window.allCity = [
  {
    zip: "00601",
    lat: 18.18027,
    lng: -66.75266,
    city: "Adjuntas",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16773,
    density: 100.5,
    county_fips: 72001,
    county_name: "Adjuntas",
    county_weights: {
      72001: 98.73,
      72141: 1.27,
    },
    county_names_all: "Adjuntas|Utuado",
    county_fips_all: "72001|72141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00602",
    lat: 18.36075,
    lng: -67.17541,
    city: "Aguada",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37083,
    density: 472.1,
    county_fips: 72003,
    county_name: "Aguada",
    county_weights: {
      72003: 100,
    },
    county_names_all: "Aguada",
    county_fips_all: 72003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00603",
    lat: 18.45744,
    lng: -67.12225,
    city: "Aguadilla",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45652,
    density: 513.2,
    county_fips: 72005,
    county_name: "Aguadilla",
    county_weights: {
      72005: 99.76,
      72099: 0.24,
    },
    county_names_all: "Aguadilla|Moca",
    county_fips_all: "72005|72099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "80150",
    lat: 18.45744,
    lng: -67.12225,
    city: "Englewood",
    state_id: "PR",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45652,
    density: 513.2,
    county_fips: 72005,
    county_name: "Aguadilla",
    county_weights: {
      72005: 99.76,
      72099: 0.24,
    },
    county_names_all: "Aguadilla|Moca",
    county_fips_all: "72005|72099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00606",
    lat: 18.16585,
    lng: -66.93716,
    city: "Maricao",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6231,
    density: 54.3,
    county_fips: 72093,
    county_name: "Maricao",
    county_weights: {
      72093: 82.26,
      72121: 6.06,
      72153: 11.68,
    },
    county_names_all: "Maricao|Yauco|Sabana Grande",
    county_fips_all: "72093|72153|72121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00610",
    lat: 18.2911,
    lng: -67.12243,
    city: "Anasco",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26502,
    density: 275.7,
    county_fips: 72011,
    county_name: "Añasco",
    county_weights: {
      72003: 0.11,
      72011: 96.71,
      72083: 0.37,
      72099: 2.81,
    },
    county_names_all: "Añasco|Moca|Las Marías|Aguada",
    county_fips_all: "72011|72099|72083|72003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00611",
    lat: 18.27698,
    lng: -66.80688,
    city: "Angeles",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 72141,
    county_name: "Utuado",
    county_weights: {
      72141: 100,
    },
    county_names_all: "Utuado",
    county_fips_all: 72141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00612",
    lat: 18.41283,
    lng: -66.7051,
    city: "Arecibo",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58771,
    density: 298,
    county_fips: 72013,
    county_name: "Arecibo",
    county_weights: {
      72013: 98.86,
      72017: 0.2,
      72065: 0.94,
    },
    county_names_all: "Arecibo|Hatillo|Barceloneta",
    county_fips_all: "72013|72065|72017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00616",
    lat: 18.41878,
    lng: -66.6679,
    city: "Bajadero",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9688,
    density: 343.7,
    county_fips: 72013,
    county_name: "Arecibo",
    county_weights: {
      72013: 100,
    },
    county_names_all: "Arecibo",
    county_fips_all: 72013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00617",
    lat: 18.44598,
    lng: -66.56006,
    city: "Barceloneta",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23771,
    density: 500,
    county_fips: 72017,
    county_name: "Barceloneta",
    county_weights: {
      72017: 99.63,
      72054: 0.37,
    },
    county_names_all: "Barceloneta|Florida",
    county_fips_all: "72017|72054",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00622",
    lat: 17.98892,
    lng: -67.1566,
    city: "Boqueron",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6505,
    density: 80.6,
    county_fips: 72023,
    county_name: "Cabo Rojo",
    county_weights: {
      72023: 100,
    },
    county_names_all: "Cabo Rojo",
    county_fips_all: 72023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00623",
    lat: 18.08429,
    lng: -67.15336,
    city: "Cabo Rojo",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41472,
    density: 408.5,
    county_fips: 72023,
    county_name: "Cabo Rojo",
    county_weights: {
      72023: 100,
    },
    county_names_all: "Cabo Rojo",
    county_fips_all: 72023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00624",
    lat: 18.05905,
    lng: -66.71932,
    city: "Penuelas",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21031,
    density: 172.9,
    county_fips: 72111,
    county_name: "Peñuelas",
    county_weights: {
      72111: 94.96,
      72113: 5.04,
    },
    county_names_all: "Peñuelas|Ponce",
    county_fips_all: "72111|72113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00627",
    lat: 18.41905,
    lng: -66.86037,
    city: "Camuy",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31066,
    density: 258.7,
    county_fips: 72027,
    county_name: "Camuy",
    county_weights: {
      72027: 100,
    },
    county_names_all: "Camuy",
    county_fips_all: 72027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00631",
    lat: 18.1852,
    lng: -66.83169,
    city: "Castaner",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1481,
    density: 182.9,
    county_fips: 72081,
    county_name: "Lares",
    county_weights: {
      72001: 49.42,
      72081: 50.58,
    },
    county_names_all: "Lares|Adjuntas",
    county_fips_all: "72081|72001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00636",
    lat: 18.16354,
    lng: -67.08014,
    city: "Rosario",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 72125,
    county_name: "San Germán",
    county_weights: {
      72125: 100,
    },
    county_names_all: "San Germán",
    county_fips_all: 72125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00637",
    lat: 18.081,
    lng: -66.94659,
    city: "Sabana Grande",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21957,
    density: 241,
    county_fips: 72121,
    county_name: "Sabana Grande",
    county_weights: {
      72079: 1.79,
      72121: 94.01,
      72125: 4.2,
    },
    county_names_all: "Sabana Grande|San Germán|Lajas",
    county_fips_all: "72121|72125|72079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00638",
    lat: 18.28462,
    lng: -66.5137,
    city: "Ciales",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16018,
    density: 86.6,
    county_fips: 72039,
    county_name: "Ciales",
    county_weights: {
      72039: 91.88,
      72091: 0.64,
      72107: 7.48,
    },
    county_names_all: "Ciales|Orocovis|Manatí",
    county_fips_all: "72039|72107|72091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00641",
    lat: 18.26742,
    lng: -66.70212,
    city: "Utuado",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26383,
    density: 121.1,
    county_fips: 72141,
    county_name: "Utuado",
    county_weights: {
      72141: 100,
    },
    county_names_all: "Utuado",
    county_fips_all: 72141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00646",
    lat: 18.43251,
    lng: -66.28429,
    city: "Dorado",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36538,
    density: 670.1,
    county_fips: 72051,
    county_name: "Dorado",
    county_weights: {
      72051: 97.19,
      72143: 2.81,
    },
    county_names_all: "Dorado|Vega Alta",
    county_fips_all: "72051|72143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00647",
    lat: 17.96667,
    lng: -66.94266,
    city: "Ensenada",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5708,
    density: 139.4,
    county_fips: 72055,
    county_name: "Guánica",
    county_weights: {
      72055: 98.36,
      72079: 1.64,
    },
    county_names_all: "Guánica|Lajas",
    county_fips_all: "72055|72079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00650",
    lat: 18.34487,
    lng: -66.58347,
    city: "Florida",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13869,
    density: 168.8,
    county_fips: 72054,
    county_name: "Florida",
    county_weights: {
      72013: 2.41,
      72017: 1.07,
      72039: 2.9,
      72054: 47.43,
      72091: 4.26,
      72141: 41.94,
    },
    county_names_all: "Florida|Utuado|Manatí|Ciales|Arecibo|Barceloneta",
    county_fips_all: "72054|72141|72091|72039|72013|72017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00652",
    lat: 18.45614,
    lng: -66.60194,
    city: "Garrochales",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3624,
    density: 217.2,
    county_fips: 72013,
    county_name: "Arecibo",
    county_weights: {
      72013: 100,
    },
    county_names_all: "Arecibo",
    county_fips_all: 72013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00653",
    lat: 17.99413,
    lng: -66.90266,
    city: "Guanica",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10117,
    density: 176.9,
    county_fips: 72055,
    county_name: "Guánica",
    county_weights: {
      72055: 97.54,
      72121: 2.46,
    },
    county_names_all: "Guánica|Sabana Grande",
    county_fips_all: "72055|72121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00656",
    lat: 18.04186,
    lng: -66.79123,
    city: "Guayanilla",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17984,
    density: 164.8,
    county_fips: 72059,
    county_name: "Guayanilla",
    county_weights: {
      72059: 96.96,
      72111: 0.16,
      72153: 2.88,
    },
    county_names_all: "Guayanilla|Yauco|Peñuelas",
    county_fips_all: "72059|72153|72111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00659",
    lat: 18.41036,
    lng: -66.79691,
    city: "Hatillo",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39561,
    density: 372,
    county_fips: 72065,
    county_name: "Hatillo",
    county_weights: {
      72065: 100,
    },
    county_names_all: "Hatillo",
    county_fips_all: 72065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00660",
    lat: 18.13412,
    lng: -67.11399,
    city: "Hormigueros",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15731,
    density: 536.6,
    county_fips: 72067,
    county_name: "Hormigueros",
    county_weights: {
      72067: 100,
    },
    county_names_all: "Hormigueros",
    county_fips_all: 72067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00662",
    lat: 18.46622,
    lng: -67.01508,
    city: "Isabela",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39017,
    density: 365,
    county_fips: 72071,
    county_name: "Isabela",
    county_weights: {
      72071: 100,
    },
    county_names_all: "Isabela",
    county_fips_all: 72071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00664",
    lat: 18.21064,
    lng: -66.59066,
    city: "Jayuya",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14405,
    density: 118.6,
    county_fips: 72073,
    county_name: "Jayuya",
    county_weights: {
      72073: 94.97,
      72141: 5.03,
    },
    county_names_all: "Jayuya|Utuado",
    county_fips_all: "72073|72141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00667",
    lat: 18.01246,
    lng: -67.0417,
    city: "Lajas",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22721,
    density: 145.7,
    county_fips: 72079,
    county_name: "Lajas",
    county_weights: {
      72079: 98.09,
      72125: 1.91,
    },
    county_names_all: "Lajas|San Germán",
    county_fips_all: "72079|72125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00669",
    lat: 18.27019,
    lng: -66.86727,
    city: "Lares",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24022,
    density: 144.7,
    county_fips: 72081,
    county_name: "Lares",
    county_weights: {
      72081: 93.38,
      72083: 2.7,
      72131: 0.12,
      72141: 3.8,
    },
    county_names_all: "Lares|Utuado|Las Marías|San Sebastián",
    county_fips_all: "72081|72141|72083|72131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00670",
    lat: 18.23782,
    lng: -66.98852,
    city: "Las Marias",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8051,
    density: 66.8,
    county_fips: 72083,
    county_name: "Las Marías",
    county_weights: {
      72011: 3.6,
      72083: 95.63,
      72093: 0.32,
      72097: 0.45,
    },
    county_names_all: "Las Marías|Añasco|Mayagüez|Maricao",
    county_fips_all: "72083|72011|72097|72093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00674",
    lat: 18.42229,
    lng: -66.4891,
    city: "Manati",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38218,
    density: 339.6,
    county_fips: 72091,
    county_name: "Manatí",
    county_weights: {
      72091: 99.45,
      72145: 0.55,
    },
    county_names_all: "Manatí|Vega Baja",
    county_fips_all: "72091|72145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00676",
    lat: 18.37897,
    lng: -67.08098,
    city: "Moca",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35621,
    density: 281.5,
    county_fips: 72099,
    county_name: "Moca",
    county_weights: {
      72003: 0.81,
      72099: 99.19,
    },
    county_names_all: "Moca|Aguada",
    county_fips_all: "72099|72003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00677",
    lat: 18.33535,
    lng: -67.23155,
    city: "Rincon",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13949,
    density: 369.7,
    county_fips: 72117,
    county_name: "Rincón",
    county_weights: {
      72003: 0.81,
      72011: 1.19,
      72117: 98,
    },
    county_names_all: "Rincón|Añasco|Aguada",
    county_fips_all: "72117|72011|72003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00678",
    lat: 18.42949,
    lng: -66.93016,
    city: "Quebradillas",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24997,
    density: 331.2,
    county_fips: 72115,
    county_name: "Quebradillas",
    county_weights: {
      72071: 17.13,
      72115: 77.11,
      72131: 5.76,
    },
    county_names_all: "Quebradillas|Isabela|San Sebastián",
    county_fips_all: "72115|72071|72131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00680",
    lat: 18.16307,
    lng: -67.36122,
    city: "Mayaguez",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44904,
    density: 269.6,
    county_fips: 72097,
    county_name: "Mayagüez",
    county_weights: {
      72011: 2.43,
      72097: 94.13,
      72125: 3.44,
    },
    county_names_all: "Mayagüez|San Germán|Añasco",
    county_fips_all: "72097|72125|72011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00682",
    lat: 18.22415,
    lng: -67.15309,
    city: "Mayaguez",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30212,
    density: 715.2,
    county_fips: 72097,
    county_name: "Mayagüez",
    county_weights: {
      72067: 0.17,
      72097: 99.83,
    },
    county_names_all: "Mayagüez|Hormigueros",
    county_fips_all: "72097|72067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00683",
    lat: 18.10926,
    lng: -67.03803,
    city: "San German",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28710,
    density: 224.9,
    county_fips: 72125,
    county_name: "San Germán",
    county_weights: {
      72125: 100,
    },
    county_names_all: "San Germán",
    county_fips_all: 72125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00685",
    lat: 18.33656,
    lng: -66.97518,
    city: "San Sebastian",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36546,
    density: 179.3,
    county_fips: 72131,
    county_name: "San Sebastián",
    county_weights: {
      72071: 11.31,
      72099: 0.95,
      72131: 87.74,
    },
    county_names_all: "San Sebastián|Isabela|Moca",
    county_fips_all: "72131|72071|72099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00687",
    lat: 18.31707,
    lng: -66.42029,
    city: "Morovis",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30652,
    density: 304.5,
    county_fips: 72101,
    county_name: "Morovis",
    county_weights: {
      72101: 100,
    },
    county_names_all: "Morovis",
    county_fips_all: 72101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00688",
    lat: 18.3807,
    lng: -66.62496,
    city: "Sabana Hoyos",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11355,
    density: 134.9,
    county_fips: 72013,
    county_name: "Arecibo",
    county_weights: {
      72013: 100,
    },
    county_names_all: "Arecibo",
    county_fips_all: 72013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00690",
    lat: 18.49363,
    lng: -67.09734,
    city: "San Antonio",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5900,
    density: 1007.5,
    county_fips: 72005,
    county_name: "Aguadilla",
    county_weights: {
      72005: 100,
    },
    county_names_all: "Aguadilla",
    county_fips_all: 72005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00692",
    lat: 18.40905,
    lng: -66.33768,
    city: "Vega Alta",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34857,
    density: 507.3,
    county_fips: 72143,
    county_name: "Vega Alta",
    county_weights: {
      72143: 99.87,
      72145: 0.13,
    },
    county_names_all: "Vega Alta|Vega Baja",
    county_fips_all: "72143|72145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00693",
    lat: 18.42633,
    lng: -66.39811,
    city: "Vega Baja",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52220,
    density: 454,
    county_fips: 72145,
    county_name: "Vega Baja",
    county_weights: {
      72091: 0.29,
      72143: 1.43,
      72145: 98.28,
    },
    county_names_all: "Vega Baja|Vega Alta|Manatí",
    county_fips_all: "72145|72143|72091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00694",
    lat: 18.48327,
    lng: -66.39269,
    city: "Vega Baja",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32,
    density: 15.5,
    county_fips: 72145,
    county_name: "Vega Baja",
    county_weights: {
      72145: 100,
    },
    county_names_all: "Vega Baja",
    county_fips_all: 72145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00698",
    lat: 18.07274,
    lng: -66.85519,
    city: "Yauco",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34449,
    density: 212.3,
    county_fips: 72153,
    county_name: "Yauco",
    county_weights: {
      72059: 2.18,
      72153: 97.82,
    },
    county_names_all: "Yauco|Guayanilla",
    county_fips_all: "72153|72059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00703",
    lat: 18.24739,
    lng: -66.13143,
    city: "Aguas Buenas",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25619,
    density: 318.9,
    county_fips: 72007,
    county_name: "Aguas Buenas",
    county_weights: {
      72007: 93.07,
      72041: 3.61,
      72045: 3.32,
    },
    county_names_all: "Aguas Buenas|Cidra|Comerío",
    county_fips_all: "72007|72041|72045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00704",
    lat: 17.97442,
    lng: -66.22888,
    city: "Aguirre",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7641,
    density: 327.9,
    county_fips: 72123,
    county_name: "Salinas",
    county_weights: {
      72057: 2.36,
      72123: 97.64,
    },
    county_names_all: "Salinas|Guayama",
    county_fips_all: "72123|72057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00705",
    lat: 18.1294,
    lng: -66.26653,
    city: "Aibonito",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22289,
    density: 283,
    county_fips: 72009,
    county_name: "Aibonito",
    county_weights: {
      72009: 97.19,
      72043: 2.81,
    },
    county_names_all: "Aibonito|Coamo",
    county_fips_all: "72009|72043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00707",
    lat: 18.01752,
    lng: -65.92127,
    city: "Maunabo",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10514,
    density: 194,
    county_fips: 72095,
    county_name: "Maunabo",
    county_weights: {
      72095: 100,
    },
    county_names_all: "Maunabo",
    county_fips_all: 72095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00714",
    lat: 17.9981,
    lng: -66.05635,
    city: "Arroyo",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17413,
    density: 448.1,
    county_fips: 72015,
    county_name: "Arroyo",
    county_weights: {
      72015: 100,
    },
    county_names_all: "Arroyo",
    county_fips_all: 72015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00715",
    lat: 17.99738,
    lng: -66.56104,
    city: "Mercedita",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2846,
    density: 86.5,
    county_fips: 72113,
    county_name: "Ponce",
    county_weights: {
      72075: 0.92,
      72113: 99.08,
    },
    county_names_all: "Ponce|Juana Díaz",
    county_fips_all: "72113|72075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00716",
    lat: 17.99942,
    lng: -66.59868,
    city: "Ponce",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26433,
    density: 1177.4,
    county_fips: 72113,
    county_name: "Ponce",
    county_weights: {
      72113: 100,
    },
    county_names_all: "Ponce",
    county_fips_all: 72113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00717",
    lat: 18.00272,
    lng: -66.61146,
    city: "Ponce",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15115,
    density: 2459.5,
    county_fips: 72113,
    county_name: "Ponce",
    county_weights: {
      72113: 100,
    },
    county_names_all: "Ponce",
    county_fips_all: 72113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00718",
    lat: 18.23145,
    lng: -65.76067,
    city: "Naguabo",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25543,
    density: 208.9,
    county_fips: 72103,
    county_name: "Naguabo",
    county_weights: {
      72037: 0.14,
      72103: 99.86,
    },
    county_names_all: "Naguabo|Ceiba",
    county_fips_all: "72103|72037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00719",
    lat: 18.28879,
    lng: -66.25316,
    city: "Naranjito",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28048,
    density: 383.9,
    county_fips: 72105,
    county_name: "Naranjito",
    county_weights: {
      72045: 0.47,
      72047: 2.22,
      72105: 96.91,
      72135: 0.4,
    },
    county_names_all: "Naranjito|Corozal|Comerío|Toa Alta",
    county_fips_all: "72105|72047|72045|72135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00720",
    lat: 18.21559,
    lng: -66.42421,
    city: "Orocovis",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20387,
    density: 140.2,
    county_fips: 72107,
    county_name: "Orocovis",
    county_weights: {
      72043: 0.73,
      72107: 99.27,
    },
    county_names_all: "Orocovis|Coamo",
    county_fips_all: "72107|72043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00723",
    lat: 18.03139,
    lng: -66.01122,
    city: "Patillas",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16645,
    density: 139.7,
    county_fips: 72109,
    county_name: "Patillas",
    county_weights: {
      72095: 0.5,
      72109: 99.5,
    },
    county_names_all: "Patillas|Maunabo",
    county_fips_all: "72109|72095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00725",
    lat: 18.22052,
    lng: -66.03962,
    city: "Caguas",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 79395,
    density: 741.1,
    county_fips: 72025,
    county_name: "Caguas",
    county_weights: {
      72007: 1.9,
      72025: 86.56,
      72061: 4.45,
      72127: 2.23,
      72129: 2.77,
      72139: 2.08,
    },
    county_names_all:
      "Caguas|Guaynabo|San Lorenzo|San Juan|Trujillo Alto|Aguas Buenas",
    county_fips_all: "72025|72061|72129|72127|72139|72007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00727",
    lat: 18.21142,
    lng: -66.07374,
    city: "Caguas",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51772,
    density: 885.9,
    county_fips: 72025,
    county_name: "Caguas",
    county_weights: {
      72025: 100,
    },
    county_names_all: "Caguas",
    county_fips_all: 72025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00728",
    lat: 18.00697,
    lng: -66.65995,
    city: "Ponce",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39204,
    density: 983.1,
    county_fips: 72113,
    county_name: "Ponce",
    county_weights: {
      72113: 100,
    },
    county_names_all: "Ponce",
    county_fips_all: 72113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00729",
    lat: 18.33524,
    lng: -65.88677,
    city: "Canovanas",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50721,
    density: 547.7,
    county_fips: 72029,
    county_name: "Canóvanas",
    county_weights: {
      72029: 91.45,
      72087: 8.55,
    },
    county_names_all: "Canóvanas|Loíza",
    county_fips_all: "72029|72087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00730",
    lat: 18.03256,
    lng: -66.61384,
    city: "Ponce",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29075,
    density: 1691.3,
    county_fips: 72113,
    county_name: "Ponce",
    county_weights: {
      72113: 100,
    },
    county_names_all: "Ponce",
    county_fips_all: 72113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00731",
    lat: 18.09914,
    lng: -66.63279,
    city: "Ponce",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12108,
    density: 95.5,
    county_fips: 72113,
    county_name: "Ponce",
    county_weights: {
      72001: 2.88,
      72113: 97.12,
    },
    county_names_all: "Ponce|Adjuntas",
    county_fips_all: "72113|72001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00735",
    lat: 18.2525,
    lng: -65.67534,
    city: "Ceiba",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11593,
    density: 163.5,
    county_fips: 72037,
    county_name: "Ceiba",
    county_weights: {
      72037: 94.61,
      72103: 5.39,
    },
    county_names_all: "Ceiba|Naguabo",
    county_fips_all: "72037|72103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00736",
    lat: 18.10736,
    lng: -66.14994,
    city: "Cayey",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45773,
    density: 321.9,
    county_fips: 72035,
    county_name: "Cayey",
    county_weights: {
      72035: 92.46,
      72041: 7.54,
    },
    county_names_all: "Cayey|Cidra",
    county_fips_all: "72035|72041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00738",
    lat: 18.31793,
    lng: -65.66793,
    city: "Fajardo",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28329,
    density: 369.3,
    county_fips: 72053,
    county_name: "Fajardo",
    county_weights: {
      72037: 0.41,
      72053: 99.59,
    },
    county_names_all: "Fajardo|Ceiba",
    county_fips_all: "72053|72037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00739",
    lat: 18.17543,
    lng: -66.16198,
    city: "Cidra",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35801,
    density: 449.2,
    county_fips: 72041,
    county_name: "Cidra",
    county_weights: {
      72041: 100,
    },
    county_names_all: "Cidra",
    county_fips_all: 72041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00740",
    lat: 18.33251,
    lng: -65.63419,
    city: "Puerto Real",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1934,
    density: 1788.4,
    county_fips: 72053,
    county_name: "Fajardo",
    county_weights: {
      72053: 100,
    },
    county_names_all: "Fajardo",
    county_fips_all: 72053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00741",
    lat: 18.16569,
    lng: -65.75506,
    city: "Punta Santiago",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3911,
    density: 663.3,
    county_fips: 72069,
    county_name: "Humacao",
    county_weights: {
      72069: 100,
    },
    county_names_all: "Humacao",
    county_fips_all: 72069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00745",
    lat: 18.3466,
    lng: -65.81382,
    city: "Rio Grande",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49472,
    density: 314.4,
    county_fips: 72119,
    county_name: "Río Grande",
    county_weights: {
      72029: 0.22,
      72119: 99.78,
    },
    county_names_all: "Río Grande|Canóvanas",
    county_fips_all: "72119|72029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00751",
    lat: 18.01205,
    lng: -66.25871,
    city: "Salinas",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20662,
    density: 131.4,
    county_fips: 72123,
    county_name: "Salinas",
    county_weights: {
      72035: 0.17,
      72123: 99.83,
    },
    county_names_all: "Salinas|Cayey",
    county_fips_all: "72123|72035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00754",
    lat: 18.1447,
    lng: -65.97565,
    city: "San Lorenzo",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36309,
    density: 280.4,
    county_fips: 72129,
    county_name: "San Lorenzo",
    county_weights: {
      72129: 100,
    },
    county_names_all: "San Lorenzo",
    county_fips_all: 72129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00757",
    lat: 17.9933,
    lng: -66.39056,
    city: "Santa Isabel",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21474,
    density: 255.6,
    county_fips: 72133,
    county_name: "Santa Isabel",
    county_weights: {
      72133: 100,
    },
    county_names_all: "Santa Isabel",
    county_fips_all: 72133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00765",
    lat: 18.12365,
    lng: -65.43013,
    city: "Vieques",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8402,
    density: 68.6,
    county_fips: 72147,
    county_name: "Vieques",
    county_weights: {
      72147: 100,
    },
    county_names_all: "Vieques",
    county_fips_all: 72147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00766",
    lat: 18.13039,
    lng: -66.4757,
    city: "Villalba",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22187,
    density: 224.4,
    county_fips: 72149,
    county_name: "Villalba",
    county_weights: {
      72107: 6.52,
      72149: 93.48,
    },
    county_names_all: "Villalba|Orocovis",
    county_fips_all: "72149|72107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00767",
    lat: 18.07033,
    lng: -65.89618,
    city: "Yabucoa",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32867,
    density: 230,
    county_fips: 72151,
    county_name: "Yabucoa",
    county_weights: {
      72069: 0.67,
      72151: 99.33,
    },
    county_names_all: "Yabucoa|Humacao",
    county_fips_all: "72151|72069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00769",
    lat: 18.09459,
    lng: -66.3607,
    city: "Coamo",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38500,
    density: 192.9,
    county_fips: 72043,
    county_name: "Coamo",
    county_weights: {
      72043: 98.05,
      72133: 1.95,
    },
    county_names_all: "Coamo|Santa Isabel",
    county_fips_all: "72043|72133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00771",
    lat: 18.18797,
    lng: -65.86916,
    city: "Las Piedras",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36388,
    density: 418.1,
    county_fips: 72085,
    county_name: "Las Piedras",
    county_weights: {
      72069: 1,
      72085: 99,
    },
    county_names_all: "Las Piedras|Humacao",
    county_fips_all: "72085|72069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00772",
    lat: 18.43048,
    lng: -65.90377,
    city: "Loiza",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18919,
    density: 447,
    county_fips: 72087,
    county_name: "Loíza",
    county_weights: {
      72087: 100,
    },
    county_names_all: "Loíza",
    county_fips_all: 72087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00773",
    lat: 18.34073,
    lng: -65.72756,
    city: "Luquillo",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17924,
    density: 287.2,
    county_fips: 72089,
    county_name: "Luquillo",
    county_weights: {
      72089: 100,
    },
    county_names_all: "Luquillo",
    county_fips_all: 72089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00775",
    lat: 18.31387,
    lng: -65.28618,
    city: "Culebra",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1326,
    density: 44,
    county_fips: 72049,
    county_name: "Culebra",
    county_weights: {
      72049: 100,
    },
    county_names_all: "Culebra",
    county_fips_all: 72049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00777",
    lat: 18.22365,
    lng: -65.90904,
    city: "Juncos",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39580,
    density: 569.1,
    county_fips: 72077,
    county_name: "Juncos",
    county_weights: {
      72029: 0.14,
      72063: 0.12,
      72077: 98.49,
      72085: 0.43,
      72129: 0.82,
    },
    county_names_all: "Juncos|San Lorenzo|Las Piedras|Canóvanas|Gurabo",
    county_fips_all: "72077|72129|72085|72029|72063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00778",
    lat: 18.26319,
    lng: -65.97938,
    city: "Gurabo",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46720,
    density: 611,
    county_fips: 72063,
    county_name: "Gurabo",
    county_weights: {
      72063: 94.08,
      72129: 5.92,
    },
    county_names_all: "Gurabo|San Lorenzo",
    county_fips_all: "72063|72129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00780",
    lat: 18.09998,
    lng: -66.57032,
    city: "Coto Laurel",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10887,
    density: 219.7,
    county_fips: 72113,
    county_name: "Ponce",
    county_weights: {
      72075: 1.87,
      72113: 98.13,
    },
    county_names_all: "Ponce|Juana Díaz",
    county_fips_all: "72113|72075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00782",
    lat: 18.22501,
    lng: -66.22452,
    city: "Comerio",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17310,
    density: 238.9,
    county_fips: 72045,
    county_name: "Comerío",
    county_weights: {
      72019: 2.61,
      72045: 97.39,
    },
    county_names_all: "Comerío|Barranquitas",
    county_fips_all: "72045|72019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00783",
    lat: 18.30348,
    lng: -66.32851,
    city: "Corozal",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32372,
    density: 296.8,
    county_fips: 72047,
    county_name: "Corozal",
    county_weights: {
      72019: 0.94,
      72047: 99.06,
    },
    county_names_all: "Corozal|Barranquitas",
    county_fips_all: "72047|72019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00784",
    lat: 18.00558,
    lng: -66.13651,
    city: "Guayama",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38894,
    density: 225,
    county_fips: 72057,
    county_name: "Guayama",
    county_weights: {
      72035: 1.53,
      72057: 97.29,
      72109: 1.18,
    },
    county_names_all: "Guayama|Cayey|Patillas",
    county_fips_all: "72057|72035|72109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00786",
    lat: 18.1357,
    lng: -66.22881,
    city: "La Plata",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 72009,
    county_name: "Aibonito",
    county_weights: {
      72009: 100,
    },
    county_names_all: "Aibonito",
    county_fips_all: 72009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00791",
    lat: 18.14391,
    lng: -65.81398,
    city: "Humacao",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47675,
    density: 431.7,
    county_fips: 72069,
    county_name: "Humacao",
    county_weights: {
      72069: 97.88,
      72085: 1.16,
      72151: 0.96,
    },
    county_names_all: "Humacao|Las Piedras|Yabucoa",
    county_fips_all: "72069|72085|72151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00794",
    lat: 18.19934,
    lng: -66.31179,
    city: "Barranquitas",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28088,
    density: 316,
    county_fips: 72019,
    county_name: "Barranquitas",
    county_weights: {
      72019: 96.51,
      72043: 3.49,
    },
    county_names_all: "Barranquitas|Coamo",
    county_fips_all: "72019|72043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00795",
    lat: 18.05128,
    lng: -66.49485,
    city: "Juana Diaz",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43475,
    density: 281,
    county_fips: 72075,
    county_name: "Juana Díaz",
    county_weights: {
      72075: 100,
    },
    county_names_all: "Juana Díaz",
    county_fips_all: 72075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00802",
    lat: 18.34349,
    lng: -64.9287,
    city: "St Thomas",
    state_id: "VI",
    state_name: "Virgin Islands",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 78030,
    county_name: "St. Thomas",
    county_weights: {
      78030: 100,
    },
    county_names_all: "St. Thomas",
    county_fips_all: 78030,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/St_Thomas",
  },
  {
    zip: "00820",
    lat: 17.7388,
    lng: -64.70695,
    city: "Christiansted",
    state_id: "VI",
    state_name: "Virgin Islands",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 78010,
    county_name: "St. Croix",
    county_weights: {
      78010: 100,
    },
    county_names_all: "St. Croix",
    county_fips_all: 78010,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/St_Thomas",
  },
  {
    zip: "00830",
    lat: 18.33857,
    lng: -64.73802,
    city: "St John",
    state_id: "VI",
    state_name: "Virgin Islands",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 78020,
    county_name: "St. John",
    county_weights: {
      78020: 100,
    },
    county_names_all: "St. John",
    county_fips_all: 78020,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/St_Thomas",
  },
  {
    zip: "00840",
    lat: 17.72649,
    lng: -64.84717,
    city: "Frederiksted",
    state_id: "VI",
    state_name: "Virgin Islands",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 78010,
    county_name: "St. Croix",
    county_weights: {
      78010: 100,
    },
    county_names_all: "St. Croix",
    county_fips_all: 78010,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/St_Thomas",
  },
  {
    zip: "00850",
    lat: 17.72763,
    lng: -64.79122,
    city: "Kingshill",
    state_id: "VI",
    state_name: "Virgin Islands",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 78010,
    county_name: "St. Croix",
    county_weights: {
      78010: 100,
    },
    county_names_all: "St. Croix",
    county_fips_all: 78010,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/St_Thomas",
  },
  {
    zip: "00851",
    lat: 17.74757,
    lng: -64.78737,
    city: "Kingshill",
    state_id: "VI",
    state_name: "Virgin Islands",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 78010,
    county_name: "St. Croix",
    county_weights: {
      78010: 100,
    },
    county_names_all: "St. Croix",
    county_fips_all: 78010,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/St_Thomas",
  },
  {
    zip: "00901",
    lat: 18.46478,
    lng: -66.10277,
    city: "San Juan",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7438,
    density: 2830.2,
    county_fips: 72127,
    county_name: "San Juan",
    county_weights: {
      72127: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 72127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00906",
    lat: 18.46446,
    lng: -66.09499,
    city: "San Juan",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 178,
    density: 21583.6,
    county_fips: 72127,
    county_name: "San Juan",
    county_weights: {
      72127: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 72127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00907",
    lat: 18.45287,
    lng: -66.08381,
    city: "San Juan",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15641,
    density: 2955.8,
    county_fips: 72127,
    county_name: "San Juan",
    county_weights: {
      72127: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 72127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00909",
    lat: 18.44131,
    lng: -66.06866,
    city: "San Juan",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4855,
    density: 2871.2,
    county_fips: 72127,
    county_name: "San Juan",
    county_weights: {
      72127: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 72127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00911",
    lat: 18.45133,
    lng: -66.05636,
    city: "San Juan",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7157,
    density: 5806.9,
    county_fips: 72127,
    county_name: "San Juan",
    county_weights: {
      72127: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 72127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00912",
    lat: 18.44503,
    lng: -66.05995,
    city: "San Juan",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5868,
    density: 6109.4,
    county_fips: 72127,
    county_name: "San Juan",
    county_weights: {
      72127: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 72127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00913",
    lat: 18.45024,
    lng: -66.04275,
    city: "San Juan",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7225,
    density: 8610.5,
    county_fips: 72127,
    county_name: "San Juan",
    county_weights: {
      72127: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 72127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00915",
    lat: 18.43673,
    lng: -66.04576,
    city: "San Juan",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24079,
    density: 6632.4,
    county_fips: 72127,
    county_name: "San Juan",
    county_weights: {
      72127: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 72127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00917",
    lat: 18.4208,
    lng: -66.04989,
    city: "San Juan",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17836,
    density: 5044,
    county_fips: 72127,
    county_name: "San Juan",
    county_weights: {
      72127: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 72127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00918",
    lat: 18.42139,
    lng: -66.06774,
    city: "San Juan",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14902,
    density: 2132.7,
    county_fips: 72127,
    county_name: "San Juan",
    county_weights: {
      72127: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 72127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00920",
    lat: 18.41904,
    lng: -66.09023,
    city: "San Juan",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16157,
    density: 1728.2,
    county_fips: 72127,
    county_name: "San Juan",
    county_weights: {
      72127: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 72127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00921",
    lat: 18.39206,
    lng: -66.0871,
    city: "San Juan",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30663,
    density: 3857.8,
    county_fips: 72127,
    county_name: "San Juan",
    county_weights: {
      72061: 0.12,
      72127: 99.88,
    },
    county_names_all: "San Juan|Guaynabo",
    county_fips_all: "72127|72061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00923",
    lat: 18.41146,
    lng: -66.03715,
    city: "San Juan",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23811,
    density: 4573.9,
    county_fips: 72127,
    county_name: "San Juan",
    county_weights: {
      72127: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 72127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00924",
    lat: 18.39987,
    lng: -66.01344,
    city: "San Juan",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46690,
    density: 3865.8,
    county_fips: 72127,
    county_name: "San Juan",
    county_weights: {
      72031: 3.44,
      72127: 96.56,
    },
    county_names_all: "San Juan|Carolina",
    county_fips_all: "72127|72031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00925",
    lat: 18.40028,
    lng: -66.05058,
    city: "San Juan",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6365,
    density: 5513.7,
    county_fips: 72127,
    county_name: "San Juan",
    county_weights: {
      72127: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 72127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00926",
    lat: 18.34691,
    lng: -66.05434,
    city: "San Juan",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 89327,
    density: 1485.8,
    county_fips: 72127,
    county_name: "San Juan",
    county_weights: {
      72061: 0.83,
      72127: 83.48,
      72139: 15.69,
    },
    county_names_all: "San Juan|Trujillo Alto|Guaynabo",
    county_fips_all: "72127|72139|72061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00927",
    lat: 18.38884,
    lng: -66.07149,
    city: "San Juan",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13490,
    density: 2149.7,
    county_fips: 72127,
    county_name: "San Juan",
    county_weights: {
      72127: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 72127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00934",
    lat: 18.41372,
    lng: -66.11998,
    city: "Fort Buchanan",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 114,
    density: 31,
    county_fips: 72061,
    county_name: "Guaynabo",
    county_weights: {
      72021: 30.84,
      72061: 69.16,
    },
    county_names_all: "Guaynabo|Bayamón",
    county_fips_all: "72061|72021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00949",
    lat: 18.43166,
    lng: -66.21349,
    city: "Toa Baja",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 71371,
    density: 1339,
    county_fips: 72137,
    county_name: "Toa Baja",
    county_weights: {
      72033: 2.93,
      72135: 0.96,
      72137: 96.11,
    },
    county_names_all: "Toa Baja|Cataño|Toa Alta",
    county_fips_all: "72137|72033|72135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00950",
    lat: 18.46201,
    lng: -66.23917,
    city: "Toa Baja",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 72051,
    county_name: "Dorado",
    county_weights: {
      72051: 99.69,
      72137: 0.31,
    },
    county_names_all: "Dorado|Toa Baja",
    county_fips_all: "72051|72137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00951",
    lat: 18.43175,
    lng: -66.25628,
    city: "Toa Baja",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 72137,
    county_name: "Toa Baja",
    county_weights: {
      72137: 100,
    },
    county_names_all: "Toa Baja",
    county_fips_all: 72137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00952",
    lat: 18.42874,
    lng: -66.18897,
    city: "Sabana Seca",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7324,
    density: 1275.4,
    county_fips: 72137,
    county_name: "Toa Baja",
    county_weights: {
      72137: 100,
    },
    county_names_all: "Toa Baja",
    county_fips_all: 72137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00953",
    lat: 18.36319,
    lng: -66.24764,
    city: "Toa Alta",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 70997,
    density: 1027.1,
    county_fips: 72135,
    county_name: "Toa Alta",
    county_weights: {
      72047: 0.79,
      72135: 98.44,
      72137: 0.77,
    },
    county_names_all: "Toa Alta|Corozal|Toa Baja",
    county_fips_all: "72135|72047|72137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00956",
    lat: 18.32121,
    lng: -66.17185,
    city: "Bayamon",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60554,
    density: 852.6,
    county_fips: 72021,
    county_name: "Bayamón",
    county_weights: {
      72007: 1.4,
      72021: 97.91,
      72135: 0.69,
    },
    county_names_all: "Bayamón|Aguas Buenas|Toa Alta",
    county_fips_all: "72021|72007|72135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00957",
    lat: 18.36696,
    lng: -66.18857,
    city: "Bayamon",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37977,
    density: 3377.8,
    county_fips: 72021,
    county_name: "Bayamón",
    county_weights: {
      72021: 93.15,
      72135: 6.85,
    },
    county_names_all: "Bayamón|Toa Alta",
    county_fips_all: "72021|72135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00959",
    lat: 18.3852,
    lng: -66.15583,
    city: "Bayamon",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46116,
    density: 2922.2,
    county_fips: 72021,
    county_name: "Bayamón",
    county_weights: {
      72021: 98.67,
      72061: 0.9,
      72135: 0.16,
      72137: 0.27,
    },
    county_names_all: "Bayamón|Guaynabo|Toa Baja|Toa Alta",
    county_fips_all: "72021|72061|72137|72135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00960",
    lat: 18.41674,
    lng: -66.14365,
    city: "Bayamon",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1793,
    density: 493.6,
    county_fips: 72021,
    county_name: "Bayamón",
    county_weights: {
      72021: 100,
    },
    county_names_all: "Bayamón",
    county_fips_all: 72021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00961",
    lat: 18.40987,
    lng: -66.16415,
    city: "Bayamon",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28638,
    density: 2073.3,
    county_fips: 72021,
    county_name: "Bayamón",
    county_weights: {
      72021: 99,
      72033: 1,
    },
    county_names_all: "Bayamón|Cataño",
    county_fips_all: "72021|72033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00962",
    lat: 18.43514,
    lng: -66.13949,
    city: "Catano",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18274,
    density: 1465,
    county_fips: 72033,
    county_name: "Cataño",
    county_weights: {
      72021: 0.26,
      72033: 85.91,
      72061: 13.72,
      72137: 0.11,
    },
    county_names_all: "Cataño|Guaynabo|Bayamón|Toa Baja",
    county_fips_all: "72033|72061|72021|72137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00965",
    lat: 18.42853,
    lng: -66.11175,
    city: "Guaynabo",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6901,
    density: 2943.6,
    county_fips: 72061,
    county_name: "Guaynabo",
    county_weights: {
      72061: 100,
    },
    county_names_all: "Guaynabo",
    county_fips_all: 72061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00966",
    lat: 18.39784,
    lng: -66.11394,
    city: "Guaynabo",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15139,
    density: 2319.4,
    county_fips: 72061,
    county_name: "Guaynabo",
    county_weights: {
      72021: 6.59,
      72061: 85.34,
      72127: 8.07,
    },
    county_names_all: "Guaynabo|San Juan|Bayamón",
    county_fips_all: "72061|72127|72021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00968",
    lat: 18.40609,
    lng: -66.10123,
    city: "Guaynabo",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3603,
    density: 3051.3,
    county_fips: 72061,
    county_name: "Guaynabo",
    county_weights: {
      72061: 99.73,
      72127: 0.27,
    },
    county_names_all: "Guaynabo|San Juan",
    county_fips_all: "72061|72127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00969",
    lat: 18.36696,
    lng: -66.11,
    city: "Guaynabo",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40402,
    density: 3096.3,
    county_fips: 72061,
    county_name: "Guaynabo",
    county_weights: {
      72021: 3.83,
      72061: 85.08,
      72127: 11.09,
    },
    county_names_all: "Guaynabo|San Juan|Bayamón",
    county_fips_all: "72061|72127|72021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00971",
    lat: 18.32067,
    lng: -66.11751,
    city: "Guaynabo",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25443,
    density: 613,
    county_fips: 72061,
    county_name: "Guaynabo",
    county_weights: {
      72061: 100,
    },
    county_names_all: "Guaynabo",
    county_fips_all: 72061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00976",
    lat: 18.33903,
    lng: -65.99286,
    city: "Trujillo Alto",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57297,
    density: 1268.8,
    county_fips: 72139,
    county_name: "Trujillo Alto",
    county_weights: {
      72031: 2.56,
      72063: 0.7,
      72127: 2.13,
      72139: 94.61,
    },
    county_names_all: "Trujillo Alto|Carolina|San Juan|Gurabo",
    county_fips_all: "72139|72031|72127|72063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00979",
    lat: 18.43734,
    lng: -66.0089,
    city: "Carolina",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17022,
    density: 1690.1,
    county_fips: 72031,
    county_name: "Carolina",
    county_weights: {
      72031: 100,
    },
    county_names_all: "Carolina",
    county_fips_all: 72031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00982",
    lat: 18.40961,
    lng: -65.99143,
    city: "Carolina",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13402,
    density: 3586.8,
    county_fips: 72031,
    county_name: "Carolina",
    county_weights: {
      72031: 100,
    },
    county_names_all: "Carolina",
    county_fips_all: 72031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00983",
    lat: 18.41788,
    lng: -65.98104,
    city: "Carolina",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32735,
    density: 2924.8,
    county_fips: 72031,
    county_name: "Carolina",
    county_weights: {
      72031: 100,
    },
    county_names_all: "Carolina",
    county_fips_all: 72031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00985",
    lat: 18.40628,
    lng: -65.94767,
    city: "Carolina",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31388,
    density: 1312.3,
    county_fips: 72031,
    county_name: "Carolina",
    county_weights: {
      72031: 100,
    },
    county_names_all: "Carolina",
    county_fips_all: 72031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "00987",
    lat: 18.34115,
    lng: -65.94257,
    city: "Carolina",
    state_id: "PR",
    state_name: "Puerto Rico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52270,
    density: 778.3,
    county_fips: 72031,
    county_name: "Carolina",
    county_weights: {
      72031: 99.83,
      72139: 0.17,
    },
    county_names_all: "Carolina|Trujillo Alto",
    county_fips_all: "72031|72139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Puerto_Rico",
  },
  {
    zip: "01001",
    lat: 42.06262,
    lng: -72.62521,
    city: "Agawam",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16064,
    density: 549.2,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01002",
    lat: 42.37633,
    lng: -72.46462,
    city: "Amherst",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30099,
    density: 218.2,
    county_fips: 25015,
    county_name: "Hampshire",
    county_weights: {
      25011: 6.74,
      25015: 93.26,
    },
    county_names_all: "Hampshire|Franklin",
    county_fips_all: "25015|25011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01003",
    lat: 42.39135,
    lng: -72.52327,
    city: "Amherst",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11588,
    density: 5564,
    county_fips: 25015,
    county_name: "Hampshire",
    county_weights: {
      25015: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 25015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01005",
    lat: 42.42117,
    lng: -72.10655,
    city: "Barre",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5166,
    density: 46.2,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01007",
    lat: 42.28163,
    lng: -72.40009,
    city: "Belchertown",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15080,
    density: 106.1,
    county_fips: 25015,
    county_name: "Hampshire",
    county_weights: {
      25015: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 25015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01008",
    lat: 42.18234,
    lng: -72.95819,
    city: "Blandford",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1116,
    density: 7,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25003: 5.64,
      25013: 94.36,
    },
    county_names_all: "Hampden|Berkshire",
    county_fips_all: "25013|25003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01009",
    lat: 42.21133,
    lng: -72.34189,
    city: "Bondsville",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 649,
    density: 359.3,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 99.06,
      25015: 0.94,
    },
    county_names_all: "Hampden|Hampshire",
    county_fips_all: "25013|25015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01010",
    lat: 42.12904,
    lng: -72.20597,
    city: "Brimfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3663,
    density: 40.1,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 98.73,
      25027: 1.27,
    },
    county_names_all: "Hampden|Worcester",
    county_fips_all: "25013|25027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01011",
    lat: 42.30233,
    lng: -72.96448,
    city: "Chester",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1486,
    density: 17.5,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 77.54,
      25015: 22.46,
    },
    county_names_all: "Hampden|Hampshire",
    county_fips_all: "25013|25015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01012",
    lat: 42.38495,
    lng: -72.84675,
    city: "Chesterfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 595,
    density: 19,
    county_fips: 25015,
    county_name: "Hampshire",
    county_weights: {
      25015: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 25015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01013",
    lat: 42.16059,
    lng: -72.60788,
    city: "Chicopee",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22739,
    density: 1551.2,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01020",
    lat: 42.17618,
    lng: -72.56538,
    city: "Chicopee",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30249,
    density: 937.3,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01022",
    lat: 42.19721,
    lng: -72.54249,
    city: "Chicopee",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2203,
    density: 176.7,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01026",
    lat: 42.46858,
    lng: -72.92296,
    city: "Cummington",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1030,
    density: 14.2,
    county_fips: 25015,
    county_name: "Hampshire",
    county_weights: {
      25003: 9.54,
      25015: 90.46,
    },
    county_names_all: "Hampshire|Berkshire",
    county_fips_all: "25015|25003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01027",
    lat: 42.29506,
    lng: -72.74303,
    city: "Easthampton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17641,
    density: 167.8,
    county_fips: 25015,
    county_name: "Hampshire",
    county_weights: {
      25015: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 25015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01028",
    lat: 42.05967,
    lng: -72.49899,
    city: "East Longmeadow",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16215,
    density: 484.5,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01029",
    lat: 42.19402,
    lng: -73.05067,
    city: "East Otis",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 572,
    density: 22.2,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01030",
    lat: 42.06869,
    lng: -72.67967,
    city: "Feeding Hills",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12563,
    density: 403.2,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01031",
    lat: 42.32782,
    lng: -72.19191,
    city: "Gilbertville",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1436,
    density: 82.3,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01032",
    lat: 42.45313,
    lng: -72.81965,
    city: "Goshen",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 482,
    density: 19.3,
    county_fips: 25015,
    county_name: "Hampshire",
    county_weights: {
      25015: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 25015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01033",
    lat: 42.26082,
    lng: -72.50361,
    city: "Granby",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6310,
    density: 87.6,
    county_fips: 25015,
    county_name: "Hampshire",
    county_weights: {
      25015: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 25015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01034",
    lat: 42.0826,
    lng: -72.95611,
    city: "Granville",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2115,
    density: 12.1,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01035",
    lat: 42.35563,
    lng: -72.5692,
    city: "Hadley",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5328,
    density: 89.1,
    county_fips: 25015,
    county_name: "Hampshire",
    county_weights: {
      25015: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 25015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01036",
    lat: 42.0638,
    lng: -72.4157,
    city: "Hampden",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5174,
    density: 101.9,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01037",
    lat: 42.37063,
    lng: -72.19466,
    city: "Hardwick",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 642,
    density: 13.3,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01038",
    lat: 42.38466,
    lng: -72.60559,
    city: "Hatfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2653,
    density: 111.1,
    county_fips: 25015,
    county_name: "Hampshire",
    county_weights: {
      25015: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 25015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01039",
    lat: 42.41049,
    lng: -72.69188,
    city: "Haydenville",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1368,
    density: 32,
    county_fips: 25015,
    county_name: "Hampshire",
    county_weights: {
      25011: 41.33,
      25015: 58.67,
    },
    county_names_all: "Hampshire|Franklin",
    county_fips_all: "25015|25011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01040",
    lat: 42.21251,
    lng: -72.64109,
    city: "Holyoke",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40161,
    density: 732.6,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01050",
    lat: 42.29092,
    lng: -72.87526,
    city: "Huntington",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2454,
    density: 22.9,
    county_fips: 25015,
    county_name: "Hampshire",
    county_weights: {
      25013: 31.02,
      25015: 68.98,
    },
    county_names_all: "Hampshire|Hampden",
    county_fips_all: "25015|25013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01053",
    lat: 42.35205,
    lng: -72.71032,
    city: "Leeds",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1850,
    density: 124.2,
    county_fips: 25015,
    county_name: "Hampshire",
    county_weights: {
      25015: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 25015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01054",
    lat: 42.47381,
    lng: -72.48768,
    city: "Leverett",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1875,
    density: 31.6,
    county_fips: 25011,
    county_name: "Franklin",
    county_weights: {
      25011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 25011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01056",
    lat: 42.19211,
    lng: -72.45805,
    city: "Ludlow",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21223,
    density: 301.3,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01057",
    lat: 42.09118,
    lng: -72.32392,
    city: "Monson",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8778,
    density: 76.1,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01060",
    lat: 42.32218,
    lng: -72.63126,
    city: "Northampton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16386,
    density: 582.1,
    county_fips: 25015,
    county_name: "Hampshire",
    county_weights: {
      25015: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 25015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01062",
    lat: 42.32146,
    lng: -72.69244,
    city: "Florence",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9693,
    density: 214.5,
    county_fips: 25015,
    county_name: "Hampshire",
    county_weights: {
      25015: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 25015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01063",
    lat: 42.31962,
    lng: -72.63951,
    city: "Northampton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 623,
    density: 2722,
    county_fips: 25015,
    county_name: "Hampshire",
    county_weights: {
      25015: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 25015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01066",
    lat: 42.40742,
    lng: -72.64032,
    city: "North Hatfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30,
    density: 9.2,
    county_fips: 25015,
    county_name: "Hampshire",
    county_weights: {
      25011: 0.6,
      25015: 99.4,
    },
    county_names_all: "Hampshire|Franklin",
    county_fips_all: "25015|25011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01068",
    lat: 42.35125,
    lng: -72.04776,
    city: "Oakham",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1636,
    density: 29.1,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01069",
    lat: 42.18798,
    lng: -72.30578,
    city: "Palmer",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8716,
    density: 119.9,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01070",
    lat: 42.51958,
    lng: -72.92504,
    city: "Plainfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 679,
    density: 13.2,
    county_fips: 25015,
    county_name: "Hampshire",
    county_weights: {
      25003: 0.6,
      25015: 99.4,
    },
    county_names_all: "Hampshire|Berkshire",
    county_fips_all: "25015|25003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01071",
    lat: 42.16029,
    lng: -72.8598,
    city: "Russell",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1392,
    density: 34.2,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01072",
    lat: 42.46327,
    lng: -72.41893,
    city: "Shutesbury",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1541,
    density: 31.2,
    county_fips: 25011,
    county_name: "Franklin",
    county_weights: {
      25011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 25011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01073",
    lat: 42.23084,
    lng: -72.73856,
    city: "Southampton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6169,
    density: 84.6,
    county_fips: 25015,
    county_name: "Hampshire",
    county_weights: {
      25015: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 25015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01074",
    lat: 42.3837,
    lng: -72.10021,
    city: "South Barre",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 396,
    density: 589.6,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01075",
    lat: 42.25672,
    lng: -72.57928,
    city: "South Hadley",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17715,
    density: 386,
    county_fips: 25015,
    county_name: "Hampshire",
    county_weights: {
      25015: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 25015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01077",
    lat: 42.05441,
    lng: -72.77851,
    city: "Southwick",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9722,
    density: 121.7,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01079",
    lat: 42.18508,
    lng: -72.33406,
    city: "Thorndike",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 515,
    density: 123.7,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01080",
    lat: 42.18228,
    lng: -72.36515,
    city: "Three Rivers",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2419,
    density: 560.9,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01081",
    lat: 42.06232,
    lng: -72.23085,
    city: "Wales",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1937,
    density: 51.7,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01082",
    lat: 42.29816,
    lng: -72.27676,
    city: "Ware",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10341,
    density: 84.9,
    county_fips: 25015,
    county_name: "Hampshire",
    county_weights: {
      25013: 0.13,
      25015: 73.12,
      25027: 26.75,
    },
    county_names_all: "Hampshire|Worcester|Hampden",
    county_fips_all: "25015|25027|25013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01083",
    lat: 42.20652,
    lng: -72.19906,
    city: "Warren",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3125,
    density: 94.6,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01084",
    lat: 42.38589,
    lng: -72.88165,
    city: "West Chesterfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 165,
    density: 7.6,
    county_fips: 25015,
    county_name: "Hampshire",
    county_weights: {
      25015: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 25015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01085",
    lat: 42.15375,
    lng: -72.76961,
    city: "Westfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41758,
    density: 269.9,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01088",
    lat: 42.38981,
    lng: -72.6465,
    city: "West Hatfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 588,
    density: 43.2,
    county_fips: 25015,
    county_name: "Hampshire",
    county_weights: {
      25015: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 25015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01089",
    lat: 42.12532,
    lng: -72.65025,
    city: "West Springfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28527,
    density: 658.3,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01092",
    lat: 42.20008,
    lng: -72.23715,
    city: "West Warren",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1200,
    density: 68.9,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01093",
    lat: 42.44335,
    lng: -72.65099,
    city: "Whately",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 295,
    density: 26.4,
    county_fips: 25011,
    county_name: "Franklin",
    county_weights: {
      25011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 25011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01094",
    lat: 42.36481,
    lng: -72.13548,
    city: "Wheelwright",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 428,
    density: 229.6,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01095",
    lat: 42.12763,
    lng: -72.42994,
    city: "Wilbraham",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14740,
    density: 253.1,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01096",
    lat: 42.40968,
    lng: -72.77213,
    city: "Williamsburg",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2288,
    density: 24.6,
    county_fips: 25015,
    county_name: "Hampshire",
    county_weights: {
      25011: 7.99,
      25015: 92.01,
    },
    county_names_all: "Hampshire|Franklin",
    county_fips_all: "25015|25011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01097",
    lat: 42.17722,
    lng: -72.83175,
    city: "Woronoco",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 93,
    density: 20.6,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01098",
    lat: 42.39551,
    lng: -72.94315,
    city: "Worthington",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1182,
    density: 14.3,
    county_fips: 25015,
    county_name: "Hampshire",
    county_weights: {
      25015: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 25015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01103",
    lat: 42.10443,
    lng: -72.58997,
    city: "Springfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1989,
    density: 1766.2,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01104",
    lat: 42.13326,
    lng: -72.56733,
    city: "Springfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23150,
    density: 1708.3,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01105",
    lat: 42.09911,
    lng: -72.57865,
    city: "Springfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12651,
    density: 4050.6,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01106",
    lat: 42.04877,
    lng: -72.57163,
    city: "Longmeadow",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15982,
    density: 643.7,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01107",
    lat: 42.12116,
    lng: -72.60642,
    city: "Springfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11693,
    density: 2927.2,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01108",
    lat: 42.0814,
    lng: -72.55866,
    city: "Springfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26397,
    density: 2961.8,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01109",
    lat: 42.11839,
    lng: -72.54876,
    city: "Springfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30684,
    density: 2177.3,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01118",
    lat: 42.09476,
    lng: -72.5253,
    city: "Springfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14839,
    density: 1593.4,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01119",
    lat: 42.12452,
    lng: -72.51126,
    city: "Springfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13253,
    density: 1449.3,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01128",
    lat: 42.09497,
    lng: -72.48806,
    city: "Springfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2989,
    density: 1040.7,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01129",
    lat: 42.1211,
    lng: -72.4877,
    city: "Springfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6296,
    density: 707.5,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01144",
    lat: 42.10189,
    lng: -72.59091,
    city: "Springfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01151",
    lat: 42.15294,
    lng: -72.50883,
    city: "Indian Orchard",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9485,
    density: 1546,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01201",
    lat: 42.45614,
    lng: -73.28114,
    city: "Pittsfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43941,
    density: 281,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01220",
    lat: 42.62686,
    lng: -73.11873,
    city: "Adams",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8129,
    density: 137.1,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01222",
    lat: 42.06242,
    lng: -73.32146,
    city: "Ashley Falls",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 720,
    density: 60.5,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01223",
    lat: 42.31118,
    lng: -73.09835,
    city: "Becket",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2499,
    density: 13.9,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01224",
    lat: 42.50622,
    lng: -73.19841,
    city: "Berkshire",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 163,
    density: 135.2,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01225",
    lat: 42.56385,
    lng: -73.1512,
    city: "Cheshire",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3093,
    density: 44.5,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01226",
    lat: 42.47954,
    lng: -73.15329,
    city: "Dalton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6698,
    density: 118.9,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01229",
    lat: 42.29411,
    lng: -73.35227,
    city: "Glendale",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59,
    density: 9.2,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01230",
    lat: 42.18197,
    lng: -73.34244,
    city: "Great Barrington",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8354,
    density: 33.3,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01235",
    lat: 42.43181,
    lng: -73.07336,
    city: "Hinsdale",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2369,
    density: 19.6,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01236",
    lat: 42.26923,
    lng: -73.37999,
    city: "Housatonic",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1577,
    density: 92,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01237",
    lat: 42.5529,
    lng: -73.25373,
    city: "Lanesborough",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2522,
    density: 19.7,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01238",
    lat: 42.30072,
    lng: -73.22553,
    city: "Lee",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5980,
    density: 83.6,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01240",
    lat: 42.37567,
    lng: -73.26466,
    city: "Lenox",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4666,
    density: 75.3,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01242",
    lat: 42.3334,
    lng: -73.24967,
    city: "Lenox Dale",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 337,
    density: 283.2,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01243",
    lat: 42.34752,
    lng: -73.03467,
    city: "Middlefield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 258,
    density: 7,
    county_fips: 25015,
    county_name: "Hampshire",
    county_weights: {
      25015: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 25015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01244",
    lat: 42.10924,
    lng: -73.27475,
    city: "Mill River",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 120,
    density: 8,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01245",
    lat: 42.19043,
    lng: -73.21579,
    city: "Monterey",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 774,
    density: 11.6,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01247",
    lat: 42.69813,
    lng: -73.09264,
    city: "North Adams",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15340,
    density: 129,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01253",
    lat: 42.20751,
    lng: -73.1118,
    city: "Otis",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 789,
    density: 14.4,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01254",
    lat: 42.37972,
    lng: -73.36608,
    city: "Richmond",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 961,
    density: 25.7,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01255",
    lat: 42.1068,
    lng: -73.12213,
    city: "Sandisfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 891,
    density: 6.8,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01256",
    lat: 42.59627,
    lng: -73.01958,
    city: "Savoy",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 701,
    density: 7.5,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01257",
    lat: 42.0976,
    lng: -73.37241,
    city: "Sheffield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1858,
    density: 21.2,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01258",
    lat: 42.09396,
    lng: -73.46616,
    city: "South Egremont",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 604,
    density: 10.5,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01259",
    lat: 42.07316,
    lng: -73.23282,
    city: "Southfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 617,
    density: 10.4,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01260",
    lat: 42.26663,
    lng: -73.2712,
    city: "South Lee",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01262",
    lat: 42.30433,
    lng: -73.32013,
    city: "Stockbridge",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1136,
    density: 22.2,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01264",
    lat: 42.23997,
    lng: -73.19686,
    city: "Tyringham",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 214,
    density: 5.7,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01266",
    lat: 42.30264,
    lng: -73.39846,
    city: "West Stockbridge",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1281,
    density: 24.5,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01267",
    lat: 42.66593,
    lng: -73.24209,
    city: "Williamstown",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7796,
    density: 50.8,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01270",
    lat: 42.51297,
    lng: -73.04859,
    city: "Windsor",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 897,
    density: 10.7,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01301",
    lat: 42.62375,
    lng: -72.60379,
    city: "Greenfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17611,
    density: 268.2,
    county_fips: 25011,
    county_name: "Franklin",
    county_weights: {
      25011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 25011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01330",
    lat: 42.51772,
    lng: -72.81556,
    city: "Ashfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1594,
    density: 17.9,
    county_fips: 25011,
    county_name: "Franklin",
    county_weights: {
      25011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 25011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01331",
    lat: 42.56793,
    lng: -72.18324,
    city: "Athol",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13609,
    density: 97,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25011: 0.28,
      25027: 99.72,
    },
    county_names_all: "Worcester|Franklin",
    county_fips_all: "25027|25011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01337",
    lat: 42.69512,
    lng: -72.57731,
    city: "Bernardston",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2442,
    density: 25.2,
    county_fips: 25011,
    county_name: "Franklin",
    county_weights: {
      25011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 25011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01338",
    lat: 42.5814,
    lng: -72.80309,
    city: "Buckland",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 150,
    density: 44.2,
    county_fips: 25011,
    county_name: "Franklin",
    county_weights: {
      25011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 25011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01339",
    lat: 42.61099,
    lng: -72.88846,
    city: "Charlemont",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1410,
    density: 9.3,
    county_fips: 25011,
    county_name: "Franklin",
    county_weights: {
      25011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 25011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01340",
    lat: 42.68805,
    lng: -72.73205,
    city: "Colrain",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1780,
    density: 13.2,
    county_fips: 25011,
    county_name: "Franklin",
    county_weights: {
      25011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 25011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01341",
    lat: 42.50734,
    lng: -72.70221,
    city: "Conway",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1796,
    density: 20.7,
    county_fips: 25011,
    county_name: "Franklin",
    county_weights: {
      25011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 25011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01342",
    lat: 42.54384,
    lng: -72.6058,
    city: "Deerfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1165,
    density: 24.4,
    county_fips: 25011,
    county_name: "Franklin",
    county_weights: {
      25011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 25011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01343",
    lat: 42.66766,
    lng: -72.98822,
    city: "Drury",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 78,
    density: 2.6,
    county_fips: 25003,
    county_name: "Berkshire",
    county_weights: {
      25003: 100,
    },
    county_names_all: "Berkshire",
    county_fips_all: 25003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01344",
    lat: 42.60756,
    lng: -72.42916,
    city: "Erving",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1343,
    density: 37.6,
    county_fips: 25011,
    county_name: "Franklin",
    county_weights: {
      25011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 25011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01346",
    lat: 42.6706,
    lng: -72.81323,
    city: "Heath",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 544,
    density: 15.7,
    county_fips: 25011,
    county_name: "Franklin",
    county_weights: {
      25011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 25011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01347",
    lat: 42.56027,
    lng: -72.51321,
    city: "Lake Pleasant",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 139,
    density: 150.2,
    county_fips: 25011,
    county_name: "Franklin",
    county_weights: {
      25011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 25011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01349",
    lat: 42.56656,
    lng: -72.47045,
    city: "Millers Falls",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1267,
    density: 49.6,
    county_fips: 25011,
    county_name: "Franklin",
    county_weights: {
      25011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 25011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01350",
    lat: 42.72259,
    lng: -72.98291,
    city: "Monroe Bridge",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 100,
    density: 3.6,
    county_fips: 25011,
    county_name: "Franklin",
    county_weights: {
      25011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 25011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01351",
    lat: 42.54162,
    lng: -72.52069,
    city: "Montague",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2577,
    density: 50.8,
    county_fips: 25011,
    county_name: "Franklin",
    county_weights: {
      25011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 25011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01354",
    lat: 42.63282,
    lng: -72.51136,
    city: "Gill",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1732,
    density: 48.6,
    county_fips: 25011,
    county_name: "Franklin",
    county_weights: {
      25011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 25011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01355",
    lat: 42.45101,
    lng: -72.33141,
    city: "New Salem",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 981,
    density: 8,
    county_fips: 25011,
    county_name: "Franklin",
    county_weights: {
      25011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 25011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01360",
    lat: 42.67575,
    lng: -72.446,
    city: "Northfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2973,
    density: 33.5,
    county_fips: 25011,
    county_name: "Franklin",
    county_weights: {
      25011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 25011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01364",
    lat: 42.60449,
    lng: -72.29263,
    city: "Orange",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7721,
    density: 82.8,
    county_fips: 25011,
    county_name: "Franklin",
    county_weights: {
      25011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 25011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01366",
    lat: 42.48858,
    lng: -72.18564,
    city: "Petersham",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1155,
    density: 12.1,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01367",
    lat: 42.69674,
    lng: -72.91387,
    city: "Rowe",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 519,
    density: 8.2,
    county_fips: 25011,
    county_name: "Franklin",
    county_weights: {
      25011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 25011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01368",
    lat: 42.67815,
    lng: -72.18557,
    city: "Royalston",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1451,
    density: 12.6,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01370",
    lat: 42.59607,
    lng: -72.72915,
    city: "Shelburne Falls",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3727,
    density: 29.9,
    county_fips: 25011,
    county_name: "Franklin",
    county_weights: {
      25011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 25011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01373",
    lat: 42.47292,
    lng: -72.61516,
    city: "South Deerfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4866,
    density: 81.5,
    county_fips: 25011,
    county_name: "Franklin",
    county_weights: {
      25011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 25011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01375",
    lat: 42.46475,
    lng: -72.55489,
    city: "Sunderland",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3643,
    density: 99.9,
    county_fips: 25011,
    county_name: "Franklin",
    county_weights: {
      25011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 25011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01376",
    lat: 42.59273,
    lng: -72.54591,
    city: "Turners Falls",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4630,
    density: 438.3,
    county_fips: 25011,
    county_name: "Franklin",
    county_weights: {
      25011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 25011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01378",
    lat: 42.67711,
    lng: -72.34057,
    city: "Warwick",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 738,
    density: 7.6,
    county_fips: 25011,
    county_name: "Franklin",
    county_weights: {
      25011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 25011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01379",
    lat: 42.54149,
    lng: -72.3989,
    city: "Wendell",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 835,
    density: 14.9,
    county_fips: 25011,
    county_name: "Franklin",
    county_weights: {
      25011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 25011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01380",
    lat: 42.58675,
    lng: -72.40264,
    city: "Wendell Depot",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 25011,
    county_name: "Franklin",
    county_weights: {
      25011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 25011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01420",
    lat: 42.58559,
    lng: -71.81693,
    city: "Fitchburg",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40576,
    density: 521.2,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01430",
    lat: 42.66069,
    lng: -71.9232,
    city: "Ashburnham",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6320,
    density: 66.4,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01431",
    lat: 42.67652,
    lng: -71.82322,
    city: "Ashby",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3211,
    density: 52.4,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01432",
    lat: 42.56351,
    lng: -71.57059,
    city: "Ayer",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7760,
    density: 351.7,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01434",
    lat: 42.53149,
    lng: -71.61663,
    city: "Devens",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2007,
    density: 119,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25017: 17.74,
      25027: 82.26,
    },
    county_names_all: "Worcester|Middlesex",
    county_fips_all: "25027|25017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01436",
    lat: 42.60579,
    lng: -72.08958,
    city: "Baldwinville",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3538,
    density: 151.9,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01438",
    lat: 42.56028,
    lng: -72.03583,
    city: "East Templeton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 512,
    density: 608.8,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01440",
    lat: 42.58797,
    lng: -71.98649,
    city: "Gardner",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20605,
    density: 324.6,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01450",
    lat: 42.61368,
    lng: -71.56139,
    city: "Groton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11322,
    density: 133.4,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01451",
    lat: 42.50005,
    lng: -71.57754,
    city: "Harvard",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4576,
    density: 83.9,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01452",
    lat: 42.48378,
    lng: -72.00514,
    city: "Hubbardston",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4758,
    density: 44.7,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01453",
    lat: 42.51961,
    lng: -71.76583,
    city: "Leominster",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41654,
    density: 610.1,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01460",
    lat: 42.53503,
    lng: -71.4891,
    city: "Littleton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10152,
    density: 237.3,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01462",
    lat: 42.58994,
    lng: -71.72036,
    city: "Lunenburg",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11530,
    density: 167.2,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01463",
    lat: 42.67126,
    lng: -71.60429,
    city: "Pepperell",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12113,
    density: 207.1,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01464",
    lat: 42.57411,
    lng: -71.6475,
    city: "Shirley",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7616,
    density: 194.4,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01468",
    lat: 42.55324,
    lng: -72.06879,
    city: "Templeton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4065,
    density: 71.5,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01469",
    lat: 42.66514,
    lng: -71.69161,
    city: "Townsend",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7812,
    density: 139.5,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01473",
    lat: 42.55122,
    lng: -71.90266,
    city: "Westminster",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7874,
    density: 85.8,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01474",
    lat: 42.67088,
    lng: -71.7508,
    city: "West Townsend",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1685,
    density: 58.7,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01475",
    lat: 42.66675,
    lng: -72.04902,
    city: "Winchendon",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10831,
    density: 97.8,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01501",
    lat: 42.19689,
    lng: -71.84549,
    city: "Auburn",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16627,
    density: 420.8,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01503",
    lat: 42.38378,
    lng: -71.63552,
    city: "Berlin",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3312,
    density: 98.6,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01504",
    lat: 42.0399,
    lng: -71.53125,
    city: "Blackstone",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9249,
    density: 321.4,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01505",
    lat: 42.35633,
    lng: -71.72123,
    city: "Boylston",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4666,
    density: 112.2,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01506",
    lat: 42.19364,
    lng: -72.10441,
    city: "Brookfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3439,
    density: 85.5,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01507",
    lat: 42.13509,
    lng: -71.96803,
    city: "Charlton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13610,
    density: 124.6,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01510",
    lat: 42.4119,
    lng: -71.68883,
    city: "Clinton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13940,
    density: 952.1,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01515",
    lat: 42.20328,
    lng: -72.04669,
    city: "East Brookfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2157,
    density: 84.4,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01516",
    lat: 42.0528,
    lng: -71.75106,
    city: "Douglas",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9168,
    density: 96.6,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01518",
    lat: 42.11342,
    lng: -72.11632,
    city: "Fiskdale",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3606,
    density: 113.8,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01519",
    lat: 42.20077,
    lng: -71.67892,
    city: "Grafton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7566,
    density: 273.5,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01520",
    lat: 42.33685,
    lng: -71.85181,
    city: "Holden",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16059,
    density: 329.4,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01521",
    lat: 42.06012,
    lng: -72.16592,
    city: "Holland",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2492,
    density: 78.3,
    county_fips: 25013,
    county_name: "Hampden",
    county_weights: {
      25013: 100,
    },
    county_names_all: "Hampden",
    county_fips_all: 25013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01522",
    lat: 42.38142,
    lng: -71.87111,
    city: "Jefferson",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3069,
    density: 75.5,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01523",
    lat: 42.48176,
    lng: -71.68079,
    city: "Lancaster",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7809,
    density: 109.9,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01524",
    lat: 42.24919,
    lng: -71.91989,
    city: "Leicester",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6778,
    density: 164.6,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01525",
    lat: 42.09899,
    lng: -71.64296,
    city: "Linwood",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01527",
    lat: 42.19228,
    lng: -71.77397,
    city: "Millbury",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13822,
    density: 342.5,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01529",
    lat: 42.03906,
    lng: -71.57767,
    city: "Millville",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3249,
    density: 258,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01531",
    lat: 42.31929,
    lng: -72.12794,
    city: "New Braintree",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1155,
    density: 21.5,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01532",
    lat: 42.32314,
    lng: -71.64621,
    city: "Northborough",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15047,
    density: 314.4,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01534",
    lat: 42.13991,
    lng: -71.64433,
    city: "Northbridge",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5885,
    density: 238.8,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01535",
    lat: 42.2695,
    lng: -72.07794,
    city: "North Brookfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4774,
    density: 86.7,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01536",
    lat: 42.23189,
    lng: -71.69219,
    city: "North Grafton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7030,
    density: 317,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01537",
    lat: 42.16177,
    lng: -71.89217,
    city: "North Oxford",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2244,
    density: 127.2,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01540",
    lat: 42.11649,
    lng: -71.85819,
    city: "Oxford",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11679,
    density: 236,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01541",
    lat: 42.45649,
    lng: -71.88128,
    city: "Princeton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3466,
    density: 37.8,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01542",
    lat: 42.20241,
    lng: -71.90995,
    city: "Rochdale",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2544,
    density: 233.1,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01543",
    lat: 42.38482,
    lng: -71.96726,
    city: "Rutland",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8799,
    density: 96.7,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01545",
    lat: 42.28419,
    lng: -71.71558,
    city: "Shrewsbury",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37683,
    density: 701.1,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01550",
    lat: 42.06039,
    lng: -72.03377,
    city: "Southbridge",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16865,
    density: 321.7,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01560",
    lat: 42.17496,
    lng: -71.67762,
    city: "South Grafton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4467,
    density: 484.2,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01561",
    lat: 42.44581,
    lng: -71.68845,
    city: "South Lancaster",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 102,
    density: 1045.3,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01562",
    lat: 42.24715,
    lng: -71.99189,
    city: "Spencer",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11942,
    density: 140.4,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01564",
    lat: 42.44124,
    lng: -71.77297,
    city: "Sterling",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8130,
    density: 102.5,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01566",
    lat: 42.1047,
    lng: -72.07745,
    city: "Sturbridge",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5953,
    density: 92,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01568",
    lat: 42.17694,
    lng: -71.60516,
    city: "Upton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7968,
    density: 145,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01569",
    lat: 42.05895,
    lng: -71.63741,
    city: "Uxbridge",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13901,
    density: 182.7,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01570",
    lat: 42.05206,
    lng: -71.8485,
    city: "Webster",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16934,
    density: 529.1,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01571",
    lat: 42.05501,
    lng: -71.93519,
    city: "Dudley",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11699,
    density: 216.8,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01581",
    lat: 42.26815,
    lng: -71.61402,
    city: "Westborough",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19035,
    density: 356.7,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01583",
    lat: 42.37034,
    lng: -71.78502,
    city: "West Boylston",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7752,
    density: 238,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01585",
    lat: 42.23762,
    lng: -72.16311,
    city: "West Brookfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4601,
    density: 63.3,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01588",
    lat: 42.11837,
    lng: -71.66836,
    city: "Whitinsville",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10439,
    density: 498,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01590",
    lat: 42.13387,
    lng: -71.75179,
    city: "Sutton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9458,
    density: 112.5,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01602",
    lat: 42.27219,
    lng: -71.84946,
    city: "Worcester",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24363,
    density: 1613.8,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01603",
    lat: 42.24373,
    lng: -71.84429,
    city: "Worcester",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18612,
    density: 1586.4,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01604",
    lat: 42.25085,
    lng: -71.7683,
    city: "Worcester",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37633,
    density: 2190.4,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01605",
    lat: 42.28979,
    lng: -71.78802,
    city: "Worcester",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27587,
    density: 1883.9,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01606",
    lat: 42.31367,
    lng: -71.79614,
    city: "Worcester",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20060,
    density: 1293.4,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01607",
    lat: 42.22684,
    lng: -71.79037,
    city: "Worcester",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8410,
    density: 1072.9,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01608",
    lat: 42.2621,
    lng: -71.80145,
    city: "Worcester",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4910,
    density: 3937.1,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01609",
    lat: 42.28592,
    lng: -71.82853,
    city: "Worcester",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21780,
    density: 2252.2,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01610",
    lat: 42.24645,
    lng: -71.80968,
    city: "Worcester",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22152,
    density: 4010.9,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01611",
    lat: 42.23945,
    lng: -71.87702,
    city: "Cherry Valley",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2036,
    density: 230,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01612",
    lat: 42.31037,
    lng: -71.93095,
    city: "Paxton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4961,
    density: 125.5,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01701",
    lat: 42.32195,
    lng: -71.43796,
    city: "Framingham",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33742,
    density: 771.4,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01702",
    lat: 42.28242,
    lng: -71.43428,
    city: "Framingham",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39163,
    density: 1841.6,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01718",
    lat: 42.52165,
    lng: -71.42983,
    city: "Acton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 709,
    density: 1985.8,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01719",
    lat: 42.48837,
    lng: -71.51779,
    city: "Boxborough",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5677,
    density: 213.1,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01720",
    lat: 42.48397,
    lng: -71.43809,
    city: "Acton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22914,
    density: 450.9,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01721",
    lat: 42.25726,
    lng: -71.46867,
    city: "Ashland",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17787,
    density: 556.6,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01730",
    lat: 42.4995,
    lng: -71.27799,
    city: "Bedford",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14072,
    density: 436.6,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01731",
    lat: 42.46422,
    lng: -71.28202,
    city: "Hanscom Afb",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2119,
    density: 350.1,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01740",
    lat: 42.43616,
    lng: -71.60728,
    city: "Bolton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5356,
    density: 103.7,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01741",
    lat: 42.53001,
    lng: -71.35128,
    city: "Carlisle",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5232,
    density: 132.3,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01742",
    lat: 42.46221,
    lng: -71.36504,
    city: "Concord",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18927,
    density: 302.9,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01745",
    lat: 42.29155,
    lng: -71.50101,
    city: "Fayville",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 600,
    density: 594.1,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01746",
    lat: 42.19775,
    lng: -71.44499,
    city: "Holliston",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14792,
    density: 306.2,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01747",
    lat: 42.12477,
    lng: -71.535,
    city: "Hopedale",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5956,
    density: 444.4,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01748",
    lat: 42.2255,
    lng: -71.53781,
    city: "Hopkinton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18030,
    density: 265.4,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01749",
    lat: 42.38868,
    lng: -71.54648,
    city: "Hudson",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19863,
    density: 665.3,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01752",
    lat: 42.3494,
    lng: -71.54681,
    city: "Marlborough",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39663,
    density: 734.1,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01754",
    lat: 42.4264,
    lng: -71.45607,
    city: "Maynard",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10900,
    density: 809.8,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01756",
    lat: 42.09301,
    lng: -71.55146,
    city: "Mendon",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6146,
    density: 133.5,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01757",
    lat: 42.15723,
    lng: -71.51978,
    city: "Milford",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28936,
    density: 738.2,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01760",
    lat: 42.28436,
    lng: -71.34966,
    city: "Natick",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35770,
    density: 934.4,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01770",
    lat: 42.23416,
    lng: -71.37532,
    city: "Sherborn",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4324,
    density: 105.7,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01772",
    lat: 42.30144,
    lng: -71.5304,
    city: "Southborough",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9551,
    density: 270.9,
    county_fips: 25027,
    county_name: "Worcester",
    county_weights: {
      25027: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 25027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01773",
    lat: 42.42572,
    lng: -71.31013,
    city: "Lincoln",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4847,
    density: 135,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01775",
    lat: 42.42983,
    lng: -71.51146,
    city: "Stow",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7159,
    density: 159.5,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01776",
    lat: 42.38456,
    lng: -71.42316,
    city: "Sudbury",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19248,
    density: 304.5,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01778",
    lat: 42.3583,
    lng: -71.35895,
    city: "Wayland",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14038,
    density: 360.6,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01801",
    lat: 42.48694,
    lng: -71.15415,
    city: "Woburn",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40297,
    density: 1224.6,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01803",
    lat: 42.5028,
    lng: -71.20147,
    city: "Burlington",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28077,
    density: 961.8,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01810",
    lat: 42.64669,
    lng: -71.16517,
    city: "Andover",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36098,
    density: 456.6,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01821",
    lat: 42.54999,
    lng: -71.25206,
    city: "Billerica",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32936,
    density: 766.4,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01824",
    lat: 42.59156,
    lng: -71.35553,
    city: "Chelmsford",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25762,
    density: 550.7,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01826",
    lat: 42.68323,
    lng: -71.30063,
    city: "Dracut",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31389,
    density: 583.1,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25009: 0.56,
      25017: 99.44,
    },
    county_names_all: "Middlesex|Essex",
    county_fips_all: "25017|25009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01827",
    lat: 42.67643,
    lng: -71.50052,
    city: "Dunstable",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3374,
    density: 79.2,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01830",
    lat: 42.7959,
    lng: -71.05323,
    city: "Haverhill",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26225,
    density: 730.1,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01832",
    lat: 42.79099,
    lng: -71.13133,
    city: "Haverhill",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23736,
    density: 807,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01833",
    lat: 42.72409,
    lng: -70.9821,
    city: "Georgetown",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8733,
    density: 262.9,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01834",
    lat: 42.75198,
    lng: -71.01486,
    city: "Groveland",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6815,
    density: 296.3,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01835",
    lat: 42.75292,
    lng: -71.08602,
    city: "Haverhill",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13822,
    density: 683.2,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01840",
    lat: 42.70695,
    lng: -71.16014,
    city: "Lawrence",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5416,
    density: 4096.3,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01841",
    lat: 42.71077,
    lng: -71.16494,
    city: "Lawrence",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49437,
    density: 6271.7,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01843",
    lat: 42.68985,
    lng: -71.16095,
    city: "Lawrence",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25170,
    density: 2880,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01844",
    lat: 42.73426,
    lng: -71.18858,
    city: "Methuen",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50517,
    density: 882.6,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01845",
    lat: 42.67132,
    lng: -71.08669,
    city: "North Andover",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31262,
    density: 457,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01850",
    lat: 42.65569,
    lng: -71.30292,
    city: "Lowell",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15950,
    density: 4525.2,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01851",
    lat: 42.62915,
    lng: -71.33674,
    city: "Lowell",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31558,
    density: 3773.8,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01852",
    lat: 42.63231,
    lng: -71.29538,
    city: "Lowell",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35033,
    density: 2720.1,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01854",
    lat: 42.64939,
    lng: -71.34827,
    city: "Lowell",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28770,
    density: 2804.9,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01860",
    lat: 42.83858,
    lng: -71.01194,
    city: "Merrimac",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6926,
    density: 314.7,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01862",
    lat: 42.57427,
    lng: -71.29437,
    city: "North Billerica",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10519,
    density: 446,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01863",
    lat: 42.63274,
    lng: -71.39132,
    city: "North Chelmsford",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9477,
    density: 821.3,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01864",
    lat: 42.58156,
    lng: -71.08759,
    city: "North Reading",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15672,
    density: 459.9,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01867",
    lat: 42.53505,
    lng: -71.1055,
    city: "Reading",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25236,
    density: 977.8,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01876",
    lat: 42.61206,
    lng: -71.22733,
    city: "Tewksbury",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30973,
    density: 574.1,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25009: 0.81,
      25017: 99.19,
    },
    county_names_all: "Middlesex|Essex",
    county_fips_all: "25017|25009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01879",
    lat: 42.66626,
    lng: -71.42911,
    city: "Tyngsboro",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12511,
    density: 288.2,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01880",
    lat: 42.50348,
    lng: -71.06559,
    city: "Wakefield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26704,
    density: 1396.1,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01886",
    lat: 42.58642,
    lng: -71.44008,
    city: "Westford",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24566,
    density: 313.6,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01887",
    lat: 42.56091,
    lng: -71.16541,
    city: "Wilmington",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23390,
    density: 532.1,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01890",
    lat: 42.45177,
    lng: -71.14628,
    city: "Winchester",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22760,
    density: 1456.9,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01901",
    lat: 42.46125,
    lng: -70.94639,
    city: "Lynn",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2370,
    density: 3373.5,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01902",
    lat: 42.4712,
    lng: -70.93983,
    city: "Lynn",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49472,
    density: 8060.3,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01904",
    lat: 42.49151,
    lng: -70.97166,
    city: "Lynn",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17928,
    density: 1630.3,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01905",
    lat: 42.46355,
    lng: -70.9733,
    city: "Lynn",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24369,
    density: 3084.8,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01906",
    lat: 42.46922,
    lng: -71.01299,
    city: "Saugus",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28334,
    density: 944.9,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01907",
    lat: 42.47572,
    lng: -70.90684,
    city: "Swampscott",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15468,
    density: 1975.6,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01908",
    lat: 42.42856,
    lng: -70.92614,
    city: "Nahant",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3512,
    density: 1260.5,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01913",
    lat: 42.85297,
    lng: -70.94459,
    city: "Amesbury",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17474,
    density: 548.9,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01915",
    lat: 42.56841,
    lng: -70.8647,
    city: "Beverly",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42062,
    density: 1143,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01921",
    lat: 42.6815,
    lng: -71.01887,
    city: "Boxford",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8316,
    density: 136.1,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01922",
    lat: 42.75862,
    lng: -70.91758,
    city: "Byfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3758,
    density: 160,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01923",
    lat: 42.57398,
    lng: -70.94923,
    city: "Danvers",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27367,
    density: 800.2,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01929",
    lat: 42.63478,
    lng: -70.77684,
    city: "Essex",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3771,
    density: 104.5,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01930",
    lat: 42.62605,
    lng: -70.68966,
    city: "Gloucester",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30291,
    density: 446.4,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01937",
    lat: 42.58579,
    lng: -70.98406,
    city: "Hathorne",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 182,
    density: 961.9,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01938",
    lat: 42.68568,
    lng: -70.83989,
    city: "Ipswich",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14022,
    density: 168.6,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01940",
    lat: 42.53523,
    lng: -71.03695,
    city: "Lynnfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13429,
    density: 514.5,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01944",
    lat: 42.58154,
    lng: -70.76825,
    city: "Manchester",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5400,
    density: 225.9,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01945",
    lat: 42.49924,
    lng: -70.86348,
    city: "Marblehead",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20530,
    density: 1789.4,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01949",
    lat: 42.6043,
    lng: -71.01641,
    city: "Middleton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9952,
    density: 285.7,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01950",
    lat: 42.81237,
    lng: -70.88785,
    city: "Newburyport",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18197,
    density: 841.4,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01951",
    lat: 42.77742,
    lng: -70.85022,
    city: "Newbury",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3348,
    density: 90.4,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01952",
    lat: 42.84655,
    lng: -70.86163,
    city: "Salisbury",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9477,
    density: 238,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01960",
    lat: 42.53374,
    lng: -70.97222,
    city: "Peabody",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52880,
    density: 1274.8,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01965",
    lat: 42.56294,
    lng: -70.82996,
    city: "Prides Crossing",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01966",
    lat: 42.65432,
    lng: -70.62227,
    city: "Rockport",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7269,
    density: 401.6,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01969",
    lat: 42.72235,
    lng: -70.88832,
    city: "Rowley",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6375,
    density: 135.2,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01970",
    lat: 42.51298,
    lng: -70.90266,
    city: "Salem",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43120,
    density: 2019.9,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01982",
    lat: 42.62669,
    lng: -70.85789,
    city: "South Hamilton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8048,
    density: 218.8,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01983",
    lat: 42.63728,
    lng: -70.94251,
    city: "Topsfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6613,
    density: 214.6,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01984",
    lat: 42.60078,
    lng: -70.8826,
    city: "Wenham",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5208,
    density: 262.6,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "01985",
    lat: 42.7939,
    lng: -70.96906,
    city: "West Newbury",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4688,
    density: 134.6,
    county_fips: 25009,
    county_name: "Essex",
    county_weights: {
      25009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 25009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02019",
    lat: 42.0777,
    lng: -71.47407,
    city: "Bellingham",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17196,
    density: 362,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02021",
    lat: 42.17504,
    lng: -71.12645,
    city: "Canton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23615,
    density: 486.4,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02025",
    lat: 42.23603,
    lng: -70.81906,
    city: "Cohasset",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8520,
    density: 336.6,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02026",
    lat: 42.24665,
    lng: -71.1777,
    city: "Dedham",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25316,
    density: 951.7,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02030",
    lat: 42.2366,
    lng: -71.28421,
    city: "Dover",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6079,
    density: 155.5,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02032",
    lat: 42.15489,
    lng: -71.2155,
    city: "East Walpole",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4360,
    density: 719.9,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02035",
    lat: 42.06266,
    lng: -71.24613,
    city: "Foxboro",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17917,
    density: 348.4,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02038",
    lat: 42.08622,
    lng: -71.41126,
    city: "Franklin",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33644,
    density: 487.6,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02043",
    lat: 42.21678,
    lng: -70.88494,
    city: "Hingham",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23983,
    density: 417.5,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02045",
    lat: 42.28437,
    lng: -70.88266,
    city: "Hull",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10478,
    density: 1513.1,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02047",
    lat: 42.14582,
    lng: -70.69603,
    city: "Humarock",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 156,
    density: 104.4,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02048",
    lat: 42.01626,
    lng: -71.21868,
    city: "Mansfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24145,
    density: 463.7,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02050",
    lat: 42.11443,
    lng: -70.71487,
    city: "Marshfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26109,
    density: 350.5,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02052",
    lat: 42.1848,
    lng: -71.30501,
    city: "Medfield",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12926,
    density: 346.4,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02053",
    lat: 42.15352,
    lng: -71.42906,
    city: "Medway",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13398,
    density: 448.4,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02054",
    lat: 42.1693,
    lng: -71.36261,
    city: "Millis",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8288,
    density: 265.9,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02056",
    lat: 42.11632,
    lng: -71.32952,
    city: "Norfolk",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11861,
    density: 307.4,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02061",
    lat: 42.16075,
    lng: -70.81772,
    city: "Norwell",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11120,
    density: 205.1,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02062",
    lat: 42.18563,
    lng: -71.19464,
    city: "Norwood",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29446,
    density: 1077.7,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02066",
    lat: 42.20129,
    lng: -70.76155,
    city: "Scituate",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18511,
    density: 433.2,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02067",
    lat: 42.10778,
    lng: -71.18183,
    city: "Sharon",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18653,
    density: 317.5,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02071",
    lat: 42.10392,
    lng: -71.27002,
    city: "South Walpole",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1230,
    density: 493.7,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02072",
    lat: 42.1192,
    lng: -71.10189,
    city: "Stoughton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28742,
    density: 689.9,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02081",
    lat: 42.14689,
    lng: -71.25916,
    city: "Walpole",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19850,
    density: 432.4,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02090",
    lat: 42.22024,
    lng: -71.21057,
    city: "Westwood",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16229,
    density: 575.4,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02093",
    lat: 42.05129,
    lng: -71.35522,
    city: "Wrentham",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11930,
    density: 212.2,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02108",
    lat: 42.35657,
    lng: -71.06516,
    city: "Boston",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4520,
    density: 6372.3,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25025: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 25025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02109",
    lat: 42.36498,
    lng: -71.05277,
    city: "Boston",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3639,
    density: 8285.5,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25025: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 25025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02110",
    lat: 42.35797,
    lng: -71.05189,
    city: "Boston",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2340,
    density: 5050.6,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25025: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 25025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02111",
    lat: 42.35067,
    lng: -71.06054,
    city: "Boston",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7949,
    density: 15658.3,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25025: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 25025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02113",
    lat: 42.36526,
    lng: -71.05524,
    city: "Boston",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7339,
    density: 29115.5,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25025: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 25025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02114",
    lat: 42.36337,
    lng: -71.06686,
    city: "Boston",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13260,
    density: 11546.2,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25025: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 25025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02115",
    lat: 42.34046,
    lng: -71.09481,
    city: "Boston",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29134,
    density: 15827.6,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25025: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 25025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02116",
    lat: 42.35105,
    lng: -71.07638,
    city: "Boston",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23007,
    density: 13678.9,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25025: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 25025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02118",
    lat: 42.33806,
    lng: -71.07057,
    city: "Boston",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28892,
    density: 10256,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25025: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 25025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02119",
    lat: 42.32405,
    lng: -71.08522,
    city: "Roxbury",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27426,
    density: 6556.1,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25025: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 25025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02120",
    lat: 42.33212,
    lng: -71.09654,
    city: "Roxbury Crossing",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15210,
    density: 9487,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25025: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 25025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02121",
    lat: 42.3057,
    lng: -71.08693,
    city: "Dorchester",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29570,
    density: 6054.7,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25025: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 25025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02122",
    lat: 42.29427,
    lng: -71.05185,
    city: "Dorchester",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24874,
    density: 5658.1,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25025: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 25025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02124",
    lat: 42.28583,
    lng: -71.07114,
    city: "Dorchester Center",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57128,
    density: 7432.2,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25025: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 25025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02125",
    lat: 42.31578,
    lng: -71.0562,
    city: "Dorchester",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34725,
    density: 6184.4,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25025: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 25025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02126",
    lat: 42.27588,
    lng: -71.0918,
    city: "Mattapan",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29807,
    density: 6294.6,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25021: 0.75,
      25025: 99.25,
    },
    county_names_all: "Suffolk|Norfolk",
    county_fips_all: "25025|25021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02127",
    lat: 42.33455,
    lng: -71.03875,
    city: "South Boston",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36941,
    density: 6931.6,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25025: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 25025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02128",
    lat: 42.37324,
    lng: -71.01616,
    city: "East Boston",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47804,
    density: 3673.3,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25025: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 25025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02129",
    lat: 42.37975,
    lng: -71.06167,
    city: "Charlestown",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20504,
    density: 5848.3,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25017: 0.45,
      25025: 99.55,
    },
    county_names_all: "Suffolk|Middlesex",
    county_fips_all: "25025|25017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02130",
    lat: 42.30823,
    lng: -71.11515,
    city: "Jamaica Plain",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42021,
    density: 4582.7,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25025: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 25025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02131",
    lat: 42.28392,
    lng: -71.12468,
    city: "Roslindale",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34048,
    density: 4715.8,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25025: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 25025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02132",
    lat: 42.27931,
    lng: -71.16072,
    city: "West Roxbury",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28263,
    density: 2243.5,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25021: 0.18,
      25025: 99.82,
    },
    county_names_all: "Suffolk|Norfolk",
    county_fips_all: "25025|25021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02133",
    lat: 42.35838,
    lng: -71.06383,
    city: "Boston",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25025: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 25025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02134",
    lat: 42.35855,
    lng: -71.12931,
    city: "Allston",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19552,
    density: 6115.9,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25017: 0.34,
      25025: 99.66,
    },
    county_names_all: "Suffolk|Middlesex",
    county_fips_all: "25025|25017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02135",
    lat: 42.34989,
    lng: -71.15417,
    city: "Brighton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45496,
    density: 6756.9,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25025: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 25025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02136",
    lat: 42.25505,
    lng: -71.12662,
    city: "Hyde Park",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36417,
    density: 3057.7,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25025: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 25025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02138",
    lat: 42.37997,
    lng: -71.13446,
    city: "Cambridge",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39139,
    density: 5518.7,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02139",
    lat: 42.36224,
    lng: -71.10253,
    city: "Cambridge",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39702,
    density: 9878.1,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02140",
    lat: 42.39332,
    lng: -71.13342,
    city: "Cambridge",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20954,
    density: 6984.2,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02141",
    lat: 42.37041,
    lng: -71.08218,
    city: "Cambridge",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14437,
    density: 9156.4,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02142",
    lat: 42.36295,
    lng: -71.08189,
    city: "Cambridge",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4074,
    density: 5014.2,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02143",
    lat: 42.38142,
    lng: -71.09677,
    city: "Somerville",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25102,
    density: 6274.8,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02144",
    lat: 42.40088,
    lng: -71.122,
    city: "Somerville",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25009,
    density: 8843.5,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02145",
    lat: 42.39206,
    lng: -71.0895,
    city: "Somerville",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28372,
    density: 7877,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02148",
    lat: 42.43048,
    lng: -71.05762,
    city: "Malden",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60710,
    density: 4645.3,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02149",
    lat: 42.40643,
    lng: -71.05446,
    city: "Everett",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46275,
    density: 5225.6,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 99.8,
      25025: 0.2,
    },
    county_names_all: "Middlesex|Suffolk",
    county_fips_all: "25017|25025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02150",
    lat: 42.39587,
    lng: -71.03251,
    city: "Chelsea",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39862,
    density: 6950.9,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25017: 0.17,
      25025: 99.83,
    },
    county_names_all: "Suffolk|Middlesex",
    county_fips_all: "25025|25017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02151",
    lat: 42.41887,
    lng: -71.004,
    city: "Revere",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53416,
    density: 3614.9,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25025: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 25025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02152",
    lat: 42.37724,
    lng: -70.98115,
    city: "Winthrop",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18558,
    density: 4323.6,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25025: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 25025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02155",
    lat: 42.42324,
    lng: -71.10878,
    city: "Medford",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60533,
    density: 2853.8,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02163",
    lat: 42.36717,
    lng: -71.12509,
    city: "Boston",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2343,
    density: 4930.9,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25025: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 25025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02169",
    lat: 42.23971,
    lng: -71.01802,
    city: "Quincy",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56999,
    density: 1819.5,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02170",
    lat: 42.26644,
    lng: -71.01621,
    city: "Quincy",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19163,
    density: 3548.7,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02171",
    lat: 42.28709,
    lng: -71.02604,
    city: "Quincy",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18227,
    density: 2869.3,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 97.35,
      25025: 2.65,
    },
    county_names_all: "Norfolk|Suffolk",
    county_fips_all: "25021|25025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02176",
    lat: 42.45561,
    lng: -71.05901,
    city: "Melrose",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28054,
    density: 2312.9,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02180",
    lat: 42.47396,
    lng: -71.09705,
    city: "Stoneham",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23625,
    density: 1525.9,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02184",
    lat: 42.20386,
    lng: -71.0022,
    city: "Braintree",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37196,
    density: 1043.5,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02186",
    lat: 42.23854,
    lng: -71.08464,
    city: "Milton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27590,
    density: 777.8,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02188",
    lat: 42.20724,
    lng: -70.95764,
    city: "Weymouth",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16114,
    density: 1611.1,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02189",
    lat: 42.2111,
    lng: -70.93135,
    city: "East Weymouth",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15337,
    density: 1476.7,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02190",
    lat: 42.16625,
    lng: -70.95253,
    city: "South Weymouth",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17466,
    density: 964,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02191",
    lat: 42.24434,
    lng: -70.94378,
    city: "North Weymouth",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8296,
    density: 1786.2,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02199",
    lat: 42.34748,
    lng: -71.08199,
    city: "Boston",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1435,
    density: 9675,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25025: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 25025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02203",
    lat: 42.36144,
    lng: -71.05945,
    city: "Boston",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24,
    density: 960.1,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25025: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 25025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02205",
    lat: 42.34935,
    lng: -71.05564,
    city: "Boston",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25025: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 25025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02210",
    lat: 42.34815,
    lng: -71.03942,
    city: "Boston",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4538,
    density: 1898.9,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25025: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 25025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02215",
    lat: 42.34741,
    lng: -71.10276,
    city: "Boston",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26243,
    density: 11458.2,
    county_fips: 25025,
    county_name: "Suffolk",
    county_weights: {
      25021: 4.29,
      25025: 95.71,
    },
    county_names_all: "Suffolk|Norfolk",
    county_fips_all: "25025|25021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02301",
    lat: 42.07791,
    lng: -71.04223,
    city: "Brockton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63920,
    density: 1982.8,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02302",
    lat: 42.08792,
    lng: -70.99864,
    city: "Brockton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31820,
    density: 1383.3,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02322",
    lat: 42.12666,
    lng: -71.04922,
    city: "Avon",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4513,
    density: 406,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02324",
    lat: 41.97272,
    lng: -70.97498,
    city: "Bridgewater",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27441,
    density: 392.7,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02325",
    lat: 41.98875,
    lng: -70.96449,
    city: "Bridgewater",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02330",
    lat: 41.87388,
    lng: -70.7563,
    city: "Carver",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11745,
    density: 121.6,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02332",
    lat: 42.04651,
    lng: -70.71388,
    city: "Duxbury",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15912,
    density: 259.2,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02333",
    lat: 42.03521,
    lng: -70.94235,
    city: "East Bridgewater",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14509,
    density: 325.8,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02338",
    lat: 41.99138,
    lng: -70.86326,
    city: "Halifax",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7830,
    density: 189.3,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02339",
    lat: 42.12241,
    lng: -70.85665,
    city: "Hanover",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14526,
    density: 361,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02341",
    lat: 42.05604,
    lng: -70.87251,
    city: "Hanson",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10874,
    density: 281.7,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02343",
    lat: 42.14733,
    lng: -71.00484,
    city: "Holbrook",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11051,
    density: 608.6,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02346",
    lat: 41.88034,
    lng: -70.87446,
    city: "Middleboro",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25139,
    density: 140.6,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02347",
    lat: 41.83101,
    lng: -70.9594,
    city: "Lakeville",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11531,
    density: 150.4,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02350",
    lat: 42.02043,
    lng: -70.84562,
    city: "Monponsett",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02351",
    lat: 42.11805,
    lng: -70.95905,
    city: "Abington",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16557,
    density: 641.6,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02356",
    lat: 42.05519,
    lng: -71.12071,
    city: "North Easton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12474,
    density: 354,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02357",
    lat: 42.06224,
    lng: -71.07751,
    city: "North Easton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1050,
    density: 1044.2,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02359",
    lat: 42.06547,
    lng: -70.8014,
    city: "Pembroke",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18455,
    density: 327,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02360",
    lat: 41.87817,
    lng: -70.63089,
    city: "Plymouth",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60797,
    density: 243.5,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02364",
    lat: 41.98616,
    lng: -70.74823,
    city: "Kingston",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13746,
    density: 284.7,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02366",
    lat: 41.84868,
    lng: -70.6613,
    city: "South Carver",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 194,
    density: 1672.9,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02367",
    lat: 41.96345,
    lng: -70.80975,
    city: "Plympton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2979,
    density: 78.3,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02368",
    lat: 42.17506,
    lng: -71.05011,
    city: "Randolph",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34214,
    density: 1416.9,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02370",
    lat: 42.1295,
    lng: -70.91002,
    city: "Rockland",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18010,
    density: 693.4,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02375",
    lat: 42.01954,
    lng: -71.10381,
    city: "South Easton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11336,
    density: 317.6,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02379",
    lat: 42.02139,
    lng: -71.0267,
    city: "West Bridgewater",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7254,
    density: 182.8,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02382",
    lat: 42.08,
    lng: -70.93993,
    city: "Whitman",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15139,
    density: 842.7,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02420",
    lat: 42.45821,
    lng: -71.21762,
    city: "Lexington",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14726,
    density: 807.9,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02421",
    lat: 42.438,
    lng: -71.23922,
    city: "Lexington",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18578,
    density: 749.6,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02445",
    lat: 42.32581,
    lng: -71.13319,
    city: "Brookline",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20520,
    density: 3034.3,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 97.44,
      25025: 2.56,
    },
    county_names_all: "Norfolk|Suffolk",
    county_fips_all: "25021|25025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02446",
    lat: 42.3435,
    lng: -71.12179,
    city: "Brookline",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29711,
    density: 8932.2,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 99.9,
      25025: 0.1,
    },
    county_names_all: "Norfolk|Suffolk",
    county_fips_all: "25021|25025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02451",
    lat: 42.39859,
    lng: -71.2573,
    city: "Waltham",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17470,
    density: 1267.9,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02452",
    lat: 42.39365,
    lng: -71.2202,
    city: "Waltham",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15636,
    density: 1583.2,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02453",
    lat: 42.36918,
    lng: -71.24101,
    city: "Waltham",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29289,
    density: 3148.3,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02457",
    lat: 42.29777,
    lng: -71.26887,
    city: "Babson Park",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1812,
    density: 3454.7,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02458",
    lat: 42.35294,
    lng: -71.18763,
    city: "Newton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12050,
    density: 2367,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02459",
    lat: 42.31515,
    lng: -71.19174,
    city: "Newton Center",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18631,
    density: 1429.1,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02460",
    lat: 42.35206,
    lng: -71.20835,
    city: "Newtonville",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9885,
    density: 2831.6,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02461",
    lat: 42.31693,
    lng: -71.20875,
    city: "Newton Highlands",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6923,
    density: 1741.2,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02462",
    lat: 42.33102,
    lng: -71.25599,
    city: "Newton Lower Falls",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1222,
    density: 675.6,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 99.45,
      25021: 0.55,
    },
    county_names_all: "Middlesex|Norfolk",
    county_fips_all: "25017|25021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02464",
    lat: 42.31274,
    lng: -71.21981,
    city: "Newton Upper Falls",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3706,
    density: 2598.9,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 99.58,
      25021: 0.42,
    },
    county_names_all: "Middlesex|Norfolk",
    county_fips_all: "25017|25021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02465",
    lat: 42.34969,
    lng: -71.22646,
    city: "West Newton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11967,
    density: 2148,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02466",
    lat: 42.34541,
    lng: -71.24759,
    city: "Auburndale",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9292,
    density: 2260.2,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02467",
    lat: 42.31725,
    lng: -71.16096,
    city: "Chestnut Hill",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22982,
    density: 1808.8,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25017: 28.65,
      25021: 57.05,
      25025: 14.3,
    },
    county_names_all: "Norfolk|Middlesex|Suffolk",
    county_fips_all: "25021|25017|25025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02468",
    lat: 42.32777,
    lng: -71.23142,
    city: "Waban",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5522,
    density: 1388,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02472",
    lat: 42.37,
    lng: -71.17713,
    city: "Watertown",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35951,
    density: 3444.2,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02474",
    lat: 42.42053,
    lng: -71.15666,
    city: "Arlington",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27853,
    density: 3516.2,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02476",
    lat: 42.41597,
    lng: -71.17437,
    city: "Arlington",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17526,
    density: 3246.4,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02478",
    lat: 42.39602,
    lng: -71.17955,
    city: "Belmont",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26123,
    density: 2171.2,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02481",
    lat: 42.31064,
    lng: -71.27779,
    city: "Wellesley Hills",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16121,
    density: 1022.1,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02482",
    lat: 42.29455,
    lng: -71.29859,
    city: "Wellesley",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10814,
    density: 1122.1,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02492",
    lat: 42.27615,
    lng: -71.24387,
    city: "Needham",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20679,
    density: 840,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02493",
    lat: 42.35893,
    lng: -71.30009,
    city: "Weston",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12103,
    density: 277.8,
    county_fips: 25017,
    county_name: "Middlesex",
    county_weights: {
      25017: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 25017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02494",
    lat: 42.29959,
    lng: -71.2317,
    city: "Needham Heights",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10498,
    density: 1447.4,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02532",
    lat: 41.75111,
    lng: -70.59713,
    city: "Buzzards Bay",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13443,
    density: 376.5,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 89.93,
      25023: 10.07,
    },
    county_names_all: "Barnstable|Plymouth",
    county_fips_all: "25001|25023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02534",
    lat: 41.66626,
    lng: -70.61628,
    city: "Cataumet",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1082,
    density: 152.5,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02535",
    lat: 41.34896,
    lng: -70.74629,
    city: "Chilmark",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2005,
    density: 31.8,
    county_fips: 25007,
    county_name: "Dukes",
    county_weights: {
      25007: 100,
    },
    county_names_all: "Dukes",
    county_fips_all: 25007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02536",
    lat: 41.59706,
    lng: -70.56677,
    city: "East Falmouth",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19629,
    density: 277,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02537",
    lat: 41.72882,
    lng: -70.44317,
    city: "East Sandwich",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6824,
    density: 192,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02538",
    lat: 41.77872,
    lng: -70.65077,
    city: "East Wareham",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4129,
    density: 254.5,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02539",
    lat: 41.37994,
    lng: -70.53227,
    city: "Edgartown",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4358,
    density: 62.8,
    county_fips: 25007,
    county_name: "Dukes",
    county_weights: {
      25007: 100,
    },
    county_names_all: "Dukes",
    county_fips_all: 25007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02540",
    lat: 41.57128,
    lng: -70.62807,
    city: "Falmouth",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8241,
    density: 289.1,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02542",
    lat: 41.70194,
    lng: -70.54824,
    city: "Buzzards Bay",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 948,
    density: 12.8,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02543",
    lat: 41.48731,
    lng: -70.74525,
    city: "Woods Hole",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 680,
    density: 23.2,
    county_fips: 25007,
    county_name: "Dukes",
    county_weights: {
      25001: 16.99,
      25007: 83.01,
    },
    county_names_all: "Dukes|Barnstable",
    county_fips_all: "25007|25001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02553",
    lat: 41.71297,
    lng: -70.62011,
    city: "Monument Beach",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 96,
    density: 187.4,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02554",
    lat: 41.28555,
    lng: -70.08043,
    city: "Nantucket",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11023,
    density: 106.4,
    county_fips: 25019,
    county_name: "Nantucket",
    county_weights: {
      25019: 100,
    },
    county_names_all: "Nantucket",
    county_fips_all: 25019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02556",
    lat: 41.63903,
    lng: -70.62521,
    city: "North Falmouth",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2554,
    density: 249.8,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02557",
    lat: 41.44218,
    lng: -70.56648,
    city: "Oak Bluffs",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4701,
    density: 560.2,
    county_fips: 25007,
    county_name: "Dukes",
    county_weights: {
      25007: 100,
    },
    county_names_all: "Dukes",
    county_fips_all: 25007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02558",
    lat: 41.74453,
    lng: -70.65377,
    city: "Onset",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1632,
    density: 564.2,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02559",
    lat: 41.69237,
    lng: -70.61374,
    city: "Pocasset",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3228,
    density: 233.7,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02561",
    lat: 41.76782,
    lng: -70.53281,
    city: "Sagamore",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 257,
    density: 119.7,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02562",
    lat: 41.78753,
    lng: -70.52746,
    city: "Sagamore Beach",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2814,
    density: 321.8,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02563",
    lat: 41.71995,
    lng: -70.4818,
    city: "Sandwich",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9728,
    density: 284.2,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02564",
    lat: 41.26552,
    lng: -69.98608,
    city: "Siasconset",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 189,
    density: 12,
    county_fips: 25019,
    county_name: "Nantucket",
    county_weights: {
      25019: 100,
    },
    county_names_all: "Nantucket",
    county_fips_all: 25019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02568",
    lat: 41.44341,
    lng: -70.61534,
    city: "Vineyard Haven",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4132,
    density: 124.2,
    county_fips: 25007,
    county_name: "Dukes",
    county_weights: {
      25007: 100,
    },
    county_names_all: "Dukes",
    county_fips_all: 25007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02571",
    lat: 41.76184,
    lng: -70.70138,
    city: "Wareham",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10858,
    density: 224.2,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02575",
    lat: 41.39651,
    lng: -70.65496,
    city: "West Tisbury",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2197,
    density: 37.3,
    county_fips: 25007,
    county_name: "Dukes",
    county_weights: {
      25007: 100,
    },
    county_names_all: "Dukes",
    county_fips_all: 25007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02576",
    lat: 41.77807,
    lng: -70.76338,
    city: "West Wareham",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4171,
    density: 171.2,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02584",
    lat: 41.25753,
    lng: -70.00522,
    city: "Nantucket",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 25019,
    county_name: "Nantucket",
    county_weights: {
      25019: 100,
    },
    county_names_all: "Nantucket",
    county_fips_all: 25019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02601",
    lat: 41.66,
    lng: -70.29327,
    city: "Hyannis",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14939,
    density: 657.8,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02630",
    lat: 41.69674,
    lng: -70.3052,
    city: "Barnstable",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1892,
    density: 149.7,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02631",
    lat: 41.74673,
    lng: -70.06894,
    city: "Brewster",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9565,
    density: 166.4,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02632",
    lat: 41.66074,
    lng: -70.34826,
    city: "Centerville",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11105,
    density: 574.7,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02633",
    lat: 41.68949,
    lng: -69.97397,
    city: "Chatham",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4040,
    density: 180.7,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02635",
    lat: 41.62348,
    lng: -70.44051,
    city: "Cotuit",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2826,
    density: 198.8,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02637",
    lat: 41.70493,
    lng: -70.27245,
    city: "Cummaquid",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 184,
    density: 92,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02638",
    lat: 41.73225,
    lng: -70.19459,
    city: "Dennis",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3028,
    density: 207.4,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02639",
    lat: 41.66639,
    lng: -70.13535,
    city: "Dennis Port",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3147,
    density: 434.5,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02641",
    lat: 41.75221,
    lng: -70.15176,
    city: "East Dennis",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 202,
    density: 47,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02642",
    lat: 41.83976,
    lng: -69.97711,
    city: "Eastham",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4873,
    density: 134.7,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02643",
    lat: 41.75534,
    lng: -69.94002,
    city: "East Orleans",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02644",
    lat: 41.68361,
    lng: -70.51202,
    city: "Forestdale",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3744,
    density: 428.4,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02645",
    lat: 41.70352,
    lng: -70.06215,
    city: "Harwich",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9730,
    density: 222,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02646",
    lat: 41.67103,
    lng: -70.07144,
    city: "Harwich Port",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1715,
    density: 228.1,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02647",
    lat: 41.63127,
    lng: -70.30909,
    city: "Hyannis Port",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 121,
    density: 108.3,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02648",
    lat: 41.67237,
    lng: -70.41545,
    city: "Marstons Mills",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6833,
    density: 264.3,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02649",
    lat: 41.61778,
    lng: -70.49077,
    city: "Mashpee",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14204,
    density: 234.4,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02650",
    lat: 41.7036,
    lng: -69.96589,
    city: "North Chatham",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 865,
    density: 244.8,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02652",
    lat: 42.0428,
    lng: -70.09276,
    city: "North Truro",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 710,
    density: 32.6,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02653",
    lat: 41.76901,
    lng: -69.9737,
    city: "Orleans",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5865,
    density: 187.9,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02655",
    lat: 41.62972,
    lng: -70.39263,
    city: "Osterville",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3100,
    density: 185,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02657",
    lat: 42.06139,
    lng: -70.19813,
    city: "Provincetown",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2972,
    density: 118.7,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02659",
    lat: 41.68258,
    lng: -70.02234,
    city: "South Chatham",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 992,
    density: 193.2,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02660",
    lat: 41.70828,
    lng: -70.15517,
    city: "South Dennis",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6336,
    density: 292.2,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02663",
    lat: 41.90576,
    lng: -69.989,
    city: "South Wellfleet",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 106,
    density: 14.3,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02664",
    lat: 41.67486,
    lng: -70.19446,
    city: "South Yarmouth",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8565,
    density: 473.5,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02666",
    lat: 41.98817,
    lng: -70.04603,
    city: "Truro",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 366,
    density: 11.3,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02667",
    lat: 41.92937,
    lng: -70.02074,
    city: "Wellfleet",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3556,
    density: 81.1,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02668",
    lat: 41.70713,
    lng: -70.36246,
    city: "West Barnstable",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2696,
    density: 72.7,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02670",
    lat: 41.66,
    lng: -70.17098,
    city: "West Dennis",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1190,
    density: 216.3,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02671",
    lat: 41.66938,
    lng: -70.11087,
    city: "West Harwich",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 940,
    density: 209.3,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02672",
    lat: 41.6357,
    lng: -70.31878,
    city: "West Hyannisport",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 261,
    density: 204.1,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02673",
    lat: 41.6557,
    lng: -70.24447,
    city: "West Yarmouth",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8875,
    density: 369.6,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02675",
    lat: 41.70401,
    lng: -70.22883,
    city: "Yarmouth Port",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6392,
    density: 281.6,
    county_fips: 25001,
    county_name: "Barnstable",
    county_weights: {
      25001: 100,
    },
    county_names_all: "Barnstable",
    county_fips_all: 25001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02702",
    lat: 41.78452,
    lng: -71.06112,
    city: "Assonet",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4450,
    density: 102.3,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02703",
    lat: 41.93108,
    lng: -71.29499,
    city: "Attleboro",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45023,
    density: 649.5,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02713",
    lat: 41.42818,
    lng: -70.89102,
    city: "Cuttyhunk",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37,
    density: 4,
    county_fips: 25007,
    county_name: "Dukes",
    county_weights: {
      25007: 100,
    },
    county_names_all: "Dukes",
    county_fips_all: 25007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02715",
    lat: 41.81681,
    lng: -71.15064,
    city: "Dighton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3934,
    density: 135.9,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02717",
    lat: 41.75405,
    lng: -70.98312,
    city: "East Freetown",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4914,
    density: 85.5,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02718",
    lat: 41.86902,
    lng: -71.01128,
    city: "East Taunton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6748,
    density: 253.2,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02719",
    lat: 41.63945,
    lng: -70.87322,
    city: "Fairhaven",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16072,
    density: 501.1,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02720",
    lat: 41.73095,
    lng: -71.10932,
    city: "Fall River",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30579,
    density: 895.6,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02721",
    lat: 41.67451,
    lng: -71.14869,
    city: "Fall River",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25826,
    density: 2478.6,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02723",
    lat: 41.69237,
    lng: -71.1309,
    city: "Fall River",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15340,
    density: 3714.1,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02724",
    lat: 41.68372,
    lng: -71.17949,
    city: "Fall River",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17506,
    density: 3752.9,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02725",
    lat: 41.71253,
    lng: -71.18426,
    city: "Somerset",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2647,
    density: 430.6,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02726",
    lat: 41.76073,
    lng: -71.14444,
    city: "Somerset",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15513,
    density: 1083.8,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02738",
    lat: 41.7092,
    lng: -70.76362,
    city: "Marion",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5148,
    density: 140.7,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02739",
    lat: 41.6687,
    lng: -70.81705,
    city: "Mattapoisett",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6374,
    density: 142,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02740",
    lat: 41.63802,
    lng: -70.93839,
    city: "New Bedford",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43444,
    density: 2918.5,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02743",
    lat: 41.71323,
    lng: -70.90054,
    city: "Acushnet",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10589,
    density: 226.4,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02744",
    lat: 41.60789,
    lng: -70.91286,
    city: "New Bedford",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11695,
    density: 3470.9,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02745",
    lat: 41.70284,
    lng: -70.94695,
    city: "New Bedford",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24836,
    density: 976.5,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02746",
    lat: 41.66474,
    lng: -70.945,
    city: "New Bedford",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15283,
    density: 2071.2,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02747",
    lat: 41.6577,
    lng: -71.01202,
    city: "North Dartmouth",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23051,
    density: 217.1,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02748",
    lat: 41.56096,
    lng: -70.97963,
    city: "South Dartmouth",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11212,
    density: 186.5,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02760",
    lat: 41.97004,
    lng: -71.33586,
    city: "North Attleboro",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27615,
    density: 593.7,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02762",
    lat: 42.01409,
    lng: -71.33642,
    city: "Plainville",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9227,
    density: 324.2,
    county_fips: 25021,
    county_name: "Norfolk",
    county_weights: {
      25021: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 25021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02763",
    lat: 41.96666,
    lng: -71.30743,
    city: "Attleboro Falls",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1666,
    density: 717.1,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02764",
    lat: 41.8562,
    lng: -71.16022,
    city: "North Dighton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3911,
    density: 138.5,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02766",
    lat: 41.96402,
    lng: -71.18418,
    city: "Norton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19874,
    density: 275.7,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02767",
    lat: 41.93939,
    lng: -71.05191,
    city: "Raynham",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14626,
    density: 228.2,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02769",
    lat: 41.84394,
    lng: -71.24559,
    city: "Rehoboth",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12285,
    density: 101.1,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02770",
    lat: 41.75875,
    lng: -70.84048,
    city: "Rochester",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5461,
    density: 65.2,
    county_fips: 25023,
    county_name: "Plymouth",
    county_weights: {
      25023: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 25023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02771",
    lat: 41.83787,
    lng: -71.31736,
    city: "Seekonk",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15613,
    density: 327.8,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02777",
    lat: 41.75699,
    lng: -71.21208,
    city: "Swansea",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16692,
    density: 284.7,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02779",
    lat: 41.83492,
    lng: -71.07543,
    city: "Berkley",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6801,
    density: 159,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02780",
    lat: 41.90743,
    lng: -71.11939,
    city: "Taunton",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50299,
    density: 586.3,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02790",
    lat: 41.59967,
    lng: -71.08266,
    city: "Westport",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15879,
    density: 113.8,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02791",
    lat: 41.52262,
    lng: -71.08266,
    city: "Westport Point",
    state_id: "MA",
    state_name: "Massachusetts",
    zcta: "TRUE",
    parent_zcta: "",
    population: 373,
    density: 110.5,
    county_fips: 25005,
    county_name: "Bristol",
    county_weights: {
      25005: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 25005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02802",
    lat: 41.95221,
    lng: -71.4559,
    city: "Albion",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 501,
    density: 1000.3,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02804",
    lat: 41.43546,
    lng: -71.77196,
    city: "Ashaway",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2005,
    density: 65.7,
    county_fips: 44009,
    county_name: "Washington",
    county_weights: {
      44009: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 44009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02806",
    lat: 41.7443,
    lng: -71.31453,
    city: "Barrington",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16106,
    density: 759.8,
    county_fips: 44001,
    county_name: "Bristol",
    county_weights: {
      44001: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 44001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02807",
    lat: 41.17762,
    lng: -71.57854,
    city: "Block Island",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 871,
    density: 37,
    county_fips: 44009,
    county_name: "Washington",
    county_weights: {
      44009: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 44009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02808",
    lat: 41.40606,
    lng: -71.74802,
    city: "Bradford",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2466,
    density: 125.5,
    county_fips: 44009,
    county_name: "Washington",
    county_weights: {
      44009: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 44009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02809",
    lat: 41.68266,
    lng: -71.26938,
    city: "Bristol",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22095,
    density: 871.5,
    county_fips: 44001,
    county_name: "Bristol",
    county_weights: {
      44001: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 44001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02812",
    lat: 41.47625,
    lng: -71.66094,
    city: "Carolina",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1300,
    density: 125.7,
    county_fips: 44009,
    county_name: "Washington",
    county_weights: {
      44009: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 44009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02813",
    lat: 41.3971,
    lng: -71.67003,
    city: "Charlestown",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7832,
    density: 82.4,
    county_fips: 44009,
    county_name: "Washington",
    county_weights: {
      44009: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 44009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02814",
    lat: 41.89959,
    lng: -71.69888,
    city: "Chepachet",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8033,
    density: 71.5,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02815",
    lat: 41.77723,
    lng: -71.66177,
    city: "Clayville",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 150,
    density: 21.3,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02816",
    lat: 41.69035,
    lng: -71.61954,
    city: "Coventry",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32683,
    density: 341.6,
    county_fips: 44003,
    county_name: "Kent",
    county_weights: {
      44003: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 44003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02817",
    lat: 41.6291,
    lng: -71.66711,
    city: "West Greenwich",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6297,
    density: 48.3,
    county_fips: 44003,
    county_name: "Kent",
    county_weights: {
      44003: 99.69,
      44009: 0.31,
    },
    county_names_all: "Kent|Washington",
    county_fips_all: "44003|44009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02818",
    lat: 41.64214,
    lng: -71.49307,
    city: "East Greenwich",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18790,
    density: 341.8,
    county_fips: 44003,
    county_name: "Kent",
    county_weights: {
      44003: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 44003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02822",
    lat: 41.56736,
    lng: -71.63348,
    city: "Exeter",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6018,
    density: 42.8,
    county_fips: 44009,
    county_name: "Washington",
    county_weights: {
      44009: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 44009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02823",
    lat: 41.73328,
    lng: -71.54479,
    city: "Fiskeville",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44003: 0.17,
      44007: 99.83,
    },
    county_names_all: "Providence|Kent",
    county_fips_all: "44007|44003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02824",
    lat: 41.99934,
    lng: -71.56322,
    city: "Forestdale",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02825",
    lat: 41.78212,
    lng: -71.72596,
    city: "Foster",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5964,
    density: 41.8,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02826",
    lat: 41.98248,
    lng: -71.64539,
    city: "Glendale",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 382,
    density: 60.6,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02827",
    lat: 41.69792,
    lng: -71.73847,
    city: "Greene",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2194,
    density: 39.5,
    county_fips: 44003,
    county_name: "Kent",
    county_weights: {
      44003: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 44003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02828",
    lat: 41.87672,
    lng: -71.56065,
    city: "Greenville",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7528,
    density: 668.8,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02829",
    lat: 41.89377,
    lng: -71.59129,
    city: "Harmony",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02830",
    lat: 41.98016,
    lng: -71.6484,
    city: "Harrisville",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5624,
    density: 106.4,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02831",
    lat: 41.74461,
    lng: -71.58442,
    city: "Hope",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3725,
    density: 133.8,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44003: 6.25,
      44007: 93.75,
    },
    county_names_all: "Providence|Kent",
    county_fips_all: "44007|44003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02832",
    lat: 41.50469,
    lng: -71.72807,
    city: "Hope Valley",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4713,
    density: 73.4,
    county_fips: 44009,
    county_name: "Washington",
    county_weights: {
      44009: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 44009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02833",
    lat: 41.48117,
    lng: -71.77787,
    city: "Hopkinton",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 932,
    density: 102.8,
    county_fips: 44009,
    county_name: "Washington",
    county_weights: {
      44009: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 44009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02835",
    lat: 41.51479,
    lng: -71.37742,
    city: "Jamestown",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5494,
    density: 226.4,
    county_fips: 44005,
    county_name: "Newport",
    county_weights: {
      44005: 100,
    },
    county_names_all: "Newport",
    county_fips_all: 44005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02836",
    lat: 41.45145,
    lng: -71.62027,
    city: "Kenyon",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 165,
    density: 226.1,
    county_fips: 44009,
    county_name: "Washington",
    county_weights: {
      44009: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 44009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02837",
    lat: 41.51524,
    lng: -71.16455,
    city: "Little Compton",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3496,
    density: 65.7,
    county_fips: 44005,
    county_name: "Newport",
    county_weights: {
      44005: 100,
    },
    county_names_all: "Newport",
    county_fips_all: 44005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02838",
    lat: 41.96552,
    lng: -71.47628,
    city: "Manville",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3521,
    density: 973.2,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02839",
    lat: 41.9433,
    lng: -71.64581,
    city: "Mapleville",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2100,
    density: 188.1,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02840",
    lat: 41.47838,
    lng: -71.31993,
    city: "Newport",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22976,
    density: 1218.9,
    county_fips: 44005,
    county_name: "Newport",
    county_weights: {
      44005: 100,
    },
    county_names_all: "Newport",
    county_fips_all: 44005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02841",
    lat: 41.51261,
    lng: -71.32522,
    city: "Newport",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1792,
    density: 2008.3,
    county_fips: 44005,
    county_name: "Newport",
    county_weights: {
      44005: 100,
    },
    county_names_all: "Newport",
    county_fips_all: 44005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02842",
    lat: 41.51739,
    lng: -71.27667,
    city: "Middletown",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15931,
    density: 490.6,
    county_fips: 44005,
    county_name: "Newport",
    county_weights: {
      44005: 100,
    },
    county_names_all: "Newport",
    county_fips_all: 44005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02852",
    lat: 41.58809,
    lng: -71.46094,
    city: "North Kingstown",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21653,
    density: 271.2,
    county_fips: 44009,
    county_name: "Washington",
    county_weights: {
      44009: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 44009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02857",
    lat: 41.82705,
    lng: -71.63083,
    city: "North Scituate",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7969,
    density: 71.3,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02858",
    lat: 41.96354,
    lng: -71.64893,
    city: "Oakland",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 613,
    density: 382.8,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02859",
    lat: 41.9665,
    lng: -71.7464,
    city: "Pascoag",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7992,
    density: 111.7,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02860",
    lat: 41.87036,
    lng: -71.38855,
    city: "Pawtucket",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47175,
    density: 3412.5,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02861",
    lat: 41.87863,
    lng: -71.35228,
    city: "Pawtucket",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24764,
    density: 2677,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      25005: 0.55,
      44007: 99.45,
    },
    county_names_all: "Providence|Bristol",
    county_fips_all: "44007|25005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02863",
    lat: 41.89005,
    lng: -71.39336,
    city: "Central Falls",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19437,
    density: 6285.9,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02864",
    lat: 41.97025,
    lng: -71.41978,
    city: "Cumberland",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34936,
    density: 509.6,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02865",
    lat: 41.91251,
    lng: -71.44822,
    city: "Lincoln",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17876,
    density: 419,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02871",
    lat: 41.58384,
    lng: -71.2564,
    city: "Portsmouth",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17108,
    density: 387,
    county_fips: 44005,
    county_name: "Newport",
    county_weights: {
      44005: 100,
    },
    county_names_all: "Newport",
    county_fips_all: 44005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02872",
    lat: 41.61718,
    lng: -71.32886,
    city: "Prudence Island",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 204,
    density: 13.2,
    county_fips: 44005,
    county_name: "Newport",
    county_weights: {
      44005: 100,
    },
    county_names_all: "Newport",
    county_fips_all: 44005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02873",
    lat: 41.5257,
    lng: -71.77734,
    city: "Rockville",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 130,
    density: 13.4,
    county_fips: 44009,
    county_name: "Washington",
    county_weights: {
      44009: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 44009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02874",
    lat: 41.51543,
    lng: -71.46985,
    city: "Saunderstown",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6620,
    density: 164.2,
    county_fips: 44009,
    county_name: "Washington",
    county_weights: {
      44009: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 44009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02875",
    lat: 41.46052,
    lng: -71.63848,
    city: "Shannock",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 439,
    density: 95.4,
    county_fips: 44009,
    county_name: "Washington",
    county_weights: {
      44009: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 44009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02876",
    lat: 41.99801,
    lng: -71.58301,
    city: "Slatersville",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 577,
    density: 1118.3,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02878",
    lat: 41.60905,
    lng: -71.17413,
    city: "Tiverton",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15730,
    density: 209,
    county_fips: 44005,
    county_name: "Newport",
    county_weights: {
      44005: 100,
    },
    county_names_all: "Newport",
    county_fips_all: 44005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02879",
    lat: 41.42865,
    lng: -71.53837,
    city: "Wakefield",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20851,
    density: 203.8,
    county_fips: 44009,
    county_name: "Washington",
    county_weights: {
      44009: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 44009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02881",
    lat: 41.4825,
    lng: -71.52694,
    city: "Kingston",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7593,
    density: 870.4,
    county_fips: 44009,
    county_name: "Washington",
    county_weights: {
      44009: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 44009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02882",
    lat: 41.4253,
    lng: -71.46816,
    city: "Narragansett",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14204,
    density: 427.1,
    county_fips: 44009,
    county_name: "Washington",
    county_weights: {
      44009: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 44009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02885",
    lat: 41.72821,
    lng: -71.26287,
    city: "Warren",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10451,
    density: 655.2,
    county_fips: 44001,
    county_name: "Bristol",
    county_weights: {
      44001: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 44001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02886",
    lat: 41.70493,
    lng: -71.45892,
    city: "Warwick",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29443,
    density: 719.7,
    county_fips: 44003,
    county_name: "Kent",
    county_weights: {
      44003: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 44003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02888",
    lat: 41.74909,
    lng: -71.41123,
    city: "Warwick",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17901,
    density: 1172.1,
    county_fips: 44003,
    county_name: "Kent",
    county_weights: {
      44003: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 44003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02889",
    lat: 41.70602,
    lng: -71.39106,
    city: "Warwick",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27531,
    density: 1257.1,
    county_fips: 44003,
    county_name: "Kent",
    county_weights: {
      44003: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 44003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02891",
    lat: 41.36043,
    lng: -71.79429,
    city: "Westerly",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21196,
    density: 311.4,
    county_fips: 44009,
    county_name: "Washington",
    county_weights: {
      44009: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 44009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02892",
    lat: 41.50226,
    lng: -71.60174,
    city: "West Kingston",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5502,
    density: 78.1,
    county_fips: 44009,
    county_name: "Washington",
    county_weights: {
      44009: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 44009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02893",
    lat: 41.69856,
    lng: -71.51566,
    city: "West Warwick",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29283,
    density: 1443.5,
    county_fips: 44003,
    county_name: "Kent",
    county_weights: {
      44003: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 44003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02894",
    lat: 41.44761,
    lng: -71.69759,
    city: "Wood River Junction",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 512,
    density: 47,
    county_fips: 44009,
    county_name: "Washington",
    county_weights: {
      44009: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 44009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02895",
    lat: 42.00103,
    lng: -71.49923,
    city: "Woonsocket",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41616,
    density: 2069.6,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02896",
    lat: 41.97285,
    lng: -71.55027,
    city: "North Smithfield",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11901,
    density: 199.6,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02898",
    lat: 41.52184,
    lng: -71.67166,
    city: "Wyoming",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1137,
    density: 36.9,
    county_fips: 44009,
    county_name: "Washington",
    county_weights: {
      44009: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 44009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02903",
    lat: 41.81902,
    lng: -71.41003,
    city: "Providence",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11443,
    density: 2632.9,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02904",
    lat: 41.86058,
    lng: -71.43539,
    city: "Providence",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29881,
    density: 2228.8,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02905",
    lat: 41.78769,
    lng: -71.39886,
    city: "Providence",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26020,
    density: 2683,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02906",
    lat: 41.83964,
    lng: -71.38963,
    city: "Providence",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28254,
    density: 3519.9,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02907",
    lat: 41.79867,
    lng: -71.42581,
    city: "Providence",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31277,
    density: 5470,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02908",
    lat: 41.83877,
    lng: -71.43926,
    city: "Providence",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37792,
    density: 4289,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02909",
    lat: 41.81825,
    lng: -71.45078,
    city: "Providence",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40286,
    density: 4969.1,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02910",
    lat: 41.77552,
    lng: -71.43564,
    city: "Cranston",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21746,
    density: 2445.6,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02911",
    lat: 41.85467,
    lng: -71.47325,
    city: "North Providence",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15627,
    density: 2413.8,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02912",
    lat: 41.82783,
    lng: -71.39959,
    city: "Providence",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1279,
    density: 2494.4,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02914",
    lat: 41.81326,
    lng: -71.36608,
    city: "East Providence",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21720,
    density: 1709,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02915",
    lat: 41.77725,
    lng: -71.34906,
    city: "Riverside",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16423,
    density: 1150.4,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02916",
    lat: 41.84438,
    lng: -71.35258,
    city: "Rumford",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9292,
    density: 1352.2,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02917",
    lat: 41.90615,
    lng: -71.52365,
    city: "Smithfield",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14260,
    density: 256.8,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02918",
    lat: 41.84386,
    lng: -71.43499,
    city: "Providence",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02919",
    lat: 41.82733,
    lng: -71.52002,
    city: "Johnston",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29312,
    density: 481.4,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02920",
    lat: 41.76719,
    lng: -71.4655,
    city: "Cranston",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36695,
    density: 1583.4,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "02921",
    lat: 41.76292,
    lng: -71.51571,
    city: "Cranston",
    state_id: "RI",
    state_name: "Rhode Island",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12463,
    density: 369.5,
    county_fips: 44007,
    county_name: "Providence",
    county_weights: {
      44007: 100,
    },
    county_names_all: "Providence",
    county_fips_all: 44007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03031",
    lat: 42.87056,
    lng: -71.60683,
    city: "Amherst",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11484,
    density: 130.7,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03032",
    lat: 42.99063,
    lng: -71.34383,
    city: "Auburn",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5514,
    density: 84,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03033",
    lat: 42.74643,
    lng: -71.67054,
    city: "Brookline",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5394,
    density: 105,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03034",
    lat: 43.06269,
    lng: -71.31106,
    city: "Candia",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4088,
    density: 48.6,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03036",
    lat: 42.96719,
    lng: -71.25083,
    city: "Chester",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5191,
    density: 77,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03037",
    lat: 43.1395,
    lng: -71.2535,
    city: "Deerfield",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4363,
    density: 34.6,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03038",
    lat: 42.88867,
    lng: -71.27932,
    city: "Derry",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33705,
    density: 363,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03042",
    lat: 43.05009,
    lng: -71.07467,
    city: "Epping",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6989,
    density: 103.6,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03043",
    lat: 42.99581,
    lng: -71.81514,
    city: "Francestown",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1574,
    density: 20.4,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03044",
    lat: 42.98899,
    lng: -71.12494,
    city: "Fremont",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4695,
    density: 105.6,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03045",
    lat: 43.01994,
    lng: -71.57035,
    city: "Goffstown",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13766,
    density: 148,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03046",
    lat: 43.10178,
    lng: -71.60548,
    city: "Dunbarton",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2846,
    density: 35.6,
    county_fips: 33013,
    county_name: "Merrimack",
    county_weights: {
      33013: 100,
    },
    county_names_all: "Merrimack",
    county_fips_all: 33013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03047",
    lat: 42.94029,
    lng: -71.87053,
    city: "Greenfield",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1828,
    density: 26.8,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03048",
    lat: 42.74668,
    lng: -71.76268,
    city: "Greenville",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3564,
    density: 48.6,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03049",
    lat: 42.7494,
    lng: -71.58338,
    city: "Hollis",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7973,
    density: 97,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03051",
    lat: 42.76394,
    lng: -71.40716,
    city: "Hudson",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25543,
    density: 348.7,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03052",
    lat: 42.84302,
    lng: -71.455,
    city: "Litchfield",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8560,
    density: 221.5,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03053",
    lat: 42.87927,
    lng: -71.38702,
    city: "Londonderry",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26028,
    density: 241.2,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03054",
    lat: 42.85471,
    lng: -71.51878,
    city: "Merrimack",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26314,
    density: 311.9,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03055",
    lat: 42.81783,
    lng: -71.67361,
    city: "Milford",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15906,
    density: 241.7,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03057",
    lat: 42.90265,
    lng: -71.6861,
    city: "Mont Vernon",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2662,
    density: 57.4,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03060",
    lat: 42.74135,
    lng: -71.45936,
    city: "Nashua",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30092,
    density: 1771.4,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03062",
    lat: 42.72212,
    lng: -71.49556,
    city: "Nashua",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28550,
    density: 916.4,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03063",
    lat: 42.7795,
    lng: -71.51939,
    city: "Nashua",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16126,
    density: 767.7,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03064",
    lat: 42.77886,
    lng: -71.47466,
    city: "Nashua",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14284,
    density: 1333.9,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03070",
    lat: 42.97702,
    lng: -71.68664,
    city: "New Boston",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5781,
    density: 51.8,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03071",
    lat: 42.74892,
    lng: -71.8747,
    city: "New Ipswich",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5373,
    density: 63.4,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03076",
    lat: 42.73354,
    lng: -71.324,
    city: "Pelham",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13991,
    density: 205.1,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03077",
    lat: 43.03219,
    lng: -71.19945,
    city: "Raymond",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10407,
    density: 139.4,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03079",
    lat: 42.79023,
    lng: -71.22024,
    city: "Salem",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29633,
    density: 460.5,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03082",
    lat: 42.90197,
    lng: -71.77545,
    city: "Lyndeborough",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1706,
    density: 22.8,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03084",
    lat: 42.82856,
    lng: -71.85495,
    city: "Temple",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1250,
    density: 21.7,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03086",
    lat: 42.82741,
    lng: -71.76967,
    city: "Wilton",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3915,
    density: 53.8,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03087",
    lat: 42.80758,
    lng: -71.29945,
    city: "Windham",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14694,
    density: 212.1,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03101",
    lat: 42.98881,
    lng: -71.4659,
    city: "Manchester",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2834,
    density: 1429.8,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03102",
    lat: 43.00797,
    lng: -71.49134,
    city: "Manchester",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33951,
    density: 1446,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03103",
    lat: 42.95536,
    lng: -71.44463,
    city: "Manchester",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36831,
    density: 1547.9,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 97.28,
      33015: 2.72,
    },
    county_names_all: "Hillsborough|Rockingham",
    county_fips_all: "33011|33015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03104",
    lat: 43.00926,
    lng: -71.4411,
    city: "Manchester",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32776,
    density: 1518.3,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 99.58,
      33013: 0.42,
    },
    county_names_all: "Hillsborough|Merrimack",
    county_fips_all: "33011|33013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03106",
    lat: 43.07097,
    lng: -71.43651,
    city: "Hooksett",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14375,
    density: 154.1,
    county_fips: 33013,
    county_name: "Merrimack",
    county_weights: {
      33013: 100,
    },
    county_names_all: "Merrimack",
    county_fips_all: 33013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03109",
    lat: 42.96594,
    lng: -71.40167,
    city: "Manchester",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10409,
    density: 554.6,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03110",
    lat: 42.94065,
    lng: -71.53023,
    city: "Bedford",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22710,
    density: 267.5,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03215",
    lat: 44.03605,
    lng: -71.48109,
    city: "Waterville Valley",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 230,
    density: 0.5,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03216",
    lat: 43.44656,
    lng: -71.79374,
    city: "Andover",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2494,
    density: 24.1,
    county_fips: 33013,
    county_name: "Merrimack",
    county_weights: {
      33013: 100,
    },
    county_names_all: "Merrimack",
    county_fips_all: 33013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03217",
    lat: 43.71492,
    lng: -71.63033,
    city: "Ashland",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2237,
    density: 76.9,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03218",
    lat: 43.33465,
    lng: -71.28803,
    city: "Barnstead",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1070,
    density: 27,
    county_fips: 33001,
    county_name: "Belknap",
    county_weights: {
      33001: 100,
    },
    county_names_all: "Belknap",
    county_fips_all: 33001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03220",
    lat: 43.46793,
    lng: -71.4758,
    city: "Belmont",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7566,
    density: 96.5,
    county_fips: 33001,
    county_name: "Belknap",
    county_weights: {
      33001: 98.91,
      33013: 1.09,
    },
    county_names_all: "Belknap|Merrimack",
    county_fips_all: "33001|33013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03221",
    lat: 43.25482,
    lng: -71.96122,
    city: "Bradford",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1922,
    density: 15.2,
    county_fips: 33013,
    county_name: "Merrimack",
    county_weights: {
      33013: 100,
    },
    county_names_all: "Merrimack",
    county_fips_all: 33013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03222",
    lat: 43.62895,
    lng: -71.78234,
    city: "Bristol",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5895,
    density: 31.9,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03223",
    lat: 43.84784,
    lng: -71.67597,
    city: "Campton",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3382,
    density: 18.7,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03224",
    lat: 43.35171,
    lng: -71.54691,
    city: "Canterbury",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2402,
    density: 21.7,
    county_fips: 33013,
    county_name: "Merrimack",
    county_weights: {
      33013: 100,
    },
    county_names_all: "Merrimack",
    county_fips_all: 33013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03225",
    lat: 43.36001,
    lng: -71.23828,
    city: "Center Barnstead",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3573,
    density: 49.7,
    county_fips: 33001,
    county_name: "Belknap",
    county_weights: {
      33001: 100,
    },
    county_names_all: "Belknap",
    county_fips_all: 33001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03226",
    lat: 43.70259,
    lng: -71.51086,
    city: "Center Harbor",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 881,
    density: 24.8,
    county_fips: 33001,
    county_name: "Belknap",
    county_weights: {
      33001: 100,
    },
    county_names_all: "Belknap",
    county_fips_all: 33001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03227",
    lat: 43.81419,
    lng: -71.45712,
    city: "Center Sandwich",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1126,
    density: 8.5,
    county_fips: 33003,
    county_name: "Carroll",
    county_weights: {
      33003: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 33003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03229",
    lat: 43.19792,
    lng: -71.69677,
    city: "Contoocook",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5746,
    density: 51.2,
    county_fips: 33013,
    county_name: "Merrimack",
    county_weights: {
      33013: 100,
    },
    county_names_all: "Merrimack",
    county_fips_all: 33013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03230",
    lat: 43.52685,
    lng: -71.8622,
    city: "Danbury",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1445,
    density: 13.9,
    county_fips: 33013,
    county_name: "Merrimack",
    county_weights: {
      33013: 100,
    },
    county_names_all: "Merrimack",
    county_fips_all: 33013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03231",
    lat: 43.45555,
    lng: -71.75551,
    city: "East Andover",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 226,
    density: 304.9,
    county_fips: 33013,
    county_name: "Merrimack",
    county_weights: {
      33013: 100,
    },
    county_names_all: "Merrimack",
    county_fips_all: 33013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03233",
    lat: 43.42325,
    lng: -71.93322,
    city: "Elkins",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 334,
    density: 290.3,
    county_fips: 33013,
    county_name: "Merrimack",
    county_weights: {
      33013: 100,
    },
    county_names_all: "Merrimack",
    county_fips_all: 33013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03234",
    lat: 43.21484,
    lng: -71.33914,
    city: "Epsom",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4767,
    density: 53.5,
    county_fips: 33013,
    county_name: "Merrimack",
    county_weights: {
      33013: 100,
    },
    county_names_all: "Merrimack",
    county_fips_all: 33013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03235",
    lat: 43.44831,
    lng: -71.67208,
    city: "Franklin",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8793,
    density: 113.8,
    county_fips: 33013,
    county_name: "Merrimack",
    county_weights: {
      33013: 100,
    },
    county_names_all: "Merrimack",
    county_fips_all: 33013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03237",
    lat: 43.42997,
    lng: -71.38233,
    city: "Gilmanton",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2082,
    density: 21.2,
    county_fips: 33001,
    county_name: "Belknap",
    county_weights: {
      33001: 100,
    },
    county_names_all: "Belknap",
    county_fips_all: 33001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03238",
    lat: 43.98168,
    lng: -71.88701,
    city: "Glencliff",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 95,
    density: 36.6,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03240",
    lat: 43.57599,
    lng: -71.97221,
    city: "Grafton",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1293,
    density: 12,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03241",
    lat: 43.71149,
    lng: -71.81915,
    city: "Hebron",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 908,
    density: 9.5,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03242",
    lat: 43.17365,
    lng: -71.8224,
    city: "Henniker",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4966,
    density: 43.5,
    county_fips: 33013,
    county_name: "Merrimack",
    county_weights: {
      33013: 100,
    },
    county_names_all: "Merrimack",
    county_fips_all: 33013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03243",
    lat: 43.5276,
    lng: -71.7644,
    city: "Hill",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 809,
    density: 12.2,
    county_fips: 33013,
    county_name: "Merrimack",
    county_weights: {
      33009: 6.17,
      33013: 93.83,
    },
    county_names_all: "Merrimack|Grafton",
    county_fips_all: "33013|33009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03244",
    lat: 43.11822,
    lng: -71.9192,
    city: "Hillsborough",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7589,
    density: 35.5,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 99.37,
      33019: 0.63,
    },
    county_names_all: "Hillsborough|Sullivan",
    county_fips_all: "33011|33019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03245",
    lat: 43.75026,
    lng: -71.58852,
    city: "Holderness",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2093,
    density: 26.5,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03246",
    lat: 43.57239,
    lng: -71.4775,
    city: "Laconia",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16573,
    density: 322,
    county_fips: 33001,
    county_name: "Belknap",
    county_weights: {
      33001: 100,
    },
    county_names_all: "Belknap",
    county_fips_all: 33001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03249",
    lat: 43.55806,
    lng: -71.38505,
    city: "Gilford",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7213,
    density: 71.8,
    county_fips: 33001,
    county_name: "Belknap",
    county_weights: {
      33001: 100,
    },
    county_names_all: "Belknap",
    county_fips_all: 33001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03251",
    lat: 44.0796,
    lng: -71.65276,
    city: "Lincoln",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1270,
    density: 7.4,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03253",
    lat: 43.63193,
    lng: -71.49749,
    city: "Meredith",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6410,
    density: 66.1,
    county_fips: 33001,
    county_name: "Belknap",
    county_weights: {
      33001: 100,
    },
    county_names_all: "Belknap",
    county_fips_all: 33001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03254",
    lat: 43.72505,
    lng: -71.37782,
    city: "Moultonborough",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4149,
    density: 26.6,
    county_fips: 33003,
    county_name: "Carroll",
    county_weights: {
      33003: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 33003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03255",
    lat: 43.3149,
    lng: -72.02795,
    city: "Newbury",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1852,
    density: 20,
    county_fips: 33013,
    county_name: "Merrimack",
    county_weights: {
      33013: 100,
    },
    county_names_all: "Merrimack",
    county_fips_all: 33013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03256",
    lat: 43.62425,
    lng: -71.63514,
    city: "New Hampton",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2450,
    density: 25.7,
    county_fips: 33001,
    county_name: "Belknap",
    county_weights: {
      33001: 100,
    },
    county_names_all: "Belknap",
    county_fips_all: 33001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03257",
    lat: 43.41768,
    lng: -71.99101,
    city: "New London",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4179,
    density: 68.5,
    county_fips: 33013,
    county_name: "Merrimack",
    county_weights: {
      33013: 97.1,
      33019: 2.9,
    },
    county_names_all: "Merrimack|Sullivan",
    county_fips_all: "33013|33019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03258",
    lat: 43.25744,
    lng: -71.39956,
    city: "Chichester",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2689,
    density: 49,
    county_fips: 33013,
    county_name: "Merrimack",
    county_weights: {
      33013: 100,
    },
    county_names_all: "Merrimack",
    county_fips_all: 33013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03259",
    lat: 43.87921,
    lng: -71.44527,
    city: "North Sandwich",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 407,
    density: 4.7,
    county_fips: 33003,
    county_name: "Carroll",
    county_weights: {
      33003: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 33003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03260",
    lat: 43.36016,
    lng: -71.92457,
    city: "North Sutton",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1012,
    density: 18.2,
    county_fips: 33013,
    county_name: "Merrimack",
    county_weights: {
      33013: 100,
    },
    county_names_all: "Merrimack",
    county_fips_all: 33013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03261",
    lat: 43.21322,
    lng: -71.20966,
    city: "Northwood",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4337,
    density: 59.4,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03262",
    lat: 43.99885,
    lng: -71.73813,
    city: "North Woodstock",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1170,
    density: 7.9,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03263",
    lat: 43.29483,
    lng: -71.31133,
    city: "Pittsfield",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4114,
    density: 64.9,
    county_fips: 33013,
    county_name: "Merrimack",
    county_weights: {
      33013: 100,
    },
    county_names_all: "Merrimack",
    county_fips_all: 33013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03264",
    lat: 43.72967,
    lng: -71.71159,
    city: "Plymouth",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7249,
    density: 76.6,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03266",
    lat: 43.79407,
    lng: -71.89035,
    city: "Rumney",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2023,
    density: 7.1,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03268",
    lat: 43.38505,
    lng: -71.7574,
    city: "Salisbury",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1452,
    density: 18.2,
    county_fips: 33013,
    county_name: "Merrimack",
    county_weights: {
      33013: 100,
    },
    county_names_all: "Merrimack",
    county_fips_all: 33013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03269",
    lat: 43.53,
    lng: -71.60219,
    city: "Sanbornton",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2920,
    density: 22.8,
    county_fips: 33001,
    county_name: "Belknap",
    county_weights: {
      33001: 100,
    },
    county_names_all: "Belknap",
    county_fips_all: 33001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03273",
    lat: 43.30337,
    lng: -71.92413,
    city: "South Sutton",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 357,
    density: 29.8,
    county_fips: 33013,
    county_name: "Merrimack",
    county_weights: {
      33013: 100,
    },
    county_names_all: "Merrimack",
    county_fips_all: 33013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03275",
    lat: 43.15999,
    lng: -71.41794,
    city: "Suncook",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11652,
    density: 104.5,
    county_fips: 33013,
    county_name: "Merrimack",
    county_weights: {
      33013: 100,
    },
    county_names_all: "Merrimack",
    county_fips_all: 33013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03276",
    lat: 43.42783,
    lng: -71.57514,
    city: "Tilton",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8289,
    density: 81.4,
    county_fips: 33013,
    county_name: "Merrimack",
    county_weights: {
      33001: 29.61,
      33013: 70.39,
    },
    county_names_all: "Merrimack|Belknap",
    county_fips_all: "33013|33001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03278",
    lat: 43.29313,
    lng: -71.82934,
    city: "Warner",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2978,
    density: 18.1,
    county_fips: 33013,
    county_name: "Merrimack",
    county_weights: {
      33013: 100,
    },
    county_names_all: "Merrimack",
    county_fips_all: 33013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03279",
    lat: 43.94468,
    lng: -71.88231,
    city: "Warren",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 639,
    density: 5.2,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03280",
    lat: 43.18339,
    lng: -72.08979,
    city: "Washington",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1057,
    density: 9,
    county_fips: 33019,
    county_name: "Sullivan",
    county_weights: {
      33019: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 33019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03281",
    lat: 43.08126,
    lng: -71.72189,
    city: "Weare",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9058,
    density: 59.2,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03282",
    lat: 43.86006,
    lng: -71.9295,
    city: "Wentworth",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1089,
    density: 10.1,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03284",
    lat: 43.49361,
    lng: -72.03057,
    city: "Springfield",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 996,
    density: 10,
    county_fips: 33019,
    county_name: "Sullivan",
    county_weights: {
      33019: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 33019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03285",
    lat: 43.92408,
    lng: -71.64359,
    city: "Thornton",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2516,
    density: 19.4,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03287",
    lat: 43.45168,
    lng: -71.91795,
    city: "Wilmot",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1444,
    density: 19,
    county_fips: 33013,
    county_name: "Merrimack",
    county_weights: {
      33013: 100,
    },
    county_names_all: "Merrimack",
    county_fips_all: 33013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03290",
    lat: 43.12391,
    lng: -71.12089,
    city: "Nottingham",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5036,
    density: 42,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03291",
    lat: 43.17976,
    lng: -71.14205,
    city: "West Nottingham",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 92,
    density: 161.3,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03293",
    lat: 43.97696,
    lng: -71.67721,
    city: "Woodstock",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 156,
    density: 41.6,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03301",
    lat: 43.22423,
    lng: -71.54342,
    city: "Concord",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33550,
    density: 263.1,
    county_fips: 33013,
    county_name: "Merrimack",
    county_weights: {
      33013: 100,
    },
    county_names_all: "Merrimack",
    county_fips_all: 33013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03303",
    lat: 43.29819,
    lng: -71.67186,
    city: "Concord",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15984,
    density: 91,
    county_fips: 33013,
    county_name: "Merrimack",
    county_weights: {
      33013: 100,
    },
    county_names_all: "Merrimack",
    county_fips_all: 33013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03304",
    lat: 43.13078,
    lng: -71.53066,
    city: "Bow",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7958,
    density: 109.1,
    county_fips: 33013,
    county_name: "Merrimack",
    county_weights: {
      33013: 100,
    },
    county_names_all: "Merrimack",
    county_fips_all: 33013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03307",
    lat: 43.32257,
    lng: -71.44265,
    city: "Loudon",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5591,
    density: 46,
    county_fips: 33013,
    county_name: "Merrimack",
    county_weights: {
      33013: 100,
    },
    county_names_all: "Merrimack",
    county_fips_all: 33013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03431",
    lat: 42.96785,
    lng: -72.29862,
    city: "Keene",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24849,
    density: 160,
    county_fips: 33005,
    county_name: "Cheshire",
    county_weights: {
      33005: 100,
    },
    county_names_all: "Cheshire",
    county_fips_all: 33005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03440",
    lat: 43.06023,
    lng: -71.97446,
    city: "Antrim",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3036,
    density: 37.5,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03441",
    lat: 42.77737,
    lng: -72.44263,
    city: "Ashuelot",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 163,
    density: 14.6,
    county_fips: 33005,
    county_name: "Cheshire",
    county_weights: {
      33005: 100,
    },
    county_names_all: "Cheshire",
    county_fips_all: 33005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03442",
    lat: 43.01268,
    lng: -71.90781,
    city: "Bennington",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1684,
    density: 57,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03443",
    lat: 42.8767,
    lng: -72.46148,
    city: "Chesterfield",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 235,
    density: 8.4,
    county_fips: 33005,
    county_name: "Cheshire",
    county_weights: {
      33005: 100,
    },
    county_names_all: "Cheshire",
    county_fips_all: 33005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03444",
    lat: 42.89403,
    lng: -72.07178,
    city: "Dublin",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1553,
    density: 21.7,
    county_fips: 33005,
    county_name: "Cheshire",
    county_weights: {
      33005: 100,
    },
    county_names_all: "Cheshire",
    county_fips_all: 33005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03445",
    lat: 43.01555,
    lng: -72.2137,
    city: "Sullivan",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 700,
    density: 13.9,
    county_fips: 33005,
    county_name: "Cheshire",
    county_weights: {
      33005: 100,
    },
    county_names_all: "Cheshire",
    county_fips_all: 33005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03446",
    lat: 42.86163,
    lng: -72.29639,
    city: "Swanzey",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6375,
    density: 55.5,
    county_fips: 33005,
    county_name: "Cheshire",
    county_weights: {
      33005: 100,
    },
    county_names_all: "Cheshire",
    county_fips_all: 33005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03447",
    lat: 42.7592,
    lng: -72.14794,
    city: "Fitzwilliam",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2324,
    density: 25.9,
    county_fips: 33005,
    county_name: "Cheshire",
    county_weights: {
      33005: 100,
    },
    county_names_all: "Cheshire",
    county_fips_all: 33005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03448",
    lat: 43.03996,
    lng: -72.26448,
    city: "Gilsum",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 749,
    density: 17.4,
    county_fips: 33005,
    county_name: "Cheshire",
    county_weights: {
      33005: 100,
    },
    county_names_all: "Cheshire",
    county_fips_all: 33005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03449",
    lat: 42.98222,
    lng: -72.00037,
    city: "Hancock",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1715,
    density: 18.9,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03450",
    lat: 42.94157,
    lng: -72.09107,
    city: "Harrisville",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 882,
    density: 18.4,
    county_fips: 33005,
    county_name: "Cheshire",
    county_weights: {
      33005: 100,
    },
    county_names_all: "Cheshire",
    county_fips_all: 33005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03451",
    lat: 42.80907,
    lng: -72.50029,
    city: "Hinsdale",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3905,
    density: 73.5,
    county_fips: 33005,
    county_name: "Cheshire",
    county_weights: {
      33005: 100,
    },
    county_names_all: "Cheshire",
    county_fips_all: 33005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03452",
    lat: 42.82922,
    lng: -72.05962,
    city: "Jaffrey",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5275,
    density: 53,
    county_fips: 33005,
    county_name: "Cheshire",
    county_weights: {
      33005: 100,
    },
    county_names_all: "Cheshire",
    county_fips_all: 33005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03455",
    lat: 42.89816,
    lng: -72.18308,
    city: "Marlborough",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2524,
    density: 41,
    county_fips: 33005,
    county_name: "Cheshire",
    county_weights: {
      33005: 100,
    },
    county_names_all: "Cheshire",
    county_fips_all: 33005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03456",
    lat: 43.13092,
    lng: -72.21505,
    city: "Marlow",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 788,
    density: 11.7,
    county_fips: 33005,
    county_name: "Cheshire",
    county_weights: {
      33005: 100,
    },
    county_names_all: "Cheshire",
    county_fips_all: 33005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03457",
    lat: 43.00282,
    lng: -72.12933,
    city: "Nelson",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 709,
    density: 9.3,
    county_fips: 33005,
    county_name: "Cheshire",
    county_weights: {
      33005: 100,
    },
    county_names_all: "Cheshire",
    county_fips_all: 33005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03458",
    lat: 42.86906,
    lng: -71.93797,
    city: "Peterborough",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7111,
    density: 51.1,
    county_fips: 33011,
    county_name: "Hillsborough",
    county_weights: {
      33011: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 33011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03461",
    lat: 42.75234,
    lng: -72.01071,
    city: "Rindge",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6100,
    density: 63.5,
    county_fips: 33005,
    county_name: "Cheshire",
    county_weights: {
      33005: 100,
    },
    county_names_all: "Cheshire",
    county_fips_all: 33005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03462",
    lat: 42.8949,
    lng: -72.40507,
    city: "Spofford",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1388,
    density: 27.7,
    county_fips: 33005,
    county_name: "Cheshire",
    county_weights: {
      33005: 100,
    },
    county_names_all: "Cheshire",
    county_fips_all: 33005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03464",
    lat: 43.08256,
    lng: -72.11085,
    city: "Stoddard",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 977,
    density: 8.4,
    county_fips: 33005,
    county_name: "Cheshire",
    county_weights: {
      33005: 99.77,
      33019: 0.23,
    },
    county_names_all: "Cheshire|Sullivan",
    county_fips_all: "33005|33019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03465",
    lat: 42.82677,
    lng: -72.18988,
    city: "Troy",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1734,
    density: 38.3,
    county_fips: 33005,
    county_name: "Cheshire",
    county_weights: {
      33005: 100,
    },
    county_names_all: "Cheshire",
    county_fips_all: 33005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03466",
    lat: 42.89525,
    lng: -72.50964,
    city: "West Chesterfield",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2002,
    density: 50,
    county_fips: 33005,
    county_name: "Cheshire",
    county_weights: {
      33005: 100,
    },
    county_names_all: "Cheshire",
    county_fips_all: 33005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03467",
    lat: 42.96894,
    lng: -72.43203,
    city: "Westmoreland",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2023,
    density: 21.8,
    county_fips: 33005,
    county_name: "Cheshire",
    county_weights: {
      33005: 100,
    },
    county_names_all: "Cheshire",
    county_fips_all: 33005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03470",
    lat: 42.77869,
    lng: -72.34413,
    city: "Winchester",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5138,
    density: 22.5,
    county_fips: 33005,
    county_name: "Cheshire",
    county_weights: {
      33005: 100,
    },
    county_names_all: "Cheshire",
    county_fips_all: 33005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03561",
    lat: 44.33222,
    lng: -71.80973,
    city: "Littleton",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5920,
    density: 45.8,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03570",
    lat: 44.49953,
    lng: -71.20396,
    city: "Berlin",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10025,
    density: 28.2,
    county_fips: 33007,
    county_name: "Coos",
    county_weights: {
      33007: 100,
    },
    county_names_all: "Coos",
    county_fips_all: 33007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03574",
    lat: 44.25386,
    lng: -71.59924,
    city: "Bethlehem",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2591,
    density: 11,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33007: 0.49,
      33009: 99.51,
    },
    county_names_all: "Grafton|Coos",
    county_fips_all: "33009|33007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03575",
    lat: 44.28946,
    lng: -71.41722,
    city: "Bretton Woods",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52,
    density: 0.6,
    county_fips: 33007,
    county_name: "Coos",
    county_weights: {
      33007: 100,
    },
    county_names_all: "Coos",
    county_fips_all: 33007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03576",
    lat: 44.89839,
    lng: -71.37178,
    city: "Colebrook",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2718,
    density: 6.2,
    county_fips: 33007,
    county_name: "Coos",
    county_weights: {
      33007: 100,
    },
    county_names_all: "Coos",
    county_fips_all: 33007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03579",
    lat: 44.95234,
    lng: -71.04182,
    city: "Errol",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 341,
    density: 0.2,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 58.53,
      33007: 41.47,
    },
    county_names_all: "Oxford|Coos",
    county_fips_all: "23017|33007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03580",
    lat: 44.17347,
    lng: -71.69519,
    city: "Franconia",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1419,
    density: 6.2,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03581",
    lat: 44.34227,
    lng: -71.13413,
    city: "Gorham",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3190,
    density: 7.9,
    county_fips: 33007,
    county_name: "Coos",
    county_weights: {
      33007: 100,
    },
    county_names_all: "Coos",
    county_fips_all: 33007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03582",
    lat: 44.59777,
    lng: -71.43703,
    city: "Groveton",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2077,
    density: 9.7,
    county_fips: 33007,
    county_name: "Coos",
    county_weights: {
      33007: 100,
    },
    county_names_all: "Coos",
    county_fips_all: 33007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03583",
    lat: 44.40148,
    lng: -71.4583,
    city: "Jefferson",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 942,
    density: 6.5,
    county_fips: 33007,
    county_name: "Coos",
    county_weights: {
      33007: 100,
    },
    county_names_all: "Coos",
    county_fips_all: 33007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03584",
    lat: 44.48696,
    lng: -71.54278,
    city: "Lancaster",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3570,
    density: 22.2,
    county_fips: 33007,
    county_name: "Coos",
    county_weights: {
      33007: 100,
    },
    county_names_all: "Coos",
    county_fips_all: 33007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03585",
    lat: 44.22538,
    lng: -71.89703,
    city: "Lisbon",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2556,
    density: 12.6,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03586",
    lat: 44.22058,
    lng: -71.7963,
    city: "Sugar Hill",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 605,
    density: 14,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03588",
    lat: 44.60545,
    lng: -71.23204,
    city: "Milan",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1535,
    density: 5.3,
    county_fips: 33007,
    county_name: "Coos",
    county_weights: {
      33007: 100,
    },
    county_names_all: "Coos",
    county_fips_all: 33007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03590",
    lat: 44.74195,
    lng: -71.51485,
    city: "North Stratford",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1173,
    density: 4.1,
    county_fips: 33007,
    county_name: "Coos",
    county_weights: {
      33007: 100,
    },
    county_names_all: "Coos",
    county_fips_all: 33007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03592",
    lat: 45.1128,
    lng: -71.25493,
    city: "Pittsburg",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1147,
    density: 1.2,
    county_fips: 33007,
    county_name: "Coos",
    county_weights: {
      33007: 100,
    },
    county_names_all: "Coos",
    county_fips_all: 33007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03593",
    lat: 44.29816,
    lng: -71.31774,
    city: "Randolph",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 384,
    density: 1.1,
    county_fips: 33007,
    county_name: "Coos",
    county_weights: {
      33007: 100,
    },
    county_names_all: "Coos",
    county_fips_all: 33007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03595",
    lat: 44.30616,
    lng: -71.527,
    city: "Twin Mountain",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 721,
    density: 7.6,
    county_fips: 33007,
    county_name: "Coos",
    county_weights: {
      33007: 100,
    },
    county_names_all: "Coos",
    county_fips_all: 33007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03597",
    lat: 44.73439,
    lng: -71.38243,
    city: "West Stewartstown",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 490,
    density: 4.2,
    county_fips: 33007,
    county_name: "Coos",
    county_weights: {
      33007: 100,
    },
    county_names_all: "Coos",
    county_fips_all: 33007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03598",
    lat: 44.37998,
    lng: -71.63179,
    city: "Whitefield",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3173,
    density: 20,
    county_fips: 33007,
    county_name: "Coos",
    county_weights: {
      33007: 100,
    },
    county_names_all: "Coos",
    county_fips_all: 33007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03601",
    lat: 43.23933,
    lng: -72.29855,
    city: "Acworth",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 602,
    density: 14.9,
    county_fips: 33019,
    county_name: "Sullivan",
    county_weights: {
      33019: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 33019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03602",
    lat: 43.13751,
    lng: -72.32938,
    city: "Alstead",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2277,
    density: 14.3,
    county_fips: 33005,
    county_name: "Cheshire",
    county_weights: {
      33005: 63.49,
      33019: 36.51,
    },
    county_names_all: "Cheshire|Sullivan",
    county_fips_all: "33005|33019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03603",
    lat: 43.25339,
    lng: -72.38059,
    city: "Charlestown",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5357,
    density: 46.7,
    county_fips: 33019,
    county_name: "Sullivan",
    county_weights: {
      33019: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 33019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03604",
    lat: 43.13232,
    lng: -72.38984,
    city: "Drewsville",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 117,
    density: 873.6,
    county_fips: 33005,
    county_name: "Cheshire",
    county_weights: {
      33005: 98.78,
      33019: 1.22,
    },
    county_names_all: "Cheshire|Sullivan",
    county_fips_all: "33005|33019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03605",
    lat: 43.22815,
    lng: -72.18032,
    city: "Lempster",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 809,
    density: 9.9,
    county_fips: 33019,
    county_name: "Sullivan",
    county_weights: {
      33019: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 33019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03607",
    lat: 43.19698,
    lng: -72.26084,
    city: "South Acworth",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 338,
    density: 8,
    county_fips: 33019,
    county_name: "Sullivan",
    county_weights: {
      33019: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 33019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03608",
    lat: 43.07128,
    lng: -72.40604,
    city: "Walpole",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3314,
    density: 37.3,
    county_fips: 33005,
    county_name: "Cheshire",
    county_weights: {
      33005: 100,
    },
    county_names_all: "Cheshire",
    county_fips_all: 33005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03609",
    lat: 43.1441,
    lng: -72.44512,
    city: "North Walpole",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 560,
    density: 240.8,
    county_fips: 33005,
    county_name: "Cheshire",
    county_weights: {
      33005: 100,
    },
    county_names_all: "Cheshire",
    county_fips_all: 33005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03740",
    lat: 44.18025,
    lng: -71.98626,
    city: "Bath",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 762,
    density: 7.9,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03741",
    lat: 43.67134,
    lng: -72.01559,
    city: "Canaan",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4115,
    density: 20.8,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03743",
    lat: 43.36026,
    lng: -72.32489,
    city: "Claremont",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13659,
    density: 89.2,
    county_fips: 33019,
    county_name: "Sullivan",
    county_weights: {
      33019: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 33019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03745",
    lat: 43.47407,
    lng: -72.32001,
    city: "Cornish",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1480,
    density: 13.6,
    county_fips: 33019,
    county_name: "Sullivan",
    county_weights: {
      33019: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 33019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03748",
    lat: 43.60207,
    lng: -72.11713,
    city: "Enfield",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4769,
    density: 39.3,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 95.14,
      33019: 4.86,
    },
    county_names_all: "Grafton|Sullivan",
    county_fips_all: "33009|33019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03750",
    lat: 43.70681,
    lng: -72.19308,
    city: "Etna",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1059,
    density: 25.9,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03751",
    lat: 43.44363,
    lng: -72.08394,
    city: "Georges Mills",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 638,
    density: 123.2,
    county_fips: 33019,
    county_name: "Sullivan",
    county_weights: {
      33019: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 33019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03752",
    lat: 43.28909,
    lng: -72.11489,
    city: "Goshen",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 964,
    density: 16.7,
    county_fips: 33019,
    county_name: "Sullivan",
    county_weights: {
      33019: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 33019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03753",
    lat: 43.51534,
    lng: -72.14798,
    city: "Grantham",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2878,
    density: 39.4,
    county_fips: 33019,
    county_name: "Sullivan",
    county_weights: {
      33019: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 33019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03755",
    lat: 43.72377,
    lng: -72.19563,
    city: "Hanover",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10466,
    density: 138.4,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03765",
    lat: 44.03452,
    lng: -72.05231,
    city: "Haverhill",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 576,
    density: 48.3,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03766",
    lat: 43.63491,
    lng: -72.23819,
    city: "Lebanon",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9643,
    density: 116.4,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03768",
    lat: 43.80529,
    lng: -72.11573,
    city: "Lyme",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1713,
    density: 12.3,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03770",
    lat: 43.5336,
    lng: -72.26469,
    city: "Meriden",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 460,
    density: 40.4,
    county_fips: 33019,
    county_name: "Sullivan",
    county_weights: {
      33019: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 33019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03771",
    lat: 44.28443,
    lng: -72.0098,
    city: "Monroe",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 939,
    density: 16.2,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03773",
    lat: 43.38484,
    lng: -72.19898,
    city: "Newport",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7636,
    density: 31.3,
    county_fips: 33019,
    county_name: "Sullivan",
    county_weights: {
      33019: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 33019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03774",
    lat: 44.09097,
    lng: -71.9947,
    city: "North Haverhill",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1884,
    density: 27.7,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03777",
    lat: 43.89548,
    lng: -72.06672,
    city: "Orford",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1372,
    density: 11.4,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03779",
    lat: 43.97477,
    lng: -72.03089,
    city: "Piermont",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 817,
    density: 8.2,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03780",
    lat: 44.03169,
    lng: -71.97142,
    city: "Pike",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 586,
    density: 11.4,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03781",
    lat: 43.5526,
    lng: -72.28399,
    city: "Plainfield",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2305,
    density: 18.6,
    county_fips: 33019,
    county_name: "Sullivan",
    county_weights: {
      33019: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 33019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03782",
    lat: 43.38962,
    lng: -72.09149,
    city: "Sunapee",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3013,
    density: 57.3,
    county_fips: 33019,
    county_name: "Sullivan",
    county_weights: {
      33019: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 33019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03784",
    lat: 43.63675,
    lng: -72.30608,
    city: "West Lebanon",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4126,
    density: 191.4,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03785",
    lat: 44.06525,
    lng: -71.87017,
    city: "Woodsville",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2300,
    density: 14.2,
    county_fips: 33009,
    county_name: "Grafton",
    county_weights: {
      33009: 100,
    },
    county_names_all: "Grafton",
    county_fips_all: 33009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03801",
    lat: 43.07293,
    lng: -70.8052,
    city: "Portsmouth",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22424,
    density: 364.2,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03809",
    lat: 43.45321,
    lng: -71.21184,
    city: "Alton",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3830,
    density: 36.9,
    county_fips: 33001,
    county_name: "Belknap",
    county_weights: {
      33001: 100,
    },
    county_names_all: "Belknap",
    county_fips_all: 33001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03810",
    lat: 43.52692,
    lng: -71.27941,
    city: "Alton Bay",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1501,
    density: 24.6,
    county_fips: 33001,
    county_name: "Belknap",
    county_weights: {
      33001: 100,
    },
    county_names_all: "Belknap",
    county_fips_all: 33001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03811",
    lat: 42.83693,
    lng: -71.16042,
    city: "Atkinson",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7014,
    density: 243.5,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03812",
    lat: 44.08148,
    lng: -71.29643,
    city: "Bartlett",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 485,
    density: 3.2,
    county_fips: 33003,
    county_name: "Carroll",
    county_weights: {
      33003: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 33003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03813",
    lat: 44.09408,
    lng: -71.04573,
    city: "Center Conway",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3044,
    density: 12,
    county_fips: 33003,
    county_name: "Carroll",
    county_weights: {
      33003: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 33003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03814",
    lat: 43.77341,
    lng: -71.18717,
    city: "Center Ossipee",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2201,
    density: 25.6,
    county_fips: 33003,
    county_name: "Carroll",
    county_weights: {
      33003: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 33003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03816",
    lat: 43.69753,
    lng: -71.24218,
    city: "Center Tuftonboro",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1206,
    density: 17.6,
    county_fips: 33003,
    county_name: "Carroll",
    county_weights: {
      33003: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 33003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03817",
    lat: 43.8885,
    lng: -71.23358,
    city: "Chocorua",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 976,
    density: 46.8,
    county_fips: 33003,
    county_name: "Carroll",
    county_weights: {
      33003: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 33003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03818",
    lat: 43.97302,
    lng: -71.25261,
    city: "Conway",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4127,
    density: 18.9,
    county_fips: 33003,
    county_name: "Carroll",
    county_weights: {
      33003: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 33003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03819",
    lat: 42.93012,
    lng: -71.12197,
    city: "Danville",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4520,
    density: 158.9,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03820",
    lat: 43.18933,
    lng: -70.88428,
    city: "Dover",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32046,
    density: 453.5,
    county_fips: 33017,
    county_name: "Strafford",
    county_weights: {
      33017: 100,
    },
    county_names_all: "Strafford",
    county_fips_all: 33017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03823",
    lat: 43.17488,
    lng: -70.94089,
    city: "Madbury",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2121,
    density: 70.3,
    county_fips: 33017,
    county_name: "Strafford",
    county_weights: {
      33017: 100,
    },
    county_names_all: "Strafford",
    county_fips_all: 33017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03824",
    lat: 43.11744,
    lng: -70.91937,
    city: "Durham",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16476,
    density: 283.8,
    county_fips: 33017,
    county_name: "Strafford",
    county_weights: {
      33017: 100,
    },
    county_names_all: "Strafford",
    county_fips_all: 33017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03825",
    lat: 43.21366,
    lng: -71.04227,
    city: "Barrington",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9293,
    density: 76.5,
    county_fips: 33017,
    county_name: "Strafford",
    county_weights: {
      33017: 100,
    },
    county_names_all: "Strafford",
    county_fips_all: 33017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03826",
    lat: 42.88878,
    lng: -71.12881,
    city: "East Hampstead",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1952,
    density: 220,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03827",
    lat: 42.90691,
    lng: -70.98774,
    city: "East Kingston",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3065,
    density: 66.3,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03830",
    lat: 43.63549,
    lng: -70.99568,
    city: "East Wakefield",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1567,
    density: 63.9,
    county_fips: 33003,
    county_name: "Carroll",
    county_weights: {
      33003: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 33003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03832",
    lat: 43.90249,
    lng: -71.04859,
    city: "Eaton Center",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 291,
    density: 4.6,
    county_fips: 33003,
    county_name: "Carroll",
    county_weights: {
      33003: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 33003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03833",
    lat: 42.97464,
    lng: -70.98885,
    city: "Exeter",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21901,
    density: 174.4,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03835",
    lat: 43.36319,
    lng: -71.07605,
    city: "Farmington",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6952,
    density: 73,
    county_fips: 33017,
    county_name: "Strafford",
    county_weights: {
      33017: 100,
    },
    county_names_all: "Strafford",
    county_fips_all: 33017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03836",
    lat: 43.82608,
    lng: -71.07118,
    city: "Freedom",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1304,
    density: 14.5,
    county_fips: 33003,
    county_name: "Carroll",
    county_weights: {
      33003: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 33003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03837",
    lat: 43.42271,
    lng: -71.32766,
    city: "Gilmanton Iron Works",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1736,
    density: 33.6,
    county_fips: 33001,
    county_name: "Belknap",
    county_weights: {
      33001: 100,
    },
    county_names_all: "Belknap",
    county_fips_all: 33001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03838",
    lat: 44.11257,
    lng: -71.24036,
    city: "Glen",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1191,
    density: 20.2,
    county_fips: 33003,
    county_name: "Carroll",
    county_weights: {
      33003: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 33003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03839",
    lat: 43.26256,
    lng: -70.98254,
    city: "Rochester",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4022,
    density: 197.3,
    county_fips: 33017,
    county_name: "Strafford",
    county_weights: {
      33017: 100,
    },
    county_names_all: "Strafford",
    county_fips_all: 33017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03840",
    lat: 43.03853,
    lng: -70.84803,
    city: "Greenland",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4038,
    density: 148.7,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03841",
    lat: 42.88148,
    lng: -71.17856,
    city: "Hampstead",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6798,
    density: 252.9,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03842",
    lat: 42.93941,
    lng: -70.83697,
    city: "Hampton",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15787,
    density: 476.9,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03844",
    lat: 42.92693,
    lng: -70.88603,
    city: "Hampton Falls",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2222,
    density: 69.3,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03845",
    lat: 44.10317,
    lng: -71.1271,
    city: "Intervale",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1213,
    density: 39.8,
    county_fips: 33003,
    county_name: "Carroll",
    county_weights: {
      33003: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 33003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03846",
    lat: 44.18445,
    lng: -71.18899,
    city: "Jackson",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 979,
    density: 5.7,
    county_fips: 33003,
    county_name: "Carroll",
    county_weights: {
      33003: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 33003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03847",
    lat: 44.06875,
    lng: -71.12162,
    city: "Kearsarge",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 376,
    density: 176.9,
    county_fips: 33003,
    county_name: "Carroll",
    county_weights: {
      33003: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 33003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03848",
    lat: 42.91562,
    lng: -71.06647,
    city: "Kingston",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6330,
    density: 123.5,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03849",
    lat: 43.89454,
    lng: -71.13101,
    city: "Madison",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1701,
    density: 29.5,
    county_fips: 33003,
    county_name: "Carroll",
    county_weights: {
      33003: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 33003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03850",
    lat: 43.69739,
    lng: -71.29983,
    city: "Melvin Village",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 198,
    density: 26.5,
    county_fips: 33003,
    county_name: "Carroll",
    county_weights: {
      33003: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 33003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03851",
    lat: 43.43606,
    lng: -71.01633,
    city: "Milton",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4230,
    density: 62.1,
    county_fips: 33017,
    county_name: "Strafford",
    county_weights: {
      33017: 100,
    },
    county_names_all: "Strafford",
    county_fips_all: 33017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03852",
    lat: 43.4982,
    lng: -70.97547,
    city: "Milton Mills",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 416,
    density: 23.8,
    county_fips: 33017,
    county_name: "Strafford",
    county_weights: {
      33017: 100,
    },
    county_names_all: "Strafford",
    county_fips_all: 33017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03853",
    lat: 43.63818,
    lng: -71.29371,
    city: "Mirror Lake",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 673,
    density: 30.1,
    county_fips: 33003,
    county_name: "Carroll",
    county_weights: {
      33001: 0.12,
      33003: 99.88,
    },
    county_names_all: "Carroll|Belknap",
    county_fips_all: "33003|33001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03854",
    lat: 43.06558,
    lng: -70.72003,
    city: "New Castle",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 863,
    density: 412.1,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03855",
    lat: 43.46343,
    lng: -71.14172,
    city: "New Durham",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2801,
    density: 26.2,
    county_fips: 33017,
    county_name: "Strafford",
    county_weights: {
      33017: 100,
    },
    county_names_all: "Strafford",
    county_fips_all: 33017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03856",
    lat: 43.03916,
    lng: -70.96627,
    city: "Newfields",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1984,
    density: 108,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03857",
    lat: 43.0691,
    lng: -70.95164,
    city: "Newmarket",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9161,
    density: 280.9,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03858",
    lat: 42.86839,
    lng: -71.04357,
    city: "Newton",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4930,
    density: 194,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03860",
    lat: 44.0427,
    lng: -71.12422,
    city: "North Conway",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4061,
    density: 67.5,
    county_fips: 33003,
    county_name: "Carroll",
    county_weights: {
      33003: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 33003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03861",
    lat: 43.11931,
    lng: -71.0068,
    city: "Lee",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4524,
    density: 88.5,
    county_fips: 33017,
    county_name: "Strafford",
    county_weights: {
      33017: 100,
    },
    county_names_all: "Strafford",
    county_fips_all: 33017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03862",
    lat: 42.97914,
    lng: -70.83025,
    city: "North Hampton",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4497,
    density: 124.7,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03864",
    lat: 43.69044,
    lng: -71.10631,
    city: "Ossipee",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2080,
    density: 20,
    county_fips: 33003,
    county_name: "Carroll",
    county_weights: {
      33003: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 33003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03865",
    lat: 42.84032,
    lng: -71.09603,
    city: "Plaistow",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7724,
    density: 281.6,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03867",
    lat: 43.3031,
    lng: -70.98891,
    city: "Rochester",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21739,
    density: 295.5,
    county_fips: 33017,
    county_name: "Strafford",
    county_weights: {
      33017: 100,
    },
    county_names_all: "Strafford",
    county_fips_all: 33017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03868",
    lat: 43.31879,
    lng: -70.9415,
    city: "Rochester",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5544,
    density: 244.7,
    county_fips: 33017,
    county_name: "Strafford",
    county_weights: {
      33017: 100,
    },
    county_names_all: "Strafford",
    county_fips_all: 33017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03869",
    lat: 43.22092,
    lng: -70.83995,
    city: "Rollinsford",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2527,
    density: 145.8,
    county_fips: 33017,
    county_name: "Strafford",
    county_weights: {
      33017: 100,
    },
    county_names_all: "Strafford",
    county_fips_all: 33017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03870",
    lat: 43.0157,
    lng: -70.76052,
    city: "Rye",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5299,
    density: 169.8,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03871",
    lat: 42.9807,
    lng: -70.77358,
    city: "Rye Beach",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 179,
    density: 124.4,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03872",
    lat: 43.57225,
    lng: -71.04249,
    city: "Sanbornville",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3875,
    density: 28.7,
    county_fips: 33003,
    county_name: "Carroll",
    county_weights: {
      33003: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 33003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03873",
    lat: 42.93321,
    lng: -71.1833,
    city: "Sandown",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6328,
    density: 175.3,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03874",
    lat: 42.88689,
    lng: -70.8607,
    city: "Seabrook",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8982,
    density: 387.6,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03875",
    lat: 43.89944,
    lng: -71.18636,
    city: "Silver Lake",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 832,
    density: 19.6,
    county_fips: 33003,
    county_name: "Carroll",
    county_weights: {
      33003: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 33003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03878",
    lat: 43.25335,
    lng: -70.88555,
    city: "Somersworth",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12085,
    density: 475.4,
    county_fips: 33017,
    county_name: "Strafford",
    county_weights: {
      33017: 100,
    },
    county_names_all: "Strafford",
    county_fips_all: 33017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03882",
    lat: 43.74727,
    lng: -71.04254,
    city: "Effingham",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1647,
    density: 17.1,
    county_fips: 33003,
    county_name: "Carroll",
    county_weights: {
      33003: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 33003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03883",
    lat: 43.81252,
    lng: -71.30789,
    city: "South Tamworth",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 282,
    density: 6,
    county_fips: 33003,
    county_name: "Carroll",
    county_weights: {
      33003: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 33003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03884",
    lat: 43.28018,
    lng: -71.14885,
    city: "Strafford",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4023,
    density: 31.7,
    county_fips: 33017,
    county_name: "Strafford",
    county_weights: {
      33017: 100,
    },
    county_names_all: "Strafford",
    county_fips_all: 33017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03885",
    lat: 43.01579,
    lng: -70.90051,
    city: "Stratham",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7430,
    density: 189.6,
    county_fips: 33015,
    county_name: "Rockingham",
    county_weights: {
      33015: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 33015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03886",
    lat: 43.86399,
    lng: -71.28783,
    city: "Tamworth",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1718,
    density: 19.3,
    county_fips: 33003,
    county_name: "Carroll",
    county_weights: {
      33003: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 33003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03887",
    lat: 43.48485,
    lng: -71.0662,
    city: "Union",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1779,
    density: 36.5,
    county_fips: 33017,
    county_name: "Strafford",
    county_weights: {
      33003: 4.89,
      33017: 95.11,
    },
    county_names_all: "Strafford|Carroll",
    county_fips_all: "33017|33003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03890",
    lat: 43.81528,
    lng: -71.20581,
    city: "West Ossipee",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64,
    density: 15.1,
    county_fips: 33003,
    county_name: "Carroll",
    county_weights: {
      33003: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 33003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03894",
    lat: 43.61109,
    lng: -71.17788,
    city: "Wolfeboro",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6289,
    density: 51.4,
    county_fips: 33003,
    county_name: "Carroll",
    county_weights: {
      33003: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 33003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03897",
    lat: 43.90841,
    lng: -71.32453,
    city: "Wonalancet",
    state_id: "NH",
    state_name: "New Hampshire",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 33003,
    county_name: "Carroll",
    county_weights: {
      33003: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 33003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03901",
    lat: 43.30063,
    lng: -70.84397,
    city: "Berwick",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7930,
    density: 81.6,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03902",
    lat: 43.22246,
    lng: -70.63788,
    city: "Cape Neddick",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1928,
    density: 39.1,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03903",
    lat: 43.14885,
    lng: -70.786,
    city: "Eliot",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6767,
    density: 132.1,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03904",
    lat: 43.11025,
    lng: -70.73201,
    city: "Kittery",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8068,
    density: 285.3,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03905",
    lat: 43.08481,
    lng: -70.68449,
    city: "Kittery Point",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1717,
    density: 96.2,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03906",
    lat: 43.3447,
    lng: -70.77759,
    city: "North Berwick",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4589,
    density: 46.3,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03907",
    lat: 43.25474,
    lng: -70.611,
    city: "Ogunquit",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1137,
    density: 107.5,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03908",
    lat: 43.23838,
    lng: -70.74795,
    city: "South Berwick",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7531,
    density: 91.2,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03909",
    lat: 43.16786,
    lng: -70.68105,
    city: "York",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10727,
    density: 117.5,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03910",
    lat: 43.17374,
    lng: -70.60842,
    city: "York Beach",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 418,
    density: 3262.4,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "03911",
    lat: 43.13424,
    lng: -70.63695,
    city: "York Harbor",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61,
    density: 66.4,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04001",
    lat: 43.52991,
    lng: -70.92078,
    city: "Acton",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2574,
    density: 26.3,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04002",
    lat: 43.49572,
    lng: -70.67922,
    city: "Alfred",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7596,
    density: 44.3,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04003",
    lat: 43.73362,
    lng: -69.98724,
    city: "Bailey Island",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 214,
    density: 79.6,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04005",
    lat: 43.49591,
    lng: -70.49537,
    city: "Biddeford",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23464,
    density: 189,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04006",
    lat: 43.44397,
    lng: -70.34272,
    city: "Biddeford Pool",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 141,
    density: 861.8,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04008",
    lat: 44.03664,
    lng: -69.86337,
    city: "Bowdoinham",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2780,
    density: 29.2,
    county_fips: 23023,
    county_name: "Sagadahoc",
    county_weights: {
      23023: 100,
    },
    county_names_all: "Sagadahoc",
    county_fips_all: 23023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04009",
    lat: 44.04791,
    lng: -70.73632,
    city: "Bridgton",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5335,
    density: 36.4,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04010",
    lat: 43.93341,
    lng: -70.91718,
    city: "Brownfield",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1691,
    density: 14.8,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04011",
    lat: 43.90068,
    lng: -69.97607,
    city: "Brunswick",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20565,
    density: 169.8,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04015",
    lat: 43.96503,
    lng: -70.5205,
    city: "Casco",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3838,
    density: 47.4,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04017",
    lat: 43.72974,
    lng: -70.11317,
    city: "Chebeague Island",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 515,
    density: 55.6,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04019",
    lat: 43.69149,
    lng: -70.0999,
    city: "Cliff Island",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42,
    density: 19.5,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04020",
    lat: 43.76811,
    lng: -70.81028,
    city: "Cornish",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1401,
    density: 24.4,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04021",
    lat: 43.79756,
    lng: -70.26519,
    city: "Cumberland Center",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6612,
    density: 124.2,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04022",
    lat: 43.98055,
    lng: -70.80718,
    city: "Denmark",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1017,
    density: 8.5,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04024",
    lat: 43.83556,
    lng: -70.67701,
    city: "East Baldwin",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 580,
    density: 15,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04027",
    lat: 43.40333,
    lng: -70.91155,
    city: "Lebanon",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6324,
    density: 44.4,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04029",
    lat: 43.89479,
    lng: -70.66007,
    city: "Sebago",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1830,
    density: 21.5,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04030",
    lat: 43.59301,
    lng: -70.69553,
    city: "East Waterboro",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2183,
    density: 54.8,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04032",
    lat: 43.85561,
    lng: -70.10085,
    city: "Freeport",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8517,
    density: 94.7,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04037",
    lat: 44.09129,
    lng: -70.94942,
    city: "Fryeburg",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3850,
    density: 18.2,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04038",
    lat: 43.70343,
    lng: -70.4581,
    city: "Gorham",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17723,
    density: 135.3,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04039",
    lat: 43.88744,
    lng: -70.34532,
    city: "Gray",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7596,
    density: 71.7,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04040",
    lat: 44.10922,
    lng: -70.71784,
    city: "Harrison",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3348,
    density: 20.8,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 55.29,
      23017: 44.71,
    },
    county_names_all: "Cumberland|Oxford",
    county_fips_all: "23005|23017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04041",
    lat: 43.86416,
    lng: -70.82631,
    city: "Hiram",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1886,
    density: 19.2,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04042",
    lat: 43.62953,
    lng: -70.62453,
    city: "Hollis Center",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4685,
    density: 56.5,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04043",
    lat: 43.39721,
    lng: -70.57071,
    city: "Kennebunk",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11536,
    density: 126.9,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04046",
    lat: 43.42027,
    lng: -70.4921,
    city: "Kennebunkport",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7965,
    density: 69.2,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04047",
    lat: 43.73552,
    lng: -70.91152,
    city: "Parsonsfield",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1733,
    density: 11.4,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04048",
    lat: 43.68862,
    lng: -70.78642,
    city: "Limerick",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3074,
    density: 43.7,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04049",
    lat: 43.7356,
    lng: -70.70263,
    city: "Limington",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3807,
    density: 35,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04050",
    lat: 43.69148,
    lng: -70.15714,
    city: "Long Island",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 282,
    density: 75.9,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04051",
    lat: 44.18945,
    lng: -70.88477,
    city: "Lovell",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1246,
    density: 11.2,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04055",
    lat: 43.97065,
    lng: -70.61444,
    city: "Naples",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3925,
    density: 47.6,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04056",
    lat: 43.66066,
    lng: -70.85875,
    city: "Newfield",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 249,
    density: 54.5,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04057",
    lat: 44.09563,
    lng: -70.70177,
    city: "North Bridgton",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 92,
    density: 108,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04061",
    lat: 43.63409,
    lng: -70.74312,
    city: "North Waterboro",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3025,
    density: 58.2,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04062",
    lat: 43.79798,
    lng: -70.40547,
    city: "Windham",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18821,
    density: 155.7,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04063",
    lat: 43.50145,
    lng: -70.39551,
    city: "Ocean Park",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 431,
    density: 226.7,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04064",
    lat: 43.52635,
    lng: -70.38985,
    city: "Old Orchard Beach",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8521,
    density: 491,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04066",
    lat: 43.77332,
    lng: -69.96808,
    city: "Orrs Island",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 678,
    density: 145.1,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04068",
    lat: 43.84009,
    lng: -70.9409,
    city: "Porter",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1329,
    density: 16.3,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04069",
    lat: 43.89918,
    lng: -70.18191,
    city: "Pownal",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1549,
    density: 26.2,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04071",
    lat: 43.89598,
    lng: -70.48133,
    city: "Raymond",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5211,
    density: 54.4,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04072",
    lat: 43.53898,
    lng: -70.46236,
    city: "Saco",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19716,
    density: 197.3,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04073",
    lat: 43.41301,
    lng: -70.74237,
    city: "Sanford",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16623,
    density: 170.1,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04074",
    lat: 43.59103,
    lng: -70.3683,
    city: "Scarborough",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20376,
    density: 165.1,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04076",
    lat: 43.55248,
    lng: -70.83793,
    city: "Shapleigh",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2772,
    density: 27.6,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04079",
    lat: 43.80343,
    lng: -69.94972,
    city: "Harpswell",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4022,
    density: 73,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04083",
    lat: 43.46728,
    lng: -70.81359,
    city: "Springvale",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4529,
    density: 174,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04084",
    lat: 43.76637,
    lng: -70.55893,
    city: "Standish",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7231,
    density: 63.7,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04085",
    lat: 43.7809,
    lng: -70.62553,
    city: "Steep Falls",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2888,
    density: 73.5,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04086",
    lat: 43.96145,
    lng: -69.95872,
    city: "Topsham",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8888,
    density: 106.6,
    county_fips: 23023,
    county_name: "Sagadahoc",
    county_weights: {
      23023: 100,
    },
    county_names_all: "Sagadahoc",
    county_fips_all: 23023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04087",
    lat: 43.56234,
    lng: -70.74529,
    city: "Waterboro",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2692,
    density: 52.3,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04088",
    lat: 44.19352,
    lng: -70.71906,
    city: "Waterford",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1311,
    density: 10.2,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04090",
    lat: 43.32669,
    lng: -70.63356,
    city: "Wells",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10530,
    density: 70.5,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04091",
    lat: 43.83035,
    lng: -70.74858,
    city: "West Baldwin",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 810,
    density: 15.4,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04092",
    lat: 43.69542,
    lng: -70.35389,
    city: "Westbrook",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18935,
    density: 425.3,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04093",
    lat: 43.64282,
    lng: -70.53765,
    city: "Buxton",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8289,
    density: 79,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04095",
    lat: 43.63925,
    lng: -70.90749,
    city: "West Newfield",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1341,
    density: 17,
    county_fips: 23031,
    county_name: "York",
    county_weights: {
      23031: 100,
    },
    county_names_all: "York",
    county_fips_all: 23031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04096",
    lat: 43.7978,
    lng: -70.1719,
    city: "Yarmouth",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8567,
    density: 246.8,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04097",
    lat: 43.85123,
    lng: -70.23636,
    city: "North Yarmouth",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3839,
    density: 69.8,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04101",
    lat: 43.6624,
    lng: -70.2586,
    city: "Portland",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18179,
    density: 3458.4,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04102",
    lat: 43.65877,
    lng: -70.30622,
    city: "Portland",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16968,
    density: 1093.2,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04103",
    lat: 43.69392,
    lng: -70.2909,
    city: "Portland",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30628,
    density: 1155.8,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04105",
    lat: 43.74753,
    lng: -70.2825,
    city: "Falmouth",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11968,
    density: 157.7,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04106",
    lat: 43.63081,
    lng: -70.28972,
    city: "South Portland",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25938,
    density: 822.9,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04107",
    lat: 43.5891,
    lng: -70.23801,
    city: "Cape Elizabeth",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9226,
    density: 239.7,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04108",
    lat: 43.66057,
    lng: -70.18901,
    city: "Peaks Island",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 809,
    density: 256.9,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04109",
    lat: 43.66732,
    lng: -70.19984,
    city: "Portland",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 80,
    density: 24.9,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04110",
    lat: 43.75834,
    lng: -70.19905,
    city: "Cumberland Foreside",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1532,
    density: 253.8,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04210",
    lat: 44.08505,
    lng: -70.24923,
    city: "Auburn",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23184,
    density: 150.9,
    county_fips: 23001,
    county_name: "Androscoggin",
    county_weights: {
      23001: 100,
    },
    county_names_all: "Androscoggin",
    county_fips_all: 23001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04216",
    lat: 44.70046,
    lng: -70.8142,
    city: "Andover",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 435,
    density: 1.2,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04217",
    lat: 44.36726,
    lng: -70.83364,
    city: "Bethel",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3425,
    density: 7.2,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04219",
    lat: 44.40924,
    lng: -70.59285,
    city: "Bryant Pond",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1328,
    density: 8.4,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04220",
    lat: 44.33511,
    lng: -70.35286,
    city: "Buckfield",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3292,
    density: 15.3,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04221",
    lat: 44.47242,
    lng: -70.29857,
    city: "Canton",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1008,
    density: 13.4,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04222",
    lat: 43.9644,
    lng: -70.12954,
    city: "Durham",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3983,
    density: 40.2,
    county_fips: 23001,
    county_name: "Androscoggin",
    county_weights: {
      23001: 100,
    },
    county_names_all: "Androscoggin",
    county_fips_all: 23001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04224",
    lat: 44.58001,
    lng: -70.40058,
    city: "Dixfield",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2583,
    density: 13.4,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23007: 44.83,
      23017: 55.17,
    },
    county_names_all: "Oxford|Franklin",
    county_fips_all: "23017|23007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04226",
    lat: 44.62555,
    lng: -70.70823,
    city: "East Andover",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 194,
    density: 15.2,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04227",
    lat: 44.56866,
    lng: -70.29471,
    city: "East Dixfield",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 83,
    density: 220.3,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04231",
    lat: 44.26438,
    lng: -70.88777,
    city: "Stoneham",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 191,
    density: 2.2,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04234",
    lat: 44.61624,
    lng: -70.19359,
    city: "East Wilton",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61,
    density: 4310,
    county_fips: 23007,
    county_name: "Franklin",
    county_weights: {
      23007: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 23007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04236",
    lat: 44.19036,
    lng: -70.14461,
    city: "Greene",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4340,
    density: 51.9,
    county_fips: 23001,
    county_name: "Androscoggin",
    county_weights: {
      23001: 100,
    },
    county_names_all: "Androscoggin",
    county_fips_all: 23001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04237",
    lat: 44.49665,
    lng: -70.7256,
    city: "Hanover",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 259,
    density: 14.2,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04238",
    lat: 44.20785,
    lng: -70.37937,
    city: "Hebron",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1600,
    density: 30.1,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04239",
    lat: 44.53062,
    lng: -70.20935,
    city: "Jay",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4612,
    density: 36.8,
    county_fips: 23007,
    county_name: "Franklin",
    county_weights: {
      23007: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 23007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04240",
    lat: 44.09147,
    lng: -70.16808,
    city: "Lewiston",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36158,
    density: 408.9,
    county_fips: 23001,
    county_name: "Androscoggin",
    county_weights: {
      23001: 100,
    },
    county_names_all: "Androscoggin",
    county_fips_all: 23001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04250",
    lat: 44.02582,
    lng: -70.11706,
    city: "Lisbon",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4193,
    density: 138.1,
    county_fips: 23001,
    county_name: "Androscoggin",
    county_weights: {
      23001: 100,
    },
    county_names_all: "Androscoggin",
    county_fips_all: 23001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04252",
    lat: 44.02719,
    lng: -70.06011,
    city: "Lisbon Falls",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4750,
    density: 165.2,
    county_fips: 23001,
    county_name: "Androscoggin",
    county_weights: {
      23001: 100,
    },
    county_names_all: "Androscoggin",
    county_fips_all: 23001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04253",
    lat: 44.4079,
    lng: -70.21503,
    city: "Livermore",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2048,
    density: 21,
    county_fips: 23001,
    county_name: "Androscoggin",
    county_weights: {
      23001: 100,
    },
    county_names_all: "Androscoggin",
    county_fips_all: 23001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04254",
    lat: 44.43249,
    lng: -70.14265,
    city: "Livermore Falls",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3176,
    density: 62.3,
    county_fips: 23001,
    county_name: "Androscoggin",
    county_weights: {
      23001: 100,
    },
    county_names_all: "Androscoggin",
    county_fips_all: 23001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04255",
    lat: 44.33505,
    lng: -70.66863,
    city: "Greenwood",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 667,
    density: 6.8,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04256",
    lat: 44.10294,
    lng: -70.40733,
    city: "Mechanic Falls",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2980,
    density: 104.6,
    county_fips: 23001,
    county_name: "Androscoggin",
    county_weights: {
      23001: 100,
    },
    county_names_all: "Androscoggin",
    county_fips_all: 23001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04257",
    lat: 44.57347,
    lng: -70.51358,
    city: "Mexico",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2632,
    density: 43.5,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04258",
    lat: 44.14829,
    lng: -70.33794,
    city: "Minot",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2667,
    density: 34.8,
    county_fips: 23001,
    county_name: "Androscoggin",
    county_weights: {
      23001: 100,
    },
    county_names_all: "Androscoggin",
    county_fips_all: 23001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04259",
    lat: 44.22762,
    lng: -70.00868,
    city: "Monmouth",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3455,
    density: 46,
    county_fips: 23011,
    county_name: "Kennebec",
    county_weights: {
      23011: 100,
    },
    county_names_all: "Kennebec",
    county_fips_all: 23011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04260",
    lat: 43.96409,
    lng: -70.29589,
    city: "New Gloucester",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5795,
    density: 47.5,
    county_fips: 23005,
    county_name: "Cumberland",
    county_weights: {
      23005: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 23005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04261",
    lat: 44.5631,
    lng: -70.91907,
    city: "Newry",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 318,
    density: 0.6,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04263",
    lat: 44.29476,
    lng: -70.13061,
    city: "Leeds",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2332,
    density: 22.5,
    county_fips: 23001,
    county_name: "Androscoggin",
    county_weights: {
      23001: 100,
    },
    county_names_all: "Androscoggin",
    county_fips_all: 23001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04265",
    lat: 44.27542,
    lng: -70.04276,
    city: "North Monmouth",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 795,
    density: 52.4,
    county_fips: 23011,
    county_name: "Kennebec",
    county_weights: {
      23011: 100,
    },
    county_names_all: "Kennebec",
    county_fips_all: 23011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04267",
    lat: 44.22478,
    lng: -70.77084,
    city: "North Waterford",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46,
    density: 39.4,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04268",
    lat: 44.22842,
    lng: -70.60651,
    city: "Norway",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4970,
    density: 42.6,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04270",
    lat: 44.11241,
    lng: -70.51559,
    city: "Oxford",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6220,
    density: 30.5,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04271",
    lat: 44.26099,
    lng: -70.49871,
    city: "Paris",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04274",
    lat: 44.04634,
    lng: -70.38999,
    city: "Poland",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5624,
    density: 51.4,
    county_fips: 23001,
    county_name: "Androscoggin",
    county_weights: {
      23001: 100,
    },
    county_names_all: "Androscoggin",
    county_fips_all: 23001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04275",
    lat: 44.68966,
    lng: -70.63729,
    city: "Roxbury",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 527,
    density: 2.1,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04276",
    lat: 44.53469,
    lng: -70.61541,
    city: "Rumford",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5733,
    density: 32.3,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04280",
    lat: 44.1215,
    lng: -70.06152,
    city: "Sabattus",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6702,
    density: 62.1,
    county_fips: 23001,
    county_name: "Androscoggin",
    county_weights: {
      23001: 100,
    },
    county_names_all: "Androscoggin",
    county_fips_all: 23001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04281",
    lat: 44.2445,
    lng: -70.48832,
    city: "South Paris",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5133,
    density: 48.7,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04282",
    lat: 44.26709,
    lng: -70.24291,
    city: "Turner",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5821,
    density: 37.9,
    county_fips: 23001,
    county_name: "Androscoggin",
    county_weights: {
      23001: 100,
    },
    county_names_all: "Androscoggin",
    county_fips_all: 23001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04284",
    lat: 44.34757,
    lng: -70.0651,
    city: "Wayne",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 954,
    density: 20,
    county_fips: 23011,
    county_name: "Kennebec",
    county_weights: {
      23011: 100,
    },
    county_names_all: "Kennebec",
    county_fips_all: 23011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04285",
    lat: 44.70625,
    lng: -70.4523,
    city: "Weld",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 428,
    density: 2.8,
    county_fips: 23007,
    county_name: "Franklin",
    county_weights: {
      23007: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 23007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04286",
    lat: 44.4032,
    lng: -70.86019,
    city: "West Bethel",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04287",
    lat: 44.05812,
    lng: -69.9694,
    city: "Bowdoin",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3423,
    density: 30.4,
    county_fips: 23023,
    county_name: "Sagadahoc",
    county_weights: {
      23023: 100,
    },
    county_names_all: "Sagadahoc",
    county_fips_all: 23023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04289",
    lat: 44.32108,
    lng: -70.53248,
    city: "West Paris",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2206,
    density: 34.4,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04290",
    lat: 44.47354,
    lng: -70.45058,
    city: "Peru",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1524,
    density: 12.6,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04292",
    lat: 44.37461,
    lng: -70.44674,
    city: "Sumner",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1085,
    density: 9.6,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23017: 100,
    },
    county_names_all: "Oxford",
    county_fips_all: 23017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04294",
    lat: 44.62346,
    lng: -70.27075,
    city: "Wilton",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3943,
    density: 28.5,
    county_fips: 23007,
    county_name: "Franklin",
    county_weights: {
      23007: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 23007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04330",
    lat: 44.36387,
    lng: -69.73729,
    city: "Augusta",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25803,
    density: 85.2,
    county_fips: 23011,
    county_name: "Kennebec",
    county_weights: {
      23011: 100,
    },
    county_names_all: "Kennebec",
    county_fips_all: 23011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04341",
    lat: 44.25997,
    lng: -69.55485,
    city: "Coopers Mills",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 23015,
    county_name: "Lincoln",
    county_weights: {
      23015: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 23015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04342",
    lat: 44.07942,
    lng: -69.73939,
    city: "Dresden",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1882,
    density: 23.9,
    county_fips: 23015,
    county_name: "Lincoln",
    county_weights: {
      23015: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 23015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04344",
    lat: 44.2588,
    lng: -69.82125,
    city: "Farmingdale",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2905,
    density: 99.8,
    county_fips: 23011,
    county_name: "Kennebec",
    county_weights: {
      23011: 100,
    },
    county_names_all: "Kennebec",
    county_fips_all: 23011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04345",
    lat: 44.19816,
    lng: -69.7841,
    city: "Gardiner",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11534,
    density: 62.1,
    county_fips: 23011,
    county_name: "Kennebec",
    county_weights: {
      23011: 100,
    },
    county_names_all: "Kennebec",
    county_fips_all: 23011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04346",
    lat: 44.23469,
    lng: -69.75068,
    city: "Randolph",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1711,
    density: 309.4,
    county_fips: 23011,
    county_name: "Kennebec",
    county_weights: {
      23011: 100,
    },
    county_names_all: "Kennebec",
    county_fips_all: 23011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04347",
    lat: 44.29047,
    lng: -69.81399,
    city: "Hallowell",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2444,
    density: 160.9,
    county_fips: 23011,
    county_name: "Kennebec",
    county_weights: {
      23011: 100,
    },
    county_names_all: "Kennebec",
    county_fips_all: 23011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04348",
    lat: 44.21521,
    lng: -69.49922,
    city: "Jefferson",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3097,
    density: 15.9,
    county_fips: 23015,
    county_name: "Lincoln",
    county_weights: {
      23015: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 23015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04349",
    lat: 44.43734,
    lng: -70.07014,
    city: "Kents Hill",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1111,
    density: 14.7,
    county_fips: 23011,
    county_name: "Kennebec",
    county_weights: {
      23011: 100,
    },
    county_names_all: "Kennebec",
    county_fips_all: 23011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04350",
    lat: 44.16266,
    lng: -69.93942,
    city: "Litchfield",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3611,
    density: 37.3,
    county_fips: 23011,
    county_name: "Kennebec",
    county_weights: {
      23011: 100,
    },
    county_names_all: "Kennebec",
    county_fips_all: 23011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04351",
    lat: 44.33174,
    lng: -69.86082,
    city: "Manchester",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2538,
    density: 45.7,
    county_fips: 23011,
    county_name: "Kennebec",
    county_weights: {
      23011: 100,
    },
    county_names_all: "Kennebec",
    county_fips_all: 23011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04352",
    lat: 44.46478,
    lng: -69.96225,
    city: "Mount Vernon",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1555,
    density: 15.8,
    county_fips: 23011,
    county_name: "Kennebec",
    county_weights: {
      23011: 100,
    },
    county_names_all: "Kennebec",
    county_fips_all: 23011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04353",
    lat: 44.2052,
    lng: -69.6126,
    city: "Whitefield",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2165,
    density: 17.9,
    county_fips: 23015,
    county_name: "Lincoln",
    county_weights: {
      23015: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 23015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04354",
    lat: 44.39602,
    lng: -69.42709,
    city: "Palermo",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1446,
    density: 13.8,
    county_fips: 23027,
    county_name: "Waldo",
    county_weights: {
      23027: 100,
    },
    county_names_all: "Waldo",
    county_fips_all: 23027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04355",
    lat: 44.38227,
    lng: -69.94915,
    city: "Readfield",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2571,
    density: 34.1,
    county_fips: 23011,
    county_name: "Kennebec",
    county_weights: {
      23011: 100,
    },
    county_names_all: "Kennebec",
    county_fips_all: 23011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04357",
    lat: 44.12366,
    lng: -69.82883,
    city: "Richmond",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3448,
    density: 43.7,
    county_fips: 23023,
    county_name: "Sagadahoc",
    county_weights: {
      23023: 100,
    },
    county_names_all: "Sagadahoc",
    county_fips_all: 23023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04358",
    lat: 44.41821,
    lng: -69.53286,
    city: "South China",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3917,
    density: 30.3,
    county_fips: 23011,
    county_name: "Kennebec",
    county_weights: {
      23011: 100,
    },
    county_names_all: "Kennebec",
    county_fips_all: 23011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04359",
    lat: 44.17947,
    lng: -69.76134,
    city: "South Gardiner",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 267,
    density: 139.9,
    county_fips: 23011,
    county_name: "Kennebec",
    county_weights: {
      23011: 100,
    },
    county_names_all: "Kennebec",
    county_fips_all: 23011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04360",
    lat: 44.54741,
    lng: -70.00299,
    city: "Vienna",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 509,
    density: 8.1,
    county_fips: 23011,
    county_name: "Kennebec",
    county_weights: {
      23011: 100,
    },
    county_names_all: "Kennebec",
    county_fips_all: 23011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04363",
    lat: 44.31101,
    lng: -69.57807,
    city: "Windsor",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2586,
    density: 28.8,
    county_fips: 23011,
    county_name: "Kennebec",
    county_weights: {
      23011: 100,
    },
    county_names_all: "Kennebec",
    county_fips_all: 23011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04364",
    lat: 44.31158,
    lng: -69.96153,
    city: "Winthrop",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5974,
    density: 74.1,
    county_fips: 23011,
    county_name: "Kennebec",
    county_weights: {
      23011: 100,
    },
    county_names_all: "Kennebec",
    county_fips_all: 23011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04401",
    lat: 44.84711,
    lng: -68.84654,
    city: "Bangor",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44008,
    density: 169.8,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04406",
    lat: 45.2186,
    lng: -69.57816,
    city: "Abbot",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 734,
    density: 2.3,
    county_fips: 23021,
    county_name: "Piscataquis",
    county_weights: {
      23021: 100,
    },
    county_names_all: "Piscataquis",
    county_fips_all: 23021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04408",
    lat: 44.9877,
    lng: -68.23246,
    city: "Aurora",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 164,
    density: 0.2,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04410",
    lat: 45.08821,
    lng: -68.90696,
    city: "Bradford",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1213,
    density: 11.4,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04411",
    lat: 44.88634,
    lng: -68.56672,
    city: "Bradley",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1791,
    density: 14,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04412",
    lat: 44.78354,
    lng: -68.73517,
    city: "Brewer",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9026,
    density: 228.7,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04413",
    lat: 45.55647,
    lng: -67.8274,
    city: "Brookton",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 145,
    density: 0.4,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23029: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 23029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04414",
    lat: 45.40654,
    lng: -69.08568,
    city: "Brownville",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1270,
    density: 2.1,
    county_fips: 23021,
    county_name: "Piscataquis",
    county_weights: {
      23021: 100,
    },
    county_names_all: "Piscataquis",
    county_fips_all: 23021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04415",
    lat: 45.35308,
    lng: -69.05832,
    city: "Brownville Junction",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 369,
    density: 878.2,
    county_fips: 23021,
    county_name: "Piscataquis",
    county_weights: {
      23021: 100,
    },
    county_names_all: "Piscataquis",
    county_fips_all: 23021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04416",
    lat: 44.62725,
    lng: -68.75286,
    city: "Bucksport",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5525,
    density: 36.9,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04417",
    lat: 45.19923,
    lng: -68.36728,
    city: "Burlington",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 385,
    density: 1.6,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04418",
    lat: 45.07572,
    lng: -68.50689,
    city: "Greenbush",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1752,
    density: 5.8,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04419",
    lat: 44.7969,
    lng: -69.03154,
    city: "Carmel",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2828,
    density: 29.8,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04421",
    lat: 44.4111,
    lng: -68.79524,
    city: "Castine",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1189,
    density: 59,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04422",
    lat: 45.07097,
    lng: -69.03408,
    city: "Charleston",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1348,
    density: 12.8,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04424",
    lat: 45.67003,
    lng: -67.86144,
    city: "Danforth",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 917,
    density: 3.6,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23003: 47.78,
      23029: 52.22,
    },
    county_names_all: "Washington|Aroostook",
    county_fips_all: "23029|23003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04426",
    lat: 45.1849,
    lng: -69.15827,
    city: "Dover Foxcroft",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4501,
    density: 14.5,
    county_fips: 23021,
    county_name: "Piscataquis",
    county_weights: {
      23021: 100,
    },
    county_names_all: "Piscataquis",
    county_fips_all: 23021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04427",
    lat: 44.9805,
    lng: -69.01063,
    city: "Corinth",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2808,
    density: 26.9,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04428",
    lat: 44.80643,
    lng: -68.55584,
    city: "Eddington",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3525,
    density: 22.9,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04429",
    lat: 44.72039,
    lng: -68.6171,
    city: "Holden",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4615,
    density: 25.2,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 57.64,
      23019: 42.36,
    },
    county_names_all: "Hancock|Penobscot",
    county_fips_all: "23009|23019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04430",
    lat: 45.64662,
    lng: -68.58646,
    city: "East Millinocket",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1695,
    density: 92.6,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04431",
    lat: 44.56453,
    lng: -68.6678,
    city: "East Orland",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35,
    density: 167.9,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04434",
    lat: 44.78529,
    lng: -69.13385,
    city: "Etna",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1141,
    density: 17.8,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04435",
    lat: 44.96435,
    lng: -69.13539,
    city: "Exeter",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1223,
    density: 12.2,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04438",
    lat: 44.59856,
    lng: -68.91904,
    city: "Frankfort",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1211,
    density: 19,
    county_fips: 23027,
    county_name: "Waldo",
    county_weights: {
      23027: 100,
    },
    county_names_all: "Waldo",
    county_fips_all: 23027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04441",
    lat: 45.68984,
    lng: -69.32252,
    city: "Greenville",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1683,
    density: 0.7,
    county_fips: 23021,
    county_name: "Piscataquis",
    county_weights: {
      23021: 100,
    },
    county_names_all: "Piscataquis",
    county_fips_all: 23021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04442",
    lat: 45.47446,
    lng: -69.69538,
    city: "Greenville Junction",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 89,
    density: 0.5,
    county_fips: 23021,
    county_name: "Piscataquis",
    county_weights: {
      23021: 100,
    },
    county_names_all: "Piscataquis",
    county_fips_all: 23021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04443",
    lat: 45.24412,
    lng: -69.40572,
    city: "Guilford",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2026,
    density: 5.2,
    county_fips: 23021,
    county_name: "Piscataquis",
    county_weights: {
      23021: 100,
    },
    county_names_all: "Piscataquis",
    county_fips_all: 23021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04444",
    lat: 44.72591,
    lng: -68.94585,
    city: "Hampden",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8994,
    density: 50.3,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04448",
    lat: 45.31208,
    lng: -68.71977,
    city: "Howland",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1474,
    density: 6.1,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04449",
    lat: 44.99761,
    lng: -68.88357,
    city: "Hudson",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1202,
    density: 12.4,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04450",
    lat: 44.91593,
    lng: -68.92797,
    city: "Kenduskeag",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1441,
    density: 33.2,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04451",
    lat: 45.6035,
    lng: -68.21915,
    city: "Kingman",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 221,
    density: 1.5,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 51.56,
      23019: 48.44,
    },
    county_names_all: "Aroostook|Penobscot",
    county_fips_all: "23003|23019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04453",
    lat: 45.18229,
    lng: -68.78244,
    city: "Lagrange",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 781,
    density: 4,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04454",
    lat: 45.5222,
    lng: -67.52516,
    city: "Lambert Lake",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21,
    density: 0.4,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23029: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 23029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04455",
    lat: 45.3223,
    lng: -68.27511,
    city: "Lee",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 752,
    density: 3.5,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04456",
    lat: 44.88645,
    lng: -68.9977,
    city: "Levant",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2954,
    density: 37.9,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04457",
    lat: 45.43432,
    lng: -68.52821,
    city: "Lincoln",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5755,
    density: 8.6,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04459",
    lat: 45.58898,
    lng: -68.33948,
    city: "Mattawamkeag",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 794,
    density: 4,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 51.94,
      23019: 48.06,
    },
    county_names_all: "Aroostook|Penobscot",
    county_fips_all: "23003|23019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04460",
    lat: 45.64134,
    lng: -68.52638,
    city: "Medway",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1417,
    density: 7.1,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04461",
    lat: 44.98057,
    lng: -68.57243,
    city: "Milford",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2991,
    density: 25.3,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04462",
    lat: 45.86541,
    lng: -68.93072,
    city: "Millinocket",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4597,
    density: 2.5,
    county_fips: 23021,
    county_name: "Piscataquis",
    county_weights: {
      23019: 29.65,
      23021: 70.35,
    },
    county_names_all: "Piscataquis|Penobscot",
    county_fips_all: "23021|23019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04463",
    lat: 45.28117,
    lng: -68.90569,
    city: "Milo",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3207,
    density: 8.6,
    county_fips: 23021,
    county_name: "Piscataquis",
    county_weights: {
      23021: 100,
    },
    county_names_all: "Piscataquis",
    county_fips_all: 23021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04464",
    lat: 45.29104,
    lng: -69.50202,
    city: "Monson",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 512,
    density: 4.3,
    county_fips: 23021,
    county_name: "Piscataquis",
    county_weights: {
      23021: 100,
    },
    county_names_all: "Piscataquis",
    county_fips_all: 23021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04468",
    lat: 45.0263,
    lng: -68.72323,
    city: "Old Town",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9199,
    density: 28.9,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04469",
    lat: 44.90251,
    lng: -68.66624,
    city: "Orono",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2510,
    density: 1133.4,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04471",
    lat: 45.8912,
    lng: -67.8471,
    city: "Orient",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 566,
    density: 2.3,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04472",
    lat: 44.57334,
    lng: -68.67736,
    city: "Orland",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2042,
    density: 16.8,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04473",
    lat: 44.88594,
    lng: -68.71888,
    city: "Orono",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8241,
    density: 183.7,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04474",
    lat: 44.71501,
    lng: -68.77901,
    city: "Orrington",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3674,
    density: 56.8,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04475",
    lat: 45.1845,
    lng: -68.58681,
    city: "Passadumkeag",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 584,
    density: 9.8,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04476",
    lat: 44.47474,
    lng: -68.70521,
    city: "Penobscot",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1018,
    density: 9.9,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04478",
    lat: 45.7299,
    lng: -69.76857,
    city: "Rockwood",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 310,
    density: 0.5,
    county_fips: 23025,
    county_name: "Somerset",
    county_weights: {
      23021: 37.63,
      23025: 62.37,
    },
    county_names_all: "Somerset|Piscataquis",
    county_fips_all: "23025|23021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04479",
    lat: 45.12755,
    lng: -69.30688,
    city: "Sangerville",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1507,
    density: 15.1,
    county_fips: 23021,
    county_name: "Piscataquis",
    county_weights: {
      23021: 100,
    },
    county_names_all: "Piscataquis",
    county_fips_all: 23021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04481",
    lat: 45.24298,
    lng: -69.10423,
    city: "Sebec",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 517,
    density: 5.4,
    county_fips: 23021,
    county_name: "Piscataquis",
    county_weights: {
      23021: 100,
    },
    county_names_all: "Piscataquis",
    county_fips_all: 23021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04485",
    lat: 45.362,
    lng: -69.61562,
    city: "Shirley Mills",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 158,
    density: 1.4,
    county_fips: 23021,
    county_name: "Piscataquis",
    county_weights: {
      23021: 100,
    },
    county_names_all: "Piscataquis",
    county_fips_all: 23021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04487",
    lat: 45.39371,
    lng: -68.1006,
    city: "Springfield",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 875,
    density: 1.5,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04488",
    lat: 44.87586,
    lng: -69.11143,
    city: "Stetson",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1360,
    density: 15,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04489",
    lat: 44.91074,
    lng: -68.69119,
    city: "Stillwater",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 343,
    density: 531.7,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04490",
    lat: 45.39527,
    lng: -67.82458,
    city: "Topsfield",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 228,
    density: 0.5,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23029: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 23029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04491",
    lat: 45.56705,
    lng: -67.51353,
    city: "Vanceboro",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 166,
    density: 2,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23029: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 23029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04492",
    lat: 45.34738,
    lng: -67.6658,
    city: "Waite",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 91,
    density: 0.9,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23029: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 23029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04493",
    lat: 45.23853,
    lng: -68.53301,
    city: "West Enfield",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1888,
    density: 10.7,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04495",
    lat: 45.45464,
    lng: -68.32985,
    city: "Winn",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 361,
    density: 3.2,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04496",
    lat: 44.65839,
    lng: -68.91189,
    city: "Winterport",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3985,
    density: 43.3,
    county_fips: 23027,
    county_name: "Waldo",
    county_weights: {
      23027: 100,
    },
    county_names_all: "Waldo",
    county_fips_all: 23027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04497",
    lat: 45.7249,
    lng: -68.06619,
    city: "Wytopitlock",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 326,
    density: 0.6,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 82.9,
      23019: 17.1,
    },
    county_names_all: "Aroostook|Penobscot",
    county_fips_all: "23003|23019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04530",
    lat: 43.89156,
    lng: -69.8306,
    city: "Bath",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10974,
    density: 147.3,
    county_fips: 23023,
    county_name: "Sagadahoc",
    county_weights: {
      23023: 100,
    },
    county_names_all: "Sagadahoc",
    county_fips_all: 23023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04535",
    lat: 44.08778,
    lng: -69.63436,
    city: "Alna",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 760,
    density: 14,
    county_fips: 23015,
    county_name: "Lincoln",
    county_weights: {
      23015: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 23015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04537",
    lat: 43.90241,
    lng: -69.62498,
    city: "Boothbay",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1609,
    density: 38.5,
    county_fips: 23015,
    county_name: "Lincoln",
    county_weights: {
      23015: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 23015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04538",
    lat: 43.85632,
    lng: -69.62807,
    city: "Boothbay Harbor",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1970,
    density: 168,
    county_fips: 23015,
    county_name: "Lincoln",
    county_weights: {
      23015: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 23015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04539",
    lat: 43.96429,
    lng: -69.50513,
    city: "Bristol",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1384,
    density: 32.4,
    county_fips: 23015,
    county_name: "Lincoln",
    county_weights: {
      23015: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 23015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04541",
    lat: 43.88671,
    lng: -69.48411,
    city: "Chamberlain",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48,
    density: 53.3,
    county_fips: 23015,
    county_name: "Lincoln",
    county_weights: {
      23015: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 23015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04543",
    lat: 44.03446,
    lng: -69.49211,
    city: "Damariscotta",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2288,
    density: 71,
    county_fips: 23015,
    county_name: "Lincoln",
    county_weights: {
      23015: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 23015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04544",
    lat: 43.83316,
    lng: -69.58997,
    city: "East Boothbay",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 930,
    density: 95.6,
    county_fips: 23015,
    county_name: "Lincoln",
    county_weights: {
      23015: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 23015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04547",
    lat: 43.99388,
    lng: -69.32779,
    city: "Friendship",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1155,
    density: 31.6,
    county_fips: 23013,
    county_name: "Knox",
    county_weights: {
      23013: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 23013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04548",
    lat: 43.81499,
    lng: -69.74804,
    city: "Georgetown",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 934,
    density: 19.4,
    county_fips: 23023,
    county_name: "Sagadahoc",
    county_weights: {
      23023: 100,
    },
    county_names_all: "Sagadahoc",
    county_fips_all: 23023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04551",
    lat: 44.00648,
    lng: -69.42701,
    city: "Bremen",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 717,
    density: 16.8,
    county_fips: 23015,
    county_name: "Lincoln",
    county_weights: {
      23015: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 23015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04553",
    lat: 44.04787,
    lng: -69.57145,
    city: "Newcastle",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1588,
    density: 21.1,
    county_fips: 23015,
    county_name: "Lincoln",
    county_weights: {
      23015: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 23015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04554",
    lat: 43.86348,
    lng: -69.50481,
    city: "New Harbor",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 659,
    density: 62.5,
    county_fips: 23015,
    county_name: "Lincoln",
    county_weights: {
      23015: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 23015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04555",
    lat: 44.10597,
    lng: -69.47687,
    city: "Nobleboro",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1552,
    density: 31.7,
    county_fips: 23015,
    county_name: "Lincoln",
    county_weights: {
      23015: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 23015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04556",
    lat: 43.96867,
    lng: -69.62311,
    city: "Edgecomb",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1257,
    density: 26.9,
    county_fips: 23015,
    county_name: "Lincoln",
    county_weights: {
      23015: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 23015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04558",
    lat: 43.89974,
    lng: -69.51499,
    city: "Pemaquid",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 142,
    density: 9.8,
    county_fips: 23015,
    county_name: "Lincoln",
    county_weights: {
      23015: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 23015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04562",
    lat: 43.78758,
    lng: -69.82764,
    city: "Phippsburg",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2128,
    density: 28.6,
    county_fips: 23023,
    county_name: "Sagadahoc",
    county_weights: {
      23023: 100,
    },
    county_names_all: "Sagadahoc",
    county_fips_all: 23023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04563",
    lat: 44.0151,
    lng: -69.25655,
    city: "Cushing",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1477,
    density: 29.6,
    county_fips: 23013,
    county_name: "Knox",
    county_weights: {
      23013: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 23013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04564",
    lat: 43.93089,
    lng: -69.46761,
    city: "Round Pond",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 527,
    density: 27,
    county_fips: 23015,
    county_name: "Lincoln",
    county_weights: {
      23015: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 23015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04568",
    lat: 43.89652,
    lng: -69.56153,
    city: "South Bristol",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 484,
    density: 35.9,
    county_fips: 23015,
    county_name: "Lincoln",
    county_weights: {
      23015: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 23015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04570",
    lat: 43.80844,
    lng: -69.63088,
    city: "Squirrel Island",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 23015,
    county_name: "Lincoln",
    county_weights: {
      23015: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 23015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04571",
    lat: 43.89949,
    lng: -69.67516,
    city: "Trevett",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 620,
    density: 115.1,
    county_fips: 23015,
    county_name: "Lincoln",
    county_weights: {
      23015: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 23015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04572",
    lat: 44.10984,
    lng: -69.36956,
    city: "Waldoboro",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5044,
    density: 27.2,
    county_fips: 23015,
    county_name: "Lincoln",
    county_weights: {
      23015: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 23015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04573",
    lat: 43.95063,
    lng: -69.55025,
    city: "Walpole",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 435,
    density: 21.3,
    county_fips: 23015,
    county_name: "Lincoln",
    county_weights: {
      23015: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 23015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04574",
    lat: 44.2734,
    lng: -69.39105,
    city: "Washington",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1561,
    density: 15.8,
    county_fips: 23013,
    county_name: "Knox",
    county_weights: {
      23013: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 23013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04575",
    lat: 43.85383,
    lng: -69.66016,
    city: "West Boothbay Harbor",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74,
    density: 24.4,
    county_fips: 23015,
    county_name: "Lincoln",
    county_weights: {
      23015: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 23015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04576",
    lat: 43.82244,
    lng: -69.6671,
    city: "Southport",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 487,
    density: 36.8,
    county_fips: 23015,
    county_name: "Lincoln",
    county_weights: {
      23015: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 23015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04578",
    lat: 43.98136,
    lng: -69.6926,
    city: "Wiscasset",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4577,
    density: 52.8,
    county_fips: 23015,
    county_name: "Lincoln",
    county_weights: {
      23015: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 23015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04579",
    lat: 43.96216,
    lng: -69.76872,
    city: "Woolwich",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3145,
    density: 34.6,
    county_fips: 23023,
    county_name: "Sagadahoc",
    county_weights: {
      23023: 100,
    },
    county_names_all: "Sagadahoc",
    county_fips_all: 23023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04605",
    lat: 44.66038,
    lng: -68.41623,
    city: "Ellsworth",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14311,
    density: 20.8,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04606",
    lat: 44.57697,
    lng: -67.70281,
    city: "Addison",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1346,
    density: 12.2,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23029: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 23029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04607",
    lat: 44.47689,
    lng: -68.05228,
    city: "Gouldsboro",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1122,
    density: 9.4,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04609",
    lat: 44.38518,
    lng: -68.27108,
    city: "Bar Harbor",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5527,
    density: 50.5,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04611",
    lat: 44.48771,
    lng: -67.59633,
    city: "Beals",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 414,
    density: 28.5,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23029: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 23029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04612",
    lat: 44.25954,
    lng: -68.37722,
    city: "Bernard",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 572,
    density: 52.6,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04613",
    lat: 44.37498,
    lng: -68.03593,
    city: "Birch Harbor",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 123,
    density: 31.7,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04614",
    lat: 44.41819,
    lng: -68.58223,
    city: "Blue Hill",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2663,
    density: 16.5,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04616",
    lat: 44.28346,
    lng: -68.57069,
    city: "Brooklin",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 677,
    density: 14.6,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04617",
    lat: 44.36929,
    lng: -68.73081,
    city: "Brooksville",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 781,
    density: 13.5,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04619",
    lat: 45.13397,
    lng: -67.22401,
    city: "Calais",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3011,
    density: 33.9,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23029: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 23029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04622",
    lat: 44.75555,
    lng: -67.95143,
    city: "Cherryfield",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 921,
    density: 1.1,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23009: 23.78,
      23029: 76.22,
    },
    county_names_all: "Washington|Hancock",
    county_fips_all: "23029|23009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04623",
    lat: 44.70786,
    lng: -67.70824,
    city: "Columbia Falls",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1011,
    density: 3.3,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23029: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 23029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04624",
    lat: 44.42438,
    lng: -67.9877,
    city: "Corea",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 191,
    density: 12.6,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04625",
    lat: 44.25041,
    lng: -68.25503,
    city: "Cranberry Isles",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49,
    density: 7.9,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04626",
    lat: 44.68494,
    lng: -67.22169,
    city: "Cutler",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 609,
    density: 5,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23029: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 23029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04627",
    lat: 44.22275,
    lng: -68.66581,
    city: "Deer Isle",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1640,
    density: 24.4,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04628",
    lat: 44.87275,
    lng: -67.28238,
    city: "Dennysville",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 565,
    density: 2.1,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23029: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 23029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04630",
    lat: 44.8471,
    lng: -67.47287,
    city: "East Machias",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1338,
    density: 5.8,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23029: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 23029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04631",
    lat: 44.91373,
    lng: -67.01834,
    city: "Eastport",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1300,
    density: 138.1,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23029: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 23029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04634",
    lat: 44.63457,
    lng: -68.22253,
    city: "Franklin",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1946,
    density: 8,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04635",
    lat: 44.11376,
    lng: -68.35479,
    city: "Frenchboro",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10,
    density: 1.6,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04640",
    lat: 44.53803,
    lng: -68.30573,
    city: "Hancock",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2038,
    density: 26.8,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04642",
    lat: 44.33906,
    lng: -68.79591,
    city: "Harborside",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 108,
    density: 4.9,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04643",
    lat: 44.57876,
    lng: -67.80562,
    city: "Harrington",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 954,
    density: 17.4,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23029: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 23029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04645",
    lat: 44.05408,
    lng: -68.6282,
    city: "Isle Au Haut",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27,
    density: 0.8,
    county_fips: 23013,
    county_name: "Knox",
    county_weights: {
      23013: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 23013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04646",
    lat: 44.26007,
    lng: -68.22812,
    city: "Islesford",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67,
    density: 32.8,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04648",
    lat: 44.65899,
    lng: -67.59585,
    city: "Jonesboro",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 723,
    density: 9.4,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23029: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 23029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04649",
    lat: 44.56606,
    lng: -67.5817,
    city: "Jonesport",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1162,
    density: 15.7,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23029: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 23029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04650",
    lat: 44.28924,
    lng: -68.71412,
    city: "Little Deer Isle",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 380,
    density: 43.2,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04652",
    lat: 44.82234,
    lng: -67.07457,
    city: "Lubec",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1584,
    density: 10,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23029: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 23029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04653",
    lat: 44.23705,
    lng: -68.3431,
    city: "Bass Harbor",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 573,
    density: 62.3,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04654",
    lat: 44.78128,
    lng: -67.57716,
    city: "Machias",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3359,
    density: 10.7,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23029: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 23029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04655",
    lat: 44.66467,
    lng: -67.39318,
    city: "Machiasport",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1008,
    density: 18.2,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23029: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 23029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04657",
    lat: 44.97624,
    lng: -67.41965,
    city: "Meddybemps",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 339,
    density: 1.7,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23029: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 23029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04658",
    lat: 44.53873,
    lng: -67.87257,
    city: "Milbridge",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1479,
    density: 24,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23029: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 23029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04660",
    lat: 44.34026,
    lng: -68.33231,
    city: "Mount Desert",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1054,
    density: 13.8,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04662",
    lat: 44.30766,
    lng: -68.28735,
    city: "Northeast Harbor",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 443,
    density: 39.7,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04664",
    lat: 44.53906,
    lng: -68.12797,
    city: "Sullivan",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1344,
    density: 12.9,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04666",
    lat: 44.97646,
    lng: -67.22204,
    city: "Pembroke",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1299,
    density: 8.6,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23029: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 23029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04667",
    lat: 44.97853,
    lng: -67.10413,
    city: "Perry",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1299,
    density: 16.8,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23029: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 23029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04668",
    lat: 45.19846,
    lng: -67.70543,
    city: "Princeton",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1448,
    density: 2.5,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23029: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 23029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04669",
    lat: 44.40014,
    lng: -68.01841,
    city: "Prospect Harbor",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 123,
    density: 27.3,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04671",
    lat: 45.06618,
    lng: -67.16247,
    city: "Robbinston",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 596,
    density: 8.2,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23029: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 23029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04673",
    lat: 44.30484,
    lng: -68.67028,
    city: "Sargentville",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 152,
    density: 19.3,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04674",
    lat: 44.29347,
    lng: -68.40883,
    city: "Seal Cove",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 377,
    density: 16,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04675",
    lat: 44.30083,
    lng: -68.24223,
    city: "Seal Harbor",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 143,
    density: 17.8,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04676",
    lat: 44.34741,
    lng: -68.64238,
    city: "Sedgwick",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1228,
    density: 19.5,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04677",
    lat: 44.49016,
    lng: -68.17945,
    city: "Sorrento",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 278,
    density: 26.9,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04679",
    lat: 44.27843,
    lng: -68.33247,
    city: "Southwest Harbor",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1496,
    density: 42.7,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04680",
    lat: 44.50699,
    lng: -67.94485,
    city: "Steuben",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1199,
    density: 10.8,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23029: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 23029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04681",
    lat: 44.16655,
    lng: -68.65646,
    city: "Stonington",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 981,
    density: 38.6,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04683",
    lat: 44.23596,
    lng: -68.82368,
    city: "Sunset",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 93,
    density: 87.7,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04684",
    lat: 44.49335,
    lng: -68.52796,
    city: "Surry",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1785,
    density: 18.6,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04685",
    lat: 44.15869,
    lng: -68.44015,
    city: "Swans Island",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 579,
    density: 14,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04686",
    lat: 44.98619,
    lng: -67.69015,
    city: "Wesley",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 151,
    density: 0.5,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23029: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 23029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04691",
    lat: 44.76178,
    lng: -67.25217,
    city: "Whiting",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 399,
    density: 3.3,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23029: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 23029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04693",
    lat: 44.38479,
    lng: -68.07828,
    city: "Winter Harbor",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 456,
    density: 12.2,
    county_fips: 23009,
    county_name: "Hancock",
    county_weights: {
      23009: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 23009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04694",
    lat: 45.09987,
    lng: -67.46518,
    city: "Baileyville",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2308,
    density: 6.7,
    county_fips: 23029,
    county_name: "Washington",
    county_weights: {
      23029: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 23029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04730",
    lat: 46.12574,
    lng: -67.91471,
    city: "Houlton",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9818,
    density: 15.5,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04732",
    lat: 46.56679,
    lng: -68.49326,
    city: "Ashland",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1536,
    density: 2.2,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 91.43,
      23021: 8.57,
    },
    county_names_all: "Aroostook|Piscataquis",
    county_fips_all: "23003|23021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04733",
    lat: 45.74275,
    lng: -68.40311,
    city: "Benedicta",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 274,
    density: 1.7,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 76.42,
      23019: 23.58,
    },
    county_names_all: "Aroostook|Penobscot",
    county_fips_all: "23003|23019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04734",
    lat: 46.48479,
    lng: -67.91955,
    city: "Blaine",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 916,
    density: 8.8,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04735",
    lat: 46.38072,
    lng: -68.02865,
    city: "Bridgewater",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 606,
    density: 1.1,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04736",
    lat: 46.90661,
    lng: -68.01998,
    city: "Caribou",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9248,
    density: 22.7,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04737",
    lat: 46.61641,
    lng: -69.52178,
    city: "Clayton Lake",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04739",
    lat: 46.97137,
    lng: -68.61049,
    city: "Eagle Lake",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 705,
    density: 1.4,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04740",
    lat: 46.64325,
    lng: -67.85487,
    city: "Easton",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1387,
    density: 13.9,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04742",
    lat: 46.77766,
    lng: -67.85526,
    city: "Fort Fairfield",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3299,
    density: 16.5,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04743",
    lat: 47.15427,
    lng: -68.72512,
    city: "Fort Kent",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4483,
    density: 10.4,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04745",
    lat: 47.27371,
    lng: -68.39936,
    city: "Frenchville",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 885,
    density: 11.9,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04746",
    lat: 47.24885,
    lng: -68.12472,
    city: "Grand Isle",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 404,
    density: 4.2,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04747",
    lat: 45.94854,
    lng: -68.19649,
    city: "Island Falls",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1392,
    density: 1.7,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04750",
    lat: 46.9582,
    lng: -67.85718,
    city: "Limestone",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2261,
    density: 11.1,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04756",
    lat: 47.33054,
    lng: -68.30176,
    city: "Madawaska",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3186,
    density: 74.9,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04757",
    lat: 46.6141,
    lng: -68.18278,
    city: "Mapleton",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2655,
    density: 4.9,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04758",
    lat: 46.55426,
    lng: -67.84732,
    city: "Mars Hill",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1246,
    density: 13.7,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04760",
    lat: 46.32354,
    lng: -67.90928,
    city: "Monticello",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 640,
    density: 3.2,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04761",
    lat: 46.11857,
    lng: -67.97183,
    city: "New Limerick",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 484,
    density: 10.3,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04762",
    lat: 46.97574,
    lng: -68.12094,
    city: "New Sweden",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 533,
    density: 6,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04763",
    lat: 46.08068,
    lng: -68.10371,
    city: "Oakfield",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 751,
    density: 8.3,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04764",
    lat: 46.36843,
    lng: -68.34229,
    city: "Oxbow",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30,
    density: 0.1,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04765",
    lat: 46.06884,
    lng: -68.64477,
    city: "Patten",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1026,
    density: 0.5,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04766",
    lat: 46.88162,
    lng: -68.23911,
    city: "Perham",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 387,
    density: 4.1,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04768",
    lat: 46.7878,
    lng: -68.82875,
    city: "Portage",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 378,
    density: 1.7,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04769",
    lat: 46.68676,
    lng: -67.98737,
    city: "Presque Isle",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9072,
    density: 46.2,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04772",
    lat: 47.23375,
    lng: -68.32732,
    city: "Saint Agatha",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 804,
    density: 10.5,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04773",
    lat: 47.27426,
    lng: -68.22649,
    city: "Saint David",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 579,
    density: 5.5,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04774",
    lat: 47.10285,
    lng: -69.05048,
    city: "Saint Francis",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 614,
    density: 1.5,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04776",
    lat: 45.8105,
    lng: -68.31818,
    city: "Sherman",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 973,
    density: 3.9,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04777",
    lat: 45.83515,
    lng: -68.48952,
    city: "Stacyville",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 388,
    density: 1.9,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04779",
    lat: 47.11615,
    lng: -68.31162,
    city: "Sinclair",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 301,
    density: 1.2,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04780",
    lat: 46.1677,
    lng: -68.26924,
    city: "Smyrna Mills",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 902,
    density: 2,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04781",
    lat: 47.14634,
    lng: -68.61883,
    city: "Wallagrass",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 575,
    density: 4.9,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04783",
    lat: 47.03586,
    lng: -68.18907,
    city: "Stockholm",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 389,
    density: 2,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04785",
    lat: 47.12678,
    lng: -68.00368,
    city: "Van Buren",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2013,
    density: 6.2,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04786",
    lat: 46.79207,
    lng: -68.17878,
    city: "Washburn",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1754,
    density: 9.6,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04787",
    lat: 46.55166,
    lng: -67.97685,
    city: "Westfield",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 676,
    density: 6.5,
    county_fips: 23003,
    county_name: "Aroostook",
    county_weights: {
      23003: 100,
    },
    county_names_all: "Aroostook",
    county_fips_all: 23003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04841",
    lat: 44.12739,
    lng: -69.13686,
    city: "Rockland",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7172,
    density: 215.6,
    county_fips: 23013,
    county_name: "Knox",
    county_weights: {
      23013: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 23013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04843",
    lat: 44.22929,
    lng: -69.08924,
    city: "Camden",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4811,
    density: 100.5,
    county_fips: 23013,
    county_name: "Knox",
    county_weights: {
      23013: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 23013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04847",
    lat: 44.25104,
    lng: -69.18962,
    city: "Hope",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1729,
    density: 30.4,
    county_fips: 23013,
    county_name: "Knox",
    county_weights: {
      23013: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 23013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04848",
    lat: 44.31083,
    lng: -68.90896,
    city: "Islesboro",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 625,
    density: 16.9,
    county_fips: 23027,
    county_name: "Waldo",
    county_weights: {
      23027: 100,
    },
    county_names_all: "Waldo",
    county_fips_all: 23027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04849",
    lat: 44.3179,
    lng: -69.04753,
    city: "Lincolnville",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3714,
    density: 23.5,
    county_fips: 23027,
    county_name: "Waldo",
    county_weights: {
      23027: 100,
    },
    county_names_all: "Waldo",
    county_fips_all: 23027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04851",
    lat: 43.85227,
    lng: -68.8916,
    city: "Matinicus",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 72,
    density: 14.5,
    county_fips: 23013,
    county_name: "Knox",
    county_weights: {
      23013: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 23013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04852",
    lat: 43.76561,
    lng: -69.31235,
    city: "Monhegan",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 119,
    density: 54,
    county_fips: 23015,
    county_name: "Lincoln",
    county_weights: {
      23015: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 23015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04853",
    lat: 44.15172,
    lng: -68.86311,
    city: "North Haven",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 449,
    density: 15.2,
    county_fips: 23013,
    county_name: "Knox",
    county_weights: {
      23013: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 23013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04854",
    lat: 44.04344,
    lng: -69.08504,
    city: "Owls Head",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1428,
    density: 52.2,
    county_fips: 23013,
    county_name: "Knox",
    county_weights: {
      23013: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 23013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04855",
    lat: 43.93797,
    lng: -69.26958,
    city: "Port Clyde",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 437,
    density: 144.3,
    county_fips: 23013,
    county_name: "Knox",
    county_weights: {
      23013: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 23013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04856",
    lat: 44.17798,
    lng: -69.12007,
    city: "Rockport",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3373,
    density: 60.2,
    county_fips: 23013,
    county_name: "Knox",
    county_weights: {
      23013: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 23013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04858",
    lat: 44.04638,
    lng: -69.1452,
    city: "South Thomaston",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1264,
    density: 42.7,
    county_fips: 23013,
    county_name: "Knox",
    county_weights: {
      23013: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 23013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04859",
    lat: 44.00068,
    lng: -69.16112,
    city: "Spruce Head",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 702,
    density: 61,
    county_fips: 23013,
    county_name: "Knox",
    county_weights: {
      23013: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 23013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04860",
    lat: 43.968,
    lng: -69.22817,
    city: "Tenants Harbor",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1476,
    density: 29.3,
    county_fips: 23013,
    county_name: "Knox",
    county_weights: {
      23013: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 23013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04861",
    lat: 44.09302,
    lng: -69.17483,
    city: "Thomaston",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2761,
    density: 97.5,
    county_fips: 23013,
    county_name: "Knox",
    county_weights: {
      23013: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 23013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04862",
    lat: 44.26186,
    lng: -69.27703,
    city: "Union",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4208,
    density: 25,
    county_fips: 23013,
    county_name: "Knox",
    county_weights: {
      23013: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 23013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04863",
    lat: 44.07898,
    lng: -68.84384,
    city: "Vinalhaven",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 932,
    density: 15.4,
    county_fips: 23013,
    county_name: "Knox",
    county_weights: {
      23013: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 23013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04864",
    lat: 44.12946,
    lng: -69.24481,
    city: "Warren",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4775,
    density: 39.7,
    county_fips: 23013,
    county_name: "Knox",
    county_weights: {
      23013: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 23013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04901",
    lat: 44.55449,
    lng: -69.57037,
    city: "Waterville",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26951,
    density: 132.1,
    county_fips: 23011,
    county_name: "Kennebec",
    county_weights: {
      23011: 100,
    },
    county_names_all: "Kennebec",
    county_fips_all: 23011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04910",
    lat: 44.517,
    lng: -69.44123,
    city: "Albion",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2344,
    density: 23.3,
    county_fips: 23011,
    county_name: "Kennebec",
    county_weights: {
      23011: 100,
    },
    county_names_all: "Kennebec",
    county_fips_all: 23011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04911",
    lat: 44.78039,
    lng: -69.96112,
    city: "Anson",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1873,
    density: 11.4,
    county_fips: 23025,
    county_name: "Somerset",
    county_weights: {
      23025: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 23025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04912",
    lat: 44.97286,
    lng: -69.68045,
    city: "Athens",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 813,
    density: 5.6,
    county_fips: 23025,
    county_name: "Somerset",
    county_weights: {
      23025: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 23025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04915",
    lat: 44.46643,
    lng: -69.04156,
    city: "Belfast",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8943,
    density: 47.3,
    county_fips: 23027,
    county_name: "Waldo",
    county_weights: {
      23027: 100,
    },
    county_names_all: "Waldo",
    county_fips_all: 23027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04917",
    lat: 44.48959,
    lng: -69.84167,
    city: "Belgrade",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2840,
    density: 25.7,
    county_fips: 23011,
    county_name: "Kennebec",
    county_weights: {
      23011: 100,
    },
    county_names_all: "Kennebec",
    county_fips_all: 23011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04918",
    lat: 44.55027,
    lng: -69.86651,
    city: "Belgrade Lakes",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 308,
    density: 197.3,
    county_fips: 23011,
    county_name: "Kennebec",
    county_weights: {
      23011: 100,
    },
    county_names_all: "Kennebec",
    county_fips_all: 23011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04920",
    lat: 45.11323,
    lng: -69.83863,
    city: "Bingham",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1655,
    density: 2.9,
    county_fips: 23025,
    county_name: "Somerset",
    county_weights: {
      23025: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 23025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04921",
    lat: 44.57256,
    lng: -69.13326,
    city: "Brooks",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1509,
    density: 11.7,
    county_fips: 23027,
    county_name: "Waldo",
    county_weights: {
      23027: 100,
    },
    county_names_all: "Waldo",
    county_fips_all: 23027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04922",
    lat: 44.68739,
    lng: -69.38255,
    city: "Burnham",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 984,
    density: 9.8,
    county_fips: 23027,
    county_name: "Waldo",
    county_weights: {
      23027: 100,
    },
    county_names_all: "Waldo",
    county_fips_all: 23027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04923",
    lat: 45.03722,
    lng: -69.44533,
    city: "Cambridge",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 614,
    density: 12.7,
    county_fips: 23025,
    county_name: "Somerset",
    county_weights: {
      23025: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 23025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04924",
    lat: 44.77922,
    lng: -69.54967,
    city: "Canaan",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2423,
    density: 22.7,
    county_fips: 23025,
    county_name: "Somerset",
    county_weights: {
      23025: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 23025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04925",
    lat: 45.21477,
    lng: -69.90509,
    city: "Caratunk",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54,
    density: 0.4,
    county_fips: 23025,
    county_name: "Somerset",
    county_weights: {
      23025: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 23025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04926",
    lat: 44.48035,
    lng: -69.51521,
    city: "China Village",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 371,
    density: 2841.2,
    county_fips: 23011,
    county_name: "Kennebec",
    county_weights: {
      23011: 100,
    },
    county_names_all: "Kennebec",
    county_fips_all: 23011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04927",
    lat: 44.67021,
    lng: -69.53589,
    city: "Clinton",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3366,
    density: 29.6,
    county_fips: 23011,
    county_name: "Kennebec",
    county_weights: {
      23011: 100,
    },
    county_names_all: "Kennebec",
    county_fips_all: 23011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04928",
    lat: 44.94973,
    lng: -69.25695,
    city: "Corinna",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1992,
    density: 19.9,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04929",
    lat: 44.76238,
    lng: -69.31131,
    city: "Detroit",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 883,
    density: 16.8,
    county_fips: 23025,
    county_name: "Somerset",
    county_weights: {
      23025: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 23025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04930",
    lat: 45.02656,
    lng: -69.32835,
    city: "Dexter",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4088,
    density: 26.2,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 59.21,
      23025: 40.79,
    },
    county_names_all: "Penobscot|Somerset",
    county_fips_all: "23019|23025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04932",
    lat: 44.6957,
    lng: -69.13335,
    city: "Dixmont",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1289,
    density: 13.7,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04936",
    lat: 45.32923,
    lng: -70.62715,
    city: "Eustis",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 205,
    density: 0.2,
    county_fips: 23007,
    county_name: "Franklin",
    county_weights: {
      23007: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 23007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04937",
    lat: 44.63546,
    lng: -69.67635,
    city: "Fairfield",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6473,
    density: 48.1,
    county_fips: 23025,
    county_name: "Somerset",
    county_weights: {
      23025: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 23025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04938",
    lat: 44.65881,
    lng: -70.10329,
    city: "Farmington",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9972,
    density: 31.4,
    county_fips: 23007,
    county_name: "Franklin",
    county_weights: {
      23007: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 23007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04939",
    lat: 45.05436,
    lng: -69.15859,
    city: "Garland",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 861,
    density: 8.8,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04940",
    lat: 44.62018,
    lng: -70.07508,
    city: "Farmington Falls",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 23007,
    county_name: "Franklin",
    county_weights: {
      23007: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 23007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04941",
    lat: 44.4654,
    lng: -69.3017,
    city: "Freedom",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1727,
    density: 10.4,
    county_fips: 23027,
    county_name: "Waldo",
    county_weights: {
      23027: 100,
    },
    county_names_all: "Waldo",
    county_fips_all: 23027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04942",
    lat: 45.04148,
    lng: -69.59241,
    city: "Harmony",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1124,
    density: 3.7,
    county_fips: 23025,
    county_name: "Somerset",
    county_weights: {
      23021: 43.52,
      23025: 56.48,
    },
    county_names_all: "Somerset|Piscataquis",
    county_fips_all: "23025|23021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04943",
    lat: 44.87994,
    lng: -69.52054,
    city: "Hartland",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1652,
    density: 17.2,
    county_fips: 23025,
    county_name: "Somerset",
    county_weights: {
      23025: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 23025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04944",
    lat: 44.68737,
    lng: -69.64237,
    city: "Hinckley",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55,
    density: 12.3,
    county_fips: 23025,
    county_name: "Somerset",
    county_weights: {
      23025: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 23025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04945",
    lat: 45.57669,
    lng: -70.27974,
    city: "Jackman",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1117,
    density: 0.7,
    county_fips: 23025,
    county_name: "Somerset",
    county_weights: {
      23025: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 23025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04947",
    lat: 45.03319,
    lng: -70.2391,
    city: "Kingfield",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1601,
    density: 4.9,
    county_fips: 23007,
    county_name: "Franklin",
    county_weights: {
      23007: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 23007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04949",
    lat: 44.36712,
    lng: -69.34029,
    city: "Liberty",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 786,
    density: 11.7,
    county_fips: 23027,
    county_name: "Waldo",
    county_weights: {
      23027: 100,
    },
    county_names_all: "Waldo",
    county_fips_all: 23027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04950",
    lat: 44.83241,
    lng: -69.80556,
    city: "Madison",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4675,
    density: 34.8,
    county_fips: 23025,
    county_name: "Somerset",
    county_weights: {
      23025: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 23025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04951",
    lat: 44.60716,
    lng: -69.04575,
    city: "Monroe",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1082,
    density: 10.7,
    county_fips: 23027,
    county_name: "Waldo",
    county_weights: {
      23027: 100,
    },
    county_names_all: "Waldo",
    county_fips_all: 23027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04952",
    lat: 44.40934,
    lng: -69.14261,
    city: "Morrill",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1953,
    density: 25,
    county_fips: 23027,
    county_name: "Waldo",
    county_weights: {
      23027: 100,
    },
    county_names_all: "Waldo",
    county_fips_all: 23027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04953",
    lat: 44.86017,
    lng: -69.23297,
    city: "Newport",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3226,
    density: 42.2,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04955",
    lat: 44.63998,
    lng: -70.00799,
    city: "New Sharon",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1403,
    density: 12,
    county_fips: 23007,
    county_name: "Franklin",
    county_weights: {
      23007: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 23007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04956",
    lat: 44.80533,
    lng: -70.11215,
    city: "New Vineyard",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 791,
    density: 8.5,
    county_fips: 23007,
    county_name: "Franklin",
    county_weights: {
      23007: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 23007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04957",
    lat: 44.70419,
    lng: -69.8471,
    city: "Norridgewock",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4153,
    density: 20.9,
    county_fips: 23025,
    county_name: "Somerset",
    county_weights: {
      23025: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 23025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04958",
    lat: 44.90561,
    lng: -69.92494,
    city: "North Anson",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1896,
    density: 13.3,
    county_fips: 23025,
    county_name: "Somerset",
    county_weights: {
      23025: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 23025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04961",
    lat: 45.16024,
    lng: -70.1665,
    city: "New Portland",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 791,
    density: 0.8,
    county_fips: 23025,
    county_name: "Somerset",
    county_weights: {
      23025: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 23025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04963",
    lat: 44.56621,
    lng: -69.81463,
    city: "Oakland",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7311,
    density: 55.3,
    county_fips: 23011,
    county_name: "Kennebec",
    county_weights: {
      23011: 100,
    },
    county_names_all: "Kennebec",
    county_fips_all: 23011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04964",
    lat: 44.9355,
    lng: -70.83584,
    city: "Oquossoc",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 130,
    density: 0.6,
    county_fips: 23017,
    county_name: "Oxford",
    county_weights: {
      23007: 25.88,
      23017: 74.12,
    },
    county_names_all: "Oxford|Franklin",
    county_fips_all: "23017|23007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04965",
    lat: 44.84563,
    lng: -69.36272,
    city: "Palmyra",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2159,
    density: 20.8,
    county_fips: 23025,
    county_name: "Somerset",
    county_weights: {
      23025: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 23025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04966",
    lat: 44.82476,
    lng: -70.47877,
    city: "Phillips",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1556,
    density: 2.5,
    county_fips: 23007,
    county_name: "Franklin",
    county_weights: {
      23007: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 23007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04967",
    lat: 44.77138,
    lng: -69.43866,
    city: "Pittsfield",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4042,
    density: 32.4,
    county_fips: 23025,
    county_name: "Somerset",
    county_weights: {
      23025: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 23025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04969",
    lat: 44.77019,
    lng: -69.22461,
    city: "Plymouth",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1154,
    density: 15,
    county_fips: 23019,
    county_name: "Penobscot",
    county_weights: {
      23019: 100,
    },
    county_names_all: "Penobscot",
    county_fips_all: 23019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04970",
    lat: 45.00032,
    lng: -70.63519,
    city: "Rangeley",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1517,
    density: 2.6,
    county_fips: 23007,
    county_name: "Franklin",
    county_weights: {
      23007: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 23007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04971",
    lat: 44.93191,
    lng: -69.39225,
    city: "Saint Albans",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1949,
    density: 16.8,
    county_fips: 23025,
    county_name: "Somerset",
    county_weights: {
      23025: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 23025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04973",
    lat: 44.36229,
    lng: -69.19303,
    city: "Searsmont",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1374,
    density: 14.1,
    county_fips: 23027,
    county_name: "Waldo",
    county_weights: {
      23027: 100,
    },
    county_names_all: "Waldo",
    county_fips_all: 23027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04974",
    lat: 44.4893,
    lng: -68.92996,
    city: "Searsport",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2575,
    density: 34.7,
    county_fips: 23027,
    county_name: "Waldo",
    county_weights: {
      23027: 100,
    },
    county_names_all: "Waldo",
    county_fips_all: 23027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04975",
    lat: 44.62549,
    lng: -69.58837,
    city: "Shawmut",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29,
    density: 205.1,
    county_fips: 23025,
    county_name: "Somerset",
    county_weights: {
      23025: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 23025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04976",
    lat: 44.79873,
    lng: -69.66951,
    city: "Skowhegan",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9842,
    density: 38.2,
    county_fips: 23025,
    county_name: "Somerset",
    county_weights: {
      23025: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 23025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04978",
    lat: 44.63466,
    lng: -69.80789,
    city: "Smithfield",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 862,
    density: 16.7,
    county_fips: 23025,
    county_name: "Somerset",
    county_weights: {
      23025: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 23025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04979",
    lat: 44.94105,
    lng: -69.79731,
    city: "Solon",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 849,
    density: 8.3,
    county_fips: 23025,
    county_name: "Somerset",
    county_weights: {
      23025: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 23025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04981",
    lat: 44.53228,
    lng: -68.85941,
    city: "Stockton Springs",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2506,
    density: 25.6,
    county_fips: 23027,
    county_name: "Waldo",
    county_weights: {
      23027: 100,
    },
    county_names_all: "Waldo",
    county_fips_all: 23027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04982",
    lat: 45.11443,
    lng: -70.40494,
    city: "Stratton",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 559,
    density: 4.9,
    county_fips: 23007,
    county_name: "Franklin",
    county_weights: {
      23007: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 23007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04983",
    lat: 44.92171,
    lng: -70.30599,
    city: "Strong",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1646,
    density: 4.1,
    county_fips: 23007,
    county_name: "Franklin",
    county_weights: {
      23007: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 23007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04984",
    lat: 44.69648,
    lng: -70.28054,
    city: "Temple",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 780,
    density: 8.5,
    county_fips: 23007,
    county_name: "Franklin",
    county_weights: {
      23007: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 23007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04985",
    lat: 45.3751,
    lng: -69.8746,
    city: "West Forks",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 95,
    density: 0.2,
    county_fips: 23025,
    county_name: "Somerset",
    county_weights: {
      23025: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 23025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04986",
    lat: 44.55286,
    lng: -69.22354,
    city: "Thorndike",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2120,
    density: 15.1,
    county_fips: 23027,
    county_name: "Waldo",
    county_weights: {
      23027: 100,
    },
    county_names_all: "Waldo",
    county_fips_all: 23027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04987",
    lat: 44.67915,
    lng: -69.25361,
    city: "Troy",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1160,
    density: 12.8,
    county_fips: 23027,
    county_name: "Waldo",
    county_weights: {
      23027: 100,
    },
    county_names_all: "Waldo",
    county_fips_all: 23027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04988",
    lat: 44.59588,
    lng: -69.35959,
    city: "Unity",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2079,
    density: 16.1,
    county_fips: 23027,
    county_name: "Waldo",
    county_weights: {
      23011: 20.11,
      23027: 79.89,
    },
    county_names_all: "Waldo|Kennebec",
    county_fips_all: "23027|23011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04989",
    lat: 44.4299,
    lng: -69.64784,
    city: "Vassalboro",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4146,
    density: 36.2,
    county_fips: 23011,
    county_name: "Kennebec",
    county_weights: {
      23011: 100,
    },
    county_names_all: "Kennebec",
    county_fips_all: 23011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "04992",
    lat: 44.65983,
    lng: -70.15584,
    city: "West Farmington",
    state_id: "ME",
    state_name: "Maine",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 23007,
    county_name: "Franklin",
    county_weights: {
      23007: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 23007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05001",
    lat: 43.67309,
    lng: -72.37943,
    city: "White River Junction",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9317,
    density: 84.2,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50027: 100,
    },
    county_names_all: "Windsor",
    county_fips_all: 50027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05009",
    lat: 43.64769,
    lng: -72.34395,
    city: "White River Junction",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50027: 100,
    },
    county_names_all: "Windsor",
    county_fips_all: 50027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05030",
    lat: 43.39989,
    lng: -72.40981,
    city: "Ascutney",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50027: 100,
    },
    county_names_all: "Windsor",
    county_fips_all: 50027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05031",
    lat: 43.72361,
    lng: -72.5872,
    city: "Barnard",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 97,
    density: 15,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50027: 100,
    },
    county_names_all: "Windsor",
    county_fips_all: 50027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05032",
    lat: 43.80193,
    lng: -72.65708,
    city: "Bethel",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2823,
    density: 16,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50027: 100,
    },
    county_names_all: "Windsor",
    county_fips_all: 50027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05033",
    lat: 44.00229,
    lng: -72.16412,
    city: "Bradford",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2517,
    density: 26.4,
    county_fips: 50017,
    county_name: "Orange",
    county_weights: {
      50017: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 50017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05034",
    lat: 43.58921,
    lng: -72.62178,
    city: "Bridgewater",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 218,
    density: 23.9,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50027: 100,
    },
    county_names_all: "Windsor",
    county_fips_all: 50027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05035",
    lat: 43.61723,
    lng: -72.67998,
    city: "Bridgewater Corners",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 654,
    density: 6.2,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50021: 0.59,
      50027: 99.41,
    },
    county_names_all: "Windsor|Rutland",
    county_fips_all: "50027|50021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05036",
    lat: 44.026,
    lng: -72.57843,
    city: "Brookfield",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1139,
    density: 14.3,
    county_fips: 50017,
    county_name: "Orange",
    county_weights: {
      50017: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 50017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05037",
    lat: 43.46033,
    lng: -72.48371,
    city: "Brownsville",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 900,
    density: 27.1,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50027: 100,
    },
    county_names_all: "Windsor",
    county_fips_all: 50027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05038",
    lat: 43.99313,
    lng: -72.45859,
    city: "Chelsea",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1304,
    density: 11.5,
    county_fips: 50017,
    county_name: "Orange",
    county_weights: {
      50017: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 50017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05039",
    lat: 44.03407,
    lng: -72.2975,
    city: "Corinth",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1272,
    density: 12.1,
    county_fips: 50017,
    county_name: "Orange",
    county_weights: {
      50017: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 50017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05040",
    lat: 44.06796,
    lng: -72.20438,
    city: "East Corinth",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 628,
    density: 21.1,
    county_fips: 50017,
    county_name: "Orange",
    county_weights: {
      50017: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 50017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05041",
    lat: 43.96702,
    lng: -72.54264,
    city: "East Randolph",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 433,
    density: 29.9,
    county_fips: 50017,
    county_name: "Orange",
    county_weights: {
      50017: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 50017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05042",
    lat: 44.24013,
    lng: -72.1053,
    city: "East Ryegate",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 492,
    density: 7.1,
    county_fips: 50005,
    county_name: "Caledonia",
    county_weights: {
      50005: 100,
    },
    county_names_all: "Caledonia",
    county_fips_all: 50005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05043",
    lat: 43.80658,
    lng: -72.21194,
    city: "East Thetford",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1018,
    density: 43.4,
    county_fips: 50017,
    county_name: "Orange",
    county_weights: {
      50017: 99.84,
      50027: 0.16,
    },
    county_names_all: "Orange|Windsor",
    county_fips_all: "50017|50027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05045",
    lat: 43.9144,
    lng: -72.19881,
    city: "Fairlee",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1997,
    density: 17.9,
    county_fips: 50017,
    county_name: "Orange",
    county_weights: {
      50017: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 50017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05046",
    lat: 44.23864,
    lng: -72.25024,
    city: "Groton",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1133,
    density: 7,
    county_fips: 50005,
    county_name: "Caledonia",
    county_weights: {
      50005: 100,
    },
    county_names_all: "Caledonia",
    county_fips_all: 50005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05048",
    lat: 43.5798,
    lng: -72.42692,
    city: "Hartland",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2938,
    density: 38.3,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50027: 100,
    },
    county_names_all: "Windsor",
    county_fips_all: 50027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05050",
    lat: 44.26442,
    lng: -72.06414,
    city: "McIndoe Falls",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 138,
    density: 160.3,
    county_fips: 50005,
    county_name: "Caledonia",
    county_weights: {
      50005: 100,
    },
    county_names_all: "Caledonia",
    county_fips_all: 50005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05051",
    lat: 44.08525,
    lng: -72.11753,
    city: "Newbury",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1445,
    density: 17.4,
    county_fips: 50017,
    county_name: "Orange",
    county_weights: {
      50017: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 50017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05052",
    lat: 43.6008,
    lng: -72.35698,
    city: "North Hartland",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 283,
    density: 47.1,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50027: 100,
    },
    county_names_all: "Windsor",
    county_fips_all: 50027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05053",
    lat: 43.71799,
    lng: -72.48362,
    city: "North Pomfret",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 281,
    density: 13.9,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50027: 100,
    },
    county_names_all: "Windsor",
    county_fips_all: 50027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05055",
    lat: 43.75481,
    lng: -72.31145,
    city: "Norwich",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3264,
    density: 31.4,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50027: 100,
    },
    county_names_all: "Windsor",
    county_fips_all: 50027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05056",
    lat: 43.52895,
    lng: -72.72397,
    city: "Plymouth",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 407,
    density: 3.9,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50021: 0.62,
      50027: 99.38,
    },
    county_names_all: "Windsor|Rutland",
    county_fips_all: "50027|50021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05058",
    lat: 43.87917,
    lng: -72.26999,
    city: "Post Mills",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 344,
    density: 44.8,
    county_fips: 50017,
    county_name: "Orange",
    county_weights: {
      50017: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 50017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05059",
    lat: 43.64233,
    lng: -72.43061,
    city: "Quechee",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 441,
    density: 30.3,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50027: 100,
    },
    county_names_all: "Windsor",
    county_fips_all: 50027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05060",
    lat: 43.96199,
    lng: -72.68594,
    city: "Randolph",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4177,
    density: 21.2,
    county_fips: 50017,
    county_name: "Orange",
    county_weights: {
      50017: 81.87,
      50023: 6.18,
      50027: 11.95,
    },
    county_names_all: "Orange|Windsor|Washington",
    county_fips_all: "50017|50027|50023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05061",
    lat: 43.93023,
    lng: -72.58087,
    city: "Randolph Center",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1562,
    density: 21.6,
    county_fips: 50017,
    county_name: "Orange",
    county_weights: {
      50017: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 50017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05062",
    lat: 43.5012,
    lng: -72.58358,
    city: "Reading",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 463,
    density: 5,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50027: 100,
    },
    county_names_all: "Windsor",
    county_fips_all: 50027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05065",
    lat: 43.79079,
    lng: -72.41617,
    city: "Sharon",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1061,
    density: 14.7,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50017: 5.08,
      50027: 94.92,
    },
    county_names_all: "Windsor|Orange",
    county_fips_all: "50027|50017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05067",
    lat: 43.69162,
    lng: -72.53944,
    city: "South Pomfret",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 188,
    density: 6.4,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50027: 100,
    },
    county_names_all: "Windsor",
    county_fips_all: 50027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05068",
    lat: 43.79188,
    lng: -72.52931,
    city: "South Royalton",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2997,
    density: 19.5,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50017: 0.31,
      50027: 99.69,
    },
    county_names_all: "Windsor|Orange",
    county_fips_all: "50027|50017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05069",
    lat: 44.17366,
    lng: -72.14317,
    city: "South Ryegate",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 591,
    density: 13,
    county_fips: 50017,
    county_name: "Orange",
    county_weights: {
      50005: 39.55,
      50017: 60.45,
    },
    county_names_all: "Orange|Caledonia",
    county_fips_all: "50017|50005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05070",
    lat: 43.84225,
    lng: -72.35099,
    city: "South Strafford",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 484,
    density: 17.5,
    county_fips: 50017,
    county_name: "Orange",
    county_weights: {
      50017: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 50017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05071",
    lat: 43.56461,
    lng: -72.56842,
    city: "South Woodstock",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 149,
    density: 4,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50027: 100,
    },
    county_names_all: "Windsor",
    county_fips_all: 50027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05072",
    lat: 43.88132,
    lng: -72.38545,
    city: "Strafford",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 591,
    density: 9,
    county_fips: 50017,
    county_name: "Orange",
    county_weights: {
      50017: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 50017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05073",
    lat: 43.62901,
    lng: -72.46108,
    city: "Taftsville",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50027: 100,
    },
    county_names_all: "Windsor",
    county_fips_all: 50027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05075",
    lat: 43.84356,
    lng: -72.28255,
    city: "Thetford Center",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 941,
    density: 11.9,
    county_fips: 50017,
    county_name: "Orange",
    county_weights: {
      50017: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 50017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05076",
    lat: 44.14503,
    lng: -72.22659,
    city: "Topsham",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 327,
    density: 4.6,
    county_fips: 50017,
    county_name: "Orange",
    county_weights: {
      50017: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 50017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05077",
    lat: 43.89961,
    lng: -72.47789,
    city: "Tunbridge",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1186,
    density: 11.9,
    county_fips: 50017,
    county_name: "Orange",
    county_weights: {
      50017: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 50017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05079",
    lat: 43.95622,
    lng: -72.32214,
    city: "Vershire",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 715,
    density: 7.8,
    county_fips: 50017,
    county_name: "Orange",
    county_weights: {
      50017: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 50017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05081",
    lat: 44.14292,
    lng: -72.08451,
    city: "Wells River",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 492,
    density: 9.8,
    county_fips: 50017,
    county_name: "Orange",
    county_weights: {
      50005: 16.48,
      50017: 83.52,
    },
    county_names_all: "Orange|Caledonia",
    county_fips_all: "50017|50005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05083",
    lat: 43.9184,
    lng: -72.26782,
    city: "West Fairlee",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 200,
    density: 97.7,
    county_fips: 50017,
    county_name: "Orange",
    county_weights: {
      50017: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 50017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05084",
    lat: 43.72791,
    lng: -72.45177,
    city: "West Hartford",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51,
    density: 8.8,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50027: 100,
    },
    county_names_all: "Windsor",
    county_fips_all: 50027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05086",
    lat: 44.1182,
    lng: -72.30249,
    city: "West Topsham",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 599,
    density: 7.9,
    county_fips: 50017,
    county_name: "Orange",
    county_weights: {
      50005: 0.11,
      50017: 99.89,
    },
    county_names_all: "Orange|Caledonia",
    county_fips_all: "50017|50005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05088",
    lat: 43.67332,
    lng: -72.30726,
    city: "Wilder",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50027: 100,
    },
    county_names_all: "Windsor",
    county_fips_all: 50027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05089",
    lat: 43.49686,
    lng: -72.4515,
    city: "Windsor",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3992,
    density: 35.2,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50027: 100,
    },
    county_names_all: "Windsor",
    county_fips_all: 50027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05091",
    lat: 43.64707,
    lng: -72.55165,
    city: "Woodstock",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3605,
    density: 20.6,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50027: 100,
    },
    county_names_all: "Windsor",
    county_fips_all: 50027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05101",
    lat: 43.1783,
    lng: -72.48333,
    city: "Bellows Falls",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4324,
    density: 59.9,
    county_fips: 50025,
    county_name: "Windham",
    county_weights: {
      50025: 100,
    },
    county_names_all: "Windham",
    county_fips_all: 50025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05141",
    lat: 43.15615,
    lng: -72.55929,
    city: "Cambridgeport",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 206,
    density: 203.5,
    county_fips: 50025,
    county_name: "Windham",
    county_weights: {
      50025: 100,
    },
    county_names_all: "Windham",
    county_fips_all: 50025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05142",
    lat: 43.40454,
    lng: -72.58457,
    city: "Cavendish",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 714,
    density: 10.3,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50027: 100,
    },
    county_names_all: "Windsor",
    county_fips_all: 50027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05143",
    lat: 43.26267,
    lng: -72.63095,
    city: "Chester",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4113,
    density: 13.9,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50025: 22.86,
      50027: 77.14,
    },
    county_names_all: "Windsor|Windham",
    county_fips_all: "50027|50025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05146",
    lat: 43.17867,
    lng: -72.62307,
    city: "Grafton",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 531,
    density: 4.9,
    county_fips: 50025,
    county_name: "Windham",
    county_weights: {
      50025: 100,
    },
    county_names_all: "Windham",
    county_fips_all: 50025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05148",
    lat: 43.24503,
    lng: -72.81224,
    city: "Londonderry",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1223,
    density: 17.6,
    county_fips: 50025,
    county_name: "Windham",
    county_weights: {
      50003: 34.85,
      50025: 63.82,
      50027: 1.32,
    },
    county_names_all: "Windham|Bennington|Windsor",
    county_fips_all: "50025|50003|50027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05149",
    lat: 43.40368,
    lng: -72.7029,
    city: "Ludlow",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1885,
    density: 17.2,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50027: 100,
    },
    county_names_all: "Windsor",
    county_fips_all: 50027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05150",
    lat: 43.33653,
    lng: -72.52727,
    city: "North Springfield",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 701,
    density: 133.8,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50027: 100,
    },
    county_names_all: "Windsor",
    county_fips_all: 50027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05151",
    lat: 43.39374,
    lng: -72.49566,
    city: "Perkinsville",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1466,
    density: 23.8,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50027: 100,
    },
    county_names_all: "Windsor",
    county_fips_all: 50027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05152",
    lat: 43.251,
    lng: -72.92008,
    city: "Peru",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 445,
    density: 4.7,
    county_fips: 50003,
    county_name: "Bennington",
    county_weights: {
      50003: 100,
    },
    county_names_all: "Bennington",
    county_fips_all: 50003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05153",
    lat: 43.42885,
    lng: -72.63487,
    city: "Proctorsville",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 588,
    density: 11.1,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50027: 100,
    },
    county_names_all: "Windsor",
    county_fips_all: 50027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05154",
    lat: 43.13558,
    lng: -72.53424,
    city: "Saxtons River",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 575,
    density: 90.5,
    county_fips: 50025,
    county_name: "Windham",
    county_weights: {
      50025: 100,
    },
    county_names_all: "Windham",
    county_fips_all: 50025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05155",
    lat: 43.17717,
    lng: -72.8228,
    city: "South Londonderry",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 770,
    density: 14.1,
    county_fips: 50025,
    county_name: "Windham",
    county_weights: {
      50025: 100,
    },
    county_names_all: "Windham",
    county_fips_all: 50025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05156",
    lat: 43.30719,
    lng: -72.46928,
    city: "Springfield",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9300,
    density: 58.8,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50027: 100,
    },
    county_names_all: "Windsor",
    county_fips_all: 50027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05158",
    lat: 43.10299,
    lng: -72.47296,
    city: "Westminster",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1136,
    density: 42.7,
    county_fips: 50025,
    county_name: "Windham",
    county_weights: {
      50025: 100,
    },
    county_names_all: "Windham",
    county_fips_all: 50025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05161",
    lat: 43.3166,
    lng: -72.8067,
    city: "Weston",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 629,
    density: 6.9,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50021: 0.12,
      50027: 99.88,
    },
    county_names_all: "Windsor|Rutland",
    county_fips_all: "50027|50021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05201",
    lat: 42.87652,
    lng: -73.1426,
    city: "Bennington",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14147,
    density: 55.1,
    county_fips: 50003,
    county_name: "Bennington",
    county_weights: {
      50003: 100,
    },
    county_names_all: "Bennington",
    county_fips_all: 50003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05250",
    lat: 43.12048,
    lng: -73.19337,
    city: "Arlington",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3625,
    density: 15.3,
    county_fips: 50003,
    county_name: "Bennington",
    county_weights: {
      50003: 100,
    },
    county_names_all: "Bennington",
    county_fips_all: 50003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05251",
    lat: 43.26189,
    lng: -73.08269,
    city: "Dorset",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1115,
    density: 10.3,
    county_fips: 50003,
    county_name: "Bennington",
    county_weights: {
      50003: 99.76,
      50021: 0.24,
    },
    county_names_all: "Bennington|Rutland",
    county_fips_all: "50003|50021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05252",
    lat: 43.06642,
    lng: -73.06132,
    city: "East Arlington",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 326,
    density: 3.2,
    county_fips: 50003,
    county_name: "Bennington",
    county_weights: {
      50003: 99.33,
      50025: 0.67,
    },
    county_names_all: "Bennington|Windham",
    county_fips_all: "50003|50025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05253",
    lat: 43.25235,
    lng: -72.99913,
    city: "East Dorset",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 483,
    density: 14.1,
    county_fips: 50003,
    county_name: "Bennington",
    county_weights: {
      50003: 94.83,
      50021: 5.17,
    },
    county_names_all: "Bennington|Rutland",
    county_fips_all: "50003|50021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05254",
    lat: 43.15937,
    lng: -73.06911,
    city: "Manchester",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 148,
    density: 22.8,
    county_fips: 50003,
    county_name: "Bennington",
    county_weights: {
      50003: 100,
    },
    county_names_all: "Bennington",
    county_fips_all: 50003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05255",
    lat: 43.16696,
    lng: -73.06685,
    city: "Manchester Center",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4091,
    density: 41,
    county_fips: 50003,
    county_name: "Bennington",
    county_weights: {
      50003: 100,
    },
    county_names_all: "Bennington",
    county_fips_all: 50003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05257",
    lat: 42.96538,
    lng: -73.25156,
    city: "North Bennington",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2750,
    density: 60.4,
    county_fips: 50003,
    county_name: "Bennington",
    county_weights: {
      50003: 100,
    },
    county_names_all: "Bennington",
    county_fips_all: 50003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05260",
    lat: 42.81594,
    lng: -73.26173,
    city: "North Pownal",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 593,
    density: 39.6,
    county_fips: 50003,
    county_name: "Bennington",
    county_weights: {
      50003: 100,
    },
    county_names_all: "Bennington",
    county_fips_all: 50003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05261",
    lat: 42.77516,
    lng: -73.21273,
    city: "Pownal",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2441,
    density: 32.5,
    county_fips: 50003,
    county_name: "Bennington",
    county_weights: {
      50003: 100,
    },
    county_names_all: "Bennington",
    county_fips_all: 50003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05262",
    lat: 42.97935,
    lng: -73.12066,
    city: "Shaftsbury",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2241,
    density: 12,
    county_fips: 50003,
    county_name: "Bennington",
    county_weights: {
      50003: 100,
    },
    county_names_all: "Bennington",
    county_fips_all: 50003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05301",
    lat: 42.84346,
    lng: -72.65901,
    city: "Brattleboro",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16037,
    density: 42.9,
    county_fips: 50025,
    county_name: "Windham",
    county_weights: {
      50025: 100,
    },
    county_names_all: "Windham",
    county_fips_all: 50025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05340",
    lat: 43.16215,
    lng: -72.93486,
    city: "Bondville",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 781,
    density: 6.9,
    county_fips: 50003,
    county_name: "Bennington",
    county_weights: {
      50003: 100,
    },
    county_names_all: "Bennington",
    county_fips_all: 50003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05341",
    lat: 42.96407,
    lng: -72.7972,
    city: "East Dover",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 558,
    density: 16.3,
    county_fips: 50025,
    county_name: "Windham",
    county_weights: {
      50025: 100,
    },
    county_names_all: "Windham",
    county_fips_all: 50025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05342",
    lat: 42.77468,
    lng: -72.80015,
    city: "Jacksonville",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 466,
    density: 10.3,
    county_fips: 50025,
    county_name: "Windham",
    county_weights: {
      50025: 100,
    },
    county_names_all: "Windham",
    county_fips_all: 50025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05343",
    lat: 43.09744,
    lng: -72.80105,
    city: "Jamaica",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 779,
    density: 6.5,
    county_fips: 50025,
    county_name: "Windham",
    county_weights: {
      50025: 100,
    },
    county_names_all: "Windham",
    county_fips_all: 50025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05344",
    lat: 42.83896,
    lng: -72.73257,
    city: "Marlboro",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 50025,
    county_name: "Windham",
    county_weights: {
      50025: 100,
    },
    county_names_all: "Windham",
    county_fips_all: 50025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05345",
    lat: 42.99516,
    lng: -72.66747,
    city: "Newfane",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2018,
    density: 19.8,
    county_fips: 50025,
    county_name: "Windham",
    county_weights: {
      50025: 100,
    },
    county_names_all: "Windham",
    county_fips_all: 50025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05346",
    lat: 43.02337,
    lng: -72.53043,
    city: "Putney",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4942,
    density: 27.2,
    county_fips: 50025,
    county_name: "Windham",
    county_weights: {
      50025: 100,
    },
    county_names_all: "Windham",
    county_fips_all: 50025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05350",
    lat: 42.79879,
    lng: -72.97187,
    city: "Readsboro",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 672,
    density: 7.1,
    county_fips: 50003,
    county_name: "Bennington",
    county_weights: {
      50003: 99.43,
      50025: 0.57,
    },
    county_names_all: "Bennington|Windham",
    county_fips_all: "50003|50025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05351",
    lat: 42.92867,
    lng: -72.73728,
    city: "South Newfane",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 50025,
    county_name: "Windham",
    county_weights: {
      50025: 100,
    },
    county_names_all: "Windham",
    county_fips_all: 50025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05352",
    lat: 42.78796,
    lng: -73.07862,
    city: "Stamford",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 897,
    density: 8.8,
    county_fips: 50003,
    county_name: "Bennington",
    county_weights: {
      50003: 100,
    },
    county_names_all: "Bennington",
    county_fips_all: 50003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05353",
    lat: 43.06501,
    lng: -72.66484,
    city: "Townshend",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1146,
    density: 12.3,
    county_fips: 50025,
    county_name: "Windham",
    county_weights: {
      50025: 100,
    },
    county_names_all: "Windham",
    county_fips_all: 50025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05354",
    lat: 42.76211,
    lng: -72.52553,
    city: "Vernon",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2392,
    density: 48,
    county_fips: 50025,
    county_name: "Windham",
    county_weights: {
      50025: 100,
    },
    county_names_all: "Windham",
    county_fips_all: 50025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05355",
    lat: 43.02079,
    lng: -72.80645,
    city: "Wardsboro",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 719,
    density: 10.2,
    county_fips: 50025,
    county_name: "Windham",
    county_weights: {
      50025: 100,
    },
    county_names_all: "Windham",
    county_fips_all: 50025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05356",
    lat: 42.95423,
    lng: -72.86952,
    city: "West Dover",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 482,
    density: 8.4,
    county_fips: 50025,
    county_name: "Windham",
    county_weights: {
      50025: 100,
    },
    county_names_all: "Windham",
    county_fips_all: 50025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05358",
    lat: 42.77396,
    lng: -72.73164,
    city: "West Halifax",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 139,
    density: 3.6,
    county_fips: 50025,
    county_name: "Windham",
    county_weights: {
      50025: 100,
    },
    county_names_all: "Windham",
    county_fips_all: 50025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05359",
    lat: 43.15184,
    lng: -72.72121,
    city: "West Townshend",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 585,
    density: 7.7,
    county_fips: 50025,
    county_name: "Windham",
    county_weights: {
      50025: 100,
    },
    county_names_all: "Windham",
    county_fips_all: 50025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05360",
    lat: 43.02778,
    lng: -72.94378,
    city: "West Wardsboro",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 287,
    density: 1.6,
    county_fips: 50025,
    county_name: "Windham",
    county_weights: {
      50003: 0.33,
      50025: 99.67,
    },
    county_names_all: "Windham|Bennington",
    county_fips_all: "50025|50003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05361",
    lat: 42.78021,
    lng: -72.87935,
    city: "Whitingham",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1076,
    density: 14.7,
    county_fips: 50025,
    county_name: "Windham",
    county_weights: {
      50025: 100,
    },
    county_names_all: "Windham",
    county_fips_all: 50025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05362",
    lat: 42.94609,
    lng: -72.6816,
    city: "Williamsville",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 113,
    density: 6.7,
    county_fips: 50025,
    county_name: "Windham",
    county_weights: {
      50025: 100,
    },
    county_names_all: "Windham",
    county_fips_all: 50025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05363",
    lat: 42.88301,
    lng: -72.89554,
    city: "Wilmington",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1917,
    density: 11.8,
    county_fips: 50025,
    county_name: "Windham",
    county_weights: {
      50003: 32.8,
      50025: 67.2,
    },
    county_names_all: "Windham|Bennington",
    county_fips_all: "50025|50003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05401",
    lat: 44.47484,
    lng: -73.21758,
    city: "Burlington",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30152,
    density: 1907.6,
    county_fips: 50007,
    county_name: "Chittenden",
    county_weights: {
      50007: 100,
    },
    county_names_all: "Chittenden",
    county_fips_all: 50007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05403",
    lat: 44.447,
    lng: -73.17229,
    city: "South Burlington",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18919,
    density: 446.1,
    county_fips: 50007,
    county_name: "Chittenden",
    county_weights: {
      50007: 100,
    },
    county_names_all: "Chittenden",
    county_fips_all: 50007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05404",
    lat: 44.49483,
    lng: -73.18467,
    city: "Winooski",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7320,
    density: 2023.3,
    county_fips: 50007,
    county_name: "Chittenden",
    county_weights: {
      50007: 100,
    },
    county_names_all: "Chittenden",
    county_fips_all: 50007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05405",
    lat: 44.47475,
    lng: -73.19649,
    city: "Burlington",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3469,
    density: 6784.9,
    county_fips: 50007,
    county_name: "Chittenden",
    county_weights: {
      50007: 100,
    },
    county_names_all: "Chittenden",
    county_fips_all: 50007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05408",
    lat: 44.48969,
    lng: -73.27139,
    city: "Burlington",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9430,
    density: 901.7,
    county_fips: 50007,
    county_name: "Chittenden",
    county_weights: {
      50007: 100,
    },
    county_names_all: "Chittenden",
    county_fips_all: 50007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05439",
    lat: 44.49573,
    lng: -73.16524,
    city: "Colchester",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1450,
    density: 3852.1,
    county_fips: 50007,
    county_name: "Chittenden",
    county_weights: {
      50007: 100,
    },
    county_names_all: "Chittenden",
    county_fips_all: 50007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05440",
    lat: 44.95214,
    lng: -73.2848,
    city: "Alburgh",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1801,
    density: 23.9,
    county_fips: 50013,
    county_name: "Grand Isle",
    county_weights: {
      50013: 100,
    },
    county_names_all: "Grand Isle",
    county_fips_all: 50013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05441",
    lat: 44.7686,
    lng: -72.78669,
    city: "Bakersfield",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 844,
    density: 26.9,
    county_fips: 50011,
    county_name: "Franklin",
    county_weights: {
      50011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 50011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05442",
    lat: 44.76164,
    lng: -72.68043,
    city: "Belvidere Center",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 400,
    density: 4.3,
    county_fips: 50015,
    county_name: "Lamoille",
    county_weights: {
      50015: 100,
    },
    county_names_all: "Lamoille",
    county_fips_all: 50015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05443",
    lat: 44.12976,
    lng: -73.03347,
    city: "Bristol",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6947,
    density: 24.8,
    county_fips: 50001,
    county_name: "Addison",
    county_weights: {
      50001: 100,
    },
    county_names_all: "Addison",
    county_fips_all: 50001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05444",
    lat: 44.62628,
    lng: -72.88242,
    city: "Cambridge",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1373,
    density: 18.9,
    county_fips: 50015,
    county_name: "Lamoille",
    county_weights: {
      50007: 0.86,
      50011: 39.07,
      50015: 60.07,
    },
    county_names_all: "Lamoille|Franklin|Chittenden",
    county_fips_all: "50015|50011|50007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05445",
    lat: 44.30896,
    lng: -73.23593,
    city: "Charlotte",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3817,
    density: 35.7,
    county_fips: 50007,
    county_name: "Chittenden",
    county_weights: {
      50007: 100,
    },
    county_names_all: "Chittenden",
    county_fips_all: 50007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05446",
    lat: 44.5541,
    lng: -73.21647,
    city: "Colchester",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15827,
    density: 167.1,
    county_fips: 50007,
    county_name: "Chittenden",
    county_weights: {
      50007: 100,
    },
    county_names_all: "Chittenden",
    county_fips_all: 50007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05447",
    lat: 44.93615,
    lng: -72.70447,
    city: "East Berkshire",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 86,
    density: 33.6,
    county_fips: 50011,
    county_name: "Franklin",
    county_weights: {
      50011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 50011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05448",
    lat: 44.75374,
    lng: -72.8872,
    city: "East Fairfield",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 936,
    density: 9.6,
    county_fips: 50011,
    county_name: "Franklin",
    county_weights: {
      50011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 50011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05450",
    lat: 44.89075,
    lng: -72.79074,
    city: "Enosburg Falls",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5073,
    density: 13.8,
    county_fips: 50011,
    county_name: "Franklin",
    county_weights: {
      50011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 50011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05452",
    lat: 44.5238,
    lng: -73.06479,
    city: "Essex Junction",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22021,
    density: 210.7,
    county_fips: 50007,
    county_name: "Chittenden",
    county_weights: {
      50007: 100,
    },
    county_names_all: "Chittenden",
    county_fips_all: 50007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05454",
    lat: 44.7056,
    lng: -73.02294,
    city: "Fairfax",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5156,
    density: 41.4,
    county_fips: 50011,
    county_name: "Franklin",
    county_weights: {
      50011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 50011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05455",
    lat: 44.80352,
    lng: -72.96568,
    city: "Fairfield",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1307,
    density: 13.9,
    county_fips: 50011,
    county_name: "Franklin",
    county_weights: {
      50011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 50011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05456",
    lat: 44.20776,
    lng: -73.25796,
    city: "Ferrisburgh",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1136,
    density: 19.1,
    county_fips: 50001,
    county_name: "Addison",
    county_weights: {
      50001: 100,
    },
    county_names_all: "Addison",
    county_fips_all: 50001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05457",
    lat: 44.97294,
    lng: -72.91832,
    city: "Franklin",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1823,
    density: 18.6,
    county_fips: 50011,
    county_name: "Franklin",
    county_weights: {
      50011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 50011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05458",
    lat: 44.71838,
    lng: -73.29837,
    city: "Grand Isle",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2133,
    density: 49,
    county_fips: 50013,
    county_name: "Grand Isle",
    county_weights: {
      50011: 0.62,
      50013: 99.38,
    },
    county_names_all: "Grand Isle|Franklin",
    county_fips_all: "50013|50011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05459",
    lat: 44.95568,
    lng: -73.01861,
    city: "Highgate Center",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2035,
    density: 35,
    county_fips: 50011,
    county_name: "Franklin",
    county_weights: {
      50011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 50011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05461",
    lat: 44.32094,
    lng: -73.09176,
    city: "Hinesburg",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4645,
    density: 42.8,
    county_fips: 50007,
    county_name: "Chittenden",
    county_weights: {
      50001: 6.25,
      50007: 93.75,
    },
    county_names_all: "Chittenden|Addison",
    county_fips_all: "50007|50001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05462",
    lat: 44.29909,
    lng: -72.95228,
    city: "Huntington",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1850,
    density: 18.9,
    county_fips: 50007,
    county_name: "Chittenden",
    county_weights: {
      50001: 0.12,
      50007: 99.71,
      50023: 0.17,
    },
    county_names_all: "Chittenden|Washington|Addison",
    county_fips_all: "50007|50023|50001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05463",
    lat: 44.86297,
    lng: -73.34254,
    city: "Isle La Motte",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 450,
    density: 22,
    county_fips: 50013,
    county_name: "Grand Isle",
    county_weights: {
      50013: 100,
    },
    county_names_all: "Grand Isle",
    county_fips_all: 50013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05464",
    lat: 44.65469,
    lng: -72.81897,
    city: "Jeffersonville",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3263,
    density: 22.4,
    county_fips: 50015,
    county_name: "Lamoille",
    county_weights: {
      50011: 24.61,
      50015: 75.39,
    },
    county_names_all: "Lamoille|Franklin",
    county_fips_all: "50015|50011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05465",
    lat: 44.45882,
    lng: -72.93058,
    city: "Jericho",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5306,
    density: 35,
    county_fips: 50007,
    county_name: "Chittenden",
    county_weights: {
      50007: 100,
    },
    county_names_all: "Chittenden",
    county_fips_all: 50007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05468",
    lat: 44.65378,
    lng: -73.15343,
    city: "Milton",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13678,
    density: 84.5,
    county_fips: 50007,
    county_name: "Chittenden",
    county_weights: {
      50007: 84.07,
      50011: 15.81,
      50013: 0.12,
    },
    county_names_all: "Chittenden|Franklin|Grand Isle",
    county_fips_all: "50007|50011|50013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05471",
    lat: 44.85739,
    lng: -72.58942,
    city: "Montgomery Center",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 656,
    density: 5.2,
    county_fips: 50011,
    county_name: "Franklin",
    county_weights: {
      50011: 92.3,
      50019: 7.7,
    },
    county_names_all: "Franklin|Orleans",
    county_fips_all: "50011|50019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05472",
    lat: 44.11377,
    lng: -73.1611,
    city: "New Haven",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1777,
    density: 16,
    county_fips: 50001,
    county_name: "Addison",
    county_weights: {
      50001: 100,
    },
    county_names_all: "Addison",
    county_fips_all: 50001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05473",
    lat: 44.24119,
    lng: -73.19346,
    city: "North Ferrisburgh",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1351,
    density: 26.6,
    county_fips: 50001,
    county_name: "Addison",
    county_weights: {
      50001: 100,
    },
    county_names_all: "Addison",
    county_fips_all: 50001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05474",
    lat: 44.83445,
    lng: -73.26687,
    city: "North Hero",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1018,
    density: 29.2,
    county_fips: 50013,
    county_name: "Grand Isle",
    county_weights: {
      50013: 100,
    },
    county_names_all: "Grand Isle",
    county_fips_all: 50013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05476",
    lat: 44.96055,
    lng: -72.6457,
    city: "Richford",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3226,
    density: 19.4,
    county_fips: 50011,
    county_name: "Franklin",
    county_weights: {
      50011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 50011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05477",
    lat: 44.3936,
    lng: -72.99152,
    city: "Richmond",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4481,
    density: 51.8,
    county_fips: 50007,
    county_name: "Chittenden",
    county_weights: {
      50007: 100,
    },
    county_names_all: "Chittenden",
    county_fips_all: 50007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05478",
    lat: 44.7941,
    lng: -73.11714,
    city: "Saint Albans",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15173,
    density: 98.8,
    county_fips: 50011,
    county_name: "Franklin",
    county_weights: {
      50011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 50011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05481",
    lat: 44.80833,
    lng: -73.1396,
    city: "Saint Albans Bay",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 50011,
    county_name: "Franklin",
    county_weights: {
      50011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 50011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05482",
    lat: 44.39057,
    lng: -73.24134,
    city: "Shelburne",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7741,
    density: 122.9,
    county_fips: 50007,
    county_name: "Chittenden",
    county_weights: {
      50007: 100,
    },
    county_names_all: "Chittenden",
    county_fips_all: 50007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05483",
    lat: 44.88322,
    lng: -72.98484,
    city: "Sheldon",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1515,
    density: 26.7,
    county_fips: 50011,
    county_name: "Franklin",
    county_weights: {
      50011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 50011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05485",
    lat: 44.90405,
    lng: -72.97567,
    city: "Sheldon Springs",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 108,
    density: 2540.5,
    county_fips: 50011,
    county_name: "Franklin",
    county_weights: {
      50011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 50011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05486",
    lat: 44.62958,
    lng: -73.31444,
    city: "South Hero",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1641,
    density: 43.6,
    county_fips: 50013,
    county_name: "Grand Isle",
    county_weights: {
      50007: 2.42,
      50013: 97.58,
    },
    county_names_all: "Grand Isle|Chittenden",
    county_fips_all: "50013|50007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05487",
    lat: 44.23082,
    lng: -73.01096,
    city: "Starksboro",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1504,
    density: 12.5,
    county_fips: 50001,
    county_name: "Addison",
    county_weights: {
      50001: 89.4,
      50007: 10.6,
    },
    county_names_all: "Addison|Chittenden",
    county_fips_all: "50001|50007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05488",
    lat: 44.92214,
    lng: -73.14286,
    city: "Swanton",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7763,
    density: 44.8,
    county_fips: 50011,
    county_name: "Franklin",
    county_weights: {
      50011: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 50011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05489",
    lat: 44.5458,
    lng: -72.89471,
    city: "Underhill",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3510,
    density: 23,
    county_fips: 50007,
    county_name: "Chittenden",
    county_weights: {
      50007: 100,
    },
    county_names_all: "Chittenden",
    county_fips_all: 50007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05491",
    lat: 44.12101,
    lng: -73.32111,
    city: "Vergennes",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5919,
    density: 26.1,
    county_fips: 50001,
    county_name: "Addison",
    county_weights: {
      50001: 100,
    },
    county_names_all: "Addison",
    county_fips_all: 50001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05492",
    lat: 44.71324,
    lng: -72.75853,
    city: "Waterville",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 740,
    density: 16.3,
    county_fips: 50015,
    county_name: "Lamoille",
    county_weights: {
      50011: 2.32,
      50015: 97.68,
    },
    county_names_all: "Lamoille|Franklin",
    county_fips_all: "50015|50011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05494",
    lat: 44.60472,
    lng: -73.01523,
    city: "Westford",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1657,
    density: 23,
    county_fips: 50007,
    county_name: "Chittenden",
    county_weights: {
      50007: 100,
    },
    county_names_all: "Chittenden",
    county_fips_all: 50007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05495",
    lat: 44.42901,
    lng: -73.09197,
    city: "Williston",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10584,
    density: 119.3,
    county_fips: 50007,
    county_name: "Chittenden",
    county_weights: {
      50007: 100,
    },
    county_names_all: "Chittenden",
    county_fips_all: 50007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05602",
    lat: 44.2848,
    lng: -72.61498,
    city: "Montpelier",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11724,
    density: 51.5,
    county_fips: 50023,
    county_name: "Washington",
    county_weights: {
      50023: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 50023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05640",
    lat: 44.34734,
    lng: -72.49675,
    city: "Adamant",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 309,
    density: 49.2,
    county_fips: 50023,
    county_name: "Washington",
    county_weights: {
      50023: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 50023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05641",
    lat: 44.18602,
    lng: -72.45108,
    city: "Barre",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16326,
    density: 93.9,
    county_fips: 50023,
    county_name: "Washington",
    county_weights: {
      50005: 0.11,
      50017: 38.34,
      50023: 61.55,
    },
    county_names_all: "Washington|Orange|Caledonia",
    county_fips_all: "50023|50017|50005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05647",
    lat: 44.41001,
    lng: -72.29126,
    city: "Cabot",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1155,
    density: 16.4,
    county_fips: 50023,
    county_name: "Washington",
    county_weights: {
      50005: 0.11,
      50023: 99.89,
    },
    county_names_all: "Washington|Caledonia",
    county_fips_all: "50023|50005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05648",
    lat: 44.38372,
    lng: -72.49355,
    city: "Calais",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 429,
    density: 17.9,
    county_fips: 50023,
    county_name: "Washington",
    county_weights: {
      50023: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 50023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05649",
    lat: 44.14004,
    lng: -72.36589,
    city: "East Barre",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 390,
    density: 29.8,
    county_fips: 50017,
    county_name: "Orange",
    county_weights: {
      50017: 91.16,
      50023: 8.84,
    },
    county_names_all: "Orange|Washington",
    county_fips_all: "50017|50023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05650",
    lat: 44.4002,
    lng: -72.44235,
    city: "East Calais",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1095,
    density: 17.8,
    county_fips: 50023,
    county_name: "Washington",
    county_weights: {
      50023: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 50023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05651",
    lat: 44.27777,
    lng: -72.49246,
    city: "East Montpelier",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1421,
    density: 32.6,
    county_fips: 50023,
    county_name: "Washington",
    county_weights: {
      50023: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 50023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05652",
    lat: 44.72824,
    lng: -72.58674,
    city: "Eden",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 610,
    density: 7.5,
    county_fips: 50015,
    county_name: "Lamoille",
    county_weights: {
      50011: 0.1,
      50015: 99.62,
      50019: 0.28,
    },
    county_names_all: "Lamoille|Orleans|Franklin",
    county_fips_all: "50015|50019|50011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05653",
    lat: 44.70141,
    lng: -72.49275,
    city: "Eden Mills",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 644,
    density: 7.9,
    county_fips: 50015,
    county_name: "Lamoille",
    county_weights: {
      50015: 99.75,
      50019: 0.25,
    },
    county_names_all: "Lamoille|Orleans",
    county_fips_all: "50015|50019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05654",
    lat: 44.14053,
    lng: -72.48092,
    city: "Graniteville",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1122,
    density: 90.3,
    county_fips: 50017,
    county_name: "Orange",
    county_weights: {
      50017: 51.41,
      50023: 48.59,
    },
    county_names_all: "Orange|Washington",
    county_fips_all: "50017|50023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05655",
    lat: 44.62461,
    lng: -72.56462,
    city: "Hyde Park",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2930,
    density: 30,
    county_fips: 50015,
    county_name: "Lamoille",
    county_weights: {
      50015: 100,
    },
    county_names_all: "Lamoille",
    county_fips_all: 50015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05656",
    lat: 44.64898,
    lng: -72.68825,
    city: "Johnson",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3625,
    density: 29.6,
    county_fips: 50015,
    county_name: "Lamoille",
    county_weights: {
      50015: 100,
    },
    county_names_all: "Lamoille",
    county_fips_all: 50015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05658",
    lat: 44.35921,
    lng: -72.35399,
    city: "Marshfield",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1592,
    density: 15.9,
    county_fips: 50023,
    county_name: "Washington",
    county_weights: {
      50023: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 50023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05660",
    lat: 44.24733,
    lng: -72.76808,
    city: "Moretown",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1566,
    density: 16.1,
    county_fips: 50023,
    county_name: "Washington",
    county_weights: {
      50023: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 50023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05661",
    lat: 44.53743,
    lng: -72.61724,
    city: "Morrisville",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6013,
    density: 35.6,
    county_fips: 50015,
    county_name: "Lamoille",
    county_weights: {
      50015: 100,
    },
    county_names_all: "Lamoille",
    county_fips_all: 50015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05663",
    lat: 44.14946,
    lng: -72.67239,
    city: "Northfield",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6847,
    density: 43.5,
    county_fips: 50023,
    county_name: "Washington",
    county_weights: {
      50017: 2.78,
      50023: 97.22,
    },
    county_names_all: "Washington|Orange",
    county_fips_all: "50023|50017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05664",
    lat: 44.16718,
    lng: -72.65316,
    city: "Northfield Falls",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46,
    density: 1066.7,
    county_fips: 50023,
    county_name: "Washington",
    county_weights: {
      50023: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 50023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05666",
    lat: 44.34125,
    lng: -72.43873,
    city: "North Montpelier",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 50023,
    county_name: "Washington",
    county_weights: {
      50023: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 50023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05667",
    lat: 44.28122,
    lng: -72.3986,
    city: "Plainfield",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1939,
    density: 15.1,
    county_fips: 50023,
    county_name: "Washington",
    county_weights: {
      50005: 0.13,
      50023: 99.87,
    },
    county_names_all: "Washington|Caledonia",
    county_fips_all: "50023|50005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05669",
    lat: 44.05325,
    lng: -72.75155,
    city: "Roxbury",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 891,
    density: 7.1,
    county_fips: 50023,
    county_name: "Washington",
    county_weights: {
      50001: 22.83,
      50017: 7.42,
      50023: 69.75,
    },
    county_names_all: "Washington|Addison|Orange",
    county_fips_all: "50023|50001|50017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05670",
    lat: 44.17799,
    lng: -72.50558,
    city: "South Barre",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 50023,
    county_name: "Washington",
    county_weights: {
      50023: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 50023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05672",
    lat: 44.48151,
    lng: -72.72174,
    city: "Stowe",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4447,
    density: 23.6,
    county_fips: 50015,
    county_name: "Lamoille",
    county_weights: {
      50015: 99.87,
      50023: 0.13,
    },
    county_names_all: "Lamoille|Washington",
    county_fips_all: "50015|50023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05673",
    lat: 44.19371,
    lng: -72.84356,
    city: "Waitsfield",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2414,
    density: 17.6,
    county_fips: 50023,
    county_name: "Washington",
    county_weights: {
      50023: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 50023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05674",
    lat: 44.11112,
    lng: -72.86081,
    city: "Warren",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1688,
    density: 16.3,
    county_fips: 50023,
    county_name: "Washington",
    county_weights: {
      50001: 0.51,
      50023: 99.49,
    },
    county_names_all: "Washington|Addison",
    county_fips_all: "50023|50001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05675",
    lat: 44.07386,
    lng: -72.41821,
    city: "Washington",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1192,
    density: 12.4,
    county_fips: 50017,
    county_name: "Orange",
    county_weights: {
      50017: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 50017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05676",
    lat: 44.34825,
    lng: -72.80984,
    city: "Waterbury",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4686,
    density: 19.3,
    county_fips: 50023,
    county_name: "Washington",
    county_weights: {
      50007: 20.49,
      50023: 79.51,
    },
    county_names_all: "Washington|Chittenden",
    county_fips_all: "50023|50007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05677",
    lat: 44.39194,
    lng: -72.70841,
    city: "Waterbury Center",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2330,
    density: 57.3,
    county_fips: 50023,
    county_name: "Washington",
    county_weights: {
      50023: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 50023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05678",
    lat: 44.15577,
    lng: -72.47445,
    city: "Websterville",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 251,
    density: 119.2,
    county_fips: 50023,
    county_name: "Washington",
    county_weights: {
      50023: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 50023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05679",
    lat: 44.10677,
    lng: -72.54052,
    city: "Williamstown",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3323,
    density: 33.4,
    county_fips: 50017,
    county_name: "Orange",
    county_weights: {
      50017: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 50017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05680",
    lat: 44.53785,
    lng: -72.46838,
    city: "Wolcott",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2104,
    density: 12.5,
    county_fips: 50015,
    county_name: "Lamoille",
    county_weights: {
      50015: 97.13,
      50023: 2.87,
    },
    county_names_all: "Lamoille|Washington",
    county_fips_all: "50015|50023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05681",
    lat: 44.45377,
    lng: -72.38016,
    city: "Woodbury",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 373,
    density: 10.7,
    county_fips: 50023,
    county_name: "Washington",
    county_weights: {
      50023: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 50023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05682",
    lat: 44.40354,
    lng: -72.57219,
    city: "Worcester",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1284,
    density: 10.9,
    county_fips: 50023,
    county_name: "Washington",
    county_weights: {
      50015: 0.1,
      50023: 99.9,
    },
    county_names_all: "Washington|Lamoille",
    county_fips_all: "50023|50015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05701",
    lat: 43.63365,
    lng: -72.91368,
    city: "Rutland",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19722,
    density: 112.4,
    county_fips: 50021,
    county_name: "Rutland",
    county_weights: {
      50021: 100,
    },
    county_names_all: "Rutland",
    county_fips_all: 50021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05730",
    lat: 43.40262,
    lng: -72.81508,
    city: "Belmont",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 279,
    density: 5.4,
    county_fips: 50021,
    county_name: "Rutland",
    county_weights: {
      50021: 100,
    },
    county_names_all: "Rutland",
    county_fips_all: 50021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05731",
    lat: 43.7532,
    lng: -73.28857,
    city: "Benson",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 50021,
    county_name: "Rutland",
    county_weights: {
      50021: 100,
    },
    county_names_all: "Rutland",
    county_fips_all: 50021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05732",
    lat: 43.67998,
    lng: -73.18648,
    city: "Bomoseen",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 984,
    density: 34.8,
    county_fips: 50021,
    county_name: "Rutland",
    county_weights: {
      50021: 100,
    },
    county_names_all: "Rutland",
    county_fips_all: 50021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05733",
    lat: 43.81746,
    lng: -73.09216,
    city: "Brandon",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6035,
    density: 21.6,
    county_fips: 50021,
    county_name: "Rutland",
    county_weights: {
      50001: 39.55,
      50021: 60.45,
    },
    county_names_all: "Rutland|Addison",
    county_fips_all: "50021|50001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05734",
    lat: 43.98243,
    lng: -73.33286,
    city: "Bridport",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1228,
    density: 11,
    county_fips: 50001,
    county_name: "Addison",
    county_weights: {
      50001: 100,
    },
    county_names_all: "Addison",
    county_fips_all: 50001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05735",
    lat: 43.64475,
    lng: -73.15456,
    city: "Castleton",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3944,
    density: 34.4,
    county_fips: 50021,
    county_name: "Rutland",
    county_weights: {
      50021: 100,
    },
    county_names_all: "Rutland",
    county_fips_all: 50021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05736",
    lat: 43.60483,
    lng: -73.01273,
    city: "Center Rutland",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 528,
    density: 60.3,
    county_fips: 50021,
    county_name: "Rutland",
    county_weights: {
      50021: 100,
    },
    county_names_all: "Rutland",
    county_fips_all: 50021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05737",
    lat: 43.76778,
    lng: -72.90434,
    city: "Chittenden",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 951,
    density: 7.6,
    county_fips: 50021,
    county_name: "Rutland",
    county_weights: {
      50021: 100,
    },
    county_names_all: "Rutland",
    county_fips_all: 50021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05738",
    lat: 43.52895,
    lng: -72.85637,
    city: "Cuttingsville",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1274,
    density: 9.7,
    county_fips: 50021,
    county_name: "Rutland",
    county_weights: {
      50021: 99.84,
      50027: 0.16,
    },
    county_names_all: "Rutland|Windsor",
    county_fips_all: "50021|50027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05739",
    lat: 43.34488,
    lng: -73.0295,
    city: "Danby",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1291,
    density: 10.6,
    county_fips: 50021,
    county_name: "Rutland",
    county_weights: {
      50021: 100,
    },
    county_names_all: "Rutland",
    county_fips_all: 50021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05742",
    lat: 43.43685,
    lng: -72.9045,
    city: "East Wallingford",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 599,
    density: 9.4,
    county_fips: 50021,
    county_name: "Rutland",
    county_weights: {
      50021: 100,
    },
    county_names_all: "Rutland",
    county_fips_all: 50021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05743",
    lat: 43.67118,
    lng: -73.30726,
    city: "Fair Haven",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3668,
    density: 14.3,
    county_fips: 50021,
    county_name: "Rutland",
    county_weights: {
      50021: 100,
    },
    county_names_all: "Rutland",
    county_fips_all: 50021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05744",
    lat: 43.69034,
    lng: -73.08272,
    city: "Florence",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 540,
    density: 8.1,
    county_fips: 50021,
    county_name: "Rutland",
    county_weights: {
      50021: 100,
    },
    county_names_all: "Rutland",
    county_fips_all: 50021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05746",
    lat: 43.72098,
    lng: -72.78836,
    city: "Gaysville",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50021: 1.49,
      50027: 98.51,
    },
    county_names_all: "Windsor|Rutland",
    county_fips_all: "50027|50021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05747",
    lat: 44.00354,
    lng: -72.85494,
    city: "Granville",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 352,
    density: 3.4,
    county_fips: 50001,
    county_name: "Addison",
    county_weights: {
      50001: 100,
    },
    county_names_all: "Addison",
    county_fips_all: 50001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05748",
    lat: 43.92004,
    lng: -72.91064,
    city: "Hancock",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 450,
    density: 4.5,
    county_fips: 50001,
    county_name: "Addison",
    county_weights: {
      50001: 100,
    },
    county_names_all: "Addison",
    county_fips_all: 50001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05751",
    lat: 43.6542,
    lng: -72.78941,
    city: "Killington",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 678,
    density: 5.6,
    county_fips: 50021,
    county_name: "Rutland",
    county_weights: {
      50021: 100,
    },
    county_names_all: "Rutland",
    county_fips_all: 50021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05753",
    lat: 43.9991,
    lng: -73.17403,
    city: "Middlebury",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10500,
    density: 48.4,
    county_fips: 50001,
    county_name: "Addison",
    county_weights: {
      50001: 100,
    },
    county_names_all: "Addison",
    county_fips_all: 50001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05757",
    lat: 43.48279,
    lng: -73.12325,
    city: "Middletown Springs",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 715,
    density: 11.2,
    county_fips: 50021,
    county_name: "Rutland",
    county_weights: {
      50021: 100,
    },
    county_names_all: "Rutland",
    county_fips_all: 50021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05758",
    lat: 43.44797,
    lng: -72.78386,
    city: "Mount Holly",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 624,
    density: 9.8,
    county_fips: 50021,
    county_name: "Rutland",
    county_weights: {
      50021: 100,
    },
    county_names_all: "Rutland",
    county_fips_all: 50021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05759",
    lat: 43.53926,
    lng: -72.96483,
    city: "North Clarendon",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1526,
    density: 29.9,
    county_fips: 50021,
    county_name: "Rutland",
    county_weights: {
      50021: 100,
    },
    county_names_all: "Rutland",
    county_fips_all: 50021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05760",
    lat: 43.80359,
    lng: -73.29517,
    city: "Orwell",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 873,
    density: 9.4,
    county_fips: 50001,
    county_name: "Addison",
    county_weights: {
      50001: 99.43,
      50021: 0.57,
    },
    county_names_all: "Addison|Rutland",
    county_fips_all: "50001|50021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05761",
    lat: 43.34786,
    lng: -73.14855,
    city: "Pawlet",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 817,
    density: 7.7,
    county_fips: 50021,
    county_name: "Rutland",
    county_weights: {
      50003: 21.17,
      50021: 78.83,
    },
    county_names_all: "Rutland|Bennington",
    county_fips_all: "50021|50003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05762",
    lat: 43.79246,
    lng: -72.8291,
    city: "Pittsfield",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 350,
    density: 6.7,
    county_fips: 50021,
    county_name: "Rutland",
    county_weights: {
      50021: 99.78,
      50027: 0.22,
    },
    county_names_all: "Rutland|Windsor",
    county_fips_all: "50021|50027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05763",
    lat: 43.73678,
    lng: -72.98946,
    city: "Pittsford",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2778,
    density: 29.6,
    county_fips: 50021,
    county_name: "Rutland",
    county_weights: {
      50021: 100,
    },
    county_names_all: "Rutland",
    county_fips_all: 50021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05764",
    lat: 43.52854,
    lng: -73.19401,
    city: "Poultney",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3251,
    density: 28.2,
    county_fips: 50021,
    county_name: "Rutland",
    county_weights: {
      50021: 100,
    },
    county_names_all: "Rutland",
    county_fips_all: 50021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05765",
    lat: 43.65068,
    lng: -73.03648,
    city: "Proctor",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1763,
    density: 95.1,
    county_fips: 50021,
    county_name: "Rutland",
    county_weights: {
      50021: 100,
    },
    county_names_all: "Rutland",
    county_fips_all: 50021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05766",
    lat: 43.98833,
    lng: -72.99072,
    city: "Ripton",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 437,
    density: 3.4,
    county_fips: 50001,
    county_name: "Addison",
    county_weights: {
      50001: 100,
    },
    county_names_all: "Addison",
    county_fips_all: 50001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05767",
    lat: 43.87513,
    lng: -72.82878,
    city: "Rochester",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1120,
    density: 7.6,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50001: 0.12,
      50021: 0.72,
      50027: 99.16,
    },
    county_names_all: "Windsor|Rutland|Addison",
    county_fips_all: "50027|50021|50001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05768",
    lat: 43.29846,
    lng: -73.22168,
    city: "Rupert",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 50003,
    county_name: "Bennington",
    county_weights: {
      50003: 100,
    },
    county_names_all: "Bennington",
    county_fips_all: 50003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05769",
    lat: 43.91948,
    lng: -73.11651,
    city: "Salisbury",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1206,
    density: 15.1,
    county_fips: 50001,
    county_name: "Addison",
    county_weights: {
      50001: 100,
    },
    county_names_all: "Addison",
    county_fips_all: 50001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05770",
    lat: 43.88662,
    lng: -73.32771,
    city: "Shoreham",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1061,
    density: 9.8,
    county_fips: 50001,
    county_name: "Addison",
    county_weights: {
      50001: 100,
    },
    county_names_all: "Addison",
    county_fips_all: 50001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05772",
    lat: 43.75989,
    lng: -72.74003,
    city: "Stockbridge",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 679,
    density: 6.4,
    county_fips: 50027,
    county_name: "Windsor",
    county_weights: {
      50021: 0.84,
      50027: 99.16,
    },
    county_names_all: "Windsor|Rutland",
    county_fips_all: "50027|50021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05773",
    lat: 43.40902,
    lng: -72.96858,
    city: "Wallingford",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2619,
    density: 13.4,
    county_fips: 50021,
    county_name: "Rutland",
    county_weights: {
      50021: 100,
    },
    county_names_all: "Rutland",
    county_fips_all: 50021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05774",
    lat: 43.42708,
    lng: -73.17435,
    city: "Wells",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1011,
    density: 14.1,
    county_fips: 50021,
    county_name: "Rutland",
    county_weights: {
      50021: 100,
    },
    county_names_all: "Rutland",
    county_fips_all: 50021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05775",
    lat: 43.35437,
    lng: -73.22804,
    city: "West Pawlet",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 641,
    density: 15.1,
    county_fips: 50021,
    county_name: "Rutland",
    county_weights: {
      50003: 7.63,
      50021: 92.37,
    },
    county_names_all: "Rutland|Bennington",
    county_fips_all: "50021|50003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05776",
    lat: 43.24494,
    lng: -73.20392,
    city: "West Rupert",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 661,
    density: 10.9,
    county_fips: 50003,
    county_name: "Bennington",
    county_weights: {
      50003: 100,
    },
    county_names_all: "Bennington",
    county_fips_all: 50003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05777",
    lat: 43.5552,
    lng: -73.05504,
    city: "West Rutland",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3245,
    density: 28.1,
    county_fips: 50021,
    county_name: "Rutland",
    county_weights: {
      50021: 100,
    },
    county_names_all: "Rutland",
    county_fips_all: 50021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05778",
    lat: 43.87279,
    lng: -73.21228,
    city: "Whiting",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 762,
    density: 11.2,
    county_fips: 50001,
    county_name: "Addison",
    county_weights: {
      50001: 92.42,
      50021: 7.58,
    },
    county_names_all: "Addison|Rutland",
    county_fips_all: "50001|50021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05819",
    lat: 44.40397,
    lng: -71.98837,
    city: "Saint Johnsbury",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8980,
    density: 39.1,
    county_fips: 50005,
    county_name: "Caledonia",
    county_weights: {
      50005: 100,
    },
    county_names_all: "Caledonia",
    county_fips_all: 50005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05820",
    lat: 44.74862,
    lng: -72.37351,
    city: "Albany",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 434,
    density: 12.5,
    county_fips: 50019,
    county_name: "Orleans",
    county_weights: {
      50019: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 50019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05821",
    lat: 44.3175,
    lng: -72.10866,
    city: "Barnet",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1181,
    density: 14.5,
    county_fips: 50005,
    county_name: "Caledonia",
    county_weights: {
      50005: 100,
    },
    county_names_all: "Caledonia",
    county_fips_all: 50005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05822",
    lat: 44.75555,
    lng: -72.15478,
    city: "Barton",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1289,
    density: 11.7,
    county_fips: 50019,
    county_name: "Orleans",
    county_weights: {
      50005: 0.69,
      50019: 99.31,
    },
    county_names_all: "Orleans|Caledonia",
    county_fips_all: "50019|50005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05824",
    lat: 44.43741,
    lng: -71.86449,
    city: "Concord",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1090,
    density: 8.2,
    county_fips: 50009,
    county_name: "Essex",
    county_weights: {
      50005: 31.02,
      50009: 68.98,
    },
    county_names_all: "Essex|Caledonia",
    county_fips_all: "50009|50005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05825",
    lat: 44.86019,
    lng: -72.25664,
    city: "Coventry",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 95,
    density: 37.3,
    county_fips: 50019,
    county_name: "Orleans",
    county_weights: {
      50019: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 50019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05826",
    lat: 44.6444,
    lng: -72.40404,
    city: "Craftsbury",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 801,
    density: 10.7,
    county_fips: 50019,
    county_name: "Orleans",
    county_weights: {
      50019: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 50019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05827",
    lat: 44.68135,
    lng: -72.36198,
    city: "Craftsbury Common",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 304,
    density: 7,
    county_fips: 50019,
    county_name: "Orleans",
    county_weights: {
      50019: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 50019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05828",
    lat: 44.43748,
    lng: -72.12334,
    city: "Danville",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2025,
    density: 14,
    county_fips: 50005,
    county_name: "Caledonia",
    county_weights: {
      50005: 100,
    },
    county_names_all: "Caledonia",
    county_fips_all: 50005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05829",
    lat: 44.95349,
    lng: -72.0759,
    city: "Derby",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1889,
    density: 30.6,
    county_fips: 50019,
    county_name: "Orleans",
    county_weights: {
      50019: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 50019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05830",
    lat: 44.97717,
    lng: -71.98278,
    city: "Derby Line",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1170,
    density: 13.5,
    county_fips: 50019,
    county_name: "Orleans",
    county_weights: {
      50019: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 50019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05832",
    lat: 44.59546,
    lng: -71.91027,
    city: "East Burke",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1079,
    density: 16.6,
    county_fips: 50005,
    county_name: "Caledonia",
    county_weights: {
      50005: 99.7,
      50009: 0.3,
    },
    county_names_all: "Caledonia|Essex",
    county_fips_all: "50005|50009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05833",
    lat: 44.83182,
    lng: -71.96965,
    city: "East Charleston",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 138,
    density: 46.8,
    county_fips: 50019,
    county_name: "Orleans",
    county_weights: {
      50009: 0.11,
      50019: 99.89,
    },
    county_names_all: "Orleans|Essex",
    county_fips_all: "50019|50009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05836",
    lat: 44.5196,
    lng: -72.25173,
    city: "East Hardwick",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1311,
    density: 15.4,
    county_fips: 50005,
    county_name: "Caledonia",
    county_weights: {
      50005: 100,
    },
    county_names_all: "Caledonia",
    county_fips_all: 50005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05837",
    lat: 44.66868,
    lng: -71.8386,
    city: "East Haven",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 347,
    density: 2.7,
    county_fips: 50009,
    county_name: "Essex",
    county_weights: {
      50005: 24.97,
      50009: 75.03,
    },
    county_names_all: "Essex|Caledonia",
    county_fips_all: "50009|50005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05839",
    lat: 44.67342,
    lng: -72.21171,
    city: "Glover",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 802,
    density: 13,
    county_fips: 50019,
    county_name: "Orleans",
    county_weights: {
      50005: 1.36,
      50019: 98.64,
    },
    county_names_all: "Orleans|Caledonia",
    county_fips_all: "50019|50005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05840",
    lat: 44.61297,
    lng: -71.73129,
    city: "Granby",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 50009,
    county_name: "Essex",
    county_weights: {
      50009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 50009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05841",
    lat: 44.60794,
    lng: -72.30232,
    city: "Greensboro",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 377,
    density: 6,
    county_fips: 50019,
    county_name: "Orleans",
    county_weights: {
      50019: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 50019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05842",
    lat: 44.57966,
    lng: -72.24453,
    city: "Greensboro Bend",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 462,
    density: 9.8,
    county_fips: 50019,
    county_name: "Orleans",
    county_weights: {
      50005: 34.63,
      50019: 65.37,
    },
    county_names_all: "Orleans|Caledonia",
    county_fips_all: "50019|50005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05843",
    lat: 44.50355,
    lng: -72.33366,
    city: "Hardwick",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2253,
    density: 18.7,
    county_fips: 50005,
    county_name: "Caledonia",
    county_weights: {
      50005: 87.71,
      50023: 12.29,
    },
    county_names_all: "Caledonia|Washington",
    county_fips_all: "50005|50023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05845",
    lat: 44.79146,
    lng: -72.30699,
    city: "Irasburg",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1481,
    density: 13.3,
    county_fips: 50019,
    county_name: "Orleans",
    county_weights: {
      50019: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 50019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05846",
    lat: 44.82671,
    lng: -71.82795,
    city: "Island Pond",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1173,
    density: 4.4,
    county_fips: 50009,
    county_name: "Essex",
    county_weights: {
      50009: 93.51,
      50019: 6.49,
    },
    county_names_all: "Essex|Orleans",
    county_fips_all: "50009|50019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05847",
    lat: 44.79165,
    lng: -72.45679,
    city: "Lowell",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 965,
    density: 6.6,
    county_fips: 50019,
    county_name: "Orleans",
    county_weights: {
      50019: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 50019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05850",
    lat: 44.55955,
    lng: -72.03417,
    city: "Lyndon Center",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 249,
    density: 68.8,
    county_fips: 50005,
    county_name: "Caledonia",
    county_weights: {
      50005: 100,
    },
    county_names_all: "Caledonia",
    county_fips_all: 50005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05851",
    lat: 44.55297,
    lng: -72.05732,
    city: "Lyndonville",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6212,
    density: 29.3,
    county_fips: 50005,
    county_name: "Caledonia",
    county_weights: {
      50005: 100,
    },
    county_names_all: "Caledonia",
    county_fips_all: 50005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05853",
    lat: 44.89499,
    lng: -71.96167,
    city: "Morgan",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 625,
    density: 8.3,
    county_fips: 50019,
    county_name: "Orleans",
    county_weights: {
      50019: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 50019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05855",
    lat: 44.92829,
    lng: -72.1943,
    city: "Newport",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6819,
    density: 44.5,
    county_fips: 50019,
    county_name: "Orleans",
    county_weights: {
      50019: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 50019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05857",
    lat: 44.93381,
    lng: -72.3092,
    city: "Newport Center",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2724,
    density: 26.4,
    county_fips: 50019,
    county_name: "Orleans",
    county_weights: {
      50019: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 50019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05858",
    lat: 44.53587,
    lng: -71.8046,
    city: "North Concord",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 417,
    density: 2.5,
    county_fips: 50009,
    county_name: "Essex",
    county_weights: {
      50005: 0.1,
      50009: 99.9,
    },
    county_names_all: "Essex|Caledonia",
    county_fips_all: "50009|50005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05859",
    lat: 44.95987,
    lng: -72.43833,
    city: "North Troy",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1815,
    density: 11.3,
    county_fips: 50019,
    county_name: "Orleans",
    county_weights: {
      50019: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 50019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05860",
    lat: 44.80018,
    lng: -72.10353,
    city: "Orleans",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2686,
    density: 13.5,
    county_fips: 50019,
    county_name: "Orleans",
    county_weights: {
      50019: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 50019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05862",
    lat: 44.31971,
    lng: -72.23133,
    city: "Peacham",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 451,
    density: 7.3,
    county_fips: 50005,
    county_name: "Caledonia",
    county_weights: {
      50005: 99.81,
      50023: 0.19,
    },
    county_names_all: "Caledonia|Washington",
    county_fips_all: "50005|50023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05866",
    lat: 44.63863,
    lng: -72.12699,
    city: "Sheffield",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 678,
    density: 7.6,
    county_fips: 50005,
    county_name: "Caledonia",
    county_weights: {
      50005: 99.83,
      50019: 0.17,
    },
    county_names_all: "Caledonia|Orleans",
    county_fips_all: "50005|50019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05867",
    lat: 44.66505,
    lng: -72.04366,
    city: "Sutton",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 896,
    density: 10,
    county_fips: 50005,
    county_name: "Caledonia",
    county_weights: {
      50005: 100,
    },
    county_names_all: "Caledonia",
    county_fips_all: 50005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05868",
    lat: 44.91881,
    lng: -72.3675,
    city: "Troy",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 241,
    density: 20.6,
    county_fips: 50019,
    county_name: "Orleans",
    county_weights: {
      50019: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 50019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05871",
    lat: 44.68367,
    lng: -71.95193,
    city: "West Burke",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1335,
    density: 13.4,
    county_fips: 50005,
    county_name: "Caledonia",
    county_weights: {
      50005: 100,
    },
    county_names_all: "Caledonia",
    county_fips_all: 50005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05872",
    lat: 44.86059,
    lng: -72.03473,
    city: "West Charleston",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 830,
    density: 10.5,
    county_fips: 50019,
    county_name: "Orleans",
    county_weights: {
      50019: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 50019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05873",
    lat: 44.40619,
    lng: -72.21841,
    city: "West Danville",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 624,
    density: 9.3,
    county_fips: 50005,
    county_name: "Caledonia",
    county_weights: {
      50005: 94.67,
      50023: 5.33,
    },
    county_names_all: "Caledonia|Washington",
    county_fips_all: "50005|50023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05874",
    lat: 44.87546,
    lng: -72.46172,
    city: "Westfield",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 580,
    density: 5.7,
    county_fips: 50019,
    county_name: "Orleans",
    county_weights: {
      50019: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 50019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05875",
    lat: 44.70947,
    lng: -72.26753,
    city: "Barton",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 490,
    density: 8.3,
    county_fips: 50019,
    county_name: "Orleans",
    county_weights: {
      50019: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 50019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05901",
    lat: 44.94197,
    lng: -71.68079,
    city: "Averill",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17,
    density: 0.2,
    county_fips: 50009,
    county_name: "Essex",
    county_weights: {
      50009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 50009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05902",
    lat: 45.00881,
    lng: -71.49472,
    city: "Beecher Falls",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 174,
    density: 51.5,
    county_fips: 50009,
    county_name: "Essex",
    county_weights: {
      50009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 50009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05903",
    lat: 44.9379,
    lng: -71.58286,
    city: "Canaan",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 776,
    density: 4.8,
    county_fips: 50009,
    county_name: "Essex",
    county_weights: {
      50009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 50009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05904",
    lat: 44.41597,
    lng: -71.70762,
    city: "Gilman",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 192,
    density: 134.8,
    county_fips: 50009,
    county_name: "Essex",
    county_weights: {
      50009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 50009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05905",
    lat: 44.70151,
    lng: -71.66672,
    city: "Guildhall",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 880,
    density: 1.8,
    county_fips: 50009,
    county_name: "Essex",
    county_weights: {
      50009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 50009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05906",
    lat: 44.47431,
    lng: -71.71538,
    city: "Lunenburg",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1411,
    density: 11.2,
    county_fips: 50009,
    county_name: "Essex",
    county_weights: {
      50009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 50009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "05907",
    lat: 44.9502,
    lng: -71.82577,
    city: "Norton",
    state_id: "VT",
    state_name: "Vermont",
    zcta: "TRUE",
    parent_zcta: "",
    population: 109,
    density: 0.6,
    county_fips: 50009,
    county_name: "Essex",
    county_weights: {
      50009: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 50009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06001",
    lat: 41.79185,
    lng: -72.85107,
    city: "Avon",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18410,
    density: 290.7,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06002",
    lat: 41.84286,
    lng: -72.73714,
    city: "Bloomfield",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21128,
    density: 317.5,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06010",
    lat: 41.681,
    lng: -72.94065,
    city: "Bristol",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60039,
    density: 874.9,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06013",
    lat: 41.7598,
    lng: -72.95895,
    city: "Burlington",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9678,
    density: 125.8,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06016",
    lat: 41.90417,
    lng: -72.54438,
    city: "Broad Brook",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6769,
    density: 174.2,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06018",
    lat: 42.02872,
    lng: -73.29807,
    city: "Canaan",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2982,
    density: 86.8,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06019",
    lat: 41.8592,
    lng: -72.90717,
    city: "Canton",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10172,
    density: 174.3,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06020",
    lat: 41.86283,
    lng: -72.90991,
    city: "Canton Center",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06021",
    lat: 42.00152,
    lng: -73.08078,
    city: "Colebrook",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 350,
    density: 4.3,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06022",
    lat: 41.86595,
    lng: -72.92749,
    city: "Collinsville",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 102,
    density: 23.5,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06023",
    lat: 41.61355,
    lng: -72.72072,
    city: "East Berlin",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1632,
    density: 633.4,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 99.71,
      "09007": 0.29,
    },
    county_names_all: "Hartford|Middlesex",
    county_fips_all: "09003|09007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06024",
    lat: 42.00812,
    lng: -73.28374,
    city: "East Canaan",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 260,
    density: 16.4,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06026",
    lat: 41.94242,
    lng: -72.74093,
    city: "East Granby",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5370,
    density: 118.1,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06027",
    lat: 42.00403,
    lng: -72.91112,
    city: "East Hartland",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1378,
    density: 33.8,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06029",
    lat: 41.91439,
    lng: -72.4535,
    city: "Ellington",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16348,
    density: 192.9,
    county_fips: "09013",
    county_name: "Tolland",
    county_weights: {
      "09013": 100,
    },
    county_names_all: "Tolland",
    county_fips_all: "09013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06031",
    lat: 41.95788,
    lng: -73.31733,
    city: "Falls Village",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1328,
    density: 13.2,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06032",
    lat: 41.72528,
    lng: -72.83147,
    city: "Farmington",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17901,
    density: 299.4,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06033",
    lat: 41.70593,
    lng: -72.53915,
    city: "Glastonbury",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28738,
    density: 302,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06035",
    lat: 41.9608,
    lng: -72.80179,
    city: "Granby",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7977,
    density: 194.7,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06037",
    lat: 41.61148,
    lng: -72.7775,
    city: "Berlin",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18828,
    density: 285.4,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06039",
    lat: 41.95001,
    lng: -73.44379,
    city: "Lakeville",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1678,
    density: 30,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06040",
    lat: 41.7616,
    lng: -72.52247,
    city: "Manchester",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35553,
    density: 810.9,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06042",
    lat: 41.79743,
    lng: -72.52704,
    city: "Manchester",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22148,
    density: 816.2,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06043",
    lat: 41.76647,
    lng: -72.43903,
    city: "Bolton",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4902,
    density: 131.3,
    county_fips: "09013",
    county_name: "Tolland",
    county_weights: {
      "09013": 100,
    },
    county_names_all: "Tolland",
    county_fips_all: "09013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06051",
    lat: 41.66519,
    lng: -72.76983,
    city: "New Britain",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30618,
    density: 2880.7,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06052",
    lat: 41.65736,
    lng: -72.80506,
    city: "New Britain",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7852,
    density: 1169.2,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06053",
    lat: 41.68874,
    lng: -72.7941,
    city: "New Britain",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34142,
    density: 1658.5,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06057",
    lat: 41.84417,
    lng: -73.00552,
    city: "New Hartford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6209,
    density: 65.2,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06058",
    lat: 41.97186,
    lng: -73.1958,
    city: "Norfolk",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1637,
    density: 12.6,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06059",
    lat: 41.89054,
    lng: -72.88833,
    city: "North Canton",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06060",
    lat: 42.00687,
    lng: -72.84594,
    city: "North Granby",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2792,
    density: 92.6,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06061",
    lat: 41.87524,
    lng: -72.96716,
    city: "Pine Meadow",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 296,
    density: 695,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06062",
    lat: 41.67338,
    lng: -72.86079,
    city: "Plainville",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17605,
    density: 776.5,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06063",
    lat: 41.93053,
    lng: -72.97096,
    city: "Barkhamsted",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3199,
    density: 36,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06065",
    lat: 41.97795,
    lng: -73.00054,
    city: "Riverton",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 753,
    density: 36.3,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 76.26,
      "09005": 23.74,
    },
    county_names_all: "Hartford|Litchfield",
    county_fips_all: "09003|09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06066",
    lat: 41.83641,
    lng: -72.46063,
    city: "Vernon Rockville",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29300,
    density: 639.1,
    county_fips: "09013",
    county_name: "Tolland",
    county_weights: {
      "09013": 100,
    },
    county_names_all: "Tolland",
    county_fips_all: "09013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06067",
    lat: 41.6574,
    lng: -72.66259,
    city: "Rocky Hill",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20147,
    density: 585.2,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06068",
    lat: 42.01404,
    lng: -73.42121,
    city: "Salisbury",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1845,
    density: 24.1,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06069",
    lat: 41.85392,
    lng: -73.4448,
    city: "Sharon",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2394,
    density: 17.7,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06070",
    lat: 41.87674,
    lng: -72.81626,
    city: "Simsbury",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15277,
    density: 258.7,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06071",
    lat: 41.99489,
    lng: -72.45213,
    city: "Somers",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11019,
    density: 147.3,
    county_fips: "09013",
    county_name: "Tolland",
    county_weights: {
      "09013": 100,
    },
    county_names_all: "Tolland",
    county_fips_all: "09013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06072",
    lat: 41.98465,
    lng: -72.4876,
    city: "Somersville",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "09013",
    county_name: "Tolland",
    county_weights: {
      "09013": 100,
    },
    county_names_all: "Tolland",
    county_fips_all: "09013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06073",
    lat: 41.65753,
    lng: -72.56742,
    city: "South Glastonbury",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5756,
    density: 153.1,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06074",
    lat: 41.83528,
    lng: -72.57332,
    city: "South Windsor",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25962,
    density: 357.3,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06076",
    lat: 41.98906,
    lng: -72.26224,
    city: "Stafford Springs",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12547,
    density: 56,
    county_fips: "09013",
    county_name: "Tolland",
    county_weights: {
      "09013": 100,
    },
    county_names_all: "Tolland",
    county_fips_all: "09013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06078",
    lat: 41.98903,
    lng: -72.64875,
    city: "Suffield",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12299,
    density: 192.6,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06079",
    lat: 42.04174,
    lng: -73.39755,
    city: "Taconic",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06080",
    lat: 41.95044,
    lng: -72.63519,
    city: "Suffield",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06081",
    lat: 41.90708,
    lng: -72.76839,
    city: "Tariffville",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1810,
    density: 1084.3,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06082",
    lat: 41.98393,
    lng: -72.55475,
    city: "Enfield",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43952,
    density: 509.3,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06084",
    lat: 41.87917,
    lng: -72.36443,
    city: "Tolland",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14685,
    density: 141.5,
    county_fips: "09013",
    county_name: "Tolland",
    county_weights: {
      "09013": 100,
    },
    county_names_all: "Tolland",
    county_fips_all: "09013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06085",
    lat: 41.74717,
    lng: -72.88883,
    city: "Unionville",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7204,
    density: 618.5,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06088",
    lat: 41.9058,
    lng: -72.59646,
    city: "East Windsor",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4733,
    density: 162.4,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06089",
    lat: 41.83801,
    lng: -72.82343,
    city: "Weatogue",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3034,
    density: 403.8,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06090",
    lat: 41.94685,
    lng: -72.86403,
    city: "West Granby",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 658,
    density: 19.2,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06091",
    lat: 42.01419,
    lng: -72.97423,
    city: "West Hartland",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 101,
    density: 3.5,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06092",
    lat: 41.87266,
    lng: -72.86101,
    city: "West Simsbury",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4958,
    density: 257.8,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06093",
    lat: 42.00265,
    lng: -72.72285,
    city: "West Suffield",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3431,
    density: 75.7,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06095",
    lat: 41.87229,
    lng: -72.67348,
    city: "Windsor",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28829,
    density: 385.2,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06096",
    lat: 41.92671,
    lng: -72.65443,
    city: "Windsor Locks",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12732,
    density: 544.8,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06098",
    lat: 41.92379,
    lng: -73.10003,
    city: "Winsted",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11895,
    density: 149.6,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06103",
    lat: 41.76477,
    lng: -72.67012,
    city: "Hartford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1883,
    density: 1253.3,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06105",
    lat: 41.77322,
    lng: -72.70442,
    city: "Hartford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19892,
    density: 3388.7,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06106",
    lat: 41.74818,
    lng: -72.69683,
    city: "Hartford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38012,
    density: 3522.7,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06107",
    lat: 41.75375,
    lng: -72.75966,
    city: "West Hartford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20017,
    density: 1161.5,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06108",
    lat: 41.78078,
    lng: -72.62165,
    city: "East Hartford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23996,
    density: 1137.7,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06109",
    lat: 41.70131,
    lng: -72.67035,
    city: "Wethersfield",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26068,
    density: 818.1,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06110",
    lat: 41.73247,
    lng: -72.73378,
    city: "West Hartford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12560,
    density: 1490,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06111",
    lat: 41.68677,
    lng: -72.73057,
    city: "Newington",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30114,
    density: 892.4,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06112",
    lat: 41.79317,
    lng: -72.69741,
    city: "Hartford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19991,
    density: 2599.6,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06114",
    lat: 41.7394,
    lng: -72.66949,
    city: "Hartford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27823,
    density: 2656,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06117",
    lat: 41.7875,
    lng: -72.76203,
    city: "West Hartford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16593,
    density: 659.2,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06118",
    lat: 41.74871,
    lng: -72.60976,
    city: "East Hartford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26073,
    density: 1020.6,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06119",
    lat: 41.76351,
    lng: -72.72711,
    city: "West Hartford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14733,
    density: 2731.2,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06120",
    lat: 41.78944,
    lng: -72.66523,
    city: "Hartford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14192,
    density: 1551.9,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06226",
    lat: 41.70816,
    lng: -72.20731,
    city: "Willimantic",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19429,
    density: 1046.5,
    county_fips: "09015",
    county_name: "Windham",
    county_weights: {
      "09015": 97.84,
      "09013": 2.16,
    },
    county_names_all: "Windham|Tolland",
    county_fips_all: "09015|09013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06231",
    lat: 41.62512,
    lng: -72.37055,
    city: "Amston",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3548,
    density: 87.5,
    county_fips: "09013",
    county_name: "Tolland",
    county_weights: {
      "09013": 100,
    },
    county_names_all: "Tolland",
    county_fips_all: "09013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06232",
    lat: 41.73309,
    lng: -72.37603,
    city: "Andover",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3178,
    density: 79.4,
    county_fips: "09013",
    county_name: "Tolland",
    county_weights: {
      "09013": 100,
    },
    county_names_all: "Tolland",
    county_fips_all: "09013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06234",
    lat: 41.78938,
    lng: -71.95266,
    city: "Brooklyn",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8311,
    density: 104.7,
    county_fips: "09015",
    county_name: "Windham",
    county_weights: {
      "09015": 100,
    },
    county_names_all: "Windham",
    county_fips_all: "09015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06235",
    lat: 41.79292,
    lng: -72.1275,
    city: "Chaplin",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2538,
    density: 50.8,
    county_fips: "09015",
    county_name: "Windham",
    county_weights: {
      "09015": 100,
    },
    county_names_all: "Windham",
    county_fips_all: "09015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06237",
    lat: 41.69387,
    lng: -72.30722,
    city: "Columbia",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5428,
    density: 98.1,
    county_fips: "09013",
    county_name: "Tolland",
    county_weights: {
      "09013": 100,
    },
    county_names_all: "Tolland",
    county_fips_all: "09013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06238",
    lat: 41.78281,
    lng: -72.33941,
    city: "Coventry",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12408,
    density: 127.5,
    county_fips: "09013",
    county_name: "Tolland",
    county_weights: {
      "09013": 100,
    },
    county_names_all: "Tolland",
    county_fips_all: "09013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06239",
    lat: 41.79116,
    lng: -71.85711,
    city: "Danielson",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11356,
    density: 189.5,
    county_fips: "09015",
    county_name: "Windham",
    county_weights: {
      "09015": 100,
    },
    county_names_all: "Windham",
    county_fips_all: "09015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06241",
    lat: 41.85635,
    lng: -71.84904,
    city: "Dayville",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6155,
    density: 88.3,
    county_fips: "09015",
    county_name: "Windham",
    county_weights: {
      "09015": 100,
    },
    county_names_all: "Windham",
    county_fips_all: "09015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06242",
    lat: 41.89326,
    lng: -72.09706,
    city: "Eastford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1204,
    density: 18.7,
    county_fips: "09015",
    county_name: "Windham",
    county_weights: {
      "09015": 96.98,
      "09013": 3.02,
    },
    county_names_all: "Windham|Tolland",
    county_fips_all: "09015|09013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06243",
    lat: 41.84743,
    lng: -71.80701,
    city: "East Killingly",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 218,
    density: 116,
    county_fips: "09015",
    county_name: "Windham",
    county_weights: {
      "09015": 100,
    },
    county_names_all: "Windham",
    county_fips_all: "09015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06247",
    lat: 41.76829,
    lng: -72.06548,
    city: "Hampton",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2514,
    density: 29.1,
    county_fips: "09015",
    county_name: "Windham",
    county_weights: {
      "09015": 100,
    },
    county_names_all: "Windham",
    county_fips_all: "09015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06248",
    lat: 41.68468,
    lng: -72.40523,
    city: "Hebron",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5958,
    density: 108.3,
    county_fips: "09013",
    county_name: "Tolland",
    county_weights: {
      "09013": 100,
    },
    county_names_all: "Tolland",
    county_fips_all: "09013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06249",
    lat: 41.63128,
    lng: -72.24019,
    city: "Lebanon",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7175,
    density: 51.2,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 100,
    },
    county_names_all: "New London",
    county_fips_all: "09011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06250",
    lat: 41.77434,
    lng: -72.19669,
    city: "Mansfield Center",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5169,
    density: 119.4,
    county_fips: "09013",
    county_name: "Tolland",
    county_weights: {
      "09013": 99.33,
      "09015": 0.67,
    },
    county_names_all: "Tolland|Windham",
    county_fips_all: "09013|09015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06254",
    lat: 41.61585,
    lng: -72.14313,
    city: "North Franklin",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1837,
    density: 36,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 100,
    },
    county_names_all: "New London",
    county_fips_all: "09011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06255",
    lat: 41.98791,
    lng: -71.90299,
    city: "North Grosvenordale",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4335,
    density: 72.5,
    county_fips: "09015",
    county_name: "Windham",
    county_weights: {
      "09015": 100,
    },
    county_names_all: "Windham",
    county_fips_all: "09015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06256",
    lat: 41.73699,
    lng: -72.15723,
    city: "North Windham",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2235,
    density: 114.2,
    county_fips: "09015",
    county_name: "Windham",
    county_weights: {
      "09015": 99.89,
      "09013": 0.11,
    },
    county_names_all: "Windham|Tolland",
    county_fips_all: "09015|09013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06258",
    lat: 41.88554,
    lng: -71.96353,
    city: "Pomfret",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "09015",
    county_name: "Windham",
    county_weights: {
      "09015": 100,
    },
    county_names_all: "Windham",
    county_fips_all: "09015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06259",
    lat: 41.8703,
    lng: -71.99248,
    city: "Pomfret Center",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4469,
    density: 40.4,
    county_fips: "09015",
    county_name: "Windham",
    county_weights: {
      "09015": 100,
    },
    county_names_all: "Windham",
    county_fips_all: "09015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06260",
    lat: 41.90898,
    lng: -71.87181,
    city: "Putnam",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9359,
    density: 180.1,
    county_fips: "09015",
    county_name: "Windham",
    county_weights: {
      "09015": 100,
    },
    county_names_all: "Windham",
    county_fips_all: "09015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06262",
    lat: 42.01871,
    lng: -71.94959,
    city: "Quinebaug",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 780,
    density: 260.7,
    county_fips: "09015",
    county_name: "Windham",
    county_weights: {
      "09015": 100,
    },
    county_names_all: "Windham",
    county_fips_all: "09015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06263",
    lat: 41.83738,
    lng: -71.90444,
    city: "Rogers",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 306,
    density: 769.3,
    county_fips: "09015",
    county_name: "Windham",
    county_weights: {
      "09015": 100,
    },
    county_names_all: "Windham",
    county_fips_all: "09015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06264",
    lat: 41.69869,
    lng: -72.10487,
    city: "Scotland",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 137,
    density: 34.9,
    county_fips: "09015",
    county_name: "Windham",
    county_weights: {
      "09015": 100,
    },
    county_names_all: "Windham",
    county_fips_all: "09015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06266",
    lat: 41.67136,
    lng: -72.17048,
    city: "South Windham",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 448,
    density: 187,
    county_fips: "09015",
    county_name: "Windham",
    county_weights: {
      "09015": 100,
    },
    county_names_all: "Windham",
    county_fips_all: "09015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06268",
    lat: 41.79852,
    lng: -72.24843,
    city: "Storrs Mansfield",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10598,
    density: 153.7,
    county_fips: "09013",
    county_name: "Tolland",
    county_weights: {
      "09013": 100,
    },
    county_names_all: "Tolland",
    county_fips_all: "09013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06269",
    lat: 41.80998,
    lng: -72.25283,
    city: "Storrs Mansfield",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9573,
    density: 2951.3,
    county_fips: "09013",
    county_name: "Tolland",
    county_weights: {
      "09013": 100,
    },
    county_names_all: "Tolland",
    county_fips_all: "09013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06277",
    lat: 41.96895,
    lng: -71.83927,
    city: "Thompson",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4145,
    density: 69.8,
    county_fips: "09015",
    county_name: "Windham",
    county_weights: {
      "09015": 100,
    },
    county_names_all: "Windham",
    county_fips_all: "09015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06278",
    lat: 41.89126,
    lng: -72.17003,
    city: "Ashford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4396,
    density: 42.9,
    county_fips: "09015",
    county_name: "Windham",
    county_weights: {
      "09015": 100,
    },
    county_names_all: "Windham",
    county_fips_all: "09015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06279",
    lat: 41.88959,
    lng: -72.25933,
    city: "Willington",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5876,
    density: 68.1,
    county_fips: "09013",
    county_name: "Tolland",
    county_weights: {
      "09013": 100,
    },
    county_names_all: "Tolland",
    county_fips_all: "09013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06280",
    lat: 41.69237,
    lng: -72.13829,
    city: "Windham",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3002,
    density: 76.9,
    county_fips: "09015",
    county_name: "Windham",
    county_weights: {
      "09015": 100,
    },
    county_names_all: "Windham",
    county_fips_all: "09015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06281",
    lat: 41.97253,
    lng: -72.01458,
    city: "Woodstock",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7077,
    density: 50.7,
    county_fips: "09015",
    county_name: "Windham",
    county_weights: {
      "09015": 100,
    },
    county_names_all: "Windham",
    county_fips_all: "09015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06282",
    lat: 41.94556,
    lng: -72.07928,
    city: "Woodstock Valley",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 876,
    density: 49.2,
    county_fips: "09015",
    county_name: "Windham",
    county_weights: {
      "09015": 100,
    },
    county_names_all: "Windham",
    county_fips_all: "09015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06320",
    lat: 41.35026,
    lng: -72.10225,
    city: "New London",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27040,
    density: 1850.1,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 100,
    },
    county_names_all: "New London",
    county_fips_all: "09011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06330",
    lat: 41.64199,
    lng: -72.07541,
    city: "Baltic",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3402,
    density: 76.5,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 75.63,
      "09015": 24.37,
    },
    county_names_all: "New London|Windham",
    county_fips_all: "09011|09015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06331",
    lat: 41.69717,
    lng: -72.00109,
    city: "Canterbury",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5080,
    density: 48.1,
    county_fips: "09015",
    county_name: "Windham",
    county_weights: {
      "09015": 100,
    },
    county_names_all: "Windham",
    county_fips_all: "09015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06332",
    lat: 41.72845,
    lng: -71.91008,
    city: "Central Village",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 324,
    density: 100.7,
    county_fips: "09015",
    county_name: "Windham",
    county_weights: {
      "09015": 100,
    },
    county_names_all: "Windham",
    county_fips_all: "09015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06333",
    lat: 41.38602,
    lng: -72.24527,
    city: "East Lyme",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7021,
    density: 115.7,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 100,
    },
    county_names_all: "New London",
    county_fips_all: "09011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06334",
    lat: 41.54431,
    lng: -72.17424,
    city: "Bozrah",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2509,
    density: 50.1,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 100,
    },
    county_names_all: "New London",
    county_fips_all: "09011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06335",
    lat: 41.42943,
    lng: -72.06247,
    city: "Gales Ferry",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5954,
    density: 209.8,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 100,
    },
    county_names_all: "New London",
    county_fips_all: "09011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06336",
    lat: 41.57934,
    lng: -72.19505,
    city: "Gilman",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 159,
    density: 100,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 100,
    },
    county_names_all: "New London",
    county_fips_all: "09011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06338",
    lat: 41.46473,
    lng: -71.97281,
    city: "Mashantucket",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 100,
    },
    county_names_all: "New London",
    county_fips_all: "09011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06339",
    lat: 41.44408,
    lng: -71.99851,
    city: "Ledyard",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8729,
    density: 131.6,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 100,
    },
    county_names_all: "New London",
    county_fips_all: "09011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06340",
    lat: 41.35643,
    lng: -72.04477,
    city: "Groton",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30486,
    density: 522.2,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 100,
    },
    county_names_all: "New London",
    county_fips_all: "09011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06350",
    lat: 41.64829,
    lng: -72.0693,
    city: "Hanover",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62,
    density: 62.2,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 100,
    },
    county_names_all: "New London",
    county_fips_all: "09011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06351",
    lat: 41.58873,
    lng: -71.94854,
    city: "Jewett City",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15880,
    density: 116.8,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 100,
    },
    county_names_all: "New London",
    county_fips_all: "09011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06353",
    lat: 41.45612,
    lng: -72.13928,
    city: "Montville",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 176,
    density: 256.5,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 100,
    },
    county_names_all: "New London",
    county_fips_all: "09011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06354",
    lat: 41.69836,
    lng: -71.85016,
    city: "Moosup",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5614,
    density: 98.6,
    county_fips: "09015",
    county_name: "Windham",
    county_weights: {
      "09015": 100,
    },
    county_names_all: "Windham",
    county_fips_all: "09015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06355",
    lat: 41.36857,
    lng: -71.97426,
    city: "Mystic",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12497,
    density: 339.9,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 100,
    },
    county_names_all: "New London",
    county_fips_all: "09011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06357",
    lat: 41.32711,
    lng: -72.21478,
    city: "Niantic",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11597,
    density: 422.9,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 100,
    },
    county_names_all: "New London",
    county_fips_all: "09011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06359",
    lat: 41.46966,
    lng: -71.87546,
    city: "North Stonington",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5286,
    density: 37.6,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 100,
    },
    county_names_all: "New London",
    county_fips_all: "09011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06360",
    lat: 41.54883,
    lng: -72.08914,
    city: "Norwich",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36549,
    density: 526.2,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 100,
    },
    county_names_all: "New London",
    county_fips_all: "09011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06365",
    lat: 41.52281,
    lng: -72.00072,
    city: "Preston",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4644,
    density: 59,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 100,
    },
    county_names_all: "New London",
    county_fips_all: "09011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06370",
    lat: 41.46541,
    lng: -72.18659,
    city: "Oakdale",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7195,
    density: 115.8,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 100,
    },
    county_names_all: "New London",
    county_fips_all: "09011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06371",
    lat: 41.36361,
    lng: -72.32582,
    city: "Old Lyme",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9642,
    density: 68.9,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 100,
    },
    county_names_all: "New London",
    county_fips_all: "09011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06373",
    lat: 41.68394,
    lng: -71.79881,
    city: "Oneco",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 246,
    density: 51.2,
    county_fips: "09015",
    county_name: "Windham",
    county_weights: {
      "09015": 100,
    },
    county_names_all: "Windham",
    county_fips_all: "09015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06374",
    lat: 41.6798,
    lng: -71.91441,
    city: "Plainfield",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8137,
    density: 122.8,
    county_fips: "09015",
    county_name: "Windham",
    county_weights: {
      "09015": 100,
    },
    county_names_all: "Windham",
    county_fips_all: "09015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06375",
    lat: 41.40544,
    lng: -72.12554,
    city: "Quaker Hill",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3615,
    density: 176.7,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 100,
    },
    county_names_all: "New London",
    county_fips_all: "09011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06376",
    lat: 41.29461,
    lng: -72.2528,
    city: "South Lyme",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 154,
    density: 2202.4,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 100,
    },
    county_names_all: "New London",
    county_fips_all: "09011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06377",
    lat: 41.72708,
    lng: -71.81679,
    city: "Sterling",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3073,
    density: 73.3,
    county_fips: "09015",
    county_name: "Windham",
    county_weights: {
      "09015": 100,
    },
    county_names_all: "Windham",
    county_fips_all: "09015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06378",
    lat: 41.38039,
    lng: -71.91376,
    city: "Stonington",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5634,
    density: 104.1,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 100,
    },
    county_names_all: "New London",
    county_fips_all: "09011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06379",
    lat: 41.36685,
    lng: -71.85826,
    city: "Pawcatuck",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8556,
    density: 270.2,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 100,
    },
    county_names_all: "New London",
    county_fips_all: "09011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06380",
    lat: 41.56533,
    lng: -72.05308,
    city: "Taftville",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2509,
    density: 1005.4,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 100,
    },
    county_names_all: "New London",
    county_fips_all: "09011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06382",
    lat: 41.46137,
    lng: -72.11762,
    city: "Uncasville",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11331,
    density: 248,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 100,
    },
    county_names_all: "New London",
    county_fips_all: "09011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06384",
    lat: 41.58188,
    lng: -71.83139,
    city: "Voluntown",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2630,
    density: 27.1,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 99.86,
      "09015": 0.14,
    },
    county_names_all: "New London|Windham",
    county_fips_all: "09011|09015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06385",
    lat: 41.35735,
    lng: -72.15581,
    city: "Waterford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15302,
    density: 237.8,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 100,
    },
    county_names_all: "New London",
    county_fips_all: "09011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06387",
    lat: 41.74418,
    lng: -71.90981,
    city: "Wauregan",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 619,
    density: 4124.2,
    county_fips: "09015",
    county_name: "Windham",
    county_weights: {
      "09015": 100,
    },
    county_names_all: "Windham",
    county_fips_all: "09015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06389",
    lat: 41.56036,
    lng: -72.12338,
    city: "Yantic",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 100,
    },
    county_names_all: "New London",
    county_fips_all: "09011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06390",
    lat: 41.27027,
    lng: -71.98886,
    city: "Fishers Island",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61,
    density: 5.8,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06401",
    lat: 41.34424,
    lng: -73.06896,
    city: "Ansonia",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18630,
    density: 1193.7,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06403",
    lat: 41.43902,
    lng: -73.05679,
    city: "Beacon Falls",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6185,
    density: 246.9,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06405",
    lat: 41.28405,
    lng: -72.79809,
    city: "Branford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27699,
    density: 494.6,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06409",
    lat: 41.35169,
    lng: -72.42056,
    city: "Centerbrook",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 729,
    density: 241.3,
    county_fips: "09007",
    county_name: "Middlesex",
    county_weights: {
      "09007": 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: "09007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06410",
    lat: 41.51183,
    lng: -72.90441,
    city: "Cheshire",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29064,
    density: 348,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06412",
    lat: 41.40594,
    lng: -72.48319,
    city: "Chester",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4219,
    density: 101.5,
    county_fips: "09007",
    county_name: "Middlesex",
    county_weights: {
      "09007": 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: "09007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06413",
    lat: 41.29801,
    lng: -72.53003,
    city: "Clinton",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12914,
    density: 307.8,
    county_fips: "09007",
    county_name: "Middlesex",
    county_weights: {
      "09007": 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: "09007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06414",
    lat: 41.57702,
    lng: -72.55231,
    city: "Cobalt",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 142,
    density: 51.7,
    county_fips: "09007",
    county_name: "Middlesex",
    county_weights: {
      "09007": 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: "09007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06415",
    lat: 41.55563,
    lng: -72.34694,
    city: "Colchester",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16518,
    density: 114,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 87.24,
      "09007": 12.76,
    },
    county_names_all: "New London|Middlesex",
    county_fips_all: "09011|09007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06416",
    lat: 41.61218,
    lng: -72.66382,
    city: "Cromwell",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13865,
    density: 429.9,
    county_fips: "09007",
    county_name: "Middlesex",
    county_weights: {
      "09007": 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: "09007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06417",
    lat: 41.36894,
    lng: -72.46227,
    city: "Deep River",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4466,
    density: 127.6,
    county_fips: "09007",
    county_name: "Middlesex",
    county_weights: {
      "09007": 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: "09007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06418",
    lat: 41.32647,
    lng: -73.08324,
    city: "Derby",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12499,
    density: 955.9,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06419",
    lat: 41.37923,
    lng: -72.57847,
    city: "Killingworth",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6390,
    density: 69.8,
    county_fips: "09007",
    county_name: "Middlesex",
    county_weights: {
      "09007": 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: "09007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06420",
    lat: 41.48492,
    lng: -72.26733,
    city: "Salem",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4098,
    density: 53.5,
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 97.94,
      "09007": 2.06,
    },
    county_names_all: "New London|Middlesex",
    county_fips_all: "09011|09007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06422",
    lat: 41.46221,
    lng: -72.68285,
    city: "Durham",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7196,
    density: 117.4,
    county_fips: "09007",
    county_name: "Middlesex",
    county_weights: {
      "09007": 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: "09007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06423",
    lat: 41.46654,
    lng: -72.39054,
    city: "East Haddam",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5439,
    density: 57.4,
    county_fips: "09007",
    county_name: "Middlesex",
    county_weights: {
      "09007": 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: "09007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06424",
    lat: 41.5588,
    lng: -72.50452,
    city: "East Hampton",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12674,
    density: 124.8,
    county_fips: "09007",
    county_name: "Middlesex",
    county_weights: {
      "09007": 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: "09007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06426",
    lat: 41.35346,
    lng: -72.39791,
    city: "Essex",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3508,
    density: 240.6,
    county_fips: "09007",
    county_name: "Middlesex",
    county_weights: {
      "09007": 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: "09007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06437",
    lat: 41.33444,
    lng: -72.70051,
    city: "Guilford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22164,
    density: 181.6,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06438",
    lat: 41.45516,
    lng: -72.50701,
    city: "Haddam",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2597,
    density: 71.9,
    county_fips: "09007",
    county_name: "Middlesex",
    county_weights: {
      "09007": 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: "09007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06439",
    lat: 41.41573,
    lng: -72.39964,
    city: "Hadlyme",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "09011",
    county_name: "New London",
    county_weights: {
      "09011": 100,
    },
    county_names_all: "New London",
    county_fips_all: "09011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06441",
    lat: 41.46674,
    lng: -72.58038,
    city: "Higganum",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5417,
    density: 86.4,
    county_fips: "09007",
    county_name: "Middlesex",
    county_weights: {
      "09007": 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: "09007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06442",
    lat: 41.34261,
    lng: -72.44429,
    city: "Ivoryton",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2374,
    density: 254.2,
    county_fips: "09007",
    county_name: "Middlesex",
    county_weights: {
      "09007": 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: "09007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06443",
    lat: 41.33976,
    lng: -72.62783,
    city: "Madison",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18065,
    density: 192.9,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06444",
    lat: 41.5634,
    lng: -72.93038,
    city: "Marion",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 261,
    density: 99,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 99.74,
      "09009": 0.26,
    },
    county_names_all: "Hartford|New Haven",
    county_fips_all: "09003|09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06447",
    lat: 41.63309,
    lng: -72.45472,
    city: "Marlborough",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6351,
    density: 105,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06450",
    lat: 41.53332,
    lng: -72.77399,
    city: "Meriden",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35343,
    density: 980.2,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06451",
    lat: 41.54203,
    lng: -72.82364,
    city: "Meriden",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24153,
    density: 948.9,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 99.83,
      "09003": 0.17,
    },
    county_names_all: "New Haven|Hartford",
    county_fips_all: "09009|09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06455",
    lat: 41.51468,
    lng: -72.71732,
    city: "Middlefield",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2977,
    density: 107,
    county_fips: "09007",
    county_name: "Middlesex",
    county_weights: {
      "09007": 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: "09007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06456",
    lat: 41.541,
    lng: -72.5483,
    city: "Middle Haddam",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 211,
    density: 61.4,
    county_fips: "09007",
    county_name: "Middlesex",
    county_weights: {
      "09007": 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: "09007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06457",
    lat: 41.54759,
    lng: -72.65484,
    city: "Middletown",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46406,
    density: 440.4,
    county_fips: "09007",
    county_name: "Middlesex",
    county_weights: {
      "09007": 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: "09007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06459",
    lat: 41.5516,
    lng: -72.66017,
    city: "Middletown",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "09007",
    county_name: "Middlesex",
    county_weights: {
      "09007": 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: "09007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06460",
    lat: 41.21505,
    lng: -73.05129,
    city: "Milford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39185,
    density: 1217.1,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06461",
    lat: 41.23937,
    lng: -73.0752,
    city: "Milford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15318,
    density: 608.1,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06467",
    lat: 41.56548,
    lng: -72.90022,
    city: "Milldale",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 544,
    density: 895.8,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06468",
    lat: 41.33791,
    lng: -73.22499,
    city: "Monroe",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19492,
    density: 288.7,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06469",
    lat: 41.50757,
    lng: -72.44924,
    city: "Moodus",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2915,
    density: 112,
    county_fips: "09007",
    county_name: "Middlesex",
    county_weights: {
      "09007": 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: "09007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06470",
    lat: 41.3943,
    lng: -73.31918,
    city: "Newtown",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16359,
    density: 169.7,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06471",
    lat: 41.33454,
    lng: -72.77372,
    city: "North Branford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7261,
    density: 316.2,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06472",
    lat: 41.38416,
    lng: -72.77911,
    city: "Northford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7111,
    density: 171,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06473",
    lat: 41.38069,
    lng: -72.85598,
    city: "North Haven",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24050,
    density: 428.9,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06475",
    lat: 41.30174,
    lng: -72.38569,
    city: "Old Saybrook",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10072,
    density: 258.2,
    county_fips: "09007",
    county_name: "Middlesex",
    county_weights: {
      "09007": 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: "09007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06477",
    lat: 41.2827,
    lng: -73.0272,
    city: "Orange",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13928,
    density: 313,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06478",
    lat: 41.43133,
    lng: -73.13499,
    city: "Oxford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13141,
    density: 155,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06479",
    lat: 41.57799,
    lng: -72.90398,
    city: "Plantsville",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9897,
    density: 563.2,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06480",
    lat: 41.59885,
    lng: -72.5893,
    city: "Portland",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9301,
    density: 154.9,
    county_fips: "09007",
    county_name: "Middlesex",
    county_weights: {
      "09007": 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: "09007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06481",
    lat: 41.53435,
    lng: -72.70067,
    city: "Rockfall",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1398,
    density: 282.6,
    county_fips: "09007",
    county_name: "Middlesex",
    county_weights: {
      "09007": 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: "09007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06482",
    lat: 41.4067,
    lng: -73.24474,
    city: "Sandy Hook",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11465,
    density: 218.7,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06483",
    lat: 41.381,
    lng: -73.08726,
    city: "Seymour",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16469,
    density: 438,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06484",
    lat: 41.30601,
    lng: -73.13828,
    city: "Shelton",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41162,
    density: 518.8,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06488",
    lat: 41.47451,
    lng: -73.23288,
    city: "Southbury",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19619,
    density: 194.1,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06489",
    lat: 41.61312,
    lng: -72.87233,
    city: "Southington",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33020,
    density: 460,
    county_fips: "09003",
    county_name: "Hartford",
    county_weights: {
      "09003": 100,
    },
    county_names_all: "Hartford",
    county_fips_all: "09003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06492",
    lat: 41.45927,
    lng: -72.80473,
    city: "Wallingford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44428,
    density: 431.2,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06498",
    lat: 41.30688,
    lng: -72.46652,
    city: "Westbrook",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6897,
    density: 168.8,
    county_fips: "09007",
    county_name: "Middlesex",
    county_weights: {
      "09007": 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: "09007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06510",
    lat: 41.3062,
    lng: -72.92652,
    city: "New Haven",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2778,
    density: 3983.9,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06511",
    lat: 41.31663,
    lng: -72.92587,
    city: "New Haven",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53859,
    density: 3577.6,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06512",
    lat: 41.28111,
    lng: -72.8719,
    city: "East Haven",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28682,
    density: 1049.3,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06513",
    lat: 41.31953,
    lng: -72.86856,
    city: "New Haven",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39403,
    density: 2106.7,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06514",
    lat: 41.3729,
    lng: -72.94159,
    city: "Hamden",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27159,
    density: 943.6,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06515",
    lat: 41.32794,
    lng: -72.96954,
    city: "New Haven",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18382,
    density: 1557,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06516",
    lat: 41.27393,
    lng: -72.96718,
    city: "West Haven",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54666,
    density: 1963.4,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06517",
    lat: 41.34834,
    lng: -72.90494,
    city: "Hamden",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14086,
    density: 1087,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06518",
    lat: 41.42744,
    lng: -72.91339,
    city: "Hamden",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19357,
    density: 453,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06519",
    lat: 41.29597,
    lng: -72.93764,
    city: "New Haven",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15675,
    density: 3420.7,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06524",
    lat: 41.42606,
    lng: -72.99308,
    city: "Bethany",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5492,
    density: 100.5,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06525",
    lat: 41.35662,
    lng: -73.01017,
    city: "Woodbridge",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8779,
    density: 180.2,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06604",
    lat: 41.17684,
    lng: -73.20027,
    city: "Bridgeport",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26858,
    density: 3286.8,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06605",
    lat: 41.16348,
    lng: -73.21763,
    city: "Bridgeport",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24541,
    density: 4144.8,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06606",
    lat: 41.21218,
    lng: -73.20829,
    city: "Bridgeport",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47040,
    density: 3438.3,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06607",
    lat: 41.1736,
    lng: -73.16696,
    city: "Bridgeport",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9456,
    density: 3157,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06608",
    lat: 41.18675,
    lng: -73.1809,
    city: "Bridgeport",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14169,
    density: 5322.1,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06610",
    lat: 41.20457,
    lng: -73.16933,
    city: "Bridgeport",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22914,
    density: 2873.7,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06611",
    lat: 41.26009,
    lng: -73.20823,
    city: "Trumbull",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35907,
    density: 594.1,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06612",
    lat: 41.26493,
    lng: -73.30006,
    city: "Easton",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7447,
    density: 104.8,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06614",
    lat: 41.22989,
    lng: -73.12785,
    city: "Stratford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33481,
    density: 1167.1,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06615",
    lat: 41.17082,
    lng: -73.13477,
    city: "Stratford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18501,
    density: 1118.4,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06702",
    lat: 41.55713,
    lng: -73.04539,
    city: "Waterbury",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3043,
    density: 1757.1,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06704",
    lat: 41.58601,
    lng: -73.03296,
    city: "Waterbury",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26209,
    density: 1253,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06705",
    lat: 41.549,
    lng: -72.992,
    city: "Waterbury",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24910,
    density: 1703.1,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06706",
    lat: 41.53285,
    lng: -73.02389,
    city: "Waterbury",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14198,
    density: 1428.9,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06708",
    lat: 41.54939,
    lng: -73.06738,
    city: "Waterbury",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29727,
    density: 1214.9,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06710",
    lat: 41.56958,
    lng: -73.04598,
    city: "Waterbury",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9740,
    density: 3881.1,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06712",
    lat: 41.49927,
    lng: -72.97609,
    city: "Prospect",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9667,
    density: 262.5,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06716",
    lat: 41.60102,
    lng: -72.97325,
    city: "Wolcott",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16611,
    density: 317,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06750",
    lat: 41.72327,
    lng: -73.2624,
    city: "Bantam",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 936,
    density: 46.6,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06751",
    lat: 41.63792,
    lng: -73.2122,
    city: "Bethlehem",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3413,
    density: 69.4,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06752",
    lat: 41.52082,
    lng: -73.35965,
    city: "Bridgewater",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1792,
    density: 41.4,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06753",
    lat: 41.82514,
    lng: -73.34471,
    city: "Cornwall",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06754",
    lat: 41.76841,
    lng: -73.36127,
    city: "Cornwall Bridge",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1808,
    density: 23.2,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06755",
    lat: 41.64915,
    lng: -73.48143,
    city: "Gaylordsville",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 953,
    density: 73.4,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06756",
    lat: 41.84714,
    lng: -73.23715,
    city: "Goshen",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2834,
    density: 29.8,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06757",
    lat: 41.73951,
    lng: -73.46637,
    city: "Kent",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2166,
    density: 27.6,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06758",
    lat: 41.67672,
    lng: -73.2286,
    city: "Lakeside",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 294,
    density: 180.9,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06759",
    lat: 41.75757,
    lng: -73.21544,
    city: "Litchfield",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5592,
    density: 40.2,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06762",
    lat: 41.5271,
    lng: -73.1228,
    city: "Middlebury",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7734,
    density: 168.2,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06763",
    lat: 41.69027,
    lng: -73.20714,
    city: "Morris",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1815,
    density: 41.9,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06770",
    lat: 41.48913,
    lng: -73.05181,
    city: "Naugatuck",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31396,
    density: 740.1,
    county_fips: "09009",
    county_name: "New Haven",
    county_weights: {
      "09009": 100,
    },
    county_names_all: "New Haven",
    county_fips_all: "09009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06776",
    lat: 41.60011,
    lng: -73.4162,
    city: "New Milford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25833,
    density: 177.4,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06777",
    lat: 41.69412,
    lng: -73.33931,
    city: "New Preston Marble Dale",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1369,
    density: 31.1,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06778",
    lat: 41.71469,
    lng: -73.10459,
    city: "Northfield",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1603,
    density: 111.6,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06779",
    lat: 41.59562,
    lng: -73.08058,
    city: "Oakville",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7834,
    density: 868.8,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06782",
    lat: 41.65448,
    lng: -73.04731,
    city: "Plymouth",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2000,
    density: 103.5,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06783",
    lat: 41.55424,
    lng: -73.29998,
    city: "Roxbury",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2108,
    density: 31.3,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06784",
    lat: 41.58018,
    lng: -73.49853,
    city: "Sherman",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3716,
    density: 65.3,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 99.48,
      "09005": 0.52,
    },
    county_names_all: "Fairfield|Litchfield",
    county_fips_all: "09001|09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06785",
    lat: 41.70491,
    lng: -73.43815,
    city: "South Kent",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 623,
    density: 15.4,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06786",
    lat: 41.66912,
    lng: -73.01502,
    city: "Terryville",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9646,
    density: 259.8,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06787",
    lat: 41.67033,
    lng: -73.08568,
    city: "Thomaston",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7707,
    density: 242,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06790",
    lat: 41.83747,
    lng: -73.12874,
    city: "Torrington",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34192,
    density: 318.1,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06791",
    lat: 41.75509,
    lng: -73.05838,
    city: "Harwinton",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5428,
    density: 67.9,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06793",
    lat: 41.63089,
    lng: -73.28835,
    city: "Washington",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1279,
    density: 33.8,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06794",
    lat: 41.64932,
    lng: -73.32511,
    city: "Washington Depot",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1037,
    density: 30.8,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06795",
    lat: 41.61873,
    lng: -73.12336,
    city: "Watertown",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13733,
    density: 204.6,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06796",
    lat: 41.87595,
    lng: -73.33255,
    city: "West Cornwall",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 997,
    density: 11.9,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06798",
    lat: 41.56149,
    lng: -73.20703,
    city: "Woodbury",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9529,
    density: 101.2,
    county_fips: "09005",
    county_name: "Litchfield",
    county_weights: {
      "09005": 100,
    },
    county_names_all: "Litchfield",
    county_fips_all: "09005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06801",
    lat: 41.37468,
    lng: -73.39275,
    city: "Bethel",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19798,
    density: 451.9,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06804",
    lat: 41.46731,
    lng: -73.39232,
    city: "Brookfield",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17219,
    density: 333,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06807",
    lat: 41.0611,
    lng: -73.59215,
    city: "Cos Cob",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7176,
    density: 846.1,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06810",
    lat: 41.37627,
    lng: -73.45904,
    city: "Danbury",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52578,
    density: 970.7,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06811",
    lat: 41.42427,
    lng: -73.4821,
    city: "Danbury",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31887,
    density: 586.2,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06812",
    lat: 41.48796,
    lng: -73.48827,
    city: "New Fairfield",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13924,
    density: 263.3,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06820",
    lat: 41.07983,
    lng: -73.48242,
    city: "Darien",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21752,
    density: 663.7,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06824",
    lat: 41.17571,
    lng: -73.28111,
    city: "Fairfield",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36058,
    density: 693.1,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06825",
    lat: 41.19685,
    lng: -73.24221,
    city: "Fairfield",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21264,
    density: 1208.1,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06830",
    lat: 41.048,
    lng: -73.624,
    city: "Greenwich",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24557,
    density: 700.4,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06831",
    lat: 41.08782,
    lng: -73.66078,
    city: "Greenwich",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15240,
    density: 213.6,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06840",
    lat: 41.15925,
    lng: -73.49916,
    city: "New Canaan",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20249,
    density: 352.4,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06850",
    lat: 41.1263,
    lng: -73.44316,
    city: "Norwalk",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19206,
    density: 1093.5,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06851",
    lat: 41.13948,
    lng: -73.40387,
    city: "Norwalk",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27028,
    density: 1357.7,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06853",
    lat: 41.06962,
    lng: -73.43775,
    city: "Norwalk",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3969,
    density: 1270.5,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06854",
    lat: 41.09148,
    lng: -73.42972,
    city: "Norwalk",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29895,
    density: 2400.2,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06855",
    lat: 41.08922,
    lng: -73.39615,
    city: "Norwalk",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8506,
    density: 1329.7,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06870",
    lat: 41.02881,
    lng: -73.56964,
    city: "Old Greenwich",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7831,
    density: 1333.5,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06877",
    lat: 41.30642,
    lng: -73.50216,
    city: "Ridgefield",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25065,
    density: 279.8,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06878",
    lat: 41.03191,
    lng: -73.58283,
    city: "Riverside",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8214,
    density: 1311.7,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06880",
    lat: 41.14379,
    lng: -73.34698,
    city: "Westport",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28413,
    density: 548.1,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06883",
    lat: 41.22842,
    lng: -73.37256,
    city: "Weston",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10278,
    density: 200.7,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06890",
    lat: 41.14639,
    lng: -73.28944,
    city: "Southport",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4540,
    density: 605.4,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06896",
    lat: 41.3051,
    lng: -73.39139,
    city: "Redding",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9070,
    density: 111.6,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06897",
    lat: 41.20705,
    lng: -73.44009,
    city: "Wilton",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18405,
    density: 265.3,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06901",
    lat: 41.05349,
    lng: -73.53845,
    city: "Stamford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7212,
    density: 5474.1,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06902",
    lat: 41.05949,
    lng: -73.54751,
    city: "Stamford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 70199,
    density: 2705,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06903",
    lat: 41.13571,
    lng: -73.57207,
    city: "Stamford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14650,
    density: 325.2,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06905",
    lat: 41.08792,
    lng: -73.54351,
    city: "Stamford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19554,
    density: 1488.7,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06906",
    lat: 41.07244,
    lng: -73.52217,
    city: "Stamford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9894,
    density: 2831.2,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "06907",
    lat: 41.1021,
    lng: -73.52033,
    city: "Stamford",
    state_id: "CT",
    state_name: "Connecticut",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8244,
    density: 1626.2,
    county_fips: "09001",
    county_name: "Fairfield",
    county_weights: {
      "09001": 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: "09001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07001",
    lat: 40.58342,
    lng: -74.26992,
    city: "Avenel",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17539,
    density: 1814,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07002",
    lat: 40.66681,
    lng: -74.11582,
    city: "Bayonne",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65112,
    density: 4317.3,
    county_fips: 34017,
    county_name: "Hudson",
    county_weights: {
      34017: 100,
    },
    county_names_all: "Hudson",
    county_fips_all: 34017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07003",
    lat: 40.80976,
    lng: -74.18683,
    city: "Bloomfield",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49389,
    density: 3585.1,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 34013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07004",
    lat: 40.88282,
    lng: -74.30413,
    city: "Fairfield",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7482,
    density: 285.2,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 34013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07005",
    lat: 40.92738,
    lng: -74.41706,
    city: "Boonton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14644,
    density: 308.9,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07006",
    lat: 40.85221,
    lng: -74.2817,
    city: "Caldwell",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25578,
    density: 1057.1,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 34013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07008",
    lat: 40.58489,
    lng: -74.2284,
    city: "Carteret",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23501,
    density: 2063.6,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 99.86,
      34039: 0.14,
    },
    county_names_all: "Middlesex|Union",
    county_fips_all: "34023|34039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07009",
    lat: 40.85651,
    lng: -74.22871,
    city: "Cedar Grove",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12593,
    density: 1144.2,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 99.71,
      34031: 0.29,
    },
    county_names_all: "Essex|Passaic",
    county_fips_all: "34013|34031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07010",
    lat: 40.82217,
    lng: -73.98792,
    city: "Cliffside Park",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25410,
    density: 10257.7,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07011",
    lat: 40.8801,
    lng: -74.14449,
    city: "Clifton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39371,
    density: 4883.9,
    county_fips: 34031,
    county_name: "Passaic",
    county_weights: {
      34031: 100,
    },
    county_names_all: "Passaic",
    county_fips_all: 34031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07012",
    lat: 40.84694,
    lng: -74.1596,
    city: "Clifton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13496,
    density: 2376.3,
    county_fips: 34031,
    county_name: "Passaic",
    county_weights: {
      34031: 100,
    },
    county_names_all: "Passaic",
    county_fips_all: 34031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07013",
    lat: 40.86935,
    lng: -74.17267,
    city: "Clifton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26942,
    density: 2349,
    county_fips: 34031,
    county_name: "Passaic",
    county_weights: {
      34031: 100,
    },
    county_names_all: "Passaic",
    county_fips_all: 34031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07014",
    lat: 40.83162,
    lng: -74.13532,
    city: "Clifton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4616,
    density: 1241.8,
    county_fips: 34031,
    county_name: "Passaic",
    county_weights: {
      34003: 0.23,
      34031: 99.77,
    },
    county_names_all: "Passaic|Bergen",
    county_fips_all: "34031|34003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07016",
    lat: 40.65678,
    lng: -74.30354,
    city: "Cranford",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24036,
    density: 1955.6,
    county_fips: 34039,
    county_name: "Union",
    county_weights: {
      34039: 100,
    },
    county_names_all: "Union",
    county_fips_all: 34039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07017",
    lat: 40.77192,
    lng: -74.20712,
    city: "East Orange",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36313,
    density: 6198.9,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 34013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07018",
    lat: 40.75572,
    lng: -74.21793,
    city: "East Orange",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28680,
    density: 6661.5,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 34013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07020",
    lat: 40.82374,
    lng: -73.97401,
    city: "Edgewater",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12890,
    density: 5125.2,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07021",
    lat: 40.82708,
    lng: -74.27981,
    city: "Essex Fells",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2022,
    density: 554.4,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 34013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07022",
    lat: 40.81821,
    lng: -74.0022,
    city: "Fairview",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14218,
    density: 6506.9,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07023",
    lat: 40.64171,
    lng: -74.38575,
    city: "Fanwood",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7686,
    density: 2215.2,
    county_fips: 34039,
    county_name: "Union",
    county_weights: {
      34039: 100,
    },
    county_names_all: "Union",
    county_fips_all: 34039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07024",
    lat: 40.85088,
    lng: -73.97128,
    city: "Fort Lee",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37843,
    density: 5815.1,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07026",
    lat: 40.87914,
    lng: -74.1085,
    city: "Garfield",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31935,
    density: 5840.8,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07027",
    lat: 40.65132,
    lng: -74.32313,
    city: "Garwood",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4341,
    density: 2577,
    county_fips: 34039,
    county_name: "Union",
    county_weights: {
      34039: 100,
    },
    county_names_all: "Union",
    county_fips_all: 34039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07028",
    lat: 40.80421,
    lng: -74.20428,
    city: "Glen Ridge",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7716,
    density: 2276.6,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 34013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07029",
    lat: 40.74377,
    lng: -74.15389,
    city: "Harrison",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20990,
    density: 6169.1,
    county_fips: 34017,
    county_name: "Hudson",
    county_weights: {
      34017: 100,
    },
    county_names_all: "Hudson",
    county_fips_all: 34017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07030",
    lat: 40.7451,
    lng: -74.02815,
    city: "Hoboken",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53283,
    density: 16467.1,
    county_fips: 34017,
    county_name: "Hudson",
    county_weights: {
      34017: 100,
    },
    county_names_all: "Hudson",
    county_fips_all: 34017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07031",
    lat: 40.78745,
    lng: -74.12731,
    city: "North Arlington",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15681,
    density: 2437.1,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 99.83,
      34013: 0.17,
    },
    county_names_all: "Bergen|Essex",
    county_fips_all: "34003|34013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07032",
    lat: 40.75281,
    lng: -74.12016,
    city: "Kearny",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41147,
    density: 1796.3,
    county_fips: 34017,
    county_name: "Hudson",
    county_weights: {
      34017: 100,
    },
    county_names_all: "Hudson",
    county_fips_all: 34017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07033",
    lat: 40.67812,
    lng: -74.28898,
    city: "Kenilworth",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8182,
    density: 1471.6,
    county_fips: 34039,
    county_name: "Union",
    county_weights: {
      34039: 100,
    },
    county_names_all: "Union",
    county_fips_all: 34039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07034",
    lat: 40.87953,
    lng: -74.37965,
    city: "Lake Hiawatha",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9134,
    density: 2776.1,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07035",
    lat: 40.925,
    lng: -74.30462,
    city: "Lincoln Park",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10220,
    density: 592.6,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34013: 0.11,
      34027: 99.89,
    },
    county_names_all: "Morris|Essex",
    county_fips_all: "34027|34013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07036",
    lat: 40.62526,
    lng: -74.23917,
    city: "Linden",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43908,
    density: 1559.8,
    county_fips: 34039,
    county_name: "Union",
    county_weights: {
      34039: 100,
    },
    county_names_all: "Union",
    county_fips_all: 34039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07039",
    lat: 40.78554,
    lng: -74.32909,
    city: "Livingston",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30059,
    density: 842.7,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 34013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07040",
    lat: 40.73302,
    lng: -74.27117,
    city: "Maplewood",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25029,
    density: 2494.5,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 34013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07041",
    lat: 40.72301,
    lng: -74.30065,
    city: "Millburn",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6862,
    density: 1974.5,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 99.53,
      34039: 0.47,
    },
    county_names_all: "Essex|Union",
    county_fips_all: "34013|34039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07042",
    lat: 40.81382,
    lng: -74.21775,
    city: "Montclair",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26526,
    density: 2713.3,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 34013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07043",
    lat: 40.84411,
    lng: -74.20041,
    city: "Montclair",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12544,
    density: 1900.5,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 96.19,
      34031: 3.81,
    },
    county_names_all: "Essex|Passaic",
    county_fips_all: "34013|34031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07044",
    lat: 40.83228,
    lng: -74.24308,
    city: "Verona",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13632,
    density: 1883.7,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 34013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07045",
    lat: 40.90736,
    lng: -74.3671,
    city: "Montville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9853,
    density: 579.2,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07046",
    lat: 40.89067,
    lng: -74.44072,
    city: "Mountain Lakes",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4278,
    density: 621.2,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07047",
    lat: 40.79376,
    lng: -74.02416,
    city: "North Bergen",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61181,
    density: 4599.5,
    county_fips: 34017,
    county_name: "Hudson",
    county_weights: {
      34017: 100,
    },
    county_names_all: "Hudson",
    county_fips_all: 34017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07050",
    lat: 40.76817,
    lng: -74.2348,
    city: "Orange",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30374,
    density: 5315.1,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 34013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07052",
    lat: 40.78928,
    lng: -74.26281,
    city: "West Orange",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47528,
    density: 1527.1,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 34013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07054",
    lat: 40.85527,
    lng: -74.40239,
    city: "Parsippany",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28943,
    density: 808,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07055",
    lat: 40.85746,
    lng: -74.12821,
    city: "Passaic",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69842,
    density: 8618.7,
    county_fips: 34031,
    county_name: "Passaic",
    county_weights: {
      34031: 100,
    },
    county_names_all: "Passaic",
    county_fips_all: 34031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07057",
    lat: 40.85355,
    lng: -74.10691,
    city: "Wallington",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11553,
    density: 4487.2,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07058",
    lat: 40.86701,
    lng: -74.34283,
    city: "Pine Brook",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5665,
    density: 740,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34013: 0.15,
      34027: 99.85,
    },
    county_names_all: "Morris|Essex",
    county_fips_all: "34027|34013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07059",
    lat: 40.63199,
    lng: -74.51463,
    city: "Warren",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15699,
    density: 307.6,
    county_fips: 34035,
    county_name: "Somerset",
    county_weights: {
      34035: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 34035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07060",
    lat: 40.61606,
    lng: -74.42164,
    city: "Plainfield",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46585,
    density: 3598.2,
    county_fips: 34039,
    county_name: "Union",
    county_weights: {
      34035: 37.51,
      34039: 62.49,
    },
    county_names_all: "Union|Somerset",
    county_fips_all: "34039|34035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07062",
    lat: 40.63174,
    lng: -74.40391,
    city: "Plainfield",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12114,
    density: 2432.5,
    county_fips: 34039,
    county_name: "Union",
    county_weights: {
      34035: 12.27,
      34039: 87.73,
    },
    county_names_all: "Union|Somerset",
    county_fips_all: "34039|34035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07063",
    lat: 40.60524,
    lng: -74.44615,
    city: "Plainfield",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13052,
    density: 2822.5,
    county_fips: 34039,
    county_name: "Union",
    county_weights: {
      34035: 38.9,
      34039: 61.1,
    },
    county_names_all: "Union|Somerset",
    county_fips_all: "34039|34035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07064",
    lat: 40.56865,
    lng: -74.2464,
    city: "Port Reading",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3973,
    density: 1163.2,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07065",
    lat: 40.60765,
    lng: -74.28066,
    city: "Rahway",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29691,
    density: 2942.3,
    county_fips: 34039,
    county_name: "Union",
    county_weights: {
      34039: 100,
    },
    county_names_all: "Union",
    county_fips_all: 34039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07066",
    lat: 40.62061,
    lng: -74.31335,
    city: "Clark",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15835,
    density: 1396.7,
    county_fips: 34039,
    county_name: "Union",
    county_weights: {
      34039: 100,
    },
    county_names_all: "Union",
    county_fips_all: 34039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07067",
    lat: 40.59255,
    lng: -74.31479,
    city: "Colonia",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17793,
    density: 1705.1,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 99.9,
      34039: 0.1,
    },
    county_names_all: "Middlesex|Union",
    county_fips_all: "34023|34039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07068",
    lat: 40.82077,
    lng: -74.30862,
    city: "Roseland",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5841,
    density: 623.4,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 34013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07069",
    lat: 40.64249,
    lng: -74.4396,
    city: "Watchung",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6186,
    density: 377.3,
    county_fips: 34035,
    county_name: "Somerset",
    county_weights: {
      34035: 99.8,
      34039: 0.2,
    },
    county_names_all: "Somerset|Union",
    county_fips_all: "34035|34039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07070",
    lat: 40.82034,
    lng: -74.10574,
    city: "Rutherford",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18376,
    density: 2551.2,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07071",
    lat: 40.79646,
    lng: -74.1099,
    city: "Lyndhurst",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22453,
    density: 1891,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 99.87,
      34013: 0.13,
    },
    county_names_all: "Bergen|Essex",
    county_fips_all: "34003|34013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07072",
    lat: 40.82472,
    lng: -74.06126,
    city: "Carlstadt",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6158,
    density: 602.3,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07073",
    lat: 40.81792,
    lng: -74.08539,
    city: "East Rutherford",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9707,
    density: 1010.1,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07074",
    lat: 40.83877,
    lng: -74.05705,
    city: "Moonachie",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2714,
    density: 957.4,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07075",
    lat: 40.85076,
    lng: -74.08779,
    city: "Wood Ridge",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9016,
    density: 3126.1,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07076",
    lat: 40.63308,
    lng: -74.37387,
    city: "Scotch Plains",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24118,
    density: 1035.2,
    county_fips: 34039,
    county_name: "Union",
    county_weights: {
      34039: 100,
    },
    county_names_all: "Union",
    county_fips_all: 34039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07077",
    lat: 40.55415,
    lng: -74.25489,
    city: "Sewaren",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2708,
    density: 677.9,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07078",
    lat: 40.74196,
    lng: -74.3277,
    city: "Short Hills",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13305,
    density: 642.8,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 34013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07079",
    lat: 40.74908,
    lng: -74.26022,
    city: "South Orange",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16795,
    density: 2274.1,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 34013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07080",
    lat: 40.57483,
    lng: -74.41542,
    city: "South Plainfield",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23961,
    density: 1125.3,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07081",
    lat: 40.69949,
    lng: -74.32542,
    city: "Springfield",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17432,
    density: 1300.1,
    county_fips: 34039,
    county_name: "Union",
    county_weights: {
      34039: 100,
    },
    county_names_all: "Union",
    county_fips_all: 34039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07082",
    lat: 40.92643,
    lng: -74.34524,
    city: "Towaco",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5244,
    density: 333.5,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07083",
    lat: 40.69443,
    lng: -74.2692,
    city: "Union",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55465,
    density: 2454.2,
    county_fips: 34039,
    county_name: "Union",
    county_weights: {
      34039: 100,
    },
    county_names_all: "Union",
    county_fips_all: 34039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07086",
    lat: 40.76761,
    lng: -74.01693,
    city: "Weehawken",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14756,
    density: 7173.8,
    county_fips: 34017,
    county_name: "Hudson",
    county_weights: {
      34017: 100,
    },
    county_names_all: "Hudson",
    county_fips_all: 34017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07087",
    lat: 40.76723,
    lng: -74.03243,
    city: "Union City",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68121,
    density: 20156,
    county_fips: 34017,
    county_name: "Hudson",
    county_weights: {
      34017: 100,
    },
    county_names_all: "Hudson",
    county_fips_all: 34017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07088",
    lat: 40.71832,
    lng: -74.28375,
    city: "Vauxhall",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3395,
    density: 4042.7,
    county_fips: 34039,
    county_name: "Union",
    county_weights: {
      34013: 0.39,
      34039: 99.61,
    },
    county_names_all: "Union|Essex",
    county_fips_all: "34039|34013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07090",
    lat: 40.65172,
    lng: -74.34328,
    city: "Westfield",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29668,
    density: 1700,
    county_fips: 34039,
    county_name: "Union",
    county_weights: {
      34039: 100,
    },
    county_names_all: "Union",
    county_fips_all: 34039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07092",
    lat: 40.68106,
    lng: -74.36038,
    city: "Mountainside",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6918,
    density: 668.9,
    county_fips: 34039,
    county_name: "Union",
    county_weights: {
      34039: 100,
    },
    county_names_all: "Union",
    county_fips_all: 34039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07093",
    lat: 40.78675,
    lng: -74.00871,
    city: "West New York",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64062,
    density: 20832.8,
    county_fips: 34017,
    county_name: "Hudson",
    county_weights: {
      34017: 100,
    },
    county_names_all: "Hudson",
    county_fips_all: 34017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07094",
    lat: 40.78109,
    lng: -74.06588,
    city: "Secaucus",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20667,
    density: 1375.7,
    county_fips: 34017,
    county_name: "Hudson",
    county_weights: {
      34017: 100,
    },
    county_names_all: "Hudson",
    county_fips_all: 34017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07095",
    lat: 40.55358,
    lng: -74.28743,
    city: "Woodbridge",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20297,
    density: 1700.7,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07102",
    lat: 40.73576,
    lng: -74.17343,
    city: "Newark",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13581,
    density: 4637.3,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 34013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07103",
    lat: 40.73886,
    lng: -74.19529,
    city: "Newark",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33548,
    density: 6019.4,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 34013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07104",
    lat: 40.76735,
    lng: -74.16831,
    city: "Newark",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51084,
    density: 7791.7,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 34013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07105",
    lat: 40.72266,
    lng: -74.13874,
    city: "Newark",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51097,
    density: 4252.8,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 34013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07106",
    lat: 40.74177,
    lng: -74.23047,
    city: "Newark",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33688,
    density: 9181.2,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 34013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07107",
    lat: 40.76181,
    lng: -74.18653,
    city: "Newark",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37943,
    density: 8886.3,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 34013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07108",
    lat: 40.72306,
    lng: -74.20039,
    city: "Newark",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24777,
    density: 6935.6,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 34013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07109",
    lat: 40.79502,
    lng: -74.16161,
    city: "Belleville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36394,
    density: 4255.3,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 34013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07110",
    lat: 40.81926,
    lng: -74.15715,
    city: "Nutley",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28385,
    density: 3248.3,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 99.78,
      34031: 0.22,
    },
    county_names_all: "Essex|Passaic",
    county_fips_all: "34013|34031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07111",
    lat: 40.72426,
    lng: -74.23173,
    city: "Irvington",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54220,
    density: 7183.6,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 34013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07112",
    lat: 40.71137,
    lng: -74.21164,
    city: "Newark",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24376,
    density: 6925.8,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 34013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07114",
    lat: 40.70018,
    lng: -74.16618,
    city: "Newark",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11947,
    density: 584.4,
    county_fips: 34013,
    county_name: "Essex",
    county_weights: {
      34013: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 34013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07201",
    lat: 40.67237,
    lng: -74.17643,
    city: "Elizabeth",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27369,
    density: 1641.5,
    county_fips: 34039,
    county_name: "Union",
    county_weights: {
      34039: 100,
    },
    county_names_all: "Union",
    county_fips_all: 34039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07202",
    lat: 40.6531,
    lng: -74.21677,
    city: "Elizabeth",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41264,
    density: 6887,
    county_fips: 34039,
    county_name: "Union",
    county_weights: {
      34039: 100,
    },
    county_names_all: "Union",
    county_fips_all: 34039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07203",
    lat: 40.65269,
    lng: -74.2599,
    city: "Roselle",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21699,
    density: 3178.9,
    county_fips: 34039,
    county_name: "Union",
    county_weights: {
      34039: 100,
    },
    county_names_all: "Union",
    county_fips_all: 34039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07204",
    lat: 40.66532,
    lng: -74.2666,
    city: "Roselle Park",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13574,
    density: 4278.3,
    county_fips: 34039,
    county_name: "Union",
    county_weights: {
      34039: 100,
    },
    county_names_all: "Union",
    county_fips_all: 34039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07205",
    lat: 40.69612,
    lng: -74.22857,
    city: "Hillside",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21955,
    density: 3065.2,
    county_fips: 34039,
    county_name: "Union",
    county_weights: {
      34039: 100,
    },
    county_names_all: "Union",
    county_fips_all: 34039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07206",
    lat: 40.65238,
    lng: -74.18385,
    city: "Elizabethport",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27520,
    density: 5978.7,
    county_fips: 34039,
    county_name: "Union",
    county_weights: {
      34039: 100,
    },
    county_names_all: "Union",
    county_fips_all: 34039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07208",
    lat: 40.67434,
    lng: -74.22498,
    city: "Elizabeth",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32319,
    density: 6963.4,
    county_fips: 34039,
    county_name: "Union",
    county_weights: {
      34039: 100,
    },
    county_names_all: "Union",
    county_fips_all: 34039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07302",
    lat: 40.71894,
    lng: -74.04462,
    city: "Jersey City",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47339,
    density: 12755.6,
    county_fips: 34017,
    county_name: "Hudson",
    county_weights: {
      34017: 100,
    },
    county_names_all: "Hudson",
    county_fips_all: 34017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07304",
    lat: 40.71741,
    lng: -74.07637,
    city: "Jersey City",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43554,
    density: 8182.2,
    county_fips: 34017,
    county_name: "Hudson",
    county_weights: {
      34017: 100,
    },
    county_names_all: "Hudson",
    county_fips_all: 34017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07305",
    lat: 40.69839,
    lng: -74.08158,
    city: "Jersey City",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 66595,
    density: 4510.9,
    county_fips: 34017,
    county_name: "Hudson",
    county_weights: {
      34017: 100,
    },
    county_names_all: "Hudson",
    county_fips_all: 34017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07306",
    lat: 40.73674,
    lng: -74.07132,
    city: "Jersey City",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51378,
    density: 6641.7,
    county_fips: 34017,
    county_name: "Hudson",
    county_weights: {
      34017: 100,
    },
    county_names_all: "Hudson",
    county_fips_all: 34017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07307",
    lat: 40.75192,
    lng: -74.05429,
    city: "Jersey City",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40012,
    density: 8127.8,
    county_fips: 34017,
    county_name: "Hudson",
    county_weights: {
      34017: 100,
    },
    county_names_all: "Hudson",
    county_fips_all: 34017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07310",
    lat: 40.72893,
    lng: -74.03391,
    city: "Jersey City",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13051,
    density: 8244.6,
    county_fips: 34017,
    county_name: "Hudson",
    county_weights: {
      34017: 100,
    },
    county_names_all: "Hudson",
    county_fips_all: 34017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07311",
    lat: 40.71878,
    lng: -74.02933,
    city: "Jersey City",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 675,
    density: 4855.9,
    county_fips: 34017,
    county_name: "Hudson",
    county_weights: {
      34017: 100,
    },
    county_names_all: "Hudson",
    county_fips_all: 34017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07401",
    lat: 41.03321,
    lng: -74.13328,
    city: "Allendale",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6757,
    density: 843.9,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07403",
    lat: 41.02059,
    lng: -74.33239,
    city: "Bloomingdale",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8001,
    density: 506.5,
    county_fips: 34031,
    county_name: "Passaic",
    county_weights: {
      34031: 100,
    },
    county_names_all: "Passaic",
    county_fips_all: 34031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07405",
    lat: 40.98646,
    lng: -74.38302,
    city: "Butler",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17657,
    density: 344.2,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07407",
    lat: 40.90493,
    lng: -74.12007,
    city: "Elmwood Park",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20019,
    density: 2924.6,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 99.89,
      34031: 0.11,
    },
    county_names_all: "Bergen|Passaic",
    county_fips_all: "34003|34031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07410",
    lat: 40.93587,
    lng: -74.11771,
    city: "Fair Lawn",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32986,
    density: 2480.2,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07416",
    lat: 41.10892,
    lng: -74.58891,
    city: "Franklin",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5491,
    density: 174.3,
    county_fips: 34037,
    county_name: "Sussex",
    county_weights: {
      34037: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 34037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07417",
    lat: 41.00859,
    lng: -74.20836,
    city: "Franklin Lakes",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11044,
    density: 452.6,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07418",
    lat: 41.2387,
    lng: -74.4873,
    city: "Glenwood",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2674,
    density: 223.9,
    county_fips: 34037,
    county_name: "Sussex",
    county_weights: {
      34037: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 34037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07419",
    lat: 41.15394,
    lng: -74.57106,
    city: "Hamburg",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8935,
    density: 202.2,
    county_fips: 34037,
    county_name: "Sussex",
    county_weights: {
      34037: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 34037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07420",
    lat: 41.02926,
    lng: -74.30281,
    city: "Haskell",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5470,
    density: 877.9,
    county_fips: 34031,
    county_name: "Passaic",
    county_weights: {
      34031: 100,
    },
    county_names_all: "Passaic",
    county_fips_all: 34031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07421",
    lat: 41.1624,
    lng: -74.35586,
    city: "Hewitt",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7824,
    density: 133.8,
    county_fips: 34031,
    county_name: "Passaic",
    county_weights: {
      34031: 92.27,
      34037: 7.73,
    },
    county_names_all: "Passaic|Sussex",
    county_fips_all: "34031|34037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07422",
    lat: 41.17984,
    lng: -74.44177,
    city: "Highland Lakes",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5886,
    density: 129.9,
    county_fips: 34037,
    county_name: "Sussex",
    county_weights: {
      34037: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 34037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07423",
    lat: 41.00007,
    lng: -74.09718,
    city: "Ho Ho Kus",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4096,
    density: 909.2,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07424",
    lat: 40.88361,
    lng: -74.2059,
    city: "Little Falls",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27095,
    density: 1829.3,
    county_fips: 34031,
    county_name: "Passaic",
    county_weights: {
      34031: 100,
    },
    county_names_all: "Passaic",
    county_fips_all: 34031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07430",
    lat: 41.08157,
    lng: -74.18562,
    city: "Mahwah",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26225,
    density: 398.6,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07432",
    lat: 40.99516,
    lng: -74.14109,
    city: "Midland Park",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7230,
    density: 1787.9,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07435",
    lat: 41.0425,
    lng: -74.44159,
    city: "Newfoundland",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2898,
    density: 88.8,
    county_fips: 34031,
    county_name: "Passaic",
    county_weights: {
      34027: 39.45,
      34031: 60.55,
    },
    county_names_all: "Passaic|Morris",
    county_fips_all: "34031|34027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07436",
    lat: 41.03135,
    lng: -74.24081,
    city: "Oakland",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12953,
    density: 588.5,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07438",
    lat: 41.0287,
    lng: -74.52038,
    city: "Oak Ridge",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11807,
    density: 151.8,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 84.86,
      34031: 15.14,
    },
    county_names_all: "Morris|Passaic",
    county_fips_all: "34027|34031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07439",
    lat: 41.0769,
    lng: -74.59734,
    city: "Ogdensburg",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2174,
    density: 380.9,
    county_fips: 34037,
    county_name: "Sussex",
    county_weights: {
      34037: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 34037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07440",
    lat: 40.94668,
    lng: -74.29421,
    city: "Pequannock",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4560,
    density: 1137.5,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07442",
    lat: 41.0024,
    lng: -74.28589,
    city: "Pompton Lakes",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10998,
    density: 1472.9,
    county_fips: 34031,
    county_name: "Passaic",
    county_weights: {
      34031: 100,
    },
    county_names_all: "Passaic",
    county_fips_all: 34031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07444",
    lat: 40.96782,
    lng: -74.30724,
    city: "Pompton Plains",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10542,
    density: 777.7,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07446",
    lat: 41.05944,
    lng: -74.14532,
    city: "Ramsey",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14870,
    density: 1044,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07450",
    lat: 40.98219,
    lng: -74.11275,
    city: "Ridgewood",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25182,
    density: 1690.6,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07452",
    lat: 40.96008,
    lng: -74.12498,
    city: "Glen Rock",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11747,
    density: 1677.7,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07456",
    lat: 41.10647,
    lng: -74.27487,
    city: "Ringwood",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12183,
    density: 183.8,
    county_fips: 34031,
    county_name: "Passaic",
    county_weights: {
      34031: 100,
    },
    county_names_all: "Passaic",
    county_fips_all: 34031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07457",
    lat: 40.99212,
    lng: -74.3125,
    city: "Riverdale",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4179,
    density: 796.3,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07458",
    lat: 41.04583,
    lng: -74.0971,
    city: "Saddle River",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11439,
    density: 434.3,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07460",
    lat: 41.11341,
    lng: -74.49006,
    city: "Stockholm",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3521,
    density: 47.6,
    county_fips: 34037,
    county_name: "Sussex",
    county_weights: {
      34027: 0.11,
      34031: 34.12,
      34037: 65.77,
    },
    county_names_all: "Sussex|Passaic|Morris",
    county_fips_all: "34037|34031|34027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07461",
    lat: 41.24213,
    lng: -74.60648,
    city: "Sussex",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17884,
    density: 83.2,
    county_fips: 34037,
    county_name: "Sussex",
    county_weights: {
      34037: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 34037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07462",
    lat: 41.19873,
    lng: -74.48911,
    city: "Vernon",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6267,
    density: 142.3,
    county_fips: 34037,
    county_name: "Sussex",
    county_weights: {
      34037: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 34037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07463",
    lat: 41.01334,
    lng: -74.12585,
    city: "Waldwick",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10051,
    density: 1896.5,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07465",
    lat: 41.05015,
    lng: -74.29849,
    city: "Wanaque",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6374,
    density: 294.3,
    county_fips: 34031,
    county_name: "Passaic",
    county_weights: {
      34031: 100,
    },
    county_names_all: "Passaic",
    county_fips_all: 34031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07470",
    lat: 40.94805,
    lng: -74.24504,
    city: "Wayne",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53679,
    density: 868.1,
    county_fips: 34031,
    county_name: "Passaic",
    county_weights: {
      34031: 100,
    },
    county_names_all: "Passaic",
    county_fips_all: 34031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07480",
    lat: 41.08713,
    lng: -74.3779,
    city: "West Milford",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15377,
    density: 179.6,
    county_fips: 34031,
    county_name: "Passaic",
    county_weights: {
      34031: 100,
    },
    county_names_all: "Passaic",
    county_fips_all: 34031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07481",
    lat: 40.99891,
    lng: -74.16757,
    city: "Wyckoff",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16959,
    density: 993.2,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07501",
    lat: 40.9125,
    lng: -74.17099,
    city: "Paterson",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32484,
    density: 6967.4,
    county_fips: 34031,
    county_name: "Passaic",
    county_weights: {
      34031: 100,
    },
    county_names_all: "Passaic",
    county_fips_all: 34031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07502",
    lat: 40.91903,
    lng: -74.19461,
    city: "Paterson",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15762,
    density: 7083,
    county_fips: 34031,
    county_name: "Passaic",
    county_weights: {
      34031: 100,
    },
    county_names_all: "Passaic",
    county_fips_all: 34031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07503",
    lat: 40.89768,
    lng: -74.15353,
    city: "Paterson",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17535,
    density: 4378,
    county_fips: 34031,
    county_name: "Passaic",
    county_weights: {
      34031: 100,
    },
    county_names_all: "Passaic",
    county_fips_all: 34031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07504",
    lat: 40.912,
    lng: -74.14121,
    city: "Paterson",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11886,
    density: 5515.3,
    county_fips: 34031,
    county_name: "Passaic",
    county_weights: {
      34003: 0.43,
      34031: 99.57,
    },
    county_names_all: "Passaic|Bergen",
    county_fips_all: "34031|34003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07505",
    lat: 40.91694,
    lng: -74.17222,
    city: "Paterson",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3303,
    density: 5210.2,
    county_fips: 34031,
    county_name: "Passaic",
    county_weights: {
      34031: 100,
    },
    county_names_all: "Passaic",
    county_fips_all: 34031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07506",
    lat: 40.95794,
    lng: -74.15815,
    city: "Hawthorne",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18762,
    density: 2182.9,
    county_fips: 34031,
    county_name: "Passaic",
    county_weights: {
      34031: 100,
    },
    county_names_all: "Passaic",
    county_fips_all: 34031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07508",
    lat: 40.95448,
    lng: -74.18423,
    city: "Haledon",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22562,
    density: 1731.3,
    county_fips: 34031,
    county_name: "Passaic",
    county_weights: {
      34031: 100,
    },
    county_names_all: "Passaic",
    county_fips_all: 34031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07512",
    lat: 40.90385,
    lng: -74.22118,
    city: "Totowa",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10810,
    density: 1054,
    county_fips: 34031,
    county_name: "Passaic",
    county_weights: {
      34031: 100,
    },
    county_names_all: "Passaic",
    county_fips_all: 34031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07513",
    lat: 40.90565,
    lng: -74.14869,
    city: "Paterson",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11417,
    density: 7765.8,
    county_fips: 34031,
    county_name: "Passaic",
    county_weights: {
      34031: 100,
    },
    county_names_all: "Passaic",
    county_fips_all: 34031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07514",
    lat: 40.92596,
    lng: -74.14452,
    city: "Paterson",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18507,
    density: 7703.4,
    county_fips: 34031,
    county_name: "Passaic",
    county_weights: {
      34003: 0.24,
      34031: 99.76,
    },
    county_names_all: "Passaic|Bergen",
    county_fips_all: "34031|34003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07522",
    lat: 40.92413,
    lng: -74.17928,
    city: "Paterson",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21301,
    density: 9383.7,
    county_fips: 34031,
    county_name: "Passaic",
    county_weights: {
      34031: 100,
    },
    county_names_all: "Passaic",
    county_fips_all: 34031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07524",
    lat: 40.93226,
    lng: -74.15674,
    city: "Paterson",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13289,
    density: 6766.6,
    county_fips: 34031,
    county_name: "Passaic",
    county_weights: {
      34031: 100,
    },
    county_names_all: "Passaic",
    county_fips_all: 34031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07601",
    lat: 40.8891,
    lng: -74.04614,
    city: "Hackensack",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44266,
    density: 4071.4,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07603",
    lat: 40.87507,
    lng: -74.02934,
    city: "Bogota",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8375,
    density: 4285,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07604",
    lat: 40.86166,
    lng: -74.07413,
    city: "Hasbrouck Heights",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12026,
    density: 3017.3,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07605",
    lat: 40.86362,
    lng: -73.9899,
    city: "Leonia",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9059,
    density: 2320.4,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07606",
    lat: 40.85783,
    lng: -74.05177,
    city: "South Hackensack",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2457,
    density: 1294.5,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07607",
    lat: 40.90249,
    lng: -74.06337,
    city: "Maywood",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9626,
    density: 2888.5,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07608",
    lat: 40.85297,
    lng: -74.06045,
    city: "Teterboro",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 110,
    density: 24.8,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07620",
    lat: 40.96165,
    lng: -73.91983,
    city: "Alpine",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1459,
    density: 88,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07621",
    lat: 40.92357,
    lng: -73.99824,
    city: "Bergenfield",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27375,
    density: 3636.6,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07624",
    lat: 40.97329,
    lng: -73.96044,
    city: "Closter",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8551,
    density: 1044.7,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07626",
    lat: 40.94054,
    lng: -73.9596,
    city: "Cresskill",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8701,
    density: 1627.1,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07627",
    lat: 40.95504,
    lng: -73.95678,
    city: "Demarest",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4911,
    density: 914.9,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07628",
    lat: 40.94524,
    lng: -73.99227,
    city: "Dumont",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17598,
    density: 3489.6,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07630",
    lat: 40.97484,
    lng: -74.024,
    city: "Emerson",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7606,
    density: 1316.4,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07631",
    lat: 40.89161,
    lng: -73.97368,
    city: "Englewood",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28390,
    density: 2216.1,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07632",
    lat: 40.88227,
    lng: -73.94672,
    city: "Englewood Cliffs",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5349,
    density: 971.4,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07640",
    lat: 40.9899,
    lng: -73.98037,
    city: "Harrington Park",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4735,
    density: 990.6,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07641",
    lat: 40.96224,
    lng: -73.9976,
    city: "Haworth",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3400,
    density: 677.6,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07642",
    lat: 41.00742,
    lng: -74.04402,
    city: "Hillsdale",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10287,
    density: 1368.8,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07643",
    lat: 40.84635,
    lng: -74.03879,
    city: "Little Ferry",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10761,
    density: 2812.9,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07644",
    lat: 40.87836,
    lng: -74.08145,
    city: "Lodi",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24389,
    density: 4144.2,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07645",
    lat: 41.05293,
    lng: -74.04985,
    city: "Montvale",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8538,
    density: 819.4,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07646",
    lat: 40.93368,
    lng: -74.01956,
    city: "New Milford",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16477,
    density: 2786.7,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07647",
    lat: 41.00674,
    lng: -73.94255,
    city: "Northvale",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5561,
    density: 946.8,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07648",
    lat: 40.99335,
    lng: -73.95103,
    city: "Norwood",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5789,
    density: 802.6,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07649",
    lat: 40.95622,
    lng: -74.03141,
    city: "Oradell",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8126,
    density: 1301.1,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07650",
    lat: 40.84716,
    lng: -73.99664,
    city: "Palisades Park",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20693,
    density: 6448.7,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07652",
    lat: 40.94553,
    lng: -74.07122,
    city: "Paramus",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26403,
    density: 976,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07656",
    lat: 41.03524,
    lng: -74.04232,
    city: "Park Ridge",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8751,
    density: 1296,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07657",
    lat: 40.83127,
    lng: -74.01471,
    city: "Ridgefield",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11209,
    density: 1702.1,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07660",
    lat: 40.85434,
    lng: -74.02013,
    city: "Ridgefield Park",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12928,
    density: 2928.1,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07661",
    lat: 40.92697,
    lng: -74.03874,
    city: "River Edge",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11510,
    density: 2433.8,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07662",
    lat: 40.90698,
    lng: -74.07911,
    city: "Rochelle Park",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5580,
    density: 2174.8,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07663",
    lat: 40.90328,
    lng: -74.09545,
    city: "Saddle Brook",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13762,
    density: 1973.8,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07666",
    lat: 40.88998,
    lng: -74.01067,
    city: "Teaneck",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40461,
    density: 2586.2,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07670",
    lat: 40.91758,
    lng: -73.95323,
    city: "Tenafly",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14550,
    density: 1224.9,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07675",
    lat: 41.00918,
    lng: -74.00428,
    city: "Westwood",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27022,
    density: 1081.8,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07676",
    lat: 40.98843,
    lng: -74.06359,
    city: "Township Of Washington",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9136,
    density: 1194.4,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07677",
    lat: 41.0253,
    lng: -74.06038,
    city: "Woodcliff Lake",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5836,
    density: 667.4,
    county_fips: 34003,
    county_name: "Bergen",
    county_weights: {
      34003: 100,
    },
    county_names_all: "Bergen",
    county_fips_all: 34003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07701",
    lat: 40.36046,
    lng: -74.07866,
    city: "Red Bank",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23844,
    density: 1005.7,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07702",
    lat: 40.32489,
    lng: -74.06002,
    city: "Shrewsbury",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4082,
    density: 729.5,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07703",
    lat: 40.31411,
    lng: -74.046,
    city: "Fort Monmouth",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 117,
    density: 66.7,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07704",
    lat: 40.36176,
    lng: -74.03926,
    city: "Fair Haven",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5833,
    density: 1403.8,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07711",
    lat: 40.2379,
    lng: -74.0076,
    city: "Allenhurst",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1711,
    density: 1021.1,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07712",
    lat: 40.24805,
    lng: -74.05531,
    city: "Asbury Park",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38228,
    density: 1207.2,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07716",
    lat: 40.40237,
    lng: -74.03533,
    city: "Atlantic Highlands",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8306,
    density: 728,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07717",
    lat: 40.19129,
    lng: -74.01657,
    city: "Avon By The Sea",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1731,
    density: 1570.5,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07718",
    lat: 40.42045,
    lng: -74.08488,
    city: "Belford",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7508,
    density: 1400.1,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07719",
    lat: 40.16864,
    lng: -74.07271,
    city: "Belmar",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21289,
    density: 647.8,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07720",
    lat: 40.20176,
    lng: -74.01276,
    city: "Bradley Beach",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4175,
    density: 2649.5,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07721",
    lat: 40.43556,
    lng: -74.23555,
    city: "Cliffwood",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3337,
    density: 1412.9,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34023: 11.02,
      34025: 88.98,
    },
    county_names_all: "Monmouth|Middlesex",
    county_fips_all: "34025|34023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07722",
    lat: 40.28765,
    lng: -74.16745,
    city: "Colts Neck",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9992,
    density: 111.7,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07723",
    lat: 40.25016,
    lng: -74.00081,
    city: "Deal",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 770,
    density: 180.9,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07724",
    lat: 40.29801,
    lng: -74.07517,
    city: "Eatontown",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21162,
    density: 673.9,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07726",
    lat: 40.28318,
    lng: -74.34232,
    city: "Englishtown",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43500,
    density: 507.7,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34023: 1.33,
      34025: 98.67,
    },
    county_names_all: "Monmouth|Middlesex",
    county_fips_all: "34025|34023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07727",
    lat: 40.20352,
    lng: -74.15863,
    city: "Farmingdale",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6061,
    density: 91.8,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07728",
    lat: 40.22522,
    lng: -74.28447,
    city: "Freehold",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55598,
    density: 432.7,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07730",
    lat: 40.42611,
    lng: -74.17422,
    city: "Hazlet",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16664,
    density: 1238.2,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07731",
    lat: 40.15014,
    lng: -74.20316,
    city: "Howell",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38783,
    density: 471.2,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07732",
    lat: 40.43115,
    lng: -73.99192,
    city: "Highlands",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4814,
    density: 492.7,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07733",
    lat: 40.37683,
    lng: -74.17259,
    city: "Holmdel",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16530,
    density: 359.1,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07734",
    lat: 40.44309,
    lng: -74.13517,
    city: "Keansburg",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13125,
    density: 2984.7,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07735",
    lat: 40.44108,
    lng: -74.2028,
    city: "Keyport",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18530,
    density: 1473.6,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34023: 16.02,
      34025: 83.98,
    },
    county_names_all: "Monmouth|Middlesex",
    county_fips_all: "34025|34023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07737",
    lat: 40.40953,
    lng: -74.06444,
    city: "Leonardo",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4186,
    density: 616,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07738",
    lat: 40.33918,
    lng: -74.12841,
    city: "Lincroft",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6501,
    density: 445.8,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07739",
    lat: 40.33569,
    lng: -74.03452,
    city: "Little Silver",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5817,
    density: 831.5,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07740",
    lat: 40.29581,
    lng: -73.9919,
    city: "Long Branch",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30557,
    density: 2235.9,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07746",
    lat: 40.31675,
    lng: -74.25029,
    city: "Marlboro",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18164,
    density: 566.7,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07747",
    lat: 40.41312,
    lng: -74.2521,
    city: "Matawan",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31402,
    density: 947.9,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 53.76,
      34025: 46.24,
    },
    county_names_all: "Middlesex|Monmouth",
    county_fips_all: "34023|34025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07748",
    lat: 40.39524,
    lng: -74.11573,
    city: "Middletown",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26773,
    density: 795.2,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07750",
    lat: 40.33639,
    lng: -73.98632,
    city: "Monmouth Beach",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3226,
    density: 1195.4,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07751",
    lat: 40.36191,
    lng: -74.25821,
    city: "Morganville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19851,
    density: 460.6,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07753",
    lat: 40.21184,
    lng: -74.07421,
    city: "Neptune",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36583,
    density: 885.3,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07755",
    lat: 40.26351,
    lng: -74.02344,
    city: "Oakhurst",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6178,
    density: 813.1,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07756",
    lat: 40.21184,
    lng: -74.00832,
    city: "Ocean Grove",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3151,
    density: 3253.9,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07757",
    lat: 40.31583,
    lng: -74.01855,
    city: "Oceanport",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5598,
    density: 758.4,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07758",
    lat: 40.431,
    lng: -74.103,
    city: "Port Monmouth",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4363,
    density: 1052.5,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07760",
    lat: 40.37053,
    lng: -74.00495,
    city: "Rumson",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8348,
    density: 380.7,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07762",
    lat: 40.15294,
    lng: -74.0359,
    city: "Spring Lake",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8156,
    density: 1116.2,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07764",
    lat: 40.28832,
    lng: -74.01854,
    city: "West Long Branch",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7911,
    density: 1069.5,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07801",
    lat: 40.93167,
    lng: -74.54643,
    city: "Dover",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25174,
    density: 750.4,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07803",
    lat: 40.87819,
    lng: -74.60003,
    city: "Mine Hill",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3511,
    density: 461.3,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07820",
    lat: 40.93104,
    lng: -74.80424,
    city: "Allamuchy",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7,
    density: 1.8,
    county_fips: 34041,
    county_name: "Warren",
    county_weights: {
      34041: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 34041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07821",
    lat: 40.96461,
    lng: -74.74807,
    city: "Andover",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8933,
    density: 80.6,
    county_fips: 34037,
    county_name: "Sussex",
    county_weights: {
      34037: 83.89,
      34041: 16.11,
    },
    county_names_all: "Sussex|Warren",
    county_fips_all: "34037|34041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07822",
    lat: 41.1409,
    lng: -74.70373,
    city: "Augusta",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1002,
    density: 52.4,
    county_fips: 34037,
    county_name: "Sussex",
    county_weights: {
      34037: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 34037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07823",
    lat: 40.82589,
    lng: -75.03781,
    city: "Belvidere",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7981,
    density: 122.9,
    county_fips: 34041,
    county_name: "Warren",
    county_weights: {
      34041: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 34041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07825",
    lat: 40.98308,
    lng: -74.9623,
    city: "Blairstown",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9686,
    density: 44,
    county_fips: 34041,
    county_name: "Warren",
    county_weights: {
      34037: 2.17,
      34041: 97.83,
    },
    county_names_all: "Warren|Sussex",
    county_fips_all: "34041|34037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07826",
    lat: 41.17633,
    lng: -74.79042,
    city: "Branchville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5827,
    density: 38.6,
    county_fips: 34037,
    county_name: "Sussex",
    county_weights: {
      34037: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 34037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07827",
    lat: 41.28918,
    lng: -74.74351,
    city: "Montague",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3979,
    density: 28.9,
    county_fips: 34037,
    county_name: "Sussex",
    county_weights: {
      34037: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 34037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07828",
    lat: 40.88559,
    lng: -74.75237,
    city: "Budd Lake",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15580,
    density: 424.6,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07830",
    lat: 40.72099,
    lng: -74.80033,
    city: "Califon",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7412,
    density: 110,
    county_fips: 34019,
    county_name: "Hunterdon",
    county_weights: {
      34019: 81.89,
      34027: 18.11,
    },
    county_names_all: "Hunterdon|Morris",
    county_fips_all: "34019|34027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07831",
    lat: 40.73909,
    lng: -74.94678,
    city: "Changewater",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 34041,
    county_name: "Warren",
    county_weights: {
      34019: 1.81,
      34041: 98.19,
    },
    county_names_all: "Warren|Hunterdon",
    county_fips_all: "34041|34019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07832",
    lat: 40.94755,
    lng: -75.06385,
    city: "Columbia",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3223,
    density: 29.6,
    county_fips: 34041,
    county_name: "Warren",
    county_weights: {
      34041: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 34041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07833",
    lat: 40.89422,
    lng: -75.06979,
    city: "Delaware",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 111,
    density: 139.1,
    county_fips: 34041,
    county_name: "Warren",
    county_weights: {
      34041: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 34041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07834",
    lat: 40.88752,
    lng: -74.48689,
    city: "Denville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17717,
    density: 589.1,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07836",
    lat: 40.84767,
    lng: -74.70163,
    city: "Flanders",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11253,
    density: 300.2,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07838",
    lat: 40.88925,
    lng: -74.91042,
    city: "Great Meadows",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3069,
    density: 45.8,
    county_fips: 34041,
    county_name: "Warren",
    county_weights: {
      34041: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 34041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07840",
    lat: 40.86034,
    lng: -74.83192,
    city: "Hackettstown",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30347,
    density: 313.9,
    county_fips: 34041,
    county_name: "Warren",
    county_weights: {
      34027: 23.62,
      34041: 76.38,
    },
    county_names_all: "Warren|Morris",
    county_fips_all: "34041|34027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07842",
    lat: 40.94477,
    lng: -74.50065,
    city: "Hibernia",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69,
    density: 105.8,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07843",
    lat: 40.93989,
    lng: -74.65928,
    city: "Hopatcong",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11389,
    density: 1131,
    county_fips: 34037,
    county_name: "Sussex",
    county_weights: {
      34037: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 34037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07844",
    lat: 40.90861,
    lng: -74.96961,
    city: "Hope",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 34041,
    county_name: "Warren",
    county_weights: {
      34041: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 34041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07846",
    lat: 40.96694,
    lng: -74.87671,
    city: "Johnsonburg",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43,
    density: 202.7,
    county_fips: 34041,
    county_name: "Warren",
    county_weights: {
      34041: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 34041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07847",
    lat: 40.8856,
    lng: -74.6237,
    city: "Kenvil",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2083,
    density: 332.2,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07848",
    lat: 41.10339,
    lng: -74.68312,
    city: "Lafayette",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4631,
    density: 78,
    county_fips: 34037,
    county_name: "Sussex",
    county_weights: {
      34037: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 34037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07849",
    lat: 40.96861,
    lng: -74.61066,
    city: "Lake Hopatcong",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8865,
    density: 511.2,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 99.61,
      34037: 0.39,
    },
    county_names_all: "Morris|Sussex",
    county_fips_all: "34027|34037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07850",
    lat: 40.90716,
    lng: -74.66158,
    city: "Landing",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7092,
    density: 983.7,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07851",
    lat: 41.19883,
    lng: -74.85923,
    city: "Layton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 185,
    density: 6.2,
    county_fips: 34037,
    county_name: "Sussex",
    county_weights: {
      34037: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 34037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07852",
    lat: 40.88374,
    lng: -74.66531,
    city: "Ledgewood",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4130,
    density: 441.2,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07853",
    lat: 40.78785,
    lng: -74.78315,
    city: "Long Valley",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13037,
    density: 154.8,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07856",
    lat: 40.9189,
    lng: -74.6336,
    city: "Mount Arlington",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4198,
    density: 472.1,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07857",
    lat: 40.89733,
    lng: -74.69998,
    city: "Netcong",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3167,
    density: 1170.8,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07860",
    lat: 41.0595,
    lng: -74.81159,
    city: "Newton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25355,
    density: 97.7,
    county_fips: 34037,
    county_name: "Sussex",
    county_weights: {
      34037: 94.11,
      34041: 5.89,
    },
    county_names_all: "Sussex|Warren",
    county_fips_all: "34037|34041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07863",
    lat: 40.81515,
    lng: -74.96562,
    city: "Oxford",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3767,
    density: 73.1,
    county_fips: 34041,
    county_name: "Warren",
    county_weights: {
      34041: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 34041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07865",
    lat: 40.78722,
    lng: -74.89845,
    city: "Port Murray",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2227,
    density: 52,
    county_fips: 34041,
    county_name: "Warren",
    county_weights: {
      34019: 21.24,
      34027: 14.29,
      34041: 64.47,
    },
    county_names_all: "Warren|Hunterdon|Morris",
    county_fips_all: "34041|34019|34027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07866",
    lat: 40.9531,
    lng: -74.48639,
    city: "Rockaway",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22651,
    density: 380.1,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07869",
    lat: 40.84528,
    lng: -74.5807,
    city: "Randolph",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25391,
    density: 488.6,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07870",
    lat: 40.80535,
    lng: -74.82303,
    city: "Schooleys Mountain",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23,
    density: 9.6,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07871",
    lat: 41.04666,
    lng: -74.62793,
    city: "Sparta",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20022,
    density: 202.6,
    county_fips: 34037,
    county_name: "Sussex",
    county_weights: {
      34037: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 34037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07874",
    lat: 40.9285,
    lng: -74.70994,
    city: "Stanhope",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8020,
    density: 366,
    county_fips: 34037,
    county_name: "Sussex",
    county_weights: {
      34037: 96.88,
      34041: 3.12,
    },
    county_names_all: "Sussex|Warren",
    county_fips_all: "34037|34041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07876",
    lat: 40.85302,
    lng: -74.65627,
    city: "Succasunna",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9383,
    density: 631.6,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07878",
    lat: 40.87152,
    lng: -74.47826,
    city: "Mount Tabor",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 550,
    density: 2326.7,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07880",
    lat: 40.874,
    lng: -74.88503,
    city: "Vienna",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 215,
    density: 75.5,
    county_fips: 34041,
    county_name: "Warren",
    county_weights: {
      34041: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 34041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07881",
    lat: 41.12213,
    lng: -74.93249,
    city: "Wallpack Center",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8,
    density: 0.3,
    county_fips: 34037,
    county_name: "Sussex",
    county_weights: {
      34037: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 34037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07882",
    lat: 40.75327,
    lng: -75.00748,
    city: "Washington",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13892,
    density: 169.9,
    county_fips: 34041,
    county_name: "Warren",
    county_weights: {
      34019: 5.09,
      34041: 94.91,
    },
    county_names_all: "Warren|Hunterdon",
    county_fips_all: "34041|34019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07885",
    lat: 40.93172,
    lng: -74.57688,
    city: "Wharton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10221,
    density: 268.8,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07901",
    lat: 40.71462,
    lng: -74.36604,
    city: "Summit",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23552,
    density: 1435.9,
    county_fips: 34039,
    county_name: "Union",
    county_weights: {
      34039: 100,
    },
    county_names_all: "Union",
    county_fips_all: 34039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07920",
    lat: 40.68374,
    lng: -74.55444,
    city: "Basking Ridge",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27150,
    density: 385.8,
    county_fips: 34035,
    county_name: "Somerset",
    county_weights: {
      34027: 19.36,
      34035: 80.64,
    },
    county_names_all: "Somerset|Morris",
    county_fips_all: "34035|34027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07921",
    lat: 40.65599,
    lng: -74.6771,
    city: "Bedminster",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7549,
    density: 158.6,
    county_fips: 34035,
    county_name: "Somerset",
    county_weights: {
      34035: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 34035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07922",
    lat: 40.67525,
    lng: -74.42806,
    city: "Berkeley Heights",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12270,
    density: 848.8,
    county_fips: 34039,
    county_name: "Union",
    county_weights: {
      34039: 100,
    },
    county_names_all: "Union",
    county_fips_all: 34039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07924",
    lat: 40.727,
    lng: -74.58941,
    city: "Bernardsville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7574,
    density: 244.3,
    county_fips: 34035,
    county_name: "Somerset",
    county_weights: {
      34035: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 34035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07926",
    lat: 40.80029,
    lng: -74.56879,
    city: "Brookside",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54,
    density: 58.8,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07927",
    lat: 40.82085,
    lng: -74.45479,
    city: "Cedar Knolls",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4250,
    density: 765.4,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07928",
    lat: 40.7262,
    lng: -74.41381,
    city: "Chatham",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18626,
    density: 776.5,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07930",
    lat: 40.78222,
    lng: -74.68642,
    city: "Chester",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8229,
    density: 124.9,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07931",
    lat: 40.70791,
    lng: -74.65732,
    city: "Far Hills",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3319,
    density: 58.4,
    county_fips: 34035,
    county_name: "Somerset",
    county_weights: {
      34027: 24.94,
      34035: 75.06,
    },
    county_names_all: "Somerset|Morris",
    county_fips_all: "34035|34027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07932",
    lat: 40.77717,
    lng: -74.39246,
    city: "Florham Park",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10140,
    density: 581.4,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07933",
    lat: 40.69198,
    lng: -74.46658,
    city: "Gillette",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2651,
    density: 193.2,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07934",
    lat: 40.72044,
    lng: -74.68159,
    city: "Gladstone",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1421,
    density: 176.6,
    county_fips: 34035,
    county_name: "Somerset",
    county_weights: {
      34027: 1.56,
      34035: 98.44,
    },
    county_names_all: "Somerset|Morris",
    county_fips_all: "34035|34027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07935",
    lat: 40.7371,
    lng: -74.45296,
    city: "Green Village",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 349,
    density: 51.6,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07936",
    lat: 40.81918,
    lng: -74.36382,
    city: "East Hanover",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11009,
    density: 539.8,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07939",
    lat: 40.66723,
    lng: -74.55215,
    city: "Lyons",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 254,
    density: 726.9,
    county_fips: 34035,
    county_name: "Somerset",
    county_weights: {
      34035: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 34035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07940",
    lat: 40.76006,
    lng: -74.41889,
    city: "Madison",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17794,
    density: 1398.4,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07945",
    lat: 40.78065,
    lng: -74.59928,
    city: "Mendham",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9130,
    density: 181,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07946",
    lat: 40.67698,
    lng: -74.51143,
    city: "Millington",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3261,
    density: 308.9,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 99.9,
      34035: 0.1,
    },
    county_names_all: "Morris|Somerset",
    county_fips_all: "34027|34035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07950",
    lat: 40.84569,
    lng: -74.48271,
    city: "Morris Plains",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19759,
    density: 837.3,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07960",
    lat: 40.78452,
    lng: -74.49813,
    city: "Morristown",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44998,
    density: 501.9,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07961",
    lat: 40.78105,
    lng: -74.43517,
    city: "Convent Station",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07970",
    lat: 40.80831,
    lng: -74.5727,
    city: "Mount Freedom",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 79,
    density: 114.9,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07974",
    lat: 40.69732,
    lng: -74.40321,
    city: "New Providence",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12794,
    density: 1244.7,
    county_fips: 34039,
    county_name: "Union",
    county_weights: {
      34039: 100,
    },
    county_names_all: "Union",
    county_fips_all: 34039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07976",
    lat: 40.72747,
    lng: -74.47704,
    city: "New Vernon",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 560,
    density: 62.4,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07977",
    lat: 40.70969,
    lng: -74.64786,
    city: "Peapack",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 503,
    density: 98.4,
    county_fips: 34035,
    county_name: "Somerset",
    county_weights: {
      34035: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 34035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07979",
    lat: 40.71225,
    lng: -74.72581,
    city: "Pottersville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 441,
    density: 192.3,
    county_fips: 34019,
    county_name: "Hunterdon",
    county_weights: {
      34019: 81.44,
      34035: 18.56,
    },
    county_names_all: "Hunterdon|Somerset",
    county_fips_all: "34019|34035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07980",
    lat: 40.6765,
    lng: -74.49465,
    city: "Stirling",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2607,
    density: 425.4,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "07981",
    lat: 40.82375,
    lng: -74.42029,
    city: "Whippany",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8839,
    density: 566.2,
    county_fips: 34027,
    county_name: "Morris",
    county_weights: {
      34027: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 34027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08001",
    lat: 39.55423,
    lng: -75.35683,
    city: "Alloway",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 847,
    density: 98.4,
    county_fips: 34033,
    county_name: "Salem",
    county_weights: {
      34033: 100,
    },
    county_names_all: "Salem",
    county_fips_all: 34033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08002",
    lat: 39.93142,
    lng: -75.02515,
    city: "Cherry Hill",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22794,
    density: 1220.8,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08003",
    lat: 39.88334,
    lng: -74.97191,
    city: "Cherry Hill",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29856,
    density: 1048.9,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08004",
    lat: 39.75494,
    lng: -74.83007,
    city: "Atco",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11366,
    density: 170.4,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08005",
    lat: 39.75503,
    lng: -74.30626,
    city: "Barnegat",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24444,
    density: 176.3,
    county_fips: 34029,
    county_name: "Ocean",
    county_weights: {
      34029: 100,
    },
    county_names_all: "Ocean",
    county_fips_all: 34029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08006",
    lat: 39.75299,
    lng: -74.10953,
    city: "Barnegat Light",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 404,
    density: 187.7,
    county_fips: 34029,
    county_name: "Ocean",
    county_weights: {
      34029: 100,
    },
    county_names_all: "Ocean",
    county_fips_all: 34029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08007",
    lat: 39.86509,
    lng: -75.05379,
    city: "Barrington",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4812,
    density: 1382.4,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08008",
    lat: 39.62188,
    lng: -74.22421,
    city: "Beach Haven",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6896,
    density: 246.3,
    county_fips: 34029,
    county_name: "Ocean",
    county_weights: {
      34029: 100,
    },
    county_names_all: "Ocean",
    county_fips_all: 34029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08009",
    lat: 39.76154,
    lng: -74.93279,
    city: "Berlin",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12903,
    density: 301.3,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08010",
    lat: 40.05484,
    lng: -74.91407,
    city: "Beverly",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11115,
    density: 1182.6,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08011",
    lat: 39.97504,
    lng: -74.71371,
    city: "Birmingham",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08012",
    lat: 39.78409,
    lng: -75.05586,
    city: "Blackwood",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38708,
    density: 996.4,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 60.1,
      34015: 39.9,
    },
    county_names_all: "Camden|Gloucester",
    county_fips_all: "34007|34015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08014",
    lat: 39.81186,
    lng: -75.36286,
    city: "Bridgeport",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 403,
    density: 43,
    county_fips: 34015,
    county_name: "Gloucester",
    county_weights: {
      34015: 100,
    },
    county_names_all: "Gloucester",
    county_fips_all: 34015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08015",
    lat: 39.92981,
    lng: -74.53966,
    city: "Browns Mills",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19236,
    density: 132.1,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08016",
    lat: 40.06926,
    lng: -74.83198,
    city: "Burlington",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33471,
    density: 597.5,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08019",
    lat: 39.76733,
    lng: -74.52781,
    city: "Chatsworth",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1142,
    density: 3.9,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08020",
    lat: 39.79674,
    lng: -75.22271,
    city: "Clarksboro",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2914,
    density: 247.2,
    county_fips: 34015,
    county_name: "Gloucester",
    county_weights: {
      34015: 100,
    },
    county_names_all: "Gloucester",
    county_fips_all: 34015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08021",
    lat: 39.80604,
    lng: -75.00025,
    city: "Clementon",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43835,
    density: 1305.4,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08022",
    lat: 40.06516,
    lng: -74.70905,
    city: "Columbus",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9258,
    density: 168.2,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08023",
    lat: 39.68825,
    lng: -75.49761,
    city: "Deepwater",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 274,
    density: 125.2,
    county_fips: 34033,
    county_name: "Salem",
    county_weights: {
      34033: 100,
    },
    county_names_all: "Salem",
    county_fips_all: 34033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08026",
    lat: 39.83329,
    lng: -74.9657,
    city: "Gibbsboro",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2231,
    density: 400.3,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08027",
    lat: 39.82883,
    lng: -75.29345,
    city: "Gibbstown",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4816,
    density: 248.4,
    county_fips: 34015,
    county_name: "Gloucester",
    county_weights: {
      34015: 100,
    },
    county_names_all: "Gloucester",
    county_fips_all: 34015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08028",
    lat: 39.69336,
    lng: -75.11949,
    city: "Glassboro",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21596,
    density: 574.9,
    county_fips: 34015,
    county_name: "Gloucester",
    county_weights: {
      34015: 100,
    },
    county_names_all: "Gloucester",
    county_fips_all: 34015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08029",
    lat: 39.84097,
    lng: -75.06717,
    city: "Glendora",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4858,
    density: 1744.8,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08030",
    lat: 39.89023,
    lng: -75.1178,
    city: "Gloucester City",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13117,
    density: 1809.2,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08031",
    lat: 39.86655,
    lng: -75.09408,
    city: "Bellmawr",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11375,
    density: 1472,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 99.89,
      34015: 0.11,
    },
    county_names_all: "Camden|Gloucester",
    county_fips_all: "34007|34015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08032",
    lat: 39.78048,
    lng: -75.05952,
    city: "Grenloch",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 34015,
    county_name: "Gloucester",
    county_weights: {
      34007: 3.62,
      34015: 96.38,
    },
    county_names_all: "Gloucester|Camden",
    county_fips_all: "34015|34007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08033",
    lat: 39.89332,
    lng: -75.03723,
    city: "Haddonfield",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15883,
    density: 1555.6,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08034",
    lat: 39.90593,
    lng: -74.99935,
    city: "Cherry Hill",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18659,
    density: 1219.5,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08035",
    lat: 39.87914,
    lng: -75.06435,
    city: "Haddon Heights",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7654,
    density: 1874.8,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08036",
    lat: 39.97669,
    lng: -74.83708,
    city: "Hainesport",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5885,
    density: 352.9,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08037",
    lat: 39.63272,
    lng: -74.77226,
    city: "Hammonton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22779,
    density: 71.8,
    county_fips: 34001,
    county_name: "Atlantic",
    county_weights: {
      34001: 79.9,
      34007: 20.1,
    },
    county_names_all: "Atlantic|Camden",
    county_fips_all: "34001|34007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08038",
    lat: 39.47391,
    lng: -75.48852,
    city: "Hancocks Bridge",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 190,
    density: 4.2,
    county_fips: 34033,
    county_name: "Salem",
    county_weights: {
      34033: 100,
    },
    county_names_all: "Salem",
    county_fips_all: 34033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08039",
    lat: 39.68662,
    lng: -75.27661,
    city: "Harrisonville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 186,
    density: 133,
    county_fips: 34015,
    county_name: "Gloucester",
    county_weights: {
      34015: 100,
    },
    county_names_all: "Gloucester",
    county_fips_all: 34015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08041",
    lat: 40.03852,
    lng: -74.68263,
    city: "Jobstown",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 804,
    density: 27.2,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08042",
    lat: 40.01363,
    lng: -74.662,
    city: "Juliustown",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 209,
    density: 94.4,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08043",
    lat: 39.84502,
    lng: -74.95492,
    city: "Voorhees",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29195,
    density: 982.7,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08045",
    lat: 39.86722,
    lng: -75.02912,
    city: "Lawnside",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2811,
    density: 777.9,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08046",
    lat: 40.02787,
    lng: -74.88709,
    city: "Willingboro",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31857,
    density: 1618.8,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08048",
    lat: 39.95644,
    lng: -74.80627,
    city: "Lumberton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12179,
    density: 387.8,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08049",
    lat: 39.85463,
    lng: -75.03816,
    city: "Magnolia",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5186,
    density: 1633.5,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08050",
    lat: 39.70291,
    lng: -74.24576,
    city: "Manahawkin",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25503,
    density: 318.7,
    county_fips: 34029,
    county_name: "Ocean",
    county_weights: {
      34029: 100,
    },
    county_names_all: "Ocean",
    county_fips_all: 34029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08051",
    lat: 39.78583,
    lng: -75.17903,
    city: "Mantua",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10994,
    density: 1103.3,
    county_fips: 34015,
    county_name: "Gloucester",
    county_weights: {
      34015: 100,
    },
    county_names_all: "Gloucester",
    county_fips_all: 34015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08052",
    lat: 39.952,
    lng: -74.99502,
    city: "Maple Shade",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18590,
    density: 1874.1,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 99.81,
      34007: 0.19,
    },
    county_names_all: "Burlington|Camden",
    county_fips_all: "34005|34007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08053",
    lat: 39.86051,
    lng: -74.89469,
    city: "Marlton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45138,
    density: 597.7,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08054",
    lat: 39.94835,
    lng: -74.90472,
    city: "Mount Laurel",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41443,
    density: 736.5,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08055",
    lat: 39.86373,
    lng: -74.82249,
    city: "Medford",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27307,
    density: 263.8,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08056",
    lat: 39.78355,
    lng: -75.25155,
    city: "Mickleton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5006,
    density: 212.3,
    county_fips: 34015,
    county_name: "Gloucester",
    county_weights: {
      34015: 100,
    },
    county_names_all: "Gloucester",
    county_fips_all: 34015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08057",
    lat: 39.97948,
    lng: -74.94105,
    city: "Moorestown",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20667,
    density: 521.5,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08059",
    lat: 39.88462,
    lng: -75.09309,
    city: "Mount Ephraim",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5380,
    density: 1690.4,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08060",
    lat: 40.00983,
    lng: -74.79105,
    city: "Mount Holly",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24556,
    density: 438.1,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08061",
    lat: 39.80459,
    lng: -75.207,
    city: "Mount Royal",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2769,
    density: 806.4,
    county_fips: 34015,
    county_name: "Gloucester",
    county_weights: {
      34015: 100,
    },
    county_names_all: "Gloucester",
    county_fips_all: 34015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08062",
    lat: 39.71465,
    lng: -75.22124,
    city: "Mullica Hill",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16419,
    density: 197,
    county_fips: 34015,
    county_name: "Gloucester",
    county_weights: {
      34015: 100,
    },
    county_names_all: "Gloucester",
    county_fips_all: 34015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08063",
    lat: 39.86758,
    lng: -75.18509,
    city: "National Park",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3007,
    density: 1128,
    county_fips: 34015,
    county_name: "Gloucester",
    county_weights: {
      34015: 100,
    },
    county_names_all: "Gloucester",
    county_fips_all: 34015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08064",
    lat: 39.93657,
    lng: -74.61095,
    city: "New Lisbon",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 225,
    density: 32.4,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08065",
    lat: 40.00234,
    lng: -75.03589,
    city: "Palmyra",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7162,
    density: 1495.3,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 99.87,
      34007: 0.13,
    },
    county_names_all: "Burlington|Camden",
    county_fips_all: "34005|34007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08066",
    lat: 39.83475,
    lng: -75.23017,
    city: "Paulsboro",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8022,
    density: 452.4,
    county_fips: 34015,
    county_name: "Gloucester",
    county_weights: {
      34015: 100,
    },
    county_names_all: "Gloucester",
    county_fips_all: 34015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08067",
    lat: 39.7388,
    lng: -75.41281,
    city: "Pedricktown",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1653,
    density: 33.5,
    county_fips: 34033,
    county_name: "Salem",
    county_weights: {
      34033: 100,
    },
    county_names_all: "Salem",
    county_fips_all: 34033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08068",
    lat: 39.9617,
    lng: -74.667,
    city: "Pemberton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7052,
    density: 116.9,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08069",
    lat: 39.70209,
    lng: -75.4501,
    city: "Penns Grove",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12442,
    density: 301.4,
    county_fips: 34033,
    county_name: "Salem",
    county_weights: {
      34033: 100,
    },
    county_names_all: "Salem",
    county_fips_all: 34033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08070",
    lat: 39.62494,
    lng: -75.50902,
    city: "Pennsville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12291,
    density: 229.3,
    county_fips: 34033,
    county_name: "Salem",
    county_weights: {
      34033: 100,
    },
    county_names_all: "Salem",
    county_fips_all: 34033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08071",
    lat: 39.73227,
    lng: -75.13457,
    city: "Pitman",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9381,
    density: 1092.7,
    county_fips: 34015,
    county_name: "Gloucester",
    county_weights: {
      34015: 100,
    },
    county_names_all: "Gloucester",
    county_fips_all: 34015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08072",
    lat: 39.54495,
    lng: -75.41258,
    city: "Quinton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 221,
    density: 240.4,
    county_fips: 34033,
    county_name: "Salem",
    county_weights: {
      34033: 100,
    },
    county_names_all: "Salem",
    county_fips_all: 34033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08073",
    lat: 40.00952,
    lng: -74.86698,
    city: "Rancocas",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 130,
    density: 579.9,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08074",
    lat: 39.71289,
    lng: -75.16379,
    city: "Richwood",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16,
    density: 11.1,
    county_fips: 34015,
    county_name: "Gloucester",
    county_weights: {
      34015: 100,
    },
    county_names_all: "Gloucester",
    county_fips_all: 34015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08075",
    lat: 40.02937,
    lng: -74.94999,
    city: "Riverside",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28617,
    density: 1118.6,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08077",
    lat: 40.00193,
    lng: -74.99515,
    city: "Riverton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19120,
    density: 910.9,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08078",
    lat: 39.85202,
    lng: -75.07542,
    city: "Runnemede",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8307,
    density: 1668.1,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08079",
    lat: 39.54284,
    lng: -75.43184,
    city: "Salem",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9793,
    density: 42.6,
    county_fips: 34033,
    county_name: "Salem",
    county_weights: {
      34033: 100,
    },
    county_names_all: "Salem",
    county_fips_all: 34033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08080",
    lat: 39.75714,
    lng: -75.11801,
    city: "Sewell",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37216,
    density: 491.5,
    county_fips: 34015,
    county_name: "Gloucester",
    county_weights: {
      34015: 100,
    },
    county_names_all: "Gloucester",
    county_fips_all: 34015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08081",
    lat: 39.73421,
    lng: -74.97564,
    city: "Sicklerville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50246,
    density: 768.5,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 96.15,
      34015: 3.85,
    },
    county_names_all: "Camden|Gloucester",
    county_fips_all: "34007|34015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08083",
    lat: 39.84138,
    lng: -75.02867,
    city: "Somerdale",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10137,
    density: 1561.3,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08084",
    lat: 39.82905,
    lng: -75.01557,
    city: "Stratford",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6968,
    density: 1713.2,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08085",
    lat: 39.75579,
    lng: -75.33017,
    city: "Swedesboro",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21074,
    density: 182.8,
    county_fips: 34015,
    county_name: "Gloucester",
    county_weights: {
      34015: 98.86,
      34033: 1.14,
    },
    county_names_all: "Gloucester|Salem",
    county_fips_all: "34015|34033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08086",
    lat: 39.85136,
    lng: -75.18582,
    city: "Thorofare",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7438,
    density: 410.1,
    county_fips: 34015,
    county_name: "Gloucester",
    county_weights: {
      34015: 100,
    },
    county_names_all: "Gloucester",
    county_fips_all: 34015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08087",
    lat: 39.60751,
    lng: -74.37994,
    city: "Tuckerton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25387,
    density: 139.9,
    county_fips: 34029,
    county_name: "Ocean",
    county_weights: {
      34005: 40.67,
      34029: 59.33,
    },
    county_names_all: "Ocean|Burlington",
    county_fips_all: "34029|34005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08088",
    lat: 39.84196,
    lng: -74.69075,
    city: "Vincentown",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24018,
    density: 61.6,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08089",
    lat: 39.71591,
    lng: -74.82686,
    city: "Waterford Works",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4611,
    density: 110.3,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08090",
    lat: 39.79777,
    lng: -75.14849,
    city: "Wenonah",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8895,
    density: 1175.3,
    county_fips: 34015,
    county_name: "Gloucester",
    county_weights: {
      34015: 100,
    },
    county_names_all: "Gloucester",
    county_fips_all: 34015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08091",
    lat: 39.80545,
    lng: -74.92558,
    city: "West Berlin",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5647,
    density: 654.7,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08092",
    lat: 39.65438,
    lng: -74.28428,
    city: "West Creek",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3257,
    density: 54.9,
    county_fips: 34029,
    county_name: "Ocean",
    county_weights: {
      34029: 100,
    },
    county_names_all: "Ocean",
    county_fips_all: 34029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08093",
    lat: 39.86098,
    lng: -75.13265,
    city: "Westville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9000,
    density: 858.6,
    county_fips: 34015,
    county_name: "Gloucester",
    county_weights: {
      34015: 100,
    },
    county_names_all: "Gloucester",
    county_fips_all: 34015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08094",
    lat: 39.65096,
    lng: -74.96529,
    city: "Williamstown",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40322,
    density: 284.2,
    county_fips: 34015,
    county_name: "Gloucester",
    county_weights: {
      34001: 10.77,
      34015: 89.23,
    },
    county_names_all: "Gloucester|Atlantic",
    county_fips_all: "34015|34001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08095",
    lat: 39.64514,
    lng: -74.85576,
    city: "Winslow",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15,
    density: 4.1,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08096",
    lat: 39.82921,
    lng: -75.12871,
    city: "Woodbury",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35187,
    density: 978.1,
    county_fips: 34015,
    county_name: "Gloucester",
    county_weights: {
      34015: 100,
    },
    county_names_all: "Gloucester",
    county_fips_all: 34015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08097",
    lat: 39.81571,
    lng: -75.15117,
    city: "Woodbury Heights",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3153,
    density: 925,
    county_fips: 34015,
    county_name: "Gloucester",
    county_weights: {
      34015: 100,
    },
    county_names_all: "Gloucester",
    county_fips_all: 34015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08098",
    lat: 39.63934,
    lng: -75.3316,
    city: "Woodstown",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9125,
    density: 60.9,
    county_fips: 34033,
    county_name: "Salem",
    county_weights: {
      34033: 100,
    },
    county_names_all: "Salem",
    county_fips_all: 34033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08102",
    lat: 39.95203,
    lng: -75.12134,
    city: "Camden",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8050,
    density: 3115.1,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08103",
    lat: 39.93533,
    lng: -75.11275,
    city: "Camden",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14239,
    density: 2569.9,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08104",
    lat: 39.91672,
    lng: -75.11203,
    city: "Camden",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22187,
    density: 2858.4,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08105",
    lat: 39.95174,
    lng: -75.09107,
    city: "Camden",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26807,
    density: 3990,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08106",
    lat: 39.89119,
    lng: -75.07388,
    city: "Audubon",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9811,
    density: 2328.3,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08107",
    lat: 39.90767,
    lng: -75.08344,
    city: "Oaklyn",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13533,
    density: 2918.1,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08108",
    lat: 39.91453,
    lng: -75.06192,
    city: "Collingswood",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18004,
    density: 2582.7,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08109",
    lat: 39.95006,
    lng: -75.05094,
    city: "Merchantville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22741,
    density: 1820.8,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08110",
    lat: 39.97243,
    lng: -75.06021,
    city: "Pennsauken",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19124,
    density: 1142.6,
    county_fips: 34007,
    county_name: "Camden",
    county_weights: {
      34007: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 34007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08201",
    lat: 39.42257,
    lng: -74.49511,
    city: "Absecon",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10029,
    density: 678,
    county_fips: 34001,
    county_name: "Atlantic",
    county_weights: {
      34001: 100,
    },
    county_names_all: "Atlantic",
    county_fips_all: 34001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08202",
    lat: 39.09659,
    lng: -74.74806,
    city: "Avalon",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1555,
    density: 86.8,
    county_fips: 34009,
    county_name: "Cape May",
    county_weights: {
      34009: 100,
    },
    county_names_all: "Cape May",
    county_fips_all: 34009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08203",
    lat: 39.41281,
    lng: -74.38006,
    city: "Brigantine",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8725,
    density: 512.5,
    county_fips: 34001,
    county_name: "Atlantic",
    county_weights: {
      34001: 100,
    },
    county_names_all: "Atlantic",
    county_fips_all: 34001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08204",
    lat: 38.97131,
    lng: -74.92054,
    city: "Cape May",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17257,
    density: 325.7,
    county_fips: 34009,
    county_name: "Cape May",
    county_weights: {
      34009: 100,
    },
    county_names_all: "Cape May",
    county_fips_all: 34009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08205",
    lat: 39.47455,
    lng: -74.45698,
    city: "Absecon",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26412,
    density: 242.3,
    county_fips: 34001,
    county_name: "Atlantic",
    county_weights: {
      34001: 100,
    },
    county_names_all: "Atlantic",
    county_fips_all: 34001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08210",
    lat: 39.11974,
    lng: -74.82248,
    city: "Cape May Court House",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16409,
    density: 92.4,
    county_fips: 34009,
    county_name: "Cape May",
    county_weights: {
      34009: 100,
    },
    county_names_all: "Cape May",
    county_fips_all: 34009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08212",
    lat: 38.93721,
    lng: -74.96509,
    city: "Cape May Point",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 165,
    density: 216,
    county_fips: 34009,
    county_name: "Cape May",
    county_weights: {
      34009: 100,
    },
    county_names_all: "Cape May",
    county_fips_all: 34009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08215",
    lat: 39.58962,
    lng: -74.58716,
    city: "Egg Harbor City",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14068,
    density: 43.8,
    county_fips: 34001,
    county_name: "Atlantic",
    county_weights: {
      34001: 53.96,
      34005: 46.04,
    },
    county_names_all: "Atlantic|Burlington",
    county_fips_all: "34001|34005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08217",
    lat: 39.57702,
    lng: -74.71879,
    city: "Elwood",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 84,
    density: 1405.5,
    county_fips: 34001,
    county_name: "Atlantic",
    county_weights: {
      34001: 100,
    },
    county_names_all: "Atlantic",
    county_fips_all: 34001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08221",
    lat: 39.33879,
    lng: -74.5652,
    city: "Linwood",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6719,
    density: 551.9,
    county_fips: 34001,
    county_name: "Atlantic",
    county_weights: {
      34001: 100,
    },
    county_names_all: "Atlantic",
    county_fips_all: 34001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08223",
    lat: 39.27021,
    lng: -74.6571,
    city: "Marmora",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4277,
    density: 127.5,
    county_fips: 34009,
    county_name: "Cape May",
    county_weights: {
      34009: 100,
    },
    county_names_all: "Cape May",
    county_fips_all: 34009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08224",
    lat: 39.59548,
    lng: -74.46352,
    city: "New Gretna",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 443,
    density: 118.1,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08225",
    lat: 39.36167,
    lng: -74.53963,
    city: "Northfield",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8103,
    density: 517,
    county_fips: 34001,
    county_name: "Atlantic",
    county_weights: {
      34001: 100,
    },
    county_names_all: "Atlantic",
    county_fips_all: 34001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08226",
    lat: 39.26812,
    lng: -74.60196,
    city: "Ocean City",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11065,
    density: 632.6,
    county_fips: 34009,
    county_name: "Cape May",
    county_weights: {
      34009: 100,
    },
    county_names_all: "Cape May",
    county_fips_all: 34009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08230",
    lat: 39.20381,
    lng: -74.70342,
    city: "Ocean View",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5250,
    density: 103.8,
    county_fips: 34009,
    county_name: "Cape May",
    county_weights: {
      34009: 100,
    },
    county_names_all: "Cape May",
    county_fips_all: 34009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08232",
    lat: 39.38771,
    lng: -74.51489,
    city: "Pleasantville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19611,
    density: 1290.9,
    county_fips: 34001,
    county_name: "Atlantic",
    county_weights: {
      34001: 100,
    },
    county_names_all: "Atlantic",
    county_fips_all: 34001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08234",
    lat: 39.38662,
    lng: -74.62369,
    city: "Egg Harbor Township",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41276,
    density: 262.7,
    county_fips: 34001,
    county_name: "Atlantic",
    county_weights: {
      34001: 100,
    },
    county_names_all: "Atlantic",
    county_fips_all: 34001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08240",
    lat: 39.48676,
    lng: -74.53633,
    city: "Pomona",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2530,
    density: 444.3,
    county_fips: 34001,
    county_name: "Atlantic",
    county_weights: {
      34001: 100,
    },
    county_names_all: "Atlantic",
    county_fips_all: 34001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08241",
    lat: 39.53278,
    lng: -74.48523,
    city: "Port Republic",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1093,
    density: 56.6,
    county_fips: 34001,
    county_name: "Atlantic",
    county_weights: {
      34001: 100,
    },
    county_names_all: "Atlantic",
    county_fips_all: 34001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08242",
    lat: 39.01786,
    lng: -74.88627,
    city: "Rio Grande",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2975,
    density: 241.3,
    county_fips: 34009,
    county_name: "Cape May",
    county_weights: {
      34009: 100,
    },
    county_names_all: "Cape May",
    county_fips_all: 34009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08243",
    lat: 39.15235,
    lng: -74.69758,
    city: "Sea Isle City",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2122,
    density: 371.7,
    county_fips: 34009,
    county_name: "Cape May",
    county_weights: {
      34009: 100,
    },
    county_names_all: "Cape May",
    county_fips_all: 34009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08244",
    lat: 39.31503,
    lng: -74.59808,
    city: "Somers Point",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10376,
    density: 813.7,
    county_fips: 34001,
    county_name: "Atlantic",
    county_weights: {
      34001: 100,
    },
    county_names_all: "Atlantic",
    county_fips_all: 34001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08245",
    lat: 39.1765,
    lng: -74.81902,
    city: "South Dennis",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 34009,
    county_name: "Cape May",
    county_weights: {
      34009: 100,
    },
    county_names_all: "Cape May",
    county_fips_all: 34009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08246",
    lat: 39.18098,
    lng: -74.76583,
    city: "South Seaville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64,
    density: 76.2,
    county_fips: 34009,
    county_name: "Cape May",
    county_weights: {
      34009: 100,
    },
    county_names_all: "Cape May",
    county_fips_all: 34009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08247",
    lat: 39.05279,
    lng: -74.78508,
    city: "Stone Harbor",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 960,
    density: 70.9,
    county_fips: 34009,
    county_name: "Cape May",
    county_weights: {
      34009: 100,
    },
    county_names_all: "Cape May",
    county_fips_all: 34009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08248",
    lat: 39.1944,
    lng: -74.66175,
    city: "Strathmere",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59,
    density: 43.3,
    county_fips: 34009,
    county_name: "Cape May",
    county_weights: {
      34009: 100,
    },
    county_names_all: "Cape May",
    county_fips_all: 34009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08251",
    lat: 39.02766,
    lng: -74.92573,
    city: "Villas",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10559,
    density: 579.7,
    county_fips: 34009,
    county_name: "Cape May",
    county_weights: {
      34009: 100,
    },
    county_names_all: "Cape May",
    county_fips_all: 34009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08260",
    lat: 38.99555,
    lng: -74.84088,
    city: "Wildwood",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12531,
    density: 303.4,
    county_fips: 34009,
    county_name: "Cape May",
    county_weights: {
      34009: 100,
    },
    county_names_all: "Cape May",
    county_fips_all: 34009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08270",
    lat: 39.26437,
    lng: -74.80861,
    city: "Woodbine",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8285,
    density: 31.1,
    county_fips: 34009,
    county_name: "Cape May",
    county_weights: {
      34001: 22.02,
      34009: 77.98,
    },
    county_names_all: "Cape May|Atlantic",
    county_fips_all: "34009|34001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08302",
    lat: 39.4397,
    lng: -75.2616,
    city: "Bridgeton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44640,
    density: 120.9,
    county_fips: 34011,
    county_name: "Cumberland",
    county_weights: {
      34011: 90.88,
      34033: 9.12,
    },
    county_names_all: "Cumberland|Salem",
    county_fips_all: "34011|34033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08310",
    lat: 39.52723,
    lng: -74.89769,
    city: "Buena",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1460,
    density: 46.1,
    county_fips: 34001,
    county_name: "Atlantic",
    county_weights: {
      34001: 100,
    },
    county_names_all: "Atlantic",
    county_fips_all: 34001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08311",
    lat: 39.32685,
    lng: -75.20804,
    city: "Cedarville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1987,
    density: 27.5,
    county_fips: 34011,
    county_name: "Cumberland",
    county_weights: {
      34011: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 34011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08312",
    lat: 39.66143,
    lng: -75.08375,
    city: "Clayton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7933,
    density: 556.1,
    county_fips: 34015,
    county_name: "Gloucester",
    county_weights: {
      34015: 100,
    },
    county_names_all: "Gloucester",
    county_fips_all: 34015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08314",
    lat: 39.21683,
    lng: -74.94113,
    city: "Delmont",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 390,
    density: 12.3,
    county_fips: 34011,
    county_name: "Cumberland",
    county_weights: {
      34011: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 34011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08316",
    lat: 39.28009,
    lng: -74.93186,
    city: "Dorchester",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 177,
    density: 8.3,
    county_fips: 34011,
    county_name: "Cumberland",
    county_weights: {
      34011: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 34011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08317",
    lat: 39.40398,
    lng: -74.82696,
    city: "Dorothy",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1677,
    density: 88,
    county_fips: 34001,
    county_name: "Atlantic",
    county_weights: {
      34001: 100,
    },
    county_names_all: "Atlantic",
    county_fips_all: 34001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08318",
    lat: 39.55657,
    lng: -75.17776,
    city: "Elmer",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12387,
    density: 59.5,
    county_fips: 34033,
    county_name: "Salem",
    county_weights: {
      34011: 5.08,
      34033: 94.92,
    },
    county_names_all: "Salem|Cumberland",
    county_fips_all: "34033|34011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08319",
    lat: 39.3645,
    lng: -74.81753,
    city: "Estell Manor",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1188,
    density: 30.5,
    county_fips: 34001,
    county_name: "Atlantic",
    county_weights: {
      34001: 100,
    },
    county_names_all: "Atlantic",
    county_fips_all: 34001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08320",
    lat: 39.3851,
    lng: -75.16059,
    city: "Fairton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1059,
    density: 968.3,
    county_fips: 34011,
    county_name: "Cumberland",
    county_weights: {
      34011: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 34011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08321",
    lat: 39.21961,
    lng: -75.14107,
    city: "Fortescue",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 112,
    density: 4.9,
    county_fips: 34011,
    county_name: "Cumberland",
    county_weights: {
      34011: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 34011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08322",
    lat: 39.61463,
    lng: -75.03385,
    city: "Franklinville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10292,
    density: 136.5,
    county_fips: 34015,
    county_name: "Gloucester",
    county_weights: {
      34015: 100,
    },
    county_names_all: "Gloucester",
    county_fips_all: 34015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08323",
    lat: 39.39557,
    lng: -75.36605,
    city: "Greenwich",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 457,
    density: 9.9,
    county_fips: 34011,
    county_name: "Cumberland",
    county_weights: {
      34011: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 34011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08324",
    lat: 39.21859,
    lng: -74.99999,
    city: "Heislerville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 341,
    density: 14.3,
    county_fips: 34011,
    county_name: "Cumberland",
    county_weights: {
      34011: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 34011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08326",
    lat: 39.53847,
    lng: -74.92761,
    city: "Landisville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1325,
    density: 160.7,
    county_fips: 34001,
    county_name: "Atlantic",
    county_weights: {
      34001: 100,
    },
    county_names_all: "Atlantic",
    county_fips_all: 34001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08327",
    lat: 39.25458,
    lng: -74.94657,
    city: "Leesburg",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5379,
    density: 216.7,
    county_fips: 34011,
    county_name: "Cumberland",
    county_weights: {
      34011: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 34011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08328",
    lat: 39.5797,
    lng: -75.06015,
    city: "Malaga",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1636,
    density: 331.8,
    county_fips: 34015,
    county_name: "Gloucester",
    county_weights: {
      34015: 100,
    },
    county_names_all: "Gloucester",
    county_fips_all: 34015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08329",
    lat: 39.2857,
    lng: -75.00338,
    city: "Mauricetown",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 351,
    density: 273.9,
    county_fips: 34011,
    county_name: "Cumberland",
    county_weights: {
      34011: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 34011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08330",
    lat: 39.4566,
    lng: -74.73814,
    city: "Mays Landing",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27385,
    density: 83,
    county_fips: 34001,
    county_name: "Atlantic",
    county_weights: {
      34001: 100,
    },
    county_names_all: "Atlantic",
    county_fips_all: 34001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08332",
    lat: 39.3705,
    lng: -75.0293,
    city: "Millville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34609,
    density: 127.9,
    county_fips: 34011,
    county_name: "Cumberland",
    county_weights: {
      34011: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 34011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08340",
    lat: 39.40087,
    lng: -74.88407,
    city: "Milmay",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1302,
    density: 18.1,
    county_fips: 34011,
    county_name: "Cumberland",
    county_weights: {
      34001: 18.86,
      34011: 81.14,
    },
    county_names_all: "Cumberland|Atlantic",
    county_fips_all: "34011|34001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08341",
    lat: 39.52002,
    lng: -74.9524,
    city: "Minotola",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2435,
    density: 937.3,
    county_fips: 34001,
    county_name: "Atlantic",
    county_weights: {
      34001: 100,
    },
    county_names_all: "Atlantic",
    county_fips_all: 34001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08343",
    lat: 39.64057,
    lng: -75.1699,
    city: "Monroeville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4927,
    density: 59,
    county_fips: 34033,
    county_name: "Salem",
    county_weights: {
      34015: 48.59,
      34033: 51.41,
    },
    county_names_all: "Salem|Gloucester",
    county_fips_all: "34033|34015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08344",
    lat: 39.56707,
    lng: -74.99185,
    city: "Newfield",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4197,
    density: 68.2,
    county_fips: 34015,
    county_name: "Gloucester",
    county_weights: {
      34001: 9.01,
      34011: 11.72,
      34015: 75.23,
      34033: 4.04,
    },
    county_names_all: "Gloucester|Cumberland|Atlantic|Salem",
    county_fips_all: "34015|34011|34001|34033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08345",
    lat: 39.28816,
    lng: -75.14668,
    city: "Newport",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 598,
    density: 8.1,
    county_fips: 34011,
    county_name: "Cumberland",
    county_weights: {
      34011: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 34011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08346",
    lat: 39.56926,
    lng: -74.85827,
    city: "Newtonville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 781,
    density: 123.6,
    county_fips: 34001,
    county_name: "Atlantic",
    county_weights: {
      34001: 100,
    },
    county_names_all: "Atlantic",
    county_fips_all: 34001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08348",
    lat: 39.31381,
    lng: -74.96594,
    city: "Port Elizabeth",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 189,
    density: 39.8,
    county_fips: 34011,
    county_name: "Cumberland",
    county_weights: {
      34011: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 34011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08349",
    lat: 39.266,
    lng: -75.06337,
    city: "Port Norris",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2390,
    density: 26.7,
    county_fips: 34011,
    county_name: "Cumberland",
    county_weights: {
      34011: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 34011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08350",
    lat: 39.49134,
    lng: -74.87413,
    city: "Richland",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 503,
    density: 59.9,
    county_fips: 34001,
    county_name: "Atlantic",
    county_weights: {
      34001: 100,
    },
    county_names_all: "Atlantic",
    county_fips_all: 34001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08352",
    lat: 39.47545,
    lng: -75.12724,
    city: "Rosenhayn",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 688,
    density: 972.1,
    county_fips: 34011,
    county_name: "Cumberland",
    county_weights: {
      34011: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 34011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08353",
    lat: 39.45954,
    lng: -75.29695,
    city: "Shiloh",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 368,
    density: 118.1,
    county_fips: 34011,
    county_name: "Cumberland",
    county_weights: {
      34011: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 34011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08360",
    lat: 39.49374,
    lng: -75.00352,
    city: "Vineland",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42225,
    density: 367.7,
    county_fips: 34011,
    county_name: "Cumberland",
    county_weights: {
      34001: 25.77,
      34011: 64.79,
      34015: 9.44,
    },
    county_names_all: "Cumberland|Atlantic|Gloucester",
    county_fips_all: "34011|34001|34015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08361",
    lat: 39.44843,
    lng: -74.95943,
    city: "Vineland",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18334,
    density: 233.4,
    county_fips: 34011,
    county_name: "Cumberland",
    county_weights: {
      34011: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 34011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08401",
    lat: 39.37964,
    lng: -74.45284,
    city: "Atlantic City",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37793,
    density: 1366.8,
    county_fips: 34001,
    county_name: "Atlantic",
    county_weights: {
      34001: 100,
    },
    county_names_all: "Atlantic",
    county_fips_all: 34001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08402",
    lat: 39.33069,
    lng: -74.50706,
    city: "Margate City",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5921,
    density: 1617.8,
    county_fips: 34001,
    county_name: "Atlantic",
    county_weights: {
      34001: 100,
    },
    county_names_all: "Atlantic",
    county_fips_all: 34001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08403",
    lat: 39.31915,
    lng: -74.53535,
    city: "Longport",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 903,
    density: 165.4,
    county_fips: 34001,
    county_name: "Atlantic",
    county_weights: {
      34001: 100,
    },
    county_names_all: "Atlantic",
    county_fips_all: 34001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08406",
    lat: 39.34565,
    lng: -74.48603,
    city: "Ventnor City",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9995,
    density: 1953.7,
    county_fips: 34001,
    county_name: "Atlantic",
    county_weights: {
      34001: 100,
    },
    county_names_all: "Atlantic",
    county_fips_all: 34001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08501",
    lat: 40.16022,
    lng: -74.55237,
    city: "Allentown",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6260,
    density: 88.9,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34005: 10.21,
      34021: 2.87,
      34025: 86.92,
    },
    county_names_all: "Monmouth|Burlington|Mercer",
    county_fips_all: "34025|34005|34021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08502",
    lat: 40.44815,
    lng: -74.65763,
    city: "Belle Mead",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11244,
    density: 328.1,
    county_fips: 34035,
    county_name: "Somerset",
    county_weights: {
      34035: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 34035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08505",
    lat: 40.10413,
    lng: -74.73959,
    city: "Bordentown",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17418,
    density: 299.1,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08510",
    lat: 40.18798,
    lng: -74.42351,
    city: "Millstone Township",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5851,
    density: 127.3,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08511",
    lat: 40.04441,
    lng: -74.55384,
    city: "Cookstown",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1226,
    density: 198.4,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08512",
    lat: 40.32166,
    lng: -74.52586,
    city: "Cranbury",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10880,
    density: 184.2,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34021: 6.63,
      34023: 93.37,
    },
    county_names_all: "Middlesex|Mercer",
    county_fips_all: "34023|34021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08514",
    lat: 40.13269,
    lng: -74.49811,
    city: "Cream Ridge",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4964,
    density: 70.1,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 75.37,
      34029: 24.63,
    },
    county_names_all: "Monmouth|Ocean",
    county_fips_all: "34025|34029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08515",
    lat: 40.1163,
    lng: -74.64568,
    city: "Chesterfield",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5972,
    density: 108.9,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08518",
    lat: 40.11541,
    lng: -74.80357,
    city: "Florence",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5471,
    density: 1101,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08520",
    lat: 40.25555,
    lng: -74.53269,
    city: "Hightstown",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27082,
    density: 579.7,
    county_fips: 34021,
    county_name: "Mercer",
    county_weights: {
      34021: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 34021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08525",
    lat: 40.39641,
    lng: -74.78185,
    city: "Hopewell",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4881,
    density: 84.2,
    county_fips: 34021,
    county_name: "Mercer",
    county_weights: {
      34019: 30.31,
      34021: 69.69,
    },
    county_names_all: "Mercer|Hunterdon",
    county_fips_all: "34021|34019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08527",
    lat: 40.10478,
    lng: -74.35035,
    city: "Jackson",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56848,
    density: 256.9,
    county_fips: 34029,
    county_name: "Ocean",
    county_weights: {
      34029: 100,
    },
    county_names_all: "Ocean",
    county_fips_all: 34029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08528",
    lat: 40.38791,
    lng: -74.61744,
    city: "Kingston",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 147,
    density: 60,
    county_fips: 34035,
    county_name: "Somerset",
    county_weights: {
      34023: 5.16,
      34035: 94.84,
    },
    county_names_all: "Somerset|Middlesex",
    county_fips_all: "34035|34023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08530",
    lat: 40.37288,
    lng: -74.89747,
    city: "Lambertville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7364,
    density: 104.9,
    county_fips: 34019,
    county_name: "Hunterdon",
    county_weights: {
      34019: 80.78,
      34021: 19.22,
    },
    county_names_all: "Hunterdon|Mercer",
    county_fips_all: "34019|34021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08533",
    lat: 40.01293,
    lng: -74.47138,
    city: "New Egypt",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6709,
    density: 47.2,
    county_fips: 34029,
    county_name: "Ocean",
    county_weights: {
      34029: 100,
    },
    county_names_all: "Ocean",
    county_fips_all: 34029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08534",
    lat: 40.33026,
    lng: -74.79422,
    city: "Pennington",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13208,
    density: 234.1,
    county_fips: 34021,
    county_name: "Mercer",
    county_weights: {
      34021: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 34021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08535",
    lat: 40.23506,
    lng: -74.437,
    city: "Millstone Township",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4567,
    density: 94.2,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08536",
    lat: 40.33392,
    lng: -74.58488,
    city: "Plainsboro",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19264,
    density: 991,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08540",
    lat: 40.36423,
    lng: -74.65661,
    city: "Princeton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51813,
    density: 386.8,
    county_fips: 34021,
    county_name: "Mercer",
    county_weights: {
      34021: 62.75,
      34023: 11,
      34035: 26.25,
    },
    county_names_all: "Mercer|Somerset|Middlesex",
    county_fips_all: "34021|34035|34023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08542",
    lat: 40.35452,
    lng: -74.66064,
    city: "Princeton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5399,
    density: 5409.9,
    county_fips: 34021,
    county_name: "Mercer",
    county_weights: {
      34021: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 34021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08544",
    lat: 40.34641,
    lng: -74.65787,
    city: "Princeton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 34021,
    county_name: "Mercer",
    county_weights: {
      34021: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 34021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08550",
    lat: 40.28125,
    lng: -74.61926,
    city: "Princeton Junction",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18143,
    density: 366.1,
    county_fips: 34021,
    county_name: "Mercer",
    county_weights: {
      34021: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 34021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08551",
    lat: 40.44425,
    lng: -74.83907,
    city: "Ringoes",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5588,
    density: 82.3,
    county_fips: 34019,
    county_name: "Hunterdon",
    county_weights: {
      34019: 100,
    },
    county_names_all: "Hunterdon",
    county_fips_all: 34019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08553",
    lat: 40.40011,
    lng: -74.64051,
    city: "Rocky Hill",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 655,
    density: 414,
    county_fips: 34035,
    county_name: "Somerset",
    county_weights: {
      34035: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 34035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08554",
    lat: 40.11556,
    lng: -74.77966,
    city: "Roebling",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4208,
    density: 1352.9,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08555",
    lat: 40.22116,
    lng: -74.473,
    city: "Roosevelt",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 913,
    density: 181.7,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08558",
    lat: 40.41382,
    lng: -74.70236,
    city: "Skillman",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7545,
    density: 186.9,
    county_fips: 34035,
    county_name: "Somerset",
    county_weights: {
      34021: 4.55,
      34035: 95.45,
    },
    county_names_all: "Somerset|Mercer",
    county_fips_all: "34035|34021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08559",
    lat: 40.4387,
    lng: -74.9716,
    city: "Stockton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5252,
    density: 50.9,
    county_fips: 34019,
    county_name: "Hunterdon",
    county_weights: {
      34019: 100,
    },
    county_names_all: "Hunterdon",
    county_fips_all: 34019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08560",
    lat: 40.31453,
    lng: -74.85946,
    city: "Titusville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3663,
    density: 106.1,
    county_fips: 34021,
    county_name: "Mercer",
    county_weights: {
      34019: 1.21,
      34021: 98.79,
    },
    county_names_all: "Mercer|Hunterdon",
    county_fips_all: "34021|34019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08561",
    lat: 40.24659,
    lng: -74.58138,
    city: "Windsor",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 596,
    density: 202.3,
    county_fips: 34021,
    county_name: "Mercer",
    county_weights: {
      34021: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 34021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08562",
    lat: 40.06812,
    lng: -74.59401,
    city: "Wrightstown",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4725,
    density: 109.1,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08608",
    lat: 40.21947,
    lng: -74.76693,
    city: "Trenton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 866,
    density: 1058.1,
    county_fips: 34021,
    county_name: "Mercer",
    county_weights: {
      34021: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 34021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08609",
    lat: 40.22594,
    lng: -74.74109,
    city: "Trenton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13003,
    density: 3813.5,
    county_fips: 34021,
    county_name: "Mercer",
    county_weights: {
      34021: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 34021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08610",
    lat: 40.19377,
    lng: -74.71565,
    city: "Trenton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31363,
    density: 1627.9,
    county_fips: 34021,
    county_name: "Mercer",
    county_weights: {
      34005: 5.63,
      34021: 94.37,
    },
    county_names_all: "Mercer|Burlington",
    county_fips_all: "34021|34005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08611",
    lat: 40.19107,
    lng: -74.74299,
    city: "Trenton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28263,
    density: 3711.8,
    county_fips: 34021,
    county_name: "Mercer",
    county_weights: {
      34021: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 34021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08618",
    lat: 40.24878,
    lng: -74.78734,
    city: "Trenton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37433,
    density: 2441.3,
    county_fips: 34021,
    county_name: "Mercer",
    county_weights: {
      34021: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 34021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08619",
    lat: 40.2414,
    lng: -74.69669,
    city: "Trenton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22416,
    density: 867.3,
    county_fips: 34021,
    county_name: "Mercer",
    county_weights: {
      34021: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 34021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08620",
    lat: 40.16825,
    lng: -74.64956,
    city: "Trenton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11904,
    density: 510.1,
    county_fips: 34021,
    county_name: "Mercer",
    county_weights: {
      34005: 12.8,
      34021: 87.2,
    },
    county_names_all: "Mercer|Burlington",
    county_fips_all: "34021|34005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08628",
    lat: 40.26705,
    lng: -74.82235,
    city: "Trenton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9100,
    density: 456.2,
    county_fips: 34021,
    county_name: "Mercer",
    county_weights: {
      34021: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 34021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08629",
    lat: 40.22066,
    lng: -74.73127,
    city: "Trenton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12910,
    density: 6303.7,
    county_fips: 34021,
    county_name: "Mercer",
    county_weights: {
      34021: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 34021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08638",
    lat: 40.25531,
    lng: -74.76222,
    city: "Trenton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22115,
    density: 1573.3,
    county_fips: 34021,
    county_name: "Mercer",
    county_weights: {
      34021: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 34021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08640",
    lat: 40.0093,
    lng: -74.58424,
    city: "Joint Base Mdl",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8350,
    density: 174.1,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08641",
    lat: 40.02819,
    lng: -74.58715,
    city: "Joint Base Mdl",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4028,
    density: 305.8,
    county_fips: 34005,
    county_name: "Burlington",
    county_weights: {
      34005: 100,
    },
    county_names_all: "Burlington",
    county_fips_all: 34005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08648",
    lat: 40.28488,
    lng: -74.72201,
    city: "Lawrence Township",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31819,
    density: 736.3,
    county_fips: 34021,
    county_name: "Mercer",
    county_weights: {
      34021: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 34021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08690",
    lat: 40.22512,
    lng: -74.66081,
    city: "Trenton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18010,
    density: 989,
    county_fips: 34021,
    county_name: "Mercer",
    county_weights: {
      34021: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 34021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08691",
    lat: 40.20953,
    lng: -74.59919,
    city: "Robbinsville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16413,
    density: 261.5,
    county_fips: 34021,
    county_name: "Mercer",
    county_weights: {
      34021: 88.55,
      34025: 11.45,
    },
    county_names_all: "Mercer|Monmouth",
    county_fips_all: "34021|34025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08701",
    lat: 40.07635,
    lng: -74.20311,
    city: "Lakewood",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 104186,
    density: 1626.2,
    county_fips: 34029,
    county_name: "Ocean",
    county_weights: {
      34029: 100,
    },
    county_names_all: "Ocean",
    county_fips_all: 34029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08720",
    lat: 40.14073,
    lng: -74.11431,
    city: "Allenwood",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 777,
    density: 113.7,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08721",
    lat: 39.9071,
    lng: -74.1846,
    city: "Bayville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21486,
    density: 349.3,
    county_fips: 34029,
    county_name: "Ocean",
    county_weights: {
      34029: 100,
    },
    county_names_all: "Ocean",
    county_fips_all: 34029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08722",
    lat: 39.92863,
    lng: -74.20224,
    city: "Beachwood",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11274,
    density: 1575.4,
    county_fips: 34029,
    county_name: "Ocean",
    county_weights: {
      34029: 100,
    },
    county_names_all: "Ocean",
    county_fips_all: 34029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08723",
    lat: 40.03896,
    lng: -74.11091,
    city: "Brick",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33059,
    density: 1067.2,
    county_fips: 34029,
    county_name: "Ocean",
    county_weights: {
      34029: 100,
    },
    county_names_all: "Ocean",
    county_fips_all: 34029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08724",
    lat: 40.09034,
    lng: -74.115,
    city: "Brick",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41504,
    density: 1160.8,
    county_fips: 34029,
    county_name: "Ocean",
    county_weights: {
      34025: 6.36,
      34029: 93.64,
    },
    county_names_all: "Ocean|Monmouth",
    county_fips_all: "34029|34025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08730",
    lat: 40.10483,
    lng: -74.06366,
    city: "Brielle",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4701,
    density: 1033.9,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08731",
    lat: 39.85946,
    lng: -74.29363,
    city: "Forked River",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20347,
    density: 100.6,
    county_fips: 34029,
    county_name: "Ocean",
    county_weights: {
      34029: 100,
    },
    county_names_all: "Ocean",
    county_fips_all: 34029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08732",
    lat: 39.94177,
    lng: -74.14497,
    city: "Island Heights",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1413,
    density: 1010.3,
    county_fips: 34029,
    county_name: "Ocean",
    county_weights: {
      34029: 100,
    },
    county_names_all: "Ocean",
    county_fips_all: 34029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08733",
    lat: 40.0262,
    lng: -74.3713,
    city: "Lakehurst",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2772,
    density: 87.2,
    county_fips: 34029,
    county_name: "Ocean",
    county_weights: {
      34029: 100,
    },
    county_names_all: "Ocean",
    county_fips_all: 34029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08734",
    lat: 39.86331,
    lng: -74.16608,
    city: "Lanoka Harbor",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8729,
    density: 658.3,
    county_fips: 34029,
    county_name: "Ocean",
    county_weights: {
      34029: 100,
    },
    county_names_all: "Ocean",
    county_fips_all: 34029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08735",
    lat: 39.98288,
    lng: -74.08121,
    city: "Lavallette",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4139,
    density: 920.8,
    county_fips: 34029,
    county_name: "Ocean",
    county_weights: {
      34029: 100,
    },
    county_names_all: "Ocean",
    county_fips_all: 34029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08736",
    lat: 40.12028,
    lng: -74.06862,
    city: "Manasquan",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13195,
    density: 1080.4,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08738",
    lat: 40.02101,
    lng: -74.06282,
    city: "Mantoloking",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1514,
    density: 599.8,
    county_fips: 34029,
    county_name: "Ocean",
    county_weights: {
      34029: 100,
    },
    county_names_all: "Ocean",
    county_fips_all: 34029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08740",
    lat: 39.93006,
    lng: -74.12811,
    city: "Ocean Gate",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1488,
    density: 1276.9,
    county_fips: 34029,
    county_name: "Ocean",
    county_weights: {
      34029: 100,
    },
    county_names_all: "Ocean",
    county_fips_all: 34029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08741",
    lat: 39.93632,
    lng: -74.16779,
    city: "Pine Beach",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2669,
    density: 1092.9,
    county_fips: 34029,
    county_name: "Ocean",
    county_weights: {
      34029: 100,
    },
    county_names_all: "Ocean",
    county_fips_all: 34029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08742",
    lat: 40.08076,
    lng: -74.06213,
    city: "Point Pleasant Beach",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24474,
    density: 1684.1,
    county_fips: 34029,
    county_name: "Ocean",
    county_weights: {
      34029: 100,
    },
    county_names_all: "Ocean",
    county_fips_all: 34029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08750",
    lat: 40.13389,
    lng: -74.0444,
    city: "Sea Girt",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3148,
    density: 639.7,
    county_fips: 34025,
    county_name: "Monmouth",
    county_weights: {
      34025: 100,
    },
    county_names_all: "Monmouth",
    county_fips_all: 34025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08751",
    lat: 39.95012,
    lng: -74.08147,
    city: "Seaside Heights",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4351,
    density: 1282.4,
    county_fips: 34029,
    county_name: "Ocean",
    county_weights: {
      34029: 100,
    },
    county_names_all: "Ocean",
    county_fips_all: 34029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08752",
    lat: 39.85233,
    lng: -74.0963,
    city: "Seaside Park",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2157,
    density: 174.7,
    county_fips: 34029,
    county_name: "Ocean",
    county_weights: {
      34029: 100,
    },
    county_names_all: "Ocean",
    county_fips_all: 34029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08753",
    lat: 39.98091,
    lng: -74.15055,
    city: "Toms River",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63750,
    density: 1067.9,
    county_fips: 34029,
    county_name: "Ocean",
    county_weights: {
      34029: 100,
    },
    county_names_all: "Ocean",
    county_fips_all: 34029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08755",
    lat: 40.00968,
    lng: -74.22457,
    city: "Toms River",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26398,
    density: 636.6,
    county_fips: 34029,
    county_name: "Ocean",
    county_weights: {
      34029: 100,
    },
    county_names_all: "Ocean",
    county_fips_all: 34029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08757",
    lat: 39.96061,
    lng: -74.25884,
    city: "Toms River",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33543,
    density: 728.3,
    county_fips: 34029,
    county_name: "Ocean",
    county_weights: {
      34029: 100,
    },
    county_names_all: "Ocean",
    county_fips_all: 34029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08758",
    lat: 39.79529,
    lng: -74.25296,
    city: "Waretown",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8254,
    density: 176.4,
    county_fips: 34029,
    county_name: "Ocean",
    county_weights: {
      34029: 100,
    },
    county_names_all: "Ocean",
    county_fips_all: 34029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08759",
    lat: 39.96239,
    lng: -74.35902,
    city: "Manchester Township",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33318,
    density: 209.7,
    county_fips: 34029,
    county_name: "Ocean",
    county_weights: {
      34005: 2.24,
      34029: 97.76,
    },
    county_names_all: "Ocean|Burlington",
    county_fips_all: "34029|34005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08801",
    lat: 40.62774,
    lng: -74.88655,
    city: "Annandale",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8383,
    density: 215.5,
    county_fips: 34019,
    county_name: "Hunterdon",
    county_weights: {
      34019: 100,
    },
    county_names_all: "Hunterdon",
    county_fips_all: 34019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08802",
    lat: 40.6783,
    lng: -75.02515,
    city: "Asbury",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4299,
    density: 67.8,
    county_fips: 34019,
    county_name: "Hunterdon",
    county_weights: {
      34019: 57.93,
      34041: 42.07,
    },
    county_names_all: "Hunterdon|Warren",
    county_fips_all: "34019|34041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08804",
    lat: 40.64412,
    lng: -75.09936,
    city: "Bloomsbury",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2579,
    density: 70.8,
    county_fips: 34019,
    county_name: "Hunterdon",
    county_weights: {
      34019: 60.16,
      34041: 39.84,
    },
    county_names_all: "Hunterdon|Warren",
    county_fips_all: "34019|34041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08805",
    lat: 40.57165,
    lng: -74.53783,
    city: "Bound Brook",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12100,
    density: 1589.3,
    county_fips: 34035,
    county_name: "Somerset",
    county_weights: {
      34035: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 34035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08807",
    lat: 40.59241,
    lng: -74.6202,
    city: "Bridgewater",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37638,
    density: 570.3,
    county_fips: 34035,
    county_name: "Somerset",
    county_weights: {
      34035: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 34035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08809",
    lat: 40.64973,
    lng: -74.92503,
    city: "Clinton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6433,
    density: 358.7,
    county_fips: 34019,
    county_name: "Hunterdon",
    county_weights: {
      34019: 100,
    },
    county_names_all: "Hunterdon",
    county_fips_all: 34019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08810",
    lat: 40.37073,
    lng: -74.49641,
    city: "Dayton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8774,
    density: 614.1,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08812",
    lat: 40.5999,
    lng: -74.47979,
    city: "Dunellen",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14008,
    density: 1065,
    county_fips: 34035,
    county_name: "Somerset",
    county_weights: {
      34023: 21.1,
      34035: 77.76,
      34039: 1.14,
    },
    county_names_all: "Somerset|Middlesex|Union",
    county_fips_all: "34035|34023|34039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08816",
    lat: 40.42943,
    lng: -74.41602,
    city: "East Brunswick",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47323,
    density: 903,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08817",
    lat: 40.51559,
    lng: -74.3939,
    city: "Edison",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44582,
    density: 1621.5,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08820",
    lat: 40.57725,
    lng: -74.36599,
    city: "Edison",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37295,
    density: 1380.5,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08821",
    lat: 40.52074,
    lng: -74.68835,
    city: "Flagtown",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 481,
    density: 781.2,
    county_fips: 34035,
    county_name: "Somerset",
    county_weights: {
      34035: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 34035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08822",
    lat: 40.52281,
    lng: -74.86576,
    city: "Flemington",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28836,
    density: 172,
    county_fips: 34019,
    county_name: "Hunterdon",
    county_weights: {
      34019: 100,
    },
    county_names_all: "Hunterdon",
    county_fips_all: 34019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08823",
    lat: 40.44218,
    lng: -74.56318,
    city: "Franklin Park",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8324,
    density: 931,
    county_fips: 34035,
    county_name: "Somerset",
    county_weights: {
      34035: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 34035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08824",
    lat: 40.42058,
    lng: -74.5538,
    city: "Kendall Park",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12418,
    density: 1105.9,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08825",
    lat: 40.51353,
    lng: -75.02341,
    city: "Frenchtown",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4040,
    density: 53.9,
    county_fips: 34019,
    county_name: "Hunterdon",
    county_weights: {
      34019: 100,
    },
    county_names_all: "Hunterdon",
    county_fips_all: 34019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08826",
    lat: 40.71912,
    lng: -74.90527,
    city: "Glen Gardner",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5027,
    density: 90.9,
    county_fips: 34019,
    county_name: "Hunterdon",
    county_weights: {
      34019: 100,
    },
    county_names_all: "Hunterdon",
    county_fips_all: 34019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08827",
    lat: 40.66775,
    lng: -74.97351,
    city: "Hampton",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3914,
    density: 83.5,
    county_fips: 34019,
    county_name: "Hunterdon",
    county_weights: {
      34019: 90.27,
      34041: 9.73,
    },
    county_names_all: "Hunterdon|Warren",
    county_fips_all: "34019|34041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08828",
    lat: 40.37767,
    lng: -74.42383,
    city: "Helmetta",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2232,
    density: 1040.4,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08829",
    lat: 40.66828,
    lng: -74.89414,
    city: "High Bridge",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3492,
    density: 559.5,
    county_fips: 34019,
    county_name: "Hunterdon",
    county_weights: {
      34019: 100,
    },
    county_names_all: "Hunterdon",
    county_fips_all: 34019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08830",
    lat: 40.56964,
    lng: -74.31719,
    city: "Iselin",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17343,
    density: 2117.8,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08831",
    lat: 40.32908,
    lng: -74.43066,
    city: "Monroe Township",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51245,
    density: 385.7,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08832",
    lat: 40.51138,
    lng: -74.31387,
    city: "Keasbey",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2825,
    density: 501.9,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08833",
    lat: 40.645,
    lng: -74.81989,
    city: "Lebanon",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8260,
    density: 91.5,
    county_fips: 34019,
    county_name: "Hunterdon",
    county_weights: {
      34019: 100,
    },
    county_names_all: "Hunterdon",
    county_fips_all: 34019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08835",
    lat: 40.54147,
    lng: -74.58876,
    city: "Manville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10193,
    density: 1746.5,
    county_fips: 34035,
    county_name: "Somerset",
    county_weights: {
      34035: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 34035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08836",
    lat: 40.59705,
    lng: -74.55446,
    city: "Martinsville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4015,
    density: 344.7,
    county_fips: 34035,
    county_name: "Somerset",
    county_weights: {
      34035: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 34035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08837",
    lat: 40.51432,
    lng: -74.34477,
    city: "Edison",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17999,
    density: 760.6,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08840",
    lat: 40.54361,
    lng: -74.35856,
    city: "Metuchen",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16792,
    density: 2021.3,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08844",
    lat: 40.49858,
    lng: -74.67274,
    city: "Hillsborough",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39852,
    density: 278.9,
    county_fips: 34035,
    county_name: "Somerset",
    county_weights: {
      34035: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 34035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08846",
    lat: 40.57439,
    lng: -74.5011,
    city: "Middlesex",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13606,
    density: 1506,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08848",
    lat: 40.59386,
    lng: -75.09569,
    city: "Milford",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8857,
    density: 104.5,
    county_fips: 34019,
    county_name: "Hunterdon",
    county_weights: {
      34019: 100,
    },
    county_names_all: "Hunterdon",
    county_fips_all: 34019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08850",
    lat: 40.44826,
    lng: -74.43994,
    city: "Milltown",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8420,
    density: 1410.3,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08852",
    lat: 40.38978,
    lng: -74.54461,
    city: "Monmouth Junction",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17643,
    density: 511.1,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08853",
    lat: 40.52879,
    lng: -74.74246,
    city: "Neshanic Station",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5297,
    density: 179.6,
    county_fips: 34035,
    county_name: "Somerset",
    county_weights: {
      34019: 23.93,
      34035: 76.07,
    },
    county_names_all: "Somerset|Hunterdon",
    county_fips_all: "34035|34019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08854",
    lat: 40.54648,
    lng: -74.46342,
    city: "Piscataway",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56948,
    density: 1161.6,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08857",
    lat: 40.39188,
    lng: -74.33059,
    city: "Old Bridge",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39601,
    density: 635.8,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08858",
    lat: 40.67903,
    lng: -74.73748,
    city: "Oldwick",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 107,
    density: 15.7,
    county_fips: 34019,
    county_name: "Hunterdon",
    county_weights: {
      34019: 100,
    },
    county_names_all: "Hunterdon",
    county_fips_all: 34019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08859",
    lat: 40.45897,
    lng: -74.30401,
    city: "Parlin",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22383,
    density: 1817.2,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08861",
    lat: 40.52087,
    lng: -74.27397,
    city: "Perth Amboy",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53899,
    density: 4081.3,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08863",
    lat: 40.53733,
    lng: -74.31216,
    city: "Fords",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12509,
    density: 2821.3,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08865",
    lat: 40.7094,
    lng: -75.15109,
    city: "Phillipsburg",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29142,
    density: 271.3,
    county_fips: 34041,
    county_name: "Warren",
    county_weights: {
      34041: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 34041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08867",
    lat: 40.57513,
    lng: -74.96777,
    city: "Pittstown",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5542,
    density: 75.5,
    county_fips: 34019,
    county_name: "Hunterdon",
    county_weights: {
      34019: 100,
    },
    county_names_all: "Hunterdon",
    county_fips_all: 34019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08869",
    lat: 40.57316,
    lng: -74.64305,
    city: "Raritan",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7833,
    density: 1518.4,
    county_fips: 34035,
    county_name: "Somerset",
    county_weights: {
      34035: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 34035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08872",
    lat: 40.46482,
    lng: -74.34002,
    city: "Sayreville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19627,
    density: 801,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08873",
    lat: 40.49865,
    lng: -74.53284,
    city: "Somerset",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54416,
    density: 653.9,
    county_fips: 34035,
    county_name: "Somerset",
    county_weights: {
      34035: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 34035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08876",
    lat: 40.58925,
    lng: -74.68871,
    city: "Somerville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21976,
    density: 530.4,
    county_fips: 34035,
    county_name: "Somerset",
    county_weights: {
      34019: 14.08,
      34035: 85.92,
    },
    county_names_all: "Somerset|Hunterdon",
    county_fips_all: "34035|34019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08879",
    lat: 40.46532,
    lng: -74.27691,
    city: "South Amboy",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23183,
    density: 1263.9,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08880",
    lat: 40.55354,
    lng: -74.52771,
    city: "South Bound Brook",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4541,
    density: 2714.9,
    county_fips: 34035,
    county_name: "Somerset",
    county_weights: {
      34023: 0.16,
      34035: 99.84,
    },
    county_names_all: "Somerset|Middlesex",
    county_fips_all: "34035|34023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08882",
    lat: 40.44556,
    lng: -74.37842,
    city: "South River",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15783,
    density: 2176.3,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08884",
    lat: 40.39493,
    lng: -74.39196,
    city: "Spotswood",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8255,
    density: 1379.6,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08886",
    lat: 40.69302,
    lng: -75.10565,
    city: "Stewartsville",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7143,
    density: 178.4,
    county_fips: 34041,
    county_name: "Warren",
    county_weights: {
      34041: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 34041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08887",
    lat: 40.52219,
    lng: -74.79428,
    city: "Three Bridges",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1231,
    density: 586.3,
    county_fips: 34019,
    county_name: "Hunterdon",
    county_weights: {
      34019: 99.51,
      34035: 0.49,
    },
    county_names_all: "Hunterdon|Somerset",
    county_fips_all: "34019|34035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08889",
    lat: 40.60744,
    lng: -74.75936,
    city: "Whitehouse Station",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10475,
    density: 175.4,
    county_fips: 34019,
    county_name: "Hunterdon",
    county_weights: {
      34019: 100,
    },
    county_names_all: "Hunterdon",
    county_fips_all: 34019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08890",
    lat: 40.53877,
    lng: -74.57531,
    city: "Zarephath",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 86,
    density: 190.1,
    county_fips: 34035,
    county_name: "Somerset",
    county_weights: {
      34035: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 34035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08901",
    lat: 40.48426,
    lng: -74.44275,
    city: "New Brunswick",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57607,
    density: 3549.3,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08902",
    lat: 40.44236,
    lng: -74.48579,
    city: "North Brunswick",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40630,
    density: 1191.1,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: "08904",
    lat: 40.50057,
    lng: -74.42832,
    city: "Highland Park",
    state_id: "NJ",
    state_name: "New Jersey",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13803,
    density: 2926.5,
    county_fips: 34023,
    county_name: "Middlesex",
    county_weights: {
      34023: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 34023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10001,
    lat: 40.75064,
    lng: -73.99728,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25026,
    density: 15489.3,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10002,
    lat: 40.71597,
    lng: -73.98692,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74363,
    density: 34916.7,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10003,
    lat: 40.73184,
    lng: -73.98915,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54671,
    density: 36928.8,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10004,
    lat: 40.69431,
    lng: -74.01835,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3310,
    density: 2805.2,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10005,
    lat: 40.70614,
    lng: -74.00862,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8664,
    density: 45907.6,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10006,
    lat: 40.70949,
    lng: -74.01306,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3260,
    density: 13007.2,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10007,
    lat: 40.71387,
    lng: -74.00792,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7566,
    density: 18269.7,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10009,
    lat: 40.72639,
    lng: -73.97865,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58267,
    density: 36478.3,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10010,
    lat: 40.73899,
    lng: -73.98243,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34763,
    density: 36398,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10011,
    lat: 40.74173,
    lng: -74.00037,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50228,
    density: 29948.2,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10012,
    lat: 40.7256,
    lng: -73.99794,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23034,
    density: 27453.1,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10013,
    lat: 40.72001,
    lng: -74.00472,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28657,
    density: 20325.3,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10014,
    lat: 40.73407,
    lng: -74.00601,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29071,
    density: 23148.5,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10016,
    lat: 40.74515,
    lng: -73.97807,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52912,
    density: 37159,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10017,
    lat: 40.75235,
    lng: -73.9726,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16065,
    density: 20821.8,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10018,
    lat: 40.75536,
    lng: -73.99265,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8135,
    density: 9129.8,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10019,
    lat: 40.76586,
    lng: -73.9853,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45521,
    density: 26675,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10020,
    lat: 40.75917,
    lng: -73.98071,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10021,
    lat: 40.76963,
    lng: -73.95899,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42253,
    density: 45753.9,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10022,
    lat: 40.75856,
    lng: -73.96787,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31574,
    density: 27493.3,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10023,
    lat: 40.77464,
    lng: -73.97836,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62228,
    density: 24787.8,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10024,
    lat: 40.78534,
    lng: -73.97138,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60714,
    density: 26482.8,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10025,
    lat: 40.79825,
    lng: -73.96831,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 92162,
    density: 40033.3,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10026,
    lat: 40.80302,
    lng: -73.95348,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38937,
    density: 39222.3,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10027,
    lat: 40.81187,
    lng: -73.95459,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64728,
    density: 26517.9,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10028,
    lat: 40.77643,
    lng: -73.95339,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47962,
    density: 58495.7,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10029,
    lat: 40.79265,
    lng: -73.94788,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74617,
    density: 24979.6,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10030,
    lat: 40.81826,
    lng: -73.94283,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30996,
    density: 43163.2,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10031,
    lat: 40.82485,
    lng: -73.95023,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60280,
    density: 34782.2,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10032,
    lat: 40.839,
    lng: -73.94282,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59527,
    density: 34168.9,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10033,
    lat: 40.84744,
    lng: -73.93549,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58648,
    density: 37964.7,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10034,
    lat: 40.86749,
    lng: -73.92358,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41933,
    density: 15834.8,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10035,
    lat: 40.79538,
    lng: -73.92965,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36999,
    density: 10170,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10036,
    lat: 40.75976,
    lng: -73.99064,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28231,
    density: 24371.9,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10037,
    lat: 40.81302,
    lng: -73.93776,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19177,
    density: 31803.5,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10038,
    lat: 40.70914,
    lng: -74.00298,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24205,
    density: 32378.2,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10039,
    lat: 40.82631,
    lng: -73.93752,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27090,
    density: 34961.1,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10040,
    lat: 40.85807,
    lng: -73.9296,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45197,
    density: 30777.2,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10044,
    lat: 40.76209,
    lng: -73.94981,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12770,
    density: 21430.5,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10065,
    lat: 40.76472,
    lng: -73.96332,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30339,
    density: 27951.4,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10069,
    lat: 40.77752,
    lng: -73.98875,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6504,
    density: 61244.7,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10075,
    lat: 40.77342,
    lng: -73.95642,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22591,
    density: 46145,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10103,
    lat: 40.76078,
    lng: -73.97767,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10110,
    lat: 40.7545,
    lng: -73.98226,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10111,
    lat: 40.75953,
    lng: -73.97858,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10112,
    lat: 40.75891,
    lng: -73.97904,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10115,
    lat: 40.81085,
    lng: -73.96374,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10119,
    lat: 40.75064,
    lng: -73.99273,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10128,
    lat: 40.78151,
    lng: -73.95018,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57993,
    density: 49434,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10152,
    lat: 40.75872,
    lng: -73.9718,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10153,
    lat: 40.76362,
    lng: -73.97244,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10154,
    lat: 40.75778,
    lng: -73.97249,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10162,
    lat: 40.76936,
    lng: -73.94986,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1240,
    density: 37410.2,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10165,
    lat: 40.75213,
    lng: -73.97872,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10167,
    lat: 40.75465,
    lng: -73.97477,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10168,
    lat: 40.75145,
    lng: -73.9771,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10169,
    lat: 40.75467,
    lng: -73.97643,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10170,
    lat: 40.75263,
    lng: -73.97588,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10171,
    lat: 40.7559,
    lng: -73.97386,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10172,
    lat: 40.75527,
    lng: -73.97431,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10173,
    lat: 40.75379,
    lng: -73.97961,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10174,
    lat: 40.75144,
    lng: -73.975,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10177,
    lat: 40.75498,
    lng: -73.97589,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10199,
    lat: 40.75138,
    lng: -73.99715,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10271,
    lat: 40.70844,
    lng: -74.01033,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10278,
    lat: 40.71513,
    lng: -74.00373,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10279,
    lat: 40.71263,
    lng: -74.00867,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 96,
    density: 8884.8,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10280,
    lat: 40.70985,
    lng: -74.01651,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9372,
    density: 33891.2,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10282,
    lat: 40.71655,
    lng: -74.01495,
    city: "New York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6086,
    density: 34220.4,
    county_fips: 36061,
    county_name: "New York",
    county_weights: {
      36061: 100,
    },
    county_names_all: "New York",
    county_fips_all: 36061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10301,
    lat: 40.62803,
    lng: -74.09564,
    city: "Staten Island",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38001,
    density: 3904.6,
    county_fips: 36085,
    county_name: "Richmond",
    county_weights: {
      36085: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 36085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10302,
    lat: 40.63055,
    lng: -74.13776,
    city: "Staten Island",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17942,
    density: 5805.7,
    county_fips: 36085,
    county_name: "Richmond",
    county_weights: {
      36085: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 36085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10303,
    lat: 40.63223,
    lng: -74.16903,
    city: "Staten Island",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27164,
    density: 3309.4,
    county_fips: 36085,
    county_name: "Richmond",
    county_weights: {
      36085: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 36085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10304,
    lat: 40.60671,
    lng: -74.0931,
    city: "Staten Island",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42133,
    density: 4660.2,
    county_fips: 36085,
    county_name: "Richmond",
    county_weights: {
      36085: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 36085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10305,
    lat: 40.59592,
    lng: -74.07539,
    city: "Staten Island",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42968,
    density: 4127.1,
    county_fips: 36085,
    county_name: "Richmond",
    county_weights: {
      36085: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 36085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10306,
    lat: 40.57149,
    lng: -74.1243,
    city: "Staten Island",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54318,
    density: 2901.2,
    county_fips: 36085,
    county_name: "Richmond",
    county_weights: {
      36085: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 36085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10307,
    lat: 40.50817,
    lng: -74.24254,
    city: "Staten Island",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15053,
    density: 3601.9,
    county_fips: 36085,
    county_name: "Richmond",
    county_weights: {
      36085: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 36085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10308,
    lat: 40.55213,
    lng: -74.15029,
    city: "Staten Island",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28901,
    density: 5106.2,
    county_fips: 36085,
    county_name: "Richmond",
    county_weights: {
      36085: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 36085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10309,
    lat: 40.53001,
    lng: -74.21912,
    city: "Staten Island",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33896,
    density: 1804.1,
    county_fips: 36085,
    county_name: "Richmond",
    county_weights: {
      36085: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 36085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10310,
    lat: 40.63243,
    lng: -74.11653,
    city: "Staten Island",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24168,
    density: 5177.1,
    county_fips: 36085,
    county_name: "Richmond",
    county_weights: {
      36085: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 36085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10311,
    lat: 40.60523,
    lng: -74.17956,
    city: "Staten Island",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36085,
    county_name: "Richmond",
    county_weights: {
      36085: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 36085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10312,
    lat: 40.54489,
    lng: -74.18084,
    city: "Staten Island",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61114,
    density: 3433.8,
    county_fips: 36085,
    county_name: "Richmond",
    county_weights: {
      36085: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 36085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10314,
    lat: 40.60086,
    lng: -74.16306,
    city: "Staten Island",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 89938,
    density: 2671.8,
    county_fips: 36085,
    county_name: "Richmond",
    county_weights: {
      36085: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 36085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10451,
    lat: 40.82097,
    lng: -73.92383,
    city: "Bronx",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49423,
    density: 18067,
    county_fips: 36005,
    county_name: "Bronx",
    county_weights: {
      36005: 100,
    },
    county_names_all: "Bronx",
    county_fips_all: 36005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10452,
    lat: 40.8378,
    lng: -73.92333,
    city: "Bronx",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74379,
    density: 29237.9,
    county_fips: 36005,
    county_name: "Bronx",
    county_weights: {
      36005: 99.79,
      36061: 0.21,
    },
    county_names_all: "Bronx|New York",
    county_fips_all: "36005|36061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10453,
    lat: 40.85248,
    lng: -73.9133,
    city: "Bronx",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 78858,
    density: 33783.6,
    county_fips: 36005,
    county_name: "Bronx",
    county_weights: {
      36005: 100,
    },
    county_names_all: "Bronx",
    county_fips_all: 36005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10454,
    lat: 40.8056,
    lng: -73.91664,
    city: "Bronx",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37807,
    density: 13770.3,
    county_fips: 36005,
    county_name: "Bronx",
    county_weights: {
      36005: 99.81,
      36061: 0.19,
    },
    county_names_all: "Bronx|New York",
    county_fips_all: "36005|36061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10455,
    lat: 40.8148,
    lng: -73.90862,
    city: "Bronx",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40300,
    density: 22187.1,
    county_fips: 36005,
    county_name: "Bronx",
    county_weights: {
      36005: 100,
    },
    county_names_all: "Bronx",
    county_fips_all: 36005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10456,
    lat: 40.83064,
    lng: -73.90812,
    city: "Bronx",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 90479,
    density: 32454.6,
    county_fips: 36005,
    county_name: "Bronx",
    county_weights: {
      36005: 100,
    },
    county_names_all: "Bronx",
    county_fips_all: 36005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10457,
    lat: 40.84571,
    lng: -73.89794,
    city: "Bronx",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74679,
    density: 21865.3,
    county_fips: 36005,
    county_name: "Bronx",
    county_weights: {
      36005: 100,
    },
    county_names_all: "Bronx",
    county_fips_all: 36005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10458,
    lat: 40.86249,
    lng: -73.88643,
    city: "Bronx",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 85893,
    density: 27161.9,
    county_fips: 36005,
    county_name: "Bronx",
    county_weights: {
      36005: 100,
    },
    county_names_all: "Bronx",
    county_fips_all: 36005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10459,
    lat: 40.82572,
    lng: -73.89295,
    city: "Bronx",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48391,
    density: 22464.9,
    county_fips: 36005,
    county_name: "Bronx",
    county_weights: {
      36005: 100,
    },
    county_names_all: "Bronx",
    county_fips_all: 36005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10460,
    lat: 40.84273,
    lng: -73.87891,
    city: "Bronx",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57514,
    density: 14817.5,
    county_fips: 36005,
    county_name: "Bronx",
    county_weights: {
      36005: 100,
    },
    county_names_all: "Bronx",
    county_fips_all: 36005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10461,
    lat: 40.84671,
    lng: -73.84079,
    city: "Bronx",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51081,
    density: 8258.4,
    county_fips: 36005,
    county_name: "Bronx",
    county_weights: {
      36005: 100,
    },
    county_names_all: "Bronx",
    county_fips_all: 36005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10462,
    lat: 40.84297,
    lng: -73.85873,
    city: "Bronx",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75441,
    density: 19451,
    county_fips: 36005,
    county_name: "Bronx",
    county_weights: {
      36005: 100,
    },
    county_names_all: "Bronx",
    county_fips_all: 36005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10463,
    lat: 40.88841,
    lng: -73.89905,
    city: "Bronx",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 70236,
    density: 9851,
    county_fips: 36005,
    county_name: "Bronx",
    county_weights: {
      36005: 96,
      36061: 4,
    },
    county_names_all: "Bronx|New York",
    county_fips_all: "36005|36061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10464,
    lat: 40.86821,
    lng: -73.80044,
    city: "Bronx",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4322,
    density: 546.5,
    county_fips: 36005,
    county_name: "Bronx",
    county_weights: {
      36005: 100,
    },
    county_names_all: "Bronx",
    county_fips_all: 36005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10465,
    lat: 40.8286,
    lng: -73.82179,
    city: "Bronx",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45066,
    density: 4438.3,
    county_fips: 36005,
    county_name: "Bronx",
    county_weights: {
      36005: 100,
    },
    county_names_all: "Bronx",
    county_fips_all: 36005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10466,
    lat: 40.89104,
    lng: -73.8461,
    city: "Bronx",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74519,
    density: 14278.5,
    county_fips: 36005,
    county_name: "Bronx",
    county_weights: {
      36005: 100,
    },
    county_names_all: "Bronx",
    county_fips_all: 36005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10467,
    lat: 40.87522,
    lng: -73.872,
    city: "Bronx",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 100867,
    density: 16710.7,
    county_fips: 36005,
    county_name: "Bronx",
    county_weights: {
      36005: 100,
    },
    county_names_all: "Bronx",
    county_fips_all: 36005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10468,
    lat: 40.8681,
    lng: -73.89985,
    city: "Bronx",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 78778,
    density: 29073.9,
    county_fips: 36005,
    county_name: "Bronx",
    county_weights: {
      36005: 100,
    },
    county_names_all: "Bronx",
    county_fips_all: 36005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10469,
    lat: 40.86851,
    lng: -73.84666,
    city: "Bronx",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 72550,
    density: 11547.7,
    county_fips: 36005,
    county_name: "Bronx",
    county_weights: {
      36005: 100,
    },
    county_names_all: "Bronx",
    county_fips_all: 36005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10470,
    lat: 40.89598,
    lng: -73.86805,
    city: "Bronx",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15500,
    density: 4168.1,
    county_fips: 36005,
    county_name: "Bronx",
    county_weights: {
      36005: 98.44,
      36119: 1.56,
    },
    county_names_all: "Bronx|Westchester",
    county_fips_all: "36005|36119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10471,
    lat: 40.90002,
    lng: -73.9067,
    city: "Bronx",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22577,
    density: 5088.5,
    county_fips: 36005,
    county_name: "Bronx",
    county_weights: {
      36005: 100,
    },
    county_names_all: "Bronx",
    county_fips_all: 36005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10472,
    lat: 40.82968,
    lng: -73.86942,
    city: "Bronx",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67989,
    density: 24360.7,
    county_fips: 36005,
    county_name: "Bronx",
    county_weights: {
      36005: 100,
    },
    county_names_all: "Bronx",
    county_fips_all: 36005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10473,
    lat: 40.81817,
    lng: -73.85889,
    city: "Bronx",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59627,
    density: 10768.5,
    county_fips: 36005,
    county_name: "Bronx",
    county_weights: {
      36005: 100,
    },
    county_names_all: "Bronx",
    county_fips_all: 36005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10474,
    lat: 40.81061,
    lng: -73.8846,
    city: "Bronx",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11579,
    density: 2914.3,
    county_fips: 36005,
    county_name: "Bronx",
    county_weights: {
      36005: 100,
    },
    county_names_all: "Bronx",
    county_fips_all: 36005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10475,
    lat: 40.87528,
    lng: -73.82702,
    city: "Bronx",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43791,
    density: 13606,
    county_fips: 36005,
    county_name: "Bronx",
    county_weights: {
      36005: 100,
    },
    county_names_all: "Bronx",
    county_fips_all: 36005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10501,
    lat: 41.2954,
    lng: -73.76006,
    city: "Amawalk",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1237,
    density: 300,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10502,
    lat: 41.01126,
    lng: -73.8409,
    city: "Ardsley",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5351,
    density: 991.4,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10503,
    lat: 41.02654,
    lng: -73.8753,
    city: "Ardsley On Hudson",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 106,
    density: 2753.5,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10504,
    lat: 41.13065,
    lng: -73.70629,
    city: "Armonk",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8053,
    density: 192.7,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10505,
    lat: 41.34207,
    lng: -73.74791,
    city: "Baldwin Place",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1336,
    density: 665.6,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10506,
    lat: 41.1889,
    lng: -73.63411,
    city: "Bedford",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5555,
    density: 128.9,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10507,
    lat: 41.22879,
    lng: -73.6878,
    city: "Bedford Hills",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7152,
    density: 371.7,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10509,
    lat: 41.41205,
    lng: -73.5937,
    city: "Brewster",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20230,
    density: 216.5,
    county_fips: 36079,
    county_name: "Putnam",
    county_weights: {
      36079: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 36079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10510,
    lat: 41.14152,
    lng: -73.83411,
    city: "Briarcliff Manor",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10300,
    density: 393.6,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10511,
    lat: 41.26302,
    lng: -73.94391,
    city: "Buchanan",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2300,
    density: 590.7,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10512,
    lat: 41.4483,
    lng: -73.71054,
    city: "Carmel",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24619,
    density: 182.2,
    county_fips: 36079,
    county_name: "Putnam",
    county_weights: {
      36079: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 36079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10514,
    lat: 41.17331,
    lng: -73.77071,
    city: "Chappaqua",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12543,
    density: 380.6,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10516,
    lat: 41.45342,
    lng: -73.90233,
    city: "Cold Spring",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5449,
    density: 66.9,
    county_fips: 36079,
    county_name: "Putnam",
    county_weights: {
      36079: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 36079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10517,
    lat: 41.29837,
    lng: -73.86013,
    city: "Crompond",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 497,
    density: 545.5,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10518,
    lat: 41.26787,
    lng: -73.60073,
    city: "Cross River",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1041,
    density: 105.5,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10519,
    lat: 41.34701,
    lng: -73.66196,
    city: "Croton Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 305,
    density: 471.2,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10520,
    lat: 41.22183,
    lng: -73.87348,
    city: "Croton On Hudson",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12885,
    density: 344.3,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10522,
    lat: 41.01221,
    lng: -73.8646,
    city: "Dobbs Ferry",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11052,
    density: 1746.3,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10523,
    lat: 41.06005,
    lng: -73.81859,
    city: "Elmsford",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9415,
    density: 997.1,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10524,
    lat: 41.37076,
    lng: -73.92201,
    city: "Garrison",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4317,
    density: 80,
    county_fips: 36079,
    county_name: "Putnam",
    county_weights: {
      36079: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 36079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10526,
    lat: 41.29388,
    lng: -73.66171,
    city: "Goldens Bridge",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1860,
    density: 202.4,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10527,
    lat: 41.3195,
    lng: -73.76502,
    city: "Granite Springs",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 829,
    density: 143.3,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10528,
    lat: 40.97819,
    lng: -73.72306,
    city: "Harrison",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13395,
    density: 1368.6,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10530,
    lat: 41.02304,
    lng: -73.80764,
    city: "Hartsdale",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12925,
    density: 1274.9,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10532,
    lat: 41.09873,
    lng: -73.80066,
    city: "Hawthorne",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4739,
    density: 782.1,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10533,
    lat: 41.03826,
    lng: -73.8556,
    city: "Irvington",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7463,
    density: 810.4,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10535,
    lat: 41.33536,
    lng: -73.79965,
    city: "Jefferson Valley",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 254,
    density: 215.6,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10536,
    lat: 41.26971,
    lng: -73.68943,
    city: "Katonah",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11002,
    density: 159.6,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10537,
    lat: 41.33784,
    lng: -73.88528,
    city: "Lake Peekskill",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2769,
    density: 996.6,
    county_fips: 36079,
    county_name: "Putnam",
    county_weights: {
      36079: 81.63,
      36119: 18.37,
    },
    county_names_all: "Putnam|Westchester",
    county_fips_all: "36079|36119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10538,
    lat: 40.9376,
    lng: -73.75707,
    city: "Larchmont",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16151,
    density: 1774.6,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10540,
    lat: 41.32575,
    lng: -73.72745,
    city: "Lincolndale",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10541,
    lat: 41.37855,
    lng: -73.75122,
    city: "Mahopac",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26678,
    density: 415.9,
    county_fips: 36079,
    county_name: "Putnam",
    county_weights: {
      36079: 96.16,
      36119: 3.84,
    },
    county_names_all: "Putnam|Westchester",
    county_fips_all: "36079|36119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10542,
    lat: 41.37115,
    lng: -73.76436,
    city: "Mahopac Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36079,
    county_name: "Putnam",
    county_weights: {
      36079: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 36079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10543,
    lat: 40.95274,
    lng: -73.73645,
    city: "Mamaroneck",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20999,
    density: 1892.9,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10545,
    lat: 41.17861,
    lng: -73.83547,
    city: "Maryknoll",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 115,
    density: 355.1,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10546,
    lat: 41.19472,
    lng: -73.8002,
    city: "Millwood",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1085,
    density: 347.4,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10547,
    lat: 41.31178,
    lng: -73.84637,
    city: "Mohegan Lake",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8034,
    density: 633.3,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10548,
    lat: 41.24599,
    lng: -73.93643,
    city: "Montrose",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4087,
    density: 765.4,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10549,
    lat: 41.19981,
    lng: -73.72028,
    city: "Mount Kisco",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16121,
    density: 326,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10550,
    lat: 40.90627,
    lng: -73.8351,
    city: "Mount Vernon",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36382,
    density: 7065.2,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36005: 0.34,
      36119: 99.66,
    },
    county_names_all: "Westchester|Bronx",
    county_fips_all: "36119|36005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10552,
    lat: 40.92376,
    lng: -73.82497,
    city: "Mount Vernon",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21342,
    density: 4993,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10553,
    lat: 40.90858,
    lng: -73.82161,
    city: "Mount Vernon",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9747,
    density: 5391.2,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10560,
    lat: 41.33303,
    lng: -73.60264,
    city: "North Salem",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4814,
    density: 88.9,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10562,
    lat: 41.19295,
    lng: -73.8305,
    city: "Ossining",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31847,
    density: 909.9,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10566,
    lat: 41.28924,
    lng: -73.91837,
    city: "Peekskill",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24111,
    density: 2144.1,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10567,
    lat: 41.28922,
    lng: -73.89633,
    city: "Cortlandt Manor",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20094,
    density: 344.6,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10570,
    lat: 41.12854,
    lng: -73.78917,
    city: "Pleasantville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12780,
    density: 693,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10573,
    lat: 41.01676,
    lng: -73.67735,
    city: "Port Chester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38749,
    density: 2736.1,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10576,
    lat: 41.21323,
    lng: -73.57289,
    city: "Pound Ridge",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5036,
    density: 86.8,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10577,
    lat: 41.03755,
    lng: -73.71349,
    city: "Purchase",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6387,
    density: 371.9,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10578,
    lat: 41.31815,
    lng: -73.673,
    city: "Purdys",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1386,
    density: 304.1,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10579,
    lat: 41.39651,
    lng: -73.83384,
    city: "Putnam Valley",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8250,
    density: 91.7,
    county_fips: 36079,
    county_name: "Putnam",
    county_weights: {
      36079: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 36079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10580,
    lat: 40.97854,
    lng: -73.69258,
    city: "Rye",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17185,
    density: 794.4,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10583,
    lat: 40.98916,
    lng: -73.79443,
    city: "Scarsdale",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41087,
    density: 1276.5,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10588,
    lat: 41.33222,
    lng: -73.82624,
    city: "Shrub Oak",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3102,
    density: 736.8,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36079: 2.8,
      36119: 97.2,
    },
    county_names_all: "Westchester|Putnam",
    county_fips_all: "36119|36079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10589,
    lat: 41.33178,
    lng: -73.6933,
    city: "Somers",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8080,
    density: 453.3,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10590,
    lat: 41.25421,
    lng: -73.53719,
    city: "South Salem",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7208,
    density: 208.9,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10591,
    lat: 41.08436,
    lng: -73.84653,
    city: "Tarrytown",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23059,
    density: 946.6,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10594,
    lat: 41.11579,
    lng: -73.771,
    city: "Thornwood",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5587,
    density: 836.3,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10595,
    lat: 41.08626,
    lng: -73.78097,
    city: "Valhalla",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8439,
    density: 612.5,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10596,
    lat: 41.25552,
    lng: -73.95854,
    city: "Verplanck",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1051,
    density: 681.3,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10597,
    lat: 41.29423,
    lng: -73.59703,
    city: "Waccabuc",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 699,
    density: 82.3,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10598,
    lat: 41.28309,
    lng: -73.79516,
    city: "Yorktown Heights",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28708,
    density: 438.7,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10601,
    lat: 41.03288,
    lng: -73.7648,
    city: "White Plains",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10256,
    density: 6132.9,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10603,
    lat: 41.05364,
    lng: -73.78014,
    city: "White Plains",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18862,
    density: 2161.8,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10604,
    lat: 41.06013,
    lng: -73.73955,
    city: "West Harrison",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11132,
    density: 636.6,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10605,
    lat: 41.0095,
    lng: -73.74518,
    city: "White Plains",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19849,
    density: 1426.9,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10606,
    lat: 41.02065,
    lng: -73.77588,
    city: "White Plains",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16199,
    density: 4214.5,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10607,
    lat: 41.03949,
    lng: -73.81214,
    city: "White Plains",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7162,
    density: 1291.6,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10701,
    lat: 40.94702,
    lng: -73.88034,
    city: "Yonkers",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61367,
    density: 5410.6,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10703,
    lat: 40.95765,
    lng: -73.88114,
    city: "Yonkers",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22636,
    density: 5561,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10704,
    lat: 40.91911,
    lng: -73.86187,
    city: "Yonkers",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31110,
    density: 4499.7,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10705,
    lat: 40.91929,
    lng: -73.88928,
    city: "Yonkers",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39848,
    density: 6950.6,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10706,
    lat: 40.99047,
    lng: -73.86951,
    city: "Hastings On Hudson",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8622,
    density: 1250,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10707,
    lat: 40.95961,
    lng: -73.82291,
    city: "Tuckahoe",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9713,
    density: 2953.6,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10708,
    lat: 40.9379,
    lng: -73.83167,
    city: "Bronxville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22212,
    density: 2923.7,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10709,
    lat: 40.95337,
    lng: -73.80885,
    city: "Eastchester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9369,
    density: 2325.9,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10710,
    lat: 40.96732,
    lng: -73.84739,
    city: "Yonkers",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25104,
    density: 2105.8,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10801,
    lat: 40.91751,
    lng: -73.78396,
    city: "New Rochelle",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40445,
    density: 4559.4,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10803,
    lat: 40.89978,
    lng: -73.80619,
    city: "Pelham",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12492,
    density: 2180.1,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36005: 0.89,
      36119: 99.11,
    },
    county_names_all: "Westchester|Bronx",
    county_fips_all: "36119|36005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10804,
    lat: 40.94914,
    lng: -73.78629,
    city: "New Rochelle",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14365,
    density: 1296.6,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10805,
    lat: 40.89593,
    lng: -73.78028,
    city: "New Rochelle",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21331,
    density: 4813.8,
    county_fips: 36119,
    county_name: "Westchester",
    county_weights: {
      36119: 100,
    },
    county_names_all: "Westchester",
    county_fips_all: 36119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10901,
    lat: 41.14554,
    lng: -74.12504,
    city: "Suffern",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23860,
    density: 391.3,
    county_fips: 36087,
    county_name: "Rockland",
    county_weights: {
      36087: 100,
    },
    county_names_all: "Rockland",
    county_fips_all: 36087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10910,
    lat: 41.2773,
    lng: -74.13625,
    city: "Arden",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10911,
    lat: 41.30798,
    lng: -73.99243,
    city: "Bear Mountain",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36087,
    county_name: "Rockland",
    county_weights: {
      36071: 0.11,
      36087: 99.89,
    },
    county_names_all: "Rockland|Orange",
    county_fips_all: "36087|36071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10913,
    lat: 41.06845,
    lng: -73.95574,
    city: "Blauvelt",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5294,
    density: 492.8,
    county_fips: 36087,
    county_name: "Rockland",
    county_weights: {
      36087: 100,
    },
    county_names_all: "Rockland",
    county_fips_all: 36087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10914,
    lat: 41.41671,
    lng: -74.20087,
    city: "Blooming Grove",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 391,
    density: 61,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10915,
    lat: 41.54022,
    lng: -74.35714,
    city: "Bullville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 79,
    density: 391.5,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10916,
    lat: 41.44881,
    lng: -74.24311,
    city: "Campbell Hall",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4582,
    density: 75.3,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10917,
    lat: 41.31851,
    lng: -74.11094,
    city: "Central Valley",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1650,
    density: 132.3,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10918,
    lat: 41.34816,
    lng: -74.25828,
    city: "Chester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12286,
    density: 145.3,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10919,
    lat: 41.52836,
    lng: -74.38327,
    city: "Circleville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1286,
    density: 131.7,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10920,
    lat: 41.15477,
    lng: -73.9393,
    city: "Congers",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8919,
    density: 771.8,
    county_fips: 36087,
    county_name: "Rockland",
    county_weights: {
      36087: 100,
    },
    county_names_all: "Rockland",
    county_fips_all: 36087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10921,
    lat: 41.3292,
    lng: -74.3651,
    city: "Florida",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3812,
    density: 178.3,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10922,
    lat: 41.32794,
    lng: -73.99604,
    city: "Fort Montgomery",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1778,
    density: 331.3,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 99.7,
      36087: 0.3,
    },
    county_names_all: "Orange|Rockland",
    county_fips_all: "36071|36087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10923,
    lat: 41.20265,
    lng: -74.00031,
    city: "Garnerville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7753,
    density: 1491.1,
    county_fips: 36087,
    county_name: "Rockland",
    county_weights: {
      36087: 100,
    },
    county_names_all: "Rockland",
    county_fips_all: 36087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10924,
    lat: 41.3788,
    lng: -74.3512,
    city: "Goshen",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13538,
    density: 130.4,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10925,
    lat: 41.20076,
    lng: -74.29535,
    city: "Greenwood Lake",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3886,
    density: 163.6,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10926,
    lat: 41.25856,
    lng: -74.1307,
    city: "Harriman",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3482,
    density: 77.4,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 99.08,
      36087: 0.92,
    },
    county_names_all: "Orange|Rockland",
    county_fips_all: "36071|36087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10927,
    lat: 41.19263,
    lng: -73.96735,
    city: "Haverstraw",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12076,
    density: 2351.4,
    county_fips: 36087,
    county_name: "Rockland",
    county_weights: {
      36087: 100,
    },
    county_names_all: "Rockland",
    county_fips_all: 36087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10928,
    lat: 41.3457,
    lng: -74.00265,
    city: "Highland Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4132,
    density: 190.8,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10930,
    lat: 41.3667,
    lng: -74.11035,
    city: "Highland Mills",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9789,
    density: 235.7,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10931,
    lat: 41.12769,
    lng: -74.17012,
    city: "Hillburn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1031,
    density: 160.6,
    county_fips: 36087,
    county_name: "Rockland",
    county_weights: {
      36087: 100,
    },
    county_names_all: "Rockland",
    county_fips_all: 36087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10932,
    lat: 41.482,
    lng: -74.46352,
    city: "Howells",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47,
    density: 117.1,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10933,
    lat: 41.36527,
    lng: -74.51106,
    city: "Johnson",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 417,
    density: 135.5,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10940,
    lat: 41.45149,
    lng: -74.46997,
    city: "Middletown",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49430,
    density: 302.2,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 96.03,
      36105: 3.97,
    },
    county_names_all: "Orange|Sullivan",
    county_fips_all: "36071|36105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10941,
    lat: 41.48923,
    lng: -74.34556,
    city: "Middletown",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13384,
    density: 161.3,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10950,
    lat: 41.31919,
    lng: -74.19825,
    city: "Monroe",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53013,
    density: 556.2,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10952,
    lat: 41.11385,
    lng: -74.07975,
    city: "Monsey",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43374,
    density: 1872,
    county_fips: 36087,
    county_name: "Rockland",
    county_weights: {
      36087: 100,
    },
    county_names_all: "Rockland",
    county_fips_all: 36087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10953,
    lat: 41.40581,
    lng: -74.07783,
    city: "Mountainville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 112,
    density: 487.8,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10954,
    lat: 41.09969,
    lng: -74.01269,
    city: "Nanuet",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25870,
    density: 1449.8,
    county_fips: 36087,
    county_name: "Rockland",
    county_weights: {
      36087: 100,
    },
    county_names_all: "Rockland",
    county_fips_all: 36087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10956,
    lat: 41.15562,
    lng: -73.99314,
    city: "New City",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30697,
    density: 768.6,
    county_fips: 36087,
    county_name: "Rockland",
    county_weights: {
      36087: 100,
    },
    county_names_all: "Rockland",
    county_fips_all: 36087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10958,
    lat: 41.3764,
    lng: -74.42881,
    city: "New Hampton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3236,
    density: 58.8,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10960,
    lat: 41.08892,
    lng: -73.92642,
    city: "Nyack",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15757,
    density: 1289.3,
    county_fips: 36087,
    county_name: "Rockland",
    county_weights: {
      36087: 100,
    },
    county_names_all: "Rockland",
    county_fips_all: 36087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10962,
    lat: 41.04857,
    lng: -73.96057,
    city: "Orangeburg",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5927,
    density: 439.1,
    county_fips: 36087,
    county_name: "Rockland",
    county_weights: {
      36087: 100,
    },
    county_names_all: "Rockland",
    county_fips_all: 36087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10963,
    lat: 41.4669,
    lng: -74.54121,
    city: "Otisville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4367,
    density: 127.7,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 95.05,
      36105: 4.95,
    },
    county_names_all: "Orange|Sullivan",
    county_fips_all: "36071|36105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10964,
    lat: 41.01642,
    lng: -73.91431,
    city: "Palisades",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1506,
    density: 238.9,
    county_fips: 36087,
    county_name: "Rockland",
    county_weights: {
      36087: 100,
    },
    county_names_all: "Rockland",
    county_fips_all: 36087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10965,
    lat: 41.06176,
    lng: -74.01286,
    city: "Pearl River",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15493,
    density: 1143.1,
    county_fips: 36087,
    county_name: "Rockland",
    county_weights: {
      36087: 100,
    },
    county_names_all: "Rockland",
    county_fips_all: 36087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10968,
    lat: 41.03976,
    lng: -73.91804,
    city: "Piermont",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2466,
    density: 1530.5,
    county_fips: 36087,
    county_name: "Rockland",
    county_weights: {
      36087: 100,
    },
    county_names_all: "Rockland",
    county_fips_all: 36087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10969,
    lat: 41.292,
    lng: -74.48879,
    city: "Pine Island",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1098,
    density: 38.7,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10970,
    lat: 41.1852,
    lng: -74.06568,
    city: "Pomona",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10433,
    density: 359.2,
    county_fips: 36087,
    county_name: "Rockland",
    county_weights: {
      36087: 100,
    },
    county_names_all: "Rockland",
    county_fips_all: 36087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10973,
    lat: 41.38442,
    lng: -74.47566,
    city: "Slate Hill",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2510,
    density: 117.3,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10974,
    lat: 41.15826,
    lng: -74.18993,
    city: "Sloatsburg",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3189,
    density: 166.2,
    county_fips: 36087,
    county_name: "Rockland",
    county_weights: {
      36071: 0.6,
      36087: 99.4,
    },
    county_names_all: "Rockland|Orange",
    county_fips_all: "36087|36071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10975,
    lat: 41.25951,
    lng: -74.17042,
    city: "Southfields",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 91,
    density: 7,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10976,
    lat: 41.02871,
    lng: -73.92594,
    city: "Sparkill",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2300,
    density: 778.4,
    county_fips: 36087,
    county_name: "Rockland",
    county_weights: {
      36087: 100,
    },
    county_names_all: "Rockland",
    county_fips_all: 36087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10977,
    lat: 41.11749,
    lng: -74.04825,
    city: "Spring Valley",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64677,
    density: 2217.8,
    county_fips: 36087,
    county_name: "Rockland",
    county_weights: {
      36087: 100,
    },
    county_names_all: "Rockland",
    county_fips_all: 36087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10979,
    lat: 41.18237,
    lng: -74.31877,
    city: "Sterling Forest",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36,
    density: 416.9,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10980,
    lat: 41.23157,
    lng: -74.05709,
    city: "Stony Point",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13923,
    density: 196.2,
    county_fips: 36087,
    county_name: "Rockland",
    county_weights: {
      36087: 100,
    },
    county_names_all: "Rockland",
    county_fips_all: 36087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10983,
    lat: 41.02747,
    lng: -73.94826,
    city: "Tappan",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5597,
    density: 1037.8,
    county_fips: 36087,
    county_name: "Rockland",
    county_weights: {
      36087: 100,
    },
    county_names_all: "Rockland",
    county_fips_all: 36087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10984,
    lat: 41.20928,
    lng: -74.02008,
    city: "Thiells",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2661,
    density: 546.5,
    county_fips: 36087,
    county_name: "Rockland",
    county_weights: {
      36087: 100,
    },
    county_names_all: "Rockland",
    county_fips_all: 36087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10985,
    lat: 41.57697,
    lng: -74.35782,
    city: "Thompson Ridge",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 149,
    density: 91.3,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 99.39,
      36105: 0.61,
    },
    county_names_all: "Orange|Sullivan",
    county_fips_all: "36071|36105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10986,
    lat: 41.27917,
    lng: -73.99445,
    city: "Tomkins Cove",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1836,
    density: 71.7,
    county_fips: 36087,
    county_name: "Rockland",
    county_weights: {
      36087: 100,
    },
    county_names_all: "Rockland",
    county_fips_all: 36087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10987,
    lat: 41.20737,
    lng: -74.22284,
    city: "Tuxedo Park",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3499,
    density: 40.5,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 99.75,
      36087: 0.25,
    },
    county_names_all: "Orange|Rockland",
    county_fips_all: "36071|36087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10988,
    lat: 41.30133,
    lng: -74.56218,
    city: "Unionville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 596,
    density: 708.3,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10989,
    lat: 41.12479,
    lng: -73.93632,
    city: "Valley Cottage",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8415,
    density: 671.9,
    county_fips: 36087,
    county_name: "Rockland",
    county_weights: {
      36087: 100,
    },
    county_names_all: "Rockland",
    county_fips_all: 36087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10990,
    lat: 41.2651,
    lng: -74.3663,
    city: "Warwick",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20735,
    density: 130.3,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10992,
    lat: 41.42648,
    lng: -74.16567,
    city: "Washingtonville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8830,
    density: 301.6,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10993,
    lat: 41.21011,
    lng: -73.97565,
    city: "West Haverstraw",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5044,
    density: 1661.7,
    county_fips: 36087,
    county_name: "Rockland",
    county_weights: {
      36087: 100,
    },
    county_names_all: "Rockland",
    county_fips_all: 36087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10994,
    lat: 41.09702,
    lng: -73.97322,
    city: "West Nyack",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7115,
    density: 443.9,
    county_fips: 36087,
    county_name: "Rockland",
    county_weights: {
      36087: 100,
    },
    county_names_all: "Rockland",
    county_fips_all: 36087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10996,
    lat: 41.38996,
    lng: -73.97257,
    city: "West Point",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6342,
    density: 767.6,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 10998,
    lat: 41.33118,
    lng: -74.53989,
    city: "Westtown",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3428,
    density: 61.3,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11001,
    lat: 40.72356,
    lng: -73.70451,
    city: "Floral Park",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26542,
    density: 4647,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 88.41,
      36081: 11.59,
    },
    county_names_all: "Nassau|Queens",
    county_fips_all: "36059|36081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11003,
    lat: 40.70143,
    lng: -73.7078,
    city: "Elmont",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44712,
    density: 4184.3,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11004,
    lat: 40.74621,
    lng: -73.71147,
    city: "Glen Oaks",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15297,
    density: 6210,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11005,
    lat: 40.75661,
    lng: -73.71424,
    city: "Floral Park",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2249,
    density: 4733.3,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11010,
    lat: 40.70066,
    lng: -73.67514,
    city: "Franklin Square",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25318,
    density: 4064.4,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11020,
    lat: 40.77098,
    lng: -73.71293,
    city: "Great Neck",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6325,
    density: 1265.2,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11021,
    lat: 40.78644,
    lng: -73.7289,
    city: "Great Neck",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18181,
    density: 2950.8,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11023,
    lat: 40.7994,
    lng: -73.73282,
    city: "Great Neck",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9479,
    density: 2191.8,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11024,
    lat: 40.81642,
    lng: -73.74205,
    city: "Great Neck",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7869,
    density: 867.8,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11030,
    lat: 40.79293,
    lng: -73.68868,
    city: "Manhasset",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18450,
    density: 1084.3,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11040,
    lat: 40.74572,
    lng: -73.67979,
    city: "New Hyde Park",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41523,
    density: 3333.7,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 96.61,
      36081: 3.39,
    },
    county_names_all: "Nassau|Queens",
    county_fips_all: "36059|36081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11042,
    lat: 40.75854,
    lng: -73.6975,
    city: "New Hyde Park",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 475,
    density: 306.1,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11050,
    lat: 40.83815,
    lng: -73.69113,
    city: "Port Washington",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30699,
    density: 1169.6,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11096,
    lat: 40.62143,
    lng: -73.75292,
    city: "Inwood",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8155,
    density: 2550.6,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11101,
    lat: 40.74679,
    lng: -73.93916,
    city: "Long Island City",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32537,
    density: 4855.8,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11102,
    lat: 40.77161,
    lng: -73.92619,
    city: "Astoria",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28359,
    density: 15621,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11103,
    lat: 40.76261,
    lng: -73.91334,
    city: "Astoria",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35419,
    density: 19758.6,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11104,
    lat: 40.74484,
    lng: -73.92049,
    city: "Sunnyside",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25037,
    density: 22109.7,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11105,
    lat: 40.779,
    lng: -73.90652,
    city: "Astoria",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37452,
    density: 8851.2,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11106,
    lat: 40.76191,
    lng: -73.93169,
    city: "Astoria",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37094,
    density: 16716,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36061: 0.26,
      36081: 99.74,
    },
    county_names_all: "Queens|New York",
    county_fips_all: "36081|36061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11109,
    lat: 40.7463,
    lng: -73.95699,
    city: "Long Island City",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6127,
    density: 51237.2,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11201,
    lat: 40.69477,
    lng: -73.99031,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64798,
    density: 18478.5,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11203,
    lat: 40.64958,
    lng: -73.93431,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 77589,
    density: 14005.3,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11204,
    lat: 40.61883,
    lng: -73.98496,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75840,
    density: 18364.2,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11205,
    lat: 40.69654,
    lng: -73.96807,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47866,
    density: 15777.7,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11206,
    lat: 40.7019,
    lng: -73.94254,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 87599,
    density: 24141.6,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11207,
    lat: 40.67016,
    lng: -73.89383,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 90867,
    density: 12898.8,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11208,
    lat: 40.67481,
    lng: -73.87243,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 102626,
    density: 14804.9,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 99.75,
      36081: 0.25,
    },
    county_names_all: "Kings|Queens",
    county_fips_all: "36047|36081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11209,
    lat: 40.62175,
    lng: -74.03013,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68368,
    density: 12490.8,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11210,
    lat: 40.62801,
    lng: -73.94631,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62423,
    density: 14617.9,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11211,
    lat: 40.71428,
    lng: -73.94602,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 104561,
    density: 27745.6,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11212,
    lat: 40.6629,
    lng: -73.91308,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74037,
    density: 18497.7,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11213,
    lat: 40.67117,
    lng: -73.93632,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67382,
    density: 24136.7,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11214,
    lat: 40.59928,
    lng: -73.99644,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 90372,
    density: 17237.3,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11215,
    lat: 40.66255,
    lng: -73.98687,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69995,
    density: 12348.2,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11216,
    lat: 40.68085,
    lng: -73.94929,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59567,
    density: 23954.1,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11217,
    lat: 40.68242,
    lng: -73.97943,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42461,
    density: 22246.1,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11218,
    lat: 40.64315,
    lng: -73.97645,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 73280,
    density: 20774.4,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11219,
    lat: 40.63267,
    lng: -73.99672,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 87812,
    density: 22717.8,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11220,
    lat: 40.64142,
    lng: -74.01741,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 90657,
    density: 20257.1,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11221,
    lat: 40.6914,
    lng: -73.92764,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 85582,
    density: 23928.6,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11222,
    lat: 40.72862,
    lng: -73.94764,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36710,
    density: 9310.3,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11223,
    lat: 40.59711,
    lng: -73.97344,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 80500,
    density: 15015.4,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11224,
    lat: 40.57652,
    lng: -73.9891,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45587,
    density: 11347.7,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11225,
    lat: 40.6631,
    lng: -73.95392,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56072,
    density: 24746.9,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11226,
    lat: 40.64636,
    lng: -73.95666,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 96332,
    density: 28553.2,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11228,
    lat: 40.61678,
    lng: -74.01337,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43878,
    density: 11315.3,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11229,
    lat: 40.60047,
    lng: -73.94453,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 81909,
    density: 15754,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11230,
    lat: 40.6221,
    lng: -73.96525,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 87188,
    density: 18266.4,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11231,
    lat: 40.67603,
    lng: -74.00644,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37796,
    density: 10241.2,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 99.8,
      36061: 0.2,
    },
    county_names_all: "Kings|New York",
    county_fips_all: "36047|36061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11232,
    lat: 40.65692,
    lng: -74.00727,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26501,
    density: 8242.1,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11233,
    lat: 40.67827,
    lng: -73.91994,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 79796,
    density: 22839.7,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11234,
    lat: 40.6072,
    lng: -73.91107,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 90372,
    density: 4725.4,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11235,
    lat: 40.58411,
    lng: -73.94331,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 76921,
    density: 12087.1,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11236,
    lat: 40.63951,
    lng: -73.90098,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 98821,
    density: 10704.9,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11237,
    lat: 40.70427,
    lng: -73.92108,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46772,
    density: 18123.9,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 99.55,
      36081: 0.45,
    },
    county_names_all: "Kings|Queens",
    county_fips_all: "36047|36081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11238,
    lat: 40.67105,
    lng: -73.96636,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55102,
    density: 11505.9,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11239,
    lat: 40.64733,
    lng: -73.87136,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12832,
    density: 2884.8,
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11249,
    lat: 40.71121,
    lng: -73.96318,
    city: "Brooklyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36047,
    county_name: "Kings",
    county_weights: {
      36047: 100,
    },
    county_names_all: "Kings",
    county_fips_all: 36047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11354,
    lat: 40.7686,
    lng: -73.82743,
    city: "Flushing",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52351,
    density: 9394.1,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11355,
    lat: 40.75143,
    lng: -73.82125,
    city: "Flushing",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 81358,
    density: 18299,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11356,
    lat: 40.78492,
    lng: -73.84149,
    city: "College Point",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24178,
    density: 5902.8,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11357,
    lat: 40.78636,
    lng: -73.81094,
    city: "Whitestone",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40118,
    density: 5464.6,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11358,
    lat: 40.76038,
    lng: -73.79648,
    city: "Flushing",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36665,
    density: 7235,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11359,
    lat: 40.79147,
    lng: -73.77662,
    city: "Bayside",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11360,
    lat: 40.7805,
    lng: -73.78159,
    city: "Bayside",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18892,
    density: 5302,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11361,
    lat: 40.76393,
    lng: -73.77294,
    city: "Bayside",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28531,
    density: 6428.8,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11362,
    lat: 40.75899,
    lng: -73.73583,
    city: "Little Neck",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18694,
    density: 3475.3,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11363,
    lat: 40.77251,
    lng: -73.74708,
    city: "Little Neck",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6834,
    density: 3052,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11364,
    lat: 40.74625,
    lng: -73.75598,
    city: "Oakland Gardens",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35866,
    density: 5519.3,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11365,
    lat: 40.73983,
    lng: -73.79499,
    city: "Fresh Meadows",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43730,
    density: 6791.1,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11366,
    lat: 40.73112,
    lng: -73.7804,
    city: "Fresh Meadows",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14109,
    density: 3575.2,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11367,
    lat: 40.73044,
    lng: -73.82274,
    city: "Flushing",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40141,
    density: 8105,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11368,
    lat: 40.74962,
    lng: -73.85264,
    city: "Corona",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 108661,
    density: 15930.3,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11369,
    lat: 40.76345,
    lng: -73.87222,
    city: "East Elmhurst",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30693,
    density: 10933.1,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11370,
    lat: 40.77554,
    lng: -73.88766,
    city: "East Elmhurst",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29366,
    density: 7346.1,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36005: 41.78,
      36081: 58.22,
    },
    county_names_all: "Queens|Bronx",
    county_fips_all: "36081|36005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11371,
    lat: 40.77445,
    lng: -73.87316,
    city: "Flushing",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11372,
    lat: 40.75172,
    lng: -73.88367,
    city: "Jackson Heights",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63107,
    density: 32988,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11373,
    lat: 40.73892,
    lng: -73.87854,
    city: "Elmhurst",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 96495,
    density: 24644.5,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11374,
    lat: 40.72647,
    lng: -73.86144,
    city: "Rego Park",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43173,
    density: 17657.1,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11375,
    lat: 40.72315,
    lng: -73.84373,
    city: "Forest Hills",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 72615,
    density: 11582.1,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11377,
    lat: 40.74483,
    lng: -73.90516,
    city: "Woodside",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 82021,
    density: 12507.9,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11378,
    lat: 40.72493,
    lng: -73.91034,
    city: "Maspeth",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39033,
    density: 6189.7,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11379,
    lat: 40.71709,
    lng: -73.88056,
    city: "Middle Village",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37780,
    density: 6583.7,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11385,
    lat: 40.70103,
    lng: -73.89011,
    city: "Ridgewood",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 105025,
    density: 11216.9,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11411,
    lat: 40.69406,
    lng: -73.73623,
    city: "Cambria Heights",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20473,
    density: 6702.8,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11412,
    lat: 40.69804,
    lng: -73.759,
    city: "Saint Albans",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37987,
    density: 8916.1,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11413,
    lat: 40.67002,
    lng: -73.75116,
    city: "Springfield Gardens",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41810,
    density: 5351.6,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11414,
    lat: 40.65818,
    lng: -73.8448,
    city: "Howard Beach",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27672,
    density: 4628.1,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11415,
    lat: 40.70808,
    lng: -73.82801,
    city: "Kew Gardens",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18464,
    density: 12727.7,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11416,
    lat: 40.68458,
    lng: -73.84967,
    city: "Ozone Park",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26087,
    density: 15269.5,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36047: 0.31,
      36081: 99.69,
    },
    county_names_all: "Queens|Kings",
    county_fips_all: "36081|36047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11417,
    lat: 40.67641,
    lng: -73.84455,
    city: "Ozone Park",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31156,
    density: 10803.3,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36047: 0.2,
      36081: 99.8,
    },
    county_names_all: "Queens|Kings",
    county_fips_all: "36081|36047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11418,
    lat: 40.70032,
    lng: -73.83603,
    city: "Richmond Hill",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37666,
    density: 8763.2,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11419,
    lat: 40.68863,
    lng: -73.82302,
    city: "South Richmond Hill",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47955,
    density: 16435.6,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11420,
    lat: 40.67352,
    lng: -73.8177,
    city: "South Ozone Park",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47266,
    density: 8658.2,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11421,
    lat: 40.69403,
    lng: -73.85865,
    city: "Woodhaven",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39654,
    density: 11915.9,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11422,
    lat: 40.66053,
    lng: -73.73658,
    city: "Rosedale",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32786,
    density: 6031.1,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36059: 0.14,
      36081: 99.86,
    },
    county_names_all: "Queens|Nassau",
    county_fips_all: "36081|36059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11423,
    lat: 40.71564,
    lng: -73.76826,
    city: "Hollis",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29532,
    density: 8101.8,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11424,
    lat: 40.71397,
    lng: -73.82809,
    city: "Jamaica",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40,
    density: 815,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11426,
    lat: 40.73641,
    lng: -73.7223,
    city: "Bellerose",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20222,
    density: 5688,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11427,
    lat: 40.73094,
    lng: -73.74569,
    city: "Queens Village",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25096,
    density: 6176.9,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11428,
    lat: 40.72099,
    lng: -73.74222,
    city: "Queens Village",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19830,
    density: 9205.8,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11429,
    lat: 40.70958,
    lng: -73.73843,
    city: "Queens Village",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27808,
    density: 8130.1,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11430,
    lat: 40.64703,
    lng: -73.78717,
    city: "Jamaica",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 220,
    density: 11.9,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11432,
    lat: 40.71491,
    lng: -73.79295,
    city: "Jamaica",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64282,
    density: 12266,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11433,
    lat: 40.69805,
    lng: -73.78675,
    city: "Jamaica",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36929,
    density: 9313.9,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11434,
    lat: 40.67683,
    lng: -73.77623,
    city: "Jamaica",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62590,
    density: 7446.4,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11435,
    lat: 40.70111,
    lng: -73.80968,
    city: "Jamaica",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59392,
    density: 15179.8,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11436,
    lat: 40.67587,
    lng: -73.79664,
    city: "Jamaica",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18955,
    density: 9176.4,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11439,
    lat: 40.72195,
    lng: -73.79455,
    city: "Jamaica",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11451,
    lat: 40.7012,
    lng: -73.79579,
    city: "Jamaica",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11501,
    lat: 40.74629,
    lng: -73.63921,
    city: "Mineola",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19675,
    density: 3733.7,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11507,
    lat: 40.77082,
    lng: -73.6521,
    city: "Albertson",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7051,
    density: 2577.1,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11509,
    lat: 40.58872,
    lng: -73.7286,
    city: "Atlantic Beach",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1790,
    density: 822.2,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11510,
    lat: 40.65027,
    lng: -73.60809,
    city: "Baldwin",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33949,
    density: 3157,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11514,
    lat: 40.74979,
    lng: -73.61298,
    city: "Carle Place",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4644,
    density: 1980.4,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11516,
    lat: 40.6258,
    lng: -73.7263,
    city: "Cedarhurst",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7476,
    density: 3138.1,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11518,
    lat: 40.63772,
    lng: -73.66691,
    city: "East Rockaway",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9819,
    density: 2714.8,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11520,
    lat: 40.65007,
    lng: -73.58305,
    city: "Freeport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43451,
    density: 3315.4,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11530,
    lat: 40.72716,
    lng: -73.63654,
    city: "Garden City",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27669,
    density: 1476.5,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11542,
    lat: 40.87073,
    lng: -73.62879,
    city: "Glen Cove",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27666,
    density: 1589.5,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11545,
    lat: 40.82685,
    lng: -73.58853,
    city: "Glen Head",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12686,
    density: 427.6,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11547,
    lat: 40.82881,
    lng: -73.64505,
    city: "Glenwood Landing",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 625,
    density: 524.9,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11548,
    lat: 40.81414,
    lng: -73.6097,
    city: "Greenvale",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2491,
    density: 996.7,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11549,
    lat: 40.71896,
    lng: -73.59973,
    city: "Hempstead",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2728,
    density: 4392.6,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11550,
    lat: 40.70158,
    lng: -73.62039,
    city: "Hempstead",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57073,
    density: 5235.5,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11552,
    lat: 40.6916,
    lng: -73.65073,
    city: "West Hempstead",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25169,
    density: 2781,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11553,
    lat: 40.70529,
    lng: -73.5923,
    city: "Uniondale",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26938,
    density: 3212,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11554,
    lat: 40.71974,
    lng: -73.56044,
    city: "East Meadow",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37992,
    density: 2327.3,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11556,
    lat: 40.71997,
    lng: -73.58327,
    city: "Uniondale",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11557,
    lat: 40.63723,
    lng: -73.6921,
    city: "Hewlett",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7950,
    density: 1505.1,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11558,
    lat: 40.60539,
    lng: -73.64952,
    city: "Island Park",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8435,
    density: 2193.7,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11559,
    lat: 40.60615,
    lng: -73.71688,
    city: "Lawrence",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8265,
    density: 767.4,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11560,
    lat: 40.88068,
    lng: -73.59057,
    city: "Locust Valley",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6850,
    density: 354.3,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11561,
    lat: 40.58969,
    lng: -73.64455,
    city: "Long Beach",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37759,
    density: 3633.9,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11563,
    lat: 40.65746,
    lng: -73.67408,
    city: "Lynbrook",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21537,
    density: 3577.7,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11565,
    lat: 40.67505,
    lng: -73.67177,
    city: "Malverne",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8921,
    density: 3052,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11566,
    lat: 40.66307,
    lng: -73.55407,
    city: "Merrick",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33626,
    density: 2389.6,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11568,
    lat: 40.78659,
    lng: -73.59719,
    city: "Old Westbury",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4470,
    density: 199.1,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11569,
    lat: 40.5903,
    lng: -73.58046,
    city: "Point Lookout",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1175,
    density: 1622.7,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11570,
    lat: 40.66504,
    lng: -73.63882,
    city: "Rockville Centre",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27240,
    density: 2931,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11572,
    lat: 40.63231,
    lng: -73.63686,
    city: "Oceanside",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28673,
    density: 2321.9,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11575,
    lat: 40.68044,
    lng: -73.58525,
    city: "Roosevelt",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16799,
    density: 3645.5,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11576,
    lat: 40.79791,
    lng: -73.64711,
    city: "Roslyn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12606,
    density: 1056.6,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11577,
    lat: 40.78288,
    lng: -73.6391,
    city: "Roslyn Heights",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12120,
    density: 1585,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11579,
    lat: 40.84406,
    lng: -73.64426,
    city: "Sea Cliff",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5183,
    density: 1797.8,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11580,
    lat: 40.67491,
    lng: -73.70374,
    city: "Valley Stream",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41930,
    density: 4164.6,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11581,
    lat: 40.65153,
    lng: -73.71653,
    city: "Valley Stream",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21847,
    density: 3097.2,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 99.84,
      36081: 0.16,
    },
    county_names_all: "Nassau|Queens",
    county_fips_all: "36059|36081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11590,
    lat: 40.75541,
    lng: -73.57463,
    city: "Westbury",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47468,
    density: 2733.6,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11596,
    lat: 40.75968,
    lng: -73.6422,
    city: "Williston Park",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10276,
    density: 2998,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11598,
    lat: 40.63109,
    lng: -73.71188,
    city: "Woodmere",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13977,
    density: 2787,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11691,
    lat: 40.60152,
    lng: -73.76173,
    city: "Far Rockaway",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68454,
    density: 9849.6,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36059: 0.12,
      36081: 99.88,
    },
    county_names_all: "Queens|Nassau",
    county_fips_all: "36081|36059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11692,
    lat: 40.59373,
    lng: -73.79201,
    city: "Arverne",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22394,
    density: 8511.5,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11693,
    lat: 40.59649,
    lng: -73.81663,
    city: "Far Rockaway",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13029,
    density: 5088.1,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11694,
    lat: 40.57532,
    lng: -73.85099,
    city: "Rockaway Park",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21258,
    density: 4697.4,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11697,
    lat: 40.55749,
    lng: -73.91361,
    city: "Breezy Point",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3527,
    density: 665.1,
    county_fips: 36081,
    county_name: "Queens",
    county_weights: {
      36081: 100,
    },
    county_names_all: "Queens",
    county_fips_all: 36081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11701,
    lat: 40.6817,
    lng: -73.41289,
    city: "Amityville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27264,
    density: 2269.1,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11702,
    lat: 40.65155,
    lng: -73.33824,
    city: "Babylon",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13963,
    density: 468.6,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11703,
    lat: 40.73325,
    lng: -73.32533,
    city: "North Babylon",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16820,
    density: 2131.1,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11704,
    lat: 40.71623,
    lng: -73.35908,
    city: "West Babylon",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39960,
    density: 1955.4,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11705,
    lat: 40.74514,
    lng: -73.05461,
    city: "Bayport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8033,
    density: 915,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11706,
    lat: 40.706,
    lng: -73.24208,
    city: "Bay Shore",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67484,
    density: 1539,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11709,
    lat: 40.90665,
    lng: -73.56005,
    city: "Bayville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6720,
    density: 1747.5,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11710,
    lat: 40.67217,
    lng: -73.53293,
    city: "Bellmore",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35473,
    density: 2815.7,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11713,
    lat: 40.77774,
    lng: -72.94253,
    city: "Bellport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8247,
    density: 570.3,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11714,
    lat: 40.74267,
    lng: -73.48615,
    city: "Bethpage",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22769,
    density: 2080.7,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11715,
    lat: 40.75005,
    lng: -73.03531,
    city: "Blue Point",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4287,
    density: 974.6,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11716,
    lat: 40.77131,
    lng: -73.12729,
    city: "Bohemia",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9748,
    density: 435.6,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11717,
    lat: 40.78405,
    lng: -73.25223,
    city: "Brentwood",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62888,
    density: 2259.9,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11718,
    lat: 40.71891,
    lng: -73.26391,
    city: "Brightwaters",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3070,
    density: 1264.7,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11719,
    lat: 40.77935,
    lng: -72.91175,
    city: "Brookhaven",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3209,
    density: 232,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11720,
    lat: 40.87025,
    lng: -73.08202,
    city: "Centereach",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28773,
    density: 1350.2,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11721,
    lat: 40.89362,
    lng: -73.37009,
    city: "Centerport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6258,
    density: 963.1,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11722,
    lat: 40.78358,
    lng: -73.19657,
    city: "Central Islip",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34139,
    density: 1891.7,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11724,
    lat: 40.86522,
    lng: -73.45288,
    city: "Cold Spring Harbor",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3089,
    density: 308.9,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11725,
    lat: 40.84056,
    lng: -73.28085,
    city: "Commack",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29229,
    density: 1162.3,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11726,
    lat: 40.67891,
    lng: -73.39564,
    city: "Copiague",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21012,
    density: 3204.3,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11727,
    lat: 40.88019,
    lng: -73.00368,
    city: "Coram",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29262,
    density: 1202.7,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11729,
    lat: 40.76249,
    lng: -73.32161,
    city: "Deer Park",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25597,
    density: 1595.2,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11730,
    lat: 40.72701,
    lng: -73.18456,
    city: "East Islip",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13335,
    density: 1145.2,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11731,
    lat: 40.86262,
    lng: -73.31703,
    city: "East Northport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30951,
    density: 1436.1,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11732,
    lat: 40.84245,
    lng: -73.53916,
    city: "East Norwich",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3505,
    density: 626,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11733,
    lat: 40.93742,
    lng: -73.10544,
    city: "East Setauket",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17000,
    density: 559.1,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11735,
    lat: 40.73177,
    lng: -73.43284,
    city: "Farmingdale",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33299,
    density: 1197.5,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36059: 46.03,
      36103: 53.97,
    },
    county_names_all: "Suffolk|Nassau",
    county_fips_all: "36103|36059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11738,
    lat: 40.83779,
    lng: -73.03761,
    city: "Farmingville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19364,
    density: 1493.7,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11739,
    lat: 40.71058,
    lng: -73.16275,
    city: "Great River",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1307,
    density: 142,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11740,
    lat: 40.86536,
    lng: -73.36118,
    city: "Greenlawn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9321,
    density: 982.5,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11741,
    lat: 40.79473,
    lng: -73.07043,
    city: "Holbrook",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26245,
    density: 1349.8,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11742,
    lat: 40.81034,
    lng: -73.0419,
    city: "Holtsville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11968,
    density: 897.4,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11743,
    lat: 40.88018,
    lng: -73.4266,
    city: "Huntington",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42636,
    density: 641.4,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11746,
    lat: 40.81421,
    lng: -73.3608,
    city: "Huntington Station",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 66518,
    density: 1065,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11747,
    lat: 40.78372,
    lng: -73.40931,
    city: "Melville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18795,
    density: 576.1,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11749,
    lat: 40.80674,
    lng: -73.1708,
    city: "Islandia",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3315,
    density: 585.3,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11751,
    lat: 40.72999,
    lng: -73.21424,
    city: "Islip",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13399,
    density: 1305.1,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11752,
    lat: 40.75791,
    lng: -73.17359,
    city: "Islip Terrace",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8821,
    density: 843.2,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11753,
    lat: 40.78976,
    lng: -73.5411,
    city: "Jericho",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13092,
    density: 1275,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11754,
    lat: 40.88771,
    lng: -73.24738,
    city: "Kings Park",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17861,
    density: 936.6,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11755,
    lat: 40.8583,
    lng: -73.11748,
    city: "Lake Grove",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12514,
    density: 1473.9,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11756,
    lat: 40.72545,
    lng: -73.51656,
    city: "Levittown",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42856,
    density: 2992.6,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11757,
    lat: 40.68892,
    lng: -73.37356,
    city: "Lindenhurst",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44130,
    density: 2502.1,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11758,
    lat: 40.65361,
    lng: -73.45626,
    city: "Massapequa",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53034,
    density: 1707.7,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11762,
    lat: 40.68283,
    lng: -73.44707,
    city: "Massapequa Park",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22263,
    density: 2669.4,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11763,
    lat: 40.82529,
    lng: -72.98245,
    city: "Medford",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28769,
    density: 807.5,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11764,
    lat: 40.93585,
    lng: -72.97544,
    city: "Miller Place",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13633,
    density: 573.4,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11765,
    lat: 40.88249,
    lng: -73.55862,
    city: "Mill Neck",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 871,
    density: 148.9,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11766,
    lat: 40.93602,
    lng: -73.01645,
    city: "Mount Sinai",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11018,
    density: 705.8,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11767,
    lat: 40.84438,
    lng: -73.14535,
    city: "Nesconset",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15051,
    density: 1341.3,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11768,
    lat: 40.91052,
    lng: -73.32611,
    city: "Northport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20903,
    density: 534.5,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11769,
    lat: 40.73703,
    lng: -73.12929,
    city: "Oakdale",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8299,
    density: 735.4,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11770,
    lat: 40.64945,
    lng: -73.14123,
    city: "Ocean Beach",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65,
    density: 41.5,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11771,
    lat: 40.8674,
    lng: -73.52651,
    city: "Oyster Bay",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9517,
    density: 339,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11772,
    lat: 40.76118,
    lng: -72.9875,
    city: "Patchogue",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46311,
    density: 1108.4,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11776,
    lat: 40.91345,
    lng: -73.04567,
    city: "Port Jefferson Station",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23578,
    density: 1273.6,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11777,
    lat: 40.95171,
    lng: -73.0645,
    city: "Port Jefferson",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9156,
    density: 804.9,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11778,
    lat: 40.94312,
    lng: -72.93073,
    city: "Rocky Point",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11855,
    density: 679,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11779,
    lat: 40.8127,
    lng: -73.1156,
    city: "Ronkonkoma",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38091,
    density: 1179.4,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11780,
    lat: 40.89249,
    lng: -73.16973,
    city: "Saint James",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15934,
    density: 534.8,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11782,
    lat: 40.73727,
    lng: -73.08024,
    city: "Sayville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15057,
    density: 1046.7,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11783,
    lat: 40.67766,
    lng: -73.49068,
    city: "Seaford",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21285,
    density: 2320.3,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11784,
    lat: 40.86855,
    lng: -73.0422,
    city: "Selden",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25014,
    density: 1762.6,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11786,
    lat: 40.94711,
    lng: -72.88939,
    city: "Shoreham",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6225,
    density: 495.9,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11787,
    lat: 40.85338,
    lng: -73.21089,
    city: "Smithtown",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33837,
    density: 876.9,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11788,
    lat: 40.81808,
    lng: -73.21318,
    city: "Hauppauge",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16693,
    density: 749.1,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11789,
    lat: 40.95759,
    lng: -72.97214,
    city: "Sound Beach",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7496,
    density: 1710.1,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11790,
    lat: 40.90719,
    lng: -73.12777,
    city: "Stony Brook",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16099,
    density: 852.2,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11791,
    lat: 40.82819,
    lng: -73.50282,
    city: "Syosset",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25776,
    density: 795.3,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11792,
    lat: 40.94832,
    lng: -72.8302,
    city: "Wading River",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8413,
    density: 328.5,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11793,
    lat: 40.6462,
    lng: -73.51024,
    city: "Wantagh",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30601,
    density: 1198.7,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11794,
    lat: 40.91915,
    lng: -73.12475,
    city: "Stony Brook",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3363,
    density: 5682.9,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11795,
    lat: 40.70803,
    lng: -73.29827,
    city: "West Islip",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25062,
    density: 1700.2,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11796,
    lat: 40.72958,
    lng: -73.09986,
    city: "West Sayville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4112,
    density: 1272.2,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11797,
    lat: 40.81739,
    lng: -73.47004,
    city: "Woodbury",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8998,
    density: 681.8,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11798,
    lat: 40.752,
    lng: -73.37497,
    city: "Wyandanch",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15636,
    density: 1212.5,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11801,
    lat: 40.76256,
    lng: -73.52383,
    city: "Hicksville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40179,
    density: 2324.1,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11803,
    lat: 40.78177,
    lng: -73.4733,
    city: "Plainview",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29208,
    density: 1830.8,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11804,
    lat: 40.75829,
    lng: -73.45706,
    city: "Old Bethpage",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4639,
    density: 635,
    county_fips: 36059,
    county_name: "Nassau",
    county_weights: {
      36059: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 36059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11901,
    lat: 40.92424,
    lng: -72.64697,
    city: "Riverhead",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28760,
    density: 195.8,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11930,
    lat: 40.98877,
    lng: -72.10482,
    city: "Amagansett",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 618,
    density: 27.8,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11931,
    lat: 40.93347,
    lng: -72.62195,
    city: "Aquebogue",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 84,
    density: 146.5,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11932,
    lat: 40.93322,
    lng: -72.30603,
    city: "Bridgehampton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1099,
    density: 58.6,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11933,
    lat: 40.92449,
    lng: -72.75453,
    city: "Calverton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6475,
    density: 98.5,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11934,
    lat: 40.80201,
    lng: -72.79428,
    city: "Center Moriches",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7357,
    density: 513.1,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11935,
    lat: 41.01795,
    lng: -72.48933,
    city: "Cutchogue",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3008,
    density: 112.5,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11937,
    lat: 40.99714,
    lng: -72.20253,
    city: "East Hampton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16672,
    density: 173.6,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11939,
    lat: 41.12627,
    lng: -72.34223,
    city: "East Marion",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1144,
    density: 197.3,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11940,
    lat: 40.80819,
    lng: -72.75664,
    city: "East Moriches",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4963,
    density: 382.4,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11941,
    lat: 40.83311,
    lng: -72.72315,
    city: "Eastport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1770,
    density: 166.5,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11942,
    lat: 40.84901,
    lng: -72.57764,
    city: "East Quogue",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5053,
    density: 229.9,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11944,
    lat: 41.09888,
    lng: -72.37223,
    city: "Greenport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4144,
    density: 393.2,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11946,
    lat: 40.87033,
    lng: -72.52294,
    city: "Hampton Bays",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15058,
    density: 430.6,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11947,
    lat: 40.94302,
    lng: -72.58189,
    city: "Jamesport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 423,
    density: 4866.8,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11948,
    lat: 40.9662,
    lng: -72.55797,
    city: "Laurel",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 670,
    density: 92.2,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11949,
    lat: 40.86496,
    lng: -72.80097,
    city: "Manorville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13457,
    density: 141.9,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11950,
    lat: 40.80627,
    lng: -72.84734,
    city: "Mastic",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16130,
    density: 1684.1,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11951,
    lat: 40.76624,
    lng: -72.83655,
    city: "Mastic Beach",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14756,
    density: 1187.2,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11952,
    lat: 40.99716,
    lng: -72.54369,
    city: "Mattituck",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5031,
    density: 209.2,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11953,
    lat: 40.88585,
    lng: -72.95054,
    city: "Middle Island",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14301,
    density: 535.4,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11954,
    lat: 41.04458,
    lng: -71.9518,
    city: "Montauk",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3563,
    density: 74.2,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11955,
    lat: 40.80777,
    lng: -72.82289,
    city: "Moriches",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3149,
    density: 544.8,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11956,
    lat: 40.98067,
    lng: -72.46868,
    city: "New Suffolk",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 353,
    density: 107.5,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11957,
    lat: 41.1492,
    lng: -72.26181,
    city: "Orient",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1023,
    density: 61,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11958,
    lat: 41.03688,
    lng: -72.4613,
    city: "Peconic",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 683,
    density: 90,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11959,
    lat: 40.82903,
    lng: -72.60977,
    city: "Quogue",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 571,
    density: 36,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11960,
    lat: 40.80894,
    lng: -72.70615,
    city: "Remsenburg",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 721,
    density: 140.1,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11961,
    lat: 40.90458,
    lng: -72.88488,
    city: "Ridge",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13701,
    density: 351.9,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11962,
    lat: 40.93715,
    lng: -72.27379,
    city: "Sagaponack",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 296,
    density: 19.5,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11963,
    lat: 40.99921,
    lng: -72.32271,
    city: "Sag Harbor",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6966,
    density: 184.4,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11964,
    lat: 41.05743,
    lng: -72.31492,
    city: "Shelter Island",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2287,
    density: 94.1,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11965,
    lat: 41.07727,
    lng: -72.34244,
    city: "Shelter Island Heights",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 456,
    density: 64.2,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11967,
    lat: 40.80092,
    lng: -72.87611,
    city: "Shirley",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29130,
    density: 851.3,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11968,
    lat: 40.90035,
    lng: -72.42081,
    city: "Southampton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10778,
    density: 154.7,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11970,
    lat: 40.94029,
    lng: -72.57403,
    city: "South Jamesport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 391,
    density: 383.3,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11971,
    lat: 41.05949,
    lng: -72.42617,
    city: "Southold",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6073,
    density: 213.9,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11972,
    lat: 40.82362,
    lng: -72.70045,
    city: "Speonk",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 983,
    density: 471.8,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11973,
    lat: 40.86583,
    lng: -72.88718,
    city: "Upton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37,
    density: 5.9,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11975,
    lat: 40.95146,
    lng: -72.25093,
    city: "Wainscott",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 170,
    density: 16.2,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11976,
    lat: 40.92986,
    lng: -72.34721,
    city: "Water Mill",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1847,
    density: 55,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11977,
    lat: 40.82769,
    lng: -72.67947,
    city: "Westhampton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2629,
    density: 176.7,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11978,
    lat: 40.82878,
    lng: -72.64669,
    city: "Westhampton Beach",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2981,
    density: 113.2,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 11980,
    lat: 40.8321,
    lng: -72.92198,
    city: "Yaphank",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5966,
    density: 191.4,
    county_fips: 36103,
    county_name: "Suffolk",
    county_weights: {
      36103: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 36103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12007,
    lat: 42.48889,
    lng: -73.93159,
    city: "Alcove",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10,
    density: 0.8,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12008,
    lat: 42.85367,
    lng: -73.9063,
    city: "Alplaus",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 542,
    density: 312.7,
    county_fips: 36093,
    county_name: "Schenectady",
    county_weights: {
      36093: 100,
    },
    county_names_all: "Schenectady",
    county_fips_all: 36093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12009,
    lat: 42.69824,
    lng: -74.03398,
    city: "Altamont",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7690,
    density: 56.4,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 99.62,
      36093: 0.38,
    },
    county_names_all: "Albany|Schenectady",
    county_fips_all: "36001|36093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12010,
    lat: 42.93752,
    lng: -74.17287,
    city: "Amsterdam",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27556,
    density: 82.9,
    county_fips: 36057,
    county_name: "Montgomery",
    county_weights: {
      36035: 18.26,
      36057: 64.3,
      36091: 11.56,
      36093: 5.88,
    },
    county_names_all: "Montgomery|Fulton|Saratoga|Schenectady",
    county_fips_all: "36057|36035|36091|36093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12015,
    lat: 42.28315,
    lng: -73.82543,
    city: "Athens",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3347,
    density: 85.5,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12017,
    lat: 42.31453,
    lng: -73.45682,
    city: "Austerlitz",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 445,
    density: 11.7,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 36021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12018,
    lat: 42.62926,
    lng: -73.52662,
    city: "Averill Park",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7112,
    density: 59.4,
    county_fips: 36083,
    county_name: "Rensselaer",
    county_weights: {
      36083: 100,
    },
    county_names_all: "Rensselaer",
    county_fips_all: 36083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12019,
    lat: 42.92993,
    lng: -73.88245,
    city: "Ballston Lake",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14244,
    density: 193.2,
    county_fips: 36091,
    county_name: "Saratoga",
    county_weights: {
      36091: 97.82,
      36093: 2.18,
    },
    county_names_all: "Saratoga|Schenectady",
    county_fips_all: "36091|36093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12020,
    lat: 43.00208,
    lng: -73.87401,
    city: "Ballston Spa",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33235,
    density: 169.8,
    county_fips: 36091,
    county_name: "Saratoga",
    county_weights: {
      36091: 100,
    },
    county_names_all: "Saratoga",
    county_fips_all: 36091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12022,
    lat: 42.66653,
    lng: -73.33401,
    city: "Berlin",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 652,
    density: 10.6,
    county_fips: 36083,
    county_name: "Rensselaer",
    county_weights: {
      36083: 100,
    },
    county_names_all: "Rensselaer",
    county_fips_all: 36083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12023,
    lat: 42.60656,
    lng: -74.16573,
    city: "Berne",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2376,
    density: 15.5,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 75.79,
      36095: 24.21,
    },
    county_names_all: "Albany|Schoharie",
    county_fips_all: "36001|36095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12024,
    lat: 42.48134,
    lng: -73.53419,
    city: "Brainard",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 99.36,
      36083: 0.64,
    },
    county_names_all: "Columbia|Rensselaer",
    county_fips_all: "36021|36083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12025,
    lat: 43.09142,
    lng: -74.11924,
    city: "Broadalbin",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5331,
    density: 49.1,
    county_fips: 36035,
    county_name: "Fulton",
    county_weights: {
      36035: 61.44,
      36091: 38.56,
    },
    county_names_all: "Fulton|Saratoga",
    county_fips_all: "36035|36091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12027,
    lat: 42.92122,
    lng: -73.90872,
    city: "Burnt Hills",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3996,
    density: 206.8,
    county_fips: 36091,
    county_name: "Saratoga",
    county_weights: {
      36091: 88,
      36093: 12,
    },
    county_names_all: "Saratoga|Schenectady",
    county_fips_all: "36091|36093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12028,
    lat: 42.94545,
    lng: -73.44213,
    city: "Buskirk",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 707,
    density: 11.5,
    county_fips: 36115,
    county_name: "Washington",
    county_weights: {
      36083: 47.22,
      36115: 52.78,
    },
    county_names_all: "Washington|Rensselaer",
    county_fips_all: "36115|36083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12029,
    lat: 42.40397,
    lng: -73.42466,
    city: "Canaan",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1082,
    density: 20.1,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 36021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12031,
    lat: 42.76579,
    lng: -74.46617,
    city: "Carlisle",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 174,
    density: 19.1,
    county_fips: 36095,
    county_name: "Schoharie",
    county_weights: {
      36095: 100,
    },
    county_names_all: "Schoharie",
    county_fips_all: 36095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12032,
    lat: 43.24042,
    lng: -74.55666,
    city: "Caroga Lake",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 753,
    density: 3.1,
    county_fips: 36041,
    county_name: "Hamilton",
    county_weights: {
      36035: 43.52,
      36041: 56.48,
    },
    county_names_all: "Hamilton|Fulton",
    county_fips_all: "36041|36035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12033,
    lat: 42.53665,
    lng: -73.70558,
    city: "Castleton On Hudson",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8152,
    density: 110.4,
    county_fips: 36083,
    county_name: "Rensselaer",
    county_weights: {
      36083: 100,
    },
    county_names_all: "Rensselaer",
    county_fips_all: 36083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12035,
    lat: 42.73453,
    lng: -74.37534,
    city: "Central Bridge",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 579,
    density: 23.2,
    county_fips: 36095,
    county_name: "Schoharie",
    county_weights: {
      36095: 100,
    },
    county_names_all: "Schoharie",
    county_fips_all: 36095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12036,
    lat: 42.53564,
    lng: -74.68468,
    city: "Charlotteville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 252,
    density: 13.8,
    county_fips: 36095,
    county_name: "Schoharie",
    county_weights: {
      36077: 21.8,
      36095: 78.2,
    },
    county_names_all: "Schoharie|Otsego",
    county_fips_all: "36095|36077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12037,
    lat: 42.33506,
    lng: -73.55714,
    city: "Chatham",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4489,
    density: 47.9,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 36021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12040,
    lat: 42.63047,
    lng: -73.35916,
    city: "Cherry Plain",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 87,
    density: 562.2,
    county_fips: 36083,
    county_name: "Rensselaer",
    county_weights: {
      36083: 100,
    },
    county_names_all: "Rensselaer",
    county_fips_all: 36083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12041,
    lat: 42.55893,
    lng: -73.97028,
    city: "Clarksville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 681,
    density: 134.1,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12042,
    lat: 42.38185,
    lng: -73.89162,
    city: "Climax",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 233,
    density: 18,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12043,
    lat: 42.70357,
    lng: -74.5267,
    city: "Cobleskill",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8202,
    density: 49.8,
    county_fips: 36095,
    county_name: "Schoharie",
    county_weights: {
      36077: 2.8,
      36095: 97.2,
    },
    county_names_all: "Schoharie|Otsego",
    county_fips_all: "36095|36077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12045,
    lat: 42.47974,
    lng: -73.79682,
    city: "Coeymans",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 449,
    density: 140.4,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12046,
    lat: 42.48864,
    lng: -73.92119,
    city: "Coeymans Hollow",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1103,
    density: 28.7,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 96.75,
      36039: 3.25,
    },
    county_names_all: "Albany|Greene",
    county_fips_all: "36001|36039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12047,
    lat: 42.78396,
    lng: -73.72655,
    city: "Cohoes",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21453,
    density: 936.9,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12051,
    lat: 42.34493,
    lng: -73.83938,
    city: "Coxsackie",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6769,
    density: 145.9,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12052,
    lat: 42.75767,
    lng: -73.47847,
    city: "Cropseyville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1921,
    density: 24.6,
    county_fips: 36083,
    county_name: "Rensselaer",
    county_weights: {
      36083: 100,
    },
    county_names_all: "Rensselaer",
    county_fips_all: 36083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12053,
    lat: 42.75283,
    lng: -74.18791,
    city: "Delanson",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4611,
    density: 31.6,
    county_fips: 36093,
    county_name: "Schenectady",
    county_weights: {
      36001: 16.77,
      36057: 2.31,
      36093: 68.36,
      36095: 12.56,
    },
    county_names_all: "Schenectady|Albany|Schoharie|Montgomery",
    county_fips_all: "36093|36001|36095|36057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12054,
    lat: 42.60764,
    lng: -73.86864,
    city: "Delmar",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16948,
    density: 423.4,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12056,
    lat: 42.76761,
    lng: -74.0905,
    city: "Duanesburg",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2543,
    density: 52.3,
    county_fips: 36093,
    county_name: "Schenectady",
    county_weights: {
      36093: 100,
    },
    county_names_all: "Schenectady",
    county_fips_all: 36093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12057,
    lat: 42.97316,
    lng: -73.34335,
    city: "Eagle Bridge",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2176,
    density: 22,
    county_fips: 36115,
    county_name: "Washington",
    county_weights: {
      36083: 18.26,
      36115: 81.74,
    },
    county_names_all: "Washington|Rensselaer",
    county_fips_all: "36115|36083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12058,
    lat: 42.3498,
    lng: -73.923,
    city: "Earlton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 971,
    density: 18.8,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12059,
    lat: 42.61403,
    lng: -74.05811,
    city: "East Berne",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1719,
    density: 29.1,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12060,
    lat: 42.41325,
    lng: -73.49284,
    city: "East Chatham",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1687,
    density: 18.1,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 36021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12061,
    lat: 42.59915,
    lng: -73.65658,
    city: "East Greenbush",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9725,
    density: 186.9,
    county_fips: 36083,
    county_name: "Rensselaer",
    county_weights: {
      36083: 100,
    },
    county_names_all: "Rensselaer",
    county_fips_all: 36083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12062,
    lat: 42.52871,
    lng: -73.501,
    city: "East Nassau",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1601,
    density: 18.6,
    county_fips: 36083,
    county_name: "Rensselaer",
    county_weights: {
      36021: 9.53,
      36083: 90.47,
    },
    county_names_all: "Rensselaer|Columbia",
    county_fips_all: "36083|36021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12063,
    lat: 42.56442,
    lng: -73.63826,
    city: "East Schodack",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 770,
    density: 232.4,
    county_fips: 36083,
    county_name: "Rensselaer",
    county_weights: {
      36083: 100,
    },
    county_names_all: "Rensselaer",
    county_fips_all: 36083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12064,
    lat: 42.60711,
    lng: -74.65887,
    city: "East Worcester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 307,
    density: 13.1,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36077: 62.24,
      36095: 37.76,
    },
    county_names_all: "Otsego|Schoharie",
    county_fips_all: "36077|36095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12065,
    lat: 42.85402,
    lng: -73.78654,
    city: "Clifton Park",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42432,
    density: 466.5,
    county_fips: 36091,
    county_name: "Saratoga",
    county_weights: {
      36091: 100,
    },
    county_names_all: "Saratoga",
    county_fips_all: 36091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12066,
    lat: 42.78011,
    lng: -74.30291,
    city: "Esperance",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1837,
    density: 21.7,
    county_fips: 36057,
    county_name: "Montgomery",
    county_weights: {
      36057: 46.85,
      36093: 22.84,
      36095: 30.31,
    },
    county_names_all: "Montgomery|Schoharie|Schenectady",
    county_fips_all: "36057|36095|36093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12067,
    lat: 42.56083,
    lng: -73.91663,
    city: "Feura Bush",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1554,
    density: 30.7,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12068,
    lat: 42.95701,
    lng: -74.40467,
    city: "Fonda",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3029,
    density: 39.9,
    county_fips: 36057,
    county_name: "Montgomery",
    county_weights: {
      36035: 4.84,
      36057: 95.16,
    },
    county_names_all: "Montgomery|Fulton",
    county_fips_all: "36057|36035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12069,
    lat: 42.94336,
    lng: -74.28193,
    city: "Fort Hunter",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 294,
    density: 304.6,
    county_fips: 36057,
    county_name: "Montgomery",
    county_weights: {
      36057: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 36057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12070,
    lat: 42.98513,
    lng: -74.25441,
    city: "Fort Johnson",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1974,
    density: 60.6,
    county_fips: 36057,
    county_name: "Montgomery",
    county_weights: {
      36035: 49.2,
      36057: 50.8,
    },
    county_names_all: "Montgomery|Fulton",
    county_fips_all: "36057|36035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12071,
    lat: 42.56971,
    lng: -74.41521,
    city: "Fultonham",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 319,
    density: 8.9,
    county_fips: 36095,
    county_name: "Schoharie",
    county_weights: {
      36095: 100,
    },
    county_names_all: "Schoharie",
    county_fips_all: 36095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12072,
    lat: 42.88102,
    lng: -74.36164,
    city: "Fultonville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3065,
    density: 22.7,
    county_fips: 36057,
    county_name: "Montgomery",
    county_weights: {
      36057: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 36057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12074,
    lat: 43.05219,
    lng: -74.04709,
    city: "Galway",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2957,
    density: 33.3,
    county_fips: 36091,
    county_name: "Saratoga",
    county_weights: {
      36091: 100,
    },
    county_names_all: "Saratoga",
    county_fips_all: 36091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12075,
    lat: 42.30145,
    lng: -73.64046,
    city: "Ghent",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2530,
    density: 26.9,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 36021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12076,
    lat: 42.40868,
    lng: -74.38506,
    city: "Gilboa",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1188,
    density: 6.7,
    county_fips: 36095,
    county_name: "Schoharie",
    county_weights: {
      36095: 100,
    },
    county_names_all: "Schoharie",
    county_fips_all: 36095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12077,
    lat: 42.59426,
    lng: -73.7841,
    city: "Glenmont",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6488,
    density: 247.6,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12078,
    lat: 43.12338,
    lng: -74.36255,
    city: "Gloversville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22956,
    density: 80,
    county_fips: 36035,
    county_name: "Fulton",
    county_weights: {
      36035: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 36035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12082,
    lat: 42.76998,
    lng: -73.44672,
    city: "Grafton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36083,
    county_name: "Rensselaer",
    county_weights: {
      36083: 100,
    },
    county_names_all: "Rensselaer",
    county_fips_all: 36083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12083,
    lat: 42.43151,
    lng: -74.03155,
    city: "Greenville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3830,
    density: 33.8,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36001: 48.12,
      36039: 51.88,
    },
    county_names_all: "Greene|Albany",
    county_fips_all: "36039|36001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12084,
    lat: 42.70411,
    lng: -73.90182,
    city: "Guilderland",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4806,
    density: 487,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12085,
    lat: 42.70043,
    lng: -73.96659,
    city: "Guilderland Center",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 430,
    density: 248,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12086,
    lat: 42.99684,
    lng: -74.10508,
    city: "Hagaman",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1379,
    density: 87.2,
    county_fips: 36091,
    county_name: "Saratoga",
    county_weights: {
      36035: 17.09,
      36057: 25.39,
      36091: 57.52,
    },
    county_names_all: "Saratoga|Montgomery|Fulton",
    county_fips_all: "36091|36057|36035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12087,
    lat: 42.42794,
    lng: -73.8931,
    city: "Hannacroix",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1069,
    density: 20.6,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36001: 8.04,
      36039: 91.96,
    },
    county_names_all: "Greene|Albany",
    county_fips_all: "36039|36001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12090,
    lat: 42.88073,
    lng: -73.35624,
    city: "Hoosick Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5931,
    density: 39.6,
    county_fips: 36083,
    county_name: "Rensselaer",
    county_weights: {
      36083: 100,
    },
    county_names_all: "Rensselaer",
    county_fips_all: 36083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12092,
    lat: 42.70396,
    lng: -74.38456,
    city: "Howes Cave",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1008,
    density: 25.2,
    county_fips: 36095,
    county_name: "Schoharie",
    county_weights: {
      36095: 100,
    },
    county_names_all: "Schoharie",
    county_fips_all: 36095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12093,
    lat: 42.49599,
    lng: -74.6262,
    city: "Jefferson",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1602,
    density: 9.5,
    county_fips: 36095,
    county_name: "Schoharie",
    county_weights: {
      36025: 26.05,
      36095: 73.95,
    },
    county_names_all: "Schoharie|Delaware",
    county_fips_all: "36095|36025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12094,
    lat: 42.89091,
    lng: -73.48737,
    city: "Johnsonville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2260,
    density: 27.5,
    county_fips: 36083,
    county_name: "Rensselaer",
    county_weights: {
      36083: 85.42,
      36115: 14.58,
    },
    county_names_all: "Rensselaer|Washington",
    county_fips_all: "36083|36115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12095,
    lat: 43.03151,
    lng: -74.41553,
    city: "Johnstown",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11986,
    density: 71,
    county_fips: 36035,
    county_name: "Fulton",
    county_weights: {
      36035: 91.64,
      36057: 8.36,
    },
    county_names_all: "Fulton|Montgomery",
    county_fips_all: "36035|36057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12106,
    lat: 42.38871,
    lng: -73.71228,
    city: "Kinderhook",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2299,
    density: 62,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 36021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12108,
    lat: 43.47045,
    lng: -74.42768,
    city: "Lake Pleasant",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 354,
    density: 1.9,
    county_fips: 36041,
    county_name: "Hamilton",
    county_weights: {
      36041: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 36041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12110,
    lat: 42.75349,
    lng: -73.77671,
    city: "Latham",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21223,
    density: 571.2,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12115,
    lat: 42.46747,
    lng: -73.59338,
    city: "Malden Bridge",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59,
    density: 6.3,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 36021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12116,
    lat: 42.53849,
    lng: -74.91278,
    city: "Maryland",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1506,
    density: 14.5,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36077: 100,
    },
    county_names_all: "Otsego",
    county_fips_all: 36077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12117,
    lat: 43.16894,
    lng: -74.25557,
    city: "Mayfield",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3163,
    density: 27.8,
    county_fips: 36035,
    county_name: "Fulton",
    county_weights: {
      36035: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 36035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12118,
    lat: 42.92096,
    lng: -73.72049,
    city: "Mechanicville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16467,
    density: 180,
    county_fips: 36091,
    county_name: "Saratoga",
    county_weights: {
      36083: 3.4,
      36091: 96.6,
    },
    county_names_all: "Saratoga|Rensselaer",
    county_fips_all: "36091|36083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12120,
    lat: 42.45781,
    lng: -74.1409,
    city: "Medusa",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 733,
    density: 19.2,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 94.6,
      36039: 5.4,
    },
    county_names_all: "Albany|Greene",
    county_fips_all: "36001|36039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12121,
    lat: 42.84368,
    lng: -73.60398,
    city: "Melrose",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2110,
    density: 42.2,
    county_fips: 36083,
    county_name: "Rensselaer",
    county_weights: {
      36083: 100,
    },
    county_names_all: "Rensselaer",
    county_fips_all: 36083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12122,
    lat: 42.54341,
    lng: -74.31138,
    city: "Middleburgh",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4137,
    density: 15.6,
    county_fips: 36095,
    county_name: "Schoharie",
    county_weights: {
      36001: 8.53,
      36095: 91.47,
    },
    county_names_all: "Schoharie|Albany",
    county_fips_all: "36095|36001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12123,
    lat: 42.52239,
    lng: -73.60636,
    city: "Nassau",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5120,
    density: 62.2,
    county_fips: 36083,
    county_name: "Rensselaer",
    county_weights: {
      36021: 2.04,
      36083: 97.96,
    },
    county_names_all: "Rensselaer|Columbia",
    county_fips_all: "36083|36021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12124,
    lat: 42.44652,
    lng: -73.78494,
    city: "New Baltimore",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 545,
    density: 135.1,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12125,
    lat: 42.47633,
    lng: -73.40394,
    city: "New Lebanon",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1084,
    density: 26.2,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 36021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12130,
    lat: 42.44156,
    lng: -73.65835,
    city: "Niverville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 892,
    density: 631.5,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 36021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12131,
    lat: 42.46573,
    lng: -74.46249,
    city: "North Blenheim",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 98,
    density: 3.3,
    county_fips: 36095,
    county_name: "Schoharie",
    county_weights: {
      36095: 100,
    },
    county_names_all: "Schoharie",
    county_fips_all: 36095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12132,
    lat: 42.47102,
    lng: -73.63362,
    city: "North Chatham",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 352,
    density: 270.4,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 36021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12134,
    lat: 43.26533,
    lng: -74.23059,
    city: "Northville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4232,
    density: 8.6,
    county_fips: 36041,
    county_name: "Hamilton",
    county_weights: {
      36035: 8.06,
      36041: 64.11,
      36091: 27.83,
    },
    county_names_all: "Hamilton|Saratoga|Fulton",
    county_fips_all: "36041|36091|36035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12136,
    lat: 42.43249,
    lng: -73.56016,
    city: "Old Chatham",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 658,
    density: 12.4,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 36021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12137,
    lat: 42.85727,
    lng: -74.12922,
    city: "Pattersonville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1993,
    density: 33,
    county_fips: 36093,
    county_name: "Schenectady",
    county_weights: {
      36057: 17.93,
      36093: 82.07,
    },
    county_names_all: "Schenectady|Montgomery",
    county_fips_all: "36093|36057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12138,
    lat: 42.73735,
    lng: -73.37128,
    city: "Petersburg",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3156,
    density: 13.6,
    county_fips: 36083,
    county_name: "Rensselaer",
    county_weights: {
      36083: 100,
    },
    county_names_all: "Rensselaer",
    county_fips_all: 36083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12139,
    lat: 43.52096,
    lng: -74.56552,
    city: "Piseco",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 142,
    density: 0.3,
    county_fips: 36041,
    county_name: "Hamilton",
    county_weights: {
      36041: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 36041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12140,
    lat: 42.689,
    lng: -73.56689,
    city: "Poestenkill",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1681,
    density: 90.7,
    county_fips: 36083,
    county_name: "Rensselaer",
    county_weights: {
      36083: 100,
    },
    county_names_all: "Rensselaer",
    county_fips_all: 36083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12143,
    lat: 42.48525,
    lng: -73.85218,
    city: "Ravena",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5032,
    density: 101.8,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 88.42,
      36039: 11.58,
    },
    county_names_all: "Albany|Greene",
    county_fips_all: "36001|36039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12144,
    lat: 42.63106,
    lng: -73.71801,
    city: "Rensselaer",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20604,
    density: 434.3,
    county_fips: 36083,
    county_name: "Rensselaer",
    county_weights: {
      36083: 100,
    },
    county_names_all: "Rensselaer",
    county_fips_all: 36083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12147,
    lat: 42.51365,
    lng: -74.15147,
    city: "Rensselaerville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 495,
    density: 10,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12148,
    lat: 42.83361,
    lng: -73.84652,
    city: "Rexford",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4143,
    density: 102.4,
    county_fips: 36091,
    county_name: "Saratoga",
    county_weights: {
      36091: 100,
    },
    county_names_all: "Saratoga",
    county_fips_all: 36091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12149,
    lat: 42.62011,
    lng: -74.56692,
    city: "Richmondville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2358,
    density: 20.5,
    county_fips: 36095,
    county_name: "Schoharie",
    county_weights: {
      36077: 5.18,
      36095: 94.82,
    },
    county_names_all: "Schoharie|Otsego",
    county_fips_all: "36095|36077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12150,
    lat: 42.87613,
    lng: -74.04923,
    city: "Rotterdam Junction",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 849,
    density: 275.5,
    county_fips: 36093,
    county_name: "Schenectady",
    county_weights: {
      36093: 100,
    },
    county_names_all: "Schenectady",
    county_fips_all: 36093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12151,
    lat: 42.92553,
    lng: -73.78874,
    city: "Round Lake",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1302,
    density: 193,
    county_fips: 36091,
    county_name: "Saratoga",
    county_weights: {
      36091: 100,
    },
    county_names_all: "Saratoga",
    county_fips_all: 36091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12153,
    lat: 42.63606,
    lng: -73.46692,
    city: "Sand Lake",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 809,
    density: 18.4,
    county_fips: 36083,
    county_name: "Rensselaer",
    county_weights: {
      36083: 100,
    },
    county_names_all: "Rensselaer",
    county_fips_all: 36083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12154,
    lat: 42.93713,
    lng: -73.60124,
    city: "Schaghticoke",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3249,
    density: 29.4,
    county_fips: 36083,
    county_name: "Rensselaer",
    county_weights: {
      36083: 55.53,
      36115: 44.47,
    },
    county_names_all: "Rensselaer|Washington",
    county_fips_all: "36083|36115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12155,
    lat: 42.59229,
    lng: -74.82337,
    city: "Schenevus",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1979,
    density: 14.6,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36025: 7.2,
      36077: 92.8,
    },
    county_names_all: "Otsego|Delaware",
    county_fips_all: "36077|36025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12156,
    lat: 42.47764,
    lng: -73.74354,
    city: "Schodack Landing",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 752,
    density: 20,
    county_fips: 36083,
    county_name: "Rensselaer",
    county_weights: {
      36021: 27.52,
      36083: 72.48,
    },
    county_names_all: "Rensselaer|Columbia",
    county_fips_all: "36083|36021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12157,
    lat: 42.66742,
    lng: -74.29892,
    city: "Schoharie",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4597,
    density: 35.4,
    county_fips: 36095,
    county_name: "Schoharie",
    county_weights: {
      36001: 0.64,
      36093: 0.83,
      36095: 98.53,
    },
    county_names_all: "Schoharie|Schenectady|Albany",
    county_fips_all: "36095|36093|36001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12158,
    lat: 42.53927,
    lng: -73.81903,
    city: "Selkirk",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6550,
    density: 86.1,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12159,
    lat: 42.64328,
    lng: -73.88503,
    city: "Slingerlands",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7971,
    density: 203.7,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12160,
    lat: 42.76325,
    lng: -74.36619,
    city: "Sloansville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 841,
    density: 21,
    county_fips: 36095,
    county_name: "Schoharie",
    county_weights: {
      36057: 8.98,
      36095: 91.02,
    },
    county_names_all: "Schoharie|Montgomery",
    county_fips_all: "36095|36057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12161,
    lat: 42.53369,
    lng: -73.84606,
    city: "South Bethlehem",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 183,
    density: 716.1,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12164,
    lat: 43.62883,
    lng: -74.42717,
    city: "Speculator",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 402,
    density: 1.3,
    county_fips: 36041,
    county_name: "Hamilton",
    county_weights: {
      36041: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 36041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12165,
    lat: 42.31518,
    lng: -73.50756,
    city: "Spencertown",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 200,
    density: 45.7,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 36021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12166,
    lat: 42.83846,
    lng: -74.45644,
    city: "Sprakers",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1145,
    density: 10.1,
    county_fips: 36057,
    county_name: "Montgomery",
    county_weights: {
      36057: 97.86,
      36095: 2.14,
    },
    county_names_all: "Montgomery|Schoharie",
    county_fips_all: "36057|36095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12167,
    lat: 42.42101,
    lng: -74.59011,
    city: "Stamford",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2663,
    density: 19.2,
    county_fips: 36095,
    county_name: "Schoharie",
    county_weights: {
      36025: 45.65,
      36095: 54.35,
    },
    county_names_all: "Schoharie|Delaware",
    county_fips_all: "36095|36025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12168,
    lat: 42.5614,
    lng: -73.3751,
    city: "Stephentown",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1993,
    density: 25,
    county_fips: 36083,
    county_name: "Rensselaer",
    county_weights: {
      36083: 100,
    },
    county_names_all: "Rensselaer",
    county_fips_all: 36083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12169,
    lat: 42.58249,
    lng: -73.43559,
    city: "Stephentown",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 353,
    density: 11.8,
    county_fips: 36083,
    county_name: "Rensselaer",
    county_weights: {
      36083: 100,
    },
    county_names_all: "Rensselaer",
    county_fips_all: 36083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12170,
    lat: 42.99936,
    lng: -73.66234,
    city: "Stillwater",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5034,
    density: 61.6,
    county_fips: 36091,
    county_name: "Saratoga",
    county_weights: {
      36091: 100,
    },
    county_names_all: "Saratoga",
    county_fips_all: 36091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12172,
    lat: 42.28915,
    lng: -73.73895,
    city: "Stottville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 187,
    density: 135,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 36021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12173,
    lat: 42.39042,
    lng: -73.76196,
    city: "Stuyvesant",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2139,
    density: 50.6,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 36021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12174,
    lat: 42.35314,
    lng: -73.72802,
    city: "Stuyvesant Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 526,
    density: 185.3,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 36021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12175,
    lat: 42.55489,
    lng: -74.56161,
    city: "Summit",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 639,
    density: 9.2,
    county_fips: 36095,
    county_name: "Schoharie",
    county_weights: {
      36095: 100,
    },
    county_names_all: "Schoharie",
    county_fips_all: 36095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12176,
    lat: 42.38839,
    lng: -73.96787,
    city: "Surprise",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 373,
    density: 27.9,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12177,
    lat: 42.95184,
    lng: -74.28459,
    city: "Tribes Hill",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 547,
    density: 439.8,
    county_fips: 36057,
    county_name: "Montgomery",
    county_weights: {
      36057: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 36057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12180,
    lat: 42.7516,
    lng: -73.59997,
    city: "Troy",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53181,
    density: 365.2,
    county_fips: 36083,
    county_name: "Rensselaer",
    county_weights: {
      36083: 100,
    },
    county_names_all: "Rensselaer",
    county_fips_all: 36083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12182,
    lat: 42.80044,
    lng: -73.63519,
    city: "Troy",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13886,
    density: 392.6,
    county_fips: 36083,
    county_name: "Rensselaer",
    county_weights: {
      36083: 100,
    },
    county_names_all: "Rensselaer",
    county_fips_all: 36083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12183,
    lat: 42.74742,
    lng: -73.69259,
    city: "Troy",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2647,
    density: 1363.6,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12184,
    lat: 42.42272,
    lng: -73.65387,
    city: "Valatie",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6762,
    density: 66.3,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 98.36,
      36083: 1.64,
    },
    county_names_all: "Columbia|Rensselaer",
    county_fips_all: "36021|36083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12185,
    lat: 42.90102,
    lng: -73.53507,
    city: "Valley Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2007,
    density: 34,
    county_fips: 36083,
    county_name: "Rensselaer",
    county_weights: {
      36083: 75.86,
      36115: 24.14,
    },
    county_names_all: "Rensselaer|Washington",
    county_fips_all: "36083|36115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12186,
    lat: 42.62502,
    lng: -73.9737,
    city: "Voorheesville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6190,
    density: 72.2,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12187,
    lat: 42.62632,
    lng: -74.46537,
    city: "Warnerville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 519,
    density: 10.3,
    county_fips: 36095,
    county_name: "Schoharie",
    county_weights: {
      36095: 100,
    },
    county_names_all: "Schoharie",
    county_fips_all: 36095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12188,
    lat: 42.8199,
    lng: -73.69589,
    city: "Waterford",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11774,
    density: 349.8,
    county_fips: 36091,
    county_name: "Saratoga",
    county_weights: {
      36091: 100,
    },
    county_names_all: "Saratoga",
    county_fips_all: 36091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12189,
    lat: 42.73618,
    lng: -73.71688,
    city: "Watervliet",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17945,
    density: 1114,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12190,
    lat: 43.47359,
    lng: -74.2733,
    city: "Wells",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 687,
    density: 1.5,
    county_fips: 36041,
    county_name: "Hamilton",
    county_weights: {
      36041: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 36041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12192,
    lat: 42.40428,
    lng: -73.82136,
    city: "West Coxsackie",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1778,
    density: 42.5,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12193,
    lat: 42.51713,
    lng: -74.04327,
    city: "Westerlo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1888,
    density: 19.2,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12194,
    lat: 42.53839,
    lng: -74.45431,
    city: "West Fulton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 122,
    density: 2.9,
    county_fips: 36095,
    county_name: "Schoharie",
    county_weights: {
      36095: 100,
    },
    county_names_all: "Schoharie",
    county_fips_all: 36095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12195,
    lat: 42.47876,
    lng: -73.46505,
    city: "West Lebanon",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 245,
    density: 120.7,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 36021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12196,
    lat: 42.63149,
    lng: -73.61708,
    city: "West Sand Lake",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4072,
    density: 175.6,
    county_fips: 36083,
    county_name: "Rensselaer",
    county_weights: {
      36083: 100,
    },
    county_names_all: "Rensselaer",
    county_fips_all: 36083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12197,
    lat: 42.6094,
    lng: -74.72587,
    city: "Worcester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2139,
    density: 12.7,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36077: 100,
    },
    county_names_all: "Otsego",
    county_fips_all: 36077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12198,
    lat: 42.67819,
    lng: -73.63285,
    city: "Wynantskill",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7119,
    density: 207.5,
    county_fips: 36083,
    county_name: "Rensselaer",
    county_weights: {
      36083: 100,
    },
    county_names_all: "Rensselaer",
    county_fips_all: 36083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12202,
    lat: 42.63355,
    lng: -73.763,
    city: "Albany",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7753,
    density: 1491.8,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12203,
    lat: 42.68138,
    lng: -73.85099,
    city: "Albany",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30837,
    density: 1141.2,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12204,
    lat: 42.68723,
    lng: -73.72869,
    city: "Albany",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7497,
    density: 699.5,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12205,
    lat: 42.71719,
    lng: -73.83006,
    city: "Albany",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26039,
    density: 654.2,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12206,
    lat: 42.67415,
    lng: -73.78196,
    city: "Albany",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15537,
    density: 2894.2,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12207,
    lat: 42.65657,
    lng: -73.74749,
    city: "Albany",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2264,
    density: 886.7,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12208,
    lat: 42.65293,
    lng: -73.80835,
    city: "Albany",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20517,
    density: 1799,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12209,
    lat: 42.6382,
    lng: -73.78976,
    city: "Albany",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10237,
    density: 1785.2,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12210,
    lat: 42.66399,
    lng: -73.75985,
    city: "Albany",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11057,
    density: 3772.6,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12211,
    lat: 42.7083,
    lng: -73.76393,
    city: "Albany",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11227,
    density: 534.1,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12222,
    lat: 42.68637,
    lng: -73.82656,
    city: "Albany",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6151,
    density: 3543.2,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12226,
    lat: 42.67931,
    lng: -73.80987,
    city: "Albany",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 36001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12302,
    lat: 42.88188,
    lng: -73.98323,
    city: "Schenectady",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27665,
    density: 246.5,
    county_fips: 36093,
    county_name: "Schenectady",
    county_weights: {
      36091: 8.74,
      36093: 91.26,
    },
    county_names_all: "Schenectady|Saratoga",
    county_fips_all: "36093|36091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12303,
    lat: 42.74938,
    lng: -73.92562,
    city: "Schenectady",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29416,
    density: 729.5,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 71.05,
      36093: 28.95,
    },
    county_names_all: "Albany|Schenectady",
    county_fips_all: "36001|36093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12304,
    lat: 42.77375,
    lng: -73.89742,
    city: "Schenectady",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20929,
    density: 1212.5,
    county_fips: 36093,
    county_name: "Schenectady",
    county_weights: {
      36001: 33.78,
      36093: 66.22,
    },
    county_names_all: "Schenectady|Albany",
    county_fips_all: "36093|36001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12305,
    lat: 42.81219,
    lng: -73.95036,
    city: "Schenectady",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6246,
    density: 1609.2,
    county_fips: 36093,
    county_name: "Schenectady",
    county_weights: {
      36093: 100,
    },
    county_names_all: "Schenectady",
    county_fips_all: 36093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12306,
    lat: 42.80686,
    lng: -74.03344,
    city: "Schenectady",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26934,
    density: 236.9,
    county_fips: 36093,
    county_name: "Schenectady",
    county_weights: {
      36001: 4.28,
      36093: 95.72,
    },
    county_names_all: "Schenectady|Albany",
    county_fips_all: "36093|36001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12307,
    lat: 42.80507,
    lng: -73.93341,
    city: "Schenectady",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7219,
    density: 3908.9,
    county_fips: 36093,
    county_name: "Schenectady",
    county_weights: {
      36093: 100,
    },
    county_names_all: "Schenectady",
    county_fips_all: 36093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12308,
    lat: 42.82152,
    lng: -73.92006,
    city: "Schenectady",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14038,
    density: 2372.8,
    county_fips: 36093,
    county_name: "Schenectady",
    county_weights: {
      36093: 100,
    },
    county_names_all: "Schenectady",
    county_fips_all: 36093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12309,
    lat: 42.79693,
    lng: -73.86785,
    city: "Schenectady",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30992,
    density: 681.2,
    county_fips: 36093,
    county_name: "Schenectady",
    county_weights: {
      36001: 17.66,
      36093: 82.34,
    },
    county_names_all: "Schenectady|Albany",
    county_fips_all: "36093|36001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12401,
    lat: 41.93504,
    lng: -74.05446,
    city: "Kingston",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34800,
    density: 228.1,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12404,
    lat: 41.81602,
    lng: -74.23632,
    city: "Accord",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3679,
    density: 38.4,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12405,
    lat: 42.31585,
    lng: -74.0989,
    city: "Acra",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 579,
    density: 20.6,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12406,
    lat: 42.09647,
    lng: -74.56502,
    city: "Arkville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 695,
    density: 5.5,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36025: 30.84,
      36111: 69.16,
    },
    county_names_all: "Ulster|Delaware",
    county_fips_all: "36111|36025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12407,
    lat: 42.30075,
    lng: -74.35343,
    city: "Ashland",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 129,
    density: 57,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12409,
    lat: 42.05662,
    lng: -74.16655,
    city: "Bearsville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 723,
    density: 15.8,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12410,
    lat: 42.0706,
    lng: -74.45212,
    city: "Big Indian",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 366,
    density: 2.8,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12411,
    lat: 41.87975,
    lng: -74.04094,
    city: "Bloomington",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 349,
    density: 201.5,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12412,
    lat: 42.01218,
    lng: -74.27698,
    city: "Boiceville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 460,
    density: 26.9,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12413,
    lat: 42.31338,
    lng: -74.02628,
    city: "Cairo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3290,
    density: 76.3,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12414,
    lat: 42.2211,
    lng: -73.92356,
    city: "Catskill",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9726,
    density: 60.4,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12416,
    lat: 42.09554,
    lng: -74.28592,
    city: "Chichester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 439,
    density: 31.8,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12417,
    lat: 41.9073,
    lng: -73.98943,
    city: "Connelly",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 559,
    density: 618.9,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12418,
    lat: 42.35863,
    lng: -74.1609,
    city: "Cornwallville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 313,
    density: 8.7,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12419,
    lat: 41.85948,
    lng: -74.10265,
    city: "Cottekill",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 495,
    density: 79.5,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12420,
    lat: 41.6743,
    lng: -74.37769,
    city: "Cragsmoor",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 436,
    density: 63.2,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12421,
    lat: 42.2512,
    lng: -74.5336,
    city: "Denver",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 207,
    density: 4.6,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 36025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12422,
    lat: 42.39205,
    lng: -74.20232,
    city: "Durham",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 272,
    density: 10.5,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12423,
    lat: 42.37968,
    lng: -74.11136,
    city: "East Durham",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1320,
    density: 47.6,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12424,
    lat: 42.24689,
    lng: -74.14358,
    city: "East Jewett",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 185,
    density: 3.5,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12427,
    lat: 42.14771,
    lng: -74.11921,
    city: "Elka Park",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 962,
    density: 9.6,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12428,
    lat: 41.73817,
    lng: -74.44615,
    city: "Ellenville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6535,
    density: 45.8,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12429,
    lat: 41.83323,
    lng: -73.961,
    city: "Esopus",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 314,
    density: 173.5,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12430,
    lat: 42.20306,
    lng: -74.49933,
    city: "Fleischmanns",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1570,
    density: 15.1,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36025: 41.43,
      36039: 58.57,
    },
    county_names_all: "Greene|Delaware",
    county_fips_all: "36039|36025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12431,
    lat: 42.35877,
    lng: -74.01843,
    city: "Freehold",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1125,
    density: 24.8,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12432,
    lat: 42.04702,
    lng: -73.94403,
    city: "Glasco",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 514,
    density: 425.7,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12433,
    lat: 42.00533,
    lng: -74.15526,
    city: "Glenford",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 483,
    density: 53.6,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12434,
    lat: 42.36491,
    lng: -74.50793,
    city: "Grand Gorge",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 813,
    density: 28.9,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 36025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12435,
    lat: 41.72715,
    lng: -74.51148,
    city: "Greenfield Park",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 144,
    density: 7,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12436,
    lat: 42.20447,
    lng: -74.0746,
    city: "Haines Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 182,
    density: 6.3,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12438,
    lat: 42.21251,
    lng: -74.59667,
    city: "Halcottsville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 36025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12439,
    lat: 42.29674,
    lng: -74.18789,
    city: "Hensonville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 380,
    density: 14.5,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12440,
    lat: 41.78665,
    lng: -74.16338,
    city: "High Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1449,
    density: 27.9,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12441,
    lat: 42.1502,
    lng: -74.50625,
    city: "Highmount",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 125,
    density: 16.1,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 70.95,
      36111: 29.05,
    },
    county_names_all: "Delaware|Ulster",
    county_fips_all: "36025|36111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12442,
    lat: 42.22275,
    lng: -74.23545,
    city: "Hunter",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 901,
    density: 18.5,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12443,
    lat: 41.93388,
    lng: -74.08536,
    city: "Hurley",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3721,
    density: 87,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12444,
    lat: 42.24942,
    lng: -74.28993,
    city: "Jewett",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 555,
    density: 10.9,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12446,
    lat: 41.79063,
    lng: -74.31655,
    city: "Kerhonkson",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4683,
    density: 26.8,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12448,
    lat: 42.07955,
    lng: -74.20067,
    city: "Lake Hill",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 387,
    density: 17.4,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12449,
    lat: 41.99377,
    lng: -73.99338,
    city: "Lake Katrine",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3208,
    density: 332.9,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12450,
    lat: 42.13804,
    lng: -74.22176,
    city: "Lanesville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 139,
    density: 2.5,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12451,
    lat: 42.30337,
    lng: -73.94802,
    city: "Leeds",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1425,
    density: 49.4,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12452,
    lat: 42.23891,
    lng: -74.34986,
    city: "Lexington",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 253,
    density: 296.4,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12453,
    lat: 42.0929,
    lng: -73.93629,
    city: "Malden On Hudson",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 345,
    density: 312.4,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12454,
    lat: 42.2869,
    lng: -74.15038,
    city: "Maplecrest",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 380,
    density: 13.4,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12455,
    lat: 42.14871,
    lng: -74.66334,
    city: "Margaretville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1553,
    density: 8.4,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 94.64,
      36111: 5.36,
    },
    county_names_all: "Delaware|Ulster",
    county_fips_all: "36025|36111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12456,
    lat: 42.03308,
    lng: -73.99703,
    city: "Mount Marion",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 968,
    density: 691.6,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12457,
    lat: 42.03997,
    lng: -74.24659,
    city: "Mount Tremper",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 911,
    density: 30.7,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12458,
    lat: 41.82273,
    lng: -74.41666,
    city: "Napanoch",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3223,
    density: 31.5,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36105: 6.34,
      36111: 93.66,
    },
    county_names_all: "Ulster|Sullivan",
    county_fips_all: "36111|36105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12459,
    lat: 42.23976,
    lng: -74.6805,
    city: "New Kingston",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 174,
    density: 10.7,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 36025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12460,
    lat: 42.42357,
    lng: -74.16676,
    city: "Oak Hill",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 340,
    density: 21.9,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 64.49,
      36039: 35.51,
    },
    county_names_all: "Albany|Greene",
    county_fips_all: "36001|36039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12461,
    lat: 41.90531,
    lng: -74.25246,
    city: "Olivebridge",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1343,
    density: 28.1,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12463,
    lat: 42.1895,
    lng: -74.01573,
    city: "Palenville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1700,
    density: 88.1,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 99.88,
      36111: 0.12,
    },
    county_names_all: "Greene|Ulster",
    county_fips_all: "36039|36111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12464,
    lat: 42.04071,
    lng: -74.34452,
    city: "Phoenicia",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 958,
    density: 8.2,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12465,
    lat: 42.15278,
    lng: -74.46725,
    city: "Pine Hill",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 301,
    density: 40,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36025: 22.26,
      36111: 77.74,
    },
    county_names_all: "Ulster|Delaware",
    county_fips_all: "36111|36025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12466,
    lat: 41.90671,
    lng: -73.97826,
    city: "Port Ewen",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2110,
    density: 791.1,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12468,
    lat: 42.29998,
    lng: -74.41375,
    city: "Prattsville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 955,
    density: 6.3,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36025: 16.25,
      36039: 83.75,
    },
    county_names_all: "Greene|Delaware",
    county_fips_all: "36039|36025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12469,
    lat: 42.44521,
    lng: -74.2421,
    city: "Preston Hollow",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 642,
    density: 7.5,
    county_fips: 36001,
    county_name: "Albany",
    county_weights: {
      36001: 59.7,
      36039: 4.92,
      36095: 35.38,
    },
    county_names_all: "Albany|Schoharie|Greene",
    county_fips_all: "36001|36095|36039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12470,
    lat: 42.26932,
    lng: -74.05515,
    city: "Purling",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 564,
    density: 18.2,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12471,
    lat: 41.83799,
    lng: -74.04195,
    city: "Rifton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 384,
    density: 486.1,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12472,
    lat: 41.84732,
    lng: -74.07447,
    city: "Rosendale",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1482,
    density: 171.6,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12473,
    lat: 42.26157,
    lng: -74.02827,
    city: "Round Top",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 573,
    density: 25.2,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12474,
    lat: 42.29378,
    lng: -74.58117,
    city: "Roxbury",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 934,
    density: 7.6,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 36025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12475,
    lat: 42.01397,
    lng: -74.01332,
    city: "Ruby",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 373,
    density: 123.3,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12477,
    lat: 42.08528,
    lng: -74.00028,
    city: "Saugerties",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17870,
    density: 103.4,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12480,
    lat: 42.13803,
    lng: -74.37683,
    city: "Shandaken",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 407,
    density: 5,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 52.6,
      36111: 47.4,
    },
    county_names_all: "Greene|Ulster",
    county_fips_all: "36039|36111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12481,
    lat: 41.97519,
    lng: -74.22718,
    city: "Shokan",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1732,
    density: 52.4,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12482,
    lat: 42.26841,
    lng: -73.95587,
    city: "South Cairo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 612,
    density: 101.8,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12483,
    lat: 41.66796,
    lng: -74.44184,
    city: "Spring Glen",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 205,
    density: 64.4,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 75.54,
      36111: 24.46,
    },
    county_names_all: "Sullivan|Ulster",
    county_fips_all: "36105|36111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12484,
    lat: 41.87024,
    lng: -74.17338,
    city: "Stone Ridge",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3318,
    density: 54,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12485,
    lat: 42.20507,
    lng: -74.15288,
    city: "Tannersville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 650,
    density: 27,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12486,
    lat: 41.83438,
    lng: -74.06235,
    city: "Tillson",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1874,
    density: 223.3,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12487,
    lat: 41.86095,
    lng: -73.99555,
    city: "Ulster Park",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3370,
    density: 79.7,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12489,
    lat: 41.75597,
    lng: -74.35462,
    city: "Wawarsing",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1055,
    density: 113.8,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12490,
    lat: 42.12355,
    lng: -73.9251,
    city: "West Camp",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39,
    density: 29.3,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12491,
    lat: 41.96957,
    lng: -74.13311,
    city: "West Hurley",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1660,
    density: 64.7,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12492,
    lat: 42.18758,
    lng: -74.33453,
    city: "West Kill",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 90,
    density: 0.8,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12493,
    lat: 41.79316,
    lng: -73.97283,
    city: "West Park",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 163,
    density: 12.2,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12494,
    lat: 41.94857,
    lng: -74.30169,
    city: "West Shokan",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 762,
    density: 12.3,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12495,
    lat: 42.08264,
    lng: -74.24563,
    city: "Willow",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 85,
    density: 4.3,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12496,
    lat: 42.32669,
    lng: -74.27256,
    city: "Windham",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1516,
    density: 13.5,
    county_fips: 36039,
    county_name: "Greene",
    county_weights: {
      36039: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 36039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12498,
    lat: 42.04772,
    lng: -74.11007,
    city: "Woodstock",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4713,
    density: 82.1,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12501,
    lat: 41.85664,
    lng: -73.55953,
    city: "Amenia",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2158,
    density: 25.7,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 100,
    },
    county_names_all: "Dutchess",
    county_fips_all: 36027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12502,
    lat: 42.08324,
    lng: -73.65409,
    city: "Ancram",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1224,
    density: 14.8,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 36021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12503,
    lat: 42.03615,
    lng: -73.58139,
    city: "Ancramdale",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 617,
    density: 10.7,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 36021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12504,
    lat: 42.02342,
    lng: -73.9094,
    city: "Annandale On Hudson",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1490,
    density: 772.6,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 100,
    },
    county_names_all: "Dutchess",
    county_fips_all: 36027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12507,
    lat: 42.00735,
    lng: -73.92126,
    city: "Barrytown",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 210,
    density: 54.9,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 100,
    },
    county_names_all: "Dutchess",
    county_fips_all: 36027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12508,
    lat: 41.49637,
    lng: -73.95351,
    city: "Beacon",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19812,
    density: 530.2,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 100,
    },
    county_names_all: "Dutchess",
    county_fips_all: 36027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12512,
    lat: 41.5542,
    lng: -73.96471,
    city: "Chelsea",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 244,
    density: 354.5,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 100,
    },
    county_names_all: "Dutchess",
    county_fips_all: 36027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12513,
    lat: 42.21661,
    lng: -73.71639,
    city: "Claverack",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 431,
    density: 57.2,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 36021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12514,
    lat: 41.87137,
    lng: -73.76274,
    city: "Clinton Corners",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2772,
    density: 39.2,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 100,
    },
    county_names_all: "Dutchess",
    county_fips_all: 36027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12515,
    lat: 41.68008,
    lng: -74.06451,
    city: "Clintondale",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1657,
    density: 147.5,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12516,
    lat: 42.10722,
    lng: -73.55343,
    city: "Copake",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1882,
    density: 35.5,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 36021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12517,
    lat: 42.13392,
    lng: -73.51103,
    city: "Copake Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 391,
    density: 31.6,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 36021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12518,
    lat: 41.41847,
    lng: -74.03571,
    city: "Cornwall",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5861,
    density: 284.4,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12520,
    lat: 41.43362,
    lng: -74.00693,
    city: "Cornwall On Hudson",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2970,
    density: 277.3,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12521,
    lat: 42.17071,
    lng: -73.65164,
    city: "Craryville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1522,
    density: 18.3,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 36021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12522,
    lat: 41.72693,
    lng: -73.58893,
    city: "Dover Plains",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4918,
    density: 50.7,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 100,
    },
    county_names_all: "Dutchess",
    county_fips_all: 36027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12523,
    lat: 42.08627,
    lng: -73.75311,
    city: "Elizaville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1810,
    density: 31.3,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 36021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12524,
    lat: 41.53092,
    lng: -73.89245,
    city: "Fishkill",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15608,
    density: 359.6,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 100,
    },
    county_names_all: "Dutchess",
    county_fips_all: 36027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12525,
    lat: 41.68115,
    lng: -74.17751,
    city: "Gardiner",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2966,
    density: 48.5,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12526,
    lat: 42.12236,
    lng: -73.85938,
    city: "Germantown",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3530,
    density: 42.1,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 36021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12527,
    lat: 41.51931,
    lng: -73.93703,
    city: "Glenham",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 100,
    },
    county_names_all: "Dutchess",
    county_fips_all: 36027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12528,
    lat: 41.72273,
    lng: -74.00477,
    city: "Highland",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12767,
    density: 109.8,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12529,
    lat: 42.21335,
    lng: -73.53802,
    city: "Hillsdale",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1919,
    density: 10.9,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 36021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12530,
    lat: 42.20692,
    lng: -73.68413,
    city: "Hollowville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47,
    density: 102,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 36021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12531,
    lat: 41.53689,
    lng: -73.66917,
    city: "Holmes",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2645,
    density: 58.6,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 83.98,
      36079: 16.02,
    },
    county_names_all: "Dutchess|Putnam",
    county_fips_all: "36027|36079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12533,
    lat: 41.55925,
    lng: -73.79401,
    city: "Hopewell Junction",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26361,
    density: 208.3,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 92.1,
      36079: 7.9,
    },
    county_names_all: "Dutchess|Putnam",
    county_fips_all: "36027|36079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12534,
    lat: 42.22434,
    lng: -73.75427,
    city: "Hudson",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17814,
    density: 77.6,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 36021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12538,
    lat: 41.79246,
    lng: -73.89336,
    city: "Hyde Park",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14566,
    density: 220.7,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 100,
    },
    county_names_all: "Dutchess",
    county_fips_all: 36027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12540,
    lat: 41.67073,
    lng: -73.72524,
    city: "Lagrangeville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8882,
    density: 97.2,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 100,
    },
    county_names_all: "Dutchess",
    county_fips_all: 36027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12542,
    lat: 41.60772,
    lng: -73.99666,
    city: "Marlboro",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5684,
    density: 152.5,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36071: 8.97,
      36111: 91.03,
    },
    county_names_all: "Ulster|Orange",
    county_fips_all: "36111|36071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12543,
    lat: 41.48602,
    lng: -74.22354,
    city: "Maybrook",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3586,
    density: 903,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12544,
    lat: 42.26129,
    lng: -73.66822,
    city: "Mellenville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 36021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12545,
    lat: 41.7914,
    lng: -73.67251,
    city: "Millbrook",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4517,
    density: 30.8,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 100,
    },
    county_names_all: "Dutchess",
    county_fips_all: 36027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12546,
    lat: 41.96627,
    lng: -73.53313,
    city: "Millerton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2824,
    density: 24,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36021: 20.95,
      36027: 79.05,
    },
    county_names_all: "Dutchess|Columbia",
    county_fips_all: "36027|36021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12547,
    lat: 41.65463,
    lng: -73.98322,
    city: "Milton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2810,
    density: 117.4,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12548,
    lat: 41.66307,
    lng: -74.10157,
    city: "Modena",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1133,
    density: 112.4,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12549,
    lat: 41.52957,
    lng: -74.25843,
    city: "Montgomery",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11453,
    density: 114.1,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12550,
    lat: 41.53671,
    lng: -74.05196,
    city: "Newburgh",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54503,
    density: 606.8,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12553,
    lat: 41.46146,
    lng: -74.07311,
    city: "New Windsor",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26665,
    density: 426,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12561,
    lat: 41.75602,
    lng: -74.0958,
    city: "New Paltz",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18224,
    density: 116.8,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36111: 100,
    },
    county_names_all: "Ulster",
    county_fips_all: 36111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12563,
    lat: 41.49417,
    lng: -73.5891,
    city: "Patterson",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7579,
    density: 124.6,
    county_fips: 36079,
    county_name: "Putnam",
    county_weights: {
      36079: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 36079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12564,
    lat: 41.57827,
    lng: -73.5862,
    city: "Pawling",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7710,
    density: 72,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 100,
    },
    county_names_all: "Dutchess",
    county_fips_all: 36027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12565,
    lat: 42.24849,
    lng: -73.64584,
    city: "Philmont",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 997,
    density: 271.9,
    county_fips: 36021,
    county_name: "Columbia",
    county_weights: {
      36021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 36021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12566,
    lat: 41.62223,
    lng: -74.33256,
    city: "Pine Bush",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11886,
    density: 82.3,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36071: 33.4,
      36105: 10.08,
      36111: 56.52,
    },
    county_names_all: "Ulster|Orange|Sullivan",
    county_fips_all: "36111|36071|36105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12567,
    lat: 41.98206,
    lng: -73.65211,
    city: "Pine Plains",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2608,
    density: 21.9,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36021: 31.49,
      36027: 68.51,
    },
    county_names_all: "Dutchess|Columbia",
    county_fips_all: "36027|36021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12569,
    lat: 41.7346,
    lng: -73.79731,
    city: "Pleasant Valley",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9838,
    density: 114.1,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 100,
    },
    county_names_all: "Dutchess",
    county_fips_all: 36027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12570,
    lat: 41.62377,
    lng: -73.66983,
    city: "Poughquag",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6772,
    density: 131.7,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 100,
    },
    county_names_all: "Dutchess",
    county_fips_all: 36027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12571,
    lat: 42.00663,
    lng: -73.81152,
    city: "Red Hook",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10037,
    density: 66.7,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36021: 14.41,
      36027: 85.59,
    },
    county_names_all: "Dutchess|Columbia",
    county_fips_all: "36027|36021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12572,
    lat: 41.92548,
    lng: -73.8717,
    city: "Rhinebeck",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8961,
    density: 67.8,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 100,
    },
    county_names_all: "Dutchess",
    county_fips_all: 36027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12574,
    lat: 41.91764,
    lng: -73.94566,
    city: "Rhinecliff",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 502,
    density: 378.6,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 100,
    },
    county_names_all: "Dutchess",
    county_fips_all: 36027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12575,
    lat: 41.48514,
    lng: -74.15714,
    city: "Rock Tavern",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1930,
    density: 46.4,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12577,
    lat: 41.42048,
    lng: -74.11678,
    city: "Salisbury Mills",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1929,
    density: 96.5,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12578,
    lat: 41.80629,
    lng: -73.79673,
    city: "Salt Point",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2100,
    density: 56.2,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 100,
    },
    county_names_all: "Dutchess",
    county_fips_all: 36027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12580,
    lat: 41.85348,
    lng: -73.87302,
    city: "Staatsburg",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4359,
    density: 75.9,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 100,
    },
    county_names_all: "Dutchess",
    county_fips_all: 36027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12581,
    lat: 41.90625,
    lng: -73.69374,
    city: "Stanfordville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2231,
    density: 22.1,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 100,
    },
    county_names_all: "Dutchess",
    county_fips_all: 36027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12582,
    lat: 41.54693,
    lng: -73.72919,
    city: "Stormville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6213,
    density: 169.5,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 98.19,
      36079: 1.81,
    },
    county_names_all: "Dutchess|Putnam",
    county_fips_all: "36027|36079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12583,
    lat: 42.05625,
    lng: -73.88014,
    city: "Tivoli",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2160,
    density: 71.5,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36021: 32.19,
      36027: 67.81,
    },
    county_names_all: "Dutchess|Columbia",
    county_fips_all: "36027|36021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12585,
    lat: 41.72396,
    lng: -73.7025,
    city: "Verbank",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 928,
    density: 76.6,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 100,
    },
    county_names_all: "Dutchess",
    county_fips_all: 36027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12586,
    lat: 41.5657,
    lng: -74.17289,
    city: "Walden",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11774,
    density: 191.4,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12589,
    lat: 41.6278,
    lng: -74.15875,
    city: "Wallkill",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17843,
    density: 115.7,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36071: 15.32,
      36111: 84.68,
    },
    county_names_all: "Ulster|Orange",
    county_fips_all: "36111|36071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12590,
    lat: 41.59559,
    lng: -73.88774,
    city: "Wappingers Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34823,
    density: 386.1,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 100,
    },
    county_names_all: "Dutchess",
    county_fips_all: 36027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12592,
    lat: 41.78601,
    lng: -73.5528,
    city: "Wassaic",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1671,
    density: 43.4,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 100,
    },
    county_names_all: "Dutchess",
    county_fips_all: 36027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12594,
    lat: 41.66049,
    lng: -73.56004,
    city: "Wingdale",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4150,
    density: 69.5,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 100,
    },
    county_names_all: "Dutchess",
    county_fips_all: 36027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12601,
    lat: 41.70602,
    lng: -73.91119,
    city: "Poughkeepsie",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41037,
    density: 867.1,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 100,
    },
    county_names_all: "Dutchess",
    county_fips_all: 36027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12603,
    lat: 41.67816,
    lng: -73.86744,
    city: "Poughkeepsie",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42140,
    density: 510.5,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 100,
    },
    county_names_all: "Dutchess",
    county_fips_all: 36027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12604,
    lat: 41.68844,
    lng: -73.89448,
    city: "Poughkeepsie",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 594,
    density: 1223.3,
    county_fips: 36027,
    county_name: "Dutchess",
    county_weights: {
      36027: 100,
    },
    county_names_all: "Dutchess",
    county_fips_all: 36027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12701,
    lat: 41.65125,
    lng: -74.6982,
    city: "Monticello",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11278,
    density: 71.3,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12719,
    lat: 41.48431,
    lng: -74.90543,
    city: "Barryville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1229,
    density: 28,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12720,
    lat: 41.65794,
    lng: -74.90029,
    city: "Bethel",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 109,
    density: 4.6,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12721,
    lat: 41.56741,
    lng: -74.42832,
    city: "Bloomingburg",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5881,
    density: 92,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36071: 30.73,
      36105: 69.27,
    },
    county_names_all: "Sullivan|Orange",
    county_fips_all: "36105|36071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12722,
    lat: 41.59042,
    lng: -74.3748,
    city: "Burlingham",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21,
    density: 26.3,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36071: 0.34,
      36105: 99.66,
    },
    county_names_all: "Sullivan|Orange",
    county_fips_all: "36105|36071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12723,
    lat: 41.77809,
    lng: -75.02751,
    city: "Callicoon",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1561,
    density: 18,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12724,
    lat: 41.85195,
    lng: -74.93535,
    city: "Callicoon Center",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 246,
    density: 18.3,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12725,
    lat: 41.95679,
    lng: -74.54794,
    city: "Claryville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 147,
    density: 0.8,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36105: 21.28,
      36111: 78.72,
    },
    county_names_all: "Ulster|Sullivan",
    county_fips_all: "36111|36105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12726,
    lat: 41.69269,
    lng: -74.96902,
    city: "Cochecton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1440,
    density: 16.8,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12729,
    lat: 41.49411,
    lng: -74.61582,
    city: "Cuddebackville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1650,
    density: 28.8,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 54.02,
      36105: 45.98,
    },
    county_names_all: "Orange|Sullivan",
    county_fips_all: "36071|36105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12732,
    lat: 41.56075,
    lng: -74.87353,
    city: "Eldred",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 753,
    density: 10.9,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12733,
    lat: 41.73378,
    lng: -74.6102,
    city: "Fallsburg",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1129,
    density: 117.5,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12734,
    lat: 41.7354,
    lng: -74.7531,
    city: "Ferndale",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 828,
    density: 22.7,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12736,
    lat: 41.85327,
    lng: -75.01917,
    city: "Fremont Center",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 90,
    density: 11.5,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12737,
    lat: 41.50529,
    lng: -74.79941,
    city: "Glen Spey",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1800,
    density: 19.8,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12738,
    lat: 41.66009,
    lng: -74.59119,
    city: "Glen Wild",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 322,
    density: 60.4,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12740,
    lat: 41.89499,
    lng: -74.46616,
    city: "Grahamsville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1927,
    density: 10.3,
    county_fips: 36111,
    county_name: "Ulster",
    county_weights: {
      36105: 37.44,
      36111: 62.56,
    },
    county_names_all: "Ulster|Sullivan",
    county_fips_all: "36111|36105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12741,
    lat: 41.84368,
    lng: -75.07816,
    city: "Hankins",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 175,
    density: 7.3,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12742,
    lat: 41.71796,
    lng: -74.72108,
    city: "Harris",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74,
    density: 12.6,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12743,
    lat: 41.54065,
    lng: -74.84687,
    city: "Highland Lake",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 391,
    density: 20.1,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12745,
    lat: 41.78503,
    lng: -75.02633,
    city: "Hortonville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 247,
    density: 79.3,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12746,
    lat: 41.44929,
    lng: -74.65582,
    city: "Huguenot",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 663,
    density: 12.5,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12747,
    lat: 41.76596,
    lng: -74.65934,
    city: "Hurleyville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2072,
    density: 46.7,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12748,
    lat: 41.77604,
    lng: -74.91845,
    city: "Jeffersonville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2042,
    density: 33.5,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12749,
    lat: 41.69149,
    lng: -74.82768,
    city: "Kauneonga Lake",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 393,
    density: 70,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12750,
    lat: 41.73595,
    lng: -74.96382,
    city: "Kenoza Lake",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 233,
    density: 28.7,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12751,
    lat: 41.69209,
    lng: -74.66119,
    city: "Kiamesha Lake",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1019,
    density: 151.6,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12752,
    lat: 41.68278,
    lng: -74.9905,
    city: "Lake Huntington",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 296,
    density: 74.1,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12754,
    lat: 41.80004,
    lng: -74.73643,
    city: "Liberty",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7142,
    density: 97.5,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12758,
    lat: 41.9428,
    lng: -74.74942,
    city: "Livingston Manor",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3699,
    density: 9.3,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36025: 0.85,
      36105: 71.34,
      36111: 27.81,
    },
    county_names_all: "Sullivan|Ulster|Delaware",
    county_fips_all: "36105|36111|36025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12759,
    lat: 41.78399,
    lng: -74.65758,
    city: "Loch Sheldrake",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2443,
    density: 239.2,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12760,
    lat: 41.90063,
    lng: -75.10559,
    city: "Long Eddy",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 478,
    density: 4.1,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 78.63,
      36105: 21.37,
    },
    county_names_all: "Delaware|Sullivan",
    county_fips_all: "36025|36105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12762,
    lat: 41.65582,
    lng: -74.79462,
    city: "Mongaup Valley",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 783,
    density: 32.8,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12763,
    lat: 41.68221,
    lng: -74.52205,
    city: "Mountain Dale",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 684,
    density: 18.7,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 96.65,
      36111: 3.35,
    },
    county_names_all: "Sullivan|Ulster",
    county_fips_all: "36105|36111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12764,
    lat: 41.59639,
    lng: -74.98515,
    city: "Narrowsburg",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1770,
    density: 11.3,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12765,
    lat: 41.85265,
    lng: -74.6281,
    city: "Neversink",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 937,
    density: 32.4,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12766,
    lat: 41.81408,
    lng: -74.97923,
    city: "North Branch",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 248,
    density: 10.2,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12767,
    lat: 41.83504,
    lng: -75.00284,
    city: "Obernburg",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 250,
    density: 47.3,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12768,
    lat: 41.87157,
    lng: -74.71507,
    city: "Parksville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 930,
    density: 10.8,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12769,
    lat: 41.65925,
    lng: -74.47071,
    city: "Phillipsport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 229,
    density: 21,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12770,
    lat: 41.44681,
    lng: -74.85028,
    city: "Pond Eddy",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 248,
    density: 27.3,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12771,
    lat: 41.37394,
    lng: -74.62429,
    city: "Port Jervis",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14408,
    density: 160.9,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 36071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12775,
    lat: 41.62266,
    lng: -74.58232,
    city: "Rock Hill",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2151,
    density: 61,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12776,
    lat: 41.96486,
    lng: -74.93197,
    city: "Roscoe",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2361,
    density: 7.9,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 61.69,
      36105: 38.31,
    },
    county_names_all: "Delaware|Sullivan",
    county_fips_all: "36025|36105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12777,
    lat: 41.55172,
    lng: -74.71067,
    city: "Forestburgh",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 863,
    density: 7.5,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12778,
    lat: 41.66174,
    lng: -74.8138,
    city: "Smallwood",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 500,
    density: 112.1,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12779,
    lat: 41.69804,
    lng: -74.62703,
    city: "South Fallsburg",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1701,
    density: 97.7,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12780,
    lat: 41.44514,
    lng: -74.71989,
    city: "Sparrow Bush",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2165,
    density: 33.9,
    county_fips: 36071,
    county_name: "Orange",
    county_weights: {
      36071: 93.28,
      36105: 6.72,
    },
    county_names_all: "Orange|Sullivan",
    county_fips_all: "36071|36105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12781,
    lat: 41.61448,
    lng: -74.47208,
    city: "Summitville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 242,
    density: 32.3,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12783,
    lat: 41.74026,
    lng: -74.83502,
    city: "Swan Lake",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1605,
    density: 19.5,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12784,
    lat: 41.66907,
    lng: -74.61485,
    city: "Thompsonville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36,
    density: 11.3,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12785,
    lat: 41.52429,
    lng: -74.58051,
    city: "Westbrookville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1390,
    density: 39.5,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36071: 22.13,
      36105: 77.87,
    },
    county_names_all: "Sullivan|Orange",
    county_fips_all: "36105|36071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12786,
    lat: 41.64306,
    lng: -74.85393,
    city: "White Lake",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 336,
    density: 7.6,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12787,
    lat: 41.7931,
    lng: -74.8365,
    city: "White Sulphur Springs",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 278,
    density: 42.3,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12788,
    lat: 41.79552,
    lng: -74.58846,
    city: "Woodbourne",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2909,
    density: 50.7,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12789,
    lat: 41.71374,
    lng: -74.57233,
    city: "Woodridge",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2009,
    density: 48.8,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 88.87,
      36111: 11.13,
    },
    county_names_all: "Sullivan|Ulster",
    county_fips_all: "36105|36111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12790,
    lat: 41.5863,
    lng: -74.51705,
    city: "Wurtsboro",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3933,
    density: 29.5,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12791,
    lat: 41.81126,
    lng: -74.88692,
    city: "Youngsville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 745,
    density: 79.5,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12792,
    lat: 41.51447,
    lng: -74.95172,
    city: "Yulan",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 106,
    density: 9.6,
    county_fips: 36105,
    county_name: "Sullivan",
    county_weights: {
      36105: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 36105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12801,
    lat: 43.31097,
    lng: -73.64545,
    city: "Glens Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14330,
    density: 1459.9,
    county_fips: 36113,
    county_name: "Warren",
    county_weights: {
      36113: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 36113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12803,
    lat: 43.28891,
    lng: -73.63024,
    city: "South Glens Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8317,
    density: 529.8,
    county_fips: 36091,
    county_name: "Saratoga",
    county_weights: {
      36091: 98,
      36113: 2,
    },
    county_names_all: "Saratoga|Warren",
    county_fips_all: "36091|36113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12804,
    lat: 43.3375,
    lng: -73.68307,
    city: "Queensbury",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26112,
    density: 184.4,
    county_fips: 36113,
    county_name: "Warren",
    county_weights: {
      36091: 0.16,
      36113: 96.37,
      36115: 3.47,
    },
    county_names_all: "Warren|Washington|Saratoga",
    county_fips_all: "36113|36115|36091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12808,
    lat: 43.74782,
    lng: -73.75393,
    city: "Adirondack",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 243,
    density: 6.6,
    county_fips: 36113,
    county_name: "Warren",
    county_weights: {
      36113: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 36113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12809,
    lat: 43.24097,
    lng: -73.4624,
    city: "Argyle",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3751,
    density: 27.7,
    county_fips: 36115,
    county_name: "Washington",
    county_weights: {
      36115: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 36115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12810,
    lat: 43.49862,
    lng: -73.95217,
    city: "Athol",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 630,
    density: 5.6,
    county_fips: 36113,
    county_name: "Warren",
    county_weights: {
      36113: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 36113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12811,
    lat: 43.57502,
    lng: -74.07508,
    city: "Bakers Mills",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36113,
    county_name: "Warren",
    county_weights: {
      36113: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 36113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12812,
    lat: 43.85731,
    lng: -74.41213,
    city: "Blue Mountain Lake",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 214,
    density: 0.9,
    county_fips: 36041,
    county_name: "Hamilton",
    county_weights: {
      36041: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 36041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12814,
    lat: 43.6004,
    lng: -73.63678,
    city: "Bolton Landing",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1259,
    density: 10.8,
    county_fips: 36113,
    county_name: "Warren",
    county_weights: {
      36113: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 36113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12815,
    lat: 43.70161,
    lng: -73.69459,
    city: "Brant Lake",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1027,
    density: 8.6,
    county_fips: 36113,
    county_name: "Warren",
    county_weights: {
      36113: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 36113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12816,
    lat: 43.05085,
    lng: -73.37829,
    city: "Cambridge",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4642,
    density: 29.9,
    county_fips: 36115,
    county_name: "Washington",
    county_weights: {
      36115: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 36115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12817,
    lat: 43.63697,
    lng: -73.82614,
    city: "Chestertown",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2243,
    density: 16.9,
    county_fips: 36113,
    county_name: "Warren",
    county_weights: {
      36113: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 36113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12819,
    lat: 43.61144,
    lng: -73.46315,
    city: "Clemons",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 236,
    density: 4.3,
    county_fips: 36115,
    county_name: "Washington",
    county_weights: {
      36115: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 36115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12820,
    lat: 43.46022,
    lng: -73.64067,
    city: "Cleverdale",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36113,
    county_name: "Warren",
    county_weights: {
      36113: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 36113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12821,
    lat: 43.45866,
    lng: -73.41332,
    city: "Comstock",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2839,
    density: 196.3,
    county_fips: 36115,
    county_name: "Washington",
    county_weights: {
      36115: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 36115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12822,
    lat: 43.2407,
    lng: -73.88959,
    city: "Corinth",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5962,
    density: 33.9,
    county_fips: 36091,
    county_name: "Saratoga",
    county_weights: {
      36091: 100,
    },
    county_names_all: "Saratoga",
    county_fips_all: 36091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12823,
    lat: 43.17945,
    lng: -73.40628,
    city: "Cossayuna",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 527,
    density: 52.6,
    county_fips: 36115,
    county_name: "Washington",
    county_weights: {
      36115: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 36115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12824,
    lat: 43.5279,
    lng: -73.71386,
    city: "Diamond Point",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 946,
    density: 17,
    county_fips: 36113,
    county_name: "Warren",
    county_weights: {
      36113: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 36113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12827,
    lat: 43.44917,
    lng: -73.51241,
    city: "Fort Ann",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3455,
    density: 10.9,
    county_fips: 36115,
    county_name: "Washington",
    county_weights: {
      36115: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 36115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12828,
    lat: 43.25534,
    lng: -73.56841,
    city: "Fort Edward",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9690,
    density: 83,
    county_fips: 36115,
    county_name: "Washington",
    county_weights: {
      36091: 26.19,
      36115: 73.81,
    },
    county_names_all: "Washington|Saratoga",
    county_fips_all: "36115|36091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12831,
    lat: 43.19533,
    lng: -73.68791,
    city: "Gansevoort",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17389,
    density: 103,
    county_fips: 36091,
    county_name: "Saratoga",
    county_weights: {
      36091: 100,
    },
    county_names_all: "Saratoga",
    county_fips_all: 36091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12832,
    lat: 43.36813,
    lng: -73.31716,
    city: "Granville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6500,
    density: 31.7,
    county_fips: 36115,
    county_name: "Washington",
    county_weights: {
      36115: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 36115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12833,
    lat: 43.13866,
    lng: -73.84355,
    city: "Greenfield Center",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4544,
    density: 47,
    county_fips: 36091,
    county_name: "Saratoga",
    county_weights: {
      36091: 100,
    },
    county_names_all: "Saratoga",
    county_fips_all: 36091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12834,
    lat: 43.09706,
    lng: -73.50423,
    city: "Greenwich",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6101,
    density: 27.9,
    county_fips: 36115,
    county_name: "Washington",
    county_weights: {
      36115: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 36115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12835,
    lat: 43.32496,
    lng: -74.00589,
    city: "Hadley",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2530,
    density: 9.7,
    county_fips: 36091,
    county_name: "Saratoga",
    county_weights: {
      36091: 99.1,
      36113: 0.9,
    },
    county_names_all: "Saratoga|Warren",
    county_fips_all: "36091|36113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12836,
    lat: 43.74994,
    lng: -73.56816,
    city: "Hague",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 605,
    density: 5.4,
    county_fips: 36113,
    county_name: "Warren",
    county_weights: {
      36031: 2.41,
      36113: 97.59,
    },
    county_names_all: "Warren|Essex",
    county_fips_all: "36113|36031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12837,
    lat: 43.50842,
    lng: -73.26651,
    city: "Hampton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1140,
    density: 31.7,
    county_fips: 36115,
    county_name: "Washington",
    county_weights: {
      36115: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 36115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12838,
    lat: 43.34354,
    lng: -73.40756,
    city: "Hartford",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 638,
    density: 45.3,
    county_fips: 36115,
    county_name: "Washington",
    county_weights: {
      36115: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 36115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12839,
    lat: 43.34496,
    lng: -73.55058,
    city: "Hudson Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13011,
    density: 161.9,
    county_fips: 36115,
    county_name: "Washington",
    county_weights: {
      36113: 0.28,
      36115: 99.72,
    },
    county_names_all: "Washington|Warren",
    county_fips_all: "36115|36113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12841,
    lat: 43.59919,
    lng: -73.5165,
    city: "Huletts Landing",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 148,
    density: 2.7,
    county_fips: 36115,
    county_name: "Washington",
    county_weights: {
      36115: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 36115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12842,
    lat: 43.75058,
    lng: -74.2746,
    city: "Indian Lake",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 765,
    density: 1.8,
    county_fips: 36041,
    county_name: "Hamilton",
    county_weights: {
      36041: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 36041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12843,
    lat: 43.5849,
    lng: -73.97771,
    city: "Johnsburg",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 482,
    density: 5.8,
    county_fips: 36113,
    county_name: "Warren",
    county_weights: {
      36113: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 36113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12844,
    lat: 43.49423,
    lng: -73.64081,
    city: "Kattskill Bay",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 292,
    density: 37.4,
    county_fips: 36113,
    county_name: "Warren",
    county_weights: {
      36113: 64.43,
      36115: 35.57,
    },
    county_names_all: "Warren|Washington",
    county_fips_all: "36113|36115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12845,
    lat: 43.42757,
    lng: -73.70703,
    city: "Lake George",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4610,
    density: 39.5,
    county_fips: 36113,
    county_name: "Warren",
    county_weights: {
      36113: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 36113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12846,
    lat: 43.34022,
    lng: -73.80592,
    city: "Lake Luzerne",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3248,
    density: 23.3,
    county_fips: 36113,
    county_name: "Warren",
    county_weights: {
      36113: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 36113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12847,
    lat: 43.98698,
    lng: -74.59024,
    city: "Long Lake",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 400,
    density: 0.3,
    county_fips: 36041,
    county_name: "Hamilton",
    county_weights: {
      36041: 91.53,
      36089: 8.47,
    },
    county_names_all: "Hamilton|St. Lawrence",
    county_fips_all: "36041|36089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12849,
    lat: 43.44812,
    lng: -73.2985,
    city: "Middle Granville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 303,
    density: 44.9,
    county_fips: 36115,
    county_name: "Washington",
    county_weights: {
      36115: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 36115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12850,
    lat: 43.09886,
    lng: -73.97941,
    city: "Middle Grove",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2866,
    density: 27.2,
    county_fips: 36091,
    county_name: "Saratoga",
    county_weights: {
      36091: 100,
    },
    county_names_all: "Saratoga",
    county_fips_all: 36091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12851,
    lat: 43.85171,
    lng: -74.06211,
    city: "Minerva",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 353,
    density: 1.6,
    county_fips: 36031,
    county_name: "Essex",
    county_weights: {
      36031: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 36031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12852,
    lat: 43.99293,
    lng: -74.13598,
    city: "Newcomb",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 344,
    density: 0.7,
    county_fips: 36031,
    county_name: "Essex",
    county_weights: {
      36031: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 36031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12853,
    lat: 43.68816,
    lng: -73.99804,
    city: "North Creek",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1834,
    density: 8.9,
    county_fips: 36113,
    county_name: "Warren",
    county_weights: {
      36031: 0.95,
      36113: 99.05,
    },
    county_names_all: "Warren|Essex",
    county_fips_all: "36113|36031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12854,
    lat: 43.45019,
    lng: -73.32767,
    city: "North Granville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36115,
    county_name: "Washington",
    county_weights: {
      36115: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 36115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12855,
    lat: 44.00121,
    lng: -73.79762,
    city: "North Hudson",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 244,
    density: 0.5,
    county_fips: 36031,
    county_name: "Essex",
    county_weights: {
      36031: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 36031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12856,
    lat: 43.65531,
    lng: -74.14625,
    city: "North River",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 291,
    density: 1.7,
    county_fips: 36113,
    county_name: "Warren",
    county_weights: {
      36113: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 36113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12857,
    lat: 43.84033,
    lng: -73.93354,
    city: "Olmstedville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 684,
    density: 3.9,
    county_fips: 36031,
    county_name: "Essex",
    county_weights: {
      36031: 98.26,
      36113: 1.74,
    },
    county_names_all: "Essex|Warren",
    county_fips_all: "36031|36113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12858,
    lat: 43.88899,
    lng: -73.6703,
    city: "Paradox",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 107,
    density: 2.4,
    county_fips: 36031,
    county_name: "Essex",
    county_weights: {
      36031: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 36031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12859,
    lat: 43.16587,
    lng: -73.90569,
    city: "Porter Corners",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2425,
    density: 47,
    county_fips: 36091,
    county_name: "Saratoga",
    county_weights: {
      36091: 100,
    },
    county_names_all: "Saratoga",
    county_fips_all: 36091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12860,
    lat: 43.72843,
    lng: -73.80942,
    city: "Pottersville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 480,
    density: 15.9,
    county_fips: 36113,
    county_name: "Warren",
    county_weights: {
      36113: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 36113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12861,
    lat: 43.74982,
    lng: -73.41502,
    city: "Putnam Station",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 530,
    density: 6.4,
    county_fips: 36115,
    county_name: "Washington",
    county_weights: {
      36031: 0.96,
      36115: 99.04,
    },
    county_names_all: "Washington|Essex",
    county_fips_all: "36115|36031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12862,
    lat: 43.67419,
    lng: -73.91878,
    city: "Riparius",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36113,
    county_name: "Warren",
    county_weights: {
      36113: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 36113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12863,
    lat: 43.06031,
    lng: -73.93162,
    city: "Rock City Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 880,
    density: 89.3,
    county_fips: 36091,
    county_name: "Saratoga",
    county_weights: {
      36091: 100,
    },
    county_names_all: "Saratoga",
    county_fips_all: 36091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12864,
    lat: 43.72733,
    lng: -74.3054,
    city: "Sabael",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13,
    density: 23.8,
    county_fips: 36041,
    county_name: "Hamilton",
    county_weights: {
      36041: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 36041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12865,
    lat: 43.21225,
    lng: -73.34191,
    city: "Salem",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3470,
    density: 18.5,
    county_fips: 36115,
    county_name: "Washington",
    county_weights: {
      36115: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 36115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12866,
    lat: 43.07537,
    lng: -73.7401,
    city: "Saratoga Springs",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38732,
    density: 232.5,
    county_fips: 36091,
    county_name: "Saratoga",
    county_weights: {
      36091: 100,
    },
    county_names_all: "Saratoga",
    county_fips_all: 36091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12870,
    lat: 43.83931,
    lng: -73.7625,
    city: "Schroon Lake",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1736,
    density: 6.8,
    county_fips: 36031,
    county_name: "Essex",
    county_weights: {
      36031: 98.11,
      36113: 1.89,
    },
    county_names_all: "Essex|Warren",
    county_fips_all: "36031|36113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12871,
    lat: 43.09249,
    lng: -73.61196,
    city: "Schuylerville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4361,
    density: 60.3,
    county_fips: 36091,
    county_name: "Saratoga",
    county_weights: {
      36091: 100,
    },
    county_names_all: "Saratoga",
    county_fips_all: 36091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12872,
    lat: 43.8839,
    lng: -73.72309,
    city: "Severance",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 91,
    density: 32.5,
    county_fips: 36031,
    county_name: "Essex",
    county_weights: {
      36031: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 36031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12873,
    lat: 43.1185,
    lng: -73.30682,
    city: "Shushan",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 875,
    density: 16,
    county_fips: 36115,
    county_name: "Washington",
    county_weights: {
      36115: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 36115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12874,
    lat: 43.69035,
    lng: -73.54836,
    city: "Silver Bay",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 173,
    density: 3.1,
    county_fips: 36113,
    county_name: "Warren",
    county_weights: {
      36113: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 36113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12878,
    lat: 43.44217,
    lng: -74.0479,
    city: "Stony Creek",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 663,
    density: 2.4,
    county_fips: 36113,
    county_name: "Warren",
    county_weights: {
      36113: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 36113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12883,
    lat: 43.85291,
    lng: -73.50786,
    city: "Ticonderoga",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4790,
    density: 21.9,
    county_fips: 36031,
    county_name: "Essex",
    county_weights: {
      36031: 98.8,
      36115: 1.2,
    },
    county_names_all: "Essex|Washington",
    county_fips_all: "36031|36115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12884,
    lat: 43.08855,
    lng: -73.5921,
    city: "Victory Mills",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 593,
    density: 516.5,
    county_fips: 36091,
    county_name: "Saratoga",
    county_weights: {
      36091: 100,
    },
    county_names_all: "Saratoga",
    county_fips_all: 36091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12885,
    lat: 43.52929,
    lng: -73.83161,
    city: "Warrensburg",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4437,
    density: 21.3,
    county_fips: 36113,
    county_name: "Warren",
    county_weights: {
      36113: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 36113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12886,
    lat: 43.63689,
    lng: -73.92654,
    city: "Wevertown",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 273,
    density: 22,
    county_fips: 36113,
    county_name: "Warren",
    county_weights: {
      36113: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 36113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12887,
    lat: 43.54504,
    lng: -73.37471,
    city: "Whitehall",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4857,
    density: 20.9,
    county_fips: 36115,
    county_name: "Washington",
    county_weights: {
      36115: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 36115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12901,
    lat: 44.70842,
    lng: -73.47465,
    city: "Plattsburgh",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33048,
    density: 180.7,
    county_fips: 36019,
    county_name: "Clinton",
    county_weights: {
      36019: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 36019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12903,
    lat: 44.65698,
    lng: -73.46306,
    city: "Plattsburgh",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1306,
    density: 119,
    county_fips: 36019,
    county_name: "Clinton",
    county_weights: {
      36019: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 36019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12910,
    lat: 44.8546,
    lng: -73.64593,
    city: "Altona",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2190,
    density: 13,
    county_fips: 36019,
    county_name: "Clinton",
    county_weights: {
      36019: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 36019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12911,
    lat: 44.53464,
    lng: -73.46687,
    city: "Keeseville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36019,
    county_name: "Clinton",
    county_weights: {
      36019: 80.99,
      36031: 19.01,
    },
    county_names_all: "Clinton|Essex",
    county_fips_all: "36019|36031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12912,
    lat: 44.46233,
    lng: -73.74201,
    city: "Au Sable Forks",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1903,
    density: 7.7,
    county_fips: 36019,
    county_name: "Clinton",
    county_weights: {
      36019: 77.09,
      36031: 22.91,
    },
    county_names_all: "Clinton|Essex",
    county_fips_all: "36019|36031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12913,
    lat: 44.42627,
    lng: -74.01562,
    city: "Bloomingdale",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1059,
    density: 13.4,
    county_fips: 36033,
    county_name: "Franklin",
    county_weights: {
      36031: 41.26,
      36033: 58.74,
    },
    county_names_all: "Franklin|Essex",
    county_fips_all: "36033|36031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12914,
    lat: 44.93289,
    lng: -74.6018,
    city: "Bombay",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 891,
    density: 11.4,
    county_fips: 36033,
    county_name: "Franklin",
    county_weights: {
      36033: 83.54,
      36089: 16.46,
    },
    county_names_all: "Franklin|St. Lawrence",
    county_fips_all: "36033|36089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12915,
    lat: 44.8535,
    lng: -74.035,
    city: "Brainardsville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36033,
    county_name: "Franklin",
    county_weights: {
      36033: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 36033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12916,
    lat: 44.83572,
    lng: -74.5145,
    city: "Brushton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2436,
    density: 22.9,
    county_fips: 36033,
    county_name: "Franklin",
    county_weights: {
      36033: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 36033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12917,
    lat: 44.92468,
    lng: -74.17387,
    city: "Burke",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1344,
    density: 11.5,
    county_fips: 36033,
    county_name: "Franklin",
    county_weights: {
      36033: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 36033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12918,
    lat: 44.68975,
    lng: -73.67863,
    city: "Cadyville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2641,
    density: 24,
    county_fips: 36019,
    county_name: "Clinton",
    county_weights: {
      36019: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 36019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12919,
    lat: 44.96793,
    lng: -73.45072,
    city: "Champlain",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2805,
    density: 28.9,
    county_fips: 36019,
    county_name: "Clinton",
    county_weights: {
      36019: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 36019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12920,
    lat: 44.89332,
    lng: -74.06016,
    city: "Chateaugay",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2387,
    density: 11.6,
    county_fips: 36033,
    county_name: "Franklin",
    county_weights: {
      36019: 7.31,
      36033: 92.69,
    },
    county_names_all: "Franklin|Clinton",
    county_fips_all: "36033|36019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12921,
    lat: 44.89188,
    lng: -73.43574,
    city: "Chazy",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2835,
    density: 34.5,
    county_fips: 36019,
    county_name: "Clinton",
    county_weights: {
      36019: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 36019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12922,
    lat: 44.33381,
    lng: -74.7827,
    city: "Childwold",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32,
    density: 0.1,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12923,
    lat: 44.94546,
    lng: -73.95802,
    city: "Churubusco",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 555,
    density: 5,
    county_fips: 36019,
    county_name: "Clinton",
    county_weights: {
      36019: 99.85,
      36033: 0.15,
    },
    county_names_all: "Clinton|Franklin",
    county_fips_all: "36019|36033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12924,
    lat: 44.47589,
    lng: -73.58751,
    city: "Keeseville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59,
    density: 8,
    county_fips: 36019,
    county_name: "Clinton",
    county_weights: {
      36019: 99.86,
      36031: 0.14,
    },
    county_names_all: "Clinton|Essex",
    county_fips_all: "36019|36031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12926,
    lat: 44.95223,
    lng: -74.32214,
    city: "Constable",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2380,
    density: 19.4,
    county_fips: 36033,
    county_name: "Franklin",
    county_weights: {
      36033: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 36033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12927,
    lat: 44.2005,
    lng: -74.81818,
    city: "Cranberry Lake",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 276,
    density: 0.9,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12928,
    lat: 43.9539,
    lng: -73.52898,
    city: "Crown Point",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2029,
    density: 10.8,
    county_fips: 36031,
    county_name: "Essex",
    county_weights: {
      36031: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 36031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12929,
    lat: 44.71971,
    lng: -73.71909,
    city: "Dannemora",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4103,
    density: 1271.3,
    county_fips: 36019,
    county_name: "Clinton",
    county_weights: {
      36019: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 36019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12930,
    lat: 44.72349,
    lng: -74.5437,
    city: "Dickinson Center",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 815,
    density: 8.8,
    county_fips: 36033,
    county_name: "Franklin",
    county_weights: {
      36033: 95.8,
      36089: 4.2,
    },
    county_names_all: "Franklin|St. Lawrence",
    county_fips_all: "36033|36089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12932,
    lat: 44.21222,
    lng: -73.6082,
    city: "Elizabethtown",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1210,
    density: 6.7,
    county_fips: 36031,
    county_name: "Essex",
    county_weights: {
      36031: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 36031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12933,
    lat: 44.89118,
    lng: -73.84512,
    city: "Ellenburg",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65,
    density: 917.4,
    county_fips: 36019,
    county_name: "Clinton",
    county_weights: {
      36019: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 36019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12934,
    lat: 44.84603,
    lng: -73.87659,
    city: "Ellenburg Center",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1059,
    density: 5.9,
    county_fips: 36019,
    county_name: "Clinton",
    county_weights: {
      36019: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 36019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12935,
    lat: 44.85709,
    lng: -73.79461,
    city: "Ellenburg Depot",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1428,
    density: 5.6,
    county_fips: 36019,
    county_name: "Clinton",
    county_weights: {
      36019: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 36019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12936,
    lat: 44.26869,
    lng: -73.4029,
    city: "Essex",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 420,
    density: 4,
    county_fips: 36031,
    county_name: "Essex",
    county_weights: {
      36031: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 36031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12937,
    lat: 44.96176,
    lng: -74.47807,
    city: "Fort Covington",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1880,
    density: 21.1,
    county_fips: 36033,
    county_name: "Franklin",
    county_weights: {
      36033: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 36033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12939,
    lat: 44.43859,
    lng: -74.16541,
    city: "Gabriels",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 155,
    density: 9.4,
    county_fips: 36033,
    county_name: "Franklin",
    county_weights: {
      36033: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 36033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12941,
    lat: 44.35147,
    lng: -73.7126,
    city: "Jay",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1402,
    density: 15.4,
    county_fips: 36031,
    county_name: "Essex",
    county_weights: {
      36031: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 36031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12942,
    lat: 44.26023,
    lng: -73.79523,
    city: "Keene",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 663,
    density: 4.9,
    county_fips: 36031,
    county_name: "Essex",
    county_weights: {
      36031: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 36031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12943,
    lat: 44.13934,
    lng: -73.82075,
    city: "Keene Valley",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 314,
    density: 1.2,
    county_fips: 36031,
    county_name: "Essex",
    county_weights: {
      36031: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 36031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12944,
    lat: 44.44585,
    lng: -73.51193,
    city: "Keeseville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3683,
    density: 15.6,
    county_fips: 36031,
    county_name: "Essex",
    county_weights: {
      36019: 12.19,
      36031: 87.81,
    },
    county_names_all: "Essex|Clinton",
    county_fips_all: "36031|36019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12945,
    lat: 44.33451,
    lng: -74.23829,
    city: "Lake Clear",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 449,
    density: 5.1,
    county_fips: 36033,
    county_name: "Franklin",
    county_weights: {
      36033: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 36033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12946,
    lat: 44.23162,
    lng: -73.98903,
    city: "Lake Placid",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4819,
    density: 13.6,
    county_fips: 36031,
    county_name: "Essex",
    county_weights: {
      36031: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 36031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12950,
    lat: 44.32685,
    lng: -73.57675,
    city: "Lewis",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 674,
    density: 5,
    county_fips: 36031,
    county_name: "Essex",
    county_weights: {
      36031: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 36031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12952,
    lat: 44.71181,
    lng: -73.91362,
    city: "Lyon Mountain",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 305,
    density: 4,
    county_fips: 36019,
    county_name: "Clinton",
    county_weights: {
      36019: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 36019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12953,
    lat: 44.74198,
    lng: -74.26347,
    city: "Malone",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15469,
    density: 28.1,
    county_fips: 36033,
    county_name: "Franklin",
    county_weights: {
      36033: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 36033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12955,
    lat: 44.78934,
    lng: -73.95855,
    city: "Lyon Mountain",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 366,
    density: 6,
    county_fips: 36019,
    county_name: "Clinton",
    county_weights: {
      36019: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 36019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12956,
    lat: 44.09301,
    lng: -73.49628,
    city: "Mineville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1180,
    density: 48.3,
    county_fips: 36031,
    county_name: "Essex",
    county_weights: {
      36031: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 36031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12957,
    lat: 44.85353,
    lng: -74.57706,
    city: "Moira",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1559,
    density: 17,
    county_fips: 36033,
    county_name: "Franklin",
    county_weights: {
      36033: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 36033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12958,
    lat: 44.95661,
    lng: -73.57419,
    city: "Mooers",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2020,
    density: 22,
    county_fips: 36019,
    county_name: "Clinton",
    county_weights: {
      36019: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 36019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12959,
    lat: 44.96073,
    lng: -73.7014,
    city: "Mooers Forks",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1474,
    density: 13.4,
    county_fips: 36019,
    county_name: "Clinton",
    county_weights: {
      36019: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 36019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12960,
    lat: 44.02226,
    lng: -73.54123,
    city: "Moriah",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 635,
    density: 10,
    county_fips: 36031,
    county_name: "Essex",
    county_weights: {
      36031: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 36031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12961,
    lat: 44.06103,
    lng: -73.57972,
    city: "Moriah Center",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 243,
    density: 6.2,
    county_fips: 36031,
    county_name: "Essex",
    county_weights: {
      36031: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 36031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12962,
    lat: 44.70642,
    lng: -73.60141,
    city: "Morrisonville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5084,
    density: 51.3,
    county_fips: 36019,
    county_name: "Clinton",
    county_weights: {
      36019: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 36019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12964,
    lat: 44.13224,
    lng: -73.63625,
    city: "New Russia",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67,
    density: 0.8,
    county_fips: 36031,
    county_name: "Essex",
    county_weights: {
      36031: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 36031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12965,
    lat: 44.70587,
    lng: -74.684,
    city: "Nicholville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 537,
    density: 22.3,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12966,
    lat: 44.79226,
    lng: -74.41915,
    city: "North Bangor",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2732,
    density: 12.5,
    county_fips: 36033,
    county_name: "Franklin",
    county_weights: {
      36033: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 36033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12967,
    lat: 44.76864,
    lng: -74.65897,
    city: "North Lawrence",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1035,
    density: 11.9,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36033: 2.35,
      36089: 97.65,
    },
    county_names_all: "St. Lawrence|Franklin",
    county_fips_all: "36089|36033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12969,
    lat: 44.71102,
    lng: -74.0812,
    city: "Owls Head",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 347,
    density: 1.2,
    county_fips: 36033,
    county_name: "Franklin",
    county_weights: {
      36033: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 36033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12970,
    lat: 44.44949,
    lng: -74.33222,
    city: "Paul Smiths",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 839,
    density: 3,
    county_fips: 36033,
    county_name: "Franklin",
    county_weights: {
      36033: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 36033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12972,
    lat: 44.559,
    lng: -73.56516,
    city: "Peru",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6611,
    density: 33.5,
    county_fips: 36019,
    county_name: "Clinton",
    county_weights: {
      36019: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 36019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12973,
    lat: 44.30279,
    lng: -74.59187,
    city: "Piercefield",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 104,
    density: 1.3,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36033: 0.24,
      36089: 99.76,
    },
    county_names_all: "St. Lawrence|Franklin",
    county_fips_all: "36089|36033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12974,
    lat: 44.05582,
    lng: -73.46931,
    city: "Port Henry",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2152,
    density: 122.1,
    county_fips: 36031,
    county_name: "Essex",
    county_weights: {
      36031: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 36031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12975,
    lat: 44.52977,
    lng: -73.431,
    city: "Port Kent",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 217,
    density: 28.2,
    county_fips: 36031,
    county_name: "Essex",
    county_weights: {
      36031: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 36031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12976,
    lat: 44.50469,
    lng: -74.20498,
    city: "Rainbow Lake",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 228,
    density: 3.2,
    county_fips: 36033,
    county_name: "Franklin",
    county_weights: {
      36033: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 36033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12977,
    lat: 44.29484,
    lng: -74.09673,
    city: "Ray Brook",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1763,
    density: 547.4,
    county_fips: 36031,
    county_name: "Essex",
    county_weights: {
      36031: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 36031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12978,
    lat: 44.6181,
    lng: -73.79589,
    city: "Redford",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 258,
    density: 90.9,
    county_fips: 36019,
    county_name: "Clinton",
    county_weights: {
      36019: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 36019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12979,
    lat: 44.98926,
    lng: -73.37213,
    city: "Rouses Point",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2435,
    density: 226.2,
    county_fips: 36019,
    county_name: "Clinton",
    county_weights: {
      36019: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 36019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12980,
    lat: 44.57254,
    lng: -74.50875,
    city: "Saint Regis Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1053,
    density: 1.7,
    county_fips: 36033,
    county_name: "Franklin",
    county_weights: {
      36033: 81.41,
      36089: 18.59,
    },
    county_names_all: "Franklin|St. Lawrence",
    county_fips_all: "36033|36089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12981,
    lat: 44.62235,
    lng: -73.84035,
    city: "Saranac",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2401,
    density: 7.9,
    county_fips: 36019,
    county_name: "Clinton",
    county_weights: {
      36019: 94.53,
      36033: 5.47,
    },
    county_names_all: "Clinton|Franklin",
    county_fips_all: "36019|36033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12983,
    lat: 44.34627,
    lng: -74.14243,
    city: "Saranac Lake",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7719,
    density: 25.7,
    county_fips: 36033,
    county_name: "Franklin",
    county_weights: {
      36031: 44.35,
      36033: 55.65,
    },
    county_names_all: "Franklin|Essex",
    county_fips_all: "36033|36031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12985,
    lat: 44.56413,
    lng: -73.73395,
    city: "Schuyler Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 994,
    density: 7.5,
    county_fips: 36019,
    county_name: "Clinton",
    county_weights: {
      36019: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 36019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12986,
    lat: 44.22279,
    lng: -74.44056,
    city: "Tupper Lake",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5928,
    density: 8,
    county_fips: 36033,
    county_name: "Franklin",
    county_weights: {
      36033: 75.43,
      36089: 24.57,
    },
    county_names_all: "Franklin|St. Lawrence",
    county_fips_all: "36033|36089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12987,
    lat: 44.33948,
    lng: -73.76386,
    city: "Upper Jay",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 242,
    density: 9.1,
    county_fips: 36031,
    county_name: "Essex",
    county_weights: {
      36031: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 36031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12989,
    lat: 44.53935,
    lng: -74.06439,
    city: "Vermontville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1114,
    density: 3,
    county_fips: 36033,
    county_name: "Franklin",
    county_weights: {
      36033: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 36033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12992,
    lat: 44.81822,
    lng: -73.51582,
    city: "West Chazy",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3565,
    density: 20.9,
    county_fips: 36019,
    county_name: "Clinton",
    county_weights: {
      36019: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 36019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12993,
    lat: 44.19711,
    lng: -73.48097,
    city: "Westport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1486,
    density: 8.9,
    county_fips: 36031,
    county_name: "Essex",
    county_weights: {
      36031: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 36031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12996,
    lat: 44.36129,
    lng: -73.42129,
    city: "Willsboro",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2084,
    density: 21,
    county_fips: 36031,
    county_name: "Essex",
    county_weights: {
      36031: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 36031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12997,
    lat: 44.3755,
    lng: -73.84314,
    city: "Wilmington",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1067,
    density: 6.3,
    county_fips: 36031,
    county_name: "Essex",
    county_weights: {
      36031: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 36031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 12998,
    lat: 44.0879,
    lng: -73.57584,
    city: "Witherbee",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 313,
    density: 16.2,
    county_fips: 36031,
    county_name: "Essex",
    county_weights: {
      36031: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 36031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13020,
    lat: 42.81646,
    lng: -76.07458,
    city: "Apulia Station",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75,
    density: 61.9,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13026,
    lat: 42.75044,
    lng: -76.65968,
    city: "Aurora",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1705,
    density: 25.1,
    county_fips: 36011,
    county_name: "Cayuga",
    county_weights: {
      36011: 100,
    },
    county_names_all: "Cayuga",
    county_fips_all: 36011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13027,
    lat: 43.16741,
    lng: -76.36258,
    city: "Baldwinsville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33937,
    density: 195.7,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36011: 0.7,
      36067: 99.3,
    },
    county_names_all: "Onondaga|Cayuga",
    county_fips_all: "36067|36011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13028,
    lat: 43.29226,
    lng: -75.93107,
    city: "Bernhards Bay",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 926,
    density: 21.1,
    county_fips: 36075,
    county_name: "Oswego",
    county_weights: {
      36075: 100,
    },
    county_names_all: "Oswego",
    county_fips_all: 36075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13029,
    lat: 43.2236,
    lng: -76.14993,
    city: "Brewerton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7360,
    density: 161.1,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13030,
    lat: 43.15962,
    lng: -75.96052,
    city: "Bridgeport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3470,
    density: 118.8,
    county_fips: 36053,
    county_name: "Madison",
    county_weights: {
      36053: 64.19,
      36067: 35.81,
    },
    county_names_all: "Madison|Onondaga",
    county_fips_all: "36053|36067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13031,
    lat: 43.0448,
    lng: -76.30775,
    city: "Camillus",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15484,
    density: 245.9,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13032,
    lat: 43.07793,
    lng: -75.76275,
    city: "Canastota",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12522,
    density: 58.6,
    county_fips: 36053,
    county_name: "Madison",
    county_weights: {
      36053: 99.68,
      36065: 0.32,
    },
    county_names_all: "Madison|Oneida",
    county_fips_all: "36053|36065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13033,
    lat: 43.1852,
    lng: -76.57044,
    city: "Cato",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3807,
    density: 24,
    county_fips: 36011,
    county_name: "Cayuga",
    county_weights: {
      36011: 100,
    },
    county_names_all: "Cayuga",
    county_fips_all: 36011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13034,
    lat: 42.91366,
    lng: -76.69502,
    city: "Cayuga",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1925,
    density: 30.4,
    county_fips: 36011,
    county_name: "Cayuga",
    county_weights: {
      36011: 100,
    },
    county_names_all: "Cayuga",
    county_fips_all: 36011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13035,
    lat: 42.93828,
    lng: -75.82551,
    city: "Cazenovia",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8707,
    density: 44.7,
    county_fips: 36053,
    county_name: "Madison",
    county_weights: {
      36053: 96.96,
      36067: 3.04,
    },
    county_names_all: "Madison|Onondaga",
    county_fips_all: "36053|36067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13036,
    lat: 43.32268,
    lng: -76.17402,
    city: "Central Square",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9632,
    density: 80.7,
    county_fips: 36075,
    county_name: "Oswego",
    county_weights: {
      36075: 100,
    },
    county_names_all: "Oswego",
    county_fips_all: 36075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13037,
    lat: 43.06046,
    lng: -75.86521,
    city: "Chittenango",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9775,
    density: 88.8,
    county_fips: 36053,
    county_name: "Madison",
    county_weights: {
      36053: 95.56,
      36067: 4.44,
    },
    county_names_all: "Madison|Onondaga",
    county_fips_all: "36053|36067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13039,
    lat: 43.16678,
    lng: -76.0654,
    city: "Cicero",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17078,
    density: 279.9,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13040,
    lat: 42.56033,
    lng: -75.93029,
    city: "Cincinnatus",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2370,
    density: 9.2,
    county_fips: 36023,
    county_name: "Cortland",
    county_weights: {
      36017: 15.47,
      36023: 84.53,
    },
    county_names_all: "Cortland|Chenango",
    county_fips_all: "36023|36017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13041,
    lat: 43.19079,
    lng: -76.19711,
    city: "Clay",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11808,
    density: 252.3,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13042,
    lat: 43.26565,
    lng: -75.85154,
    city: "Cleveland",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2383,
    density: 26.8,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 63.3,
      36075: 36.7,
    },
    county_names_all: "Oneida|Oswego",
    county_fips_all: "36065|36075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13044,
    lat: 43.2977,
    lng: -75.99595,
    city: "Constantia",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2742,
    density: 35.2,
    county_fips: 36075,
    county_name: "Oswego",
    county_weights: {
      36075: 100,
    },
    county_names_all: "Oswego",
    county_fips_all: 36075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13045,
    lat: 42.58692,
    lng: -76.19029,
    city: "Cortland",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28975,
    density: 103.7,
    county_fips: 36023,
    county_name: "Cortland",
    county_weights: {
      36011: 8.92,
      36023: 84.99,
      36109: 6.09,
    },
    county_names_all: "Cortland|Cayuga|Tompkins",
    county_fips_all: "36023|36011|36109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13051,
    lat: 42.88339,
    lng: -75.91021,
    city: "Delphi Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 135,
    density: 141.9,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13052,
    lat: 42.72838,
    lng: -75.86957,
    city: "De Ruyter",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1626,
    density: 10.6,
    county_fips: 36053,
    county_name: "Madison",
    county_weights: {
      36017: 32.41,
      36023: 25.17,
      36053: 38.2,
      36067: 4.22,
    },
    county_names_all: "Madison|Chenango|Cortland|Onondaga",
    county_fips_all: "36053|36017|36023|36067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13053,
    lat: 42.47513,
    lng: -76.26471,
    city: "Dryden",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4861,
    density: 53.9,
    county_fips: 36109,
    county_name: "Tompkins",
    county_weights: {
      36023: 42.11,
      36109: 57.89,
    },
    county_names_all: "Tompkins|Cortland",
    county_fips_all: "36109|36023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13054,
    lat: 43.16947,
    lng: -75.66923,
    city: "Durhamville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1500,
    density: 25,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13057,
    lat: 43.09543,
    lng: -76.04014,
    city: "East Syracuse",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13126,
    density: 182.9,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13060,
    lat: 43.02381,
    lng: -76.41926,
    city: "Elbridge",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3050,
    density: 72.9,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13061,
    lat: 42.86493,
    lng: -75.75173,
    city: "Erieville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 877,
    density: 12.5,
    county_fips: 36053,
    county_name: "Madison",
    county_weights: {
      36053: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 36053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13062,
    lat: 42.48121,
    lng: -76.38694,
    city: "Etna",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37,
    density: 21,
    county_fips: 36109,
    county_name: "Tompkins",
    county_weights: {
      36109: 100,
    },
    county_names_all: "Tompkins",
    county_fips_all: 36109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13063,
    lat: 42.84429,
    lng: -75.98023,
    city: "Fabius",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1827,
    density: 19.3,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13065,
    lat: 42.81884,
    lng: -76.81577,
    city: "Fayette",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36099,
    county_name: "Seneca",
    county_weights: {
      36099: 100,
    },
    county_names_all: "Seneca",
    county_fips_all: 36099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13066,
    lat: 43.03297,
    lng: -76.00259,
    city: "Fayetteville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12443,
    density: 324.8,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13068,
    lat: 42.49905,
    lng: -76.35555,
    city: "Freeville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5184,
    density: 39.6,
    county_fips: 36109,
    county_name: "Tompkins",
    county_weights: {
      36109: 100,
    },
    county_names_all: "Tompkins",
    county_fips_all: 36109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13069,
    lat: 43.33081,
    lng: -76.37867,
    city: "Fulton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24111,
    density: 84.7,
    county_fips: 36075,
    county_name: "Oswego",
    county_weights: {
      36067: 1.02,
      36075: 98.98,
    },
    county_names_all: "Oswego|Onondaga",
    county_fips_all: "36075|36067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13071,
    lat: 42.67584,
    lng: -76.54252,
    city: "Genoa",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 934,
    density: 14.9,
    county_fips: 36011,
    county_name: "Cayuga",
    county_weights: {
      36011: 100,
    },
    county_names_all: "Cayuga",
    county_fips_all: 36011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13072,
    lat: 42.76243,
    lng: -75.76296,
    city: "Georgetown",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 884,
    density: 7.4,
    county_fips: 36053,
    county_name: "Madison",
    county_weights: {
      36017: 22.41,
      36053: 77.59,
    },
    county_names_all: "Madison|Chenango",
    county_fips_all: "36053|36017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13073,
    lat: 42.58514,
    lng: -76.39832,
    city: "Groton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6729,
    density: 47.2,
    county_fips: 36109,
    county_name: "Tompkins",
    county_weights: {
      36011: 2.42,
      36109: 97.58,
    },
    county_names_all: "Tompkins|Cayuga",
    county_fips_all: "36109|36011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13074,
    lat: 43.31035,
    lng: -76.54786,
    city: "Hannibal",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4230,
    density: 38.6,
    county_fips: 36075,
    county_name: "Oswego",
    county_weights: {
      36011: 5.31,
      36075: 94.69,
    },
    county_names_all: "Oswego|Cayuga",
    county_fips_all: "36075|36011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13076,
    lat: 43.35364,
    lng: -76.15182,
    city: "Hastings",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2037,
    density: 52.7,
    county_fips: 36075,
    county_name: "Oswego",
    county_weights: {
      36075: 100,
    },
    county_names_all: "Oswego",
    county_fips_all: 36075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13077,
    lat: 42.71557,
    lng: -76.20089,
    city: "Homer",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6462,
    density: 36.3,
    county_fips: 36023,
    county_name: "Cortland",
    county_weights: {
      36011: 2.45,
      36023: 83.9,
      36067: 13.65,
    },
    county_names_all: "Cortland|Onondaga|Cayuga",
    county_fips_all: "36023|36067|36011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13078,
    lat: 42.96206,
    lng: -76.06171,
    city: "Jamesville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10940,
    density: 109.6,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13080,
    lat: 43.08338,
    lng: -76.47776,
    city: "Jordan",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3227,
    density: 44.2,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36011: 40.26,
      36067: 59.74,
    },
    county_names_all: "Onondaga|Cayuga",
    county_fips_all: "36067|36011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13081,
    lat: 42.67364,
    lng: -76.62527,
    city: "King Ferry",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1203,
    density: 16.2,
    county_fips: 36011,
    county_name: "Cayuga",
    county_weights: {
      36011: 100,
    },
    county_names_all: "Cayuga",
    county_fips_all: 36011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13082,
    lat: 43.10148,
    lng: -75.95253,
    city: "Kirkville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4201,
    density: 66.6,
    county_fips: 36053,
    county_name: "Madison",
    county_weights: {
      36053: 52.56,
      36067: 47.44,
    },
    county_names_all: "Madison|Onondaga",
    county_fips_all: "36053|36067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13083,
    lat: 43.64853,
    lng: -75.98091,
    city: "Lacona",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2027,
    density: 13.1,
    county_fips: 36075,
    county_name: "Oswego",
    county_weights: {
      36045: 1.48,
      36075: 98.52,
    },
    county_names_all: "Oswego|Jefferson",
    county_fips_all: "36075|36045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13084,
    lat: 42.88938,
    lng: -76.11314,
    city: "La Fayette",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3814,
    density: 34.6,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13087,
    lat: 42.69634,
    lng: -76.16493,
    city: "Little York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 243,
    density: 98.9,
    county_fips: 36023,
    county_name: "Cortland",
    county_weights: {
      36023: 100,
    },
    county_names_all: "Cortland",
    county_fips_all: 36023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13088,
    lat: 43.10787,
    lng: -76.19096,
    city: "Liverpool",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20926,
    density: 969.8,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13090,
    lat: 43.15162,
    lng: -76.21344,
    city: "Liverpool",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29017,
    density: 766.6,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13092,
    lat: 42.65145,
    lng: -76.42502,
    city: "Locke",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2484,
    density: 19.2,
    county_fips: 36011,
    county_name: "Cayuga",
    county_weights: {
      36011: 90.85,
      36109: 9.15,
    },
    county_names_all: "Cayuga|Tompkins",
    county_fips_all: "36011|36109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13101,
    lat: 42.60211,
    lng: -76.06665,
    city: "McGraw",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2448,
    density: 24.6,
    county_fips: 36023,
    county_name: "Cortland",
    county_weights: {
      36023: 100,
    },
    county_names_all: "Cortland",
    county_fips_all: 36023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13102,
    lat: 42.55276,
    lng: -76.29253,
    city: "McLean",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74,
    density: 490.9,
    county_fips: 36109,
    county_name: "Tompkins",
    county_weights: {
      36109: 100,
    },
    county_names_all: "Tompkins",
    county_fips_all: 36109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13103,
    lat: 43.32652,
    lng: -76.10507,
    city: "Mallory",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 226,
    density: 224.1,
    county_fips: 36075,
    county_name: "Oswego",
    county_weights: {
      36075: 100,
    },
    county_names_all: "Oswego",
    county_fips_all: 36075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13104,
    lat: 42.96378,
    lng: -75.95523,
    city: "Manlius",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16038,
    density: 129.8,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36053: 3.83,
      36067: 96.17,
    },
    county_names_all: "Onondaga|Madison",
    county_fips_all: "36067|36053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13108,
    lat: 42.97349,
    lng: -76.33069,
    city: "Marcellus",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6193,
    density: 80.4,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13110,
    lat: 42.89019,
    lng: -76.28507,
    city: "Marietta",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2198,
    density: 35.2,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13111,
    lat: 43.25988,
    lng: -76.61858,
    city: "Martville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1769,
    density: 24.9,
    county_fips: 36011,
    county_name: "Cayuga",
    county_weights: {
      36011: 82.46,
      36075: 17.54,
    },
    county_names_all: "Cayuga|Oswego",
    county_fips_all: "36011|36075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13112,
    lat: 43.10306,
    lng: -76.41926,
    city: "Memphis",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1683,
    density: 31.9,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13113,
    lat: 43.16425,
    lng: -76.53488,
    city: "Meridian",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 258,
    density: 2857.8,
    county_fips: 36011,
    county_name: "Cayuga",
    county_weights: {
      36011: 100,
    },
    county_names_all: "Cayuga",
    county_fips_all: 36011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13114,
    lat: 43.46386,
    lng: -76.24328,
    city: "Mexico",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6594,
    density: 40.4,
    county_fips: 36075,
    county_name: "Oswego",
    county_weights: {
      36075: 100,
    },
    county_names_all: "Oswego",
    county_fips_all: 36075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13115,
    lat: 43.3937,
    lng: -76.47462,
    city: "Minetto",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 238,
    density: 359.9,
    county_fips: 36075,
    county_name: "Oswego",
    county_weights: {
      36075: 100,
    },
    county_names_all: "Oswego",
    county_fips_all: 36075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13116,
    lat: 43.07449,
    lng: -76.00796,
    city: "Minoa",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3447,
    density: 1022.5,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13117,
    lat: 43.01007,
    lng: -76.70838,
    city: "Montezuma",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 289,
    density: 115.3,
    county_fips: 36011,
    county_name: "Cayuga",
    county_weights: {
      36011: 99.34,
      36099: 0.66,
    },
    county_names_all: "Cayuga|Seneca",
    county_fips_all: "36011|36099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13118,
    lat: 42.75226,
    lng: -76.39522,
    city: "Moravia",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6130,
    density: 23,
    county_fips: 36011,
    county_name: "Cayuga",
    county_weights: {
      36011: 100,
    },
    county_names_all: "Cayuga",
    county_fips_all: 36011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13119,
    lat: 42.97655,
    lng: -76.44488,
    city: "Mottville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13120,
    lat: 42.94233,
    lng: -76.1695,
    city: "Nedrow",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2092,
    density: 51,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13121,
    lat: 43.48491,
    lng: -76.30966,
    city: "New Haven",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36075,
    county_name: "Oswego",
    county_weights: {
      36075: 100,
    },
    county_names_all: "Oswego",
    county_fips_all: 36075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13122,
    lat: 42.83857,
    lng: -75.85919,
    city: "New Woodstock",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1181,
    density: 23.7,
    county_fips: 36053,
    county_name: "Madison",
    county_weights: {
      36053: 81.54,
      36067: 18.46,
    },
    county_names_all: "Madison|Onondaga",
    county_fips_all: "36053|36067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13123,
    lat: 43.22796,
    lng: -75.75325,
    city: "North Bay",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 485,
    density: 652.6,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13124,
    lat: 42.64578,
    lng: -75.81718,
    city: "North Pitcher",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 99,
    density: 7.6,
    county_fips: 36017,
    county_name: "Chenango",
    county_weights: {
      36017: 100,
    },
    county_names_all: "Chenango",
    county_fips_all: 36017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13126,
    lat: 43.43469,
    lng: -76.46331,
    city: "Oswego",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35369,
    density: 135.7,
    county_fips: 36075,
    county_name: "Oswego",
    county_weights: {
      36011: 0.91,
      36075: 99.09,
    },
    county_names_all: "Oswego|Cayuga",
    county_fips_all: "36075|36011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13131,
    lat: 43.41964,
    lng: -76.09539,
    city: "Parish",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3317,
    density: 24.4,
    county_fips: 36075,
    county_name: "Oswego",
    county_weights: {
      36075: 100,
    },
    county_names_all: "Oswego",
    county_fips_all: 36075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13132,
    lat: 43.26547,
    lng: -76.24446,
    city: "Pennellville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3557,
    density: 59.4,
    county_fips: 36075,
    county_name: "Oswego",
    county_weights: {
      36075: 100,
    },
    county_names_all: "Oswego",
    county_fips_all: 36075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13134,
    lat: 42.96731,
    lng: -75.68476,
    city: "Peterboro",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 187,
    density: 874.7,
    county_fips: 36053,
    county_name: "Madison",
    county_weights: {
      36053: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 36053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13135,
    lat: 43.25801,
    lng: -76.31676,
    city: "Phoenix",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5939,
    density: 71.6,
    county_fips: 36075,
    county_name: "Oswego",
    county_weights: {
      36067: 26.04,
      36075: 73.96,
    },
    county_names_all: "Oswego|Onondaga",
    county_fips_all: "36075|36067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13136,
    lat: 42.60368,
    lng: -75.84582,
    city: "Pitcher",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 360,
    density: 7.7,
    county_fips: 36017,
    county_name: "Chenango",
    county_weights: {
      36017: 100,
    },
    county_names_all: "Chenango",
    county_fips_all: 36017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13138,
    lat: 42.89915,
    lng: -76.01461,
    city: "Pompey",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 121,
    density: 1137.8,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13140,
    lat: 43.05891,
    lng: -76.65841,
    city: "Port Byron",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4534,
    density: 33,
    county_fips: 36011,
    county_name: "Cayuga",
    county_weights: {
      36011: 100,
    },
    county_names_all: "Cayuga",
    county_fips_all: 36011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13141,
    lat: 42.76684,
    lng: -76.18616,
    city: "Preble",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 510,
    density: 13.7,
    county_fips: 36023,
    county_name: "Cortland",
    county_weights: {
      36023: 63.65,
      36067: 36.35,
    },
    county_names_all: "Cortland|Onondaga",
    county_fips_all: "36023|36067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13142,
    lat: 43.55189,
    lng: -76.12959,
    city: "Pulaski",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6486,
    density: 34.7,
    county_fips: 36075,
    county_name: "Oswego",
    county_weights: {
      36075: 100,
    },
    county_names_all: "Oswego",
    county_fips_all: 36075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13143,
    lat: 43.23325,
    lng: -76.71545,
    city: "Red Creek",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2300,
    density: 19.8,
    county_fips: 36117,
    county_name: "Wayne",
    county_weights: {
      36011: 44.35,
      36117: 55.65,
    },
    county_names_all: "Wayne|Cayuga",
    county_fips_all: "36117|36011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13144,
    lat: 43.57034,
    lng: -75.97464,
    city: "Richland",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1608,
    density: 16.7,
    county_fips: 36075,
    county_name: "Oswego",
    county_weights: {
      36075: 100,
    },
    county_names_all: "Oswego",
    county_fips_all: 36075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13145,
    lat: 43.65188,
    lng: -76.1232,
    city: "Sandy Creek",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1410,
    density: 35,
    county_fips: 36075,
    county_name: "Oswego",
    county_weights: {
      36075: 100,
    },
    county_names_all: "Oswego",
    county_fips_all: 36075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13146,
    lat: 43.09711,
    lng: -76.76031,
    city: "Savannah",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2433,
    density: 17.9,
    county_fips: 36117,
    county_name: "Wayne",
    county_weights: {
      36099: 3.53,
      36117: 96.47,
    },
    county_names_all: "Wayne|Seneca",
    county_fips_all: "36117|36099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13147,
    lat: 42.77336,
    lng: -76.56603,
    city: "Scipio Center",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1031,
    density: 11.3,
    county_fips: 36011,
    county_name: "Cayuga",
    county_weights: {
      36011: 100,
    },
    county_names_all: "Cayuga",
    county_fips_all: 36011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13148,
    lat: 42.9208,
    lng: -76.78106,
    city: "Seneca Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10648,
    density: 66,
    county_fips: 36099,
    county_name: "Seneca",
    county_weights: {
      36099: 100,
    },
    county_names_all: "Seneca",
    county_fips_all: 36099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13152,
    lat: 42.89323,
    lng: -76.38518,
    city: "Skaneateles",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7841,
    density: 47.8,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36011: 14.23,
      36067: 85.77,
    },
    county_names_all: "Onondaga|Cayuga",
    county_fips_all: "36067|36011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13153,
    lat: 42.9945,
    lng: -76.45476,
    city: "Skaneateles Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 469,
    density: 314.6,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13154,
    lat: 43.13378,
    lng: -76.76192,
    city: "South Butler",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36117,
    county_name: "Wayne",
    county_weights: {
      36117: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 36117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13155,
    lat: 42.65945,
    lng: -75.77136,
    city: "South Otselic",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 491,
    density: 7.8,
    county_fips: 36017,
    county_name: "Chenango",
    county_weights: {
      36017: 100,
    },
    county_names_all: "Chenango",
    county_fips_all: 36017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13156,
    lat: 43.33355,
    lng: -76.66249,
    city: "Sterling",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1757,
    density: 23.1,
    county_fips: 36011,
    county_name: "Cayuga",
    county_weights: {
      36011: 99.1,
      36117: 0.9,
    },
    county_names_all: "Cayuga|Wayne",
    county_fips_all: "36011|36117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13157,
    lat: 43.20288,
    lng: -75.7254,
    city: "Sylvan Beach",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 489,
    density: 451.2,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13158,
    lat: 42.71603,
    lng: -75.97626,
    city: "Truxton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1772,
    density: 11.6,
    county_fips: 36023,
    county_name: "Cortland",
    county_weights: {
      36023: 94.15,
      36067: 5.85,
    },
    county_names_all: "Cortland|Onondaga",
    county_fips_all: "36023|36067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13159,
    lat: 42.80321,
    lng: -76.11545,
    city: "Tully",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5303,
    density: 26.5,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36023: 32.12,
      36067: 67.88,
    },
    county_names_all: "Onondaga|Cortland",
    county_fips_all: "36067|36023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13160,
    lat: 42.82613,
    lng: -76.65157,
    city: "Union Springs",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2242,
    density: 38.2,
    county_fips: 36011,
    county_name: "Cayuga",
    county_weights: {
      36011: 100,
    },
    county_names_all: "Cayuga",
    county_fips_all: 36011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13162,
    lat: 43.18833,
    lng: -75.71823,
    city: "Verona Beach",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 248,
    density: 54.1,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13163,
    lat: 43.08194,
    lng: -75.70841,
    city: "Wampsville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 462,
    density: 489.2,
    county_fips: 36053,
    county_name: "Madison",
    county_weights: {
      36053: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 36053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13164,
    lat: 43.09377,
    lng: -76.31626,
    city: "Warners",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2607,
    density: 90.4,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13165,
    lat: 42.91185,
    lng: -76.87601,
    city: "Waterloo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9905,
    density: 56.1,
    county_fips: 36099,
    county_name: "Seneca",
    county_weights: {
      36099: 100,
    },
    county_names_all: "Seneca",
    county_fips_all: 36099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13166,
    lat: 43.07219,
    lng: -76.5568,
    city: "Weedsport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5465,
    density: 51.6,
    county_fips: 36011,
    county_name: "Cayuga",
    county_weights: {
      36011: 98.23,
      36067: 1.77,
    },
    county_names_all: "Cayuga|Onondaga",
    county_fips_all: "36011|36067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13167,
    lat: 43.3171,
    lng: -76.0571,
    city: "West Monroe",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2756,
    density: 29,
    county_fips: 36075,
    county_name: "Oswego",
    county_weights: {
      36075: 100,
    },
    county_names_all: "Oswego",
    county_fips_all: 36075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13202,
    lat: 43.04356,
    lng: -76.15065,
    city: "Syracuse",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6943,
    density: 2667.6,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13203,
    lat: 43.061,
    lng: -76.13486,
    city: "Syracuse",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16876,
    density: 3832.9,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13204,
    lat: 43.05204,
    lng: -76.17666,
    city: "Syracuse",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19264,
    density: 1747.5,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13205,
    lat: 43.00474,
    lng: -76.14163,
    city: "Syracuse",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16746,
    density: 1784.4,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13206,
    lat: 43.07354,
    lng: -76.10584,
    city: "Syracuse",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16837,
    density: 1599.7,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13207,
    lat: 43.01221,
    lng: -76.16354,
    city: "Syracuse",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12552,
    density: 1502.6,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13208,
    lat: 43.07878,
    lng: -76.14521,
    city: "Syracuse",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22560,
    density: 2129.5,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13209,
    lat: 43.08581,
    lng: -76.24355,
    city: "Syracuse",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12364,
    density: 365.1,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13210,
    lat: 43.03186,
    lng: -76.12653,
    city: "Syracuse",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27172,
    density: 2785.7,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13211,
    lat: 43.10333,
    lng: -76.11954,
    city: "Syracuse",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6117,
    density: 517.2,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13212,
    lat: 43.12839,
    lng: -76.12889,
    city: "Syracuse",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21557,
    density: 749.5,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13214,
    lat: 43.03865,
    lng: -76.0741,
    city: "Syracuse",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8392,
    density: 923,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13215,
    lat: 42.97852,
    lng: -76.22979,
    city: "Syracuse",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14306,
    density: 164.7,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13219,
    lat: 43.03969,
    lng: -76.22277,
    city: "Syracuse",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14819,
    density: 1139.6,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13224,
    lat: 43.03892,
    lng: -76.10264,
    city: "Syracuse",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8486,
    density: 1142.2,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13244,
    lat: 43.02318,
    lng: -76.12329,
    city: "Syracuse",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13290,
    lat: 43.07132,
    lng: -76.17368,
    city: "Syracuse",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36067,
    county_name: "Onondaga",
    county_weights: {
      36067: 100,
    },
    county_names_all: "Onondaga",
    county_fips_all: 36067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13301,
    lat: 43.42225,
    lng: -75.21546,
    city: "Alder Creek",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 198,
    density: 66,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13302,
    lat: 43.50261,
    lng: -75.95044,
    city: "Altmar",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1483,
    density: 12.7,
    county_fips: 36075,
    county_name: "Oswego",
    county_weights: {
      36075: 100,
    },
    county_names_all: "Oswego",
    county_fips_all: 36075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13303,
    lat: 43.36992,
    lng: -75.46636,
    city: "Ava",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1454,
    density: 16.3,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13304,
    lat: 43.23954,
    lng: -75.1589,
    city: "Barneveld",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1726,
    density: 37.8,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36043: 10.68,
      36065: 89.32,
    },
    county_names_all: "Oneida|Herkimer",
    county_fips_all: "36065|36043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13305,
    lat: 43.89329,
    lng: -75.43144,
    city: "Beaver Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 204,
    density: 68.3,
    county_fips: 36049,
    county_name: "Lewis",
    county_weights: {
      36049: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 36049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13308,
    lat: 43.24865,
    lng: -75.66686,
    city: "Blossvale",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3867,
    density: 39.4,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13309,
    lat: 43.47398,
    lng: -75.34103,
    city: "Boonville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5672,
    density: 15.1,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36049: 26.35,
      36065: 73.65,
    },
    county_names_all: "Oneida|Lewis",
    county_fips_all: "36065|36049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13310,
    lat: 42.89055,
    lng: -75.57065,
    city: "Bouckville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 828,
    density: 37.9,
    county_fips: 36053,
    county_name: "Madison",
    county_weights: {
      36053: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 36053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13312,
    lat: 43.70247,
    lng: -75.20758,
    city: "Brantingham",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 332,
    density: 1.9,
    county_fips: 36049,
    county_name: "Lewis",
    county_weights: {
      36043: 0.13,
      36049: 99.87,
    },
    county_names_all: "Lewis|Herkimer",
    county_fips_all: "36049|36043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13313,
    lat: 42.88715,
    lng: -75.26228,
    city: "Bridgewater",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 451,
    density: 52.7,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13314,
    lat: 42.82476,
    lng: -75.31568,
    city: "Brookfield",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 232,
    density: 40.1,
    county_fips: 36053,
    county_name: "Madison",
    county_weights: {
      36053: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 36053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13315,
    lat: 42.7438,
    lng: -75.1385,
    city: "Burlington Flats",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1471,
    density: 11.7,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36077: 100,
    },
    county_names_all: "Otsego",
    county_fips_all: 36077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13316,
    lat: 43.41492,
    lng: -75.73963,
    city: "Camden",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6168,
    density: 14,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36049: 28.98,
      36065: 68.19,
      36075: 2.83,
    },
    county_names_all: "Oneida|Lewis|Oswego",
    county_fips_all: "36065|36049|36075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13317,
    lat: 42.85638,
    lng: -74.58844,
    city: "Canajoharie",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3847,
    density: 31.9,
    county_fips: 36057,
    county_name: "Montgomery",
    county_weights: {
      36057: 94.3,
      36077: 5.7,
    },
    county_names_all: "Montgomery|Otsego",
    county_fips_all: "36057|36077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13318,
    lat: 42.92366,
    lng: -75.25958,
    city: "Cassville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1300,
    density: 20.4,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13319,
    lat: 43.02705,
    lng: -75.26593,
    city: "Chadwicks",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 761,
    density: 298.6,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13320,
    lat: 42.77353,
    lng: -74.74325,
    city: "Cherry Valley",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2119,
    density: 10.4,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36077: 100,
    },
    county_names_all: "Otsego",
    county_fips_all: 36077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13321,
    lat: 43.08901,
    lng: -75.37259,
    city: "Clark Mills",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 639,
    density: 425.7,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13322,
    lat: 42.96661,
    lng: -75.20445,
    city: "Clayville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 888,
    density: 25.7,
    county_fips: 36043,
    county_name: "Herkimer",
    county_weights: {
      36043: 60.06,
      36065: 39.94,
    },
    county_names_all: "Herkimer|Oneida",
    county_fips_all: "36043|36065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13323,
    lat: 43.04198,
    lng: -75.38144,
    city: "Clinton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11585,
    density: 115,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13324,
    lat: 43.3165,
    lng: -74.93325,
    city: "Cold Brook",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2195,
    density: 6.3,
    county_fips: 36043,
    county_name: "Herkimer",
    county_weights: {
      36043: 100,
    },
    county_names_all: "Herkimer",
    county_fips_all: 36043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13325,
    lat: 43.58398,
    lng: -75.54091,
    city: "Constableville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 955,
    density: 3.6,
    county_fips: 36049,
    county_name: "Lewis",
    county_weights: {
      36049: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 36049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13326,
    lat: 42.71865,
    lng: -74.90374,
    city: "Cooperstown",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5165,
    density: 21.7,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36077: 100,
    },
    county_names_all: "Otsego",
    county_fips_all: 36077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13327,
    lat: 43.96047,
    lng: -75.28474,
    city: "Croghan",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1762,
    density: 4.9,
    county_fips: 36049,
    county_name: "Lewis",
    county_weights: {
      36049: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 36049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13328,
    lat: 42.98247,
    lng: -75.42836,
    city: "Deansboro",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1622,
    density: 39.8,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13329,
    lat: 43.11094,
    lng: -74.70017,
    city: "Dolgeville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4211,
    density: 29.4,
    county_fips: 36035,
    county_name: "Fulton",
    county_weights: {
      36035: 71.24,
      36043: 28.76,
    },
    county_names_all: "Fulton|Herkimer",
    county_fips_all: "36035|36043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13331,
    lat: 43.81706,
    lng: -74.97284,
    city: "Eagle Bay",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61,
    density: 0.1,
    county_fips: 36043,
    county_name: "Herkimer",
    county_weights: {
      36041: 1.38,
      36043: 98.62,
    },
    county_names_all: "Herkimer|Hamilton",
    county_fips_all: "36043|36041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13332,
    lat: 42.75831,
    lng: -75.57452,
    city: "Earlville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2823,
    density: 19.5,
    county_fips: 36053,
    county_name: "Madison",
    county_weights: {
      36017: 19.26,
      36053: 80.74,
    },
    county_names_all: "Madison|Chenango",
    county_fips_all: "36053|36017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13333,
    lat: 42.83091,
    lng: -74.82207,
    city: "East Springfield",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35,
    density: 8.3,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36077: 100,
    },
    county_names_all: "Otsego",
    county_fips_all: 36077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13334,
    lat: 42.83445,
    lng: -75.65986,
    city: "Eaton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1083,
    density: 14.3,
    county_fips: 36053,
    county_name: "Madison",
    county_weights: {
      36053: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 36053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13335,
    lat: 42.70193,
    lng: -75.24847,
    city: "Edmeston",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1386,
    density: 15,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36077: 100,
    },
    county_names_all: "Otsego",
    county_fips_all: 36077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13337,
    lat: 42.75114,
    lng: -74.9816,
    city: "Fly Creek",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 628,
    density: 14.4,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36077: 100,
    },
    county_names_all: "Otsego",
    county_fips_all: 36077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13338,
    lat: 43.49706,
    lng: -74.97833,
    city: "Forestport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1263,
    density: 2.1,
    county_fips: 36043,
    county_name: "Herkimer",
    county_weights: {
      36043: 76.74,
      36065: 23.26,
    },
    county_names_all: "Herkimer|Oneida",
    county_fips_all: "36043|36065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13339,
    lat: 42.93995,
    lng: -74.66631,
    city: "Fort Plain",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6382,
    density: 23.4,
    county_fips: 36057,
    county_name: "Montgomery",
    county_weights: {
      36035: 6.28,
      36043: 18.38,
      36057: 75.34,
    },
    county_names_all: "Montgomery|Herkimer|Fulton",
    county_fips_all: "36057|36043|36035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13340,
    lat: 43.04814,
    lng: -75.11502,
    city: "Frankfort",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8023,
    density: 51.3,
    county_fips: 36043,
    county_name: "Herkimer",
    county_weights: {
      36043: 100,
    },
    county_names_all: "Herkimer",
    county_fips_all: 36043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13342,
    lat: 42.64766,
    lng: -75.18918,
    city: "Garrattsville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 229,
    density: 15.1,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36077: 100,
    },
    county_names_all: "Otsego",
    county_fips_all: 36077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13343,
    lat: 43.75271,
    lng: -75.31062,
    city: "Glenfield",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1572,
    density: 10.4,
    county_fips: 36049,
    county_name: "Lewis",
    county_weights: {
      36049: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 36049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13345,
    lat: 43.6889,
    lng: -75.33153,
    city: "Greig",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 150,
    density: 10.8,
    county_fips: 36049,
    county_name: "Lewis",
    county_weights: {
      36049: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 36049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13346,
    lat: 42.82093,
    lng: -75.54453,
    city: "Hamilton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6225,
    density: 67.9,
    county_fips: 36053,
    county_name: "Madison",
    county_weights: {
      36053: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 36053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13348,
    lat: 42.70202,
    lng: -75.06398,
    city: "Hartwick",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1381,
    density: 14.9,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36077: 100,
    },
    county_names_all: "Otsego",
    county_fips_all: 36077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13350,
    lat: 43.06352,
    lng: -74.98817,
    city: "Herkimer",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9727,
    density: 118.7,
    county_fips: 36043,
    county_name: "Herkimer",
    county_weights: {
      36043: 100,
    },
    county_names_all: "Herkimer",
    county_fips_all: 36043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13352,
    lat: 43.31122,
    lng: -75.12058,
    city: "Hinckley",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10,
    density: 13.9,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13353,
    lat: 43.47123,
    lng: -74.72732,
    city: "Hoffmeister",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17,
    density: 0,
    county_fips: 36041,
    county_name: "Hamilton",
    county_weights: {
      36041: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 36041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13354,
    lat: 43.26612,
    lng: -75.27199,
    city: "Holland Patent",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3777,
    density: 27.3,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13355,
    lat: 42.80971,
    lng: -75.42401,
    city: "Hubbardsville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1440,
    density: 17.1,
    county_fips: 36053,
    county_name: "Madison",
    county_weights: {
      36053: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 36053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13357,
    lat: 42.96952,
    lng: -75.08037,
    city: "Ilion",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10748,
    density: 140.4,
    county_fips: 36043,
    county_name: "Herkimer",
    county_weights: {
      36043: 100,
    },
    county_names_all: "Herkimer",
    county_fips_all: 36043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13360,
    lat: 43.72457,
    lng: -74.73577,
    city: "Inlet",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 134,
    density: 0.9,
    county_fips: 36041,
    county_name: "Hamilton",
    county_weights: {
      36041: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 36041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13361,
    lat: 42.89807,
    lng: -74.86256,
    city: "Jordanville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 872,
    density: 11.8,
    county_fips: 36043,
    county_name: "Herkimer",
    county_weights: {
      36043: 76.91,
      36077: 23.09,
    },
    county_names_all: "Herkimer|Otsego",
    county_fips_all: "36043|36077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13363,
    lat: 43.33127,
    lng: -75.50984,
    city: "Lee Center",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2358,
    density: 38.8,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13364,
    lat: 42.80501,
    lng: -75.26105,
    city: "Leonardsville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 222,
    density: 29.1,
    county_fips: 36053,
    county_name: "Madison",
    county_weights: {
      36053: 99.7,
      36077: 0.3,
    },
    county_names_all: "Madison|Otsego",
    county_fips_all: "36053|36077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13365,
    lat: 43.09804,
    lng: -74.84937,
    city: "Little Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8472,
    density: 26.5,
    county_fips: 36043,
    county_name: "Herkimer",
    county_weights: {
      36043: 100,
    },
    county_names_all: "Herkimer",
    county_fips_all: 36043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13367,
    lat: 43.85563,
    lng: -75.31772,
    city: "Lowville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8893,
    density: 7.4,
    county_fips: 36049,
    county_name: "Lewis",
    county_weights: {
      36043: 37.85,
      36049: 62.15,
    },
    county_names_all: "Lewis|Herkimer",
    county_fips_all: "36049|36043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13368,
    lat: 43.6446,
    lng: -75.33209,
    city: "Lyons Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1184,
    density: 19,
    county_fips: 36049,
    county_name: "Lewis",
    county_weights: {
      36049: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 36049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13402,
    lat: 42.90209,
    lng: -75.50728,
    city: "Madison",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1441,
    density: 23.2,
    county_fips: 36053,
    county_name: "Madison",
    county_weights: {
      36053: 93.12,
      36065: 6.88,
    },
    county_names_all: "Madison|Oneida",
    county_fips_all: "36053|36065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13403,
    lat: 43.17041,
    lng: -75.27188,
    city: "Marcy",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7485,
    density: 103.8,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13404,
    lat: 43.73842,
    lng: -75.48089,
    city: "Martinsburg",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 130,
    density: 30.4,
    county_fips: 36049,
    county_name: "Lewis",
    county_weights: {
      36049: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 36049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13406,
    lat: 43.14326,
    lng: -74.92257,
    city: "Middleville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 865,
    density: 72.2,
    county_fips: 36043,
    county_name: "Herkimer",
    county_weights: {
      36043: 100,
    },
    county_names_all: "Herkimer",
    county_fips_all: 36043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13407,
    lat: 42.9677,
    lng: -74.94087,
    city: "Mohawk",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4830,
    density: 33.1,
    county_fips: 36043,
    county_name: "Herkimer",
    county_weights: {
      36043: 100,
    },
    county_names_all: "Herkimer",
    county_fips_all: 36043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13408,
    lat: 42.92205,
    lng: -75.66722,
    city: "Morrisville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3584,
    density: 40.7,
    county_fips: 36053,
    county_name: "Madison",
    county_weights: {
      36053: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 36053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13409,
    lat: 42.97602,
    lng: -75.59131,
    city: "Munnsville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2255,
    density: 24.2,
    county_fips: 36053,
    county_name: "Madison",
    county_weights: {
      36053: 94.2,
      36065: 5.8,
    },
    county_names_all: "Madison|Oneida",
    county_fips_all: "36053|36065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13410,
    lat: 42.92908,
    lng: -74.60922,
    city: "Nelliston",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 350,
    density: 273.8,
    county_fips: 36057,
    county_name: "Montgomery",
    county_weights: {
      36057: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 36057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13411,
    lat: 42.63723,
    lng: -75.30981,
    city: "New Berlin",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3092,
    density: 16.9,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36017: 46.35,
      36077: 53.65,
    },
    county_names_all: "Otsego|Chenango",
    county_fips_all: "36077|36017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13413,
    lat: 43.0576,
    lng: -75.27495,
    city: "New Hartford",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15750,
    density: 315.4,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36043: 11.27,
      36065: 88.73,
    },
    county_names_all: "Oneida|Herkimer",
    county_fips_all: "36065|36043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13415,
    lat: 42.59714,
    lng: -75.19729,
    city: "New Lisbon",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25,
    density: 4.7,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36077: 100,
    },
    county_names_all: "Otsego",
    county_fips_all: 36077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13416,
    lat: 43.18768,
    lng: -74.9571,
    city: "Newport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2079,
    density: 16,
    county_fips: 36043,
    county_name: "Herkimer",
    county_weights: {
      36043: 100,
    },
    county_names_all: "Herkimer",
    county_fips_all: 36043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13417,
    lat: 43.10002,
    lng: -75.29399,
    city: "New York Mills",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3066,
    density: 834.1,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13418,
    lat: 42.84519,
    lng: -75.38213,
    city: "North Brookfield",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 268,
    density: 19.3,
    county_fips: 36053,
    county_name: "Madison",
    county_weights: {
      36053: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 36053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13420,
    lat: 43.65069,
    lng: -74.9619,
    city: "Old Forge",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1064,
    density: 2.8,
    county_fips: 36043,
    county_name: "Herkimer",
    county_weights: {
      36043: 100,
    },
    county_names_all: "Herkimer",
    county_fips_all: 36043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13421,
    lat: 43.06293,
    lng: -75.64654,
    city: "Oneida",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13230,
    density: 127.3,
    county_fips: 36053,
    county_name: "Madison",
    county_weights: {
      36053: 75.94,
      36065: 24.06,
    },
    county_names_all: "Madison|Oneida",
    county_fips_all: "36053|36065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13424,
    lat: 43.15228,
    lng: -75.36291,
    city: "Oriskany",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2375,
    density: 76.3,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13425,
    lat: 42.9635,
    lng: -75.48675,
    city: "Oriskany Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2143,
    density: 32.1,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36053: 13.98,
      36065: 86.02,
    },
    county_names_all: "Oneida|Madison",
    county_fips_all: "36065|36053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13428,
    lat: 42.92096,
    lng: -74.53311,
    city: "Palatine Bridge",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1668,
    density: 38.7,
    county_fips: 36057,
    county_name: "Montgomery",
    county_weights: {
      36057: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 36057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13431,
    lat: 43.20691,
    lng: -75.07608,
    city: "Poland",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1902,
    density: 20.3,
    county_fips: 36043,
    county_name: "Herkimer",
    county_weights: {
      36043: 87.97,
      36065: 12.03,
    },
    county_names_all: "Herkimer|Oneida",
    county_fips_all: "36043|36065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13433,
    lat: 43.59914,
    lng: -75.24765,
    city: "Port Leyden",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1657,
    density: 11.2,
    county_fips: 36049,
    county_name: "Lewis",
    county_weights: {
      36043: 0.15,
      36049: 99.85,
    },
    county_names_all: "Lewis|Herkimer",
    county_fips_all: "36049|36043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13435,
    lat: 43.30255,
    lng: -75.15134,
    city: "Prospect",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 347,
    density: 311.4,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36043: 1.09,
      36065: 98.91,
    },
    county_names_all: "Oneida|Herkimer",
    county_fips_all: "36065|36043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13436,
    lat: 43.80501,
    lng: -74.67034,
    city: "Raquette Lake",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42,
    density: 0.5,
    county_fips: 36041,
    county_name: "Hamilton",
    county_weights: {
      36041: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 36041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13437,
    lat: 43.59677,
    lng: -75.80383,
    city: "Redfield",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 326,
    density: 1.3,
    county_fips: 36075,
    county_name: "Oswego",
    county_weights: {
      36049: 24.42,
      36075: 75.58,
    },
    county_names_all: "Oswego|Lewis",
    county_fips_all: "36075|36049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13438,
    lat: 43.35171,
    lng: -75.15527,
    city: "Remsen",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2944,
    density: 11.9,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36043: 24.32,
      36065: 75.68,
    },
    county_names_all: "Oneida|Herkimer",
    county_fips_all: "36065|36043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13439,
    lat: 42.85491,
    lng: -74.99724,
    city: "Richfield Springs",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3720,
    density: 16.3,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36043: 38.86,
      36077: 61.14,
    },
    county_names_all: "Otsego|Herkimer",
    county_fips_all: "36077|36043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13440,
    lat: 43.21807,
    lng: -75.45941,
    city: "Rome",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41342,
    density: 137,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13441,
    lat: 43.22711,
    lng: -75.40758,
    city: "Rome",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 197,
    density: 22.4,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13450,
    lat: 42.7026,
    lng: -74.81263,
    city: "Roseboom",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 85,
    density: 9.7,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36077: 100,
    },
    county_names_all: "Otsego",
    county_fips_all: 36077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13452,
    lat: 43.03718,
    lng: -74.63001,
    city: "Saint Johnsville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4671,
    density: 23.8,
    county_fips: 36035,
    county_name: "Fulton",
    county_weights: {
      36035: 75.5,
      36057: 24.5,
    },
    county_names_all: "Fulton|Montgomery",
    county_fips_all: "36035|36057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13454,
    lat: 43.16885,
    lng: -74.75719,
    city: "Salisbury Center",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 800,
    density: 24.1,
    county_fips: 36043,
    county_name: "Herkimer",
    county_weights: {
      36043: 100,
    },
    county_names_all: "Herkimer",
    county_fips_all: 36043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13455,
    lat: 42.91791,
    lng: -75.37655,
    city: "Sangerfield",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13456,
    lat: 43.00145,
    lng: -75.25855,
    city: "Sauquoit",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4039,
    density: 61.1,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36043: 14.05,
      36065: 85.95,
    },
    county_names_all: "Oneida|Herkimer",
    county_fips_all: "36065|36043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13457,
    lat: 42.77527,
    lng: -75.03691,
    city: "Schuyler Lake",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36077: 100,
    },
    county_names_all: "Otsego",
    county_fips_all: 36077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13459,
    lat: 42.77721,
    lng: -74.59315,
    city: "Sharon Springs",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2343,
    density: 17.9,
    county_fips: 36095,
    county_name: "Schoharie",
    county_weights: {
      36057: 7.53,
      36077: 2.89,
      36095: 89.58,
    },
    county_names_all: "Schoharie|Montgomery|Otsego",
    county_fips_all: "36095|36057|36077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13460,
    lat: 42.68492,
    lng: -75.45572,
    city: "Sherburne",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4122,
    density: 23.9,
    county_fips: 36017,
    county_name: "Chenango",
    county_weights: {
      36017: 95.98,
      36053: 4.02,
    },
    county_names_all: "Chenango|Madison",
    county_fips_all: "36017|36053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13461,
    lat: 43.07115,
    lng: -75.59866,
    city: "Sherrill",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2987,
    density: 468.4,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13464,
    lat: 42.68632,
    lng: -75.61998,
    city: "Smyrna",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1368,
    density: 13.3,
    county_fips: 36017,
    county_name: "Chenango",
    county_weights: {
      36017: 98.27,
      36053: 1.73,
    },
    county_names_all: "Chenango|Madison",
    county_fips_all: "36017|36053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13468,
    lat: 42.84696,
    lng: -74.86448,
    city: "Springfield Center",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 478,
    density: 30.5,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36077: 100,
    },
    county_names_all: "Otsego",
    county_fips_all: 36077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13469,
    lat: 43.22028,
    lng: -75.29853,
    city: "Stittville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1238,
    density: 154.4,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13470,
    lat: 43.21075,
    lng: -74.66825,
    city: "Stratford",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 665,
    density: 2.9,
    county_fips: 36035,
    county_name: "Fulton",
    county_weights: {
      36035: 70.43,
      36043: 29.57,
    },
    county_names_all: "Fulton|Herkimer",
    county_fips_all: "36035|36043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13471,
    lat: 43.37606,
    lng: -75.6122,
    city: "Taberg",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3045,
    density: 14.9,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36049: 18.59,
      36065: 81.41,
    },
    county_names_all: "Oneida|Lewis",
    county_fips_all: "36065|36049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13472,
    lat: 43.69491,
    lng: -75.06072,
    city: "Thendara",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 79,
    density: 2.2,
    county_fips: 36043,
    county_name: "Herkimer",
    county_weights: {
      36043: 100,
    },
    county_names_all: "Herkimer",
    county_fips_all: 36043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13473,
    lat: 43.64414,
    lng: -75.44517,
    city: "Turin",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 958,
    density: 9,
    county_fips: 36049,
    county_name: "Lewis",
    county_weights: {
      36049: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 36049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13475,
    lat: 42.88789,
    lng: -74.81196,
    city: "Van Hornesville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36043,
    county_name: "Herkimer",
    county_weights: {
      36043: 100,
    },
    county_names_all: "Herkimer",
    county_fips_all: 36043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13476,
    lat: 43.08728,
    lng: -75.51219,
    city: "Vernon",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3617,
    density: 60.9,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13477,
    lat: 43.03633,
    lng: -75.51441,
    city: "Vernon Center",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1029,
    density: 22.1,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13478,
    lat: 43.14916,
    lng: -75.58009,
    city: "Verona",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3257,
    density: 36,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13480,
    lat: 42.91424,
    lng: -75.36699,
    city: "Waterville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3235,
    density: 22.8,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36053: 9,
      36065: 91,
    },
    county_names_all: "Oneida|Madison",
    county_fips_all: "36065|36053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13482,
    lat: 42.69661,
    lng: -75.17695,
    city: "West Burlington",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36077: 100,
    },
    county_names_all: "Otsego",
    county_fips_all: 36077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13483,
    lat: 43.40075,
    lng: -75.81995,
    city: "Westdale",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 317,
    density: 13.6,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 98.16,
      36075: 1.84,
    },
    county_names_all: "Oneida|Oswego",
    county_fips_all: "36065|36075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13484,
    lat: 42.85426,
    lng: -75.65549,
    city: "West Eaton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 174,
    density: 2436.5,
    county_fips: 36053,
    county_name: "Madison",
    county_weights: {
      36053: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 36053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13485,
    lat: 42.7865,
    lng: -75.3165,
    city: "West Edmeston",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1231,
    density: 11.1,
    county_fips: 36053,
    county_name: "Madison",
    county_weights: {
      36017: 7.57,
      36053: 80.42,
      36077: 12.01,
    },
    county_names_all: "Madison|Otsego|Chenango",
    county_fips_all: "36053|36077|36017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13486,
    lat: 43.35707,
    lng: -75.34088,
    city: "Westernville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 701,
    density: 10.2,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13488,
    lat: 42.67447,
    lng: -74.76796,
    city: "Westford",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 103,
    density: 8.2,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36077: 100,
    },
    county_names_all: "Otsego",
    county_fips_all: 36077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13489,
    lat: 43.46698,
    lng: -75.52928,
    city: "West Leyden",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 538,
    density: 6.7,
    county_fips: 36049,
    county_name: "Lewis",
    county_weights: {
      36049: 99.89,
      36065: 0.11,
    },
    county_names_all: "Lewis|Oneida",
    county_fips_all: "36049|36065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13490,
    lat: 43.10612,
    lng: -75.42991,
    city: "Westmoreland",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1606,
    density: 63,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13491,
    lat: 42.85957,
    lng: -75.17698,
    city: "West Winfield",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3330,
    density: 17.1,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36043: 38.08,
      36053: 10.11,
      36077: 51.82,
    },
    county_names_all: "Otsego|Herkimer|Madison",
    county_fips_all: "36077|36043|36053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13492,
    lat: 43.1172,
    lng: -75.33023,
    city: "Whitesboro",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11118,
    density: 280.5,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13493,
    lat: 43.43162,
    lng: -75.90102,
    city: "Williamstown",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2318,
    density: 12.7,
    county_fips: 36075,
    county_name: "Oswego",
    county_weights: {
      36065: 0.5,
      36075: 99.5,
    },
    county_names_all: "Oswego|Oneida",
    county_fips_all: "36075|36065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13494,
    lat: 43.53136,
    lng: -75.14198,
    city: "Woodgate",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 240,
    density: 5.5,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13495,
    lat: 43.11087,
    lng: -75.27744,
    city: "Yorkville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2035,
    density: 907.6,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13501,
    lat: 43.08138,
    lng: -75.22611,
    city: "Utica",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37132,
    density: 1621.3,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36065: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 36065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13502,
    lat: 43.14121,
    lng: -75.16584,
    city: "Utica",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32437,
    density: 243.5,
    county_fips: 36065,
    county_name: "Oneida",
    county_weights: {
      36043: 29.73,
      36065: 70.27,
    },
    county_names_all: "Oneida|Herkimer",
    county_fips_all: "36065|36043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13601,
    lat: 43.96949,
    lng: -75.90965,
    city: "Watertown",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36982,
    density: 101.4,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 94.31,
      36049: 5.69,
    },
    county_names_all: "Jefferson|Lewis",
    county_fips_all: "36045|36049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13602,
    lat: 44.04877,
    lng: -75.75747,
    city: "Fort Drum",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4383,
    density: 147.4,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13603,
    lat: 44.03826,
    lng: -75.79765,
    city: "Watertown",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9274,
    density: 646.7,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13605,
    lat: 43.80641,
    lng: -76.05195,
    city: "Adams",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5173,
    density: 25.6,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13606,
    lat: 43.87007,
    lng: -76.01601,
    city: "Adams Center",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2456,
    density: 27.1,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13607,
    lat: 44.33233,
    lng: -75.91187,
    city: "Alexandria Bay",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1445,
    density: 34.1,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13608,
    lat: 44.23879,
    lng: -75.62508,
    city: "Antwerp",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1698,
    density: 16.1,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 88.34,
      36089: 11.66,
    },
    county_names_all: "Jefferson|St. Lawrence",
    county_fips_all: "36045|36089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13611,
    lat: 43.77726,
    lng: -76.12374,
    city: "Belleville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13612,
    lat: 43.98571,
    lng: -75.76911,
    city: "Black River",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2233,
    density: 45.5,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13613,
    lat: 44.85884,
    lng: -74.73879,
    city: "Brasher Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2698,
    density: 12.8,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13614,
    lat: 44.53081,
    lng: -75.69194,
    city: "Brier Hill",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 355,
    density: 15.7,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Toronto",
  },
  {
    zip: 13615,
    lat: 44.00569,
    lng: -75.98328,
    city: "Brownville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 905,
    density: 547.3,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13616,
    lat: 44.02538,
    lng: -75.85896,
    city: "Calcium",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2202,
    density: 152.9,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13617,
    lat: 44.5789,
    lng: -75.14668,
    city: "Canton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11556,
    density: 33.7,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13618,
    lat: 44.11641,
    lng: -76.27851,
    city: "Cape Vincent",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1525,
    density: 12.1,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13619,
    lat: 43.97705,
    lng: -75.59432,
    city: "Carthage",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10439,
    density: 35.8,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 54.49,
      36049: 45.51,
    },
    county_names_all: "Jefferson|Lewis",
    county_fips_all: "36045|36049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13620,
    lat: 43.89989,
    lng: -75.45265,
    city: "Castorland",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2592,
    density: 26.9,
    county_fips: 36049,
    county_name: "Lewis",
    county_weights: {
      36049: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 36049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13621,
    lat: 44.8452,
    lng: -75.06596,
    city: "Chase Mills",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 494,
    density: 6.7,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13622,
    lat: 44.09654,
    lng: -76.115,
    city: "Chaumont",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2138,
    density: 15.6,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13623,
    lat: 44.44877,
    lng: -75.75299,
    city: "Chippewa Bay",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13,
    density: 11.3,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13624,
    lat: 44.22284,
    lng: -76.09736,
    city: "Clayton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5297,
    density: 32.3,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13625,
    lat: 44.5384,
    lng: -74.92135,
    city: "Colton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1470,
    density: 10.4,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13626,
    lat: 43.85143,
    lng: -75.7202,
    city: "Copenhagen",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2271,
    density: 10,
    county_fips: 36049,
    county_name: "Lewis",
    county_weights: {
      36045: 13.54,
      36049: 86.46,
    },
    county_names_all: "Lewis|Jefferson",
    county_fips_all: "36049|36045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13628,
    lat: 44.03764,
    lng: -75.68307,
    city: "Deferiet",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 211,
    density: 408.4,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13630,
    lat: 44.49742,
    lng: -75.31756,
    city: "De Kalb Junction",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1515,
    density: 12.8,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13632,
    lat: 44.12698,
    lng: -76.06826,
    city: "Depauville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13633,
    lat: 44.48259,
    lng: -75.48825,
    city: "De Peyster",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 249,
    density: 5.2,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13634,
    lat: 44.01197,
    lng: -76.07034,
    city: "Dexter",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3706,
    density: 29.6,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13635,
    lat: 44.29915,
    lng: -75.26188,
    city: "Edwards",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1108,
    density: 9.2,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13636,
    lat: 43.74107,
    lng: -76.12762,
    city: "Ellisburg",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 237,
    density: 27,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13637,
    lat: 44.09751,
    lng: -75.83346,
    city: "Evans Mills",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3720,
    density: 40.8,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13638,
    lat: 44.02077,
    lng: -75.75443,
    city: "Felts Mills",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 401,
    density: 191.9,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13639,
    lat: 44.2594,
    lng: -75.14324,
    city: "Fine",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 172,
    density: 19.7,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13640,
    lat: 44.3198,
    lng: -75.99937,
    city: "Wellesley Island",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 272,
    density: 8.5,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13641,
    lat: 44.27341,
    lng: -76.00573,
    city: "Fishers Landing",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38,
    density: 35.8,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13642,
    lat: 44.3263,
    lng: -75.46742,
    city: "Gouverneur",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10055,
    density: 20.5,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36045: 8.15,
      36089: 91.85,
    },
    county_names_all: "St. Lawrence|Jefferson",
    county_fips_all: "36089|36045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13643,
    lat: 44.03207,
    lng: -75.71738,
    city: "Great Bend",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30,
    density: 267.3,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13645,
    lat: 44.30878,
    lng: -75.44655,
    city: "Hailesboro",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13646,
    lat: 44.44144,
    lng: -75.69379,
    city: "Hammond",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1879,
    density: 6.9,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36045: 0.92,
      36089: 99.08,
    },
    county_names_all: "St. Lawrence|Jefferson",
    county_fips_all: "36089|36045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13647,
    lat: 44.6017,
    lng: -74.99264,
    city: "Hannawa Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13648,
    lat: 44.14977,
    lng: -75.29908,
    city: "Harrisville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2056,
    density: 4.6,
    county_fips: 36049,
    county_name: "Lewis",
    county_weights: {
      36049: 57.82,
      36089: 42.18,
    },
    county_names_all: "Lewis|St. Lawrence",
    county_fips_all: "36049|36089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13649,
    lat: 44.91246,
    lng: -74.69983,
    city: "Helena",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13650,
    lat: 43.80742,
    lng: -76.20629,
    city: "Henderson",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1559,
    density: 14.6,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13651,
    lat: 43.86513,
    lng: -76.18125,
    city: "Henderson Harbor",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 112,
    density: 20.3,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13652,
    lat: 44.43579,
    lng: -75.21338,
    city: "Hermon",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1544,
    density: 8.1,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13654,
    lat: 44.56654,
    lng: -75.46067,
    city: "Heuvelton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2603,
    density: 15.2,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13655,
    lat: 44.97865,
    lng: -74.64781,
    city: "Hogansburg",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3418,
    density: 67.6,
    county_fips: 36033,
    county_name: "Franklin",
    county_weights: {
      36033: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 36033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13656,
    lat: 44.19141,
    lng: -75.95058,
    city: "La Fargeville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2834,
    density: 12.6,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13658,
    lat: 44.73979,
    lng: -75.27756,
    city: "Lisbon",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2414,
    density: 11.7,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13659,
    lat: 43.73783,
    lng: -75.8707,
    city: "Lorraine",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 382,
    density: 2.6,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13660,
    lat: 44.77727,
    lng: -75.15764,
    city: "Madrid",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1641,
    density: 10.8,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13661,
    lat: 43.70924,
    lng: -76.1054,
    city: "Mannsville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1609,
    density: 13.7,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 89.5,
      36075: 10.5,
    },
    county_names_all: "Jefferson|Oswego",
    county_fips_all: "36045|36075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13662,
    lat: 44.9378,
    lng: -74.89383,
    city: "Massena",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16179,
    density: 70,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13664,
    lat: 44.58423,
    lng: -75.64537,
    city: "Morristown",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 348,
    density: 137.8,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Toronto",
  },
  {
    zip: 13665,
    lat: 44.05227,
    lng: -75.44933,
    city: "Natural Bridge",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 626,
    density: 6.7,
    county_fips: 36049,
    county_name: "Lewis",
    county_weights: {
      36045: 18.7,
      36049: 81.3,
    },
    county_names_all: "Lewis|Jefferson",
    county_fips_all: "36049|36045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13666,
    lat: 44.21404,
    lng: -74.95557,
    city: "Newton Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 240,
    density: 2.3,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13667,
    lat: 44.83768,
    lng: -74.96149,
    city: "Norfolk",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2781,
    density: 22.9,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13668,
    lat: 44.75432,
    lng: -74.98764,
    city: "Norwood",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3196,
    density: 33.6,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13669,
    lat: 44.65004,
    lng: -75.49861,
    city: "Ogdensburg",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15870,
    density: 60.4,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13670,
    lat: 44.18264,
    lng: -75.11635,
    city: "Oswegatchie",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 476,
    density: 2.3,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36049: 0.13,
      36089: 99.87,
    },
    county_names_all: "St. Lawrence|Lewis",
    county_fips_all: "36089|36049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13672,
    lat: 44.48166,
    lng: -74.67987,
    city: "Parishville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 439,
    density: 1.2,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13673,
    lat: 44.17105,
    lng: -75.72133,
    city: "Philadelphia",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2231,
    density: 21.1,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13674,
    lat: 43.73763,
    lng: -76.05192,
    city: "Pierrepont Manor",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 191,
    density: 1407.8,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13675,
    lat: 44.28227,
    lng: -75.83872,
    city: "Plessis",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 250,
    density: 64.5,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13676,
    lat: 44.65178,
    lng: -74.91377,
    city: "Potsdam",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16754,
    density: 40.5,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13678,
    lat: 44.83165,
    lng: -74.96775,
    city: "Raymondville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 330,
    density: 57.9,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13679,
    lat: 44.32664,
    lng: -75.76554,
    city: "Redwood",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1686,
    density: 10.7,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 76.09,
      36089: 23.91,
    },
    county_names_all: "Jefferson|St. Lawrence",
    county_fips_all: "36045|36089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13680,
    lat: 44.59416,
    lng: -75.32814,
    city: "Rensselaer Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1643,
    density: 16.5,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13681,
    lat: 44.42933,
    lng: -75.37142,
    city: "Richville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1149,
    density: 13,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13682,
    lat: 43.84024,
    lng: -75.88924,
    city: "Rodman",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 654,
    density: 7.3,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 92.46,
      36049: 7.54,
    },
    county_names_all: "Jefferson|Lewis",
    county_fips_all: "36045|36049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13683,
    lat: 44.97395,
    lng: -74.73543,
    city: "Rooseveltown",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13684,
    lat: 44.36577,
    lng: -75.0464,
    city: "Russell",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 842,
    density: 2,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13685,
    lat: 43.93343,
    lng: -76.09399,
    city: "Sackets Harbor",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2238,
    density: 60.4,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13687,
    lat: 44.44744,
    lng: -74.82516,
    city: "South Colton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 458,
    density: 2.3,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13690,
    lat: 44.12612,
    lng: -75.02319,
    city: "Star Lake",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 569,
    density: 4,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13691,
    lat: 44.22747,
    lng: -75.78208,
    city: "Theresa",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3016,
    density: 16.4,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 98.51,
      36089: 1.49,
    },
    county_names_all: "Jefferson|St. Lawrence",
    county_fips_all: "36045|36089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13692,
    lat: 44.28861,
    lng: -76.0258,
    city: "Thousand Island Park",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 155,
    density: 204.3,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13693,
    lat: 44.03237,
    lng: -76.24824,
    city: "Three Mile Bay",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 408,
    density: 7.6,
    county_fips: 36045,
    county_name: "Jefferson",
    county_weights: {
      36045: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 36045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13694,
    lat: 44.8575,
    lng: -75.1645,
    city: "Waddington",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1328,
    density: 28.3,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13695,
    lat: 44.10505,
    lng: -74.92872,
    city: "Wanakena",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 152,
    density: 2.8,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13696,
    lat: 44.70425,
    lng: -74.88971,
    city: "West Stockholm",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 87,
    density: 11.9,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13697,
    lat: 44.74841,
    lng: -74.80656,
    city: "Winthrop",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1776,
    density: 10.6,
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13699,
    lat: 44.66372,
    lng: -74.99851,
    city: "Potsdam",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36089,
    county_name: "St. Lawrence",
    county_weights: {
      36089: 100,
    },
    county_names_all: "St. Lawrence",
    county_fips_all: 36089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13730,
    lat: 42.23201,
    lng: -75.53127,
    city: "Afton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2630,
    density: 19.8,
    county_fips: 36017,
    county_name: "Chenango",
    county_weights: {
      36007: 12.79,
      36017: 87.21,
    },
    county_names_all: "Chenango|Broome",
    county_fips_all: "36017|36007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13731,
    lat: 42.13059,
    lng: -74.7882,
    city: "Andes",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 946,
    density: 4.1,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 36025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13732,
    lat: 42.04396,
    lng: -76.16772,
    city: "Apalachin",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7602,
    density: 89.2,
    county_fips: 36107,
    county_name: "Tioga",
    county_weights: {
      36107: 100,
    },
    county_names_all: "Tioga",
    county_fips_all: 36107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13733,
    lat: 42.30459,
    lng: -75.4793,
    city: "Bainbridge",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5112,
    density: 22.4,
    county_fips: 36017,
    county_name: "Chenango",
    county_weights: {
      36017: 88.53,
      36025: 9.23,
      36077: 2.24,
    },
    county_names_all: "Chenango|Delaware|Otsego",
    county_fips_all: "36017|36025|36077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13734,
    lat: 42.07752,
    lng: -76.40864,
    city: "Barton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1828,
    density: 17.7,
    county_fips: 36107,
    county_name: "Tioga",
    county_weights: {
      36107: 100,
    },
    county_names_all: "Tioga",
    county_fips_all: 36107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13736,
    lat: 42.31722,
    lng: -76.19389,
    city: "Berkshire",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2086,
    density: 13.2,
    county_fips: 36107,
    county_name: "Tioga",
    county_weights: {
      36007: 4.42,
      36107: 75.4,
      36109: 20.18,
    },
    county_names_all: "Tioga|Tompkins|Broome",
    county_fips_all: "36107|36109|36007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13738,
    lat: 42.56236,
    lng: -76.11986,
    city: "Blodgett Mills",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36023,
    county_name: "Cortland",
    county_weights: {
      36023: 100,
    },
    county_names_all: "Cortland",
    county_fips_all: 36023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13739,
    lat: 42.36614,
    lng: -74.78982,
    city: "Bloomville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 783,
    density: 7.7,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 36025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13740,
    lat: 42.27535,
    lng: -74.74498,
    city: "Bovina Center",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 483,
    density: 5.2,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 36025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13743,
    lat: 42.21706,
    lng: -76.33898,
    city: "Candor",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3630,
    density: 23.2,
    county_fips: 36107,
    county_name: "Tioga",
    county_weights: {
      36107: 100,
    },
    county_names_all: "Tioga",
    county_fips_all: 36107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13744,
    lat: 42.24078,
    lng: -75.90629,
    city: "Castle Creek",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1307,
    density: 49.7,
    county_fips: 36007,
    county_name: "Broome",
    county_weights: {
      36007: 100,
    },
    county_names_all: "Broome",
    county_fips_all: 36007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13746,
    lat: 42.26868,
    lng: -75.82085,
    city: "Chenango Forks",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1578,
    density: 18.2,
    county_fips: 36007,
    county_name: "Broome",
    county_weights: {
      36007: 60.84,
      36017: 39.16,
    },
    county_names_all: "Broome|Chenango",
    county_fips_all: "36007|36017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13747,
    lat: 42.49003,
    lng: -74.98209,
    city: "Colliersville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36077: 100,
    },
    county_names_all: "Otsego",
    county_fips_all: 36077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13748,
    lat: 42.03428,
    lng: -75.81727,
    city: "Conklin",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3766,
    density: 107.7,
    county_fips: 36007,
    county_name: "Broome",
    county_weights: {
      36007: 100,
    },
    county_names_all: "Broome",
    county_fips_all: 36007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13750,
    lat: 42.47739,
    lng: -74.83904,
    city: "Davenport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 788,
    density: 12.8,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 90.69,
      36077: 9.31,
    },
    county_names_all: "Delaware|Otsego",
    county_fips_all: "36025|36077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13751,
    lat: 42.45745,
    lng: -74.88363,
    city: "Davenport Center",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 189,
    density: 22.3,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 36025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13752,
    lat: 42.17257,
    lng: -74.90379,
    city: "Delancey",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 886,
    density: 6.3,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 36025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13753,
    lat: 42.30873,
    lng: -74.92538,
    city: "Delhi",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5511,
    density: 21.7,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 36025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13754,
    lat: 42.09387,
    lng: -75.43625,
    city: "Deposit",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2883,
    density: 14.3,
    county_fips: 36007,
    county_name: "Broome",
    county_weights: {
      36007: 64.66,
      36025: 35.34,
    },
    county_names_all: "Broome|Delaware",
    county_fips_all: "36007|36025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13755,
    lat: 42.05976,
    lng: -75.01524,
    city: "Downsville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 982,
    density: 7.3,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 36025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13756,
    lat: 42.01025,
    lng: -75.10394,
    city: "East Branch",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 431,
    density: 3.7,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 36025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13757,
    lat: 42.40915,
    lng: -74.89321,
    city: "East Meredith",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1396,
    density: 15.1,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 36025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13760,
    lat: 42.13425,
    lng: -76.08354,
    city: "Endicott",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42103,
    density: 329.7,
    county_fips: 36007,
    county_name: "Broome",
    county_weights: {
      36007: 71.75,
      36107: 28.25,
    },
    county_names_all: "Broome|Tioga",
    county_fips_all: "36007|36107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13774,
    lat: 41.96192,
    lng: -75.17283,
    city: "Fishs Eddy",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 198,
    density: 12.6,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 36025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13775,
    lat: 42.33706,
    lng: -75.14728,
    city: "Franklin",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1780,
    density: 14.1,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 98.26,
      36077: 1.74,
    },
    county_names_all: "Delaware|Otsego",
    county_fips_all: "36025|36077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13776,
    lat: 42.47023,
    lng: -75.33458,
    city: "Gilbertsville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 507,
    density: 31.1,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36077: 100,
    },
    county_names_all: "Otsego",
    county_fips_all: 36077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13777,
    lat: 42.25894,
    lng: -75.9866,
    city: "Glen Aubrey",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 433,
    density: 22,
    county_fips: 36007,
    county_name: "Broome",
    county_weights: {
      36007: 100,
    },
    county_names_all: "Broome",
    county_fips_all: 36007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13778,
    lat: 42.34795,
    lng: -75.75977,
    city: "Greene",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5458,
    density: 22.1,
    county_fips: 36017,
    county_name: "Chenango",
    county_weights: {
      36007: 6.68,
      36017: 93.32,
    },
    county_names_all: "Chenango|Broome",
    county_fips_all: "36017|36007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13780,
    lat: 42.42496,
    lng: -75.48128,
    city: "Guilford",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 708,
    density: 12,
    county_fips: 36017,
    county_name: "Chenango",
    county_weights: {
      36017: 100,
    },
    county_names_all: "Chenango",
    county_fips_all: 36017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13782,
    lat: 42.17304,
    lng: -74.9836,
    city: "Hamden",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 824,
    density: 8.9,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 36025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13783,
    lat: 41.99037,
    lng: -75.26764,
    city: "Hancock",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2659,
    density: 9.1,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36007: 0.49,
      36025: 99.51,
    },
    county_names_all: "Delaware|Broome",
    county_fips_all: "36025|36007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13784,
    lat: 42.43542,
    lng: -76.2177,
    city: "Harford",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 215,
    density: 80.6,
    county_fips: 36023,
    county_name: "Cortland",
    county_weights: {
      36023: 100,
    },
    county_names_all: "Cortland",
    county_fips_all: 36023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13786,
    lat: 42.4485,
    lng: -74.69563,
    city: "Harpersfield",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 464,
    density: 23.1,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 36025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13787,
    lat: 42.20606,
    lng: -75.66334,
    city: "Harpursville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3039,
    density: 19.3,
    county_fips: 36007,
    county_name: "Broome",
    county_weights: {
      36007: 66.79,
      36017: 33.21,
    },
    county_names_all: "Broome|Chenango",
    county_fips_all: "36007|36017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13788,
    lat: 42.34914,
    lng: -74.65658,
    city: "Hobart",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 899,
    density: 10,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 36025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13790,
    lat: 42.16937,
    lng: -75.99796,
    city: "Johnson City",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17763,
    density: 252.2,
    county_fips: 36007,
    county_name: "Broome",
    county_weights: {
      36007: 100,
    },
    county_names_all: "Broome",
    county_fips_all: 36007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13795,
    lat: 42.05844,
    lng: -75.77419,
    city: "Kirkwood",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3093,
    density: 50,
    county_fips: 36007,
    county_name: "Broome",
    county_weights: {
      36007: 100,
    },
    county_names_all: "Broome",
    county_fips_all: 36007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13796,
    lat: 42.5513,
    lng: -75.13644,
    city: "Laurens",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1063,
    density: 16.8,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36077: 100,
    },
    county_names_all: "Otsego",
    county_fips_all: 36077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13797,
    lat: 42.32765,
    lng: -76.04389,
    city: "Lisle",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2262,
    density: 26,
    county_fips: 36007,
    county_name: "Broome",
    county_weights: {
      36007: 100,
    },
    county_names_all: "Broome",
    county_fips_all: 36007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13801,
    lat: 42.50327,
    lng: -75.78028,
    city: "McDonough",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1457,
    density: 8.8,
    county_fips: 36017,
    county_name: "Chenango",
    county_weights: {
      36017: 100,
    },
    county_names_all: "Chenango",
    county_fips_all: 36017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13802,
    lat: 42.25164,
    lng: -76.04207,
    city: "Maine",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 964,
    density: 34.7,
    county_fips: 36007,
    county_name: "Broome",
    county_weights: {
      36007: 100,
    },
    county_names_all: "Broome",
    county_fips_all: 36007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13803,
    lat: 42.45787,
    lng: -76.06028,
    city: "Marathon",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4131,
    density: 17.1,
    county_fips: 36023,
    county_name: "Cortland",
    county_weights: {
      36007: 9.93,
      36023: 90.07,
    },
    county_names_all: "Cortland|Broome",
    county_fips_all: "36023|36007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13804,
    lat: 42.20708,
    lng: -75.37562,
    city: "Masonville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 332,
    density: 12.2,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 36025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13806,
    lat: 42.37894,
    lng: -74.97315,
    city: "Meridale",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 224,
    density: 21.9,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 36025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13807,
    lat: 42.61718,
    lng: -74.98612,
    city: "Milford",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1214,
    density: 21.8,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36077: 100,
    },
    county_names_all: "Otsego",
    county_fips_all: 36077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13808,
    lat: 42.52797,
    lng: -75.25657,
    city: "Morris",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1524,
    density: 16,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36077: 100,
    },
    county_names_all: "Otsego",
    county_fips_all: 36077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13809,
    lat: 42.40849,
    lng: -75.3914,
    city: "Mount Upton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1761,
    density: 20.2,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36017: 46.96,
      36077: 53.04,
    },
    county_names_all: "Otsego|Chenango",
    county_fips_all: "36077|36017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13810,
    lat: 42.61188,
    lng: -75.11157,
    city: "Mount Vision",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1362,
    density: 13.8,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36077: 100,
    },
    county_names_all: "Otsego",
    county_fips_all: 36077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13811,
    lat: 42.23099,
    lng: -76.17481,
    city: "Newark Valley",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3988,
    density: 24.7,
    county_fips: 36107,
    county_name: "Tioga",
    county_weights: {
      36007: 9,
      36107: 91,
    },
    county_names_all: "Tioga|Broome",
    county_fips_all: "36107|36007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13812,
    lat: 42.02993,
    lng: -76.35461,
    city: "Nichols",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2258,
    density: 27.8,
    county_fips: 36107,
    county_name: "Tioga",
    county_weights: {
      36107: 100,
    },
    county_names_all: "Tioga",
    county_fips_all: 36107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13813,
    lat: 42.16808,
    lng: -75.54266,
    city: "Nineveh",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1368,
    density: 18.3,
    county_fips: 36007,
    county_name: "Broome",
    county_weights: {
      36007: 90.09,
      36017: 9.91,
    },
    county_names_all: "Broome|Chenango",
    county_fips_all: "36007|36017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13814,
    lat: 42.61655,
    lng: -75.52584,
    city: "North Norwich",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36017,
    county_name: "Chenango",
    county_weights: {
      36017: 100,
    },
    county_names_all: "Chenango",
    county_fips_all: 36017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13815,
    lat: 42.54712,
    lng: -75.53413,
    city: "Norwich",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12901,
    density: 46,
    county_fips: 36017,
    county_name: "Chenango",
    county_weights: {
      36017: 100,
    },
    county_names_all: "Chenango",
    county_fips_all: 36017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13820,
    lat: 42.47204,
    lng: -75.03893,
    city: "Oneonta",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22157,
    density: 79.7,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36025: 29.56,
      36077: 70.44,
    },
    county_names_all: "Otsego|Delaware",
    county_fips_all: "36077|36025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13825,
    lat: 42.44329,
    lng: -75.20154,
    city: "Otego",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2888,
    density: 19.7,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36025: 1.7,
      36077: 98.3,
    },
    county_names_all: "Otsego|Delaware",
    county_fips_all: "36077|36025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13826,
    lat: 42.10517,
    lng: -75.63701,
    city: "Ouaquaga",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36007,
    county_name: "Broome",
    county_weights: {
      36007: 100,
    },
    county_names_all: "Broome",
    county_fips_all: 36007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13827,
    lat: 42.11178,
    lng: -76.25216,
    city: "Owego",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11538,
    density: 49.1,
    county_fips: 36107,
    county_name: "Tioga",
    county_weights: {
      36107: 100,
    },
    county_names_all: "Tioga",
    county_fips_all: 36107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13830,
    lat: 42.43868,
    lng: -75.6295,
    city: "Oxford",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5119,
    density: 18.1,
    county_fips: 36017,
    county_name: "Chenango",
    county_weights: {
      36017: 100,
    },
    county_names_all: "Chenango",
    county_fips_all: 36017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13832,
    lat: 42.6531,
    lng: -75.66286,
    city: "Plymouth",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 563,
    density: 10.6,
    county_fips: 36017,
    county_name: "Chenango",
    county_weights: {
      36017: 100,
    },
    county_names_all: "Chenango",
    county_fips_all: 36017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13833,
    lat: 42.19829,
    lng: -75.76432,
    city: "Port Crane",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3890,
    density: 40.8,
    county_fips: 36007,
    county_name: "Broome",
    county_weights: {
      36007: 100,
    },
    county_names_all: "Broome",
    county_fips_all: 36007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13834,
    lat: 42.54903,
    lng: -74.96727,
    city: "Portlandville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36077: 100,
    },
    county_names_all: "Otsego",
    county_fips_all: 36077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13835,
    lat: 42.38906,
    lng: -76.16939,
    city: "Richford",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1310,
    density: 11.5,
    county_fips: 36107,
    county_name: "Tioga",
    county_weights: {
      36007: 25.85,
      36023: 15.07,
      36107: 59.08,
    },
    county_names_all: "Tioga|Broome|Cortland",
    county_fips_all: "36107|36007|36023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13838,
    lat: 42.28423,
    lng: -75.39595,
    city: "Sidney",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3873,
    density: 173.4,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 95.63,
      36077: 4.37,
    },
    county_names_all: "Delaware|Otsego",
    county_fips_all: "36025|36077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13839,
    lat: 42.24824,
    lng: -75.26007,
    city: "Sidney Center",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1251,
    density: 9.5,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 36025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13841,
    lat: 42.41408,
    lng: -75.84171,
    city: "Smithville Flats",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 561,
    density: 23.5,
    county_fips: 36017,
    county_name: "Chenango",
    county_weights: {
      36007: 4.04,
      36017: 80.47,
      36023: 15.49,
    },
    county_names_all: "Chenango|Cortland|Broome",
    county_fips_all: "36017|36023|36007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13842,
    lat: 42.37922,
    lng: -74.72302,
    city: "South Kortright",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 627,
    density: 17.6,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 36025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13843,
    lat: 42.53468,
    lng: -75.37584,
    city: "South New Berlin",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2241,
    density: 16.6,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36017: 49.62,
      36077: 50.38,
    },
    county_names_all: "Otsego|Chenango",
    county_fips_all: "36077|36017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13844,
    lat: 42.60927,
    lng: -75.68083,
    city: "South Plymouth",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 674,
    density: 9.2,
    county_fips: 36017,
    county_name: "Chenango",
    county_weights: {
      36017: 100,
    },
    county_names_all: "Chenango",
    county_fips_all: 36017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13846,
    lat: 42.36037,
    lng: -75.05465,
    city: "Treadwell",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 475,
    density: 26.8,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 36025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13847,
    lat: 42.20443,
    lng: -75.27777,
    city: "Trout Creek",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58,
    density: 567.9,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 36025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13849,
    lat: 42.33785,
    lng: -75.31392,
    city: "Unadilla",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4449,
    density: 23.8,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36025: 46,
      36077: 54,
    },
    county_names_all: "Otsego|Delaware",
    county_fips_all: "36077|36025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13850,
    lat: 42.04873,
    lng: -76.02663,
    city: "Vestal",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22392,
    density: 169.3,
    county_fips: 36007,
    county_name: "Broome",
    county_weights: {
      36007: 100,
    },
    county_names_all: "Broome",
    county_fips_all: 36007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13856,
    lat: 42.16666,
    lng: -75.16633,
    city: "Walton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5999,
    density: 12.9,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 36025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13859,
    lat: 42.37123,
    lng: -75.24916,
    city: "Wells Bridge",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 99,
    density: 77.4,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36077: 100,
    },
    county_names_all: "Otsego",
    county_fips_all: 36077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13860,
    lat: 42.45573,
    lng: -74.94989,
    city: "West Davenport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22,
    density: 2.5,
    county_fips: 36025,
    county_name: "Delaware",
    county_weights: {
      36025: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 36025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13861,
    lat: 42.5048,
    lng: -75.14156,
    city: "West Oneonta",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 379,
    density: 38.6,
    county_fips: 36077,
    county_name: "Otsego",
    county_weights: {
      36077: 100,
    },
    county_names_all: "Otsego",
    county_fips_all: 36077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13862,
    lat: 42.3369,
    lng: -75.9372,
    city: "Whitney Point",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4053,
    density: 30.4,
    county_fips: 36007,
    county_name: "Broome",
    county_weights: {
      36007: 98.8,
      36023: 1.2,
    },
    county_names_all: "Broome|Cortland",
    county_fips_all: "36007|36023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13863,
    lat: 42.44164,
    lng: -75.904,
    city: "Willet",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 681,
    density: 21.3,
    county_fips: 36023,
    county_name: "Cortland",
    county_weights: {
      36007: 1.25,
      36023: 98.75,
    },
    county_names_all: "Cortland|Broome",
    county_fips_all: "36023|36007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13864,
    lat: 42.29095,
    lng: -76.39225,
    city: "Willseyville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1181,
    density: 17.7,
    county_fips: 36107,
    county_name: "Tioga",
    county_weights: {
      36107: 75.71,
      36109: 24.29,
    },
    county_names_all: "Tioga|Tompkins",
    county_fips_all: "36107|36109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13865,
    lat: 42.06282,
    lng: -75.62879,
    city: "Windsor",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6203,
    density: 22.3,
    county_fips: 36007,
    county_name: "Broome",
    county_weights: {
      36007: 100,
    },
    county_names_all: "Broome",
    county_fips_all: 36007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13901,
    lat: 42.18253,
    lng: -75.88048,
    city: "Binghamton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18786,
    density: 315.4,
    county_fips: 36007,
    county_name: "Broome",
    county_weights: {
      36007: 100,
    },
    county_names_all: "Broome",
    county_fips_all: 36007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13902,
    lat: 42.08895,
    lng: -75.96891,
    city: "Binghamton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6162,
    density: 3341.2,
    county_fips: 36007,
    county_name: "Broome",
    county_weights: {
      36007: 100,
    },
    county_names_all: "Broome",
    county_fips_all: 36007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13903,
    lat: 42.04749,
    lng: -75.89573,
    city: "Binghamton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17905,
    density: 175.2,
    county_fips: 36007,
    county_name: "Broome",
    county_weights: {
      36007: 100,
    },
    county_names_all: "Broome",
    county_fips_all: 36007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13904,
    lat: 42.13072,
    lng: -75.81587,
    city: "Binghamton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9789,
    density: 159.2,
    county_fips: 36007,
    county_name: "Broome",
    county_weights: {
      36007: 100,
    },
    county_names_all: "Broome",
    county_fips_all: 36007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13905,
    lat: 42.18086,
    lng: -75.94476,
    city: "Binghamton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26151,
    density: 357.5,
    county_fips: 36007,
    county_name: "Broome",
    county_weights: {
      36007: 100,
    },
    county_names_all: "Broome",
    county_fips_all: 36007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14001,
    lat: 43.03149,
    lng: -78.51154,
    city: "Akron",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9324,
    density: 55.8,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 78.7,
      36037: 8.27,
      36063: 13.03,
    },
    county_names_all: "Erie|Niagara|Genesee",
    county_fips_all: "36029|36063|36037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14004,
    lat: 42.89487,
    lng: -78.51008,
    city: "Alden",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12240,
    density: 97.2,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 82.3,
      36037: 5.09,
      36121: 12.61,
    },
    county_names_all: "Erie|Wyoming|Genesee",
    county_fips_all: "36029|36121|36037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14005,
    lat: 42.91788,
    lng: -78.24703,
    city: "Alexander",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2312,
    density: 27.9,
    county_fips: 36037,
    county_name: "Genesee",
    county_weights: {
      36037: 100,
    },
    county_names_all: "Genesee",
    county_fips_all: 36037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14006,
    lat: 42.63366,
    lng: -79.02056,
    city: "Angola",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9823,
    density: 134.9,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14008,
    lat: 43.30792,
    lng: -78.62728,
    city: "Appleton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1547,
    density: 24.1,
    county_fips: 36063,
    county_name: "Niagara",
    county_weights: {
      36063: 100,
    },
    county_names_all: "Niagara",
    county_fips_all: 36063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14009,
    lat: 42.57542,
    lng: -78.39241,
    city: "Arcade",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5625,
    density: 29.7,
    county_fips: 36121,
    county_name: "Wyoming",
    county_weights: {
      36009: 10.2,
      36121: 89.8,
    },
    county_names_all: "Wyoming|Cattaraugus",
    county_fips_all: "36121|36009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14011,
    lat: 42.83158,
    lng: -78.29784,
    city: "Attica",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8864,
    density: 50.2,
    county_fips: 36121,
    county_name: "Wyoming",
    county_weights: {
      36037: 10.22,
      36121: 89.78,
    },
    county_names_all: "Wyoming|Genesee",
    county_fips_all: "36121|36037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14012,
    lat: 43.33431,
    lng: -78.52572,
    city: "Barker",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2374,
    density: 27.3,
    county_fips: 36063,
    county_name: "Niagara",
    county_weights: {
      36063: 95.57,
      36073: 4.43,
    },
    county_names_all: "Niagara|Orleans",
    county_fips_all: "36063|36073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14013,
    lat: 43.07639,
    lng: -78.39704,
    city: "Basom",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1680,
    density: 18.8,
    county_fips: 36037,
    county_name: "Genesee",
    county_weights: {
      36029: 2.1,
      36037: 97.9,
    },
    county_names_all: "Genesee|Erie",
    county_fips_all: "36037|36029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14020,
    lat: 42.99513,
    lng: -78.21508,
    city: "Batavia",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22060,
    density: 128.5,
    county_fips: 36037,
    county_name: "Genesee",
    county_weights: {
      36037: 100,
    },
    county_names_all: "Genesee",
    county_fips_all: 36037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14024,
    lat: 42.58111,
    lng: -78.24431,
    city: "Bliss",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1408,
    density: 8.7,
    county_fips: 36121,
    county_name: "Wyoming",
    county_weights: {
      36003: 5.01,
      36121: 94.99,
    },
    county_names_all: "Wyoming|Allegany",
    county_fips_all: "36121|36003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14025,
    lat: 42.6232,
    lng: -78.72609,
    city: "Boston",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3784,
    density: 69.6,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14026,
    lat: 42.94212,
    lng: -78.68794,
    city: "Bowmansville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 568,
    density: 252,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14027,
    lat: 42.59408,
    lng: -79.02067,
    city: "Brant",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14028,
    lat: 43.31498,
    lng: -78.71664,
    city: "Burt",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1571,
    density: 43.7,
    county_fips: 36063,
    county_name: "Niagara",
    county_weights: {
      36063: 100,
    },
    county_names_all: "Niagara",
    county_fips_all: 36063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14029,
    lat: 42.47293,
    lng: -78.26346,
    city: "Centerville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36003,
    county_name: "Allegany",
    county_weights: {
      36003: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 36003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14030,
    lat: 42.56518,
    lng: -78.50052,
    city: "Chaffee",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1882,
    density: 34.4,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36009: 9.71,
      36029: 86.87,
      36121: 3.42,
    },
    county_names_all: "Erie|Cattaraugus|Wyoming",
    county_fips_all: "36029|36009|36121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14031,
    lat: 42.98661,
    lng: -78.60908,
    city: "Clarence",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10158,
    density: 202.6,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14032,
    lat: 43.04587,
    lng: -78.63189,
    city: "Clarence Center",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10084,
    density: 162.8,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14033,
    lat: 42.65865,
    lng: -78.68436,
    city: "Colden",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1344,
    density: 29.8,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14034,
    lat: 42.4985,
    lng: -78.86238,
    city: "Collins",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2428,
    density: 38.8,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14035,
    lat: 42.49099,
    lng: -78.85936,
    city: "Collins Center",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 127,
    density: 71.3,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14036,
    lat: 42.97447,
    lng: -78.38712,
    city: "Corfu",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5588,
    density: 40.2,
    county_fips: 36037,
    county_name: "Genesee",
    county_weights: {
      36037: 100,
    },
    county_names_all: "Genesee",
    county_fips_all: 36037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14037,
    lat: 42.80637,
    lng: -78.45448,
    city: "Cowlesville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 897,
    density: 19.5,
    county_fips: 36121,
    county_name: "Wyoming",
    county_weights: {
      36029: 11.09,
      36121: 88.91,
    },
    county_names_all: "Wyoming|Erie",
    county_fips_all: "36121|36029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14039,
    lat: 42.83593,
    lng: -78.17101,
    city: "Dale",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57,
    density: 11,
    county_fips: 36121,
    county_name: "Wyoming",
    county_weights: {
      36121: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 36121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14040,
    lat: 42.88809,
    lng: -78.37847,
    city: "Darien Center",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1719,
    density: 22.1,
    county_fips: 36037,
    county_name: "Genesee",
    county_weights: {
      36037: 81.28,
      36121: 18.72,
    },
    county_names_all: "Genesee|Wyoming",
    county_fips_all: "36037|36121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14041,
    lat: 42.4059,
    lng: -78.97699,
    city: "Dayton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 180,
    density: 54.6,
    county_fips: 36009,
    county_name: "Cattaraugus",
    county_weights: {
      36009: 100,
    },
    county_names_all: "Cattaraugus",
    county_fips_all: 36009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14042,
    lat: 42.46882,
    lng: -78.48377,
    city: "Delevan",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4359,
    density: 36,
    county_fips: 36009,
    county_name: "Cattaraugus",
    county_weights: {
      36009: 100,
    },
    county_names_all: "Cattaraugus",
    county_fips_all: 36009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14043,
    lat: 42.90142,
    lng: -78.70431,
    city: "Depew",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25058,
    density: 1064.8,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14047,
    lat: 42.68579,
    lng: -78.99328,
    city: "Derby",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6525,
    density: 191.7,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14048,
    lat: 42.48087,
    lng: -79.31128,
    city: "Dunkirk",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14414,
    density: 242.3,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14051,
    lat: 43.04168,
    lng: -78.69927,
    city: "East Amherst",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19178,
    density: 477.8,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14052,
    lat: 42.77054,
    lng: -78.58084,
    city: "East Aurora",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17664,
    density: 111.4,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14054,
    lat: 42.90606,
    lng: -78.1312,
    city: "East Bethany",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1554,
    density: 21.2,
    county_fips: 36037,
    county_name: "Genesee",
    county_weights: {
      36037: 86.81,
      36121: 13.19,
    },
    county_names_all: "Genesee|Wyoming",
    county_fips_all: "36037|36121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14055,
    lat: 42.5536,
    lng: -78.60121,
    city: "East Concord",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1337,
    density: 16.5,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14056,
    lat: 42.99183,
    lng: -78.30663,
    city: "East Pembroke",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36037,
    county_name: "Genesee",
    county_weights: {
      36037: 100,
    },
    county_names_all: "Genesee",
    county_fips_all: 36037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14057,
    lat: 42.64587,
    lng: -78.87542,
    city: "Eden",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8192,
    density: 68.5,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14058,
    lat: 43.10167,
    lng: -78.16211,
    city: "Elba",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2160,
    density: 20.4,
    county_fips: 36037,
    county_name: "Genesee",
    county_weights: {
      36037: 82.25,
      36073: 17.75,
    },
    county_names_all: "Genesee|Orleans",
    county_fips_all: "36037|36073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14059,
    lat: 42.83241,
    lng: -78.63678,
    city: "Elma",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10446,
    density: 149.7,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14060,
    lat: 42.43986,
    lng: -78.30884,
    city: "Farmersville Station",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 478,
    density: 9.5,
    county_fips: 36003,
    county_name: "Allegany",
    county_weights: {
      36003: 54.97,
      36009: 45.03,
    },
    county_names_all: "Allegany|Cattaraugus",
    county_fips_all: "36003|36009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14061,
    lat: 42.59111,
    lng: -79.08949,
    city: "Farnham",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 345,
    density: 1277.4,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14062,
    lat: 42.44364,
    lng: -79.14897,
    city: "Forestville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3331,
    density: 18.2,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36009: 0.29,
      36013: 99.71,
    },
    county_names_all: "Chautauqua|Cattaraugus",
    county_fips_all: "36013|36009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14063,
    lat: 42.41451,
    lng: -79.32518,
    city: "Fredonia",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13891,
    density: 105.5,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14065,
    lat: 42.48741,
    lng: -78.31158,
    city: "Freedom",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1705,
    density: 18.1,
    county_fips: 36009,
    county_name: "Cattaraugus",
    county_weights: {
      36003: 43,
      36009: 57,
    },
    county_names_all: "Cattaraugus|Allegany",
    county_fips_all: "36009|36003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14066,
    lat: 42.62381,
    lng: -78.18051,
    city: "Gainesville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1188,
    density: 12.3,
    county_fips: 36121,
    county_name: "Wyoming",
    county_weights: {
      36121: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 36121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14067,
    lat: 43.21565,
    lng: -78.56644,
    city: "Gasport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4971,
    density: 38.9,
    county_fips: 36063,
    county_name: "Niagara",
    county_weights: {
      36063: 100,
    },
    county_names_all: "Niagara",
    county_fips_all: 36063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14068,
    lat: 43.02696,
    lng: -78.75808,
    city: "Getzville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7169,
    density: 749.9,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14069,
    lat: 42.59984,
    lng: -78.62984,
    city: "Glenwood",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 642,
    density: 32.7,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14070,
    lat: 42.43673,
    lng: -78.92798,
    city: "Gowanda",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6958,
    density: 52.9,
    county_fips: 36009,
    county_name: "Cattaraugus",
    county_weights: {
      36009: 57.85,
      36029: 42.15,
    },
    county_names_all: "Cattaraugus|Erie",
    county_fips_all: "36009|36029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14072,
    lat: 43.01673,
    lng: -78.96308,
    city: "Grand Island",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21287,
    density: 291.9,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Toronto",
  },
  {
    zip: 14075,
    lat: 42.71297,
    lng: -78.82985,
    city: "Hamburg",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42958,
    density: 420.6,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14080,
    lat: 42.64289,
    lng: -78.54886,
    city: "Holland",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4323,
    density: 31.8,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14081,
    lat: 42.56332,
    lng: -79.06528,
    city: "Irving",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2844,
    density: 34.3,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36009: 2.23,
      36013: 21.43,
      36029: 76.34,
    },
    county_names_all: "Erie|Chautauqua|Cattaraugus",
    county_fips_all: "36029|36013|36009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14082,
    lat: 42.65689,
    lng: -78.38435,
    city: "Java Center",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 498,
    density: 18.1,
    county_fips: 36121,
    county_name: "Wyoming",
    county_weights: {
      36121: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 36121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14083,
    lat: 42.67921,
    lng: -78.43446,
    city: "Java Village",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36121,
    county_name: "Wyoming",
    county_weights: {
      36121: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 36121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14085,
    lat: 42.71494,
    lng: -78.92691,
    city: "Lake View",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7605,
    density: 380.4,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14086,
    lat: 42.90661,
    lng: -78.6291,
    city: "Lancaster",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32653,
    density: 378,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14091,
    lat: 42.54224,
    lng: -78.88868,
    city: "Lawtons",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1422,
    density: 24.6,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14092,
    lat: 43.17314,
    lng: -78.99521,
    city: "Lewiston",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10819,
    density: 197,
    county_fips: 36063,
    county_name: "Niagara",
    county_weights: {
      36063: 100,
    },
    county_names_all: "Niagara",
    county_fips_all: 36063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14094,
    lat: 43.15989,
    lng: -78.70032,
    city: "Lockport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49792,
    density: 158,
    county_fips: 36063,
    county_name: "Niagara",
    county_weights: {
      36063: 100,
    },
    county_names_all: "Niagara",
    county_fips_all: 36063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14098,
    lat: 43.33464,
    lng: -78.37827,
    city: "Lyndonville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3028,
    density: 25.2,
    county_fips: 36073,
    county_name: "Orleans",
    county_weights: {
      36063: 1.89,
      36073: 98.11,
    },
    county_names_all: "Orleans|Niagara",
    county_fips_all: "36073|36063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14101,
    lat: 42.3863,
    lng: -78.54292,
    city: "Machias",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1718,
    density: 14.5,
    county_fips: 36009,
    county_name: "Cattaraugus",
    county_weights: {
      36009: 100,
    },
    county_names_all: "Cattaraugus",
    county_fips_all: 36009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14102,
    lat: 42.84272,
    lng: -78.55481,
    city: "Marilla",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1367,
    density: 156.9,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14103,
    lat: 43.2125,
    lng: -78.37696,
    city: "Medina",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10448,
    density: 51.1,
    county_fips: 36073,
    county_name: "Orleans",
    county_weights: {
      36073: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 36073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14105,
    lat: 43.19043,
    lng: -78.4813,
    city: "Middleport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4745,
    density: 35.5,
    county_fips: 36063,
    county_name: "Niagara",
    county_weights: {
      36037: 8.59,
      36063: 72.46,
      36073: 18.95,
    },
    county_names_all: "Niagara|Orleans|Genesee",
    county_fips_all: "36063|36073|36037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14108,
    lat: 43.26365,
    lng: -78.7274,
    city: "Newfane",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5196,
    density: 80.8,
    county_fips: 36063,
    county_name: "Niagara",
    county_weights: {
      36063: 100,
    },
    county_names_all: "Niagara",
    county_fips_all: 36063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14109,
    lat: 43.13718,
    lng: -79.03516,
    city: "Niagara University",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1089,
    density: 1821,
    county_fips: 36063,
    county_name: "Niagara",
    county_weights: {
      36063: 100,
    },
    county_names_all: "Niagara",
    county_fips_all: 36063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Toronto",
  },
  {
    zip: 14111,
    lat: 42.58206,
    lng: -78.89803,
    city: "North Collins",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3146,
    density: 34.2,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14112,
    lat: 42.6981,
    lng: -78.9395,
    city: "North Evans",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 118,
    density: 1285.5,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14113,
    lat: 42.66813,
    lng: -78.33624,
    city: "North Java",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 488,
    density: 8.7,
    county_fips: 36121,
    county_name: "Wyoming",
    county_weights: {
      36121: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 36121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14120,
    lat: 43.07337,
    lng: -78.83585,
    city: "North Tonawanda",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43738,
    density: 517.7,
    county_fips: 36063,
    county_name: "Niagara",
    county_weights: {
      36063: 100,
    },
    county_names_all: "Niagara",
    county_fips_all: 36063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14125,
    lat: 43.08773,
    lng: -78.28207,
    city: "Oakfield",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3514,
    density: 34.6,
    county_fips: 36037,
    county_name: "Genesee",
    county_weights: {
      36037: 98.64,
      36073: 1.36,
    },
    county_names_all: "Genesee|Orleans",
    county_fips_all: "36037|36073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14126,
    lat: 43.33529,
    lng: -78.72335,
    city: "Olcott",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 661,
    density: 384.6,
    county_fips: 36063,
    county_name: "Niagara",
    county_weights: {
      36063: 100,
    },
    county_names_all: "Niagara",
    county_fips_all: 36063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14127,
    lat: 42.75204,
    lng: -78.74402,
    city: "Orchard Park",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29964,
    density: 284.1,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14129,
    lat: 42.4805,
    lng: -79.0092,
    city: "Perrysburg",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1519,
    density: 19.1,
    county_fips: 36009,
    county_name: "Cattaraugus",
    county_weights: {
      36009: 100,
    },
    county_names_all: "Cattaraugus",
    county_fips_all: 36009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14130,
    lat: 42.55318,
    lng: -78.14959,
    city: "Pike",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 231,
    density: 293.5,
    county_fips: 36121,
    county_name: "Wyoming",
    county_weights: {
      36121: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 36121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14131,
    lat: 43.23556,
    lng: -78.89935,
    city: "Ransomville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5056,
    density: 46.6,
    county_fips: 36063,
    county_name: "Niagara",
    county_weights: {
      36063: 100,
    },
    county_names_all: "Niagara",
    county_fips_all: 36063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14132,
    lat: 43.14787,
    lng: -78.87856,
    city: "Sanborn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5999,
    density: 80.7,
    county_fips: 36063,
    county_name: "Niagara",
    county_weights: {
      36063: 100,
    },
    county_names_all: "Niagara",
    county_fips_all: 36063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14134,
    lat: 42.53057,
    lng: -78.51738,
    city: "Sardinia",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 99,
    density: 54.5,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36009: 0.9,
      36029: 99.1,
    },
    county_names_all: "Erie|Cattaraugus",
    county_fips_all: "36029|36009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14135,
    lat: 42.48489,
    lng: -79.2437,
    city: "Sheridan",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 95,
    density: 48.2,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14136,
    lat: 42.52387,
    lng: -79.16935,
    city: "Silver Creek",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4574,
    density: 72.7,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14138,
    lat: 42.37497,
    lng: -79.05376,
    city: "South Dayton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1786,
    density: 14.8,
    county_fips: 36009,
    county_name: "Cattaraugus",
    county_weights: {
      36009: 64.1,
      36013: 35.9,
    },
    county_names_all: "Cattaraugus|Chautauqua",
    county_fips_all: "36009|36013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14139,
    lat: 42.71723,
    lng: -78.53606,
    city: "South Wales",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2020,
    density: 31.4,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14141,
    lat: 42.52366,
    lng: -78.7109,
    city: "Springville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7534,
    density: 40.2,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36009: 16.94,
      36029: 83.06,
    },
    county_names_all: "Erie|Cattaraugus",
    county_fips_all: "36029|36009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14143,
    lat: 42.97547,
    lng: -78.0759,
    city: "Stafford",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 938,
    density: 23.4,
    county_fips: 36037,
    county_name: "Genesee",
    county_weights: {
      36037: 100,
    },
    county_names_all: "Genesee",
    county_fips_all: 36037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14145,
    lat: 42.73154,
    lng: -78.43205,
    city: "Strykersville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1456,
    density: 21.4,
    county_fips: 36121,
    county_name: "Wyoming",
    county_weights: {
      36029: 8.59,
      36121: 91.41,
    },
    county_names_all: "Wyoming|Erie",
    county_fips_all: "36121|36029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14150,
    lat: 42.99794,
    lng: -78.87815,
    city: "Tonawanda",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41144,
    density: 1068.6,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14166,
    lat: 42.45088,
    lng: -79.41592,
    city: "Van Buren Point",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14167,
    lat: 42.74327,
    lng: -78.32629,
    city: "Varysburg",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1788,
    density: 19.6,
    county_fips: 36121,
    county_name: "Wyoming",
    county_weights: {
      36121: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 36121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14168,
    lat: 42.51187,
    lng: -78.98745,
    city: "Versailles",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29,
    density: 35,
    county_fips: 36009,
    county_name: "Cattaraugus",
    county_weights: {
      36009: 100,
    },
    county_names_all: "Cattaraugus",
    county_fips_all: 36009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14169,
    lat: 42.76446,
    lng: -78.52938,
    city: "Wales Center",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14170,
    lat: 42.70115,
    lng: -78.67294,
    city: "West Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2350,
    density: 67.6,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14171,
    lat: 42.42491,
    lng: -78.64286,
    city: "West Valley",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2029,
    density: 15.7,
    county_fips: 36009,
    county_name: "Cattaraugus",
    county_weights: {
      36009: 100,
    },
    county_names_all: "Cattaraugus",
    county_fips_all: 36009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14172,
    lat: 43.28201,
    lng: -78.81757,
    city: "Wilson",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2781,
    density: 40.8,
    county_fips: 36063,
    county_name: "Niagara",
    county_weights: {
      36063: 100,
    },
    county_names_all: "Niagara",
    county_fips_all: 36063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14173,
    lat: 42.52594,
    lng: -78.47306,
    city: "Yorkshire",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 166,
    density: 111.1,
    county_fips: 36009,
    county_name: "Cattaraugus",
    county_weights: {
      36009: 99.54,
      36029: 0.1,
      36121: 0.36,
    },
    county_names_all: "Cattaraugus|Wyoming|Erie",
    county_fips_all: "36009|36121|36029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14174,
    lat: 43.24178,
    lng: -79.00548,
    city: "Youngstown",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5843,
    density: 97.1,
    county_fips: 36063,
    county_name: "Niagara",
    county_weights: {
      36063: 100,
    },
    county_names_all: "Niagara",
    county_fips_all: 36063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14201,
    lat: 42.89706,
    lng: -78.88752,
    city: "Buffalo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11192,
    density: 3923.3,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14202,
    lat: 42.88798,
    lng: -78.88358,
    city: "Buffalo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3749,
    density: 1663,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14203,
    lat: 42.86244,
    lng: -78.86507,
    city: "Buffalo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1819,
    density: 250.8,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14204,
    lat: 42.882,
    lng: -78.8614,
    city: "Buffalo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8003,
    density: 1725.3,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14206,
    lat: 42.88078,
    lng: -78.81018,
    city: "Buffalo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20064,
    density: 1562.7,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14207,
    lat: 42.95201,
    lng: -78.89824,
    city: "Buffalo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23773,
    density: 2350.2,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14208,
    lat: 42.9146,
    lng: -78.85146,
    city: "Buffalo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10346,
    density: 3440.8,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14209,
    lat: 42.91365,
    lng: -78.86622,
    city: "Buffalo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7807,
    density: 3166.3,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14210,
    lat: 42.86407,
    lng: -78.82811,
    city: "Buffalo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14148,
    density: 1736.4,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14211,
    lat: 42.90813,
    lng: -78.81883,
    city: "Buffalo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22206,
    density: 2177.3,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14212,
    lat: 42.89438,
    lng: -78.81957,
    city: "Buffalo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10973,
    density: 2009.6,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14213,
    lat: 42.91762,
    lng: -78.89099,
    city: "Buffalo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22132,
    density: 4460.1,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14214,
    lat: 42.93936,
    lng: -78.84101,
    city: "Buffalo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19754,
    density: 2291.3,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14215,
    lat: 42.93451,
    lng: -78.81023,
    city: "Buffalo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41340,
    density: 3350.8,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14216,
    lat: 42.94855,
    lng: -78.862,
    city: "Buffalo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21464,
    density: 3002.2,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14217,
    lat: 42.97189,
    lng: -78.87674,
    city: "Buffalo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23017,
    density: 2774.5,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14218,
    lat: 42.81921,
    lng: -78.82772,
    city: "Buffalo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18935,
    density: 902.3,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14219,
    lat: 42.78903,
    lng: -78.82694,
    city: "Buffalo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11391,
    density: 633.2,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14220,
    lat: 42.84571,
    lng: -78.82264,
    city: "Buffalo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22641,
    density: 2280.4,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14221,
    lat: 42.97918,
    lng: -78.72158,
    city: "Buffalo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53727,
    density: 886.9,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14222,
    lat: 42.92002,
    lng: -78.8771,
    city: "Buffalo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15103,
    density: 4671.1,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14223,
    lat: 42.97348,
    lng: -78.84612,
    city: "Buffalo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21734,
    density: 2426.9,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14224,
    lat: 42.83767,
    lng: -78.74771,
    city: "Buffalo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40903,
    density: 780.1,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14225,
    lat: 42.92879,
    lng: -78.752,
    city: "Buffalo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33360,
    density: 1121.6,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14226,
    lat: 42.97078,
    lng: -78.79844,
    city: "Buffalo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29920,
    density: 1676.5,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14227,
    lat: 42.88402,
    lng: -78.74665,
    city: "Buffalo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20540,
    density: 968.4,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14228,
    lat: 43.04214,
    lng: -78.7798,
    city: "Buffalo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23406,
    density: 567.4,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14260,
    lat: 43.00165,
    lng: -78.79066,
    city: "Buffalo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14261,
    lat: 43.00188,
    lng: -78.7848,
    city: "Buffalo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5557,
    density: 1944.4,
    county_fips: 36029,
    county_name: "Erie",
    county_weights: {
      36029: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 36029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14301,
    lat: 43.09701,
    lng: -79.03726,
    city: "Niagara Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11838,
    density: 2210.5,
    county_fips: 36063,
    county_name: "Niagara",
    county_weights: {
      36063: 100,
    },
    county_names_all: "Niagara",
    county_fips_all: 36063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Toronto",
  },
  {
    zip: 14302,
    lat: 43.0939,
    lng: -79.04919,
    city: "Niagara Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 255,
    density: 7084.9,
    county_fips: 36063,
    county_name: "Niagara",
    county_weights: {
      36063: 100,
    },
    county_names_all: "Niagara",
    county_fips_all: 36063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Toronto",
  },
  {
    zip: 14303,
    lat: 43.08428,
    lng: -79.03908,
    city: "Niagara Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5652,
    density: 804.3,
    county_fips: 36063,
    county_name: "Niagara",
    county_weights: {
      36063: 100,
    },
    county_names_all: "Niagara",
    county_fips_all: 36063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Toronto",
  },
  {
    zip: 14304,
    lat: 43.10197,
    lng: -78.95282,
    city: "Niagara Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29001,
    density: 519.8,
    county_fips: 36063,
    county_name: "Niagara",
    county_weights: {
      36063: 100,
    },
    county_names_all: "Niagara",
    county_fips_all: 36063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14305,
    lat: 43.1199,
    lng: -79.02265,
    city: "Niagara Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17026,
    density: 838.9,
    county_fips: 36063,
    county_name: "Niagara",
    county_weights: {
      36063: 100,
    },
    county_names_all: "Niagara",
    county_fips_all: 36063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Toronto",
  },
  {
    zip: 14411,
    lat: 43.23456,
    lng: -78.21349,
    city: "Albion",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13671,
    density: 46.8,
    county_fips: 36073,
    county_name: "Orleans",
    county_weights: {
      36073: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 36073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14413,
    lat: 43.2229,
    lng: -76.97067,
    city: "Alton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36117,
    county_name: "Wayne",
    county_weights: {
      36117: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 36117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14414,
    lat: 42.89358,
    lng: -77.73501,
    city: "Avon",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6797,
    density: 66.8,
    county_fips: 36051,
    county_name: "Livingston",
    county_weights: {
      36051: 98.95,
      36055: 1.05,
    },
    county_names_all: "Livingston|Monroe",
    county_fips_all: "36051|36055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14415,
    lat: 42.7559,
    lng: -77.01643,
    city: "Bellona",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 124,
    density: 28.9,
    county_fips: 36123,
    county_name: "Yates",
    county_weights: {
      36123: 100,
    },
    county_names_all: "Yates",
    county_fips_all: 36123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14416,
    lat: 43.08003,
    lng: -77.97849,
    city: "Bergen",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3611,
    density: 34.6,
    county_fips: 36037,
    county_name: "Genesee",
    county_weights: {
      36037: 87.2,
      36055: 12.8,
    },
    county_names_all: "Genesee|Monroe",
    county_fips_all: "36037|36055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14418,
    lat: 42.60717,
    lng: -77.21681,
    city: "Branchport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 932,
    density: 9.6,
    county_fips: 36123,
    county_name: "Yates",
    county_weights: {
      36101: 10.61,
      36123: 89.39,
    },
    county_names_all: "Yates|Steuben",
    county_fips_all: "36123|36101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14420,
    lat: 43.21385,
    lng: -77.93305,
    city: "Brockport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21124,
    density: 138.2,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 99.5,
      36073: 0.5,
    },
    county_names_all: "Monroe|Orleans",
    county_fips_all: "36055|36073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14422,
    lat: 43.08357,
    lng: -78.06704,
    city: "Byron",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2074,
    density: 24.1,
    county_fips: 36037,
    county_name: "Genesee",
    county_weights: {
      36037: 94.31,
      36073: 5.69,
    },
    county_names_all: "Genesee|Orleans",
    county_fips_all: "36037|36073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14423,
    lat: 42.94382,
    lng: -77.82788,
    city: "Caledonia",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4479,
    density: 35.8,
    county_fips: 36051,
    county_name: "Livingston",
    county_weights: {
      36051: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 36051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14424,
    lat: 42.84649,
    lng: -77.3104,
    city: "Canandaigua",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28055,
    density: 83.7,
    county_fips: 36069,
    county_name: "Ontario",
    county_weights: {
      36069: 100,
    },
    county_names_all: "Ontario",
    county_fips_all: 36069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14425,
    lat: 42.98962,
    lng: -77.33734,
    city: "Farmington",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12230,
    density: 241.4,
    county_fips: 36069,
    county_name: "Ontario",
    county_weights: {
      36069: 100,
    },
    county_names_all: "Ontario",
    county_fips_all: 36069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14427,
    lat: 42.61828,
    lng: -78.05442,
    city: "Castile",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2073,
    density: 23.8,
    county_fips: 36121,
    county_name: "Wyoming",
    county_weights: {
      36121: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 36121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14428,
    lat: 43.08029,
    lng: -77.85963,
    city: "Churchville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7278,
    density: 60.5,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14432,
    lat: 42.95696,
    lng: -77.14333,
    city: "Clifton Springs",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5277,
    density: 51.8,
    county_fips: 36069,
    county_name: "Ontario",
    county_weights: {
      36069: 100,
    },
    county_names_all: "Ontario",
    county_fips_all: 36069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14433,
    lat: 43.07939,
    lng: -76.87779,
    city: "Clyde",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3920,
    density: 22.7,
    county_fips: 36117,
    county_name: "Wayne",
    county_weights: {
      36099: 7.13,
      36117: 92.87,
    },
    county_names_all: "Wayne|Seneca",
    county_fips_all: "36117|36099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14435,
    lat: 42.71496,
    lng: -77.66721,
    city: "Conesus",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2327,
    density: 24.7,
    county_fips: 36051,
    county_name: "Livingston",
    county_weights: {
      36051: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 36051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14437,
    lat: 42.57072,
    lng: -77.73435,
    city: "Dansville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11274,
    density: 36.9,
    county_fips: 36051,
    county_name: "Livingston",
    county_weights: {
      36003: 0.18,
      36051: 83.83,
      36101: 15.99,
    },
    county_names_all: "Livingston|Steuben|Allegany",
    county_fips_all: "36051|36101|36003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14441,
    lat: 42.68608,
    lng: -76.95756,
    city: "Dresden",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 301,
    density: 295.8,
    county_fips: 36123,
    county_name: "Yates",
    county_weights: {
      36123: 100,
    },
    county_names_all: "Yates",
    county_fips_all: 36123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14445,
    lat: 43.11312,
    lng: -77.48978,
    city: "East Rochester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7761,
    density: 1535.8,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14450,
    lat: 43.0921,
    lng: -77.41623,
    city: "Fairport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42513,
    density: 512.4,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 97.83,
      36117: 2.17,
    },
    county_names_all: "Monroe|Wayne",
    county_fips_all: "36055|36117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14453,
    lat: 43.01602,
    lng: -77.47338,
    city: "Fishers",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36069,
    county_name: "Ontario",
    county_weights: {
      36069: 100,
    },
    county_names_all: "Ontario",
    county_fips_all: 36069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14454,
    lat: 42.79731,
    lng: -77.76879,
    city: "Geneseo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11237,
    density: 91.1,
    county_fips: 36051,
    county_name: "Livingston",
    county_weights: {
      36051: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 36051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14456,
    lat: 42.84584,
    lng: -77.00012,
    city: "Geneva",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19539,
    density: 97.6,
    county_fips: 36069,
    county_name: "Ontario",
    county_weights: {
      36069: 76.85,
      36099: 21.96,
      36123: 1.19,
    },
    county_names_all: "Ontario|Seneca|Yates",
    county_fips_all: "36069|36099|36123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14462,
    lat: 42.68652,
    lng: -77.75112,
    city: "Groveland",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 718,
    density: 23.1,
    county_fips: 36051,
    county_name: "Livingston",
    county_weights: {
      36051: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 36051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14463,
    lat: 42.79539,
    lng: -77.0689,
    city: "Hall",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36069,
    county_name: "Ontario",
    county_weights: {
      36069: 100,
    },
    county_names_all: "Ontario",
    county_fips_all: 36069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14464,
    lat: 43.32659,
    lng: -77.9374,
    city: "Hamlin",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7419,
    density: 95.3,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 95.61,
      36073: 4.39,
    },
    county_names_all: "Monroe|Orleans",
    county_fips_all: "36055|36073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14466,
    lat: 42.77773,
    lng: -77.5842,
    city: "Hemlock",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1526,
    density: 33.6,
    county_fips: 36069,
    county_name: "Ontario",
    county_weights: {
      36051: 42.87,
      36069: 57.13,
    },
    county_names_all: "Ontario|Livingston",
    county_fips_all: "36069|36051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14467,
    lat: 43.04119,
    lng: -77.60996,
    city: "Henrietta",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9909,
    density: 372.3,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14468,
    lat: 43.29242,
    lng: -77.80542,
    city: "Hilton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17994,
    density: 132,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14469,
    lat: 42.87778,
    lng: -77.46735,
    city: "Bloomfield",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5646,
    density: 33,
    county_fips: 36069,
    county_name: "Ontario",
    county_weights: {
      36069: 100,
    },
    county_names_all: "Ontario",
    county_fips_all: 36069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14470,
    lat: 43.21099,
    lng: -78.05456,
    city: "Holley",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7331,
    density: 43.5,
    county_fips: 36073,
    county_name: "Orleans",
    county_weights: {
      36055: 3.61,
      36073: 96.39,
    },
    county_names_all: "Orleans|Monroe",
    county_fips_all: "36073|36055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14471,
    lat: 42.75308,
    lng: -77.49425,
    city: "Honeoye",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2385,
    density: 35.3,
    county_fips: 36069,
    county_name: "Ontario",
    county_weights: {
      36051: 0.34,
      36069: 99.66,
    },
    county_names_all: "Ontario|Livingston",
    county_fips_all: "36069|36051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14472,
    lat: 42.96589,
    lng: -77.58173,
    city: "Honeoye Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9271,
    density: 81.2,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36051: 15.48,
      36055: 81.55,
      36069: 2.97,
    },
    county_names_all: "Monroe|Livingston|Ontario",
    county_fips_all: "36055|36051|36069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14475,
    lat: 42.93683,
    lng: -77.49787,
    city: "Ionia",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 287,
    density: 64,
    county_fips: 36069,
    county_name: "Ontario",
    county_weights: {
      36069: 100,
    },
    county_names_all: "Ontario",
    county_fips_all: 36069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14476,
    lat: 43.32946,
    lng: -78.04226,
    city: "Kendall",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2270,
    density: 36.6,
    county_fips: 36073,
    county_name: "Orleans",
    county_weights: {
      36055: 4.57,
      36073: 95.43,
    },
    county_names_all: "Orleans|Monroe",
    county_fips_all: "36073|36055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14477,
    lat: 43.33353,
    lng: -78.13415,
    city: "Kent",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1460,
    density: 20.7,
    county_fips: 36073,
    county_name: "Orleans",
    county_weights: {
      36073: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 36073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14478,
    lat: 42.58011,
    lng: -77.12791,
    city: "Keuka Park",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1577,
    density: 44.9,
    county_fips: 36123,
    county_name: "Yates",
    county_weights: {
      36123: 100,
    },
    county_names_all: "Yates",
    county_fips_all: 36123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14479,
    lat: 43.23768,
    lng: -78.31008,
    city: "Knowlesville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 140,
    density: 32.2,
    county_fips: 36073,
    county_name: "Orleans",
    county_weights: {
      36073: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 36073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14480,
    lat: 42.83809,
    lng: -77.70736,
    city: "Lakeville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 904,
    density: 273.1,
    county_fips: 36051,
    county_name: "Livingston",
    county_weights: {
      36051: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 36051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14481,
    lat: 42.77173,
    lng: -77.91643,
    city: "Leicester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1906,
    density: 32.8,
    county_fips: 36051,
    county_name: "Livingston",
    county_weights: {
      36051: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 36051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14482,
    lat: 42.97457,
    lng: -77.97014,
    city: "Le Roy",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8230,
    density: 52.2,
    county_fips: 36037,
    county_name: "Genesee",
    county_weights: {
      36037: 90.78,
      36051: 7.47,
      36055: 1.75,
    },
    county_names_all: "Genesee|Livingston|Monroe",
    county_fips_all: "36037|36051|36055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14485,
    lat: 42.88016,
    lng: -77.60131,
    city: "Lima",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3976,
    density: 45.5,
    county_fips: 36051,
    county_name: "Livingston",
    county_weights: {
      36051: 88.33,
      36069: 11.67,
    },
    county_names_all: "Livingston|Ontario",
    county_fips_all: "36051|36069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14486,
    lat: 42.89293,
    lng: -77.92295,
    city: "Linwood",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 462,
    density: 30.4,
    county_fips: 36051,
    county_name: "Livingston",
    county_weights: {
      36051: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 36051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14487,
    lat: 42.81174,
    lng: -77.63873,
    city: "Livonia",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5997,
    density: 70.3,
    county_fips: 36051,
    county_name: "Livingston",
    county_weights: {
      36051: 78.32,
      36069: 21.68,
    },
    county_names_all: "Livingston|Ontario",
    county_fips_all: "36051|36069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14489,
    lat: 43.09008,
    lng: -76.99238,
    city: "Lyons",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7065,
    density: 39.2,
    county_fips: 36117,
    county_name: "Wayne",
    county_weights: {
      36069: 3.94,
      36099: 3.42,
      36117: 92.64,
    },
    county_names_all: "Wayne|Ontario|Seneca",
    county_fips_all: "36117|36069|36099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14502,
    lat: 43.09532,
    lng: -77.33598,
    city: "Macedon",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10551,
    density: 113.8,
    county_fips: 36117,
    county_name: "Wayne",
    county_weights: {
      36055: 3.76,
      36117: 96.24,
    },
    county_names_all: "Wayne|Monroe",
    county_fips_all: "36117|36055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14504,
    lat: 42.96839,
    lng: -77.2327,
    city: "Manchester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1593,
    density: 520.4,
    county_fips: 36069,
    county_name: "Ontario",
    county_weights: {
      36069: 100,
    },
    county_names_all: "Ontario",
    county_fips_all: 36069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14505,
    lat: 43.15846,
    lng: -77.17503,
    city: "Marion",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5277,
    density: 51.5,
    county_fips: 36117,
    county_name: "Wayne",
    county_weights: {
      36117: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 36117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14506,
    lat: 43.0012,
    lng: -77.50508,
    city: "Mendon",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 939,
    density: 117,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14507,
    lat: 42.69635,
    lng: -77.27373,
    city: "Middlesex",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 894,
    density: 11,
    county_fips: 36123,
    county_name: "Yates",
    county_weights: {
      36123: 100,
    },
    county_names_all: "Yates",
    county_fips_all: 36123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14510,
    lat: 42.69485,
    lng: -77.87167,
    city: "Mount Morris",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4571,
    density: 23.5,
    county_fips: 36051,
    county_name: "Livingston",
    county_weights: {
      36051: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 36051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14511,
    lat: 42.99603,
    lng: -77.87762,
    city: "Mumford",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 399,
    density: 55.4,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14512,
    lat: 42.64411,
    lng: -77.39296,
    city: "Naples",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4542,
    density: 16.9,
    county_fips: 36069,
    county_name: "Ontario",
    county_weights: {
      36051: 1.47,
      36069: 65.73,
      36101: 5.53,
      36123: 27.27,
    },
    county_names_all: "Ontario|Yates|Steuben|Livingston",
    county_fips_all: "36069|36123|36101|36051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14513,
    lat: 43.07204,
    lng: -77.0961,
    city: "Newark",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13749,
    density: 117.3,
    county_fips: 36117,
    county_name: "Wayne",
    county_weights: {
      36069: 6.08,
      36117: 93.92,
    },
    county_names_all: "Wayne|Ontario",
    county_fips_all: "36117|36069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14514,
    lat: 43.08597,
    lng: -77.80303,
    city: "North Chili",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6293,
    density: 430.8,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14515,
    lat: 43.25287,
    lng: -77.73175,
    city: "North Greece",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14516,
    lat: 43.19855,
    lng: -76.91153,
    city: "North Rose",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2338,
    density: 31.1,
    county_fips: 36117,
    county_name: "Wayne",
    county_weights: {
      36117: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 36117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14517,
    lat: 42.59217,
    lng: -77.8971,
    city: "Nunda",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2846,
    density: 29.7,
    county_fips: 36051,
    county_name: "Livingston",
    county_weights: {
      36051: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 36051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14519,
    lat: 43.23184,
    lng: -77.31389,
    city: "Ontario",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11537,
    density: 106,
    county_fips: 36117,
    county_name: "Wayne",
    county_weights: {
      36055: 2.46,
      36117: 97.54,
    },
    county_names_all: "Wayne|Monroe",
    county_fips_all: "36117|36055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14521,
    lat: 42.67639,
    lng: -76.80876,
    city: "Ovid",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3077,
    density: 30.9,
    county_fips: 36099,
    county_name: "Seneca",
    county_weights: {
      36099: 100,
    },
    county_names_all: "Seneca",
    county_fips_all: 36099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14522,
    lat: 43.05911,
    lng: -77.22152,
    city: "Palmyra",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9559,
    density: 81,
    county_fips: 36117,
    county_name: "Wayne",
    county_weights: {
      36069: 27.44,
      36117: 72.56,
    },
    county_names_all: "Wayne|Ontario",
    county_fips_all: "36117|36069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14525,
    lat: 42.87242,
    lng: -78.01471,
    city: "Pavilion",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2524,
    density: 20.6,
    county_fips: 36037,
    county_name: "Genesee",
    county_weights: {
      36037: 56.89,
      36051: 8.71,
      36121: 34.4,
    },
    county_names_all: "Genesee|Wyoming|Livingston",
    county_fips_all: "36037|36121|36051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14526,
    lat: 43.15129,
    lng: -77.44806,
    city: "Penfield",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19001,
    density: 447.9,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14527,
    lat: 42.66764,
    lng: -77.06473,
    city: "Penn Yan",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12835,
    density: 36.7,
    county_fips: 36123,
    county_name: "Yates",
    county_weights: {
      36123: 100,
    },
    county_names_all: "Yates",
    county_fips_all: 36123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14529,
    lat: 42.53748,
    lng: -77.64418,
    city: "Perkinsville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12,
    density: 4.3,
    county_fips: 36101,
    county_name: "Steuben",
    county_weights: {
      36101: 100,
    },
    county_names_all: "Steuben",
    county_fips_all: 36101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14530,
    lat: 42.73446,
    lng: -78.00276,
    city: "Perry",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5500,
    density: 42,
    county_fips: 36121,
    county_name: "Wyoming",
    county_weights: {
      36051: 4.89,
      36121: 95.11,
    },
    county_names_all: "Wyoming|Livingston",
    county_fips_all: "36121|36051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14532,
    lat: 42.96462,
    lng: -77.02601,
    city: "Phelps",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3998,
    density: 37.4,
    county_fips: 36069,
    county_name: "Ontario",
    county_weights: {
      36069: 87.33,
      36099: 12.67,
    },
    county_names_all: "Ontario|Seneca",
    county_fips_all: "36069|36099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14533,
    lat: 42.84632,
    lng: -77.88468,
    city: "Piffard",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2254,
    density: 30,
    county_fips: 36051,
    county_name: "Livingston",
    county_weights: {
      36051: 99.27,
      36121: 0.73,
    },
    county_names_all: "Livingston|Wyoming",
    county_fips_all: "36051|36121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14534,
    lat: 43.0564,
    lng: -77.52083,
    city: "Pittsford",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31975,
    density: 381.7,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 96.35,
      36069: 3.65,
    },
    county_names_all: "Monroe|Ontario",
    county_fips_all: "36055|36069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14536,
    lat: 42.53958,
    lng: -78.08358,
    city: "Portageville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 599,
    density: 12.7,
    county_fips: 36121,
    county_name: "Wyoming",
    county_weights: {
      36003: 20.86,
      36121: 79.14,
    },
    county_names_all: "Wyoming|Allegany",
    county_fips_all: "36121|36003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14537,
    lat: 43.03539,
    lng: -77.15604,
    city: "Port Gibson",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 160,
    density: 89,
    county_fips: 36069,
    county_name: "Ontario",
    county_weights: {
      36069: 100,
    },
    county_names_all: "Ontario",
    county_fips_all: 36069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14539,
    lat: 42.83418,
    lng: -77.87521,
    city: "Retsof",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60,
    density: 92.3,
    county_fips: 36051,
    county_name: "Livingston",
    county_weights: {
      36051: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 36051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14541,
    lat: 42.75704,
    lng: -76.84403,
    city: "Romulus",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4584,
    density: 36.9,
    county_fips: 36099,
    county_name: "Seneca",
    county_weights: {
      36099: 100,
    },
    county_names_all: "Seneca",
    county_fips_all: 36099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14542,
    lat: 43.15306,
    lng: -76.87595,
    city: "Rose",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 80,
    density: 598.2,
    county_fips: 36117,
    county_name: "Wayne",
    county_weights: {
      36117: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 36117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14543,
    lat: 42.98777,
    lng: -77.67747,
    city: "Rush",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3145,
    density: 48.3,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14544,
    lat: 42.75562,
    lng: -77.23958,
    city: "Rushville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2280,
    density: 29.2,
    county_fips: 36123,
    county_name: "Yates",
    county_weights: {
      36069: 35.88,
      36123: 64.12,
    },
    county_names_all: "Yates|Ontario",
    county_fips_all: "36123|36069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14545,
    lat: 42.66166,
    lng: -77.71056,
    city: "Scottsburg",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 227,
    density: 190.6,
    county_fips: 36051,
    county_name: "Livingston",
    county_weights: {
      36051: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 36051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14546,
    lat: 43.0296,
    lng: -77.77372,
    city: "Scottsville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4614,
    density: 49.3,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36051: 3.41,
      36055: 96.59,
    },
    county_names_all: "Monroe|Livingston",
    county_fips_all: "36055|36051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14548,
    lat: 42.97538,
    lng: -77.24341,
    city: "Shortsville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4132,
    density: 55.7,
    county_fips: 36069,
    county_name: "Ontario",
    county_weights: {
      36069: 100,
    },
    county_names_all: "Ontario",
    county_fips_all: 36069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14549,
    lat: 42.69667,
    lng: -78.02212,
    city: "Silver Lake",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65,
    density: 129.4,
    county_fips: 36121,
    county_name: "Wyoming",
    county_weights: {
      36121: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 36121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14550,
    lat: 42.67757,
    lng: -78.09166,
    city: "Silver Springs",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1256,
    density: 22.4,
    county_fips: 36121,
    county_name: "Wyoming",
    county_weights: {
      36121: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 36121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14551,
    lat: 43.21886,
    lng: -77.04596,
    city: "Sodus",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5392,
    density: 47.7,
    county_fips: 36117,
    county_name: "Wayne",
    county_weights: {
      36117: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 36117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14555,
    lat: 43.25946,
    lng: -76.98665,
    city: "Sodus Point",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1048,
    density: 140,
    county_fips: 36117,
    county_name: "Wayne",
    county_weights: {
      36117: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 36117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14556,
    lat: 42.67906,
    lng: -77.83222,
    city: "Sonyea",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36051,
    county_name: "Livingston",
    county_weights: {
      36051: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 36051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14557,
    lat: 43.04807,
    lng: -78.06126,
    city: "South Byron",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36037,
    county_name: "Genesee",
    county_weights: {
      36037: 100,
    },
    county_names_all: "Genesee",
    county_fips_all: 36037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14559,
    lat: 43.18823,
    lng: -77.81778,
    city: "Spencerport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18584,
    density: 164.1,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14560,
    lat: 42.68716,
    lng: -77.57691,
    city: "Springwater",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2320,
    density: 22.9,
    county_fips: 36069,
    county_name: "Ontario",
    county_weights: {
      36051: 41.81,
      36069: 58.19,
    },
    county_names_all: "Ontario|Livingston",
    county_fips_all: "36069|36051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14561,
    lat: 42.82218,
    lng: -77.13131,
    city: "Stanley",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2815,
    density: 21.7,
    county_fips: 36069,
    county_name: "Ontario",
    county_weights: {
      36069: 98.53,
      36123: 1.47,
    },
    county_names_all: "Ontario|Yates",
    county_fips_all: "36069|36123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14564,
    lat: 42.98329,
    lng: -77.42417,
    city: "Victor",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15359,
    density: 140.3,
    county_fips: 36069,
    county_name: "Ontario",
    county_weights: {
      36055: 3.84,
      36069: 96.16,
    },
    county_names_all: "Ontario|Monroe",
    county_fips_all: "36069|36055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14568,
    lat: 43.14657,
    lng: -77.28365,
    city: "Walworth",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6241,
    density: 98.5,
    county_fips: 36117,
    county_name: "Wayne",
    county_weights: {
      36117: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 36117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14569,
    lat: 42.74012,
    lng: -78.17269,
    city: "Warsaw",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5910,
    density: 30.5,
    county_fips: 36121,
    county_name: "Wyoming",
    county_weights: {
      36121: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 36121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14571,
    lat: 43.34397,
    lng: -78.24894,
    city: "Waterport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1314,
    density: 29.8,
    county_fips: 36073,
    county_name: "Orleans",
    county_weights: {
      36073: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 36073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14572,
    lat: 42.5669,
    lng: -77.57017,
    city: "Wayland",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5017,
    density: 25.9,
    county_fips: 36101,
    county_name: "Steuben",
    county_weights: {
      36051: 44,
      36101: 56,
    },
    county_names_all: "Steuben|Livingston",
    county_fips_all: "36101|36051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14580,
    lat: 43.21883,
    lng: -77.44561,
    city: "Webster",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53593,
    density: 485.2,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 99.23,
      36117: 0.77,
    },
    county_names_all: "Monroe|Wayne",
    county_fips_all: "36055|36117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14585,
    lat: 42.90587,
    lng: -77.55301,
    city: "West Bloomfield",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50,
    density: 176,
    county_fips: 36069,
    county_name: "Ontario",
    county_weights: {
      36069: 100,
    },
    county_names_all: "Ontario",
    county_fips_all: 36069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14586,
    lat: 43.04151,
    lng: -77.68693,
    city: "West Henrietta",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11848,
    density: 414.7,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14588,
    lat: 42.67973,
    lng: -76.87047,
    city: "Willard",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 191,
    density: 276.8,
    county_fips: 36099,
    county_name: "Seneca",
    county_weights: {
      36099: 100,
    },
    county_names_all: "Seneca",
    county_fips_all: 36099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14589,
    lat: 43.23997,
    lng: -77.17224,
    city: "Williamson",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7502,
    density: 65.9,
    county_fips: 36117,
    county_name: "Wayne",
    county_weights: {
      36117: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 36117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14590,
    lat: 43.24533,
    lng: -76.83099,
    city: "Wolcott",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5420,
    density: 32.4,
    county_fips: 36117,
    county_name: "Wayne",
    county_weights: {
      36117: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 36117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14591,
    lat: 42.82865,
    lng: -78.09364,
    city: "Wyoming",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1556,
    density: 17.2,
    county_fips: 36121,
    county_name: "Wyoming",
    county_weights: {
      36037: 4.26,
      36121: 95.74,
    },
    county_names_all: "Wyoming|Genesee",
    county_fips_all: "36121|36037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14592,
    lat: 42.86875,
    lng: -77.89066,
    city: "York",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48,
    density: 32.9,
    county_fips: 36051,
    county_name: "Livingston",
    county_weights: {
      36051: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 36051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14604,
    lat: 43.1569,
    lng: -77.60536,
    city: "Rochester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2536,
    density: 2867,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14605,
    lat: 43.16838,
    lng: -77.60177,
    city: "Rochester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11457,
    density: 2478.8,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14606,
    lat: 43.17069,
    lng: -77.69933,
    city: "Rochester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27711,
    density: 1135.4,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14607,
    lat: 43.15099,
    lng: -77.58682,
    city: "Rochester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16880,
    density: 3801.3,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14608,
    lat: 43.15335,
    lng: -77.62362,
    city: "Rochester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11260,
    density: 2473.5,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14609,
    lat: 43.17731,
    lng: -77.55234,
    city: "Rochester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40081,
    density: 2092.1,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14610,
    lat: 43.14196,
    lng: -77.5463,
    city: "Rochester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13373,
    density: 1228.4,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14611,
    lat: 43.14756,
    lng: -77.64731,
    city: "Rochester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17429,
    density: 2296.5,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14612,
    lat: 43.26513,
    lng: -77.67654,
    city: "Rochester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34316,
    density: 769.5,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14613,
    lat: 43.1822,
    lng: -77.64068,
    city: "Rochester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15375,
    density: 3132.1,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14614,
    lat: 43.1574,
    lng: -77.61473,
    city: "Rochester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1151,
    density: 2007.8,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14615,
    lat: 43.20337,
    lng: -77.65637,
    city: "Rochester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16812,
    density: 1091.2,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14616,
    lat: 43.23431,
    lng: -77.65822,
    city: "Rochester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26935,
    density: 1771.2,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14617,
    lat: 43.22488,
    lng: -77.59323,
    city: "Rochester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21985,
    density: 1072.3,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14618,
    lat: 43.11305,
    lng: -77.55547,
    city: "Rochester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23252,
    density: 935.9,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14619,
    lat: 43.1361,
    lng: -77.649,
    city: "Rochester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13788,
    density: 3710.7,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14620,
    lat: 43.12878,
    lng: -77.60463,
    city: "Rochester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23912,
    density: 2081.4,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14621,
    lat: 43.18911,
    lng: -77.60408,
    city: "Rochester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33757,
    density: 3210.4,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14622,
    lat: 43.21389,
    lng: -77.55359,
    city: "Rochester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12906,
    density: 1123,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14623,
    lat: 43.08798,
    lng: -77.64314,
    city: "Rochester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24720,
    density: 488.8,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14624,
    lat: 43.12765,
    lng: -77.7317,
    city: "Rochester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37873,
    density: 534.6,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14625,
    lat: 43.14891,
    lng: -77.50551,
    city: "Rochester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10051,
    density: 508.5,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14626,
    lat: 43.21348,
    lng: -77.71272,
    city: "Rochester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29941,
    density: 864.3,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14627,
    lat: 43.12931,
    lng: -77.62912,
    city: "Rochester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2280,
    density: 4346.5,
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14642,
    lat: 43.12281,
    lng: -77.62508,
    city: "Rochester",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36055,
    county_name: "Monroe",
    county_weights: {
      36055: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 36055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14701,
    lat: 42.08091,
    lng: -79.25502,
    city: "Jamestown",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39214,
    density: 163.6,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14706,
    lat: 42.10663,
    lng: -78.52795,
    city: "Allegany",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6110,
    density: 29.1,
    county_fips: 36009,
    county_name: "Cattaraugus",
    county_weights: {
      36009: 100,
    },
    county_names_all: "Cattaraugus",
    county_fips_all: 36009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14707,
    lat: 42.08256,
    lng: -78.06196,
    city: "Allentown",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 90,
    density: 39.7,
    county_fips: 36003,
    county_name: "Allegany",
    county_weights: {
      36003: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 36003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14708,
    lat: 42.01424,
    lng: -78.06988,
    city: "Alma",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 239,
    density: 10.2,
    county_fips: 36003,
    county_name: "Allegany",
    county_weights: {
      36003: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 36003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14709,
    lat: 42.35279,
    lng: -77.98267,
    city: "Angelica",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1421,
    density: 10.6,
    county_fips: 36003,
    county_name: "Allegany",
    county_weights: {
      36003: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 36003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14710,
    lat: 42.08957,
    lng: -79.42306,
    city: "Ashville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3244,
    density: 23.5,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14711,
    lat: 42.32088,
    lng: -78.12625,
    city: "Belfast",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1874,
    density: 17.6,
    county_fips: 36003,
    county_name: "Allegany",
    county_weights: {
      36003: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 36003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14712,
    lat: 42.18163,
    lng: -79.36812,
    city: "Bemus Point",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3051,
    density: 45.7,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14714,
    lat: 42.28368,
    lng: -78.23493,
    city: "Black Creek",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 604,
    density: 19.7,
    county_fips: 36003,
    county_name: "Allegany",
    county_weights: {
      36003: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 36003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14715,
    lat: 42.07323,
    lng: -78.14832,
    city: "Bolivar",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2585,
    density: 21.9,
    county_fips: 36003,
    county_name: "Allegany",
    county_weights: {
      36003: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 36003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14716,
    lat: 42.38056,
    lng: -79.43406,
    city: "Brocton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2640,
    density: 86.1,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14717,
    lat: 42.36258,
    lng: -78.18235,
    city: "Caneadea",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 394,
    density: 4.4,
    county_fips: 36003,
    county_name: "Allegany",
    county_weights: {
      36003: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 36003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14718,
    lat: 42.34417,
    lng: -79.28813,
    city: "Cassadaga",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1899,
    density: 20.9,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14719,
    lat: 42.34323,
    lng: -78.87198,
    city: "Cattaraugus",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3283,
    density: 12.5,
    county_fips: 36009,
    county_name: "Cattaraugus",
    county_weights: {
      36009: 100,
    },
    county_names_all: "Cattaraugus",
    county_fips_all: 36009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14720,
    lat: 42.10857,
    lng: -79.27997,
    city: "Celoron",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 749,
    density: 1012.9,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14721,
    lat: 42.01645,
    lng: -78.26801,
    city: "Ceres",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 160,
    density: 18.4,
    county_fips: 36003,
    county_name: "Allegany",
    county_weights: {
      36003: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 36003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14722,
    lat: 42.20961,
    lng: -79.46882,
    city: "Chautauqua",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 214,
    density: 228.8,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14723,
    lat: 42.3101,
    lng: -79.13489,
    city: "Cherry Creek",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1098,
    density: 9.3,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14724,
    lat: 42.05272,
    lng: -79.67031,
    city: "Clymer",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2723,
    density: 14.3,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14726,
    lat: 42.25255,
    lng: -79.02221,
    city: "Conewango Valley",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1980,
    density: 18.2,
    county_fips: 36009,
    county_name: "Cattaraugus",
    county_weights: {
      36009: 88.31,
      36013: 11.69,
    },
    county_names_all: "Cattaraugus|Chautauqua",
    county_fips_all: "36009|36013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14727,
    lat: 42.2129,
    lng: -78.29358,
    city: "Cuba",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5385,
    density: 19.5,
    county_fips: 36003,
    county_name: "Allegany",
    county_weights: {
      36003: 64.07,
      36009: 35.93,
    },
    county_names_all: "Allegany|Cattaraugus",
    county_fips_all: "36003|36009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14728,
    lat: 42.2648,
    lng: -79.41689,
    city: "Dewittville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1056,
    density: 14.3,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14729,
    lat: 42.40404,
    lng: -78.73628,
    city: "East Otto",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 990,
    density: 12.9,
    county_fips: 36009,
    county_name: "Cattaraugus",
    county_weights: {
      36009: 100,
    },
    county_names_all: "Cattaraugus",
    county_fips_all: 36009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14731,
    lat: 42.30063,
    lng: -78.65092,
    city: "Ellicottville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1291,
    density: 11,
    county_fips: 36009,
    county_name: "Cattaraugus",
    county_weights: {
      36009: 100,
    },
    county_names_all: "Cattaraugus",
    county_fips_all: 36009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14732,
    lat: 42.2188,
    lng: -79.10696,
    city: "Ellington",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 180,
    density: 903.4,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14733,
    lat: 42.14996,
    lng: -79.17499,
    city: "Falconer",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3655,
    density: 52.9,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14735,
    lat: 42.45027,
    lng: -78.09681,
    city: "Fillmore",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2900,
    density: 14.3,
    county_fips: 36003,
    county_name: "Allegany",
    county_weights: {
      36003: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 36003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14736,
    lat: 42.13715,
    lng: -79.74644,
    city: "Findley Lake",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 188,
    density: 15.9,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14737,
    lat: 42.33524,
    lng: -78.42926,
    city: "Franklinville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4272,
    density: 15.5,
    county_fips: 36009,
    county_name: "Cattaraugus",
    county_weights: {
      36003: 1.03,
      36009: 98.97,
    },
    county_names_all: "Cattaraugus|Allegany",
    county_fips_all: "36009|36003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14738,
    lat: 42.04539,
    lng: -79.05926,
    city: "Frewsburg",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3319,
    density: 19.7,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36009: 49.28,
      36013: 50.72,
    },
    county_names_all: "Chautauqua|Cattaraugus",
    county_fips_all: "36013|36009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14739,
    lat: 42.1925,
    lng: -78.14932,
    city: "Friendship",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2421,
    density: 11.5,
    county_fips: 36003,
    county_name: "Allegany",
    county_weights: {
      36003: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 36003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14740,
    lat: 42.21962,
    lng: -79.18053,
    city: "Gerry",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1032,
    density: 15.6,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14741,
    lat: 42.21868,
    lng: -78.5963,
    city: "Great Valley",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1796,
    density: 11.1,
    county_fips: 36009,
    county_name: "Cattaraugus",
    county_weights: {
      36009: 100,
    },
    county_names_all: "Cattaraugus",
    county_fips_all: 36009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14742,
    lat: 42.11934,
    lng: -79.30878,
    city: "Greenhurst",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 244,
    density: 747.9,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14743,
    lat: 42.20532,
    lng: -78.40631,
    city: "Hinsdale",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1938,
    density: 16.6,
    county_fips: 36009,
    county_name: "Cattaraugus",
    county_weights: {
      36009: 100,
    },
    county_names_all: "Cattaraugus",
    county_fips_all: 36009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14744,
    lat: 42.4219,
    lng: -78.21516,
    city: "Houghton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2103,
    density: 40.9,
    county_fips: 36003,
    county_name: "Allegany",
    county_weights: {
      36003: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 36003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14747,
    lat: 42.15346,
    lng: -79.09061,
    city: "Kennedy",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2015,
    density: 17.5,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36009: 18.45,
      36013: 81.55,
    },
    county_names_all: "Chautauqua|Cattaraugus",
    county_fips_all: "36013|36009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14748,
    lat: 42.1392,
    lng: -78.63636,
    city: "Kill Buck",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 548,
    density: 12.6,
    county_fips: 36009,
    county_name: "Cattaraugus",
    county_weights: {
      36009: 100,
    },
    county_names_all: "Cattaraugus",
    county_fips_all: 36009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14750,
    lat: 42.07939,
    lng: -79.32752,
    city: "Lakewood",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4277,
    density: 146.6,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14752,
    lat: 42.3517,
    lng: -79.31965,
    city: "Lily Dale",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 339,
    density: 524.5,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14753,
    lat: 42.03899,
    lng: -78.63516,
    city: "Limestone",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1182,
    density: 12.8,
    county_fips: 36009,
    county_name: "Cattaraugus",
    county_weights: {
      36009: 100,
    },
    county_names_all: "Cattaraugus",
    county_fips_all: 36009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14754,
    lat: 42.02385,
    lng: -78.19799,
    city: "Little Genesee",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 533,
    density: 10.5,
    county_fips: 36003,
    county_name: "Allegany",
    county_weights: {
      36003: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 36003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14755,
    lat: 42.23477,
    lng: -78.81398,
    city: "Little Valley",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3146,
    density: 16.4,
    county_fips: 36009,
    county_name: "Cattaraugus",
    county_weights: {
      36009: 100,
    },
    county_names_all: "Cattaraugus",
    county_fips_all: 36009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14756,
    lat: 42.19708,
    lng: -79.42373,
    city: "Maple Springs",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28,
    density: 461.1,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14757,
    lat: 42.23944,
    lng: -79.50457,
    city: "Mayville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3371,
    density: 29.8,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14760,
    lat: 42.07098,
    lng: -78.41421,
    city: "Olean",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17567,
    density: 104.2,
    county_fips: 36009,
    county_name: "Cattaraugus",
    county_weights: {
      36009: 100,
    },
    county_names_all: "Cattaraugus",
    county_fips_all: 36009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14767,
    lat: 42.05344,
    lng: -79.51583,
    city: "Panama",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2224,
    density: 15.6,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14769,
    lat: 42.36885,
    lng: -79.47413,
    city: "Portland",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 996,
    density: 42.8,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14770,
    lat: 42.0468,
    lng: -78.29963,
    city: "Portville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2761,
    density: 36.5,
    county_fips: 36003,
    county_name: "Allegany",
    county_weights: {
      36003: 52.1,
      36009: 47.9,
    },
    county_names_all: "Allegany|Cattaraugus",
    county_fips_all: "36003|36009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14772,
    lat: 42.15383,
    lng: -78.95086,
    city: "Randolph",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3995,
    density: 20.1,
    county_fips: 36009,
    county_name: "Cattaraugus",
    county_weights: {
      36009: 100,
    },
    county_names_all: "Cattaraugus",
    county_fips_all: 36009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14774,
    lat: 42.08875,
    lng: -78.14658,
    city: "Richburg",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 137,
    density: 205.6,
    county_fips: 36003,
    county_name: "Allegany",
    county_weights: {
      36003: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 36003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14775,
    lat: 42.23198,
    lng: -79.69532,
    city: "Ripley",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2520,
    density: 18.1,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14777,
    lat: 42.38999,
    lng: -78.26167,
    city: "Rushford",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 673,
    density: 34.2,
    county_fips: 36003,
    county_name: "Allegany",
    county_weights: {
      36003: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 36003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14778,
    lat: 42.07759,
    lng: -78.4827,
    city: "Saint Bonaventure",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1349,
    density: 1133.3,
    county_fips: 36009,
    county_name: "Cattaraugus",
    county_weights: {
      36009: 100,
    },
    county_names_all: "Cattaraugus",
    county_fips_all: 36009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14779,
    lat: 42.10703,
    lng: -78.76977,
    city: "Salamanca",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6537,
    density: 18.2,
    county_fips: 36009,
    county_name: "Cattaraugus",
    county_weights: {
      36009: 100,
    },
    county_names_all: "Cattaraugus",
    county_fips_all: 36009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14781,
    lat: 42.16402,
    lng: -79.604,
    city: "Sherman",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1782,
    density: 9.5,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14782,
    lat: 42.2665,
    lng: -79.2559,
    city: "Sinclairville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2272,
    density: 16.2,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14783,
    lat: 42.06014,
    lng: -78.91816,
    city: "Steamburg",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 306,
    density: 8.2,
    county_fips: 36009,
    county_name: "Cattaraugus",
    county_weights: {
      36009: 100,
    },
    county_names_all: "Cattaraugus",
    county_fips_all: 36009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14784,
    lat: 42.31445,
    lng: -79.38028,
    city: "Stockton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 938,
    density: 13.2,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14785,
    lat: 42.15572,
    lng: -79.40337,
    city: "Stow",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14787,
    lat: 42.31342,
    lng: -79.5675,
    city: "Westfield",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4759,
    density: 43.1,
    county_fips: 36013,
    county_name: "Chautauqua",
    county_weights: {
      36013: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 36013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14788,
    lat: 42.06012,
    lng: -78.37661,
    city: "Westons Mills",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28,
    density: 33.3,
    county_fips: 36009,
    county_name: "Cattaraugus",
    county_weights: {
      36009: 100,
    },
    county_names_all: "Cattaraugus",
    county_fips_all: 36009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14801,
    lat: 42.09718,
    lng: -77.28461,
    city: "Addison",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5234,
    density: 19.3,
    county_fips: 36101,
    county_name: "Steuben",
    county_weights: {
      36101: 100,
    },
    county_names_all: "Steuben",
    county_fips_all: 36101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14802,
    lat: 42.2537,
    lng: -77.78989,
    city: "Alfred",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4171,
    density: 1415.7,
    county_fips: 36003,
    county_name: "Allegany",
    county_weights: {
      36003: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 36003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14803,
    lat: 42.25135,
    lng: -77.78808,
    city: "Alfred Station",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 782,
    density: 10.8,
    county_fips: 36003,
    county_name: "Allegany",
    county_weights: {
      36003: 90.84,
      36101: 9.16,
    },
    county_names_all: "Allegany|Steuben",
    county_fips_all: "36003|36101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14804,
    lat: 42.31587,
    lng: -77.8476,
    city: "Almond",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1739,
    density: 12.4,
    county_fips: 36003,
    county_name: "Allegany",
    county_weights: {
      36003: 99.87,
      36101: 0.13,
    },
    county_names_all: "Allegany|Steuben",
    county_fips_all: "36003|36101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14805,
    lat: 42.3563,
    lng: -76.72618,
    city: "Alpine",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 958,
    density: 12.6,
    county_fips: 36097,
    county_name: "Schuyler",
    county_weights: {
      36015: 4.76,
      36097: 95.24,
    },
    county_names_all: "Schuyler|Chemung",
    county_fips_all: "36097|36015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14806,
    lat: 42.15543,
    lng: -77.78662,
    city: "Andover",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2060,
    density: 13,
    county_fips: 36003,
    county_name: "Allegany",
    county_weights: {
      36003: 85.2,
      36101: 14.8,
    },
    county_names_all: "Allegany|Steuben",
    county_fips_all: "36003|36101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14807,
    lat: 42.41821,
    lng: -77.71949,
    city: "Arkport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3070,
    density: 16.2,
    county_fips: 36101,
    county_name: "Steuben",
    county_weights: {
      36003: 45.13,
      36101: 54.87,
    },
    county_names_all: "Steuben|Allegany",
    county_fips_all: "36101|36003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14808,
    lat: 42.55817,
    lng: -77.46882,
    city: "Atlanta",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 514,
    density: 73.4,
    county_fips: 36101,
    county_name: "Steuben",
    county_weights: {
      36101: 100,
    },
    county_names_all: "Steuben",
    county_fips_all: 36101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14809,
    lat: 42.41961,
    lng: -77.44355,
    city: "Avoca",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2676,
    density: 18.2,
    county_fips: 36101,
    county_name: "Steuben",
    county_weights: {
      36101: 100,
    },
    county_names_all: "Steuben",
    county_fips_all: 36101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14810,
    lat: 42.34678,
    lng: -77.34599,
    city: "Bath",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11673,
    density: 37.4,
    county_fips: 36101,
    county_name: "Steuben",
    county_weights: {
      36101: 100,
    },
    county_names_all: "Steuben",
    county_fips_all: 36101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14812,
    lat: 42.29199,
    lng: -76.99413,
    city: "Beaver Dams",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3200,
    density: 16.2,
    county_fips: 36097,
    county_name: "Schuyler",
    county_weights: {
      36015: 18.33,
      36097: 57.18,
      36101: 24.49,
    },
    county_names_all: "Schuyler|Steuben|Chemung",
    county_fips_all: "36097|36101|36015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14813,
    lat: 42.24638,
    lng: -77.99209,
    city: "Belmont",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2264,
    density: 14.4,
    county_fips: 36003,
    county_name: "Allegany",
    county_weights: {
      36003: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 36003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14814,
    lat: 42.15525,
    lng: -76.95148,
    city: "Big Flats",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1883,
    density: 87.9,
    county_fips: 36015,
    county_name: "Chemung",
    county_weights: {
      36015: 91.23,
      36101: 8.77,
    },
    county_names_all: "Chemung|Steuben",
    county_fips_all: "36015|36101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14815,
    lat: 42.37335,
    lng: -77.09463,
    city: "Bradford",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 776,
    density: 16.5,
    county_fips: 36097,
    county_name: "Schuyler",
    county_weights: {
      36097: 68.4,
      36101: 31.6,
    },
    county_names_all: "Schuyler|Steuben",
    county_fips_all: "36097|36101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14816,
    lat: 42.19728,
    lng: -76.73161,
    city: "Breesport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 544,
    density: 55.8,
    county_fips: 36015,
    county_name: "Chemung",
    county_weights: {
      36015: 100,
    },
    county_names_all: "Chemung",
    county_fips_all: 36015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14817,
    lat: 42.36295,
    lng: -76.34548,
    city: "Brooktondale",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2508,
    density: 23.8,
    county_fips: 36109,
    county_name: "Tompkins",
    county_weights: {
      36107: 4.85,
      36109: 95.15,
    },
    county_names_all: "Tompkins|Tioga",
    county_fips_all: "36109|36107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14818,
    lat: 42.44878,
    lng: -76.81688,
    city: "Burdett",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2029,
    density: 20.3,
    county_fips: 36097,
    county_name: "Schuyler",
    county_weights: {
      36097: 100,
    },
    county_names_all: "Schuyler",
    county_fips_all: 36097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14819,
    lat: 42.21924,
    lng: -77.43466,
    city: "Cameron",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 696,
    density: 7,
    county_fips: 36101,
    county_name: "Steuben",
    county_weights: {
      36101: 100,
    },
    county_names_all: "Steuben",
    county_fips_all: 36101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14820,
    lat: 42.18629,
    lng: -77.36258,
    city: "Cameron Mills",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 807,
    density: 11.2,
    county_fips: 36101,
    county_name: "Steuben",
    county_weights: {
      36101: 100,
    },
    county_names_all: "Steuben",
    county_fips_all: 36101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14821,
    lat: 42.23541,
    lng: -77.21623,
    city: "Campbell",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3141,
    density: 21.7,
    county_fips: 36101,
    county_name: "Steuben",
    county_weights: {
      36101: 100,
    },
    county_names_all: "Steuben",
    county_fips_all: 36101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14822,
    lat: 42.43522,
    lng: -77.84702,
    city: "Canaseraga",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 947,
    density: 9.2,
    county_fips: 36003,
    county_name: "Allegany",
    county_weights: {
      36003: 87.47,
      36051: 12.53,
    },
    county_names_all: "Allegany|Livingston",
    county_fips_all: "36003|36051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14823,
    lat: 42.23984,
    lng: -77.5722,
    city: "Canisteo",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3467,
    density: 14.1,
    county_fips: 36101,
    county_name: "Steuben",
    county_weights: {
      36101: 100,
    },
    county_names_all: "Steuben",
    county_fips_all: 36101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14824,
    lat: 42.26875,
    lng: -76.70881,
    city: "Cayuta",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 639,
    density: 12.1,
    county_fips: 36097,
    county_name: "Schuyler",
    county_weights: {
      36015: 33.3,
      36097: 66.7,
    },
    county_names_all: "Schuyler|Chemung",
    county_fips_all: "36097|36015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14825,
    lat: 42.05564,
    lng: -76.62116,
    city: "Chemung",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 784,
    density: 18.1,
    county_fips: 36015,
    county_name: "Chemung",
    county_weights: {
      36015: 100,
    },
    county_names_all: "Chemung",
    county_fips_all: 36015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14826,
    lat: 42.49354,
    lng: -77.49335,
    city: "Cohocton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2271,
    density: 14.8,
    county_fips: 36101,
    county_name: "Steuben",
    county_weights: {
      36101: 100,
    },
    county_names_all: "Steuben",
    county_fips_all: 36101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14827,
    lat: 42.18069,
    lng: -77.14292,
    city: "Coopers Plains",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 146,
    density: 626.4,
    county_fips: 36101,
    county_name: "Steuben",
    county_weights: {
      36101: 100,
    },
    county_names_all: "Steuben",
    county_fips_all: 36101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14830,
    lat: 42.12927,
    lng: -77.02783,
    city: "Corning",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19138,
    density: 81.5,
    county_fips: 36101,
    county_name: "Steuben",
    county_weights: {
      36015: 6.72,
      36101: 93.28,
    },
    county_names_all: "Steuben|Chemung",
    county_fips_all: "36101|36015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14836,
    lat: 42.51526,
    lng: -77.91526,
    city: "Dalton",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 931,
    density: 11.9,
    county_fips: 36051,
    county_name: "Livingston",
    county_weights: {
      36003: 40.97,
      36051: 59.03,
    },
    county_names_all: "Livingston|Allegany",
    county_fips_all: "36051|36003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14837,
    lat: 42.49919,
    lng: -77.01668,
    city: "Dundee",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5947,
    density: 29.2,
    county_fips: 36123,
    county_name: "Yates",
    county_weights: {
      36097: 31.43,
      36101: 1.45,
      36123: 67.12,
    },
    county_names_all: "Yates|Schuyler|Steuben",
    county_fips_all: "36123|36097|36101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14838,
    lat: 42.18951,
    lng: -76.66635,
    city: "Erin",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2039,
    density: 19.7,
    county_fips: 36015,
    county_name: "Chemung",
    county_weights: {
      36015: 93.83,
      36097: 6.17,
    },
    county_names_all: "Chemung|Schuyler",
    county_fips_all: "36015|36097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14839,
    lat: 42.13961,
    lng: -77.64331,
    city: "Greenwood",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 881,
    density: 9.3,
    county_fips: 36101,
    county_name: "Steuben",
    county_weights: {
      36101: 100,
    },
    county_names_all: "Steuben",
    county_fips_all: 36101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14840,
    lat: 42.44119,
    lng: -77.18758,
    city: "Hammondsport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2730,
    density: 18,
    county_fips: 36101,
    county_name: "Steuben",
    county_weights: {
      36097: 0.57,
      36101: 99.43,
    },
    county_names_all: "Steuben|Schuyler",
    county_fips_all: "36101|36097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14841,
    lat: 42.52699,
    lng: -76.84249,
    city: "Hector",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 665,
    density: 12.7,
    county_fips: 36097,
    county_name: "Schuyler",
    county_weights: {
      36097: 73.32,
      36099: 26.68,
    },
    county_names_all: "Schuyler|Seneca",
    county_fips_all: "36097|36099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14842,
    lat: 42.59666,
    lng: -76.963,
    city: "Himrod",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1111,
    density: 27.3,
    county_fips: 36123,
    county_name: "Yates",
    county_weights: {
      36123: 100,
    },
    county_names_all: "Yates",
    county_fips_all: 36123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14843,
    lat: 42.32819,
    lng: -77.64371,
    city: "Hornell",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12447,
    density: 50.2,
    county_fips: 36101,
    county_name: "Steuben",
    county_weights: {
      36003: 3.66,
      36101: 96.34,
    },
    county_names_all: "Steuben|Allegany",
    county_fips_all: "36101|36003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14845,
    lat: 42.20225,
    lng: -76.8334,
    city: "Horseheads",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20401,
    density: 100.7,
    county_fips: 36015,
    county_name: "Chemung",
    county_weights: {
      36015: 100,
    },
    county_names_all: "Chemung",
    county_fips_all: 36015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14846,
    lat: 42.5301,
    lng: -78.00319,
    city: "Hunt",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 966,
    density: 10.8,
    county_fips: 36051,
    county_name: "Livingston",
    county_weights: {
      36003: 40.09,
      36051: 59.91,
    },
    county_names_all: "Livingston|Allegany",
    county_fips_all: "36051|36003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14847,
    lat: 42.6031,
    lng: -76.74047,
    city: "Interlaken",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2375,
    density: 22.7,
    county_fips: 36099,
    county_name: "Seneca",
    county_weights: {
      36097: 2.95,
      36099: 97.05,
    },
    county_names_all: "Seneca|Schuyler",
    county_fips_all: "36099|36097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14850,
    lat: 42.43249,
    lng: -76.49891,
    city: "Ithaca",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64224,
    density: 198.7,
    county_fips: 36109,
    county_name: "Tompkins",
    county_weights: {
      36109: 100,
    },
    county_names_all: "Tompkins",
    county_fips_all: 36109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14853,
    lat: 42.44727,
    lng: -76.48149,
    city: "Ithaca",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2663,
    density: 2671.9,
    county_fips: 36109,
    county_name: "Tompkins",
    county_weights: {
      36109: 100,
    },
    county_names_all: "Tompkins",
    county_fips_all: 36109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14854,
    lat: 42.51138,
    lng: -76.60874,
    city: "Jacksonville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 36109,
    county_name: "Tompkins",
    county_weights: {
      36109: 100,
    },
    county_names_all: "Tompkins",
    county_fips_all: 36109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14855,
    lat: 42.13978,
    lng: -77.50112,
    city: "Jasper",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 785,
    density: 10.4,
    county_fips: 36101,
    county_name: "Steuben",
    county_weights: {
      36101: 100,
    },
    county_names_all: "Steuben",
    county_fips_all: 36101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14856,
    lat: 42.37737,
    lng: -77.36944,
    city: "Kanona",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 275,
    density: 614.5,
    county_fips: 36101,
    county_name: "Steuben",
    county_weights: {
      36101: 100,
    },
    county_names_all: "Steuben",
    county_fips_all: 36101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14858,
    lat: 42.02909,
    lng: -77.13315,
    city: "Lindley",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1232,
    density: 13,
    county_fips: 36101,
    county_name: "Steuben",
    county_weights: {
      36101: 100,
    },
    county_names_all: "Steuben",
    county_fips_all: 36101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14859,
    lat: 42.12118,
    lng: -76.53985,
    city: "Lockwood",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1076,
    density: 13.3,
    county_fips: 36107,
    county_name: "Tioga",
    county_weights: {
      36015: 40.49,
      36107: 59.51,
    },
    county_names_all: "Tioga|Chemung",
    county_fips_all: "36107|36015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14860,
    lat: 42.59099,
    lng: -76.84201,
    city: "Lodi",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1132,
    density: 21.7,
    county_fips: 36099,
    county_name: "Seneca",
    county_weights: {
      36099: 100,
    },
    county_names_all: "Seneca",
    county_fips_all: 36099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14861,
    lat: 42.0914,
    lng: -76.6888,
    city: "Lowman",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1153,
    density: 12.6,
    county_fips: 36015,
    county_name: "Chemung",
    county_weights: {
      36015: 100,
    },
    county_names_all: "Chemung",
    county_fips_all: 36015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14864,
    lat: 42.2804,
    lng: -76.84205,
    city: "Millport",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 961,
    density: 30.6,
    county_fips: 36015,
    county_name: "Chemung",
    county_weights: {
      36015: 70.75,
      36097: 29.25,
    },
    county_names_all: "Chemung|Schuyler",
    county_fips_all: "36015|36097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14865,
    lat: 42.35091,
    lng: -76.83178,
    city: "Montour Falls",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2784,
    density: 48.5,
    county_fips: 36097,
    county_name: "Schuyler",
    county_weights: {
      36097: 100,
    },
    county_names_all: "Schuyler",
    county_fips_all: 36097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14867,
    lat: 42.34243,
    lng: -76.61461,
    city: "Newfield",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5431,
    density: 31,
    county_fips: 36109,
    county_name: "Tompkins",
    county_weights: {
      36015: 2.36,
      36109: 97.64,
    },
    county_names_all: "Tompkins|Chemung",
    county_fips_all: "36109|36015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14869,
    lat: 42.36403,
    lng: -76.77052,
    city: "Odessa",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1276,
    density: 26.2,
    county_fips: 36097,
    county_name: "Schuyler",
    county_weights: {
      36097: 100,
    },
    county_names_all: "Schuyler",
    county_fips_all: 36097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14870,
    lat: 42.16816,
    lng: -77.13234,
    city: "Painted Post",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10202,
    density: 61.1,
    county_fips: 36101,
    county_name: "Steuben",
    county_weights: {
      36097: 5.13,
      36101: 94.87,
    },
    county_names_all: "Steuben|Schuyler",
    county_fips_all: "36101|36097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14871,
    lat: 42.03838,
    lng: -76.91093,
    city: "Pine City",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5081,
    density: 37.1,
    county_fips: 36015,
    county_name: "Chemung",
    county_weights: {
      36015: 80.92,
      36101: 19.08,
    },
    county_names_all: "Chemung|Steuben",
    county_fips_all: "36015|36101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14872,
    lat: 42.24141,
    lng: -76.86473,
    city: "Pine Valley",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 547,
    density: 36.4,
    county_fips: 36015,
    county_name: "Chemung",
    county_weights: {
      36015: 100,
    },
    county_names_all: "Chemung",
    county_fips_all: 36015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14873,
    lat: 42.52181,
    lng: -77.29814,
    city: "Prattsburgh",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2328,
    density: 12.2,
    county_fips: 36101,
    county_name: "Steuben",
    county_weights: {
      36101: 100,
    },
    county_names_all: "Steuben",
    county_fips_all: 36101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14874,
    lat: 42.53231,
    lng: -77.17234,
    city: "Pulteney",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 260,
    density: 63.4,
    county_fips: 36101,
    county_name: "Steuben",
    county_weights: {
      36101: 100,
    },
    county_names_all: "Steuben",
    county_fips_all: 36101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14877,
    lat: 42.06181,
    lng: -77.68384,
    city: "Rexville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 583,
    density: 4.9,
    county_fips: 36101,
    county_name: "Steuben",
    county_weights: {
      36003: 0.1,
      36101: 99.9,
    },
    county_names_all: "Steuben|Allegany",
    county_fips_all: "36101|36003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14878,
    lat: 42.44946,
    lng: -76.94401,
    city: "Rock Stream",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 536,
    density: 12.9,
    county_fips: 36097,
    county_name: "Schuyler",
    county_weights: {
      36097: 75.15,
      36123: 24.85,
    },
    county_names_all: "Schuyler|Yates",
    county_fips_all: "36097|36123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14879,
    lat: 42.31521,
    lng: -77.19323,
    city: "Savona",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2257,
    density: 19.8,
    county_fips: 36101,
    county_name: "Steuben",
    county_weights: {
      36101: 100,
    },
    county_names_all: "Steuben",
    county_fips_all: 36101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14880,
    lat: 42.17363,
    lng: -77.97334,
    city: "Scio",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1847,
    density: 13.7,
    county_fips: 36003,
    county_name: "Allegany",
    county_weights: {
      36003: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 36003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14881,
    lat: 42.4017,
    lng: -76.35795,
    city: "Slaterville Springs",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 151,
    density: 38,
    county_fips: 36109,
    county_name: "Tompkins",
    county_weights: {
      36109: 100,
    },
    county_names_all: "Tompkins",
    county_fips_all: 36109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14882,
    lat: 42.5801,
    lng: -76.56576,
    city: "Lansing",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3998,
    density: 47.5,
    county_fips: 36109,
    county_name: "Tompkins",
    county_weights: {
      36109: 100,
    },
    county_names_all: "Tompkins",
    county_fips_all: 36109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14883,
    lat: 42.24056,
    lng: -76.482,
    city: "Spencer",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4808,
    density: 25.6,
    county_fips: 36107,
    county_name: "Tioga",
    county_weights: {
      36107: 69.85,
      36109: 30.15,
    },
    county_names_all: "Tioga|Tompkins",
    county_fips_all: "36107|36109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14884,
    lat: 42.47613,
    lng: -77.88724,
    city: "Swain",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 284,
    density: 4.8,
    county_fips: 36003,
    county_name: "Allegany",
    county_weights: {
      36003: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 36003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14885,
    lat: 42.048,
    lng: -77.57117,
    city: "Troupsburg",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 742,
    density: 6.7,
    county_fips: 36101,
    county_name: "Steuben",
    county_weights: {
      36101: 100,
    },
    county_names_all: "Steuben",
    county_fips_all: 36101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14886,
    lat: 42.50408,
    lng: -76.68836,
    city: "Trumansburg",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6490,
    density: 33.4,
    county_fips: 36109,
    county_name: "Tompkins",
    county_weights: {
      36097: 42.38,
      36099: 13.03,
      36109: 44.6,
    },
    county_names_all: "Tompkins|Schuyler|Seneca",
    county_fips_all: "36109|36097|36099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14889,
    lat: 42.21605,
    lng: -76.58138,
    city: "Van Etten",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1580,
    density: 14.3,
    county_fips: 36015,
    county_name: "Chemung",
    county_weights: {
      36015: 87.3,
      36097: 8.62,
      36107: 4.08,
    },
    county_names_all: "Chemung|Schuyler|Tioga",
    county_fips_all: "36015|36097|36107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14891,
    lat: 42.37823,
    lng: -76.95035,
    city: "Watkins Glen",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4536,
    density: 32.2,
    county_fips: 36097,
    county_name: "Schuyler",
    county_weights: {
      36097: 100,
    },
    county_names_all: "Schuyler",
    county_fips_all: 36097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14892,
    lat: 42.0478,
    lng: -76.52804,
    city: "Waverly",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7748,
    density: 70.8,
    county_fips: 36107,
    county_name: "Tioga",
    county_weights: {
      36015: 32.81,
      36107: 67.19,
    },
    county_names_all: "Tioga|Chemung",
    county_fips_all: "36107|36015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14893,
    lat: 42.46952,
    lng: -77.11182,
    city: "Wayne",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 36101,
    county_name: "Steuben",
    county_weights: {
      36097: 2.06,
      36101: 97.94,
    },
    county_names_all: "Steuben|Schuyler",
    county_fips_all: "36101|36097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14894,
    lat: 42.02442,
    lng: -76.77185,
    city: "Wellsburg",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1051,
    density: 33.3,
    county_fips: 36015,
    county_name: "Chemung",
    county_weights: {
      36015: 100,
    },
    county_names_all: "Chemung",
    county_fips_all: 36015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14895,
    lat: 42.07772,
    lng: -77.93387,
    city: "Wellsville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8957,
    density: 29.8,
    county_fips: 36003,
    county_name: "Allegany",
    county_weights: {
      36003: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 36003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14897,
    lat: 42.02949,
    lng: -77.79076,
    city: "Whitesville",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 772,
    density: 12.1,
    county_fips: 36003,
    county_name: "Allegany",
    county_weights: {
      36003: 92.01,
      36101: 7.99,
    },
    county_names_all: "Allegany|Steuben",
    county_fips_all: "36003|36101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14898,
    lat: 42.05729,
    lng: -77.43482,
    city: "Woodhull",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1772,
    density: 11.2,
    county_fips: 36101,
    county_name: "Steuben",
    county_weights: {
      36101: 100,
    },
    county_names_all: "Steuben",
    county_fips_all: 36101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14901,
    lat: 42.07363,
    lng: -76.74137,
    city: "Elmira",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15581,
    density: 181.2,
    county_fips: 36015,
    county_name: "Chemung",
    county_weights: {
      36015: 100,
    },
    county_names_all: "Chemung",
    county_fips_all: 36015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14903,
    lat: 42.12372,
    lng: -76.87771,
    city: "Elmira",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7186,
    density: 128.2,
    county_fips: 36015,
    county_name: "Chemung",
    county_weights: {
      36015: 100,
    },
    county_names_all: "Chemung",
    county_fips_all: 36015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14904,
    lat: 42.07007,
    lng: -76.80798,
    city: "Elmira",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15109,
    density: 904.6,
    county_fips: 36015,
    county_name: "Chemung",
    county_weights: {
      36015: 100,
    },
    county_names_all: "Chemung",
    county_fips_all: 36015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 14905,
    lat: 42.08692,
    lng: -76.84284,
    city: "Elmira",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8330,
    density: 866.8,
    county_fips: 36015,
    county_name: "Chemung",
    county_weights: {
      36015: 100,
    },
    county_names_all: "Chemung",
    county_fips_all: 36015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15001,
    lat: 40.59161,
    lng: -80.32078,
    city: "Aliquippa",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31129,
    density: 199.2,
    county_fips: 42007,
    county_name: "Beaver",
    county_weights: {
      42007: 100,
    },
    county_names_all: "Beaver",
    county_fips_all: 42007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15003,
    lat: 40.60153,
    lng: -80.21415,
    city: "Ambridge",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11212,
    density: 723.6,
    county_fips: 42007,
    county_name: "Beaver",
    county_weights: {
      42003: 4.92,
      42007: 95.08,
    },
    county_names_all: "Beaver|Allegheny",
    county_fips_all: "42007|42003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15004,
    lat: 40.34216,
    lng: -80.38289,
    city: "Atlasburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 380,
    density: 1292.9,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15005,
    lat: 40.64431,
    lng: -80.17607,
    city: "Baden",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9191,
    density: 220.1,
    county_fips: 42007,
    county_name: "Beaver",
    county_weights: {
      42003: 25.96,
      42007: 74.04,
    },
    county_names_all: "Beaver|Allegheny",
    county_fips_all: "42007|42003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15006,
    lat: 40.63351,
    lng: -79.87678,
    city: "Bairdford",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 292,
    density: 466.9,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15007,
    lat: 40.65128,
    lng: -79.93173,
    city: "Bakerstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 629,
    density: 606.1,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15009,
    lat: 40.69933,
    lng: -80.36464,
    city: "Beaver",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15114,
    density: 250.4,
    county_fips: 42007,
    county_name: "Beaver",
    county_weights: {
      42007: 100,
    },
    county_names_all: "Beaver",
    county_fips_all: 42007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15010,
    lat: 40.76829,
    lng: -80.35873,
    city: "Beaver Falls",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27205,
    density: 205.8,
    county_fips: 42007,
    county_name: "Beaver",
    county_weights: {
      42007: 100,
    },
    county_names_all: "Beaver",
    county_fips_all: 42007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15012,
    lat: 40.15871,
    lng: -79.81188,
    city: "Belle Vernon",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15243,
    density: 172.5,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42051: 14.9,
      42125: 0.5,
      42129: 84.6,
    },
    county_names_all: "Westmoreland|Fayette|Washington",
    county_fips_all: "42129|42051|42125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15014,
    lat: 40.60859,
    lng: -79.74149,
    city: "Brackenridge",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3055,
    density: 2418.2,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15015,
    lat: 40.63622,
    lng: -80.08164,
    city: "Bradfordwoods",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1267,
    density: 524.3,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15017,
    lat: 40.34348,
    lng: -80.12865,
    city: "Bridgeville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15363,
    density: 486.2,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 86.7,
      42125: 13.3,
    },
    county_names_all: "Allegheny|Washington",
    county_fips_all: "42003|42125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15018,
    lat: 40.26924,
    lng: -79.79805,
    city: "Buena Vista",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1296,
    density: 611.2,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15019,
    lat: 40.40805,
    lng: -80.33053,
    city: "Bulger",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1617,
    density: 26.9,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42003: 0.12,
      42125: 99.88,
    },
    county_names_all: "Washington|Allegheny",
    county_fips_all: "42125|42003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15020,
    lat: 40.2283,
    lng: -79.9479,
    city: "Bunola",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36,
    density: 5.8,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15021,
    lat: 40.39373,
    lng: -80.43583,
    city: "Burgettstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7093,
    density: 29.7,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42007: 0.51,
      42125: 99.49,
    },
    county_names_all: "Washington|Beaver",
    county_fips_all: "42125|42007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15022,
    lat: 40.13329,
    lng: -79.93661,
    city: "Charleroi",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9692,
    density: 202.9,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15024,
    lat: 40.57649,
    lng: -79.84649,
    city: "Cheswick",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8555,
    density: 188.2,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15025,
    lat: 40.29887,
    lng: -79.9213,
    city: "Clairton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15911,
    density: 368.9,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15026,
    lat: 40.51043,
    lng: -80.35662,
    city: "Clinton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3324,
    density: 37.1,
    county_fips: 42007,
    county_name: "Beaver",
    county_weights: {
      42003: 23.38,
      42007: 72.01,
      42125: 4.61,
    },
    county_names_all: "Beaver|Allegheny|Washington",
    county_fips_all: "42007|42003|42125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15027,
    lat: 40.66706,
    lng: -80.23988,
    city: "Conway",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2287,
    density: 637.7,
    county_fips: 42007,
    county_name: "Beaver",
    county_weights: {
      42007: 100,
    },
    county_names_all: "Beaver",
    county_fips_all: 42007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15028,
    lat: 40.30194,
    lng: -79.79891,
    city: "Coulters",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 143,
    density: 275.2,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15030,
    lat: 40.58492,
    lng: -79.78074,
    city: "Creighton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1124,
    density: 288.9,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 99.83,
      42129: 0.17,
    },
    county_names_all: "Allegheny|Westmoreland",
    county_fips_all: "42003|42129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15031,
    lat: 40.34802,
    lng: -80.16235,
    city: "Cuddy",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 451,
    density: 553,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15033,
    lat: 40.18011,
    lng: -79.86501,
    city: "Donora",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4675,
    density: 759.6,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 99.87,
      42129: 0.13,
    },
    county_names_all: "Washington|Westmoreland",
    county_fips_all: "42125|42129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15034,
    lat: 40.35083,
    lng: -79.89067,
    city: "Dravosburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1710,
    density: 683.2,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15035,
    lat: 40.38488,
    lng: -79.80726,
    city: "East McKeesport",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1885,
    density: 1727.9,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15037,
    lat: 40.25649,
    lng: -79.85017,
    city: "Elizabeth",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10239,
    density: 152.1,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15038,
    lat: 40.2499,
    lng: -79.92379,
    city: "Elrama",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 470,
    density: 618,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15042,
    lat: 40.68786,
    lng: -80.20411,
    city: "Freedom",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7951,
    density: 181.7,
    county_fips: 42007,
    county_name: "Beaver",
    county_weights: {
      42007: 100,
    },
    county_names_all: "Beaver",
    county_fips_all: 42007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15043,
    lat: 40.55585,
    lng: -80.48994,
    city: "Georgetown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2228,
    density: 27.1,
    county_fips: 42007,
    county_name: "Beaver",
    county_weights: {
      42007: 100,
    },
    county_names_all: "Beaver",
    county_fips_all: 42007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15044,
    lat: 40.64009,
    lng: -79.9492,
    city: "Gibsonia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28105,
    density: 277.9,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 96.7,
      42019: 3.3,
    },
    county_names_all: "Allegheny|Butler",
    county_fips_all: "42003|42019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15045,
    lat: 40.32613,
    lng: -79.88614,
    city: "Glassport",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4338,
    density: 1059,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15046,
    lat: 40.55618,
    lng: -80.22868,
    city: "Crescent",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2573,
    density: 475,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15047,
    lat: 40.3123,
    lng: -79.79513,
    city: "Greenock",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74,
    density: 163.9,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15049,
    lat: 40.55545,
    lng: -79.80366,
    city: "Harwick",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 904,
    density: 622.5,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15050,
    lat: 40.5617,
    lng: -80.44038,
    city: "Hookstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2690,
    density: 44.1,
    county_fips: 42007,
    county_name: "Beaver",
    county_weights: {
      42007: 100,
    },
    county_names_all: "Beaver",
    county_fips_all: 42007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15051,
    lat: 40.56812,
    lng: -79.86076,
    city: "Indianola",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 466,
    density: 378.1,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15052,
    lat: 40.6669,
    lng: -80.43318,
    city: "Industry",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2958,
    density: 59.9,
    county_fips: 42007,
    county_name: "Beaver",
    county_weights: {
      42007: 100,
    },
    county_names_all: "Beaver",
    county_fips_all: 42007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15053,
    lat: 40.38056,
    lng: -80.35975,
    city: "Joffre",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 107,
    density: 364.9,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15054,
    lat: 40.36353,
    lng: -80.4008,
    city: "Langeloth",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 315,
    density: 147.1,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15055,
    lat: 40.30642,
    lng: -80.12296,
    city: "Lawrence",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1030,
    density: 596.7,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15056,
    lat: 40.56512,
    lng: -80.21407,
    city: "Leetsdale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1063,
    density: 433.1,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15057,
    lat: 40.35571,
    lng: -80.24713,
    city: "McDonald",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16834,
    density: 120.2,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42003: 34.57,
      42125: 65.43,
    },
    county_names_all: "Washington|Allegheny",
    county_fips_all: "42125|42003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15059,
    lat: 40.68056,
    lng: -80.49182,
    city: "Midland",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4227,
    density: 111.5,
    county_fips: 42007,
    county_name: "Beaver",
    county_weights: {
      42007: 100,
    },
    county_names_all: "Beaver",
    county_fips_all: 42007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15060,
    lat: 40.37695,
    lng: -80.29113,
    city: "Midway",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 873,
    density: 420.7,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15061,
    lat: 40.66013,
    lng: -80.31082,
    city: "Monaca",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12178,
    density: 272,
    county_fips: 42007,
    county_name: "Beaver",
    county_weights: {
      42007: 100,
    },
    county_names_all: "Beaver",
    county_fips_all: 42007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15062,
    lat: 40.15184,
    lng: -79.88277,
    city: "Monessen",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7287,
    density: 972.4,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42125: 0.12,
      42129: 99.88,
    },
    county_names_all: "Westmoreland|Washington",
    county_fips_all: "42129|42125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15063,
    lat: 40.19487,
    lng: -79.92228,
    city: "Monongahela",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11511,
    density: 162,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42003: 39.14,
      42125: 60.86,
    },
    county_names_all: "Washington|Allegheny",
    county_fips_all: "42125|42003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15064,
    lat: 40.35538,
    lng: -80.14849,
    city: "Morgan",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 257,
    density: 154.3,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15065,
    lat: 40.64192,
    lng: -79.72766,
    city: "Natrona Heights",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11280,
    density: 349.6,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15066,
    lat: 40.75119,
    lng: -80.25269,
    city: "New Brighton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12487,
    density: 222.8,
    county_fips: 42007,
    county_name: "Beaver",
    county_weights: {
      42007: 100,
    },
    county_names_all: "Beaver",
    county_fips_all: 42007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15067,
    lat: 40.20823,
    lng: -79.96106,
    city: "New Eagle",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2532,
    density: 564.5,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15068,
    lat: 40.56241,
    lng: -79.7124,
    city: "New Kensington",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37442,
    density: 318.1,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42003: 22.16,
      42129: 77.84,
    },
    county_names_all: "Westmoreland|Allegheny",
    county_fips_all: "42129|42003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15071,
    lat: 40.41486,
    lng: -80.18981,
    city: "Oakdale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11595,
    density: 243.9,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15072,
    lat: 40.13922,
    lng: -79.85605,
    city: "Pricedale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8,
    density: 52.4,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15074,
    lat: 40.72837,
    lng: -80.21937,
    city: "Rochester",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8190,
    density: 212.7,
    county_fips: 42007,
    county_name: "Beaver",
    county_weights: {
      42007: 100,
    },
    county_names_all: "Beaver",
    county_fips_all: 42007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15075,
    lat: 40.58665,
    lng: -79.82693,
    city: "Rural Ridge",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50,
    density: 703,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15076,
    lat: 40.60949,
    lng: -79.8374,
    city: "Russellton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 723,
    density: 223.4,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15077,
    lat: 40.62517,
    lng: -80.4173,
    city: "Shippingport",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 192,
    density: 88.6,
    county_fips: 42007,
    county_name: "Beaver",
    county_weights: {
      42007: 100,
    },
    county_names_all: "Beaver",
    county_fips_all: 42007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15078,
    lat: 40.35949,
    lng: -80.38501,
    city: "Slovan",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 441,
    density: 288.4,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15081,
    lat: 40.57471,
    lng: -80.23614,
    city: "South Heights",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 310,
    density: 386.2,
    county_fips: 42007,
    county_name: "Beaver",
    county_weights: {
      42007: 100,
    },
    county_names_all: "Beaver",
    county_fips_all: 42007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15082,
    lat: 40.38031,
    lng: -80.21061,
    city: "Sturgeon",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 153,
    density: 225.8,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15083,
    lat: 40.24802,
    lng: -79.79041,
    city: "Sutersville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 750,
    density: 75.9,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42003: 13.14,
      42129: 86.86,
    },
    county_names_all: "Westmoreland|Allegheny",
    county_fips_all: "42129|42003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15084,
    lat: 40.6282,
    lng: -79.8028,
    city: "Tarentum",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10034,
    density: 133.9,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15085,
    lat: 40.38497,
    lng: -79.72539,
    city: "Trafford",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7479,
    density: 312.6,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42003: 2.41,
      42129: 97.59,
    },
    county_names_all: "Westmoreland|Allegheny",
    county_fips_all: "42129|42003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15086,
    lat: 40.664,
    lng: -80.09593,
    city: "Warrendale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 422,
    density: 87.5,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 75.35,
      42019: 24.65,
    },
    county_names_all: "Allegheny|Butler",
    county_fips_all: "42003|42019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15087,
    lat: 40.19504,
    lng: -79.84948,
    city: "Webster",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 73,
    density: 22.4,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15088,
    lat: 40.27159,
    lng: -79.89607,
    city: "West Elizabeth",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 507,
    density: 1187.6,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15089,
    lat: 40.22063,
    lng: -79.73719,
    city: "West Newton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6476,
    density: 139.3,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42003: 1.43,
      42129: 98.57,
    },
    county_names_all: "Westmoreland|Allegheny",
    county_fips_all: "42129|42003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15090,
    lat: 40.62587,
    lng: -80.06766,
    city: "Wexford",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23970,
    density: 423.2,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15101,
    lat: 40.58139,
    lng: -79.95531,
    city: "Allison Park",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25594,
    density: 460.2,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15102,
    lat: 40.32125,
    lng: -80.03707,
    city: "Bethel Park",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29419,
    density: 1069.2,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 99.12,
      42125: 0.88,
    },
    county_names_all: "Allegheny|Washington",
    county_fips_all: "42003|42125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15104,
    lat: 40.40379,
    lng: -79.86249,
    city: "Braddock",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8492,
    density: 1329,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15106,
    lat: 40.40882,
    lng: -80.10863,
    city: "Carnegie",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19438,
    density: 753.2,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15108,
    lat: 40.50006,
    lng: -80.20031,
    city: "Coraopolis",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41447,
    density: 404.9,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15110,
    lat: 40.37321,
    lng: -79.85024,
    city: "Duquesne",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5534,
    density: 1176.5,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15112,
    lat: 40.40453,
    lng: -79.83734,
    city: "East Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3073,
    density: 1415,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15116,
    lat: 40.5384,
    lng: -79.95211,
    city: "Glenshaw",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14088,
    density: 705.6,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15120,
    lat: 40.39597,
    lng: -79.90689,
    city: "Homestead",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18424,
    density: 1517.4,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15122,
    lat: 40.35976,
    lng: -79.90628,
    city: "West Mifflin",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19500,
    density: 582.3,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15123,
    lat: 40.34817,
    lng: -79.93471,
    city: "West Mifflin",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15126,
    lat: 40.46019,
    lng: -80.28727,
    city: "Imperial",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6805,
    density: 133.1,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 99.27,
      42125: 0.73,
    },
    county_names_all: "Allegheny|Washington",
    county_fips_all: "42003|42125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15129,
    lat: 40.29348,
    lng: -79.99515,
    city: "South Park",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10363,
    density: 516.6,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 98.06,
      42125: 1.94,
    },
    county_names_all: "Allegheny|Washington",
    county_fips_all: "42003|42125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15131,
    lat: 40.33477,
    lng: -79.80132,
    city: "Mckeesport",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7960,
    density: 465.3,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 94.83,
      42129: 5.17,
    },
    county_names_all: "Allegheny|Westmoreland",
    county_fips_all: "42003|42129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15132,
    lat: 40.33982,
    lng: -79.84299,
    city: "Mckeesport",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20915,
    density: 1433.9,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15133,
    lat: 40.3257,
    lng: -79.86127,
    city: "Mckeesport",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6173,
    density: 707.4,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15135,
    lat: 40.29959,
    lng: -79.81153,
    city: "Mckeesport",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5004,
    density: 383,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15136,
    lat: 40.46872,
    lng: -80.10233,
    city: "McKees Rocks",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22183,
    density: 796.9,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15137,
    lat: 40.37762,
    lng: -79.80902,
    city: "North Versailles",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10215,
    density: 501.4,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15139,
    lat: 40.52192,
    lng: -79.83479,
    city: "Oakmont",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6504,
    density: 1306.2,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15140,
    lat: 40.4073,
    lng: -79.7783,
    city: "Pitcairn",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3180,
    density: 2000,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15142,
    lat: 40.38474,
    lng: -80.12231,
    city: "Presto",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 957,
    density: 164.1,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15143,
    lat: 40.57298,
    lng: -80.14725,
    city: "Sewickley",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21966,
    density: 229.8,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 90.26,
      42007: 9.74,
    },
    county_names_all: "Allegheny|Beaver",
    county_fips_all: "42003|42007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15144,
    lat: 40.54759,
    lng: -79.78317,
    city: "Springdale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4002,
    density: 743.4,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15145,
    lat: 40.41451,
    lng: -79.82352,
    city: "Turtle Creek",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6982,
    density: 1406.4,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15146,
    lat: 40.4264,
    lng: -79.76005,
    city: "Monroeville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27541,
    density: 541.9,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 99.63,
      42129: 0.37,
    },
    county_names_all: "Allegheny|Westmoreland",
    county_fips_all: "42003|42129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15147,
    lat: 40.49704,
    lng: -79.82858,
    city: "Verona",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16693,
    density: 643.8,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15148,
    lat: 40.39351,
    lng: -79.79525,
    city: "Wilmerding",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2423,
    density: 839.5,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15201,
    lat: 40.47565,
    lng: -79.95389,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12922,
    density: 2591.6,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15202,
    lat: 40.50566,
    lng: -80.06902,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19261,
    density: 1660.6,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15203,
    lat: 40.4257,
    lng: -79.97491,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10782,
    density: 2805.7,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15204,
    lat: 40.45597,
    lng: -80.06051,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7905,
    density: 1623.2,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15205,
    lat: 40.4381,
    lng: -80.10552,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21379,
    density: 706.6,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15206,
    lat: 40.47244,
    lng: -79.91324,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29197,
    density: 2366.4,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15207,
    lat: 40.39813,
    lng: -79.9334,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10522,
    density: 894.9,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15208,
    lat: 40.45387,
    lng: -79.89883,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8916,
    density: 2297.8,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15209,
    lat: 40.50007,
    lng: -79.97463,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12087,
    density: 968.5,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15210,
    lat: 40.40679,
    lng: -79.98411,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26875,
    density: 2205.1,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15211,
    lat: 40.4302,
    lng: -80.01533,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10457,
    density: 2548.8,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15212,
    lat: 40.47106,
    lng: -80.00844,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27067,
    density: 1802.6,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15213,
    lat: 40.44293,
    lng: -79.95345,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27347,
    density: 4327.2,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15214,
    lat: 40.48541,
    lng: -80.01455,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14203,
    density: 1191.3,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15215,
    lat: 40.50457,
    lng: -79.91338,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12637,
    density: 788.4,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15216,
    lat: 40.40268,
    lng: -80.0348,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22670,
    density: 2546.9,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15217,
    lat: 40.43083,
    lng: -79.91999,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27566,
    density: 2751.3,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15218,
    lat: 40.42366,
    lng: -79.88924,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13495,
    density: 2273.4,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15219,
    lat: 40.44304,
    lng: -79.98443,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16101,
    density: 2824.9,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15220,
    lat: 40.41875,
    lng: -80.04894,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17401,
    density: 1420.8,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15221,
    lat: 40.43457,
    lng: -79.86631,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29451,
    density: 1831,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15222,
    lat: 40.44998,
    lng: -79.9912,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5468,
    density: 2383.4,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15223,
    lat: 40.50431,
    lng: -79.95199,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6493,
    density: 1345.8,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15224,
    lat: 40.46737,
    lng: -79.94623,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11079,
    density: 2803.1,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15225,
    lat: 40.50636,
    lng: -80.1116,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1006,
    density: 253.7,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15226,
    lat: 40.39527,
    lng: -80.01374,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13925,
    density: 2156.4,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15227,
    lat: 40.375,
    lng: -79.97077,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27774,
    density: 1754.1,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15228,
    lat: 40.37075,
    lng: -80.04395,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17508,
    density: 2122.2,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15229,
    lat: 40.51995,
    lng: -80.03866,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14378,
    density: 1372.2,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15232,
    lat: 40.45246,
    lng: -79.93193,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12017,
    density: 5671.1,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15233,
    lat: 40.45985,
    lng: -80.03387,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3466,
    density: 1024.3,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15234,
    lat: 40.36808,
    lng: -80.01782,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13711,
    density: 1700.5,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15235,
    lat: 40.45968,
    lng: -79.82194,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34339,
    density: 895,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15236,
    lat: 40.34756,
    lng: -79.97652,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28499,
    density: 1027.3,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15237,
    lat: 40.54834,
    lng: -80.04682,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41264,
    density: 662.4,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15238,
    lat: 40.53405,
    lng: -79.88115,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12358,
    density: 302.3,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15239,
    lat: 40.48437,
    lng: -79.73753,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20523,
    density: 484.9,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15241,
    lat: 40.33293,
    lng: -80.08291,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20952,
    density: 791.5,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 99.01,
      42125: 0.99,
    },
    county_names_all: "Allegheny|Washington",
    county_fips_all: "42003|42125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15243,
    lat: 40.37474,
    lng: -80.07305,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12991,
    density: 1663.8,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15260,
    lat: 40.4432,
    lng: -79.95306,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15275,
    lat: 40.45246,
    lng: -80.18405,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15282,
    lat: 40.43602,
    lng: -79.99042,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15290,
    lat: 40.45735,
    lng: -80.01932,
    city: "Pittsburgh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 42003,
    county_name: "Allegheny",
    county_weights: {
      42003: 100,
    },
    county_names_all: "Allegheny",
    county_fips_all: 42003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15301,
    lat: 40.16411,
    lng: -80.25304,
    city: "Washington",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49238,
    density: 155.9,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15310,
    lat: 39.79255,
    lng: -80.48108,
    city: "Aleppo",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 242,
    density: 4.8,
    county_fips: 42059,
    county_name: "Greene",
    county_weights: {
      42059: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 42059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15311,
    lat: 40.04608,
    lng: -80.18592,
    city: "Amity",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1369,
    density: 22.4,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15312,
    lat: 40.25404,
    lng: -80.43757,
    city: "Avella",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4009,
    density: 21.6,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15313,
    lat: 40.06318,
    lng: -80.02937,
    city: "Beallsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 355,
    density: 70.4,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15314,
    lat: 40.14555,
    lng: -80.01775,
    city: "Bentleyville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3478,
    density: 78.9,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15315,
    lat: 39.75741,
    lng: -79.98319,
    city: "Bobtown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 648,
    density: 278.6,
    county_fips: 42059,
    county_name: "Greene",
    county_weights: {
      42059: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 42059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15316,
    lat: 39.76514,
    lng: -80.26185,
    city: "Brave",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42059,
    county_name: "Greene",
    county_weights: {
      42059: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 42059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15317,
    lat: 40.27105,
    lng: -80.16535,
    city: "Canonsburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39823,
    density: 341.3,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15320,
    lat: 39.87386,
    lng: -79.99768,
    city: "Carmichaels",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5157,
    density: 53.5,
    county_fips: 42059,
    county_name: "Greene",
    county_weights: {
      42059: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 42059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15321,
    lat: 40.32167,
    lng: -80.18716,
    city: "Cecil",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1497,
    density: 302.9,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42003: 13.9,
      42125: 86.1,
    },
    county_names_all: "Washington|Allegheny",
    county_fips_all: "42125|42003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15322,
    lat: 39.97655,
    lng: -80.0488,
    city: "Clarksville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1655,
    density: 42.6,
    county_fips: 42059,
    county_name: "Greene",
    county_weights: {
      42059: 80.47,
      42125: 19.53,
    },
    county_names_all: "Greene|Washington",
    county_fips_all: "42059|42125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15323,
    lat: 40.10845,
    lng: -80.40926,
    city: "Claysville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4265,
    density: 23,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15324,
    lat: 40.10074,
    lng: -80.0654,
    city: "Cokeburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 671,
    density: 907.1,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15325,
    lat: 39.94893,
    lng: -79.96331,
    city: "Crucible",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 341,
    density: 507.4,
    county_fips: 42059,
    county_name: "Greene",
    county_weights: {
      42059: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 42059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15327,
    lat: 39.75088,
    lng: -79.96293,
    city: "Dilliner",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1521,
    density: 29.3,
    county_fips: 42059,
    county_name: "Greene",
    county_weights: {
      42059: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 42059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15329,
    lat: 40.02813,
    lng: -80.27205,
    city: "Prosperity",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1547,
    density: 13.9,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42059: 28.06,
      42125: 71.94,
    },
    county_names_all: "Washington|Greene",
    county_fips_all: "42125|42059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15330,
    lat: 40.18227,
    lng: -80.09492,
    city: "Eighty Four",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5039,
    density: 44,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15331,
    lat: 40.10754,
    lng: -80.02214,
    city: "Ellsworth",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 753,
    density: 375.1,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15332,
    lat: 40.24226,
    lng: -79.99134,
    city: "Finleyville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8616,
    density: 124.6,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42003: 12.96,
      42125: 87.04,
    },
    county_names_all: "Washington|Allegheny",
    county_fips_all: "42125|42003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15333,
    lat: 40.02693,
    lng: -80.01429,
    city: "Fredericktown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1926,
    density: 51.8,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15334,
    lat: 39.81292,
    lng: -79.9673,
    city: "Garards Fort",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 251,
    density: 34.8,
    county_fips: 42059,
    county_name: "Greene",
    county_weights: {
      42059: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 42059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15337,
    lat: 39.9505,
    lng: -80.37521,
    city: "Graysville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 447,
    density: 5.2,
    county_fips: 42059,
    county_name: "Greene",
    county_weights: {
      42059: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 42059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15338,
    lat: 39.81654,
    lng: -79.96206,
    city: "Greensboro",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1789,
    density: 44.8,
    county_fips: 42059,
    county_name: "Greene",
    county_weights: {
      42059: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 42059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15340,
    lat: 40.28654,
    lng: -80.32258,
    city: "Hickory",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1172,
    density: 30.1,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15341,
    lat: 39.82381,
    lng: -80.34728,
    city: "Holbrook",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 772,
    density: 5.7,
    county_fips: 42059,
    county_name: "Greene",
    county_weights: {
      42059: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 42059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15342,
    lat: 40.24533,
    lng: -80.22061,
    city: "Houston",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4892,
    density: 589.2,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15344,
    lat: 39.92289,
    lng: -80.05068,
    city: "Jefferson",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1628,
    density: 41.7,
    county_fips: 42059,
    county_name: "Greene",
    county_weights: {
      42059: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 42059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15345,
    lat: 40.02173,
    lng: -80.10743,
    city: "Marianna",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1370,
    density: 25,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42059: 3.68,
      42125: 96.32,
    },
    county_names_all: "Washington|Greene",
    county_fips_all: "42125|42059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15346,
    lat: 39.93545,
    lng: -80.07536,
    city: "Mather",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 495,
    density: 209.5,
    county_fips: 42059,
    county_name: "Greene",
    county_weights: {
      42059: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 42059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15347,
    lat: 40.21807,
    lng: -80.22469,
    city: "Meadow Lands",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 345,
    density: 279,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15348,
    lat: 39.98748,
    lng: -79.99624,
    city: "Millsboro",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 186,
    density: 533.8,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42051: 0.36,
      42125: 99.64,
    },
    county_names_all: "Washington|Fayette",
    county_fips_all: "42125|42051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15349,
    lat: 39.75885,
    lng: -80.07795,
    city: "Mount Morris",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1497,
    density: 13.9,
    county_fips: 42059,
    county_name: "Greene",
    county_weights: {
      42059: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 42059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15350,
    lat: 40.29377,
    lng: -80.20056,
    city: "Muse",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 490,
    density: 2333,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15351,
    lat: 39.87827,
    lng: -79.93068,
    city: "Nemacolin",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 943,
    density: 225.2,
    county_fips: 42059,
    county_name: "Greene",
    county_weights: {
      42059: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 42059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15352,
    lat: 39.75418,
    lng: -80.40253,
    city: "New Freeport",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 939,
    density: 8.1,
    county_fips: 42059,
    county_name: "Greene",
    county_weights: {
      42059: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 42059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15353,
    lat: 39.96223,
    lng: -80.31107,
    city: "Nineveh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 134,
    density: 914.2,
    county_fips: 42059,
    county_name: "Greene",
    county_weights: {
      42059: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 42059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15357,
    lat: 39.93721,
    lng: -79.98153,
    city: "Rices Landing",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1513,
    density: 73.9,
    county_fips: 42059,
    county_name: "Greene",
    county_weights: {
      42059: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 42059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15358,
    lat: 40.055,
    lng: -80.00309,
    city: "Richeyville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1058,
    density: 519.8,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15359,
    lat: 39.87667,
    lng: -80.27555,
    city: "Rogersville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 203,
    density: 530.2,
    county_fips: 42059,
    county_name: "Greene",
    county_weights: {
      42059: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 42059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15360,
    lat: 40.08846,
    lng: -80.08144,
    city: "Scenery Hill",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1785,
    density: 24.9,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15361,
    lat: 40.33277,
    lng: -80.2623,
    city: "Southview",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 224,
    density: 231.7,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15362,
    lat: 39.75821,
    lng: -80.21301,
    city: "Spraggs",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 733,
    density: 12.2,
    county_fips: 42059,
    county_name: "Greene",
    county_weights: {
      42059: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 42059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15363,
    lat: 40.25159,
    lng: -80.19761,
    city: "Strabane",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 418,
    density: 709.8,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15364,
    lat: 39.94557,
    lng: -80.2849,
    city: "Sycamore",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 784,
    density: 9.4,
    county_fips: 42059,
    county_name: "Greene",
    county_weights: {
      42059: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 42059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15365,
    lat: 40.15564,
    lng: -80.38548,
    city: "Taylorstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15366,
    lat: 40.1598,
    lng: -79.974,
    city: "Van Voorhis",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 478,
    density: 506.3,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15367,
    lat: 40.26321,
    lng: -80.05474,
    city: "Venetia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9559,
    density: 361.1,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15368,
    lat: 40.0145,
    lng: -79.9892,
    city: "Vestaburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 357,
    density: 723.5,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15370,
    lat: 39.8734,
    lng: -80.17991,
    city: "Waynesburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13994,
    density: 36.5,
    county_fips: 42059,
    county_name: "Greene",
    county_weights: {
      42059: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 42059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15376,
    lat: 40.10493,
    lng: -80.48744,
    city: "West Alexander",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1547,
    density: 15.7,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15377,
    lat: 39.97973,
    lng: -80.45083,
    city: "West Finley",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 689,
    density: 6.4,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42059: 30.73,
      42125: 69.27,
    },
    county_names_all: "Washington|Greene",
    county_fips_all: "42125|42059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15378,
    lat: 40.27771,
    lng: -80.27433,
    city: "Westland",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45,
    density: 236.4,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15379,
    lat: 40.2432,
    lng: -80.42519,
    city: "West Middletown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 108,
    density: 104.2,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15380,
    lat: 39.8725,
    lng: -80.4692,
    city: "Wind Ridge",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 655,
    density: 6.9,
    county_fips: 42059,
    county_name: "Greene",
    county_weights: {
      42059: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 42059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15401,
    lat: 39.89914,
    lng: -79.74965,
    city: "Uniontown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30401,
    density: 211.9,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15410,
    lat: 39.91246,
    lng: -79.90352,
    city: "Adah",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1422,
    density: 59.5,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15411,
    lat: 39.74724,
    lng: -79.34344,
    city: "Addison",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 629,
    density: 12.9,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15412,
    lat: 40.09496,
    lng: -79.85218,
    city: "Allenport",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 426,
    density: 105.6,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15413,
    lat: 39.98493,
    lng: -79.87141,
    city: "Allison",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 347,
    density: 238.5,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15416,
    lat: 39.85903,
    lng: -79.72286,
    city: "Brownfield",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15417,
    lat: 40.01466,
    lng: -79.91464,
    city: "Brownsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8398,
    density: 159.1,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42051: 49.43,
      42125: 50.57,
    },
    county_names_all: "Washington|Fayette",
    county_fips_all: "42125|42051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15419,
    lat: 40.05861,
    lng: -79.89408,
    city: "California",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4333,
    density: 1299.7,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42051: 0.58,
      42125: 99.42,
    },
    county_names_all: "Washington|Fayette",
    county_fips_all: "42125|42051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15420,
    lat: 39.95981,
    lng: -79.86537,
    city: "Cardale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 250,
    density: 201,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15421,
    lat: 39.84527,
    lng: -79.59743,
    city: "Chalk Hill",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39,
    density: 56.2,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15422,
    lat: 39.9781,
    lng: -79.80927,
    city: "Chestnut Ridge",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 140,
    density: 165.8,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15423,
    lat: 40.08804,
    lng: -79.92538,
    city: "Coal Center",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2487,
    density: 56.1,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15424,
    lat: 39.829,
    lng: -79.35377,
    city: "Confluence",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2006,
    density: 10.8,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42051: 26.08,
      42111: 73.92,
    },
    county_names_all: "Somerset|Fayette",
    county_fips_all: "42111|42051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15425,
    lat: 40.02702,
    lng: -79.55411,
    city: "Connellsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18905,
    density: 126.4,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15427,
    lat: 40.06742,
    lng: -79.97065,
    city: "Daisytown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 971,
    density: 40.7,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15428,
    lat: 40.0811,
    lng: -79.68184,
    city: "Dawson",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1880,
    density: 35.4,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15429,
    lat: 40.00678,
    lng: -79.94021,
    city: "Denbo",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 261,
    density: 76.9,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42051: 0.27,
      42125: 99.73,
    },
    county_names_all: "Washington|Fayette",
    county_fips_all: "42125|42051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15430,
    lat: 40.04025,
    lng: -79.65534,
    city: "Dickerson Run",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 339,
    density: 370.6,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15431,
    lat: 39.94066,
    lng: -79.58075,
    city: "Dunbar",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4167,
    density: 27.8,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15432,
    lat: 40.11301,
    lng: -79.85913,
    city: "Dunlevy",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 453,
    density: 328.7,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15433,
    lat: 39.97413,
    lng: -79.95799,
    city: "East Millsboro",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 641,
    density: 16.8,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15434,
    lat: 40.08013,
    lng: -79.88037,
    city: "Elco",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 308,
    density: 680.1,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15435,
    lat: 39.94314,
    lng: -79.84731,
    city: "Fairbank",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 429,
    density: 874.6,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15436,
    lat: 39.81844,
    lng: -79.72543,
    city: "Fairchance",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2602,
    density: 149.7,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15437,
    lat: 39.79202,
    lng: -79.59846,
    city: "Farmington",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2861,
    density: 17.1,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15438,
    lat: 40.07485,
    lng: -79.84431,
    city: "Fayette City",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2087,
    density: 71.9,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15440,
    lat: 39.73775,
    lng: -79.64347,
    city: "Gibbon Glade",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 125,
    density: 2.5,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15442,
    lat: 40.01542,
    lng: -79.84019,
    city: "Grindstone",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2060,
    density: 48.9,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15443,
    lat: 39.91924,
    lng: -79.88448,
    city: "Hibbs",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8,
    density: 1.3,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15444,
    lat: 40.0134,
    lng: -79.90836,
    city: "Hiller",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 676,
    density: 560.5,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15445,
    lat: 39.87343,
    lng: -79.65766,
    city: "Hopwood",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2690,
    density: 48.8,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15446,
    lat: 40.03172,
    lng: -79.39433,
    city: "Indian Head",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 162,
    density: 162.3,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15447,
    lat: 39.9445,
    lng: -79.93257,
    city: "Isabella",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 240,
    density: 38.3,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15448,
    lat: 40.13572,
    lng: -79.73394,
    city: "Jacobs Creek",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 234,
    density: 94.7,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15449,
    lat: 39.97267,
    lng: -79.78055,
    city: "Keisterville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15450,
    lat: 40.00289,
    lng: -79.97616,
    city: "La Belle",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2414,
    density: 850.6,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 99.54,
      42125: 0.46,
    },
    county_names_all: "Fayette|Washington",
    county_fips_all: "42051|42125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15451,
    lat: 39.74018,
    lng: -79.84005,
    city: "Lake Lynn",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1313,
    density: 53.5,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15454,
    lat: 39.86386,
    lng: -79.87286,
    city: "Leckrone",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 97,
    density: 30.5,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15455,
    lat: 40.00614,
    lng: -79.64609,
    city: "Leisenring",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 381,
    density: 114.6,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15456,
    lat: 39.92919,
    lng: -79.6532,
    city: "Lemont Furnace",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2824,
    density: 140.4,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15458,
    lat: 39.88715,
    lng: -79.85099,
    city: "McClellandtown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2449,
    density: 64.3,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15459,
    lat: 39.76483,
    lng: -79.4648,
    city: "Markleysburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1625,
    density: 19.2,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15460,
    lat: 39.80712,
    lng: -79.90756,
    city: "Martin",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 166,
    density: 179.2,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15461,
    lat: 39.83978,
    lng: -79.89843,
    city: "Masontown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4014,
    density: 142.3,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15462,
    lat: 40.06136,
    lng: -79.38113,
    city: "Melcroft",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 321,
    density: 92.2,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15463,
    lat: 39.9629,
    lng: -79.89916,
    city: "Merrittstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 100,
    density: 57.8,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15464,
    lat: 39.92463,
    lng: -79.43695,
    city: "Mill Run",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1498,
    density: 12.7,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15465,
    lat: 39.93883,
    lng: -79.64126,
    city: "Mount Braddock",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15466,
    lat: 40.07562,
    lng: -79.89199,
    city: "Newell",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 521,
    density: 759.3,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15467,
    lat: 39.78931,
    lng: -79.90526,
    city: "New Geneva",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 123,
    density: 76.1,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15468,
    lat: 39.94872,
    lng: -79.83761,
    city: "New Salem",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2461,
    density: 79.6,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15469,
    lat: 40.01366,
    lng: -79.41861,
    city: "Normalville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2491,
    density: 29.2,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15470,
    lat: 39.85321,
    lng: -79.53078,
    city: "Ohiopyle",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 633,
    density: 8.4,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15472,
    lat: 39.91933,
    lng: -79.71679,
    city: "Oliver",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 142,
    density: 228.2,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15473,
    lat: 40.07256,
    lng: -79.77352,
    city: "Perryopolis",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3495,
    density: 61.7,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15474,
    lat: 39.75201,
    lng: -79.90145,
    city: "Point Marion",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1968,
    density: 94.9,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15475,
    lat: 39.95812,
    lng: -79.88057,
    city: "Republic",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1288,
    density: 423.9,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15476,
    lat: 39.86888,
    lng: -79.92228,
    city: "Ronco",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15477,
    lat: 40.07856,
    lng: -79.86243,
    city: "Roscoe",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 789,
    density: 1299.5,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15478,
    lat: 39.78601,
    lng: -79.80099,
    city: "Smithfield",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5554,
    density: 34.5,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15479,
    lat: 40.15224,
    lng: -79.71329,
    city: "Smithton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2151,
    density: 38.6,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15480,
    lat: 39.98644,
    lng: -79.76962,
    city: "Smock",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1959,
    density: 48.6,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15482,
    lat: 40.06073,
    lng: -79.76645,
    city: "Star Junction",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 241,
    density: 86.6,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15483,
    lat: 40.08352,
    lng: -79.85036,
    city: "Stockdale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 369,
    density: 552.9,
    county_fips: 42125,
    county_name: "Washington",
    county_weights: {
      42125: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 42125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15484,
    lat: 39.89242,
    lng: -79.77842,
    city: "Uledi",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 557,
    density: 198.3,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15486,
    lat: 40.02762,
    lng: -79.70981,
    city: "Vanderbilt",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2206,
    density: 39.1,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15488,
    lat: 39.97749,
    lng: -79.75974,
    city: "Waltersburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15489,
    lat: 39.96323,
    lng: -79.69531,
    city: "West Leisenring",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 319,
    density: 99.6,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15490,
    lat: 40.06782,
    lng: -79.45327,
    city: "White",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 407,
    density: 16.7,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15492,
    lat: 40.11974,
    lng: -79.76306,
    city: "Wickhaven",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 171,
    density: 109.5,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15501,
    lat: 40.03582,
    lng: -79.13024,
    city: "Somerset",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16150,
    density: 47.2,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 95.39,
      42129: 4.61,
    },
    county_names_all: "Somerset|Westmoreland",
    county_fips_all: "42111|42129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15502,
    lat: 40.03641,
    lng: -79.25176,
    city: "Hidden Valley",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64,
    density: 5.6,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15510,
    lat: 39.96435,
    lng: -79.04009,
    city: "Somerset",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2588,
    density: 5695.4,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15520,
    lat: 40.10626,
    lng: -79.06017,
    city: "Acosta",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 310,
    density: 181.3,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15521,
    lat: 40.19972,
    lng: -78.63176,
    city: "Alum Bank",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1782,
    density: 18.4,
    county_fips: 42009,
    county_name: "Bedford",
    county_weights: {
      42009: 100,
    },
    county_names_all: "Bedford",
    county_fips_all: 42009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15522,
    lat: 39.94931,
    lng: -78.55173,
    city: "Bedford",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11196,
    density: 23,
    county_fips: 42009,
    county_name: "Bedford",
    county_weights: {
      42009: 100,
    },
    county_names_all: "Bedford",
    county_fips_all: 42009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15530,
    lat: 39.94531,
    lng: -78.91253,
    city: "Berlin",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5167,
    density: 23,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15531,
    lat: 40.18537,
    lng: -79.0794,
    city: "Boswell",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3672,
    density: 23.3,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 87.48,
      42129: 12.52,
    },
    county_names_all: "Somerset|Westmoreland",
    county_fips_all: "42111|42129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15532,
    lat: 39.76232,
    lng: -79.06084,
    city: "Boynton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 144,
    density: 79.5,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15533,
    lat: 39.98585,
    lng: -78.24566,
    city: "Breezewood",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1292,
    density: 16,
    county_fips: 42009,
    county_name: "Bedford",
    county_weights: {
      42009: 93.87,
      42057: 6.13,
    },
    county_names_all: "Bedford|Fulton",
    county_fips_all: "42009|42057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15534,
    lat: 39.89712,
    lng: -78.69589,
    city: "Buffalo Mills",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 901,
    density: 6.7,
    county_fips: 42009,
    county_name: "Bedford",
    county_weights: {
      42009: 99.12,
      42111: 0.88,
    },
    county_names_all: "Bedford|Somerset",
    county_fips_all: "42009|42111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15535,
    lat: 39.826,
    lng: -78.45001,
    city: "Clearville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2018,
    density: 5,
    county_fips: 42009,
    county_name: "Bedford",
    county_weights: {
      42009: 100,
    },
    county_names_all: "Bedford",
    county_fips_all: 42009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15536,
    lat: 39.94956,
    lng: -78.2109,
    city: "Crystal Spring",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 338,
    density: 3.9,
    county_fips: 42057,
    county_name: "Fulton",
    county_weights: {
      42057: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 42057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15537,
    lat: 39.9981,
    lng: -78.36506,
    city: "Everett",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8194,
    density: 28.1,
    county_fips: 42009,
    county_name: "Bedford",
    county_weights: {
      42009: 100,
    },
    county_names_all: "Bedford",
    county_fips_all: 42009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15538,
    lat: 39.86644,
    lng: -78.83233,
    city: "Fairhope",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 665,
    density: 3.8,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15539,
    lat: 40.12835,
    lng: -78.59341,
    city: "Fishertown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 296,
    density: 95.4,
    county_fips: 42009,
    county_name: "Bedford",
    county_weights: {
      42009: 100,
    },
    county_names_all: "Bedford",
    county_fips_all: 42009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15540,
    lat: 39.79549,
    lng: -79.23712,
    city: "Fort Hill",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 289,
    density: 2.6,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15541,
    lat: 40.04905,
    lng: -78.98076,
    city: "Friedens",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3255,
    density: 33.5,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15542,
    lat: 39.86742,
    lng: -79.07851,
    city: "Garrett",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1067,
    density: 11.4,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15544,
    lat: 40.13254,
    lng: -79.09656,
    city: "Gray",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 102,
    density: 76,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15545,
    lat: 39.77943,
    lng: -78.776,
    city: "Hyndman",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2882,
    density: 23.1,
    county_fips: 42009,
    county_name: "Bedford",
    county_weights: {
      42009: 58.31,
      42111: 41.69,
    },
    county_names_all: "Bedford|Somerset",
    county_fips_all: "42009|42111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15546,
    lat: 40.13717,
    lng: -79.04758,
    city: "Jenners",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 523,
    density: 243.7,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15547,
    lat: 40.1629,
    lng: -79.07019,
    city: "Jennerstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 936,
    density: 528,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15550,
    lat: 39.99025,
    lng: -78.64493,
    city: "Manns Choice",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1834,
    density: 13.2,
    county_fips: 42009,
    county_name: "Bedford",
    county_weights: {
      42009: 100,
    },
    county_names_all: "Bedford",
    county_fips_all: 42009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15551,
    lat: 39.88413,
    lng: -79.26761,
    city: "Markleton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 632,
    density: 9.9,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15552,
    lat: 39.79629,
    lng: -78.98232,
    city: "Meyersdale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5772,
    density: 21.9,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15554,
    lat: 40.12525,
    lng: -78.61575,
    city: "New Paris",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2422,
    density: 27,
    county_fips: 42009,
    county_name: "Bedford",
    county_weights: {
      42009: 100,
    },
    county_names_all: "Bedford",
    county_fips_all: 42009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15555,
    lat: 40.09758,
    lng: -79.08132,
    city: "Quecreek",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54,
    density: 53.8,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15557,
    lat: 39.92757,
    lng: -79.20945,
    city: "Rockwood",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3358,
    density: 14.4,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42051: 0.76,
      42111: 99.24,
    },
    county_names_all: "Somerset|Fayette",
    county_fips_all: "42111|42051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15558,
    lat: 39.7494,
    lng: -79.09755,
    city: "Salisbury",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2113,
    density: 24.5,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15559,
    lat: 40.05914,
    lng: -78.68241,
    city: "Schellsburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1594,
    density: 13.2,
    county_fips: 42009,
    county_name: "Bedford",
    county_weights: {
      42009: 99.88,
      42111: 0.12,
    },
    county_names_all: "Bedford|Somerset",
    county_fips_all: "42009|42111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15560,
    lat: 40.01687,
    lng: -78.90664,
    city: "Shanksville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 129,
    density: 295.9,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15561,
    lat: 40.09379,
    lng: -79.0907,
    city: "Sipesville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 185,
    density: 207.5,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15562,
    lat: 39.74165,
    lng: -79.1219,
    city: "Springs",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 321,
    density: 36.3,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15563,
    lat: 40.0962,
    lng: -78.93618,
    city: "Stoystown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2986,
    density: 20.9,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15564,
    lat: 39.72967,
    lng: -78.84542,
    city: "Wellersburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49,
    density: 34.8,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15565,
    lat: 39.75907,
    lng: -79.11552,
    city: "West Salisbury",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15601,
    lat: 40.31397,
    lng: -79.53643,
    city: "Greensburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56328,
    density: 269.7,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15610,
    lat: 40.13699,
    lng: -79.41613,
    city: "Acme",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4016,
    density: 39.1,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42051: 32.63,
      42129: 67.37,
    },
    county_names_all: "Westmoreland|Fayette",
    county_fips_all: "42129|42051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15611,
    lat: 40.30656,
    lng: -79.65266,
    city: "Adamsburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 514,
    density: 285,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15612,
    lat: 40.13793,
    lng: -79.59938,
    city: "Alverton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 366,
    density: 65.6,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15613,
    lat: 40.55355,
    lng: -79.56577,
    city: "Apollo",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13122,
    density: 87.5,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42005: 37.97,
      42129: 62.03,
    },
    county_names_all: "Westmoreland|Armstrong",
    county_fips_all: "42129|42005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15615,
    lat: 40.36133,
    lng: -79.73397,
    city: "Ardara",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 330,
    density: 245.7,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15616,
    lat: 40.23502,
    lng: -79.55093,
    city: "Armbrust",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15617,
    lat: 40.26856,
    lng: -79.65805,
    city: "Arona",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 291,
    density: 226.9,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15618,
    lat: 40.56229,
    lng: -79.44628,
    city: "Avonmore",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2511,
    density: 33.2,
    county_fips: 42005,
    county_name: "Armstrong",
    county_weights: {
      42005: 62.89,
      42063: 7.64,
      42129: 29.47,
    },
    county_names_all: "Armstrong|Westmoreland|Indiana",
    county_fips_all: "42005|42129|42063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15619,
    lat: 40.32051,
    lng: -79.49719,
    city: "Bovard",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15620,
    lat: 40.32336,
    lng: -79.33882,
    city: "Bradenville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 419,
    density: 177.3,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15622,
    lat: 40.0356,
    lng: -79.31724,
    city: "Champion",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1159,
    density: 12.5,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 36.86,
      42111: 34.82,
      42129: 28.32,
    },
    county_names_all: "Fayette|Somerset|Westmoreland",
    county_fips_all: "42051|42111|42129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15623,
    lat: 40.3689,
    lng: -79.62263,
    city: "Claridge",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 817,
    density: 264.9,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15624,
    lat: 40.36638,
    lng: -79.47124,
    city: "Crabtree",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 430,
    density: 341.8,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15625,
    lat: 40.27048,
    lng: -79.67925,
    city: "Darragh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42,
    density: 27,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15626,
    lat: 40.40868,
    lng: -79.57592,
    city: "Delmont",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4854,
    density: 436.3,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15627,
    lat: 40.35064,
    lng: -79.30667,
    city: "Derry",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5955,
    density: 72.5,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15628,
    lat: 40.10009,
    lng: -79.37008,
    city: "Donegal",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 644,
    density: 137.4,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15629,
    lat: 40.59731,
    lng: -79.56304,
    city: "East Vandergrift",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 697,
    density: 2133.2,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15631,
    lat: 40.08968,
    lng: -79.58527,
    city: "Everson",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 970,
    density: 665.1,
    county_fips: 42051,
    county_name: "Fayette",
    county_weights: {
      42051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 42051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15632,
    lat: 40.43803,
    lng: -79.60668,
    city: "Export",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8316,
    density: 107.9,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15633,
    lat: 40.35941,
    lng: -79.51699,
    city: "Forbes Road",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 517,
    density: 70.7,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15634,
    lat: 40.32533,
    lng: -79.60596,
    city: "Grapeville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 320,
    density: 976.6,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15635,
    lat: 40.34891,
    lng: -79.49877,
    city: "Hannastown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 110,
    density: 149.8,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15636,
    lat: 40.36459,
    lng: -79.65619,
    city: "Harrison City",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4658,
    density: 745.1,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15637,
    lat: 40.26125,
    lng: -79.71203,
    city: "Herminie",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1239,
    density: 98.9,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15638,
    lat: 40.26466,
    lng: -79.4017,
    city: "Hostetter",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 79,
    density: 197.7,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15639,
    lat: 40.20927,
    lng: -79.59379,
    city: "Hunker",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2042,
    density: 72.2,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15640,
    lat: 40.22315,
    lng: -79.73243,
    city: "Hutchinson",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 676,
    density: 649.6,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15641,
    lat: 40.63151,
    lng: -79.58909,
    city: "Hyde Park",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 486,
    density: 780.5,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15642,
    lat: 40.32045,
    lng: -79.72119,
    city: "Irwin",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44333,
    density: 371.8,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42003: 1.91,
      42129: 98.09,
    },
    county_names_all: "Westmoreland|Allegheny",
    county_fips_all: "42129|42003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15644,
    lat: 40.34681,
    lng: -79.61278,
    city: "Jeannette",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18550,
    density: 323.5,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15646,
    lat: 40.09517,
    lng: -79.34448,
    city: "Jones Mills",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 288,
    density: 100.7,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15647,
    lat: 40.34262,
    lng: -79.72009,
    city: "Larimer",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 325,
    density: 1556.7,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15650,
    lat: 40.27527,
    lng: -79.39213,
    city: "Latrobe",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26975,
    density: 140.4,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15655,
    lat: 40.19739,
    lng: -79.18141,
    city: "Laughlintown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 169,
    density: 5.5,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15656,
    lat: 40.64114,
    lng: -79.61981,
    city: "Leechburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9717,
    density: 117.7,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42005: 42.89,
      42129: 57.11,
    },
    county_names_all: "Westmoreland|Armstrong",
    county_fips_all: "42129|42005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15658,
    lat: 40.25467,
    lng: -79.22217,
    city: "Ligonier",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8936,
    density: 37.4,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15660,
    lat: 40.24669,
    lng: -79.77293,
    city: "Lowber",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 448,
    density: 666.1,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15661,
    lat: 40.32192,
    lng: -79.36007,
    city: "Loyalhanna",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 836,
    density: 825.5,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15662,
    lat: 40.33892,
    lng: -79.47972,
    city: "Luxor",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 759,
    density: 195.5,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15663,
    lat: 40.25233,
    lng: -79.67958,
    city: "Madison",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 466,
    density: 188.6,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15665,
    lat: 40.33925,
    lng: -79.66338,
    city: "Manor",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1172,
    density: 507.9,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15666,
    lat: 40.15858,
    lng: -79.51398,
    city: "Mount Pleasant",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15750,
    density: 114,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42051: 24.01,
      42129: 75.99,
    },
    county_names_all: "Westmoreland|Fayette",
    county_fips_all: "42129|42051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15668,
    lat: 40.46352,
    lng: -79.67168,
    city: "Murrysville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13469,
    density: 232.3,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42003: 0.23,
      42129: 99.77,
    },
    county_names_all: "Westmoreland|Allegheny",
    county_fips_all: "42129|42003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15670,
    lat: 40.40783,
    lng: -79.4321,
    city: "New Alexandria",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3215,
    density: 30.4,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15671,
    lat: 40.36038,
    lng: -79.32146,
    city: "New Derry",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 625,
    density: 104.6,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15672,
    lat: 40.24428,
    lng: -79.63069,
    city: "New Stanton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3343,
    density: 115.6,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15673,
    lat: 40.59383,
    lng: -79.55634,
    city: "North Apollo",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1186,
    density: 847.4,
    county_fips: 42005,
    county_name: "Armstrong",
    county_weights: {
      42005: 100,
    },
    county_names_all: "Armstrong",
    county_fips_all: 42005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15674,
    lat: 40.20672,
    lng: -79.49636,
    city: "Norvelt",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15675,
    lat: 40.33363,
    lng: -79.63867,
    city: "Penn",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1164,
    density: 427.2,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15676,
    lat: 40.24303,
    lng: -79.45913,
    city: "Pleasant Unity",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 729,
    density: 242.4,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15677,
    lat: 40.15048,
    lng: -79.23113,
    city: "Rector",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 257,
    density: 4,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15678,
    lat: 40.28447,
    lng: -79.72579,
    city: "Rillton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 671,
    density: 196.2,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15679,
    lat: 40.18126,
    lng: -79.64982,
    city: "Ruffs Dale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2298,
    density: 40.3,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15680,
    lat: 40.52104,
    lng: -79.49638,
    city: "Salina",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15681,
    lat: 40.5023,
    lng: -79.43873,
    city: "Saltsburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4773,
    density: 34.6,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 54.07,
      42129: 45.93,
    },
    county_names_all: "Indiana|Westmoreland",
    county_fips_all: "42063|42129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15682,
    lat: 40.68301,
    lng: -79.63696,
    city: "Schenley",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42005,
    county_name: "Armstrong",
    county_weights: {
      42005: 100,
    },
    county_names_all: "Armstrong",
    county_fips_all: 42005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15683,
    lat: 40.10926,
    lng: -79.60492,
    city: "Scottdale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7680,
    density: 157.7,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42051: 18.94,
      42129: 81.06,
    },
    county_names_all: "Westmoreland|Fayette",
    county_fips_all: "42129|42051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15684,
    lat: 40.4629,
    lng: -79.50629,
    city: "Slickville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 695,
    density: 105.2,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15686,
    lat: 40.61802,
    lng: -79.43635,
    city: "Spring Church",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 891,
    density: 31.2,
    county_fips: 42005,
    county_name: "Armstrong",
    county_weights: {
      42005: 100,
    },
    county_names_all: "Armstrong",
    county_fips_all: 42005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15687,
    lat: 40.13149,
    lng: -79.31977,
    city: "Stahlstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1042,
    density: 13.5,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15688,
    lat: 40.1734,
    lng: -79.58602,
    city: "Tarrs",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1052,
    density: 194.9,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15689,
    lat: 40.2253,
    lng: -79.49164,
    city: "United",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 202,
    density: 215.2,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15690,
    lat: 40.6455,
    lng: -79.54243,
    city: "Vandergrift",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8977,
    density: 131.6,
    county_fips: 42005,
    county_name: "Armstrong",
    county_weights: {
      42005: 90.5,
      42129: 9.5,
    },
    county_names_all: "Armstrong|Westmoreland",
    county_fips_all: "42005|42129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15691,
    lat: 40.29668,
    lng: -79.68411,
    city: "Wendel",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15692,
    lat: 40.33086,
    lng: -79.67861,
    city: "Westmoreland City",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 852,
    density: 1036.1,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15693,
    lat: 40.24939,
    lng: -79.40592,
    city: "Whitney",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 141,
    density: 111.3,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15695,
    lat: 40.19707,
    lng: -79.69284,
    city: "Wyano",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 408,
    density: 314,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15696,
    lat: 40.2798,
    lng: -79.36587,
    city: "Youngstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 263,
    density: 912,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15697,
    lat: 40.24054,
    lng: -79.5803,
    city: "Youngwood",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2867,
    density: 619.2,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15698,
    lat: 40.2167,
    lng: -79.68894,
    city: "Yukon",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 567,
    density: 152.5,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15701,
    lat: 40.62935,
    lng: -79.15056,
    city: "Indiana",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33460,
    density: 115.1,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15705,
    lat: 40.61588,
    lng: -79.15983,
    city: "Indiana",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15710,
    lat: 40.64019,
    lng: -78.87193,
    city: "Alverda",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 124,
    density: 26.5,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15711,
    lat: 41.00926,
    lng: -78.96235,
    city: "Anita",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 417,
    density: 145.9,
    county_fips: 42065,
    county_name: "Jefferson",
    county_weights: {
      42065: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 42065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15712,
    lat: 40.79323,
    lng: -78.84692,
    city: "Arcadia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 215,
    density: 64.4,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15713,
    lat: 40.5698,
    lng: -79.26184,
    city: "Aultman",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 358,
    density: 107.1,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15714,
    lat: 40.63962,
    lng: -78.82978,
    city: "Northern Cambria",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4509,
    density: 52.2,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 55.6,
      42063: 44.4,
    },
    county_names_all: "Cambria|Indiana",
    county_fips_all: "42021|42063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15715,
    lat: 40.97017,
    lng: -78.87655,
    city: "Big Run",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 406,
    density: 226.7,
    county_fips: 42065,
    county_name: "Jefferson",
    county_weights: {
      42065: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 42065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15716,
    lat: 40.47025,
    lng: -79.19031,
    city: "Black Lick",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 876,
    density: 772.9,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15717,
    lat: 40.45354,
    lng: -79.23896,
    city: "Blairsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10003,
    density: 41.1,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 69.62,
      42129: 30.38,
    },
    county_names_all: "Indiana|Westmoreland",
    county_fips_all: "42063|42129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15720,
    lat: 40.53896,
    lng: -79.06625,
    city: "Brush Valley",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15721,
    lat: 40.82029,
    lng: -78.78739,
    city: "Burnside",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 175,
    density: 29.4,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15722,
    lat: 40.59833,
    lng: -78.72532,
    city: "Carrolltown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1984,
    density: 33.9,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15723,
    lat: 40.70066,
    lng: -79.1582,
    city: "Chambersville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12,
    density: 4.3,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15724,
    lat: 40.73545,
    lng: -78.81746,
    city: "Cherry Tree",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2059,
    density: 19.3,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42021: 11.22,
      42033: 29.07,
      42063: 59.71,
    },
    county_names_all: "Indiana|Clearfield|Cambria",
    county_fips_all: "42063|42033|42021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15725,
    lat: 40.51751,
    lng: -79.33954,
    city: "Clarksburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1452,
    density: 19.5,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15727,
    lat: 40.56498,
    lng: -79.31496,
    city: "Clune",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 171,
    density: 36.6,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15728,
    lat: 40.6757,
    lng: -78.96644,
    city: "Clymer",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3447,
    density: 30,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15729,
    lat: 40.70583,
    lng: -78.92049,
    city: "Commodore",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1204,
    density: 25.4,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15730,
    lat: 41.02749,
    lng: -79.07921,
    city: "Coolspring",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 113,
    density: 11.5,
    county_fips: 42065,
    county_name: "Jefferson",
    county_weights: {
      42065: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 42065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15731,
    lat: 40.50383,
    lng: -79.1767,
    city: "Coral",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 334,
    density: 644.3,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15732,
    lat: 40.72829,
    lng: -79.21336,
    city: "Creekside",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1541,
    density: 20.1,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42005: 10.47,
      42063: 89.53,
    },
    county_names_all: "Indiana|Armstrong",
    county_fips_all: "42063|42005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15733,
    lat: 40.9869,
    lng: -78.96072,
    city: "De Lancey",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 152,
    density: 146.7,
    county_fips: 42065,
    county_name: "Jefferson",
    county_weights: {
      42065: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 42065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15734,
    lat: 40.72046,
    lng: -79.00836,
    city: "Dixonville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 463,
    density: 366.8,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15736,
    lat: 40.69945,
    lng: -79.36946,
    city: "Elderton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 835,
    density: 164,
    county_fips: 42005,
    county_name: "Armstrong",
    county_weights: {
      42005: 100,
    },
    county_names_all: "Armstrong",
    county_fips_all: 42005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15737,
    lat: 40.59871,
    lng: -78.75356,
    city: "Elmora",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 78,
    density: 29.5,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15738,
    lat: 40.69039,
    lng: -78.78174,
    city: "Emeigh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 169,
    density: 25.6,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15739,
    lat: 40.67875,
    lng: -79.16454,
    city: "Ernest",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 574,
    density: 1175.1,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15741,
    lat: 40.80601,
    lng: -78.88924,
    city: "Gipsy",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58,
    density: 17.3,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15742,
    lat: 40.81042,
    lng: -78.8688,
    city: "Glen Campbell",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1034,
    density: 14,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42033: 6.68,
      42063: 93.32,
    },
    county_names_all: "Indiana|Clearfield",
    county_fips_all: "42063|42033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15744,
    lat: 40.91722,
    lng: -79.07119,
    city: "Hamilton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 145,
    density: 67.7,
    county_fips: 42065,
    county_name: "Jefferson",
    county_weights: {
      42065: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 42065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15745,
    lat: 40.62264,
    lng: -78.91347,
    city: "Heilwood",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 196,
    density: 59.6,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15746,
    lat: 40.75285,
    lng: -78.87455,
    city: "Hillsdale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 83,
    density: 12.5,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15747,
    lat: 40.76533,
    lng: -79.14562,
    city: "Home",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1803,
    density: 22.1,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15748,
    lat: 40.52489,
    lng: -79.087,
    city: "Homer City",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7216,
    density: 38.3,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15750,
    lat: 40.48377,
    lng: -79.18256,
    city: "Josephine",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 177,
    density: 98.2,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15752,
    lat: 40.5408,
    lng: -79.28177,
    city: "Kent",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40,
    density: 215.5,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15753,
    lat: 40.78681,
    lng: -78.64728,
    city: "La Jose",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 480,
    density: 4.9,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15754,
    lat: 40.55667,
    lng: -79.15152,
    city: "Lucernemines",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 593,
    density: 530.3,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15756,
    lat: 40.57134,
    lng: -79.30096,
    city: "McIntyre",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 171,
    density: 53,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15757,
    lat: 40.8902,
    lng: -78.73733,
    city: "Mahaffey",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1466,
    density: 6.7,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 94.63,
      42063: 5.37,
    },
    county_names_all: "Clearfield|Indiana",
    county_fips_all: "42033|42063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15759,
    lat: 40.7721,
    lng: -79.03045,
    city: "Marion Center",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2848,
    density: 19.3,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15760,
    lat: 40.64583,
    lng: -78.80509,
    city: "Marsteller",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 137,
    density: 37.4,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15761,
    lat: 40.63399,
    lng: -78.89019,
    city: "Mentcle",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 132,
    density: 134.2,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15762,
    lat: 40.6001,
    lng: -78.83309,
    city: "Nicktown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1069,
    density: 32.2,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15763,
    lat: 40.90718,
    lng: -79.12795,
    city: "Northpoint",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15764,
    lat: 40.99423,
    lng: -79.02773,
    city: "Oliveburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 143,
    density: 30,
    county_fips: 42065,
    county_name: "Jefferson",
    county_weights: {
      42065: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 42065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15765,
    lat: 40.59661,
    lng: -78.99574,
    city: "Penn Run",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1541,
    density: 14.7,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15767,
    lat: 40.95859,
    lng: -78.96974,
    city: "Punxsutawney",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14229,
    density: 34.3,
    county_fips: 42065,
    county_name: "Jefferson",
    county_weights: {
      42033: 7.23,
      42063: 9.11,
      42065: 83.66,
    },
    county_names_all: "Jefferson|Indiana|Clearfield",
    county_fips_all: "42065|42063|42033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15770,
    lat: 40.99528,
    lng: -79.15747,
    city: "Ringgold",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 229,
    density: 19,
    county_fips: 42065,
    county_name: "Jefferson",
    county_weights: {
      42065: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 42065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15771,
    lat: 40.83309,
    lng: -78.99009,
    city: "Rochester Mills",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 848,
    density: 10.5,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15772,
    lat: 40.87392,
    lng: -78.89984,
    city: "Rossiter",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1748,
    density: 20.6,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 96.53,
      42065: 3.47,
    },
    county_names_all: "Indiana|Jefferson",
    county_fips_all: "42063|42065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15773,
    lat: 40.63075,
    lng: -78.73041,
    city: "Saint Benedict",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 660,
    density: 166.4,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15774,
    lat: 40.65729,
    lng: -79.32508,
    city: "Shelocta",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2769,
    density: 19.5,
    county_fips: 42005,
    county_name: "Armstrong",
    county_weights: {
      42005: 53.77,
      42063: 46.23,
    },
    county_names_all: "Armstrong|Indiana",
    county_fips_all: "42005|42063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15775,
    lat: 40.63488,
    lng: -78.78405,
    city: "Spangler",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 817,
    density: 223.9,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15776,
    lat: 41.01348,
    lng: -79.11442,
    city: "Sprankle Mills",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56,
    density: 9.6,
    county_fips: 42065,
    county_name: "Jefferson",
    county_weights: {
      42065: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 42065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15777,
    lat: 40.69749,
    lng: -78.96255,
    city: "Starford",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74,
    density: 39.4,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15778,
    lat: 40.96728,
    lng: -79.19901,
    city: "Timblin",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 283,
    density: 156.1,
    county_fips: 42065,
    county_name: "Jefferson",
    county_weights: {
      42005: 0.25,
      42065: 99.75,
    },
    county_names_all: "Jefferson|Armstrong",
    county_fips_all: "42065|42005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15779,
    lat: 40.40008,
    lng: -79.21846,
    city: "Torrance",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 679,
    density: 31.8,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15780,
    lat: 40.91628,
    lng: -79.05606,
    city: "Valier",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 116,
    density: 36.2,
    county_fips: 42065,
    county_name: "Jefferson",
    county_weights: {
      42065: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 42065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15781,
    lat: 40.96375,
    lng: -78.98679,
    city: "Walston",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 86,
    density: 31.5,
    county_fips: 42065,
    county_name: "Jefferson",
    county_weights: {
      42065: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 42065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15783,
    lat: 40.60297,
    lng: -79.34495,
    city: "West Lebanon",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 78,
    density: 22.5,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15784,
    lat: 41.02449,
    lng: -79.13937,
    city: "Worthville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46,
    density: 103.7,
    county_fips: 42065,
    county_name: "Jefferson",
    county_weights: {
      42065: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 42065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15801,
    lat: 41.12867,
    lng: -78.72352,
    city: "Du Bois",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18871,
    density: 103.9,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 99.15,
      42065: 0.85,
    },
    county_names_all: "Clearfield|Jefferson",
    county_fips_all: "42033|42065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15821,
    lat: 41.35868,
    lng: -78.36453,
    city: "Benezett",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 122,
    density: 1.4,
    county_fips: 42047,
    county_name: "Elk",
    county_weights: {
      42047: 100,
    },
    county_names_all: "Elk",
    county_fips_all: 42047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15823,
    lat: 41.25888,
    lng: -78.71001,
    city: "Brockport",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1123,
    density: 12.1,
    county_fips: 42047,
    county_name: "Elk",
    county_weights: {
      42047: 84.92,
      42065: 15.08,
    },
    county_names_all: "Elk|Jefferson",
    county_fips_all: "42047|42065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15824,
    lat: 41.24831,
    lng: -78.83828,
    city: "Brockway",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4962,
    density: 28.8,
    county_fips: 42065,
    county_name: "Jefferson",
    county_weights: {
      42033: 5.75,
      42065: 94.25,
    },
    county_names_all: "Jefferson|Clearfield",
    county_fips_all: "42065|42033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15825,
    lat: 41.17005,
    lng: -79.03885,
    city: "Brookville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9229,
    density: 23,
    county_fips: 42065,
    county_name: "Jefferson",
    county_weights: {
      42065: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 42065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15827,
    lat: 41.29479,
    lng: -78.50582,
    city: "Byrnedale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 317,
    density: 345.5,
    county_fips: 42047,
    county_name: "Elk",
    county_weights: {
      42047: 100,
    },
    county_names_all: "Elk",
    county_fips_all: 42047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15828,
    lat: 41.35104,
    lng: -79.13906,
    city: "Clarington",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 217,
    density: 3.4,
    county_fips: 42053,
    county_name: "Forest",
    county_weights: {
      42053: 56.28,
      42065: 43.72,
    },
    county_names_all: "Forest|Jefferson",
    county_fips_all: "42053|42065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15829,
    lat: 41.17337,
    lng: -79.19324,
    city: "Corsica",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1342,
    density: 16.2,
    county_fips: 42065,
    county_name: "Jefferson",
    county_weights: {
      42031: 31.03,
      42065: 68.97,
    },
    county_names_all: "Jefferson|Clarion",
    county_fips_all: "42065|42031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15831,
    lat: 41.35305,
    lng: -78.604,
    city: "Dagus Mines",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42047,
    county_name: "Elk",
    county_weights: {
      42047: 100,
    },
    county_names_all: "Elk",
    county_fips_all: 42047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15832,
    lat: 41.35301,
    lng: -78.19053,
    city: "Driftwood",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 231,
    density: 0.8,
    county_fips: 42023,
    county_name: "Cameron",
    county_weights: {
      42023: 89.31,
      42047: 10.69,
    },
    county_names_all: "Cameron|Elk",
    county_fips_all: "42023|42047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15834,
    lat: 41.51228,
    lng: -78.27811,
    city: "Emporium",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4107,
    density: 7.8,
    county_fips: 42023,
    county_name: "Cameron",
    county_weights: {
      42023: 100,
    },
    county_names_all: "Cameron",
    county_fips_all: 42023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15840,
    lat: 41.16927,
    lng: -78.82708,
    city: "Falls Creek",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1858,
    density: 41.6,
    county_fips: 42065,
    county_name: "Jefferson",
    county_weights: {
      42033: 3.07,
      42065: 96.93,
    },
    county_names_all: "Jefferson|Clearfield",
    county_fips_all: "42065|42033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15841,
    lat: 41.25798,
    lng: -78.50441,
    city: "Force",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 383,
    density: 935.8,
    county_fips: 42047,
    county_name: "Elk",
    county_weights: {
      42047: 100,
    },
    county_names_all: "Elk",
    county_fips_all: 42047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15845,
    lat: 41.50714,
    lng: -78.69066,
    city: "Johnsonburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2857,
    density: 27.6,
    county_fips: 42047,
    county_name: "Elk",
    county_weights: {
      42047: 100,
    },
    county_names_all: "Elk",
    county_fips_all: 42047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15846,
    lat: 41.33375,
    lng: -78.6147,
    city: "Kersey",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3455,
    density: 23,
    county_fips: 42047,
    county_name: "Elk",
    county_weights: {
      42047: 100,
    },
    county_names_all: "Elk",
    county_fips_all: 42047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15847,
    lat: 41.08614,
    lng: -79.02948,
    city: "Knox Dale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 277,
    density: 4406.5,
    county_fips: 42065,
    county_name: "Jefferson",
    county_weights: {
      42065: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 42065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15848,
    lat: 41.03137,
    lng: -78.71908,
    city: "Luthersburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 954,
    density: 18.4,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15849,
    lat: 41.17838,
    lng: -78.55592,
    city: "Penfield",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1283,
    density: 6.4,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15851,
    lat: 41.10115,
    lng: -78.90316,
    city: "Reynoldsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6478,
    density: 25.8,
    county_fips: 42065,
    county_name: "Jefferson",
    county_weights: {
      42065: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 42065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15853,
    lat: 41.39253,
    lng: -78.79357,
    city: "Ridgway",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6379,
    density: 16.4,
    county_fips: 42047,
    county_name: "Elk",
    county_weights: {
      42047: 93.64,
      42065: 6.36,
    },
    county_names_all: "Elk|Jefferson",
    county_fips_all: "42047|42065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15856,
    lat: 41.08906,
    lng: -78.6154,
    city: "Rockton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 804,
    density: 7.9,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15857,
    lat: 41.45671,
    lng: -78.53439,
    city: "Saint Marys",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12433,
    density: 47.8,
    county_fips: 42047,
    county_name: "Elk",
    county_weights: {
      42047: 100,
    },
    county_names_all: "Elk",
    county_fips_all: 42047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15860,
    lat: 41.3435,
    lng: -79.04697,
    city: "Sigel",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1075,
    density: 3.1,
    county_fips: 42065,
    county_name: "Jefferson",
    county_weights: {
      42031: 2.28,
      42047: 45.17,
      42065: 52.55,
    },
    county_names_all: "Jefferson|Elk|Clarion",
    county_fips_all: "42065|42047|42031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15861,
    lat: 41.3221,
    lng: -78.07246,
    city: "Sinnamahoning",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 135,
    density: 0.8,
    county_fips: 42023,
    county_name: "Cameron",
    county_weights: {
      42023: 100,
    },
    county_names_all: "Cameron",
    county_fips_all: 42023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15863,
    lat: 41.0157,
    lng: -78.83847,
    city: "Stump Creek",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 184,
    density: 140.4,
    county_fips: 42065,
    county_name: "Jefferson",
    county_weights: {
      42065: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 42065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15864,
    lat: 41.09911,
    lng: -79.19532,
    city: "Summerville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1489,
    density: 14.8,
    county_fips: 42065,
    county_name: "Jefferson",
    county_weights: {
      42031: 43.79,
      42065: 56.21,
    },
    county_names_all: "Jefferson|Clarion",
    county_fips_all: "42065|42031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15865,
    lat: 41.0508,
    lng: -78.81418,
    city: "Sykesville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1272,
    density: 202.7,
    county_fips: 42065,
    county_name: "Jefferson",
    county_weights: {
      42033: 21.45,
      42065: 78.55,
    },
    county_names_all: "Jefferson|Clearfield",
    county_fips_all: "42065|42033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15866,
    lat: 41.02587,
    lng: -78.78628,
    city: "Troutville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 259,
    density: 129.7,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15868,
    lat: 41.29885,
    lng: -78.41799,
    city: "Weedville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1448,
    density: 4.1,
    county_fips: 42047,
    county_name: "Elk",
    county_weights: {
      42047: 100,
    },
    county_names_all: "Elk",
    county_fips_all: 42047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15870,
    lat: 41.58116,
    lng: -78.57935,
    city: "Wilcox",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1151,
    density: 3.9,
    county_fips: 42047,
    county_name: "Elk",
    county_weights: {
      42047: 94.13,
      42083: 5.87,
    },
    county_names_all: "Elk|McKean",
    county_fips_all: "42047|42083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15901,
    lat: 40.32845,
    lng: -78.9146,
    city: "Johnstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3518,
    density: 890.2,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15902,
    lat: 40.32,
    lng: -78.87911,
    city: "Johnstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10905,
    density: 447.6,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15904,
    lat: 40.3056,
    lng: -78.84382,
    city: "Johnstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16347,
    density: 218.4,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 99.85,
      42111: 0.15,
    },
    county_names_all: "Cambria|Somerset",
    county_fips_all: "42021|42111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15905,
    lat: 40.29423,
    lng: -78.98035,
    city: "Johnstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19676,
    density: 182.9,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 58.69,
      42111: 41.31,
    },
    county_names_all: "Cambria|Somerset",
    county_fips_all: "42021|42111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15906,
    lat: 40.37806,
    lng: -78.93356,
    city: "Johnstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10364,
    density: 146.8,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15909,
    lat: 40.40783,
    lng: -78.87047,
    city: "Johnstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4703,
    density: 102.2,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15920,
    lat: 40.46705,
    lng: -79.05006,
    city: "Armagh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 656,
    density: 31.5,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15921,
    lat: 40.31642,
    lng: -78.69786,
    city: "Beaverdale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 76,
    density: 113.1,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15922,
    lat: 40.51853,
    lng: -78.87794,
    city: "Belsano",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 259,
    density: 445.5,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15923,
    lat: 40.35518,
    lng: -79.16447,
    city: "Bolivar",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1817,
    density: 27.3,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42129: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 42129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15924,
    lat: 40.10684,
    lng: -78.77527,
    city: "Cairnbrook",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1068,
    density: 15.6,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15925,
    lat: 40.40851,
    lng: -78.6407,
    city: "Cassandra",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 167,
    density: 804.1,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15926,
    lat: 40.04783,
    lng: -78.81934,
    city: "Central City",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2478,
    density: 30.2,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15927,
    lat: 40.54148,
    lng: -78.78019,
    city: "Colver",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 857,
    density: 64.2,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15928,
    lat: 40.23943,
    lng: -78.91591,
    city: "Davidsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2094,
    density: 128.5,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15929,
    lat: 40.47683,
    lng: -79.0042,
    city: "Dilltown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41,
    density: 15.5,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15930,
    lat: 40.29468,
    lng: -78.71732,
    city: "Dunlo",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 201,
    density: 183.6,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15931,
    lat: 40.51612,
    lng: -78.76225,
    city: "Ebensburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9257,
    density: 43.9,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15934,
    lat: 40.28107,
    lng: -78.79589,
    city: "Elton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26,
    density: 78.7,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15935,
    lat: 40.20112,
    lng: -78.96755,
    city: "Hollsopple",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3084,
    density: 52.2,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15936,
    lat: 40.16221,
    lng: -78.89584,
    city: "Hooversville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1440,
    density: 21.5,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15937,
    lat: 40.21463,
    lng: -78.98105,
    city: "Jerome",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 600,
    density: 96.8,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15938,
    lat: 40.42215,
    lng: -78.6057,
    city: "Lilly",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2340,
    density: 37.6,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15940,
    lat: 40.52128,
    lng: -78.63218,
    city: "Loretto",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3860,
    density: 61,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15942,
    lat: 40.40584,
    lng: -78.81215,
    city: "Mineral Point",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2121,
    density: 47.5,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15943,
    lat: 40.47437,
    lng: -78.83513,
    city: "Nanty Glo",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3534,
    density: 64.8,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15944,
    lat: 40.36295,
    lng: -79.0816,
    city: "New Florence",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2971,
    density: 17.6,
    county_fips: 42129,
    county_name: "Westmoreland",
    county_weights: {
      42063: 36.2,
      42129: 63.8,
    },
    county_names_all: "Westmoreland|Indiana",
    county_fips_all: "42129|42063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15945,
    lat: 40.35909,
    lng: -78.86867,
    city: "Parkhill",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48,
    density: 119.6,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15946,
    lat: 40.37248,
    lng: -78.63573,
    city: "Portage",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6471,
    density: 51.2,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42009: 9.43,
      42013: 20.96,
      42021: 69.61,
    },
    county_names_all: "Cambria|Blair|Bedford",
    county_fips_all: "42021|42013|42009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15948,
    lat: 40.48986,
    lng: -78.76699,
    city: "Revloc",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 556,
    density: 348.3,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15949,
    lat: 40.4055,
    lng: -79.13442,
    city: "Robinson",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 409,
    density: 124.8,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15951,
    lat: 40.3307,
    lng: -78.77209,
    city: "Saint Michael",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 432,
    density: 113.2,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15952,
    lat: 40.30348,
    lng: -78.77614,
    city: "Salix",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1578,
    density: 183.8,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15953,
    lat: 40.21113,
    lng: -78.89049,
    city: "Seanor",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 85,
    density: 31.3,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42111: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 42111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15954,
    lat: 40.41837,
    lng: -79.00051,
    city: "Seward",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2234,
    density: 42.6,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42021: 0.14,
      42063: 60.16,
      42129: 39.7,
    },
    county_names_all: "Indiana|Westmoreland|Cambria",
    county_fips_all: "42063|42129|42021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15955,
    lat: 40.30878,
    lng: -78.69285,
    city: "Sidman",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2266,
    density: 25.7,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15956,
    lat: 40.35022,
    lng: -78.78819,
    city: "South Fork",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2596,
    density: 121.8,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15957,
    lat: 40.53953,
    lng: -78.89744,
    city: "Strongstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 527,
    density: 35.9,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42021: 46.17,
      42063: 53.83,
    },
    county_names_all: "Indiana|Cambria",
    county_fips_all: "42063|42021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15958,
    lat: 40.3891,
    lng: -78.73284,
    city: "Summerhill",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1973,
    density: 41.2,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15960,
    lat: 40.49848,
    lng: -78.85184,
    city: "Twin Rocks",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 255,
    density: 93.9,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15961,
    lat: 40.46187,
    lng: -78.9382,
    city: "Vintondale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 750,
    density: 17.1,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42021: 42.79,
      42063: 57.21,
    },
    county_names_all: "Indiana|Cambria",
    county_fips_all: "42063|42021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15962,
    lat: 40.38942,
    lng: -78.71644,
    city: "Wilmore",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 267,
    density: 422.8,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 15963,
    lat: 40.21676,
    lng: -78.77234,
    city: "Windber",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10103,
    density: 43.1,
    county_fips: 42111,
    county_name: "Somerset",
    county_weights: {
      42021: 25.72,
      42111: 74.28,
    },
    county_names_all: "Somerset|Cambria",
    county_fips_all: "42111|42021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16001,
    lat: 40.91049,
    lng: -79.94376,
    city: "Butler",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38363,
    density: 195.4,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42019: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 42019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16002,
    lat: 40.81568,
    lng: -79.85638,
    city: "Butler",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15509,
    density: 81.7,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42019: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 42019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16020,
    lat: 41.11651,
    lng: -79.89648,
    city: "Boyers",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1006,
    density: 14.3,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42019: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 42019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16022,
    lat: 41.05461,
    lng: -79.7333,
    city: "Bruin",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 383,
    density: 196.5,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42019: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 42019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16023,
    lat: 40.78495,
    lng: -79.74921,
    city: "Cabot",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4462,
    density: 65.9,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42019: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 42019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16024,
    lat: 40.73961,
    lng: -80.03719,
    city: "Callery",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 310,
    density: 360.6,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42019: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 42019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16025,
    lat: 40.94464,
    lng: -79.75841,
    city: "Chicora",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5035,
    density: 35.6,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42005: 11.8,
      42019: 88.2,
    },
    county_names_all: "Butler|Armstrong",
    county_fips_all: "42019|42005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16027,
    lat: 40.81822,
    lng: -80.01531,
    city: "Connoquenessing",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 276,
    density: 132.3,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42019: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 42019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16028,
    lat: 40.95684,
    lng: -79.63985,
    city: "East Brady",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1692,
    density: 42.2,
    county_fips: 42005,
    county_name: "Armstrong",
    county_weights: {
      42005: 92.98,
      42031: 7.02,
    },
    county_names_all: "Armstrong|Clarion",
    county_fips_all: "42005|42031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16029,
    lat: 40.87996,
    lng: -79.84602,
    city: "East Butler",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 931,
    density: 463.4,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42019: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 42019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16030,
    lat: 41.13619,
    lng: -79.79699,
    city: "Eau Claire",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 322,
    density: 117.2,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42019: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 42019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16033,
    lat: 40.79355,
    lng: -80.04618,
    city: "Evans City",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6425,
    density: 80.7,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42019: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 42019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16034,
    lat: 40.86051,
    lng: -79.7288,
    city: "Fenelton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1831,
    density: 37.6,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42019: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 42019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16035,
    lat: 41.10779,
    lng: -80.01659,
    city: "Forestville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 127,
    density: 56.3,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42019: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 42019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16036,
    lat: 41.13519,
    lng: -79.66948,
    city: "Foxburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 322,
    density: 56.7,
    county_fips: 42031,
    county_name: "Clarion",
    county_weights: {
      42005: 0.26,
      42031: 99.74,
    },
    county_names_all: "Clarion|Armstrong",
    county_fips_all: "42031|42005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16037,
    lat: 40.85103,
    lng: -80.12592,
    city: "Harmony",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4558,
    density: 51.1,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42007: 6.12,
      42019: 86.1,
      42073: 7.78,
    },
    county_names_all: "Butler|Lawrence|Beaver",
    county_fips_all: "42019|42073|42007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16038,
    lat: 41.15967,
    lng: -79.95042,
    city: "Harrisville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3656,
    density: 30.8,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42019: 62.42,
      42121: 37.58,
    },
    county_names_all: "Butler|Venango",
    county_fips_all: "42019|42121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16040,
    lat: 41.09399,
    lng: -79.84537,
    city: "Hilliards",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 971,
    density: 19.4,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42019: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 42019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16041,
    lat: 41.00693,
    lng: -79.71395,
    city: "Karns City",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2236,
    density: 29.7,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42005: 38.69,
      42019: 61.31,
    },
    county_names_all: "Butler|Armstrong",
    county_fips_all: "42019|42005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16045,
    lat: 40.85277,
    lng: -79.91626,
    city: "Lyndora",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1111,
    density: 709.1,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42019: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 42019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16046,
    lat: 40.70192,
    lng: -80.02866,
    city: "Mars",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17044,
    density: 288.3,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42003: 19.52,
      42019: 80.48,
    },
    county_names_all: "Butler|Allegheny",
    county_fips_all: "42019|42003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16048,
    lat: 41.05217,
    lng: -79.80349,
    city: "North Washington",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 104,
    density: 16.1,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42019: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 42019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16049,
    lat: 41.09622,
    lng: -79.67258,
    city: "Parker",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2982,
    density: 12.7,
    county_fips: 42031,
    county_name: "Clarion",
    county_weights: {
      42005: 10.79,
      42019: 41.91,
      42031: 47.3,
    },
    county_names_all: "Clarion|Butler|Armstrong",
    county_fips_all: "42031|42019|42005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16050,
    lat: 41.04362,
    lng: -79.77379,
    city: "Petrolia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1283,
    density: 23.8,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42019: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 42019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16051,
    lat: 40.94459,
    lng: -80.14152,
    city: "Portersville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2896,
    density: 28.1,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42019: 61.95,
      42073: 38.05,
    },
    county_names_all: "Butler|Lawrence",
    county_fips_all: "42019|42073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16052,
    lat: 40.90579,
    lng: -80.06154,
    city: "Prospect",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2544,
    density: 54.4,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42019: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 42019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16053,
    lat: 40.81194,
    lng: -79.9826,
    city: "Renfrew",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4125,
    density: 74.4,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42019: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 42019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16054,
    lat: 41.15651,
    lng: -79.65711,
    city: "Saint Petersburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 344,
    density: 81,
    county_fips: 42031,
    county_name: "Clarion",
    county_weights: {
      42031: 100,
    },
    county_names_all: "Clarion",
    county_fips_all: 42031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16055,
    lat: 40.7157,
    lng: -79.74753,
    city: "Sarver",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8036,
    density: 80.6,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42005: 11.58,
      42019: 88.42,
    },
    county_names_all: "Butler|Armstrong",
    county_fips_all: "42019|42005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16056,
    lat: 40.72301,
    lng: -79.83911,
    city: "Saxonburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4403,
    density: 80.8,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42019: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 42019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16057,
    lat: 41.03427,
    lng: -80.0579,
    city: "Slippery Rock",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14434,
    density: 62.9,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42019: 86.19,
      42073: 12.69,
      42085: 1.12,
    },
    county_names_all: "Butler|Lawrence|Mercer",
    county_fips_all: "42019|42073|42085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16059,
    lat: 40.70425,
    lng: -79.92812,
    city: "Valencia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8278,
    density: 122.1,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42003: 3.36,
      42019: 96.64,
    },
    county_names_all: "Butler|Allegheny",
    county_fips_all: "42019|42003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16061,
    lat: 41.00866,
    lng: -79.88687,
    city: "West Sunbury",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2975,
    density: 26.9,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42019: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 42019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16063,
    lat: 40.76352,
    lng: -80.12773,
    city: "Zelienople",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7248,
    density: 165,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42007: 22.11,
      42019: 77.89,
    },
    county_names_all: "Butler|Beaver",
    county_fips_all: "42019|42007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16066,
    lat: 40.71114,
    lng: -80.10606,
    city: "Cranberry Township",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31231,
    density: 539.2,
    county_fips: 42019,
    county_name: "Butler",
    county_weights: {
      42019: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 42019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16101,
    lat: 40.98776,
    lng: -80.28814,
    city: "New Castle",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31405,
    density: 175.2,
    county_fips: 42073,
    county_name: "Lawrence",
    county_weights: {
      42073: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 42073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16102,
    lat: 40.96173,
    lng: -80.41616,
    city: "New Castle",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5694,
    density: 90.3,
    county_fips: 42073,
    county_name: "Lawrence",
    county_weights: {
      42073: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 42073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16105,
    lat: 41.05285,
    lng: -80.33918,
    city: "New Castle",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15147,
    density: 228.7,
    county_fips: 42073,
    county_name: "Lawrence",
    county_weights: {
      42073: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 42073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16110,
    lat: 41.49757,
    lng: -80.38591,
    city: "Adamsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 328,
    density: 16.1,
    county_fips: 42039,
    county_name: "Crawford",
    county_weights: {
      42039: 75.97,
      42085: 24.03,
    },
    county_names_all: "Crawford|Mercer",
    county_fips_all: "42039|42085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16111,
    lat: 41.51936,
    lng: -80.28463,
    city: "Atlantic",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1422,
    density: 20.9,
    county_fips: 42039,
    county_name: "Crawford",
    county_weights: {
      42039: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 42039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16112,
    lat: 40.96812,
    lng: -80.50099,
    city: "Bessemer",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1529,
    density: 84.3,
    county_fips: 42073,
    county_name: "Lawrence",
    county_weights: {
      42073: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 42073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16113,
    lat: 41.2828,
    lng: -80.42569,
    city: "Clark",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 463,
    density: 336.1,
    county_fips: 42085,
    county_name: "Mercer",
    county_weights: {
      42085: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 42085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16114,
    lat: 41.40432,
    lng: -80.18766,
    city: "Clarks Mills",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 613,
    density: 21,
    county_fips: 42085,
    county_name: "Mercer",
    county_weights: {
      42085: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 42085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16115,
    lat: 40.79433,
    lng: -80.46289,
    city: "Darlington",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3369,
    density: 32.8,
    county_fips: 42007,
    county_name: "Beaver",
    county_weights: {
      42007: 100,
    },
    county_names_all: "Beaver",
    county_fips_all: 42007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16116,
    lat: 41.03744,
    lng: -80.45212,
    city: "Edinburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2854,
    density: 43.4,
    county_fips: 42073,
    county_name: "Lawrence",
    county_weights: {
      42073: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 42073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16117,
    lat: 40.8743,
    lng: -80.2568,
    city: "Ellwood City",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16285,
    density: 172.8,
    county_fips: 42073,
    county_name: "Lawrence",
    county_weights: {
      42007: 34.53,
      42073: 65.47,
    },
    county_names_all: "Lawrence|Beaver",
    county_fips_all: "42073|42007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16120,
    lat: 40.892,
    lng: -80.47344,
    city: "Enon Valley",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2450,
    density: 28.3,
    county_fips: 42073,
    county_name: "Lawrence",
    county_weights: {
      42007: 10.4,
      42073: 89.6,
    },
    county_names_all: "Lawrence|Beaver",
    county_fips_all: "42073|42007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16121,
    lat: 41.21121,
    lng: -80.49696,
    city: "Farrell",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4632,
    density: 785.6,
    county_fips: 42085,
    county_name: "Mercer",
    county_weights: {
      42085: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 42085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16123,
    lat: 40.82389,
    lng: -80.19844,
    city: "Fombell",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2625,
    density: 46.2,
    county_fips: 42007,
    county_name: "Beaver",
    county_weights: {
      42007: 82.1,
      42073: 17.9,
    },
    county_names_all: "Beaver|Lawrence",
    county_fips_all: "42007|42073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16124,
    lat: 41.33336,
    lng: -80.26486,
    city: "Fredonia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1689,
    density: 24.1,
    county_fips: 42085,
    county_name: "Mercer",
    county_weights: {
      42085: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 42085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16125,
    lat: 41.40565,
    lng: -80.37135,
    city: "Greenville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17056,
    density: 62.6,
    county_fips: 42085,
    county_name: "Mercer",
    county_weights: {
      42039: 1.59,
      42085: 98.41,
    },
    county_names_all: "Mercer|Crawford",
    county_fips_all: "42085|42039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16127,
    lat: 41.17433,
    lng: -80.07002,
    city: "Grove City",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15263,
    density: 80.5,
    county_fips: 42085,
    county_name: "Mercer",
    county_weights: {
      42019: 0.34,
      42073: 1.69,
      42085: 89.98,
      42121: 7.99,
    },
    county_names_all: "Mercer|Venango|Lawrence|Butler",
    county_fips_all: "42085|42121|42073|42019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16130,
    lat: 41.44315,
    lng: -80.21668,
    city: "Hadley",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2089,
    density: 26.2,
    county_fips: 42085,
    county_name: "Mercer",
    county_weights: {
      42085: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 42085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16131,
    lat: 41.54908,
    lng: -80.37617,
    city: "Hartstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 871,
    density: 14.3,
    county_fips: 42039,
    county_name: "Crawford",
    county_weights: {
      42039: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 42039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16132,
    lat: 41.00603,
    lng: -80.50449,
    city: "Hillsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 347,
    density: 61.4,
    county_fips: 42073,
    county_name: "Lawrence",
    county_weights: {
      42073: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 42073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16133,
    lat: 41.27101,
    lng: -80.11562,
    city: "Jackson Center",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1516,
    density: 21.4,
    county_fips: 42085,
    county_name: "Mercer",
    county_weights: {
      42085: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 42085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16134,
    lat: 41.50315,
    lng: -80.46571,
    city: "Jamestown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3927,
    density: 32,
    county_fips: 42039,
    county_name: "Crawford",
    county_weights: {
      42039: 58.85,
      42085: 41.15,
    },
    county_names_all: "Crawford|Mercer",
    county_fips_all: "42039|42085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16136,
    lat: 40.83425,
    lng: -80.32369,
    city: "Koppel",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 772,
    density: 404.2,
    county_fips: 42007,
    county_name: "Beaver",
    county_weights: {
      42007: 100,
    },
    county_names_all: "Beaver",
    county_fips_all: 42007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16137,
    lat: 41.23219,
    lng: -80.2397,
    city: "Mercer",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12769,
    density: 45.4,
    county_fips: 42085,
    county_name: "Mercer",
    county_weights: {
      42085: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 42085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16140,
    lat: 41.09355,
    lng: -80.51078,
    city: "New Bedford",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 349,
    density: 322.8,
    county_fips: 42073,
    county_name: "Lawrence",
    county_weights: {
      42073: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 42073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16141,
    lat: 40.87237,
    lng: -80.3968,
    city: "New Galilee",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1736,
    density: 31.4,
    county_fips: 42073,
    county_name: "Lawrence",
    county_weights: {
      42007: 30.29,
      42073: 69.71,
    },
    county_names_all: "Lawrence|Beaver",
    county_fips_all: "42073|42007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16142,
    lat: 41.13908,
    lng: -80.34084,
    city: "New Wilmington",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6349,
    density: 56,
    county_fips: 42085,
    county_name: "Mercer",
    county_weights: {
      42073: 37.74,
      42085: 62.26,
    },
    county_names_all: "Mercer|Lawrence",
    county_fips_all: "42085|42073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16143,
    lat: 41.10528,
    lng: -80.45434,
    city: "Pulaski",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2157,
    density: 34,
    county_fips: 42073,
    county_name: "Lawrence",
    county_weights: {
      42073: 70.7,
      42085: 29.3,
    },
    county_names_all: "Lawrence|Mercer",
    county_fips_all: "42073|42085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16145,
    lat: 41.38574,
    lng: -80.07422,
    city: "Sandy Lake",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2953,
    density: 24.3,
    county_fips: 42085,
    county_name: "Mercer",
    county_weights: {
      42085: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 42085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16146,
    lat: 41.23478,
    lng: -80.49932,
    city: "Sharon",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13115,
    density: 1270.6,
    county_fips: 42085,
    county_name: "Mercer",
    county_weights: {
      42085: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 42085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16148,
    lat: 41.23147,
    lng: -80.43199,
    city: "Hermitage",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15949,
    density: 195.3,
    county_fips: 42085,
    county_name: "Mercer",
    county_weights: {
      42085: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 42085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16150,
    lat: 41.28687,
    lng: -80.44509,
    city: "Sharpsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6760,
    density: 112.6,
    county_fips: 42085,
    county_name: "Mercer",
    county_weights: {
      42085: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 42085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16151,
    lat: 41.4428,
    lng: -80.2056,
    city: "Sheakleyville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 81,
    density: 410.1,
    county_fips: 42085,
    county_name: "Mercer",
    county_weights: {
      42085: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 42085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16153,
    lat: 41.31845,
    lng: -80.08122,
    city: "Stoneboro",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2296,
    density: 20.6,
    county_fips: 42085,
    county_name: "Mercer",
    county_weights: {
      42085: 86.59,
      42121: 13.41,
    },
    county_names_all: "Mercer|Venango",
    county_fips_all: "42085|42121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16154,
    lat: 41.32539,
    lng: -80.42111,
    city: "Transfer",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2259,
    density: 32.3,
    county_fips: 42085,
    county_name: "Mercer",
    county_weights: {
      42085: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 42085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16155,
    lat: 41.06771,
    lng: -80.51073,
    city: "Villa Maria",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 135,
    density: 77,
    county_fips: 42073,
    county_name: "Lawrence",
    county_weights: {
      42073: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 42073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16156,
    lat: 41.09702,
    lng: -80.21943,
    city: "Volant",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3148,
    density: 23.7,
    county_fips: 42073,
    county_name: "Lawrence",
    county_weights: {
      42073: 78.68,
      42085: 21.32,
    },
    county_names_all: "Lawrence|Mercer",
    county_fips_all: "42073|42085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16157,
    lat: 40.88902,
    lng: -80.33509,
    city: "Wampum",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2930,
    density: 45.2,
    county_fips: 42073,
    county_name: "Lawrence",
    county_weights: {
      42007: 18,
      42073: 82,
    },
    county_names_all: "Lawrence|Beaver",
    county_fips_all: "42073|42007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16159,
    lat: 41.15967,
    lng: -80.46858,
    city: "West Middlesex",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4885,
    density: 67.2,
    county_fips: 42085,
    county_name: "Mercer",
    county_weights: {
      42073: 10.46,
      42085: 89.54,
    },
    county_names_all: "Mercer|Lawrence",
    county_fips_all: "42085|42073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16160,
    lat: 40.9283,
    lng: -80.36235,
    city: "West Pittsburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 907,
    density: 298.4,
    county_fips: 42073,
    county_name: "Lawrence",
    county_weights: {
      42073: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 42073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16161,
    lat: 41.20232,
    lng: -80.49282,
    city: "Wheatland",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 567,
    density: 699.8,
    county_fips: 42085,
    county_name: "Mercer",
    county_weights: {
      42085: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 42085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16172,
    lat: 41.1177,
    lng: -80.33105,
    city: "New Wilmington",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42073,
    county_name: "Lawrence",
    county_weights: {
      42073: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 42073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16201,
    lat: 40.80984,
    lng: -79.47204,
    city: "Kittanning",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16645,
    density: 57.3,
    county_fips: 42005,
    county_name: "Armstrong",
    county_weights: {
      42005: 100,
    },
    county_names_all: "Armstrong",
    county_fips_all: 42005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16210,
    lat: 40.89697,
    lng: -79.519,
    city: "Adrian",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 849,
    density: 14.7,
    county_fips: 42005,
    county_name: "Armstrong",
    county_weights: {
      42005: 100,
    },
    county_names_all: "Armstrong",
    county_fips_all: 42005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16211,
    lat: 40.79436,
    lng: -79.2023,
    city: "Beyer",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 79,
    density: 29.6,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16212,
    lat: 40.75239,
    lng: -79.57795,
    city: "Cadogan",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 267,
    density: 235.5,
    county_fips: 42005,
    county_name: "Armstrong",
    county_weights: {
      42005: 100,
    },
    county_names_all: "Armstrong",
    county_fips_all: 42005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16213,
    lat: 41.12556,
    lng: -79.55831,
    city: "Callensburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 123,
    density: 397.1,
    county_fips: 42031,
    county_name: "Clarion",
    county_weights: {
      42031: 100,
    },
    county_names_all: "Clarion",
    county_fips_all: 42031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16214,
    lat: 41.2008,
    lng: -79.36046,
    city: "Clarion",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10276,
    density: 82.8,
    county_fips: 42031,
    county_name: "Clarion",
    county_weights: {
      42031: 100,
    },
    county_names_all: "Clarion",
    county_fips_all: 42031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16217,
    lat: 41.34908,
    lng: -79.18095,
    city: "Cooksburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 128,
    density: 6.6,
    county_fips: 42053,
    county_name: "Forest",
    county_weights: {
      42031: 24.32,
      42053: 75.56,
      42065: 0.12,
    },
    county_names_all: "Forest|Clarion|Jefferson",
    county_fips_all: "42053|42031|42065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16218,
    lat: 40.92705,
    lng: -79.59325,
    city: "Cowansville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1326,
    density: 18.9,
    county_fips: 42005,
    county_name: "Armstrong",
    county_weights: {
      42005: 100,
    },
    county_names_all: "Armstrong",
    county_fips_all: 42005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16220,
    lat: 41.41817,
    lng: -79.26659,
    city: "Crown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42031,
    county_name: "Clarion",
    county_weights: {
      42031: 99.88,
      42053: 0.12,
    },
    county_names_all: "Clarion|Forest",
    county_fips_all: "42031|42053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16222,
    lat: 40.87171,
    lng: -79.25719,
    city: "Dayton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2923,
    density: 18.5,
    county_fips: 42005,
    county_name: "Armstrong",
    county_weights: {
      42005: 82.9,
      42063: 8.99,
      42065: 8.11,
    },
    county_names_all: "Armstrong|Indiana|Jefferson",
    county_fips_all: "42005|42063|42065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16223,
    lat: 40.98701,
    lng: -79.35381,
    city: "Distant",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 130,
    density: 32.8,
    county_fips: 42005,
    county_name: "Armstrong",
    county_weights: {
      42005: 100,
    },
    county_names_all: "Armstrong",
    county_fips_all: 42005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16224,
    lat: 41.06314,
    lng: -79.29245,
    city: "Fairmount City",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1134,
    density: 22.5,
    county_fips: 42031,
    county_name: "Clarion",
    county_weights: {
      42005: 4.88,
      42031: 95.12,
    },
    county_names_all: "Clarion|Armstrong",
    county_fips_all: "42031|42005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16226,
    lat: 40.71139,
    lng: -79.48608,
    city: "Ford City",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7695,
    density: 50.7,
    county_fips: 42005,
    county_name: "Armstrong",
    county_weights: {
      42005: 100,
    },
    county_names_all: "Armstrong",
    county_fips_all: 42005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16228,
    lat: 40.76076,
    lng: -79.5358,
    city: "Ford Cliff",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 372,
    density: 1889.9,
    county_fips: 42005,
    county_name: "Armstrong",
    county_weights: {
      42005: 100,
    },
    county_names_all: "Armstrong",
    county_fips_all: 42005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16229,
    lat: 40.71624,
    lng: -79.64567,
    city: "Freeport",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5203,
    density: 74.8,
    county_fips: 42005,
    county_name: "Armstrong",
    county_weights: {
      42005: 87.16,
      42019: 6.76,
      42129: 6.08,
    },
    county_names_all: "Armstrong|Butler|Westmoreland",
    county_fips_all: "42005|42019|42129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16230,
    lat: 41.02099,
    lng: -79.27817,
    city: "Hawthorn",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 467,
    density: 176,
    county_fips: 42031,
    county_name: "Clarion",
    county_weights: {
      42005: 0.44,
      42031: 99.56,
    },
    county_names_all: "Clarion|Armstrong",
    county_fips_all: "42031|42005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16232,
    lat: 41.22197,
    lng: -79.54923,
    city: "Knox",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4199,
    density: 27.3,
    county_fips: 42031,
    county_name: "Clarion",
    county_weights: {
      42031: 98.73,
      42121: 1.27,
    },
    county_names_all: "Clarion|Venango",
    county_fips_all: "42031|42121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16233,
    lat: 41.36162,
    lng: -79.27588,
    city: "Leeper",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1208,
    density: 12.8,
    county_fips: 42031,
    county_name: "Clarion",
    county_weights: {
      42031: 100,
    },
    county_names_all: "Clarion",
    county_fips_all: 42031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16235,
    lat: 41.31759,
    lng: -79.34943,
    city: "Lucinda",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1185,
    density: 15.6,
    county_fips: 42031,
    county_name: "Clarion",
    county_weights: {
      42031: 100,
    },
    county_names_all: "Clarion",
    county_fips_all: 42031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16236,
    lat: 40.78119,
    lng: -79.52376,
    city: "McGrann",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 282,
    density: 1656.9,
    county_fips: 42005,
    county_name: "Armstrong",
    county_weights: {
      42005: 100,
    },
    county_names_all: "Armstrong",
    county_fips_all: 42005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16238,
    lat: 40.78778,
    lng: -79.52036,
    city: "Manorville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 487,
    density: 1866.4,
    county_fips: 42005,
    county_name: "Armstrong",
    county_weights: {
      42005: 100,
    },
    county_names_all: "Armstrong",
    county_fips_all: 42005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16239,
    lat: 41.49507,
    lng: -79.1297,
    city: "Marienville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4458,
    density: 9.1,
    county_fips: 42053,
    county_name: "Forest",
    county_weights: {
      42053: 100,
    },
    county_names_all: "Forest",
    county_fips_all: 42053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16240,
    lat: 41.03316,
    lng: -79.22432,
    city: "Mayport",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1573,
    density: 11.3,
    county_fips: 42065,
    county_name: "Jefferson",
    county_weights: {
      42005: 35.66,
      42031: 27.41,
      42065: 36.93,
    },
    county_names_all: "Jefferson|Armstrong|Clarion",
    county_fips_all: "42065|42005|42031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16242,
    lat: 41.0031,
    lng: -79.35479,
    city: "New Bethlehem",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4259,
    density: 17.6,
    county_fips: 42031,
    county_name: "Clarion",
    county_weights: {
      42005: 49.77,
      42031: 50.23,
    },
    county_names_all: "Clarion|Armstrong",
    county_fips_all: "42031|42005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16244,
    lat: 40.80499,
    lng: -79.27905,
    city: "Nu Mine",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 424,
    density: 87.2,
    county_fips: 42005,
    county_name: "Armstrong",
    county_weights: {
      42005: 100,
    },
    county_names_all: "Armstrong",
    county_fips_all: 42005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16245,
    lat: 41.00153,
    lng: -79.29311,
    city: "Oak Ridge",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 229,
    density: 67.6,
    county_fips: 42005,
    county_name: "Armstrong",
    county_weights: {
      42005: 99.85,
      42031: 0.15,
    },
    county_names_all: "Armstrong|Clarion",
    county_fips_all: "42005|42031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16246,
    lat: 40.79167,
    lng: -79.18215,
    city: "Plumville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 208,
    density: 237.1,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16248,
    lat: 41.03412,
    lng: -79.50348,
    city: "Rimersburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3059,
    density: 20.9,
    county_fips: 42031,
    county_name: "Clarion",
    county_weights: {
      42031: 100,
    },
    county_names_all: "Clarion",
    county_fips_all: 42031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16249,
    lat: 40.76209,
    lng: -79.32163,
    city: "Rural Valley",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1952,
    density: 29.1,
    county_fips: 42005,
    county_name: "Armstrong",
    county_weights: {
      42005: 100,
    },
    county_names_all: "Armstrong",
    county_fips_all: 42005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16250,
    lat: 40.77566,
    lng: -79.23782,
    city: "Sagamore",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 502,
    density: 43.3,
    county_fips: 42005,
    county_name: "Armstrong",
    county_weights: {
      42005: 100,
    },
    county_names_all: "Armstrong",
    county_fips_all: 42005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16253,
    lat: 40.954,
    lng: -79.34106,
    city: "Seminole",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 102,
    density: 103.8,
    county_fips: 42005,
    county_name: "Armstrong",
    county_weights: {
      42005: 100,
    },
    county_names_all: "Armstrong",
    county_fips_all: 42005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16254,
    lat: 41.26557,
    lng: -79.45259,
    city: "Shippenville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3572,
    density: 29.2,
    county_fips: 42031,
    county_name: "Clarion",
    county_weights: {
      42031: 100,
    },
    county_names_all: "Clarion",
    county_fips_all: 42031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16255,
    lat: 41.1267,
    lng: -79.46809,
    city: "Sligo",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1690,
    density: 16.1,
    county_fips: 42031,
    county_name: "Clarion",
    county_weights: {
      42031: 100,
    },
    county_names_all: "Clarion",
    county_fips_all: 42031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16256,
    lat: 40.8661,
    lng: -79.13611,
    city: "Smicksburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2116,
    density: 21.2,
    county_fips: 42063,
    county_name: "Indiana",
    county_weights: {
      42063: 100,
    },
    county_names_all: "Indiana",
    county_fips_all: 42063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16258,
    lat: 41.2307,
    lng: -79.27217,
    city: "Strattanville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1648,
    density: 17.3,
    county_fips: 42031,
    county_name: "Clarion",
    county_weights: {
      42031: 100,
    },
    county_names_all: "Clarion",
    county_fips_all: 42031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16259,
    lat: 40.92699,
    lng: -79.45692,
    city: "Templeton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2070,
    density: 17.7,
    county_fips: 42005,
    county_name: "Armstrong",
    county_weights: {
      42005: 100,
    },
    county_names_all: "Armstrong",
    county_fips_all: 42005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16260,
    lat: 41.41102,
    lng: -79.23092,
    city: "Vowinckel",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 293,
    density: 8.8,
    county_fips: 42031,
    county_name: "Clarion",
    county_weights: {
      42031: 60.65,
      42053: 39.35,
    },
    county_names_all: "Clarion|Forest",
    county_fips_all: "42031|42053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16262,
    lat: 40.8377,
    lng: -79.65266,
    city: "Worthington",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2794,
    density: 31.9,
    county_fips: 42005,
    county_name: "Armstrong",
    county_weights: {
      42005: 100,
    },
    county_names_all: "Armstrong",
    county_fips_all: 42005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16263,
    lat: 40.80118,
    lng: -79.34108,
    city: "Yatesboro",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 251,
    density: 26.4,
    county_fips: 42005,
    county_name: "Armstrong",
    county_weights: {
      42005: 100,
    },
    county_names_all: "Armstrong",
    county_fips_all: 42005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16301,
    lat: 41.45596,
    lng: -79.64946,
    city: "Oil City",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15044,
    density: 61.3,
    county_fips: 42121,
    county_name: "Venango",
    county_weights: {
      42121: 100,
    },
    county_names_all: "Venango",
    county_fips_all: 42121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16311,
    lat: 41.45706,
    lng: -80.03477,
    city: "Carlton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 453,
    density: 12,
    county_fips: 42085,
    county_name: "Mercer",
    county_weights: {
      42085: 95.28,
      42121: 4.72,
    },
    county_names_all: "Mercer|Venango",
    county_fips_all: "42085|42121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16312,
    lat: 41.93218,
    lng: -79.30324,
    city: "Chandlers Valley",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 42123,
    county_name: "Warren",
    county_weights: {
      42123: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 42123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16313,
    lat: 41.72294,
    lng: -79.13884,
    city: "Clarendon",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1785,
    density: 6,
    county_fips: 42123,
    county_name: "Warren",
    county_weights: {
      42123: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 42123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16314,
    lat: 41.51895,
    lng: -80.06782,
    city: "Cochranton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5240,
    density: 22,
    county_fips: 42039,
    county_name: "Crawford",
    county_weights: {
      42039: 80.61,
      42085: 11.4,
      42121: 7.99,
    },
    county_names_all: "Crawford|Mercer|Venango",
    county_fips_all: "42039|42085|42121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16316,
    lat: 41.6012,
    lng: -80.29958,
    city: "Conneaut Lake",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4821,
    density: 40.9,
    county_fips: 42039,
    county_name: "Crawford",
    county_weights: {
      42039: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 42039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16317,
    lat: 41.53232,
    lng: -79.85258,
    city: "Cooperstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1327,
    density: 16.9,
    county_fips: 42121,
    county_name: "Venango",
    county_weights: {
      42039: 4.71,
      42121: 95.29,
    },
    county_names_all: "Venango|Crawford",
    county_fips_all: "42121|42039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16319,
    lat: 41.3216,
    lng: -79.62942,
    city: "Cranberry",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1244,
    density: 13.3,
    county_fips: 42121,
    county_name: "Venango",
    county_weights: {
      42031: 24.79,
      42121: 75.21,
    },
    county_names_all: "Venango|Clarion",
    county_fips_all: "42121|42031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16321,
    lat: 41.56835,
    lng: -79.40084,
    city: "East Hickory",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31,
    density: 11.9,
    county_fips: 42053,
    county_name: "Forest",
    county_weights: {
      42053: 100,
    },
    county_names_all: "Forest",
    county_fips_all: 42053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16322,
    lat: 41.60567,
    lng: -79.38428,
    city: "Endeavor",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 86,
    density: 9.1,
    county_fips: 42053,
    county_name: "Forest",
    county_weights: {
      42053: 99.42,
      42123: 0.58,
    },
    county_names_all: "Forest|Warren",
    county_fips_all: "42053|42123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16323,
    lat: 41.41286,
    lng: -79.83047,
    city: "Franklin",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15141,
    density: 58.5,
    county_fips: 42121,
    county_name: "Venango",
    county_weights: {
      42121: 100,
    },
    county_names_all: "Venango",
    county_fips_all: 42121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16326,
    lat: 41.36733,
    lng: -79.43182,
    city: "Fryburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 340,
    density: 19.2,
    county_fips: 42031,
    county_name: "Clarion",
    county_weights: {
      42031: 100,
    },
    county_names_all: "Clarion",
    county_fips_all: 42031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16327,
    lat: 41.6323,
    lng: -79.95878,
    city: "Guys Mills",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2813,
    density: 18.1,
    county_fips: 42039,
    county_name: "Crawford",
    county_weights: {
      42039: 99.6,
      42121: 0.4,
    },
    county_names_all: "Crawford|Venango",
    county_fips_all: "42039|42121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16328,
    lat: 41.651,
    lng: -79.72716,
    city: "Hydetown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 215,
    density: 170.9,
    county_fips: 42039,
    county_name: "Crawford",
    county_weights: {
      42039: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 42039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16329,
    lat: 41.80642,
    lng: -79.27684,
    city: "Irvine",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 483,
    density: 41.6,
    county_fips: 42123,
    county_name: "Warren",
    county_weights: {
      42123: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 42123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16331,
    lat: 41.29047,
    lng: -79.56435,
    city: "Kossuth",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49,
    density: 10.5,
    county_fips: 42031,
    county_name: "Clarion",
    county_weights: {
      42031: 100,
    },
    county_names_all: "Clarion",
    county_fips_all: 42031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16332,
    lat: 41.36096,
    lng: -79.36873,
    city: "Lickingville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29,
    density: 2.8,
    county_fips: 42031,
    county_name: "Clarion",
    county_weights: {
      42031: 100,
    },
    county_names_all: "Clarion",
    county_fips_all: 42031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16333,
    lat: 41.74922,
    lng: -78.9323,
    city: "Ludlow",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42083,
    county_name: "McKean",
    county_weights: {
      42083: 100,
    },
    county_names_all: "McKean",
    county_fips_all: 42083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16334,
    lat: 41.29749,
    lng: -79.44968,
    city: "Marble",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 330,
    density: 18.8,
    county_fips: 42031,
    county_name: "Clarion",
    county_weights: {
      42031: 100,
    },
    county_names_all: "Clarion",
    county_fips_all: 42031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16335,
    lat: 41.63143,
    lng: -80.15378,
    city: "Meadville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27120,
    density: 91.4,
    county_fips: 42039,
    county_name: "Crawford",
    county_weights: {
      42039: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 42039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16340,
    lat: 41.79864,
    lng: -79.41749,
    city: "Pittsfield",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1795,
    density: 7.4,
    county_fips: 42123,
    county_name: "Warren",
    county_weights: {
      42123: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 42123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16341,
    lat: 41.56288,
    lng: -79.54703,
    city: "Pleasantville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1617,
    density: 8.4,
    county_fips: 42121,
    county_name: "Venango",
    county_weights: {
      42053: 31.74,
      42121: 68.26,
    },
    county_names_all: "Venango|Forest",
    county_fips_all: "42121|42053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16342,
    lat: 41.31995,
    lng: -79.9294,
    city: "Polk",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2202,
    density: 12.8,
    county_fips: 42121,
    county_name: "Venango",
    county_weights: {
      42085: 3.32,
      42121: 96.68,
    },
    county_names_all: "Venango|Mercer",
    county_fips_all: "42121|42085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16343,
    lat: 41.42204,
    lng: -79.75233,
    city: "Reno",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 629,
    density: 51.1,
    county_fips: 42121,
    county_name: "Venango",
    county_weights: {
      42121: 100,
    },
    county_names_all: "Venango",
    county_fips_all: 42121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16344,
    lat: 41.47045,
    lng: -79.684,
    city: "Rouseville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 436,
    density: 201.4,
    county_fips: 42121,
    county_name: "Venango",
    county_weights: {
      42121: 100,
    },
    county_names_all: "Venango",
    county_fips_all: 42121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16345,
    lat: 41.95085,
    lng: -79.07548,
    city: "Russell",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3436,
    density: 14.1,
    county_fips: 42123,
    county_name: "Warren",
    county_weights: {
      42123: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 42123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16346,
    lat: 41.37845,
    lng: -79.6727,
    city: "Seneca",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3615,
    density: 89.6,
    county_fips: 42121,
    county_name: "Venango",
    county_weights: {
      42121: 100,
    },
    county_names_all: "Venango",
    county_fips_all: 42121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16347,
    lat: 41.64671,
    lng: -79.06481,
    city: "Sheffield",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2007,
    density: 7.5,
    county_fips: 42123,
    county_name: "Warren",
    county_weights: {
      42053: 42.8,
      42123: 57.2,
    },
    county_names_all: "Warren|Forest",
    county_fips_all: "42123|42053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16350,
    lat: 41.96323,
    lng: -79.3322,
    city: "Sugar Grove",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2385,
    density: 18.4,
    county_fips: 42123,
    county_name: "Warren",
    county_weights: {
      42123: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 42123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16351,
    lat: 41.67583,
    lng: -79.37285,
    city: "Tidioute",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1521,
    density: 6.3,
    county_fips: 42123,
    county_name: "Warren",
    county_weights: {
      42053: 13.58,
      42123: 86.42,
    },
    county_names_all: "Warren|Forest",
    county_fips_all: "42123|42053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16352,
    lat: 41.76615,
    lng: -79.03644,
    city: "Tiona",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 189,
    density: 6.6,
    county_fips: 42123,
    county_name: "Warren",
    county_weights: {
      42123: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 42123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16353,
    lat: 41.49359,
    lng: -79.38839,
    city: "Tionesta",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2976,
    density: 7.7,
    county_fips: 42053,
    county_name: "Forest",
    county_weights: {
      42031: 10.01,
      42053: 80.59,
      42121: 9.4,
    },
    county_names_all: "Forest|Clarion|Venango",
    county_fips_all: "42053|42031|42121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16354,
    lat: 41.61476,
    lng: -79.70637,
    city: "Titusville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10819,
    density: 33.7,
    county_fips: 42121,
    county_name: "Venango",
    county_weights: {
      42039: 40.7,
      42121: 51.58,
      42123: 7.72,
    },
    county_names_all: "Venango|Crawford|Warren",
    county_fips_all: "42121|42039|42123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16360,
    lat: 41.68167,
    lng: -79.89028,
    city: "Townville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1387,
    density: 17.6,
    county_fips: 42039,
    county_name: "Crawford",
    county_weights: {
      42039: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 42039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16361,
    lat: 41.38597,
    lng: -79.3422,
    city: "Tylersburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11,
    density: 1.9,
    county_fips: 42031,
    county_name: "Clarion",
    county_weights: {
      42031: 100,
    },
    county_names_all: "Clarion",
    county_fips_all: 42031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16362,
    lat: 41.45032,
    lng: -79.96284,
    city: "Utica",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 863,
    density: 11.9,
    county_fips: 42121,
    county_name: "Venango",
    county_weights: {
      42085: 11.14,
      42121: 88.86,
    },
    county_names_all: "Venango|Mercer",
    county_fips_all: "42121|42085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16364,
    lat: 41.36379,
    lng: -79.51517,
    city: "Venus",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1260,
    density: 14.3,
    county_fips: 42121,
    county_name: "Venango",
    county_weights: {
      42031: 20.13,
      42121: 79.87,
    },
    county_names_all: "Venango|Clarion",
    county_fips_all: "42121|42031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16365,
    lat: 41.83943,
    lng: -79.15324,
    city: "Warren",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17675,
    density: 49,
    county_fips: 42123,
    county_name: "Warren",
    county_weights: {
      42123: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 42123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16370,
    lat: 41.56586,
    lng: -79.44796,
    city: "West Hickory",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 271,
    density: 13.2,
    county_fips: 42053,
    county_name: "Forest",
    county_weights: {
      42053: 100,
    },
    county_names_all: "Forest",
    county_fips_all: 42053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16371,
    lat: 41.86751,
    lng: -79.3187,
    city: "Youngsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3347,
    density: 40.9,
    county_fips: 42123,
    county_name: "Warren",
    county_weights: {
      42123: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 42123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16372,
    lat: 41.20121,
    lng: -79.87406,
    city: "Clintonville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 546,
    density: 213.7,
    county_fips: 42121,
    county_name: "Venango",
    county_weights: {
      42121: 100,
    },
    county_names_all: "Venango",
    county_fips_all: 42121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16373,
    lat: 41.20786,
    lng: -79.69796,
    city: "Emlenton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3172,
    density: 15.2,
    county_fips: 42121,
    county_name: "Venango",
    county_weights: {
      42019: 7.03,
      42031: 28.53,
      42121: 64.44,
    },
    county_names_all: "Venango|Clarion|Butler",
    county_fips_all: "42121|42031|42019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16374,
    lat: 41.26136,
    lng: -79.81066,
    city: "Kennerdell",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1776,
    density: 10.4,
    county_fips: 42121,
    county_name: "Venango",
    county_weights: {
      42121: 100,
    },
    county_names_all: "Venango",
    county_fips_all: 42121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16401,
    lat: 41.88044,
    lng: -80.40395,
    city: "Albion",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6431,
    density: 44.7,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42039: 4.22,
      42049: 95.78,
    },
    county_names_all: "Erie|Crawford",
    county_fips_all: "42049|42039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16402,
    lat: 41.96459,
    lng: -79.48076,
    city: "Bear Lake",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 836,
    density: 12.6,
    county_fips: 42123,
    county_name: "Warren",
    county_weights: {
      42123: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 42123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16403,
    lat: 41.7912,
    lng: -80.02017,
    city: "Cambridge Springs",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7278,
    density: 31,
    county_fips: 42039,
    county_name: "Crawford",
    county_weights: {
      42039: 93.09,
      42049: 6.91,
    },
    county_names_all: "Crawford|Erie",
    county_fips_all: "42039|42049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16404,
    lat: 41.72483,
    lng: -79.79018,
    city: "Centerville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3286,
    density: 14.5,
    county_fips: 42039,
    county_name: "Crawford",
    county_weights: {
      42039: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 42039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16405,
    lat: 41.938,
    lng: -79.5335,
    city: "Columbus",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 771,
    density: 15.8,
    county_fips: 42123,
    county_name: "Warren",
    county_weights: {
      42123: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 42123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16406,
    lat: 41.75047,
    lng: -80.36273,
    city: "Conneautville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3294,
    density: 16.2,
    county_fips: 42039,
    county_name: "Crawford",
    county_weights: {
      42039: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 42039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16407,
    lat: 41.91743,
    lng: -79.66374,
    city: "Corry",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10816,
    density: 36.9,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42039: 3.78,
      42049: 72.3,
      42123: 23.92,
    },
    county_names_all: "Erie|Warren|Crawford",
    county_fips_all: "42049|42123|42039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16410,
    lat: 41.92012,
    lng: -80.30482,
    city: "Cranesville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2087,
    density: 35.4,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42049: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 42049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16411,
    lat: 41.97781,
    lng: -80.45037,
    city: "East Springfield",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1390,
    density: 35,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42049: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 42049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16412,
    lat: 41.88212,
    lng: -80.16392,
    city: "Edinboro",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10041,
    density: 48,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42039: 20.73,
      42049: 79.27,
    },
    county_names_all: "Erie|Crawford",
    county_fips_all: "42049|42039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16415,
    lat: 42.03122,
    lng: -80.22873,
    city: "Fairview",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9492,
    density: 157,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42049: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 42049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16416,
    lat: 41.82606,
    lng: -79.47311,
    city: "Garland",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 158,
    density: 15.9,
    county_fips: 42123,
    county_name: "Warren",
    county_weights: {
      42123: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 42123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16417,
    lat: 41.97107,
    lng: -80.31039,
    city: "Girard",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8141,
    density: 65.5,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42049: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 42049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16420,
    lat: 41.69481,
    lng: -79.54544,
    city: "Grand Valley",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 499,
    density: 3.9,
    county_fips: 42123,
    county_name: "Warren",
    county_weights: {
      42123: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 42123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16421,
    lat: 42.17036,
    lng: -79.9351,
    city: "Harborcreek",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2606,
    density: 95.4,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42049: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 42049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16422,
    lat: 41.66555,
    lng: -80.31447,
    city: "Harmonsburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 366,
    density: 102.7,
    county_fips: 42039,
    county_name: "Crawford",
    county_weights: {
      42039: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 42039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16423,
    lat: 42.01881,
    lng: -80.34253,
    city: "Lake City",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4018,
    density: 169.4,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42049: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 42049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16424,
    lat: 41.65887,
    lng: -80.44175,
    city: "Linesville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4641,
    density: 25.4,
    county_fips: 42039,
    county_name: "Crawford",
    county_weights: {
      42039: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 42039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16426,
    lat: 41.98121,
    lng: -80.13937,
    city: "McKean",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3389,
    density: 45.5,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42049: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 42049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16427,
    lat: 41.87466,
    lng: -79.97132,
    city: "Mill Village",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 146,
    density: 224.7,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42049: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 42049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16428,
    lat: 42.17109,
    lng: -79.82907,
    city: "North East",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12313,
    density: 64.6,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42049: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 42049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16430,
    lat: 42.00413,
    lng: -80.41823,
    city: "North Springfield",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42049: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 42049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16433,
    lat: 41.73553,
    lng: -80.14316,
    city: "Saegertown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5193,
    density: 35.5,
    county_fips: 42039,
    county_name: "Crawford",
    county_weights: {
      42039: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 42039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16434,
    lat: 41.79442,
    lng: -79.66765,
    city: "Spartansburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3228,
    density: 19.8,
    county_fips: 42039,
    county_name: "Crawford",
    county_weights: {
      42039: 82.96,
      42123: 17.04,
    },
    county_names_all: "Crawford|Warren",
    county_fips_all: "42039|42123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16435,
    lat: 41.81937,
    lng: -80.38356,
    city: "Springboro",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1806,
    density: 13.1,
    county_fips: 42039,
    county_name: "Crawford",
    county_weights: {
      42039: 99.53,
      42049: 0.47,
    },
    county_names_all: "Crawford|Erie",
    county_fips_all: "42039|42049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16436,
    lat: 41.85563,
    lng: -79.49889,
    city: "Spring Creek",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 859,
    density: 6.8,
    county_fips: 42123,
    county_name: "Warren",
    county_weights: {
      42123: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 42123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16438,
    lat: 41.89084,
    lng: -79.84709,
    city: "Union City",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7588,
    density: 28.6,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42039: 31.05,
      42049: 68.95,
    },
    county_names_all: "Erie|Crawford",
    county_fips_all: "42049|42039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16440,
    lat: 41.78673,
    lng: -80.13088,
    city: "Venango",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 850,
    density: 31.4,
    county_fips: 42039,
    county_name: "Crawford",
    county_weights: {
      42039: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 42039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16441,
    lat: 41.9554,
    lng: -79.98552,
    city: "Waterford",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10069,
    density: 35.3,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42039: 2.89,
      42049: 97.11,
    },
    county_names_all: "Erie|Crawford",
    county_fips_all: "42049|42039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16442,
    lat: 42.04094,
    lng: -79.82631,
    city: "Wattsburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3334,
    density: 25.6,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42049: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 42049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16443,
    lat: 41.93745,
    lng: -80.47831,
    city: "West Springfield",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1166,
    density: 35.4,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42049: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 42049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16444,
    lat: 41.87071,
    lng: -80.12175,
    city: "Edinboro",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1022,
    density: 1504.2,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42049: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 42049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16475,
    lat: 41.87645,
    lng: -80.36107,
    city: "Albion",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42049: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 42049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16501,
    lat: 42.12096,
    lng: -80.08958,
    city: "Erie",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1569,
    density: 846.4,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42049: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 42049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16502,
    lat: 42.11073,
    lng: -80.10123,
    city: "Erie",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15818,
    density: 2463.4,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42049: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 42049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16503,
    lat: 42.12718,
    lng: -80.06103,
    city: "Erie",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15855,
    density: 2513.8,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42049: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 42049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16504,
    lat: 42.10942,
    lng: -80.0489,
    city: "Erie",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16571,
    density: 2320.2,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42049: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 42049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16505,
    lat: 42.11789,
    lng: -80.14304,
    city: "Erie",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15615,
    density: 517.1,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42049: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 42049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16506,
    lat: 42.06449,
    lng: -80.15472,
    city: "Erie",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24163,
    density: 687,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42049: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 42049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16507,
    lat: 42.13575,
    lng: -80.08743,
    city: "Erie",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9512,
    density: 1756.2,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42049: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 42049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16508,
    lat: 42.09719,
    lng: -80.09249,
    city: "Erie",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16021,
    density: 2206.2,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42049: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 42049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16509,
    lat: 42.05861,
    lng: -80.04419,
    city: "Erie",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26838,
    density: 271.2,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42049: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 42049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16510,
    lat: 42.11184,
    lng: -79.95395,
    city: "Erie",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25299,
    density: 296.3,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42049: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 42049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16511,
    lat: 42.16529,
    lng: -79.99667,
    city: "Erie",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11439,
    density: 597.8,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42049: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 42049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16546,
    lat: 42.10389,
    lng: -80.05338,
    city: "Erie",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 715,
    density: 2671.1,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42049: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 42049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16550,
    lat: 42.13378,
    lng: -80.08495,
    city: "Erie",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42049: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 42049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16563,
    lat: 42.11929,
    lng: -79.98643,
    city: "Erie",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1596,
    density: 1408.7,
    county_fips: 42049,
    county_name: "Erie",
    county_weights: {
      42049: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 42049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16601,
    lat: 40.55338,
    lng: -78.37283,
    city: "Altoona",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31825,
    density: 144.8,
    county_fips: 42013,
    county_name: "Blair",
    county_weights: {
      42013: 100,
    },
    county_names_all: "Blair",
    county_fips_all: 42013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16602,
    lat: 40.51491,
    lng: -78.37052,
    city: "Altoona",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28609,
    density: 752.4,
    county_fips: 42013,
    county_name: "Blair",
    county_weights: {
      42013: 100,
    },
    county_names_all: "Blair",
    county_fips_all: 42013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16611,
    lat: 40.56719,
    lng: -78.10214,
    city: "Alexandria",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2624,
    density: 22.4,
    county_fips: 42061,
    county_name: "Huntingdon",
    county_weights: {
      42061: 100,
    },
    county_names_all: "Huntingdon",
    county_fips_all: 42061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16613,
    lat: 40.53723,
    lng: -78.53214,
    city: "Ashville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1277,
    density: 15.7,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42013: 31.91,
      42021: 68.09,
    },
    county_names_all: "Cambria|Blair",
    county_fips_all: "42021|42013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16616,
    lat: 40.76832,
    lng: -78.45128,
    city: "Beccaria",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 164,
    density: 38.1,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16617,
    lat: 40.6036,
    lng: -78.32995,
    city: "Bellwood",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2637,
    density: 688.1,
    county_fips: 42013,
    county_name: "Blair",
    county_weights: {
      42013: 100,
    },
    county_names_all: "Blair",
    county_fips_all: 42013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16619,
    lat: 40.68367,
    lng: -78.41591,
    city: "Blandburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 318,
    density: 253.6,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16620,
    lat: 40.83947,
    lng: -78.35259,
    city: "Brisbin",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 323,
    density: 175.5,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16621,
    lat: 40.22888,
    lng: -78.12298,
    city: "Broad Top",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 680,
    density: 16.6,
    county_fips: 42061,
    county_name: "Huntingdon",
    county_weights: {
      42061: 100,
    },
    county_names_all: "Huntingdon",
    county_fips_all: 42061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16622,
    lat: 40.32853,
    lng: -78.0692,
    city: "Calvin",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 132,
    density: 7.1,
    county_fips: 42061,
    county_name: "Huntingdon",
    county_weights: {
      42061: 100,
    },
    county_names_all: "Huntingdon",
    county_fips_all: 42061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16623,
    lat: 40.27618,
    lng: -78.04556,
    city: "Cassville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 552,
    density: 19.1,
    county_fips: 42061,
    county_name: "Huntingdon",
    county_weights: {
      42061: 100,
    },
    county_names_all: "Huntingdon",
    county_fips_all: 42061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16624,
    lat: 40.5651,
    lng: -78.60664,
    city: "Chest Springs",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 189,
    density: 25.1,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16625,
    lat: 40.28482,
    lng: -78.50855,
    city: "Claysburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4044,
    density: 48.7,
    county_fips: 42013,
    county_name: "Blair",
    county_weights: {
      42009: 41.84,
      42013: 58.16,
    },
    county_names_all: "Blair|Bedford",
    county_fips_all: "42013|42009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16627,
    lat: 40.75272,
    lng: -78.50036,
    city: "Coalport",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2118,
    density: 25.3,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42021: 12.62,
      42033: 87.38,
    },
    county_names_all: "Clearfield|Cambria",
    county_fips_all: "42033|42021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16630,
    lat: 40.46231,
    lng: -78.58003,
    city: "Cresson",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4778,
    density: 323.6,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16631,
    lat: 40.27141,
    lng: -78.34754,
    city: "Curryville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 116,
    density: 86,
    county_fips: 42013,
    county_name: "Blair",
    county_weights: {
      42013: 100,
    },
    county_names_all: "Blair",
    county_fips_all: 42013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16633,
    lat: 40.15969,
    lng: -78.23259,
    city: "Defiance",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 443,
    density: 1159.8,
    county_fips: 42009,
    county_name: "Bedford",
    county_weights: {
      42009: 100,
    },
    county_names_all: "Bedford",
    county_fips_all: 42009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16634,
    lat: 40.2105,
    lng: -78.17308,
    city: "Dudley",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 315,
    density: 37,
    county_fips: 42061,
    county_name: "Huntingdon",
    county_weights: {
      42009: 0.5,
      42061: 99.5,
    },
    county_names_all: "Huntingdon|Bedford",
    county_fips_all: "42061|42009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16635,
    lat: 40.41621,
    lng: -78.48743,
    city: "Duncansville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12438,
    density: 84.6,
    county_fips: 42013,
    county_name: "Blair",
    county_weights: {
      42013: 100,
    },
    county_names_all: "Blair",
    county_fips_all: 42013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16636,
    lat: 40.60214,
    lng: -78.50161,
    city: "Dysart",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 898,
    density: 12.3,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42013: 4.97,
      42021: 95.03,
    },
    county_names_all: "Cambria|Blair",
    county_fips_all: "42021|42013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16637,
    lat: 40.34214,
    lng: -78.47079,
    city: "East Freedom",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2323,
    density: 45.8,
    county_fips: 42013,
    county_name: "Blair",
    county_weights: {
      42013: 100,
    },
    county_names_all: "Blair",
    county_fips_all: 42013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16638,
    lat: 40.33809,
    lng: -78.2012,
    city: "Entriken",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40,
    density: 16.5,
    county_fips: 42061,
    county_name: "Huntingdon",
    county_weights: {
      42061: 100,
    },
    county_names_all: "Huntingdon",
    county_fips_all: 42061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16639,
    lat: 40.68566,
    lng: -78.44912,
    city: "Fallentimber",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1592,
    density: 13.1,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 88.67,
      42033: 11.33,
    },
    county_names_all: "Cambria|Clearfield",
    county_fips_all: "42021|42033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16640,
    lat: 40.70657,
    lng: -78.5702,
    city: "Flinton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 707,
    density: 19.6,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16641,
    lat: 40.50774,
    lng: -78.57146,
    city: "Gallitzin",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2519,
    density: 74.8,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42013: 6.79,
      42021: 93.21,
    },
    county_names_all: "Cambria|Blair",
    county_fips_all: "42021|42013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16645,
    lat: 40.80204,
    lng: -78.49932,
    city: "Glen Hope",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 189,
    density: 38.3,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16646,
    lat: 40.68291,
    lng: -78.71579,
    city: "Hastings",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2159,
    density: 46,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 98.64,
      42033: 1.36,
    },
    county_names_all: "Cambria|Clearfield",
    county_fips_all: "42021|42033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16647,
    lat: 40.39514,
    lng: -78.09798,
    city: "Hesston",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 765,
    density: 11.6,
    county_fips: 42061,
    county_name: "Huntingdon",
    county_weights: {
      42061: 100,
    },
    county_names_all: "Huntingdon",
    county_fips_all: 42061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16648,
    lat: 40.44231,
    lng: -78.33242,
    city: "Hollidaysburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14374,
    density: 92.4,
    county_fips: 42013,
    county_name: "Blair",
    county_weights: {
      42013: 100,
    },
    county_names_all: "Blair",
    county_fips_all: 42013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16650,
    lat: 40.11592,
    lng: -78.29237,
    city: "Hopewell",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1644,
    density: 13.6,
    county_fips: 42009,
    county_name: "Bedford",
    county_weights: {
      42009: 100,
    },
    county_names_all: "Bedford",
    county_fips_all: 42009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16651,
    lat: 40.8505,
    lng: -78.37945,
    city: "Houtzdale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5818,
    density: 56.8,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16652,
    lat: 40.51692,
    lng: -77.95302,
    city: "Huntingdon",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18469,
    density: 41.1,
    county_fips: 42061,
    county_name: "Huntingdon",
    county_weights: {
      42061: 100,
    },
    county_names_all: "Huntingdon",
    county_fips_all: 42061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16654,
    lat: 40.49189,
    lng: -78.02854,
    city: "Huntingdon",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42061,
    county_name: "Huntingdon",
    county_weights: {
      42061: 100,
    },
    county_names_all: "Huntingdon",
    county_fips_all: 42061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16655,
    lat: 40.24898,
    lng: -78.55092,
    city: "Imler",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1666,
    density: 19.9,
    county_fips: 42009,
    county_name: "Bedford",
    county_weights: {
      42009: 97.9,
      42013: 2.1,
    },
    county_names_all: "Bedford|Blair",
    county_fips_all: "42009|42013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16656,
    lat: 40.8066,
    lng: -78.56353,
    city: "Irvona",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1259,
    density: 17.9,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16657,
    lat: 40.32486,
    lng: -78.17757,
    city: "James Creek",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1397,
    density: 10.9,
    county_fips: 42061,
    county_name: "Huntingdon",
    county_weights: {
      42009: 1.91,
      42061: 98.09,
    },
    county_names_all: "Huntingdon|Bedford",
    county_fips_all: "42061|42009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16659,
    lat: 40.16063,
    lng: -78.39138,
    city: "Loysburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 230,
    density: 54.1,
    county_fips: 42009,
    county_name: "Bedford",
    county_weights: {
      42009: 100,
    },
    county_names_all: "Bedford",
    county_fips_all: 42009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16661,
    lat: 40.83058,
    lng: -78.45026,
    city: "Madera",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 834,
    density: 14.2,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16662,
    lat: 40.30635,
    lng: -78.29961,
    city: "Martinsburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5967,
    density: 42.8,
    county_fips: 42013,
    county_name: "Blair",
    county_weights: {
      42009: 15.05,
      42013: 84.95,
    },
    county_names_all: "Blair|Bedford",
    county_fips_all: "42013|42009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16664,
    lat: 40.17822,
    lng: -78.42437,
    city: "New Enterprise",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2156,
    density: 20.7,
    county_fips: 42009,
    county_name: "Bedford",
    county_weights: {
      42009: 100,
    },
    county_names_all: "Bedford",
    county_fips_all: 42009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16665,
    lat: 40.38898,
    lng: -78.43491,
    city: "Newry",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 300,
    density: 248.1,
    county_fips: 42013,
    county_name: "Blair",
    county_weights: {
      42013: 100,
    },
    county_names_all: "Blair",
    county_fips_all: 42013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16666,
    lat: 40.87056,
    lng: -78.31286,
    city: "Osceola Mills",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3043,
    density: 50.1,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42027: 10.71,
      42033: 89.29,
    },
    county_names_all: "Clearfield|Centre",
    county_fips_all: "42033|42027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16667,
    lat: 40.18213,
    lng: -78.52546,
    city: "Osterburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1483,
    density: 31.7,
    county_fips: 42009,
    county_name: "Bedford",
    county_weights: {
      42009: 100,
    },
    county_names_all: "Bedford",
    county_fips_all: 42009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16668,
    lat: 40.65072,
    lng: -78.61974,
    city: "Patton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3381,
    density: 24.6,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16669,
    lat: 40.65737,
    lng: -77.90675,
    city: "Petersburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2058,
    density: 7.6,
    county_fips: 42061,
    county_name: "Huntingdon",
    county_weights: {
      42061: 100,
    },
    county_names_all: "Huntingdon",
    county_fips_all: 42061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16670,
    lat: 40.25828,
    lng: -78.50556,
    city: "Queen",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28,
    density: 16.8,
    county_fips: 42009,
    county_name: "Bedford",
    county_weights: {
      42009: 100,
    },
    county_names_all: "Bedford",
    county_fips_all: 42009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16671,
    lat: 40.79414,
    lng: -78.40203,
    city: "Ramey",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 472,
    density: 74.7,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16672,
    lat: 40.16935,
    lng: -78.24324,
    city: "Riddlesburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 242,
    density: 22.4,
    county_fips: 42009,
    county_name: "Bedford",
    county_weights: {
      42009: 100,
    },
    county_names_all: "Bedford",
    county_fips_all: 42009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16673,
    lat: 40.30671,
    lng: -78.39026,
    city: "Roaring Spring",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5385,
    density: 60.5,
    county_fips: 42013,
    county_name: "Blair",
    county_weights: {
      42009: 37.86,
      42013: 62.14,
    },
    county_names_all: "Blair|Bedford",
    county_fips_all: "42013|42009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16674,
    lat: 40.1865,
    lng: -78.07926,
    city: "Robertsdale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 643,
    density: 15.9,
    county_fips: 42061,
    county_name: "Huntingdon",
    county_weights: {
      42061: 100,
    },
    county_names_all: "Huntingdon",
    county_fips_all: 42061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16675,
    lat: 40.68796,
    lng: -78.67905,
    city: "Saint Boniface",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16677,
    lat: 40.81507,
    lng: -78.2457,
    city: "Sandy Ridge",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 204,
    density: 26.1,
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 100,
    },
    county_names_all: "Centre",
    county_fips_all: 42027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16678,
    lat: 40.2252,
    lng: -78.23421,
    city: "Saxton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2456,
    density: 19.6,
    county_fips: 42009,
    county_name: "Bedford",
    county_weights: {
      42009: 54.56,
      42061: 45.44,
    },
    county_names_all: "Bedford|Huntingdon",
    county_fips_all: "42009|42061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16679,
    lat: 40.15659,
    lng: -78.195,
    city: "Six Mile Run",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 687,
    density: 11.7,
    county_fips: 42009,
    county_name: "Bedford",
    county_weights: {
      42009: 100,
    },
    county_names_all: "Bedford",
    county_fips_all: 42009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16680,
    lat: 40.75149,
    lng: -78.40254,
    city: "Smithmill",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 303,
    density: 15.9,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16682,
    lat: 40.27206,
    lng: -78.4565,
    city: "Sproul",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22,
    density: 110.2,
    county_fips: 42013,
    county_name: "Blair",
    county_weights: {
      42013: 100,
    },
    county_names_all: "Blair",
    county_fips_all: 42013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16683,
    lat: 40.65595,
    lng: -78.07313,
    city: "Spruce Creek",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 259,
    density: 5.1,
    county_fips: 42061,
    county_name: "Huntingdon",
    county_weights: {
      42061: 100,
    },
    county_names_all: "Huntingdon",
    county_fips_all: 42061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16684,
    lat: 40.63541,
    lng: -78.29685,
    city: "Tipton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42013,
    county_name: "Blair",
    county_weights: {
      42013: 100,
    },
    county_names_all: "Blair",
    county_fips_all: 42013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16685,
    lat: 40.28019,
    lng: -78.08063,
    city: "Todd",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 274,
    density: 9.5,
    county_fips: 42061,
    county_name: "Huntingdon",
    county_weights: {
      42061: 100,
    },
    county_names_all: "Huntingdon",
    county_fips_all: 42061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16686,
    lat: 40.67056,
    lng: -78.24102,
    city: "Tyrone",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12879,
    density: 33.8,
    county_fips: 42013,
    county_name: "Blair",
    county_weights: {
      42013: 68.51,
      42027: 6.77,
      42061: 24.72,
    },
    county_names_all: "Blair|Huntingdon|Centre",
    county_fips_all: "42013|42061|42027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16689,
    lat: 40.10737,
    lng: -78.10028,
    city: "Waterfall",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 477,
    density: 10.6,
    county_fips: 42057,
    county_name: "Fulton",
    county_weights: {
      42057: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 42057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16691,
    lat: 40.07744,
    lng: -78.1473,
    city: "Wells Tannery",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 318,
    density: 4.3,
    county_fips: 42057,
    county_name: "Fulton",
    county_weights: {
      42057: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 42057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16692,
    lat: 40.75935,
    lng: -78.72053,
    city: "Westover",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 811,
    density: 15.8,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16693,
    lat: 40.46519,
    lng: -78.21593,
    city: "Williamsburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4066,
    density: 20.3,
    county_fips: 42013,
    county_name: "Blair",
    county_weights: {
      42013: 100,
    },
    county_names_all: "Blair",
    county_fips_all: 42013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16694,
    lat: 40.17259,
    lng: -78.12852,
    city: "Wood",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 191,
    density: 17.7,
    county_fips: 42061,
    county_name: "Huntingdon",
    county_weights: {
      42009: 14.09,
      42057: 1.56,
      42061: 84.35,
    },
    county_names_all: "Huntingdon|Bedford|Fulton",
    county_fips_all: "42061|42009|42057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16695,
    lat: 40.20327,
    lng: -78.35943,
    city: "Woodbury",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1213,
    density: 34,
    county_fips: 42009,
    county_name: "Bedford",
    county_weights: {
      42009: 100,
    },
    county_names_all: "Bedford",
    county_fips_all: 42009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16699,
    lat: 40.44736,
    lng: -78.56054,
    city: "Cresson",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 42021,
    county_name: "Cambria",
    county_weights: {
      42021: 100,
    },
    county_names_all: "Cambria",
    county_fips_all: 42021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16701,
    lat: 41.91105,
    lng: -78.77385,
    city: "Bradford",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17072,
    density: 30,
    county_fips: 42083,
    county_name: "McKean",
    county_weights: {
      42083: 92.18,
      42123: 7.82,
    },
    county_names_all: "McKean|Warren",
    county_fips_all: "42083|42123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16720,
    lat: 41.5793,
    lng: -78.02599,
    city: "Austin",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1238,
    density: 1.8,
    county_fips: 42105,
    county_name: "Potter",
    county_weights: {
      42023: 10.55,
      42083: 4.19,
      42105: 85.26,
    },
    county_names_all: "Potter|Cameron|McKean",
    county_fips_all: "42105|42023|42083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16724,
    lat: 41.74674,
    lng: -78.39022,
    city: "Crosby",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 122,
    density: 126.5,
    county_fips: 42083,
    county_name: "McKean",
    county_weights: {
      42083: 100,
    },
    county_names_all: "McKean",
    county_fips_all: 42083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16725,
    lat: 41.89881,
    lng: -78.66328,
    city: "Custer City",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 179,
    density: 68.8,
    county_fips: 42083,
    county_name: "McKean",
    county_weights: {
      42083: 100,
    },
    county_names_all: "McKean",
    county_fips_all: 42083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16726,
    lat: 41.80456,
    lng: -78.57787,
    city: "Cyclone",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 572,
    density: 6.6,
    county_fips: 42083,
    county_name: "McKean",
    county_weights: {
      42083: 100,
    },
    county_names_all: "McKean",
    county_fips_all: 42083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16727,
    lat: 41.98501,
    lng: -78.5338,
    city: "Derrick City",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 196,
    density: 16.8,
    county_fips: 42083,
    county_name: "McKean",
    county_weights: {
      42083: 100,
    },
    county_names_all: "McKean",
    county_fips_all: 42083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16729,
    lat: 41.96501,
    lng: -78.4788,
    city: "Duke Center",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 707,
    density: 17.8,
    county_fips: 42083,
    county_name: "McKean",
    county_weights: {
      42083: 100,
    },
    county_names_all: "McKean",
    county_fips_all: 42083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16730,
    lat: 41.81339,
    lng: -78.42309,
    city: "East Smethport",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68,
    density: 33.6,
    county_fips: 42083,
    county_name: "McKean",
    county_weights: {
      42083: 100,
    },
    county_names_all: "McKean",
    county_fips_all: 42083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16731,
    lat: 41.94625,
    lng: -78.37126,
    city: "Eldred",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2342,
    density: 15.3,
    county_fips: 42083,
    county_name: "McKean",
    county_weights: {
      42083: 100,
    },
    county_names_all: "McKean",
    county_fips_all: 42083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16732,
    lat: 41.85921,
    lng: -78.60843,
    city: "Gifford",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 189,
    density: 12,
    county_fips: 42083,
    county_name: "McKean",
    county_weights: {
      42083: 100,
    },
    county_names_all: "McKean",
    county_fips_all: 42083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16733,
    lat: 41.70303,
    lng: -78.59514,
    city: "Hazel Hurst",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 208,
    density: 6.9,
    county_fips: 42083,
    county_name: "McKean",
    county_weights: {
      42083: 100,
    },
    county_names_all: "McKean",
    county_fips_all: 42083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16734,
    lat: 41.61806,
    lng: -78.84418,
    city: "James City",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 250,
    density: 137.8,
    county_fips: 42047,
    county_name: "Elk",
    county_weights: {
      42047: 100,
    },
    county_names_all: "Elk",
    county_fips_all: 42047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16735,
    lat: 41.63045,
    lng: -78.81,
    city: "Kane",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5952,
    density: 8.7,
    county_fips: 42083,
    county_name: "McKean",
    county_weights: {
      42047: 39.31,
      42083: 60.69,
    },
    county_names_all: "McKean|Elk",
    county_fips_all: "42083|42047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16738,
    lat: 41.80511,
    lng: -78.73929,
    city: "Lewis Run",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2476,
    density: 13.4,
    county_fips: 42083,
    county_name: "McKean",
    county_weights: {
      42083: 100,
    },
    county_names_all: "McKean",
    county_fips_all: 42083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16740,
    lat: 41.69255,
    lng: -78.54998,
    city: "Mount Jewett",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1036,
    density: 8.9,
    county_fips: 42083,
    county_name: "McKean",
    county_weights: {
      42083: 100,
    },
    county_names_all: "McKean",
    county_fips_all: 42083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16743,
    lat: 41.7888,
    lng: -78.26016,
    city: "Port Allegany",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3898,
    density: 14.9,
    county_fips: 42083,
    county_name: "McKean",
    county_weights: {
      42083: 88.47,
      42105: 11.53,
    },
    county_names_all: "McKean|Potter",
    county_fips_all: "42083|42105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16744,
    lat: 41.87567,
    lng: -78.56941,
    city: "Rew",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 245,
    density: 18.7,
    county_fips: 42083,
    county_name: "McKean",
    county_weights: {
      42083: 100,
    },
    county_names_all: "McKean",
    county_fips_all: 42083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16745,
    lat: 41.92578,
    lng: -78.49042,
    city: "Rixford",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 642,
    density: 19,
    county_fips: 42083,
    county_name: "McKean",
    county_weights: {
      42083: 100,
    },
    county_names_all: "McKean",
    county_fips_all: 42083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16746,
    lat: 41.79064,
    lng: -78.13858,
    city: "Roulette",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1156,
    density: 11,
    county_fips: 42105,
    county_name: "Potter",
    county_weights: {
      42105: 100,
    },
    county_names_all: "Potter",
    county_fips_all: 42105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16748,
    lat: 41.9427,
    lng: -78.14425,
    city: "Shinglehouse",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2824,
    density: 10,
    county_fips: 42105,
    county_name: "Potter",
    county_weights: {
      42083: 23.38,
      42105: 76.62,
    },
    county_names_all: "Potter|McKean",
    county_fips_all: "42105|42083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16749,
    lat: 41.75578,
    lng: -78.4214,
    city: "Smethport",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4039,
    density: 8.4,
    county_fips: 42083,
    county_name: "McKean",
    county_weights: {
      42083: 100,
    },
    county_names_all: "McKean",
    county_fips_all: 42083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16750,
    lat: 41.88796,
    lng: -78.29682,
    city: "Turtlepoint",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 371,
    density: 6.9,
    county_fips: 42083,
    county_name: "McKean",
    county_weights: {
      42083: 100,
    },
    county_names_all: "McKean",
    county_fips_all: 42083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16801,
    lat: 40.78538,
    lng: -77.84214,
    city: "State College",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45527,
    density: 565.7,
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 100,
    },
    county_names_all: "Centre",
    county_fips_all: 42027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16802,
    lat: 40.79867,
    lng: -77.86481,
    city: "University Park",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11473,
    density: 5776.9,
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 100,
    },
    county_names_all: "Centre",
    county_fips_all: 42027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16803,
    lat: 40.80849,
    lng: -77.89449,
    city: "State College",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24582,
    density: 412.9,
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 100,
    },
    county_names_all: "Centre",
    county_fips_all: 42027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16820,
    lat: 40.91995,
    lng: -77.38702,
    city: "Aaronsburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1698,
    density: 40.8,
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 100,
    },
    county_names_all: "Centre",
    county_fips_all: 42027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16821,
    lat: 40.95888,
    lng: -78.19875,
    city: "Allport",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 301,
    density: 84.3,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16822,
    lat: 41.15813,
    lng: -77.71441,
    city: "Beech Creek",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1850,
    density: 7.1,
    county_fips: 42035,
    county_name: "Clinton",
    county_weights: {
      42027: 4.22,
      42035: 95.78,
    },
    county_names_all: "Clinton|Centre",
    county_fips_all: "42035|42027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16823,
    lat: 40.92734,
    lng: -77.76685,
    city: "Bellefonte",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30978,
    density: 96.2,
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 100,
    },
    county_names_all: "Centre",
    county_fips_all: 42027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16825,
    lat: 40.98803,
    lng: -78.31208,
    city: "Bigler",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 246,
    density: 122.1,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16826,
    lat: 41.06199,
    lng: -77.58598,
    city: "Blanchard",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 376,
    density: 82.8,
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 100,
    },
    county_names_all: "Centre",
    county_fips_all: 42027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16827,
    lat: 40.76607,
    lng: -77.77739,
    city: "Boalsburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4686,
    density: 99.7,
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 100,
    },
    county_names_all: "Centre",
    county_fips_all: 42027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16828,
    lat: 40.80704,
    lng: -77.69097,
    city: "Centre Hall",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4603,
    density: 31.9,
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 100,
    },
    county_names_all: "Centre",
    county_fips_all: 42027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16829,
    lat: 41.08223,
    lng: -77.89386,
    city: "Clarence",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 765,
    density: 6.3,
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 100,
    },
    county_names_all: "Centre",
    county_fips_all: 42027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16830,
    lat: 41.08569,
    lng: -78.43317,
    city: "Clearfield",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13551,
    density: 39.6,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16832,
    lat: 40.84711,
    lng: -77.4347,
    city: "Coburn",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 503,
    density: 9.1,
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 100,
    },
    county_names_all: "Centre",
    county_fips_all: 42027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16833,
    lat: 40.94158,
    lng: -78.57862,
    city: "Curwensville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5265,
    density: 29.2,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16834,
    lat: 41.0391,
    lng: -78.10389,
    city: "Drifting",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 616,
    density: 13,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16835,
    lat: 40.90668,
    lng: -77.87731,
    city: "Fleming",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 295,
    density: 566,
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 100,
    },
    county_names_all: "Centre",
    county_fips_all: 42027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16836,
    lat: 41.14633,
    lng: -78.26454,
    city: "Frenchville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1034,
    density: 3.2,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16837,
    lat: 40.94576,
    lng: -78.47494,
    city: "Glen Richey",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 203,
    density: 92.6,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16838,
    lat: 40.98923,
    lng: -78.64292,
    city: "Grampian",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1825,
    density: 18.8,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16839,
    lat: 41.00319,
    lng: -78.11113,
    city: "Grassflat",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 601,
    density: 208.8,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16840,
    lat: 40.92555,
    lng: -78.20214,
    city: "Hawk Run",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 494,
    density: 552.7,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16841,
    lat: 41.03399,
    lng: -77.69011,
    city: "Howard",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6366,
    density: 20.2,
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 98.77,
      42035: 1.23,
    },
    county_names_all: "Centre|Clinton",
    county_fips_all: "42027|42035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16843,
    lat: 41.00849,
    lng: -78.46269,
    city: "Hyde",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 408,
    density: 217.2,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16844,
    lat: 40.91285,
    lng: -77.93261,
    city: "Julian",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2623,
    density: 16.3,
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 100,
    },
    county_names_all: "Centre",
    county_fips_all: 42027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16845,
    lat: 41.15641,
    lng: -78.02422,
    city: "Karthaus",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 984,
    density: 3.8,
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 64.07,
      42033: 35.93,
    },
    county_names_all: "Centre|Clearfield",
    county_fips_all: "42027|42033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16847,
    lat: 40.99941,
    lng: -78.16439,
    city: "Kylertown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 317,
    density: 99.7,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16848,
    lat: 41.01247,
    lng: -77.53455,
    city: "Lamar",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 352,
    density: 549.4,
    county_fips: 42035,
    county_name: "Clinton",
    county_weights: {
      42035: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 42035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16849,
    lat: 40.95978,
    lng: -78.11431,
    city: "Lanse",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 166,
    density: 16.3,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16851,
    lat: 40.81229,
    lng: -77.80132,
    city: "Lemont",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 657,
    density: 136.1,
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 100,
    },
    county_names_all: "Centre",
    county_fips_all: 42027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16852,
    lat: 40.93639,
    lng: -77.5386,
    city: "Madisonburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 193,
    density: 19.3,
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 100,
    },
    county_names_all: "Centre",
    county_fips_all: 42027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16853,
    lat: 40.94045,
    lng: -77.78638,
    city: "Milesburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 210,
    density: 392.6,
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 100,
    },
    county_names_all: "Centre",
    county_fips_all: 42027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16854,
    lat: 40.89697,
    lng: -77.47228,
    city: "Millheim",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 597,
    density: 90.1,
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 100,
    },
    county_names_all: "Centre",
    county_fips_all: 42027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16855,
    lat: 40.99902,
    lng: -78.36046,
    city: "Mineral Springs",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 103,
    density: 21.3,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16856,
    lat: 40.92871,
    lng: -77.65005,
    city: "Mingoville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 100,
    },
    county_names_all: "Centre",
    county_fips_all: 42027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16858,
    lat: 41.00056,
    lng: -78.20033,
    city: "Morrisdale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3538,
    density: 25.2,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16859,
    lat: 41.04903,
    lng: -78.03519,
    city: "Moshannon",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 465,
    density: 6,
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 100,
    },
    county_names_all: "Centre",
    county_fips_all: 42027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16860,
    lat: 40.94673,
    lng: -78.17219,
    city: "Munson",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 308,
    density: 23.4,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42027: 23.18,
      42033: 76.82,
    },
    county_names_all: "Clearfield|Centre",
    county_fips_all: "42033|42027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16861,
    lat: 40.86764,
    lng: -78.51991,
    city: "New Millport",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 335,
    density: 9.2,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16863,
    lat: 40.91162,
    lng: -78.47204,
    city: "Olanta",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 443,
    density: 6.9,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16864,
    lat: 41.15428,
    lng: -77.79857,
    city: "Orviston",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 100,
    },
    county_names_all: "Centre",
    county_fips_all: 42027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16865,
    lat: 40.72086,
    lng: -77.96396,
    city: "Pennsylvania Furnace",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1763,
    density: 29.6,
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 84.27,
      42061: 15.73,
    },
    county_names_all: "Centre|Huntingdon",
    county_fips_all: "42027|42061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16866,
    lat: 40.86684,
    lng: -78.17163,
    city: "Philipsburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10362,
    density: 25.5,
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 90.46,
      42033: 9.54,
    },
    county_names_all: "Centre|Clearfield",
    county_fips_all: "42027|42033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16868,
    lat: 40.72725,
    lng: -77.89066,
    city: "Pine Grove Mills",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 725,
    density: 184.5,
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 100,
    },
    county_names_all: "Centre",
    county_fips_all: 42027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16870,
    lat: 40.80149,
    lng: -78.04969,
    city: "Port Matilda",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7576,
    density: 40.5,
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 100,
    },
    county_names_all: "Centre",
    county_fips_all: 42027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16871,
    lat: 41.1879,
    lng: -78.03705,
    city: "Pottersdale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64,
    density: 0.7,
    county_fips: 42035,
    county_name: "Clinton",
    county_weights: {
      42033: 25.51,
      42035: 74.49,
    },
    county_names_all: "Clinton|Clearfield",
    county_fips_all: "42035|42033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16872,
    lat: 40.96715,
    lng: -77.35939,
    city: "Rebersburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1556,
    density: 10.3,
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 100,
    },
    county_names_all: "Centre",
    county_fips_all: 42027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16874,
    lat: 41.01141,
    lng: -77.94077,
    city: "Snow Shoe",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1411,
    density: 16.1,
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 100,
    },
    county_names_all: "Centre",
    county_fips_all: 42027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16875,
    lat: 40.84536,
    lng: -77.56882,
    city: "Spring Mills",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4042,
    density: 19,
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 100,
    },
    county_names_all: "Centre",
    county_fips_all: 42027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16876,
    lat: 40.96648,
    lng: -78.29087,
    city: "Wallaceton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 268,
    density: 94.8,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16877,
    lat: 40.73291,
    lng: -78.06846,
    city: "Warriors Mark",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2244,
    density: 30.7,
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 58.66,
      42061: 41.34,
    },
    county_names_all: "Centre|Huntingdon",
    county_fips_all: "42027|42061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16878,
    lat: 40.94325,
    lng: -78.33609,
    city: "West Decatur",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1658,
    density: 22.3,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16879,
    lat: 40.97116,
    lng: -78.15162,
    city: "Winburne",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 460,
    density: 103.8,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16881,
    lat: 41.02743,
    lng: -78.31119,
    city: "Woodland",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2446,
    density: 33.2,
    county_fips: 42033,
    county_name: "Clearfield",
    county_weights: {
      42033: 100,
    },
    county_names_all: "Clearfield",
    county_fips_all: 42033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16882,
    lat: 40.90707,
    lng: -77.33841,
    city: "Woodward",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 407,
    density: 5.1,
    county_fips: 42027,
    county_name: "Centre",
    county_weights: {
      42027: 100,
    },
    county_names_all: "Centre",
    county_fips_all: 42027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16901,
    lat: 41.73038,
    lng: -77.31841,
    city: "Wellsboro",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10136,
    density: 17,
    county_fips: 42117,
    county_name: "Tioga",
    county_weights: {
      42117: 100,
    },
    county_names_all: "Tioga",
    county_fips_all: 42117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16910,
    lat: 41.70477,
    lng: -76.83124,
    city: "Alba",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42015,
    county_name: "Bradford",
    county_weights: {
      42015: 100,
    },
    county_names_all: "Bradford",
    county_fips_all: 42015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16911,
    lat: 41.67787,
    lng: -77.10392,
    city: "Arnot",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 512,
    density: 49.2,
    county_fips: 42117,
    county_name: "Tioga",
    county_weights: {
      42117: 100,
    },
    county_names_all: "Tioga",
    county_fips_all: 42117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16912,
    lat: 41.66803,
    lng: -77.05845,
    city: "Blossburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2544,
    density: 44.2,
    county_fips: 42117,
    county_name: "Tioga",
    county_weights: {
      42117: 100,
    },
    county_names_all: "Tioga",
    county_fips_all: 42117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16914,
    lat: 41.8618,
    lng: -76.77687,
    city: "Columbia Cross Roads",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2461,
    density: 12.3,
    county_fips: 42015,
    county_name: "Bradford",
    county_weights: {
      42015: 93.19,
      42117: 6.81,
    },
    county_names_all: "Bradford|Tioga",
    county_fips_all: "42015|42117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16915,
    lat: 41.77481,
    lng: -77.96104,
    city: "Coudersport",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6099,
    density: 9.6,
    county_fips: 42105,
    county_name: "Potter",
    county_weights: {
      42105: 100,
    },
    county_names_all: "Potter",
    county_fips_all: 42105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16917,
    lat: 41.723,
    lng: -77.05519,
    city: "Covington",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1072,
    density: 8,
    county_fips: 42117,
    county_name: "Tioga",
    county_weights: {
      42117: 100,
    },
    county_names_all: "Tioga",
    county_fips_all: 42117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16920,
    lat: 41.98218,
    lng: -77.28851,
    city: "Elkland",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1899,
    density: 77.1,
    county_fips: 42117,
    county_name: "Tioga",
    county_weights: {
      42117: 100,
    },
    county_names_all: "Tioga",
    county_fips_all: 42117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16921,
    lat: 41.69614,
    lng: -77.54654,
    city: "Gaines",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 511,
    density: 2.3,
    county_fips: 42117,
    county_name: "Tioga",
    county_weights: {
      42105: 1.33,
      42117: 98.67,
    },
    county_names_all: "Tioga|Potter",
    county_fips_all: "42117|42105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16922,
    lat: 41.67191,
    lng: -77.70064,
    city: "Galeton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1800,
    density: 4.7,
    county_fips: 42105,
    county_name: "Potter",
    county_weights: {
      42105: 100,
    },
    county_names_all: "Potter",
    county_fips_all: 42105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16923,
    lat: 41.94103,
    lng: -77.8761,
    city: "Genesee",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1481,
    density: 7.4,
    county_fips: 42105,
    county_name: "Potter",
    county_weights: {
      42105: 100,
    },
    county_names_all: "Potter",
    county_fips_all: 42105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16925,
    lat: 41.95319,
    lng: -76.78997,
    city: "Gillett",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3407,
    density: 17.1,
    county_fips: 42015,
    county_name: "Bradford",
    county_weights: {
      42015: 100,
    },
    county_names_all: "Bradford",
    county_fips_all: 42015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16926,
    lat: 41.71506,
    lng: -76.70485,
    city: "Granville Summit",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 919,
    density: 13.6,
    county_fips: 42015,
    county_name: "Bradford",
    county_weights: {
      42015: 100,
    },
    county_names_all: "Bradford",
    county_fips_all: 42015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16927,
    lat: 41.9655,
    lng: -77.65941,
    city: "Harrison Valley",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 545,
    density: 13.5,
    county_fips: 42105,
    county_name: "Potter",
    county_weights: {
      42105: 100,
    },
    county_names_all: "Potter",
    county_fips_all: 42105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16928,
    lat: 41.95203,
    lng: -77.43371,
    city: "Knoxville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1447,
    density: 15.2,
    county_fips: 42117,
    county_name: "Tioga",
    county_weights: {
      42117: 100,
    },
    county_names_all: "Tioga",
    county_fips_all: 42117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16929,
    lat: 41.97352,
    lng: -77.15028,
    city: "Lawrenceville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2503,
    density: 22.7,
    county_fips: 42117,
    county_name: "Tioga",
    county_weights: {
      42117: 100,
    },
    county_names_all: "Tioga",
    county_fips_all: 42117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16930,
    lat: 41.57693,
    lng: -77.14021,
    city: "Liberty",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1190,
    density: 7.3,
    county_fips: 42117,
    county_name: "Tioga",
    county_weights: {
      42081: 25.53,
      42117: 74.47,
    },
    county_names_all: "Tioga|Lycoming",
    county_fips_all: "42117|42081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16932,
    lat: 41.77574,
    lng: -76.94017,
    city: "Mainesburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 810,
    density: 15.8,
    county_fips: 42117,
    county_name: "Tioga",
    county_weights: {
      42117: 100,
    },
    county_names_all: "Tioga",
    county_fips_all: 42117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16933,
    lat: 41.81904,
    lng: -77.06716,
    city: "Mansfield",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6374,
    density: 24,
    county_fips: 42117,
    county_name: "Tioga",
    county_weights: {
      42117: 100,
    },
    county_names_all: "Tioga",
    county_fips_all: 42117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16935,
    lat: 41.87032,
    lng: -77.32404,
    city: "Middlebury Center",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1126,
    density: 8.8,
    county_fips: 42117,
    county_name: "Tioga",
    county_weights: {
      42117: 100,
    },
    county_names_all: "Tioga",
    county_fips_all: 42117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16936,
    lat: 41.94318,
    lng: -76.95837,
    city: "Millerton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2070,
    density: 16.8,
    county_fips: 42117,
    county_name: "Tioga",
    county_weights: {
      42015: 17.09,
      42117: 82.91,
    },
    county_names_all: "Tioga|Bradford",
    county_fips_all: "42117|42015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16937,
    lat: 41.96421,
    lng: -77.71004,
    city: "Mills",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 146,
    density: 8.1,
    county_fips: 42105,
    county_name: "Potter",
    county_weights: {
      42105: 100,
    },
    county_names_all: "Potter",
    county_fips_all: 42105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16938,
    lat: 41.56935,
    lng: -77.34487,
    city: "Morris",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 749,
    density: 2.7,
    county_fips: 42117,
    county_name: "Tioga",
    county_weights: {
      42081: 27.26,
      42117: 72.74,
    },
    county_names_all: "Tioga|Lycoming",
    county_fips_all: "42117|42081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16939,
    lat: 41.68097,
    lng: -77.0141,
    city: "Morris Run",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 310,
    density: 289.4,
    county_fips: 42117,
    county_name: "Tioga",
    county_weights: {
      42117: 100,
    },
    county_names_all: "Tioga",
    county_fips_all: 42117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16940,
    lat: 41.97752,
    lng: -77.23373,
    city: "Nelson",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 213,
    density: 163.1,
    county_fips: 42117,
    county_name: "Tioga",
    county_weights: {
      42117: 100,
    },
    county_names_all: "Tioga",
    county_fips_all: 42117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16941,
    lat: 41.98841,
    lng: -77.75796,
    city: "Genesee",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 88,
    density: 14,
    county_fips: 42105,
    county_name: "Potter",
    county_weights: {
      42105: 100,
    },
    county_names_all: "Potter",
    county_fips_all: 42105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16942,
    lat: 41.9654,
    lng: -77.35414,
    city: "Osceola",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 842,
    density: 15.2,
    county_fips: 42117,
    county_name: "Tioga",
    county_weights: {
      42117: 100,
    },
    county_names_all: "Tioga",
    county_fips_all: 42117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16943,
    lat: 41.8406,
    lng: -77.61915,
    city: "Sabinsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 399,
    density: 4.3,
    county_fips: 42105,
    county_name: "Potter",
    county_weights: {
      42105: 58.61,
      42117: 41.39,
    },
    county_names_all: "Potter|Tioga",
    county_fips_all: "42105|42117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16946,
    lat: 41.91422,
    lng: -77.13999,
    city: "Tioga",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2354,
    density: 13.8,
    county_fips: 42117,
    county_name: "Tioga",
    county_weights: {
      42117: 100,
    },
    county_names_all: "Tioga",
    county_fips_all: 42117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16947,
    lat: 41.76969,
    lng: -76.79519,
    city: "Troy",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4531,
    density: 15.6,
    county_fips: 42015,
    county_name: "Bradford",
    county_weights: {
      42015: 87.18,
      42117: 12.82,
    },
    county_names_all: "Bradford|Tioga",
    county_fips_all: "42015|42117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16948,
    lat: 41.85369,
    lng: -77.75683,
    city: "Ulysses",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1612,
    density: 6.3,
    county_fips: 42105,
    county_name: "Potter",
    county_weights: {
      42105: 100,
    },
    county_names_all: "Potter",
    county_fips_all: 42105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 16950,
    lat: 41.89816,
    lng: -77.53429,
    city: "Westfield",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3283,
    density: 10.9,
    county_fips: 42117,
    county_name: "Tioga",
    county_weights: {
      42105: 16.71,
      42117: 83.29,
    },
    county_names_all: "Tioga|Potter",
    county_fips_all: "42117|42105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17002,
    lat: 40.46463,
    lng: -77.86761,
    city: "Allensville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 699,
    density: 18.3,
    county_fips: 42061,
    county_name: "Huntingdon",
    county_weights: {
      42061: 82.31,
      42087: 17.69,
    },
    county_names_all: "Huntingdon|Mifflin",
    county_fips_all: "42061|42087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17003,
    lat: 40.35735,
    lng: -76.55528,
    city: "Annville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12565,
    density: 113.7,
    county_fips: 42075,
    county_name: "Lebanon",
    county_weights: {
      42075: 100,
    },
    county_names_all: "Lebanon",
    county_fips_all: 42075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17004,
    lat: 40.59966,
    lng: -77.73278,
    city: "Belleville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5016,
    density: 38,
    county_fips: 42087,
    county_name: "Mifflin",
    county_weights: {
      42087: 100,
    },
    county_names_all: "Mifflin",
    county_fips_all: 42087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17005,
    lat: 40.60304,
    lng: -76.81065,
    city: "Berrysburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 295,
    density: 202.3,
    county_fips: 42043,
    county_name: "Dauphin",
    county_weights: {
      42043: 100,
    },
    county_names_all: "Dauphin",
    county_fips_all: 42043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17006,
    lat: 40.28495,
    lng: -77.54364,
    city: "Blain",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1028,
    density: 5.3,
    county_fips: 42099,
    county_name: "Perry",
    county_weights: {
      42099: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 42099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17007,
    lat: 40.13428,
    lng: -77.11801,
    city: "Boiling Springs",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5888,
    density: 127,
    county_fips: 42041,
    county_name: "Cumberland",
    county_weights: {
      42041: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 42041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17009,
    lat: 40.6359,
    lng: -77.56609,
    city: "Burnham",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1892,
    density: 486.4,
    county_fips: 42087,
    county_name: "Mifflin",
    county_weights: {
      42087: 100,
    },
    county_names_all: "Mifflin",
    county_fips_all: 42087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17010,
    lat: 40.27809,
    lng: -76.58335,
    city: "Campbelltown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 363,
    density: 6704.1,
    county_fips: 42075,
    county_name: "Lebanon",
    county_weights: {
      42075: 100,
    },
    county_names_all: "Lebanon",
    county_fips_all: 42075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17011,
    lat: 40.23508,
    lng: -76.92931,
    city: "Camp Hill",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37718,
    density: 1113.3,
    county_fips: 42041,
    county_name: "Cumberland",
    county_weights: {
      42041: 93.95,
      42133: 6.05,
    },
    county_names_all: "Cumberland|York",
    county_fips_all: "42041|42133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17013,
    lat: 40.241,
    lng: -77.19286,
    city: "Carlisle",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36627,
    density: 360.9,
    county_fips: 42041,
    county_name: "Cumberland",
    county_weights: {
      42041: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 42041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17014,
    lat: 40.6596,
    lng: -77.19358,
    city: "Cocolamus",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42067,
    county_name: "Juniata",
    county_weights: {
      42067: 100,
    },
    county_names_all: "Juniata",
    county_fips_all: 42067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17015,
    lat: 40.18392,
    lng: -77.23234,
    city: "Carlisle",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21898,
    density: 76.3,
    county_fips: 42041,
    county_name: "Cumberland",
    county_weights: {
      42041: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 42041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17016,
    lat: 40.27322,
    lng: -76.40705,
    city: "Cornwall",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1352,
    density: 2202.5,
    county_fips: 42075,
    county_name: "Lebanon",
    county_weights: {
      42075: 100,
    },
    county_names_all: "Lebanon",
    county_fips_all: 42075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17017,
    lat: 40.6275,
    lng: -76.89854,
    city: "Dalmatia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1500,
    density: 22.9,
    county_fips: 42097,
    county_name: "Northumberland",
    county_weights: {
      42043: 31.36,
      42097: 68.64,
    },
    county_names_all: "Northumberland|Dauphin",
    county_fips_all: "42097|42043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17018,
    lat: 40.40246,
    lng: -76.88117,
    city: "Dauphin",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4299,
    density: 41.7,
    county_fips: 42043,
    county_name: "Dauphin",
    county_weights: {
      42043: 100,
    },
    county_names_all: "Dauphin",
    county_fips_all: 42043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17019,
    lat: 40.09078,
    lng: -77.02462,
    city: "Dillsburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19159,
    density: 115.9,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42001: 1.43,
      42041: 6.24,
      42133: 92.33,
    },
    county_names_all: "York|Cumberland|Adams",
    county_fips_all: "42133|42041|42001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17020,
    lat: 40.41014,
    lng: -77.04367,
    city: "Duncannon",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9122,
    density: 61,
    county_fips: 42099,
    county_name: "Perry",
    county_weights: {
      42043: 6.32,
      42099: 93.68,
    },
    county_names_all: "Perry|Dauphin",
    county_fips_all: "42099|42043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17021,
    lat: 40.33758,
    lng: -77.66093,
    city: "East Waterford",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 866,
    density: 6.1,
    county_fips: 42067,
    county_name: "Juniata",
    county_weights: {
      42055: 5.42,
      42061: 1.54,
      42067: 77.21,
      42099: 15.83,
    },
    county_names_all: "Juniata|Perry|Franklin|Huntingdon",
    county_fips_all: "42067|42099|42055|42061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17022,
    lat: 40.16677,
    lng: -76.60823,
    city: "Elizabethtown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31045,
    density: 218.1,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42043: 29.14,
      42071: 70.86,
    },
    county_names_all: "Lancaster|Dauphin",
    county_fips_all: "42071|42043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17023,
    lat: 40.5813,
    lng: -76.81169,
    city: "Elizabethville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3405,
    density: 64.1,
    county_fips: 42043,
    county_name: "Dauphin",
    county_weights: {
      42043: 100,
    },
    county_names_all: "Dauphin",
    county_fips_all: 42043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17024,
    lat: 40.40992,
    lng: -77.30854,
    city: "Elliottsburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1951,
    density: 23.5,
    county_fips: 42099,
    county_name: "Perry",
    county_weights: {
      42099: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 42099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17025,
    lat: 40.29506,
    lng: -76.97731,
    city: "Enola",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16511,
    density: 425.5,
    county_fips: 42041,
    county_name: "Cumberland",
    county_weights: {
      42041: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 42041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17026,
    lat: 40.46734,
    lng: -76.43626,
    city: "Fredericksburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3981,
    density: 63,
    county_fips: 42075,
    county_name: "Lebanon",
    county_weights: {
      42011: 8.86,
      42075: 91.14,
    },
    county_names_all: "Lebanon|Berks",
    county_fips_all: "42075|42011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17027,
    lat: 40.15653,
    lng: -76.99316,
    city: "Grantham",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1908,
    density: 1324.6,
    county_fips: 42041,
    county_name: "Cumberland",
    county_weights: {
      42041: 99.56,
      42133: 0.44,
    },
    county_names_all: "Cumberland|York",
    county_fips_all: "42041|42133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17028,
    lat: 40.4033,
    lng: -76.65073,
    city: "Grantville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3982,
    density: 56.1,
    county_fips: 42075,
    county_name: "Lebanon",
    county_weights: {
      42043: 45.82,
      42075: 54.18,
    },
    county_names_all: "Lebanon|Dauphin",
    county_fips_all: "42075|42043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17029,
    lat: 40.55416,
    lng: -77.62196,
    city: "Granville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 105,
    density: 29.4,
    county_fips: 42087,
    county_name: "Mifflin",
    county_weights: {
      42087: 100,
    },
    county_names_all: "Mifflin",
    county_fips_all: 42087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17030,
    lat: 40.60833,
    lng: -76.74417,
    city: "Gratz",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 859,
    density: 105.2,
    county_fips: 42043,
    county_name: "Dauphin",
    county_weights: {
      42043: 100,
    },
    county_names_all: "Dauphin",
    county_fips_all: 42043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17032,
    lat: 40.49448,
    lng: -76.81788,
    city: "Halifax",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7930,
    density: 27.7,
    county_fips: 42043,
    county_name: "Dauphin",
    county_weights: {
      42043: 100,
    },
    county_names_all: "Dauphin",
    county_fips_all: 42043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17033,
    lat: 40.26829,
    lng: -76.62754,
    city: "Hershey",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17969,
    density: 253.3,
    county_fips: 42043,
    county_name: "Dauphin",
    county_weights: {
      42043: 87.72,
      42075: 12.28,
    },
    county_names_all: "Dauphin|Lebanon",
    county_fips_all: "42043|42075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17034,
    lat: 40.20831,
    lng: -76.78489,
    city: "Highspire",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2512,
    density: 1196.1,
    county_fips: 42043,
    county_name: "Dauphin",
    county_weights: {
      42043: 100,
    },
    county_names_all: "Dauphin",
    county_fips_all: 42043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17035,
    lat: 40.41638,
    lng: -77.57443,
    city: "Honey Grove",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 940,
    density: 10.4,
    county_fips: 42067,
    county_name: "Juniata",
    county_weights: {
      42067: 93.91,
      42099: 6.09,
    },
    county_names_all: "Juniata|Perry",
    county_fips_all: "42067|42099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17036,
    lat: 40.28579,
    lng: -76.69611,
    city: "Hummelstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22165,
    density: 305.1,
    county_fips: 42043,
    county_name: "Dauphin",
    county_weights: {
      42043: 100,
    },
    county_names_all: "Dauphin",
    county_fips_all: 42043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17037,
    lat: 40.43329,
    lng: -77.42872,
    city: "Ickesburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 862,
    density: 14.9,
    county_fips: 42099,
    county_name: "Perry",
    county_weights: {
      42099: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 42099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17038,
    lat: 40.46787,
    lng: -76.54895,
    city: "Jonestown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8553,
    density: 49.9,
    county_fips: 42075,
    county_name: "Lebanon",
    county_weights: {
      42075: 100,
    },
    county_names_all: "Lebanon",
    county_fips_all: 42075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17039,
    lat: 40.2928,
    lng: -76.24077,
    city: "Kleinfeltersville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 71,
    density: 75.7,
    county_fips: 42075,
    county_name: "Lebanon",
    county_weights: {
      42075: 100,
    },
    county_names_all: "Lebanon",
    county_fips_all: 42075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17040,
    lat: 40.31558,
    lng: -77.32571,
    city: "Landisburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2328,
    density: 16.9,
    county_fips: 42099,
    county_name: "Perry",
    county_weights: {
      42099: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 42099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17041,
    lat: 40.21667,
    lng: -76.5395,
    city: "Lawn",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 290,
    density: 198.9,
    county_fips: 42075,
    county_name: "Lebanon",
    county_weights: {
      42075: 100,
    },
    county_names_all: "Lebanon",
    county_fips_all: 42075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17042,
    lat: 40.29488,
    lng: -76.42271,
    city: "Lebanon",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36949,
    density: 210.7,
    county_fips: 42075,
    county_name: "Lebanon",
    county_weights: {
      42075: 100,
    },
    county_names_all: "Lebanon",
    county_fips_all: 42075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17043,
    lat: 40.24679,
    lng: -76.90033,
    city: "Lemoyne",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5503,
    density: 1029.6,
    county_fips: 42041,
    county_name: "Cumberland",
    county_weights: {
      42041: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 42041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17044,
    lat: 40.58236,
    lng: -77.59013,
    city: "Lewistown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21013,
    density: 85.1,
    county_fips: 42087,
    county_name: "Mifflin",
    county_weights: {
      42087: 100,
    },
    county_names_all: "Mifflin",
    county_fips_all: 42087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17045,
    lat: 40.58841,
    lng: -77.00389,
    city: "Liverpool",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3687,
    density: 37.4,
    county_fips: 42099,
    county_name: "Perry",
    county_weights: {
      42067: 25.52,
      42099: 67.11,
      42109: 7.37,
    },
    county_names_all: "Perry|Juniata|Snyder",
    county_fips_all: "42099|42067|42109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17046,
    lat: 40.38242,
    lng: -76.4306,
    city: "Lebanon",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31587,
    density: 313.6,
    county_fips: 42075,
    county_name: "Lebanon",
    county_weights: {
      42075: 100,
    },
    county_names_all: "Lebanon",
    county_fips_all: 42075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17047,
    lat: 40.37098,
    lng: -77.41426,
    city: "Loysville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2815,
    density: 24.4,
    county_fips: 42099,
    county_name: "Perry",
    county_weights: {
      42099: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 42099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17048,
    lat: 40.60554,
    lng: -76.72669,
    city: "Lykens",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4530,
    density: 51.8,
    county_fips: 42043,
    county_name: "Dauphin",
    county_weights: {
      42043: 100,
    },
    county_names_all: "Dauphin",
    county_fips_all: 42043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17049,
    lat: 40.65172,
    lng: -77.25948,
    city: "McAlisterville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3358,
    density: 32.7,
    county_fips: 42067,
    county_name: "Juniata",
    county_weights: {
      42067: 100,
    },
    county_names_all: "Juniata",
    county_fips_all: 42067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17050,
    lat: 40.24907,
    lng: -77.03005,
    city: "Mechanicsburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38993,
    density: 430.3,
    county_fips: 42041,
    county_name: "Cumberland",
    county_weights: {
      42041: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 42041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17051,
    lat: 40.45881,
    lng: -77.77306,
    city: "McVeytown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4729,
    density: 20,
    county_fips: 42087,
    county_name: "Mifflin",
    county_weights: {
      42087: 100,
    },
    county_names_all: "Mifflin",
    county_fips_all: 42087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17052,
    lat: 40.31577,
    lng: -77.98195,
    city: "Mapleton Depot",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1573,
    density: 14.8,
    county_fips: 42061,
    county_name: "Huntingdon",
    county_weights: {
      42061: 100,
    },
    county_names_all: "Huntingdon",
    county_fips_all: 42061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17053,
    lat: 40.3255,
    lng: -77.03256,
    city: "Marysville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5135,
    density: 68.2,
    county_fips: 42099,
    county_name: "Perry",
    county_weights: {
      42041: 0.71,
      42099: 99.29,
    },
    county_names_all: "Perry|Cumberland",
    county_fips_all: "42099|42041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17054,
    lat: 40.49746,
    lng: -77.72764,
    city: "Mattawana",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42087,
    county_name: "Mifflin",
    county_weights: {
      42087: 100,
    },
    county_names_all: "Mifflin",
    county_fips_all: 42087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17055,
    lat: 40.17756,
    lng: -76.99789,
    city: "Mechanicsburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37130,
    density: 365.5,
    county_fips: 42041,
    county_name: "Cumberland",
    county_weights: {
      42041: 87.63,
      42133: 12.37,
    },
    county_names_all: "Cumberland|York",
    county_fips_all: "42041|42133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17056,
    lat: 40.53349,
    lng: -77.35585,
    city: "Mexico",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 120,
    density: 771.2,
    county_fips: 42067,
    county_name: "Juniata",
    county_weights: {
      42067: 100,
    },
    county_names_all: "Juniata",
    county_fips_all: 42067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17057,
    lat: 40.19437,
    lng: -76.72659,
    city: "Middletown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23157,
    density: 287.3,
    county_fips: 42043,
    county_name: "Dauphin",
    county_weights: {
      42043: 100,
    },
    county_names_all: "Dauphin",
    county_fips_all: 42043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17058,
    lat: 40.50111,
    lng: -77.54792,
    city: "Mifflin",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1622,
    density: 14.9,
    county_fips: 42067,
    county_name: "Juniata",
    county_weights: {
      42067: 100,
    },
    county_names_all: "Juniata",
    county_fips_all: 42067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17059,
    lat: 40.59241,
    lng: -77.38165,
    city: "Mifflintown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7889,
    density: 38.4,
    county_fips: 42067,
    county_name: "Juniata",
    county_weights: {
      42067: 100,
    },
    county_names_all: "Juniata",
    county_fips_all: 42067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17060,
    lat: 40.49144,
    lng: -77.88158,
    city: "Mill Creek",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 947,
    density: 18.2,
    county_fips: 42061,
    county_name: "Huntingdon",
    county_weights: {
      42061: 92.87,
      42087: 7.13,
    },
    county_names_all: "Huntingdon|Mifflin",
    county_fips_all: "42061|42087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17061,
    lat: 40.56542,
    lng: -76.90046,
    city: "Millersburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7190,
    density: 85.4,
    county_fips: 42043,
    county_name: "Dauphin",
    county_weights: {
      42043: 100,
    },
    county_names_all: "Dauphin",
    county_fips_all: 42043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17062,
    lat: 40.55153,
    lng: -77.16813,
    city: "Millerstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4289,
    density: 20.1,
    county_fips: 42099,
    county_name: "Perry",
    county_weights: {
      42067: 23.94,
      42099: 76.06,
    },
    county_names_all: "Perry|Juniata",
    county_fips_all: "42099|42067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17063,
    lat: 40.76274,
    lng: -77.47343,
    city: "Milroy",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3221,
    density: 13.5,
    county_fips: 42087,
    county_name: "Mifflin",
    county_weights: {
      42087: 94.1,
      42109: 5.9,
    },
    county_names_all: "Mifflin|Snyder",
    county_fips_all: "42087|42109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17064,
    lat: 40.24135,
    lng: -76.47553,
    city: "Mount Gretna",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 528,
    density: 106.6,
    county_fips: 42075,
    county_name: "Lebanon",
    county_weights: {
      42075: 100,
    },
    county_names_all: "Lebanon",
    county_fips_all: 42075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17065,
    lat: 40.09837,
    lng: -77.20527,
    city: "Mount Holly Springs",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3559,
    density: 91.5,
    county_fips: 42041,
    county_name: "Cumberland",
    county_weights: {
      42041: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 42041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17066,
    lat: 40.35885,
    lng: -77.85892,
    city: "Mount Union",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5284,
    density: 69.4,
    county_fips: 42061,
    county_name: "Huntingdon",
    county_weights: {
      42061: 81.49,
      42087: 18.51,
    },
    county_names_all: "Huntingdon|Mifflin",
    county_fips_all: "42061|42087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17067,
    lat: 40.38848,
    lng: -76.31583,
    city: "Myerstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15111,
    density: 123.8,
    county_fips: 42075,
    county_name: "Lebanon",
    county_weights: {
      42011: 26.6,
      42075: 73.4,
    },
    county_names_all: "Lebanon|Berks",
    county_fips_all: "42075|42011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17068,
    lat: 40.40685,
    lng: -77.17795,
    city: "New Bloomfield",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4391,
    density: 51.8,
    county_fips: 42099,
    county_name: "Perry",
    county_weights: {
      42099: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 42099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17069,
    lat: 40.45722,
    lng: -76.97921,
    city: "New Buffalo",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42099,
    county_name: "Perry",
    county_weights: {
      42099: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 42099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17070,
    lat: 40.20217,
    lng: -76.86377,
    city: "New Cumberland",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16609,
    density: 439.4,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42041: 13.61,
      42133: 86.39,
    },
    county_names_all: "York|Cumberland",
    county_fips_all: "42133|42041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17071,
    lat: 40.30061,
    lng: -77.58928,
    city: "New Germantown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 110,
    density: 4,
    county_fips: 42099,
    county_name: "Perry",
    county_weights: {
      42099: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 42099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17073,
    lat: 40.30047,
    lng: -76.25924,
    city: "Newmanstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6000,
    density: 81.4,
    county_fips: 42075,
    county_name: "Lebanon",
    county_weights: {
      42071: 9.54,
      42075: 90.46,
    },
    county_names_all: "Lebanon|Lancaster",
    county_fips_all: "42075|42071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17074,
    lat: 40.47983,
    lng: -77.14456,
    city: "Newport",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7220,
    density: 43.2,
    county_fips: 42099,
    county_name: "Perry",
    county_weights: {
      42099: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 42099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17075,
    lat: 40.39372,
    lng: -77.83429,
    city: "Newton Hamilton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 167,
    density: 641.1,
    county_fips: 42087,
    county_name: "Mifflin",
    county_weights: {
      42087: 100,
    },
    county_names_all: "Mifflin",
    county_fips_all: 42087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17076,
    lat: 40.62084,
    lng: -77.30758,
    city: "Oakland Mills",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 86,
    density: 136.2,
    county_fips: 42067,
    county_name: "Juniata",
    county_weights: {
      42067: 100,
    },
    county_names_all: "Juniata",
    county_fips_all: 42067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17077,
    lat: 40.40232,
    lng: -76.53651,
    city: "Ono",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42075,
    county_name: "Lebanon",
    county_weights: {
      42075: 100,
    },
    county_names_all: "Lebanon",
    county_fips_all: 42075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17078,
    lat: 40.28952,
    lng: -76.58484,
    city: "Palmyra",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22071,
    density: 283.2,
    county_fips: 42075,
    county_name: "Lebanon",
    county_weights: {
      42043: 16.59,
      42075: 83.41,
    },
    county_names_all: "Lebanon|Dauphin",
    county_fips_all: "42075|42043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17080,
    lat: 40.64057,
    lng: -76.80299,
    city: "Pillow",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 297,
    density: 232.4,
    county_fips: 42043,
    county_name: "Dauphin",
    county_weights: {
      42043: 100,
    },
    county_names_all: "Dauphin",
    county_fips_all: 42043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17081,
    lat: 40.20121,
    lng: -77.28322,
    city: "Plainfield",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 278,
    density: 166.2,
    county_fips: 42041,
    county_name: "Cumberland",
    county_weights: {
      42041: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 42041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17082,
    lat: 40.49762,
    lng: -77.42579,
    city: "Port Royal",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3233,
    density: 22,
    county_fips: 42067,
    county_name: "Juniata",
    county_weights: {
      42067: 100,
    },
    county_names_all: "Juniata",
    county_fips_all: 42067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17084,
    lat: 40.68705,
    lng: -77.62692,
    city: "Reedsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4580,
    density: 53.3,
    county_fips: 42087,
    county_name: "Mifflin",
    county_weights: {
      42087: 100,
    },
    county_names_all: "Mifflin",
    county_fips_all: 42087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17086,
    lat: 40.69067,
    lng: -77.12502,
    city: "Richfield",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2115,
    density: 22.2,
    county_fips: 42109,
    county_name: "Snyder",
    county_weights: {
      42067: 35.87,
      42109: 64.13,
    },
    county_names_all: "Snyder|Juniata",
    county_fips_all: "42109|42067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17087,
    lat: 40.40523,
    lng: -76.26356,
    city: "Richland",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2884,
    density: 87.4,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 67.79,
      42075: 32.21,
    },
    county_names_all: "Berks|Lebanon",
    county_fips_all: "42011|42075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17088,
    lat: 40.30046,
    lng: -76.295,
    city: "Schaefferstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 745,
    density: 173.9,
    county_fips: 42075,
    county_name: "Lebanon",
    county_weights: {
      42075: 100,
    },
    county_names_all: "Lebanon",
    county_fips_all: 42075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17090,
    lat: 40.32953,
    lng: -77.18302,
    city: "Shermans Dale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5636,
    density: 67.3,
    county_fips: 42099,
    county_name: "Perry",
    county_weights: {
      42099: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 42099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17093,
    lat: 40.30998,
    lng: -76.92817,
    city: "Summerdale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1611,
    density: 1242.1,
    county_fips: 42041,
    county_name: "Cumberland",
    county_weights: {
      42041: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 42041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17094,
    lat: 40.58414,
    lng: -77.2168,
    city: "Thompsontown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2569,
    density: 34.3,
    county_fips: 42067,
    county_name: "Juniata",
    county_weights: {
      42067: 100,
    },
    county_names_all: "Juniata",
    county_fips_all: 42067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17097,
    lat: 40.57414,
    lng: -76.67704,
    city: "Wiconisco",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 598,
    density: 209.7,
    county_fips: 42043,
    county_name: "Dauphin",
    county_weights: {
      42043: 100,
    },
    county_names_all: "Dauphin",
    county_fips_all: 42043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17098,
    lat: 40.58998,
    lng: -76.63071,
    city: "Williamstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2307,
    density: 95.6,
    county_fips: 42043,
    county_name: "Dauphin",
    county_weights: {
      42043: 100,
    },
    county_names_all: "Dauphin",
    county_fips_all: 42043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17099,
    lat: 40.64535,
    lng: -77.57639,
    city: "Yeagertown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1133,
    density: 304,
    county_fips: 42087,
    county_name: "Mifflin",
    county_weights: {
      42087: 100,
    },
    county_names_all: "Mifflin",
    county_fips_all: 42087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17101,
    lat: 40.2595,
    lng: -76.88705,
    city: "Harrisburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2199,
    density: 1629.6,
    county_fips: 42043,
    county_name: "Dauphin",
    county_weights: {
      42043: 100,
    },
    county_names_all: "Dauphin",
    county_fips_all: 42043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17102,
    lat: 40.27119,
    lng: -76.89686,
    city: "Harrisburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7531,
    density: 3838.8,
    county_fips: 42043,
    county_name: "Dauphin",
    county_weights: {
      42043: 100,
    },
    county_names_all: "Dauphin",
    county_fips_all: 42043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17103,
    lat: 40.27499,
    lng: -76.86326,
    city: "Harrisburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12495,
    density: 2554.6,
    county_fips: 42043,
    county_name: "Dauphin",
    county_weights: {
      42043: 100,
    },
    county_names_all: "Dauphin",
    county_fips_all: 42043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17104,
    lat: 40.23901,
    lng: -76.84985,
    city: "Harrisburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19765,
    density: 2273.6,
    county_fips: 42043,
    county_name: "Dauphin",
    county_weights: {
      42043: 100,
    },
    county_names_all: "Dauphin",
    county_fips_all: 42043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17109,
    lat: 40.28986,
    lng: -76.82414,
    city: "Harrisburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24726,
    density: 1369.6,
    county_fips: 42043,
    county_name: "Dauphin",
    county_weights: {
      42043: 100,
    },
    county_names_all: "Dauphin",
    county_fips_all: 42043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17110,
    lat: 40.31776,
    lng: -76.88354,
    city: "Harrisburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25122,
    density: 648.8,
    county_fips: 42043,
    county_name: "Dauphin",
    county_weights: {
      42043: 100,
    },
    county_names_all: "Dauphin",
    county_fips_all: 42043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17111,
    lat: 40.27041,
    lng: -76.78265,
    city: "Harrisburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33261,
    density: 699.3,
    county_fips: 42043,
    county_name: "Dauphin",
    county_weights: {
      42043: 100,
    },
    county_names_all: "Dauphin",
    county_fips_all: 42043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17112,
    lat: 40.37497,
    lng: -76.77163,
    city: "Harrisburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36080,
    density: 200.2,
    county_fips: 42043,
    county_name: "Dauphin",
    county_weights: {
      42043: 100,
    },
    county_names_all: "Dauphin",
    county_fips_all: 42043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17113,
    lat: 40.23032,
    lng: -76.82083,
    city: "Harrisburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10309,
    density: 954.7,
    county_fips: 42043,
    county_name: "Dauphin",
    county_weights: {
      42043: 100,
    },
    county_names_all: "Dauphin",
    county_fips_all: 42043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17120,
    lat: 40.26511,
    lng: -76.88281,
    city: "Harrisburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 42043,
    county_name: "Dauphin",
    county_weights: {
      42043: 100,
    },
    county_names_all: "Dauphin",
    county_fips_all: 42043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17201,
    lat: 39.96229,
    lng: -77.65677,
    city: "Chambersburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26362,
    density: 532.3,
    county_fips: 42055,
    county_name: "Franklin",
    county_weights: {
      42055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 42055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17202,
    lat: 39.92133,
    lng: -77.67442,
    city: "Chambersburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30942,
    density: 101.1,
    county_fips: 42055,
    county_name: "Franklin",
    county_weights: {
      42055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 42055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17210,
    lat: 40.18989,
    lng: -77.661,
    city: "Amberson",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 119,
    density: 2.9,
    county_fips: 42055,
    county_name: "Franklin",
    county_weights: {
      42055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 42055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17211,
    lat: 39.75191,
    lng: -78.41457,
    city: "Artemas",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 387,
    density: 5.3,
    county_fips: 42009,
    county_name: "Bedford",
    county_weights: {
      42009: 100,
    },
    county_names_all: "Bedford",
    county_fips_all: 42009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17212,
    lat: 39.81,
    lng: -78.07073,
    city: "Big Cove Tannery",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 673,
    density: 7,
    county_fips: 42057,
    county_name: "Fulton",
    county_weights: {
      42057: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 42057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17213,
    lat: 40.25381,
    lng: -77.77249,
    city: "Blairs Mills",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 597,
    density: 5.9,
    county_fips: 42061,
    county_name: "Huntingdon",
    county_weights: {
      42061: 100,
    },
    county_names_all: "Huntingdon",
    county_fips_all: 42061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17214,
    lat: 39.74811,
    lng: -77.47025,
    city: "Blue Ridge Summit",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 828,
    density: 83.9,
    county_fips: 42055,
    county_name: "Franklin",
    county_weights: {
      42055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 42055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17215,
    lat: 40.09234,
    lng: -77.89008,
    city: "Burnt Cabins",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 253,
    density: 16.4,
    county_fips: 42061,
    county_name: "Huntingdon",
    county_weights: {
      42057: 41,
      42061: 59,
    },
    county_names_all: "Huntingdon|Fulton",
    county_fips_all: "42061|42057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17217,
    lat: 40.23822,
    lng: -77.72235,
    city: "Concord",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 155,
    density: 16,
    county_fips: 42055,
    county_name: "Franklin",
    county_weights: {
      42055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 42055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17219,
    lat: 40.22367,
    lng: -77.69318,
    city: "Doylesburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 506,
    density: 14.7,
    county_fips: 42055,
    county_name: "Franklin",
    county_weights: {
      42055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 42055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17220,
    lat: 40.17807,
    lng: -77.74108,
    city: "Dry Run",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 502,
    density: 14.2,
    county_fips: 42055,
    county_name: "Franklin",
    county_weights: {
      42055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 42055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17221,
    lat: 40.05796,
    lng: -77.82019,
    city: "Fannettsburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 582,
    density: 19.3,
    county_fips: 42055,
    county_name: "Franklin",
    county_weights: {
      42055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 42055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17222,
    lat: 39.89983,
    lng: -77.49242,
    city: "Fayetteville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10717,
    density: 63.7,
    county_fips: 42055,
    county_name: "Franklin",
    county_weights: {
      42001: 31.22,
      42055: 68.78,
    },
    county_names_all: "Franklin|Adams",
    county_fips_all: "42055|42001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17223,
    lat: 40.06521,
    lng: -77.9389,
    city: "Fort Littleton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 288,
    density: 7.2,
    county_fips: 42057,
    county_name: "Fulton",
    county_weights: {
      42057: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 42057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17224,
    lat: 39.9723,
    lng: -77.89195,
    city: "Fort Loudon",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2077,
    density: 20.3,
    county_fips: 42055,
    county_name: "Franklin",
    county_weights: {
      42055: 94.99,
      42057: 5.01,
    },
    county_names_all: "Franklin|Fulton",
    county_fips_all: "42055|42057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17225,
    lat: 39.78706,
    lng: -77.75709,
    city: "Greencastle",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20576,
    density: 97.2,
    county_fips: 42055,
    county_name: "Franklin",
    county_weights: {
      42055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 42055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17228,
    lat: 39.99512,
    lng: -78.09831,
    city: "Harrisonville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1062,
    density: 12.7,
    county_fips: 42057,
    county_name: "Fulton",
    county_weights: {
      42057: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 42057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17229,
    lat: 40.07853,
    lng: -78.01144,
    city: "Hustontown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1268,
    density: 17,
    county_fips: 42057,
    county_name: "Fulton",
    county_weights: {
      42057: 90.36,
      42061: 9.64,
    },
    county_names_all: "Fulton|Huntingdon",
    county_fips_all: "42057|42061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17232,
    lat: 40.09462,
    lng: -77.63341,
    city: "Lurgan",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42055,
    county_name: "Franklin",
    county_weights: {
      42055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 42055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17233,
    lat: 39.95118,
    lng: -78.00406,
    city: "McConnellsburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5214,
    density: 25.6,
    county_fips: 42057,
    county_name: "Fulton",
    county_weights: {
      42057: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 42057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17235,
    lat: 39.85699,
    lng: -77.69743,
    city: "Marion",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 886,
    density: 605.3,
    county_fips: 42055,
    county_name: "Franklin",
    county_weights: {
      42055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 42055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17236,
    lat: 39.79997,
    lng: -77.94305,
    city: "Mercersburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8084,
    density: 24.8,
    county_fips: 42055,
    county_name: "Franklin",
    county_weights: {
      42055: 95.32,
      42057: 4.68,
    },
    county_names_all: "Franklin|Fulton",
    county_fips_all: "42055|42057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17237,
    lat: 39.83705,
    lng: -77.54091,
    city: "Mont Alto",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2006,
    density: 315.2,
    county_fips: 42055,
    county_name: "Franklin",
    county_weights: {
      42055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 42055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17238,
    lat: 39.8612,
    lng: -78.13003,
    city: "Needmore",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1701,
    density: 12.4,
    county_fips: 42057,
    county_name: "Fulton",
    county_weights: {
      42057: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 42057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17239,
    lat: 40.13973,
    lng: -77.83009,
    city: "Neelyton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 156,
    density: 5.4,
    county_fips: 42061,
    county_name: "Huntingdon",
    county_weights: {
      42061: 100,
    },
    county_names_all: "Huntingdon",
    county_fips_all: 42061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17240,
    lat: 40.15411,
    lng: -77.58227,
    city: "Newburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3981,
    density: 31.6,
    county_fips: 42041,
    county_name: "Cumberland",
    county_weights: {
      42041: 60.96,
      42055: 39.04,
    },
    county_names_all: "Cumberland|Franklin",
    county_fips_all: "42041|42055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17241,
    lat: 40.17793,
    lng: -77.40326,
    city: "Newville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11877,
    density: 41.1,
    county_fips: 42041,
    county_name: "Cumberland",
    county_weights: {
      42041: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 42041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17243,
    lat: 40.28368,
    lng: -77.81484,
    city: "Orbisonia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1364,
    density: 8.8,
    county_fips: 42061,
    county_name: "Huntingdon",
    county_weights: {
      42061: 71.59,
      42067: 28.41,
    },
    county_names_all: "Huntingdon|Juniata",
    county_fips_all: "42061|42067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17244,
    lat: 40.08595,
    lng: -77.66562,
    city: "Orrstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2113,
    density: 30.5,
    county_fips: 42055,
    county_name: "Franklin",
    county_weights: {
      42055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 42055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17246,
    lat: 40.0629,
    lng: -77.68255,
    city: "Pleasant Hall",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 402,
    density: 71.2,
    county_fips: 42055,
    county_name: "Franklin",
    county_weights: {
      42055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 42055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17247,
    lat: 39.79883,
    lng: -77.57933,
    city: "Quincy",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 433,
    density: 1149.6,
    county_fips: 42055,
    county_name: "Franklin",
    county_weights: {
      42055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 42055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17249,
    lat: 40.24186,
    lng: -77.9002,
    city: "Rockhill Furnace",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 348,
    density: 583.3,
    county_fips: 42061,
    county_name: "Huntingdon",
    county_weights: {
      42061: 100,
    },
    county_names_all: "Huntingdon",
    county_fips_all: 42061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17250,
    lat: 39.73668,
    lng: -77.52338,
    city: "Rouzerville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33,
    density: 460.9,
    county_fips: 42055,
    county_name: "Franklin",
    county_weights: {
      42055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 42055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17251,
    lat: 40.12159,
    lng: -77.66695,
    city: "Roxbury",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 80,
    density: 15.6,
    county_fips: 42055,
    county_name: "Franklin",
    county_weights: {
      42055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 42055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17252,
    lat: 39.91317,
    lng: -77.81695,
    city: "Saint Thomas",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3681,
    density: 46.6,
    county_fips: 42055,
    county_name: "Franklin",
    county_weights: {
      42055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 42055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17253,
    lat: 40.21241,
    lng: -78.00628,
    city: "Saltillo",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 343,
    density: 479.4,
    county_fips: 42061,
    county_name: "Huntingdon",
    county_weights: {
      42061: 100,
    },
    county_names_all: "Huntingdon",
    county_fips_all: 42061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17254,
    lat: 39.96853,
    lng: -77.58917,
    city: "Scotland",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 73,
    density: 64.8,
    county_fips: 42055,
    county_name: "Franklin",
    county_weights: {
      42055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 42055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17255,
    lat: 40.15426,
    lng: -77.86756,
    city: "Shade Gap",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1181,
    density: 14.4,
    county_fips: 42061,
    county_name: "Huntingdon",
    county_weights: {
      42057: 5.47,
      42061: 94.53,
    },
    county_names_all: "Huntingdon|Fulton",
    county_fips_all: "42061|42057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17257,
    lat: 40.0508,
    lng: -77.49027,
    city: "Shippensburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29164,
    density: 97.8,
    county_fips: 42041,
    county_name: "Cumberland",
    county_weights: {
      42041: 63.7,
      42055: 36.3,
    },
    county_names_all: "Cumberland|Franklin",
    county_fips_all: "42041|42055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17260,
    lat: 40.2977,
    lng: -77.89489,
    city: "Shirleysburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 979,
    density: 10.6,
    county_fips: 42061,
    county_name: "Huntingdon",
    county_weights: {
      42061: 100,
    },
    county_names_all: "Huntingdon",
    county_fips_all: 42061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17261,
    lat: 39.85981,
    lng: -77.51164,
    city: "South Mountain",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 297,
    density: 71.1,
    county_fips: 42055,
    county_name: "Franklin",
    county_weights: {
      42055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 42055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17262,
    lat: 40.14489,
    lng: -77.74174,
    city: "Spring Run",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1494,
    density: 30.3,
    county_fips: 42055,
    county_name: "Franklin",
    county_weights: {
      42055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 42055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17263,
    lat: 39.72409,
    lng: -77.71727,
    city: "State Line",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 799,
    density: 1124.6,
    county_fips: 42055,
    county_name: "Franklin",
    county_weights: {
      42055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 42055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17264,
    lat: 40.17993,
    lng: -77.99331,
    city: "Three Springs",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2304,
    density: 15.3,
    county_fips: 42061,
    county_name: "Huntingdon",
    county_weights: {
      42057: 8.39,
      42061: 91.61,
    },
    county_names_all: "Huntingdon|Fulton",
    county_fips_all: "42061|42057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17265,
    lat: 40.03846,
    lng: -77.77297,
    city: "Upperstrasburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 821,
    density: 10.5,
    county_fips: 42055,
    county_name: "Franklin",
    county_weights: {
      42055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 42055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17266,
    lat: 40.08745,
    lng: -77.412,
    city: "Walnut Bottom",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 506,
    density: 148.5,
    county_fips: 42041,
    county_name: "Cumberland",
    county_weights: {
      42041: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 42041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17267,
    lat: 39.80389,
    lng: -78.23958,
    city: "Warfordsburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2854,
    density: 11.4,
    county_fips: 42057,
    county_name: "Fulton",
    county_weights: {
      42057: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 42057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17268,
    lat: 39.77421,
    lng: -77.57354,
    city: "Waynesboro",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29153,
    density: 144.7,
    county_fips: 42055,
    county_name: "Franklin",
    county_weights: {
      42055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 42055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17271,
    lat: 40.10183,
    lng: -77.80367,
    city: "Willow Hill",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 292,
    density: 8.9,
    county_fips: 42055,
    county_name: "Franklin",
    county_weights: {
      42055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 42055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17301,
    lat: 39.89119,
    lng: -76.9815,
    city: "Abbottstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4462,
    density: 145.1,
    county_fips: 42001,
    county_name: "Adams",
    county_weights: {
      42001: 60.55,
      42133: 39.45,
    },
    county_names_all: "Adams|York",
    county_fips_all: "42001|42133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17302,
    lat: 39.81659,
    lng: -76.41069,
    city: "Airville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2566,
    density: 24.6,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17303,
    lat: 39.92615,
    lng: -77.29755,
    city: "Arendtsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42001,
    county_name: "Adams",
    county_weights: {
      42001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 42001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17304,
    lat: 39.97696,
    lng: -77.23099,
    city: "Aspers",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2795,
    density: 44.3,
    county_fips: 42001,
    county_name: "Adams",
    county_weights: {
      42001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 42001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17306,
    lat: 39.98383,
    lng: -77.24966,
    city: "Bendersville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 337,
    density: 533.3,
    county_fips: 42001,
    county_name: "Adams",
    county_weights: {
      42001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 42001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17307,
    lat: 39.94853,
    lng: -77.314,
    city: "Biglerville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6259,
    density: 40.7,
    county_fips: 42001,
    county_name: "Adams",
    county_weights: {
      42001: 90.63,
      42041: 9.37,
    },
    county_names_all: "Adams|Cumberland",
    county_fips_all: "42001|42041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17309,
    lat: 39.87351,
    lng: -76.44894,
    city: "Brogue",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2251,
    density: 38.2,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17311,
    lat: 39.81709,
    lng: -76.84191,
    city: "Codorus",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 211,
    density: 1614.4,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17313,
    lat: 39.88472,
    lng: -76.65719,
    city: "Dallastown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11269,
    density: 445.3,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17314,
    lat: 39.75469,
    lng: -76.32852,
    city: "Delta",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6085,
    density: 67,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17315,
    lat: 40.01859,
    lng: -76.8685,
    city: "Dover",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26160,
    density: 173.8,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17316,
    lat: 39.96721,
    lng: -77.00226,
    city: "East Berlin",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8391,
    density: 79.1,
    county_fips: 42001,
    county_name: "Adams",
    county_weights: {
      42001: 58.27,
      42133: 41.73,
    },
    county_names_all: "Adams|York",
    county_fips_all: "42001|42133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17317,
    lat: 39.97136,
    lng: -76.52267,
    city: "East Prospect",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 565,
    density: 1131.4,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17318,
    lat: 40.01847,
    lng: -76.7265,
    city: "Emigsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 376,
    density: 136,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17319,
    lat: 40.1585,
    lng: -76.79468,
    city: "Etters",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11440,
    density: 263,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17320,
    lat: 39.7695,
    lng: -77.38749,
    city: "Fairfield",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7956,
    density: 53.9,
    county_fips: 42001,
    county_name: "Adams",
    county_weights: {
      42001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 42001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17321,
    lat: 39.75406,
    lng: -76.44742,
    city: "Fawn Grove",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2304,
    density: 52.5,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17322,
    lat: 39.85548,
    lng: -76.53513,
    city: "Felton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6191,
    density: 60.6,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17323,
    lat: 40.07523,
    lng: -77.02669,
    city: "Franklintown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17324,
    lat: 40.03616,
    lng: -77.22772,
    city: "Gardners",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4061,
    density: 29.4,
    county_fips: 42041,
    county_name: "Cumberland",
    county_weights: {
      42001: 34.82,
      42041: 65.18,
    },
    county_names_all: "Cumberland|Adams",
    county_fips_all: "42041|42001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17325,
    lat: 39.82762,
    lng: -77.22641,
    city: "Gettysburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28563,
    density: 87.6,
    county_fips: 42001,
    county_name: "Adams",
    county_weights: {
      42001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 42001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17327,
    lat: 39.77934,
    lng: -76.75373,
    city: "Glen Rock",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8318,
    density: 69.6,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17329,
    lat: 39.76295,
    lng: -76.85374,
    city: "Glenville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2554,
    density: 56,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17331,
    lat: 39.79085,
    lng: -76.98028,
    city: "Hanover",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52219,
    density: 270.9,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42001: 39.46,
      42133: 60.54,
    },
    county_names_all: "York|Adams",
    county_fips_all: "42133|42001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17339,
    lat: 40.13438,
    lng: -76.88188,
    city: "Lewisberry",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6766,
    density: 97.4,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17340,
    lat: 39.75566,
    lng: -77.11183,
    city: "Littlestown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11024,
    density: 108.1,
    county_fips: 42001,
    county_name: "Adams",
    county_weights: {
      42001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 42001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17342,
    lat: 39.85275,
    lng: -76.70756,
    city: "Loganville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17343,
    lat: 39.86863,
    lng: -77.32948,
    city: "McKnightstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68,
    density: 36.7,
    county_fips: 42001,
    county_name: "Adams",
    county_weights: {
      42001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 42001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17344,
    lat: 39.80535,
    lng: -77.01887,
    city: "McSherrystown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3515,
    density: 1815.6,
    county_fips: 42001,
    county_name: "Adams",
    county_weights: {
      42001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 42001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17345,
    lat: 40.07929,
    lng: -76.72812,
    city: "Manchester",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7737,
    density: 248.8,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17347,
    lat: 40.04927,
    lng: -76.68247,
    city: "Mount Wolf",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6577,
    density: 200.1,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17349,
    lat: 39.75536,
    lng: -76.68003,
    city: "New Freedom",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7261,
    density: 132.9,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17350,
    lat: 39.88918,
    lng: -77.07896,
    city: "New Oxford",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12830,
    density: 111.9,
    county_fips: 42001,
    county_name: "Adams",
    county_weights: {
      42001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 42001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17352,
    lat: 39.76199,
    lng: -76.50008,
    city: "New Park",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1628,
    density: 47.1,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17353,
    lat: 39.88741,
    lng: -77.38714,
    city: "Orrtanna",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3413,
    density: 34,
    county_fips: 42001,
    county_name: "Adams",
    county_weights: {
      42001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 42001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17355,
    lat: 39.75978,
    lng: -76.696,
    city: "Railroad",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 321,
    density: 201.2,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17356,
    lat: 39.89834,
    lng: -76.58366,
    city: "Red Lion",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21784,
    density: 251.6,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17360,
    lat: 39.85196,
    lng: -76.75377,
    city: "Seven Valleys",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7072,
    density: 109,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17361,
    lat: 39.76617,
    lng: -76.67702,
    city: "Shrewsbury",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6544,
    density: 828.7,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17362,
    lat: 39.85088,
    lng: -76.86872,
    city: "Spring Grove",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13088,
    density: 103,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17363,
    lat: 39.76736,
    lng: -76.58504,
    city: "Stewartstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8772,
    density: 91.8,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17364,
    lat: 39.92985,
    lng: -76.90049,
    city: "Thomasville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3699,
    density: 82.2,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17365,
    lat: 40.05696,
    lng: -76.9392,
    city: "Wellsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2206,
    density: 40.9,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17366,
    lat: 39.93184,
    lng: -76.55585,
    city: "Windsor",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5974,
    density: 203.9,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17368,
    lat: 39.98463,
    lng: -76.51966,
    city: "Wrightsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6198,
    density: 127.8,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42071: 0.1,
      42133: 99.9,
    },
    county_names_all: "York|Lancaster",
    county_fips_all: "42133|42071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17370,
    lat: 40.1174,
    lng: -76.78124,
    city: "York Haven",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5423,
    density: 158.2,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17371,
    lat: 39.90258,
    lng: -76.78797,
    city: "York New Salem",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 235,
    density: 445.2,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17372,
    lat: 40.00037,
    lng: -77.10633,
    city: "York Springs",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4028,
    density: 46.2,
    county_fips: 42001,
    county_name: "Adams",
    county_weights: {
      42001: 98.72,
      42133: 1.28,
    },
    county_names_all: "Adams|York",
    county_fips_all: "42001|42133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17401,
    lat: 39.95893,
    lng: -76.73359,
    city: "York",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16973,
    density: 4408.7,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17402,
    lat: 39.95799,
    lng: -76.66045,
    city: "York",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38026,
    density: 784.7,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17403,
    lat: 39.92142,
    lng: -76.71277,
    city: "York",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39217,
    density: 735.6,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17404,
    lat: 40.00496,
    lng: -76.77217,
    city: "York",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37280,
    density: 668.1,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17406,
    lat: 40.01224,
    lng: -76.64249,
    city: "York",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23326,
    density: 184.2,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17407,
    lat: 39.8855,
    lng: -76.71244,
    city: "York",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3070,
    density: 801.7,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17408,
    lat: 39.93451,
    lng: -76.80203,
    city: "York",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23402,
    density: 337.4,
    county_fips: 42133,
    county_name: "York",
    county_weights: {
      42133: 100,
    },
    county_names_all: "York",
    county_fips_all: 42133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17501,
    lat: 40.15697,
    lng: -76.20532,
    city: "Akron",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4450,
    density: 1117.6,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17502,
    lat: 40.10081,
    lng: -76.66732,
    city: "Bainbridge",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2673,
    density: 96.7,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 99.9,
      42133: 0.1,
    },
    county_names_all: "Lancaster|York",
    county_fips_all: "42071|42133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17504,
    lat: 40.02448,
    lng: -76.32855,
    city: "Bausman",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17505,
    lat: 40.05915,
    lng: -76.18999,
    city: "Bird In Hand",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1460,
    density: 76.1,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17506,
    lat: 40.11718,
    lng: -76.0527,
    city: "Blue Ball",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17507,
    lat: 40.19806,
    lng: -76.01624,
    city: "Bowmansville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 112,
    density: 2031.7,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17508,
    lat: 40.12455,
    lng: -76.21394,
    city: "Brownstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 302,
    density: 410.3,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17509,
    lat: 39.90923,
    lng: -76.03073,
    city: "Christiana",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5246,
    density: 77.6,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17512,
    lat: 40.04,
    lng: -76.48558,
    city: "Columbia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17802,
    density: 429.3,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17516,
    lat: 39.93773,
    lng: -76.38703,
    city: "Conestoga",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4875,
    density: 91.7,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 99.9,
      42133: 0.1,
    },
    county_names_all: "Lancaster|York",
    county_fips_all: "42071|42133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17517,
    lat: 40.24402,
    lng: -76.13151,
    city: "Denver",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15974,
    density: 173.5,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17518,
    lat: 39.80519,
    lng: -76.25932,
    city: "Drumore",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1618,
    density: 45.2,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17519,
    lat: 40.14278,
    lng: -76.02145,
    city: "East Earl",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6859,
    density: 122.9,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17520,
    lat: 40.09813,
    lng: -76.34897,
    city: "East Petersburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4688,
    density: 986.9,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17522,
    lat: 40.17499,
    lng: -76.17009,
    city: "Ephrata",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34400,
    density: 308.8,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17527,
    lat: 40.01495,
    lng: -75.99333,
    city: "Gap",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5655,
    density: 103.9,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42029: 5.88,
      42071: 94.12,
    },
    county_names_all: "Lancaster|Chester",
    county_fips_all: "42071|42029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17529,
    lat: 40.04036,
    lng: -76.10008,
    city: "Gordonville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5100,
    density: 134.2,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17532,
    lat: 39.85731,
    lng: -76.2923,
    city: "Holtwood",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3287,
    density: 59.3,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17534,
    lat: 40.03665,
    lng: -76.11214,
    city: "Intercourse",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17535,
    lat: 40.01224,
    lng: -76.03813,
    city: "Kinzers",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2912,
    density: 88.7,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17536,
    lat: 39.84345,
    lng: -76.07316,
    city: "Kirkwood",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3361,
    density: 62,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17538,
    lat: 40.08804,
    lng: -76.41528,
    city: "Landisville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7311,
    density: 683.1,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17540,
    lat: 40.09877,
    lng: -76.1888,
    city: "Leola",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10773,
    density: 198.8,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17543,
    lat: 40.18217,
    lng: -76.30038,
    city: "Lititz",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44973,
    density: 263.3,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17545,
    lat: 40.17307,
    lng: -76.42792,
    city: "Manheim",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22174,
    density: 122.7,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 94.12,
      42075: 5.88,
    },
    county_names_all: "Lancaster|Lebanon",
    county_fips_all: "42071|42075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17547,
    lat: 40.07056,
    lng: -76.58436,
    city: "Marietta",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8068,
    density: 260.5,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17550,
    lat: 40.07492,
    lng: -76.58339,
    city: "Maytown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 576,
    density: 1422.5,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17551,
    lat: 39.97911,
    lng: -76.37608,
    city: "Millersville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11011,
    density: 400.6,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17552,
    lat: 40.10935,
    lng: -76.51174,
    city: "Mount Joy",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20369,
    density: 241.1,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17554,
    lat: 40.03923,
    lng: -76.42584,
    city: "Mountville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7214,
    density: 893.3,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17555,
    lat: 40.12075,
    lng: -75.96514,
    city: "Narvon",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7760,
    density: 90.5,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42029: 0.91,
      42071: 99.09,
    },
    county_names_all: "Lancaster|Chester",
    county_fips_all: "42071|42029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17557,
    lat: 40.10328,
    lng: -76.07543,
    city: "New Holland",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14860,
    density: 179.1,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17560,
    lat: 39.91117,
    lng: -76.22712,
    city: "New Providence",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5287,
    density: 129.2,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17562,
    lat: 39.97636,
    lng: -76.09264,
    city: "Paradise",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4770,
    density: 107.1,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17563,
    lat: 39.76404,
    lng: -76.18649,
    city: "Peach Bottom",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4075,
    density: 48.7,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17565,
    lat: 39.89191,
    lng: -76.32994,
    city: "Pequea",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2297,
    density: 66.9,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17566,
    lat: 39.86924,
    lng: -76.1476,
    city: "Quarryville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12147,
    density: 78.7,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17568,
    lat: 39.94806,
    lng: -76.23416,
    city: "Refton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17569,
    lat: 40.27043,
    lng: -76.09652,
    city: "Reinholds",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6422,
    density: 149.7,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42011: 26.19,
      42071: 73.81,
    },
    county_names_all: "Lancaster|Berks",
    county_fips_all: "42071|42011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17570,
    lat: 40.12574,
    lng: -76.57035,
    city: "Rheems",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17572,
    lat: 40.00937,
    lng: -76.15105,
    city: "Ronks",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3985,
    density: 94.8,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17576,
    lat: 40.03561,
    lng: -76.19782,
    city: "Smoketown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6,
    density: 24.4,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17578,
    lat: 40.22397,
    lng: -76.16405,
    city: "Stevens",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7667,
    density: 211.8,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17579,
    lat: 39.95938,
    lng: -76.18032,
    city: "Strasburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6320,
    density: 166.6,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17581,
    lat: 40.15617,
    lng: -76.05535,
    city: "Terre Hill",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 824,
    density: 845.1,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17582,
    lat: 39.98928,
    lng: -76.44756,
    city: "Washington Boro",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2022,
    density: 85.2,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17584,
    lat: 39.95981,
    lng: -76.26463,
    city: "Willow Street",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10669,
    density: 278,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17601,
    lat: 40.07296,
    lng: -76.31457,
    city: "Lancaster",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53023,
    density: 610.8,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17602,
    lat: 40.01486,
    lng: -76.24632,
    city: "Lancaster",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50660,
    density: 796.3,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17603,
    lat: 40.0127,
    lng: -76.35287,
    city: "Lancaster",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65022,
    density: 837.2,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17606,
    lat: 40.11174,
    lng: -76.30401,
    city: "Lancaster",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 428,
    density: 3811.4,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42071: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 42071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17701,
    lat: 41.34206,
    lng: -76.88821,
    city: "Williamsport",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43068,
    density: 169.6,
    county_fips: 42081,
    county_name: "Lycoming",
    county_weights: {
      42081: 89.98,
      42113: 10.02,
    },
    county_names_all: "Lycoming|Sullivan",
    county_fips_all: "42081|42113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17702,
    lat: 41.18215,
    lng: -77.07728,
    city: "Williamsport",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10568,
    density: 66.7,
    county_fips: 42081,
    county_name: "Lycoming",
    county_weights: {
      42081: 100,
    },
    county_names_all: "Lycoming",
    county_fips_all: 42081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17720,
    lat: 41.18046,
    lng: -77.20503,
    city: "Antes Fort",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42081,
    county_name: "Lycoming",
    county_weights: {
      42081: 100,
    },
    county_names_all: "Lycoming",
    county_fips_all: 42081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17721,
    lat: 41.18155,
    lng: -77.31927,
    city: "Avis",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1532,
    density: 499.6,
    county_fips: 42035,
    county_name: "Clinton",
    county_weights: {
      42035: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 42035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17723,
    lat: 41.43125,
    lng: -77.45629,
    city: "Cammal",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54,
    density: 1.5,
    county_fips: 42081,
    county_name: "Lycoming",
    county_weights: {
      42081: 100,
    },
    county_names_all: "Lycoming",
    county_fips_all: 42081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17724,
    lat: 41.63827,
    lng: -76.80034,
    city: "Canton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4840,
    density: 17.1,
    county_fips: 42015,
    county_name: "Bradford",
    county_weights: {
      42015: 75.17,
      42081: 8.11,
      42117: 16.72,
    },
    county_names_all: "Bradford|Tioga|Lycoming",
    county_fips_all: "42015|42117|42081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17727,
    lat: 41.53904,
    lng: -77.47914,
    city: "Cedar Run",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 81,
    density: 0.7,
    county_fips: 42117,
    county_name: "Tioga",
    county_weights: {
      42081: 41.19,
      42117: 58.81,
    },
    county_names_all: "Tioga|Lycoming",
    county_fips_all: "42117|42081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17728,
    lat: 41.32546,
    lng: -77.08215,
    city: "Cogan Station",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4636,
    density: 39.4,
    county_fips: 42081,
    county_name: "Lycoming",
    county_weights: {
      42081: 100,
    },
    county_names_all: "Lycoming",
    county_fips_all: 42081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17729,
    lat: 41.49798,
    lng: -77.74106,
    city: "Cross Fork",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 72,
    density: 0.3,
    county_fips: 42105,
    county_name: "Potter",
    county_weights: {
      42035: 28.62,
      42105: 71.38,
    },
    county_names_all: "Potter|Clinton",
    county_fips_all: "42105|42035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17730,
    lat: 41.10677,
    lng: -76.87591,
    city: "Dewart",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 199,
    density: 397.2,
    county_fips: 42097,
    county_name: "Northumberland",
    county_weights: {
      42097: 100,
    },
    county_names_all: "Northumberland",
    county_fips_all: 42097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17731,
    lat: 41.42713,
    lng: -76.57293,
    city: "Eagles Mere",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 181,
    density: 5.6,
    county_fips: 42113,
    county_name: "Sullivan",
    county_weights: {
      42113: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 42113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17737,
    lat: 41.28673,
    lng: -76.68149,
    city: "Hughesville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6596,
    density: 42.2,
    county_fips: 42081,
    county_name: "Lycoming",
    county_weights: {
      42081: 98.35,
      42113: 1.65,
    },
    county_names_all: "Lycoming|Sullivan",
    county_fips_all: "42081|42113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17739,
    lat: 41.41289,
    lng: -77.40156,
    city: "Jersey Mills",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31,
    density: 0.7,
    county_fips: 42081,
    county_name: "Lycoming",
    county_weights: {
      42081: 100,
    },
    county_names_all: "Lycoming",
    county_fips_all: 42081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17740,
    lat: 41.2342,
    lng: -77.26171,
    city: "Jersey Shore",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12306,
    density: 34.9,
    county_fips: 42081,
    county_name: "Lycoming",
    county_weights: {
      42035: 17.08,
      42081: 82.92,
    },
    county_names_all: "Lycoming|Clinton",
    county_fips_all: "42081|42035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17742,
    lat: 41.23919,
    lng: -76.5829,
    city: "Lairdsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42081,
    county_name: "Lycoming",
    county_weights: {
      42081: 100,
    },
    county_names_all: "Lycoming",
    county_fips_all: 42081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17744,
    lat: 41.24397,
    lng: -77.16139,
    city: "Linden",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2881,
    density: 49.4,
    county_fips: 42081,
    county_name: "Lycoming",
    county_weights: {
      42081: 100,
    },
    county_names_all: "Lycoming",
    county_fips_all: 42081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17745,
    lat: 41.28589,
    lng: -77.48097,
    city: "Lock Haven",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18195,
    density: 30.7,
    county_fips: 42035,
    county_name: "Clinton",
    county_weights: {
      42035: 71.71,
      42081: 28.29,
    },
    county_names_all: "Clinton|Lycoming",
    county_fips_all: "42035|42081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17747,
    lat: 41.03847,
    lng: -77.31497,
    city: "Loganton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3494,
    density: 15.9,
    county_fips: 42035,
    county_name: "Clinton",
    county_weights: {
      42035: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 42035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17748,
    lat: 41.15147,
    lng: -77.35043,
    city: "McElhattan",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 148,
    density: 58.5,
    county_fips: 42035,
    county_name: "Clinton",
    county_weights: {
      42035: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 42035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17749,
    lat: 41.07232,
    lng: -76.81352,
    city: "McEwensville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 279,
    density: 322.7,
    county_fips: 42097,
    county_name: "Northumberland",
    county_weights: {
      42097: 100,
    },
    county_names_all: "Northumberland",
    county_fips_all: 42097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17750,
    lat: 41.05517,
    lng: -77.47805,
    city: "Mackeyville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 245,
    density: 68.6,
    county_fips: 42035,
    county_name: "Clinton",
    county_weights: {
      42035: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 42035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17751,
    lat: 41.13086,
    lng: -77.53201,
    city: "Mill Hall",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7267,
    density: 20,
    county_fips: 42035,
    county_name: "Clinton",
    county_weights: {
      42035: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 42035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17752,
    lat: 41.18244,
    lng: -76.92144,
    city: "Montgomery",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4503,
    density: 42.7,
    county_fips: 42081,
    county_name: "Lycoming",
    county_weights: {
      42081: 100,
    },
    county_names_all: "Lycoming",
    county_fips_all: 42081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17754,
    lat: 41.31108,
    lng: -76.88421,
    city: "Montoursville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12392,
    density: 79.6,
    county_fips: 42081,
    county_name: "Lycoming",
    county_weights: {
      42081: 100,
    },
    county_names_all: "Lycoming",
    county_fips_all: 42081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17756,
    lat: 41.20841,
    lng: -76.73325,
    city: "Muncy",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12305,
    density: 44.1,
    county_fips: 42081,
    county_name: "Lycoming",
    county_weights: {
      42037: 1.99,
      42081: 81.92,
      42093: 2.8,
      42097: 13.29,
    },
    county_names_all: "Lycoming|Northumberland|Montour|Columbia",
    county_fips_all: "42081|42097|42093|42037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17758,
    lat: 41.35234,
    lng: -76.55155,
    city: "Muncy Valley",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 841,
    density: 3.6,
    county_fips: 42113,
    county_name: "Sullivan",
    county_weights: {
      42081: 5.07,
      42113: 94.93,
    },
    county_names_all: "Sullivan|Lycoming",
    county_fips_all: "42113|42081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17760,
    lat: 41.3966,
    lng: -77.66602,
    city: "North Bend",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 576,
    density: 2.8,
    county_fips: 42035,
    county_name: "Clinton",
    county_weights: {
      42035: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 42035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17762,
    lat: 41.28326,
    lng: -76.70751,
    city: "Picture Rocks",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 467,
    density: 324.3,
    county_fips: 42081,
    county_name: "Lycoming",
    county_weights: {
      42081: 100,
    },
    county_names_all: "Lycoming",
    county_fips_all: 42081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17763,
    lat: 41.50999,
    lng: -76.91388,
    city: "Ralston",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 217,
    density: 4.9,
    county_fips: 42081,
    county_name: "Lycoming",
    county_weights: {
      42081: 100,
    },
    county_names_all: "Lycoming",
    county_fips_all: 42081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17764,
    lat: 41.34316,
    lng: -77.82735,
    city: "Renovo",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2341,
    density: 5.6,
    county_fips: 42035,
    county_name: "Clinton",
    county_weights: {
      42035: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 42035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17765,
    lat: 41.57591,
    lng: -76.97168,
    city: "Roaring Branch",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1179,
    density: 5,
    county_fips: 42117,
    county_name: "Tioga",
    county_weights: {
      42015: 0.73,
      42081: 42.69,
      42117: 56.58,
    },
    county_names_all: "Tioga|Lycoming|Bradford",
    county_fips_all: "42117|42081|42015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17768,
    lat: 41.54632,
    lng: -76.7477,
    city: "Shunk",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 367,
    density: 4.7,
    county_fips: 42113,
    county_name: "Sullivan",
    county_weights: {
      42113: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 42113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17769,
    lat: 41.49939,
    lng: -77.50073,
    city: "Slate Run",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42081,
    county_name: "Lycoming",
    county_weights: {
      42081: 100,
    },
    county_names_all: "Lycoming",
    county_fips_all: 42081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17771,
    lat: 41.43137,
    lng: -77.04524,
    city: "Trout Run",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3168,
    density: 5.6,
    county_fips: 42081,
    county_name: "Lycoming",
    county_weights: {
      42081: 100,
    },
    county_names_all: "Lycoming",
    county_fips_all: 42081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17772,
    lat: 41.11832,
    lng: -76.71756,
    city: "Turbotville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2333,
    density: 38.9,
    county_fips: 42093,
    county_name: "Montour",
    county_weights: {
      42093: 68.64,
      42097: 31.36,
    },
    county_names_all: "Montour|Northumberland",
    county_fips_all: "42093|42097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17774,
    lat: 41.24782,
    lng: -76.5416,
    city: "Unityville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1369,
    density: 18.8,
    county_fips: 42081,
    county_name: "Lycoming",
    county_weights: {
      42037: 0.81,
      42081: 99.19,
    },
    county_names_all: "Lycoming|Columbia",
    county_fips_all: "42081|42037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17776,
    lat: 41.41704,
    lng: -77.31257,
    city: "Waterville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 232,
    density: 1,
    county_fips: 42081,
    county_name: "Lycoming",
    county_weights: {
      42081: 100,
    },
    county_names_all: "Lycoming",
    county_fips_all: 42081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17777,
    lat: 41.10332,
    lng: -76.82678,
    city: "Watsontown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7163,
    density: 75,
    county_fips: 42097,
    county_name: "Northumberland",
    county_weights: {
      42093: 2.96,
      42097: 97.04,
    },
    county_names_all: "Northumberland|Montour",
    county_fips_all: "42097|42093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17778,
    lat: 41.28532,
    lng: -77.96477,
    city: "Westport",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 165,
    density: 0.9,
    county_fips: 42035,
    county_name: "Clinton",
    county_weights: {
      42035: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 42035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17779,
    lat: 41.20551,
    lng: -77.38019,
    city: "Woolrich",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 318,
    density: 90.3,
    county_fips: 42035,
    county_name: "Clinton",
    county_weights: {
      42035: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 42035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17801,
    lat: 40.83669,
    lng: -76.75762,
    city: "Sunbury",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15583,
    density: 91,
    county_fips: 42097,
    county_name: "Northumberland",
    county_weights: {
      42097: 100,
    },
    county_names_all: "Northumberland",
    county_fips_all: 42097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17810,
    lat: 41.1123,
    lng: -77.02543,
    city: "Allenwood",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5884,
    density: 41.2,
    county_fips: 42081,
    county_name: "Lycoming",
    county_weights: {
      42081: 73.46,
      42119: 26.54,
    },
    county_names_all: "Lycoming|Union",
    county_fips_all: "42081|42119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17812,
    lat: 40.73626,
    lng: -77.23641,
    city: "Beaver Springs",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1562,
    density: 23.1,
    county_fips: 42109,
    county_name: "Snyder",
    county_weights: {
      42109: 100,
    },
    county_names_all: "Snyder",
    county_fips_all: 42109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17813,
    lat: 40.78505,
    lng: -77.1772,
    city: "Beavertown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2094,
    density: 21.8,
    county_fips: 42109,
    county_name: "Snyder",
    county_weights: {
      42109: 100,
    },
    county_names_all: "Snyder",
    county_fips_all: 42109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17814,
    lat: 41.26885,
    lng: -76.3751,
    city: "Benton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4604,
    density: 13.9,
    county_fips: 42037,
    county_name: "Columbia",
    county_weights: {
      42037: 55.68,
      42079: 16.82,
      42081: 2.01,
      42113: 25.49,
    },
    county_names_all: "Columbia|Sullivan|Luzerne|Lycoming",
    county_fips_all: "42037|42113|42079|42081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17815,
    lat: 41.02216,
    lng: -76.43061,
    city: "Bloomsburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29705,
    density: 91.2,
    county_fips: 42037,
    county_name: "Columbia",
    county_weights: {
      42037: 97.38,
      42079: 2.31,
      42093: 0.31,
    },
    county_names_all: "Columbia|Luzerne|Montour",
    county_fips_all: "42037|42079|42093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17820,
    lat: 40.9011,
    lng: -76.40783,
    city: "Catawissa",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5405,
    density: 24.1,
    county_fips: 42037,
    county_name: "Columbia",
    county_weights: {
      42037: 93.97,
      42093: 6.03,
    },
    county_names_all: "Columbia|Montour",
    county_fips_all: "42037|42093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17821,
    lat: 40.9917,
    lng: -76.63959,
    city: "Danville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18773,
    density: 53.9,
    county_fips: 42093,
    county_name: "Montour",
    county_weights: {
      42037: 5.92,
      42093: 70.35,
      42097: 23.73,
    },
    county_names_all: "Montour|Northumberland|Columbia",
    county_fips_all: "42093|42097|42037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17822,
    lat: 40.96861,
    lng: -76.60365,
    city: "Danville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 42093,
    county_name: "Montour",
    county_weights: {
      42093: 100,
    },
    county_names_all: "Montour",
    county_fips_all: 42093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17823,
    lat: 40.72099,
    lng: -76.72541,
    city: "Dornsife",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1252,
    density: 14.1,
    county_fips: 42097,
    county_name: "Northumberland",
    county_weights: {
      42097: 99.83,
      42107: 0.17,
    },
    county_names_all: "Northumberland|Schuylkill",
    county_fips_all: "42097|42107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17824,
    lat: 40.85652,
    lng: -76.49848,
    city: "Elysburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3758,
    density: 51.7,
    county_fips: 42037,
    county_name: "Columbia",
    county_weights: {
      42037: 54.74,
      42093: 1.51,
      42097: 43.75,
    },
    county_names_all: "Columbia|Northumberland|Montour",
    county_fips_all: "42037|42097|42093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17827,
    lat: 40.75482,
    lng: -76.96133,
    city: "Freeburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 796,
    density: 151.8,
    county_fips: 42109,
    county_name: "Snyder",
    county_weights: {
      42109: 100,
    },
    county_names_all: "Snyder",
    county_fips_all: 42109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17829,
    lat: 40.90057,
    lng: -77.15546,
    city: "Hartleton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 281,
    density: 149.9,
    county_fips: 42119,
    county_name: "Union",
    county_weights: {
      42119: 100,
    },
    county_names_all: "Union",
    county_fips_all: 42119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17830,
    lat: 40.68791,
    lng: -76.79449,
    city: "Herndon",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1988,
    density: 24.9,
    county_fips: 42097,
    county_name: "Northumberland",
    county_weights: {
      42097: 100,
    },
    county_names_all: "Northumberland",
    county_fips_all: 42097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17832,
    lat: 40.80554,
    lng: -76.45499,
    city: "Marion Heights",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 687,
    density: 338.7,
    county_fips: 42097,
    county_name: "Northumberland",
    county_weights: {
      42097: 100,
    },
    county_names_all: "Northumberland",
    county_fips_all: 42097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17834,
    lat: 40.77982,
    lng: -76.46701,
    city: "Kulpmont",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3222,
    density: 220.9,
    county_fips: 42097,
    county_name: "Northumberland",
    county_weights: {
      42097: 100,
    },
    county_names_all: "Northumberland",
    county_fips_all: 42097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17835,
    lat: 40.88365,
    lng: -77.19795,
    city: "Laurelton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 336,
    density: 1450.1,
    county_fips: 42119,
    county_name: "Union",
    county_weights: {
      42119: 100,
    },
    county_names_all: "Union",
    county_fips_all: 42119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17836,
    lat: 40.71446,
    lng: -76.60136,
    city: "Leck Kill",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 221,
    density: 24.5,
    county_fips: 42097,
    county_name: "Northumberland",
    county_weights: {
      42097: 100,
    },
    county_names_all: "Northumberland",
    county_fips_all: 42097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17837,
    lat: 40.97485,
    lng: -76.94247,
    city: "Lewisburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19665,
    density: 135.1,
    county_fips: 42119,
    county_name: "Union",
    county_weights: {
      42119: 100,
    },
    county_names_all: "Union",
    county_fips_all: 42119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17840,
    lat: 40.77537,
    lng: -76.43291,
    city: "Locust Gap",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 568,
    density: 110.5,
    county_fips: 42097,
    county_name: "Northumberland",
    county_weights: {
      42097: 100,
    },
    county_names_all: "Northumberland",
    county_fips_all: 42097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17841,
    lat: 40.72455,
    lng: -77.35888,
    city: "McClure",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4666,
    density: 24.6,
    county_fips: 42087,
    county_name: "Mifflin",
    county_weights: {
      42087: 53.82,
      42109: 46.18,
    },
    county_names_all: "Mifflin|Snyder",
    county_fips_all: "42087|42109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17842,
    lat: 40.80389,
    lng: -77.04329,
    city: "Middleburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8817,
    density: 42.9,
    county_fips: 42109,
    county_name: "Snyder",
    county_weights: {
      42109: 100,
    },
    county_names_all: "Snyder",
    county_fips_all: 42109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17844,
    lat: 40.95904,
    lng: -77.08747,
    city: "Mifflinburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10504,
    density: 38,
    county_fips: 42119,
    county_name: "Union",
    county_weights: {
      42119: 100,
    },
    county_names_all: "Union",
    county_fips_all: 42119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17845,
    lat: 40.88308,
    lng: -77.21628,
    city: "Millmont",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1902,
    density: 11.8,
    county_fips: 42119,
    county_name: "Union",
    county_weights: {
      42119: 100,
    },
    county_names_all: "Union",
    county_fips_all: 42119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17846,
    lat: 41.14647,
    lng: -76.51681,
    city: "Millville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4052,
    density: 33.4,
    county_fips: 42037,
    county_name: "Columbia",
    county_weights: {
      42037: 96.45,
      42081: 3.55,
    },
    county_names_all: "Columbia|Lycoming",
    county_fips_all: "42037|42081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17847,
    lat: 41.00609,
    lng: -76.80612,
    city: "Milton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11433,
    density: 95.4,
    county_fips: 42097,
    county_name: "Northumberland",
    county_weights: {
      42093: 19.48,
      42097: 80.52,
    },
    county_names_all: "Northumberland|Montour",
    county_fips_all: "42097|42093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17850,
    lat: 40.9671,
    lng: -76.85847,
    city: "Montandon",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 686,
    density: 588,
    county_fips: 42097,
    county_name: "Northumberland",
    county_weights: {
      42097: 100,
    },
    county_names_all: "Northumberland",
    county_fips_all: 42097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17851,
    lat: 40.80255,
    lng: -76.433,
    city: "Mount Carmel",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7623,
    density: 196.4,
    county_fips: 42097,
    county_name: "Northumberland",
    county_weights: {
      42097: 100,
    },
    county_names_all: "Northumberland",
    county_fips_all: 42097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17853,
    lat: 40.69212,
    lng: -77.01254,
    city: "Mount Pleasant Mills",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3320,
    density: 29.5,
    county_fips: 42109,
    county_name: "Snyder",
    county_weights: {
      42067: 18.12,
      42109: 81.88,
    },
    county_names_all: "Snyder|Juniata",
    county_fips_all: "42109|42067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17855,
    lat: 40.88735,
    lng: -76.97217,
    city: "New Berlin",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 906,
    density: 180.5,
    county_fips: 42119,
    county_name: "Union",
    county_weights: {
      42119: 100,
    },
    county_names_all: "Union",
    county_fips_all: 42119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17856,
    lat: 41.05636,
    lng: -76.9722,
    city: "New Columbia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3094,
    density: 24.5,
    county_fips: 42119,
    county_name: "Union",
    county_weights: {
      42119: 100,
    },
    county_names_all: "Union",
    county_fips_all: 42119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17857,
    lat: 40.92789,
    lng: -76.76712,
    city: "Northumberland",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7281,
    density: 105.4,
    county_fips: 42097,
    county_name: "Northumberland",
    county_weights: {
      42097: 100,
    },
    county_names_all: "Northumberland",
    county_fips_all: 42097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17858,
    lat: 40.84238,
    lng: -76.42314,
    city: "Numidia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42037,
    county_name: "Columbia",
    county_weights: {
      42037: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 42037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17859,
    lat: 41.11821,
    lng: -76.39498,
    city: "Orangeville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2890,
    density: 29.5,
    county_fips: 42037,
    county_name: "Columbia",
    county_weights: {
      42037: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 42037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17860,
    lat: 40.82685,
    lng: -76.63402,
    city: "Paxinos",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2217,
    density: 30.5,
    county_fips: 42097,
    county_name: "Northumberland",
    county_weights: {
      42097: 100,
    },
    county_names_all: "Northumberland",
    county_fips_all: 42097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17861,
    lat: 40.77361,
    lng: -77.0788,
    city: "Paxtonville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 196,
    density: 156.9,
    county_fips: 42109,
    county_name: "Snyder",
    county_weights: {
      42109: 100,
    },
    county_names_all: "Snyder",
    county_fips_all: 42109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17862,
    lat: 40.86069,
    lng: -77.05661,
    city: "Penns Creek",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 384,
    density: 397,
    county_fips: 42109,
    county_name: "Snyder",
    county_weights: {
      42109: 100,
    },
    county_names_all: "Snyder",
    county_fips_all: 42109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17864,
    lat: 40.70294,
    lng: -76.90687,
    city: "Port Trevorton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2222,
    density: 40.8,
    county_fips: 42109,
    county_name: "Snyder",
    county_weights: {
      42109: 100,
    },
    county_names_all: "Snyder",
    county_fips_all: 42109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17865,
    lat: 40.98688,
    lng: -76.78979,
    city: "Potts Grove",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35,
    density: 30.6,
    county_fips: 42097,
    county_name: "Northumberland",
    county_weights: {
      42097: 100,
    },
    county_names_all: "Northumberland",
    county_fips_all: 42097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17866,
    lat: 40.78866,
    lng: -76.55035,
    city: "Coal Township",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10190,
    density: 161.3,
    county_fips: 42097,
    county_name: "Northumberland",
    county_weights: {
      42097: 100,
    },
    county_names_all: "Northumberland",
    county_fips_all: 42097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17867,
    lat: 40.71464,
    lng: -76.69025,
    city: "Rebuck",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 150,
    density: 19.7,
    county_fips: 42097,
    county_name: "Northumberland",
    county_weights: {
      42097: 100,
    },
    county_names_all: "Northumberland",
    county_fips_all: 42097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17868,
    lat: 40.95536,
    lng: -76.63098,
    city: "Riverside",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1162,
    density: 1295.5,
    county_fips: 42097,
    county_name: "Northumberland",
    county_weights: {
      42097: 100,
    },
    county_names_all: "Northumberland",
    county_fips_all: 42097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17870,
    lat: 40.80992,
    lng: -76.8897,
    city: "Selinsgrove",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15273,
    density: 128.7,
    county_fips: 42109,
    county_name: "Snyder",
    county_weights: {
      42109: 97.97,
      42119: 2.03,
    },
    county_names_all: "Snyder|Union",
    county_fips_all: "42109|42119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17872,
    lat: 40.7677,
    lng: -76.61317,
    city: "Shamokin",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9413,
    density: 84.5,
    county_fips: 42097,
    county_name: "Northumberland",
    county_weights: {
      42097: 100,
    },
    county_names_all: "Northumberland",
    county_fips_all: 42097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17876,
    lat: 40.85571,
    lng: -76.82319,
    city: "Shamokin Dam",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1812,
    density: 382.6,
    county_fips: 42109,
    county_name: "Snyder",
    county_weights: {
      42109: 100,
    },
    county_names_all: "Snyder",
    county_fips_all: 42109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17878,
    lat: 41.1721,
    lng: -76.32364,
    city: "Stillwater",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1546,
    density: 27.1,
    county_fips: 42037,
    county_name: "Columbia",
    county_weights: {
      42037: 70.95,
      42079: 29.05,
    },
    county_names_all: "Columbia|Luzerne",
    county_fips_all: "42037|42079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17880,
    lat: 40.89109,
    lng: -77.12383,
    city: "Swengel",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 149,
    density: 1324.7,
    county_fips: 42119,
    county_name: "Union",
    county_weights: {
      42119: 100,
    },
    county_names_all: "Union",
    county_fips_all: 42119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17881,
    lat: 40.78098,
    lng: -76.68632,
    city: "Trevorton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1375,
    density: 192.1,
    county_fips: 42097,
    county_name: "Northumberland",
    county_weights: {
      42097: 100,
    },
    county_names_all: "Northumberland",
    county_fips_all: 42097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17884,
    lat: 41.05201,
    lng: -76.67509,
    city: "Washingtonville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 188,
    density: 1173.6,
    county_fips: 42093,
    county_name: "Montour",
    county_weights: {
      42093: 100,
    },
    county_names_all: "Montour",
    county_fips_all: 42093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17885,
    lat: 40.87042,
    lng: -77.28941,
    city: "Weikert",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 235,
    density: 7.1,
    county_fips: 42119,
    county_name: "Union",
    county_weights: {
      42119: 100,
    },
    county_names_all: "Union",
    county_fips_all: 42119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17886,
    lat: 41.01847,
    lng: -76.87598,
    city: "West Milton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1190,
    density: 584.9,
    county_fips: 42119,
    county_name: "Union",
    county_weights: {
      42119: 100,
    },
    county_names_all: "Union",
    county_fips_all: 42119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17887,
    lat: 41.07508,
    lng: -76.8849,
    city: "White Deer",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 656,
    density: 1548.9,
    county_fips: 42119,
    county_name: "Union",
    county_weights: {
      42119: 100,
    },
    county_names_all: "Union",
    county_fips_all: 42119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17888,
    lat: 40.81931,
    lng: -76.37306,
    city: "Wilburton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 414,
    density: 21.2,
    county_fips: 42037,
    county_name: "Columbia",
    county_weights: {
      42037: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 42037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17889,
    lat: 40.88228,
    lng: -76.9143,
    city: "Winfield",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2609,
    density: 41,
    county_fips: 42109,
    county_name: "Snyder",
    county_weights: {
      42109: 58.97,
      42119: 41.03,
    },
    county_names_all: "Snyder|Union",
    county_fips_all: "42109|42119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17901,
    lat: 40.69364,
    lng: -76.25526,
    city: "Pottsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22878,
    density: 111.2,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17920,
    lat: 40.81328,
    lng: -76.32989,
    city: "Aristes",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 278,
    density: 47.6,
    county_fips: 42037,
    county_name: "Columbia",
    county_weights: {
      42037: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 42037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17921,
    lat: 40.75422,
    lng: -76.35732,
    city: "Ashland",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7208,
    density: 79.5,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42037: 8.54,
      42107: 91.46,
    },
    county_names_all: "Schuylkill|Columbia",
    county_fips_all: "42107|42037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17922,
    lat: 40.592,
    lng: -76.11212,
    city: "Auburn",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5111,
    density: 63.9,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17923,
    lat: 40.66136,
    lng: -76.31871,
    city: "Branchdale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 327,
    density: 45.7,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17925,
    lat: 40.75609,
    lng: -76.07047,
    city: "Brockton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 294,
    density: 117.4,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17929,
    lat: 40.63104,
    lng: -76.19273,
    city: "Cressona",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1350,
    density: 458.8,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17930,
    lat: 40.70867,
    lng: -76.11529,
    city: "Cumbola",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 318,
    density: 40.2,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17931,
    lat: 40.78378,
    lng: -76.21638,
    city: "Frackville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8728,
    density: 636.3,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17933,
    lat: 40.60357,
    lng: -76.24244,
    city: "Friedensburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 90,
    density: 289.1,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17934,
    lat: 40.79786,
    lng: -76.21205,
    city: "Gilberton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 304,
    density: 157.1,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17935,
    lat: 40.79417,
    lng: -76.28,
    city: "Girardville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1464,
    density: 100,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17936,
    lat: 40.75048,
    lng: -76.33997,
    city: "Gordon",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 969,
    density: 602,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17938,
    lat: 40.65558,
    lng: -76.50198,
    city: "Hegins",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2517,
    density: 23.7,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17941,
    lat: 40.68614,
    lng: -76.61472,
    city: "Klingerstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 774,
    density: 11.7,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42097: 36.18,
      42107: 63.82,
    },
    county_names_all: "Schuylkill|Northumberland",
    county_fips_all: "42107|42097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17943,
    lat: 40.76161,
    lng: -76.37949,
    city: "Lavelle",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 111,
    density: 322.2,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17944,
    lat: 40.6605,
    lng: -76.28903,
    city: "Llewellyn",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17945,
    lat: 40.78458,
    lng: -76.37523,
    city: "Locustdale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 135,
    density: 49.8,
    county_fips: 42037,
    county_name: "Columbia",
    county_weights: {
      42037: 97.46,
      42107: 2.54,
    },
    county_names_all: "Columbia|Schuylkill",
    county_fips_all: "42037|42107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17946,
    lat: 40.8123,
    lng: -76.2449,
    city: "Lost Creek",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 115,
    density: 25.9,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17948,
    lat: 40.82485,
    lng: -76.14223,
    city: "Mahanoy City",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4702,
    density: 94.6,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17949,
    lat: 40.79624,
    lng: -76.23547,
    city: "Mahanoy Plane",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 209,
    density: 252.4,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17951,
    lat: 40.67919,
    lng: -76.24425,
    city: "Mar Lin",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 389,
    density: 1242.6,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17952,
    lat: 40.76434,
    lng: -76.05997,
    city: "Mary D",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 223,
    density: 50,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17953,
    lat: 40.74728,
    lng: -76.09969,
    city: "Middleport",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 371,
    density: 15.9,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17954,
    lat: 40.69047,
    lng: -76.25985,
    city: "Minersville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4393,
    density: 2400.9,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17957,
    lat: 40.59359,
    lng: -76.51651,
    city: "Muir",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 326,
    density: 390.8,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17959,
    lat: 40.74224,
    lng: -76.15141,
    city: "New Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1395,
    density: 38.5,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17960,
    lat: 40.69932,
    lng: -75.94656,
    city: "New Ringgold",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4183,
    density: 30.8,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17961,
    lat: 40.64713,
    lng: -76.05988,
    city: "Orwigsburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6102,
    density: 91.9,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17963,
    lat: 40.56133,
    lng: -76.39548,
    city: "Pine Grove",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9073,
    density: 41.8,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42075: 3.63,
      42107: 96.37,
    },
    county_names_all: "Schuylkill|Lebanon",
    county_fips_all: "42107|42075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17964,
    lat: 40.71415,
    lng: -76.49785,
    city: "Pitman",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 819,
    density: 13.6,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42097: 10.25,
      42107: 89.75,
    },
    county_names_all: "Schuylkill|Northumberland",
    county_fips_all: "42107|42097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17965,
    lat: 40.69919,
    lng: -76.16536,
    city: "Port Carbon",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1890,
    density: 653.3,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17967,
    lat: 40.86047,
    lng: -76.20945,
    city: "Ringtown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2234,
    density: 25,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17968,
    lat: 40.6417,
    lng: -76.62625,
    city: "Sacramento",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 210,
    density: 14.5,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42043: 0.29,
      42107: 99.71,
    },
    county_names_all: "Schuylkill|Dauphin",
    county_fips_all: "42107|42043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17970,
    lat: 40.72072,
    lng: -76.19056,
    city: "Saint Clair",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3167,
    density: 960.6,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17972,
    lat: 40.58199,
    lng: -76.21367,
    city: "Schuylkill Haven",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10936,
    density: 86.9,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17974,
    lat: 40.69592,
    lng: -76.23606,
    city: "Seltzer",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 291,
    density: 1479.3,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17976,
    lat: 40.8204,
    lng: -76.21131,
    city: "Shenandoah",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6787,
    density: 344.2,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17978,
    lat: 40.6165,
    lng: -76.65219,
    city: "Spring Glen",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 296,
    density: 16.9,
    county_fips: 42043,
    county_name: "Dauphin",
    county_weights: {
      42043: 60.44,
      42107: 39.56,
    },
    county_names_all: "Dauphin|Schuylkill",
    county_fips_all: "42043|42107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17979,
    lat: 40.56729,
    lng: -76.20207,
    city: "Summit Station",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 118,
    density: 147.5,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17980,
    lat: 40.531,
    lng: -76.62065,
    city: "Tower City",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2931,
    density: 32.5,
    county_fips: 42043,
    county_name: "Dauphin",
    county_weights: {
      42043: 68.44,
      42107: 31.56,
    },
    county_names_all: "Dauphin|Schuylkill",
    county_fips_all: "42043|42107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17981,
    lat: 40.63077,
    lng: -76.39523,
    city: "Tremont",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2669,
    density: 27,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17982,
    lat: 40.76798,
    lng: -76.03827,
    city: "Tuscarora",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 502,
    density: 772.3,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17983,
    lat: 40.64403,
    lng: -76.55027,
    city: "Valley View",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1343,
    density: 189.9,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 17985,
    lat: 40.91935,
    lng: -76.23729,
    city: "Zion Grove",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1232,
    density: 13,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42037: 42.4,
      42107: 57.6,
    },
    county_names_all: "Schuylkill|Columbia",
    county_fips_all: "42107|42037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18011,
    lat: 40.47288,
    lng: -75.64395,
    city: "Alburtis",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5458,
    density: 123.1,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 76.83,
      42077: 23.17,
    },
    county_names_all: "Berks|Lehigh",
    county_fips_all: "42011|42077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18012,
    lat: 40.81135,
    lng: -75.59158,
    city: "Aquashicola",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42025,
    county_name: "Carbon",
    county_weights: {
      42025: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 42025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18013,
    lat: 40.85511,
    lng: -75.17114,
    city: "Bangor",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18880,
    density: 115.7,
    county_fips: 42095,
    county_name: "Northampton",
    county_weights: {
      42095: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 42095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18014,
    lat: 40.7654,
    lng: -75.40923,
    city: "Bath",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11738,
    density: 138.4,
    county_fips: 42095,
    county_name: "Northampton",
    county_weights: {
      42095: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 42095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18015,
    lat: 40.5887,
    lng: -75.36786,
    city: "Bethlehem",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32936,
    density: 548.4,
    county_fips: 42095,
    county_name: "Northampton",
    county_weights: {
      42077: 34.79,
      42095: 65.21,
    },
    county_names_all: "Northampton|Lehigh",
    county_fips_all: "42095|42077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18017,
    lat: 40.66069,
    lng: -75.38739,
    city: "Bethlehem",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39705,
    density: 914.8,
    county_fips: 42095,
    county_name: "Northampton",
    county_weights: {
      42077: 5.16,
      42095: 94.84,
    },
    county_names_all: "Northampton|Lehigh",
    county_fips_all: "42095|42077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18018,
    lat: 40.62766,
    lng: -75.39538,
    city: "Bethlehem",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31240,
    density: 2332.1,
    county_fips: 42077,
    county_name: "Lehigh",
    county_weights: {
      42077: 66.51,
      42095: 33.49,
    },
    county_names_all: "Lehigh|Northampton",
    county_fips_all: "42077|42095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18020,
    lat: 40.67267,
    lng: -75.32692,
    city: "Bethlehem",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21196,
    density: 628.6,
    county_fips: 42095,
    county_name: "Northampton",
    county_weights: {
      42095: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 42095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18030,
    lat: 40.80408,
    lng: -75.66336,
    city: "Bowmanstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 734,
    density: 952.2,
    county_fips: 42025,
    county_name: "Carbon",
    county_weights: {
      42025: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 42025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18031,
    lat: 40.554,
    lng: -75.65361,
    city: "Breinigsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11354,
    density: 314.8,
    county_fips: 42077,
    county_name: "Lehigh",
    county_weights: {
      42011: 1.28,
      42077: 98.72,
    },
    county_names_all: "Lehigh|Berks",
    county_fips_all: "42077|42011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18032,
    lat: 40.65694,
    lng: -75.46776,
    city: "Catasauqua",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9422,
    density: 1810.3,
    county_fips: 42077,
    county_name: "Lehigh",
    county_weights: {
      42077: 64.61,
      42095: 35.39,
    },
    county_names_all: "Lehigh|Northampton",
    county_fips_all: "42077|42095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18034,
    lat: 40.54182,
    lng: -75.41654,
    city: "Center Valley",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9396,
    density: 329.5,
    county_fips: 42077,
    county_name: "Lehigh",
    county_weights: {
      42077: 100,
    },
    county_names_all: "Lehigh",
    county_fips_all: 42077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18035,
    lat: 40.75053,
    lng: -75.54148,
    city: "Cherryville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14,
    density: 25.6,
    county_fips: 42095,
    county_name: "Northampton",
    county_weights: {
      42095: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 42095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18036,
    lat: 40.50925,
    lng: -75.38891,
    city: "Coopersburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14399,
    density: 190.5,
    county_fips: 42077,
    county_name: "Lehigh",
    county_weights: {
      42017: 37.68,
      42077: 62.32,
    },
    county_names_all: "Lehigh|Bucks",
    county_fips_all: "42077|42017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18037,
    lat: 40.68203,
    lng: -75.54638,
    city: "Coplay",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7577,
    density: 384.4,
    county_fips: 42077,
    county_name: "Lehigh",
    county_weights: {
      42077: 100,
    },
    county_names_all: "Lehigh",
    county_fips_all: 42077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18038,
    lat: 40.79574,
    lng: -75.48246,
    city: "Danielsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3562,
    density: 102.2,
    county_fips: 42095,
    county_name: "Northampton",
    county_weights: {
      42095: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 42095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18040,
    lat: 40.7459,
    lng: -75.22172,
    city: "Easton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16790,
    density: 375.2,
    county_fips: 42095,
    county_name: "Northampton",
    county_weights: {
      42095: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 42095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18041,
    lat: 40.41742,
    lng: -75.51306,
    city: "East Greenville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5429,
    density: 164.9,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42011: 2.93,
      42017: 4.89,
      42077: 28.09,
      42091: 64.09,
    },
    county_names_all: "Montgomery|Lehigh|Bucks|Berks",
    county_fips_all: "42091|42077|42017|42011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18042,
    lat: 40.6497,
    lng: -75.22376,
    city: "Easton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42387,
    density: 740.1,
    county_fips: 42095,
    county_name: "Northampton",
    county_weights: {
      42017: 0.7,
      42095: 99.3,
    },
    county_names_all: "Northampton|Bucks",
    county_fips_all: "42095|42017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18045,
    lat: 40.6919,
    lng: -75.27494,
    city: "Easton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26070,
    density: 522.6,
    county_fips: 42095,
    county_name: "Northampton",
    county_weights: {
      42095: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 42095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18046,
    lat: 40.54803,
    lng: -75.56029,
    city: "East Texas",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 142,
    density: 3004.6,
    county_fips: 42077,
    county_name: "Lehigh",
    county_weights: {
      42077: 100,
    },
    county_names_all: "Lehigh",
    county_fips_all: 42077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18049,
    lat: 40.51912,
    lng: -75.50018,
    city: "Emmaus",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17601,
    density: 453.1,
    county_fips: 42077,
    county_name: "Lehigh",
    county_weights: {
      42077: 100,
    },
    county_names_all: "Lehigh",
    county_fips_all: 42077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18051,
    lat: 40.59409,
    lng: -75.66415,
    city: "Fogelsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3217,
    density: 155.4,
    county_fips: 42077,
    county_name: "Lehigh",
    county_weights: {
      42077: 100,
    },
    county_names_all: "Lehigh",
    county_fips_all: 42077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18052,
    lat: 40.65668,
    lng: -75.50443,
    city: "Whitehall",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27896,
    density: 844.6,
    county_fips: 42077,
    county_name: "Lehigh",
    county_weights: {
      42077: 100,
    },
    county_names_all: "Lehigh",
    county_fips_all: 42077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18053,
    lat: 40.71802,
    lng: -75.70999,
    city: "Germansville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2248,
    density: 47.5,
    county_fips: 42077,
    county_name: "Lehigh",
    county_weights: {
      42077: 100,
    },
    county_names_all: "Lehigh",
    county_fips_all: 42077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18054,
    lat: 40.35321,
    lng: -75.43824,
    city: "Green Lane",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4909,
    density: 111.9,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42017: 19.73,
      42091: 80.27,
    },
    county_names_all: "Montgomery|Bucks",
    county_fips_all: "42091|42017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18055,
    lat: 40.58794,
    lng: -75.29929,
    city: "Hellertown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12000,
    density: 231.9,
    county_fips: 42095,
    county_name: "Northampton",
    county_weights: {
      42017: 5.65,
      42095: 94.35,
    },
    county_names_all: "Northampton|Bucks",
    county_fips_all: "42095|42017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18056,
    lat: 40.44798,
    lng: -75.54911,
    city: "Hereford",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1510,
    density: 509.5,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18058,
    lat: 40.8922,
    lng: -75.49094,
    city: "Kunkletown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9615,
    density: 69.8,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42025: 15.86,
      42089: 84.14,
    },
    county_names_all: "Monroe|Carbon",
    county_fips_all: "42089|42025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18059,
    lat: 40.7233,
    lng: -75.53644,
    city: "Laurys Station",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 925,
    density: 221.6,
    county_fips: 42077,
    county_name: "Lehigh",
    county_weights: {
      42077: 100,
    },
    county_names_all: "Lehigh",
    county_fips_all: 42077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18062,
    lat: 40.5035,
    lng: -75.57886,
    city: "Macungie",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26788,
    density: 492.9,
    county_fips: 42077,
    county_name: "Lehigh",
    county_weights: {
      42011: 30.28,
      42077: 69.72,
    },
    county_names_all: "Lehigh|Berks",
    county_fips_all: "42077|42011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18063,
    lat: 40.78229,
    lng: -75.18164,
    city: "Martins Creek",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 378,
    density: 343.2,
    county_fips: 42095,
    county_name: "Northampton",
    county_weights: {
      42095: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 42095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18064,
    lat: 40.75755,
    lng: -75.31927,
    city: "Nazareth",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25955,
    density: 260.2,
    county_fips: 42095,
    county_name: "Northampton",
    county_weights: {
      42095: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 42095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18065,
    lat: 40.69814,
    lng: -75.61086,
    city: "Neffs",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42077,
    county_name: "Lehigh",
    county_weights: {
      42077: 100,
    },
    county_names_all: "Lehigh",
    county_fips_all: 42077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18066,
    lat: 40.6635,
    lng: -75.74492,
    city: "New Tripoli",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6143,
    density: 53.8,
    county_fips: 42077,
    county_name: "Lehigh",
    county_weights: {
      42077: 100,
    },
    county_names_all: "Lehigh",
    county_fips_all: 42077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18067,
    lat: 40.71792,
    lng: -75.47937,
    city: "Northampton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17608,
    density: 266.5,
    county_fips: 42095,
    county_name: "Northampton",
    county_weights: {
      42095: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 42095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18069,
    lat: 40.626,
    lng: -75.616,
    city: "Orefield",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8600,
    density: 234.8,
    county_fips: 42077,
    county_name: "Lehigh",
    county_weights: {
      42077: 100,
    },
    county_names_all: "Lehigh",
    county_fips_all: 42077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18070,
    lat: 40.4317,
    lng: -75.53884,
    city: "Palm",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 606,
    density: 74,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42011: 39.21,
      42091: 60.79,
    },
    county_names_all: "Montgomery|Berks",
    county_fips_all: "42091|42011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18071,
    lat: 40.83098,
    lng: -75.57843,
    city: "Palmerton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10362,
    density: 128.6,
    county_fips: 42025,
    county_name: "Carbon",
    county_weights: {
      42025: 96.9,
      42089: 3.1,
    },
    county_names_all: "Carbon|Monroe",
    county_fips_all: "42025|42089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18072,
    lat: 40.84548,
    lng: -75.25842,
    city: "Pen Argyl",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6429,
    density: 166.8,
    county_fips: 42095,
    county_name: "Northampton",
    county_weights: {
      42095: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 42095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18073,
    lat: 40.38378,
    lng: -75.47702,
    city: "Pennsburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10920,
    density: 234,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42017: 14.36,
      42091: 85.64,
    },
    county_names_all: "Montgomery|Bucks",
    county_fips_all: "42091|42017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18074,
    lat: 40.31971,
    lng: -75.51424,
    city: "Perkiomenville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5709,
    density: 121.9,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18076,
    lat: 40.37382,
    lng: -75.48154,
    city: "Red Hill",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2931,
    density: 927,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18077,
    lat: 40.56603,
    lng: -75.24115,
    city: "Riegelsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2279,
    density: 65.6,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 93.2,
      42095: 6.8,
    },
    county_names_all: "Bucks|Northampton",
    county_fips_all: "42017|42095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18078,
    lat: 40.67181,
    lng: -75.62096,
    city: "Schnecksville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8050,
    density: 199.9,
    county_fips: 42077,
    county_name: "Lehigh",
    county_weights: {
      42077: 100,
    },
    county_names_all: "Lehigh",
    county_fips_all: 42077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18079,
    lat: 40.74415,
    lng: -75.65754,
    city: "Slatedale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 493,
    density: 766.6,
    county_fips: 42077,
    county_name: "Lehigh",
    county_weights: {
      42077: 100,
    },
    county_names_all: "Lehigh",
    county_fips_all: 42077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18080,
    lat: 40.73618,
    lng: -75.63227,
    city: "Slatington",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11498,
    density: 147,
    county_fips: 42077,
    county_name: "Lehigh",
    county_weights: {
      42077: 100,
    },
    county_names_all: "Lehigh",
    county_fips_all: 42077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18081,
    lat: 40.56236,
    lng: -75.28396,
    city: "Springtown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 159,
    density: 119.9,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 99.58,
      42095: 0.42,
    },
    county_names_all: "Bucks|Northampton",
    county_fips_all: "42017|42095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18083,
    lat: 40.75494,
    lng: -75.2637,
    city: "Stockertown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 351,
    density: 196.5,
    county_fips: 42095,
    county_name: "Northampton",
    county_weights: {
      42095: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 42095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18085,
    lat: 40.74174,
    lng: -75.25434,
    city: "Tatamy",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1170,
    density: 1212.7,
    county_fips: 42095,
    county_name: "Northampton",
    county_weights: {
      42095: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 42095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18086,
    lat: 40.73867,
    lng: -75.54757,
    city: "Treichlers",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 725,
    density: 1957.5,
    county_fips: 42095,
    county_name: "Northampton",
    county_weights: {
      42095: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 42095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18087,
    lat: 40.55398,
    lng: -75.59588,
    city: "Trexlertown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 779,
    density: 284.1,
    county_fips: 42077,
    county_name: "Lehigh",
    county_weights: {
      42077: 100,
    },
    county_names_all: "Lehigh",
    county_fips_all: 42077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18088,
    lat: 40.76578,
    lng: -75.5576,
    city: "Walnutport",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8342,
    density: 169.1,
    county_fips: 42095,
    county_name: "Northampton",
    county_weights: {
      42095: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 42095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18091,
    lat: 40.82656,
    lng: -75.32068,
    city: "Wind Gap",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6155,
    density: 160.1,
    county_fips: 42095,
    county_name: "Northampton",
    county_weights: {
      42095: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 42095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18092,
    lat: 40.46844,
    lng: -75.51372,
    city: "Zionsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3617,
    density: 93,
    county_fips: 42077,
    county_name: "Lehigh",
    county_weights: {
      42011: 7.56,
      42077: 92.44,
    },
    county_names_all: "Lehigh|Berks",
    county_fips_all: "42077|42011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18101,
    lat: 40.60301,
    lng: -75.4698,
    city: "Allentown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4738,
    density: 5957,
    county_fips: 42077,
    county_name: "Lehigh",
    county_weights: {
      42077: 100,
    },
    county_names_all: "Lehigh",
    county_fips_all: 42077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18102,
    lat: 40.60792,
    lng: -75.47613,
    city: "Allentown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50702,
    density: 6567.7,
    county_fips: 42077,
    county_name: "Lehigh",
    county_weights: {
      42077: 100,
    },
    county_names_all: "Lehigh",
    county_fips_all: 42077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18103,
    lat: 40.57223,
    lng: -75.48138,
    city: "Allentown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46884,
    density: 1055,
    county_fips: 42077,
    county_name: "Lehigh",
    county_weights: {
      42077: 100,
    },
    county_names_all: "Lehigh",
    county_fips_all: 42077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18104,
    lat: 40.61122,
    lng: -75.54699,
    city: "Allentown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44217,
    density: 743.8,
    county_fips: 42077,
    county_name: "Lehigh",
    county_weights: {
      42077: 100,
    },
    county_names_all: "Lehigh",
    county_fips_all: 42077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18106,
    lat: 40.57472,
    lng: -75.59542,
    city: "Allentown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6890,
    density: 334.3,
    county_fips: 42077,
    county_name: "Lehigh",
    county_weights: {
      42077: 100,
    },
    county_names_all: "Lehigh",
    county_fips_all: 42077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18109,
    lat: 40.63673,
    lng: -75.44043,
    city: "Allentown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17425,
    density: 815.7,
    county_fips: 42077,
    county_name: "Lehigh",
    county_weights: {
      42077: 94.98,
      42095: 5.02,
    },
    county_names_all: "Lehigh|Northampton",
    county_fips_all: "42077|42095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18195,
    lat: 40.58427,
    lng: -75.62479,
    city: "Allentown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 42077,
    county_name: "Lehigh",
    county_weights: {
      42077: 100,
    },
    county_names_all: "Lehigh",
    county_fips_all: 42077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18201,
    lat: 40.95198,
    lng: -75.95395,
    city: "Hazleton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26978,
    density: 596.3,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42025: 2.41,
      42079: 97.59,
    },
    county_names_all: "Luzerne|Carbon",
    county_fips_all: "42079|42025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18202,
    lat: 40.94874,
    lng: -76.0483,
    city: "Hazleton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11527,
    density: 127,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 88.76,
      42107: 11.24,
    },
    county_names_all: "Luzerne|Schuylkill",
    county_fips_all: "42079|42107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18210,
    lat: 41.00057,
    lng: -75.59146,
    city: "Albrightsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7504,
    density: 80.9,
    county_fips: 42025,
    county_name: "Carbon",
    county_weights: {
      42025: 93.47,
      42089: 6.53,
    },
    county_names_all: "Carbon|Monroe",
    county_fips_all: "42025|42089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18211,
    lat: 40.74315,
    lng: -75.82314,
    city: "Andreas",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1077,
    density: 20.6,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42025: 3.73,
      42107: 96.27,
    },
    county_names_all: "Schuylkill|Carbon",
    county_fips_all: "42107|42025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18212,
    lat: 40.77292,
    lng: -75.71883,
    city: "Ashfield",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 86,
    density: 44.5,
    county_fips: 42025,
    county_name: "Carbon",
    county_weights: {
      42025: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 42025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18214,
    lat: 40.80667,
    lng: -76.08093,
    city: "Barnesville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1720,
    density: 21.9,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18216,
    lat: 40.94212,
    lng: -75.90517,
    city: "Beaver Meadows",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1106,
    density: 57,
    county_fips: 42025,
    county_name: "Carbon",
    county_weights: {
      42025: 71.98,
      42079: 28.02,
    },
    county_names_all: "Carbon|Luzerne",
    county_fips_all: "42025|42079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18218,
    lat: 40.81974,
    lng: -75.91611,
    city: "Coaldale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2164,
    density: 384.1,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18219,
    lat: 40.99105,
    lng: -76.05824,
    city: "Conyngham",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1340,
    density: 640,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18220,
    lat: 40.83958,
    lng: -76.07509,
    city: "Delano",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 221,
    density: 67.3,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18221,
    lat: 41.00152,
    lng: -75.919,
    city: "Drifton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 611,
    density: 110.5,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18222,
    lat: 41.03569,
    lng: -76.00097,
    city: "Drums",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9926,
    density: 104,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18223,
    lat: 40.98221,
    lng: -75.95011,
    city: "Ebervale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 152,
    density: 48.5,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18224,
    lat: 41.02499,
    lng: -75.88728,
    city: "Freeland",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6113,
    density: 165.4,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18225,
    lat: 40.98137,
    lng: -75.97111,
    city: "Harleigh",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18229,
    lat: 40.93245,
    lng: -75.68247,
    city: "Jim Thorpe",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9038,
    density: 63.1,
    county_fips: 42025,
    county_name: "Carbon",
    county_weights: {
      42025: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 42025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18230,
    lat: 40.9201,
    lng: -75.93077,
    city: "Junedale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 91,
    density: 17,
    county_fips: 42025,
    county_name: "Carbon",
    county_weights: {
      42025: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 42025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18231,
    lat: 40.90068,
    lng: -76.00446,
    city: "Kelayres",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 429,
    density: 1446.5,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18232,
    lat: 40.83515,
    lng: -75.87939,
    city: "Lansford",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3761,
    density: 700.7,
    county_fips: 42025,
    county_name: "Carbon",
    county_weights: {
      42025: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 42025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18234,
    lat: 40.99259,
    lng: -75.96468,
    city: "Lattimer Mines",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 404,
    density: 616.1,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18235,
    lat: 40.83603,
    lng: -75.692,
    city: "Lehighton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18904,
    density: 84,
    county_fips: 42025,
    county_name: "Carbon",
    county_weights: {
      42025: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 42025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18237,
    lat: 40.88591,
    lng: -76.02582,
    city: "Mcadoo",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3725,
    density: 81.5,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42025: 5.75,
      42107: 94.25,
    },
    county_names_all: "Schuylkill|Carbon",
    county_fips_all: "42107|42025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18239,
    lat: 40.98962,
    lng: -75.98154,
    city: "Milnesville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 210,
    density: 2710.9,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18240,
    lat: 40.86279,
    lng: -75.84727,
    city: "Nesquehoning",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3806,
    density: 60.6,
    county_fips: 42025,
    county_name: "Carbon",
    county_weights: {
      42025: 86.19,
      42107: 13.81,
    },
    county_names_all: "Carbon|Schuylkill",
    county_fips_all: "42025|42107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18241,
    lat: 40.94439,
    lng: -76.16492,
    city: "Nuremberg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 587,
    density: 214.8,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 96.99,
      42107: 3.01,
    },
    county_names_all: "Luzerne|Schuylkill",
    county_fips_all: "42079|42107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18242,
    lat: 40.90606,
    lng: -76.12349,
    city: "Oneida",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 372,
    density: 649.7,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18244,
    lat: 40.82361,
    lng: -75.66879,
    city: "Parryville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 287,
    density: 105.9,
    county_fips: 42025,
    county_name: "Carbon",
    county_weights: {
      42025: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 42025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18245,
    lat: 40.8528,
    lng: -76.03011,
    city: "Quakake",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 242,
    density: 39.1,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18246,
    lat: 40.95743,
    lng: -76.195,
    city: "Rock Glen",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 334,
    density: 59.1,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18248,
    lat: 40.90089,
    lng: -76.09448,
    city: "Sheppton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 634,
    density: 55.2,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18249,
    lat: 40.98457,
    lng: -76.1206,
    city: "Sugarloaf",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3676,
    density: 43,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18250,
    lat: 40.81744,
    lng: -75.86145,
    city: "Summit Hill",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2981,
    density: 109.9,
    county_fips: 42025,
    county_name: "Carbon",
    county_weights: {
      42025: 77.5,
      42107: 22.5,
    },
    county_names_all: "Carbon|Schuylkill",
    county_fips_all: "42025|42107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18252,
    lat: 40.77857,
    lng: -75.97893,
    city: "Tamaqua",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10720,
    density: 60.9,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18254,
    lat: 40.91594,
    lng: -75.96563,
    city: "Tresckow",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1175,
    density: 257,
    county_fips: 42025,
    county_name: "Carbon",
    county_weights: {
      42025: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 42025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18255,
    lat: 40.93308,
    lng: -75.82996,
    city: "Weatherly",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4411,
    density: 23.6,
    county_fips: 42025,
    county_name: "Carbon",
    county_weights: {
      42025: 88.74,
      42079: 11.26,
    },
    county_names_all: "Carbon|Luzerne",
    county_fips_all: "42025|42079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18256,
    lat: 40.94044,
    lng: -76.14752,
    city: "Weston",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 368,
    density: 364.7,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18301,
    lat: 41.03141,
    lng: -75.18316,
    city: "East Stroudsburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29694,
    density: 300.9,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42089: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 42089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18302,
    lat: 41.09243,
    lng: -75.11783,
    city: "East Stroudsburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17499,
    density: 108.3,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42089: 99.2,
      42103: 0.8,
    },
    county_names_all: "Monroe|Pike",
    county_fips_all: "42089|42103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18321,
    lat: 41.01734,
    lng: -75.28754,
    city: "Bartonsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1642,
    density: 209.4,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42089: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 42089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18322,
    lat: 40.9221,
    lng: -75.39714,
    city: "Brodheadsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3020,
    density: 168.4,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42089: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 42089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18323,
    lat: 41.19558,
    lng: -75.27264,
    city: "Buck Hill Falls",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 95,
    density: 18.5,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42089: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 42089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18324,
    lat: 41.14712,
    lng: -75.0001,
    city: "Bushkill",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9249,
    density: 112.1,
    county_fips: 42103,
    county_name: "Pike",
    county_weights: {
      42089: 0.55,
      42103: 99.45,
    },
    county_names_all: "Pike|Monroe",
    county_fips_all: "42103|42089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18325,
    lat: 41.22545,
    lng: -75.22268,
    city: "Canadensis",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2684,
    density: 24.1,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42089: 72.53,
      42103: 27.47,
    },
    county_names_all: "Monroe|Pike",
    county_fips_all: "42089|42103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18326,
    lat: 41.15617,
    lng: -75.25186,
    city: "Cresco",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3041,
    density: 35.1,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42089: 97.18,
      42103: 2.82,
    },
    county_names_all: "Monroe|Pike",
    county_fips_all: "42089|42103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18327,
    lat: 40.98341,
    lng: -75.14665,
    city: "Delaware Water Gap",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 577,
    density: 398,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42089: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 42089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18328,
    lat: 41.22531,
    lng: -75.00633,
    city: "Dingmans Ferry",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7466,
    density: 25.7,
    county_fips: 42103,
    county_name: "Pike",
    county_weights: {
      42103: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 42103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18330,
    lat: 40.96505,
    lng: -75.45285,
    city: "Effort",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8635,
    density: 230.5,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42089: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 42089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18331,
    lat: 40.90878,
    lng: -75.44076,
    city: "Gilbert",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 628,
    density: 92.3,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42089: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 42089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18332,
    lat: 41.0922,
    lng: -75.25968,
    city: "Henryville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3309,
    density: 88.6,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42089: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 42089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18333,
    lat: 40.89833,
    lng: -75.49104,
    city: "Kresgeville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 729,
    density: 214.7,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42089: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 42089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18334,
    lat: 41.07208,
    lng: -75.44298,
    city: "Long Pond",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4471,
    density: 72.1,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42089: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 42089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18335,
    lat: 41.06413,
    lng: -75.10455,
    city: "Marshalls Creek",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 788,
    density: 207.2,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42089: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 42089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18336,
    lat: 41.37566,
    lng: -74.73674,
    city: "Matamoras",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3800,
    density: 127.5,
    county_fips: 42103,
    county_name: "Pike",
    county_weights: {
      42103: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 42103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18337,
    lat: 41.33406,
    lng: -74.87342,
    city: "Milford",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14192,
    density: 76.4,
    county_fips: 42103,
    county_name: "Pike",
    county_weights: {
      42103: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 42103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18340,
    lat: 41.42027,
    lng: -74.77503,
    city: "Millrift",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 211,
    density: 18.9,
    county_fips: 42103,
    county_name: "Pike",
    county_weights: {
      42103: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 42103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18342,
    lat: 41.17045,
    lng: -75.30485,
    city: "Mountainhome",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42089: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 42089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18343,
    lat: 40.89043,
    lng: -75.1058,
    city: "Mount Bethel",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4010,
    density: 76,
    county_fips: 42095,
    county_name: "Northampton",
    county_weights: {
      42095: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 42095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18344,
    lat: 41.11735,
    lng: -75.34442,
    city: "Mount Pocono",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3780,
    density: 186.3,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42089: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 42089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18346,
    lat: 41.14643,
    lng: -75.42752,
    city: "Pocono Summit",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2322,
    density: 49.9,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42089: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 42089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18347,
    lat: 41.15116,
    lng: -75.53664,
    city: "Pocono Lake",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2932,
    density: 22.7,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42089: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 42089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18349,
    lat: 41.0995,
    lng: -75.3682,
    city: "Pocono Manor",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 228,
    density: 102.1,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42089: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 42089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18350,
    lat: 41.11339,
    lng: -75.45633,
    city: "Pocono Pines",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 927,
    density: 61.3,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42089: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 42089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18351,
    lat: 40.92321,
    lng: -75.10063,
    city: "Portland",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 549,
    density: 637.7,
    county_fips: 42095,
    county_name: "Northampton",
    county_weights: {
      42095: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 42095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18353,
    lat: 40.89848,
    lng: -75.36953,
    city: "Saylorsburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12806,
    density: 111.4,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42089: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 42089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18354,
    lat: 40.92561,
    lng: -75.32831,
    city: "Sciota",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1201,
    density: 127.2,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42089: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 42089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18355,
    lat: 41.07301,
    lng: -75.35553,
    city: "Scotrun",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1163,
    density: 42.8,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42089: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 42089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18356,
    lat: 41.01574,
    lng: -75.11192,
    city: "Shawnee On Delaware",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58,
    density: 24.7,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42089: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 42089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18357,
    lat: 41.22956,
    lng: -75.2191,
    city: "Skytop",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 107,
    density: 8.2,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42089: 99.74,
      42103: 0.26,
    },
    county_names_all: "Monroe|Pike",
    county_fips_all: "42089|42103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18360,
    lat: 40.97254,
    lng: -75.28562,
    city: "Stroudsburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27759,
    density: 123.9,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42089: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 42089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18370,
    lat: 41.08926,
    lng: -75.33771,
    city: "Swiftwater",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1600,
    density: 281.1,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42089: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 42089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18371,
    lat: 41.15837,
    lng: -75.03658,
    city: "Tamiment",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 670,
    density: 33.3,
    county_fips: 42103,
    county_name: "Pike",
    county_weights: {
      42103: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 42103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18372,
    lat: 41.04777,
    lng: -75.32512,
    city: "Tannersville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2926,
    density: 146.8,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42089: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 42089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18403,
    lat: 41.50495,
    lng: -75.53529,
    city: "Archbald",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6768,
    density: 135.8,
    county_fips: 42069,
    county_name: "Lackawanna",
    county_weights: {
      42069: 100,
    },
    county_names_all: "Lackawanna",
    county_fips_all: 42069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18405,
    lat: 41.59792,
    lng: -75.09509,
    city: "Beach Lake",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2712,
    density: 30.5,
    county_fips: 42127,
    county_name: "Wayne",
    county_weights: {
      42103: 23.95,
      42127: 76.05,
    },
    county_names_all: "Wayne|Pike",
    county_fips_all: "42127|42103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18407,
    lat: 41.59971,
    lng: -75.53026,
    city: "Carbondale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13629,
    density: 126.8,
    county_fips: 42069,
    county_name: "Lackawanna",
    county_weights: {
      42069: 92.53,
      42115: 7.47,
    },
    county_names_all: "Lackawanna|Susquehanna",
    county_fips_all: "42069|42115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18411,
    lat: 41.45655,
    lng: -75.74295,
    city: "Clarks Summit",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21312,
    density: 148.6,
    county_fips: 42069,
    county_name: "Lackawanna",
    county_weights: {
      42069: 100,
    },
    county_names_all: "Lackawanna",
    county_fips_all: 42069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18413,
    lat: 41.64767,
    lng: -75.53258,
    city: "Clifford",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42115,
    county_name: "Susquehanna",
    county_weights: {
      42115: 100,
    },
    county_names_all: "Susquehanna",
    county_fips_all: 42115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18414,
    lat: 41.53893,
    lng: -75.7427,
    city: "Dalton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5461,
    density: 51.8,
    county_fips: 42069,
    county_name: "Lackawanna",
    county_weights: {
      42069: 70.2,
      42131: 29.8,
    },
    county_names_all: "Lackawanna|Wyoming",
    county_fips_all: "42069|42131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18415,
    lat: 41.74821,
    lng: -75.11315,
    city: "Damascus",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1491,
    density: 16.8,
    county_fips: 42127,
    county_name: "Wayne",
    county_weights: {
      42127: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 42127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18417,
    lat: 41.80705,
    lng: -75.20122,
    city: "Equinunk",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1014,
    density: 7.1,
    county_fips: 42127,
    county_name: "Wayne",
    county_weights: {
      42127: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 42127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18419,
    lat: 41.57858,
    lng: -75.7994,
    city: "Factoryville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4632,
    density: 46.7,
    county_fips: 42131,
    county_name: "Wyoming",
    county_weights: {
      42069: 33.02,
      42115: 3.09,
      42131: 63.89,
    },
    county_names_all: "Wyoming|Lackawanna|Susquehanna",
    county_fips_all: "42131|42069|42115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18420,
    lat: 41.60333,
    lng: -75.70589,
    city: "Fleetville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41,
    density: 9.8,
    county_fips: 42069,
    county_name: "Lackawanna",
    county_weights: {
      42069: 100,
    },
    county_names_all: "Lackawanna",
    county_fips_all: 42069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18421,
    lat: 41.66337,
    lng: -75.4691,
    city: "Forest City",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4289,
    density: 44.4,
    county_fips: 42115,
    county_name: "Susquehanna",
    county_weights: {
      42069: 7.87,
      42115: 46.86,
      42127: 45.27,
    },
    county_names_all: "Susquehanna|Wayne|Lackawanna",
    county_fips_all: "42115|42127|42069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18424,
    lat: 41.24267,
    lng: -75.52234,
    city: "Gouldsboro",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5148,
    density: 24.5,
    county_fips: 42069,
    county_name: "Lackawanna",
    county_weights: {
      42069: 68.49,
      42079: 1.74,
      42089: 10.02,
      42127: 19.75,
    },
    county_names_all: "Lackawanna|Wayne|Monroe|Luzerne",
    county_fips_all: "42069|42127|42089|42079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18425,
    lat: 41.42263,
    lng: -75.02206,
    city: "Greeley",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1059,
    density: 17.5,
    county_fips: 42103,
    county_name: "Pike",
    county_weights: {
      42103: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 42103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18426,
    lat: 41.32774,
    lng: -75.23577,
    city: "Greentown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4091,
    density: 30.3,
    county_fips: 42103,
    county_name: "Pike",
    county_weights: {
      42103: 99.62,
      42127: 0.38,
    },
    county_names_all: "Pike|Wayne",
    county_fips_all: "42103|42127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18428,
    lat: 41.42946,
    lng: -75.1253,
    city: "Hawley",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11668,
    density: 29.8,
    county_fips: 42103,
    county_name: "Pike",
    county_weights: {
      42103: 75.43,
      42127: 24.57,
    },
    county_names_all: "Pike|Wayne",
    county_fips_all: "42103|42127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18430,
    lat: 41.7428,
    lng: -75.47779,
    city: "Herrick Center",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 42115,
    county_name: "Susquehanna",
    county_weights: {
      42115: 100,
    },
    county_names_all: "Susquehanna",
    county_fips_all: 42115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18431,
    lat: 41.62214,
    lng: -75.25531,
    city: "Honesdale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12133,
    density: 34.8,
    county_fips: 42127,
    county_name: "Wayne",
    county_weights: {
      42127: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 42127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18433,
    lat: 41.57107,
    lng: -75.58452,
    city: "Jermyn",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6128,
    density: 82.3,
    county_fips: 42069,
    county_name: "Lackawanna",
    county_weights: {
      42069: 100,
    },
    county_names_all: "Lackawanna",
    county_fips_all: 42069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18434,
    lat: 41.46014,
    lng: -75.54823,
    city: "Jessup",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3772,
    density: 238.6,
    county_fips: 42069,
    county_name: "Lackawanna",
    county_weights: {
      42069: 100,
    },
    county_names_all: "Lackawanna",
    county_fips_all: 42069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18435,
    lat: 41.49221,
    lng: -75.00661,
    city: "Lackawaxen",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 878,
    density: 27.1,
    county_fips: 42103,
    county_name: "Pike",
    county_weights: {
      42103: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 42103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18436,
    lat: 41.43867,
    lng: -75.3959,
    city: "Lake Ariel",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12960,
    density: 50.6,
    county_fips: 42127,
    county_name: "Wayne",
    county_weights: {
      42069: 26.44,
      42127: 73.56,
    },
    county_names_all: "Wayne|Lackawanna",
    county_fips_all: "42127|42069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18437,
    lat: 41.86859,
    lng: -75.30345,
    city: "Lake Como",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 214,
    density: 7.6,
    county_fips: 42127,
    county_name: "Wayne",
    county_weights: {
      42127: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 42127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18438,
    lat: 41.43591,
    lng: -75.24499,
    city: "Lakeville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1148,
    density: 53.8,
    county_fips: 42127,
    county_name: "Wayne",
    county_weights: {
      42127: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 42127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18439,
    lat: 41.82674,
    lng: -75.34735,
    city: "Lakewood",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 526,
    density: 7.2,
    county_fips: 42127,
    county_name: "Wayne",
    county_weights: {
      42127: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 42127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18440,
    lat: 41.55931,
    lng: -75.76505,
    city: "La Plume",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42069,
    county_name: "Lackawanna",
    county_weights: {
      42069: 100,
    },
    county_names_all: "Lackawanna",
    county_fips_all: 42069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18441,
    lat: 41.65833,
    lng: -75.62565,
    city: "Lenoxville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 385,
    density: 52.5,
    county_fips: 42115,
    county_name: "Susquehanna",
    county_weights: {
      42115: 100,
    },
    county_names_all: "Susquehanna",
    county_fips_all: 42115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18443,
    lat: 41.66262,
    lng: -75.11059,
    city: "Milanville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 269,
    density: 7.9,
    county_fips: 42127,
    county_name: "Wayne",
    county_weights: {
      42127: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 42127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18444,
    lat: 41.33912,
    lng: -75.54667,
    city: "Moscow",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13938,
    density: 51.2,
    county_fips: 42069,
    county_name: "Lackawanna",
    county_weights: {
      42069: 86.18,
      42127: 13.82,
    },
    county_names_all: "Lackawanna|Wayne",
    county_fips_all: "42069|42127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18445,
    lat: 41.2948,
    lng: -75.34751,
    city: "Newfoundland",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2493,
    density: 29.4,
    county_fips: 42127,
    county_name: "Wayne",
    county_weights: {
      42103: 32.51,
      42127: 67.49,
    },
    county_names_all: "Wayne|Pike",
    county_fips_all: "42127|42103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18446,
    lat: 41.64513,
    lng: -75.76044,
    city: "Nicholson",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3048,
    density: 21.1,
    county_fips: 42115,
    county_name: "Susquehanna",
    county_weights: {
      42069: 8.06,
      42115: 56.3,
      42131: 35.64,
    },
    county_names_all: "Susquehanna|Wyoming|Lackawanna",
    county_fips_all: "42115|42131|42069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18447,
    lat: 41.5132,
    lng: -75.61684,
    city: "Olyphant",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10503,
    density: 203.7,
    county_fips: 42069,
    county_name: "Lackawanna",
    county_weights: {
      42069: 100,
    },
    county_names_all: "Lackawanna",
    county_fips_all: 42069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18451,
    lat: 41.39849,
    lng: -75.22023,
    city: "Paupack",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 739,
    density: 66.2,
    county_fips: 42103,
    county_name: "Pike",
    county_weights: {
      42103: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 42103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18452,
    lat: 41.48387,
    lng: -75.58951,
    city: "Peckville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4909,
    density: 1008.3,
    county_fips: 42069,
    county_name: "Lackawanna",
    county_weights: {
      42069: 100,
    },
    county_names_all: "Lackawanna",
    county_fips_all: 42069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18453,
    lat: 41.74971,
    lng: -75.361,
    city: "Pleasant Mount",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1073,
    density: 8.2,
    county_fips: 42127,
    county_name: "Wayne",
    county_weights: {
      42127: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 42127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18454,
    lat: 41.81963,
    lng: -75.42731,
    city: "Poyntelle",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65,
    density: 6.1,
    county_fips: 42127,
    county_name: "Wayne",
    county_weights: {
      42127: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 42127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18455,
    lat: 41.88467,
    lng: -75.35541,
    city: "Preston Park",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 134,
    density: 10.5,
    county_fips: 42127,
    county_name: "Wayne",
    county_weights: {
      42127: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 42127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18456,
    lat: 41.61843,
    lng: -75.3404,
    city: "Prompton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 474,
    density: 39.8,
    county_fips: 42127,
    county_name: "Wayne",
    county_weights: {
      42127: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 42127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18457,
    lat: 41.4696,
    lng: -75.05084,
    city: "Rowland",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 140,
    density: 83.7,
    county_fips: 42103,
    county_name: "Pike",
    county_weights: {
      42103: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 42103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18458,
    lat: 41.40916,
    lng: -74.91757,
    city: "Shohola",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2968,
    density: 20.8,
    county_fips: 42103,
    county_name: "Pike",
    county_weights: {
      42103: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 42103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18460,
    lat: 41.26719,
    lng: -75.34744,
    city: "South Sterling",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 89,
    density: 22.5,
    county_fips: 42127,
    county_name: "Wayne",
    county_weights: {
      42103: 0.13,
      42127: 99.87,
    },
    county_names_all: "Wayne|Pike",
    county_fips_all: "42127|42103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18461,
    lat: 41.92774,
    lng: -75.32434,
    city: "Starlight",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 269,
    density: 5.4,
    county_fips: 42127,
    county_name: "Wayne",
    county_weights: {
      42127: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 42127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18462,
    lat: 41.9049,
    lng: -75.42988,
    city: "Starrucca",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 414,
    density: 4.8,
    county_fips: 42127,
    county_name: "Wayne",
    county_weights: {
      42115: 14.85,
      42127: 85.15,
    },
    county_names_all: "Wayne|Susquehanna",
    county_fips_all: "42127|42115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18463,
    lat: 41.34825,
    lng: -75.37964,
    city: "Sterling",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 286,
    density: 43.8,
    county_fips: 42127,
    county_name: "Wayne",
    county_weights: {
      42127: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 42127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18464,
    lat: 41.40181,
    lng: -75.17824,
    city: "Tafton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1291,
    density: 43,
    county_fips: 42103,
    county_name: "Pike",
    county_weights: {
      42103: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 42103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18465,
    lat: 41.83654,
    lng: -75.51811,
    city: "Thompson",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1208,
    density: 9.4,
    county_fips: 42115,
    county_name: "Susquehanna",
    county_weights: {
      42115: 84.52,
      42127: 15.48,
    },
    county_names_all: "Susquehanna|Wayne",
    county_fips_all: "42115|42127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18466,
    lat: 41.19709,
    lng: -75.37796,
    city: "Tobyhanna",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17531,
    density: 193.2,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42089: 97.74,
      42127: 2.26,
    },
    county_names_all: "Monroe|Wayne",
    county_fips_all: "42089|42127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18469,
    lat: 41.70352,
    lng: -75.14597,
    city: "Tyler Hill",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 279,
    density: 9.7,
    county_fips: 42127,
    county_name: "Wayne",
    county_weights: {
      42127: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 42127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18470,
    lat: 41.732,
    lng: -75.53502,
    city: "Union Dale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1976,
    density: 11.7,
    county_fips: 42115,
    county_name: "Susquehanna",
    county_weights: {
      42115: 81.49,
      42127: 18.51,
    },
    county_names_all: "Susquehanna|Wayne",
    county_fips_all: "42115|42127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18471,
    lat: 41.5291,
    lng: -75.69807,
    city: "Waverly",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 722,
    density: 138.5,
    county_fips: 42069,
    county_name: "Lackawanna",
    county_weights: {
      42069: 100,
    },
    county_names_all: "Lackawanna",
    county_fips_all: 42069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18472,
    lat: 41.58738,
    lng: -75.40002,
    city: "Waymart",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7203,
    density: 44.8,
    county_fips: 42127,
    county_name: "Wayne",
    county_weights: {
      42127: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 42127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18473,
    lat: 41.52828,
    lng: -75.20821,
    city: "White Mills",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 501,
    density: 248.7,
    county_fips: 42127,
    county_name: "Wayne",
    county_weights: {
      42127: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 42127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18503,
    lat: 41.41007,
    lng: -75.66767,
    city: "Scranton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1197,
    density: 975.3,
    county_fips: 42069,
    county_name: "Lackawanna",
    county_weights: {
      42069: 100,
    },
    county_names_all: "Lackawanna",
    county_fips_all: 42069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18504,
    lat: 41.42375,
    lng: -75.70581,
    city: "Scranton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20632,
    density: 778,
    county_fips: 42069,
    county_name: "Lackawanna",
    county_weights: {
      42069: 100,
    },
    county_names_all: "Lackawanna",
    county_fips_all: 42069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18505,
    lat: 41.38874,
    lng: -75.65109,
    city: "Scranton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21671,
    density: 948.6,
    county_fips: 42069,
    county_name: "Lackawanna",
    county_weights: {
      42069: 100,
    },
    county_names_all: "Lackawanna",
    county_fips_all: 42069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18507,
    lat: 41.35541,
    lng: -75.68016,
    city: "Moosic",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5159,
    density: 206.6,
    county_fips: 42069,
    county_name: "Lackawanna",
    county_weights: {
      42069: 100,
    },
    county_names_all: "Lackawanna",
    county_fips_all: 42069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18508,
    lat: 41.45503,
    lng: -75.65827,
    city: "Scranton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12368,
    density: 705.4,
    county_fips: 42069,
    county_name: "Lackawanna",
    county_weights: {
      42069: 100,
    },
    county_names_all: "Lackawanna",
    county_fips_all: 42069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18509,
    lat: 41.43062,
    lng: -75.64321,
    city: "Scranton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13786,
    density: 1799.8,
    county_fips: 42069,
    county_name: "Lackawanna",
    county_weights: {
      42069: 100,
    },
    county_names_all: "Lackawanna",
    county_fips_all: 42069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18510,
    lat: 41.40735,
    lng: -75.64376,
    city: "Scranton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13534,
    density: 2899.1,
    county_fips: 42069,
    county_name: "Lackawanna",
    county_weights: {
      42069: 100,
    },
    county_names_all: "Lackawanna",
    county_fips_all: 42069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18512,
    lat: 41.42648,
    lng: -75.5912,
    city: "Scranton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11550,
    density: 395.2,
    county_fips: 42069,
    county_name: "Lackawanna",
    county_weights: {
      42069: 100,
    },
    county_names_all: "Lackawanna",
    county_fips_all: 42069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18517,
    lat: 41.39524,
    lng: -75.71461,
    city: "Taylor",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4807,
    density: 446.6,
    county_fips: 42069,
    county_name: "Lackawanna",
    county_weights: {
      42069: 100,
    },
    county_names_all: "Lackawanna",
    county_fips_all: 42069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18518,
    lat: 41.37495,
    lng: -75.73963,
    city: "Old Forge",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7909,
    density: 754.7,
    county_fips: 42069,
    county_name: "Lackawanna",
    county_weights: {
      42069: 100,
    },
    county_names_all: "Lackawanna",
    county_fips_all: 42069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18519,
    lat: 41.46207,
    lng: -75.63062,
    city: "Scranton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4997,
    density: 796.5,
    county_fips: 42069,
    county_name: "Lackawanna",
    county_weights: {
      42069: 100,
    },
    county_names_all: "Lackawanna",
    county_fips_all: 42069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18602,
    lat: 41.18749,
    lng: -75.75526,
    city: "Bear Creek",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 342,
    density: 69.6,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18603,
    lat: 41.08506,
    lng: -76.24591,
    city: "Berwick",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19441,
    density: 140.6,
    county_fips: 42037,
    county_name: "Columbia",
    county_weights: {
      42037: 57.34,
      42079: 42.66,
    },
    county_names_all: "Columbia|Luzerne",
    county_fips_all: "42037|42079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18610,
    lat: 41.05959,
    lng: -75.53226,
    city: "Blakeslee",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5247,
    density: 61.2,
    county_fips: 42089,
    county_name: "Monroe",
    county_weights: {
      42079: 4.45,
      42089: 95.55,
    },
    county_names_all: "Monroe|Luzerne",
    county_fips_all: "42089|42079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18612,
    lat: 41.35025,
    lng: -75.98207,
    city: "Dallas",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18761,
    density: 132.9,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 89.28,
      42131: 10.72,
    },
    county_names_all: "Luzerne|Wyoming",
    county_fips_all: "42079|42131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18614,
    lat: 41.48373,
    lng: -76.35768,
    city: "Dushore",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1937,
    density: 4.9,
    county_fips: 42113,
    county_name: "Sullivan",
    county_weights: {
      42015: 1.56,
      42079: 0.1,
      42113: 75.94,
      42131: 22.4,
    },
    county_names_all: "Sullivan|Wyoming|Bradford|Luzerne",
    county_fips_all: "42113|42131|42015|42079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18615,
    lat: 41.45968,
    lng: -75.85752,
    city: "Falls",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1966,
    density: 42.9,
    county_fips: 42131,
    county_name: "Wyoming",
    county_weights: {
      42079: 7.35,
      42131: 92.65,
    },
    county_names_all: "Wyoming|Luzerne",
    county_fips_all: "42131|42079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18616,
    lat: 41.51907,
    lng: -76.63954,
    city: "Forksville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 734,
    density: 4.2,
    county_fips: 42113,
    county_name: "Sullivan",
    county_weights: {
      42015: 12.78,
      42113: 87.22,
    },
    county_names_all: "Sullivan|Bradford",
    county_fips_all: "42113|42015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18617,
    lat: 41.17149,
    lng: -76.07707,
    city: "Glen Lyon",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1813,
    density: 120.4,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18618,
    lat: 41.37883,
    lng: -76.0313,
    city: "Harveys Lake",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3684,
    density: 67.2,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 62.73,
      42131: 37.27,
    },
    county_names_all: "Luzerne|Wyoming",
    county_fips_all: "42079|42131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18619,
    lat: 41.43574,
    lng: -76.7195,
    city: "Hillsgrove",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 239,
    density: 3.7,
    county_fips: 42113,
    county_name: "Sullivan",
    county_weights: {
      42081: 18.42,
      42113: 81.58,
    },
    county_names_all: "Sullivan|Lycoming",
    county_fips_all: "42113|42081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18621,
    lat: 41.25441,
    lng: -76.09129,
    city: "Hunlock Creek",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6261,
    density: 53.8,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18622,
    lat: 41.20228,
    lng: -76.27348,
    city: "Huntington Mills",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 193,
    density: 22,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18623,
    lat: 41.67297,
    lng: -76.14768,
    city: "Laceyville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2559,
    density: 17.1,
    county_fips: 42015,
    county_name: "Bradford",
    county_weights: {
      42015: 44.81,
      42115: 18.44,
      42131: 36.75,
    },
    county_names_all: "Bradford|Wyoming|Susquehanna",
    county_fips_all: "42015|42131|42115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18624,
    lat: 41.05529,
    lng: -75.62088,
    city: "Lake Harmony",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 389,
    density: 8.2,
    county_fips: 42025,
    county_name: "Carbon",
    county_weights: {
      42025: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 42025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18625,
    lat: 41.51311,
    lng: -75.85027,
    city: "Lake Winola",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 437,
    density: 711.7,
    county_fips: 42131,
    county_name: "Wyoming",
    county_weights: {
      42131: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 42131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18626,
    lat: 41.41136,
    lng: -76.4635,
    city: "Laporte",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 519,
    density: 4.6,
    county_fips: 42113,
    county_name: "Sullivan",
    county_weights: {
      42113: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 42113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18627,
    lat: 41.31559,
    lng: -76.02235,
    city: "Lehman",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18628,
    lat: 41.41474,
    lng: -76.32047,
    city: "Lopez",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 199,
    density: 3.2,
    county_fips: 42113,
    county_name: "Sullivan",
    county_weights: {
      42113: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 42113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18629,
    lat: 41.52393,
    lng: -76.13365,
    city: "Mehoopany",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1838,
    density: 8.9,
    county_fips: 42131,
    county_name: "Wyoming",
    county_weights: {
      42131: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 42131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18630,
    lat: 41.66361,
    lng: -76.02698,
    city: "Meshoppen",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3086,
    density: 18.5,
    county_fips: 42115,
    county_name: "Susquehanna",
    county_weights: {
      42115: 63.75,
      42131: 36.25,
    },
    county_names_all: "Susquehanna|Wyoming",
    county_fips_all: "42115|42131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18631,
    lat: 41.03079,
    lng: -76.30233,
    city: "Mifflinville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 973,
    density: 264.1,
    county_fips: 42037,
    county_name: "Columbia",
    county_weights: {
      42037: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 42037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18632,
    lat: 41.46769,
    lng: -76.3764,
    city: "Mildred",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 655,
    density: 35.3,
    county_fips: 42113,
    county_name: "Sullivan",
    county_weights: {
      42113: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 42113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18634,
    lat: 41.18984,
    lng: -76.0218,
    city: "Nanticoke",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13212,
    density: 356.5,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18635,
    lat: 41.02961,
    lng: -76.20598,
    city: "Nescopeck",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3790,
    density: 38.7,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42037: 40.23,
      42079: 59.77,
    },
    county_names_all: "Luzerne|Columbia",
    county_fips_all: "42079|42037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18636,
    lat: 41.41215,
    lng: -76.08859,
    city: "Noxen",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1343,
    density: 13.8,
    county_fips: 42131,
    county_name: "Wyoming",
    county_weights: {
      42079: 11.71,
      42131: 88.29,
    },
    county_names_all: "Wyoming|Luzerne",
    county_fips_all: "42131|42079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18640,
    lat: 41.29724,
    lng: -75.74024,
    city: "Pittston",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16917,
    density: 233.9,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18641,
    lat: 41.33644,
    lng: -75.73007,
    city: "Pittston",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7010,
    density: 595.3,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42069: 20.2,
      42079: 79.8,
    },
    county_names_all: "Luzerne|Lackawanna",
    county_fips_all: "42079|42069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18642,
    lat: 41.35359,
    lng: -75.77681,
    city: "Duryea",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3862,
    density: 278.2,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18643,
    lat: 41.36456,
    lng: -75.8344,
    city: "Pittston",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13049,
    density: 275.7,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18644,
    lat: 41.33192,
    lng: -75.87753,
    city: "Wyoming",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7715,
    density: 189.1,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18651,
    lat: 41.24748,
    lng: -75.962,
    city: "Plymouth",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8987,
    density: 288,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18655,
    lat: 41.18327,
    lng: -76.19619,
    city: "Shickshinny",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5441,
    density: 29.4,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42037: 9.57,
      42079: 90.43,
    },
    county_names_all: "Luzerne|Columbia",
    county_fips_all: "42079|42037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18656,
    lat: 41.32703,
    lng: -76.20442,
    city: "Sweet Valley",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2472,
    density: 16,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18657,
    lat: 41.52712,
    lng: -75.95601,
    city: "Tunkhannock",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11575,
    density: 37.8,
    county_fips: 42131,
    county_name: "Wyoming",
    county_weights: {
      42131: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 42131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18660,
    lat: 41.10195,
    lng: -76.06196,
    city: "Wapwallopen",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3645,
    density: 30.5,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18661,
    lat: 41.08435,
    lng: -75.75666,
    city: "White Haven",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5055,
    density: 16.1,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42025: 32.67,
      42079: 67.33,
    },
    county_names_all: "Luzerne|Carbon",
    county_fips_all: "42079|42025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18701,
    lat: 41.2433,
    lng: -75.88523,
    city: "Wilkes Barre",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3459,
    density: 2663.1,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18702,
    lat: 41.21406,
    lng: -75.76925,
    city: "Wilkes Barre",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40105,
    density: 198.3,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18704,
    lat: 41.27676,
    lng: -75.89474,
    city: "Kingston",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30181,
    density: 1152,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18705,
    lat: 41.27156,
    lng: -75.84241,
    city: "Wilkes Barre",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14425,
    density: 1124,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18706,
    lat: 41.20432,
    lng: -75.91231,
    city: "Wilkes Barre",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15861,
    density: 233.2,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18707,
    lat: 41.13325,
    lng: -75.9228,
    city: "Mountain Top",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15891,
    density: 120.2,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18708,
    lat: 41.297,
    lng: -75.95927,
    city: "Shavertown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8056,
    density: 194.4,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18709,
    lat: 41.28635,
    lng: -75.89674,
    city: "Luzerne",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2892,
    density: 1469.1,
    county_fips: 42079,
    county_name: "Luzerne",
    county_weights: {
      42079: 100,
    },
    county_names_all: "Luzerne",
    county_fips_all: 42079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18801,
    lat: 41.82861,
    lng: -75.9437,
    city: "Montrose",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8254,
    density: 17.7,
    county_fips: 42115,
    county_name: "Susquehanna",
    county_weights: {
      42115: 100,
    },
    county_names_all: "Susquehanna",
    county_fips_all: 42115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18810,
    lat: 41.93738,
    lng: -76.50181,
    city: "Athens",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5707,
    density: 46.4,
    county_fips: 42015,
    county_name: "Bradford",
    county_weights: {
      42015: 100,
    },
    county_names_all: "Bradford",
    county_fips_all: 42015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18812,
    lat: 41.97203,
    lng: -75.96822,
    city: "Brackney",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1640,
    density: 21.8,
    county_fips: 42115,
    county_name: "Susquehanna",
    county_weights: {
      42115: 100,
    },
    county_names_all: "Susquehanna",
    county_fips_all: 42115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18814,
    lat: 41.78151,
    lng: -76.60121,
    city: "Burlington",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 205,
    density: 102,
    county_fips: 42015,
    county_name: "Bradford",
    county_weights: {
      42015: 100,
    },
    county_names_all: "Bradford",
    county_fips_all: 42015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18816,
    lat: 41.73977,
    lng: -75.90966,
    city: "Dimock",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 101,
    density: 32.4,
    county_fips: 42115,
    county_name: "Susquehanna",
    county_weights: {
      42115: 100,
    },
    county_names_all: "Susquehanna",
    county_fips_all: 42115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18817,
    lat: 41.87431,
    lng: -76.62075,
    city: "East Smithfield",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 305,
    density: 156.7,
    county_fips: 42015,
    county_name: "Bradford",
    county_weights: {
      42015: 100,
    },
    county_names_all: "Bradford",
    county_fips_all: 42015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18818,
    lat: 41.91343,
    lng: -76.04843,
    city: "Friendsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1178,
    density: 10.9,
    county_fips: 42115,
    county_name: "Susquehanna",
    county_weights: {
      42115: 100,
    },
    county_names_all: "Susquehanna",
    county_fips_all: 42115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18820,
    lat: 41.7779,
    lng: -75.65029,
    city: "Gibson",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42115,
    county_name: "Susquehanna",
    county_weights: {
      42115: 100,
    },
    county_names_all: "Susquehanna",
    county_fips_all: 42115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18821,
    lat: 41.98588,
    lng: -75.73466,
    city: "Great Bend",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1203,
    density: 122.8,
    county_fips: 42115,
    county_name: "Susquehanna",
    county_weights: {
      42115: 100,
    },
    county_names_all: "Susquehanna",
    county_fips_all: 42115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18822,
    lat: 41.9482,
    lng: -75.80116,
    city: "Hallstead",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3096,
    density: 27.5,
    county_fips: 42115,
    county_name: "Susquehanna",
    county_weights: {
      42115: 100,
    },
    county_names_all: "Susquehanna",
    county_fips_all: 42115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18823,
    lat: 41.77415,
    lng: -75.69168,
    city: "Harford",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 194,
    density: 61.2,
    county_fips: 42115,
    county_name: "Susquehanna",
    county_weights: {
      42115: 100,
    },
    county_names_all: "Susquehanna",
    county_fips_all: 42115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18824,
    lat: 41.70422,
    lng: -75.786,
    city: "Hop Bottom",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1487,
    density: 21,
    county_fips: 42115,
    county_name: "Susquehanna",
    county_weights: {
      42115: 100,
    },
    county_names_all: "Susquehanna",
    county_fips_all: 42115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18825,
    lat: 41.82276,
    lng: -75.599,
    city: "Jackson",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69,
    density: 7.2,
    county_fips: 42115,
    county_name: "Susquehanna",
    county_weights: {
      42115: 100,
    },
    county_names_all: "Susquehanna",
    county_fips_all: 42115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18826,
    lat: 41.7495,
    lng: -75.74276,
    city: "Kingsley",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1289,
    density: 10.8,
    county_fips: 42115,
    county_name: "Susquehanna",
    county_weights: {
      42115: 100,
    },
    county_names_all: "Susquehanna",
    county_fips_all: 42115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18828,
    lat: 41.79672,
    lng: -76.11245,
    city: "Lawton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 337,
    density: 18,
    county_fips: 42115,
    county_name: "Susquehanna",
    county_weights: {
      42115: 100,
    },
    county_names_all: "Susquehanna",
    county_fips_all: 42115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18829,
    lat: 41.8395,
    lng: -76.17088,
    city: "Le Raysville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 656,
    density: 10.3,
    county_fips: 42015,
    county_name: "Bradford",
    county_weights: {
      42015: 98.58,
      42115: 1.42,
    },
    county_names_all: "Bradford|Susquehanna",
    county_fips_all: "42015|42115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18830,
    lat: 41.95049,
    lng: -76.10904,
    city: "Little Meadows",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 566,
    density: 9.3,
    county_fips: 42115,
    county_name: "Susquehanna",
    county_weights: {
      42015: 6.3,
      42115: 93.7,
    },
    county_names_all: "Susquehanna|Bradford",
    county_fips_all: "42115|42015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18831,
    lat: 41.89356,
    lng: -76.60832,
    city: "Milan",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1023,
    density: 12.4,
    county_fips: 42015,
    county_name: "Bradford",
    county_weights: {
      42015: 100,
    },
    county_names_all: "Bradford",
    county_fips_all: 42015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18832,
    lat: 41.67625,
    lng: -76.55639,
    city: "Monroeton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1944,
    density: 12.7,
    county_fips: 42015,
    county_name: "Bradford",
    county_weights: {
      42015: 100,
    },
    county_names_all: "Bradford",
    county_fips_all: 42015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18833,
    lat: 41.59433,
    lng: -76.46515,
    city: "New Albany",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1902,
    density: 7.7,
    county_fips: 42015,
    county_name: "Bradford",
    county_weights: {
      42015: 92.24,
      42113: 7.76,
    },
    county_names_all: "Bradford|Sullivan",
    county_fips_all: "42015|42113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18834,
    lat: 41.84185,
    lng: -75.71189,
    city: "New Milford",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3508,
    density: 20.7,
    county_fips: 42115,
    county_name: "Susquehanna",
    county_weights: {
      42115: 100,
    },
    county_names_all: "Susquehanna",
    county_fips_all: 42115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18837,
    lat: 41.91928,
    lng: -76.29122,
    city: "Rome",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2899,
    density: 12.9,
    county_fips: 42015,
    county_name: "Bradford",
    county_weights: {
      42015: 100,
    },
    county_names_all: "Bradford",
    county_fips_all: 42015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18840,
    lat: 41.97433,
    lng: -76.52968,
    city: "Sayre",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10756,
    density: 100.8,
    county_fips: 42015,
    county_name: "Bradford",
    county_weights: {
      42015: 100,
    },
    county_names_all: "Bradford",
    county_fips_all: 42015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18842,
    lat: 41.75594,
    lng: -75.61652,
    city: "South Gibson",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 209,
    density: 18.8,
    county_fips: 42115,
    county_name: "Susquehanna",
    county_weights: {
      42115: 100,
    },
    county_names_all: "Susquehanna",
    county_fips_all: 42115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18843,
    lat: 41.80446,
    lng: -75.89416,
    city: "South Montrose",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 185,
    density: 51.1,
    county_fips: 42115,
    county_name: "Susquehanna",
    county_weights: {
      42115: 100,
    },
    county_names_all: "Susquehanna",
    county_fips_all: 42115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18844,
    lat: 41.69247,
    lng: -75.91351,
    city: "Springville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1944,
    density: 25.1,
    county_fips: 42115,
    county_name: "Susquehanna",
    county_weights: {
      42115: 98.91,
      42131: 1.09,
    },
    county_names_all: "Susquehanna|Wyoming",
    county_fips_all: "42115|42131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18845,
    lat: 41.78994,
    lng: -76.18454,
    city: "Stevensville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 345,
    density: 12.2,
    county_fips: 42015,
    county_name: "Bradford",
    county_weights: {
      42015: 100,
    },
    county_names_all: "Bradford",
    county_fips_all: 42015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18846,
    lat: 41.60494,
    lng: -76.23929,
    city: "Sugar Run",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 951,
    density: 16,
    county_fips: 42015,
    county_name: "Bradford",
    county_weights: {
      42015: 99.58,
      42131: 0.42,
    },
    county_names_all: "Bradford|Wyoming",
    county_fips_all: "42015|42131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18847,
    lat: 41.93539,
    lng: -75.56893,
    city: "Susquehanna",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6011,
    density: 17.9,
    county_fips: 42115,
    county_name: "Susquehanna",
    county_weights: {
      42115: 79.93,
      42127: 20.07,
    },
    county_names_all: "Susquehanna|Wayne",
    county_fips_all: "42115|42127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18848,
    lat: 41.75358,
    lng: -76.45615,
    city: "Towanda",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8703,
    density: 30.3,
    county_fips: 42015,
    county_name: "Bradford",
    county_weights: {
      42015: 100,
    },
    county_names_all: "Bradford",
    county_fips_all: 42015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18850,
    lat: 41.85916,
    lng: -76.49126,
    city: "Ulster",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1965,
    density: 12.2,
    county_fips: 42015,
    county_name: "Bradford",
    county_weights: {
      42015: 100,
    },
    county_names_all: "Bradford",
    county_fips_all: 42015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18851,
    lat: 41.93677,
    lng: -76.17992,
    city: "Warren Center",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 624,
    density: 8.9,
    county_fips: 42015,
    county_name: "Bradford",
    county_weights: {
      42015: 100,
    },
    county_names_all: "Bradford",
    county_fips_all: 42015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18853,
    lat: 41.71654,
    lng: -76.27534,
    city: "Wyalusing",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4332,
    density: 15.7,
    county_fips: 42015,
    county_name: "Bradford",
    county_weights: {
      42015: 100,
    },
    county_names_all: "Bradford",
    county_fips_all: 42015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18854,
    lat: 41.79532,
    lng: -76.35472,
    city: "Wysox",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1715,
    density: 28.5,
    county_fips: 42015,
    county_name: "Bradford",
    county_weights: {
      42015: 100,
    },
    county_names_all: "Bradford",
    county_fips_all: 42015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18901,
    lat: 40.30529,
    lng: -75.15026,
    city: "Doylestown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27875,
    density: 513.2,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18902,
    lat: 40.35474,
    lng: -75.09855,
    city: "Doylestown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21625,
    density: 308.4,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18912,
    lat: 40.32134,
    lng: -75.05852,
    city: "Buckingham",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10,
    density: 3.2,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18913,
    lat: 40.37727,
    lng: -75.0545,
    city: "Carversville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42,
    density: 11.2,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18914,
    lat: 40.28908,
    lng: -75.21046,
    city: "Chalfont",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21888,
    density: 480.1,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 98.61,
      42091: 1.39,
    },
    county_names_all: "Bucks|Montgomery",
    county_fips_all: "42017|42091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18915,
    lat: 40.27255,
    lng: -75.25628,
    city: "Colmar",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 744,
    density: 239.4,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18917,
    lat: 40.37088,
    lng: -75.202,
    city: "Dublin",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2110,
    density: 1087,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18920,
    lat: 40.49264,
    lng: -75.09067,
    city: "Erwinna",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 205,
    density: 20.5,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18921,
    lat: 40.52946,
    lng: -75.1738,
    city: "Ferndale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18923,
    lat: 40.3532,
    lng: -75.16798,
    city: "Fountainville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1235,
    density: 264.3,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18925,
    lat: 40.2851,
    lng: -75.05934,
    city: "Furlong",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6825,
    density: 266.2,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18927,
    lat: 40.31952,
    lng: -75.24514,
    city: "Hilltown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18929,
    lat: 40.25674,
    lng: -75.07885,
    city: "Jamison",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10136,
    density: 533.6,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18930,
    lat: 40.52926,
    lng: -75.2142,
    city: "Kintnersville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2454,
    density: 51,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18932,
    lat: 40.29457,
    lng: -75.25581,
    city: "Line Lexington",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 311,
    density: 92.2,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18933,
    lat: 40.40265,
    lng: -75.042,
    city: "Lumberville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18935,
    lat: 40.43444,
    lng: -75.39714,
    city: "Milford Square",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20,
    density: 36.7,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18936,
    lat: 40.22993,
    lng: -75.23154,
    city: "Montgomeryville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18938,
    lat: 40.35126,
    lng: -74.99779,
    city: "New Hope",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13560,
    density: 128,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18940,
    lat: 40.26349,
    lng: -74.9483,
    city: "Newtown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29164,
    density: 325.7,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18942,
    lat: 40.47167,
    lng: -75.16261,
    city: "Ottsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2805,
    density: 53.4,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18944,
    lat: 40.39252,
    lng: -75.23381,
    city: "Perkasie",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26301,
    density: 223.5,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18946,
    lat: 40.28923,
    lng: -75.01009,
    city: "Pineville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18947,
    lat: 40.42677,
    lng: -75.1138,
    city: "Pipersville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6356,
    density: 97.5,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18950,
    lat: 40.44709,
    lng: -75.06544,
    city: "Point Pleasant",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 204,
    density: 148.8,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18951,
    lat: 40.45294,
    lng: -75.33833,
    city: "Quakertown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35331,
    density: 190.3,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 99.57,
      42077: 0.43,
    },
    county_names_all: "Bucks|Lehigh",
    county_fips_all: "42017|42077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18954,
    lat: 40.2224,
    lng: -75.00032,
    city: "Richboro",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11456,
    density: 687.8,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18955,
    lat: 40.48469,
    lng: -75.3141,
    city: "Richlandtown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1414,
    density: 197.4,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18960,
    lat: 40.36376,
    lng: -75.32366,
    city: "Sellersville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11484,
    density: 232.8,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18962,
    lat: 40.34462,
    lng: -75.27033,
    city: "Silverdale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 361,
    density: 950.7,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18964,
    lat: 40.29759,
    lng: -75.33327,
    city: "Souderton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14307,
    density: 584.4,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42017: 11.48,
      42091: 88.52,
    },
    county_names_all: "Montgomery|Bucks",
    county_fips_all: "42091|42017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18966,
    lat: 40.1879,
    lng: -75.00557,
    city: "Southampton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35147,
    density: 832.3,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18969,
    lat: 40.32644,
    lng: -75.37239,
    city: "Telford",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14930,
    density: 351.7,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42017: 19.08,
      42091: 80.92,
    },
    county_names_all: "Montgomery|Bucks",
    county_fips_all: "42091|42017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18970,
    lat: 40.41212,
    lng: -75.38129,
    city: "Trumbauersville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 665,
    density: 624.4,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18972,
    lat: 40.53395,
    lng: -75.11997,
    city: "Upper Black Eddy",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3220,
    density: 53.8,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18974,
    lat: 40.21675,
    lng: -75.07321,
    city: "Warminster",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40405,
    density: 791.8,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18976,
    lat: 40.24676,
    lng: -75.14321,
    city: "Warrington",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20313,
    density: 735.3,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18977,
    lat: 40.28655,
    lng: -74.87865,
    city: "Washington Crossing",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4395,
    density: 386.5,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 18980,
    lat: 40.27276,
    lng: -75.01105,
    city: "Wycombe",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 438,
    density: 204.3,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19001,
    lat: 40.12624,
    lng: -75.12652,
    city: "Abington",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16871,
    density: 2035.8,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19002,
    lat: 40.18386,
    lng: -75.21104,
    city: "Ambler",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31166,
    density: 595.3,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19003,
    lat: 40.00217,
    lng: -75.29841,
    city: "Ardmore",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13641,
    density: 2613.7,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 53.91,
      42091: 46.09,
    },
    county_names_all: "Delaware|Montgomery",
    county_fips_all: "42045|42091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19004,
    lat: 40.01362,
    lng: -75.22979,
    city: "Bala Cynwyd",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9246,
    density: 1328.3,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19006,
    lat: 40.13323,
    lng: -75.06222,
    city: "Huntingdon Valley",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21897,
    density: 636.6,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42017: 8.99,
      42091: 91.01,
    },
    county_names_all: "Montgomery|Bucks",
    county_fips_all: "42091|42017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19007,
    lat: 40.11483,
    lng: -74.85474,
    city: "Bristol",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21443,
    density: 1107.7,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19008,
    lat: 39.97425,
    lng: -75.36107,
    city: "Broomall",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20240,
    density: 1195.4,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 42045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19009,
    lat: 40.13775,
    lng: -75.06308,
    city: "Bryn Athyn",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 885,
    density: 261.3,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19010,
    lat: 40.02362,
    lng: -75.3298,
    city: "Bryn Mawr",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21783,
    density: 995,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 55.17,
      42091: 44.83,
    },
    county_names_all: "Delaware|Montgomery",
    county_fips_all: "42045|42091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19012,
    lat: 40.05966,
    lng: -75.10586,
    city: "Cheltenham",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6749,
    density: 1490.2,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19013,
    lat: 39.84529,
    lng: -75.37474,
    city: "Chester",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35113,
    density: 2401.2,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 42045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19014,
    lat: 39.8637,
    lng: -75.4338,
    city: "Aston",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21012,
    density: 876.6,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 42045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19015,
    lat: 39.86811,
    lng: -75.39164,
    city: "Brookhaven",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16647,
    density: 2219.1,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 42045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19017,
    lat: 39.89078,
    lng: -75.46295,
    city: "Chester Heights",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 206,
    density: 159.8,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 42045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19018,
    lat: 39.92312,
    lng: -75.29834,
    city: "Clifton Heights",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23009,
    density: 3259.1,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 42045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19020,
    lat: 40.10453,
    lng: -74.93853,
    city: "Bensalem",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54850,
    density: 1226.4,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 99.86,
      42101: 0.14,
    },
    county_names_all: "Bucks|Philadelphia",
    county_fips_all: "42017|42101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19021,
    lat: 40.08874,
    lng: -74.89385,
    city: "Croydon",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9714,
    density: 1208.8,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19022,
    lat: 39.85862,
    lng: -75.33507,
    city: "Crum Lynne",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3986,
    density: 1177.9,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 42045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19023,
    lat: 39.91724,
    lng: -75.26708,
    city: "Darby",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22087,
    density: 4337,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 42045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19025,
    lat: 40.14556,
    lng: -75.1632,
    city: "Dresher",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6545,
    density: 783.4,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19026,
    lat: 39.95035,
    lng: -75.304,
    city: "Drexel Hill",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30357,
    density: 3221.5,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 42045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19027,
    lat: 40.07347,
    lng: -75.12453,
    city: "Elkins Park",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19216,
    density: 1886.4,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19029,
    lat: 39.86345,
    lng: -75.29271,
    city: "Essington",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4027,
    density: 715.7,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 42045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19030,
    lat: 40.1812,
    lng: -74.83269,
    city: "Fairless Hills",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11989,
    density: 916.2,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19031,
    lat: 40.1083,
    lng: -75.21747,
    city: "Flourtown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4390,
    density: 553.1,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19032,
    lat: 39.88907,
    lng: -75.277,
    city: "Folcroft",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6629,
    density: 2055.3,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 42045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19033,
    lat: 39.89077,
    lng: -75.32892,
    city: "Folsom",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8360,
    density: 2717.9,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 42045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19034,
    lat: 40.13353,
    lng: -75.20953,
    city: "Fort Washington",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6107,
    density: 331.1,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19035,
    lat: 40.04851,
    lng: -75.28126,
    city: "Gladwyne",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3936,
    density: 322.6,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19036,
    lat: 39.90368,
    lng: -75.29323,
    city: "Glenolden",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12984,
    density: 3215.8,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 42045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19038,
    lat: 40.10197,
    lng: -75.17214,
    city: "Glenside",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31615,
    density: 1488.7,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19040,
    lat: 40.17732,
    lng: -75.10624,
    city: "Hatboro",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22092,
    density: 1434.3,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42017: 1.22,
      42091: 98.78,
    },
    county_names_all: "Montgomery|Bucks",
    county_fips_all: "42091|42017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19041,
    lat: 40.00663,
    lng: -75.31747,
    city: "Haverford",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6277,
    density: 738.8,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 67.53,
      42091: 32.47,
    },
    county_names_all: "Delaware|Montgomery",
    county_fips_all: "42045|42091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19043,
    lat: 39.90042,
    lng: -75.30891,
    city: "Holmes",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2828,
    density: 2731.1,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 42045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19044,
    lat: 40.18901,
    lng: -75.15253,
    city: "Horsham",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16216,
    density: 695.4,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19046,
    lat: 40.10133,
    lng: -75.10558,
    city: "Jenkintown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17961,
    density: 1037.8,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19047,
    lat: 40.18207,
    lng: -74.91062,
    city: "Langhorne",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33199,
    density: 743.1,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19050,
    lat: 39.93764,
    lng: -75.26355,
    city: "Lansdowne",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27485,
    density: 2899,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 99.74,
      42101: 0.26,
    },
    county_names_all: "Delaware|Philadelphia",
    county_fips_all: "42045|42101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19052,
    lat: 39.89721,
    lng: -75.44532,
    city: "Lenni",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 42045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19053,
    lat: 40.15475,
    lng: -74.97918,
    city: "Feasterville Trevose",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26498,
    density: 971.1,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19054,
    lat: 40.17055,
    lng: -74.82016,
    city: "Levittown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17040,
    density: 1592.4,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19055,
    lat: 40.14984,
    lng: -74.83881,
    city: "Levittown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13672,
    density: 1873,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19056,
    lat: 40.15044,
    lng: -74.88534,
    city: "Levittown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16153,
    density: 1619.3,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19057,
    lat: 40.14013,
    lng: -74.85718,
    city: "Levittown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17240,
    density: 1500,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19060,
    lat: 39.85048,
    lng: -75.4921,
    city: "Garnet Valley",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11227,
    density: 560.6,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 42045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19061,
    lat: 39.82741,
    lng: -75.432,
    city: "Marcus Hook",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20525,
    density: 1132.1,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 42045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19063,
    lat: 39.92248,
    lng: -75.41419,
    city: "Media",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35439,
    density: 545.2,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 42045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19064,
    lat: 39.93214,
    lng: -75.33873,
    city: "Springfield",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25356,
    density: 1369.8,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 42045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19066,
    lat: 40.0022,
    lng: -75.2489,
    city: "Merion Station",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5319,
    density: 1540.8,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19067,
    lat: 40.19595,
    lng: -74.80976,
    city: "Morrisville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52519,
    density: 643.4,
    county_fips: 42017,
    county_name: "Bucks",
    county_weights: {
      42017: 100,
    },
    county_names_all: "Bucks",
    county_fips_all: 42017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19070,
    lat: 39.90628,
    lng: -75.32452,
    city: "Morton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6625,
    density: 2413.2,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 42045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19072,
    lat: 40.02419,
    lng: -75.25697,
    city: "Narberth",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10008,
    density: 1216.1,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19073,
    lat: 39.98093,
    lng: -75.4346,
    city: "Newtown Square",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20421,
    density: 384.1,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42029: 21.54,
      42045: 78.46,
    },
    county_names_all: "Delaware|Chester",
    county_fips_all: "42045|42029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19074,
    lat: 39.88642,
    lng: -75.29643,
    city: "Norwood",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5957,
    density: 2957,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 42045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19075,
    lat: 40.1136,
    lng: -75.18852,
    city: "Oreland",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7600,
    density: 1570.3,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19076,
    lat: 39.88586,
    lng: -75.30763,
    city: "Prospect Park",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6559,
    density: 3385.6,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 42045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19078,
    lat: 39.87328,
    lng: -75.32159,
    city: "Ridley Park",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11379,
    density: 2161.9,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 42045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19079,
    lat: 39.90238,
    lng: -75.26591,
    city: "Sharon Hill",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9068,
    density: 2164.7,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 42045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19081,
    lat: 39.89864,
    lng: -75.34751,
    city: "Swarthmore",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10075,
    density: 1799.2,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 42045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19082,
    lat: 39.96043,
    lng: -75.27032,
    city: "Upper Darby",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42670,
    density: 6397,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 99.6,
      42101: 0.4,
    },
    county_names_all: "Delaware|Philadelphia",
    county_fips_all: "42045|42101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19083,
    lat: 39.97715,
    lng: -75.31192,
    city: "Havertown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36110,
    density: 2492.8,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 99.62,
      42091: 0.38,
    },
    county_names_all: "Delaware|Montgomery",
    county_fips_all: "42045|42091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19085,
    lat: 40.03759,
    lng: -75.34969,
    city: "Villanova",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8981,
    density: 556.7,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 56.79,
      42091: 43.21,
    },
    county_names_all: "Delaware|Montgomery",
    county_fips_all: "42045|42091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19086,
    lat: 39.89094,
    lng: -75.37014,
    city: "Wallingford",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12142,
    density: 1171.1,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 42045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19087,
    lat: 40.06172,
    lng: -75.40004,
    city: "Wayne",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32592,
    density: 805.6,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 50,
      42045: 34.75,
      42091: 15.25,
    },
    county_names_all: "Chester|Delaware|Montgomery",
    county_fips_all: "42029|42045|42091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19090,
    lat: 40.1484,
    lng: -75.12378,
    city: "Willow Grove",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18202,
    density: 1526.6,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19094,
    lat: 39.87499,
    lng: -75.3467,
    city: "Woodlyn",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4280,
    density: 2012.7,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 42045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19095,
    lat: 40.08588,
    lng: -75.15137,
    city: "Wyncote",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7515,
    density: 1401.9,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19096,
    lat: 39.99813,
    lng: -75.27388,
    city: "Wynnewood",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14262,
    density: 1577.9,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42045: 4.76,
      42091: 95.24,
    },
    county_names_all: "Montgomery|Delaware",
    county_fips_all: "42091|42045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19102,
    lat: 39.95301,
    lng: -75.16544,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5335,
    density: 11035.5,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19103,
    lat: 39.95303,
    lng: -75.17386,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25113,
    density: 15021.4,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19104,
    lat: 39.95891,
    lng: -75.19836,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52480,
    density: 6620.2,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19106,
    lat: 39.94589,
    lng: -75.14224,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13536,
    density: 6148.1,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19107,
    lat: 39.9518,
    lng: -75.15864,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14689,
    density: 10425.2,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19108,
    lat: 39.95987,
    lng: -75.16083,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19109,
    lat: 39.94958,
    lng: -75.16387,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19111,
    lat: 40.06065,
    lng: -75.08019,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67159,
    density: 5351.3,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19112,
    lat: 39.88999,
    lng: -75.16985,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19113,
    lat: 39.86679,
    lng: -75.27911,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 82,
    density: 47.1,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42045: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 42045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19114,
    lat: 40.06743,
    lng: -75.00361,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31448,
    density: 2157.6,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19115,
    lat: 40.09094,
    lng: -75.04595,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35504,
    density: 2655.6,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19116,
    lat: 40.11655,
    lng: -75.01399,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33976,
    density: 2512.5,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19118,
    lat: 40.07233,
    lng: -75.21247,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10826,
    density: 1304.2,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42091: 1.86,
      42101: 98.14,
    },
    county_names_all: "Philadelphia|Montgomery",
    county_fips_all: "42101|42091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19119,
    lat: 40.05303,
    lng: -75.19223,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29055,
    density: 3296.5,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19120,
    lat: 40.03417,
    lng: -75.11986,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74270,
    density: 8866.6,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19121,
    lat: 39.98231,
    lng: -75.17995,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31664,
    density: 5164.6,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19122,
    lat: 39.97767,
    lng: -75.14571,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21067,
    density: 6289.8,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19123,
    lat: 39.96399,
    lng: -75.14568,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17793,
    density: 5447,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19124,
    lat: 40.01728,
    lng: -75.09387,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 71858,
    density: 5392.9,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19125,
    lat: 39.97611,
    lng: -75.12472,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25705,
    density: 7340,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19126,
    lat: 40.05516,
    lng: -75.13728,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16609,
    density: 5390.1,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19127,
    lat: 40.02854,
    lng: -75.22746,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5610,
    density: 3795.1,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42091: 0.22,
      42101: 99.78,
    },
    county_names_all: "Philadelphia|Montgomery",
    county_fips_all: "42101|42091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19128,
    lat: 40.05003,
    lng: -75.23003,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37677,
    density: 2082.7,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42091: 2.34,
      42101: 97.66,
    },
    county_names_all: "Philadelphia|Montgomery",
    county_fips_all: "42101|42091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19129,
    lat: 40.01338,
    lng: -75.18454,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11408,
    density: 2147.2,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19130,
    lat: 39.9676,
    lng: -75.17495,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28010,
    density: 8739.3,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19131,
    lat: 39.98865,
    lng: -75.21835,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44649,
    density: 3270.3,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19132,
    lat: 39.99649,
    lng: -75.17102,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29850,
    density: 5350.2,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19133,
    lat: 39.99238,
    lng: -75.14149,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26705,
    density: 8035.7,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19134,
    lat: 39.98953,
    lng: -75.10838,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61615,
    density: 6903.5,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19135,
    lat: 40.02192,
    lng: -75.04966,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36102,
    density: 6152.8,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19136,
    lat: 40.03973,
    lng: -75.01932,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34962,
    density: 2813.4,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19137,
    lat: 39.99455,
    lng: -75.074,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8652,
    density: 1379.3,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19138,
    lat: 40.05594,
    lng: -75.15947,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33711,
    density: 7377.9,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19139,
    lat: 39.96144,
    lng: -75.22964,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45198,
    density: 9867.4,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19140,
    lat: 40.01224,
    lng: -75.14512,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52608,
    density: 6443.6,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19141,
    lat: 40.03788,
    lng: -75.14541,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34115,
    density: 7546.7,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19142,
    lat: 39.92278,
    lng: -75.23375,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29864,
    density: 6604,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42045: 0.49,
      42101: 99.51,
    },
    county_names_all: "Philadelphia|Delaware",
    county_fips_all: "42101|42045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19143,
    lat: 39.94315,
    lng: -75.22664,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62927,
    density: 7798.3,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42045: 0.16,
      42101: 99.84,
    },
    county_names_all: "Philadelphia|Delaware",
    county_fips_all: "42101|42045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19144,
    lat: 40.03278,
    lng: -75.17523,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44968,
    density: 4838.5,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19145,
    lat: 39.91469,
    lng: -75.19194,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44508,
    density: 3583.3,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19146,
    lat: 39.93917,
    lng: -75.18398,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40635,
    density: 9100.8,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19147,
    lat: 39.93645,
    lng: -75.15468,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38809,
    density: 11200.8,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19148,
    lat: 39.91175,
    lng: -75.1514,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51754,
    density: 4720.4,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19149,
    lat: 40.03781,
    lng: -75.06544,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58811,
    density: 9511.9,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19150,
    lat: 40.07251,
    lng: -75.17165,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22916,
    density: 5983.2,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19151,
    lat: 39.97562,
    lng: -75.25616,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32306,
    density: 5200.3,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42045: 0.18,
      42101: 99.82,
    },
    county_names_all: "Philadelphia|Delaware",
    county_fips_all: "42101|42045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19152,
    lat: 40.06158,
    lng: -75.04663,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37436,
    density: 5015.5,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42101: 100,
    },
    county_names_all: "Philadelphia",
    county_fips_all: 42101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19153,
    lat: 39.88391,
    lng: -75.2343,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12909,
    density: 492.9,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42045: 33.25,
      42101: 66.75,
    },
    county_names_all: "Philadelphia|Delaware",
    county_fips_all: "42101|42045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19154,
    lat: 40.0951,
    lng: -74.98159,
    city: "Philadelphia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34946,
    density: 2108.9,
    county_fips: 42101,
    county_name: "Philadelphia",
    county_weights: {
      42017: 0.23,
      42101: 99.77,
    },
    county_names_all: "Philadelphia|Bucks",
    county_fips_all: "42101|42017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19301,
    lat: 40.0414,
    lng: -75.4809,
    city: "Paoli",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6689,
    density: 719.1,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 42029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19310,
    lat: 39.93478,
    lng: -75.97038,
    city: "Atglen",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3207,
    density: 92.6,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 92.48,
      42071: 7.52,
    },
    county_names_all: "Chester|Lancaster",
    county_fips_all: "42029|42071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19311,
    lat: 39.82163,
    lng: -75.76887,
    city: "Avondale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9541,
    density: 293.6,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 42029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19312,
    lat: 40.0309,
    lng: -75.45083,
    city: "Berwyn",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11338,
    density: 457.6,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 95.92,
      42045: 4.08,
    },
    county_names_all: "Chester|Delaware",
    county_fips_all: "42029|42045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19316,
    lat: 40.05597,
    lng: -75.83804,
    city: "Brandamore",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 229,
    density: 111,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 42029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19317,
    lat: 39.85722,
    lng: -75.60244,
    city: "Chadds Ford",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10043,
    density: 177.6,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 56.81,
      42045: 43.19,
    },
    county_names_all: "Chester|Delaware",
    county_fips_all: "42029|42045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19319,
    lat: 39.92723,
    lng: -75.52319,
    city: "Cheyney",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 426,
    density: 253.7,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42029: 24.14,
      42045: 75.86,
    },
    county_names_all: "Delaware|Chester",
    county_fips_all: "42045|42029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19320,
    lat: 39.97046,
    lng: -75.83069,
    city: "Coatesville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55219,
    density: 261.3,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 42029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19330,
    lat: 39.87359,
    lng: -75.91695,
    city: "Cochranville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5726,
    density: 66.1,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 42029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19333,
    lat: 40.04208,
    lng: -75.42331,
    city: "Devon",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6893,
    density: 720.2,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 42029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19335,
    lat: 40.02271,
    lng: -75.72045,
    city: "Downingtown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48272,
    density: 430.5,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 42029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19341,
    lat: 40.04213,
    lng: -75.63814,
    city: "Exton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19133,
    density: 539.7,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 42029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19342,
    lat: 39.90458,
    lng: -75.50243,
    city: "Glen Mills",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20069,
    density: 391.9,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42029: 3.3,
      42045: 96.7,
    },
    county_names_all: "Delaware|Chester",
    county_fips_all: "42045|42029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19343,
    lat: 40.10203,
    lng: -75.75461,
    city: "Glenmoore",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7553,
    density: 105.7,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 42029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19344,
    lat: 40.08279,
    lng: -75.88338,
    city: "Honey Brook",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12145,
    density: 141.6,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 97.43,
      42071: 2.57,
    },
    county_names_all: "Chester|Lancaster",
    county_fips_all: "42029|42071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19345,
    lat: 40.02967,
    lng: -75.56955,
    city: "Immaculata",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 668,
    density: 719,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 42029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19348,
    lat: 39.86706,
    lng: -75.71763,
    city: "Kennett Square",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23636,
    density: 247.8,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 42029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19350,
    lat: 39.76244,
    lng: -75.79528,
    city: "Landenberg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11606,
    density: 160.1,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 42029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19352,
    lat: 39.78036,
    lng: -75.89054,
    city: "Lincoln University",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11432,
    density: 251.4,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 42029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19355,
    lat: 40.0466,
    lng: -75.5302,
    city: "Malvern",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26920,
    density: 271.4,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 42029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19358,
    lat: 39.96362,
    lng: -75.80659,
    city: "Modena",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 633,
    density: 1747.6,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 42029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19362,
    lat: 39.75175,
    lng: -76.06576,
    city: "Nottingham",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5844,
    density: 76.6,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 61.41,
      42071: 38.59,
    },
    county_names_all: "Chester|Lancaster",
    county_fips_all: "42029|42071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19363,
    lat: 39.7864,
    lng: -75.97279,
    city: "Oxford",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17170,
    density: 131.1,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 96.11,
      42071: 3.89,
    },
    county_names_all: "Chester|Lancaster",
    county_fips_all: "42029|42071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19365,
    lat: 39.9655,
    lng: -75.92766,
    city: "Parkesburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7496,
    density: 175.5,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 42029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19367,
    lat: 39.96285,
    lng: -75.88395,
    city: "Pomeroy",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 82,
    density: 194.6,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 42029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19369,
    lat: 39.98082,
    lng: -75.89496,
    city: "Sadsburyville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 42029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19372,
    lat: 39.99941,
    lng: -75.75972,
    city: "Thorndale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2042,
    density: 843.2,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 42029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19373,
    lat: 39.90674,
    lng: -75.53255,
    city: "Thornton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4389,
    density: 527,
    county_fips: 42045,
    county_name: "Delaware",
    county_weights: {
      42029: 4.18,
      42045: 95.82,
    },
    county_names_all: "Delaware|Chester",
    county_fips_all: "42045|42029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19374,
    lat: 39.83333,
    lng: -75.75267,
    city: "Toughkenamon",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1013,
    density: 251.6,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 42029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19375,
    lat: 39.8996,
    lng: -75.73993,
    city: "Unionville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 131,
    density: 109.3,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 42029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19380,
    lat: 39.98594,
    lng: -75.60358,
    city: "West Chester",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50501,
    density: 640,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 42029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19382,
    lat: 39.92766,
    lng: -75.61475,
    city: "West Chester",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54748,
    density: 458.2,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 97.45,
      42045: 2.55,
    },
    county_names_all: "Chester|Delaware",
    county_fips_all: "42029|42045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19383,
    lat: 39.94303,
    lng: -75.60155,
    city: "West Chester",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3222,
    density: 2981.6,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 42029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19390,
    lat: 39.83683,
    lng: -75.83962,
    city: "West Grove",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13821,
    density: 182.1,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 42029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19401,
    lat: 40.13042,
    lng: -75.33143,
    city: "Norristown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41287,
    density: 2591.6,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19403,
    lat: 40.14898,
    lng: -75.38034,
    city: "Norristown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46794,
    density: 807.7,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19405,
    lat: 40.09949,
    lng: -75.33497,
    city: "Bridgeport",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4648,
    density: 1743.1,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19406,
    lat: 40.09467,
    lng: -75.38402,
    city: "King Of Prussia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26631,
    density: 764.8,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19422,
    lat: 40.15835,
    lng: -75.27858,
    city: "Blue Bell",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19018,
    density: 598.7,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19425,
    lat: 40.10383,
    lng: -75.64476,
    city: "Chester Springs",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16445,
    density: 236.9,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 42029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19426,
    lat: 40.18972,
    lng: -75.43734,
    city: "Collegeville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40870,
    density: 463.7,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19428,
    lat: 40.08011,
    lng: -75.30317,
    city: "Conshohocken",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18215,
    density: 962.7,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19435,
    lat: 40.32788,
    lng: -75.56518,
    city: "Frederick",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38,
    density: 12.3,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19436,
    lat: 40.20253,
    lng: -75.24842,
    city: "Gwynedd",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 722,
    density: 1315.2,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19437,
    lat: 40.18706,
    lng: -75.25274,
    city: "Gwynedd Valley",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1091,
    density: 364.6,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19438,
    lat: 40.27018,
    lng: -75.39554,
    city: "Harleysville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24812,
    density: 431.4,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19440,
    lat: 40.285,
    lng: -75.29102,
    city: "Hatfield",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19218,
    density: 654.5,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42017: 24.69,
      42091: 75.31,
    },
    county_names_all: "Montgomery|Bucks",
    county_fips_all: "42091|42017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19442,
    lat: 40.13233,
    lng: -75.57863,
    city: "Kimberton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 42029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19444,
    lat: 40.08686,
    lng: -75.25427,
    city: "Lafayette Hill",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10855,
    density: 867.8,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19446,
    lat: 40.23068,
    lng: -75.30369,
    city: "Lansdale",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58570,
    density: 1002.4,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19453,
    lat: 40.13886,
    lng: -75.50141,
    city: "Mont Clare",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1691,
    density: 911.8,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19454,
    lat: 40.22303,
    lng: -75.24365,
    city: "North Wales",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27562,
    density: 861.9,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42017: 0.89,
      42091: 99.11,
    },
    county_names_all: "Montgomery|Bucks",
    county_fips_all: "42091|42017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19456,
    lat: 40.1367,
    lng: -75.45962,
    city: "Oaks",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 869,
    density: 1780.5,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19457,
    lat: 40.20512,
    lng: -75.58758,
    city: "Parker Ford",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 107,
    density: 159.9,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 42029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19460,
    lat: 40.12674,
    lng: -75.5294,
    city: "Phoenixville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41615,
    density: 465.3,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 81.17,
      42091: 18.83,
    },
    county_names_all: "Chester|Montgomery",
    county_fips_all: "42029|42091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19462,
    lat: 40.11542,
    lng: -75.28453,
    city: "Plymouth Meeting",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15203,
    density: 707.1,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19464,
    lat: 40.25882,
    lng: -75.616,
    city: "Pottstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47040,
    density: 708.4,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42011: 0.77,
      42091: 99.23,
    },
    county_names_all: "Montgomery|Berks",
    county_fips_all: "42091|42011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19465,
    lat: 40.19981,
    lng: -75.6727,
    city: "Pottstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17750,
    density: 192.8,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 42029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19468,
    lat: 40.20776,
    lng: -75.53137,
    city: "Royersford",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25284,
    density: 576.9,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19472,
    lat: 40.34036,
    lng: -75.58189,
    city: "Sassamansville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10,
    density: 6,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19473,
    lat: 40.25842,
    lng: -75.47363,
    city: "Schwenksville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17910,
    density: 284.4,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19474,
    lat: 40.22427,
    lng: -75.40507,
    city: "Skippack",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 344,
    density: 902.8,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19475,
    lat: 40.17028,
    lng: -75.60042,
    city: "Spring City",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11457,
    density: 268.9,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42029: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 42029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19477,
    lat: 40.18447,
    lng: -75.23583,
    city: "Spring House",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 129,
    density: 699,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19490,
    lat: 40.19673,
    lng: -75.35401,
    city: "Worcester",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19492,
    lat: 40.28817,
    lng: -75.50623,
    city: "Zieglerville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 456,
    density: 105.9,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42091: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 42091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19501,
    lat: 40.24314,
    lng: -76.05822,
    city: "Adamstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1145,
    density: 452.4,
    county_fips: 42071,
    county_name: "Lancaster",
    county_weights: {
      42011: 2.06,
      42071: 97.94,
    },
    county_names_all: "Lancaster|Berks",
    county_fips_all: "42071|42011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19503,
    lat: 40.40808,
    lng: -75.5755,
    city: "Bally",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1410,
    density: 337.9,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19504,
    lat: 40.40699,
    lng: -75.58965,
    city: "Barto",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4599,
    density: 76.6,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 71.61,
      42091: 28.39,
    },
    county_names_all: "Berks|Montgomery",
    county_fips_all: "42011|42091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19505,
    lat: 40.3795,
    lng: -75.62331,
    city: "Bechtelsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3546,
    density: 173.5,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 92.82,
      42091: 7.18,
    },
    county_names_all: "Berks|Montgomery",
    county_fips_all: "42011|42091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19506,
    lat: 40.45873,
    lng: -76.12379,
    city: "Bernville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7034,
    density: 42.9,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19507,
    lat: 40.49268,
    lng: -76.28235,
    city: "Bethel",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3358,
    density: 31.9,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19508,
    lat: 40.25913,
    lng: -75.83984,
    city: "Birdsboro",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15523,
    density: 147.4,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19510,
    lat: 40.44551,
    lng: -75.88179,
    city: "Blandon",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8949,
    density: 671,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19511,
    lat: 40.48473,
    lng: -75.74381,
    city: "Bowers",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 161,
    density: 203.5,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19512,
    lat: 40.35,
    lng: -75.67937,
    city: "Boyertown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16736,
    density: 149.3,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 98.5,
      42091: 1.5,
    },
    county_names_all: "Berks|Montgomery",
    county_fips_all: "42011|42091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19516,
    lat: 40.48686,
    lng: -76.00526,
    city: "Centerport",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19518,
    lat: 40.27187,
    lng: -75.74981,
    city: "Douglassville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15619,
    density: 168.4,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19520,
    lat: 40.15968,
    lng: -75.79959,
    city: "Elverson",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5889,
    density: 60.6,
    county_fips: 42029,
    county_name: "Chester",
    county_weights: {
      42011: 23.12,
      42029: 76.88,
    },
    county_names_all: "Chester|Berks",
    county_fips_all: "42029|42011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19522,
    lat: 40.44948,
    lng: -75.81676,
    city: "Fleetwood",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13531,
    density: 112.2,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19523,
    lat: 40.20116,
    lng: -75.84974,
    city: "Geigertown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 95,
    density: 36.3,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19525,
    lat: 40.30784,
    lng: -75.58591,
    city: "Gilbertsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17148,
    density: 387.3,
    county_fips: 42091,
    county_name: "Montgomery",
    county_weights: {
      42011: 0.18,
      42091: 99.82,
    },
    county_names_all: "Montgomery|Berks",
    county_fips_all: "42091|42011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19526,
    lat: 40.5465,
    lng: -75.99802,
    city: "Hamburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11415,
    density: 76.7,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19529,
    lat: 40.63387,
    lng: -75.86158,
    city: "Kempton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4028,
    density: 29.1,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 65.99,
      42077: 34.01,
    },
    county_names_all: "Berks|Lehigh",
    county_fips_all: "42011|42077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19530,
    lat: 40.54012,
    lng: -75.77675,
    city: "Kutztown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15939,
    density: 112.7,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 90.38,
      42077: 9.62,
    },
    county_names_all: "Berks|Lehigh",
    county_fips_all: "42011|42077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19533,
    lat: 40.42245,
    lng: -75.99021,
    city: "Leesport",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8378,
    density: 187.4,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19534,
    lat: 40.57813,
    lng: -75.88111,
    city: "Lenhartsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1597,
    density: 24.6,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19535,
    lat: 40.3394,
    lng: -75.79537,
    city: "Limekiln",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19536,
    lat: 40.48069,
    lng: -75.75891,
    city: "Lyon Station",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 552,
    density: 573.7,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19538,
    lat: 40.54655,
    lng: -75.70023,
    city: "Maxatawny",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37,
    density: 30.6,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19539,
    lat: 40.49071,
    lng: -75.68823,
    city: "Mertztown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4740,
    density: 84.6,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 94.84,
      42077: 5.16,
    },
    county_names_all: "Berks|Lehigh",
    county_fips_all: "42011|42077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19540,
    lat: 40.23714,
    lng: -75.9658,
    city: "Mohnton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11342,
    density: 124.4,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 90.08,
      42071: 9.92,
    },
    county_names_all: "Berks|Lancaster",
    county_fips_all: "42011|42071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19541,
    lat: 40.47821,
    lng: -76.02597,
    city: "Mohrsville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4598,
    density: 81.9,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19543,
    lat: 40.1697,
    lng: -75.89635,
    city: "Morgantown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5816,
    density: 104.8,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 68.73,
      42029: 2.32,
      42071: 28.95,
    },
    county_names_all: "Berks|Lancaster|Chester",
    county_fips_all: "42011|42071|42029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19544,
    lat: 40.41669,
    lng: -76.29619,
    city: "Mount Aetna",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 159,
    density: 351.5,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19545,
    lat: 40.3411,
    lng: -75.62977,
    city: "New Berlinville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1015,
    density: 17943.3,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19547,
    lat: 40.38315,
    lng: -75.76644,
    city: "Oley",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4684,
    density: 63.4,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19549,
    lat: 40.58176,
    lng: -76.02672,
    city: "Port Clinton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 373,
    density: 189.1,
    county_fips: 42107,
    county_name: "Schuylkill",
    county_weights: {
      42107: 100,
    },
    county_names_all: "Schuylkill",
    county_fips_all: 42107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19550,
    lat: 40.45593,
    lng: -76.25055,
    city: "Rehrersburg",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 602,
    density: 149.7,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19551,
    lat: 40.35951,
    lng: -76.14213,
    city: "Robesonia",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4524,
    density: 69,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 82.14,
      42071: 0.84,
      42075: 17.02,
    },
    county_names_all: "Berks|Lebanon|Lancaster",
    county_fips_all: "42011|42075|42071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19554,
    lat: 40.51288,
    lng: -76.10377,
    city: "Shartlesville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 436,
    density: 376.1,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19555,
    lat: 40.49335,
    lng: -75.94993,
    city: "Shoemakersville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3344,
    density: 86.5,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19559,
    lat: 40.49234,
    lng: -76.18661,
    city: "Strausstown",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 322,
    density: 214.9,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19560,
    lat: 40.40053,
    lng: -75.88993,
    city: "Temple",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8170,
    density: 337.9,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19562,
    lat: 40.50316,
    lng: -75.70135,
    city: "Topton",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2602,
    density: 880.2,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19564,
    lat: 40.51926,
    lng: -75.87403,
    city: "Virginville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 66,
    density: 77.8,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19565,
    lat: 40.34231,
    lng: -76.08873,
    city: "Wernersville",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8789,
    density: 188.4,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19567,
    lat: 40.3957,
    lng: -76.20989,
    city: "Womelsdorf",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5628,
    density: 95.8,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19601,
    lat: 40.3526,
    lng: -75.9408,
    city: "Reading",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33382,
    density: 3426.2,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19602,
    lat: 40.32695,
    lng: -75.91701,
    city: "Reading",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16410,
    density: 3104.6,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19604,
    lat: 40.35791,
    lng: -75.90954,
    city: "Reading",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29069,
    density: 4499.5,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19605,
    lat: 40.39917,
    lng: -75.94596,
    city: "Reading",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18863,
    density: 414.1,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19606,
    lat: 40.3357,
    lng: -75.85755,
    city: "Reading",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35750,
    density: 517.9,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19607,
    lat: 40.29147,
    lng: -75.94521,
    city: "Reading",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22985,
    density: 791,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19608,
    lat: 40.31401,
    lng: -76.03574,
    city: "Reading",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23304,
    density: 342.1,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19609,
    lat: 40.32774,
    lng: -75.99622,
    city: "Reading",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10066,
    density: 1692.5,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19610,
    lat: 40.34015,
    lng: -75.97612,
    city: "Reading",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15871,
    density: 864.6,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19611,
    lat: 40.32473,
    lng: -75.9411,
    city: "Reading",
    state_id: "PA",
    state_name: "Pennsylvania",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10707,
    density: 2032.3,
    county_fips: 42011,
    county_name: "Berks",
    county_weights: {
      42011: 100,
    },
    county_names_all: "Berks",
    county_fips_all: 42011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19701,
    lat: 39.58427,
    lng: -75.69914,
    city: "Bear",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42240,
    density: 613.8,
    county_fips: 10003,
    county_name: "New Castle",
    county_weights: {
      10003: 100,
    },
    county_names_all: "New Castle",
    county_fips_all: 10003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19702,
    lat: 39.62199,
    lng: -75.72803,
    city: "Newark",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54980,
    density: 755.7,
    county_fips: 10003,
    county_name: "New Castle",
    county_weights: {
      10003: 100,
    },
    county_names_all: "New Castle",
    county_fips_all: 10003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19703,
    lat: 39.8043,
    lng: -75.45794,
    city: "Claymont",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15379,
    density: 1495.5,
    county_fips: 10003,
    county_name: "New Castle",
    county_weights: {
      10003: 100,
    },
    county_names_all: "New Castle",
    county_fips_all: 10003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19706,
    lat: 39.5715,
    lng: -75.5905,
    city: "Delaware City",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1858,
    density: 283.4,
    county_fips: 10003,
    county_name: "New Castle",
    county_weights: {
      10003: 100,
    },
    county_names_all: "New Castle",
    county_fips_all: 10003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19707,
    lat: 39.78512,
    lng: -75.68147,
    city: "Hockessin",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16383,
    density: 479.9,
    county_fips: 10003,
    county_name: "New Castle",
    county_weights: {
      10003: 100,
    },
    county_names_all: "New Castle",
    county_fips_all: 10003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19709,
    lat: 39.48923,
    lng: -75.68314,
    city: "Middletown",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45005,
    density: 223.8,
    county_fips: 10003,
    county_name: "New Castle",
    county_weights: {
      10003: 100,
    },
    county_names_all: "New Castle",
    county_fips_all: 10003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19710,
    lat: 39.78964,
    lng: -75.58458,
    city: "Montchanin",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 10003,
    county_name: "New Castle",
    county_weights: {
      10003: 100,
    },
    county_names_all: "New Castle",
    county_fips_all: 10003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19711,
    lat: 39.71379,
    lng: -75.74033,
    city: "Newark",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53194,
    density: 749.4,
    county_fips: 10003,
    county_name: "New Castle",
    county_weights: {
      10003: 100,
    },
    county_names_all: "New Castle",
    county_fips_all: 10003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19713,
    lat: 39.67097,
    lng: -75.70972,
    city: "Newark",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30403,
    density: 902.9,
    county_fips: 10003,
    county_name: "New Castle",
    county_weights: {
      10003: 100,
    },
    county_names_all: "New Castle",
    county_fips_all: 10003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19716,
    lat: 39.66779,
    lng: -75.74595,
    city: "Newark",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 10003,
    county_name: "New Castle",
    county_weights: {
      10003: 100,
    },
    county_names_all: "New Castle",
    county_fips_all: 10003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19717,
    lat: 39.68121,
    lng: -75.75343,
    city: "Newark",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3649,
    density: 5459.5,
    county_fips: 10003,
    county_name: "New Castle",
    county_weights: {
      10003: 100,
    },
    county_names_all: "New Castle",
    county_fips_all: 10003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19720,
    lat: 39.645,
    lng: -75.60678,
    city: "New Castle",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59410,
    density: 598.9,
    county_fips: 10003,
    county_name: "New Castle",
    county_weights: {
      10003: 100,
    },
    county_names_all: "New Castle",
    county_fips_all: 10003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19730,
    lat: 39.45443,
    lng: -75.66077,
    city: "Odessa",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 441,
    density: 252.4,
    county_fips: 10003,
    county_name: "New Castle",
    county_weights: {
      10003: 100,
    },
    county_names_all: "New Castle",
    county_fips_all: 10003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19731,
    lat: 39.5102,
    lng: -75.59616,
    city: "Port Penn",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 350,
    density: 53.5,
    county_fips: 10003,
    county_name: "New Castle",
    county_weights: {
      10003: 100,
    },
    county_names_all: "New Castle",
    county_fips_all: 10003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19732,
    lat: 39.80033,
    lng: -75.57455,
    city: "Rockland",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 81,
    density: 17.8,
    county_fips: 10003,
    county_name: "New Castle",
    county_weights: {
      10003: 100,
    },
    county_names_all: "New Castle",
    county_fips_all: 10003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19733,
    lat: 39.55928,
    lng: -75.65143,
    city: "Saint Georges",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68,
    density: 239,
    county_fips: 10003,
    county_name: "New Castle",
    county_weights: {
      10003: 100,
    },
    county_names_all: "New Castle",
    county_fips_all: 10003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19734,
    lat: 39.38377,
    lng: -75.65026,
    city: "Townsend",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13072,
    density: 63.2,
    county_fips: 10003,
    county_name: "New Castle",
    county_weights: {
      10003: 100,
    },
    county_names_all: "New Castle",
    county_fips_all: 10003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19735,
    lat: 39.80666,
    lng: -75.5973,
    city: "Winterthur",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8,
    density: 6.9,
    county_fips: 10003,
    county_name: "New Castle",
    county_weights: {
      10003: 100,
    },
    county_names_all: "New Castle",
    county_fips_all: 10003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19736,
    lat: 39.78031,
    lng: -75.64274,
    city: "Yorklyn",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 10003,
    county_name: "New Castle",
    county_weights: {
      10003: 100,
    },
    county_names_all: "New Castle",
    county_fips_all: 10003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19801,
    lat: 39.72782,
    lng: -75.54615,
    city: "Wilmington",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17447,
    density: 1532.2,
    county_fips: 10003,
    county_name: "New Castle",
    county_weights: {
      10003: 100,
    },
    county_names_all: "New Castle",
    county_fips_all: 10003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19802,
    lat: 39.75715,
    lng: -75.52873,
    city: "Wilmington",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26126,
    density: 2895.4,
    county_fips: 10003,
    county_name: "New Castle",
    county_weights: {
      10003: 100,
    },
    county_names_all: "New Castle",
    county_fips_all: 10003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19803,
    lat: 39.79912,
    lng: -75.5422,
    city: "Wilmington",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21484,
    density: 655.2,
    county_fips: 10003,
    county_name: "New Castle",
    county_weights: {
      10003: 100,
    },
    county_names_all: "New Castle",
    county_fips_all: 10003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19804,
    lat: 39.7166,
    lng: -75.62094,
    city: "Wilmington",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17529,
    density: 943.1,
    county_fips: 10003,
    county_name: "New Castle",
    county_weights: {
      10003: 100,
    },
    county_names_all: "New Castle",
    county_fips_all: 10003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19805,
    lat: 39.74523,
    lng: -75.59373,
    city: "Wilmington",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38061,
    density: 2663.2,
    county_fips: 10003,
    county_name: "New Castle",
    county_weights: {
      10003: 100,
    },
    county_names_all: "New Castle",
    county_fips_all: 10003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19806,
    lat: 39.762,
    lng: -75.56336,
    city: "Wilmington",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9313,
    density: 2109.5,
    county_fips: 10003,
    county_name: "New Castle",
    county_weights: {
      10003: 100,
    },
    county_names_all: "New Castle",
    county_fips_all: 10003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19807,
    lat: 39.79767,
    lng: -75.61284,
    city: "Wilmington",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7369,
    density: 156.6,
    county_fips: 10003,
    county_name: "New Castle",
    county_weights: {
      10003: 100,
    },
    county_names_all: "New Castle",
    county_fips_all: 10003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19808,
    lat: 39.73777,
    lng: -75.66596,
    city: "Wilmington",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38106,
    density: 1070,
    county_fips: 10003,
    county_name: "New Castle",
    county_weights: {
      10003: 100,
    },
    county_names_all: "New Castle",
    county_fips_all: 10003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19809,
    lat: 39.75801,
    lng: -75.50218,
    city: "Wilmington",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14827,
    density: 847.3,
    county_fips: 10003,
    county_name: "New Castle",
    county_weights: {
      10003: 100,
    },
    county_names_all: "New Castle",
    county_fips_all: 10003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19810,
    lat: 39.81855,
    lng: -75.50628,
    city: "Wilmington",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25273,
    density: 1235.6,
    county_fips: 10003,
    county_name: "New Castle",
    county_weights: {
      10003: 100,
    },
    county_names_all: "New Castle",
    county_fips_all: 10003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19901,
    lat: 39.17335,
    lng: -75.47758,
    city: "Dover",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38673,
    density: 197,
    county_fips: 10001,
    county_name: "Kent",
    county_weights: {
      10001: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 10001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19902,
    lat: 39.12765,
    lng: -75.46694,
    city: "Dover Afb",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 10001,
    county_name: "Kent",
    county_weights: {
      10001: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 10001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19904,
    lat: 39.17289,
    lng: -75.59517,
    city: "Dover",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38158,
    density: 341.1,
    county_fips: 10001,
    county_name: "Kent",
    county_weights: {
      10001: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 10001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19930,
    lat: 38.56311,
    lng: -75.07085,
    city: "Bethany Beach",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3077,
    density: 202.8,
    county_fips: 10005,
    county_name: "Sussex",
    county_weights: {
      10005: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 10005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19931,
    lat: 38.56928,
    lng: -75.61029,
    city: "Bethel",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 416,
    density: 134.6,
    county_fips: 10005,
    county_name: "Sussex",
    county_weights: {
      10005: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 10005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19933,
    lat: 38.73699,
    lng: -75.60586,
    city: "Bridgeville",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11457,
    density: 65.8,
    county_fips: 10005,
    county_name: "Sussex",
    county_weights: {
      10005: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 10005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19934,
    lat: 39.08135,
    lng: -75.63113,
    city: "Camden Wyoming",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13673,
    density: 113.3,
    county_fips: 10001,
    county_name: "Kent",
    county_weights: {
      10001: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 10001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19936,
    lat: 39.21846,
    lng: -75.58498,
    city: "Cheswold",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 315,
    density: 591.2,
    county_fips: 10001,
    county_name: "Kent",
    county_weights: {
      10001: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 10001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19938,
    lat: 39.25646,
    lng: -75.69884,
    city: "Clayton",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8587,
    density: 68.8,
    county_fips: 10001,
    county_name: "Kent",
    county_weights: {
      10001: 85.08,
      10003: 14.92,
    },
    county_names_all: "Kent|New Castle",
    county_fips_all: "10001|10003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19939,
    lat: 38.56575,
    lng: -75.2022,
    city: "Dagsboro",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7302,
    density: 108.6,
    county_fips: 10005,
    county_name: "Sussex",
    county_weights: {
      10005: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 10005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19940,
    lat: 38.47723,
    lng: -75.56828,
    city: "Delmar",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6560,
    density: 61.3,
    county_fips: 10005,
    county_name: "Sussex",
    county_weights: {
      10005: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 10005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19941,
    lat: 38.7949,
    lng: -75.42476,
    city: "Ellendale",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3477,
    density: 44.3,
    county_fips: 10005,
    county_name: "Sussex",
    county_weights: {
      10005: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 10005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19943,
    lat: 39.00562,
    lng: -75.60756,
    city: "Felton",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12504,
    density: 77.3,
    county_fips: 10001,
    county_name: "Kent",
    county_weights: {
      10001: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 10001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19944,
    lat: 38.47542,
    lng: -75.05559,
    city: "Fenwick Island",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 746,
    density: 231.8,
    county_fips: 10005,
    county_name: "Sussex",
    county_weights: {
      10005: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 10005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19945,
    lat: 38.50336,
    lng: -75.22855,
    city: "Frankford",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6432,
    density: 39.8,
    county_fips: 10005,
    county_name: "Sussex",
    county_weights: {
      10005: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 10005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19946,
    lat: 39.03224,
    lng: -75.45297,
    city: "Frederica",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5539,
    density: 92.7,
    county_fips: 10001,
    county_name: "Kent",
    county_weights: {
      10001: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 10001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19947,
    lat: 38.67421,
    lng: -75.39864,
    city: "Georgetown",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20033,
    density: 64.9,
    county_fips: 10005,
    county_name: "Sussex",
    county_weights: {
      10005: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 10005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19950,
    lat: 38.82007,
    lng: -75.59691,
    city: "Greenwood",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6762,
    density: 36.1,
    county_fips: 10005,
    county_name: "Sussex",
    county_weights: {
      10001: 24.22,
      10005: 75.78,
    },
    county_names_all: "Sussex|Kent",
    county_fips_all: "10005|10001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19951,
    lat: 38.68763,
    lng: -75.25124,
    city: "Harbeson",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2046,
    density: 88.4,
    county_fips: 10005,
    county_name: "Sussex",
    county_weights: {
      10005: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 10005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19952,
    lat: 38.91654,
    lng: -75.62531,
    city: "Harrington",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10610,
    density: 45,
    county_fips: 10001,
    county_name: "Kent",
    county_weights: {
      10001: 98.41,
      10005: 1.59,
    },
    county_names_all: "Kent|Sussex",
    county_fips_all: "10001|10005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19953,
    lat: 39.15145,
    lng: -75.69695,
    city: "Hartly",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4896,
    density: 63.2,
    county_fips: 10001,
    county_name: "Kent",
    county_weights: {
      10001: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 10001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19954,
    lat: 38.89891,
    lng: -75.52092,
    city: "Houston",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1417,
    density: 56,
    county_fips: 10001,
    county_name: "Kent",
    county_weights: {
      10001: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 10001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19955,
    lat: 39.22652,
    lng: -75.6654,
    city: "Kenton",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 96,
    density: 374.4,
    county_fips: 10001,
    county_name: "Kent",
    county_weights: {
      10001: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 10001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19956,
    lat: 38.5465,
    lng: -75.53961,
    city: "Laurel",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14557,
    density: 56,
    county_fips: 10005,
    county_name: "Sussex",
    county_weights: {
      10005: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 10005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19958,
    lat: 38.72737,
    lng: -75.16632,
    city: "Lewes",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27123,
    density: 221.5,
    county_fips: 10005,
    county_name: "Sussex",
    county_weights: {
      10005: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 10005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19960,
    lat: 38.85082,
    lng: -75.41363,
    city: "Lincoln",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6209,
    density: 79.1,
    county_fips: 10005,
    county_name: "Sussex",
    county_weights: {
      10005: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 10005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19962,
    lat: 39.07005,
    lng: -75.49753,
    city: "Magnolia",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11448,
    density: 302.5,
    county_fips: 10001,
    county_name: "Kent",
    county_weights: {
      10001: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 10001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19963,
    lat: 38.93347,
    lng: -75.37799,
    city: "Milford",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21489,
    density: 78.9,
    county_fips: 10005,
    county_name: "Sussex",
    county_weights: {
      10001: 49.74,
      10005: 50.26,
    },
    county_names_all: "Sussex|Kent",
    county_fips_all: "10005|10001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19964,
    lat: 39.09436,
    lng: -75.72439,
    city: "Marydel",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1472,
    density: 70,
    county_fips: 10001,
    county_name: "Kent",
    county_weights: {
      10001: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 10001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19966,
    lat: 38.58118,
    lng: -75.28274,
    city: "Millsboro",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30601,
    density: 132.6,
    county_fips: 10005,
    county_name: "Sussex",
    county_weights: {
      10005: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 10005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19967,
    lat: 38.53978,
    lng: -75.1209,
    city: "Millville",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1005,
    density: 238.4,
    county_fips: 10005,
    county_name: "Sussex",
    county_weights: {
      10005: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 10005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19968,
    lat: 38.77553,
    lng: -75.28466,
    city: "Milton",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12902,
    density: 78,
    county_fips: 10005,
    county_name: "Sussex",
    county_weights: {
      10005: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 10005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19970,
    lat: 38.55504,
    lng: -75.09901,
    city: "Ocean View",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8770,
    density: 363.1,
    county_fips: 10005,
    county_name: "Sussex",
    county_weights: {
      10005: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 10005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19971,
    lat: 38.69113,
    lng: -75.10132,
    city: "Rehoboth Beach",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13922,
    density: 299.3,
    county_fips: 10005,
    county_name: "Sussex",
    county_weights: {
      10005: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 10005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19973,
    lat: 38.63404,
    lng: -75.62454,
    city: "Seaford",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25991,
    density: 119.5,
    county_fips: 10005,
    county_name: "Sussex",
    county_weights: {
      10005: 92.75,
      24019: 7.25,
    },
    county_names_all: "Sussex|Dorchester",
    county_fips_all: "10005|24019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19975,
    lat: 38.46862,
    lng: -75.17462,
    city: "Selbyville",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9336,
    density: 141.2,
    county_fips: 10005,
    county_name: "Sussex",
    county_weights: {
      10005: 99.82,
      24047: 0.18,
    },
    county_names_all: "Sussex|Worcester",
    county_fips_all: "10005|24047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19977,
    lat: 39.29653,
    lng: -75.55132,
    city: "Smyrna",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25536,
    density: 118.6,
    county_fips: 10001,
    county_name: "Kent",
    county_weights: {
      10001: 78.88,
      10003: 21.12,
    },
    county_names_all: "Kent|New Castle",
    county_fips_all: "10001|10003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19979,
    lat: 39.05041,
    lng: -75.57642,
    city: "Viola",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: 738,
    density: 86.8,
    county_fips: 10001,
    county_name: "Kent",
    county_weights: {
      10001: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 10001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 19980,
    lat: 39.07349,
    lng: -75.57008,
    city: "Woodside",
    state_id: "DE",
    state_name: "Delaware",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 10001,
    county_name: "Kent",
    county_weights: {
      10001: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 10001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20001,
    lat: 38.91002,
    lng: -77.018,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47697,
    density: 8995.4,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20002,
    lat: 38.90511,
    lng: -76.98431,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69141,
    density: 5197,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20003,
    lat: 38.88193,
    lng: -76.99033,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33584,
    density: 5705.7,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20004,
    lat: 38.89504,
    lng: -77.02661,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1885,
    density: 3751.9,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20005,
    lat: 38.90443,
    lng: -77.0316,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13058,
    density: 11630.4,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20006,
    lat: 38.89847,
    lng: -77.04119,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2830,
    density: 3097.7,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20007,
    lat: 38.91259,
    lng: -77.07756,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26412,
    density: 3300.4,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20008,
    lat: 38.93539,
    lng: -77.05935,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30255,
    density: 3781.4,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20009,
    lat: 38.91986,
    lng: -77.03749,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53715,
    density: 15734.8,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20010,
    lat: 38.93255,
    lng: -77.03128,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35297,
    density: 13697.1,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20011,
    lat: 38.95295,
    lng: -77.02323,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69686,
    density: 5016.9,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20012,
    lat: 38.97863,
    lng: -77.03076,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18375,
    density: 3439.4,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20015,
    lat: 38.96661,
    lng: -77.05837,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16113,
    density: 1789.9,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20016,
    lat: 38.93822,
    lng: -77.09139,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34686,
    density: 3022.2,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20017,
    lat: 38.93813,
    lng: -76.99294,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21372,
    density: 3714.2,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20018,
    lat: 38.92596,
    lng: -76.97281,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20864,
    density: 2669.1,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20019,
    lat: 38.89214,
    lng: -76.94195,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65769,
    density: 4138.4,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20020,
    lat: 38.86234,
    lng: -76.97446,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57031,
    density: 4788.2,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20024,
    lat: 38.87517,
    lng: -77.0295,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14603,
    density: 2570.2,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20032,
    lat: 38.83142,
    lng: -77.01514,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42009,
    density: 3091,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20036,
    lat: 38.90705,
    lng: -77.04155,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5426,
    density: 6453.2,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20037,
    lat: 38.89213,
    lng: -77.0535,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14879,
    density: 7846.8,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20045,
    lat: 38.89673,
    lng: -77.0308,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20052,
    lat: 38.89884,
    lng: -77.04779,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20057,
    lat: 38.90892,
    lng: -77.07511,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3948,
    density: 9746.6,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20059,
    lat: 38.92247,
    lng: -77.02003,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20064,
    lat: 38.93637,
    lng: -76.99924,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2084,
    density: 4160.6,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20105,
    lat: 38.95949,
    lng: -77.60829,
    city: "Aldie",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27526,
    density: 298,
    county_fips: 51107,
    county_name: "Loudoun",
    county_weights: {
      51107: 100,
    },
    county_names_all: "Loudoun",
    county_fips_all: 51107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20106,
    lat: 38.6871,
    lng: -78.0133,
    city: "Amissville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5073,
    density: 36.7,
    county_fips: 51157,
    county_name: "Rappahannock",
    county_weights: {
      51047: 21.06,
      51061: 7.28,
      51157: 71.66,
    },
    county_names_all: "Rappahannock|Culpeper|Fauquier",
    county_fips_all: "51157|51047|51061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20109,
    lat: 38.79472,
    lng: -77.53105,
    city: "Manassas",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42128,
    density: 682.7,
    county_fips: 51153,
    county_name: "Prince William",
    county_weights: {
      51153: 100,
    },
    county_names_all: "Prince William",
    county_fips_all: 51153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20110,
    lat: 38.7464,
    lng: -77.48699,
    city: "Manassas",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48035,
    density: 1444.8,
    county_fips: 51683,
    county_name: "Manassas",
    county_weights: {
      51153: 23.28,
      51683: 76.72,
    },
    county_names_all: "Manassas|Prince William",
    county_fips_all: "51683|51153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20111,
    lat: 38.74907,
    lng: -77.43039,
    city: "Manassas",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36264,
    density: 853.5,
    county_fips: 51153,
    county_name: "Prince William",
    county_weights: {
      51153: 81.98,
      51685: 18.02,
    },
    county_names_all: "Prince William|Manassas Park",
    county_fips_all: "51153|51685",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20112,
    lat: 38.67274,
    lng: -77.42901,
    city: "Manassas",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25990,
    density: 296.1,
    county_fips: 51153,
    county_name: "Prince William",
    county_weights: {
      51153: 100,
    },
    county_names_all: "Prince William",
    county_fips_all: 51153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20115,
    lat: 38.82138,
    lng: -77.89764,
    city: "Marshall",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7838,
    density: 30.7,
    county_fips: 51061,
    county_name: "Fauquier",
    county_weights: {
      51061: 100,
    },
    county_names_all: "Fauquier",
    county_fips_all: 51061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20117,
    lat: 38.99473,
    lng: -77.73851,
    city: "Middleburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2591,
    density: 20.6,
    county_fips: 51107,
    county_name: "Loudoun",
    county_weights: {
      51061: 10.59,
      51107: 89.41,
    },
    county_names_all: "Loudoun|Fauquier",
    county_fips_all: "51107|51061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20119,
    lat: 38.62159,
    lng: -77.62819,
    city: "Catlett",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4288,
    density: 25.5,
    county_fips: 51061,
    county_name: "Fauquier",
    county_weights: {
      51061: 99.02,
      51153: 0.98,
    },
    county_names_all: "Fauquier|Prince William",
    county_fips_all: "51061|51153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20120,
    lat: 38.85576,
    lng: -77.47987,
    city: "Centreville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43258,
    density: 928.9,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 89.89,
      51107: 10.11,
    },
    county_names_all: "Fairfax|Loudoun",
    county_fips_all: "51059|51107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20121,
    lat: 38.8175,
    lng: -77.46015,
    city: "Centreville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28120,
    density: 1253.7,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20124,
    lat: 38.78059,
    lng: -77.39085,
    city: "Clifton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15305,
    density: 272.4,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20129,
    lat: 39.16673,
    lng: -77.59404,
    city: "Paeonian Springs",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 507,
    density: 45.7,
    county_fips: 51107,
    county_name: "Loudoun",
    county_weights: {
      51107: 100,
    },
    county_names_all: "Loudoun",
    county_fips_all: 51107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20130,
    lat: 39.02756,
    lng: -77.94243,
    city: "Paris",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 220,
    density: 7.7,
    county_fips: 51043,
    county_name: "Clarke",
    county_weights: {
      51043: 53.94,
      51061: 23.48,
      51107: 22.58,
    },
    county_names_all: "Clarke|Fauquier|Loudoun",
    county_fips_all: "51043|51061|51107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20132,
    lat: 39.16648,
    lng: -77.72748,
    city: "Purcellville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18810,
    density: 85.9,
    county_fips: 51107,
    county_name: "Loudoun",
    county_weights: {
      51107: 100,
    },
    county_names_all: "Loudoun",
    county_fips_all: 51107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20135,
    lat: 39.08602,
    lng: -77.87659,
    city: "Bluemont",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3652,
    density: 36.5,
    county_fips: 51043,
    county_name: "Clarke",
    county_weights: {
      51043: 61.09,
      51107: 38.18,
      54037: 0.73,
    },
    county_names_all: "Clarke|Loudoun|Jefferson",
    county_fips_all: "51043|51107|54037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20136,
    lat: 38.7374,
    lng: -77.55473,
    city: "Bristow",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32135,
    density: 896.8,
    county_fips: 51153,
    county_name: "Prince William",
    county_weights: {
      51153: 100,
    },
    county_names_all: "Prince William",
    county_fips_all: 51153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20137,
    lat: 38.80682,
    lng: -77.72992,
    city: "Broad Run",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1736,
    density: 36.3,
    county_fips: 51061,
    county_name: "Fauquier",
    county_weights: {
      51061: 81.67,
      51153: 18.33,
    },
    county_names_all: "Fauquier|Prince William",
    county_fips_all: "51061|51153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20141,
    lat: 39.11675,
    lng: -77.79159,
    city: "Round Hill",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7407,
    density: 109.9,
    county_fips: 51107,
    county_name: "Loudoun",
    county_weights: {
      51107: 100,
    },
    county_names_all: "Loudoun",
    county_fips_all: 51107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20143,
    lat: 38.86421,
    lng: -77.56792,
    city: "Catharpin",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 630,
    density: 38.1,
    county_fips: 51153,
    county_name: "Prince William",
    county_weights: {
      51153: 100,
    },
    county_names_all: "Prince William",
    county_fips_all: 51153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20144,
    lat: 38.92117,
    lng: -77.93759,
    city: "Delaplane",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1089,
    density: 9.4,
    county_fips: 51061,
    county_name: "Fauquier",
    county_weights: {
      51061: 100,
    },
    county_names_all: "Fauquier",
    county_fips_all: 51061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20147,
    lat: 39.04151,
    lng: -77.47958,
    city: "Ashburn",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63903,
    density: 1243.3,
    county_fips: 51107,
    county_name: "Loudoun",
    county_weights: {
      51107: 100,
    },
    county_names_all: "Loudoun",
    county_fips_all: 51107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20148,
    lat: 38.99062,
    lng: -77.53284,
    city: "Ashburn",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54125,
    density: 1077.7,
    county_fips: 51107,
    county_name: "Loudoun",
    county_weights: {
      51107: 100,
    },
    county_names_all: "Loudoun",
    county_fips_all: 51107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20151,
    lat: 38.89583,
    lng: -77.44453,
    city: "Chantilly",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22209,
    density: 540.7,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20152,
    lat: 38.8998,
    lng: -77.51917,
    city: "Chantilly",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36465,
    density: 1056.7,
    county_fips: 51107,
    county_name: "Loudoun",
    county_weights: {
      51107: 100,
    },
    county_names_all: "Loudoun",
    county_fips_all: 51107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20155,
    lat: 38.80646,
    lng: -77.62145,
    city: "Gainesville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37151,
    density: 563.1,
    county_fips: 51153,
    county_name: "Prince William",
    county_weights: {
      51153: 100,
    },
    county_names_all: "Prince William",
    county_fips_all: 51153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20158,
    lat: 39.14126,
    lng: -77.65514,
    city: "Hamilton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5482,
    density: 159.7,
    county_fips: 51107,
    county_name: "Loudoun",
    county_weights: {
      51107: 100,
    },
    county_names_all: "Loudoun",
    county_fips_all: 51107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20164,
    lat: 39.01244,
    lng: -77.39586,
    city: "Sterling",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42011,
    density: 2132.5,
    county_fips: 51107,
    county_name: "Loudoun",
    county_weights: {
      51107: 100,
    },
    county_names_all: "Loudoun",
    county_fips_all: 51107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20165,
    lat: 39.05058,
    lng: -77.38854,
    city: "Sterling",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33290,
    density: 1305.2,
    county_fips: 51107,
    county_name: "Loudoun",
    county_weights: {
      51107: 100,
    },
    county_names_all: "Loudoun",
    county_fips_all: 51107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20166,
    lat: 38.97146,
    lng: -77.4637,
    city: "Sterling",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12572,
    density: 178.5,
    county_fips: 51107,
    county_name: "Loudoun",
    county_weights: {
      51107: 100,
    },
    county_names_all: "Loudoun",
    county_fips_all: 51107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20169,
    lat: 38.87172,
    lng: -77.64627,
    city: "Haymarket",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25914,
    density: 267.3,
    county_fips: 51153,
    county_name: "Prince William",
    county_weights: {
      51061: 3.04,
      51153: 96.96,
    },
    county_names_all: "Prince William|Fauquier",
    county_fips_all: "51153|51061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20170,
    lat: 38.98075,
    lng: -77.38042,
    city: "Herndon",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43610,
    density: 1923.2,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20171,
    lat: 38.9246,
    lng: -77.39824,
    city: "Herndon",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50511,
    density: 1678.7,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20175,
    lat: 39.0641,
    lng: -77.59939,
    city: "Leesburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35429,
    density: 231.8,
    county_fips: 51107,
    county_name: "Loudoun",
    county_weights: {
      51107: 100,
    },
    county_names_all: "Loudoun",
    county_fips_all: 51107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20176,
    lat: 39.18147,
    lng: -77.5345,
    city: "Leesburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51823,
    density: 364.5,
    county_fips: 51107,
    county_name: "Loudoun",
    county_weights: {
      51107: 100,
    },
    county_names_all: "Loudoun",
    county_fips_all: 51107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20180,
    lat: 39.26775,
    lng: -77.63804,
    city: "Lovettsville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7693,
    density: 69,
    county_fips: 51107,
    county_name: "Loudoun",
    county_weights: {
      51107: 100,
    },
    county_names_all: "Loudoun",
    county_fips_all: 51107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20181,
    lat: 38.66687,
    lng: -77.55374,
    city: "Nokesville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8526,
    density: 42.3,
    county_fips: 51153,
    county_name: "Prince William",
    county_weights: {
      51061: 6.43,
      51153: 93.57,
    },
    county_names_all: "Prince William|Fauquier",
    county_fips_all: "51153|51061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20184,
    lat: 39.00143,
    lng: -77.87874,
    city: "Upperville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 436,
    density: 4.7,
    county_fips: 51107,
    county_name: "Loudoun",
    county_weights: {
      51061: 43.75,
      51107: 56.25,
    },
    county_names_all: "Loudoun|Fauquier",
    county_fips_all: "51107|51061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20186,
    lat: 38.69045,
    lng: -77.843,
    city: "Warrenton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15143,
    density: 99.6,
    county_fips: 51061,
    county_name: "Fauquier",
    county_weights: {
      51047: 1.68,
      51061: 98.32,
    },
    county_names_all: "Fauquier|Culpeper",
    county_fips_all: "51061|51047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20187,
    lat: 38.71846,
    lng: -77.74275,
    city: "Warrenton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18684,
    density: 141.3,
    county_fips: 51061,
    county_name: "Fauquier",
    county_weights: {
      51061: 100,
    },
    county_names_all: "Fauquier",
    county_fips_all: 51061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20190,
    lat: 38.95968,
    lng: -77.33806,
    city: "Reston",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20609,
    density: 1823.7,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20191,
    lat: 38.93438,
    lng: -77.35184,
    city: "Reston",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30224,
    density: 1504.5,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20194,
    lat: 38.97998,
    lng: -77.34354,
    city: "Reston",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12067,
    density: 1494.5,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20197,
    lat: 39.19379,
    lng: -77.62252,
    city: "Waterford",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2931,
    density: 77.1,
    county_fips: 51107,
    county_name: "Loudoun",
    county_weights: {
      51107: 100,
    },
    county_names_all: "Loudoun",
    county_fips_all: 51107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20198,
    lat: 38.87523,
    lng: -77.76128,
    city: "The Plains",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1854,
    density: 10.3,
    county_fips: 51061,
    county_name: "Fauquier",
    county_weights: {
      51061: 100,
    },
    county_names_all: "Fauquier",
    county_fips_all: 51061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20204,
    lat: 38.88556,
    lng: -77.01443,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20220,
    lat: 38.89713,
    lng: -77.03436,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20230,
    lat: 38.89373,
    lng: -77.03567,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20240,
    lat: 38.89446,
    lng: -77.04261,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20245,
    lat: 38.89358,
    lng: -77.04503,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20250,
    lat: 38.88556,
    lng: -77.03276,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20260,
    lat: 38.88355,
    lng: -77.02504,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20317,
    lat: 38.93645,
    lng: -77.0128,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 419,
    density: 461.6,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20319,
    lat: 38.86706,
    lng: -77.01695,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48,
    density: 134.9,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20373,
    lat: 38.85779,
    lng: -77.01051,
    city: "Naval Anacost Annex",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 187,
    density: 143.1,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20388,
    lat: 38.8718,
    lng: -76.99481,
    city: "Washington Navy Yard",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20390,
    lat: 38.87902,
    lng: -76.99375,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 434,
    density: 39689.1,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20408,
    lat: 38.89284,
    lng: -77.02301,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20415,
    lat: 38.89494,
    lng: -77.0442,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20418,
    lat: 38.8928,
    lng: -77.04776,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20422,
    lat: 38.92714,
    lng: -77.0103,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20427,
    lat: 38.90207,
    lng: -77.04755,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20431,
    lat: 38.89895,
    lng: -77.04419,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20510,
    lat: 38.89278,
    lng: -77.00689,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20515,
    lat: 38.88681,
    lng: -77.00901,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20520,
    lat: 38.8947,
    lng: -77.04848,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20530,
    lat: 38.89313,
    lng: -77.02503,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20535,
    lat: 38.89514,
    lng: -77.02493,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20540,
    lat: 38.88793,
    lng: -77.00471,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20542,
    lat: 38.94136,
    lng: -77.02801,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20551,
    lat: 38.8928,
    lng: -77.0458,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20560,
    lat: 38.8902,
    lng: -77.02745,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20565,
    lat: 38.89007,
    lng: -77.01955,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20566,
    lat: 38.89667,
    lng: -77.05536,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20591,
    lat: 38.88695,
    lng: -77.02297,
    city: "Washington",
    state_id: "DC",
    state_name: "District of Columbia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 11001,
    county_name: "District of Columbia",
    county_weights: {
      11001: 100,
    },
    county_names_all: "District of Columbia",
    county_fips_all: 11001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20601,
    lat: 38.61863,
    lng: -76.85715,
    city: "Waldorf",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26236,
    density: 211.8,
    county_fips: 24017,
    county_name: "Charles",
    county_weights: {
      24017: 83.95,
      24033: 16.05,
    },
    county_names_all: "Charles|Prince George's",
    county_fips_all: "24017|24033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20602,
    lat: 38.58335,
    lng: -76.89466,
    city: "Waldorf",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26835,
    density: 715.7,
    county_fips: 24017,
    county_name: "Charles",
    county_weights: {
      24017: 100,
    },
    county_names_all: "Charles",
    county_fips_all: 24017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20603,
    lat: 38.62972,
    lng: -76.97473,
    city: "Waldorf",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32726,
    density: 780.1,
    county_fips: 24017,
    county_name: "Charles",
    county_weights: {
      24017: 100,
    },
    county_names_all: "Charles",
    county_fips_all: 24017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20606,
    lat: 38.25412,
    lng: -76.73878,
    city: "Abell",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 314,
    density: 133.2,
    county_fips: 24037,
    county_name: "St. Mary's",
    county_weights: {
      24037: 100,
    },
    county_names_all: "St. Mary's",
    county_fips_all: 24037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20607,
    lat: 38.67161,
    lng: -77.02478,
    city: "Accokeek",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10755,
    density: 211.5,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24017: 3.66,
      24033: 96.34,
    },
    county_names_all: "Prince George's|Charles",
    county_fips_all: "24033|24017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20608,
    lat: 38.58638,
    lng: -76.70702,
    city: "Aquasco",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 739,
    density: 16.1,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20609,
    lat: 38.27191,
    lng: -76.74625,
    city: "Avenue",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1211,
    density: 46.7,
    county_fips: 24037,
    county_name: "St. Mary's",
    county_weights: {
      24037: 100,
    },
    county_names_all: "St. Mary's",
    county_fips_all: 24037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20611,
    lat: 38.46251,
    lng: -76.98538,
    city: "Bel Alton",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1354,
    density: 62.9,
    county_fips: 24017,
    county_name: "Charles",
    county_weights: {
      24017: 100,
    },
    county_names_all: "Charles",
    county_fips_all: 24017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20612,
    lat: 38.50708,
    lng: -76.67789,
    city: "Benedict",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 181,
    density: 299.3,
    county_fips: 24017,
    county_name: "Charles",
    county_weights: {
      24017: 100,
    },
    county_names_all: "Charles",
    county_fips_all: 24017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20613,
    lat: 38.67179,
    lng: -76.80576,
    city: "Brandywine",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13240,
    density: 70.6,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24017: 8.13,
      24033: 91.87,
    },
    county_names_all: "Prince George's|Charles",
    county_fips_all: "24033|24017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20615,
    lat: 38.4204,
    lng: -76.54772,
    city: "Broomes Island",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 513,
    density: 272.4,
    county_fips: 24009,
    county_name: "Calvert",
    county_weights: {
      24009: 100,
    },
    county_names_all: "Calvert",
    county_fips_all: 24009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20616,
    lat: 38.65443,
    lng: -77.08848,
    city: "Bryans Road",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6728,
    density: 268.1,
    county_fips: 24017,
    county_name: "Charles",
    county_weights: {
      24017: 100,
    },
    county_names_all: "Charles",
    county_fips_all: 24017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20617,
    lat: 38.54351,
    lng: -76.854,
    city: "Bryantown",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 715,
    density: 46,
    county_fips: 24017,
    county_name: "Charles",
    county_weights: {
      24017: 100,
    },
    county_names_all: "Charles",
    county_fips_all: 24017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20618,
    lat: 38.28152,
    lng: -76.78891,
    city: "Bushwood",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 402,
    density: 20.5,
    county_fips: 24037,
    county_name: "St. Mary's",
    county_weights: {
      24037: 100,
    },
    county_names_all: "St. Mary's",
    county_fips_all: 24037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20619,
    lat: 38.2919,
    lng: -76.52714,
    city: "California",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13845,
    density: 332.8,
    county_fips: 24037,
    county_name: "St. Mary's",
    county_weights: {
      24037: 100,
    },
    county_names_all: "St. Mary's",
    county_fips_all: 24037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20620,
    lat: 38.23288,
    lng: -76.52196,
    city: "Callaway",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1688,
    density: 152.1,
    county_fips: 24037,
    county_name: "St. Mary's",
    county_weights: {
      24037: 100,
    },
    county_names_all: "St. Mary's",
    county_fips_all: 24037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20621,
    lat: 38.33062,
    lng: -76.79438,
    city: "Chaptico",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1277,
    density: 35.6,
    county_fips: 24037,
    county_name: "St. Mary's",
    county_weights: {
      24037: 100,
    },
    county_names_all: "St. Mary's",
    county_fips_all: 24037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20622,
    lat: 38.45281,
    lng: -76.84504,
    city: "Charlotte Hall",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6692,
    density: 70.7,
    county_fips: 24017,
    county_name: "Charles",
    county_weights: {
      24017: 83.11,
      24037: 16.89,
    },
    county_names_all: "Charles|St. Mary's",
    county_fips_all: "24017|24037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20623,
    lat: 38.7423,
    lng: -76.83747,
    city: "Cheltenham",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2619,
    density: 527.1,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20624,
    lat: 38.33523,
    lng: -76.73451,
    city: "Clements",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1242,
    density: 46.1,
    county_fips: 24037,
    county_name: "St. Mary's",
    county_weights: {
      24037: 100,
    },
    county_names_all: "St. Mary's",
    county_fips_all: 24037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20625,
    lat: 38.26212,
    lng: -76.84877,
    city: "Cobb Island",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 929,
    density: 732.9,
    county_fips: 24017,
    county_name: "Charles",
    county_weights: {
      24017: 100,
    },
    county_names_all: "Charles",
    county_fips_all: 24017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20626,
    lat: 38.23256,
    lng: -76.76404,
    city: "Coltons Point",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 278,
    density: 70.2,
    county_fips: 24037,
    county_name: "St. Mary's",
    county_weights: {
      24037: 100,
    },
    county_names_all: "St. Mary's",
    county_fips_all: 24037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20628,
    lat: 38.1459,
    lng: -76.35027,
    city: "Dameron",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 452,
    density: 26.9,
    county_fips: 24037,
    county_name: "St. Mary's",
    county_weights: {
      24037: 100,
    },
    county_names_all: "St. Mary's",
    county_fips_all: 24037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20629,
    lat: 38.33996,
    lng: -76.45388,
    city: "Dowell",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 525,
    density: 241.6,
    county_fips: 24009,
    county_name: "Calvert",
    county_weights: {
      24009: 100,
    },
    county_names_all: "Calvert",
    county_fips_all: 24009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20630,
    lat: 38.16653,
    lng: -76.47087,
    city: "Drayden",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 192,
    density: 10.7,
    county_fips: 24037,
    county_name: "St. Mary's",
    county_weights: {
      24037: 100,
    },
    county_names_all: "St. Mary's",
    county_fips_all: 24037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20632,
    lat: 38.42591,
    lng: -76.95682,
    city: "Faulkner",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 314,
    density: 18.5,
    county_fips: 24017,
    county_name: "Charles",
    county_weights: {
      24017: 100,
    },
    county_names_all: "Charles",
    county_fips_all: 24017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20634,
    lat: 38.24582,
    lng: -76.49412,
    city: "Great Mills",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6961,
    density: 384.4,
    county_fips: 24037,
    county_name: "St. Mary's",
    county_weights: {
      24037: 100,
    },
    county_names_all: "St. Mary's",
    county_fips_all: 24037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20636,
    lat: 38.35582,
    lng: -76.57212,
    city: "Hollywood",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11295,
    density: 126.9,
    county_fips: 24037,
    county_name: "St. Mary's",
    county_weights: {
      24037: 100,
    },
    county_names_all: "St. Mary's",
    county_fips_all: 24037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20637,
    lat: 38.52577,
    lng: -76.77897,
    city: "Hughesville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5288,
    density: 62.4,
    county_fips: 24017,
    county_name: "Charles",
    county_weights: {
      24017: 100,
    },
    county_names_all: "Charles",
    county_fips_all: 24017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20639,
    lat: 38.60823,
    lng: -76.6086,
    city: "Huntingtown",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15216,
    density: 141.2,
    county_fips: 24009,
    county_name: "Calvert",
    county_weights: {
      24009: 100,
    },
    county_names_all: "Calvert",
    county_fips_all: 24009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20640,
    lat: 38.55408,
    lng: -77.1657,
    city: "Indian Head",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11113,
    density: 102.8,
    county_fips: 24017,
    county_name: "Charles",
    county_weights: {
      24017: 100,
    },
    county_names_all: "Charles",
    county_fips_all: 24017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20645,
    lat: 38.29838,
    lng: -76.91413,
    city: "Issue",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 653,
    density: 183.1,
    county_fips: 24017,
    county_name: "Charles",
    county_weights: {
      24017: 100,
    },
    county_names_all: "Charles",
    county_fips_all: 24017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20646,
    lat: 38.52114,
    lng: -76.99989,
    city: "La Plata",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22583,
    density: 109.3,
    county_fips: 24017,
    county_name: "Charles",
    county_weights: {
      24017: 100,
    },
    county_names_all: "Charles",
    county_fips_all: 24017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20650,
    lat: 38.27186,
    lng: -76.63276,
    city: "Leonardtown",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14069,
    density: 88.4,
    county_fips: 24037,
    county_name: "St. Mary's",
    county_weights: {
      24037: 100,
    },
    county_names_all: "St. Mary's",
    county_fips_all: 24037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20653,
    lat: 38.22795,
    lng: -76.43139,
    city: "Lexington Park",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26112,
    density: 303.8,
    county_fips: 24037,
    county_name: "St. Mary's",
    county_weights: {
      24037: 100,
    },
    county_names_all: "St. Mary's",
    county_fips_all: 24037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20656,
    lat: 38.33914,
    lng: -76.6787,
    city: "Loveville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 24037,
    county_name: "St. Mary's",
    county_weights: {
      24037: 100,
    },
    county_names_all: "St. Mary's",
    county_fips_all: 24037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20657,
    lat: 38.38358,
    lng: -76.44537,
    city: "Lusby",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19711,
    density: 254.8,
    county_fips: 24009,
    county_name: "Calvert",
    county_weights: {
      24009: 100,
    },
    county_names_all: "Calvert",
    county_fips_all: 24009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20658,
    lat: 38.56973,
    lng: -77.15958,
    city: "Marbury",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 858,
    density: 75.9,
    county_fips: 24017,
    county_name: "Charles",
    county_weights: {
      24017: 100,
    },
    county_names_all: "Charles",
    county_fips_all: 24017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20659,
    lat: 38.41886,
    lng: -76.73238,
    city: "Mechanicsville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23030,
    density: 91.7,
    county_fips: 24037,
    county_name: "St. Mary's",
    county_weights: {
      24017: 3.99,
      24037: 96.01,
    },
    county_names_all: "St. Mary's|Charles",
    county_fips_all: "24037|24017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20660,
    lat: 38.36928,
    lng: -76.70741,
    city: "Morganza",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 24037,
    county_name: "St. Mary's",
    county_weights: {
      24037: 100,
    },
    county_names_all: "St. Mary's",
    county_fips_all: 24037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20661,
    lat: 38.26474,
    lng: -76.84473,
    city: "Mount Victoria",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 24017,
    county_name: "Charles",
    county_weights: {
      24017: 100,
    },
    county_names_all: "Charles",
    county_fips_all: 24017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20662,
    lat: 38.43359,
    lng: -77.19972,
    city: "Nanjemoy",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2333,
    density: 16,
    county_fips: 24017,
    county_name: "Charles",
    county_weights: {
      24017: 100,
    },
    county_names_all: "Charles",
    county_fips_all: 24017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20664,
    lat: 38.35062,
    lng: -76.91631,
    city: "Newburg",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3285,
    density: 31,
    county_fips: 24017,
    county_name: "Charles",
    county_weights: {
      24017: 100,
    },
    county_names_all: "Charles",
    county_fips_all: 24017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20667,
    lat: 38.21782,
    lng: -76.44537,
    city: "Park Hall",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 868,
    density: 140.4,
    county_fips: 24037,
    county_name: "St. Mary's",
    county_weights: {
      24037: 100,
    },
    county_names_all: "St. Mary's",
    county_fips_all: 24037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20670,
    lat: 38.2824,
    lng: -76.42031,
    city: "Patuxent River",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1620,
    density: 66.9,
    county_fips: 24037,
    county_name: "St. Mary's",
    county_weights: {
      24037: 100,
    },
    county_names_all: "St. Mary's",
    county_fips_all: 24037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20674,
    lat: 38.13307,
    lng: -76.50019,
    city: "Piney Point",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1082,
    density: 225,
    county_fips: 24037,
    county_name: "St. Mary's",
    county_weights: {
      24037: 100,
    },
    county_names_all: "St. Mary's",
    county_fips_all: 24037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20675,
    lat: 38.58349,
    lng: -77.01522,
    city: "Pomfret",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1662,
    density: 90.1,
    county_fips: 24017,
    county_name: "Charles",
    county_weights: {
      24017: 100,
    },
    county_names_all: "Charles",
    county_fips_all: 24017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20676,
    lat: 38.4869,
    lng: -76.54788,
    city: "Port Republic",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3631,
    density: 97.2,
    county_fips: 24009,
    county_name: "Calvert",
    county_weights: {
      24009: 100,
    },
    county_names_all: "Calvert",
    county_fips_all: 24009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20677,
    lat: 38.49992,
    lng: -77.04016,
    city: "Port Tobacco",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2215,
    density: 54.7,
    county_fips: 24017,
    county_name: "Charles",
    county_weights: {
      24017: 100,
    },
    county_names_all: "Charles",
    county_fips_all: 24017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20678,
    lat: 38.52164,
    lng: -76.60072,
    city: "Prince Frederick",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12418,
    density: 106.8,
    county_fips: 24009,
    county_name: "Calvert",
    county_weights: {
      24009: 100,
    },
    county_names_all: "Calvert",
    county_fips_all: 24009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20680,
    lat: 38.11071,
    lng: -76.37353,
    city: "Ridge",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 649,
    density: 31.8,
    county_fips: 24037,
    county_name: "St. Mary's",
    county_weights: {
      24037: 100,
    },
    county_names_all: "St. Mary's",
    county_fips_all: 24037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20684,
    lat: 38.14308,
    lng: -76.41027,
    city: "Saint Inigoes",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 784,
    density: 36.3,
    county_fips: 24037,
    county_name: "St. Mary's",
    county_weights: {
      24037: 100,
    },
    county_names_all: "St. Mary's",
    county_fips_all: 24037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20685,
    lat: 38.43465,
    lng: -76.52904,
    city: "Saint Leonard",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6732,
    density: 113.5,
    county_fips: 24009,
    county_name: "Calvert",
    county_weights: {
      24009: 100,
    },
    county_names_all: "Calvert",
    county_fips_all: 24009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20686,
    lat: 38.18557,
    lng: -76.43898,
    city: "Saint Marys City",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1639,
    density: 2334.7,
    county_fips: 24037,
    county_name: "St. Mary's",
    county_weights: {
      24037: 100,
    },
    county_names_all: "St. Mary's",
    county_fips_all: 24037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20687,
    lat: 38.07578,
    lng: -76.34382,
    city: "Scotland",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 429,
    density: 33.2,
    county_fips: 24037,
    county_name: "St. Mary's",
    county_weights: {
      24037: 100,
    },
    county_names_all: "St. Mary's",
    county_fips_all: 24037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20688,
    lat: 38.33475,
    lng: -76.46965,
    city: "Solomons",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1945,
    density: 652.1,
    county_fips: 24009,
    county_name: "Calvert",
    county_weights: {
      24009: 100,
    },
    county_names_all: "Calvert",
    county_fips_all: 24009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20689,
    lat: 38.66963,
    lng: -76.58591,
    city: "Sunderland",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2386,
    density: 119.5,
    county_fips: 24009,
    county_name: "Calvert",
    county_weights: {
      24009: 100,
    },
    county_names_all: "Calvert",
    county_fips_all: 24009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20690,
    lat: 38.15916,
    lng: -76.52631,
    city: "Tall Timbers",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 950,
    density: 219.9,
    county_fips: 24037,
    county_name: "St. Mary's",
    county_weights: {
      24037: 100,
    },
    county_names_all: "St. Mary's",
    county_fips_all: 24037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20692,
    lat: 38.18352,
    lng: -76.50682,
    city: "Valley Lee",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 684,
    density: 36.7,
    county_fips: 24037,
    county_name: "St. Mary's",
    county_weights: {
      24037: 100,
    },
    county_names_all: "St. Mary's",
    county_fips_all: 24037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20693,
    lat: 38.45924,
    lng: -77.08931,
    city: "Welcome",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1171,
    density: 22.4,
    county_fips: 24017,
    county_name: "Charles",
    county_weights: {
      24017: 100,
    },
    county_names_all: "Charles",
    county_fips_all: 24017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20695,
    lat: 38.58885,
    lng: -76.97269,
    city: "White Plains",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8400,
    density: 225.4,
    county_fips: 24017,
    county_name: "Charles",
    county_weights: {
      24017: 100,
    },
    county_names_all: "Charles",
    county_fips_all: 24017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20701,
    lat: 39.12877,
    lng: -76.78803,
    city: "Annapolis Junction",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 760,
    density: 133.3,
    county_fips: 24027,
    county_name: "Howard",
    county_weights: {
      24003: 45.95,
      24027: 54.05,
    },
    county_names_all: "Howard|Anne Arundel",
    county_fips_all: "24027|24003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20705,
    lat: 39.04503,
    lng: -76.90009,
    city: "Beltsville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28348,
    density: 757.4,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24031: 1.14,
      24033: 98.86,
    },
    county_names_all: "Prince George's|Montgomery",
    county_fips_all: "24033|24031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20706,
    lat: 38.96548,
    lng: -76.85091,
    city: "Lanham",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45329,
    density: 1741.5,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20707,
    lat: 39.09563,
    lng: -76.8842,
    city: "Laurel",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32184,
    density: 982.4,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24031: 6.49,
      24033: 93.51,
    },
    county_names_all: "Prince George's|Montgomery",
    county_fips_all: "24033|24031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20708,
    lat: 39.04546,
    lng: -76.83462,
    city: "Laurel",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26842,
    density: 852.5,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20710,
    lat: 38.94204,
    lng: -76.92623,
    city: "Bladensburg",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9483,
    density: 3278.7,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20711,
    lat: 38.80485,
    lng: -76.65245,
    city: "Lothian",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7400,
    density: 84.5,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20712,
    lat: 38.94306,
    lng: -76.96517,
    city: "Mount Rainier",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9649,
    density: 5104.4,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20714,
    lat: 38.71813,
    lng: -76.53987,
    city: "North Beach",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5331,
    density: 1446.7,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 64.4,
      24009: 35.6,
    },
    county_names_all: "Anne Arundel|Calvert",
    county_fips_all: "24003|24009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20715,
    lat: 38.98643,
    lng: -76.73967,
    city: "Bowie",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27360,
    density: 751.9,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20716,
    lat: 38.92734,
    lng: -76.71494,
    city: "Bowie",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22223,
    density: 746.4,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20720,
    lat: 38.9971,
    lng: -76.78588,
    city: "Bowie",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23618,
    density: 618.8,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20721,
    lat: 38.92106,
    lng: -76.78881,
    city: "Bowie",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30121,
    density: 690.9,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20722,
    lat: 38.9351,
    lng: -76.94944,
    city: "Brentwood",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5604,
    density: 1470.7,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20723,
    lat: 39.13664,
    lng: -76.86647,
    city: "Laurel",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36082,
    density: 1070.1,
    county_fips: 24027,
    county_name: "Howard",
    county_weights: {
      24027: 100,
    },
    county_names_all: "Howard",
    county_fips_all: 24027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20724,
    lat: 39.08028,
    lng: -76.79054,
    city: "Laurel",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17681,
    density: 362.7,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20732,
    lat: 38.65573,
    lng: -76.54292,
    city: "Chesapeake Beach",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10295,
    density: 356.5,
    county_fips: 24009,
    county_name: "Calvert",
    county_weights: {
      24009: 100,
    },
    county_names_all: "Calvert",
    county_fips_all: 24009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20733,
    lat: 38.80628,
    lng: -76.53139,
    city: "Churchton",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2645,
    density: 283.6,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20735,
    lat: 38.75034,
    lng: -76.90566,
    city: "Clinton",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37009,
    density: 551.2,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20736,
    lat: 38.6913,
    lng: -76.62855,
    city: "Owings",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8715,
    density: 136,
    county_fips: 24009,
    county_name: "Calvert",
    county_weights: {
      24003: 2.86,
      24009: 97.14,
    },
    county_names_all: "Calvert|Anne Arundel",
    county_fips_all: "24009|24003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20737,
    lat: 38.96247,
    lng: -76.91571,
    city: "Riverdale",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22666,
    density: 2764.8,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20740,
    lat: 39.00193,
    lng: -76.93096,
    city: "College Park",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31723,
    density: 1394.6,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20742,
    lat: 38.99422,
    lng: -76.94347,
    city: "College Park",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6511,
    density: 7796.8,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20743,
    lat: 38.88372,
    lng: -76.89362,
    city: "Capitol Heights",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38747,
    density: 1552.1,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20744,
    lat: 38.75362,
    lng: -76.98393,
    city: "Fort Washington",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54572,
    density: 807.6,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20745,
    lat: 38.80552,
    lng: -76.99495,
    city: "Oxon Hill",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27503,
    density: 1631.9,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20746,
    lat: 38.83664,
    lng: -76.91936,
    city: "Suitland",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26396,
    density: 1347,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20747,
    lat: 38.85348,
    lng: -76.88377,
    city: "District Heights",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41128,
    density: 2009.8,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20748,
    lat: 38.81692,
    lng: -76.94124,
    city: "Temple Hills",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38720,
    density: 1607.4,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20751,
    lat: 38.79552,
    lng: -76.56221,
    city: "Deale",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1972,
    density: 146.8,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20754,
    lat: 38.736,
    lng: -76.65493,
    city: "Dunkirk",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6950,
    density: 167.4,
    county_fips: 24009,
    county_name: "Calvert",
    county_weights: {
      24003: 16.14,
      24009: 83.86,
    },
    county_names_all: "Calvert|Anne Arundel",
    county_fips_all: "24009|24003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20755,
    lat: 39.09892,
    lng: -76.74479,
    city: "Fort George G Meade",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11340,
    density: 415.2,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20758,
    lat: 38.73399,
    lng: -76.58961,
    city: "Friendship",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 486,
    density: 38.6,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 97.47,
      24009: 2.53,
    },
    county_names_all: "Anne Arundel|Calvert",
    county_fips_all: "24003|24009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20759,
    lat: 39.15419,
    lng: -76.92877,
    city: "Fulton",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4721,
    density: 290.1,
    county_fips: 24027,
    county_name: "Howard",
    county_weights: {
      24027: 100,
    },
    county_names_all: "Howard",
    county_fips_all: 24027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20762,
    lat: 38.80748,
    lng: -76.87457,
    city: "Andrews Air Force Base",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3316,
    density: 219.7,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20763,
    lat: 39.13786,
    lng: -76.82134,
    city: "Savage",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1955,
    density: 707.8,
    county_fips: 24027,
    county_name: "Howard",
    county_weights: {
      24027: 100,
    },
    county_names_all: "Howard",
    county_fips_all: 24027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20764,
    lat: 38.83374,
    lng: -76.51146,
    city: "Shady Side",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3482,
    density: 338.2,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20765,
    lat: 38.84533,
    lng: -76.54654,
    city: "Galesville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 530,
    density: 434.2,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20769,
    lat: 38.98818,
    lng: -76.81635,
    city: "Glenn Dale",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6172,
    density: 366.9,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20770,
    lat: 38.99981,
    lng: -76.88567,
    city: "Greenbelt",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24602,
    density: 1300.5,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20771,
    lat: 39.00289,
    lng: -76.85534,
    city: "Greenbelt",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20772,
    lat: 38.7785,
    lng: -76.76911,
    city: "Upper Marlboro",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46471,
    density: 247.6,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20774,
    lat: 38.87589,
    lng: -76.76925,
    city: "Upper Marlboro",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49907,
    density: 552.5,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20776,
    lat: 38.86913,
    lng: -76.6067,
    city: "Harwood",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2940,
    density: 52.5,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20777,
    lat: 39.17487,
    lng: -76.96783,
    city: "Highland",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3444,
    density: 176.3,
    county_fips: 24027,
    county_name: "Howard",
    county_weights: {
      24027: 98.2,
      24031: 1.8,
    },
    county_names_all: "Howard|Montgomery",
    county_fips_all: "24027|24031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20778,
    lat: 38.83733,
    lng: -76.56647,
    city: "West River",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2460,
    density: 124.3,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20779,
    lat: 38.76388,
    lng: -76.57665,
    city: "Tracys Landing",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 956,
    density: 54.1,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20781,
    lat: 38.94229,
    lng: -76.93655,
    city: "Hyattsville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11460,
    density: 1799,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20782,
    lat: 38.96469,
    lng: -76.9649,
    city: "Hyattsville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32527,
    density: 2953.4,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20783,
    lat: 38.99988,
    lng: -76.96886,
    city: "Hyattsville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45550,
    density: 3012.2,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20784,
    lat: 38.95145,
    lng: -76.89025,
    city: "Hyattsville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30381,
    density: 2833.7,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20785,
    lat: 38.91849,
    lng: -76.88237,
    city: "Hyattsville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39237,
    density: 1497,
    county_fips: 24033,
    county_name: "Prince George's",
    county_weights: {
      24033: 100,
    },
    county_names_all: "Prince George's",
    county_fips_all: 24033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20794,
    lat: 39.15107,
    lng: -76.78882,
    city: "Jessup",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16956,
    density: 678.8,
    county_fips: 24027,
    county_name: "Howard",
    county_weights: {
      24003: 33.46,
      24027: 66.54,
    },
    county_names_all: "Howard|Anne Arundel",
    county_fips_all: "24027|24003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20812,
    lat: 38.96677,
    lng: -77.14357,
    city: "Glen Echo",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 323,
    density: 705,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20814,
    lat: 39.00506,
    lng: -77.10295,
    city: "Bethesda",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29632,
    density: 2565.8,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20815,
    lat: 38.98369,
    lng: -77.07845,
    city: "Chevy Chase",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30908,
    density: 2216.3,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20816,
    lat: 38.95612,
    lng: -77.11873,
    city: "Bethesda",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16661,
    density: 1804.9,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20817,
    lat: 38.99809,
    lng: -77.14919,
    city: "Bethesda",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38131,
    density: 1048.7,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20818,
    lat: 38.97347,
    lng: -77.16188,
    city: "Cabin John",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2072,
    density: 861.9,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20832,
    lat: 39.15134,
    lng: -77.07331,
    city: "Olney",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25427,
    density: 1021.6,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20833,
    lat: 39.20595,
    lng: -77.05552,
    city: "Brookeville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7746,
    density: 156.5,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24027: 9.57,
      24031: 90.43,
    },
    county_names_all: "Montgomery|Howard",
    county_fips_all: "24031|24027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20837,
    lat: 39.11208,
    lng: -77.40823,
    city: "Poolesville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6129,
    density: 58.7,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20838,
    lat: 39.22341,
    lng: -77.37223,
    city: "Barnesville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 377,
    density: 155.6,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20839,
    lat: 39.17909,
    lng: -77.41438,
    city: "Beallsville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 139,
    density: 17.6,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20841,
    lat: 39.1858,
    lng: -77.32581,
    city: "Boyds",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11692,
    density: 166.3,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20842,
    lat: 39.20831,
    lng: -77.42473,
    city: "Dickerson",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1467,
    density: 10.2,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24021: 22.54,
      24031: 77.46,
    },
    county_names_all: "Montgomery|Frederick",
    county_fips_all: "24031|24021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20850,
    lat: 39.0908,
    lng: -77.1809,
    city: "Rockville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53522,
    density: 1463.8,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20851,
    lat: 39.07767,
    lng: -77.12089,
    city: "Rockville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14519,
    density: 2211,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20852,
    lat: 39.05134,
    lng: -77.12507,
    city: "Rockville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47338,
    density: 2263.6,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20853,
    lat: 39.10237,
    lng: -77.09462,
    city: "Rockville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31510,
    density: 1347.2,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20854,
    lat: 39.03413,
    lng: -77.22149,
    city: "Potomac",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49196,
    density: 561.8,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20855,
    lat: 39.13702,
    lng: -77.13197,
    city: "Derwood",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15955,
    density: 471.2,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20860,
    lat: 39.15072,
    lng: -77.03069,
    city: "Sandy Spring",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2890,
    density: 309.2,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20861,
    lat: 39.14653,
    lng: -76.99886,
    city: "Ashton",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2015,
    density: 150.3,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20862,
    lat: 39.18039,
    lng: -77.01879,
    city: "Brinklow",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 359,
    density: 87.9,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24027: 0.4,
      24031: 99.6,
    },
    county_names_all: "Montgomery|Howard",
    county_fips_all: "24031|24027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20866,
    lat: 39.10969,
    lng: -76.93411,
    city: "Burtonsville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16974,
    density: 932.6,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20868,
    lat: 39.12534,
    lng: -76.96834,
    city: "Spencerville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 539,
    density: 128,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20871,
    lat: 39.2592,
    lng: -77.28187,
    city: "Clarksburg",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18961,
    density: 319.9,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24021: 5.65,
      24031: 94.35,
    },
    county_names_all: "Montgomery|Frederick",
    county_fips_all: "24031|24021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20872,
    lat: 39.29142,
    lng: -77.21619,
    city: "Damascus",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12790,
    density: 248.3,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20874,
    lat: 39.1291,
    lng: -77.29721,
    city: "Germantown",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60258,
    density: 1026.1,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20876,
    lat: 39.20706,
    lng: -77.23284,
    city: "Germantown",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31703,
    density: 1128,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20877,
    lat: 39.14068,
    lng: -77.18865,
    city: "Gaithersburg",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37948,
    density: 2597.5,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20878,
    lat: 39.11376,
    lng: -77.24781,
    city: "Gaithersburg",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63576,
    density: 1200.4,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20879,
    lat: 39.16992,
    lng: -77.17416,
    city: "Gaithersburg",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26343,
    density: 1180.5,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20880,
    lat: 39.14077,
    lng: -77.17456,
    city: "Washington Grove",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 530,
    density: 613.4,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20882,
    lat: 39.23182,
    lng: -77.14514,
    city: "Gaithersburg",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14441,
    density: 147.7,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20886,
    lat: 39.17952,
    lng: -77.197,
    city: "Montgomery Village",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34887,
    density: 3284.5,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20889,
    lat: 39.00193,
    lng: -77.09038,
    city: "Bethesda",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20892,
    lat: 39.0006,
    lng: -77.10373,
    city: "Bethesda",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20894,
    lat: 38.99591,
    lng: -77.10221,
    city: "Bethesda",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20895,
    lat: 39.02696,
    lng: -77.07781,
    city: "Kensington",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18930,
    density: 1794,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20896,
    lat: 39.03521,
    lng: -77.09494,
    city: "Garrett Park",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 792,
    density: 895.4,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20899,
    lat: 39.14442,
    lng: -77.21621,
    city: "Gaithersburg",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 284,
    density: 1034.4,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20901,
    lat: 39.02155,
    lng: -77.00919,
    city: "Silver Spring",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36802,
    density: 2656.8,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20902,
    lat: 39.04381,
    lng: -77.0421,
    city: "Silver Spring",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52752,
    density: 2692.8,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20903,
    lat: 39.02128,
    lng: -76.9821,
    city: "Silver Spring",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26951,
    density: 3051.4,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 94.94,
      24033: 5.06,
    },
    county_names_all: "Montgomery|Prince George's",
    county_fips_all: "24031|24033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20904,
    lat: 39.06608,
    lng: -76.97918,
    city: "Silver Spring",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55856,
    density: 1570.9,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 97.42,
      24033: 2.58,
    },
    county_names_all: "Montgomery|Prince George's",
    county_fips_all: "24031|24033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20905,
    lat: 39.11052,
    lng: -76.99036,
    city: "Silver Spring",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18590,
    density: 609,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20906,
    lat: 39.08858,
    lng: -77.05522,
    city: "Silver Spring",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 70441,
    density: 2135.9,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20910,
    lat: 39.00227,
    lng: -77.03634,
    city: "Silver Spring",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43729,
    density: 3673.6,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 24031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 20912,
    lat: 38.98182,
    lng: -77.00106,
    city: "Takoma Park",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25118,
    density: 3620,
    county_fips: 24031,
    county_name: "Montgomery",
    county_weights: {
      24031: 89.99,
      24033: 10.01,
    },
    county_names_all: "Montgomery|Prince George's",
    county_fips_all: "24031|24033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21001,
    lat: 39.51077,
    lng: -76.20274,
    city: "Aberdeen",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24959,
    density: 321.7,
    county_fips: 24025,
    county_name: "Harford",
    county_weights: {
      24025: 100,
    },
    county_names_all: "Harford",
    county_fips_all: 24025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21005,
    lat: 39.44101,
    lng: -76.16509,
    city: "Aberdeen Proving Ground",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2724,
    density: 31.5,
    county_fips: 24025,
    county_name: "Harford",
    county_weights: {
      24025: 100,
    },
    county_names_all: "Harford",
    county_fips_all: 24025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21009,
    lat: 39.47032,
    lng: -76.29378,
    city: "Abingdon",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31683,
    density: 1072.9,
    county_fips: 24025,
    county_name: "Harford",
    county_weights: {
      24025: 100,
    },
    county_names_all: "Harford",
    county_fips_all: 24025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21010,
    lat: 39.38953,
    lng: -76.29851,
    city: "Gunpowder",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 329,
    density: 17.5,
    county_fips: 24025,
    county_name: "Harford",
    county_weights: {
      24025: 100,
    },
    county_names_all: "Harford",
    county_fips_all: 24025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21012,
    lat: 39.04529,
    lng: -76.49716,
    city: "Arnold",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22746,
    density: 898,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21013,
    lat: 39.51123,
    lng: -76.49124,
    city: "Baldwin",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5157,
    density: 132.7,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 71.01,
      24025: 28.99,
    },
    county_names_all: "Baltimore|Harford",
    county_fips_all: "24005|24025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21014,
    lat: 39.53606,
    lng: -76.35164,
    city: "Bel Air",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35668,
    density: 989.6,
    county_fips: 24025,
    county_name: "Harford",
    county_weights: {
      24025: 100,
    },
    county_names_all: "Harford",
    county_fips_all: 24025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21015,
    lat: 39.54691,
    lng: -76.29619,
    city: "Bel Air",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28975,
    density: 358,
    county_fips: 24025,
    county_name: "Harford",
    county_weights: {
      24025: 100,
    },
    county_names_all: "Harford",
    county_fips_all: 24025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21017,
    lat: 39.47498,
    lng: -76.23667,
    city: "Belcamp",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6034,
    density: 870.4,
    county_fips: 24025,
    county_name: "Harford",
    county_weights: {
      24025: 100,
    },
    county_names_all: "Harford",
    county_fips_all: 24025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21023,
    lat: 39.52368,
    lng: -76.73984,
    city: "Butler",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21028,
    lat: 39.56832,
    lng: -76.24162,
    city: "Churchville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2609,
    density: 78.3,
    county_fips: 24025,
    county_name: "Harford",
    county_weights: {
      24025: 100,
    },
    county_names_all: "Harford",
    county_fips_all: 24025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21029,
    lat: 39.20633,
    lng: -76.95206,
    city: "Clarksville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11523,
    density: 263,
    county_fips: 24027,
    county_name: "Howard",
    county_weights: {
      24027: 100,
    },
    county_names_all: "Howard",
    county_fips_all: 24027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21030,
    lat: 39.49002,
    lng: -76.6659,
    city: "Cockeysville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24152,
    density: 387.7,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21031,
    lat: 39.4874,
    lng: -76.65792,
    city: "Hunt Valley",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26,
    density: 10.7,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21032,
    lat: 39.03376,
    lng: -76.60401,
    city: "Crownsville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7787,
    density: 173.9,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21034,
    lat: 39.64905,
    lng: -76.22261,
    city: "Darlington",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3178,
    density: 46,
    county_fips: 24025,
    county_name: "Harford",
    county_weights: {
      24025: 100,
    },
    county_names_all: "Harford",
    county_fips_all: 24025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21035,
    lat: 38.93637,
    lng: -76.63875,
    city: "Davidsonville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8315,
    density: 103.4,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21036,
    lat: 39.23416,
    lng: -77.00223,
    city: "Dayton",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2243,
    density: 138.5,
    county_fips: 24027,
    county_name: "Howard",
    county_weights: {
      24027: 100,
    },
    county_names_all: "Howard",
    county_fips_all: 24027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21037,
    lat: 38.91476,
    lng: -76.54361,
    city: "Edgewater",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21134,
    density: 485.7,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21040,
    lat: 39.42953,
    lng: -76.28947,
    city: "Edgewood",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24717,
    density: 972.4,
    county_fips: 24025,
    county_name: "Harford",
    county_weights: {
      24025: 100,
    },
    county_names_all: "Harford",
    county_fips_all: 24025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21042,
    lat: 39.27105,
    lng: -76.8924,
    city: "Ellicott City",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42157,
    density: 439.9,
    county_fips: 24027,
    county_name: "Howard",
    county_weights: {
      24027: 100,
    },
    county_names_all: "Howard",
    county_fips_all: 24027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21043,
    lat: 39.25759,
    lng: -76.79773,
    city: "Ellicott City",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46747,
    density: 1055.7,
    county_fips: 24027,
    county_name: "Howard",
    county_weights: {
      24005: 3.5,
      24027: 96.5,
    },
    county_names_all: "Howard|Baltimore",
    county_fips_all: "24027|24005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21044,
    lat: 39.21047,
    lng: -76.88353,
    city: "Columbia",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45741,
    density: 1485.8,
    county_fips: 24027,
    county_name: "Howard",
    county_weights: {
      24027: 100,
    },
    county_names_all: "Howard",
    county_fips_all: 24027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21045,
    lat: 39.20622,
    lng: -76.82747,
    city: "Columbia",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40265,
    density: 1603.1,
    county_fips: 24027,
    county_name: "Howard",
    county_weights: {
      24027: 100,
    },
    county_names_all: "Howard",
    county_fips_all: 24027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21046,
    lat: 39.17357,
    lng: -76.84183,
    city: "Columbia",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15597,
    density: 771.1,
    county_fips: 24027,
    county_name: "Howard",
    county_weights: {
      24027: 100,
    },
    county_names_all: "Howard",
    county_fips_all: 24027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21047,
    lat: 39.52818,
    lng: -76.43781,
    city: "Fallston",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12629,
    density: 216.3,
    county_fips: 24025,
    county_name: "Harford",
    county_weights: {
      24025: 100,
    },
    county_names_all: "Harford",
    county_fips_all: 24025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21048,
    lat: 39.49568,
    lng: -76.91057,
    city: "Finksburg",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9719,
    density: 137.7,
    county_fips: 24013,
    county_name: "Carroll",
    county_weights: {
      24013: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 24013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21050,
    lat: 39.58569,
    lng: -76.39228,
    city: "Forest Hill",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17846,
    density: 237.6,
    county_fips: 24025,
    county_name: "Harford",
    county_weights: {
      24025: 100,
    },
    county_names_all: "Harford",
    county_fips_all: 24025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21051,
    lat: 39.4721,
    lng: -76.45388,
    city: "Fork",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 231,
    density: 224.4,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21052,
    lat: 39.20238,
    lng: -76.44379,
    city: "Fort Howard",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 179,
    density: 172,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21053,
    lat: 39.69296,
    lng: -76.71567,
    city: "Freeland",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3134,
    density: 55.8,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21054,
    lat: 39.02624,
    lng: -76.67083,
    city: "Gambrills",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11697,
    density: 283.8,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21056,
    lat: 39.07805,
    lng: -76.4338,
    city: "Gibson Island",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 333,
    density: 93.4,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21057,
    lat: 39.45111,
    lng: -76.50606,
    city: "Glen Arm",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4109,
    density: 99.8,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21060,
    lat: 39.16893,
    lng: -76.58346,
    city: "Glen Burnie",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36049,
    density: 1072.7,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21061,
    lat: 39.16116,
    lng: -76.63226,
    city: "Glen Burnie",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55020,
    density: 1742.6,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21071,
    lat: 39.48516,
    lng: -76.8081,
    city: "Glyndon",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 454,
    density: 116.8,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21074,
    lat: 39.61746,
    lng: -76.84351,
    city: "Hampstead",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14933,
    density: 153,
    county_fips: 24013,
    county_name: "Carroll",
    county_weights: {
      24005: 29.35,
      24013: 70.65,
    },
    county_names_all: "Carroll|Baltimore",
    county_fips_all: "24013|24005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21075,
    lat: 39.20414,
    lng: -76.75301,
    city: "Elkridge",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34939,
    density: 968.3,
    county_fips: 24027,
    county_name: "Howard",
    county_weights: {
      24027: 100,
    },
    county_names_all: "Howard",
    county_fips_all: 24027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21076,
    lat: 39.16856,
    lng: -76.72239,
    city: "Hanover",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17947,
    density: 527.2,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 89.75,
      24027: 10.25,
    },
    county_names_all: "Anne Arundel|Howard",
    county_fips_all: "24003|24027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21077,
    lat: 39.1583,
    lng: -76.69953,
    city: "Harmans",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 235,
    density: 206.8,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21078,
    lat: 39.56911,
    lng: -76.14776,
    city: "Havre De Grace",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18957,
    density: 243.2,
    county_fips: 24025,
    county_name: "Harford",
    county_weights: {
      24025: 100,
    },
    county_names_all: "Harford",
    county_fips_all: 24025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21082,
    lat: 39.48284,
    lng: -76.46735,
    city: "Hydes",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 608,
    density: 39,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 97.35,
      24025: 2.65,
    },
    county_names_all: "Baltimore|Harford",
    county_fips_all: "24005|24025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21084,
    lat: 39.61659,
    lng: -76.46317,
    city: "Jarrettsville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7670,
    density: 124.6,
    county_fips: 24025,
    county_name: "Harford",
    county_weights: {
      24025: 100,
    },
    county_names_all: "Harford",
    county_fips_all: 24025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21085,
    lat: 39.44462,
    lng: -76.35601,
    city: "Joppa",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16318,
    density: 332.1,
    county_fips: 24025,
    county_name: "Harford",
    county_weights: {
      24005: 6.25,
      24025: 93.75,
    },
    county_names_all: "Harford|Baltimore",
    county_fips_all: "24025|24005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21087,
    lat: 39.44728,
    lng: -76.41583,
    city: "Kingsville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5437,
    density: 143.5,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 90.04,
      24025: 9.96,
    },
    county_names_all: "Baltimore|Harford",
    county_fips_all: "24005|24025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21090,
    lat: 39.20919,
    lng: -76.66796,
    city: "Linthicum Heights",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9715,
    density: 564.8,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21093,
    lat: 39.43773,
    lng: -76.64318,
    city: "Lutherville Timonium",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38245,
    density: 730,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21102,
    lat: 39.68732,
    lng: -76.84564,
    city: "Manchester",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12043,
    density: 114.4,
    county_fips: 24013,
    county_name: "Carroll",
    county_weights: {
      24005: 24.35,
      24013: 75.65,
    },
    county_names_all: "Carroll|Baltimore",
    county_fips_all: "24013|24005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21104,
    lat: 39.35044,
    lng: -76.90654,
    city: "Marriottsville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6029,
    density: 136.5,
    county_fips: 24027,
    county_name: "Howard",
    county_weights: {
      24005: 15.07,
      24013: 33.87,
      24027: 51.06,
    },
    county_names_all: "Howard|Carroll|Baltimore",
    county_fips_all: "24027|24013|24005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21105,
    lat: 39.71512,
    lng: -76.65225,
    city: "Maryland Line",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21108,
    lat: 39.08932,
    lng: -76.62139,
    city: "Millersville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19136,
    density: 572.1,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21111,
    lat: 39.57568,
    lng: -76.58089,
    city: "Monkton",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5343,
    density: 58.4,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 76.78,
      24025: 23.22,
    },
    county_names_all: "Baltimore|Harford",
    county_fips_all: "24005|24025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21113,
    lat: 39.05448,
    lng: -76.71519,
    city: "Odenton",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35210,
    density: 909.3,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21114,
    lat: 39.00967,
    lng: -76.6839,
    city: "Crofton",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26460,
    density: 1767.8,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21117,
    lat: 39.42719,
    lng: -76.77795,
    city: "Owings Mills",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59663,
    density: 775.2,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21120,
    lat: 39.64723,
    lng: -76.67703,
    city: "Parkton",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6775,
    density: 62.3,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21122,
    lat: 39.11631,
    lng: -76.49941,
    city: "Pasadena",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59664,
    density: 734.2,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21128,
    lat: 39.40526,
    lng: -76.44628,
    city: "Perry Hall",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13967,
    density: 792.3,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21130,
    lat: 39.47495,
    lng: -76.18921,
    city: "Perryman",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 104,
    density: 73.3,
    county_fips: 24025,
    county_name: "Harford",
    county_weights: {
      24025: 100,
    },
    county_names_all: "Harford",
    county_fips_all: 24025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21131,
    lat: 39.50338,
    lng: -76.57486,
    city: "Phoenix",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7587,
    density: 139.3,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21132,
    lat: 39.69601,
    lng: -76.42577,
    city: "Pylesville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3162,
    density: 54.6,
    county_fips: 24025,
    county_name: "Harford",
    county_weights: {
      24025: 100,
    },
    county_names_all: "Harford",
    county_fips_all: 24025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21133,
    lat: 39.37705,
    lng: -76.81174,
    city: "Randallstown",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32714,
    density: 1409.6,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21136,
    lat: 39.48851,
    lng: -76.80888,
    city: "Reisterstown",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34347,
    density: 236,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 96.26,
      24013: 3.74,
    },
    county_names_all: "Baltimore|Carroll",
    county_fips_all: "24005|24013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21140,
    lat: 38.95062,
    lng: -76.58569,
    city: "Riva",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3862,
    density: 1052.6,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21144,
    lat: 39.12058,
    lng: -76.67767,
    city: "Severn",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35680,
    density: 834.5,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21146,
    lat: 39.07737,
    lng: -76.55613,
    city: "Severna Park",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27634,
    density: 1052.7,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21152,
    lat: 39.54905,
    lng: -76.68107,
    city: "Sparks Glencoe",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5349,
    density: 85.3,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21153,
    lat: 39.41649,
    lng: -76.707,
    city: "Stevenson",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 348,
    density: 46.8,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21154,
    lat: 39.65314,
    lng: -76.36087,
    city: "Street",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6467,
    density: 63.5,
    county_fips: 24025,
    county_name: "Harford",
    county_weights: {
      24025: 100,
    },
    county_names_all: "Harford",
    county_fips_all: 24025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21155,
    lat: 39.57183,
    lng: -76.80597,
    city: "Upperco",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2363,
    density: 41.2,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 89,
      24013: 11,
    },
    county_names_all: "Baltimore|Carroll",
    county_fips_all: "24005|24013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21156,
    lat: 39.43752,
    lng: -76.397,
    city: "Upper Falls",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 371,
    density: 136.5,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21157,
    lat: 39.54889,
    lng: -76.98162,
    city: "Westminster",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38714,
    density: 192.4,
    county_fips: 24013,
    county_name: "Carroll",
    county_weights: {
      24013: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 24013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21158,
    lat: 39.6466,
    lng: -77.03217,
    city: "Westminster",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20773,
    density: 109.4,
    county_fips: 24013,
    county_name: "Carroll",
    county_weights: {
      24013: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 24013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21160,
    lat: 39.70728,
    lng: -76.30754,
    city: "Whiteford",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2615,
    density: 65.1,
    county_fips: 24025,
    county_name: "Harford",
    county_weights: {
      24025: 100,
    },
    county_names_all: "Harford",
    county_fips_all: 24025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21161,
    lat: 39.65983,
    lng: -76.56475,
    city: "White Hall",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5738,
    density: 45.7,
    county_fips: 24025,
    county_name: "Harford",
    county_weights: {
      24005: 46.67,
      24025: 53.33,
    },
    county_names_all: "Harford|Baltimore",
    county_fips_all: "24025|24005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21162,
    lat: 39.39084,
    lng: -76.40164,
    city: "White Marsh",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4089,
    density: 221.5,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21163,
    lat: 39.34024,
    lng: -76.85706,
    city: "Woodstock",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6602,
    density: 186.9,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 73.49,
      24027: 26.51,
    },
    county_names_all: "Baltimore|Howard",
    county_fips_all: "24005|24027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21201,
    lat: 39.29487,
    lng: -76.62237,
    city: "Baltimore",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17534,
    density: 5332.7,
    county_fips: 24510,
    county_name: "Baltimore",
    county_weights: {
      24510: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21202,
    lat: 39.29705,
    lng: -76.60747,
    city: "Baltimore",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21880,
    density: 5228.8,
    county_fips: 24510,
    county_name: "Baltimore",
    county_weights: {
      24510: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21204,
    lat: 39.40353,
    lng: -76.63024,
    city: "Towson",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21518,
    density: 1326.7,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21205,
    lat: 39.30227,
    lng: -76.56413,
    city: "Baltimore",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15900,
    density: 2992.7,
    county_fips: 24510,
    county_name: "Baltimore",
    county_weights: {
      24510: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21206,
    lat: 39.33932,
    lng: -76.53706,
    city: "Baltimore",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51670,
    density: 2750.7,
    county_fips: 24510,
    county_name: "Baltimore",
    county_weights: {
      24005: 31.21,
      24510: 68.79,
    },
    county_names_all: "Baltimore|Baltimore",
    county_fips_all: "24510|24005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21207,
    lat: 39.32417,
    lng: -76.72017,
    city: "Gwynn Oak",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50440,
    density: 1882.5,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 71.87,
      24510: 28.13,
    },
    county_names_all: "Baltimore|Baltimore",
    county_fips_all: "24005|24510",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21208,
    lat: 39.38401,
    lng: -76.72547,
    city: "Pikesville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35273,
    density: 1084.5,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 98.62,
      24510: 1.38,
    },
    county_names_all: "Baltimore|Baltimore",
    county_fips_all: "24005|24510",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21209,
    lat: 39.37261,
    lng: -76.66802,
    city: "Baltimore",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28621,
    density: 1711.2,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 55.45,
      24510: 44.55,
    },
    county_names_all: "Baltimore|Baltimore",
    county_fips_all: "24005|24510",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21210,
    lat: 39.35878,
    lng: -76.63521,
    city: "Baltimore",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16076,
    density: 1800.5,
    county_fips: 24510,
    county_name: "Baltimore",
    county_weights: {
      24005: 16.76,
      24510: 83.24,
    },
    county_names_all: "Baltimore|Baltimore",
    county_fips_all: "24510|24005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21211,
    lat: 39.32857,
    lng: -76.6389,
    city: "Baltimore",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15735,
    density: 2119,
    county_fips: 24510,
    county_name: "Baltimore",
    county_weights: {
      24510: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21212,
    lat: 39.3678,
    lng: -76.61456,
    city: "Baltimore",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33865,
    density: 2851.2,
    county_fips: 24510,
    county_name: "Baltimore",
    county_weights: {
      24005: 43.44,
      24510: 56.56,
    },
    county_names_all: "Baltimore|Baltimore",
    county_fips_all: "24510|24005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21213,
    lat: 39.31501,
    lng: -76.57723,
    city: "Baltimore",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30596,
    density: 3442.4,
    county_fips: 24510,
    county_name: "Baltimore",
    county_weights: {
      24510: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21214,
    lat: 39.35217,
    lng: -76.5644,
    city: "Baltimore",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21666,
    density: 2993.7,
    county_fips: 24510,
    county_name: "Baltimore",
    county_weights: {
      24510: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21215,
    lat: 39.34578,
    lng: -76.68367,
    city: "Baltimore",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55081,
    density: 3122.2,
    county_fips: 24510,
    county_name: "Baltimore",
    county_weights: {
      24005: 3.47,
      24510: 96.53,
    },
    county_names_all: "Baltimore|Baltimore",
    county_fips_all: "24510|24005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21216,
    lat: 39.3108,
    lng: -76.67145,
    city: "Baltimore",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28733,
    density: 3359.3,
    county_fips: 24510,
    county_name: "Baltimore",
    county_weights: {
      24510: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21217,
    lat: 39.30701,
    lng: -76.63833,
    city: "Baltimore",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32830,
    density: 5978.6,
    county_fips: 24510,
    county_name: "Baltimore",
    county_weights: {
      24510: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21218,
    lat: 39.33031,
    lng: -76.60235,
    city: "Baltimore",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46172,
    density: 4117.7,
    county_fips: 24510,
    county_name: "Baltimore",
    county_weights: {
      24510: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21219,
    lat: 39.23097,
    lng: -76.44383,
    city: "Sparrows Point",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9454,
    density: 301,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21220,
    lat: 39.345,
    lng: -76.3966,
    city: "Middle River",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41067,
    density: 748.7,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21221,
    lat: 39.29462,
    lng: -76.44034,
    city: "Essex",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41899,
    density: 1076.2,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21222,
    lat: 39.26424,
    lng: -76.49537,
    city: "Dundalk",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56946,
    density: 1911.4,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 93.59,
      24510: 6.41,
    },
    county_names_all: "Baltimore|Baltimore",
    county_fips_all: "24005|24510",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21223,
    lat: 39.28421,
    lng: -76.65323,
    city: "Baltimore",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21974,
    density: 3231.1,
    county_fips: 24510,
    county_name: "Baltimore",
    county_weights: {
      24510: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21224,
    lat: 39.28309,
    lng: -76.54088,
    city: "Baltimore",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48770,
    density: 2019.1,
    county_fips: 24510,
    county_name: "Baltimore",
    county_weights: {
      24005: 28.97,
      24510: 71.03,
    },
    county_names_all: "Baltimore|Baltimore",
    county_fips_all: "24510|24005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21225,
    lat: 39.22597,
    lng: -76.61508,
    city: "Brooklyn",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33227,
    density: 1985.5,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 63.01,
      24510: 36.99,
    },
    county_names_all: "Anne Arundel|Baltimore",
    county_fips_all: "24003|24510",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21226,
    lat: 39.2078,
    lng: -76.5627,
    city: "Curtis Bay",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6699,
    density: 264.6,
    county_fips: 24510,
    county_name: "Baltimore",
    county_weights: {
      24003: 43.2,
      24510: 56.8,
    },
    county_names_all: "Baltimore|Anne Arundel",
    county_fips_all: "24510|24003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21227,
    lat: 39.24024,
    lng: -76.67913,
    city: "Halethorpe",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33396,
    density: 1137.8,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 96.71,
      24510: 3.29,
    },
    county_names_all: "Baltimore|Baltimore",
    county_fips_all: "24005|24510",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21228,
    lat: 39.27272,
    lng: -76.74687,
    city: "Catonsville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49438,
    density: 1225.4,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 99.87,
      24510: 0.13,
    },
    county_names_all: "Baltimore|Baltimore",
    county_fips_all: "24005|24510",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21229,
    lat: 39.28509,
    lng: -76.69083,
    city: "Baltimore",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45983,
    density: 2990.9,
    county_fips: 24510,
    county_name: "Baltimore",
    county_weights: {
      24005: 14.51,
      24510: 85.49,
    },
    county_names_all: "Baltimore|Baltimore",
    county_fips_all: "24510|24005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21230,
    lat: 39.26651,
    lng: -76.62213,
    city: "Baltimore",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33592,
    density: 2052.8,
    county_fips: 24510,
    county_name: "Baltimore",
    county_weights: {
      24510: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21231,
    lat: 39.28775,
    lng: -76.592,
    city: "Baltimore",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15906,
    density: 7080,
    county_fips: 24510,
    county_name: "Baltimore",
    county_weights: {
      24510: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21233,
    lat: 39.29244,
    lng: -76.60503,
    city: "Baltimore",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 24510,
    county_name: "Baltimore",
    county_weights: {
      24510: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21234,
    lat: 39.395,
    lng: -76.53252,
    city: "Parkville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68678,
    density: 1985.6,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 92.63,
      24510: 7.37,
    },
    county_names_all: "Baltimore|Baltimore",
    county_fips_all: "24005|24510",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21236,
    lat: 39.38789,
    lng: -76.48552,
    city: "Nottingham",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37803,
    density: 1636.4,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 98.11,
      24510: 1.89,
    },
    county_names_all: "Baltimore|Baltimore",
    county_fips_all: "24005|24510",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21237,
    lat: 39.33938,
    lng: -76.49456,
    city: "Rosedale",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31105,
    density: 1067.3,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 93.92,
      24510: 6.08,
    },
    county_names_all: "Baltimore|Baltimore",
    county_fips_all: "24005|24510",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21239,
    lat: 39.36517,
    lng: -76.58709,
    city: "Baltimore",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30143,
    density: 3971.2,
    county_fips: 24510,
    county_name: "Baltimore",
    county_weights: {
      24005: 26.73,
      24510: 73.27,
    },
    county_names_all: "Baltimore|Baltimore",
    county_fips_all: "24510|24005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21240,
    lat: 39.17483,
    lng: -76.67181,
    city: "Baltimore",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21244,
    lat: 39.3342,
    lng: -76.78217,
    city: "Windsor Mill",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36897,
    density: 1007.8,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21250,
    lat: 39.25558,
    lng: -76.71117,
    city: "Baltimore",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2443,
    density: 3848.9,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21251,
    lat: 39.34993,
    lng: -76.58027,
    city: "Baltimore",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1652,
    density: 5392,
    county_fips: 24510,
    county_name: "Baltimore",
    county_weights: {
      24510: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21252,
    lat: 39.39413,
    lng: -76.61144,
    city: "Towson",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2040,
    density: 3168.7,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21285,
    lat: 39.3875,
    lng: -76.61702,
    city: "Towson",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21286,
    lat: 39.41374,
    lng: -76.57375,
    city: "Towson",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19711,
    density: 885.6,
    county_fips: 24005,
    county_name: "Baltimore",
    county_weights: {
      24005: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21287,
    lat: 39.29899,
    lng: -76.58817,
    city: "Baltimore",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 24510,
    county_name: "Baltimore",
    county_weights: {
      24510: 100,
    },
    county_names_all: "Baltimore",
    county_fips_all: 24510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21401,
    lat: 38.98967,
    lng: -76.5505,
    city: "Annapolis",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38788,
    density: 751.4,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21402,
    lat: 38.98816,
    lng: -76.47202,
    city: "Annapolis",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6460,
    density: 1331.7,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21403,
    lat: 38.94433,
    lng: -76.49296,
    city: "Annapolis",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31218,
    density: 1298.9,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21405,
    lat: 39.02996,
    lng: -76.54971,
    city: "Annapolis",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 398,
    density: 150.2,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21409,
    lat: 39.01968,
    lng: -76.44738,
    city: "Annapolis",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19304,
    density: 532.3,
    county_fips: 24003,
    county_name: "Anne Arundel",
    county_weights: {
      24003: 100,
    },
    county_names_all: "Anne Arundel",
    county_fips_all: 24003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21502,
    lat: 39.64143,
    lng: -78.75609,
    city: "Cumberland",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41735,
    density: 175,
    county_fips: 24001,
    county_name: "Allegany",
    county_weights: {
      24001: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 24001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21520,
    lat: 39.63661,
    lng: -79.30786,
    city: "Accident",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2003,
    density: 13.6,
    county_fips: 24023,
    county_name: "Garrett",
    county_weights: {
      24023: 100,
    },
    county_names_all: "Garrett",
    county_fips_all: 24023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21521,
    lat: 39.55042,
    lng: -79.04836,
    city: "Barton",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1183,
    density: 19.2,
    county_fips: 24023,
    county_name: "Garrett",
    county_weights: {
      24001: 37.79,
      24023: 62.21,
    },
    county_names_all: "Garrett|Allegany",
    county_fips_all: "24023|24001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21523,
    lat: 39.47956,
    lng: -79.07925,
    city: "Bloomington",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 180,
    density: 93.2,
    county_fips: 24023,
    county_name: "Garrett",
    county_weights: {
      24023: 100,
    },
    county_names_all: "Garrett",
    county_fips_all: 24023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21524,
    lat: 39.70666,
    lng: -78.80203,
    city: "Corriganville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 831,
    density: 89.4,
    county_fips: 24001,
    county_name: "Allegany",
    county_weights: {
      24001: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 24001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21529,
    lat: 39.71692,
    lng: -78.77474,
    city: "Ellerslie",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 467,
    density: 195.4,
    county_fips: 24001,
    county_name: "Allegany",
    county_weights: {
      24001: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 24001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21530,
    lat: 39.68878,
    lng: -78.54138,
    city: "Flintstone",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1923,
    density: 12.2,
    county_fips: 24001,
    county_name: "Allegany",
    county_weights: {
      24001: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 24001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21531,
    lat: 39.64862,
    lng: -79.42221,
    city: "Friendsville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1744,
    density: 11,
    county_fips: 24023,
    county_name: "Garrett",
    county_weights: {
      24023: 100,
    },
    county_names_all: "Garrett",
    county_fips_all: 24023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21532,
    lat: 39.65559,
    lng: -78.96025,
    city: "Frostburg",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14498,
    density: 75.5,
    county_fips: 24001,
    county_name: "Allegany",
    county_weights: {
      24001: 54.4,
      24023: 45.6,
    },
    county_names_all: "Allegany|Garrett",
    county_fips_all: "24001|24023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21536,
    lat: 39.65619,
    lng: -79.16924,
    city: "Grantsville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3984,
    density: 15.7,
    county_fips: 24023,
    county_name: "Garrett",
    county_weights: {
      24023: 100,
    },
    county_names_all: "Garrett",
    county_fips_all: 24023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21538,
    lat: 39.40133,
    lng: -79.22109,
    city: "Kitzmiller",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 525,
    density: 11.3,
    county_fips: 24023,
    county_name: "Garrett",
    county_weights: {
      24023: 100,
    },
    county_names_all: "Garrett",
    county_fips_all: 24023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21539,
    lat: 39.59828,
    lng: -79.01074,
    city: "Lonaconing",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2664,
    density: 27.7,
    county_fips: 24023,
    county_name: "Garrett",
    county_weights: {
      24001: 42.57,
      24023: 57.43,
    },
    county_names_all: "Garrett|Allegany",
    county_fips_all: "24023|24001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21540,
    lat: 39.47659,
    lng: -79.05929,
    city: "Luke",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 90,
    density: 130.4,
    county_fips: 24001,
    county_name: "Allegany",
    county_weights: {
      24001: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 24001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21541,
    lat: 39.55727,
    lng: -79.36732,
    city: "McHenry",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1536,
    density: 25.7,
    county_fips: 24023,
    county_name: "Garrett",
    county_weights: {
      24023: 100,
    },
    county_names_all: "Garrett",
    county_fips_all: 24023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21542,
    lat: 39.59114,
    lng: -78.95087,
    city: "Midland",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 678,
    density: 11799.7,
    county_fips: 24001,
    county_name: "Allegany",
    county_weights: {
      24001: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 24001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21543,
    lat: 39.64157,
    lng: -78.96231,
    city: "Midlothian",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 229,
    density: 35.9,
    county_fips: 24001,
    county_name: "Allegany",
    county_weights: {
      24001: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 24001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21545,
    lat: 39.6991,
    lng: -78.86513,
    city: "Mount Savage",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1771,
    density: 43,
    county_fips: 24001,
    county_name: "Allegany",
    county_weights: {
      24001: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 24001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21550,
    lat: 39.39107,
    lng: -79.39085,
    city: "Oakland",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14327,
    density: 26.9,
    county_fips: 24023,
    county_name: "Garrett",
    county_weights: {
      24023: 100,
    },
    county_names_all: "Garrett",
    county_fips_all: 24023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21555,
    lat: 39.58777,
    lng: -78.55685,
    city: "Oldtown",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1501,
    density: 5.9,
    county_fips: 24001,
    county_name: "Allegany",
    county_weights: {
      24001: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 24001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21557,
    lat: 39.5191,
    lng: -78.92353,
    city: "Rawlings",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1592,
    density: 23,
    county_fips: 24001,
    county_name: "Allegany",
    county_weights: {
      24001: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 24001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21560,
    lat: 39.56508,
    lng: -78.70632,
    city: "Spring Gap",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 24001,
    county_name: "Allegany",
    county_weights: {
      24001: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 24001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21561,
    lat: 39.49976,
    lng: -79.20482,
    city: "Swanton",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2392,
    density: 9.1,
    county_fips: 24023,
    county_name: "Garrett",
    county_weights: {
      24023: 100,
    },
    county_names_all: "Garrett",
    county_fips_all: 24023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21562,
    lat: 39.50326,
    lng: -79.05046,
    city: "Westernport",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3426,
    density: 45.8,
    county_fips: 24001,
    county_name: "Allegany",
    county_weights: {
      24001: 50.01,
      24023: 49.99,
    },
    county_names_all: "Allegany|Garrett",
    county_fips_all: "24001|24023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21601,
    lat: 38.79275,
    lng: -76.08242,
    city: "Easton",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23338,
    density: 84.2,
    county_fips: 24041,
    county_name: "Talbot",
    county_weights: {
      24041: 100,
    },
    county_names_all: "Talbot",
    county_fips_all: 24041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21607,
    lat: 39.13398,
    lng: -75.85644,
    city: "Barclay",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 770,
    density: 19.9,
    county_fips: 24035,
    county_name: "Queen Anne's",
    county_weights: {
      24035: 100,
    },
    county_names_all: "Queen Anne's",
    county_fips_all: 24035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21610,
    lat: 39.3652,
    lng: -76.06845,
    city: "Betterton",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 412,
    density: 149.5,
    county_fips: 24029,
    county_name: "Kent",
    county_weights: {
      24029: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 24029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21612,
    lat: 38.74928,
    lng: -76.27695,
    city: "Bozman",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 597,
    density: 41.6,
    county_fips: 24041,
    county_name: "Talbot",
    county_weights: {
      24041: 100,
    },
    county_names_all: "Talbot",
    county_fips_all: 24041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21613,
    lat: 38.49537,
    lng: -76.07169,
    city: "Cambridge",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17115,
    density: 43,
    county_fips: 24019,
    county_name: "Dorchester",
    county_weights: {
      24019: 100,
    },
    county_names_all: "Dorchester",
    county_fips_all: 24019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21617,
    lat: 39.04985,
    lng: -76.03819,
    city: "Centreville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10534,
    density: 37.5,
    county_fips: 24035,
    county_name: "Queen Anne's",
    county_weights: {
      24035: 100,
    },
    county_names_all: "Queen Anne's",
    county_fips_all: 24035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21619,
    lat: 38.95285,
    lng: -76.27939,
    city: "Chester",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5789,
    density: 240.7,
    county_fips: 24035,
    county_name: "Queen Anne's",
    county_weights: {
      24035: 100,
    },
    county_names_all: "Queen Anne's",
    county_fips_all: 24035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21620,
    lat: 39.20667,
    lng: -76.08739,
    city: "Chestertown",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12989,
    density: 42.2,
    county_fips: 24029,
    county_name: "Kent",
    county_weights: {
      24029: 75.2,
      24035: 24.8,
    },
    county_names_all: "Kent|Queen Anne's",
    county_fips_all: "24029|24035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21622,
    lat: 38.40821,
    lng: -76.17381,
    city: "Church Creek",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 704,
    density: 4.2,
    county_fips: 24019,
    county_name: "Dorchester",
    county_weights: {
      24019: 100,
    },
    county_names_all: "Dorchester",
    county_fips_all: 24019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21623,
    lat: 39.11915,
    lng: -75.96268,
    city: "Church Hill",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2248,
    density: 23.9,
    county_fips: 24035,
    county_name: "Queen Anne's",
    county_weights: {
      24035: 100,
    },
    county_names_all: "Queen Anne's",
    county_fips_all: 24035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21624,
    lat: 38.83407,
    lng: -76.27212,
    city: "Claiborne",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 115,
    density: 19.1,
    county_fips: 24041,
    county_name: "Talbot",
    county_weights: {
      24041: 100,
    },
    county_names_all: "Talbot",
    county_fips_all: 24041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21625,
    lat: 38.86925,
    lng: -75.99216,
    city: "Cordova",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2401,
    density: 22.5,
    county_fips: 24041,
    county_name: "Talbot",
    county_weights: {
      24041: 100,
    },
    county_names_all: "Talbot",
    county_fips_all: 24041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21626,
    lat: 38.33902,
    lng: -76.08398,
    city: "Crapo",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47,
    density: 0.7,
    county_fips: 24019,
    county_name: "Dorchester",
    county_weights: {
      24019: 100,
    },
    county_names_all: "Dorchester",
    county_fips_all: 24019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21627,
    lat: 38.23528,
    lng: -76.04967,
    city: "Crocheron",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4,
    density: 0.9,
    county_fips: 24019,
    county_name: "Dorchester",
    county_weights: {
      24019: 100,
    },
    county_names_all: "Dorchester",
    county_fips_all: 24019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21628,
    lat: 39.23577,
    lng: -75.92238,
    city: "Crumpton",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 324,
    density: 133.2,
    county_fips: 24035,
    county_name: "Queen Anne's",
    county_weights: {
      24035: 100,
    },
    county_names_all: "Queen Anne's",
    county_fips_all: 24035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21629,
    lat: 38.86111,
    lng: -75.82753,
    city: "Denton",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9464,
    density: 43.7,
    county_fips: 24011,
    county_name: "Caroline",
    county_weights: {
      24011: 100,
    },
    county_names_all: "Caroline",
    county_fips_all: 24011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21631,
    lat: 38.58784,
    lng: -75.94598,
    city: "East New Market",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2708,
    density: 43.3,
    county_fips: 24019,
    county_name: "Dorchester",
    county_weights: {
      24019: 100,
    },
    county_names_all: "Dorchester",
    county_fips_all: 24019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21632,
    lat: 38.72287,
    lng: -75.77478,
    city: "Federalsburg",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5885,
    density: 29.2,
    county_fips: 24011,
    county_name: "Caroline",
    county_weights: {
      24011: 79.6,
      24019: 20.4,
    },
    county_names_all: "Caroline|Dorchester",
    county_fips_all: "24011|24019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21634,
    lat: 38.27995,
    lng: -76.185,
    city: "Fishing Creek",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 243,
    density: 20.8,
    county_fips: 24019,
    county_name: "Dorchester",
    county_weights: {
      24019: 100,
    },
    county_names_all: "Dorchester",
    county_fips_all: 24019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21635,
    lat: 39.34006,
    lng: -75.83826,
    city: "Galena",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1970,
    density: 24.7,
    county_fips: 24029,
    county_name: "Kent",
    county_weights: {
      24029: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 24029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21636,
    lat: 39.0261,
    lng: -75.79839,
    city: "Goldsboro",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 837,
    density: 13.7,
    county_fips: 24011,
    county_name: "Caroline",
    county_weights: {
      24011: 100,
    },
    county_names_all: "Caroline",
    county_fips_all: 24011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21638,
    lat: 38.94513,
    lng: -76.20263,
    city: "Grasonville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5227,
    density: 203.9,
    county_fips: 24035,
    county_name: "Queen Anne's",
    county_weights: {
      24035: 100,
    },
    county_names_all: "Queen Anne's",
    county_fips_all: 24035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21639,
    lat: 38.96533,
    lng: -75.7928,
    city: "Greensboro",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5410,
    density: 63.1,
    county_fips: 24011,
    county_name: "Caroline",
    county_weights: {
      24011: 100,
    },
    county_names_all: "Caroline",
    county_fips_all: 24011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21640,
    lat: 39.07036,
    lng: -75.82533,
    city: "Henderson",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1467,
    density: 22.1,
    county_fips: 24011,
    county_name: "Caroline",
    county_weights: {
      24011: 80.18,
      24035: 19.82,
    },
    county_names_all: "Caroline|Queen Anne's",
    county_fips_all: "24011|24035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21641,
    lat: 38.91696,
    lng: -75.94161,
    city: "Hillsboro",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 87,
    density: 248.3,
    county_fips: 24011,
    county_name: "Caroline",
    county_weights: {
      24011: 100,
    },
    county_names_all: "Caroline",
    county_fips_all: 24011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21643,
    lat: 38.6442,
    lng: -75.87124,
    city: "Hurlock",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5956,
    density: 49.8,
    county_fips: 24019,
    county_name: "Dorchester",
    county_weights: {
      24019: 100,
    },
    county_names_all: "Dorchester",
    county_fips_all: 24019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21644,
    lat: 39.11728,
    lng: -75.87441,
    city: "Ingleside",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 78,
    density: 8.3,
    county_fips: 24035,
    county_name: "Queen Anne's",
    county_weights: {
      24035: 100,
    },
    county_names_all: "Queen Anne's",
    county_fips_all: 24035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21645,
    lat: 39.31979,
    lng: -75.96216,
    city: "Kennedyville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1345,
    density: 12.4,
    county_fips: 24029,
    county_name: "Kent",
    county_weights: {
      24029: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 24029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21647,
    lat: 38.80114,
    lng: -76.2831,
    city: "Mcdaniel",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 357,
    density: 41,
    county_fips: 24041,
    county_name: "Talbot",
    county_weights: {
      24041: 100,
    },
    county_names_all: "Talbot",
    county_fips_all: 24041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21648,
    lat: 38.4966,
    lng: -76.23386,
    city: "Madison",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 126,
    density: 5.2,
    county_fips: 24019,
    county_name: "Dorchester",
    county_weights: {
      24019: 100,
    },
    county_names_all: "Dorchester",
    county_fips_all: 24019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21649,
    lat: 39.1366,
    lng: -75.77453,
    city: "Marydel",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2204,
    density: 40.5,
    county_fips: 24035,
    county_name: "Queen Anne's",
    county_weights: {
      24011: 47.7,
      24035: 52.3,
    },
    county_names_all: "Queen Anne's|Caroline",
    county_fips_all: "24035|24011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21650,
    lat: 39.31286,
    lng: -75.80795,
    city: "Massey",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 296,
    density: 11.8,
    county_fips: 24029,
    county_name: "Kent",
    county_weights: {
      24029: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 24029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21651,
    lat: 39.25821,
    lng: -75.85802,
    city: "Millington",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2683,
    density: 25.5,
    county_fips: 24029,
    county_name: "Kent",
    county_weights: {
      24029: 70.33,
      24035: 29.67,
    },
    county_names_all: "Kent|Queen Anne's",
    county_fips_all: "24029|24035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21652,
    lat: 38.72028,
    lng: -76.28108,
    city: "Neavitt",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 149,
    density: 110,
    county_fips: 24041,
    county_name: "Talbot",
    county_weights: {
      24041: 100,
    },
    county_names_all: "Talbot",
    county_fips_all: 24041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21653,
    lat: 38.74704,
    lng: -76.17744,
    city: "Newcomb",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 96,
    density: 200.6,
    county_fips: 24041,
    county_name: "Talbot",
    county_weights: {
      24041: 100,
    },
    county_names_all: "Talbot",
    county_fips_all: 24041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21654,
    lat: 38.6908,
    lng: -76.12518,
    city: "Oxford",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1221,
    density: 42.5,
    county_fips: 24041,
    county_name: "Talbot",
    county_weights: {
      24041: 100,
    },
    county_names_all: "Talbot",
    county_fips_all: 24041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21655,
    lat: 38.74601,
    lng: -75.92103,
    city: "Preston",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4763,
    density: 34.9,
    county_fips: 24011,
    county_name: "Caroline",
    county_weights: {
      24011: 100,
    },
    county_names_all: "Caroline",
    county_fips_all: 24011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21657,
    lat: 38.9534,
    lng: -75.99042,
    city: "Queen Anne",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 727,
    density: 9.2,
    county_fips: 24035,
    county_name: "Queen Anne's",
    county_weights: {
      24011: 3.43,
      24035: 76.72,
      24041: 19.85,
    },
    county_names_all: "Queen Anne's|Talbot|Caroline",
    county_fips_all: "24035|24041|24011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21658,
    lat: 38.94071,
    lng: -76.13819,
    city: "Queenstown",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4177,
    density: 41.4,
    county_fips: 24035,
    county_name: "Queen Anne's",
    county_weights: {
      24035: 97.16,
      24041: 2.84,
    },
    county_names_all: "Queen Anne's|Talbot",
    county_fips_all: "24035|24041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21659,
    lat: 38.57442,
    lng: -75.79985,
    city: "Rhodesdale",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1509,
    density: 13.3,
    county_fips: 24019,
    county_name: "Dorchester",
    county_weights: {
      24019: 100,
    },
    county_names_all: "Dorchester",
    county_fips_all: 24019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21660,
    lat: 38.95534,
    lng: -75.88839,
    city: "Ridgely",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4361,
    density: 51.6,
    county_fips: 24011,
    county_name: "Caroline",
    county_weights: {
      24011: 100,
    },
    county_names_all: "Caroline",
    county_fips_all: 24011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21661,
    lat: 39.12905,
    lng: -76.21967,
    city: "Rock Hall",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2695,
    density: 31.5,
    county_fips: 24029,
    county_name: "Kent",
    county_weights: {
      24029: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 24029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21662,
    lat: 38.7136,
    lng: -76.20209,
    city: "Royal Oak",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 369,
    density: 17,
    county_fips: 24041,
    county_name: "Talbot",
    county_weights: {
      24041: 100,
    },
    county_names_all: "Talbot",
    county_fips_all: 24041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21663,
    lat: 38.78333,
    lng: -76.23303,
    city: "Saint Michaels",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3715,
    density: 117.6,
    county_fips: 24041,
    county_name: "Talbot",
    county_weights: {
      24041: 100,
    },
    county_names_all: "Talbot",
    county_fips_all: 24041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21664,
    lat: 38.6081,
    lng: -75.94732,
    city: "Secretary",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 497,
    density: 658.8,
    county_fips: 24019,
    county_name: "Dorchester",
    county_weights: {
      24019: 100,
    },
    county_names_all: "Dorchester",
    county_fips_all: 24019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21665,
    lat: 38.75158,
    lng: -76.34469,
    city: "Sherwood",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 194,
    density: 14.2,
    county_fips: 24041,
    county_name: "Talbot",
    county_weights: {
      24041: 100,
    },
    county_names_all: "Talbot",
    county_fips_all: 24041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21666,
    lat: 38.93956,
    lng: -76.33272,
    city: "Stevensville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13463,
    density: 237.7,
    county_fips: 24035,
    county_name: "Queen Anne's",
    county_weights: {
      24035: 100,
    },
    county_names_all: "Queen Anne's",
    county_fips_all: 24035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21667,
    lat: 39.34377,
    lng: -76.05188,
    city: "Still Pond",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 255,
    density: 14.1,
    county_fips: 24029,
    county_name: "Kent",
    county_weights: {
      24029: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 24029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21668,
    lat: 39.18967,
    lng: -75.85139,
    city: "Sudlersville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1763,
    density: 15,
    county_fips: 24035,
    county_name: "Queen Anne's",
    county_weights: {
      24035: 100,
    },
    county_names_all: "Queen Anne's",
    county_fips_all: 24035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21669,
    lat: 38.45897,
    lng: -76.28509,
    city: "Taylors Island",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 114,
    density: 3,
    county_fips: 24019,
    county_name: "Dorchester",
    county_weights: {
      24019: 100,
    },
    county_names_all: "Dorchester",
    county_fips_all: 24019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21671,
    lat: 38.69658,
    lng: -76.33562,
    city: "Tilghman",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 808,
    density: 147.6,
    county_fips: 24041,
    county_name: "Talbot",
    county_weights: {
      24041: 100,
    },
    county_names_all: "Talbot",
    county_fips_all: 24041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21672,
    lat: 38.27707,
    lng: -76.06148,
    city: "Toddville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 149,
    density: 5.9,
    county_fips: 24019,
    county_name: "Dorchester",
    county_weights: {
      24019: 100,
    },
    county_names_all: "Dorchester",
    county_fips_all: 24019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21673,
    lat: 38.65235,
    lng: -76.04163,
    city: "Trappe",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3019,
    density: 22.5,
    county_fips: 24041,
    county_name: "Talbot",
    county_weights: {
      24041: 100,
    },
    county_names_all: "Talbot",
    county_fips_all: 24041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21675,
    lat: 38.29011,
    lng: -76.0884,
    city: "Wingate",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57,
    density: 7.8,
    county_fips: 24019,
    county_name: "Dorchester",
    county_weights: {
      24019: 100,
    },
    county_names_all: "Dorchester",
    county_fips_all: 24019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21676,
    lat: 38.78628,
    lng: -76.30548,
    city: "Wittman",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 367,
    density: 35.5,
    county_fips: 24041,
    county_name: "Talbot",
    county_weights: {
      24041: 100,
    },
    county_names_all: "Talbot",
    county_fips_all: 24041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21677,
    lat: 38.48454,
    lng: -76.18544,
    city: "Woolford",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 579,
    density: 17.1,
    county_fips: 24019,
    county_name: "Dorchester",
    county_weights: {
      24019: 100,
    },
    county_names_all: "Dorchester",
    county_fips_all: 24019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21678,
    lat: 39.30889,
    lng: -76.10336,
    city: "Worton",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1549,
    density: 16.2,
    county_fips: 24029,
    county_name: "Kent",
    county_weights: {
      24029: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 24029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21679,
    lat: 38.91722,
    lng: -76.08875,
    city: "Wye Mills",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 272,
    density: 13.4,
    county_fips: 24041,
    county_name: "Talbot",
    county_weights: {
      24035: 3.02,
      24041: 96.98,
    },
    county_names_all: "Talbot|Queen Anne's",
    county_fips_all: "24041|24035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21701,
    lat: 39.44729,
    lng: -77.33512,
    city: "Frederick",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38390,
    density: 373.3,
    county_fips: 24021,
    county_name: "Frederick",
    county_weights: {
      24021: 100,
    },
    county_names_all: "Frederick",
    county_fips_all: 24021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21702,
    lat: 39.48019,
    lng: -77.4578,
    city: "Frederick",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41729,
    density: 386.2,
    county_fips: 24021,
    county_name: "Frederick",
    county_weights: {
      24021: 100,
    },
    county_names_all: "Frederick",
    county_fips_all: 24021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21703,
    lat: 39.36961,
    lng: -77.47088,
    city: "Frederick",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37048,
    density: 446.6,
    county_fips: 24021,
    county_name: "Frederick",
    county_weights: {
      24021: 100,
    },
    county_names_all: "Frederick",
    county_fips_all: 24021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21704,
    lat: 39.3506,
    lng: -77.3735,
    city: "Frederick",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16478,
    density: 238.9,
    county_fips: 24021,
    county_name: "Frederick",
    county_weights: {
      24021: 100,
    },
    county_names_all: "Frederick",
    county_fips_all: 24021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21705,
    lat: 39.40887,
    lng: -77.41002,
    city: "Frederick",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4,
    density: 65.3,
    county_fips: 24021,
    county_name: "Frederick",
    county_weights: {
      24021: 100,
    },
    county_names_all: "Frederick",
    county_fips_all: 24021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21710,
    lat: 39.29652,
    lng: -77.44941,
    city: "Adamstown",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4847,
    density: 63.7,
    county_fips: 24021,
    county_name: "Frederick",
    county_weights: {
      24021: 100,
    },
    county_names_all: "Frederick",
    county_fips_all: 24021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21711,
    lat: 39.66808,
    lng: -78.01247,
    city: "Big Pool",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1139,
    density: 17.9,
    county_fips: 24043,
    county_name: "Washington",
    county_weights: {
      24043: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 24043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21713,
    lat: 39.52618,
    lng: -77.66933,
    city: "Boonsboro",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9979,
    density: 97.4,
    county_fips: 24043,
    county_name: "Washington",
    county_weights: {
      24043: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 24043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21714,
    lat: 39.41059,
    lng: -77.51003,
    city: "Braddock Heights",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 24021,
    county_name: "Frederick",
    county_weights: {
      24021: 100,
    },
    county_names_all: "Frederick",
    county_fips_all: 24021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21715,
    lat: 39.37879,
    lng: -77.66063,
    city: "Brownsville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 24043,
    county_name: "Washington",
    county_weights: {
      24043: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 24043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21716,
    lat: 39.31798,
    lng: -77.6262,
    city: "Brunswick",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5453,
    density: 771.1,
    county_fips: 24021,
    county_name: "Frederick",
    county_weights: {
      24021: 100,
    },
    county_names_all: "Frederick",
    county_fips_all: 24021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21717,
    lat: 39.33865,
    lng: -77.43147,
    city: "Buckeystown",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 126,
    density: 80.3,
    county_fips: 24021,
    county_name: "Frederick",
    county_weights: {
      24021: 100,
    },
    county_names_all: "Frederick",
    county_fips_all: 24021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21718,
    lat: 39.39343,
    lng: -77.62734,
    city: "Burkittsville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 167,
    density: 194.3,
    county_fips: 24021,
    county_name: "Frederick",
    county_weights: {
      24021: 100,
    },
    county_names_all: "Frederick",
    county_fips_all: 24021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21719,
    lat: 39.70501,
    lng: -77.49977,
    city: "Cascade",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1074,
    density: 100.2,
    county_fips: 24043,
    county_name: "Washington",
    county_weights: {
      24021: 2.75,
      24043: 97.25,
    },
    county_names_all: "Washington|Frederick",
    county_fips_all: "24043|24021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21722,
    lat: 39.66575,
    lng: -77.91457,
    city: "Clear Spring",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6389,
    density: 43.3,
    county_fips: 24043,
    county_name: "Washington",
    county_weights: {
      24043: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 24043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21723,
    lat: 39.32825,
    lng: -77.01056,
    city: "Cooksville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 648,
    density: 69.4,
    county_fips: 24027,
    county_name: "Howard",
    county_weights: {
      24027: 100,
    },
    county_names_all: "Howard",
    county_fips_all: 24027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21727,
    lat: 39.68865,
    lng: -77.33096,
    city: "Emmitsburg",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6965,
    density: 85.8,
    county_fips: 24021,
    county_name: "Frederick",
    county_weights: {
      24021: 100,
    },
    county_names_all: "Frederick",
    county_fips_all: 24021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21733,
    lat: 39.55004,
    lng: -77.75838,
    city: "Fairplay",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 988,
    density: 65.3,
    county_fips: 24043,
    county_name: "Washington",
    county_weights: {
      24043: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 24043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21734,
    lat: 39.60583,
    lng: -77.70382,
    city: "Funkstown",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 840,
    density: 671.2,
    county_fips: 24043,
    county_name: "Washington",
    county_weights: {
      24043: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 24043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21737,
    lat: 39.2543,
    lng: -77.01959,
    city: "Glenelg",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2476,
    density: 186.6,
    county_fips: 24027,
    county_name: "Howard",
    county_weights: {
      24027: 100,
    },
    county_names_all: "Howard",
    county_fips_all: 24027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21738,
    lat: 39.27973,
    lng: -77.02554,
    city: "Glenwood",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3861,
    density: 213.6,
    county_fips: 24027,
    county_name: "Howard",
    county_weights: {
      24027: 100,
    },
    county_names_all: "Howard",
    county_fips_all: 24027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21740,
    lat: 39.63233,
    lng: -77.73902,
    city: "Hagerstown",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60922,
    density: 331.9,
    county_fips: 24043,
    county_name: "Washington",
    county_weights: {
      24043: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 24043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21742,
    lat: 39.67363,
    lng: -77.65928,
    city: "Hagerstown",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33425,
    density: 277.5,
    county_fips: 24043,
    county_name: "Washington",
    county_weights: {
      24043: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 24043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21746,
    lat: 39.56591,
    lng: -77.71409,
    city: "Hagerstown",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3036,
    density: 4465.2,
    county_fips: 24043,
    county_name: "Washington",
    county_weights: {
      24043: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 24043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21750,
    lat: 39.68698,
    lng: -78.2129,
    city: "Hancock",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3787,
    density: 23.7,
    county_fips: 24043,
    county_name: "Washington",
    county_weights: {
      24043: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 24043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21754,
    lat: 39.33684,
    lng: -77.31131,
    city: "Ijamsville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7117,
    density: 125.9,
    county_fips: 24021,
    county_name: "Frederick",
    county_weights: {
      24021: 100,
    },
    county_names_all: "Frederick",
    county_fips_all: 24021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21755,
    lat: 39.36101,
    lng: -77.56887,
    city: "Jefferson",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5745,
    density: 64.6,
    county_fips: 24021,
    county_name: "Frederick",
    county_weights: {
      24021: 100,
    },
    county_names_all: "Frederick",
    county_fips_all: 24021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21756,
    lat: 39.45758,
    lng: -77.70118,
    city: "Keedysville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2912,
    density: 48.3,
    county_fips: 24043,
    county_name: "Washington",
    county_weights: {
      24043: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 24043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21757,
    lat: 39.59902,
    lng: -77.25906,
    city: "Keymar",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2753,
    density: 30.2,
    county_fips: 24013,
    county_name: "Carroll",
    county_weights: {
      24013: 52.42,
      24021: 47.58,
    },
    county_names_all: "Carroll|Frederick",
    county_fips_all: "24013|24021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21758,
    lat: 39.34567,
    lng: -77.66265,
    city: "Knoxville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4616,
    density: 55.7,
    county_fips: 24043,
    county_name: "Washington",
    county_weights: {
      24021: 49.42,
      24043: 50.58,
    },
    county_names_all: "Washington|Frederick",
    county_fips_all: "24043|24021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21762,
    lat: 39.48058,
    lng: -77.24842,
    city: "Libertytown",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 131,
    density: 113.1,
    county_fips: 24021,
    county_name: "Frederick",
    county_weights: {
      24021: 100,
    },
    county_names_all: "Frederick",
    county_fips_all: 24021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21766,
    lat: 39.65928,
    lng: -78.39859,
    city: "Little Orleans",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 660,
    density: 6.2,
    county_fips: 24001,
    county_name: "Allegany",
    county_weights: {
      24001: 100,
    },
    county_names_all: "Allegany",
    county_fips_all: 24001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21767,
    lat: 39.69773,
    lng: -77.74638,
    city: "Maugansville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 694,
    density: 778.5,
    county_fips: 24043,
    county_name: "Washington",
    county_weights: {
      24043: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 24043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21769,
    lat: 39.44582,
    lng: -77.56489,
    city: "Middletown",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11868,
    density: 114.2,
    county_fips: 24021,
    county_name: "Frederick",
    county_weights: {
      24021: 99.33,
      24043: 0.67,
    },
    county_names_all: "Frederick|Washington",
    county_fips_all: "24021|24043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21770,
    lat: 39.35245,
    lng: -77.25791,
    city: "Monrovia",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6145,
    density: 207.2,
    county_fips: 24021,
    county_name: "Frederick",
    county_weights: {
      24021: 100,
    },
    county_names_all: "Frederick",
    county_fips_all: 24021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21771,
    lat: 39.3955,
    lng: -77.15869,
    city: "Mount Airy",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31366,
    density: 135.3,
    county_fips: 24021,
    county_name: "Frederick",
    county_weights: {
      24013: 26.26,
      24021: 51.35,
      24027: 18.21,
      24031: 4.18,
    },
    county_names_all: "Frederick|Carroll|Howard|Montgomery",
    county_fips_all: "24021|24013|24027|24031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21773,
    lat: 39.53725,
    lng: -77.55301,
    city: "Myersville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5404,
    density: 57.5,
    county_fips: 24021,
    county_name: "Frederick",
    county_weights: {
      24021: 100,
    },
    county_names_all: "Frederick",
    county_fips_all: 24021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21774,
    lat: 39.4088,
    lng: -77.27844,
    city: "New Market",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13618,
    density: 371.3,
    county_fips: 24021,
    county_name: "Frederick",
    county_weights: {
      24021: 100,
    },
    county_names_all: "Frederick",
    county_fips_all: 24021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21776,
    lat: 39.51861,
    lng: -77.10376,
    city: "New Windsor",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6137,
    density: 66.8,
    county_fips: 24013,
    county_name: "Carroll",
    county_weights: {
      24013: 79.17,
      24021: 20.83,
    },
    county_names_all: "Carroll|Frederick",
    county_fips_all: "24013|24021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21777,
    lat: 39.27918,
    lng: -77.5287,
    city: "Point Of Rocks",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2067,
    density: 723.3,
    county_fips: 24021,
    county_name: "Frederick",
    county_weights: {
      24021: 100,
    },
    county_names_all: "Frederick",
    county_fips_all: 24021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21778,
    lat: 39.61576,
    lng: -77.33754,
    city: "Rocky Ridge",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 930,
    density: 19.7,
    county_fips: 24021,
    county_name: "Frederick",
    county_weights: {
      24021: 100,
    },
    county_names_all: "Frederick",
    county_fips_all: 24021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21779,
    lat: 39.42447,
    lng: -77.65398,
    city: "Rohrersville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1712,
    density: 67.9,
    county_fips: 24043,
    county_name: "Washington",
    county_weights: {
      24043: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 24043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21780,
    lat: 39.67676,
    lng: -77.46777,
    city: "Sabillasville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1864,
    density: 32.6,
    county_fips: 24021,
    county_name: "Frederick",
    county_weights: {
      24021: 95.77,
      24043: 4.23,
    },
    county_names_all: "Frederick|Washington",
    county_fips_all: "24021|24043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21781,
    lat: 39.57123,
    lng: -77.75981,
    city: "Saint James",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 128,
    density: 205.9,
    county_fips: 24043,
    county_name: "Washington",
    county_weights: {
      24043: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 24043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21782,
    lat: 39.4552,
    lng: -77.75995,
    city: "Sharpsburg",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4348,
    density: 57.3,
    county_fips: 24043,
    county_name: "Washington",
    county_weights: {
      24043: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 24043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21783,
    lat: 39.64885,
    lng: -77.55903,
    city: "Smithsburg",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9637,
    density: 78.2,
    county_fips: 24043,
    county_name: "Washington",
    county_weights: {
      24021: 27.17,
      24043: 72.83,
    },
    county_names_all: "Washington|Frederick",
    county_fips_all: "24043|24021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21784,
    lat: 39.40087,
    lng: -76.9726,
    city: "Sykesville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36484,
    density: 251,
    county_fips: 24013,
    county_name: "Carroll",
    county_weights: {
      24013: 82.5,
      24027: 17.5,
    },
    county_names_all: "Carroll|Howard",
    county_fips_all: "24013|24027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21787,
    lat: 39.67169,
    lng: -77.17317,
    city: "Taneytown",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10194,
    density: 64.4,
    county_fips: 24013,
    county_name: "Carroll",
    county_weights: {
      24013: 86.98,
      24021: 13.02,
    },
    county_names_all: "Carroll|Frederick",
    county_fips_all: "24013|24021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21788,
    lat: 39.59429,
    lng: -77.41958,
    city: "Thurmont",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12241,
    density: 72.2,
    county_fips: 24021,
    county_name: "Frederick",
    county_weights: {
      24021: 100,
    },
    county_names_all: "Frederick",
    county_fips_all: 24021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21790,
    lat: 39.25908,
    lng: -77.49559,
    city: "Tuscarora",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 104,
    density: 8.4,
    county_fips: 24021,
    county_name: "Frederick",
    county_weights: {
      24021: 100,
    },
    county_names_all: "Frederick",
    county_fips_all: 24021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21791,
    lat: 39.54267,
    lng: -77.18713,
    city: "Union Bridge",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5080,
    density: 42.6,
    county_fips: 24021,
    county_name: "Frederick",
    county_weights: {
      24013: 39.37,
      24021: 60.63,
    },
    county_names_all: "Frederick|Carroll",
    county_fips_all: "24021|24013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21793,
    lat: 39.48963,
    lng: -77.34357,
    city: "Walkersville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10477,
    density: 189.4,
    county_fips: 24021,
    county_name: "Frederick",
    county_weights: {
      24021: 100,
    },
    county_names_all: "Frederick",
    county_fips_all: 24021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21794,
    lat: 39.29705,
    lng: -76.97388,
    city: "West Friendship",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2191,
    density: 103.7,
    county_fips: 24027,
    county_name: "Howard",
    county_weights: {
      24027: 100,
    },
    county_names_all: "Howard",
    county_fips_all: 24027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21795,
    lat: 39.582,
    lng: -77.82733,
    city: "Williamsport",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9150,
    density: 109.9,
    county_fips: 24043,
    county_name: "Washington",
    county_weights: {
      24043: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 24043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21797,
    lat: 39.33284,
    lng: -77.07002,
    city: "Woodbine",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8558,
    density: 75.6,
    county_fips: 24027,
    county_name: "Howard",
    county_weights: {
      24013: 31.72,
      24027: 66.96,
      24031: 1.32,
    },
    county_names_all: "Howard|Carroll|Montgomery",
    county_fips_all: "24027|24013|24031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21798,
    lat: 39.53858,
    lng: -77.29985,
    city: "Woodsboro",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2412,
    density: 57.1,
    county_fips: 24021,
    county_name: "Frederick",
    county_weights: {
      24021: 100,
    },
    county_names_all: "Frederick",
    county_fips_all: 24021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21801,
    lat: 38.38106,
    lng: -75.64073,
    city: "Salisbury",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30122,
    density: 289.9,
    county_fips: 24045,
    county_name: "Wicomico",
    county_weights: {
      24045: 100,
    },
    county_names_all: "Wicomico",
    county_fips_all: 24045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21804,
    lat: 38.31726,
    lng: -75.53673,
    city: "Salisbury",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39842,
    density: 224.3,
    county_fips: 24045,
    county_name: "Wicomico",
    county_weights: {
      24045: 77.69,
      24047: 22.31,
    },
    county_names_all: "Wicomico|Worcester",
    county_fips_all: "24045|24047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21810,
    lat: 38.29005,
    lng: -75.68887,
    city: "Allen",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 656,
    density: 533.7,
    county_fips: 24045,
    county_name: "Wicomico",
    county_weights: {
      24039: 0.3,
      24045: 99.7,
    },
    county_names_all: "Wicomico|Somerset",
    county_fips_all: "24045|24039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21811,
    lat: 38.31977,
    lng: -75.22024,
    city: "Berlin",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24356,
    density: 92.6,
    county_fips: 24047,
    county_name: "Worcester",
    county_weights: {
      24047: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 24047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21813,
    lat: 38.42658,
    lng: -75.17293,
    city: "Bishopville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2636,
    density: 37.1,
    county_fips: 24047,
    county_name: "Worcester",
    county_weights: {
      24047: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 24047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21814,
    lat: 38.29176,
    lng: -75.88669,
    city: "Bivalve",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 274,
    density: 29.7,
    county_fips: 24045,
    county_name: "Wicomico",
    county_weights: {
      24045: 100,
    },
    county_names_all: "Wicomico",
    county_fips_all: 24045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21817,
    lat: 37.98081,
    lng: -75.83537,
    city: "Crisfield",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4247,
    density: 113.4,
    county_fips: 24039,
    county_name: "Somerset",
    county_weights: {
      24039: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 24039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21821,
    lat: 38.16664,
    lng: -75.90611,
    city: "Deal Island",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 834,
    density: 21.9,
    county_fips: 24039,
    county_name: "Somerset",
    county_weights: {
      24039: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 24039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21822,
    lat: 38.28129,
    lng: -75.65566,
    city: "Eden",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1527,
    density: 15.4,
    county_fips: 24045,
    county_name: "Wicomico",
    county_weights: {
      24039: 23.13,
      24045: 50.96,
      24047: 25.91,
    },
    county_names_all: "Wicomico|Worcester|Somerset",
    county_fips_all: "24045|24047|24039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21824,
    lat: 37.97982,
    lng: -76.02871,
    city: "Ewell",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 181,
    density: 30.6,
    county_fips: 24039,
    county_name: "Somerset",
    county_weights: {
      24039: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 24039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21826,
    lat: 38.32077,
    lng: -75.62353,
    city: "Fruitland",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5317,
    density: 508.1,
    county_fips: 24045,
    county_name: "Wicomico",
    county_weights: {
      24045: 100,
    },
    county_names_all: "Wicomico",
    county_fips_all: 24045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21829,
    lat: 38.09892,
    lng: -75.38324,
    city: "Girdletree",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 397,
    density: 9.1,
    county_fips: 24047,
    county_name: "Worcester",
    county_weights: {
      24047: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 24047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21830,
    lat: 38.40202,
    lng: -75.72841,
    city: "Hebron",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4790,
    density: 56.2,
    county_fips: 24045,
    county_name: "Wicomico",
    county_weights: {
      24045: 100,
    },
    county_names_all: "Wicomico",
    county_fips_all: 24045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21835,
    lat: 38.53355,
    lng: -75.93758,
    city: "Linkwood",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 207,
    density: 7.5,
    county_fips: 24019,
    county_name: "Dorchester",
    county_weights: {
      24019: 100,
    },
    county_names_all: "Dorchester",
    county_fips_all: 24019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21837,
    lat: 38.4594,
    lng: -75.76731,
    city: "Mardela Springs",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3322,
    density: 29.2,
    county_fips: 24045,
    county_name: "Wicomico",
    county_weights: {
      24045: 100,
    },
    county_names_all: "Wicomico",
    county_fips_all: 24045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21838,
    lat: 38.01452,
    lng: -75.73098,
    city: "Marion Station",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1805,
    density: 12.7,
    county_fips: 24039,
    county_name: "Somerset",
    county_weights: {
      24039: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 24039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21840,
    lat: 38.25814,
    lng: -75.89276,
    city: "Nanticoke",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 353,
    density: 25.9,
    county_fips: 24045,
    county_name: "Wicomico",
    county_weights: {
      24045: 100,
    },
    county_names_all: "Wicomico",
    county_fips_all: 24045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21841,
    lat: 38.24385,
    lng: -75.29588,
    city: "Newark",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1455,
    density: 19.9,
    county_fips: 24047,
    county_name: "Worcester",
    county_weights: {
      24047: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 24047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21842,
    lat: 38.3778,
    lng: -75.09084,
    city: "Ocean City",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10525,
    density: 443.6,
    county_fips: 24047,
    county_name: "Worcester",
    county_weights: {
      24047: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 24047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21849,
    lat: 38.37006,
    lng: -75.46064,
    city: "Parsonsburg",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3659,
    density: 38.3,
    county_fips: 24045,
    county_name: "Wicomico",
    county_weights: {
      24045: 100,
    },
    county_names_all: "Wicomico",
    county_fips_all: 24045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21850,
    lat: 38.36171,
    lng: -75.39867,
    city: "Pittsville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3442,
    density: 47.3,
    county_fips: 24045,
    county_name: "Wicomico",
    county_weights: {
      24045: 100,
    },
    county_names_all: "Wicomico",
    county_fips_all: 24045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21851,
    lat: 38.07825,
    lng: -75.54375,
    city: "Pocomoke City",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7237,
    density: 27,
    county_fips: 24047,
    county_name: "Worcester",
    county_weights: {
      24039: 19.67,
      24047: 80.33,
    },
    county_names_all: "Worcester|Somerset",
    county_fips_all: "24047|24039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21853,
    lat: 38.20453,
    lng: -75.7102,
    city: "Princess Anne",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11437,
    density: 38.5,
    county_fips: 24039,
    county_name: "Somerset",
    county_weights: {
      24039: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 24039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21856,
    lat: 38.33807,
    lng: -75.79224,
    city: "Quantico",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 957,
    density: 11,
    county_fips: 24045,
    county_name: "Wicomico",
    county_weights: {
      24045: 100,
    },
    county_names_all: "Wicomico",
    county_fips_all: 24045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21861,
    lat: 38.53525,
    lng: -75.72834,
    city: "Sharptown",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 687,
    density: 101.8,
    county_fips: 24045,
    county_name: "Wicomico",
    county_weights: {
      24045: 100,
    },
    county_names_all: "Wicomico",
    county_fips_all: 24045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21862,
    lat: 38.39716,
    lng: -75.21514,
    city: "Showell",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 86,
    density: 31.6,
    county_fips: 24047,
    county_name: "Worcester",
    county_weights: {
      24047: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 24047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21863,
    lat: 38.19167,
    lng: -75.40327,
    city: "Snow Hill",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4578,
    density: 14.4,
    county_fips: 24047,
    county_name: "Worcester",
    county_weights: {
      24047: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 24047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21864,
    lat: 38.04355,
    lng: -75.40532,
    city: "Stockton",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 643,
    density: 10.9,
    county_fips: 24047,
    county_name: "Worcester",
    county_weights: {
      24047: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 24047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21865,
    lat: 38.28605,
    lng: -75.83296,
    city: "Tyaskin",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 433,
    density: 9.1,
    county_fips: 24045,
    county_name: "Wicomico",
    county_weights: {
      24045: 100,
    },
    county_names_all: "Wicomico",
    county_fips_all: 24045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21866,
    lat: 37.9672,
    lng: -76.02137,
    city: "Tylerton",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 80,
    density: 251.3,
    county_fips: 24039,
    county_name: "Somerset",
    county_weights: {
      24039: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 24039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21867,
    lat: 38.11025,
    lng: -75.79399,
    city: "Upper Fairmount",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23,
    density: 37.7,
    county_fips: 24039,
    county_name: "Somerset",
    county_weights: {
      24039: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 24039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21869,
    lat: 38.43246,
    lng: -75.89012,
    city: "Vienna",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1155,
    density: 5.1,
    county_fips: 24019,
    county_name: "Dorchester",
    county_weights: {
      24019: 100,
    },
    county_names_all: "Dorchester",
    county_fips_all: 24019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21871,
    lat: 38.10489,
    lng: -75.73127,
    city: "Westover",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2031,
    density: 11.7,
    county_fips: 24039,
    county_name: "Somerset",
    county_weights: {
      24039: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 24039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21872,
    lat: 38.4163,
    lng: -75.29399,
    city: "Whaleyville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 585,
    density: 13.8,
    county_fips: 24047,
    county_name: "Worcester",
    county_weights: {
      24047: 100,
    },
    county_names_all: "Worcester",
    county_fips_all: 24047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21874,
    lat: 38.39266,
    lng: -75.35417,
    city: "Willards",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1917,
    density: 26.2,
    county_fips: 24045,
    county_name: "Wicomico",
    county_weights: {
      10005: 0.52,
      24045: 99.48,
    },
    county_names_all: "Wicomico|Sussex",
    county_fips_all: "24045|10005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21875,
    lat: 38.44038,
    lng: -75.54559,
    city: "Delmar",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7084,
    density: 112.2,
    county_fips: 24045,
    county_name: "Wicomico",
    county_weights: {
      24045: 100,
    },
    county_names_all: "Wicomico",
    county_fips_all: 24045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21890,
    lat: 38.15673,
    lng: -75.6998,
    city: "Westover",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3272,
    density: 3598.8,
    county_fips: 24039,
    county_name: "Somerset",
    county_weights: {
      24039: 100,
    },
    county_names_all: "Somerset",
    county_fips_all: 24039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21901,
    lat: 39.58593,
    lng: -75.95821,
    city: "North East",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17694,
    density: 140.7,
    county_fips: 24015,
    county_name: "Cecil",
    county_weights: {
      24015: 100,
    },
    county_names_all: "Cecil",
    county_fips_all: 24015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21902,
    lat: 39.55229,
    lng: -76.06157,
    city: "Perry Point",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 262,
    density: 116.8,
    county_fips: 24015,
    county_name: "Cecil",
    county_weights: {
      24015: 100,
    },
    county_names_all: "Cecil",
    county_fips_all: 24015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21903,
    lat: 39.57274,
    lng: -76.04378,
    city: "Perryville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5794,
    density: 175.9,
    county_fips: 24015,
    county_name: "Cecil",
    county_weights: {
      24015: 100,
    },
    county_names_all: "Cecil",
    county_fips_all: 24015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21904,
    lat: 39.62303,
    lng: -76.07812,
    city: "Port Deposit",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6484,
    density: 106.1,
    county_fips: 24015,
    county_name: "Cecil",
    county_weights: {
      24015: 100,
    },
    county_names_all: "Cecil",
    county_fips_all: 24015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21911,
    lat: 39.68931,
    lng: -76.03886,
    city: "Rising Sun",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11103,
    density: 114.5,
    county_fips: 24015,
    county_name: "Cecil",
    county_weights: {
      24015: 100,
    },
    county_names_all: "Cecil",
    county_fips_all: 24015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21912,
    lat: 39.42486,
    lng: -75.81607,
    city: "Warwick",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1520,
    density: 17.3,
    county_fips: 24015,
    county_name: "Cecil",
    county_weights: {
      10003: 0.25,
      24015: 99.75,
    },
    county_names_all: "Cecil|New Castle",
    county_fips_all: "24015|10003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21913,
    lat: 39.40973,
    lng: -75.87073,
    city: "Cecilton",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 901,
    density: 287.8,
    county_fips: 24015,
    county_name: "Cecil",
    county_weights: {
      24015: 100,
    },
    county_names_all: "Cecil",
    county_fips_all: 24015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21914,
    lat: 39.57256,
    lng: -75.98158,
    city: "Charlestown",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 804,
    density: 424.8,
    county_fips: 24015,
    county_name: "Cecil",
    county_weights: {
      24015: 100,
    },
    county_names_all: "Cecil",
    county_fips_all: 24015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21915,
    lat: 39.50095,
    lng: -75.84764,
    city: "Chesapeake City",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2739,
    density: 46.5,
    county_fips: 24015,
    county_name: "Cecil",
    county_weights: {
      24015: 100,
    },
    county_names_all: "Cecil",
    county_fips_all: 24015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21917,
    lat: 39.67106,
    lng: -76.09823,
    city: "Colora",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2017,
    density: 99.6,
    county_fips: 24015,
    county_name: "Cecil",
    county_weights: {
      24015: 100,
    },
    county_names_all: "Cecil",
    county_fips_all: 24015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21918,
    lat: 39.68327,
    lng: -76.16662,
    city: "Conowingo",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4321,
    density: 95,
    county_fips: 24015,
    county_name: "Cecil",
    county_weights: {
      24015: 100,
    },
    county_names_all: "Cecil",
    county_fips_all: 24015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21919,
    lat: 39.42047,
    lng: -75.93372,
    city: "Earleville",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2905,
    density: 26.2,
    county_fips: 24015,
    county_name: "Cecil",
    county_weights: {
      24015: 100,
    },
    county_names_all: "Cecil",
    county_fips_all: 24015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21920,
    lat: 39.65675,
    lng: -75.83449,
    city: "Elk Mills",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 953,
    density: 371.9,
    county_fips: 24015,
    county_name: "Cecil",
    county_weights: {
      24015: 100,
    },
    county_names_all: "Cecil",
    county_fips_all: 24015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21921,
    lat: 39.62568,
    lng: -75.85904,
    city: "Elkton",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45225,
    density: 184.3,
    county_fips: 24015,
    county_name: "Cecil",
    county_weights: {
      24015: 100,
    },
    county_names_all: "Cecil",
    county_fips_all: 24015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 21930,
    lat: 39.37198,
    lng: -75.89115,
    city: "Georgetown",
    state_id: "MD",
    state_name: "Maryland",
    zcta: "TRUE",
    parent_zcta: "",
    population: 120,
    density: 62.9,
    county_fips: 24015,
    county_name: "Cecil",
    county_weights: {
      24015: 100,
    },
    county_names_all: "Cecil",
    county_fips_all: 24015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22003,
    lat: 38.8308,
    lng: -77.21402,
    city: "Annandale",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58252,
    density: 1780.2,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22015,
    lat: 38.78784,
    lng: -77.28136,
    city: "Burke",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45028,
    density: 2048.6,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22025,
    lat: 38.59874,
    lng: -77.3491,
    city: "Dumfries",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19634,
    density: 787,
    county_fips: 51153,
    county_name: "Prince William",
    county_weights: {
      51153: 100,
    },
    county_names_all: "Prince William",
    county_fips_all: 51153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22026,
    lat: 38.56717,
    lng: -77.29476,
    city: "Dumfries",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16701,
    density: 768.4,
    county_fips: 51153,
    county_name: "Prince William",
    county_weights: {
      51153: 100,
    },
    county_names_all: "Prince William",
    county_fips_all: 51153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22027,
    lat: 38.89411,
    lng: -77.22159,
    city: "Dunn Loring",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2427,
    density: 1470.7,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22030,
    lat: 38.83891,
    lng: -77.34188,
    city: "Fairfax",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60220,
    density: 1195.7,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 76,
      51600: 24,
    },
    county_names_all: "Fairfax|Fairfax",
    county_fips_all: "51059|51600",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22031,
    lat: 38.85954,
    lng: -77.2599,
    city: "Fairfax",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35110,
    density: 1902.1,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 82.41,
      51600: 17.59,
    },
    county_names_all: "Fairfax|Fairfax",
    county_fips_all: "51059|51600",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22032,
    lat: 38.82012,
    lng: -77.29032,
    city: "Fairfax",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31103,
    density: 1662.2,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 95.4,
      51600: 4.6,
    },
    county_names_all: "Fairfax|Fairfax",
    county_fips_all: "51059|51600",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22033,
    lat: 38.87564,
    lng: -77.38419,
    city: "Fairfax",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38724,
    density: 1911.8,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22035,
    lat: 38.85628,
    lng: -77.36269,
    city: "Fairfax",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 183,
    density: 1680.3,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22039,
    lat: 38.74992,
    lng: -77.31536,
    city: "Fairfax Station",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18095,
    density: 295.8,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22041,
    lat: 38.8485,
    lng: -77.14212,
    city: "Falls Church",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28476,
    density: 3962.2,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22042,
    lat: 38.86463,
    lng: -77.19406,
    city: "Falls Church",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36744,
    density: 2209.4,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 99.09,
      51610: 0.91,
    },
    county_names_all: "Fairfax|Falls Church",
    county_fips_all: "51059|51610",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22043,
    lat: 38.90076,
    lng: -77.19746,
    city: "Falls Church",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25012,
    density: 2066.8,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 98.86,
      51610: 1.14,
    },
    county_names_all: "Fairfax|Falls Church",
    county_fips_all: "51059|51610",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22044,
    lat: 38.85957,
    lng: -77.15627,
    city: "Falls Church",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14078,
    density: 2537.6,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 94.24,
      51610: 5.76,
    },
    county_names_all: "Fairfax|Falls Church",
    county_fips_all: "51059|51610",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22046,
    lat: 38.88696,
    lng: -77.18025,
    city: "Falls Church",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18639,
    density: 2642,
    county_fips: 51610,
    county_name: "Falls Church",
    county_weights: {
      51059: 33.62,
      51610: 66.38,
    },
    county_names_all: "Falls Church|Fairfax",
    county_fips_all: "51610|51059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22060,
    lat: 38.70525,
    lng: -77.15636,
    city: "Fort Belvoir",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9800,
    density: 288.1,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22066,
    lat: 39.01032,
    lng: -77.30258,
    city: "Great Falls",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17393,
    density: 262.5,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 99.12,
      51107: 0.88,
    },
    county_names_all: "Fairfax|Loudoun",
    county_fips_all: "51059|51107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22079,
    lat: 38.67998,
    lng: -77.2055,
    city: "Lorton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36839,
    density: 500.4,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22101,
    lat: 38.9386,
    lng: -77.16513,
    city: "McLean",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30598,
    density: 901.6,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51013: 0.54,
      51059: 99.46,
    },
    county_names_all: "Fairfax|Arlington",
    county_fips_all: "51059|51013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22102,
    lat: 38.95199,
    lng: -77.22901,
    city: "McLean",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26875,
    density: 843.1,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22124,
    lat: 38.8909,
    lng: -77.33025,
    city: "Oakton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18377,
    density: 687.1,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22125,
    lat: 38.68217,
    lng: -77.26073,
    city: "Occoquan",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 797,
    density: 2030.4,
    county_fips: 51153,
    county_name: "Prince William",
    county_weights: {
      51153: 100,
    },
    county_names_all: "Prince William",
    county_fips_all: 51153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22134,
    lat: 38.53186,
    lng: -77.409,
    city: "Quantico",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7354,
    density: 60.2,
    county_fips: 51179,
    county_name: "Stafford",
    county_weights: {
      51153: 23.44,
      51179: 76.56,
    },
    county_names_all: "Stafford|Prince William",
    county_fips_all: "51179|51153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22150,
    lat: 38.77198,
    lng: -77.18605,
    city: "Springfield",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29585,
    density: 1498.4,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22151,
    lat: 38.80283,
    lng: -77.2096,
    city: "Springfield",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18631,
    density: 1414,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22152,
    lat: 38.77564,
    lng: -77.23149,
    city: "Springfield",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30314,
    density: 1941.2,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22153,
    lat: 38.74443,
    lng: -77.23451,
    city: "Springfield",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31897,
    density: 1390.3,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22172,
    lat: 38.5742,
    lng: -77.3895,
    city: "Triangle",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11494,
    density: 215.4,
    county_fips: 51153,
    county_name: "Prince William",
    county_weights: {
      51153: 100,
    },
    county_names_all: "Prince William",
    county_fips_all: 51153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22180,
    lat: 38.89619,
    lng: -77.25426,
    city: "Vienna",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24011,
    density: 1573.4,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22181,
    lat: 38.9053,
    lng: -77.29466,
    city: "Vienna",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14531,
    density: 1005.2,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22182,
    lat: 38.93611,
    lng: -77.2736,
    city: "Vienna",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25985,
    density: 803.1,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22191,
    lat: 38.6249,
    lng: -77.26849,
    city: "Woodbridge",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 73081,
    density: 1829,
    county_fips: 51153,
    county_name: "Prince William",
    county_weights: {
      51153: 100,
    },
    county_names_all: "Prince William",
    county_fips_all: 51153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22192,
    lat: 38.68358,
    lng: -77.31821,
    city: "Woodbridge",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59670,
    density: 1199.7,
    county_fips: 51153,
    county_name: "Prince William",
    county_weights: {
      51153: 100,
    },
    county_names_all: "Prince William",
    county_fips_all: 51153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22193,
    lat: 38.64233,
    lng: -77.34881,
    city: "Woodbridge",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 82060,
    density: 1733.1,
    county_fips: 51153,
    county_name: "Prince William",
    county_weights: {
      51153: 100,
    },
    county_names_all: "Prince William",
    county_fips_all: 51153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22201,
    lat: 38.88684,
    lng: -77.09501,
    city: "Arlington",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38990,
    density: 6559.9,
    county_fips: 51013,
    county_name: "Arlington",
    county_weights: {
      51013: 100,
    },
    county_names_all: "Arlington",
    county_fips_all: 51013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22202,
    lat: 38.8569,
    lng: -77.05175,
    city: "Arlington",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26742,
    density: 2632.9,
    county_fips: 51013,
    county_name: "Arlington",
    county_weights: {
      51013: 100,
    },
    county_names_all: "Arlington",
    county_fips_all: 51013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22203,
    lat: 38.87377,
    lng: -77.1164,
    city: "Arlington",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24841,
    density: 6110.4,
    county_fips: 51013,
    county_name: "Arlington",
    county_weights: {
      51013: 99.07,
      51059: 0.93,
    },
    county_names_all: "Arlington|Fairfax",
    county_fips_all: "51013|51059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22204,
    lat: 38.86076,
    lng: -77.09894,
    city: "Arlington",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53855,
    density: 5048.8,
    county_fips: 51013,
    county_name: "Arlington",
    county_weights: {
      51013: 100,
    },
    county_names_all: "Arlington",
    county_fips_all: 51013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22205,
    lat: 38.88337,
    lng: -77.13948,
    city: "Arlington",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18570,
    density: 2628.2,
    county_fips: 51013,
    county_name: "Arlington",
    county_weights: {
      51013: 100,
    },
    county_names_all: "Arlington",
    county_fips_all: 51013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22206,
    lat: 38.8442,
    lng: -77.0886,
    city: "Arlington",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20716,
    density: 3880.7,
    county_fips: 51013,
    county_name: "Arlington",
    county_weights: {
      51013: 96.82,
      51510: 3.18,
    },
    county_names_all: "Arlington|Alexandria",
    county_fips_all: "51013|51510",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22207,
    lat: 38.90665,
    lng: -77.12384,
    city: "Arlington",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34113,
    density: 2041,
    county_fips: 51013,
    county_name: "Arlington",
    county_weights: {
      51013: 99.37,
      51059: 0.63,
    },
    county_names_all: "Arlington|Fairfax",
    county_fips_all: "51013|51059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22209,
    lat: 38.89413,
    lng: -77.07309,
    city: "Arlington",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13172,
    density: 6792.5,
    county_fips: 51013,
    county_name: "Arlington",
    county_weights: {
      51013: 100,
    },
    county_names_all: "Arlington",
    county_fips_all: 51013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22211,
    lat: 38.88011,
    lng: -77.07482,
    city: "Fort Myer",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1482,
    density: 531.6,
    county_fips: 51013,
    county_name: "Arlington",
    county_weights: {
      51013: 100,
    },
    county_names_all: "Arlington",
    county_fips_all: 51013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22213,
    lat: 38.89459,
    lng: -77.16239,
    city: "Arlington",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4168,
    density: 2720,
    county_fips: 51013,
    county_name: "Arlington",
    county_weights: {
      51013: 100,
    },
    county_names_all: "Arlington",
    county_fips_all: 51013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22214,
    lat: 38.87499,
    lng: -77.06501,
    city: "Arlington",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 51013,
    county_name: "Arlington",
    county_weights: {
      51013: 100,
    },
    county_names_all: "Arlington",
    county_fips_all: 51013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22301,
    lat: 38.81995,
    lng: -77.05934,
    city: "Alexandria",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13188,
    density: 3668.6,
    county_fips: 51510,
    county_name: "Alexandria",
    county_weights: {
      51510: 100,
    },
    county_names_all: "Alexandria",
    county_fips_all: 51510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22302,
    lat: 38.82799,
    lng: -77.08432,
    city: "Alexandria",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17985,
    density: 3062.4,
    county_fips: 51510,
    county_name: "Alexandria",
    county_weights: {
      51059: 4.42,
      51510: 95.58,
    },
    county_names_all: "Alexandria|Fairfax",
    county_fips_all: "51510|51059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22303,
    lat: 38.794,
    lng: -77.08175,
    city: "Alexandria",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14688,
    density: 2950.2,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22304,
    lat: 38.81361,
    lng: -77.11498,
    city: "Alexandria",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49262,
    density: 3924.7,
    county_fips: 51510,
    county_name: "Alexandria",
    county_weights: {
      51059: 3.45,
      51510: 96.55,
    },
    county_names_all: "Alexandria|Fairfax",
    county_fips_all: "51510|51059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22305,
    lat: 38.83655,
    lng: -77.06234,
    city: "Alexandria",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18377,
    density: 5328.4,
    county_fips: 51510,
    county_name: "Alexandria",
    county_weights: {
      51510: 100,
    },
    county_names_all: "Alexandria",
    county_fips_all: 51510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22306,
    lat: 38.75655,
    lng: -77.09254,
    city: "Alexandria",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34391,
    density: 1956.6,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22307,
    lat: 38.7708,
    lng: -77.05694,
    city: "Alexandria",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10286,
    density: 1275.3,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22308,
    lat: 38.72957,
    lng: -77.05876,
    city: "Alexandria",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12980,
    density: 1130,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22309,
    lat: 38.71931,
    lng: -77.10724,
    city: "Alexandria",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36110,
    density: 1852.4,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22310,
    lat: 38.78447,
    lng: -77.12231,
    city: "Alexandria",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32329,
    density: 1851.2,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22311,
    lat: 38.83442,
    lng: -77.12313,
    city: "Alexandria",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18890,
    density: 4712.7,
    county_fips: 51510,
    county_name: "Alexandria",
    county_weights: {
      51059: 23.59,
      51510: 76.41,
    },
    county_names_all: "Alexandria|Fairfax",
    county_fips_all: "51510|51059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22312,
    lat: 38.81685,
    lng: -77.15372,
    city: "Alexandria",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30327,
    density: 2284.4,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 91.6,
      51510: 8.4,
    },
    county_names_all: "Fairfax|Alexandria",
    county_fips_all: "51059|51510",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22314,
    lat: 38.80732,
    lng: -77.0563,
    city: "Alexandria",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35208,
    density: 3672.5,
    county_fips: 51510,
    county_name: "Alexandria",
    county_weights: {
      51510: 100,
    },
    county_names_all: "Alexandria",
    county_fips_all: 51510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22315,
    lat: 38.75735,
    lng: -77.14803,
    city: "Alexandria",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29634,
    density: 2077.7,
    county_fips: 51059,
    county_name: "Fairfax",
    county_weights: {
      51059: 100,
    },
    county_names_all: "Fairfax",
    county_fips_all: 51059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22401,
    lat: 38.29928,
    lng: -77.48704,
    city: "Fredericksburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29059,
    density: 1082.4,
    county_fips: 51630,
    county_name: "Fredericksburg",
    county_weights: {
      51177: 0.17,
      51630: 99.83,
    },
    county_names_all: "Fredericksburg|Spotsylvania",
    county_fips_all: "51630|51177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22405,
    lat: 38.31568,
    lng: -77.40377,
    city: "Fredericksburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33482,
    density: 242.5,
    county_fips: 51179,
    county_name: "Stafford",
    county_weights: {
      51179: 100,
    },
    county_names_all: "Stafford",
    county_fips_all: 51179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22406,
    lat: 38.39964,
    lng: -77.55596,
    city: "Fredericksburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25665,
    density: 136.3,
    county_fips: 51179,
    county_name: "Stafford",
    county_weights: {
      51061: 4.61,
      51179: 95.39,
    },
    county_names_all: "Stafford|Fauquier",
    county_fips_all: "51179|51061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22407,
    lat: 38.28581,
    lng: -77.58055,
    city: "Fredericksburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59551,
    density: 376.9,
    county_fips: 51177,
    county_name: "Spotsylvania",
    county_weights: {
      51047: 2.64,
      51177: 97.25,
      51630: 0.11,
    },
    county_names_all: "Spotsylvania|Culpeper|Fredericksburg",
    county_fips_all: "51177|51047|51630",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22408,
    lat: 38.21916,
    lng: -77.44013,
    city: "Fredericksburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30129,
    density: 245.8,
    county_fips: 51177,
    county_name: "Spotsylvania",
    county_weights: {
      51033: 17.17,
      51177: 82.83,
    },
    county_names_all: "Spotsylvania|Caroline",
    county_fips_all: "51177|51033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22427,
    lat: 38.07177,
    lng: -77.28624,
    city: "Bowling Green",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5259,
    density: 19.2,
    county_fips: 51033,
    county_name: "Caroline",
    county_weights: {
      51033: 100,
    },
    county_names_all: "Caroline",
    county_fips_all: 51033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22432,
    lat: 37.8637,
    lng: -76.35043,
    city: "Burgess",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 233,
    density: 28.5,
    county_fips: 51133,
    county_name: "Northumberland",
    county_weights: {
      51133: 100,
    },
    county_names_all: "Northumberland",
    county_fips_all: 51133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22433,
    lat: 38.35875,
    lng: -77.86093,
    city: "Burr Hill",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 402,
    density: 41.5,
    county_fips: 51137,
    county_name: "Orange",
    county_weights: {
      51137: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 51137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22435,
    lat: 37.97216,
    lng: -76.57288,
    city: "Callao",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2559,
    density: 38.8,
    county_fips: 51133,
    county_name: "Northumberland",
    county_weights: {
      51133: 93.43,
      51159: 5.25,
      51193: 1.32,
    },
    county_names_all: "Northumberland|Richmond|Westmoreland",
    county_fips_all: "51133|51159|51193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22436,
    lat: 38.04698,
    lng: -77.07471,
    city: "Caret",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1055,
    density: 14,
    county_fips: 51057,
    county_name: "Essex",
    county_weights: {
      51057: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 51057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22437,
    lat: 37.7764,
    lng: -76.8156,
    city: "Center Cross",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1002,
    density: 10.4,
    county_fips: 51097,
    county_name: "King and Queen",
    county_weights: {
      51057: 33.96,
      51097: 66.04,
    },
    county_names_all: "King and Queen|Essex",
    county_fips_all: "51097|51057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22438,
    lat: 38.03788,
    lng: -76.99971,
    city: "Champlain",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 379,
    density: 3.6,
    county_fips: 51057,
    county_name: "Essex",
    county_weights: {
      51033: 9.43,
      51057: 90.57,
    },
    county_names_all: "Essex|Caroline",
    county_fips_all: "51057|51033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22443,
    lat: 38.18078,
    lng: -76.99776,
    city: "Colonial Beach",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8906,
    density: 58,
    county_fips: 51193,
    county_name: "Westmoreland",
    county_weights: {
      51099: 0.31,
      51193: 99.69,
    },
    county_names_all: "Westmoreland|King George",
    county_fips_all: "51193|51099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22448,
    lat: 38.33996,
    lng: -77.03238,
    city: "Dahlgren",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 714,
    density: 67.3,
    county_fips: 51099,
    county_name: "King George",
    county_weights: {
      51099: 100,
    },
    county_names_all: "King George",
    county_fips_all: 51099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22454,
    lat: 37.83599,
    lng: -76.85032,
    city: "Dunnsville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1968,
    density: 16.9,
    county_fips: 51057,
    county_name: "Essex",
    county_weights: {
      51057: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 51057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22460,
    lat: 37.87612,
    lng: -76.60692,
    city: "Farnham",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1276,
    density: 8.5,
    county_fips: 51159,
    county_name: "Richmond",
    county_weights: {
      51159: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 51159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22469,
    lat: 38.0667,
    lng: -76.64749,
    city: "Hague",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2347,
    density: 29.7,
    county_fips: 51193,
    county_name: "Westmoreland",
    county_weights: {
      51193: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 51193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22472,
    lat: 37.95897,
    lng: -76.67257,
    city: "Haynesville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 51159,
    county_name: "Richmond",
    county_weights: {
      51159: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 51159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22473,
    lat: 37.88316,
    lng: -76.41386,
    city: "Heathsville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5013,
    density: 16.9,
    county_fips: 51133,
    county_name: "Northumberland",
    county_weights: {
      51103: 3.08,
      51133: 96.92,
    },
    county_names_all: "Northumberland|Lancaster",
    county_fips_all: "51133|51103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22476,
    lat: 38.03807,
    lng: -77.06872,
    city: "Hustle",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 225,
    density: 5,
    county_fips: 51057,
    county_name: "Essex",
    county_weights: {
      51057: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 51057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22480,
    lat: 37.66631,
    lng: -76.41498,
    city: "Irvington",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 692,
    density: 108,
    county_fips: 51103,
    county_name: "Lancaster",
    county_weights: {
      51103: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 51103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22482,
    lat: 37.73723,
    lng: -76.35245,
    city: "Kilmarnock",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2980,
    density: 37.9,
    county_fips: 51133,
    county_name: "Northumberland",
    county_weights: {
      51103: 34.91,
      51133: 65.09,
    },
    county_names_all: "Northumberland|Lancaster",
    county_fips_all: "51133|51103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22485,
    lat: 38.2717,
    lng: -77.15996,
    city: "King George",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25997,
    density: 57.1,
    county_fips: 51099,
    county_name: "King George",
    county_weights: {
      51099: 99.77,
      51193: 0.23,
    },
    county_names_all: "King George|Westmoreland",
    county_fips_all: "51099|51193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22488,
    lat: 38.04986,
    lng: -76.58796,
    city: "Kinsale",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 678,
    density: 10.4,
    county_fips: 51193,
    county_name: "Westmoreland",
    county_weights: {
      51193: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 51193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22503,
    lat: 37.7624,
    lng: -76.50432,
    city: "Lancaster",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3606,
    density: 16.1,
    county_fips: 51103,
    county_name: "Lancaster",
    county_weights: {
      51103: 98.07,
      51133: 1.93,
    },
    county_names_all: "Lancaster|Northumberland",
    county_fips_all: "51103|51133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22504,
    lat: 37.76346,
    lng: -76.72675,
    city: "Laneview",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 117,
    density: 3.6,
    county_fips: 51057,
    county_name: "Essex",
    county_weights: {
      51057: 81.31,
      51119: 18.69,
    },
    county_names_all: "Essex|Middlesex",
    county_fips_all: "51057|51119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22508,
    lat: 38.31732,
    lng: -77.7913,
    city: "Locust Grove",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15323,
    density: 102.8,
    county_fips: 51137,
    county_name: "Orange",
    county_weights: {
      51137: 90.38,
      51177: 9.62,
    },
    county_names_all: "Orange|Spotsylvania",
    county_fips_all: "51137|51177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22509,
    lat: 38.10642,
    lng: -77.06669,
    city: "Loretto",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55,
    density: 1.4,
    county_fips: 51057,
    county_name: "Essex",
    county_weights: {
      51057: 100,
    },
    county_names_all: "Essex",
    county_fips_all: 51057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22511,
    lat: 37.98352,
    lng: -76.50323,
    city: "Lottsburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 816,
    density: 19.8,
    county_fips: 51133,
    county_name: "Northumberland",
    county_weights: {
      51133: 100,
    },
    county_names_all: "Northumberland",
    county_fips_all: 51133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22514,
    lat: 37.9724,
    lng: -77.24471,
    city: "Milford",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2307,
    density: 11.6,
    county_fips: 51033,
    county_name: "Caroline",
    county_weights: {
      51033: 97.63,
      51097: 2.37,
    },
    county_names_all: "Caroline|King and Queen",
    county_fips_all: "51033|51097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22520,
    lat: 38.11651,
    lng: -76.80634,
    city: "Montross",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5410,
    density: 21.6,
    county_fips: 51193,
    county_name: "Westmoreland",
    county_weights: {
      51159: 2.44,
      51193: 97.56,
    },
    county_names_all: "Westmoreland|Richmond",
    county_fips_all: "51193|51159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22529,
    lat: 38.01036,
    lng: -76.67942,
    city: "Oldhams",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11,
    density: 0.6,
    county_fips: 51193,
    county_name: "Westmoreland",
    county_weights: {
      51193: 100,
    },
    county_names_all: "Westmoreland",
    county_fips_all: 51193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22534,
    lat: 38.08473,
    lng: -77.67062,
    city: "Partlow",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2910,
    density: 33.9,
    county_fips: 51177,
    county_name: "Spotsylvania",
    county_weights: {
      51177: 100,
    },
    county_names_all: "Spotsylvania",
    county_fips_all: 51177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22535,
    lat: 38.12314,
    lng: -77.19619,
    city: "Port Royal",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 432,
    density: 3.9,
    county_fips: 51033,
    county_name: "Caroline",
    county_weights: {
      51033: 100,
    },
    county_names_all: "Caroline",
    county_fips_all: 51033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22538,
    lat: 38.18941,
    lng: -77.27334,
    city: "Rappahannock Academy",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 177,
    density: 2.8,
    county_fips: 51033,
    county_name: "Caroline",
    county_weights: {
      51033: 100,
    },
    county_names_all: "Caroline",
    county_fips_all: 51033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22539,
    lat: 37.85865,
    lng: -76.28731,
    city: "Reedville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2429,
    density: 55.5,
    county_fips: 51133,
    county_name: "Northumberland",
    county_weights: {
      51133: 100,
    },
    county_names_all: "Northumberland",
    county_fips_all: 51133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22542,
    lat: 38.29348,
    lng: -77.88837,
    city: "Rhoadesville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1846,
    density: 41.8,
    county_fips: 51137,
    county_name: "Orange",
    county_weights: {
      51137: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 51137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22546,
    lat: 37.94342,
    lng: -77.44565,
    city: "Ruther Glen",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16553,
    density: 39,
    county_fips: 51033,
    county_name: "Caroline",
    county_weights: {
      51033: 93.91,
      51085: 4.58,
      51177: 1.51,
    },
    county_names_all: "Caroline|Hanover|Spotsylvania",
    county_fips_all: "51033|51085|51177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22548,
    lat: 37.82929,
    lng: -76.69256,
    city: "Sharps",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 439,
    density: 170.6,
    county_fips: 51159,
    county_name: "Richmond",
    county_weights: {
      51159: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 51159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22551,
    lat: 38.17273,
    lng: -77.70575,
    city: "Spotsylvania",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20218,
    density: 46.4,
    county_fips: 51177,
    county_name: "Spotsylvania",
    county_weights: {
      51137: 0.61,
      51177: 99.39,
    },
    county_names_all: "Spotsylvania|Orange",
    county_fips_all: "51177|51137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22553,
    lat: 38.26594,
    lng: -77.6397,
    city: "Spotsylvania",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15960,
    density: 141.4,
    county_fips: 51177,
    county_name: "Spotsylvania",
    county_weights: {
      51177: 100,
    },
    county_names_all: "Spotsylvania",
    county_fips_all: 51177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22554,
    lat: 38.42285,
    lng: -77.3835,
    city: "Stafford",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57488,
    density: 346.2,
    county_fips: 51179,
    county_name: "Stafford",
    county_weights: {
      51179: 100,
    },
    county_names_all: "Stafford",
    county_fips_all: 51179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22556,
    lat: 38.48624,
    lng: -77.513,
    city: "Stafford",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31545,
    density: 262.8,
    county_fips: 51179,
    county_name: "Stafford",
    county_weights: {
      51061: 0.82,
      51179: 99.18,
    },
    county_names_all: "Stafford|Fauquier",
    county_fips_all: "51179|51061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22560,
    lat: 37.91289,
    lng: -76.96196,
    city: "Tappahannock",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6269,
    density: 24.4,
    county_fips: 51057,
    county_name: "Essex",
    county_weights: {
      51057: 88.7,
      51097: 11.3,
    },
    county_names_all: "Essex|King and Queen",
    county_fips_all: "51057|51097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22567,
    lat: 38.23395,
    lng: -77.92401,
    city: "Unionville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3336,
    density: 28.5,
    county_fips: 51137,
    county_name: "Orange",
    county_weights: {
      51137: 99.35,
      51177: 0.65,
    },
    county_names_all: "Orange|Spotsylvania",
    county_fips_all: "51137|51177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22572,
    lat: 37.97552,
    lng: -76.77495,
    city: "Warsaw",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7378,
    density: 20.2,
    county_fips: 51159,
    county_name: "Richmond",
    county_weights: {
      51159: 91.58,
      51193: 8.42,
    },
    county_names_all: "Richmond|Westmoreland",
    county_fips_all: "51159|51193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22576,
    lat: 37.69398,
    lng: -76.43277,
    city: "Weems",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1972,
    density: 61.7,
    county_fips: 51103,
    county_name: "Lancaster",
    county_weights: {
      51103: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 51103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22578,
    lat: 37.65063,
    lng: -76.36268,
    city: "White Stone",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2596,
    density: 53.6,
    county_fips: 51103,
    county_name: "Lancaster",
    county_weights: {
      51103: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 51103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22580,
    lat: 38.10941,
    lng: -77.44419,
    city: "Woodford",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5467,
    density: 22.3,
    county_fips: 51033,
    county_name: "Caroline",
    county_weights: {
      51033: 89.9,
      51177: 10.1,
    },
    county_names_all: "Caroline|Spotsylvania",
    county_fips_all: "51033|51177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22601,
    lat: 39.1743,
    lng: -78.1743,
    city: "Winchester",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29192,
    density: 1153.1,
    county_fips: 51840,
    county_name: "Winchester",
    county_weights: {
      51069: 6,
      51840: 94,
    },
    county_names_all: "Winchester|Frederick",
    county_fips_all: "51840|51069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22602,
    lat: 39.1508,
    lng: -78.26555,
    city: "Winchester",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30665,
    density: 104.4,
    county_fips: 51069,
    county_name: "Frederick",
    county_weights: {
      51069: 100,
    },
    county_names_all: "Frederick",
    county_fips_all: 51069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22603,
    lat: 39.28153,
    lng: -78.2056,
    city: "Winchester",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16073,
    density: 63,
    county_fips: 51069,
    county_name: "Frederick",
    county_weights: {
      51069: 100,
    },
    county_names_all: "Frederick",
    county_fips_all: 51069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22610,
    lat: 38.81803,
    lng: -78.28102,
    city: "Bentonville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1499,
    density: 11.1,
    county_fips: 51187,
    county_name: "Warren",
    county_weights: {
      51187: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 51187,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22611,
    lat: 39.16374,
    lng: -77.98512,
    city: "Berryville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9059,
    density: 42.2,
    county_fips: 51043,
    county_name: "Clarke",
    county_weights: {
      51043: 100,
    },
    county_names_all: "Clarke",
    county_fips_all: 51043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22620,
    lat: 39.06417,
    lng: -78.03317,
    city: "Boyce",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2865,
    density: 24.2,
    county_fips: 51043,
    county_name: "Clarke",
    county_weights: {
      51043: 100,
    },
    county_names_all: "Clarke",
    county_fips_all: 51043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22623,
    lat: 38.85158,
    lng: -78.13734,
    city: "Chester Gap",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 892,
    density: 287.3,
    county_fips: 51157,
    county_name: "Rappahannock",
    county_weights: {
      51157: 100,
    },
    county_names_all: "Rappahannock",
    county_fips_all: 51157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22624,
    lat: 39.26535,
    lng: -78.09507,
    city: "Clear Brook",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3107,
    density: 58.4,
    county_fips: 51069,
    county_name: "Frederick",
    county_weights: {
      51069: 100,
    },
    county_names_all: "Frederick",
    county_fips_all: 51069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22625,
    lat: 39.37397,
    lng: -78.31172,
    city: "Cross Junction",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3739,
    density: 34.2,
    county_fips: 51069,
    county_name: "Frederick",
    county_weights: {
      51069: 100,
    },
    county_names_all: "Frederick",
    county_fips_all: 51069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22627,
    lat: 38.76554,
    lng: -78.11371,
    city: "Flint Hill",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 780,
    density: 9.4,
    county_fips: 51157,
    county_name: "Rappahannock",
    county_weights: {
      51157: 100,
    },
    county_names_all: "Rappahannock",
    county_fips_all: 51157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22630,
    lat: 38.92909,
    lng: -78.18052,
    city: "Front Royal",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33623,
    density: 106.5,
    county_fips: 51187,
    county_name: "Warren",
    county_weights: {
      51043: 0.63,
      51061: 0.19,
      51069: 1.63,
      51187: 97.55,
    },
    county_names_all: "Warren|Frederick|Clarke|Fauquier",
    county_fips_all: "51187|51069|51043|51061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22637,
    lat: 39.25057,
    lng: -78.3605,
    city: "Gore",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2042,
    density: 18.7,
    county_fips: 51069,
    county_name: "Frederick",
    county_weights: {
      51069: 100,
    },
    county_names_all: "Frederick",
    county_fips_all: 51069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22639,
    lat: 38.82625,
    lng: -78.0321,
    city: "Hume",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 526,
    density: 6.2,
    county_fips: 51061,
    county_name: "Fauquier",
    county_weights: {
      51061: 100,
    },
    county_names_all: "Fauquier",
    county_fips_all: 51061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22640,
    lat: 38.80737,
    lng: -78.13302,
    city: "Huntly",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 294,
    density: 4.7,
    county_fips: 51157,
    county_name: "Rappahannock",
    county_weights: {
      51157: 100,
    },
    county_names_all: "Rappahannock",
    county_fips_all: 51157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22641,
    lat: 39.07795,
    lng: -78.38588,
    city: "Strasburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 470,
    density: 37.6,
    county_fips: 51171,
    county_name: "Shenandoah",
    county_weights: {
      51069: 0.15,
      51171: 99.85,
    },
    county_names_all: "Shenandoah|Frederick",
    county_fips_all: "51171|51069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22642,
    lat: 38.91532,
    lng: -78.06538,
    city: "Linden",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4702,
    density: 64,
    county_fips: 51187,
    county_name: "Warren",
    county_weights: {
      51061: 47.9,
      51187: 52.1,
    },
    county_names_all: "Warren|Fauquier",
    county_fips_all: "51187|51061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22643,
    lat: 38.9034,
    lng: -78.00801,
    city: "Markham",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 286,
    density: 5.2,
    county_fips: 51061,
    county_name: "Fauquier",
    county_weights: {
      51061: 100,
    },
    county_names_all: "Fauquier",
    county_fips_all: 51061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22644,
    lat: 38.96362,
    lng: -78.5314,
    city: "Maurertown",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2415,
    density: 15.4,
    county_fips: 51171,
    county_name: "Shenandoah",
    county_weights: {
      51171: 100,
    },
    county_names_all: "Shenandoah",
    county_fips_all: 51171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22645,
    lat: 39.02152,
    lng: -78.27457,
    city: "Middletown",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4321,
    density: 45.9,
    county_fips: 51069,
    county_name: "Frederick",
    county_weights: {
      51069: 56.83,
      51187: 43.17,
    },
    county_names_all: "Frederick|Warren",
    county_fips_all: "51069|51187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22646,
    lat: 39.07019,
    lng: -78.04803,
    city: "Millwood",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50,
    density: 19.2,
    county_fips: 51043,
    county_name: "Clarke",
    county_weights: {
      51043: 100,
    },
    county_names_all: "Clarke",
    county_fips_all: 51043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22650,
    lat: 38.75893,
    lng: -78.35817,
    city: "Rileyville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 656,
    density: 8.6,
    county_fips: 51139,
    county_name: "Page",
    county_weights: {
      51139: 100,
    },
    county_names_all: "Page",
    county_fips_all: 51139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22652,
    lat: 38.83921,
    lng: -78.42894,
    city: "Fort Valley",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1403,
    density: 7.8,
    county_fips: 51171,
    county_name: "Shenandoah",
    county_weights: {
      51171: 100,
    },
    county_names_all: "Shenandoah",
    county_fips_all: 51171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22654,
    lat: 39.06863,
    lng: -78.4586,
    city: "Star Tannery",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 833,
    density: 7.8,
    county_fips: 51069,
    county_name: "Frederick",
    county_weights: {
      51069: 68.19,
      51171: 31.81,
    },
    county_names_all: "Frederick|Shenandoah",
    county_fips_all: "51069|51171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22655,
    lat: 39.06443,
    lng: -78.21425,
    city: "Stephens City",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21567,
    density: 235,
    county_fips: 51069,
    county_name: "Frederick",
    county_weights: {
      51069: 91.59,
      51187: 8.41,
    },
    county_names_all: "Frederick|Warren",
    county_fips_all: "51069|51187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22656,
    lat: 39.21723,
    lng: -78.08901,
    city: "Stephenson",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4052,
    density: 178.1,
    county_fips: 51069,
    county_name: "Frederick",
    county_weights: {
      51069: 100,
    },
    county_names_all: "Frederick",
    county_fips_all: 51069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22657,
    lat: 39.00155,
    lng: -78.36755,
    city: "Strasburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10389,
    density: 69.5,
    county_fips: 51171,
    county_name: "Shenandoah",
    county_weights: {
      51171: 85.88,
      51187: 14.12,
    },
    county_names_all: "Shenandoah|Warren",
    county_fips_all: "51171|51187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22660,
    lat: 38.95628,
    lng: -78.4383,
    city: "Toms Brook",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1803,
    density: 58.2,
    county_fips: 51171,
    county_name: "Shenandoah",
    county_weights: {
      51171: 100,
    },
    county_names_all: "Shenandoah",
    county_fips_all: 51171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22663,
    lat: 39.05,
    lng: -78.11716,
    city: "White Post",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 690,
    density: 12.4,
    county_fips: 51043,
    county_name: "Clarke",
    county_weights: {
      51043: 75.3,
      51069: 16.12,
      51187: 8.58,
    },
    county_names_all: "Clarke|Frederick|Warren",
    county_fips_all: "51043|51069|51187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22664,
    lat: 38.8944,
    lng: -78.53119,
    city: "Woodstock",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9528,
    density: 81.1,
    county_fips: 51171,
    county_name: "Shenandoah",
    county_weights: {
      51171: 100,
    },
    county_names_all: "Shenandoah",
    county_fips_all: 51171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22701,
    lat: 38.44038,
    lng: -77.99633,
    city: "Culpeper",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34793,
    density: 78,
    county_fips: 51047,
    county_name: "Culpeper",
    county_weights: {
      51047: 78.54,
      51113: 7.2,
      51137: 14.26,
    },
    county_names_all: "Culpeper|Orange|Madison",
    county_fips_all: "51047|51137|51113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22709,
    lat: 38.32769,
    lng: -78.21732,
    city: "Aroda",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1425,
    density: 47,
    county_fips: 51113,
    county_name: "Madison",
    county_weights: {
      51113: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 51113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22711,
    lat: 38.46239,
    lng: -78.27634,
    city: "Banco",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25,
    density: 4.2,
    county_fips: 51113,
    county_name: "Madison",
    county_weights: {
      51113: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 51113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22712,
    lat: 38.55632,
    lng: -77.75884,
    city: "Bealeton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8209,
    density: 87.4,
    county_fips: 51061,
    county_name: "Fauquier",
    county_weights: {
      51061: 100,
    },
    county_names_all: "Fauquier",
    county_fips_all: 51061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22713,
    lat: 38.54123,
    lng: -78.13204,
    city: "Boston",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1812,
    density: 31.4,
    county_fips: 51047,
    county_name: "Culpeper",
    county_weights: {
      51047: 67.95,
      51157: 32.05,
    },
    county_names_all: "Culpeper|Rappahannock",
    county_fips_all: "51047|51157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22714,
    lat: 38.52068,
    lng: -77.89363,
    city: "Brandy Station",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1027,
    density: 18.9,
    county_fips: 51047,
    county_name: "Culpeper",
    county_weights: {
      51047: 100,
    },
    county_names_all: "Culpeper",
    county_fips_all: 51047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22715,
    lat: 38.41032,
    lng: -78.18541,
    city: "Brightwood",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1379,
    density: 73.7,
    county_fips: 51113,
    county_name: "Madison",
    county_weights: {
      51113: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 51113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22716,
    lat: 38.62596,
    lng: -78.10794,
    city: "Castleton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 757,
    density: 11.5,
    county_fips: 51157,
    county_name: "Rappahannock",
    county_weights: {
      51047: 2.9,
      51157: 97.1,
    },
    county_names_all: "Rappahannock|Culpeper",
    county_fips_all: "51157|51047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22718,
    lat: 38.47076,
    lng: -77.82026,
    city: "Elkwood",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 579,
    density: 8.9,
    county_fips: 51047,
    county_name: "Culpeper",
    county_weights: {
      51047: 100,
    },
    county_names_all: "Culpeper",
    county_fips_all: 51047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22719,
    lat: 38.52888,
    lng: -78.28337,
    city: "Etlan",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 81,
    density: 1.6,
    county_fips: 51113,
    county_name: "Madison",
    county_weights: {
      51113: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 51113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22720,
    lat: 38.48044,
    lng: -77.6468,
    city: "Goldvein",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1060,
    density: 29.6,
    county_fips: 51061,
    county_name: "Fauquier",
    county_weights: {
      51061: 100,
    },
    county_names_all: "Fauquier",
    county_fips_all: 51061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22722,
    lat: 38.46304,
    lng: -78.22645,
    city: "Haywood",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 421,
    density: 62.1,
    county_fips: 51113,
    county_name: "Madison",
    county_weights: {
      51113: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 51113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22723,
    lat: 38.33789,
    lng: -78.38821,
    city: "Hood",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 114,
    density: 11.7,
    county_fips: 51113,
    county_name: "Madison",
    county_weights: {
      51079: 0.14,
      51113: 99.86,
    },
    county_names_all: "Madison|Greene",
    county_fips_all: "51113|51079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22724,
    lat: 38.63286,
    lng: -77.90752,
    city: "Jeffersonton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2342,
    density: 55,
    county_fips: 51047,
    county_name: "Culpeper",
    county_weights: {
      51047: 100,
    },
    county_names_all: "Culpeper",
    county_fips_all: 51047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22725,
    lat: 38.44029,
    lng: -78.1527,
    city: "Leon",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 51113,
    county_name: "Madison",
    county_weights: {
      51113: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 51113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22726,
    lat: 38.40179,
    lng: -77.81796,
    city: "Lignum",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 886,
    density: 20.2,
    county_fips: 51047,
    county_name: "Culpeper",
    county_weights: {
      51047: 100,
    },
    county_names_all: "Culpeper",
    county_fips_all: 51047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22727,
    lat: 38.39626,
    lng: -78.30058,
    city: "Madison",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5761,
    density: 20.9,
    county_fips: 51113,
    county_name: "Madison",
    county_weights: {
      51113: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 51113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22728,
    lat: 38.57773,
    lng: -77.68639,
    city: "Midland",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2615,
    density: 20.8,
    county_fips: 51061,
    county_name: "Fauquier",
    county_weights: {
      51061: 100,
    },
    county_names_all: "Fauquier",
    county_fips_all: 51061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22729,
    lat: 38.35658,
    lng: -78.01596,
    city: "Mitchells",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1391,
    density: 52.5,
    county_fips: 51047,
    county_name: "Culpeper",
    county_weights: {
      51047: 100,
    },
    county_names_all: "Culpeper",
    county_fips_all: 51047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22730,
    lat: 38.36782,
    lng: -78.16635,
    city: "Oakpark",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 211,
    density: 20.2,
    county_fips: 51113,
    county_name: "Madison",
    county_weights: {
      51113: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 51113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22731,
    lat: 38.34413,
    lng: -78.26151,
    city: "Pratts",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35,
    density: 7.1,
    county_fips: 51113,
    county_name: "Madison",
    county_weights: {
      51113: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 51113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22732,
    lat: 38.30886,
    lng: -78.19153,
    city: "Radiant",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 89,
    density: 8.6,
    county_fips: 51113,
    county_name: "Madison",
    county_weights: {
      51113: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 51113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22733,
    lat: 38.33191,
    lng: -78.0467,
    city: "Rapidan",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1314,
    density: 11.4,
    county_fips: 51047,
    county_name: "Culpeper",
    county_weights: {
      51047: 50.35,
      51113: 2.12,
      51137: 47.53,
    },
    county_names_all: "Culpeper|Orange|Madison",
    county_fips_all: "51047|51137|51113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22734,
    lat: 38.52757,
    lng: -77.81119,
    city: "Remington",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3641,
    density: 39.3,
    county_fips: 51061,
    county_name: "Fauquier",
    county_weights: {
      51047: 34.71,
      51061: 65.29,
    },
    county_names_all: "Fauquier|Culpeper",
    county_fips_all: "51061|51047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22735,
    lat: 38.47941,
    lng: -78.18336,
    city: "Reva",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2686,
    density: 32.5,
    county_fips: 51113,
    county_name: "Madison",
    county_weights: {
      51047: 37.16,
      51113: 62.84,
    },
    county_names_all: "Madison|Culpeper",
    county_fips_all: "51113|51047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22736,
    lat: 38.39633,
    lng: -77.69673,
    city: "Richardsville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 990,
    density: 15.8,
    county_fips: 51047,
    county_name: "Culpeper",
    county_weights: {
      51047: 100,
    },
    county_names_all: "Culpeper",
    county_fips_all: 51047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22737,
    lat: 38.59024,
    lng: -78.00205,
    city: "Rixeyville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3475,
    density: 32.4,
    county_fips: 51047,
    county_name: "Culpeper",
    county_weights: {
      51047: 100,
    },
    county_names_all: "Culpeper",
    county_fips_all: 51047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22738,
    lat: 38.28692,
    lng: -78.27685,
    city: "Rochelle",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1394,
    density: 22.3,
    county_fips: 51113,
    county_name: "Madison",
    county_weights: {
      51113: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 51113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22740,
    lat: 38.63805,
    lng: -78.26163,
    city: "Sperryville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 922,
    density: 4.8,
    county_fips: 51157,
    county_name: "Rappahannock",
    county_weights: {
      51047: 4.28,
      51113: 1.91,
      51157: 93.81,
    },
    county_names_all: "Rappahannock|Culpeper|Madison",
    county_fips_all: "51157|51047|51113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22741,
    lat: 38.44541,
    lng: -77.86819,
    city: "Stevensburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 209,
    density: 12.4,
    county_fips: 51047,
    county_name: "Culpeper",
    county_weights: {
      51047: 100,
    },
    county_names_all: "Culpeper",
    county_fips_all: 51047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22742,
    lat: 38.4589,
    lng: -77.71179,
    city: "Sumerduck",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1838,
    density: 35.5,
    county_fips: 51061,
    county_name: "Fauquier",
    county_weights: {
      51061: 100,
    },
    county_names_all: "Fauquier",
    county_fips_all: 51061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22743,
    lat: 38.52477,
    lng: -78.37132,
    city: "Syria",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 183,
    density: 1.2,
    county_fips: 51113,
    county_name: "Madison",
    county_weights: {
      51113: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 51113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22746,
    lat: 38.62922,
    lng: -78.0195,
    city: "Viewtown",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 51047,
    county_name: "Culpeper",
    county_weights: {
      51047: 100,
    },
    county_names_all: "Culpeper",
    county_fips_all: 51047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22747,
    lat: 38.7122,
    lng: -78.16768,
    city: "Washington",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1261,
    density: 11.9,
    county_fips: 51157,
    county_name: "Rappahannock",
    county_weights: {
      51157: 100,
    },
    county_names_all: "Rappahannock",
    county_fips_all: 51157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22749,
    lat: 38.61945,
    lng: -78.18394,
    city: "Woodville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 225,
    density: 3,
    county_fips: 51157,
    county_name: "Rappahannock",
    county_weights: {
      51157: 100,
    },
    county_names_all: "Rappahannock",
    county_fips_all: 51157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22801,
    lat: 38.40519,
    lng: -78.87931,
    city: "Harrisonburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40284,
    density: 458.5,
    county_fips: 51165,
    county_name: "Rockingham",
    county_weights: {
      51165: 68.81,
      51660: 31.19,
    },
    county_names_all: "Rockingham|Harrisonburg",
    county_fips_all: "51165|51660",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22802,
    lat: 38.50016,
    lng: -78.8585,
    city: "Harrisonburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30534,
    density: 129.6,
    county_fips: 51165,
    county_name: "Rockingham",
    county_weights: {
      51165: 93.3,
      51660: 6.7,
    },
    county_names_all: "Rockingham|Harrisonburg",
    county_fips_all: "51165|51660",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22807,
    lat: 38.43495,
    lng: -78.86736,
    city: "Harrisonburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3345,
    density: 1982,
    county_fips: 51660,
    county_name: "Harrisonburg",
    county_weights: {
      51660: 100,
    },
    county_names_all: "Harrisonburg",
    county_fips_all: 51660,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22810,
    lat: 38.84466,
    lng: -78.78554,
    city: "Basye",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 754,
    density: 15.2,
    county_fips: 51171,
    county_name: "Shenandoah",
    county_weights: {
      51171: 100,
    },
    county_names_all: "Shenandoah",
    county_fips_all: 51171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22811,
    lat: 38.79264,
    lng: -78.9757,
    city: "Bergton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 512,
    density: 6.9,
    county_fips: 51165,
    county_name: "Rockingham",
    county_weights: {
      51165: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 51165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22812,
    lat: 38.37934,
    lng: -79.03836,
    city: "Bridgewater",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9100,
    density: 70.6,
    county_fips: 51165,
    county_name: "Rockingham",
    county_weights: {
      51015: 40.7,
      51165: 59.3,
    },
    county_names_all: "Rockingham|Augusta",
    county_fips_all: "51165|51015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22815,
    lat: 38.63469,
    lng: -78.80939,
    city: "Broadway",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8915,
    density: 48.6,
    county_fips: 51165,
    county_name: "Rockingham",
    county_weights: {
      51165: 96.96,
      51171: 3.04,
    },
    county_names_all: "Rockingham|Shenandoah",
    county_fips_all: "51165|51171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22820,
    lat: 38.74387,
    lng: -79.00948,
    city: "Criders",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 296,
    density: 5.9,
    county_fips: 51165,
    county_name: "Rockingham",
    county_weights: {
      51165: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 51165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22821,
    lat: 38.46349,
    lng: -79.0743,
    city: "Dayton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5791,
    density: 30.8,
    county_fips: 51165,
    county_name: "Rockingham",
    county_weights: {
      51165: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 51165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22824,
    lat: 38.84743,
    lng: -78.6278,
    city: "Edinburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6410,
    density: 29,
    county_fips: 51171,
    county_name: "Shenandoah",
    county_weights: {
      51171: 100,
    },
    county_names_all: "Shenandoah",
    county_fips_all: 51171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22827,
    lat: 38.3903,
    lng: -78.6131,
    city: "Elkton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10675,
    density: 25.9,
    county_fips: 51165,
    county_name: "Rockingham",
    county_weights: {
      51139: 22.25,
      51165: 77.75,
    },
    county_names_all: "Rockingham|Page",
    county_fips_all: "51165|51139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22830,
    lat: 38.65789,
    lng: -78.97902,
    city: "Fulks Run",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2180,
    density: 7.2,
    county_fips: 51165,
    county_name: "Rockingham",
    county_weights: {
      51165: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 51165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22831,
    lat: 38.56395,
    lng: -79.10005,
    city: "Hinton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1056,
    density: 5.8,
    county_fips: 51165,
    county_name: "Rockingham",
    county_weights: {
      51165: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 51165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22832,
    lat: 38.45778,
    lng: -78.75692,
    city: "Keezletown",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 743,
    density: 13.8,
    county_fips: 51165,
    county_name: "Rockingham",
    county_weights: {
      51165: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 51165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22834,
    lat: 38.55709,
    lng: -78.85769,
    city: "Linville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1057,
    density: 21.6,
    county_fips: 51165,
    county_name: "Rockingham",
    county_weights: {
      51165: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 51165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22835,
    lat: 38.67199,
    lng: -78.4548,
    city: "Luray",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12077,
    density: 31.2,
    county_fips: 51139,
    county_name: "Page",
    county_weights: {
      51139: 100,
    },
    county_names_all: "Page",
    county_fips_all: 51139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22840,
    lat: 38.38642,
    lng: -78.73845,
    city: "McGaheysville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5065,
    density: 62.3,
    county_fips: 51165,
    county_name: "Rockingham",
    county_weights: {
      51165: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 51165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22841,
    lat: 38.33887,
    lng: -78.89417,
    city: "Mount Crawford",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2746,
    density: 35.3,
    county_fips: 51165,
    county_name: "Rockingham",
    county_weights: {
      51015: 1.88,
      51165: 98.12,
    },
    county_names_all: "Rockingham|Augusta",
    county_fips_all: "51165|51015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22842,
    lat: 38.77191,
    lng: -78.6992,
    city: "Mount Jackson",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5572,
    density: 26.3,
    county_fips: 51171,
    county_name: "Shenandoah",
    county_weights: {
      51171: 100,
    },
    county_names_all: "Shenandoah",
    county_fips_all: 51171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22843,
    lat: 38.36703,
    lng: -79.16053,
    city: "Mount Solon",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2536,
    density: 9.3,
    county_fips: 51015,
    county_name: "Augusta",
    county_weights: {
      51015: 100,
    },
    county_names_all: "Augusta",
    county_fips_all: 51015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22844,
    lat: 38.65886,
    lng: -78.66038,
    city: "New Market",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4881,
    density: 38,
    county_fips: 51171,
    county_name: "Shenandoah",
    county_weights: {
      51165: 19.18,
      51171: 80.82,
    },
    county_names_all: "Shenandoah|Rockingham",
    county_fips_all: "51171|51165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22845,
    lat: 38.77991,
    lng: -78.8375,
    city: "Orkney Springs",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8,
    density: 0.5,
    county_fips: 51171,
    county_name: "Shenandoah",
    county_weights: {
      51165: 0.35,
      51171: 99.65,
    },
    county_names_all: "Shenandoah|Rockingham",
    county_fips_all: "51171|51165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22846,
    lat: 38.38791,
    lng: -78.79239,
    city: "Penn Laird",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1843,
    density: 64,
    county_fips: 51165,
    county_name: "Rockingham",
    county_weights: {
      51165: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 51165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22847,
    lat: 38.71792,
    lng: -78.70972,
    city: "Quicksburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 718,
    density: 19.3,
    county_fips: 51171,
    county_name: "Shenandoah",
    county_weights: {
      51171: 100,
    },
    county_names_all: "Shenandoah",
    county_fips_all: 51171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22849,
    lat: 38.5256,
    lng: -78.6253,
    city: "Shenandoah",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4957,
    density: 41.5,
    county_fips: 51139,
    county_name: "Page",
    county_weights: {
      51139: 87.96,
      51165: 12.04,
    },
    county_names_all: "Page|Rockingham",
    county_fips_all: "51139|51165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22850,
    lat: 38.56668,
    lng: -78.92048,
    city: "Singers Glen",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1302,
    density: 37.5,
    county_fips: 51165,
    county_name: "Rockingham",
    county_weights: {
      51165: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 51165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22851,
    lat: 38.56061,
    lng: -78.51061,
    city: "Stanley",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6002,
    density: 42.1,
    county_fips: 51139,
    county_name: "Page",
    county_weights: {
      51139: 100,
    },
    county_names_all: "Page",
    county_fips_all: 51139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22853,
    lat: 38.65156,
    lng: -78.76406,
    city: "Timberville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4339,
    density: 43,
    county_fips: 51165,
    county_name: "Rockingham",
    county_weights: {
      51165: 91.5,
      51171: 8.5,
    },
    county_names_all: "Rockingham|Shenandoah",
    county_fips_all: "51165|51171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22901,
    lat: 38.08874,
    lng: -78.55569,
    city: "Charlottesville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34687,
    density: 256.7,
    county_fips: 51003,
    county_name: "Albemarle",
    county_weights: {
      51003: 94.71,
      51540: 5.29,
    },
    county_names_all: "Albemarle|Charlottesville",
    county_fips_all: "51003|51540",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22902,
    lat: 37.95566,
    lng: -78.46883,
    city: "Charlottesville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25815,
    density: 155,
    county_fips: 51003,
    county_name: "Albemarle",
    county_weights: {
      51003: 94.39,
      51065: 1.35,
      51540: 4.26,
    },
    county_names_all: "Albemarle|Charlottesville|Fluvanna",
    county_fips_all: "51003|51540|51065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22903,
    lat: 38.01239,
    lng: -78.60159,
    city: "Charlottesville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40192,
    density: 224.9,
    county_fips: 51003,
    county_name: "Albemarle",
    county_weights: {
      51003: 93.31,
      51540: 6.69,
    },
    county_names_all: "Albemarle|Charlottesville",
    county_fips_all: "51003|51540",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22904,
    lat: 38.03492,
    lng: -78.51161,
    city: "Charlottesville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5634,
    density: 8336.8,
    county_fips: 51003,
    county_name: "Albemarle",
    county_weights: {
      51003: 89.88,
      51540: 10.12,
    },
    county_names_all: "Albemarle|Charlottesville",
    county_fips_all: "51003|51540",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22908,
    lat: 38.03103,
    lng: -78.49639,
    city: "Charlottesville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 51540,
    county_name: "Charlottesville",
    county_weights: {
      51540: 100,
    },
    county_names_all: "Charlottesville",
    county_fips_all: 51540,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22911,
    lat: 38.09522,
    lng: -78.4078,
    city: "Charlottesville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18610,
    density: 139.8,
    county_fips: 51003,
    county_name: "Albemarle",
    county_weights: {
      51003: 100,
    },
    county_names_all: "Albemarle",
    county_fips_all: 51003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22920,
    lat: 37.97294,
    lng: -78.81276,
    city: "Afton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3731,
    density: 18.6,
    county_fips: 51125,
    county_name: "Nelson",
    county_weights: {
      51003: 37.02,
      51015: 4.77,
      51125: 58.21,
    },
    county_names_all: "Nelson|Albemarle|Augusta",
    county_fips_all: "51125|51003|51015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22922,
    lat: 37.68621,
    lng: -78.92511,
    city: "Arrington",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2098,
    density: 17.4,
    county_fips: 51125,
    county_name: "Nelson",
    county_weights: {
      51009: 5.3,
      51125: 94.7,
    },
    county_names_all: "Nelson|Amherst",
    county_fips_all: "51125|51009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22923,
    lat: 38.18671,
    lng: -78.32405,
    city: "Barboursville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5766,
    density: 47,
    county_fips: 51003,
    county_name: "Albemarle",
    county_weights: {
      51003: 43.13,
      51079: 14.91,
      51137: 41.95,
    },
    county_names_all: "Albemarle|Orange|Greene",
    county_fips_all: "51003|51137|51079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22931,
    lat: 37.90374,
    lng: -78.71696,
    city: "Covesville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 188,
    density: 5.2,
    county_fips: 51003,
    county_name: "Albemarle",
    county_weights: {
      51003: 100,
    },
    county_names_all: "Albemarle",
    county_fips_all: 51003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22932,
    lat: 38.15037,
    lng: -78.69743,
    city: "Crozet",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7779,
    density: 29.6,
    county_fips: 51003,
    county_name: "Albemarle",
    county_weights: {
      51003: 100,
    },
    county_names_all: "Albemarle",
    county_fips_all: 51003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22935,
    lat: 38.25785,
    lng: -78.55474,
    city: "Dyke",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 814,
    density: 14.1,
    county_fips: 51079,
    county_name: "Greene",
    county_weights: {
      51003: 37.51,
      51079: 62.49,
    },
    county_names_all: "Greene|Albemarle",
    county_fips_all: "51079|51003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22936,
    lat: 38.1671,
    lng: -78.49974,
    city: "Earlysville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4950,
    density: 51.2,
    county_fips: 51003,
    county_name: "Albemarle",
    county_weights: {
      51003: 100,
    },
    county_names_all: "Albemarle",
    county_fips_all: 51003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22937,
    lat: 37.81297,
    lng: -78.60891,
    city: "Esmont",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2152,
    density: 16.6,
    county_fips: 51003,
    county_name: "Albemarle",
    county_weights: {
      51003: 100,
    },
    county_names_all: "Albemarle",
    county_fips_all: 51003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22938,
    lat: 37.86256,
    lng: -78.78248,
    city: "Faber",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 833,
    density: 8.9,
    county_fips: 51125,
    county_name: "Nelson",
    county_weights: {
      51003: 9.02,
      51125: 90.98,
    },
    county_names_all: "Nelson|Albemarle",
    county_fips_all: "51125|51003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22939,
    lat: 38.10575,
    lng: -78.97288,
    city: "Fishersville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6716,
    density: 146.7,
    county_fips: 51015,
    county_name: "Augusta",
    county_weights: {
      51015: 100,
    },
    county_names_all: "Augusta",
    county_fips_all: 51015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22940,
    lat: 38.20559,
    lng: -78.59705,
    city: "Free Union",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1266,
    density: 14,
    county_fips: 51003,
    county_name: "Albemarle",
    county_weights: {
      51003: 75.55,
      51079: 24.45,
    },
    county_names_all: "Albemarle|Greene",
    county_fips_all: "51003|51079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22942,
    lat: 38.10397,
    lng: -78.19684,
    city: "Gordonsville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10494,
    density: 34.4,
    county_fips: 51109,
    county_name: "Louisa",
    county_weights: {
      51003: 13.37,
      51109: 52.08,
      51137: 34.55,
    },
    county_names_all: "Louisa|Orange|Albemarle",
    county_fips_all: "51109|51137|51003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22943,
    lat: 38.04508,
    lng: -78.78369,
    city: "Greenwood",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 549,
    density: 18.4,
    county_fips: 51003,
    county_name: "Albemarle",
    county_weights: {
      51003: 100,
    },
    county_names_all: "Albemarle",
    county_fips_all: 51003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22946,
    lat: 37.84789,
    lng: -78.56053,
    city: "Keene",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 198,
    density: 40.7,
    county_fips: 51003,
    county_name: "Albemarle",
    county_weights: {
      51003: 100,
    },
    county_names_all: "Albemarle",
    county_fips_all: 51003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22947,
    lat: 38.04326,
    lng: -78.32624,
    city: "Keswick",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3837,
    density: 30.7,
    county_fips: 51003,
    county_name: "Albemarle",
    county_weights: {
      51003: 88.16,
      51065: 5.27,
      51109: 6.57,
    },
    county_names_all: "Albemarle|Louisa|Fluvanna",
    county_fips_all: "51003|51109|51065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22948,
    lat: 38.35154,
    lng: -78.12264,
    city: "Locust Dale",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 143,
    density: 8,
    county_fips: 51113,
    county_name: "Madison",
    county_weights: {
      51113: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 51113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22949,
    lat: 37.788,
    lng: -78.88257,
    city: "Lovingston",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1084,
    density: 10.4,
    county_fips: 51125,
    county_name: "Nelson",
    county_weights: {
      51125: 100,
    },
    county_names_all: "Nelson",
    county_fips_all: 51125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22952,
    lat: 37.95836,
    lng: -78.97136,
    city: "Lyndhurst",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2263,
    density: 19,
    county_fips: 51015,
    county_name: "Augusta",
    county_weights: {
      51015: 98.84,
      51125: 1.16,
    },
    county_names_all: "Augusta|Nelson",
    county_fips_all: "51015|51125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22957,
    lat: 38.22998,
    lng: -78.1918,
    city: "Montpelier Station",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 51137,
    county_name: "Orange",
    county_weights: {
      51137: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 51137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22958,
    lat: 37.8983,
    lng: -78.89611,
    city: "Nellysford",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2082,
    density: 28,
    county_fips: 51125,
    county_name: "Nelson",
    county_weights: {
      51015: 2.7,
      51125: 97.3,
    },
    county_names_all: "Nelson|Augusta",
    county_fips_all: "51125|51015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22959,
    lat: 37.93758,
    lng: -78.64794,
    city: "North Garden",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1679,
    density: 14,
    county_fips: 51003,
    county_name: "Albemarle",
    county_weights: {
      51003: 100,
    },
    county_names_all: "Albemarle",
    county_fips_all: 51003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22960,
    lat: 38.21992,
    lng: -78.06624,
    city: "Orange",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10319,
    density: 32.7,
    county_fips: 51137,
    county_name: "Orange",
    county_weights: {
      51113: 16.22,
      51137: 79.7,
      51177: 4.08,
    },
    county_names_all: "Orange|Madison|Spotsylvania",
    county_fips_all: "51137|51113|51177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22963,
    lat: 37.84793,
    lng: -78.28524,
    city: "Palmyra",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16170,
    density: 50.1,
    county_fips: 51065,
    county_name: "Fluvanna",
    county_weights: {
      51065: 100,
    },
    county_names_all: "Fluvanna",
    county_fips_all: 51065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22964,
    lat: 37.71722,
    lng: -78.98861,
    city: "Piney River",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 221,
    density: 23.7,
    county_fips: 51125,
    county_name: "Nelson",
    county_weights: {
      51125: 100,
    },
    county_names_all: "Nelson",
    county_fips_all: 51125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22967,
    lat: 37.79945,
    lng: -79.0192,
    city: "Roseland",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2582,
    density: 10.3,
    county_fips: 51125,
    county_name: "Nelson",
    county_weights: {
      51009: 19.68,
      51125: 80.32,
    },
    county_names_all: "Nelson|Amherst",
    county_fips_all: "51125|51009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22968,
    lat: 38.24111,
    lng: -78.39407,
    city: "Ruckersville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10865,
    density: 113.1,
    county_fips: 51079,
    county_name: "Greene",
    county_weights: {
      51003: 7.29,
      51079: 91.06,
      51137: 1.65,
    },
    county_names_all: "Greene|Albemarle|Orange",
    county_fips_all: "51079|51003|51137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22969,
    lat: 37.79699,
    lng: -78.69367,
    city: "Schuyler",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1966,
    density: 16.8,
    county_fips: 51125,
    county_name: "Nelson",
    county_weights: {
      51003: 46.6,
      51125: 53.4,
    },
    county_names_all: "Nelson|Albemarle",
    county_fips_all: "51125|51003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22971,
    lat: 37.75019,
    lng: -78.80299,
    city: "Shipman",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1921,
    density: 13.3,
    county_fips: 51125,
    county_name: "Nelson",
    county_weights: {
      51125: 100,
    },
    county_names_all: "Nelson",
    county_fips_all: 51125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22972,
    lat: 38.21746,
    lng: -78.23451,
    city: "Somerset",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 430,
    density: 10.1,
    county_fips: 51137,
    county_name: "Orange",
    county_weights: {
      51113: 4.76,
      51137: 95.24,
    },
    county_names_all: "Orange|Madison",
    county_fips_all: "51137|51113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22973,
    lat: 38.33588,
    lng: -78.46915,
    city: "Stanardsville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5750,
    density: 21.5,
    county_fips: 51079,
    county_name: "Greene",
    county_weights: {
      51079: 89.63,
      51113: 10.37,
    },
    county_names_all: "Greene|Madison",
    county_fips_all: "51079|51113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22974,
    lat: 37.96207,
    lng: -78.2753,
    city: "Troy",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5180,
    density: 55.5,
    county_fips: 51065,
    county_name: "Fluvanna",
    county_weights: {
      51003: 8.46,
      51065: 76.74,
      51109: 14.8,
    },
    county_names_all: "Fluvanna|Louisa|Albemarle",
    county_fips_all: "51065|51109|51003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22976,
    lat: 37.84555,
    lng: -79.04036,
    city: "Tyro",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 408,
    density: 8.2,
    county_fips: 51125,
    county_name: "Nelson",
    county_weights: {
      51125: 100,
    },
    county_names_all: "Nelson",
    county_fips_all: 51125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22980,
    lat: 38.09588,
    lng: -78.88585,
    city: "Waynesboro",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31800,
    density: 164.7,
    county_fips: 51015,
    county_name: "Augusta",
    county_weights: {
      51015: 79.86,
      51820: 20.14,
    },
    county_names_all: "Augusta|Waynesboro",
    county_fips_all: "51015|51820",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 22989,
    lat: 38.29328,
    lng: -78.11943,
    city: "Woodberry Forest",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19,
    density: 4.2,
    county_fips: 51113,
    county_name: "Madison",
    county_weights: {
      51113: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 51113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23002,
    lat: 37.34917,
    lng: -77.96357,
    city: "Amelia Court House",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10512,
    density: 15.8,
    county_fips: 51007,
    county_name: "Amelia",
    county_weights: {
      51007: 99.2,
      51135: 0.8,
    },
    county_names_all: "Amelia|Nottoway",
    county_fips_all: "51007|51135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23004,
    lat: 37.68307,
    lng: -78.40567,
    city: "Arvonia",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 925,
    density: 9.3,
    county_fips: 51029,
    county_name: "Buckingham",
    county_weights: {
      51029: 100,
    },
    county_names_all: "Buckingham",
    county_fips_all: 51029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23005,
    lat: 37.75982,
    lng: -77.4826,
    city: "Ashland",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18059,
    density: 100.6,
    county_fips: 51085,
    county_name: "Hanover",
    county_weights: {
      51085: 100,
    },
    county_names_all: "Hanover",
    county_fips_all: 51085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23009,
    lat: 37.81038,
    lng: -77.18717,
    city: "Aylett",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6955,
    density: 33.1,
    county_fips: 51101,
    county_name: "King William",
    county_weights: {
      51101: 100,
    },
    county_names_all: "King William",
    county_fips_all: 51101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23011,
    lat: 37.47562,
    lng: -76.80691,
    city: "Barhamsville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1404,
    density: 26.1,
    county_fips: 51127,
    county_name: "New Kent",
    county_weights: {
      51095: 0.1,
      51127: 99.9,
    },
    county_names_all: "New Kent|James City",
    county_fips_all: "51127|51095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23015,
    lat: 37.93127,
    lng: -77.63124,
    city: "Beaverdam",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4101,
    density: 18.2,
    county_fips: 51085,
    county_name: "Hanover",
    county_weights: {
      51033: 7.68,
      51085: 76.89,
      51109: 0.93,
      51177: 14.5,
    },
    county_names_all: "Hanover|Spotsylvania|Caroline|Louisa",
    county_fips_all: "51085|51177|51033|51109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23021,
    lat: 37.40102,
    lng: -76.37187,
    city: "Bohannon",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 318,
    density: 87.9,
    county_fips: 51115,
    county_name: "Mathews",
    county_weights: {
      51115: 100,
    },
    county_names_all: "Mathews",
    county_fips_all: 51115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23022,
    lat: 37.7353,
    lng: -78.26432,
    city: "Bremo Bluff",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 798,
    density: 11.9,
    county_fips: 51065,
    county_name: "Fluvanna",
    county_weights: {
      51065: 100,
    },
    county_names_all: "Fluvanna",
    county_fips_all: 51065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23023,
    lat: 37.78293,
    lng: -76.96586,
    city: "Bruington",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 713,
    density: 12.1,
    county_fips: 51097,
    county_name: "King and Queen",
    county_weights: {
      51097: 100,
    },
    county_names_all: "King and Queen",
    county_fips_all: 51097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23024,
    lat: 37.92448,
    lng: -77.77554,
    city: "Bumpass",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9492,
    density: 34,
    county_fips: 51109,
    county_name: "Louisa",
    county_weights: {
      51085: 4.44,
      51109: 80.41,
      51177: 15.15,
    },
    county_names_all: "Louisa|Spotsylvania|Hanover",
    county_fips_all: "51109|51177|51085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23025,
    lat: 37.41447,
    lng: -76.36204,
    city: "Cardinal",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 168,
    density: 14.8,
    county_fips: 51115,
    county_name: "Mathews",
    county_weights: {
      51115: 100,
    },
    county_names_all: "Mathews",
    county_fips_all: 51115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23027,
    lat: 37.64551,
    lng: -78.13183,
    city: "Cartersville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1385,
    density: 12.2,
    county_fips: 51049,
    county_name: "Cumberland",
    county_weights: {
      51049: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 51049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23030,
    lat: 37.34652,
    lng: -77.05962,
    city: "Charles City",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4560,
    density: 11.8,
    county_fips: 51036,
    county_name: "Charles City",
    county_weights: {
      51036: 99.36,
      51087: 0.64,
    },
    county_names_all: "Charles City|Henrico",
    county_fips_all: "51036|51087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23032,
    lat: 37.65552,
    lng: -76.68199,
    city: "Church View",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 314,
    density: 7,
    county_fips: 51119,
    county_name: "Middlesex",
    county_weights: {
      51119: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 51119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23035,
    lat: 37.49809,
    lng: -76.37679,
    city: "Cobbs Creek",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1330,
    density: 47.3,
    county_fips: 51115,
    county_name: "Mathews",
    county_weights: {
      51115: 100,
    },
    county_names_all: "Mathews",
    county_fips_all: 51115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23038,
    lat: 37.75627,
    lng: -78.14552,
    city: "Columbia",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1612,
    density: 8.3,
    county_fips: 51075,
    county_name: "Goochland",
    county_weights: {
      51049: 39.3,
      51065: 19.83,
      51075: 40.87,
    },
    county_names_all: "Goochland|Cumberland|Fluvanna",
    county_fips_all: "51075|51049|51065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23039,
    lat: 37.65503,
    lng: -77.80596,
    city: "Crozier",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1074,
    density: 27,
    county_fips: 51075,
    county_name: "Goochland",
    county_weights: {
      51075: 100,
    },
    county_names_all: "Goochland",
    county_fips_all: 51075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23040,
    lat: 37.51017,
    lng: -78.24919,
    city: "Cumberland",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4353,
    density: 11.3,
    county_fips: 51049,
    county_name: "Cumberland",
    county_weights: {
      51029: 9.48,
      51049: 90.52,
    },
    county_names_all: "Cumberland|Buckingham",
    county_fips_all: "51049|51029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23043,
    lat: 37.55519,
    lng: -76.34357,
    city: "Deltaville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1749,
    density: 99.2,
    county_fips: 51119,
    county_name: "Middlesex",
    county_weights: {
      51119: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 51119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23045,
    lat: 37.42937,
    lng: -76.27069,
    city: "Diggs",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43,
    density: 4.8,
    county_fips: 51115,
    county_name: "Mathews",
    county_weights: {
      51115: 100,
    },
    county_names_all: "Mathews",
    county_fips_all: 51115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23047,
    lat: 37.84765,
    lng: -77.48973,
    city: "Doswell",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1628,
    density: 14.6,
    county_fips: 51085,
    county_name: "Hanover",
    county_weights: {
      51033: 11.59,
      51085: 88.41,
    },
    county_names_all: "Hanover|Caroline",
    county_fips_all: "51085|51033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23050,
    lat: 37.48918,
    lng: -76.41986,
    city: "Dutton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 638,
    density: 31.9,
    county_fips: 51115,
    county_name: "Mathews",
    county_weights: {
      51073: 6.75,
      51115: 93.25,
    },
    county_names_all: "Mathews|Gloucester",
    county_fips_all: "51115|51073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23055,
    lat: 37.7706,
    lng: -78.21852,
    city: "Fork Union",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1198,
    density: 33.1,
    county_fips: 51065,
    county_name: "Fluvanna",
    county_weights: {
      51065: 100,
    },
    county_names_all: "Fluvanna",
    county_fips_all: 51065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23056,
    lat: 37.41809,
    lng: -76.38724,
    city: "Foster",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 389,
    density: 21.9,
    county_fips: 51115,
    county_name: "Mathews",
    county_weights: {
      51115: 100,
    },
    county_names_all: "Mathews",
    county_fips_all: 51115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23059,
    lat: 37.70424,
    lng: -77.56539,
    city: "Glen Allen",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39602,
    density: 333.6,
    county_fips: 51085,
    county_name: "Hanover",
    county_weights: {
      51075: 1.84,
      51085: 59.07,
      51087: 39.09,
    },
    county_names_all: "Hanover|Henrico|Goochland",
    county_fips_all: "51085|51087|51075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23060,
    lat: 37.65981,
    lng: -77.53427,
    city: "Glen Allen",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36042,
    density: 913.9,
    county_fips: 51087,
    county_name: "Henrico",
    county_weights: {
      51087: 100,
    },
    county_names_all: "Henrico",
    county_fips_all: 51087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23061,
    lat: 37.4331,
    lng: -76.55019,
    city: "Gloucester",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21364,
    density: 52.2,
    county_fips: 51073,
    county_name: "Gloucester",
    county_weights: {
      51073: 100,
    },
    county_names_all: "Gloucester",
    county_fips_all: 51073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23062,
    lat: 37.258,
    lng: -76.50404,
    city: "Gloucester Point",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2326,
    density: 581.3,
    county_fips: 51073,
    county_name: "Gloucester",
    county_weights: {
      51073: 100,
    },
    county_names_all: "Gloucester",
    county_fips_all: 51073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23063,
    lat: 37.71694,
    lng: -77.99882,
    city: "Goochland",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4610,
    density: 17.4,
    county_fips: 51075,
    county_name: "Goochland",
    county_weights: {
      51075: 100,
    },
    county_names_all: "Goochland",
    county_fips_all: 51075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23065,
    lat: 37.8016,
    lng: -77.92979,
    city: "Gum Spring",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1956,
    density: 44.4,
    county_fips: 51075,
    county_name: "Goochland",
    county_weights: {
      51075: 76.2,
      51109: 23.8,
    },
    county_names_all: "Goochland|Louisa",
    county_fips_all: "51075|51109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23066,
    lat: 37.49836,
    lng: -76.28831,
    city: "Gwynn",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 319,
    density: 52.5,
    county_fips: 51115,
    county_name: "Mathews",
    county_weights: {
      51115: 100,
    },
    county_names_all: "Mathews",
    county_fips_all: 51115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23068,
    lat: 37.49511,
    lng: -76.33727,
    city: "Hallieford",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69,
    density: 31.6,
    county_fips: 51115,
    county_name: "Mathews",
    county_weights: {
      51115: 100,
    },
    county_names_all: "Mathews",
    county_fips_all: 51115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23069,
    lat: 37.76924,
    lng: -77.32874,
    city: "Hanover",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2817,
    density: 15.7,
    county_fips: 51085,
    county_name: "Hanover",
    county_weights: {
      51033: 22.92,
      51085: 41.68,
      51101: 35.4,
    },
    county_names_all: "Hanover|King William|Caroline",
    county_fips_all: "51085|51101|51033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23070,
    lat: 37.55065,
    lng: -76.38528,
    city: "Hardyville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 556,
    density: 67.9,
    county_fips: 51119,
    county_name: "Middlesex",
    county_weights: {
      51119: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 51119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23071,
    lat: 37.54326,
    lng: -76.45228,
    city: "Hartfield",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1700,
    density: 53.8,
    county_fips: 51119,
    county_name: "Middlesex",
    county_weights: {
      51119: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 51119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23072,
    lat: 37.29543,
    lng: -76.48148,
    city: "Hayes",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12380,
    density: 134.3,
    county_fips: 51073,
    county_name: "Gloucester",
    county_weights: {
      51073: 100,
    },
    county_names_all: "Gloucester",
    county_fips_all: 51073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23075,
    lat: 37.54938,
    lng: -77.31591,
    city: "Henrico",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9238,
    density: 774,
    county_fips: 51087,
    county_name: "Henrico",
    county_weights: {
      51087: 100,
    },
    county_names_all: "Henrico",
    county_fips_all: 51087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23076,
    lat: 37.47328,
    lng: -76.30499,
    city: "Hudgins",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 813,
    density: 108.6,
    county_fips: 51115,
    county_name: "Mathews",
    county_weights: {
      51115: 100,
    },
    county_names_all: "Mathews",
    county_fips_all: 51115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23079,
    lat: 37.7248,
    lng: -76.68941,
    city: "Jamaica",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 497,
    density: 8.9,
    county_fips: 51119,
    county_name: "Middlesex",
    county_weights: {
      51119: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 51119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23081,
    lat: 37.20758,
    lng: -76.7617,
    city: "Jamestown",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 51095,
    county_name: "James City",
    county_weights: {
      51095: 100,
    },
    county_names_all: "James City",
    county_fips_all: 51095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23083,
    lat: 37.31899,
    lng: -78.11111,
    city: "Jetersville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2299,
    density: 14.3,
    county_fips: 51007,
    county_name: "Amelia",
    county_weights: {
      51007: 98.34,
      51135: 1.66,
    },
    county_names_all: "Amelia|Nottoway",
    county_fips_all: "51007|51135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23084,
    lat: 37.8864,
    lng: -78.11162,
    city: "Kents Store",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1504,
    density: 14.9,
    county_fips: 51065,
    county_name: "Fluvanna",
    county_weights: {
      51065: 73.53,
      51075: 19.39,
      51109: 7.08,
    },
    county_names_all: "Fluvanna|Goochland|Louisa",
    county_fips_all: "51065|51075|51109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23085,
    lat: 37.70623,
    lng: -76.84205,
    city: "King And Queen Court House",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 548,
    density: 4.9,
    county_fips: 51097,
    county_name: "King and Queen",
    county_weights: {
      51097: 100,
    },
    county_names_all: "King and Queen",
    county_fips_all: 51097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23086,
    lat: 37.66296,
    lng: -77.05394,
    city: "King William",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3282,
    density: 15.3,
    county_fips: 51101,
    county_name: "King William",
    county_weights: {
      51101: 100,
    },
    county_names_all: "King William",
    county_fips_all: 51101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23089,
    lat: 37.47593,
    lng: -76.91212,
    city: "Lanexa",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5361,
    density: 34.2,
    county_fips: 51127,
    county_name: "New Kent",
    county_weights: {
      51095: 12.66,
      51127: 87.34,
    },
    county_names_all: "New Kent|James City",
    county_fips_all: "51127|51095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23091,
    lat: 37.64647,
    lng: -76.80167,
    city: "Little Plymouth",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 313,
    density: 4.6,
    county_fips: 51097,
    county_name: "King and Queen",
    county_weights: {
      51097: 100,
    },
    county_names_all: "King and Queen",
    county_fips_all: 51097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23092,
    lat: 37.59402,
    lng: -76.50755,
    city: "Locust Hill",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 682,
    density: 45.7,
    county_fips: 51119,
    county_name: "Middlesex",
    county_weights: {
      51119: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 51119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23093,
    lat: 38.00153,
    lng: -78.03595,
    city: "Louisa",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13441,
    density: 25.5,
    county_fips: 51109,
    county_name: "Louisa",
    county_weights: {
      51065: 0.79,
      51075: 4.24,
      51109: 94.97,
    },
    county_names_all: "Louisa|Goochland|Fluvanna",
    county_fips_all: "51109|51075|51065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23102,
    lat: 37.71053,
    lng: -77.83325,
    city: "Maidens",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3562,
    density: 50.1,
    county_fips: 51075,
    county_name: "Goochland",
    county_weights: {
      51075: 76.07,
      51085: 6.39,
      51109: 17.54,
    },
    county_names_all: "Goochland|Louisa|Hanover",
    county_fips_all: "51075|51109|51085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23103,
    lat: 37.6506,
    lng: -77.72754,
    city: "Manakin Sabot",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5692,
    density: 57.2,
    county_fips: 51075,
    county_name: "Goochland",
    county_weights: {
      51075: 100,
    },
    county_names_all: "Goochland",
    county_fips_all: 51075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23106,
    lat: 37.71524,
    lng: -77.2062,
    city: "Manquin",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1381,
    density: 22.4,
    county_fips: 51101,
    county_name: "King William",
    county_weights: {
      51101: 100,
    },
    county_names_all: "King William",
    county_fips_all: 51101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23108,
    lat: 37.65523,
    lng: -76.73015,
    city: "Mascot",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 155,
    density: 6.6,
    county_fips: 51097,
    county_name: "King and Queen",
    county_weights: {
      51097: 100,
    },
    county_names_all: "King and Queen",
    county_fips_all: 51097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23109,
    lat: 37.43263,
    lng: -76.32445,
    city: "Mathews",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2592,
    density: 49.3,
    county_fips: 51115,
    county_name: "Mathews",
    county_weights: {
      51115: 100,
    },
    county_names_all: "Mathews",
    county_fips_all: 51115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23110,
    lat: 37.58338,
    lng: -76.76578,
    city: "Mattaponi",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 647,
    density: 11.9,
    county_fips: 51097,
    county_name: "King and Queen",
    county_weights: {
      51097: 100,
    },
    county_names_all: "King and Queen",
    county_fips_all: 51097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23111,
    lat: 37.6112,
    lng: -77.24697,
    city: "Mechanicsville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36511,
    density: 182.7,
    county_fips: 51085,
    county_name: "Hanover",
    county_weights: {
      51085: 100,
    },
    county_names_all: "Hanover",
    county_fips_all: 51085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23112,
    lat: 37.43738,
    lng: -77.66394,
    city: "Midlothian",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55165,
    density: 664.4,
    county_fips: 51041,
    county_name: "Chesterfield",
    county_weights: {
      51041: 99.28,
      51145: 0.72,
    },
    county_names_all: "Chesterfield|Powhatan",
    county_fips_all: "51041|51145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23113,
    lat: 37.53935,
    lng: -77.68093,
    city: "Midlothian",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25387,
    density: 268.8,
    county_fips: 51041,
    county_name: "Chesterfield",
    county_weights: {
      51041: 53.51,
      51145: 46.39,
      51760: 0.1,
    },
    county_names_all: "Chesterfield|Powhatan|Richmond",
    county_fips_all: "51041|51145|51760",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23114,
    lat: 37.48317,
    lng: -77.66054,
    city: "Midlothian",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19904,
    density: 633.2,
    county_fips: 51041,
    county_name: "Chesterfield",
    county_weights: {
      51041: 100,
    },
    county_names_all: "Chesterfield",
    county_fips_all: 51041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23116,
    lat: 37.67152,
    lng: -77.33458,
    city: "Mechanicsville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31510,
    density: 221.3,
    county_fips: 51085,
    county_name: "Hanover",
    county_weights: {
      51085: 100,
    },
    county_names_all: "Hanover",
    county_fips_all: 51085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23117,
    lat: 37.97736,
    lng: -77.87365,
    city: "Mineral",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9817,
    density: 26.5,
    county_fips: 51109,
    county_name: "Louisa",
    county_weights: {
      51075: 3.08,
      51109: 88.46,
      51177: 8.46,
    },
    county_names_all: "Louisa|Spotsylvania|Goochland",
    county_fips_all: "51109|51177|51075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23119,
    lat: 37.45139,
    lng: -76.27978,
    city: "Moon",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 285,
    density: 49.1,
    county_fips: 51115,
    county_name: "Mathews",
    county_weights: {
      51115: 100,
    },
    county_names_all: "Mathews",
    county_fips_all: 51115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23120,
    lat: 37.40872,
    lng: -77.78468,
    city: "Moseley",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11529,
    density: 70.5,
    county_fips: 51041,
    county_name: "Chesterfield",
    county_weights: {
      51041: 93.68,
      51145: 6.32,
    },
    county_names_all: "Chesterfield|Powhatan",
    county_fips_all: "51041|51145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23123,
    lat: 37.65238,
    lng: -78.3031,
    city: "New Canton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1807,
    density: 16.1,
    county_fips: 51029,
    county_name: "Buckingham",
    county_weights: {
      51029: 91.74,
      51049: 8.26,
    },
    county_names_all: "Buckingham|Cumberland",
    county_fips_all: "51029|51049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23124,
    lat: 37.55271,
    lng: -77.05949,
    city: "New Kent",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4625,
    density: 33.5,
    county_fips: 51127,
    county_name: "New Kent",
    county_weights: {
      51127: 100,
    },
    county_names_all: "New Kent",
    county_fips_all: 51127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23126,
    lat: 37.92285,
    lng: -77.1448,
    city: "Newtown",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 505,
    density: 8.8,
    county_fips: 51097,
    county_name: "King and Queen",
    county_weights: {
      51097: 100,
    },
    county_names_all: "King and Queen",
    county_fips_all: 51097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23128,
    lat: 37.4514,
    lng: -76.43216,
    city: "North",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 505,
    density: 22.8,
    county_fips: 51115,
    county_name: "Mathews",
    county_weights: {
      51073: 14.83,
      51115: 85.17,
    },
    county_names_all: "Mathews|Gloucester",
    county_fips_all: "51115|51073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23129,
    lat: 37.705,
    lng: -77.78261,
    city: "Oilville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 542,
    density: 52.2,
    county_fips: 51075,
    county_name: "Goochland",
    county_weights: {
      51075: 100,
    },
    county_names_all: "Goochland",
    county_fips_all: 51075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23130,
    lat: 37.39048,
    lng: -76.26494,
    city: "Onemo",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 192,
    density: 23.6,
    county_fips: 51115,
    county_name: "Mathews",
    county_weights: {
      51115: 100,
    },
    county_names_all: "Mathews",
    county_fips_all: 51115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23138,
    lat: 37.36245,
    lng: -76.30062,
    city: "Port Haywood",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 587,
    density: 20,
    county_fips: 51115,
    county_name: "Mathews",
    county_weights: {
      51115: 100,
    },
    county_names_all: "Mathews",
    county_fips_all: 51115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23139,
    lat: 37.54999,
    lng: -77.93507,
    city: "Powhatan",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25214,
    density: 40.5,
    county_fips: 51145,
    county_name: "Powhatan",
    county_weights: {
      51049: 1.31,
      51145: 98.69,
    },
    county_names_all: "Powhatan|Cumberland",
    county_fips_all: "51145|51049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23140,
    lat: 37.43852,
    lng: -77.04818,
    city: "Providence Forge",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6453,
    density: 34.5,
    county_fips: 51127,
    county_name: "New Kent",
    county_weights: {
      51036: 42.02,
      51127: 57.98,
    },
    county_names_all: "New Kent|Charles City",
    county_fips_all: "51127|51036",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23141,
    lat: 37.53042,
    lng: -77.15791,
    city: "Quinton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7550,
    density: 82.9,
    county_fips: 51127,
    county_name: "New Kent",
    county_weights: {
      51127: 100,
    },
    county_names_all: "New Kent",
    county_fips_all: 51127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23146,
    lat: 37.7273,
    lng: -77.70928,
    city: "Rockville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3356,
    density: 40.2,
    county_fips: 51085,
    county_name: "Hanover",
    county_weights: {
      51075: 21.53,
      51085: 78.47,
    },
    county_names_all: "Hanover|Goochland",
    county_fips_all: "51085|51075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23147,
    lat: 37.36965,
    lng: -77.0391,
    city: "Ruthville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 51036,
    county_name: "Charles City",
    county_weights: {
      51036: 100,
    },
    county_names_all: "Charles City",
    county_fips_all: 51036,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23148,
    lat: 37.84262,
    lng: -77.06223,
    city: "Saint Stephens Church",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1648,
    density: 10.9,
    county_fips: 51097,
    county_name: "King and Queen",
    county_weights: {
      51057: 6.5,
      51097: 93.5,
    },
    county_names_all: "King and Queen|Essex",
    county_fips_all: "51097|51057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23149,
    lat: 37.56794,
    lng: -76.61599,
    city: "Saluda",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2883,
    density: 21.2,
    county_fips: 51119,
    county_name: "Middlesex",
    county_weights: {
      51073: 38.73,
      51097: 17.62,
      51119: 43.65,
    },
    county_names_all: "Middlesex|Gloucester|King and Queen",
    county_fips_all: "51119|51073|51097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23150,
    lat: 37.50718,
    lng: -77.25402,
    city: "Sandston",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12523,
    density: 164,
    county_fips: 51087,
    county_name: "Henrico",
    county_weights: {
      51087: 100,
    },
    county_names_all: "Henrico",
    county_fips_all: 51087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23153,
    lat: 37.77641,
    lng: -77.95719,
    city: "Sandy Hook",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1245,
    density: 36.2,
    county_fips: 51075,
    county_name: "Goochland",
    county_weights: {
      51075: 99.71,
      51109: 0.29,
    },
    county_names_all: "Goochland|Louisa",
    county_fips_all: "51075|51109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23156,
    lat: 37.5244,
    lng: -76.71106,
    city: "Shacklefords",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1384,
    density: 12.7,
    county_fips: 51097,
    county_name: "King and Queen",
    county_weights: {
      51097: 100,
    },
    county_names_all: "King and Queen",
    county_fips_all: 51097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23160,
    lat: 37.62757,
    lng: -77.84028,
    city: "State Farm",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2552,
    density: 570,
    county_fips: 51145,
    county_name: "Powhatan",
    county_weights: {
      51075: 0.29,
      51145: 99.71,
    },
    county_names_all: "Powhatan|Goochland",
    county_fips_all: "51145|51075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23161,
    lat: 37.72152,
    lng: -76.93037,
    city: "Stevensville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 80,
    density: 3.3,
    county_fips: 51097,
    county_name: "King and Queen",
    county_weights: {
      51097: 100,
    },
    county_names_all: "King and Queen",
    county_fips_all: 51097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23163,
    lat: 37.3572,
    lng: -76.29765,
    city: "Susan",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46,
    density: 11.6,
    county_fips: 51115,
    county_name: "Mathews",
    county_weights: {
      51115: 100,
    },
    county_names_all: "Mathews",
    county_fips_all: 51115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23168,
    lat: 37.3942,
    lng: -76.832,
    city: "Toano",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7601,
    density: 98.5,
    county_fips: 51095,
    county_name: "James City",
    county_weights: {
      51095: 100,
    },
    county_names_all: "James City",
    county_fips_all: 51095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23169,
    lat: 37.58945,
    lng: -76.46225,
    city: "Topping",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 947,
    density: 41.8,
    county_fips: 51119,
    county_name: "Middlesex",
    county_weights: {
      51119: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 51119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23173,
    lat: 37.57677,
    lng: -77.54069,
    city: "Richmond",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2295,
    density: 2708.3,
    county_fips: 51760,
    county_name: "Richmond",
    county_weights: {
      51760: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 51760,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23175,
    lat: 37.65343,
    lng: -76.62407,
    city: "Urbanna",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1634,
    density: 39.7,
    county_fips: 51119,
    county_name: "Middlesex",
    county_weights: {
      51119: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 51119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23176,
    lat: 37.56934,
    lng: -76.41991,
    city: "Wake",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 336,
    density: 28,
    county_fips: 51119,
    county_name: "Middlesex",
    county_weights: {
      51119: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 51119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23177,
    lat: 37.73088,
    lng: -77.00295,
    city: "Walkerton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 776,
    density: 14.5,
    county_fips: 51097,
    county_name: "King and Queen",
    county_weights: {
      51097: 88.53,
      51101: 11.47,
    },
    county_names_all: "King and Queen|King William",
    county_fips_all: "51097|51101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23180,
    lat: 37.69977,
    lng: -76.62045,
    city: "Water View",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 670,
    density: 27.3,
    county_fips: 51119,
    county_name: "Middlesex",
    county_weights: {
      51119: 100,
    },
    county_names_all: "Middlesex",
    county_fips_all: 51119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23181,
    lat: 37.59809,
    lng: -76.889,
    city: "West Point",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5075,
    density: 30,
    county_fips: 51101,
    county_name: "King William",
    county_weights: {
      51101: 90.8,
      51127: 9.2,
    },
    county_names_all: "King William|New Kent",
    county_fips_all: "51101|51127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23185,
    lat: 37.24927,
    lng: -76.68702,
    city: "Williamsburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49874,
    density: 336.4,
    county_fips: 51095,
    county_name: "James City",
    county_weights: {
      51036: 0.47,
      51095: 54.4,
      51199: 31.98,
      51830: 13.15,
    },
    county_names_all: "James City|York|Williamsburg|Charles City",
    county_fips_all: "51095|51199|51830|51036",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23188,
    lat: 37.33849,
    lng: -76.74925,
    city: "Williamsburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44561,
    density: 176.9,
    county_fips: 51095,
    county_name: "James City",
    county_weights: {
      51095: 70.68,
      51199: 28.22,
      51830: 1.1,
    },
    county_names_all: "James City|York|Williamsburg",
    county_fips_all: "51095|51199|51830",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23192,
    lat: 37.81732,
    lng: -77.68209,
    city: "Montpelier",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6785,
    density: 38.6,
    county_fips: 51085,
    county_name: "Hanover",
    county_weights: {
      51085: 95.94,
      51109: 4.06,
    },
    county_names_all: "Hanover|Louisa",
    county_fips_all: "51085|51109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23219,
    lat: 37.54076,
    lng: -77.43484,
    city: "Richmond",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4652,
    density: 1353.4,
    county_fips: 51760,
    county_name: "Richmond",
    county_weights: {
      51760: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 51760,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23220,
    lat: 37.54923,
    lng: -77.46012,
    city: "Richmond",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34853,
    density: 2782.8,
    county_fips: 51760,
    county_name: "Richmond",
    county_weights: {
      51760: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 51760,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23221,
    lat: 37.5533,
    lng: -77.49056,
    city: "Richmond",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14619,
    density: 1709.3,
    county_fips: 51760,
    county_name: "Richmond",
    county_weights: {
      51760: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 51760,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23222,
    lat: 37.58265,
    lng: -77.41894,
    city: "Richmond",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28542,
    density: 1350.1,
    county_fips: 51087,
    county_name: "Henrico",
    county_weights: {
      51087: 58.62,
      51760: 41.38,
    },
    county_names_all: "Henrico|Richmond",
    county_fips_all: "51087|51760",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23223,
    lat: 37.55595,
    lng: -77.37927,
    city: "Richmond",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53917,
    density: 1248.7,
    county_fips: 51087,
    county_name: "Henrico",
    county_weights: {
      51087: 76.76,
      51760: 23.24,
    },
    county_names_all: "Henrico|Richmond",
    county_fips_all: "51087|51760",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23224,
    lat: 37.4985,
    lng: -77.46563,
    city: "Richmond",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40136,
    density: 1340.4,
    county_fips: 51760,
    county_name: "Richmond",
    county_weights: {
      51041: 5.36,
      51760: 94.64,
    },
    county_names_all: "Richmond|Chesterfield",
    county_fips_all: "51760|51041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23225,
    lat: 37.51872,
    lng: -77.51044,
    city: "Richmond",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43454,
    density: 1202.8,
    county_fips: 51760,
    county_name: "Richmond",
    county_weights: {
      51041: 18.84,
      51760: 81.16,
    },
    county_names_all: "Richmond|Chesterfield",
    county_fips_all: "51760|51041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23226,
    lat: 37.57774,
    lng: -77.5198,
    city: "Richmond",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16452,
    density: 1128.6,
    county_fips: 51760,
    county_name: "Richmond",
    county_weights: {
      51087: 42.9,
      51760: 57.1,
    },
    county_names_all: "Richmond|Henrico",
    county_fips_all: "51760|51087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23227,
    lat: 37.61486,
    lng: -77.44234,
    city: "Richmond",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26467,
    density: 890.3,
    county_fips: 51087,
    county_name: "Henrico",
    county_weights: {
      51087: 74.22,
      51760: 25.78,
    },
    county_names_all: "Henrico|Richmond",
    county_fips_all: "51087|51760",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23228,
    lat: 37.62588,
    lng: -77.49125,
    city: "Henrico",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35847,
    density: 1246.8,
    county_fips: 51087,
    county_name: "Henrico",
    county_weights: {
      51087: 100,
    },
    county_names_all: "Henrico",
    county_fips_all: 51087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23229,
    lat: 37.58785,
    lng: -77.56973,
    city: "Henrico",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35626,
    density: 982,
    county_fips: 51087,
    county_name: "Henrico",
    county_weights: {
      51087: 100,
    },
    county_names_all: "Henrico",
    county_fips_all: 51087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23230,
    lat: 37.587,
    lng: -77.49153,
    city: "Richmond",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6993,
    density: 634.1,
    county_fips: 51087,
    county_name: "Henrico",
    county_weights: {
      51087: 71.97,
      51760: 28.03,
    },
    county_names_all: "Henrico|Richmond",
    county_fips_all: "51087|51760",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23231,
    lat: 37.44219,
    lng: -77.31903,
    city: "Henrico",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36587,
    density: 160.2,
    county_fips: 51087,
    county_name: "Henrico",
    county_weights: {
      51036: 3.96,
      51087: 94.78,
      51760: 1.26,
    },
    county_names_all: "Henrico|Charles City|Richmond",
    county_fips_all: "51087|51036|51760",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23233,
    lat: 37.64461,
    lng: -77.62828,
    city: "Henrico",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31572,
    density: 945.8,
    county_fips: 51087,
    county_name: "Henrico",
    county_weights: {
      51075: 26.75,
      51087: 73.25,
    },
    county_names_all: "Henrico|Goochland",
    county_fips_all: "51087|51075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23234,
    lat: 37.45293,
    lng: -77.46752,
    city: "Richmond",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45455,
    density: 918.5,
    county_fips: 51041,
    county_name: "Chesterfield",
    county_weights: {
      51041: 61.86,
      51760: 38.14,
    },
    county_names_all: "Chesterfield|Richmond",
    county_fips_all: "51041|51760",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23235,
    lat: 37.51314,
    lng: -77.56426,
    city: "Richmond",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31778,
    density: 689.3,
    county_fips: 51041,
    county_name: "Chesterfield",
    county_weights: {
      51041: 73.59,
      51760: 26.41,
    },
    county_names_all: "Chesterfield|Richmond",
    county_fips_all: "51041|51760",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23236,
    lat: 37.47438,
    lng: -77.58634,
    city: "Richmond",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24235,
    density: 643.8,
    county_fips: 51041,
    county_name: "Chesterfield",
    county_weights: {
      51041: 100,
    },
    county_names_all: "Chesterfield",
    county_fips_all: 51041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23237,
    lat: 37.40173,
    lng: -77.45433,
    city: "Richmond",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26609,
    density: 476,
    county_fips: 51041,
    county_name: "Chesterfield",
    county_weights: {
      51041: 100,
    },
    county_names_all: "Chesterfield",
    county_fips_all: 51041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23238,
    lat: 37.59595,
    lng: -77.64138,
    city: "Henrico",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26962,
    density: 491.3,
    county_fips: 51075,
    county_name: "Goochland",
    county_weights: {
      51075: 56.75,
      51087: 43.25,
    },
    county_names_all: "Goochland|Henrico",
    county_fips_all: "51075|51087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23250,
    lat: 37.50517,
    lng: -77.32098,
    city: "Richmond",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 51087,
    county_name: "Henrico",
    county_weights: {
      51087: 100,
    },
    county_names_all: "Henrico",
    county_fips_all: 51087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23284,
    lat: 37.54759,
    lng: -77.45273,
    city: "Richmond",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 51760,
    county_name: "Richmond",
    county_weights: {
      51760: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 51760,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23294,
    lat: 37.63048,
    lng: -77.54205,
    city: "Henrico",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18493,
    density: 1682.8,
    county_fips: 51087,
    county_name: "Henrico",
    county_weights: {
      51087: 100,
    },
    county_names_all: "Henrico",
    county_fips_all: 51087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23298,
    lat: 37.5416,
    lng: -77.42954,
    city: "Richmond",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 51760,
    county_name: "Richmond",
    county_weights: {
      51760: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 51760,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23301,
    lat: 37.68402,
    lng: -75.6397,
    city: "Accomac",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2200,
    density: 29.5,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23302,
    lat: 37.85858,
    lng: -75.52197,
    city: "Assawoman",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48,
    density: 8.1,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23303,
    lat: 37.90346,
    lng: -75.50562,
    city: "Atlantic",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 298,
    density: 20.4,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23304,
    lat: 36.99586,
    lng: -76.56993,
    city: "Battery Park",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 51093,
    county_name: "Isle of Wight",
    county_weights: {
      51093: 100,
    },
    county_names_all: "Isle of Wight",
    county_fips_all: 51093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23306,
    lat: 37.56859,
    lng: -75.88148,
    city: "Belle Haven",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 913,
    density: 29.9,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23307,
    lat: 37.43282,
    lng: -75.87095,
    city: "Birdsnest",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 599,
    density: 27.6,
    county_fips: 51131,
    county_name: "Northampton",
    county_weights: {
      51131: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 51131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23308,
    lat: 37.82431,
    lng: -75.61773,
    city: "Bloxom",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1891,
    density: 20.7,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23310,
    lat: 37.26407,
    lng: -75.95676,
    city: "Cape Charles",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4176,
    density: 24.8,
    county_fips: 51131,
    county_name: "Northampton",
    county_weights: {
      51131: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 51131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23314,
    lat: 36.95054,
    lng: -76.53625,
    city: "Carrollton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9028,
    density: 179.1,
    county_fips: 51093,
    county_name: "Isle of Wight",
    county_weights: {
      51093: 100,
    },
    county_names_all: "Isle of Wight",
    county_fips_all: 51093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23315,
    lat: 36.73861,
    lng: -76.84289,
    city: "Carrsville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1211,
    density: 15.6,
    county_fips: 51093,
    county_name: "Isle of Wight",
    county_weights: {
      51093: 100,
    },
    county_names_all: "Isle of Wight",
    county_fips_all: 51093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23316,
    lat: 37.29517,
    lng: -75.96635,
    city: "Cheriton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 51131,
    county_name: "Northampton",
    county_weights: {
      51131: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 51131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23320,
    lat: 36.75208,
    lng: -76.21807,
    city: "Chesapeake",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59248,
    density: 720.7,
    county_fips: 51550,
    county_name: "Chesapeake",
    county_weights: {
      51550: 100,
    },
    county_names_all: "Chesapeake",
    county_fips_all: 51550,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23321,
    lat: 36.80067,
    lng: -76.42189,
    city: "Chesapeake",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36768,
    density: 532.6,
    county_fips: 51550,
    county_name: "Chesapeake",
    county_weights: {
      51550: 100,
    },
    county_names_all: "Chesapeake",
    county_fips_all: 51550,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23322,
    lat: 36.62703,
    lng: -76.26929,
    city: "Chesapeake",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65272,
    density: 134.2,
    county_fips: 51550,
    county_name: "Chesapeake",
    county_weights: {
      51550: 100,
    },
    county_names_all: "Chesapeake",
    county_fips_all: 51550,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23323,
    lat: 36.70785,
    lng: -76.37949,
    city: "Chesapeake",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40644,
    density: 191.6,
    county_fips: 51550,
    county_name: "Chesapeake",
    county_weights: {
      51550: 100,
    },
    county_names_all: "Chesapeake",
    county_fips_all: 51550,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23324,
    lat: 36.79996,
    lng: -76.27517,
    city: "Chesapeake",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23232,
    density: 1347.9,
    county_fips: 51550,
    county_name: "Chesapeake",
    county_weights: {
      51550: 100,
    },
    county_names_all: "Chesapeake",
    county_fips_all: 51550,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23325,
    lat: 36.81507,
    lng: -76.239,
    city: "Chesapeake",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17516,
    density: 1794.6,
    county_fips: 51550,
    county_name: "Chesapeake",
    county_weights: {
      51550: 100,
    },
    county_names_all: "Chesapeake",
    county_fips_all: 51550,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23336,
    lat: 37.95461,
    lng: -75.33759,
    city: "Chincoteague Island",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2912,
    density: 58.2,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23337,
    lat: 37.93332,
    lng: -75.46691,
    city: "Wallops Island",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 302,
    density: 19.1,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23347,
    lat: 37.36026,
    lng: -75.96798,
    city: "Eastville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 778,
    density: 28.2,
    county_fips: 51131,
    county_name: "Northampton",
    county_weights: {
      51131: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 51131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23350,
    lat: 37.51489,
    lng: -75.87428,
    city: "Exmore",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3468,
    density: 40.7,
    county_fips: 51131,
    county_name: "Northampton",
    county_weights: {
      51131: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 51131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23354,
    lat: 37.47806,
    lng: -75.90225,
    city: "Franktown",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 237,
    density: 14.5,
    county_fips: 51131,
    county_name: "Northampton",
    county_weights: {
      51131: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 51131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23356,
    lat: 37.9905,
    lng: -75.39228,
    city: "Greenbackville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1384,
    density: 150.4,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23357,
    lat: 37.75862,
    lng: -75.67459,
    city: "Greenbush",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 707,
    density: 47.4,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23358,
    lat: 37.64406,
    lng: -75.86495,
    city: "Hacksneck",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 108,
    density: 7.5,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23359,
    lat: 37.88643,
    lng: -75.60422,
    city: "Hallwood",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1192,
    density: 34.9,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23389,
    lat: 37.65731,
    lng: -75.83226,
    city: "Harborton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 214,
    density: 93,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23395,
    lat: 37.97051,
    lng: -75.45159,
    city: "Horntown",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 349,
    density: 18.5,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23398,
    lat: 37.52054,
    lng: -75.93971,
    city: "Jamesville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37,
    density: 11.1,
    county_fips: 51131,
    county_name: "Northampton",
    county_weights: {
      51131: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 51131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23401,
    lat: 37.62776,
    lng: -75.77843,
    city: "Keller",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 304,
    density: 54.7,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23405,
    lat: 37.41466,
    lng: -75.91969,
    city: "Machipongo",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 962,
    density: 14.5,
    county_fips: 51131,
    county_name: "Northampton",
    county_weights: {
      51131: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 51131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23407,
    lat: 37.8432,
    lng: -75.55362,
    city: "Mappsville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 894,
    density: 57,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23408,
    lat: 37.4533,
    lng: -75.84587,
    city: "Marionville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 101,
    density: 36.5,
    county_fips: 51131,
    county_name: "Northampton",
    county_weights: {
      51131: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 51131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23409,
    lat: 37.88017,
    lng: -75.64709,
    city: "Mears",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 110,
    density: 5.4,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23410,
    lat: 37.63802,
    lng: -75.74306,
    city: "Melfa",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1826,
    density: 24.8,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23413,
    lat: 37.4653,
    lng: -75.85356,
    city: "Nassawadox",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 725,
    density: 37.7,
    county_fips: 51131,
    county_name: "Northampton",
    county_weights: {
      51131: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 51131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23414,
    lat: 37.81375,
    lng: -75.58688,
    city: "Nelsonia",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 156,
    density: 187,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23415,
    lat: 37.97459,
    lng: -75.53443,
    city: "New Church",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1582,
    density: 19.3,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23416,
    lat: 37.93371,
    lng: -75.557,
    city: "Oak Hall",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 160,
    density: 8.9,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23417,
    lat: 37.73061,
    lng: -75.76687,
    city: "Onancock",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3383,
    density: 27.6,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23418,
    lat: 37.63821,
    lng: -75.66926,
    city: "Onley",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 771,
    density: 21.9,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23420,
    lat: 37.58275,
    lng: -75.81166,
    city: "Painter",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3610,
    density: 39.1,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23421,
    lat: 37.76564,
    lng: -75.61429,
    city: "Parksley",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3755,
    density: 45,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23422,
    lat: 37.63647,
    lng: -75.82397,
    city: "Pungoteague",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58,
    density: 6.4,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23423,
    lat: 37.52361,
    lng: -75.73969,
    city: "Quinby",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 333,
    density: 8.8,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23426,
    lat: 37.92706,
    lng: -75.67506,
    city: "Sanford",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 70,
    density: 6.8,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23427,
    lat: 37.9124,
    lng: -75.71344,
    city: "Saxis",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 298,
    density: 23.6,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23430,
    lat: 36.98615,
    lng: -76.66337,
    city: "Smithfield",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17493,
    density: 64.9,
    county_fips: 51093,
    county_name: "Isle of Wight",
    county_weights: {
      51093: 97.05,
      51181: 2.95,
    },
    county_names_all: "Isle of Wight|Surry",
    county_fips_all: "51093|51181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23432,
    lat: 36.87099,
    lng: -76.55097,
    city: "Suffolk",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1451,
    density: 41.3,
    county_fips: 51800,
    county_name: "Suffolk",
    county_weights: {
      51800: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 51800,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23433,
    lat: 36.90763,
    lng: -76.49183,
    city: "Suffolk",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1105,
    density: 248.8,
    county_fips: 51800,
    county_name: "Suffolk",
    county_weights: {
      51800: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 51800,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23434,
    lat: 36.70163,
    lng: -76.59074,
    city: "Suffolk",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49583,
    density: 92.6,
    county_fips: 51800,
    county_name: "Suffolk",
    county_weights: {
      51800: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 51800,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23435,
    lat: 36.83751,
    lng: -76.4803,
    city: "Suffolk",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32137,
    density: 347.8,
    county_fips: 51800,
    county_name: "Suffolk",
    county_weights: {
      51800: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 51800,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23436,
    lat: 36.89516,
    lng: -76.50873,
    city: "Suffolk",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1064,
    density: 263.8,
    county_fips: 51800,
    county_name: "Suffolk",
    county_weights: {
      51800: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 51800,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23437,
    lat: 36.63533,
    lng: -76.80256,
    city: "Suffolk",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4488,
    density: 17.3,
    county_fips: 51800,
    county_name: "Suffolk",
    county_weights: {
      51800: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 51800,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23438,
    lat: 36.58116,
    lng: -76.69749,
    city: "Suffolk",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1555,
    density: 15.1,
    county_fips: 51800,
    county_name: "Suffolk",
    county_weights: {
      51800: 100,
    },
    county_names_all: "Suffolk",
    county_fips_all: 51800,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23440,
    lat: 37.83048,
    lng: -75.99019,
    city: "Tangier",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 506,
    density: 123.2,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23441,
    lat: 37.71208,
    lng: -75.69943,
    city: "Tasley",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68,
    density: 130.9,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23442,
    lat: 37.90127,
    lng: -75.56874,
    city: "Temperanceville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1167,
    density: 25.7,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23451,
    lat: 36.87175,
    lng: -76.00689,
    city: "Virginia Beach",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41512,
    density: 810.9,
    county_fips: 51810,
    county_name: "Virginia Beach",
    county_weights: {
      51810: 100,
    },
    county_names_all: "Virginia Beach",
    county_fips_all: 51810,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23452,
    lat: 36.84604,
    lng: -76.09197,
    city: "Virginia Beach",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56392,
    density: 1439.5,
    county_fips: 51810,
    county_name: "Virginia Beach",
    county_weights: {
      51810: 100,
    },
    county_names_all: "Virginia Beach",
    county_fips_all: 51810,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23453,
    lat: 36.785,
    lng: -76.07679,
    city: "Virginia Beach",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34377,
    density: 1454.6,
    county_fips: 51810,
    county_name: "Virginia Beach",
    county_weights: {
      51810: 100,
    },
    county_names_all: "Virginia Beach",
    county_fips_all: 51810,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23454,
    lat: 36.83216,
    lng: -76.02616,
    city: "Virginia Beach",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57508,
    density: 987.3,
    county_fips: 51810,
    county_name: "Virginia Beach",
    county_weights: {
      51810: 100,
    },
    county_names_all: "Virginia Beach",
    county_fips_all: 51810,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23455,
    lat: 36.88974,
    lng: -76.1441,
    city: "Virginia Beach",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49405,
    density: 1256.9,
    county_fips: 51810,
    county_name: "Virginia Beach",
    county_weights: {
      51810: 100,
    },
    county_names_all: "Virginia Beach",
    county_fips_all: 51810,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23456,
    lat: 36.73435,
    lng: -76.03492,
    city: "Virginia Beach",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57705,
    density: 444.4,
    county_fips: 51810,
    county_name: "Virginia Beach",
    county_weights: {
      51810: 100,
    },
    county_names_all: "Virginia Beach",
    county_fips_all: 51810,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23457,
    lat: 36.61686,
    lng: -76.01576,
    city: "Virginia Beach",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4695,
    density: 26.7,
    county_fips: 51810,
    county_name: "Virginia Beach",
    county_weights: {
      51810: 100,
    },
    county_names_all: "Virginia Beach",
    county_fips_all: 51810,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23459,
    lat: 36.91607,
    lng: -76.17043,
    city: "Virginia Beach",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 51810,
    county_name: "Virginia Beach",
    county_weights: {
      51810: 100,
    },
    county_names_all: "Virginia Beach",
    county_fips_all: 51810,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23460,
    lat: 36.81848,
    lng: -76.03161,
    city: "Virginia Beach",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 51810,
    county_name: "Virginia Beach",
    county_weights: {
      51810: 100,
    },
    county_names_all: "Virginia Beach",
    county_fips_all: 51810,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23461,
    lat: 36.77244,
    lng: -75.96172,
    city: "Virginia Beach",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 51810,
    county_name: "Virginia Beach",
    county_weights: {
      51810: 100,
    },
    county_names_all: "Virginia Beach",
    county_fips_all: 51810,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23462,
    lat: 36.8366,
    lng: -76.15105,
    city: "Virginia Beach",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67963,
    density: 2379.3,
    county_fips: 51810,
    county_name: "Virginia Beach",
    county_weights: {
      51810: 100,
    },
    county_names_all: "Virginia Beach",
    county_fips_all: 51810,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23464,
    lat: 36.79732,
    lng: -76.17899,
    city: "Virginia Beach",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 77623,
    density: 1798.1,
    county_fips: 51810,
    county_name: "Virginia Beach",
    county_weights: {
      51810: 100,
    },
    county_names_all: "Virginia Beach",
    county_fips_all: 51810,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23480,
    lat: 37.61388,
    lng: -75.69077,
    city: "Wachapreague",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 309,
    density: 61.9,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23486,
    lat: 37.5177,
    lng: -75.80824,
    city: "Willis Wharf",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19,
    density: 20.9,
    county_fips: 51131,
    county_name: "Northampton",
    county_weights: {
      51131: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 51131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23487,
    lat: 36.85197,
    lng: -76.72303,
    city: "Windsor",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6187,
    density: 25,
    county_fips: 51093,
    county_name: "Isle of Wight",
    county_weights: {
      51093: 100,
    },
    county_names_all: "Isle of Wight",
    county_fips_all: 51093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23488,
    lat: 37.95237,
    lng: -75.60831,
    city: "Withams",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 682,
    density: 36.3,
    county_fips: 51001,
    county_name: "Accomack",
    county_weights: {
      51001: 100,
    },
    county_names_all: "Accomack",
    county_fips_all: 51001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23502,
    lat: 36.86274,
    lng: -76.20983,
    city: "Norfolk",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20642,
    density: 804.5,
    county_fips: 51710,
    county_name: "Norfolk",
    county_weights: {
      51710: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 51710,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23503,
    lat: 36.94727,
    lng: -76.26223,
    city: "Norfolk",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32815,
    density: 2511.1,
    county_fips: 51710,
    county_name: "Norfolk",
    county_weights: {
      51710: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 51710,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23504,
    lat: 36.85677,
    lng: -76.26568,
    city: "Norfolk",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24354,
    density: 2299,
    county_fips: 51710,
    county_name: "Norfolk",
    county_weights: {
      51710: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 51710,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23505,
    lat: 36.91418,
    lng: -76.29081,
    city: "Norfolk",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29508,
    density: 1734.1,
    county_fips: 51710,
    county_name: "Norfolk",
    county_weights: {
      51710: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 51710,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23507,
    lat: 36.8642,
    lng: -76.30304,
    city: "Norfolk",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6528,
    density: 2776.7,
    county_fips: 51710,
    county_name: "Norfolk",
    county_weights: {
      51710: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 51710,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23508,
    lat: 36.8844,
    lng: -76.30898,
    city: "Norfolk",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21627,
    density: 2499.7,
    county_fips: 51710,
    county_name: "Norfolk",
    county_weights: {
      51710: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 51710,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23509,
    lat: 36.88215,
    lng: -76.26203,
    city: "Norfolk",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12961,
    density: 1967.1,
    county_fips: 51710,
    county_name: "Norfolk",
    county_weights: {
      51710: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 51710,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23510,
    lat: 36.8518,
    lng: -76.29154,
    city: "Norfolk",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9216,
    density: 3095.6,
    county_fips: 51710,
    county_name: "Norfolk",
    county_weights: {
      51710: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 51710,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23511,
    lat: 36.94,
    lng: -76.30055,
    city: "Norfolk",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13926,
    density: 1051.2,
    county_fips: 51710,
    county_name: "Norfolk",
    county_weights: {
      51710: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 51710,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23513,
    lat: 36.88948,
    lng: -76.23831,
    city: "Norfolk",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30836,
    density: 2347.8,
    county_fips: 51710,
    county_name: "Norfolk",
    county_weights: {
      51710: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 51710,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23517,
    lat: 36.86927,
    lng: -76.29198,
    city: "Norfolk",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4129,
    density: 1930.1,
    county_fips: 51710,
    county_name: "Norfolk",
    county_weights: {
      51710: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 51710,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23518,
    lat: 36.91638,
    lng: -76.21586,
    city: "Norfolk",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29098,
    density: 1832.2,
    county_fips: 51710,
    county_name: "Norfolk",
    county_weights: {
      51710: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 51710,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23523,
    lat: 36.83254,
    lng: -76.27199,
    city: "Norfolk",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7179,
    density: 1325.9,
    county_fips: 51710,
    county_name: "Norfolk",
    county_weights: {
      51710: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 51710,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23551,
    lat: 36.92359,
    lng: -76.29238,
    city: "Norfolk",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1481,
    density: 1176,
    county_fips: 51710,
    county_name: "Norfolk",
    county_weights: {
      51710: 100,
    },
    county_names_all: "Norfolk",
    county_fips_all: 51710,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23601,
    lat: 37.05862,
    lng: -76.46414,
    city: "Newport News",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25345,
    density: 1316,
    county_fips: 51700,
    county_name: "Newport News",
    county_weights: {
      51700: 100,
    },
    county_names_all: "Newport News",
    county_fips_all: 51700,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23602,
    lat: 37.11511,
    lng: -76.51625,
    city: "Newport News",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39714,
    density: 1165.9,
    county_fips: 51700,
    county_name: "Newport News",
    county_weights: {
      51700: 100,
    },
    county_names_all: "Newport News",
    county_fips_all: 51700,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23603,
    lat: 37.19188,
    lng: -76.56563,
    city: "Newport News",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4012,
    density: 222.8,
    county_fips: 51700,
    county_name: "Newport News",
    county_weights: {
      51199: 2.45,
      51700: 97.55,
    },
    county_names_all: "Newport News|York",
    county_fips_all: "51700|51199",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23604,
    lat: 37.13195,
    lng: -76.58902,
    city: "Fort Eustis",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6150,
    density: 196,
    county_fips: 51700,
    county_name: "Newport News",
    county_weights: {
      51700: 100,
    },
    county_names_all: "Newport News",
    county_fips_all: 51700,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23605,
    lat: 37.01754,
    lng: -76.43527,
    city: "Newport News",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13544,
    density: 1426.5,
    county_fips: 51700,
    county_name: "Newport News",
    county_weights: {
      51650: 15.04,
      51700: 84.96,
    },
    county_names_all: "Newport News|Hampton",
    county_fips_all: "51700|51650",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23606,
    lat: 37.07847,
    lng: -76.49557,
    city: "Newport News",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28222,
    density: 1127.8,
    county_fips: 51700,
    county_name: "Newport News",
    county_weights: {
      51700: 100,
    },
    county_names_all: "Newport News",
    county_fips_all: 51700,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23607,
    lat: 36.98753,
    lng: -76.42235,
    city: "Newport News",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24065,
    density: 1547.7,
    county_fips: 51700,
    county_name: "Newport News",
    county_weights: {
      51650: 0.14,
      51700: 99.86,
    },
    county_names_all: "Newport News|Hampton",
    county_fips_all: "51700|51650",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23608,
    lat: 37.15093,
    lng: -76.54343,
    city: "Newport News",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42136,
    density: 1513.5,
    county_fips: 51700,
    county_name: "Newport News",
    county_weights: {
      51700: 100,
    },
    county_names_all: "Newport News",
    county_fips_all: 51700,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23651,
    lat: 37.0099,
    lng: -76.30451,
    city: "Fort Monroe",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 409,
    density: 201.1,
    county_fips: 51650,
    county_name: "Hampton",
    county_weights: {
      51650: 100,
    },
    county_names_all: "Hampton",
    county_fips_all: 51650,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23661,
    lat: 37.00804,
    lng: -76.38631,
    city: "Hampton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12947,
    density: 1057.2,
    county_fips: 51650,
    county_name: "Hampton",
    county_weights: {
      51650: 100,
    },
    county_names_all: "Hampton",
    county_fips_all: 51650,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23662,
    lat: 37.13178,
    lng: -76.35678,
    city: "Poquoson",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12085,
    density: 303.8,
    county_fips: 51735,
    county_name: "Poquoson",
    county_weights: {
      51735: 100,
    },
    county_names_all: "Poquoson",
    county_fips_all: 51735,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23663,
    lat: 37.03216,
    lng: -76.31589,
    city: "Hampton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14275,
    density: 1961,
    county_fips: 51650,
    county_name: "Hampton",
    county_weights: {
      51650: 100,
    },
    county_names_all: "Hampton",
    county_fips_all: 51650,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23664,
    lat: 37.07467,
    lng: -76.2925,
    city: "Hampton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9771,
    density: 701.5,
    county_fips: 51650,
    county_name: "Hampton",
    county_weights: {
      51650: 100,
    },
    county_names_all: "Hampton",
    county_fips_all: 51650,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23665,
    lat: 37.08963,
    lng: -76.36302,
    city: "Hampton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6855,
    density: 538.7,
    county_fips: 51650,
    county_name: "Hampton",
    county_weights: {
      51199: 8.67,
      51650: 91.33,
    },
    county_names_all: "Hampton|York",
    county_fips_all: "51650|51199",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23666,
    lat: 37.05818,
    lng: -76.40817,
    city: "Hampton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52119,
    density: 1037.9,
    county_fips: 51650,
    county_name: "Hampton",
    county_weights: {
      51650: 100,
    },
    county_names_all: "Hampton",
    county_fips_all: 51650,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23667,
    lat: 37.02081,
    lng: -76.33093,
    city: "Hampton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 51650,
    county_name: "Hampton",
    county_weights: {
      51650: 100,
    },
    county_names_all: "Hampton",
    county_fips_all: 51650,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23668,
    lat: 37.02034,
    lng: -76.33839,
    city: "Hampton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 51650,
    county_name: "Hampton",
    county_weights: {
      51650: 100,
    },
    county_names_all: "Hampton",
    county_fips_all: 51650,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23669,
    lat: 37.05052,
    lng: -76.33952,
    city: "Hampton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40014,
    density: 1278,
    county_fips: 51650,
    county_name: "Hampton",
    county_weights: {
      51650: 100,
    },
    county_names_all: "Hampton",
    county_fips_all: 51650,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23681,
    lat: 37.09697,
    lng: -76.38389,
    city: "Hampton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 51650,
    county_name: "Hampton",
    county_weights: {
      51650: 99.8,
      51735: 0.2,
    },
    county_names_all: "Hampton|Poquoson",
    county_fips_all: "51650|51735",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23690,
    lat: 37.21829,
    lng: -76.52371,
    city: "Yorktown",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4908,
    density: 165.2,
    county_fips: 51199,
    county_name: "York",
    county_weights: {
      51199: 100,
    },
    county_names_all: "York",
    county_fips_all: 51199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23691,
    lat: 37.25906,
    lng: -76.57322,
    city: "Yorktown",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 51199,
    county_name: "York",
    county_weights: {
      51199: 100,
    },
    county_names_all: "York",
    county_fips_all: 51199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23692,
    lat: 37.18107,
    lng: -76.45868,
    city: "Yorktown",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18192,
    density: 361.7,
    county_fips: 51199,
    county_name: "York",
    county_weights: {
      51199: 100,
    },
    county_names_all: "York",
    county_fips_all: 51199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23693,
    lat: 37.12669,
    lng: -76.44755,
    city: "Yorktown",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23650,
    density: 668.5,
    county_fips: 51199,
    county_name: "York",
    county_weights: {
      51199: 100,
    },
    county_names_all: "York",
    county_fips_all: 51199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23696,
    lat: 37.19249,
    lng: -76.42589,
    city: "Seaford",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3980,
    density: 274.4,
    county_fips: 51199,
    county_name: "York",
    county_weights: {
      51199: 100,
    },
    county_names_all: "York",
    county_fips_all: 51199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23701,
    lat: 36.81158,
    lng: -76.36986,
    city: "Portsmouth",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23540,
    density: 1177.1,
    county_fips: 51740,
    county_name: "Portsmouth",
    county_weights: {
      51740: 100,
    },
    county_names_all: "Portsmouth",
    county_fips_all: 51740,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23702,
    lat: 36.80292,
    lng: -76.32679,
    city: "Portsmouth",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12072,
    density: 1943.5,
    county_fips: 51740,
    county_name: "Portsmouth",
    county_weights: {
      51740: 100,
    },
    county_names_all: "Portsmouth",
    county_fips_all: 51740,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23703,
    lat: 36.88039,
    lng: -76.37101,
    city: "Portsmouth",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26019,
    density: 720.8,
    county_fips: 51740,
    county_name: "Portsmouth",
    county_weights: {
      51740: 100,
    },
    county_names_all: "Portsmouth",
    county_fips_all: 51740,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23704,
    lat: 36.82603,
    lng: -76.3123,
    city: "Portsmouth",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18673,
    density: 1594.9,
    county_fips: 51740,
    county_name: "Portsmouth",
    county_weights: {
      51740: 100,
    },
    county_names_all: "Portsmouth",
    county_fips_all: 51740,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23707,
    lat: 36.84255,
    lng: -76.34002,
    city: "Portsmouth",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14145,
    density: 1400.7,
    county_fips: 51740,
    county_name: "Portsmouth",
    county_weights: {
      51740: 100,
    },
    county_names_all: "Portsmouth",
    county_fips_all: 51740,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23708,
    lat: 36.84804,
    lng: -76.30646,
    city: "Portsmouth",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 512,
    density: 1143.1,
    county_fips: 51740,
    county_name: "Portsmouth",
    county_weights: {
      51740: 100,
    },
    county_names_all: "Portsmouth",
    county_fips_all: 51740,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23709,
    lat: 36.81685,
    lng: -76.29846,
    city: "Portsmouth",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 51740,
    county_name: "Portsmouth",
    county_weights: {
      51740: 100,
    },
    county_names_all: "Portsmouth",
    county_fips_all: 51740,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23801,
    lat: 37.23618,
    lng: -77.33582,
    city: "Fort Lee",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5944,
    density: 346,
    county_fips: 51149,
    county_name: "Prince George",
    county_weights: {
      51149: 100,
    },
    county_names_all: "Prince George",
    county_fips_all: 51149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23803,
    lat: 37.21183,
    lng: -77.48028,
    city: "Petersburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37939,
    density: 202.9,
    county_fips: 51053,
    county_name: "Dinwiddie",
    county_weights: {
      51041: 41.63,
      51053: 43.82,
      51730: 14.55,
    },
    county_names_all: "Dinwiddie|Chesterfield|Petersburg",
    county_fips_all: "51053|51041|51730",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23805,
    lat: 37.12922,
    lng: -77.3953,
    city: "Petersburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19312,
    density: 104.3,
    county_fips: 51149,
    county_name: "Prince George",
    county_weights: {
      51053: 39.93,
      51149: 43.18,
      51730: 16.89,
    },
    county_names_all: "Prince George|Dinwiddie|Petersburg",
    county_fips_all: "51149|51053|51730",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23821,
    lat: 36.876,
    lng: -77.91794,
    city: "Alberta",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2071,
    density: 11.9,
    county_fips: 51025,
    county_name: "Brunswick",
    county_weights: {
      51025: 100,
    },
    county_names_all: "Brunswick",
    county_fips_all: 51025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23824,
    lat: 37.08767,
    lng: -77.95749,
    city: "Blackstone",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6222,
    density: 12.2,
    county_fips: 51135,
    county_name: "Nottoway",
    county_weights: {
      51025: 8.93,
      51053: 12.43,
      51111: 2.7,
      51135: 75.94,
    },
    county_names_all: "Nottoway|Dinwiddie|Brunswick|Lunenburg",
    county_fips_all: "51135|51053|51025|51111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23827,
    lat: 36.61491,
    lng: -77.20724,
    city: "Boykins",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1606,
    density: 14.8,
    county_fips: 51175,
    county_name: "Southampton",
    county_weights: {
      51175: 100,
    },
    county_names_all: "Southampton",
    county_fips_all: 51175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23828,
    lat: 36.58693,
    lng: -77.28557,
    city: "Branchville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 462,
    density: 4.3,
    county_fips: 51175,
    county_name: "Southampton",
    county_weights: {
      51175: 100,
    },
    county_names_all: "Southampton",
    county_fips_all: 51175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23829,
    lat: 36.73393,
    lng: -77.22525,
    city: "Capron",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2351,
    density: 11.3,
    county_fips: 51175,
    county_name: "Southampton",
    county_weights: {
      51175: 100,
    },
    county_names_all: "Southampton",
    county_fips_all: 51175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23830,
    lat: 37.02098,
    lng: -77.39771,
    city: "Carson",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1570,
    density: 12,
    county_fips: 51053,
    county_name: "Dinwiddie",
    county_weights: {
      51053: 51.54,
      51149: 21.32,
      51183: 27.14,
    },
    county_names_all: "Dinwiddie|Sussex|Prince George",
    county_fips_all: "51053|51183|51149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23831,
    lat: 37.34437,
    lng: -77.44998,
    city: "Chester",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35986,
    density: 587.6,
    county_fips: 51041,
    county_name: "Chesterfield",
    county_weights: {
      51041: 100,
    },
    county_names_all: "Chesterfield",
    county_fips_all: 51041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23832,
    lat: 37.39436,
    lng: -77.59491,
    city: "Chesterfield",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37973,
    density: 353,
    county_fips: 51041,
    county_name: "Chesterfield",
    county_weights: {
      51041: 100,
    },
    county_names_all: "Chesterfield",
    county_fips_all: 51041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23833,
    lat: 37.21094,
    lng: -77.66947,
    city: "Church Road",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2538,
    density: 16.8,
    county_fips: 51053,
    county_name: "Dinwiddie",
    county_weights: {
      51007: 27.11,
      51053: 72.89,
    },
    county_names_all: "Dinwiddie|Amelia",
    county_fips_all: "51053|51007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23834,
    lat: 37.28911,
    lng: -77.40063,
    city: "Colonial Heights",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26526,
    density: 430.8,
    county_fips: 51041,
    county_name: "Chesterfield",
    county_weights: {
      51041: 69.26,
      51570: 30.74,
    },
    county_names_all: "Chesterfield|Colonial Heights",
    county_fips_all: "51041|51570",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23836,
    lat: 37.35087,
    lng: -77.33253,
    city: "Chester",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12479,
    density: 181.3,
    county_fips: 51041,
    county_name: "Chesterfield",
    county_weights: {
      51041: 100,
    },
    county_names_all: "Chesterfield",
    county_fips_all: 51041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23837,
    lat: 36.75816,
    lng: -77.08753,
    city: "Courtland",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4395,
    density: 15.4,
    county_fips: 51175,
    county_name: "Southampton",
    county_weights: {
      51175: 92.68,
      51183: 7.32,
    },
    county_names_all: "Southampton|Sussex",
    county_fips_all: "51175|51183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23838,
    lat: 37.31772,
    lng: -77.63288,
    city: "Chesterfield",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16523,
    density: 64.6,
    county_fips: 51041,
    county_name: "Chesterfield",
    county_weights: {
      51041: 100,
    },
    county_names_all: "Chesterfield",
    county_fips_all: 51041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23839,
    lat: 37.08718,
    lng: -76.91895,
    city: "Dendron",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1035,
    density: 11.6,
    county_fips: 51181,
    county_name: "Surry",
    county_weights: {
      51181: 100,
    },
    county_names_all: "Surry",
    county_fips_all: 51181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23840,
    lat: 37.05638,
    lng: -77.67076,
    city: "Dewitt",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2305,
    density: 17,
    county_fips: 51053,
    county_name: "Dinwiddie",
    county_weights: {
      51053: 100,
    },
    county_names_all: "Dinwiddie",
    county_fips_all: 51053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23841,
    lat: 37.05421,
    lng: -77.55305,
    city: "Dinwiddie",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2745,
    density: 14,
    county_fips: 51053,
    county_name: "Dinwiddie",
    county_weights: {
      51053: 100,
    },
    county_names_all: "Dinwiddie",
    county_fips_all: 51053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23842,
    lat: 37.13625,
    lng: -77.22086,
    city: "Disputanta",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6824,
    density: 18.9,
    county_fips: 51149,
    county_name: "Prince George",
    county_weights: {
      51149: 82.42,
      51181: 2.15,
      51183: 15.43,
    },
    county_names_all: "Prince George|Sussex|Surry",
    county_fips_all: "51149|51183|51181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23843,
    lat: 36.84988,
    lng: -77.8109,
    city: "Dolphin",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 360,
    density: 5.1,
    county_fips: 51025,
    county_name: "Brunswick",
    county_weights: {
      51025: 100,
    },
    county_names_all: "Brunswick",
    county_fips_all: 51025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23844,
    lat: 36.67032,
    lng: -77.3358,
    city: "Drewryville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 815,
    density: 7.3,
    county_fips: 51175,
    county_name: "Southampton",
    county_weights: {
      51175: 100,
    },
    county_names_all: "Southampton",
    county_fips_all: 51175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23845,
    lat: 36.57048,
    lng: -77.99322,
    city: "Ebony",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 381,
    density: 12.2,
    county_fips: 51025,
    county_name: "Brunswick",
    county_weights: {
      51025: 100,
    },
    county_names_all: "Brunswick",
    county_fips_all: 51025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23846,
    lat: 37.05947,
    lng: -76.83224,
    city: "Elberon",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 699,
    density: 6.3,
    county_fips: 51181,
    county_name: "Surry",
    county_weights: {
      51181: 100,
    },
    county_names_all: "Surry",
    county_fips_all: 51181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23847,
    lat: 36.668,
    lng: -77.54972,
    city: "Emporia",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15929,
    density: 22.4,
    county_fips: 51081,
    county_name: "Greensville",
    county_weights: {
      51025: 6.75,
      51081: 78.73,
      51175: 6.62,
      51183: 5.39,
      51595: 2.51,
    },
    county_names_all: "Greensville|Brunswick|Southampton|Sussex|Emporia",
    county_fips_all: "51081|51025|51175|51183|51595",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23850,
    lat: 37.16276,
    lng: -77.7434,
    city: "Ford",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 922,
    density: 7.8,
    county_fips: 51053,
    county_name: "Dinwiddie",
    county_weights: {
      51007: 29.55,
      51053: 70.45,
    },
    county_names_all: "Dinwiddie|Amelia",
    county_fips_all: "51053|51007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23851,
    lat: 36.6521,
    lng: -76.95776,
    city: "Franklin",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12960,
    density: 46,
    county_fips: 51175,
    county_name: "Southampton",
    county_weights: {
      51093: 14.02,
      51175: 78.43,
      51620: 7.55,
    },
    county_names_all: "Southampton|Isle of Wight|Franklin",
    county_fips_all: "51175|51093|51620",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23856,
    lat: 36.78735,
    lng: -77.70291,
    city: "Freeman",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1025,
    density: 7.7,
    county_fips: 51025,
    county_name: "Brunswick",
    county_weights: {
      51025: 94.93,
      51081: 5.07,
    },
    county_names_all: "Brunswick|Greensville",
    county_fips_all: "51025|51081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23857,
    lat: 36.58389,
    lng: -77.88588,
    city: "Gasburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 692,
    density: 18.5,
    county_fips: 51025,
    county_name: "Brunswick",
    county_weights: {
      51025: 100,
    },
    county_names_all: "Brunswick",
    county_fips_all: 51025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23860,
    lat: 37.28267,
    lng: -77.22267,
    city: "Hopewell",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30388,
    density: 259.4,
    county_fips: 51149,
    county_name: "Prince George",
    county_weights: {
      51149: 80.3,
      51670: 19.7,
    },
    county_names_all: "Prince George|Hopewell",
    county_fips_all: "51149|51670",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23866,
    lat: 36.92012,
    lng: -76.86693,
    city: "Ivor",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1959,
    density: 9,
    county_fips: 51175,
    county_name: "Southampton",
    county_weights: {
      51093: 36,
      51175: 63.54,
      51181: 0.46,
    },
    county_names_all: "Southampton|Isle of Wight|Surry",
    county_fips_all: "51175|51093|51181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23867,
    lat: 36.82063,
    lng: -77.4878,
    city: "Jarratt",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1914,
    density: 7.6,
    county_fips: 51183,
    county_name: "Sussex",
    county_weights: {
      51081: 41.57,
      51183: 58.43,
    },
    county_names_all: "Sussex|Greensville",
    county_fips_all: "51183|51081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23868,
    lat: 36.70991,
    lng: -77.8038,
    city: "Lawrenceville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6893,
    density: 22.1,
    county_fips: 51025,
    county_name: "Brunswick",
    county_weights: {
      51025: 100,
    },
    county_names_all: "Brunswick",
    county_fips_all: 51025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23870,
    lat: 36.75241,
    lng: -77.50016,
    city: "Jarratt",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 51081,
    county_name: "Greensville",
    county_weights: {
      51081: 100,
    },
    county_names_all: "Greensville",
    county_fips_all: 51081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23872,
    lat: 36.98351,
    lng: -77.72629,
    city: "McKenney",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2861,
    density: 11.1,
    county_fips: 51053,
    county_name: "Dinwiddie",
    county_weights: {
      51053: 100,
    },
    county_names_all: "Dinwiddie",
    county_fips_all: 51053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23874,
    lat: 36.60761,
    lng: -77.09803,
    city: "Newsoms",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 790,
    density: 6.5,
    county_fips: 51175,
    county_name: "Southampton",
    county_weights: {
      51175: 100,
    },
    county_names_all: "Southampton",
    county_fips_all: 51175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23875,
    lat: 37.22941,
    lng: -77.25845,
    city: "Prince George",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12370,
    density: 134.2,
    county_fips: 51149,
    county_name: "Prince George",
    county_weights: {
      51149: 100,
    },
    county_names_all: "Prince George",
    county_fips_all: 51149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23876,
    lat: 36.95635,
    lng: -77.83343,
    city: "Rawlings",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 238,
    density: 2.5,
    county_fips: 51025,
    county_name: "Brunswick",
    county_weights: {
      51025: 100,
    },
    county_names_all: "Brunswick",
    county_fips_all: 51025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23878,
    lat: 36.8291,
    lng: -77.02065,
    city: "Sedley",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1385,
    density: 14.6,
    county_fips: 51175,
    county_name: "Southampton",
    county_weights: {
      51175: 100,
    },
    county_names_all: "Southampton",
    county_fips_all: 51175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23879,
    lat: 36.59224,
    lng: -77.59547,
    city: "Skippers",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 477,
    density: 5.4,
    county_fips: 51081,
    county_name: "Greensville",
    county_weights: {
      51081: 100,
    },
    county_names_all: "Greensville",
    county_fips_all: 51081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23881,
    lat: 37.1917,
    lng: -76.98588,
    city: "Spring Grove",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2045,
    density: 7.3,
    county_fips: 51181,
    county_name: "Surry",
    county_weights: {
      51149: 32.44,
      51181: 67.56,
    },
    county_names_all: "Surry|Prince George",
    county_fips_all: "51181|51149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23882,
    lat: 36.92591,
    lng: -77.41543,
    city: "Stony Creek",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1708,
    density: 4.5,
    county_fips: 51183,
    county_name: "Sussex",
    county_weights: {
      51053: 20.45,
      51183: 79.55,
    },
    county_names_all: "Sussex|Dinwiddie",
    county_fips_all: "51183|51053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23883,
    lat: 37.12546,
    lng: -76.7502,
    city: "Surry",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2069,
    density: 15.3,
    county_fips: 51181,
    county_name: "Surry",
    county_weights: {
      51181: 100,
    },
    county_names_all: "Surry",
    county_fips_all: 51181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23884,
    lat: 36.91733,
    lng: -77.28011,
    city: "Sussex",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38,
    density: 39.3,
    county_fips: 51183,
    county_name: "Sussex",
    county_weights: {
      51183: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 51183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23885,
    lat: 37.18521,
    lng: -77.57834,
    city: "Sutherland",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2541,
    density: 28.7,
    county_fips: 51053,
    county_name: "Dinwiddie",
    county_weights: {
      51053: 100,
    },
    county_names_all: "Dinwiddie",
    county_fips_all: 51053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23887,
    lat: 36.56762,
    lng: -77.81658,
    city: "Valentines",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 224,
    density: 4.4,
    county_fips: 51025,
    county_name: "Brunswick",
    county_weights: {
      51025: 100,
    },
    county_names_all: "Brunswick",
    county_fips_all: 51025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23888,
    lat: 36.95383,
    lng: -76.97802,
    city: "Wakefield",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2344,
    density: 10.4,
    county_fips: 51183,
    county_name: "Sussex",
    county_weights: {
      51175: 27.75,
      51181: 28.87,
      51183: 43.38,
    },
    county_names_all: "Sussex|Surry|Southampton",
    county_fips_all: "51183|51181|51175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23889,
    lat: 36.8972,
    lng: -77.74395,
    city: "Warfield",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 703,
    density: 8.8,
    county_fips: 51025,
    county_name: "Brunswick",
    county_weights: {
      51025: 100,
    },
    county_names_all: "Brunswick",
    county_fips_all: 51025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23890,
    lat: 37.00755,
    lng: -77.11837,
    city: "Waverly",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4531,
    density: 8.9,
    county_fips: 51183,
    county_name: "Sussex",
    county_weights: {
      51181: 19.92,
      51183: 80.08,
    },
    county_names_all: "Sussex|Surry",
    county_fips_all: "51183|51181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23891,
    lat: 37.04752,
    lng: -77.20367,
    city: "Waverly",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1776,
    density: 822.8,
    county_fips: 51183,
    county_name: "Sussex",
    county_weights: {
      51183: 100,
    },
    county_names_all: "Sussex",
    county_fips_all: 51183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23893,
    lat: 36.6244,
    lng: -77.93658,
    city: "White Plains",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 228,
    density: 4,
    county_fips: 51025,
    county_name: "Brunswick",
    county_weights: {
      51025: 100,
    },
    county_names_all: "Brunswick",
    county_fips_all: 51025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23894,
    lat: 37.13867,
    lng: -77.82404,
    city: "Wilsons",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 995,
    density: 13.7,
    county_fips: 51053,
    county_name: "Dinwiddie",
    county_weights: {
      51053: 90.67,
      51135: 9.33,
    },
    county_names_all: "Dinwiddie|Nottoway",
    county_fips_all: "51053|51135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23897,
    lat: 36.83399,
    lng: -77.28234,
    city: "Yale",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 461,
    density: 2.9,
    county_fips: 51183,
    county_name: "Sussex",
    county_weights: {
      51175: 0.23,
      51183: 99.77,
    },
    county_names_all: "Sussex|Southampton",
    county_fips_all: "51183|51175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23898,
    lat: 36.82737,
    lng: -76.85662,
    city: "Zuni",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2104,
    density: 16.2,
    county_fips: 51093,
    county_name: "Isle of Wight",
    county_weights: {
      51093: 50.18,
      51175: 49.82,
    },
    county_names_all: "Isle of Wight|Southampton",
    county_fips_all: "51093|51175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23899,
    lat: 37.23079,
    lng: -76.96562,
    city: "Claremont",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 446,
    density: 68.5,
    county_fips: 51181,
    county_name: "Surry",
    county_weights: {
      51181: 100,
    },
    county_names_all: "Surry",
    county_fips_all: 51181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23901,
    lat: 37.32309,
    lng: -78.41186,
    city: "Farmville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18462,
    density: 36.9,
    county_fips: 51049,
    county_name: "Cumberland",
    county_weights: {
      51029: 18.79,
      51049: 40.9,
      51147: 40.3,
    },
    county_names_all: "Cumberland|Prince Edward|Buckingham",
    county_fips_all: "51049|51147|51029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23909,
    lat: 37.29891,
    lng: -78.39635,
    city: "Farmville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 386,
    density: 1569.2,
    county_fips: 51147,
    county_name: "Prince Edward",
    county_weights: {
      51147: 100,
    },
    county_names_all: "Prince Edward",
    county_fips_all: 51147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23915,
    lat: 36.70668,
    lng: -78.28627,
    city: "Baskerville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1366,
    density: 14.8,
    county_fips: 51117,
    county_name: "Mecklenburg",
    county_weights: {
      51117: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 51117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23917,
    lat: 36.62378,
    lng: -78.34144,
    city: "Boydton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2937,
    density: 10.5,
    county_fips: 51117,
    county_name: "Mecklenburg",
    county_weights: {
      51117: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 51117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23919,
    lat: 36.59103,
    lng: -78.13305,
    city: "Bracey",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2360,
    density: 34,
    county_fips: 51117,
    county_name: "Mecklenburg",
    county_weights: {
      51025: 11.4,
      51117: 88.6,
    },
    county_names_all: "Mecklenburg|Brunswick",
    county_fips_all: "51117|51025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23920,
    lat: 36.72452,
    lng: -77.97266,
    city: "Brodnax",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2868,
    density: 8.7,
    county_fips: 51025,
    county_name: "Brunswick",
    county_weights: {
      51025: 82.43,
      51111: 7.06,
      51117: 10.51,
    },
    county_names_all: "Brunswick|Mecklenburg|Lunenburg",
    county_fips_all: "51025|51117|51111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23921,
    lat: 37.59143,
    lng: -78.61413,
    city: "Buckingham",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1405,
    density: 6.7,
    county_fips: 51029,
    county_name: "Buckingham",
    county_weights: {
      51029: 100,
    },
    county_names_all: "Buckingham",
    county_fips_all: 51029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23922,
    lat: 37.17987,
    lng: -78.21219,
    city: "Burkeville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4029,
    density: 21.2,
    county_fips: 51135,
    county_name: "Nottoway",
    county_weights: {
      51135: 77.31,
      51147: 22.69,
    },
    county_names_all: "Nottoway|Prince Edward",
    county_fips_all: "51135|51147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23923,
    lat: 37.09316,
    lng: -78.64627,
    city: "Charlotte Court House",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2729,
    density: 11.5,
    county_fips: 51037,
    county_name: "Charlotte",
    county_weights: {
      51037: 94.19,
      51147: 5.81,
    },
    county_names_all: "Charlotte|Prince Edward",
    county_fips_all: "51037|51147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23924,
    lat: 36.80919,
    lng: -78.43396,
    city: "Chase City",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6135,
    density: 16.7,
    county_fips: 51117,
    county_name: "Mecklenburg",
    county_weights: {
      51037: 5.81,
      51111: 9.35,
      51117: 84.84,
    },
    county_names_all: "Mecklenburg|Lunenburg|Charlotte",
    county_fips_all: "51117|51111|51037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23927,
    lat: 36.60899,
    lng: -78.51258,
    city: "Clarksville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4552,
    density: 24.4,
    county_fips: 51117,
    county_name: "Mecklenburg",
    county_weights: {
      51117: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 51117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23930,
    lat: 37.17468,
    lng: -78.09608,
    city: "Crewe",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5279,
    density: 20.3,
    county_fips: 51135,
    county_name: "Nottoway",
    county_weights: {
      51135: 100,
    },
    county_names_all: "Nottoway",
    county_fips_all: 51135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23934,
    lat: 37.17613,
    lng: -78.62373,
    city: "Cullen",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 565,
    density: 5.4,
    county_fips: 51147,
    county_name: "Prince Edward",
    county_weights: {
      51037: 44.69,
      51147: 55.31,
    },
    county_names_all: "Prince Edward|Charlotte",
    county_fips_all: "51147|51037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23936,
    lat: 37.52494,
    lng: -78.4819,
    city: "Dillwyn",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7976,
    density: 14.9,
    county_fips: 51029,
    county_name: "Buckingham",
    county_weights: {
      51029: 97.98,
      51049: 2.02,
    },
    county_names_all: "Buckingham|Cumberland",
    county_fips_all: "51029|51049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23937,
    lat: 36.94547,
    lng: -78.52463,
    city: "Drakes Branch",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2143,
    density: 12.3,
    county_fips: 51037,
    county_name: "Charlotte",
    county_weights: {
      51037: 77.68,
      51111: 22.32,
    },
    county_names_all: "Charlotte|Lunenburg",
    county_fips_all: "51037|51111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23938,
    lat: 36.90541,
    lng: -78.00464,
    city: "Dundas",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 233,
    density: 4.1,
    county_fips: 51025,
    county_name: "Brunswick",
    county_weights: {
      51025: 59.96,
      51111: 40.04,
    },
    county_names_all: "Brunswick|Lunenburg",
    county_fips_all: "51025|51111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23942,
    lat: 37.13241,
    lng: -78.30138,
    city: "Green Bay",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1323,
    density: 8.3,
    county_fips: 51147,
    county_name: "Prince Edward",
    county_weights: {
      51111: 38.53,
      51147: 61.47,
    },
    county_names_all: "Prince Edward|Lunenburg",
    county_fips_all: "51147|51111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23943,
    lat: 37.24181,
    lng: -78.46041,
    city: "Hampden Sydney",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63,
    density: 81.6,
    county_fips: 51147,
    county_name: "Prince Edward",
    county_weights: {
      51147: 100,
    },
    county_names_all: "Prince Edward",
    county_fips_all: 51147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23944,
    lat: 36.9056,
    lng: -78.13319,
    city: "Kenbridge",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3359,
    density: 10.2,
    county_fips: 51111,
    county_name: "Lunenburg",
    county_weights: {
      51111: 100,
    },
    county_names_all: "Lunenburg",
    county_fips_all: 51111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23947,
    lat: 37.02265,
    lng: -78.44284,
    city: "Keysville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3461,
    density: 9.2,
    county_fips: 51111,
    county_name: "Lunenburg",
    county_weights: {
      51037: 37.42,
      51111: 51.65,
      51147: 10.93,
    },
    county_names_all: "Lunenburg|Charlotte|Prince Edward",
    county_fips_all: "51111|51037|51147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23950,
    lat: 36.66005,
    lng: -78.07699,
    city: "La Crosse",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3683,
    density: 21.4,
    county_fips: 51117,
    county_name: "Mecklenburg",
    county_weights: {
      51025: 15.59,
      51117: 84.41,
    },
    county_names_all: "Mecklenburg|Brunswick",
    county_fips_all: "51117|51025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23952,
    lat: 36.91786,
    lng: -78.27886,
    city: "Lunenburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 290,
    density: 7.4,
    county_fips: 51111,
    county_name: "Lunenburg",
    county_weights: {
      51111: 100,
    },
    county_names_all: "Lunenburg",
    county_fips_all: 51111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23954,
    lat: 37.10893,
    lng: -78.38705,
    city: "Meherrin",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2533,
    density: 14.5,
    county_fips: 51147,
    county_name: "Prince Edward",
    county_weights: {
      51111: 35.03,
      51147: 64.97,
    },
    county_names_all: "Prince Edward|Lunenburg",
    county_fips_all: "51147|51111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23955,
    lat: 37.10816,
    lng: -78.06556,
    city: "Nottoway",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 51135,
    county_name: "Nottoway",
    county_weights: {
      51135: 100,
    },
    county_names_all: "Nottoway",
    county_fips_all: 51135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23958,
    lat: 37.26848,
    lng: -78.65581,
    city: "Pamplin",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2906,
    density: 11.5,
    county_fips: 51011,
    county_name: "Appomattox",
    county_weights: {
      51011: 45.74,
      51037: 11.52,
      51147: 42.74,
    },
    county_names_all: "Appomattox|Prince Edward|Charlotte",
    county_fips_all: "51011|51147|51037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23959,
    lat: 37.10472,
    lng: -78.79654,
    city: "Phenix",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1379,
    density: 10,
    county_fips: 51037,
    county_name: "Charlotte",
    county_weights: {
      51037: 100,
    },
    county_names_all: "Charlotte",
    county_fips_all: 51037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23960,
    lat: 37.31531,
    lng: -78.5579,
    city: "Prospect",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2089,
    density: 18.9,
    county_fips: 51147,
    county_name: "Prince Edward",
    county_weights: {
      51011: 2.94,
      51147: 97.06,
    },
    county_names_all: "Prince Edward|Appomattox",
    county_fips_all: "51147|51011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23962,
    lat: 36.93865,
    lng: -78.70399,
    city: "Randolph",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 721,
    density: 5.2,
    county_fips: 51037,
    county_name: "Charlotte",
    county_weights: {
      51037: 80.59,
      51083: 19.41,
    },
    county_names_all: "Charlotte|Halifax",
    county_fips_all: "51037|51083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23963,
    lat: 37.195,
    lng: -78.80168,
    city: "Red House",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 82,
    density: 1.5,
    county_fips: 51037,
    county_name: "Charlotte",
    county_weights: {
      51011: 3.87,
      51031: 23.65,
      51037: 72.48,
    },
    county_names_all: "Charlotte|Campbell|Appomattox",
    county_fips_all: "51037|51031|51011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23964,
    lat: 36.77713,
    lng: -78.63149,
    city: "Red Oak",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1146,
    density: 9.7,
    county_fips: 51037,
    county_name: "Charlotte",
    county_weights: {
      51037: 88.16,
      51117: 11.84,
    },
    county_names_all: "Charlotte|Mecklenburg",
    county_fips_all: "51037|51117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23966,
    lat: 37.29177,
    lng: -78.27418,
    city: "Rice",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1735,
    density: 11.3,
    county_fips: 51147,
    county_name: "Prince Edward",
    county_weights: {
      51007: 18.82,
      51135: 1.16,
      51147: 80.02,
    },
    county_names_all: "Prince Edward|Amelia|Nottoway",
    county_fips_all: "51147|51007|51135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23967,
    lat: 36.91813,
    lng: -78.62857,
    city: "Saxe",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1206,
    density: 11.2,
    county_fips: 51037,
    county_name: "Charlotte",
    county_weights: {
      51037: 100,
    },
    county_names_all: "Charlotte",
    county_fips_all: 51037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23968,
    lat: 36.72123,
    lng: -78.51922,
    city: "Skipwith",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 534,
    density: 5.8,
    county_fips: 51117,
    county_name: "Mecklenburg",
    county_weights: {
      51117: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 51117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23970,
    lat: 36.74818,
    lng: -78.18637,
    city: "South Hill",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8028,
    density: 25.5,
    county_fips: 51117,
    county_name: "Mecklenburg",
    county_weights: {
      51111: 21.79,
      51117: 78.21,
    },
    county_names_all: "Mecklenburg|Lunenburg",
    county_fips_all: "51117|51111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23974,
    lat: 36.97323,
    lng: -78.24549,
    city: "Victoria",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5326,
    density: 23.2,
    county_fips: 51111,
    county_name: "Lunenburg",
    county_weights: {
      51111: 100,
    },
    county_names_all: "Lunenburg",
    county_fips_all: 51111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 23976,
    lat: 36.8482,
    lng: -78.5797,
    city: "Wylliesburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65,
    density: 2.9,
    county_fips: 51037,
    county_name: "Charlotte",
    county_weights: {
      51037: 100,
    },
    county_names_all: "Charlotte",
    county_fips_all: 51037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24011,
    lat: 37.27048,
    lng: -79.94128,
    city: "Roanoke",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 672,
    density: 1570.2,
    county_fips: 51770,
    county_name: "Roanoke",
    county_weights: {
      51770: 100,
    },
    county_names_all: "Roanoke",
    county_fips_all: 51770,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24012,
    lat: 37.31585,
    lng: -79.89833,
    city: "Roanoke",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30055,
    density: 570.7,
    county_fips: 51770,
    county_name: "Roanoke",
    county_weights: {
      51023: 27.39,
      51161: 23.15,
      51770: 49.46,
    },
    county_names_all: "Roanoke|Botetourt|Roanoke",
    county_fips_all: "51770|51023|51161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24013,
    lat: 37.26691,
    lng: -79.92219,
    city: "Roanoke",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8022,
    density: 1421.6,
    county_fips: 51770,
    county_name: "Roanoke",
    county_weights: {
      51161: 0.11,
      51770: 99.89,
    },
    county_names_all: "Roanoke|Roanoke",
    county_fips_all: "51770|51161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24014,
    lat: 37.22427,
    lng: -79.91282,
    city: "Roanoke",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16010,
    density: 226.4,
    county_fips: 51161,
    county_name: "Roanoke",
    county_weights: {
      51161: 72,
      51770: 28,
    },
    county_names_all: "Roanoke|Roanoke",
    county_fips_all: "51161|51770",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24015,
    lat: 37.25588,
    lng: -79.97979,
    city: "Roanoke",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15478,
    density: 1276.7,
    county_fips: 51770,
    county_name: "Roanoke",
    county_weights: {
      51161: 3.19,
      51770: 96.81,
    },
    county_names_all: "Roanoke|Roanoke",
    county_fips_all: "51770|51161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24016,
    lat: 37.27208,
    lng: -79.95468,
    city: "Roanoke",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8912,
    density: 1149.1,
    county_fips: 51770,
    county_name: "Roanoke",
    county_weights: {
      51770: 100,
    },
    county_names_all: "Roanoke",
    county_fips_all: 51770,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24017,
    lat: 37.29472,
    lng: -79.99183,
    city: "Roanoke",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24273,
    density: 1038.5,
    county_fips: 51770,
    county_name: "Roanoke",
    county_weights: {
      51770: 100,
    },
    county_names_all: "Roanoke",
    county_fips_all: 51770,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24018,
    lat: 37.21238,
    lng: -80.04261,
    city: "Roanoke",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38063,
    density: 343.5,
    county_fips: 51161,
    county_name: "Roanoke",
    county_weights: {
      51161: 93.77,
      51770: 6.23,
    },
    county_names_all: "Roanoke|Roanoke",
    county_fips_all: "51161|51770",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24019,
    lat: 37.3446,
    lng: -79.95564,
    city: "Roanoke",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26969,
    density: 344.3,
    county_fips: 51161,
    county_name: "Roanoke",
    county_weights: {
      51023: 23.81,
      51161: 65.91,
      51770: 10.28,
    },
    county_names_all: "Roanoke|Botetourt|Roanoke",
    county_fips_all: "51161|51023|51770",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24020,
    lat: 37.35739,
    lng: -79.94279,
    city: "Roanoke",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 612,
    density: 664.7,
    county_fips: 51161,
    county_name: "Roanoke",
    county_weights: {
      51161: 100,
    },
    county_names_all: "Roanoke",
    county_fips_all: 51161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24022,
    lat: 37.27689,
    lng: -79.93429,
    city: "Roanoke",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 51770,
    county_name: "Roanoke",
    county_weights: {
      51770: 100,
    },
    county_names_all: "Roanoke",
    county_fips_all: 51770,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24053,
    lat: 36.60999,
    lng: -80.53283,
    city: "Ararat",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2513,
    density: 19.4,
    county_fips: 51141,
    county_name: "Patrick",
    county_weights: {
      51035: 3.63,
      51141: 96.37,
    },
    county_names_all: "Patrick|Carroll",
    county_fips_all: "51141|51035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24054,
    lat: 36.67806,
    lng: -79.70396,
    city: "Axton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6406,
    density: 22.6,
    county_fips: 51089,
    county_name: "Henry",
    county_weights: {
      51089: 67.4,
      51143: 32.6,
    },
    county_names_all: "Henry|Pittsylvania",
    county_fips_all: "51089|51143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24055,
    lat: 36.76333,
    lng: -79.99741,
    city: "Bassett",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11938,
    density: 53.2,
    county_fips: 51089,
    county_name: "Henry",
    county_weights: {
      51067: 11.94,
      51089: 77.46,
      51141: 10.6,
    },
    county_names_all: "Henry|Franklin|Patrick",
    county_fips_all: "51089|51067|51141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24058,
    lat: 37.18257,
    lng: -80.61637,
    city: "Belspring",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 222,
    density: 32,
    county_fips: 51155,
    county_name: "Pulaski",
    county_weights: {
      51155: 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: 51155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24059,
    lat: 37.15577,
    lng: -80.13159,
    city: "Bent Mountain",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 874,
    density: 13.2,
    county_fips: 51161,
    county_name: "Roanoke",
    county_weights: {
      51067: 10.93,
      51121: 0.45,
      51161: 88.62,
    },
    county_names_all: "Roanoke|Franklin|Montgomery",
    county_fips_all: "51161|51067|51121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24060,
    lat: 37.25772,
    lng: -80.41961,
    city: "Blacksburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56423,
    density: 166.5,
    county_fips: 51121,
    county_name: "Montgomery",
    county_weights: {
      51121: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 51121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24061,
    lat: 37.22539,
    lng: -80.42658,
    city: "Blacksburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 51121,
    county_name: "Montgomery",
    county_weights: {
      51121: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 51121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24064,
    lat: 37.37237,
    lng: -79.7759,
    city: "Blue Ridge",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5314,
    density: 59.6,
    county_fips: 51019,
    county_name: "Bedford",
    county_weights: {
      51019: 68.73,
      51023: 31.27,
    },
    county_names_all: "Bedford|Botetourt",
    county_fips_all: "51019|51023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24065,
    lat: 37.11814,
    lng: -79.96453,
    city: "Boones Mill",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6311,
    density: 29.8,
    county_fips: 51067,
    county_name: "Franklin",
    county_weights: {
      51067: 84.5,
      51161: 15.5,
    },
    county_names_all: "Franklin|Roanoke",
    county_fips_all: "51067|51161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24066,
    lat: 37.5382,
    lng: -79.67822,
    city: "Buchanan",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5177,
    density: 12.7,
    county_fips: 51023,
    county_name: "Botetourt",
    county_weights: {
      51023: 98.35,
      51163: 1.65,
    },
    county_names_all: "Botetourt|Rockbridge",
    county_fips_all: "51023|51163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24067,
    lat: 37.03737,
    lng: -80.06884,
    city: "Callaway",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2293,
    density: 14.2,
    county_fips: 51067,
    county_name: "Franklin",
    county_weights: {
      51067: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 51067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24069,
    lat: 36.58376,
    lng: -79.63779,
    city: "Cascade",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1433,
    density: 17.8,
    county_fips: 51143,
    county_name: "Pittsylvania",
    county_weights: {
      51143: 100,
    },
    county_names_all: "Pittsylvania",
    county_fips_all: 51143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24070,
    lat: 37.37316,
    lng: -80.21238,
    city: "Catawba",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1795,
    density: 11.3,
    county_fips: 51161,
    county_name: "Roanoke",
    county_weights: {
      51045: 47.16,
      51121: 4.91,
      51161: 47.92,
    },
    county_names_all: "Roanoke|Craig|Montgomery",
    county_fips_all: "51161|51045|51121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24072,
    lat: 37.03809,
    lng: -80.23113,
    city: "Check",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1141,
    density: 14.7,
    county_fips: 51063,
    county_name: "Floyd",
    county_weights: {
      51063: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 51063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24073,
    lat: 37.13053,
    lng: -80.4225,
    city: "Christiansburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29451,
    density: 126.9,
    county_fips: 51121,
    county_name: "Montgomery",
    county_weights: {
      51121: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 51121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24076,
    lat: 36.59704,
    lng: -80.42116,
    city: "Claudville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1292,
    density: 12.8,
    county_fips: 51141,
    county_name: "Patrick",
    county_weights: {
      51141: 100,
    },
    county_names_all: "Patrick",
    county_fips_all: 51141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24077,
    lat: 37.36337,
    lng: -79.90278,
    city: "Cloverdale",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 923,
    density: 613,
    county_fips: 51023,
    county_name: "Botetourt",
    county_weights: {
      51023: 100,
    },
    county_names_all: "Botetourt",
    county_fips_all: 51023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24078,
    lat: 36.72376,
    lng: -79.91303,
    city: "Collinsville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6952,
    density: 388.3,
    county_fips: 51089,
    county_name: "Henry",
    county_weights: {
      51089: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 51089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24079,
    lat: 37.0539,
    lng: -80.15418,
    city: "Copper Hill",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1929,
    density: 19.2,
    county_fips: 51063,
    county_name: "Floyd",
    county_weights: {
      51063: 96.93,
      51067: 3.07,
    },
    county_names_all: "Floyd|Franklin",
    county_fips_all: "51063|51067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24082,
    lat: 36.62923,
    lng: -80.13204,
    city: "Critz",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 549,
    density: 20.1,
    county_fips: 51141,
    county_name: "Patrick",
    county_weights: {
      51141: 100,
    },
    county_names_all: "Patrick",
    county_fips_all: 51141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24083,
    lat: 37.40614,
    lng: -79.92031,
    city: "Daleville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3065,
    density: 117.6,
    county_fips: 51023,
    county_name: "Botetourt",
    county_weights: {
      51023: 100,
    },
    county_names_all: "Botetourt",
    county_fips_all: 51023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24084,
    lat: 37.11468,
    lng: -80.79088,
    city: "Dublin",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11361,
    density: 38.6,
    county_fips: 51155,
    county_name: "Pulaski",
    county_weights: {
      51021: 25.06,
      51155: 74.94,
    },
    county_names_all: "Pulaski|Bland",
    county_fips_all: "51155|51021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24085,
    lat: 37.67539,
    lng: -79.83639,
    city: "Eagle Rock",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2375,
    density: 5.5,
    county_fips: 51023,
    county_name: "Botetourt",
    county_weights: {
      51005: 1.6,
      51023: 98.4,
    },
    county_names_all: "Botetourt|Alleghany",
    county_fips_all: "51023|51005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24086,
    lat: 37.27268,
    lng: -80.63585,
    city: "Eggleston",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 125,
    density: 7.4,
    county_fips: 51071,
    county_name: "Giles",
    county_weights: {
      51071: 100,
    },
    county_names_all: "Giles",
    county_fips_all: 51071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24087,
    lat: 37.22594,
    lng: -80.24748,
    city: "Elliston",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4110,
    density: 34.7,
    county_fips: 51121,
    county_name: "Montgomery",
    county_weights: {
      51121: 96.45,
      51161: 3.55,
    },
    county_names_all: "Montgomery|Roanoke",
    county_fips_all: "51121|51161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24088,
    lat: 36.89492,
    lng: -80.0798,
    city: "Ferrum",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4957,
    density: 17,
    county_fips: 51067,
    county_name: "Franklin",
    county_weights: {
      51067: 83.69,
      51141: 16.31,
    },
    county_names_all: "Franklin|Patrick",
    county_fips_all: "51067|51141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24089,
    lat: 36.70392,
    lng: -79.96078,
    city: "Fieldale",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3078,
    density: 96.4,
    county_fips: 51089,
    county_name: "Henry",
    county_weights: {
      51089: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 51089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24090,
    lat: 37.52633,
    lng: -79.88921,
    city: "Fincastle",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5032,
    density: 21.3,
    county_fips: 51023,
    county_name: "Botetourt",
    county_weights: {
      51023: 100,
    },
    county_names_all: "Botetourt",
    county_fips_all: 51023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24091,
    lat: 36.92131,
    lng: -80.32264,
    city: "Floyd",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7338,
    density: 16.6,
    county_fips: 51063,
    county_name: "Floyd",
    county_weights: {
      51063: 94.5,
      51067: 3.9,
      51141: 1.6,
    },
    county_names_all: "Floyd|Franklin|Patrick",
    county_fips_all: "51063|51067|51141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24092,
    lat: 37.00158,
    lng: -79.76306,
    city: "Glade Hill",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3578,
    density: 37.4,
    county_fips: 51067,
    county_name: "Franklin",
    county_weights: {
      51067: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 51067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24093,
    lat: 37.38784,
    lng: -80.85657,
    city: "Glen Lyn",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 105,
    density: 7.7,
    county_fips: 51071,
    county_name: "Giles",
    county_weights: {
      51071: 100,
    },
    county_names_all: "Giles",
    county_fips_all: 51071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24095,
    lat: 37.22304,
    lng: -79.73787,
    city: "Goodview",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3924,
    density: 60.4,
    county_fips: 51019,
    county_name: "Bedford",
    county_weights: {
      51019: 100,
    },
    county_names_all: "Bedford",
    county_fips_all: 51019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24101,
    lat: 37.17702,
    lng: -79.80111,
    city: "Hardy",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6118,
    density: 42.5,
    county_fips: 51067,
    county_name: "Franklin",
    county_weights: {
      51019: 7.27,
      51067: 91.67,
      51161: 1.06,
    },
    county_names_all: "Franklin|Bedford|Roanoke",
    county_fips_all: "51067|51019|51161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24102,
    lat: 36.83994,
    lng: -79.99891,
    city: "Henry",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1724,
    density: 20.6,
    county_fips: 51067,
    county_name: "Franklin",
    county_weights: {
      51067: 92.66,
      51089: 7.34,
    },
    county_names_all: "Franklin|Henry",
    county_fips_all: "51067|51089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24104,
    lat: 37.13546,
    lng: -79.48773,
    city: "Huddleston",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3046,
    density: 15.9,
    county_fips: 51019,
    county_name: "Bedford",
    county_weights: {
      51019: 100,
    },
    county_names_all: "Bedford",
    county_fips_all: 51019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24105,
    lat: 36.90278,
    lng: -80.60127,
    city: "Indian Valley",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 479,
    density: 9.1,
    county_fips: 51063,
    county_name: "Floyd",
    county_weights: {
      51035: 34.4,
      51063: 65.6,
    },
    county_names_all: "Floyd|Carroll",
    county_fips_all: "51063|51035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24112,
    lat: 36.72378,
    lng: -79.84921,
    city: "Martinsville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28791,
    density: 73.5,
    county_fips: 51089,
    county_name: "Henry",
    county_weights: {
      51067: 12.82,
      51089: 79.95,
      51690: 7.23,
    },
    county_names_all: "Henry|Franklin|Martinsville",
    county_fips_all: "51089|51067|51690",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24120,
    lat: 36.71891,
    lng: -80.41277,
    city: "Meadows Of Dan",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1569,
    density: 8,
    county_fips: 51141,
    county_name: "Patrick",
    county_weights: {
      51035: 8.78,
      51063: 17.02,
      51141: 74.2,
    },
    county_names_all: "Patrick|Floyd|Carroll",
    county_fips_all: "51141|51063|51035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24121,
    lat: 37.1709,
    lng: -79.64141,
    city: "Moneta",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10489,
    density: 44.1,
    county_fips: 51019,
    county_name: "Bedford",
    county_weights: {
      51019: 73.07,
      51067: 26.93,
    },
    county_names_all: "Bedford|Franklin",
    county_fips_all: "51019|51067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24122,
    lat: 37.4212,
    lng: -79.69372,
    city: "Montvale",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1519,
    density: 19.8,
    county_fips: 51019,
    county_name: "Bedford",
    county_weights: {
      51019: 100,
    },
    county_names_all: "Bedford",
    county_fips_all: 51019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24124,
    lat: 37.30996,
    lng: -80.86774,
    city: "Narrows",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4808,
    density: 24,
    county_fips: 51071,
    county_name: "Giles",
    county_weights: {
      51021: 11.97,
      51071: 88.03,
    },
    county_names_all: "Giles|Bland",
    county_fips_all: "51071|51021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24127,
    lat: 37.47949,
    lng: -80.19468,
    city: "New Castle",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4195,
    density: 7.4,
    county_fips: 51045,
    county_name: "Craig",
    county_weights: {
      51045: 100,
    },
    county_names_all: "Craig",
    county_fips_all: 51045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24128,
    lat: 37.3426,
    lng: -80.47196,
    city: "Newport",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2007,
    density: 10.5,
    county_fips: 51071,
    county_name: "Giles",
    county_weights: {
      51045: 28.63,
      51071: 71.37,
    },
    county_names_all: "Giles|Craig",
    county_fips_all: "51071|51045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24129,
    lat: 37.13947,
    lng: -80.5918,
    city: "New River",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 51155,
    county_name: "Pulaski",
    county_weights: {
      51155: 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: 51155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24131,
    lat: 37.56836,
    lng: -80.22894,
    city: "Paint Bank",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22,
    density: 0.2,
    county_fips: 51045,
    county_name: "Craig",
    county_weights: {
      51045: 100,
    },
    county_names_all: "Craig",
    county_fips_all: 51045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24132,
    lat: 37.20534,
    lng: -80.64707,
    city: "Parrott",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 301,
    density: 8,
    county_fips: 51155,
    county_name: "Pulaski",
    county_weights: {
      51155: 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: 51155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24133,
    lat: 36.67563,
    lng: -80.12794,
    city: "Patrick Springs",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2167,
    density: 20.6,
    county_fips: 51141,
    county_name: "Patrick",
    county_weights: {
      51089: 0.54,
      51141: 99.46,
    },
    county_names_all: "Patrick|Henry",
    county_fips_all: "51141|51089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24134,
    lat: 37.24595,
    lng: -80.77901,
    city: "Pearisburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5166,
    density: 19.1,
    county_fips: 51071,
    county_name: "Giles",
    county_weights: {
      51071: 100,
    },
    county_names_all: "Giles",
    county_fips_all: 51071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24136,
    lat: 37.31927,
    lng: -80.60686,
    city: "Pembroke",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3097,
    density: 34.7,
    county_fips: 51071,
    county_name: "Giles",
    county_weights: {
      51071: 100,
    },
    county_names_all: "Giles",
    county_fips_all: 51071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24137,
    lat: 36.92587,
    lng: -79.65456,
    city: "Penhook",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3286,
    density: 17.7,
    county_fips: 51067,
    county_name: "Franklin",
    county_weights: {
      51067: 78.76,
      51143: 21.24,
    },
    county_names_all: "Franklin|Pittsylvania",
    county_fips_all: "51067|51143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24138,
    lat: 37.05052,
    lng: -80.31684,
    city: "Pilot",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1506,
    density: 23.1,
    county_fips: 51121,
    county_name: "Montgomery",
    county_weights: {
      51063: 49.93,
      51121: 50.07,
    },
    county_names_all: "Montgomery|Floyd",
    county_fips_all: "51121|51063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24139,
    lat: 37.01092,
    lng: -79.4752,
    city: "Pittsville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 662,
    density: 10.5,
    county_fips: 51143,
    county_name: "Pittsylvania",
    county_weights: {
      51019: 24.62,
      51143: 75.38,
    },
    county_names_all: "Pittsylvania|Bedford",
    county_fips_all: "51143|51019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24141,
    lat: 37.10105,
    lng: -80.56677,
    city: "Radford",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23080,
    density: 135.9,
    county_fips: 51155,
    county_name: "Pulaski",
    county_weights: {
      51063: 7.15,
      51121: 29.82,
      51155: 48.7,
      51750: 14.32,
    },
    county_names_all: "Pulaski|Montgomery|Radford|Floyd",
    county_fips_all: "51155|51121|51750|51063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24142,
    lat: 37.13833,
    lng: -80.55084,
    city: "Radford",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2658,
    density: 8994.1,
    county_fips: 51750,
    county_name: "Radford",
    county_weights: {
      51750: 100,
    },
    county_names_all: "Radford",
    county_fips_all: 51750,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24147,
    lat: 37.40178,
    lng: -80.82815,
    city: "Rich Creek",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1347,
    density: 84.4,
    county_fips: 51071,
    county_name: "Giles",
    county_weights: {
      51071: 100,
    },
    county_names_all: "Giles",
    county_fips_all: 51071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24148,
    lat: 36.58156,
    lng: -79.87231,
    city: "Ridgeway",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8868,
    density: 48.3,
    county_fips: 51089,
    county_name: "Henry",
    county_weights: {
      51089: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 51089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24149,
    lat: 37.02277,
    lng: -80.43424,
    city: "Riner",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3942,
    density: 27.6,
    county_fips: 51121,
    county_name: "Montgomery",
    county_weights: {
      51063: 33.9,
      51121: 66.1,
    },
    county_names_all: "Montgomery|Floyd",
    county_fips_all: "51121|51063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24150,
    lat: 37.40229,
    lng: -80.59694,
    city: "Ripplemead",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 788,
    density: 4.6,
    county_fips: 51071,
    county_name: "Giles",
    county_weights: {
      51071: 100,
    },
    county_names_all: "Giles",
    county_fips_all: 51071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24151,
    lat: 36.95827,
    lng: -79.86457,
    city: "Rocky Mount",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19552,
    density: 45.6,
    county_fips: 51067,
    county_name: "Franklin",
    county_weights: {
      51067: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 51067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24153,
    lat: 37.29674,
    lng: -80.11609,
    city: "Salem",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37801,
    density: 144.2,
    county_fips: 51161,
    county_name: "Roanoke",
    county_weights: {
      51023: 0.9,
      51161: 84.72,
      51775: 14.38,
    },
    county_names_all: "Roanoke|Salem|Botetourt",
    county_fips_all: "51161|51775|51023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24161,
    lat: 36.98132,
    lng: -79.54391,
    city: "Sandy Level",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 402,
    density: 5.5,
    county_fips: 51143,
    county_name: "Pittsylvania",
    county_weights: {
      51143: 100,
    },
    county_names_all: "Pittsylvania",
    county_fips_all: 51143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24162,
    lat: 37.13735,
    lng: -80.25828,
    city: "Shawsville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2435,
    density: 20.1,
    county_fips: 51121,
    county_name: "Montgomery",
    county_weights: {
      51063: 2.22,
      51121: 97.78,
    },
    county_names_all: "Montgomery|Floyd",
    county_fips_all: "51121|51063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24165,
    lat: 36.58368,
    lng: -80.05319,
    city: "Spencer",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1251,
    density: 11.8,
    county_fips: 51089,
    county_name: "Henry",
    county_weights: {
      51089: 51.32,
      51141: 48.68,
    },
    county_names_all: "Henry|Patrick",
    county_fips_all: "51089|51141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24167,
    lat: 37.24718,
    lng: -80.7345,
    city: "Staffordsville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 140,
    density: 8.7,
    county_fips: 51071,
    county_name: "Giles",
    county_weights: {
      51071: 100,
    },
    county_names_all: "Giles",
    county_fips_all: 51071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24168,
    lat: 36.73613,
    lng: -79.94876,
    city: "Stanleytown",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 295,
    density: 98.2,
    county_fips: 51089,
    county_name: "Henry",
    county_weights: {
      51089: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 51089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24171,
    lat: 36.67095,
    lng: -80.23835,
    city: "Stuart",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8498,
    density: 16.5,
    county_fips: 51141,
    county_name: "Patrick",
    county_weights: {
      51141: 100,
    },
    county_names_all: "Patrick",
    county_fips_all: 51141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24174,
    lat: 37.35087,
    lng: -79.66762,
    city: "Thaxton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3344,
    density: 41,
    county_fips: 51019,
    county_name: "Bedford",
    county_weights: {
      51019: 100,
    },
    county_names_all: "Bedford",
    county_fips_all: 51019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24175,
    lat: 37.42589,
    lng: -79.93788,
    city: "Troutville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8101,
    density: 38.9,
    county_fips: 51023,
    county_name: "Botetourt",
    county_weights: {
      51023: 95.33,
      51161: 4.67,
    },
    county_names_all: "Botetourt|Roanoke",
    county_fips_all: "51023|51161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24176,
    lat: 37.00937,
    lng: -79.69193,
    city: "Union Hall",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1197,
    density: 21,
    county_fips: 51067,
    county_name: "Franklin",
    county_weights: {
      51067: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 51067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24179,
    lat: 37.2855,
    lng: -79.79963,
    city: "Vinton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18715,
    density: 152.1,
    county_fips: 51019,
    county_name: "Bedford",
    county_weights: {
      51019: 80.75,
      51161: 18.81,
      51770: 0.44,
    },
    county_names_all: "Bedford|Roanoke|Roanoke",
    county_fips_all: "51019|51161|51770",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24184,
    lat: 37.0881,
    lng: -79.77642,
    city: "Wirtz",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4263,
    density: 39.8,
    county_fips: 51067,
    county_name: "Franklin",
    county_weights: {
      51067: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 51067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24185,
    lat: 36.80868,
    lng: -80.27557,
    city: "Woolwine",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 729,
    density: 8,
    county_fips: 51141,
    county_name: "Patrick",
    county_weights: {
      51141: 100,
    },
    county_names_all: "Patrick",
    county_fips_all: 51141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24201,
    lat: 36.61059,
    lng: -82.16971,
    city: "Bristol",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15867,
    density: 605.9,
    county_fips: 51520,
    county_name: "Bristol",
    county_weights: {
      51520: 100,
    },
    county_names_all: "Bristol",
    county_fips_all: 51520,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24202,
    lat: 36.65904,
    lng: -82.21564,
    city: "Bristol",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12345,
    density: 37,
    county_fips: 51191,
    county_name: "Washington",
    county_weights: {
      51169: 18.15,
      51191: 79.66,
      51520: 2.19,
    },
    county_names_all: "Washington|Scott|Bristol",
    county_fips_all: "51191|51169|51520",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24210,
    lat: 36.77231,
    lng: -82.02244,
    city: "Abingdon",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16132,
    density: 43.2,
    county_fips: 51191,
    county_name: "Washington",
    county_weights: {
      51191: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 51191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24211,
    lat: 36.65413,
    lng: -81.95643,
    city: "Abingdon",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10260,
    density: 56.4,
    county_fips: 51191,
    county_name: "Washington",
    county_weights: {
      51191: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 51191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24216,
    lat: 36.94237,
    lng: -82.79571,
    city: "Appalachia",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2575,
    density: 14.3,
    county_fips: 51195,
    county_name: "Wise",
    county_weights: {
      51195: 100,
    },
    county_names_all: "Wise",
    county_fips_all: 51195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24217,
    lat: 37.1014,
    lng: -82.17783,
    city: "Bee",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 237,
    density: 3.5,
    county_fips: 51051,
    county_name: "Dickenson",
    county_weights: {
      51027: 22.57,
      51051: 77.43,
    },
    county_names_all: "Dickenson|Buchanan",
    county_fips_all: "51051|51027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24219,
    lat: 36.84831,
    lng: -82.74645,
    city: "Big Stone Gap",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11725,
    density: 62.2,
    county_fips: 51195,
    county_name: "Wise",
    county_weights: {
      51105: 24.43,
      51169: 7.05,
      51195: 68.52,
    },
    county_names_all: "Wise|Lee|Scott",
    county_fips_all: "51195|51105|51169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24220,
    lat: 37.11957,
    lng: -82.22641,
    city: "Birchleaf",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1199,
    density: 20.6,
    county_fips: 51051,
    county_name: "Dickenson",
    county_weights: {
      51051: 100,
    },
    county_names_all: "Dickenson",
    county_fips_all: 51051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24221,
    lat: 36.63398,
    lng: -82.9943,
    city: "Blackwater",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 514,
    density: 3.8,
    county_fips: 51105,
    county_name: "Lee",
    county_weights: {
      51105: 61.01,
      51169: 38.99,
    },
    county_names_all: "Lee|Scott",
    county_fips_all: "51105|51169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24224,
    lat: 36.86059,
    lng: -82.28322,
    city: "Castlewood",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5503,
    density: 20.2,
    county_fips: 51167,
    county_name: "Russell",
    county_weights: {
      51167: 100,
    },
    county_names_all: "Russell",
    county_fips_all: 51167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24225,
    lat: 36.97543,
    lng: -82.14115,
    city: "Cleveland",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2557,
    density: 16.3,
    county_fips: 51167,
    county_name: "Russell",
    county_weights: {
      51051: 0.98,
      51167: 99.02,
    },
    county_names_all: "Russell|Dickenson",
    county_fips_all: "51167|51051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24226,
    lat: 37.14223,
    lng: -82.33384,
    city: "Clinchco",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1298,
    density: 19.2,
    county_fips: 51051,
    county_name: "Dickenson",
    county_weights: {
      51051: 100,
    },
    county_names_all: "Dickenson",
    county_fips_all: 51051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24228,
    lat: 37.17047,
    lng: -82.44963,
    city: "Clintwood",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6224,
    density: 26,
    county_fips: 51051,
    county_name: "Dickenson",
    county_weights: {
      51051: 100,
    },
    county_names_all: "Dickenson",
    county_fips_all: 51051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24230,
    lat: 36.96928,
    lng: -82.45449,
    city: "Coeburn",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7382,
    density: 23,
    county_fips: 51195,
    county_name: "Wise",
    county_weights: {
      51051: 34.02,
      51169: 7.51,
      51195: 58.47,
    },
    county_names_all: "Wise|Dickenson|Scott",
    county_fips_all: "51195|51051|51169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24236,
    lat: 36.64408,
    lng: -81.73689,
    city: "Damascus",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3060,
    density: 19.7,
    county_fips: 51191,
    county_name: "Washington",
    county_weights: {
      51173: 4.06,
      51191: 95.94,
    },
    county_names_all: "Washington|Smyth",
    county_fips_all: "51191|51173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24237,
    lat: 37.03939,
    lng: -82.26424,
    city: "Dante",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 769,
    density: 5.5,
    county_fips: 51051,
    county_name: "Dickenson",
    county_weights: {
      51051: 76.47,
      51167: 23.53,
    },
    county_names_all: "Dickenson|Russell",
    county_fips_all: "51051|51167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24239,
    lat: 37.1136,
    lng: -82.14577,
    city: "Davenport",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 206,
    density: 30.4,
    county_fips: 51027,
    county_name: "Buchanan",
    county_weights: {
      51027: 100,
    },
    county_names_all: "Buchanan",
    county_fips_all: 51027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24243,
    lat: 36.78174,
    lng: -82.92083,
    city: "Dryden",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1666,
    density: 28,
    county_fips: 51105,
    county_name: "Lee",
    county_weights: {
      51105: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 51105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24244,
    lat: 36.71075,
    lng: -82.79785,
    city: "Duffield",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6085,
    density: 13.9,
    county_fips: 51169,
    county_name: "Scott",
    county_weights: {
      51105: 17.3,
      51169: 82.7,
    },
    county_names_all: "Scott|Lee",
    county_fips_all: "51169|51105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24245,
    lat: 36.84045,
    lng: -82.51598,
    city: "Dungannon",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 912,
    density: 6.1,
    county_fips: 51169,
    county_name: "Scott",
    county_weights: {
      51169: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 51169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24246,
    lat: 36.86609,
    lng: -82.74395,
    city: "East Stone Gap",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 309,
    density: 300.7,
    county_fips: 51195,
    county_name: "Wise",
    county_weights: {
      51195: 100,
    },
    county_names_all: "Wise",
    county_fips_all: 51195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24248,
    lat: 36.62708,
    lng: -83.50767,
    city: "Ewing",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2196,
    density: 15.5,
    county_fips: 51105,
    county_name: "Lee",
    county_weights: {
      51105: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 51105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24250,
    lat: 36.75752,
    lng: -82.58705,
    city: "Fort Blackmore",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1217,
    density: 8.2,
    county_fips: 51169,
    county_name: "Scott",
    county_weights: {
      51169: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 51169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24251,
    lat: 36.65807,
    lng: -82.60582,
    city: "Gate City",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7647,
    density: 25.2,
    county_fips: 51169,
    county_name: "Scott",
    county_weights: {
      51169: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 51169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24256,
    lat: 37.22344,
    lng: -82.28503,
    city: "Haysi",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3585,
    density: 25.3,
    county_fips: 51051,
    county_name: "Dickenson",
    county_weights: {
      51027: 17.57,
      51051: 82.43,
    },
    county_names_all: "Dickenson|Buchanan",
    county_fips_all: "51051|51027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24258,
    lat: 36.6517,
    lng: -82.41199,
    city: "Hiltons",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1495,
    density: 14.6,
    county_fips: 51169,
    county_name: "Scott",
    county_weights: {
      51169: 93.27,
      51191: 6.73,
    },
    county_names_all: "Scott|Washington",
    county_fips_all: "51169|51191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24260,
    lat: 37.02291,
    lng: -82.00059,
    city: "Honaker",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4940,
    density: 18.9,
    county_fips: 51167,
    county_name: "Russell",
    county_weights: {
      51027: 21.35,
      51167: 78.65,
    },
    county_names_all: "Russell|Buchanan",
    county_fips_all: "51167|51027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24263,
    lat: 36.67164,
    lng: -83.15079,
    city: "Jonesville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6144,
    density: 20,
    county_fips: 51105,
    county_name: "Lee",
    county_weights: {
      51105: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 51105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24265,
    lat: 36.83811,
    lng: -82.93904,
    city: "Keokee",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1328,
    density: 13.1,
    county_fips: 51105,
    county_name: "Lee",
    county_weights: {
      51105: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 51105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24266,
    lat: 36.8671,
    lng: -82.10523,
    city: "Lebanon",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9301,
    density: 28.5,
    county_fips: 51167,
    county_name: "Russell",
    county_weights: {
      51167: 100,
    },
    county_names_all: "Russell",
    county_fips_all: 51167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24269,
    lat: 37.0803,
    lng: -82.37894,
    city: "McClure",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 424,
    density: 21.3,
    county_fips: 51051,
    county_name: "Dickenson",
    county_weights: {
      51051: 100,
    },
    county_names_all: "Dickenson",
    county_fips_all: 51051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24270,
    lat: 36.72846,
    lng: -82.24693,
    city: "Mendota",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 468,
    density: 9.4,
    county_fips: 51191,
    county_name: "Washington",
    county_weights: {
      51191: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 51191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24271,
    lat: 36.74712,
    lng: -82.41714,
    city: "Nickelsville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2495,
    density: 15.1,
    county_fips: 51169,
    county_name: "Scott",
    county_weights: {
      51167: 0.81,
      51169: 99.19,
    },
    county_names_all: "Scott|Russell",
    county_fips_all: "51169|51167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24272,
    lat: 37.0302,
    lng: -82.33401,
    city: "Nora",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 639,
    density: 10.6,
    county_fips: 51051,
    county_name: "Dickenson",
    county_weights: {
      51051: 100,
    },
    county_names_all: "Dickenson",
    county_fips_all: 51051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24273,
    lat: 36.96142,
    lng: -82.65632,
    city: "Norton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6052,
    density: 36.2,
    county_fips: 51195,
    county_name: "Wise",
    county_weights: {
      51195: 88.41,
      51720: 11.59,
    },
    county_names_all: "Wise|Norton",
    county_fips_all: "51195|51720",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24277,
    lat: 36.74948,
    lng: -83.03037,
    city: "Pennington Gap",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6731,
    density: 48.9,
    county_fips: 51105,
    county_name: "Lee",
    county_weights: {
      51105: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 51105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24279,
    lat: 37.10383,
    lng: -82.61909,
    city: "Pound",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5400,
    density: 26.3,
    county_fips: 51195,
    county_name: "Wise",
    county_weights: {
      51195: 100,
    },
    county_names_all: "Wise",
    county_fips_all: 51195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24280,
    lat: 36.95575,
    lng: -81.94167,
    city: "Rosedale",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1070,
    density: 41.4,
    county_fips: 51167,
    county_name: "Russell",
    county_weights: {
      51167: 100,
    },
    county_names_all: "Russell",
    county_fips_all: 51167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24281,
    lat: 36.65051,
    lng: -83.3295,
    city: "Rose Hill",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2447,
    density: 18.1,
    county_fips: 51105,
    county_name: "Lee",
    county_weights: {
      51105: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 51105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24282,
    lat: 36.82159,
    lng: -83.05533,
    city: "Saint Charles",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 672,
    density: 16.9,
    county_fips: 51105,
    county_name: "Lee",
    county_weights: {
      51105: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 51105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24283,
    lat: 36.94155,
    lng: -82.34554,
    city: "Saint Paul",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1831,
    density: 27.3,
    county_fips: 51195,
    county_name: "Wise",
    county_weights: {
      51051: 13.38,
      51167: 16.52,
      51195: 70.1,
    },
    county_names_all: "Wise|Russell|Dickenson",
    county_fips_all: "51195|51167|51051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24290,
    lat: 36.61186,
    lng: -82.56688,
    city: "Weber City",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2127,
    density: 163.7,
    county_fips: 51169,
    county_name: "Scott",
    county_weights: {
      51169: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 51169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24292,
    lat: 36.6147,
    lng: -81.5791,
    city: "Whitetop",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 383,
    density: 5.7,
    county_fips: 51077,
    county_name: "Grayson",
    county_weights: {
      51077: 100,
    },
    county_names_all: "Grayson",
    county_fips_all: 51077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24293,
    lat: 37.00559,
    lng: -82.56458,
    city: "Wise",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9606,
    density: 65.5,
    county_fips: 51195,
    county_name: "Wise",
    county_weights: {
      51195: 100,
    },
    county_names_all: "Wise",
    county_fips_all: 51195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24301,
    lat: 37.06319,
    lng: -80.79735,
    city: "Pulaski",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13594,
    density: 61.4,
    county_fips: 51155,
    county_name: "Pulaski",
    county_weights: {
      51155: 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: 51155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24311,
    lat: 36.87292,
    lng: -81.40161,
    city: "Atkins",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1613,
    density: 19.7,
    county_fips: 51173,
    county_name: "Smyth",
    county_weights: {
      51173: 100,
    },
    county_names_all: "Smyth",
    county_fips_all: 51173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24312,
    lat: 36.83117,
    lng: -80.86897,
    city: "Austinville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2118,
    density: 22.8,
    county_fips: 51035,
    county_name: "Carroll",
    county_weights: {
      51035: 68.73,
      51197: 31.27,
    },
    county_names_all: "Carroll|Wythe",
    county_fips_all: "51035|51197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24313,
    lat: 36.9105,
    lng: -80.79805,
    city: "Barren Springs",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 704,
    density: 35.7,
    county_fips: 51197,
    county_name: "Wythe",
    county_weights: {
      51155: 9.99,
      51197: 90.01,
    },
    county_names_all: "Wythe|Pulaski",
    county_fips_all: "51197|51155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24314,
    lat: 37.17166,
    lng: -81.20728,
    city: "Bastian",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1199,
    density: 4.8,
    county_fips: 51021,
    county_name: "Bland",
    county_weights: {
      51021: 90.57,
      51185: 9.43,
    },
    county_names_all: "Bland|Tazewell",
    county_fips_all: "51021|51185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24315,
    lat: 37.1393,
    lng: -81.0534,
    city: "Bland",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3765,
    density: 8.5,
    county_fips: 51021,
    county_name: "Bland",
    county_weights: {
      51021: 95.66,
      51071: 4.34,
    },
    county_names_all: "Bland|Giles",
    county_fips_all: "51021|51071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24316,
    lat: 36.95277,
    lng: -81.67145,
    city: "Broadford",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 51185,
    county_name: "Tazewell",
    county_weights: {
      51173: 9.14,
      51185: 90.86,
    },
    county_names_all: "Tazewell|Smyth",
    county_fips_all: "51185|51173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24317,
    lat: 36.60138,
    lng: -80.66876,
    city: "Cana",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4147,
    density: 41.2,
    county_fips: 51035,
    county_name: "Carroll",
    county_weights: {
      51035: 93.49,
      51141: 6.51,
    },
    county_names_all: "Carroll|Patrick",
    county_fips_all: "51035|51141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24318,
    lat: 37.00047,
    lng: -81.38658,
    city: "Ceres",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 567,
    density: 3,
    county_fips: 51021,
    county_name: "Bland",
    county_weights: {
      51021: 66.25,
      51173: 33.75,
    },
    county_names_all: "Bland|Smyth",
    county_fips_all: "51021|51173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24319,
    lat: 36.76048,
    lng: -81.65778,
    city: "Chilhowie",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6838,
    density: 42.3,
    county_fips: 51173,
    county_name: "Smyth",
    county_weights: {
      51173: 79.3,
      51191: 20.7,
    },
    county_names_all: "Smyth|Washington",
    county_fips_all: "51173|51191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24322,
    lat: 36.80534,
    lng: -81.1195,
    city: "Cripple Creek",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33,
    density: 0.7,
    county_fips: 51197,
    county_name: "Wythe",
    county_weights: {
      51197: 100,
    },
    county_names_all: "Wythe",
    county_fips_all: 51197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24323,
    lat: 36.86513,
    lng: -81.1997,
    city: "Crockett",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 919,
    density: 17.7,
    county_fips: 51197,
    county_name: "Wythe",
    county_weights: {
      51197: 100,
    },
    county_names_all: "Wythe",
    county_fips_all: 51197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24324,
    lat: 36.97461,
    lng: -80.78836,
    city: "Draper",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2373,
    density: 23.4,
    county_fips: 51155,
    county_name: "Pulaski",
    county_weights: {
      51155: 76.28,
      51197: 23.72,
    },
    county_names_all: "Pulaski|Wythe",
    county_fips_all: "51155|51197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24325,
    lat: 36.80918,
    lng: -80.60608,
    city: "Dugspur",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1017,
    density: 8.2,
    county_fips: 51035,
    county_name: "Carroll",
    county_weights: {
      51035: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 51035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24326,
    lat: 36.72771,
    lng: -81.19625,
    city: "Elk Creek",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 985,
    density: 7.4,
    county_fips: 51077,
    county_name: "Grayson",
    county_weights: {
      51077: 100,
    },
    county_names_all: "Grayson",
    county_fips_all: 51077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24327,
    lat: 36.77357,
    lng: -81.82971,
    city: "Emory",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 51191,
    county_name: "Washington",
    county_weights: {
      51191: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 51191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24328,
    lat: 36.66185,
    lng: -80.69382,
    city: "Fancy Gap",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1621,
    density: 16.4,
    county_fips: 51035,
    county_name: "Carroll",
    county_weights: {
      51035: 99.48,
      51141: 0.52,
    },
    county_names_all: "Carroll|Patrick",
    county_fips_all: "51035|51141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24330,
    lat: 36.72375,
    lng: -81.02471,
    city: "Fries",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2905,
    density: 26.2,
    county_fips: 51077,
    county_name: "Grayson",
    county_weights: {
      51035: 21.13,
      51077: 78.87,
    },
    county_names_all: "Grayson|Carroll",
    county_fips_all: "51077|51035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24333,
    lat: 36.64057,
    lng: -80.92921,
    city: "Galax",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17317,
    density: 46.1,
    county_fips: 51077,
    county_name: "Grayson",
    county_weights: {
      51035: 42.81,
      51077: 51.59,
      51640: 5.6,
    },
    county_names_all: "Grayson|Carroll|Galax",
    county_fips_all: "51077|51035|51640",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24340,
    lat: 36.75267,
    lng: -81.75891,
    city: "Glade Spring",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6489,
    density: 37.6,
    county_fips: 51191,
    county_name: "Washington",
    county_weights: {
      51191: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 51191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24343,
    lat: 36.76612,
    lng: -80.70045,
    city: "Hillsville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9221,
    density: 28.3,
    county_fips: 51035,
    county_name: "Carroll",
    county_weights: {
      51035: 95.06,
      51141: 2.58,
      51197: 2.36,
    },
    county_names_all: "Carroll|Patrick|Wythe",
    county_fips_all: "51035|51141|51197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24347,
    lat: 36.95958,
    lng: -80.65598,
    city: "Hiwassee",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1341,
    density: 6.3,
    county_fips: 51155,
    county_name: "Pulaski",
    county_weights: {
      51035: 9.03,
      51121: 3.85,
      51155: 87.12,
    },
    county_names_all: "Pulaski|Carroll|Montgomery",
    county_fips_all: "51155|51035|51121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24348,
    lat: 36.63897,
    lng: -81.17392,
    city: "Independence",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4800,
    density: 18.2,
    county_fips: 51077,
    county_name: "Grayson",
    county_weights: {
      51077: 100,
    },
    county_names_all: "Grayson",
    county_fips_all: 51077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24350,
    lat: 36.81109,
    lng: -81.01757,
    city: "Ivanhoe",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1370,
    density: 10.9,
    county_fips: 51197,
    county_name: "Wythe",
    county_weights: {
      51035: 30,
      51077: 20.48,
      51197: 49.52,
    },
    county_names_all: "Wythe|Carroll|Grayson",
    county_fips_all: "51197|51035|51077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24351,
    lat: 36.58081,
    lng: -80.76591,
    city: "Lambsburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 313,
    density: 10.6,
    county_fips: 51035,
    county_name: "Carroll",
    county_weights: {
      51035: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 51035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24352,
    lat: 36.71547,
    lng: -80.53437,
    city: "Laurel Fork",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1168,
    density: 15.2,
    county_fips: 51035,
    county_name: "Carroll",
    county_weights: {
      51035: 98.92,
      51063: 1.08,
    },
    county_names_all: "Carroll|Floyd",
    county_fips_all: "51035|51063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24354,
    lat: 36.82159,
    lng: -81.54001,
    city: "Marion",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14137,
    density: 45.6,
    county_fips: 51173,
    county_name: "Smyth",
    county_weights: {
      51173: 100,
    },
    county_names_all: "Smyth",
    county_fips_all: 51173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24360,
    lat: 36.93917,
    lng: -80.9023,
    city: "Max Meadows",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5816,
    density: 24.3,
    county_fips: 51197,
    county_name: "Wythe",
    county_weights: {
      51035: 1.19,
      51197: 98.81,
    },
    county_names_all: "Wythe|Carroll",
    county_fips_all: "51197|51035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24361,
    lat: 36.76672,
    lng: -81.84552,
    city: "Meadowview",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5484,
    density: 38.8,
    county_fips: 51191,
    county_name: "Washington",
    county_weights: {
      51191: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 51191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24363,
    lat: 36.6137,
    lng: -81.40084,
    city: "Mouth Of Wilson",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1256,
    density: 6.3,
    county_fips: 51077,
    county_name: "Grayson",
    county_weights: {
      51077: 100,
    },
    county_names_all: "Grayson",
    county_fips_all: 51077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24366,
    lat: 37.26426,
    lng: -81.10315,
    city: "Rocky Gap",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 544,
    density: 10.1,
    county_fips: 51021,
    county_name: "Bland",
    county_weights: {
      51021: 100,
    },
    county_names_all: "Bland",
    county_fips_all: 51021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24368,
    lat: 36.89283,
    lng: -81.30003,
    city: "Rural Retreat",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5582,
    density: 24.9,
    county_fips: 51197,
    county_name: "Wythe",
    county_weights: {
      51173: 27.36,
      51197: 72.64,
    },
    county_names_all: "Wythe|Smyth",
    county_fips_all: "51197|51173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24370,
    lat: 36.91345,
    lng: -81.69107,
    city: "Saltville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6199,
    density: 15.8,
    county_fips: 51173,
    county_name: "Smyth",
    county_weights: {
      51173: 79.91,
      51191: 20.09,
    },
    county_names_all: "Smyth|Washington",
    county_fips_all: "51173|51191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24374,
    lat: 36.79129,
    lng: -81.20178,
    city: "Speedwell",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 793,
    density: 11.8,
    county_fips: 51197,
    county_name: "Wythe",
    county_weights: {
      51197: 100,
    },
    county_names_all: "Wythe",
    county_fips_all: 51197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24375,
    lat: 36.77128,
    lng: -81.39026,
    city: "Sugar Grove",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1670,
    density: 10.3,
    county_fips: 51173,
    county_name: "Smyth",
    county_weights: {
      51173: 100,
    },
    county_names_all: "Smyth",
    county_fips_all: 51173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24377,
    lat: 37.00206,
    lng: -81.56961,
    city: "Tannersville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 507,
    density: 5.6,
    county_fips: 51185,
    county_name: "Tazewell",
    county_weights: {
      51185: 100,
    },
    county_names_all: "Tazewell",
    county_fips_all: 51185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24378,
    lat: 36.69126,
    lng: -81.42944,
    city: "Troutdale",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 998,
    density: 4.7,
    county_fips: 51077,
    county_name: "Grayson",
    county_weights: {
      51077: 80.95,
      51173: 19.05,
    },
    county_names_all: "Grayson|Smyth",
    county_fips_all: "51077|51173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24380,
    lat: 36.85672,
    lng: -80.50183,
    city: "Willis",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2782,
    density: 11.4,
    county_fips: 51063,
    county_name: "Floyd",
    county_weights: {
      51035: 6.98,
      51063: 93.02,
    },
    county_names_all: "Floyd|Carroll",
    county_fips_all: "51063|51035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24381,
    lat: 36.72453,
    lng: -80.83924,
    city: "Woodlawn",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3727,
    density: 28.3,
    county_fips: 51035,
    county_name: "Carroll",
    county_weights: {
      51035: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 51035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24382,
    lat: 36.95702,
    lng: -81.10652,
    city: "Wytheville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13839,
    density: 28.1,
    county_fips: 51197,
    county_name: "Wythe",
    county_weights: {
      51197: 100,
    },
    county_names_all: "Wythe",
    county_fips_all: 51197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24401,
    lat: 38.13257,
    lng: -79.08846,
    city: "Staunton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35772,
    density: 104.3,
    county_fips: 51015,
    county_name: "Augusta",
    county_weights: {
      51015: 85,
      51790: 15,
    },
    county_names_all: "Augusta|Staunton",
    county_fips_all: "51015|51790",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24411,
    lat: 38.11784,
    lng: -79.33052,
    city: "Augusta Springs",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 51015,
    county_name: "Augusta",
    county_weights: {
      51015: 100,
    },
    county_names_all: "Augusta",
    county_fips_all: 51015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24412,
    lat: 38.05774,
    lng: -79.83096,
    city: "Bacova",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 174,
    density: 20,
    county_fips: 51017,
    county_name: "Bath",
    county_weights: {
      51017: 100,
    },
    county_names_all: "Bath",
    county_fips_all: 51017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24413,
    lat: 38.50753,
    lng: -79.55925,
    city: "Blue Grass",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 266,
    density: 4.3,
    county_fips: 51091,
    county_name: "Highland",
    county_weights: {
      51091: 100,
    },
    county_names_all: "Highland",
    county_fips_all: 51091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24415,
    lat: 37.91099,
    lng: -79.31126,
    city: "Brownsburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 51163,
    county_name: "Rockbridge",
    county_weights: {
      51163: 100,
    },
    county_names_all: "Rockbridge",
    county_fips_all: 51163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24416,
    lat: 37.72892,
    lng: -79.35534,
    city: "Buena Vista",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8901,
    density: 55.7,
    county_fips: 51163,
    county_name: "Rockbridge",
    county_weights: {
      51163: 89.53,
      51530: 10.47,
    },
    county_names_all: "Rockbridge|Buena Vista",
    county_fips_all: "51163|51530",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24421,
    lat: 38.26389,
    lng: -79.20019,
    city: "Churchville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4189,
    density: 21.7,
    county_fips: 51015,
    county_name: "Augusta",
    county_weights: {
      51015: 100,
    },
    county_names_all: "Augusta",
    county_fips_all: 51015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24422,
    lat: 37.83041,
    lng: -79.75128,
    city: "Clifton Forge",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5953,
    density: 28.9,
    county_fips: 51005,
    county_name: "Alleghany",
    county_weights: {
      51005: 95.93,
      51023: 4.07,
    },
    county_names_all: "Alleghany|Botetourt",
    county_fips_all: "51005|51023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24426,
    lat: 37.76589,
    lng: -80.06927,
    city: "Covington",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13258,
    density: 14.1,
    county_fips: 51005,
    county_name: "Alleghany",
    county_weights: {
      51005: 94.98,
      51045: 3.48,
      51580: 1.54,
    },
    county_names_all: "Alleghany|Craig|Covington",
    county_fips_all: "51005|51045|51580",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24430,
    lat: 38.076,
    lng: -79.34181,
    city: "Craigsville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4025,
    density: 65.8,
    county_fips: 51015,
    county_name: "Augusta",
    county_weights: {
      51015: 100,
    },
    county_names_all: "Augusta",
    county_fips_all: 51015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24431,
    lat: 38.16897,
    lng: -78.83924,
    city: "Crimora",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2567,
    density: 66.4,
    county_fips: 51015,
    county_name: "Augusta",
    county_weights: {
      51015: 100,
    },
    county_names_all: "Augusta",
    county_fips_all: 51015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24432,
    lat: 38.17639,
    lng: -79.43845,
    city: "Deerfield",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 307,
    density: 2.8,
    county_fips: 51015,
    county_name: "Augusta",
    county_weights: {
      51015: 89.01,
      51017: 10.99,
    },
    county_names_all: "Augusta|Bath",
    county_fips_all: "51015|51017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24433,
    lat: 38.41817,
    lng: -79.46461,
    city: "Doe Hill",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 77,
    density: 1.8,
    county_fips: 51091,
    county_name: "Highland",
    county_weights: {
      51091: 100,
    },
    county_names_all: "Highland",
    county_fips_all: 51091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24435,
    lat: 37.86716,
    lng: -79.30663,
    city: "Fairfield",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1707,
    density: 25.4,
    county_fips: 51163,
    county_name: "Rockbridge",
    county_weights: {
      51163: 100,
    },
    county_names_all: "Rockbridge",
    county_fips_all: 51163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24437,
    lat: 38.2116,
    lng: -78.933,
    city: "Fort Defiance",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1520,
    density: 53.6,
    county_fips: 51015,
    county_name: "Augusta",
    county_weights: {
      51015: 100,
    },
    county_names_all: "Augusta",
    county_fips_all: 51015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24439,
    lat: 38.01151,
    lng: -79.47359,
    city: "Goshen",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1208,
    density: 3.8,
    county_fips: 51163,
    county_name: "Rockbridge",
    county_weights: {
      51015: 28.23,
      51163: 71.77,
    },
    county_names_all: "Rockbridge|Augusta",
    county_fips_all: "51163|51015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24440,
    lat: 37.99595,
    lng: -79.16574,
    city: "Greenville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3003,
    density: 44.7,
    county_fips: 51015,
    county_name: "Augusta",
    county_weights: {
      51015: 100,
    },
    county_names_all: "Augusta",
    county_fips_all: 51015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24441,
    lat: 38.22823,
    lng: -78.8109,
    city: "Grottoes",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5765,
    density: 42,
    county_fips: 51015,
    county_name: "Augusta",
    county_weights: {
      51015: 65.52,
      51165: 34.48,
    },
    county_names_all: "Augusta|Rockingham",
    county_fips_all: "51015|51165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24442,
    lat: 38.35971,
    lng: -79.39028,
    city: "Head Waters",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 116,
    density: 1.1,
    county_fips: 51091,
    county_name: "Highland",
    county_weights: {
      51091: 100,
    },
    county_names_all: "Highland",
    county_fips_all: 51091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24445,
    lat: 37.96615,
    lng: -79.88013,
    city: "Hot Springs",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2773,
    density: 11.1,
    county_fips: 51017,
    county_name: "Bath",
    county_weights: {
      51005: 20.86,
      51017: 79.14,
    },
    county_names_all: "Bath|Alleghany",
    county_fips_all: "51017|51005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24448,
    lat: 37.79836,
    lng: -79.79002,
    city: "Iron Gate",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 393,
    density: 493.7,
    county_fips: 51005,
    county_name: "Alleghany",
    county_weights: {
      51005: 100,
    },
    county_names_all: "Alleghany",
    county_fips_all: 51005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24450,
    lat: 37.77883,
    lng: -79.53888,
    city: "Lexington",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17385,
    density: 30.5,
    county_fips: 51163,
    county_name: "Rockbridge",
    county_weights: {
      51023: 7.81,
      51163: 91.05,
      51678: 1.14,
    },
    county_names_all: "Rockbridge|Botetourt|Lexington",
    county_fips_all: "51163|51023|51678",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24457,
    lat: 37.79379,
    lng: -79.87014,
    city: "Low Moor",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 333,
    density: 110.9,
    county_fips: 51005,
    county_name: "Alleghany",
    county_weights: {
      51005: 100,
    },
    county_names_all: "Alleghany",
    county_fips_all: 51005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24458,
    lat: 38.33066,
    lng: -79.51201,
    city: "McDowell",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 241,
    density: 1.4,
    county_fips: 51091,
    county_name: "Highland",
    county_weights: {
      51091: 100,
    },
    county_names_all: "Highland",
    county_fips_all: 51091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24459,
    lat: 38.02955,
    lng: -79.28621,
    city: "Middlebrook",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 611,
    density: 4.9,
    county_fips: 51015,
    county_name: "Augusta",
    county_weights: {
      51015: 87.93,
      51163: 12.07,
    },
    county_names_all: "Augusta|Rockbridge",
    county_fips_all: "51015|51163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24460,
    lat: 38.02237,
    lng: -79.65048,
    city: "Millboro",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 915,
    density: 1.4,
    county_fips: 51017,
    county_name: "Bath",
    county_weights: {
      51017: 100,
    },
    county_names_all: "Bath",
    county_fips_all: 51017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24464,
    lat: 37.86082,
    lng: -79.10398,
    city: "Montebello",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 291,
    density: 4.1,
    county_fips: 51125,
    county_name: "Nelson",
    county_weights: {
      51125: 100,
    },
    county_names_all: "Nelson",
    county_fips_all: 51125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24465,
    lat: 38.39611,
    lng: -79.64636,
    city: "Monterey",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1350,
    density: 2.7,
    county_fips: 51091,
    county_name: "Highland",
    county_weights: {
      51091: 100,
    },
    county_names_all: "Highland",
    county_fips_all: 51091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24467,
    lat: 38.2592,
    lng: -78.97249,
    city: "Mount Sidney",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2474,
    density: 39.4,
    county_fips: 51015,
    county_name: "Augusta",
    county_weights: {
      51015: 100,
    },
    county_names_all: "Augusta",
    county_fips_all: 51015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24469,
    lat: 38.20099,
    lng: -78.90828,
    city: "New Hope",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 51015,
    county_name: "Augusta",
    county_weights: {
      51015: 100,
    },
    county_names_all: "Augusta",
    county_fips_all: 51015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24471,
    lat: 38.30837,
    lng: -78.79645,
    city: "Port Republic",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1623,
    density: 38,
    county_fips: 51165,
    county_name: "Rockingham",
    county_weights: {
      51165: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 51165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24472,
    lat: 37.93833,
    lng: -79.22194,
    city: "Raphine",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1866,
    density: 10.1,
    county_fips: 51163,
    county_name: "Rockbridge",
    county_weights: {
      51015: 49.33,
      51163: 50.67,
    },
    county_names_all: "Rockbridge|Augusta",
    county_fips_all: "51163|51015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24473,
    lat: 37.9129,
    lng: -79.41052,
    city: "Rockbridge Baths",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 854,
    density: 7.1,
    county_fips: 51163,
    county_name: "Rockbridge",
    county_weights: {
      51163: 100,
    },
    county_names_all: "Rockbridge",
    county_fips_all: 51163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24474,
    lat: 37.80504,
    lng: -79.84731,
    city: "Selma",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 495,
    density: 324.8,
    county_fips: 51005,
    county_name: "Alleghany",
    county_weights: {
      51005: 100,
    },
    county_names_all: "Alleghany",
    county_fips_all: 51005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24476,
    lat: 37.97231,
    lng: -79.22,
    city: "Steeles Tavern",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 234,
    density: 12.3,
    county_fips: 51015,
    county_name: "Augusta",
    county_weights: {
      51015: 100,
    },
    county_names_all: "Augusta",
    county_fips_all: 51015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24477,
    lat: 38.00416,
    lng: -79.04374,
    city: "Stuarts Draft",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10851,
    density: 85.7,
    county_fips: 51015,
    county_name: "Augusta",
    county_weights: {
      51015: 100,
    },
    county_names_all: "Augusta",
    county_fips_all: 51015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24479,
    lat: 38.15353,
    lng: -79.23992,
    city: "Swoope",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1737,
    density: 10.9,
    county_fips: 51015,
    county_name: "Augusta",
    county_weights: {
      51015: 100,
    },
    county_names_all: "Augusta",
    county_fips_all: 51015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24482,
    lat: 38.20502,
    lng: -78.99706,
    city: "Verona",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5297,
    density: 123.3,
    county_fips: 51015,
    county_name: "Augusta",
    county_weights: {
      51015: 99.9,
      51790: 0.1,
    },
    county_names_all: "Augusta|Staunton",
    county_fips_all: "51015|51790",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24483,
    lat: 37.81484,
    lng: -79.2256,
    city: "Vesuvius",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 846,
    density: 4.6,
    county_fips: 51163,
    county_name: "Rockbridge",
    county_weights: {
      51009: 35.97,
      51125: 2.92,
      51163: 61.11,
    },
    county_names_all: "Rockbridge|Amherst|Nelson",
    county_fips_all: "51163|51009|51125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24484,
    lat: 38.1448,
    lng: -79.82013,
    city: "Warm Springs",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 556,
    density: 1.2,
    county_fips: 51017,
    county_name: "Bath",
    county_weights: {
      51017: 88.69,
      51091: 11.31,
    },
    county_names_all: "Bath|Highland",
    county_fips_all: "51017|51091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24485,
    lat: 38.27521,
    lng: -79.33165,
    city: "West Augusta",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 405,
    density: 1.8,
    county_fips: 51015,
    county_name: "Augusta",
    county_weights: {
      51015: 100,
    },
    county_names_all: "Augusta",
    county_fips_all: 51015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24486,
    lat: 38.29366,
    lng: -78.92925,
    city: "Weyers Cave",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3269,
    density: 52.2,
    county_fips: 51015,
    county_name: "Augusta",
    county_weights: {
      51015: 90.8,
      51165: 9.2,
    },
    county_names_all: "Augusta|Rockingham",
    county_fips_all: "51015|51165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24487,
    lat: 38.20099,
    lng: -79.58105,
    city: "Williamsville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 379,
    density: 1.6,
    county_fips: 51091,
    county_name: "Highland",
    county_weights: {
      51017: 40.75,
      51091: 59.25,
    },
    county_names_all: "Highland|Bath",
    county_fips_all: "51091|51017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24501,
    lat: 37.35565,
    lng: -79.15608,
    city: "Lynchburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27828,
    density: 295.7,
    county_fips: 51031,
    county_name: "Campbell",
    county_weights: {
      51031: 62.75,
      51680: 37.25,
    },
    county_names_all: "Campbell|Lynchburg",
    county_fips_all: "51031|51680",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24502,
    lat: 37.35624,
    lng: -79.2194,
    city: "Lynchburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45450,
    density: 586.8,
    county_fips: 51680,
    county_name: "Lynchburg",
    county_weights: {
      51019: 4.26,
      51031: 38.36,
      51680: 57.38,
    },
    county_names_all: "Lynchburg|Campbell|Bedford",
    county_fips_all: "51680|51031|51019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24503,
    lat: 37.45272,
    lng: -79.24286,
    city: "Lynchburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19682,
    density: 206.9,
    county_fips: 51019,
    county_name: "Bedford",
    county_weights: {
      51019: 65.34,
      51680: 34.66,
    },
    county_names_all: "Bedford|Lynchburg",
    county_fips_all: "51019|51680",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24504,
    lat: 37.36673,
    lng: -79.04953,
    city: "Lynchburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9331,
    density: 96,
    county_fips: 51031,
    county_name: "Campbell",
    county_weights: {
      51011: 9.28,
      51031: 78.27,
      51680: 12.44,
    },
    county_names_all: "Campbell|Lynchburg|Appomattox",
    county_fips_all: "51031|51680|51011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24515,
    lat: 37.35261,
    lng: -79.17827,
    city: "Lynchburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 51680,
    county_name: "Lynchburg",
    county_weights: {
      51031: 0.45,
      51680: 99.55,
    },
    county_names_all: "Lynchburg|Campbell",
    county_fips_all: "51680|51031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24517,
    lat: 37.14532,
    lng: -79.23258,
    city: "Altavista",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4958,
    density: 58.7,
    county_fips: 51031,
    county_name: "Campbell",
    county_weights: {
      51031: 100,
    },
    county_names_all: "Campbell",
    county_fips_all: 51031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24520,
    lat: 36.58486,
    lng: -79.03752,
    city: "Alton",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2158,
    density: 8.8,
    county_fips: 51083,
    county_name: "Halifax",
    county_weights: {
      51083: 100,
    },
    county_names_all: "Halifax",
    county_fips_all: 51083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24521,
    lat: 37.63672,
    lng: -79.09539,
    city: "Amherst",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9184,
    density: 16.3,
    county_fips: 51009,
    county_name: "Amherst",
    county_weights: {
      51009: 95.77,
      51125: 4.23,
    },
    county_names_all: "Amherst|Nelson",
    county_fips_all: "51009|51125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24522,
    lat: 37.37324,
    lng: -78.78591,
    city: "Appomattox",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9230,
    density: 17.8,
    county_fips: 51011,
    county_name: "Appomattox",
    county_weights: {
      51011: 96.26,
      51029: 3.48,
      51037: 0.26,
    },
    county_names_all: "Appomattox|Buckingham|Charlotte",
    county_fips_all: "51011|51029|51037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24523,
    lat: 37.3364,
    lng: -79.52347,
    city: "Bedford",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20791,
    density: 34.9,
    county_fips: 51019,
    county_name: "Bedford",
    county_weights: {
      51019: 100,
    },
    county_names_all: "Bedford",
    county_fips_all: 51019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24526,
    lat: 37.55452,
    lng: -79.40169,
    city: "Big Island",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1431,
    density: 7.8,
    county_fips: 51019,
    county_name: "Bedford",
    county_weights: {
      51009: 28.64,
      51019: 71.36,
    },
    county_names_all: "Bedford|Amherst",
    county_fips_all: "51019|51009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24527,
    lat: 36.7324,
    lng: -79.34577,
    city: "Blairs",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3141,
    density: 39.2,
    county_fips: 51143,
    county_name: "Pittsylvania",
    county_weights: {
      51143: 100,
    },
    county_names_all: "Pittsylvania",
    county_fips_all: 51143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24528,
    lat: 37.07733,
    lng: -78.8777,
    city: "Brookneal",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3530,
    density: 13.7,
    county_fips: 51031,
    county_name: "Campbell",
    county_weights: {
      51031: 56.86,
      51037: 43.14,
    },
    county_names_all: "Campbell|Charlotte",
    county_fips_all: "51031|51037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24529,
    lat: 36.62452,
    lng: -78.64001,
    city: "Buffalo Junction",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1602,
    density: 16.9,
    county_fips: 51117,
    county_name: "Mecklenburg",
    county_weights: {
      51117: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 51117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24530,
    lat: 36.80785,
    lng: -79.61044,
    city: "Callands",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 876,
    density: 9.4,
    county_fips: 51143,
    county_name: "Pittsylvania",
    county_weights: {
      51089: 9.71,
      51143: 90.29,
    },
    county_names_all: "Pittsylvania|Henry",
    county_fips_all: "51143|51089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24531,
    lat: 36.83922,
    lng: -79.44332,
    city: "Chatham",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8697,
    density: 17.1,
    county_fips: 51143,
    county_name: "Pittsylvania",
    county_weights: {
      51143: 100,
    },
    county_names_all: "Pittsylvania",
    county_fips_all: 51143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24534,
    lat: 36.87835,
    lng: -78.76691,
    city: "Clover",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1281,
    density: 8.6,
    county_fips: 51083,
    county_name: "Halifax",
    county_weights: {
      51083: 100,
    },
    county_names_all: "Halifax",
    county_fips_all: 51083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24536,
    lat: 37.48996,
    lng: -79.32097,
    city: "Coleman Falls",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 223,
    density: 9.1,
    county_fips: 51019,
    county_name: "Bedford",
    county_weights: {
      51019: 100,
    },
    county_names_all: "Bedford",
    county_fips_all: 51019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24538,
    lat: 37.32908,
    lng: -78.95367,
    city: "Concord",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5601,
    density: 24.9,
    county_fips: 51031,
    county_name: "Campbell",
    county_weights: {
      51011: 39.79,
      51031: 60.21,
    },
    county_names_all: "Campbell|Appomattox",
    county_fips_all: "51031|51011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24539,
    lat: 36.85376,
    lng: -78.90728,
    city: "Crystal Hill",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 135,
    density: 5.2,
    county_fips: 51083,
    county_name: "Halifax",
    county_weights: {
      51083: 100,
    },
    county_names_all: "Halifax",
    county_fips_all: 51083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24540,
    lat: 36.64235,
    lng: -79.42473,
    city: "Danville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31257,
    density: 160.8,
    county_fips: 51143,
    county_name: "Pittsylvania",
    county_weights: {
      51143: 76.94,
      51590: 23.06,
    },
    county_names_all: "Pittsylvania|Danville",
    county_fips_all: "51143|51590",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24541,
    lat: 36.59072,
    lng: -79.51572,
    city: "Danville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27452,
    density: 141,
    county_fips: 51143,
    county_name: "Pittsylvania",
    county_weights: {
      51143: 65.48,
      51590: 34.52,
    },
    county_names_all: "Pittsylvania|Danville",
    county_fips_all: "51143|51590",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24549,
    lat: 36.71584,
    lng: -79.50632,
    city: "Dry Fork",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3885,
    density: 29.1,
    county_fips: 51143,
    county_name: "Pittsylvania",
    county_weights: {
      51143: 100,
    },
    county_names_all: "Pittsylvania",
    county_fips_all: 51143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24550,
    lat: 37.23493,
    lng: -79.26898,
    city: "Evington",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7870,
    density: 48,
    county_fips: 51031,
    county_name: "Campbell",
    county_weights: {
      51019: 12.43,
      51031: 87.57,
    },
    county_names_all: "Campbell|Bedford",
    county_fips_all: "51031|51019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24551,
    lat: 37.36655,
    lng: -79.3268,
    city: "Forest",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26654,
    density: 138.7,
    county_fips: 51019,
    county_name: "Bedford",
    county_weights: {
      51019: 97.23,
      51031: 2.42,
      51680: 0.35,
    },
    county_names_all: "Bedford|Campbell|Lynchburg",
    county_fips_all: "51019|51031|51680",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24553,
    lat: 37.54845,
    lng: -78.81907,
    city: "Gladstone",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2030,
    density: 5.8,
    county_fips: 51029,
    county_name: "Buckingham",
    county_weights: {
      51009: 18.12,
      51011: 16.58,
      51029: 44.07,
      51125: 21.22,
    },
    county_names_all: "Buckingham|Nelson|Amherst|Appomattox",
    county_fips_all: "51029|51125|51009|51011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24554,
    lat: 37.13674,
    lng: -79.06639,
    city: "Gladys",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3518,
    density: 10.8,
    county_fips: 51031,
    county_name: "Campbell",
    county_weights: {
      51031: 100,
    },
    county_names_all: "Campbell",
    county_fips_all: 51031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24555,
    lat: 37.6678,
    lng: -79.47007,
    city: "Glasgow",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2249,
    density: 38,
    county_fips: 51163,
    county_name: "Rockbridge",
    county_weights: {
      51163: 100,
    },
    county_names_all: "Rockbridge",
    county_fips_all: 51163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24556,
    lat: 37.38093,
    lng: -79.4021,
    city: "Goode",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2626,
    density: 25.6,
    county_fips: 51019,
    county_name: "Bedford",
    county_weights: {
      51019: 100,
    },
    county_names_all: "Bedford",
    county_fips_all: 51019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24557,
    lat: 36.9666,
    lng: -79.30401,
    city: "Gretna",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7773,
    density: 18.5,
    county_fips: 51143,
    county_name: "Pittsylvania",
    county_weights: {
      51083: 0.23,
      51143: 99.77,
    },
    county_names_all: "Pittsylvania|Halifax",
    county_fips_all: "51143|51083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24558,
    lat: 36.77914,
    lng: -78.95741,
    city: "Halifax",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6134,
    density: 24.9,
    county_fips: 51083,
    county_name: "Halifax",
    county_weights: {
      51083: 100,
    },
    county_names_all: "Halifax",
    county_fips_all: 51083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24562,
    lat: 37.70577,
    lng: -78.62241,
    city: "Howardsville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 661,
    density: 11.2,
    county_fips: 51029,
    county_name: "Buckingham",
    county_weights: {
      51003: 8,
      51029: 64.74,
      51125: 27.26,
    },
    county_names_all: "Buckingham|Nelson|Albemarle",
    county_fips_all: "51029|51125|51003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24563,
    lat: 37.06106,
    lng: -79.27385,
    city: "Hurt",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5164,
    density: 29,
    county_fips: 51143,
    county_name: "Pittsylvania",
    county_weights: {
      51143: 100,
    },
    county_names_all: "Pittsylvania",
    county_fips_all: 51143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24565,
    lat: 36.85259,
    lng: -79.18588,
    city: "Java",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1010,
    density: 6.7,
    county_fips: 51143,
    county_name: "Pittsylvania",
    county_weights: {
      51083: 16.19,
      51143: 83.81,
    },
    county_names_all: "Pittsylvania|Halifax",
    county_fips_all: "51143|51083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24566,
    lat: 36.72747,
    lng: -79.25069,
    city: "Keeling",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1260,
    density: 13.1,
    county_fips: 51143,
    county_name: "Pittsylvania",
    county_weights: {
      51143: 100,
    },
    county_names_all: "Pittsylvania",
    county_fips_all: 51143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24569,
    lat: 37.0463,
    lng: -79.12129,
    city: "Long Island",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1112,
    density: 12.7,
    county_fips: 51143,
    county_name: "Pittsylvania",
    county_weights: {
      51031: 19.05,
      51083: 18.82,
      51143: 62.13,
    },
    county_names_all: "Pittsylvania|Campbell|Halifax",
    county_fips_all: "51143|51031|51083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24570,
    lat: 37.3486,
    lng: -79.4272,
    city: "Lowry",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 51019,
    county_name: "Bedford",
    county_weights: {
      51019: 100,
    },
    county_names_all: "Bedford",
    county_fips_all: 51019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24571,
    lat: 37.13671,
    lng: -79.37983,
    city: "Lynch Station",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2270,
    density: 17.2,
    county_fips: 51031,
    county_name: "Campbell",
    county_weights: {
      51019: 39.73,
      51031: 60.27,
    },
    county_names_all: "Campbell|Bedford",
    county_fips_all: "51031|51019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24572,
    lat: 37.46514,
    lng: -79.09628,
    city: "Madison Heights",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16480,
    density: 95.9,
    county_fips: 51009,
    county_name: "Amherst",
    county_weights: {
      51009: 100,
    },
    county_names_all: "Amherst",
    county_fips_all: 51009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24574,
    lat: 37.57589,
    lng: -79.24714,
    city: "Monroe",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4345,
    density: 15.8,
    county_fips: 51009,
    county_name: "Amherst",
    county_weights: {
      51009: 100,
    },
    county_names_all: "Amherst",
    county_fips_all: 51009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24577,
    lat: 36.93762,
    lng: -78.97553,
    city: "Nathalie",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4479,
    density: 9.2,
    county_fips: 51083,
    county_name: "Halifax",
    county_weights: {
      51083: 100,
    },
    county_names_all: "Halifax",
    county_fips_all: 51083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24578,
    lat: 37.66269,
    lng: -79.55693,
    city: "Natural Bridge",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 948,
    density: 10.4,
    county_fips: 51163,
    county_name: "Rockbridge",
    county_weights: {
      51163: 100,
    },
    county_names_all: "Rockbridge",
    county_fips_all: 51163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24579,
    lat: 37.58763,
    lng: -79.50483,
    city: "Natural Bridge Station",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 948,
    density: 11,
    county_fips: 51163,
    county_name: "Rockbridge",
    county_weights: {
      51163: 100,
    },
    county_names_all: "Rockbridge",
    county_fips_all: 51163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24580,
    lat: 36.58328,
    lng: -78.68,
    city: "Nelson",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 578,
    density: 10.6,
    county_fips: 51117,
    county_name: "Mecklenburg",
    county_weights: {
      51117: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 51117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24581,
    lat: 37.65692,
    lng: -78.8098,
    city: "Norwood",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27,
    density: 3.2,
    county_fips: 51125,
    county_name: "Nelson",
    county_weights: {
      51125: 100,
    },
    county_names_all: "Nelson",
    county_fips_all: 51125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24586,
    lat: 36.60776,
    lng: -79.2828,
    city: "Ringgold",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5334,
    density: 38.4,
    county_fips: 51143,
    county_name: "Pittsylvania",
    county_weights: {
      51143: 100,
    },
    county_names_all: "Pittsylvania",
    county_fips_all: 51143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24588,
    lat: 37.26408,
    lng: -79.09997,
    city: "Rustburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9886,
    density: 52.9,
    county_fips: 51031,
    county_name: "Campbell",
    county_weights: {
      51031: 100,
    },
    county_names_all: "Campbell",
    county_fips_all: 51031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24589,
    lat: 36.75528,
    lng: -78.75555,
    city: "Scottsburg",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2656,
    density: 13.5,
    county_fips: 51083,
    county_name: "Halifax",
    county_weights: {
      51083: 100,
    },
    county_names_all: "Halifax",
    county_fips_all: 51083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24590,
    lat: 37.79353,
    lng: -78.47767,
    city: "Scottsville",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8179,
    density: 19.5,
    county_fips: 51029,
    county_name: "Buckingham",
    county_weights: {
      51003: 35.59,
      51029: 35.8,
      51065: 28.62,
    },
    county_names_all: "Buckingham|Albemarle|Fluvanna",
    county_fips_all: "51029|51003|51065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24592,
    lat: 36.67808,
    lng: -78.95474,
    city: "South Boston",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13669,
    density: 42,
    county_fips: 51083,
    county_name: "Halifax",
    county_weights: {
      51083: 99.66,
      51143: 0.34,
    },
    county_names_all: "Halifax|Pittsylvania",
    county_fips_all: "51083|51143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24593,
    lat: 37.32651,
    lng: -78.91342,
    city: "Spout Spring",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2562,
    density: 28.3,
    county_fips: 51011,
    county_name: "Appomattox",
    county_weights: {
      51011: 98.08,
      51031: 1.92,
    },
    county_names_all: "Appomattox|Campbell",
    county_fips_all: "51011|51031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24594,
    lat: 36.64217,
    lng: -79.18504,
    city: "Sutherlin",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1387,
    density: 9.7,
    county_fips: 51083,
    county_name: "Halifax",
    county_weights: {
      51083: 57.48,
      51143: 42.52,
    },
    county_names_all: "Halifax|Pittsylvania",
    county_fips_all: "51083|51143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24595,
    lat: 37.55904,
    lng: -79.08421,
    city: "Sweet Briar",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 608,
    density: 155.6,
    county_fips: 51009,
    county_name: "Amherst",
    county_weights: {
      51009: 100,
    },
    county_names_all: "Amherst",
    county_fips_all: 51009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24597,
    lat: 36.78553,
    lng: -79.1095,
    city: "Vernon Hill",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1088,
    density: 8.5,
    county_fips: 51083,
    county_name: "Halifax",
    county_weights: {
      51083: 87.23,
      51143: 12.77,
    },
    county_names_all: "Halifax|Pittsylvania",
    county_fips_all: "51083|51143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24598,
    lat: 36.60521,
    lng: -78.7828,
    city: "Virgilina",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1596,
    density: 8.3,
    county_fips: 51083,
    county_name: "Halifax",
    county_weights: {
      51083: 96.37,
      51117: 3.63,
    },
    county_names_all: "Halifax|Mecklenburg",
    county_fips_all: "51083|51117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24599,
    lat: 37.63289,
    lng: -78.72452,
    city: "Wingina",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 883,
    density: 7,
    county_fips: 51029,
    county_name: "Buckingham",
    county_weights: {
      51029: 52.19,
      51125: 47.81,
    },
    county_names_all: "Buckingham|Nelson",
    county_fips_all: "51029|51125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24601,
    lat: 37.19068,
    lng: -81.64049,
    city: "Amonate",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 51185,
    county_name: "Tazewell",
    county_weights: {
      51185: 100,
    },
    county_names_all: "Tazewell",
    county_fips_all: 51185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24602,
    lat: 37.18383,
    lng: -81.65762,
    city: "Bandy",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 803,
    density: 5.8,
    county_fips: 51185,
    county_name: "Tazewell",
    county_weights: {
      51185: 100,
    },
    county_names_all: "Tazewell",
    county_fips_all: 51185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24603,
    lat: 37.35607,
    lng: -82.1914,
    city: "Big Rock",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 743,
    density: 14.4,
    county_fips: 51027,
    county_name: "Buchanan",
    county_weights: {
      51027: 100,
    },
    county_names_all: "Buchanan",
    county_fips_all: 51027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24604,
    lat: 37.21088,
    lng: -81.54378,
    city: "Bishop",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 138,
    density: 14.2,
    county_fips: 51185,
    county_name: "Tazewell",
    county_weights: {
      51185: 79.37,
      54047: 20.63,
    },
    county_names_all: "Tazewell|McDowell",
    county_fips_all: "51185|54047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24605,
    lat: 37.24093,
    lng: -81.36123,
    city: "Bluefield",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7965,
    density: 62.7,
    county_fips: 51185,
    county_name: "Tazewell",
    county_weights: {
      51185: 100,
    },
    county_names_all: "Tazewell",
    county_fips_all: 51185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24606,
    lat: 37.28814,
    lng: -81.39183,
    city: "Boissevain",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 130,
    density: 21.4,
    county_fips: 51185,
    county_name: "Tazewell",
    county_weights: {
      51185: 100,
    },
    county_names_all: "Tazewell",
    county_fips_all: 51185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24607,
    lat: 37.29498,
    lng: -82.26533,
    city: "Breaks",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 271,
    density: 7.3,
    county_fips: 51027,
    county_name: "Buchanan",
    county_weights: {
      51027: 62.4,
      51051: 37.6,
    },
    county_names_all: "Buchanan|Dickenson",
    county_fips_all: "51027|51051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24609,
    lat: 37.02955,
    lng: -81.795,
    city: "Cedar Bluff",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6351,
    density: 29.3,
    county_fips: 51185,
    county_name: "Tazewell",
    county_weights: {
      51167: 49.57,
      51185: 50.43,
    },
    county_names_all: "Tazewell|Russell",
    county_fips_all: "51185|51167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24612,
    lat: 37.09728,
    lng: -81.84461,
    city: "Doran",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 153,
    density: 54.5,
    county_fips: 51185,
    county_name: "Tazewell",
    county_weights: {
      51185: 100,
    },
    county_names_all: "Tazewell",
    county_fips_all: 51185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24613,
    lat: 37.262,
    lng: -81.3385,
    city: "Falls Mills",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 636,
    density: 20.8,
    county_fips: 51185,
    county_name: "Tazewell",
    county_weights: {
      51185: 100,
    },
    county_names_all: "Tazewell",
    county_fips_all: 51185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24614,
    lat: 37.31466,
    lng: -82.07181,
    city: "Grundy",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6488,
    density: 18.9,
    county_fips: 51027,
    county_name: "Buchanan",
    county_weights: {
      51027: 100,
    },
    county_names_all: "Buchanan",
    county_fips_all: 51027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24620,
    lat: 37.43335,
    lng: -82.01932,
    city: "Hurley",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3288,
    density: 17.8,
    county_fips: 51027,
    county_name: "Buchanan",
    county_weights: {
      51027: 100,
    },
    county_names_all: "Buchanan",
    county_fips_all: 51027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24622,
    lat: 37.22005,
    lng: -81.79638,
    city: "Jewell Ridge",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 539,
    density: 3.8,
    county_fips: 51027,
    county_name: "Buchanan",
    county_weights: {
      51027: 53.21,
      51185: 34.1,
      54047: 12.69,
    },
    county_names_all: "Buchanan|Tazewell|McDowell",
    county_fips_all: "51027|51185|54047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24630,
    lat: 37.17292,
    lng: -81.4782,
    city: "North Tazewell",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6903,
    density: 39.9,
    county_fips: 51185,
    county_name: "Tazewell",
    county_weights: {
      51185: 100,
    },
    county_names_all: "Tazewell",
    county_fips_all: 51185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24631,
    lat: 37.2202,
    lng: -81.99714,
    city: "Oakwood",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2263,
    density: 16.3,
    county_fips: 51027,
    county_name: "Buchanan",
    county_weights: {
      51027: 100,
    },
    county_names_all: "Buchanan",
    county_fips_all: 51027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24634,
    lat: 37.27411,
    lng: -81.90253,
    city: "Pilgrims Knob",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 422,
    density: 11,
    county_fips: 51027,
    county_name: "Buchanan",
    county_weights: {
      51027: 100,
    },
    county_names_all: "Buchanan",
    county_fips_all: 51027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24635,
    lat: 37.30683,
    lng: -81.34962,
    city: "Pocahontas",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1407,
    density: 81.1,
    county_fips: 51185,
    county_name: "Tazewell",
    county_weights: {
      51185: 100,
    },
    county_names_all: "Tazewell",
    county_fips_all: 51185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24637,
    lat: 37.05258,
    lng: -81.70981,
    city: "Pounding Mill",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3954,
    density: 47.7,
    county_fips: 51185,
    county_name: "Tazewell",
    county_weights: {
      51185: 100,
    },
    county_names_all: "Tazewell",
    county_fips_all: 51185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24639,
    lat: 37.17357,
    lng: -81.90461,
    city: "Raven",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4025,
    density: 32.4,
    county_fips: 51027,
    county_name: "Buchanan",
    county_weights: {
      51027: 72,
      51167: 4.13,
      51185: 23.87,
    },
    county_names_all: "Buchanan|Tazewell|Russell",
    county_fips_all: "51027|51185|51167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24641,
    lat: 37.11797,
    lng: -81.80802,
    city: "Richlands",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5532,
    density: 110.4,
    county_fips: 51185,
    county_name: "Tazewell",
    county_weights: {
      51185: 100,
    },
    county_names_all: "Tazewell",
    county_fips_all: 51185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24646,
    lat: 37.13751,
    lng: -82.02976,
    city: "Rowe",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 765,
    density: 23.4,
    county_fips: 51027,
    county_name: "Buchanan",
    county_weights: {
      51027: 100,
    },
    county_names_all: "Buchanan",
    county_fips_all: 51027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24649,
    lat: 37.08303,
    lng: -81.92198,
    city: "Swords Creek",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2761,
    density: 32.9,
    county_fips: 51167,
    county_name: "Russell",
    county_weights: {
      51027: 0.71,
      51167: 99.29,
    },
    county_names_all: "Russell|Buchanan",
    county_fips_all: "51167|51027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24651,
    lat: 37.07732,
    lng: -81.50054,
    city: "Tazewell",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5346,
    density: 13.6,
    county_fips: 51185,
    county_name: "Tazewell",
    county_weights: {
      51185: 100,
    },
    county_names_all: "Tazewell",
    county_fips_all: 51185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24656,
    lat: 37.1743,
    lng: -82.12364,
    city: "Vansant",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2495,
    density: 13.8,
    county_fips: 51027,
    county_name: "Buchanan",
    county_weights: {
      51027: 100,
    },
    county_names_all: "Buchanan",
    county_fips_all: 51027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24657,
    lat: 37.22363,
    lng: -81.84737,
    city: "Whitewood",
    state_id: "VA",
    state_name: "Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 504,
    density: 12.1,
    county_fips: 51027,
    county_name: "Buchanan",
    county_weights: {
      51027: 100,
    },
    county_names_all: "Buchanan",
    county_fips_all: 51027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24701,
    lat: 37.29929,
    lng: -81.2065,
    city: "Bluefield",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18517,
    density: 116.8,
    county_fips: 54055,
    county_name: "Mercer",
    county_weights: {
      54055: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 54055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24712,
    lat: 37.46903,
    lng: -81.02029,
    city: "Athens",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2124,
    density: 69.2,
    county_fips: 54055,
    county_name: "Mercer",
    county_weights: {
      54055: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 54055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24714,
    lat: 37.47627,
    lng: -81.18352,
    city: "Beeson",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 135,
    density: 3.8,
    county_fips: 54055,
    county_name: "Mercer",
    county_weights: {
      54055: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 54055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24715,
    lat: 37.33408,
    lng: -81.32933,
    city: "Bramwell",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 399,
    density: 19.2,
    county_fips: 54055,
    county_name: "Mercer",
    county_weights: {
      54055: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 54055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24716,
    lat: 37.53331,
    lng: -81.37337,
    city: "Bud",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 308,
    density: 40.5,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24719,
    lat: 37.48722,
    lng: -81.32652,
    city: "Covel",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25,
    density: 9.5,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24724,
    lat: 37.33603,
    lng: -81.31579,
    city: "Freeman",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54055,
    county_name: "Mercer",
    county_weights: {
      54055: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 54055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24726,
    lat: 37.52084,
    lng: -81.37229,
    city: "Herndon",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 711,
    density: 5.5,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24729,
    lat: 37.44759,
    lng: -81.24699,
    city: "Hiawatha",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 225,
    density: 10.9,
    county_fips: 54055,
    county_name: "Mercer",
    county_weights: {
      54055: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 54055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24731,
    lat: 37.39733,
    lng: -81.15162,
    city: "Kegley",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 139,
    density: 41.1,
    county_fips: 54055,
    county_name: "Mercer",
    county_weights: {
      54055: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 54055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24733,
    lat: 37.44986,
    lng: -81.20094,
    city: "Lashmeet",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 373,
    density: 42.6,
    county_fips: 54055,
    county_name: "Mercer",
    county_weights: {
      54055: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 54055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24736,
    lat: 37.45045,
    lng: -81.29589,
    city: "Matoaka",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 467,
    density: 6.4,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54055: 47.98,
      54109: 52.02,
    },
    county_names_all: "Wyoming|Mercer",
    county_fips_all: "54109|54055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24737,
    lat: 37.35042,
    lng: -81.26055,
    city: "Montcalm",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54055,
    county_name: "Mercer",
    county_weights: {
      54055: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 54055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24738,
    lat: 37.3032,
    lng: -81.32013,
    city: "Nemours",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 313,
    density: 708.2,
    county_fips: 54055,
    county_name: "Mercer",
    county_weights: {
      54055: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 54055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24739,
    lat: 37.36784,
    lng: -80.9949,
    city: "Princeton",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54055,
    county_name: "Mercer",
    county_weights: {
      54055: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 54055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24740,
    lat: 37.4042,
    lng: -81.10205,
    city: "Princeton",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30721,
    density: 387.3,
    county_fips: 54055,
    county_name: "Mercer",
    county_weights: {
      54055: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 54055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24747,
    lat: 37.40182,
    lng: -81.2273,
    city: "Rock",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3330,
    density: 30.1,
    county_fips: 54055,
    county_name: "Mercer",
    county_weights: {
      54047: 2.73,
      54055: 97.27,
    },
    county_names_all: "Mercer|McDowell",
    county_fips_all: "54055|54047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24801,
    lat: 37.46841,
    lng: -81.55544,
    city: "Welch",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4403,
    density: 16,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54047: 47.2,
      54109: 52.8,
    },
    county_names_all: "Wyoming|McDowell",
    county_fips_all: "54109|54047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24808,
    lat: 37.33142,
    lng: -81.41048,
    city: "Anawalt",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 488,
    density: 11.3,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24811,
    lat: 37.40881,
    lng: -81.75381,
    city: "Avondale",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 533,
    density: 6.5,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24813,
    lat: 37.35954,
    lng: -81.72489,
    city: "Bartley",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24815,
    lat: 37.22036,
    lng: -81.63026,
    city: "Berwind",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 633,
    density: 20.4,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24816,
    lat: 37.46139,
    lng: -81.70516,
    city: "Big Sandy",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26,
    density: 21.1,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24817,
    lat: 37.34206,
    lng: -81.81721,
    city: "Bradshaw",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 904,
    density: 15.4,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24818,
    lat: 37.60809,
    lng: -81.62275,
    city: "Brenton",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1056,
    density: 15.8,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24822,
    lat: 37.62908,
    lng: -81.68755,
    city: "Clear Fork",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 913,
    density: 17.8,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24823,
    lat: 37.66761,
    lng: -81.74105,
    city: "Coal Mountain",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 465,
    density: 16.8,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24826,
    lat: 37.29212,
    lng: -81.62411,
    city: "Cucumber",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38,
    density: 3,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24827,
    lat: 37.75186,
    lng: -81.65997,
    city: "Cyclone",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1334,
    density: 17.4,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24828,
    lat: 37.49975,
    lng: -81.6553,
    city: "Davy",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 643,
    density: 16.6,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 86.26,
      54109: 13.74,
    },
    county_names_all: "McDowell|Wyoming",
    county_fips_all: "54047|54109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24830,
    lat: 37.33399,
    lng: -81.55799,
    city: "Elbert",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24831,
    lat: 37.38943,
    lng: -81.44085,
    city: "Elkhorn",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 209,
    density: 6.2,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24834,
    lat: 37.54313,
    lng: -81.66093,
    city: "Fanrock",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 496,
    density: 10.5,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24836,
    lat: 37.36846,
    lng: -81.54908,
    city: "Gary",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 649,
    density: 30.6,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24839,
    lat: 37.58216,
    lng: -81.76504,
    city: "Hanover",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1266,
    density: 29,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24843,
    lat: 37.48378,
    lng: -81.70923,
    city: "Hensley",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 72,
    density: 8.5,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24844,
    lat: 37.48554,
    lng: -81.78703,
    city: "Iaeger",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1021,
    density: 6.9,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 71.52,
      54109: 28.48,
    },
    county_names_all: "McDowell|Wyoming",
    county_fips_all: "54047|54109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24845,
    lat: 37.52643,
    lng: -81.80041,
    city: "Ikes Fork",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 351,
    density: 18.6,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24846,
    lat: 37.52611,
    lng: -81.89175,
    city: "Isaban",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 128,
    density: 5.1,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 63.88,
      54059: 36.12,
    },
    county_names_all: "McDowell|Mingo",
    county_fips_all: "54047|54059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24847,
    lat: 37.57339,
    lng: -81.41455,
    city: "Itmann",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 206,
    density: 80.5,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24848,
    lat: 37.28206,
    lng: -81.43413,
    city: "Jenkinjones",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 227,
    density: 44.5,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24849,
    lat: 37.67435,
    lng: -81.55848,
    city: "Jesse",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 236,
    density: 9.8,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24850,
    lat: 37.37807,
    lng: -81.88516,
    city: "Jolo",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24851,
    lat: 37.59922,
    lng: -81.83805,
    city: "Justice",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 584,
    density: 169.7,
    county_fips: 54059,
    county_name: "Mingo",
    county_weights: {
      54059: 99.09,
      54109: 0.91,
    },
    county_names_all: "Mingo|Wyoming",
    county_fips_all: "54059|54109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24853,
    lat: 37.42924,
    lng: -81.51686,
    city: "Kimball",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 237,
    density: 4.3,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24854,
    lat: 37.73997,
    lng: -81.5789,
    city: "Kopperston",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 263,
    density: 11.6,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24855,
    lat: 37.40882,
    lng: -81.42499,
    city: "Kyle",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24857,
    lat: 37.69591,
    lng: -81.67557,
    city: "Lynco",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 917,
    density: 19.8,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24860,
    lat: 37.65919,
    lng: -81.59075,
    city: "Matheny",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 170,
    density: 11.1,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24861,
    lat: 37.36182,
    lng: -81.36525,
    city: "Maybeury",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58,
    density: 6,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24862,
    lat: 37.47905,
    lng: -81.9489,
    city: "Mohawk",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 579,
    density: 18,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24866,
    lat: 37.25216,
    lng: -81.59925,
    city: "Newhall",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 474,
    density: 10.1,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24867,
    lat: 37.60432,
    lng: -81.45261,
    city: "New Richmond",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 350,
    density: 8.4,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24868,
    lat: 37.42412,
    lng: -81.40259,
    city: "Northfork",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1176,
    density: 13.5,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24869,
    lat: 37.56133,
    lng: -81.82315,
    city: "North Spring",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 228,
    density: 11.8,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54047: 0.14,
      54109: 99.86,
    },
    county_names_all: "Wyoming|McDowell",
    county_fips_all: "54109|54047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24870,
    lat: 37.73784,
    lng: -81.53203,
    city: "Oceana",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2309,
    density: 25.6,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24871,
    lat: 37.31693,
    lng: -81.48552,
    city: "Pageton",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 460,
    density: 5.1,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24872,
    lat: 37.44986,
    lng: -81.8932,
    city: "Panther",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 626,
    density: 7.3,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24873,
    lat: 37.35734,
    lng: -81.87415,
    city: "Paynesville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 594,
    density: 24.3,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24874,
    lat: 37.60201,
    lng: -81.53072,
    city: "Pineville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2919,
    density: 51.4,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24878,
    lat: 37.4321,
    lng: -81.63086,
    city: "Premier",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 277,
    density: 10.6,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24879,
    lat: 37.31639,
    lng: -81.76725,
    city: "Raysal",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 436,
    density: 36.9,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24880,
    lat: 37.64679,
    lng: -81.53187,
    city: "Rock View",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 428,
    density: 38.1,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24881,
    lat: 37.44435,
    lng: -81.68785,
    city: "Roderfield",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 285,
    density: 8,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24882,
    lat: 37.62771,
    lng: -81.76623,
    city: "Simon",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 689,
    density: 20.2,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24884,
    lat: 37.27943,
    lng: -81.55048,
    city: "Squire",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 177,
    density: 3.1,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24887,
    lat: 37.37808,
    lng: -81.38664,
    city: "Switchback",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52,
    density: 25.7,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24888,
    lat: 37.36195,
    lng: -81.48876,
    city: "Thorpe",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55,
    density: 4.5,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24892,
    lat: 37.31691,
    lng: -81.69699,
    city: "War",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1678,
    density: 17,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24894,
    lat: 37.25186,
    lng: -81.69052,
    city: "Warriormine",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 172,
    density: 3.9,
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24895,
    lat: 37.37718,
    lng: -81.58208,
    city: "Wilcoe",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54047,
    county_name: "McDowell",
    county_weights: {
      54047: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 54047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24898,
    lat: 37.58752,
    lng: -81.57504,
    city: "Wyoming",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24901,
    lat: 37.85298,
    lng: -80.47598,
    city: "Lewisburg",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9958,
    density: 41.2,
    county_fips: 54025,
    county_name: "Greenbrier",
    county_weights: {
      54025: 100,
    },
    county_names_all: "Greenbrier",
    county_fips_all: 54025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24910,
    lat: 37.74173,
    lng: -80.66835,
    city: "Alderson",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4926,
    density: 14.1,
    county_fips: 54025,
    county_name: "Greenbrier",
    county_weights: {
      54025: 44.38,
      54063: 23.03,
      54089: 32.59,
    },
    county_names_all: "Greenbrier|Summers|Monroe",
    county_fips_all: "54025|54089|54063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24915,
    lat: 38.4693,
    lng: -79.78668,
    city: "Arbovale",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 566,
    density: 5.1,
    county_fips: 54075,
    county_name: "Pocahontas",
    county_weights: {
      54075: 100,
    },
    county_names_all: "Pocahontas",
    county_fips_all: 54075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24916,
    lat: 37.82735,
    lng: -80.57735,
    city: "Asbury",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 917,
    density: 21.7,
    county_fips: 54025,
    county_name: "Greenbrier",
    county_weights: {
      54025: 100,
    },
    county_names_all: "Greenbrier",
    county_fips_all: 54025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24918,
    lat: 37.51793,
    lng: -80.75461,
    city: "Ballard",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2264,
    density: 23.5,
    county_fips: 54063,
    county_name: "Monroe",
    county_weights: {
      54063: 99.16,
      54089: 0.84,
    },
    county_names_all: "Monroe|Summers",
    county_fips_all: "54063|54089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24920,
    lat: 38.58918,
    lng: -79.71723,
    city: "Bartow",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 199,
    density: 0.8,
    county_fips: 54075,
    county_name: "Pocahontas",
    county_weights: {
      54075: 100,
    },
    county_names_all: "Pocahontas",
    county_fips_all: 54075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24924,
    lat: 38.19294,
    lng: -80.15174,
    city: "Buckeye",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 314,
    density: 6.7,
    county_fips: 54075,
    county_name: "Pocahontas",
    county_weights: {
      54075: 100,
    },
    county_names_all: "Pocahontas",
    county_fips_all: 54075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24925,
    lat: 37.72919,
    lng: -80.38348,
    city: "Caldwell",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 447,
    density: 4.4,
    county_fips: 54025,
    county_name: "Greenbrier",
    county_weights: {
      54025: 73.53,
      54063: 26.47,
    },
    county_names_all: "Greenbrier|Monroe",
    county_fips_all: "54025|54063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24927,
    lat: 38.38999,
    lng: -79.965,
    city: "Cass",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 395,
    density: 2.2,
    county_fips: 54075,
    county_name: "Pocahontas",
    county_weights: {
      54075: 100,
    },
    county_names_all: "Pocahontas",
    county_fips_all: 54075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24931,
    lat: 37.91471,
    lng: -80.59355,
    city: "Crawley",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 997,
    density: 8,
    county_fips: 54025,
    county_name: "Greenbrier",
    county_weights: {
      54025: 100,
    },
    county_names_all: "Greenbrier",
    county_fips_all: 54025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24934,
    lat: 38.32836,
    lng: -79.89267,
    city: "Dunmore",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 301,
    density: 1.6,
    county_fips: 54075,
    county_name: "Pocahontas",
    county_weights: {
      54075: 100,
    },
    county_names_all: "Pocahontas",
    county_fips_all: 54075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24935,
    lat: 37.56362,
    lng: -80.80344,
    city: "Forest Hill",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 417,
    density: 7.5,
    county_fips: 54089,
    county_name: "Summers",
    county_weights: {
      54089: 100,
    },
    county_names_all: "Summers",
    county_fips_all: 54089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24938,
    lat: 37.92516,
    lng: -80.38083,
    city: "Frankford",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1511,
    density: 19.7,
    county_fips: 54025,
    county_name: "Greenbrier",
    county_weights: {
      54025: 100,
    },
    county_names_all: "Greenbrier",
    county_fips_all: 54025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24941,
    lat: 37.58824,
    lng: -80.3577,
    city: "Gap Mills",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1124,
    density: 5.5,
    county_fips: 54063,
    county_name: "Monroe",
    county_weights: {
      54063: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 54063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24943,
    lat: 37.83632,
    lng: -80.72709,
    city: "Grassy Meadows",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54025,
    county_name: "Greenbrier",
    county_weights: {
      54025: 100,
    },
    county_names_all: "Greenbrier",
    county_fips_all: 54025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24944,
    lat: 38.39926,
    lng: -79.77108,
    city: "Green Bank",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 431,
    density: 4.5,
    county_fips: 54075,
    county_name: "Pocahontas",
    county_weights: {
      54075: 100,
    },
    county_names_all: "Pocahontas",
    county_fips_all: 54075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24945,
    lat: 37.54113,
    lng: -80.68795,
    city: "Greenville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 270,
    density: 5.4,
    county_fips: 54063,
    county_name: "Monroe",
    county_weights: {
      54063: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 54063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24946,
    lat: 38.17891,
    lng: -80.2671,
    city: "Hillsboro",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1062,
    density: 2.4,
    county_fips: 54075,
    county_name: "Pocahontas",
    county_weights: {
      54075: 100,
    },
    county_names_all: "Pocahontas",
    county_fips_all: 54075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24951,
    lat: 37.48358,
    lng: -80.63103,
    city: "Lindside",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1732,
    density: 12.8,
    county_fips: 54063,
    county_name: "Monroe",
    county_weights: {
      54063: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 54063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24954,
    lat: 38.22932,
    lng: -80.07436,
    city: "Marlinton",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4209,
    density: 5.6,
    county_fips: 54075,
    county_name: "Pocahontas",
    county_weights: {
      54075: 100,
    },
    county_names_all: "Pocahontas",
    county_fips_all: 54075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24957,
    lat: 37.88729,
    lng: -80.40827,
    city: "Maxwelton",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 208,
    density: 9.9,
    county_fips: 54025,
    county_name: "Greenbrier",
    county_weights: {
      54025: 100,
    },
    county_names_all: "Greenbrier",
    county_fips_all: 54025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24962,
    lat: 37.66029,
    lng: -80.72041,
    city: "Pence Springs",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 115,
    density: 15.2,
    county_fips: 54089,
    county_name: "Summers",
    county_weights: {
      54089: 100,
    },
    county_names_all: "Summers",
    county_fips_all: 54089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24963,
    lat: 37.43743,
    lng: -80.77617,
    city: "Peterstown",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3679,
    density: 28.3,
    county_fips: 54063,
    county_name: "Monroe",
    county_weights: {
      54063: 82,
      54089: 18,
    },
    county_names_all: "Monroe|Summers",
    county_fips_all: "54063|54089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24966,
    lat: 38.03345,
    lng: -80.35283,
    city: "Renick",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1327,
    density: 4.3,
    county_fips: 54025,
    county_name: "Greenbrier",
    county_weights: {
      54025: 100,
    },
    county_names_all: "Greenbrier",
    county_fips_all: 54025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24970,
    lat: 37.73238,
    lng: -80.47574,
    city: "Ronceverte",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4566,
    density: 46.3,
    county_fips: 54025,
    county_name: "Greenbrier",
    county_weights: {
      54025: 96.05,
      54063: 3.95,
    },
    county_names_all: "Greenbrier|Monroe",
    county_fips_all: "54025|54063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24974,
    lat: 37.65395,
    lng: -80.44693,
    city: "Secondcreekx",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 352,
    density: 20.2,
    county_fips: 54063,
    county_name: "Monroe",
    county_weights: {
      54063: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 54063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24976,
    lat: 37.66513,
    lng: -80.52273,
    city: "Sinks Grove",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 891,
    density: 9.2,
    county_fips: 54063,
    county_name: "Monroe",
    county_weights: {
      54025: 9.64,
      54063: 90.36,
    },
    county_names_all: "Monroe|Greenbrier",
    county_fips_all: "54063|54025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24977,
    lat: 37.90823,
    lng: -80.67527,
    city: "Smoot",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 323,
    density: 6.7,
    county_fips: 54025,
    county_name: "Greenbrier",
    county_weights: {
      54025: 100,
    },
    county_names_all: "Greenbrier",
    county_fips_all: 54025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24981,
    lat: 37.63256,
    lng: -80.73968,
    city: "Talcott",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 541,
    density: 26.6,
    county_fips: 54089,
    county_name: "Summers",
    county_weights: {
      54063: 13.32,
      54089: 86.68,
    },
    county_names_all: "Summers|Monroe",
    county_fips_all: "54089|54063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24983,
    lat: 37.59165,
    lng: -80.51672,
    city: "Union",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2212,
    density: 8.6,
    county_fips: 54063,
    county_name: "Monroe",
    county_weights: {
      54063: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 54063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24984,
    lat: 37.48942,
    lng: -80.41749,
    city: "Waiteville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 114,
    density: 1,
    county_fips: 54063,
    county_name: "Monroe",
    county_weights: {
      54063: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 54063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24985,
    lat: 37.59989,
    lng: -80.68948,
    city: "Wayside",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54063,
    county_name: "Monroe",
    county_weights: {
      54063: 78.76,
      54089: 21.24,
    },
    county_names_all: "Monroe|Summers",
    county_fips_all: "54063|54089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24986,
    lat: 37.91189,
    lng: -80.19455,
    city: "White Sulphur Springs",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5057,
    density: 8.1,
    county_fips: 54025,
    county_name: "Greenbrier",
    county_weights: {
      54025: 96.91,
      54075: 3.09,
    },
    county_names_all: "Greenbrier|Pocahontas",
    county_fips_all: "54025|54075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24991,
    lat: 38.00702,
    lng: -80.48972,
    city: "Williamsburg",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 675,
    density: 7.6,
    county_fips: 54025,
    county_name: "Greenbrier",
    county_weights: {
      54025: 100,
    },
    county_names_all: "Greenbrier",
    county_fips_all: 54025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 24993,
    lat: 37.66095,
    lng: -80.63512,
    city: "Wolfcreek",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54063,
    county_name: "Monroe",
    county_weights: {
      54063: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 54063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25002,
    lat: 38.13087,
    lng: -81.25466,
    city: "Alloy",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25003,
    lat: 38.25101,
    lng: -81.77925,
    city: "Alum Creek",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2315,
    density: 24,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54005: 0.1,
      54039: 70.54,
      54043: 29.36,
    },
    county_names_all: "Kanawha|Lincoln|Boone",
    county_fips_all: "54039|54043|54005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25005,
    lat: 38.58201,
    lng: -81.26982,
    city: "Amma",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 143,
    density: 7.5,
    county_fips: 54087,
    county_name: "Roane",
    county_weights: {
      54087: 100,
    },
    county_names_all: "Roane",
    county_fips_all: 54087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25007,
    lat: 37.8252,
    lng: -81.42766,
    city: "Arnett",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 485,
    density: 34.9,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25008,
    lat: 37.95044,
    lng: -81.35766,
    city: "Artie",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 220,
    density: 6.2,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25009,
    lat: 38.19237,
    lng: -81.71301,
    city: "Ashford",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1182,
    density: 16.1,
    county_fips: 54005,
    county_name: "Boone",
    county_weights: {
      54005: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 54005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25011,
    lat: 38.51169,
    lng: -81.8363,
    city: "Bancroft",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 541,
    density: 230.2,
    county_fips: 54079,
    county_name: "Putnam",
    county_weights: {
      54079: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 54079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25015,
    lat: 38.24293,
    lng: -81.49226,
    city: "Belle",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3659,
    density: 47.3,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25019,
    lat: 38.37663,
    lng: -81.08955,
    city: "Bickmore",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 571,
    density: 9,
    county_fips: 54015,
    county_name: "Clay",
    county_weights: {
      54015: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 54015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25021,
    lat: 37.91587,
    lng: -81.68482,
    city: "Bim",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 349,
    density: 12.7,
    county_fips: 54005,
    county_name: "Boone",
    county_weights: {
      54005: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 54005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25022,
    lat: 37.84157,
    lng: -81.79241,
    city: "Blair",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 323,
    density: 5.8,
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54045: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 54045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25024,
    lat: 38.15744,
    lng: -81.6266,
    city: "Bloomingrose",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 620,
    density: 51.4,
    county_fips: 54005,
    county_name: "Boone",
    county_weights: {
      54005: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 54005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25025,
    lat: 38.29378,
    lng: -81.4018,
    city: "Blount",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 99,
    density: 2.2,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25028,
    lat: 37.95598,
    lng: -81.72535,
    city: "Bob White",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 253,
    density: 19.8,
    county_fips: 54005,
    county_name: "Boone",
    county_weights: {
      54005: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 54005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25030,
    lat: 38.45028,
    lng: -81.22599,
    city: "Bomont",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 369,
    density: 11,
    county_fips: 54015,
    county_name: "Clay",
    county_weights: {
      54015: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 54015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25031,
    lat: 38.14615,
    lng: -81.2801,
    city: "Boomer",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 624,
    density: 180.2,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25033,
    lat: 38.61095,
    lng: -81.92511,
    city: "Buffalo",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1699,
    density: 26.4,
    county_fips: 54079,
    county_name: "Putnam",
    county_weights: {
      54079: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 54079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25035,
    lat: 38.16339,
    lng: -81.52399,
    city: "Cabin Creek",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1088,
    density: 33.9,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25036,
    lat: 38.19168,
    lng: -81.26438,
    city: "Cannelton",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 167,
    density: 4.4,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 99.38,
      54039: 0.62,
    },
    county_names_all: "Fayette|Kanawha",
    county_fips_all: "54019|54039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25039,
    lat: 38.24642,
    lng: -81.36524,
    city: "Cedar Grove",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1005,
    density: 21.6,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25040,
    lat: 38.13673,
    lng: -81.24385,
    city: "Charlton Heights",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 700,
    density: 71,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25043,
    lat: 38.44092,
    lng: -80.98981,
    city: "Clay",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1796,
    density: 7.1,
    county_fips: 54015,
    county_name: "Clay",
    county_weights: {
      54015: 87.21,
      54067: 12.79,
    },
    county_names_all: "Clay|Nicholas",
    county_fips_all: "54015|54067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25044,
    lat: 37.91139,
    lng: -81.32118,
    city: "Clear Creek",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 247,
    density: 14.3,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25045,
    lat: 38.45603,
    lng: -81.32474,
    city: "Clendenin",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4652,
    density: 13.7,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54015: 7.94,
      54039: 78.17,
      54087: 13.89,
    },
    county_names_all: "Kanawha|Roane|Clay",
    county_fips_all: "54039|54087|54015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25047,
    lat: 37.9219,
    lng: -81.76027,
    city: "Clothier",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 104,
    density: 5.1,
    county_fips: 54005,
    county_name: "Boone",
    county_weights: {
      54005: 96.51,
      54045: 3.49,
    },
    county_names_all: "Boone|Logan",
    county_fips_all: "54005|54045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25048,
    lat: 37.95442,
    lng: -81.44656,
    city: "Colcord",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25049,
    lat: 38.11954,
    lng: -81.57315,
    city: "Comfort",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 405,
    density: 9.1,
    county_fips: 54005,
    county_name: "Boone",
    county_weights: {
      54005: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 54005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25051,
    lat: 38.15885,
    lng: -81.70929,
    city: "Costa",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 182,
    density: 158.2,
    county_fips: 54005,
    county_name: "Boone",
    county_weights: {
      54005: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 54005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25053,
    lat: 38.04725,
    lng: -81.87633,
    city: "Danville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3999,
    density: 31.6,
    county_fips: 54005,
    county_name: "Boone",
    county_weights: {
      54005: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 54005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25054,
    lat: 38.12226,
    lng: -81.45044,
    city: "Dawes",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 282,
    density: 508.5,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25057,
    lat: 38.1078,
    lng: -81.23783,
    city: "Deep Water",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 295,
    density: 15.9,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25059,
    lat: 38.25422,
    lng: -81.2153,
    city: "Dixie",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 399,
    density: 29.6,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54015: 0.1,
      54019: 52.08,
      54067: 47.82,
    },
    county_names_all: "Fayette|Nicholas|Clay",
    county_fips_all: "54019|54067|54015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25060,
    lat: 37.97058,
    lng: -81.47286,
    city: "Dorothy",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 289,
    density: 22.9,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54005: 0.13,
      54081: 99.87,
    },
    county_names_all: "Raleigh|Boone",
    county_fips_all: "54081|54005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25061,
    lat: 38.1751,
    lng: -81.43342,
    city: "Drybranch",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 524,
    density: 12.9,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25062,
    lat: 37.87549,
    lng: -81.44411,
    city: "Dry Creek",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 112,
    density: 11.1,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25063,
    lat: 38.57761,
    lng: -80.92572,
    city: "Duck",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1899,
    density: 9.9,
    county_fips: 54007,
    county_name: "Braxton",
    county_weights: {
      54007: 57.37,
      54015: 40.45,
      54067: 2.18,
    },
    county_names_all: "Braxton|Clay|Nicholas",
    county_fips_all: "54007|54015|54067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25064,
    lat: 38.37631,
    lng: -81.74764,
    city: "Dunbar",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8892,
    density: 513.2,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25067,
    lat: 38.20963,
    lng: -81.44018,
    city: "East Bank",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1261,
    density: 563.3,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25070,
    lat: 38.54667,
    lng: -81.93179,
    city: "Eleanor",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1544,
    density: 121.6,
    county_fips: 54079,
    county_name: "Putnam",
    county_weights: {
      54079: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 54079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25071,
    lat: 38.47732,
    lng: -81.46756,
    city: "Elkview",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11743,
    density: 40.3,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 91.31,
      54087: 8.69,
    },
    county_names_all: "Kanawha|Roane",
    county_fips_all: "54039|54087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25075,
    lat: 38.0526,
    lng: -81.42915,
    city: "Eskdale",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 836,
    density: 5.5,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25076,
    lat: 37.86889,
    lng: -81.937,
    city: "Ethel",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 261,
    density: 12.7,
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54045: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 54045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25081,
    lat: 38.08235,
    lng: -81.76875,
    city: "Foster",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1274,
    density: 31.9,
    county_fips: 54005,
    county_name: "Boone",
    county_weights: {
      54005: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 54005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25082,
    lat: 38.60861,
    lng: -82.02879,
    city: "Fraziers Bottom",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1497,
    density: 11.1,
    county_fips: 54079,
    county_name: "Putnam",
    county_weights: {
      54053: 47.85,
      54079: 52.15,
    },
    county_names_all: "Putnam|Mason",
    county_fips_all: "54079|54053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25083,
    lat: 38.06809,
    lng: -81.36118,
    city: "Gallagher",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1055,
    density: 15,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54019: 37.26,
      54039: 62.74,
    },
    county_names_all: "Kanawha|Fayette",
    county_fips_all: "54039|54019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25085,
    lat: 38.16762,
    lng: -81.18867,
    city: "Gauley Bridge",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 786,
    density: 21.8,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25086,
    lat: 38.21326,
    lng: -81.41238,
    city: "Glasgow",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 697,
    density: 194.6,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25088,
    lat: 38.37963,
    lng: -81.21551,
    city: "Glen",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 104,
    density: 2.5,
    county_fips: 54015,
    county_name: "Clay",
    county_weights: {
      54015: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 54015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25090,
    lat: 38.15544,
    lng: -81.21655,
    city: "Glen Ferris",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 174,
    density: 34.5,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25093,
    lat: 37.9653,
    lng: -81.64137,
    city: "Gordon",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 296,
    density: 7.9,
    county_fips: 54005,
    county_name: "Boone",
    county_weights: {
      54005: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 54005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25102,
    lat: 38.16735,
    lng: -81.35192,
    city: "Handley",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 274,
    density: 22.8,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25103,
    lat: 38.18207,
    lng: -81.38225,
    city: "Hansford",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 167,
    density: 15.5,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25106,
    lat: 38.77598,
    lng: -82.08237,
    city: "Henderson",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 604,
    density: 14.7,
    county_fips: 54053,
    county_name: "Mason",
    county_weights: {
      54053: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 54053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25107,
    lat: 38.22427,
    lng: -81.64493,
    city: "Hernshaw",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 530,
    density: 11.6,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25108,
    lat: 37.9655,
    lng: -81.87289,
    city: "Hewett",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 360,
    density: 22.5,
    county_fips: 54005,
    county_name: "Boone",
    county_weights: {
      54005: 99.89,
      54045: 0.11,
    },
    county_names_all: "Boone|Logan",
    county_fips_all: "54005|54045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25109,
    lat: 38.53097,
    lng: -81.86062,
    city: "Hometown",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 595,
    density: 764.7,
    county_fips: 54079,
    county_name: "Putnam",
    county_weights: {
      54079: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 54079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25110,
    lat: 38.21324,
    lng: -81.3264,
    city: "Hugheston",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 436,
    density: 11.9,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25111,
    lat: 38.34841,
    lng: -81.12591,
    city: "Indore",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 562,
    density: 7.8,
    county_fips: 54015,
    county_name: "Clay",
    county_weights: {
      54015: 55.87,
      54067: 44.13,
    },
    county_names_all: "Clay|Nicholas",
    county_fips_all: "54015|54067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25112,
    lat: 38.38103,
    lng: -81.76633,
    city: "Institute",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 122,
    density: 944.5,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25113,
    lat: 38.55741,
    lng: -81.03338,
    city: "Ivydale",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 489,
    density: 5.6,
    county_fips: 54015,
    county_name: "Clay",
    county_weights: {
      54015: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 54015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25114,
    lat: 37.98199,
    lng: -81.7986,
    city: "Jeffrey",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 228,
    density: 8.3,
    county_fips: 54005,
    county_name: "Boone",
    county_weights: {
      54005: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 54005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25115,
    lat: 38.13065,
    lng: -81.18997,
    city: "Kanawha Falls",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 141,
    density: 6.7,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25118,
    lat: 38.11882,
    lng: -81.32294,
    city: "Kimberly",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 894,
    density: 62.3,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25119,
    lat: 38.03362,
    lng: -81.27494,
    city: "Kincaid",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 378,
    density: 14.7,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25121,
    lat: 37.91167,
    lng: -81.87787,
    city: "Lake",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1202,
    density: 15,
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54045: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 54045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25123,
    lat: 38.73172,
    lng: -81.90214,
    city: "Leon",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2656,
    density: 8.8,
    county_fips: 54053,
    county_name: "Mason",
    county_weights: {
      54053: 80.93,
      54079: 19.07,
    },
    county_names_all: "Mason|Putnam",
    county_fips_all: "54053|54079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25124,
    lat: 38.62006,
    lng: -81.76536,
    city: "Liberty",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1254,
    density: 14.8,
    county_fips: 54079,
    county_name: "Putnam",
    county_weights: {
      54035: 0.77,
      54039: 6.13,
      54079: 93.1,
    },
    county_names_all: "Putnam|Kanawha|Jackson",
    county_fips_all: "54079|54039|54035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25125,
    lat: 38.31554,
    lng: -81.19074,
    city: "Lizemores",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1297,
    density: 17.4,
    county_fips: 54015,
    county_name: "Clay",
    county_weights: {
      54015: 92.72,
      54067: 7.28,
    },
    county_names_all: "Clay|Nicholas",
    county_fips_all: "54015|54067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25126,
    lat: 38.19058,
    lng: -81.35382,
    city: "London",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 66,
    density: 42.9,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25130,
    lat: 38.02776,
    lng: -81.7455,
    city: "Madison",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3241,
    density: 50.5,
    county_fips: 54005,
    county_name: "Boone",
    county_weights: {
      54005: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 54005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25132,
    lat: 38.29328,
    lng: -81.33441,
    city: "Mammoth",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 131,
    density: 3.6,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25133,
    lat: 38.47976,
    lng: -81.11831,
    city: "Maysel",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 704,
    density: 12.3,
    county_fips: 54015,
    county_name: "Clay",
    county_weights: {
      54015: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 54015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25134,
    lat: 38.13596,
    lng: -81.48553,
    city: "Miami",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 253,
    density: 4.9,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25136,
    lat: 38.15864,
    lng: -81.31977,
    city: "Montgomery",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1751,
    density: 131.5,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 91.72,
      54039: 8.28,
    },
    county_names_all: "Fayette|Kanawha",
    county_fips_all: "54019|54039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25139,
    lat: 38.11038,
    lng: -81.2874,
    city: "Mount Carbon",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25140,
    lat: 37.86738,
    lng: -81.49733,
    city: "Naoma",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 935,
    density: 6.5,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25141,
    lat: 38.6305,
    lng: -81.03592,
    city: "Nebo",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 174,
    density: 10.1,
    county_fips: 54015,
    county_name: "Clay",
    county_weights: {
      54013: 4.78,
      54015: 95.22,
    },
    county_names_all: "Clay|Calhoun",
    county_fips_all: "54015|54013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25142,
    lat: 38.15001,
    lng: -81.73066,
    city: "Nellis",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 401,
    density: 31.1,
    county_fips: 54005,
    county_name: "Boone",
    county_weights: {
      54005: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 54005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25143,
    lat: 38.42001,
    lng: -81.82414,
    city: "Nitro",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8926,
    density: 388.2,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 67.22,
      54079: 32.78,
    },
    county_names_all: "Kanawha|Putnam",
    county_fips_all: "54039|54079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25148,
    lat: 38.03511,
    lng: -81.53695,
    city: "Orgas",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 447,
    density: 5.7,
    county_fips: 54005,
    county_name: "Boone",
    county_weights: {
      54005: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 54005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25149,
    lat: 37.9558,
    lng: -81.7745,
    city: "Ottawa",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 105,
    density: 4,
    county_fips: 54005,
    county_name: "Boone",
    county_weights: {
      54005: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 54005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25152,
    lat: 38.0411,
    lng: -81.24004,
    city: "Page",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 500,
    density: 19.7,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25154,
    lat: 38.11572,
    lng: -81.70249,
    city: "Peytona",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 989,
    density: 23.1,
    county_fips: 54005,
    county_name: "Boone",
    county_weights: {
      54005: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 54005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25156,
    lat: 38.41181,
    lng: -81.48217,
    city: "Pinch",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25159,
    lat: 38.50186,
    lng: -81.7806,
    city: "Poca",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4939,
    density: 55.9,
    county_fips: 54079,
    county_name: "Putnam",
    county_weights: {
      54079: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 54079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25160,
    lat: 38.29884,
    lng: -81.27314,
    city: "Pond Gap",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 275,
    density: 3.4,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54015: 0.1,
      54039: 99.9,
    },
    county_names_all: "Kanawha|Clay",
    county_fips_all: "54039|54015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25161,
    lat: 38.06123,
    lng: -81.3189,
    city: "Powellton",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 386,
    density: 10,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25162,
    lat: 38.20712,
    lng: -81.38435,
    city: "Pratt",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 323,
    density: 380.7,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25164,
    lat: 38.50406,
    lng: -81.19373,
    city: "Procious",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 957,
    density: 9.7,
    county_fips: 54015,
    county_name: "Clay",
    county_weights: {
      54015: 65.42,
      54087: 34.58,
    },
    county_names_all: "Clay|Roane",
    county_fips_all: "54015|54087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25165,
    lat: 38.14907,
    lng: -81.65308,
    city: "Racine",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 852,
    density: 77.5,
    county_fips: 54005,
    county_name: "Boone",
    county_weights: {
      54005: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 54005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25168,
    lat: 38.56394,
    lng: -81.87733,
    city: "Red House",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3815,
    density: 46.2,
    county_fips: 54079,
    county_name: "Putnam",
    county_weights: {
      54079: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 54079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25169,
    lat: 38.12788,
    lng: -81.76288,
    city: "Ridgeview",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 598,
    density: 35.6,
    county_fips: 54005,
    county_name: "Boone",
    county_weights: {
      54005: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 54005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25173,
    lat: 38.07519,
    lng: -81.21898,
    city: "Robson",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 181,
    density: 6.5,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25174,
    lat: 37.86115,
    lng: -81.41376,
    city: "Rock Creek",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 423,
    density: 17.6,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25177,
    lat: 38.36928,
    lng: -81.85021,
    city: "Saint Albans",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23143,
    density: 283.1,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 93.38,
      54079: 6.62,
    },
    county_names_all: "Kanawha|Putnam",
    county_fips_all: "54039|54079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25180,
    lat: 37.78961,
    lng: -81.43316,
    city: "Saxon",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 235,
    density: 24.9,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25181,
    lat: 38.04962,
    lng: -81.63476,
    city: "Seth",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1189,
    density: 8.1,
    county_fips: 54005,
    county_name: "Boone",
    county_weights: {
      54005: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 54005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25183,
    lat: 37.9074,
    lng: -81.79745,
    city: "Sharples",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37,
    density: 1.1,
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54045: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 54045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25185,
    lat: 38.22149,
    lng: -81.23587,
    city: "Mount Olive",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25186,
    lat: 38.17113,
    lng: -81.29811,
    city: "Smithers",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1023,
    density: 222,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25187,
    lat: 38.72617,
    lng: -82.01878,
    city: "Southside",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 533,
    density: 5.1,
    county_fips: 54053,
    county_name: "Mason",
    county_weights: {
      54053: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 54053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25193,
    lat: 38.01672,
    lng: -81.55089,
    city: "Sylvester",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 728,
    density: 86,
    county_fips: 54005,
    county_name: "Boone",
    county_weights: {
      54005: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 54005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25201,
    lat: 38.3489,
    lng: -81.48645,
    city: "Tad",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25202,
    lat: 38.31593,
    lng: -81.85372,
    city: "Tornado",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1072,
    density: 31.6,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 52.43,
      54043: 47.57,
    },
    county_names_all: "Kanawha|Lincoln",
    county_fips_all: "54039|54043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25203,
    lat: 38.02125,
    lng: -81.88162,
    city: "Turtle Creek",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19,
    density: 3.3,
    county_fips: 54005,
    county_name: "Boone",
    county_weights: {
      54005: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 54005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25204,
    lat: 37.91546,
    lng: -81.60914,
    city: "Twilight",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 103,
    density: 2.7,
    county_fips: 54005,
    county_name: "Boone",
    county_weights: {
      54005: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 54005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25205,
    lat: 38.01841,
    lng: -81.78926,
    city: "Uneeda",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 200,
    density: 10.8,
    county_fips: 54005,
    county_name: "Boone",
    county_weights: {
      54005: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 54005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25206,
    lat: 37.9596,
    lng: -81.69296,
    city: "Van",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 227,
    density: 13.8,
    county_fips: 54005,
    county_name: "Boone",
    county_weights: {
      54005: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 54005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25208,
    lat: 37.84579,
    lng: -81.64282,
    city: "Wharton",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 859,
    density: 4.6,
    county_fips: 54005,
    county_name: "Boone",
    county_weights: {
      54005: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 54005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25209,
    lat: 37.96271,
    lng: -81.52861,
    city: "Whitesville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1122,
    density: 16.9,
    county_fips: 54005,
    county_name: "Boone",
    county_weights: {
      54005: 51.78,
      54081: 48.22,
    },
    county_names_all: "Boone|Raleigh",
    county_fips_all: "54005|54081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25211,
    lat: 38.46107,
    lng: -80.87932,
    city: "Widen",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 92,
    density: 3,
    county_fips: 54015,
    county_name: "Clay",
    county_weights: {
      54015: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 54015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25213,
    lat: 38.50776,
    lng: -81.91796,
    city: "Winfield",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6462,
    density: 69.5,
    county_fips: 54079,
    county_name: "Putnam",
    county_weights: {
      54079: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 54079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25214,
    lat: 38.18947,
    lng: -81.55127,
    city: "Winifrede",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 854,
    density: 49.9,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25231,
    lat: 38.60464,
    lng: -81.591,
    city: "Advent",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54035,
    county_name: "Jackson",
    county_weights: {
      54035: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 54035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25234,
    lat: 38.81291,
    lng: -81.12343,
    city: "Arnoldsburg",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 803,
    density: 6.9,
    county_fips: 54013,
    county_name: "Calhoun",
    county_weights: {
      54013: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 54013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25235,
    lat: 38.66939,
    lng: -81.08874,
    city: "Chloe",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1128,
    density: 10.9,
    county_fips: 54013,
    county_name: "Calhoun",
    county_weights: {
      54007: 1.79,
      54013: 88.84,
      54015: 9.37,
    },
    county_names_all: "Calhoun|Clay|Braxton",
    county_fips_all: "54013|54015|54007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25239,
    lat: 38.84616,
    lng: -81.83941,
    city: "Cottageville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2126,
    density: 28.4,
    county_fips: 54035,
    county_name: "Jackson",
    county_weights: {
      54035: 84,
      54053: 16,
    },
    county_names_all: "Jackson|Mason",
    county_fips_all: "54035|54053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25241,
    lat: 38.78427,
    lng: -81.80801,
    city: "Evans",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1846,
    density: 30.5,
    county_fips: 54035,
    county_name: "Jackson",
    county_weights: {
      54035: 71.19,
      54053: 28.81,
    },
    county_names_all: "Jackson|Mason",
    county_fips_all: "54035|54053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25243,
    lat: 38.67841,
    lng: -81.48216,
    city: "Gandeeville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 421,
    density: 3,
    county_fips: 54087,
    county_name: "Roane",
    county_weights: {
      54035: 3.77,
      54087: 96.23,
    },
    county_names_all: "Roane|Jackson",
    county_fips_all: "54087|54035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25244,
    lat: 38.77068,
    lng: -81.54237,
    city: "Gay",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 610,
    density: 7.4,
    county_fips: 54035,
    county_name: "Jackson",
    county_weights: {
      54035: 67.12,
      54087: 32.88,
    },
    county_names_all: "Jackson|Roane",
    county_fips_all: "54035|54087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25245,
    lat: 38.69916,
    lng: -81.7393,
    city: "Given",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 632,
    density: 7.3,
    county_fips: 54035,
    county_name: "Jackson",
    county_weights: {
      54035: 84.89,
      54079: 15.11,
    },
    county_names_all: "Jackson|Putnam",
    county_fips_all: "54035|54079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25247,
    lat: 39.001,
    lng: -81.98987,
    city: "Hartford",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 531,
    density: 161.3,
    county_fips: 54053,
    county_name: "Mason",
    county_weights: {
      54053: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 54053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25248,
    lat: 38.64255,
    lng: -81.61454,
    city: "Kenna",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3191,
    density: 18.7,
    county_fips: 54035,
    county_name: "Jackson",
    county_weights: {
      54035: 98.3,
      54039: 1.7,
    },
    county_names_all: "Jackson|Kanawha",
    county_fips_all: "54035|54039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25251,
    lat: 38.62119,
    lng: -81.23173,
    city: "Left Hand",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 167,
    density: 4.3,
    county_fips: 54087,
    county_name: "Roane",
    county_weights: {
      54087: 100,
    },
    county_names_all: "Roane",
    county_fips_all: 54087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25252,
    lat: 38.88345,
    lng: -81.53679,
    city: "Le Roy",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1371,
    density: 8.1,
    county_fips: 54035,
    county_name: "Jackson",
    county_weights: {
      54035: 55.55,
      54087: 26.62,
      54105: 17.83,
    },
    county_names_all: "Jackson|Roane|Wirt",
    county_fips_all: "54035|54087|54105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25253,
    lat: 38.91947,
    lng: -81.9669,
    city: "Letart",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2269,
    density: 18.6,
    county_fips: 54053,
    county_name: "Mason",
    county_weights: {
      54053: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 54053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25259,
    lat: 38.67465,
    lng: -81.24836,
    city: "Looneyville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1041,
    density: 9.3,
    county_fips: 54087,
    county_name: "Roane",
    county_weights: {
      54087: 100,
    },
    county_names_all: "Roane",
    county_fips_all: 54087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25260,
    lat: 39.01653,
    lng: -82.02465,
    city: "Mason",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1328,
    density: 237.4,
    county_fips: 54053,
    county_name: "Mason",
    county_weights: {
      39105: 1.11,
      54053: 98.89,
    },
    county_names_all: "Mason|Meigs",
    county_fips_all: "54053|39105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25261,
    lat: 38.83027,
    lng: -81.08886,
    city: "Millstone",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 84,
    density: 3.3,
    county_fips: 54013,
    county_name: "Calhoun",
    county_weights: {
      54013: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 54013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25262,
    lat: 38.90751,
    lng: -81.83219,
    city: "Millwood",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1230,
    density: 120.4,
    county_fips: 54035,
    county_name: "Jackson",
    county_weights: {
      54035: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 54035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25264,
    lat: 38.85547,
    lng: -81.89516,
    city: "Mount Alto",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 356,
    density: 19.4,
    county_fips: 54053,
    county_name: "Mason",
    county_weights: {
      54035: 49.05,
      54053: 50.95,
    },
    county_names_all: "Mason|Jackson",
    county_fips_all: "54053|54035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25265,
    lat: 38.98129,
    lng: -81.97356,
    city: "New Haven",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1672,
    density: 270.9,
    county_fips: 54053,
    county_name: "Mason",
    county_weights: {
      54053: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 54053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25266,
    lat: 38.60224,
    lng: -81.1589,
    city: "Newton",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 883,
    density: 9.7,
    county_fips: 54087,
    county_name: "Roane",
    county_weights: {
      54087: 100,
    },
    county_names_all: "Roane",
    county_fips_all: 54087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25267,
    lat: 38.85778,
    lng: -80.94187,
    city: "Normantown",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 493,
    density: 2.7,
    county_fips: 54021,
    county_name: "Gilmer",
    county_weights: {
      54013: 9.66,
      54021: 90.34,
    },
    county_names_all: "Gilmer|Calhoun",
    county_fips_all: "54021|54013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25268,
    lat: 38.73969,
    lng: -81.107,
    city: "Orma",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1059,
    density: 10.3,
    county_fips: 54013,
    county_name: "Calhoun",
    county_weights: {
      54013: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 54013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25270,
    lat: 38.88174,
    lng: -81.43395,
    city: "Reedy",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 799,
    density: 7.5,
    county_fips: 54087,
    county_name: "Roane",
    county_weights: {
      54087: 90.03,
      54105: 9.97,
    },
    county_names_all: "Roane|Wirt",
    county_fips_all: "54087|54105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25271,
    lat: 38.78845,
    lng: -81.68625,
    city: "Ripley",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9185,
    density: 37.1,
    county_fips: 54035,
    county_name: "Jackson",
    county_weights: {
      54035: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 54035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25275,
    lat: 38.92451,
    lng: -81.61687,
    city: "Sandyville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1761,
    density: 11.3,
    county_fips: 54035,
    county_name: "Jackson",
    county_weights: {
      54035: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 54035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25276,
    lat: 38.78803,
    lng: -81.33203,
    city: "Spencer",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7446,
    density: 17.4,
    county_fips: 54087,
    county_name: "Roane",
    county_weights: {
      54087: 100,
    },
    county_names_all: "Roane",
    county_fips_all: 54087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25285,
    lat: 38.54723,
    lng: -81.1129,
    city: "Wallback",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 493,
    density: 11.9,
    county_fips: 54015,
    county_name: "Clay",
    county_weights: {
      54015: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 54015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25286,
    lat: 38.62098,
    lng: -81.39728,
    city: "Walton",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1719,
    density: 11.2,
    county_fips: 54087,
    county_name: "Roane",
    county_weights: {
      54087: 100,
    },
    county_names_all: "Roane",
    county_fips_all: 54087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25287,
    lat: 38.96158,
    lng: -82.04834,
    city: "West Columbia",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1041,
    density: 18.3,
    county_fips: 54053,
    county_name: "Mason",
    county_weights: {
      54053: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 54053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25301,
    lat: 38.35123,
    lng: -81.62761,
    city: "Charleston",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2120,
    density: 610.5,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25302,
    lat: 38.39053,
    lng: -81.59879,
    city: "Charleston",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12818,
    density: 398,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25303,
    lat: 38.36033,
    lng: -81.68679,
    city: "South Charleston",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6764,
    density: 730.6,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25304,
    lat: 38.30521,
    lng: -81.59044,
    city: "Charleston",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8732,
    density: 349.2,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25305,
    lat: 38.33682,
    lng: -81.61313,
    city: "Charleston",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25306,
    lat: 38.31071,
    lng: -81.49087,
    city: "Charleston",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6749,
    density: 70.2,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25309,
    lat: 38.31177,
    lng: -81.75715,
    city: "South Charleston",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13425,
    density: 166.7,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25311,
    lat: 38.36308,
    lng: -81.55357,
    city: "Charleston",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10386,
    density: 156.1,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25312,
    lat: 38.46156,
    lng: -81.656,
    city: "Charleston",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15859,
    density: 86.2,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25313,
    lat: 38.41547,
    lng: -81.75704,
    city: "Charleston",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11611,
    density: 221.4,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25314,
    lat: 38.29705,
    lng: -81.65463,
    city: "Charleston",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13979,
    density: 165.1,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25315,
    lat: 38.21032,
    lng: -81.57992,
    city: "Charleston",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3554,
    density: 67.8,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25320,
    lat: 38.54124,
    lng: -81.62706,
    city: "Charleston",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5482,
    density: 34.9,
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25387,
    lat: 38.38523,
    lng: -81.6642,
    city: "Charleston",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54039,
    county_name: "Kanawha",
    county_weights: {
      54039: 100,
    },
    county_names_all: "Kanawha",
    county_fips_all: 54039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25401,
    lat: 39.45642,
    lng: -77.97267,
    city: "Martinsburg",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14676,
    density: 968.9,
    county_fips: 54003,
    county_name: "Berkeley",
    county_weights: {
      54003: 100,
    },
    county_names_all: "Berkeley",
    county_fips_all: 54003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25403,
    lat: 39.4842,
    lng: -78.00725,
    city: "Martinsburg",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13614,
    density: 130,
    county_fips: 54003,
    county_name: "Berkeley",
    county_weights: {
      54003: 100,
    },
    county_names_all: "Berkeley",
    county_fips_all: 54003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25404,
    lat: 39.48631,
    lng: -77.89782,
    city: "Martinsburg",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22287,
    density: 226.9,
    county_fips: 54003,
    county_name: "Berkeley",
    county_weights: {
      54003: 100,
    },
    county_names_all: "Berkeley",
    county_fips_all: 54003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25405,
    lat: 39.40892,
    lng: -77.96235,
    city: "Martinsburg",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13921,
    density: 248,
    county_fips: 54003,
    county_name: "Berkeley",
    county_weights: {
      54003: 100,
    },
    county_names_all: "Berkeley",
    county_fips_all: 54003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25411,
    lat: 39.55497,
    lng: -78.22004,
    city: "Berkeley Springs",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12614,
    density: 34.9,
    county_fips: 54065,
    county_name: "Morgan",
    county_weights: {
      54065: 100,
    },
    county_names_all: "Morgan",
    county_fips_all: 54065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25413,
    lat: 39.31632,
    lng: -78.053,
    city: "Bunker Hill",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8953,
    density: 151.2,
    county_fips: 54003,
    county_name: "Berkeley",
    county_weights: {
      54003: 100,
    },
    county_names_all: "Berkeley",
    county_fips_all: 54003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25414,
    lat: 39.25273,
    lng: -77.87055,
    city: "Charles Town",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19073,
    density: 130.2,
    county_fips: 54037,
    county_name: "Jefferson",
    county_weights: {
      54037: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 54037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25419,
    lat: 39.58286,
    lng: -77.88493,
    city: "Falling Waters",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10860,
    density: 239.8,
    county_fips: 54003,
    county_name: "Berkeley",
    county_weights: {
      54003: 100,
    },
    county_names_all: "Berkeley",
    county_fips_all: 54003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25420,
    lat: 39.38095,
    lng: -78.11969,
    city: "Gerrardstown",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4650,
    density: 60.2,
    county_fips: 54003,
    county_name: "Berkeley",
    county_weights: {
      54003: 100,
    },
    county_names_all: "Berkeley",
    county_fips_all: 54003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25421,
    lat: 39.37821,
    lng: -78.16384,
    city: "Glengary",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54003,
    county_name: "Berkeley",
    county_weights: {
      54003: 100,
    },
    county_names_all: "Berkeley",
    county_fips_all: 54003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25422,
    lat: 39.55812,
    lng: -78.35887,
    city: "Great Cacapon",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1531,
    density: 8.9,
    county_fips: 54065,
    county_name: "Morgan",
    county_weights: {
      54027: 4.91,
      54065: 95.09,
    },
    county_names_all: "Morgan|Hampshire",
    county_fips_all: "54065|54027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25425,
    lat: 39.27613,
    lng: -77.79184,
    city: "Harpers Ferry",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13735,
    density: 120.8,
    county_fips: 54037,
    county_name: "Jefferson",
    county_weights: {
      54037: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 54037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25427,
    lat: 39.52608,
    lng: -78.09098,
    city: "Hedgesville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15570,
    density: 45.9,
    county_fips: 54003,
    county_name: "Berkeley",
    county_weights: {
      54003: 87.85,
      54065: 12.15,
    },
    county_names_all: "Berkeley|Morgan",
    county_fips_all: "54003|54065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25428,
    lat: 39.37407,
    lng: -78.02729,
    city: "Inwood",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13517,
    density: 237.6,
    county_fips: 54003,
    county_name: "Berkeley",
    county_weights: {
      54003: 100,
    },
    county_names_all: "Berkeley",
    county_fips_all: 54003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25430,
    lat: 39.34024,
    lng: -77.93899,
    city: "Kearneysville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8571,
    density: 72,
    county_fips: 54037,
    county_name: "Jefferson",
    county_weights: {
      54003: 9.03,
      54037: 90.97,
    },
    county_names_all: "Jefferson|Berkeley",
    county_fips_all: "54037|54003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25431,
    lat: 39.48682,
    lng: -78.57279,
    city: "Levels",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 335,
    density: 14.9,
    county_fips: 54027,
    county_name: "Hampshire",
    county_weights: {
      54027: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 54027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25432,
    lat: 39.29562,
    lng: -77.78663,
    city: "Millville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 116,
    density: 611.6,
    county_fips: 54037,
    county_name: "Jefferson",
    county_weights: {
      54037: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 54037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25434,
    lat: 39.45797,
    lng: -78.45038,
    city: "Paw Paw",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3078,
    density: 15.9,
    county_fips: 54027,
    county_name: "Hampshire",
    county_weights: {
      54027: 85.95,
      54065: 14.05,
    },
    county_names_all: "Hampshire|Morgan",
    county_fips_all: "54027|54065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25437,
    lat: 39.4225,
    lng: -78.57623,
    city: "Points",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 205,
    density: 4.2,
    county_fips: 54027,
    county_name: "Hampshire",
    county_weights: {
      54027: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 54027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25438,
    lat: 39.31853,
    lng: -77.86448,
    city: "Ranson",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6324,
    density: 249.7,
    county_fips: 54037,
    county_name: "Jefferson",
    county_weights: {
      54037: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 54037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25442,
    lat: 39.37157,
    lng: -77.83181,
    city: "Shenandoah Junction",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2302,
    density: 61,
    county_fips: 54037,
    county_name: "Jefferson",
    county_weights: {
      54037: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 54037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25443,
    lat: 39.43835,
    lng: -77.81477,
    city: "Shepherdstown",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7401,
    density: 93.1,
    county_fips: 54037,
    county_name: "Jefferson",
    county_weights: {
      54003: 10.26,
      54037: 89.74,
    },
    county_names_all: "Jefferson|Berkeley",
    county_fips_all: "54037|54003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25444,
    lat: 39.43543,
    lng: -78.52081,
    city: "Slanesville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 283,
    density: 7.2,
    county_fips: 54027,
    county_name: "Hampshire",
    county_weights: {
      54027: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 54027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25446,
    lat: 39.24013,
    lng: -77.95705,
    city: "Summit Point",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1212,
    density: 31.7,
    county_fips: 54037,
    county_name: "Jefferson",
    county_weights: {
      54037: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 54037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25501,
    lat: 38.16035,
    lng: -81.95582,
    city: "Alkol",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1204,
    density: 17.9,
    county_fips: 54043,
    county_name: "Lincoln",
    county_weights: {
      54043: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 54043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25502,
    lat: 38.66501,
    lng: -82.11024,
    city: "Apple Grove",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 850,
    density: 13.5,
    county_fips: 54053,
    county_name: "Mason",
    county_weights: {
      54053: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 54053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25503,
    lat: 38.60835,
    lng: -82.11666,
    city: "Ashton",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1336,
    density: 34,
    county_fips: 54053,
    county_name: "Mason",
    county_weights: {
      54053: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 54053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25504,
    lat: 38.37297,
    lng: -82.26674,
    city: "Barboursville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13249,
    density: 97.9,
    county_fips: 54011,
    county_name: "Cabell",
    county_weights: {
      54011: 90.24,
      54099: 9.76,
    },
    county_names_all: "Cabell|Wayne",
    county_fips_all: "54011|54099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25505,
    lat: 38.01967,
    lng: -82.03075,
    city: "Big Creek",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 325,
    density: 38.4,
    county_fips: 54043,
    county_name: "Lincoln",
    county_weights: {
      54043: 58.25,
      54045: 41.75,
    },
    county_names_all: "Lincoln|Logan",
    county_fips_all: "54043|54045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25506,
    lat: 38.20826,
    lng: -82.18665,
    city: "Branchland",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5563,
    density: 21.1,
    county_fips: 54043,
    county_name: "Lincoln",
    county_weights: {
      54011: 16.11,
      54043: 83.89,
    },
    county_names_all: "Lincoln|Cabell",
    county_fips_all: "54043|54011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25507,
    lat: 38.39945,
    lng: -82.55193,
    city: "Ceredo",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 864,
    density: 482.4,
    county_fips: 54099,
    county_name: "Wayne",
    county_weights: {
      54099: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 54099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25508,
    lat: 37.96388,
    lng: -82.01394,
    city: "Chapmanville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9467,
    density: 49.3,
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54005: 15.64,
      54045: 84.36,
    },
    county_names_all: "Logan|Boone",
    county_fips_all: "54045|54005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25510,
    lat: 38.38832,
    lng: -82.06599,
    city: "Culloden",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5109,
    density: 59.7,
    county_fips: 54011,
    county_name: "Cabell",
    county_weights: {
      54011: 49.52,
      54043: 26.93,
      54079: 23.55,
    },
    county_names_all: "Cabell|Lincoln|Putnam",
    county_fips_all: "54011|54043|54079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25511,
    lat: 38.03194,
    lng: -82.35637,
    city: "Dunlow",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 829,
    density: 3.9,
    county_fips: 54099,
    county_name: "Wayne",
    county_weights: {
      54099: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 54099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25512,
    lat: 38.17784,
    lng: -82.32056,
    city: "East Lynn",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1130,
    density: 8.9,
    county_fips: 54099,
    county_name: "Wayne",
    county_weights: {
      54099: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 54099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25514,
    lat: 38.08136,
    lng: -82.51678,
    city: "Fort Gay",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4066,
    density: 20.5,
    county_fips: 54099,
    county_name: "Wayne",
    county_weights: {
      54099: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 54099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25515,
    lat: 38.75731,
    lng: -82.15262,
    city: "Gallipolis Ferry",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1856,
    density: 15.7,
    county_fips: 54053,
    county_name: "Mason",
    county_weights: {
      54053: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 54053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25517,
    lat: 38.10989,
    lng: -82.45368,
    city: "Genoa",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1216,
    density: 11.7,
    county_fips: 54099,
    county_name: "Wayne",
    county_weights: {
      54099: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 54099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25520,
    lat: 38.55773,
    lng: -82.17899,
    city: "Glenwood",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1200,
    density: 12.2,
    county_fips: 54011,
    county_name: "Cabell",
    county_weights: {
      54011: 54.38,
      54053: 45.62,
    },
    county_names_all: "Cabell|Mason",
    county_fips_all: "54011|54053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25521,
    lat: 38.22915,
    lng: -81.98641,
    city: "Griffithsville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 825,
    density: 10,
    county_fips: 54043,
    county_name: "Lincoln",
    county_weights: {
      54043: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 54043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25523,
    lat: 38.27934,
    lng: -82.06754,
    city: "Hamlin",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2775,
    density: 27.5,
    county_fips: 54043,
    county_name: "Lincoln",
    county_weights: {
      54043: 89.03,
      54079: 10.97,
    },
    county_names_all: "Lincoln|Putnam",
    county_fips_all: "54043|54079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25524,
    lat: 38.01309,
    lng: -82.11712,
    city: "Harts",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2311,
    density: 9.2,
    county_fips: 54043,
    county_name: "Lincoln",
    county_weights: {
      54043: 71.07,
      54045: 23.22,
      54099: 5.71,
    },
    county_names_all: "Lincoln|Logan|Wayne",
    county_fips_all: "54043|54045|54099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25526,
    lat: 38.3984,
    lng: -81.98279,
    city: "Hurricane",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22135,
    density: 93.7,
    county_fips: 54079,
    county_name: "Putnam",
    county_weights: {
      54043: 1.11,
      54053: 0.26,
      54079: 98.63,
    },
    county_names_all: "Putnam|Lincoln|Mason",
    county_fips_all: "54079|54043|54053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25529,
    lat: 38.15573,
    lng: -81.8245,
    city: "Julian",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 944,
    density: 11.1,
    county_fips: 54005,
    county_name: "Boone",
    county_weights: {
      54005: 94.78,
      54043: 5.22,
    },
    county_names_all: "Boone|Lincoln",
    county_fips_all: "54005|54043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25530,
    lat: 38.35629,
    lng: -82.56337,
    city: "Kenova",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6575,
    density: 170.6,
    county_fips: 54099,
    county_name: "Wayne",
    county_weights: {
      54099: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 54099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25534,
    lat: 38.08065,
    lng: -82.27781,
    city: "Kiahsville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 243,
    density: 4.4,
    county_fips: 54099,
    county_name: "Wayne",
    county_weights: {
      54099: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 54099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25535,
    lat: 38.30772,
    lng: -82.43405,
    city: "Lavalette",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2848,
    density: 70.4,
    county_fips: 54099,
    county_name: "Wayne",
    county_weights: {
      54099: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 54099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25537,
    lat: 38.53399,
    lng: -82.26926,
    city: "Lesage",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1077,
    density: 17.9,
    county_fips: 54011,
    county_name: "Cabell",
    county_weights: {
      54011: 100,
    },
    county_names_all: "Cabell",
    county_fips_all: 54011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25540,
    lat: 38.15709,
    lng: -82.13914,
    city: "Midkiff",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 267,
    density: 6.8,
    county_fips: 54043,
    county_name: "Lincoln",
    county_weights: {
      54043: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 54043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25541,
    lat: 38.45884,
    lng: -82.12707,
    city: "Milton",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10663,
    density: 58.7,
    county_fips: 54011,
    county_name: "Cabell",
    county_weights: {
      54011: 80.45,
      54053: 19.55,
    },
    county_names_all: "Cabell|Mason",
    county_fips_all: "54011|54053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25544,
    lat: 38.23078,
    lng: -82.11017,
    city: "Myra",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54043,
    county_name: "Lincoln",
    county_weights: {
      54043: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 54043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25545,
    lat: 38.45847,
    lng: -82.22456,
    city: "Ona",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5112,
    density: 74.8,
    county_fips: 54011,
    county_name: "Cabell",
    county_weights: {
      54011: 100,
    },
    county_names_all: "Cabell",
    county_fips_all: 54011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25547,
    lat: 37.92627,
    lng: -81.9537,
    city: "Pecks Mill",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 732,
    density: 56,
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54045: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 54045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25550,
    lat: 38.86655,
    lng: -82.0749,
    city: "Point Pleasant",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9489,
    density: 74.3,
    county_fips: 54053,
    county_name: "Mason",
    county_weights: {
      54053: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 54053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25555,
    lat: 38.23525,
    lng: -82.55913,
    city: "Prichard",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2214,
    density: 22.7,
    county_fips: 54099,
    county_name: "Wayne",
    county_weights: {
      54099: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 54099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25557,
    lat: 38.09923,
    lng: -82.16262,
    city: "Ranger",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1612,
    density: 14.1,
    county_fips: 54043,
    county_name: "Lincoln",
    county_weights: {
      54043: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 54043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25559,
    lat: 38.32753,
    lng: -82.23181,
    city: "Salt Rock",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1734,
    density: 33.8,
    county_fips: 54011,
    county_name: "Cabell",
    county_weights: {
      54011: 100,
    },
    county_names_all: "Cabell",
    county_fips_all: 54011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25560,
    lat: 38.44736,
    lng: -81.89908,
    city: "Scott Depot",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7590,
    density: 138.1,
    county_fips: 54079,
    county_name: "Putnam",
    county_weights: {
      54079: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 54079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25564,
    lat: 38.26302,
    lng: -81.88835,
    city: "Sod",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1217,
    density: 26.8,
    county_fips: 54043,
    county_name: "Lincoln",
    county_weights: {
      54043: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 54043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25565,
    lat: 38.10998,
    lng: -81.96631,
    city: "Spurlockville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 521,
    density: 5.2,
    county_fips: 54043,
    county_name: "Lincoln",
    county_weights: {
      54005: 41.22,
      54043: 58.78,
    },
    county_names_all: "Lincoln|Boone",
    county_fips_all: "54043|54005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25567,
    lat: 38.21971,
    lng: -81.87294,
    city: "Sumerco",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 511,
    density: 13.4,
    county_fips: 54043,
    county_name: "Lincoln",
    county_weights: {
      54043: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 54043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25570,
    lat: 38.23508,
    lng: -82.41927,
    city: "Wayne",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5193,
    density: 26.2,
    county_fips: 54099,
    county_name: "Wayne",
    county_weights: {
      54099: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 54099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25571,
    lat: 38.2947,
    lng: -82.15632,
    city: "West Hamlin",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2211,
    density: 32.1,
    county_fips: 54043,
    county_name: "Lincoln",
    county_weights: {
      54043: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 54043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25573,
    lat: 38.22725,
    lng: -81.94549,
    city: "Yawkey",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 565,
    density: 19.4,
    county_fips: 54043,
    county_name: "Lincoln",
    county_weights: {
      54043: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 54043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25601,
    lat: 37.86255,
    lng: -82.0026,
    city: "Logan",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5053,
    density: 93.5,
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54045: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 54045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25606,
    lat: 37.76641,
    lng: -81.82878,
    city: "Accoville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1346,
    density: 71.9,
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54045: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 54045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25607,
    lat: 37.78125,
    lng: -81.77081,
    city: "Amherstdale",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 847,
    density: 25.8,
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54045: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 54045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25608,
    lat: 37.57512,
    lng: -81.89165,
    city: "Baisden",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 967,
    density: 36.4,
    county_fips: 54059,
    county_name: "Mingo",
    county_weights: {
      54059: 100,
    },
    county_names_all: "Mingo",
    county_fips_all: 54059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25611,
    lat: 37.6832,
    lng: -81.87068,
    city: "Bruno",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 724,
    density: 33.7,
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54045: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 54045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25612,
    lat: 37.76396,
    lng: -81.98064,
    city: "Chauncey",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54045: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 54045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25617,
    lat: 37.74549,
    lng: -81.80275,
    city: "Davin",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 824,
    density: 44,
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54045: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 54045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25621,
    lat: 37.63149,
    lng: -81.89643,
    city: "Gilbert",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1512,
    density: 13.1,
    county_fips: 54059,
    county_name: "Mingo",
    county_weights: {
      54059: 100,
    },
    county_names_all: "Mingo",
    county_fips_all: 54059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25624,
    lat: 37.90393,
    lng: -81.97162,
    city: "Henlawson",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 120,
    density: 22.7,
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54045: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 54045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25625,
    lat: 37.82237,
    lng: -82.09206,
    city: "Holden",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1264,
    density: 27.4,
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54045: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 54045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25628,
    lat: 37.7657,
    lng: -81.86237,
    city: "Kistler",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 226,
    density: 40.2,
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54045: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 54045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25630,
    lat: 37.79821,
    lng: -81.6816,
    city: "Lorado",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 447,
    density: 8.7,
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54045: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 54045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25632,
    lat: 37.76292,
    lng: -81.9368,
    city: "Lyburn",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 247,
    density: 4,
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54045: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 54045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25634,
    lat: 37.73017,
    lng: -81.82461,
    city: "Mallory",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 580,
    density: 51.7,
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54045: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 54045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25635,
    lat: 37.71937,
    lng: -81.87261,
    city: "Man",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1681,
    density: 23,
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54045: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 54045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25637,
    lat: 37.85086,
    lng: -82.02805,
    city: "Mount Gay",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1065,
    density: 89.6,
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54045: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 54045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25638,
    lat: 37.74423,
    lng: -82.05133,
    city: "Omar",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 898,
    density: 21.4,
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54045: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 54045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25639,
    lat: 37.88674,
    lng: -81.95905,
    city: "Peach Creek",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 408,
    density: 26.2,
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54045: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 54045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25644,
    lat: 37.70191,
    lng: -82.00107,
    city: "Sarah Ann",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 584,
    density: 9.8,
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54045: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 54045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25646,
    lat: 37.83187,
    lng: -81.89349,
    city: "Stollings",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 995,
    density: 15.9,
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54045: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 54045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25647,
    lat: 37.786,
    lng: -81.98738,
    city: "Switzer",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 481,
    density: 70.7,
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54045: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 54045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25649,
    lat: 37.87166,
    lng: -82.08489,
    city: "Verdunville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1297,
    density: 40.1,
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54045: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 54045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25650,
    lat: 37.68358,
    lng: -81.78773,
    city: "Verner",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 344,
    density: 6.5,
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54045: 80.91,
      54059: 19.09,
    },
    county_names_all: "Logan|Mingo",
    county_fips_all: "54045|54059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25651,
    lat: 37.57142,
    lng: -81.9662,
    city: "Wharncliffe",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 612,
    density: 7.5,
    county_fips: 54059,
    county_name: "Mingo",
    county_weights: {
      54059: 100,
    },
    county_names_all: "Mingo",
    county_fips_all: 54059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25652,
    lat: 37.78702,
    lng: -82.04865,
    city: "Whitman",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1031,
    density: 27.5,
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54045: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 54045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25653,
    lat: 37.8287,
    lng: -81.9944,
    city: "Wilkinson",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 397,
    density: 137.7,
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54045: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 54045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25654,
    lat: 37.80302,
    lng: -81.87401,
    city: "Yolyn",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 193,
    density: 6.4,
    county_fips: 54045,
    county_name: "Logan",
    county_weights: {
      54045: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 54045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25661,
    lat: 37.71062,
    lng: -82.25377,
    city: "Williamson",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5791,
    density: 53.7,
    county_fips: 54059,
    county_name: "Mingo",
    county_weights: {
      54059: 100,
    },
    county_names_all: "Mingo",
    county_fips_all: 54059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25666,
    lat: 37.9203,
    lng: -82.29432,
    city: "Breeden",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 333,
    density: 14.3,
    county_fips: 54059,
    county_name: "Mingo",
    county_weights: {
      54059: 100,
    },
    county_names_all: "Mingo",
    county_fips_all: 54059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25667,
    lat: 37.70619,
    lng: -82.2738,
    city: "Chattaroy",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54059,
    county_name: "Mingo",
    county_weights: {
      54059: 100,
    },
    county_names_all: "Mingo",
    county_fips_all: 54059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25669,
    lat: 37.93186,
    lng: -82.4519,
    city: "Crum",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1151,
    density: 31.1,
    county_fips: 54099,
    county_name: "Wayne",
    county_weights: {
      54099: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 54099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25670,
    lat: 37.7385,
    lng: -82.15588,
    city: "Delbarton",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5435,
    density: 32.6,
    county_fips: 54059,
    county_name: "Mingo",
    county_weights: {
      54059: 100,
    },
    county_names_all: "Mingo",
    county_fips_all: 54059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25671,
    lat: 37.90411,
    lng: -82.20283,
    city: "Dingess",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1724,
    density: 14.1,
    county_fips: 54059,
    county_name: "Mingo",
    county_weights: {
      54043: 0.1,
      54059: 99.9,
    },
    county_names_all: "Mingo|Lincoln",
    county_fips_all: "54059|54043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25672,
    lat: 37.57017,
    lng: -82.10044,
    city: "Edgarton",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 296,
    density: 13.9,
    county_fips: 54059,
    county_name: "Mingo",
    county_weights: {
      54059: 100,
    },
    county_names_all: "Mingo",
    county_fips_all: 54059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25674,
    lat: 37.87114,
    lng: -82.34672,
    city: "Kermit",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2079,
    density: 15.6,
    county_fips: 54059,
    county_name: "Mingo",
    county_weights: {
      54059: 73.74,
      54099: 26.26,
    },
    county_names_all: "Mingo|Wayne",
    county_fips_all: "54059|54099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25676,
    lat: 37.82509,
    lng: -82.22972,
    city: "Lenore",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1380,
    density: 16.1,
    county_fips: 54059,
    county_name: "Mingo",
    county_weights: {
      54059: 100,
    },
    county_names_all: "Mingo",
    county_fips_all: 54059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25678,
    lat: 37.59564,
    lng: -82.08187,
    city: "Matewan",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1675,
    density: 33.2,
    county_fips: 54059,
    county_name: "Mingo",
    county_weights: {
      54059: 100,
    },
    county_names_all: "Mingo",
    county_fips_all: 54059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25685,
    lat: 37.79592,
    lng: -82.31426,
    city: "Naugatuck",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54059,
    county_name: "Mingo",
    county_weights: {
      54059: 100,
    },
    county_names_all: "Mingo",
    county_fips_all: 54059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25688,
    lat: 37.63952,
    lng: -82.15832,
    city: "North Matewan",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 264,
    density: 29.2,
    county_fips: 54059,
    county_name: "Mingo",
    county_weights: {
      54059: 100,
    },
    county_names_all: "Mingo",
    county_fips_all: 54059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25690,
    lat: 37.69124,
    lng: -82.15505,
    city: "Ragland",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54059,
    county_name: "Mingo",
    county_weights: {
      54059: 100,
    },
    county_names_all: "Mingo",
    county_fips_all: 54059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25692,
    lat: 37.61804,
    lng: -82.07375,
    city: "Red Jacket",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 964,
    density: 18,
    county_fips: 54059,
    county_name: "Mingo",
    county_weights: {
      54059: 100,
    },
    county_names_all: "Mingo",
    county_fips_all: 54059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25696,
    lat: 37.66116,
    lng: -82.07154,
    city: "Varney",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54059,
    county_name: "Mingo",
    county_weights: {
      54059: 100,
    },
    county_names_all: "Mingo",
    county_fips_all: 54059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25699,
    lat: 37.96297,
    lng: -82.31493,
    city: "Wilsondale",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 133,
    density: 2.6,
    county_fips: 54099,
    county_name: "Wayne",
    county_weights: {
      54043: 24.7,
      54099: 75.3,
    },
    county_names_all: "Wayne|Lincoln",
    county_fips_all: "54099|54043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25701,
    lat: 38.36809,
    lng: -82.41127,
    city: "Huntington",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19869,
    density: 197.1,
    county_fips: 54011,
    county_name: "Cabell",
    county_weights: {
      54011: 74.48,
      54099: 25.52,
    },
    county_names_all: "Cabell|Wayne",
    county_fips_all: "54011|54099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25702,
    lat: 38.43825,
    lng: -82.33344,
    city: "Huntington",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7286,
    density: 257,
    county_fips: 54011,
    county_name: "Cabell",
    county_weights: {
      54011: 100,
    },
    county_names_all: "Cabell",
    county_fips_all: 54011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25703,
    lat: 38.42201,
    lng: -82.41827,
    city: "Huntington",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7205,
    density: 2724.9,
    county_fips: 54011,
    county_name: "Cabell",
    county_weights: {
      54011: 100,
    },
    county_names_all: "Cabell",
    county_fips_all: 54011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25704,
    lat: 38.34969,
    lng: -82.50693,
    city: "Huntington",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16540,
    density: 206.8,
    county_fips: 54099,
    county_name: "Wayne",
    county_weights: {
      54011: 7.31,
      54099: 92.69,
    },
    county_names_all: "Wayne|Cabell",
    county_fips_all: "54099|54011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25705,
    lat: 38.40636,
    lng: -82.36276,
    city: "Huntington",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20690,
    density: 689.9,
    county_fips: 54011,
    county_name: "Cabell",
    county_weights: {
      54011: 100,
    },
    county_names_all: "Cabell",
    county_fips_all: 54011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25755,
    lat: 38.42359,
    lng: -82.42796,
    city: "Huntington",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54011,
    county_name: "Cabell",
    county_weights: {
      54011: 100,
    },
    county_names_all: "Cabell",
    county_fips_all: 54011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25801,
    lat: 37.83805,
    lng: -81.27017,
    city: "Beckley",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31694,
    density: 123.4,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25810,
    lat: 37.58355,
    lng: -81.34953,
    city: "Allen Junction",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29,
    density: 28,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25811,
    lat: 37.60835,
    lng: -81.3065,
    city: "Amigo",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29,
    density: 0.5,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 99.81,
      54109: 0.19,
    },
    county_names_all: "Raleigh|Wyoming",
    county_fips_all: "54081|54109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25812,
    lat: 38.14048,
    lng: -81.11512,
    city: "Ansted",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1710,
    density: 73.5,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25813,
    lat: 37.78309,
    lng: -81.10001,
    city: "Beaver",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8214,
    density: 69,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25817,
    lat: 37.76393,
    lng: -81.42191,
    city: "Bolt",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 588,
    density: 40,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25818,
    lat: 37.8608,
    lng: -81.19252,
    city: "Bradley",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 461,
    density: 347.3,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25820,
    lat: 37.50812,
    lng: -81.13549,
    city: "Camp Creek",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 401,
    density: 5.1,
    county_fips: 54055,
    county_name: "Mercer",
    county_weights: {
      54055: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 54055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25823,
    lat: 37.66626,
    lng: -81.18231,
    city: "Coal City",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1818,
    density: 36.6,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25825,
    lat: 37.64736,
    lng: -81.08862,
    city: "Cool Ridge",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3000,
    density: 52.2,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 85.72,
      54089: 14.28,
    },
    county_names_all: "Raleigh|Summers",
    county_fips_all: "54081|54089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25826,
    lat: 37.57291,
    lng: -81.36565,
    city: "Corinne",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 161,
    density: 68.3,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25827,
    lat: 37.73869,
    lng: -81.25368,
    city: "Crab Orchard",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1923,
    density: 134.1,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25831,
    lat: 37.95645,
    lng: -80.94037,
    city: "Danese",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1672,
    density: 11.1,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25832,
    lat: 37.72637,
    lng: -81.10494,
    city: "Daniels",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4065,
    density: 125.2,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25836,
    lat: 37.78693,
    lng: -81.27804,
    city: "Eccles",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 101,
    density: 4.9,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25837,
    lat: 38.06041,
    lng: -81.0383,
    city: "Edmond",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 400,
    density: 25,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25839,
    lat: 37.78091,
    lng: -81.38228,
    city: "Fairdale",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 295,
    density: 22.5,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25840,
    lat: 38.04001,
    lng: -81.11442,
    city: "Fayetteville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7634,
    density: 46,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25841,
    lat: 37.55325,
    lng: -81.09061,
    city: "Flat Top",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 469,
    density: 5.8,
    county_fips: 54055,
    county_name: "Mercer",
    county_weights: {
      54055: 89.02,
      54089: 10.98,
    },
    county_names_all: "Mercer|Summers",
    county_fips_all: "54055|54089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25843,
    lat: 37.62129,
    lng: -81.14129,
    city: "Ghent",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 935,
    density: 25,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25844,
    lat: 37.81056,
    lng: -81.37022,
    city: "Glen Daniel",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1206,
    density: 31.6,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25845,
    lat: 37.70291,
    lng: -81.51107,
    city: "Glen Fork",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 538,
    density: 18.5,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25846,
    lat: 37.92476,
    lng: -81.16628,
    city: "Glen Jean",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 240,
    density: 72.5,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25848,
    lat: 37.71427,
    lng: -81.43117,
    city: "Glen Rogers",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 265,
    density: 10.8,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25849,
    lat: 37.73175,
    lng: -81.27799,
    city: "Glen White",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 648,
    density: 362.3,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25851,
    lat: 37.80177,
    lng: -81.26154,
    city: "Harper",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25853,
    lat: 37.64616,
    lng: -81.27827,
    city: "Helen",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25854,
    lat: 38.12629,
    lng: -80.97537,
    city: "Hico",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1088,
    density: 15.2,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25855,
    lat: 37.94052,
    lng: -81.15296,
    city: "Hilltop",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 312,
    density: 257.1,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25857,
    lat: 37.61443,
    lng: -81.23288,
    city: "Josephine",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68,
    density: 2.4,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25862,
    lat: 38.08448,
    lng: -81.05192,
    city: "Lansing",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 169,
    density: 20.1,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25864,
    lat: 37.87948,
    lng: -81.01781,
    city: "Layland",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 196,
    density: 3.6,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 85.94,
      54081: 14.06,
    },
    county_names_all: "Fayette|Raleigh",
    county_fips_all: "54019|54081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25865,
    lat: 37.73076,
    lng: -81.35212,
    city: "Lester",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1239,
    density: 15.7,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25866,
    lat: 38.00883,
    lng: -81.15738,
    city: "Lochgelly",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25868,
    lat: 38.07172,
    lng: -80.96461,
    city: "Lookout",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 563,
    density: 16.9,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25870,
    lat: 37.63931,
    lng: -81.3813,
    city: "Maben",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25871,
    lat: 37.76917,
    lng: -81.21165,
    city: "Mabscott",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 810,
    density: 463.1,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25873,
    lat: 37.75136,
    lng: -81.21515,
    city: "MacArthur",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 678,
    density: 382,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25875,
    lat: 37.66907,
    lng: -81.45956,
    city: "McGraws",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1065,
    density: 34.3,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25876,
    lat: 37.63677,
    lng: -81.44731,
    city: "Saulsville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47,
    density: 9,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25878,
    lat: 37.71303,
    lng: -81.22464,
    city: "Midway",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 747,
    density: 62.2,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25879,
    lat: 37.98048,
    lng: -81.10453,
    city: "Minden",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 194,
    density: 44.9,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25880,
    lat: 37.87672,
    lng: -81.20095,
    city: "Mount Hope",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6539,
    density: 86.3,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54019: 31.31,
      54081: 68.69,
    },
    county_names_all: "Raleigh|Fayette",
    county_fips_all: "54081|54019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25882,
    lat: 37.60359,
    lng: -81.39892,
    city: "Mullens",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2066,
    density: 84.9,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25901,
    lat: 37.93575,
    lng: -81.11242,
    city: "Oak Hill",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11498,
    density: 115.6,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25902,
    lat: 37.56301,
    lng: -81.21115,
    city: "Odd",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 191,
    density: 2.9,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54055: 24.98,
      54081: 75.02,
    },
    county_names_all: "Raleigh|Mercer",
    county_fips_all: "54081|54055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25904,
    lat: 37.9128,
    lng: -81.25213,
    city: "Pax",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 306,
    density: 6.3,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25907,
    lat: 37.8593,
    lng: -81.07196,
    city: "Prince",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 186,
    density: 38.7,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25908,
    lat: 37.66782,
    lng: -81.24434,
    city: "Princewick",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 172,
    density: 37.5,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25909,
    lat: 37.83687,
    lng: -81.20192,
    city: "Prosperity",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25911,
    lat: 37.75232,
    lng: -81.17848,
    city: "Raleigh",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25913,
    lat: 37.70781,
    lng: -81.47301,
    city: "Ravencliff",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 324,
    density: 62.7,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25915,
    lat: 37.61575,
    lng: -81.28691,
    city: "Rhodell",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 165,
    density: 16.5,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25916,
    lat: 37.67818,
    lng: -81.49019,
    city: "Sabine",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 314,
    density: 84.7,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25917,
    lat: 37.97944,
    lng: -81.25021,
    city: "Scarbro",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1751,
    density: 15.3,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25918,
    lat: 37.74575,
    lng: -81.00993,
    city: "Shady Spring",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4555,
    density: 28,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25920,
    lat: 37.68646,
    lng: -81.33661,
    city: "Slab Fork",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 295,
    density: 20.1,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25921,
    lat: 37.69181,
    lng: -81.25882,
    city: "Sophia",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1844,
    density: 55.5,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25922,
    lat: 37.47147,
    lng: -81.09966,
    city: "Spanishburg",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 318,
    density: 44.6,
    county_fips: 54055,
    county_name: "Mercer",
    county_weights: {
      54055: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 54055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25928,
    lat: 37.55481,
    lng: -81.34126,
    city: "Stephenson",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 341,
    density: 9,
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25932,
    lat: 37.75623,
    lng: -81.30282,
    city: "Surveyor",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 413,
    density: 57.4,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25936,
    lat: 37.92917,
    lng: -81.03105,
    city: "Thurmond",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25938,
    lat: 38.15993,
    lng: -81.03447,
    city: "Victor",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1127,
    density: 10,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25942,
    lat: 38.02691,
    lng: -80.98836,
    city: "Winona",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 160,
    density: 4,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25943,
    lat: 37.59657,
    lng: -81.34914,
    city: "Wyco",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54109,
    county_name: "Wyoming",
    county_weights: {
      54109: 100,
    },
    county_names_all: "Wyoming",
    county_fips_all: 54109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25951,
    lat: 37.65535,
    lng: -80.87197,
    city: "Hinton",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6166,
    density: 21,
    county_fips: 54089,
    county_name: "Summers",
    county_weights: {
      54081: 11.29,
      54089: 88.71,
    },
    county_names_all: "Summers|Raleigh",
    county_fips_all: "54089|54081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25958,
    lat: 38.02156,
    lng: -80.76077,
    city: "Charmco",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 788,
    density: 15.1,
    county_fips: 54025,
    county_name: "Greenbrier",
    county_weights: {
      54025: 100,
    },
    county_names_all: "Greenbrier",
    county_fips_all: 54025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25962,
    lat: 37.97044,
    lng: -80.8098,
    city: "Rainelle",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3034,
    density: 15.4,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 62.11,
      54025: 37.89,
    },
    county_names_all: "Fayette|Greenbrier",
    county_fips_all: "54019|54025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25966,
    lat: 37.7975,
    lng: -80.76729,
    city: "Green Sulphur Springs",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54089,
    county_name: "Summers",
    county_weights: {
      54089: 100,
    },
    county_names_all: "Summers",
    county_fips_all: 54089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25969,
    lat: 37.61657,
    lng: -81.00903,
    city: "Jumping Branch",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1013,
    density: 10.4,
    county_fips: 54089,
    county_name: "Summers",
    county_weights: {
      54081: 0.31,
      54089: 99.69,
    },
    county_names_all: "Summers|Raleigh",
    county_fips_all: "54089|54081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25971,
    lat: 37.48001,
    lng: -80.97821,
    city: "Lerona",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1083,
    density: 22.8,
    county_fips: 54055,
    county_name: "Mercer",
    county_weights: {
      54055: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 54055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25972,
    lat: 38.03576,
    lng: -80.7222,
    city: "Leslie",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 272,
    density: 15.1,
    county_fips: 54025,
    county_name: "Greenbrier",
    county_weights: {
      54025: 100,
    },
    county_names_all: "Greenbrier",
    county_fips_all: 54025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25976,
    lat: 37.84372,
    lng: -80.86221,
    city: "Meadow Bridge",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2626,
    density: 13.7,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 43.27,
      54025: 16.6,
      54089: 40.13,
    },
    county_names_all: "Fayette|Summers|Greenbrier",
    county_fips_all: "54019|54089|54025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25977,
    lat: 37.80819,
    lng: -80.90571,
    city: "Meadow Creek",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 84,
    density: 8.6,
    county_fips: 54089,
    county_name: "Summers",
    county_weights: {
      54089: 100,
    },
    county_names_all: "Summers",
    county_fips_all: 54089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25978,
    lat: 37.62861,
    lng: -80.94138,
    city: "Nimitz",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 644,
    density: 16.6,
    county_fips: 54089,
    county_name: "Summers",
    county_weights: {
      54089: 100,
    },
    county_names_all: "Summers",
    county_fips_all: 54089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25979,
    lat: 37.5126,
    lng: -80.91736,
    city: "Pipestem",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 671,
    density: 5.7,
    county_fips: 54089,
    county_name: "Summers",
    county_weights: {
      54055: 6.94,
      54089: 93.06,
    },
    county_names_all: "Summers|Mercer",
    county_fips_all: "54089|54055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25981,
    lat: 38.08321,
    lng: -80.70274,
    city: "Quinwood",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 584,
    density: 3.9,
    county_fips: 54025,
    county_name: "Greenbrier",
    county_weights: {
      54025: 72.16,
      54067: 27.84,
    },
    county_names_all: "Greenbrier|Nicholas",
    county_fips_all: "54025|54067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25984,
    lat: 38.01409,
    lng: -80.6026,
    city: "Rupert",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1986,
    density: 13.6,
    county_fips: 54025,
    county_name: "Greenbrier",
    county_weights: {
      54025: 100,
    },
    county_names_all: "Greenbrier",
    county_fips_all: 54025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25985,
    lat: 37.75752,
    lng: -80.83044,
    city: "Sandstone",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 521,
    density: 10.1,
    county_fips: 54089,
    county_name: "Summers",
    county_weights: {
      54089: 100,
    },
    county_names_all: "Summers",
    county_fips_all: 54089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25986,
    lat: 37.89395,
    lng: -80.81741,
    city: "Spring Dale",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 54019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 25989,
    lat: 37.67864,
    lng: -81.04594,
    city: "White Oak",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9,
    density: 0.8,
    county_fips: 54081,
    county_name: "Raleigh",
    county_weights: {
      54081: 100,
    },
    county_names_all: "Raleigh",
    county_fips_all: 54081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26003,
    lat: 40.0693,
    lng: -80.6508,
    city: "Wheeling",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41196,
    density: 174.6,
    county_fips: 54069,
    county_name: "Ohio",
    county_weights: {
      54009: 4.02,
      54051: 33.47,
      54069: 62.51,
    },
    county_names_all: "Ohio|Marshall|Brooke",
    county_fips_all: "54069|54051|54009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26030,
    lat: 40.21662,
    lng: -80.65965,
    city: "Beech Bottom",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 625,
    density: 205.1,
    county_fips: 54009,
    county_name: "Brooke",
    county_weights: {
      54009: 100,
    },
    county_names_all: "Brooke",
    county_fips_all: 54009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26031,
    lat: 40.00236,
    lng: -80.71985,
    city: "Benwood",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1525,
    density: 117.4,
    county_fips: 54051,
    county_name: "Marshall",
    county_weights: {
      54051: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 54051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26032,
    lat: 40.18646,
    lng: -80.55024,
    city: "Bethany",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1088,
    density: 36.6,
    county_fips: 54009,
    county_name: "Brooke",
    county_weights: {
      54009: 89.55,
      54069: 10.45,
    },
    county_names_all: "Brooke|Ohio",
    county_fips_all: "54009|54069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26033,
    lat: 39.8284,
    lng: -80.57985,
    city: "Cameron",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1733,
    density: 7,
    county_fips: 54051,
    county_name: "Marshall",
    county_weights: {
      54051: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 54051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26034,
    lat: 40.59404,
    lng: -80.55258,
    city: "Chester",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4397,
    density: 112.3,
    county_fips: 54029,
    county_name: "Hancock",
    county_weights: {
      54029: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 54029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26035,
    lat: 40.3482,
    lng: -80.55522,
    city: "Colliers",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1815,
    density: 40.1,
    county_fips: 54009,
    county_name: "Brooke",
    county_weights: {
      54009: 100,
    },
    county_names_all: "Brooke",
    county_fips_all: 54009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26036,
    lat: 39.98406,
    lng: -80.54339,
    city: "Dallas",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 436,
    density: 14.6,
    county_fips: 54051,
    county_name: "Marshall",
    county_weights: {
      54051: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 54051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26037,
    lat: 40.3344,
    lng: -80.58494,
    city: "Follansbee",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6196,
    density: 351.4,
    county_fips: 54009,
    county_name: "Brooke",
    county_weights: {
      54009: 100,
    },
    county_names_all: "Brooke",
    county_fips_all: 54009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26038,
    lat: 39.96329,
    lng: -80.72595,
    city: "Glen Dale",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3580,
    density: 226.5,
    county_fips: 54051,
    county_name: "Marshall",
    county_weights: {
      54051: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 54051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26039,
    lat: 39.81641,
    lng: -80.66969,
    city: "Glen Easton",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 542,
    density: 5.8,
    county_fips: 54051,
    county_name: "Marshall",
    county_weights: {
      54051: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 54051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26040,
    lat: 39.98389,
    lng: -80.73104,
    city: "Mcmechen",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1982,
    density: 1017.3,
    county_fips: 54051,
    county_name: "Marshall",
    county_weights: {
      54051: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 54051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26041,
    lat: 39.89764,
    lng: -80.7107,
    city: "Moundsville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15585,
    density: 95.5,
    county_fips: 54051,
    county_name: "Marshall",
    county_weights: {
      54051: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 54051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26047,
    lat: 40.53223,
    lng: -80.5837,
    city: "New Cumberland",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6175,
    density: 57.3,
    county_fips: 54029,
    county_name: "Hancock",
    county_weights: {
      54029: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 54029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26050,
    lat: 40.60108,
    lng: -80.62646,
    city: "Newell",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1659,
    density: 269.5,
    county_fips: 54029,
    county_name: "Hancock",
    county_weights: {
      54029: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 54029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26055,
    lat: 39.75338,
    lng: -80.77396,
    city: "Proctor",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1053,
    density: 5.5,
    county_fips: 54051,
    county_name: "Marshall",
    county_weights: {
      54051: 72.37,
      54103: 27.63,
    },
    county_names_all: "Marshall|Wetzel",
    county_fips_all: "54051|54103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26056,
    lat: 40.5211,
    lng: -80.57022,
    city: "New Manchester",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54029,
    county_name: "Hancock",
    county_weights: {
      54029: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 54029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26058,
    lat: 40.18622,
    lng: -80.66453,
    city: "Short Creek",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54009,
    county_name: "Brooke",
    county_weights: {
      54009: 99.54,
      54069: 0.46,
    },
    county_names_all: "Brooke|Ohio",
    county_fips_all: "54009|54069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26059,
    lat: 40.07156,
    lng: -80.59379,
    city: "Triadelphia",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2806,
    density: 46.5,
    county_fips: 54069,
    county_name: "Ohio",
    county_weights: {
      54069: 100,
    },
    county_names_all: "Ohio",
    county_fips_all: 54069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26060,
    lat: 40.10465,
    lng: -80.54649,
    city: "Valley Grove",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1743,
    density: 27.7,
    county_fips: 54069,
    county_name: "Ohio",
    county_weights: {
      54069: 100,
    },
    county_names_all: "Ohio",
    county_fips_all: 54069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26062,
    lat: 40.42189,
    lng: -80.56123,
    city: "Weirton",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20493,
    density: 285.4,
    county_fips: 54029,
    county_name: "Hancock",
    county_weights: {
      54009: 23.73,
      54029: 76.27,
    },
    county_names_all: "Hancock|Brooke",
    county_fips_all: "54029|54009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26070,
    lat: 40.25008,
    lng: -80.58037,
    city: "Wellsburg",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8028,
    density: 77.6,
    county_fips: 54009,
    county_name: "Brooke",
    county_weights: {
      54009: 100,
    },
    county_names_all: "Brooke",
    county_fips_all: 54009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26074,
    lat: 40.16889,
    lng: -80.59813,
    city: "West Liberty",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1205,
    density: 477.2,
    county_fips: 54069,
    county_name: "Ohio",
    county_weights: {
      54069: 100,
    },
    county_names_all: "Ohio",
    county_fips_all: 54069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26075,
    lat: 40.19748,
    lng: -80.64567,
    city: "Windsor Heights",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 558,
    density: 70.1,
    county_fips: 54009,
    county_name: "Brooke",
    county_weights: {
      54009: 100,
    },
    county_names_all: "Brooke",
    county_fips_all: 54009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26101,
    lat: 39.23394,
    lng: -81.57483,
    city: "Parkersburg",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28644,
    density: 359.1,
    county_fips: 54107,
    county_name: "Wood",
    county_weights: {
      54107: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 54107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26104,
    lat: 39.27413,
    lng: -81.47779,
    city: "Parkersburg",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16228,
    density: 169.1,
    county_fips: 54107,
    county_name: "Wood",
    county_weights: {
      54107: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 54107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26105,
    lat: 39.32949,
    lng: -81.52267,
    city: "Vienna",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11659,
    density: 377.9,
    county_fips: 54107,
    county_name: "Wood",
    county_weights: {
      54107: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 54107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26133,
    lat: 39.11973,
    lng: -81.66968,
    city: "Belleville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1425,
    density: 13.7,
    county_fips: 54107,
    county_name: "Wood",
    county_weights: {
      54107: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 54107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26134,
    lat: 39.37686,
    lng: -81.27544,
    city: "Belmont",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 908,
    density: 440.4,
    county_fips: 54073,
    county_name: "Pleasants",
    county_weights: {
      54073: 100,
    },
    county_names_all: "Pleasants",
    county_fips_all: 54073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26136,
    lat: 38.96553,
    lng: -81.11478,
    city: "Big Bend",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 533,
    density: 12.7,
    county_fips: 54013,
    county_name: "Calhoun",
    county_weights: {
      54013: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 54013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26137,
    lat: 39.00647,
    lng: -81.0385,
    city: "Big Springs",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 488,
    density: 3.7,
    county_fips: 54021,
    county_name: "Gilmer",
    county_weights: {
      54013: 34.41,
      54021: 44.14,
      54085: 21.46,
    },
    county_names_all: "Gilmer|Calhoun|Ritchie",
    county_fips_all: "54021|54013|54085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26138,
    lat: 39.02114,
    lng: -81.18155,
    city: "Brohard",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62,
    density: 2.1,
    county_fips: 54013,
    county_name: "Calhoun",
    county_weights: {
      54013: 55.98,
      54105: 44.02,
    },
    county_names_all: "Calhoun|Wirt",
    county_fips_all: "54013|54105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26141,
    lat: 38.92925,
    lng: -81.26059,
    city: "Creston",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 380,
    density: 3.8,
    county_fips: 54013,
    county_name: "Calhoun",
    county_weights: {
      54013: 52.17,
      54105: 47.83,
    },
    county_names_all: "Calhoun|Wirt",
    county_fips_all: "54013|54105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26142,
    lat: 39.21488,
    lng: -81.45431,
    city: "Davisville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2490,
    density: 90.8,
    county_fips: 54107,
    county_name: "Wood",
    county_weights: {
      54107: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 54107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26143,
    lat: 39.06338,
    lng: -81.3764,
    city: "Elizabeth",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4517,
    density: 13,
    county_fips: 54105,
    county_name: "Wirt",
    county_weights: {
      54035: 2.66,
      54085: 5.06,
      54105: 85.28,
      54107: 7,
    },
    county_names_all: "Wirt|Wood|Ritchie|Jackson",
    county_fips_all: "54105|54107|54085|54035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26146,
    lat: 39.45053,
    lng: -81.03601,
    city: "Friendly",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 995,
    density: 8.3,
    county_fips: 54095,
    county_name: "Tyler",
    county_weights: {
      54073: 37.28,
      54095: 62.72,
    },
    county_names_all: "Tyler|Pleasants",
    county_fips_all: "54095|54073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26147,
    lat: 38.91368,
    lng: -81.07629,
    city: "Grantsville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2249,
    density: 18.8,
    county_fips: 54013,
    county_name: "Calhoun",
    county_weights: {
      54013: 92.32,
      54021: 7.68,
    },
    county_names_all: "Calhoun|Gilmer",
    county_fips_all: "54013|54021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26148,
    lat: 39.07122,
    lng: -81.18088,
    city: "Macfarlan",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 281,
    density: 6,
    county_fips: 54085,
    county_name: "Ritchie",
    county_weights: {
      54085: 100,
    },
    county_names_all: "Ritchie",
    county_fips_all: 54085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26149,
    lat: 39.47429,
    lng: -80.88269,
    city: "Middlebourne",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2002,
    density: 10.7,
    county_fips: 54095,
    county_name: "Tyler",
    county_weights: {
      54095: 100,
    },
    county_names_all: "Tyler",
    county_fips_all: 54095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26150,
    lat: 39.1566,
    lng: -81.53697,
    city: "Mineral Wells",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6030,
    density: 53,
    county_fips: 54107,
    county_name: "Wood",
    county_weights: {
      54107: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 54107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26151,
    lat: 38.89493,
    lng: -81.17503,
    city: "Mount Zion",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 673,
    density: 9.9,
    county_fips: 54013,
    county_name: "Calhoun",
    county_weights: {
      54013: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 54013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26152,
    lat: 38.98355,
    lng: -81.19308,
    city: "Munday",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9,
    density: 0.4,
    county_fips: 54013,
    county_name: "Calhoun",
    county_weights: {
      54013: 71.12,
      54105: 28.88,
    },
    county_names_all: "Calhoun|Wirt",
    county_fips_all: "54013|54105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26155,
    lat: 39.6333,
    lng: -80.76707,
    city: "New Martinsville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7599,
    density: 25.8,
    county_fips: 54103,
    county_name: "Wetzel",
    county_weights: {
      54051: 1.96,
      54095: 12.53,
      54103: 85.51,
    },
    county_names_all: "Wetzel|Tyler|Marshall",
    county_fips_all: "54103|54095|54051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26159,
    lat: 39.60724,
    lng: -80.93216,
    city: "Paden City",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3016,
    density: 1147,
    county_fips: 54103,
    county_name: "Wetzel",
    county_weights: {
      54095: 24.01,
      54103: 75.99,
    },
    county_names_all: "Wetzel|Tyler",
    county_fips_all: "54103|54095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26160,
    lat: 38.98066,
    lng: -81.41368,
    city: "Palestine",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1034,
    density: 5.8,
    county_fips: 54105,
    county_name: "Wirt",
    county_weights: {
      54105: 100,
    },
    county_names_all: "Wirt",
    county_fips_all: 54105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26161,
    lat: 39.16789,
    lng: -81.2526,
    city: "Petroleum",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 632,
    density: 4.9,
    county_fips: 54085,
    county_name: "Ritchie",
    county_weights: {
      54085: 100,
    },
    county_names_all: "Ritchie",
    county_fips_all: 54085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26162,
    lat: 39.57231,
    lng: -80.76572,
    city: "Porters Falls",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54103,
    county_name: "Wetzel",
    county_weights: {
      54103: 100,
    },
    county_names_all: "Wetzel",
    county_fips_all: 54103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26164,
    lat: 38.99061,
    lng: -81.71949,
    city: "Ravenswood",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7690,
    density: 29,
    county_fips: 54035,
    county_name: "Jackson",
    county_weights: {
      54035: 97.3,
      54107: 2.7,
    },
    county_names_all: "Jackson|Wood",
    county_fips_all: "54035|54107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26167,
    lat: 39.53454,
    lng: -80.71429,
    city: "Reader",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 893,
    density: 10.3,
    county_fips: 54103,
    county_name: "Wetzel",
    county_weights: {
      54103: 100,
    },
    county_names_all: "Wetzel",
    county_fips_all: 54103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26169,
    lat: 39.07291,
    lng: -81.57121,
    city: "Rockport",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 605,
    density: 9,
    county_fips: 54107,
    county_name: "Wood",
    county_weights: {
      54107: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 54107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26170,
    lat: 39.36136,
    lng: -81.17136,
    city: "Saint Marys",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6023,
    density: 21.4,
    county_fips: 54073,
    county_name: "Pleasants",
    county_weights: {
      54073: 96.45,
      54085: 3.55,
    },
    county_names_all: "Pleasants|Ritchie",
    county_fips_all: "54073|54085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26175,
    lat: 39.53899,
    lng: -80.96577,
    city: "Sistersville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3631,
    density: 34,
    county_fips: 54095,
    county_name: "Tyler",
    county_weights: {
      54095: 100,
    },
    county_names_all: "Tyler",
    county_fips_all: 54095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26178,
    lat: 39.06001,
    lng: -81.02888,
    city: "Smithville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 191,
    density: 2,
    county_fips: 54085,
    county_name: "Ritchie",
    county_weights: {
      54085: 100,
    },
    county_names_all: "Ritchie",
    county_fips_all: 54085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26180,
    lat: 39.20016,
    lng: -81.36699,
    city: "Walker",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1980,
    density: 11.4,
    county_fips: 54107,
    county_name: "Wood",
    county_weights: {
      54105: 12.2,
      54107: 87.8,
    },
    county_names_all: "Wood|Wirt",
    county_fips_all: "54107|54105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26181,
    lat: 39.20707,
    lng: -81.6733,
    city: "Washington",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6821,
    density: 67.7,
    county_fips: 54107,
    county_name: "Wood",
    county_weights: {
      54107: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 54107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26184,
    lat: 39.29739,
    lng: -81.35086,
    city: "Waverly",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2547,
    density: 25,
    county_fips: 54107,
    county_name: "Wood",
    county_weights: {
      54073: 13.01,
      54107: 86.99,
    },
    county_names_all: "Wood|Pleasants",
    county_fips_all: "54107|54073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26187,
    lat: 39.36711,
    lng: -81.44894,
    city: "Williamstown",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6169,
    density: 110.6,
    county_fips: 54107,
    county_name: "Wood",
    county_weights: {
      54107: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 54107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26201,
    lat: 39.00082,
    lng: -80.20249,
    city: "Buckhannon",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20019,
    density: 44,
    county_fips: 54097,
    county_name: "Upshur",
    county_weights: {
      54001: 8.3,
      54041: 3.69,
      54097: 88.01,
    },
    county_names_all: "Upshur|Barbour|Lewis",
    county_fips_all: "54097|54001|54041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26202,
    lat: 38.22657,
    lng: -80.62639,
    city: "Fenwick",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 482,
    density: 10.6,
    county_fips: 54067,
    county_name: "Nicholas",
    county_weights: {
      54067: 100,
    },
    county_names_all: "Nicholas",
    county_fips_all: 54067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26203,
    lat: 38.53136,
    lng: -80.60149,
    city: "Erbacon",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 173,
    density: 1.7,
    county_fips: 54101,
    county_name: "Webster",
    county_weights: {
      54007: 7.3,
      54067: 7.8,
      54101: 84.9,
    },
    county_names_all: "Webster|Nicholas|Braxton",
    county_fips_all: "54101|54067|54007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26205,
    lat: 38.32078,
    lng: -80.64828,
    city: "Craigsville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3469,
    density: 59.1,
    county_fips: 54067,
    county_name: "Nicholas",
    county_weights: {
      54067: 100,
    },
    county_names_all: "Nicholas",
    county_fips_all: 54067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26206,
    lat: 38.36992,
    lng: -80.47848,
    city: "Cowen",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3012,
    density: 10.4,
    county_fips: 54101,
    county_name: "Webster",
    county_weights: {
      54101: 100,
    },
    county_names_all: "Webster",
    county_fips_all: 54101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26208,
    lat: 38.34781,
    lng: -80.57314,
    city: "Camden On Gauley",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 865,
    density: 8.4,
    county_fips: 54101,
    county_name: "Webster",
    county_weights: {
      54067: 35.13,
      54101: 64.87,
    },
    county_names_all: "Webster|Nicholas",
    county_fips_all: "54101|54067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26209,
    lat: 38.39401,
    lng: -80.04434,
    city: "Snowshoe",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 168,
    density: 1.6,
    county_fips: 54075,
    county_name: "Pocahontas",
    county_weights: {
      54075: 100,
    },
    county_names_all: "Pocahontas",
    county_fips_all: 54075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26210,
    lat: 38.90315,
    lng: -80.27812,
    city: "Adrian",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54097,
    county_name: "Upshur",
    county_weights: {
      54097: 100,
    },
    county_names_all: "Upshur",
    county_fips_all: 54097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26215,
    lat: 38.71931,
    lng: -80.37915,
    city: "Cleveland",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36,
    density: 3.3,
    county_fips: 54101,
    county_name: "Webster",
    county_weights: {
      54041: 0.15,
      54101: 99.85,
    },
    county_names_all: "Webster|Lewis",
    county_fips_all: "54101|54041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26217,
    lat: 38.60837,
    lng: -80.45901,
    city: "Diana",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 122,
    density: 1.6,
    county_fips: 54101,
    county_name: "Webster",
    county_weights: {
      54101: 100,
    },
    county_names_all: "Webster",
    county_fips_all: 54101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26218,
    lat: 38.84506,
    lng: -80.26798,
    city: "French Creek",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2931,
    density: 16.4,
    county_fips: 54097,
    county_name: "Upshur",
    county_weights: {
      54097: 100,
    },
    county_names_all: "Upshur",
    county_fips_all: 54097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26222,
    lat: 38.66123,
    lng: -80.37122,
    city: "Hacker Valley",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 244,
    density: 1.2,
    county_fips: 54101,
    county_name: "Webster",
    county_weights: {
      54101: 100,
    },
    county_names_all: "Webster",
    county_fips_all: 54101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26224,
    lat: 38.74485,
    lng: -80.17474,
    city: "Helvetia",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 255,
    density: 3.2,
    county_fips: 54083,
    county_name: "Randolph",
    county_weights: {
      54083: 52.59,
      54097: 47.41,
    },
    county_names_all: "Randolph|Upshur",
    county_fips_all: "54083|54097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26228,
    lat: 38.75437,
    lng: -80.37054,
    city: "Kanawha Head",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 54097,
    county_name: "Upshur",
    county_weights: {
      54097: 100,
    },
    county_names_all: "Upshur",
    county_fips_all: 54097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26230,
    lat: 38.6437,
    lng: -80.18881,
    city: "Pickens",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 77,
    density: 0.6,
    county_fips: 54083,
    county_name: "Randolph",
    county_weights: {
      54083: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 54083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26234,
    lat: 38.76618,
    lng: -80.30833,
    city: "Rock Cave",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1190,
    density: 10,
    county_fips: 54097,
    county_name: "Upshur",
    county_weights: {
      54097: 100,
    },
    county_names_all: "Upshur",
    county_fips_all: 54097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26236,
    lat: 38.71755,
    lng: -80.23088,
    city: "Selbyville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54083,
    county_name: "Randolph",
    county_weights: {
      54083: 94.69,
      54097: 5.31,
    },
    county_names_all: "Randolph|Upshur",
    county_fips_all: "54083|54097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26237,
    lat: 38.84769,
    lng: -80.15145,
    city: "Tallmansville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 461,
    density: 5,
    county_fips: 54097,
    county_name: "Upshur",
    county_weights: {
      54097: 100,
    },
    county_names_all: "Upshur",
    county_fips_all: 54097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26238,
    lat: 39.10178,
    lng: -80.1584,
    city: "Volga",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 784,
    density: 14.5,
    county_fips: 54001,
    county_name: "Barbour",
    county_weights: {
      54001: 89.21,
      54097: 10.79,
    },
    county_names_all: "Barbour|Upshur",
    county_fips_all: "54001|54097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26241,
    lat: 38.9163,
    lng: -79.79229,
    city: "Elkins",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13352,
    density: 49.3,
    county_fips: 54083,
    county_name: "Randolph",
    county_weights: {
      54083: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 54083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26250,
    lat: 39.02757,
    lng: -79.96198,
    city: "Belington",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5972,
    density: 25.2,
    county_fips: 54001,
    county_name: "Barbour",
    county_weights: {
      54001: 90.79,
      54083: 9.21,
    },
    county_names_all: "Barbour|Randolph",
    county_fips_all: "54001|54083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26253,
    lat: 38.80772,
    lng: -79.85654,
    city: "Beverly",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3790,
    density: 24.4,
    county_fips: 54083,
    county_name: "Randolph",
    county_weights: {
      54083: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 54083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26254,
    lat: 38.91261,
    lng: -79.65341,
    city: "Bowden",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 157,
    density: 0.5,
    county_fips: 54083,
    county_name: "Randolph",
    county_weights: {
      54083: 87.15,
      54093: 12.85,
    },
    county_names_all: "Randolph|Tucker",
    county_fips_all: "54083|54093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26257,
    lat: 38.9226,
    lng: -80.01239,
    city: "Coalton",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1110,
    density: 27.2,
    county_fips: 54083,
    county_name: "Randolph",
    county_weights: {
      54083: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 54083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26259,
    lat: 38.82536,
    lng: -79.91528,
    city: "Dailey",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54083,
    county_name: "Randolph",
    county_weights: {
      54083: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 54083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26260,
    lat: 39.08923,
    lng: -79.41147,
    city: "Davis",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1546,
    density: 4.2,
    county_fips: 54093,
    county_name: "Tucker",
    county_weights: {
      54093: 100,
    },
    county_names_all: "Tucker",
    county_fips_all: 54093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26261,
    lat: 38.18881,
    lng: -80.50454,
    city: "Richwood",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2855,
    density: 6.7,
    county_fips: 54025,
    county_name: "Greenbrier",
    county_weights: {
      54025: 66.89,
      54067: 33.11,
    },
    county_names_all: "Greenbrier|Nicholas",
    county_fips_all: "54025|54067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26263,
    lat: 38.95705,
    lng: -79.43586,
    city: "Dryfork",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 123,
    density: 1.3,
    county_fips: 54083,
    county_name: "Randolph",
    county_weights: {
      54083: 73.92,
      54093: 26.08,
    },
    county_names_all: "Randolph|Tucker",
    county_fips_all: "54083|54093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26264,
    lat: 38.58923,
    lng: -79.82277,
    city: "Durbin",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 590,
    density: 3.2,
    county_fips: 54075,
    county_name: "Pocahontas",
    county_weights: {
      54075: 100,
    },
    county_names_all: "Pocahontas",
    county_fips_all: 54075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26266,
    lat: 38.43411,
    lng: -80.50219,
    city: "Upperglade",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 88,
    density: 8.4,
    county_fips: 54101,
    county_name: "Webster",
    county_weights: {
      54101: 100,
    },
    county_names_all: "Webster",
    county_fips_all: 54101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26267,
    lat: 38.92557,
    lng: -80.08069,
    city: "Ellamore",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 608,
    density: 10.1,
    county_fips: 54083,
    county_name: "Randolph",
    county_weights: {
      54001: 2.17,
      54083: 62.39,
      54097: 35.44,
    },
    county_names_all: "Randolph|Upshur|Barbour",
    county_fips_all: "54083|54097|54001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26268,
    lat: 38.71457,
    lng: -79.82276,
    city: "Glady",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52,
    density: 0.4,
    county_fips: 54083,
    county_name: "Randolph",
    county_weights: {
      54083: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 54083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26269,
    lat: 39.11612,
    lng: -79.61617,
    city: "Hambleton",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 894,
    density: 14.7,
    county_fips: 54093,
    county_name: "Tucker",
    county_weights: {
      54093: 100,
    },
    county_names_all: "Tucker",
    county_fips_all: 54093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26270,
    lat: 38.81229,
    lng: -79.60034,
    city: "Harman",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 341,
    density: 1.2,
    county_fips: 54083,
    county_name: "Randolph",
    county_weights: {
      54083: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 54083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26271,
    lat: 39.049,
    lng: -79.55194,
    city: "Hendricks",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 502,
    density: 8.3,
    county_fips: 54093,
    county_name: "Tucker",
    county_weights: {
      54093: 100,
    },
    county_names_all: "Tucker",
    county_fips_all: 54093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26273,
    lat: 38.62993,
    lng: -79.963,
    city: "Huttonsville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1841,
    density: 7.4,
    county_fips: 54083,
    county_name: "Randolph",
    county_weights: {
      54083: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 54083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26275,
    lat: 38.98313,
    lng: -79.94583,
    city: "Junior",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 483,
    density: 41.1,
    county_fips: 54001,
    county_name: "Barbour",
    county_weights: {
      54001: 100,
    },
    county_names_all: "Barbour",
    county_fips_all: 54001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26276,
    lat: 39.03201,
    lng: -79.75659,
    city: "Kerens",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 891,
    density: 14.9,
    county_fips: 54083,
    county_name: "Randolph",
    county_weights: {
      54083: 51.58,
      54093: 48.42,
    },
    county_names_all: "Randolph|Tucker",
    county_fips_all: "54083|54093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26278,
    lat: 38.82572,
    lng: -80.02547,
    city: "Mabie",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 548,
    density: 3.1,
    county_fips: 54083,
    county_name: "Randolph",
    county_weights: {
      54083: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 54083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26280,
    lat: 38.71738,
    lng: -80.03775,
    city: "Mill Creek",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1714,
    density: 9.7,
    county_fips: 54083,
    county_name: "Randolph",
    county_weights: {
      54083: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 54083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26282,
    lat: 38.52022,
    lng: -80.14619,
    city: "Monterville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 93,
    density: 0.5,
    county_fips: 54083,
    county_name: "Randolph",
    county_weights: {
      54083: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 54083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26283,
    lat: 39.06436,
    lng: -79.82088,
    city: "Montrose",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1794,
    density: 13.2,
    county_fips: 54083,
    county_name: "Randolph",
    county_weights: {
      54001: 15.16,
      54083: 63.11,
      54093: 21.73,
    },
    county_names_all: "Randolph|Tucker|Barbour",
    county_fips_all: "54083|54093|54001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26285,
    lat: 38.9102,
    lng: -79.94945,
    city: "Norton",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 240,
    density: 7.2,
    county_fips: 54083,
    county_name: "Randolph",
    county_weights: {
      54083: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 54083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26287,
    lat: 39.16657,
    lng: -79.69057,
    city: "Parsons",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3186,
    density: 8.3,
    county_fips: 54093,
    county_name: "Tucker",
    county_weights: {
      54077: 1.17,
      54093: 98.83,
    },
    county_names_all: "Tucker|Preston",
    county_fips_all: "54093|54077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26288,
    lat: 38.49664,
    lng: -80.3645,
    city: "Webster Springs",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3456,
    density: 5.7,
    county_fips: 54101,
    county_name: "Webster",
    county_weights: {
      54101: 100,
    },
    county_names_all: "Webster",
    county_fips_all: 54101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26289,
    lat: 38.98972,
    lng: -79.51268,
    city: "Red Creek",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54093,
    county_name: "Tucker",
    county_weights: {
      54083: 0.3,
      54093: 99.7,
    },
    county_names_all: "Tucker|Randolph",
    county_fips_all: "54093|54083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26291,
    lat: 38.44109,
    lng: -80.08637,
    city: "Slatyfork",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 147,
    density: 1.9,
    county_fips: 54075,
    county_name: "Pocahontas",
    county_weights: {
      54075: 100,
    },
    county_names_all: "Pocahontas",
    county_fips_all: 54075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26292,
    lat: 39.15247,
    lng: -79.52916,
    city: "Thomas",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 586,
    density: 7.9,
    county_fips: 54093,
    county_name: "Tucker",
    county_weights: {
      54093: 100,
    },
    county_names_all: "Tucker",
    county_fips_all: 54093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26293,
    lat: 38.7824,
    lng: -79.9365,
    city: "Valley Bend",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 663,
    density: 44.5,
    county_fips: 54083,
    county_name: "Randolph",
    county_weights: {
      54083: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 54083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26294,
    lat: 38.53443,
    lng: -80.02309,
    city: "Valley Head",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 940,
    density: 5.6,
    county_fips: 54083,
    county_name: "Randolph",
    county_weights: {
      54075: 1.55,
      54083: 98.45,
    },
    county_names_all: "Randolph|Pocahontas",
    county_fips_all: "54083|54075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26296,
    lat: 38.75425,
    lng: -79.56369,
    city: "Whitmer",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 82,
    density: 1.4,
    county_fips: 54083,
    county_name: "Randolph",
    county_weights: {
      54083: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 54083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26298,
    lat: 38.45054,
    lng: -80.26552,
    city: "Bergoo",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 93,
    density: 2.1,
    county_fips: 54101,
    county_name: "Webster",
    county_weights: {
      54101: 100,
    },
    county_names_all: "Webster",
    county_fips_all: 54101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26301,
    lat: 39.28629,
    lng: -80.37735,
    city: "Clarksburg",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28652,
    density: 143.5,
    county_fips: 54033,
    county_name: "Harrison",
    county_weights: {
      54033: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 54033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26320,
    lat: 39.41514,
    lng: -80.82614,
    city: "Alma",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 522,
    density: 3.4,
    county_fips: 54095,
    county_name: "Tyler",
    county_weights: {
      54017: 4.02,
      54095: 95.98,
    },
    county_names_all: "Tyler|Doddridge",
    county_fips_all: "54095|54017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26321,
    lat: 39.05461,
    lng: -80.68732,
    city: "Alum Bridge",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 156,
    density: 2.5,
    county_fips: 54041,
    county_name: "Lewis",
    county_weights: {
      54017: 9.97,
      54041: 90.03,
    },
    county_names_all: "Lewis|Doddridge",
    county_fips_all: "54041|54017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26323,
    lat: 39.2623,
    lng: -80.29057,
    city: "Anmoore",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 509,
    density: 182,
    county_fips: 54033,
    county_name: "Harrison",
    county_weights: {
      54033: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 54033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26325,
    lat: 39.09749,
    lng: -80.882,
    city: "Auburn",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 240,
    density: 3.8,
    county_fips: 54085,
    county_name: "Ritchie",
    county_weights: {
      54085: 100,
    },
    county_names_all: "Ritchie",
    county_fips_all: 54085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26327,
    lat: 39.12283,
    lng: -80.9406,
    city: "Berea",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 120,
    density: 4.6,
    county_fips: 54085,
    county_name: "Ritchie",
    county_weights: {
      54085: 100,
    },
    county_names_all: "Ritchie",
    county_fips_all: 54085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26330,
    lat: 39.28837,
    lng: -80.22109,
    city: "Bridgeport",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14870,
    density: 81.2,
    county_fips: 54033,
    county_name: "Harrison",
    county_weights: {
      54001: 8.47,
      54033: 71.36,
      54091: 20.17,
    },
    county_names_all: "Harrison|Taylor|Barbour",
    county_fips_all: "54033|54091|54001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26335,
    lat: 38.85364,
    lng: -80.67683,
    city: "Burnsville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1751,
    density: 15.5,
    county_fips: 54007,
    county_name: "Braxton",
    county_weights: {
      54007: 70.7,
      54021: 29.3,
    },
    county_names_all: "Braxton|Gilmer",
    county_fips_all: "54007|54021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26337,
    lat: 39.23856,
    lng: -81.16388,
    city: "Cairo",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1313,
    density: 7.8,
    county_fips: 54085,
    county_name: "Ritchie",
    county_weights: {
      54085: 100,
    },
    county_names_all: "Ritchie",
    county_fips_all: 54085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26338,
    lat: 39.08503,
    lng: -80.61941,
    city: "Camden",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 824,
    density: 8.1,
    county_fips: 54041,
    county_name: "Lewis",
    county_weights: {
      54041: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 54041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26339,
    lat: 39.42231,
    lng: -80.60998,
    city: "Center Point",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 173,
    density: 3.6,
    county_fips: 54017,
    county_name: "Doddridge",
    county_weights: {
      54017: 100,
    },
    county_names_all: "Doddridge",
    county_fips_all: 54017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26342,
    lat: 39.0248,
    lng: -80.84698,
    city: "Coxs Mills",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 194,
    density: 1.4,
    county_fips: 54021,
    county_name: "Gilmer",
    county_weights: {
      54021: 100,
    },
    county_names_all: "Gilmer",
    county_fips_all: 54021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26343,
    lat: 38.82665,
    lng: -80.39831,
    city: "Crawford",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 421,
    density: 6,
    county_fips: 54041,
    county_name: "Lewis",
    county_weights: {
      54041: 50.05,
      54097: 49.95,
    },
    county_names_all: "Lewis|Upshur",
    county_fips_all: "54041|54097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26346,
    lat: 39.29247,
    lng: -81.06294,
    city: "Ellenboro",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 717,
    density: 11.4,
    county_fips: 54085,
    county_name: "Ritchie",
    county_weights: {
      54073: 10.79,
      54085: 88.72,
      54095: 0.49,
    },
    county_names_all: "Ritchie|Pleasants|Tyler",
    county_fips_all: "54085|54073|54095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26347,
    lat: 39.26371,
    lng: -80.1261,
    city: "Flemington",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2341,
    density: 22.1,
    county_fips: 54091,
    county_name: "Taylor",
    county_weights: {
      54001: 26.36,
      54091: 73.64,
    },
    county_names_all: "Taylor|Barbour",
    county_fips_all: "54091|54001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26348,
    lat: 39.46035,
    lng: -80.53474,
    city: "Folsom",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 318,
    density: 10.6,
    county_fips: 54103,
    county_name: "Wetzel",
    county_weights: {
      54103: 100,
    },
    county_names_all: "Wetzel",
    county_fips_all: 54103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26349,
    lat: 39.22757,
    lng: -80.11098,
    city: "Galloway",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 191,
    density: 45.9,
    county_fips: 54001,
    county_name: "Barbour",
    county_weights: {
      54001: 100,
    },
    county_names_all: "Barbour",
    county_fips_all: 54001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26351,
    lat: 38.92846,
    lng: -80.84479,
    city: "Glenville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4842,
    density: 26.4,
    county_fips: 54021,
    county_name: "Gilmer",
    county_weights: {
      54007: 4.27,
      54021: 95.73,
    },
    county_names_all: "Gilmer|Braxton",
    county_fips_all: "54021|54007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26354,
    lat: 39.34847,
    lng: -80.02866,
    city: "Grafton",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10927,
    density: 45.5,
    county_fips: 54091,
    county_name: "Taylor",
    county_weights: {
      54049: 1.76,
      54091: 98.24,
    },
    county_names_all: "Taylor|Marion",
    county_fips_all: "54091|54049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26361,
    lat: 39.36507,
    lng: -80.31776,
    city: "Gypsy",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 97,
    density: 132.8,
    county_fips: 54033,
    county_name: "Harrison",
    county_weights: {
      54033: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 54033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26362,
    lat: 39.15457,
    lng: -81.05705,
    city: "Harrisville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3301,
    density: 12,
    county_fips: 54085,
    county_name: "Ritchie",
    county_weights: {
      54085: 100,
    },
    county_names_all: "Ritchie",
    county_fips_all: 54085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26366,
    lat: 39.38266,
    lng: -80.33474,
    city: "Haywood",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56,
    density: 71.6,
    county_fips: 54033,
    county_name: "Harrison",
    county_weights: {
      54033: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 54033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26369,
    lat: 39.33527,
    lng: -80.33117,
    city: "Hepzibah",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 531,
    density: 104.3,
    county_fips: 54033,
    county_name: "Harrison",
    county_weights: {
      54033: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 54033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26372,
    lat: 38.95859,
    lng: -80.37155,
    city: "Horner",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 618,
    density: 7.6,
    county_fips: 54041,
    county_name: "Lewis",
    county_weights: {
      54041: 97.76,
      54097: 2.24,
    },
    county_names_all: "Lewis|Upshur",
    county_fips_all: "54041|54097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26374,
    lat: 39.44755,
    lng: -79.88101,
    city: "Independence",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1613,
    density: 17.3,
    county_fips: 54077,
    county_name: "Preston",
    county_weights: {
      54061: 10.45,
      54077: 71.35,
      54091: 18.2,
    },
    county_names_all: "Preston|Taylor|Monongalia",
    county_fips_all: "54077|54091|54061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26376,
    lat: 38.77565,
    lng: -80.46864,
    city: "Ireland",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 467,
    density: 5,
    county_fips: 54007,
    county_name: "Braxton",
    county_weights: {
      54007: 53.95,
      54041: 46.05,
    },
    county_names_all: "Braxton|Lewis",
    county_fips_all: "54007|54041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26377,
    lat: 39.49185,
    lng: -80.64068,
    city: "Jacksonburg",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 866,
    density: 5.4,
    county_fips: 54103,
    county_name: "Wetzel",
    county_weights: {
      54095: 32.33,
      54103: 67.67,
    },
    county_names_all: "Wetzel|Tyler",
    county_fips_all: "54103|54095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26378,
    lat: 39.12264,
    lng: -80.44772,
    city: "Jane Lew",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4112,
    density: 22.2,
    county_fips: 54041,
    county_name: "Lewis",
    county_weights: {
      54033: 33.15,
      54041: 66.85,
    },
    county_names_all: "Lewis|Harrison",
    county_fips_all: "54041|54033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26384,
    lat: 38.97467,
    lng: -80.7178,
    city: "Linn",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 589,
    density: 7.9,
    county_fips: 54021,
    county_name: "Gilmer",
    county_weights: {
      54021: 84.89,
      54041: 15.11,
    },
    county_names_all: "Gilmer|Lewis",
    county_fips_all: "54021|54041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26385,
    lat: 39.15895,
    lng: -80.3517,
    city: "Lost Creek",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3879,
    density: 25.2,
    county_fips: 54033,
    county_name: "Harrison",
    county_weights: {
      54033: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 54033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26386,
    lat: 39.39878,
    lng: -80.40263,
    city: "Lumberport",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3037,
    density: 40.1,
    county_fips: 54033,
    county_name: "Harrison",
    county_weights: {
      54033: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 54033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26404,
    lat: 39.34636,
    lng: -80.30996,
    city: "Meadowbrook",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 541,
    density: 165.7,
    county_fips: 54033,
    county_name: "Harrison",
    county_weights: {
      54033: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 54033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26405,
    lat: 39.23093,
    lng: -79.89076,
    city: "Moatsville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1202,
    density: 7.4,
    county_fips: 54001,
    county_name: "Barbour",
    county_weights: {
      54001: 75.41,
      54077: 24.59,
    },
    county_names_all: "Barbour|Preston",
    county_fips_all: "54001|54077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26408,
    lat: 39.20313,
    lng: -80.28973,
    city: "Mount Clare",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2651,
    density: 33.8,
    county_fips: 54033,
    county_name: "Harrison",
    county_weights: {
      54033: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 54033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26410,
    lat: 39.4032,
    lng: -79.82389,
    city: "Newburg",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 926,
    density: 16.1,
    county_fips: 54077,
    county_name: "Preston",
    county_weights: {
      54077: 100,
    },
    county_names_all: "Preston",
    county_fips_all: 54077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26411,
    lat: 39.18078,
    lng: -80.70723,
    city: "New Milton",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 544,
    density: 2.7,
    county_fips: 54017,
    county_name: "Doddridge",
    county_weights: {
      54017: 97.93,
      54021: 2.07,
    },
    county_names_all: "Doddridge|Gilmer",
    county_fips_all: "54017|54021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26412,
    lat: 38.89164,
    lng: -80.59457,
    city: "Orlando",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 318,
    density: 2.5,
    county_fips: 54041,
    county_name: "Lewis",
    county_weights: {
      54007: 39.47,
      54021: 19.25,
      54041: 41.29,
    },
    county_names_all: "Lewis|Braxton|Gilmer",
    county_fips_all: "54041|54007|54021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26415,
    lat: 39.29808,
    lng: -80.93499,
    city: "Pennsboro",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3911,
    density: 15,
    county_fips: 54085,
    county_name: "Ritchie",
    county_weights: {
      54017: 14.47,
      54085: 68.8,
      54095: 16.73,
    },
    county_names_all: "Ritchie|Tyler|Doddridge",
    county_fips_all: "54085|54095|54017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26416,
    lat: 39.16349,
    lng: -80.02245,
    city: "Philippi",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7597,
    density: 20.8,
    county_fips: 54001,
    county_name: "Barbour",
    county_weights: {
      54001: 99.06,
      54091: 0.94,
    },
    county_names_all: "Barbour|Taylor",
    county_fips_all: "54001|54091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26419,
    lat: 39.58469,
    lng: -80.631,
    city: "Pine Grove",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 974,
    density: 14.2,
    county_fips: 54103,
    county_name: "Wetzel",
    county_weights: {
      54103: 100,
    },
    county_names_all: "Wetzel",
    county_fips_all: 54103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26421,
    lat: 39.18412,
    lng: -80.91607,
    city: "Pullman",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 158,
    density: 3.6,
    county_fips: 54085,
    county_name: "Ritchie",
    county_weights: {
      54085: 100,
    },
    county_names_all: "Ritchie",
    county_fips_all: 54085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26422,
    lat: 39.29797,
    lng: -80.43323,
    city: "Reynoldsville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 481,
    density: 71.7,
    county_fips: 54033,
    county_name: "Harrison",
    county_weights: {
      54033: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 54033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26424,
    lat: 39.28117,
    lng: -80.17272,
    city: "Rosemont",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 139,
    density: 15.2,
    county_fips: 54091,
    county_name: "Taylor",
    county_weights: {
      54033: 0.1,
      54091: 99.9,
    },
    county_names_all: "Taylor|Harrison",
    county_fips_all: "54091|54033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26425,
    lat: 39.3116,
    lng: -79.68651,
    city: "Rowlesburg",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 924,
    density: 6.4,
    county_fips: 54077,
    county_name: "Preston",
    county_weights: {
      54077: 96.87,
      54093: 3.13,
    },
    county_names_all: "Preston|Tucker",
    county_fips_all: "54077|54093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26426,
    lat: 39.28758,
    lng: -80.56313,
    city: "Salem",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7678,
    density: 21.7,
    county_fips: 54017,
    county_name: "Doddridge",
    county_weights: {
      54017: 54.46,
      54033: 45.54,
    },
    county_names_all: "Doddridge|Harrison",
    county_fips_all: "54017|54033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26430,
    lat: 38.88475,
    lng: -80.7598,
    city: "Sand Fork",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 338,
    density: 9,
    county_fips: 54021,
    county_name: "Gilmer",
    county_weights: {
      54021: 100,
    },
    county_names_all: "Gilmer",
    county_fips_all: 54021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26431,
    lat: 39.39144,
    lng: -80.28085,
    city: "Shinnston",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5835,
    density: 74.7,
    county_fips: 54033,
    county_name: "Harrison",
    county_weights: {
      54033: 97.67,
      54091: 2.33,
    },
    county_names_all: "Harrison|Taylor",
    county_fips_all: "54033|54091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26435,
    lat: 39.26743,
    lng: -80.08875,
    city: "Simpson",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58,
    density: 230.5,
    county_fips: 54091,
    county_name: "Taylor",
    county_weights: {
      54091: 100,
    },
    county_names_all: "Taylor",
    county_fips_all: 54091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26436,
    lat: 39.2965,
    lng: -80.71683,
    city: "Smithburg",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 211,
    density: 30.8,
    county_fips: 54017,
    county_name: "Doddridge",
    county_weights: {
      54017: 100,
    },
    county_names_all: "Doddridge",
    county_fips_all: 54017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26437,
    lat: 39.53147,
    lng: -80.5193,
    city: "Smithfield",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 682,
    density: 9,
    county_fips: 54103,
    county_name: "Wetzel",
    county_weights: {
      54049: 3.84,
      54103: 96.16,
    },
    county_names_all: "Wetzel|Marion",
    county_fips_all: "54103|54049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26438,
    lat: 39.34315,
    lng: -80.31631,
    city: "Spelter",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41,
    density: 32,
    county_fips: 54033,
    county_name: "Harrison",
    county_weights: {
      54033: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 54033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26440,
    lat: 39.32947,
    lng: -79.90625,
    city: "Thornton",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1187,
    density: 11.4,
    county_fips: 54091,
    county_name: "Taylor",
    county_weights: {
      54001: 17.19,
      54077: 31.4,
      54091: 51.41,
    },
    county_names_all: "Taylor|Preston|Barbour",
    county_fips_all: "54091|54077|54001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26443,
    lat: 39.06814,
    lng: -80.7554,
    city: "Troy",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 537,
    density: 9.9,
    county_fips: 54021,
    county_name: "Gilmer",
    county_weights: {
      54017: 13.35,
      54021: 86.65,
    },
    county_names_all: "Gilmer|Doddridge",
    county_fips_all: "54021|54017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26444,
    lat: 39.36861,
    lng: -79.7626,
    city: "Tunnelton",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3762,
    density: 23,
    county_fips: 54077,
    county_name: "Preston",
    county_weights: {
      54077: 100,
    },
    county_names_all: "Preston",
    county_fips_all: 54077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26447,
    lat: 38.90546,
    lng: -80.4854,
    city: "Walkersville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1118,
    density: 5.9,
    county_fips: 54041,
    county_name: "Lewis",
    county_weights: {
      54007: 6,
      54041: 94,
    },
    county_names_all: "Lewis|Braxton",
    county_fips_all: "54041|54007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26448,
    lat: 39.40595,
    lng: -80.49265,
    city: "Wallace",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1412,
    density: 14.3,
    county_fips: 54033,
    county_name: "Harrison",
    county_weights: {
      54017: 3.54,
      54033: 90.89,
      54049: 5.57,
    },
    county_names_all: "Harrison|Marion|Doddridge",
    county_fips_all: "54033|54049|54017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26451,
    lat: 39.20439,
    lng: -80.40352,
    city: "West Milford",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 644,
    density: 463,
    county_fips: 54033,
    county_name: "Harrison",
    county_weights: {
      54033: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 54033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26452,
    lat: 39.03286,
    lng: -80.51315,
    city: "Weston",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9464,
    density: 31.1,
    county_fips: 54041,
    county_name: "Lewis",
    county_weights: {
      54041: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 54041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26456,
    lat: 39.28078,
    lng: -80.77354,
    city: "West Union",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3663,
    density: 10,
    county_fips: 54017,
    county_name: "Doddridge",
    county_weights: {
      54017: 87.02,
      54085: 8.73,
      54095: 4.25,
    },
    county_names_all: "Doddridge|Ritchie|Tyler",
    county_fips_all: "54017|54085|54095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26463,
    lat: 39.43174,
    lng: -80.35007,
    city: "Wyatt",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54033,
    county_name: "Harrison",
    county_weights: {
      54033: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 54033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26501,
    lat: 39.62872,
    lng: -80.04025,
    city: "Morgantown",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21870,
    density: 144.3,
    county_fips: 54061,
    county_name: "Monongalia",
    county_weights: {
      54061: 100,
    },
    county_names_all: "Monongalia",
    county_fips_all: 54061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26505,
    lat: 39.6511,
    lng: -79.94306,
    city: "Morgantown",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39487,
    density: 1205.3,
    county_fips: 54061,
    county_name: "Monongalia",
    county_weights: {
      54061: 100,
    },
    county_names_all: "Monongalia",
    county_fips_all: 54061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26506,
    lat: 39.64677,
    lng: -79.9701,
    city: "Morgantown",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54061,
    county_name: "Monongalia",
    county_weights: {
      54061: 100,
    },
    county_names_all: "Monongalia",
    county_fips_all: 54061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26508,
    lat: 39.59941,
    lng: -79.89724,
    city: "Morgantown",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34453,
    density: 108,
    county_fips: 54061,
    county_name: "Monongalia",
    county_weights: {
      54061: 100,
    },
    county_names_all: "Monongalia",
    county_fips_all: 54061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26519,
    lat: 39.55179,
    lng: -79.63212,
    city: "Albright",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2131,
    density: 13.7,
    county_fips: 54077,
    county_name: "Preston",
    county_weights: {
      54077: 100,
    },
    county_names_all: "Preston",
    county_fips_all: 54077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26520,
    lat: 39.50105,
    lng: -79.82393,
    city: "Arthurdale",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 825,
    density: 108.8,
    county_fips: 54077,
    county_name: "Preston",
    county_weights: {
      54077: 100,
    },
    county_names_all: "Preston",
    county_fips_all: 54077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26521,
    lat: 39.71374,
    lng: -80.23065,
    city: "Blacksville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 197,
    density: 39.4,
    county_fips: 54061,
    county_name: "Monongalia",
    county_weights: {
      54061: 100,
    },
    county_names_all: "Monongalia",
    county_fips_all: 54061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26524,
    lat: 39.54075,
    lng: -79.80716,
    city: "Bretz",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54077,
    county_name: "Preston",
    county_weights: {
      54077: 100,
    },
    county_names_all: "Preston",
    county_fips_all: 54077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26525,
    lat: 39.65465,
    lng: -79.6184,
    city: "Bruceton Mills",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6954,
    density: 18.9,
    county_fips: 54077,
    county_name: "Preston",
    county_weights: {
      54077: 100,
    },
    county_names_all: "Preston",
    county_fips_all: 54077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26534,
    lat: 39.64748,
    lng: -79.99733,
    city: "Granville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2876,
    density: 871.8,
    county_fips: 54061,
    county_name: "Monongalia",
    county_weights: {
      54061: 100,
    },
    county_names_all: "Monongalia",
    county_fips_all: 54061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26537,
    lat: 39.4846,
    lng: -79.71189,
    city: "Kingwood",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5607,
    density: 52.1,
    county_fips: 54077,
    county_name: "Preston",
    county_weights: {
      54077: 100,
    },
    county_names_all: "Preston",
    county_fips_all: 54077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26541,
    lat: 39.68179,
    lng: -80.07458,
    city: "Maidsville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2761,
    density: 26.3,
    county_fips: 54061,
    county_name: "Monongalia",
    county_weights: {
      54061: 100,
    },
    county_names_all: "Monongalia",
    county_fips_all: 54061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26542,
    lat: 39.573,
    lng: -79.79041,
    city: "Masontown",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2370,
    density: 25.5,
    county_fips: 54077,
    county_name: "Preston",
    county_weights: {
      54061: 24.52,
      54077: 75.48,
    },
    county_names_all: "Preston|Monongalia",
    county_fips_all: "54077|54061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26543,
    lat: 39.66375,
    lng: -80.00219,
    city: "Osage",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 170,
    density: 98.8,
    county_fips: 54061,
    county_name: "Monongalia",
    county_weights: {
      54061: 100,
    },
    county_names_all: "Monongalia",
    county_fips_all: 54061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26544,
    lat: 39.71233,
    lng: -80.17064,
    city: "Pentress",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54061,
    county_name: "Monongalia",
    county_weights: {
      54061: 100,
    },
    county_names_all: "Monongalia",
    county_fips_all: 54061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26546,
    lat: 39.66099,
    lng: -80.03115,
    city: "Pursglove",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54061,
    county_name: "Monongalia",
    county_weights: {
      54061: 100,
    },
    county_names_all: "Monongalia",
    county_fips_all: 54061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26547,
    lat: 39.5133,
    lng: -79.80757,
    city: "Reedsville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3058,
    density: 77.5,
    county_fips: 54077,
    county_name: "Preston",
    county_weights: {
      54077: 100,
    },
    county_names_all: "Preston",
    county_fips_all: 54077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26554,
    lat: 39.46475,
    lng: -80.11461,
    city: "Fairmont",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41939,
    density: 122.7,
    county_fips: 54049,
    county_name: "Marion",
    county_weights: {
      54033: 1.47,
      54049: 87.25,
      54061: 8.04,
      54091: 3.24,
    },
    county_names_all: "Marion|Monongalia|Taylor|Harrison",
    county_fips_all: "54049|54061|54091|54033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26559,
    lat: 39.52141,
    lng: -80.18015,
    city: "Barrackville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1232,
    density: 139.2,
    county_fips: 54049,
    county_name: "Marion",
    county_weights: {
      54049: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 54049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26560,
    lat: 39.54088,
    lng: -80.14362,
    city: "Baxter",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 105,
    density: 257.9,
    county_fips: 54049,
    county_name: "Marion",
    county_weights: {
      54049: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 54049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26562,
    lat: 39.63957,
    lng: -80.45072,
    city: "Burton",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 374,
    density: 4.2,
    county_fips: 54103,
    county_name: "Wetzel",
    county_weights: {
      54061: 31.66,
      54103: 68.34,
    },
    county_names_all: "Wetzel|Monongalia",
    county_fips_all: "54103|54061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26563,
    lat: 39.48085,
    lng: -80.27369,
    city: "Carolina",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 306,
    density: 166.1,
    county_fips: 54049,
    county_name: "Marion",
    county_weights: {
      54049: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 54049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26568,
    lat: 39.42542,
    lng: -80.27729,
    city: "Enterprise",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 580,
    density: 190,
    county_fips: 54033,
    county_name: "Harrison",
    county_weights: {
      54033: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 54033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26570,
    lat: 39.64284,
    lng: -80.23444,
    city: "Fairview",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3591,
    density: 21.6,
    county_fips: 54061,
    county_name: "Monongalia",
    county_weights: {
      54049: 25.82,
      54061: 74.18,
    },
    county_names_all: "Monongalia|Marion",
    county_fips_all: "54061|54049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26571,
    lat: 39.51945,
    lng: -80.26013,
    city: "Farmington",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2094,
    density: 49,
    county_fips: 54049,
    county_name: "Marion",
    county_weights: {
      54049: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 54049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26572,
    lat: 39.4871,
    lng: -80.31973,
    city: "Four States",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54049,
    county_name: "Marion",
    county_weights: {
      54049: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 54049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26574,
    lat: 39.55926,
    lng: -80.17741,
    city: "Grant Town",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 594,
    density: 466.8,
    county_fips: 54049,
    county_name: "Marion",
    county_weights: {
      54049: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 54049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26575,
    lat: 39.6978,
    lng: -80.43256,
    city: "Hundred",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 767,
    density: 13.9,
    county_fips: 54103,
    county_name: "Wetzel",
    county_weights: {
      54061: 27.17,
      54103: 72.83,
    },
    county_names_all: "Wetzel|Monongalia",
    county_fips_all: "54103|54061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26576,
    lat: 39.49307,
    lng: -80.25644,
    city: "Idamay",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 886,
    density: 291.3,
    county_fips: 54049,
    county_name: "Marion",
    county_weights: {
      54049: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 54049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26581,
    lat: 39.66554,
    lng: -80.56781,
    city: "Littleton",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 883,
    density: 7,
    county_fips: 54103,
    county_name: "Wetzel",
    county_weights: {
      54103: 100,
    },
    county_names_all: "Wetzel",
    county_fips_all: 54103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26582,
    lat: 39.53114,
    lng: -80.38767,
    city: "Mannington",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4171,
    density: 18.6,
    county_fips: 54049,
    county_name: "Marion",
    county_weights: {
      54033: 1.74,
      54049: 97.58,
      54061: 0.68,
    },
    county_names_all: "Marion|Harrison|Monongalia",
    county_fips_all: "54049|54033|54061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26585,
    lat: 39.6065,
    lng: -80.42379,
    city: "Metz",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 386,
    density: 5,
    county_fips: 54049,
    county_name: "Marion",
    county_weights: {
      54049: 67.05,
      54103: 32.95,
    },
    county_names_all: "Marion|Wetzel",
    county_fips_all: "54049|54103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26586,
    lat: 39.52786,
    lng: -80.10952,
    city: "Montana Mines",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 253,
    density: 959.9,
    county_fips: 54049,
    county_name: "Marion",
    county_weights: {
      54049: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 54049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26587,
    lat: 39.51606,
    lng: -80.29751,
    city: "Rachel",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 411,
    density: 218,
    county_fips: 54049,
    county_name: "Marion",
    county_weights: {
      54049: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 54049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26588,
    lat: 39.5738,
    lng: -80.15339,
    city: "Rivesville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2784,
    density: 31.2,
    county_fips: 54049,
    county_name: "Marion",
    county_weights: {
      54049: 79.13,
      54061: 20.87,
    },
    county_names_all: "Marion|Monongalia",
    county_fips_all: "54049|54061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26590,
    lat: 39.67428,
    lng: -80.31674,
    city: "Wana",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 648,
    density: 10.4,
    county_fips: 54061,
    county_name: "Monongalia",
    county_weights: {
      54061: 100,
    },
    county_names_all: "Monongalia",
    county_fips_all: 54061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26591,
    lat: 39.45499,
    lng: -80.2903,
    city: "Worthington",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1609,
    density: 51.5,
    county_fips: 54049,
    county_name: "Marion",
    county_weights: {
      54033: 3.8,
      54049: 96.2,
    },
    county_names_all: "Marion|Harrison",
    county_fips_all: "54049|54033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26601,
    lat: 38.63307,
    lng: -80.6567,
    city: "Sutton",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4488,
    density: 13.7,
    county_fips: 54007,
    county_name: "Braxton",
    county_weights: {
      54007: 100,
    },
    county_names_all: "Braxton",
    county_fips_all: 54007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26610,
    lat: 38.47769,
    lng: -80.71887,
    city: "Birch River",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 851,
    density: 4.4,
    county_fips: 54067,
    county_name: "Nicholas",
    county_weights: {
      54067: 80.24,
      54101: 19.76,
    },
    county_names_all: "Nicholas|Webster",
    county_fips_all: "54067|54101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26611,
    lat: 38.84639,
    lng: -80.83339,
    city: "Cedarville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 177,
    density: 5.9,
    county_fips: 54021,
    county_name: "Gilmer",
    county_weights: {
      54021: 100,
    },
    county_names_all: "Gilmer",
    county_fips_all: 54021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26615,
    lat: 38.83242,
    lng: -80.73136,
    city: "Copen",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 237,
    density: 14,
    county_fips: 54007,
    county_name: "Braxton",
    county_weights: {
      54007: 100,
    },
    county_names_all: "Braxton",
    county_fips_all: 54007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26617,
    lat: 38.4828,
    lng: -80.82572,
    city: "Dille",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 87,
    density: 3.1,
    county_fips: 54067,
    county_name: "Nicholas",
    county_weights: {
      54015: 18.33,
      54067: 81.67,
    },
    county_names_all: "Nicholas|Clay",
    county_fips_all: "54067|54015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26619,
    lat: 38.77542,
    lng: -80.73562,
    city: "Exchange",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 467,
    density: 6,
    county_fips: 54007,
    county_name: "Braxton",
    county_weights: {
      54007: 100,
    },
    county_names_all: "Braxton",
    county_fips_all: 54007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26621,
    lat: 38.72186,
    lng: -80.56057,
    city: "Flatwoods",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 840,
    density: 10.8,
    county_fips: 54007,
    county_name: "Braxton",
    county_weights: {
      54007: 100,
    },
    county_names_all: "Braxton",
    county_fips_all: 54007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26623,
    lat: 38.6576,
    lng: -80.87714,
    city: "Frametown",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1168,
    density: 7.3,
    county_fips: 54007,
    county_name: "Braxton",
    county_weights: {
      54007: 97.83,
      54021: 2.17,
    },
    county_names_all: "Braxton|Gilmer",
    county_fips_all: "54007|54021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26624,
    lat: 38.72071,
    lng: -80.80883,
    city: "Gassaway",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3137,
    density: 15.4,
    county_fips: 54007,
    county_name: "Braxton",
    county_weights: {
      54007: 94.46,
      54021: 5.54,
    },
    county_names_all: "Braxton|Gilmer",
    county_fips_all: "54007|54021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26627,
    lat: 38.75578,
    lng: -80.5943,
    city: "Heaters",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 266,
    density: 5.1,
    county_fips: 54007,
    county_name: "Braxton",
    county_weights: {
      54007: 100,
    },
    county_names_all: "Braxton",
    county_fips_all: 54007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26629,
    lat: 38.56846,
    lng: -80.70152,
    city: "Little Birch",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 239,
    density: 8.8,
    county_fips: 54007,
    county_name: "Braxton",
    county_weights: {
      54007: 100,
    },
    county_names_all: "Braxton",
    county_fips_all: 54007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26631,
    lat: 38.79795,
    lng: -80.56856,
    city: "Napier",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 71,
    density: 1.6,
    county_fips: 54007,
    county_name: "Braxton",
    county_weights: {
      54007: 100,
    },
    county_names_all: "Braxton",
    county_fips_all: 54007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26636,
    lat: 38.73386,
    lng: -80.96599,
    city: "Rosedale",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 501,
    density: 7.2,
    county_fips: 54007,
    county_name: "Braxton",
    county_weights: {
      54007: 46.14,
      54013: 10.19,
      54021: 43.68,
    },
    county_names_all: "Braxton|Gilmer|Calhoun",
    county_fips_all: "54007|54021|54013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26638,
    lat: 38.77265,
    lng: -80.99878,
    city: "Shock",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 174,
    density: 3.2,
    county_fips: 54021,
    county_name: "Gilmer",
    county_weights: {
      54013: 15.11,
      54021: 84.89,
    },
    county_names_all: "Gilmer|Calhoun",
    county_fips_all: "54021|54013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26651,
    lat: 38.3185,
    lng: -80.87902,
    city: "Summersville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9134,
    density: 17.6,
    county_fips: 54067,
    county_name: "Nicholas",
    county_weights: {
      54067: 100,
    },
    county_names_all: "Nicholas",
    county_fips_all: 54067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26656,
    lat: 38.24358,
    lng: -81.18082,
    city: "Belva",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 197,
    density: 4.8,
    county_fips: 54067,
    county_name: "Nicholas",
    county_weights: {
      54019: 43.81,
      54067: 56.19,
    },
    county_names_all: "Nicholas|Fayette",
    county_fips_all: "54067|54019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26660,
    lat: 38.35513,
    lng: -80.70061,
    city: "Calvin",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 397,
    density: 22.7,
    county_fips: 54067,
    county_name: "Nicholas",
    county_weights: {
      54067: 100,
    },
    county_names_all: "Nicholas",
    county_fips_all: 54067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26662,
    lat: 38.25813,
    lng: -80.7695,
    city: "Canvas",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1108,
    density: 42.5,
    county_fips: 54067,
    county_name: "Nicholas",
    county_weights: {
      54067: 100,
    },
    county_names_all: "Nicholas",
    county_fips_all: 54067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26667,
    lat: 38.2384,
    lng: -80.99908,
    city: "Drennen",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54067,
    county_name: "Nicholas",
    county_weights: {
      54067: 100,
    },
    county_names_all: "Nicholas",
    county_fips_all: 54067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26671,
    lat: 38.31978,
    lng: -80.90929,
    city: "Gilboa",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54067,
    county_name: "Nicholas",
    county_weights: {
      54067: 100,
    },
    county_names_all: "Nicholas",
    county_fips_all: 54067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26676,
    lat: 38.16173,
    lng: -80.65944,
    city: "Leivasy",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 494,
    density: 7.3,
    county_fips: 54067,
    county_name: "Nicholas",
    county_weights: {
      54067: 100,
    },
    county_names_all: "Nicholas",
    county_fips_all: 54067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26678,
    lat: 38.16883,
    lng: -80.91085,
    city: "Mount Lookout",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1334,
    density: 36.1,
    county_fips: 54067,
    county_name: "Nicholas",
    county_weights: {
      54067: 100,
    },
    county_names_all: "Nicholas",
    county_fips_all: 54067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26679,
    lat: 38.16509,
    lng: -80.7971,
    city: "Mount Nebo",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1745,
    density: 12.9,
    county_fips: 54067,
    county_name: "Nicholas",
    county_weights: {
      54067: 100,
    },
    county_names_all: "Nicholas",
    county_fips_all: 54067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26680,
    lat: 38.08991,
    lng: -80.87423,
    city: "Nallen",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 308,
    density: 3.4,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 44.55,
      54025: 32.06,
      54067: 23.39,
    },
    county_names_all: "Fayette|Greenbrier|Nicholas",
    county_fips_all: "54019|54025|54067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26681,
    lat: 38.22983,
    lng: -80.71905,
    city: "Nettie",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1015,
    density: 10.4,
    county_fips: 54067,
    county_name: "Nicholas",
    county_weights: {
      54067: 100,
    },
    county_names_all: "Nicholas",
    county_fips_all: 54067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26684,
    lat: 38.16324,
    lng: -80.8544,
    city: "Pool",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 248,
    density: 41.1,
    county_fips: 54067,
    county_name: "Nicholas",
    county_weights: {
      54067: 100,
    },
    county_names_all: "Nicholas",
    county_fips_all: 54067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26690,
    lat: 38.21757,
    lng: -81.12069,
    city: "Swiss",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 680,
    density: 6.6,
    county_fips: 54019,
    county_name: "Fayette",
    county_weights: {
      54019: 55.69,
      54067: 44.31,
    },
    county_names_all: "Fayette|Nicholas",
    county_fips_all: "54019|54067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26691,
    lat: 38.39785,
    lng: -80.67213,
    city: "Tioga",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 554,
    density: 15.2,
    county_fips: 54067,
    county_name: "Nicholas",
    county_weights: {
      54067: 96.03,
      54101: 3.97,
    },
    county_names_all: "Nicholas|Webster",
    county_fips_all: "54067|54101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26704,
    lat: 39.28619,
    lng: -78.59471,
    city: "Augusta",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5660,
    density: 23.3,
    county_fips: 54027,
    county_name: "Hampshire",
    county_weights: {
      54027: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 54027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26705,
    lat: 39.32388,
    lng: -79.56663,
    city: "Aurora",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 664,
    density: 5.4,
    county_fips: 54077,
    county_name: "Preston",
    county_weights: {
      54077: 100,
    },
    county_names_all: "Preston",
    county_fips_all: 54077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26707,
    lat: 39.22275,
    lng: -79.39418,
    city: "Bayard",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 281,
    density: 4,
    county_fips: 54023,
    county_name: "Grant",
    county_weights: {
      54023: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 54023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26710,
    lat: 39.30996,
    lng: -78.94544,
    city: "Burlington",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2224,
    density: 10.5,
    county_fips: 54057,
    county_name: "Mineral",
    county_weights: {
      54023: 22.59,
      54027: 3.08,
      54057: 74.33,
    },
    county_names_all: "Mineral|Grant|Hampshire",
    county_fips_all: "54057|54023|54027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26711,
    lat: 39.30301,
    lng: -78.47073,
    city: "Capon Bridge",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3063,
    density: 23.3,
    county_fips: 54027,
    county_name: "Hampshire",
    county_weights: {
      54027: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 54027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26714,
    lat: 39.17634,
    lng: -78.64177,
    city: "Delray",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 430,
    density: 8,
    county_fips: 54027,
    county_name: "Hampshire",
    county_weights: {
      54027: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 54027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26716,
    lat: 39.2641,
    lng: -79.51892,
    city: "Eglon",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 691,
    density: 11.3,
    county_fips: 54077,
    county_name: "Preston",
    county_weights: {
      54077: 100,
    },
    county_names_all: "Preston",
    county_fips_all: 54077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26717,
    lat: 39.34583,
    lng: -79.17597,
    city: "Elk Garden",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 829,
    density: 7.8,
    county_fips: 54057,
    county_name: "Mineral",
    county_weights: {
      54023: 17.4,
      54057: 82.6,
    },
    county_names_all: "Mineral|Grant",
    county_fips_all: "54057|54023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26719,
    lat: 39.49778,
    lng: -78.7678,
    city: "Fort Ashby",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2929,
    density: 64.5,
    county_fips: 54057,
    county_name: "Mineral",
    county_weights: {
      54057: 100,
    },
    county_names_all: "Mineral",
    county_fips_all: 54057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26720,
    lat: 39.27761,
    lng: -79.33126,
    city: "Gormania",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 157,
    density: 8.8,
    county_fips: 54023,
    county_name: "Grant",
    county_weights: {
      54023: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 54023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26722,
    lat: 39.49774,
    lng: -78.63463,
    city: "Green Spring",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 250,
    density: 5.1,
    county_fips: 54027,
    county_name: "Hampshire",
    county_weights: {
      54027: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 54027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26726,
    lat: 39.40508,
    lng: -78.98222,
    city: "Keyser",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12331,
    density: 31.8,
    county_fips: 54057,
    county_name: "Mineral",
    county_weights: {
      54023: 14.18,
      54057: 85.82,
    },
    county_names_all: "Mineral|Grant",
    county_fips_all: "54057|54023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26731,
    lat: 39.15243,
    lng: -79.06859,
    city: "Lahmansville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 446,
    density: 12,
    county_fips: 54023,
    county_name: "Grant",
    county_weights: {
      54023: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 54023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26739,
    lat: 39.21508,
    lng: -79.2647,
    city: "Mount Storm",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 924,
    density: 4.2,
    county_fips: 54023,
    county_name: "Grant",
    county_weights: {
      54023: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 54023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26743,
    lat: 39.28873,
    lng: -79.07998,
    city: "New Creek",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1735,
    density: 9.3,
    county_fips: 54057,
    county_name: "Mineral",
    county_weights: {
      54023: 49.34,
      54057: 50.66,
    },
    county_names_all: "Mineral|Grant",
    county_fips_all: "54057|54023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26750,
    lat: 39.47764,
    lng: -79.04627,
    city: "Piedmont",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 928,
    density: 851.9,
    county_fips: 54057,
    county_name: "Mineral",
    county_weights: {
      54057: 100,
    },
    county_names_all: "Mineral",
    county_fips_all: 54057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26753,
    lat: 39.56017,
    lng: -78.79026,
    city: "Ridgeley",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6129,
    density: 91.8,
    county_fips: 54057,
    county_name: "Mineral",
    county_weights: {
      54057: 100,
    },
    county_names_all: "Mineral",
    county_fips_all: 54057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26755,
    lat: 39.15856,
    lng: -78.73534,
    city: "Rio",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 864,
    density: 10.2,
    county_fips: 54027,
    county_name: "Hampshire",
    county_weights: {
      54027: 53.98,
      54031: 46.02,
    },
    county_names_all: "Hampshire|Hardy",
    county_fips_all: "54027|54031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26757,
    lat: 39.31652,
    lng: -78.75001,
    city: "Romney",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7032,
    density: 18.6,
    county_fips: 54027,
    county_name: "Hampshire",
    county_weights: {
      54027: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 54027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26761,
    lat: 39.27303,
    lng: -78.6997,
    city: "Shanks",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 640,
    density: 22.4,
    county_fips: 54027,
    county_name: "Hampshire",
    county_weights: {
      54027: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 54027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26763,
    lat: 39.4789,
    lng: -78.69316,
    city: "Springfield",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1507,
    density: 11.9,
    county_fips: 54027,
    county_name: "Hampshire",
    county_weights: {
      54027: 65.69,
      54057: 34.31,
    },
    county_names_all: "Hampshire|Mineral",
    county_fips_all: "54027|54057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26764,
    lat: 39.45042,
    lng: -79.56035,
    city: "Terra Alta",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4158,
    density: 17.2,
    county_fips: 54077,
    county_name: "Preston",
    county_weights: {
      54077: 100,
    },
    county_names_all: "Preston",
    county_fips_all: 54077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26767,
    lat: 39.61581,
    lng: -78.75674,
    city: "Wiley Ford",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 574,
    density: 95.1,
    county_fips: 54057,
    county_name: "Mineral",
    county_weights: {
      54057: 100,
    },
    county_names_all: "Mineral",
    county_fips_all: 54057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26801,
    lat: 39.05694,
    lng: -78.79374,
    city: "Baker",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 649,
    density: 3.1,
    county_fips: 54031,
    county_name: "Hardy",
    county_weights: {
      54031: 100,
    },
    county_names_all: "Hardy",
    county_fips_all: 54031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26802,
    lat: 38.64454,
    lng: -79.18706,
    city: "Brandywine",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 920,
    density: 2.8,
    county_fips: 54071,
    county_name: "Pendleton",
    county_weights: {
      54071: 100,
    },
    county_names_all: "Pendleton",
    county_fips_all: 54071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26804,
    lat: 38.63306,
    lng: -79.54526,
    city: "Circleville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 650,
    density: 3.2,
    county_fips: 54071,
    county_name: "Pendleton",
    county_weights: {
      54071: 100,
    },
    county_names_all: "Pendleton",
    county_fips_all: 54071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26807,
    lat: 38.62895,
    lng: -79.36157,
    city: "Franklin",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2769,
    density: 6.6,
    county_fips: 54071,
    county_name: "Pendleton",
    county_weights: {
      54071: 100,
    },
    county_names_all: "Pendleton",
    county_fips_all: 54071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26808,
    lat: 39.19563,
    lng: -78.44416,
    city: "High View",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 437,
    density: 6.3,
    county_fips: 54027,
    county_name: "Hampshire",
    county_weights: {
      54027: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 54027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26810,
    lat: 38.97721,
    lng: -78.74853,
    city: "Lost City",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 398,
    density: 4.7,
    county_fips: 54031,
    county_name: "Hardy",
    county_weights: {
      54031: 100,
    },
    county_names_all: "Hardy",
    county_fips_all: 54031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26812,
    lat: 38.88184,
    lng: -78.87688,
    city: "Mathias",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1690,
    density: 6.3,
    county_fips: 54031,
    county_name: "Hardy",
    county_weights: {
      54031: 100,
    },
    county_names_all: "Hardy",
    county_fips_all: 54031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26814,
    lat: 38.75176,
    lng: -79.46648,
    city: "Riverton",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 552,
    density: 3.4,
    county_fips: 54071,
    county_name: "Pendleton",
    county_weights: {
      54071: 100,
    },
    county_names_all: "Pendleton",
    county_fips_all: 54071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26815,
    lat: 38.48923,
    lng: -79.35884,
    city: "Sugar Grove",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 750,
    density: 3.5,
    county_fips: 54071,
    county_name: "Pendleton",
    county_weights: {
      54071: 100,
    },
    county_names_all: "Pendleton",
    county_fips_all: 54071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26817,
    lat: 39.35957,
    lng: -78.39067,
    city: "Bloomery",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 239,
    density: 4.5,
    county_fips: 54027,
    county_name: "Hampshire",
    county_weights: {
      54027: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 54027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26818,
    lat: 39.07662,
    lng: -79.02238,
    city: "Fisher",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 914,
    density: 13.3,
    county_fips: 54031,
    county_name: "Hardy",
    county_weights: {
      54031: 100,
    },
    county_names_all: "Hardy",
    county_fips_all: 54031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26823,
    lat: 39.13033,
    lng: -78.51139,
    city: "Capon Springs",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68,
    density: 1.9,
    county_fips: 54027,
    county_name: "Hampshire",
    county_weights: {
      54027: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 54027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26833,
    lat: 39.08119,
    lng: -79.2083,
    city: "Maysville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2197,
    density: 7.7,
    county_fips: 54023,
    county_name: "Grant",
    county_weights: {
      54023: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 54023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26836,
    lat: 39.00693,
    lng: -78.96366,
    city: "Moorefield",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6925,
    density: 15.4,
    county_fips: 54031,
    county_name: "Hardy",
    county_weights: {
      54031: 100,
    },
    county_names_all: "Hardy",
    county_fips_all: 54031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26838,
    lat: 38.80492,
    lng: -79.07237,
    city: "Milam",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54031,
    county_name: "Hardy",
    county_weights: {
      54031: 100,
    },
    county_names_all: "Hardy",
    county_fips_all: 54031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26845,
    lat: 39.16734,
    lng: -78.96193,
    city: "Old Fields",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 934,
    density: 12.3,
    county_fips: 54031,
    county_name: "Hardy",
    county_weights: {
      54031: 100,
    },
    county_names_all: "Hardy",
    county_fips_all: 54031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26847,
    lat: 38.95809,
    lng: -79.15189,
    city: "Petersburg",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6088,
    density: 17.3,
    county_fips: 54023,
    county_name: "Grant",
    county_weights: {
      54023: 96.82,
      54031: 1.63,
      54071: 1.55,
    },
    county_names_all: "Grant|Hardy|Pendleton",
    county_fips_all: "54023|54031|54071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26851,
    lat: 39.04801,
    lng: -78.62878,
    city: "Wardensville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1868,
    density: 7.1,
    county_fips: 54031,
    county_name: "Hardy",
    county_weights: {
      54027: 6.17,
      54031: 93.83,
    },
    county_names_all: "Hardy|Hampshire",
    county_fips_all: "54031|54027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26852,
    lat: 39.2477,
    lng: -78.91599,
    city: "Purgitsville",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 843,
    density: 6.9,
    county_fips: 54027,
    county_name: "Hampshire",
    county_weights: {
      54027: 74.25,
      54031: 14.2,
      54057: 11.54,
    },
    county_names_all: "Hampshire|Hardy|Mineral",
    county_fips_all: "54027|54031|54057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26855,
    lat: 38.96933,
    lng: -79.25935,
    city: "Cabins",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 658,
    density: 14.5,
    county_fips: 54023,
    county_name: "Grant",
    county_weights: {
      54023: 77.37,
      54071: 22.63,
    },
    county_names_all: "Grant|Pendleton",
    county_fips_all: "54023|54071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26865,
    lat: 39.19053,
    lng: -78.51932,
    city: "Yellow Spring",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 199,
    density: 2.2,
    county_fips: 54027,
    county_name: "Hampshire",
    county_weights: {
      54027: 100,
    },
    county_names_all: "Hampshire",
    county_fips_all: 54027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26866,
    lat: 38.80493,
    lng: -79.2512,
    city: "Upper Tract",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 621,
    density: 2.5,
    county_fips: 54071,
    county_name: "Pendleton",
    county_weights: {
      54023: 6.37,
      54071: 93.63,
    },
    county_names_all: "Pendleton|Grant",
    county_fips_all: "54071|54023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26884,
    lat: 38.84273,
    lng: -79.40118,
    city: "Seneca Rocks",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 645,
    density: 4.3,
    county_fips: 54071,
    county_name: "Pendleton",
    county_weights: {
      54071: 100,
    },
    county_names_all: "Pendleton",
    county_fips_all: 54071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 26886,
    lat: 38.88742,
    lng: -79.40064,
    city: "Onego",
    state_id: "WV",
    state_name: "West Virginia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 54071,
    county_name: "Pendleton",
    county_weights: {
      54071: 100,
    },
    county_names_all: "Pendleton",
    county_fips_all: 54071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27006,
    lat: 35.94352,
    lng: -80.43673,
    city: "Advance",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15320,
    density: 94.2,
    county_fips: 37059,
    county_name: "Davie",
    county_weights: {
      37059: 100,
    },
    county_names_all: "Davie",
    county_fips_all: 37059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27007,
    lat: 36.38799,
    lng: -80.59144,
    city: "Ararat",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2507,
    density: 47,
    county_fips: 37171,
    county_name: "Surry",
    county_weights: {
      37171: 100,
    },
    county_names_all: "Surry",
    county_fips_all: 37171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27009,
    lat: 36.23089,
    lng: -80.07927,
    city: "Belews Creek",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3341,
    density: 78.2,
    county_fips: 37067,
    county_name: "Forsyth",
    county_weights: {
      37067: 90.74,
      37169: 9.26,
    },
    county_names_all: "Forsyth|Stokes",
    county_fips_all: "37067|37169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27011,
    lat: 36.21649,
    lng: -80.69728,
    city: "Boonville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4885,
    density: 36.7,
    county_fips: 37197,
    county_name: "Yadkin",
    county_weights: {
      37197: 100,
    },
    county_names_all: "Yadkin",
    county_fips_all: 37197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27012,
    lat: 36.00434,
    lng: -80.37547,
    city: "Clemmons",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28051,
    density: 257.9,
    county_fips: 37067,
    county_name: "Forsyth",
    county_weights: {
      37057: 37.87,
      37067: 62.13,
    },
    county_names_all: "Forsyth|Davidson",
    county_fips_all: "37067|37057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27013,
    lat: 35.75633,
    lng: -80.70235,
    city: "Cleveland",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6120,
    density: 31.4,
    county_fips: 37159,
    county_name: "Rowan",
    county_weights: {
      37097: 19.31,
      37159: 80.69,
    },
    county_names_all: "Rowan|Iredell",
    county_fips_all: "37159|37097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27014,
    lat: 35.8121,
    lng: -80.55508,
    city: "Cooleemee",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 932,
    density: 577.2,
    county_fips: 37059,
    county_name: "Davie",
    county_weights: {
      37059: 100,
    },
    county_names_all: "Davie",
    county_fips_all: 37059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27016,
    lat: 36.44318,
    lng: -80.2219,
    city: "Danbury",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1440,
    density: 12.4,
    county_fips: 37169,
    county_name: "Stokes",
    county_weights: {
      37169: 100,
    },
    county_names_all: "Stokes",
    county_fips_all: 37169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27017,
    lat: 36.38141,
    lng: -80.76052,
    city: "Dobson",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9438,
    density: 33.6,
    county_fips: 37171,
    county_name: "Surry",
    county_weights: {
      37171: 100,
    },
    county_names_all: "Surry",
    county_fips_all: 37171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27018,
    lat: 36.1978,
    lng: -80.52096,
    city: "East Bend",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8337,
    density: 39.1,
    county_fips: 37197,
    county_name: "Yadkin",
    county_weights: {
      37197: 100,
    },
    county_names_all: "Yadkin",
    county_fips_all: 37197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27019,
    lat: 36.28604,
    lng: -80.23548,
    city: "Germanton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4232,
    density: 45.7,
    county_fips: 37169,
    county_name: "Stokes",
    county_weights: {
      37067: 31.77,
      37169: 68.23,
    },
    county_names_all: "Stokes|Forsyth",
    county_fips_all: "37169|37067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27020,
    lat: 36.1047,
    lng: -80.81272,
    city: "Hamptonville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6091,
    density: 30.9,
    county_fips: 37197,
    county_name: "Yadkin",
    county_weights: {
      37097: 13.92,
      37193: 7.76,
      37197: 78.32,
    },
    county_names_all: "Yadkin|Iredell|Wilkes",
    county_fips_all: "37197|37097|37193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27021,
    lat: 36.31859,
    lng: -80.3386,
    city: "King",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17286,
    density: 124.2,
    county_fips: 37169,
    county_name: "Stokes",
    county_weights: {
      37067: 0.66,
      37169: 99.34,
    },
    county_names_all: "Stokes|Forsyth",
    county_fips_all: "37169|37067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27022,
    lat: 36.51409,
    lng: -80.21739,
    city: "Lawsonville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1330,
    density: 15.5,
    county_fips: 37169,
    county_name: "Stokes",
    county_weights: {
      37169: 100,
    },
    county_names_all: "Stokes",
    county_fips_all: 37169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27023,
    lat: 36.09103,
    lng: -80.45101,
    city: "Lewisville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13418,
    density: 186.6,
    county_fips: 37067,
    county_name: "Forsyth",
    county_weights: {
      37067: 100,
    },
    county_names_all: "Forsyth",
    county_fips_all: 37067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27024,
    lat: 36.52399,
    lng: -80.84027,
    city: "Lowgap",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3404,
    density: 30.1,
    county_fips: 37171,
    county_name: "Surry",
    county_weights: {
      37171: 100,
    },
    county_names_all: "Surry",
    county_fips_all: 37171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27025,
    lat: 36.3771,
    lng: -79.97148,
    city: "Madison",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11346,
    density: 44.8,
    county_fips: 37157,
    county_name: "Rockingham",
    county_weights: {
      37157: 71.89,
      37169: 28.11,
    },
    county_names_all: "Rockingham|Stokes",
    county_fips_all: "37157|37169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27027,
    lat: 36.4456,
    lng: -79.98883,
    city: "Mayodan",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4194,
    density: 76.6,
    county_fips: 37157,
    county_name: "Rockingham",
    county_weights: {
      37157: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 37157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27028,
    lat: 35.92433,
    lng: -80.5742,
    city: "Mocksville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25865,
    density: 51.8,
    county_fips: 37059,
    county_name: "Davie",
    county_weights: {
      37059: 99.38,
      37097: 0.62,
    },
    county_names_all: "Davie|Iredell",
    county_fips_all: "37059|37097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27030,
    lat: 36.48836,
    lng: -80.63013,
    city: "Mount Airy",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35421,
    density: 80.2,
    county_fips: 37171,
    county_name: "Surry",
    county_weights: {
      37169: 4.27,
      37171: 95.73,
    },
    county_names_all: "Surry|Stokes",
    county_fips_all: "37171|37169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27040,
    lat: 36.16869,
    lng: -80.38969,
    city: "Pfafftown",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12670,
    density: 185.4,
    county_fips: 37067,
    county_name: "Forsyth",
    county_weights: {
      37067: 100,
    },
    county_names_all: "Forsyth",
    county_fips_all: 37067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27041,
    lat: 36.41539,
    lng: -80.48465,
    city: "Pilot Mountain",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7772,
    density: 49.7,
    county_fips: 37171,
    county_name: "Surry",
    county_weights: {
      37169: 18.62,
      37171: 81.38,
    },
    county_names_all: "Surry|Stokes",
    county_fips_all: "37171|37169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27042,
    lat: 36.34177,
    lng: -80.05434,
    city: "Pine Hall",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 284,
    density: 15.2,
    county_fips: 37169,
    county_name: "Stokes",
    county_weights: {
      37169: 100,
    },
    county_names_all: "Stokes",
    county_fips_all: 37169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27043,
    lat: 36.33709,
    lng: -80.44917,
    city: "Pinnacle",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6985,
    density: 39.4,
    county_fips: 37169,
    county_name: "Stokes",
    county_weights: {
      37067: 0.64,
      37169: 52.27,
      37171: 47.09,
    },
    county_names_all: "Stokes|Surry|Forsyth",
    county_fips_all: "37169|37171|37067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27045,
    lat: 36.23482,
    lng: -80.29614,
    city: "Rural Hall",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10011,
    density: 165.4,
    county_fips: 37067,
    county_name: "Forsyth",
    county_weights: {
      37067: 91.48,
      37169: 8.52,
    },
    county_names_all: "Forsyth|Stokes",
    county_fips_all: "37067|37169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27046,
    lat: 36.49228,
    lng: -80.09223,
    city: "Sandy Ridge",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2061,
    density: 18.4,
    county_fips: 37169,
    county_name: "Stokes",
    county_weights: {
      37169: 100,
    },
    county_names_all: "Stokes",
    county_fips_all: 37169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27047,
    lat: 36.31178,
    lng: -80.57786,
    city: "Siloam",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1443,
    density: 27.2,
    county_fips: 37171,
    county_name: "Surry",
    county_weights: {
      37171: 100,
    },
    county_names_all: "Surry",
    county_fips_all: 37171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27048,
    lat: 36.47611,
    lng: -79.91295,
    city: "Stoneville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8367,
    density: 38.8,
    county_fips: 37157,
    county_name: "Rockingham",
    county_weights: {
      37157: 98.59,
      51089: 1.41,
    },
    county_names_all: "Rockingham|Henry",
    county_fips_all: "37157|51089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27050,
    lat: 36.23608,
    lng: -80.40116,
    city: "Tobaccoville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4051,
    density: 62.5,
    county_fips: 37067,
    county_name: "Forsyth",
    county_weights: {
      37067: 86.98,
      37169: 13.02,
    },
    county_names_all: "Forsyth|Stokes",
    county_fips_all: "37067|37169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27051,
    lat: 36.18728,
    lng: -80.16012,
    city: "Walkertown",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7108,
    density: 149.9,
    county_fips: 37067,
    county_name: "Forsyth",
    county_weights: {
      37067: 100,
    },
    county_names_all: "Forsyth",
    county_fips_all: 37067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27052,
    lat: 36.32259,
    lng: -80.14552,
    city: "Walnut Cove",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10425,
    density: 40.7,
    county_fips: 37169,
    county_name: "Stokes",
    county_weights: {
      37067: 10.96,
      37169: 89.04,
    },
    county_names_all: "Stokes|Forsyth",
    county_fips_all: "37169|37067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27053,
    lat: 36.47317,
    lng: -80.34989,
    city: "Westfield",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3419,
    density: 19,
    county_fips: 37169,
    county_name: "Stokes",
    county_weights: {
      37169: 96.53,
      37171: 3.47,
    },
    county_names_all: "Stokes|Surry",
    county_fips_all: "37169|37171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27054,
    lat: 35.79304,
    lng: -80.59833,
    city: "Woodleaf",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2118,
    density: 28.3,
    county_fips: 37159,
    county_name: "Rowan",
    county_weights: {
      37159: 100,
    },
    county_names_all: "Rowan",
    county_fips_all: 37159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27055,
    lat: 36.11382,
    lng: -80.63586,
    city: "Yadkinville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14239,
    density: 49.4,
    county_fips: 37197,
    county_name: "Yadkin",
    county_weights: {
      37059: 1.73,
      37097: 1.31,
      37197: 96.96,
    },
    county_names_all: "Yadkin|Davie|Iredell",
    county_fips_all: "37197|37059|37097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27101,
    lat: 36.11204,
    lng: -80.19889,
    city: "Winston Salem",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19888,
    density: 615.4,
    county_fips: 37067,
    county_name: "Forsyth",
    county_weights: {
      37067: 100,
    },
    county_names_all: "Forsyth",
    county_fips_all: 37067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27103,
    lat: 36.05822,
    lng: -80.32125,
    city: "Winston Salem",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35057,
    density: 727.1,
    county_fips: 37067,
    county_name: "Forsyth",
    county_weights: {
      37067: 100,
    },
    county_names_all: "Forsyth",
    county_fips_all: 37067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27104,
    lat: 36.09465,
    lng: -80.32501,
    city: "Winston Salem",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29318,
    density: 914,
    county_fips: 37067,
    county_name: "Forsyth",
    county_weights: {
      37067: 100,
    },
    county_names_all: "Forsyth",
    county_fips_all: 37067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27105,
    lat: 36.16294,
    lng: -80.23521,
    city: "Winston Salem",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41630,
    density: 476.6,
    county_fips: 37067,
    county_name: "Forsyth",
    county_weights: {
      37067: 100,
    },
    county_names_all: "Forsyth",
    county_fips_all: 37067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27106,
    lat: 36.14255,
    lng: -80.3228,
    city: "Winston Salem",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47332,
    density: 641.9,
    county_fips: 37067,
    county_name: "Forsyth",
    county_weights: {
      37067: 100,
    },
    county_names_all: "Forsyth",
    county_fips_all: 37067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27107,
    lat: 36.01488,
    lng: -80.17819,
    city: "Winston Salem",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48420,
    density: 282.5,
    county_fips: 37057,
    county_name: "Davidson",
    county_weights: {
      37057: 52.5,
      37067: 47.5,
    },
    county_names_all: "Davidson|Forsyth",
    county_fips_all: "37057|37067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27109,
    lat: 36.13371,
    lng: -80.27539,
    city: "Winston Salem",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2674,
    density: 3392.1,
    county_fips: 37067,
    county_name: "Forsyth",
    county_weights: {
      37067: 100,
    },
    county_names_all: "Forsyth",
    county_fips_all: 37067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27110,
    lat: 36.08919,
    lng: -80.225,
    city: "Winston Salem",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2754,
    density: 5815.8,
    county_fips: 37067,
    county_name: "Forsyth",
    county_weights: {
      37067: 100,
    },
    county_names_all: "Forsyth",
    county_fips_all: 37067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27127,
    lat: 36.02028,
    lng: -80.27847,
    city: "Winston Salem",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41398,
    density: 544.4,
    county_fips: 37067,
    county_name: "Forsyth",
    county_weights: {
      37057: 18.45,
      37067: 81.55,
    },
    county_names_all: "Forsyth|Davidson",
    county_fips_all: "37067|37057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27201,
    lat: 36.03258,
    lng: -79.48418,
    city: "Alamance",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 82,
    density: 144.9,
    county_fips: 37001,
    county_name: "Alamance",
    county_weights: {
      37001: 100,
    },
    county_names_all: "Alamance",
    county_fips_all: 37001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27202,
    lat: 36.18565,
    lng: -79.50594,
    city: "Altamahaw",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37001,
    county_name: "Alamance",
    county_weights: {
      37001: 100,
    },
    county_names_all: "Alamance",
    county_fips_all: 37001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27203,
    lat: 35.73253,
    lng: -79.78857,
    city: "Asheboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21783,
    density: 374,
    county_fips: 37151,
    county_name: "Randolph",
    county_weights: {
      37151: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 37151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27205,
    lat: 35.6399,
    lng: -79.85094,
    city: "Asheboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36294,
    density: 62.6,
    county_fips: 37151,
    county_name: "Randolph",
    county_weights: {
      37151: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 37151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27207,
    lat: 35.6064,
    lng: -79.38893,
    city: "Bear Creek",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3877,
    density: 17.3,
    county_fips: 37037,
    county_name: "Chatham",
    county_weights: {
      37037: 100,
    },
    county_names_all: "Chatham",
    county_fips_all: 37037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27208,
    lat: 35.56246,
    lng: -79.54231,
    city: "Bennett",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1470,
    density: 13.9,
    county_fips: 37037,
    county_name: "Chatham",
    county_weights: {
      37037: 52.95,
      37125: 8.4,
      37151: 38.65,
    },
    county_names_all: "Chatham|Randolph|Moore",
    county_fips_all: "37037|37151|37125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27209,
    lat: 35.34254,
    lng: -79.74936,
    city: "Biscoe",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4514,
    density: 37.3,
    county_fips: 37123,
    county_name: "Montgomery",
    county_weights: {
      37123: 68.46,
      37125: 31.54,
    },
    county_names_all: "Montgomery|Moore",
    county_fips_all: "37123|37125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27212,
    lat: 36.46207,
    lng: -79.27976,
    city: "Blanch",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1923,
    density: 14.4,
    county_fips: 37033,
    county_name: "Caswell",
    county_weights: {
      37033: 100,
    },
    county_names_all: "Caswell",
    county_fips_all: 37033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27213,
    lat: 35.6473,
    lng: -79.40454,
    city: "Bonlee",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37037,
    county_name: "Chatham",
    county_weights: {
      37037: 100,
    },
    county_names_all: "Chatham",
    county_fips_all: 37037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27214,
    lat: 36.21407,
    lng: -79.68283,
    city: "Browns Summit",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12421,
    density: 93.5,
    county_fips: 37081,
    county_name: "Guilford",
    county_weights: {
      37081: 89.07,
      37157: 10.93,
    },
    county_names_all: "Guilford|Rockingham",
    county_fips_all: "37081|37157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27215,
    lat: 36.03055,
    lng: -79.48729,
    city: "Burlington",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43187,
    density: 264.4,
    county_fips: 37001,
    county_name: "Alamance",
    county_weights: {
      37001: 88.5,
      37081: 11.5,
    },
    county_names_all: "Alamance|Guilford",
    county_fips_all: "37001|37081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27217,
    lat: 36.19221,
    lng: -79.38404,
    city: "Burlington",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38587,
    density: 120.9,
    county_fips: 37001,
    county_name: "Alamance",
    county_weights: {
      37001: 82.77,
      37033: 17.23,
    },
    county_names_all: "Alamance|Caswell",
    county_fips_all: "37001|37033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27229,
    lat: 35.24853,
    lng: -79.79873,
    city: "Candor",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3310,
    density: 14.1,
    county_fips: 37123,
    county_name: "Montgomery",
    county_weights: {
      37123: 97.25,
      37153: 2.75,
    },
    county_names_all: "Montgomery|Richmond",
    county_fips_all: "37123|37153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27231,
    lat: 36.20455,
    lng: -79.17268,
    city: "Cedar Grove",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2224,
    density: 24.5,
    county_fips: 37135,
    county_name: "Orange",
    county_weights: {
      37033: 1.65,
      37135: 97.23,
      37145: 1.12,
    },
    county_names_all: "Orange|Caswell|Person",
    county_fips_all: "37135|37033|37145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27233,
    lat: 35.8882,
    lng: -79.6988,
    city: "Climax",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3490,
    density: 55.2,
    county_fips: 37151,
    county_name: "Randolph",
    county_weights: {
      37081: 33.52,
      37151: 66.48,
    },
    county_names_all: "Randolph|Guilford",
    county_fips_all: "37151|37081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27235,
    lat: 36.09734,
    lng: -80.00871,
    city: "Colfax",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4609,
    density: 133.8,
    county_fips: 37081,
    county_name: "Guilford",
    county_weights: {
      37081: 100,
    },
    county_names_all: "Guilford",
    county_fips_all: 37081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27239,
    lat: 35.60566,
    lng: -80.09024,
    city: "Denton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8693,
    density: 21.6,
    county_fips: 37057,
    county_name: "Davidson",
    county_weights: {
      37057: 60.4,
      37151: 39.6,
    },
    county_names_all: "Davidson|Randolph",
    county_fips_all: "37057|37151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27242,
    lat: 35.33645,
    lng: -79.63761,
    city: "Eagle Springs",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1627,
    density: 12.4,
    county_fips: 37125,
    county_name: "Moore",
    county_weights: {
      37125: 100,
    },
    county_names_all: "Moore",
    county_fips_all: 37125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27243,
    lat: 36.07821,
    lng: -79.1945,
    city: "Efland",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4958,
    density: 47.5,
    county_fips: 37135,
    county_name: "Orange",
    county_weights: {
      37135: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 37135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27244,
    lat: 36.21402,
    lng: -79.48747,
    city: "Elon",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16697,
    density: 119.9,
    county_fips: 37001,
    county_name: "Alamance",
    county_weights: {
      37001: 47.03,
      37033: 41.59,
      37081: 11.38,
    },
    county_names_all: "Alamance|Caswell|Guilford",
    county_fips_all: "37001|37033|37081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27247,
    lat: 35.46096,
    lng: -79.78784,
    city: "Ether",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37123,
    county_name: "Montgomery",
    county_weights: {
      37123: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 37123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27248,
    lat: 35.78916,
    lng: -79.70953,
    city: "Franklinville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3522,
    density: 39.5,
    county_fips: 37151,
    county_name: "Randolph",
    county_weights: {
      37151: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 37151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27249,
    lat: 36.16014,
    lng: -79.58134,
    city: "Gibsonville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12825,
    density: 82.8,
    county_fips: 37081,
    county_name: "Guilford",
    county_weights: {
      37001: 8.89,
      37033: 3.06,
      37081: 79.77,
      37157: 8.28,
    },
    county_names_all: "Guilford|Alamance|Rockingham|Caswell",
    county_fips_all: "37081|37001|37157|37033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27252,
    lat: 35.56033,
    lng: -79.35563,
    city: "Goldston",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1665,
    density: 17.3,
    county_fips: 37037,
    county_name: "Chatham",
    county_weights: {
      37037: 100,
    },
    county_names_all: "Chatham",
    county_fips_all: 37037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27253,
    lat: 35.96239,
    lng: -79.34581,
    city: "Graham",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31046,
    density: 146.3,
    county_fips: 37001,
    county_name: "Alamance",
    county_weights: {
      37001: 100,
    },
    county_names_all: "Alamance",
    county_fips_all: 37001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27256,
    lat: 35.56058,
    lng: -79.2725,
    city: "Gulf",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37037,
    county_name: "Chatham",
    county_weights: {
      37037: 100,
    },
    county_names_all: "Chatham",
    county_fips_all: 37037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27258,
    lat: 36.03401,
    lng: -79.32623,
    city: "Haw River",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7292,
    density: 150,
    county_fips: 37001,
    county_name: "Alamance",
    county_weights: {
      37001: 100,
    },
    county_names_all: "Alamance",
    county_fips_all: 37001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27259,
    lat: 35.49149,
    lng: -79.52624,
    city: "Highfalls",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37125,
    county_name: "Moore",
    county_weights: {
      37125: 100,
    },
    county_names_all: "Moore",
    county_fips_all: 37125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27260,
    lat: 35.95473,
    lng: -79.98697,
    city: "High Point",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25351,
    density: 790.8,
    county_fips: 37081,
    county_name: "Guilford",
    county_weights: {
      37081: 96.49,
      37151: 3.51,
    },
    county_names_all: "Guilford|Randolph",
    county_fips_all: "37081|37151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27262,
    lat: 35.96191,
    lng: -80.03845,
    city: "High Point",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26094,
    density: 763.8,
    county_fips: 37081,
    county_name: "Guilford",
    county_weights: {
      37057: 32.84,
      37081: 66.52,
      37151: 0.64,
    },
    county_names_all: "Guilford|Davidson|Randolph",
    county_fips_all: "37081|37057|37151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27263,
    lat: 35.90931,
    lng: -79.93829,
    city: "High Point",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22157,
    density: 219.2,
    county_fips: 37151,
    county_name: "Randolph",
    county_weights: {
      37081: 38.91,
      37151: 61.09,
    },
    county_names_all: "Randolph|Guilford",
    county_fips_all: "37151|37081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27265,
    lat: 36.00947,
    lng: -80.03272,
    city: "High Point",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50220,
    density: 467.2,
    county_fips: 37081,
    county_name: "Guilford",
    county_weights: {
      37057: 37.66,
      37067: 2.95,
      37081: 59.39,
    },
    county_names_all: "Guilford|Davidson|Forsyth",
    county_fips_all: "37081|37057|37067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27268,
    lat: 35.97139,
    lng: -79.99471,
    city: "High Point",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37081,
    county_name: "Guilford",
    county_weights: {
      37081: 100,
    },
    county_names_all: "Guilford",
    county_fips_all: 37081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27278,
    lat: 36.08673,
    lng: -79.08778,
    city: "Hillsborough",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26393,
    density: 98.3,
    county_fips: 37135,
    county_name: "Orange",
    county_weights: {
      37063: 4.01,
      37135: 95.99,
    },
    county_names_all: "Orange|Durham",
    county_fips_all: "37135|37063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27281,
    lat: 35.18538,
    lng: -79.62689,
    city: "Jackson Springs",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3211,
    density: 18.2,
    county_fips: 37125,
    county_name: "Moore",
    county_weights: {
      37123: 28.98,
      37125: 58.77,
      37153: 12.25,
    },
    county_names_all: "Moore|Montgomery|Richmond",
    county_fips_all: "37125|37123|37153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27282,
    lat: 35.99656,
    lng: -79.92869,
    city: "Jamestown",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16515,
    density: 433.2,
    county_fips: 37081,
    county_name: "Guilford",
    county_weights: {
      37081: 100,
    },
    county_names_all: "Guilford",
    county_fips_all: 37081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27283,
    lat: 35.95293,
    lng: -79.63621,
    city: "Julian",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3007,
    density: 45.1,
    county_fips: 37081,
    county_name: "Guilford",
    county_weights: {
      37081: 98.54,
      37151: 1.46,
    },
    county_names_all: "Guilford|Randolph",
    county_fips_all: "37081|37151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27284,
    lat: 36.11818,
    lng: -80.07794,
    city: "Kernersville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55913,
    density: 274,
    county_fips: 37067,
    county_name: "Forsyth",
    county_weights: {
      37057: 2.72,
      37067: 82.92,
      37081: 14.36,
    },
    county_names_all: "Forsyth|Guilford|Davidson",
    county_fips_all: "37067|37081|37057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27288,
    lat: 36.49812,
    lng: -79.74587,
    city: "Eden",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23536,
    density: 127.2,
    county_fips: 37157,
    county_name: "Rockingham",
    county_weights: {
      37157: 100,
    },
    county_names_all: "Rockingham",
    county_fips_all: 37157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27291,
    lat: 36.40173,
    lng: -79.16679,
    city: "Leasburg",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1293,
    density: 9.9,
    county_fips: 37033,
    county_name: "Caswell",
    county_weights: {
      37033: 68.4,
      37145: 31.6,
    },
    county_names_all: "Caswell|Person",
    county_fips_all: "37033|37145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27292,
    lat: 35.73469,
    lng: -80.20845,
    city: "Lexington",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40545,
    density: 108.7,
    county_fips: 37057,
    county_name: "Davidson",
    county_weights: {
      37057: 99.36,
      37151: 0.64,
    },
    county_names_all: "Davidson|Randolph",
    county_fips_all: "37057|37151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27295,
    lat: 35.86756,
    lng: -80.31623,
    city: "Lexington",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38751,
    density: 117.2,
    county_fips: 37057,
    county_name: "Davidson",
    county_weights: {
      37057: 100,
    },
    county_names_all: "Davidson",
    county_fips_all: 37057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27298,
    lat: 35.88563,
    lng: -79.56816,
    city: "Liberty",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10841,
    density: 44.1,
    county_fips: 37151,
    county_name: "Randolph",
    county_weights: {
      37001: 30.87,
      37037: 1,
      37081: 23.74,
      37151: 44.39,
    },
    county_names_all: "Randolph|Alamance|Guilford|Chatham",
    county_fips_all: "37151|37001|37081|37037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27299,
    lat: 35.75131,
    lng: -80.38402,
    city: "Linwood",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5827,
    density: 81.8,
    county_fips: 37057,
    county_name: "Davidson",
    county_weights: {
      37057: 100,
    },
    county_names_all: "Davidson",
    county_fips_all: 37057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27301,
    lat: 36.11512,
    lng: -79.66755,
    city: "McLeansville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8797,
    density: 102,
    county_fips: 37081,
    county_name: "Guilford",
    county_weights: {
      37081: 100,
    },
    county_names_all: "Guilford",
    county_fips_all: 37081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27302,
    lat: 36.13749,
    lng: -79.2647,
    city: "Mebane",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31693,
    density: 106.7,
    county_fips: 37001,
    county_name: "Alamance",
    county_weights: {
      37001: 41.03,
      37033: 23,
      37135: 35.97,
    },
    county_names_all: "Alamance|Orange|Caswell",
    county_fips_all: "37001|37135|37033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27305,
    lat: 36.52029,
    lng: -79.22553,
    city: "Milton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1570,
    density: 23.7,
    county_fips: 37033,
    county_name: "Caswell",
    county_weights: {
      37033: 97.49,
      37145: 2.51,
    },
    county_names_all: "Caswell|Person",
    county_fips_all: "37033|37145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27306,
    lat: 35.22098,
    lng: -79.97685,
    city: "Mount Gilead",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6226,
    density: 13,
    county_fips: 37123,
    county_name: "Montgomery",
    county_weights: {
      37123: 77.29,
      37153: 22.71,
    },
    county_names_all: "Montgomery|Richmond",
    county_fips_all: "37123|37153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27310,
    lat: 36.17294,
    lng: -79.99159,
    city: "Oak Ridge",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7398,
    density: 159.3,
    county_fips: 37081,
    county_name: "Guilford",
    county_weights: {
      37081: 100,
    },
    county_names_all: "Guilford",
    county_fips_all: 37081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27311,
    lat: 36.48137,
    lng: -79.47577,
    city: "Pelham",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3323,
    density: 26.1,
    county_fips: 37033,
    county_name: "Caswell",
    county_weights: {
      37033: 81.88,
      37157: 18.12,
    },
    county_names_all: "Caswell|Rockingham",
    county_fips_all: "37033|37157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27312,
    lat: 35.75446,
    lng: -79.19648,
    city: "Pittsboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22031,
    density: 49.8,
    county_fips: 37037,
    county_name: "Chatham",
    county_weights: {
      37001: 0.63,
      37037: 99.37,
    },
    county_names_all: "Chatham|Alamance",
    county_fips_all: "37037|37001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27313,
    lat: 35.92892,
    lng: -79.75142,
    city: "Pleasant Garden",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6663,
    density: 92.1,
    county_fips: 37081,
    county_name: "Guilford",
    county_weights: {
      37081: 69.83,
      37151: 30.17,
    },
    county_names_all: "Guilford|Randolph",
    county_fips_all: "37081|37151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27314,
    lat: 36.29072,
    lng: -79.18594,
    city: "Prospect Hill",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1023,
    density: 16.2,
    county_fips: 37033,
    county_name: "Caswell",
    county_weights: {
      37033: 100,
    },
    county_names_all: "Caswell",
    county_fips_all: 37033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27315,
    lat: 36.50613,
    lng: -79.39173,
    city: "Providence",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1933,
    density: 29,
    county_fips: 37033,
    county_name: "Caswell",
    county_weights: {
      37033: 100,
    },
    county_names_all: "Caswell",
    county_fips_all: 37033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27316,
    lat: 35.68996,
    lng: -79.62366,
    city: "Ramseur",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8169,
    density: 46.6,
    county_fips: 37151,
    county_name: "Randolph",
    county_weights: {
      37151: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 37151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27317,
    lat: 35.83809,
    lng: -79.80376,
    city: "Randleman",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16474,
    density: 117.5,
    county_fips: 37151,
    county_name: "Randolph",
    county_weights: {
      37081: 4.85,
      37151: 95.15,
    },
    county_names_all: "Randolph|Guilford",
    county_fips_all: "37151|37081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27320,
    lat: 36.3434,
    lng: -79.6599,
    city: "Reidsville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38318,
    density: 60.4,
    county_fips: 37157,
    county_name: "Rockingham",
    county_weights: {
      37033: 12.03,
      37081: 0.25,
      37157: 87.72,
    },
    county_names_all: "Rockingham|Caswell|Guilford",
    county_fips_all: "37157|37033|37081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27325,
    lat: 35.46236,
    lng: -79.57249,
    city: "Robbins",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8289,
    density: 38.7,
    county_fips: 37125,
    county_name: "Moore",
    county_weights: {
      37125: 98.84,
      37151: 1.16,
    },
    county_names_all: "Moore|Randolph",
    county_fips_all: "37125|37151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27326,
    lat: 36.45542,
    lng: -79.55867,
    city: "Ruffin",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3253,
    density: 19.3,
    county_fips: 37157,
    county_name: "Rockingham",
    county_weights: {
      37033: 31.2,
      37157: 68.8,
    },
    county_names_all: "Rockingham|Caswell",
    county_fips_all: "37157|37033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27330,
    lat: 35.51624,
    lng: -79.18394,
    city: "Sanford",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38943,
    density: 71.4,
    county_fips: 37105,
    county_name: "Lee",
    county_weights: {
      37037: 8.42,
      37085: 2.1,
      37105: 83.36,
      37125: 6.12,
    },
    county_names_all: "Lee|Chatham|Moore|Harnett",
    county_fips_all: "37105|37037|37125|37085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27332,
    lat: 35.37836,
    lng: -79.13599,
    city: "Sanford",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33465,
    density: 120.7,
    county_fips: 37105,
    county_name: "Lee",
    county_weights: {
      37085: 35.83,
      37105: 64.17,
    },
    county_names_all: "Lee|Harnett",
    county_fips_all: "37105|37085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27340,
    lat: 35.94557,
    lng: -79.31141,
    city: "Saxapahaw",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15,
    density: 16.3,
    county_fips: 37001,
    county_name: "Alamance",
    county_weights: {
      37001: 100,
    },
    county_names_all: "Alamance",
    county_fips_all: 37001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27341,
    lat: 35.52467,
    lng: -79.70014,
    city: "Seagrove",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3914,
    density: 15.8,
    county_fips: 37151,
    county_name: "Randolph",
    county_weights: {
      37123: 7.83,
      37125: 28.68,
      37151: 63.49,
    },
    county_names_all: "Randolph|Moore|Montgomery",
    county_fips_all: "37151|37125|37123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27342,
    lat: 36.06641,
    lng: -79.6186,
    city: "Sedalia",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37081,
    county_name: "Guilford",
    county_weights: {
      37081: 100,
    },
    county_names_all: "Guilford",
    county_fips_all: 37081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27343,
    lat: 36.50229,
    lng: -79.08892,
    city: "Semora",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1655,
    density: 13.7,
    county_fips: 37145,
    county_name: "Person",
    county_weights: {
      37033: 22.55,
      37145: 77.45,
    },
    county_names_all: "Person|Caswell",
    county_fips_all: "37145|37033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27344,
    lat: 35.7289,
    lng: -79.43366,
    city: "Siler City",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18864,
    density: 43.8,
    county_fips: 37037,
    county_name: "Chatham",
    county_weights: {
      37037: 94.94,
      37151: 5.06,
    },
    county_names_all: "Chatham|Randolph",
    county_fips_all: "37037|37151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27349,
    lat: 35.89845,
    lng: -79.41202,
    city: "Snow Camp",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5265,
    density: 31.9,
    county_fips: 37001,
    county_name: "Alamance",
    county_weights: {
      37001: 91.34,
      37037: 8.66,
    },
    county_names_all: "Alamance|Chatham",
    county_fips_all: "37001|37037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27350,
    lat: 35.80631,
    lng: -79.88917,
    city: "Sophia",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6253,
    density: 66.3,
    county_fips: 37151,
    county_name: "Randolph",
    county_weights: {
      37151: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 37151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27351,
    lat: 35.65976,
    lng: -80.26786,
    city: "Southmont",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37057,
    county_name: "Davidson",
    county_weights: {
      37057: 100,
    },
    county_names_all: "Davidson",
    county_fips_all: 37057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27355,
    lat: 35.78859,
    lng: -79.5678,
    city: "Staley",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2253,
    density: 25.2,
    county_fips: 37151,
    county_name: "Randolph",
    county_weights: {
      37037: 31.51,
      37151: 68.49,
    },
    county_names_all: "Randolph|Chatham",
    county_fips_all: "37151|37037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27356,
    lat: 35.43991,
    lng: -79.7982,
    city: "Star",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2974,
    density: 20.3,
    county_fips: 37123,
    county_name: "Montgomery",
    county_weights: {
      37123: 78.79,
      37125: 21.21,
    },
    county_names_all: "Montgomery|Moore",
    county_fips_all: "37123|37125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27357,
    lat: 36.26844,
    lng: -79.97641,
    city: "Stokesdale",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8558,
    density: 77.4,
    county_fips: 37157,
    county_name: "Rockingham",
    county_weights: {
      37081: 36.42,
      37157: 63.45,
      37169: 0.13,
    },
    county_names_all: "Rockingham|Guilford|Stokes",
    county_fips_all: "37157|37081|37169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27358,
    lat: 36.22723,
    lng: -79.88124,
    city: "Summerfield",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15852,
    density: 116,
    county_fips: 37081,
    county_name: "Guilford",
    county_weights: {
      37081: 70.99,
      37157: 29.01,
    },
    county_names_all: "Guilford|Rockingham",
    county_fips_all: "37081|37157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27360,
    lat: 35.85684,
    lng: -80.09987,
    city: "Thomasville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46292,
    density: 202.1,
    county_fips: 37057,
    county_name: "Davidson",
    county_weights: {
      37057: 87.83,
      37151: 12.17,
    },
    county_names_all: "Davidson|Randolph",
    county_fips_all: "37057|37151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27370,
    lat: 35.8116,
    lng: -79.99133,
    city: "Trinity",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13770,
    density: 89,
    county_fips: 37151,
    county_name: "Randolph",
    county_weights: {
      37151: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 37151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27371,
    lat: 35.42489,
    lng: -79.94912,
    city: "Troy",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8724,
    density: 23.5,
    county_fips: 37123,
    county_name: "Montgomery",
    county_weights: {
      37123: 92.37,
      37151: 7.63,
    },
    county_names_all: "Montgomery|Randolph",
    county_fips_all: "37123|37151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27374,
    lat: 35.91752,
    lng: -80.25777,
    city: "Welcome",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37057,
    county_name: "Davidson",
    county_weights: {
      37057: 100,
    },
    county_names_all: "Davidson",
    county_fips_all: 37057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27376,
    lat: 35.25607,
    lng: -79.53184,
    city: "West End",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9737,
    density: 54.8,
    county_fips: 37125,
    county_name: "Moore",
    county_weights: {
      37125: 100,
    },
    county_names_all: "Moore",
    county_fips_all: 37125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27377,
    lat: 36.03728,
    lng: -79.60221,
    city: "Whitsett",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8884,
    density: 133.2,
    county_fips: 37081,
    county_name: "Guilford",
    county_weights: {
      37081: 100,
    },
    county_names_all: "Guilford",
    county_fips_all: 37081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27379,
    lat: 36.37653,
    lng: -79.34653,
    city: "Yanceyville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4898,
    density: 21.3,
    county_fips: 37033,
    county_name: "Caswell",
    county_weights: {
      37033: 100,
    },
    county_names_all: "Caswell",
    county_fips_all: 37033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27401,
    lat: 36.06995,
    lng: -79.76724,
    city: "Greensboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23519,
    density: 1567.5,
    county_fips: 37081,
    county_name: "Guilford",
    county_weights: {
      37081: 100,
    },
    county_names_all: "Guilford",
    county_fips_all: 37081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27403,
    lat: 36.06406,
    lng: -79.82538,
    city: "Greensboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23410,
    density: 1568.4,
    county_fips: 37081,
    county_name: "Guilford",
    county_weights: {
      37081: 100,
    },
    county_names_all: "Guilford",
    county_fips_all: 37081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27405,
    lat: 36.11373,
    lng: -79.73463,
    city: "Greensboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51160,
    density: 629.6,
    county_fips: 37081,
    county_name: "Guilford",
    county_weights: {
      37081: 100,
    },
    county_names_all: "Guilford",
    county_fips_all: 37081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27406,
    lat: 35.9982,
    lng: -79.76686,
    city: "Greensboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62757,
    density: 349.3,
    county_fips: 37081,
    county_name: "Guilford",
    county_weights: {
      37081: 100,
    },
    county_names_all: "Guilford",
    county_fips_all: 37081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27407,
    lat: 36.01124,
    lng: -79.87588,
    city: "Greensboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53237,
    density: 698.1,
    county_fips: 37081,
    county_name: "Guilford",
    county_weights: {
      37081: 100,
    },
    county_names_all: "Guilford",
    county_fips_all: 37081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27408,
    lat: 36.10321,
    lng: -79.81411,
    city: "Greensboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17063,
    density: 857,
    county_fips: 37081,
    county_name: "Guilford",
    county_weights: {
      37081: 100,
    },
    county_names_all: "Guilford",
    county_fips_all: 37081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27409,
    lat: 36.09242,
    lng: -79.94431,
    city: "Greensboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15799,
    density: 306.4,
    county_fips: 37081,
    county_name: "Guilford",
    county_weights: {
      37081: 100,
    },
    county_names_all: "Guilford",
    county_fips_all: 37081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27410,
    lat: 36.11826,
    lng: -79.89223,
    city: "Greensboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57466,
    density: 696.2,
    county_fips: 37081,
    county_name: "Guilford",
    county_weights: {
      37081: 100,
    },
    county_names_all: "Guilford",
    county_fips_all: 37081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27411,
    lat: 36.07665,
    lng: -79.77157,
    city: "Greensboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37081,
    county_name: "Guilford",
    county_weights: {
      37081: 100,
    },
    county_names_all: "Guilford",
    county_fips_all: 37081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27412,
    lat: 36.06903,
    lng: -79.81062,
    city: "Greensboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37081,
    county_name: "Guilford",
    county_weights: {
      37081: 100,
    },
    county_names_all: "Guilford",
    county_fips_all: 37081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27455,
    lat: 36.18283,
    lng: -79.80794,
    city: "Greensboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28052,
    density: 377.1,
    county_fips: 37081,
    county_name: "Guilford",
    county_weights: {
      37081: 100,
    },
    county_names_all: "Guilford",
    county_fips_all: 37081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27501,
    lat: 35.48684,
    lng: -78.68419,
    city: "Angier",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21001,
    density: 129,
    county_fips: 37085,
    county_name: "Harnett",
    county_weights: {
      37085: 61.86,
      37101: 37.32,
      37183: 0.82,
    },
    county_names_all: "Harnett|Johnston|Wake",
    county_fips_all: "37085|37101|37183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27502,
    lat: 35.72123,
    lng: -78.90828,
    city: "Apex",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43345,
    density: 590.8,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37037: 20.47,
      37183: 79.53,
    },
    county_names_all: "Wake|Chatham",
    county_fips_all: "37183|37037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27503,
    lat: 36.15832,
    lng: -78.87757,
    city: "Bahama",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6209,
    density: 63.5,
    county_fips: 37063,
    county_name: "Durham",
    county_weights: {
      37063: 100,
    },
    county_names_all: "Durham",
    county_fips_all: 37063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27504,
    lat: 35.39963,
    lng: -78.51863,
    city: "Benson",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14734,
    density: 63.3,
    county_fips: 37101,
    county_name: "Johnston",
    county_weights: {
      37085: 2.86,
      37101: 97.14,
    },
    county_names_all: "Johnston|Harnett",
    county_fips_all: "37101|37085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27505,
    lat: 35.414,
    lng: -79.00198,
    city: "Broadway",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6970,
    density: 50,
    county_fips: 37085,
    county_name: "Harnett",
    county_weights: {
      37085: 96.27,
      37105: 3.73,
    },
    county_names_all: "Harnett|Lee",
    county_fips_all: "37085|37105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27506,
    lat: 35.40875,
    lng: -78.73896,
    city: "Buies Creek",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37085,
    county_name: "Harnett",
    county_weights: {
      37085: 100,
    },
    county_names_all: "Harnett",
    county_fips_all: 37085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27507,
    lat: 36.51253,
    lng: -78.55143,
    city: "Bullock",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2041,
    density: 14.6,
    county_fips: 37077,
    county_name: "Granville",
    county_weights: {
      37077: 78.26,
      37181: 21.74,
    },
    county_names_all: "Granville|Vance",
    county_fips_all: "37077|37181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27508,
    lat: 35.95882,
    lng: -78.25105,
    city: "Bunn",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2092,
    density: 76.3,
    county_fips: 37069,
    county_name: "Franklin",
    county_weights: {
      37069: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 37069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27509,
    lat: 36.12889,
    lng: -78.77604,
    city: "Butner",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6160,
    density: 162.2,
    county_fips: 37077,
    county_name: "Granville",
    county_weights: {
      37077: 100,
    },
    county_names_all: "Granville",
    county_fips_all: 37077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27510,
    lat: 35.91147,
    lng: -79.08211,
    city: "Carrboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14799,
    density: 1786.6,
    county_fips: 37135,
    county_name: "Orange",
    county_weights: {
      37135: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 37135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27511,
    lat: 35.76324,
    lng: -78.78437,
    city: "Cary",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34108,
    density: 1122.4,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37183: 100,
    },
    county_names_all: "Wake",
    county_fips_all: 37183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27513,
    lat: 35.80269,
    lng: -78.80159,
    city: "Cary",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46660,
    density: 1098.9,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37183: 100,
    },
    county_names_all: "Wake",
    county_fips_all: 37183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27514,
    lat: 35.96776,
    lng: -79.04406,
    city: "Chapel Hill",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33525,
    density: 660,
    county_fips: 37135,
    county_name: "Orange",
    county_weights: {
      37135: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 37135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27516,
    lat: 35.91239,
    lng: -79.15156,
    city: "Chapel Hill",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44572,
    density: 184.1,
    county_fips: 37135,
    county_name: "Orange",
    county_weights: {
      37037: 16.53,
      37135: 83.47,
    },
    county_names_all: "Orange|Chatham",
    county_fips_all: "37135|37037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27517,
    lat: 35.84389,
    lng: -79.03186,
    city: "Chapel Hill",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24928,
    density: 209.2,
    county_fips: 37037,
    county_name: "Chatham",
    county_weights: {
      37037: 61.14,
      37063: 17.4,
      37135: 21.46,
    },
    county_names_all: "Chatham|Orange|Durham",
    county_fips_all: "37037|37135|37063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27518,
    lat: 35.72927,
    lng: -78.7736,
    city: "Cary",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18397,
    density: 717.7,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37183: 100,
    },
    county_names_all: "Wake",
    county_fips_all: 37183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27519,
    lat: 35.80815,
    lng: -78.88711,
    city: "Cary",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58178,
    density: 1007.7,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37037: 8.14,
      37183: 91.86,
    },
    county_names_all: "Wake|Chatham",
    county_fips_all: "37183|37037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27520,
    lat: 35.61274,
    lng: -78.47075,
    city: "Clayton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43170,
    density: 235.5,
    county_fips: 37101,
    county_name: "Johnston",
    county_weights: {
      37101: 95.9,
      37183: 4.1,
    },
    county_names_all: "Johnston|Wake",
    county_fips_all: "37101|37183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27521,
    lat: 35.41298,
    lng: -78.65847,
    city: "Coats",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7021,
    density: 104.2,
    county_fips: 37085,
    county_name: "Harnett",
    county_weights: {
      37085: 100,
    },
    county_names_all: "Harnett",
    county_fips_all: 37085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27522,
    lat: 36.10565,
    lng: -78.67676,
    city: "Creedmoor",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12457,
    density: 66.5,
    county_fips: 37077,
    county_name: "Granville",
    county_weights: {
      37077: 84.25,
      37183: 15.75,
    },
    county_names_all: "Granville|Wake",
    county_fips_all: "37077|37183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27523,
    lat: 35.77102,
    lng: -78.95367,
    city: "Apex",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14946,
    density: 149.7,
    county_fips: 37037,
    county_name: "Chatham",
    county_weights: {
      37037: 70.39,
      37183: 29.61,
    },
    county_names_all: "Chatham|Wake",
    county_fips_all: "37037|37183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27524,
    lat: 35.39392,
    lng: -78.37948,
    city: "Four Oaks",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13308,
    density: 38.2,
    county_fips: 37101,
    county_name: "Johnston",
    county_weights: {
      37101: 92.07,
      37191: 7.93,
    },
    county_names_all: "Johnston|Wayne",
    county_fips_all: "37101|37191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27525,
    lat: 36.11721,
    lng: -78.46997,
    city: "Franklinton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14088,
    density: 58,
    county_fips: 37069,
    county_name: "Franklin",
    county_weights: {
      37069: 72.16,
      37077: 27.84,
    },
    county_names_all: "Franklin|Granville",
    county_fips_all: "37069|37077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27526,
    lat: 35.54179,
    lng: -78.8274,
    city: "Fuquay Varina",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48946,
    density: 192.5,
    county_fips: 37085,
    county_name: "Harnett",
    county_weights: {
      37085: 59.64,
      37183: 40.36,
    },
    county_names_all: "Harnett|Wake",
    county_fips_all: "37085|37183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27527,
    lat: 35.65767,
    lng: -78.38336,
    city: "Clayton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27711,
    density: 242.7,
    county_fips: 37101,
    county_name: "Johnston",
    county_weights: {
      37101: 100,
    },
    county_names_all: "Johnston",
    county_fips_all: 37101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27529,
    lat: 35.65048,
    lng: -78.58167,
    city: "Garner",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49632,
    density: 332.1,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37101: 33.45,
      37183: 66.55,
    },
    county_names_all: "Wake|Johnston",
    county_fips_all: "37183|37101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27530,
    lat: 35.36825,
    lng: -78.07511,
    city: "Goldsboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38229,
    density: 138.5,
    county_fips: 37191,
    county_name: "Wayne",
    county_weights: {
      37191: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 37191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27531,
    lat: 35.34362,
    lng: -77.96743,
    city: "Goldsboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 750,
    density: 83.3,
    county_fips: 37191,
    county_name: "Wayne",
    county_weights: {
      37191: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 37191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27533,
    lat: 35.38746,
    lng: -78.03896,
    city: "Goldsboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37191,
    county_name: "Wayne",
    county_weights: {
      37191: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 37191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27534,
    lat: 35.37153,
    lng: -77.90646,
    city: "Goldsboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31139,
    density: 164.6,
    county_fips: 37191,
    county_name: "Wayne",
    county_weights: {
      37079: 0.78,
      37191: 99.22,
    },
    county_names_all: "Wayne|Greene",
    county_fips_all: "37191|37079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27536,
    lat: 36.32645,
    lng: -78.40754,
    city: "Henderson",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16171,
    density: 516.1,
    county_fips: 37181,
    county_name: "Vance",
    county_weights: {
      37181: 100,
    },
    county_names_all: "Vance",
    county_fips_all: 37181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27537,
    lat: 36.35343,
    lng: -78.38887,
    city: "Henderson",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23894,
    density: 49.7,
    county_fips: 37181,
    county_name: "Vance",
    county_weights: {
      37069: 7.61,
      37181: 88.38,
      37185: 4.01,
    },
    county_names_all: "Vance|Franklin|Warren",
    county_fips_all: "37181|37069|37185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27539,
    lat: 35.67713,
    lng: -78.81269,
    city: "Apex",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23488,
    density: 292.5,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37183: 100,
    },
    county_names_all: "Wake",
    county_fips_all: 37183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27540,
    lat: 35.6103,
    lng: -78.87332,
    city: "Holly Springs",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41097,
    density: 330.6,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37037: 7.39,
      37085: 19.61,
      37183: 73,
    },
    county_names_all: "Wake|Harnett|Chatham",
    county_fips_all: "37183|37085|37037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27541,
    lat: 36.26176,
    lng: -79.0866,
    city: "Hurdle Mills",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4063,
    density: 22.6,
    county_fips: 37145,
    county_name: "Person",
    county_weights: {
      37033: 0.37,
      37135: 31.51,
      37145: 68.12,
    },
    county_names_all: "Person|Orange|Caswell",
    county_fips_all: "37145|37135|37033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27542,
    lat: 35.61776,
    lng: -78.1377,
    city: "Kenly",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10303,
    density: 44.2,
    county_fips: 37101,
    county_name: "Johnston",
    county_weights: {
      37101: 63.32,
      37191: 8.17,
      37195: 28.51,
    },
    county_names_all: "Johnston|Wilson|Wayne",
    county_fips_all: "37101|37195|37191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27544,
    lat: 36.20018,
    lng: -78.44097,
    city: "Kittrell",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5043,
    density: 32.4,
    county_fips: 37181,
    county_name: "Vance",
    county_weights: {
      37069: 29.73,
      37077: 19.36,
      37181: 50.91,
    },
    county_names_all: "Vance|Franklin|Granville",
    county_fips_all: "37181|37069|37077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27545,
    lat: 35.78513,
    lng: -78.48045,
    city: "Knightdale",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27215,
    density: 332.1,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37183: 100,
    },
    county_names_all: "Wake",
    county_fips_all: 37183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27546,
    lat: 35.38458,
    lng: -78.86626,
    city: "Lillington",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21743,
    density: 68.5,
    county_fips: 37085,
    county_name: "Harnett",
    county_weights: {
      37085: 100,
    },
    county_names_all: "Harnett",
    county_fips_all: 37085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27549,
    lat: 36.10439,
    lng: -78.24282,
    city: "Louisburg",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25485,
    density: 42.5,
    county_fips: 37069,
    county_name: "Franklin",
    county_weights: {
      37069: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 37069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27551,
    lat: 36.43339,
    lng: -78.05231,
    city: "Macon",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1694,
    density: 7.9,
    county_fips: 37185,
    county_name: "Warren",
    county_weights: {
      37185: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 37185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27553,
    lat: 36.48047,
    lng: -78.30643,
    city: "Manson",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2774,
    density: 27.8,
    county_fips: 37185,
    county_name: "Warren",
    county_weights: {
      37181: 41.16,
      37185: 58.84,
    },
    county_names_all: "Warren|Vance",
    county_fips_all: "37185|37181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27555,
    lat: 35.56242,
    lng: -78.20353,
    city: "Micro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 688,
    density: 633.5,
    county_fips: 37101,
    county_name: "Johnston",
    county_weights: {
      37101: 100,
    },
    county_names_all: "Johnston",
    county_fips_all: 37101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27556,
    lat: 36.39869,
    lng: -78.31294,
    city: "Middleburg",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 287,
    density: 52.6,
    county_fips: 37181,
    county_name: "Vance",
    county_weights: {
      37181: 100,
    },
    county_names_all: "Vance",
    county_fips_all: 37181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27557,
    lat: 35.77941,
    lng: -78.2,
    city: "Middlesex",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9061,
    density: 52.1,
    county_fips: 37127,
    county_name: "Nash",
    county_weights: {
      37069: 0.25,
      37101: 32.31,
      37127: 64.63,
      37195: 2.81,
    },
    county_names_all: "Nash|Johnston|Wilson|Franklin",
    county_fips_all: "37127|37101|37195|37069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27559,
    lat: 35.6299,
    lng: -79.0973,
    city: "Moncure",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2532,
    density: 19.3,
    county_fips: 37037,
    county_name: "Chatham",
    county_weights: {
      37037: 100,
    },
    county_names_all: "Chatham",
    county_fips_all: 37037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27560,
    lat: 35.85845,
    lng: -78.82544,
    city: "Morrisville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37830,
    density: 532.8,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37063: 12.88,
      37183: 87.12,
    },
    county_names_all: "Wake|Durham",
    county_fips_all: "37183|37063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27562,
    lat: 35.64157,
    lng: -78.98141,
    city: "New Hill",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3567,
    density: 25.4,
    county_fips: 37037,
    county_name: "Chatham",
    county_weights: {
      37037: 60.06,
      37183: 39.94,
    },
    county_names_all: "Chatham|Wake",
    county_fips_all: "37037|37183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27563,
    lat: 36.4312,
    lng: -78.23343,
    city: "Norlina",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4914,
    density: 26.6,
    county_fips: 37185,
    county_name: "Warren",
    county_weights: {
      37181: 2.98,
      37185: 97.02,
    },
    county_names_all: "Warren|Vance",
    county_fips_all: "37185|37181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27565,
    lat: 36.36203,
    lng: -78.64604,
    city: "Oxford",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25568,
    density: 30.9,
    county_fips: 37077,
    county_name: "Granville",
    county_weights: {
      37077: 94.74,
      37145: 1.23,
      37181: 4.03,
    },
    county_names_all: "Granville|Vance|Person",
    county_fips_all: "37077|37181|37145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27568,
    lat: 35.51132,
    lng: -78.24299,
    city: "Pine Level",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 609,
    density: 193.6,
    county_fips: 37101,
    county_name: "Johnston",
    county_weights: {
      37101: 100,
    },
    county_names_all: "Johnston",
    county_fips_all: 37101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27569,
    lat: 35.43306,
    lng: -78.17432,
    city: "Princeton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8813,
    density: 42.5,
    county_fips: 37101,
    county_name: "Johnston",
    county_weights: {
      37101: 79.03,
      37191: 20.97,
    },
    county_names_all: "Johnston|Wayne",
    county_fips_all: "37101|37191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27570,
    lat: 36.43861,
    lng: -78.23662,
    city: "Ridgeway",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37185,
    county_name: "Warren",
    county_weights: {
      37185: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 37185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27571,
    lat: 35.92151,
    lng: -78.4647,
    city: "Rolesville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7182,
    density: 569.4,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37183: 100,
    },
    county_names_all: "Wake",
    county_fips_all: 37183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27572,
    lat: 36.24872,
    lng: -78.88045,
    city: "Rougemont",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6750,
    density: 24.5,
    county_fips: 37145,
    county_name: "Person",
    county_weights: {
      37063: 24.52,
      37077: 16.19,
      37135: 23.55,
      37145: 35.73,
    },
    county_names_all: "Person|Durham|Orange|Granville",
    county_fips_all: "37145|37063|37135|37077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27573,
    lat: 36.3978,
    lng: -78.97476,
    city: "Roxboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11696,
    density: 260.9,
    county_fips: 37145,
    county_name: "Person",
    county_weights: {
      37145: 100,
    },
    county_names_all: "Person",
    county_fips_all: 37145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27574,
    lat: 36.43166,
    lng: -78.94147,
    city: "Roxboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14527,
    density: 29.3,
    county_fips: 37145,
    county_name: "Person",
    county_weights: {
      37077: 2.64,
      37145: 97.36,
    },
    county_names_all: "Person|Granville",
    county_fips_all: "37145|37077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27576,
    lat: 35.58297,
    lng: -78.25776,
    city: "Selma",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19253,
    density: 91.4,
    county_fips: 37101,
    county_name: "Johnston",
    county_weights: {
      37101: 100,
    },
    county_names_all: "Johnston",
    county_fips_all: 37101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27577,
    lat: 35.49166,
    lng: -78.3446,
    city: "Smithfield",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26352,
    density: 98.1,
    county_fips: 37101,
    county_name: "Johnston",
    county_weights: {
      37101: 100,
    },
    county_names_all: "Johnston",
    county_fips_all: 37101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27581,
    lat: 36.20155,
    lng: -78.73355,
    city: "Stem",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4408,
    density: 47,
    county_fips: 37077,
    county_name: "Granville",
    county_weights: {
      37077: 100,
    },
    county_names_all: "Granville",
    county_fips_all: 37077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27582,
    lat: 36.44736,
    lng: -78.5691,
    city: "Stovall",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 451,
    density: 171.7,
    county_fips: 37077,
    county_name: "Granville",
    county_weights: {
      37077: 100,
    },
    county_names_all: "Granville",
    county_fips_all: 37077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27583,
    lat: 36.29723,
    lng: -78.93153,
    city: "Timberlake",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6474,
    density: 50.8,
    county_fips: 37145,
    county_name: "Person",
    county_weights: {
      37063: 1.32,
      37135: 2.88,
      37145: 95.8,
    },
    county_names_all: "Person|Orange|Durham",
    county_fips_all: "37145|37135|37063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27584,
    lat: 36.4934,
    lng: -78.44601,
    city: "Townsville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37181,
    county_name: "Vance",
    county_weights: {
      37181: 100,
    },
    county_names_all: "Vance",
    county_fips_all: 37181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27587,
    lat: 35.98098,
    lng: -78.54963,
    city: "Wake Forest",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 73345,
    density: 269.4,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37069: 2.57,
      37077: 9.18,
      37183: 88.25,
    },
    county_names_all: "Wake|Granville|Franklin",
    county_fips_all: "37183|37077|37069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27589,
    lat: 36.33461,
    lng: -78.12819,
    city: "Warrenton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7332,
    density: 16.7,
    county_fips: 37185,
    county_name: "Warren",
    county_weights: {
      37069: 3.64,
      37185: 96.36,
    },
    county_names_all: "Warren|Franklin",
    county_fips_all: "37185|37069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27591,
    lat: 35.7859,
    lng: -78.38638,
    city: "Wendell",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21294,
    density: 123.4,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37101: 30.25,
      37183: 69.75,
    },
    county_names_all: "Wake|Johnston",
    county_fips_all: "37183|37101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27592,
    lat: 35.55922,
    lng: -78.67164,
    city: "Willow Spring",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18198,
    density: 179.1,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37085: 0.54,
      37101: 39.23,
      37183: 60.23,
    },
    county_names_all: "Wake|Johnston|Harnett",
    county_fips_all: "37183|37101|37085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27593,
    lat: 35.58579,
    lng: -78.36231,
    city: "Wilsons Mills",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37101,
    county_name: "Johnston",
    county_weights: {
      37101: 100,
    },
    county_names_all: "Johnston",
    county_fips_all: 37101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27594,
    lat: 36.47294,
    lng: -78.16622,
    city: "Wise",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37185,
    county_name: "Warren",
    county_weights: {
      37185: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 37185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27596,
    lat: 36.00906,
    lng: -78.44448,
    city: "Youngsville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19116,
    density: 139.7,
    county_fips: 37069,
    county_name: "Franklin",
    county_weights: {
      37069: 90.88,
      37077: 3.26,
      37183: 5.86,
    },
    county_names_all: "Franklin|Wake|Granville",
    county_fips_all: "37069|37183|37077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27597,
    lat: 35.84034,
    lng: -78.30303,
    city: "Zebulon",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26991,
    density: 88,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37069: 28.47,
      37101: 22.91,
      37127: 6.43,
      37183: 42.19,
    },
    county_names_all: "Wake|Franklin|Johnston|Nash",
    county_fips_all: "37183|37069|37101|37127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27599,
    lat: 35.90394,
    lng: -79.05234,
    city: "Chapel Hill",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37135,
    county_name: "Orange",
    county_weights: {
      37135: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 37135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27601,
    lat: 35.7737,
    lng: -78.63453,
    city: "Raleigh",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11111,
    density: 2359.1,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37183: 100,
    },
    county_names_all: "Wake",
    county_fips_all: 37183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27603,
    lat: 35.66408,
    lng: -78.66186,
    city: "Raleigh",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56826,
    density: 426.8,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37101: 4.61,
      37183: 95.39,
    },
    county_names_all: "Wake|Johnston",
    county_fips_all: "37183|37101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27604,
    lat: 35.82011,
    lng: -78.56369,
    city: "Raleigh",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48044,
    density: 969.8,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37183: 100,
    },
    county_names_all: "Wake",
    county_fips_all: 37183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27605,
    lat: 35.79046,
    lng: -78.65452,
    city: "Raleigh",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5908,
    density: 2228.2,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37183: 100,
    },
    county_names_all: "Wake",
    county_fips_all: 37183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27606,
    lat: 35.73991,
    lng: -78.71833,
    city: "Raleigh",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48726,
    density: 769,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37183: 100,
    },
    county_names_all: "Wake",
    county_fips_all: 37183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27607,
    lat: 35.82145,
    lng: -78.72697,
    city: "Raleigh",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29005,
    density: 644.6,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37183: 100,
    },
    county_names_all: "Wake",
    county_fips_all: 37183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27608,
    lat: 35.81004,
    lng: -78.64815,
    city: "Raleigh",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11749,
    density: 1314.8,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37183: 100,
    },
    county_names_all: "Wake",
    county_fips_all: 37183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27609,
    lat: 35.8437,
    lng: -78.63282,
    city: "Raleigh",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35025,
    density: 1236,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37183: 100,
    },
    county_names_all: "Wake",
    county_fips_all: 37183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27610,
    lat: 35.7435,
    lng: -78.54644,
    city: "Raleigh",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 80973,
    density: 692.4,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37101: 0.19,
      37183: 99.81,
    },
    county_names_all: "Wake|Johnston",
    county_fips_all: "37183|37101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27612,
    lat: 35.85034,
    lng: -78.70387,
    city: "Raleigh",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41346,
    density: 961.4,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37183: 100,
    },
    county_names_all: "Wake",
    county_fips_all: 37183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27613,
    lat: 35.92633,
    lng: -78.71183,
    city: "Raleigh",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42111,
    density: 637.6,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37063: 16.3,
      37183: 83.7,
    },
    county_names_all: "Wake|Durham",
    county_fips_all: "37183|37063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27614,
    lat: 35.94739,
    lng: -78.62059,
    city: "Raleigh",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32144,
    density: 447.5,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37183: 100,
    },
    county_names_all: "Wake",
    county_fips_all: 37183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27615,
    lat: 35.89772,
    lng: -78.636,
    city: "Raleigh",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46536,
    density: 950.8,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37183: 100,
    },
    county_names_all: "Wake",
    county_fips_all: 37183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27616,
    lat: 35.86735,
    lng: -78.53792,
    city: "Raleigh",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55997,
    density: 961.2,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37183: 100,
    },
    county_names_all: "Wake",
    county_fips_all: 37183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27617,
    lat: 35.90723,
    lng: -78.77221,
    city: "Raleigh",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19048,
    density: 889.1,
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37063: 2.45,
      37183: 97.55,
    },
    county_names_all: "Wake|Durham",
    county_fips_all: "37183|37063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27695,
    lat: 35.78558,
    lng: -78.679,
    city: "Raleigh",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37183: 100,
    },
    county_names_all: "Wake",
    county_fips_all: 37183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27697,
    lat: 35.7788,
    lng: -78.62297,
    city: "Raleigh",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37183,
    county_name: "Wake",
    county_weights: {
      37183: 100,
    },
    county_names_all: "Wake",
    county_fips_all: 37183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27701,
    lat: 35.99858,
    lng: -78.89872,
    city: "Durham",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23415,
    density: 1722.2,
    county_fips: 37063,
    county_name: "Durham",
    county_weights: {
      37063: 100,
    },
    county_names_all: "Durham",
    county_fips_all: 37063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27703,
    lat: 35.96299,
    lng: -78.80452,
    city: "Durham",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56071,
    density: 441.2,
    county_fips: 37063,
    county_name: "Durham",
    county_weights: {
      37063: 99.38,
      37183: 0.62,
    },
    county_names_all: "Durham|Wake",
    county_fips_all: "37063|37183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27704,
    lat: 36.04088,
    lng: -78.83007,
    city: "Durham",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40657,
    density: 378.9,
    county_fips: 37063,
    county_name: "Durham",
    county_weights: {
      37063: 100,
    },
    county_names_all: "Durham",
    county_fips_all: 37063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27705,
    lat: 36.0259,
    lng: -78.98046,
    city: "Durham",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50530,
    density: 463.8,
    county_fips: 37063,
    county_name: "Durham",
    county_weights: {
      37063: 53.04,
      37135: 46.96,
    },
    county_names_all: "Durham|Orange",
    county_fips_all: "37063|37135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27707,
    lat: 35.95463,
    lng: -78.95451,
    city: "Durham",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52008,
    density: 969.8,
    county_fips: 37063,
    county_name: "Durham",
    county_weights: {
      37063: 91.45,
      37135: 8.55,
    },
    county_names_all: "Durham|Orange",
    county_fips_all: "37063|37135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27708,
    lat: 36.00009,
    lng: -78.94305,
    city: "Durham",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37063,
    county_name: "Durham",
    county_weights: {
      37063: 100,
    },
    county_names_all: "Durham",
    county_fips_all: 37063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27709,
    lat: 35.91441,
    lng: -78.86666,
    city: "Durham",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37063,
    county_name: "Durham",
    county_weights: {
      37063: 100,
    },
    county_names_all: "Durham",
    county_fips_all: 37063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27712,
    lat: 36.09606,
    lng: -78.90481,
    city: "Durham",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22787,
    density: 264.8,
    county_fips: 37063,
    county_name: "Durham",
    county_weights: {
      37063: 98.31,
      37135: 1.69,
    },
    county_names_all: "Durham|Orange",
    county_fips_all: "37063|37135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27713,
    lat: 35.88401,
    lng: -78.936,
    city: "Durham",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55516,
    density: 606.3,
    county_fips: 37063,
    county_name: "Durham",
    county_weights: {
      37037: 33.42,
      37063: 66.07,
      37183: 0.51,
    },
    county_names_all: "Durham|Chatham|Wake",
    county_fips_all: "37063|37037|37183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27801,
    lat: 35.91209,
    lng: -77.73656,
    city: "Rocky Mount",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19893,
    density: 115,
    county_fips: 37065,
    county_name: "Edgecombe",
    county_weights: {
      37065: 100,
    },
    county_names_all: "Edgecombe",
    county_fips_all: 37065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27803,
    lat: 35.89627,
    lng: -77.85407,
    city: "Rocky Mount",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17548,
    density: 161.6,
    county_fips: 37127,
    county_name: "Nash",
    county_weights: {
      37065: 5.73,
      37127: 84.98,
      37195: 9.29,
    },
    county_names_all: "Nash|Wilson|Edgecombe",
    county_fips_all: "37127|37195|37065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27804,
    lat: 35.98958,
    lng: -77.84778,
    city: "Rocky Mount",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30484,
    density: 273.4,
    county_fips: 37127,
    county_name: "Nash",
    county_weights: {
      37127: 100,
    },
    county_names_all: "Nash",
    county_fips_all: 37127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27805,
    lat: 36.20863,
    lng: -77.08861,
    city: "Aulander",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3916,
    density: 13.9,
    county_fips: 37015,
    county_name: "Bertie",
    county_weights: {
      37015: 60.76,
      37091: 39.24,
    },
    county_names_all: "Bertie|Hertford",
    county_fips_all: "37015|37091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27806,
    lat: 35.29713,
    lng: -76.76264,
    city: "Aurora",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2764,
    density: 7.8,
    county_fips: 37013,
    county_name: "Beaufort",
    county_weights: {
      37013: 100,
    },
    county_names_all: "Beaufort",
    county_fips_all: 37013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27807,
    lat: 35.80915,
    lng: -78.0917,
    city: "Bailey",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6315,
    density: 50.6,
    county_fips: 37127,
    county_name: "Nash",
    county_weights: {
      37127: 92.99,
      37195: 7.01,
    },
    county_names_all: "Nash|Wilson",
    county_fips_all: "37127|37195",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27808,
    lat: 35.47228,
    lng: -76.76494,
    city: "Bath",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1955,
    density: 16.4,
    county_fips: 37013,
    county_name: "Beaufort",
    county_weights: {
      37013: 100,
    },
    county_names_all: "Beaufort",
    county_fips_all: 37013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27809,
    lat: 36.01932,
    lng: -77.74085,
    city: "Battleboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3988,
    density: 20.1,
    county_fips: 37065,
    county_name: "Edgecombe",
    county_weights: {
      37065: 62.78,
      37127: 37.22,
    },
    county_names_all: "Edgecombe|Nash",
    county_fips_all: "37065|37127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27810,
    lat: 35.58637,
    lng: -76.49706,
    city: "Belhaven",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3679,
    density: 7,
    county_fips: 37095,
    county_name: "Hyde",
    county_weights: {
      37013: 39.78,
      37095: 60.22,
    },
    county_names_all: "Hyde|Beaufort",
    county_fips_all: "37095|37013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27812,
    lat: 35.80506,
    lng: -77.37616,
    city: "Bethel",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2692,
    density: 17.7,
    county_fips: 37147,
    county_name: "Pitt",
    county_weights: {
      37065: 26.54,
      37117: 8.3,
      37147: 65.16,
    },
    county_names_all: "Pitt|Edgecombe|Martin",
    county_fips_all: "37147|37065|37117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27813,
    lat: 35.63083,
    lng: -77.93587,
    city: "Black Creek",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 873,
    density: 306.4,
    county_fips: 37195,
    county_name: "Wilson",
    county_weights: {
      37195: 100,
    },
    county_names_all: "Wilson",
    county_fips_all: 37195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27814,
    lat: 35.37987,
    lng: -76.93513,
    city: "Blounts Creek",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1564,
    density: 7.9,
    county_fips: 37013,
    county_name: "Beaufort",
    county_weights: {
      37013: 100,
    },
    county_names_all: "Beaufort",
    county_fips_all: 37013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27815,
    lat: 35.92473,
    lng: -77.69304,
    city: "Rocky Mount",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37065,
    county_name: "Edgecombe",
    county_weights: {
      37065: 100,
    },
    county_names_all: "Edgecombe",
    county_fips_all: 37065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27816,
    lat: 36.10732,
    lng: -78.07245,
    city: "Castalia",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2994,
    density: 17.8,
    county_fips: 37069,
    county_name: "Franklin",
    county_weights: {
      37069: 51.81,
      37127: 48.19,
    },
    county_names_all: "Franklin|Nash",
    county_fips_all: "37069|37127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27817,
    lat: 35.4506,
    lng: -77.0825,
    city: "Chocowinity",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7781,
    density: 29.8,
    county_fips: 37013,
    county_name: "Beaufort",
    county_weights: {
      37013: 100,
    },
    county_names_all: "Beaufort",
    county_fips_all: 37013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27818,
    lat: 36.50275,
    lng: -77.01394,
    city: "Como",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1426,
    density: 9,
    county_fips: 37091,
    county_name: "Hertford",
    county_weights: {
      37091: 100,
    },
    county_names_all: "Hertford",
    county_fips_all: 37091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27819,
    lat: 35.81412,
    lng: -77.45731,
    city: "Conetoe",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 599,
    density: 166.3,
    county_fips: 37065,
    county_name: "Edgecombe",
    county_weights: {
      37065: 100,
    },
    county_names_all: "Edgecombe",
    county_fips_all: 37065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27820,
    lat: 36.4154,
    lng: -77.24431,
    city: "Conway",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2166,
    density: 14.6,
    county_fips: 37131,
    county_name: "Northampton",
    county_weights: {
      37131: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 37131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27821,
    lat: 35.3237,
    lng: -76.87392,
    city: "Edward",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 121,
    density: 7.3,
    county_fips: 37013,
    county_name: "Beaufort",
    county_weights: {
      37013: 100,
    },
    county_names_all: "Beaufort",
    county_fips_all: 37013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27822,
    lat: 35.80402,
    lng: -77.83868,
    city: "Elm City",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8797,
    density: 38.8,
    county_fips: 37195,
    county_name: "Wilson",
    county_weights: {
      37065: 8.79,
      37127: 16.57,
      37195: 74.64,
    },
    county_names_all: "Wilson|Nash|Edgecombe",
    county_fips_all: "37195|37127|37065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27823,
    lat: 36.20616,
    lng: -77.71685,
    city: "Enfield",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7573,
    density: 15.9,
    county_fips: 37083,
    county_name: "Halifax",
    county_weights: {
      37083: 100,
    },
    county_names_all: "Halifax",
    county_fips_all: 37083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27824,
    lat: 35.55688,
    lng: -76.02105,
    city: "Engelhard",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1458,
    density: 3.5,
    county_fips: 37095,
    county_name: "Hyde",
    county_weights: {
      37095: 100,
    },
    county_names_all: "Hyde",
    county_fips_all: 37095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27825,
    lat: 35.83527,
    lng: -77.17152,
    city: "Everetts",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 87,
    density: 90.3,
    county_fips: 37117,
    county_name: "Martin",
    county_weights: {
      37117: 100,
    },
    county_names_all: "Martin",
    county_fips_all: 37117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27826,
    lat: 35.58988,
    lng: -76.2521,
    city: "Fairfield",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 759,
    density: 1.8,
    county_fips: 37095,
    county_name: "Hyde",
    county_weights: {
      37095: 73.93,
      37177: 26.07,
    },
    county_names_all: "Hyde|Tyrrell",
    county_fips_all: "37095|37177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27827,
    lat: 35.69823,
    lng: -77.51224,
    city: "Falkland",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 182,
    density: 367.1,
    county_fips: 37147,
    county_name: "Pitt",
    county_weights: {
      37147: 100,
    },
    county_names_all: "Pitt",
    county_fips_all: 37147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27828,
    lat: 35.58509,
    lng: -77.58519,
    city: "Farmville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9848,
    density: 47.9,
    county_fips: 37147,
    county_name: "Pitt",
    county_weights: {
      37079: 31.42,
      37147: 68.58,
    },
    county_names_all: "Pitt|Greene",
    county_fips_all: "37147|37079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27829,
    lat: 35.69272,
    lng: -77.61215,
    city: "Fountain",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1331,
    density: 11.1,
    county_fips: 37147,
    county_name: "Pitt",
    county_weights: {
      37065: 20.6,
      37147: 63.4,
      37195: 16,
    },
    county_names_all: "Pitt|Edgecombe|Wilson",
    county_fips_all: "37147|37065|37195",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27830,
    lat: 35.55557,
    lng: -77.95224,
    city: "Fremont",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4099,
    density: 27.1,
    county_fips: 37191,
    county_name: "Wayne",
    county_weights: {
      37191: 89.43,
      37195: 10.57,
    },
    county_names_all: "Wayne|Wilson",
    county_fips_all: "37191|37195",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27831,
    lat: 36.45614,
    lng: -77.56574,
    city: "Garysburg",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2705,
    density: 16.8,
    county_fips: 37131,
    county_name: "Northampton",
    county_weights: {
      37131: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 37131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27832,
    lat: 36.51262,
    lng: -77.72178,
    city: "Gaston",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2786,
    density: 32.2,
    county_fips: 37131,
    county_name: "Northampton",
    county_weights: {
      37131: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 37131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27834,
    lat: 35.6571,
    lng: -77.37981,
    city: "Greenville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59049,
    density: 130.8,
    county_fips: 37147,
    county_name: "Pitt",
    county_weights: {
      37013: 2.67,
      37065: 1.06,
      37147: 96.27,
    },
    county_names_all: "Pitt|Beaufort|Edgecombe",
    county_fips_all: "37147|37013|37065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27837,
    lat: 35.51606,
    lng: -77.20892,
    city: "Grimesland",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7595,
    density: 49.8,
    county_fips: 37147,
    county_name: "Pitt",
    county_weights: {
      37013: 3.08,
      37147: 96.92,
    },
    county_names_all: "Pitt|Beaufort",
    county_fips_all: "37147|37013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27839,
    lat: 36.28818,
    lng: -77.55009,
    city: "Halifax",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3569,
    density: 9.9,
    county_fips: 37083,
    county_name: "Halifax",
    county_weights: {
      37083: 100,
    },
    county_names_all: "Halifax",
    county_fips_all: 37083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27840,
    lat: 35.9343,
    lng: -77.23186,
    city: "Hamilton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 275,
    density: 19.1,
    county_fips: 37117,
    county_name: "Martin",
    county_weights: {
      37117: 100,
    },
    county_names_all: "Martin",
    county_fips_all: 37117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27841,
    lat: 35.90859,
    lng: -77.27632,
    city: "Hassell",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34,
    density: 49.3,
    county_fips: 37117,
    county_name: "Martin",
    county_weights: {
      37117: 100,
    },
    county_names_all: "Martin",
    county_fips_all: 37117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27842,
    lat: 36.52458,
    lng: -77.85593,
    city: "Henrico",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1868,
    density: 68.5,
    county_fips: 37131,
    county_name: "Northampton",
    county_weights: {
      37131: 92.12,
      37185: 7.88,
    },
    county_names_all: "Northampton|Warren",
    county_fips_all: "37131|37185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27843,
    lat: 35.99332,
    lng: -77.39509,
    city: "Hobgood",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1018,
    density: 6.5,
    county_fips: 37065,
    county_name: "Edgecombe",
    county_weights: {
      37065: 34.53,
      37083: 32.4,
      37117: 33.07,
    },
    county_names_all: "Edgecombe|Martin|Halifax",
    county_fips_all: "37065|37117|37083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27844,
    lat: 36.24555,
    lng: -77.94945,
    city: "Hollister",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3094,
    density: 22.1,
    county_fips: 37083,
    county_name: "Halifax",
    county_weights: {
      37069: 3.67,
      37083: 71.23,
      37127: 4.51,
      37185: 20.59,
    },
    county_names_all: "Halifax|Warren|Nash|Franklin",
    county_fips_all: "37083|37185|37127|37069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27845,
    lat: 36.37403,
    lng: -77.43331,
    city: "Jackson",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2947,
    density: 11.6,
    county_fips: 37131,
    county_name: "Northampton",
    county_weights: {
      37131: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 37131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27846,
    lat: 35.76519,
    lng: -76.89191,
    city: "Jamesville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2698,
    density: 11.1,
    county_fips: 37117,
    county_name: "Martin",
    county_weights: {
      37117: 100,
    },
    county_names_all: "Martin",
    county_fips_all: 37117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27847,
    lat: 36.18597,
    lng: -77.20738,
    city: "Kelford",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 561,
    density: 4.8,
    county_fips: 37015,
    county_name: "Bertie",
    county_weights: {
      37015: 100,
    },
    county_names_all: "Bertie",
    county_fips_all: 37015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27849,
    lat: 36.06796,
    lng: -77.20675,
    city: "Lewiston Woodville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1533,
    density: 8,
    county_fips: 37015,
    county_name: "Bertie",
    county_weights: {
      37015: 100,
    },
    county_names_all: "Bertie",
    county_fips_all: 37015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27850,
    lat: 36.40202,
    lng: -77.88141,
    city: "Littleton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7847,
    density: 15.9,
    county_fips: 37083,
    county_name: "Halifax",
    county_weights: {
      37083: 61.86,
      37185: 38.14,
    },
    county_names_all: "Halifax|Warren",
    county_fips_all: "37083|37185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27851,
    lat: 35.63965,
    lng: -78.02739,
    city: "Lucama",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4977,
    density: 43.4,
    county_fips: 37195,
    county_name: "Wilson",
    county_weights: {
      37191: 0.89,
      37195: 99.11,
    },
    county_names_all: "Wilson|Wayne",
    county_fips_all: "37195|37191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27852,
    lat: 35.75288,
    lng: -77.63581,
    city: "Macclesfield",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2820,
    density: 22.6,
    county_fips: 37065,
    county_name: "Edgecombe",
    county_weights: {
      37065: 81.43,
      37147: 9.89,
      37195: 8.68,
    },
    county_names_all: "Edgecombe|Pitt|Wilson",
    county_fips_all: "37065|37147|37195",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27853,
    lat: 36.51716,
    lng: -77.30488,
    city: "Margarettsville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 509,
    density: 5.3,
    county_fips: 37131,
    county_name: "Northampton",
    county_weights: {
      37131: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 37131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27855,
    lat: 36.42171,
    lng: -77.08432,
    city: "Murfreesboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6360,
    density: 44.7,
    county_fips: 37091,
    county_name: "Hertford",
    county_weights: {
      37091: 83.52,
      37131: 16.48,
    },
    county_names_all: "Hertford|Northampton",
    county_fips_all: "37091|37131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27856,
    lat: 36.00998,
    lng: -77.98151,
    city: "Nashville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16633,
    density: 50.2,
    county_fips: 37127,
    county_name: "Nash",
    county_weights: {
      37127: 100,
    },
    county_names_all: "Nash",
    county_fips_all: 37127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27857,
    lat: 35.96968,
    lng: -77.27198,
    city: "Oak City",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1067,
    density: 5.6,
    county_fips: 37117,
    county_name: "Martin",
    county_weights: {
      37117: 100,
    },
    county_names_all: "Martin",
    county_fips_all: 37117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27858,
    lat: 35.53229,
    lng: -77.29709,
    city: "Greenville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58502,
    density: 367.9,
    county_fips: 37147,
    county_name: "Pitt",
    county_weights: {
      37147: 100,
    },
    county_names_all: "Pitt",
    county_fips_all: 37147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27860,
    lat: 35.67693,
    lng: -76.65001,
    city: "Pantego",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2373,
    density: 6.2,
    county_fips: 37013,
    county_name: "Beaufort",
    county_weights: {
      37013: 53.75,
      37095: 14.71,
      37187: 31.54,
    },
    county_names_all: "Beaufort|Washington|Hyde",
    county_fips_all: "37013|37187|37095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27861,
    lat: 35.81716,
    lng: -77.31899,
    city: "Parmele",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 94,
    density: 78.6,
    county_fips: 37117,
    county_name: "Martin",
    county_weights: {
      37117: 100,
    },
    county_names_all: "Martin",
    county_fips_all: 37117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27862,
    lat: 36.49264,
    lng: -77.18906,
    city: "Pendleton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 866,
    density: 7.4,
    county_fips: 37131,
    county_name: "Northampton",
    county_weights: {
      37131: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 37131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27863,
    lat: 35.48739,
    lng: -77.96993,
    city: "Pikeville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13923,
    density: 81.3,
    county_fips: 37191,
    county_name: "Wayne",
    county_weights: {
      37079: 2.82,
      37101: 1.15,
      37191: 96.03,
    },
    county_names_all: "Wayne|Greene|Johnston",
    county_fips_all: "37191|37079|37101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27864,
    lat: 35.8075,
    lng: -77.64789,
    city: "Pinetops",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4986,
    density: 47.3,
    county_fips: 37065,
    county_name: "Edgecombe",
    county_weights: {
      37065: 100,
    },
    county_names_all: "Edgecombe",
    county_fips_all: 37065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27865,
    lat: 35.60588,
    lng: -76.83244,
    city: "Pinetown",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2224,
    density: 6.8,
    county_fips: 37013,
    county_name: "Beaufort",
    county_weights: {
      37013: 100,
    },
    county_names_all: "Beaufort",
    county_fips_all: 37013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27866,
    lat: 36.51832,
    lng: -77.51577,
    city: "Pleasant Hill",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 908,
    density: 13.4,
    county_fips: 37131,
    county_name: "Northampton",
    county_weights: {
      37131: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 37131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27869,
    lat: 36.26631,
    lng: -77.31665,
    city: "Rich Square",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1550,
    density: 7.3,
    county_fips: 37131,
    county_name: "Northampton",
    county_weights: {
      37015: 0.3,
      37131: 99.7,
    },
    county_names_all: "Northampton|Bertie",
    county_fips_all: "37131|37015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27870,
    lat: 36.43053,
    lng: -77.71828,
    city: "Roanoke Rapids",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24571,
    density: 145.6,
    county_fips: 37083,
    county_name: "Halifax",
    county_weights: {
      37083: 100,
    },
    county_names_all: "Halifax",
    county_fips_all: 37083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27871,
    lat: 35.81355,
    lng: -77.26306,
    city: "Robersonville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4452,
    density: 17.9,
    county_fips: 37117,
    county_name: "Martin",
    county_weights: {
      37013: 0.64,
      37117: 72.5,
      37147: 26.86,
    },
    county_names_all: "Martin|Pitt|Beaufort",
    county_fips_all: "37117|37147|37013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27872,
    lat: 36.20096,
    lng: -77.24601,
    city: "Roxobel",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 757,
    density: 144,
    county_fips: 37015,
    county_name: "Bertie",
    county_weights: {
      37015: 100,
    },
    county_names_all: "Bertie",
    county_fips_all: 37015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27873,
    lat: 35.65331,
    lng: -77.77606,
    city: "Saratoga",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 370,
    density: 254.6,
    county_fips: 37195,
    county_name: "Wilson",
    county_weights: {
      37195: 100,
    },
    county_names_all: "Wilson",
    county_fips_all: 37195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27874,
    lat: 36.12874,
    lng: -77.41037,
    city: "Scotland Neck",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3984,
    density: 11.4,
    county_fips: 37083,
    county_name: "Halifax",
    county_weights: {
      37083: 100,
    },
    county_names_all: "Halifax",
    county_fips_all: 37083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27875,
    lat: 35.45623,
    lng: -76.48532,
    city: "Scranton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 344,
    density: 2.4,
    county_fips: 37095,
    county_name: "Hyde",
    county_weights: {
      37095: 100,
    },
    county_names_all: "Hyde",
    county_fips_all: 37095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27876,
    lat: 36.48015,
    lng: -77.40065,
    city: "Seaboard",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1355,
    density: 12.5,
    county_fips: 37131,
    county_name: "Northampton",
    county_weights: {
      37131: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 37131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27877,
    lat: 36.51883,
    lng: -77.19219,
    city: "Severn",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37131,
    county_name: "Northampton",
    county_weights: {
      37131: 100,
    },
    county_names_all: "Northampton",
    county_fips_all: 37131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27878,
    lat: 35.86606,
    lng: -77.83062,
    city: "Sharpsburg",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1458,
    density: 715.6,
    county_fips: 37127,
    county_name: "Nash",
    county_weights: {
      37065: 12.96,
      37127: 59.17,
      37195: 27.87,
    },
    county_names_all: "Nash|Wilson|Edgecombe",
    county_fips_all: "37127|37195|37065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27879,
    lat: 35.57456,
    lng: -77.27968,
    city: "Simpson",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 347,
    density: 461.3,
    county_fips: 37147,
    county_name: "Pitt",
    county_weights: {
      37147: 100,
    },
    county_names_all: "Pitt",
    county_fips_all: 37147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27880,
    lat: 35.73656,
    lng: -78.08912,
    city: "Sims",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3954,
    density: 59.8,
    county_fips: 37195,
    county_name: "Wilson",
    county_weights: {
      37127: 3.93,
      37195: 96.07,
    },
    county_names_all: "Wilson|Nash",
    county_fips_all: "37195|37127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27881,
    lat: 35.9702,
    lng: -77.44228,
    city: "Speed",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55,
    density: 242.2,
    county_fips: 37065,
    county_name: "Edgecombe",
    county_weights: {
      37065: 100,
    },
    county_names_all: "Edgecombe",
    county_fips_all: 37065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27882,
    lat: 35.94222,
    lng: -78.11825,
    city: "Spring Hope",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7819,
    density: 29.1,
    county_fips: 37127,
    county_name: "Nash",
    county_weights: {
      37069: 21.91,
      37127: 78.09,
    },
    county_names_all: "Nash|Franklin",
    county_fips_all: "37127|37069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27883,
    lat: 35.59141,
    lng: -77.80095,
    city: "Stantonsburg",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3184,
    density: 15.6,
    county_fips: 37195,
    county_name: "Wilson",
    county_weights: {
      37079: 36.65,
      37191: 15.54,
      37195: 47.81,
    },
    county_names_all: "Wilson|Greene|Wayne",
    county_fips_all: "37195|37079|37191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27884,
    lat: 35.70771,
    lng: -77.27176,
    city: "Stokes",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1409,
    density: 15.2,
    county_fips: 37147,
    county_name: "Pitt",
    county_weights: {
      37147: 100,
    },
    county_names_all: "Pitt",
    county_fips_all: 37147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27885,
    lat: 35.44429,
    lng: -76.23125,
    city: "Swanquarter",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1164,
    density: 3.6,
    county_fips: 37095,
    county_name: "Hyde",
    county_weights: {
      37095: 100,
    },
    county_names_all: "Hyde",
    county_fips_all: 37095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27886,
    lat: 35.90369,
    lng: -77.52248,
    city: "Tarboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19981,
    density: 40.3,
    county_fips: 37065,
    county_name: "Edgecombe",
    county_weights: {
      37065: 96.99,
      37147: 3.01,
    },
    county_names_all: "Edgecombe|Pitt",
    county_fips_all: "37065|37147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27888,
    lat: 35.59589,
    lng: -77.70448,
    city: "Walstonburg",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2062,
    density: 14.1,
    county_fips: 37079,
    county_name: "Greene",
    county_weights: {
      37079: 72.92,
      37147: 10.07,
      37195: 17.01,
    },
    county_names_all: "Greene|Wilson|Pitt",
    county_fips_all: "37079|37195|37147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27889,
    lat: 35.58909,
    lng: -77.02386,
    city: "Washington",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25991,
    density: 57,
    county_fips: 37013,
    county_name: "Beaufort",
    county_weights: {
      37013: 90.25,
      37117: 2.01,
      37147: 7.74,
    },
    county_names_all: "Beaufort|Pitt|Martin",
    county_fips_all: "37013|37147|37117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27890,
    lat: 36.41505,
    lng: -77.59194,
    city: "Weldon",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2686,
    density: 112.6,
    county_fips: 37083,
    county_name: "Halifax",
    county_weights: {
      37083: 100,
    },
    county_names_all: "Halifax",
    county_fips_all: 37083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27891,
    lat: 36.09968,
    lng: -77.74103,
    city: "Whitakers",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5284,
    density: 14.5,
    county_fips: 37127,
    county_name: "Nash",
    county_weights: {
      37065: 45.22,
      37083: 6.96,
      37127: 47.82,
    },
    county_names_all: "Nash|Edgecombe|Halifax",
    county_fips_all: "37127|37065|37083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27892,
    lat: 35.81844,
    lng: -77.06434,
    city: "Williamston",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14068,
    density: 29.4,
    county_fips: 37117,
    county_name: "Martin",
    county_weights: {
      37013: 0.43,
      37117: 99.57,
    },
    county_names_all: "Martin|Beaufort",
    county_fips_all: "37117|37013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27893,
    lat: 35.69351,
    lng: -77.90458,
    city: "Wilson",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40602,
    density: 143.8,
    county_fips: 37195,
    county_name: "Wilson",
    county_weights: {
      37195: 100,
    },
    county_names_all: "Wilson",
    county_fips_all: 37195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27896,
    lat: 35.79303,
    lng: -77.97399,
    city: "Wilson",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19659,
    density: 215.9,
    county_fips: 37195,
    county_name: "Wilson",
    county_weights: {
      37127: 32.28,
      37195: 67.72,
    },
    county_names_all: "Wilson|Nash",
    county_fips_all: "37195|37127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27897,
    lat: 36.3246,
    lng: -77.20969,
    city: "Woodland",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1949,
    density: 17,
    county_fips: 37131,
    county_name: "Northampton",
    county_weights: {
      37091: 20.37,
      37131: 79.63,
    },
    county_names_all: "Northampton|Hertford",
    county_fips_all: "37131|37091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27909,
    lat: 36.29548,
    lng: -76.28394,
    city: "Elizabeth City",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39804,
    density: 67.7,
    county_fips: 37139,
    county_name: "Pasquotank",
    county_weights: {
      37139: 100,
    },
    county_names_all: "Pasquotank",
    county_fips_all: 37139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27910,
    lat: 36.27996,
    lng: -76.99281,
    city: "Ahoskie",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11882,
    density: 31.4,
    county_fips: 37091,
    county_name: "Hertford",
    county_weights: {
      37015: 30.3,
      37091: 69.7,
    },
    county_names_all: "Hertford|Bertie",
    county_fips_all: "37091|37015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27915,
    lat: 35.40794,
    lng: -75.49465,
    city: "Avon",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 474,
    density: 22.4,
    county_fips: 37055,
    county_name: "Dare",
    county_weights: {
      37055: 100,
    },
    county_names_all: "Dare",
    county_fips_all: 37055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27916,
    lat: 36.32933,
    lng: -75.91996,
    city: "Aydlett",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 934,
    density: 42.4,
    county_fips: 37053,
    county_name: "Currituck",
    county_weights: {
      37053: 100,
    },
    county_names_all: "Currituck",
    county_fips_all: 37053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27917,
    lat: 36.36071,
    lng: -75.99071,
    city: "Barco",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 714,
    density: 14,
    county_fips: 37053,
    county_name: "Currituck",
    county_weights: {
      37053: 100,
    },
    county_names_all: "Currituck",
    county_fips_all: 37053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27919,
    lat: 36.31178,
    lng: -76.50293,
    city: "Belvidere",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1324,
    density: 8.6,
    county_fips: 37143,
    county_name: "Perquimans",
    county_weights: {
      37041: 9.62,
      37143: 90.38,
    },
    county_names_all: "Perquimans|Chowan",
    county_fips_all: "37143|37041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27920,
    lat: 35.25109,
    lng: -75.54755,
    city: "Buxton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1558,
    density: 76.7,
    county_fips: 37055,
    county_name: "Dare",
    county_weights: {
      37055: 100,
    },
    county_names_all: "Dare",
    county_fips_all: 37055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27921,
    lat: 36.3446,
    lng: -76.15512,
    city: "Camden",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4307,
    density: 26,
    county_fips: 37029,
    county_name: "Camden",
    county_weights: {
      37029: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 37029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27922,
    lat: 36.32118,
    lng: -76.84837,
    city: "Cofield",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 530,
    density: 4.8,
    county_fips: 37091,
    county_name: "Hertford",
    county_weights: {
      37091: 100,
    },
    county_names_all: "Hertford",
    county_fips_all: 37091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27923,
    lat: 36.38852,
    lng: -75.93562,
    city: "Coinjock",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 590,
    density: 44.1,
    county_fips: 37053,
    county_name: "Currituck",
    county_weights: {
      37053: 100,
    },
    county_names_all: "Currituck",
    county_fips_all: 37053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27924,
    lat: 36.17835,
    lng: -76.83822,
    city: "Colerain",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3465,
    density: 13.7,
    county_fips: 37015,
    county_name: "Bertie",
    county_weights: {
      37015: 91.63,
      37091: 8.37,
    },
    county_names_all: "Bertie|Hertford",
    county_fips_all: "37015|37091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27925,
    lat: 35.84336,
    lng: -76.18349,
    city: "Columbia",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3902,
    density: 5,
    county_fips: 37177,
    county_name: "Tyrrell",
    county_weights: {
      37177: 100,
    },
    county_names_all: "Tyrrell",
    county_fips_all: 37177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27926,
    lat: 36.51687,
    lng: -76.60288,
    city: "Corapeake",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1899,
    density: 20.3,
    county_fips: 37073,
    county_name: "Gates",
    county_weights: {
      37073: 100,
    },
    county_names_all: "Gates",
    county_fips_all: 37073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27927,
    lat: 36.4131,
    lng: -75.8497,
    city: "Corolla",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1132,
    density: 16.4,
    county_fips: 37053,
    county_name: "Currituck",
    county_weights: {
      37053: 100,
    },
    county_names_all: "Currituck",
    county_fips_all: 37053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27928,
    lat: 35.80857,
    lng: -76.43579,
    city: "Creswell",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1844,
    density: 4.7,
    county_fips: 37187,
    county_name: "Washington",
    county_weights: {
      37177: 27.02,
      37187: 72.98,
    },
    county_names_all: "Washington|Tyrrell",
    county_fips_all: "37187|37177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27929,
    lat: 36.42407,
    lng: -76.02534,
    city: "Currituck",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1825,
    density: 45.5,
    county_fips: 37053,
    county_name: "Currituck",
    county_weights: {
      37053: 100,
    },
    county_names_all: "Currituck",
    county_fips_all: 37053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27932,
    lat: 36.10223,
    lng: -76.59414,
    city: "Edenton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11728,
    density: 34.7,
    county_fips: 37041,
    county_name: "Chowan",
    county_weights: {
      37041: 90.92,
      37143: 9.08,
    },
    county_names_all: "Chowan|Perquimans",
    county_fips_all: "37041|37143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27935,
    lat: 36.43026,
    lng: -76.85962,
    city: "Eure",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1853,
    density: 11.7,
    county_fips: 37073,
    county_name: "Gates",
    county_weights: {
      37073: 100,
    },
    county_names_all: "Gates",
    county_fips_all: 37073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27936,
    lat: 35.24224,
    lng: -75.60547,
    city: "Frisco",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 795,
    density: 58.9,
    county_fips: 37055,
    county_name: "Dare",
    county_weights: {
      37055: 100,
    },
    county_names_all: "Dare",
    county_fips_all: 37055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27937,
    lat: 36.50453,
    lng: -76.77726,
    city: "Gates",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4205,
    density: 20.1,
    county_fips: 37073,
    county_name: "Gates",
    county_weights: {
      37073: 100,
    },
    county_names_all: "Gates",
    county_fips_all: 37073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27938,
    lat: 36.38422,
    lng: -76.71628,
    city: "Gatesville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1469,
    density: 11.1,
    county_fips: 37073,
    county_name: "Gates",
    county_weights: {
      37073: 100,
    },
    county_names_all: "Gates",
    county_fips_all: 37073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27939,
    lat: 36.23528,
    lng: -75.87689,
    city: "Grandy",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2798,
    density: 141.4,
    county_fips: 37053,
    county_name: "Currituck",
    county_weights: {
      37053: 100,
    },
    county_names_all: "Currituck",
    county_fips_all: 37053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27941,
    lat: 36.09147,
    lng: -75.81678,
    city: "Harbinger",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 215,
    density: 32.7,
    county_fips: 37053,
    county_name: "Currituck",
    county_weights: {
      37053: 100,
    },
    county_names_all: "Currituck",
    county_fips_all: 37053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27942,
    lat: 36.28785,
    lng: -76.7597,
    city: "Harrellsville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 505,
    density: 7,
    county_fips: 37091,
    county_name: "Hertford",
    county_weights: {
      37091: 100,
    },
    county_names_all: "Hertford",
    county_fips_all: 37091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27943,
    lat: 35.21432,
    lng: -75.69363,
    city: "Hatteras",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 373,
    density: 53.8,
    county_fips: 37055,
    county_name: "Dare",
    county_weights: {
      37055: 100,
    },
    county_names_all: "Dare",
    county_fips_all: 37055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27944,
    lat: 36.17908,
    lng: -76.41446,
    city: "Hertford",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11736,
    density: 25.9,
    county_fips: 37143,
    county_name: "Perquimans",
    county_weights: {
      37143: 100,
    },
    county_names_all: "Perquimans",
    county_fips_all: 37143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27946,
    lat: 36.35901,
    lng: -76.59648,
    city: "Hobbsville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1040,
    density: 9.2,
    county_fips: 37073,
    county_name: "Gates",
    county_weights: {
      37041: 12.81,
      37073: 87.19,
    },
    county_names_all: "Gates|Chowan",
    county_fips_all: "37073|37041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27947,
    lat: 36.20278,
    lng: -75.86922,
    city: "Jarvisburg",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1350,
    density: 50.5,
    county_fips: 37053,
    county_name: "Currituck",
    county_weights: {
      37053: 100,
    },
    county_names_all: "Currituck",
    county_fips_all: 37053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27948,
    lat: 36.01761,
    lng: -75.68663,
    city: "Kill Devil Hills",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12044,
    density: 502.4,
    county_fips: 37055,
    county_name: "Dare",
    county_weights: {
      37055: 100,
    },
    county_names_all: "Dare",
    county_fips_all: 37055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27949,
    lat: 36.10814,
    lng: -75.73112,
    city: "Kitty Hawk",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7596,
    density: 193.3,
    county_fips: 37055,
    county_name: "Dare",
    county_weights: {
      37055: 100,
    },
    county_names_all: "Dare",
    county_fips_all: 37055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27950,
    lat: 36.52599,
    lng: -76.00081,
    city: "Knotts Island",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1946,
    density: 25.3,
    county_fips: 37053,
    county_name: "Currituck",
    county_weights: {
      37053: 100,
    },
    county_names_all: "Currituck",
    county_fips_all: 37053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27953,
    lat: 35.79298,
    lng: -75.8685,
    city: "Manns Harbor",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 801,
    density: 1.2,
    county_fips: 37055,
    county_name: "Dare",
    county_weights: {
      37055: 100,
    },
    county_names_all: "Dare",
    county_fips_all: 37055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27954,
    lat: 35.91056,
    lng: -75.68202,
    city: "Manteo",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7397,
    density: 322.6,
    county_fips: 37055,
    county_name: "Dare",
    county_weights: {
      37055: 100,
    },
    county_names_all: "Dare",
    county_fips_all: 37055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27956,
    lat: 36.39999,
    lng: -76.00115,
    city: "Maple",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 387,
    density: 54.3,
    county_fips: 37053,
    county_name: "Currituck",
    county_weights: {
      37053: 100,
    },
    county_names_all: "Currituck",
    county_fips_all: 37053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27957,
    lat: 36.05577,
    lng: -76.76293,
    city: "Merry Hill",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1153,
    density: 8.3,
    county_fips: 37015,
    county_name: "Bertie",
    county_weights: {
      37015: 100,
    },
    county_names_all: "Bertie",
    county_fips_all: 37015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27958,
    lat: 36.48971,
    lng: -76.15378,
    city: "Moyock",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12364,
    density: 59.8,
    county_fips: 37053,
    county_name: "Currituck",
    county_weights: {
      37053: 100,
    },
    county_names_all: "Currituck",
    county_fips_all: 37053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27959,
    lat: 35.88566,
    lng: -75.59641,
    city: "Nags Head",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2971,
    density: 78.1,
    county_fips: 37055,
    county_name: "Dare",
    county_weights: {
      37055: 100,
    },
    county_names_all: "Dare",
    county_fips_all: 37055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27960,
    lat: 35.12593,
    lng: -75.92165,
    city: "Ocracoke",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 973,
    density: 43.2,
    county_fips: 37095,
    county_name: "Hyde",
    county_weights: {
      37095: 100,
    },
    county_names_all: "Hyde",
    county_fips_all: 37095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27962,
    lat: 35.78437,
    lng: -76.75026,
    city: "Plymouth",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6813,
    density: 30.9,
    county_fips: 37187,
    county_name: "Washington",
    county_weights: {
      37013: 6.88,
      37187: 93.12,
    },
    county_names_all: "Washington|Beaufort",
    county_fips_all: "37187|37013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27964,
    lat: 36.10074,
    lng: -75.80438,
    city: "Point Harbor",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 773,
    density: 182.6,
    county_fips: 37053,
    county_name: "Currituck",
    county_weights: {
      37053: 100,
    },
    county_names_all: "Currituck",
    county_fips_all: 37053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27965,
    lat: 36.28404,
    lng: -75.92681,
    city: "Poplar Branch",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 318,
    density: 6.8,
    county_fips: 37053,
    county_name: "Currituck",
    county_weights: {
      37053: 100,
    },
    county_names_all: "Currituck",
    county_fips_all: 37053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27966,
    lat: 36.13325,
    lng: -75.83833,
    city: "Powells Point",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 891,
    density: 32.2,
    county_fips: 37053,
    county_name: "Currituck",
    county_weights: {
      37053: 100,
    },
    county_names_all: "Currituck",
    county_fips_all: 37053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27967,
    lat: 36.22232,
    lng: -76.90838,
    city: "Powellsville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 98,
    density: 6.6,
    county_fips: 37015,
    county_name: "Bertie",
    county_weights: {
      37015: 100,
    },
    county_names_all: "Bertie",
    county_fips_all: 37015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27968,
    lat: 35.68549,
    lng: -75.49195,
    city: "Rodanthe",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 178,
    density: 9.1,
    county_fips: 37055,
    county_name: "Dare",
    county_weights: {
      37055: 100,
    },
    county_names_all: "Dare",
    county_fips_all: 37055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27969,
    lat: 36.4633,
    lng: -76.80259,
    city: "Roduco",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37073,
    county_name: "Gates",
    county_weights: {
      37073: 100,
    },
    county_names_all: "Gates",
    county_fips_all: 37073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27970,
    lat: 35.87596,
    lng: -76.57945,
    city: "Roper",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3070,
    density: 9.9,
    county_fips: 37187,
    county_name: "Washington",
    county_weights: {
      37187: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 37187,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27972,
    lat: 35.55427,
    lng: -75.46986,
    city: "Salvo",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 94,
    density: 36.9,
    county_fips: 37055,
    county_name: "Dare",
    county_weights: {
      37055: 100,
    },
    county_names_all: "Dare",
    county_fips_all: 37055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27973,
    lat: 36.36448,
    lng: -76.07058,
    city: "Shawboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1178,
    density: 12.3,
    county_fips: 37053,
    county_name: "Currituck",
    county_weights: {
      37029: 37.47,
      37053: 62.53,
    },
    county_names_all: "Currituck|Camden",
    county_fips_all: "37053|37029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27974,
    lat: 36.23941,
    lng: -76.00264,
    city: "Shiloh",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1399,
    density: 11.9,
    county_fips: 37029,
    county_name: "Camden",
    county_weights: {
      37029: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 37029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27976,
    lat: 36.48185,
    lng: -76.34005,
    city: "South Mills",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4714,
    density: 15.5,
    county_fips: 37029,
    county_name: "Camden",
    county_weights: {
      37029: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 37029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27978,
    lat: 35.66438,
    lng: -75.76959,
    city: "Stumpy Point",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 268,
    density: 3.5,
    county_fips: 37055,
    county_name: "Dare",
    county_weights: {
      37055: 100,
    },
    county_names_all: "Dare",
    county_fips_all: 37055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27979,
    lat: 36.44072,
    lng: -76.56243,
    city: "Sunbury",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1217,
    density: 6.6,
    county_fips: 37073,
    county_name: "Gates",
    county_weights: {
      37073: 100,
    },
    county_names_all: "Gates",
    county_fips_all: 37073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27980,
    lat: 36.24292,
    lng: -76.62161,
    city: "Tyner",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2182,
    density: 17.3,
    county_fips: 37041,
    county_name: "Chowan",
    county_weights: {
      37041: 87.6,
      37143: 12.4,
    },
    county_names_all: "Chowan|Perquimans",
    county_fips_all: "37041|37143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27981,
    lat: 35.85602,
    lng: -75.64041,
    city: "Wanchese",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2092,
    density: 88.6,
    county_fips: 37055,
    county_name: "Dare",
    county_weights: {
      37055: 100,
    },
    county_names_all: "Dare",
    county_fips_all: 37055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27982,
    lat: 35.5635,
    lng: -75.46466,
    city: "Waves",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57,
    density: 33.3,
    county_fips: 37055,
    county_name: "Dare",
    county_weights: {
      37055: 100,
    },
    county_names_all: "Dare",
    county_fips_all: 37055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27983,
    lat: 35.98198,
    lng: -76.94704,
    city: "Windsor",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8546,
    density: 10.4,
    county_fips: 37015,
    county_name: "Bertie",
    county_weights: {
      37015: 100,
    },
    county_names_all: "Bertie",
    county_fips_all: 37015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27985,
    lat: 36.22085,
    lng: -76.46928,
    city: "Winfall",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 374,
    density: 549.7,
    county_fips: 37143,
    county_name: "Perquimans",
    county_weights: {
      37143: 100,
    },
    county_names_all: "Perquimans",
    county_fips_all: 37143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 27986,
    lat: 36.3891,
    lng: -76.92816,
    city: "Winton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2364,
    density: 63.7,
    county_fips: 37091,
    county_name: "Hertford",
    county_weights: {
      37091: 100,
    },
    county_names_all: "Hertford",
    county_fips_all: 37091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28001,
    lat: 35.33594,
    lng: -80.20419,
    city: "Albemarle",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26998,
    density: 79.3,
    county_fips: 37167,
    county_name: "Stanly",
    county_weights: {
      37167: 100,
    },
    county_names_all: "Stanly",
    county_fips_all: 37167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28006,
    lat: 35.40664,
    lng: -81.0926,
    city: "Alexis",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1276,
    density: 107,
    county_fips: 37071,
    county_name: "Gaston",
    county_weights: {
      37071: 51.42,
      37109: 48.58,
    },
    county_names_all: "Gaston|Lincoln",
    county_fips_all: "37071|37109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28007,
    lat: 35.12169,
    lng: -80.13052,
    city: "Ansonville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 616,
    density: 26,
    county_fips: 37007,
    county_name: "Anson",
    county_weights: {
      37007: 100,
    },
    county_names_all: "Anson",
    county_fips_all: 37007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28009,
    lat: 35.40826,
    lng: -80.10743,
    city: "Badin",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1154,
    density: 157,
    county_fips: 37167,
    county_name: "Stanly",
    county_weights: {
      37167: 100,
    },
    county_names_all: "Stanly",
    county_fips_all: 37167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28012,
    lat: 35.21054,
    lng: -81.04077,
    city: "Belmont",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23475,
    density: 332.6,
    county_fips: 37071,
    county_name: "Gaston",
    county_weights: {
      37071: 100,
    },
    county_names_all: "Gaston",
    county_fips_all: 37071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28016,
    lat: 35.31729,
    lng: -81.28737,
    city: "Bessemer City",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14278,
    density: 128.3,
    county_fips: 37071,
    county_name: "Gaston",
    county_weights: {
      37071: 100,
    },
    county_names_all: "Gaston",
    county_fips_all: 37071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28017,
    lat: 35.24708,
    lng: -81.67059,
    city: "Boiling Springs",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 627,
    density: 1409.5,
    county_fips: 37045,
    county_name: "Cleveland",
    county_weights: {
      37045: 100,
    },
    county_names_all: "Cleveland",
    county_fips_all: 37045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28018,
    lat: 35.48458,
    lng: -81.79393,
    city: "Bostic",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4196,
    density: 16.3,
    county_fips: 37161,
    county_name: "Rutherford",
    county_weights: {
      37161: 100,
    },
    county_names_all: "Rutherford",
    county_fips_all: 37161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28019,
    lat: 35.28395,
    lng: -81.79396,
    city: "Caroleen",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 37161,
    county_name: "Rutherford",
    county_weights: {
      37161: 100,
    },
    county_names_all: "Rutherford",
    county_fips_all: 37161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28020,
    lat: 35.52408,
    lng: -81.64328,
    city: "Casar",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2604,
    density: 21.7,
    county_fips: 37045,
    county_name: "Cleveland",
    county_weights: {
      37045: 87.31,
      37161: 12.69,
    },
    county_names_all: "Cleveland|Rutherford",
    county_fips_all: "37045|37161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28021,
    lat: 35.39952,
    lng: -81.41035,
    city: "Cherryville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14817,
    density: 97.2,
    county_fips: 37071,
    county_name: "Gaston",
    county_weights: {
      37045: 24.74,
      37071: 43.01,
      37109: 32.25,
    },
    county_names_all: "Gaston|Lincoln|Cleveland",
    county_fips_all: "37071|37109|37045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28023,
    lat: 35.56922,
    lng: -80.60321,
    city: "China Grove",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15372,
    density: 127.5,
    county_fips: 37159,
    county_name: "Rowan",
    county_weights: {
      37159: 100,
    },
    county_names_all: "Rowan",
    county_fips_all: 37159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28024,
    lat: 35.24347,
    lng: -81.77066,
    city: "Cliffside",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37161,
    county_name: "Rutherford",
    county_weights: {
      37161: 100,
    },
    county_names_all: "Rutherford",
    county_fips_all: 37161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28025,
    lat: 35.38095,
    lng: -80.52719,
    city: "Concord",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55540,
    density: 197.9,
    county_fips: 37025,
    county_name: "Cabarrus",
    county_weights: {
      37025: 100,
    },
    county_names_all: "Cabarrus",
    county_fips_all: 37025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28027,
    lat: 35.40879,
    lng: -80.67524,
    city: "Concord",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68564,
    density: 383.7,
    county_fips: 37025,
    county_name: "Cabarrus",
    county_weights: {
      37025: 100,
    },
    county_names_all: "Cabarrus",
    county_fips_all: 37025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28031,
    lat: 35.47539,
    lng: -80.89344,
    city: "Cornelius",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28408,
    density: 784.6,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37119: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 37119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28032,
    lat: 35.23354,
    lng: -81.07925,
    city: "Cramerton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3211,
    density: 597.7,
    county_fips: 37071,
    county_name: "Gaston",
    county_weights: {
      37071: 100,
    },
    county_names_all: "Gaston",
    county_fips_all: 37071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28033,
    lat: 35.42005,
    lng: -81.3239,
    city: "Crouse",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2561,
    density: 61.3,
    county_fips: 37109,
    county_name: "Lincoln",
    county_weights: {
      37071: 36.6,
      37109: 63.4,
    },
    county_names_all: "Lincoln|Gaston",
    county_fips_all: "37109|37071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28034,
    lat: 35.35323,
    lng: -81.18016,
    city: "Dallas",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18118,
    density: 153.2,
    county_fips: 37071,
    county_name: "Gaston",
    county_weights: {
      37071: 100,
    },
    county_names_all: "Gaston",
    county_fips_all: 37071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28036,
    lat: 35.48586,
    lng: -80.79375,
    city: "Davidson",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19127,
    density: 315.2,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37025: 32.73,
      37097: 7.89,
      37119: 59.06,
      37159: 0.32,
    },
    county_names_all: "Mecklenburg|Cabarrus|Iredell|Rowan",
    county_fips_all: "37119|37025|37097|37159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28037,
    lat: 35.5064,
    lng: -81.01712,
    city: "Denver",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22549,
    density: 194.6,
    county_fips: 37109,
    county_name: "Lincoln",
    county_weights: {
      37035: 10.25,
      37109: 89.75,
    },
    county_names_all: "Lincoln|Catawba",
    county_fips_all: "37109|37035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28039,
    lat: 35.6803,
    lng: -80.43626,
    city: "East Spencer",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 89,
    density: 584.4,
    county_fips: 37159,
    county_name: "Rowan",
    county_weights: {
      37159: 100,
    },
    county_names_all: "Rowan",
    county_fips_all: 37159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28040,
    lat: 35.38738,
    lng: -81.74762,
    city: "Ellenboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7223,
    density: 41.2,
    county_fips: 37161,
    county_name: "Rutherford",
    county_weights: {
      37045: 3.85,
      37161: 96.15,
    },
    county_names_all: "Rutherford|Cleveland",
    county_fips_all: "37161|37045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28041,
    lat: 35.58747,
    lng: -80.46249,
    city: "Faith",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37159,
    county_name: "Rowan",
    county_weights: {
      37159: 100,
    },
    county_names_all: "Rowan",
    county_fips_all: 37159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28042,
    lat: 35.42334,
    lng: -81.50747,
    city: "Fallston",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37045,
    county_name: "Cleveland",
    county_weights: {
      37045: 100,
    },
    county_names_all: "Cleveland",
    county_fips_all: 37045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28043,
    lat: 35.31301,
    lng: -81.86971,
    city: "Forest City",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21275,
    density: 123.9,
    county_fips: 37161,
    county_name: "Rutherford",
    county_weights: {
      37161: 100,
    },
    county_names_all: "Rutherford",
    county_fips_all: 37161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28052,
    lat: 35.22492,
    lng: -81.23266,
    city: "Gastonia",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35741,
    density: 333.3,
    county_fips: 37071,
    county_name: "Gaston",
    county_weights: {
      37071: 100,
    },
    county_names_all: "Gaston",
    county_fips_all: 37071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28054,
    lat: 35.26128,
    lng: -81.15072,
    city: "Gastonia",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37246,
    density: 743.8,
    county_fips: 37071,
    county_name: "Gaston",
    county_weights: {
      37071: 100,
    },
    county_names_all: "Gaston",
    county_fips_all: 37071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28056,
    lat: 35.21768,
    lng: -81.12503,
    city: "Gastonia",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35709,
    density: 285.6,
    county_fips: 37071,
    county_name: "Gaston",
    county_weights: {
      37071: 100,
    },
    county_names_all: "Gaston",
    county_fips_all: 37071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28071,
    lat: 35.51859,
    lng: -80.32175,
    city: "Gold Hill",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2752,
    density: 21.8,
    county_fips: 37159,
    county_name: "Rowan",
    county_weights: {
      37025: 26.62,
      37159: 66.85,
      37167: 6.53,
    },
    county_names_all: "Rowan|Cabarrus|Stanly",
    county_fips_all: "37159|37025|37167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28072,
    lat: 35.61326,
    lng: -80.44241,
    city: "Granite Quarry",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1313,
    density: 635.5,
    county_fips: 37159,
    county_name: "Rowan",
    county_weights: {
      37159: 100,
    },
    county_names_all: "Rowan",
    county_fips_all: 37159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28073,
    lat: 35.19776,
    lng: -81.48126,
    city: "Grover",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6185,
    density: 92.8,
    county_fips: 37045,
    county_name: "Cleveland",
    county_weights: {
      37045: 100,
    },
    county_names_all: "Cleveland",
    county_fips_all: 37045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28074,
    lat: 35.23933,
    lng: -81.8783,
    city: "Harris",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37161,
    county_name: "Rutherford",
    county_weights: {
      37161: 100,
    },
    county_names_all: "Rutherford",
    county_fips_all: 37161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28075,
    lat: 35.30192,
    lng: -80.63929,
    city: "Harrisburg",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19654,
    density: 359.7,
    county_fips: 37025,
    county_name: "Cabarrus",
    county_weights: {
      37025: 100,
    },
    county_names_all: "Cabarrus",
    county_fips_all: 37025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28076,
    lat: 35.25904,
    lng: -81.79074,
    city: "Henrietta",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 819,
    density: 302.5,
    county_fips: 37161,
    county_name: "Rutherford",
    county_weights: {
      37161: 100,
    },
    county_names_all: "Rutherford",
    county_fips_all: 37161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28077,
    lat: 35.40413,
    lng: -81.20284,
    city: "High Shoals",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 552,
    density: 364.7,
    county_fips: 37071,
    county_name: "Gaston",
    county_weights: {
      37071: 100,
    },
    county_names_all: "Gaston",
    county_fips_all: 37071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28078,
    lat: 35.40545,
    lng: -80.86633,
    city: "Huntersville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64000,
    density: 387.8,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37025: 1.81,
      37119: 98.19,
    },
    county_names_all: "Mecklenburg|Cabarrus",
    county_fips_all: "37119|37025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28079,
    lat: 35.1132,
    lng: -80.60183,
    city: "Indian Trail",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40990,
    density: 339.6,
    county_fips: 37179,
    county_name: "Union",
    county_weights: {
      37179: 100,
    },
    county_names_all: "Union",
    county_fips_all: 37179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28080,
    lat: 35.45269,
    lng: -81.10995,
    city: "Iron Station",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7387,
    density: 70.8,
    county_fips: 37109,
    county_name: "Lincoln",
    county_weights: {
      37071: 0.44,
      37109: 99.56,
    },
    county_names_all: "Lincoln|Gaston",
    county_fips_all: "37109|37071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28081,
    lat: 35.50199,
    lng: -80.67024,
    city: "Kannapolis",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29421,
    density: 375.2,
    county_fips: 37025,
    county_name: "Cabarrus",
    county_weights: {
      37025: 50.62,
      37159: 49.38,
    },
    county_names_all: "Cabarrus|Rowan",
    county_fips_all: "37025|37159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28083,
    lat: 35.49108,
    lng: -80.58092,
    city: "Kannapolis",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25109,
    density: 484.8,
    county_fips: 37025,
    county_name: "Cabarrus",
    county_weights: {
      37025: 75.27,
      37159: 24.73,
    },
    county_names_all: "Cabarrus|Rowan",
    county_fips_all: "37025|37159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28086,
    lat: 35.24381,
    lng: -81.37028,
    city: "Kings Mountain",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26490,
    density: 113,
    county_fips: 37045,
    county_name: "Cleveland",
    county_weights: {
      37045: 74.19,
      37071: 25.81,
    },
    county_names_all: "Cleveland|Gaston",
    county_fips_all: "37045|37071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28088,
    lat: 35.54437,
    lng: -80.61463,
    city: "Landis",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2659,
    density: 361.8,
    county_fips: 37159,
    county_name: "Rowan",
    county_weights: {
      37159: 100,
    },
    county_names_all: "Rowan",
    county_fips_all: 37159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28089,
    lat: 35.3202,
    lng: -81.66067,
    city: "Lattimore",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 219,
    density: 202.6,
    county_fips: 37045,
    county_name: "Cleveland",
    county_weights: {
      37045: 100,
    },
    county_names_all: "Cleveland",
    county_fips_all: 37045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28090,
    lat: 35.45987,
    lng: -81.55957,
    city: "Lawndale",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8649,
    density: 35.6,
    county_fips: 37045,
    county_name: "Cleveland",
    county_weights: {
      37023: 1.22,
      37035: 1.06,
      37045: 94.26,
      37109: 3.46,
    },
    county_names_all: "Cleveland|Lincoln|Burke|Catawba",
    county_fips_all: "37045|37109|37023|37035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28091,
    lat: 34.98628,
    lng: -79.93171,
    city: "Lilesville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2132,
    density: 8.8,
    county_fips: 37007,
    county_name: "Anson",
    county_weights: {
      37007: 100,
    },
    county_names_all: "Anson",
    county_fips_all: 37007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28092,
    lat: 35.48404,
    lng: -81.25391,
    city: "Lincolnton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40491,
    density: 130.4,
    county_fips: 37109,
    county_name: "Lincoln",
    county_weights: {
      37035: 4.62,
      37071: 7.9,
      37109: 87.48,
    },
    county_names_all: "Lincoln|Gaston|Catawba",
    county_fips_all: "37109|37071|37035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28097,
    lat: 35.29675,
    lng: -80.39327,
    city: "Locust",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6085,
    density: 78.1,
    county_fips: 37167,
    county_name: "Stanly",
    county_weights: {
      37025: 1.95,
      37167: 98.05,
    },
    county_names_all: "Stanly|Cabarrus",
    county_fips_all: "37167|37025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28098,
    lat: 35.27057,
    lng: -81.09749,
    city: "Lowell",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3689,
    density: 391.1,
    county_fips: 37071,
    county_name: "Gaston",
    county_weights: {
      37071: 100,
    },
    county_names_all: "Gaston",
    county_fips_all: 37071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28101,
    lat: 35.25703,
    lng: -81.07572,
    city: "McAdenville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1170,
    density: 885.3,
    county_fips: 37071,
    county_name: "Gaston",
    county_weights: {
      37071: 100,
    },
    county_names_all: "Gaston",
    county_fips_all: 37071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28102,
    lat: 34.81482,
    lng: -79.97663,
    city: "McFarlan",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 86,
    density: 36.1,
    county_fips: 37007,
    county_name: "Anson",
    county_weights: {
      37007: 100,
    },
    county_names_all: "Anson",
    county_fips_all: 37007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28103,
    lat: 35.0037,
    lng: -80.35316,
    city: "Marshville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11233,
    density: 28.3,
    county_fips: 37179,
    county_name: "Union",
    county_weights: {
      37007: 2.48,
      37179: 97.52,
    },
    county_names_all: "Union|Anson",
    county_fips_all: "37179|37007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28104,
    lat: 35.06017,
    lng: -80.69666,
    city: "Matthews",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31803,
    density: 414.8,
    county_fips: 37179,
    county_name: "Union",
    county_weights: {
      37119: 3.09,
      37179: 96.91,
    },
    county_names_all: "Union|Mecklenburg",
    county_fips_all: "37179|37119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28105,
    lat: 35.11914,
    lng: -80.71116,
    city: "Matthews",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47292,
    density: 785.9,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37119: 98.58,
      37179: 1.42,
    },
    county_names_all: "Mecklenburg|Union",
    county_fips_all: "37119|37179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28107,
    lat: 35.24992,
    lng: -80.52115,
    city: "Midland",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8322,
    density: 65.8,
    county_fips: 37025,
    county_name: "Cabarrus",
    county_weights: {
      37025: 91.45,
      37119: 3.87,
      37167: 1.6,
      37179: 3.08,
    },
    county_names_all: "Cabarrus|Mecklenburg|Union|Stanly",
    county_fips_all: "37025|37119|37179|37167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28108,
    lat: 34.93411,
    lng: -80.67975,
    city: "Mineral Springs",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 128,
    density: 240.9,
    county_fips: 37179,
    county_name: "Union",
    county_weights: {
      37179: 100,
    },
    county_names_all: "Union",
    county_fips_all: 37179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28109,
    lat: 35.48609,
    lng: -80.28628,
    city: "Misenheimer",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 343,
    density: 229.9,
    county_fips: 37167,
    county_name: "Stanly",
    county_weights: {
      37167: 100,
    },
    county_names_all: "Stanly",
    county_fips_all: 37167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28110,
    lat: 35.06552,
    lng: -80.52781,
    city: "Monroe",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54912,
    density: 166.5,
    county_fips: 37179,
    county_name: "Union",
    county_weights: {
      37179: 100,
    },
    county_names_all: "Union",
    county_fips_all: 37179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28112,
    lat: 34.89355,
    lng: -80.54113,
    city: "Monroe",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27580,
    density: 80.6,
    county_fips: 37179,
    county_name: "Union",
    county_weights: {
      37179: 100,
    },
    county_names_all: "Union",
    county_fips_all: 37179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28114,
    lat: 35.23,
    lng: -81.74814,
    city: "Mooresboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7194,
    density: 42.3,
    county_fips: 37045,
    county_name: "Cleveland",
    county_weights: {
      37045: 54.43,
      37161: 45.57,
    },
    county_names_all: "Cleveland|Rutherford",
    county_fips_all: "37045|37161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28115,
    lat: 35.58001,
    lng: -80.77477,
    city: "Mooresville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36978,
    density: 191.3,
    county_fips: 37097,
    county_name: "Iredell",
    county_weights: {
      37097: 70.68,
      37159: 29.32,
    },
    county_names_all: "Iredell|Rowan",
    county_fips_all: "37097|37159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28117,
    lat: 35.57405,
    lng: -80.89658,
    city: "Mooresville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41912,
    density: 413.9,
    county_fips: 37097,
    county_name: "Iredell",
    county_weights: {
      37097: 100,
    },
    county_names_all: "Iredell",
    county_fips_all: 37097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28119,
    lat: 34.85112,
    lng: -80.01492,
    city: "Morven",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2286,
    density: 13.2,
    county_fips: 37007,
    county_name: "Anson",
    county_weights: {
      37007: 100,
    },
    county_names_all: "Anson",
    county_fips_all: 37007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28120,
    lat: 35.33305,
    lng: -81.02692,
    city: "Mount Holly",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21624,
    density: 266.1,
    county_fips: 37071,
    county_name: "Gaston",
    county_weights: {
      37071: 100,
    },
    county_names_all: "Gaston",
    county_fips_all: 37071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28124,
    lat: 35.40136,
    lng: -80.40406,
    city: "Mount Pleasant",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6794,
    density: 45.2,
    county_fips: 37025,
    county_name: "Cabarrus",
    county_weights: {
      37025: 86.24,
      37167: 13.76,
    },
    county_names_all: "Cabarrus|Stanly",
    county_fips_all: "37025|37167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28125,
    lat: 35.66061,
    lng: -80.69949,
    city: "Mount Ulla",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3083,
    density: 31,
    county_fips: 37159,
    county_name: "Rowan",
    county_weights: {
      37097: 4.89,
      37159: 95.11,
    },
    county_names_all: "Rowan|Iredell",
    county_fips_all: "37159|37097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28127,
    lat: 35.44978,
    lng: -80.16552,
    city: "New London",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7227,
    density: 37.4,
    county_fips: 37167,
    county_name: "Stanly",
    county_weights: {
      37057: 5.01,
      37123: 33.74,
      37159: 0.95,
      37167: 60.3,
    },
    county_names_all: "Stanly|Montgomery|Davidson|Rowan",
    county_fips_all: "37167|37123|37057|37159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28128,
    lat: 35.21476,
    lng: -80.15862,
    city: "Norwood",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7641,
    density: 43.2,
    county_fips: 37167,
    county_name: "Stanly",
    county_weights: {
      37167: 100,
    },
    county_names_all: "Stanly",
    county_fips_all: 37167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28129,
    lat: 35.23224,
    lng: -80.32737,
    city: "Oakboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5772,
    density: 51.4,
    county_fips: 37167,
    county_name: "Stanly",
    county_weights: {
      37167: 100,
    },
    county_names_all: "Stanly",
    county_fips_all: 37167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28133,
    lat: 34.93468,
    lng: -80.26239,
    city: "Peachland",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2544,
    density: 12,
    county_fips: 37007,
    county_name: "Anson",
    county_weights: {
      37007: 95.64,
      37179: 4.36,
    },
    county_names_all: "Anson|Union",
    county_fips_all: "37007|37179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28134,
    lat: 35.08364,
    lng: -80.89125,
    city: "Pineville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10766,
    density: 498.4,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37119: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 37119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28135,
    lat: 35.03547,
    lng: -80.21412,
    city: "Polkton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5496,
    density: 21,
    county_fips: 37007,
    county_name: "Anson",
    county_weights: {
      37007: 100,
    },
    county_names_all: "Anson",
    county_fips_all: 37007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28136,
    lat: 35.4206,
    lng: -81.64241,
    city: "Polkville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37045,
    county_name: "Cleveland",
    county_weights: {
      37045: 100,
    },
    county_names_all: "Cleveland",
    county_fips_all: 37045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28137,
    lat: 35.50009,
    lng: -80.25783,
    city: "Richfield",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3100,
    density: 27,
    county_fips: 37167,
    county_name: "Stanly",
    county_weights: {
      37159: 45.74,
      37167: 54.26,
    },
    county_names_all: "Stanly|Rowan",
    county_fips_all: "37167|37159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28138,
    lat: 35.52121,
    lng: -80.44193,
    city: "Rockwell",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9604,
    density: 82.5,
    county_fips: 37159,
    county_name: "Rowan",
    county_weights: {
      37025: 25.03,
      37159: 74.97,
    },
    county_names_all: "Rowan|Cabarrus",
    county_fips_all: "37159|37025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28139,
    lat: 35.34736,
    lng: -81.99702,
    city: "Rutherfordton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20948,
    density: 44.5,
    county_fips: 37161,
    county_name: "Rutherford",
    county_weights: {
      37149: 13.32,
      37161: 86.68,
    },
    county_names_all: "Rutherford|Polk",
    county_fips_all: "37161|37149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28144,
    lat: 35.70645,
    lng: -80.46341,
    city: "Salisbury",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25486,
    density: 327.2,
    county_fips: 37159,
    county_name: "Rowan",
    county_weights: {
      37159: 100,
    },
    county_names_all: "Rowan",
    county_fips_all: 37159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28146,
    lat: 35.62194,
    lng: -80.39563,
    city: "Salisbury",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30212,
    density: 120.1,
    county_fips: 37159,
    county_name: "Rowan",
    county_weights: {
      37159: 100,
    },
    county_names_all: "Rowan",
    county_fips_all: 37159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28147,
    lat: 35.67997,
    lng: -80.56275,
    city: "Salisbury",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23162,
    density: 115.2,
    county_fips: 37159,
    county_name: "Rowan",
    county_weights: {
      37159: 100,
    },
    county_names_all: "Rowan",
    county_fips_all: 37159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28150,
    lat: 35.34712,
    lng: -81.57502,
    city: "Shelby",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27400,
    density: 96.6,
    county_fips: 37045,
    county_name: "Cleveland",
    county_weights: {
      37045: 99.76,
      37161: 0.24,
    },
    county_names_all: "Cleveland|Rutherford",
    county_fips_all: "37045|37161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28152,
    lat: 35.24188,
    lng: -81.59289,
    city: "Shelby",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23681,
    density: 115,
    county_fips: 37045,
    county_name: "Cleveland",
    county_weights: {
      37045: 100,
    },
    county_names_all: "Cleveland",
    county_fips_all: 37045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28159,
    lat: 35.69411,
    lng: -80.43528,
    city: "Spencer",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2838,
    density: 490.3,
    county_fips: 37159,
    county_name: "Rowan",
    county_weights: {
      37159: 100,
    },
    county_names_all: "Rowan",
    county_fips_all: 37159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28160,
    lat: 35.36064,
    lng: -81.92234,
    city: "Spindale",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3902,
    density: 273.6,
    county_fips: 37161,
    county_name: "Rutherford",
    county_weights: {
      37161: 100,
    },
    county_names_all: "Rutherford",
    county_fips_all: 37161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28163,
    lat: 35.20702,
    lng: -80.4285,
    city: "Stanfield",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5347,
    density: 59.3,
    county_fips: 37167,
    county_name: "Stanly",
    county_weights: {
      37167: 100,
    },
    county_names_all: "Stanly",
    county_fips_all: 37167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28164,
    lat: 35.39091,
    lng: -81.03846,
    city: "Stanley",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15709,
    density: 147.9,
    county_fips: 37071,
    county_name: "Gaston",
    county_weights: {
      37071: 62.79,
      37109: 37.21,
    },
    county_names_all: "Gaston|Lincoln",
    county_fips_all: "37071|37109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28166,
    lat: 35.68025,
    lng: -80.87528,
    city: "Troutman",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10576,
    density: 140.8,
    county_fips: 37097,
    county_name: "Iredell",
    county_weights: {
      37097: 100,
    },
    county_names_all: "Iredell",
    county_fips_all: 37097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28167,
    lat: 35.5062,
    lng: -81.95986,
    city: "Union Mills",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2284,
    density: 12,
    county_fips: 37161,
    county_name: "Rutherford",
    county_weights: {
      37111: 6.69,
      37161: 93.31,
    },
    county_names_all: "Rutherford|McDowell",
    county_fips_all: "37161|37111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28168,
    lat: 35.55452,
    lng: -81.42228,
    city: "Vale",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10749,
    density: 47.7,
    county_fips: 37109,
    county_name: "Lincoln",
    county_weights: {
      37023: 0.22,
      37035: 40.44,
      37045: 0.1,
      37109: 59.24,
    },
    county_names_all: "Lincoln|Catawba|Burke|Cleveland",
    county_fips_all: "37109|37035|37023|37045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28169,
    lat: 35.36036,
    lng: -81.42935,
    city: "Waco",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 169,
    density: 111.3,
    county_fips: 37045,
    county_name: "Cleveland",
    county_weights: {
      37045: 100,
    },
    county_names_all: "Cleveland",
    county_fips_all: 37045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28170,
    lat: 34.99263,
    lng: -80.09259,
    city: "Wadesboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11459,
    density: 24.9,
    county_fips: 37007,
    county_name: "Anson",
    county_weights: {
      37007: 100,
    },
    county_names_all: "Anson",
    county_fips_all: 37007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28173,
    lat: 34.91532,
    lng: -80.73021,
    city: "Waxhaw",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58565,
    density: 212.7,
    county_fips: 37179,
    county_name: "Union",
    county_weights: {
      37179: 100,
    },
    county_names_all: "Union",
    county_fips_all: 37179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28174,
    lat: 34.96959,
    lng: -80.4382,
    city: "Wingate",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9927,
    density: 105.3,
    county_fips: 37179,
    county_name: "Union",
    county_weights: {
      37179: 100,
    },
    county_names_all: "Union",
    county_fips_all: 37179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28202,
    lat: 35.22773,
    lng: -80.8447,
    city: "Charlotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14153,
    density: 3028.6,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37119: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 37119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28203,
    lat: 35.20832,
    lng: -80.8577,
    city: "Charlotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17587,
    density: 2167.9,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37119: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 37119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28204,
    lat: 35.21469,
    lng: -80.82677,
    city: "Charlotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7691,
    density: 1684,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37119: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 37119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28205,
    lat: 35.22019,
    lng: -80.78737,
    city: "Charlotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50461,
    density: 1647.3,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37119: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 37119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28206,
    lat: 35.25631,
    lng: -80.82144,
    city: "Charlotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12260,
    density: 678.3,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37119: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 37119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28207,
    lat: 35.19512,
    lng: -80.82606,
    city: "Charlotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10294,
    density: 1635.9,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37119: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 37119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28208,
    lat: 35.23153,
    lng: -80.90611,
    city: "Charlotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41893,
    density: 799.3,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37119: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 37119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28209,
    lat: 35.17878,
    lng: -80.85418,
    city: "Charlotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24373,
    density: 1713.8,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37119: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 37119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28210,
    lat: 35.12969,
    lng: -80.8548,
    city: "Charlotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48715,
    density: 1516.5,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37119: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 37119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28211,
    lat: 35.16816,
    lng: -80.79604,
    city: "Charlotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31510,
    density: 1110.9,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37119: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 37119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28212,
    lat: 35.1896,
    lng: -80.74519,
    city: "Charlotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46770,
    density: 1966.1,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37119: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 37119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28213,
    lat: 35.28459,
    lng: -80.73339,
    city: "Charlotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45086,
    density: 1223.9,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37025: 1.84,
      37119: 98.16,
    },
    county_names_all: "Mecklenburg|Cabarrus",
    county_fips_all: "37119|37025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28214,
    lat: 35.27177,
    lng: -80.96847,
    city: "Charlotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40105,
    density: 456.7,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37119: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 37119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28215,
    lat: 35.24854,
    lng: -80.69571,
    city: "Charlotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64293,
    density: 860.4,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37025: 6.98,
      37119: 93.02,
    },
    county_names_all: "Mecklenburg|Cabarrus",
    county_fips_all: "37119|37025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28216,
    lat: 35.31039,
    lng: -80.8883,
    city: "Charlotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49103,
    density: 631.5,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37119: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 37119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28217,
    lat: 35.17146,
    lng: -80.9077,
    city: "Charlotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31951,
    density: 826.1,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37119: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 37119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28223,
    lat: 35.30824,
    lng: -80.73282,
    city: "Charlotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37119: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 37119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28226,
    lat: 35.10767,
    lng: -80.81837,
    city: "Charlotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38957,
    density: 1021.4,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37119: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 37119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28227,
    lat: 35.18851,
    lng: -80.6507,
    city: "Charlotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58813,
    density: 565.5,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37119: 99.21,
      37179: 0.79,
    },
    county_names_all: "Mecklenburg|Union",
    county_fips_all: "37119|37179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28244,
    lat: 35.2246,
    lng: -80.8431,
    city: "Charlotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37119: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 37119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28262,
    lat: 35.32609,
    lng: -80.74234,
    city: "Charlotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47940,
    density: 881.1,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37025: 0.93,
      37119: 99.07,
    },
    county_names_all: "Mecklenburg|Cabarrus",
    county_fips_all: "37119|37025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28269,
    lat: 35.33747,
    lng: -80.8026,
    city: "Charlotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 79059,
    density: 998.5,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37025: 3.07,
      37119: 96.93,
    },
    county_names_all: "Mecklenburg|Cabarrus",
    county_fips_all: "37119|37025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28270,
    lat: 35.10963,
    lng: -80.76005,
    city: "Charlotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34958,
    density: 1086.3,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37119: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 37119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28273,
    lat: 35.12624,
    lng: -80.94469,
    city: "Charlotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45179,
    density: 774.7,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37119: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 37119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28274,
    lat: 35.18909,
    lng: -80.83384,
    city: "Charlotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37119: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 37119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28277,
    lat: 35.05212,
    lng: -80.81622,
    city: "Charlotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 70193,
    density: 1122.3,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37119: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 37119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28278,
    lat: 35.13063,
    lng: -81.00753,
    city: "Charlotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29919,
    density: 401,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37119: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 37119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28280,
    lat: 35.22633,
    lng: -80.84309,
    city: "Charlotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37119: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 37119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28282,
    lat: 35.22481,
    lng: -80.84529,
    city: "Charlotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 37119,
    county_name: "Mecklenburg",
    county_weights: {
      37119: 100,
    },
    county_names_all: "Mecklenburg",
    county_fips_all: 37119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28301,
    lat: 35.07442,
    lng: -78.88376,
    city: "Fayetteville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16981,
    density: 528.8,
    county_fips: 37051,
    county_name: "Cumberland",
    county_weights: {
      37051: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 37051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28303,
    lat: 35.0852,
    lng: -78.95815,
    city: "Fayetteville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30605,
    density: 767.3,
    county_fips: 37051,
    county_name: "Cumberland",
    county_weights: {
      37051: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 37051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28304,
    lat: 35.02498,
    lng: -78.99072,
    city: "Fayetteville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35605,
    density: 790.4,
    county_fips: 37051,
    county_name: "Cumberland",
    county_weights: {
      37051: 97.53,
      37093: 2.47,
    },
    county_names_all: "Cumberland|Hoke",
    county_fips_all: "37051|37093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28305,
    lat: 35.05321,
    lng: -78.90687,
    city: "Fayetteville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5720,
    density: 849.2,
    county_fips: 37051,
    county_name: "Cumberland",
    county_weights: {
      37051: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 37051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28306,
    lat: 34.9582,
    lng: -78.89487,
    city: "Fayetteville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43300,
    density: 239.7,
    county_fips: 37051,
    county_name: "Cumberland",
    county_weights: {
      37017: 3.64,
      37051: 95.23,
      37093: 1.13,
    },
    county_names_all: "Cumberland|Bladen|Hoke",
    county_fips_all: "37051|37017|37093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28307,
    lat: 35.14154,
    lng: -78.99447,
    city: "Fort Bragg",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17245,
    density: 746.8,
    county_fips: 37051,
    county_name: "Cumberland",
    county_weights: {
      37051: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 37051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28308,
    lat: 35.17206,
    lng: -79.0149,
    city: "Pope Army Airfield",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 588,
    density: 83.1,
    county_fips: 37051,
    county_name: "Cumberland",
    county_weights: {
      37051: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 37051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28310,
    lat: 35.12946,
    lng: -79.0523,
    city: "Fort Bragg",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37051,
    county_name: "Cumberland",
    county_weights: {
      37051: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 37051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28311,
    lat: 35.17033,
    lng: -78.88223,
    city: "Fayetteville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35534,
    density: 375.6,
    county_fips: 37051,
    county_name: "Cumberland",
    county_weights: {
      37051: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 37051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28312,
    lat: 34.94713,
    lng: -78.73225,
    city: "Fayetteville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19892,
    density: 46.8,
    county_fips: 37051,
    county_name: "Cumberland",
    county_weights: {
      37017: 14.63,
      37051: 85.37,
    },
    county_names_all: "Cumberland|Bladen",
    county_fips_all: "37051|37017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28314,
    lat: 35.0557,
    lng: -79.01678,
    city: "Fayetteville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59189,
    density: 1179,
    county_fips: 37051,
    county_name: "Cumberland",
    county_weights: {
      37051: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 37051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28315,
    lat: 35.1122,
    lng: -79.44452,
    city: "Aberdeen",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13804,
    density: 82,
    county_fips: 37125,
    county_name: "Moore",
    county_weights: {
      37093: 33.54,
      37125: 66.46,
    },
    county_names_all: "Moore|Hoke",
    county_fips_all: "37125|37093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28318,
    lat: 35.0176,
    lng: -78.61665,
    city: "Autryville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3644,
    density: 17.4,
    county_fips: 37163,
    county_name: "Sampson",
    county_weights: {
      37051: 31.17,
      37163: 68.83,
    },
    county_names_all: "Sampson|Cumberland",
    county_fips_all: "37163|37051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28320,
    lat: 34.55378,
    lng: -78.77456,
    city: "Bladenboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9524,
    density: 31.7,
    county_fips: 37017,
    county_name: "Bladen",
    county_weights: {
      37017: 94.24,
      37047: 5.76,
    },
    county_names_all: "Bladen|Columbus",
    county_fips_all: "37017|37047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28323,
    lat: 35.31192,
    lng: -78.83842,
    city: "Bunnlevel",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4125,
    density: 42.9,
    county_fips: 37085,
    county_name: "Harnett",
    county_weights: {
      37085: 100,
    },
    county_names_all: "Harnett",
    county_fips_all: 37085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28325,
    lat: 35.15335,
    lng: -78.10425,
    city: "Calypso",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 647,
    density: 263.5,
    county_fips: 37061,
    county_name: "Duplin",
    county_weights: {
      37061: 100,
    },
    county_names_all: "Duplin",
    county_fips_all: 37061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28326,
    lat: 35.27938,
    lng: -79.16989,
    city: "Cameron",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23854,
    density: 78.2,
    county_fips: 37085,
    county_name: "Harnett",
    county_weights: {
      37085: 56.43,
      37105: 7.53,
      37125: 36.04,
    },
    county_names_all: "Harnett|Moore|Lee",
    county_fips_all: "37085|37125|37105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28327,
    lat: 35.35759,
    lng: -79.42333,
    city: "Carthage",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17406,
    density: 36,
    county_fips: 37125,
    county_name: "Moore",
    county_weights: {
      37125: 100,
    },
    county_names_all: "Moore",
    county_fips_all: 37125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28328,
    lat: 35.00504,
    lng: -78.33513,
    city: "Clinton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27016,
    density: 42.4,
    county_fips: 37163,
    county_name: "Sampson",
    county_weights: {
      37163: 100,
    },
    county_names_all: "Sampson",
    county_fips_all: 37163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28330,
    lat: 34.91077,
    lng: -79.82332,
    city: "Cordova",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 240,
    density: 269.7,
    county_fips: 37153,
    county_name: "Richmond",
    county_weights: {
      37153: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 37153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28331,
    lat: 35.19883,
    lng: -78.64944,
    city: "Cumberland",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37051,
    county_name: "Cumberland",
    county_weights: {
      37051: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 37051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28332,
    lat: 34.65808,
    lng: -78.70971,
    city: "Dublin",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 501,
    density: 56.9,
    county_fips: 37017,
    county_name: "Bladen",
    county_weights: {
      37017: 100,
    },
    county_names_all: "Bladen",
    county_fips_all: 37017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28333,
    lat: 35.28292,
    lng: -78.01239,
    city: "Dudley",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11218,
    density: 94.8,
    county_fips: 37191,
    county_name: "Wayne",
    county_weights: {
      37191: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 37191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28334,
    lat: 35.2681,
    lng: -78.57051,
    city: "Dunn",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23091,
    density: 55.6,
    county_fips: 37163,
    county_name: "Sampson",
    county_weights: {
      37051: 8.49,
      37085: 36.83,
      37101: 8.12,
      37163: 46.55,
    },
    county_names_all: "Sampson|Harnett|Cumberland|Johnston",
    county_fips_all: "37163|37085|37051|37101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28337,
    lat: 34.66094,
    lng: -78.57733,
    city: "Elizabethtown",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10611,
    density: 24.7,
    county_fips: 37017,
    county_name: "Bladen",
    county_weights: {
      37017: 100,
    },
    county_names_all: "Bladen",
    county_fips_all: 37017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28338,
    lat: 35.09644,
    lng: -79.75506,
    city: "Ellerbe",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3895,
    density: 10.2,
    county_fips: 37153,
    county_name: "Richmond",
    county_weights: {
      37153: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 37153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28339,
    lat: 35.31409,
    lng: -78.72115,
    city: "Erwin",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7237,
    density: 78.5,
    county_fips: 37085,
    county_name: "Harnett",
    county_weights: {
      37085: 100,
    },
    county_names_all: "Harnett",
    county_fips_all: 37085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28340,
    lat: 34.47136,
    lng: -79.1403,
    city: "Fairmont",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10695,
    density: 33.5,
    county_fips: 37155,
    county_name: "Robeson",
    county_weights: {
      37155: 100,
    },
    county_names_all: "Robeson",
    county_fips_all: 37155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28341,
    lat: 35.11919,
    lng: -78.17577,
    city: "Faison",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4752,
    density: 19.6,
    county_fips: 37163,
    county_name: "Sampson",
    county_weights: {
      37061: 41.09,
      37163: 58.91,
    },
    county_names_all: "Sampson|Duplin",
    county_fips_all: "37163|37061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28342,
    lat: 35.18949,
    lng: -78.6499,
    city: "Falcon",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 219,
    density: 101.7,
    county_fips: 37051,
    county_name: "Cumberland",
    county_weights: {
      37051: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 37051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28343,
    lat: 34.76454,
    lng: -79.58129,
    city: "Gibson",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1572,
    density: 39.1,
    county_fips: 37165,
    county_name: "Scotland",
    county_weights: {
      37165: 100,
    },
    county_names_all: "Scotland",
    county_fips_all: 37165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28344,
    lat: 35.16506,
    lng: -78.63139,
    city: "Godwin",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5299,
    density: 55.7,
    county_fips: 37163,
    county_name: "Sampson",
    county_weights: {
      37051: 38.87,
      37163: 61.13,
    },
    county_names_all: "Sampson|Cumberland",
    county_fips_all: "37163|37051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28345,
    lat: 34.87464,
    lng: -79.6716,
    city: "Hamlet",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11484,
    density: 62.4,
    county_fips: 37153,
    county_name: "Richmond",
    county_weights: {
      37153: 96.47,
      37165: 3.53,
    },
    county_names_all: "Richmond|Scotland",
    county_fips_all: "37153|37165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28347,
    lat: 35.04652,
    lng: -79.56203,
    city: "Hoffman",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2012,
    density: 20.6,
    county_fips: 37153,
    county_name: "Richmond",
    county_weights: {
      37125: 15.86,
      37153: 84.14,
    },
    county_names_all: "Richmond|Moore",
    county_fips_all: "37153|37125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28348,
    lat: 34.92691,
    lng: -78.91313,
    city: "Hope Mills",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37073,
    density: 339.1,
    county_fips: 37051,
    county_name: "Cumberland",
    county_weights: {
      37051: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 37051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28349,
    lat: 34.98206,
    lng: -77.92033,
    city: "Kenansville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3541,
    density: 20.7,
    county_fips: 37061,
    county_name: "Duplin",
    county_weights: {
      37061: 100,
    },
    county_names_all: "Duplin",
    county_fips_all: 37061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28350,
    lat: 35.2488,
    lng: -79.32064,
    city: "Lakeview",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 114,
    density: 21.6,
    county_fips: 37125,
    county_name: "Moore",
    county_weights: {
      37125: 100,
    },
    county_names_all: "Moore",
    county_fips_all: 37125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28351,
    lat: 34.84098,
    lng: -79.56102,
    city: "Laurel Hill",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4767,
    density: 31.3,
    county_fips: 37165,
    county_name: "Scotland",
    county_weights: {
      37153: 2.94,
      37165: 97.06,
    },
    county_names_all: "Scotland|Richmond",
    county_fips_all: "37165|37153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28352,
    lat: 34.76762,
    lng: -79.45321,
    city: "Laurinburg",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24677,
    density: 76.1,
    county_fips: 37165,
    county_name: "Scotland",
    county_weights: {
      37165: 100,
    },
    county_names_all: "Scotland",
    county_fips_all: 37165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28355,
    lat: 35.39053,
    lng: -79.19514,
    city: "Lemon Springs",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37105,
    county_name: "Lee",
    county_weights: {
      37105: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 37105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28356,
    lat: 35.23092,
    lng: -78.79113,
    city: "Linden",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4595,
    density: 32.1,
    county_fips: 37051,
    county_name: "Cumberland",
    county_weights: {
      37051: 79.41,
      37085: 20.59,
    },
    county_names_all: "Cumberland|Harnett",
    county_fips_all: "37051|37085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28357,
    lat: 34.90606,
    lng: -79.08688,
    city: "Lumber Bridge",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2520,
    density: 27.8,
    county_fips: 37155,
    county_name: "Robeson",
    county_weights: {
      37093: 45.44,
      37155: 54.56,
    },
    county_names_all: "Robeson|Hoke",
    county_fips_all: "37155|37093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28358,
    lat: 34.60527,
    lng: -78.94097,
    city: "Lumberton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39102,
    density: 76.8,
    county_fips: 37155,
    county_name: "Robeson",
    county_weights: {
      37155: 100,
    },
    county_names_all: "Robeson",
    county_fips_all: 37155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28359,
    lat: 34.58686,
    lng: -79.05475,
    city: "Lumberton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37155,
    county_name: "Robeson",
    county_weights: {
      37155: 100,
    },
    county_names_all: "Robeson",
    county_fips_all: 37155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28360,
    lat: 34.67588,
    lng: -79.07582,
    city: "Lumberton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15743,
    density: 84.1,
    county_fips: 37155,
    county_name: "Robeson",
    county_weights: {
      37155: 100,
    },
    county_names_all: "Robeson",
    county_fips_all: 37155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28362,
    lat: 34.36961,
    lng: -79.12882,
    city: "Marietta",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37155,
    county_name: "Robeson",
    county_weights: {
      37155: 100,
    },
    county_names_all: "Robeson",
    county_fips_all: 37155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28363,
    lat: 34.95772,
    lng: -79.53384,
    city: "Marston",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1623,
    density: 8.4,
    county_fips: 37165,
    county_name: "Scotland",
    county_weights: {
      37153: 26.15,
      37165: 73.85,
    },
    county_names_all: "Scotland|Richmond",
    county_fips_all: "37165|37153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28364,
    lat: 34.71447,
    lng: -79.32759,
    city: "Maxton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14221,
    density: 40.9,
    county_fips: 37155,
    county_name: "Robeson",
    county_weights: {
      37093: 1.43,
      37155: 91.65,
      37165: 6.92,
    },
    county_names_all: "Robeson|Scotland|Hoke",
    county_fips_all: "37155|37165|37093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28365,
    lat: 35.17807,
    lng: -78.05827,
    city: "Mount Olive",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15872,
    density: 32,
    county_fips: 37061,
    county_name: "Duplin",
    county_weights: {
      37061: 48.98,
      37163: 4.83,
      37191: 46.19,
    },
    county_names_all: "Duplin|Wayne|Sampson",
    county_fips_all: "37061|37191|37163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28366,
    lat: 35.22974,
    lng: -78.36317,
    city: "Newton Grove",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5003,
    density: 22.5,
    county_fips: 37163,
    county_name: "Sampson",
    county_weights: {
      37101: 20.41,
      37163: 79.59,
    },
    county_names_all: "Sampson|Johnston",
    county_fips_all: "37163|37101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28367,
    lat: 35.16982,
    lng: -79.72325,
    city: "Norman",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 172,
    density: 119.1,
    county_fips: 37153,
    county_name: "Richmond",
    county_weights: {
      37123: 0.33,
      37153: 99.67,
    },
    county_names_all: "Richmond|Montgomery",
    county_fips_all: "37153|37123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28368,
    lat: 35.36942,
    lng: -79.11331,
    city: "Olivia",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37085,
    county_name: "Harnett",
    county_weights: {
      37085: 100,
    },
    county_names_all: "Harnett",
    county_fips_all: 37085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28369,
    lat: 34.42184,
    lng: -79.02901,
    city: "Orrum",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2488,
    density: 12.9,
    county_fips: 37155,
    county_name: "Robeson",
    county_weights: {
      37155: 100,
    },
    county_names_all: "Robeson",
    county_fips_all: 37155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28371,
    lat: 34.9079,
    lng: -78.99018,
    city: "Parkton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5827,
    density: 66.9,
    county_fips: 37155,
    county_name: "Robeson",
    county_weights: {
      37051: 19.77,
      37093: 2.16,
      37155: 78.07,
    },
    county_names_all: "Robeson|Cumberland|Hoke",
    county_fips_all: "37155|37051|37093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28372,
    lat: 34.69991,
    lng: -79.1786,
    city: "Pembroke",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13371,
    density: 116.6,
    county_fips: 37155,
    county_name: "Robeson",
    county_weights: {
      37155: 100,
    },
    county_names_all: "Robeson",
    county_fips_all: 37155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28373,
    lat: 35.09079,
    lng: -79.48522,
    city: "Pinebluff",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2841,
    density: 85,
    county_fips: 37125,
    county_name: "Moore",
    county_weights: {
      37125: 100,
    },
    county_names_all: "Moore",
    county_fips_all: 37125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28374,
    lat: 35.19705,
    lng: -79.46009,
    city: "Pinehurst",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17794,
    density: 326.6,
    county_fips: 37125,
    county_name: "Moore",
    county_weights: {
      37125: 100,
    },
    county_names_all: "Moore",
    county_fips_all: 37125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28375,
    lat: 34.47723,
    lng: -79.04337,
    city: "Proctorville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 187,
    density: 47.6,
    county_fips: 37155,
    county_name: "Robeson",
    county_weights: {
      37155: 100,
    },
    county_names_all: "Robeson",
    county_fips_all: 37155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28376,
    lat: 35.052,
    lng: -79.23342,
    city: "Raeford",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45895,
    density: 63.6,
    county_fips: 37093,
    county_name: "Hoke",
    county_weights: {
      37093: 100,
    },
    county_names_all: "Hoke",
    county_fips_all: 37093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28377,
    lat: 34.83526,
    lng: -79.21282,
    city: "Red Springs",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12831,
    density: 49.1,
    county_fips: 37093,
    county_name: "Hoke",
    county_weights: {
      37093: 51.53,
      37155: 48.47,
    },
    county_names_all: "Hoke|Robeson",
    county_fips_all: "37093|37155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28378,
    lat: 34.85872,
    lng: -79.0506,
    city: "Rex",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37155,
    county_name: "Robeson",
    county_weights: {
      37155: 100,
    },
    county_names_all: "Robeson",
    county_fips_all: 37155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28379,
    lat: 34.93073,
    lng: -79.78252,
    city: "Rockingham",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25663,
    density: 65.4,
    county_fips: 37153,
    county_name: "Richmond",
    county_weights: {
      37153: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 37153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28382,
    lat: 34.97546,
    lng: -78.50561,
    city: "Roseboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7879,
    density: 27,
    county_fips: 37163,
    county_name: "Sampson",
    county_weights: {
      37051: 12.78,
      37163: 87.22,
    },
    county_names_all: "Sampson|Cumberland",
    county_fips_all: "37163|37051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28383,
    lat: 34.57553,
    lng: -79.26856,
    city: "Rowland",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7651,
    density: 28,
    county_fips: 37155,
    county_name: "Robeson",
    county_weights: {
      37155: 100,
    },
    county_names_all: "Robeson",
    county_fips_all: 37155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28384,
    lat: 34.79687,
    lng: -78.95035,
    city: "Saint Pauls",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10831,
    density: 41.2,
    county_fips: 37155,
    county_name: "Robeson",
    county_weights: {
      37017: 13.07,
      37051: 3.06,
      37155: 83.87,
    },
    county_names_all: "Robeson|Bladen|Cumberland",
    county_fips_all: "37155|37017|37051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28385,
    lat: 35.04461,
    lng: -78.50012,
    city: "Salemburg",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2012,
    density: 19.5,
    county_fips: 37163,
    county_name: "Sampson",
    county_weights: {
      37163: 100,
    },
    county_names_all: "Sampson",
    county_fips_all: 37163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28386,
    lat: 34.85889,
    lng: -79.12984,
    city: "Shannon",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5936,
    density: 53.1,
    county_fips: 37155,
    county_name: "Robeson",
    county_weights: {
      37093: 41.54,
      37155: 58.46,
    },
    county_names_all: "Robeson|Hoke",
    county_fips_all: "37155|37093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28387,
    lat: 35.18059,
    lng: -79.37566,
    city: "Southern Pines",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15110,
    density: 197.6,
    county_fips: 37125,
    county_name: "Moore",
    county_weights: {
      37125: 100,
    },
    county_names_all: "Moore",
    county_fips_all: 37125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28390,
    lat: 35.21783,
    lng: -78.95488,
    city: "Spring Lake",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24794,
    density: 159.1,
    county_fips: 37085,
    county_name: "Harnett",
    county_weights: {
      37051: 47.79,
      37085: 52.21,
    },
    county_names_all: "Harnett|Cumberland",
    county_fips_all: "37085|37051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28391,
    lat: 35.03045,
    lng: -78.70009,
    city: "Stedman",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6022,
    density: 59.1,
    county_fips: 37051,
    county_name: "Cumberland",
    county_weights: {
      37051: 99.3,
      37163: 0.7,
    },
    county_names_all: "Cumberland|Sampson",
    county_fips_all: "37051|37163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28392,
    lat: 34.73467,
    lng: -78.79465,
    city: "Tar Heel",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1555,
    density: 16,
    county_fips: 37017,
    county_name: "Bladen",
    county_weights: {
      37017: 100,
    },
    county_names_all: "Bladen",
    county_fips_all: 37017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28393,
    lat: 34.98205,
    lng: -78.18895,
    city: "Turkey",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2012,
    density: 16.6,
    county_fips: 37163,
    county_name: "Sampson",
    county_weights: {
      37061: 0.63,
      37163: 99.37,
    },
    county_names_all: "Sampson|Duplin",
    county_fips_all: "37163|37061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28394,
    lat: 35.21652,
    lng: -79.23777,
    city: "Vass",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6110,
    density: 57.2,
    county_fips: 37125,
    county_name: "Moore",
    county_weights: {
      37125: 100,
    },
    county_names_all: "Moore",
    county_fips_all: 37125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28395,
    lat: 35.13643,
    lng: -78.73855,
    city: "Wade",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2171,
    density: 16.6,
    county_fips: 37051,
    county_name: "Cumberland",
    county_weights: {
      37051: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 37051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28396,
    lat: 34.93948,
    lng: -79.40971,
    city: "Wagram",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2836,
    density: 20.1,
    county_fips: 37165,
    county_name: "Scotland",
    county_weights: {
      37165: 100,
    },
    county_names_all: "Scotland",
    county_fips_all: 37165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28398,
    lat: 34.99307,
    lng: -78.07143,
    city: "Warsaw",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8856,
    density: 36.3,
    county_fips: 37061,
    county_name: "Duplin",
    county_weights: {
      37061: 100,
    },
    county_names_all: "Duplin",
    county_fips_all: 37061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28399,
    lat: 34.77885,
    lng: -78.72953,
    city: "White Oak",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1896,
    density: 9.2,
    county_fips: 37017,
    county_name: "Bladen",
    county_weights: {
      37017: 93.9,
      37051: 6.1,
    },
    county_names_all: "Bladen|Cumberland",
    county_fips_all: "37017|37051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28401,
    lat: 34.29053,
    lng: -77.97053,
    city: "Wilmington",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24764,
    density: 308.6,
    county_fips: 37129,
    county_name: "New Hanover",
    county_weights: {
      37129: 80.6,
      37141: 19.4,
    },
    county_names_all: "New Hanover|Pender",
    county_fips_all: "37129|37141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28403,
    lat: 34.22177,
    lng: -77.87902,
    city: "Wilmington",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42319,
    density: 1164.7,
    county_fips: 37129,
    county_name: "New Hanover",
    county_weights: {
      37129: 100,
    },
    county_names_all: "New Hanover",
    county_fips_all: 37129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28405,
    lat: 34.26388,
    lng: -77.86743,
    city: "Wilmington",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33344,
    density: 546.8,
    county_fips: 37129,
    county_name: "New Hanover",
    county_weights: {
      37129: 100,
    },
    county_names_all: "New Hanover",
    county_fips_all: 37129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28409,
    lat: 34.15244,
    lng: -77.86477,
    city: "Wilmington",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36070,
    density: 621.6,
    county_fips: 37129,
    county_name: "New Hanover",
    county_weights: {
      37129: 100,
    },
    county_names_all: "New Hanover",
    county_fips_all: 37129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28411,
    lat: 34.3015,
    lng: -77.79307,
    city: "Wilmington",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38112,
    density: 357,
    county_fips: 37129,
    county_name: "New Hanover",
    county_weights: {
      37129: 80.48,
      37141: 19.52,
    },
    county_names_all: "New Hanover|Pender",
    county_fips_all: "37129|37141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28412,
    lat: 34.13306,
    lng: -77.9191,
    city: "Wilmington",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38882,
    density: 674.2,
    county_fips: 37129,
    county_name: "New Hanover",
    county_weights: {
      37129: 100,
    },
    county_names_all: "New Hanover",
    county_fips_all: 37129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28420,
    lat: 34.07831,
    lng: -78.46087,
    city: "Ash",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4157,
    density: 9.4,
    county_fips: 37019,
    county_name: "Brunswick",
    county_weights: {
      37019: 100,
    },
    county_names_all: "Brunswick",
    county_fips_all: 37019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28421,
    lat: 34.52183,
    lng: -78.17802,
    city: "Atkinson",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1893,
    density: 12.9,
    county_fips: 37141,
    county_name: "Pender",
    county_weights: {
      37141: 100,
    },
    county_names_all: "Pender",
    county_fips_all: 37141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28422,
    lat: 34.05192,
    lng: -78.20147,
    city: "Bolivia",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8598,
    density: 25,
    county_fips: 37019,
    county_name: "Brunswick",
    county_weights: {
      37019: 100,
    },
    county_names_all: "Brunswick",
    county_fips_all: 37019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28423,
    lat: 34.27782,
    lng: -78.40483,
    city: "Bolton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2791,
    density: 8.8,
    county_fips: 37047,
    county_name: "Columbus",
    county_weights: {
      37017: 3.89,
      37047: 96.11,
    },
    county_names_all: "Columbus|Bladen",
    county_fips_all: "37047|37017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28424,
    lat: 34.29032,
    lng: -78.69971,
    city: "Brunswick",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48,
    density: 129.3,
    county_fips: 37047,
    county_name: "Columbus",
    county_weights: {
      37047: 100,
    },
    county_names_all: "Columbus",
    county_fips_all: 37047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28425,
    lat: 34.5591,
    lng: -77.90253,
    city: "Burgaw",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11433,
    density: 28.8,
    county_fips: 37141,
    county_name: "Pender",
    county_weights: {
      37141: 100,
    },
    county_names_all: "Pender",
    county_fips_all: 37141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28428,
    lat: 34.03831,
    lng: -77.90682,
    city: "Carolina Beach",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6634,
    density: 496.2,
    county_fips: 37129,
    county_name: "New Hanover",
    county_weights: {
      37129: 100,
    },
    county_names_all: "New Hanover",
    county_fips_all: 37129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28429,
    lat: 34.34171,
    lng: -77.9011,
    city: "Castle Hayne",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8116,
    density: 78.9,
    county_fips: 37129,
    county_name: "New Hanover",
    county_weights: {
      37129: 100,
    },
    county_names_all: "New Hanover",
    county_fips_all: 37129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28430,
    lat: 34.28419,
    lng: -78.93333,
    city: "Cerro Gordo",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2250,
    density: 18.5,
    county_fips: 37047,
    county_name: "Columbus",
    county_weights: {
      37047: 100,
    },
    county_names_all: "Columbus",
    county_fips_all: 37047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28431,
    lat: 34.31661,
    lng: -78.84397,
    city: "Chadbourn",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7093,
    density: 34.9,
    county_fips: 37047,
    county_name: "Columbus",
    county_weights: {
      37047: 100,
    },
    county_names_all: "Columbus",
    county_fips_all: 37047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28432,
    lat: 34.17018,
    lng: -78.75795,
    city: "Clarendon",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1371,
    density: 15.5,
    county_fips: 37047,
    county_name: "Columbus",
    county_weights: {
      37047: 100,
    },
    county_names_all: "Columbus",
    county_fips_all: 37047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28433,
    lat: 34.48979,
    lng: -78.62598,
    city: "Clarkton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4788,
    density: 15.4,
    county_fips: 37017,
    county_name: "Bladen",
    county_weights: {
      37017: 73.73,
      37047: 26.27,
    },
    county_names_all: "Bladen|Columbus",
    county_fips_all: "37017|37047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28434,
    lat: 34.47154,
    lng: -78.47479,
    city: "Council",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 852,
    density: 4.7,
    county_fips: 37017,
    county_name: "Bladen",
    county_weights: {
      37017: 100,
    },
    county_names_all: "Bladen",
    county_fips_all: 37017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28435,
    lat: 34.41007,
    lng: -78.11508,
    city: "Currie",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2131,
    density: 9.4,
    county_fips: 37141,
    county_name: "Pender",
    county_weights: {
      37141: 100,
    },
    county_names_all: "Pender",
    county_fips_all: 37141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28436,
    lat: 34.26703,
    lng: -78.27552,
    city: "Delco",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1935,
    density: 17.1,
    county_fips: 37047,
    county_name: "Columbus",
    county_weights: {
      37047: 100,
    },
    county_names_all: "Columbus",
    county_fips_all: 37047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28438,
    lat: 34.4166,
    lng: -78.92221,
    city: "Evergreen",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1654,
    density: 14.2,
    county_fips: 37047,
    county_name: "Columbus",
    county_weights: {
      37017: 4.49,
      37047: 95.51,
    },
    county_names_all: "Columbus|Bladen",
    county_fips_all: "37047|37017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28439,
    lat: 34.29411,
    lng: -79.00947,
    city: "Fair Bluff",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1091,
    density: 17.3,
    county_fips: 37047,
    county_name: "Columbus",
    county_weights: {
      37047: 100,
    },
    county_names_all: "Columbus",
    county_fips_all: 37047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28441,
    lat: 34.79047,
    lng: -78.4355,
    city: "Garland",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3352,
    density: 9,
    county_fips: 37163,
    county_name: "Sampson",
    county_weights: {
      37017: 47.09,
      37163: 52.91,
    },
    county_names_all: "Sampson|Bladen",
    county_fips_all: "37163|37017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28442,
    lat: 34.31023,
    lng: -78.60106,
    city: "Hallsboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1469,
    density: 14.9,
    county_fips: 37047,
    county_name: "Columbus",
    county_weights: {
      37047: 100,
    },
    county_names_all: "Columbus",
    county_fips_all: 37047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28443,
    lat: 34.46211,
    lng: -77.67312,
    city: "Hampstead",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24778,
    density: 65.6,
    county_fips: 37141,
    county_name: "Pender",
    county_weights: {
      37141: 100,
    },
    county_names_all: "Pender",
    county_fips_all: 37141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28444,
    lat: 34.6885,
    lng: -78.31798,
    city: "Harrells",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2352,
    density: 8.6,
    county_fips: 37163,
    county_name: "Sampson",
    county_weights: {
      37017: 43.71,
      37061: 3.08,
      37163: 53.21,
    },
    county_names_all: "Sampson|Bladen|Duplin",
    county_fips_all: "37163|37017|37061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28445,
    lat: 34.54199,
    lng: -77.54019,
    city: "Holly Ridge",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7288,
    density: 27.1,
    county_fips: 37133,
    county_name: "Onslow",
    county_weights: {
      37133: 87.94,
      37141: 12.06,
    },
    county_names_all: "Onslow|Pender",
    county_fips_all: "37133|37141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28447,
    lat: 34.59953,
    lng: -78.25848,
    city: "Ivanhoe",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1941,
    density: 7.5,
    county_fips: 37017,
    county_name: "Bladen",
    county_weights: {
      37017: 41.74,
      37141: 27.4,
      37163: 30.87,
    },
    county_names_all: "Bladen|Sampson|Pender",
    county_fips_all: "37017|37163|37141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28448,
    lat: 34.49078,
    lng: -78.31933,
    city: "Kelly",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 621,
    density: 2.5,
    county_fips: 37017,
    county_name: "Bladen",
    county_weights: {
      37017: 95.29,
      37141: 4.71,
    },
    county_names_all: "Bladen|Pender",
    county_fips_all: "37017|37141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28449,
    lat: 33.98151,
    lng: -77.92748,
    city: "Kure Beach",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2141,
    density: 208.7,
    county_fips: 37129,
    county_name: "New Hanover",
    county_weights: {
      37129: 100,
    },
    county_names_all: "New Hanover",
    county_fips_all: 37129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28450,
    lat: 34.29689,
    lng: -78.51425,
    city: "Lake Waccamaw",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2194,
    density: 14.6,
    county_fips: 37047,
    county_name: "Columbus",
    county_weights: {
      37047: 100,
    },
    county_names_all: "Columbus",
    county_fips_all: 37047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28451,
    lat: 34.2327,
    lng: -78.11503,
    city: "Leland",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37414,
    density: 83.9,
    county_fips: 37019,
    county_name: "Brunswick",
    county_weights: {
      37019: 100,
    },
    county_names_all: "Brunswick",
    county_fips_all: 37019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28452,
    lat: 34.0031,
    lng: -78.55068,
    city: "Longwood",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 723,
    density: 55.7,
    county_fips: 37019,
    county_name: "Brunswick",
    county_weights: {
      37019: 100,
    },
    county_names_all: "Brunswick",
    county_fips_all: 37019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28453,
    lat: 34.88283,
    lng: -78.06805,
    city: "Magnolia",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3937,
    density: 18,
    county_fips: 37061,
    county_name: "Duplin",
    county_weights: {
      37061: 75.38,
      37163: 24.62,
    },
    county_names_all: "Duplin|Sampson",
    county_fips_all: "37061|37163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28454,
    lat: 34.6703,
    lng: -77.65393,
    city: "Maple Hill",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2827,
    density: 13.5,
    county_fips: 37133,
    county_name: "Onslow",
    county_weights: {
      37133: 53.16,
      37141: 46.84,
    },
    county_names_all: "Onslow|Pender",
    county_fips_all: "37133|37141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28455,
    lat: 34.11045,
    lng: -78.62865,
    city: "Nakina",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2698,
    density: 14.8,
    county_fips: 37047,
    county_name: "Columbus",
    county_weights: {
      37047: 100,
    },
    county_names_all: "Columbus",
    county_fips_all: 37047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28456,
    lat: 34.37678,
    lng: -78.29228,
    city: "Riegelwood",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3797,
    density: 18.6,
    county_fips: 37047,
    county_name: "Columbus",
    county_weights: {
      37017: 43.19,
      37019: 13.04,
      37047: 43.76,
    },
    county_names_all: "Columbus|Bladen|Brunswick",
    county_fips_all: "37047|37017|37019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28457,
    lat: 34.45608,
    lng: -77.86618,
    city: "Rocky Point",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10967,
    density: 28.7,
    county_fips: 37141,
    county_name: "Pender",
    county_weights: {
      37141: 100,
    },
    county_names_all: "Pender",
    county_fips_all: 37141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28458,
    lat: 34.81886,
    lng: -78.07895,
    city: "Rose Hill",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6357,
    density: 21.5,
    county_fips: 37061,
    county_name: "Duplin",
    county_weights: {
      37061: 69.65,
      37163: 30.35,
    },
    county_names_all: "Duplin|Sampson",
    county_fips_all: "37061|37163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28460,
    lat: 34.52569,
    lng: -77.41873,
    city: "Sneads Ferry",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10831,
    density: 150,
    county_fips: 37133,
    county_name: "Onslow",
    county_weights: {
      37133: 100,
    },
    county_names_all: "Onslow",
    county_fips_all: 37133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28461,
    lat: 33.96607,
    lng: -78.03874,
    city: "Southport",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22421,
    density: 114,
    county_fips: 37019,
    county_name: "Brunswick",
    county_weights: {
      37019: 100,
    },
    county_names_all: "Brunswick",
    county_fips_all: 37019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28462,
    lat: 34,
    lng: -78.30497,
    city: "Supply",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13140,
    density: 70.1,
    county_fips: 37019,
    county_name: "Brunswick",
    county_weights: {
      37019: 100,
    },
    county_names_all: "Brunswick",
    county_fips_all: 37019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28463,
    lat: 34.10213,
    lng: -78.78001,
    city: "Tabor City",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8732,
    density: 29.9,
    county_fips: 37047,
    county_name: "Columbus",
    county_weights: {
      37047: 100,
    },
    county_names_all: "Columbus",
    county_fips_all: 37047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28464,
    lat: 34.77661,
    lng: -78.01854,
    city: "Teachey",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2827,
    density: 44.8,
    county_fips: 37061,
    county_name: "Duplin",
    county_weights: {
      37061: 100,
    },
    county_names_all: "Duplin",
    county_fips_all: 37061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28465,
    lat: 33.91227,
    lng: -78.09913,
    city: "Oak Island",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7750,
    density: 274.3,
    county_fips: 37019,
    county_name: "Brunswick",
    county_weights: {
      37019: 100,
    },
    county_names_all: "Brunswick",
    county_fips_all: 37019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28466,
    lat: 34.73219,
    lng: -77.8954,
    city: "Wallace",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9172,
    density: 19.8,
    county_fips: 37061,
    county_name: "Duplin",
    county_weights: {
      37061: 63.07,
      37141: 36.93,
    },
    county_names_all: "Duplin|Pender",
    county_fips_all: "37061|37141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28467,
    lat: 33.91968,
    lng: -78.58434,
    city: "Calabash",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12115,
    density: 269.3,
    county_fips: 37019,
    county_name: "Brunswick",
    county_weights: {
      37019: 100,
    },
    county_names_all: "Brunswick",
    county_fips_all: 37019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28468,
    lat: 33.90333,
    lng: -78.52295,
    city: "Sunset Beach",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4388,
    density: 88.7,
    county_fips: 37019,
    county_name: "Brunswick",
    county_weights: {
      37019: 100,
    },
    county_names_all: "Brunswick",
    county_fips_all: 37019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28469,
    lat: 33.93271,
    lng: -78.47159,
    city: "Ocean Isle Beach",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6997,
    density: 104.9,
    county_fips: 37019,
    county_name: "Brunswick",
    county_weights: {
      37019: 100,
    },
    county_names_all: "Brunswick",
    county_fips_all: 37019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28470,
    lat: 33.96415,
    lng: -78.3987,
    city: "Shallotte",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12271,
    density: 106,
    county_fips: 37019,
    county_name: "Brunswick",
    county_weights: {
      37019: 100,
    },
    county_names_all: "Brunswick",
    county_fips_all: 37019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28472,
    lat: 34.29707,
    lng: -78.68452,
    city: "Whiteville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18673,
    density: 36.4,
    county_fips: 37047,
    county_name: "Columbus",
    county_weights: {
      37047: 100,
    },
    county_names_all: "Columbus",
    county_fips_all: 37047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28478,
    lat: 34.64217,
    lng: -78.04255,
    city: "Willard",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4803,
    density: 15.1,
    county_fips: 37141,
    county_name: "Pender",
    county_weights: {
      37061: 1.33,
      37141: 91.58,
      37163: 7.09,
    },
    county_names_all: "Pender|Sampson|Duplin",
    county_fips_all: "37141|37163|37061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28479,
    lat: 34.09488,
    lng: -78.01496,
    city: "Winnabow",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7138,
    density: 29.7,
    county_fips: 37019,
    county_name: "Brunswick",
    county_weights: {
      37019: 100,
    },
    county_names_all: "Brunswick",
    county_fips_all: 37019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28480,
    lat: 34.21679,
    lng: -77.79957,
    city: "Wrightsville Beach",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2592,
    density: 256.7,
    county_fips: 37129,
    county_name: "New Hanover",
    county_weights: {
      37129: 100,
    },
    county_names_all: "New Hanover",
    county_fips_all: 37129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28501,
    lat: 35.23838,
    lng: -77.52658,
    city: "Kinston",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18630,
    density: 72,
    county_fips: 37107,
    county_name: "Lenoir",
    county_weights: {
      37103: 25.28,
      37107: 74.72,
    },
    county_names_all: "Lenoir|Jones",
    county_fips_all: "37107|37103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28504,
    lat: 35.22755,
    lng: -77.63566,
    city: "Kinston",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20665,
    density: 65.9,
    county_fips: 37107,
    county_name: "Lenoir",
    county_weights: {
      37103: 2,
      37107: 98,
    },
    county_names_all: "Lenoir|Jones",
    county_fips_all: "37107|37103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28508,
    lat: 35.09684,
    lng: -77.82789,
    city: "Albertson",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2605,
    density: 27.8,
    county_fips: 37061,
    county_name: "Duplin",
    county_weights: {
      37061: 100,
    },
    county_names_all: "Duplin",
    county_fips_all: 37061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28509,
    lat: 35.14524,
    lng: -76.80662,
    city: "Alliance",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37137,
    county_name: "Pamlico",
    county_weights: {
      37137: 100,
    },
    county_names_all: "Pamlico",
    county_fips_all: 37137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28510,
    lat: 35.00516,
    lng: -76.81171,
    city: "Arapahoe",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1395,
    density: 26.1,
    county_fips: 37137,
    county_name: "Pamlico",
    county_weights: {
      37137: 100,
    },
    county_names_all: "Pamlico",
    county_fips_all: 37137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28511,
    lat: 34.89959,
    lng: -76.35195,
    city: "Atlantic",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 665,
    density: 31.4,
    county_fips: 37031,
    county_name: "Carteret",
    county_weights: {
      37031: 100,
    },
    county_names_all: "Carteret",
    county_fips_all: 37031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28512,
    lat: 34.69857,
    lng: -76.77505,
    city: "Atlantic Beach",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3305,
    density: 208.7,
    county_fips: 37031,
    county_name: "Carteret",
    county_weights: {
      37031: 100,
    },
    county_names_all: "Carteret",
    county_fips_all: 37031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28513,
    lat: 35.44276,
    lng: -77.3897,
    city: "Ayden",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9913,
    density: 43,
    county_fips: 37147,
    county_name: "Pitt",
    county_weights: {
      37079: 12.98,
      37147: 87.02,
    },
    county_names_all: "Pitt|Greene",
    county_fips_all: "37147|37079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28515,
    lat: 35.19285,
    lng: -76.70263,
    city: "Bayboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2787,
    density: 14,
    county_fips: 37137,
    county_name: "Pamlico",
    county_weights: {
      37137: 100,
    },
    county_names_all: "Pamlico",
    county_fips_all: 37137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28516,
    lat: 34.84827,
    lng: -76.61128,
    city: "Beaufort",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11546,
    density: 35.5,
    county_fips: 37031,
    county_name: "Carteret",
    county_weights: {
      37031: 100,
    },
    county_names_all: "Carteret",
    county_fips_all: 37031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28518,
    lat: 34.89678,
    lng: -77.75569,
    city: "Beulaville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9442,
    density: 38.1,
    county_fips: 37061,
    county_name: "Duplin",
    county_weights: {
      37061: 88.88,
      37133: 11.12,
    },
    county_names_all: "Duplin|Onslow",
    county_fips_all: "37061|37133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28519,
    lat: 35.1268,
    lng: -77.01477,
    city: "Bridgeton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 299,
    density: 88.1,
    county_fips: 37049,
    county_name: "Craven",
    county_weights: {
      37049: 100,
    },
    county_names_all: "Craven",
    county_fips_all: 37049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28520,
    lat: 34.95613,
    lng: -76.44484,
    city: "Cedar Island",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 235,
    density: 1,
    county_fips: 37031,
    county_name: "Carteret",
    county_weights: {
      37031: 100,
    },
    county_names_all: "Carteret",
    county_fips_all: 37031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28521,
    lat: 34.82136,
    lng: -77.73684,
    city: "Chinquapin",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2258,
    density: 21.1,
    county_fips: 37061,
    county_name: "Duplin",
    county_weights: {
      37061: 96.4,
      37133: 3.6,
    },
    county_names_all: "Duplin|Onslow",
    county_fips_all: "37061|37133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28523,
    lat: 35.20662,
    lng: -77.29541,
    city: "Cove City",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2672,
    density: 15.8,
    county_fips: 37049,
    county_name: "Craven",
    county_weights: {
      37049: 100,
    },
    county_names_all: "Craven",
    county_fips_all: 37049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28524,
    lat: 34.78893,
    lng: -76.47452,
    city: "Davis",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 226,
    density: 24,
    county_fips: 37031,
    county_name: "Carteret",
    county_weights: {
      37031: 100,
    },
    county_names_all: "Carteret",
    county_fips_all: 37031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28525,
    lat: 35.1241,
    lng: -77.68987,
    city: "Deep Run",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2504,
    density: 20.4,
    county_fips: 37107,
    county_name: "Lenoir",
    county_weights: {
      37061: 7.57,
      37107: 92.43,
    },
    county_names_all: "Lenoir|Duplin",
    county_fips_all: "37107|37061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28526,
    lat: 35.24439,
    lng: -77.40447,
    city: "Dover",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2588,
    density: 10.4,
    county_fips: 37049,
    county_name: "Craven",
    county_weights: {
      37049: 62.71,
      37103: 31.49,
      37107: 5.8,
    },
    county_names_all: "Craven|Jones|Lenoir",
    county_fips_all: "37049|37103|37107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28527,
    lat: 35.26396,
    lng: -77.01568,
    city: "Ernul",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1032,
    density: 6.2,
    county_fips: 37049,
    county_name: "Craven",
    county_weights: {
      37049: 100,
    },
    county_names_all: "Craven",
    county_fips_all: 37049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28528,
    lat: 34.73695,
    lng: -76.5396,
    city: "Gloucester",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 589,
    density: 81.5,
    county_fips: 37031,
    county_name: "Carteret",
    county_weights: {
      37031: 100,
    },
    county_names_all: "Carteret",
    county_fips_all: 37031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28529,
    lat: 35.12237,
    lng: -76.86848,
    city: "Grantsboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1979,
    density: 13.9,
    county_fips: 37137,
    county_name: "Pamlico",
    county_weights: {
      37137: 100,
    },
    county_names_all: "Pamlico",
    county_fips_all: 37137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28530,
    lat: 35.372,
    lng: -77.41579,
    city: "Grifton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6455,
    density: 33.7,
    county_fips: 37147,
    county_name: "Pitt",
    county_weights: {
      37049: 16.54,
      37079: 8.29,
      37107: 35.71,
      37147: 39.45,
    },
    county_names_all: "Pitt|Lenoir|Craven|Greene",
    county_fips_all: "37147|37107|37049|37079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28531,
    lat: 34.70015,
    lng: -76.56116,
    city: "Harkers Island",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1314,
    density: 226.4,
    county_fips: 37031,
    county_name: "Carteret",
    county_weights: {
      37031: 100,
    },
    county_names_all: "Carteret",
    county_fips_all: 37031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28532,
    lat: 34.88857,
    lng: -76.90872,
    city: "Havelock",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22187,
    density: 51.8,
    county_fips: 37049,
    county_name: "Craven",
    county_weights: {
      37049: 100,
    },
    county_names_all: "Craven",
    county_fips_all: 37049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28533,
    lat: 34.90167,
    lng: -76.89955,
    city: "Cherry Point",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3463,
    density: 1912.6,
    county_fips: 37049,
    county_name: "Craven",
    county_weights: {
      37049: 100,
    },
    county_names_all: "Craven",
    county_fips_all: 37049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28537,
    lat: 35.25558,
    lng: -76.55912,
    city: "Hobucken",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 76,
    density: 2.5,
    county_fips: 37137,
    county_name: "Pamlico",
    county_weights: {
      37137: 100,
    },
    county_names_all: "Pamlico",
    county_fips_all: 37137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28538,
    lat: 35.41769,
    lng: -77.56366,
    city: "Hookerton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2135,
    density: 29.3,
    county_fips: 37079,
    county_name: "Greene",
    county_weights: {
      37079: 82.31,
      37107: 17.69,
    },
    county_names_all: "Greene|Lenoir",
    county_fips_all: "37079|37107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28539,
    lat: 34.6891,
    lng: -77.23615,
    city: "Hubert",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16365,
    density: 82,
    county_fips: 37133,
    county_name: "Onslow",
    county_weights: {
      37133: 100,
    },
    county_names_all: "Onslow",
    county_fips_all: 37133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28540,
    lat: 34.74361,
    lng: -77.49833,
    city: "Jacksonville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49417,
    density: 173,
    county_fips: 37133,
    county_name: "Onslow",
    county_weights: {
      37133: 100,
    },
    county_names_all: "Onslow",
    county_fips_all: 37133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28542,
    lat: 34.72992,
    lng: -77.46198,
    city: "Camp Lejeune",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37133,
    county_name: "Onslow",
    county_weights: {
      37133: 100,
    },
    county_names_all: "Onslow",
    county_fips_all: 37133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28543,
    lat: 34.73263,
    lng: -77.39825,
    city: "Tarawa Terrace",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4763,
    density: 401.7,
    county_fips: 37133,
    county_name: "Onslow",
    county_weights: {
      37133: 100,
    },
    county_names_all: "Onslow",
    county_fips_all: 37133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28544,
    lat: 34.70853,
    lng: -77.31562,
    city: "Midway Park",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6187,
    density: 224.9,
    county_fips: 37133,
    county_name: "Onslow",
    county_weights: {
      37133: 100,
    },
    county_names_all: "Onslow",
    county_fips_all: 37133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28546,
    lat: 34.83461,
    lng: -77.38818,
    city: "Jacksonville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47681,
    density: 177.1,
    county_fips: 37133,
    county_name: "Onslow",
    county_weights: {
      37133: 100,
    },
    county_names_all: "Onslow",
    county_fips_all: 37133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28547,
    lat: 34.62518,
    lng: -77.36307,
    city: "Camp Lejeune",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26214,
    density: 140.2,
    county_fips: 37133,
    county_name: "Onslow",
    county_weights: {
      37133: 100,
    },
    county_names_all: "Onslow",
    county_fips_all: 37133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28551,
    lat: 35.32204,
    lng: -77.78087,
    city: "La Grange",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14248,
    density: 41.5,
    county_fips: 37107,
    county_name: "Lenoir",
    county_weights: {
      37079: 15.11,
      37107: 57.94,
      37191: 26.95,
    },
    county_names_all: "Lenoir|Wayne|Greene",
    county_fips_all: "37107|37191|37079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28552,
    lat: 35.29281,
    lng: -76.54382,
    city: "Lowland",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 291,
    density: 5.1,
    county_fips: 37137,
    county_name: "Pamlico",
    county_weights: {
      37137: 100,
    },
    county_names_all: "Pamlico",
    county_fips_all: 37137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28553,
    lat: 34.73217,
    lng: -76.51335,
    city: "Marshallberg",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 427,
    density: 148.7,
    county_fips: 37031,
    county_name: "Carteret",
    county_weights: {
      37031: 100,
    },
    county_names_all: "Carteret",
    county_fips_all: 37031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28554,
    lat: 35.47569,
    lng: -77.5926,
    city: "Maury",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 148,
    density: 118.1,
    county_fips: 37079,
    county_name: "Greene",
    county_weights: {
      37079: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 37079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28555,
    lat: 34.86982,
    lng: -77.24543,
    city: "Maysville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5169,
    density: 14.1,
    county_fips: 37133,
    county_name: "Onslow",
    county_weights: {
      37103: 49.1,
      37133: 50.9,
    },
    county_names_all: "Onslow|Jones",
    county_fips_all: "37133|37103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28556,
    lat: 35.12233,
    lng: -76.66904,
    city: "Merritt",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 982,
    density: 7.4,
    county_fips: 37137,
    county_name: "Pamlico",
    county_weights: {
      37137: 100,
    },
    county_names_all: "Pamlico",
    county_fips_all: 37137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28557,
    lat: 34.74064,
    lng: -76.74566,
    city: "Morehead City",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15147,
    density: 412.2,
    county_fips: 37031,
    county_name: "Carteret",
    county_weights: {
      37031: 100,
    },
    county_names_all: "Carteret",
    county_fips_all: 37031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28560,
    lat: 35.13354,
    lng: -76.97575,
    city: "New Bern",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27928,
    density: 88,
    county_fips: 37049,
    county_name: "Craven",
    county_weights: {
      37049: 63.56,
      37137: 36.44,
    },
    county_names_all: "Craven|Pamlico",
    county_fips_all: "37049|37137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28562,
    lat: 35.08105,
    lng: -77.12486,
    city: "New Bern",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37185,
    density: 94.6,
    county_fips: 37049,
    county_name: "Craven",
    county_weights: {
      37049: 92.23,
      37103: 7.77,
    },
    county_names_all: "Craven|Jones",
    county_fips_all: "37049|37103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28570,
    lat: 34.78123,
    lng: -76.88003,
    city: "Newport",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21139,
    density: 54.9,
    county_fips: 37031,
    county_name: "Carteret",
    county_weights: {
      37031: 100,
    },
    county_names_all: "Carteret",
    county_fips_all: 37031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28571,
    lat: 35.05679,
    lng: -76.72311,
    city: "Oriental",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2690,
    density: 20.5,
    county_fips: 37137,
    county_name: "Pamlico",
    county_weights: {
      37137: 100,
    },
    county_names_all: "Pamlico",
    county_fips_all: 37137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28572,
    lat: 35.02256,
    lng: -77.72637,
    city: "Pink Hill",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7418,
    density: 26,
    county_fips: 37061,
    county_name: "Duplin",
    county_weights: {
      37061: 52.5,
      37103: 20.43,
      37107: 26.74,
      37133: 0.33,
    },
    county_names_all: "Duplin|Lenoir|Jones|Onslow",
    county_fips_all: "37061|37107|37103|37133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28573,
    lat: 34.97997,
    lng: -77.19794,
    city: "Pollocksville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1719,
    density: 6.4,
    county_fips: 37103,
    county_name: "Jones",
    county_weights: {
      37049: 1.61,
      37103: 98.39,
    },
    county_names_all: "Jones|Craven",
    county_fips_all: "37103|37049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28574,
    lat: 34.87716,
    lng: -77.59212,
    city: "Richlands",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19020,
    density: 59.2,
    county_fips: 37133,
    county_name: "Onslow",
    county_weights: {
      37061: 4,
      37103: 3.85,
      37133: 92.15,
    },
    county_names_all: "Onslow|Duplin|Jones",
    county_fips_all: "37133|37061|37103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28575,
    lat: 34.68833,
    lng: -76.88129,
    city: "Salter Path",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 451,
    density: 728.9,
    county_fips: 37031,
    county_name: "Carteret",
    county_weights: {
      37031: 100,
    },
    county_names_all: "Carteret",
    county_fips_all: 37031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28577,
    lat: 34.91494,
    lng: -76.40769,
    city: "Sealevel",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 313,
    density: 7.1,
    county_fips: 37031,
    county_name: "Carteret",
    county_weights: {
      37031: 100,
    },
    county_names_all: "Carteret",
    county_fips_all: 37031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28578,
    lat: 35.20017,
    lng: -77.86332,
    city: "Seven Springs",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7167,
    density: 42.2,
    county_fips: 37191,
    county_name: "Wayne",
    county_weights: {
      37061: 14.49,
      37107: 27.89,
      37191: 57.62,
    },
    county_names_all: "Wayne|Lenoir|Duplin",
    county_fips_all: "37191|37107|37061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28579,
    lat: 34.80411,
    lng: -76.50422,
    city: "Smyrna",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 683,
    density: 15.1,
    county_fips: 37031,
    county_name: "Carteret",
    county_weights: {
      37031: 100,
    },
    county_names_all: "Carteret",
    county_fips_all: 37031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28580,
    lat: 35.45116,
    lng: -77.68053,
    city: "Snow Hill",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13084,
    density: 46.7,
    county_fips: 37079,
    county_name: "Greene",
    county_weights: {
      37079: 99.63,
      37107: 0.37,
    },
    county_names_all: "Greene|Lenoir",
    county_fips_all: "37079|37107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28581,
    lat: 34.84992,
    lng: -76.43341,
    city: "Stacy",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 279,
    density: 11.8,
    county_fips: 37031,
    county_name: "Carteret",
    county_weights: {
      37031: 100,
    },
    county_names_all: "Carteret",
    county_fips_all: 37031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28582,
    lat: 34.7613,
    lng: -77.14507,
    city: "Stella",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2218,
    density: 62.4,
    county_fips: 37133,
    county_name: "Onslow",
    county_weights: {
      37031: 43.05,
      37133: 56.95,
    },
    county_names_all: "Onslow|Carteret",
    county_fips_all: "37133|37031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28584,
    lat: 34.72632,
    lng: -77.10002,
    city: "Swansboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13768,
    density: 156.7,
    county_fips: 37031,
    county_name: "Carteret",
    county_weights: {
      37031: 70.42,
      37133: 29.58,
    },
    county_names_all: "Carteret|Onslow",
    county_fips_all: "37031|37133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28585,
    lat: 35.05264,
    lng: -77.41497,
    city: "Trenton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3743,
    density: 7.1,
    county_fips: 37103,
    county_name: "Jones",
    county_weights: {
      37103: 100,
    },
    county_names_all: "Jones",
    county_fips_all: 37103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28586,
    lat: 35.31884,
    lng: -77.16602,
    city: "Vanceboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7185,
    density: 21.3,
    county_fips: 37049,
    county_name: "Craven",
    county_weights: {
      37013: 4.81,
      37049: 91.37,
      37147: 3.82,
    },
    county_names_all: "Craven|Beaufort|Pitt",
    county_fips_all: "37049|37013|37147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28587,
    lat: 35.18714,
    lng: -76.66783,
    city: "Vandemere",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 256,
    density: 48.7,
    county_fips: 37137,
    county_name: "Pamlico",
    county_weights: {
      37137: 100,
    },
    county_names_all: "Pamlico",
    county_fips_all: 37137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28589,
    lat: 34.79343,
    lng: -76.49398,
    city: "Williston",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 174,
    density: 97.8,
    county_fips: 37031,
    county_name: "Carteret",
    county_weights: {
      37031: 100,
    },
    county_names_all: "Carteret",
    county_fips_all: 37031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28590,
    lat: 35.52046,
    lng: -77.41651,
    city: "Winterville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25648,
    density: 240.3,
    county_fips: 37147,
    county_name: "Pitt",
    county_weights: {
      37147: 100,
    },
    county_names_all: "Pitt",
    county_fips_all: 37147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28594,
    lat: 34.66486,
    lng: -77.02918,
    city: "Emerald Isle",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3691,
    density: 249.5,
    county_fips: 37031,
    county_name: "Carteret",
    county_weights: {
      37031: 100,
    },
    county_names_all: "Carteret",
    county_fips_all: 37031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28601,
    lat: 35.7729,
    lng: -81.32704,
    city: "Hickory",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50265,
    density: 412.4,
    county_fips: 37035,
    county_name: "Catawba",
    county_weights: {
      37003: 12.99,
      37023: 15.45,
      37027: 8.53,
      37035: 63.03,
    },
    county_names_all: "Catawba|Burke|Alexander|Caldwell",
    county_fips_all: "37035|37023|37003|37027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28602,
    lat: 35.67574,
    lng: -81.38459,
    city: "Hickory",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29467,
    density: 161,
    county_fips: 37035,
    county_name: "Catawba",
    county_weights: {
      37023: 19.09,
      37035: 80.91,
    },
    county_names_all: "Catawba|Burke",
    county_fips_all: "37035|37023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28604,
    lat: 36.17701,
    lng: -81.84745,
    city: "Banner Elk",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7325,
    density: 41.2,
    county_fips: 37189,
    county_name: "Watauga",
    county_weights: {
      37011: 42.34,
      37189: 57.66,
    },
    county_names_all: "Watauga|Avery",
    county_fips_all: "37189|37011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28605,
    lat: 36.13454,
    lng: -81.70218,
    city: "Blowing Rock",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3538,
    density: 41.6,
    county_fips: 37189,
    county_name: "Watauga",
    county_weights: {
      37011: 6.14,
      37027: 22.38,
      37189: 71.48,
    },
    county_names_all: "Watauga|Caldwell|Avery",
    county_fips_all: "37189|37027|37011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28606,
    lat: 36.05346,
    lng: -81.31413,
    city: "Boomer",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1271,
    density: 11.4,
    county_fips: 37193,
    county_name: "Wilkes",
    county_weights: {
      37027: 11,
      37193: 89,
    },
    county_names_all: "Wilkes|Caldwell",
    county_fips_all: "37193|37027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28607,
    lat: 36.21547,
    lng: -81.64427,
    city: "Boone",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36347,
    density: 138,
    county_fips: 37189,
    county_name: "Watauga",
    county_weights: {
      37189: 100,
    },
    county_names_all: "Watauga",
    county_fips_all: 37189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28609,
    lat: 35.67608,
    lng: -81.05314,
    city: "Catawba",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5858,
    density: 49.5,
    county_fips: 37035,
    county_name: "Catawba",
    county_weights: {
      37035: 100,
    },
    county_names_all: "Catawba",
    county_fips_all: 37035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28610,
    lat: 35.73103,
    lng: -81.13837,
    city: "Claremont",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10904,
    density: 105.5,
    county_fips: 37035,
    county_name: "Catawba",
    county_weights: {
      37035: 100,
    },
    county_names_all: "Catawba",
    county_fips_all: 37035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28611,
    lat: 36.00608,
    lng: -81.73699,
    city: "Collettsville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 667,
    density: 3.6,
    county_fips: 37027,
    county_name: "Caldwell",
    county_weights: {
      37011: 19.1,
      37027: 80.9,
    },
    county_names_all: "Caldwell|Avery",
    county_fips_all: "37027|37011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28612,
    lat: 35.6641,
    lng: -81.53619,
    city: "Connelly Springs",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12274,
    density: 59.2,
    county_fips: 37023,
    county_name: "Burke",
    county_weights: {
      37023: 98.37,
      37035: 1.63,
    },
    county_names_all: "Burke|Catawba",
    county_fips_all: "37023|37035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28613,
    lat: 35.73978,
    lng: -81.20897,
    city: "Conover",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22728,
    density: 207.2,
    county_fips: 37035,
    county_name: "Catawba",
    county_weights: {
      37035: 100,
    },
    county_names_all: "Catawba",
    county_fips_all: 37035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28615,
    lat: 36.46407,
    lng: -81.65368,
    city: "Creston",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1699,
    density: 9.3,
    county_fips: 37009,
    county_name: "Ashe",
    county_weights: {
      37009: 100,
    },
    county_names_all: "Ashe",
    county_fips_all: 37009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28616,
    lat: 36.02138,
    lng: -81.93021,
    city: "Crossnore",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 210,
    density: 153.3,
    county_fips: 37011,
    county_name: "Avery",
    county_weights: {
      37011: 100,
    },
    county_names_all: "Avery",
    county_fips_all: 37011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28617,
    lat: 36.48433,
    lng: -81.38264,
    city: "Crumpler",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1526,
    density: 16.8,
    county_fips: 37009,
    county_name: "Ashe",
    county_weights: {
      37009: 100,
    },
    county_names_all: "Ashe",
    county_fips_all: 37009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28618,
    lat: 36.20888,
    lng: -81.51291,
    city: "Deep Gap",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2448,
    density: 25.2,
    county_fips: 37189,
    county_name: "Watauga",
    county_weights: {
      37189: 88.43,
      37193: 11.57,
    },
    county_names_all: "Watauga|Wilkes",
    county_fips_all: "37189|37193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28619,
    lat: 35.76013,
    lng: -81.60674,
    city: "Drexel",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1283,
    density: 1049.5,
    county_fips: 37023,
    county_name: "Burke",
    county_weights: {
      37023: 100,
    },
    county_names_all: "Burke",
    county_fips_all: 37023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28621,
    lat: 36.30863,
    lng: -80.83612,
    city: "Elkin",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9583,
    density: 54.6,
    county_fips: 37171,
    county_name: "Surry",
    county_weights: {
      37171: 68.25,
      37193: 31.75,
    },
    county_names_all: "Surry|Wilkes",
    county_fips_all: "37171|37193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28622,
    lat: 36.19492,
    lng: -81.94899,
    city: "Elk Park",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2131,
    density: 27.7,
    county_fips: 37011,
    county_name: "Avery",
    county_weights: {
      37011: 99.73,
      37189: 0.27,
    },
    county_names_all: "Avery|Watauga",
    county_fips_all: "37011|37189",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28623,
    lat: 36.53088,
    lng: -80.97185,
    city: "Ennice",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1285,
    density: 16.6,
    county_fips: 37005,
    county_name: "Alleghany",
    county_weights: {
      37005: 99.86,
      37171: 0.14,
    },
    county_names_all: "Alleghany|Surry",
    county_fips_all: "37005|37171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28624,
    lat: 36.11971,
    lng: -81.41327,
    city: "Ferguson",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1497,
    density: 9.8,
    county_fips: 37193,
    county_name: "Wilkes",
    county_weights: {
      37027: 0.36,
      37193: 99.64,
    },
    county_names_all: "Wilkes|Caldwell",
    county_fips_all: "37193|37027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28625,
    lat: 35.86487,
    lng: -80.88709,
    city: "Statesville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40127,
    density: 77.7,
    county_fips: 37097,
    county_name: "Iredell",
    county_weights: {
      37003: 1.51,
      37059: 0.43,
      37097: 98.06,
    },
    county_names_all: "Iredell|Alexander|Davie",
    county_fips_all: "37097|37003|37059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28626,
    lat: 36.29256,
    lng: -81.50119,
    city: "Fleetwood",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2994,
    density: 38.9,
    county_fips: 37009,
    county_name: "Ashe",
    county_weights: {
      37009: 100,
    },
    county_names_all: "Ashe",
    county_fips_all: 37009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28627,
    lat: 36.4528,
    lng: -81.01294,
    city: "Glade Valley",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 948,
    density: 14.2,
    county_fips: 37005,
    county_name: "Alleghany",
    county_weights: {
      37005: 100,
    },
    county_names_all: "Alleghany",
    county_fips_all: 37005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28628,
    lat: 35.72914,
    lng: -81.77826,
    city: "Glen Alpine",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 686,
    density: 938,
    county_fips: 37023,
    county_name: "Burke",
    county_weights: {
      37023: 100,
    },
    county_names_all: "Burke",
    county_fips_all: 37023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28629,
    lat: 36.34196,
    lng: -81.36423,
    city: "Glendale Springs",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 37009,
    county_name: "Ashe",
    county_weights: {
      37009: 98.93,
      37193: 1.07,
    },
    county_names_all: "Ashe|Wilkes",
    county_fips_all: "37009|37193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28630,
    lat: 35.82771,
    lng: -81.41998,
    city: "Granite Falls",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19987,
    density: 126.5,
    county_fips: 37027,
    county_name: "Caldwell",
    county_weights: {
      37003: 1.44,
      37027: 98.56,
    },
    county_names_all: "Caldwell|Alexander",
    county_fips_all: "37027|37003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28631,
    lat: 36.55218,
    lng: -81.40994,
    city: "Grassy Creek",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1175,
    density: 19.5,
    county_fips: 37009,
    county_name: "Ashe",
    county_weights: {
      37005: 9.72,
      37009: 90.28,
    },
    county_names_all: "Ashe|Alleghany",
    county_fips_all: "37009|37005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28634,
    lat: 35.97052,
    lng: -80.75528,
    city: "Harmony",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4982,
    density: 30.9,
    county_fips: 37097,
    county_name: "Iredell",
    county_weights: {
      37059: 9.59,
      37097: 89.48,
      37197: 0.93,
    },
    county_names_all: "Iredell|Davie|Yadkin",
    county_fips_all: "37097|37059|37197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28635,
    lat: 36.33297,
    lng: -81.12603,
    city: "Hays",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3612,
    density: 24.6,
    county_fips: 37193,
    county_name: "Wilkes",
    county_weights: {
      37193: 100,
    },
    county_names_all: "Wilkes",
    county_fips_all: 37193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28636,
    lat: 35.94241,
    lng: -81.06589,
    city: "Hiddenite",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4217,
    density: 28.2,
    county_fips: 37003,
    county_name: "Alexander",
    county_weights: {
      37003: 93.44,
      37097: 6.56,
    },
    county_names_all: "Alexander|Iredell",
    county_fips_all: "37003|37097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28637,
    lat: 35.71768,
    lng: -81.41939,
    city: "Hildebran",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1392,
    density: 203.5,
    county_fips: 37023,
    county_name: "Burke",
    county_weights: {
      37023: 100,
    },
    county_names_all: "Burke",
    county_fips_all: 37023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28638,
    lat: 35.84411,
    lng: -81.47701,
    city: "Hudson",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12454,
    density: 240.8,
    county_fips: 37027,
    county_name: "Caldwell",
    county_weights: {
      37027: 100,
    },
    county_names_all: "Caldwell",
    county_fips_all: 37027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28640,
    lat: 36.40385,
    lng: -81.40751,
    city: "Jefferson",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4718,
    density: 49.2,
    county_fips: 37009,
    county_name: "Ashe",
    county_weights: {
      37009: 99.81,
      37193: 0.19,
    },
    county_names_all: "Ashe|Wilkes",
    county_fips_all: "37009|37193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28641,
    lat: 35.97902,
    lng: -81.89684,
    city: "Jonas Ridge",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37023,
    county_name: "Burke",
    county_weights: {
      37023: 100,
    },
    county_names_all: "Burke",
    county_fips_all: 37023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28642,
    lat: 36.22433,
    lng: -80.81628,
    city: "Jonesville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5467,
    density: 65.4,
    county_fips: 37197,
    county_name: "Yadkin",
    county_weights: {
      37193: 11.43,
      37197: 88.57,
    },
    county_names_all: "Yadkin|Wilkes",
    county_fips_all: "37197|37193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28643,
    lat: 36.52982,
    lng: -81.53486,
    city: "Lansing",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4303,
    density: 23.7,
    county_fips: 37009,
    county_name: "Ashe",
    county_weights: {
      37009: 100,
    },
    county_names_all: "Ashe",
    county_fips_all: 37009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28644,
    lat: 36.43134,
    lng: -81.26758,
    city: "Laurel Springs",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1045,
    density: 5.6,
    county_fips: 37005,
    county_name: "Alleghany",
    county_weights: {
      37005: 53.61,
      37009: 45.32,
      37193: 1.07,
    },
    county_names_all: "Alleghany|Ashe|Wilkes",
    county_fips_all: "37005|37009|37193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28645,
    lat: 35.97778,
    lng: -81.54371,
    city: "Lenoir",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46972,
    density: 55.1,
    county_fips: 37027,
    county_name: "Caldwell",
    county_weights: {
      37023: 1.1,
      37027: 95.75,
      37189: 2.43,
      37193: 0.72,
    },
    county_names_all: "Caldwell|Watauga|Burke|Wilkes",
    county_fips_all: "37027|37189|37023|37193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28646,
    lat: 36.08261,
    lng: -81.83811,
    city: "Linville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 393,
    density: 6.5,
    county_fips: 37011,
    county_name: "Avery",
    county_weights: {
      37011: 100,
    },
    county_names_all: "Avery",
    county_fips_all: 37011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28649,
    lat: 36.33198,
    lng: -81.20326,
    city: "McGrady",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1183,
    density: 12.9,
    county_fips: 37193,
    county_name: "Wilkes",
    county_weights: {
      37193: 100,
    },
    county_names_all: "Wilkes",
    county_fips_all: 37193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28650,
    lat: 35.57347,
    lng: -81.15668,
    city: "Maiden",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10652,
    density: 84.6,
    county_fips: 37035,
    county_name: "Catawba",
    county_weights: {
      37035: 81.8,
      37109: 18.2,
    },
    county_names_all: "Catawba|Lincoln",
    county_fips_all: "37035|37109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28651,
    lat: 36.27241,
    lng: -81.28496,
    city: "Millers Creek",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6332,
    density: 29,
    county_fips: 37193,
    county_name: "Wilkes",
    county_weights: {
      37193: 100,
    },
    county_names_all: "Wilkes",
    county_fips_all: 37193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28652,
    lat: 36.08969,
    lng: -81.98656,
    city: "Minneapolis",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37011,
    county_name: "Avery",
    county_weights: {
      37011: 100,
    },
    county_names_all: "Avery",
    county_fips_all: 37011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28653,
    lat: 36.06615,
    lng: -81.90072,
    city: "Montezuma",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37011,
    county_name: "Avery",
    county_weights: {
      37011: 100,
    },
    county_names_all: "Avery",
    county_fips_all: 37011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28654,
    lat: 36.06338,
    lng: -81.15003,
    city: "Moravian Falls",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3116,
    density: 19.6,
    county_fips: 37193,
    county_name: "Wilkes",
    county_weights: {
      37003: 7.52,
      37193: 92.48,
    },
    county_names_all: "Wilkes|Alexander",
    county_fips_all: "37193|37003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28655,
    lat: 35.75578,
    lng: -81.74212,
    city: "Morganton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55375,
    density: 65.8,
    county_fips: 37023,
    county_name: "Burke",
    county_weights: {
      37023: 99.3,
      37027: 0.42,
      37111: 0.28,
    },
    county_names_all: "Burke|Caldwell|McDowell",
    county_fips_all: "37023|37027|37111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28657,
    lat: 36.02833,
    lng: -81.93977,
    city: "Newland",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8680,
    density: 20.9,
    county_fips: 37011,
    county_name: "Avery",
    county_weights: {
      37011: 83.98,
      37023: 15.15,
      37111: 0.87,
    },
    county_names_all: "Avery|Burke|McDowell",
    county_fips_all: "37011|37023|37111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28658,
    lat: 35.63557,
    lng: -81.24222,
    city: "Newton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27818,
    density: 150.6,
    county_fips: 37035,
    county_name: "Catawba",
    county_weights: {
      37035: 100,
    },
    county_names_all: "Catawba",
    county_fips_all: 37035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28659,
    lat: 36.16647,
    lng: -81.07913,
    city: "North Wilkesboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21281,
    density: 81.7,
    county_fips: 37193,
    county_name: "Wilkes",
    county_weights: {
      37193: 100,
    },
    county_names_all: "Wilkes",
    county_fips_all: 37193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28660,
    lat: 35.9689,
    lng: -80.85785,
    city: "Olin",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2109,
    density: 25.5,
    county_fips: 37097,
    county_name: "Iredell",
    county_weights: {
      37097: 100,
    },
    county_names_all: "Iredell",
    county_fips_all: 37097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28662,
    lat: 36.02237,
    lng: -81.89171,
    city: "Pineola",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 193,
    density: 76.4,
    county_fips: 37011,
    county_name: "Avery",
    county_weights: {
      37011: 100,
    },
    county_names_all: "Avery",
    county_fips_all: 37011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28663,
    lat: 36.53477,
    lng: -81.30063,
    city: "Piney Creek",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 662,
    density: 12.4,
    county_fips: 37005,
    county_name: "Alleghany",
    county_weights: {
      37005: 100,
    },
    county_names_all: "Alleghany",
    county_fips_all: 37005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28664,
    lat: 36.04249,
    lng: -82.00596,
    city: "Plumtree",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37011,
    county_name: "Avery",
    county_weights: {
      37011: 100,
    },
    county_names_all: "Avery",
    county_fips_all: 37011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28665,
    lat: 36.20969,
    lng: -81.37392,
    city: "Purlear",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2348,
    density: 14,
    county_fips: 37193,
    county_name: "Wilkes",
    county_weights: {
      37193: 100,
    },
    county_names_all: "Wilkes",
    county_fips_all: 37193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28666,
    lat: 35.71864,
    lng: -81.47057,
    city: "Icard",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 210,
    density: 897.5,
    county_fips: 37023,
    county_name: "Burke",
    county_weights: {
      37023: 100,
    },
    county_names_all: "Burke",
    county_fips_all: 37023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28667,
    lat: 35.77423,
    lng: -81.42793,
    city: "Rhodhiss",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 363,
    density: 298.5,
    county_fips: 37027,
    county_name: "Caldwell",
    county_weights: {
      37023: 14.03,
      37027: 85.97,
    },
    county_names_all: "Caldwell|Burke",
    county_fips_all: "37027|37023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28668,
    lat: 36.40698,
    lng: -80.99024,
    city: "Roaring Gap",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 341,
    density: 11.3,
    county_fips: 37005,
    county_name: "Alleghany",
    county_weights: {
      37005: 100,
    },
    county_names_all: "Alleghany",
    county_fips_all: 37005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28669,
    lat: 36.22538,
    lng: -80.99443,
    city: "Roaring River",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2849,
    density: 22.9,
    county_fips: 37193,
    county_name: "Wilkes",
    county_weights: {
      37193: 100,
    },
    county_names_all: "Wilkes",
    county_fips_all: 37193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28670,
    lat: 36.19508,
    lng: -80.92282,
    city: "Ronda",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3284,
    density: 33.3,
    county_fips: 37193,
    county_name: "Wilkes",
    county_weights: {
      37193: 100,
    },
    county_names_all: "Wilkes",
    county_fips_all: 37193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28671,
    lat: 35.7502,
    lng: -81.52668,
    city: "Rutherford College",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 313,
    density: 293.3,
    county_fips: 37023,
    county_name: "Burke",
    county_weights: {
      37023: 100,
    },
    county_names_all: "Burke",
    county_fips_all: 37023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28672,
    lat: 36.48381,
    lng: -81.32735,
    city: "Scottville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 155,
    density: 32.7,
    county_fips: 37009,
    county_name: "Ashe",
    county_weights: {
      37005: 0.2,
      37009: 99.8,
    },
    county_names_all: "Ashe|Alleghany",
    county_fips_all: "37009|37005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28673,
    lat: 35.60704,
    lng: -80.99817,
    city: "Sherrills Ford",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6573,
    density: 107.1,
    county_fips: 37035,
    county_name: "Catawba",
    county_weights: {
      37035: 99.53,
      37109: 0.47,
    },
    county_names_all: "Catawba|Lincoln",
    county_fips_all: "37035|37109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28675,
    lat: 36.50642,
    lng: -81.13546,
    city: "Sparta",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7134,
    density: 25.7,
    county_fips: 37005,
    county_name: "Alleghany",
    county_weights: {
      37005: 99.11,
      37193: 0.19,
      51077: 0.7,
    },
    county_names_all: "Alleghany|Grayson|Wilkes",
    county_fips_all: "37005|51077|37193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28676,
    lat: 36.3283,
    lng: -80.85722,
    city: "State Road",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3456,
    density: 47.4,
    county_fips: 37171,
    county_name: "Surry",
    county_weights: {
      37171: 76.22,
      37193: 23.78,
    },
    county_names_all: "Surry|Wilkes",
    county_fips_all: "37171|37193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28677,
    lat: 35.73743,
    lng: -80.92272,
    city: "Statesville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34710,
    density: 161.5,
    county_fips: 37097,
    county_name: "Iredell",
    county_weights: {
      37097: 100,
    },
    county_names_all: "Iredell",
    county_fips_all: 37097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28678,
    lat: 35.83586,
    lng: -81.06151,
    city: "Stony Point",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5804,
    density: 52.1,
    county_fips: 37097,
    county_name: "Iredell",
    county_weights: {
      37003: 46.17,
      37097: 53.83,
    },
    county_names_all: "Iredell|Alexander",
    county_fips_all: "37097|37003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28679,
    lat: 36.25962,
    lng: -81.84207,
    city: "Sugar Grove",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2438,
    density: 36.7,
    county_fips: 37189,
    county_name: "Watauga",
    county_weights: {
      37011: 3.94,
      37189: 96.06,
    },
    county_names_all: "Watauga|Avery",
    county_fips_all: "37189|37011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28681,
    lat: 35.92185,
    lng: -81.22151,
    city: "Taylorsville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27820,
    density: 64.1,
    county_fips: 37003,
    county_name: "Alexander",
    county_weights: {
      37003: 100,
    },
    county_names_all: "Alexander",
    county_fips_all: 37003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28682,
    lat: 35.5838,
    lng: -80.96369,
    city: "Terrell",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1311,
    density: 132.3,
    county_fips: 37035,
    county_name: "Catawba",
    county_weights: {
      37035: 100,
    },
    county_names_all: "Catawba",
    county_fips_all: 37035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28683,
    lat: 36.38835,
    lng: -80.91219,
    city: "Thurmond",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1177,
    density: 13.2,
    county_fips: 37171,
    county_name: "Surry",
    county_weights: {
      37171: 72.98,
      37193: 27.02,
    },
    county_names_all: "Surry|Wilkes",
    county_fips_all: "37171|37193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28684,
    lat: 36.33541,
    lng: -81.6163,
    city: "Todd",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1989,
    density: 15.3,
    county_fips: 37009,
    county_name: "Ashe",
    county_weights: {
      37009: 55.96,
      37189: 44.04,
    },
    county_names_all: "Ashe|Watauga",
    county_fips_all: "37009|37189",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28685,
    lat: 36.34729,
    lng: -81.04097,
    city: "Traphill",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2059,
    density: 16.9,
    county_fips: 37193,
    county_name: "Wilkes",
    county_weights: {
      37193: 100,
    },
    county_names_all: "Wilkes",
    county_fips_all: 37193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28689,
    lat: 36.04319,
    lng: -80.93345,
    city: "Union Grove",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2955,
    density: 25.2,
    county_fips: 37097,
    county_name: "Iredell",
    county_weights: {
      37003: 8.59,
      37097: 64.25,
      37193: 17.08,
      37197: 10.08,
    },
    county_names_all: "Iredell|Wilkes|Yadkin|Alexander",
    county_fips_all: "37097|37193|37197|37003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28690,
    lat: 35.73237,
    lng: -81.5739,
    city: "Valdese",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9696,
    density: 173.8,
    county_fips: 37023,
    county_name: "Burke",
    county_weights: {
      37023: 100,
    },
    county_names_all: "Burke",
    county_fips_all: 37023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28692,
    lat: 36.28023,
    lng: -81.79259,
    city: "Vilas",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4065,
    density: 39.2,
    county_fips: 37189,
    county_name: "Watauga",
    county_weights: {
      37189: 100,
    },
    county_names_all: "Watauga",
    county_fips_all: 37189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28693,
    lat: 36.46622,
    lng: -81.55434,
    city: "Warrensville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1630,
    density: 28.4,
    county_fips: 37009,
    county_name: "Ashe",
    county_weights: {
      37009: 100,
    },
    county_names_all: "Ashe",
    county_fips_all: 37009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28694,
    lat: 36.36197,
    lng: -81.47465,
    city: "West Jefferson",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7305,
    density: 40.3,
    county_fips: 37009,
    county_name: "Ashe",
    county_weights: {
      37009: 100,
    },
    county_names_all: "Ashe",
    county_fips_all: 37009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28697,
    lat: 36.13666,
    lng: -81.16317,
    city: "Wilkesboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14524,
    density: 90,
    county_fips: 37193,
    county_name: "Wilkes",
    county_weights: {
      37193: 100,
    },
    county_names_all: "Wilkes",
    county_fips_all: 37193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28698,
    lat: 36.344,
    lng: -81.73604,
    city: "Zionville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2589,
    density: 38.6,
    county_fips: 37189,
    county_name: "Watauga",
    county_weights: {
      37009: 23.95,
      37189: 76.05,
    },
    county_names_all: "Watauga|Ashe",
    county_fips_all: "37189|37009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28701,
    lat: 35.70558,
    lng: -82.64096,
    city: "Alexander",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5432,
    density: 115.6,
    county_fips: 37021,
    county_name: "Buncombe",
    county_weights: {
      37021: 96.12,
      37115: 3.88,
    },
    county_names_all: "Buncombe|Madison",
    county_fips_all: "37021|37115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28702,
    lat: 35.39346,
    lng: -83.62906,
    city: "Almond",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 427,
    density: 6.8,
    county_fips: 37075,
    county_name: "Graham",
    county_weights: {
      37075: 95.83,
      37173: 4.17,
    },
    county_names_all: "Graham|Swain",
    county_fips_all: "37075|37173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28704,
    lat: 35.46305,
    lng: -82.57142,
    city: "Arden",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20606,
    density: 264.1,
    county_fips: 37021,
    county_name: "Buncombe",
    county_weights: {
      37021: 93.71,
      37089: 6.29,
    },
    county_names_all: "Buncombe|Henderson",
    county_fips_all: "37021|37089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28705,
    lat: 36.04349,
    lng: -82.1573,
    city: "Bakersville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6800,
    density: 21.1,
    county_fips: 37121,
    county_name: "Mitchell",
    county_weights: {
      37121: 99.53,
      37199: 0.47,
    },
    county_names_all: "Mitchell|Yancey",
    county_fips_all: "37121|37199",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28707,
    lat: 35.39873,
    lng: -83.0662,
    city: "Balsam",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 179,
    density: 6.2,
    county_fips: 37099,
    county_name: "Jackson",
    county_weights: {
      37099: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 37099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28708,
    lat: 35.27105,
    lng: -82.85979,
    city: "Balsam Grove",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 152,
    density: 1.2,
    county_fips: 37175,
    county_name: "Transylvania",
    county_weights: {
      37175: 100,
    },
    county_names_all: "Transylvania",
    county_fips_all: 37175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28709,
    lat: 35.76321,
    lng: -82.40428,
    city: "Barnardsville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2650,
    density: 19.9,
    county_fips: 37021,
    county_name: "Buncombe",
    county_weights: {
      37021: 100,
    },
    county_names_all: "Buncombe",
    county_fips_all: 37021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28710,
    lat: 35.45683,
    lng: -82.27971,
    city: "Bat Cave",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37089,
    county_name: "Henderson",
    county_weights: {
      37089: 100,
    },
    county_names_all: "Henderson",
    county_fips_all: 37089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28711,
    lat: 35.59666,
    lng: -82.28767,
    city: "Black Mountain",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13018,
    density: 48.4,
    county_fips: 37021,
    county_name: "Buncombe",
    county_weights: {
      37021: 79.4,
      37089: 0.86,
      37111: 10.65,
      37161: 9.09,
    },
    county_names_all: "Buncombe|McDowell|Rutherford|Henderson",
    county_fips_all: "37021|37111|37161|37089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28712,
    lat: 35.17324,
    lng: -82.76711,
    city: "Brevard",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19842,
    density: 65.9,
    county_fips: 37175,
    county_name: "Transylvania",
    county_weights: {
      37175: 100,
    },
    county_names_all: "Transylvania",
    county_fips_all: 37175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28713,
    lat: 35.3697,
    lng: -83.50559,
    city: "Bryson City",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9094,
    density: 25.2,
    county_fips: 37173,
    county_name: "Swain",
    county_weights: {
      37113: 0.23,
      37173: 99.77,
    },
    county_names_all: "Swain|Macon",
    county_fips_all: "37173|37113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28714,
    lat: 35.87739,
    lng: -82.30714,
    city: "Burnsville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16918,
    density: 25.3,
    county_fips: 37199,
    county_name: "Yancey",
    county_weights: {
      37199: 100,
    },
    county_names_all: "Yancey",
    county_fips_all: 37199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28715,
    lat: 35.51247,
    lng: -82.71196,
    city: "Candler",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26451,
    density: 130.8,
    county_fips: 37021,
    county_name: "Buncombe",
    county_weights: {
      37021: 100,
    },
    county_names_all: "Buncombe",
    county_fips_all: 37021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28716,
    lat: 35.4358,
    lng: -82.86126,
    city: "Canton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18095,
    density: 44,
    county_fips: 37087,
    county_name: "Haywood",
    county_weights: {
      37087: 100,
    },
    county_names_all: "Haywood",
    county_fips_all: 37087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28717,
    lat: 35.07131,
    lng: -83.09458,
    city: "Cashiers",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1933,
    density: 20.5,
    county_fips: 37099,
    county_name: "Jackson",
    county_weights: {
      37099: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 37099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28718,
    lat: 35.16614,
    lng: -82.63108,
    city: "Cedar Mountain",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 468,
    density: 8.9,
    county_fips: 37175,
    county_name: "Transylvania",
    county_weights: {
      37175: 100,
    },
    county_names_all: "Transylvania",
    county_fips_all: 37175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28719,
    lat: 35.53223,
    lng: -83.47056,
    city: "Cherokee",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7404,
    density: 7.2,
    county_fips: 37173,
    county_name: "Swain",
    county_weights: {
      37099: 7.58,
      37173: 92.42,
    },
    county_names_all: "Swain|Jackson",
    county_fips_all: "37173|37099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28720,
    lat: 35.42766,
    lng: -82.25145,
    city: "Chimney Rock",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 174,
    density: 7.2,
    county_fips: 37161,
    county_name: "Rutherford",
    county_weights: {
      37161: 100,
    },
    county_names_all: "Rutherford",
    county_fips_all: 37161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28721,
    lat: 35.63378,
    lng: -82.93081,
    city: "Clyde",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10394,
    density: 42.7,
    county_fips: 37087,
    county_name: "Haywood",
    county_weights: {
      37087: 100,
    },
    county_names_all: "Haywood",
    county_fips_all: 37087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28722,
    lat: 35.23408,
    lng: -82.12794,
    city: "Columbus",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6587,
    density: 58,
    county_fips: 37149,
    county_name: "Polk",
    county_weights: {
      37149: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 37149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28723,
    lat: 35.27776,
    lng: -83.12195,
    city: "Cullowhee",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11164,
    density: 38.5,
    county_fips: 37099,
    county_name: "Jackson",
    county_weights: {
      37099: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 37099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28725,
    lat: 35.37631,
    lng: -83.26411,
    city: "Dillsboro",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23,
    density: 16.7,
    county_fips: 37099,
    county_name: "Jackson",
    county_weights: {
      37099: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 37099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28726,
    lat: 35.282,
    lng: -82.41752,
    city: "East Flat Rock",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3953,
    density: 618.2,
    county_fips: 37089,
    county_name: "Henderson",
    county_weights: {
      37089: 100,
    },
    county_names_all: "Henderson",
    county_fips_all: 37089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28729,
    lat: 35.31961,
    lng: -82.60283,
    city: "Etowah",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3534,
    density: 328.6,
    county_fips: 37089,
    county_name: "Henderson",
    county_weights: {
      37089: 100,
    },
    county_names_all: "Henderson",
    county_fips_all: 37089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28730,
    lat: 35.52792,
    lng: -82.37588,
    city: "Fairview",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9632,
    density: 82,
    county_fips: 37021,
    county_name: "Buncombe",
    county_weights: {
      37021: 100,
    },
    county_names_all: "Buncombe",
    county_fips_all: 37021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28731,
    lat: 35.28905,
    lng: -82.37796,
    city: "Flat Rock",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9079,
    density: 105.9,
    county_fips: 37089,
    county_name: "Henderson",
    county_weights: {
      37089: 80.63,
      37149: 19.37,
    },
    county_names_all: "Henderson|Polk",
    county_fips_all: "37089|37149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28732,
    lat: 35.44667,
    lng: -82.46577,
    city: "Fletcher",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18575,
    density: 173.5,
    county_fips: 37089,
    county_name: "Henderson",
    county_weights: {
      37021: 36.09,
      37089: 63.91,
    },
    county_names_all: "Henderson|Buncombe",
    county_fips_all: "37089|37021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28733,
    lat: 35.43536,
    lng: -83.78403,
    city: "Fontana Dam",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34,
    density: 1.1,
    county_fips: 37075,
    county_name: "Graham",
    county_weights: {
      37075: 100,
    },
    county_names_all: "Graham",
    county_fips_all: 37075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28734,
    lat: 35.1825,
    lng: -83.42599,
    city: "Franklin",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28315,
    density: 36.3,
    county_fips: 37113,
    county_name: "Macon",
    county_weights: {
      37043: 1.28,
      37113: 98.72,
    },
    county_names_all: "Macon|Clay",
    county_fips_all: "37113|37043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28735,
    lat: 35.47544,
    lng: -82.3485,
    city: "Gerton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 258,
    density: 24.6,
    county_fips: 37089,
    county_name: "Henderson",
    county_weights: {
      37089: 100,
    },
    county_names_all: "Henderson",
    county_fips_all: 37089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28736,
    lat: 35.18039,
    lng: -83.0838,
    city: "Glenville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 718,
    density: 7.1,
    county_fips: 37099,
    county_name: "Jackson",
    county_weights: {
      37099: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 37099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28739,
    lat: 35.2719,
    lng: -82.5419,
    city: "Hendersonville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21116,
    density: 133.6,
    county_fips: 37089,
    county_name: "Henderson",
    county_weights: {
      37089: 95.32,
      37175: 4.68,
    },
    county_names_all: "Henderson|Transylvania",
    county_fips_all: "37089|37175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28740,
    lat: 36.04118,
    lng: -82.30287,
    city: "Green Mountain",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 851,
    density: 3.7,
    county_fips: 37199,
    county_name: "Yancey",
    county_weights: {
      37121: 45.45,
      37199: 54.55,
    },
    county_names_all: "Yancey|Mitchell",
    county_fips_all: "37199|37121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28741,
    lat: 35.06614,
    lng: -83.21053,
    city: "Highlands",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3714,
    density: 15.9,
    county_fips: 37113,
    county_name: "Macon",
    county_weights: {
      37099: 12.99,
      37113: 87.01,
    },
    county_names_all: "Macon|Jackson",
    county_fips_all: "37113|37099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28742,
    lat: 35.39486,
    lng: -82.65436,
    city: "Horse Shoe",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3159,
    density: 26.3,
    county_fips: 37089,
    county_name: "Henderson",
    county_weights: {
      37089: 98.76,
      37175: 1.24,
    },
    county_names_all: "Henderson|Transylvania",
    county_fips_all: "37089|37175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28743,
    lat: 35.80869,
    lng: -82.90114,
    city: "Hot Springs",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2375,
    density: 7.5,
    county_fips: 37115,
    county_name: "Madison",
    county_weights: {
      37087: 18.72,
      37115: 81.28,
    },
    county_names_all: "Madison|Haywood",
    county_fips_all: "37115|37087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28745,
    lat: 35.52524,
    lng: -82.97152,
    city: "Lake Junaluska",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 440,
    density: 284.1,
    county_fips: 37087,
    county_name: "Haywood",
    county_weights: {
      37087: 100,
    },
    county_names_all: "Haywood",
    county_fips_all: 37087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28746,
    lat: 35.461,
    lng: -82.16779,
    city: "Lake Lure",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2575,
    density: 22.1,
    county_fips: 37161,
    county_name: "Rutherford",
    county_weights: {
      37161: 100,
    },
    county_names_all: "Rutherford",
    county_fips_all: 37161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28747,
    lat: 35.15185,
    lng: -82.9249,
    city: "Lake Toxaway",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2267,
    density: 18,
    county_fips: 37175,
    county_name: "Transylvania",
    county_weights: {
      37175: 100,
    },
    county_names_all: "Transylvania",
    county_fips_all: 37175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28748,
    lat: 35.65492,
    lng: -82.76032,
    city: "Leicester",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11764,
    density: 49.3,
    county_fips: 37021,
    county_name: "Buncombe",
    county_weights: {
      37021: 89.05,
      37115: 10.95,
    },
    county_names_all: "Buncombe|Madison",
    county_fips_all: "37021|37115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28749,
    lat: 35.84098,
    lng: -82.09797,
    city: "Little Switzerland",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 130,
    density: 43,
    county_fips: 37111,
    county_name: "McDowell",
    county_weights: {
      37111: 72.98,
      37121: 27.02,
    },
    county_names_all: "McDowell|Mitchell",
    county_fips_all: "37111|37121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28751,
    lat: 35.50547,
    lng: -83.11955,
    city: "Maggie Valley",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3812,
    density: 32.2,
    county_fips: 37087,
    county_name: "Haywood",
    county_weights: {
      37087: 78.3,
      37099: 21.7,
    },
    county_names_all: "Haywood|Jackson",
    county_fips_all: "37087|37099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28752,
    lat: 35.71124,
    lng: -82.03631,
    city: "Marion",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31690,
    density: 49.1,
    county_fips: 37111,
    county_name: "McDowell",
    county_weights: {
      37111: 99.85,
      37161: 0.15,
    },
    county_names_all: "McDowell|Rutherford",
    county_fips_all: "37111|37161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28753,
    lat: 35.87181,
    lng: -82.7002,
    city: "Marshall",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9110,
    density: 13.7,
    county_fips: 37115,
    county_name: "Madison",
    county_weights: {
      37021: 2.14,
      37115: 97.86,
    },
    county_names_all: "Madison|Buncombe",
    county_fips_all: "37115|37021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28754,
    lat: 35.87696,
    lng: -82.51441,
    city: "Mars Hill",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10720,
    density: 47.4,
    county_fips: 37115,
    county_name: "Madison",
    county_weights: {
      37115: 94.61,
      37199: 5.39,
    },
    county_names_all: "Madison|Yancey",
    county_fips_all: "37115|37199",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28755,
    lat: 35.90825,
    lng: -82.21756,
    city: "Micaville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37199,
    county_name: "Yancey",
    county_weights: {
      37199: 100,
    },
    county_names_all: "Yancey",
    county_fips_all: 37199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28756,
    lat: 35.34256,
    lng: -82.18219,
    city: "Mill Spring",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3975,
    density: 19.3,
    county_fips: 37149,
    county_name: "Polk",
    county_weights: {
      37149: 98.85,
      37161: 1.15,
    },
    county_names_all: "Polk|Rutherford",
    county_fips_all: "37149|37161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28757,
    lat: 35.64781,
    lng: -82.30006,
    city: "Montreat",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29,
    density: 4.1,
    county_fips: 37021,
    county_name: "Buncombe",
    county_weights: {
      37021: 100,
    },
    county_names_all: "Buncombe",
    county_fips_all: 37021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28758,
    lat: 35.37489,
    lng: -82.49569,
    city: "Mountain Home",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37089,
    county_name: "Henderson",
    county_weights: {
      37089: 100,
    },
    county_names_all: "Henderson",
    county_fips_all: 37089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28759,
    lat: 35.38348,
    lng: -82.58431,
    city: "Mills River",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7671,
    density: 120.9,
    county_fips: 37089,
    county_name: "Henderson",
    county_weights: {
      37021: 1.63,
      37089: 98.37,
    },
    county_names_all: "Henderson|Buncombe",
    county_fips_all: "37089|37021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28761,
    lat: 35.69134,
    lng: -81.90714,
    city: "Nebo",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6742,
    density: 25.1,
    county_fips: 37111,
    county_name: "McDowell",
    county_weights: {
      37023: 30.02,
      37111: 69.98,
    },
    county_names_all: "McDowell|Burke",
    county_fips_all: "37111|37023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28762,
    lat: 35.63517,
    lng: -82.18929,
    city: "Old Fort",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7018,
    density: 28.4,
    county_fips: 37111,
    county_name: "McDowell",
    county_weights: {
      37111: 100,
    },
    county_names_all: "McDowell",
    county_fips_all: 37111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28763,
    lat: 35.03796,
    lng: -83.43215,
    city: "Otto",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2357,
    density: 16.4,
    county_fips: 37113,
    county_name: "Macon",
    county_weights: {
      37113: 100,
    },
    county_names_all: "Macon",
    county_fips_all: 37113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28766,
    lat: 35.24945,
    lng: -82.61923,
    city: "Penrose",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1140,
    density: 73.4,
    county_fips: 37175,
    county_name: "Transylvania",
    county_weights: {
      37089: 12.89,
      37175: 87.11,
    },
    county_names_all: "Transylvania|Henderson",
    county_fips_all: "37175|37089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28768,
    lat: 35.30437,
    lng: -82.70925,
    city: "Pisgah Forest",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7923,
    density: 36.8,
    county_fips: 37175,
    county_name: "Transylvania",
    county_weights: {
      37175: 100,
    },
    county_names_all: "Transylvania",
    county_fips_all: 37175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28770,
    lat: 35.62104,
    lng: -82.2782,
    city: "Ridgecrest",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37021,
    county_name: "Buncombe",
    county_weights: {
      37021: 99.85,
      37111: 0.15,
    },
    county_names_all: "Buncombe|McDowell",
    county_fips_all: "37021|37111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28771,
    lat: 35.34245,
    lng: -83.8567,
    city: "Robbinsville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8113,
    density: 12.1,
    county_fips: 37075,
    county_name: "Graham",
    county_weights: {
      37075: 98.91,
      37173: 1.09,
    },
    county_names_all: "Graham|Swain",
    county_fips_all: "37075|37173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28772,
    lat: 35.13927,
    lng: -82.83709,
    city: "Rosman",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1210,
    density: 24.2,
    county_fips: 37175,
    county_name: "Transylvania",
    county_weights: {
      37175: 100,
    },
    county_names_all: "Transylvania",
    county_fips_all: 37175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28773,
    lat: 35.25246,
    lng: -82.31166,
    city: "Saluda",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3166,
    density: 25.3,
    county_fips: 37149,
    county_name: "Polk",
    county_weights: {
      37089: 26.57,
      37149: 73.43,
    },
    county_names_all: "Polk|Henderson",
    county_fips_all: "37149|37089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28774,
    lat: 35.08976,
    lng: -82.99791,
    city: "Sapphire",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1066,
    density: 7.6,
    county_fips: 37175,
    county_name: "Transylvania",
    county_weights: {
      37099: 38.28,
      37175: 61.72,
    },
    county_names_all: "Transylvania|Jackson",
    county_fips_all: "37175|37099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28775,
    lat: 35.01916,
    lng: -83.32186,
    city: "Scaly Mountain",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 354,
    density: 11.1,
    county_fips: 37113,
    county_name: "Macon",
    county_weights: {
      37113: 100,
    },
    county_names_all: "Macon",
    county_fips_all: 37113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28777,
    lat: 35.90833,
    lng: -82.06617,
    city: "Spruce Pine",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10546,
    density: 56.7,
    county_fips: 37121,
    county_name: "Mitchell",
    county_weights: {
      37011: 15.02,
      37111: 3.34,
      37121: 79.54,
      37199: 2.1,
    },
    county_names_all: "Mitchell|Avery|McDowell|Yancey",
    county_fips_all: "37121|37011|37111|37199",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28778,
    lat: 35.61667,
    lng: -82.40768,
    city: "Swannanoa",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10931,
    density: 129.9,
    county_fips: 37021,
    county_name: "Buncombe",
    county_weights: {
      37021: 100,
    },
    county_names_all: "Buncombe",
    county_fips_all: 37021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28779,
    lat: 35.3558,
    lng: -83.20962,
    city: "Sylva",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19292,
    density: 69,
    county_fips: 37099,
    county_name: "Jackson",
    county_weights: {
      37099: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 37099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28781,
    lat: 35.21417,
    lng: -83.63877,
    city: "Topton",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 745,
    density: 4,
    county_fips: 37113,
    county_name: "Macon",
    county_weights: {
      37113: 100,
    },
    county_names_all: "Macon",
    county_fips_all: 37113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28782,
    lat: 35.23569,
    lng: -82.1519,
    city: "Tryon",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6894,
    density: 54.3,
    county_fips: 37149,
    county_name: "Polk",
    county_weights: {
      37149: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 37149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28783,
    lat: 35.24906,
    lng: -83.02,
    city: "Tuckasegee",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1393,
    density: 7.9,
    county_fips: 37099,
    county_name: "Jackson",
    county_weights: {
      37099: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 37099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28785,
    lat: 35.64632,
    lng: -83.08952,
    city: "Waynesville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7713,
    density: 17.7,
    county_fips: 37087,
    county_name: "Haywood",
    county_weights: {
      37087: 100,
    },
    county_names_all: "Haywood",
    county_fips_all: 37087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28786,
    lat: 35.46272,
    lng: -82.99294,
    city: "Waynesville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21373,
    density: 113.1,
    county_fips: 37087,
    county_name: "Haywood",
    county_weights: {
      37087: 100,
    },
    county_names_all: "Haywood",
    county_fips_all: 37087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28787,
    lat: 35.72795,
    lng: -82.52306,
    city: "Weaverville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21083,
    density: 102.4,
    county_fips: 37021,
    county_name: "Buncombe",
    county_weights: {
      37021: 94.61,
      37115: 5.39,
    },
    county_names_all: "Buncombe|Madison",
    county_fips_all: "37021|37115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28788,
    lat: 35.35044,
    lng: -83.22266,
    city: "Webster",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 37099,
    county_name: "Jackson",
    county_weights: {
      37099: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 37099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28789,
    lat: 35.4077,
    lng: -83.31727,
    city: "Whittier",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5672,
    density: 37.4,
    county_fips: 37099,
    county_name: "Jackson",
    county_weights: {
      37099: 72.45,
      37173: 27.55,
    },
    county_names_all: "Jackson|Swain",
    county_fips_all: "37099|37173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28790,
    lat: 35.20036,
    lng: -82.49507,
    city: "Zirconia",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3581,
    density: 29,
    county_fips: 37089,
    county_name: "Henderson",
    county_weights: {
      37089: 100,
    },
    county_names_all: "Henderson",
    county_fips_all: 37089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28791,
    lat: 35.35674,
    lng: -82.508,
    city: "Hendersonville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14978,
    density: 345.6,
    county_fips: 37089,
    county_name: "Henderson",
    county_weights: {
      37089: 100,
    },
    county_names_all: "Henderson",
    county_fips_all: 37089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28792,
    lat: 35.39289,
    lng: -82.36786,
    city: "Hendersonville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34670,
    density: 130.1,
    county_fips: 37089,
    county_name: "Henderson",
    county_weights: {
      37021: 3.12,
      37089: 96.88,
    },
    county_names_all: "Henderson|Buncombe",
    county_fips_all: "37089|37021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28801,
    lat: 35.59441,
    lng: -82.55785,
    city: "Asheville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13792,
    density: 1042.4,
    county_fips: 37021,
    county_name: "Buncombe",
    county_weights: {
      37021: 100,
    },
    county_names_all: "Buncombe",
    county_fips_all: 37021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28803,
    lat: 35.52949,
    lng: -82.52007,
    city: "Asheville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34126,
    density: 343.4,
    county_fips: 37021,
    county_name: "Buncombe",
    county_weights: {
      37021: 100,
    },
    county_names_all: "Buncombe",
    county_fips_all: 37021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28804,
    lat: 35.64814,
    lng: -82.5612,
    city: "Asheville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22959,
    density: 309.3,
    county_fips: 37021,
    county_name: "Buncombe",
    county_weights: {
      37021: 100,
    },
    county_names_all: "Buncombe",
    county_fips_all: 37021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28805,
    lat: 35.61528,
    lng: -82.47923,
    city: "Asheville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19600,
    density: 285.7,
    county_fips: 37021,
    county_name: "Buncombe",
    county_weights: {
      37021: 100,
    },
    county_names_all: "Buncombe",
    county_fips_all: 37021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28806,
    lat: 35.57154,
    lng: -82.61386,
    city: "Asheville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42901,
    density: 434.3,
    county_fips: 37021,
    county_name: "Buncombe",
    county_weights: {
      37021: 100,
    },
    county_names_all: "Buncombe",
    county_fips_all: 37021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28901,
    lat: 35.20127,
    lng: -83.80506,
    city: "Andrews",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5151,
    density: 28.6,
    county_fips: 37039,
    county_name: "Cherokee",
    county_weights: {
      37039: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 37039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28902,
    lat: 35.02503,
    lng: -83.9571,
    city: "Brasstown",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1262,
    density: 21.6,
    county_fips: 37043,
    county_name: "Clay",
    county_weights: {
      37039: 33.24,
      37043: 66.76,
    },
    county_names_all: "Clay|Cherokee",
    county_fips_all: "37043|37039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28904,
    lat: 35.06185,
    lng: -83.73041,
    city: "Hayesville",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9523,
    density: 19.7,
    county_fips: 37043,
    county_name: "Clay",
    county_weights: {
      37043: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 37043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28905,
    lat: 35.1631,
    lng: -83.9409,
    city: "Marble",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2999,
    density: 25.6,
    county_fips: 37039,
    county_name: "Cherokee",
    county_weights: {
      37039: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 37039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28906,
    lat: 35.11873,
    lng: -84.13343,
    city: "Murphy",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19665,
    density: 22.8,
    county_fips: 37039,
    county_name: "Cherokee",
    county_weights: {
      37039: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 37039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 28909,
    lat: 35.00125,
    lng: -83.90319,
    city: "Warne",
    state_id: "NC",
    state_name: "North Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 836,
    density: 33.9,
    county_fips: 37043,
    county_name: "Clay",
    county_weights: {
      37043: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 37043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29001,
    lat: 33.78528,
    lng: -80.17338,
    city: "Alcolu",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1811,
    density: 10,
    county_fips: 45027,
    county_name: "Clarendon",
    county_weights: {
      45027: 89.1,
      45085: 10.9,
    },
    county_names_all: "Clarendon|Sumter",
    county_fips_all: "45027|45085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29003,
    lat: 33.24135,
    lng: -81.01838,
    city: "Bamberg",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6224,
    density: 17.6,
    county_fips: 45009,
    county_name: "Bamberg",
    county_weights: {
      45009: 100,
    },
    county_names_all: "Bamberg",
    county_fips_all: 45009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29006,
    lat: 33.87673,
    lng: -81.55294,
    city: "Batesburg",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9887,
    density: 27.6,
    county_fips: 45081,
    county_name: "Saluda",
    county_weights: {
      45003: 37.71,
      45063: 21.88,
      45081: 40.41,
    },
    county_names_all: "Saluda|Aiken|Lexington",
    county_fips_all: "45081|45003|45063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29009,
    lat: 34.44097,
    lng: -80.37642,
    city: "Bethune",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1999,
    density: 6.9,
    county_fips: 45055,
    county_name: "Kershaw",
    county_weights: {
      45025: 6.15,
      45055: 91.28,
      45061: 2.57,
    },
    county_names_all: "Kershaw|Chesterfield|Lee",
    county_fips_all: "45055|45025|45061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29010,
    lat: 34.21487,
    lng: -80.26946,
    city: "Bishopville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12017,
    density: 23.3,
    county_fips: 45061,
    county_name: "Lee",
    county_weights: {
      45055: 0.71,
      45061: 99.29,
    },
    county_names_all: "Lee|Kershaw",
    county_fips_all: "45061|45055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29014,
    lat: 34.54368,
    lng: -81.13553,
    city: "Blackstock",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1446,
    density: 3.4,
    county_fips: 45039,
    county_name: "Fairfield",
    county_weights: {
      45023: 41.94,
      45039: 58.06,
    },
    county_names_all: "Fairfield|Chester",
    county_fips_all: "45039|45023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29015,
    lat: 34.4412,
    lng: -81.33807,
    city: "Blair",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1883,
    density: 6.2,
    county_fips: 45039,
    county_name: "Fairfield",
    county_weights: {
      45039: 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: 45039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29016,
    lat: 34.20367,
    lng: -80.99296,
    city: "Blythewood",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24255,
    density: 107.7,
    county_fips: 45079,
    county_name: "Richland",
    county_weights: {
      45039: 9.54,
      45079: 90.46,
    },
    county_names_all: "Richland|Fairfield",
    county_fips_all: "45079|45039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29018,
    lat: 33.34619,
    lng: -80.64373,
    city: "Bowman",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3288,
    density: 12,
    county_fips: 45075,
    county_name: "Orangeburg",
    county_weights: {
      45035: 2.55,
      45075: 97.45,
    },
    county_names_all: "Orangeburg|Dorchester",
    county_fips_all: "45075|45035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29020,
    lat: 34.31036,
    lng: -80.59334,
    city: "Camden",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21443,
    density: 35.6,
    county_fips: 45055,
    county_name: "Kershaw",
    county_weights: {
      45055: 94.16,
      45061: 5.84,
    },
    county_names_all: "Kershaw|Lee",
    county_fips_all: "45055|45061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29030,
    lat: 33.57917,
    lng: -80.65441,
    city: "Cameron",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1772,
    density: 7.2,
    county_fips: 45017,
    county_name: "Calhoun",
    county_weights: {
      45017: 79.51,
      45075: 20.49,
    },
    county_names_all: "Calhoun|Orangeburg",
    county_fips_all: "45017|45075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29031,
    lat: 34.60624,
    lng: -81.42665,
    city: "Carlisle",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1574,
    density: 4.7,
    county_fips: 45023,
    county_name: "Chester",
    county_weights: {
      45023: 50.2,
      45039: 5.69,
      45087: 44.11,
    },
    county_names_all: "Chester|Union|Fairfield",
    county_fips_all: "45023|45087|45039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29032,
    lat: 34.34002,
    lng: -80.44374,
    city: "Cassatt",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5669,
    density: 27.7,
    county_fips: 45055,
    county_name: "Kershaw",
    county_weights: {
      45055: 78.8,
      45061: 21.2,
    },
    county_names_all: "Kershaw|Lee",
    county_fips_all: "45055|45061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29033,
    lat: 33.9552,
    lng: -81.05691,
    city: "Cayce",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12430,
    density: 479,
    county_fips: 45063,
    county_name: "Lexington",
    county_weights: {
      45063: 100,
    },
    county_names_all: "Lexington",
    county_fips_all: 45063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29036,
    lat: 34.13396,
    lng: -81.33622,
    city: "Chapin",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23935,
    density: 167.6,
    county_fips: 45063,
    county_name: "Lexington",
    county_weights: {
      45063: 72.66,
      45071: 3.65,
      45079: 23.69,
    },
    county_names_all: "Lexington|Richland|Newberry",
    county_fips_all: "45063|45079|45071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29037,
    lat: 34.18961,
    lng: -81.86868,
    city: "Chappells",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 842,
    density: 4.7,
    county_fips: 45071,
    county_name: "Newberry",
    county_weights: {
      45059: 4.9,
      45071: 57.22,
      45081: 37.88,
    },
    county_names_all: "Newberry|Saluda|Laurens",
    county_fips_all: "45071|45081|45059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29038,
    lat: 33.37494,
    lng: -80.98095,
    city: "Cope",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2280,
    density: 10.4,
    county_fips: 45075,
    county_name: "Orangeburg",
    county_weights: {
      45075: 100,
    },
    county_names_all: "Orangeburg",
    county_fips_all: 45075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29039,
    lat: 33.41855,
    lng: -80.90556,
    city: "Cordova",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3863,
    density: 62.1,
    county_fips: 45075,
    county_name: "Orangeburg",
    county_weights: {
      45075: 100,
    },
    county_names_all: "Orangeburg",
    county_fips_all: 45075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29040,
    lat: 34.06253,
    lng: -80.43455,
    city: "Dalzell",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10912,
    density: 77.4,
    county_fips: 45085,
    county_name: "Sumter",
    county_weights: {
      45061: 38.54,
      45085: 61.46,
    },
    county_names_all: "Sumter|Lee",
    county_fips_all: "45085|45061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29042,
    lat: 33.30735,
    lng: -81.14723,
    city: "Denmark",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4850,
    density: 30.4,
    county_fips: 45009,
    county_name: "Bamberg",
    county_weights: {
      45009: 100,
    },
    county_names_all: "Bamberg",
    county_fips_all: 45009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29044,
    lat: 33.93437,
    lng: -80.69446,
    city: "Eastover",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5772,
    density: 16.3,
    county_fips: 45079,
    county_name: "Richland",
    county_weights: {
      45079: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 45079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29045,
    lat: 34.18389,
    lng: -80.8141,
    city: "Elgin",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27751,
    density: 157.8,
    county_fips: 45055,
    county_name: "Kershaw",
    county_weights: {
      45039: 1.94,
      45055: 64.46,
      45079: 33.6,
    },
    county_names_all: "Kershaw|Richland|Fairfield",
    county_fips_all: "45055|45079|45039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29046,
    lat: 34.11252,
    lng: -80.16131,
    city: "Elliott",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 130,
    density: 127.1,
    county_fips: 45061,
    county_name: "Lee",
    county_weights: {
      45061: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 45061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29047,
    lat: 33.53218,
    lng: -80.57956,
    city: "Elloree",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3635,
    density: 21.8,
    county_fips: 45017,
    county_name: "Calhoun",
    county_weights: {
      45017: 51.15,
      45075: 48.85,
    },
    county_names_all: "Calhoun|Orangeburg",
    county_fips_all: "45017|45075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29048,
    lat: 33.39057,
    lng: -80.29702,
    city: "Eutawville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5406,
    density: 46.6,
    county_fips: 45075,
    county_name: "Orangeburg",
    county_weights: {
      45075: 100,
    },
    county_names_all: "Orangeburg",
    county_fips_all: 45075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29051,
    lat: 33.8669,
    lng: -80.12231,
    city: "Gable",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1720,
    density: 16.2,
    county_fips: 45027,
    county_name: "Clarendon",
    county_weights: {
      45027: 52.99,
      45085: 47.01,
    },
    county_names_all: "Clarendon|Sumter",
    county_fips_all: "45027|45085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29052,
    lat: 33.81036,
    lng: -80.73832,
    city: "Gadsden",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1634,
    density: 10.5,
    county_fips: 45079,
    county_name: "Richland",
    county_weights: {
      45079: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 45079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29053,
    lat: 33.82734,
    lng: -81.08646,
    city: "Gaston",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20028,
    density: 96.2,
    county_fips: 45063,
    county_name: "Lexington",
    county_weights: {
      45017: 29.01,
      45063: 70.99,
    },
    county_names_all: "Lexington|Calhoun",
    county_fips_all: "45063|45017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29054,
    lat: 33.94834,
    lng: -81.37875,
    city: "Gilbert",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9179,
    density: 61.8,
    county_fips: 45063,
    county_name: "Lexington",
    county_weights: {
      45063: 100,
    },
    county_names_all: "Lexington",
    county_fips_all: 45063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29055,
    lat: 34.57248,
    lng: -80.91753,
    city: "Great Falls",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3761,
    density: 41.9,
    county_fips: 45023,
    county_name: "Chester",
    county_weights: {
      45023: 68.09,
      45039: 31.91,
    },
    county_names_all: "Chester|Fairfield",
    county_fips_all: "45023|45039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29056,
    lat: 33.60798,
    lng: -79.99473,
    city: "Greeleyville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2150,
    density: 8.1,
    county_fips: 45089,
    county_name: "Williamsburg",
    county_weights: {
      45027: 11.39,
      45089: 88.61,
    },
    county_names_all: "Williamsburg|Clarendon",
    county_fips_all: "45089|45027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29058,
    lat: 34.56297,
    lng: -80.73473,
    city: "Heath Springs",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4726,
    density: 12.6,
    county_fips: 45057,
    county_name: "Lancaster",
    county_weights: {
      45055: 9.95,
      45057: 90.05,
    },
    county_names_all: "Lancaster|Kershaw",
    county_fips_all: "45057|45055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29059,
    lat: 33.32853,
    lng: -80.41891,
    city: "Holly Hill",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5484,
    density: 19.4,
    county_fips: 45075,
    county_name: "Orangeburg",
    county_weights: {
      45015: 4.82,
      45075: 95.18,
    },
    county_names_all: "Orangeburg|Berkeley",
    county_fips_all: "45075|45015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29061,
    lat: 33.89923,
    lng: -80.84955,
    city: "Hopkins",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14295,
    density: 62.5,
    county_fips: 45079,
    county_name: "Richland",
    county_weights: {
      45079: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 45079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29062,
    lat: 33.99818,
    lng: -80.60785,
    city: "Horatio",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 127,
    density: 4,
    county_fips: 45085,
    county_name: "Sumter",
    county_weights: {
      45085: 100,
    },
    county_names_all: "Sumter",
    county_fips_all: 45085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29063,
    lat: 34.13948,
    lng: -81.20457,
    city: "Irmo",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42194,
    density: 406.1,
    county_fips: 45079,
    county_name: "Richland",
    county_weights: {
      45063: 2.81,
      45079: 97.19,
    },
    county_names_all: "Richland|Lexington",
    county_fips_all: "45079|45063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29065,
    lat: 34.29495,
    lng: -81.29239,
    city: "Jenkinsville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 309,
    density: 4.6,
    county_fips: 45039,
    county_name: "Fairfield",
    county_weights: {
      45039: 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: 45039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29067,
    lat: 34.54976,
    lng: -80.53268,
    city: "Kershaw",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11223,
    density: 22.8,
    county_fips: 45057,
    county_name: "Lancaster",
    county_weights: {
      45055: 45.87,
      45057: 54.13,
    },
    county_names_all: "Lancaster|Kershaw",
    county_fips_all: "45057|45055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29069,
    lat: 34.18798,
    lng: -80.09654,
    city: "Lamar",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4681,
    density: 23,
    county_fips: 45031,
    county_name: "Darlington",
    county_weights: {
      45031: 78.46,
      45061: 21.54,
    },
    county_names_all: "Darlington|Lee",
    county_fips_all: "45031|45061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29070,
    lat: 33.91742,
    lng: -81.45517,
    city: "Leesville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17208,
    density: 40.5,
    county_fips: 45063,
    county_name: "Lexington",
    county_weights: {
      45063: 77.95,
      45081: 22.05,
    },
    county_names_all: "Lexington|Saluda",
    county_fips_all: "45063|45081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29072,
    lat: 33.9985,
    lng: -81.27098,
    city: "Lexington",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64143,
    density: 364,
    county_fips: 45063,
    county_name: "Lexington",
    county_weights: {
      45063: 100,
    },
    county_names_all: "Lexington",
    county_fips_all: 45063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29073,
    lat: 33.89299,
    lng: -81.23774,
    city: "Lexington",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47694,
    density: 225,
    county_fips: 45063,
    county_name: "Lexington",
    county_weights: {
      45063: 100,
    },
    county_names_all: "Lexington",
    county_fips_all: 45063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29074,
    lat: 34.4512,
    lng: -80.8144,
    city: "Liberty Hill",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 201,
    density: 3.7,
    county_fips: 45055,
    county_name: "Kershaw",
    county_weights: {
      45055: 100,
    },
    county_names_all: "Kershaw",
    county_fips_all: 45055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29075,
    lat: 34.19985,
    lng: -81.37581,
    city: "Little Mountain",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2819,
    density: 26.3,
    county_fips: 45071,
    county_name: "Newberry",
    county_weights: {
      45063: 6.62,
      45071: 66.45,
      45079: 26.93,
    },
    county_names_all: "Newberry|Richland|Lexington",
    county_fips_all: "45071|45079|45063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29078,
    lat: 34.18162,
    lng: -80.6994,
    city: "Lugoff",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16162,
    density: 49.6,
    county_fips: 45055,
    county_name: "Kershaw",
    county_weights: {
      45055: 88.54,
      45079: 11.46,
    },
    county_names_all: "Kershaw|Richland",
    county_fips_all: "45055|45079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29079,
    lat: 34.289,
    lng: -80.11318,
    city: "Lydia",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10,
    density: 36.2,
    county_fips: 45031,
    county_name: "Darlington",
    county_weights: {
      45031: 100,
    },
    county_names_all: "Darlington",
    county_fips_all: 45031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29080,
    lat: 34.01525,
    lng: -80.08374,
    city: "Lynchburg",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2883,
    density: 8.7,
    county_fips: 45061,
    county_name: "Lee",
    county_weights: {
      45061: 55.63,
      45085: 44.37,
    },
    county_names_all: "Lee|Sumter",
    county_fips_all: "45061|45085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29081,
    lat: 33.09161,
    lng: -81.0426,
    city: "Ehrhardt",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1188,
    density: 5.7,
    county_fips: 45009,
    county_name: "Bamberg",
    county_weights: {
      45009: 85.4,
      45029: 14.6,
    },
    county_names_all: "Bamberg|Colleton",
    county_fips_all: "45009|45029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29082,
    lat: 33.04012,
    lng: -80.93868,
    city: "Lodge",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 515,
    density: 5.3,
    county_fips: 45029,
    county_name: "Colleton",
    county_weights: {
      45009: 3.19,
      45029: 96.81,
    },
    county_names_all: "Colleton|Bamberg",
    county_fips_all: "45029|45009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29101,
    lat: 34.47798,
    lng: -80.24038,
    city: "McBee",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2991,
    density: 9.4,
    county_fips: 45025,
    county_name: "Chesterfield",
    county_weights: {
      45025: 87.28,
      45031: 12.72,
    },
    county_names_all: "Chesterfield|Darlington",
    county_fips_all: "45025|45031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29102,
    lat: 33.6437,
    lng: -80.19225,
    city: "Manning",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17245,
    density: 27.4,
    county_fips: 45027,
    county_name: "Clarendon",
    county_weights: {
      45027: 100,
    },
    county_names_all: "Clarendon",
    county_fips_all: 45027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29104,
    lat: 33.99524,
    lng: -80.21373,
    city: "Mayesville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1452,
    density: 8.5,
    county_fips: 45061,
    county_name: "Lee",
    county_weights: {
      45061: 51.67,
      45085: 48.33,
    },
    county_names_all: "Lee|Sumter",
    county_fips_all: "45061|45085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29105,
    lat: 33.80764,
    lng: -81.59047,
    city: "Monetta",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1274,
    density: 16.1,
    county_fips: 45003,
    county_name: "Aiken",
    county_weights: {
      45003: 76.06,
      45081: 23.94,
    },
    county_names_all: "Aiken|Saluda",
    county_fips_all: "45003|45081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29107,
    lat: 33.52348,
    lng: -81.11856,
    city: "Neeses",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3048,
    density: 16.9,
    county_fips: 45075,
    county_name: "Orangeburg",
    county_weights: {
      45075: 100,
    },
    county_names_all: "Orangeburg",
    county_fips_all: 45075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29108,
    lat: 34.29805,
    lng: -81.62433,
    city: "Newberry",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21235,
    density: 39,
    county_fips: 45071,
    county_name: "Newberry",
    county_weights: {
      45071: 100,
    },
    county_names_all: "Newberry",
    county_fips_all: 45071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29111,
    lat: 33.78648,
    lng: -80.01433,
    city: "New Zion",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1825,
    density: 10.8,
    county_fips: 45027,
    county_name: "Clarendon",
    county_weights: {
      45027: 88.39,
      45089: 11.61,
    },
    county_names_all: "Clarendon|Williamsburg",
    county_fips_all: "45027|45089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29112,
    lat: 33.62662,
    lng: -81.0837,
    city: "North",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3907,
    density: 12.5,
    county_fips: 45075,
    county_name: "Orangeburg",
    county_weights: {
      45017: 9,
      45063: 2.85,
      45075: 88.15,
    },
    county_names_all: "Orangeburg|Calhoun|Lexington",
    county_fips_all: "45075|45017|45063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29113,
    lat: 33.43514,
    lng: -81.13173,
    city: "Norway",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1687,
    density: 15.7,
    county_fips: 45075,
    county_name: "Orangeburg",
    county_weights: {
      45075: 100,
    },
    county_names_all: "Orangeburg",
    county_fips_all: 45075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29114,
    lat: 33.95436,
    lng: -79.93537,
    city: "Olanta",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1840,
    density: 20.6,
    county_fips: 45041,
    county_name: "Florence",
    county_weights: {
      45027: 1.68,
      45041: 58.79,
      45085: 39.53,
    },
    county_names_all: "Florence|Sumter|Clarendon",
    county_fips_all: "45041|45085|45027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29115,
    lat: 33.47673,
    lng: -80.84758,
    city: "Orangeburg",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26893,
    density: 83.3,
    county_fips: 45075,
    county_name: "Orangeburg",
    county_weights: {
      45075: 100,
    },
    county_names_all: "Orangeburg",
    county_fips_all: 45075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29117,
    lat: 33.49828,
    lng: -80.85,
    city: "Orangeburg",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1134,
    density: 4470.9,
    county_fips: 45075,
    county_name: "Orangeburg",
    county_weights: {
      45075: 100,
    },
    county_names_all: "Orangeburg",
    county_fips_all: 45075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29118,
    lat: 33.57056,
    lng: -80.89501,
    city: "Orangeburg",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16771,
    density: 84.5,
    county_fips: 45075,
    county_name: "Orangeburg",
    county_weights: {
      45017: 7.13,
      45075: 92.87,
    },
    county_names_all: "Orangeburg|Calhoun",
    county_fips_all: "45075|45017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29122,
    lat: 34.24015,
    lng: -81.32532,
    city: "Peak",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51,
    density: 45.3,
    county_fips: 45071,
    county_name: "Newberry",
    county_weights: {
      45071: 100,
    },
    county_names_all: "Newberry",
    county_fips_all: 45071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29123,
    lat: 33.76563,
    lng: -81.25844,
    city: "Pelion",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7195,
    density: 40.8,
    county_fips: 45063,
    county_name: "Lexington",
    county_weights: {
      45063: 100,
    },
    county_names_all: "Lexington",
    county_fips_all: 45063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29125,
    lat: 33.70165,
    lng: -80.47434,
    city: "Pinewood",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3017,
    density: 10.1,
    county_fips: 45085,
    county_name: "Sumter",
    county_weights: {
      45027: 46.67,
      45085: 53.33,
    },
    county_names_all: "Sumter|Clarendon",
    county_fips_all: "45085|45027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29126,
    lat: 34.32195,
    lng: -81.41932,
    city: "Pomaria",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2391,
    density: 11.9,
    county_fips: 45071,
    county_name: "Newberry",
    county_weights: {
      45071: 100,
    },
    county_names_all: "Newberry",
    county_fips_all: 45071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29127,
    lat: 34.16568,
    lng: -81.51192,
    city: "Prosperity",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8386,
    density: 32.3,
    county_fips: 45071,
    county_name: "Newberry",
    county_weights: {
      45071: 93.54,
      45081: 6.46,
    },
    county_names_all: "Newberry|Saluda",
    county_fips_all: "45071|45081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29128,
    lat: 34.0963,
    lng: -80.53268,
    city: "Rembert",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4869,
    density: 17.5,
    county_fips: 45085,
    county_name: "Sumter",
    county_weights: {
      45055: 23.99,
      45061: 11.51,
      45085: 64.5,
    },
    county_names_all: "Sumter|Kershaw|Lee",
    county_fips_all: "45085|45055|45061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29129,
    lat: 33.79236,
    lng: -81.66823,
    city: "Ridge Spring",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4492,
    density: 20.8,
    county_fips: 45003,
    county_name: "Aiken",
    county_weights: {
      45003: 55.01,
      45037: 12.18,
      45081: 32.81,
    },
    county_names_all: "Aiken|Saluda|Edgefield",
    county_fips_all: "45003|45081|45037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29130,
    lat: 34.32757,
    lng: -80.89205,
    city: "Ridgeway",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7064,
    density: 18.1,
    county_fips: 45039,
    county_name: "Fairfield",
    county_weights: {
      45039: 83.46,
      45055: 15.41,
      45079: 1.13,
    },
    county_names_all: "Fairfield|Kershaw|Richland",
    county_fips_all: "45039|45055|45079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29133,
    lat: 33.35726,
    lng: -80.80698,
    city: "Rowesville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 919,
    density: 6.2,
    county_fips: 45075,
    county_name: "Orangeburg",
    county_weights: {
      45075: 100,
    },
    county_names_all: "Orangeburg",
    county_fips_all: 45075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29135,
    lat: 33.68834,
    lng: -80.7875,
    city: "Saint Matthews",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8589,
    density: 17.1,
    county_fips: 45017,
    county_name: "Calhoun",
    county_weights: {
      45017: 98.93,
      45075: 1.07,
    },
    county_names_all: "Calhoun|Orangeburg",
    county_fips_all: "45017|45075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29137,
    lat: 33.59626,
    lng: -81.32226,
    city: "Salley",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2062,
    density: 8.5,
    county_fips: 45003,
    county_name: "Aiken",
    county_weights: {
      45003: 82.98,
      45075: 17.02,
    },
    county_names_all: "Aiken|Orangeburg",
    county_fips_all: "45003|45075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29138,
    lat: 34.04491,
    lng: -81.77152,
    city: "Saluda",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11040,
    density: 19.3,
    county_fips: 45081,
    county_name: "Saluda",
    county_weights: {
      45037: 0.43,
      45047: 2.55,
      45081: 97.02,
    },
    county_names_all: "Saluda|Greenwood|Edgefield",
    county_fips_all: "45081|45047|45037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29142,
    lat: 33.46491,
    lng: -80.52329,
    city: "Santee",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5307,
    density: 40.2,
    county_fips: 45075,
    county_name: "Orangeburg",
    county_weights: {
      45075: 100,
    },
    county_names_all: "Orangeburg",
    county_fips_all: 45075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29145,
    lat: 34.21905,
    lng: -81.77453,
    city: "Silverstreet",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 773,
    density: 6.6,
    county_fips: 45071,
    county_name: "Newberry",
    county_weights: {
      45071: 100,
    },
    county_names_all: "Newberry",
    county_fips_all: 45071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29146,
    lat: 33.50816,
    lng: -81.29812,
    city: "Springfield",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1380,
    density: 8.9,
    county_fips: 45075,
    county_name: "Orangeburg",
    county_weights: {
      45003: 33.37,
      45075: 66.63,
    },
    county_names_all: "Orangeburg|Aiken",
    county_fips_all: "45075|45003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29148,
    lat: 33.53731,
    lng: -80.34386,
    city: "Summerton",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6526,
    density: 24.1,
    county_fips: 45027,
    county_name: "Clarendon",
    county_weights: {
      45027: 100,
    },
    county_names_all: "Clarendon",
    county_fips_all: 45027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29150,
    lat: 33.87621,
    lng: -80.35609,
    city: "Sumter",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38203,
    density: 336,
    county_fips: 45085,
    county_name: "Sumter",
    county_weights: {
      45085: 100,
    },
    county_names_all: "Sumter",
    county_fips_all: 45085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29152,
    lat: 33.97517,
    lng: -80.47019,
    city: "Shaw Afb",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2387,
    density: 180.7,
    county_fips: 45085,
    county_name: "Sumter",
    county_weights: {
      45085: 100,
    },
    county_names_all: "Sumter",
    county_fips_all: 45085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29153,
    lat: 33.96515,
    lng: -80.30675,
    city: "Sumter",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15821,
    density: 42.4,
    county_fips: 45085,
    county_name: "Sumter",
    county_weights: {
      45061: 12.73,
      45085: 87.27,
    },
    county_names_all: "Sumter|Lee",
    county_fips_all: "45085|45061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29154,
    lat: 33.88515,
    lng: -80.47547,
    city: "Sumter",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27443,
    density: 99.3,
    county_fips: 45085,
    county_name: "Sumter",
    county_weights: {
      45085: 100,
    },
    county_names_all: "Sumter",
    county_fips_all: 45085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29160,
    lat: 33.74358,
    lng: -81.04188,
    city: "Swansea",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6628,
    density: 21.7,
    county_fips: 45063,
    county_name: "Lexington",
    county_weights: {
      45017: 38.07,
      45063: 61.5,
      45075: 0.43,
    },
    county_names_all: "Lexington|Calhoun|Orangeburg",
    county_fips_all: "45063|45017|45075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29161,
    lat: 34.10532,
    lng: -79.94143,
    city: "Timmonsville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11537,
    density: 32.9,
    county_fips: 45041,
    county_name: "Florence",
    county_weights: {
      45031: 24.26,
      45041: 75.74,
    },
    county_names_all: "Florence|Darlington",
    county_fips_all: "45041|45031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29162,
    lat: 33.88751,
    lng: -80.00865,
    city: "Turbeville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2859,
    density: 32.7,
    county_fips: 45027,
    county_name: "Clarendon",
    county_weights: {
      45027: 96.53,
      45085: 3.47,
    },
    county_names_all: "Clarendon|Sumter",
    county_fips_all: "45027|45085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29163,
    lat: 33.42019,
    lng: -80.43918,
    city: "Vance",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1665,
    density: 20.1,
    county_fips: 45075,
    county_name: "Orangeburg",
    county_weights: {
      45075: 100,
    },
    county_names_all: "Orangeburg",
    county_fips_all: 45075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29164,
    lat: 33.65699,
    lng: -81.42586,
    city: "Wagener",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4979,
    density: 17.9,
    county_fips: 45003,
    county_name: "Aiken",
    county_weights: {
      45003: 100,
    },
    county_names_all: "Aiken",
    county_fips_all: 45003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29166,
    lat: 33.90102,
    lng: -81.71304,
    city: "Ward",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 770,
    density: 9.6,
    county_fips: 45081,
    county_name: "Saluda",
    county_weights: {
      45081: 100,
    },
    county_names_all: "Saluda",
    county_fips_all: 45081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29168,
    lat: 33.84848,
    lng: -80.54483,
    city: "Wedgefield",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4249,
    density: 21,
    county_fips: 45085,
    county_name: "Sumter",
    county_weights: {
      45085: 100,
    },
    county_names_all: "Sumter",
    county_fips_all: 45085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29169,
    lat: 33.9967,
    lng: -81.09676,
    city: "West Columbia",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23100,
    density: 767.6,
    county_fips: 45063,
    county_name: "Lexington",
    county_weights: {
      45063: 100,
    },
    county_names_all: "Lexington",
    county_fips_all: 45063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29170,
    lat: 33.93929,
    lng: -81.14487,
    city: "West Columbia",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21839,
    density: 344.8,
    county_fips: 45063,
    county_name: "Lexington",
    county_weights: {
      45063: 100,
    },
    county_names_all: "Lexington",
    county_fips_all: 45063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29172,
    lat: 33.90603,
    lng: -81.07264,
    city: "West Columbia",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10901,
    density: 176.3,
    county_fips: 45063,
    county_name: "Lexington",
    county_weights: {
      45063: 100,
    },
    county_names_all: "Lexington",
    county_fips_all: 45063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29175,
    lat: 34.44266,
    lng: -80.60666,
    city: "Westville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 456,
    density: 21.6,
    county_fips: 45055,
    county_name: "Kershaw",
    county_weights: {
      45055: 100,
    },
    county_names_all: "Kershaw",
    county_fips_all: 45055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29177,
    lat: 34.1405,
    lng: -81.2675,
    city: "White Rock",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 45079,
    county_name: "Richland",
    county_weights: {
      45079: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 45079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29178,
    lat: 34.4992,
    lng: -81.5961,
    city: "Whitmire",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3485,
    density: 9.3,
    county_fips: 45071,
    county_name: "Newberry",
    county_weights: {
      45059: 12.91,
      45071: 50.49,
      45087: 36.6,
    },
    county_names_all: "Newberry|Union|Laurens",
    county_fips_all: "45071|45087|45059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29180,
    lat: 34.36472,
    lng: -81.09821,
    city: "Winnsboro",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13119,
    density: 16.5,
    county_fips: 45039,
    county_name: "Fairfield",
    county_weights: {
      45039: 95.55,
      45079: 4.45,
    },
    county_names_all: "Fairfield|Richland",
    county_fips_all: "45039|45079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29201,
    lat: 33.98381,
    lng: -81.02829,
    city: "Columbia",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20906,
    density: 700,
    county_fips: 45079,
    county_name: "Richland",
    county_weights: {
      45079: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 45079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29203,
    lat: 34.10198,
    lng: -81.04009,
    city: "Columbia",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40638,
    density: 252,
    county_fips: 45079,
    county_name: "Richland",
    county_weights: {
      45079: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 45079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29204,
    lat: 34.02938,
    lng: -81.00008,
    city: "Columbia",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17755,
    density: 1077,
    county_fips: 45079,
    county_name: "Richland",
    county_weights: {
      45079: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 45079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29205,
    lat: 33.99001,
    lng: -80.99661,
    city: "Columbia",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23970,
    density: 1433.4,
    county_fips: 45079,
    county_name: "Richland",
    county_weights: {
      45079: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 45079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29206,
    lat: 34.02848,
    lng: -80.95828,
    city: "Columbia",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18676,
    density: 835,
    county_fips: 45079,
    county_name: "Richland",
    county_weights: {
      45079: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 45079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29207,
    lat: 34.04306,
    lng: -80.84208,
    city: "Columbia",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12797,
    density: 75.4,
    county_fips: 45079,
    county_name: "Richland",
    county_weights: {
      45079: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 45079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29208,
    lat: 33.99751,
    lng: -81.02681,
    city: "Columbia",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 766,
    density: 2151.4,
    county_fips: 45079,
    county_name: "Richland",
    county_weights: {
      45079: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 45079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29209,
    lat: 33.92442,
    lng: -80.95284,
    city: "Columbia",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35206,
    density: 257.4,
    county_fips: 45079,
    county_name: "Richland",
    county_weights: {
      45079: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 45079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29210,
    lat: 34.04764,
    lng: -81.10697,
    city: "Columbia",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40488,
    density: 932.5,
    county_fips: 45079,
    county_name: "Richland",
    county_weights: {
      45063: 29.44,
      45079: 70.56,
    },
    county_names_all: "Richland|Lexington",
    county_fips_all: "45079|45063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29212,
    lat: 34.0777,
    lng: -81.2022,
    city: "Columbia",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28234,
    density: 510,
    county_fips: 45063,
    county_name: "Lexington",
    county_weights: {
      45063: 77.74,
      45079: 22.26,
    },
    county_names_all: "Lexington|Richland",
    county_fips_all: "45063|45079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29223,
    lat: 34.09243,
    lng: -80.92153,
    city: "Columbia",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52895,
    density: 806.9,
    county_fips: 45079,
    county_name: "Richland",
    county_weights: {
      45079: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 45079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29225,
    lat: 33.99538,
    lng: -81.03006,
    city: "Columbia",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 45079,
    county_name: "Richland",
    county_weights: {
      45079: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 45079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29229,
    lat: 34.14697,
    lng: -80.89316,
    city: "Columbia",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50137,
    density: 1060,
    county_fips: 45079,
    county_name: "Richland",
    county_weights: {
      45079: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 45079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29301,
    lat: 34.93516,
    lng: -82.01301,
    city: "Spartanburg",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35585,
    density: 499,
    county_fips: 45083,
    county_name: "Spartanburg",
    county_weights: {
      45083: 100,
    },
    county_names_all: "Spartanburg",
    county_fips_all: 45083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29302,
    lat: 34.89399,
    lng: -81.84151,
    city: "Spartanburg",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16727,
    density: 127.3,
    county_fips: 45083,
    county_name: "Spartanburg",
    county_weights: {
      45083: 100,
    },
    county_names_all: "Spartanburg",
    county_fips_all: 45083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29303,
    lat: 34.99424,
    lng: -81.96883,
    city: "Spartanburg",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27575,
    density: 328.2,
    county_fips: 45083,
    county_name: "Spartanburg",
    county_weights: {
      45083: 100,
    },
    county_names_all: "Spartanburg",
    county_fips_all: 45083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29306,
    lat: 34.89338,
    lng: -81.92177,
    city: "Spartanburg",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17388,
    density: 344,
    county_fips: 45083,
    county_name: "Spartanburg",
    county_weights: {
      45083: 100,
    },
    county_names_all: "Spartanburg",
    county_fips_all: 45083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29307,
    lat: 34.98381,
    lng: -81.83146,
    city: "Spartanburg",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18583,
    density: 160.4,
    county_fips: 45083,
    county_name: "Spartanburg",
    county_weights: {
      45021: 10.72,
      45083: 89.28,
    },
    county_names_all: "Spartanburg|Cherokee",
    county_fips_all: "45083|45021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29316,
    lat: 35.04179,
    lng: -81.9766,
    city: "Boiling Springs",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27315,
    density: 483.3,
    county_fips: 45083,
    county_name: "Spartanburg",
    county_weights: {
      45083: 100,
    },
    county_names_all: "Spartanburg",
    county_fips_all: 45083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29320,
    lat: 34.95847,
    lng: -81.9922,
    city: "Arcadia",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 459,
    density: 286.9,
    county_fips: 45083,
    county_name: "Spartanburg",
    county_weights: {
      45083: 100,
    },
    county_names_all: "Spartanburg",
    county_fips_all: 45083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29321,
    lat: 34.71975,
    lng: -81.74151,
    city: "Buffalo",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2821,
    density: 27.7,
    county_fips: 45087,
    county_name: "Union",
    county_weights: {
      45087: 100,
    },
    county_names_all: "Union",
    county_fips_all: 45087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29322,
    lat: 35.12254,
    lng: -82.13157,
    city: "Campobello",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9177,
    density: 61.2,
    county_fips: 45083,
    county_name: "Spartanburg",
    county_weights: {
      45045: 2.26,
      45083: 97.74,
    },
    county_names_all: "Spartanburg|Greenville",
    county_fips_all: "45083|45045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29323,
    lat: 35.12911,
    lng: -81.90902,
    city: "Chesnee",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14649,
    density: 79.7,
    county_fips: 45083,
    county_name: "Spartanburg",
    county_weights: {
      45021: 12.84,
      45083: 87.16,
    },
    county_names_all: "Spartanburg|Cherokee",
    county_fips_all: "45083|45021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29324,
    lat: 34.98944,
    lng: -81.82523,
    city: "Clifton",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 264,
    density: 214.4,
    county_fips: 45083,
    county_name: "Spartanburg",
    county_weights: {
      45083: 100,
    },
    county_names_all: "Spartanburg",
    county_fips_all: 45083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29325,
    lat: 34.47682,
    lng: -81.83973,
    city: "Clinton",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14763,
    density: 36.2,
    county_fips: 45059,
    county_name: "Laurens",
    county_weights: {
      45059: 100,
    },
    county_names_all: "Laurens",
    county_fips_all: 45059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29329,
    lat: 34.99262,
    lng: -81.83682,
    city: "Converse",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 214,
    density: 269.3,
    county_fips: 45083,
    county_name: "Spartanburg",
    county_weights: {
      45083: 100,
    },
    county_names_all: "Spartanburg",
    county_fips_all: 45083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29330,
    lat: 35.05362,
    lng: -81.80463,
    city: "Cowpens",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9316,
    density: 100.4,
    county_fips: 45021,
    county_name: "Cherokee",
    county_weights: {
      45021: 52.45,
      45083: 47.55,
    },
    county_names_all: "Cherokee|Spartanburg",
    county_fips_all: "45021|45083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29331,
    lat: 34.64351,
    lng: -81.85836,
    city: "Cross Anchor",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 93,
    density: 49.4,
    county_fips: 45083,
    county_name: "Spartanburg",
    county_weights: {
      45083: 100,
    },
    county_names_all: "Spartanburg",
    county_fips_all: 45083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29332,
    lat: 34.28329,
    lng: -81.97292,
    city: "Cross Hill",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2925,
    density: 24.2,
    county_fips: 45059,
    county_name: "Laurens",
    county_weights: {
      45059: 96.7,
      45071: 3.3,
    },
    county_names_all: "Laurens|Newberry",
    county_fips_all: "45059|45071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29333,
    lat: 34.97092,
    lng: -81.91069,
    city: "Drayton",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 416,
    density: 396.6,
    county_fips: 45083,
    county_name: "Spartanburg",
    county_weights: {
      45083: 100,
    },
    county_names_all: "Spartanburg",
    county_fips_all: 45083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29334,
    lat: 34.90372,
    lng: -82.12526,
    city: "Duncan",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14298,
    density: 240.3,
    county_fips: 45083,
    county_name: "Spartanburg",
    county_weights: {
      45083: 100,
    },
    county_names_all: "Spartanburg",
    county_fips_all: 45083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29335,
    lat: 34.65714,
    lng: -81.90035,
    city: "Enoree",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6028,
    density: 24.3,
    county_fips: 45083,
    county_name: "Spartanburg",
    county_weights: {
      45059: 18.98,
      45083: 66.79,
      45087: 14.23,
    },
    county_names_all: "Spartanburg|Laurens|Union",
    county_fips_all: "45083|45059|45087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29338,
    lat: 35.13444,
    lng: -82.00172,
    city: "Fingerville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31,
    density: 76.6,
    county_fips: 45083,
    county_name: "Spartanburg",
    county_weights: {
      45083: 100,
    },
    county_names_all: "Spartanburg",
    county_fips_all: 45083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29340,
    lat: 34.98225,
    lng: -81.59427,
    city: "Gaffney",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20327,
    density: 48,
    county_fips: 45021,
    county_name: "Cherokee",
    county_weights: {
      45021: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 45021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29341,
    lat: 35.1184,
    lng: -81.71321,
    city: "Gaffney",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21213,
    density: 87.9,
    county_fips: 45021,
    county_name: "Cherokee",
    county_weights: {
      45021: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 45021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29346,
    lat: 34.94524,
    lng: -81.83627,
    city: "Glendale",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 312,
    density: 596.1,
    county_fips: 45083,
    county_name: "Spartanburg",
    county_weights: {
      45083: 100,
    },
    county_names_all: "Spartanburg",
    county_fips_all: 45083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29349,
    lat: 35.07045,
    lng: -82.0688,
    city: "Inman",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33134,
    density: 166.4,
    county_fips: 45083,
    county_name: "Spartanburg",
    county_weights: {
      45083: 100,
    },
    county_names_all: "Spartanburg",
    county_fips_all: 45083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29351,
    lat: 34.42177,
    lng: -81.80967,
    city: "Joanna",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1270,
    density: 103.5,
    county_fips: 45059,
    county_name: "Laurens",
    county_weights: {
      45059: 100,
    },
    county_names_all: "Laurens",
    county_fips_all: 45059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29353,
    lat: 34.83064,
    lng: -81.65636,
    city: "Jonesville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3793,
    density: 16,
    county_fips: 45087,
    county_name: "Union",
    county_weights: {
      45087: 100,
    },
    county_names_all: "Union",
    county_fips_all: 45087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29355,
    lat: 34.37012,
    lng: -81.75894,
    city: "Kinards",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 810,
    density: 3.9,
    county_fips: 45071,
    county_name: "Newberry",
    county_weights: {
      45059: 26.89,
      45071: 73.11,
    },
    county_names_all: "Newberry|Laurens",
    county_fips_all: "45071|45059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29356,
    lat: 35.14411,
    lng: -82.26187,
    city: "Landrum",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7722,
    density: 36.3,
    county_fips: 45045,
    county_name: "Greenville",
    county_weights: {
      45045: 75.99,
      45083: 24.01,
    },
    county_names_all: "Greenville|Spartanburg",
    county_fips_all: "45045|45083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29360,
    lat: 34.49361,
    lng: -82.04884,
    city: "Laurens",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21044,
    density: 54,
    county_fips: 45059,
    county_name: "Laurens",
    county_weights: {
      45059: 100,
    },
    county_names_all: "Laurens",
    county_fips_all: 45059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29364,
    lat: 34.78846,
    lng: -81.46202,
    city: "Lockhart",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 500,
    density: 247.8,
    county_fips: 45087,
    county_name: "Union",
    county_weights: {
      45023: 0.28,
      45087: 99.72,
    },
    county_names_all: "Union|Chester",
    county_fips_all: "45087|45023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29365,
    lat: 34.98079,
    lng: -82.16869,
    city: "Lyman",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11572,
    density: 254.4,
    county_fips: 45083,
    county_name: "Spartanburg",
    county_weights: {
      45083: 100,
    },
    county_names_all: "Spartanburg",
    county_fips_all: 45083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29368,
    lat: 35.08262,
    lng: -81.86281,
    city: "Mayo",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 112,
    density: 146.3,
    county_fips: 45083,
    county_name: "Spartanburg",
    county_weights: {
      45083: 100,
    },
    county_names_all: "Spartanburg",
    county_fips_all: 45083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29369,
    lat: 34.86535,
    lng: -82.02207,
    city: "Moore",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14119,
    density: 194,
    county_fips: 45083,
    county_name: "Spartanburg",
    county_weights: {
      45083: 100,
    },
    county_names_all: "Spartanburg",
    county_fips_all: 45083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29370,
    lat: 34.37315,
    lng: -81.96816,
    city: "Mountville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 673,
    density: 5.6,
    county_fips: 45059,
    county_name: "Laurens",
    county_weights: {
      45059: 100,
    },
    county_names_all: "Laurens",
    county_fips_all: 45059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29372,
    lat: 34.9059,
    lng: -81.70878,
    city: "Pacolet",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4709,
    density: 42.7,
    county_fips: 45021,
    county_name: "Cherokee",
    county_weights: {
      45021: 42.36,
      45083: 31.86,
      45087: 25.78,
    },
    county_names_all: "Cherokee|Spartanburg|Union",
    county_fips_all: "45021|45083|45087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29373,
    lat: 34.92442,
    lng: -81.74276,
    city: "Pacolet Mills",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 355,
    density: 433.7,
    county_fips: 45083,
    county_name: "Spartanburg",
    county_weights: {
      45083: 100,
    },
    county_names_all: "Spartanburg",
    county_fips_all: 45083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29374,
    lat: 34.7861,
    lng: -81.84854,
    city: "Pauline",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3209,
    density: 25.4,
    county_fips: 45083,
    county_name: "Spartanburg",
    county_weights: {
      45083: 90.18,
      45087: 9.82,
    },
    county_names_all: "Spartanburg|Union",
    county_fips_all: "45083|45087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29375,
    lat: 34.86049,
    lng: -82.11386,
    city: "Reidville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 95,
    density: 299,
    county_fips: 45083,
    county_name: "Spartanburg",
    county_weights: {
      45083: 100,
    },
    county_names_all: "Spartanburg",
    county_fips_all: 45083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29376,
    lat: 34.81564,
    lng: -81.94921,
    city: "Roebuck",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7760,
    density: 77.7,
    county_fips: 45083,
    county_name: "Spartanburg",
    county_weights: {
      45083: 100,
    },
    county_names_all: "Spartanburg",
    county_fips_all: 45083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29377,
    lat: 34.93036,
    lng: -82.0971,
    city: "Startex",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 550,
    density: 149.2,
    county_fips: 45083,
    county_name: "Spartanburg",
    county_weights: {
      45083: 100,
    },
    county_names_all: "Spartanburg",
    county_fips_all: 45083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29378,
    lat: 34.96684,
    lng: -81.96857,
    city: "Una",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17,
    density: 62.9,
    county_fips: 45083,
    county_name: "Spartanburg",
    county_weights: {
      45083: 100,
    },
    county_names_all: "Spartanburg",
    county_fips_all: 45083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29379,
    lat: 34.68772,
    lng: -81.60403,
    city: "Union",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17438,
    density: 27.7,
    county_fips: 45087,
    county_name: "Union",
    county_weights: {
      45087: 100,
    },
    county_names_all: "Union",
    county_fips_all: 45087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29384,
    lat: 34.33976,
    lng: -82.0904,
    city: "Waterloo",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3872,
    density: 34.9,
    county_fips: 45059,
    county_name: "Laurens",
    county_weights: {
      45059: 100,
    },
    county_names_all: "Laurens",
    county_fips_all: 45059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29385,
    lat: 34.97623,
    lng: -82.1024,
    city: "Wellford",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8004,
    density: 164.9,
    county_fips: 45083,
    county_name: "Spartanburg",
    county_weights: {
      45083: 100,
    },
    county_names_all: "Spartanburg",
    county_fips_all: 45083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29388,
    lat: 34.76292,
    lng: -82.04299,
    city: "Woodruff",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16000,
    density: 63.5,
    county_fips: 45083,
    county_name: "Spartanburg",
    county_weights: {
      45059: 5.77,
      45083: 94.23,
    },
    county_names_all: "Spartanburg|Laurens",
    county_fips_all: "45083|45059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29401,
    lat: 32.77868,
    lng: -79.9354,
    city: "Charleston",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9360,
    density: 2355.3,
    county_fips: 45019,
    county_name: "Charleston",
    county_weights: {
      45019: 100,
    },
    county_names_all: "Charleston",
    county_fips_all: 45019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29403,
    lat: 32.80347,
    lng: -79.94561,
    city: "Charleston",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22117,
    density: 1582,
    county_fips: 45019,
    county_name: "Charleston",
    county_weights: {
      45019: 100,
    },
    county_names_all: "Charleston",
    county_fips_all: 45019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29404,
    lat: 32.89783,
    lng: -80.05246,
    city: "Charleston Afb",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2150,
    density: 164.3,
    county_fips: 45019,
    county_name: "Charleston",
    county_weights: {
      45019: 100,
    },
    county_names_all: "Charleston",
    county_fips_all: 45019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29405,
    lat: 32.85207,
    lng: -79.97903,
    city: "North Charleston",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29620,
    density: 779,
    county_fips: 45019,
    county_name: "Charleston",
    county_weights: {
      45019: 100,
    },
    county_names_all: "Charleston",
    county_fips_all: 45019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29406,
    lat: 32.93417,
    lng: -80.03083,
    city: "Charleston",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36202,
    density: 911.4,
    county_fips: 45019,
    county_name: "Charleston",
    county_weights: {
      45015: 3.04,
      45019: 96.96,
    },
    county_names_all: "Charleston|Berkeley",
    county_fips_all: "45019|45015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29407,
    lat: 32.79912,
    lng: -79.99872,
    city: "Charleston",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35385,
    density: 889,
    county_fips: 45019,
    county_name: "Charleston",
    county_weights: {
      45019: 100,
    },
    county_names_all: "Charleston",
    county_fips_all: 45019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29409,
    lat: 32.79662,
    lng: -79.96072,
    city: "Charleston",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2500,
    density: 6590.7,
    county_fips: 45019,
    county_name: "Charleston",
    county_weights: {
      45019: 100,
    },
    county_names_all: "Charleston",
    county_fips_all: 45019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29410,
    lat: 32.93258,
    lng: -80.0056,
    city: "Hanahan",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25743,
    density: 951.1,
    county_fips: 45015,
    county_name: "Berkeley",
    county_weights: {
      45015: 100,
    },
    county_names_all: "Berkeley",
    county_fips_all: 45015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29412,
    lat: 32.70979,
    lng: -79.95115,
    city: "Charleston",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41049,
    density: 404.3,
    county_fips: 45019,
    county_name: "Charleston",
    county_weights: {
      45019: 100,
    },
    county_names_all: "Charleston",
    county_fips_all: 45019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29414,
    lat: 32.84479,
    lng: -80.10756,
    city: "Charleston",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39319,
    density: 309.9,
    county_fips: 45019,
    county_name: "Charleston",
    county_weights: {
      45019: 82.35,
      45035: 17.65,
    },
    county_names_all: "Charleston|Dorchester",
    county_fips_all: "45019|45035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29418,
    lat: 32.88896,
    lng: -80.0644,
    city: "North Charleston",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22088,
    density: 644.7,
    county_fips: 45019,
    county_name: "Charleston",
    county_weights: {
      45019: 77.53,
      45035: 22.47,
    },
    county_names_all: "Charleston|Dorchester",
    county_fips_all: "45019|45035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29420,
    lat: 32.93202,
    lng: -80.09938,
    city: "North Charleston",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22878,
    density: 880.7,
    county_fips: 45035,
    county_name: "Dorchester",
    county_weights: {
      45019: 40.13,
      45035: 59.87,
    },
    county_names_all: "Dorchester|Charleston",
    county_fips_all: "45035|45019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29424,
    lat: 32.78494,
    lng: -79.93778,
    city: "Charleston",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 464,
    density: 4704.8,
    county_fips: 45019,
    county_name: "Charleston",
    county_weights: {
      45019: 100,
    },
    county_names_all: "Charleston",
    county_fips_all: 45019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29425,
    lat: 32.78516,
    lng: -79.94828,
    city: "Charleston",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 45019,
    county_name: "Charleston",
    county_weights: {
      45019: 100,
    },
    county_names_all: "Charleston",
    county_fips_all: 45019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29426,
    lat: 32.79275,
    lng: -80.37023,
    city: "Adams Run",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1635,
    density: 8,
    county_fips: 45019,
    county_name: "Charleston",
    county_weights: {
      45019: 83.53,
      45035: 16.47,
    },
    county_names_all: "Charleston|Dorchester",
    county_fips_all: "45019|45035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29429,
    lat: 32.98699,
    lng: -79.68011,
    city: "Awendaw",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4465,
    density: 20.1,
    county_fips: 45019,
    county_name: "Charleston",
    county_weights: {
      45019: 100,
    },
    county_names_all: "Charleston",
    county_fips_all: 45019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29431,
    lat: 33.27708,
    lng: -79.87711,
    city: "Bonneau",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7700,
    density: 35.1,
    county_fips: 45015,
    county_name: "Berkeley",
    county_weights: {
      45015: 100,
    },
    county_names_all: "Berkeley",
    county_fips_all: 45015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29432,
    lat: 33.2294,
    lng: -80.81428,
    city: "Branchville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2816,
    density: 9,
    county_fips: 45075,
    county_name: "Orangeburg",
    county_weights: {
      45009: 32.53,
      45035: 6.98,
      45075: 60.49,
    },
    county_names_all: "Orangeburg|Bamberg|Dorchester",
    county_fips_all: "45075|45009|45035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29434,
    lat: 33.14027,
    lng: -79.8453,
    city: "Cordesville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 542,
    density: 3.9,
    county_fips: 45015,
    county_name: "Berkeley",
    county_weights: {
      45015: 100,
    },
    county_names_all: "Berkeley",
    county_fips_all: 45015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29435,
    lat: 32.9526,
    lng: -80.4672,
    city: "Cottageville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4429,
    density: 22.7,
    county_fips: 45029,
    county_name: "Colleton",
    county_weights: {
      45029: 100,
    },
    county_names_all: "Colleton",
    county_fips_all: 45029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29436,
    lat: 33.31658,
    lng: -80.18457,
    city: "Cross",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4352,
    density: 19.6,
    county_fips: 45015,
    county_name: "Berkeley",
    county_weights: {
      45015: 95.36,
      45075: 4.64,
    },
    county_names_all: "Berkeley|Orangeburg",
    county_fips_all: "45015|45075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29437,
    lat: 33.13673,
    lng: -80.42319,
    city: "Dorchester",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2347,
    density: 10.8,
    county_fips: 45035,
    county_name: "Dorchester",
    county_weights: {
      45035: 100,
    },
    county_names_all: "Dorchester",
    county_fips_all: 45035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29438,
    lat: 32.5722,
    lng: -80.31893,
    city: "Edisto Island",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2638,
    density: 13.6,
    county_fips: 45019,
    county_name: "Charleston",
    county_weights: {
      45019: 91.95,
      45029: 8.05,
    },
    county_names_all: "Charleston|Colleton",
    county_fips_all: "45019|45029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29439,
    lat: 32.66636,
    lng: -79.92902,
    city: "Folly Beach",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2391,
    density: 317.5,
    county_fips: 45019,
    county_name: "Charleston",
    county_weights: {
      45019: 100,
    },
    county_names_all: "Charleston",
    county_fips_all: 45019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29440,
    lat: 33.38229,
    lng: -79.32908,
    city: "Georgetown",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26790,
    density: 19.8,
    county_fips: 45043,
    county_name: "Georgetown",
    county_weights: {
      45043: 99.47,
      45089: 0.53,
    },
    county_names_all: "Georgetown|Williamsburg",
    county_fips_all: "45043|45089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29445,
    lat: 32.9976,
    lng: -79.98757,
    city: "Goose Creek",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59233,
    density: 398.4,
    county_fips: 45015,
    county_name: "Berkeley",
    county_weights: {
      45015: 100,
    },
    county_names_all: "Berkeley",
    county_fips_all: 45015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29446,
    lat: 32.6281,
    lng: -80.54028,
    city: "Green Pond",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 940,
    density: 2.1,
    county_fips: 45029,
    county_name: "Colleton",
    county_weights: {
      45029: 100,
    },
    county_names_all: "Colleton",
    county_fips_all: 45029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29448,
    lat: 33.24062,
    lng: -80.44639,
    city: "Harleyville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1989,
    density: 12.9,
    county_fips: 45035,
    county_name: "Dorchester",
    county_weights: {
      45035: 100,
    },
    county_names_all: "Dorchester",
    county_fips_all: 45035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29449,
    lat: 32.70183,
    lng: -80.28038,
    city: "Hollywood",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8005,
    density: 41,
    county_fips: 45019,
    county_name: "Charleston",
    county_weights: {
      45019: 100,
    },
    county_names_all: "Charleston",
    county_fips_all: 45019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29450,
    lat: 33.08731,
    lng: -79.77164,
    city: "Huger",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2539,
    density: 6,
    county_fips: 45015,
    county_name: "Berkeley",
    county_weights: {
      45015: 94.49,
      45019: 5.51,
    },
    county_names_all: "Berkeley|Charleston",
    county_fips_all: "45015|45019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29451,
    lat: 32.81633,
    lng: -79.75266,
    city: "Isle Of Palms",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4463,
    density: 189,
    county_fips: 45019,
    county_name: "Charleston",
    county_weights: {
      45019: 100,
    },
    county_names_all: "Charleston",
    county_fips_all: 45019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29452,
    lat: 32.6997,
    lng: -80.46998,
    city: "Jacksonboro",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 169,
    density: 1.2,
    county_fips: 45029,
    county_name: "Colleton",
    county_weights: {
      45029: 100,
    },
    county_names_all: "Colleton",
    county_fips_all: 45029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29453,
    lat: 33.21984,
    lng: -79.61269,
    city: "Jamestown",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1183,
    density: 3.8,
    county_fips: 45015,
    county_name: "Berkeley",
    county_weights: {
      45015: 100,
    },
    county_names_all: "Berkeley",
    county_fips_all: 45015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29455,
    lat: 32.68581,
    lng: -80.08604,
    city: "Johns Island",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22492,
    density: 86.6,
    county_fips: 45019,
    county_name: "Charleston",
    county_weights: {
      45019: 100,
    },
    county_names_all: "Charleston",
    county_fips_all: 45019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29456,
    lat: 32.98433,
    lng: -80.11206,
    city: "Ladson",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33408,
    density: 714.1,
    county_fips: 45019,
    county_name: "Charleston",
    county_weights: {
      45015: 28.72,
      45019: 46.11,
      45035: 25.17,
    },
    county_names_all: "Charleston|Berkeley|Dorchester",
    county_fips_all: "45019|45015|45035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29458,
    lat: 33.11922,
    lng: -79.4872,
    city: "McClellanville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2860,
    density: 9.8,
    county_fips: 45019,
    county_name: "Charleston",
    county_weights: {
      45019: 100,
    },
    county_names_all: "Charleston",
    county_fips_all: 45019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29461,
    lat: 33.17009,
    lng: -80.00773,
    city: "Moncks Corner",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40696,
    density: 95.7,
    county_fips: 45015,
    county_name: "Berkeley",
    county_weights: {
      45015: 100,
    },
    county_names_all: "Berkeley",
    county_fips_all: 45015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29464,
    lat: 32.82082,
    lng: -79.85583,
    city: "Mount Pleasant",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53119,
    density: 680.5,
    county_fips: 45019,
    county_name: "Charleston",
    county_weights: {
      45019: 100,
    },
    county_names_all: "Charleston",
    county_fips_all: 45019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29466,
    lat: 32.87486,
    lng: -79.78785,
    city: "Mount Pleasant",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41466,
    density: 548.7,
    county_fips: 45019,
    county_name: "Charleston",
    county_weights: {
      45019: 100,
    },
    county_names_all: "Charleston",
    county_fips_all: 45019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29468,
    lat: 33.42624,
    lng: -80.06856,
    city: "Pineville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2479,
    density: 13,
    county_fips: 45015,
    county_name: "Berkeley",
    county_weights: {
      45015: 100,
    },
    county_names_all: "Berkeley",
    county_fips_all: 45015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29469,
    lat: 33.24366,
    lng: -80.13106,
    city: "Pinopolis",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 817,
    density: 16,
    county_fips: 45015,
    county_name: "Berkeley",
    county_weights: {
      45015: 100,
    },
    county_names_all: "Berkeley",
    county_fips_all: 45015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29470,
    lat: 32.81904,
    lng: -80.23855,
    city: "Ravenel",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4840,
    density: 25.8,
    county_fips: 45019,
    county_name: "Charleston",
    county_weights: {
      45019: 66.26,
      45035: 33.74,
    },
    county_names_all: "Charleston|Dorchester",
    county_fips_all: "45019|45035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29471,
    lat: 33.18714,
    lng: -80.66955,
    city: "Reevesville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1490,
    density: 13.4,
    county_fips: 45035,
    county_name: "Dorchester",
    county_weights: {
      45035: 97.15,
      45075: 2.85,
    },
    county_names_all: "Dorchester|Orangeburg",
    county_fips_all: "45035|45075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29472,
    lat: 33.05379,
    lng: -80.31928,
    city: "Ridgeville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10463,
    density: 21.3,
    county_fips: 45035,
    county_name: "Dorchester",
    county_weights: {
      45015: 32.32,
      45029: 8.05,
      45035: 59.63,
    },
    county_names_all: "Dorchester|Berkeley|Colleton",
    county_fips_all: "45035|45015|45029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29474,
    lat: 32.90833,
    lng: -80.52448,
    city: "Round O",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2210,
    density: 8.5,
    county_fips: 45029,
    county_name: "Colleton",
    county_weights: {
      45029: 100,
    },
    county_names_all: "Colleton",
    county_fips_all: 45029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29475,
    lat: 32.96687,
    lng: -80.8189,
    city: "Ruffin",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2534,
    density: 10,
    county_fips: 45029,
    county_name: "Colleton",
    county_weights: {
      45029: 100,
    },
    county_names_all: "Colleton",
    county_fips_all: 45029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29477,
    lat: 33.16626,
    lng: -80.57176,
    city: "Saint George",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7903,
    density: 27.7,
    county_fips: 45035,
    county_name: "Dorchester",
    county_weights: {
      45035: 99.13,
      45075: 0.87,
    },
    county_names_all: "Dorchester|Orangeburg",
    county_fips_all: "45035|45075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29479,
    lat: 33.3808,
    lng: -79.89499,
    city: "Saint Stephen",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6940,
    density: 29.5,
    county_fips: 45015,
    county_name: "Berkeley",
    county_weights: {
      45015: 100,
    },
    county_names_all: "Berkeley",
    county_fips_all: 45015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29481,
    lat: 33.11382,
    lng: -80.80301,
    city: "Smoaks",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1482,
    density: 6.5,
    county_fips: 45029,
    county_name: "Colleton",
    county_weights: {
      45009: 15.39,
      45029: 84.61,
    },
    county_names_all: "Colleton|Bamberg",
    county_fips_all: "45029|45009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29482,
    lat: 32.76845,
    lng: -79.83556,
    city: "Sullivans Island",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2177,
    density: 336.5,
    county_fips: 45019,
    county_name: "Charleston",
    county_weights: {
      45019: 100,
    },
    county_names_all: "Charleston",
    county_fips_all: 45019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29483,
    lat: 33.03126,
    lng: -80.23205,
    city: "Summerville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 91630,
    density: 663.2,
    county_fips: 45035,
    county_name: "Dorchester",
    county_weights: {
      45015: 16.28,
      45019: 0.31,
      45035: 83.41,
    },
    county_names_all: "Dorchester|Berkeley|Charleston",
    county_fips_all: "45035|45015|45019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29485,
    lat: 32.94398,
    lng: -80.19362,
    city: "Summerville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60383,
    density: 480,
    county_fips: 45035,
    county_name: "Dorchester",
    county_weights: {
      45019: 6.41,
      45035: 93.59,
    },
    county_names_all: "Dorchester|Charleston",
    county_fips_all: "45035|45019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29486,
    lat: 33.10744,
    lng: -80.1458,
    city: "Summerville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 45015,
    county_name: "Berkeley",
    county_weights: {
      45015: 100,
    },
    county_names_all: "Berkeley",
    county_fips_all: 45015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29487,
    lat: 32.65691,
    lng: -80.18476,
    city: "Wadmalaw Island",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2693,
    density: 24.8,
    county_fips: 45019,
    county_name: "Charleston",
    county_weights: {
      45019: 100,
    },
    county_names_all: "Charleston",
    county_fips_all: 45019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29488,
    lat: 32.90664,
    lng: -80.67458,
    city: "Walterboro",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20792,
    density: 33.8,
    county_fips: 45029,
    county_name: "Colleton",
    county_weights: {
      45029: 100,
    },
    county_names_all: "Colleton",
    county_fips_all: 45029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29492,
    lat: 32.91657,
    lng: -79.87818,
    city: "Charleston",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14210,
    density: 104,
    county_fips: 45015,
    county_name: "Berkeley",
    county_weights: {
      45015: 100,
    },
    county_names_all: "Berkeley",
    county_fips_all: 45015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29493,
    lat: 33.04536,
    lng: -80.84276,
    city: "Williams",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 194,
    density: 30.5,
    county_fips: 45029,
    county_name: "Colleton",
    county_weights: {
      45029: 100,
    },
    county_names_all: "Colleton",
    county_fips_all: 45029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29501,
    lat: 34.20414,
    lng: -79.82654,
    city: "Florence",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46306,
    density: 341.3,
    county_fips: 45041,
    county_name: "Florence",
    county_weights: {
      45031: 14.55,
      45041: 85.45,
    },
    county_names_all: "Florence|Darlington",
    county_fips_all: "45041|45031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29505,
    lat: 34.12348,
    lng: -79.68974,
    city: "Florence",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24763,
    density: 188,
    county_fips: 45041,
    county_name: "Florence",
    county_weights: {
      45041: 100,
    },
    county_names_all: "Florence",
    county_fips_all: 45041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29506,
    lat: 34.2103,
    lng: -79.64432,
    city: "Florence",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20304,
    density: 64.9,
    county_fips: 45041,
    county_name: "Florence",
    county_weights: {
      45031: 2.05,
      45041: 97.95,
    },
    county_names_all: "Florence|Darlington",
    county_fips_all: "45041|45031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29510,
    lat: 33.45326,
    lng: -79.61068,
    city: "Andrews",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9467,
    density: 11.7,
    county_fips: 45089,
    county_name: "Williamsburg",
    county_weights: {
      45043: 34.91,
      45089: 65.09,
    },
    county_names_all: "Williamsburg|Georgetown",
    county_fips_all: "45089|45043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29511,
    lat: 33.97519,
    lng: -79.11043,
    city: "Aynor",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5799,
    density: 39.2,
    county_fips: 45051,
    county_name: "Horry",
    county_weights: {
      45051: 100,
    },
    county_names_all: "Horry",
    county_fips_all: 45051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29512,
    lat: 34.62733,
    lng: -79.71091,
    city: "Bennettsville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18233,
    density: 32.5,
    county_fips: 45069,
    county_name: "Marlboro",
    county_weights: {
      45069: 100,
    },
    county_names_all: "Marlboro",
    county_fips_all: 45069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29516,
    lat: 34.44323,
    lng: -79.62414,
    city: "Blenheim",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 929,
    density: 3.5,
    county_fips: 45069,
    county_name: "Marlboro",
    county_weights: {
      45069: 100,
    },
    county_names_all: "Marlboro",
    county_fips_all: 45069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29518,
    lat: 33.7892,
    lng: -79.84851,
    city: "Cades",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 938,
    density: 7.7,
    county_fips: 45089,
    county_name: "Williamsburg",
    county_weights: {
      45027: 0.49,
      45089: 99.51,
    },
    county_names_all: "Williamsburg|Clarendon",
    county_fips_all: "45089|45027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29519,
    lat: 34.01622,
    lng: -79.36048,
    city: "Centenary",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 407,
    density: 35.6,
    county_fips: 45067,
    county_name: "Marion",
    county_weights: {
      45067: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 45067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29520,
    lat: 34.68083,
    lng: -79.92601,
    city: "Cheraw",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13447,
    density: 39.4,
    county_fips: 45025,
    county_name: "Chesterfield",
    county_weights: {
      45025: 99.83,
      45069: 0.17,
    },
    county_names_all: "Chesterfield|Marlboro",
    county_fips_all: "45025|45069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29525,
    lat: 34.5722,
    lng: -79.53327,
    city: "Clio",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1827,
    density: 16.3,
    county_fips: 45069,
    county_name: "Marlboro",
    county_weights: {
      45033: 5.44,
      45069: 94.56,
    },
    county_names_all: "Marlboro|Dillon",
    county_fips_all: "45069|45033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29526,
    lat: 33.86696,
    lng: -78.9718,
    city: "Conway",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50489,
    density: 111.4,
    county_fips: 45051,
    county_name: "Horry",
    county_weights: {
      45051: 100,
    },
    county_names_all: "Horry",
    county_fips_all: 45051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29527,
    lat: 33.78271,
    lng: -79.14715,
    city: "Conway",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26793,
    density: 66.7,
    county_fips: 45051,
    county_name: "Horry",
    county_weights: {
      45051: 100,
    },
    county_names_all: "Horry",
    county_fips_all: 45051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29530,
    lat: 33.98984,
    lng: -79.74222,
    city: "Coward",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2149,
    density: 20.5,
    county_fips: 45041,
    county_name: "Florence",
    county_weights: {
      45041: 100,
    },
    county_names_all: "Florence",
    county_fips_all: 45041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29532,
    lat: 34.28421,
    lng: -79.85119,
    city: "Darlington",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20499,
    density: 68.9,
    county_fips: 45031,
    county_name: "Darlington",
    county_weights: {
      45031: 100,
    },
    county_names_all: "Darlington",
    county_fips_all: 45031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29536,
    lat: 34.41911,
    lng: -79.37241,
    city: "Dillon",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16838,
    density: 50.6,
    county_fips: 45033,
    county_name: "Dillon",
    county_weights: {
      45033: 100,
    },
    county_names_all: "Dillon",
    county_fips_all: 45033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29540,
    lat: 34.38903,
    lng: -79.85028,
    city: "Darlington",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4556,
    density: 16.3,
    county_fips: 45031,
    county_name: "Darlington",
    county_weights: {
      45031: 100,
    },
    county_names_all: "Darlington",
    county_fips_all: 45031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29541,
    lat: 34.0653,
    lng: -79.74087,
    city: "Effingham",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9719,
    density: 47,
    county_fips: 45041,
    county_name: "Florence",
    county_weights: {
      45041: 100,
    },
    county_names_all: "Florence",
    county_fips_all: 45041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29543,
    lat: 34.28759,
    lng: -79.26591,
    city: "Fork",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 674,
    density: 14.1,
    county_fips: 45033,
    county_name: "Dillon",
    county_weights: {
      45033: 100,
    },
    county_names_all: "Dillon",
    county_fips_all: 45033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29544,
    lat: 34.00067,
    lng: -79.21083,
    city: "Galivants Ferry",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5571,
    density: 17.8,
    county_fips: 45051,
    county_name: "Horry",
    county_weights: {
      45051: 100,
    },
    county_names_all: "Horry",
    county_fips_all: 45051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29545,
    lat: 34.16175,
    lng: -78.96635,
    city: "Green Sea",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1958,
    density: 20.7,
    county_fips: 45051,
    county_name: "Horry",
    county_weights: {
      45051: 100,
    },
    county_names_all: "Horry",
    county_fips_all: 45051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29546,
    lat: 33.89001,
    lng: -79.35151,
    city: "Gresham",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2914,
    density: 7.9,
    county_fips: 45067,
    county_name: "Marion",
    county_weights: {
      45067: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 45067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29547,
    lat: 34.48684,
    lng: -79.33243,
    city: "Hamer",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2496,
    density: 24,
    county_fips: 45033,
    county_name: "Dillon",
    county_weights: {
      45033: 100,
    },
    county_names_all: "Dillon",
    county_fips_all: 45033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29550,
    lat: 34.39309,
    lng: -80.07595,
    city: "Hartsville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32083,
    density: 59.5,
    county_fips: 45031,
    county_name: "Darlington",
    county_weights: {
      45025: 16.83,
      45031: 80.94,
      45061: 2.23,
    },
    county_names_all: "Darlington|Chesterfield|Lee",
    county_fips_all: "45031|45025|45061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29554,
    lat: 33.69879,
    lng: -79.38816,
    city: "Hemingway",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9460,
    density: 17.3,
    county_fips: 45043,
    county_name: "Georgetown",
    county_weights: {
      45041: 0.82,
      45043: 51.81,
      45089: 47.37,
    },
    county_names_all: "Georgetown|Williamsburg|Florence",
    county_fips_all: "45043|45089|45041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29555,
    lat: 33.83864,
    lng: -79.46191,
    city: "Johnsonville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6146,
    density: 25,
    county_fips: 45041,
    county_name: "Florence",
    county_weights: {
      45041: 92.46,
      45089: 7.54,
    },
    county_names_all: "Florence|Williamsburg",
    county_fips_all: "45041|45089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29556,
    lat: 33.66849,
    lng: -79.76403,
    city: "Kingstree",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11687,
    density: 26.1,
    county_fips: 45089,
    county_name: "Williamsburg",
    county_weights: {
      45089: 100,
    },
    county_names_all: "Williamsburg",
    county_fips_all: 45089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29560,
    lat: 33.83535,
    lng: -79.74747,
    city: "Lake City",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13557,
    density: 31.7,
    county_fips: 45041,
    county_name: "Florence",
    county_weights: {
      45027: 9.89,
      45041: 48.1,
      45089: 42,
    },
    county_names_all: "Florence|Williamsburg|Clarendon",
    county_fips_all: "45041|45089|45027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29563,
    lat: 34.35301,
    lng: -79.2044,
    city: "Lake View",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2039,
    density: 20.9,
    county_fips: 45033,
    county_name: "Dillon",
    county_weights: {
      45033: 100,
    },
    county_names_all: "Dillon",
    county_fips_all: 45033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29564,
    lat: 33.47686,
    lng: -79.85522,
    city: "Lane",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1106,
    density: 8.3,
    county_fips: 45089,
    county_name: "Williamsburg",
    county_weights: {
      45089: 100,
    },
    county_names_all: "Williamsburg",
    county_fips_all: 45089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29565,
    lat: 34.35841,
    lng: -79.50457,
    city: "Latta",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7887,
    density: 24,
    county_fips: 45033,
    county_name: "Dillon",
    county_weights: {
      45033: 92.43,
      45067: 4.43,
      45069: 3.14,
    },
    county_names_all: "Dillon|Marion|Marlboro",
    county_fips_all: "45033|45067|45069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29566,
    lat: 33.8821,
    lng: -78.65906,
    city: "Little River",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18269,
    density: 217.7,
    county_fips: 45051,
    county_name: "Horry",
    county_weights: {
      45051: 100,
    },
    county_names_all: "Horry",
    county_fips_all: 45051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29567,
    lat: 34.55325,
    lng: -79.42649,
    city: "Little Rock",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 372,
    density: 7.5,
    county_fips: 45033,
    county_name: "Dillon",
    county_weights: {
      45033: 100,
    },
    county_names_all: "Dillon",
    county_fips_all: 45033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29568,
    lat: 33.90815,
    lng: -78.75455,
    city: "Longs",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17153,
    density: 74,
    county_fips: 45051,
    county_name: "Horry",
    county_weights: {
      45051: 100,
    },
    county_names_all: "Horry",
    county_fips_all: 45051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29569,
    lat: 34.0326,
    lng: -78.90359,
    city: "Loris",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16470,
    density: 37.3,
    county_fips: 45051,
    county_name: "Horry",
    county_weights: {
      45051: 100,
    },
    county_names_all: "Horry",
    county_fips_all: 45051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29570,
    lat: 34.67495,
    lng: -79.5624,
    city: "McColl",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3172,
    density: 25.4,
    county_fips: 45069,
    county_name: "Marlboro",
    county_weights: {
      45069: 100,
    },
    county_names_all: "Marlboro",
    county_fips_all: 45069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29571,
    lat: 34.138,
    lng: -79.42205,
    city: "Marion",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14185,
    density: 27.1,
    county_fips: 45067,
    county_name: "Marion",
    county_weights: {
      45033: 0.44,
      45067: 99.56,
    },
    county_names_all: "Marion|Dillon",
    county_fips_all: "45067|45033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29572,
    lat: 33.76798,
    lng: -78.79279,
    city: "Myrtle Beach",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10163,
    density: 441.2,
    county_fips: 45051,
    county_name: "Horry",
    county_weights: {
      45051: 100,
    },
    county_names_all: "Horry",
    county_fips_all: 45051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29574,
    lat: 34.17134,
    lng: -79.26695,
    city: "Mullins",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10471,
    density: 41.1,
    county_fips: 45067,
    county_name: "Marion",
    county_weights: {
      45033: 0.45,
      45067: 99.55,
    },
    county_names_all: "Marion|Dillon",
    county_fips_all: "45067|45033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29575,
    lat: 33.628,
    lng: -78.97369,
    city: "Myrtle Beach",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19673,
    density: 743.8,
    county_fips: 45051,
    county_name: "Horry",
    county_weights: {
      45051: 100,
    },
    county_names_all: "Horry",
    county_fips_all: 45051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29576,
    lat: 33.56952,
    lng: -79.05076,
    city: "Murrells Inlet",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33347,
    density: 422.5,
    county_fips: 45051,
    county_name: "Horry",
    county_weights: {
      45043: 47.22,
      45051: 52.78,
    },
    county_names_all: "Horry|Georgetown",
    county_fips_all: "45051|45043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29577,
    lat: 33.69711,
    lng: -78.90495,
    city: "Myrtle Beach",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32858,
    density: 555.5,
    county_fips: 45051,
    county_name: "Horry",
    county_weights: {
      45051: 100,
    },
    county_names_all: "Horry",
    county_fips_all: 45051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29579,
    lat: 33.76052,
    lng: -78.91463,
    city: "Myrtle Beach",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44037,
    density: 321,
    county_fips: 45051,
    county_name: "Horry",
    county_weights: {
      45051: 100,
    },
    county_names_all: "Horry",
    county_fips_all: 45051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29580,
    lat: 33.65827,
    lng: -79.56164,
    city: "Nesmith",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1479,
    density: 7.5,
    county_fips: 45089,
    county_name: "Williamsburg",
    county_weights: {
      45089: 100,
    },
    county_names_all: "Williamsburg",
    county_fips_all: 45089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29581,
    lat: 34.19864,
    lng: -79.11295,
    city: "Nichols",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4626,
    density: 10.8,
    county_fips: 45051,
    county_name: "Horry",
    county_weights: {
      45033: 15.84,
      45051: 73.29,
      45067: 10.87,
    },
    county_names_all: "Horry|Dillon|Marion",
    county_fips_all: "45051|45033|45067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29582,
    lat: 33.83423,
    lng: -78.66049,
    city: "North Myrtle Beach",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17356,
    density: 305.9,
    county_fips: 45051,
    county_name: "Horry",
    county_weights: {
      45051: 100,
    },
    county_names_all: "Horry",
    county_fips_all: 45051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29583,
    lat: 33.9724,
    lng: -79.57045,
    city: "Pamplico",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5406,
    density: 20.1,
    county_fips: 45041,
    county_name: "Florence",
    county_weights: {
      45041: 100,
    },
    county_names_all: "Florence",
    county_fips_all: 45041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29584,
    lat: 34.5764,
    lng: -80.05419,
    city: "Patrick",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2070,
    density: 6.9,
    county_fips: 45025,
    county_name: "Chesterfield",
    county_weights: {
      45025: 100,
    },
    county_names_all: "Chesterfield",
    county_fips_all: 45025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29585,
    lat: 33.50537,
    lng: -79.13557,
    city: "Pawleys Island",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15935,
    density: 99.6,
    county_fips: 45043,
    county_name: "Georgetown",
    county_weights: {
      45043: 100,
    },
    county_names_all: "Georgetown",
    county_fips_all: 45043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29588,
    lat: 33.67112,
    lng: -79.02574,
    city: "Myrtle Beach",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51632,
    density: 475,
    county_fips: 45051,
    county_name: "Horry",
    county_weights: {
      45051: 100,
    },
    county_names_all: "Horry",
    county_fips_all: 45051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29589,
    lat: 34.10037,
    lng: -79.32015,
    city: "Rains",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 45067,
    county_name: "Marion",
    county_weights: {
      45067: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 45067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29590,
    lat: 33.55892,
    lng: -79.84784,
    city: "Salters",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3543,
    density: 13,
    county_fips: 45089,
    county_name: "Williamsburg",
    county_weights: {
      45089: 100,
    },
    county_names_all: "Williamsburg",
    county_fips_all: 45089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29591,
    lat: 33.93894,
    lng: -79.759,
    city: "Scranton",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4746,
    density: 26,
    county_fips: 45041,
    county_name: "Florence",
    county_weights: {
      45041: 100,
    },
    county_names_all: "Florence",
    county_fips_all: 45041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29592,
    lat: 34.26941,
    lng: -79.47704,
    city: "Sellers",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 623,
    density: 7,
    county_fips: 45067,
    county_name: "Marion",
    county_weights: {
      45033: 42.76,
      45067: 57.24,
    },
    county_names_all: "Marion|Dillon",
    county_fips_all: "45067|45033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29593,
    lat: 34.49462,
    lng: -79.85429,
    city: "Society Hill",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1987,
    density: 10.1,
    county_fips: 45031,
    county_name: "Darlington",
    county_weights: {
      45025: 35.67,
      45031: 64.33,
    },
    county_names_all: "Darlington|Chesterfield",
    county_fips_all: "45031|45025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29594,
    lat: 34.64017,
    lng: -79.57728,
    city: "Tatum",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 351,
    density: 59.1,
    county_fips: 45069,
    county_name: "Marlboro",
    county_weights: {
      45069: 100,
    },
    county_names_all: "Marlboro",
    county_fips_all: 45069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29596,
    lat: 34.74456,
    lng: -79.83978,
    city: "Wallace",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1852,
    density: 11.1,
    county_fips: 45069,
    county_name: "Marlboro",
    county_weights: {
      45069: 100,
    },
    county_names_all: "Marlboro",
    county_fips_all: 45069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29601,
    lat: 34.84744,
    lng: -82.40257,
    city: "Greenville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12785,
    density: 1161.9,
    county_fips: 45045,
    county_name: "Greenville",
    county_weights: {
      45045: 100,
    },
    county_names_all: "Greenville",
    county_fips_all: 45045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29605,
    lat: 34.77693,
    lng: -82.38064,
    city: "Greenville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38808,
    density: 603.4,
    county_fips: 45045,
    county_name: "Greenville",
    county_weights: {
      45045: 100,
    },
    county_names_all: "Greenville",
    county_fips_all: 45045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29607,
    lat: 34.80952,
    lng: -82.33193,
    city: "Greenville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40933,
    density: 544.8,
    county_fips: 45045,
    county_name: "Greenville",
    county_weights: {
      45045: 100,
    },
    county_names_all: "Greenville",
    county_fips_all: 45045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29609,
    lat: 34.91209,
    lng: -82.38928,
    city: "Greenville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31127,
    density: 494.6,
    county_fips: 45045,
    county_name: "Greenville",
    county_weights: {
      45045: 100,
    },
    county_names_all: "Greenville",
    county_fips_all: 45045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29611,
    lat: 34.83137,
    lng: -82.45965,
    city: "Greenville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31180,
    density: 502.7,
    county_fips: 45045,
    county_name: "Greenville",
    county_weights: {
      45007: 11.65,
      45045: 86.02,
      45077: 2.33,
    },
    county_names_all: "Greenville|Anderson|Pickens",
    county_fips_all: "45045|45007|45077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29613,
    lat: 34.9257,
    lng: -82.4384,
    city: "Greenville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2168,
    density: 1326.7,
    county_fips: 45045,
    county_name: "Greenville",
    county_weights: {
      45045: 100,
    },
    county_names_all: "Greenville",
    county_fips_all: 45045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29614,
    lat: 34.87386,
    lng: -82.36302,
    city: "Greenville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1886,
    density: 3832.2,
    county_fips: 45045,
    county_name: "Greenville",
    county_weights: {
      45045: 100,
    },
    county_names_all: "Greenville",
    county_fips_all: 45045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29615,
    lat: 34.85591,
    lng: -82.29553,
    city: "Greenville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37349,
    density: 750.1,
    county_fips: 45045,
    county_name: "Greenville",
    county_weights: {
      45045: 100,
    },
    county_names_all: "Greenville",
    county_fips_all: 45045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29617,
    lat: 34.91262,
    lng: -82.4666,
    city: "Greenville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28936,
    density: 498.8,
    county_fips: 45045,
    county_name: "Greenville",
    county_weights: {
      45045: 100,
    },
    county_names_all: "Greenville",
    county_fips_all: 45045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29620,
    lat: 34.1813,
    lng: -82.42804,
    city: "Abbeville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12413,
    density: 19.4,
    county_fips: 45001,
    county_name: "Abbeville",
    county_weights: {
      45001: 96.08,
      45065: 3.92,
    },
    county_names_all: "Abbeville|McCormick",
    county_fips_all: "45001|45065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29621,
    lat: 34.50598,
    lng: -82.60328,
    city: "Anderson",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42546,
    density: 188.5,
    county_fips: 45007,
    county_name: "Anderson",
    county_weights: {
      45007: 100,
    },
    county_names_all: "Anderson",
    county_fips_all: 45007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29624,
    lat: 34.43778,
    lng: -82.62553,
    city: "Anderson",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14926,
    density: 204.5,
    county_fips: 45007,
    county_name: "Anderson",
    county_weights: {
      45007: 100,
    },
    county_names_all: "Anderson",
    county_fips_all: 45007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29625,
    lat: 34.55577,
    lng: -82.76294,
    city: "Anderson",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27875,
    density: 229.3,
    county_fips: 45007,
    county_name: "Anderson",
    county_weights: {
      45007: 100,
    },
    county_names_all: "Anderson",
    county_fips_all: 45007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29626,
    lat: 34.46004,
    lng: -82.76057,
    city: "Anderson",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13847,
    density: 103.3,
    county_fips: 45007,
    county_name: "Anderson",
    county_weights: {
      45007: 100,
    },
    county_names_all: "Anderson",
    county_fips_all: 45007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29627,
    lat: 34.51807,
    lng: -82.47861,
    city: "Belton",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17445,
    density: 56.7,
    county_fips: 45007,
    county_name: "Anderson",
    county_weights: {
      45001: 1.42,
      45007: 82.88,
      45045: 15.7,
    },
    county_names_all: "Anderson|Greenville|Abbeville",
    county_fips_all: "45007|45045|45001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29628,
    lat: 34.09253,
    lng: -82.55821,
    city: "Calhoun Falls",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2480,
    density: 13.5,
    county_fips: 45001,
    county_name: "Abbeville",
    county_weights: {
      45001: 77.88,
      45065: 22.12,
    },
    county_names_all: "Abbeville|McCormick",
    county_fips_all: "45001|45065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29630,
    lat: 34.73882,
    lng: -82.79646,
    city: "Central",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16212,
    density: 101.7,
    county_fips: 45077,
    county_name: "Pickens",
    county_weights: {
      45007: 11.98,
      45077: 88.02,
    },
    county_names_all: "Pickens|Anderson",
    county_fips_all: "45077|45007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29631,
    lat: 34.68133,
    lng: -82.81716,
    city: "Clemson",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15573,
    density: 689.9,
    county_fips: 45077,
    county_name: "Pickens",
    county_weights: {
      45007: 0.49,
      45077: 99.51,
    },
    county_names_all: "Pickens|Anderson",
    county_fips_all: "45077|45007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29634,
    lat: 34.67517,
    lng: -82.83978,
    city: "Clemson",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5329,
    density: 1478.6,
    county_fips: 45077,
    county_name: "Pickens",
    county_weights: {
      45073: 1.09,
      45077: 98.91,
    },
    county_names_all: "Pickens|Oconee",
    county_fips_all: "45077|45073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29635,
    lat: 35.07754,
    lng: -82.63152,
    city: "Cleveland",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1334,
    density: 9.7,
    county_fips: 45045,
    county_name: "Greenville",
    county_weights: {
      45045: 81.79,
      45077: 18.21,
    },
    county_names_all: "Greenville|Pickens",
    county_fips_all: "45045|45077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29638,
    lat: 34.36087,
    lng: -82.3346,
    city: "Donalds",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3546,
    density: 23.5,
    county_fips: 45001,
    county_name: "Abbeville",
    county_weights: {
      45001: 83.93,
      45047: 16.07,
    },
    county_names_all: "Abbeville|Greenwood",
    county_fips_all: "45001|45047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29639,
    lat: 34.31402,
    lng: -82.4205,
    city: "Due West",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1914,
    density: 45.9,
    county_fips: 45001,
    county_name: "Abbeville",
    county_weights: {
      45001: 100,
    },
    county_names_all: "Abbeville",
    county_fips_all: 45001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29640,
    lat: 34.88706,
    lng: -82.57725,
    city: "Easley",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29766,
    density: 134.2,
    county_fips: 45077,
    county_name: "Pickens",
    county_weights: {
      45077: 100,
    },
    county_names_all: "Pickens",
    county_fips_all: 45077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29642,
    lat: 34.77487,
    lng: -82.56538,
    city: "Easley",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33120,
    density: 251.9,
    county_fips: 45007,
    county_name: "Anderson",
    county_weights: {
      45007: 55.55,
      45077: 44.45,
    },
    county_names_all: "Anderson|Pickens",
    county_fips_all: "45007|45077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29643,
    lat: 34.50506,
    lng: -82.97441,
    city: "Fair Play",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2327,
    density: 32.1,
    county_fips: 45073,
    county_name: "Oconee",
    county_weights: {
      45007: 34.84,
      45073: 65.16,
    },
    county_names_all: "Oconee|Anderson",
    county_fips_all: "45073|45007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29644,
    lat: 34.66864,
    lng: -82.19714,
    city: "Fountain Inn",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21811,
    density: 102.7,
    county_fips: 45045,
    county_name: "Greenville",
    county_weights: {
      45045: 50.14,
      45059: 49.86,
    },
    county_names_all: "Greenville|Laurens",
    county_fips_all: "45045|45059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29645,
    lat: 34.59453,
    lng: -82.12375,
    city: "Gray Court",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10445,
    density: 37.8,
    county_fips: 45059,
    county_name: "Laurens",
    county_weights: {
      45045: 0.12,
      45059: 99.88,
    },
    county_names_all: "Laurens|Greenville",
    county_fips_all: "45059|45045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29646,
    lat: 34.13995,
    lng: -82.15032,
    city: "Greenwood",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28739,
    density: 109.4,
    county_fips: 45047,
    county_name: "Greenwood",
    county_weights: {
      45001: 3.95,
      45047: 96.05,
    },
    county_names_all: "Greenwood|Abbeville",
    county_fips_all: "45047|45001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29649,
    lat: 34.24354,
    lng: -82.13825,
    city: "Greenwood",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26440,
    density: 190.4,
    county_fips: 45047,
    county_name: "Greenwood",
    county_weights: {
      45001: 2.56,
      45047: 97.44,
    },
    county_names_all: "Greenwood|Abbeville",
    county_fips_all: "45047|45001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29650,
    lat: 34.89805,
    lng: -82.25826,
    city: "Greer",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35053,
    density: 753,
    county_fips: 45045,
    county_name: "Greenville",
    county_weights: {
      45045: 98.74,
      45083: 1.26,
    },
    county_names_all: "Greenville|Spartanburg",
    county_fips_all: "45045|45083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29651,
    lat: 34.94653,
    lng: -82.22649,
    city: "Greer",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51262,
    density: 220.9,
    county_fips: 45045,
    county_name: "Greenville",
    county_weights: {
      45045: 56.27,
      45083: 43.73,
    },
    county_names_all: "Greenville|Spartanburg",
    county_fips_all: "45045|45083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29653,
    lat: 34.30028,
    lng: -82.23173,
    city: "Hodges",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4310,
    density: 23.5,
    county_fips: 45047,
    county_name: "Greenwood",
    county_weights: {
      45001: 7.27,
      45047: 92.73,
    },
    county_names_all: "Greenwood|Abbeville",
    county_fips_all: "45047|45001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29654,
    lat: 34.46621,
    lng: -82.36354,
    city: "Honea Path",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9829,
    density: 31.9,
    county_fips: 45007,
    county_name: "Anderson",
    county_weights: {
      45001: 29.52,
      45007: 36.74,
      45045: 23.41,
      45059: 10.33,
    },
    county_names_all: "Anderson|Abbeville|Greenville|Laurens",
    county_fips_all: "45007|45001|45045|45059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29655,
    lat: 34.267,
    lng: -82.64032,
    city: "Iva",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6923,
    density: 19,
    county_fips: 45001,
    county_name: "Abbeville",
    county_weights: {
      45001: 54.97,
      45007: 45.03,
    },
    county_names_all: "Abbeville|Anderson",
    county_fips_all: "45001|45007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29657,
    lat: 34.76713,
    lng: -82.68941,
    city: "Liberty",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15847,
    density: 96.6,
    county_fips: 45077,
    county_name: "Pickens",
    county_weights: {
      45007: 23.82,
      45077: 76.18,
    },
    county_names_all: "Pickens|Anderson",
    county_fips_all: "45077|45007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29658,
    lat: 34.76191,
    lng: -83.29858,
    city: "Long Creek",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 397,
    density: 7.2,
    county_fips: 45073,
    county_name: "Oconee",
    county_weights: {
      45073: 100,
    },
    county_names_all: "Oconee",
    county_fips_all: 45073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29659,
    lat: 34.21167,
    lng: -82.64535,
    city: "Lowndesville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 167,
    density: 149,
    county_fips: 45001,
    county_name: "Abbeville",
    county_weights: {
      45001: 100,
    },
    county_names_all: "Abbeville",
    county_fips_all: 45001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29661,
    lat: 35.06706,
    lng: -82.53852,
    city: "Marietta",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5684,
    density: 27.1,
    county_fips: 45045,
    county_name: "Greenville",
    county_weights: {
      45045: 80.17,
      45077: 19.83,
    },
    county_names_all: "Greenville|Pickens",
    county_fips_all: "45045|45077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29662,
    lat: 34.77837,
    lng: -82.30557,
    city: "Mauldin",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16600,
    density: 1163.1,
    county_fips: 45045,
    county_name: "Greenville",
    county_weights: {
      45045: 100,
    },
    county_names_all: "Greenville",
    county_fips_all: 45045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29664,
    lat: 34.86393,
    lng: -83.15991,
    city: "Mountain Rest",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2162,
    density: 8.5,
    county_fips: 45073,
    county_name: "Oconee",
    county_weights: {
      45073: 100,
    },
    county_names_all: "Oconee",
    county_fips_all: 45073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29665,
    lat: 34.72399,
    lng: -82.91413,
    city: "Newry",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 98,
    density: 128.2,
    county_fips: 45073,
    county_name: "Oconee",
    county_weights: {
      45073: 100,
    },
    county_names_all: "Oconee",
    county_fips_all: 45073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29666,
    lat: 34.12345,
    lng: -81.99121,
    city: "Ninety Six",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6436,
    density: 20.3,
    county_fips: 45047,
    county_name: "Greenwood",
    county_weights: {
      45047: 94.64,
      45081: 5.36,
    },
    county_names_all: "Greenwood|Saluda",
    county_fips_all: "45047|45081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29667,
    lat: 34.76446,
    lng: -82.75655,
    city: "Norris",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 253,
    density: 186.3,
    county_fips: 45077,
    county_name: "Pickens",
    county_weights: {
      45077: 100,
    },
    county_names_all: "Pickens",
    county_fips_all: 45077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29669,
    lat: 34.6405,
    lng: -82.41495,
    city: "Pelzer",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12624,
    density: 79,
    county_fips: 45045,
    county_name: "Greenville",
    county_weights: {
      45007: 27.86,
      45045: 72.14,
    },
    county_names_all: "Greenville|Anderson",
    county_fips_all: "45045|45007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29670,
    lat: 34.64191,
    lng: -82.72455,
    city: "Pendleton",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10232,
    density: 70.5,
    county_fips: 45007,
    county_name: "Anderson",
    county_weights: {
      45007: 95.25,
      45077: 4.75,
    },
    county_names_all: "Anderson|Pickens",
    county_fips_all: "45007|45077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29671,
    lat: 34.94071,
    lng: -82.72057,
    city: "Pickens",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18125,
    density: 52.9,
    county_fips: 45077,
    county_name: "Pickens",
    county_weights: {
      45077: 100,
    },
    county_names_all: "Pickens",
    county_fips_all: 45077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29672,
    lat: 34.75036,
    lng: -82.94257,
    city: "Seneca",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12038,
    density: 118.7,
    county_fips: 45073,
    county_name: "Oconee",
    county_weights: {
      45073: 100,
    },
    county_names_all: "Oconee",
    county_fips_all: 45073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29673,
    lat: 34.71901,
    lng: -82.455,
    city: "Piedmont",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30704,
    density: 168,
    county_fips: 45045,
    county_name: "Greenville",
    county_weights: {
      45007: 46.1,
      45045: 53.9,
    },
    county_names_all: "Greenville|Anderson",
    county_fips_all: "45045|45007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29676,
    lat: 34.93326,
    lng: -82.96006,
    city: "Salem",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5748,
    density: 30.8,
    county_fips: 45073,
    county_name: "Oconee",
    county_weights: {
      45073: 100,
    },
    county_names_all: "Oconee",
    county_fips_all: 45073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29678,
    lat: 34.63365,
    lng: -82.93991,
    city: "Seneca",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23299,
    density: 112.8,
    county_fips: 45073,
    county_name: "Oconee",
    county_weights: {
      45073: 99.47,
      45077: 0.53,
    },
    county_names_all: "Oconee|Pickens",
    county_fips_all: "45073|45077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29680,
    lat: 34.69011,
    lng: -82.29073,
    city: "Simpsonville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31913,
    density: 424,
    county_fips: 45045,
    county_name: "Greenville",
    county_weights: {
      45045: 100,
    },
    county_names_all: "Greenville",
    county_fips_all: 45045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29681,
    lat: 34.76988,
    lng: -82.22218,
    city: "Simpsonville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64806,
    density: 572.7,
    county_fips: 45045,
    county_name: "Greenville",
    county_weights: {
      45045: 97.43,
      45059: 2.57,
    },
    county_names_all: "Greenville|Laurens",
    county_fips_all: "45045|45059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29682,
    lat: 34.83295,
    lng: -82.84701,
    city: "Six Mile",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3644,
    density: 54.5,
    county_fips: 45077,
    county_name: "Pickens",
    county_weights: {
      45077: 100,
    },
    county_names_all: "Pickens",
    county_fips_all: 45077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29683,
    lat: 35.03032,
    lng: -82.49306,
    city: "Slater",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 508,
    density: 1333.9,
    county_fips: 45045,
    county_name: "Greenville",
    county_weights: {
      45045: 100,
    },
    county_names_all: "Greenville",
    county_fips_all: 45045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29684,
    lat: 34.3791,
    lng: -82.72722,
    city: "Starr",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4809,
    density: 31.5,
    county_fips: 45007,
    county_name: "Anderson",
    county_weights: {
      45007: 100,
    },
    county_names_all: "Anderson",
    county_fips_all: 45007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29685,
    lat: 34.98297,
    lng: -82.84727,
    city: "Sunset",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1945,
    density: 8.5,
    county_fips: 45077,
    county_name: "Pickens",
    county_weights: {
      45077: 100,
    },
    county_names_all: "Pickens",
    county_fips_all: 45077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29686,
    lat: 34.92858,
    lng: -83.04541,
    city: "Tamassee",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1019,
    density: 12.3,
    county_fips: 45073,
    county_name: "Oconee",
    county_weights: {
      45073: 100,
    },
    county_names_all: "Oconee",
    county_fips_all: 45073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29687,
    lat: 34.9855,
    lng: -82.32833,
    city: "Taylors",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41098,
    density: 329,
    county_fips: 45045,
    county_name: "Greenville",
    county_weights: {
      45045: 100,
    },
    county_names_all: "Greenville",
    county_fips_all: 45045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29689,
    lat: 34.53624,
    lng: -82.87658,
    city: "Townville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4012,
    density: 44.8,
    county_fips: 45007,
    county_name: "Anderson",
    county_weights: {
      45007: 88.92,
      45073: 11.08,
    },
    county_names_all: "Anderson|Oconee",
    county_fips_all: "45007|45073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29690,
    lat: 35.06008,
    lng: -82.42136,
    city: "Travelers Rest",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24595,
    density: 90.3,
    county_fips: 45045,
    county_name: "Greenville",
    county_weights: {
      45045: 100,
    },
    county_names_all: "Greenville",
    county_fips_all: 45045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29691,
    lat: 34.78547,
    lng: -83.07669,
    city: "Walhalla",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12141,
    density: 75.4,
    county_fips: 45073,
    county_name: "Oconee",
    county_weights: {
      45073: 100,
    },
    county_names_all: "Oconee",
    county_fips_all: 45073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29692,
    lat: 34.42142,
    lng: -82.22208,
    city: "Ware Shoals",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5483,
    density: 43.6,
    county_fips: 45059,
    county_name: "Laurens",
    county_weights: {
      45001: 7.34,
      45047: 12.64,
      45059: 80.02,
    },
    county_names_all: "Laurens|Greenwood|Abbeville",
    county_fips_all: "45059|45047|45001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29693,
    lat: 34.65641,
    lng: -83.15284,
    city: "Westminster",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13747,
    density: 30.6,
    county_fips: 45073,
    county_name: "Oconee",
    county_weights: {
      45073: 100,
    },
    county_names_all: "Oconee",
    county_fips_all: 45073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29696,
    lat: 34.77458,
    lng: -83.00771,
    city: "West Union",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5435,
    density: 95.8,
    county_fips: 45073,
    county_name: "Oconee",
    county_weights: {
      45073: 100,
    },
    county_names_all: "Oconee",
    county_fips_all: 45073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29697,
    lat: 34.62887,
    lng: -82.54786,
    city: "Williamston",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14421,
    density: 141.9,
    county_fips: 45007,
    county_name: "Anderson",
    county_weights: {
      45007: 100,
    },
    county_names_all: "Anderson",
    county_fips_all: 45007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29702,
    lat: 35.11674,
    lng: -81.47884,
    city: "Blacksburg",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10209,
    density: 42.2,
    county_fips: 45021,
    county_name: "Cherokee",
    county_weights: {
      45021: 85.58,
      45091: 14.42,
    },
    county_names_all: "Cherokee|York",
    county_fips_all: "45021|45091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29704,
    lat: 34.82293,
    lng: -80.91592,
    city: "Catawba",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2930,
    density: 43.1,
    county_fips: 45091,
    county_name: "York",
    county_weights: {
      45023: 43.2,
      45091: 56.8,
    },
    county_names_all: "York|Chester",
    county_fips_all: "45091|45023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29706,
    lat: 34.71773,
    lng: -81.23055,
    city: "Chester",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19813,
    density: 28.5,
    county_fips: 45023,
    county_name: "Chester",
    county_weights: {
      45023: 99.72,
      45091: 0.28,
    },
    county_names_all: "Chester|York",
    county_fips_all: "45023|45091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29707,
    lat: 34.98148,
    lng: -80.85669,
    city: "Fort Mill",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34022,
    density: 461.7,
    county_fips: 45057,
    county_name: "Lancaster",
    county_weights: {
      45057: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 45057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29708,
    lat: 35.04655,
    lng: -80.98604,
    city: "Fort Mill",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38452,
    density: 780.2,
    county_fips: 45091,
    county_name: "York",
    county_weights: {
      45091: 100,
    },
    county_names_all: "York",
    county_fips_all: 45091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29709,
    lat: 34.71882,
    lng: -80.09752,
    city: "Chesterfield",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6578,
    density: 25.4,
    county_fips: 45025,
    county_name: "Chesterfield",
    county_weights: {
      45025: 100,
    },
    county_names_all: "Chesterfield",
    county_fips_all: 45025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29710,
    lat: 35.10598,
    lng: -81.22209,
    city: "Clover",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37269,
    density: 126.1,
    county_fips: 45091,
    county_name: "York",
    county_weights: {
      45091: 100,
    },
    county_names_all: "York",
    county_fips_all: 45091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29712,
    lat: 34.79439,
    lng: -80.98398,
    city: "Edgemoor",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2199,
    density: 29.5,
    county_fips: 45023,
    county_name: "Chester",
    county_weights: {
      45023: 84.91,
      45091: 15.09,
    },
    county_names_all: "Chester|York",
    county_fips_all: "45023|45091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29714,
    lat: 34.71171,
    lng: -80.9145,
    city: "Fort Lawn",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3178,
    density: 37.7,
    county_fips: 45023,
    county_name: "Chester",
    county_weights: {
      45023: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 45023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29715,
    lat: 35.01028,
    lng: -80.92752,
    city: "Fort Mill",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36277,
    density: 400.5,
    county_fips: 45091,
    county_name: "York",
    county_weights: {
      45091: 100,
    },
    county_names_all: "York",
    county_fips_all: 45091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29717,
    lat: 34.95119,
    lng: -81.44304,
    city: "Hickory Grove",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1662,
    density: 17.2,
    county_fips: 45091,
    county_name: "York",
    county_weights: {
      45091: 100,
    },
    county_names_all: "York",
    county_fips_all: 45091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29718,
    lat: 34.6291,
    lng: -80.35469,
    city: "Jefferson",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4220,
    density: 15.7,
    county_fips: 45025,
    county_name: "Chesterfield",
    county_weights: {
      45025: 90.47,
      45055: 6.96,
      45057: 2.57,
    },
    county_names_all: "Chesterfield|Kershaw|Lancaster",
    county_fips_all: "45025|45055|45057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29720,
    lat: 34.74265,
    lng: -80.73684,
    city: "Lancaster",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48641,
    density: 65.9,
    county_fips: 45057,
    county_name: "Lancaster",
    county_weights: {
      45057: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 45057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29724,
    lat: 34.77503,
    lng: -81.01248,
    city: "Lando",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 45023,
    county_name: "Chester",
    county_weights: {
      45023: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 45023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29726,
    lat: 34.85738,
    lng: -81.23223,
    city: "McConnells",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1537,
    density: 14.7,
    county_fips: 45091,
    county_name: "York",
    county_weights: {
      45091: 100,
    },
    county_names_all: "York",
    county_fips_all: 45091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29727,
    lat: 34.71566,
    lng: -80.2684,
    city: "Mount Croghan",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2189,
    density: 16.7,
    county_fips: 45025,
    county_name: "Chesterfield",
    county_weights: {
      45025: 100,
    },
    county_names_all: "Chesterfield",
    county_fips_all: 45025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29728,
    lat: 34.76831,
    lng: -80.40445,
    city: "Pageland",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9616,
    density: 39,
    county_fips: 45025,
    county_name: "Chesterfield",
    county_weights: {
      45025: 100,
    },
    county_names_all: "Chesterfield",
    county_fips_all: 45025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29729,
    lat: 34.67716,
    lng: -81.00528,
    city: "Richburg",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2215,
    density: 12.3,
    county_fips: 45023,
    county_name: "Chester",
    county_weights: {
      45023: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 45023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29730,
    lat: 34.8878,
    lng: -81.02116,
    city: "Rock Hill",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57174,
    density: 184.9,
    county_fips: 45091,
    county_name: "York",
    county_weights: {
      45023: 4.61,
      45091: 95.39,
    },
    county_names_all: "York|Chester",
    county_fips_all: "45091|45023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29732,
    lat: 34.96979,
    lng: -81.07963,
    city: "Rock Hill",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58351,
    density: 426.7,
    county_fips: 45091,
    county_name: "York",
    county_weights: {
      45091: 100,
    },
    county_names_all: "York",
    county_fips_all: 45091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29733,
    lat: 34.93945,
    lng: -81.03173,
    city: "Rock Hill",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1713,
    density: 5173.8,
    county_fips: 45091,
    county_name: "York",
    county_weights: {
      45091: 100,
    },
    county_names_all: "York",
    county_fips_all: 45091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29741,
    lat: 34.72511,
    lng: -80.20138,
    city: "Ruby",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2422,
    density: 25.2,
    county_fips: 45025,
    county_name: "Chesterfield",
    county_weights: {
      45025: 100,
    },
    county_names_all: "Chesterfield",
    county_fips_all: 45025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29742,
    lat: 34.86939,
    lng: -81.38155,
    city: "Sharon",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2594,
    density: 12.4,
    county_fips: 45091,
    county_name: "York",
    county_weights: {
      45023: 16.06,
      45091: 83.94,
    },
    county_names_all: "York|Chester",
    county_fips_all: "45091|45023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29743,
    lat: 35.02865,
    lng: -81.40772,
    city: "Smyrna",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1438,
    density: 14.9,
    county_fips: 45091,
    county_name: "York",
    county_weights: {
      45021: 15.47,
      45091: 84.53,
    },
    county_names_all: "York|Cherokee",
    county_fips_all: "45091|45021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29745,
    lat: 34.99549,
    lng: -81.21573,
    city: "York",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34052,
    density: 96.8,
    county_fips: 45091,
    county_name: "York",
    county_weights: {
      45091: 100,
    },
    county_names_all: "York",
    county_fips_all: 45091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29801,
    lat: 33.58675,
    lng: -81.69701,
    city: "Aiken",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28610,
    density: 124.2,
    county_fips: 45003,
    county_name: "Aiken",
    county_weights: {
      45003: 100,
    },
    county_names_all: "Aiken",
    county_fips_all: 45003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29803,
    lat: 33.45889,
    lng: -81.70076,
    city: "Aiken",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38735,
    density: 117.3,
    county_fips: 45003,
    county_name: "Aiken",
    county_weights: {
      45003: 100,
    },
    county_names_all: "Aiken",
    county_fips_all: 45003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29805,
    lat: 33.6495,
    lng: -81.61044,
    city: "Aiken",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5409,
    density: 21.4,
    county_fips: 45003,
    county_name: "Aiken",
    county_weights: {
      45003: 100,
    },
    county_names_all: "Aiken",
    county_fips_all: 45003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29809,
    lat: 33.41653,
    lng: -81.6889,
    city: "New Ellenton",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2729,
    density: 195.3,
    county_fips: 45003,
    county_name: "Aiken",
    county_weights: {
      45003: 100,
    },
    county_names_all: "Aiken",
    county_fips_all: 45003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29810,
    lat: 32.99358,
    lng: -81.3798,
    city: "Allendale",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4084,
    density: 12.4,
    county_fips: 45005,
    county_name: "Allendale",
    county_weights: {
      45005: 100,
    },
    county_names_all: "Allendale",
    county_fips_all: 45005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29812,
    lat: 33.21185,
    lng: -81.37911,
    city: "Barnwell",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10969,
    density: 24.4,
    county_fips: 45011,
    county_name: "Barnwell",
    county_weights: {
      45005: 2.33,
      45011: 97.67,
    },
    county_names_all: "Barnwell|Allendale",
    county_fips_all: "45011|45005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29816,
    lat: 33.50105,
    lng: -81.87164,
    city: "Bath",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1171,
    density: 757.7,
    county_fips: 45003,
    county_name: "Aiken",
    county_weights: {
      45003: 100,
    },
    county_names_all: "Aiken",
    county_fips_all: 45003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29817,
    lat: 33.36989,
    lng: -81.27096,
    city: "Blackville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4293,
    density: 14.5,
    county_fips: 45011,
    county_name: "Barnwell",
    county_weights: {
      45009: 16.15,
      45011: 83.85,
    },
    county_names_all: "Barnwell|Bamberg",
    county_fips_all: "45011|45009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29819,
    lat: 34.04764,
    lng: -82.22632,
    city: "Bradley",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1607,
    density: 7.5,
    county_fips: 45047,
    county_name: "Greenwood",
    county_weights: {
      45001: 11.28,
      45047: 83.23,
      45065: 5.49,
    },
    county_names_all: "Greenwood|Abbeville|McCormick",
    county_fips_all: "45047|45001|45065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29821,
    lat: 33.64242,
    lng: -82.11667,
    city: "Clarks Hill",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1568,
    density: 11,
    county_fips: 45037,
    county_name: "Edgefield",
    county_weights: {
      45037: 51.62,
      45065: 48.38,
    },
    county_names_all: "Edgefield|McCormick",
    county_fips_all: "45037|45065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29824,
    lat: 33.81647,
    lng: -81.99666,
    city: "Edgefield",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8432,
    density: 13.9,
    county_fips: 45037,
    county_name: "Edgefield",
    county_weights: {
      45037: 98.26,
      45081: 1.74,
    },
    county_names_all: "Edgefield|Saluda",
    county_fips_all: "45037|45081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29826,
    lat: 33.383,
    lng: -81.36697,
    city: "Elko",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 321,
    density: 61.4,
    county_fips: 45011,
    county_name: "Barnwell",
    county_weights: {
      45011: 100,
    },
    county_names_all: "Barnwell",
    county_fips_all: 45011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29827,
    lat: 32.96951,
    lng: -81.24542,
    city: "Fairfax",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3982,
    density: 14.7,
    county_fips: 45005,
    county_name: "Allendale",
    county_weights: {
      45005: 96.17,
      45049: 3.83,
    },
    county_names_all: "Allendale|Hampton",
    county_fips_all: "45005|45049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29828,
    lat: 33.52299,
    lng: -81.82891,
    city: "Gloverville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 604,
    density: 357,
    county_fips: 45003,
    county_name: "Aiken",
    county_weights: {
      45003: 100,
    },
    county_names_all: "Aiken",
    county_fips_all: 45003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29829,
    lat: 33.57715,
    lng: -81.85537,
    city: "Graniteville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11387,
    density: 126.1,
    county_fips: 45003,
    county_name: "Aiken",
    county_weights: {
      45003: 100,
    },
    county_names_all: "Aiken",
    county_fips_all: 45003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29831,
    lat: 33.33657,
    lng: -81.84293,
    city: "Jackson",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4270,
    density: 25.7,
    county_fips: 45003,
    county_name: "Aiken",
    county_weights: {
      45003: 100,
    },
    county_names_all: "Aiken",
    county_fips_all: 45003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29832,
    lat: 33.83922,
    lng: -81.80656,
    city: "Johnston",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5727,
    density: 23.4,
    county_fips: 45037,
    county_name: "Edgefield",
    county_weights: {
      45003: 0.84,
      45037: 66.75,
      45081: 32.41,
    },
    county_names_all: "Edgefield|Saluda|Aiken",
    county_fips_all: "45037|45081|45003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29834,
    lat: 33.5178,
    lng: -81.84216,
    city: "Langley",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1889,
    density: 4682.7,
    county_fips: 45003,
    county_name: "Aiken",
    county_weights: {
      45003: 100,
    },
    county_names_all: "Aiken",
    county_fips_all: 45003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29835,
    lat: 33.91779,
    lng: -82.29559,
    city: "McCormick",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6119,
    density: 13.9,
    county_fips: 45065,
    county_name: "McCormick",
    county_weights: {
      45037: 14.59,
      45065: 85.41,
    },
    county_names_all: "McCormick|Edgefield",
    county_fips_all: "45065|45037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29836,
    lat: 33.09046,
    lng: -81.50026,
    city: "Martin",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 254,
    density: 1,
    county_fips: 45005,
    county_name: "Allendale",
    county_weights: {
      45005: 83.09,
      45011: 16.91,
    },
    county_names_all: "Allendale|Barnwell",
    county_fips_all: "45005|45011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29838,
    lat: 33.73452,
    lng: -82.1667,
    city: "Modoc",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 458,
    density: 6.1,
    county_fips: 45037,
    county_name: "Edgefield",
    county_weights: {
      45037: 60.52,
      45065: 39.48,
    },
    county_names_all: "Edgefield|McCormick",
    county_fips_all: "45037|45065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29840,
    lat: 33.99797,
    lng: -82.52749,
    city: "Mount Carmel",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 281,
    density: 3.5,
    county_fips: 45065,
    county_name: "McCormick",
    county_weights: {
      45065: 100,
    },
    county_names_all: "McCormick",
    county_fips_all: 45065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29841,
    lat: 33.52508,
    lng: -81.93954,
    city: "North Augusta",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32989,
    density: 398.7,
    county_fips: 45003,
    county_name: "Aiken",
    county_weights: {
      45003: 100,
    },
    county_names_all: "Aiken",
    county_fips_all: 45003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29842,
    lat: 33.44559,
    lng: -81.8645,
    city: "Beech Island",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7778,
    density: 72.6,
    county_fips: 45003,
    county_name: "Aiken",
    county_weights: {
      45003: 100,
    },
    county_names_all: "Aiken",
    county_fips_all: 45003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29843,
    lat: 33.18385,
    lng: -81.18218,
    city: "Olar",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1493,
    density: 8.7,
    county_fips: 45009,
    county_name: "Bamberg",
    county_weights: {
      45009: 81.28,
      45011: 18.72,
    },
    county_names_all: "Bamberg|Barnwell",
    county_fips_all: "45009|45011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29844,
    lat: 33.78528,
    lng: -82.2142,
    city: "Parksville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 136,
    density: 50.3,
    county_fips: 45065,
    county_name: "McCormick",
    county_weights: {
      45065: 100,
    },
    county_names_all: "McCormick",
    county_fips_all: 45065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29845,
    lat: 33.8231,
    lng: -82.20788,
    city: "Plum Branch",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 808,
    density: 4.3,
    county_fips: 45065,
    county_name: "McCormick",
    county_weights: {
      45037: 7.64,
      45065: 92.36,
    },
    county_names_all: "McCormick|Edgefield",
    county_fips_all: "45065|45037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29847,
    lat: 33.69941,
    lng: -81.84878,
    city: "Trenton",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4936,
    density: 21.1,
    county_fips: 45037,
    county_name: "Edgefield",
    county_weights: {
      45003: 24.34,
      45037: 75.66,
    },
    county_names_all: "Edgefield|Aiken",
    county_fips_all: "45037|45003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29848,
    lat: 33.99616,
    lng: -82.18304,
    city: "Troy",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 881,
    density: 3.7,
    county_fips: 45065,
    county_name: "McCormick",
    county_weights: {
      45047: 38.06,
      45065: 53.03,
      45081: 8.91,
    },
    county_names_all: "McCormick|Greenwood|Saluda",
    county_fips_all: "45065|45047|45081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29849,
    lat: 33.10168,
    lng: -81.23641,
    city: "Ulmer",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 452,
    density: 4.2,
    county_fips: 45005,
    county_name: "Allendale",
    county_weights: {
      45005: 73.59,
      45011: 26.41,
    },
    county_names_all: "Allendale|Barnwell",
    county_fips_all: "45005|45011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29851,
    lat: 33.51098,
    lng: -81.81597,
    city: "Warrenville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7743,
    density: 135.6,
    county_fips: 45003,
    county_name: "Aiken",
    county_weights: {
      45003: 100,
    },
    county_names_all: "Aiken",
    county_fips_all: 45003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29853,
    lat: 33.39871,
    lng: -81.43217,
    city: "Williston",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6139,
    density: 19.5,
    county_fips: 45011,
    county_name: "Barnwell",
    county_weights: {
      45003: 24.79,
      45011: 75.21,
    },
    county_names_all: "Barnwell|Aiken",
    county_fips_all: "45011|45003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29856,
    lat: 33.48365,
    lng: -81.51276,
    city: "Windsor",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3607,
    density: 25.6,
    county_fips: 45003,
    county_name: "Aiken",
    county_weights: {
      45003: 100,
    },
    county_names_all: "Aiken",
    county_fips_all: 45003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29860,
    lat: 33.60667,
    lng: -81.97776,
    city: "North Augusta",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16483,
    density: 117.1,
    county_fips: 45037,
    county_name: "Edgefield",
    county_weights: {
      45003: 14.49,
      45037: 85.51,
    },
    county_names_all: "Edgefield|Aiken",
    county_fips_all: "45037|45003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29899,
    lat: 33.92801,
    lng: -82.25064,
    city: "McCormick",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1037,
    density: 1061.1,
    county_fips: 45065,
    county_name: "McCormick",
    county_weights: {
      45065: 100,
    },
    county_names_all: "McCormick",
    county_fips_all: 45065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29902,
    lat: 32.37426,
    lng: -80.69438,
    city: "Beaufort",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16083,
    density: 342.4,
    county_fips: 45013,
    county_name: "Beaufort",
    county_weights: {
      45013: 100,
    },
    county_names_all: "Beaufort",
    county_fips_all: 45013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29904,
    lat: 32.47899,
    lng: -80.72198,
    city: "Beaufort",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 45013,
    county_name: "Beaufort",
    county_weights: {
      45013: 100,
    },
    county_names_all: "Beaufort",
    county_fips_all: 45013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29905,
    lat: 32.35383,
    lng: -80.69537,
    city: "Parris Island",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1494,
    density: 203.5,
    county_fips: 45013,
    county_name: "Beaufort",
    county_weights: {
      45013: 100,
    },
    county_names_all: "Beaufort",
    county_fips_all: 45013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29906,
    lat: 32.44521,
    lng: -80.75159,
    city: "Beaufort",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28205,
    density: 242.2,
    county_fips: 45013,
    county_name: "Beaufort",
    county_weights: {
      45013: 100,
    },
    county_names_all: "Beaufort",
    county_fips_all: 45013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29907,
    lat: 32.45326,
    lng: -80.60926,
    city: "Beaufort",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15524,
    density: 141.8,
    county_fips: 45013,
    county_name: "Beaufort",
    county_weights: {
      45013: 100,
    },
    county_names_all: "Beaufort",
    county_fips_all: 45013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29909,
    lat: 32.34042,
    lng: -80.85465,
    city: "Okatie",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20554,
    density: 142.6,
    county_fips: 45013,
    county_name: "Beaufort",
    county_weights: {
      45013: 98.36,
      45053: 1.64,
    },
    county_names_all: "Beaufort|Jasper",
    county_fips_all: "45013|45053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29910,
    lat: 32.2204,
    lng: -80.88277,
    city: "Bluffton",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43618,
    density: 161.2,
    county_fips: 45013,
    county_name: "Beaufort",
    county_weights: {
      45013: 100,
    },
    county_names_all: "Beaufort",
    county_fips_all: 45013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29911,
    lat: 32.9327,
    lng: -81.14536,
    city: "Brunson",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1436,
    density: 6.9,
    county_fips: 45049,
    county_name: "Hampton",
    county_weights: {
      45049: 100,
    },
    county_names_all: "Hampton",
    county_fips_all: 45049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29912,
    lat: 32.58262,
    lng: -80.93102,
    city: "Coosawhatchie",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 45053,
    county_name: "Jasper",
    county_weights: {
      45053: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 45053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29915,
    lat: 32.11464,
    lng: -80.86892,
    city: "Daufuskie Island",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 485,
    density: 17.4,
    county_fips: 45013,
    county_name: "Beaufort",
    county_weights: {
      45013: 100,
    },
    county_names_all: "Beaufort",
    county_fips_all: 45013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29916,
    lat: 32.72863,
    lng: -80.95708,
    city: "Early Branch",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2257,
    density: 13.7,
    county_fips: 45049,
    county_name: "Hampton",
    county_weights: {
      45049: 63.06,
      45053: 36.94,
    },
    county_names_all: "Hampton|Jasper",
    county_fips_all: "45049|45053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29918,
    lat: 32.74461,
    lng: -81.24899,
    city: "Estill",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5765,
    density: 20.7,
    county_fips: 45049,
    county_name: "Hampton",
    county_weights: {
      45049: 100,
    },
    county_names_all: "Hampton",
    county_fips_all: 45049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29920,
    lat: 32.36441,
    lng: -80.54946,
    city: "Saint Helena Island",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11042,
    density: 43.7,
    county_fips: 45013,
    county_name: "Beaufort",
    county_weights: {
      45013: 100,
    },
    county_names_all: "Beaufort",
    county_fips_all: 45013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29921,
    lat: 32.68664,
    lng: -81.18011,
    city: "Furman",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 552,
    density: 41.4,
    county_fips: 45049,
    county_name: "Hampton",
    county_weights: {
      45049: 100,
    },
    county_names_all: "Hampton",
    county_fips_all: 45049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29922,
    lat: 32.59632,
    lng: -81.27407,
    city: "Garnett",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 987,
    density: 2.6,
    county_fips: 45049,
    county_name: "Hampton",
    county_weights: {
      45049: 66.78,
      45053: 33.22,
    },
    county_names_all: "Hampton|Jasper",
    county_fips_all: "45049|45053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29923,
    lat: 32.84821,
    lng: -81.23856,
    city: "Gifford",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 203,
    density: 12.7,
    county_fips: 45049,
    county_name: "Hampton",
    county_weights: {
      45049: 100,
    },
    county_names_all: "Hampton",
    county_fips_all: 45049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29924,
    lat: 32.87737,
    lng: -81.10749,
    city: "Hampton",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4515,
    density: 35.7,
    county_fips: 45049,
    county_name: "Hampton",
    county_weights: {
      45049: 100,
    },
    county_names_all: "Hampton",
    county_fips_all: 45049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29926,
    lat: 32.22936,
    lng: -80.74931,
    city: "Hilton Head Island",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27160,
    density: 365.4,
    county_fips: 45013,
    county_name: "Beaufort",
    county_weights: {
      45013: 100,
    },
    county_names_all: "Beaufort",
    county_fips_all: 45013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29927,
    lat: 32.24343,
    lng: -81.04971,
    city: "Hardeeville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9644,
    density: 18.6,
    county_fips: 45053,
    county_name: "Jasper",
    county_weights: {
      45013: 0.34,
      45053: 99.66,
    },
    county_names_all: "Jasper|Beaufort",
    county_fips_all: "45053|45013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29928,
    lat: 32.16214,
    lng: -80.76274,
    city: "Hilton Head Island",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15553,
    density: 290,
    county_fips: 45013,
    county_name: "Beaufort",
    county_weights: {
      45013: 100,
    },
    county_names_all: "Beaufort",
    county_fips_all: 45013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29929,
    lat: 32.93805,
    lng: -80.9434,
    city: "Islandton",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 872,
    density: 4.3,
    county_fips: 45029,
    county_name: "Colleton",
    county_weights: {
      45029: 100,
    },
    county_names_all: "Colleton",
    county_fips_all: 45029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29932,
    lat: 32.82529,
    lng: -81.34853,
    city: "Luray",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 175,
    density: 1,
    county_fips: 45005,
    county_name: "Allendale",
    county_weights: {
      45005: 88.73,
      45049: 11.27,
    },
    county_names_all: "Allendale|Hampton",
    county_fips_all: "45005|45049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29934,
    lat: 32.59651,
    lng: -81.11245,
    city: "Pineland",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 629,
    density: 3.2,
    county_fips: 45053,
    county_name: "Jasper",
    county_weights: {
      45049: 12.58,
      45053: 87.42,
    },
    county_names_all: "Jasper|Hampton",
    county_fips_all: "45053|45049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29935,
    lat: 32.38277,
    lng: -80.6963,
    city: "Port Royal",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4515,
    density: 747.4,
    county_fips: 45013,
    county_name: "Beaufort",
    county_weights: {
      45013: 100,
    },
    county_names_all: "Beaufort",
    county_fips_all: 45013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29936,
    lat: 32.48475,
    lng: -80.96766,
    city: "Ridgeland",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14498,
    density: 24.2,
    county_fips: 45053,
    county_name: "Jasper",
    county_weights: {
      45053: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 45053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29939,
    lat: 32.68127,
    lng: -81.24538,
    city: "Scotia",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 289,
    density: 32.7,
    county_fips: 45049,
    county_name: "Hampton",
    county_weights: {
      45049: 100,
    },
    county_names_all: "Hampton",
    county_fips_all: 45049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29940,
    lat: 32.5524,
    lng: -80.67511,
    city: "Seabrook",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4340,
    density: 22.6,
    county_fips: 45013,
    county_name: "Beaufort",
    county_weights: {
      45013: 100,
    },
    county_names_all: "Beaufort",
    county_fips_all: 45013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29941,
    lat: 32.54357,
    lng: -80.81509,
    city: "Sheldon",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 538,
    density: 13.8,
    county_fips: 45013,
    county_name: "Beaufort",
    county_weights: {
      45013: 100,
    },
    county_names_all: "Beaufort",
    county_fips_all: 45013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29943,
    lat: 32.4821,
    lng: -81.14952,
    city: "Tillman",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 454,
    density: 6.3,
    county_fips: 45053,
    county_name: "Jasper",
    county_weights: {
      45053: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 45053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29944,
    lat: 32.79129,
    lng: -81.03409,
    city: "Varnville",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3790,
    density: 10.8,
    county_fips: 45049,
    county_name: "Hampton",
    county_weights: {
      45049: 86.16,
      45053: 13.84,
    },
    county_names_all: "Hampton|Jasper",
    county_fips_all: "45049|45053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 29945,
    lat: 32.68694,
    lng: -80.80912,
    city: "Yemassee",
    state_id: "SC",
    state_name: "South Carolina",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5544,
    density: 10.4,
    county_fips: 45029,
    county_name: "Colleton",
    county_weights: {
      45013: 27.05,
      45029: 41.83,
      45049: 15.28,
      45053: 15.83,
    },
    county_names_all: "Colleton|Beaufort|Jasper|Hampton",
    county_fips_all: "45029|45013|45053|45049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30002,
    lat: 33.77309,
    lng: -84.26093,
    city: "Avondale Estates",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5902,
    density: 1342.4,
    county_fips: 13089,
    county_name: "DeKalb",
    county_weights: {
      13089: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 13089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30004,
    lat: 34.14352,
    lng: -84.29926,
    city: "Alpharetta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 66538,
    density: 443.4,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13057: 15.64,
      13117: 15.9,
      13121: 68.46,
    },
    county_names_all: "Fulton|Forsyth|Cherokee",
    county_fips_all: "13121|13117|13057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30005,
    lat: 34.08582,
    lng: -84.22158,
    city: "Alpharetta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40213,
    density: 983.3,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13117: 29.49,
      13121: 70.51,
    },
    county_names_all: "Fulton|Forsyth",
    county_fips_all: "13121|13117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30008,
    lat: 33.8966,
    lng: -84.58847,
    city: "Marietta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34709,
    density: 1404.5,
    county_fips: 13067,
    county_name: "Cobb",
    county_weights: {
      13067: 100,
    },
    county_names_all: "Cobb",
    county_fips_all: 13067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30009,
    lat: 34.07711,
    lng: -84.3029,
    city: "Alpharetta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18625,
    density: 789.6,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13121: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 13121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30011,
    lat: 34.02281,
    lng: -83.8364,
    city: "Auburn",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17265,
    density: 248.2,
    county_fips: 13013,
    county_name: "Barrow",
    county_weights: {
      13013: 73.92,
      13135: 26.08,
    },
    county_names_all: "Barrow|Gwinnett",
    county_fips_all: "13013|13135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30012,
    lat: 33.71739,
    lng: -83.99913,
    city: "Conyers",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31427,
    density: 285.9,
    county_fips: 13247,
    county_name: "Rockdale",
    county_weights: {
      13089: 0.59,
      13247: 96.61,
      13297: 2.8,
    },
    county_names_all: "Rockdale|Walton|DeKalb",
    county_fips_all: "13247|13297|13089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30013,
    lat: 33.643,
    lng: -83.97147,
    city: "Conyers",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25218,
    density: 343.4,
    county_fips: 13247,
    county_name: "Rockdale",
    county_weights: {
      13217: 5.06,
      13247: 94.94,
    },
    county_names_all: "Rockdale|Newton",
    county_fips_all: "13247|13217",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30014,
    lat: 33.58109,
    lng: -83.8191,
    city: "Covington",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39352,
    density: 125.9,
    county_fips: 13217,
    county_name: "Newton",
    county_weights: {
      13159: 0.95,
      13217: 77.75,
      13297: 21.3,
    },
    county_names_all: "Newton|Walton|Jasper",
    county_fips_all: "13217|13297|13159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30016,
    lat: 33.51836,
    lng: -83.93073,
    city: "Covington",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56934,
    density: 242.1,
    county_fips: 13217,
    county_name: "Newton",
    county_weights: {
      13217: 99.62,
      13247: 0.38,
    },
    county_names_all: "Newton|Rockdale",
    county_fips_all: "13217|13247",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30017,
    lat: 33.88939,
    lng: -83.96348,
    city: "Grayson",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23788,
    density: 794.6,
    county_fips: 13135,
    county_name: "Gwinnett",
    county_weights: {
      13135: 100,
    },
    county_names_all: "Gwinnett",
    county_fips_all: 13135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30018,
    lat: 33.71737,
    lng: -83.80034,
    city: "Jersey",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 13297,
    county_name: "Walton",
    county_weights: {
      13297: 100,
    },
    county_names_all: "Walton",
    county_fips_all: 13297,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30019,
    lat: 33.97642,
    lng: -83.88252,
    city: "Dacula",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48443,
    density: 399.1,
    county_fips: 13135,
    county_name: "Gwinnett",
    county_weights: {
      13135: 96.05,
      13297: 3.95,
    },
    county_names_all: "Gwinnett|Walton",
    county_fips_all: "13135|13297",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30021,
    lat: 33.80803,
    lng: -84.23909,
    city: "Clarkston",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24138,
    density: 2606.5,
    county_fips: 13089,
    county_name: "DeKalb",
    county_weights: {
      13089: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 13089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30022,
    lat: 34.02745,
    lng: -84.24643,
    city: "Alpharetta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69135,
    density: 1127.5,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13121: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 13121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30024,
    lat: 34.06341,
    lng: -84.09116,
    city: "Suwanee",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 80598,
    density: 747,
    county_fips: 13135,
    county_name: "Gwinnett",
    county_weights: {
      13117: 31.96,
      13121: 2.76,
      13135: 65.28,
    },
    county_names_all: "Gwinnett|Forsyth|Fulton",
    county_fips_all: "13135|13117|13121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30025,
    lat: 33.65689,
    lng: -83.69869,
    city: "Social Circle",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10689,
    density: 58.7,
    county_fips: 13297,
    county_name: "Walton",
    county_weights: {
      13211: 1.04,
      13217: 28.3,
      13297: 70.66,
    },
    county_names_all: "Walton|Newton|Morgan",
    county_fips_all: "13297|13217|13211",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30028,
    lat: 34.28928,
    lng: -84.17985,
    city: "Cumming",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30609,
    density: 236.5,
    county_fips: 13117,
    county_name: "Forsyth",
    county_weights: {
      13057: 7.29,
      13117: 92.71,
    },
    county_names_all: "Forsyth|Cherokee",
    county_fips_all: "13117|13057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30030,
    lat: 33.7721,
    lng: -84.29135,
    city: "Decatur",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31856,
    density: 1826.1,
    county_fips: 13089,
    county_name: "DeKalb",
    county_weights: {
      13089: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 13089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30032,
    lat: 33.73987,
    lng: -84.2641,
    city: "Decatur",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47267,
    density: 1337.1,
    county_fips: 13089,
    county_name: "DeKalb",
    county_weights: {
      13089: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 13089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30033,
    lat: 33.81342,
    lng: -84.28355,
    city: "Decatur",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32782,
    density: 1433,
    county_fips: 13089,
    county_name: "DeKalb",
    county_weights: {
      13089: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 13089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30034,
    lat: 33.69198,
    lng: -84.24835,
    city: "Decatur",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45968,
    density: 1057,
    county_fips: 13089,
    county_name: "DeKalb",
    county_weights: {
      13089: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 13089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30035,
    lat: 33.72563,
    lng: -84.20541,
    city: "Decatur",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23087,
    density: 1045.5,
    county_fips: 13089,
    county_name: "DeKalb",
    county_weights: {
      13089: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 13089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30038,
    lat: 33.67078,
    lng: -84.14209,
    city: "Lithonia",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39543,
    density: 530.1,
    county_fips: 13089,
    county_name: "DeKalb",
    county_weights: {
      13089: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 13089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30039,
    lat: 33.79871,
    lng: -84.03414,
    city: "Snellville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46640,
    density: 712.5,
    county_fips: 13135,
    county_name: "Gwinnett",
    county_weights: {
      13089: 5.69,
      13135: 94.31,
    },
    county_names_all: "Gwinnett|DeKalb",
    county_fips_all: "13135|13089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30040,
    lat: 34.21622,
    lng: -84.17978,
    city: "Cumming",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 72858,
    density: 487.8,
    county_fips: 13117,
    county_name: "Forsyth",
    county_weights: {
      13057: 2.16,
      13117: 97.84,
    },
    county_names_all: "Forsyth|Cherokee",
    county_fips_all: "13117|13057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30041,
    lat: 34.20166,
    lng: -84.09371,
    city: "Cumming",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 71750,
    density: 464,
    county_fips: 13117,
    county_name: "Forsyth",
    county_weights: {
      13117: 100,
    },
    county_names_all: "Forsyth",
    county_fips_all: 13117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30043,
    lat: 34.00353,
    lng: -84.00703,
    city: "Lawrenceville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 88276,
    density: 1030.5,
    county_fips: 13135,
    county_name: "Gwinnett",
    county_weights: {
      13135: 100,
    },
    county_names_all: "Gwinnett",
    county_fips_all: 13135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30044,
    lat: 33.92207,
    lng: -84.06924,
    city: "Lawrenceville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 93987,
    density: 1461.4,
    county_fips: 13135,
    county_name: "Gwinnett",
    county_weights: {
      13135: 100,
    },
    county_names_all: "Gwinnett",
    county_fips_all: 13135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30045,
    lat: 33.93046,
    lng: -83.93019,
    city: "Lawrenceville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46088,
    density: 837,
    county_fips: 13135,
    county_name: "Gwinnett",
    county_weights: {
      13135: 100,
    },
    county_names_all: "Gwinnett",
    county_fips_all: 13135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30046,
    lat: 33.9497,
    lng: -83.99389,
    city: "Lawrenceville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37919,
    density: 924.9,
    county_fips: 13135,
    county_name: "Gwinnett",
    county_weights: {
      13135: 100,
    },
    county_names_all: "Gwinnett",
    county_fips_all: 13135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30047,
    lat: 33.87104,
    lng: -84.11304,
    city: "Lilburn",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68700,
    density: 969.2,
    county_fips: 13135,
    county_name: "Gwinnett",
    county_weights: {
      13135: 100,
    },
    county_names_all: "Gwinnett",
    county_fips_all: 13135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30052,
    lat: 33.81654,
    lng: -83.89538,
    city: "Loganville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69518,
    density: 301.9,
    county_fips: 13297,
    county_name: "Walton",
    county_weights: {
      13135: 27.12,
      13217: 1.3,
      13247: 4.61,
      13297: 66.97,
    },
    county_names_all: "Walton|Gwinnett|Rockdale|Newton",
    county_fips_all: "13297|13135|13247|13217",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30054,
    lat: 33.67651,
    lng: -83.87558,
    city: "Oxford",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11867,
    density: 111.9,
    county_fips: 13217,
    county_name: "Newton",
    county_weights: {
      13217: 85.03,
      13297: 14.97,
    },
    county_names_all: "Newton|Walton",
    county_fips_all: "13217|13297",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30055,
    lat: 33.49055,
    lng: -83.74224,
    city: "Mansfield",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3788,
    density: 27.5,
    county_fips: 13217,
    county_name: "Newton",
    county_weights: {
      13159: 38.87,
      13211: 11.96,
      13217: 49.17,
    },
    county_names_all: "Newton|Jasper|Morgan",
    county_fips_all: "13217|13159|13211",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30056,
    lat: 33.49496,
    lng: -83.65068,
    city: "Newborn",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2518,
    density: 22.2,
    county_fips: 13159,
    county_name: "Jasper",
    county_weights: {
      13159: 47.85,
      13211: 38.36,
      13217: 13.8,
    },
    county_names_all: "Jasper|Morgan|Newton",
    county_fips_all: "13159|13211|13217",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30058,
    lat: 33.7377,
    lng: -84.10779,
    city: "Lithonia",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61247,
    density: 774.5,
    county_fips: 13089,
    county_name: "DeKalb",
    county_weights: {
      13089: 99.51,
      13247: 0.49,
    },
    county_names_all: "DeKalb|Rockdale",
    county_fips_all: "13089|13247",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30060,
    lat: 33.9209,
    lng: -84.543,
    city: "Marietta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40055,
    density: 997.5,
    county_fips: 13067,
    county_name: "Cobb",
    county_weights: {
      13067: 100,
    },
    county_names_all: "Cobb",
    county_fips_all: 13067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30062,
    lat: 33.99977,
    lng: -84.46899,
    city: "Marietta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63906,
    density: 953.6,
    county_fips: 13067,
    county_name: "Cobb",
    county_weights: {
      13067: 100,
    },
    county_names_all: "Cobb",
    county_fips_all: 13067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30064,
    lat: 33.93809,
    lng: -84.61691,
    city: "Marietta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49849,
    density: 626.5,
    county_fips: 13067,
    county_name: "Cobb",
    county_weights: {
      13067: 100,
    },
    county_names_all: "Cobb",
    county_fips_all: 13067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30066,
    lat: 34.034,
    lng: -84.50798,
    city: "Marietta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57953,
    density: 823.9,
    county_fips: 13067,
    county_name: "Cobb",
    county_weights: {
      13067: 100,
    },
    county_names_all: "Cobb",
    county_fips_all: 13067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30067,
    lat: 33.93286,
    lng: -84.46187,
    city: "Marietta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46482,
    density: 1248.9,
    county_fips: 13067,
    county_name: "Cobb",
    county_weights: {
      13067: 100,
    },
    county_names_all: "Cobb",
    county_fips_all: 13067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30068,
    lat: 33.96887,
    lng: -84.43273,
    city: "Marietta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32798,
    density: 879.2,
    county_fips: 13067,
    county_name: "Cobb",
    county_weights: {
      13067: 100,
    },
    county_names_all: "Cobb",
    county_fips_all: 13067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30070,
    lat: 33.5733,
    lng: -83.89546,
    city: "Porterdale",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 444,
    density: 6604.8,
    county_fips: 13217,
    county_name: "Newton",
    county_weights: {
      13217: 100,
    },
    county_names_all: "Newton",
    county_fips_all: 13217,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30071,
    lat: 33.93977,
    lng: -84.20561,
    city: "Norcross",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25865,
    density: 825.5,
    county_fips: 13135,
    county_name: "Gwinnett",
    county_weights: {
      13135: 100,
    },
    county_names_all: "Gwinnett",
    county_fips_all: 13135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30072,
    lat: 33.79115,
    lng: -84.20598,
    city: "Pine Lake",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 806,
    density: 2427,
    county_fips: 13089,
    county_name: "DeKalb",
    county_weights: {
      13089: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 13089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30075,
    lat: 34.05282,
    lng: -84.38739,
    city: "Roswell",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55945,
    density: 726.5,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13057: 1.7,
      13067: 14.03,
      13121: 84.27,
    },
    county_names_all: "Fulton|Cobb|Cherokee",
    county_fips_all: "13121|13067|13057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30076,
    lat: 34.02777,
    lng: -84.31723,
    city: "Roswell",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46739,
    density: 1126,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13121: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 13121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30078,
    lat: 33.86118,
    lng: -84.01795,
    city: "Snellville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38472,
    density: 858.3,
    county_fips: 13135,
    county_name: "Gwinnett",
    county_weights: {
      13135: 100,
    },
    county_names_all: "Gwinnett",
    county_fips_all: 13135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30079,
    lat: 33.79173,
    lng: -84.25839,
    city: "Scottdale",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3846,
    density: 1266.9,
    county_fips: 13089,
    county_name: "DeKalb",
    county_weights: {
      13089: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 13089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30080,
    lat: 33.87864,
    lng: -84.5053,
    city: "Smyrna",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58806,
    density: 1800.2,
    county_fips: 13067,
    county_name: "Cobb",
    county_weights: {
      13067: 100,
    },
    county_names_all: "Cobb",
    county_fips_all: 13067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30082,
    lat: 33.85517,
    lng: -84.5373,
    city: "Smyrna",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26442,
    density: 970.6,
    county_fips: 13067,
    county_name: "Cobb",
    county_weights: {
      13067: 100,
    },
    county_names_all: "Cobb",
    county_fips_all: 13067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30083,
    lat: 33.79641,
    lng: -84.19231,
    city: "Stone Mountain",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59798,
    density: 1293,
    county_fips: 13089,
    county_name: "DeKalb",
    county_weights: {
      13089: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 13089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30084,
    lat: 33.85457,
    lng: -84.21657,
    city: "Tucker",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37354,
    density: 969.2,
    county_fips: 13089,
    county_name: "DeKalb",
    county_weights: {
      13089: 82.46,
      13135: 17.54,
    },
    county_names_all: "DeKalb|Gwinnett",
    county_fips_all: "13089|13135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30087,
    lat: 33.81087,
    lng: -84.13135,
    city: "Stone Mountain",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38304,
    density: 653.7,
    county_fips: 13089,
    county_name: "DeKalb",
    county_weights: {
      13089: 68.66,
      13135: 31.34,
    },
    county_names_all: "DeKalb|Gwinnett",
    county_fips_all: "13089|13135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30088,
    lat: 33.75959,
    lng: -84.17918,
    city: "Stone Mountain",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30760,
    density: 1514.5,
    county_fips: 13089,
    county_name: "DeKalb",
    county_weights: {
      13089: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 13089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30090,
    lat: 33.953,
    lng: -84.54837,
    city: "Marietta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 13067,
    county_name: "Cobb",
    county_weights: {
      13067: 100,
    },
    county_names_all: "Cobb",
    county_fips_all: 13067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30092,
    lat: 33.97145,
    lng: -84.23537,
    city: "Peachtree Corners",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37025,
    density: 1279,
    county_fips: 13135,
    county_name: "Gwinnett",
    county_weights: {
      13121: 1.51,
      13135: 98.49,
    },
    county_names_all: "Gwinnett|Fulton",
    county_fips_all: "13135|13121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30093,
    lat: 33.90879,
    lng: -84.17839,
    city: "Norcross",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53896,
    density: 1733.7,
    county_fips: 13135,
    county_name: "Gwinnett",
    county_weights: {
      13135: 100,
    },
    county_names_all: "Gwinnett",
    county_fips_all: 13135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30094,
    lat: 33.61243,
    lng: -84.0555,
    city: "Conyers",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32359,
    density: 318,
    county_fips: 13247,
    county_name: "Rockdale",
    county_weights: {
      13089: 0.62,
      13247: 99.38,
    },
    county_names_all: "Rockdale|DeKalb",
    county_fips_all: "13247|13089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30096,
    lat: 33.97691,
    lng: -84.14791,
    city: "Duluth",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68570,
    density: 1163.9,
    county_fips: 13135,
    county_name: "Gwinnett",
    county_weights: {
      13135: 100,
    },
    county_names_all: "Gwinnett",
    county_fips_all: 13135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30097,
    lat: 34.0271,
    lng: -84.14702,
    city: "Duluth",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45894,
    density: 753.3,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13117: 7.31,
      13121: 49.66,
      13135: 43.03,
    },
    county_names_all: "Fulton|Gwinnett|Forsyth",
    county_fips_all: "13121|13135|13117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30101,
    lat: 34.04355,
    lng: -84.71244,
    city: "Acworth",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58844,
    density: 554.7,
    county_fips: 13067,
    county_name: "Cobb",
    county_weights: {
      13015: 5.54,
      13057: 0.57,
      13067: 68.6,
      13223: 25.29,
    },
    county_names_all: "Cobb|Paulding|Bartow|Cherokee",
    county_fips_all: "13067|13223|13015|13057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30102,
    lat: 34.10857,
    lng: -84.64622,
    city: "Acworth",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42232,
    density: 518.8,
    county_fips: 13057,
    county_name: "Cherokee",
    county_weights: {
      13015: 43.42,
      13057: 46.5,
      13067: 10.08,
    },
    county_names_all: "Cherokee|Bartow|Cobb",
    county_fips_all: "13057|13015|13067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30103,
    lat: 34.36457,
    lng: -84.92014,
    city: "Adairsville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15246,
    density: 56.7,
    county_fips: 13015,
    county_name: "Bartow",
    county_weights: {
      13015: 68.57,
      13115: 7.4,
      13129: 24.03,
    },
    county_names_all: "Bartow|Gordon|Floyd",
    county_fips_all: "13015|13129|13115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30104,
    lat: 34.0879,
    lng: -85.06982,
    city: "Aragon",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5552,
    density: 63.1,
    county_fips: 13233,
    county_name: "Polk",
    county_weights: {
      13015: 12.22,
      13115: 30.96,
      13233: 56.82,
    },
    county_names_all: "Polk|Floyd|Bartow",
    county_fips_all: "13233|13115|13015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30105,
    lat: 34.47012,
    lng: -85.15532,
    city: "Armuchee",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1947,
    density: 13.8,
    county_fips: 13115,
    county_name: "Floyd",
    county_weights: {
      13055: 19.24,
      13115: 80.76,
    },
    county_names_all: "Floyd|Chattooga",
    county_fips_all: "13115|13055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30106,
    lat: 33.83476,
    lng: -84.62947,
    city: "Austell",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22433,
    density: 687.5,
    county_fips: 13067,
    county_name: "Cobb",
    county_weights: {
      13067: 97.66,
      13097: 2.34,
    },
    county_names_all: "Cobb|Douglas",
    county_fips_all: "13067|13097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30107,
    lat: 34.3352,
    lng: -84.34744,
    city: "Ball Ground",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14083,
    density: 50.3,
    county_fips: 13057,
    county_name: "Cherokee",
    county_weights: {
      13057: 80.47,
      13117: 4.56,
      13227: 14.97,
    },
    county_names_all: "Cherokee|Pickens|Forsyth",
    county_fips_all: "13057|13227|13117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30108,
    lat: 33.53172,
    lng: -85.26242,
    city: "Bowdon",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8494,
    density: 36.7,
    county_fips: 13045,
    county_name: "Carroll",
    county_weights: {
      13045: 96.4,
      13149: 3.6,
    },
    county_names_all: "Carroll|Heard",
    county_fips_all: "13045|13149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30110,
    lat: 33.74071,
    lng: -85.137,
    city: "Bremen",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14232,
    density: 76.3,
    county_fips: 13143,
    county_name: "Haralson",
    county_weights: {
      13045: 10.57,
      13143: 89.43,
    },
    county_names_all: "Haralson|Carroll",
    county_fips_all: "13143|13045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30111,
    lat: 33.8318,
    lng: -84.65499,
    city: "Clarkdale",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 13067,
    county_name: "Cobb",
    county_weights: {
      13067: 100,
    },
    county_names_all: "Cobb",
    county_fips_all: 13067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30113,
    lat: 33.8531,
    lng: -85.20967,
    city: "Buchanan",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6152,
    density: 23.3,
    county_fips: 13143,
    county_name: "Haralson",
    county_weights: {
      13143: 92.38,
      13233: 7.62,
    },
    county_names_all: "Haralson|Polk",
    county_fips_all: "13143|13233",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30114,
    lat: 34.24433,
    lng: -84.5393,
    city: "Canton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57013,
    density: 231.3,
    county_fips: 13057,
    county_name: "Cherokee",
    county_weights: {
      13057: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 13057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30115,
    lat: 34.21296,
    lng: -84.40138,
    city: "Canton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44811,
    density: 236.4,
    county_fips: 13057,
    county_name: "Cherokee",
    county_weights: {
      13057: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 13057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30116,
    lat: 33.55224,
    lng: -85.01298,
    city: "Carrollton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23886,
    density: 87.9,
    county_fips: 13045,
    county_name: "Carroll",
    county_weights: {
      13045: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 13045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30117,
    lat: 33.58113,
    lng: -85.13197,
    city: "Carrollton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35097,
    density: 125.4,
    county_fips: 13045,
    county_name: "Carroll",
    county_weights: {
      13045: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 13045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30118,
    lat: 33.57288,
    lng: -85.09938,
    city: "Carrollton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2118,
    density: 4080.1,
    county_fips: 13045,
    county_name: "Carroll",
    county_weights: {
      13045: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 13045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30120,
    lat: 34.16639,
    lng: -84.85597,
    city: "Cartersville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40008,
    density: 166.1,
    county_fips: 13015,
    county_name: "Bartow",
    county_weights: {
      13015: 99.62,
      13223: 0.38,
    },
    county_names_all: "Bartow|Paulding",
    county_fips_all: "13015|13223",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30121,
    lat: 34.21073,
    lng: -84.77802,
    city: "Cartersville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25309,
    density: 169.4,
    county_fips: 13015,
    county_name: "Bartow",
    county_weights: {
      13015: 100,
    },
    county_names_all: "Bartow",
    county_fips_all: 13015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30122,
    lat: 33.76329,
    lng: -84.6386,
    city: "Lithia Springs",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27580,
    density: 430.4,
    county_fips: 13097,
    county_name: "Douglas",
    county_weights: {
      13067: 0.62,
      13097: 99.38,
    },
    county_names_all: "Douglas|Cobb",
    county_fips_all: "13097|13067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30124,
    lat: 34.12872,
    lng: -85.35589,
    city: "Cave Spring",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3048,
    density: 19.6,
    county_fips: 13115,
    county_name: "Floyd",
    county_weights: {
      13115: 98.94,
      13233: 1.06,
    },
    county_names_all: "Floyd|Polk",
    county_fips_all: "13115|13233",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30125,
    lat: 34.00067,
    lng: -85.27331,
    city: "Cedartown",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23793,
    density: 50.4,
    county_fips: 13233,
    county_name: "Polk",
    county_weights: {
      13115: 2.22,
      13143: 0.51,
      13233: 97.27,
    },
    county_names_all: "Polk|Floyd|Haralson",
    county_fips_all: "13233|13115|13143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30126,
    lat: 33.81588,
    lng: -84.55171,
    city: "Mableton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42794,
    density: 805.3,
    county_fips: 13067,
    county_name: "Cobb",
    county_weights: {
      13067: 100,
    },
    county_names_all: "Cobb",
    county_fips_all: 13067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30127,
    lat: 33.87647,
    lng: -84.69648,
    city: "Powder Springs",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 71709,
    density: 539.4,
    county_fips: 13067,
    county_name: "Cobb",
    county_weights: {
      13067: 84.59,
      13223: 15.41,
    },
    county_names_all: "Cobb|Paulding",
    county_fips_all: "13067|13223",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30132,
    lat: 33.99042,
    lng: -84.85279,
    city: "Dallas",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47378,
    density: 178.6,
    county_fips: 13223,
    county_name: "Paulding",
    county_weights: {
      13223: 100,
    },
    county_names_all: "Paulding",
    county_fips_all: 13223,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30134,
    lat: 33.77436,
    lng: -84.78241,
    city: "Douglasville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43504,
    density: 322.6,
    county_fips: 13097,
    county_name: "Douglas",
    county_weights: {
      13097: 67.5,
      13223: 32.5,
    },
    county_names_all: "Douglas|Paulding",
    county_fips_all: "13097|13223",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30135,
    lat: 33.67285,
    lng: -84.74523,
    city: "Douglasville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67853,
    density: 313.4,
    county_fips: 13097,
    county_name: "Douglas",
    county_weights: {
      13097: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 13097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30137,
    lat: 34.11657,
    lng: -84.7657,
    city: "Emerson",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2060,
    density: 249.2,
    county_fips: 13015,
    county_name: "Bartow",
    county_weights: {
      13015: 100,
    },
    county_names_all: "Bartow",
    county_fips_all: 13015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30139,
    lat: 34.43346,
    lng: -84.70575,
    city: "Fairmount",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4147,
    density: 22.1,
    county_fips: 13129,
    county_name: "Gordon",
    county_weights: {
      13015: 18.06,
      13129: 60.23,
      13227: 21.71,
    },
    county_names_all: "Gordon|Pickens|Bartow",
    county_fips_all: "13129|13227|13015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30141,
    lat: 33.86244,
    lng: -84.77521,
    city: "Hiram",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26494,
    density: 370.3,
    county_fips: 13223,
    county_name: "Paulding",
    county_weights: {
      13067: 0.24,
      13223: 99.76,
    },
    county_names_all: "Paulding|Cobb",
    county_fips_all: "13223|13067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30143,
    lat: 34.46198,
    lng: -84.42385,
    city: "Jasper",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22726,
    density: 60.4,
    county_fips: 13227,
    county_name: "Pickens",
    county_weights: {
      13057: 2.02,
      13085: 9.89,
      13227: 88.09,
    },
    county_names_all: "Pickens|Dawson|Cherokee",
    county_fips_all: "13227|13085|13057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30144,
    lat: 34.03672,
    lng: -84.59174,
    city: "Kennesaw",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59085,
    density: 1030.9,
    county_fips: 13067,
    county_name: "Cobb",
    county_weights: {
      13067: 100,
    },
    county_names_all: "Cobb",
    county_fips_all: 13067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30145,
    lat: 34.24177,
    lng: -84.98076,
    city: "Kingston",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8807,
    density: 45.7,
    county_fips: 13015,
    county_name: "Bartow",
    county_weights: {
      13015: 82,
      13115: 18,
    },
    county_names_all: "Bartow|Floyd",
    county_fips_all: "13015|13115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30147,
    lat: 34.13751,
    lng: -85.21877,
    city: "Lindale",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5901,
    density: 120.8,
    county_fips: 13115,
    county_name: "Floyd",
    county_weights: {
      13115: 92.54,
      13233: 7.46,
    },
    county_names_all: "Floyd|Polk",
    county_fips_all: "13115|13233",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30148,
    lat: 34.46009,
    lng: -84.2648,
    city: "Marble Hill",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 637,
    density: 24.9,
    county_fips: 13085,
    county_name: "Dawson",
    county_weights: {
      13085: 54.36,
      13227: 45.64,
    },
    county_names_all: "Dawson|Pickens",
    county_fips_all: "13085|13227",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30149,
    lat: 34.31107,
    lng: -85.21691,
    city: "Mount Berry",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1966,
    density: 113.1,
    county_fips: 13115,
    county_name: "Floyd",
    county_weights: {
      13115: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 13115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30152,
    lat: 33.99435,
    lng: -84.6474,
    city: "Kennesaw",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44115,
    density: 762.9,
    county_fips: 13067,
    county_name: "Cobb",
    county_weights: {
      13067: 100,
    },
    county_names_all: "Cobb",
    county_fips_all: 13067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30153,
    lat: 33.96678,
    lng: -85.05425,
    city: "Rockmart",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17906,
    density: 56.1,
    county_fips: 13233,
    county_name: "Polk",
    county_weights: {
      13143: 9.14,
      13223: 19.96,
      13233: 70.9,
    },
    county_names_all: "Polk|Paulding|Haralson",
    county_fips_all: "13233|13223|13143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30157,
    lat: 33.88641,
    lng: -84.8731,
    city: "Dallas",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48446,
    density: 219.8,
    county_fips: 13223,
    county_name: "Paulding",
    county_weights: {
      13067: 1,
      13223: 99,
    },
    county_names_all: "Paulding|Cobb",
    county_fips_all: "13223|13067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30161,
    lat: 34.23758,
    lng: -85.17319,
    city: "Rome",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35344,
    density: 95.3,
    county_fips: 13115,
    county_name: "Floyd",
    county_weights: {
      13015: 1.49,
      13115: 98.51,
    },
    county_names_all: "Floyd|Bartow",
    county_fips_all: "13115|13015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30165,
    lat: 34.30279,
    lng: -85.27233,
    city: "Rome",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40349,
    density: 93.3,
    county_fips: 13115,
    county_name: "Floyd",
    county_weights: {
      13055: 0.92,
      13115: 98.15,
      "01019": 0.93,
    },
    county_names_all: "Floyd|Cherokee|Chattooga",
    county_fips_all: "13115|01019|13055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30168,
    lat: 33.78354,
    lng: -84.58765,
    city: "Austell",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24936,
    density: 778.5,
    county_fips: 13067,
    county_name: "Cobb",
    county_weights: {
      13067: 90.63,
      13097: 9.37,
    },
    county_names_all: "Cobb|Douglas",
    county_fips_all: "13067|13097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30170,
    lat: 33.43065,
    lng: -85.16821,
    city: "Roopville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2986,
    density: 25.4,
    county_fips: 13045,
    county_name: "Carroll",
    county_weights: {
      13045: 52.09,
      13149: 47.91,
    },
    county_names_all: "Carroll|Heard",
    county_fips_all: "13045|13149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30171,
    lat: 34.36122,
    lng: -84.73584,
    city: "Rydal",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2893,
    density: 27.1,
    county_fips: 13015,
    county_name: "Bartow",
    county_weights: {
      13015: 85.87,
      13129: 14.13,
    },
    county_names_all: "Bartow|Gordon",
    county_fips_all: "13015|13129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30173,
    lat: 34.13541,
    lng: -85.14217,
    city: "Silver Creek",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5679,
    density: 62.8,
    county_fips: 13115,
    county_name: "Floyd",
    county_weights: {
      13115: 90.38,
      13233: 9.62,
    },
    county_names_all: "Floyd|Polk",
    county_fips_all: "13115|13233",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30175,
    lat: 34.54239,
    lng: -84.52793,
    city: "Talking Rock",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5526,
    density: 24.5,
    county_fips: 13227,
    county_name: "Pickens",
    county_weights: {
      13123: 42.8,
      13227: 57.2,
    },
    county_names_all: "Pickens|Gilmer",
    county_fips_all: "13227|13123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30176,
    lat: 33.76972,
    lng: -85.30398,
    city: "Tallapoosa",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7221,
    density: 33.5,
    county_fips: 13143,
    county_name: "Haralson",
    county_weights: {
      13143: 100,
    },
    county_names_all: "Haralson",
    county_fips_all: 13143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30177,
    lat: 34.40705,
    lng: -84.37401,
    city: "Tate",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1759,
    density: 187.2,
    county_fips: 13227,
    county_name: "Pickens",
    county_weights: {
      13227: 100,
    },
    county_names_all: "Pickens",
    county_fips_all: 13227,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30178,
    lat: 34.09709,
    lng: -84.97051,
    city: "Taylorsville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3024,
    density: 19.8,
    county_fips: 13015,
    county_name: "Bartow",
    county_weights: {
      13015: 60.87,
      13223: 16.76,
      13233: 22.37,
    },
    county_names_all: "Bartow|Polk|Paulding",
    county_fips_all: "13015|13233|13223",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30179,
    lat: 33.78088,
    lng: -85.01961,
    city: "Temple",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16763,
    density: 88.2,
    county_fips: 13045,
    county_name: "Carroll",
    county_weights: {
      13045: 52,
      13143: 20.8,
      13223: 27.2,
    },
    county_names_all: "Carroll|Paulding|Haralson",
    county_fips_all: "13045|13223|13143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30180,
    lat: 33.72018,
    lng: -84.91956,
    city: "Villa Rica",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38203,
    density: 190.5,
    county_fips: 13045,
    county_name: "Carroll",
    county_weights: {
      13045: 62.78,
      13097: 27.52,
      13223: 9.7,
    },
    county_names_all: "Carroll|Douglas|Paulding",
    county_fips_all: "13045|13097|13223",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30182,
    lat: 33.65603,
    lng: -85.24628,
    city: "Waco",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3178,
    density: 34.9,
    county_fips: 13045,
    county_name: "Carroll",
    county_weights: {
      13045: 63.53,
      13143: 36.47,
    },
    county_names_all: "Carroll|Haralson",
    county_fips_all: "13045|13143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30183,
    lat: 34.33854,
    lng: -84.59762,
    city: "Waleska",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6772,
    density: 41.6,
    county_fips: 13057,
    county_name: "Cherokee",
    county_weights: {
      13015: 0.43,
      13057: 95.96,
      13227: 3.61,
    },
    county_names_all: "Cherokee|Pickens|Bartow",
    county_fips_all: "13057|13227|13015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30184,
    lat: 34.26042,
    lng: -84.71603,
    city: "White",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6535,
    density: 33.1,
    county_fips: 13015,
    county_name: "Bartow",
    county_weights: {
      13015: 89.36,
      13057: 10.64,
    },
    county_names_all: "Bartow|Cherokee",
    county_fips_all: "13015|13057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30185,
    lat: 33.51975,
    lng: -84.90879,
    city: "Whitesburg",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4578,
    density: 28.4,
    county_fips: 13045,
    county_name: "Carroll",
    county_weights: {
      13045: 95.5,
      13097: 4.5,
    },
    county_names_all: "Carroll|Douglas",
    county_fips_all: "13045|13097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30187,
    lat: 33.65736,
    lng: -84.85454,
    city: "Winston",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7123,
    density: 87.4,
    county_fips: 13097,
    county_name: "Douglas",
    county_weights: {
      13045: 1.49,
      13097: 98.51,
    },
    county_names_all: "Douglas|Carroll",
    county_fips_all: "13097|13045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30188,
    lat: 34.11873,
    lng: -84.45526,
    city: "Woodstock",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63869,
    density: 564.6,
    county_fips: 13057,
    county_name: "Cherokee",
    county_weights: {
      13057: 99.08,
      13067: 0.92,
    },
    county_names_all: "Cherokee|Cobb",
    county_fips_all: "13057|13067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30189,
    lat: 34.12835,
    lng: -84.57148,
    city: "Woodstock",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39522,
    density: 793.7,
    county_fips: 13057,
    county_name: "Cherokee",
    county_weights: {
      13057: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 13057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30204,
    lat: 33.05844,
    lng: -84.12343,
    city: "Barnesville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13735,
    density: 42.3,
    county_fips: 13171,
    county_name: "Lamar",
    county_weights: {
      13171: 91.93,
      13207: 3.92,
      13293: 4.15,
    },
    county_names_all: "Lamar|Upson|Monroe",
    county_fips_all: "13171|13293|13207",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30205,
    lat: 33.26911,
    lng: -84.46634,
    city: "Brooks",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3147,
    density: 33.1,
    county_fips: 13113,
    county_name: "Fayette",
    county_weights: {
      13113: 60.8,
      13255: 39.2,
    },
    county_names_all: "Fayette|Spalding",
    county_fips_all: "13113|13255",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30206,
    lat: 33.09671,
    lng: -84.46303,
    city: "Concord",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3763,
    density: 29.4,
    county_fips: 13231,
    county_name: "Pike",
    county_weights: {
      13231: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 13231,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30213,
    lat: 33.59113,
    lng: -84.6333,
    city: "Fairburn",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37948,
    density: 235.8,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13113: 0.22,
      13121: 99.78,
    },
    county_names_all: "Fulton|Fayette",
    county_fips_all: "13121|13113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30214,
    lat: 33.49222,
    lng: -84.48697,
    city: "Fayetteville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30232,
    density: 221.6,
    county_fips: 13113,
    county_name: "Fayette",
    county_weights: {
      13113: 99.62,
      13121: 0.38,
    },
    county_names_all: "Fayette|Fulton",
    county_fips_all: "13113|13121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30215,
    lat: 33.3888,
    lng: -84.45709,
    city: "Fayetteville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36953,
    density: 201.3,
    county_fips: 13113,
    county_name: "Fayette",
    county_weights: {
      13063: 2.31,
      13113: 97.69,
    },
    county_names_all: "Fayette|Clayton",
    county_fips_all: "13113|13063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30216,
    lat: 33.23951,
    lng: -83.88162,
    city: "Flovilla",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2112,
    density: 20.6,
    county_fips: 13035,
    county_name: "Butts",
    county_weights: {
      13035: 99.88,
      13207: 0.12,
    },
    county_names_all: "Butts|Monroe",
    county_fips_all: "13035|13207",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30217,
    lat: 33.28671,
    lng: -85.13309,
    city: "Franklin",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9595,
    density: 14.6,
    county_fips: 13149,
    county_name: "Heard",
    county_weights: {
      13149: 96.73,
      13285: 3.27,
    },
    county_names_all: "Heard|Troup",
    county_fips_all: "13149|13285",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30218,
    lat: 33.12706,
    lng: -84.58093,
    city: "Gay",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2134,
    density: 12.5,
    county_fips: 13199,
    county_name: "Meriwether",
    county_weights: {
      13199: 100,
    },
    county_names_all: "Meriwether",
    county_fips_all: 13199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30220,
    lat: 33.22849,
    lng: -84.82463,
    city: "Grantville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6216,
    density: 47.1,
    county_fips: 13077,
    county_name: "Coweta",
    county_weights: {
      13077: 56.63,
      13199: 43.37,
    },
    county_names_all: "Coweta|Meriwether",
    county_fips_all: "13077|13199",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30222,
    lat: 33.04113,
    lng: -84.74294,
    city: "Greenville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4101,
    density: 10.5,
    county_fips: 13199,
    county_name: "Meriwether",
    county_weights: {
      13199: 100,
    },
    county_names_all: "Meriwether",
    county_fips_all: 13199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30223,
    lat: 33.28635,
    lng: -84.28012,
    city: "Griffin",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36797,
    density: 131.6,
    county_fips: 13255,
    county_name: "Spalding",
    county_weights: {
      13255: 100,
    },
    county_names_all: "Spalding",
    county_fips_all: 13255,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30224,
    lat: 33.20411,
    lng: -84.23587,
    city: "Griffin",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27139,
    density: 154.9,
    county_fips: 13255,
    county_name: "Spalding",
    county_weights: {
      13171: 10.12,
      13231: 15.19,
      13255: 74.69,
    },
    county_names_all: "Spalding|Pike|Lamar",
    county_fips_all: "13255|13231|13171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30228,
    lat: 33.40374,
    lng: -84.30575,
    city: "Hampton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43753,
    density: 231,
    county_fips: 13151,
    county_name: "Henry",
    county_weights: {
      13063: 28.22,
      13151: 66.13,
      13255: 5.65,
    },
    county_names_all: "Henry|Clayton|Spalding",
    county_fips_all: "13151|13063|13255",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30229,
    lat: 33.22791,
    lng: -84.57033,
    city: "Haralson",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 13077,
    county_name: "Coweta",
    county_weights: {
      13077: 100,
    },
    county_names_all: "Coweta",
    county_fips_all: 13077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30230,
    lat: 33.16699,
    lng: -84.92071,
    city: "Hogansville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9727,
    density: 26.9,
    county_fips: 13285,
    county_name: "Troup",
    county_weights: {
      13077: 5.1,
      13149: 16.59,
      13199: 22.01,
      13285: 56.3,
    },
    county_names_all: "Troup|Meriwether|Heard|Coweta",
    county_fips_all: "13285|13199|13149|13077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30233,
    lat: 33.29492,
    lng: -83.97501,
    city: "Jackson",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24398,
    density: 63.7,
    county_fips: 13035,
    county_name: "Butts",
    county_weights: {
      13035: 86.7,
      13151: 4.37,
      13171: 2.99,
      13207: 5.76,
      13217: 0.18,
    },
    county_names_all: "Butts|Monroe|Henry|Lamar|Newton",
    county_fips_all: "13035|13207|13151|13171|13217",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30234,
    lat: 33.33001,
    lng: -84.02617,
    city: "Jenkinsburg",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1480,
    density: 56,
    county_fips: 13035,
    county_name: "Butts",
    county_weights: {
      13035: 93.5,
      13151: 6.5,
    },
    county_names_all: "Butts|Henry",
    county_fips_all: "13035|13151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30236,
    lat: 33.52157,
    lng: -84.32405,
    city: "Jonesboro",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53224,
    density: 634.4,
    county_fips: 13063,
    county_name: "Clayton",
    county_weights: {
      13063: 89.89,
      13151: 10.11,
    },
    county_names_all: "Clayton|Henry",
    county_fips_all: "13063|13151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30238,
    lat: 33.4949,
    lng: -84.38181,
    city: "Jonesboro",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39310,
    density: 877.2,
    county_fips: 13063,
    county_name: "Clayton",
    county_weights: {
      13063: 86.07,
      13113: 13.93,
    },
    county_names_all: "Clayton|Fayette",
    county_fips_all: "13063|13113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30240,
    lat: 33.03757,
    lng: -85.12222,
    city: "Lagrange",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31223,
    density: 86.4,
    county_fips: 13285,
    county_name: "Troup",
    county_weights: {
      13149: 0.18,
      13285: 99.82,
    },
    county_names_all: "Troup|Heard",
    county_fips_all: "13285|13149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30241,
    lat: 33.02115,
    lng: -84.95285,
    city: "Lagrange",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23449,
    density: 80.5,
    county_fips: 13285,
    county_name: "Troup",
    county_weights: {
      13285: 100,
    },
    county_names_all: "Troup",
    county_fips_all: 13285,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30248,
    lat: 33.34975,
    lng: -84.10838,
    city: "Locust Grove",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27747,
    density: 151.6,
    county_fips: 13151,
    county_name: "Henry",
    county_weights: {
      13035: 8.08,
      13151: 83.89,
      13255: 8.03,
    },
    county_names_all: "Henry|Butts|Spalding",
    county_fips_all: "13151|13035|13255",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30250,
    lat: 33.43473,
    lng: -84.30603,
    city: "Lovejoy",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 667,
    density: 8908.9,
    county_fips: 13063,
    county_name: "Clayton",
    county_weights: {
      13063: 100,
    },
    county_names_all: "Clayton",
    county_fips_all: 13063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30251,
    lat: 33.18871,
    lng: -84.69983,
    city: "Luthersville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1882,
    density: 20,
    county_fips: 13199,
    county_name: "Meriwether",
    county_weights: {
      13077: 2.82,
      13199: 97.18,
    },
    county_names_all: "Meriwether|Coweta",
    county_fips_all: "13199|13077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30252,
    lat: 33.47206,
    lng: -84.06416,
    city: "Mcdonough",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47005,
    density: 192.9,
    county_fips: 13151,
    county_name: "Henry",
    county_weights: {
      13151: 94.99,
      13247: 5.01,
    },
    county_names_all: "Henry|Rockdale",
    county_fips_all: "13151|13247",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30253,
    lat: 33.45028,
    lng: -84.18579,
    city: "Mcdonough",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57889,
    density: 476.9,
    county_fips: 13151,
    county_name: "Henry",
    county_weights: {
      13151: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 13151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30256,
    lat: 33.01654,
    lng: -84.31515,
    city: "Meansville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2819,
    density: 30.5,
    county_fips: 13231,
    county_name: "Pike",
    county_weights: {
      13171: 8.52,
      13231: 70.94,
      13293: 20.54,
    },
    county_names_all: "Pike|Upson|Lamar",
    county_fips_all: "13231|13293|13171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30257,
    lat: 33.14218,
    lng: -84.18606,
    city: "Milner",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4024,
    density: 36.9,
    county_fips: 13171,
    county_name: "Lamar",
    county_weights: {
      13171: 90.92,
      13231: 9.08,
    },
    county_names_all: "Lamar|Pike",
    county_fips_all: "13171|13231",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30258,
    lat: 32.99278,
    lng: -84.47024,
    city: "Molena",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3165,
    density: 22.6,
    county_fips: 13231,
    county_name: "Pike",
    county_weights: {
      13231: 61.81,
      13293: 38.19,
    },
    county_names_all: "Pike|Upson",
    county_fips_all: "13231|13293",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30259,
    lat: 33.26522,
    lng: -84.74073,
    city: "Moreland",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3674,
    density: 41.4,
    county_fips: 13077,
    county_name: "Coweta",
    county_weights: {
      13077: 100,
    },
    county_names_all: "Coweta",
    county_fips_all: 13077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30260,
    lat: 33.5862,
    lng: -84.33046,
    city: "Morrow",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27183,
    density: 962.8,
    county_fips: 13063,
    county_name: "Clayton",
    county_weights: {
      13063: 100,
    },
    county_names_all: "Clayton",
    county_fips_all: 13063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30263,
    lat: 33.38852,
    lng: -84.85911,
    city: "Newnan",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60769,
    density: 118.4,
    county_fips: 13077,
    county_name: "Coweta",
    county_weights: {
      13077: 99.48,
      13149: 0.52,
    },
    county_names_all: "Coweta|Heard",
    county_fips_all: "13077|13149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30265,
    lat: 33.41649,
    lng: -84.70749,
    city: "Newnan",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34596,
    density: 303.5,
    county_fips: 13077,
    county_name: "Coweta",
    county_weights: {
      13077: 100,
    },
    county_names_all: "Coweta",
    county_fips_all: 13077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30268,
    lat: 33.54357,
    lng: -84.72262,
    city: "Palmetto",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10099,
    density: 56.3,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13077: 12.72,
      13121: 87.28,
    },
    county_names_all: "Fulton|Coweta",
    county_fips_all: "13121|13077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30269,
    lat: 33.39375,
    lng: -84.56974,
    city: "Peachtree City",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36578,
    density: 539.5,
    county_fips: 13113,
    county_name: "Fayette",
    county_weights: {
      13113: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 13113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30272,
    lat: 33.62313,
    lng: -84.50175,
    city: "Red Oak",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13121: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 13121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30273,
    lat: 33.58365,
    lng: -84.27208,
    city: "Rex",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15720,
    density: 849.7,
    county_fips: 13063,
    county_name: "Clayton",
    county_weights: {
      13063: 85.7,
      13151: 14.3,
    },
    county_names_all: "Clayton|Henry",
    county_fips_all: "13063|13151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30274,
    lat: 33.55583,
    lng: -84.40091,
    city: "Riverdale",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34426,
    density: 1301.7,
    county_fips: 13063,
    county_name: "Clayton",
    county_weights: {
      13063: 100,
    },
    county_names_all: "Clayton",
    county_fips_all: 13063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30275,
    lat: 33.43066,
    lng: -84.86798,
    city: "Sargent",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 13077,
    county_name: "Coweta",
    county_weights: {
      13077: 100,
    },
    county_names_all: "Coweta",
    county_fips_all: 13077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30276,
    lat: 33.26552,
    lng: -84.582,
    city: "Senoia",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18128,
    density: 72.9,
    county_fips: 13077,
    county_name: "Coweta",
    county_weights: {
      13077: 76.88,
      13113: 4.23,
      13199: 18.89,
    },
    county_names_all: "Coweta|Meriwether|Fayette",
    county_fips_all: "13077|13199|13113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30277,
    lat: 33.37962,
    lng: -84.64767,
    city: "Sharpsburg",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23365,
    density: 197.9,
    county_fips: 13077,
    county_name: "Coweta",
    county_weights: {
      13077: 100,
    },
    county_names_all: "Coweta",
    county_fips_all: 13077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30281,
    lat: 33.56338,
    lng: -84.1961,
    city: "Stockbridge",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 70098,
    density: 390.7,
    county_fips: 13151,
    county_name: "Henry",
    county_weights: {
      13063: 1.61,
      13151: 79.25,
      13247: 19.14,
    },
    county_names_all: "Henry|Rockdale|Clayton",
    county_fips_all: "13151|13247|13063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30284,
    lat: 33.34032,
    lng: -84.28858,
    city: "Sunny Side",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 81,
    density: 1328.8,
    county_fips: 13255,
    county_name: "Spalding",
    county_weights: {
      13255: 100,
    },
    county_names_all: "Spalding",
    county_fips_all: 13255,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30285,
    lat: 32.98647,
    lng: -84.25255,
    city: "The Rock",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 682,
    density: 16.4,
    county_fips: 13293,
    county_name: "Upson",
    county_weights: {
      13171: 20.94,
      13231: 17.26,
      13293: 61.8,
    },
    county_names_all: "Upson|Lamar|Pike",
    county_fips_all: "13293|13171|13231",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30286,
    lat: 32.88078,
    lng: -84.33334,
    city: "Thomaston",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22270,
    density: 43.1,
    county_fips: 13293,
    county_name: "Upson",
    county_weights: {
      13293: 100,
    },
    county_names_all: "Upson",
    county_fips_all: 13293,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30288,
    lat: 33.65502,
    lng: -84.32813,
    city: "Conley",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10181,
    density: 565.4,
    county_fips: 13089,
    county_name: "DeKalb",
    county_weights: {
      13063: 28.01,
      13089: 71.99,
    },
    county_names_all: "DeKalb|Clayton",
    county_fips_all: "13089|13063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30289,
    lat: 33.32358,
    lng: -84.63368,
    city: "Turin",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34,
    density: 107.8,
    county_fips: 13077,
    county_name: "Coweta",
    county_weights: {
      13077: 100,
    },
    county_names_all: "Coweta",
    county_fips_all: 13077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30290,
    lat: 33.47675,
    lng: -84.58804,
    city: "Tyrone",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8706,
    density: 188.3,
    county_fips: 13113,
    county_name: "Fayette",
    county_weights: {
      13077: 0.16,
      13113: 99.84,
    },
    county_names_all: "Fayette|Coweta",
    county_fips_all: "13113|13077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30291,
    lat: 33.57569,
    lng: -84.5408,
    city: "Union City",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22636,
    density: 810.9,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13121: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 13121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30292,
    lat: 33.17207,
    lng: -84.39438,
    city: "Williamson",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5631,
    density: 37.5,
    county_fips: 13231,
    county_name: "Pike",
    county_weights: {
      13231: 77.69,
      13255: 22.31,
    },
    county_names_all: "Pike|Spalding",
    county_fips_all: "13231|13255",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30293,
    lat: 32.97581,
    lng: -84.59612,
    city: "Woodbury",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2482,
    density: 12.7,
    county_fips: 13199,
    county_name: "Meriwether",
    county_weights: {
      13199: 100,
    },
    county_names_all: "Meriwether",
    county_fips_all: 13199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30294,
    lat: 33.6371,
    lng: -84.26289,
    city: "Ellenwood",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41096,
    density: 484.6,
    county_fips: 13089,
    county_name: "DeKalb",
    county_weights: {
      13063: 35.09,
      13089: 36.39,
      13151: 27.37,
      13247: 1.15,
    },
    county_names_all: "DeKalb|Clayton|Henry|Rockdale",
    county_fips_all: "13089|13063|13151|13247",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30295,
    lat: 33.09319,
    lng: -84.31819,
    city: "Zebulon",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4750,
    density: 38.6,
    county_fips: 13231,
    county_name: "Pike",
    county_weights: {
      13171: 2.63,
      13231: 97.37,
    },
    county_names_all: "Pike|Lamar",
    county_fips_all: "13231|13171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30296,
    lat: 33.56351,
    lng: -84.44254,
    city: "Riverdale",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27579,
    density: 1019.8,
    county_fips: 13063,
    county_name: "Clayton",
    county_weights: {
      13063: 80.24,
      13121: 19.76,
    },
    county_names_all: "Clayton|Fulton",
    county_fips_all: "13063|13121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30297,
    lat: 33.61511,
    lng: -84.37145,
    city: "Forest Park",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28503,
    density: 1004.7,
    county_fips: 13063,
    county_name: "Clayton",
    county_weights: {
      13063: 100,
    },
    county_names_all: "Clayton",
    county_fips_all: 13063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30303,
    lat: 33.75284,
    lng: -84.39028,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6840,
    density: 2547.3,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13121: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 13121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30305,
    lat: 33.83518,
    lng: -84.38931,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25139,
    density: 1494.2,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13121: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 13121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30306,
    lat: 33.78867,
    lng: -84.35136,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24915,
    density: 2107.6,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13089: 41.26,
      13121: 58.74,
    },
    county_names_all: "Fulton|DeKalb",
    county_fips_all: "13121|13089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30307,
    lat: 33.77053,
    lng: -84.33419,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20337,
    density: 1727.4,
    county_fips: 13089,
    county_name: "DeKalb",
    county_weights: {
      13089: 82.16,
      13121: 17.84,
    },
    county_names_all: "DeKalb|Fulton",
    county_fips_all: "13089|13121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30308,
    lat: 33.77094,
    lng: -84.37773,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20438,
    density: 4939.3,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13121: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 13121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30309,
    lat: 33.798,
    lng: -84.38774,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25852,
    density: 3016.6,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13121: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 13121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30310,
    lat: 33.72695,
    lng: -84.42726,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28597,
    density: 1285.3,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13121: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 13121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30311,
    lat: 33.72345,
    lng: -84.47442,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35523,
    density: 1101.1,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13121: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 13121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30312,
    lat: 33.74463,
    lng: -84.37577,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23921,
    density: 2789.7,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13121: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 13121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30313,
    lat: 33.76369,
    lng: -84.39761,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11761,
    density: 3866.3,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13121: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 13121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30314,
    lat: 33.75787,
    lng: -84.43193,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25752,
    density: 2179.6,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13121: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 13121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30315,
    lat: 33.70312,
    lng: -84.38272,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36296,
    density: 1221.9,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13089: 0.59,
      13121: 99.41,
    },
    county_names_all: "Fulton|DeKalb",
    county_fips_all: "13121|13089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30316,
    lat: 33.71277,
    lng: -84.33218,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33832,
    density: 1001.5,
    county_fips: 13089,
    county_name: "DeKalb",
    county_weights: {
      13089: 84.31,
      13121: 15.69,
    },
    county_names_all: "DeKalb|Fulton",
    county_fips_all: "13089|13121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30317,
    lat: 33.74913,
    lng: -84.31537,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13959,
    density: 1523,
    county_fips: 13089,
    county_name: "DeKalb",
    county_weights: {
      13089: 99.8,
      13121: 0.2,
    },
    county_names_all: "DeKalb|Fulton",
    county_fips_all: "13089|13121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30318,
    lat: 33.79235,
    lng: -84.44831,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57136,
    density: 1086.2,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13121: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 13121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30319,
    lat: 33.87875,
    lng: -84.33596,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45135,
    density: 1689.2,
    county_fips: 13089,
    county_name: "DeKalb",
    county_weights: {
      13089: 85.58,
      13121: 14.42,
    },
    county_names_all: "DeKalb|Fulton",
    county_fips_all: "13089|13121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30322,
    lat: 33.7948,
    lng: -84.32539,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2308,
    density: 1895.5,
    county_fips: 13089,
    county_name: "DeKalb",
    county_weights: {
      13089: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 13089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30324,
    lat: 33.8196,
    lng: -84.3572,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28654,
    density: 2095.5,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13089: 24.66,
      13121: 75.34,
    },
    county_names_all: "Fulton|DeKalb",
    county_fips_all: "13121|13089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30326,
    lat: 33.84957,
    lng: -84.36342,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6643,
    density: 3402.7,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13121: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 13121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30327,
    lat: 33.86708,
    lng: -84.42358,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23059,
    density: 509.6,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13121: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 13121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30328,
    lat: 33.93194,
    lng: -84.38617,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38685,
    density: 1172.1,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13121: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 13121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30329,
    lat: 33.82625,
    lng: -84.32282,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26980,
    density: 1900.4,
    county_fips: 13089,
    county_name: "DeKalb",
    county_weights: {
      13089: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 13089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30331,
    lat: 33.70627,
    lng: -84.54439,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65996,
    density: 675.5,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13121: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 13121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30332,
    lat: 33.77757,
    lng: -84.40429,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3162,
    density: 13591.5,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13121: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 13121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30334,
    lat: 33.74855,
    lng: -84.38804,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13121: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 13121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30336,
    lat: 33.73718,
    lng: -84.56768,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 876,
    density: 33.2,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13121: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 13121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30337,
    lat: 33.64019,
    lng: -84.44962,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13309,
    density: 420.1,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13063: 46.89,
      13121: 53.11,
    },
    county_names_all: "Fulton|Clayton",
    county_fips_all: "13121|13063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30338,
    lat: 33.9437,
    lng: -84.31801,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35680,
    density: 1397.9,
    county_fips: 13089,
    county_name: "DeKalb",
    county_weights: {
      13089: 98.06,
      13121: 1.94,
    },
    county_names_all: "DeKalb|Fulton",
    county_fips_all: "13089|13121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30339,
    lat: 33.86786,
    lng: -84.46483,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25318,
    density: 990.2,
    county_fips: 13067,
    county_name: "Cobb",
    county_weights: {
      13067: 95.62,
      13121: 4.38,
    },
    county_names_all: "Cobb|Fulton",
    county_fips_all: "13067|13121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30340,
    lat: 33.89808,
    lng: -84.25113,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29069,
    density: 1360.8,
    county_fips: 13089,
    county_name: "DeKalb",
    county_weights: {
      13089: 80.79,
      13135: 19.21,
    },
    county_names_all: "DeKalb|Gwinnett",
    county_fips_all: "13089|13135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30341,
    lat: 33.88711,
    lng: -84.28992,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32134,
    density: 1241.1,
    county_fips: 13089,
    county_name: "DeKalb",
    county_weights: {
      13089: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 13089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30342,
    lat: 33.88227,
    lng: -84.37429,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31828,
    density: 1370.9,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13121: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 13121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30344,
    lat: 33.67508,
    lng: -84.46029,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32155,
    density: 1021.9,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13121: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 13121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30345,
    lat: 33.85082,
    lng: -84.28317,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25777,
    density: 1407,
    county_fips: 13089,
    county_name: "DeKalb",
    county_weights: {
      13089: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 13089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30346,
    lat: 33.92425,
    lng: -84.33881,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5008,
    density: 1915.4,
    county_fips: 13089,
    county_name: "DeKalb",
    county_weights: {
      13089: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 13089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30349,
    lat: 33.62346,
    lng: -84.52591,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75647,
    density: 636.6,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13063: 14.48,
      13121: 85.52,
    },
    county_names_all: "Fulton|Clayton",
    county_fips_all: "13121|13063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30350,
    lat: 33.97881,
    lng: -84.33366,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38785,
    density: 1187.9,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13089: 0.58,
      13121: 99.42,
    },
    county_names_all: "Fulton|DeKalb",
    county_fips_all: "13121|13089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30354,
    lat: 33.66058,
    lng: -84.38609,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16660,
    density: 600.3,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13063: 12.84,
      13121: 87.16,
    },
    county_names_all: "Fulton|Clayton",
    county_fips_all: "13121|13063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30360,
    lat: 33.93198,
    lng: -84.27302,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16099,
    density: 1016.9,
    county_fips: 13089,
    county_name: "DeKalb",
    county_weights: {
      13089: 72.72,
      13135: 27.28,
    },
    county_names_all: "DeKalb|Gwinnett",
    county_fips_all: "13089|13135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30363,
    lat: 33.79147,
    lng: -84.39887,
    city: "Atlanta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4737,
    density: 7405.9,
    county_fips: 13121,
    county_name: "Fulton",
    county_weights: {
      13121: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 13121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30401,
    lat: 32.604,
    lng: -82.34825,
    city: "Swainsboro",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13708,
    density: 20.3,
    county_fips: 13107,
    county_name: "Emanuel",
    county_weights: {
      13107: 100,
    },
    county_names_all: "Emanuel",
    county_fips_all: 13107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30410,
    lat: 32.18655,
    lng: -82.51767,
    city: "Ailey",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1821,
    density: 11.9,
    county_fips: 13209,
    county_name: "Montgomery",
    county_weights: {
      13209: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 13209,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30411,
    lat: 32.1254,
    lng: -82.79362,
    city: "Alamo",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5205,
    density: 15.5,
    county_fips: 13309,
    county_name: "Wheeler",
    county_weights: {
      13175: 14.88,
      13309: 85.12,
    },
    county_names_all: "Wheeler|Laurens",
    county_fips_all: "13309|13175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30412,
    lat: 32.07973,
    lng: -82.48643,
    city: "Alston",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 73,
    density: 10,
    county_fips: 13209,
    county_name: "Montgomery",
    county_weights: {
      13209: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 13209,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30413,
    lat: 32.88467,
    lng: -82.51393,
    city: "Bartow",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1547,
    density: 4.6,
    county_fips: 13163,
    county_name: "Jefferson",
    county_weights: {
      13163: 55.14,
      13167: 14.18,
      13303: 30.68,
    },
    county_names_all: "Jefferson|Washington|Johnson",
    county_fips_all: "13163|13303|13167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30414,
    lat: 32.15618,
    lng: -81.98522,
    city: "Bellville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 13109,
    county_name: "Evans",
    county_weights: {
      13109: 100,
    },
    county_names_all: "Evans",
    county_fips_all: 13109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30415,
    lat: 32.32773,
    lng: -81.6008,
    city: "Brooklet",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6272,
    density: 15.2,
    county_fips: 13031,
    county_name: "Bulloch",
    county_weights: {
      13031: 100,
    },
    county_names_all: "Bulloch",
    county_fips_all: 13031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30417,
    lat: 32.16953,
    lng: -81.91978,
    city: "Claxton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10487,
    density: 23.7,
    county_fips: 13109,
    county_name: "Evans",
    county_weights: {
      13109: 86.33,
      13267: 13.67,
    },
    county_names_all: "Evans|Tattnall",
    county_fips_all: "13109|13267",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30420,
    lat: 32.30363,
    lng: -82.12958,
    city: "Cobbtown",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1278,
    density: 7.4,
    county_fips: 13043,
    county_name: "Candler",
    county_weights: {
      13043: 57.61,
      13109: 0.74,
      13267: 41.65,
    },
    county_names_all: "Candler|Tattnall|Evans",
    county_fips_all: "13043|13267|13109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30421,
    lat: 32.18401,
    lng: -82.11096,
    city: "Collins",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2945,
    density: 11.4,
    county_fips: 13267,
    county_name: "Tattnall",
    county_weights: {
      13267: 100,
    },
    county_names_all: "Tattnall",
    county_fips_all: 13267,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30423,
    lat: 32.14601,
    lng: -81.82301,
    city: "Daisy",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 350,
    density: 174.4,
    county_fips: 13109,
    county_name: "Evans",
    county_weights: {
      13109: 100,
    },
    county_names_all: "Evans",
    county_fips_all: 13109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30425,
    lat: 32.64732,
    lng: -82.02337,
    city: "Garfield",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1316,
    density: 6.5,
    county_fips: 13107,
    county_name: "Emanuel",
    county_weights: {
      13031: 12.5,
      13107: 50.46,
      13165: 37.04,
    },
    county_names_all: "Emanuel|Jenkins|Bulloch",
    county_fips_all: "13107|13165|13031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30426,
    lat: 33.03546,
    lng: -81.65159,
    city: "Girard",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 831,
    density: 2.8,
    county_fips: 13033,
    county_name: "Burke",
    county_weights: {
      13033: 72.2,
      13251: 27.8,
    },
    county_names_all: "Burke|Screven",
    county_fips_all: "13033|13251",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30427,
    lat: 31.92271,
    lng: -81.96622,
    city: "Glennville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12771,
    density: 21.4,
    county_fips: 13267,
    county_name: "Tattnall",
    county_weights: {
      13109: 0.54,
      13183: 17.07,
      13267: 82.39,
    },
    county_names_all: "Tattnall|Long|Evans",
    county_fips_all: "13267|13183|13109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30428,
    lat: 32.21706,
    lng: -82.71436,
    city: "Glenwood",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2804,
    density: 6.9,
    county_fips: 13309,
    county_name: "Wheeler",
    county_weights: {
      13175: 25.34,
      13309: 74.66,
    },
    county_names_all: "Wheeler|Laurens",
    county_fips_all: "13309|13175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30429,
    lat: 32.15897,
    lng: -81.93714,
    city: "Hagan",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 193,
    density: 337.2,
    county_fips: 13109,
    county_name: "Evans",
    county_weights: {
      13109: 100,
    },
    county_names_all: "Evans",
    county_fips_all: 13109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30434,
    lat: 33.02867,
    lng: -82.3727,
    city: "Louisville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5017,
    density: 9.5,
    county_fips: 13163,
    county_name: "Jefferson",
    county_weights: {
      13033: 18.1,
      13163: 81.9,
    },
    county_names_all: "Jefferson|Burke",
    county_fips_all: "13163|13033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30436,
    lat: 32.1494,
    lng: -82.29026,
    city: "Lyons",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12039,
    density: 16.4,
    county_fips: 13279,
    county_name: "Toombs",
    county_weights: {
      13107: 16.63,
      13267: 2.1,
      13279: 80.88,
      13283: 0.39,
    },
    county_names_all: "Toombs|Emanuel|Tattnall|Treutlen",
    county_fips_all: "13279|13107|13267|13283",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30439,
    lat: 32.4169,
    lng: -82.07112,
    city: "Metter",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10795,
    density: 20.1,
    county_fips: 13043,
    county_name: "Candler",
    county_weights: {
      13031: 0.13,
      13043: 97.3,
      13107: 2.57,
    },
    county_names_all: "Candler|Emanuel|Bulloch",
    county_fips_all: "13043|13107|13031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30441,
    lat: 32.81467,
    lng: -82.23682,
    city: "Midville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1803,
    density: 4.1,
    county_fips: 13107,
    county_name: "Emanuel",
    county_weights: {
      13033: 42.67,
      13107: 55.94,
      13165: 1.39,
    },
    county_names_all: "Emanuel|Burke|Jenkins",
    county_fips_all: "13107|13033|13165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30442,
    lat: 32.81677,
    lng: -81.97549,
    city: "Millen",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8239,
    density: 9,
    county_fips: 13165,
    county_name: "Jenkins",
    county_weights: {
      13033: 10.59,
      13165: 88.67,
      13251: 0.74,
    },
    county_names_all: "Jenkins|Burke|Screven",
    county_fips_all: "13165|13033|13251",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30445,
    lat: 32.16715,
    lng: -82.58413,
    city: "Mount Vernon",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3797,
    density: 17.5,
    county_fips: 13209,
    county_name: "Montgomery",
    county_weights: {
      13209: 99.14,
      13283: 0.86,
    },
    county_names_all: "Montgomery|Treutlen",
    county_fips_all: "13209|13283",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30446,
    lat: 32.5599,
    lng: -81.46734,
    city: "Newington",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1466,
    density: 10.3,
    county_fips: 13251,
    county_name: "Screven",
    county_weights: {
      13103: 38.41,
      13251: 61.59,
    },
    county_names_all: "Screven|Effingham",
    county_fips_all: "13251|13103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30448,
    lat: 32.48754,
    lng: -82.36444,
    city: "Nunez",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 81,
    density: 13.5,
    county_fips: 13107,
    county_name: "Emanuel",
    county_weights: {
      13107: 100,
    },
    county_names_all: "Emanuel",
    county_fips_all: 13107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30449,
    lat: 32.52254,
    lng: -81.52987,
    city: "Oliver",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 111,
    density: 143.4,
    county_fips: 13251,
    county_name: "Screven",
    county_weights: {
      13103: 1.19,
      13251: 98.81,
    },
    county_names_all: "Screven|Effingham",
    county_fips_all: "13251|13103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30450,
    lat: 32.55964,
    lng: -81.93322,
    city: "Portal",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1882,
    density: 12.9,
    county_fips: 13031,
    county_name: "Bulloch",
    county_weights: {
      13031: 98.02,
      13107: 1.98,
    },
    county_names_all: "Bulloch|Emanuel",
    county_fips_all: "13031|13107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30451,
    lat: 32.39325,
    lng: -81.95622,
    city: "Pulaski",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27,
    density: 43,
    county_fips: 13043,
    county_name: "Candler",
    county_weights: {
      13043: 100,
    },
    county_names_all: "Candler",
    county_fips_all: 13043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30452,
    lat: 32.31706,
    lng: -81.89417,
    city: "Register",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1477,
    density: 9.9,
    county_fips: 13031,
    county_name: "Bulloch",
    county_weights: {
      13031: 92.62,
      13043: 0.68,
      13109: 6.7,
    },
    county_names_all: "Bulloch|Evans|Candler",
    county_fips_all: "13031|13109|13043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30453,
    lat: 32.01926,
    lng: -82.11899,
    city: "Reidsville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10627,
    density: 32.1,
    county_fips: 13267,
    county_name: "Tattnall",
    county_weights: {
      13267: 100,
    },
    county_names_all: "Tattnall",
    county_fips_all: 13267,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30454,
    lat: 32.43857,
    lng: -82.73421,
    city: "Rockledge",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 670,
    density: 6.8,
    county_fips: 13175,
    county_name: "Laurens",
    county_weights: {
      13175: 100,
    },
    county_names_all: "Laurens",
    county_fips_all: 13175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30455,
    lat: 32.70111,
    lng: -81.80652,
    city: "Rocky Ford",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 603,
    density: 4.5,
    county_fips: 13251,
    county_name: "Screven",
    county_weights: {
      13165: 2.59,
      13251: 97.41,
    },
    county_names_all: "Screven|Jenkins",
    county_fips_all: "13251|13165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30456,
    lat: 32.98137,
    lng: -81.79246,
    city: "Sardis",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2146,
    density: 11.6,
    county_fips: 13033,
    county_name: "Burke",
    county_weights: {
      13033: 100,
    },
    county_names_all: "Burke",
    county_fips_all: 13033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30457,
    lat: 32.39852,
    lng: -82.56498,
    city: "Soperton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5697,
    density: 12.6,
    county_fips: 13283,
    county_name: "Treutlen",
    county_weights: {
      13107: 2.74,
      13209: 4.56,
      13283: 92.7,
    },
    county_names_all: "Treutlen|Montgomery|Emanuel",
    county_fips_all: "13283|13209|13107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30458,
    lat: 32.39732,
    lng: -81.82694,
    city: "Statesboro",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47890,
    density: 130,
    county_fips: 13031,
    county_name: "Bulloch",
    county_weights: {
      13031: 100,
    },
    county_names_all: "Bulloch",
    county_fips_all: 13031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30460,
    lat: 32.42718,
    lng: -81.78272,
    city: "Statesboro",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 13031,
    county_name: "Bulloch",
    county_weights: {
      13031: 100,
    },
    county_names_all: "Bulloch",
    county_fips_all: 13031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30461,
    lat: 32.5072,
    lng: -81.71941,
    city: "Statesboro",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15034,
    density: 35.6,
    county_fips: 13031,
    county_name: "Bulloch",
    county_weights: {
      13031: 100,
    },
    county_names_all: "Bulloch",
    county_fips_all: 13031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30464,
    lat: 32.43509,
    lng: -82.22186,
    city: "Stillmore",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 187,
    density: 88.1,
    county_fips: 13107,
    county_name: "Emanuel",
    county_weights: {
      13107: 100,
    },
    county_names_all: "Emanuel",
    county_fips_all: 13107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30467,
    lat: 32.75114,
    lng: -81.60468,
    city: "Sylvania",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11764,
    density: 8.6,
    county_fips: 13251,
    county_name: "Screven",
    county_weights: {
      13251: 100,
    },
    county_names_all: "Screven",
    county_fips_all: 13251,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30470,
    lat: 32.33018,
    lng: -82.51818,
    city: "Tarrytown",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 305,
    density: 2.9,
    county_fips: 13209,
    county_name: "Montgomery",
    county_weights: {
      13209: 56.64,
      13283: 43.36,
    },
    county_names_all: "Montgomery|Treutlen",
    county_fips_all: "13209|13283",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30471,
    lat: 32.53816,
    lng: -82.18563,
    city: "Twin City",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4490,
    density: 11.6,
    county_fips: 13107,
    county_name: "Emanuel",
    county_weights: {
      13031: 3.38,
      13043: 1.67,
      13107: 94.95,
    },
    county_names_all: "Emanuel|Bulloch|Candler",
    county_fips_all: "13107|13031|13043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30473,
    lat: 32.01613,
    lng: -82.47198,
    city: "Uvalda",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2504,
    density: 11.8,
    county_fips: 13279,
    county_name: "Toombs",
    county_weights: {
      13209: 45.89,
      13279: 54.11,
    },
    county_names_all: "Toombs|Montgomery",
    county_fips_all: "13279|13209",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30474,
    lat: 32.22393,
    lng: -82.41381,
    city: "Vidalia",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16892,
    density: 50.9,
    county_fips: 13279,
    county_name: "Toombs",
    county_weights: {
      13107: 4.56,
      13209: 21.47,
      13279: 71.09,
      13283: 2.88,
    },
    county_names_all: "Toombs|Montgomery|Emanuel|Treutlen",
    county_fips_all: "13279|13209|13107|13283",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30477,
    lat: 32.86279,
    lng: -82.3979,
    city: "Wadley",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2779,
    density: 14.7,
    county_fips: 13163,
    county_name: "Jefferson",
    county_weights: {
      13163: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 13163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30501,
    lat: 34.31844,
    lng: -83.81636,
    city: "Gainesville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32652,
    density: 576.7,
    county_fips: 13139,
    county_name: "Hall",
    county_weights: {
      13139: 100,
    },
    county_names_all: "Hall",
    county_fips_all: 13139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30504,
    lat: 34.26639,
    lng: -83.88751,
    city: "Gainesville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27242,
    density: 579.6,
    county_fips: 13139,
    county_name: "Hall",
    county_weights: {
      13139: 100,
    },
    county_names_all: "Hall",
    county_fips_all: 13139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30506,
    lat: 34.34918,
    lng: -83.89486,
    city: "Gainesville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43974,
    density: 169,
    county_fips: 13139,
    county_name: "Hall",
    county_weights: {
      13117: 27.07,
      13139: 72.93,
    },
    county_names_all: "Hall|Forsyth",
    county_fips_all: "13139|13117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30507,
    lat: 34.26082,
    lng: -83.76622,
    city: "Gainesville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31290,
    density: 170.7,
    county_fips: 13139,
    county_name: "Hall",
    county_weights: {
      13139: 100,
    },
    county_names_all: "Hall",
    county_fips_all: 13139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30510,
    lat: 34.44194,
    lng: -83.58446,
    city: "Alto",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9136,
    density: 80.1,
    county_fips: 13011,
    county_name: "Banks",
    county_weights: {
      13011: 56.9,
      13137: 28.19,
      13139: 14.91,
    },
    county_names_all: "Banks|Habersham|Hall",
    county_fips_all: "13011|13137|13139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30511,
    lat: 34.45674,
    lng: -83.47474,
    city: "Baldwin",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3831,
    density: 46,
    county_fips: 13011,
    county_name: "Banks",
    county_weights: {
      13011: 92.85,
      13137: 3.1,
      13257: 4.05,
    },
    county_names_all: "Banks|Stephens|Habersham",
    county_fips_all: "13011|13257|13137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30512,
    lat: 34.85667,
    lng: -83.97204,
    city: "Blairsville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22646,
    density: 39.4,
    county_fips: 13291,
    county_name: "Union",
    county_weights: {
      13111: 0.84,
      13291: 99.16,
    },
    county_names_all: "Union|Fannin",
    county_fips_all: "13291|13111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30513,
    lat: 34.82469,
    lng: -84.31891,
    city: "Blue Ridge",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12504,
    density: 32.5,
    county_fips: 13111,
    county_name: "Fannin",
    county_weights: {
      13111: 95.22,
      13123: 4.78,
    },
    county_names_all: "Fannin|Gilmer",
    county_fips_all: "13111|13123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30516,
    lat: 34.37535,
    lng: -83.03748,
    city: "Bowersville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2634,
    density: 49.2,
    county_fips: 13147,
    county_name: "Hart",
    county_weights: {
      13119: 0.15,
      13147: 99.85,
    },
    county_names_all: "Hart|Franklin",
    county_fips_all: "13147|13119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30517,
    lat: 34.13047,
    lng: -83.7975,
    city: "Braselton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16070,
    density: 224,
    county_fips: 13157,
    county_name: "Jackson",
    county_weights: {
      13013: 7.35,
      13135: 10.8,
      13139: 29.84,
      13157: 52.01,
    },
    county_names_all: "Jackson|Hall|Gwinnett|Barrow",
    county_fips_all: "13157|13139|13135|13013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30518,
    lat: 34.132,
    lng: -84.02578,
    city: "Buford",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54832,
    density: 528.8,
    county_fips: 13135,
    county_name: "Gwinnett",
    county_weights: {
      13135: 69.8,
      13139: 30.2,
    },
    county_names_all: "Gwinnett|Hall",
    county_fips_all: "13135|13139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30519,
    lat: 34.08792,
    lng: -83.9423,
    city: "Buford",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49986,
    density: 571.7,
    county_fips: 13135,
    county_name: "Gwinnett",
    county_weights: {
      13135: 88.42,
      13139: 11.58,
    },
    county_names_all: "Gwinnett|Hall",
    county_fips_all: "13135|13139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30520,
    lat: 34.33833,
    lng: -83.08661,
    city: "Canon",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5418,
    density: 37.3,
    county_fips: 13147,
    county_name: "Hart",
    county_weights: {
      13119: 47.3,
      13147: 52.7,
    },
    county_names_all: "Hart|Franklin",
    county_fips_all: "13147|13119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30521,
    lat: 34.36202,
    lng: -83.29355,
    city: "Carnesville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4683,
    density: 19.6,
    county_fips: 13119,
    county_name: "Franklin",
    county_weights: {
      13011: 5.84,
      13119: 94.16,
    },
    county_names_all: "Franklin|Banks",
    county_fips_all: "13119|13011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30522,
    lat: 34.78351,
    lng: -84.34233,
    city: "Cherry Log",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1430,
    density: 11.9,
    county_fips: 13123,
    county_name: "Gilmer",
    county_weights: {
      13111: 26.82,
      13123: 73.18,
    },
    county_names_all: "Gilmer|Fannin",
    county_fips_all: "13123|13111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30523,
    lat: 34.72012,
    lng: -83.54166,
    city: "Clarkesville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12099,
    density: 25.4,
    county_fips: 13137,
    county_name: "Habersham",
    county_weights: {
      13137: 83.85,
      13241: 16.15,
    },
    county_names_all: "Habersham|Rabun",
    county_fips_all: "13137|13241",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30525,
    lat: 34.91289,
    lng: -83.35853,
    city: "Clayton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7515,
    density: 14.7,
    county_fips: 13241,
    county_name: "Rabun",
    county_weights: {
      13241: 98.06,
      13281: 1.94,
    },
    county_names_all: "Rabun|Towns",
    county_fips_all: "13241|13281",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30527,
    lat: 34.47948,
    lng: -83.7863,
    city: "Clermont",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3701,
    density: 56.2,
    county_fips: 13139,
    county_name: "Hall",
    county_weights: {
      13139: 100,
    },
    county_names_all: "Hall",
    county_fips_all: 13139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30528,
    lat: 34.6083,
    lng: -83.77589,
    city: "Cleveland",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25149,
    density: 58.4,
    county_fips: 13311,
    county_name: "White",
    county_weights: {
      13187: 11,
      13311: 89,
    },
    county_names_all: "White|Lumpkin",
    county_fips_all: "13311|13187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30529,
    lat: 34.2155,
    lng: -83.482,
    city: "Commerce",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12098,
    density: 92.5,
    county_fips: 13157,
    county_name: "Jackson",
    county_weights: {
      13011: 26.45,
      13157: 73.55,
    },
    county_names_all: "Jackson|Banks",
    county_fips_all: "13157|13011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30530,
    lat: 34.22691,
    lng: -83.38433,
    city: "Commerce",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7475,
    density: 36.5,
    county_fips: 13011,
    county_name: "Banks",
    county_weights: {
      13011: 41.82,
      13119: 15.02,
      13157: 25.84,
      13195: 17.32,
    },
    county_names_all: "Banks|Jackson|Madison|Franklin",
    county_fips_all: "13011|13157|13195|13119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30531,
    lat: 34.51017,
    lng: -83.59103,
    city: "Cornelia",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10809,
    density: 110.6,
    county_fips: 13137,
    county_name: "Habersham",
    county_weights: {
      13137: 85.21,
      13139: 14.79,
    },
    county_names_all: "Habersham|Hall",
    county_fips_all: "13137|13139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30533,
    lat: 34.57344,
    lng: -84.01576,
    city: "Dahlonega",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27738,
    density: 44.1,
    county_fips: 13187,
    county_name: "Lumpkin",
    county_weights: {
      13085: 2.57,
      13139: 1.71,
      13187: 95.32,
      13311: 0.4,
    },
    county_names_all: "Lumpkin|Dawson|Hall|White",
    county_fips_all: "13187|13085|13139|13311",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30534,
    lat: 34.43085,
    lng: -84.1439,
    city: "Dawsonville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30848,
    density: 55.9,
    county_fips: 13085,
    county_name: "Dawson",
    county_weights: {
      13057: 0.66,
      13085: 85.36,
      13117: 3,
      13187: 9.71,
      13227: 1.27,
    },
    county_names_all: "Dawson|Lumpkin|Forsyth|Pickens|Cherokee",
    county_fips_all: "13085|13187|13117|13227|13057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30535,
    lat: 34.58063,
    lng: -83.57652,
    city: "Demorest",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7607,
    density: 99.2,
    county_fips: 13137,
    county_name: "Habersham",
    county_weights: {
      13137: 100,
    },
    county_names_all: "Habersham",
    county_fips_all: 13137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30536,
    lat: 34.65151,
    lng: -84.35223,
    city: "Ellijay",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9290,
    density: 23.3,
    county_fips: 13123,
    county_name: "Gilmer",
    county_weights: {
      13085: 2.24,
      13123: 97.76,
    },
    county_names_all: "Gilmer|Dawson",
    county_fips_all: "13123|13085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30537,
    lat: 34.97855,
    lng: -83.32975,
    city: "Dillard",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1539,
    density: 31.7,
    county_fips: 13241,
    county_name: "Rabun",
    county_weights: {
      13241: 100,
    },
    county_names_all: "Rabun",
    county_fips_all: 13241,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30538,
    lat: 34.5035,
    lng: -83.26888,
    city: "Eastanollee",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2799,
    density: 39.7,
    county_fips: 13257,
    county_name: "Stephens",
    county_weights: {
      13119: 11.89,
      13257: 88.11,
    },
    county_names_all: "Stephens|Franklin",
    county_fips_all: "13257|13119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30539,
    lat: 34.68061,
    lng: -84.47016,
    city: "East Ellijay",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 13123,
    county_name: "Gilmer",
    county_weights: {
      13123: 100,
    },
    county_names_all: "Gilmer",
    county_fips_all: 13123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30540,
    lat: 34.72313,
    lng: -84.54421,
    city: "Ellijay",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19732,
    density: 38.8,
    county_fips: 13123,
    county_name: "Gilmer",
    county_weights: {
      13123: 100,
    },
    county_names_all: "Gilmer",
    county_fips_all: 13123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30541,
    lat: 34.91164,
    lng: -84.53482,
    city: "Epworth",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1326,
    density: 6.9,
    county_fips: 13111,
    county_name: "Fannin",
    county_weights: {
      13111: 100,
    },
    county_names_all: "Fannin",
    county_fips_all: 13111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30542,
    lat: 34.17846,
    lng: -83.90915,
    city: "Flowery Branch",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36450,
    density: 331.6,
    county_fips: 13139,
    county_name: "Hall",
    county_weights: {
      13139: 100,
    },
    county_names_all: "Hall",
    county_fips_all: 13139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30543,
    lat: 34.29781,
    lng: -83.64971,
    city: "Gillsville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5939,
    density: 59.8,
    county_fips: 13139,
    county_name: "Hall",
    county_weights: {
      13011: 32.66,
      13139: 56.84,
      13157: 10.5,
    },
    county_names_all: "Hall|Banks|Jackson",
    county_fips_all: "13139|13011|13157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30545,
    lat: 34.74208,
    lng: -83.75813,
    city: "Helen",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 949,
    density: 7.9,
    county_fips: 13311,
    county_name: "White",
    county_weights: {
      13311: 100,
    },
    county_names_all: "White",
    county_fips_all: 13311,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30546,
    lat: 34.90673,
    lng: -83.71016,
    city: "Hiawassee",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7596,
    density: 22.5,
    county_fips: 13281,
    county_name: "Towns",
    county_weights: {
      13281: 100,
    },
    county_names_all: "Towns",
    county_fips_all: 13281,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30547,
    lat: 34.35737,
    lng: -83.46095,
    city: "Homer",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3266,
    density: 23.2,
    county_fips: 13011,
    county_name: "Banks",
    county_weights: {
      13011: 100,
    },
    county_names_all: "Banks",
    county_fips_all: 13011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30548,
    lat: 34.09311,
    lng: -83.7646,
    city: "Hoschton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19828,
    density: 189.4,
    county_fips: 13157,
    county_name: "Jackson",
    county_weights: {
      13013: 19.96,
      13135: 8.93,
      13139: 9.1,
      13157: 62.01,
    },
    county_names_all: "Jackson|Barrow|Hall|Gwinnett",
    county_fips_all: "13157|13013|13139|13135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30549,
    lat: 34.10731,
    lng: -83.57684,
    city: "Jefferson",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28195,
    density: 103.1,
    county_fips: 13157,
    county_name: "Jackson",
    county_weights: {
      13157: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 13157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30552,
    lat: 34.76965,
    lng: -83.44575,
    city: "Lakemont",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1640,
    density: 11.4,
    county_fips: 13241,
    county_name: "Rabun",
    county_weights: {
      13241: 100,
    },
    county_names_all: "Rabun",
    county_fips_all: 13241,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30553,
    lat: 34.44473,
    lng: -83.08771,
    city: "Lavonia",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8041,
    density: 52.4,
    county_fips: 13119,
    county_name: "Franklin",
    county_weights: {
      13119: 58.85,
      13147: 41.15,
    },
    county_names_all: "Franklin|Hart",
    county_fips_all: "13119|13147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30554,
    lat: 34.40093,
    lng: -83.65926,
    city: "Lula",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8486,
    density: 45.8,
    county_fips: 13139,
    county_name: "Hall",
    county_weights: {
      13011: 39.44,
      13139: 60.56,
    },
    county_names_all: "Hall|Banks",
    county_fips_all: "13139|13011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30555,
    lat: 34.97216,
    lng: -84.42459,
    city: "McCaysville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2443,
    density: 82.5,
    county_fips: 13111,
    county_name: "Fannin",
    county_weights: {
      13111: 100,
    },
    county_names_all: "Fannin",
    county_fips_all: 13111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30557,
    lat: 34.48143,
    lng: -83.18484,
    city: "Martin",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5112,
    density: 33.9,
    county_fips: 13119,
    county_name: "Franklin",
    county_weights: {
      13119: 59.4,
      13257: 40.6,
    },
    county_names_all: "Franklin|Stephens",
    county_fips_all: "13119|13257",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30558,
    lat: 34.2683,
    lng: -83.56787,
    city: "Maysville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5240,
    density: 33,
    county_fips: 13157,
    county_name: "Jackson",
    county_weights: {
      13011: 46.18,
      13157: 53.82,
    },
    county_names_all: "Jackson|Banks",
    county_fips_all: "13157|13011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30559,
    lat: 34.95233,
    lng: -84.26612,
    city: "Mineral Bluff",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4751,
    density: 36.5,
    county_fips: 13111,
    county_name: "Fannin",
    county_weights: {
      13111: 100,
    },
    county_names_all: "Fannin",
    county_fips_all: 13111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30560,
    lat: 34.87785,
    lng: -84.19528,
    city: "Morganton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4544,
    density: 24.6,
    county_fips: 13111,
    county_name: "Fannin",
    county_weights: {
      13111: 89.19,
      13291: 10.81,
    },
    county_names_all: "Fannin|Union",
    county_fips_all: "13111|13291",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30562,
    lat: 34.91937,
    lng: -83.38177,
    city: "Mountain City",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1113,
    density: 364.2,
    county_fips: 13241,
    county_name: "Rabun",
    county_weights: {
      13241: 100,
    },
    county_names_all: "Rabun",
    county_fips_all: 13241,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30563,
    lat: 34.5596,
    lng: -83.46283,
    city: "Mount Airy",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6274,
    density: 62.3,
    county_fips: 13137,
    county_name: "Habersham",
    county_weights: {
      13137: 98.78,
      13257: 1.22,
    },
    county_names_all: "Habersham|Stephens",
    county_fips_all: "13137|13257",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30564,
    lat: 34.47251,
    lng: -83.8826,
    city: "Murrayville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3696,
    density: 44.8,
    county_fips: 13139,
    county_name: "Hall",
    county_weights: {
      13139: 57.86,
      13187: 37.19,
      13311: 4.95,
    },
    county_names_all: "Hall|Lumpkin|White",
    county_fips_all: "13139|13187|13311",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30565,
    lat: 34.08802,
    lng: -83.41203,
    city: "Nicholson",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4731,
    density: 54.3,
    county_fips: 13157,
    county_name: "Jackson",
    county_weights: {
      13157: 86.98,
      13195: 13.02,
    },
    county_names_all: "Jackson|Madison",
    county_fips_all: "13157|13195",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30566,
    lat: 34.23747,
    lng: -83.89477,
    city: "Oakwood",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7741,
    density: 371.5,
    county_fips: 13139,
    county_name: "Hall",
    county_weights: {
      13139: 100,
    },
    county_names_all: "Hall",
    county_fips_all: 13139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30567,
    lat: 34.18326,
    lng: -83.6814,
    city: "Pendergrass",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3565,
    density: 47.4,
    county_fips: 13157,
    county_name: "Jackson",
    county_weights: {
      13139: 1.19,
      13157: 98.81,
    },
    county_names_all: "Jackson|Hall",
    county_fips_all: "13157|13139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30568,
    lat: 34.95348,
    lng: -83.41218,
    city: "Rabun Gap",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1531,
    density: 19.3,
    county_fips: 13241,
    county_name: "Rabun",
    county_weights: {
      13241: 100,
    },
    county_names_all: "Rabun",
    county_fips_all: 13241,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30571,
    lat: 34.71219,
    lng: -83.68322,
    city: "Sautee Nacoochee",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4069,
    density: 36,
    county_fips: 13311,
    county_name: "White",
    county_weights: {
      13311: 100,
    },
    county_names_all: "White",
    county_fips_all: 13311,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30572,
    lat: 34.73539,
    lng: -84.07364,
    city: "Suches",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 844,
    density: 3,
    county_fips: 13291,
    county_name: "Union",
    county_weights: {
      13111: 30.32,
      13291: 69.68,
    },
    county_names_all: "Union|Fannin",
    county_fips_all: "13291|13111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30573,
    lat: 34.74242,
    lng: -83.39986,
    city: "Tallulah Falls",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 218,
    density: 42.3,
    county_fips: 13241,
    county_name: "Rabun",
    county_weights: {
      13241: 100,
    },
    county_names_all: "Rabun",
    county_fips_all: 13241,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30575,
    lat: 34.20353,
    lng: -83.71556,
    city: "Talmo",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1512,
    density: 52.7,
    county_fips: 13157,
    county_name: "Jackson",
    county_weights: {
      13139: 32.77,
      13157: 67.23,
    },
    county_names_all: "Jackson|Hall",
    county_fips_all: "13157|13139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30576,
    lat: 34.82682,
    lng: -83.44539,
    city: "Tiger",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3104,
    density: 30,
    county_fips: 13241,
    county_name: "Rabun",
    county_weights: {
      13241: 100,
    },
    county_names_all: "Rabun",
    county_fips_all: 13241,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30577,
    lat: 34.55549,
    lng: -83.32632,
    city: "Toccoa",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22261,
    density: 54.6,
    county_fips: 13257,
    county_name: "Stephens",
    county_weights: {
      13011: 1.39,
      13119: 11.09,
      13137: 4.32,
      13257: 83.2,
    },
    county_names_all: "Stephens|Franklin|Habersham|Banks",
    county_fips_all: "13257|13119|13137|13011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30581,
    lat: 34.80195,
    lng: -83.42405,
    city: "Wiley",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 160,
    density: 218.3,
    county_fips: 13241,
    county_name: "Rabun",
    county_weights: {
      13241: 100,
    },
    county_names_all: "Rabun",
    county_fips_all: 13241,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30582,
    lat: 34.9494,
    lng: -83.89869,
    city: "Young Harris",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4706,
    density: 35,
    county_fips: 13281,
    county_name: "Towns",
    county_weights: {
      13281: 62.92,
      13291: 37.08,
    },
    county_names_all: "Towns|Union",
    county_fips_all: "13281|13291",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30597,
    lat: 34.52762,
    lng: -83.98462,
    city: "Dahlonega",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 13187,
    county_name: "Lumpkin",
    county_weights: {
      13187: 100,
    },
    county_names_all: "Lumpkin",
    county_fips_all: 13187,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30598,
    lat: 34.59663,
    lng: -83.35411,
    city: "Toccoa Falls",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 13257,
    county_name: "Stephens",
    county_weights: {
      13257: 100,
    },
    county_names_all: "Stephens",
    county_fips_all: 13257,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30601,
    lat: 34.00032,
    lng: -83.34851,
    city: "Athens",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23390,
    density: 386.4,
    county_fips: 13059,
    county_name: "Clarke",
    county_weights: {
      13059: 89.62,
      13157: 4.46,
      13195: 5.92,
    },
    county_names_all: "Clarke|Madison|Jackson",
    county_fips_all: "13059|13195|13157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30602,
    lat: 33.94252,
    lng: -83.37256,
    city: "Athens",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3127,
    density: 2010.8,
    county_fips: 13059,
    county_name: "Clarke",
    county_weights: {
      13059: 100,
    },
    county_names_all: "Clarke",
    county_fips_all: 13059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30605,
    lat: 33.90551,
    lng: -83.32405,
    city: "Athens",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41388,
    density: 418.3,
    county_fips: 13059,
    county_name: "Clarke",
    county_weights: {
      13059: 95.06,
      13219: 4.94,
    },
    county_names_all: "Clarke|Oconee",
    county_fips_all: "13059|13219",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30606,
    lat: 33.93873,
    lng: -83.43305,
    city: "Athens",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45698,
    density: 574.7,
    county_fips: 13059,
    county_name: "Clarke",
    county_weights: {
      13059: 73.67,
      13219: 26.33,
    },
    county_names_all: "Clarke|Oconee",
    county_fips_all: "13059|13219",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30607,
    lat: 34.01895,
    lng: -83.44774,
    city: "Athens",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10475,
    density: 108.8,
    county_fips: 13157,
    county_name: "Jackson",
    county_weights: {
      13059: 37.14,
      13157: 62.86,
    },
    county_names_all: "Jackson|Clarke",
    county_fips_all: "13157|13059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30609,
    lat: 33.93289,
    lng: -83.37223,
    city: "Athens",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 13059,
    county_name: "Clarke",
    county_weights: {
      13059: 100,
    },
    county_names_all: "Clarke",
    county_fips_all: 13059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30619,
    lat: 33.85752,
    lng: -83.2403,
    city: "Arnoldsville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1543,
    density: 22.7,
    county_fips: 13221,
    county_name: "Oglethorpe",
    county_weights: {
      13219: 3.5,
      13221: 96.5,
    },
    county_names_all: "Oglethorpe|Oconee",
    county_fips_all: "13221|13219",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30620,
    lat: 33.92917,
    lng: -83.75958,
    city: "Bethlehem",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14027,
    density: 243.9,
    county_fips: 13013,
    county_name: "Barrow",
    county_weights: {
      13013: 77.96,
      13135: 15.58,
      13297: 6.46,
    },
    county_names_all: "Barrow|Gwinnett|Walton",
    county_fips_all: "13013|13135|13297",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30621,
    lat: 33.80194,
    lng: -83.4791,
    city: "Bishop",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5794,
    density: 49.3,
    county_fips: 13219,
    county_name: "Oconee",
    county_weights: {
      13211: 35.23,
      13219: 64.77,
    },
    county_names_all: "Oconee|Morgan",
    county_fips_all: "13219|13211",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30622,
    lat: 33.92041,
    lng: -83.53076,
    city: "Bogart",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13073,
    density: 136.4,
    county_fips: 13219,
    county_name: "Oconee",
    county_weights: {
      13013: 0.66,
      13059: 22.72,
      13157: 8.66,
      13219: 67.96,
    },
    county_names_all: "Oconee|Clarke|Jackson|Barrow",
    county_fips_all: "13219|13059|13157|13013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30623,
    lat: 33.73113,
    lng: -83.51592,
    city: "Bostwick",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48,
    density: 19,
    county_fips: 13211,
    county_name: "Morgan",
    county_weights: {
      13211: 100,
    },
    county_names_all: "Morgan",
    county_fips_all: 13211,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30624,
    lat: 34.18097,
    lng: -83.03885,
    city: "Bowman",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3016,
    density: 25.5,
    county_fips: 13105,
    county_name: "Elbert",
    county_weights: {
      13105: 82.51,
      13147: 10.75,
      13195: 6.74,
    },
    county_names_all: "Elbert|Hart|Madison",
    county_fips_all: "13105|13147|13195",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30625,
    lat: 33.52128,
    lng: -83.34211,
    city: "Buckhead",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2582,
    density: 21,
    county_fips: 13211,
    county_name: "Morgan",
    county_weights: {
      13211: 88.65,
      13237: 11.35,
    },
    county_names_all: "Morgan|Putnam",
    county_fips_all: "13211|13237",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30627,
    lat: 33.98264,
    lng: -82.96265,
    city: "Carlton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2490,
    density: 8.1,
    county_fips: 13221,
    county_name: "Oglethorpe",
    county_weights: {
      13195: 17.69,
      13221: 82.31,
    },
    county_names_all: "Oglethorpe|Madison",
    county_fips_all: "13221|13195",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30628,
    lat: 34.03115,
    lng: -83.21364,
    city: "Colbert",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7241,
    density: 57.5,
    county_fips: 13195,
    county_name: "Madison",
    county_weights: {
      13195: 70.07,
      13221: 29.93,
    },
    county_names_all: "Madison|Oglethorpe",
    county_fips_all: "13195|13221",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30629,
    lat: 34.07779,
    lng: -83.11625,
    city: "Comer",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4817,
    density: 25,
    county_fips: 13195,
    county_name: "Madison",
    county_weights: {
      13195: 71.31,
      13221: 28.69,
    },
    county_names_all: "Madison|Oglethorpe",
    county_fips_all: "13195|13221",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30630,
    lat: 33.89894,
    lng: -83.14366,
    city: "Crawford",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2407,
    density: 21.2,
    county_fips: 13221,
    county_name: "Oglethorpe",
    county_weights: {
      13221: 100,
    },
    county_names_all: "Oglethorpe",
    county_fips_all: 13221,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30631,
    lat: 33.56553,
    lng: -82.87034,
    city: "Crawfordville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1585,
    density: 3.4,
    county_fips: 13265,
    county_name: "Taliaferro",
    county_weights: {
      13133: 1.19,
      13265: 95.84,
      13317: 2.97,
    },
    county_names_all: "Taliaferro|Wilkes|Greene",
    county_fips_all: "13265|13317|13133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30633,
    lat: 34.17896,
    lng: -83.24612,
    city: "Danielsville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8776,
    density: 34.1,
    county_fips: 13195,
    county_name: "Madison",
    county_weights: {
      13011: 0.3,
      13119: 1.92,
      13195: 97.78,
    },
    county_names_all: "Madison|Franklin|Banks",
    county_fips_all: "13195|13119|13011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30634,
    lat: 34.20307,
    lng: -82.94522,
    city: "Dewy Rose",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2148,
    density: 17,
    county_fips: 13105,
    county_name: "Elbert",
    county_weights: {
      13105: 72.82,
      13147: 27.18,
    },
    county_names_all: "Elbert|Hart",
    county_fips_all: "13105|13147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30635,
    lat: 34.10346,
    lng: -82.80145,
    city: "Elberton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15200,
    density: 20.9,
    county_fips: 13105,
    county_name: "Elbert",
    county_weights: {
      13105: 98.66,
      13147: 1.34,
    },
    county_names_all: "Elbert|Hart",
    county_fips_all: "13105|13147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30639,
    lat: 34.28283,
    lng: -83.15232,
    city: "Franklin Springs",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 13119,
    county_name: "Franklin",
    county_weights: {
      13119: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 13119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30641,
    lat: 33.77872,
    lng: -83.56456,
    city: "Good Hope",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1859,
    density: 21.7,
    county_fips: 13297,
    county_name: "Walton",
    county_weights: {
      13211: 22.93,
      13297: 77.07,
    },
    county_names_all: "Walton|Morgan",
    county_fips_all: "13297|13211",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30642,
    lat: 33.5446,
    lng: -83.1832,
    city: "Greensboro",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13104,
    density: 27.5,
    county_fips: 13133,
    county_name: "Greene",
    county_weights: {
      13133: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 13133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30643,
    lat: 34.36464,
    lng: -82.91143,
    city: "Hartwell",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15487,
    density: 52.2,
    county_fips: 13147,
    county_name: "Hart",
    county_weights: {
      13147: 100,
    },
    county_names_all: "Hart",
    county_fips_all: 13147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30646,
    lat: 34.08011,
    lng: -83.31254,
    city: "Hull",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6893,
    density: 73.1,
    county_fips: 13195,
    county_name: "Madison",
    county_weights: {
      13059: 0.44,
      13157: 0.41,
      13195: 99.15,
    },
    county_names_all: "Madison|Clarke|Jackson",
    county_fips_all: "13195|13059|13157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30648,
    lat: 33.87577,
    lng: -83.03319,
    city: "Lexington",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3028,
    density: 12.7,
    county_fips: 13221,
    county_name: "Oglethorpe",
    county_weights: {
      13221: 100,
    },
    county_names_all: "Oglethorpe",
    county_fips_all: 13221,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30650,
    lat: 33.5907,
    lng: -83.46693,
    city: "Madison",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11971,
    density: 20.1,
    county_fips: 13211,
    county_name: "Morgan",
    county_weights: {
      13133: 8.21,
      13211: 89.86,
      13237: 0.69,
      13297: 1.23,
    },
    county_names_all: "Morgan|Greene|Walton|Putnam",
    county_fips_all: "13211|13133|13297|13237",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30655,
    lat: 33.78214,
    lng: -83.69072,
    city: "Monroe",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25876,
    density: 120.3,
    county_fips: 13297,
    county_name: "Walton",
    county_weights: {
      13297: 100,
    },
    county_names_all: "Walton",
    county_fips_all: 13297,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30656,
    lat: 33.86302,
    lng: -83.71903,
    city: "Monroe",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16582,
    density: 89.5,
    county_fips: 13297,
    county_name: "Walton",
    county_weights: {
      13013: 3.41,
      13297: 96.59,
    },
    county_names_all: "Walton|Barrow",
    county_fips_all: "13297|13013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30660,
    lat: 33.78237,
    lng: -82.94369,
    city: "Rayle",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1515,
    density: 5.9,
    county_fips: 13317,
    county_name: "Wilkes",
    county_weights: {
      13221: 36.09,
      13265: 0.98,
      13317: 62.93,
    },
    county_names_all: "Wilkes|Oglethorpe|Taliaferro",
    county_fips_all: "13317|13221|13265",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30662,
    lat: 34.26383,
    lng: -83.14624,
    city: "Royston",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8779,
    density: 40.7,
    county_fips: 13119,
    county_name: "Franklin",
    county_weights: {
      13105: 1.68,
      13119: 51.4,
      13147: 25.17,
      13195: 21.75,
    },
    county_names_all: "Franklin|Hart|Madison|Elbert",
    county_fips_all: "13119|13147|13195|13105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30663,
    lat: 33.61572,
    lng: -83.60357,
    city: "Rutledge",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3463,
    density: 26.6,
    county_fips: 13211,
    county_name: "Morgan",
    county_weights: {
      13211: 100,
    },
    county_names_all: "Morgan",
    county_fips_all: 13211,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30664,
    lat: 33.55786,
    lng: -82.79904,
    city: "Sharon",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11,
    density: 17.1,
    county_fips: 13265,
    county_name: "Taliaferro",
    county_weights: {
      13265: 100,
    },
    county_names_all: "Taliaferro",
    county_fips_all: 13265,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30665,
    lat: 33.53707,
    lng: -83.07475,
    city: "Siloam",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 115,
    density: 153.2,
    county_fips: 13133,
    county_name: "Greene",
    county_weights: {
      13133: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 13133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30666,
    lat: 33.95891,
    lng: -83.58266,
    city: "Statham",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9622,
    density: 104.3,
    county_fips: 13013,
    county_name: "Barrow",
    county_weights: {
      13013: 59.72,
      13157: 9.7,
      13219: 30.58,
    },
    county_names_all: "Barrow|Oconee|Jackson",
    county_fips_all: "13013|13219|13157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30667,
    lat: 33.78526,
    lng: -83.16634,
    city: "Stephens",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 851,
    density: 4.8,
    county_fips: 13221,
    county_name: "Oglethorpe",
    county_weights: {
      13221: 100,
    },
    county_names_all: "Oglethorpe",
    county_fips_all: 13221,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30668,
    lat: 33.90835,
    lng: -82.69486,
    city: "Tignall",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1836,
    density: 4.9,
    county_fips: 13317,
    county_name: "Wilkes",
    county_weights: {
      13181: 20.24,
      13317: 79.76,
    },
    county_names_all: "Wilkes|Lincoln",
    county_fips_all: "13317|13181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30669,
    lat: 33.67159,
    lng: -83.11187,
    city: "Union Point",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2959,
    density: 7.8,
    county_fips: 13133,
    county_name: "Greene",
    county_weights: {
      13133: 77.03,
      13221: 11.78,
      13265: 11.19,
    },
    county_names_all: "Greene|Oglethorpe|Taliaferro",
    county_fips_all: "13133|13221|13265",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30673,
    lat: 33.72716,
    lng: -82.71594,
    city: "Washington",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6726,
    density: 9.4,
    county_fips: 13317,
    county_name: "Wilkes",
    county_weights: {
      13317: 100,
    },
    county_names_all: "Wilkes",
    county_fips_all: 13317,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30677,
    lat: 33.7929,
    lng: -83.38186,
    city: "Watkinsville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18770,
    density: 59.3,
    county_fips: 13219,
    county_name: "Oconee",
    county_weights: {
      13133: 13.53,
      13219: 86.47,
    },
    county_names_all: "Oconee|Greene",
    county_fips_all: "13219|13133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30678,
    lat: 33.44626,
    lng: -83.07598,
    city: "White Plains",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1390,
    density: 7.5,
    county_fips: 13133,
    county_name: "Greene",
    county_weights: {
      13133: 75.1,
      13141: 20.9,
      13265: 4,
    },
    county_names_all: "Greene|Hancock|Taliaferro",
    county_fips_all: "13133|13141|13265",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30680,
    lat: 33.99725,
    lng: -83.69743,
    city: "Winder",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45852,
    density: 186.5,
    county_fips: 13013,
    county_name: "Barrow",
    county_weights: {
      13013: 94.56,
      13157: 3.18,
      13219: 2.26,
    },
    county_names_all: "Barrow|Jackson|Oconee",
    county_fips_all: "13013|13157|13219",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30683,
    lat: 33.94703,
    lng: -83.25775,
    city: "Winterville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7192,
    density: 71.6,
    county_fips: 13221,
    county_name: "Oglethorpe",
    county_weights: {
      13059: 41.46,
      13195: 1.41,
      13221: 57.13,
    },
    county_names_all: "Oglethorpe|Clarke|Madison",
    county_fips_all: "13221|13059|13195",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30701,
    lat: 34.49535,
    lng: -84.95385,
    city: "Calhoun",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42050,
    density: 107,
    county_fips: 13129,
    county_name: "Gordon",
    county_weights: {
      13115: 5.79,
      13129: 94.21,
    },
    county_names_all: "Gordon|Floyd",
    county_fips_all: "13129|13115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30705,
    lat: 34.74711,
    lng: -84.74929,
    city: "Chatsworth",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34072,
    density: 54.1,
    county_fips: 13213,
    county_name: "Murray",
    county_weights: {
      13213: 100,
    },
    county_names_all: "Murray",
    county_fips_all: 13213,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30707,
    lat: 34.77943,
    lng: -85.36028,
    city: "Chickamauga",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17145,
    density: 54.7,
    county_fips: 13295,
    county_name: "Walker",
    county_weights: {
      13047: 4.02,
      13295: 95.98,
    },
    county_names_all: "Walker|Catoosa",
    county_fips_all: "13295|13047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30708,
    lat: 34.93985,
    lng: -84.66754,
    city: "Cisco",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 172,
    density: 1.9,
    county_fips: 13213,
    county_name: "Murray",
    county_weights: {
      13213: 100,
    },
    county_names_all: "Murray",
    county_fips_all: 13213,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30710,
    lat: 34.95002,
    lng: -84.91993,
    city: "Cohutta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7297,
    density: 60.3,
    county_fips: 13313,
    county_name: "Whitfield",
    county_weights: {
      13047: 0.21,
      13313: 99.79,
    },
    county_names_all: "Whitfield|Catoosa",
    county_fips_all: "13313|13047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30711,
    lat: 34.92905,
    lng: -84.76259,
    city: "Crandall",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3757,
    density: 29.5,
    county_fips: 13213,
    county_name: "Murray",
    county_weights: {
      13213: 100,
    },
    county_names_all: "Murray",
    county_fips_all: 13213,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30720,
    lat: 34.73472,
    lng: -85.00289,
    city: "Dalton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28067,
    density: 222.8,
    county_fips: 13313,
    county_name: "Whitfield",
    county_weights: {
      13313: 100,
    },
    county_names_all: "Whitfield",
    county_fips_all: 13313,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30721,
    lat: 34.79168,
    lng: -84.91187,
    city: "Dalton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52658,
    density: 160.4,
    county_fips: 13313,
    county_name: "Whitfield",
    county_weights: {
      13213: 4.23,
      13313: 95.77,
    },
    county_names_all: "Whitfield|Murray",
    county_fips_all: "13313|13213",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30724,
    lat: 34.8253,
    lng: -84.75795,
    city: "Eton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 13213,
    county_name: "Murray",
    county_weights: {
      13213: 100,
    },
    county_names_all: "Murray",
    county_fips_all: 13213,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30725,
    lat: 34.92443,
    lng: -85.35359,
    city: "Flintstone",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4731,
    density: 111,
    county_fips: 13295,
    county_name: "Walker",
    county_weights: {
      13295: 100,
    },
    county_names_all: "Walker",
    county_fips_all: 13295,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30726,
    lat: 34.97579,
    lng: -85.13959,
    city: "Graysville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 13047,
    county_name: "Catoosa",
    county_weights: {
      13047: 100,
    },
    county_names_all: "Catoosa",
    county_fips_all: 13047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30728,
    lat: 34.68015,
    lng: -85.23417,
    city: "La Fayette",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20183,
    density: 44.9,
    county_fips: 13295,
    county_name: "Walker",
    county_weights: {
      13295: 100,
    },
    county_names_all: "Walker",
    county_fips_all: 13295,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30730,
    lat: 34.36017,
    lng: -85.42172,
    city: "Lyerly",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1902,
    density: 13.1,
    county_fips: 13055,
    county_name: "Chattooga",
    county_weights: {
      13055: 100,
    },
    county_names_all: "Chattooga",
    county_fips_all: 13055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30731,
    lat: 34.58317,
    lng: -85.47894,
    city: "Menlo",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2655,
    density: 12.3,
    county_fips: 13055,
    county_name: "Chattooga",
    county_weights: {
      13055: 54.33,
      13083: 15.85,
      13295: 29.82,
    },
    county_names_all: "Chattooga|Walker|Dade",
    county_fips_all: "13055|13295|13083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30733,
    lat: 34.41574,
    lng: -85.04349,
    city: "Plainville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2171,
    density: 53.7,
    county_fips: 13129,
    county_name: "Gordon",
    county_weights: {
      13115: 10.9,
      13129: 89.1,
    },
    county_names_all: "Gordon|Floyd",
    county_fips_all: "13129|13115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30734,
    lat: 34.53361,
    lng: -84.71346,
    city: "Ranger",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3418,
    density: 17.2,
    county_fips: 13129,
    county_name: "Gordon",
    county_weights: {
      13129: 88.41,
      13227: 11.59,
    },
    county_names_all: "Gordon|Pickens",
    county_fips_all: "13129|13227",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30735,
    lat: 34.60183,
    lng: -84.89375,
    city: "Resaca",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6631,
    density: 46.6,
    county_fips: 13129,
    county_name: "Gordon",
    county_weights: {
      13129: 71.94,
      13213: 20.14,
      13313: 7.92,
    },
    county_names_all: "Gordon|Murray|Whitfield",
    county_fips_all: "13129|13213|13313",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30736,
    lat: 34.90244,
    lng: -85.13306,
    city: "Ringgold",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43639,
    density: 135.2,
    county_fips: 13047,
    county_name: "Catoosa",
    county_weights: {
      13047: 95.55,
      13295: 1.32,
      13313: 3.13,
    },
    county_names_all: "Catoosa|Whitfield|Walker",
    county_fips_all: "13047|13313|13295",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30738,
    lat: 34.79534,
    lng: -85.47846,
    city: "Rising Fawn",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3509,
    density: 15.3,
    county_fips: 13083,
    county_name: "Dade",
    county_weights: {
      13083: 68.3,
      13295: 31.7,
    },
    county_names_all: "Dade|Walker",
    county_fips_all: "13083|13295",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30739,
    lat: 34.80345,
    lng: -85.21515,
    city: "Rock Spring",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6773,
    density: 102.3,
    county_fips: 13295,
    county_name: "Walker",
    county_weights: {
      13047: 25.1,
      13295: 74.9,
    },
    county_names_all: "Walker|Catoosa",
    county_fips_all: "13295|13047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30740,
    lat: 34.75407,
    lng: -85.07786,
    city: "Rocky Face",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8584,
    density: 66.1,
    county_fips: 13313,
    county_name: "Whitfield",
    county_weights: {
      13295: 8.01,
      13313: 91.99,
    },
    county_names_all: "Whitfield|Walker",
    county_fips_all: "13313|13295",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30741,
    lat: 34.95168,
    lng: -85.28213,
    city: "Rossville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28592,
    density: 443.9,
    county_fips: 13295,
    county_name: "Walker",
    county_weights: {
      13047: 27.64,
      13295: 72.36,
    },
    county_names_all: "Walker|Catoosa",
    county_fips_all: "13295|13047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30742,
    lat: 34.93566,
    lng: -85.24482,
    city: "Fort Oglethorpe",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7374,
    density: 392.6,
    county_fips: 13047,
    county_name: "Catoosa",
    county_weights: {
      13047: 99.87,
      13295: 0.13,
    },
    county_names_all: "Catoosa|Walker",
    county_fips_all: "13047|13295",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30746,
    lat: 34.59214,
    lng: -85.03285,
    city: "Sugar Valley",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 762,
    density: 13.8,
    county_fips: 13129,
    county_name: "Gordon",
    county_weights: {
      13129: 84.55,
      13295: 15.45,
    },
    county_names_all: "Gordon|Walker",
    county_fips_all: "13129|13295",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30747,
    lat: 34.50179,
    lng: -85.29407,
    city: "Summerville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15807,
    density: 31.6,
    county_fips: 13055,
    county_name: "Chattooga",
    county_weights: {
      13055: 90.55,
      13295: 9.45,
    },
    county_names_all: "Chattooga|Walker",
    county_fips_all: "13055|13295",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30750,
    lat: 34.93681,
    lng: -85.3882,
    city: "Lookout Mountain",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4148,
    density: 144.1,
    county_fips: 13295,
    county_name: "Walker",
    county_weights: {
      13083: 35.57,
      13295: 64.43,
    },
    county_names_all: "Walker|Dade",
    county_fips_all: "13295|13083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30751,
    lat: 34.98212,
    lng: -84.73743,
    city: "Tennga",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 172,
    density: 116.8,
    county_fips: 13213,
    county_name: "Murray",
    county_weights: {
      13213: 100,
    },
    county_names_all: "Murray",
    county_fips_all: 13213,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30752,
    lat: 34.91136,
    lng: -85.53079,
    city: "Trenton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8638,
    density: 44.1,
    county_fips: 13083,
    county_name: "Dade",
    county_weights: {
      13083: 100,
    },
    county_names_all: "Dade",
    county_fips_all: 13083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30753,
    lat: 34.57896,
    lng: -85.28806,
    city: "Trion",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7016,
    density: 66.3,
    county_fips: 13055,
    county_name: "Chattooga",
    county_weights: {
      13055: 60.83,
      13295: 39.17,
    },
    county_names_all: "Chattooga|Walker",
    county_fips_all: "13055|13295",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30755,
    lat: 34.86944,
    lng: -85.04072,
    city: "Tunnel Hill",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10108,
    density: 105.9,
    county_fips: 13313,
    county_name: "Whitfield",
    county_weights: {
      13047: 47.52,
      13313: 52.48,
    },
    county_names_all: "Whitfield|Catoosa",
    county_fips_all: "13313|13047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30756,
    lat: 34.90103,
    lng: -84.97458,
    city: "Varnell",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58,
    density: 451.5,
    county_fips: 13313,
    county_name: "Whitfield",
    county_weights: {
      13313: 100,
    },
    county_names_all: "Whitfield",
    county_fips_all: 13313,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30757,
    lat: 34.94164,
    lng: -85.4324,
    city: "Wildwood",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2131,
    density: 40.3,
    county_fips: 13083,
    county_name: "Dade",
    county_weights: {
      13083: 100,
    },
    county_names_all: "Dade",
    county_fips_all: 13083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30802,
    lat: 33.60215,
    lng: -82.31832,
    city: "Appling",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6243,
    density: 18.2,
    county_fips: 13073,
    county_name: "Columbia",
    county_weights: {
      13073: 98.49,
      13189: 1.51,
    },
    county_names_all: "Columbia|McDuffie",
    county_fips_all: "13073|13189",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30803,
    lat: 33.13878,
    lng: -82.55013,
    city: "Avera",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1039,
    density: 7.7,
    county_fips: 13163,
    county_name: "Jefferson",
    county_weights: {
      13125: 1.06,
      13163: 98.94,
    },
    county_names_all: "Jefferson|Glascock",
    county_fips_all: "13163|13125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30805,
    lat: 33.28012,
    lng: -82.19936,
    city: "Blythe",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2397,
    density: 22.9,
    county_fips: 13245,
    county_name: "Richmond",
    county_weights: {
      13033: 40.45,
      13245: 59.55,
    },
    county_names_all: "Richmond|Burke",
    county_fips_all: "13245|13033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30807,
    lat: 33.45517,
    lng: -82.64777,
    city: "Camak",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 199,
    density: 196,
    county_fips: 13301,
    county_name: "Warren",
    county_weights: {
      13301: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 13301,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30808,
    lat: 33.38234,
    lng: -82.40237,
    city: "Dearing",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4561,
    density: 31.3,
    county_fips: 13189,
    county_name: "McDuffie",
    county_weights: {
      13189: 98.28,
      13301: 1.72,
    },
    county_names_all: "McDuffie|Warren",
    county_fips_all: "13189|13301",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30809,
    lat: 33.55522,
    lng: -82.16357,
    city: "Evans",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50288,
    density: 439.6,
    county_fips: 13073,
    county_name: "Columbia",
    county_weights: {
      13073: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 13073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30810,
    lat: 33.23247,
    lng: -82.58849,
    city: "Gibson",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2096,
    density: 9.7,
    county_fips: 13125,
    county_name: "Glascock",
    county_weights: {
      13125: 90.84,
      13163: 4.61,
      13301: 4.55,
    },
    county_names_all: "Glascock|Jefferson|Warren",
    county_fips_all: "13125|13163|13301",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30812,
    lat: 33.36731,
    lng: -82.0291,
    city: "Gracewood",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 403,
    density: 1651.1,
    county_fips: 13245,
    county_name: "Richmond",
    county_weights: {
      13245: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 13245,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30813,
    lat: 33.47037,
    lng: -82.2193,
    city: "Grovetown",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45485,
    density: 348.4,
    county_fips: 13073,
    county_name: "Columbia",
    county_weights: {
      13073: 95.33,
      13245: 4.67,
    },
    county_names_all: "Columbia|Richmond",
    county_fips_all: "13073|13245",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30814,
    lat: 33.43604,
    lng: -82.31879,
    city: "Harlem",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9342,
    density: 67.4,
    county_fips: 13073,
    county_name: "Columbia",
    county_weights: {
      13073: 83.95,
      13189: 16.05,
    },
    county_names_all: "Columbia|McDuffie",
    county_fips_all: "13073|13189",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30815,
    lat: 33.2869,
    lng: -82.0829,
    city: "Hephzibah",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41590,
    density: 126.8,
    county_fips: 13245,
    county_name: "Richmond",
    county_weights: {
      13033: 28.07,
      13245: 71.93,
    },
    county_names_all: "Richmond|Burke",
    county_fips_all: "13245|13033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30816,
    lat: 33.1639,
    lng: -82.17061,
    city: "Keysville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2018,
    density: 6.9,
    county_fips: 13033,
    county_name: "Burke",
    county_weights: {
      13033: 86.55,
      13163: 13.45,
    },
    county_names_all: "Burke|Jefferson",
    county_fips_all: "13033|13163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30817,
    lat: 33.7746,
    lng: -82.43469,
    city: "Lincolnton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7775,
    density: 15.7,
    county_fips: 13181,
    county_name: "Lincoln",
    county_weights: {
      13181: 98.35,
      13317: 1.65,
    },
    county_names_all: "Lincoln|Wilkes",
    county_fips_all: "13181|13317",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30818,
    lat: 33.26765,
    lng: -82.32646,
    city: "Matthews",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 468,
    density: 6,
    county_fips: 13163,
    county_name: "Jefferson",
    county_weights: {
      13163: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 13163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30820,
    lat: 33.22457,
    lng: -82.71989,
    city: "Mitchell",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1068,
    density: 4.4,
    county_fips: 13125,
    county_name: "Glascock",
    county_weights: {
      13125: 54.22,
      13141: 12.4,
      13301: 16.95,
      13303: 16.43,
    },
    county_names_all: "Glascock|Warren|Washington|Hancock",
    county_fips_all: "13125|13301|13303|13141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30821,
    lat: 33.48502,
    lng: -82.73121,
    city: "Norwood",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 825,
    density: 2.9,
    county_fips: 13301,
    county_name: "Warren",
    county_weights: {
      13301: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 13301,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30822,
    lat: 32.91866,
    lng: -81.94439,
    city: "Perkins",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 434,
    density: 144.3,
    county_fips: 13165,
    county_name: "Jenkins",
    county_weights: {
      13165: 100,
    },
    county_names_all: "Jenkins",
    county_fips_all: 13165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30823,
    lat: 33.222,
    lng: -82.45647,
    city: "Stapleton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1349,
    density: 7.3,
    county_fips: 13163,
    county_name: "Jefferson",
    county_weights: {
      13125: 16.23,
      13163: 59.19,
      13301: 24.58,
    },
    county_names_all: "Jefferson|Warren|Glascock",
    county_fips_all: "13163|13301|13125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30824,
    lat: 33.51586,
    lng: -82.51467,
    city: "Thomson",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16866,
    density: 34,
    county_fips: 13189,
    county_name: "McDuffie",
    county_weights: {
      13073: 0.17,
      13189: 98.32,
      13301: 1.51,
    },
    county_names_all: "McDuffie|Warren|Columbia",
    county_fips_all: "13189|13301|13073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30828,
    lat: 33.37281,
    lng: -82.65351,
    city: "Warrenton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3927,
    density: 11.3,
    county_fips: 13301,
    county_name: "Warren",
    county_weights: {
      13125: 3.78,
      13301: 96.22,
    },
    county_names_all: "Warren|Glascock",
    county_fips_all: "13301|13125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30830,
    lat: 33.08204,
    lng: -81.9751,
    city: "Waynesboro",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13544,
    density: 13.9,
    county_fips: 13033,
    county_name: "Burke",
    county_weights: {
      13033: 100,
    },
    county_names_all: "Burke",
    county_fips_all: 13033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30833,
    lat: 33.18934,
    lng: -82.36014,
    city: "Wrens",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3888,
    density: 21,
    county_fips: 13163,
    county_name: "Jefferson",
    county_weights: {
      13163: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 13163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30901,
    lat: 33.43811,
    lng: -81.95327,
    city: "Augusta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16394,
    density: 359.3,
    county_fips: 13245,
    county_name: "Richmond",
    county_weights: {
      13245: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 13245,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30904,
    lat: 33.47864,
    lng: -82.01315,
    city: "Augusta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27136,
    density: 954.9,
    county_fips: 13245,
    county_name: "Richmond",
    county_weights: {
      13245: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 13245,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30905,
    lat: 33.4087,
    lng: -82.15073,
    city: "Augusta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7594,
    density: 161.4,
    county_fips: 13245,
    county_name: "Richmond",
    county_weights: {
      13245: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 13245,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30906,
    lat: 33.34842,
    lng: -81.97239,
    city: "Augusta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60200,
    density: 268.1,
    county_fips: 13245,
    county_name: "Richmond",
    county_weights: {
      13245: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 13245,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30907,
    lat: 33.52193,
    lng: -82.08596,
    city: "Augusta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51428,
    density: 823.2,
    county_fips: 13073,
    county_name: "Columbia",
    county_weights: {
      13073: 77.23,
      13245: 22.77,
    },
    county_names_all: "Columbia|Richmond",
    county_fips_all: "13073|13245",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30909,
    lat: 33.47068,
    lng: -82.08376,
    city: "Augusta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40595,
    density: 614.9,
    county_fips: 13245,
    county_name: "Richmond",
    county_weights: {
      13073: 1.54,
      13245: 98.46,
    },
    county_names_all: "Richmond|Columbia",
    county_fips_all: "13245|13073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 30912,
    lat: 33.47021,
    lng: -81.98789,
    city: "Augusta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 171,
    density: 909,
    county_fips: 13245,
    county_name: "Richmond",
    county_weights: {
      13245: 100,
    },
    county_names_all: "Richmond",
    county_fips_all: 13245,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31001,
    lat: 31.97595,
    lng: -83.33979,
    city: "Abbeville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4323,
    density: 9.6,
    county_fips: 13315,
    county_name: "Wilcox",
    county_weights: {
      13315: 100,
    },
    county_names_all: "Wilcox",
    county_fips_all: 13315,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31002,
    lat: 32.54802,
    lng: -82.59012,
    city: "Adrian",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3267,
    density: 9.9,
    county_fips: 13107,
    county_name: "Emanuel",
    county_weights: {
      13107: 45.23,
      13167: 21.39,
      13175: 21.73,
      13283: 11.65,
    },
    county_names_all: "Emanuel|Laurens|Johnson|Treutlen",
    county_fips_all: "13107|13175|13167|13283",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31003,
    lat: 32.59688,
    lng: -83.22299,
    city: "Allentown",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 82,
    density: 19.6,
    county_fips: 13319,
    county_name: "Wilkinson",
    county_weights: {
      13319: 100,
    },
    county_names_all: "Wilkinson",
    county_fips_all: 13319,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31004,
    lat: 32.95167,
    lng: -83.80536,
    city: "Bolingbroke",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 13207,
    county_name: "Monroe",
    county_weights: {
      13207: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 13207,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31005,
    lat: 32.54533,
    lng: -83.59497,
    city: "Bonaire",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18336,
    density: 306.4,
    county_fips: 13153,
    county_name: "Houston",
    county_weights: {
      13153: 100,
    },
    county_names_all: "Houston",
    county_fips_all: 13153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31006,
    lat: 32.58164,
    lng: -84.25531,
    city: "Butler",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4523,
    density: 9.7,
    county_fips: 13269,
    county_name: "Taylor",
    county_weights: {
      13269: 100,
    },
    county_names_all: "Taylor",
    county_fips_all: 13269,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31007,
    lat: 32.18917,
    lng: -83.93377,
    city: "Byromville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 941,
    density: 5.4,
    county_fips: 13093,
    county_name: "Dooly",
    county_weights: {
      13093: 100,
    },
    county_names_all: "Dooly",
    county_fips_all: 13093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31008,
    lat: 32.65479,
    lng: -83.78287,
    city: "Byron",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19824,
    density: 107.6,
    county_fips: 13225,
    county_name: "Peach",
    county_weights: {
      13079: 34.27,
      13153: 3.8,
      13225: 61.93,
    },
    county_names_all: "Peach|Crawford|Houston",
    county_fips_all: "13225|13079|13153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31009,
    lat: 32.27636,
    lng: -83.00564,
    city: "Cadwell",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1312,
    density: 6.6,
    county_fips: 13175,
    county_name: "Laurens",
    county_weights: {
      13175: 100,
    },
    county_names_all: "Laurens",
    county_fips_all: 13175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31011,
    lat: 32.13315,
    lng: -83.0556,
    city: "Chauncey",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 753,
    density: 5.4,
    county_fips: 13091,
    county_name: "Dodge",
    county_weights: {
      13091: 96.09,
      13175: 3.91,
    },
    county_names_all: "Dodge|Laurens",
    county_fips_all: "13091|13175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31012,
    lat: 32.39422,
    lng: -83.17717,
    city: "Chester",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2703,
    density: 19,
    county_fips: 13091,
    county_name: "Dodge",
    county_weights: {
      13023: 22.67,
      13091: 74.72,
      13175: 2.61,
    },
    county_names_all: "Dodge|Bleckley|Laurens",
    county_fips_all: "13091|13023|13175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31014,
    lat: 32.41439,
    lng: -83.34504,
    city: "Cochran",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13404,
    density: 24.8,
    county_fips: 13023,
    county_name: "Bleckley",
    county_weights: {
      13023: 77,
      13091: 14.14,
      13235: 0.36,
      13289: 8.5,
    },
    county_names_all: "Bleckley|Dodge|Twiggs|Pulaski",
    county_fips_all: "13023|13091|13289|13235",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31015,
    lat: 31.93729,
    lng: -83.77444,
    city: "Cordele",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21224,
    density: 38.4,
    county_fips: 13081,
    county_name: "Crisp",
    county_weights: {
      13081: 96.57,
      13093: 0.5,
      13315: 2.93,
    },
    county_names_all: "Crisp|Wilcox|Dooly",
    county_fips_all: "13081|13315|13093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31016,
    lat: 32.83656,
    lng: -84.11477,
    city: "Culloden",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1832,
    density: 6.9,
    county_fips: 13207,
    county_name: "Monroe",
    county_weights: {
      13079: 17.93,
      13171: 4.88,
      13207: 43.44,
      13293: 33.75,
    },
    county_names_all: "Monroe|Upson|Crawford|Lamar",
    county_fips_all: "13207|13293|13079|13171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31017,
    lat: 32.62075,
    lng: -83.23305,
    city: "Danville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1579,
    density: 6.1,
    county_fips: 13319,
    county_name: "Wilkinson",
    county_weights: {
      13023: 19.55,
      13289: 27.54,
      13319: 52.91,
    },
    county_names_all: "Wilkinson|Twiggs|Bleckley",
    county_fips_all: "13319|13289|13023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31018,
    lat: 32.97888,
    lng: -82.62012,
    city: "Davisboro",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2906,
    density: 12.2,
    county_fips: 13303,
    county_name: "Washington",
    county_weights: {
      13303: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 13303,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31019,
    lat: 32.42622,
    lng: -83.0534,
    city: "Dexter",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2622,
    density: 18.9,
    county_fips: 13175,
    county_name: "Laurens",
    county_weights: {
      13175: 100,
    },
    county_names_all: "Laurens",
    county_fips_all: 13175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31020,
    lat: 32.65376,
    lng: -83.501,
    city: "Dry Branch",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1382,
    density: 4.2,
    county_fips: 13289,
    county_name: "Twiggs",
    county_weights: {
      13021: 3.94,
      13289: 96.06,
    },
    county_names_all: "Twiggs|Bibb",
    county_fips_all: "13289|13021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31021,
    lat: 32.49002,
    lng: -82.93435,
    city: "Dublin",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27503,
    density: 45.5,
    county_fips: 13175,
    county_name: "Laurens",
    county_weights: {
      13175: 100,
    },
    county_names_all: "Laurens",
    county_fips_all: 13175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31022,
    lat: 32.51216,
    lng: -83.10954,
    city: "Dudley",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1630,
    density: 12.2,
    county_fips: 13175,
    county_name: "Laurens",
    county_weights: {
      13023: 4.87,
      13175: 95.13,
    },
    county_names_all: "Laurens|Bleckley",
    county_fips_all: "13175|13023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31023,
    lat: 32.18288,
    lng: -83.1991,
    city: "Eastman",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14079,
    density: 19.2,
    county_fips: 13091,
    county_name: "Dodge",
    county_weights: {
      13091: 96.46,
      13235: 3.54,
    },
    county_names_all: "Dodge|Pulaski",
    county_fips_all: "13091|13235",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31024,
    lat: 33.32344,
    lng: -83.36987,
    city: "Eatonton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20792,
    density: 24.7,
    county_fips: 13237,
    county_name: "Putnam",
    county_weights: {
      13237: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 13237,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31025,
    lat: 32.33833,
    lng: -83.73876,
    city: "Elko",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1312,
    density: 7.6,
    county_fips: 13153,
    county_name: "Houston",
    county_weights: {
      13153: 100,
    },
    county_names_all: "Houston",
    county_fips_all: 13153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31027,
    lat: 32.57405,
    lng: -82.81959,
    city: "East Dublin",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9264,
    density: 22.8,
    county_fips: 13175,
    county_name: "Laurens",
    county_weights: {
      13175: 100,
    },
    county_names_all: "Laurens",
    county_fips_all: 13175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31028,
    lat: 32.63164,
    lng: -83.68459,
    city: "Centerville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6673,
    density: 879.1,
    county_fips: 13153,
    county_name: "Houston",
    county_weights: {
      13153: 100,
    },
    county_names_all: "Houston",
    county_fips_all: 13153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31029,
    lat: 33.03894,
    lng: -83.92977,
    city: "Forsyth",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16467,
    density: 26.1,
    county_fips: 13207,
    county_name: "Monroe",
    county_weights: {
      13207: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 13207,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31030,
    lat: 32.56861,
    lng: -83.89103,
    city: "Fort Valley",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17691,
    density: 39,
    county_fips: 13225,
    county_name: "Peach",
    county_weights: {
      13079: 38.06,
      13193: 3.39,
      13225: 58.55,
    },
    county_names_all: "Peach|Crawford|Macon",
    county_fips_all: "13225|13079|13193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31031,
    lat: 32.87424,
    lng: -83.32555,
    city: "Gordon",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7251,
    density: 22.2,
    county_fips: 13319,
    county_name: "Wilkinson",
    county_weights: {
      13009: 13.08,
      13169: 4.25,
      13289: 16.68,
      13319: 65.99,
    },
    county_names_all: "Wilkinson|Twiggs|Baldwin|Jones",
    county_fips_all: "13319|13289|13009|13169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31032,
    lat: 33.01039,
    lng: -83.57292,
    city: "Gray",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15324,
    density: 37.2,
    county_fips: 13169,
    county_name: "Jones",
    county_weights: {
      13169: 100,
    },
    county_names_all: "Jones",
    county_fips_all: 13169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31033,
    lat: 33.07661,
    lng: -83.43643,
    city: "Haddock",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2287,
    density: 13.1,
    county_fips: 13169,
    county_name: "Jones",
    county_weights: {
      13009: 11.35,
      13169: 88.65,
    },
    county_names_all: "Jones|Baldwin",
    county_fips_all: "13169|13009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31034,
    lat: 33.05473,
    lng: -83.22538,
    city: "Hardwick",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 13009,
    county_name: "Baldwin",
    county_weights: {
      13009: 100,
    },
    county_names_all: "Baldwin",
    county_fips_all: 13009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31035,
    lat: 32.84601,
    lng: -82.7062,
    city: "Harrison",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1130,
    density: 9,
    county_fips: 13303,
    county_name: "Washington",
    county_weights: {
      13303: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 13303,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31036,
    lat: 32.27055,
    lng: -83.49597,
    city: "Hawkinsville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12236,
    density: 19.6,
    county_fips: 13235,
    county_name: "Pulaski",
    county_weights: {
      13023: 1.08,
      13091: 0.32,
      13153: 16.66,
      13235: 81.94,
    },
    county_names_all: "Pulaski|Houston|Bleckley|Dodge",
    county_fips_all: "13235|13153|13023|13091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31037,
    lat: 32.12056,
    lng: -82.93245,
    city: "McRae Helena",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3584,
    density: 21.1,
    county_fips: 13271,
    county_name: "Telfair",
    county_weights: {
      13091: 29.48,
      13175: 8.77,
      13271: 36.14,
      13309: 25.6,
    },
    county_names_all: "Telfair|Dodge|Wheeler|Laurens",
    county_fips_all: "13271|13091|13309|13175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31038,
    lat: 33.15554,
    lng: -83.61644,
    city: "Hillsboro",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 819,
    density: 2.9,
    county_fips: 13169,
    county_name: "Jones",
    county_weights: {
      13159: 32.49,
      13169: 58.52,
      13237: 8.99,
    },
    county_names_all: "Jones|Jasper|Putnam",
    county_fips_all: "13169|13159|13237",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31039,
    lat: 32.6024,
    lng: -84.38036,
    city: "Howard",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 13269,
    county_name: "Taylor",
    county_weights: {
      13269: 100,
    },
    county_names_all: "Taylor",
    county_fips_all: 13269,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31041,
    lat: 32.37905,
    lng: -84.1721,
    city: "Ideal",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 888,
    density: 8.6,
    county_fips: 13193,
    county_name: "Macon",
    county_weights: {
      13193: 100,
    },
    county_names_all: "Macon",
    county_fips_all: 13193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31042,
    lat: 32.74421,
    lng: -83.16964,
    city: "Irwinton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1445,
    density: 6.7,
    county_fips: 13319,
    county_name: "Wilkinson",
    county_weights: {
      13319: 100,
    },
    county_names_all: "Wilkinson",
    county_fips_all: 13319,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31044,
    lat: 32.66857,
    lng: -83.37612,
    city: "Jeffersonville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2986,
    density: 7.6,
    county_fips: 13289,
    county_name: "Twiggs",
    county_weights: {
      13289: 91.12,
      13319: 8.88,
    },
    county_names_all: "Twiggs|Wilkinson",
    county_fips_all: "13289|13319",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31045,
    lat: 33.28484,
    lng: -82.78933,
    city: "Jewell",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62,
    density: 2.7,
    county_fips: 13141,
    county_name: "Hancock",
    county_weights: {
      13141: 75.24,
      13301: 24.76,
    },
    county_names_all: "Hancock|Warren",
    county_fips_all: "13141|13301",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31046,
    lat: 33.05237,
    lng: -83.78302,
    city: "Juliette",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3694,
    density: 17.2,
    county_fips: 13207,
    county_name: "Monroe",
    county_weights: {
      13169: 30.29,
      13207: 69.71,
    },
    county_names_all: "Monroe|Jones",
    county_fips_all: "13207|13169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31047,
    lat: 32.46786,
    lng: -83.58009,
    city: "Kathleen",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15750,
    density: 80.8,
    county_fips: 13153,
    county_name: "Houston",
    county_weights: {
      13153: 100,
    },
    county_names_all: "Houston",
    county_fips_all: 13153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31049,
    lat: 32.68281,
    lng: -82.52634,
    city: "Kite",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1769,
    density: 7.5,
    county_fips: 13167,
    county_name: "Johnson",
    county_weights: {
      13107: 19.87,
      13167: 80.13,
    },
    county_names_all: "Johnson|Emanuel",
    county_fips_all: "13167|13107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31050,
    lat: 32.72924,
    lng: -83.94096,
    city: "Knoxville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 868,
    density: 17.1,
    county_fips: 13079,
    county_name: "Crawford",
    county_weights: {
      13079: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 13079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31051,
    lat: 32.14456,
    lng: -83.87812,
    city: "Lilly",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 209,
    density: 188.5,
    county_fips: 13093,
    county_name: "Dooly",
    county_weights: {
      13093: 100,
    },
    county_names_all: "Dooly",
    county_fips_all: 13093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31052,
    lat: 32.7743,
    lng: -83.84664,
    city: "Lizella",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8837,
    density: 47.9,
    county_fips: 13021,
    county_name: "Bibb",
    county_weights: {
      13021: 52.27,
      13079: 47.73,
    },
    county_names_all: "Bibb|Crawford",
    county_fips_all: "13021|13079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31054,
    lat: 32.88214,
    lng: -83.20723,
    city: "McIntyre",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1294,
    density: 9.8,
    county_fips: 13319,
    county_name: "Wilkinson",
    county_weights: {
      13319: 100,
    },
    county_names_all: "Wilkinson",
    county_fips_all: 13319,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31055,
    lat: 31.98248,
    lng: -82.89046,
    city: "McRae Helena",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8005,
    density: 23.1,
    county_fips: 13271,
    county_name: "Telfair",
    county_weights: {
      13271: 100,
    },
    county_names_all: "Telfair",
    county_fips_all: 13271,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31057,
    lat: 32.43319,
    lng: -83.94324,
    city: "Marshallville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2048,
    density: 9.6,
    county_fips: 13193,
    county_name: "Macon",
    county_weights: {
      13193: 100,
    },
    county_names_all: "Macon",
    county_fips_all: 13193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31058,
    lat: 32.4911,
    lng: -84.41273,
    city: "Mauk",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1798,
    density: 6.7,
    county_fips: 13269,
    county_name: "Taylor",
    county_weights: {
      13197: 39.58,
      13249: 0.56,
      13269: 59.86,
    },
    county_names_all: "Taylor|Marion|Schley",
    county_fips_all: "13269|13197|13249",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31060,
    lat: 31.98333,
    lng: -83.05673,
    city: "Milan",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2056,
    density: 8.9,
    county_fips: 13271,
    county_name: "Telfair",
    county_weights: {
      13091: 29.96,
      13271: 70.04,
    },
    county_names_all: "Telfair|Dodge",
    county_fips_all: "13271|13091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31061,
    lat: 33.06041,
    lng: -83.22816,
    city: "Milledgeville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42625,
    density: 60.3,
    county_fips: 13009,
    county_name: "Baldwin",
    county_weights: {
      13009: 81.11,
      13141: 3.32,
      13237: 1.18,
      13319: 14.39,
    },
    county_names_all: "Baldwin|Wilkinson|Hancock|Putnam",
    county_fips_all: "13009|13319|13141|13237",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31062,
    lat: 33.04336,
    lng: -83.21563,
    city: "Milledgeville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 475,
    density: 597.1,
    county_fips: 13009,
    county_name: "Baldwin",
    county_weights: {
      13009: 100,
    },
    county_names_all: "Baldwin",
    county_fips_all: 13009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31063,
    lat: 32.29249,
    lng: -83.9648,
    city: "Montezuma",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4954,
    density: 17.1,
    county_fips: 13193,
    county_name: "Macon",
    county_weights: {
      13093: 11.8,
      13193: 88.2,
    },
    county_names_all: "Macon|Dooly",
    county_fips_all: "13193|13093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31064,
    lat: 33.29031,
    lng: -83.69986,
    city: "Monticello",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9469,
    density: 14.9,
    county_fips: 13159,
    county_name: "Jasper",
    county_weights: {
      13159: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 13159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31065,
    lat: 32.56301,
    lng: -83.16642,
    city: "Montrose",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1210,
    density: 6.9,
    county_fips: 13175,
    county_name: "Laurens",
    county_weights: {
      13023: 26.55,
      13175: 66.25,
      13319: 7.2,
    },
    county_names_all: "Laurens|Bleckley|Wilkinson",
    county_fips_all: "13175|13023|13319",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31066,
    lat: 32.80757,
    lng: -83.98953,
    city: "Musella",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1257,
    density: 7.9,
    county_fips: 13079,
    county_name: "Crawford",
    county_weights: {
      13021: 1.2,
      13079: 92.79,
      13207: 6.01,
    },
    county_names_all: "Crawford|Monroe|Bibb",
    county_fips_all: "13079|13207|13021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31067,
    lat: 32.85229,
    lng: -82.96471,
    city: "Oconee",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 266,
    density: 55.8,
    county_fips: 13303,
    county_name: "Washington",
    county_weights: {
      13303: 99.56,
      13319: 0.44,
    },
    county_names_all: "Washington|Wilkinson",
    county_fips_all: "13303|13319",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31068,
    lat: 32.33226,
    lng: -84.10704,
    city: "Oglethorpe",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4950,
    density: 20.5,
    county_fips: 13193,
    county_name: "Macon",
    county_weights: {
      13193: 100,
    },
    county_names_all: "Macon",
    county_fips_all: 13193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31069,
    lat: 32.4406,
    lng: -83.74373,
    city: "Perry",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20207,
    density: 78.2,
    county_fips: 13153,
    county_name: "Houston",
    county_weights: {
      13153: 95.58,
      13193: 0.6,
      13225: 3.82,
    },
    county_names_all: "Houston|Peach|Macon",
    county_fips_all: "13153|13225|13193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31070,
    lat: 32.18801,
    lng: -83.78669,
    city: "Pinehurst",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1590,
    density: 12.3,
    county_fips: 13093,
    county_name: "Dooly",
    county_weights: {
      13093: 100,
    },
    county_names_all: "Dooly",
    county_fips_all: 13093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31071,
    lat: 32.13325,
    lng: -83.52255,
    city: "Pineview",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1035,
    density: 7.1,
    county_fips: 13235,
    county_name: "Pulaski",
    county_weights: {
      13235: 68.07,
      13315: 31.93,
    },
    county_names_all: "Pulaski|Wilcox",
    county_fips_all: "13235|13315",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31072,
    lat: 31.96582,
    lng: -83.56619,
    city: "Pitts",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1060,
    density: 5.7,
    county_fips: 13315,
    county_name: "Wilcox",
    county_weights: {
      13081: 5.04,
      13093: 2.31,
      13315: 92.65,
    },
    county_names_all: "Wilcox|Crisp|Dooly",
    county_fips_all: "13315|13081|13093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31075,
    lat: 32.35428,
    lng: -82.95277,
    city: "Rentz",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2834,
    density: 21.6,
    county_fips: 13175,
    county_name: "Laurens",
    county_weights: {
      13175: 100,
    },
    county_names_all: "Laurens",
    county_fips_all: 13175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31076,
    lat: 32.54709,
    lng: -84.10762,
    city: "Reynolds",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2867,
    density: 9,
    county_fips: 13269,
    county_name: "Taylor",
    county_weights: {
      13193: 30.22,
      13269: 69.78,
    },
    county_names_all: "Taylor|Macon",
    county_fips_all: "13269|13193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31077,
    lat: 31.93489,
    lng: -83.17727,
    city: "Rhine",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1723,
    density: 6.6,
    county_fips: 13091,
    county_name: "Dodge",
    county_weights: {
      13091: 53.2,
      13271: 46.8,
    },
    county_names_all: "Dodge|Telfair",
    county_fips_all: "13091|13271",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31078,
    lat: 32.6987,
    lng: -84.06456,
    city: "Roberta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3203,
    density: 11.8,
    county_fips: 13079,
    county_name: "Crawford",
    county_weights: {
      13079: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 13079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31079,
    lat: 31.94104,
    lng: -83.46303,
    city: "Rochelle",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2705,
    density: 8.9,
    county_fips: 13315,
    county_name: "Wilcox",
    county_weights: {
      13017: 9.12,
      13315: 90.88,
    },
    county_names_all: "Wilcox|Ben Hill",
    county_fips_all: "13315|13017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31081,
    lat: 32.40824,
    lng: -84.27725,
    city: "Rupert",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11,
    density: 0.1,
    county_fips: 13269,
    county_name: "Taylor",
    county_weights: {
      13193: 10.51,
      13249: 1.19,
      13269: 88.3,
    },
    county_names_all: "Taylor|Macon|Schley",
    county_fips_all: "13269|13193|13249",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31082,
    lat: 32.992,
    lng: -82.89815,
    city: "Sandersville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10061,
    density: 17.1,
    county_fips: 13303,
    county_name: "Washington",
    county_weights: {
      13009: 2.87,
      13303: 97.13,
    },
    county_names_all: "Washington|Baldwin",
    county_fips_all: "13303|13009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31083,
    lat: 32.04473,
    lng: -82.81957,
    city: "Scotland",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 433,
    density: 204.9,
    county_fips: 13271,
    county_name: "Telfair",
    county_weights: {
      13271: 100,
    },
    county_names_all: "Telfair",
    county_fips_all: 13271,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31084,
    lat: 31.96152,
    lng: -83.6028,
    city: "Seville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45,
    density: 503.5,
    county_fips: 13315,
    county_name: "Wilcox",
    county_weights: {
      13315: 100,
    },
    county_names_all: "Wilcox",
    county_fips_all: 13315,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31085,
    lat: 33.42557,
    lng: -83.631,
    city: "Shady Dale",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1035,
    density: 9,
    county_fips: 13159,
    county_name: "Jasper",
    county_weights: {
      13159: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 13159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31087,
    lat: 33.26609,
    lng: -83.00712,
    city: "Sparta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8608,
    density: 7.6,
    county_fips: 13141,
    county_name: "Hancock",
    county_weights: {
      13009: 1.61,
      13141: 97.66,
      13303: 0.73,
    },
    county_names_all: "Hancock|Baldwin|Washington",
    county_fips_all: "13141|13009|13303",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31088,
    lat: 32.58587,
    lng: -83.65528,
    city: "Warner Robins",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57063,
    density: 748.5,
    county_fips: 13153,
    county_name: "Houston",
    county_weights: {
      13153: 100,
    },
    county_names_all: "Houston",
    county_fips_all: 13153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31089,
    lat: 32.85239,
    lng: -82.86361,
    city: "Tennille",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4021,
    density: 9.9,
    county_fips: 13303,
    county_name: "Washington",
    county_weights: {
      13167: 15.08,
      13303: 84.92,
    },
    county_names_all: "Washington|Johnson",
    county_fips_all: "13303|13167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31090,
    lat: 32.79599,
    lng: -83.0512,
    city: "Toomsboro",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1256,
    density: 4.1,
    county_fips: 13319,
    county_name: "Wilkinson",
    county_weights: {
      13319: 100,
    },
    county_names_all: "Wilkinson",
    county_fips_all: 13319,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31091,
    lat: 32.23653,
    lng: -83.69966,
    city: "Unadilla",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4347,
    density: 18.2,
    county_fips: 13093,
    county_name: "Dooly",
    county_weights: {
      13093: 94.86,
      13153: 2.47,
      13235: 2.67,
    },
    county_names_all: "Dooly|Pulaski|Houston",
    county_fips_all: "13093|13235|13153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31092,
    lat: 32.08984,
    lng: -83.78304,
    city: "Vienna",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6423,
    density: 13.2,
    county_fips: 13093,
    county_name: "Dooly",
    county_weights: {
      13081: 5.37,
      13093: 91.28,
      13315: 3.35,
    },
    county_names_all: "Dooly|Crisp|Wilcox",
    county_fips_all: "13093|13081|13315",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31093,
    lat: 32.64815,
    lng: -83.65688,
    city: "Warner Robins",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25488,
    density: 482,
    county_fips: 13153,
    county_name: "Houston",
    county_weights: {
      13153: 100,
    },
    county_names_all: "Houston",
    county_fips_all: 13153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31094,
    lat: 33.11378,
    lng: -82.79892,
    city: "Warthen",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 844,
    density: 2.9,
    county_fips: 13303,
    county_name: "Washington",
    county_weights: {
      13303: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 13303,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31096,
    lat: 32.71875,
    lng: -82.70636,
    city: "Wrightsville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7552,
    density: 16.1,
    county_fips: 13167,
    county_name: "Johnson",
    county_weights: {
      13167: 88.74,
      13175: 4.36,
      13303: 6.9,
    },
    county_names_all: "Johnson|Washington|Laurens",
    county_fips_all: "13167|13303|13175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31097,
    lat: 32.89947,
    lng: -84.15554,
    city: "Yatesville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1681,
    density: 12.1,
    county_fips: 13293,
    county_name: "Upson",
    county_weights: {
      13171: 11.59,
      13207: 1.67,
      13293: 86.74,
    },
    county_names_all: "Upson|Lamar|Monroe",
    county_fips_all: "13293|13171|13207",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31098,
    lat: 32.61898,
    lng: -83.57357,
    city: "Warner Robins",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3809,
    density: 83.7,
    county_fips: 13153,
    county_name: "Houston",
    county_weights: {
      13153: 100,
    },
    county_names_all: "Houston",
    county_fips_all: 13153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31201,
    lat: 32.81433,
    lng: -83.61846,
    city: "Macon",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7937,
    density: 327.3,
    county_fips: 13021,
    county_name: "Bibb",
    county_weights: {
      13021: 100,
    },
    county_names_all: "Bibb",
    county_fips_all: 13021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31204,
    lat: 32.84996,
    lng: -83.67609,
    city: "Macon",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31055,
    density: 822.1,
    county_fips: 13021,
    county_name: "Bibb",
    county_weights: {
      13021: 100,
    },
    county_names_all: "Bibb",
    county_fips_all: 13021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31206,
    lat: 32.79383,
    lng: -83.6832,
    city: "Macon",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24983,
    density: 362,
    county_fips: 13021,
    county_name: "Bibb",
    county_weights: {
      13021: 100,
    },
    county_names_all: "Bibb",
    county_fips_all: 13021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31207,
    lat: 32.82859,
    lng: -83.64928,
    city: "Macon",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1074,
    density: 2131.7,
    county_fips: 13021,
    county_name: "Bibb",
    county_weights: {
      13021: 100,
    },
    county_names_all: "Bibb",
    county_fips_all: 13021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31210,
    lat: 32.90486,
    lng: -83.7356,
    city: "Macon",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33647,
    density: 314.3,
    county_fips: 13021,
    county_name: "Bibb",
    county_weights: {
      13021: 75.18,
      13207: 24.82,
    },
    county_names_all: "Bibb|Monroe",
    county_fips_all: "13021|13207",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31211,
    lat: 32.90665,
    lng: -83.60435,
    city: "Macon",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14602,
    density: 127.2,
    county_fips: 13169,
    county_name: "Jones",
    county_weights: {
      13021: 18.54,
      13169: 81.46,
    },
    county_names_all: "Jones|Bibb",
    county_fips_all: "13169|13021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31213,
    lat: 32.84009,
    lng: -83.63937,
    city: "Macon",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 13021,
    county_name: "Bibb",
    county_weights: {
      13021: 100,
    },
    county_names_all: "Bibb",
    county_fips_all: 13021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31216,
    lat: 32.72885,
    lng: -83.67914,
    city: "Macon",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17267,
    density: 116.2,
    county_fips: 13021,
    county_name: "Bibb",
    county_weights: {
      13021: 100,
    },
    county_names_all: "Bibb",
    county_fips_all: 13021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31217,
    lat: 32.84506,
    lng: -83.50568,
    city: "Macon",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17044,
    density: 61.1,
    county_fips: 13169,
    county_name: "Jones",
    county_weights: {
      13021: 30.48,
      13169: 39.79,
      13289: 29.73,
    },
    county_names_all: "Jones|Bibb|Twiggs",
    county_fips_all: "13169|13021|13289",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31220,
    lat: 32.87813,
    lng: -83.8209,
    city: "Macon",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15230,
    density: 121.8,
    county_fips: 13021,
    county_name: "Bibb",
    county_weights: {
      13021: 57.28,
      13207: 42.72,
    },
    county_names_all: "Bibb|Monroe",
    county_fips_all: "13021|13207",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31301,
    lat: 31.7581,
    lng: -81.60386,
    city: "Allenhurst",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3906,
    density: 85.5,
    county_fips: 13179,
    county_name: "Liberty",
    county_weights: {
      13179: 57.43,
      13183: 42.57,
    },
    county_names_all: "Liberty|Long",
    county_fips_all: "13179|13183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31302,
    lat: 32.12567,
    lng: -81.34134,
    city: "Bloomingdale",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7540,
    density: 69.4,
    county_fips: 13051,
    county_name: "Chatham",
    county_weights: {
      13051: 58.61,
      13103: 41.39,
    },
    county_names_all: "Chatham|Effingham",
    county_fips_all: "13051|13103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31303,
    lat: 32.49631,
    lng: -81.30616,
    city: "Clyo",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2348,
    density: 11.1,
    county_fips: 13103,
    county_name: "Effingham",
    county_weights: {
      13103: 100,
    },
    county_names_all: "Effingham",
    county_fips_all: 13103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31305,
    lat: 31.39057,
    lng: -81.39054,
    city: "Darien",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6039,
    density: 37.7,
    county_fips: 13191,
    county_name: "McIntosh",
    county_weights: {
      13191: 100,
    },
    county_names_all: "McIntosh",
    county_fips_all: 13191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31307,
    lat: 32.17979,
    lng: -81.3967,
    city: "Eden",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1275,
    density: 104.5,
    county_fips: 13103,
    county_name: "Effingham",
    county_weights: {
      13103: 100,
    },
    county_names_all: "Effingham",
    county_fips_all: 13103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31308,
    lat: 32.1758,
    lng: -81.48024,
    city: "Ellabell",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8111,
    density: 37.1,
    county_fips: 13029,
    county_name: "Bryan",
    county_weights: {
      13029: 80.52,
      13031: 19.48,
    },
    county_names_all: "Bryan|Bulloch",
    county_fips_all: "13029|13031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31309,
    lat: 31.88382,
    lng: -81.44358,
    city: "Fleming",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 614,
    density: 8.1,
    county_fips: 13179,
    county_name: "Liberty",
    county_weights: {
      13179: 100,
    },
    county_names_all: "Liberty",
    county_fips_all: 13179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31312,
    lat: 32.3211,
    lng: -81.40126,
    city: "Guyton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21762,
    density: 48.1,
    county_fips: 13103,
    county_name: "Effingham",
    county_weights: {
      13103: 100,
    },
    county_names_all: "Effingham",
    county_fips_all: 13103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31313,
    lat: 31.83534,
    lng: -81.6183,
    city: "Hinesville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41378,
    density: 261.3,
    county_fips: 13179,
    county_name: "Liberty",
    county_weights: {
      13179: 97.12,
      13183: 2.88,
    },
    county_names_all: "Liberty|Long",
    county_fips_all: "13179|13183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31314,
    lat: 31.90628,
    lng: -81.61671,
    city: "Fort Stewart",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1378,
    density: 11.1,
    county_fips: 13179,
    county_name: "Liberty",
    county_weights: {
      13179: 100,
    },
    county_names_all: "Liberty",
    county_fips_all: 13179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31315,
    lat: 31.88768,
    lng: -81.60598,
    city: "Fort Stewart",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8387,
    density: 958,
    county_fips: 13179,
    county_name: "Liberty",
    county_weights: {
      13179: 100,
    },
    county_names_all: "Liberty",
    county_fips_all: 13179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31316,
    lat: 31.7183,
    lng: -81.73457,
    city: "Ludowici",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13732,
    density: 18.5,
    county_fips: 13183,
    county_name: "Long",
    county_weights: {
      13183: 100,
    },
    county_names_all: "Long",
    county_fips_all: 13183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31318,
    lat: 32.13575,
    lng: -81.37566,
    city: "Meldrim",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 369,
    density: 54.9,
    county_fips: 13103,
    county_name: "Effingham",
    county_weights: {
      13103: 100,
    },
    county_names_all: "Effingham",
    county_fips_all: 13103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31320,
    lat: 31.76707,
    lng: -81.36231,
    city: "Midway",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7627,
    density: 23.8,
    county_fips: 13179,
    county_name: "Liberty",
    county_weights: {
      13179: 100,
    },
    county_names_all: "Liberty",
    county_fips_all: 13179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31321,
    lat: 32.18185,
    lng: -81.66472,
    city: "Pembroke",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7576,
    density: 20.4,
    county_fips: 13029,
    county_name: "Bryan",
    county_weights: {
      13029: 50.21,
      13031: 49.79,
    },
    county_names_all: "Bryan|Bulloch",
    county_fips_all: "13029|13031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31322,
    lat: 32.10265,
    lng: -81.25626,
    city: "Pooler",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26119,
    density: 342.1,
    county_fips: 13051,
    county_name: "Chatham",
    county_weights: {
      13051: 100,
    },
    county_names_all: "Chatham",
    county_fips_all: 13051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31323,
    lat: 31.67359,
    lng: -81.45304,
    city: "Riceboro",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1295,
    density: 3.2,
    county_fips: 13179,
    county_name: "Liberty",
    county_weights: {
      13179: 56.15,
      13183: 13.3,
      13191: 30.55,
    },
    county_names_all: "Liberty|McIntosh|Long",
    county_fips_all: "13179|13191|13183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31324,
    lat: 31.85707,
    lng: -81.26951,
    city: "Richmond Hill",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27155,
    density: 80.8,
    county_fips: 13029,
    county_name: "Bryan",
    county_weights: {
      13029: 100,
    },
    county_names_all: "Bryan",
    county_fips_all: 13029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31326,
    lat: 32.29653,
    lng: -81.22824,
    city: "Rincon",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21722,
    density: 122.3,
    county_fips: 13103,
    county_name: "Effingham",
    county_weights: {
      13103: 100,
    },
    county_names_all: "Effingham",
    county_fips_all: 13103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31327,
    lat: 31.44909,
    lng: -81.25132,
    city: "Sapelo Island",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54,
    density: 1.1,
    county_fips: 13191,
    county_name: "McIntosh",
    county_weights: {
      13191: 100,
    },
    county_names_all: "McIntosh",
    county_fips_all: 13191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31328,
    lat: 32.01046,
    lng: -80.89009,
    city: "Tybee Island",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3419,
    density: 142.9,
    county_fips: 13051,
    county_name: "Chatham",
    county_weights: {
      13051: 100,
    },
    county_names_all: "Chatham",
    county_fips_all: 13051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31329,
    lat: 32.4251,
    lng: -81.34314,
    city: "Springfield",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10831,
    density: 45.3,
    county_fips: 13103,
    county_name: "Effingham",
    county_weights: {
      13103: 100,
    },
    county_names_all: "Effingham",
    county_fips_all: 13103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31331,
    lat: 31.5159,
    lng: -81.42042,
    city: "Townsend",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8079,
    density: 11,
    county_fips: 13191,
    county_name: "McIntosh",
    county_weights: {
      13191: 100,
    },
    county_names_all: "McIntosh",
    county_fips_all: 13191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31333,
    lat: 31.76786,
    lng: -81.62758,
    city: "Walthourville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 13179,
    county_name: "Liberty",
    county_weights: {
      13179: 100,
    },
    county_names_all: "Liberty",
    county_fips_all: 13179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31401,
    lat: 32.06831,
    lng: -81.09252,
    city: "Savannah",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19580,
    density: 2215,
    county_fips: 13051,
    county_name: "Chatham",
    county_weights: {
      13051: 100,
    },
    county_names_all: "Chatham",
    county_fips_all: 13051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31404,
    lat: 32.05064,
    lng: -81.05367,
    city: "Savannah",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33597,
    density: 945.9,
    county_fips: 13051,
    county_name: "Chatham",
    county_weights: {
      13051: 100,
    },
    county_names_all: "Chatham",
    county_fips_all: 13051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31405,
    lat: 32.0392,
    lng: -81.17352,
    city: "Savannah",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37929,
    density: 469,
    county_fips: 13051,
    county_name: "Chatham",
    county_weights: {
      13051: 100,
    },
    county_names_all: "Chatham",
    county_fips_all: 13051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31406,
    lat: 31.97783,
    lng: -81.08517,
    city: "Savannah",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35073,
    density: 516.9,
    county_fips: 13051,
    county_name: "Chatham",
    county_weights: {
      13051: 100,
    },
    county_names_all: "Chatham",
    county_fips_all: 13051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31407,
    lat: 32.18232,
    lng: -81.19942,
    city: "Port Wentworth",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14010,
    density: 159.7,
    county_fips: 13051,
    county_name: "Chatham",
    county_weights: {
      13051: 100,
    },
    county_names_all: "Chatham",
    county_fips_all: 13051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31408,
    lat: 32.11164,
    lng: -81.18158,
    city: "Savannah",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10554,
    density: 193.2,
    county_fips: 13051,
    county_name: "Chatham",
    county_weights: {
      13051: 100,
    },
    county_names_all: "Chatham",
    county_fips_all: 13051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31409,
    lat: 32.0106,
    lng: -81.15539,
    city: "Savannah",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 873,
    density: 50,
    county_fips: 13051,
    county_name: "Chatham",
    county_weights: {
      13051: 100,
    },
    county_names_all: "Chatham",
    county_fips_all: 13051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31410,
    lat: 32.01821,
    lng: -80.99215,
    city: "Savannah",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24626,
    density: 421.2,
    county_fips: 13051,
    county_name: "Chatham",
    county_weights: {
      13051: 100,
    },
    county_names_all: "Chatham",
    county_fips_all: 13051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31411,
    lat: 31.94002,
    lng: -81.03511,
    city: "Savannah",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8993,
    density: 154.4,
    county_fips: 13051,
    county_name: "Chatham",
    county_weights: {
      13051: 100,
    },
    county_names_all: "Chatham",
    county_fips_all: 13051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31415,
    lat: 32.0802,
    lng: -81.126,
    city: "Savannah",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12706,
    density: 744.4,
    county_fips: 13051,
    county_name: "Chatham",
    county_weights: {
      13051: 100,
    },
    county_names_all: "Chatham",
    county_fips_all: 13051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31419,
    lat: 31.98479,
    lng: -81.23867,
    city: "Savannah",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58483,
    density: 309.7,
    county_fips: 13051,
    county_name: "Chatham",
    county_weights: {
      13051: 100,
    },
    county_names_all: "Chatham",
    county_fips_all: 13051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31421,
    lat: 32.08712,
    lng: -81.08016,
    city: "Savannah",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 13051,
    county_name: "Chatham",
    county_weights: {
      13051: 100,
    },
    county_names_all: "Chatham",
    county_fips_all: 13051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31501,
    lat: 31.22693,
    lng: -82.34852,
    city: "Waycross",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16265,
    density: 523.6,
    county_fips: 13299,
    county_name: "Ware",
    county_weights: {
      13299: 100,
    },
    county_names_all: "Ware",
    county_fips_all: 13299,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31503,
    lat: 31.17687,
    lng: -82.40173,
    city: "Waycross",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20043,
    density: 22.9,
    county_fips: 13299,
    county_name: "Ware",
    county_weights: {
      13025: 7.94,
      13229: 0.72,
      13299: 91.34,
    },
    county_names_all: "Ware|Brantley|Pierce",
    county_fips_all: "13299|13025|13229",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31510,
    lat: 31.54729,
    lng: -82.43992,
    city: "Alma",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9658,
    density: 16.8,
    county_fips: 13005,
    county_name: "Bacon",
    county_weights: {
      13005: 89.89,
      13229: 10.11,
    },
    county_names_all: "Bacon|Pierce",
    county_fips_all: "13005|13229",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31512,
    lat: 31.54535,
    lng: -83.01255,
    city: "Ambrose",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1681,
    density: 7.9,
    county_fips: 13069,
    county_name: "Coffee",
    county_weights: {
      13069: 100,
    },
    county_names_all: "Coffee",
    county_fips_all: 13069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31513,
    lat: 31.77792,
    lng: -82.34622,
    city: "Baxley",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15950,
    density: 18.8,
    county_fips: 13001,
    county_name: "Appling",
    county_weights: {
      13001: 100,
    },
    county_names_all: "Appling",
    county_fips_all: 13001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31516,
    lat: 31.30946,
    lng: -82.2565,
    city: "Blackshear",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15052,
    density: 36.4,
    county_fips: 13229,
    county_name: "Pierce",
    county_weights: {
      13229: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 13229,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31518,
    lat: 31.51272,
    lng: -82.18325,
    city: "Bristol",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1064,
    density: 8.8,
    county_fips: 13001,
    county_name: "Appling",
    county_weights: {
      13001: 57.5,
      13229: 30.79,
      13305: 11.71,
    },
    county_names_all: "Appling|Pierce|Wayne",
    county_fips_all: "13001|13229|13305",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31519,
    lat: 31.67641,
    lng: -82.86946,
    city: "Broxton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3462,
    density: 10.8,
    county_fips: 13069,
    county_name: "Coffee",
    county_weights: {
      13069: 89.12,
      13161: 10.88,
    },
    county_names_all: "Coffee|Jeff Davis",
    county_fips_all: "13069|13161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31520,
    lat: 31.17745,
    lng: -81.48729,
    city: "Brunswick",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22783,
    density: 436.7,
    county_fips: 13127,
    county_name: "Glynn",
    county_weights: {
      13127: 100,
    },
    county_names_all: "Glynn",
    county_fips_all: 13127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31522,
    lat: 31.23595,
    lng: -81.35528,
    city: "Saint Simons Island",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16777,
    density: 121.3,
    county_fips: 13127,
    county_name: "Glynn",
    county_weights: {
      13127: 100,
    },
    county_names_all: "Glynn",
    county_fips_all: 13127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31523,
    lat: 31.21113,
    lng: -81.61519,
    city: "Brunswick",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13450,
    density: 27.1,
    county_fips: 13127,
    county_name: "Glynn",
    county_weights: {
      13127: 100,
    },
    county_names_all: "Glynn",
    county_fips_all: 13127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31524,
    lat: 31.24098,
    lng: -81.47449,
    city: "Brunswick",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 13127,
    county_name: "Glynn",
    county_weights: {
      13127: 100,
    },
    county_names_all: "Glynn",
    county_fips_all: 13127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31525,
    lat: 31.3114,
    lng: -81.5229,
    city: "Brunswick",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30780,
    density: 120.9,
    county_fips: 13127,
    county_name: "Glynn",
    county_weights: {
      13127: 100,
    },
    county_names_all: "Glynn",
    county_fips_all: 13127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31527,
    lat: 31.07155,
    lng: -81.42225,
    city: "Jekyll Island",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1116,
    density: 44.2,
    county_fips: 13127,
    county_name: "Glynn",
    county_weights: {
      13127: 100,
    },
    county_names_all: "Glynn",
    county_fips_all: 13127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31532,
    lat: 31.72462,
    lng: -82.74889,
    city: "Denton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 568,
    density: 4.7,
    county_fips: 13161,
    county_name: "Jeff Davis",
    county_weights: {
      13161: 100,
    },
    county_names_all: "Jeff Davis",
    county_fips_all: 13161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31533,
    lat: 31.55021,
    lng: -82.8287,
    city: "Douglas",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18050,
    density: 105.1,
    county_fips: 13069,
    county_name: "Coffee",
    county_weights: {
      13069: 100,
    },
    county_names_all: "Coffee",
    county_fips_all: 13069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31535,
    lat: 31.45841,
    lng: -82.86504,
    city: "Douglas",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11257,
    density: 46.2,
    county_fips: 13069,
    county_name: "Coffee",
    county_weights: {
      13069: 100,
    },
    county_names_all: "Coffee",
    county_fips_all: 13069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31537,
    lat: 30.89223,
    lng: -82.12492,
    city: "Folkston",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10559,
    density: 7.5,
    county_fips: 13049,
    county_name: "Charlton",
    county_weights: {
      13039: 4.89,
      13049: 95.11,
    },
    county_names_all: "Charlton|Camden",
    county_fips_all: "13049|13039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31539,
    lat: 31.82393,
    lng: -82.60658,
    city: "Hazlehurst",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14796,
    density: 20.7,
    county_fips: 13161,
    county_name: "Jeff Davis",
    county_weights: {
      13001: 2.02,
      13161: 97.98,
    },
    county_names_all: "Jeff Davis|Appling",
    county_fips_all: "13161|13001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31542,
    lat: 31.1528,
    lng: -82.12166,
    city: "Hoboken",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2645,
    density: 12.6,
    county_fips: 13025,
    county_name: "Brantley",
    county_weights: {
      13025: 100,
    },
    county_names_all: "Brantley",
    county_fips_all: 13025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31543,
    lat: 31.34455,
    lng: -81.82697,
    city: "Hortense",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4549,
    density: 10.7,
    county_fips: 13025,
    county_name: "Brantley",
    county_weights: {
      13025: 50.37,
      13127: 8.02,
      13305: 41.61,
    },
    county_names_all: "Brantley|Wayne|Glynn",
    county_fips_all: "13025|13305|13127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31544,
    lat: 31.83802,
    lng: -82.95561,
    city: "Jacksonville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 597,
    density: 2.2,
    county_fips: 13271,
    county_name: "Telfair",
    county_weights: {
      13271: 100,
    },
    county_names_all: "Telfair",
    county_fips_all: 13271,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31545,
    lat: 31.64867,
    lng: -81.9405,
    city: "Jesup",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15949,
    density: 60.7,
    county_fips: 13305,
    county_name: "Wayne",
    county_weights: {
      13305: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 13305,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31546,
    lat: 31.52521,
    lng: -81.8113,
    city: "Jesup",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8555,
    density: 21.9,
    county_fips: 13305,
    county_name: "Wayne",
    county_weights: {
      13305: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 13305,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31547,
    lat: 30.79096,
    lng: -81.53443,
    city: "Kings Bay",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 13039,
    county_name: "Camden",
    county_weights: {
      13039: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 13039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31548,
    lat: 30.7953,
    lng: -81.71043,
    city: "Kingsland",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21858,
    density: 134.5,
    county_fips: 13039,
    county_name: "Camden",
    county_weights: {
      13039: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 13039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31549,
    lat: 31.94503,
    lng: -82.70922,
    city: "Lumber City",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2590,
    density: 8.5,
    county_fips: 13271,
    county_name: "Telfair",
    county_weights: {
      13271: 56.49,
      13309: 43.51,
    },
    county_names_all: "Telfair|Wheeler",
    county_fips_all: "13271|13309",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31550,
    lat: 31.13924,
    lng: -82.59575,
    city: "Manor",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 762,
    density: 5.1,
    county_fips: 13299,
    county_name: "Ware",
    county_weights: {
      13065: 8.11,
      13299: 91.89,
    },
    county_names_all: "Ware|Clinch",
    county_fips_all: "13299|13065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31551,
    lat: 31.49223,
    lng: -82.27322,
    city: "Mershon",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 884,
    density: 5,
    county_fips: 13229,
    county_name: "Pierce",
    county_weights: {
      13005: 47.61,
      13229: 52.39,
    },
    county_names_all: "Pierce|Bacon",
    county_fips_all: "13229|13005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31552,
    lat: 31.29144,
    lng: -82.5996,
    city: "Millwood",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 965,
    density: 3.7,
    county_fips: 13299,
    county_name: "Ware",
    county_weights: {
      13003: 6.76,
      13069: 3.05,
      13299: 90.19,
    },
    county_names_all: "Ware|Atkinson|Coffee",
    county_fips_all: "13299|13003|13069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31553,
    lat: 31.17307,
    lng: -81.98026,
    city: "Nahunta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4520,
    density: 9.4,
    county_fips: 13025,
    county_name: "Brantley",
    county_weights: {
      13025: 98.09,
      13049: 1.91,
    },
    county_names_all: "Brantley|Charlton",
    county_fips_all: "13025|13049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31554,
    lat: 31.48265,
    lng: -82.61861,
    city: "Nicholls",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7803,
    density: 13.4,
    county_fips: 13069,
    county_name: "Coffee",
    county_weights: {
      13005: 23.26,
      13069: 51.73,
      13299: 25.01,
    },
    county_names_all: "Coffee|Ware|Bacon",
    county_fips_all: "13069|13299|13005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31555,
    lat: 31.70275,
    lng: -82.06647,
    city: "Odum",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2428,
    density: 6.5,
    county_fips: 13305,
    county_name: "Wayne",
    county_weights: {
      13001: 16.82,
      13305: 83.18,
    },
    county_names_all: "Wayne|Appling",
    county_fips_all: "13305|13001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31556,
    lat: 31.40508,
    lng: -82.1152,
    city: "Offerman",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 130,
    density: 455.7,
    county_fips: 13229,
    county_name: "Pierce",
    county_weights: {
      13229: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 13229,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31557,
    lat: 31.3745,
    lng: -82.09711,
    city: "Patterson",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3316,
    density: 11.3,
    county_fips: 13229,
    county_name: "Pierce",
    county_weights: {
      13001: 2.56,
      13025: 4.01,
      13229: 93.43,
    },
    county_names_all: "Pierce|Brantley|Appling",
    county_fips_all: "13229|13025|13001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31558,
    lat: 30.80173,
    lng: -81.51606,
    city: "Saint Marys",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22237,
    density: 119.7,
    county_fips: 13039,
    county_name: "Camden",
    county_weights: {
      13039: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 13039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31560,
    lat: 31.50312,
    lng: -82.02896,
    city: "Screven",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2806,
    density: 9.1,
    county_fips: 13305,
    county_name: "Wayne",
    county_weights: {
      13001: 0.66,
      13305: 99.34,
    },
    county_names_all: "Wayne|Appling",
    county_fips_all: "13305|13001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31561,
    lat: 31.20199,
    lng: -81.3373,
    city: "Sea Island",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 102,
    density: 8.3,
    county_fips: 13127,
    county_name: "Glynn",
    county_weights: {
      13127: 100,
    },
    county_names_all: "Glynn",
    county_fips_all: 13127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31562,
    lat: 30.47778,
    lng: -82.10755,
    city: "Saint George",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2540,
    density: 6.4,
    county_fips: 13049,
    county_name: "Charlton",
    county_weights: {
      13049: 100,
    },
    county_names_all: "Charlton",
    county_fips_all: 13049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31563,
    lat: 31.73653,
    lng: -82.18288,
    city: "Surrency",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1183,
    density: 3.8,
    county_fips: 13001,
    county_name: "Appling",
    county_weights: {
      13001: 100,
    },
    county_names_all: "Appling",
    county_fips_all: 13001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31564,
    lat: 31.24872,
    lng: -82.47093,
    city: "Waresboro",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 13299,
    county_name: "Ware",
    county_weights: {
      13299: 100,
    },
    county_names_all: "Ware",
    county_fips_all: 13299,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31565,
    lat: 31.06868,
    lng: -81.64783,
    city: "Waverly",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2236,
    density: 7.3,
    county_fips: 13039,
    county_name: "Camden",
    county_weights: {
      13039: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 13039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31566,
    lat: 31.18357,
    lng: -81.8084,
    city: "Waynesville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4638,
    density: 27.5,
    county_fips: 13025,
    county_name: "Brantley",
    county_weights: {
      13025: 79.44,
      13039: 6.95,
      13127: 13.61,
    },
    county_names_all: "Brantley|Glynn|Camden",
    county_fips_all: "13025|13127|13039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31567,
    lat: 31.63011,
    lng: -82.70705,
    city: "West Green",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 921,
    density: 8.4,
    county_fips: 13069,
    county_name: "Coffee",
    county_weights: {
      13069: 100,
    },
    county_names_all: "Coffee",
    county_fips_all: 13069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31568,
    lat: 31.00975,
    lng: -81.82218,
    city: "White Oak",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 529,
    density: 1.8,
    county_fips: 13039,
    county_name: "Camden",
    county_weights: {
      13039: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 13039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31569,
    lat: 30.90167,
    lng: -81.68249,
    city: "Woodbine",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5814,
    density: 29.1,
    county_fips: 13039,
    county_name: "Camden",
    county_weights: {
      13039: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 13039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31599,
    lat: 31.56333,
    lng: -81.90271,
    city: "Jesup",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 13305,
    county_name: "Wayne",
    county_weights: {
      13305: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 13305,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31601,
    lat: 30.74772,
    lng: -83.33968,
    city: "Valdosta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31652,
    density: 76.9,
    county_fips: 13185,
    county_name: "Lowndes",
    county_weights: {
      13027: 0.35,
      13185: 99.65,
    },
    county_names_all: "Lowndes|Brooks",
    county_fips_all: "13185|13027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31602,
    lat: 30.86734,
    lng: -83.34269,
    city: "Valdosta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35916,
    density: 347.5,
    county_fips: 13185,
    county_name: "Lowndes",
    county_weights: {
      13027: 38.69,
      13185: 61.31,
    },
    county_names_all: "Lowndes|Brooks",
    county_fips_all: "13185|13027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31605,
    lat: 30.93334,
    lng: -83.23482,
    city: "Valdosta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23955,
    density: 189.5,
    county_fips: 13185,
    county_name: "Lowndes",
    county_weights: {
      13185: 100,
    },
    county_names_all: "Lowndes",
    county_fips_all: 13185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31606,
    lat: 30.7963,
    lng: -83.18647,
    city: "Valdosta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3196,
    density: 27.7,
    county_fips: 13185,
    county_name: "Lowndes",
    county_weights: {
      13101: 6.1,
      13185: 93.9,
    },
    county_names_all: "Lowndes|Echols",
    county_fips_all: "13185|13101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31620,
    lat: 31.11861,
    lng: -83.43731,
    city: "Adel",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11272,
    density: 34.8,
    county_fips: 13075,
    county_name: "Cook",
    county_weights: {
      13075: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 13075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31622,
    lat: 31.37446,
    lng: -83.2023,
    city: "Alapaha",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2021,
    density: 6.5,
    county_fips: 13019,
    county_name: "Berrien",
    county_weights: {
      13019: 100,
    },
    county_names_all: "Berrien",
    county_fips_all: 13019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31623,
    lat: 31.07137,
    lng: -82.644,
    city: "Argyle",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 380,
    density: 232.7,
    county_fips: 13065,
    county_name: "Clinch",
    county_weights: {
      13065: 100,
    },
    county_names_all: "Clinch",
    county_fips_all: 13065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31624,
    lat: 31.29911,
    lng: -82.72612,
    city: "Axson",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1329,
    density: 5.4,
    county_fips: 13003,
    county_name: "Atkinson",
    county_weights: {
      13003: 87.17,
      13069: 11.22,
      13299: 1.61,
    },
    county_names_all: "Atkinson|Coffee|Ware",
    county_fips_all: "13003|13069|13299",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31625,
    lat: 30.9918,
    lng: -83.52556,
    city: "Barney",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1335,
    density: 8.9,
    county_fips: 13027,
    county_name: "Brooks",
    county_weights: {
      13027: 100,
    },
    county_names_all: "Brooks",
    county_fips_all: 13027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31626,
    lat: 30.77609,
    lng: -83.80208,
    city: "Boston",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3274,
    density: 8.9,
    county_fips: 13275,
    county_name: "Thomas",
    county_weights: {
      13027: 7.89,
      13275: 92.11,
    },
    county_names_all: "Thomas|Brooks",
    county_fips_all: "13275|13027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31627,
    lat: 31.03923,
    lng: -83.39238,
    city: "Cecil",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 229,
    density: 119.4,
    county_fips: 13075,
    county_name: "Cook",
    county_weights: {
      13075: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 13075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31629,
    lat: 30.82051,
    lng: -83.68809,
    city: "Dixie",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1070,
    density: 8.8,
    county_fips: 13027,
    county_name: "Brooks",
    county_weights: {
      13027: 100,
    },
    county_names_all: "Brooks",
    county_fips_all: 13027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31630,
    lat: 30.92354,
    lng: -82.85667,
    city: "Du Pont",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 656,
    density: 1.8,
    county_fips: 13065,
    county_name: "Clinch",
    county_weights: {
      13065: 82.04,
      13101: 17.96,
    },
    county_names_all: "Clinch|Echols",
    county_fips_all: "13065|13101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31631,
    lat: 30.71119,
    lng: -82.64657,
    city: "Fargo",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 493,
    density: 0.8,
    county_fips: 13101,
    county_name: "Echols",
    county_weights: {
      13049: 8.68,
      13065: 32.48,
      13101: 57.25,
      13299: 1.59,
    },
    county_names_all: "Echols|Clinch|Charlton|Ware",
    county_fips_all: "13101|13065|13049|13299",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31632,
    lat: 30.9876,
    lng: -83.36006,
    city: "Hahira",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13408,
    density: 46.1,
    county_fips: 13185,
    county_name: "Lowndes",
    county_weights: {
      13075: 21.08,
      13185: 78.92,
    },
    county_names_all: "Lowndes|Cook",
    county_fips_all: "13185|13075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31634,
    lat: 31.02867,
    lng: -82.7321,
    city: "Homerville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5179,
    density: 9.9,
    county_fips: 13065,
    county_name: "Clinch",
    county_weights: {
      13065: 100,
    },
    county_names_all: "Clinch",
    county_fips_all: 13065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31635,
    lat: 31.103,
    lng: -83.04317,
    city: "Lakeland",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6961,
    density: 18.8,
    county_fips: 13173,
    county_name: "Lanier",
    county_weights: {
      13003: 11.75,
      13065: 9.81,
      13173: 78.45,
    },
    county_names_all: "Lanier|Atkinson|Clinch",
    county_fips_all: "13173|13003|13065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31636,
    lat: 30.7337,
    lng: -83.1096,
    city: "Lake Park",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10585,
    density: 22,
    county_fips: 13101,
    county_name: "Echols",
    county_weights: {
      13101: 59.71,
      13185: 40.29,
    },
    county_names_all: "Echols|Lowndes",
    county_fips_all: "13101|13185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31637,
    lat: 31.293,
    lng: -83.44092,
    city: "Lenox",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2726,
    density: 12.8,
    county_fips: 13075,
    county_name: "Cook",
    county_weights: {
      13019: 35.34,
      13071: 16.74,
      13075: 41.58,
      13277: 6.33,
    },
    county_names_all: "Cook|Berrien|Colquitt|Tift",
    county_fips_all: "13075|13019|13071|13277",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31638,
    lat: 30.90627,
    lng: -83.51589,
    city: "Morven",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1573,
    density: 25.7,
    county_fips: 13027,
    county_name: "Brooks",
    county_weights: {
      13027: 100,
    },
    county_names_all: "Brooks",
    county_fips_all: 13027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31639,
    lat: 31.21239,
    lng: -83.19248,
    city: "Nashville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10606,
    density: 19.4,
    county_fips: 13019,
    county_name: "Berrien",
    county_weights: {
      13019: 98.92,
      13173: 1.08,
    },
    county_names_all: "Berrien|Lanier",
    county_fips_all: "13019|13173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31641,
    lat: 30.93182,
    lng: -83.09672,
    city: "Naylor",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1805,
    density: 7.9,
    county_fips: 13185,
    county_name: "Lowndes",
    county_weights: {
      13173: 41.31,
      13185: 58.69,
    },
    county_names_all: "Lowndes|Lanier",
    county_fips_all: "13185|13173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31642,
    lat: 31.25989,
    lng: -82.88273,
    city: "Pearson",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4676,
    density: 9.3,
    county_fips: 13003,
    county_name: "Atkinson",
    county_weights: {
      13003: 82.95,
      13065: 17.05,
    },
    county_names_all: "Atkinson|Clinch",
    county_fips_all: "13003|13065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31643,
    lat: 30.77061,
    lng: -83.55859,
    city: "Quitman",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8442,
    density: 12.4,
    county_fips: 13027,
    county_name: "Brooks",
    county_weights: {
      13027: 100,
    },
    county_names_all: "Brooks",
    county_fips_all: 13027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31645,
    lat: 31.06245,
    lng: -83.21846,
    city: "Ray City",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4904,
    density: 38.7,
    county_fips: 13019,
    county_name: "Berrien",
    county_weights: {
      13019: 69.58,
      13173: 18.53,
      13185: 11.89,
    },
    county_names_all: "Berrien|Lanier|Lowndes",
    county_fips_all: "13019|13173|13185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31647,
    lat: 31.21033,
    lng: -83.43158,
    city: "Sparks",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3571,
    density: 30.6,
    county_fips: 13075,
    county_name: "Cook",
    county_weights: {
      13075: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 13075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31648,
    lat: 30.70834,
    lng: -83.00838,
    city: "Statenville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 816,
    density: 16.3,
    county_fips: 13101,
    county_name: "Echols",
    county_weights: {
      13101: 100,
    },
    county_names_all: "Echols",
    county_fips_all: 13101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31649,
    lat: 30.94349,
    lng: -83.00781,
    city: "Stockton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1166,
    density: 14.4,
    county_fips: 13173,
    county_name: "Lanier",
    county_weights: {
      13101: 2.15,
      13173: 97.85,
    },
    county_names_all: "Lanier|Echols",
    county_fips_all: "13173|13101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31650,
    lat: 31.38327,
    lng: -83.02761,
    city: "Willacoochee",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3999,
    density: 13.7,
    county_fips: 13003,
    county_name: "Atkinson",
    county_weights: {
      13003: 66.79,
      13069: 33.21,
    },
    county_names_all: "Atkinson|Coffee",
    county_fips_all: "13003|13069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31698,
    lat: 30.84749,
    lng: -83.29051,
    city: "Valdosta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 770,
    density: 1984,
    county_fips: 13185,
    county_name: "Lowndes",
    county_weights: {
      13185: 100,
    },
    county_names_all: "Lowndes",
    county_fips_all: 13185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31699,
    lat: 30.96666,
    lng: -83.19237,
    city: "Moody Afb",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 13185,
    county_name: "Lowndes",
    county_weights: {
      13185: 100,
    },
    county_names_all: "Lowndes",
    county_fips_all: 13185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31701,
    lat: 31.57376,
    lng: -84.15508,
    city: "Albany",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18886,
    density: 344.4,
    county_fips: 13095,
    county_name: "Dougherty",
    county_weights: {
      13095: 90.39,
      13177: 9.61,
    },
    county_names_all: "Dougherty|Lee",
    county_fips_all: "13095|13177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31704,
    lat: 31.551,
    lng: -84.05634,
    city: "Albany",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 13095,
    county_name: "Dougherty",
    county_weights: {
      13095: 100,
    },
    county_names_all: "Dougherty",
    county_fips_all: 13095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31705,
    lat: 31.51169,
    lng: -84.05333,
    city: "Albany",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32290,
    density: 88.8,
    county_fips: 13095,
    county_name: "Dougherty",
    county_weights: {
      13095: 76.47,
      13205: 11.1,
      13321: 12.43,
    },
    county_names_all: "Dougherty|Worth|Mitchell",
    county_fips_all: "13095|13321|13205",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31707,
    lat: 31.58736,
    lng: -84.20689,
    city: "Albany",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23645,
    density: 497,
    county_fips: 13095,
    county_name: "Dougherty",
    county_weights: {
      13095: 91.14,
      13177: 8.86,
    },
    county_names_all: "Dougherty|Lee",
    county_fips_all: "13095|13177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31709,
    lat: 32.05071,
    lng: -84.14011,
    city: "Americus",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15509,
    density: 49.7,
    county_fips: 13261,
    county_name: "Sumter",
    county_weights: {
      13261: 100,
    },
    county_names_all: "Sumter",
    county_fips_all: 13261,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31711,
    lat: 32.18766,
    lng: -84.12258,
    city: "Andersonville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 751,
    density: 3.9,
    county_fips: 13261,
    county_name: "Sumter",
    county_weights: {
      13193: 37.28,
      13249: 0.81,
      13261: 61.91,
    },
    county_names_all: "Sumter|Macon|Schley",
    county_fips_all: "13261|13193|13249",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31712,
    lat: 31.8215,
    lng: -83.72806,
    city: "Arabi",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1109,
    density: 6.4,
    county_fips: 13081,
    county_name: "Crisp",
    county_weights: {
      13081: 78.02,
      13287: 20.5,
      13321: 1.48,
    },
    county_names_all: "Crisp|Turner|Worth",
    county_fips_all: "13081|13287|13321",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31714,
    lat: 31.71075,
    lng: -83.67496,
    city: "Ashburn",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5644,
    density: 12.8,
    county_fips: 13287,
    county_name: "Turner",
    county_weights: {
      13277: 0.8,
      13287: 91.46,
      13321: 7.74,
    },
    county_names_all: "Turner|Worth|Tift",
    county_fips_all: "13287|13321|13277",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31716,
    lat: 31.36512,
    lng: -84.11445,
    city: "Baconton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2817,
    density: 13.6,
    county_fips: 13205,
    county_name: "Mitchell",
    county_weights: {
      13205: 100,
    },
    county_names_all: "Mitchell",
    county_fips_all: 13205,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31719,
    lat: 32.08261,
    lng: -84.29768,
    city: "Americus",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8830,
    density: 36,
    county_fips: 13261,
    county_name: "Sumter",
    county_weights: {
      13249: 0.76,
      13261: 99.24,
    },
    county_names_all: "Sumter|Schley",
    county_fips_all: "13261|13249",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31720,
    lat: 30.87986,
    lng: -83.72297,
    city: "Barwick",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 285,
    density: 23.7,
    county_fips: 13027,
    county_name: "Brooks",
    county_weights: {
      13027: 93.16,
      13275: 6.84,
    },
    county_names_all: "Brooks|Thomas",
    county_fips_all: "13027|13275",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31721,
    lat: 31.5087,
    lng: -84.30331,
    city: "Albany",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20924,
    density: 36.6,
    county_fips: 13095,
    county_name: "Dougherty",
    county_weights: {
      13007: 15.95,
      13095: 82.76,
      13177: 0.67,
      13273: 0.62,
    },
    county_names_all: "Dougherty|Baker|Lee|Terrell",
    county_fips_all: "13095|13007|13177|13273",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31722,
    lat: 31.05492,
    lng: -83.61559,
    city: "Berlin",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 492,
    density: 80,
    county_fips: 13071,
    county_name: "Colquitt",
    county_weights: {
      13071: 100,
    },
    county_names_all: "Colquitt",
    county_fips_all: 13071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31727,
    lat: 31.41778,
    lng: -83.3874,
    city: "Brookfield",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 13277,
    county_name: "Tift",
    county_weights: {
      13277: 100,
    },
    county_names_all: "Tift",
    county_fips_all: 13277,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31730,
    lat: 31.20749,
    lng: -84.28438,
    city: "Camilla",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7836,
    density: 11.7,
    county_fips: 13205,
    county_name: "Mitchell",
    county_weights: {
      13087: 3.06,
      13205: 96.94,
    },
    county_names_all: "Mitchell|Decatur",
    county_fips_all: "13205|13087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31733,
    lat: 31.59293,
    lng: -83.48599,
    city: "Chula",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1435,
    density: 10.3,
    county_fips: 13155,
    county_name: "Irwin",
    county_weights: {
      13155: 61.44,
      13277: 38.56,
    },
    county_names_all: "Irwin|Tift",
    county_fips_all: "13155|13277",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31735,
    lat: 31.97195,
    lng: -83.96446,
    city: "Cobb",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 581,
    density: 11.3,
    county_fips: 13261,
    county_name: "Sumter",
    county_weights: {
      13261: 100,
    },
    county_names_all: "Sumter",
    county_fips_all: 13261,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31738,
    lat: 31.01133,
    lng: -83.87502,
    city: "Coolidge",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2232,
    density: 13.8,
    county_fips: 13275,
    county_name: "Thomas",
    county_weights: {
      13071: 26.44,
      13275: 73.56,
    },
    county_names_all: "Thomas|Colquitt",
    county_fips_all: "13275|13071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31743,
    lat: 31.90089,
    lng: -84.00604,
    city: "De Soto",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 326,
    density: 1.9,
    county_fips: 13177,
    county_name: "Lee",
    county_weights: {
      13177: 60.35,
      13261: 39.65,
    },
    county_names_all: "Lee|Sumter",
    county_fips_all: "13177|13261",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31744,
    lat: 31.33709,
    lng: -83.90646,
    city: "Doerun",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2763,
    density: 8.8,
    county_fips: 13321,
    county_name: "Worth",
    county_weights: {
      13071: 42.8,
      13205: 3.16,
      13321: 54.04,
    },
    county_names_all: "Worth|Colquitt|Mitchell",
    county_fips_all: "13321|13071|13205",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31747,
    lat: 31.1753,
    lng: -83.58736,
    city: "Ellenton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 200,
    density: 111,
    county_fips: 13071,
    county_name: "Colquitt",
    county_weights: {
      13071: 100,
    },
    county_names_all: "Colquitt",
    county_fips_all: 13071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31749,
    lat: 31.42128,
    lng: -83.3315,
    city: "Enigma",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2764,
    density: 16.8,
    county_fips: 13019,
    county_name: "Berrien",
    county_weights: {
      13019: 78.08,
      13155: 13.6,
      13277: 8.32,
    },
    county_names_all: "Berrien|Irwin|Tift",
    county_fips_all: "13019|13155|13277",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31750,
    lat: 31.73391,
    lng: -83.21752,
    city: "Fitzgerald",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17959,
    density: 24.7,
    county_fips: 13017,
    county_name: "Ben Hill",
    county_weights: {
      13017: 74.41,
      13155: 25.59,
    },
    county_names_all: "Ben Hill|Irwin",
    county_fips_all: "13017|13155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31753,
    lat: 31.20044,
    lng: -83.87287,
    city: "Funston",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 13071,
    county_name: "Colquitt",
    county_weights: {
      13071: 100,
    },
    county_names_all: "Colquitt",
    county_fips_all: 13071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31756,
    lat: 31.17558,
    lng: -83.96224,
    city: "Hartsfield",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1048,
    density: 9.4,
    county_fips: 13071,
    county_name: "Colquitt",
    county_weights: {
      13071: 99.82,
      13205: 0.18,
    },
    county_names_all: "Colquitt|Mitchell",
    county_fips_all: "13071|13205",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31757,
    lat: 30.87291,
    lng: -83.89945,
    city: "Thomasville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10977,
    density: 50.1,
    county_fips: 13275,
    county_name: "Thomas",
    county_weights: {
      13275: 100,
    },
    county_names_all: "Thomas",
    county_fips_all: 13275,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31763,
    lat: 31.73889,
    lng: -84.14711,
    city: "Leesburg",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24307,
    density: 37.9,
    county_fips: 13177,
    county_name: "Lee",
    county_weights: {
      13095: 0.79,
      13177: 99.06,
      13273: 0.15,
    },
    county_names_all: "Lee|Dougherty|Terrell",
    county_fips_all: "13177|13095|13273",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31764,
    lat: 31.9772,
    lng: -84.08135,
    city: "Leslie",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1844,
    density: 9.4,
    county_fips: 13261,
    county_name: "Sumter",
    county_weights: {
      13177: 14.08,
      13261: 85.92,
    },
    county_names_all: "Sumter|Lee",
    county_fips_all: "13261|13177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31765,
    lat: 31.09514,
    lng: -84.0346,
    city: "Meigs",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2577,
    density: 12,
    county_fips: 13205,
    county_name: "Mitchell",
    county_weights: {
      13071: 20.94,
      13205: 50.07,
      13275: 28.99,
    },
    county_names_all: "Mitchell|Thomas|Colquitt",
    county_fips_all: "13205|13275|13071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31768,
    lat: 31.19329,
    lng: -83.84047,
    city: "Moultrie",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22212,
    density: 60.2,
    county_fips: 13071,
    county_name: "Colquitt",
    county_weights: {
      13071: 100,
    },
    county_names_all: "Colquitt",
    county_fips_all: 13071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31771,
    lat: 31.24332,
    lng: -83.64775,
    city: "Norman Park",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7626,
    density: 26.1,
    county_fips: 13071,
    county_name: "Colquitt",
    county_weights: {
      13071: 96.93,
      13321: 3.07,
    },
    county_names_all: "Colquitt|Worth",
    county_fips_all: "13071|13321",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31772,
    lat: 31.72213,
    lng: -83.96504,
    city: "Oakfield",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 522,
    density: 3.7,
    county_fips: 13321,
    county_name: "Worth",
    county_weights: {
      13321: 100,
    },
    county_names_all: "Worth",
    county_fips_all: 13321,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31773,
    lat: 30.97795,
    lng: -84.04624,
    city: "Ochlocknee",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4245,
    density: 19.2,
    county_fips: 13275,
    county_name: "Thomas",
    county_weights: {
      13071: 1.96,
      13131: 19.1,
      13275: 78.94,
    },
    county_names_all: "Thomas|Grady|Colquitt",
    county_fips_all: "13275|13131|13071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31774,
    lat: 31.56102,
    lng: -83.27125,
    city: "Ocilla",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6452,
    density: 15.3,
    county_fips: 13155,
    county_name: "Irwin",
    county_weights: {
      13155: 100,
    },
    county_names_all: "Irwin",
    county_fips_all: 13155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31775,
    lat: 31.33418,
    lng: -83.60366,
    city: "Omega",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3121,
    density: 27.1,
    county_fips: 13071,
    county_name: "Colquitt",
    county_weights: {
      13071: 43.61,
      13277: 37.43,
      13321: 18.96,
    },
    county_names_all: "Colquitt|Tift|Worth",
    county_fips_all: "13071|13277|13321",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31778,
    lat: 30.9754,
    lng: -83.70931,
    city: "Pavo",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2262,
    density: 7.9,
    county_fips: 13027,
    county_name: "Brooks",
    county_weights: {
      13027: 61.54,
      13071: 2.56,
      13275: 35.9,
    },
    county_names_all: "Brooks|Thomas|Colquitt",
    county_fips_all: "13027|13275|13071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31779,
    lat: 31.10032,
    lng: -84.19117,
    city: "Pelham",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10338,
    density: 29.5,
    county_fips: 13205,
    county_name: "Mitchell",
    county_weights: {
      13131: 33.15,
      13205: 64.66,
      13275: 2.19,
    },
    county_names_all: "Mitchell|Grady|Thomas",
    county_fips_all: "13205|13131|13275",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31780,
    lat: 32.02898,
    lng: -84.39024,
    city: "Plains",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1990,
    density: 8.4,
    county_fips: 13261,
    county_name: "Sumter",
    county_weights: {
      13261: 90.51,
      13307: 9.49,
    },
    county_names_all: "Sumter|Webster",
    county_fips_all: "13261|13307",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31781,
    lat: 31.56062,
    lng: -83.79316,
    city: "Poulan",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2084,
    density: 29.7,
    county_fips: 13321,
    county_name: "Worth",
    county_weights: {
      13321: 100,
    },
    county_names_all: "Worth",
    county_fips_all: 13321,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31783,
    lat: 31.76416,
    lng: -83.4738,
    city: "Rebecca",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1208,
    density: 4.8,
    county_fips: 13287,
    county_name: "Turner",
    county_weights: {
      13017: 19.43,
      13155: 28.25,
      13287: 52.32,
    },
    county_names_all: "Turner|Irwin|Ben Hill",
    county_fips_all: "13287|13155|13017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31784,
    lat: 31.25671,
    lng: -84.0431,
    city: "Sale City",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 892,
    density: 10.6,
    county_fips: 13205,
    county_name: "Mitchell",
    county_weights: {
      13205: 100,
    },
    county_names_all: "Mitchell",
    county_fips_all: 13205,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31787,
    lat: 31.89994,
    lng: -84.24947,
    city: "Smithville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1418,
    density: 6.5,
    county_fips: 13177,
    county_name: "Lee",
    county_weights: {
      13177: 66,
      13261: 34,
    },
    county_names_all: "Lee|Sumter",
    county_fips_all: "13177|13261",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31788,
    lat: 31.10891,
    lng: -83.68099,
    city: "Moultrie",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9954,
    density: 29.9,
    county_fips: 13071,
    county_name: "Colquitt",
    county_weights: {
      13027: 1.87,
      13071: 98.13,
    },
    county_names_all: "Colquitt|Brooks",
    county_fips_all: "13071|13027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31789,
    lat: 31.47858,
    lng: -83.73257,
    city: "Sumner",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 968,
    density: 5.7,
    county_fips: 13321,
    county_name: "Worth",
    county_weights: {
      13321: 100,
    },
    county_names_all: "Worth",
    county_fips_all: 13321,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31790,
    lat: 31.64823,
    lng: -83.5693,
    city: "Sycamore",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2181,
    density: 12.2,
    county_fips: 13287,
    county_name: "Turner",
    county_weights: {
      13155: 3.2,
      13277: 2.78,
      13287: 94.02,
    },
    county_names_all: "Turner|Irwin|Tift",
    county_fips_all: "13287|13155|13277",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31791,
    lat: 31.53383,
    lng: -83.87833,
    city: "Sylvester",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11485,
    density: 21.2,
    county_fips: 13321,
    county_name: "Worth",
    county_weights: {
      13095: 0.36,
      13321: 99.64,
    },
    county_names_all: "Worth|Dougherty",
    county_fips_all: "13321|13095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31792,
    lat: 30.77079,
    lng: -84.04238,
    city: "Thomasville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22458,
    density: 41,
    county_fips: 13275,
    county_name: "Thomas",
    county_weights: {
      13131: 29.18,
      13275: 70.82,
    },
    county_names_all: "Thomas|Grady",
    county_fips_all: "13275|13131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31793,
    lat: 31.46104,
    lng: -83.58386,
    city: "Tifton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9029,
    density: 37.3,
    county_fips: 13277,
    county_name: "Tift",
    county_weights: {
      13277: 100,
    },
    county_names_all: "Tift",
    county_fips_all: 13277,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31794,
    lat: 31.44418,
    lng: -83.45151,
    city: "Tifton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27918,
    density: 94.1,
    county_fips: 13277,
    county_name: "Tift",
    county_weights: {
      13019: 9.22,
      13277: 90.78,
    },
    county_names_all: "Tift|Berrien",
    county_fips_all: "13277|13019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31795,
    lat: 31.47611,
    lng: -83.67633,
    city: "Ty Ty",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1808,
    density: 14.7,
    county_fips: 13321,
    county_name: "Worth",
    county_weights: {
      13277: 26.77,
      13321: 73.23,
    },
    county_names_all: "Worth|Tift",
    county_fips_all: "13321|13277",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31796,
    lat: 31.77351,
    lng: -83.87659,
    city: "Warwick",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1462,
    density: 8,
    county_fips: 13321,
    county_name: "Worth",
    county_weights: {
      13081: 0.9,
      13321: 99.1,
    },
    county_names_all: "Worth|Crisp",
    county_fips_all: "13321|13081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31798,
    lat: 31.64117,
    lng: -83.04333,
    city: "Wray",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 812,
    density: 3.4,
    county_fips: 13155,
    county_name: "Irwin",
    county_weights: {
      13017: 12.47,
      13069: 34.22,
      13155: 53.31,
    },
    county_names_all: "Irwin|Coffee|Ben Hill",
    county_fips_all: "13155|13069|13017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31801,
    lat: 32.51765,
    lng: -84.5906,
    city: "Box Springs",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3068,
    density: 13.8,
    county_fips: 13197,
    county_name: "Marion",
    county_weights: {
      13197: 64.88,
      13215: 2.49,
      13263: 32.63,
    },
    county_names_all: "Marion|Talbot|Muscogee",
    county_fips_all: "13197|13263|13215",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31803,
    lat: 32.30501,
    lng: -84.51682,
    city: "Buena Vista",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5367,
    density: 7.3,
    county_fips: 13197,
    county_name: "Marion",
    county_weights: {
      13197: 93.63,
      13249: 5.63,
      13307: 0.74,
    },
    county_names_all: "Marion|Schley|Webster",
    county_fips_all: "13197|13249|13307",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31804,
    lat: 32.66199,
    lng: -84.88402,
    city: "Cataula",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6151,
    density: 49.4,
    county_fips: 13145,
    county_name: "Harris",
    county_weights: {
      13145: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 13145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31805,
    lat: 32.26621,
    lng: -84.74612,
    city: "Cusseta",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2790,
    density: 15.9,
    county_fips: 13053,
    county_name: "Chattahoochee",
    county_weights: {
      13053: 83.37,
      13259: 16.63,
    },
    county_names_all: "Chattahoochee|Stewart",
    county_fips_all: "13053|13259",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31806,
    lat: 32.26147,
    lng: -84.30043,
    city: "Ellaville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5135,
    density: 12.4,
    county_fips: 13249,
    county_name: "Schley",
    county_weights: {
      13193: 7.14,
      13249: 92.86,
    },
    county_names_all: "Schley|Macon",
    county_fips_all: "13249|13193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31807,
    lat: 32.64054,
    lng: -84.80142,
    city: "Ellerslie",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2489,
    density: 71.5,
    county_fips: 13145,
    county_name: "Harris",
    county_weights: {
      13145: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 13145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31808,
    lat: 32.63545,
    lng: -85.00707,
    city: "Fortson",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9077,
    density: 63.2,
    county_fips: 13145,
    county_name: "Harris",
    county_weights: {
      13145: 79.62,
      13215: 20.38,
    },
    county_names_all: "Harris|Muscogee",
    county_fips_all: "13145|13215",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31810,
    lat: 32.56775,
    lng: -84.53236,
    city: "Geneva",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 206,
    density: 5,
    county_fips: 13263,
    county_name: "Talbot",
    county_weights: {
      13263: 100,
    },
    county_names_all: "Talbot",
    county_fips_all: 13263,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31811,
    lat: 32.74522,
    lng: -84.93327,
    city: "Hamilton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6204,
    density: 18.3,
    county_fips: 13145,
    county_name: "Harris",
    county_weights: {
      13145: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 13145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31812,
    lat: 32.63173,
    lng: -84.42019,
    city: "Junction City",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 682,
    density: 4,
    county_fips: 13263,
    county_name: "Talbot",
    county_weights: {
      13263: 79.54,
      13269: 20.46,
    },
    county_names_all: "Talbot|Taylor",
    county_fips_all: "13263|13269",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31814,
    lat: 32.20531,
    lng: -84.8614,
    city: "Louvale",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55,
    density: 1.3,
    county_fips: 13259,
    county_name: "Stewart",
    county_weights: {
      13259: 100,
    },
    county_names_all: "Stewart",
    county_fips_all: 13259,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31815,
    lat: 32.04117,
    lng: -84.85407,
    city: "Lumpkin",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3949,
    density: 6,
    county_fips: 13259,
    county_name: "Stewart",
    county_weights: {
      13259: 100,
    },
    county_names_all: "Stewart",
    county_fips_all: 13259,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31816,
    lat: 32.8762,
    lng: -84.60169,
    city: "Manchester",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5510,
    density: 56.7,
    county_fips: 13199,
    county_name: "Meriwether",
    county_weights: {
      13199: 85.89,
      13263: 14.11,
    },
    county_names_all: "Meriwether|Talbot",
    county_fips_all: "13199|13263",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31820,
    lat: 32.57576,
    lng: -84.82947,
    city: "Midland",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11832,
    density: 110.6,
    county_fips: 13215,
    county_name: "Muscogee",
    county_weights: {
      13145: 39.77,
      13215: 60.23,
    },
    county_names_all: "Muscogee|Harris",
    county_fips_all: "13215|13145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31821,
    lat: 32.14048,
    lng: -84.97083,
    city: "Omaha",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 227,
    density: 1.3,
    county_fips: 13259,
    county_name: "Stewart",
    county_weights: {
      13259: 100,
    },
    county_names_all: "Stewart",
    county_fips_all: 13259,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 31822,
    lat: 32.86708,
    lng: -84.91107,
    city: "Pine Mountain",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6166,
    density: 20.6,
    county_fips: 13145,
    county_name: "Harris",
    county_weights: {
      13145: 49.84,
      13199: 17.69,
      13285: 32.47,
    },
    county_names_all: "Harris|Troup|Meriwether",
    county_fips_all: "13145|13285|13199",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31823,
    lat: 32.80061,
    lng: -84.81377,
    city: "Pine Mountain Valley",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 690,
    density: 35.9,
    county_fips: 13145,
    county_name: "Harris",
    county_weights: {
      13145: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 13145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31824,
    lat: 32.05687,
    lng: -84.5229,
    city: "Preston",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1507,
    density: 5,
    county_fips: 13307,
    county_name: "Webster",
    county_weights: {
      13197: 1.82,
      13307: 98.18,
    },
    county_names_all: "Webster|Marion",
    county_fips_all: "13307|13197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31825,
    lat: 32.1081,
    lng: -84.6693,
    city: "Richland",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2471,
    density: 6.6,
    county_fips: 13259,
    county_name: "Stewart",
    county_weights: {
      13259: 70.2,
      13307: 29.8,
    },
    county_names_all: "Stewart|Webster",
    county_fips_all: "13259|13307",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31826,
    lat: 32.79526,
    lng: -84.70292,
    city: "Shiloh",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2065,
    density: 15.5,
    county_fips: 13145,
    county_name: "Harris",
    county_weights: {
      13145: 65.99,
      13263: 34.01,
    },
    county_names_all: "Harris|Talbot",
    county_fips_all: "13145|13263",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31827,
    lat: 32.69821,
    lng: -84.49847,
    city: "Talbotton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2152,
    density: 5.4,
    county_fips: 13263,
    county_name: "Talbot",
    county_weights: {
      13263: 100,
    },
    county_names_all: "Talbot",
    county_fips_all: 13263,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31829,
    lat: 32.56681,
    lng: -84.72787,
    city: "Upatoi",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1251,
    density: 36.2,
    county_fips: 13215,
    county_name: "Muscogee",
    county_weights: {
      13145: 15.78,
      13215: 84.22,
    },
    county_names_all: "Muscogee|Harris",
    county_fips_all: "13215|13145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31830,
    lat: 32.8951,
    lng: -84.72689,
    city: "Warm Springs",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2354,
    density: 16.6,
    county_fips: 13199,
    county_name: "Meriwether",
    county_weights: {
      13145: 9.79,
      13199: 90.21,
    },
    county_names_all: "Meriwether|Harris",
    county_fips_all: "13199|13145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31831,
    lat: 32.66486,
    lng: -84.70701,
    city: "Waverly Hall",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2951,
    density: 15.5,
    county_fips: 13145,
    county_name: "Harris",
    county_weights: {
      13145: 62.4,
      13263: 37.6,
    },
    county_names_all: "Harris|Talbot",
    county_fips_all: "13145|13263",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31832,
    lat: 31.95501,
    lng: -84.61709,
    city: "Weston",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 222,
    density: 3,
    county_fips: 13307,
    county_name: "Webster",
    county_weights: {
      13243: 12.44,
      13307: 87.56,
    },
    county_names_all: "Webster|Randolph",
    county_fips_all: "13307|13243",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31833,
    lat: 32.84963,
    lng: -85.09202,
    city: "West Point",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6883,
    density: 27.2,
    county_fips: 13145,
    county_name: "Harris",
    county_weights: {
      13145: 60.91,
      13285: 39.09,
    },
    county_names_all: "Harris|Troup",
    county_fips_all: "13145|13285",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31836,
    lat: 32.79189,
    lng: -84.54891,
    city: "Woodland",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 993,
    density: 4.3,
    county_fips: 13263,
    county_name: "Talbot",
    county_weights: {
      13263: 100,
    },
    county_names_all: "Talbot",
    county_fips_all: 13263,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31901,
    lat: 32.46461,
    lng: -84.97986,
    city: "Columbus",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6150,
    density: 540.2,
    county_fips: 13215,
    county_name: "Muscogee",
    county_weights: {
      13215: 100,
    },
    county_names_all: "Muscogee",
    county_fips_all: 13215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31903,
    lat: 32.41484,
    lng: -84.95321,
    city: "Columbus",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17796,
    density: 688.8,
    county_fips: 13215,
    county_name: "Muscogee",
    county_weights: {
      13215: 100,
    },
    county_names_all: "Muscogee",
    county_fips_all: 13215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31904,
    lat: 32.55189,
    lng: -85.00009,
    city: "Columbus",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32087,
    density: 450.3,
    county_fips: 13215,
    county_name: "Muscogee",
    county_weights: {
      13215: 100,
    },
    county_names_all: "Muscogee",
    county_fips_all: 13215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31905,
    lat: 32.37304,
    lng: -84.84331,
    city: "Fort Benning",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17867,
    density: 75.7,
    county_fips: 13053,
    county_name: "Chattahoochee",
    county_weights: {
      13053: 80.96,
      13215: 19.04,
    },
    county_names_all: "Chattahoochee|Muscogee",
    county_fips_all: "13053|13215",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31906,
    lat: 32.46815,
    lng: -84.94963,
    city: "Columbus",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20114,
    density: 1130.6,
    county_fips: 13215,
    county_name: "Muscogee",
    county_weights: {
      13215: 100,
    },
    county_names_all: "Muscogee",
    county_fips_all: 13215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31907,
    lat: 32.48388,
    lng: -84.89976,
    city: "Columbus",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58615,
    density: 949,
    county_fips: 13215,
    county_name: "Muscogee",
    county_weights: {
      13215: 100,
    },
    county_names_all: "Muscogee",
    county_fips_all: 13215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 31909,
    lat: 32.54517,
    lng: -84.92385,
    city: "Columbus",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38486,
    density: 794.6,
    county_fips: 13215,
    county_name: "Muscogee",
    county_weights: {
      13215: 100,
    },
    county_names_all: "Muscogee",
    county_fips_all: 13215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32003,
    lat: 30.09813,
    lng: -81.71255,
    city: "Fleming Island",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30582,
    density: 745.5,
    county_fips: 12019,
    county_name: "Clay",
    county_weights: {
      12019: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 12019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32008,
    lat: 29.90351,
    lng: -82.90311,
    city: "Branford",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4887,
    density: 12.5,
    county_fips: 12067,
    county_name: "Lafayette",
    county_weights: {
      12029: 5.56,
      12041: 24.59,
      12067: 46.09,
      12121: 23.75,
    },
    county_names_all: "Lafayette|Gilchrist|Suwannee|Dixie",
    county_fips_all: "12067|12041|12121|12029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32009,
    lat: 30.42078,
    lng: -81.97252,
    city: "Bryceville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3841,
    density: 17,
    county_fips: 12089,
    county_name: "Nassau",
    county_weights: {
      12089: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 12089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32011,
    lat: 30.56985,
    lng: -81.83975,
    city: "Callahan",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13910,
    density: 31.9,
    county_fips: 12089,
    county_name: "Nassau",
    county_weights: {
      12089: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 12089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32013,
    lat: 30.19366,
    lng: -83.29116,
    city: "Day",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12067,
    county_name: "Lafayette",
    county_weights: {
      12067: 100,
    },
    county_names_all: "Lafayette",
    county_fips_all: 12067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32024,
    lat: 30.0793,
    lng: -82.72597,
    city: "Lake City",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18957,
    density: 50.3,
    county_fips: 12023,
    county_name: "Columbia",
    county_weights: {
      12023: 81.42,
      12121: 18.58,
    },
    county_names_all: "Columbia|Suwannee",
    county_fips_all: "12023|12121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32025,
    lat: 30.11266,
    lng: -82.57072,
    city: "Lake City",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24317,
    density: 89.8,
    county_fips: 12023,
    county_name: "Columbia",
    county_weights: {
      12023: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 12023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32033,
    lat: 29.78851,
    lng: -81.44263,
    city: "Elkton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4771,
    density: 23.5,
    county_fips: 12109,
    county_name: "St. Johns",
    county_weights: {
      12109: 100,
    },
    county_names_all: "St. Johns",
    county_fips_all: 12109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32034,
    lat: 30.624,
    lng: -81.49392,
    city: "Fernandina Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38189,
    density: 226.9,
    county_fips: 12089,
    county_name: "Nassau",
    county_weights: {
      12089: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 12089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32038,
    lat: 29.93617,
    lng: -82.69924,
    city: "Fort White",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10639,
    density: 38.4,
    county_fips: 12023,
    county_name: "Columbia",
    county_weights: {
      12023: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 12023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32040,
    lat: 30.24696,
    lng: -82.23531,
    city: "Glen Saint Mary",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8450,
    density: 26.9,
    county_fips: 12003,
    county_name: "Baker",
    county_weights: {
      12003: 100,
    },
    county_names_all: "Baker",
    county_fips_all: 12003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32043,
    lat: 29.92991,
    lng: -81.74304,
    city: "Green Cove Springs",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28501,
    density: 48,
    county_fips: 12019,
    county_name: "Clay",
    county_weights: {
      12019: 93.13,
      12107: 6.87,
    },
    county_names_all: "Clay|Putnam",
    county_fips_all: "12019|12107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32044,
    lat: 29.85344,
    lng: -82.16425,
    city: "Hampton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2263,
    density: 50,
    county_fips: 12007,
    county_name: "Bradford",
    county_weights: {
      12001: 6.29,
      12007: 93.71,
    },
    county_names_all: "Bradford|Alachua",
    county_fips_all: "12007|12001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32046,
    lat: 30.70253,
    lng: -81.91718,
    city: "Hilliard",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10615,
    density: 20.9,
    county_fips: 12089,
    county_name: "Nassau",
    county_weights: {
      12089: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 12089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32052,
    lat: 30.48683,
    lng: -82.94499,
    city: "Jasper",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8727,
    density: 11.8,
    county_fips: 12047,
    county_name: "Hamilton",
    county_weights: {
      12047: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 12047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32053,
    lat: 30.56417,
    lng: -83.1519,
    city: "Jennings",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3990,
    density: 14.6,
    county_fips: 12047,
    county_name: "Hamilton",
    county_weights: {
      12047: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 12047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32054,
    lat: 30.0281,
    lng: -82.39143,
    city: "Lake Butler",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11802,
    density: 21.1,
    county_fips: 12125,
    county_name: "Union",
    county_weights: {
      12007: 8.69,
      12125: 91.31,
    },
    county_names_all: "Union|Bradford",
    county_fips_all: "12125|12007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32055,
    lat: 30.27031,
    lng: -82.62507,
    city: "Lake City",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16313,
    density: 34.1,
    county_fips: 12023,
    county_name: "Columbia",
    county_weights: {
      12023: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 12023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32058,
    lat: 30.07988,
    lng: -82.10743,
    city: "Lawtey",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4728,
    density: 25.5,
    county_fips: 12007,
    county_name: "Bradford",
    county_weights: {
      12007: 86.69,
      12019: 2.84,
      12125: 10.47,
    },
    county_names_all: "Bradford|Union|Clay",
    county_fips_all: "12007|12125|12019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32059,
    lat: 30.38672,
    lng: -83.27066,
    city: "Lee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2507,
    density: 8.1,
    county_fips: 12079,
    county_name: "Madison",
    county_weights: {
      12079: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 12079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32060,
    lat: 30.27554,
    lng: -83.04935,
    city: "Live Oak",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23437,
    density: 23,
    county_fips: 12121,
    county_name: "Suwannee",
    county_weights: {
      12121: 100,
    },
    county_names_all: "Suwannee",
    county_fips_all: 12121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32061,
    lat: 30.08311,
    lng: -82.51666,
    city: "Lulu",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 442,
    density: 10.7,
    county_fips: 12023,
    county_name: "Columbia",
    county_weights: {
      12023: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 12023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32062,
    lat: 30.13276,
    lng: -82.9754,
    city: "McAlpin",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1666,
    density: 9.7,
    county_fips: 12121,
    county_name: "Suwannee",
    county_weights: {
      12121: 100,
    },
    county_names_all: "Suwannee",
    county_fips_all: 12121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32063,
    lat: 30.27045,
    lng: -82.11974,
    city: "Macclenny",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13495,
    density: 71.1,
    county_fips: 12003,
    county_name: "Baker",
    county_weights: {
      12003: 100,
    },
    county_names_all: "Baker",
    county_fips_all: 12003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32064,
    lat: 30.28907,
    lng: -83.02375,
    city: "Live Oak",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6929,
    density: 287.9,
    county_fips: 12121,
    county_name: "Suwannee",
    county_weights: {
      12121: 100,
    },
    county_names_all: "Suwannee",
    county_fips_all: 12121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32065,
    lat: 30.15613,
    lng: -81.81762,
    city: "Orange Park",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37905,
    density: 738.8,
    county_fips: 12019,
    county_name: "Clay",
    county_weights: {
      12019: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 12019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32066,
    lat: 30.04423,
    lng: -83.22495,
    city: "Mayo",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7455,
    density: 10.3,
    county_fips: 12067,
    county_name: "Lafayette",
    county_weights: {
      12067: 100,
    },
    county_names_all: "Lafayette",
    county_fips_all: 12067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32068,
    lat: 30.08218,
    lng: -81.88245,
    city: "Middleburg",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56217,
    density: 187.9,
    county_fips: 12019,
    county_name: "Clay",
    county_weights: {
      12019: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 12019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32071,
    lat: 30.04097,
    lng: -82.945,
    city: "O'Brien",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3559,
    density: 13.3,
    county_fips: 12121,
    county_name: "Suwannee",
    county_weights: {
      12121: 100,
    },
    county_names_all: "Suwannee",
    county_fips_all: 12121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32073,
    lat: 30.16766,
    lng: -81.74069,
    city: "Orange Park",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42153,
    density: 966.6,
    county_fips: 12019,
    county_name: "Clay",
    county_weights: {
      12019: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 12019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32079,
    lat: 29.97814,
    lng: -81.80563,
    city: "Penney Farms",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 426,
    density: 363.6,
    county_fips: 12019,
    county_name: "Clay",
    county_weights: {
      12019: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 12019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32080,
    lat: 29.82453,
    lng: -81.27412,
    city: "Saint Augustine",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22237,
    density: 545.9,
    county_fips: 12109,
    county_name: "St. Johns",
    county_weights: {
      12035: 0.94,
      12109: 99.06,
    },
    county_names_all: "St. Johns|Flagler",
    county_fips_all: "12109|12035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32081,
    lat: 30.12143,
    lng: -81.42089,
    city: "Ponte Vedra",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16914,
    density: 185.2,
    county_fips: 12109,
    county_name: "St. Johns",
    county_weights: {
      12031: 9.59,
      12109: 90.41,
    },
    county_names_all: "St. Johns|Duval",
    county_fips_all: "12109|12031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32082,
    lat: 30.12488,
    lng: -81.36577,
    city: "Ponte Vedra Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28503,
    density: 329.9,
    county_fips: 12109,
    county_name: "St. Johns",
    county_weights: {
      12109: 100,
    },
    county_names_all: "St. Johns",
    county_fips_all: 12109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32083,
    lat: 30.09074,
    lng: -82.23222,
    city: "Raiford",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4188,
    density: 41,
    county_fips: 12125,
    county_name: "Union",
    county_weights: {
      12007: 1.95,
      12125: 98.05,
    },
    county_names_all: "Union|Bradford",
    county_fips_all: "12125|12007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32084,
    lat: 29.91412,
    lng: -81.36417,
    city: "Saint Augustine",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36415,
    density: 311.6,
    county_fips: 12109,
    county_name: "St. Johns",
    county_weights: {
      12109: 100,
    },
    county_names_all: "St. Johns",
    county_fips_all: 12109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32086,
    lat: 29.75656,
    lng: -81.30282,
    city: "Saint Augustine",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30392,
    density: 178.5,
    county_fips: 12109,
    county_name: "St. Johns",
    county_weights: {
      12109: 100,
    },
    county_names_all: "St. Johns",
    county_fips_all: 12109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32087,
    lat: 30.36999,
    lng: -82.29741,
    city: "Sanderson",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6541,
    density: 15.8,
    county_fips: 12003,
    county_name: "Baker",
    county_weights: {
      12003: 100,
    },
    county_names_all: "Baker",
    county_fips_all: 12003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32091,
    lat: 29.93205,
    lng: -82.11324,
    city: "Starke",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15026,
    density: 38.2,
    county_fips: 12007,
    county_name: "Bradford",
    county_weights: {
      12007: 83.22,
      12019: 16.78,
    },
    county_names_all: "Bradford|Clay",
    county_fips_all: "12007|12019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32092,
    lat: 29.92849,
    lng: -81.52209,
    city: "Saint Augustine",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39858,
    density: 124.1,
    county_fips: 12109,
    county_name: "St. Johns",
    county_weights: {
      12109: 100,
    },
    county_names_all: "St. Johns",
    county_fips_all: 12109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32094,
    lat: 30.19797,
    lng: -82.82767,
    city: "Wellborn",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3909,
    density: 26.8,
    county_fips: 12121,
    county_name: "Suwannee",
    county_weights: {
      12023: 11.52,
      12121: 88.48,
    },
    county_names_all: "Suwannee|Columbia",
    county_fips_all: "12121|12023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32095,
    lat: 30.01693,
    lng: -81.40927,
    city: "Saint Augustine",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13155,
    density: 88.5,
    county_fips: 12109,
    county_name: "St. Johns",
    county_weights: {
      12109: 100,
    },
    county_names_all: "St. Johns",
    county_fips_all: 12109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32096,
    lat: 30.43678,
    lng: -82.7011,
    city: "White Springs",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2870,
    density: 6.5,
    county_fips: 12023,
    county_name: "Columbia",
    county_weights: {
      12023: 55.39,
      12047: 42.96,
      12121: 1.65,
    },
    county_names_all: "Columbia|Hamilton|Suwannee",
    county_fips_all: "12023|12047|12121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32097,
    lat: 30.65851,
    lng: -81.64478,
    city: "Yulee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19139,
    density: 59.3,
    county_fips: 12089,
    county_name: "Nassau",
    county_weights: {
      12089: 100,
    },
    county_names_all: "Nassau",
    county_fips_all: 12089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32102,
    lat: 29.1359,
    lng: -81.52544,
    city: "Astor",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2081,
    density: 12.9,
    county_fips: 12069,
    county_name: "Lake",
    county_weights: {
      12069: 61.11,
      12127: 38.89,
    },
    county_names_all: "Lake|Volusia",
    county_fips_all: "12069|12127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32110,
    lat: 29.44456,
    lng: -81.36131,
    city: "Bunnell",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8537,
    density: 11.1,
    county_fips: 12035,
    county_name: "Flagler",
    county_weights: {
      12035: 100,
    },
    county_names_all: "Flagler",
    county_fips_all: 12035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32112,
    lat: 29.42664,
    lng: -81.55649,
    city: "Crescent City",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7342,
    density: 55.1,
    county_fips: 12107,
    county_name: "Putnam",
    county_weights: {
      12107: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 12107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32113,
    lat: 29.39836,
    lng: -82.08127,
    city: "Citra",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5341,
    density: 24.1,
    county_fips: 12083,
    county_name: "Marion",
    county_weights: {
      12083: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 12083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32114,
    lat: 29.19312,
    lng: -81.04915,
    city: "Daytona Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33731,
    density: 814.1,
    county_fips: 12127,
    county_name: "Volusia",
    county_weights: {
      12127: 100,
    },
    county_names_all: "Volusia",
    county_fips_all: 12127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32117,
    lat: 29.23351,
    lng: -81.06727,
    city: "Daytona Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28266,
    density: 909.8,
    county_fips: 12127,
    county_name: "Volusia",
    county_weights: {
      12127: 100,
    },
    county_names_all: "Volusia",
    county_fips_all: 12127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32118,
    lat: 29.21035,
    lng: -81.00425,
    city: "Daytona Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17492,
    density: 1592.7,
    county_fips: 12127,
    county_name: "Volusia",
    county_weights: {
      12127: 100,
    },
    county_names_all: "Volusia",
    county_fips_all: 12127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32119,
    lat: 29.16001,
    lng: -81.02707,
    city: "Daytona Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22431,
    density: 1107,
    county_fips: 12127,
    county_name: "Volusia",
    county_weights: {
      12127: 100,
    },
    county_names_all: "Volusia",
    county_fips_all: 12127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32124,
    lat: 29.15802,
    lng: -81.15732,
    city: "Daytona Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6589,
    density: 41.4,
    county_fips: 12127,
    county_name: "Volusia",
    county_weights: {
      12127: 100,
    },
    county_names_all: "Volusia",
    county_fips_all: 12127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32127,
    lat: 29.10866,
    lng: -80.97907,
    city: "Port Orange",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29082,
    density: 754.9,
    county_fips: 12127,
    county_name: "Volusia",
    county_weights: {
      12127: 100,
    },
    county_names_all: "Volusia",
    county_fips_all: 12127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32128,
    lat: 29.09773,
    lng: -81.07467,
    city: "Port Orange",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22046,
    density: 254.8,
    county_fips: 12127,
    county_name: "Volusia",
    county_weights: {
      12127: 100,
    },
    county_names_all: "Volusia",
    county_fips_all: 12127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32129,
    lat: 29.13721,
    lng: -81.02381,
    city: "Port Orange",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23383,
    density: 1200.6,
    county_fips: 12127,
    county_name: "Volusia",
    county_weights: {
      12127: 100,
    },
    county_names_all: "Volusia",
    county_fips_all: 12127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32130,
    lat: 29.15704,
    lng: -81.34501,
    city: "De Leon Springs",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5393,
    density: 22,
    county_fips: 12127,
    county_name: "Volusia",
    county_weights: {
      12127: 100,
    },
    county_names_all: "Volusia",
    county_fips_all: 12127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32131,
    lat: 29.67803,
    lng: -81.56785,
    city: "East Palatka",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4558,
    density: 49.2,
    county_fips: 12107,
    county_name: "Putnam",
    county_weights: {
      12107: 93.98,
      12109: 6.02,
    },
    county_names_all: "Putnam|St. Johns",
    county_fips_all: "12107|12109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32132,
    lat: 28.97731,
    lng: -80.92345,
    city: "Edgewater",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7954,
    density: 437.1,
    county_fips: 12127,
    county_name: "Volusia",
    county_weights: {
      12127: 100,
    },
    county_names_all: "Volusia",
    county_fips_all: 12127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32133,
    lat: 29.01061,
    lng: -81.92036,
    city: "Eastlake Weir",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 12083,
    county_name: "Marion",
    county_weights: {
      12083: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 12083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32134,
    lat: 29.37177,
    lng: -81.82562,
    city: "Fort McCoy",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7712,
    density: 11.1,
    county_fips: 12083,
    county_name: "Marion",
    county_weights: {
      12069: 1.42,
      12083: 79.1,
      12107: 19.48,
    },
    county_names_all: "Marion|Putnam|Lake",
    county_fips_all: "12083|12107|12069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32136,
    lat: 29.45252,
    lng: -81.14025,
    city: "Flagler Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8372,
    density: 182.3,
    county_fips: 12035,
    county_name: "Flagler",
    county_weights: {
      12035: 90.25,
      12127: 9.75,
    },
    county_names_all: "Flagler|Volusia",
    county_fips_all: "12035|12127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32137,
    lat: 29.58057,
    lng: -81.22455,
    city: "Palm Coast",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44396,
    density: 274.7,
    county_fips: 12035,
    county_name: "Flagler",
    county_weights: {
      12035: 100,
    },
    county_names_all: "Flagler",
    county_fips_all: 12035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32139,
    lat: 29.37693,
    lng: -81.61431,
    city: "Georgetown",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1028,
    density: 31.5,
    county_fips: 12107,
    county_name: "Putnam",
    county_weights: {
      12107: 99.79,
      12127: 0.21,
    },
    county_names_all: "Putnam|Volusia",
    county_fips_all: "12107|12127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32140,
    lat: 29.76274,
    lng: -81.86306,
    city: "Florahome",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1575,
    density: 18.2,
    county_fips: 12107,
    county_name: "Putnam",
    county_weights: {
      12019: 9.83,
      12107: 90.17,
    },
    county_names_all: "Putnam|Clay",
    county_fips_all: "12107|12019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32141,
    lat: 28.92322,
    lng: -80.90196,
    city: "Edgewater",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19414,
    density: 318,
    county_fips: 12127,
    county_name: "Volusia",
    county_weights: {
      12127: 100,
    },
    county_names_all: "Volusia",
    county_fips_all: 12127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32145,
    lat: 29.67899,
    lng: -81.41973,
    city: "Hastings",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5788,
    density: 25,
    county_fips: 12109,
    county_name: "St. Johns",
    county_weights: {
      12107: 0.65,
      12109: 99.35,
    },
    county_names_all: "St. Johns|Putnam",
    county_fips_all: "12109|12107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32147,
    lat: 29.63157,
    lng: -81.79577,
    city: "Hollister",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 597,
    density: 7.7,
    county_fips: 12107,
    county_name: "Putnam",
    county_weights: {
      12107: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 12107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32148,
    lat: 29.60088,
    lng: -81.88191,
    city: "Interlachen",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10766,
    density: 53.2,
    county_fips: 12107,
    county_name: "Putnam",
    county_weights: {
      12107: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 12107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32157,
    lat: 29.46296,
    lng: -81.58165,
    city: "Lake Como",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 340,
    density: 52.3,
    county_fips: 12107,
    county_name: "Putnam",
    county_weights: {
      12107: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 12107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32159,
    lat: 28.92456,
    lng: -81.90528,
    city: "Lady Lake",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30459,
    density: 389.9,
    county_fips: 12069,
    county_name: "Lake",
    county_weights: {
      12069: 85.93,
      12119: 14.07,
    },
    county_names_all: "Lake|Sumter",
    county_fips_all: "12069|12119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32162,
    lat: 28.91629,
    lng: -81.99374,
    city: "The Villages",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55828,
    density: 946.6,
    county_fips: 12119,
    county_name: "Sumter",
    county_weights: {
      12083: 15.05,
      12119: 84.95,
    },
    county_names_all: "Sumter|Marion",
    county_fips_all: "12119|12083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32163,
    lat: 28.81878,
    lng: -81.98663,
    city: "The Villages",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12119,
    county_name: "Sumter",
    county_weights: {
      12069: 9.44,
      12119: 90.56,
    },
    county_names_all: "Sumter|Lake",
    county_fips_all: "12119|12069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32164,
    lat: 29.48316,
    lng: -81.2174,
    city: "Palm Coast",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49642,
    density: 589.5,
    county_fips: 12035,
    county_name: "Flagler",
    county_weights: {
      12035: 100,
    },
    county_names_all: "Flagler",
    county_fips_all: 12035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32168,
    lat: 28.98214,
    lng: -81.03721,
    city: "New Smyrna Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28284,
    density: 70.9,
    county_fips: 12127,
    county_name: "Volusia",
    county_weights: {
      12127: 100,
    },
    county_names_all: "Volusia",
    county_fips_all: 12127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32169,
    lat: 28.97934,
    lng: -80.87386,
    city: "New Smyrna Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10732,
    density: 255.8,
    county_fips: 12127,
    county_name: "Volusia",
    county_weights: {
      12127: 100,
    },
    county_names_all: "Volusia",
    county_fips_all: 12127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32174,
    lat: 29.28928,
    lng: -81.16446,
    city: "Ormond Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52115,
    density: 160.5,
    county_fips: 12127,
    county_name: "Volusia",
    county_weights: {
      12035: 28.18,
      12127: 71.82,
    },
    county_names_all: "Volusia|Flagler",
    county_fips_all: "12127|12035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32176,
    lat: 29.33216,
    lng: -81.06327,
    city: "Ormond Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14821,
    density: 1005.4,
    county_fips: 12127,
    county_name: "Volusia",
    county_weights: {
      12127: 100,
    },
    county_names_all: "Volusia",
    county_fips_all: 12127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32177,
    lat: 29.69011,
    lng: -81.70565,
    city: "Palatka",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28343,
    density: 48.2,
    county_fips: 12107,
    county_name: "Putnam",
    county_weights: {
      12107: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 12107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32179,
    lat: 29.09631,
    lng: -81.89686,
    city: "Ocklawaha",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7843,
    density: 40.3,
    county_fips: 12083,
    county_name: "Marion",
    county_weights: {
      12083: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 12083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32180,
    lat: 29.23437,
    lng: -81.44521,
    city: "Pierson",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5184,
    density: 22.2,
    county_fips: 12127,
    county_name: "Volusia",
    county_weights: {
      12035: 11.91,
      12127: 88.09,
    },
    county_names_all: "Volusia|Flagler",
    county_fips_all: "12127|12035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32181,
    lat: 29.50658,
    lng: -81.60126,
    city: "Pomona Park",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2696,
    density: 40.8,
    county_fips: 12107,
    county_name: "Putnam",
    county_weights: {
      12107: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 12107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32182,
    lat: 29.50926,
    lng: -81.94113,
    city: "Orange Springs",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12083,
    county_name: "Marion",
    county_weights: {
      12083: 98.56,
      12107: 1.44,
    },
    county_names_all: "Marion|Putnam",
    county_fips_all: "12083|12107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32187,
    lat: 29.57827,
    lng: -81.55392,
    city: "San Mateo",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1454,
    density: 24.3,
    county_fips: 12107,
    county_name: "Putnam",
    county_weights: {
      12107: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 12107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32189,
    lat: 29.54991,
    lng: -81.64819,
    city: "Satsuma",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5541,
    density: 73.1,
    county_fips: 12107,
    county_name: "Putnam",
    county_weights: {
      12107: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 12107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32190,
    lat: 29.33289,
    lng: -81.49056,
    city: "Seville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1310,
    density: 13.6,
    county_fips: 12127,
    county_name: "Volusia",
    county_weights: {
      12127: 100,
    },
    county_names_all: "Volusia",
    county_fips_all: 12127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32192,
    lat: 29.35005,
    lng: -82.11109,
    city: "Sparr",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12083,
    county_name: "Marion",
    county_weights: {
      12083: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 12083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32193,
    lat: 29.47605,
    lng: -81.6647,
    city: "Welaka",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 969,
    density: 104.9,
    county_fips: 12107,
    county_name: "Putnam",
    county_weights: {
      12107: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 12107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32195,
    lat: 28.9854,
    lng: -81.89814,
    city: "Weirsdale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3291,
    density: 52.1,
    county_fips: 12083,
    county_name: "Marion",
    county_weights: {
      12069: 12.71,
      12083: 87.29,
    },
    county_names_all: "Marion|Lake",
    county_fips_all: "12083|12069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32202,
    lat: 30.32505,
    lng: -81.64786,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6965,
    density: 1356.8,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32203,
    lat: 30.33702,
    lng: -81.67129,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32204,
    lat: 30.31636,
    lng: -81.68095,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7507,
    density: 1079.1,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32205,
    lat: 30.30275,
    lng: -81.72257,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30349,
    density: 1514.4,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32206,
    lat: 30.35069,
    lng: -81.63865,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16118,
    density: 998.4,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32207,
    lat: 30.29,
    lng: -81.64018,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35659,
    density: 1203.4,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32208,
    lat: 30.39351,
    lng: -81.68245,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30648,
    density: 1026.5,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32209,
    lat: 30.36141,
    lng: -81.69573,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35919,
    density: 1490,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32210,
    lat: 30.26491,
    lng: -81.74746,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62457,
    density: 1101.7,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32211,
    lat: 30.33276,
    lng: -81.58428,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35160,
    density: 1656.9,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32212,
    lat: 30.21916,
    lng: -81.67869,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2327,
    density: 175.7,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32214,
    lat: 30.20749,
    lng: -81.68334,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32216,
    lat: 30.27891,
    lng: -81.58305,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37867,
    density: 1153.5,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32217,
    lat: 30.2394,
    lng: -81.62722,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19785,
    density: 1421.1,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32218,
    lat: 30.48673,
    lng: -81.66959,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65878,
    density: 263.2,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32219,
    lat: 30.41815,
    lng: -81.81367,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12760,
    density: 68.9,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32220,
    lat: 30.33693,
    lng: -81.85335,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12703,
    density: 127.1,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32221,
    lat: 30.26043,
    lng: -81.86764,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28809,
    density: 234.3,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32222,
    lat: 30.21651,
    lng: -81.8293,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13933,
    density: 472.1,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32223,
    lat: 30.1549,
    lng: -81.64821,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24615,
    density: 826.2,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32224,
    lat: 30.26815,
    lng: -81.4642,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41017,
    density: 759.2,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 91.7,
      12109: 8.3,
    },
    county_names_all: "Duval|St. Johns",
    county_fips_all: "12031|12109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32225,
    lat: 30.35768,
    lng: -81.50592,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53414,
    density: 784,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32226,
    lat: 30.46444,
    lng: -81.50999,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16407,
    density: 73.9,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32227,
    lat: 30.38792,
    lng: -81.40571,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3599,
    density: 1257,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32228,
    lat: 30.39158,
    lng: -81.40022,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 509,
    density: 1518.5,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32233,
    lat: 30.35943,
    lng: -81.42098,
    city: "Atlantic Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25318,
    density: 958,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32234,
    lat: 30.20784,
    lng: -82.01096,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6475,
    density: 16.4,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12003: 20.97,
      12019: 28.87,
      12031: 45.8,
      12089: 4.36,
    },
    county_names_all: "Duval|Clay|Baker|Nassau",
    county_fips_all: "12031|12019|12003|12089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32244,
    lat: 30.2171,
    lng: -81.75384,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61190,
    density: 1002.2,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32246,
    lat: 30.29422,
    lng: -81.51782,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55325,
    density: 1118.4,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32250,
    lat: 30.27846,
    lng: -81.41035,
    city: "Jacksonville Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27612,
    density: 1190.5,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32254,
    lat: 30.34164,
    lng: -81.73549,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13572,
    density: 422.5,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32256,
    lat: 30.1929,
    lng: -81.50309,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47883,
    density: 301.3,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32257,
    lat: 30.19515,
    lng: -81.6123,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39154,
    density: 1233.9,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32258,
    lat: 30.13874,
    lng: -81.54941,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39963,
    density: 866,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32259,
    lat: 30.07109,
    lng: -81.6029,
    city: "Saint Johns",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57223,
    density: 390.7,
    county_fips: 12109,
    county_name: "St. Johns",
    county_weights: {
      12031: 1.14,
      12109: 98.86,
    },
    county_names_all: "St. Johns|Duval",
    county_fips_all: "12109|12031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32266,
    lat: 30.31648,
    lng: -81.41177,
    city: "Neptune Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7214,
    density: 1191.8,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32277,
    lat: 30.3728,
    lng: -81.59465,
    city: "Jacksonville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32446,
    density: 1750,
    county_fips: 12031,
    county_name: "Duval",
    county_weights: {
      12031: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 12031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32301,
    lat: 30.42701,
    lng: -84.25799,
    city: "Tallahassee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32552,
    density: 1231.8,
    county_fips: 12073,
    county_name: "Leon",
    county_weights: {
      12073: 100,
    },
    county_names_all: "Leon",
    county_fips_all: 12073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32303,
    lat: 30.51237,
    lng: -84.34386,
    city: "Tallahassee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49073,
    density: 544.1,
    county_fips: 12073,
    county_name: "Leon",
    county_weights: {
      12073: 100,
    },
    county_names_all: "Leon",
    county_fips_all: 12073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32304,
    lat: 30.45346,
    lng: -84.35314,
    city: "Tallahassee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50298,
    density: 1279.7,
    county_fips: 12073,
    county_name: "Leon",
    county_weights: {
      12073: 100,
    },
    county_names_all: "Leon",
    county_fips_all: 12073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32305,
    lat: 30.3337,
    lng: -84.26977,
    city: "Tallahassee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21533,
    density: 86.6,
    county_fips: 12073,
    county_name: "Leon",
    county_weights: {
      12073: 100,
    },
    county_names_all: "Leon",
    county_fips_all: 12073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32306,
    lat: 30.44227,
    lng: -84.29455,
    city: "Tallahassee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12073,
    county_name: "Leon",
    county_weights: {
      12073: 100,
    },
    county_names_all: "Leon",
    county_fips_all: 12073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32307,
    lat: 30.42173,
    lng: -84.28686,
    city: "Tallahassee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12073,
    county_name: "Leon",
    county_weights: {
      12073: 100,
    },
    county_names_all: "Leon",
    county_fips_all: 12073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32308,
    lat: 30.4781,
    lng: -84.21968,
    city: "Tallahassee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21870,
    density: 534.2,
    county_fips: 12073,
    county_name: "Leon",
    county_weights: {
      12073: 100,
    },
    county_names_all: "Leon",
    county_fips_all: 12073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32309,
    lat: 30.57174,
    lng: -84.10128,
    city: "Tallahassee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33359,
    density: 105.6,
    county_fips: 12073,
    county_name: "Leon",
    county_weights: {
      12073: 100,
    },
    county_names_all: "Leon",
    county_fips_all: 12073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32310,
    lat: 30.39924,
    lng: -84.50694,
    city: "Tallahassee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15265,
    density: 64.1,
    county_fips: 12073,
    county_name: "Leon",
    county_weights: {
      12073: 100,
    },
    county_names_all: "Leon",
    county_fips_all: 12073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32311,
    lat: 30.39647,
    lng: -84.16843,
    city: "Tallahassee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20897,
    density: 142.8,
    county_fips: 12073,
    county_name: "Leon",
    county_weights: {
      12073: 100,
    },
    county_names_all: "Leon",
    county_fips_all: 12073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32312,
    lat: 30.60421,
    lng: -84.23996,
    city: "Tallahassee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32380,
    density: 133.9,
    county_fips: 12073,
    county_name: "Leon",
    county_weights: {
      12073: 100,
    },
    county_names_all: "Leon",
    county_fips_all: 12073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32313,
    lat: 30.44168,
    lng: -84.30287,
    city: "Tallahassee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12073,
    county_name: "Leon",
    county_weights: {
      12073: 100,
    },
    county_names_all: "Leon",
    county_fips_all: 12073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32317,
    lat: 30.46746,
    lng: -84.11442,
    city: "Tallahassee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14636,
    density: 159,
    county_fips: 12073,
    county_name: "Leon",
    county_weights: {
      12073: 100,
    },
    county_names_all: "Leon",
    county_fips_all: 12073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32320,
    lat: 29.74232,
    lng: -85.06938,
    city: "Apalachicola",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4035,
    density: 48.7,
    county_fips: 12037,
    county_name: "Franklin",
    county_weights: {
      12037: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 12037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32321,
    lat: 30.26196,
    lng: -84.9891,
    city: "Bristol",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6534,
    density: 6.7,
    county_fips: 12077,
    county_name: "Liberty",
    county_weights: {
      12037: 2.28,
      12077: 97.72,
    },
    county_names_all: "Liberty|Franklin",
    county_fips_all: "12077|12037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32322,
    lat: 29.89948,
    lng: -84.62327,
    city: "Carrabelle",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3721,
    density: 19.1,
    county_fips: 12037,
    county_name: "Franklin",
    county_weights: {
      12037: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 12037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32323,
    lat: 29.89185,
    lng: -84.6122,
    city: "Lanark Village",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 113,
    density: 5.9,
    county_fips: 12037,
    county_name: "Franklin",
    county_weights: {
      12037: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 12037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32324,
    lat: 30.65635,
    lng: -84.79126,
    city: "Chattahoochee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4858,
    density: 27.8,
    county_fips: 12039,
    county_name: "Gadsden",
    county_weights: {
      12039: 100,
    },
    county_names_all: "Gadsden",
    county_fips_all: 12039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32327,
    lat: 30.18705,
    lng: -84.30472,
    city: "Crawfordville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29688,
    density: 48.7,
    county_fips: 12129,
    county_name: "Wakulla",
    county_weights: {
      12129: 100,
    },
    county_names_all: "Wakulla",
    county_fips_all: 12129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32328,
    lat: 29.8463,
    lng: -84.90991,
    city: "Eastpoint",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3682,
    density: 16.6,
    county_fips: 12037,
    county_name: "Franklin",
    county_weights: {
      12037: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 12037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32330,
    lat: 30.57859,
    lng: -84.74799,
    city: "Greensboro",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 743,
    density: 79.7,
    county_fips: 12039,
    county_name: "Gadsden",
    county_weights: {
      12039: 100,
    },
    county_names_all: "Gadsden",
    county_fips_all: 12039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32331,
    lat: 30.45851,
    lng: -83.6294,
    city: "Greenville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4687,
    density: 5.4,
    county_fips: 12079,
    county_name: "Madison",
    county_weights: {
      12065: 12.8,
      12079: 73.43,
      12123: 13.77,
    },
    county_names_all: "Madison|Taylor|Jefferson",
    county_fips_all: "12079|12123|12065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32332,
    lat: 30.61168,
    lng: -84.6657,
    city: "Gretna",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1103,
    density: 121.8,
    county_fips: 12039,
    county_name: "Gadsden",
    county_weights: {
      12039: 100,
    },
    county_names_all: "Gadsden",
    county_fips_all: 12039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32333,
    lat: 30.60677,
    lng: -84.41249,
    city: "Havana",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11805,
    density: 43.2,
    county_fips: 12039,
    county_name: "Gadsden",
    county_weights: {
      12039: 100,
    },
    county_names_all: "Gadsden",
    county_fips_all: 12039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32334,
    lat: 30.2612,
    lng: -84.75835,
    city: "Hosford",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1799,
    density: 3.1,
    county_fips: 12077,
    county_name: "Liberty",
    county_weights: {
      12077: 100,
    },
    county_names_all: "Liberty",
    county_fips_all: 12077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32336,
    lat: 30.26371,
    lng: -83.86319,
    city: "Lamont",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1144,
    density: 2,
    county_fips: 12123,
    county_name: "Taylor",
    county_weights: {
      12065: 40.28,
      12079: 12.27,
      12123: 47.44,
    },
    county_names_all: "Taylor|Jefferson|Madison",
    county_fips_all: "12123|12065|12079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32337,
    lat: 30.48307,
    lng: -84.02104,
    city: "Lloyd",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12065,
    county_name: "Jefferson",
    county_weights: {
      12065: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 12065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32340,
    lat: 30.45651,
    lng: -83.42667,
    city: "Madison",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11058,
    density: 20.5,
    county_fips: 12079,
    county_name: "Madison",
    county_weights: {
      12079: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 12079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32343,
    lat: 30.48515,
    lng: -84.47652,
    city: "Midway",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3153,
    density: 45.4,
    county_fips: 12039,
    county_name: "Gadsden",
    county_weights: {
      12039: 100,
    },
    county_names_all: "Gadsden",
    county_fips_all: 12039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32344,
    lat: 30.44645,
    lng: -83.91902,
    city: "Monticello",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12580,
    density: 10.9,
    county_fips: 12065,
    county_name: "Jefferson",
    county_weights: {
      12065: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 12065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32346,
    lat: 29.97919,
    lng: -84.38387,
    city: "Panacea",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1709,
    density: 23.2,
    county_fips: 12129,
    county_name: "Wakulla",
    county_weights: {
      12037: 39.46,
      12129: 60.54,
    },
    county_names_all: "Wakulla|Franklin",
    county_fips_all: "12129|12037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32347,
    lat: 30.14416,
    lng: -83.64268,
    city: "Perry",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7240,
    density: 20.3,
    county_fips: 12123,
    county_name: "Taylor",
    county_weights: {
      12123: 100,
    },
    county_names_all: "Taylor",
    county_fips_all: 12123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32348,
    lat: 29.94808,
    lng: -83.56762,
    city: "Perry",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12980,
    density: 15.5,
    county_fips: 12123,
    county_name: "Taylor",
    county_weights: {
      12123: 100,
    },
    county_names_all: "Taylor",
    county_fips_all: 12123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32350,
    lat: 30.58662,
    lng: -83.32242,
    city: "Pinetta",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1414,
    density: 10.7,
    county_fips: 12079,
    county_name: "Madison",
    county_weights: {
      12079: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 12079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32351,
    lat: 30.52358,
    lng: -84.68362,
    city: "Quincy",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18095,
    density: 32.8,
    county_fips: 12039,
    county_name: "Gadsden",
    county_weights: {
      12039: 100,
    },
    county_names_all: "Gadsden",
    county_fips_all: 12039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32352,
    lat: 30.6499,
    lng: -84.58535,
    city: "Quincy",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6030,
    density: 24.1,
    county_fips: 12039,
    county_name: "Gadsden",
    county_weights: {
      12039: 100,
    },
    county_names_all: "Gadsden",
    county_fips_all: 12039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32355,
    lat: 30.1695,
    lng: -84.21002,
    city: "Saint Marks",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 340,
    density: 47.3,
    county_fips: 12129,
    county_name: "Wakulla",
    county_weights: {
      12129: 100,
    },
    county_names_all: "Wakulla",
    county_fips_all: 12129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32356,
    lat: 29.85387,
    lng: -83.40018,
    city: "Salem",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 12123,
    county_name: "Taylor",
    county_weights: {
      12123: 100,
    },
    county_names_all: "Taylor",
    county_fips_all: 12123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32358,
    lat: 30.09535,
    lng: -84.54468,
    city: "Sopchoppy",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1481,
    density: 3.2,
    county_fips: 12129,
    county_name: "Wakulla",
    county_weights: {
      12037: 15.22,
      12129: 84.78,
    },
    county_names_all: "Wakulla|Franklin",
    county_fips_all: "12129|12037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32359,
    lat: 29.66181,
    lng: -83.37047,
    city: "Steinhatchee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 986,
    density: 2.1,
    county_fips: 12029,
    county_name: "Dixie",
    county_weights: {
      12029: 61.1,
      12123: 38.9,
    },
    county_names_all: "Dixie|Taylor",
    county_fips_all: "12029|12123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32360,
    lat: 30.36506,
    lng: -84.81238,
    city: "Telogia",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12077,
    county_name: "Liberty",
    county_weights: {
      12077: 100,
    },
    county_names_all: "Liberty",
    county_fips_all: 12077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32361,
    lat: 30.35765,
    lng: -83.98865,
    city: "Wacissa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 358,
    density: 59.9,
    county_fips: 12065,
    county_name: "Jefferson",
    county_weights: {
      12065: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 12065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32399,
    lat: 30.40162,
    lng: -84.24426,
    city: "Tallahassee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 12073,
    county_name: "Leon",
    county_weights: {
      12073: 100,
    },
    county_names_all: "Leon",
    county_fips_all: 12073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32401,
    lat: 30.14477,
    lng: -85.67448,
    city: "Panama City",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21045,
    density: 650.3,
    county_fips: 12005,
    county_name: "Bay",
    county_weights: {
      12005: 100,
    },
    county_names_all: "Bay",
    county_fips_all: 12005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32403,
    lat: 30.05337,
    lng: -85.55679,
    city: "Panama City",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2072,
    density: 18.1,
    county_fips: 12005,
    county_name: "Bay",
    county_weights: {
      12005: 100,
    },
    county_names_all: "Bay",
    county_fips_all: 12005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32404,
    lat: 30.19075,
    lng: -85.51122,
    city: "Panama City",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40300,
    density: 115.2,
    county_fips: 12005,
    county_name: "Bay",
    county_weights: {
      12005: 100,
    },
    county_names_all: "Bay",
    county_fips_all: 12005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32405,
    lat: 30.20002,
    lng: -85.66869,
    city: "Panama City",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31875,
    density: 655.4,
    county_fips: 12005,
    county_name: "Bay",
    county_weights: {
      12005: 100,
    },
    county_names_all: "Bay",
    county_fips_all: 12005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32407,
    lat: 30.20276,
    lng: -85.7912,
    city: "Panama City Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11277,
    density: 291.9,
    county_fips: 12005,
    county_name: "Bay",
    county_weights: {
      12005: 100,
    },
    county_names_all: "Bay",
    county_fips_all: 12005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32408,
    lat: 30.1593,
    lng: -85.75324,
    city: "Panama City",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19463,
    density: 876.6,
    county_fips: 12005,
    county_name: "Bay",
    county_weights: {
      12005: 100,
    },
    county_names_all: "Bay",
    county_fips_all: 12005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32409,
    lat: 30.33447,
    lng: -85.70516,
    city: "Panama City",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9913,
    density: 30.2,
    county_fips: 12005,
    county_name: "Bay",
    county_weights: {
      12005: 100,
    },
    county_names_all: "Bay",
    county_fips_all: 12005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32410,
    lat: 29.94805,
    lng: -85.41812,
    city: "Mexico Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 901,
    density: 222.9,
    county_fips: 12005,
    county_name: "Bay",
    county_weights: {
      12005: 100,
    },
    county_names_all: "Bay",
    county_fips_all: 12005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32413,
    lat: 30.30975,
    lng: -85.88745,
    city: "Panama City Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14551,
    density: 51.9,
    county_fips: 12005,
    county_name: "Bay",
    county_weights: {
      12005: 99.58,
      12131: 0.42,
    },
    county_names_all: "Bay|Walton",
    county_fips_all: "12005|12131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32420,
    lat: 30.63637,
    lng: -85.38123,
    city: "Alford",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2263,
    density: 16.5,
    county_fips: 12063,
    county_name: "Jackson",
    county_weights: {
      12063: 97.61,
      12133: 2.39,
    },
    county_names_all: "Jackson|Washington",
    county_fips_all: "12063|12133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32421,
    lat: 30.52973,
    lng: -85.19308,
    city: "Altha",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4793,
    density: 14.7,
    county_fips: 12013,
    county_name: "Calhoun",
    county_weights: {
      12013: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 12013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32423,
    lat: 30.94496,
    lng: -85.06073,
    city: "Bascom",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 955,
    density: 5.5,
    county_fips: 12063,
    county_name: "Jackson",
    county_weights: {
      12063: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 12063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32424,
    lat: 30.38901,
    lng: -85.08232,
    city: "Blountstown",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7643,
    density: 18.6,
    county_fips: 12013,
    county_name: "Calhoun",
    county_weights: {
      12013: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 12013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32425,
    lat: 30.85538,
    lng: -85.72225,
    city: "Bonifay",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14330,
    density: 20.9,
    county_fips: 12059,
    county_name: "Holmes",
    county_weights: {
      12059: 85.81,
      12133: 14.19,
    },
    county_names_all: "Holmes|Washington",
    county_fips_all: "12059|12133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32426,
    lat: 30.94861,
    lng: -85.36714,
    city: "Campbellton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 798,
    density: 6.6,
    county_fips: 12063,
    county_name: "Jackson",
    county_weights: {
      12063: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 12063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32427,
    lat: 30.71587,
    lng: -85.79311,
    city: "Caryville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 888,
    density: 7.6,
    county_fips: 12133,
    county_name: "Washington",
    county_weights: {
      12133: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 12133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32428,
    lat: 30.61797,
    lng: -85.57154,
    city: "Chipley",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17807,
    density: 24,
    county_fips: 12133,
    county_name: "Washington",
    county_weights: {
      12005: 1.67,
      12063: 0.85,
      12133: 97.48,
    },
    county_names_all: "Washington|Bay|Jackson",
    county_fips_all: "12133|12005|12063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32430,
    lat: 30.41872,
    lng: -85.22562,
    city: "Clarksville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 935,
    density: 4.4,
    county_fips: 12013,
    county_name: "Calhoun",
    county_weights: {
      12013: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 12013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32431,
    lat: 30.78609,
    lng: -85.40982,
    city: "Cottondale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4154,
    density: 15.2,
    county_fips: 12063,
    county_name: "Jackson",
    county_weights: {
      12063: 82.98,
      12133: 17.02,
    },
    county_names_all: "Jackson|Washington",
    county_fips_all: "12063|12133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32432,
    lat: 30.71415,
    lng: -85.07727,
    city: "Cypress",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 12063,
    county_name: "Jackson",
    county_weights: {
      12063: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 12063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32433,
    lat: 30.84848,
    lng: -86.19822,
    city: "Defuniak Springs",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19459,
    density: 29.9,
    county_fips: 12131,
    county_name: "Walton",
    county_weights: {
      12131: 100,
    },
    county_names_all: "Walton",
    county_fips_all: 12131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32435,
    lat: 30.65367,
    lng: -86.11597,
    city: "Defuniak Springs",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7039,
    density: 19.9,
    county_fips: 12131,
    county_name: "Walton",
    county_weights: {
      12131: 100,
    },
    county_names_all: "Walton",
    county_fips_all: 12131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32437,
    lat: 30.43315,
    lng: -85.90694,
    city: "Ebro",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 763,
    density: 8.5,
    county_fips: 12133,
    county_name: "Washington",
    county_weights: {
      12005: 22.47,
      12133: 77.53,
    },
    county_names_all: "Washington|Bay",
    county_fips_all: "12133|12005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32438,
    lat: 30.51251,
    lng: -85.41744,
    city: "Fountain",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3842,
    density: 26.1,
    county_fips: 12005,
    county_name: "Bay",
    county_weights: {
      12005: 77.1,
      12013: 17.09,
      12063: 4.6,
      12133: 1.21,
    },
    county_names_all: "Bay|Calhoun|Jackson|Washington",
    county_fips_all: "12005|12013|12063|12133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32439,
    lat: 30.49082,
    lng: -86.12933,
    city: "Freeport",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10545,
    density: 42.2,
    county_fips: 12131,
    county_name: "Walton",
    county_weights: {
      12131: 100,
    },
    county_names_all: "Walton",
    county_fips_all: 12131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32440,
    lat: 30.92025,
    lng: -85.52588,
    city: "Graceville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7640,
    density: 27.5,
    county_fips: 12063,
    county_name: "Jackson",
    county_weights: {
      12059: 30.99,
      12063: 69.01,
    },
    county_names_all: "Jackson|Holmes",
    county_fips_all: "12063|12059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32442,
    lat: 30.68531,
    lng: -85.00829,
    city: "Grand Ridge",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3291,
    density: 13.5,
    county_fips: 12063,
    county_name: "Jackson",
    county_weights: {
      12013: 10.24,
      12063: 89.76,
    },
    county_names_all: "Jackson|Calhoun",
    county_fips_all: "12063|12013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32443,
    lat: 30.86586,
    lng: -85.11695,
    city: "Greenwood",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3405,
    density: 23.2,
    county_fips: 12063,
    county_name: "Jackson",
    county_weights: {
      12063: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 12063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32444,
    lat: 30.23854,
    lng: -85.65185,
    city: "Lynn Haven",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21922,
    density: 862.6,
    county_fips: 12005,
    county_name: "Bay",
    county_weights: {
      12005: 100,
    },
    county_names_all: "Bay",
    county_fips_all: 12005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32445,
    lat: 30.96924,
    lng: -85.19504,
    city: "Malone",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2427,
    density: 36.7,
    county_fips: 12063,
    county_name: "Jackson",
    county_weights: {
      12063: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 12063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32446,
    lat: 30.84493,
    lng: -85.23017,
    city: "Marianna",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10745,
    density: 25.1,
    county_fips: 12063,
    county_name: "Jackson",
    county_weights: {
      12063: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 12063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32448,
    lat: 30.66663,
    lng: -85.21616,
    city: "Marianna",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7232,
    density: 15.5,
    county_fips: 12063,
    county_name: "Jackson",
    county_weights: {
      12013: 0.67,
      12063: 99.33,
    },
    county_names_all: "Jackson|Calhoun",
    county_fips_all: "12063|12013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32449,
    lat: 30.27611,
    lng: -85.20607,
    city: "Wewahitchka",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 751,
    density: 6.4,
    county_fips: 12013,
    county_name: "Calhoun",
    county_weights: {
      12013: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 12013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32455,
    lat: 30.63831,
    lng: -85.96395,
    city: "Ponce De Leon",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4138,
    density: 7.1,
    county_fips: 12131,
    county_name: "Walton",
    county_weights: {
      12059: 32.16,
      12131: 67.84,
    },
    county_names_all: "Walton|Holmes",
    county_fips_all: "12131|12059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32456,
    lat: 29.84586,
    lng: -85.3188,
    city: "Port Saint Joe",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8113,
    density: 29.5,
    county_fips: 12045,
    county_name: "Gulf",
    county_weights: {
      12005: 19.81,
      12037: 7.52,
      12045: 72.67,
    },
    county_names_all: "Gulf|Bay|Franklin",
    county_fips_all: "12045|12005|12037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32459,
    lat: 30.36527,
    lng: -86.18429,
    city: "Santa Rosa Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18160,
    density: 128.6,
    county_fips: 12131,
    county_name: "Walton",
    county_weights: {
      12131: 100,
    },
    county_names_all: "Walton",
    county_fips_all: 12131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32460,
    lat: 30.77565,
    lng: -84.94949,
    city: "Sneads",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6124,
    density: 32.4,
    county_fips: 12063,
    county_name: "Jackson",
    county_weights: {
      12063: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 12063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32461,
    lat: 30.30905,
    lng: -86.03508,
    city: "Inlet Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12131,
    county_name: "Walton",
    county_weights: {
      12131: 100,
    },
    county_names_all: "Walton",
    county_fips_all: 12131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32462,
    lat: 30.55753,
    lng: -85.83241,
    city: "Vernon",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3835,
    density: 9.6,
    county_fips: 12133,
    county_name: "Washington",
    county_weights: {
      12005: 1.43,
      12131: 16.68,
      12133: 81.89,
    },
    county_names_all: "Washington|Walton|Bay",
    county_fips_all: "12133|12131|12005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32463,
    lat: 30.6279,
    lng: -85.58728,
    city: "Wausau",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 212,
    density: 182.1,
    county_fips: 12133,
    county_name: "Washington",
    county_weights: {
      12133: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 12133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32464,
    lat: 30.89687,
    lng: -85.95592,
    city: "Westville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3640,
    density: 8,
    county_fips: 12059,
    county_name: "Holmes",
    county_weights: {
      12059: 81.84,
      12131: 18.16,
    },
    county_names_all: "Holmes|Walton",
    county_fips_all: "12059|12131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32465,
    lat: 30.00239,
    lng: -85.18615,
    city: "Wewahitchka",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7429,
    density: 9.1,
    county_fips: 12045,
    county_name: "Gulf",
    county_weights: {
      12045: 100,
    },
    county_names_all: "Gulf",
    county_fips_all: 12045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32466,
    lat: 30.38618,
    lng: -85.464,
    city: "Youngstown",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4927,
    density: 11,
    county_fips: 12005,
    county_name: "Bay",
    county_weights: {
      12005: 65.66,
      12013: 24.08,
      12133: 10.26,
    },
    county_names_all: "Bay|Calhoun|Washington",
    county_fips_all: "12005|12013|12133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32501,
    lat: 30.42826,
    lng: -87.22277,
    city: "Pensacola",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11422,
    density: 1196,
    county_fips: 12033,
    county_name: "Escambia",
    county_weights: {
      12033: 100,
    },
    county_names_all: "Escambia",
    county_fips_all: 12033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32502,
    lat: 30.40928,
    lng: -87.22636,
    city: "Pensacola",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3483,
    density: 501.6,
    county_fips: 12033,
    county_name: "Escambia",
    county_weights: {
      12033: 100,
    },
    county_names_all: "Escambia",
    county_fips_all: 12033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32503,
    lat: 30.46022,
    lng: -87.21372,
    city: "Pensacola",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33163,
    density: 1015.4,
    county_fips: 12033,
    county_name: "Escambia",
    county_weights: {
      12033: 100,
    },
    county_names_all: "Escambia",
    county_fips_all: 12033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32504,
    lat: 30.48495,
    lng: -87.19093,
    city: "Pensacola",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21467,
    density: 790.2,
    county_fips: 12033,
    county_name: "Escambia",
    county_weights: {
      12033: 100,
    },
    county_names_all: "Escambia",
    county_fips_all: 12033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32505,
    lat: 30.45575,
    lng: -87.26082,
    city: "Pensacola",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27369,
    density: 815.7,
    county_fips: 12033,
    county_name: "Escambia",
    county_weights: {
      12033: 100,
    },
    county_names_all: "Escambia",
    county_fips_all: 12033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32506,
    lat: 30.39152,
    lng: -87.37167,
    city: "Pensacola",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37604,
    density: 474.5,
    county_fips: 12033,
    county_name: "Escambia",
    county_weights: {
      12033: 100,
    },
    county_names_all: "Escambia",
    county_fips_all: 12033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32507,
    lat: 30.34035,
    lng: -87.37706,
    city: "Pensacola",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33689,
    density: 466.7,
    county_fips: 12033,
    county_name: "Escambia",
    county_weights: {
      12033: 100,
    },
    county_names_all: "Escambia",
    county_fips_all: 12033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32508,
    lat: 30.35614,
    lng: -87.29866,
    city: "Pensacola",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5144,
    density: 275.3,
    county_fips: 12033,
    county_name: "Escambia",
    county_weights: {
      12033: 100,
    },
    county_names_all: "Escambia",
    county_fips_all: 12033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32509,
    lat: 30.47096,
    lng: -87.34115,
    city: "Pensacola",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 642,
    density: 192.9,
    county_fips: 12033,
    county_name: "Escambia",
    county_weights: {
      12033: 100,
    },
    county_names_all: "Escambia",
    county_fips_all: 12033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32511,
    lat: 30.4064,
    lng: -87.29129,
    city: "Pensacola",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1080,
    density: 1460.2,
    county_fips: 12033,
    county_name: "Escambia",
    county_weights: {
      12033: 100,
    },
    county_names_all: "Escambia",
    county_fips_all: 12033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32512,
    lat: 30.399,
    lng: -87.29925,
    city: "Pensacola",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12033,
    county_name: "Escambia",
    county_weights: {
      12033: 100,
    },
    county_names_all: "Escambia",
    county_fips_all: 12033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32514,
    lat: 30.53209,
    lng: -87.22235,
    city: "Pensacola",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43323,
    density: 844,
    county_fips: 12033,
    county_name: "Escambia",
    county_weights: {
      12033: 100,
    },
    county_names_all: "Escambia",
    county_fips_all: 12033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32526,
    lat: 30.49824,
    lng: -87.36543,
    city: "Pensacola",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37484,
    density: 247.8,
    county_fips: 12033,
    county_name: "Escambia",
    county_weights: {
      12033: 100,
    },
    county_names_all: "Escambia",
    county_fips_all: 12033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32530,
    lat: 30.5926,
    lng: -87.02344,
    city: "Bagdad",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12113,
    county_name: "Santa Rosa",
    county_weights: {
      12113: 100,
    },
    county_names_all: "Santa Rosa",
    county_fips_all: 12113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32531,
    lat: 30.88513,
    lng: -86.696,
    city: "Baker",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5128,
    density: 8.7,
    county_fips: 12091,
    county_name: "Okaloosa",
    county_weights: {
      12091: 87.95,
      12113: 12.05,
    },
    county_names_all: "Okaloosa|Santa Rosa",
    county_fips_all: "12091|12113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32533,
    lat: 30.61329,
    lng: -87.32561,
    city: "Cantonment",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29024,
    density: 145.2,
    county_fips: 12033,
    county_name: "Escambia",
    county_weights: {
      12033: 100,
    },
    county_names_all: "Escambia",
    county_fips_all: 12033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32534,
    lat: 30.53276,
    lng: -87.28374,
    city: "Pensacola",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14759,
    density: 576.4,
    county_fips: 12033,
    county_name: "Escambia",
    county_weights: {
      12033: 100,
    },
    county_names_all: "Escambia",
    county_fips_all: 12033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32535,
    lat: 30.96515,
    lng: -87.34673,
    city: "Century",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5683,
    density: 31.1,
    county_fips: 12033,
    county_name: "Escambia",
    county_weights: {
      12033: 100,
    },
    county_names_all: "Escambia",
    county_fips_all: 12033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32536,
    lat: 30.75399,
    lng: -86.59491,
    city: "Crestview",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24601,
    density: 223.5,
    county_fips: 12091,
    county_name: "Okaloosa",
    county_weights: {
      12091: 100,
    },
    county_names_all: "Okaloosa",
    county_fips_all: 12091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32539,
    lat: 30.78128,
    lng: -86.46646,
    city: "Crestview",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30357,
    density: 91.6,
    county_fips: 12091,
    county_name: "Okaloosa",
    county_weights: {
      12091: 88.79,
      12131: 11.21,
    },
    county_names_all: "Okaloosa|Walton",
    county_fips_all: "12091|12131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32541,
    lat: 30.39666,
    lng: -86.47486,
    city: "Destin",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19085,
    density: 586.6,
    county_fips: 12091,
    county_name: "Okaloosa",
    county_weights: {
      12091: 100,
    },
    county_names_all: "Okaloosa",
    county_fips_all: 12091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32542,
    lat: 30.58743,
    lng: -86.59296,
    city: "Eglin Afb",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3725,
    density: 17.1,
    county_fips: 12091,
    county_name: "Okaloosa",
    county_weights: {
      12091: 100,
    },
    county_names_all: "Okaloosa",
    county_fips_all: 12091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32544,
    lat: 30.42801,
    lng: -86.70441,
    city: "Hurlburt Field",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2268,
    density: 106.5,
    county_fips: 12091,
    county_name: "Okaloosa",
    county_weights: {
      12091: 100,
    },
    county_names_all: "Okaloosa",
    county_fips_all: 12091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32547,
    lat: 30.46649,
    lng: -86.65513,
    city: "Fort Walton Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34071,
    density: 453.8,
    county_fips: 12091,
    county_name: "Okaloosa",
    county_weights: {
      12091: 100,
    },
    county_names_all: "Okaloosa",
    county_fips_all: 12091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32548,
    lat: 30.4094,
    lng: -86.6494,
    city: "Fort Walton Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22818,
    density: 729.2,
    county_fips: 12091,
    county_name: "Okaloosa",
    county_weights: {
      12091: 100,
    },
    county_names_all: "Okaloosa",
    county_fips_all: 12091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32550,
    lat: 30.38541,
    lng: -86.34438,
    city: "Miramar Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8310,
    density: 459.2,
    county_fips: 12131,
    county_name: "Walton",
    county_weights: {
      12131: 100,
    },
    county_names_all: "Walton",
    county_fips_all: 12131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32561,
    lat: 30.35165,
    lng: -87.10906,
    city: "Gulf Breeze",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10296,
    density: 330.2,
    county_fips: 12033,
    county_name: "Escambia",
    county_weights: {
      12033: 77.78,
      12113: 22.22,
    },
    county_names_all: "Escambia|Santa Rosa",
    county_fips_all: "12033|12113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32563,
    lat: 30.38782,
    lng: -87.0331,
    city: "Gulf Breeze",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27807,
    density: 645.4,
    county_fips: 12113,
    county_name: "Santa Rosa",
    county_weights: {
      12113: 100,
    },
    county_names_all: "Santa Rosa",
    county_fips_all: 12113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32564,
    lat: 30.72755,
    lng: -86.7875,
    city: "Holt",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2832,
    density: 10.6,
    county_fips: 12113,
    county_name: "Santa Rosa",
    county_weights: {
      12091: 49.85,
      12113: 50.15,
    },
    county_names_all: "Santa Rosa|Okaloosa",
    county_fips_all: "12113|12091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32565,
    lat: 30.89241,
    lng: -87.14071,
    city: "Jay",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4793,
    density: 8,
    county_fips: 12113,
    county_name: "Santa Rosa",
    county_weights: {
      12113: 100,
    },
    county_names_all: "Santa Rosa",
    county_fips_all: 12113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32566,
    lat: 30.4253,
    lng: -86.8843,
    city: "Navarre",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41165,
    density: 405.8,
    county_fips: 12113,
    county_name: "Santa Rosa",
    county_weights: {
      12113: 100,
    },
    county_names_all: "Santa Rosa",
    county_fips_all: 12113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32567,
    lat: 30.92207,
    lng: -86.43396,
    city: "Laurel Hill",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3325,
    density: 8.8,
    county_fips: 12091,
    county_name: "Okaloosa",
    county_weights: {
      12091: 65.23,
      12131: 34.77,
    },
    county_names_all: "Okaloosa|Walton",
    county_fips_all: "12091|12131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32568,
    lat: 30.87085,
    lng: -87.46792,
    city: "McDavid",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2806,
    density: 5.3,
    county_fips: 12033,
    county_name: "Escambia",
    county_weights: {
      12033: 100,
    },
    county_names_all: "Escambia",
    county_fips_all: 12033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32569,
    lat: 30.40666,
    lng: -86.72962,
    city: "Mary Esther",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12789,
    density: 1188.8,
    county_fips: 12091,
    county_name: "Okaloosa",
    county_weights: {
      12091: 100,
    },
    county_names_all: "Okaloosa",
    county_fips_all: 12091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32570,
    lat: 30.80022,
    lng: -86.98158,
    city: "Milton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32341,
    density: 41.5,
    county_fips: 12113,
    county_name: "Santa Rosa",
    county_weights: {
      12113: 100,
    },
    county_names_all: "Santa Rosa",
    county_fips_all: 12113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32571,
    lat: 30.67162,
    lng: -87.20004,
    city: "Milton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35905,
    density: 123.1,
    county_fips: 12113,
    county_name: "Santa Rosa",
    county_weights: {
      12113: 100,
    },
    county_names_all: "Santa Rosa",
    county_fips_all: 12113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32577,
    lat: 30.73453,
    lng: -87.37471,
    city: "Molino",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4978,
    density: 27.9,
    county_fips: 12033,
    county_name: "Escambia",
    county_weights: {
      12033: 100,
    },
    county_names_all: "Escambia",
    county_fips_all: 12033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32578,
    lat: 30.50871,
    lng: -86.4535,
    city: "Niceville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33846,
    density: 563.9,
    county_fips: 12091,
    county_name: "Okaloosa",
    county_weights: {
      12091: 97.72,
      12131: 2.28,
    },
    county_names_all: "Okaloosa|Walton",
    county_fips_all: "12091|12131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32579,
    lat: 30.44553,
    lng: -86.57401,
    city: "Shalimar",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10796,
    density: 1195.2,
    county_fips: 12091,
    county_name: "Okaloosa",
    county_weights: {
      12091: 100,
    },
    county_names_all: "Okaloosa",
    county_fips_all: 12091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32580,
    lat: 30.50337,
    lng: -86.50942,
    city: "Valparaiso",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4924,
    density: 245.2,
    county_fips: 12091,
    county_name: "Okaloosa",
    county_weights: {
      12091: 100,
    },
    county_names_all: "Okaloosa",
    county_fips_all: 12091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32583,
    lat: 30.60084,
    lng: -86.97513,
    city: "Milton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30135,
    density: 93,
    county_fips: 12113,
    county_name: "Santa Rosa",
    county_weights: {
      12113: 100,
    },
    county_names_all: "Santa Rosa",
    county_fips_all: 12113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 32601,
    lat: 29.64886,
    lng: -82.32506,
    city: "Gainesville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19805,
    density: 1663.2,
    county_fips: 12001,
    county_name: "Alachua",
    county_weights: {
      12001: 100,
    },
    county_names_all: "Alachua",
    county_fips_all: 12001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32603,
    lat: 29.65305,
    lng: -82.35054,
    city: "Gainesville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7096,
    density: 3159.8,
    county_fips: 12001,
    county_name: "Alachua",
    county_weights: {
      12001: 100,
    },
    county_names_all: "Alachua",
    county_fips_all: 12001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32605,
    lat: 29.67659,
    lng: -82.37351,
    city: "Gainesville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26305,
    density: 1034.7,
    county_fips: 12001,
    county_name: "Alachua",
    county_weights: {
      12001: 100,
    },
    county_names_all: "Alachua",
    county_fips_all: 12001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32606,
    lat: 29.68169,
    lng: -82.44391,
    city: "Gainesville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23748,
    density: 595.6,
    county_fips: 12001,
    county_name: "Alachua",
    county_weights: {
      12001: 100,
    },
    county_names_all: "Alachua",
    county_fips_all: 12001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32607,
    lat: 29.64524,
    lng: -82.41923,
    city: "Gainesville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30139,
    density: 925,
    county_fips: 12001,
    county_name: "Alachua",
    county_weights: {
      12001: 100,
    },
    county_names_all: "Alachua",
    county_fips_all: 12001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32608,
    lat: 29.59271,
    lng: -82.3935,
    city: "Gainesville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50431,
    density: 438,
    county_fips: 12001,
    county_name: "Alachua",
    county_weights: {
      12001: 100,
    },
    county_names_all: "Alachua",
    county_fips_all: 12001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32609,
    lat: 29.76296,
    lng: -82.27978,
    city: "Gainesville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19495,
    density: 64,
    county_fips: 12001,
    county_name: "Alachua",
    county_weights: {
      12001: 100,
    },
    county_names_all: "Alachua",
    county_fips_all: 12001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32610,
    lat: 29.64077,
    lng: -82.34326,
    city: "Gainesville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12001,
    county_name: "Alachua",
    county_weights: {
      12001: 100,
    },
    county_names_all: "Alachua",
    county_fips_all: 12001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32612,
    lat: 29.64469,
    lng: -82.35307,
    city: "Gainesville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6517,
    density: 2675.5,
    county_fips: 12001,
    county_name: "Alachua",
    county_weights: {
      12001: 100,
    },
    county_names_all: "Alachua",
    county_fips_all: 12001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32615,
    lat: 29.81706,
    lng: -82.49065,
    city: "Alachua",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13669,
    density: 38.3,
    county_fips: 12001,
    county_name: "Alachua",
    county_weights: {
      12001: 100,
    },
    county_names_all: "Alachua",
    county_fips_all: 12001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32616,
    lat: 29.78205,
    lng: -82.49933,
    city: "Alachua",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1198,
    density: 2018.7,
    county_fips: 12001,
    county_name: "Alachua",
    county_weights: {
      12001: 100,
    },
    county_names_all: "Alachua",
    county_fips_all: 12001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32617,
    lat: 29.30659,
    lng: -82.07553,
    city: "Anthony",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4768,
    density: 61.6,
    county_fips: 12083,
    county_name: "Marion",
    county_weights: {
      12083: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 12083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32618,
    lat: 29.53789,
    lng: -82.52295,
    city: "Archer",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8954,
    density: 37.6,
    county_fips: 12001,
    county_name: "Alachua",
    county_weights: {
      12001: 80.25,
      12075: 19.75,
    },
    county_names_all: "Alachua|Levy",
    county_fips_all: "12001|12075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32619,
    lat: 29.75661,
    lng: -82.86668,
    city: "Bell",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5540,
    density: 19.4,
    county_fips: 12041,
    county_name: "Gilchrist",
    county_weights: {
      12041: 100,
    },
    county_names_all: "Gilchrist",
    county_fips_all: 12041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32621,
    lat: 29.426,
    lng: -82.62936,
    city: "Bronson",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4672,
    density: 24.5,
    county_fips: 12075,
    county_name: "Levy",
    county_weights: {
      12075: 100,
    },
    county_names_all: "Levy",
    county_fips_all: 12075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32622,
    lat: 29.89914,
    lng: -82.31216,
    city: "Brooker",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1076,
    density: 6,
    county_fips: 12007,
    county_name: "Bradford",
    county_weights: {
      12001: 14.36,
      12007: 85.64,
    },
    county_names_all: "Bradford|Alachua",
    county_fips_all: "12007|12001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32625,
    lat: 29.23005,
    lng: -82.98331,
    city: "Cedar Key",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1568,
    density: 6.4,
    county_fips: 12075,
    county_name: "Levy",
    county_weights: {
      12075: 100,
    },
    county_names_all: "Levy",
    county_fips_all: 12075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32626,
    lat: 29.42146,
    lng: -82.89464,
    city: "Chiefland",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8583,
    density: 13.6,
    county_fips: 12075,
    county_name: "Levy",
    county_weights: {
      12075: 100,
    },
    county_names_all: "Levy",
    county_fips_all: 12075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32628,
    lat: 29.65471,
    lng: -83.16247,
    city: "Cross City",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5377,
    density: 23.6,
    county_fips: 12029,
    county_name: "Dixie",
    county_weights: {
      12029: 100,
    },
    county_names_all: "Dixie",
    county_fips_all: 12029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32631,
    lat: 29.71719,
    lng: -82.10225,
    city: "Earleton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 298,
    density: 25,
    county_fips: 12001,
    county_name: "Alachua",
    county_weights: {
      12001: 100,
    },
    county_names_all: "Alachua",
    county_fips_all: 12001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32634,
    lat: 29.3646,
    lng: -82.25419,
    city: "Fairfield",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12083,
    county_name: "Marion",
    county_weights: {
      12083: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 12083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32639,
    lat: 29.23092,
    lng: -82.72007,
    city: "Gulf Hammock",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 270,
    density: 2.2,
    county_fips: 12075,
    county_name: "Levy",
    county_weights: {
      12075: 100,
    },
    county_names_all: "Levy",
    county_fips_all: 12075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32640,
    lat: 29.56889,
    lng: -82.08021,
    city: "Hawthorne",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10647,
    density: 21.9,
    county_fips: 12001,
    county_name: "Alachua",
    county_weights: {
      12001: 62.72,
      12107: 37.28,
    },
    county_names_all: "Alachua|Putnam",
    county_fips_all: "12001|12107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32641,
    lat: 29.62956,
    lng: -82.22557,
    city: "Gainesville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16258,
    density: 91.4,
    county_fips: 12001,
    county_name: "Alachua",
    county_weights: {
      12001: 100,
    },
    county_names_all: "Alachua",
    county_fips_all: 12001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32643,
    lat: 29.81845,
    lng: -82.64155,
    city: "High Springs",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11453,
    density: 39.5,
    county_fips: 12001,
    county_name: "Alachua",
    county_weights: {
      12001: 52.23,
      12023: 12.74,
      12041: 35.03,
    },
    county_names_all: "Alachua|Gilchrist|Columbia",
    county_fips_all: "12001|12041|12023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32648,
    lat: 29.50515,
    lng: -83.24498,
    city: "Horseshoe Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 399,
    density: 1.9,
    county_fips: 12029,
    county_name: "Dixie",
    county_weights: {
      12029: 100,
    },
    county_names_all: "Dixie",
    county_fips_all: 12029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32653,
    lat: 29.74506,
    lng: -82.40546,
    city: "Gainesville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14363,
    density: 144.2,
    county_fips: 12001,
    county_name: "Alachua",
    county_weights: {
      12001: 100,
    },
    county_names_all: "Alachua",
    county_fips_all: 12001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32656,
    lat: 29.82533,
    lng: -81.95287,
    city: "Keystone Heights",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14538,
    density: 80,
    county_fips: 12019,
    county_name: "Clay",
    county_weights: {
      12007: 4.65,
      12019: 95.35,
    },
    county_names_all: "Clay|Bradford",
    county_fips_all: "12019|12007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32658,
    lat: 29.84817,
    lng: -82.41214,
    city: "La Crosse",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 327,
    density: 74.1,
    county_fips: 12001,
    county_name: "Alachua",
    county_weights: {
      12001: 100,
    },
    county_names_all: "Alachua",
    county_fips_all: 12001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32664,
    lat: 29.44986,
    lng: -82.22187,
    city: "McIntosh",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 379,
    density: 175.8,
    county_fips: 12083,
    county_name: "Marion",
    county_weights: {
      12083: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 12083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32666,
    lat: 29.72301,
    lng: -81.99145,
    city: "Melrose",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6620,
    density: 45,
    county_fips: 12107,
    county_name: "Putnam",
    county_weights: {
      12001: 20.37,
      12007: 5.7,
      12019: 14.2,
      12107: 59.73,
    },
    county_names_all: "Putnam|Alachua|Clay|Bradford",
    county_fips_all: "12107|12001|12019|12007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32667,
    lat: 29.49484,
    lng: -82.31084,
    city: "Micanopy",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4135,
    density: 17.6,
    county_fips: 12001,
    county_name: "Alachua",
    county_weights: {
      12001: 57.5,
      12083: 42.5,
    },
    county_names_all: "Alachua|Marion",
    county_fips_all: "12001|12083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32668,
    lat: 29.26327,
    lng: -82.50321,
    city: "Morriston",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5144,
    density: 14.7,
    county_fips: 12075,
    county_name: "Levy",
    county_weights: {
      12075: 81.31,
      12083: 18.69,
    },
    county_names_all: "Levy|Marion",
    county_fips_all: "12075|12083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32669,
    lat: 29.63666,
    lng: -82.60015,
    city: "Newberry",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13457,
    density: 52.7,
    county_fips: 12001,
    county_name: "Alachua",
    county_weights: {
      12001: 83.05,
      12041: 12.11,
      12075: 4.84,
    },
    county_names_all: "Alachua|Gilchrist|Levy",
    county_fips_all: "12001|12041|12075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32680,
    lat: 29.58144,
    lng: -83.08041,
    city: "Old Town",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10428,
    density: 11.7,
    county_fips: 12029,
    county_name: "Dixie",
    county_weights: {
      12029: 100,
    },
    county_names_all: "Dixie",
    county_fips_all: 12029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32681,
    lat: 29.42694,
    lng: -82.21527,
    city: "Orange Lake",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30,
    density: 79.4,
    county_fips: 12083,
    county_name: "Marion",
    county_weights: {
      12083: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 12083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32683,
    lat: 29.29519,
    lng: -82.76743,
    city: "Otter Creek",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 409,
    density: 9.9,
    county_fips: 12075,
    county_name: "Levy",
    county_weights: {
      12075: 100,
    },
    county_names_all: "Levy",
    county_fips_all: 12075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32686,
    lat: 29.36214,
    lng: -82.26236,
    city: "Reddick",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5193,
    density: 27.7,
    county_fips: 12083,
    county_name: "Marion",
    county_weights: {
      12083: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 12083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32692,
    lat: 29.32519,
    lng: -83.15995,
    city: "Suwannee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 126,
    density: 26.5,
    county_fips: 12029,
    county_name: "Dixie",
    county_weights: {
      12029: 100,
    },
    county_names_all: "Dixie",
    county_fips_all: 12029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32693,
    lat: 29.62814,
    lng: -82.79446,
    city: "Trenton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11997,
    density: 23.1,
    county_fips: 12041,
    county_name: "Gilchrist",
    county_weights: {
      12041: 75.14,
      12075: 24.86,
    },
    county_names_all: "Gilchrist|Levy",
    county_fips_all: "12041|12075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32694,
    lat: 29.79086,
    lng: -82.15367,
    city: "Waldo",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2118,
    density: 27.9,
    county_fips: 12001,
    county_name: "Alachua",
    county_weights: {
      12001: 100,
    },
    county_names_all: "Alachua",
    county_fips_all: 12001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32696,
    lat: 29.39544,
    lng: -82.46728,
    city: "Williston",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12783,
    density: 34.7,
    county_fips: 12075,
    county_name: "Levy",
    county_weights: {
      12075: 79.57,
      12083: 20.43,
    },
    county_names_all: "Levy|Marion",
    county_fips_all: "12075|12083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32697,
    lat: 29.92831,
    lng: -82.42538,
    city: "Worthington Springs",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 226,
    density: 315.8,
    county_fips: 12125,
    county_name: "Union",
    county_weights: {
      12125: 100,
    },
    county_names_all: "Union",
    county_fips_all: 12125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32701,
    lat: 28.66509,
    lng: -81.36916,
    city: "Altamonte Springs",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24060,
    density: 1649,
    county_fips: 12117,
    county_name: "Seminole",
    county_weights: {
      12117: 100,
    },
    county_names_all: "Seminole",
    county_fips_all: 12117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32702,
    lat: 29.04642,
    lng: -81.6259,
    city: "Altoona",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2378,
    density: 15.5,
    county_fips: 12069,
    county_name: "Lake",
    county_weights: {
      12069: 77.12,
      12083: 22.88,
    },
    county_names_all: "Lake|Marion",
    county_fips_all: "12069|12083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32703,
    lat: 28.65579,
    lng: -81.52139,
    city: "Apopka",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55239,
    density: 664.2,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 90.8,
      12117: 9.2,
    },
    county_names_all: "Orange|Seminole",
    county_fips_all: "12095|12117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32707,
    lat: 28.66255,
    lng: -81.31403,
    city: "Casselberry",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37106,
    density: 1489.7,
    county_fips: 12117,
    county_name: "Seminole",
    county_weights: {
      12117: 100,
    },
    county_names_all: "Seminole",
    county_fips_all: 12117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32708,
    lat: 28.68751,
    lng: -81.27086,
    city: "Winter Springs",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46542,
    density: 971.3,
    county_fips: 12117,
    county_name: "Seminole",
    county_weights: {
      12117: 100,
    },
    county_names_all: "Seminole",
    county_fips_all: 12117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32709,
    lat: 28.49266,
    lng: -80.98801,
    city: "Christmas",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1601,
    density: 4.2,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32712,
    lat: 28.72917,
    lng: -81.54103,
    city: "Apopka",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48987,
    density: 264.4,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32713,
    lat: 28.8816,
    lng: -81.3238,
    city: "Debary",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21212,
    density: 429.4,
    county_fips: 12127,
    county_name: "Volusia",
    county_weights: {
      12127: 100,
    },
    county_names_all: "Volusia",
    county_fips_all: 12127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32714,
    lat: 28.66237,
    lng: -81.4115,
    city: "Altamonte Springs",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37983,
    density: 1728.2,
    county_fips: 12117,
    county_name: "Seminole",
    county_weights: {
      12117: 100,
    },
    county_names_all: "Seminole",
    county_fips_all: 12117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32720,
    lat: 29.01775,
    lng: -81.37802,
    city: "Deland",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33485,
    density: 195,
    county_fips: 12127,
    county_name: "Volusia",
    county_weights: {
      12069: 44.14,
      12127: 55.86,
    },
    county_names_all: "Volusia|Lake",
    county_fips_all: "12127|12069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32723,
    lat: 29.03454,
    lng: -81.30452,
    city: "Deland",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12127,
    county_name: "Volusia",
    county_weights: {
      12127: 100,
    },
    county_names_all: "Volusia",
    county_fips_all: 12127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32724,
    lat: 29.0506,
    lng: -81.23284,
    city: "Deland",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37856,
    density: 174.5,
    county_fips: 12127,
    county_name: "Volusia",
    county_weights: {
      12127: 100,
    },
    county_names_all: "Volusia",
    county_fips_all: 12127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32725,
    lat: 28.88368,
    lng: -81.25061,
    city: "Deltona",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49802,
    density: 834.2,
    county_fips: 12127,
    county_name: "Volusia",
    county_weights: {
      12127: 100,
    },
    county_names_all: "Volusia",
    county_fips_all: 12127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32726,
    lat: 28.8541,
    lng: -81.68,
    city: "Eustis",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23354,
    density: 784.9,
    county_fips: 12069,
    county_name: "Lake",
    county_weights: {
      12069: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 12069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32730,
    lat: 28.65242,
    lng: -81.34301,
    city: "Casselberry",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6656,
    density: 2084,
    county_fips: 12117,
    county_name: "Seminole",
    county_weights: {
      12117: 100,
    },
    county_names_all: "Seminole",
    county_fips_all: 12117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32732,
    lat: 28.74565,
    lng: -81.10563,
    city: "Geneva",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5345,
    density: 37,
    county_fips: 12117,
    county_name: "Seminole",
    county_weights: {
      12117: 100,
    },
    county_names_all: "Seminole",
    county_fips_all: 12117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32735,
    lat: 28.89099,
    lng: -81.73718,
    city: "Grand Island",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4133,
    density: 399.9,
    county_fips: 12069,
    county_name: "Lake",
    county_weights: {
      12069: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 12069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32736,
    lat: 28.89831,
    lng: -81.49317,
    city: "Eustis",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11229,
    density: 39.7,
    county_fips: 12069,
    county_name: "Lake",
    county_weights: {
      12069: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 12069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32738,
    lat: 28.90755,
    lng: -81.18862,
    city: "Deltona",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46727,
    density: 700,
    county_fips: 12127,
    county_name: "Volusia",
    county_weights: {
      12127: 100,
    },
    county_names_all: "Volusia",
    county_fips_all: 12127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32744,
    lat: 28.98497,
    lng: -81.21899,
    city: "Lake Helen",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3478,
    density: 98.8,
    county_fips: 12127,
    county_name: "Volusia",
    county_weights: {
      12127: 100,
    },
    county_names_all: "Volusia",
    county_fips_all: 12127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32746,
    lat: 28.76297,
    lng: -81.35499,
    city: "Lake Mary",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46816,
    density: 858.2,
    county_fips: 12117,
    county_name: "Seminole",
    county_weights: {
      12117: 100,
    },
    county_names_all: "Seminole",
    county_fips_all: 12117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32750,
    lat: 28.7074,
    lng: -81.34955,
    city: "Longwood",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25639,
    density: 867.4,
    county_fips: 12117,
    county_name: "Seminole",
    county_weights: {
      12117: 100,
    },
    county_names_all: "Seminole",
    county_fips_all: 12117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32751,
    lat: 28.631,
    lng: -81.36457,
    city: "Maitland",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21478,
    density: 1181.5,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 76.68,
      12117: 23.32,
    },
    county_names_all: "Orange|Seminole",
    county_fips_all: "12095|12117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32754,
    lat: 28.68565,
    lng: -80.9208,
    city: "Mims",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11398,
    density: 32.1,
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 78.48,
      12127: 21.52,
    },
    county_names_all: "Brevard|Volusia",
    county_fips_all: "12009|12127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32757,
    lat: 28.77954,
    lng: -81.637,
    city: "Mount Dora",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29295,
    density: 320.7,
    county_fips: 12069,
    county_name: "Lake",
    county_weights: {
      12069: 67.86,
      12095: 32.14,
    },
    county_names_all: "Lake|Orange",
    county_fips_all: "12069|12095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32759,
    lat: 28.84004,
    lng: -80.9034,
    city: "Oak Hill",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3230,
    density: 25.6,
    county_fips: 12127,
    county_name: "Volusia",
    county_weights: {
      12127: 100,
    },
    county_names_all: "Volusia",
    county_fips_all: 12127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32763,
    lat: 28.94291,
    lng: -81.30593,
    city: "Orange City",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23837,
    density: 440,
    county_fips: 12127,
    county_name: "Volusia",
    county_weights: {
      12127: 100,
    },
    county_names_all: "Volusia",
    county_fips_all: 12127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32764,
    lat: 28.83883,
    lng: -81.07239,
    city: "Osteen",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3043,
    density: 12.4,
    county_fips: 12127,
    county_name: "Volusia",
    county_weights: {
      12127: 100,
    },
    county_names_all: "Volusia",
    county_fips_all: 12127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32765,
    lat: 28.66732,
    lng: -81.20033,
    city: "Oviedo",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63800,
    density: 631.2,
    county_fips: 12117,
    county_name: "Seminole",
    county_weights: {
      12117: 100,
    },
    county_names_all: "Seminole",
    county_fips_all: 12117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32766,
    lat: 28.64761,
    lng: -81.08124,
    city: "Oviedo",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16415,
    density: 144.6,
    county_fips: 12117,
    county_name: "Seminole",
    county_weights: {
      12117: 100,
    },
    county_names_all: "Seminole",
    county_fips_all: 12117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32767,
    lat: 29.01957,
    lng: -81.52065,
    city: "Paisley",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3226,
    density: 22.7,
    county_fips: 12069,
    county_name: "Lake",
    county_weights: {
      12069: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 12069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32768,
    lat: 28.69577,
    lng: -81.55795,
    city: "Plymouth",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32771,
    lat: 28.81496,
    lng: -81.31751,
    city: "Sanford",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57030,
    density: 587.2,
    county_fips: 12117,
    county_name: "Seminole",
    county_weights: {
      12117: 100,
    },
    county_names_all: "Seminole",
    county_fips_all: 12117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32773,
    lat: 28.75264,
    lng: -81.24659,
    city: "Sanford",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31090,
    density: 434.9,
    county_fips: 12117,
    county_name: "Seminole",
    county_weights: {
      12117: 100,
    },
    county_names_all: "Seminole",
    county_fips_all: 12117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32775,
    lat: 28.76704,
    lng: -80.8767,
    city: "Scottsmoor",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 100,
    },
    county_names_all: "Brevard",
    county_fips_all: 12009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32776,
    lat: 28.81033,
    lng: -81.4872,
    city: "Sorrento",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12191,
    density: 95,
    county_fips: 12069,
    county_name: "Lake",
    county_weights: {
      12069: 85.09,
      12095: 14.91,
    },
    county_names_all: "Lake|Orange",
    county_fips_all: "12069|12095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32778,
    lat: 28.77554,
    lng: -81.72884,
    city: "Tavares",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22486,
    density: 341.8,
    county_fips: 12069,
    county_name: "Lake",
    county_weights: {
      12069: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 12069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32779,
    lat: 28.71632,
    lng: -81.41343,
    city: "Longwood",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29618,
    density: 606,
    county_fips: 12117,
    county_name: "Seminole",
    county_weights: {
      12117: 100,
    },
    county_names_all: "Seminole",
    county_fips_all: 12117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32780,
    lat: 28.54672,
    lng: -80.7841,
    city: "Titusville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35908,
    density: 203.5,
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 100,
    },
    county_names_all: "Brevard",
    county_fips_all: 12009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32784,
    lat: 28.97626,
    lng: -81.7232,
    city: "Umatilla",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10869,
    density: 45.2,
    county_fips: 12083,
    county_name: "Marion",
    county_weights: {
      12069: 46.81,
      12083: 53.19,
    },
    county_names_all: "Marion|Lake",
    county_fips_all: "12083|12069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32789,
    lat: 28.59977,
    lng: -81.35235,
    city: "Winter Park",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25767,
    density: 1275.2,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32792,
    lat: 28.61066,
    lng: -81.29923,
    city: "Winter Park",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52670,
    density: 1678.4,
    county_fips: 12117,
    county_name: "Seminole",
    county_weights: {
      12095: 48.29,
      12117: 51.71,
    },
    county_names_all: "Seminole|Orange",
    county_fips_all: "12117|12095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32796,
    lat: 28.62591,
    lng: -80.84051,
    city: "Titusville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20738,
    density: 555.5,
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 100,
    },
    county_names_all: "Brevard",
    county_fips_all: 12009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32798,
    lat: 28.72647,
    lng: -81.58648,
    city: "Zellwood",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2583,
    density: 333.2,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32801,
    lat: 28.542,
    lng: -81.37343,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12945,
    density: 2261.7,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32803,
    lat: 28.55592,
    lng: -81.34895,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20771,
    density: 1178.2,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32804,
    lat: 28.57688,
    lng: -81.39748,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18695,
    density: 1009,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32805,
    lat: 28.52981,
    lng: -81.40614,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19764,
    density: 1121.1,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32806,
    lat: 28.5123,
    lng: -81.36031,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26964,
    density: 1525.7,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32807,
    lat: 28.55245,
    lng: -81.30165,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34239,
    density: 1573.6,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32808,
    lat: 28.57932,
    lng: -81.44342,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60450,
    density: 1965.2,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32809,
    lat: 28.46301,
    lng: -81.38428,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30100,
    density: 1119,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32810,
    lat: 28.62113,
    lng: -81.42863,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38248,
    density: 1610.8,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 99.89,
      12117: 0.11,
    },
    county_names_all: "Orange|Seminole",
    county_fips_all: "12095|12117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32811,
    lat: 28.51624,
    lng: -81.44516,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39905,
    density: 1854.9,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32812,
    lat: 28.4848,
    lng: -81.32767,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35174,
    density: 1599.9,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32814,
    lat: 28.57002,
    lng: -81.32663,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8405,
    density: 2710.6,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32816,
    lat: 28.60075,
    lng: -81.19511,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32817,
    lat: 28.59002,
    lng: -81.2445,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35332,
    density: 1162.9,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32818,
    lat: 28.58518,
    lng: -81.48716,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61027,
    density: 2117.2,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32819,
    lat: 28.45565,
    lng: -81.472,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27849,
    density: 520.3,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32820,
    lat: 28.58493,
    lng: -81.12127,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10934,
    density: 279.6,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32821,
    lat: 28.38095,
    lng: -81.47719,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19220,
    density: 454.9,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32822,
    lat: 28.49001,
    lng: -81.29056,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64013,
    density: 1817.7,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32824,
    lat: 28.38991,
    lng: -81.34471,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51946,
    density: 598.8,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32825,
    lat: 28.53681,
    lng: -81.24243,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60254,
    density: 1265.7,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32826,
    lat: 28.58543,
    lng: -81.18263,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37297,
    density: 1961.8,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32827,
    lat: 28.41399,
    lng: -81.29032,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9775,
    density: 166.5,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32828,
    lat: 28.53052,
    lng: -81.17022,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69913,
    density: 1295.8,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32829,
    lat: 28.47639,
    lng: -81.22478,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20903,
    density: 416.6,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32830,
    lat: 28.38643,
    lng: -81.56732,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32831,
    lat: 28.47439,
    lng: -81.14729,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3022,
    density: 108.2,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32832,
    lat: 28.39843,
    lng: -81.18407,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29359,
    density: 209.3,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32833,
    lat: 28.4948,
    lng: -81.081,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9659,
    density: 109.3,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32835,
    lat: 28.52182,
    lng: -81.48473,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47867,
    density: 1967.5,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32836,
    lat: 28.41734,
    lng: -81.51536,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19640,
    density: 635.5,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32837,
    lat: 28.38074,
    lng: -81.41998,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50780,
    density: 1075.7,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32839,
    lat: 28.48833,
    lng: -81.40689,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53012,
    density: 2755.2,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32899,
    lat: 28.58331,
    lng: -80.63544,
    city: "Orlando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 100,
    },
    county_names_all: "Brevard",
    county_fips_all: 12009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32901,
    lat: 28.07887,
    lng: -80.62268,
    city: "Melbourne",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26014,
    density: 832.6,
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 100,
    },
    county_names_all: "Brevard",
    county_fips_all: 12009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32903,
    lat: 28.10818,
    lng: -80.58709,
    city: "Indialantic",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14693,
    density: 1566,
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 100,
    },
    county_names_all: "Brevard",
    county_fips_all: 12009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32904,
    lat: 28.01,
    lng: -80.79104,
    city: "Melbourne",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 100,
    },
    county_names_all: "Brevard",
    county_fips_all: 12009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32905,
    lat: 28.03136,
    lng: -80.59997,
    city: "Palm Bay",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23410,
    density: 931.6,
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 100,
    },
    county_names_all: "Brevard",
    county_fips_all: 12009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32907,
    lat: 28.01565,
    lng: -80.68187,
    city: "Palm Bay",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46911,
    density: 1022.9,
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 100,
    },
    county_names_all: "Brevard",
    county_fips_all: 12009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32908,
    lat: 27.95622,
    lng: -80.69827,
    city: "Palm Bay",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12605,
    density: 253.4,
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 100,
    },
    county_names_all: "Brevard",
    county_fips_all: 12009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32909,
    lat: 27.90435,
    lng: -80.65515,
    city: "Palm Bay",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31734,
    density: 212.5,
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 100,
    },
    county_names_all: "Brevard",
    county_fips_all: 12009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32920,
    lat: 28.44603,
    lng: -80.58503,
    city: "Cape Canaveral",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10387,
    density: 161.8,
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 100,
    },
    county_names_all: "Brevard",
    county_fips_all: 12009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32922,
    lat: 28.37252,
    lng: -80.74279,
    city: "Cocoa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17384,
    density: 1233.1,
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 100,
    },
    county_names_all: "Brevard",
    county_fips_all: 12009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32925,
    lat: 28.24272,
    lng: -80.62287,
    city: "Patrick Afb",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1642,
    density: 204.8,
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 100,
    },
    county_names_all: "Brevard",
    county_fips_all: 12009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32926,
    lat: 28.39051,
    lng: -80.81773,
    city: "Cocoa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22862,
    density: 179.2,
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 100,
    },
    county_names_all: "Brevard",
    county_fips_all: 12009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32927,
    lat: 28.46372,
    lng: -80.80709,
    city: "Cocoa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27344,
    density: 411.6,
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 100,
    },
    county_names_all: "Brevard",
    county_fips_all: 12009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32931,
    lat: 28.32193,
    lng: -80.62731,
    city: "Cocoa Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14131,
    density: 1050.2,
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 100,
    },
    county_names_all: "Brevard",
    county_fips_all: 12009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32934,
    lat: 28.13532,
    lng: -80.71153,
    city: "Melbourne",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18298,
    density: 308.2,
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 100,
    },
    county_names_all: "Brevard",
    county_fips_all: 12009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32935,
    lat: 28.1444,
    lng: -80.64832,
    city: "Melbourne",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42463,
    density: 1247.5,
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 100,
    },
    county_names_all: "Brevard",
    county_fips_all: 12009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32937,
    lat: 28.17464,
    lng: -80.61146,
    city: "Satellite Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27054,
    density: 1537,
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 100,
    },
    county_names_all: "Brevard",
    county_fips_all: 12009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32940,
    lat: 28.21813,
    lng: -80.7543,
    city: "Melbourne",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43046,
    density: 290.1,
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 100,
    },
    county_names_all: "Brevard",
    county_fips_all: 12009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32948,
    lat: 27.75901,
    lng: -80.61826,
    city: "Fellsmere",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6594,
    density: 22.3,
    county_fips: 12061,
    county_name: "Indian River",
    county_weights: {
      12009: 21.28,
      12061: 78.72,
    },
    county_names_all: "Indian River|Brevard",
    county_fips_all: "12061|12009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32949,
    lat: 27.92005,
    lng: -80.55203,
    city: "Grant",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2711,
    density: 62.3,
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 100,
    },
    county_names_all: "Brevard",
    county_fips_all: 12009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32950,
    lat: 27.9757,
    lng: -80.57839,
    city: "Malabar",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4422,
    density: 91.8,
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 100,
    },
    county_names_all: "Brevard",
    county_fips_all: 12009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32951,
    lat: 27.9595,
    lng: -80.51498,
    city: "Melbourne Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12150,
    density: 576.6,
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 100,
    },
    county_names_all: "Brevard",
    county_fips_all: 12009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32952,
    lat: 28.31749,
    lng: -80.66832,
    city: "Merritt Island",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20553,
    density: 644.9,
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 100,
    },
    county_names_all: "Brevard",
    county_fips_all: 12009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32953,
    lat: 28.45613,
    lng: -80.69916,
    city: "Merritt Island",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23829,
    density: 231.4,
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 100,
    },
    county_names_all: "Brevard",
    county_fips_all: 12009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32955,
    lat: 28.29414,
    lng: -80.77528,
    city: "Rockledge",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39846,
    density: 302.5,
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 100,
    },
    county_names_all: "Brevard",
    county_fips_all: 12009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32958,
    lat: 27.79364,
    lng: -80.49135,
    city: "Sebastian",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29057,
    density: 402.8,
    county_fips: 12061,
    county_name: "Indian River",
    county_weights: {
      12061: 100,
    },
    county_names_all: "Indian River",
    county_fips_all: 12061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32959,
    lat: 28.44513,
    lng: -80.7637,
    city: "Sharpes",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 100,
    },
    county_names_all: "Brevard",
    county_fips_all: 12009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32960,
    lat: 27.64069,
    lng: -80.40366,
    city: "Vero Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22974,
    density: 802.5,
    county_fips: 12061,
    county_name: "Indian River",
    county_weights: {
      12061: 100,
    },
    county_names_all: "Indian River",
    county_fips_all: 12061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32962,
    lat: 27.5865,
    lng: -80.38414,
    city: "Vero Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25229,
    density: 779.6,
    county_fips: 12061,
    county_name: "Indian River",
    county_weights: {
      12061: 100,
    },
    county_names_all: "Indian River",
    county_fips_all: 12061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32963,
    lat: 27.71951,
    lng: -80.39646,
    city: "Vero Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15383,
    density: 341,
    county_fips: 12061,
    county_name: "Indian River",
    county_weights: {
      12061: 100,
    },
    county_names_all: "Indian River",
    county_fips_all: 12061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32966,
    lat: 27.68716,
    lng: -80.70693,
    city: "Vero Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19957,
    density: 29.7,
    county_fips: 12061,
    county_name: "Indian River",
    county_weights: {
      12061: 100,
    },
    county_names_all: "Indian River",
    county_fips_all: 12061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32967,
    lat: 27.71359,
    lng: -80.46015,
    city: "Vero Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22819,
    density: 220.5,
    county_fips: 12061,
    county_name: "Indian River",
    county_weights: {
      12061: 100,
    },
    county_names_all: "Indian River",
    county_fips_all: 12061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32968,
    lat: 27.58808,
    lng: -80.50993,
    city: "Vero Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14705,
    density: 130.6,
    county_fips: 12061,
    county_name: "Indian River",
    county_weights: {
      12061: 100,
    },
    county_names_all: "Indian River",
    county_fips_all: 12061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32970,
    lat: 27.75402,
    lng: -80.45136,
    city: "Wabasso",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 246,
    density: 96.2,
    county_fips: 12061,
    county_name: "Indian River",
    county_weights: {
      12061: 100,
    },
    county_names_all: "Indian River",
    county_fips_all: 12061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 32976,
    lat: 27.86198,
    lng: -80.53721,
    city: "Sebastian",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9109,
    density: 144.8,
    county_fips: 12009,
    county_name: "Brevard",
    county_weights: {
      12009: 100,
    },
    county_names_all: "Brevard",
    county_fips_all: 12009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33001,
    lat: 24.82041,
    lng: -80.80992,
    city: "Long Key",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 300,
    density: 59.3,
    county_fips: 12087,
    county_name: "Monroe",
    county_weights: {
      12087: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 12087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33004,
    lat: 26.05939,
    lng: -80.13637,
    city: "Dania",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16234,
    density: 927.8,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33009,
    lat: 25.98531,
    lng: -80.1466,
    city: "Hallandale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42070,
    density: 3320.6,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33010,
    lat: 25.83309,
    lng: -80.27902,
    city: "Hialeah",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45454,
    density: 4061.2,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33012,
    lat: 25.86583,
    lng: -80.30247,
    city: "Hialeah",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74603,
    density: 4904.9,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33013,
    lat: 25.86209,
    lng: -80.27032,
    city: "Hialeah",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30524,
    density: 3111.9,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33014,
    lat: 25.90332,
    lng: -80.30173,
    city: "Hialeah",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42153,
    density: 2511.5,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33015,
    lat: 25.94116,
    lng: -80.31761,
    city: "Hialeah",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67952,
    density: 4457.4,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33016,
    lat: 25.89361,
    lng: -80.33186,
    city: "Hialeah",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50269,
    density: 4638.4,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33018,
    lat: 25.92,
    lng: -80.39274,
    city: "Hialeah",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53575,
    density: 736.5,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33019,
    lat: 26.02346,
    lng: -80.1236,
    city: "Hollywood",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14307,
    density: 1475,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33020,
    lat: 26.01911,
    lng: -80.15251,
    city: "Hollywood",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44655,
    density: 2865.2,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33021,
    lat: 26.02277,
    lng: -80.18742,
    city: "Hollywood",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49859,
    density: 2179,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33022,
    lat: 26.01385,
    lng: -80.14407,
    city: "Hollywood",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33023,
    lat: 25.98812,
    lng: -80.21263,
    city: "Hollywood",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74913,
    density: 3303.7,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33024,
    lat: 26.02501,
    lng: -80.24475,
    city: "Hollywood",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75701,
    density: 2519,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33025,
    lat: 25.98737,
    lng: -80.28134,
    city: "Hollywood",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 73180,
    density: 2677.9,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33026,
    lat: 26.02575,
    lng: -80.29625,
    city: "Hollywood",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32882,
    density: 2756.9,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33027,
    lat: 25.98245,
    lng: -80.34359,
    city: "Hollywood",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 66467,
    density: 1920.8,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33028,
    lat: 26.01852,
    lng: -80.34488,
    city: "Pembroke Pines",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27314,
    density: 1835.2,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33029,
    lat: 25.99184,
    lng: -80.40794,
    city: "Hollywood",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45142,
    density: 1039.8,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33030,
    lat: 25.4848,
    lng: -80.50857,
    city: "Homestead",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35743,
    density: 782.1,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33031,
    lat: 25.52709,
    lng: -80.50312,
    city: "Homestead",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9148,
    density: 159,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33032,
    lat: 25.52963,
    lng: -80.39234,
    city: "Homestead",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52073,
    density: 1102.3,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33033,
    lat: 25.47858,
    lng: -80.4057,
    city: "Homestead",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58869,
    density: 1017.9,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33034,
    lat: 25.4195,
    lng: -80.86342,
    city: "Homestead",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23356,
    density: 7.7,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 52.45,
      12087: 47.55,
    },
    county_names_all: "Miami-Dade|Monroe",
    county_fips_all: "12086|12087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33035,
    lat: 25.4216,
    lng: -80.4036,
    city: "Homestead",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14509,
    density: 190.1,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33036,
    lat: 24.9227,
    lng: -80.6385,
    city: "Islamorada",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3264,
    density: 215.6,
    county_fips: 12087,
    county_name: "Monroe",
    county_weights: {
      12087: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 12087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33037,
    lat: 25.19779,
    lng: -80.38634,
    city: "Key Largo",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10541,
    density: 123.7,
    county_fips: 12087,
    county_name: "Monroe",
    county_weights: {
      12087: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 12087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33039,
    lat: 25.49796,
    lng: -80.39818,
    city: "Homestead",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 378,
    density: 2191.3,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33040,
    lat: 24.5855,
    lng: -81.74904,
    city: "Key West",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34401,
    density: 749.4,
    county_fips: 12087,
    county_name: "Monroe",
    county_weights: {
      12087: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 12087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33042,
    lat: 24.67481,
    lng: -81.50717,
    city: "Summerland Key",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6512,
    density: 91.1,
    county_fips: 12087,
    county_name: "Monroe",
    county_weights: {
      12087: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 12087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33043,
    lat: 24.70563,
    lng: -81.3587,
    city: "Big Pine Key",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4911,
    density: 113.9,
    county_fips: 12087,
    county_name: "Monroe",
    county_weights: {
      12087: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 12087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33050,
    lat: 24.72843,
    lng: -81.03405,
    city: "Marathon",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9530,
    density: 405.3,
    county_fips: 12087,
    county_name: "Monroe",
    county_weights: {
      12087: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 12087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33051,
    lat: 24.72328,
    lng: -81.02155,
    city: "Key Colony Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 523,
    density: 460.3,
    county_fips: 12087,
    county_name: "Monroe",
    county_weights: {
      12087: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 12087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33054,
    lat: 25.90775,
    lng: -80.25753,
    city: "Opa Locka",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32735,
    density: 1504.9,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33055,
    lat: 25.94812,
    lng: -80.27809,
    city: "Opa Locka",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38509,
    density: 2476.1,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33056,
    lat: 25.94922,
    lng: -80.24562,
    city: "Miami Gardens",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36822,
    density: 2319.9,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33060,
    lat: 26.23513,
    lng: -80.12084,
    city: "Pompano Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38637,
    density: 2145.5,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33062,
    lat: 26.24101,
    lng: -80.09399,
    city: "Pompano Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23303,
    density: 2308.8,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33063,
    lat: 26.25138,
    lng: -80.21014,
    city: "Pompano Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54916,
    density: 2584.4,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33064,
    lat: 26.27806,
    lng: -80.11524,
    city: "Pompano Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59942,
    density: 2267.4,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33065,
    lat: 26.27318,
    lng: -80.26029,
    city: "Coral Springs",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58637,
    density: 2638.9,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33066,
    lat: 26.25347,
    lng: -80.17753,
    city: "Pompano Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17382,
    density: 2211.5,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33067,
    lat: 26.307,
    lng: -80.2257,
    city: "Pompano Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26294,
    density: 1027,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33068,
    lat: 26.21644,
    lng: -80.21535,
    city: "Pompano Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52691,
    density: 3160.6,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33069,
    lat: 26.23565,
    lng: -80.15808,
    city: "Pompano Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29321,
    density: 1207.1,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33070,
    lat: 25.00873,
    lng: -80.52501,
    city: "Tavernier",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5138,
    density: 468.9,
    county_fips: 12087,
    county_name: "Monroe",
    county_weights: {
      12087: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 12087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33071,
    lat: 26.24395,
    lng: -80.26627,
    city: "Coral Springs",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39433,
    density: 2031.8,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33073,
    lat: 26.29818,
    lng: -80.1827,
    city: "Pompano Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35407,
    density: 1679,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33076,
    lat: 26.31788,
    lng: -80.27431,
    city: "Pompano Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41884,
    density: 1493.6,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33101,
    lat: 25.77976,
    lng: -80.19877,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33109,
    lat: 25.7616,
    lng: -80.14197,
    city: "Miami Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 390,
    density: 477.1,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33122,
    lat: 25.80523,
    lng: -80.31706,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 432,
    density: 69.6,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33125,
    lat: 25.7839,
    lng: -80.23738,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60347,
    density: 5946.8,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33126,
    lat: 25.78061,
    lng: -80.30054,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50886,
    density: 3647,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33127,
    lat: 25.81307,
    lng: -80.20553,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30795,
    density: 3609.3,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33128,
    lat: 25.77661,
    lng: -80.20407,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8729,
    density: 7845.1,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33129,
    lat: 25.7527,
    lng: -80.20046,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14220,
    density: 3971.7,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33130,
    lat: 25.76805,
    lng: -80.20291,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33938,
    density: 11980.4,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33131,
    lat: 25.76417,
    lng: -80.18459,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20558,
    density: 15838.6,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33132,
    lat: 25.77719,
    lng: -80.17395,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15496,
    density: 3959.1,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33133,
    lat: 25.72983,
    lng: -80.24327,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35445,
    density: 3288,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33134,
    lat: 25.75338,
    lng: -80.2712,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39420,
    density: 2911.4,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33135,
    lat: 25.76657,
    lng: -80.23495,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36678,
    density: 6658.8,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33136,
    lat: 25.78703,
    lng: -80.20444,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17065,
    density: 4699.4,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33137,
    lat: 25.81538,
    lng: -80.17798,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22835,
    density: 4361,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33138,
    lat: 25.85388,
    lng: -80.17846,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29163,
    density: 2672.9,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33139,
    lat: 25.78523,
    lng: -80.15085,
    city: "Miami Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38488,
    density: 5340.7,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33140,
    lat: 25.81606,
    lng: -80.13895,
    city: "Miami Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21248,
    density: 2657.5,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33141,
    lat: 25.85116,
    lng: -80.14147,
    city: "Miami Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38442,
    density: 6425.1,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33142,
    lat: 25.80665,
    lng: -80.25517,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59773,
    density: 2116.2,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33143,
    lat: 25.70255,
    lng: -80.29792,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32055,
    density: 1595,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33144,
    lat: 25.76335,
    lng: -80.31228,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30343,
    density: 3791.6,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33145,
    lat: 25.75322,
    lng: -80.23461,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30450,
    density: 4623.3,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33146,
    lat: 25.72059,
    lng: -80.27274,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16171,
    density: 1990.8,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33147,
    lat: 25.85104,
    lng: -80.23861,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46765,
    density: 2502.6,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33149,
    lat: 25.72479,
    lng: -80.16118,
    city: "Key Biscayne",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12955,
    density: 1062.3,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33150,
    lat: 25.85196,
    lng: -80.20702,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31637,
    density: 3517.6,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33154,
    lat: 25.88609,
    lng: -80.13332,
    city: "Miami Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14511,
    density: 2890.1,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33155,
    lat: 25.73672,
    lng: -80.31117,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44659,
    density: 2339.1,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33156,
    lat: 25.66779,
    lng: -80.29728,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33223,
    density: 924.8,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33157,
    lat: 25.60671,
    lng: -80.34314,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67268,
    density: 1738.1,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33158,
    lat: 25.63744,
    lng: -80.30945,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6233,
    density: 864.1,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33160,
    lat: 25.93234,
    lng: -80.13583,
    city: "North Miami Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39704,
    density: 3457.2,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33161,
    lat: 25.89357,
    lng: -80.18285,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56446,
    density: 3975,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33162,
    lat: 25.92845,
    lng: -80.17844,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47855,
    density: 3481.5,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33165,
    lat: 25.73437,
    lng: -80.35862,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54497,
    density: 2803.5,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33166,
    lat: 25.8253,
    lng: -80.31049,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25097,
    density: 1221.9,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33167,
    lat: 25.8848,
    lng: -80.23631,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22618,
    density: 2068.8,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33168,
    lat: 25.89318,
    lng: -80.2093,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23996,
    density: 2576.1,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33169,
    lat: 25.94298,
    lng: -80.2147,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40221,
    density: 2271.3,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33170,
    lat: 25.55827,
    lng: -80.45313,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13254,
    density: 413.5,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33172,
    lat: 25.78655,
    lng: -80.3623,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42232,
    density: 2548.1,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33173,
    lat: 25.70163,
    lng: -80.35765,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32469,
    density: 2289.8,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33174,
    lat: 25.76199,
    lng: -80.36029,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35938,
    density: 4531.2,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33175,
    lat: 25.73435,
    lng: -80.40621,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52885,
    density: 2584.5,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33176,
    lat: 25.65876,
    lng: -80.35919,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53934,
    density: 1727.3,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33177,
    lat: 25.59703,
    lng: -80.40458,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56862,
    density: 1748.8,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33178,
    lat: 25.83578,
    lng: -80.4213,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52885,
    density: 334.2,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33179,
    lat: 25.95821,
    lng: -80.17981,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46620,
    density: 3576.3,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33180,
    lat: 25.96145,
    lng: -80.1415,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32136,
    density: 3804,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33181,
    lat: 25.89717,
    lng: -80.1531,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20242,
    density: 2567.1,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33182,
    lat: 25.78252,
    lng: -80.40182,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16484,
    density: 1828.7,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33183,
    lat: 25.70047,
    lng: -80.40578,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36673,
    density: 2567.9,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33184,
    lat: 25.7597,
    lng: -80.4066,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21472,
    density: 3351.2,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33185,
    lat: 25.73035,
    lng: -80.45448,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30165,
    density: 1689.5,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33186,
    lat: 25.65565,
    lng: -80.41062,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69459,
    density: 2155.4,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33187,
    lat: 25.54889,
    lng: -80.57638,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18381,
    density: 62.8,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33189,
    lat: 25.57314,
    lng: -80.33929,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24802,
    density: 1881.8,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33190,
    lat: 25.55734,
    lng: -80.34897,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17252,
    density: 3261.9,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33193,
    lat: 25.70175,
    lng: -80.46672,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49083,
    density: 2506.3,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33194,
    lat: 25.7163,
    lng: -80.62799,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8757,
    density: 29.7,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33196,
    lat: 25.64505,
    lng: -80.55524,
    city: "Miami",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55829,
    density: 413,
    county_fips: 12086,
    county_name: "Miami-Dade",
    county_weights: {
      12086: 100,
    },
    county_names_all: "Miami-Dade",
    county_fips_all: 12086,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33301,
    lat: 26.12128,
    lng: -80.12745,
    city: "Fort Lauderdale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15250,
    density: 2362.2,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33304,
    lat: 26.13845,
    lng: -80.12166,
    city: "Fort Lauderdale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17630,
    density: 2181.1,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33305,
    lat: 26.15375,
    lng: -80.123,
    city: "Fort Lauderdale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12976,
    density: 2281,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33306,
    lat: 26.16548,
    lng: -80.11404,
    city: "Fort Lauderdale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3286,
    density: 1486.7,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33308,
    lat: 26.18952,
    lng: -80.10859,
    city: "Fort Lauderdale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27226,
    density: 2282.7,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33309,
    lat: 26.18793,
    lng: -80.17385,
    city: "Fort Lauderdale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39928,
    density: 1586.6,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33311,
    lat: 26.14412,
    lng: -80.17319,
    city: "Fort Lauderdale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75705,
    density: 2818.5,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33312,
    lat: 26.08835,
    lng: -80.18166,
    city: "Fort Lauderdale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55149,
    density: 1921.7,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33313,
    lat: 26.15069,
    lng: -80.22634,
    city: "Fort Lauderdale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62945,
    density: 3881.9,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33314,
    lat: 26.06822,
    lng: -80.22391,
    city: "Fort Lauderdale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27895,
    density: 1230.2,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33315,
    lat: 26.08703,
    lng: -80.15297,
    city: "Fort Lauderdale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13490,
    density: 985.3,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33316,
    lat: 26.09913,
    lng: -80.12398,
    city: "Fort Lauderdale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10447,
    density: 989.8,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33317,
    lat: 26.11268,
    lng: -80.22607,
    city: "Fort Lauderdale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38256,
    density: 1545.6,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33319,
    lat: 26.1826,
    lng: -80.22641,
    city: "Fort Lauderdale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49218,
    density: 2795.4,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33321,
    lat: 26.2121,
    lng: -80.2697,
    city: "Fort Lauderdale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48061,
    density: 2255.1,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33322,
    lat: 26.14997,
    lng: -80.27429,
    city: "Fort Lauderdale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40832,
    density: 2861.7,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33323,
    lat: 26.14988,
    lng: -80.32222,
    city: "Fort Lauderdale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21612,
    density: 1110.9,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33324,
    lat: 26.11205,
    lng: -80.27469,
    city: "Fort Lauderdale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49350,
    density: 2106.9,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33325,
    lat: 26.11032,
    lng: -80.32261,
    city: "Fort Lauderdale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30985,
    density: 1268.8,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33326,
    lat: 26.11033,
    lng: -80.37403,
    city: "Fort Lauderdale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32586,
    density: 1741.4,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33327,
    lat: 26.24429,
    lng: -80.39267,
    city: "Fort Lauderdale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33328,
    lat: 26.06673,
    lng: -80.27301,
    city: "Fort Lauderdale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29355,
    density: 1239.4,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33330,
    lat: 26.06034,
    lng: -80.32333,
    city: "Fort Lauderdale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15355,
    density: 535.1,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33331,
    lat: 26.0587,
    lng: -80.36989,
    city: "Fort Lauderdale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25829,
    density: 847.5,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33332,
    lat: 26.03825,
    lng: -80.44352,
    city: "Fort Lauderdale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12111,
    density: 136.2,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33334,
    lat: 26.18316,
    lng: -80.13456,
    city: "Fort Lauderdale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30333,
    density: 2456.8,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33351,
    lat: 26.17938,
    lng: -80.27463,
    city: "Fort Lauderdale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34774,
    density: 2420.4,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33388,
    lat: 26.11715,
    lng: -80.25409,
    city: "Plantation",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33401,
    lat: 26.71805,
    lng: -80.0685,
    city: "West Palm Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30315,
    density: 2306.1,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33403,
    lat: 26.8032,
    lng: -80.07562,
    city: "West Palm Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12458,
    density: 1454.4,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33404,
    lat: 26.78248,
    lng: -80.06567,
    city: "West Palm Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29357,
    density: 1553.5,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33405,
    lat: 26.66774,
    lng: -80.0584,
    city: "West Palm Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20838,
    density: 1783.6,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33406,
    lat: 26.66503,
    lng: -80.09093,
    city: "West Palm Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26653,
    density: 1184.1,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33407,
    lat: 26.75841,
    lng: -80.09195,
    city: "West Palm Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31124,
    density: 1218.7,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33408,
    lat: 26.84115,
    lng: -80.05677,
    city: "North Palm Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18251,
    density: 1036,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33409,
    lat: 26.7161,
    lng: -80.0965,
    city: "West Palm Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32607,
    density: 2013.8,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33410,
    lat: 26.84629,
    lng: -80.08823,
    city: "Palm Beach Gardens",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35410,
    density: 1202.5,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33411,
    lat: 26.71517,
    lng: -80.20305,
    city: "West Palm Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74554,
    density: 825.9,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33412,
    lat: 26.80561,
    lng: -80.21557,
    city: "West Palm Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15012,
    density: 97.7,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33413,
    lat: 26.66397,
    lng: -80.1553,
    city: "West Palm Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16904,
    density: 905.5,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33414,
    lat: 26.64829,
    lng: -80.24943,
    city: "Wellington",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60452,
    density: 823.5,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33415,
    lat: 26.66002,
    lng: -80.12742,
    city: "West Palm Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51932,
    density: 2743.2,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33417,
    lat: 26.71994,
    lng: -80.12495,
    city: "West Palm Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34044,
    density: 1988.5,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33418,
    lat: 26.86077,
    lng: -80.16641,
    city: "Palm Beach Gardens",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41737,
    density: 351.5,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33426,
    lat: 26.53359,
    lng: -80.08295,
    city: "Boynton Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23797,
    density: 1495.3,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33428,
    lat: 26.35054,
    lng: -80.22792,
    city: "Boca Raton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43566,
    density: 1459.7,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12011: 0.14,
      12099: 99.86,
    },
    county_names_all: "Palm Beach|Broward",
    county_fips_all: "12099|12011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33430,
    lat: 26.61415,
    lng: -80.57952,
    city: "Belle Glade",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23428,
    density: 37.7,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33431,
    lat: 26.37996,
    lng: -80.1028,
    city: "Boca Raton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23329,
    density: 1081,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33432,
    lat: 26.34546,
    lng: -80.0838,
    city: "Boca Raton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21017,
    density: 1749,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33433,
    lat: 26.34706,
    lng: -80.15919,
    city: "Boca Raton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40655,
    density: 1661.3,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33434,
    lat: 26.38139,
    lng: -80.16913,
    city: "Boca Raton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20685,
    density: 1156.3,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33435,
    lat: 26.52565,
    lng: -80.06297,
    city: "Boynton Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36406,
    density: 2157,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33436,
    lat: 26.52423,
    lng: -80.10758,
    city: "Boynton Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46812,
    density: 1536.6,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33437,
    lat: 26.51164,
    lng: -80.14917,
    city: "Boynton Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37420,
    density: 1343.7,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33438,
    lat: 26.95443,
    lng: -80.56524,
    city: "Canal Point",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 388,
    density: 3.8,
    county_fips: 12085,
    county_name: "Martin",
    county_weights: {
      12085: 64.73,
      12099: 35.27,
    },
    county_names_all: "Martin|Palm Beach",
    county_fips_all: "12085|12099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33440,
    lat: 26.54065,
    lng: -81.04325,
    city: "Clewiston",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21254,
    density: 11.3,
    county_fips: 12051,
    county_name: "Hendry",
    county_weights: {
      12051: 95.37,
      12099: 4.63,
    },
    county_names_all: "Hendry|Palm Beach",
    county_fips_all: "12051|12099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33441,
    lat: 26.31096,
    lng: -80.09885,
    city: "Deerfield Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27963,
    density: 2252.2,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33442,
    lat: 26.31012,
    lng: -80.14503,
    city: "Deerfield Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28934,
    density: 1630.2,
    county_fips: 12011,
    county_name: "Broward",
    county_weights: {
      12011: 100,
    },
    county_names_all: "Broward",
    county_fips_all: 12011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33444,
    lat: 26.45781,
    lng: -80.08002,
    city: "Delray Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24970,
    density: 1927,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33445,
    lat: 26.4548,
    lng: -80.1063,
    city: "Delray Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31025,
    density: 1482.2,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33446,
    lat: 26.45444,
    lng: -80.18353,
    city: "Delray Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26415,
    density: 543.5,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33449,
    lat: 26.59272,
    lng: -80.2339,
    city: "Lake Worth",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11783,
    density: 279.3,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33455,
    lat: 27.05748,
    lng: -80.1703,
    city: "Hobe Sound",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22031,
    density: 150.3,
    county_fips: 12085,
    county_name: "Martin",
    county_weights: {
      12085: 100,
    },
    county_names_all: "Martin",
    county_fips_all: 12085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33458,
    lat: 26.93477,
    lng: -80.12906,
    city: "Jupiter",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59098,
    density: 1120.9,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12085: 19.28,
      12099: 80.72,
    },
    county_names_all: "Palm Beach|Martin",
    county_fips_all: "12099|12085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33460,
    lat: 26.61872,
    lng: -80.05527,
    city: "Lake Worth Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32848,
    density: 2680.4,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33461,
    lat: 26.61936,
    lng: -80.09048,
    city: "Lake Worth",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46574,
    density: 2528.6,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33462,
    lat: 26.58027,
    lng: -80.07337,
    city: "Lake Worth",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34068,
    density: 1537.3,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33463,
    lat: 26.59508,
    lng: -80.12968,
    city: "Lake Worth",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64116,
    density: 2296.7,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33467,
    lat: 26.59472,
    lng: -80.17567,
    city: "Lake Worth",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55279,
    density: 1140.5,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33469,
    lat: 26.98275,
    lng: -80.1092,
    city: "Jupiter",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14848,
    density: 530.1,
    county_fips: 12085,
    county_name: "Martin",
    county_weights: {
      12085: 69.2,
      12099: 30.8,
    },
    county_names_all: "Martin|Palm Beach",
    county_fips_all: "12085|12099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33470,
    lat: 26.7832,
    lng: -80.38063,
    city: "Loxahatchee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28587,
    density: 53.8,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33471,
    lat: 26.9105,
    lng: -81.19754,
    city: "Moore Haven",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7061,
    density: 8.3,
    county_fips: 12043,
    county_name: "Glades",
    county_weights: {
      12043: 100,
    },
    county_names_all: "Glades",
    county_fips_all: 12043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33472,
    lat: 26.53974,
    lng: -80.18903,
    city: "Boynton Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19874,
    density: 541.4,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33473,
    lat: 26.50328,
    lng: -80.19225,
    city: "Boynton Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11868,
    density: 644,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33476,
    lat: 26.80109,
    lng: -80.65305,
    city: "Pahokee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8123,
    density: 141.3,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33477,
    lat: 26.91401,
    lng: -80.0799,
    city: "Jupiter",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12875,
    density: 802.2,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33478,
    lat: 26.93788,
    lng: -80.26298,
    city: "Jupiter",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14745,
    density: 88.2,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12085: 19.95,
      12099: 80.05,
    },
    county_names_all: "Palm Beach|Martin",
    county_fips_all: "12099|12085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33480,
    lat: 26.69796,
    lng: -80.04075,
    city: "Palm Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10631,
    density: 1046.2,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33483,
    lat: 26.46157,
    lng: -80.0638,
    city: "Delray Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13233,
    density: 1339.5,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33484,
    lat: 26.45432,
    lng: -80.13434,
    city: "Delray Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27210,
    density: 1744.5,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33486,
    lat: 26.34729,
    lng: -80.11449,
    city: "Boca Raton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23729,
    density: 1712.1,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33487,
    lat: 26.40991,
    lng: -80.09169,
    city: "Boca Raton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20794,
    density: 1197.3,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33493,
    lat: 26.47559,
    lng: -80.72306,
    city: "South Bay",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6681,
    density: 10.6,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33496,
    lat: 26.40887,
    lng: -80.16139,
    city: "Boca Raton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23442,
    density: 857.9,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33498,
    lat: 26.39529,
    lng: -80.21982,
    city: "Boca Raton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16280,
    density: 628.1,
    county_fips: 12099,
    county_name: "Palm Beach",
    county_weights: {
      12099: 100,
    },
    county_names_all: "Palm Beach",
    county_fips_all: 12099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33503,
    lat: 27.76375,
    lng: -82.27425,
    city: "Balm",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 222,
    density: 140.7,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33510,
    lat: 27.95564,
    lng: -82.29986,
    city: "Brandon",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29831,
    density: 1519.9,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33511,
    lat: 27.9099,
    lng: -82.29405,
    city: "Brandon",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59776,
    density: 1438.4,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33513,
    lat: 28.66849,
    lng: -82.17143,
    city: "Bushnell",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13982,
    density: 63.1,
    county_fips: 12119,
    county_name: "Sumter",
    county_weights: {
      12119: 100,
    },
    county_names_all: "Sumter",
    county_fips_all: 12119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33514,
    lat: 28.65771,
    lng: -81.99886,
    city: "Center Hill",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2954,
    density: 27,
    county_fips: 12119,
    county_name: "Sumter",
    county_weights: {
      12119: 100,
    },
    county_names_all: "Sumter",
    county_fips_all: 12119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33521,
    lat: 28.79788,
    lng: -82.0752,
    city: "Coleman",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 719,
    density: 85.8,
    county_fips: 12119,
    county_name: "Sumter",
    county_weights: {
      12119: 100,
    },
    county_names_all: "Sumter",
    county_fips_all: 12119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33523,
    lat: 28.41787,
    lng: -82.26476,
    city: "Dade City",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18834,
    density: 69,
    county_fips: 12101,
    county_name: "Pasco",
    county_weights: {
      12053: 7.67,
      12101: 92.33,
    },
    county_names_all: "Pasco|Hernando",
    county_fips_all: "12101|12053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33525,
    lat: 28.33503,
    lng: -82.18383,
    city: "Dade City",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20337,
    density: 81.8,
    county_fips: 12101,
    county_name: "Pasco",
    county_weights: {
      12101: 100,
    },
    county_names_all: "Pasco",
    county_fips_all: 12101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33527,
    lat: 27.97571,
    lng: -82.2138,
    city: "Dover",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15593,
    density: 191.5,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33530,
    lat: 27.90773,
    lng: -82.17236,
    city: "Durant",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33534,
    lat: 27.82273,
    lng: -82.37505,
    city: "Gibsonton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16608,
    density: 486.6,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33538,
    lat: 28.84679,
    lng: -82.18218,
    city: "Lake Panasoffkee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5371,
    density: 23.3,
    county_fips: 12119,
    county_name: "Sumter",
    county_weights: {
      12119: 100,
    },
    county_names_all: "Sumter",
    county_fips_all: 12119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33540,
    lat: 28.21936,
    lng: -82.14866,
    city: "Zephyrhills",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9126,
    density: 97.7,
    county_fips: 12101,
    county_name: "Pasco",
    county_weights: {
      12057: 8.33,
      12101: 91.67,
    },
    county_names_all: "Pasco|Hillsborough",
    county_fips_all: "12101|12057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33541,
    lat: 28.23029,
    lng: -82.22073,
    city: "Zephyrhills",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22432,
    density: 364.4,
    county_fips: 12101,
    county_name: "Pasco",
    county_weights: {
      12101: 100,
    },
    county_names_all: "Pasco",
    county_fips_all: 12101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33542,
    lat: 28.23562,
    lng: -82.17708,
    city: "Zephyrhills",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22744,
    density: 841.8,
    county_fips: 12101,
    county_name: "Pasco",
    county_weights: {
      12101: 100,
    },
    county_names_all: "Pasco",
    county_fips_all: 12101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33543,
    lat: 28.20279,
    lng: -82.30503,
    city: "Wesley Chapel",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27933,
    density: 410.8,
    county_fips: 12101,
    county_name: "Pasco",
    county_weights: {
      12101: 100,
    },
    county_names_all: "Pasco",
    county_fips_all: 12101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33544,
    lat: 28.25132,
    lng: -82.37039,
    city: "Wesley Chapel",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28417,
    density: 381.6,
    county_fips: 12101,
    county_name: "Pasco",
    county_weights: {
      12101: 100,
    },
    county_names_all: "Pasco",
    county_fips_all: 12101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33545,
    lat: 28.26578,
    lng: -82.28832,
    city: "Wesley Chapel",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22515,
    density: 326.9,
    county_fips: 12101,
    county_name: "Pasco",
    county_weights: {
      12101: 100,
    },
    county_names_all: "Pasco",
    county_fips_all: 12101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33547,
    lat: 27.77239,
    lng: -82.13665,
    city: "Lithia",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25676,
    density: 61.7,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 97.54,
      12105: 2.46,
    },
    county_names_all: "Hillsborough|Polk",
    county_fips_all: "12057|12105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33548,
    lat: 28.13788,
    lng: -82.48184,
    city: "Lutz",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7335,
    density: 371.9,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 96.46,
      12101: 3.54,
    },
    county_names_all: "Hillsborough|Pasco",
    county_fips_all: "12057|12101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33549,
    lat: 28.1392,
    lng: -82.44624,
    city: "Lutz",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18132,
    density: 574.1,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 81.78,
      12101: 18.22,
    },
    county_names_all: "Hillsborough|Pasco",
    county_fips_all: "12057|12101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33550,
    lat: 27.97956,
    lng: -82.30698,
    city: "Mango",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33556,
    lat: 28.17029,
    lng: -82.59264,
    city: "Odessa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23679,
    density: 151.6,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 55.85,
      12101: 44.15,
    },
    county_names_all: "Hillsborough|Pasco",
    county_fips_all: "12057|12101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33558,
    lat: 28.15871,
    lng: -82.51597,
    city: "Lutz",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25429,
    density: 541.6,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 65.3,
      12101: 34.7,
    },
    county_names_all: "Hillsborough|Pasco",
    county_fips_all: "12057|12101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33559,
    lat: 28.15788,
    lng: -82.41007,
    city: "Lutz",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18744,
    density: 605.7,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 58.49,
      12101: 41.51,
    },
    county_names_all: "Hillsborough|Pasco",
    county_fips_all: "12057|12101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33563,
    lat: 28.01694,
    lng: -82.12544,
    city: "Plant City",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27807,
    density: 711.6,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33565,
    lat: 28.08858,
    lng: -82.15595,
    city: "Plant City",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17922,
    density: 88.3,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33566,
    lat: 27.99241,
    lng: -82.1172,
    city: "Plant City",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21920,
    density: 357.5,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33567,
    lat: 27.92159,
    lng: -82.1217,
    city: "Plant City",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12349,
    density: 114.6,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33569,
    lat: 27.84429,
    lng: -82.29069,
    city: "Riverview",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28342,
    density: 785.8,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33570,
    lat: 27.69354,
    lng: -82.45861,
    city: "Ruskin",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29576,
    density: 273.1,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33572,
    lat: 27.7659,
    lng: -82.39999,
    city: "Apollo Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21889,
    density: 646.4,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33573,
    lat: 27.72179,
    lng: -82.36,
    city: "Sun City Center",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25132,
    density: 577.6,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33574,
    lat: 28.33811,
    lng: -82.257,
    city: "Saint Leo",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12101,
    county_name: "Pasco",
    county_weights: {
      12101: 100,
    },
    county_names_all: "Pasco",
    county_fips_all: 12101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33576,
    lat: 28.32472,
    lng: -82.31682,
    city: "San Antonio",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4512,
    density: 84.1,
    county_fips: 12101,
    county_name: "Pasco",
    county_weights: {
      12101: 100,
    },
    county_names_all: "Pasco",
    county_fips_all: 12101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33578,
    lat: 27.86187,
    lng: -82.34775,
    city: "Riverview",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54143,
    density: 1026,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33579,
    lat: 27.79585,
    lng: -82.28376,
    city: "Riverview",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37920,
    density: 677.9,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33584,
    lat: 28.00637,
    lng: -82.28959,
    city: "Seffner",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27006,
    density: 543.3,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33585,
    lat: 28.74089,
    lng: -82.03347,
    city: "Sumterville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1060,
    density: 11.6,
    county_fips: 12119,
    county_name: "Sumter",
    county_weights: {
      12119: 100,
    },
    county_names_all: "Sumter",
    county_fips_all: 12119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33592,
    lat: 28.10087,
    lng: -82.28698,
    city: "Thonotosassa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11706,
    density: 85.1,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33594,
    lat: 27.94081,
    lng: -82.24207,
    city: "Valrico",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36685,
    density: 1384.4,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33596,
    lat: 27.88765,
    lng: -82.23591,
    city: "Valrico",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31000,
    density: 1053.3,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33597,
    lat: 28.52675,
    lng: -82.08613,
    city: "Webster",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9075,
    density: 22.7,
    county_fips: 12119,
    county_name: "Sumter",
    county_weights: {
      12053: 23.2,
      12101: 21.27,
      12119: 55.53,
    },
    county_names_all: "Sumter|Hernando|Pasco",
    county_fips_all: "12119|12053|12101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33598,
    lat: 27.69531,
    lng: -82.29025,
    city: "Wimauma",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22776,
    density: 104.4,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 92.49,
      12081: 7.51,
    },
    county_names_all: "Hillsborough|Manatee",
    county_fips_all: "12057|12081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33602,
    lat: 27.95371,
    lng: -82.45675,
    city: "Tampa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15860,
    density: 2362.8,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33603,
    lat: 27.98526,
    lng: -82.46458,
    city: "Tampa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21084,
    density: 1970.3,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33604,
    lat: 28.01686,
    lng: -82.45519,
    city: "Tampa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40309,
    density: 2084.2,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33605,
    lat: 27.95121,
    lng: -82.42924,
    city: "Tampa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17945,
    density: 884,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33606,
    lat: 27.93209,
    lng: -82.46493,
    city: "Tampa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21789,
    density: 2567.7,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33607,
    lat: 27.96677,
    lng: -82.51408,
    city: "Tampa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25018,
    density: 1041.2,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33609,
    lat: 27.94307,
    lng: -82.51108,
    city: "Tampa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18972,
    density: 1832.7,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33610,
    lat: 27.9972,
    lng: -82.38015,
    city: "Tampa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48490,
    density: 1040.1,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33611,
    lat: 27.89059,
    lng: -82.50632,
    city: "Tampa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34615,
    density: 2127.1,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33612,
    lat: 28.05071,
    lng: -82.451,
    city: "Tampa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51347,
    density: 1993.6,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33613,
    lat: 28.08344,
    lng: -82.44873,
    city: "Tampa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36388,
    density: 1886,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33614,
    lat: 28.00619,
    lng: -82.50598,
    city: "Tampa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49652,
    density: 1968.3,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33615,
    lat: 28.00546,
    lng: -82.58144,
    city: "Tampa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49048,
    density: 2211.8,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33616,
    lat: 27.86712,
    lng: -82.5287,
    city: "Tampa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15373,
    density: 1511.4,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33617,
    lat: 28.03893,
    lng: -82.39327,
    city: "Tampa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48456,
    density: 2117.3,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33618,
    lat: 28.07313,
    lng: -82.49781,
    city: "Tampa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28544,
    density: 1305.9,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33619,
    lat: 27.93536,
    lng: -82.37841,
    city: "Tampa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40257,
    density: 565.8,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33620,
    lat: 28.06112,
    lng: -82.41172,
    city: "Tampa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5286,
    density: 2337.1,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33621,
    lat: 27.8436,
    lng: -82.50089,
    city: "Tampa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2655,
    density: 123.5,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33624,
    lat: 28.07903,
    lng: -82.52608,
    city: "Tampa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39750,
    density: 1688.8,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33625,
    lat: 28.06807,
    lng: -82.56016,
    city: "Tampa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28619,
    density: 1222.1,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33626,
    lat: 28.06256,
    lng: -82.61526,
    city: "Tampa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29337,
    density: 923.2,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33629,
    lat: 27.92181,
    lng: -82.51007,
    city: "Tampa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27059,
    density: 2171.8,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33634,
    lat: 28.00769,
    lng: -82.54614,
    city: "Tampa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23071,
    density: 1055.6,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33635,
    lat: 28.02408,
    lng: -82.61882,
    city: "Tampa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19590,
    density: 1186.6,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33637,
    lat: 28.04715,
    lng: -82.36118,
    city: "Tampa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17919,
    density: 883.1,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33647,
    lat: 28.13401,
    lng: -82.36017,
    city: "Tampa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74066,
    density: 883,
    county_fips: 12057,
    county_name: "Hillsborough",
    county_weights: {
      12057: 100,
    },
    county_names_all: "Hillsborough",
    county_fips_all: 12057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33701,
    lat: 27.7705,
    lng: -82.63566,
    city: "Saint Petersburg",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16632,
    density: 2409.2,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33702,
    lat: 27.84567,
    lng: -82.63251,
    city: "Saint Petersburg",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32968,
    density: 1227,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33703,
    lat: 27.81756,
    lng: -82.62433,
    city: "Saint Petersburg",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26980,
    density: 2076.4,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33704,
    lat: 27.79666,
    lng: -82.63292,
    city: "Saint Petersburg",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17202,
    density: 1941,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33705,
    lat: 27.73641,
    lng: -82.64265,
    city: "Saint Petersburg",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28013,
    density: 1937.6,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33706,
    lat: 27.74396,
    lng: -82.75014,
    city: "Saint Petersburg",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16404,
    density: 1732,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33707,
    lat: 27.74913,
    lng: -82.72293,
    city: "Saint Petersburg",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25148,
    density: 1838.7,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33708,
    lat: 27.81192,
    lng: -82.7933,
    city: "Saint Petersburg",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15377,
    density: 1743,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33709,
    lat: 27.81721,
    lng: -82.73075,
    city: "Saint Petersburg",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23690,
    density: 1786.4,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33710,
    lat: 27.7898,
    lng: -82.73069,
    city: "Saint Petersburg",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35695,
    density: 1728.7,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33711,
    lat: 27.73884,
    lng: -82.68845,
    city: "Saint Petersburg",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19291,
    density: 1583.6,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33712,
    lat: 27.73719,
    lng: -82.66535,
    city: "Saint Petersburg",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24802,
    density: 1496.8,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33713,
    lat: 27.78882,
    lng: -82.67753,
    city: "Saint Petersburg",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32084,
    density: 1895.3,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33714,
    lat: 27.81696,
    lng: -82.67794,
    city: "Saint Petersburg",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21049,
    density: 2225.6,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33715,
    lat: 27.66323,
    lng: -82.72214,
    city: "Saint Petersburg",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8010,
    density: 814.2,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33716,
    lat: 27.8774,
    lng: -82.65119,
    city: "Saint Petersburg",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18243,
    density: 983.4,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33744,
    lat: 27.8084,
    lng: -82.77451,
    city: "Bay Pines",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 101,
    density: 66.8,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33755,
    lat: 27.9793,
    lng: -82.78007,
    city: "Clearwater",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26937,
    density: 1901.7,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33756,
    lat: 27.94421,
    lng: -82.79216,
    city: "Clearwater",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32554,
    density: 1742.9,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33759,
    lat: 27.98095,
    lng: -82.7145,
    city: "Clearwater",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18303,
    density: 1339.3,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33760,
    lat: 27.90535,
    lng: -82.71389,
    city: "Clearwater",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18438,
    density: 1263.6,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33761,
    lat: 28.03103,
    lng: -82.72511,
    city: "Clearwater",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19239,
    density: 1468.3,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33762,
    lat: 27.89685,
    lng: -82.67946,
    city: "Clearwater",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8542,
    density: 465,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33763,
    lat: 28.00298,
    lng: -82.74347,
    city: "Clearwater",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19987,
    density: 2301.1,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33764,
    lat: 27.93679,
    lng: -82.7424,
    city: "Clearwater",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27273,
    density: 1667.8,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33765,
    lat: 27.97452,
    lng: -82.74419,
    city: "Clearwater",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15076,
    density: 1393.6,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33767,
    lat: 27.97022,
    lng: -82.82329,
    city: "Clearwater Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7493,
    density: 1441.2,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33770,
    lat: 27.91477,
    lng: -82.8035,
    city: "Largo",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26979,
    density: 2003.4,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33771,
    lat: 27.90585,
    lng: -82.7583,
    city: "Largo",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29868,
    density: 1925.7,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33772,
    lat: 27.84286,
    lng: -82.79666,
    city: "Seminole",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23413,
    density: 1713,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33773,
    lat: 27.88156,
    lng: -82.75594,
    city: "Largo",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17290,
    density: 1320.2,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33774,
    lat: 27.88275,
    lng: -82.8278,
    city: "Largo",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19270,
    density: 1622.5,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33776,
    lat: 27.84975,
    lng: -82.82634,
    city: "Seminole",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13043,
    density: 1487,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33777,
    lat: 27.85257,
    lng: -82.76026,
    city: "Seminole",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17186,
    density: 1206,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33778,
    lat: 27.88266,
    lng: -82.79843,
    city: "Largo",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15836,
    density: 1625,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33781,
    lat: 27.83861,
    lng: -82.71512,
    city: "Pinellas Park",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26265,
    density: 1542.9,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33782,
    lat: 27.85964,
    lng: -82.70901,
    city: "Pinellas Park",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23671,
    density: 1696.7,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33785,
    lat: 27.88559,
    lng: -82.84425,
    city: "Indian Rocks Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5501,
    density: 1802.2,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33786,
    lat: 27.92385,
    lng: -82.83635,
    city: "Belleair Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1568,
    density: 1129.1,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33801,
    lat: 28.0401,
    lng: -81.8947,
    city: "Lakeland",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34406,
    density: 701.8,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33803,
    lat: 28.00887,
    lng: -81.93604,
    city: "Lakeland",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29875,
    density: 695.2,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33805,
    lat: 28.09829,
    lng: -81.91279,
    city: "Lakeland",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26189,
    density: 389.5,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33809,
    lat: 28.20291,
    lng: -81.96597,
    city: "Lakeland",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30646,
    density: 179.7,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12101: 0.17,
      12105: 99.83,
    },
    county_names_all: "Polk|Pasco",
    county_fips_all: "12105|12101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33810,
    lat: 28.13027,
    lng: -82.03989,
    city: "Lakeland",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51595,
    density: 308.2,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12057: 26.82,
      12105: 73.18,
    },
    county_names_all: "Polk|Hillsborough",
    county_fips_all: "12105|12057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33811,
    lat: 27.97933,
    lng: -82.01866,
    city: "Lakeland",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23623,
    density: 338.6,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33812,
    lat: 27.97262,
    lng: -81.89304,
    city: "Lakeland",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13478,
    density: 538,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33813,
    lat: 27.94789,
    lng: -81.92701,
    city: "Lakeland",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38080,
    density: 700.2,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33815,
    lat: 28.04067,
    lng: -81.99634,
    city: "Lakeland",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15265,
    density: 798.5,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33823,
    lat: 28.09041,
    lng: -81.81267,
    city: "Auburndale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35712,
    density: 395,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33825,
    lat: 27.62704,
    lng: -81.44343,
    city: "Avon Park",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28151,
    density: 96.4,
    county_fips: 12055,
    county_name: "Highlands",
    county_weights: {
      12055: 65.77,
      12105: 34.23,
    },
    county_names_all: "Highlands|Polk",
    county_fips_all: "12055|12105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33827,
    lat: 27.81445,
    lng: -81.51484,
    city: "Babson Park",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3022,
    density: 36.7,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33830,
    lat: 27.88234,
    lng: -81.80565,
    city: "Bartow",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30242,
    density: 96.9,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33834,
    lat: 27.62778,
    lng: -81.92115,
    city: "Bowling Green",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7451,
    density: 21.4,
    county_fips: 12049,
    county_name: "Hardee",
    county_weights: {
      12049: 65.8,
      12105: 34.2,
    },
    county_names_all: "Hardee|Polk",
    county_fips_all: "12049|12105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33835,
    lat: 27.78829,
    lng: -81.97256,
    city: "Bradley",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33837,
    lat: 28.19012,
    lng: -81.59163,
    city: "Davenport",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32185,
    density: 242,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33838,
    lat: 28.01851,
    lng: -81.60956,
    city: "Dundee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4552,
    density: 239.8,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33839,
    lat: 27.97481,
    lng: -81.75365,
    city: "Eagle Lake",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3565,
    density: 439.3,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33840,
    lat: 28.00915,
    lng: -81.90506,
    city: "Eaton Park",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33841,
    lat: 27.7381,
    lng: -81.7674,
    city: "Fort Meade",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9650,
    density: 22.1,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33843,
    lat: 27.73131,
    lng: -81.5108,
    city: "Frostproof",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11976,
    density: 37.3,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33844,
    lat: 28.08616,
    lng: -81.58717,
    city: "Haines City",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40078,
    density: 159.2,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33847,
    lat: 27.80864,
    lng: -81.82381,
    city: "Homeland",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 154,
    density: 66.4,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33848,
    lat: 28.27594,
    lng: -81.50824,
    city: "Intercession City",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 908,
    density: 32.1,
    county_fips: 12097,
    county_name: "Osceola",
    county_weights: {
      12097: 100,
    },
    county_names_all: "Osceola",
    county_fips_all: 12097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33849,
    lat: 28.21613,
    lng: -82.07414,
    city: "Kathleen",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 728,
    density: 12.5,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12101: 1.72,
      12105: 98.28,
    },
    county_names_all: "Polk|Pasco",
    county_fips_all: "12105|12101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33850,
    lat: 28.11886,
    lng: -81.73191,
    city: "Lake Alfred",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8608,
    density: 198.4,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33851,
    lat: 28.04439,
    lng: -81.62677,
    city: "Lake Hamilton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1245,
    density: 369.7,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33852,
    lat: 27.25904,
    lng: -81.37844,
    city: "Lake Placid",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20839,
    density: 27.4,
    county_fips: 12055,
    county_name: "Highlands",
    county_weights: {
      12055: 100,
    },
    county_names_all: "Highlands",
    county_fips_all: 12055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33853,
    lat: 27.90023,
    lng: -81.58556,
    city: "Lake Wales",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11674,
    density: 520.4,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33854,
    lat: 27.85608,
    lng: -81.41033,
    city: "Lakeshore",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 366,
    density: 898.5,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33855,
    lat: 27.79104,
    lng: -81.35971,
    city: "Indian Lake Estates",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33856,
    lat: 27.85648,
    lng: -81.42828,
    city: "Nalcrest",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 299,
    density: 1051.2,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33857,
    lat: 27.35647,
    lng: -81.16517,
    city: "Lorida",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1710,
    density: 4.4,
    county_fips: 12055,
    county_name: "Highlands",
    county_weights: {
      12055: 100,
    },
    county_names_all: "Highlands",
    county_fips_all: 12055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33858,
    lat: 28.24506,
    lng: -81.55832,
    city: "Loughman",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12097: 0.13,
      12105: 99.87,
    },
    county_names_all: "Polk|Osceola",
    county_fips_all: "12105|12097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33859,
    lat: 27.88428,
    lng: -81.63106,
    city: "Lake Wales",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10987,
    density: 93.3,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33860,
    lat: 27.8056,
    lng: -81.99511,
    city: "Mulberry",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28372,
    density: 111.3,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12057: 1.31,
      12105: 98.69,
    },
    county_names_all: "Polk|Hillsborough",
    county_fips_all: "12105|12057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33865,
    lat: 27.42944,
    lng: -81.96262,
    city: "Ona",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1130,
    density: 2.6,
    county_fips: 12049,
    county_name: "Hardee",
    county_weights: {
      12027: 2.96,
      12049: 97.04,
    },
    county_names_all: "Hardee|DeSoto",
    county_fips_all: "12049|12027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33867,
    lat: 27.78249,
    lng: -81.20136,
    city: "River Ranch",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 148,
    density: 12.8,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12097: 0.15,
      12105: 99.85,
    },
    county_names_all: "Polk|Osceola",
    county_fips_all: "12105|12097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33868,
    lat: 28.25882,
    lng: -81.84769,
    city: "Polk City",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13051,
    density: 27.6,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33870,
    lat: 27.50571,
    lng: -81.36071,
    city: "Sebring",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22664,
    density: 91.9,
    county_fips: 12055,
    county_name: "Highlands",
    county_weights: {
      12055: 100,
    },
    county_names_all: "Highlands",
    county_fips_all: 12055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33872,
    lat: 27.50911,
    lng: -81.53147,
    city: "Sebring",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15740,
    density: 267.4,
    county_fips: 12055,
    county_name: "Highlands",
    county_weights: {
      12055: 100,
    },
    county_names_all: "Highlands",
    county_fips_all: 12055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33873,
    lat: 27.56181,
    lng: -81.77855,
    city: "Wauchula",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13394,
    density: 41.5,
    county_fips: 12049,
    county_name: "Hardee",
    county_weights: {
      12049: 100,
    },
    county_names_all: "Hardee",
    county_fips_all: 12049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33875,
    lat: 27.41813,
    lng: -81.49198,
    city: "Sebring",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10787,
    density: 78,
    county_fips: 12055,
    county_name: "Highlands",
    county_weights: {
      12055: 100,
    },
    county_names_all: "Highlands",
    county_fips_all: 12055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33876,
    lat: 27.4269,
    lng: -81.35086,
    city: "Sebring",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5808,
    density: 71.5,
    county_fips: 12055,
    county_name: "Highlands",
    county_weights: {
      12055: 100,
    },
    county_names_all: "Highlands",
    county_fips_all: 12055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33877,
    lat: 27.98766,
    lng: -81.61985,
    city: "Waverly",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 529,
    density: 97.5,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33880,
    lat: 27.9914,
    lng: -81.77448,
    city: "Winter Haven",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42268,
    density: 503.9,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33881,
    lat: 28.05439,
    lng: -81.70081,
    city: "Winter Haven",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33577,
    density: 591.7,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33884,
    lat: 27.97669,
    lng: -81.67653,
    city: "Winter Haven",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33008,
    density: 511.1,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12105: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 12105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33890,
    lat: 27.4558,
    lng: -81.68354,
    city: "Zolfo Springs",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5274,
    density: 8,
    county_fips: 12049,
    county_name: "Hardee",
    county_weights: {
      12049: 100,
    },
    county_names_all: "Hardee",
    county_fips_all: 12049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33896,
    lat: 28.24663,
    lng: -81.57526,
    city: "Davenport",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13735,
    density: 262.5,
    county_fips: 12097,
    county_name: "Osceola",
    county_weights: {
      12097: 63.46,
      12105: 36.54,
    },
    county_names_all: "Osceola|Polk",
    county_fips_all: "12097|12105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33897,
    lat: 28.28088,
    lng: -81.69533,
    city: "Davenport",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22769,
    density: 210.3,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12097: 0.97,
      12105: 99.03,
    },
    county_names_all: "Polk|Osceola",
    county_fips_all: "12105|12097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33898,
    lat: 27.83946,
    lng: -81.34943,
    city: "Lake Wales",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16829,
    density: 21.9,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12097: 12.88,
      12105: 87.12,
    },
    county_names_all: "Polk|Osceola",
    county_fips_all: "12105|12097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33901,
    lat: 26.62304,
    lng: -81.88228,
    city: "Fort Myers",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22907,
    density: 1416.9,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33903,
    lat: 26.68217,
    lng: -81.90688,
    city: "North Fort Myers",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22616,
    density: 770.8,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33904,
    lat: 26.57601,
    lng: -81.94536,
    city: "Cape Coral",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31388,
    density: 1245.4,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33905,
    lat: 26.66873,
    lng: -81.76166,
    city: "Fort Myers",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38304,
    density: 368.2,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33907,
    lat: 26.56447,
    lng: -81.87171,
    city: "Fort Myers",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25813,
    density: 1357.4,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33908,
    lat: 26.48857,
    lng: -81.91319,
    city: "Fort Myers",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35798,
    density: 403.8,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33909,
    lat: 26.72032,
    lng: -81.96443,
    city: "Cape Coral",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32183,
    density: 328.5,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33912,
    lat: 26.53288,
    lng: -81.82502,
    city: "Fort Myers",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20037,
    density: 364.6,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33913,
    lat: 26.51718,
    lng: -81.69712,
    city: "Fort Myers",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26232,
    density: 100.3,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33914,
    lat: 26.57052,
    lng: -82.01944,
    city: "Cape Coral",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40422,
    density: 696.2,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33916,
    lat: 26.63998,
    lng: -81.84104,
    city: "Fort Myers",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26013,
    density: 976.9,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33917,
    lat: 26.75403,
    lng: -81.84779,
    city: "North Fort Myers",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30270,
    density: 178.3,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12015: 26.78,
      12071: 73.22,
    },
    county_names_all: "Lee|Charlotte",
    county_fips_all: "12071|12015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33919,
    lat: 26.55607,
    lng: -81.90388,
    city: "Fort Myers",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30485,
    density: 1345.4,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33920,
    lat: 26.72903,
    lng: -81.6529,
    city: "Alva",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6709,
    density: 41.7,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33921,
    lat: 26.77919,
    lng: -82.25386,
    city: "Boca Grande",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 947,
    density: 132.4,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12015: 28.61,
      12071: 71.39,
    },
    county_names_all: "Lee|Charlotte",
    county_fips_all: "12071|12015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33922,
    lat: 26.66476,
    lng: -82.15897,
    city: "Bokeelia",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4057,
    density: 75.1,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33924,
    lat: 26.54521,
    lng: -82.19832,
    city: "Captiva",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 181,
    density: 25.2,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33928,
    lat: 26.43545,
    lng: -81.71002,
    city: "Estero",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26303,
    density: 243.7,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33930,
    lat: 26.55916,
    lng: -81.40069,
    city: "Felda",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 631,
    density: 2.2,
    county_fips: 12051,
    county_name: "Hendry",
    county_weights: {
      12051: 100,
    },
    county_names_all: "Hendry",
    county_fips_all: 12051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33931,
    lat: 26.44036,
    lng: -81.90974,
    city: "Fort Myers Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10984,
    density: 412.1,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33935,
    lat: 26.75692,
    lng: -81.41966,
    city: "Labelle",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23872,
    density: 25.4,
    county_fips: 12051,
    county_name: "Hendry",
    county_weights: {
      12043: 41.71,
      12051: 58.29,
    },
    county_names_all: "Hendry|Glades",
    county_fips_all: "12051|12043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33936,
    lat: 26.6292,
    lng: -81.5602,
    city: "Lehigh Acres",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26157,
    density: 279.4,
    county_fips: 12051,
    county_name: "Hendry",
    county_weights: {
      12051: 67.55,
      12071: 32.45,
    },
    county_names_all: "Hendry|Lee",
    county_fips_all: "12051|12071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33944,
    lat: 26.97163,
    lng: -81.36924,
    city: "Palmdale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 415,
    density: 3.5,
    county_fips: 12043,
    county_name: "Glades",
    county_weights: {
      12043: 100,
    },
    county_names_all: "Glades",
    county_fips_all: 12043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33946,
    lat: 26.853,
    lng: -82.26958,
    city: "Placida",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2368,
    density: 85,
    county_fips: 12015,
    county_name: "Charlotte",
    county_weights: {
      12015: 100,
    },
    county_names_all: "Charlotte",
    county_fips_all: 12015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33947,
    lat: 26.89015,
    lng: -82.27184,
    city: "Rotonda West",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9455,
    density: 274.6,
    county_fips: 12015,
    county_name: "Charlotte",
    county_weights: {
      12015: 100,
    },
    county_names_all: "Charlotte",
    county_fips_all: 12015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33948,
    lat: 26.98411,
    lng: -82.15126,
    city: "Port Charlotte",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18322,
    density: 545.5,
    county_fips: 12015,
    county_name: "Charlotte",
    county_weights: {
      12015: 100,
    },
    county_names_all: "Charlotte",
    county_fips_all: 12015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33950,
    lat: 26.91166,
    lng: -82.04009,
    city: "Punta Gorda",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23948,
    density: 518.1,
    county_fips: 12015,
    county_name: "Charlotte",
    county_weights: {
      12015: 100,
    },
    county_names_all: "Charlotte",
    county_fips_all: 12015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33952,
    lat: 26.99008,
    lng: -82.0972,
    city: "Port Charlotte",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35285,
    density: 1235.7,
    county_fips: 12015,
    county_name: "Charlotte",
    county_weights: {
      12015: 100,
    },
    county_names_all: "Charlotte",
    county_fips_all: 12015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33953,
    lat: 26.99991,
    lng: -82.21222,
    city: "Port Charlotte",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6408,
    density: 153.3,
    county_fips: 12015,
    county_name: "Charlotte",
    county_weights: {
      12015: 100,
    },
    county_names_all: "Charlotte",
    county_fips_all: 12015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33954,
    lat: 27.02506,
    lng: -82.12167,
    city: "Port Charlotte",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9876,
    density: 442.9,
    county_fips: 12015,
    county_name: "Charlotte",
    county_weights: {
      12015: 100,
    },
    county_names_all: "Charlotte",
    county_fips_all: 12015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33955,
    lat: 26.82528,
    lng: -81.97007,
    city: "Punta Gorda",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10645,
    density: 52.4,
    county_fips: 12015,
    county_name: "Charlotte",
    county_weights: {
      12015: 98.33,
      12071: 1.67,
    },
    county_names_all: "Charlotte|Lee",
    county_fips_all: "12015|12071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33956,
    lat: 26.54622,
    lng: -82.09589,
    city: "Saint James City",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3510,
    density: 83.2,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33957,
    lat: 26.4534,
    lng: -82.10228,
    city: "Sanibel",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7378,
    density: 175.6,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33960,
    lat: 27.07709,
    lng: -81.41682,
    city: "Venus",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 586,
    density: 0.9,
    county_fips: 12055,
    county_name: "Highlands",
    county_weights: {
      12043: 27.36,
      12055: 72.64,
    },
    county_names_all: "Highlands|Glades",
    county_fips_all: "12055|12043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33965,
    lat: 26.46126,
    lng: -81.76862,
    city: "Fort Myers",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1359,
    density: 217.6,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33966,
    lat: 26.58234,
    lng: -81.83206,
    city: "Fort Myers",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9576,
    density: 422.2,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33967,
    lat: 26.47226,
    lng: -81.81231,
    city: "Fort Myers",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26277,
    density: 1327.4,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33971,
    lat: 26.63856,
    lng: -81.69948,
    city: "Lehigh Acres",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28101,
    density: 639.1,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33972,
    lat: 26.64954,
    lng: -81.61721,
    city: "Lehigh Acres",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15656,
    density: 239.2,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33973,
    lat: 26.6014,
    lng: -81.73012,
    city: "Lehigh Acres",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16595,
    density: 1686.6,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33974,
    lat: 26.56205,
    lng: -81.60271,
    city: "Lehigh Acres",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19304,
    density: 332.9,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33976,
    lat: 26.59128,
    lng: -81.68543,
    city: "Lehigh Acres",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16933,
    density: 704.6,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33980,
    lat: 26.98062,
    lng: -82.05206,
    city: "Punta Gorda",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13461,
    density: 567.7,
    county_fips: 12015,
    county_name: "Charlotte",
    county_weights: {
      12015: 100,
    },
    county_names_all: "Charlotte",
    county_fips_all: 12015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33981,
    lat: 26.87544,
    lng: -82.21047,
    city: "Port Charlotte",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12009,
    density: 102,
    county_fips: 12015,
    county_name: "Charlotte",
    county_weights: {
      12015: 100,
    },
    county_names_all: "Charlotte",
    county_fips_all: 12015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33982,
    lat: 26.91587,
    lng: -81.75753,
    city: "Punta Gorda",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11553,
    density: 11,
    county_fips: 12015,
    county_name: "Charlotte",
    county_weights: {
      12015: 100,
    },
    county_names_all: "Charlotte",
    county_fips_all: 12015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33983,
    lat: 27.00712,
    lng: -82.01508,
    city: "Punta Gorda",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15161,
    density: 550.5,
    county_fips: 12015,
    county_name: "Charlotte",
    county_weights: {
      12015: 100,
    },
    county_names_all: "Charlotte",
    county_fips_all: 12015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33990,
    lat: 26.62875,
    lng: -81.94602,
    city: "Cape Coral",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35396,
    density: 1462.1,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33991,
    lat: 26.63074,
    lng: -82.01065,
    city: "Cape Coral",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23620,
    density: 711.7,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 33993,
    lat: 26.67194,
    lng: -82.04522,
    city: "Cape Coral",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29328,
    density: 259.3,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34101,
    lat: 26.05694,
    lng: -81.78056,
    city: "Naples",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 12021,
    county_name: "Collier",
    county_weights: {
      12021: 100,
    },
    county_names_all: "Collier",
    county_fips_all: 12021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34102,
    lat: 26.13783,
    lng: -81.79654,
    city: "Naples",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11930,
    density: 815.9,
    county_fips: 12021,
    county_name: "Collier",
    county_weights: {
      12021: 100,
    },
    county_names_all: "Collier",
    county_fips_all: 12021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34103,
    lat: 26.19197,
    lng: -81.80207,
    city: "Naples",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12848,
    density: 1278.4,
    county_fips: 12021,
    county_name: "Collier",
    county_weights: {
      12021: 100,
    },
    county_names_all: "Collier",
    county_fips_all: 12021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34104,
    lat: 26.15321,
    lng: -81.74214,
    city: "Naples",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24106,
    density: 944.3,
    county_fips: 12021,
    county_name: "Collier",
    county_weights: {
      12021: 100,
    },
    county_names_all: "Collier",
    county_fips_all: 12021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34105,
    lat: 26.18938,
    lng: -81.7626,
    city: "Naples",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16185,
    density: 658.8,
    county_fips: 12021,
    county_name: "Collier",
    county_weights: {
      12021: 100,
    },
    county_names_all: "Collier",
    county_fips_all: 12021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34108,
    lat: 26.24533,
    lng: -81.80694,
    city: "Naples",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17177,
    density: 846.3,
    county_fips: 12021,
    county_name: "Collier",
    county_weights: {
      12021: 100,
    },
    county_names_all: "Collier",
    county_fips_all: 12021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34109,
    lat: 26.24073,
    lng: -81.76365,
    city: "Naples",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26562,
    density: 819.6,
    county_fips: 12021,
    county_name: "Collier",
    county_weights: {
      12021: 100,
    },
    county_names_all: "Collier",
    county_fips_all: 12021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34110,
    lat: 26.29619,
    lng: -81.78505,
    city: "Naples",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24713,
    density: 595.7,
    county_fips: 12021,
    county_name: "Collier",
    county_weights: {
      12021: 94.99,
      12071: 5.01,
    },
    county_names_all: "Collier|Lee",
    county_fips_all: "12021|12071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34112,
    lat: 26.12053,
    lng: -81.73908,
    city: "Naples",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28702,
    density: 746.6,
    county_fips: 12021,
    county_name: "Collier",
    county_weights: {
      12021: 100,
    },
    county_names_all: "Collier",
    county_fips_all: 12021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34113,
    lat: 26.05685,
    lng: -81.73523,
    city: "Naples",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22573,
    density: 336.8,
    county_fips: 12021,
    county_name: "Collier",
    county_weights: {
      12021: 100,
    },
    county_names_all: "Collier",
    county_fips_all: 12021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34114,
    lat: 25.98902,
    lng: -81.58517,
    city: "Naples",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17856,
    density: 39,
    county_fips: 12021,
    county_name: "Collier",
    county_weights: {
      12021: 100,
    },
    county_names_all: "Collier",
    county_fips_all: 12021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34116,
    lat: 26.18816,
    lng: -81.71058,
    city: "Naples",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37138,
    density: 1544.3,
    county_fips: 12021,
    county_name: "Collier",
    county_weights: {
      12021: 100,
    },
    county_names_all: "Collier",
    county_fips_all: 12021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34117,
    lat: 26.11864,
    lng: -81.548,
    city: "Naples",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20129,
    density: 56.6,
    county_fips: 12021,
    county_name: "Collier",
    county_weights: {
      12021: 100,
    },
    county_names_all: "Collier",
    county_fips_all: 12021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34119,
    lat: 26.26658,
    lng: -81.71493,
    city: "Naples",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31355,
    density: 536.9,
    county_fips: 12021,
    county_name: "Collier",
    county_weights: {
      12021: 97.94,
      12071: 2.06,
    },
    county_names_all: "Collier|Lee",
    county_fips_all: "12021|12071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34120,
    lat: 26.31382,
    lng: -81.58344,
    city: "Naples",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34431,
    density: 94.4,
    county_fips: 12021,
    county_name: "Collier",
    county_weights: {
      12021: 100,
    },
    county_names_all: "Collier",
    county_fips_all: 12021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34134,
    lat: 26.36634,
    lng: -81.83503,
    city: "Bonita Springs",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15208,
    density: 436.8,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12021: 10.48,
      12071: 89.52,
    },
    county_names_all: "Lee|Collier",
    county_fips_all: "12071|12021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34135,
    lat: 26.36923,
    lng: -81.73303,
    city: "Bonita Springs",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49455,
    density: 309.1,
    county_fips: 12071,
    county_name: "Lee",
    county_weights: {
      12071: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 12071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34137,
    lat: 26.03542,
    lng: -81.40757,
    city: "Copeland",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12021,
    county_name: "Collier",
    county_weights: {
      12021: 100,
    },
    county_names_all: "Collier",
    county_fips_all: 12021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34138,
    lat: 25.82255,
    lng: -81.37084,
    city: "Chokoloskee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1136,
    density: 1574,
    county_fips: 12021,
    county_name: "Collier",
    county_weights: {
      12021: 99.79,
      12087: 0.21,
    },
    county_names_all: "Collier|Monroe",
    county_fips_all: "12021|12087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34139,
    lat: 25.85449,
    lng: -81.38253,
    city: "Everglades City",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 247,
    density: 66.4,
    county_fips: 12021,
    county_name: "Collier",
    county_weights: {
      12021: 100,
    },
    county_names_all: "Collier",
    county_fips_all: 12021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34140,
    lat: 25.92531,
    lng: -81.65888,
    city: "Goodland",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 217,
    density: 63,
    county_fips: 12021,
    county_name: "Collier",
    county_weights: {
      12021: 100,
    },
    county_names_all: "Collier",
    county_fips_all: 12021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34141,
    lat: 25.91774,
    lng: -81.07706,
    city: "Ochopee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 110,
    density: 0,
    county_fips: 12021,
    county_name: "Collier",
    county_weights: {
      12021: 74.99,
      12086: 4.67,
      12087: 20.34,
    },
    county_names_all: "Collier|Monroe|Miami-Dade",
    county_fips_all: "12021|12087|12086",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34142,
    lat: 26.31392,
    lng: -81.28601,
    city: "Immokalee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33029,
    density: 20.4,
    county_fips: 12021,
    county_name: "Collier",
    county_weights: {
      12021: 82.25,
      12051: 17.75,
    },
    county_names_all: "Collier|Hendry",
    county_fips_all: "12021|12051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34145,
    lat: 25.91903,
    lng: -81.69506,
    city: "Marco Island",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17963,
    density: 426.4,
    county_fips: 12021,
    county_name: "Collier",
    county_weights: {
      12021: 100,
    },
    county_names_all: "Collier",
    county_fips_all: 12021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34201,
    lat: 27.4029,
    lng: -82.46784,
    city: "Bradenton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3729,
    density: 420.8,
    county_fips: 12081,
    county_name: "Manatee",
    county_weights: {
      12081: 100,
    },
    county_names_all: "Manatee",
    county_fips_all: 12081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34202,
    lat: 27.40722,
    lng: -82.39254,
    city: "Bradenton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23759,
    density: 397.1,
    county_fips: 12081,
    county_name: "Manatee",
    county_weights: {
      12081: 100,
    },
    county_names_all: "Manatee",
    county_fips_all: 12081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34203,
    lat: 27.44319,
    lng: -82.50834,
    city: "Bradenton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39350,
    density: 981.9,
    county_fips: 12081,
    county_name: "Manatee",
    county_weights: {
      12081: 100,
    },
    county_names_all: "Manatee",
    county_fips_all: 12081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34205,
    lat: 27.48418,
    lng: -82.5835,
    city: "Bradenton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31871,
    density: 1905.7,
    county_fips: 12081,
    county_name: "Manatee",
    county_weights: {
      12081: 100,
    },
    county_names_all: "Manatee",
    county_fips_all: 12081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34207,
    lat: 27.43762,
    lng: -82.57993,
    city: "Bradenton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36677,
    density: 2296.1,
    county_fips: 12081,
    county_name: "Manatee",
    county_weights: {
      12081: 100,
    },
    county_names_all: "Manatee",
    county_fips_all: 12081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34208,
    lat: 27.48693,
    lng: -82.51404,
    city: "Bradenton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43397,
    density: 1016.5,
    county_fips: 12081,
    county_name: "Manatee",
    county_weights: {
      12081: 100,
    },
    county_names_all: "Manatee",
    county_fips_all: 12081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34209,
    lat: 27.49489,
    lng: -82.6433,
    city: "Bradenton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35148,
    density: 1075.1,
    county_fips: 12081,
    county_name: "Manatee",
    county_weights: {
      12081: 100,
    },
    county_names_all: "Manatee",
    county_fips_all: 12081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34210,
    lat: 27.43897,
    lng: -82.63117,
    city: "Bradenton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16799,
    density: 729.9,
    county_fips: 12081,
    county_name: "Manatee",
    county_weights: {
      12081: 100,
    },
    county_names_all: "Manatee",
    county_fips_all: 12081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34211,
    lat: 27.44944,
    lng: -82.37738,
    city: "Bradenton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10897,
    density: 123.6,
    county_fips: 12081,
    county_name: "Manatee",
    county_weights: {
      12081: 100,
    },
    county_names_all: "Manatee",
    county_fips_all: 12081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34212,
    lat: 27.49559,
    lng: -82.40528,
    city: "Bradenton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22119,
    density: 383.7,
    county_fips: 12081,
    county_name: "Manatee",
    county_weights: {
      12081: 100,
    },
    county_names_all: "Manatee",
    county_fips_all: 12081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34215,
    lat: 27.47444,
    lng: -82.68409,
    city: "Cortez",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 633,
    density: 412.7,
    county_fips: 12081,
    county_name: "Manatee",
    county_weights: {
      12081: 100,
    },
    county_names_all: "Manatee",
    county_fips_all: 12081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34216,
    lat: 27.52837,
    lng: -82.7331,
    city: "Anna Maria",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1092,
    density: 490.8,
    county_fips: 12081,
    county_name: "Manatee",
    county_weights: {
      12081: 100,
    },
    county_names_all: "Manatee",
    county_fips_all: 12081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34217,
    lat: 27.48916,
    lng: -82.7044,
    city: "Bradenton Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5178,
    density: 951.8,
    county_fips: 12081,
    county_name: "Manatee",
    county_weights: {
      12081: 100,
    },
    county_names_all: "Manatee",
    county_fips_all: 12081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34219,
    lat: 27.58041,
    lng: -82.26094,
    city: "Parrish",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23970,
    density: 43.9,
    county_fips: 12081,
    county_name: "Manatee",
    county_weights: {
      12081: 100,
    },
    county_names_all: "Manatee",
    county_fips_all: 12081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34221,
    lat: 27.57777,
    lng: -82.54285,
    city: "Palmetto",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50857,
    density: 364.3,
    county_fips: 12081,
    county_name: "Manatee",
    county_weights: {
      12081: 100,
    },
    county_names_all: "Manatee",
    county_fips_all: 12081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34222,
    lat: 27.53474,
    lng: -82.50699,
    city: "Ellenton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12466,
    density: 905.4,
    county_fips: 12081,
    county_name: "Manatee",
    county_weights: {
      12081: 100,
    },
    county_names_all: "Manatee",
    county_fips_all: 12081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34223,
    lat: 26.97963,
    lng: -82.33257,
    city: "Englewood",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18500,
    density: 170.6,
    county_fips: 12115,
    county_name: "Sarasota",
    county_weights: {
      12015: 10.22,
      12115: 89.78,
    },
    county_names_all: "Sarasota|Charlotte",
    county_fips_all: "12115|12015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34224,
    lat: 26.91902,
    lng: -82.30581,
    city: "Englewood",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16369,
    density: 492.1,
    county_fips: 12015,
    county_name: "Charlotte",
    county_weights: {
      12015: 95.16,
      12115: 4.84,
    },
    county_names_all: "Charlotte|Sarasota",
    county_fips_all: "12015|12115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34228,
    lat: 27.39258,
    lng: -82.63407,
    city: "Longboat Key",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7299,
    density: 691,
    county_fips: 12081,
    county_name: "Manatee",
    county_weights: {
      12081: 52.65,
      12115: 47.35,
    },
    county_names_all: "Manatee|Sarasota",
    county_fips_all: "12081|12115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34229,
    lat: 27.19159,
    lng: -82.48309,
    city: "Osprey",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7934,
    density: 514,
    county_fips: 12115,
    county_name: "Sarasota",
    county_weights: {
      12115: 100,
    },
    county_names_all: "Sarasota",
    county_fips_all: 12115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34231,
    lat: 27.26651,
    lng: -82.51626,
    city: "Sarasota",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32762,
    density: 1338.9,
    county_fips: 12115,
    county_name: "Sarasota",
    county_weights: {
      12115: 100,
    },
    county_names_all: "Sarasota",
    county_fips_all: 12115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34232,
    lat: 27.32601,
    lng: -82.47239,
    city: "Sarasota",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35486,
    density: 1241.8,
    county_fips: 12115,
    county_name: "Sarasota",
    county_weights: {
      12115: 100,
    },
    county_names_all: "Sarasota",
    county_fips_all: 12115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34233,
    lat: 27.2836,
    lng: -82.47311,
    city: "Sarasota",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18560,
    density: 1170.8,
    county_fips: 12115,
    county_name: "Sarasota",
    county_weights: {
      12115: 100,
    },
    county_names_all: "Sarasota",
    county_fips_all: 12115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34234,
    lat: 27.36934,
    lng: -82.5574,
    city: "Sarasota",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22330,
    density: 1319.4,
    county_fips: 12115,
    county_name: "Sarasota",
    county_weights: {
      12115: 100,
    },
    county_names_all: "Sarasota",
    county_fips_all: 12115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34235,
    lat: 27.36673,
    lng: -82.47724,
    city: "Sarasota",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14269,
    density: 886.9,
    county_fips: 12115,
    county_name: "Sarasota",
    county_weights: {
      12115: 100,
    },
    county_names_all: "Sarasota",
    county_fips_all: 12115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34236,
    lat: 27.32964,
    lng: -82.55874,
    city: "Sarasota",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13384,
    density: 1453.4,
    county_fips: 12115,
    county_name: "Sarasota",
    county_weights: {
      12115: 100,
    },
    county_names_all: "Sarasota",
    county_fips_all: 12115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34237,
    lat: 27.33761,
    lng: -82.51409,
    city: "Sarasota",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19169,
    density: 1879.1,
    county_fips: 12115,
    county_name: "Sarasota",
    county_weights: {
      12115: 100,
    },
    county_names_all: "Sarasota",
    county_fips_all: 12115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34238,
    lat: 27.23049,
    lng: -82.4687,
    city: "Sarasota",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20095,
    density: 587.7,
    county_fips: 12115,
    county_name: "Sarasota",
    county_weights: {
      12115: 100,
    },
    county_names_all: "Sarasota",
    county_fips_all: 12115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34239,
    lat: 27.31094,
    lng: -82.52179,
    city: "Sarasota",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15178,
    density: 1318.8,
    county_fips: 12115,
    county_name: "Sarasota",
    county_weights: {
      12115: 100,
    },
    county_names_all: "Sarasota",
    county_fips_all: 12115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34240,
    lat: 27.34218,
    lng: -82.35177,
    city: "Sarasota",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12143,
    density: 70.5,
    county_fips: 12115,
    county_name: "Sarasota",
    county_weights: {
      12081: 0.13,
      12115: 99.87,
    },
    county_names_all: "Sarasota|Manatee",
    county_fips_all: "12115|12081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34241,
    lat: 27.24944,
    lng: -82.37305,
    city: "Sarasota",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15222,
    density: 83.8,
    county_fips: 12115,
    county_name: "Sarasota",
    county_weights: {
      12115: 100,
    },
    county_names_all: "Sarasota",
    county_fips_all: 12115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34242,
    lat: 27.26237,
    lng: -82.53997,
    city: "Sarasota",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7643,
    density: 825.3,
    county_fips: 12115,
    county_name: "Sarasota",
    county_weights: {
      12115: 100,
    },
    county_names_all: "Sarasota",
    county_fips_all: 12115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34243,
    lat: 27.40264,
    lng: -82.52809,
    city: "Sarasota",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31700,
    density: 681,
    county_fips: 12081,
    county_name: "Manatee",
    county_weights: {
      12081: 81.77,
      12115: 18.23,
    },
    county_names_all: "Manatee|Sarasota",
    county_fips_all: "12081|12115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34250,
    lat: 27.57168,
    lng: -82.58923,
    city: "Terra Ceia",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12081,
    county_name: "Manatee",
    county_weights: {
      12081: 100,
    },
    county_names_all: "Manatee",
    county_fips_all: 12081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34251,
    lat: 27.37819,
    lng: -82.17152,
    city: "Myakka City",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7586,
    density: 9.8,
    county_fips: 12081,
    county_name: "Manatee",
    county_weights: {
      12081: 99.17,
      12115: 0.83,
    },
    county_names_all: "Manatee|Sarasota",
    county_fips_all: "12081|12115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34266,
    lat: 27.19895,
    lng: -81.80304,
    city: "Arcadia",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31733,
    density: 21.2,
    county_fips: 12027,
    county_name: "DeSoto",
    county_weights: {
      12027: 93.37,
      12115: 6.63,
    },
    county_names_all: "DeSoto|Sarasota",
    county_fips_all: "12027|12115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34267,
    lat: 27.0893,
    lng: -81.9543,
    city: "Fort Ogden",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12027,
    county_name: "DeSoto",
    county_weights: {
      12027: 100,
    },
    county_names_all: "DeSoto",
    county_fips_all: 12027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34268,
    lat: 27.14459,
    lng: -81.91775,
    city: "Nocatee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12027,
    county_name: "DeSoto",
    county_weights: {
      12027: 100,
    },
    county_names_all: "DeSoto",
    county_fips_all: 12027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34269,
    lat: 27.08865,
    lng: -81.9639,
    city: "Arcadia",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5272,
    density: 22.9,
    county_fips: 12027,
    county_name: "DeSoto",
    county_weights: {
      12027: 100,
    },
    county_names_all: "DeSoto",
    county_fips_all: 12027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34275,
    lat: 27.15203,
    lng: -82.41966,
    city: "Nokomis",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20475,
    density: 307.9,
    county_fips: 12115,
    county_name: "Sarasota",
    county_weights: {
      12115: 100,
    },
    county_names_all: "Sarasota",
    county_fips_all: 12115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34285,
    lat: 27.0918,
    lng: -82.43408,
    city: "Venice",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18117,
    density: 839.5,
    county_fips: 12115,
    county_name: "Sarasota",
    county_weights: {
      12115: 100,
    },
    county_names_all: "Sarasota",
    county_fips_all: 12115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34286,
    lat: 27.09099,
    lng: -82.14147,
    city: "North Port",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19700,
    density: 277.2,
    county_fips: 12115,
    county_name: "Sarasota",
    county_weights: {
      12115: 100,
    },
    county_names_all: "Sarasota",
    county_fips_all: 12115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34287,
    lat: 27.05735,
    lng: -82.24677,
    city: "North Port",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27620,
    density: 611.8,
    county_fips: 12115,
    county_name: "Sarasota",
    county_weights: {
      12115: 100,
    },
    county_names_all: "Sarasota",
    county_fips_all: 12115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34288,
    lat: 27.05385,
    lng: -82.11161,
    city: "North Port",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11973,
    density: 239.7,
    county_fips: 12115,
    county_name: "Sarasota",
    county_weights: {
      12115: 100,
    },
    county_names_all: "Sarasota",
    county_fips_all: 12115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34289,
    lat: 27.08587,
    lng: -82.13664,
    city: "North Port",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4097,
    density: 440.7,
    county_fips: 12115,
    county_name: "Sarasota",
    county_weights: {
      12115: 100,
    },
    county_names_all: "Sarasota",
    county_fips_all: 12115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34291,
    lat: 27.11494,
    lng: -82.21722,
    city: "North Port",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6165,
    density: 131.9,
    county_fips: 12115,
    county_name: "Sarasota",
    county_weights: {
      12115: 100,
    },
    county_names_all: "Sarasota",
    county_fips_all: 12115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34292,
    lat: 27.10308,
    lng: -82.33496,
    city: "Venice",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15090,
    density: 179.3,
    county_fips: 12115,
    county_name: "Sarasota",
    county_weights: {
      12115: 100,
    },
    county_names_all: "Sarasota",
    county_fips_all: 12115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34293,
    lat: 27.04642,
    lng: -82.35595,
    city: "Venice",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43988,
    density: 521,
    county_fips: 12115,
    county_name: "Sarasota",
    county_weights: {
      12115: 100,
    },
    county_names_all: "Sarasota",
    county_fips_all: 12115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34420,
    lat: 29.05359,
    lng: -82.04008,
    city: "Belleview",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18592,
    density: 298.3,
    county_fips: 12083,
    county_name: "Marion",
    county_weights: {
      12083: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 12083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34428,
    lat: 28.9608,
    lng: -82.63421,
    city: "Crystal River",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9334,
    density: 53.7,
    county_fips: 12017,
    county_name: "Citrus",
    county_weights: {
      12017: 100,
    },
    county_names_all: "Citrus",
    county_fips_all: 12017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34429,
    lat: 28.85737,
    lng: -82.65152,
    city: "Crystal River",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8439,
    density: 78.7,
    county_fips: 12017,
    county_name: "Citrus",
    county_weights: {
      12017: 100,
    },
    county_names_all: "Citrus",
    county_fips_all: 12017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34431,
    lat: 29.1339,
    lng: -82.52963,
    city: "Dunnellon",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8116,
    density: 30.1,
    county_fips: 12083,
    county_name: "Marion",
    county_weights: {
      12075: 44.94,
      12083: 55.06,
    },
    county_names_all: "Marion|Levy",
    county_fips_all: "12083|12075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34432,
    lat: 29.06588,
    lng: -82.36353,
    city: "Dunnellon",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12793,
    density: 47,
    county_fips: 12083,
    county_name: "Marion",
    county_weights: {
      12083: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 12083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34433,
    lat: 28.996,
    lng: -82.52383,
    city: "Dunnellon",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6998,
    density: 80.2,
    county_fips: 12017,
    county_name: "Citrus",
    county_weights: {
      12017: 100,
    },
    county_names_all: "Citrus",
    county_fips_all: 12017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34434,
    lat: 28.99535,
    lng: -82.43775,
    city: "Dunnellon",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8233,
    density: 120.9,
    county_fips: 12017,
    county_name: "Citrus",
    county_weights: {
      12017: 100,
    },
    county_names_all: "Citrus",
    county_fips_all: 12017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34436,
    lat: 28.72672,
    lng: -82.29134,
    city: "Floral City",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8189,
    density: 57.4,
    county_fips: 12017,
    county_name: "Citrus",
    county_weights: {
      12017: 100,
    },
    county_names_all: "Citrus",
    county_fips_all: 12017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34442,
    lat: 28.93084,
    lng: -82.39122,
    city: "Hernando",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15479,
    density: 164,
    county_fips: 12017,
    county_name: "Citrus",
    county_weights: {
      12017: 100,
    },
    county_names_all: "Citrus",
    county_fips_all: 12017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34445,
    lat: 28.97143,
    lng: -82.42414,
    city: "Holder",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 12017,
    county_name: "Citrus",
    county_weights: {
      12017: 100,
    },
    county_names_all: "Citrus",
    county_fips_all: 12017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34446,
    lat: 28.74904,
    lng: -82.52344,
    city: "Homosassa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17878,
    density: 231.3,
    county_fips: 12017,
    county_name: "Citrus",
    county_weights: {
      12017: 100,
    },
    county_names_all: "Citrus",
    county_fips_all: 12017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34448,
    lat: 28.77009,
    lng: -82.61201,
    city: "Homosassa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10140,
    density: 54.1,
    county_fips: 12017,
    county_name: "Citrus",
    county_weights: {
      12017: 100,
    },
    county_names_all: "Citrus",
    county_fips_all: 12017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34449,
    lat: 29.10451,
    lng: -82.68694,
    city: "Inglis",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3650,
    density: 10.8,
    county_fips: 12075,
    county_name: "Levy",
    county_weights: {
      12017: 7.03,
      12075: 92.97,
    },
    county_names_all: "Levy|Citrus",
    county_fips_all: "12075|12017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34450,
    lat: 28.82699,
    lng: -82.25767,
    city: "Inverness",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11074,
    density: 137.1,
    county_fips: 12017,
    county_name: "Citrus",
    county_weights: {
      12017: 100,
    },
    county_names_all: "Citrus",
    county_fips_all: 12017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34452,
    lat: 28.76231,
    lng: -82.37986,
    city: "Inverness",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12538,
    density: 82.1,
    county_fips: 12017,
    county_name: "Citrus",
    county_weights: {
      12017: 100,
    },
    county_names_all: "Citrus",
    county_fips_all: 12017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34453,
    lat: 28.89276,
    lng: -82.33663,
    city: "Inverness",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10236,
    density: 146,
    county_fips: 12017,
    county_name: "Citrus",
    county_weights: {
      12017: 100,
    },
    county_names_all: "Citrus",
    county_fips_all: 12017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34461,
    lat: 28.81544,
    lng: -82.48029,
    city: "Lecanto",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12154,
    density: 102.6,
    county_fips: 12017,
    county_name: "Citrus",
    county_weights: {
      12017: 100,
    },
    county_names_all: "Citrus",
    county_fips_all: 12017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34465,
    lat: 28.92869,
    lng: -82.49092,
    city: "Beverly Hills",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16652,
    density: 264.4,
    county_fips: 12017,
    county_name: "Citrus",
    county_weights: {
      12017: 100,
    },
    county_names_all: "Citrus",
    county_fips_all: 12017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34470,
    lat: 29.20098,
    lng: -82.08262,
    city: "Ocala",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20000,
    density: 575.5,
    county_fips: 12083,
    county_name: "Marion",
    county_weights: {
      12083: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 12083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34471,
    lat: 29.16054,
    lng: -82.12786,
    city: "Ocala",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24635,
    density: 479.9,
    county_fips: 12083,
    county_name: "Marion",
    county_weights: {
      12083: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 12083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34472,
    lat: 29.11187,
    lng: -81.99625,
    city: "Ocala",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31271,
    density: 332.8,
    county_fips: 12083,
    county_name: "Marion",
    county_weights: {
      12083: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 12083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34473,
    lat: 29.00506,
    lng: -82.18833,
    city: "Ocala",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21424,
    density: 230.8,
    county_fips: 12083,
    county_name: "Marion",
    county_weights: {
      12083: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 12083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34474,
    lat: 29.15515,
    lng: -82.21106,
    city: "Ocala",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17358,
    density: 319.7,
    county_fips: 12083,
    county_name: "Marion",
    county_weights: {
      12083: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 12083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34475,
    lat: 29.25282,
    lng: -82.16065,
    city: "Ocala",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13291,
    density: 184.6,
    county_fips: 12083,
    county_name: "Marion",
    county_weights: {
      12083: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 12083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34476,
    lat: 29.08579,
    lng: -82.19279,
    city: "Ocala",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22857,
    density: 255.2,
    county_fips: 12083,
    county_name: "Marion",
    county_weights: {
      12083: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 12083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34479,
    lat: 29.25285,
    lng: -82.10945,
    city: "Ocala",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13887,
    density: 299.3,
    county_fips: 12083,
    county_name: "Marion",
    county_weights: {
      12083: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 12083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34480,
    lat: 29.10178,
    lng: -82.09975,
    city: "Ocala",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21173,
    density: 232.4,
    county_fips: 12083,
    county_name: "Marion",
    county_weights: {
      12083: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 12083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34481,
    lat: 29.11902,
    lng: -82.30769,
    city: "Ocala",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21462,
    density: 119.7,
    county_fips: 12083,
    county_name: "Marion",
    county_weights: {
      12083: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 12083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34482,
    lat: 29.24984,
    lng: -82.27702,
    city: "Ocala",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23576,
    density: 97.9,
    county_fips: 12083,
    county_name: "Marion",
    county_weights: {
      12083: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 12083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34484,
    lat: 28.93417,
    lng: -82.08867,
    city: "Oxford",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3361,
    density: 40.4,
    county_fips: 12119,
    county_name: "Sumter",
    county_weights: {
      12119: 100,
    },
    county_names_all: "Sumter",
    county_fips_all: 12119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34487,
    lat: 28.78148,
    lng: -82.61272,
    city: "Homosassa",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12017,
    county_name: "Citrus",
    county_weights: {
      12017: 100,
    },
    county_names_all: "Citrus",
    county_fips_all: 12017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34488,
    lat: 29.22584,
    lng: -81.93226,
    city: "Silver Springs",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11472,
    density: 51.7,
    county_fips: 12083,
    county_name: "Marion",
    county_weights: {
      12083: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 12083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34491,
    lat: 28.99634,
    lng: -82.04665,
    city: "Summerfield",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29998,
    density: 257.8,
    county_fips: 12083,
    county_name: "Marion",
    county_weights: {
      12083: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 12083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34498,
    lat: 29.03299,
    lng: -82.734,
    city: "Yankeetown",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 570,
    density: 30,
    county_fips: 12075,
    county_name: "Levy",
    county_weights: {
      12075: 100,
    },
    county_names_all: "Levy",
    county_fips_all: 12075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34601,
    lat: 28.5892,
    lng: -82.36857,
    city: "Brooksville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22644,
    density: 76.7,
    county_fips: 12053,
    county_name: "Hernando",
    county_weights: {
      12017: 0.23,
      12053: 99.77,
    },
    county_names_all: "Hernando|Citrus",
    county_fips_all: "12053|12017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34602,
    lat: 28.50252,
    lng: -82.28007,
    city: "Brooksville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8320,
    density: 48.2,
    county_fips: 12053,
    county_name: "Hernando",
    county_weights: {
      12053: 100,
    },
    county_names_all: "Hernando",
    county_fips_all: 12053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34604,
    lat: 28.4781,
    lng: -82.43322,
    city: "Brooksville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13026,
    density: 138.4,
    county_fips: 12053,
    county_name: "Hernando",
    county_weights: {
      12053: 100,
    },
    county_names_all: "Hernando",
    county_fips_all: 12053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34606,
    lat: 28.46961,
    lng: -82.59759,
    city: "Spring Hill",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27014,
    density: 901.6,
    county_fips: 12053,
    county_name: "Hernando",
    county_weights: {
      12053: 100,
    },
    county_names_all: "Hernando",
    county_fips_all: 12053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34607,
    lat: 28.57528,
    lng: -82.62715,
    city: "Spring Hill",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8666,
    density: 52.5,
    county_fips: 12053,
    county_name: "Hernando",
    county_weights: {
      12053: 100,
    },
    county_names_all: "Hernando",
    county_fips_all: 12053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34608,
    lat: 28.48258,
    lng: -82.5532,
    city: "Spring Hill",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36327,
    density: 920.5,
    county_fips: 12053,
    county_name: "Hernando",
    county_weights: {
      12053: 100,
    },
    county_names_all: "Hernando",
    county_fips_all: 12053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34609,
    lat: 28.4792,
    lng: -82.50818,
    city: "Spring Hill",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43374,
    density: 754.8,
    county_fips: 12053,
    county_name: "Hernando",
    county_weights: {
      12053: 100,
    },
    county_names_all: "Hernando",
    county_fips_all: 12053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34610,
    lat: 28.38339,
    lng: -82.50058,
    city: "Spring Hill",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15679,
    density: 89,
    county_fips: 12101,
    county_name: "Pasco",
    county_weights: {
      12101: 100,
    },
    county_names_all: "Pasco",
    county_fips_all: 12101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34613,
    lat: 28.56183,
    lng: -82.53803,
    city: "Brooksville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17760,
    density: 184.5,
    county_fips: 12053,
    county_name: "Hernando",
    county_weights: {
      12053: 100,
    },
    county_names_all: "Hernando",
    county_fips_all: 12053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34614,
    lat: 28.64627,
    lng: -82.51324,
    city: "Brooksville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7710,
    density: 54.2,
    county_fips: 12053,
    county_name: "Hernando",
    county_weights: {
      12053: 100,
    },
    county_names_all: "Hernando",
    county_fips_all: 12053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34637,
    lat: 28.29589,
    lng: -82.46368,
    city: "Land O'Lakes",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8411,
    density: 219.7,
    county_fips: 12101,
    county_name: "Pasco",
    county_weights: {
      12101: 100,
    },
    county_names_all: "Pasco",
    county_fips_all: 12101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34638,
    lat: 28.26035,
    lng: -82.52036,
    city: "Land O'Lakes",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30182,
    density: 251.8,
    county_fips: 12101,
    county_name: "Pasco",
    county_weights: {
      12101: 100,
    },
    county_names_all: "Pasco",
    county_fips_all: 12101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34639,
    lat: 28.24456,
    lng: -82.42475,
    city: "Land O'Lakes",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29728,
    density: 424.1,
    county_fips: 12101,
    county_name: "Pasco",
    county_weights: {
      12101: 100,
    },
    county_names_all: "Pasco",
    county_fips_all: 12101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34652,
    lat: 28.2368,
    lng: -82.73661,
    city: "New Port Richey",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24549,
    density: 1103.6,
    county_fips: 12101,
    county_name: "Pasco",
    county_weights: {
      12101: 100,
    },
    county_names_all: "Pasco",
    county_fips_all: 12101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34653,
    lat: 28.24266,
    lng: -82.69308,
    city: "New Port Richey",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36166,
    density: 1276.5,
    county_fips: 12101,
    county_name: "Pasco",
    county_weights: {
      12101: 100,
    },
    county_names_all: "Pasco",
    county_fips_all: 12101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34654,
    lat: 28.29757,
    lng: -82.62904,
    city: "New Port Richey",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25182,
    density: 384,
    county_fips: 12101,
    county_name: "Pasco",
    county_weights: {
      12101: 100,
    },
    county_names_all: "Pasco",
    county_fips_all: 12101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34655,
    lat: 28.21201,
    lng: -82.65516,
    city: "New Port Richey",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44192,
    density: 632.5,
    county_fips: 12101,
    county_name: "Pasco",
    county_weights: {
      12101: 100,
    },
    county_names_all: "Pasco",
    county_fips_all: 12101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34661,
    lat: 28.62108,
    lng: -82.26507,
    city: "Nobleton",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 186,
    density: 8,
    county_fips: 12053,
    county_name: "Hernando",
    county_weights: {
      12053: 99.86,
      12119: 0.14,
    },
    county_names_all: "Hernando|Sumter",
    county_fips_all: "12053|12119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34667,
    lat: 28.38926,
    lng: -82.65654,
    city: "Hudson",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32360,
    density: 409.2,
    county_fips: 12101,
    county_name: "Pasco",
    county_weights: {
      12101: 100,
    },
    county_names_all: "Pasco",
    county_fips_all: 12101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34668,
    lat: 28.30176,
    lng: -82.70516,
    city: "Port Richey",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48452,
    density: 1205.7,
    county_fips: 12101,
    county_name: "Pasco",
    county_weights: {
      12101: 100,
    },
    county_names_all: "Pasco",
    county_fips_all: 12101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34669,
    lat: 28.3577,
    lng: -82.61476,
    city: "Hudson",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14022,
    density: 288.9,
    county_fips: 12101,
    county_name: "Pasco",
    county_weights: {
      12101: 100,
    },
    county_names_all: "Pasco",
    county_fips_all: 12101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34677,
    lat: 28.05293,
    lng: -82.67549,
    city: "Oldsmar",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22703,
    density: 692.8,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34679,
    lat: 28.42226,
    lng: -82.67716,
    city: "Aripeka",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12101,
    county_name: "Pasco",
    county_weights: {
      12101: 100,
    },
    county_names_all: "Pasco",
    county_fips_all: 12101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34681,
    lat: 28.0903,
    lng: -82.77801,
    city: "Crystal Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 589,
    density: 313.8,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34683,
    lat: 28.08626,
    lng: -82.76025,
    city: "Palm Harbor",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33699,
    density: 1264.6,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34684,
    lat: 28.08122,
    lng: -82.72779,
    city: "Palm Harbor",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28058,
    density: 1608.4,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34685,
    lat: 28.09995,
    lng: -82.68851,
    city: "Palm Harbor",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17549,
    density: 675.1,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34688,
    lat: 28.14445,
    lng: -82.68543,
    city: "Tarpon Springs",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7779,
    density: 189.6,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34689,
    lat: 28.14971,
    lng: -82.75956,
    city: "Tarpon Springs",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27428,
    density: 1003.7,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34690,
    lat: 28.19228,
    lng: -82.72726,
    city: "Holiday",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11367,
    density: 1280.4,
    county_fips: 12101,
    county_name: "Pasco",
    county_weights: {
      12101: 99.79,
      12103: 0.21,
    },
    county_names_all: "Pasco|Pinellas",
    county_fips_all: "12101|12103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34691,
    lat: 28.19042,
    lng: -82.76603,
    city: "Holiday",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20473,
    density: 1015.4,
    county_fips: 12101,
    county_name: "Pasco",
    county_weights: {
      12101: 99.18,
      12103: 0.82,
    },
    county_names_all: "Pasco|Pinellas",
    county_fips_all: "12101|12103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34695,
    lat: 28.00927,
    lng: -82.69673,
    city: "Safety Harbor",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18442,
    density: 1275.5,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34698,
    lat: 28.03204,
    lng: -82.78433,
    city: "Dunedin",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39317,
    density: 1357.7,
    county_fips: 12103,
    county_name: "Pinellas",
    county_weights: {
      12103: 100,
    },
    county_names_all: "Pinellas",
    county_fips_all: 12103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34705,
    lat: 28.69367,
    lng: -81.71138,
    city: "Astatula",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3010,
    density: 58.5,
    county_fips: 12069,
    county_name: "Lake",
    county_weights: {
      12069: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 12069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34711,
    lat: 28.52724,
    lng: -81.75349,
    city: "Clermont",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61189,
    density: 603.2,
    county_fips: 12069,
    county_name: "Lake",
    county_weights: {
      12069: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 12069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34714,
    lat: 28.40406,
    lng: -81.80132,
    city: "Clermont",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24227,
    density: 75,
    county_fips: 12069,
    county_name: "Lake",
    county_weights: {
      12069: 99.61,
      12105: 0.39,
    },
    county_names_all: "Lake|Polk",
    county_fips_all: "12069|12105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34715,
    lat: 28.6242,
    lng: -81.73019,
    city: "Clermont",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21032,
    density: 257.5,
    county_fips: 12069,
    county_name: "Lake",
    county_weights: {
      12069: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 12069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34729,
    lat: 28.61764,
    lng: -81.69901,
    city: "Ferndale",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 12069,
    county_name: "Lake",
    county_weights: {
      12069: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 12069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34731,
    lat: 28.86788,
    lng: -81.89638,
    city: "Fruitland Park",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16508,
    density: 403.3,
    county_fips: 12069,
    county_name: "Lake",
    county_weights: {
      12069: 99.56,
      12119: 0.44,
    },
    county_names_all: "Lake|Sumter",
    county_fips_all: "12069|12119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34734,
    lat: 28.5376,
    lng: -81.52204,
    city: "Gotha",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4529,
    density: 939.3,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34736,
    lat: 28.57883,
    lng: -81.88844,
    city: "Groveland",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20564,
    density: 69.1,
    county_fips: 12069,
    county_name: "Lake",
    county_weights: {
      12069: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 12069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34737,
    lat: 28.69638,
    lng: -81.80243,
    city: "Howey In The Hills",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3016,
    density: 50.5,
    county_fips: 12069,
    county_name: "Lake",
    county_weights: {
      12069: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 12069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34739,
    lat: 27.92236,
    lng: -81.10762,
    city: "Kenansville",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 551,
    density: 0.5,
    county_fips: 12097,
    county_name: "Osceola",
    county_weights: {
      12097: 100,
    },
    county_names_all: "Osceola",
    county_fips_all: 12097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34741,
    lat: 28.30544,
    lng: -81.42567,
    city: "Kissimmee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48520,
    density: 1251,
    county_fips: 12097,
    county_name: "Osceola",
    county_weights: {
      12097: 100,
    },
    county_names_all: "Osceola",
    county_fips_all: 12097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34743,
    lat: 28.33066,
    lng: -81.35441,
    city: "Kissimmee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45456,
    density: 2543.9,
    county_fips: 12097,
    county_name: "Osceola",
    county_weights: {
      12097: 100,
    },
    county_names_all: "Osceola",
    county_fips_all: 12097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34744,
    lat: 28.2954,
    lng: -81.34675,
    city: "Kissimmee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60555,
    density: 703,
    county_fips: 12097,
    county_name: "Osceola",
    county_weights: {
      12097: 100,
    },
    county_names_all: "Osceola",
    county_fips_all: 12097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34746,
    lat: 28.24233,
    lng: -81.4423,
    city: "Kissimmee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46725,
    density: 409.7,
    county_fips: 12097,
    county_name: "Osceola",
    county_weights: {
      12097: 100,
    },
    county_names_all: "Osceola",
    county_fips_all: 12097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34747,
    lat: 28.31111,
    lng: -81.59107,
    city: "Kissimmee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24445,
    density: 217.4,
    county_fips: 12097,
    county_name: "Osceola",
    county_weights: {
      12095: 5.25,
      12097: 94.75,
    },
    county_names_all: "Osceola|Orange",
    county_fips_all: "12097|12095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34748,
    lat: 28.77366,
    lng: -81.88552,
    city: "Leesburg",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39265,
    density: 384.4,
    county_fips: 12069,
    county_name: "Lake",
    county_weights: {
      12069: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 12069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34753,
    lat: 28.58684,
    lng: -81.89624,
    city: "Mascotte",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6014,
    density: 491.9,
    county_fips: 12069,
    county_name: "Lake",
    county_weights: {
      12069: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 12069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34756,
    lat: 28.58651,
    lng: -81.68214,
    city: "Montverde",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3641,
    density: 154.6,
    county_fips: 12069,
    county_name: "Lake",
    county_weights: {
      12069: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 12069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34758,
    lat: 28.19142,
    lng: -81.4871,
    city: "Kissimmee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44155,
    density: 653.8,
    county_fips: 12097,
    county_name: "Osceola",
    county_weights: {
      12097: 100,
    },
    county_names_all: "Osceola",
    county_fips_all: 12097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34759,
    lat: 28.09113,
    lng: -81.43774,
    city: "Kissimmee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38406,
    density: 196.7,
    county_fips: 12105,
    county_name: "Polk",
    county_weights: {
      12097: 35.4,
      12105: 64.6,
    },
    county_names_all: "Polk|Osceola",
    county_fips_all: "12105|12097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34760,
    lat: 28.55694,
    lng: -81.62916,
    city: "Oakland",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 805,
    density: 555.1,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34761,
    lat: 28.57975,
    lng: -81.53386,
    city: "Ocoee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45749,
    density: 1011.8,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34762,
    lat: 28.75772,
    lng: -81.9152,
    city: "Okahumpka",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 435,
    density: 20,
    county_fips: 12069,
    county_name: "Lake",
    county_weights: {
      12069: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 12069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34769,
    lat: 28.24366,
    lng: -81.29412,
    city: "Saint Cloud",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25524,
    density: 931.5,
    county_fips: 12097,
    county_name: "Osceola",
    county_weights: {
      12097: 100,
    },
    county_names_all: "Osceola",
    county_fips_all: 12097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34771,
    lat: 28.26647,
    lng: -81.11908,
    city: "Saint Cloud",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21715,
    density: 54.3,
    county_fips: 12097,
    county_name: "Osceola",
    county_weights: {
      12097: 100,
    },
    county_names_all: "Osceola",
    county_fips_all: 12097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34772,
    lat: 28.16534,
    lng: -81.27273,
    city: "Saint Cloud",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31830,
    density: 141.5,
    county_fips: 12097,
    county_name: "Osceola",
    county_weights: {
      12097: 100,
    },
    county_names_all: "Osceola",
    county_fips_all: 12097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34773,
    lat: 28.14695,
    lng: -80.99968,
    city: "Saint Cloud",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3883,
    density: 4.9,
    county_fips: 12097,
    county_name: "Osceola",
    county_weights: {
      12097: 100,
    },
    county_names_all: "Osceola",
    county_fips_all: 12097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34785,
    lat: 28.84516,
    lng: -82.06065,
    city: "Wildwood",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37555,
    density: 226,
    county_fips: 12119,
    county_name: "Sumter",
    county_weights: {
      12119: 100,
    },
    county_names_all: "Sumter",
    county_fips_all: 12119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34786,
    lat: 28.48161,
    lng: -81.55501,
    city: "Windermere",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46044,
    density: 896.1,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12095: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 12095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34787,
    lat: 28.48309,
    lng: -81.62833,
    city: "Winter Garden",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74842,
    density: 429.7,
    county_fips: 12095,
    county_name: "Orange",
    county_weights: {
      12069: 16.87,
      12095: 83.13,
    },
    county_names_all: "Orange|Lake",
    county_fips_all: "12095|12069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34788,
    lat: 28.88542,
    lng: -81.79678,
    city: "Leesburg",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19344,
    density: 206.6,
    county_fips: 12069,
    county_name: "Lake",
    county_weights: {
      12069: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 12069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34797,
    lat: 28.73517,
    lng: -81.81813,
    city: "Yalaha",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1455,
    density: 126.1,
    county_fips: 12069,
    county_name: "Lake",
    county_weights: {
      12069: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 12069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34945,
    lat: 27.45219,
    lng: -80.55213,
    city: "Fort Pierce",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5265,
    density: 9.3,
    county_fips: 12111,
    county_name: "St. Lucie",
    county_weights: {
      12111: 100,
    },
    county_names_all: "St. Lucie",
    county_fips_all: 12111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34946,
    lat: 27.50456,
    lng: -80.36106,
    city: "Fort Pierce",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6292,
    density: 159.6,
    county_fips: 12111,
    county_name: "St. Lucie",
    county_weights: {
      12111: 100,
    },
    county_names_all: "St. Lucie",
    county_fips_all: 12111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34947,
    lat: 27.44903,
    lng: -80.37633,
    city: "Fort Pierce",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13399,
    density: 533,
    county_fips: 12111,
    county_name: "St. Lucie",
    county_weights: {
      12111: 100,
    },
    county_names_all: "St. Lucie",
    county_fips_all: 12111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34949,
    lat: 27.4668,
    lng: -80.30417,
    city: "Fort Pierce",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7740,
    density: 318.4,
    county_fips: 12111,
    county_name: "St. Lucie",
    county_weights: {
      12111: 100,
    },
    county_names_all: "St. Lucie",
    county_fips_all: 12111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34950,
    lat: 27.44341,
    lng: -80.32969,
    city: "Fort Pierce",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17039,
    density: 1273.4,
    county_fips: 12111,
    county_name: "St. Lucie",
    county_weights: {
      12111: 100,
    },
    county_names_all: "St. Lucie",
    county_fips_all: 12111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34951,
    lat: 27.52268,
    lng: -80.41783,
    city: "Fort Pierce",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16896,
    density: 268.1,
    county_fips: 12111,
    county_name: "St. Lucie",
    county_weights: {
      12111: 100,
    },
    county_names_all: "St. Lucie",
    county_fips_all: 12111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34952,
    lat: 27.2969,
    lng: -80.29748,
    city: "Port Saint Lucie",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43317,
    density: 678.9,
    county_fips: 12111,
    county_name: "St. Lucie",
    county_weights: {
      12111: 100,
    },
    county_names_all: "St. Lucie",
    county_fips_all: 12111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34953,
    lat: 27.24938,
    lng: -80.38137,
    city: "Port Saint Lucie",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 72636,
    density: 1177,
    county_fips: 12111,
    county_name: "St. Lucie",
    county_weights: {
      12111: 100,
    },
    county_names_all: "St. Lucie",
    county_fips_all: 12111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34956,
    lat: 27.07969,
    lng: -80.50074,
    city: "Indiantown",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10195,
    density: 23.7,
    county_fips: 12085,
    county_name: "Martin",
    county_weights: {
      12085: 100,
    },
    county_names_all: "Martin",
    county_fips_all: 12085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34957,
    lat: 27.28399,
    lng: -80.24252,
    city: "Jensen Beach",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22900,
    density: 540.4,
    county_fips: 12111,
    county_name: "St. Lucie",
    county_weights: {
      12085: 42.32,
      12111: 57.68,
    },
    county_names_all: "St. Lucie|Martin",
    county_fips_all: "12111|12085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34972,
    lat: 27.48016,
    lng: -80.90926,
    city: "Okeechobee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20132,
    density: 9.1,
    county_fips: 12093,
    county_name: "Okeechobee",
    county_weights: {
      12093: 79.81,
      12097: 14.45,
      12111: 5.74,
    },
    county_names_all: "Okeechobee|Osceola|St. Lucie",
    county_fips_all: "12093|12097|12111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34974,
    lat: 27.15062,
    lng: -80.91371,
    city: "Okeechobee",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24871,
    density: 25.5,
    county_fips: 12043,
    county_name: "Glades",
    county_weights: {
      12043: 52.13,
      12055: 9.92,
      12085: 15.53,
      12093: 22.42,
    },
    county_names_all: "Glades|Okeechobee|Martin|Highlands",
    county_fips_all: "12043|12093|12085|12055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34981,
    lat: 27.39329,
    lng: -80.37163,
    city: "Fort Pierce",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5626,
    density: 201.8,
    county_fips: 12111,
    county_name: "St. Lucie",
    county_weights: {
      12111: 100,
    },
    county_names_all: "St. Lucie",
    county_fips_all: 12111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34982,
    lat: 27.37669,
    lng: -80.31082,
    city: "Fort Pierce",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26034,
    density: 648.5,
    county_fips: 12111,
    county_name: "St. Lucie",
    county_weights: {
      12111: 100,
    },
    county_names_all: "St. Lucie",
    county_fips_all: 12111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34983,
    lat: 27.32295,
    lng: -80.35052,
    city: "Port Saint Lucie",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44005,
    density: 1137.9,
    county_fips: 12111,
    county_name: "St. Lucie",
    county_weights: {
      12111: 100,
    },
    county_names_all: "St. Lucie",
    county_fips_all: 12111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34984,
    lat: 27.24784,
    lng: -80.33456,
    city: "Port Saint Lucie",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17072,
    density: 672.8,
    county_fips: 12111,
    county_name: "St. Lucie",
    county_weights: {
      12111: 100,
    },
    county_names_all: "St. Lucie",
    county_fips_all: 12111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34986,
    lat: 27.32804,
    lng: -80.40524,
    city: "Port Saint Lucie",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28354,
    density: 583.2,
    county_fips: 12111,
    county_name: "St. Lucie",
    county_weights: {
      12111: 100,
    },
    county_names_all: "St. Lucie",
    county_fips_all: 12111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34987,
    lat: 27.28637,
    lng: -80.50953,
    city: "Port Saint Lucie",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10816,
    density: 36.5,
    county_fips: 12111,
    county_name: "St. Lucie",
    county_weights: {
      12111: 100,
    },
    county_names_all: "St. Lucie",
    county_fips_all: 12111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34990,
    lat: 27.13623,
    lng: -80.35655,
    city: "Palm City",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30138,
    density: 112.9,
    county_fips: 12085,
    county_name: "Martin",
    county_weights: {
      12085: 97.47,
      12111: 2.53,
    },
    county_names_all: "Martin|St. Lucie",
    county_fips_all: "12085|12111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34994,
    lat: 27.19954,
    lng: -80.2557,
    city: "Stuart",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17782,
    density: 1019,
    county_fips: 12085,
    county_name: "Martin",
    county_weights: {
      12085: 100,
    },
    county_names_all: "Martin",
    county_fips_all: 12085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34996,
    lat: 27.20071,
    lng: -80.19644,
    city: "Stuart",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11287,
    density: 649,
    county_fips: 12085,
    county_name: "Martin",
    county_weights: {
      12085: 100,
    },
    county_names_all: "Martin",
    county_fips_all: 12085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 34997,
    lat: 27.05085,
    lng: -80.27268,
    city: "Stuart",
    state_id: "FL",
    state_name: "Florida",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45382,
    density: 193.2,
    county_fips: 12085,
    county_name: "Martin",
    county_weights: {
      12085: 100,
    },
    county_names_all: "Martin",
    county_fips_all: 12085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 35004,
    lat: 33.60369,
    lng: -86.49333,
    city: "Moody",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11944,
    density: 267.5,
    county_fips: "01115",
    county_name: "St. Clair",
    county_weights: {
      "01115": 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: "01115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35005,
    lat: 33.59215,
    lng: -86.99833,
    city: "Adamsville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8815,
    density: 107.2,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35006,
    lat: 33.43159,
    lng: -87.19961,
    city: "Adger",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3170,
    density: 11.8,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 95.12,
      "01127": 2.88,
      "01125": 2,
    },
    county_names_all: "Jefferson|Walker|Tuscaloosa",
    county_fips_all: "01073|01127|01125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35007,
    lat: 33.21751,
    lng: -86.79307,
    city: "Alabaster",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26510,
    density: 262.1,
    county_fips: "01117",
    county_name: "Shelby",
    county_weights: {
      "01117": 100,
    },
    county_names_all: "Shelby",
    county_fips_all: "01117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35010,
    lat: 32.91433,
    lng: -85.93816,
    city: "Alexander City",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20208,
    density: 35,
    county_fips: "01123",
    county_name: "Tallapoosa",
    county_weights: {
      "01123": 75.53,
      "01037": 18.23,
      "01051": 6.24,
    },
    county_names_all: "Tallapoosa|Coosa|Elmore",
    county_fips_all: "01123|01037|01051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35013,
    lat: 33.90166,
    lng: -86.51785,
    city: "Allgood",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 72,
    density: 988.2,
    county_fips: "01009",
    county_name: "Blount",
    county_weights: {
      "01009": 100,
    },
    county_names_all: "Blount",
    county_fips_all: "01009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35014,
    lat: 33.36097,
    lng: -86.25909,
    city: "Alpine",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4803,
    density: 23.5,
    county_fips: "01121",
    county_name: "Talladega",
    county_weights: {
      "01121": 100,
    },
    county_names_all: "Talladega",
    county_fips_all: "01121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35016,
    lat: 34.32545,
    lng: -86.5033,
    city: "Arab",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17066,
    density: 83.4,
    county_fips: "01095",
    county_name: "Marshall",
    county_weights: {
      "01095": 68.69,
      "01043": 21.19,
      "01009": 5.6,
      "01103": 4.52,
    },
    county_names_all: "Marshall|Cullman|Blount|Morgan",
    county_fips_all: "01095|01043|01009|01103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35019,
    lat: 34.29828,
    lng: -86.63496,
    city: "Baileyton",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2007,
    density: 27.4,
    county_fips: "01043",
    county_name: "Cullman",
    county_weights: {
      "01043": 63.29,
      "01103": 36.71,
    },
    county_names_all: "Cullman|Morgan",
    county_fips_all: "01043|01103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35020,
    lat: 33.40502,
    lng: -86.95436,
    city: "Bessemer",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24821,
    density: 578.9,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35022,
    lat: 33.33107,
    lng: -86.95959,
    city: "Bessemer",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20684,
    density: 124.5,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 93.68,
      "01117": 6.32,
    },
    county_names_all: "Jefferson|Shelby",
    county_fips_all: "01073|01117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35023,
    lat: 33.46674,
    lng: -87.08891,
    city: "Bessemer",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23633,
    density: 99.5,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35031,
    lat: 34.10256,
    lng: -86.5455,
    city: "Blountsville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7460,
    density: 22.1,
    county_fips: "01009",
    county_name: "Blount",
    county_weights: {
      "01009": 100,
    },
    county_names_all: "Blount",
    county_fips_all: "01009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35032,
    lat: 33.26321,
    lng: -86.33408,
    city: "Bon Air",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41,
    density: 282.5,
    county_fips: "01121",
    county_name: "Talladega",
    county_weights: {
      "01121": 100,
    },
    county_names_all: "Talladega",
    county_fips_all: "01121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35033,
    lat: 33.94517,
    lng: -87.02904,
    city: "Bremen",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2860,
    density: 14.8,
    county_fips: "01043",
    county_name: "Cullman",
    county_weights: {
      "01043": 88.17,
      "01127": 11.83,
    },
    county_names_all: "Cullman|Walker",
    county_fips_all: "01043|01127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35034,
    lat: 32.9016,
    lng: -87.26948,
    city: "Brent",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6907,
    density: 23.1,
    county_fips: "01007",
    county_name: "Bibb",
    county_weights: {
      "01007": 88.32,
      "01105": 11.68,
    },
    county_names_all: "Bibb|Perry",
    county_fips_all: "01007|01105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35035,
    lat: 33.04423,
    lng: -86.97149,
    city: "Brierfield",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 959,
    density: 5.2,
    county_fips: "01007",
    county_name: "Bibb",
    county_weights: {
      "01007": 94.43,
      "01117": 5.57,
    },
    county_names_all: "Bibb|Shelby",
    county_fips_all: "01007|01117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35036,
    lat: 33.64095,
    lng: -86.91601,
    city: "Brookside",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 255,
    density: 1764.2,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35040,
    lat: 33.10487,
    lng: -86.72958,
    city: "Calera",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17611,
    density: 87.3,
    county_fips: "01117",
    county_name: "Shelby",
    county_weights: {
      "01117": 83.29,
      "01021": 16.71,
    },
    county_names_all: "Shelby|Chilton",
    county_fips_all: "01117|01021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35042,
    lat: 32.93297,
    lng: -87.12542,
    city: "Centreville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5732,
    density: 11.5,
    county_fips: "01007",
    county_name: "Bibb",
    county_weights: {
      "01007": 83.01,
      "01105": 16.99,
    },
    county_names_all: "Bibb|Perry",
    county_fips_all: "01007|01105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35043,
    lat: 33.30926,
    lng: -86.66028,
    city: "Chelsea",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13297,
    density: 111.1,
    county_fips: "01117",
    county_name: "Shelby",
    county_weights: {
      "01117": 100,
    },
    county_names_all: "Shelby",
    county_fips_all: "01117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35044,
    lat: 33.26859,
    lng: -86.36324,
    city: "Childersburg",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7149,
    density: 38.4,
    county_fips: "01121",
    county_name: "Talladega",
    county_weights: {
      "01121": 100,
    },
    county_names_all: "Talladega",
    county_fips_all: "01121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35045,
    lat: 32.81127,
    lng: -86.67249,
    city: "Clanton",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14383,
    density: 49.2,
    county_fips: "01021",
    county_name: "Chilton",
    county_weights: {
      "01021": 100,
    },
    county_names_all: "Chilton",
    county_fips_all: "01021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35046,
    lat: 32.923,
    lng: -86.54127,
    city: "Clanton",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5002,
    density: 14.1,
    county_fips: "01021",
    county_name: "Chilton",
    county_weights: {
      "01021": 76.96,
      "01037": 23.04,
    },
    county_names_all: "Chilton|Coosa",
    county_fips_all: "01021|01037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35049,
    lat: 33.95674,
    lng: -86.59904,
    city: "Cleveland",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3914,
    density: 36.3,
    county_fips: "01009",
    county_name: "Blount",
    county_weights: {
      "01009": 100,
    },
    county_names_all: "Blount",
    county_fips_all: "01009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35051,
    lat: 33.20457,
    lng: -86.61523,
    city: "Columbiana",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9609,
    density: 36.6,
    county_fips: "01117",
    county_name: "Shelby",
    county_weights: {
      "01117": 100,
    },
    county_names_all: "Shelby",
    county_fips_all: "01117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35052,
    lat: 33.59228,
    lng: -86.40771,
    city: "Cook Springs",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 257,
    density: 296.7,
    county_fips: "01115",
    county_name: "St. Clair",
    county_weights: {
      "01115": 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: "01115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35053,
    lat: 34.05495,
    lng: -87.06527,
    city: "Crane Hill",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2457,
    density: 19.2,
    county_fips: "01043",
    county_name: "Cullman",
    county_weights: {
      "01043": 90.97,
      "01133": 9.03,
    },
    county_names_all: "Cullman|Winston",
    county_fips_all: "01043|01133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35054,
    lat: 33.50417,
    lng: -86.32693,
    city: "Cropwell",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4459,
    density: 76.2,
    county_fips: "01115",
    county_name: "St. Clair",
    county_weights: {
      "01115": 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: "01115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35055,
    lat: 34.1542,
    lng: -86.75932,
    city: "Cullman",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21535,
    density: 130.3,
    county_fips: "01043",
    county_name: "Cullman",
    county_weights: {
      "01043": 100,
    },
    county_names_all: "Cullman",
    county_fips_all: "01043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35057,
    lat: 34.13788,
    lng: -86.95876,
    city: "Cullman",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14535,
    density: 43.9,
    county_fips: "01043",
    county_name: "Cullman",
    county_weights: {
      "01043": 100,
    },
    county_names_all: "Cullman",
    county_fips_all: "01043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35058,
    lat: 34.23082,
    lng: -86.73265,
    city: "Cullman",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9216,
    density: 47.3,
    county_fips: "01043",
    county_name: "Cullman",
    county_weights: {
      "01043": 100,
    },
    county_names_all: "Cullman",
    county_fips_all: "01043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35060,
    lat: 33.55768,
    lng: -86.92822,
    city: "Docena",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 187,
    density: 210.4,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35061,
    lat: 33.47529,
    lng: -86.9469,
    city: "Dolomite",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1593,
    density: 161.8,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35062,
    lat: 33.72862,
    lng: -87.02775,
    city: "Dora",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8347,
    density: 68.6,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 65.13,
      "01127": 34.87,
    },
    county_names_all: "Jefferson|Walker",
    county_fips_all: "01073|01127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35063,
    lat: 33.8221,
    lng: -87.00765,
    city: "Empire",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3130,
    density: 30.2,
    county_fips: "01127",
    county_name: "Walker",
    county_weights: {
      "01127": 87.64,
      "01009": 9.19,
      "01073": 3.17,
    },
    county_names_all: "Walker|Blount|Jefferson",
    county_fips_all: "01127|01009|01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35064,
    lat: 33.47474,
    lng: -86.91964,
    city: "Fairfield",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10858,
    density: 1167,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35068,
    lat: 33.60933,
    lng: -86.83174,
    city: "Fultondale",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8431,
    density: 265.7,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35070,
    lat: 34.01394,
    lng: -86.74443,
    city: "Garden City",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 298,
    density: 653.6,
    county_fips: "01043",
    county_name: "Cullman",
    county_weights: {
      "01043": 100,
    },
    county_names_all: "Cullman",
    county_fips_all: "01043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35071,
    lat: 33.70376,
    lng: -86.84286,
    city: "Gardendale",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15591,
    density: 104.3,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35072,
    lat: 33.08985,
    lng: -86.06057,
    city: "Goodwater",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4835,
    density: 10.2,
    county_fips: "01037",
    county_name: "Coosa",
    county_weights: {
      "01037": 46.66,
      "01027": 42.07,
      "01123": 11.11,
      "01121": 0.16,
    },
    county_names_all: "Coosa|Clay|Tallapoosa|Talladega",
    county_fips_all: "01037|01027|01123|01121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35073,
    lat: 33.65377,
    lng: -86.98051,
    city: "Graysville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2544,
    density: 33.3,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35074,
    lat: 33.22235,
    lng: -87.12415,
    city: "Green Pond",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 91,
    density: 630.2,
    county_fips: "01007",
    county_name: "Bibb",
    county_weights: {
      "01007": 100,
    },
    county_names_all: "Bibb",
    county_fips_all: "01007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35077,
    lat: 34.01984,
    lng: -86.83108,
    city: "Hanceville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13935,
    density: 35.8,
    county_fips: "01043",
    county_name: "Cullman",
    county_weights: {
      "01043": 100,
    },
    county_names_all: "Cullman",
    county_fips_all: "01043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35078,
    lat: 33.32279,
    lng: -86.44116,
    city: "Harpersville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2057,
    density: 18.4,
    county_fips: "01117",
    county_name: "Shelby",
    county_weights: {
      "01117": 100,
    },
    county_names_all: "Shelby",
    county_fips_all: "01117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35079,
    lat: 33.94118,
    lng: -86.75261,
    city: "Hayden",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9398,
    density: 33.1,
    county_fips: "01009",
    county_name: "Blount",
    county_weights: {
      "01009": 100,
    },
    county_names_all: "Blount",
    county_fips_all: "01009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35080,
    lat: 33.25508,
    lng: -86.91894,
    city: "Helena",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19047,
    density: 159.4,
    county_fips: "01117",
    county_name: "Shelby",
    county_weights: {
      "01117": 99.51,
      "01073": 0.49,
    },
    county_names_all: "Shelby|Jefferson",
    county_fips_all: "01117|01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35082,
    lat: 33.1563,
    lng: -86.15456,
    city: "Hollins",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "01027",
    county_name: "Clay",
    county_weights: {
      "01027": 100,
    },
    county_names_all: "Clay",
    county_fips_all: "01027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35083,
    lat: 34.19718,
    lng: -86.5931,
    city: "Holly Pond",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3394,
    density: 40.3,
    county_fips: "01043",
    county_name: "Cullman",
    county_weights: {
      "01043": 100,
    },
    county_names_all: "Cullman",
    county_fips_all: "01043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35085,
    lat: 32.97975,
    lng: -86.73584,
    city: "Jemison",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8479,
    density: 31.5,
    county_fips: "01021",
    county_name: "Chilton",
    county_weights: {
      "01021": 100,
    },
    county_names_all: "Chilton",
    county_fips_all: "01021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35087,
    lat: 34.30556,
    lng: -86.58252,
    city: "Joppa",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2684,
    density: 45.4,
    county_fips: "01043",
    county_name: "Cullman",
    county_weights: {
      "01043": 48.41,
      "01103": 38.46,
      "01095": 13.13,
    },
    county_names_all: "Cullman|Morgan|Marshall",
    county_fips_all: "01043|01103|01095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35089,
    lat: 32.9426,
    lng: -86.07457,
    city: "Kellyton",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1776,
    density: 11.2,
    county_fips: "01037",
    county_name: "Coosa",
    county_weights: {
      "01037": 81.8,
      "01123": 18.2,
    },
    county_names_all: "Coosa|Tallapoosa",
    county_fips_all: "01037|01123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35091,
    lat: 33.78344,
    lng: -86.78963,
    city: "Kimberly",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3179,
    density: 157.5,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35094,
    lat: 33.52057,
    lng: -86.56127,
    city: "Leeds",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15392,
    density: 101.2,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 52.07,
      "01117": 33.26,
      "01115": 14.67,
    },
    county_names_all: "Jefferson|Shelby|St. Clair",
    county_fips_all: "01073|01117|01115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35096,
    lat: 33.62141,
    lng: -86.10849,
    city: "Lincoln",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8695,
    density: 42.7,
    county_fips: "01121",
    county_name: "Talladega",
    county_weights: {
      "01121": 89.25,
      "01015": 10.75,
    },
    county_names_all: "Talladega|Calhoun",
    county_fips_all: "01121|01015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35097,
    lat: 33.89871,
    lng: -86.62526,
    city: "Locust Fork",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1900,
    density: 92.9,
    county_fips: "01009",
    county_name: "Blount",
    county_weights: {
      "01009": 100,
    },
    county_names_all: "Blount",
    county_fips_all: "01009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35098,
    lat: 34.12779,
    lng: -87.04626,
    city: "Logan",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 928,
    density: 12.1,
    county_fips: "01043",
    county_name: "Cullman",
    county_weights: {
      "01043": 83.32,
      "01133": 16.68,
    },
    county_names_all: "Cullman|Winston",
    county_fips_all: "01043|01133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35111,
    lat: 33.28309,
    lng: -87.09002,
    city: "McCalla",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17512,
    density: 109,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 54.26,
      "01125": 42.85,
      "01007": 2.89,
    },
    county_names_all: "Jefferson|Tuscaloosa|Bibb",
    county_fips_all: "01073|01125|01007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35112,
    lat: 33.69374,
    lng: -86.47248,
    city: "Margaret",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 198,
    density: 71.3,
    county_fips: "01115",
    county_name: "St. Clair",
    county_weights: {
      "01115": 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: "01115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35114,
    lat: 33.22274,
    lng: -86.86739,
    city: "Alabaster",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8170,
    density: 297.7,
    county_fips: "01117",
    county_name: "Shelby",
    county_weights: {
      "01117": 100,
    },
    county_names_all: "Shelby",
    county_fips_all: "01117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35115,
    lat: 33.12133,
    lng: -86.89605,
    city: "Montevallo",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16737,
    density: 52.4,
    county_fips: "01117",
    county_name: "Shelby",
    county_weights: {
      "01117": 70.2,
      "01021": 18.03,
      "01007": 11.77,
    },
    county_names_all: "Shelby|Chilton|Bibb",
    county_fips_all: "01117|01021|01007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35116,
    lat: 33.73167,
    lng: -86.76819,
    city: "Morris",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4768,
    density: 81.8,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35117,
    lat: 33.67085,
    lng: -86.89678,
    city: "Mount Olive",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5203,
    density: 68.9,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35118,
    lat: 33.53916,
    lng: -87.05212,
    city: "Mulga",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3157,
    density: 33.7,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35119,
    lat: 33.63809,
    lng: -86.77864,
    city: "New Castle",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 138,
    density: 318.9,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35120,
    lat: 33.66777,
    lng: -86.42064,
    city: "Odenville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16072,
    density: 87.7,
    county_fips: "01115",
    county_name: "St. Clair",
    county_weights: {
      "01115": 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: "01115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35121,
    lat: 33.9397,
    lng: -86.454,
    city: "Oneonta",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16542,
    density: 44.2,
    county_fips: "01009",
    county_name: "Blount",
    county_weights: {
      "01009": 97.13,
      "01115": 2.11,
      "01055": 0.76,
    },
    county_names_all: "Blount|St. Clair|Etowah",
    county_fips_all: "01009|01115|01055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35124,
    lat: 33.31368,
    lng: -86.76194,
    city: "Pelham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24044,
    density: 217.7,
    county_fips: "01117",
    county_name: "Shelby",
    county_weights: {
      "01117": 100,
    },
    county_names_all: "Shelby",
    county_fips_all: "01117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35125,
    lat: 33.62567,
    lng: -86.29594,
    city: "Pell City",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10945,
    density: 89.2,
    county_fips: "01115",
    county_name: "St. Clair",
    county_weights: {
      "01115": 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: "01115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35126,
    lat: 33.73071,
    lng: -86.65385,
    city: "Pinson",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20761,
    density: 133.3,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 96.57,
      "01009": 3.43,
    },
    county_names_all: "Jefferson|Blount",
    county_fips_all: "01073|01009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35127,
    lat: 33.49118,
    lng: -86.97581,
    city: "Pleasant Grove",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9625,
    density: 366.9,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35128,
    lat: 33.54738,
    lng: -86.34596,
    city: "Pell City",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10859,
    density: 60.1,
    county_fips: "01115",
    county_name: "St. Clair",
    county_weights: {
      "01115": 98.19,
      "01117": 1.81,
    },
    county_names_all: "St. Clair|Shelby",
    county_fips_all: "01115|01117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35130,
    lat: 33.63235,
    lng: -87.13313,
    city: "Quinton",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3421,
    density: 19.7,
    county_fips: "01127",
    county_name: "Walker",
    county_weights: {
      "01127": 56.03,
      "01073": 43.97,
    },
    county_names_all: "Walker|Jefferson",
    county_fips_all: "01127|01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35131,
    lat: 33.72062,
    lng: -86.19965,
    city: "Ragland",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3784,
    density: 20.6,
    county_fips: "01115",
    county_name: "St. Clair",
    county_weights: {
      "01115": 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: "01115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35133,
    lat: 33.81969,
    lng: -86.59878,
    city: "Remlap",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3295,
    density: 26.2,
    county_fips: "01009",
    county_name: "Blount",
    county_weights: {
      "01009": 92.32,
      "01115": 7.68,
    },
    county_names_all: "Blount|St. Clair",
    county_fips_all: "01009|01115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35135,
    lat: 33.61814,
    lng: -86.1991,
    city: "Riverside",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1820,
    density: 98.2,
    county_fips: "01115",
    county_name: "St. Clair",
    county_weights: {
      "01115": 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: "01115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35136,
    lat: 32.87877,
    lng: -86.28965,
    city: "Rockford",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2047,
    density: 3.6,
    county_fips: "01037",
    county_name: "Coosa",
    county_weights: {
      "01037": 100,
    },
    county_names_all: "Coosa",
    county_fips_all: "01037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35143,
    lat: 33.08797,
    lng: -86.55369,
    city: "Shelby",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3078,
    density: 27.2,
    county_fips: "01117",
    county_name: "Shelby",
    county_weights: {
      "01117": 100,
    },
    county_names_all: "Shelby",
    county_fips_all: "01117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35146,
    lat: 33.79275,
    lng: -86.43258,
    city: "Springville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11551,
    density: 43.2,
    county_fips: "01115",
    county_name: "St. Clair",
    county_weights: {
      "01115": 81.16,
      "01009": 16.17,
      "01073": 2.67,
    },
    county_names_all: "St. Clair|Blount|Jefferson",
    county_fips_all: "01115|01009|01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35147,
    lat: 33.41233,
    lng: -86.53164,
    city: "Sterrett",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5825,
    density: 32.7,
    county_fips: "01117",
    county_name: "Shelby",
    county_weights: {
      "01117": 100,
    },
    county_names_all: "Shelby",
    county_fips_all: "01117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35148,
    lat: 33.75643,
    lng: -87.04556,
    city: "Sumiton",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2209,
    density: 137.2,
    county_fips: "01127",
    county_name: "Walker",
    county_weights: {
      "01127": 97.99,
      "01073": 2.01,
    },
    county_names_all: "Walker|Jefferson",
    county_fips_all: "01127|01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35149,
    lat: 33.24378,
    lng: -86.20709,
    city: "Sycamore",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 249,
    density: 29,
    county_fips: "01121",
    county_name: "Talladega",
    county_weights: {
      "01121": 100,
    },
    county_names_all: "Talladega",
    county_fips_all: "01121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35150,
    lat: 33.18581,
    lng: -86.24454,
    city: "Sylacauga",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17326,
    density: 109.5,
    county_fips: "01121",
    county_name: "Talladega",
    county_weights: {
      "01121": 97.31,
      "01037": 2.28,
      "01027": 0.41,
    },
    county_names_all: "Talladega|Coosa|Clay",
    county_fips_all: "01121|01037|01027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35151,
    lat: 33.108,
    lng: -86.36704,
    city: "Sylacauga",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7827,
    density: 20.4,
    county_fips: "01121",
    county_name: "Talladega",
    county_weights: {
      "01121": 52.06,
      "01037": 47.94,
    },
    county_names_all: "Talladega|Coosa",
    county_fips_all: "01121|01037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35160,
    lat: 33.36898,
    lng: -86.1005,
    city: "Talladega",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25622,
    density: 29.7,
    county_fips: "01121",
    county_name: "Talladega",
    county_weights: {
      "01121": 77.56,
      "01027": 22.44,
    },
    county_names_all: "Talladega|Clay",
    county_fips_all: "01121|01027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35171,
    lat: 32.87823,
    lng: -86.74636,
    city: "Thorsby",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3557,
    density: 40.1,
    county_fips: "01021",
    county_name: "Chilton",
    county_weights: {
      "01021": 100,
    },
    county_names_all: "Chilton",
    county_fips_all: "01021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35172,
    lat: 33.84389,
    lng: -86.69788,
    city: "Trafford",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2941,
    density: 38.6,
    county_fips: "01009",
    county_name: "Blount",
    county_weights: {
      "01009": 81.15,
      "01073": 18.85,
    },
    county_names_all: "Blount|Jefferson",
    county_fips_all: "01009|01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35173,
    lat: 33.65284,
    lng: -86.56337,
    city: "Trussville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27312,
    density: 163.4,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 76.14,
      "01115": 23.86,
    },
    county_names_all: "Jefferson|St. Clair",
    county_fips_all: "01073|01115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35175,
    lat: 34.43731,
    lng: -86.51673,
    city: "Union Grove",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5218,
    density: 31.8,
    county_fips: "01095",
    county_name: "Marshall",
    county_weights: {
      "01095": 82.63,
      "01103": 17.37,
    },
    county_names_all: "Marshall|Morgan",
    county_fips_all: "01095|01103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35176,
    lat: 33.4817,
    lng: -86.50221,
    city: "Vandiver",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 683,
    density: 29.8,
    county_fips: "01117",
    county_name: "Shelby",
    county_weights: {
      "01117": 100,
    },
    county_names_all: "Shelby",
    county_fips_all: "01117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35178,
    lat: 33.42003,
    lng: -86.39993,
    city: "Vincent",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3126,
    density: 21,
    county_fips: "01117",
    county_name: "Shelby",
    county_weights: {
      "01117": 78.69,
      "01115": 21.31,
    },
    county_names_all: "Shelby|St. Clair",
    county_fips_all: "01117|01115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35179,
    lat: 34.27004,
    lng: -86.96847,
    city: "Vinemont",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8128,
    density: 33.7,
    county_fips: "01043",
    county_name: "Cullman",
    county_weights: {
      "01043": 91.05,
      "01133": 4.55,
      "01103": 4.4,
    },
    county_names_all: "Cullman|Winston|Morgan",
    county_fips_all: "01043|01133|01103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35180,
    lat: 33.82388,
    lng: -86.83987,
    city: "Warrior",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14305,
    density: 64.7,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 63.53,
      "01009": 36.47,
    },
    county_names_all: "Jefferson|Blount",
    county_fips_all: "01073|01009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35181,
    lat: 33.62647,
    lng: -86.87999,
    city: "Watson",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35183,
    lat: 33.00675,
    lng: -86.35706,
    city: "Weogufka",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 663,
    density: 2.8,
    county_fips: "01037",
    county_name: "Coosa",
    county_weights: {
      "01037": 100,
    },
    county_names_all: "Coosa",
    county_fips_all: "01037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35184,
    lat: 33.1152,
    lng: -87.13931,
    city: "West Blocton",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4638,
    density: 12.6,
    county_fips: "01007",
    county_name: "Bibb",
    county_weights: {
      "01007": 99.75,
      "01125": 0.25,
    },
    county_names_all: "Bibb|Tuscaloosa",
    county_fips_all: "01007|01125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35185,
    lat: 33.34903,
    lng: -86.53871,
    city: "Westover",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "01117",
    county_name: "Shelby",
    county_weights: {
      "01117": 100,
    },
    county_names_all: "Shelby",
    county_fips_all: "01117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35186,
    lat: 33.25699,
    lng: -86.51442,
    city: "Wilsonville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5068,
    density: 35.5,
    county_fips: "01117",
    county_name: "Shelby",
    county_weights: {
      "01117": 100,
    },
    county_names_all: "Shelby",
    county_fips_all: "01117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35188,
    lat: 33.18326,
    lng: -87.17322,
    city: "Woodstock",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2351,
    density: 36.3,
    county_fips: "01007",
    county_name: "Bibb",
    county_weights: {
      "01007": 73.48,
      "01125": 26.52,
    },
    county_names_all: "Bibb|Tuscaloosa",
    county_fips_all: "01007|01125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35203,
    lat: 33.51847,
    lng: -86.80999,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3026,
    density: 563.2,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35204,
    lat: 33.52203,
    lng: -86.84067,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9907,
    density: 760.6,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35205,
    lat: 33.49509,
    lng: -86.8084,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20145,
    density: 2084.6,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35206,
    lat: 33.57024,
    lng: -86.71328,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17211,
    density: 661,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35207,
    lat: 33.5682,
    lng: -86.8223,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7901,
    density: 262.2,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35208,
    lat: 33.49717,
    lng: -86.87909,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13752,
    density: 1445.3,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35209,
    lat: 33.46507,
    lng: -86.81107,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29262,
    density: 1177.7,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35210,
    lat: 33.5431,
    lng: -86.6661,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13955,
    density: 216.5,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35211,
    lat: 33.45262,
    lng: -86.87046,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24876,
    density: 580.1,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35212,
    lat: 33.54765,
    lng: -86.75272,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10498,
    density: 654.7,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35213,
    lat: 33.50659,
    lng: -86.74241,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13963,
    density: 852.9,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35214,
    lat: 33.57322,
    lng: -86.89081,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17021,
    density: 264.9,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35215,
    lat: 33.64911,
    lng: -86.70435,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47438,
    density: 647.8,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35216,
    lat: 33.41995,
    lng: -86.78746,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37828,
    density: 1125,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 98.04,
      "01117": 1.96,
    },
    county_names_all: "Jefferson|Shelby",
    county_fips_all: "01073|01117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35217,
    lat: 33.60711,
    lng: -86.7613,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13133,
    density: 286.6,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35218,
    lat: 33.50771,
    lng: -86.89388,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7283,
    density: 1071.4,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35221,
    lat: 33.4497,
    lng: -86.89901,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4112,
    density: 430.3,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35222,
    lat: 33.52378,
    lng: -86.76994,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9299,
    density: 921.3,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35223,
    lat: 33.48777,
    lng: -86.73605,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10388,
    density: 474.9,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35224,
    lat: 33.52965,
    lng: -86.94518,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5362,
    density: 127.8,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35226,
    lat: 33.39823,
    lng: -86.84421,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35256,
    density: 769.3,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35228,
    lat: 33.45606,
    lng: -86.92165,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10558,
    density: 931,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35229,
    lat: 33.46434,
    lng: -86.79399,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 816,
    density: 1207.4,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35233,
    lat: 33.50916,
    lng: -86.80132,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2244,
    density: 569.1,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35234,
    lat: 33.54005,
    lng: -86.80382,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5545,
    density: 638.6,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35235,
    lat: 33.61723,
    lng: -86.65008,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21419,
    density: 613.1,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35242,
    lat: 33.42371,
    lng: -86.67073,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56713,
    density: 418.1,
    county_fips: "01117",
    county_name: "Shelby",
    county_weights: {
      "01117": 80.44,
      "01073": 19.56,
    },
    county_names_all: "Shelby|Jefferson",
    county_fips_all: "01117|01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35243,
    lat: 33.44185,
    lng: -86.74055,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16155,
    density: 497.8,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 97.72,
      "01117": 2.28,
    },
    county_names_all: "Jefferson|Shelby",
    county_fips_all: "01073|01117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35244,
    lat: 33.35205,
    lng: -86.8267,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31935,
    density: 516.9,
    county_fips: "01117",
    county_name: "Shelby",
    county_weights: {
      "01117": 54.16,
      "01073": 45.84,
    },
    county_names_all: "Shelby|Jefferson",
    county_fips_all: "01117|01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35249,
    lat: 33.50657,
    lng: -86.80316,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35254,
    lat: 33.51375,
    lng: -86.85282,
    city: "Birmingham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1698,
    density: 6431.4,
    county_fips: "01073",
    county_name: "Jefferson",
    county_weights: {
      "01073": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35401,
    lat: 33.179,
    lng: -87.61586,
    city: "Tuscaloosa",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37909,
    density: 365,
    county_fips: "01125",
    county_name: "Tuscaloosa",
    county_weights: {
      "01125": 100,
    },
    county_names_all: "Tuscaloosa",
    county_fips_all: "01125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35404,
    lat: 33.21661,
    lng: -87.48655,
    city: "Tuscaloosa",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22578,
    density: 523.7,
    county_fips: "01125",
    county_name: "Tuscaloosa",
    county_weights: {
      "01125": 100,
    },
    county_names_all: "Tuscaloosa",
    county_fips_all: "01125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35405,
    lat: 33.12087,
    lng: -87.55082,
    city: "Tuscaloosa",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44449,
    density: 324.5,
    county_fips: "01125",
    county_name: "Tuscaloosa",
    county_weights: {
      "01125": 100,
    },
    county_names_all: "Tuscaloosa",
    county_fips_all: "01125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35406,
    lat: 33.33194,
    lng: -87.4683,
    city: "Tuscaloosa",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18391,
    density: 87.7,
    county_fips: "01125",
    county_name: "Tuscaloosa",
    county_weights: {
      "01125": 100,
    },
    county_names_all: "Tuscaloosa",
    county_fips_all: "01125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35441,
    lat: 32.85616,
    lng: -87.73114,
    city: "Akron",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1058,
    density: 6.1,
    county_fips: "01065",
    county_name: "Hale",
    county_weights: {
      "01065": 100,
    },
    county_names_all: "Hale",
    county_fips_all: "01065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35442,
    lat: 33.06016,
    lng: -88.20159,
    city: "Aliceville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6386,
    density: 9.2,
    county_fips: "01107",
    county_name: "Pickens",
    county_weights: {
      "01107": 74.47,
      "01119": 20.41,
      "01063": 5.12,
    },
    county_names_all: "Pickens|Sumter|Greene",
    county_fips_all: "01107|01119|01063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35443,
    lat: 32.76538,
    lng: -88.01908,
    city: "Boligee",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1702,
    density: 3,
    county_fips: "01063",
    county_name: "Greene",
    county_weights: {
      "01063": 100,
    },
    county_names_all: "Greene",
    county_fips_all: "01063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35444,
    lat: 33.33474,
    lng: -87.30387,
    city: "Brookwood",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4007,
    density: 10.3,
    county_fips: "01125",
    county_name: "Tuscaloosa",
    county_weights: {
      "01125": 93.49,
      "01073": 6.51,
    },
    county_names_all: "Tuscaloosa|Jefferson",
    county_fips_all: "01125|01073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35446,
    lat: 33.21642,
    lng: -87.74833,
    city: "Buhl",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1662,
    density: 10.6,
    county_fips: "01125",
    county_name: "Tuscaloosa",
    county_weights: {
      "01125": 100,
    },
    county_names_all: "Tuscaloosa",
    county_fips_all: "01125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35447,
    lat: 33.25701,
    lng: -88.15716,
    city: "Carrollton",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3328,
    density: 9.1,
    county_fips: "01107",
    county_name: "Pickens",
    county_weights: {
      "01107": 100,
    },
    county_names_all: "Pickens",
    county_fips_all: "01107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35452,
    lat: 33.28349,
    lng: -87.6854,
    city: "Coker",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3225,
    density: 24.6,
    county_fips: "01125",
    county_name: "Tuscaloosa",
    county_weights: {
      "01125": 100,
    },
    county_names_all: "Tuscaloosa",
    county_fips_all: "01125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35453,
    lat: 33.16176,
    lng: -87.387,
    city: "Cottondale",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11738,
    density: 50.1,
    county_fips: "01125",
    county_name: "Tuscaloosa",
    county_weights: {
      "01125": 100,
    },
    county_names_all: "Tuscaloosa",
    county_fips_all: "01125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35456,
    lat: 33.05651,
    lng: -87.43515,
    city: "Duncanville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4332,
    density: 20.6,
    county_fips: "01125",
    county_name: "Tuscaloosa",
    county_weights: {
      "01125": 100,
    },
    county_names_all: "Tuscaloosa",
    county_fips_all: "01125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35457,
    lat: 33.29891,
    lng: -87.77229,
    city: "Echola",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28,
    density: 1.4,
    county_fips: "01125",
    county_name: "Tuscaloosa",
    county_weights: {
      "01125": 100,
    },
    county_names_all: "Tuscaloosa",
    county_fips_all: "01125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35458,
    lat: 33.3814,
    lng: -87.79713,
    city: "Elrod",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 279,
    density: 3.7,
    county_fips: "01125",
    county_name: "Tuscaloosa",
    county_weights: {
      "01125": 100,
    },
    county_names_all: "Tuscaloosa",
    county_fips_all: "01125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35459,
    lat: 32.79337,
    lng: -88.3003,
    city: "Emelle",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 913,
    density: 2.6,
    county_fips: "01119",
    county_name: "Sumter",
    county_weights: {
      "01119": 100,
    },
    county_names_all: "Sumter",
    county_fips_all: "01119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35460,
    lat: 32.71882,
    lng: -88.19452,
    city: "Epes",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 750,
    density: 5.3,
    county_fips: "01119",
    county_name: "Sumter",
    county_weights: {
      "01119": 100,
    },
    county_names_all: "Sumter",
    county_fips_all: "01119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35461,
    lat: 33.41749,
    lng: -88.21158,
    city: "Ethelsville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2140,
    density: 6.5,
    county_fips: "01107",
    county_name: "Pickens",
    county_weights: {
      "01107": 100,
    },
    county_names_all: "Pickens",
    county_fips_all: "01107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35462,
    lat: 32.93389,
    lng: -87.94183,
    city: "Eutaw",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4355,
    density: 5.9,
    county_fips: "01063",
    county_name: "Greene",
    county_weights: {
      "01063": 100,
    },
    county_names_all: "Greene",
    county_fips_all: "01063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35463,
    lat: 33.0563,
    lng: -87.68687,
    city: "Fosters",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2183,
    density: 14.7,
    county_fips: "01125",
    county_name: "Tuscaloosa",
    county_weights: {
      "01125": 82.98,
      "01063": 17.02,
    },
    county_names_all: "Tuscaloosa|Greene",
    county_fips_all: "01125|01063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35464,
    lat: 32.78369,
    lng: -88.14383,
    city: "Gainesville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 916,
    density: 8.8,
    county_fips: "01119",
    county_name: "Sumter",
    county_weights: {
      "01119": 89.8,
      "01063": 10.2,
    },
    county_names_all: "Sumter|Greene",
    county_fips_all: "01119|01063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35466,
    lat: 33.25904,
    lng: -87.91554,
    city: "Gordo",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4999,
    density: 7.2,
    county_fips: "01107",
    county_name: "Pickens",
    county_weights: {
      "01107": 86.03,
      "01125": 13.97,
    },
    county_names_all: "Pickens|Tuscaloosa",
    county_fips_all: "01107|01125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35469,
    lat: 33.01447,
    lng: -87.80578,
    city: "Knoxville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49,
    density: 0.6,
    county_fips: "01063",
    county_name: "Greene",
    county_weights: {
      "01063": 79.51,
      "01125": 20.49,
    },
    county_names_all: "Greene|Tuscaloosa",
    county_fips_all: "01063|01125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35470,
    lat: 32.56801,
    lng: -88.09894,
    city: "Livingston",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5123,
    density: 7.2,
    county_fips: "01119",
    county_name: "Sumter",
    county_weights: {
      "01119": 100,
    },
    county_names_all: "Sumter",
    county_fips_all: "01119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35473,
    lat: 33.27236,
    lng: -87.58481,
    city: "Northport",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16498,
    density: 247.2,
    county_fips: "01125",
    county_name: "Tuscaloosa",
    county_weights: {
      "01125": 100,
    },
    county_names_all: "Tuscaloosa",
    county_fips_all: "01125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35474,
    lat: 32.93679,
    lng: -87.57226,
    city: "Moundville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7056,
    density: 13.1,
    county_fips: "01065",
    county_name: "Hale",
    county_weights: {
      "01065": 88.88,
      "01125": 11.12,
    },
    county_names_all: "Hale|Tuscaloosa",
    county_fips_all: "01065|01125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35475,
    lat: 33.42792,
    lng: -87.5854,
    city: "Northport",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17518,
    density: 33.4,
    county_fips: "01125",
    county_name: "Tuscaloosa",
    county_weights: {
      "01125": 100,
    },
    county_names_all: "Tuscaloosa",
    county_fips_all: "01125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35476,
    lat: 33.2271,
    lng: -87.60464,
    city: "Northport",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6833,
    density: 382.4,
    county_fips: "01125",
    county_name: "Tuscaloosa",
    county_weights: {
      "01125": 100,
    },
    county_names_all: "Tuscaloosa",
    county_fips_all: "01125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35477,
    lat: 32.96304,
    lng: -88.23121,
    city: "Panola",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 132,
    density: 5.2,
    county_fips: "01119",
    county_name: "Sumter",
    county_weights: {
      "01119": 99.6,
      "01107": 0.4,
    },
    county_names_all: "Sumter|Pickens",
    county_fips_all: "01119|01107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35480,
    lat: 33.09794,
    lng: -87.80734,
    city: "Ralph",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1108,
    density: 7,
    county_fips: "01125",
    county_name: "Tuscaloosa",
    county_weights: {
      "01125": 72.77,
      "01063": 27.23,
    },
    county_names_all: "Tuscaloosa|Greene",
    county_fips_all: "01125|01063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35481,
    lat: 33.39852,
    lng: -88.03934,
    city: "Reform",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3208,
    density: 11.2,
    county_fips: "01107",
    county_name: "Pickens",
    county_weights: {
      "01107": 100,
    },
    county_names_all: "Pickens",
    county_fips_all: "01107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35487,
    lat: 33.21426,
    lng: -87.54782,
    city: "Tuscaloosa",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "01125",
    county_name: "Tuscaloosa",
    county_weights: {
      "01125": 100,
    },
    county_names_all: "Tuscaloosa",
    county_fips_all: "01125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35490,
    lat: 33.21607,
    lng: -87.24546,
    city: "Vance",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4179,
    density: 24,
    county_fips: "01125",
    county_name: "Tuscaloosa",
    county_weights: {
      "01125": 100,
    },
    county_names_all: "Tuscaloosa",
    county_fips_all: "01125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35491,
    lat: 32.93665,
    lng: -88.09774,
    city: "West Greene",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "01063",
    county_name: "Greene",
    county_weights: {
      "01063": 100,
    },
    county_names_all: "Greene",
    county_fips_all: "01063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35501,
    lat: 33.82145,
    lng: -87.29544,
    city: "Jasper",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9719,
    density: 78.4,
    county_fips: "01127",
    county_name: "Walker",
    county_weights: {
      "01127": 100,
    },
    county_names_all: "Walker",
    county_fips_all: "01127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35503,
    lat: 33.93664,
    lng: -87.30147,
    city: "Jasper",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9817,
    density: 48.2,
    county_fips: "01127",
    county_name: "Walker",
    county_weights: {
      "01127": 91.1,
      "01133": 8.9,
    },
    county_names_all: "Walker|Winston",
    county_fips_all: "01127|01133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35504,
    lat: 33.89311,
    lng: -87.16672,
    city: "Jasper",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12420,
    density: 49.1,
    county_fips: "01127",
    county_name: "Walker",
    county_weights: {
      "01127": 100,
    },
    county_names_all: "Walker",
    county_fips_all: "01127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35540,
    lat: 34.23066,
    lng: -87.18374,
    city: "Addison",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2413,
    density: 13.2,
    county_fips: "01133",
    county_name: "Winston",
    county_weights: {
      "01133": 97.88,
      "01043": 2.12,
    },
    county_names_all: "Winston|Cullman",
    county_fips_all: "01133|01043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35541,
    lat: 34.07936,
    lng: -87.1801,
    city: "Arley",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3399,
    density: 19.8,
    county_fips: "01133",
    county_name: "Winston",
    county_weights: {
      "01133": 99.04,
      "01043": 0.96,
    },
    county_names_all: "Winston|Cullman",
    county_fips_all: "01133|01043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35542,
    lat: 33.7083,
    lng: -87.68161,
    city: "Bankston",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 681,
    density: 4.5,
    county_fips: "01057",
    county_name: "Fayette",
    county_weights: {
      "01057": 100,
    },
    county_names_all: "Fayette",
    county_fips_all: "01057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35543,
    lat: 34.21219,
    lng: -87.75197,
    city: "Bear Creek",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1308,
    density: 13.7,
    county_fips: "01093",
    county_name: "Marion",
    county_weights: {
      "01093": 100,
    },
    county_names_all: "Marion",
    county_fips_all: "01093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35544,
    lat: 33.95392,
    lng: -88.02022,
    city: "Beaverton",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 635,
    density: 3.2,
    county_fips: "01075",
    county_name: "Lamar",
    county_weights: {
      "01075": 100,
    },
    county_names_all: "Lamar",
    county_fips_all: "01075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35545,
    lat: 33.6421,
    lng: -87.93147,
    city: "Belk",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 90,
    density: 82.9,
    county_fips: "01057",
    county_name: "Fayette",
    county_weights: {
      "01057": 100,
    },
    county_names_all: "Fayette",
    county_fips_all: "01057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35546,
    lat: 33.60555,
    lng: -87.54763,
    city: "Berry",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3765,
    density: 6.2,
    county_fips: "01125",
    county_name: "Tuscaloosa",
    county_weights: {
      "01125": 48.67,
      "01057": 43.34,
      "01127": 8,
    },
    county_names_all: "Tuscaloosa|Fayette|Walker",
    county_fips_all: "01125|01057|01127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35548,
    lat: 34.06263,
    lng: -87.75251,
    city: "Brilliant",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1864,
    density: 10.2,
    county_fips: "01093",
    county_name: "Marion",
    county_weights: {
      "01093": 100,
    },
    county_names_all: "Marion",
    county_fips_all: "01093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35549,
    lat: 33.83474,
    lng: -87.55001,
    city: "Carbon Hill",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3667,
    density: 12.4,
    county_fips: "01057",
    county_name: "Fayette",
    county_weights: {
      "01057": 50.75,
      "01127": 49.25,
    },
    county_names_all: "Fayette|Walker",
    county_fips_all: "01057|01127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35550,
    lat: 33.74249,
    lng: -87.16534,
    city: "Cordova",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5322,
    density: 30.5,
    county_fips: "01127",
    county_name: "Walker",
    county_weights: {
      "01127": 100,
    },
    county_names_all: "Walker",
    county_fips_all: "01127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35552,
    lat: 34.07311,
    lng: -88.14266,
    city: "Detroit",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1031,
    density: 6.5,
    county_fips: "01093",
    county_name: "Marion",
    county_weights: {
      "01093": 60.34,
      "01075": 39.66,
    },
    county_names_all: "Marion|Lamar",
    county_fips_all: "01093|01075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35553,
    lat: 34.12471,
    lng: -87.38794,
    city: "Double Springs",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4359,
    density: 11,
    county_fips: "01133",
    county_name: "Winston",
    county_weights: {
      "01133": 100,
    },
    county_names_all: "Winston",
    county_fips_all: "01133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35554,
    lat: 33.89745,
    lng: -87.65593,
    city: "Eldridge",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1050,
    density: 7.8,
    county_fips: "01057",
    county_name: "Fayette",
    county_weights: {
      "01057": 55.57,
      "01127": 25.4,
      "01093": 19.03,
    },
    county_names_all: "Fayette|Walker|Marion",
    county_fips_all: "01057|01127|01093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35555,
    lat: 33.66829,
    lng: -87.82309,
    city: "Fayette",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10050,
    density: 11.9,
    county_fips: "01057",
    county_name: "Fayette",
    county_weights: {
      "01057": 87.82,
      "01125": 7.12,
      "01075": 3.96,
      "01107": 1.1,
    },
    county_names_all: "Fayette|Tuscaloosa|Lamar|Pickens",
    county_fips_all: "01057|01125|01075|01107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35559,
    lat: 33.91166,
    lng: -87.73537,
    city: "Glen Allen",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75,
    density: 258.6,
    county_fips: "01057",
    county_name: "Fayette",
    county_weights: {
      "01057": 100,
    },
    county_names_all: "Fayette",
    county_fips_all: "01057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35563,
    lat: 33.99678,
    lng: -87.90149,
    city: "Guin",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4287,
    density: 17.8,
    county_fips: "01093",
    county_name: "Marion",
    county_weights: {
      "01093": 88.01,
      "01057": 6.87,
      "01075": 5.12,
    },
    county_names_all: "Marion|Fayette|Lamar",
    county_fips_all: "01093|01057|01075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35564,
    lat: 34.25733,
    lng: -87.84306,
    city: "Hackleburg",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2100,
    density: 11.9,
    county_fips: "01093",
    county_name: "Marion",
    county_weights: {
      "01093": 92.82,
      "01059": 7.18,
    },
    county_names_all: "Marion|Franklin",
    county_fips_all: "01093|01059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35565,
    lat: 34.23555,
    lng: -87.56309,
    city: "Haleyville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12115,
    density: 16.7,
    county_fips: "01133",
    county_name: "Winston",
    county_weights: {
      "01133": 53.44,
      "01093": 23.12,
      "01079": 17.53,
      "01059": 5.91,
    },
    county_names_all: "Winston|Marion|Lawrence|Franklin",
    county_fips_all: "01133|01093|01079|01059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35570,
    lat: 34.16532,
    lng: -87.99466,
    city: "Hamilton",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11516,
    density: 19,
    county_fips: "01093",
    county_name: "Marion",
    county_weights: {
      "01093": 99.14,
      "01075": 0.86,
    },
    county_names_all: "Marion|Lamar",
    county_fips_all: "01093|01075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35571,
    lat: 34.35153,
    lng: -87.94672,
    city: "Hodges",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 794,
    density: 4.9,
    county_fips: "01059",
    county_name: "Franklin",
    county_weights: {
      "01059": 78.43,
      "01093": 21.57,
    },
    county_names_all: "Franklin|Marion",
    county_fips_all: "01059|01093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35572,
    lat: 34.20672,
    lng: -87.29447,
    city: "Houston",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1700,
    density: 8.4,
    county_fips: "01133",
    county_name: "Winston",
    county_weights: {
      "01133": 100,
    },
    county_names_all: "Winston",
    county_fips_all: "01133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35573,
    lat: 33.90137,
    lng: -87.54999,
    city: "Kansas",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "01127",
    county_name: "Walker",
    county_weights: {
      "01127": 100,
    },
    county_names_all: "Walker",
    county_fips_all: "01127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35574,
    lat: 33.5683,
    lng: -87.95757,
    city: "Kennedy",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1632,
    density: 6.3,
    county_fips: "01075",
    county_name: "Lamar",
    county_weights: {
      "01075": 53.52,
      "01107": 34.02,
      "01057": 12.46,
    },
    county_names_all: "Lamar|Pickens|Fayette",
    county_fips_all: "01075|01107|01057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35575,
    lat: 34.04521,
    lng: -87.57716,
    city: "Lynn",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1097,
    density: 12.1,
    county_fips: "01133",
    county_name: "Winston",
    county_weights: {
      "01133": 100,
    },
    county_names_all: "Winston",
    county_fips_all: "01133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35576,
    lat: 33.582,
    lng: -88.1315,
    city: "Millport",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3135,
    density: 7.1,
    county_fips: "01075",
    county_name: "Lamar",
    county_weights: {
      "01075": 80.53,
      "01107": 19.47,
    },
    county_names_all: "Lamar|Pickens",
    county_fips_all: "01075|01107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35577,
    lat: 34.09175,
    lng: -87.59931,
    city: "Natural Bridge",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61,
    density: 132.8,
    county_fips: "01133",
    county_name: "Winston",
    county_weights: {
      "01133": 100,
    },
    county_names_all: "Winston",
    county_fips_all: "01133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35578,
    lat: 33.982,
    lng: -87.46638,
    city: "Nauvoo",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5691,
    density: 18.1,
    county_fips: "01127",
    county_name: "Walker",
    county_weights: {
      "01127": 64.48,
      "01133": 35.52,
    },
    county_names_all: "Walker|Winston",
    county_fips_all: "01127|01133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35579,
    lat: 33.63069,
    lng: -87.34441,
    city: "Oakman",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3349,
    density: 8.2,
    county_fips: "01127",
    county_name: "Walker",
    county_weights: {
      "01127": 76.65,
      "01125": 23.35,
    },
    county_names_all: "Walker|Tuscaloosa",
    county_fips_all: "01127|01125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35580,
    lat: 33.7011,
    lng: -87.27331,
    city: "Parrish",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3682,
    density: 22.7,
    county_fips: "01127",
    county_name: "Walker",
    county_weights: {
      "01127": 100,
    },
    county_names_all: "Walker",
    county_fips_all: "01127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35581,
    lat: 34.35789,
    lng: -87.71267,
    city: "Phil Campbell",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6206,
    density: 19.9,
    county_fips: "01059",
    county_name: "Franklin",
    county_weights: {
      "01059": 87.65,
      "01093": 12.35,
    },
    county_names_all: "Franklin|Marion",
    county_fips_all: "01059|01093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35582,
    lat: 34.48577,
    lng: -88.09536,
    city: "Red Bay",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4871,
    density: 20.7,
    county_fips: "01059",
    county_name: "Franklin",
    county_weights: {
      "01059": 100,
    },
    county_names_all: "Franklin",
    county_fips_all: "01059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35584,
    lat: 33.82161,
    lng: -87.08692,
    city: "Sipsey",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 283,
    density: 194,
    county_fips: "01127",
    county_name: "Walker",
    county_weights: {
      "01127": 100,
    },
    county_names_all: "Walker",
    county_fips_all: "01127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35585,
    lat: 34.41868,
    lng: -87.82008,
    city: "Spruce Pine",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1139,
    density: 9.5,
    county_fips: "01059",
    county_name: "Franklin",
    county_weights: {
      "01059": 100,
    },
    county_names_all: "Franklin",
    county_fips_all: "01059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35586,
    lat: 33.87332,
    lng: -88.13837,
    city: "Sulligent",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3746,
    density: 8.1,
    county_fips: "01075",
    county_name: "Lamar",
    county_weights: {
      "01075": 100,
    },
    county_names_all: "Lamar",
    county_fips_all: "01075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35587,
    lat: 33.80071,
    lng: -87.4521,
    city: "Townley",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 538,
    density: 4.2,
    county_fips: "01127",
    county_name: "Walker",
    county_weights: {
      "01127": 100,
    },
    county_names_all: "Walker",
    county_fips_all: "01127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35592,
    lat: 33.74315,
    lng: -88.09672,
    city: "Vernon",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4590,
    density: 15.4,
    county_fips: "01075",
    county_name: "Lamar",
    county_weights: {
      "01075": 100,
    },
    county_names_all: "Lamar",
    county_fips_all: "01075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35593,
    lat: 34.35721,
    lng: -88.07328,
    city: "Vina",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1443,
    density: 4.4,
    county_fips: "01059",
    county_name: "Franklin",
    county_weights: {
      "01059": 64.81,
      "01093": 35.19,
    },
    county_names_all: "Franklin|Marion",
    county_fips_all: "01059|01093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35594,
    lat: 33.92222,
    lng: -87.7813,
    city: "Winfield",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6784,
    density: 17.8,
    county_fips: "01057",
    county_name: "Fayette",
    county_weights: {
      "01057": 50.14,
      "01093": 49.86,
    },
    county_names_all: "Fayette|Marion",
    county_fips_all: "01057|01093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35601,
    lat: 34.60616,
    lng: -87.00795,
    city: "Decatur",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32299,
    density: 470.8,
    county_fips: "01103",
    county_name: "Morgan",
    county_weights: {
      "01103": 100,
    },
    county_names_all: "Morgan",
    county_fips_all: "01103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35603,
    lat: 34.53712,
    lng: -86.96717,
    city: "Decatur",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31509,
    density: 171.3,
    county_fips: "01103",
    county_name: "Morgan",
    county_weights: {
      "01103": 99.49,
      "01079": 0.51,
    },
    county_names_all: "Morgan|Lawrence",
    county_fips_all: "01103|01079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35610,
    lat: 34.95361,
    lng: -87.23714,
    city: "Anderson",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1721,
    density: 15.6,
    county_fips: "01077",
    county_name: "Lauderdale",
    county_weights: {
      "01077": 70.36,
      "01083": 29.64,
    },
    county_names_all: "Lauderdale|Limestone",
    county_fips_all: "01077|01083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35611,
    lat: 34.76554,
    lng: -87.08418,
    city: "Athens",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27293,
    density: 91.6,
    county_fips: "01083",
    county_name: "Limestone",
    county_weights: {
      "01083": 100,
    },
    county_names_all: "Limestone",
    county_fips_all: "01083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35613,
    lat: 34.82336,
    lng: -86.88001,
    city: "Athens",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25936,
    density: 133.5,
    county_fips: "01083",
    county_name: "Limestone",
    county_weights: {
      "01083": 100,
    },
    county_names_all: "Limestone",
    county_fips_all: "01083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35614,
    lat: 34.86433,
    lng: -87.08457,
    city: "Athens",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7570,
    density: 45.3,
    county_fips: "01083",
    county_name: "Limestone",
    county_weights: {
      "01083": 98.32,
      "01077": 1.68,
    },
    county_names_all: "Limestone|Lauderdale",
    county_fips_all: "01083|01077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35615,
    lat: 34.66229,
    lng: -86.87596,
    city: "Belle Mina",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 162,
    density: 124.8,
    county_fips: "01083",
    county_name: "Limestone",
    county_weights: {
      "01083": 100,
    },
    county_names_all: "Limestone",
    county_fips_all: "01083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35616,
    lat: 34.7382,
    lng: -88.01889,
    city: "Cherokee",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3643,
    density: 6.5,
    county_fips: "01033",
    county_name: "Colbert",
    county_weights: {
      "01033": 100,
    },
    county_names_all: "Colbert",
    county_fips_all: "01033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35618,
    lat: 34.64334,
    lng: -87.30552,
    city: "Courtland",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2003,
    density: 17.4,
    county_fips: "01079",
    county_name: "Lawrence",
    county_weights: {
      "01079": 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: "01079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35619,
    lat: 34.38606,
    lng: -87.14545,
    city: "Danville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4534,
    density: 13.3,
    county_fips: "01079",
    county_name: "Lawrence",
    county_weights: {
      "01079": 68.25,
      "01103": 31.59,
      "01043": 0.16,
    },
    county_names_all: "Lawrence|Morgan|Cullman",
    county_fips_all: "01079|01103|01043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35620,
    lat: 34.93141,
    lng: -86.99086,
    city: "Elkmont",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10668,
    density: 38.3,
    county_fips: "01083",
    county_name: "Limestone",
    county_weights: {
      "01083": 100,
    },
    county_names_all: "Limestone",
    county_fips_all: "01083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35621,
    lat: 34.34967,
    lng: -86.7239,
    city: "Eva",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3113,
    density: 26.4,
    county_fips: "01103",
    county_name: "Morgan",
    county_weights: {
      "01103": 96.67,
      "01043": 3.33,
    },
    county_names_all: "Morgan|Cullman",
    county_fips_all: "01103|01043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35622,
    lat: 34.34491,
    lng: -86.89535,
    city: "Falkville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7138,
    density: 28.6,
    county_fips: "01103",
    county_name: "Morgan",
    county_weights: {
      "01103": 84.61,
      "01043": 15.39,
    },
    county_names_all: "Morgan|Cullman",
    county_fips_all: "01103|01043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35630,
    lat: 34.82526,
    lng: -87.66018,
    city: "Florence",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33685,
    density: 514.5,
    county_fips: "01077",
    county_name: "Lauderdale",
    county_weights: {
      "01077": 100,
    },
    county_names_all: "Lauderdale",
    county_fips_all: "01077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35632,
    lat: 34.80763,
    lng: -87.68043,
    city: "Florence",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "01077",
    county_name: "Lauderdale",
    county_weights: {
      "01077": 100,
    },
    county_names_all: "Lauderdale",
    county_fips_all: "01077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35633,
    lat: 34.87586,
    lng: -87.79645,
    city: "Florence",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20593,
    density: 38.2,
    county_fips: "01077",
    county_name: "Lauderdale",
    county_weights: {
      "01077": 100,
    },
    county_names_all: "Lauderdale",
    county_fips_all: "01077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35634,
    lat: 34.92306,
    lng: -87.60738,
    city: "Florence",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9606,
    density: 52,
    county_fips: "01077",
    county_name: "Lauderdale",
    county_weights: {
      "01077": 100,
    },
    county_names_all: "Lauderdale",
    county_fips_all: "01077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35640,
    lat: 34.4414,
    lng: -86.94315,
    city: "Hartselle",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26308,
    density: 95,
    county_fips: "01103",
    county_name: "Morgan",
    county_weights: {
      "01103": 100,
    },
    county_names_all: "Morgan",
    county_fips_all: "01103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35643,
    lat: 34.66882,
    lng: -87.20707,
    city: "Hillsboro",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3501,
    density: 16.7,
    county_fips: "01079",
    county_name: "Lawrence",
    county_weights: {
      "01079": 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: "01079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35645,
    lat: 34.89605,
    lng: -87.4936,
    city: "Killen",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13335,
    density: 67.4,
    county_fips: "01077",
    county_name: "Lauderdale",
    county_weights: {
      "01077": 100,
    },
    county_names_all: "Lauderdale",
    county_fips_all: "01077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35646,
    lat: 34.66988,
    lng: -87.53165,
    city: "Leighton",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4414,
    density: 18.9,
    county_fips: "01033",
    county_name: "Colbert",
    county_weights: {
      "01033": 100,
    },
    county_names_all: "Colbert",
    county_fips_all: "01033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35647,
    lat: 34.96539,
    lng: -87.11933,
    city: "Lester",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1143,
    density: 17.9,
    county_fips: "01083",
    county_name: "Limestone",
    county_weights: {
      "01083": 100,
    },
    county_names_all: "Limestone",
    county_fips_all: "01083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35648,
    lat: 34.95857,
    lng: -87.38022,
    city: "Lexington",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3226,
    density: 20.1,
    county_fips: "01077",
    county_name: "Lauderdale",
    county_weights: {
      "01077": 100,
    },
    county_names_all: "Lauderdale",
    county_fips_all: "01077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35649,
    lat: 34.62091,
    lng: -86.87965,
    city: "Mooresville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 87,
    density: 13.3,
    county_fips: "01083",
    county_name: "Limestone",
    county_weights: {
      "01083": 100,
    },
    county_names_all: "Limestone",
    county_fips_all: "01083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35650,
    lat: 34.45176,
    lng: -87.30289,
    city: "Moulton",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13534,
    density: 24.6,
    county_fips: "01079",
    county_name: "Lawrence",
    county_weights: {
      "01079": 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: "01079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35651,
    lat: 34.46254,
    lng: -87.48044,
    city: "Mount Hope",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1614,
    density: 15.4,
    county_fips: "01079",
    county_name: "Lawrence",
    county_weights: {
      "01079": 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: "01079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35652,
    lat: 34.84742,
    lng: -87.31137,
    city: "Rogersville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9104,
    density: 41.2,
    county_fips: "01077",
    county_name: "Lauderdale",
    county_weights: {
      "01077": 97.89,
      "01083": 2.11,
    },
    county_names_all: "Lauderdale|Limestone",
    county_fips_all: "01077|01083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35653,
    lat: 34.53131,
    lng: -87.86974,
    city: "Russellville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10621,
    density: 27.4,
    county_fips: "01059",
    county_name: "Franklin",
    county_weights: {
      "01059": 79.12,
      "01033": 20.88,
    },
    county_names_all: "Franklin|Colbert",
    county_fips_all: "01059|01033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35654,
    lat: 34.49971,
    lng: -87.62,
    city: "Russellville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8023,
    density: 20.8,
    county_fips: "01059",
    county_name: "Franklin",
    county_weights: {
      "01059": 82.45,
      "01033": 9.64,
      "01079": 7.91,
    },
    county_names_all: "Franklin|Colbert|Lawrence",
    county_fips_all: "01059|01033|01079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35660,
    lat: 34.75837,
    lng: -87.69847,
    city: "Sheffield",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8925,
    density: 559.9,
    county_fips: "01033",
    county_name: "Colbert",
    county_weights: {
      "01033": 100,
    },
    county_names_all: "Colbert",
    county_fips_all: "01033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35661,
    lat: 34.77737,
    lng: -87.56331,
    city: "Muscle Shoals",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17576,
    density: 132.6,
    county_fips: "01033",
    county_name: "Colbert",
    county_weights: {
      "01033": 100,
    },
    county_names_all: "Colbert",
    county_fips_all: "01033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35670,
    lat: 34.46318,
    lng: -86.72356,
    city: "Somerville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6443,
    density: 25.2,
    county_fips: "01103",
    county_name: "Morgan",
    county_weights: {
      "01103": 100,
    },
    county_names_all: "Morgan",
    county_fips_all: "01103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35671,
    lat: 34.66607,
    lng: -86.95191,
    city: "Tanner",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2621,
    density: 21.5,
    county_fips: "01083",
    county_name: "Limestone",
    county_weights: {
      "01083": 100,
    },
    county_names_all: "Limestone",
    county_fips_all: "01083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35672,
    lat: 34.65106,
    lng: -87.40705,
    city: "Town Creek",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5191,
    density: 14.8,
    county_fips: "01079",
    county_name: "Lawrence",
    county_weights: {
      "01079": 94.45,
      "01033": 5.55,
    },
    county_names_all: "Lawrence|Colbert",
    county_fips_all: "01079|01033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35673,
    lat: 34.58601,
    lng: -87.13166,
    city: "Trinity",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7971,
    density: 66.6,
    county_fips: "01079",
    county_name: "Lawrence",
    county_weights: {
      "01079": 71.65,
      "01103": 28.35,
    },
    county_names_all: "Lawrence|Morgan",
    county_fips_all: "01079|01103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35674,
    lat: 34.66343,
    lng: -87.75996,
    city: "Tuscumbia",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19187,
    density: 42.6,
    county_fips: "01033",
    county_name: "Colbert",
    county_weights: {
      "01033": 100,
    },
    county_names_all: "Colbert",
    county_fips_all: "01033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35677,
    lat: 34.95367,
    lng: -88.02529,
    city: "Waterloo",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2099,
    density: 7.3,
    county_fips: "01077",
    county_name: "Lauderdale",
    county_weights: {
      "01077": 100,
    },
    county_names_all: "Lauderdale",
    county_fips_all: "01077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35739,
    lat: 34.96914,
    lng: -86.79501,
    city: "Ardmore",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4380,
    density: 63.4,
    county_fips: "01083",
    county_name: "Limestone",
    county_weights: {
      "01083": 55.35,
      "01089": 44.65,
    },
    county_names_all: "Limestone|Madison",
    county_fips_all: "01083|01089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35740,
    lat: 34.95009,
    lng: -85.75855,
    city: "Bridgeport",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3342,
    density: 36.1,
    county_fips: "01071",
    county_name: "Jackson",
    county_weights: {
      "01071": 100,
    },
    county_names_all: "Jackson",
    county_fips_all: "01071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35741,
    lat: 34.7242,
    lng: -86.47745,
    city: "Brownsboro",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3829,
    density: 60.3,
    county_fips: "01089",
    county_name: "Madison",
    county_weights: {
      "01089": 100,
    },
    county_names_all: "Madison",
    county_fips_all: "01089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35744,
    lat: 34.61435,
    lng: -85.90603,
    city: "Dutton",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1720,
    density: 20.1,
    county_fips: "01071",
    county_name: "Jackson",
    county_weights: {
      "01071": 100,
    },
    county_names_all: "Jackson",
    county_fips_all: "01071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35745,
    lat: 34.94101,
    lng: -86.20002,
    city: "Estillfork",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 137,
    density: 0.8,
    county_fips: "01071",
    county_name: "Jackson",
    county_weights: {
      "01071": 100,
    },
    county_names_all: "Jackson",
    county_fips_all: "01071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35746,
    lat: 34.8287,
    lng: -85.99868,
    city: "Fackler",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 558,
    density: 4,
    county_fips: "01071",
    county_name: "Jackson",
    county_weights: {
      "01071": 100,
    },
    county_names_all: "Jackson",
    county_fips_all: "01071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35747,
    lat: 34.49414,
    lng: -86.30497,
    city: "Grant",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5828,
    density: 29.9,
    county_fips: "01095",
    county_name: "Marshall",
    county_weights: {
      "01095": 100,
    },
    county_names_all: "Marshall",
    county_fips_all: "01095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35748,
    lat: 34.71925,
    lng: -86.39036,
    city: "Gurley",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6612,
    density: 33,
    county_fips: "01089",
    county_name: "Madison",
    county_weights: {
      "01089": 92.96,
      "01071": 7.04,
    },
    county_names_all: "Madison|Jackson",
    county_fips_all: "01089|01071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35749,
    lat: 34.82314,
    lng: -86.75662,
    city: "Harvest",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23239,
    density: 206.1,
    county_fips: "01089",
    county_name: "Madison",
    county_weights: {
      "01089": 70.03,
      "01083": 29.97,
    },
    county_names_all: "Madison|Limestone",
    county_fips_all: "01089|01083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35750,
    lat: 34.95407,
    lng: -86.5951,
    city: "Hazel Green",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13317,
    density: 84.1,
    county_fips: "01089",
    county_name: "Madison",
    county_weights: {
      "01089": 100,
    },
    county_names_all: "Madison",
    county_fips_all: "01089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35751,
    lat: 34.81066,
    lng: -86.27931,
    city: "Hollytree",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 227,
    density: 3.1,
    county_fips: "01071",
    county_name: "Jackson",
    county_weights: {
      "01071": 100,
    },
    county_names_all: "Jackson",
    county_fips_all: "01071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35752,
    lat: 34.75593,
    lng: -85.95119,
    city: "Hollywood",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2192,
    density: 19.2,
    county_fips: "01071",
    county_name: "Jackson",
    county_weights: {
      "01071": 100,
    },
    county_names_all: "Jackson",
    county_fips_all: "01071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35754,
    lat: 34.51819,
    lng: -86.61099,
    city: "Laceys Spring",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5806,
    density: 51.1,
    county_fips: "01103",
    county_name: "Morgan",
    county_weights: {
      "01103": 96.54,
      "01095": 3.46,
    },
    county_names_all: "Morgan|Marshall",
    county_fips_all: "01103|01095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35755,
    lat: 34.50676,
    lng: -86.12609,
    city: "Langston",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 435,
    density: 9.5,
    county_fips: "01095",
    county_name: "Marshall",
    county_weights: {
      "01095": 62.03,
      "01071": 37.97,
    },
    county_names_all: "Marshall|Jackson",
    county_fips_all: "01095|01071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35756,
    lat: 34.64287,
    lng: -86.82114,
    city: "Madison",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14757,
    density: 71,
    county_fips: "01083",
    county_name: "Limestone",
    county_weights: {
      "01083": 81.76,
      "01089": 18.24,
    },
    county_names_all: "Limestone|Madison",
    county_fips_all: "01083|01089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35757,
    lat: 34.78426,
    lng: -86.74419,
    city: "Madison",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17972,
    density: 595,
    county_fips: "01089",
    county_name: "Madison",
    county_weights: {
      "01089": 96.68,
      "01083": 3.32,
    },
    county_names_all: "Madison|Limestone",
    county_fips_all: "01089|01083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35758,
    lat: 34.71417,
    lng: -86.74707,
    city: "Madison",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47979,
    density: 680.7,
    county_fips: "01089",
    county_name: "Madison",
    county_weights: {
      "01089": 100,
    },
    county_names_all: "Madison",
    county_fips_all: "01089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35759,
    lat: 34.86856,
    lng: -86.55262,
    city: "Meridianville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8479,
    density: 177.1,
    county_fips: "01089",
    county_name: "Madison",
    county_weights: {
      "01089": 100,
    },
    county_names_all: "Madison",
    county_fips_all: "01089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35760,
    lat: 34.54768,
    lng: -86.38324,
    city: "New Hope",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4797,
    density: 36.5,
    county_fips: "01089",
    county_name: "Madison",
    county_weights: {
      "01089": 92.68,
      "01095": 7.32,
    },
    county_names_all: "Madison|Marshall",
    county_fips_all: "01089|01095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35761,
    lat: 34.914,
    lng: -86.41001,
    city: "New Market",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13229,
    density: 43.8,
    county_fips: "01089",
    county_name: "Madison",
    county_weights: {
      "01089": 100,
    },
    county_names_all: "Madison",
    county_fips_all: "01089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35763,
    lat: 34.62022,
    lng: -86.46615,
    city: "Owens Cross Roads",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18422,
    density: 174.1,
    county_fips: "01089",
    county_name: "Madison",
    county_weights: {
      "01089": 100,
    },
    county_names_all: "Madison",
    county_fips_all: "01089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35764,
    lat: 34.73102,
    lng: -86.31381,
    city: "Paint Rock",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 554,
    density: 7.6,
    county_fips: "01071",
    county_name: "Jackson",
    county_weights: {
      "01071": 100,
    },
    county_names_all: "Jackson",
    county_fips_all: "01071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35765,
    lat: 34.69393,
    lng: -85.82423,
    city: "Pisgah",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4112,
    density: 22.3,
    county_fips: "01071",
    county_name: "Jackson",
    county_weights: {
      "01071": 94.8,
      "01049": 5.2,
    },
    county_names_all: "Jackson|DeKalb",
    county_fips_all: "01071|01049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35766,
    lat: 34.87342,
    lng: -86.27661,
    city: "Princeton",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 171,
    density: 1.8,
    county_fips: "01071",
    county_name: "Jackson",
    county_weights: {
      "01071": 100,
    },
    county_names_all: "Jackson",
    county_fips_all: "01071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35768,
    lat: 34.77852,
    lng: -86.10383,
    city: "Scottsboro",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12224,
    density: 27.4,
    county_fips: "01071",
    county_name: "Jackson",
    county_weights: {
      "01071": 100,
    },
    county_names_all: "Jackson",
    county_fips_all: "01071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35769,
    lat: 34.59255,
    lng: -86.09472,
    city: "Scottsboro",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9376,
    density: 57.4,
    county_fips: "01071",
    county_name: "Jackson",
    county_weights: {
      "01071": 73.36,
      "01095": 26.64,
    },
    county_names_all: "Jackson|Marshall",
    county_fips_all: "01071|01095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35771,
    lat: 34.53635,
    lng: -85.99843,
    city: "Section",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3681,
    density: 22.9,
    county_fips: "01071",
    county_name: "Jackson",
    county_weights: {
      "01071": 96.27,
      "01049": 3.73,
    },
    county_names_all: "Jackson|DeKalb",
    county_fips_all: "01071|01049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35772,
    lat: 34.89152,
    lng: -85.88614,
    city: "Stevenson",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4722,
    density: 11.1,
    county_fips: "01071",
    county_name: "Jackson",
    county_weights: {
      "01071": 100,
    },
    county_names_all: "Jackson",
    county_fips_all: "01071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35773,
    lat: 34.89431,
    lng: -86.71282,
    city: "Toney",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13688,
    density: 72.9,
    county_fips: "01089",
    county_name: "Madison",
    county_weights: {
      "01089": 78.19,
      "01083": 21.81,
    },
    county_names_all: "Madison|Limestone",
    county_fips_all: "01089|01083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35774,
    lat: 34.7611,
    lng: -86.22805,
    city: "Trenton",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 175,
    density: 4.8,
    county_fips: "01071",
    county_name: "Jackson",
    county_weights: {
      "01071": 100,
    },
    county_names_all: "Jackson",
    county_fips_all: "01071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35775,
    lat: 34.5477,
    lng: -86.69623,
    city: "Valhermoso Springs",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 726,
    density: 16.8,
    county_fips: "01103",
    county_name: "Morgan",
    county_weights: {
      "01103": 100,
    },
    county_names_all: "Morgan",
    county_fips_all: "01103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35776,
    lat: 34.66083,
    lng: -86.24338,
    city: "Woodville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3596,
    density: 13.4,
    county_fips: "01071",
    county_name: "Jackson",
    county_weights: {
      "01071": 78.79,
      "01095": 18.71,
      "01089": 2.5,
    },
    county_names_all: "Jackson|Marshall|Madison",
    county_fips_all: "01071|01095|01089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35801,
    lat: 34.72497,
    lng: -86.56304,
    city: "Huntsville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24337,
    density: 678.7,
    county_fips: "01089",
    county_name: "Madison",
    county_weights: {
      "01089": 100,
    },
    county_names_all: "Madison",
    county_fips_all: "01089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35802,
    lat: 34.67398,
    lng: -86.55449,
    city: "Huntsville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22301,
    density: 524.3,
    county_fips: "01089",
    county_name: "Madison",
    county_weights: {
      "01089": 100,
    },
    county_names_all: "Madison",
    county_fips_all: "01089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35803,
    lat: 34.56476,
    lng: -86.52185,
    city: "Huntsville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26504,
    density: 207.9,
    county_fips: "01089",
    county_name: "Madison",
    county_weights: {
      "01089": 100,
    },
    county_names_all: "Madison",
    county_fips_all: "01089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35805,
    lat: 34.70875,
    lng: -86.6219,
    city: "Huntsville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19761,
    density: 830.1,
    county_fips: "01089",
    county_name: "Madison",
    county_weights: {
      "01089": 100,
    },
    county_names_all: "Madison",
    county_fips_all: "01089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35806,
    lat: 34.76615,
    lng: -86.68324,
    city: "Huntsville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24132,
    density: 366.1,
    county_fips: "01089",
    county_name: "Madison",
    county_weights: {
      "01089": 100,
    },
    county_names_all: "Madison",
    county_fips_all: "01089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35808,
    lat: 34.63236,
    lng: -86.65579,
    city: "Huntsville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1308,
    density: 8.6,
    county_fips: "01089",
    county_name: "Madison",
    county_weights: {
      "01089": 100,
    },
    county_names_all: "Madison",
    county_fips_all: "01089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35810,
    lat: 34.80183,
    lng: -86.60264,
    city: "Huntsville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30243,
    density: 414.8,
    county_fips: "01089",
    county_name: "Madison",
    county_weights: {
      "01089": 100,
    },
    county_names_all: "Madison",
    county_fips_all: "01089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35811,
    lat: 34.79925,
    lng: -86.50386,
    city: "Huntsville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26198,
    density: 215.8,
    county_fips: "01089",
    county_name: "Madison",
    county_weights: {
      "01089": 100,
    },
    county_names_all: "Madison",
    county_fips_all: "01089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35816,
    lat: 34.73923,
    lng: -86.62985,
    city: "Huntsville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14219,
    density: 1084,
    county_fips: "01089",
    county_name: "Madison",
    county_weights: {
      "01089": 100,
    },
    county_names_all: "Madison",
    county_fips_all: "01089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35824,
    lat: 34.64458,
    lng: -86.75193,
    city: "Huntsville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8352,
    density: 254.2,
    county_fips: "01089",
    county_name: "Madison",
    county_weights: {
      "01089": 100,
    },
    county_names_all: "Madison",
    county_fips_all: "01089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35896,
    lat: 34.75318,
    lng: -86.65213,
    city: "Huntsville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 615,
    density: 546.7,
    county_fips: "01089",
    county_name: "Madison",
    county_weights: {
      "01089": 100,
    },
    county_names_all: "Madison",
    county_fips_all: "01089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35901,
    lat: 34.04848,
    lng: -85.92395,
    city: "Gadsden",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18903,
    density: 123.3,
    county_fips: "01055",
    county_name: "Etowah",
    county_weights: {
      "01055": 96.68,
      "01019": 3.32,
    },
    county_names_all: "Etowah|Cherokee",
    county_fips_all: "01055|01019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35903,
    lat: 34.03144,
    lng: -85.85703,
    city: "Gadsden",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18240,
    density: 103.2,
    county_fips: "01055",
    county_name: "Etowah",
    county_weights: {
      "01055": 91.47,
      "01019": 8.53,
    },
    county_names_all: "Etowah|Cherokee",
    county_fips_all: "01055|01019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35904,
    lat: 34.07569,
    lng: -85.98519,
    city: "Gadsden",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14130,
    density: 111.8,
    county_fips: "01055",
    county_name: "Etowah",
    county_weights: {
      "01055": 100,
    },
    county_names_all: "Etowah",
    county_fips_all: "01055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35905,
    lat: 33.93667,
    lng: -85.89842,
    city: "Gadsden",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5852,
    density: 54,
    county_fips: "01055",
    county_name: "Etowah",
    county_weights: {
      "01055": 76.46,
      "01015": 23.54,
    },
    county_names_all: "Etowah|Calhoun",
    county_fips_all: "01055|01015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35906,
    lat: 33.93159,
    lng: -86.09033,
    city: "Rainbow City",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9926,
    density: 109.6,
    county_fips: "01055",
    county_name: "Etowah",
    county_weights: {
      "01055": 100,
    },
    county_names_all: "Etowah",
    county_fips_all: "01055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35907,
    lat: 33.89874,
    lng: -86.02408,
    city: "Gadsden",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8692,
    density: 152,
    county_fips: "01055",
    county_name: "Etowah",
    county_weights: {
      "01055": 100,
    },
    county_names_all: "Etowah",
    county_fips_all: "01055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35950,
    lat: 34.25273,
    lng: -86.26023,
    city: "Albertville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20728,
    density: 185,
    county_fips: "01095",
    county_name: "Marshall",
    county_weights: {
      "01095": 100,
    },
    county_names_all: "Marshall",
    county_fips_all: "01095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35951,
    lat: 34.33713,
    lng: -86.1553,
    city: "Albertville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12226,
    density: 60.7,
    county_fips: "01095",
    county_name: "Marshall",
    county_weights: {
      "01095": 80.99,
      "01049": 19.01,
    },
    county_names_all: "Marshall|DeKalb",
    county_fips_all: "01095|01049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35952,
    lat: 34.05322,
    lng: -86.3082,
    city: "Altoona",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8318,
    density: 29.3,
    county_fips: "01055",
    county_name: "Etowah",
    county_weights: {
      "01055": 55.02,
      "01009": 44.67,
      "01095": 0.31,
    },
    county_names_all: "Etowah|Blount|Marshall",
    county_fips_all: "01055|01009|01095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35953,
    lat: 33.81058,
    lng: -86.20986,
    city: "Ashville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6944,
    density: 20.8,
    county_fips: "01115",
    county_name: "St. Clair",
    county_weights: {
      "01115": 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: "01115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35954,
    lat: 34.08952,
    lng: -86.05771,
    city: "Attalla",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12095,
    density: 43.8,
    county_fips: "01055",
    county_name: "Etowah",
    county_weights: {
      "01055": 94.71,
      "01049": 5.29,
    },
    county_names_all: "Etowah|DeKalb",
    county_fips_all: "01055|01049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35956,
    lat: 34.1433,
    lng: -86.14799,
    city: "Boaz",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8608,
    density: 44.7,
    county_fips: "01055",
    county_name: "Etowah",
    county_weights: {
      "01055": 99.87,
      "01049": 0.13,
    },
    county_names_all: "Etowah|DeKalb",
    county_fips_all: "01055|01049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35957,
    lat: 34.19105,
    lng: -86.19531,
    city: "Boaz",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15861,
    density: 78.2,
    county_fips: "01095",
    county_name: "Marshall",
    county_weights: {
      "01095": 74.38,
      "01049": 20.63,
      "01009": 4.99,
    },
    county_names_all: "Marshall|DeKalb|Blount",
    county_fips_all: "01095|01049|01009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35958,
    lat: 34.91796,
    lng: -85.64731,
    city: "Bryant",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3237,
    density: 23.7,
    county_fips: "01071",
    county_name: "Jackson",
    county_weights: {
      "01071": 100,
    },
    county_names_all: "Jackson",
    county_fips_all: "01071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35959,
    lat: 34.23968,
    lng: -85.60575,
    city: "Cedar Bluff",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4348,
    density: 27.1,
    county_fips: "01019",
    county_name: "Cherokee",
    county_weights: {
      "01019": 99.51,
      "01049": 0.49,
    },
    county_names_all: "Cherokee|DeKalb",
    county_fips_all: "01019|01049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35960,
    lat: 34.12515,
    lng: -85.56786,
    city: "Centre",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9039,
    density: 23.8,
    county_fips: "01019",
    county_name: "Cherokee",
    county_weights: {
      "01019": 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: "01019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35961,
    lat: 34.27753,
    lng: -85.86241,
    city: "Collinsville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6623,
    density: 21.7,
    county_fips: "01049",
    county_name: "DeKalb",
    county_weights: {
      "01049": 81.47,
      "01019": 10.57,
      "01055": 7.96,
    },
    county_names_all: "DeKalb|Cherokee|Etowah",
    county_fips_all: "01049|01019|01055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35962,
    lat: 34.29916,
    lng: -86.03795,
    city: "Crossville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8327,
    density: 45,
    county_fips: "01049",
    county_name: "DeKalb",
    county_weights: {
      "01049": 90.75,
      "01095": 9.25,
    },
    county_names_all: "DeKalb|Marshall",
    county_fips_all: "01049|01095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35963,
    lat: 34.35812,
    lng: -85.93114,
    city: "Dawson",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1076,
    density: 14.4,
    county_fips: "01049",
    county_name: "DeKalb",
    county_weights: {
      "01049": 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: "01049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35966,
    lat: 34.79696,
    lng: -85.68833,
    city: "Flat Rock",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3951,
    density: 18.1,
    county_fips: "01071",
    county_name: "Jackson",
    county_weights: {
      "01071": 75.51,
      "01049": 24.49,
    },
    county_names_all: "Jackson|DeKalb",
    county_fips_all: "01071|01049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35967,
    lat: 34.3981,
    lng: -85.69698,
    city: "Fort Payne",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15993,
    density: 48.6,
    county_fips: "01049",
    county_name: "DeKalb",
    county_weights: {
      "01049": 92.34,
      "01019": 7.66,
    },
    county_names_all: "DeKalb|Cherokee",
    county_fips_all: "01049|01019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35968,
    lat: 34.48095,
    lng: -85.77232,
    city: "Fort Payne",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5033,
    density: 30.6,
    county_fips: "01049",
    county_name: "DeKalb",
    county_weights: {
      "01049": 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: "01049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35971,
    lat: 34.45603,
    lng: -85.9466,
    city: "Fyffe",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6344,
    density: 44.4,
    county_fips: "01049",
    county_name: "DeKalb",
    county_weights: {
      "01049": 99.67,
      "01071": 0.33,
    },
    county_names_all: "DeKalb|Jackson",
    county_fips_all: "01049|01071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35972,
    lat: 33.98797,
    lng: -86.24943,
    city: "Gallant",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1196,
    density: 17.6,
    county_fips: "01055",
    county_name: "Etowah",
    county_weights: {
      "01055": 64.99,
      "01115": 35.01,
    },
    county_names_all: "Etowah|St. Clair",
    county_fips_all: "01055|01115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35973,
    lat: 34.34222,
    lng: -85.5554,
    city: "Gaylesville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3368,
    density: 11.8,
    county_fips: "01019",
    county_name: "Cherokee",
    county_weights: {
      "01019": 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: "01019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35974,
    lat: 34.36284,
    lng: -86.0099,
    city: "Geraldine",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1641,
    density: 51.2,
    county_fips: "01049",
    county_name: "DeKalb",
    county_weights: {
      "01049": 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: "01049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35975,
    lat: 34.43832,
    lng: -86.06655,
    city: "Groveoak",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 999,
    density: 11.3,
    county_fips: "01049",
    county_name: "DeKalb",
    county_weights: {
      "01049": 72.66,
      "01095": 27.34,
    },
    county_names_all: "DeKalb|Marshall",
    county_fips_all: "01049|01095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35976,
    lat: 34.34819,
    lng: -86.32919,
    city: "Guntersville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17655,
    density: 53.4,
    county_fips: "01095",
    county_name: "Marshall",
    county_weights: {
      "01095": 93.82,
      "01009": 6.18,
    },
    county_names_all: "Marshall|Blount",
    county_fips_all: "01095|01009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35978,
    lat: 34.64239,
    lng: -85.72983,
    city: "Henagar",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5435,
    density: 30.3,
    county_fips: "01049",
    county_name: "DeKalb",
    county_weights: {
      "01049": 77.51,
      "01071": 22.49,
    },
    county_names_all: "DeKalb|Jackson",
    county_fips_all: "01049|01071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35979,
    lat: 34.82994,
    lng: -85.6125,
    city: "Higdon",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1032,
    density: 34.3,
    county_fips: "01049",
    county_name: "DeKalb",
    county_weights: {
      "01049": 64.23,
      "01071": 35.77,
    },
    county_names_all: "DeKalb|Jackson",
    county_fips_all: "01049|01071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35980,
    lat: 34.17719,
    lng: -86.38335,
    city: "Horton",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5925,
    density: 41.6,
    county_fips: "01095",
    county_name: "Marshall",
    county_weights: {
      "01095": 52.17,
      "01009": 47.83,
    },
    county_names_all: "Marshall|Blount",
    county_fips_all: "01095|01009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35981,
    lat: 34.72218,
    lng: -85.64072,
    city: "Ider",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2040,
    density: 30.2,
    county_fips: "01049",
    county_name: "DeKalb",
    county_weights: {
      "01049": 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: "01049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35983,
    lat: 34.17088,
    lng: -85.76746,
    city: "Leesburg",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3827,
    density: 30.7,
    county_fips: "01019",
    county_name: "Cherokee",
    county_weights: {
      "01019": 99.6,
      "01049": 0.4,
    },
    county_names_all: "Cherokee|DeKalb",
    county_fips_all: "01019|01049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35984,
    lat: 34.52781,
    lng: -85.56594,
    city: "Mentone",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1623,
    density: 8.8,
    county_fips: "01049",
    county_name: "DeKalb",
    county_weights: {
      "01049": 70.23,
      "01019": 29.77,
    },
    county_names_all: "DeKalb|Cherokee",
    county_fips_all: "01049|01019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35986,
    lat: 34.50524,
    lng: -85.84012,
    city: "Rainsville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7833,
    density: 70.2,
    county_fips: "01049",
    county_name: "DeKalb",
    county_weights: {
      "01049": 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: "01049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35987,
    lat: 33.91557,
    lng: -86.23889,
    city: "Steele",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2421,
    density: 15.5,
    county_fips: "01115",
    county_name: "St. Clair",
    county_weights: {
      "01115": 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: "01115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35988,
    lat: 34.5589,
    lng: -85.79994,
    city: "Sylvania",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2355,
    density: 73.9,
    county_fips: "01049",
    county_name: "DeKalb",
    county_weights: {
      "01049": 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: "01049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35989,
    lat: 34.60858,
    lng: -85.63162,
    city: "Valley Head",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4063,
    density: 27.4,
    county_fips: "01049",
    county_name: "DeKalb",
    county_weights: {
      "01049": 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: "01049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 35990,
    lat: 34.06676,
    lng: -86.3052,
    city: "Walnut Grove",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69,
    density: 474.6,
    county_fips: "01055",
    county_name: "Etowah",
    county_weights: {
      "01055": 100,
    },
    county_names_all: "Etowah",
    county_fips_all: "01055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36003,
    lat: 32.44651,
    lng: -86.72536,
    city: "Autaugaville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1830,
    density: 8.6,
    county_fips: "01001",
    county_name: "Autauga",
    county_weights: {
      "01001": 100,
    },
    county_names_all: "Autauga",
    county_fips_all: "01001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36005,
    lat: 31.88137,
    lng: -85.72802,
    city: "Banks",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1411,
    density: 3.6,
    county_fips: "01109",
    county_name: "Pike",
    county_weights: {
      "01109": 54.71,
      "01011": 44.91,
      "01005": 0.38,
    },
    county_names_all: "Pike|Bullock|Barbour",
    county_fips_all: "01109|01011|01005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36006,
    lat: 32.63831,
    lng: -86.72531,
    city: "Billingsley",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1571,
    density: 7.9,
    county_fips: "01001",
    county_name: "Autauga",
    county_weights: {
      "01001": 75.57,
      "01021": 24.43,
    },
    county_names_all: "Autauga|Chilton",
    county_fips_all: "01001|01021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36008,
    lat: 32.49747,
    lng: -86.56416,
    city: "Booth",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "01001",
    county_name: "Autauga",
    county_weights: {
      "01001": 100,
    },
    county_names_all: "Autauga",
    county_fips_all: "01001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36009,
    lat: 31.58395,
    lng: -86.30531,
    city: "Brantley",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2257,
    density: 5.4,
    county_fips: "01041",
    county_name: "Crenshaw",
    county_weights: {
      "01041": 98.8,
      "01031": 1.2,
    },
    county_names_all: "Crenshaw|Coffee",
    county_fips_all: "01041|01031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36010,
    lat: 31.66751,
    lng: -85.81439,
    city: "Brundidge",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5047,
    density: 15,
    county_fips: "01109",
    county_name: "Pike",
    county_weights: {
      "01109": 80.96,
      "01031": 16.98,
      "01045": 2.06,
    },
    county_names_all: "Pike|Coffee|Dale",
    county_fips_all: "01109|01031|01045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36013,
    lat: 32.2976,
    lng: -85.97959,
    city: "Cecil",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 631,
    density: 16.3,
    county_fips: "01101",
    county_name: "Montgomery",
    county_weights: {
      "01101": 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: "01101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36016,
    lat: 31.84562,
    lng: -85.4255,
    city: "Clayton",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5360,
    density: 8.9,
    county_fips: "01005",
    county_name: "Barbour",
    county_weights: {
      "01005": 98.63,
      "01067": 1.37,
    },
    county_names_all: "Barbour|Henry",
    county_fips_all: "01005|01067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36017,
    lat: 31.68142,
    lng: -85.55411,
    city: "Clio",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3042,
    density: 19,
    county_fips: "01005",
    county_name: "Barbour",
    county_weights: {
      "01005": 100,
    },
    county_names_all: "Barbour",
    county_fips_all: "01005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36020,
    lat: 32.49616,
    lng: -86.31858,
    city: "Coosada",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 988,
    density: 45.4,
    county_fips: "01051",
    county_name: "Elmore",
    county_weights: {
      "01051": 100,
    },
    county_names_all: "Elmore",
    county_fips_all: "01051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36022,
    lat: 32.61951,
    lng: -86.40492,
    city: "Deatsville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12833,
    density: 55.1,
    county_fips: "01051",
    county_name: "Elmore",
    county_weights: {
      "01051": 56.3,
      "01001": 43.7,
    },
    county_names_all: "Elmore|Autauga",
    county_fips_all: "01051|01001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36024,
    lat: 32.6654,
    lng: -86.03312,
    city: "Eclectic",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4234,
    density: 18.5,
    county_fips: "01051",
    county_name: "Elmore",
    county_weights: {
      "01051": 100,
    },
    county_names_all: "Elmore",
    county_fips_all: "01051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36025,
    lat: 32.54664,
    lng: -86.33941,
    city: "Elmore",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6722,
    density: 202.5,
    county_fips: "01051",
    county_name: "Elmore",
    county_weights: {
      "01051": 100,
    },
    county_names_all: "Elmore",
    county_fips_all: "01051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36026,
    lat: 32.77587,
    lng: -86.13269,
    city: "Equality",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 976,
    density: 5.2,
    county_fips: "01037",
    county_name: "Coosa",
    county_weights: {
      "01037": 75.92,
      "01051": 24.08,
    },
    county_names_all: "Coosa|Elmore",
    county_fips_all: "01037|01051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36027,
    lat: 31.93307,
    lng: -85.20968,
    city: "Eufaula",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14282,
    density: 19,
    county_fips: "01005",
    county_name: "Barbour",
    county_weights: {
      "01005": 85.23,
      "01113": 12.07,
      "01067": 2.7,
    },
    county_names_all: "Barbour|Russell|Henry",
    county_fips_all: "01005|01113|01067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36028,
    lat: 31.49031,
    lng: -86.38271,
    city: "Dozier",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1474,
    density: 5,
    county_fips: "01039",
    county_name: "Covington",
    county_weights: {
      "01039": 60.06,
      "01041": 39.94,
    },
    county_names_all: "Covington|Crenshaw",
    county_fips_all: "01039|01041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36029,
    lat: 32.18479,
    lng: -85.92953,
    city: "Fitzpatrick",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1008,
    density: 3.3,
    county_fips: "01011",
    county_name: "Bullock",
    county_weights: {
      "01011": 87.58,
      "01087": 9.12,
      "01101": 3.3,
    },
    county_names_all: "Bullock|Macon|Montgomery",
    county_fips_all: "01011|01087|01101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36030,
    lat: 31.86044,
    lng: -86.85697,
    city: "Forest Home",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 540,
    density: 2.8,
    county_fips: "01013",
    county_name: "Butler",
    county_weights: {
      "01013": 100,
    },
    county_names_all: "Butler",
    county_fips_all: "01013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36031,
    lat: 32.24944,
    lng: -85.75157,
    city: "Fort Davis",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 129,
    density: 5.1,
    county_fips: "01087",
    county_name: "Macon",
    county_weights: {
      "01087": 99.9,
      "01011": 0.1,
    },
    county_names_all: "Macon|Bullock",
    county_fips_all: "01087|01011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36032,
    lat: 31.99857,
    lng: -86.57179,
    city: "Fort Deposit",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2522,
    density: 8.3,
    county_fips: "01085",
    county_name: "Lowndes",
    county_weights: {
      "01085": 85.68,
      "01013": 14.32,
    },
    county_names_all: "Lowndes|Butler",
    county_fips_all: "01085|01013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36033,
    lat: 31.66983,
    lng: -86.771,
    city: "Georgiana",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3824,
    density: 7,
    county_fips: "01013",
    county_name: "Butler",
    county_weights: {
      "01013": 90.47,
      "01035": 7.51,
      "01099": 2.02,
    },
    county_names_all: "Butler|Conecuh|Monroe",
    county_fips_all: "01013|01035|01099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36034,
    lat: 31.62308,
    lng: -86.11155,
    city: "Glenwood",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1141,
    density: 7.3,
    county_fips: "01109",
    county_name: "Pike",
    county_weights: {
      "01109": 47.59,
      "01031": 32.09,
      "01041": 20.32,
    },
    county_names_all: "Pike|Coffee|Crenshaw",
    county_fips_all: "01109|01031|01041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36035,
    lat: 31.79285,
    lng: -86.12415,
    city: "Goshen",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1691,
    density: 5.9,
    county_fips: "01109",
    county_name: "Pike",
    county_weights: {
      "01109": 80.19,
      "01041": 19.81,
    },
    county_names_all: "Pike|Crenshaw",
    county_fips_all: "01109|01041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36036,
    lat: 31.97541,
    lng: -86.16063,
    city: "Grady",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2045,
    density: 8,
    county_fips: "01101",
    county_name: "Montgomery",
    county_weights: {
      "01101": 69.84,
      "01041": 30.16,
    },
    county_names_all: "Montgomery|Crenshaw",
    county_fips_all: "01101|01041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36037,
    lat: 31.79384,
    lng: -86.62356,
    city: "Greenville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13172,
    density: 13.6,
    county_fips: "01013",
    county_name: "Butler",
    county_weights: {
      "01013": 98.02,
      "01041": 1.98,
    },
    county_names_all: "Butler|Crenshaw",
    county_fips_all: "01013|01041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36038,
    lat: 31.40788,
    lng: -86.4869,
    city: "Gantt",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "01039",
    county_name: "Covington",
    county_weights: {
      "01039": 100,
    },
    county_names_all: "Covington",
    county_fips_all: "01039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36039,
    lat: 32.28939,
    lng: -85.82789,
    city: "Hardaway",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 139,
    density: 1.1,
    county_fips: "01087",
    county_name: "Macon",
    county_weights: {
      "01087": 100,
    },
    county_names_all: "Macon",
    county_fips_all: "01087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36040,
    lat: 32.17795,
    lng: -86.66972,
    city: "Hayneville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3516,
    density: 10.9,
    county_fips: "01085",
    county_name: "Lowndes",
    county_weights: {
      "01085": 100,
    },
    county_names_all: "Lowndes",
    county_fips_all: "01085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36041,
    lat: 31.92361,
    lng: -86.32172,
    city: "Highland Home",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1336,
    density: 9.3,
    county_fips: "01041",
    county_name: "Crenshaw",
    county_weights: {
      "01041": 98.85,
      "01101": 1.15,
    },
    county_names_all: "Crenshaw|Montgomery",
    county_fips_all: "01041|01101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36042,
    lat: 31.86655,
    lng: -86.44897,
    city: "Honoraville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1645,
    density: 8,
    county_fips: "01041",
    county_name: "Crenshaw",
    county_weights: {
      "01041": 50.87,
      "01013": 49.13,
    },
    county_names_all: "Crenshaw|Butler",
    county_fips_all: "01041|01013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36043,
    lat: 32.1939,
    lng: -86.42811,
    city: "Hope Hull",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3788,
    density: 11.8,
    county_fips: "01085",
    county_name: "Lowndes",
    county_weights: {
      "01085": 55.77,
      "01101": 44.23,
    },
    county_names_all: "Lowndes|Montgomery",
    county_fips_all: "01085|01101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36046,
    lat: 31.9994,
    lng: -86.33948,
    city: "Lapine",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1345,
    density: 8.4,
    county_fips: "01041",
    county_name: "Crenshaw",
    county_weights: {
      "01041": 67.41,
      "01101": 32.59,
    },
    county_names_all: "Crenshaw|Montgomery",
    county_fips_all: "01041|01101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36047,
    lat: 32.07868,
    lng: -86.52474,
    city: "Letohatchee",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1117,
    density: 4.1,
    county_fips: "01085",
    county_name: "Lowndes",
    county_weights: {
      "01085": 90.02,
      "01101": 9.98,
    },
    county_names_all: "Lowndes|Montgomery",
    county_fips_all: "01085|01101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36048,
    lat: 31.79011,
    lng: -85.59066,
    city: "Louisville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1373,
    density: 5,
    county_fips: "01005",
    county_name: "Barbour",
    county_weights: {
      "01005": 100,
    },
    county_names_all: "Barbour",
    county_fips_all: "01005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36049,
    lat: 31.76612,
    lng: -86.28092,
    city: "Luverne",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5965,
    density: 14.3,
    county_fips: "01041",
    county_name: "Crenshaw",
    county_weights: {
      "01041": 95.81,
      "01109": 4.19,
    },
    county_names_all: "Crenshaw|Pike",
    county_fips_all: "01041|01109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36051,
    lat: 32.68771,
    lng: -86.488,
    city: "Marbury",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2363,
    density: 17.5,
    county_fips: "01001",
    county_name: "Autauga",
    county_weights: {
      "01001": 63.88,
      "01051": 19.93,
      "01021": 16.19,
    },
    county_names_all: "Autauga|Elmore|Chilton",
    county_fips_all: "01001|01051|01021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36052,
    lat: 32.17935,
    lng: -86.04309,
    city: "Mathews",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 620,
    density: 3.3,
    county_fips: "01101",
    county_name: "Montgomery",
    county_weights: {
      "01101": 90.35,
      "01011": 9.65,
    },
    county_names_all: "Montgomery|Bullock",
    county_fips_all: "01101|01011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36053,
    lat: 32.03514,
    lng: -85.43945,
    city: "Midway",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1896,
    density: 2.3,
    county_fips: "01005",
    county_name: "Barbour",
    county_weights: {
      "01005": 58.93,
      "01011": 41.07,
    },
    county_names_all: "Barbour|Bullock",
    county_fips_all: "01005|01011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36054,
    lat: 32.46821,
    lng: -86.35962,
    city: "Millbrook",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15559,
    density: 214.1,
    county_fips: "01051",
    county_name: "Elmore",
    county_weights: {
      "01051": 86.92,
      "01101": 13.08,
    },
    county_names_all: "Elmore|Montgomery",
    county_fips_all: "01051|01101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36057,
    lat: 32.37464,
    lng: -86.08461,
    city: "Mount Meigs",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "01101",
    county_name: "Montgomery",
    county_weights: {
      "01101": 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: "01101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36064,
    lat: 32.3008,
    lng: -86.08186,
    city: "Pike Road",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10574,
    density: 47.5,
    county_fips: "01101",
    county_name: "Montgomery",
    county_weights: {
      "01101": 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: "01101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36066,
    lat: 32.48216,
    lng: -86.42431,
    city: "Prattville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20283,
    density: 389.2,
    county_fips: "01001",
    county_name: "Autauga",
    county_weights: {
      "01001": 67.38,
      "01051": 32.62,
    },
    county_names_all: "Autauga|Elmore",
    county_fips_all: "01001|01051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36067,
    lat: 32.51134,
    lng: -86.57084,
    city: "Prattville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27682,
    density: 43.7,
    county_fips: "01001",
    county_name: "Autauga",
    county_weights: {
      "01001": 100,
    },
    county_names_all: "Autauga",
    county_fips_all: "01001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36069,
    lat: 32.0905,
    lng: -86.16008,
    city: "Ramer",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1714,
    density: 4.4,
    county_fips: "01101",
    county_name: "Montgomery",
    county_weights: {
      "01101": 94.69,
      "01109": 5.31,
    },
    county_names_all: "Montgomery|Pike",
    county_fips_all: "01101|01109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36071,
    lat: 31.70534,
    lng: -86.39815,
    city: "Rutledge",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 479,
    density: 3.9,
    county_fips: "01041",
    county_name: "Crenshaw",
    county_weights: {
      "01041": 86.78,
      "01013": 13.22,
    },
    county_names_all: "Crenshaw|Butler",
    county_fips_all: "01041|01013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36075,
    lat: 32.38913,
    lng: -85.91257,
    city: "Shorter",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2206,
    density: 10.4,
    county_fips: "01087",
    county_name: "Macon",
    county_weights: {
      "01087": 100,
    },
    county_names_all: "Macon",
    county_fips_all: "01087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36078,
    lat: 32.53991,
    lng: -85.93328,
    city: "Tallassee",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13433,
    density: 29.2,
    county_fips: "01051",
    county_name: "Elmore",
    county_weights: {
      "01051": 73.1,
      "01123": 24.27,
      "01087": 2.63,
    },
    county_names_all: "Elmore|Tallapoosa|Macon",
    county_fips_all: "01051|01123|01087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36079,
    lat: 31.76605,
    lng: -86.01206,
    city: "Troy",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9789,
    density: 20.2,
    county_fips: "01109",
    county_name: "Pike",
    county_weights: {
      "01109": 92.92,
      "01031": 7.08,
    },
    county_names_all: "Pike|Coffee",
    county_fips_all: "01109|01031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36080,
    lat: 32.70497,
    lng: -86.28662,
    city: "Titus",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1997,
    density: 14.8,
    county_fips: "01051",
    county_name: "Elmore",
    county_weights: {
      "01051": 96.66,
      "01037": 3.34,
    },
    county_names_all: "Elmore|Coosa",
    county_fips_all: "01051|01037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36081,
    lat: 31.90663,
    lng: -85.89804,
    city: "Troy",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15701,
    density: 28.9,
    county_fips: "01109",
    county_name: "Pike",
    county_weights: {
      "01109": 85.26,
      "01011": 14.74,
    },
    county_names_all: "Pike|Bullock",
    county_fips_all: "01109|01011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36082,
    lat: 31.80271,
    lng: -85.95514,
    city: "Troy",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1004,
    density: 998.1,
    county_fips: "01109",
    county_name: "Pike",
    county_weights: {
      "01109": 100,
    },
    county_names_all: "Pike",
    county_fips_all: "01109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36083,
    lat: 32.39512,
    lng: -85.68672,
    city: "Tuskegee",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7187,
    density: 12.4,
    county_fips: "01087",
    county_name: "Macon",
    county_weights: {
      "01087": 100,
    },
    county_names_all: "Macon",
    county_fips_all: "01087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36088,
    lat: 32.41911,
    lng: -85.718,
    city: "Tuskegee Institute",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4511,
    density: 599.9,
    county_fips: "01087",
    county_name: "Macon",
    county_weights: {
      "01087": 100,
    },
    county_names_all: "Macon",
    county_fips_all: "01087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36089,
    lat: 32.15745,
    lng: -85.69872,
    city: "Union Springs",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7683,
    density: 9,
    county_fips: "01011",
    county_name: "Bullock",
    county_weights: {
      "01011": 77.86,
      "01087": 22.14,
    },
    county_names_all: "Bullock|Macon",
    county_fips_all: "01011|01087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36091,
    lat: 32.74881,
    lng: -86.52021,
    city: "Verbena",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3177,
    density: 14.7,
    county_fips: "01021",
    county_name: "Chilton",
    county_weights: {
      "01021": 84.65,
      "01001": 14.99,
      "01037": 0.36,
    },
    county_names_all: "Chilton|Autauga|Coosa",
    county_fips_all: "01021|01001|01037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36092,
    lat: 32.61401,
    lng: -86.19619,
    city: "Wetumpka",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20805,
    density: 58.2,
    county_fips: "01051",
    county_name: "Elmore",
    county_weights: {
      "01051": 100,
    },
    county_names_all: "Elmore",
    county_fips_all: "01051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36093,
    lat: 32.49584,
    lng: -86.13956,
    city: "Wetumpka",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10839,
    density: 53.3,
    county_fips: "01051",
    county_name: "Elmore",
    county_weights: {
      "01051": 100,
    },
    county_names_all: "Elmore",
    county_fips_all: "01051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36101,
    lat: 32.38177,
    lng: -86.29763,
    city: "Montgomery",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "01101",
    county_name: "Montgomery",
    county_weights: {
      "01101": 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: "01101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36104,
    lat: 32.39889,
    lng: -86.31593,
    city: "Montgomery",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9084,
    density: 335.6,
    county_fips: "01101",
    county_name: "Montgomery",
    county_weights: {
      "01101": 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: "01101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36105,
    lat: 32.21808,
    lng: -86.28778,
    city: "Montgomery",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9636,
    density: 54.1,
    county_fips: "01101",
    county_name: "Montgomery",
    county_weights: {
      "01101": 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: "01101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36106,
    lat: 32.35264,
    lng: -86.25793,
    city: "Montgomery",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14575,
    density: 909.1,
    county_fips: "01101",
    county_name: "Montgomery",
    county_weights: {
      "01101": 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: "01101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36107,
    lat: 32.38434,
    lng: -86.2795,
    city: "Montgomery",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7782,
    density: 942.4,
    county_fips: "01101",
    county_name: "Montgomery",
    county_weights: {
      "01101": 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: "01101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36108,
    lat: 32.33956,
    lng: -86.40602,
    city: "Montgomery",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16247,
    density: 89.2,
    county_fips: "01101",
    county_name: "Montgomery",
    county_weights: {
      "01101": 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: "01101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36109,
    lat: 32.38682,
    lng: -86.24052,
    city: "Montgomery",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24802,
    density: 845.2,
    county_fips: "01101",
    county_name: "Montgomery",
    county_weights: {
      "01101": 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: "01101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36110,
    lat: 32.44899,
    lng: -86.25566,
    city: "Montgomery",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11864,
    density: 155.3,
    county_fips: "01101",
    county_name: "Montgomery",
    county_weights: {
      "01101": 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: "01101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36111,
    lat: 32.33755,
    lng: -86.27154,
    city: "Montgomery",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12500,
    density: 1125.1,
    county_fips: "01101",
    county_name: "Montgomery",
    county_weights: {
      "01101": 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: "01101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36112,
    lat: 32.38343,
    lng: -86.36,
    city: "Montgomery",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "01101",
    county_name: "Montgomery",
    county_weights: {
      "01101": 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: "01101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36113,
    lat: 32.38146,
    lng: -86.34172,
    city: "Montgomery",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1781,
    density: 1009.3,
    county_fips: "01101",
    county_name: "Montgomery",
    county_weights: {
      "01101": 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: "01101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36114,
    lat: 32.40484,
    lng: -86.24568,
    city: "Montgomery",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "01101",
    county_name: "Montgomery",
    county_weights: {
      "01101": 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: "01101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36115,
    lat: 32.40688,
    lng: -86.24685,
    city: "Montgomery",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 994,
    density: 683,
    county_fips: "01101",
    county_name: "Montgomery",
    county_weights: {
      "01101": 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: "01101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36116,
    lat: 32.27312,
    lng: -86.21765,
    city: "Montgomery",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45027,
    density: 325.9,
    county_fips: "01101",
    county_name: "Montgomery",
    county_weights: {
      "01101": 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: "01101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36117,
    lat: 32.37831,
    lng: -86.14627,
    city: "Montgomery",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53594,
    density: 388.4,
    county_fips: "01101",
    county_name: "Montgomery",
    county_weights: {
      "01101": 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: "01101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36130,
    lat: 32.37778,
    lng: -86.29926,
    city: "Montgomery",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "01101",
    county_name: "Montgomery",
    county_weights: {
      "01101": 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: "01101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36201,
    lat: 33.65082,
    lng: -85.88264,
    city: "Anniston",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17431,
    density: 172.8,
    county_fips: "01015",
    county_name: "Calhoun",
    county_weights: {
      "01015": 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: "01015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36203,
    lat: 33.58205,
    lng: -85.83312,
    city: "Oxford",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17705,
    density: 173.3,
    county_fips: "01015",
    county_name: "Calhoun",
    county_weights: {
      "01015": 60.36,
      "01121": 39.64,
    },
    county_names_all: "Calhoun|Talladega",
    county_fips_all: "01015|01121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36205,
    lat: 33.70037,
    lng: -85.78898,
    city: "Anniston",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 718,
    density: 21.3,
    county_fips: "01015",
    county_name: "Calhoun",
    county_weights: {
      "01015": 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: "01015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36206,
    lat: 33.73225,
    lng: -85.81638,
    city: "Anniston",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10539,
    density: 258.2,
    county_fips: "01015",
    county_name: "Calhoun",
    county_weights: {
      "01015": 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: "01015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36207,
    lat: 33.68196,
    lng: -85.71356,
    city: "Anniston",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19737,
    density: 101.8,
    county_fips: "01015",
    county_name: "Calhoun",
    county_weights: {
      "01015": 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: "01015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36250,
    lat: 33.76564,
    lng: -85.89675,
    city: "Alexandria",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5258,
    density: 103.1,
    county_fips: "01015",
    county_name: "Calhoun",
    county_weights: {
      "01015": 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: "01015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36251,
    lat: 33.22996,
    lng: -85.86532,
    city: "Ashland",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4755,
    density: 12.5,
    county_fips: "01027",
    county_name: "Clay",
    county_weights: {
      "01027": 100,
    },
    county_names_all: "Clay",
    county_fips_all: "01027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36255,
    lat: 33.18094,
    lng: -85.73933,
    city: "Cragford",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 974,
    density: 6.1,
    county_fips: "01027",
    county_name: "Clay",
    county_weights: {
      "01027": 97.74,
      "01123": 2.26,
    },
    county_names_all: "Clay|Tallapoosa",
    county_fips_all: "01027|01123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36256,
    lat: 33.04181,
    lng: -85.70775,
    city: "Daviston",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1325,
    density: 5.4,
    county_fips: "01123",
    county_name: "Tallapoosa",
    county_weights: {
      "01123": 96.07,
      "01027": 3.93,
    },
    county_names_all: "Tallapoosa|Clay",
    county_fips_all: "01123|01027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36258,
    lat: 33.47795,
    lng: -85.716,
    city: "Delta",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1258,
    density: 4.4,
    county_fips: "01029",
    county_name: "Cleburne",
    county_weights: {
      "01029": 46.13,
      "01027": 42.39,
      "01111": 11.48,
    },
    county_names_all: "Cleburne|Clay|Randolph",
    county_fips_all: "01029|01027|01111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36260,
    lat: 33.58662,
    lng: -86.00025,
    city: "Eastaboga",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4286,
    density: 57.2,
    county_fips: "01121",
    county_name: "Talladega",
    county_weights: {
      "01121": 63.22,
      "01015": 36.78,
    },
    county_names_all: "Talladega|Calhoun",
    county_fips_all: "01121|01015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36262,
    lat: 33.7965,
    lng: -85.46741,
    city: "Fruithurst",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1402,
    density: 5.1,
    county_fips: "01029",
    county_name: "Cleburne",
    county_weights: {
      "01029": 100,
    },
    county_names_all: "Cleburne",
    county_fips_all: "01029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36263,
    lat: 33.46727,
    lng: -85.36016,
    city: "Graham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 385,
    density: 6.2,
    county_fips: "01111",
    county_name: "Randolph",
    county_weights: {
      "01111": 99.86,
      "01029": 0.14,
    },
    county_names_all: "Randolph|Cleburne",
    county_fips_all: "01111|01029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36264,
    lat: 33.59305,
    lng: -85.53817,
    city: "Heflin",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8270,
    density: 13.4,
    county_fips: "01029",
    county_name: "Cleburne",
    county_weights: {
      "01029": 91.7,
      "01111": 8.3,
    },
    county_names_all: "Cleburne|Randolph",
    county_fips_all: "01029|01111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36265,
    lat: 33.84659,
    lng: -85.78662,
    city: "Jacksonville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20299,
    density: 79.9,
    county_fips: "01015",
    county_name: "Calhoun",
    county_weights: {
      "01015": 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: "01015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36266,
    lat: 33.35338,
    lng: -85.75062,
    city: "Lineville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6064,
    density: 11.9,
    county_fips: "01027",
    county_name: "Clay",
    county_weights: {
      "01027": 78.77,
      "01111": 21.23,
    },
    county_names_all: "Clay|Randolph",
    county_fips_all: "01027|01111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36267,
    lat: 33.19513,
    lng: -85.94659,
    city: "Millerville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 239,
    density: 92.2,
    county_fips: "01027",
    county_name: "Clay",
    county_weights: {
      "01027": 100,
    },
    county_names_all: "Clay",
    county_fips_all: "01027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36268,
    lat: 33.49469,
    lng: -85.94016,
    city: "Munford",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5980,
    density: 24.1,
    county_fips: "01121",
    county_name: "Talladega",
    county_weights: {
      "01121": 89.67,
      "01027": 10.33,
    },
    county_names_all: "Talladega|Clay",
    county_fips_all: "01121|01027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36269,
    lat: 33.73569,
    lng: -85.38314,
    city: "Muscadine",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1836,
    density: 16,
    county_fips: "01029",
    county_name: "Cleburne",
    county_weights: {
      "01029": 100,
    },
    county_names_all: "Cleburne",
    county_fips_all: "01029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36271,
    lat: 33.78215,
    lng: -86.01624,
    city: "Ohatchee",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6237,
    density: 29.6,
    county_fips: "01015",
    county_name: "Calhoun",
    county_weights: {
      "01015": 99.82,
      "01055": 0.18,
    },
    county_names_all: "Calhoun|Etowah",
    county_fips_all: "01015|01055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36272,
    lat: 33.94441,
    lng: -85.60454,
    city: "Piedmont",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13012,
    density: 15.8,
    county_fips: "01019",
    county_name: "Cherokee",
    county_weights: {
      "01019": 42.23,
      "01015": 33.5,
      "01029": 19.63,
      "01055": 4.64,
    },
    county_names_all: "Cherokee|Calhoun|Cleburne|Etowah",
    county_fips_all: "01019|01015|01029|01055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36273,
    lat: 33.53904,
    lng: -85.37742,
    city: "Ranburne",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3132,
    density: 24.4,
    county_fips: "01029",
    county_name: "Cleburne",
    county_weights: {
      "01029": 100,
    },
    county_names_all: "Cleburne",
    county_fips_all: "01029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36274,
    lat: 33.17687,
    lng: -85.36283,
    city: "Roanoke",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10617,
    density: 22.8,
    county_fips: "01111",
    county_name: "Randolph",
    county_weights: {
      "01111": 82.79,
      "01017": 17.21,
    },
    county_names_all: "Randolph|Chambers",
    county_fips_all: "01111|01017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36276,
    lat: 33.12644,
    lng: -85.57772,
    city: "Wadley",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2684,
    density: 7.6,
    county_fips: "01111",
    county_name: "Randolph",
    county_weights: {
      "01111": 54.6,
      "01017": 24.2,
      "01027": 14.75,
      "01123": 6.45,
    },
    county_names_all: "Randolph|Chambers|Clay|Tallapoosa",
    county_fips_all: "01111|01017|01027|01123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36277,
    lat: 33.7609,
    lng: -85.81541,
    city: "Weaver",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5804,
    density: 290.9,
    county_fips: "01015",
    county_name: "Calhoun",
    county_weights: {
      "01015": 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: "01015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36278,
    lat: 33.31885,
    lng: -85.5253,
    city: "Wedowee",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4271,
    density: 11.9,
    county_fips: "01111",
    county_name: "Randolph",
    county_weights: {
      "01111": 100,
    },
    county_names_all: "Randolph",
    county_fips_all: "01111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36279,
    lat: 33.87237,
    lng: -85.88645,
    city: "Wellington",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2864,
    density: 36.4,
    county_fips: "01015",
    county_name: "Calhoun",
    county_weights: {
      "01015": 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: "01015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36280,
    lat: 33.38427,
    lng: -85.3891,
    city: "Woodland",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4532,
    density: 14.5,
    county_fips: "01111",
    county_name: "Randolph",
    county_weights: {
      "01111": 100,
    },
    county_names_all: "Randolph",
    county_fips_all: "01111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36301,
    lat: 31.14387,
    lng: -85.40321,
    city: "Dothan",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37951,
    density: 164.3,
    county_fips: "01069",
    county_name: "Houston",
    county_weights: {
      "01069": 95.38,
      "01061": 4.62,
    },
    county_names_all: "Houston|Geneva",
    county_fips_all: "01069|01061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36303,
    lat: 31.26389,
    lng: -85.39213,
    city: "Dothan",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31096,
    density: 204,
    county_fips: "01069",
    county_name: "Houston",
    county_weights: {
      "01069": 90.89,
      "01045": 8.18,
      "01067": 0.93,
    },
    county_names_all: "Houston|Dale|Henry",
    county_fips_all: "01069|01045|01067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36305,
    lat: 31.20229,
    lng: -85.49798,
    city: "Dothan",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17018,
    density: 212.1,
    county_fips: "01069",
    county_name: "Houston",
    county_weights: {
      "01069": 65.53,
      "01061": 34.47,
    },
    county_names_all: "Houston|Geneva",
    county_fips_all: "01069|01061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36310,
    lat: 31.60296,
    lng: -85.21229,
    city: "Abbeville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6258,
    density: 11.5,
    county_fips: "01067",
    county_name: "Henry",
    county_weights: {
      "01067": 100,
    },
    county_names_all: "Henry",
    county_fips_all: "01067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36311,
    lat: 31.60092,
    lng: -85.68372,
    city: "Ariton",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2369,
    density: 7.4,
    county_fips: "01045",
    county_name: "Dale",
    county_weights: {
      "01045": 54.84,
      "01005": 35.58,
      "01031": 9.58,
    },
    county_names_all: "Dale|Barbour|Coffee",
    county_fips_all: "01045|01005|01031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36312,
    lat: 31.16748,
    lng: -85.23867,
    city: "Ashford",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6352,
    density: 33.1,
    county_fips: "01069",
    county_name: "Houston",
    county_weights: {
      "01069": 100,
    },
    county_names_all: "Houston",
    county_fips_all: "01069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36313,
    lat: 31.18024,
    lng: -85.79368,
    city: "Bellwood",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 201,
    density: 22.2,
    county_fips: "01061",
    county_name: "Geneva",
    county_weights: {
      "01061": 100,
    },
    county_names_all: "Geneva",
    county_fips_all: "01061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36314,
    lat: 31.02141,
    lng: -85.77645,
    city: "Black",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 576,
    density: 8.6,
    county_fips: "01061",
    county_name: "Geneva",
    county_weights: {
      "01061": 100,
    },
    county_names_all: "Geneva",
    county_fips_all: "01061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36316,
    lat: 31.17835,
    lng: -85.86496,
    city: "Chancellor",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2260,
    density: 16,
    county_fips: "01061",
    county_name: "Geneva",
    county_weights: {
      "01061": 65.39,
      "01031": 34.61,
    },
    county_names_all: "Geneva|Coffee",
    county_fips_all: "01061|01031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36317,
    lat: 31.63532,
    lng: -85.38748,
    city: "Clopton",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 700,
    density: 6.6,
    county_fips: "01067",
    county_name: "Henry",
    county_weights: {
      "01067": 83.46,
      "01045": 8.69,
      "01005": 7.85,
    },
    county_names_all: "Henry|Dale|Barbour",
    county_fips_all: "01067|01045|01005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36318,
    lat: 31.17612,
    lng: -85.95653,
    city: "Coffee Springs",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1254,
    density: 10.2,
    county_fips: "01061",
    county_name: "Geneva",
    county_weights: {
      "01061": 67.84,
      "01031": 32.16,
    },
    county_names_all: "Geneva|Coffee",
    county_fips_all: "01061|01031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36319,
    lat: 31.32367,
    lng: -85.14931,
    city: "Columbia",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2212,
    density: 8.2,
    county_fips: "01067",
    county_name: "Henry",
    county_weights: {
      "01067": 60.45,
      "01069": 39.55,
    },
    county_names_all: "Henry|Houston",
    county_fips_all: "01067|01069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36320,
    lat: 31.05105,
    lng: -85.31765,
    city: "Cottonwood",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3208,
    density: 19.3,
    county_fips: "01069",
    county_name: "Houston",
    county_weights: {
      "01069": 100,
    },
    county_names_all: "Houston",
    county_fips_all: "01069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36321,
    lat: 31.20558,
    lng: -85.30093,
    city: "Cowarts",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1898,
    density: 116.1,
    county_fips: "01069",
    county_name: "Houston",
    county_weights: {
      "01069": 100,
    },
    county_names_all: "Houston",
    county_fips_all: "01069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36322,
    lat: 31.25575,
    lng: -85.73249,
    city: "Daleville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8951,
    density: 58.1,
    county_fips: "01045",
    county_name: "Dale",
    county_weights: {
      "01045": 93.04,
      "01061": 5.96,
      "01031": 1,
    },
    county_names_all: "Dale|Geneva|Coffee",
    county_fips_all: "01045|01061|01031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36323,
    lat: 31.42702,
    lng: -86.07221,
    city: "Elba",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7863,
    density: 13,
    county_fips: "01031",
    county_name: "Coffee",
    county_weights: {
      "01031": 100,
    },
    county_names_all: "Coffee",
    county_fips_all: "01031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36330,
    lat: 31.30743,
    lng: -85.85854,
    city: "Enterprise",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38010,
    density: 132,
    county_fips: "01031",
    county_name: "Coffee",
    county_weights: {
      "01031": 92.38,
      "01045": 7.62,
    },
    county_names_all: "Coffee|Dale",
    county_fips_all: "01031|01045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36340,
    lat: 31.05391,
    lng: -85.89155,
    city: "Geneva",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5745,
    density: 45,
    county_fips: "01061",
    county_name: "Geneva",
    county_weights: {
      "01061": 100,
    },
    county_names_all: "Geneva",
    county_fips_all: "01061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36343,
    lat: 31.05753,
    lng: -85.11812,
    city: "Gordon",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1174,
    density: 4.6,
    county_fips: "01069",
    county_name: "Houston",
    county_weights: {
      "01069": 100,
    },
    county_names_all: "Houston",
    county_fips_all: "01069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36344,
    lat: 31.1007,
    lng: -85.70931,
    city: "Hartford",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5564,
    density: 16.8,
    county_fips: "01061",
    county_name: "Geneva",
    county_weights: {
      "01061": 100,
    },
    county_names_all: "Geneva",
    county_fips_all: "01061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36345,
    lat: 31.3741,
    lng: -85.31,
    city: "Headland",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8449,
    density: 26.7,
    county_fips: "01067",
    county_name: "Henry",
    county_weights: {
      "01067": 83.77,
      "01069": 9.94,
      "01045": 6.29,
    },
    county_names_all: "Henry|Houston|Dale",
    county_fips_all: "01067|01069|01045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36346,
    lat: 31.55783,
    lng: -85.9331,
    city: "Jack",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1379,
    density: 10,
    county_fips: "01031",
    county_name: "Coffee",
    county_weights: {
      "01031": 100,
    },
    county_names_all: "Coffee",
    county_fips_all: "01031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36350,
    lat: 31.3435,
    lng: -85.49669,
    city: "Midland City",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6677,
    density: 33.4,
    county_fips: "01045",
    county_name: "Dale",
    county_weights: {
      "01045": 97.76,
      "01069": 2.24,
    },
    county_names_all: "Dale|Houston",
    county_fips_all: "01045|01069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36351,
    lat: 31.41469,
    lng: -85.90596,
    city: "New Brockton",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3199,
    density: 12.5,
    county_fips: "01031",
    county_name: "Coffee",
    county_weights: {
      "01031": 100,
    },
    county_names_all: "Coffee",
    county_fips_all: "01031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36352,
    lat: 31.25682,
    lng: -85.61629,
    city: "Newton",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4757,
    density: 26.3,
    county_fips: "01069",
    county_name: "Houston",
    county_weights: {
      "01069": 58.07,
      "01045": 39.01,
      "01061": 2.92,
    },
    county_names_all: "Houston|Dale|Geneva",
    county_fips_all: "01069|01045|01061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36353,
    lat: 31.4817,
    lng: -85.36208,
    city: "Newville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1564,
    density: 6.2,
    county_fips: "01067",
    county_name: "Henry",
    county_weights: {
      "01067": 81.95,
      "01045": 18.05,
    },
    county_names_all: "Henry|Dale",
    county_fips_all: "01067|01045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36360,
    lat: 31.46648,
    lng: -85.61641,
    city: "Ozark",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18922,
    density: 41.1,
    county_fips: "01045",
    county_name: "Dale",
    county_weights: {
      "01045": 98.57,
      "01031": 1.43,
    },
    county_names_all: "Dale|Coffee",
    county_fips_all: "01045|01031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36362,
    lat: 31.35072,
    lng: -85.69027,
    city: "Fort Rucker",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5715,
    density: 75.1,
    county_fips: "01045",
    county_name: "Dale",
    county_weights: {
      "01045": 100,
    },
    county_names_all: "Dale",
    county_fips_all: "01045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36370,
    lat: 31.13175,
    lng: -85.15688,
    city: "Pansey",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 922,
    density: 10.9,
    county_fips: "01069",
    county_name: "Houston",
    county_weights: {
      "01069": 100,
    },
    county_names_all: "Houston",
    county_fips_all: "01069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36371,
    lat: 31.3208,
    lng: -85.54738,
    city: "Pinckard",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 805,
    density: 92.9,
    county_fips: "01045",
    county_name: "Dale",
    county_weights: {
      "01045": 100,
    },
    county_names_all: "Dale",
    county_fips_all: "01045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36373,
    lat: 31.52131,
    lng: -85.10355,
    city: "Shorterville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 476,
    density: 3,
    county_fips: "01067",
    county_name: "Henry",
    county_weights: {
      "01067": 100,
    },
    county_names_all: "Henry",
    county_fips_all: "01067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 36374,
    lat: 31.5723,
    lng: -85.48956,
    city: "Skipperville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 643,
    density: 4.5,
    county_fips: "01045",
    county_name: "Dale",
    county_weights: {
      "01045": 88.53,
      "01005": 11.47,
    },
    county_names_all: "Dale|Barbour",
    county_fips_all: "01045|01005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36375,
    lat: 31.07681,
    lng: -85.54111,
    city: "Slocomb",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6884,
    density: 21.7,
    county_fips: "01061",
    county_name: "Geneva",
    county_weights: {
      "01061": 78.64,
      "01069": 21.36,
    },
    county_names_all: "Geneva|Houston",
    county_fips_all: "01061|01069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36376,
    lat: 31.25213,
    lng: -85.26961,
    city: "Webb",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2167,
    density: 35.2,
    county_fips: "01069",
    county_name: "Houston",
    county_weights: {
      "01069": 100,
    },
    county_names_all: "Houston",
    county_fips_all: "01069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36401,
    lat: 31.47123,
    lng: -86.94928,
    city: "Evergreen",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7900,
    density: 6.9,
    county_fips: "01035",
    county_name: "Conecuh",
    county_weights: {
      "01035": 93.53,
      "01099": 5.68,
      "01053": 0.79,
    },
    county_names_all: "Conecuh|Monroe|Escambia",
    county_fips_all: "01035|01099|01053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36420,
    lat: 31.18092,
    lng: -86.57618,
    city: "Andalusia",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9552,
    density: 13.8,
    county_fips: "01039",
    county_name: "Covington",
    county_weights: {
      "01039": 80.27,
      "01053": 19.73,
    },
    county_names_all: "Covington|Escambia",
    county_fips_all: "01039|01053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36421,
    lat: 31.32769,
    lng: -86.50903,
    city: "Andalusia",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10870,
    density: 19.7,
    county_fips: "01039",
    county_name: "Covington",
    county_weights: {
      "01039": 84.07,
      "01035": 15.93,
    },
    county_names_all: "Covington|Conecuh",
    county_fips_all: "01039|01035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36425,
    lat: 31.75884,
    lng: -87.19731,
    city: "Beatrice",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1086,
    density: 3.1,
    county_fips: "01099",
    county_name: "Monroe",
    county_weights: {
      "01099": 100,
    },
    county_names_all: "Monroe",
    county_fips_all: "01099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36426,
    lat: 31.14386,
    lng: -87.076,
    city: "Brewton",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15404,
    density: 11.9,
    county_fips: "01053",
    county_name: "Escambia",
    county_weights: {
      "01053": 96.26,
      "01035": 3.74,
    },
    county_names_all: "Escambia|Conecuh",
    county_fips_all: "01053|01035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36432,
    lat: 31.30055,
    lng: -87.03888,
    city: "Castleberry",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1795,
    density: 5,
    county_fips: "01035",
    county_name: "Conecuh",
    county_weights: {
      "01035": 74.96,
      "01053": 25.04,
    },
    county_names_all: "Conecuh|Escambia",
    county_fips_all: "01035|01053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36435,
    lat: 31.87889,
    lng: -87.45564,
    city: "Coy",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 362,
    density: 2.8,
    county_fips: "01131",
    county_name: "Wilcox",
    county_weights: {
      "01131": 99.85,
      "01099": 0.15,
    },
    county_names_all: "Wilcox|Monroe",
    county_fips_all: "01131|01099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36436,
    lat: 31.76636,
    lng: -87.6614,
    city: "Dickinson",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 356,
    density: 3.7,
    county_fips: "01025",
    county_name: "Clarke",
    county_weights: {
      "01025": 100,
    },
    county_names_all: "Clarke",
    county_fips_all: "01025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36439,
    lat: 31.42252,
    lng: -87.34512,
    city: "Excel",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 508,
    density: 225.6,
    county_fips: "01099",
    county_name: "Monroe",
    county_weights: {
      "01099": 100,
    },
    county_names_all: "Monroe",
    county_fips_all: "01099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36441,
    lat: 31.04064,
    lng: -87.25885,
    city: "Flomaton",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3828,
    density: 24.3,
    county_fips: "01053",
    county_name: "Escambia",
    county_weights: {
      "01053": 100,
    },
    county_names_all: "Escambia",
    county_fips_all: "01053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36442,
    lat: 31.07312,
    lng: -86.36355,
    city: "Florala",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3783,
    density: 7.1,
    county_fips: "01039",
    county_name: "Covington",
    county_weights: {
      "01039": 99.6,
      "01061": 0.4,
    },
    county_names_all: "Covington|Geneva",
    county_fips_all: "01039|01061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36444,
    lat: 31.65935,
    lng: -87.4651,
    city: "Franklin",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 747,
    density: 3,
    county_fips: "01099",
    county_name: "Monroe",
    county_weights: {
      "01099": 100,
    },
    county_names_all: "Monroe",
    county_fips_all: "01099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36445,
    lat: 31.44397,
    lng: -87.44982,
    city: "Frisco City",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5647,
    density: 14.7,
    county_fips: "01099",
    county_name: "Monroe",
    county_weights: {
      "01099": 100,
    },
    county_names_all: "Monroe",
    county_fips_all: "01099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36446,
    lat: 31.79146,
    lng: -87.72446,
    city: "Fulton",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 512,
    density: 99.6,
    county_fips: "01025",
    county_name: "Clarke",
    county_weights: {
      "01025": 100,
    },
    county_names_all: "Clarke",
    county_fips_all: "01025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36451,
    lat: 31.69769,
    lng: -87.80664,
    city: "Grove Hill",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4665,
    density: 9.5,
    county_fips: "01025",
    county_name: "Clarke",
    county_weights: {
      "01025": 100,
    },
    county_names_all: "Clarke",
    county_fips_all: "01025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36453,
    lat: 31.19788,
    lng: -86.14726,
    city: "Kinston",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2475,
    density: 9.3,
    county_fips: "01031",
    county_name: "Coffee",
    county_weights: {
      "01031": 52.26,
      "01061": 39.06,
      "01039": 8.68,
    },
    county_names_all: "Coffee|Geneva|Covington",
    county_fips_all: "01031|01061|01039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36454,
    lat: 31.34368,
    lng: -87.20185,
    city: "Lenox",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7,
    density: 0.9,
    county_fips: "01035",
    county_name: "Conecuh",
    county_weights: {
      "01035": 100,
    },
    county_names_all: "Conecuh",
    county_fips_all: "01035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36455,
    lat: 31.01212,
    lng: -86.35321,
    city: "Lockhart",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 179,
    density: 98.4,
    county_fips: "01039",
    county_name: "Covington",
    county_weights: {
      "01039": 100,
    },
    county_names_all: "Covington",
    county_fips_all: "01039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36456,
    lat: 31.57103,
    lng: -86.82556,
    city: "McKenzie",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1621,
    density: 4.4,
    county_fips: "01035",
    county_name: "Conecuh",
    county_weights: {
      "01035": 51.08,
      "01013": 42.74,
      "01039": 6.18,
    },
    county_names_all: "Conecuh|Butler|Covington",
    county_fips_all: "01035|01013|01039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36460,
    lat: 31.52679,
    lng: -87.30786,
    city: "Monroeville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9029,
    density: 23,
    county_fips: "01099",
    county_name: "Monroe",
    county_weights: {
      "01099": 96.92,
      "01035": 3.08,
    },
    county_names_all: "Monroe|Conecuh",
    county_fips_all: "01099|01035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36467,
    lat: 31.2795,
    lng: -86.25579,
    city: "Opp",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9538,
    density: 23.3,
    county_fips: "01039",
    county_name: "Covington",
    county_weights: {
      "01039": 94.16,
      "01031": 5.84,
    },
    county_names_all: "Covington|Coffee",
    county_fips_all: "01039|01031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36470,
    lat: 31.51602,
    lng: -87.55518,
    city: "Perdue Hill",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35,
    density: 0.6,
    county_fips: "01099",
    county_name: "Monroe",
    county_weights: {
      "01099": 100,
    },
    county_names_all: "Monroe",
    county_fips_all: "01099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36471,
    lat: 31.62616,
    lng: -87.22861,
    city: "Peterman",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 942,
    density: 3.8,
    county_fips: "01099",
    county_name: "Monroe",
    county_weights: {
      "01099": 90.14,
      "01035": 9.86,
    },
    county_names_all: "Monroe|Conecuh",
    county_fips_all: "01099|01035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36473,
    lat: 31.32009,
    lng: -87.21967,
    city: "Range",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 96,
    density: 2.9,
    county_fips: "01035",
    county_name: "Conecuh",
    county_weights: {
      "01035": 100,
    },
    county_names_all: "Conecuh",
    county_fips_all: "01035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36474,
    lat: 31.42664,
    lng: -86.62022,
    city: "Red Level",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2770,
    density: 5.8,
    county_fips: "01039",
    county_name: "Covington",
    county_weights: {
      "01039": 74.12,
      "01035": 14.77,
      "01013": 11.11,
    },
    county_names_all: "Covington|Conecuh|Butler",
    county_fips_all: "01039|01035|01013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36475,
    lat: 31.38511,
    lng: -87.22717,
    city: "Repton",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2063,
    density: 5.5,
    county_fips: "01035",
    county_name: "Conecuh",
    county_weights: {
      "01035": 86.87,
      "01099": 13.13,
    },
    county_names_all: "Conecuh|Monroe",
    county_fips_all: "01035|01099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36476,
    lat: 31.35359,
    lng: -86.54633,
    city: "River Falls",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3,
    density: 2.9,
    county_fips: "01039",
    county_name: "Covington",
    county_weights: {
      "01039": 100,
    },
    county_names_all: "Covington",
    county_fips_all: "01039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36477,
    lat: 31.08741,
    lng: -86.05407,
    city: "Samson",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3615,
    density: 8.7,
    county_fips: "01061",
    county_name: "Geneva",
    county_weights: {
      "01061": 89.06,
      "01031": 10.49,
      "01039": 0.45,
    },
    county_names_all: "Geneva|Coffee|Covington",
    county_fips_all: "01061|01031|01039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36480,
    lat: 31.32976,
    lng: -87.61125,
    city: "Uriah",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1853,
    density: 4.6,
    county_fips: "01099",
    county_name: "Monroe",
    county_weights: {
      "01099": 100,
    },
    county_names_all: "Monroe",
    county_fips_all: "01099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36481,
    lat: 31.77356,
    lng: -87.37553,
    city: "Vredenburgh",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 258,
    density: 1.7,
    county_fips: "01099",
    county_name: "Monroe",
    county_weights: {
      "01099": 100,
    },
    county_names_all: "Monroe",
    county_fips_all: "01099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36482,
    lat: 31.6223,
    lng: -87.63424,
    city: "Whatley",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 785,
    density: 2.3,
    county_fips: "01025",
    county_name: "Clarke",
    county_weights: {
      "01025": 91.24,
      "01099": 8.76,
    },
    county_names_all: "Clarke|Monroe",
    county_fips_all: "01025|01099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36483,
    lat: 31.04273,
    lng: -86.68494,
    city: "Wing",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 471,
    density: 1.7,
    county_fips: "01039",
    county_name: "Covington",
    county_weights: {
      "01039": 54.84,
      "01053": 45.16,
    },
    county_names_all: "Covington|Escambia",
    county_fips_all: "01039|01053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36502,
    lat: 31.14498,
    lng: -87.49303,
    city: "Atmore",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17775,
    density: 20.7,
    county_fips: "01053",
    county_name: "Escambia",
    county_weights: {
      "01053": 79.32,
      "01003": 10.07,
      "01099": 7.75,
      "01035": 2.86,
    },
    county_names_all: "Escambia|Baldwin|Monroe|Conecuh",
    county_fips_all: "01053|01003|01099|01035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36503,
    lat: 31.15674,
    lng: -87.4654,
    city: "Atmore",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "01053",
    county_name: "Escambia",
    county_weights: {
      "01053": 100,
    },
    county_names_all: "Escambia",
    county_fips_all: "01053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36505,
    lat: 30.94978,
    lng: -88.0225,
    city: "Axis",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1062,
    density: 14.1,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36507,
    lat: 30.85893,
    lng: -87.74188,
    city: "Bay Minette",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21598,
    density: 24.3,
    county_fips: "01003",
    county_name: "Baldwin",
    county_weights: {
      "01003": 100,
    },
    county_names_all: "Baldwin",
    county_fips_all: "01003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36509,
    lat: 30.4077,
    lng: -88.24726,
    city: "Bayou La Batre",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1634,
    density: 63.7,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36511,
    lat: 30.31173,
    lng: -87.74259,
    city: "Bon Secour",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 173,
    density: 14.9,
    county_fips: "01003",
    county_name: "Baldwin",
    county_weights: {
      "01003": 100,
    },
    county_names_all: "Baldwin",
    county_fips_all: "01003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36512,
    lat: 31.00327,
    lng: -88.01023,
    city: "Bucks",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12,
    density: 1.6,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36513,
    lat: 31.15516,
    lng: -87.99021,
    city: "Calvert",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 388,
    density: 6,
    county_fips: "01129",
    county_name: "Washington",
    county_weights: {
      "01129": 52.84,
      "01097": 47.16,
    },
    county_names_all: "Washington|Mobile",
    county_fips_all: "01129|01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36518,
    lat: 31.47082,
    lng: -88.27546,
    city: "Chatom",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2547,
    density: 7.4,
    county_fips: "01129",
    county_name: "Washington",
    county_weights: {
      "01129": 100,
    },
    county_names_all: "Washington",
    county_fips_all: "01129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36521,
    lat: 30.96241,
    lng: -88.18526,
    city: "Chunchula",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6482,
    density: 18.9,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36522,
    lat: 31.08296,
    lng: -88.27795,
    city: "Citronelle",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6759,
    density: 11.2,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 77.56,
      "01129": 22.44,
    },
    county_names_all: "Mobile|Washington",
    county_fips_all: "01097|01129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36523,
    lat: 30.37852,
    lng: -88.16536,
    city: "Coden",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3054,
    density: 32,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36524,
    lat: 31.80868,
    lng: -88.0203,
    city: "Coffeeville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1314,
    density: 3.3,
    county_fips: "01025",
    county_name: "Clarke",
    county_weights: {
      "01025": 100,
    },
    county_names_all: "Clarke",
    county_fips_all: "01025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36525,
    lat: 30.8898,
    lng: -88.02329,
    city: "Creola",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1702,
    density: 37.3,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36526,
    lat: 30.61187,
    lng: -87.86151,
    city: "Daphne",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34788,
    density: 356.3,
    county_fips: "01003",
    county_name: "Baldwin",
    county_weights: {
      "01003": 100,
    },
    county_names_all: "Baldwin",
    county_fips_all: "01003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36527,
    lat: 30.69679,
    lng: -87.87734,
    city: "Daphne",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15586,
    density: 142.1,
    county_fips: "01003",
    county_name: "Baldwin",
    county_weights: {
      "01003": 100,
    },
    county_names_all: "Baldwin",
    county_fips_all: "01003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36528,
    lat: 30.25253,
    lng: -88.14381,
    city: "Dauphin Island",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1610,
    density: 99,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36529,
    lat: 31.29279,
    lng: -88.27281,
    city: "Deer Park",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 259,
    density: 1.1,
    county_fips: "01129",
    county_name: "Washington",
    county_weights: {
      "01129": 100,
    },
    county_names_all: "Washington",
    county_fips_all: "01129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36530,
    lat: 30.41192,
    lng: -87.55445,
    city: "Elberta",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5848,
    density: 23.6,
    county_fips: "01003",
    county_name: "Baldwin",
    county_weights: {
      "01003": 100,
    },
    county_names_all: "Baldwin",
    county_fips_all: "01003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36532,
    lat: 30.48197,
    lng: -87.86207,
    city: "Fairhope",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35728,
    density: 188.5,
    county_fips: "01003",
    county_name: "Baldwin",
    county_weights: {
      "01003": 100,
    },
    county_names_all: "Baldwin",
    county_fips_all: "01003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36535,
    lat: 30.38562,
    lng: -87.72514,
    city: "Foley",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34542,
    density: 144.1,
    county_fips: "01003",
    county_name: "Baldwin",
    county_weights: {
      "01003": 100,
    },
    county_names_all: "Baldwin",
    county_fips_all: "01003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36538,
    lat: 31.65948,
    lng: -88.13836,
    city: "Frankville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 356,
    density: 3.7,
    county_fips: "01129",
    county_name: "Washington",
    county_weights: {
      "01129": 100,
    },
    county_names_all: "Washington",
    county_fips_all: "01129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36539,
    lat: 31.3475,
    lng: -88.39358,
    city: "Fruitdale",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 605,
    density: 3.6,
    county_fips: "01129",
    county_name: "Washington",
    county_weights: {
      "01129": 100,
    },
    county_names_all: "Washington",
    county_fips_all: "01129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36540,
    lat: 31.44702,
    lng: -87.66487,
    city: "Gainestown",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 738,
    density: 6.6,
    county_fips: "01025",
    county_name: "Clarke",
    county_weights: {
      "01025": 100,
    },
    county_names_all: "Clarke",
    county_fips_all: "01025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36541,
    lat: 30.49084,
    lng: -88.34384,
    city: "Grand Bay",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15135,
    density: 62.7,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36542,
    lat: 30.27683,
    lng: -87.73867,
    city: "Gulf Shores",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14937,
    density: 110.9,
    county_fips: "01003",
    county_name: "Baldwin",
    county_weights: {
      "01003": 100,
    },
    county_names_all: "Baldwin",
    county_fips_all: "01003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36543,
    lat: 31.22129,
    lng: -87.46592,
    city: "Huxford",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55,
    density: 127.9,
    county_fips: "01053",
    county_name: "Escambia",
    county_weights: {
      "01053": 100,
    },
    county_names_all: "Escambia",
    county_fips_all: "01053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36544,
    lat: 30.47436,
    lng: -88.234,
    city: "Irvington",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11523,
    density: 109.6,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36545,
    lat: 31.48767,
    lng: -87.87424,
    city: "Jackson",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9222,
    density: 9,
    county_fips: "01025",
    county_name: "Clarke",
    county_weights: {
      "01025": 100,
    },
    county_names_all: "Clarke",
    county_fips_all: "01025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36547,
    lat: 30.25278,
    lng: -87.65405,
    city: "Gulf Shores",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "01003",
    county_name: "Baldwin",
    county_weights: {
      "01003": 100,
    },
    county_names_all: "Baldwin",
    county_fips_all: "01003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36548,
    lat: 31.48326,
    lng: -87.97226,
    city: "Leroy",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1019,
    density: 12.1,
    county_fips: "01129",
    county_name: "Washington",
    county_weights: {
      "01129": 100,
    },
    county_names_all: "Washington",
    county_fips_all: "01129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36549,
    lat: 30.41377,
    lng: -87.44951,
    city: "Lillian",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5825,
    density: 77.4,
    county_fips: "01003",
    county_name: "Baldwin",
    county_weights: {
      "01003": 100,
    },
    county_names_all: "Baldwin",
    county_fips_all: "01003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36550,
    lat: 31.25212,
    lng: -87.74294,
    city: "Little River",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 198,
    density: 2.1,
    county_fips: "01003",
    county_name: "Baldwin",
    county_weights: {
      "01003": 100,
    },
    county_names_all: "Baldwin",
    county_fips_all: "01003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36551,
    lat: 30.63982,
    lng: -87.7504,
    city: "Loxley",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10892,
    density: 61.2,
    county_fips: "01003",
    county_name: "Baldwin",
    county_weights: {
      "01003": 100,
    },
    county_names_all: "Baldwin",
    county_fips_all: "01003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36553,
    lat: 31.22852,
    lng: -88.08658,
    city: "McIntosh",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3361,
    density: 13.8,
    county_fips: "01129",
    county_name: "Washington",
    county_weights: {
      "01129": 100,
    },
    county_names_all: "Washington",
    county_fips_all: "01129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36555,
    lat: 30.40006,
    lng: -87.77312,
    city: "Magnolia Springs",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 870,
    density: 333.2,
    county_fips: "01003",
    county_name: "Baldwin",
    county_weights: {
      "01003": 100,
    },
    county_names_all: "Baldwin",
    county_fips_all: "01003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36556,
    lat: 31.20649,
    lng: -87.97127,
    city: "Malcolm",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 396,
    density: 21.6,
    county_fips: "01129",
    county_name: "Washington",
    county_weights: {
      "01129": 100,
    },
    county_names_all: "Washington",
    county_fips_all: "01129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36558,
    lat: 31.61606,
    lng: -88.33034,
    city: "Millry",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3755,
    density: 6.1,
    county_fips: "01129",
    county_name: "Washington",
    county_weights: {
      "01129": 89.45,
      "01023": 10.55,
    },
    county_names_all: "Washington|Choctaw",
    county_fips_all: "01129|01023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36559,
    lat: 30.56894,
    lng: -87.90393,
    city: "Montrose",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 182,
    density: 182.6,
    county_fips: "01003",
    county_name: "Baldwin",
    county_weights: {
      "01003": 100,
    },
    county_names_all: "Baldwin",
    county_fips_all: "01003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36560,
    lat: 31.08553,
    lng: -88.04991,
    city: "Mount Vernon",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3246,
    density: 20.8,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36561,
    lat: 30.28813,
    lng: -87.57142,
    city: "Orange Beach",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6774,
    density: 156.6,
    county_fips: "01003",
    county_name: "Baldwin",
    county_weights: {
      "01003": 100,
    },
    county_names_all: "Baldwin",
    county_fips_all: "01003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36562,
    lat: 31.03738,
    lng: -87.66274,
    city: "Perdido",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1230,
    density: 9.6,
    county_fips: "01003",
    county_name: "Baldwin",
    county_weights: {
      "01003": 94.8,
      "01053": 5.2,
    },
    county_names_all: "Baldwin|Escambia",
    county_fips_all: "01003|01053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36564,
    lat: 30.46983,
    lng: -87.91467,
    city: "Point Clear",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "01003",
    county_name: "Baldwin",
    county_weights: {
      "01003": 100,
    },
    county_names_all: "Baldwin",
    county_fips_all: "01003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36567,
    lat: 30.61483,
    lng: -87.55792,
    city: "Robertsdale",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13590,
    density: 22.9,
    county_fips: "01003",
    county_name: "Baldwin",
    county_weights: {
      "01003": 100,
    },
    county_names_all: "Baldwin",
    county_fips_all: "01003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36568,
    lat: 30.51291,
    lng: -88.27067,
    city: "Saint Elmo",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 108,
    density: 55.2,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36569,
    lat: 31.54418,
    lng: -88.07907,
    city: "Saint Stephens",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 445,
    density: 2.8,
    county_fips: "01129",
    county_name: "Washington",
    county_weights: {
      "01129": 100,
    },
    county_names_all: "Washington",
    county_fips_all: "01129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36571,
    lat: 30.85055,
    lng: -88.10415,
    city: "Saraland",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15500,
    density: 152.4,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36572,
    lat: 30.85617,
    lng: -88.05956,
    city: "Satsuma",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6183,
    density: 296.1,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36574,
    lat: 30.5141,
    lng: -87.48258,
    city: "Seminole",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1271,
    density: 38.3,
    county_fips: "01003",
    county_name: "Baldwin",
    county_weights: {
      "01003": 100,
    },
    county_names_all: "Baldwin",
    county_fips_all: "01003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36575,
    lat: 30.76825,
    lng: -88.27276,
    city: "Semmes",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22268,
    density: 214.5,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36576,
    lat: 30.52654,
    lng: -87.76654,
    city: "Silverhill",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3899,
    density: 77.2,
    county_fips: "01003",
    county_name: "Baldwin",
    county_weights: {
      "01003": 100,
    },
    county_names_all: "Baldwin",
    county_fips_all: "01003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36578,
    lat: 30.73867,
    lng: -87.77275,
    city: "Stapleton",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2682,
    density: 60.6,
    county_fips: "01003",
    county_name: "Baldwin",
    county_weights: {
      "01003": 100,
    },
    county_names_all: "Baldwin",
    county_fips_all: "01003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36579,
    lat: 31.11395,
    lng: -87.78616,
    city: "Stockton",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1425,
    density: 3.6,
    county_fips: "01003",
    county_name: "Baldwin",
    county_weights: {
      "01003": 100,
    },
    county_names_all: "Baldwin",
    county_fips_all: "01003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36580,
    lat: 30.48085,
    lng: -87.70321,
    city: "Summerdale",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5730,
    density: 42.1,
    county_fips: "01003",
    county_name: "Baldwin",
    county_weights: {
      "01003": 100,
    },
    county_names_all: "Baldwin",
    county_fips_all: "01003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36581,
    lat: 31.36645,
    lng: -88.0098,
    city: "Sunflower",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 336,
    density: 10.6,
    county_fips: "01129",
    county_name: "Washington",
    county_weights: {
      "01129": 100,
    },
    county_names_all: "Washington",
    county_fips_all: "01129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36582,
    lat: 30.51616,
    lng: -88.17719,
    city: "Theodore",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24115,
    density: 116.8,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36583,
    lat: 31.36677,
    lng: -88.1869,
    city: "Tibbie",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 678,
    density: 3.7,
    county_fips: "01129",
    county_name: "Washington",
    county_weights: {
      "01129": 100,
    },
    county_names_all: "Washington",
    county_fips_all: "01129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36584,
    lat: 31.19579,
    lng: -88.38385,
    city: "Vinegar Bend",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 650,
    density: 3.9,
    county_fips: "01129",
    county_name: "Washington",
    county_weights: {
      "01129": 100,
    },
    county_names_all: "Washington",
    county_fips_all: "01129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36585,
    lat: 31.36985,
    lng: -88.02338,
    city: "Wagarville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1412,
    density: 4,
    county_fips: "01129",
    county_name: "Washington",
    county_weights: {
      "01129": 100,
    },
    county_names_all: "Washington",
    county_fips_all: "01129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36587,
    lat: 30.83599,
    lng: -88.35006,
    city: "Wilmer",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11049,
    density: 38.4,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36602,
    lat: 30.69834,
    lng: -88.03815,
    city: "Mobile",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 919,
    density: 90.4,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36603,
    lat: 30.68426,
    lng: -88.05273,
    city: "Mobile",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9239,
    density: 934.8,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36604,
    lat: 30.68229,
    lng: -88.06837,
    city: "Mobile",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9670,
    density: 1437.3,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36605,
    lat: 30.60649,
    lng: -88.09064,
    city: "Mobile",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27035,
    density: 593.8,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36606,
    lat: 30.67088,
    lng: -88.10617,
    city: "Mobile",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18507,
    density: 1043.6,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36607,
    lat: 30.699,
    lng: -88.10552,
    city: "Mobile",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6417,
    density: 823,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36608,
    lat: 30.68115,
    lng: -88.29593,
    city: "Mobile",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36317,
    density: 215.3,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36609,
    lat: 30.66086,
    lng: -88.16378,
    city: "Mobile",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23043,
    density: 1327.7,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36610,
    lat: 30.73721,
    lng: -88.07389,
    city: "Mobile",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10273,
    density: 525.3,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36611,
    lat: 30.7702,
    lng: -88.07747,
    city: "Mobile",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5757,
    density: 455.4,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36612,
    lat: 30.75283,
    lng: -88.11285,
    city: "Mobile",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4460,
    density: 573.5,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36613,
    lat: 30.81175,
    lng: -88.18176,
    city: "Eight Mile",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13746,
    density: 102.1,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36615,
    lat: 30.63563,
    lng: -88.06717,
    city: "Mobile",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36617,
    lat: 30.71544,
    lng: -88.09518,
    city: "Mobile",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12871,
    density: 1096.8,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36618,
    lat: 30.73612,
    lng: -88.17333,
    city: "Mobile",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16948,
    density: 410.5,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36619,
    lat: 30.59488,
    lng: -88.19302,
    city: "Mobile",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15262,
    density: 331.3,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36652,
    lat: 30.69586,
    lng: -88.0803,
    city: "Mobile",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36663,
    lat: 30.73683,
    lng: -88.10896,
    city: "Mobile",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36688,
    lat: 30.69559,
    lng: -88.18783,
    city: "Mobile",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 232,
    density: 92.2,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36693,
    lat: 30.62676,
    lng: -88.14989,
    city: "Mobile",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19806,
    density: 599.9,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36695,
    lat: 30.6309,
    lng: -88.27775,
    city: "Mobile",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52524,
    density: 444.7,
    county_fips: "01097",
    county_name: "Mobile",
    county_weights: {
      "01097": 100,
    },
    county_names_all: "Mobile",
    county_fips_all: "01097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36701,
    lat: 32.49672,
    lng: -87.0568,
    city: "Selma",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20513,
    density: 28.6,
    county_fips: "01047",
    county_name: "Dallas",
    county_weights: {
      "01047": 63.58,
      "01105": 36.42,
    },
    county_names_all: "Dallas|Perry",
    county_fips_all: "01047|01105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36703,
    lat: 32.43387,
    lng: -86.91118,
    city: "Selma",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11880,
    density: 36.7,
    county_fips: "01047",
    county_name: "Dallas",
    county_weights: {
      "01047": 74.29,
      "01001": 25.71,
    },
    county_names_all: "Dallas|Autauga",
    county_fips_all: "01047|01001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36720,
    lat: 32.16493,
    lng: -87.34684,
    city: "Alberta",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 993,
    density: 7.8,
    county_fips: "01131",
    county_name: "Wilcox",
    county_weights: {
      "01131": 100,
    },
    county_names_all: "Wilcox",
    county_fips_all: "01131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36722,
    lat: 32.08124,
    lng: -87.57661,
    city: "Arlington",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 344,
    density: 5.2,
    county_fips: "01131",
    county_name: "Wilcox",
    county_weights: {
      "01131": 92.62,
      "01091": 7.38,
    },
    county_names_all: "Wilcox|Marengo",
    county_fips_all: "01131|01091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36723,
    lat: 32.06633,
    lng: -87.2907,
    city: "Boykin",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 414,
    density: 27.9,
    county_fips: "01131",
    county_name: "Wilcox",
    county_weights: {
      "01131": 100,
    },
    county_names_all: "Wilcox",
    county_fips_all: "01131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36726,
    lat: 31.97043,
    lng: -87.27532,
    city: "Camden",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4828,
    density: 6.4,
    county_fips: "01131",
    county_name: "Wilcox",
    county_weights: {
      "01131": 99.85,
      "01099": 0.15,
    },
    county_names_all: "Wilcox|Monroe",
    county_fips_all: "01131|01099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36727,
    lat: 31.91193,
    lng: -88.02054,
    city: "Campbell",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 138,
    density: 0.9,
    county_fips: "01025",
    county_name: "Clarke",
    county_weights: {
      "01025": 100,
    },
    county_names_all: "Clarke",
    county_fips_all: "01025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36728,
    lat: 32.16625,
    lng: -87.48416,
    city: "Catherine",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 212,
    density: 0.7,
    county_fips: "01131",
    county_name: "Wilcox",
    county_weights: {
      "01131": 75.88,
      "01091": 24.12,
    },
    county_names_all: "Wilcox|Marengo",
    county_fips_all: "01131|01091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36732,
    lat: 32.41638,
    lng: -87.91367,
    city: "Demopolis",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7628,
    density: 21.6,
    county_fips: "01091",
    county_name: "Marengo",
    county_weights: {
      "01091": 100,
    },
    county_names_all: "Marengo",
    county_fips_all: "01091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36736,
    lat: 32.07832,
    lng: -87.76444,
    city: "Dixons Mills",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1492,
    density: 17.1,
    county_fips: "01091",
    county_name: "Marengo",
    county_weights: {
      "01091": 100,
    },
    county_names_all: "Marengo",
    county_fips_all: "01091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36738,
    lat: 32.43421,
    lng: -87.62481,
    city: "Faunsdale",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 719,
    density: 3.8,
    county_fips: "01091",
    county_name: "Marengo",
    county_weights: {
      "01091": 73.05,
      "01065": 26.95,
    },
    county_names_all: "Marengo|Hale",
    county_fips_all: "01091|01065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36740,
    lat: 32.62421,
    lng: -87.83209,
    city: "Forkland",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1523,
    density: 8.9,
    county_fips: "01063",
    county_name: "Greene",
    county_weights: {
      "01063": 100,
    },
    county_names_all: "Greene",
    county_fips_all: "01063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36741,
    lat: 32.02198,
    lng: -87.02594,
    city: "Furman",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "01131",
    county_name: "Wilcox",
    county_weights: {
      "01131": 100,
    },
    county_names_all: "Wilcox",
    county_fips_all: "01131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36742,
    lat: 32.45836,
    lng: -87.74215,
    city: "Gallion",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2663,
    density: 8.7,
    county_fips: "01091",
    county_name: "Marengo",
    county_weights: {
      "01091": 71.57,
      "01065": 28.43,
    },
    county_names_all: "Marengo|Hale",
    county_fips_all: "01091|01065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36744,
    lat: 32.69178,
    lng: -87.59845,
    city: "Greensboro",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5972,
    density: 10.3,
    county_fips: "01065",
    county_name: "Hale",
    county_weights: {
      "01065": 98.49,
      "01105": 1.51,
    },
    county_names_all: "Hale|Perry",
    county_fips_all: "01065|01105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36748,
    lat: 32.27084,
    lng: -87.77728,
    city: "Linden",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2357,
    density: 6.5,
    county_fips: "01091",
    county_name: "Marengo",
    county_weights: {
      "01091": 100,
    },
    county_names_all: "Marengo",
    county_fips_all: "01091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36749,
    lat: 32.54759,
    lng: -86.85303,
    city: "Jones",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 741,
    density: 4.6,
    county_fips: "01001",
    county_name: "Autauga",
    county_weights: {
      "01001": 83.42,
      "01047": 16.58,
    },
    county_names_all: "Autauga|Dallas",
    county_fips_all: "01001|01047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36750,
    lat: 32.78396,
    lng: -86.84361,
    city: "Maplesville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2616,
    density: 9.7,
    county_fips: "01021",
    county_name: "Chilton",
    county_weights: {
      "01021": 98.76,
      "01007": 1.24,
    },
    county_names_all: "Chilton|Bibb",
    county_fips_all: "01021|01007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36751,
    lat: 31.80808,
    lng: -87.54865,
    city: "Lower Peach Tree",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 411,
    density: 1.4,
    county_fips: "01025",
    county_name: "Clarke",
    county_weights: {
      "01025": 40,
      "01131": 33.95,
      "01099": 26.05,
    },
    county_names_all: "Clarke|Wilcox|Monroe",
    county_fips_all: "01025|01131|01099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36752,
    lat: 32.30628,
    lng: -86.62544,
    city: "Lowndesboro",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1066,
    density: 3,
    county_fips: "01085",
    county_name: "Lowndes",
    county_weights: {
      "01085": 100,
    },
    county_names_all: "Lowndes",
    county_fips_all: "01085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36753,
    lat: 31.83698,
    lng: -87.10762,
    city: "McWilliams",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26,
    density: 6.5,
    county_fips: "01131",
    county_name: "Wilcox",
    county_weights: {
      "01131": 99.84,
      "01099": 0.16,
    },
    county_names_all: "Wilcox|Monroe",
    county_fips_all: "01131|01099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36754,
    lat: 32.15731,
    lng: -87.70238,
    city: "Magnolia",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 643,
    density: 6.6,
    county_fips: "01091",
    county_name: "Marengo",
    county_weights: {
      "01091": 100,
    },
    county_names_all: "Marengo",
    county_fips_all: "01091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36756,
    lat: 32.69327,
    lng: -87.29873,
    city: "Marion",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4949,
    density: 5.1,
    county_fips: "01105",
    county_name: "Perry",
    county_weights: {
      "01105": 99.9,
      "01065": 0.1,
    },
    county_names_all: "Perry|Hale",
    county_fips_all: "01105|01065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36758,
    lat: 32.6491,
    lng: -86.89975,
    city: "Plantersville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1448,
    density: 7,
    county_fips: "01021",
    county_name: "Chilton",
    county_weights: {
      "01021": 37.77,
      "01047": 31.23,
      "01001": 31,
    },
    county_names_all: "Chilton|Dallas|Autauga",
    county_fips_all: "01021|01047|01001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36759,
    lat: 32.42977,
    lng: -87.28722,
    city: "Marion Junction",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1724,
    density: 3.1,
    county_fips: "01047",
    county_name: "Dallas",
    county_weights: {
      "01047": 79.63,
      "01105": 20.37,
    },
    county_names_all: "Dallas|Perry",
    county_fips_all: "01047|01105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36761,
    lat: 32.07872,
    lng: -86.97602,
    city: "Minter",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 715,
    density: 1.1,
    county_fips: "01047",
    county_name: "Dallas",
    county_weights: {
      "01047": 59.94,
      "01085": 31.61,
      "01131": 8.45,
    },
    county_names_all: "Dallas|Lowndes|Wilcox",
    county_fips_all: "01047|01085|01131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36763,
    lat: 32.26184,
    lng: -87.96509,
    city: "Myrtlewood",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 111,
    density: 1.5,
    county_fips: "01091",
    county_name: "Marengo",
    county_weights: {
      "01091": 100,
    },
    county_names_all: "Marengo",
    county_fips_all: "01091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36764,
    lat: 32.11518,
    lng: -87.98526,
    city: "Nanafalia",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "01091",
    county_name: "Marengo",
    county_weights: {
      "01091": 100,
    },
    county_names_all: "Marengo",
    county_fips_all: "01091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36765,
    lat: 32.59278,
    lng: -87.51933,
    city: "Newbern",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2207,
    density: 14.8,
    county_fips: "01105",
    county_name: "Perry",
    county_weights: {
      "01105": 50.71,
      "01065": 49.29,
    },
    county_names_all: "Perry|Hale",
    county_fips_all: "01105|01065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36766,
    lat: 31.95505,
    lng: -87.08668,
    city: "Oak Hill",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23,
    density: 1.1,
    county_fips: "01131",
    county_name: "Wilcox",
    county_weights: {
      "01131": 100,
    },
    county_names_all: "Wilcox",
    county_fips_all: "01131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36767,
    lat: 32.25083,
    lng: -87.21042,
    city: "Orrville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1513,
    density: 3.9,
    county_fips: "01047",
    county_name: "Dallas",
    county_weights: {
      "01047": 100,
    },
    county_names_all: "Dallas",
    county_fips_all: "01047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36768,
    lat: 31.8837,
    lng: -87.01186,
    city: "Pine Apple",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 923,
    density: 1.6,
    county_fips: "01131",
    county_name: "Wilcox",
    county_weights: {
      "01131": 73.4,
      "01099": 26.6,
    },
    county_names_all: "Wilcox|Monroe",
    county_fips_all: "01131|01099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36769,
    lat: 31.99306,
    lng: -87.55049,
    city: "Pine Hill",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2229,
    density: 6,
    county_fips: "01131",
    county_name: "Wilcox",
    county_weights: {
      "01131": 86.76,
      "01091": 13.24,
    },
    county_names_all: "Wilcox|Marengo",
    county_fips_all: "01131|01091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36773,
    lat: 32.28252,
    lng: -87.38607,
    city: "Safford",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 294,
    density: 1.6,
    county_fips: "01047",
    county_name: "Dallas",
    county_weights: {
      "01047": 89.41,
      "01091": 10.59,
    },
    county_names_all: "Dallas|Marengo",
    county_fips_all: "01047|01091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36775,
    lat: 32.20066,
    lng: -86.95487,
    city: "Sardis",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1274,
    density: 3.1,
    county_fips: "01047",
    county_name: "Dallas",
    county_weights: {
      "01047": 64.65,
      "01085": 35.35,
    },
    county_names_all: "Dallas|Lowndes",
    county_fips_all: "01047|01085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36776,
    lat: 32.74513,
    lng: -87.74488,
    city: "Sawyerville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2016,
    density: 9.1,
    county_fips: "01065",
    county_name: "Hale",
    county_weights: {
      "01065": 100,
    },
    county_names_all: "Hale",
    county_fips_all: "01065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36782,
    lat: 32.11684,
    lng: -87.90996,
    city: "Sweet Water",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2578,
    density: 4.8,
    county_fips: "01091",
    county_name: "Marengo",
    county_weights: {
      "01091": 100,
    },
    county_names_all: "Marengo",
    county_fips_all: "01091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36783,
    lat: 32.24085,
    lng: -87.6081,
    city: "Thomaston",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 633,
    density: 2.3,
    county_fips: "01091",
    county_name: "Marengo",
    county_weights: {
      "01091": 94.06,
      "01131": 5.94,
    },
    county_names_all: "Marengo|Wilcox",
    county_fips_all: "01091|01131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36784,
    lat: 31.94208,
    lng: -87.82271,
    city: "Thomasville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6802,
    density: 9.8,
    county_fips: "01025",
    county_name: "Clarke",
    county_weights: {
      "01025": 71.92,
      "01091": 26.32,
      "01131": 1.76,
    },
    county_names_all: "Clarke|Marengo|Wilcox",
    county_fips_all: "01025|01091|01131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36785,
    lat: 32.27615,
    lng: -86.82683,
    city: "Tyler",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1037,
    density: 4,
    county_fips: "01085",
    county_name: "Lowndes",
    county_weights: {
      "01085": 55.65,
      "01047": 44.35,
    },
    county_names_all: "Lowndes|Dallas",
    county_fips_all: "01085|01047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36786,
    lat: 32.43832,
    lng: -87.49002,
    city: "Uniontown",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2442,
    density: 6.8,
    county_fips: "01105",
    county_name: "Perry",
    county_weights: {
      "01105": 77.1,
      "01091": 19.33,
      "01065": 3.57,
    },
    county_names_all: "Perry|Marengo|Hale",
    county_fips_all: "01105|01091|01065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36790,
    lat: 32.72758,
    lng: -86.9107,
    city: "Stanton",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 471,
    density: 14.5,
    county_fips: "01021",
    county_name: "Chilton",
    county_weights: {
      "01021": 100,
    },
    county_names_all: "Chilton",
    county_fips_all: "01021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36792,
    lat: 32.92146,
    lng: -86.91147,
    city: "Randolph",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1109,
    density: 6.7,
    county_fips: "01007",
    county_name: "Bibb",
    county_weights: {
      "01007": 81.88,
      "01021": 18.12,
    },
    county_names_all: "Bibb|Chilton",
    county_fips_all: "01007|01021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36793,
    lat: 32.8292,
    lng: -87.00947,
    city: "Lawley",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 313,
    density: 2,
    county_fips: "01007",
    county_name: "Bibb",
    county_weights: {
      "01007": 45.93,
      "01021": 30.95,
      "01105": 23.13,
    },
    county_names_all: "Bibb|Chilton|Perry",
    county_fips_all: "01007|01021|01105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36801,
    lat: 32.701,
    lng: -85.39243,
    city: "Opelika",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25127,
    density: 123.8,
    county_fips: "01081",
    county_name: "Lee",
    county_weights: {
      "01081": 78.26,
      "01017": 21.74,
    },
    county_names_all: "Lee|Chambers",
    county_fips_all: "01081|01017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36804,
    lat: 32.53045,
    lng: -85.33875,
    city: "Opelika",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20356,
    density: 39.9,
    county_fips: "01081",
    county_name: "Lee",
    county_weights: {
      "01081": 78.02,
      "01113": 14.57,
      "01087": 7.41,
    },
    county_names_all: "Lee|Russell|Macon",
    county_fips_all: "01081|01113|01087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36830,
    lat: 32.5339,
    lng: -85.49449,
    city: "Auburn",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40141,
    density: 141.5,
    county_fips: "01081",
    county_name: "Lee",
    county_weights: {
      "01081": 56.01,
      "01087": 43.99,
    },
    county_names_all: "Lee|Macon",
    county_fips_all: "01081|01087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36832,
    lat: 32.59447,
    lng: -85.58163,
    city: "Auburn",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25386,
    density: 143.9,
    county_fips: "01081",
    county_name: "Lee",
    county_weights: {
      "01081": 96.94,
      "01087": 3.06,
    },
    county_names_all: "Lee|Macon",
    county_fips_all: "01081|01087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36849,
    lat: 32.59953,
    lng: -85.48858,
    city: "Auburn University",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4228,
    density: 2202.3,
    county_fips: "01081",
    county_name: "Lee",
    county_weights: {
      "01081": 100,
    },
    county_names_all: "Lee",
    county_fips_all: "01081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36850,
    lat: 32.78857,
    lng: -85.65336,
    city: "Camp Hill",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2982,
    density: 7.4,
    county_fips: "01123",
    county_name: "Tallapoosa",
    county_weights: {
      "01123": 72.39,
      "01017": 17.59,
      "01081": 10.02,
    },
    county_names_all: "Tallapoosa|Chambers|Lee",
    county_fips_all: "01123|01017|01081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36851,
    lat: 32.15039,
    lng: -85.08094,
    city: "Cottonton",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "01113",
    county_name: "Russell",
    county_weights: {
      "01113": 100,
    },
    county_names_all: "Russell",
    county_fips_all: "01113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36852,
    lat: 32.75343,
    lng: -85.27942,
    city: "Cusseta",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3314,
    density: 43.7,
    county_fips: "01017",
    county_name: "Chambers",
    county_weights: {
      "01017": 60.49,
      "01081": 39.51,
    },
    county_names_all: "Chambers|Lee",
    county_fips_all: "01017|01081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36853,
    lat: 32.80557,
    lng: -85.76809,
    city: "Dadeville",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8241,
    density: 17.5,
    county_fips: "01123",
    county_name: "Tallapoosa",
    county_weights: {
      "01123": 100,
    },
    county_names_all: "Tallapoosa",
    county_fips_all: "01123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36854,
    lat: 32.75257,
    lng: -85.18484,
    city: "Valley",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14863,
    density: 94.9,
    county_fips: "01017",
    county_name: "Chambers",
    county_weights: {
      "01017": 56.35,
      "01081": 43.65,
    },
    county_names_all: "Chambers|Lee",
    county_fips_all: "01017|01081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36855,
    lat: 33.03709,
    lng: -85.30516,
    city: "Five Points",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1592,
    density: 8.5,
    county_fips: "01017",
    county_name: "Chambers",
    county_weights: {
      13285: 1.06,
      "01017": 98.94,
    },
    county_names_all: "Chambers|Troup",
    county_fips_all: "01017|13285",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36856,
    lat: 32.26897,
    lng: -84.99757,
    city: "Fort Mitchell",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7944,
    density: 79.2,
    county_fips: "01113",
    county_name: "Russell",
    county_weights: {
      "01113": 100,
    },
    county_names_all: "Russell",
    county_fips_all: "01113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36858,
    lat: 32.30061,
    lng: -85.30138,
    city: "Hatchechubbee",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 354,
    density: 2.2,
    county_fips: "01113",
    county_name: "Russell",
    county_weights: {
      "01113": 100,
    },
    county_names_all: "Russell",
    county_fips_all: "01113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36860,
    lat: 32.26118,
    lng: -85.42064,
    city: "Hurtsboro",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1890,
    density: 4.8,
    county_fips: "01113",
    county_name: "Russell",
    county_weights: {
      "01113": 62.45,
      "01087": 19.39,
      "01011": 18.15,
    },
    county_names_all: "Russell|Macon|Bullock",
    county_fips_all: "01113|01087|01011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36861,
    lat: 32.88585,
    lng: -85.83232,
    city: "Jacksons Gap",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2726,
    density: 21,
    county_fips: "01123",
    county_name: "Tallapoosa",
    county_weights: {
      "01123": 100,
    },
    county_names_all: "Tallapoosa",
    county_fips_all: "01123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36862,
    lat: 32.90612,
    lng: -85.44283,
    city: "Lafayette",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5691,
    density: 9.7,
    county_fips: "01017",
    county_name: "Chambers",
    county_weights: {
      "01017": 100,
    },
    county_names_all: "Chambers",
    county_fips_all: "01017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36863,
    lat: 32.89722,
    lng: -85.25916,
    city: "Lanett",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11718,
    density: 47.3,
    county_fips: "01017",
    county_name: "Chambers",
    county_weights: {
      "01017": 100,
    },
    county_names_all: "Chambers",
    county_fips_all: "01017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36865,
    lat: 32.60259,
    lng: -85.58946,
    city: "Loachapoka",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59,
    density: 198.2,
    county_fips: "01081",
    county_name: "Lee",
    county_weights: {
      "01081": 100,
    },
    county_names_all: "Lee",
    county_fips_all: "01081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36866,
    lat: 32.55468,
    lng: -85.71459,
    city: "Notasulga",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3795,
    density: 16.8,
    county_fips: "01087",
    county_name: "Macon",
    county_weights: {
      "01087": 68.6,
      "01123": 22.49,
      "01081": 8.91,
    },
    county_names_all: "Macon|Tallapoosa|Lee",
    county_fips_all: "01087|01123|01081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36867,
    lat: 32.49823,
    lng: -85.02304,
    city: "Phenix City",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22239,
    density: 683.1,
    county_fips: "01113",
    county_name: "Russell",
    county_weights: {
      "01113": 65.06,
      "01081": 34.94,
    },
    county_names_all: "Russell|Lee",
    county_fips_all: "01113|01081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36869,
    lat: 32.41891,
    lng: -85.0779,
    city: "Phenix City",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21191,
    density: 107.2,
    county_fips: "01113",
    county_name: "Russell",
    county_weights: {
      "01113": 100,
    },
    county_names_all: "Russell",
    county_fips_all: "01113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36870,
    lat: 32.48308,
    lng: -85.11942,
    city: "Phenix City",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18435,
    density: 300,
    county_fips: "01081",
    county_name: "Lee",
    county_weights: {
      "01081": 64.21,
      "01113": 35.79,
    },
    county_names_all: "Lee|Russell",
    county_fips_all: "01081|01113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36871,
    lat: 32.17455,
    lng: -85.14892,
    city: "Pittsview",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1081,
    density: 3.2,
    county_fips: "01113",
    county_name: "Russell",
    county_weights: {
      "01113": 100,
    },
    county_names_all: "Russell",
    county_fips_all: "01113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36874,
    lat: 32.56603,
    lng: -85.20322,
    city: "Salem",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8892,
    density: 30.7,
    county_fips: "01081",
    county_name: "Lee",
    county_weights: {
      "01081": 94.8,
      "01113": 5.2,
    },
    county_names_all: "Lee|Russell",
    county_fips_all: "01081|01113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36875,
    lat: 32.32632,
    lng: -85.16295,
    city: "Seale",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3488,
    density: 9.7,
    county_fips: "01113",
    county_name: "Russell",
    county_weights: {
      "01113": 100,
    },
    county_names_all: "Russell",
    county_fips_all: "01113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36877,
    lat: 32.55465,
    lng: -85.0974,
    city: "Smiths Station",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13340,
    density: 131.8,
    county_fips: "01081",
    county_name: "Lee",
    county_weights: {
      "01081": 99.9,
      "01113": 0.1,
    },
    county_names_all: "Lee|Russell",
    county_fips_all: "01081|01113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36879,
    lat: 32.73091,
    lng: -85.55449,
    city: "Waverly",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2637,
    density: 11.7,
    county_fips: "01017",
    county_name: "Chambers",
    county_weights: {
      "01017": 48.32,
      "01081": 46.17,
      "01123": 5.51,
    },
    county_names_all: "Chambers|Lee|Tallapoosa",
    county_fips_all: "01017|01081|01123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36901,
    lat: 32.42284,
    lng: -88.1465,
    city: "Bellamy",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 316,
    density: 9.7,
    county_fips: "01119",
    county_name: "Sumter",
    county_weights: {
      "01119": 100,
    },
    county_names_all: "Sumter",
    county_fips_all: "01119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36904,
    lat: 32.10287,
    lng: -88.25596,
    city: "Butler",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3983,
    density: 6.7,
    county_fips: "01023",
    county_name: "Choctaw",
    county_weights: {
      "01023": 100,
    },
    county_names_all: "Choctaw",
    county_fips_all: "01023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36907,
    lat: 32.43895,
    lng: -88.34797,
    city: "Cuba",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1531,
    density: 4.9,
    county_fips: "01119",
    county_name: "Sumter",
    county_weights: {
      "01119": 100,
    },
    county_names_all: "Sumter",
    county_fips_all: "01119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36908,
    lat: 31.89818,
    lng: -88.30807,
    city: "Gilbertown",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1820,
    density: 5.4,
    county_fips: "01023",
    county_name: "Choctaw",
    county_weights: {
      "01023": 100,
    },
    county_names_all: "Choctaw",
    county_fips_all: "01023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36910,
    lat: 32.23078,
    lng: -88.15928,
    city: "Jachin",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45,
    density: 11.2,
    county_fips: "01023",
    county_name: "Choctaw",
    county_weights: {
      "01023": 100,
    },
    county_names_all: "Choctaw",
    county_fips_all: "01023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36912,
    lat: 32.23825,
    lng: -88.30369,
    city: "Lisman",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1813,
    density: 4.6,
    county_fips: "01023",
    county_name: "Choctaw",
    county_weights: {
      "01023": 94.05,
      "01119": 5.95,
    },
    county_names_all: "Choctaw|Sumter",
    county_fips_all: "01023|01119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36913,
    lat: 31.96069,
    lng: -88.44667,
    city: "Melvin",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50,
    density: 2,
    county_fips: "01023",
    county_name: "Choctaw",
    county_weights: {
      "01023": 100,
    },
    county_names_all: "Choctaw",
    county_fips_all: "01023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36915,
    lat: 31.95894,
    lng: -88.36019,
    city: "Needham",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 645,
    density: 6.5,
    county_fips: "01023",
    county_name: "Choctaw",
    county_weights: {
      "01023": 100,
    },
    county_names_all: "Choctaw",
    county_fips_all: "01023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36916,
    lat: 32.23788,
    lng: -88.04143,
    city: "Pennington",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1030,
    density: 8.9,
    county_fips: "01023",
    county_name: "Choctaw",
    county_weights: {
      "01023": 100,
    },
    county_names_all: "Choctaw",
    county_fips_all: "01023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36919,
    lat: 31.76765,
    lng: -88.2894,
    city: "Silas",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1707,
    density: 4.3,
    county_fips: "01023",
    county_name: "Choctaw",
    county_weights: {
      "01023": 100,
    },
    county_names_all: "Choctaw",
    county_fips_all: "01023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36921,
    lat: 31.96956,
    lng: -88.19108,
    city: "Toxey",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 814,
    density: 3.2,
    county_fips: "01023",
    county_name: "Choctaw",
    county_weights: {
      "01023": 100,
    },
    county_names_all: "Choctaw",
    county_fips_all: "01023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36922,
    lat: 32.30061,
    lng: -88.15068,
    city: "Ward",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 651,
    density: 3.2,
    county_fips: "01023",
    county_name: "Choctaw",
    county_weights: {
      "01023": 51.57,
      "01119": 48.43,
    },
    county_names_all: "Choctaw|Sumter",
    county_fips_all: "01023|01119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 36925,
    lat: 32.43468,
    lng: -88.1791,
    city: "York",
    state_id: "AL",
    state_name: "Alabama",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2935,
    density: 7.1,
    county_fips: "01119",
    county_name: "Sumter",
    county_weights: {
      "01119": 100,
    },
    county_names_all: "Sumter",
    county_fips_all: "01119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37010,
    lat: 36.5675,
    lng: -87.10894,
    city: "Adams",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5096,
    density: 24.9,
    county_fips: 47147,
    county_name: "Robertson",
    county_weights: {
      47125: 38.74,
      47147: 61.26,
    },
    county_names_all: "Robertson|Montgomery",
    county_fips_all: "47147|47125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37012,
    lat: 36.07112,
    lng: -86.00563,
    city: "Alexandria",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1954,
    density: 20.5,
    county_fips: 47041,
    county_name: "DeKalb",
    county_weights: {
      47041: 57.53,
      47159: 20.45,
      47189: 22.02,
    },
    county_names_all: "DeKalb|Wilson|Smith",
    county_fips_all: "47041|47189|47159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37013,
    lat: 36.04658,
    lng: -86.63445,
    city: "Antioch",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 99109,
    density: 976,
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47037: 100,
    },
    county_names_all: "Davidson",
    county_fips_all: 47037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37014,
    lat: 35.8725,
    lng: -86.6532,
    city: "Arrington",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2858,
    density: 50.2,
    county_fips: 47187,
    county_name: "Williamson",
    county_weights: {
      47149: 30.6,
      47187: 69.4,
    },
    county_names_all: "Williamson|Rutherford",
    county_fips_all: "47187|47149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37015,
    lat: 36.28798,
    lng: -87.08113,
    city: "Ashland City",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17835,
    density: 44.2,
    county_fips: 47021,
    county_name: "Cheatham",
    county_weights: {
      47021: 92.85,
      47037: 5.7,
      47125: 1.45,
    },
    county_names_all: "Cheatham|Davidson|Montgomery",
    county_fips_all: "47021|47037|47125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37016,
    lat: 35.96355,
    lng: -86.11364,
    city: "Auburntown",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 955,
    density: 11,
    county_fips: 47189,
    county_name: "Wilson",
    county_weights: {
      47015: 40.94,
      47189: 59.06,
    },
    county_names_all: "Wilson|Cannon",
    county_fips_all: "47189|47015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37018,
    lat: 35.64255,
    lng: -86.19876,
    city: "Beechgrove",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2494,
    density: 23.9,
    county_fips: 47031,
    county_name: "Coffee",
    county_weights: {
      47003: 9.41,
      47031: 90.59,
    },
    county_names_all: "Coffee|Bedford",
    county_fips_all: "47031|47003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37019,
    lat: 35.39094,
    lng: -86.70943,
    city: "Belfast",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 676,
    density: 14.7,
    county_fips: 47117,
    county_name: "Marshall",
    county_weights: {
      47117: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 47117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37020,
    lat: 35.62563,
    lng: -86.39927,
    city: "Bell Buckle",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6036,
    density: 25.4,
    county_fips: 47003,
    county_name: "Bedford",
    county_weights: {
      47003: 75.66,
      47149: 24.34,
    },
    county_names_all: "Bedford|Rutherford",
    county_fips_all: "47003|47149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37022,
    lat: 36.4997,
    lng: -86.31017,
    city: "Bethpage",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6694,
    density: 29.7,
    county_fips: 47165,
    county_name: "Sumner",
    county_weights: {
      47111: 1.59,
      47165: 85.07,
      47169: 13.34,
    },
    county_names_all: "Sumner|Trousdale|Macon",
    county_fips_all: "47165|47169|47111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37023,
    lat: 36.58409,
    lng: -87.78302,
    city: "Big Rock",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1408,
    density: 31,
    county_fips: 47161,
    county_name: "Stewart",
    county_weights: {
      47161: 100,
    },
    county_names_all: "Stewart",
    county_fips_all: 47161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37025,
    lat: 35.95263,
    lng: -87.30855,
    city: "Bon Aqua",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5923,
    density: 35.8,
    county_fips: 47081,
    county_name: "Hickman",
    county_weights: {
      47043: 23.99,
      47081: 72.82,
      47187: 3.19,
    },
    county_names_all: "Hickman|Dickson|Williamson",
    county_fips_all: "47081|47043|47187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37026,
    lat: 35.69578,
    lng: -86.10746,
    city: "Bradyville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2117,
    density: 16,
    county_fips: 47015,
    county_name: "Cannon",
    county_weights: {
      47015: 96.34,
      47031: 3.66,
    },
    county_names_all: "Cannon|Coffee",
    county_fips_all: "47015|47031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37027,
    lat: 35.99978,
    lng: -86.78439,
    city: "Brentwood",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57096,
    density: 386.7,
    county_fips: 47187,
    county_name: "Williamson",
    county_weights: {
      47037: 13.57,
      47187: 86.43,
    },
    county_names_all: "Williamson|Davidson",
    county_fips_all: "47187|47037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37028,
    lat: 36.62793,
    lng: -87.85723,
    city: "Bumpus Mills",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 434,
    density: 10.8,
    county_fips: 47161,
    county_name: "Stewart",
    county_weights: {
      47161: 100,
    },
    county_names_all: "Stewart",
    county_fips_all: 47161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37029,
    lat: 36.04253,
    lng: -87.2678,
    city: "Burns",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7166,
    density: 63.5,
    county_fips: 47043,
    county_name: "Dickson",
    county_weights: {
      47043: 100,
    },
    county_names_all: "Dickson",
    county_fips_all: 47043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37030,
    lat: 36.27374,
    lng: -85.95035,
    city: "Carthage",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7674,
    density: 45.6,
    county_fips: 47159,
    county_name: "Smith",
    county_weights: {
      47087: 0.21,
      47159: 99.79,
    },
    county_names_all: "Smith|Jackson",
    county_fips_all: "47159|47087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37031,
    lat: 36.3721,
    lng: -86.30328,
    city: "Castalian Springs",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4149,
    density: 41.9,
    county_fips: 47165,
    county_name: "Sumner",
    county_weights: {
      47165: 78.4,
      47169: 21.6,
    },
    county_names_all: "Sumner|Trousdale",
    county_fips_all: "47165|47169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37032,
    lat: 36.52518,
    lng: -87.01647,
    city: "Cedar Hill",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5227,
    density: 25.5,
    county_fips: 47147,
    county_name: "Robertson",
    county_weights: {
      47021: 1.47,
      47125: 0.11,
      47147: 98.42,
    },
    county_names_all: "Robertson|Cheatham|Montgomery",
    county_fips_all: "47147|47021|47125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37033,
    lat: 35.73493,
    lng: -87.55365,
    city: "Centerville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7604,
    density: 11,
    county_fips: 47081,
    county_name: "Hickman",
    county_weights: {
      47081: 98.04,
      47135: 1.96,
    },
    county_names_all: "Hickman|Perry",
    county_fips_all: "47081|47135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37034,
    lat: 35.63977,
    lng: -86.69158,
    city: "Chapel Hill",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7576,
    density: 40.1,
    county_fips: 47117,
    county_name: "Marshall",
    county_weights: {
      47003: 23.15,
      47117: 76.85,
    },
    county_names_all: "Marshall|Bedford",
    county_fips_all: "47117|47003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37035,
    lat: 36.3849,
    lng: -87.12602,
    city: "Chapmansboro",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3709,
    density: 48.7,
    county_fips: 47021,
    county_name: "Cheatham",
    county_weights: {
      47021: 100,
    },
    county_names_all: "Cheatham",
    county_fips_all: 47021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37036,
    lat: 36.23979,
    lng: -87.27182,
    city: "Charlotte",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6437,
    density: 25,
    county_fips: 47043,
    county_name: "Dickson",
    county_weights: {
      47021: 6.67,
      47043: 93.33,
    },
    county_names_all: "Dickson|Cheatham",
    county_fips_all: "47043|47021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37037,
    lat: 35.70272,
    lng: -86.35318,
    city: "Christiana",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8570,
    density: 42.7,
    county_fips: 47149,
    county_name: "Rutherford",
    county_weights: {
      47149: 100,
    },
    county_names_all: "Rutherford",
    county_fips_all: 47149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37040,
    lat: 36.52408,
    lng: -87.33287,
    city: "Clarksville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52736,
    density: 219.4,
    county_fips: 47125,
    county_name: "Montgomery",
    county_weights: {
      47125: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 47125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37042,
    lat: 36.56894,
    lng: -87.41225,
    city: "Clarksville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 80661,
    density: 547.6,
    county_fips: 47125,
    county_name: "Montgomery",
    county_weights: {
      47125: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 47125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37043,
    lat: 36.49842,
    lng: -87.23197,
    city: "Clarksville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49669,
    density: 176.8,
    county_fips: 47125,
    county_name: "Montgomery",
    county_weights: {
      47021: 1.69,
      47125: 98.31,
    },
    county_names_all: "Montgomery|Cheatham",
    county_fips_all: "47125|47021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37046,
    lat: 35.77995,
    lng: -86.71582,
    city: "College Grove",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5669,
    density: 30.7,
    county_fips: 47187,
    county_name: "Williamson",
    county_weights: {
      47117: 1.73,
      47149: 6.31,
      47187: 91.96,
    },
    county_names_all: "Williamson|Rutherford|Marshall",
    county_fips_all: "47187|47149|47117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37047,
    lat: 35.31291,
    lng: -86.83191,
    city: "Cornersville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2315,
    density: 13.6,
    county_fips: 47117,
    county_name: "Marshall",
    county_weights: {
      47055: 19.93,
      47103: 1.85,
      47117: 78.22,
    },
    county_names_all: "Marshall|Giles|Lincoln",
    county_fips_all: "47117|47055|47103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37048,
    lat: 36.4904,
    lng: -86.59112,
    city: "Cottontown",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6229,
    density: 51.8,
    county_fips: 47165,
    county_name: "Sumner",
    county_weights: {
      47147: 4.25,
      47165: 95.75,
    },
    county_names_all: "Sumner|Robertson",
    county_fips_all: "47165|47147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37049,
    lat: 36.55985,
    lng: -86.67887,
    city: "Cross Plains",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4035,
    density: 58.2,
    county_fips: 47147,
    county_name: "Robertson",
    county_weights: {
      47147: 100,
    },
    county_names_all: "Robertson",
    county_fips_all: 47147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37050,
    lat: 36.3713,
    lng: -87.63586,
    city: "Cumberland City",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1712,
    density: 12.5,
    county_fips: 47161,
    county_name: "Stewart",
    county_weights: {
      47083: 26.13,
      47125: 21.11,
      47161: 52.76,
    },
    county_names_all: "Stewart|Houston|Montgomery",
    county_fips_all: "47161|47083|47125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37051,
    lat: 36.30426,
    lng: -87.41405,
    city: "Cumberland Furnace",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3237,
    density: 15.5,
    county_fips: 47043,
    county_name: "Dickson",
    county_weights: {
      47043: 72.33,
      47083: 3.9,
      47125: 23.77,
    },
    county_names_all: "Dickson|Montgomery|Houston",
    county_fips_all: "47043|47125|47083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37052,
    lat: 36.37534,
    lng: -87.40095,
    city: "Cunningham",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2458,
    density: 27.2,
    county_fips: 47125,
    county_name: "Montgomery",
    county_weights: {
      47043: 1.8,
      47125: 98.2,
    },
    county_names_all: "Montgomery|Dickson",
    county_fips_all: "47125|47043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37055,
    lat: 36.07921,
    lng: -87.44238,
    city: "Dickson",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27410,
    density: 52.5,
    county_fips: 47043,
    county_name: "Dickson",
    county_weights: {
      47043: 91.59,
      47081: 8.41,
    },
    county_names_all: "Dickson|Hickman",
    county_fips_all: "47043|47081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37057,
    lat: 36.40466,
    lng: -86.02726,
    city: "Dixon Springs",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 660,
    density: 8.7,
    county_fips: 47169,
    county_name: "Trousdale",
    county_weights: {
      47111: 30.49,
      47159: 31.37,
      47169: 38.14,
    },
    county_names_all: "Trousdale|Smith|Macon",
    county_fips_all: "47169|47159|47111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37058,
    lat: 36.47872,
    lng: -87.8807,
    city: "Dover",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7817,
    density: 16.4,
    county_fips: 47161,
    county_name: "Stewart",
    county_weights: {
      47161: 100,
    },
    county_names_all: "Stewart",
    county_fips_all: 47161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37059,
    lat: 35.98611,
    lng: -85.90798,
    city: "Dowelltown",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1336,
    density: 18.3,
    county_fips: 47041,
    county_name: "DeKalb",
    county_weights: {
      47041: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 47041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37060,
    lat: 35.74924,
    lng: -86.63428,
    city: "Eagleville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2807,
    density: 26.8,
    county_fips: 47149,
    county_name: "Rutherford",
    county_weights: {
      47003: 11.51,
      47117: 1.02,
      47149: 74.76,
      47187: 12.71,
    },
    county_names_all: "Rutherford|Williamson|Bedford|Marshall",
    county_fips_all: "47149|47187|47003|47117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37061,
    lat: 36.28918,
    lng: -87.66528,
    city: "Erin",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5179,
    density: 22.5,
    county_fips: 47083,
    county_name: "Houston",
    county_weights: {
      47083: 98.55,
      47125: 0.9,
      47161: 0.55,
    },
    county_names_all: "Houston|Montgomery|Stewart",
    county_fips_all: "47083|47125|47161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37062,
    lat: 35.98833,
    lng: -87.13483,
    city: "Fairview",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12971,
    density: 72.4,
    county_fips: 47187,
    county_name: "Williamson",
    county_weights: {
      47043: 6.81,
      47187: 93.19,
    },
    county_names_all: "Williamson|Dickson",
    county_fips_all: "47187|47043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37064,
    lat: 35.88966,
    lng: -86.96112,
    city: "Franklin",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60272,
    density: 126.5,
    county_fips: 47187,
    county_name: "Williamson",
    county_weights: {
      47037: 0.78,
      47187: 99.22,
    },
    county_names_all: "Williamson|Davidson",
    county_fips_all: "47187|47037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37066,
    lat: 36.39871,
    lng: -86.45594,
    city: "Gallatin",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54377,
    density: 180.5,
    county_fips: 47165,
    county_name: "Sumner",
    county_weights: {
      47165: 100,
    },
    county_names_all: "Sumner",
    county_fips_all: 47165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37067,
    lat: 35.91314,
    lng: -86.77461,
    city: "Franklin",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31681,
    density: 376,
    county_fips: 47187,
    county_name: "Williamson",
    county_weights: {
      47187: 100,
    },
    county_names_all: "Williamson",
    county_fips_all: 47187,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37069,
    lat: 35.98753,
    lng: -86.90664,
    city: "Franklin",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20093,
    density: 215.8,
    county_fips: 47187,
    county_name: "Williamson",
    county_weights: {
      47187: 100,
    },
    county_names_all: "Williamson",
    county_fips_all: 47187,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37072,
    lat: 36.35686,
    lng: -86.74494,
    city: "Goodlettsville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31134,
    density: 155,
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47037: 50.71,
      47147: 14.84,
      47165: 34.45,
    },
    county_names_all: "Davidson|Sumner|Robertson",
    county_fips_all: "47037|47165|47147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37073,
    lat: 36.42834,
    lng: -86.81414,
    city: "Greenbrier",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14569,
    density: 109.8,
    county_fips: 47147,
    county_name: "Robertson",
    county_weights: {
      47147: 100,
    },
    county_names_all: "Robertson",
    county_fips_all: 47147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37074,
    lat: 36.41552,
    lng: -86.14724,
    city: "Hartsville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9967,
    density: 38.5,
    county_fips: 47169,
    county_name: "Trousdale",
    county_weights: {
      47111: 25.8,
      47169: 74.2,
    },
    county_names_all: "Trousdale|Macon",
    county_fips_all: "47169|47111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37075,
    lat: 36.34085,
    lng: -86.60845,
    city: "Hendersonville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68336,
    density: 446.9,
    county_fips: 47165,
    county_name: "Sumner",
    county_weights: {
      47165: 100,
    },
    county_names_all: "Sumner",
    county_fips_all: 47165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37076,
    lat: 36.14512,
    lng: -86.57977,
    city: "Hermitage",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38647,
    density: 536.5,
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47037: 93.74,
      47189: 6.26,
    },
    county_names_all: "Davidson|Wilson",
    county_fips_all: "47037|47189",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37078,
    lat: 35.92366,
    lng: -87.77138,
    city: "Hurricane Mills",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 341,
    density: 1.4,
    county_fips: 47085,
    county_name: "Humphreys",
    county_weights: {
      47081: 2.42,
      47085: 97.58,
    },
    county_names_all: "Humphreys|Hickman",
    county_fips_all: "47085|47081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37079,
    lat: 36.4826,
    lng: -87.65939,
    city: "Indian Mound",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2915,
    density: 14.3,
    county_fips: 47161,
    county_name: "Stewart",
    county_weights: {
      47125: 19.92,
      47161: 80.08,
    },
    county_names_all: "Stewart|Montgomery",
    county_fips_all: "47161|47125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37080,
    lat: 36.32901,
    lng: -86.91633,
    city: "Joelton",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7537,
    density: 59.2,
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47021: 39.79,
      47037: 59.48,
      47147: 0.73,
    },
    county_names_all: "Davidson|Cheatham|Robertson",
    county_fips_all: "47037|47021|47147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37082,
    lat: 36.09717,
    lng: -87.11484,
    city: "Kingston Springs",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5734,
    density: 52.2,
    county_fips: 47021,
    county_name: "Cheatham",
    county_weights: {
      47021: 100,
    },
    county_names_all: "Cheatham",
    county_fips_all: 47021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37083,
    lat: 36.54357,
    lng: -86.00149,
    city: "Lafayette",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14847,
    density: 38.8,
    county_fips: 47111,
    county_name: "Macon",
    county_weights: {
      47111: 100,
    },
    county_names_all: "Macon",
    county_fips_all: 47111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37085,
    lat: 35.95308,
    lng: -86.27912,
    city: "Lascassas",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5220,
    density: 36.7,
    county_fips: 47149,
    county_name: "Rutherford",
    county_weights: {
      47149: 72.56,
      47189: 27.44,
    },
    county_names_all: "Rutherford|Wilson",
    county_fips_all: "47149|47189",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37086,
    lat: 36.02177,
    lng: -86.55971,
    city: "La Vergne",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34362,
    density: 535.5,
    county_fips: 47149,
    county_name: "Rutherford",
    county_weights: {
      47037: 5.11,
      47149: 94.89,
    },
    county_names_all: "Rutherford|Davidson",
    county_fips_all: "47149|47037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37087,
    lat: 36.2733,
    lng: -86.27224,
    city: "Lebanon",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48478,
    density: 113.5,
    county_fips: 47189,
    county_name: "Wilson",
    county_weights: {
      47159: 7.42,
      47169: 5.58,
      47189: 87,
    },
    county_names_all: "Wilson|Smith|Trousdale",
    county_fips_all: "47189|47159|47169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37090,
    lat: 36.12439,
    lng: -86.29707,
    city: "Lebanon",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15143,
    density: 35.1,
    county_fips: 47189,
    county_name: "Wilson",
    county_weights: {
      47149: 0.98,
      47159: 2.72,
      47189: 96.3,
    },
    county_names_all: "Wilson|Smith|Rutherford",
    county_fips_all: "47189|47159|47149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37091,
    lat: 35.48546,
    lng: -86.76405,
    city: "Lewisburg",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23052,
    density: 43.2,
    county_fips: 47117,
    county_name: "Marshall",
    county_weights: {
      47003: 7.81,
      47117: 91.1,
      47119: 1.09,
    },
    county_names_all: "Marshall|Bedford|Maury",
    county_fips_all: "47117|47003|47119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37095,
    lat: 35.98295,
    lng: -85.95919,
    city: "Liberty",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3142,
    density: 15.7,
    county_fips: 47041,
    county_name: "DeKalb",
    county_weights: {
      47015: 21.58,
      47041: 76.38,
      47189: 2.04,
    },
    county_names_all: "DeKalb|Cannon|Wilson",
    county_fips_all: "47041|47015|47189",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37096,
    lat: 35.60487,
    lng: -87.86054,
    city: "Linden",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5947,
    density: 7.4,
    county_fips: 47135,
    county_name: "Perry",
    county_weights: {
      47101: 0.46,
      47135: 97.4,
      47181: 2.14,
    },
    county_names_all: "Perry|Wayne|Lewis",
    county_fips_all: "47135|47181|47101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37097,
    lat: 35.7785,
    lng: -87.8303,
    city: "Lobelville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2005,
    density: 8.3,
    county_fips: 47135,
    county_name: "Perry",
    county_weights: {
      47135: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 47135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37098,
    lat: 35.87142,
    lng: -87.31075,
    city: "Lyles",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5904,
    density: 39,
    county_fips: 47081,
    county_name: "Hickman",
    county_weights: {
      47081: 100,
    },
    county_names_all: "Hickman",
    county_fips_all: 47081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37101,
    lat: 36.06625,
    lng: -87.63741,
    city: "McEwen",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7032,
    density: 13.6,
    county_fips: 47085,
    county_name: "Humphreys",
    county_weights: {
      47081: 8.82,
      47083: 4.25,
      47085: 86.93,
    },
    county_names_all: "Humphreys|Hickman|Houston",
    county_fips_all: "47085|47081|47083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37110,
    lat: 35.6436,
    lng: -85.74314,
    city: "Mcminnville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32731,
    density: 33.8,
    county_fips: 47177,
    county_name: "Warren",
    county_weights: {
      47015: 1.93,
      47061: 14.89,
      47153: 1.54,
      47175: 3.02,
      47177: 78.62,
    },
    county_names_all: "Warren|Grundy|Van Buren|Cannon|Sequatchie",
    county_fips_all: "47177|47061|47175|47015|47153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37115,
    lat: 36.25444,
    lng: -86.69636,
    city: "Madison",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39573,
    density: 712.1,
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47037: 100,
    },
    county_names_all: "Davidson",
    county_fips_all: 47037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37118,
    lat: 35.92569,
    lng: -86.18903,
    city: "Milton",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1052,
    density: 12.4,
    county_fips: 47149,
    county_name: "Rutherford",
    county_weights: {
      47015: 8.03,
      47149: 69.32,
      47189: 22.65,
    },
    county_names_all: "Rutherford|Wilson|Cannon",
    county_fips_all: "47149|47189|47015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37122,
    lat: 36.17791,
    lng: -86.48872,
    city: "Mount Juliet",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61002,
    density: 211,
    county_fips: 47189,
    county_name: "Wilson",
    county_weights: {
      47037: 0.91,
      47149: 8.74,
      47189: 90.35,
    },
    county_names_all: "Wilson|Rutherford|Davidson",
    county_fips_all: "47189|47149|47037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37127,
    lat: 35.77947,
    lng: -86.32723,
    city: "Murfreesboro",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19817,
    density: 162.5,
    county_fips: 47149,
    county_name: "Rutherford",
    county_weights: {
      47149: 100,
    },
    county_names_all: "Rutherford",
    county_fips_all: 47149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37128,
    lat: 35.80343,
    lng: -86.47483,
    city: "Murfreesboro",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60038,
    density: 409.1,
    county_fips: 47149,
    county_name: "Rutherford",
    county_weights: {
      47149: 100,
    },
    county_names_all: "Rutherford",
    county_fips_all: 47149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37129,
    lat: 35.92556,
    lng: -86.44098,
    city: "Murfreesboro",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60516,
    density: 292.1,
    county_fips: 47149,
    county_name: "Rutherford",
    county_weights: {
      47149: 100,
    },
    county_names_all: "Rutherford",
    county_fips_all: 47149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37130,
    lat: 35.8809,
    lng: -86.33003,
    city: "Murfreesboro",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57068,
    density: 407,
    county_fips: 47149,
    county_name: "Rutherford",
    county_weights: {
      47149: 100,
    },
    county_names_all: "Rutherford",
    county_fips_all: 47149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37132,
    lat: 35.84873,
    lng: -86.36284,
    city: "Murfreesboro",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2414,
    density: 1509.8,
    county_fips: 47149,
    county_name: "Rutherford",
    county_weights: {
      47149: 100,
    },
    county_names_all: "Rutherford",
    county_fips_all: 47149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37134,
    lat: 36.0014,
    lng: -87.95063,
    city: "New Johnsonville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3109,
    density: 30.7,
    county_fips: 47085,
    county_name: "Humphreys",
    county_weights: {
      47085: 100,
    },
    county_names_all: "Humphreys",
    county_fips_all: 47085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37135,
    lat: 35.93562,
    lng: -86.6625,
    city: "Nolensville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17318,
    density: 181.3,
    county_fips: 47187,
    county_name: "Williamson",
    county_weights: {
      47037: 8.22,
      47149: 3.24,
      47187: 88.54,
    },
    county_names_all: "Williamson|Davidson|Rutherford",
    county_fips_all: "47187|47037|47149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37137,
    lat: 35.87912,
    lng: -87.50276,
    city: "Nunnelly",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2679,
    density: 12,
    county_fips: 47081,
    county_name: "Hickman",
    county_weights: {
      47081: 100,
    },
    county_names_all: "Hickman",
    county_fips_all: 47081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37138,
    lat: 36.24652,
    lng: -86.61938,
    city: "Old Hickory",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23789,
    density: 512.4,
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47037: 69.19,
      47189: 30.81,
    },
    county_names_all: "Davidson|Wilson",
    county_fips_all: "47037|47189",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37140,
    lat: 35.86345,
    lng: -87.65245,
    city: "Only",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1613,
    density: 24.1,
    county_fips: 47081,
    county_name: "Hickman",
    county_weights: {
      47081: 100,
    },
    county_names_all: "Hickman",
    county_fips_all: 47081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37141,
    lat: 36.6145,
    lng: -86.69894,
    city: "Orlinda",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1476,
    density: 28.1,
    county_fips: 47147,
    county_name: "Robertson",
    county_weights: {
      47147: 100,
    },
    county_names_all: "Robertson",
    county_fips_all: 47147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37142,
    lat: 36.41164,
    lng: -87.50112,
    city: "Palmyra",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1747,
    density: 18.1,
    county_fips: 47125,
    county_name: "Montgomery",
    county_weights: {
      47125: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 47125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37143,
    lat: 36.13137,
    lng: -87.03038,
    city: "Pegram",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3905,
    density: 45.5,
    county_fips: 47021,
    county_name: "Cheatham",
    county_weights: {
      47021: 81.41,
      47037: 18.59,
    },
    county_names_all: "Cheatham|Davidson",
    county_fips_all: "47021|47037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37144,
    lat: 35.30516,
    lng: -86.65585,
    city: "Petersburg",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3088,
    density: 9.1,
    county_fips: 47103,
    county_name: "Lincoln",
    county_weights: {
      47003: 8.27,
      47055: 1.66,
      47103: 58.79,
      47117: 28,
      47127: 3.28,
    },
    county_names_all: "Lincoln|Marshall|Bedford|Moore|Giles",
    county_fips_all: "47103|47117|47003|47127|47055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37145,
    lat: 36.38179,
    lng: -85.91203,
    city: "Pleasant Shade",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2323,
    density: 11.3,
    county_fips: 47159,
    county_name: "Smith",
    county_weights: {
      47087: 10.43,
      47111: 18.69,
      47159: 70.88,
    },
    county_names_all: "Smith|Macon|Jackson",
    county_fips_all: "47159|47111|47087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37146,
    lat: 36.4047,
    lng: -87.03123,
    city: "Pleasant View",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7396,
    density: 93.3,
    county_fips: 47147,
    county_name: "Robertson",
    county_weights: {
      47021: 46.42,
      47147: 53.58,
    },
    county_names_all: "Robertson|Cheatham",
    county_fips_all: "47147|47021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37148,
    lat: 36.57694,
    lng: -86.50224,
    city: "Portland",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24747,
    density: 72.5,
    county_fips: 47165,
    county_name: "Sumner",
    county_weights: {
      47147: 14.81,
      47165: 85.19,
    },
    county_names_all: "Sumner|Robertson",
    county_fips_all: "47165|47147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37149,
    lat: 35.80876,
    lng: -86.19311,
    city: "Readyville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2500,
    density: 15,
    county_fips: 47149,
    county_name: "Rutherford",
    county_weights: {
      47015: 42.74,
      47149: 57.26,
    },
    county_names_all: "Rutherford|Cannon",
    county_fips_all: "47149|47015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37150,
    lat: 36.54437,
    lng: -85.81082,
    city: "Red Boiling Springs",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5031,
    density: 18.8,
    county_fips: 47111,
    county_name: "Macon",
    county_weights: {
      47027: 40.53,
      47087: 5.3,
      47111: 54.17,
    },
    county_names_all: "Macon|Clay|Jackson",
    county_fips_all: "47111|47027|47087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37151,
    lat: 36.31288,
    lng: -86.04536,
    city: "Riddleton",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 609,
    density: 13.8,
    county_fips: 47159,
    county_name: "Smith",
    county_weights: {
      47159: 100,
    },
    county_names_all: "Smith",
    county_fips_all: 47159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37153,
    lat: 35.7645,
    lng: -86.55531,
    city: "Rockvale",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6132,
    density: 45.3,
    county_fips: 47149,
    county_name: "Rutherford",
    county_weights: {
      47003: 9.89,
      47149: 90.11,
    },
    county_names_all: "Rutherford|Bedford",
    county_fips_all: "47149|47003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37160,
    lat: 35.46562,
    lng: -86.48268,
    city: "Shelbyville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33606,
    density: 55.6,
    county_fips: 47003,
    county_name: "Bedford",
    county_weights: {
      47003: 97.91,
      47127: 2.09,
    },
    county_names_all: "Bedford|Moore",
    county_fips_all: "47003|47127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37165,
    lat: 36.29005,
    lng: -87.46943,
    city: "Slayden",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31,
    density: 35.4,
    county_fips: 47043,
    county_name: "Dickson",
    county_weights: {
      47043: 100,
    },
    county_names_all: "Dickson",
    county_fips_all: 47043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37166,
    lat: 35.92444,
    lng: -85.78978,
    city: "Smithville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14310,
    density: 35.7,
    county_fips: 47041,
    county_name: "DeKalb",
    county_weights: {
      47015: 1.59,
      47041: 91.48,
      47177: 6.93,
    },
    county_names_all: "DeKalb|Warren|Cannon",
    county_fips_all: "47041|47177|47015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37167,
    lat: 35.96325,
    lng: -86.52922,
    city: "Smyrna",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61176,
    density: 429.5,
    county_fips: 47149,
    county_name: "Rutherford",
    county_weights: {
      47149: 100,
    },
    county_names_all: "Rutherford",
    county_fips_all: 47149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37171,
    lat: 36.36442,
    lng: -87.30365,
    city: "Southside",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 874,
    density: 14.1,
    county_fips: 47125,
    county_name: "Montgomery",
    county_weights: {
      47043: 0.1,
      47125: 99.9,
    },
    county_names_all: "Montgomery|Dickson",
    county_fips_all: "47125|47043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37172,
    lat: 36.53661,
    lng: -86.86005,
    city: "Springfield",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30261,
    density: 65,
    county_fips: 47147,
    county_name: "Robertson",
    county_weights: {
      47147: 100,
    },
    county_names_all: "Robertson",
    county_fips_all: 47147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37174,
    lat: 35.72197,
    lng: -86.8995,
    city: "Spring Hill",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38793,
    density: 214.9,
    county_fips: 47119,
    county_name: "Maury",
    county_weights: {
      47117: 1.48,
      47119: 74.83,
      47187: 23.69,
    },
    county_names_all: "Maury|Williamson|Marshall",
    county_fips_all: "47119|47187|47117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37175,
    lat: 36.32349,
    lng: -87.89678,
    city: "Stewart",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 738,
    density: 3.8,
    county_fips: 47083,
    county_name: "Houston",
    county_weights: {
      47083: 58.89,
      47161: 41.11,
    },
    county_names_all: "Houston|Stewart",
    county_fips_all: "47083|47161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37178,
    lat: 36.3195,
    lng: -87.78694,
    city: "Tennessee Ridge",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1842,
    density: 16.8,
    county_fips: 47083,
    county_name: "Houston",
    county_weights: {
      47083: 60.92,
      47161: 39.08,
    },
    county_names_all: "Houston|Stewart",
    county_fips_all: "47083|47161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37179,
    lat: 35.8073,
    lng: -86.91517,
    city: "Thompsons Station",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15860,
    density: 115.4,
    county_fips: 47187,
    county_name: "Williamson",
    county_weights: {
      47187: 100,
    },
    county_names_all: "Williamson",
    county_fips_all: 47187,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37180,
    lat: 35.6189,
    lng: -86.57679,
    city: "Unionville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4454,
    density: 51,
    county_fips: 47003,
    county_name: "Bedford",
    county_weights: {
      47003: 92.27,
      47117: 0.5,
      47149: 7.23,
    },
    county_names_all: "Bedford|Rutherford|Marshall",
    county_fips_all: "47003|47149|47117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37181,
    lat: 36.241,
    lng: -87.49706,
    city: "Vanleer",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1652,
    density: 12.2,
    county_fips: 47043,
    county_name: "Dickson",
    county_weights: {
      47043: 65.39,
      47083: 34.61,
    },
    county_names_all: "Dickson|Houston",
    county_fips_all: "47043|47083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37183,
    lat: 35.5104,
    lng: -86.30162,
    city: "Wartrace",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3270,
    density: 15.3,
    county_fips: 47003,
    county_name: "Bedford",
    county_weights: {
      47003: 79.52,
      47031: 15.44,
      47127: 5.04,
    },
    county_names_all: "Bedford|Coffee|Moore",
    county_fips_all: "47003|47031|47127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37184,
    lat: 36.08682,
    lng: -86.14524,
    city: "Watertown",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6884,
    density: 24.1,
    county_fips: 47189,
    county_name: "Wilson",
    county_weights: {
      47159: 3.49,
      47189: 96.51,
    },
    county_names_all: "Wilson|Smith",
    county_fips_all: "47189|47159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37185,
    lat: 36.07118,
    lng: -87.8392,
    city: "Waverly",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8381,
    density: 14.4,
    county_fips: 47085,
    county_name: "Humphreys",
    county_weights: {
      47083: 0.27,
      47085: 99.73,
    },
    county_names_all: "Humphreys|Houston",
    county_fips_all: "47085|47083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37186,
    lat: 36.58644,
    lng: -86.22868,
    city: "Westmoreland",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10597,
    density: 37.9,
    county_fips: 47165,
    county_name: "Sumner",
    county_weights: {
      47111: 45.97,
      47165: 54.03,
    },
    county_names_all: "Sumner|Macon",
    county_fips_all: "47165|47111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37187,
    lat: 36.1471,
    lng: -87.19885,
    city: "White Bluff",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7745,
    density: 42,
    county_fips: 47043,
    county_name: "Dickson",
    county_weights: {
      47021: 22.39,
      47043: 77.61,
    },
    county_names_all: "Dickson|Cheatham",
    county_fips_all: "47043|47021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37188,
    lat: 36.48048,
    lng: -86.68101,
    city: "White House",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16034,
    density: 201.4,
    county_fips: 47147,
    county_name: "Robertson",
    county_weights: {
      47147: 73.04,
      47165: 26.96,
    },
    county_names_all: "Robertson|Sumner",
    county_fips_all: "47147|47165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37189,
    lat: 36.27875,
    lng: -86.82983,
    city: "Whites Creek",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4453,
    density: 68.1,
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47037: 100,
    },
    county_names_all: "Davidson",
    county_fips_all: 47037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37190,
    lat: 35.82599,
    lng: -86.0424,
    city: "Woodbury",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8611,
    density: 23.9,
    county_fips: 47015,
    county_name: "Cannon",
    county_weights: {
      47015: 98.46,
      47177: 1.54,
    },
    county_names_all: "Cannon|Warren",
    county_fips_all: "47015|47177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37191,
    lat: 36.50726,
    lng: -87.52392,
    city: "Woodlawn",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4545,
    density: 38.2,
    county_fips: 47125,
    county_name: "Montgomery",
    county_weights: {
      47125: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 47125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37201,
    lat: 36.16662,
    lng: -86.77799,
    city: "Nashville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1745,
    density: 2098.5,
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47037: 100,
    },
    county_names_all: "Davidson",
    county_fips_all: 47037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37203,
    lat: 36.14937,
    lng: -86.78986,
    city: "Nashville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16772,
    density: 1543.9,
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47037: 100,
    },
    county_names_all: "Davidson",
    county_fips_all: 47037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37204,
    lat: 36.10669,
    lng: -86.77463,
    city: "Nashville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15908,
    density: 842.1,
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47037: 100,
    },
    county_names_all: "Davidson",
    county_fips_all: 47037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37205,
    lat: 36.11075,
    lng: -86.87274,
    city: "Nashville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23680,
    density: 641,
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47037: 100,
    },
    county_names_all: "Davidson",
    county_fips_all: 47037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37206,
    lat: 36.18085,
    lng: -86.73117,
    city: "Nashville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27055,
    density: 1347.8,
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47037: 100,
    },
    county_names_all: "Davidson",
    county_fips_all: 47037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37207,
    lat: 36.23278,
    lng: -86.77765,
    city: "Nashville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39151,
    density: 781.4,
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47037: 100,
    },
    county_names_all: "Davidson",
    county_fips_all: 47037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37208,
    lat: 36.17691,
    lng: -86.80901,
    city: "Nashville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18375,
    density: 1473.2,
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47037: 100,
    },
    county_names_all: "Davidson",
    county_fips_all: 47037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37209,
    lat: 36.15591,
    lng: -86.91638,
    city: "Nashville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37852,
    density: 434.3,
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47021: 0.32,
      47037: 99.68,
    },
    county_names_all: "Davidson|Cheatham",
    county_fips_all: "47037|47021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37210,
    lat: 36.1442,
    lng: -86.73374,
    city: "Nashville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16810,
    density: 699.4,
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47037: 100,
    },
    county_names_all: "Davidson",
    county_fips_all: 47037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37211,
    lat: 36.06704,
    lng: -86.72345,
    city: "Nashville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75199,
    density: 1336.4,
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47037: 100,
    },
    county_names_all: "Davidson",
    county_fips_all: 47037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37212,
    lat: 36.13376,
    lng: -86.80167,
    city: "Nashville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20672,
    density: 2902.4,
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47037: 100,
    },
    county_names_all: "Davidson",
    county_fips_all: 47037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37213,
    lat: 36.16654,
    lng: -86.76731,
    city: "Nashville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40,
    density: 21.8,
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47037: 100,
    },
    county_names_all: "Davidson",
    county_fips_all: 47037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37214,
    lat: 36.16789,
    lng: -86.66296,
    city: "Nashville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30217,
    density: 531.5,
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47037: 100,
    },
    county_names_all: "Davidson",
    county_fips_all: 47037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37215,
    lat: 36.08197,
    lng: -86.83492,
    city: "Nashville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23044,
    density: 580.5,
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47037: 98.32,
      47187: 1.68,
    },
    county_names_all: "Davidson|Williamson",
    county_fips_all: "47037|47187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37216,
    lat: 36.21589,
    lng: -86.72676,
    city: "Nashville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18081,
    density: 1037.5,
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47037: 100,
    },
    county_names_all: "Davidson",
    county_fips_all: 47037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37217,
    lat: 36.10836,
    lng: -86.66178,
    city: "Nashville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30947,
    density: 672.8,
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47037: 100,
    },
    county_names_all: "Davidson",
    county_fips_all: 47037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37218,
    lat: 36.20814,
    lng: -86.89158,
    city: "Nashville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15582,
    density: 154.1,
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47037: 100,
    },
    county_names_all: "Davidson",
    county_fips_all: 47037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37219,
    lat: 36.1663,
    lng: -86.78299,
    city: "Nashville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1043,
    density: 1868.2,
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47037: 100,
    },
    county_names_all: "Davidson",
    county_fips_all: 47037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37220,
    lat: 36.06759,
    lng: -86.78127,
    city: "Nashville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5894,
    density: 295.1,
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47037: 100,
    },
    county_names_all: "Davidson",
    county_fips_all: 47037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37221,
    lat: 36.05991,
    lng: -86.97189,
    city: "Nashville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41736,
    density: 326.6,
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47037: 91.34,
      47187: 8.66,
    },
    county_names_all: "Davidson|Williamson",
    county_fips_all: "47037|47187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37228,
    lat: 36.19513,
    lng: -86.80418,
    city: "Nashville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1528,
    density: 404.7,
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47037: 100,
    },
    county_names_all: "Davidson",
    county_fips_all: 47037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37232,
    lat: 36.1411,
    lng: -86.8029,
    city: "Nashville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47037: 100,
    },
    county_names_all: "Davidson",
    county_fips_all: 47037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37238,
    lat: 36.1657,
    lng: -86.77946,
    city: "Nashville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 47037,
    county_name: "Davidson",
    county_weights: {
      47037: 100,
    },
    county_names_all: "Davidson",
    county_fips_all: 47037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37301,
    lat: 35.42765,
    lng: -85.80295,
    city: "Altamont",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 959,
    density: 6,
    county_fips: 47061,
    county_name: "Grundy",
    county_weights: {
      47061: 100,
    },
    county_names_all: "Grundy",
    county_fips_all: 47061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37302,
    lat: 35.01303,
    lng: -85.01961,
    city: "Apison",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5139,
    density: 114.9,
    county_fips: 47065,
    county_name: "Hamilton",
    county_weights: {
      47065: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 47065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37303,
    lat: 35.4403,
    lng: -84.64051,
    city: "Athens",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25062,
    density: 65,
    county_fips: 47107,
    county_name: "McMinn",
    county_weights: {
      47107: 100,
    },
    county_names_all: "McMinn",
    county_fips_all: 47107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37305,
    lat: 35.45795,
    lng: -85.70195,
    city: "Beersheba Springs",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1157,
    density: 27.4,
    county_fips: 47061,
    county_name: "Grundy",
    county_weights: {
      47061: 100,
    },
    county_names_all: "Grundy",
    county_fips_all: 47061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37306,
    lat: 35.09776,
    lng: -86.18928,
    city: "Belvidere",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2027,
    density: 6.6,
    county_fips: 47051,
    county_name: "Franklin",
    county_weights: {
      47051: 90.6,
      47127: 9.4,
    },
    county_names_all: "Franklin|Moore",
    county_fips_all: "47051|47127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37307,
    lat: 35.16676,
    lng: -84.62158,
    city: "Benton",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4806,
    density: 32.3,
    county_fips: 47139,
    county_name: "Polk",
    county_weights: {
      47011: 0.99,
      47139: 99.01,
    },
    county_names_all: "Polk|Bradley",
    county_fips_all: "47139|47011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37308,
    lat: 35.3476,
    lng: -84.99728,
    city: "Birchwood",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2644,
    density: 27.6,
    county_fips: 47065,
    county_name: "Hamilton",
    county_weights: {
      47065: 56.76,
      47121: 43.24,
    },
    county_names_all: "Hamilton|Meigs",
    county_fips_all: "47065|47121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37309,
    lat: 35.30595,
    lng: -84.74453,
    city: "Calhoun",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2280,
    density: 22.3,
    county_fips: 47107,
    county_name: "McMinn",
    county_weights: {
      47107: 88.75,
      47139: 11.25,
    },
    county_names_all: "McMinn|Polk",
    county_fips_all: "47107|47139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37310,
    lat: 35.26237,
    lng: -84.77767,
    city: "Charleston",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3786,
    density: 34.2,
    county_fips: 47011,
    county_name: "Bradley",
    county_weights: {
      47011: 89.42,
      47139: 10.58,
    },
    county_names_all: "Bradley|Polk",
    county_fips_all: "47011|47139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37311,
    lat: 35.10054,
    lng: -84.92298,
    city: "Cleveland",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29139,
    density: 224.6,
    county_fips: 47011,
    county_name: "Bradley",
    county_weights: {
      47011: 97.9,
      47065: 2.1,
    },
    county_names_all: "Bradley|Hamilton",
    county_fips_all: "47011|47065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37312,
    lat: 35.2286,
    lng: -84.87344,
    city: "Cleveland",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35877,
    density: 215,
    county_fips: 47011,
    county_name: "Bradley",
    county_weights: {
      47011: 100,
    },
    county_names_all: "Bradley",
    county_fips_all: 47011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37313,
    lat: 35.37703,
    lng: -85.70245,
    city: "Coalmont",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1558,
    density: 29.7,
    county_fips: 47061,
    county_name: "Grundy",
    county_weights: {
      47061: 100,
    },
    county_names_all: "Grundy",
    county_fips_all: 47061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37315,
    lat: 35.04722,
    lng: -85.05158,
    city: "Collegedale",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1640,
    density: 4996.9,
    county_fips: 47065,
    county_name: "Hamilton",
    county_weights: {
      47065: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 47065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37316,
    lat: 35.00161,
    lng: -84.72975,
    city: "Conasauga",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 47139,
    county_name: "Polk",
    county_weights: {
      47139: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 47139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37317,
    lat: 35.03079,
    lng: -84.44341,
    city: "Copperhill",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2936,
    density: 15.1,
    county_fips: 47139,
    county_name: "Polk",
    county_weights: {
      47139: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 47139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37318,
    lat: 35.17879,
    lng: -85.97994,
    city: "Cowan",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1720,
    density: 53.5,
    county_fips: 47051,
    county_name: "Franklin",
    county_weights: {
      47051: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 47051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37321,
    lat: 35.50239,
    lng: -85.00801,
    city: "Dayton",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20191,
    density: 68.4,
    county_fips: 47143,
    county_name: "Rhea",
    county_weights: {
      47007: 4.64,
      47143: 95.36,
    },
    county_names_all: "Rhea|Bledsoe",
    county_fips_all: "47143|47007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37322,
    lat: 35.49562,
    lng: -84.81512,
    city: "Decatur",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8270,
    density: 23.7,
    county_fips: 47121,
    county_name: "Meigs",
    county_weights: {
      47107: 7.97,
      47121: 92.03,
    },
    county_names_all: "Meigs|McMinn",
    county_fips_all: "47121|47107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37323,
    lat: 35.09627,
    lng: -84.81984,
    city: "Cleveland",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31202,
    density: 105.1,
    county_fips: 47011,
    county_name: "Bradley",
    county_weights: {
      47011: 99.66,
      47139: 0.34,
    },
    county_names_all: "Bradley|Polk",
    county_fips_all: "47011|47139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37324,
    lat: 35.25251,
    lng: -86.00044,
    city: "Decherd",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5551,
    density: 32.2,
    county_fips: 47051,
    county_name: "Franklin",
    county_weights: {
      47051: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 47051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37325,
    lat: 35.24726,
    lng: -84.61108,
    city: "Delano",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1646,
    density: 29.4,
    county_fips: 47139,
    county_name: "Polk",
    county_weights: {
      47107: 12.08,
      47139: 87.92,
    },
    county_names_all: "Polk|McMinn",
    county_fips_all: "47139|47107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37326,
    lat: 35.04023,
    lng: -84.38329,
    city: "Ducktown",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 547,
    density: 119.1,
    county_fips: 47139,
    county_name: "Polk",
    county_weights: {
      47139: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 47139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37327,
    lat: 35.42251,
    lng: -85.39993,
    city: "Dunlap",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11569,
    density: 23.3,
    county_fips: 47153,
    county_name: "Sequatchie",
    county_weights: {
      47007: 16.21,
      47153: 82.17,
      47175: 1.62,
    },
    county_names_all: "Sequatchie|Bledsoe|Van Buren",
    county_fips_all: "47153|47007|47175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37328,
    lat: 35.02825,
    lng: -86.36876,
    city: "Elora",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1408,
    density: 17,
    county_fips: 47103,
    county_name: "Lincoln",
    county_weights: {
      47051: 4.82,
      47103: 95.18,
    },
    county_names_all: "Lincoln|Franklin",
    county_fips_all: "47103|47051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37329,
    lat: 35.39201,
    lng: -84.46017,
    city: "Englewood",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5877,
    density: 38.3,
    county_fips: 47107,
    county_name: "McMinn",
    county_weights: {
      47107: 84.47,
      47123: 15.53,
    },
    county_names_all: "McMinn|Monroe",
    county_fips_all: "47107|47123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37330,
    lat: 35.28411,
    lng: -86.12967,
    city: "Estill Springs",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6639,
    density: 66,
    county_fips: 47051,
    county_name: "Franklin",
    county_weights: {
      47031: 7.15,
      47051: 92.85,
    },
    county_names_all: "Franklin|Coffee",
    county_fips_all: "47051|47031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37331,
    lat: 35.31662,
    lng: -84.5336,
    city: "Etowah",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6849,
    density: 67.2,
    county_fips: 47107,
    county_name: "McMinn",
    county_weights: {
      47107: 100,
    },
    county_names_all: "McMinn",
    county_fips_all: 47107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37332,
    lat: 35.59418,
    lng: -84.96277,
    city: "Evensville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2497,
    density: 14.1,
    county_fips: 47143,
    county_name: "Rhea",
    county_weights: {
      47007: 5.82,
      47143: 94.18,
    },
    county_names_all: "Rhea|Bledsoe",
    county_fips_all: "47143|47007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37333,
    lat: 35.14844,
    lng: -84.35981,
    city: "Farner",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 474,
    density: 9.1,
    county_fips: 47139,
    county_name: "Polk",
    county_weights: {
      47139: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 47139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37334,
    lat: 35.16532,
    lng: -86.57966,
    city: "Fayetteville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23398,
    density: 35.5,
    county_fips: 47103,
    county_name: "Lincoln",
    county_weights: {
      47003: 0.37,
      47103: 93.11,
      47127: 6.52,
    },
    county_names_all: "Lincoln|Moore|Bedford",
    county_fips_all: "47103|47127|47003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37335,
    lat: 35.06584,
    lng: -86.40548,
    city: "Flintville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2626,
    density: 22.9,
    county_fips: 47103,
    county_name: "Lincoln",
    county_weights: {
      47051: 2.78,
      47103: 97.22,
    },
    county_names_all: "Lincoln|Franklin",
    county_fips_all: "47103|47051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37336,
    lat: 35.30117,
    lng: -84.93413,
    city: "Georgetown",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4726,
    density: 41.7,
    county_fips: 47121,
    county_name: "Meigs",
    county_weights: {
      47011: 30.69,
      47065: 33.35,
      47121: 35.96,
    },
    county_names_all: "Meigs|Hamilton|Bradley",
    county_fips_all: "47121|47065|47011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37337,
    lat: 35.78594,
    lng: -84.86651,
    city: "Grandview",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1330,
    density: 8.5,
    county_fips: 47143,
    county_name: "Rhea",
    county_weights: {
      47007: 5.91,
      47035: 43.85,
      47143: 50.24,
    },
    county_names_all: "Rhea|Cumberland|Bledsoe",
    county_fips_all: "47143|47035|47007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37338,
    lat: 35.42356,
    lng: -85.20942,
    city: "Graysville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2983,
    density: 15.9,
    county_fips: 47007,
    county_name: "Bledsoe",
    county_weights: {
      47007: 58.52,
      47065: 16.01,
      47143: 5.1,
      47153: 20.37,
    },
    county_names_all: "Bledsoe|Sequatchie|Hamilton|Rhea",
    county_fips_all: "47007|47153|47065|47143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37339,
    lat: 35.37386,
    lng: -85.63222,
    city: "Gruetli Laager",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2110,
    density: 20.7,
    county_fips: 47061,
    county_name: "Grundy",
    county_weights: {
      47061: 100,
    },
    county_names_all: "Grundy",
    county_fips_all: 47061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37340,
    lat: 35.02085,
    lng: -85.53179,
    city: "Guild",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 480,
    density: 21.9,
    county_fips: 47115,
    county_name: "Marion",
    county_weights: {
      47115: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 47115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37341,
    lat: 35.21386,
    lng: -85.0834,
    city: "Harrison",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12010,
    density: 137.4,
    county_fips: 47065,
    county_name: "Hamilton",
    county_weights: {
      47065: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 47065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37342,
    lat: 35.38175,
    lng: -85.94937,
    city: "Hillsboro",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4286,
    density: 24.2,
    county_fips: 47031,
    county_name: "Coffee",
    county_weights: {
      47031: 100,
    },
    county_names_all: "Coffee",
    county_fips_all: 47031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37343,
    lat: 35.16904,
    lng: -85.20899,
    city: "Hixson",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42120,
    density: 386.3,
    county_fips: 47065,
    county_name: "Hamilton",
    county_weights: {
      47065: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 47065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37345,
    lat: 35.0366,
    lng: -86.24299,
    city: "Huntland",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2715,
    density: 18.6,
    county_fips: 47051,
    county_name: "Franklin",
    county_weights: {
      47051: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 47051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37347,
    lat: 35.06088,
    lng: -85.61894,
    city: "Jasper",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8135,
    density: 64.2,
    county_fips: 47115,
    county_name: "Marion",
    county_weights: {
      47115: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 47115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37348,
    lat: 35.11935,
    lng: -86.44222,
    city: "Kelso",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 785,
    density: 10.1,
    county_fips: 47103,
    county_name: "Lincoln",
    county_weights: {
      47103: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 47103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37350,
    lat: 34.99445,
    lng: -85.3516,
    city: "Lookout Mountain",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2013,
    density: 578.7,
    county_fips: 47065,
    county_name: "Hamilton",
    county_weights: {
      47065: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 47065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37351,
    lat: 35.10073,
    lng: -85.26135,
    city: "Lupton City",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 318,
    density: 281.6,
    county_fips: 47065,
    county_name: "Hamilton",
    county_weights: {
      47065: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 47065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37352,
    lat: 35.27981,
    lng: -86.35417,
    city: "Lynchburg",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3440,
    density: 26.6,
    county_fips: 47127,
    county_name: "Moore",
    county_weights: {
      47051: 0.83,
      47127: 99.17,
    },
    county_names_all: "Moore|Franklin",
    county_fips_all: "47127|47051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37353,
    lat: 35.12288,
    lng: -84.9855,
    city: "McDonald",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4921,
    density: 47,
    county_fips: 47011,
    county_name: "Bradley",
    county_weights: {
      47011: 87.25,
      47065: 12.75,
    },
    county_names_all: "Bradley|Hamilton",
    county_fips_all: "47011|47065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37354,
    lat: 35.50195,
    lng: -84.34387,
    city: "Madisonville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17029,
    density: 55.9,
    county_fips: 47123,
    county_name: "Monroe",
    county_weights: {
      47107: 2.98,
      47123: 97.02,
    },
    county_names_all: "Monroe|McMinn",
    county_fips_all: "47123|47107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37355,
    lat: 35.50843,
    lng: -86.07866,
    city: "Manchester",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27203,
    density: 50.7,
    county_fips: 47031,
    county_name: "Coffee",
    county_weights: {
      47031: 100,
    },
    county_names_all: "Coffee",
    county_fips_all: 47031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37356,
    lat: 35.22952,
    lng: -85.82393,
    city: "Monteagle",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2680,
    density: 42.1,
    county_fips: 47115,
    county_name: "Marion",
    county_weights: {
      47051: 1.31,
      47061: 42.88,
      47115: 55.81,
    },
    county_names_all: "Marion|Grundy|Franklin",
    county_fips_all: "47115|47061|47051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37357,
    lat: 35.59454,
    lng: -85.92003,
    city: "Morrison",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5633,
    density: 16.1,
    county_fips: 47177,
    county_name: "Warren",
    county_weights: {
      47015: 6.68,
      47031: 28.61,
      47061: 10.41,
      47177: 54.3,
    },
    county_names_all: "Warren|Coffee|Grundy|Cannon",
    county_fips_all: "47177|47031|47061|47015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37359,
    lat: 35.19776,
    lng: -86.4119,
    city: "Mulberry",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1033,
    density: 10.3,
    county_fips: 47103,
    county_name: "Lincoln",
    county_weights: {
      47103: 80.52,
      47127: 19.48,
    },
    county_names_all: "Lincoln|Moore",
    county_fips_all: "47103|47127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37360,
    lat: 35.44702,
    lng: -86.25586,
    city: "Normandy",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2042,
    density: 28.5,
    county_fips: 47003,
    county_name: "Bedford",
    county_weights: {
      47003: 58.78,
      47031: 37.05,
      47127: 4.17,
    },
    county_names_all: "Bedford|Coffee|Moore",
    county_fips_all: "47003|47031|47127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37361,
    lat: 35.08543,
    lng: -84.6551,
    city: "Ocoee",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1763,
    density: 23.9,
    county_fips: 47139,
    county_name: "Polk",
    county_weights: {
      47139: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 47139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37362,
    lat: 35.03152,
    lng: -84.70028,
    city: "Old Fort",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3178,
    density: 18.4,
    county_fips: 47139,
    county_name: "Polk",
    county_weights: {
      47011: 20.74,
      47139: 79.26,
    },
    county_names_all: "Polk|Bradley",
    county_fips_all: "47139|47011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37363,
    lat: 35.11551,
    lng: -85.0549,
    city: "Ooltewah",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41503,
    density: 266.5,
    county_fips: 47065,
    county_name: "Hamilton",
    county_weights: {
      47065: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 47065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37365,
    lat: 35.37287,
    lng: -85.54013,
    city: "Palmer",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1263,
    density: 8.6,
    county_fips: 47061,
    county_name: "Grundy",
    county_weights: {
      47061: 70.61,
      47153: 29.39,
    },
    county_names_all: "Grundy|Sequatchie",
    county_fips_all: "47061|47153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37366,
    lat: 35.32054,
    lng: -85.84224,
    city: "Pelham",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 991,
    density: 7.3,
    county_fips: 47061,
    county_name: "Grundy",
    county_weights: {
      47051: 0.46,
      47061: 99.54,
    },
    county_names_all: "Grundy|Franklin",
    county_fips_all: "47061|47051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37367,
    lat: 35.62959,
    lng: -85.21832,
    city: "Pikeville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12045,
    density: 15.7,
    county_fips: 47007,
    county_name: "Bledsoe",
    county_weights: {
      47007: 91.77,
      47035: 4.41,
      47175: 3.82,
    },
    county_names_all: "Bledsoe|Cumberland|Van Buren",
    county_fips_all: "47007|47035|47175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37369,
    lat: 35.19908,
    lng: -84.47707,
    city: "Reliance",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 693,
    density: 2.5,
    county_fips: 47139,
    county_name: "Polk",
    county_weights: {
      47123: 9.53,
      47139: 90.47,
    },
    county_names_all: "Polk|Monroe",
    county_fips_all: "47139|47123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37370,
    lat: 35.35903,
    lng: -84.70064,
    city: "Riceville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4965,
    density: 31,
    county_fips: 47107,
    county_name: "McMinn",
    county_weights: {
      47107: 100,
    },
    county_names_all: "McMinn",
    county_fips_all: 47107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37373,
    lat: 35.39476,
    lng: -85.10373,
    city: "Sale Creek",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3107,
    density: 29.6,
    county_fips: 47065,
    county_name: "Hamilton",
    county_weights: {
      47065: 99.61,
      47143: 0.39,
    },
    county_names_all: "Hamilton|Rhea",
    county_fips_all: "47065|47143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37374,
    lat: 35.16404,
    lng: -85.65818,
    city: "Sequatchie",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1886,
    density: 12.6,
    county_fips: 47115,
    county_name: "Marion",
    county_weights: {
      47115: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 47115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37375,
    lat: 35.15355,
    lng: -85.88173,
    city: "Sewanee",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4026,
    density: 22.7,
    county_fips: 47051,
    county_name: "Franklin",
    county_weights: {
      47051: 67.71,
      47115: 32.29,
    },
    county_names_all: "Franklin|Marion",
    county_fips_all: "47051|47115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37376,
    lat: 35.04748,
    lng: -85.95834,
    city: "Sherwood",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 439,
    density: 2.1,
    county_fips: 47051,
    county_name: "Franklin",
    county_weights: {
      47051: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 47051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37377,
    lat: 35.21243,
    lng: -85.3389,
    city: "Signal Mountain",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15496,
    density: 74.4,
    county_fips: 47065,
    county_name: "Hamilton",
    county_weights: {
      47065: 50.17,
      47115: 3.59,
      47153: 46.24,
    },
    county_names_all: "Hamilton|Sequatchie|Marion",
    county_fips_all: "47065|47153|47115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37379,
    lat: 35.29407,
    lng: -85.17429,
    city: "Soddy Daisy",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28115,
    density: 102,
    county_fips: 47065,
    county_name: "Hamilton",
    county_weights: {
      47007: 5.32,
      47065: 88.6,
      47153: 6.08,
    },
    county_names_all: "Hamilton|Sequatchie|Bledsoe",
    county_fips_all: "47065|47153|47007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37380,
    lat: 35.07265,
    lng: -85.75754,
    city: "South Pittsburg",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6505,
    density: 19.9,
    county_fips: 47115,
    county_name: "Marion",
    county_weights: {
      47051: 1.84,
      47115: 98.16,
    },
    county_names_all: "Marion|Franklin",
    county_fips_all: "47115|47051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37381,
    lat: 35.68533,
    lng: -84.8775,
    city: "Spring City",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9574,
    density: 27.1,
    county_fips: 47143,
    county_name: "Rhea",
    county_weights: {
      47007: 18.41,
      47143: 81.59,
    },
    county_names_all: "Rhea|Bledsoe",
    county_fips_all: "47143|47007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37383,
    lat: 35.20984,
    lng: -85.91373,
    city: "Sewanee",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 47051,
    county_name: "Franklin",
    county_weights: {
      47051: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 47051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37385,
    lat: 35.33494,
    lng: -84.22933,
    city: "Tellico Plains",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9292,
    density: 13.4,
    county_fips: 47123,
    county_name: "Monroe",
    county_weights: {
      47123: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 47123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37387,
    lat: 35.27745,
    lng: -85.71427,
    city: "Tracy City",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3358,
    density: 17.5,
    county_fips: 47061,
    county_name: "Grundy",
    county_weights: {
      47061: 68.72,
      47115: 31.28,
    },
    county_names_all: "Grundy|Marion",
    county_fips_all: "47061|47115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37388,
    lat: 35.35141,
    lng: -86.19747,
    city: "Tullahoma",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25462,
    density: 83.4,
    county_fips: 47031,
    county_name: "Coffee",
    county_weights: {
      47003: 3.34,
      47031: 43.01,
      47051: 33.92,
      47127: 19.73,
    },
    county_names_all: "Coffee|Franklin|Moore|Bedford",
    county_fips_all: "47031|47051|47127|47003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37391,
    lat: 35.09049,
    lng: -84.35327,
    city: "Turtletown",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1474,
    density: 22.2,
    county_fips: 47139,
    county_name: "Polk",
    county_weights: {
      47139: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 47139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37394,
    lat: 35.53918,
    lng: -85.86047,
    city: "Viola",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 120,
    density: 323.1,
    county_fips: 47177,
    county_name: "Warren",
    county_weights: {
      47177: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 47177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37396,
    lat: 35.00198,
    lng: -85.50353,
    city: "Whiteside",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 221,
    density: 17.2,
    county_fips: 47115,
    county_name: "Marion",
    county_weights: {
      47115: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 47115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37397,
    lat: 35.21046,
    lng: -85.51819,
    city: "Whitwell",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10101,
    density: 26.1,
    county_fips: 47115,
    county_name: "Marion",
    county_weights: {
      47115: 84.65,
      47153: 15.35,
    },
    county_names_all: "Marion|Sequatchie",
    county_fips_all: "47115|47153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37398,
    lat: 35.18182,
    lng: -86.13808,
    city: "Winchester",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15020,
    density: 53,
    county_fips: 47051,
    county_name: "Franklin",
    county_weights: {
      47051: 94.38,
      47127: 5.62,
    },
    county_names_all: "Franklin|Moore",
    county_fips_all: "47051|47127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37402,
    lat: 35.04672,
    lng: -85.31553,
    city: "Chattanooga",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4100,
    density: 1231.2,
    county_fips: 47065,
    county_name: "Hamilton",
    county_weights: {
      47065: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 47065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37403,
    lat: 35.0476,
    lng: -85.29448,
    city: "Chattanooga",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7484,
    density: 1694.7,
    county_fips: 47065,
    county_name: "Hamilton",
    county_weights: {
      47065: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 47065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37404,
    lat: 35.02827,
    lng: -85.27331,
    city: "Chattanooga",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12168,
    density: 906.7,
    county_fips: 47065,
    county_name: "Hamilton",
    county_weights: {
      47065: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 47065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37405,
    lat: 35.11757,
    lng: -85.40429,
    city: "Chattanooga",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18231,
    density: 129.6,
    county_fips: 47115,
    county_name: "Marion",
    county_weights: {
      47065: 26.75,
      47115: 73.25,
    },
    county_names_all: "Marion|Hamilton",
    county_fips_all: "47115|47065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37406,
    lat: 35.07246,
    lng: -85.24541,
    city: "Chattanooga",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14259,
    density: 453.7,
    county_fips: 47065,
    county_name: "Hamilton",
    county_weights: {
      47065: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 47065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37407,
    lat: 35.002,
    lng: -85.28941,
    city: "Chattanooga",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11126,
    density: 1263.6,
    county_fips: 47065,
    county_name: "Hamilton",
    county_weights: {
      47065: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 47065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37408,
    lat: 35.03048,
    lng: -85.31237,
    city: "Chattanooga",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2033,
    density: 369.4,
    county_fips: 47065,
    county_name: "Hamilton",
    county_weights: {
      47065: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 47065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37409,
    lat: 35.0012,
    lng: -85.34466,
    city: "Chattanooga",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3399,
    density: 297.1,
    county_fips: 47065,
    county_name: "Hamilton",
    county_weights: {
      47065: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 47065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37410,
    lat: 35.002,
    lng: -85.31366,
    city: "Chattanooga",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3709,
    density: 473.6,
    county_fips: 47065,
    county_name: "Hamilton",
    county_weights: {
      47065: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 47065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37411,
    lat: 35.02655,
    lng: -85.23026,
    city: "Chattanooga",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16801,
    density: 883.8,
    county_fips: 47065,
    county_name: "Hamilton",
    county_weights: {
      47065: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 47065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37412,
    lat: 34.9974,
    lng: -85.22726,
    city: "Chattanooga",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21220,
    density: 946.2,
    county_fips: 47065,
    county_name: "Hamilton",
    county_weights: {
      47065: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 47065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37415,
    lat: 35.12735,
    lng: -85.27932,
    city: "Chattanooga",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23693,
    density: 522.2,
    county_fips: 47065,
    county_name: "Hamilton",
    county_weights: {
      47065: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 47065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37416,
    lat: 35.09856,
    lng: -85.15751,
    city: "Chattanooga",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15307,
    density: 287.7,
    county_fips: 47065,
    county_name: "Hamilton",
    county_weights: {
      47065: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 47065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37419,
    lat: 35.04052,
    lng: -85.41734,
    city: "Chattanooga",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6557,
    density: 51.7,
    county_fips: 47115,
    county_name: "Marion",
    county_weights: {
      47065: 46.11,
      47115: 53.89,
    },
    county_names_all: "Marion|Hamilton",
    county_fips_all: "47115|47065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37421,
    lat: 35.02915,
    lng: -85.153,
    city: "Chattanooga",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53050,
    density: 646.1,
    county_fips: 47065,
    county_name: "Hamilton",
    county_weights: {
      47065: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 47065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37450,
    lat: 35.04897,
    lng: -85.31217,
    city: "Chattanooga",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 47065,
    county_name: "Hamilton",
    county_weights: {
      47065: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 47065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37601,
    lat: 36.32838,
    lng: -82.31974,
    city: "Johnson City",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35963,
    density: 291,
    county_fips: 47179,
    county_name: "Washington",
    county_weights: {
      47019: 44.06,
      47171: 2.49,
      47179: 53.45,
    },
    county_names_all: "Washington|Carter|Unicoi",
    county_fips_all: "47179|47019|47171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37604,
    lat: 36.29923,
    lng: -82.38302,
    city: "Johnson City",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36203,
    density: 423.3,
    county_fips: 47179,
    county_name: "Washington",
    county_weights: {
      47019: 5.65,
      47179: 94.35,
    },
    county_names_all: "Washington|Carter",
    county_fips_all: "47179|47019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37614,
    lat: 36.30097,
    lng: -82.36741,
    city: "Johnson City",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1909,
    density: 1494,
    county_fips: 47179,
    county_name: "Washington",
    county_weights: {
      47179: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 47179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37615,
    lat: 36.39771,
    lng: -82.45246,
    city: "Johnson City",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22064,
    density: 226.6,
    county_fips: 47179,
    county_name: "Washington",
    county_weights: {
      47179: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 47179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37616,
    lat: 36.22619,
    lng: -82.7498,
    city: "Afton",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5101,
    density: 44.4,
    county_fips: 47059,
    county_name: "Greene",
    county_weights: {
      47059: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 47059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37617,
    lat: 36.53155,
    lng: -82.37248,
    city: "Blountville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14596,
    density: 96.5,
    county_fips: 47163,
    county_name: "Sullivan",
    county_weights: {
      47163: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 47163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37618,
    lat: 36.46555,
    lng: -82.20833,
    city: "Bluff City",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13592,
    density: 75.7,
    county_fips: 47163,
    county_name: "Sullivan",
    county_weights: {
      47163: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 47163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37620,
    lat: 36.55124,
    lng: -82.09867,
    city: "Bristol",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37760,
    density: 113.7,
    county_fips: 47163,
    county_name: "Sullivan",
    county_weights: {
      47163: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 47163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37640,
    lat: 36.33023,
    lng: -81.9773,
    city: "Butler",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3494,
    density: 12.8,
    county_fips: 47091,
    county_name: "Johnson",
    county_weights: {
      47019: 36.97,
      47091: 63.03,
    },
    county_names_all: "Johnson|Carter",
    county_fips_all: "47091|47019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37641,
    lat: 36.20015,
    lng: -82.66306,
    city: "Chuckey",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9491,
    density: 39.1,
    county_fips: 47059,
    county_name: "Greene",
    county_weights: {
      47059: 82.37,
      47179: 17.63,
    },
    county_names_all: "Greene|Washington",
    county_fips_all: "47059|47179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37642,
    lat: 36.53261,
    lng: -82.7267,
    city: "Church Hill",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14658,
    density: 100.7,
    county_fips: 47073,
    county_name: "Hawkins",
    county_weights: {
      47073: 99.53,
      51169: 0.47,
    },
    county_names_all: "Hawkins|Scott",
    county_fips_all: "47073|51169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37643,
    lat: 36.37513,
    lng: -82.13729,
    city: "Elizabethton",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33413,
    density: 98.4,
    county_fips: 47019,
    county_name: "Carter",
    county_weights: {
      47019: 98.8,
      47171: 1.2,
    },
    county_names_all: "Carter|Unicoi",
    county_fips_all: "47019|47171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37645,
    lat: 36.56275,
    lng: -82.66243,
    city: "Mount Carmel",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5080,
    density: 313.8,
    county_fips: 47073,
    county_name: "Hawkins",
    county_weights: {
      47073: 100,
    },
    county_names_all: "Hawkins",
    county_fips_all: 47073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37650,
    lat: 36.10416,
    lng: -82.45938,
    city: "Erwin",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12960,
    density: 51.6,
    county_fips: 47171,
    county_name: "Unicoi",
    county_weights: {
      47171: 96.06,
      47179: 3.94,
    },
    county_names_all: "Unicoi|Washington",
    county_fips_all: "47171|47179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37656,
    lat: 36.39997,
    lng: -82.63075,
    city: "Fall Branch",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3423,
    density: 45.4,
    county_fips: 47179,
    county_name: "Washington",
    county_weights: {
      47059: 28.82,
      47163: 8.3,
      47179: 62.88,
    },
    county_names_all: "Washington|Greene|Sullivan",
    county_fips_all: "47179|47059|47163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37657,
    lat: 36.01725,
    lng: -82.56057,
    city: "Flag Pond",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 955,
    density: 10,
    county_fips: 47171,
    county_name: "Unicoi",
    county_weights: {
      47171: 100,
    },
    county_names_all: "Unicoi",
    county_fips_all: 47171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37658,
    lat: 36.26352,
    lng: -82.1535,
    city: "Hampton",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4027,
    density: 34.6,
    county_fips: 47019,
    county_name: "Carter",
    county_weights: {
      47019: 99.75,
      47171: 0.25,
    },
    county_names_all: "Carter|Unicoi",
    county_fips_all: "47019|47171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37659,
    lat: 36.28074,
    lng: -82.4938,
    city: "Jonesborough",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27813,
    density: 84.6,
    county_fips: 47179,
    county_name: "Washington",
    county_weights: {
      47163: 0.69,
      47179: 99.31,
    },
    county_names_all: "Washington|Sullivan",
    county_fips_all: "47179|47163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37660,
    lat: 36.52938,
    lng: -82.57339,
    city: "Kingsport",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39638,
    density: 232.9,
    county_fips: 47163,
    county_name: "Sullivan",
    county_weights: {
      47073: 9.46,
      47163: 90.54,
    },
    county_names_all: "Sullivan|Hawkins",
    county_fips_all: "47163|47073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37663,
    lat: 36.46466,
    lng: -82.48525,
    city: "Kingsport",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13672,
    density: 205,
    county_fips: 47163,
    county_name: "Sullivan",
    county_weights: {
      47163: 95.26,
      47179: 4.74,
    },
    county_names_all: "Sullivan|Washington",
    county_fips_all: "47163|47179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37664,
    lat: 36.51163,
    lng: -82.50729,
    city: "Kingsport",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28040,
    density: 319.1,
    county_fips: 47163,
    county_name: "Sullivan",
    county_weights: {
      47163: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 47163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37665,
    lat: 36.57951,
    lng: -82.57304,
    city: "Kingsport",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5202,
    density: 663.5,
    county_fips: 47163,
    county_name: "Sullivan",
    county_weights: {
      47163: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 47163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37680,
    lat: 36.57462,
    lng: -81.72556,
    city: "Laurel Bloomery",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 485,
    density: 6.4,
    county_fips: 47091,
    county_name: "Johnson",
    county_weights: {
      47091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 47091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37681,
    lat: 36.25465,
    lng: -82.62672,
    city: "Limestone",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6446,
    density: 38.2,
    county_fips: 47179,
    county_name: "Washington",
    county_weights: {
      47059: 37.24,
      47179: 62.76,
    },
    county_names_all: "Washington|Greene",
    county_fips_all: "47179|47059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37682,
    lat: 36.30035,
    lng: -82.29169,
    city: "Milligan College",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 577,
    density: 2185,
    county_fips: 47019,
    county_name: "Carter",
    county_weights: {
      47019: 100,
    },
    county_names_all: "Carter",
    county_fips_all: 47019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37683,
    lat: 36.45303,
    lng: -81.82233,
    city: "Mountain City",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13496,
    density: 38.9,
    county_fips: 47091,
    county_name: "Johnson",
    county_weights: {
      47091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 47091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37686,
    lat: 36.44175,
    lng: -82.34639,
    city: "Piney Flats",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8470,
    density: 111,
    county_fips: 47163,
    county_name: "Sullivan",
    county_weights: {
      47163: 99.61,
      47179: 0.39,
    },
    county_names_all: "Sullivan|Washington",
    county_fips_all: "47163|47179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37687,
    lat: 36.18667,
    lng: -82.09667,
    city: "Roan Mountain",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4428,
    density: 17.9,
    county_fips: 47019,
    county_name: "Carter",
    county_weights: {
      47019: 100,
    },
    county_names_all: "Carter",
    county_fips_all: 47019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37688,
    lat: 36.54548,
    lng: -81.88281,
    city: "Shady Valley",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1012,
    density: 7.2,
    county_fips: 47091,
    county_name: "Johnson",
    county_weights: {
      47091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 47091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37690,
    lat: 36.25124,
    lng: -82.55895,
    city: "Telford",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4599,
    density: 70.3,
    county_fips: 47179,
    county_name: "Washington",
    county_weights: {
      47179: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 47179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37691,
    lat: 36.36792,
    lng: -81.75519,
    city: "Trade",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 583,
    density: 15.7,
    county_fips: 47091,
    county_name: "Johnson",
    county_weights: {
      47091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 47091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37692,
    lat: 36.18456,
    lng: -82.30413,
    city: "Unicoi",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4780,
    density: 34.8,
    county_fips: 47171,
    county_name: "Unicoi",
    county_weights: {
      47171: 100,
    },
    county_names_all: "Unicoi",
    county_fips_all: 47171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37694,
    lat: 36.3849,
    lng: -82.27588,
    city: "Watauga",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2264,
    density: 69.2,
    county_fips: 47019,
    county_name: "Carter",
    county_weights: {
      47019: 79.42,
      47163: 17.62,
      47179: 2.96,
    },
    county_names_all: "Carter|Sullivan|Washington",
    county_fips_all: "47019|47163|47179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37701,
    lat: 35.79393,
    lng: -83.98461,
    city: "Alcoa",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7509,
    density: 269.9,
    county_fips: 47009,
    county_name: "Blount",
    county_weights: {
      47009: 100,
    },
    county_names_all: "Blount",
    county_fips_all: 47009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37705,
    lat: 36.22862,
    lng: -84.00947,
    city: "Andersonville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4388,
    density: 38,
    county_fips: 47001,
    county_name: "Anderson",
    county_weights: {
      47001: 67.48,
      47173: 32.52,
    },
    county_names_all: "Anderson|Union",
    county_fips_all: "47001|47173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37708,
    lat: 36.32312,
    lng: -83.33588,
    city: "Bean Station",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6078,
    density: 56.8,
    county_fips: 47057,
    county_name: "Grainger",
    county_weights: {
      47057: 100,
    },
    county_names_all: "Grainger",
    county_fips_all: 47057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37709,
    lat: 36.16798,
    lng: -83.66479,
    city: "Blaine",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3876,
    density: 36.1,
    county_fips: 47057,
    county_name: "Grainger",
    county_weights: {
      47057: 98.65,
      47093: 1.35,
    },
    county_names_all: "Grainger|Knox",
    county_fips_all: "47057|47093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37710,
    lat: 36.15802,
    lng: -84.3177,
    city: "Briceville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1161,
    density: 5.6,
    county_fips: 47001,
    county_name: "Anderson",
    county_weights: {
      47001: 100,
    },
    county_names_all: "Anderson",
    county_fips_all: 47001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37711,
    lat: 36.28102,
    lng: -83.03885,
    city: "Bulls Gap",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5496,
    density: 40.7,
    county_fips: 47073,
    county_name: "Hawkins",
    county_weights: {
      47059: 41.08,
      47063: 3.79,
      47073: 55.13,
    },
    county_names_all: "Hawkins|Greene|Hamblen",
    county_fips_all: "47073|47059|47063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37713,
    lat: 36.09073,
    lng: -83.13373,
    city: "Bybee",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1364,
    density: 17.6,
    county_fips: 47029,
    county_name: "Cocke",
    county_weights: {
      47029: 100,
    },
    county_names_all: "Cocke",
    county_fips_all: 47029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37714,
    lat: 36.26656,
    lng: -84.25277,
    city: "Caryville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4485,
    density: 26.9,
    county_fips: 47013,
    county_name: "Campbell",
    county_weights: {
      47013: 100,
    },
    county_names_all: "Campbell",
    county_fips_all: 47013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37715,
    lat: 36.55323,
    lng: -83.95894,
    city: "Clairfield",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 838,
    density: 12.6,
    county_fips: 47025,
    county_name: "Claiborne",
    county_weights: {
      47013: 26.78,
      47025: 73.22,
    },
    county_names_all: "Claiborne|Campbell",
    county_fips_all: "47025|47013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37716,
    lat: 36.09919,
    lng: -84.16822,
    city: "Clinton",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27768,
    density: 128.5,
    county_fips: 47001,
    county_name: "Anderson",
    county_weights: {
      47001: 100,
    },
    county_names_all: "Anderson",
    county_fips_all: 47001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37719,
    lat: 36.02196,
    lng: -84.42815,
    city: "Coalfield",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 330,
    density: 194.9,
    county_fips: 47129,
    county_name: "Morgan",
    county_weights: {
      47129: 100,
    },
    county_names_all: "Morgan",
    county_fips_all: 47129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37721,
    lat: 36.13155,
    lng: -83.80829,
    city: "Corryton",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14024,
    density: 109.9,
    county_fips: 47093,
    county_name: "Knox",
    county_weights: {
      47093: 90.08,
      47173: 9.92,
    },
    county_names_all: "Knox|Union",
    county_fips_all: "47093|47173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37722,
    lat: 35.80611,
    lng: -83.23339,
    city: "Cosby",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6759,
    density: 29.1,
    county_fips: 47029,
    county_name: "Cocke",
    county_weights: {
      47029: 85.67,
      47155: 14.33,
    },
    county_names_all: "Cocke|Sevier",
    county_fips_all: "47029|47155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37723,
    lat: 35.96044,
    lng: -84.82171,
    city: "Crab Orchard",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1038,
    density: 7.1,
    county_fips: 47035,
    county_name: "Cumberland",
    county_weights: {
      47035: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 47035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37724,
    lat: 36.54457,
    lng: -83.69328,
    city: "Cumberland Gap",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2378,
    density: 42.6,
    county_fips: 47025,
    county_name: "Claiborne",
    county_weights: {
      47025: 100,
    },
    county_names_all: "Claiborne",
    county_fips_all: 47025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37725,
    lat: 35.99778,
    lng: -83.39678,
    city: "Dandridge",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18514,
    density: 76.5,
    county_fips: 47089,
    county_name: "Jefferson",
    county_weights: {
      47089: 98.92,
      47155: 1.08,
    },
    county_names_all: "Jefferson|Sevier",
    county_fips_all: "47089|47155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37726,
    lat: 36.20464,
    lng: -84.8386,
    city: "Deer Lodge",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1792,
    density: 7.6,
    county_fips: 47129,
    county_name: "Morgan",
    county_weights: {
      47049: 12.42,
      47129: 87.58,
    },
    county_names_all: "Morgan|Fentress",
    county_fips_all: "47129|47049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37727,
    lat: 35.88885,
    lng: -83.00651,
    city: "Del Rio",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2450,
    density: 8.5,
    county_fips: 47029,
    county_name: "Cocke",
    county_weights: {
      47029: 100,
    },
    county_names_all: "Cocke",
    county_fips_all: 47029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37729,
    lat: 36.51412,
    lng: -84.03276,
    city: "Duff",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1937,
    density: 15.2,
    county_fips: 47013,
    county_name: "Campbell",
    county_weights: {
      47013: 100,
    },
    county_names_all: "Campbell",
    county_fips_all: 47013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37730,
    lat: 36.56837,
    lng: -83.97357,
    city: "Eagan",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 47025,
    county_name: "Claiborne",
    county_weights: {
      47013: 0.42,
      47025: 99.58,
    },
    county_names_all: "Claiborne|Campbell",
    county_fips_all: "47025|47013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37731,
    lat: 36.54383,
    lng: -83.00873,
    city: "Eidson",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 433,
    density: 3.4,
    county_fips: 47073,
    county_name: "Hawkins",
    county_weights: {
      47067: 49.89,
      47073: 50.11,
    },
    county_names_all: "Hawkins|Hancock",
    county_fips_all: "47073|47067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37732,
    lat: 36.32792,
    lng: -84.6282,
    city: "Elgin",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 47151,
    county_name: "Scott",
    county_weights: {
      47151: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 47151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37733,
    lat: 36.35676,
    lng: -84.69497,
    city: "Rugby",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37,
    density: 17.6,
    county_fips: 47129,
    county_name: "Morgan",
    county_weights: {
      47129: 99.42,
      47151: 0.58,
    },
    county_names_all: "Morgan|Scott",
    county_fips_all: "47129|47151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37737,
    lat: 35.75778,
    lng: -84.11913,
    city: "Friendsville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6058,
    density: 87.7,
    county_fips: 47009,
    county_name: "Blount",
    county_weights: {
      47009: 93.62,
      47105: 6.38,
    },
    county_names_all: "Blount|Loudon",
    county_fips_all: "47009|47105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37738,
    lat: 35.67125,
    lng: -83.47641,
    city: "Gatlinburg",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5343,
    density: 9.6,
    county_fips: 47155,
    county_name: "Sevier",
    county_weights: {
      47155: 100,
    },
    county_names_all: "Sevier",
    county_fips_all: 47155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37742,
    lat: 35.67548,
    lng: -84.18049,
    city: "Greenback",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6362,
    density: 49.7,
    county_fips: 47105,
    county_name: "Loudon",
    county_weights: {
      47009: 30.63,
      47105: 69.37,
    },
    county_names_all: "Loudon|Blount",
    county_fips_all: "47105|47009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37743,
    lat: 36.06663,
    lng: -82.85659,
    city: "Greeneville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24791,
    density: 43.1,
    county_fips: 47059,
    county_name: "Greene",
    county_weights: {
      47029: 1.86,
      47059: 98.14,
    },
    county_names_all: "Greene|Cocke",
    county_fips_all: "47059|47029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37745,
    lat: 36.2784,
    lng: -82.82631,
    city: "Greeneville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18233,
    density: 57.7,
    county_fips: 47059,
    county_name: "Greene",
    county_weights: {
      47059: 96.61,
      47073: 3.39,
    },
    county_names_all: "Greene|Hawkins",
    county_fips_all: "47059|47073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37748,
    lat: 35.94797,
    lng: -84.51413,
    city: "Harriman",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16745,
    density: 60.7,
    county_fips: 47145,
    county_name: "Roane",
    county_weights: {
      47129: 28.53,
      47145: 71.47,
    },
    county_names_all: "Roane|Morgan",
    county_fips_all: "47145|47129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37752,
    lat: 36.56735,
    lng: -83.55422,
    city: "Harrogate",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6460,
    density: 52.8,
    county_fips: 47025,
    county_name: "Claiborne",
    county_weights: {
      47025: 99.42,
      51105: 0.58,
    },
    county_names_all: "Claiborne|Lee",
    county_fips_all: "47025|51105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37753,
    lat: 35.82276,
    lng: -83.098,
    city: "Hartford",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 833,
    density: 10,
    county_fips: 47029,
    county_name: "Cocke",
    county_weights: {
      47029: 100,
    },
    county_names_all: "Cocke",
    county_fips_all: 47029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37754,
    lat: 36.13059,
    lng: -84.03305,
    city: "Heiskell",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3951,
    density: 39.9,
    county_fips: 47001,
    county_name: "Anderson",
    county_weights: {
      47001: 68.36,
      47093: 27.19,
      47173: 4.45,
    },
    county_names_all: "Anderson|Knox|Union",
    county_fips_all: "47001|47093|47173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37755,
    lat: 36.42249,
    lng: -84.53166,
    city: "Helenwood",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2652,
    density: 27,
    county_fips: 47151,
    county_name: "Scott",
    county_weights: {
      47151: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 47151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37756,
    lat: 36.30165,
    lng: -84.40704,
    city: "Huntsville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2973,
    density: 9.7,
    county_fips: 47151,
    county_name: "Scott",
    county_weights: {
      47013: 12.56,
      47151: 87.44,
    },
    county_names_all: "Scott|Campbell",
    county_fips_all: "47151|47013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37757,
    lat: 36.30182,
    lng: -84.14371,
    city: "Jacksboro",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10096,
    density: 137.8,
    county_fips: 47013,
    county_name: "Campbell",
    county_weights: {
      47013: 100,
    },
    county_names_all: "Campbell",
    county_fips_all: 47013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37760,
    lat: 36.10773,
    lng: -83.46443,
    city: "Jefferson City",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13550,
    density: 128.5,
    county_fips: 47089,
    county_name: "Jefferson",
    county_weights: {
      47089: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 47089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37762,
    lat: 36.57657,
    lng: -84.12323,
    city: "Jellico",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2630,
    density: 66.7,
    county_fips: 47013,
    county_name: "Campbell",
    county_weights: {
      47013: 100,
    },
    county_names_all: "Campbell",
    county_fips_all: 47013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37763,
    lat: 35.82344,
    lng: -84.49356,
    city: "Kingston",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15959,
    density: 71.7,
    county_fips: 47145,
    county_name: "Roane",
    county_weights: {
      47145: 100,
    },
    county_names_all: "Roane",
    county_fips_all: 47145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37764,
    lat: 35.97074,
    lng: -83.61585,
    city: "Kodak",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10448,
    density: 118.4,
    county_fips: 47155,
    county_name: "Sevier",
    county_weights: {
      47089: 0.24,
      47093: 12.39,
      47155: 87.37,
    },
    county_names_all: "Sevier|Knox|Jefferson",
    county_fips_all: "47155|47093|47089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37765,
    lat: 36.57219,
    lng: -83.06534,
    city: "Kyles Ford",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 601,
    density: 11.9,
    county_fips: 47067,
    county_name: "Hancock",
    county_weights: {
      47067: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 47067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37766,
    lat: 36.39958,
    lng: -84.07275,
    city: "La Follette",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17169,
    density: 48.3,
    county_fips: 47013,
    county_name: "Campbell",
    county_weights: {
      47013: 100,
    },
    county_names_all: "Campbell",
    county_fips_all: 47013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37769,
    lat: 36.21799,
    lng: -84.15532,
    city: "Rocky Top",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5839,
    density: 75.1,
    county_fips: 47001,
    county_name: "Anderson",
    county_weights: {
      47001: 81.22,
      47013: 18.78,
    },
    county_names_all: "Anderson|Campbell",
    county_fips_all: "47001|47013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37770,
    lat: 36.15239,
    lng: -84.6418,
    city: "Lancing",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2835,
    density: 8,
    county_fips: 47129,
    county_name: "Morgan",
    county_weights: {
      47129: 100,
    },
    county_names_all: "Morgan",
    county_fips_all: 47129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37771,
    lat: 35.8382,
    lng: -84.31748,
    city: "Lenoir City",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17730,
    density: 136.5,
    county_fips: 47105,
    county_name: "Loudon",
    county_weights: {
      47105: 74.89,
      47145: 25.11,
    },
    county_names_all: "Loudon|Roane",
    county_fips_all: "47105|47145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37772,
    lat: 35.78775,
    lng: -84.21876,
    city: "Lenoir City",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13106,
    density: 130.9,
    county_fips: 47105,
    county_name: "Loudon",
    county_weights: {
      47093: 0.12,
      47105: 99.88,
    },
    county_names_all: "Loudon|Knox",
    county_fips_all: "47105|47093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37774,
    lat: 35.7317,
    lng: -84.35526,
    city: "Loudon",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18340,
    density: 80.3,
    county_fips: 47105,
    county_name: "Loudon",
    county_weights: {
      47105: 86.78,
      47123: 1.14,
      47145: 12.08,
    },
    county_names_all: "Loudon|Roane|Monroe",
    county_fips_all: "47105|47145|47123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37777,
    lat: 35.82742,
    lng: -84.05186,
    city: "Louisville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12763,
    density: 149.9,
    county_fips: 47009,
    county_name: "Blount",
    county_weights: {
      47009: 100,
    },
    county_names_all: "Blount",
    county_fips_all: 47009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37779,
    lat: 36.21093,
    lng: -83.75793,
    city: "Luttrell",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3598,
    density: 40.2,
    county_fips: 47173,
    county_name: "Union",
    county_weights: {
      47057: 0.21,
      47093: 4.05,
      47173: 95.74,
    },
    county_names_all: "Union|Knox|Grainger",
    county_fips_all: "47173|47093|47057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37801,
    lat: 35.67134,
    lng: -84.08453,
    city: "Maryville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27102,
    density: 150.8,
    county_fips: 47009,
    county_name: "Blount",
    county_weights: {
      47009: 87.63,
      47123: 12.37,
    },
    county_names_all: "Blount|Monroe",
    county_fips_all: "47009|47123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37803,
    lat: 35.67115,
    lng: -83.97761,
    city: "Maryville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32016,
    density: 140.9,
    county_fips: 47009,
    county_name: "Blount",
    county_weights: {
      47009: 100,
    },
    county_names_all: "Blount",
    county_fips_all: 47009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37804,
    lat: 35.79228,
    lng: -83.89311,
    city: "Maryville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27040,
    density: 299.5,
    county_fips: 47009,
    county_name: "Blount",
    county_weights: {
      47009: 100,
    },
    county_names_all: "Blount",
    county_fips_all: 47009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37806,
    lat: 36.08645,
    lng: -83.72368,
    city: "Mascot",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2925,
    density: 62.1,
    county_fips: 47093,
    county_name: "Knox",
    county_weights: {
      47057: 11.53,
      47093: 88.47,
    },
    county_names_all: "Knox|Grainger",
    county_fips_all: "47093|47057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37807,
    lat: 36.25955,
    lng: -83.82702,
    city: "Maynardville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11397,
    density: 55,
    county_fips: 47173,
    county_name: "Union",
    county_weights: {
      47093: 0.63,
      47173: 99.37,
    },
    county_names_all: "Union|Knox",
    county_fips_all: "47173|47093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37809,
    lat: 36.15431,
    lng: -83.03611,
    city: "Midway",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2584,
    density: 32.2,
    county_fips: 47059,
    county_name: "Greene",
    county_weights: {
      47059: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 47059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37810,
    lat: 36.17984,
    lng: -83.10296,
    city: "Mohawk",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1981,
    density: 22.8,
    county_fips: 47059,
    county_name: "Greene",
    county_weights: {
      47059: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 47059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37811,
    lat: 36.35558,
    lng: -83.2144,
    city: "Mooresburg",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3926,
    density: 39.2,
    county_fips: 47073,
    county_name: "Hawkins",
    county_weights: {
      47057: 1.61,
      47073: 98.39,
    },
    county_names_all: "Hawkins|Grainger",
    county_fips_all: "47073|47057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37813,
    lat: 36.17644,
    lng: -83.26542,
    city: "Morristown",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17946,
    density: 119.5,
    county_fips: 47063,
    county_name: "Hamblen",
    county_weights: {
      47063: 97.36,
      47089: 2.64,
    },
    county_names_all: "Hamblen|Jefferson",
    county_fips_all: "47063|47089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37814,
    lat: 36.23604,
    lng: -83.3317,
    city: "Morristown",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34359,
    density: 302.5,
    county_fips: 47063,
    county_name: "Hamblen",
    county_weights: {
      47063: 100,
    },
    county_names_all: "Hamblen",
    county_fips_all: 47063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37818,
    lat: 36.18581,
    lng: -82.97233,
    city: "Mosheim",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5328,
    density: 44.6,
    county_fips: 47059,
    county_name: "Greene",
    county_weights: {
      47029: 0.23,
      47059: 99.77,
    },
    county_names_all: "Greene|Cocke",
    county_fips_all: "47059|47029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37819,
    lat: 36.55649,
    lng: -84.21169,
    city: "Newcomb",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 665,
    density: 12.2,
    county_fips: 47013,
    county_name: "Campbell",
    county_weights: {
      47013: 100,
    },
    county_names_all: "Campbell",
    county_fips_all: 47013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37820,
    lat: 36.08364,
    lng: -83.56715,
    city: "New Market",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7715,
    density: 44.1,
    county_fips: 47089,
    county_name: "Jefferson",
    county_weights: {
      47089: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 47089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37821,
    lat: 35.97688,
    lng: -83.19506,
    city: "Newport",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21657,
    density: 64.4,
    county_fips: 47029,
    county_name: "Cocke",
    county_weights: {
      47029: 99.8,
      47089: 0.2,
    },
    county_names_all: "Cocke|Jefferson",
    county_fips_all: "47029|47089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37825,
    lat: 36.41221,
    lng: -83.68196,
    city: "New Tazewell",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8291,
    density: 36.8,
    county_fips: 47025,
    county_name: "Claiborne",
    county_weights: {
      47025: 94.81,
      47173: 5.19,
    },
    county_names_all: "Claiborne|Union",
    county_fips_all: "47025|47173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37826,
    lat: 35.55825,
    lng: -84.58984,
    city: "Niota",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4930,
    density: 35.4,
    county_fips: 47107,
    county_name: "McMinn",
    county_weights: {
      47107: 98.73,
      47121: 1.27,
    },
    county_names_all: "McMinn|Meigs",
    county_fips_all: "47107|47121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37828,
    lat: 36.19788,
    lng: -84.06889,
    city: "Norris",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1457,
    density: 175.5,
    county_fips: 47001,
    county_name: "Anderson",
    county_weights: {
      47001: 100,
    },
    county_names_all: "Anderson",
    county_fips_all: 47001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37829,
    lat: 36.00094,
    lng: -84.61331,
    city: "Oakdale",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1731,
    density: 15.1,
    county_fips: 47129,
    county_name: "Morgan",
    county_weights: {
      47129: 100,
    },
    county_names_all: "Morgan",
    county_fips_all: 47129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37830,
    lat: 35.96431,
    lng: -84.29221,
    city: "Oak Ridge",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29569,
    density: 134.6,
    county_fips: 47001,
    county_name: "Anderson",
    county_weights: {
      47001: 52.24,
      47093: 0.53,
      47145: 47.23,
    },
    county_names_all: "Anderson|Roane|Knox",
    county_fips_all: "47001|47145|47093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37840,
    lat: 36.05849,
    lng: -84.37047,
    city: "Oliver Springs",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10092,
    density: 48.3,
    county_fips: 47129,
    county_name: "Morgan",
    county_weights: {
      47001: 36.8,
      47129: 44.27,
      47145: 18.92,
    },
    county_names_all: "Morgan|Anderson|Roane",
    county_fips_all: "47129|47001|47145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37841,
    lat: 36.5088,
    lng: -84.54665,
    city: "Oneida",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9966,
    density: 26.1,
    county_fips: 47151,
    county_name: "Scott",
    county_weights: {
      47151: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 47151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37843,
    lat: 36.01137,
    lng: -83.04979,
    city: "Parrottsville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4245,
    density: 31.1,
    county_fips: 47029,
    county_name: "Cocke",
    county_weights: {
      47029: 100,
    },
    county_names_all: "Cocke",
    county_fips_all: 47029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37845,
    lat: 36.10369,
    lng: -84.45022,
    city: "Petros",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 479,
    density: 46.3,
    county_fips: 47129,
    county_name: "Morgan",
    county_weights: {
      47129: 100,
    },
    county_names_all: "Morgan",
    county_fips_all: 47129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37846,
    lat: 35.68008,
    lng: -84.48505,
    city: "Philadelphia",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4002,
    density: 21.3,
    county_fips: 47105,
    county_name: "Loudon",
    county_weights: {
      47105: 42.7,
      47107: 3.94,
      47121: 0.13,
      47123: 14.53,
      47145: 38.7,
    },
    county_names_all: "Loudon|Roane|Monroe|McMinn|Meigs",
    county_fips_all: "47105|47145|47123|47107|47121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37847,
    lat: 36.43156,
    lng: -84.27346,
    city: "Pioneer",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3172,
    density: 8.4,
    county_fips: 47013,
    county_name: "Campbell",
    county_weights: {
      47013: 81.65,
      47151: 18.35,
    },
    county_names_all: "Campbell|Scott",
    county_fips_all: "47013|47151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37848,
    lat: 36.23701,
    lng: -83.68179,
    city: "Powder Springs",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 103,
    density: 5,
    county_fips: 47057,
    county_name: "Grainger",
    county_weights: {
      47057: 74.67,
      47173: 25.33,
    },
    county_names_all: "Grainger|Union",
    county_fips_all: "47057|47173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37849,
    lat: 36.0578,
    lng: -84.04476,
    city: "Powell",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28109,
    density: 273.1,
    county_fips: 47093,
    county_name: "Knox",
    county_weights: {
      47001: 29.21,
      47093: 70.79,
    },
    county_names_all: "Knox|Anderson",
    county_fips_all: "47093|47001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37851,
    lat: 36.56558,
    lng: -83.79244,
    city: "Pruden",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 47025,
    county_name: "Claiborne",
    county_weights: {
      47025: 100,
    },
    county_names_all: "Claiborne",
    county_fips_all: 47025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37852,
    lat: 36.32365,
    lng: -84.57454,
    city: "Robbins",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2941,
    density: 10.8,
    county_fips: 47151,
    county_name: "Scott",
    county_weights: {
      47129: 9.27,
      47151: 90.73,
    },
    county_names_all: "Scott|Morgan",
    county_fips_all: "47151|47129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37853,
    lat: 35.83723,
    lng: -83.90854,
    city: "Rockford",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3474,
    density: 80.1,
    county_fips: 47009,
    county_name: "Blount",
    county_weights: {
      47009: 91.22,
      47093: 8.78,
    },
    county_names_all: "Blount|Knox",
    county_fips_all: "47009|47093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37854,
    lat: 35.88004,
    lng: -84.71454,
    city: "Rockwood",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12690,
    density: 35.9,
    county_fips: 47145,
    county_name: "Roane",
    county_weights: {
      47035: 39.65,
      47129: 12.66,
      47145: 47.68,
    },
    county_names_all: "Roane|Cumberland|Morgan",
    county_fips_all: "47145|47035|47129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 37857,
    lat: 36.42145,
    lng: -82.94269,
    city: "Rogersville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20429,
    density: 33.5,
    county_fips: 47073,
    county_name: "Hawkins",
    county_weights: {
      47073: 99.4,
      47163: 0.6,
    },
    county_names_all: "Hawkins|Sullivan",
    county_fips_all: "47073|47163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37860,
    lat: 36.24492,
    lng: -83.18441,
    city: "Russellville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3613,
    density: 58,
    county_fips: 47063,
    county_name: "Hamblen",
    county_weights: {
      47063: 100,
    },
    county_names_all: "Hamblen",
    county_fips_all: 47063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37861,
    lat: 36.24516,
    lng: -83.51421,
    city: "Rutledge",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8980,
    density: 35.2,
    county_fips: 47057,
    county_name: "Grainger",
    county_weights: {
      47057: 100,
    },
    county_names_all: "Grainger",
    county_fips_all: 47057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37862,
    lat: 35.78314,
    lng: -83.61232,
    city: "Sevierville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22731,
    density: 107.3,
    county_fips: 47155,
    county_name: "Sevier",
    county_weights: {
      47155: 100,
    },
    county_names_all: "Sevier",
    county_fips_all: 47155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37863,
    lat: 35.7864,
    lng: -83.56367,
    city: "Pigeon Forge",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6932,
    density: 155.3,
    county_fips: 47155,
    county_name: "Sevier",
    county_weights: {
      47155: 100,
    },
    county_names_all: "Sevier",
    county_fips_all: 47155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37865,
    lat: 35.84609,
    lng: -83.73974,
    city: "Seymour",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24638,
    density: 129.7,
    county_fips: 47155,
    county_name: "Sevier",
    county_weights: {
      47009: 30.7,
      47155: 69.3,
    },
    county_names_all: "Sevier|Blount",
    county_fips_all: "47155|47009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37866,
    lat: 36.35017,
    lng: -83.8517,
    city: "Sharps Chapel",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1508,
    density: 10.5,
    county_fips: 47173,
    county_name: "Union",
    county_weights: {
      47173: 100,
    },
    county_names_all: "Union",
    county_fips_all: 47173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37869,
    lat: 36.51555,
    lng: -83.24579,
    city: "Sneedville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4624,
    density: 13.4,
    county_fips: 47067,
    county_name: "Hancock",
    county_weights: {
      47025: 4.86,
      47067: 88.44,
      47073: 6.7,
    },
    county_names_all: "Hancock|Hawkins|Claiborne",
    county_fips_all: "47067|47073|47025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37870,
    lat: 36.46319,
    lng: -83.83562,
    city: "Speedwell",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4278,
    density: 19.9,
    county_fips: 47025,
    county_name: "Claiborne",
    county_weights: {
      47013: 15.26,
      47025: 73.2,
      47173: 11.54,
    },
    county_names_all: "Claiborne|Campbell|Union",
    county_fips_all: "47025|47013|47173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37871,
    lat: 36.04693,
    lng: -83.67932,
    city: "Strawberry Plains",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8524,
    density: 84.2,
    county_fips: 47093,
    county_name: "Knox",
    county_weights: {
      47089: 42.93,
      47093: 45.44,
      47155: 11.63,
    },
    county_names_all: "Knox|Jefferson|Sevier",
    county_fips_all: "47093|47089|47155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37872,
    lat: 36.26869,
    lng: -84.68119,
    city: "Sunbright",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1710,
    density: 7.2,
    county_fips: 47129,
    county_name: "Morgan",
    county_weights: {
      47129: 86.35,
      47151: 13.65,
    },
    county_names_all: "Morgan|Scott",
    county_fips_all: "47129|47151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37873,
    lat: 36.52446,
    lng: -82.84754,
    city: "Surgoinsville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4362,
    density: 26.9,
    county_fips: 47073,
    county_name: "Hawkins",
    county_weights: {
      47073: 100,
    },
    county_names_all: "Hawkins",
    county_fips_all: 47073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37874,
    lat: 35.59749,
    lng: -84.45823,
    city: "Sweetwater",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15765,
    density: 59.2,
    county_fips: 47123,
    county_name: "Monroe",
    county_weights: {
      47105: 8.72,
      47107: 20.58,
      47123: 70.29,
      47145: 0.41,
    },
    county_names_all: "Monroe|McMinn|Loudon|Roane",
    county_fips_all: "47123|47107|47105|47145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37876,
    lat: 35.8645,
    lng: -83.47876,
    city: "Sevierville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32142,
    density: 66.4,
    county_fips: 47155,
    county_name: "Sevier",
    county_weights: {
      47089: 8.54,
      47155: 91.46,
    },
    county_names_all: "Sevier|Jefferson",
    county_fips_all: "47155|47089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37877,
    lat: 36.15176,
    lng: -83.40503,
    city: "Talbott",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8893,
    density: 129.8,
    county_fips: 47089,
    county_name: "Jefferson",
    county_weights: {
      47063: 44.6,
      47089: 55.4,
    },
    county_names_all: "Jefferson|Hamblen",
    county_fips_all: "47089|47063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37878,
    lat: 35.59406,
    lng: -83.98358,
    city: "Tallassee",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 350,
    density: 5.2,
    county_fips: 47009,
    county_name: "Blount",
    county_weights: {
      47009: 100,
    },
    county_names_all: "Blount",
    county_fips_all: 47009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37879,
    lat: 36.48403,
    lng: -83.48705,
    city: "Tazewell",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11501,
    density: 25.3,
    county_fips: 47025,
    county_name: "Claiborne",
    county_weights: {
      47025: 80.38,
      47067: 19.62,
    },
    county_names_all: "Claiborne|Hancock",
    county_fips_all: "47025|47067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37880,
    lat: 35.7012,
    lng: -84.66453,
    city: "Ten Mile",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3772,
    density: 19.8,
    county_fips: 47121,
    county_name: "Meigs",
    county_weights: {
      47107: 0.46,
      47121: 56.61,
      47145: 42.93,
    },
    county_names_all: "Meigs|Roane|McMinn",
    county_fips_all: "47121|47145|47107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37881,
    lat: 36.39861,
    lng: -83.34393,
    city: "Thorn Hill",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2023,
    density: 10.9,
    county_fips: 47057,
    county_name: "Grainger",
    county_weights: {
      47025: 0.57,
      47057: 56.61,
      47067: 35.83,
      47073: 6.99,
    },
    county_names_all: "Grainger|Hancock|Hawkins|Claiborne",
    county_fips_all: "47057|47067|47073|47025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37882,
    lat: 35.60335,
    lng: -83.82118,
    city: "Townsend",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3036,
    density: 6.4,
    county_fips: 47009,
    county_name: "Blount",
    county_weights: {
      47009: 100,
    },
    county_names_all: "Blount",
    county_fips_all: 47009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37885,
    lat: 35.50392,
    lng: -84.12539,
    city: "Vonore",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5854,
    density: 15.6,
    county_fips: 47123,
    county_name: "Monroe",
    county_weights: {
      47105: 2.14,
      47123: 97.86,
    },
    county_names_all: "Monroe|Loudon",
    county_fips_all: "47123|47105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37886,
    lat: 35.74142,
    lng: -83.80747,
    city: "Walland",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4594,
    density: 41.9,
    county_fips: 47009,
    county_name: "Blount",
    county_weights: {
      47009: 100,
    },
    county_names_all: "Blount",
    county_fips_all: 47009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37887,
    lat: 36.0772,
    lng: -84.61573,
    city: "Wartburg",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7651,
    density: 36.3,
    county_fips: 47129,
    county_name: "Morgan",
    county_weights: {
      47129: 100,
    },
    county_names_all: "Morgan",
    county_fips_all: 47129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37888,
    lat: 36.31063,
    lng: -83.61266,
    city: "Washburn",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3406,
    density: 23.6,
    county_fips: 47057,
    county_name: "Grainger",
    county_weights: {
      47057: 90.97,
      47173: 9.03,
    },
    county_names_all: "Grainger|Union",
    county_fips_all: "47057|47173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37890,
    lat: 36.08144,
    lng: -83.29299,
    city: "White Pine",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7208,
    density: 80.7,
    county_fips: 47089,
    county_name: "Jefferson",
    county_weights: {
      47063: 5.9,
      47089: 94.1,
    },
    county_names_all: "Jefferson|Hamblen",
    county_fips_all: "47089|47063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37891,
    lat: 36.29172,
    lng: -83.13992,
    city: "Whitesburg",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3628,
    density: 40.2,
    county_fips: 47063,
    county_name: "Hamblen",
    county_weights: {
      47063: 64.91,
      47073: 35.09,
    },
    county_names_all: "Hamblen|Hawkins",
    county_fips_all: "47063|47073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37892,
    lat: 36.55666,
    lng: -84.37132,
    city: "Winfield",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2034,
    density: 11.1,
    county_fips: 47151,
    county_name: "Scott",
    county_weights: {
      47151: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 47151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37902,
    lat: 35.96203,
    lng: -83.92039,
    city: "Knoxville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2463,
    density: 2151.4,
    county_fips: 47093,
    county_name: "Knox",
    county_weights: {
      47093: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 47093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37909,
    lat: 35.94716,
    lng: -84.02275,
    city: "Knoxville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16321,
    density: 926.6,
    county_fips: 47093,
    county_name: "Knox",
    county_weights: {
      47093: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 47093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37912,
    lat: 36.00849,
    lng: -83.98465,
    city: "Knoxville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22154,
    density: 810.1,
    county_fips: 47093,
    county_name: "Knox",
    county_weights: {
      47093: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 47093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37914,
    lat: 35.97988,
    lng: -83.79937,
    city: "Knoxville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19912,
    density: 193.6,
    county_fips: 47093,
    county_name: "Knox",
    county_weights: {
      47093: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 47093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37915,
    lat: 35.97057,
    lng: -83.90002,
    city: "Knoxville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5055,
    density: 1035.7,
    county_fips: 47093,
    county_name: "Knox",
    county_weights: {
      47093: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 47093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37916,
    lat: 35.95309,
    lng: -83.9335,
    city: "Knoxville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13711,
    density: 3757,
    county_fips: 47093,
    county_name: "Knox",
    county_weights: {
      47093: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 47093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37917,
    lat: 36.00156,
    lng: -83.91265,
    city: "Knoxville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25048,
    density: 1017.8,
    county_fips: 47093,
    county_name: "Knox",
    county_weights: {
      47093: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 47093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37918,
    lat: 36.0599,
    lng: -83.91082,
    city: "Knoxville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45107,
    density: 504,
    county_fips: 47093,
    county_name: "Knox",
    county_weights: {
      47093: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 47093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37919,
    lat: 35.91429,
    lng: -84.00106,
    city: "Knoxville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29637,
    density: 598.9,
    county_fips: 47093,
    county_name: "Knox",
    county_weights: {
      47093: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 47093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37920,
    lat: 35.91084,
    lng: -83.85909,
    city: "Knoxville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40678,
    density: 217.2,
    county_fips: 47093,
    county_name: "Knox",
    county_weights: {
      47009: 0.67,
      47093: 99.33,
    },
    county_names_all: "Knox|Blount",
    county_fips_all: "47093|47009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37921,
    lat: 35.97877,
    lng: -84.00028,
    city: "Knoxville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27522,
    density: 668.3,
    county_fips: 47093,
    county_name: "Knox",
    county_weights: {
      47093: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 47093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37922,
    lat: 35.86124,
    lng: -84.10127,
    city: "Knoxville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37709,
    density: 525.1,
    county_fips: 47093,
    county_name: "Knox",
    county_weights: {
      47093: 99.35,
      47105: 0.65,
    },
    county_names_all: "Knox|Loudon",
    county_fips_all: "47093|47105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37923,
    lat: 35.92697,
    lng: -84.08076,
    city: "Knoxville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31548,
    density: 1098.6,
    county_fips: 47093,
    county_name: "Knox",
    county_weights: {
      47093: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 47093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37924,
    lat: 36.03554,
    lng: -83.80211,
    city: "Knoxville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12312,
    density: 170.6,
    county_fips: 47093,
    county_name: "Knox",
    county_weights: {
      47093: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 47093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37929,
    lat: 35.96241,
    lng: -83.91597,
    city: "Knoxville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 47093,
    county_name: "Knox",
    county_weights: {
      47093: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 47093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37931,
    lat: 35.97611,
    lng: -84.12496,
    city: "Knoxville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28440,
    density: 387.1,
    county_fips: 47093,
    county_name: "Knox",
    county_weights: {
      47001: 8.51,
      47093: 91.49,
    },
    county_names_all: "Knox|Anderson",
    county_fips_all: "47093|47001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37932,
    lat: 35.92273,
    lng: -84.19562,
    city: "Knoxville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19206,
    density: 255.8,
    county_fips: 47093,
    county_name: "Knox",
    county_weights: {
      47093: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 47093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37934,
    lat: 35.87338,
    lng: -84.17882,
    city: "Farragut",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27152,
    density: 601.6,
    county_fips: 47093,
    county_name: "Knox",
    county_weights: {
      47093: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 47093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 37938,
    lat: 36.12499,
    lng: -83.93815,
    city: "Knoxville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17230,
    density: 205.6,
    county_fips: 47093,
    county_name: "Knox",
    county_weights: {
      47001: 0.38,
      47093: 99.02,
      47173: 0.6,
    },
    county_names_all: "Knox|Union|Anderson",
    county_fips_all: "47093|47173|47001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 38001,
    lat: 35.81323,
    lng: -89.15505,
    city: "Alamo",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4350,
    density: 24.9,
    county_fips: 47033,
    county_name: "Crockett",
    county_weights: {
      47033: 100,
    },
    county_names_all: "Crockett",
    county_fips_all: 47033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38002,
    lat: 35.28854,
    lng: -89.70926,
    city: "Arlington",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40070,
    density: 133,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47047: 13.13,
      47157: 86.87,
    },
    county_names_all: "Shelby|Fayette",
    county_fips_all: "47157|47047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38004,
    lat: 35.41909,
    lng: -89.76687,
    city: "Atoka",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11094,
    density: 156.6,
    county_fips: 47167,
    county_name: "Tipton",
    county_weights: {
      47157: 20.79,
      47167: 79.21,
    },
    county_names_all: "Tipton|Shelby",
    county_fips_all: "47167|47157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38006,
    lat: 35.69507,
    lng: -89.09761,
    city: "Bells",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5530,
    density: 21,
    county_fips: 47075,
    county_name: "Haywood",
    county_weights: {
      47033: 45.32,
      47075: 48.49,
      47113: 6.18,
    },
    county_names_all: "Haywood|Crockett|Madison",
    county_fips_all: "47075|47033|47113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38007,
    lat: 36.16422,
    lng: -89.43925,
    city: "Bogota",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69,
    density: 478.8,
    county_fips: 47045,
    county_name: "Dyer",
    county_weights: {
      47045: 100,
    },
    county_names_all: "Dyer",
    county_fips_all: 47045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38008,
    lat: 35.24455,
    lng: -88.99879,
    city: "Bolivar",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8726,
    density: 21.9,
    county_fips: 47069,
    county_name: "Hardeman",
    county_weights: {
      47069: 100,
    },
    county_names_all: "Hardeman",
    county_fips_all: 47069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38011,
    lat: 35.47266,
    lng: -89.71415,
    city: "Brighton",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9429,
    density: 63.8,
    county_fips: 47167,
    county_name: "Tipton",
    county_weights: {
      47157: 3.16,
      47167: 96.84,
    },
    county_names_all: "Tipton|Shelby",
    county_fips_all: "47167|47157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38012,
    lat: 35.60959,
    lng: -89.27085,
    city: "Brownsville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12658,
    density: 17.9,
    county_fips: 47075,
    county_name: "Haywood",
    county_weights: {
      47075: 100,
    },
    county_names_all: "Haywood",
    county_fips_all: 47075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38015,
    lat: 35.55948,
    lng: -89.82436,
    city: "Burlison",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2249,
    density: 20.5,
    county_fips: 47167,
    county_name: "Tipton",
    county_weights: {
      47167: 100,
    },
    county_names_all: "Tipton",
    county_fips_all: 47167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38016,
    lat: 35.17956,
    lng: -89.76046,
    city: "Cordova",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45424,
    density: 968.3,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38017,
    lat: 35.06722,
    lng: -89.65347,
    city: "Collierville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55884,
    density: 263.3,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47047: 43.46,
      47157: 56.54,
    },
    county_names_all: "Shelby|Fayette",
    county_fips_all: "47157|47047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38018,
    lat: 35.13781,
    lng: -89.76647,
    city: "Cordova",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37269,
    density: 771.2,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38019,
    lat: 35.56114,
    lng: -89.6304,
    city: "Covington",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16137,
    density: 44.3,
    county_fips: 47167,
    county_name: "Tipton",
    county_weights: {
      47167: 100,
    },
    county_names_all: "Tipton",
    county_fips_all: 47167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38021,
    lat: 35.87042,
    lng: -89.18411,
    city: "Crockett Mills",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 47033,
    county_name: "Crockett",
    county_weights: {
      47033: 100,
    },
    county_names_all: "Crockett",
    county_fips_all: 47033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38023,
    lat: 35.47468,
    lng: -89.95114,
    city: "Drummonds",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6683,
    density: 34.2,
    county_fips: 47167,
    county_name: "Tipton",
    county_weights: {
      47167: 100,
    },
    county_names_all: "Tipton",
    county_fips_all: 47167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38024,
    lat: 36.03743,
    lng: -89.38511,
    city: "Dyersburg",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26627,
    density: 71.9,
    county_fips: 47045,
    county_name: "Dyer",
    county_weights: {
      47045: 100,
    },
    county_names_all: "Dyer",
    county_fips_all: 47045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38028,
    lat: 35.18486,
    lng: -89.63474,
    city: "Eads",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7478,
    density: 48.8,
    county_fips: 47047,
    county_name: "Fayette",
    county_weights: {
      47047: 53.22,
      47157: 46.78,
    },
    county_names_all: "Fayette|Shelby",
    county_fips_all: "47047|47157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38029,
    lat: 35.24205,
    lng: -89.82351,
    city: "Ellendale",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27,
    density: 78,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38030,
    lat: 35.99942,
    lng: -89.59981,
    city: "Finley",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 444,
    density: 1.6,
    county_fips: 47045,
    county_name: "Dyer",
    county_weights: {
      47045: 100,
    },
    county_names_all: "Dyer",
    county_fips_all: 47045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38034,
    lat: 35.91273,
    lng: -89.236,
    city: "Friendship",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2968,
    density: 11.1,
    county_fips: 47033,
    county_name: "Crockett",
    county_weights: {
      47033: 65.63,
      47045: 34.37,
    },
    county_names_all: "Crockett|Dyer",
    county_fips_all: "47033|47045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38036,
    lat: 35.32715,
    lng: -89.61941,
    city: "Gallaway",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 612,
    density: 1038.1,
    county_fips: 47047,
    county_name: "Fayette",
    county_weights: {
      47047: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 47047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38037,
    lat: 35.79433,
    lng: -89.39232,
    city: "Gates",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1558,
    density: 13,
    county_fips: 47075,
    county_name: "Haywood",
    county_weights: {
      47075: 59.14,
      47097: 40.86,
    },
    county_names_all: "Haywood|Lauderdale",
    county_fips_all: "47075|47097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38039,
    lat: 35.0571,
    lng: -89.18545,
    city: "Grand Junction",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1882,
    density: 10.8,
    county_fips: 47069,
    county_name: "Hardeman",
    county_weights: {
      47047: 42.47,
      47069: 57.53,
    },
    county_names_all: "Hardeman|Fayette",
    county_fips_all: "47069|47047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38040,
    lat: 35.88185,
    lng: -89.48065,
    city: "Halls",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4574,
    density: 13.4,
    county_fips: 47097,
    county_name: "Lauderdale",
    county_weights: {
      47033: 18.74,
      47045: 8.53,
      47097: 72.73,
    },
    county_names_all: "Lauderdale|Crockett|Dyer",
    county_fips_all: "47097|47033|47045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38041,
    lat: 35.64397,
    lng: -89.70204,
    city: "Henning",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4752,
    density: 18,
    county_fips: 47097,
    county_name: "Lauderdale",
    county_weights: {
      47097: 100,
    },
    county_names_all: "Lauderdale",
    county_fips_all: 47097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38042,
    lat: 35.15059,
    lng: -89.13848,
    city: "Hickory Valley",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 672,
    density: 5.1,
    county_fips: 47069,
    county_name: "Hardeman",
    county_weights: {
      47047: 14.78,
      47069: 85.22,
    },
    county_names_all: "Hardeman|Fayette",
    county_fips_all: "47069|47047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38044,
    lat: 35.20736,
    lng: -88.80244,
    city: "Hornsby",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 638,
    density: 5.8,
    county_fips: 47069,
    county_name: "Hardeman",
    county_weights: {
      47023: 5.36,
      47069: 81.29,
      47109: 13.35,
    },
    county_names_all: "Hardeman|McNairy|Chester",
    county_fips_all: "47069|47109|47023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38046,
    lat: 35.04598,
    lng: -89.24408,
    city: "La Grange",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60,
    density: 263.6,
    county_fips: 47047,
    county_name: "Fayette",
    county_weights: {
      47047: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 47047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38047,
    lat: 36.06499,
    lng: -89.55569,
    city: "Lenox",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 47045,
    county_name: "Dyer",
    county_weights: {
      47045: 100,
    },
    county_names_all: "Dyer",
    county_fips_all: 47045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38049,
    lat: 35.38689,
    lng: -89.544,
    city: "Mason",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4271,
    density: 14.8,
    county_fips: 47047,
    county_name: "Fayette",
    county_weights: {
      47047: 62.52,
      47167: 37.48,
    },
    county_names_all: "Fayette|Tipton",
    county_fips_all: "47047|47167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38050,
    lat: 35.81635,
    lng: -89.22712,
    city: "Maury City",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 733,
    density: 486.5,
    county_fips: 47033,
    county_name: "Crockett",
    county_weights: {
      47033: 100,
    },
    county_names_all: "Crockett",
    county_fips_all: 47033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38052,
    lat: 35.08574,
    lng: -88.91308,
    city: "Middleton",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4023,
    density: 12.3,
    county_fips: 47069,
    county_name: "Hardeman",
    county_weights: {
      47069: 100,
    },
    county_names_all: "Hardeman",
    county_fips_all: 47069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38053,
    lat: 35.33583,
    lng: -89.95,
    city: "Millington",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25816,
    density: 61.4,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 92.6,
      47167: 7.4,
    },
    county_names_all: "Shelby|Tipton",
    county_fips_all: "47157|47167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38054,
    lat: 35.3358,
    lng: -89.8744,
    city: "Millington",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 289,
    density: 358.2,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38057,
    lat: 35.05381,
    lng: -89.36772,
    city: "Moscow",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3595,
    density: 13.1,
    county_fips: 47047,
    county_name: "Fayette",
    county_weights: {
      47047: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 47047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38058,
    lat: 35.45861,
    lng: -89.81933,
    city: "Munford",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9981,
    density: 148.6,
    county_fips: 47167,
    county_name: "Tipton",
    county_weights: {
      47167: 100,
    },
    county_names_all: "Tipton",
    county_fips_all: 47167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38059,
    lat: 36.11132,
    lng: -89.24113,
    city: "Newbern",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7928,
    density: 23.3,
    county_fips: 47045,
    county_name: "Dyer",
    county_weights: {
      47045: 86.62,
      47053: 13.38,
    },
    county_names_all: "Dyer|Gibson",
    county_fips_all: "47045|47053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38060,
    lat: 35.21214,
    lng: -89.50468,
    city: "Oakland",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10403,
    density: 89.5,
    county_fips: 47047,
    county_name: "Fayette",
    county_weights: {
      47047: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 47047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38061,
    lat: 35.06704,
    lng: -88.7647,
    city: "Pocahontas",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1185,
    density: 6.7,
    county_fips: 47109,
    county_name: "McNairy",
    county_weights: {
      47069: 28.32,
      47109: 71.68,
    },
    county_names_all: "McNairy|Hardeman",
    county_fips_all: "47109|47069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38063,
    lat: 35.74598,
    lng: -89.63412,
    city: "Ripley",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16154,
    density: 21.9,
    county_fips: 47097,
    county_name: "Lauderdale",
    county_weights: {
      47075: 9.09,
      47097: 90.91,
    },
    county_names_all: "Lauderdale|Haywood",
    county_fips_all: "47097|47075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38066,
    lat: 35.07421,
    lng: -89.53944,
    city: "Rossville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2786,
    density: 18.7,
    county_fips: 47047,
    county_name: "Fayette",
    county_weights: {
      47047: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 47047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38067,
    lat: 35.08561,
    lng: -89.04804,
    city: "Saulsbury",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1230,
    density: 8.1,
    county_fips: 47069,
    county_name: "Hardeman",
    county_weights: {
      47069: 100,
    },
    county_names_all: "Hardeman",
    county_fips_all: 47069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38068,
    lat: 35.25972,
    lng: -89.3349,
    city: "Somerville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10850,
    density: 16.2,
    county_fips: 47047,
    county_name: "Fayette",
    county_weights: {
      47047: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 47047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38069,
    lat: 35.46209,
    lng: -89.37151,
    city: "Stanton",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2146,
    density: 5.9,
    county_fips: 47075,
    county_name: "Haywood",
    county_weights: {
      47047: 2.92,
      47075: 84.29,
      47167: 12.79,
    },
    county_names_all: "Haywood|Tipton|Fayette",
    county_fips_all: "47075|47167|47047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38070,
    lat: 35.94045,
    lng: -89.24915,
    city: "Tigrett",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 94,
    density: 21.5,
    county_fips: 47045,
    county_name: "Dyer",
    county_weights: {
      47045: 100,
    },
    county_names_all: "Dyer",
    county_fips_all: 47045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38075,
    lat: 35.37197,
    lng: -89.15569,
    city: "Whiteville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6744,
    density: 19.8,
    county_fips: 47069,
    county_name: "Hardeman",
    county_weights: {
      47047: 12.46,
      47069: 58.96,
      47075: 28.58,
    },
    county_names_all: "Hardeman|Haywood|Fayette",
    county_fips_all: "47069|47075|47047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38076,
    lat: 35.12301,
    lng: -89.45633,
    city: "Williston",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1154,
    density: 15.6,
    county_fips: 47047,
    county_name: "Fayette",
    county_weights: {
      47047: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 47047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38077,
    lat: 36.32852,
    lng: -89.4744,
    city: "Wynnburg",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38,
    density: 615.4,
    county_fips: 47095,
    county_name: "Lake",
    county_weights: {
      47095: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 47095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38079,
    lat: 36.41378,
    lng: -89.47032,
    city: "Tiptonville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5023,
    density: 17.6,
    county_fips: 47095,
    county_name: "Lake",
    county_weights: {
      21075: 12.96,
      47095: 87.04,
    },
    county_names_all: "Lake|Fulton",
    county_fips_all: "47095|21075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38080,
    lat: 36.20295,
    lng: -89.52142,
    city: "Ridgely",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2441,
    density: 6.8,
    county_fips: 47095,
    county_name: "Lake",
    county_weights: {
      47045: 45.37,
      47095: 52.4,
      47131: 2.23,
    },
    county_names_all: "Lake|Dyer|Obion",
    county_fips_all: "47095|47045|47131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38103,
    lat: 35.15308,
    lng: -90.05518,
    city: "Memphis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14713,
    density: 2141.2,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38104,
    lat: 35.13253,
    lng: -90.00435,
    city: "Memphis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23812,
    density: 1856.6,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38105,
    lat: 35.1512,
    lng: -90.03541,
    city: "Memphis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5638,
    density: 1287.9,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38106,
    lat: 35.10067,
    lng: -90.0375,
    city: "Memphis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24256,
    density: 900.7,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38107,
    lat: 35.17054,
    lng: -90.02397,
    city: "Memphis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15477,
    density: 1096.6,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38108,
    lat: 35.1763,
    lng: -89.96382,
    city: "Memphis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17258,
    density: 877.3,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38109,
    lat: 35.0341,
    lng: -90.13533,
    city: "Memphis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44846,
    density: 290,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38111,
    lat: 35.11014,
    lng: -89.94429,
    city: "Memphis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42146,
    density: 1664.9,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38112,
    lat: 35.14791,
    lng: -89.97661,
    city: "Memphis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16046,
    density: 1289.2,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38113,
    lat: 35.10198,
    lng: -90.13285,
    city: "Memphis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38114,
    lat: 35.09648,
    lng: -89.98596,
    city: "Memphis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23940,
    density: 1216.7,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38115,
    lat: 35.05499,
    lng: -89.86362,
    city: "Memphis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38817,
    density: 1746.2,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38116,
    lat: 35.03213,
    lng: -90.01001,
    city: "Memphis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42057,
    density: 827,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38117,
    lat: 35.11504,
    lng: -89.90551,
    city: "Memphis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27162,
    density: 1116.9,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38118,
    lat: 35.03655,
    lng: -89.93021,
    city: "Memphis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40156,
    density: 508.9,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38119,
    lat: 35.07986,
    lng: -89.84593,
    city: "Memphis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24818,
    density: 1086.9,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38120,
    lat: 35.12344,
    lng: -89.85237,
    city: "Memphis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15485,
    density: 621.5,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38122,
    lat: 35.1571,
    lng: -89.92247,
    city: "Memphis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23955,
    density: 1356.8,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38125,
    lat: 35.02537,
    lng: -89.78936,
    city: "Memphis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39315,
    density: 798.8,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38126,
    lat: 35.12695,
    lng: -90.04378,
    city: "Memphis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5844,
    density: 1214.5,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38127,
    lat: 35.23795,
    lng: -90.01753,
    city: "Memphis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43240,
    density: 442.1,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38128,
    lat: 35.22623,
    lng: -89.92612,
    city: "Memphis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46158,
    density: 753.9,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38131,
    lat: 35.06603,
    lng: -89.99266,
    city: "Memphis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38132,
    lat: 35.07069,
    lng: -90.00033,
    city: "Memphis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38133,
    lat: 35.21292,
    lng: -89.79474,
    city: "Memphis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22155,
    density: 658.8,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38134,
    lat: 35.17674,
    lng: -89.85992,
    city: "Memphis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45184,
    density: 939.2,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38135,
    lat: 35.23876,
    lng: -89.8497,
    city: "Memphis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29719,
    density: 890.4,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38138,
    lat: 35.08477,
    lng: -89.7993,
    city: "Germantown",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24143,
    density: 786.1,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38139,
    lat: 35.08615,
    lng: -89.75581,
    city: "Germantown",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15986,
    density: 709.1,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38141,
    lat: 35.01599,
    lng: -89.85472,
    city: "Memphis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23443,
    density: 1159.2,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38152,
    lat: 35.11843,
    lng: -89.93743,
    city: "Memphis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 870,
    density: 3400.3,
    county_fips: 47157,
    county_name: "Shelby",
    county_weights: {
      47157: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 47157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38201,
    lat: 36.12335,
    lng: -88.53131,
    city: "McKenzie",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10755,
    density: 29.8,
    county_fips: 47017,
    county_name: "Carroll",
    county_weights: {
      47017: 59.17,
      47079: 13.43,
      47183: 27.4,
    },
    county_names_all: "Carroll|Weakley|Henry",
    county_fips_all: "47017|47183|47079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38220,
    lat: 35.98836,
    lng: -88.673,
    city: "Atwood",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1565,
    density: 15.7,
    county_fips: 47017,
    county_name: "Carroll",
    county_weights: {
      47017: 72.09,
      47053: 27.91,
    },
    county_names_all: "Carroll|Gibson",
    county_fips_all: "47017|47053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38221,
    lat: 36.24552,
    lng: -88.03685,
    city: "Big Sandy",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3289,
    density: 11.7,
    county_fips: 47005,
    county_name: "Benton",
    county_weights: {
      47005: 100,
    },
    county_names_all: "Benton",
    county_fips_all: 47005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38222,
    lat: 36.44512,
    lng: -88.16288,
    city: "Buchanan",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2109,
    density: 11.8,
    county_fips: 47079,
    county_name: "Henry",
    county_weights: {
      47079: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 47079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38224,
    lat: 36.39172,
    lng: -88.48774,
    city: "Cottage Grove",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 791,
    density: 5.1,
    county_fips: 47079,
    county_name: "Henry",
    county_weights: {
      47079: 88.06,
      47183: 11.94,
    },
    county_names_all: "Henry|Weakley",
    county_fips_all: "47079|47183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38225,
    lat: 36.31764,
    lng: -88.67937,
    city: "Dresden",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5398,
    density: 19.8,
    county_fips: 47183,
    county_name: "Weakley",
    county_weights: {
      47183: 100,
    },
    county_names_all: "Weakley",
    county_fips_all: 47183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38226,
    lat: 36.47722,
    lng: -88.66382,
    city: "Dukedom",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 288,
    density: 4.6,
    county_fips: 47183,
    county_name: "Weakley",
    county_weights: {
      47183: 100,
    },
    county_names_all: "Weakley",
    county_fips_all: 47183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38229,
    lat: 36.22108,
    lng: -88.60939,
    city: "Gleason",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3121,
    density: 19.8,
    county_fips: 47183,
    county_name: "Weakley",
    county_weights: {
      47079: 1.39,
      47183: 98.61,
    },
    county_names_all: "Weakley|Henry",
    county_fips_all: "47183|47079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38230,
    lat: 36.15592,
    lng: -88.77154,
    city: "Greenfield",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3704,
    density: 16.7,
    county_fips: 47183,
    county_name: "Weakley",
    county_weights: {
      47183: 100,
    },
    county_names_all: "Weakley",
    county_fips_all: 47183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38231,
    lat: 36.21277,
    lng: -88.42442,
    city: "Henry",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1610,
    density: 10.6,
    county_fips: 47079,
    county_name: "Henry",
    county_weights: {
      47079: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 47079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38232,
    lat: 36.34828,
    lng: -89.32295,
    city: "Hornbeak",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2173,
    density: 16.2,
    county_fips: 47131,
    county_name: "Obion",
    county_weights: {
      47131: 100,
    },
    county_names_all: "Obion",
    county_fips_all: 47131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38233,
    lat: 36.20411,
    lng: -89.04622,
    city: "Kenton",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2880,
    density: 12,
    county_fips: 47053,
    county_name: "Gibson",
    county_weights: {
      47053: 51.33,
      47131: 48.67,
    },
    county_names_all: "Gibson|Obion",
    county_fips_all: "47053|47131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38235,
    lat: 35.99116,
    lng: -88.58109,
    city: "McLemoresville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 511,
    density: 143.7,
    county_fips: 47017,
    county_name: "Carroll",
    county_weights: {
      47017: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 47017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38236,
    lat: 36.17572,
    lng: -88.26463,
    city: "Mansfield",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 512,
    density: 4.8,
    county_fips: 47079,
    county_name: "Henry",
    county_weights: {
      47079: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 47079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38237,
    lat: 36.36406,
    lng: -88.83162,
    city: "Martin",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15281,
    density: 42.7,
    county_fips: 47183,
    county_name: "Weakley",
    county_weights: {
      47131: 3.47,
      47183: 96.53,
    },
    county_names_all: "Weakley|Obion",
    county_fips_all: "47183|47131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38240,
    lat: 36.25091,
    lng: -89.32045,
    city: "Obion",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2236,
    density: 10.1,
    county_fips: 47131,
    county_name: "Obion",
    county_weights: {
      47045: 10.58,
      47131: 89.42,
    },
    county_names_all: "Obion|Dyer",
    county_fips_all: "47131|47045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38241,
    lat: 36.42852,
    lng: -88.58964,
    city: "Palmersville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1099,
    density: 7.1,
    county_fips: 47183,
    county_name: "Weakley",
    county_weights: {
      47183: 100,
    },
    county_names_all: "Weakley",
    county_fips_all: 47183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38242,
    lat: 36.3076,
    lng: -88.33244,
    city: "Paris",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20274,
    density: 44.6,
    county_fips: 47079,
    county_name: "Henry",
    county_weights: {
      47079: 93.6,
      47183: 6.4,
    },
    county_names_all: "Henry|Weakley",
    county_fips_all: "47079|47183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38251,
    lat: 36.44636,
    lng: -88.3539,
    city: "Puryear",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3225,
    density: 13.9,
    county_fips: 47079,
    county_name: "Henry",
    county_weights: {
      47079: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 47079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38253,
    lat: 36.29821,
    lng: -89.05822,
    city: "Rives",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1180,
    density: 8.6,
    county_fips: 47131,
    county_name: "Obion",
    county_weights: {
      47131: 100,
    },
    county_names_all: "Obion",
    county_fips_all: 47131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38254,
    lat: 36.37444,
    lng: -89.34662,
    city: "Samburg",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 70,
    density: 45.4,
    county_fips: 47131,
    county_name: "Obion",
    county_weights: {
      47131: 100,
    },
    county_names_all: "Obion",
    county_fips_all: 47131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38255,
    lat: 36.23954,
    lng: -88.86483,
    city: "Sharon",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2478,
    density: 19.4,
    county_fips: 47183,
    county_name: "Weakley",
    county_weights: {
      47131: 2.63,
      47183: 97.37,
    },
    county_names_all: "Weakley|Obion",
    county_fips_all: "47183|47131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38256,
    lat: 36.31388,
    lng: -88.12539,
    city: "Springville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3316,
    density: 18.9,
    county_fips: 47079,
    county_name: "Henry",
    county_weights: {
      47079: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 47079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38257,
    lat: 36.46386,
    lng: -88.88397,
    city: "South Fulton",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4310,
    density: 30,
    county_fips: 47131,
    county_name: "Obion",
    county_weights: {
      47131: 85.93,
      47183: 14.07,
    },
    county_names_all: "Obion|Weakley",
    county_fips_all: "47131|47183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38258,
    lat: 36.02094,
    lng: -88.61188,
    city: "Trezevant",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1430,
    density: 17.1,
    county_fips: 47017,
    county_name: "Carroll",
    county_weights: {
      47017: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 47017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38259,
    lat: 36.20204,
    lng: -89.18439,
    city: "Trimble",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 815,
    density: 11.4,
    county_fips: 47131,
    county_name: "Obion",
    county_weights: {
      47045: 36.77,
      47053: 12.38,
      47131: 50.85,
    },
    county_names_all: "Obion|Dyer|Gibson",
    county_fips_all: "47131|47045|47053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38260,
    lat: 36.36961,
    lng: -89.21128,
    city: "Troy",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3652,
    density: 19.7,
    county_fips: 47131,
    county_name: "Obion",
    county_weights: {
      47131: 100,
    },
    county_names_all: "Obion",
    county_fips_all: 47131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38261,
    lat: 36.43214,
    lng: -89.11583,
    city: "Union City",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15511,
    density: 33.9,
    county_fips: 47131,
    county_name: "Obion",
    county_weights: {
      47131: 99.65,
      47183: 0.35,
    },
    county_names_all: "Obion|Weakley",
    county_fips_all: "47131|47183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38301,
    lat: 35.5908,
    lng: -88.8531,
    city: "Jackson",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34534,
    density: 88.4,
    county_fips: 47113,
    county_name: "Madison",
    county_weights: {
      47113: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 47113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38305,
    lat: 35.70108,
    lng: -88.76779,
    city: "Jackson",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52092,
    density: 157.1,
    county_fips: 47113,
    county_name: "Madison",
    county_weights: {
      47017: 2.66,
      47113: 97.34,
    },
    county_names_all: "Madison|Carroll",
    county_fips_all: "47113|47017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38310,
    lat: 35.26175,
    lng: -88.39832,
    city: "Adamsville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6135,
    density: 23.1,
    county_fips: 47109,
    county_name: "McNairy",
    county_weights: {
      47071: 31.22,
      47109: 68.78,
    },
    county_names_all: "McNairy|Hardin",
    county_fips_all: "47109|47071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38311,
    lat: 35.43842,
    lng: -88.09737,
    city: "Bath Springs",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 907,
    density: 6.3,
    county_fips: 47039,
    county_name: "Decatur",
    county_weights: {
      47039: 100,
    },
    county_names_all: "Decatur",
    county_fips_all: 47039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38313,
    lat: 35.60107,
    lng: -88.62541,
    city: "Beech Bluff",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3533,
    density: 18,
    county_fips: 47113,
    county_name: "Madison",
    county_weights: {
      47023: 22.07,
      47077: 22.31,
      47113: 55.62,
    },
    county_names_all: "Madison|Henderson|Chester",
    county_fips_all: "47113|47077|47023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38315,
    lat: 35.26918,
    lng: -88.6241,
    city: "Bethel Springs",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4044,
    density: 14,
    county_fips: 47109,
    county_name: "McNairy",
    county_weights: {
      47023: 9.03,
      47109: 90.97,
    },
    county_names_all: "McNairy|Chester",
    county_fips_all: "47109|47023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38316,
    lat: 36.06873,
    lng: -88.81547,
    city: "Bradford",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3031,
    density: 18.6,
    county_fips: 47053,
    county_name: "Gibson",
    county_weights: {
      47053: 100,
    },
    county_names_all: "Gibson",
    county_fips_all: 47053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38317,
    lat: 36.05425,
    lng: -88.26965,
    city: "Bruceton",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2556,
    density: 25.4,
    county_fips: 47017,
    county_name: "Carroll",
    county_weights: {
      47005: 6.09,
      47017: 93.91,
    },
    county_names_all: "Carroll|Benton",
    county_fips_all: "47017|47005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38318,
    lat: 35.95687,
    lng: -88.26189,
    city: "Buena Vista",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 398,
    density: 3.6,
    county_fips: 47017,
    county_name: "Carroll",
    county_weights: {
      47017: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 47017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38320,
    lat: 36.04764,
    lng: -88.1095,
    city: "Camden",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10593,
    density: 27.9,
    county_fips: 47005,
    county_name: "Benton",
    county_weights: {
      47005: 100,
    },
    county_names_all: "Benton",
    county_fips_all: 47005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38321,
    lat: 35.83341,
    lng: -88.53013,
    city: "Cedar Grove",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2330,
    density: 9.8,
    county_fips: 47017,
    county_name: "Carroll",
    county_weights: {
      47017: 57.92,
      47077: 42.08,
    },
    county_names_all: "Carroll|Henderson",
    county_fips_all: "47017|47077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38326,
    lat: 35.04419,
    lng: -88.27514,
    city: "Counce",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2804,
    density: 25.4,
    county_fips: 47071,
    county_name: "Hardin",
    county_weights: {
      28141: 1.3,
      47071: 98.7,
    },
    county_names_all: "Hardin|Tishomingo",
    county_fips_all: "47071|28141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38327,
    lat: 35.22348,
    lng: -88.30085,
    city: "Crump",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 427,
    density: 66.2,
    county_fips: 47071,
    county_name: "Hardin",
    county_weights: {
      47071: 100,
    },
    county_names_all: "Hardin",
    county_fips_all: 47071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38328,
    lat: 35.67601,
    lng: -88.21222,
    city: "Darden",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 913,
    density: 11.8,
    county_fips: 47077,
    county_name: "Henderson",
    county_weights: {
      47039: 15.65,
      47077: 84.35,
    },
    county_names_all: "Henderson|Decatur",
    county_fips_all: "47077|47039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38329,
    lat: 35.54541,
    lng: -88.11283,
    city: "Decaturville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3255,
    density: 11.5,
    county_fips: 47039,
    county_name: "Decatur",
    county_weights: {
      47039: 94.68,
      47077: 5.32,
    },
    county_names_all: "Decatur|Henderson",
    county_fips_all: "47039|47077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38330,
    lat: 36.0675,
    lng: -89.03316,
    city: "Dyer",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4338,
    density: 25.5,
    county_fips: 47053,
    county_name: "Gibson",
    county_weights: {
      47053: 100,
    },
    county_names_all: "Gibson",
    county_fips_all: 47053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38332,
    lat: 35.41978,
    lng: -88.42934,
    city: "Enville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1203,
    density: 8.8,
    county_fips: 47023,
    county_name: "Chester",
    county_weights: {
      47023: 86.91,
      47109: 13.09,
    },
    county_names_all: "Chester|McNairy",
    county_fips_all: "47023|47109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38333,
    lat: 36.12236,
    lng: -87.9709,
    city: "Eva",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 162,
    density: 2.5,
    county_fips: 47005,
    county_name: "Benton",
    county_weights: {
      47005: 100,
    },
    county_names_all: "Benton",
    county_fips_all: 47005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38334,
    lat: 35.35342,
    lng: -88.58977,
    city: "Finger",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2052,
    density: 16.6,
    county_fips: 47109,
    county_name: "McNairy",
    county_weights: {
      47023: 29.86,
      47109: 70.14,
    },
    county_names_all: "McNairy|Chester",
    county_fips_all: "47109|47023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38337,
    lat: 35.78515,
    lng: -89.01149,
    city: "Gadsden",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1556,
    density: 22.5,
    county_fips: 47033,
    county_name: "Crockett",
    county_weights: {
      47033: 100,
    },
    county_names_all: "Crockett",
    county_fips_all: 47033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38338,
    lat: 35.87483,
    lng: -88.84863,
    city: "Gibson",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 47053,
    county_name: "Gibson",
    county_weights: {
      47053: 100,
    },
    county_names_all: "Gibson",
    county_fips_all: 47053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38339,
    lat: 35.0524,
    lng: -88.5147,
    city: "Guys",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 674,
    density: 13.1,
    county_fips: 47109,
    county_name: "McNairy",
    county_weights: {
      47109: 100,
    },
    county_names_all: "McNairy",
    county_fips_all: 47109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38340,
    lat: 35.40021,
    lng: -88.68226,
    city: "Henderson",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12379,
    density: 27.5,
    county_fips: 47023,
    county_name: "Chester",
    county_weights: {
      47023: 87.74,
      47069: 12.16,
      47109: 0.1,
    },
    county_names_all: "Chester|Hardeman|McNairy",
    county_fips_all: "47023|47069|47109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38341,
    lat: 35.87677,
    lng: -88.08888,
    city: "Holladay",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2302,
    density: 6.6,
    county_fips: 47005,
    county_name: "Benton",
    county_weights: {
      47005: 77.08,
      47017: 2.03,
      47039: 20.89,
    },
    county_names_all: "Benton|Decatur|Carroll",
    county_fips_all: "47005|47039|47017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38342,
    lat: 36.10766,
    lng: -88.29024,
    city: "Hollow Rock",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1387,
    density: 15.9,
    county_fips: 47017,
    county_name: "Carroll",
    county_weights: {
      47017: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 47017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38343,
    lat: 35.82727,
    lng: -88.92819,
    city: "Humboldt",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15438,
    density: 42,
    county_fips: 47053,
    county_name: "Gibson",
    county_weights: {
      47033: 21.32,
      47053: 60.97,
      47113: 17.71,
    },
    county_names_all: "Gibson|Crockett|Madison",
    county_fips_all: "47053|47033|47113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38344,
    lat: 35.97716,
    lng: -88.43066,
    city: "Huntingdon",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7868,
    density: 18.3,
    county_fips: 47017,
    county_name: "Carroll",
    county_weights: {
      47017: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 47017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38345,
    lat: 35.59109,
    lng: -88.51163,
    city: "Huron",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1723,
    density: 13.5,
    county_fips: 47077,
    county_name: "Henderson",
    county_weights: {
      47077: 100,
    },
    county_names_all: "Henderson",
    county_fips_all: 47077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38347,
    lat: 35.47632,
    lng: -88.49846,
    city: "Jacks Creek",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 157,
    density: 13.8,
    county_fips: 47023,
    county_name: "Chester",
    county_weights: {
      47023: 100,
    },
    county_names_all: "Chester",
    county_fips_all: 47023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38348,
    lat: 35.86893,
    lng: -88.65198,
    city: "Lavinia",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 887,
    density: 6.3,
    county_fips: 47017,
    county_name: "Carroll",
    county_weights: {
      47017: 98.66,
      47113: 1.34,
    },
    county_names_all: "Carroll|Madison",
    county_fips_all: "47017|47113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38351,
    lat: 35.66324,
    lng: -88.40401,
    city: "Lexington",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18050,
    density: 33.5,
    county_fips: 47077,
    county_name: "Henderson",
    county_weights: {
      47077: 99.43,
      47113: 0.57,
    },
    county_names_all: "Henderson|Madison",
    county_fips_all: "47077|47113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38352,
    lat: 35.53037,
    lng: -88.53308,
    city: "Luray",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 562,
    density: 12,
    county_fips: 47023,
    county_name: "Chester",
    county_weights: {
      47023: 67.73,
      47077: 32.27,
    },
    county_names_all: "Chester|Henderson",
    county_fips_all: "47023|47077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38355,
    lat: 35.78637,
    lng: -88.76942,
    city: "Medina",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7041,
    density: 72.7,
    county_fips: 47113,
    county_name: "Madison",
    county_weights: {
      47053: 36.82,
      47113: 63.18,
    },
    county_names_all: "Madison|Gibson",
    county_fips_all: "47113|47053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38356,
    lat: 35.43877,
    lng: -88.89029,
    city: "Medon",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2736,
    density: 13.6,
    county_fips: 47113,
    county_name: "Madison",
    county_weights: {
      47023: 6.52,
      47069: 35.58,
      47113: 57.9,
    },
    county_names_all: "Madison|Hardeman|Chester",
    county_fips_all: "47113|47069|47023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38357,
    lat: 35.04888,
    lng: -88.4112,
    city: "Michie",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2813,
    density: 16.5,
    county_fips: 47109,
    county_name: "McNairy",
    county_weights: {
      47071: 24.82,
      47109: 75.18,
    },
    county_names_all: "McNairy|Hardin",
    county_fips_all: "47109|47071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38358,
    lat: 35.91661,
    lng: -88.75934,
    city: "Milan",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11619,
    density: 54.3,
    county_fips: 47053,
    county_name: "Gibson",
    county_weights: {
      47053: 100,
    },
    county_names_all: "Gibson",
    county_fips_all: 47053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38359,
    lat: 35.37222,
    lng: -88.35109,
    city: "Milledgeville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 298,
    density: 18.9,
    county_fips: 47071,
    county_name: "Hardin",
    county_weights: {
      47023: 3.67,
      47071: 81.75,
      47109: 14.58,
    },
    county_names_all: "Hardin|McNairy|Chester",
    county_fips_all: "47071|47109|47023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38361,
    lat: 35.31897,
    lng: -88.29232,
    city: "Morris Chapel",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1001,
    density: 8.6,
    county_fips: 47071,
    county_name: "Hardin",
    county_weights: {
      47071: 91.91,
      47109: 8.09,
    },
    county_names_all: "Hardin|McNairy",
    county_fips_all: "47071|47109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38362,
    lat: 35.72696,
    lng: -88.78508,
    city: "Oakfield",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1167,
    density: 52.1,
    county_fips: 47113,
    county_name: "Madison",
    county_weights: {
      47113: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 47113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38363,
    lat: 35.68625,
    lng: -88.11051,
    city: "Parsons",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5326,
    density: 23.8,
    county_fips: 47039,
    county_name: "Decatur",
    county_weights: {
      47039: 96.09,
      47077: 3.91,
    },
    county_names_all: "Decatur|Henderson",
    county_fips_all: "47039|47077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38365,
    lat: 35.05383,
    lng: -88.23627,
    city: "Pickwick Dam",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 47071,
    county_name: "Hardin",
    county_weights: {
      47071: 100,
    },
    county_names_all: "Hardin",
    county_fips_all: 47071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38366,
    lat: 35.47797,
    lng: -88.74461,
    city: "Pinson",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1877,
    density: 15.3,
    county_fips: 47113,
    county_name: "Madison",
    county_weights: {
      47023: 27.07,
      47113: 72.93,
    },
    county_names_all: "Madison|Chester",
    county_fips_all: "47113|47023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38367,
    lat: 35.05266,
    lng: -88.62728,
    city: "Ramer",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2730,
    density: 13.8,
    county_fips: 47109,
    county_name: "McNairy",
    county_weights: {
      47109: 100,
    },
    county_names_all: "McNairy",
    county_fips_all: 47109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38368,
    lat: 35.50191,
    lng: -88.35659,
    city: "Reagan",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2154,
    density: 15.8,
    county_fips: 47077,
    county_name: "Henderson",
    county_weights: {
      47023: 17.31,
      47077: 82.69,
    },
    county_names_all: "Henderson|Chester",
    county_fips_all: "47077|47023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38369,
    lat: 36.13253,
    lng: -88.9652,
    city: "Rutherford",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1466,
    density: 14.1,
    county_fips: 47053,
    county_name: "Gibson",
    county_weights: {
      47053: 100,
    },
    county_names_all: "Gibson",
    county_fips_all: 47053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38370,
    lat: 35.38942,
    lng: -88.2465,
    city: "Saltillo",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 772,
    density: 13.7,
    county_fips: 47071,
    county_name: "Hardin",
    county_weights: {
      47039: 0.1,
      47071: 88.4,
      47077: 11.5,
    },
    county_names_all: "Hardin|Henderson|Decatur",
    county_fips_all: "47071|47077|47039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38371,
    lat: 35.42346,
    lng: -88.2967,
    city: "Sardis",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 951,
    density: 8.6,
    county_fips: 47077,
    county_name: "Henderson",
    county_weights: {
      47039: 4.09,
      47071: 42.52,
      47077: 53.39,
    },
    county_names_all: "Henderson|Hardin|Decatur",
    county_fips_all: "47077|47071|47039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38372,
    lat: 35.16516,
    lng: -88.14523,
    city: "Savannah",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17192,
    density: 21.5,
    county_fips: 47071,
    county_name: "Hardin",
    county_weights: {
      47071: 100,
    },
    county_names_all: "Hardin",
    county_fips_all: 47071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38374,
    lat: 35.51192,
    lng: -88.23469,
    city: "Scotts Hill",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2373,
    density: 20.4,
    county_fips: 47039,
    county_name: "Decatur",
    county_weights: {
      47039: 51.42,
      47077: 48.58,
    },
    county_names_all: "Decatur|Henderson",
    county_fips_all: "47039|47077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38375,
    lat: 35.16142,
    lng: -88.58811,
    city: "Selmer",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8088,
    density: 27.7,
    county_fips: 47109,
    county_name: "McNairy",
    county_weights: {
      47109: 100,
    },
    county_names_all: "McNairy",
    county_fips_all: 47109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38376,
    lat: 35.12974,
    lng: -88.34447,
    city: "Shiloh",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 133,
    density: 4,
    county_fips: 47071,
    county_name: "Hardin",
    county_weights: {
      47071: 96.07,
      47109: 3.93,
    },
    county_names_all: "Hardin|McNairy",
    county_fips_all: "47071|47109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38379,
    lat: 35.16388,
    lng: -88.42825,
    city: "Stantonville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1459,
    density: 16.5,
    county_fips: 47109,
    county_name: "McNairy",
    county_weights: {
      47071: 9.58,
      47109: 90.42,
    },
    county_names_all: "McNairy|Hardin",
    county_fips_all: "47109|47071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38380,
    lat: 35.79114,
    lng: -88.03263,
    city: "Sugar Tree",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 505,
    density: 5.1,
    county_fips: 47039,
    county_name: "Decatur",
    county_weights: {
      47005: 12.34,
      47039: 87.66,
    },
    county_names_all: "Decatur|Benton",
    county_fips_all: "47039|47005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38381,
    lat: 35.35144,
    lng: -88.96205,
    city: "Toone",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1416,
    density: 9.6,
    county_fips: 47069,
    county_name: "Hardeman",
    county_weights: {
      47069: 100,
    },
    county_names_all: "Hardeman",
    county_fips_all: 47069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38382,
    lat: 35.96925,
    lng: -88.99186,
    city: "Trenton",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8559,
    density: 19.3,
    county_fips: 47053,
    county_name: "Gibson",
    county_weights: {
      47053: 100,
    },
    county_names_all: "Gibson",
    county_fips_all: 47053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38387,
    lat: 35.86573,
    lng: -88.26968,
    city: "Westport",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 209,
    density: 1.9,
    county_fips: 47017,
    county_name: "Carroll",
    county_weights: {
      47005: 10.75,
      47017: 89.25,
    },
    county_names_all: "Carroll|Benton",
    county_fips_all: "47017|47005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38388,
    lat: 35.77672,
    lng: -88.31535,
    city: "Wildersville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1956,
    density: 10.5,
    county_fips: 47077,
    county_name: "Henderson",
    county_weights: {
      47039: 0.66,
      47077: 99.34,
    },
    county_names_all: "Henderson|Decatur",
    county_fips_all: "47077|47039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38389,
    lat: 36.10315,
    lng: -89.12134,
    city: "Yorkville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 47053,
    county_name: "Gibson",
    county_weights: {
      47053: 100,
    },
    county_names_all: "Gibson",
    county_fips_all: 47053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38390,
    lat: 35.83845,
    lng: -88.37797,
    city: "Yuma",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1195,
    density: 15.1,
    county_fips: 47017,
    county_name: "Carroll",
    county_weights: {
      47017: 80.74,
      47077: 19.26,
    },
    county_names_all: "Carroll|Henderson",
    county_fips_all: "47017|47077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38391,
    lat: 35.55026,
    lng: -88.99033,
    city: "Denmark",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1088,
    density: 6.2,
    county_fips: 47113,
    county_name: "Madison",
    county_weights: {
      47113: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 47113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38392,
    lat: 35.45908,
    lng: -89.03709,
    city: "Mercer",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 709,
    density: 7.6,
    county_fips: 47113,
    county_name: "Madison",
    county_weights: {
      47069: 25.53,
      47113: 74.47,
    },
    county_names_all: "Madison|Hardeman",
    county_fips_all: "47113|47069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38401,
    lat: 35.62955,
    lng: -87.02097,
    city: "Columbia",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64822,
    density: 84.4,
    county_fips: 47119,
    county_name: "Maury",
    county_weights: {
      47117: 1.83,
      47119: 96.07,
      47187: 2.1,
    },
    county_names_all: "Maury|Williamson|Marshall",
    county_fips_all: "47119|47187|47117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38425,
    lat: 35.40706,
    lng: -87.96588,
    city: "Clifton",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3803,
    density: 14.2,
    county_fips: 47181,
    county_name: "Wayne",
    county_weights: {
      47071: 26.49,
      47135: 14.68,
      47181: 58.83,
    },
    county_names_all: "Wayne|Hardin|Perry",
    county_fips_all: "47181|47071|47135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38449,
    lat: 35.05231,
    lng: -86.82954,
    city: "Ardmore",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2713,
    density: 17.9,
    county_fips: 47103,
    county_name: "Lincoln",
    county_weights: {
      47055: 47.38,
      47103: 52.62,
    },
    county_names_all: "Lincoln|Giles",
    county_fips_all: "47103|47055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38450,
    lat: 35.18523,
    lng: -87.80143,
    city: "Collinwood",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3130,
    density: 11.4,
    county_fips: 47181,
    county_name: "Wayne",
    county_weights: {
      47181: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 47181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38451,
    lat: 35.46706,
    lng: -86.99573,
    city: "Culleoka",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4107,
    density: 18.9,
    county_fips: 47119,
    county_name: "Maury",
    county_weights: {
      47055: 2.09,
      47117: 16.84,
      47119: 81.07,
    },
    county_names_all: "Maury|Marshall|Giles",
    county_fips_all: "47119|47117|47055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38452,
    lat: 35.07898,
    lng: -87.79239,
    city: "Cypress Inn",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 945,
    density: 6.9,
    county_fips: 47181,
    county_name: "Wayne",
    county_weights: {
      47181: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 47181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38453,
    lat: 35.11923,
    lng: -86.81472,
    city: "Dellrose",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 373,
    density: 8.3,
    county_fips: 47103,
    county_name: "Lincoln",
    county_weights: {
      47055: 24.24,
      47103: 75.76,
    },
    county_names_all: "Lincoln|Giles",
    county_fips_all: "47103|47055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38454,
    lat: 35.72334,
    lng: -87.35538,
    city: "Duck River",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1128,
    density: 7.4,
    county_fips: 47081,
    county_name: "Hickman",
    county_weights: {
      47081: 100,
    },
    county_names_all: "Hickman",
    county_fips_all: 47081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38455,
    lat: 35.06199,
    lng: -86.89366,
    city: "Elkton",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 47055,
    county_name: "Giles",
    county_weights: {
      47055: 100,
    },
    county_names_all: "Giles",
    county_fips_all: 47055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38456,
    lat: 35.33464,
    lng: -87.26559,
    city: "Ethridge",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4997,
    density: 27.8,
    county_fips: 47099,
    county_name: "Lawrence",
    county_weights: {
      47055: 29.36,
      47099: 70.64,
    },
    county_names_all: "Lawrence|Giles",
    county_fips_all: "47099|47055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38457,
    lat: 35.0297,
    lng: -87.28482,
    city: "Five Points",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 780,
    density: 11.4,
    county_fips: 47099,
    county_name: "Lawrence",
    county_weights: {
      47099: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 47099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38459,
    lat: 35.19135,
    lng: -86.80219,
    city: "Frankewing",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 296,
    density: 5.5,
    county_fips: 47103,
    county_name: "Lincoln",
    county_weights: {
      47055: 10.9,
      47103: 89.1,
    },
    county_names_all: "Lincoln|Giles",
    county_fips_all: "47103|47055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38460,
    lat: 35.10116,
    lng: -87.15937,
    city: "Goodspring",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1713,
    density: 25.1,
    county_fips: 47055,
    county_name: "Giles",
    county_weights: {
      47055: 100,
    },
    county_names_all: "Giles",
    county_fips_all: 47055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38461,
    lat: 35.59514,
    lng: -87.33987,
    city: "Hampshire",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1240,
    density: 6.6,
    county_fips: 47101,
    county_name: "Lewis",
    county_weights: {
      47081: 1.66,
      47101: 56.86,
      47119: 41.48,
    },
    county_names_all: "Lewis|Maury|Hickman",
    county_fips_all: "47101|47119|47081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38462,
    lat: 35.53142,
    lng: -87.54869,
    city: "Hohenwald",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10204,
    density: 20.4,
    county_fips: 47101,
    county_name: "Lewis",
    county_weights: {
      47081: 1.68,
      47101: 98.32,
    },
    county_names_all: "Lewis|Hickman",
    county_fips_all: "47101|47081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38463,
    lat: 35.06802,
    lng: -87.64494,
    city: "Iron City",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2205,
    density: 7.4,
    county_fips: 47181,
    county_name: "Wayne",
    county_weights: {
      47099: 22.84,
      47181: 77.16,
    },
    county_names_all: "Wayne|Lawrence",
    county_fips_all: "47181|47099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38464,
    lat: 35.29035,
    lng: -87.42845,
    city: "Lawrenceburg",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22412,
    density: 32.1,
    county_fips: 47099,
    county_name: "Lawrence",
    county_weights: {
      47055: 6.28,
      47099: 81.24,
      47101: 0.38,
      47181: 12.1,
    },
    county_names_all: "Lawrence|Wayne|Giles|Lewis",
    county_fips_all: "47099|47181|47055|47101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38468,
    lat: 35.13083,
    lng: -87.29072,
    city: "Leoma",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5738,
    density: 22.3,
    county_fips: 47099,
    county_name: "Lawrence",
    county_weights: {
      47055: 7.74,
      47099: 92.26,
    },
    county_names_all: "Lawrence|Giles",
    county_fips_all: "47099|47055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38469,
    lat: 35.0741,
    lng: -87.42765,
    city: "Loretto",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4291,
    density: 23.9,
    county_fips: 47099,
    county_name: "Lawrence",
    county_weights: {
      47099: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 47099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38471,
    lat: 35.0771,
    lng: -87.92134,
    city: "Lutts",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 403,
    density: 2.1,
    county_fips: 47181,
    county_name: "Wayne",
    county_weights: {
      47181: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 47181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38472,
    lat: 35.3773,
    lng: -87.03873,
    city: "Lynnville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2708,
    density: 10.4,
    county_fips: 47055,
    county_name: "Giles",
    county_weights: {
      47055: 96.36,
      47117: 3.64,
    },
    county_names_all: "Giles|Marshall",
    county_fips_all: "47055|47117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38473,
    lat: 35.02775,
    lng: -87.17057,
    city: "Minor Hill",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1074,
    density: 14.9,
    county_fips: 47055,
    county_name: "Giles",
    county_weights: {
      47055: 98.29,
      47099: 1.71,
    },
    county_names_all: "Giles|Lawrence",
    county_fips_all: "47055|47099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38474,
    lat: 35.51848,
    lng: -87.22966,
    city: "Mount Pleasant",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8518,
    density: 31.6,
    county_fips: 47119,
    county_name: "Maury",
    county_weights: {
      47055: 2.22,
      47099: 1.64,
      47101: 9.3,
      47119: 86.84,
    },
    county_names_all: "Maury|Lewis|Giles|Lawrence",
    county_fips_all: "47119|47101|47055|47099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38475,
    lat: 35.2624,
    lng: -88.02336,
    city: "Olivehill",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 805,
    density: 4.9,
    county_fips: 47071,
    county_name: "Hardin",
    county_weights: {
      47071: 77.53,
      47181: 22.47,
    },
    county_names_all: "Hardin|Wayne",
    county_fips_all: "47071|47181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38476,
    lat: 35.84341,
    lng: -87.20984,
    city: "Primm Springs",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1352,
    density: 12.8,
    county_fips: 47187,
    county_name: "Williamson",
    county_weights: {
      47081: 40.42,
      47119: 17.19,
      47187: 42.39,
    },
    county_names_all: "Williamson|Hickman|Maury",
    county_fips_all: "47187|47081|47119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38477,
    lat: 35.05075,
    lng: -87.00932,
    city: "Prospect",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2914,
    density: 11.5,
    county_fips: 47055,
    county_name: "Giles",
    county_weights: {
      47055: 100,
    },
    county_names_all: "Giles",
    county_fips_all: 47055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38478,
    lat: 35.21565,
    lng: -87.01329,
    city: "Pulaski",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17618,
    density: 26.5,
    county_fips: 47055,
    county_name: "Giles",
    county_weights: {
      47055: 100,
    },
    county_names_all: "Giles",
    county_fips_all: 47055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38481,
    lat: 35.02813,
    lng: -87.48863,
    city: "Saint Joseph",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1062,
    density: 39.1,
    county_fips: 47099,
    county_name: "Lawrence",
    county_weights: {
      47099: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 47099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38482,
    lat: 35.76792,
    lng: -87.14574,
    city: "Santa Fe",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1701,
    density: 14.8,
    county_fips: 47119,
    county_name: "Maury",
    county_weights: {
      47119: 100,
    },
    county_names_all: "Maury",
    county_fips_all: 47119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38483,
    lat: 35.43411,
    lng: -87.33476,
    city: "Summertown",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5933,
    density: 22.6,
    county_fips: 47099,
    county_name: "Lawrence",
    county_weights: {
      47055: 7.17,
      47099: 56.77,
      47101: 35.42,
      47119: 0.64,
    },
    county_names_all: "Lawrence|Lewis|Giles|Maury",
    county_fips_all: "47099|47101|47055|47119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38485,
    lat: 35.33281,
    lng: -87.77659,
    city: "Waynesboro",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6384,
    density: 8.7,
    county_fips: 47181,
    county_name: "Wayne",
    county_weights: {
      47101: 0.98,
      47181: 99.02,
    },
    county_names_all: "Wayne|Lewis",
    county_fips_all: "47181|47101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38486,
    lat: 35.17306,
    lng: -87.54029,
    city: "Westpoint",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1000,
    density: 4.7,
    county_fips: 47099,
    county_name: "Lawrence",
    county_weights: {
      47099: 79.6,
      47181: 20.4,
    },
    county_names_all: "Lawrence|Wayne",
    county_fips_all: "47099|47181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38487,
    lat: 35.72163,
    lng: -87.23589,
    city: "Williamsport",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 978,
    density: 7.4,
    county_fips: 47119,
    county_name: "Maury",
    county_weights: {
      47081: 34.93,
      47119: 65.07,
    },
    county_names_all: "Maury|Hickman",
    county_fips_all: "47119|47081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38488,
    lat: 35.03906,
    lng: -86.68569,
    city: "Taft",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2228,
    density: 14.8,
    county_fips: 47103,
    county_name: "Lincoln",
    county_weights: {
      47103: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 47103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38501,
    lat: 36.22682,
    lng: -85.53841,
    city: "Cookeville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39013,
    density: 173,
    county_fips: 47141,
    county_name: "Putnam",
    county_weights: {
      47087: 35.09,
      47133: 1.36,
      47141: 63.55,
    },
    county_names_all: "Putnam|Jackson|Overton",
    county_fips_all: "47141|47087|47133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38503,
    lat: 36.16333,
    lng: -85.50588,
    city: "Cookeville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 47141,
    county_name: "Putnam",
    county_weights: {
      47141: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 47141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38504,
    lat: 36.39314,
    lng: -84.73528,
    city: "Allardt",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 670,
    density: 5.7,
    county_fips: 47049,
    county_name: "Fentress",
    county_weights: {
      47049: 84.27,
      47151: 15.73,
    },
    county_names_all: "Fentress|Scott",
    county_fips_all: "47049|47151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38505,
    lat: 36.17316,
    lng: -85.50559,
    city: "Cookeville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2028,
    density: 15570.2,
    county_fips: 47141,
    county_name: "Putnam",
    county_weights: {
      47141: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 47141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38506,
    lat: 36.18334,
    lng: -85.44246,
    city: "Cookeville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28818,
    density: 67.7,
    county_fips: 47141,
    county_name: "Putnam",
    county_weights: {
      47087: 0.46,
      47133: 25.32,
      47141: 70.2,
      47185: 4.02,
    },
    county_names_all: "Putnam|Overton|White|Jackson",
    county_fips_all: "47141|47133|47185|47087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38541,
    lat: 36.52903,
    lng: -85.33767,
    city: "Allons",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1810,
    density: 13.9,
    county_fips: 47027,
    county_name: "Clay",
    county_weights: {
      47027: 57.11,
      47133: 42.89,
    },
    county_names_all: "Clay|Overton",
    county_fips_all: "47027|47133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38542,
    lat: 36.31576,
    lng: -85.20113,
    city: "Allred",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16,
    density: 2,
    county_fips: 47133,
    county_name: "Overton",
    county_weights: {
      47133: 100,
    },
    county_names_all: "Overton",
    county_fips_all: 47133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38543,
    lat: 36.37514,
    lng: -85.15931,
    city: "Alpine",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 339,
    density: 3.2,
    county_fips: 47133,
    county_name: "Overton",
    county_weights: {
      47133: 88.08,
      47137: 11.92,
    },
    county_names_all: "Overton|Pickett",
    county_fips_all: "47133|47137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38544,
    lat: 36.11605,
    lng: -85.66238,
    city: "Baxter",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7450,
    density: 36.3,
    county_fips: 47141,
    county_name: "Putnam",
    county_weights: {
      47041: 12.02,
      47141: 87.98,
    },
    county_names_all: "Putnam|DeKalb",
    county_fips_all: "47141|47041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38545,
    lat: 36.23133,
    lng: -85.65964,
    city: "Bloomington Springs",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1625,
    density: 27.3,
    county_fips: 47087,
    county_name: "Jackson",
    county_weights: {
      47087: 67.2,
      47141: 32.8,
    },
    county_names_all: "Jackson|Putnam",
    county_fips_all: "47087|47141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38547,
    lat: 36.14954,
    lng: -86.00833,
    city: "Brush Creek",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1992,
    density: 24.8,
    county_fips: 47159,
    county_name: "Smith",
    county_weights: {
      47159: 100,
    },
    county_names_all: "Smith",
    county_fips_all: 47159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38548,
    lat: 36.17252,
    lng: -85.79197,
    city: "Buffalo Valley",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1149,
    density: 15.7,
    county_fips: 47141,
    county_name: "Putnam",
    county_weights: {
      47041: 2.86,
      47141: 64.02,
      47159: 33.12,
    },
    county_names_all: "Putnam|Smith|DeKalb",
    county_fips_all: "47141|47159|47041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38549,
    lat: 36.5617,
    lng: -85.15243,
    city: "Byrdstown",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4040,
    density: 21.2,
    county_fips: 47137,
    county_name: "Pickett",
    county_weights: {
      21053: 1.85,
      47049: 4.45,
      47137: 93.7,
    },
    county_names_all: "Pickett|Fentress|Clinton",
    county_fips_all: "47137|47049|21053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38550,
    lat: 35.76982,
    lng: -85.63268,
    city: "Campaign",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 47177,
    county_name: "Warren",
    county_weights: {
      47177: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 47177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38551,
    lat: 36.55804,
    lng: -85.48699,
    city: "Celina",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4213,
    density: 18.2,
    county_fips: 47027,
    county_name: "Clay",
    county_weights: {
      47027: 97.82,
      47087: 2.18,
    },
    county_names_all: "Clay|Jackson",
    county_fips_all: "47027|47087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38552,
    lat: 36.2166,
    lng: -85.81195,
    city: "Chestnut Mound",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 253,
    density: 13.4,
    county_fips: 47159,
    county_name: "Smith",
    county_weights: {
      47159: 100,
    },
    county_names_all: "Smith",
    county_fips_all: 47159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38553,
    lat: 36.20322,
    lng: -85.00442,
    city: "Clarkrange",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2827,
    density: 22.7,
    county_fips: 47049,
    county_name: "Fentress",
    county_weights: {
      47049: 100,
    },
    county_names_all: "Fentress",
    county_fips_all: 47049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38554,
    lat: 36.25131,
    lng: -85.16095,
    city: "Crawford",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 842,
    density: 10.1,
    county_fips: 47133,
    county_name: "Overton",
    county_weights: {
      47133: 100,
    },
    county_names_all: "Overton",
    county_fips_all: 47133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38555,
    lat: 35.88956,
    lng: -84.97537,
    city: "Crossville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20371,
    density: 85.2,
    county_fips: 47035,
    county_name: "Cumberland",
    county_weights: {
      47035: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 47035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38556,
    lat: 36.41016,
    lng: -84.9249,
    city: "Jamestown",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11592,
    density: 14.2,
    county_fips: 47049,
    county_name: "Fentress",
    county_weights: {
      47049: 99.36,
      47137: 0.64,
    },
    county_names_all: "Fentress|Pickett",
    county_fips_all: "47049|47137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38558,
    lat: 36.00532,
    lng: -84.87374,
    city: "Crossville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9572,
    density: 183.3,
    county_fips: 47035,
    county_name: "Cumberland",
    county_weights: {
      47035: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 47035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38559,
    lat: 35.80692,
    lng: -85.51334,
    city: "Doyle",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1302,
    density: 25,
    county_fips: 47175,
    county_name: "Van Buren",
    county_weights: {
      47175: 69.54,
      47185: 30.46,
    },
    county_names_all: "Van Buren|White",
    county_fips_all: "47175|47185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38560,
    lat: 36.23458,
    lng: -85.8713,
    city: "Elmwood",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1491,
    density: 17.5,
    county_fips: 47159,
    county_name: "Smith",
    county_weights: {
      47159: 100,
    },
    county_names_all: "Smith",
    county_fips_all: 47159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38562,
    lat: 36.35173,
    lng: -85.65932,
    city: "Gainesboro",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6552,
    density: 18.1,
    county_fips: 47087,
    county_name: "Jackson",
    county_weights: {
      47087: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 47087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38563,
    lat: 36.19658,
    lng: -86.0147,
    city: "Gordonsville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2989,
    density: 34.8,
    county_fips: 47159,
    county_name: "Smith",
    county_weights: {
      47159: 100,
    },
    county_names_all: "Smith",
    county_fips_all: 47159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38564,
    lat: 36.27144,
    lng: -85.75364,
    city: "Granville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 477,
    density: 6.4,
    county_fips: 47087,
    county_name: "Jackson",
    county_weights: {
      47087: 90.73,
      47141: 9.27,
    },
    county_names_all: "Jackson|Putnam",
    county_fips_all: "47087|47141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38565,
    lat: 36.26296,
    lng: -85.00992,
    city: "Grimsley",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1023,
    density: 38.2,
    county_fips: 47049,
    county_name: "Fentress",
    county_weights: {
      47049: 100,
    },
    county_names_all: "Fentress",
    county_fips_all: 47049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38567,
    lat: 36.13392,
    lng: -85.91518,
    city: "Hickman",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 723,
    density: 13.5,
    county_fips: 47159,
    county_name: "Smith",
    county_weights: {
      47041: 12.42,
      47159: 87.58,
    },
    county_names_all: "Smith|DeKalb",
    county_fips_all: "47159|47041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38568,
    lat: 36.43594,
    lng: -85.46907,
    city: "Hilham",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1807,
    density: 10.3,
    county_fips: 47133,
    county_name: "Overton",
    county_weights: {
      47027: 37.16,
      47087: 9.71,
      47133: 53.13,
    },
    county_names_all: "Overton|Clay|Jackson",
    county_fips_all: "47133|47027|47087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38569,
    lat: 36.10887,
    lng: -85.85647,
    city: "Lancaster",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 197,
    density: 5.7,
    county_fips: 47159,
    county_name: "Smith",
    county_weights: {
      47041: 47.01,
      47159: 52.99,
    },
    county_names_all: "Smith|DeKalb",
    county_fips_all: "47159|47041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38570,
    lat: 36.37678,
    lng: -85.31983,
    city: "Livingston",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9802,
    density: 31.8,
    county_fips: 47133,
    county_name: "Overton",
    county_weights: {
      47133: 100,
    },
    county_names_all: "Overton",
    county_fips_all: 47133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38571,
    lat: 36.0513,
    lng: -85.01374,
    city: "Crossville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14180,
    density: 24.1,
    county_fips: 47035,
    county_name: "Cumberland",
    county_weights: {
      47035: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 47035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38572,
    lat: 35.84764,
    lng: -85.12778,
    city: "Crossville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11123,
    density: 27.1,
    county_fips: 47035,
    county_name: "Cumberland",
    county_weights: {
      47007: 8.59,
      47035: 91.41,
    },
    county_names_all: "Cumberland|Bledsoe",
    county_fips_all: "47035|47007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38573,
    lat: 36.48945,
    lng: -85.21931,
    city: "Monroe",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1872,
    density: 10.8,
    county_fips: 47133,
    county_name: "Overton",
    county_weights: {
      47027: 1.59,
      47133: 61.66,
      47137: 36.75,
    },
    county_names_all: "Overton|Pickett|Clay",
    county_fips_all: "47133|47137|47027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38574,
    lat: 36.141,
    lng: -85.22498,
    city: "Monterey",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9093,
    density: 20.7,
    county_fips: 47141,
    county_name: "Putnam",
    county_weights: {
      47035: 13.84,
      47049: 4.6,
      47133: 32.93,
      47141: 48.63,
    },
    county_names_all: "Putnam|Overton|Cumberland|Fentress",
    county_fips_all: "47141|47133|47035|47049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38575,
    lat: 36.55848,
    lng: -85.63515,
    city: "Moss",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1097,
    density: 8.8,
    county_fips: 47027,
    county_name: "Clay",
    county_weights: {
      47027: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 47027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38577,
    lat: 36.56453,
    lng: -84.94651,
    city: "Pall Mall",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1661,
    density: 7.3,
    county_fips: 47137,
    county_name: "Pickett",
    county_weights: {
      47049: 43.05,
      47137: 56.95,
    },
    county_names_all: "Pickett|Fentress",
    county_fips_all: "47137|47049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38578,
    lat: 35.98031,
    lng: -85.19886,
    city: "Pleasant Hill",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 174,
    density: 203.4,
    county_fips: 47035,
    county_name: "Cumberland",
    county_weights: {
      47035: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 47035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38579,
    lat: 35.83218,
    lng: -85.54919,
    city: "Quebeck",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1286,
    density: 27.1,
    county_fips: 47185,
    county_name: "White",
    county_weights: {
      47185: 100,
    },
    county_names_all: "White",
    county_fips_all: 47185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38580,
    lat: 36.27729,
    lng: -85.29522,
    city: "Rickman",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1731,
    density: 19.2,
    county_fips: 47133,
    county_name: "Overton",
    county_weights: {
      47133: 100,
    },
    county_names_all: "Overton",
    county_fips_all: 47133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38581,
    lat: 35.73834,
    lng: -85.62141,
    city: "Rock Island",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3850,
    density: 15.2,
    county_fips: 47177,
    county_name: "Warren",
    county_weights: {
      47041: 1.42,
      47175: 44.91,
      47177: 53.67,
    },
    county_names_all: "Warren|Van Buren|DeKalb",
    county_fips_all: "47177|47175|47041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38582,
    lat: 36.09431,
    lng: -85.75382,
    city: "Silver Point",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1733,
    density: 14.5,
    county_fips: 47141,
    county_name: "Putnam",
    county_weights: {
      47041: 47.24,
      47141: 52.76,
    },
    county_names_all: "Putnam|DeKalb",
    county_fips_all: "47141|47041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38583,
    lat: 35.94649,
    lng: -85.43781,
    city: "Sparta",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24906,
    density: 26.4,
    county_fips: 47185,
    county_name: "White",
    county_weights: {
      47035: 4.88,
      47041: 5.87,
      47141: 5.59,
      47175: 2.36,
      47185: 81.3,
    },
    county_names_all: "White|DeKalb|Putnam|Cumberland|Van Buren",
    county_fips_all: "47185|47041|47141|47035|47175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38585,
    lat: 35.68995,
    lng: -85.42274,
    city: "Spencer",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4461,
    density: 9.3,
    county_fips: 47175,
    county_name: "Van Buren",
    county_weights: {
      47153: 2.28,
      47175: 97.72,
    },
    county_names_all: "Van Buren|Sequatchie",
    county_fips_all: "47175|47153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38587,
    lat: 35.8677,
    lng: -85.61723,
    city: "Walling",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1037,
    density: 13.4,
    county_fips: 47185,
    county_name: "White",
    county_weights: {
      47185: 100,
    },
    county_names_all: "White",
    county_fips_all: 47185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38588,
    lat: 36.45613,
    lng: -85.7189,
    city: "Whitleyville",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 922,
    density: 4.1,
    county_fips: 47087,
    county_name: "Jackson",
    county_weights: {
      47027: 12.47,
      47087: 84.92,
      47111: 2.61,
    },
    county_names_all: "Jackson|Clay|Macon",
    county_fips_all: "47087|47027|47111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38589,
    lat: 36.28551,
    lng: -85.07624,
    city: "Wilder",
    state_id: "TN",
    state_name: "Tennessee",
    zcta: "TRUE",
    parent_zcta: "",
    population: 241,
    density: 3.1,
    county_fips: 47049,
    county_name: "Fentress",
    county_weights: {
      47049: 90.74,
      47133: 9.26,
    },
    county_names_all: "Fentress|Overton",
    county_fips_all: "47049|47133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38601,
    lat: 34.48146,
    lng: -89.45166,
    city: "Abbeville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1857,
    density: 8.2,
    county_fips: 28071,
    county_name: "Lafayette",
    county_weights: {
      28071: 100,
    },
    county_names_all: "Lafayette",
    county_fips_all: 28071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38603,
    lat: 34.83949,
    lng: -89.14163,
    city: "Ashland",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2715,
    density: 7.7,
    county_fips: 28009,
    county_name: "Benton",
    county_weights: {
      28009: 96,
      28139: 4,
    },
    county_names_all: "Benton|Tippah",
    county_fips_all: "28009|28139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38606,
    lat: 34.30375,
    lng: -89.9581,
    city: "Batesville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15538,
    density: 23.9,
    county_fips: 28107,
    county_name: "Panola",
    county_weights: {
      28071: 1.44,
      28107: 95.81,
      28119: 2.75,
    },
    county_names_all: "Panola|Quitman|Lafayette",
    county_fips_all: "28107|28119|28071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38610,
    lat: 34.65357,
    lng: -89.02637,
    city: "Blue Mountain",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3324,
    density: 13.5,
    county_fips: 28139,
    county_name: "Tippah",
    county_weights: {
      28009: 15.58,
      28139: 72.62,
      28145: 11.8,
    },
    county_names_all: "Tippah|Benton|Union",
    county_fips_all: "28139|28009|28145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38611,
    lat: 34.85467,
    lng: -89.67116,
    city: "Byhalia",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16885,
    density: 34,
    county_fips: 28093,
    county_name: "Marshall",
    county_weights: {
      28033: 18.71,
      28093: 81.29,
    },
    county_names_all: "Marshall|DeSoto",
    county_fips_all: "28093|28033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38614,
    lat: 34.15914,
    lng: -90.60747,
    city: "Clarksdale",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17353,
    density: 27.6,
    county_fips: 28027,
    county_name: "Coahoma",
    county_weights: {
      28011: 3.06,
      28027: 96.94,
    },
    county_names_all: "Coahoma|Bolivar",
    county_fips_all: "28027|28011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38617,
    lat: 34.36261,
    lng: -90.49342,
    city: "Coahoma",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 495,
    density: 2.2,
    county_fips: 28027,
    county_name: "Coahoma",
    county_weights: {
      28027: 99.14,
      28119: 0.86,
    },
    county_names_all: "Coahoma|Quitman",
    county_fips_all: "28027|28119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38618,
    lat: 34.70203,
    lng: -89.93415,
    city: "Coldwater",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11091,
    density: 21.6,
    county_fips: 28137,
    county_name: "Tate",
    county_weights: {
      28033: 2.29,
      28093: 0.71,
      28137: 97,
    },
    county_names_all: "Tate|DeSoto|Marshall",
    county_fips_all: "28137|28033|28093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38619,
    lat: 34.51288,
    lng: -89.82678,
    city: "Como",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4721,
    density: 12.8,
    county_fips: 28107,
    county_name: "Panola",
    county_weights: {
      28071: 25.1,
      28107: 70.11,
      28137: 4.79,
    },
    county_names_all: "Panola|Lafayette|Tate",
    county_fips_all: "28107|28071|28137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38620,
    lat: 34.23206,
    lng: -89.9156,
    city: "Courtland",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3416,
    density: 22.4,
    county_fips: 28107,
    county_name: "Panola",
    county_weights: {
      28107: 100,
    },
    county_names_all: "Panola",
    county_fips_all: 28107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38621,
    lat: 34.4528,
    lng: -90.1731,
    city: "Crenshaw",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2107,
    density: 13.2,
    county_fips: 28107,
    county_name: "Panola",
    county_weights: {
      28107: 79.99,
      28119: 20.01,
    },
    county_names_all: "Panola|Quitman",
    county_fips_all: "28107|28119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38622,
    lat: 34.16944,
    lng: -90.13448,
    city: "Crowder",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 810,
    density: 348.1,
    county_fips: 28107,
    county_name: "Panola",
    county_weights: {
      28107: 59.59,
      28119: 40.21,
      28135: 0.2,
    },
    county_names_all: "Panola|Quitman|Tallahatchie",
    county_fips_all: "28107|28119|28135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38623,
    lat: 34.36131,
    lng: -90.29692,
    city: "Darling",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 224,
    density: 12.8,
    county_fips: 28119,
    county_name: "Quitman",
    county_weights: {
      28119: 100,
    },
    county_names_all: "Quitman",
    county_fips_all: 28119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38625,
    lat: 34.61866,
    lng: -88.8334,
    city: "Dumas",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1617,
    density: 18.7,
    county_fips: 28139,
    county_name: "Tippah",
    county_weights: {
      28139: 68.53,
      28145: 31.47,
    },
    county_names_all: "Tippah|Union",
    county_fips_all: "28139|28145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38626,
    lat: 34.5182,
    lng: -90.43966,
    city: "Dundee",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 906,
    density: 2.1,
    county_fips: 28143,
    county_name: "Tunica",
    county_weights: {
      28027: 18.29,
      28143: 81.71,
    },
    county_names_all: "Tunica|Coahoma",
    county_fips_all: "28143|28027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38627,
    lat: 34.44503,
    lng: -89.24563,
    city: "Etta",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1600,
    density: 9.8,
    county_fips: 28071,
    county_name: "Lafayette",
    county_weights: {
      28071: 52.46,
      28145: 47.54,
    },
    county_names_all: "Lafayette|Union",
    county_fips_all: "28071|28145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38629,
    lat: 34.86914,
    lng: -88.99421,
    city: "Falkner",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1752,
    density: 15.7,
    county_fips: 28139,
    county_name: "Tippah",
    county_weights: {
      28009: 28.67,
      28139: 71.33,
    },
    county_names_all: "Tippah|Benton",
    county_fips_all: "28139|28009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38631,
    lat: 34.35891,
    lng: -90.62765,
    city: "Friars Point",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1415,
    density: 174.2,
    county_fips: 28027,
    county_name: "Coahoma",
    county_weights: {
      28027: 100,
    },
    county_names_all: "Coahoma",
    county_fips_all: 28027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38632,
    lat: 34.79973,
    lng: -90.00629,
    city: "Hernando",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27467,
    density: 65.4,
    county_fips: 28033,
    county_name: "DeSoto",
    county_weights: {
      28033: 100,
    },
    county_names_all: "DeSoto",
    county_fips_all: 28033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38633,
    lat: 34.64206,
    lng: -89.19671,
    city: "Hickory Flat",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2649,
    density: 10.2,
    county_fips: 28009,
    county_name: "Benton",
    county_weights: {
      28009: 79.99,
      28145: 20.01,
    },
    county_names_all: "Benton|Union",
    county_fips_all: "28009|28145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38635,
    lat: 34.7677,
    lng: -89.47896,
    city: "Holly Springs",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16173,
    density: 18.2,
    county_fips: 28093,
    county_name: "Marshall",
    county_weights: {
      28009: 6.1,
      28093: 91.43,
      28137: 2.47,
    },
    county_names_all: "Marshall|Benton|Tate",
    county_fips_all: "28093|28009|28137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38637,
    lat: 34.95105,
    lng: -90.05004,
    city: "Horn Lake",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27290,
    density: 665,
    county_fips: 28033,
    county_name: "DeSoto",
    county_weights: {
      28033: 100,
    },
    county_names_all: "DeSoto",
    county_fips_all: 28033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38639,
    lat: 34.30909,
    lng: -90.4285,
    city: "Jonestown",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 957,
    density: 81.9,
    county_fips: 28027,
    county_name: "Coahoma",
    county_weights: {
      28027: 100,
    },
    county_names_all: "Coahoma",
    county_fips_all: 28027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38641,
    lat: 34.90616,
    lng: -90.1857,
    city: "Lake Cormorant",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2203,
    density: 11.1,
    county_fips: 28033,
    county_name: "DeSoto",
    county_weights: {
      28033: 100,
    },
    county_names_all: "DeSoto",
    county_fips_all: 28033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38642,
    lat: 34.91861,
    lng: -89.33901,
    city: "Lamar",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2626,
    density: 13.5,
    county_fips: 28009,
    county_name: "Benton",
    county_weights: {
      28009: 55.13,
      28093: 44.87,
    },
    county_names_all: "Benton|Marshall",
    county_fips_all: "28009|28093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38643,
    lat: 34.15082,
    lng: -90.26281,
    city: "Lambert",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1596,
    density: 4,
    county_fips: 28119,
    county_name: "Quitman",
    county_weights: {
      28119: 96.71,
      28135: 3.29,
    },
    county_names_all: "Quitman|Tallahatchie",
    county_fips_all: "28119|28135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38644,
    lat: 34.45899,
    lng: -90.47576,
    city: "Lula",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 218,
    density: 216,
    county_fips: 28027,
    county_name: "Coahoma",
    county_weights: {
      28027: 100,
    },
    county_names_all: "Coahoma",
    county_fips_all: 28027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38645,
    lat: 34.2469,
    lng: -90.47663,
    city: "Lyon",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1446,
    density: 8.9,
    county_fips: 28027,
    county_name: "Coahoma",
    county_weights: {
      28027: 82.62,
      28119: 17.38,
    },
    county_names_all: "Coahoma|Quitman",
    county_fips_all: "28027|28119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38646,
    lat: 34.28141,
    lng: -90.29673,
    city: "Marks",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2959,
    density: 10.2,
    county_fips: 28119,
    county_name: "Quitman",
    county_weights: {
      28119: 100,
    },
    county_names_all: "Quitman",
    county_fips_all: 28119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38647,
    lat: 34.95851,
    lng: -89.21746,
    city: "Michigan City",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 560,
    density: 3.2,
    county_fips: 28009,
    county_name: "Benton",
    county_weights: {
      28009: 100,
    },
    county_names_all: "Benton",
    county_fips_all: 28009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38650,
    lat: 34.52776,
    lng: -89.14165,
    city: "Myrtle",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4332,
    density: 21.2,
    county_fips: 28145,
    county_name: "Union",
    county_weights: {
      28009: 8.17,
      28145: 91.83,
    },
    county_names_all: "Union|Benton",
    county_fips_all: "28145|28009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38651,
    lat: 34.89172,
    lng: -90.00359,
    city: "Nesbit",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8751,
    density: 102.6,
    county_fips: 28033,
    county_name: "DeSoto",
    county_weights: {
      28033: 100,
    },
    county_names_all: "DeSoto",
    county_fips_all: 28033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38652,
    lat: 34.48545,
    lng: -88.99652,
    city: "New Albany",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16088,
    density: 40.2,
    county_fips: 28145,
    county_name: "Union",
    county_weights: {
      28145: 100,
    },
    county_names_all: "Union",
    county_fips_all: 28145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38654,
    lat: 34.93635,
    lng: -89.82409,
    city: "Olive Branch",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53995,
    density: 227.1,
    county_fips: 28033,
    county_name: "DeSoto",
    county_weights: {
      28033: 96.64,
      28093: 3.36,
    },
    county_names_all: "DeSoto|Marshall",
    county_fips_all: "28033|28093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38655,
    lat: 34.33114,
    lng: -89.4825,
    city: "Oxford",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44339,
    density: 47.3,
    county_fips: 28071,
    county_name: "Lafayette",
    county_weights: {
      28071: 100,
    },
    county_names_all: "Lafayette",
    county_fips_all: 28071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38658,
    lat: 34.19011,
    lng: -89.89906,
    city: "Pope",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2724,
    density: 24.5,
    county_fips: 28107,
    county_name: "Panola",
    county_weights: {
      28107: 94.55,
      28161: 5.45,
    },
    county_names_all: "Panola|Yalobusha",
    county_fips_all: "28107|28161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38659,
    lat: 34.62073,
    lng: -89.32065,
    city: "Potts Camp",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2895,
    density: 10.1,
    county_fips: 28093,
    county_name: "Marshall",
    county_weights: {
      28009: 19.73,
      28093: 80.27,
    },
    county_names_all: "Marshall|Benton",
    county_fips_all: "28093|28009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38661,
    lat: 34.89009,
    lng: -89.55918,
    city: "Red Banks",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1740,
    density: 22.2,
    county_fips: 28093,
    county_name: "Marshall",
    county_weights: {
      28093: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 28093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38663,
    lat: 34.74111,
    lng: -88.89718,
    city: "Ripley",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12287,
    density: 25.1,
    county_fips: 28139,
    county_name: "Tippah",
    county_weights: {
      28009: 0.82,
      28139: 99.18,
    },
    county_names_all: "Tippah|Benton",
    county_fips_all: "28139|28009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38664,
    lat: 34.80434,
    lng: -90.33217,
    city: "Robinsonville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3221,
    density: 12.5,
    county_fips: 28143,
    county_name: "Tunica",
    county_weights: {
      28143: 100,
    },
    county_names_all: "Tunica",
    county_fips_all: 28143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38665,
    lat: 34.58165,
    lng: -90.16693,
    city: "Sarah",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2998,
    density: 17.7,
    county_fips: 28137,
    county_name: "Tate",
    county_weights: {
      28107: 26.8,
      28137: 61.62,
      28143: 11.58,
    },
    county_names_all: "Tate|Panola|Tunica",
    county_fips_all: "28137|28107|28143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38666,
    lat: 34.42007,
    lng: -89.92708,
    city: "Sardis",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6553,
    density: 17.8,
    county_fips: 28107,
    county_name: "Panola",
    county_weights: {
      28107: 100,
    },
    county_names_all: "Panola",
    county_fips_all: 28107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38668,
    lat: 34.60109,
    lng: -89.92505,
    city: "Senatobia",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14383,
    density: 34.6,
    county_fips: 28137,
    county_name: "Tate",
    county_weights: {
      28107: 2.85,
      28137: 97.15,
    },
    county_names_all: "Tate|Panola",
    county_fips_all: "28137|28107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38670,
    lat: 34.42815,
    lng: -90.28899,
    city: "Sledge",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 860,
    density: 3.3,
    county_fips: 28119,
    county_name: "Quitman",
    county_weights: {
      28119: 74.9,
      28143: 25.1,
    },
    county_names_all: "Quitman|Tunica",
    county_fips_all: "28119|28143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38671,
    lat: 34.96376,
    lng: -89.99567,
    city: "Southaven",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37798,
    density: 656.7,
    county_fips: 28033,
    county_name: "DeSoto",
    county_weights: {
      28033: 100,
    },
    county_names_all: "DeSoto",
    county_fips_all: 28033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38672,
    lat: 34.93727,
    lng: -89.94943,
    city: "Southaven",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15535,
    density: 460.7,
    county_fips: 28033,
    county_name: "DeSoto",
    county_weights: {
      28033: 100,
    },
    county_names_all: "DeSoto",
    county_fips_all: 28033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38673,
    lat: 34.29607,
    lng: -89.62485,
    city: "Taylor",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1234,
    density: 16.4,
    county_fips: 28071,
    county_name: "Lafayette",
    county_weights: {
      28071: 100,
    },
    county_names_all: "Lafayette",
    county_fips_all: 28071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38674,
    lat: 34.8718,
    lng: -88.89549,
    city: "Tiplersville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1070,
    density: 10,
    county_fips: 28139,
    county_name: "Tippah",
    county_weights: {
      28139: 100,
    },
    county_names_all: "Tippah",
    county_fips_all: 28139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38676,
    lat: 34.67274,
    lng: -90.3682,
    city: "Tunica",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5882,
    density: 13.4,
    county_fips: 28143,
    county_name: "Tunica",
    county_weights: {
      28143: 100,
    },
    county_names_all: "Tunica",
    county_fips_all: 28143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38677,
    lat: 34.36402,
    lng: -89.53859,
    city: "University",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3799,
    density: 1238.9,
    county_fips: 28071,
    county_name: "Lafayette",
    county_weights: {
      28071: 100,
    },
    county_names_all: "Lafayette",
    county_fips_all: 28071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38680,
    lat: 34.96152,
    lng: -90.14463,
    city: "Walls",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6130,
    density: 97.7,
    county_fips: 28033,
    county_name: "DeSoto",
    county_weights: {
      28033: 100,
    },
    county_names_all: "DeSoto",
    county_fips_all: 28033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38683,
    lat: 34.93504,
    lng: -88.85997,
    city: "Walnut",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4472,
    density: 12.9,
    county_fips: 28139,
    county_name: "Tippah",
    county_weights: {
      28003: 38.38,
      28009: 6.92,
      28139: 54.7,
    },
    county_names_all: "Tippah|Alcorn|Benton",
    county_fips_all: "28139|28003|28009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38685,
    lat: 34.5953,
    lng: -89.48827,
    city: "Waterford",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1106,
    density: 5.1,
    county_fips: 28093,
    county_name: "Marshall",
    county_weights: {
      28071: 5.82,
      28093: 94.18,
    },
    county_names_all: "Marshall|Lafayette",
    county_fips_all: "28093|28071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38701,
    lat: 33.30621,
    lng: -91.03346,
    city: "Greenville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22296,
    density: 96.3,
    county_fips: 28151,
    county_name: "Washington",
    county_weights: {
      28151: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 28151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38703,
    lat: 33.47081,
    lng: -91.04775,
    city: "Greenville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11673,
    density: 31.8,
    county_fips: 28151,
    county_name: "Washington",
    county_weights: {
      28011: 13.25,
      28151: 86.75,
    },
    county_names_all: "Washington|Bolivar",
    county_fips_all: "28151|28011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38720,
    lat: 34.11907,
    lng: -90.78741,
    city: "Alligator",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 732,
    density: 4.8,
    county_fips: 28027,
    county_name: "Coahoma",
    county_weights: {
      28011: 44.87,
      28027: 55.13,
    },
    county_names_all: "Coahoma|Bolivar",
    county_fips_all: "28027|28011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38721,
    lat: 32.96598,
    lng: -90.75876,
    city: "Anguilla",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 891,
    density: 2.7,
    county_fips: 28125,
    county_name: "Sharkey",
    county_weights: {
      28125: 100,
    },
    county_names_all: "Sharkey",
    county_fips_all: 28125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38722,
    lat: 33.26116,
    lng: -90.88304,
    city: "Arcola",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 355,
    density: 27.8,
    county_fips: 28151,
    county_name: "Washington",
    county_weights: {
      28151: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 28151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38723,
    lat: 33.22967,
    lng: -91.03845,
    city: "Avon",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52,
    density: 38.7,
    county_fips: 28151,
    county_name: "Washington",
    county_weights: {
      28151: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 28151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38725,
    lat: 33.63834,
    lng: -91.05543,
    city: "Benoit",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1033,
    density: 2.7,
    county_fips: 28011,
    county_name: "Bolivar",
    county_weights: {
      28011: 100,
    },
    county_names_all: "Bolivar",
    county_fips_all: 28011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38726,
    lat: 33.75207,
    lng: -90.97664,
    city: "Beulah",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 457,
    density: 3.2,
    county_fips: 28011,
    county_name: "Bolivar",
    county_weights: {
      28011: 100,
    },
    county_names_all: "Bolivar",
    county_fips_all: 28011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38730,
    lat: 33.6883,
    lng: -90.79932,
    city: "Boyle",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1968,
    density: 12.4,
    county_fips: 28011,
    county_name: "Bolivar",
    county_weights: {
      28011: 100,
    },
    county_names_all: "Bolivar",
    county_fips_all: 28011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38731,
    lat: 33.11524,
    lng: -91.13829,
    city: "Chatham",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 28151,
    county_name: "Washington",
    county_weights: {
      28151: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 28151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38732,
    lat: 33.75556,
    lng: -90.72558,
    city: "Cleveland",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16418,
    density: 71.8,
    county_fips: 28011,
    county_name: "Bolivar",
    county_weights: {
      28011: 76.84,
      28133: 23.16,
    },
    county_names_all: "Bolivar|Sunflower",
    county_fips_all: "28011|28133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38733,
    lat: 33.74463,
    lng: -90.73504,
    city: "Cleveland",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 28011,
    county_name: "Bolivar",
    county_weights: {
      28011: 100,
    },
    county_names_all: "Bolivar",
    county_fips_all: 28011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38736,
    lat: 33.64389,
    lng: -90.54173,
    city: "Doddsville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 399,
    density: 2.2,
    county_fips: 28133,
    county_name: "Sunflower",
    county_weights: {
      28083: 6.02,
      28133: 93.98,
    },
    county_names_all: "Sunflower|Leflore",
    county_fips_all: "28133|28083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38737,
    lat: 33.85683,
    lng: -90.4928,
    city: "Drew",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3064,
    density: 10.2,
    county_fips: 28133,
    county_name: "Sunflower",
    county_weights: {
      28133: 69.48,
      28135: 30.52,
    },
    county_names_all: "Sunflower|Tallahatchie",
    county_fips_all: "28133|28135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38738,
    lat: 33.93049,
    lng: -90.53653,
    city: "Parchman",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3765,
    density: 77.4,
    county_fips: 28133,
    county_name: "Sunflower",
    county_weights: {
      28133: 100,
    },
    county_names_all: "Sunflower",
    county_fips_all: 28133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38740,
    lat: 34.04825,
    lng: -90.79039,
    city: "Duncan",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 262,
    density: 1.5,
    county_fips: 28011,
    county_name: "Bolivar",
    county_weights: {
      28011: 99.63,
      28027: 0.37,
    },
    county_names_all: "Bolivar|Coahoma",
    county_fips_all: "28011|28027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38744,
    lat: 33.03066,
    lng: -91.05371,
    city: "Glen Allan",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 435,
    density: 2.4,
    county_fips: 28151,
    county_name: "Washington",
    county_weights: {
      28055: 29.01,
      28151: 70.99,
    },
    county_names_all: "Washington|Issaquena",
    county_fips_all: "28151|28055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38745,
    lat: 32.98592,
    lng: -91.00499,
    city: "Grace",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 162,
    density: 6,
    county_fips: 28055,
    county_name: "Issaquena",
    county_weights: {
      28055: 100,
    },
    county_names_all: "Issaquena",
    county_fips_all: 28055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38746,
    lat: 33.95677,
    lng: -90.94112,
    city: "Gunnison",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 438,
    density: 2,
    county_fips: 28011,
    county_name: "Bolivar",
    county_weights: {
      28011: 100,
    },
    county_names_all: "Bolivar",
    county_fips_all: 28011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38748,
    lat: 33.15787,
    lng: -90.87964,
    city: "Hollandale",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3071,
    density: 4.5,
    county_fips: 28151,
    county_name: "Washington",
    county_weights: {
      28125: 5.15,
      28151: 94.85,
    },
    county_names_all: "Washington|Sharkey",
    county_fips_all: "28151|28125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38751,
    lat: 33.45326,
    lng: -90.67469,
    city: "Indianola",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10203,
    density: 24.2,
    county_fips: 28133,
    county_name: "Sunflower",
    county_weights: {
      28133: 100,
    },
    county_names_all: "Sunflower",
    county_fips_all: 28133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38753,
    lat: 33.34845,
    lng: -90.58583,
    city: "Inverness",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1157,
    density: 6,
    county_fips: 28133,
    county_name: "Sunflower",
    county_weights: {
      28053: 11.03,
      28133: 88.97,
    },
    county_names_all: "Sunflower|Humphreys",
    county_fips_all: "28133|28053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38754,
    lat: 33.24816,
    lng: -90.62066,
    city: "Isola",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1250,
    density: 5.3,
    county_fips: 28053,
    county_name: "Humphreys",
    county_weights: {
      28053: 72.97,
      28133: 27.03,
    },
    county_names_all: "Humphreys|Sunflower",
    county_fips_all: "28053|28133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38756,
    lat: 33.39326,
    lng: -90.85827,
    city: "Leland",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6226,
    density: 12.4,
    county_fips: 28151,
    county_name: "Washington",
    county_weights: {
      28151: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 28151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38759,
    lat: 33.82495,
    lng: -90.73501,
    city: "Merigold",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1271,
    density: 7.6,
    county_fips: 28011,
    county_name: "Bolivar",
    county_weights: {
      28011: 71.58,
      28133: 28.42,
    },
    county_names_all: "Bolivar|Sunflower",
    county_fips_all: "28011|28133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38760,
    lat: 33.4535,
    lng: -90.99394,
    city: "Metcalfe",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 951,
    density: 224.8,
    county_fips: 28151,
    county_name: "Washington",
    county_weights: {
      28151: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 28151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38761,
    lat: 33.42507,
    lng: -90.47658,
    city: "Moorhead",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2286,
    density: 16,
    county_fips: 28133,
    county_name: "Sunflower",
    county_weights: {
      28083: 30.64,
      28133: 69.36,
    },
    county_names_all: "Sunflower|Leflore",
    county_fips_all: "28133|28083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38762,
    lat: 33.8885,
    lng: -90.72681,
    city: "Mound Bayou",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2337,
    density: 13.7,
    county_fips: 28011,
    county_name: "Bolivar",
    county_weights: {
      28011: 79.05,
      28133: 20.95,
    },
    county_names_all: "Bolivar|Sunflower",
    county_fips_all: "28011|28133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38764,
    lat: 33.79878,
    lng: -90.87965,
    city: "Pace",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 297,
    density: 34.8,
    county_fips: 28011,
    county_name: "Bolivar",
    county_weights: {
      28011: 100,
    },
    county_names_all: "Bolivar",
    county_fips_all: 28011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38765,
    lat: 33.0493,
    lng: -90.8896,
    city: "Panther Burn",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 103,
    density: 5.3,
    county_fips: 28125,
    county_name: "Sharkey",
    county_weights: {
      28125: 100,
    },
    county_names_all: "Sharkey",
    county_fips_all: 28125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38767,
    lat: 34.12809,
    lng: -90.80552,
    city: "Rena Lara",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 28027,
    county_name: "Coahoma",
    county_weights: {
      28027: 100,
    },
    county_names_all: "Coahoma",
    county_fips_all: 28027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38768,
    lat: 33.96576,
    lng: -90.48036,
    city: "Rome",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47,
    density: 5.4,
    county_fips: 28133,
    county_name: "Sunflower",
    county_weights: {
      28133: 100,
    },
    county_names_all: "Sunflower",
    county_fips_all: 28133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38769,
    lat: 33.84255,
    lng: -90.97678,
    city: "Rosedale",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1946,
    density: 10.6,
    county_fips: 28011,
    county_name: "Bolivar",
    county_weights: {
      28011: 91.6,
      "05041": 8.4,
    },
    county_names_all: "Bolivar|Desha",
    county_fips_all: "28011|05041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38771,
    lat: 33.73914,
    lng: -90.5243,
    city: "Ruleville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2980,
    density: 21.2,
    county_fips: 28133,
    county_name: "Sunflower",
    county_weights: {
      28133: 100,
    },
    county_names_all: "Sunflower",
    county_fips_all: 28133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38772,
    lat: 33.56254,
    lng: -91.08769,
    city: "Scott",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19,
    density: 0.4,
    county_fips: 28011,
    county_name: "Bolivar",
    county_weights: {
      28011: 99.77,
      28151: 0.23,
    },
    county_names_all: "Bolivar|Washington",
    county_fips_all: "28011|28151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38773,
    lat: 33.60455,
    lng: -90.77388,
    city: "Shaw",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3269,
    density: 9.8,
    county_fips: 28011,
    county_name: "Bolivar",
    county_weights: {
      28011: 71.55,
      28133: 28.45,
    },
    county_names_all: "Bolivar|Sunflower",
    county_fips_all: "28011|28133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38774,
    lat: 33.9659,
    lng: -90.76695,
    city: "Shelby",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1804,
    density: 11.1,
    county_fips: 28011,
    county_name: "Bolivar",
    county_weights: {
      28011: 100,
    },
    county_names_all: "Bolivar",
    county_fips_all: 28011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38776,
    lat: 33.42466,
    lng: -90.92752,
    city: "Stoneville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 28151,
    county_name: "Washington",
    county_weights: {
      28151: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 28151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38778,
    lat: 33.54564,
    lng: -90.51832,
    city: "Sunflower",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1219,
    density: 7.7,
    county_fips: 28133,
    county_name: "Sunflower",
    county_weights: {
      28133: 100,
    },
    county_names_all: "Sunflower",
    county_fips_all: 28133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38781,
    lat: 33.90876,
    lng: -90.75684,
    city: "Winstonville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 146,
    density: 82.3,
    county_fips: 28011,
    county_name: "Bolivar",
    county_weights: {
      28011: 100,
    },
    county_names_all: "Bolivar",
    county_fips_all: 28011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38801,
    lat: 34.22256,
    lng: -88.7762,
    city: "Tupelo",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29889,
    density: 158.1,
    county_fips: 28081,
    county_name: "Lee",
    county_weights: {
      28081: 82.65,
      28115: 17.35,
    },
    county_names_all: "Lee|Pontotoc",
    county_fips_all: "28081|28115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38804,
    lat: 34.28094,
    lng: -88.67246,
    city: "Tupelo",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16602,
    density: 81.7,
    county_fips: 28081,
    county_name: "Lee",
    county_weights: {
      28057: 2.3,
      28081: 97.7,
    },
    county_names_all: "Lee|Itawamba",
    county_fips_all: "28081|28057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38821,
    lat: 33.97503,
    lng: -88.43918,
    city: "Amory",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12528,
    density: 34.9,
    county_fips: 28095,
    county_name: "Monroe",
    county_weights: {
      28095: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 28095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38824,
    lat: 34.52303,
    lng: -88.64334,
    city: "Baldwyn",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7387,
    density: 19.4,
    county_fips: 28117,
    county_name: "Prentiss",
    county_weights: {
      28057: 7.8,
      28081: 24.64,
      28117: 47.4,
      28139: 5.96,
      28145: 14.21,
    },
    county_names_all: "Prentiss|Lee|Union|Itawamba|Tippah",
    county_fips_all: "28117|28081|28145|28057|28139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38826,
    lat: 34.30164,
    lng: -88.84655,
    city: "Belden",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4698,
    density: 59.1,
    county_fips: 28115,
    county_name: "Pontotoc",
    county_weights: {
      28081: 28.23,
      28115: 71.77,
    },
    county_names_all: "Pontotoc|Lee",
    county_fips_all: "28115|28081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38827,
    lat: 34.53,
    lng: -88.20244,
    city: "Belmont",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3551,
    density: 39.8,
    county_fips: 28141,
    county_name: "Tishomingo",
    county_weights: {
      28141: 100,
    },
    county_names_all: "Tishomingo",
    county_fips_all: 28141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38828,
    lat: 34.42365,
    lng: -88.86789,
    city: "Blue Springs",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4628,
    density: 19.1,
    county_fips: 28145,
    county_name: "Union",
    county_weights: {
      28081: 4.02,
      28115: 15.11,
      28145: 80.87,
    },
    county_names_all: "Union|Pontotoc|Lee",
    county_fips_all: "28145|28115|28081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38829,
    lat: 34.65229,
    lng: -88.53639,
    city: "Booneville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18644,
    density: 28,
    county_fips: 28117,
    county_name: "Prentiss",
    county_weights: {
      28117: 92.68,
      28139: 7.32,
    },
    county_names_all: "Prentiss|Tippah",
    county_fips_all: "28117|28139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38833,
    lat: 34.82259,
    lng: -88.34274,
    city: "Burnsville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2297,
    density: 17.7,
    county_fips: 28141,
    county_name: "Tishomingo",
    county_weights: {
      28003: 14.93,
      28117: 7.83,
      28141: 77.24,
    },
    county_names_all: "Tishomingo|Alcorn|Prentiss",
    county_fips_all: "28141|28003|28117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38834,
    lat: 34.91627,
    lng: -88.56027,
    city: "Corinth",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29190,
    density: 50.5,
    county_fips: 28003,
    county_name: "Alcorn",
    county_weights: {
      28003: 98.57,
      28141: 1.43,
    },
    county_names_all: "Alcorn|Tishomingo",
    county_fips_all: "28003|28141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38838,
    lat: 34.5448,
    lng: -88.2643,
    city: "Dennis",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1246,
    density: 10.6,
    county_fips: 28141,
    county_name: "Tishomingo",
    county_weights: {
      28117: 0.84,
      28141: 99.16,
    },
    county_names_all: "Tishomingo|Prentiss",
    county_fips_all: "28141|28117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38839,
    lat: 33.8558,
    lng: -89.28404,
    city: "Derma",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 28013,
    county_name: "Calhoun",
    county_weights: {
      28013: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 28013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38841,
    lat: 34.34943,
    lng: -89.02237,
    city: "Ecru",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3411,
    density: 40,
    county_fips: 28115,
    county_name: "Pontotoc",
    county_weights: {
      28115: 90.69,
      28145: 9.31,
    },
    county_names_all: "Pontotoc|Union",
    county_fips_all: "28115|28145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38843,
    lat: 34.26753,
    lng: -88.37437,
    city: "Fulton",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10813,
    density: 21.3,
    county_fips: 28057,
    county_name: "Itawamba",
    county_weights: {
      28057: 99.56,
      28081: 0.44,
    },
    county_names_all: "Itawamba|Lee",
    county_fips_all: "28057|28081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38844,
    lat: 33.839,
    lng: -88.25593,
    city: "Gattman",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 217,
    density: 6.4,
    county_fips: 28095,
    county_name: "Monroe",
    county_weights: {
      28095: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 28095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38846,
    lat: 34.85135,
    lng: -88.39501,
    city: "Glen",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1972,
    density: 22,
    county_fips: 28003,
    county_name: "Alcorn",
    county_weights: {
      28003: 80.17,
      28141: 19.83,
    },
    county_names_all: "Alcorn|Tishomingo",
    county_fips_all: "28003|28141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38847,
    lat: 34.40772,
    lng: -88.24074,
    city: "Golden",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3519,
    density: 14.8,
    county_fips: 28057,
    county_name: "Itawamba",
    county_weights: {
      28057: 87.07,
      28141: 12.93,
    },
    county_names_all: "Itawamba|Tishomingo",
    county_fips_all: "28057|28141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38848,
    lat: 33.94523,
    lng: -88.27797,
    city: "Greenwood Springs",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 696,
    density: 3.3,
    county_fips: 28095,
    county_name: "Monroe",
    county_weights: {
      28095: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 28095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38849,
    lat: 34.45442,
    lng: -88.69319,
    city: "Guntown",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6052,
    density: 32.2,
    county_fips: 28081,
    county_name: "Lee",
    county_weights: {
      28057: 0.97,
      28081: 81.11,
      28145: 17.92,
    },
    county_names_all: "Lee|Union|Itawamba",
    county_fips_all: "28081|28145|28057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38850,
    lat: 34.04792,
    lng: -89.06705,
    city: "Houlka",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2536,
    density: 7,
    county_fips: 28017,
    county_name: "Chickasaw",
    county_weights: {
      28013: 21.15,
      28017: 61.28,
      28115: 17.57,
    },
    county_names_all: "Chickasaw|Calhoun|Pontotoc",
    county_fips_all: "28017|28013|28115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38851,
    lat: 33.90763,
    lng: -88.9637,
    city: "Houston",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8757,
    density: 15.5,
    county_fips: 28017,
    county_name: "Chickasaw",
    county_weights: {
      28017: 100,
    },
    county_names_all: "Chickasaw",
    county_fips_all: 28017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38852,
    lat: 34.84484,
    lng: -88.21598,
    city: "Iuka",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9016,
    density: 17.6,
    county_fips: 28141,
    county_name: "Tishomingo",
    county_weights: {
      28141: 99.7,
      "01033": 0.3,
    },
    county_names_all: "Tishomingo|Colbert",
    county_fips_all: "28141|01033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38855,
    lat: 34.32646,
    lng: -88.48659,
    city: "Mantachie",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4501,
    density: 28.1,
    county_fips: 28057,
    county_name: "Itawamba",
    county_weights: {
      28057: 100,
    },
    county_names_all: "Itawamba",
    county_fips_all: 28057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38856,
    lat: 34.46835,
    lng: -88.44553,
    city: "Marietta",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2254,
    density: 14.8,
    county_fips: 28057,
    county_name: "Itawamba",
    county_weights: {
      28057: 54.63,
      28117: 45.37,
    },
    county_names_all: "Itawamba|Prentiss",
    county_fips_all: "28057|28117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38857,
    lat: 34.28004,
    lng: -88.57808,
    city: "Mooreville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4804,
    density: 97.7,
    county_fips: 28081,
    county_name: "Lee",
    county_weights: {
      28081: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 28081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38858,
    lat: 34.10145,
    lng: -88.53726,
    city: "Nettleton",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7579,
    density: 24,
    county_fips: 28057,
    county_name: "Itawamba",
    county_weights: {
      28057: 44.88,
      28081: 17.64,
      28095: 37.48,
    },
    county_names_all: "Itawamba|Monroe|Lee",
    county_fips_all: "28057|28095|28081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38859,
    lat: 34.52865,
    lng: -88.37548,
    city: "New Site",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 747,
    density: 6.6,
    county_fips: 28117,
    county_name: "Prentiss",
    county_weights: {
      28117: 100,
    },
    county_names_all: "Prentiss",
    county_fips_all: 28117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38860,
    lat: 33.97649,
    lng: -88.75879,
    city: "Okolona",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5621,
    density: 15.7,
    county_fips: 28017,
    county_name: "Chickasaw",
    county_weights: {
      28017: 74.43,
      28081: 3.37,
      28095: 21.66,
      28115: 0.54,
    },
    county_names_all: "Chickasaw|Monroe|Lee|Pontotoc",
    county_fips_all: "28017|28095|28081|28115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38862,
    lat: 34.16871,
    lng: -88.62048,
    city: "Plantersville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2517,
    density: 32.6,
    county_fips: 28081,
    county_name: "Lee",
    county_weights: {
      28081: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 28081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38863,
    lat: 34.2167,
    lng: -89.02738,
    city: "Pontotoc",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20526,
    density: 27.3,
    county_fips: 28115,
    county_name: "Pontotoc",
    county_weights: {
      28071: 3.94,
      28115: 96.06,
    },
    county_names_all: "Pontotoc|Lafayette",
    county_fips_all: "28115|28071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38864,
    lat: 34.14325,
    lng: -89.20167,
    city: "Randolph",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2221,
    density: 10.8,
    county_fips: 28115,
    county_name: "Pontotoc",
    county_weights: {
      28013: 22.13,
      28115: 77.87,
    },
    county_names_all: "Pontotoc|Calhoun",
    county_fips_all: "28115|28013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38865,
    lat: 34.78003,
    lng: -88.58821,
    city: "Rienzi",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5156,
    density: 16.8,
    county_fips: 28003,
    county_name: "Alcorn",
    county_weights: {
      28003: 78.41,
      28117: 21.59,
    },
    county_names_all: "Alcorn|Prentiss",
    county_fips_all: "28003|28117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38866,
    lat: 34.36644,
    lng: -88.68187,
    city: "Saltillo",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12538,
    density: 64.2,
    county_fips: 28081,
    county_name: "Lee",
    county_weights: {
      28081: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 28081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38868,
    lat: 34.12168,
    lng: -88.74692,
    city: "Shannon",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6238,
    density: 33,
    county_fips: 28081,
    county_name: "Lee",
    county_weights: {
      28017: 2.93,
      28081: 74.24,
      28095: 7.38,
      28115: 15.45,
    },
    county_names_all: "Lee|Pontotoc|Monroe|Chickasaw",
    county_fips_all: "28081|28115|28095|28017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38869,
    lat: 34.35627,
    lng: -88.83635,
    city: "Sherman",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 430,
    density: 157.6,
    county_fips: 28115,
    county_name: "Pontotoc",
    county_weights: {
      28115: 100,
    },
    county_names_all: "Pontotoc",
    county_fips_all: 28115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38870,
    lat: 34.06886,
    lng: -88.34125,
    city: "Smithville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2328,
    density: 13.1,
    county_fips: 28095,
    county_name: "Monroe",
    county_weights: {
      28057: 29.33,
      28095: 70.67,
    },
    county_names_all: "Monroe|Itawamba",
    county_fips_all: "28095|28057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38871,
    lat: 34.33582,
    lng: -89.2055,
    city: "Thaxton",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1781,
    density: 12.4,
    county_fips: 28115,
    county_name: "Pontotoc",
    county_weights: {
      28071: 17,
      28115: 75.05,
      28145: 7.95,
    },
    county_names_all: "Pontotoc|Lafayette|Union",
    county_fips_all: "28115|28071|28145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38873,
    lat: 34.66169,
    lng: -88.25141,
    city: "Tishomingo",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2876,
    density: 12,
    county_fips: 28141,
    county_name: "Tishomingo",
    county_weights: {
      28117: 6.42,
      28141: 93.58,
    },
    county_names_all: "Tishomingo|Prentiss",
    county_fips_all: "28141|28117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38876,
    lat: 34.21457,
    lng: -88.23112,
    city: "Tremont",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1442,
    density: 7.4,
    county_fips: 28057,
    county_name: "Itawamba",
    county_weights: {
      28057: 100,
    },
    county_names_all: "Itawamba",
    county_fips_all: 28057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38878,
    lat: 33.88179,
    lng: -89.19231,
    city: "Vardaman",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2712,
    density: 12,
    county_fips: 28013,
    county_name: "Calhoun",
    county_weights: {
      28013: 94.17,
      28017: 5.83,
    },
    county_names_all: "Calhoun|Chickasaw",
    county_fips_all: "28013|28017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38879,
    lat: 34.19519,
    lng: -88.71209,
    city: "Verona",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 888,
    density: 2882.2,
    county_fips: 28081,
    county_name: "Lee",
    county_weights: {
      28081: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 28081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38901,
    lat: 33.76275,
    lng: -89.79799,
    city: "Grenada",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17668,
    density: 28.2,
    county_fips: 28043,
    county_name: "Grenada",
    county_weights: {
      28015: 9.33,
      28043: 86.25,
      28097: 0.86,
      28135: 3.56,
    },
    county_names_all: "Grenada|Carroll|Tallahatchie|Montgomery",
    county_fips_all: "28043|28015|28135|28097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38913,
    lat: 34.13774,
    lng: -89.37836,
    city: "Banner",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 487,
    density: 8.2,
    county_fips: 28013,
    county_name: "Calhoun",
    county_weights: {
      28013: 97.43,
      28071: 2.57,
    },
    county_names_all: "Calhoun|Lafayette",
    county_fips_all: "28013|28071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38914,
    lat: 33.86466,
    lng: -89.46453,
    city: "Big Creek",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 880,
    density: 6.9,
    county_fips: 28013,
    county_name: "Calhoun",
    county_weights: {
      28013: 93.62,
      28043: 6.38,
    },
    county_names_all: "Calhoun|Grenada",
    county_fips_all: "28013|28043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38915,
    lat: 34.02807,
    lng: -89.38957,
    city: "Bruce",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3404,
    density: 11.9,
    county_fips: 28013,
    county_name: "Calhoun",
    county_weights: {
      28013: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 28013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38916,
    lat: 33.81815,
    lng: -89.35158,
    city: "Calhoun City",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5244,
    density: 11.5,
    county_fips: 28013,
    county_name: "Calhoun",
    county_weights: {
      28013: 95.48,
      28155: 4.52,
    },
    county_names_all: "Calhoun|Webster",
    county_fips_all: "28013|28155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38917,
    lat: 33.54902,
    lng: -89.95501,
    city: "Carrollton",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2993,
    density: 6.9,
    county_fips: 28015,
    county_name: "Carroll",
    county_weights: {
      28015: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 28015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38920,
    lat: 33.8823,
    lng: -90.05018,
    city: "Cascilla",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 585,
    density: 4.4,
    county_fips: 28135,
    county_name: "Tallahatchie",
    county_weights: {
      28135: 100,
    },
    county_names_all: "Tallahatchie",
    county_fips_all: 28135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38921,
    lat: 33.98328,
    lng: -90.1425,
    city: "Charleston",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5061,
    density: 13.2,
    county_fips: 28135,
    county_name: "Tallahatchie",
    county_weights: {
      28135: 100,
    },
    county_names_all: "Tallahatchie",
    county_fips_all: 28135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38922,
    lat: 33.93641,
    lng: -89.64878,
    city: "Coffeeville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3037,
    density: 5.3,
    county_fips: 28161,
    county_name: "Yalobusha",
    county_weights: {
      28043: 19.63,
      28161: 80.37,
    },
    county_names_all: "Yalobusha|Grenada",
    county_fips_all: "28161|28043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38923,
    lat: 33.37829,
    lng: -89.99354,
    city: "Coila",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 598,
    density: 2.8,
    county_fips: 28015,
    county_name: "Carroll",
    county_weights: {
      28015: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 28015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38924,
    lat: 33.29342,
    lng: -90.22392,
    city: "Cruger",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 369,
    density: 1.2,
    county_fips: 28051,
    county_name: "Holmes",
    county_weights: {
      28015: 10.89,
      28051: 66.48,
      28053: 15.91,
      28083: 6.72,
    },
    county_names_all: "Holmes|Humphreys|Carroll|Leflore",
    county_fips_all: "28051|28053|28015|28083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38925,
    lat: 33.62917,
    lng: -89.61961,
    city: "Duck Hill",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2357,
    density: 5.8,
    county_fips: 28097,
    county_name: "Montgomery",
    county_weights: {
      28043: 11.45,
      28097: 78.24,
      28155: 10.31,
    },
    county_names_all: "Montgomery|Grenada|Webster",
    county_fips_all: "28097|28043|28155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38927,
    lat: 34.13394,
    lng: -90.01827,
    city: "Enid",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1186,
    density: 7.7,
    county_fips: 28135,
    county_name: "Tallahatchie",
    county_weights: {
      28107: 15.1,
      28135: 83.62,
      28161: 1.28,
    },
    county_names_all: "Tallahatchie|Panola|Yalobusha",
    county_fips_all: "28135|28107|28161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38928,
    lat: 33.85405,
    lng: -90.28731,
    city: "Glendora",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 406,
    density: 4.5,
    county_fips: 28135,
    county_name: "Tallahatchie",
    county_weights: {
      28135: 100,
    },
    county_names_all: "Tallahatchie",
    county_fips_all: 28135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38929,
    lat: 33.74014,
    lng: -89.52425,
    city: "Gore Springs",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1872,
    density: 10.2,
    county_fips: 28043,
    county_name: "Grenada",
    county_weights: {
      28013: 7.34,
      28043: 60.71,
      28155: 31.95,
    },
    county_names_all: "Grenada|Webster|Calhoun",
    county_fips_all: "28043|28155|28013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38930,
    lat: 33.52845,
    lng: -90.14245,
    city: "Greenwood",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23406,
    density: 46.5,
    county_fips: 28083,
    county_name: "Leflore",
    county_weights: {
      28015: 37.54,
      28083: 62.46,
    },
    county_names_all: "Leflore|Carroll",
    county_fips_all: "28083|28015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38940,
    lat: 33.75145,
    lng: -90.03505,
    city: "Holcomb",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1676,
    density: 4.3,
    county_fips: 28043,
    county_name: "Grenada",
    county_weights: {
      28015: 8,
      28043: 72.89,
      28135: 19.11,
    },
    county_names_all: "Grenada|Tallahatchie|Carroll",
    county_fips_all: "28043|28135|28015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38941,
    lat: 33.48655,
    lng: -90.35909,
    city: "Itta Bena",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3922,
    density: 14.3,
    county_fips: 28083,
    county_name: "Leflore",
    county_weights: {
      28083: 100,
    },
    county_names_all: "Leflore",
    county_fips_all: 28083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38943,
    lat: 33.52033,
    lng: -89.84525,
    city: "McCarley",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 335,
    density: 2.7,
    county_fips: 28015,
    county_name: "Carroll",
    county_weights: {
      28015: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 28015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38944,
    lat: 33.76106,
    lng: -90.34242,
    city: "Minter City",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 375,
    density: 1.5,
    county_fips: 28083,
    county_name: "Leflore",
    county_weights: {
      28083: 96.71,
      28135: 3.29,
    },
    county_names_all: "Leflore|Tallahatchie",
    county_fips_all: "28083|28135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38946,
    lat: 33.37701,
    lng: -90.35591,
    city: "Morgan City",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 264,
    density: 10.7,
    county_fips: 28083,
    county_name: "Leflore",
    county_weights: {
      28083: 100,
    },
    county_names_all: "Leflore",
    county_fips_all: 28083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38947,
    lat: 33.51718,
    lng: -89.92128,
    city: "North Carrollton",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 516,
    density: 2156.5,
    county_fips: 28015,
    county_name: "Carroll",
    county_weights: {
      28015: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 28015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38948,
    lat: 34.07635,
    lng: -89.89364,
    city: "Oakland",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2361,
    density: 8.8,
    county_fips: 28161,
    county_name: "Yalobusha",
    county_weights: {
      28135: 30.73,
      28161: 69.27,
    },
    county_names_all: "Yalobusha|Tallahatchie",
    county_fips_all: "28161|28135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38949,
    lat: 34.18542,
    lng: -89.4151,
    city: "Paris",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 386,
    density: 13.1,
    county_fips: 28071,
    county_name: "Lafayette",
    county_weights: {
      28071: 100,
    },
    county_names_all: "Lafayette",
    county_fips_all: 28071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38950,
    lat: 33.74281,
    lng: -90.19758,
    city: "Philipp",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 518,
    density: 3.2,
    county_fips: 28135,
    county_name: "Tallahatchie",
    county_weights: {
      28083: 28.47,
      28135: 71.53,
    },
    county_names_all: "Tallahatchie|Leflore",
    county_fips_all: "28135|28083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38951,
    lat: 33.97605,
    lng: -89.28802,
    city: "Pittsboro",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1128,
    density: 8.4,
    county_fips: 28013,
    county_name: "Calhoun",
    county_weights: {
      28013: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 28013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38952,
    lat: 33.63041,
    lng: -90.33711,
    city: "Schlater",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 468,
    density: 1.7,
    county_fips: 28083,
    county_name: "Leflore",
    county_weights: {
      28083: 100,
    },
    county_names_all: "Leflore",
    county_fips_all: 28083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38953,
    lat: 33.91821,
    lng: -89.92325,
    city: "Scobey",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 513,
    density: 5.5,
    county_fips: 28135,
    county_name: "Tallahatchie",
    county_weights: {
      28043: 12.43,
      28135: 45.77,
      28161: 41.8,
    },
    county_names_all: "Tallahatchie|Yalobusha|Grenada",
    county_fips_all: "28135|28161|28043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38954,
    lat: 33.41301,
    lng: -90.21536,
    city: "Sidon",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1137,
    density: 6.8,
    county_fips: 28083,
    county_name: "Leflore",
    county_weights: {
      28015: 15.61,
      28051: 2.4,
      28083: 81.99,
    },
    county_names_all: "Leflore|Carroll|Holmes",
    county_fips_all: "28083|28015|28051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38957,
    lat: 33.98747,
    lng: -90.37296,
    city: "Sumner",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 467,
    density: 16.7,
    county_fips: 28135,
    county_name: "Tallahatchie",
    county_weights: {
      28135: 100,
    },
    county_names_all: "Tallahatchie",
    county_fips_all: 28135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38961,
    lat: 33.96463,
    lng: -89.8859,
    city: "Tillatoba",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 660,
    density: 3.5,
    county_fips: 28161,
    county_name: "Yalobusha",
    county_weights: {
      28135: 31.52,
      28161: 68.48,
    },
    county_names_all: "Yalobusha|Tallahatchie",
    county_fips_all: "28161|28135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38962,
    lat: 33.87201,
    lng: -90.18465,
    city: "Tippo",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 72,
    density: 2.4,
    county_fips: 28135,
    county_name: "Tallahatchie",
    county_weights: {
      28135: 100,
    },
    county_names_all: "Tallahatchie",
    county_fips_all: 28135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38963,
    lat: 34.00442,
    lng: -90.40598,
    city: "Tutwiler",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3858,
    density: 8.6,
    county_fips: 28135,
    county_name: "Tallahatchie",
    county_weights: {
      28027: 19.73,
      28133: 17.34,
      28135: 62.93,
    },
    county_names_all: "Tallahatchie|Coahoma|Sunflower",
    county_fips_all: "28135|28027|28133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38964,
    lat: 34.11035,
    lng: -90.38868,
    city: "Vance",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 163,
    density: 2,
    county_fips: 28119,
    county_name: "Quitman",
    county_weights: {
      28119: 88.19,
      28135: 11.81,
    },
    county_names_all: "Quitman|Tallahatchie",
    county_fips_all: "28119|28135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38965,
    lat: 34.13486,
    lng: -89.59257,
    city: "Water Valley",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8380,
    density: 12.9,
    county_fips: 28161,
    county_name: "Yalobusha",
    county_weights: {
      28013: 15.77,
      28071: 21.43,
      28107: 4.08,
      28161: 58.72,
    },
    county_names_all: "Yalobusha|Lafayette|Calhoun|Panola",
    county_fips_all: "28161|28071|28013|28107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38966,
    lat: 33.9202,
    lng: -90.31828,
    city: "Webb",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 733,
    density: 11.5,
    county_fips: 28135,
    county_name: "Tallahatchie",
    county_weights: {
      28135: 100,
    },
    county_names_all: "Tallahatchie",
    county_fips_all: 28135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 38967,
    lat: 33.45832,
    lng: -89.72026,
    city: "Winona",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7824,
    density: 17.7,
    county_fips: 28097,
    county_name: "Montgomery",
    county_weights: {
      28015: 38.79,
      28097: 61.21,
    },
    county_names_all: "Montgomery|Carroll",
    county_fips_all: "28097|28015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39038,
    lat: 33.20179,
    lng: -90.47023,
    city: "Belzoni",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5589,
    density: 8.8,
    county_fips: 28053,
    county_name: "Humphreys",
    county_weights: {
      28051: 2.82,
      28053: 73.07,
      28083: 22.46,
      28133: 1.65,
    },
    county_names_all: "Humphreys|Leflore|Holmes|Sunflower",
    county_fips_all: "28053|28083|28051|28133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39039,
    lat: 32.82216,
    lng: -90.22757,
    city: "Benton",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2108,
    density: 5.7,
    county_fips: 28163,
    county_name: "Yazoo",
    county_weights: {
      28163: 100,
    },
    county_names_all: "Yazoo",
    county_fips_all: 28163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39040,
    lat: 32.63907,
    lng: -90.41314,
    city: "Bentonia",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3209,
    density: 7.1,
    county_fips: 28163,
    county_name: "Yazoo",
    county_weights: {
      28163: 100,
    },
    county_names_all: "Yazoo",
    county_fips_all: 28163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39041,
    lat: 32.41757,
    lng: -90.47273,
    city: "Bolton",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3889,
    density: 12.2,
    county_fips: 28049,
    county_name: "Hinds",
    county_weights: {
      28049: 99.58,
      28089: 0.42,
    },
    county_names_all: "Hinds|Madison",
    county_fips_all: "28049|28089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39042,
    lat: 32.2135,
    lng: -89.88966,
    city: "Brandon",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36793,
    density: 66.3,
    county_fips: 28121,
    county_name: "Rankin",
    county_weights: {
      28121: 98.73,
      28129: 1.27,
    },
    county_names_all: "Rankin|Smith",
    county_fips_all: "28121|28129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39044,
    lat: 32.02869,
    lng: -89.97161,
    city: "Braxton",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3604,
    density: 9.9,
    county_fips: 28127,
    county_name: "Simpson",
    county_weights: {
      28121: 40.74,
      28127: 59.26,
    },
    county_names_all: "Simpson|Rankin",
    county_fips_all: "28127|28121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39045,
    lat: 32.78735,
    lng: -89.8173,
    city: "Camden",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1825,
    density: 6.3,
    county_fips: 28089,
    county_name: "Madison",
    county_weights: {
      28089: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 28089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39046,
    lat: 32.62834,
    lng: -89.99634,
    city: "Canton",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27693,
    density: 34.3,
    county_fips: 28089,
    county_name: "Madison",
    county_weights: {
      28089: 99.85,
      28163: 0.15,
    },
    county_names_all: "Madison|Yazoo",
    county_fips_all: "28089|28163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39047,
    lat: 32.43356,
    lng: -89.95011,
    city: "Brandon",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40496,
    density: 161.3,
    county_fips: 28121,
    county_name: "Rankin",
    county_weights: {
      28121: 100,
    },
    county_names_all: "Rankin",
    county_fips_all: 28121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39051,
    lat: 32.7868,
    lng: -89.50718,
    city: "Carthage",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16199,
    density: 14.5,
    county_fips: 28079,
    county_name: "Leake",
    county_weights: {
      28007: 1.42,
      28079: 90.9,
      28089: 2.25,
      28099: 5.43,
    },
    county_names_all: "Leake|Neshoba|Madison|Attala",
    county_fips_all: "28079|28099|28089|28007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39054,
    lat: 32.79855,
    lng: -90.93525,
    city: "Cary",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 472,
    density: 13.6,
    county_fips: 28125,
    county_name: "Sharkey",
    county_weights: {
      28125: 100,
    },
    county_names_all: "Sharkey",
    county_fips_all: 28125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39056,
    lat: 32.37384,
    lng: -90.35083,
    city: "Clinton",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25357,
    density: 180.5,
    county_fips: 28049,
    county_name: "Hinds",
    county_weights: {
      28049: 100,
    },
    county_names_all: "Hinds",
    county_fips_all: 28049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39057,
    lat: 32.49268,
    lng: -89.28381,
    city: "Conehatta",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2403,
    density: 14.8,
    county_fips: 28101,
    county_name: "Newton",
    county_weights: {
      28101: 87.49,
      28123: 12.51,
    },
    county_names_all: "Newton|Scott",
    county_fips_all: "28101|28123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39058,
    lat: 32.33571,
    lng: -90.33143,
    city: "Clinton",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 28049,
    county_name: "Hinds",
    county_weights: {
      28049: 100,
    },
    county_names_all: "Hinds",
    county_fips_all: 28049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39059,
    lat: 31.98194,
    lng: -90.35141,
    city: "Crystal Springs",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11775,
    density: 30,
    county_fips: 28029,
    county_name: "Copiah",
    county_weights: {
      28029: 94.56,
      28049: 5.44,
    },
    county_names_all: "Copiah|Hinds",
    county_fips_all: "28029|28049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39061,
    lat: 33.08597,
    lng: -90.80324,
    city: "Delta City",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 28125,
    county_name: "Sharkey",
    county_weights: {
      28125: 100,
    },
    county_names_all: "Sharkey",
    county_fips_all: 28125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39062,
    lat: 31.98479,
    lng: -89.89815,
    city: "D Lo",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 600,
    density: 163.3,
    county_fips: 28127,
    county_name: "Simpson",
    county_weights: {
      28127: 100,
    },
    county_names_all: "Simpson",
    county_fips_all: 28127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39063,
    lat: 33.11698,
    lng: -89.89975,
    city: "Durant",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3790,
    density: 14.8,
    county_fips: 28051,
    county_name: "Holmes",
    county_weights: {
      28051: 100,
    },
    county_names_all: "Holmes",
    county_fips_all: 28051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39066,
    lat: 32.30188,
    lng: -90.60502,
    city: "Edwards",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5272,
    density: 13.5,
    county_fips: 28049,
    county_name: "Hinds",
    county_weights: {
      28049: 100,
    },
    county_names_all: "Hinds",
    county_fips_all: 28049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39067,
    lat: 33.11574,
    lng: -89.44853,
    city: "Ethel",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1166,
    density: 4.4,
    county_fips: 28007,
    county_name: "Attala",
    county_weights: {
      28007: 100,
    },
    county_names_all: "Attala",
    county_fips_all: 28007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39069,
    lat: 31.6836,
    lng: -91.04038,
    city: "Fayette",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4856,
    density: 10.5,
    county_fips: 28063,
    county_name: "Jefferson",
    county_weights: {
      28037: 2.98,
      28063: 97.02,
    },
    county_names_all: "Jefferson|Franklin",
    county_fips_all: "28063|28037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39071,
    lat: 32.54887,
    lng: -90.3185,
    city: "Flora",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6496,
    density: 22.9,
    county_fips: 28089,
    county_name: "Madison",
    county_weights: {
      28049: 0.9,
      28089: 99.1,
    },
    county_names_all: "Madison|Hinds",
    county_fips_all: "28089|28049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39073,
    lat: 32.10269,
    lng: -90.13049,
    city: "Florence",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21277,
    density: 51,
    county_fips: 28121,
    county_name: "Rankin",
    county_weights: {
      28121: 78.02,
      28127: 21.98,
    },
    county_names_all: "Rankin|Simpson",
    county_fips_all: "28121|28127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39074,
    lat: 32.3872,
    lng: -89.47398,
    city: "Forest",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14951,
    density: 20.8,
    county_fips: 28123,
    county_name: "Scott",
    county_weights: {
      28123: 83.23,
      28129: 16.77,
    },
    county_names_all: "Scott|Smith",
    county_fips_all: "28123|28129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39078,
    lat: 31.87901,
    lng: -90.19596,
    city: "Georgetown",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 673,
    density: 6.6,
    county_fips: 28029,
    county_name: "Copiah",
    county_weights: {
      28029: 99.52,
      28127: 0.48,
    },
    county_names_all: "Copiah|Simpson",
    county_fips_all: "28029|28127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39079,
    lat: 32.93178,
    lng: -89.88449,
    city: "Goodman",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1720,
    density: 8.4,
    county_fips: 28007,
    county_name: "Attala",
    county_weights: {
      28007: 53.9,
      28051: 36.98,
      28089: 9.12,
    },
    county_names_all: "Attala|Holmes|Madison",
    county_fips_all: "28007|28051|28089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39082,
    lat: 31.94663,
    lng: -90.12369,
    city: "Harrisville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1184,
    density: 7.5,
    county_fips: 28127,
    county_name: "Simpson",
    county_weights: {
      28127: 100,
    },
    county_names_all: "Simpson",
    county_fips_all: 28127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39083,
    lat: 31.83467,
    lng: -90.46997,
    city: "Hazlehurst",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9366,
    density: 11.3,
    county_fips: 28029,
    county_name: "Copiah",
    county_weights: {
      28029: 98.3,
      28085: 1.7,
    },
    county_names_all: "Copiah|Lincoln",
    county_fips_all: "28029|28085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39086,
    lat: 31.96275,
    lng: -90.75964,
    city: "Hermanville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1638,
    density: 3.5,
    county_fips: 28021,
    county_name: "Claiborne",
    county_weights: {
      28021: 65.61,
      28029: 34.39,
    },
    county_names_all: "Claiborne|Copiah",
    county_fips_all: "28021|28029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39088,
    lat: 32.73287,
    lng: -90.7545,
    city: "Holly Bluff",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 82,
    density: 0.5,
    county_fips: 28125,
    county_name: "Sharkey",
    county_weights: {
      28125: 100,
    },
    county_names_all: "Sharkey",
    county_fips_all: 28125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39090,
    lat: 33.00775,
    lng: -89.54503,
    city: "Kosciusko",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12811,
    density: 18.8,
    county_fips: 28007,
    county_name: "Attala",
    county_weights: {
      28007: 84.11,
      28079: 15.53,
      28159: 0.36,
    },
    county_names_all: "Attala|Leake|Winston",
    county_fips_all: "28007|28079|28159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39092,
    lat: 32.31489,
    lng: -89.36833,
    city: "Lake",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3059,
    density: 11.7,
    county_fips: 28123,
    county_name: "Scott",
    county_weights: {
      28101: 14.19,
      28123: 79.83,
      28129: 5.98,
    },
    county_names_all: "Scott|Newton|Smith",
    county_fips_all: "28123|28101|28129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39094,
    lat: 32.57497,
    lng: -89.67591,
    city: "Lena",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3714,
    density: 8.4,
    county_fips: 28079,
    county_name: "Leake",
    county_weights: {
      28079: 43.09,
      28121: 19.02,
      28123: 37.9,
    },
    county_names_all: "Leake|Scott|Rankin",
    county_fips_all: "28079|28123|28121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39095,
    lat: 33.11929,
    lng: -90.09452,
    city: "Lexington",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6117,
    density: 6.7,
    county_fips: 28051,
    county_name: "Holmes",
    county_weights: {
      28015: 5.66,
      28051: 91.85,
      28163: 2.49,
    },
    county_names_all: "Holmes|Carroll|Yazoo",
    county_fips_all: "28051|28015|28163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39096,
    lat: 31.82508,
    lng: -91.11672,
    city: "Lorman",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2346,
    density: 4.6,
    county_fips: 28063,
    county_name: "Jefferson",
    county_weights: {
      28021: 18.24,
      28063: 81.76,
    },
    county_names_all: "Jefferson|Claiborne",
    county_fips_all: "28063|28021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39097,
    lat: 32.99105,
    lng: -90.59478,
    city: "Louise",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 435,
    density: 2.9,
    county_fips: 28053,
    county_name: "Humphreys",
    county_weights: {
      28053: 100,
    },
    county_names_all: "Humphreys",
    county_fips_all: 28053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39108,
    lat: 33.15684,
    lng: -89.33033,
    city: "McCool",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1492,
    density: 3,
    county_fips: 28007,
    county_name: "Attala",
    county_weights: {
      28007: 49.57,
      28019: 27.74,
      28159: 22.68,
    },
    county_names_all: "Attala|Choctaw|Winston",
    county_fips_all: "28007|28019|28159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39110,
    lat: 32.50325,
    lng: -90.13791,
    city: "Madison",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43336,
    density: 225.1,
    county_fips: 28089,
    county_name: "Madison",
    county_weights: {
      28089: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 28089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39111,
    lat: 31.89536,
    lng: -89.71816,
    city: "Magee",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8929,
    density: 24.4,
    county_fips: 28127,
    county_name: "Simpson",
    county_weights: {
      28127: 78.99,
      28129: 21.01,
    },
    county_names_all: "Simpson|Smith",
    county_fips_all: "28127|28129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39113,
    lat: 32.82707,
    lng: -91.06476,
    city: "Mayersville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 589,
    density: 8.2,
    county_fips: 28055,
    county_name: "Issaquena",
    county_weights: {
      28055: 100,
    },
    county_names_all: "Issaquena",
    county_fips_all: 28055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39114,
    lat: 31.95331,
    lng: -89.83257,
    city: "Mendenhall",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10362,
    density: 21,
    county_fips: 28127,
    county_name: "Simpson",
    county_weights: {
      28121: 11.8,
      28127: 88.2,
    },
    county_names_all: "Simpson|Rankin",
    county_fips_all: "28127|28121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39115,
    lat: 33.04679,
    lng: -90.56133,
    city: "Midnight",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 184,
    density: 15,
    county_fips: 28053,
    county_name: "Humphreys",
    county_weights: {
      28053: 100,
    },
    county_names_all: "Humphreys",
    county_fips_all: 28053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39116,
    lat: 31.89165,
    lng: -89.54925,
    city: "Mize",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3126,
    density: 14.1,
    county_fips: 28129,
    county_name: "Smith",
    county_weights: {
      28129: 100,
    },
    county_names_all: "Smith",
    county_fips_all: 28129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39117,
    lat: 32.31096,
    lng: -89.66413,
    city: "Morton",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10354,
    density: 15.9,
    county_fips: 28123,
    county_name: "Scott",
    county_weights: {
      28121: 3.82,
      28123: 70.36,
      28129: 25.82,
    },
    county_names_all: "Scott|Smith|Rankin",
    county_fips_all: "28123|28129|28121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39119,
    lat: 31.75236,
    lng: -89.67509,
    city: "Mount Olive",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4733,
    density: 12.4,
    county_fips: 28031,
    county_name: "Covington",
    county_weights: {
      28031: 55.97,
      28065: 15.68,
      28127: 12.5,
      28129: 15.85,
    },
    county_names_all: "Covington|Smith|Jefferson Davis|Simpson",
    county_fips_all: "28031|28129|28065|28127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39120,
    lat: 31.51148,
    lng: -91.35206,
    city: "Natchez",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30733,
    density: 24.5,
    county_fips: 28001,
    county_name: "Adams",
    county_weights: {
      28001: 87.49,
      28063: 12.51,
    },
    county_names_all: "Adams|Jefferson",
    county_fips_all: "28001|28063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39140,
    lat: 31.75211,
    lng: -90.00512,
    city: "Newhebron",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2364,
    density: 9.4,
    county_fips: 28065,
    county_name: "Jefferson Davis",
    county_weights: {
      28065: 36.45,
      28077: 31.5,
      28127: 32.04,
    },
    county_names_all: "Jefferson Davis|Simpson|Lawrence",
    county_fips_all: "28065|28127|28077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39144,
    lat: 31.82971,
    lng: -90.80155,
    city: "Pattison",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 787,
    density: 2.6,
    county_fips: 28021,
    county_name: "Claiborne",
    county_weights: {
      28021: 61.13,
      28029: 17.5,
      28063: 21.37,
    },
    county_names_all: "Claiborne|Jefferson|Copiah",
    county_fips_all: "28021|28063|28029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39145,
    lat: 32.33862,
    lng: -89.79819,
    city: "Pelahatchie",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5293,
    density: 15.8,
    county_fips: 28121,
    county_name: "Rankin",
    county_weights: {
      28121: 97.99,
      28123: 2.01,
    },
    county_names_all: "Rankin|Scott",
    county_fips_all: "28121|28123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39146,
    lat: 32.88078,
    lng: -89.99316,
    city: "Pickens",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2779,
    density: 7.9,
    county_fips: 28089,
    county_name: "Madison",
    county_weights: {
      28051: 40.22,
      28089: 42.62,
      28163: 17.15,
    },
    county_names_all: "Madison|Holmes|Yazoo",
    county_fips_all: "28089|28051|28163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39148,
    lat: 32.06159,
    lng: -89.99459,
    city: "Piney Woods",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 28121,
    county_name: "Rankin",
    county_weights: {
      28121: 100,
    },
    county_names_all: "Rankin",
    county_fips_all: 28121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39149,
    lat: 31.83354,
    lng: -90.00985,
    city: "Pinola",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1211,
    density: 5.9,
    county_fips: 28127,
    county_name: "Simpson",
    county_weights: {
      28127: 100,
    },
    county_names_all: "Simpson",
    county_fips_all: 28127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39150,
    lat: 31.99264,
    lng: -90.98487,
    city: "Port Gibson",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5305,
    density: 9,
    county_fips: 28021,
    county_name: "Claiborne",
    county_weights: {
      28021: 100,
    },
    county_names_all: "Claiborne",
    county_fips_all: 28021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39152,
    lat: 32.2011,
    lng: -89.57779,
    city: "Pulaski",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1059,
    density: 5.7,
    county_fips: 28129,
    county_name: "Smith",
    county_weights: {
      28123: 34.99,
      28129: 65.01,
    },
    county_names_all: "Smith|Scott",
    county_fips_all: "28129|28123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39153,
    lat: 32.05133,
    lng: -89.50159,
    city: "Raleigh",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2935,
    density: 7.5,
    county_fips: 28129,
    county_name: "Smith",
    county_weights: {
      28129: 100,
    },
    county_names_all: "Smith",
    county_fips_all: 28129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39154,
    lat: 32.22695,
    lng: -90.44762,
    city: "Raymond",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10276,
    density: 33.9,
    county_fips: 28049,
    county_name: "Hinds",
    county_weights: {
      28049: 100,
    },
    county_names_all: "Hinds",
    county_fips_all: 28049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39156,
    lat: 32.53901,
    lng: -90.77056,
    city: "Redwood",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 523,
    density: 3.3,
    county_fips: 28149,
    county_name: "Warren",
    county_weights: {
      28149: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 28149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39157,
    lat: 32.42537,
    lng: -90.16685,
    city: "Ridgeland",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24811,
    density: 319,
    county_fips: 28089,
    county_name: "Madison",
    county_weights: {
      28089: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 28089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39159,
    lat: 32.82894,
    lng: -90.92476,
    city: "Rolling Fork",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3133,
    density: 3.2,
    county_fips: 28125,
    county_name: "Sharkey",
    county_weights: {
      28055: 44.57,
      28125: 55.43,
    },
    county_names_all: "Sharkey|Issaquena",
    county_fips_all: "28125|28055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39160,
    lat: 32.99756,
    lng: -89.75336,
    city: "Sallis",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2989,
    density: 8.2,
    county_fips: 28007,
    county_name: "Attala",
    county_weights: {
      28007: 91.73,
      28079: 8.27,
    },
    county_names_all: "Attala|Leake",
    county_fips_all: "28007|28079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39162,
    lat: 32.62627,
    lng: -90.63395,
    city: "Satartia",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54,
    density: 0.4,
    county_fips: 28163,
    county_name: "Yazoo",
    county_weights: {
      28163: 100,
    },
    county_names_all: "Yazoo",
    county_fips_all: 28163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39166,
    lat: 33.05161,
    lng: -90.48208,
    city: "Silver City",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 705,
    density: 4.8,
    county_fips: 28053,
    county_name: "Humphreys",
    county_weights: {
      28053: 100,
    },
    county_names_all: "Humphreys",
    county_fips_all: 28053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39167,
    lat: 32.09316,
    lng: -90.04003,
    city: "Star",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 28121,
    county_name: "Rankin",
    county_weights: {
      28121: 100,
    },
    county_names_all: "Rankin",
    county_fips_all: 28121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39168,
    lat: 31.82994,
    lng: -89.40974,
    city: "Taylorsville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6441,
    density: 16.7,
    county_fips: 28129,
    county_name: "Smith",
    county_weights: {
      28031: 15.63,
      28067: 19.84,
      28129: 64.53,
    },
    county_names_all: "Smith|Jones|Covington",
    county_fips_all: "28129|28067|28031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39169,
    lat: 33.13515,
    lng: -90.29371,
    city: "Tchula",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2846,
    density: 9,
    county_fips: 28051,
    county_name: "Holmes",
    county_weights: {
      28051: 100,
    },
    county_names_all: "Holmes",
    county_fips_all: 28051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39170,
    lat: 32.11182,
    lng: -90.3377,
    city: "Terry",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10257,
    density: 40.8,
    county_fips: 28049,
    county_name: "Hinds",
    county_weights: {
      28029: 2.19,
      28049: 97.81,
    },
    county_names_all: "Hinds|Copiah",
    county_fips_all: "28049|28029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39173,
    lat: 32.74247,
    lng: -90.47219,
    city: "Tinsley",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 28163,
    county_name: "Yazoo",
    county_weights: {
      28163: 100,
    },
    county_names_all: "Yazoo",
    county_fips_all: 28163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39174,
    lat: 32.4009,
    lng: -90.16018,
    city: "Tougaloo",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 808,
    density: 1272.5,
    county_fips: 28089,
    county_name: "Madison",
    county_weights: {
      28049: 39.55,
      28089: 60.45,
    },
    county_names_all: "Madison|Hinds",
    county_fips_all: "28089|28049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39175,
    lat: 32.09238,
    lng: -90.62097,
    city: "Utica",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4009,
    density: 6.6,
    county_fips: 28049,
    county_name: "Hinds",
    county_weights: {
      28021: 15.6,
      28029: 25.57,
      28049: 58.83,
    },
    county_names_all: "Hinds|Copiah|Claiborne",
    county_fips_all: "28049|28029|28021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39176,
    lat: 33.30398,
    lng: -89.74859,
    city: "Vaiden",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2592,
    density: 7.4,
    county_fips: 28015,
    county_name: "Carroll",
    county_weights: {
      28007: 20.95,
      28015: 68.61,
      28097: 10.44,
    },
    county_names_all: "Carroll|Attala|Montgomery",
    county_fips_all: "28015|28007|28097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39177,
    lat: 32.61286,
    lng: -90.84546,
    city: "Valley Park",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 183,
    density: 0.7,
    county_fips: 28055,
    county_name: "Issaquena",
    county_weights: {
      28055: 100,
    },
    county_names_all: "Issaquena",
    county_fips_all: 28055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39179,
    lat: 32.80873,
    lng: -90.0984,
    city: "Vaughan",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 853,
    density: 3.7,
    county_fips: 28163,
    county_name: "Yazoo",
    county_weights: {
      28163: 100,
    },
    county_names_all: "Yazoo",
    county_fips_all: 28163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39180,
    lat: 32.223,
    lng: -90.90225,
    city: "Vicksburg",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31720,
    density: 46.9,
    county_fips: 28149,
    county_name: "Warren",
    county_weights: {
      28149: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 28149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39183,
    lat: 32.4554,
    lng: -90.83307,
    city: "Vicksburg",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13787,
    density: 17.3,
    county_fips: 28149,
    county_name: "Warren",
    county_weights: {
      28055: 13.37,
      28149: 86.63,
    },
    county_names_all: "Warren|Issaquena",
    county_fips_all: "28149|28055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39189,
    lat: 32.60412,
    lng: -89.4003,
    city: "Walnut Grove",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3915,
    density: 19.7,
    county_fips: 28079,
    county_name: "Leake",
    county_weights: {
      28079: 74.36,
      28123: 25.64,
    },
    county_names_all: "Leake|Scott",
    county_fips_all: "28079|28123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39191,
    lat: 31.71492,
    lng: -90.40764,
    city: "Wesson",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8252,
    density: 14.5,
    county_fips: 28029,
    county_name: "Copiah",
    county_weights: {
      28029: 60.36,
      28077: 1.56,
      28085: 38.08,
    },
    county_names_all: "Copiah|Lincoln|Lawrence",
    county_fips_all: "28029|28085|28077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39192,
    lat: 33.19153,
    lng: -89.75324,
    city: "West",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1895,
    density: 5,
    county_fips: 28007,
    county_name: "Attala",
    county_weights: {
      28007: 57.22,
      28015: 13.23,
      28051: 29.55,
    },
    county_names_all: "Attala|Holmes|Carroll",
    county_fips_all: "28007|28051|28015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39193,
    lat: 32.23625,
    lng: -90.07681,
    city: "Whitfield",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 960,
    density: 202.7,
    county_fips: 28121,
    county_name: "Rankin",
    county_weights: {
      28121: 100,
    },
    county_names_all: "Rankin",
    county_fips_all: 28121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39194,
    lat: 32.83423,
    lng: -90.49856,
    city: "Yazoo City",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22156,
    density: 18.8,
    county_fips: 28163,
    county_name: "Yazoo",
    county_weights: {
      28053: 5.52,
      28163: 94.48,
    },
    county_names_all: "Yazoo|Humphreys",
    county_fips_all: "28163|28053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39201,
    lat: 32.28981,
    lng: -90.18398,
    city: "Jackson",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 918,
    density: 170.7,
    county_fips: 28049,
    county_name: "Hinds",
    county_weights: {
      28049: 100,
    },
    county_names_all: "Hinds",
    county_fips_all: 28049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39202,
    lat: 32.31105,
    lng: -90.16956,
    city: "Jackson",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7836,
    density: 780.7,
    county_fips: 28049,
    county_name: "Hinds",
    county_weights: {
      28049: 100,
    },
    county_names_all: "Hinds",
    county_fips_all: 28049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39203,
    lat: 32.30928,
    lng: -90.20042,
    city: "Jackson",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6689,
    density: 1139.6,
    county_fips: 28049,
    county_name: "Hinds",
    county_weights: {
      28049: 100,
    },
    county_names_all: "Hinds",
    county_fips_all: 28049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39204,
    lat: 32.28313,
    lng: -90.23689,
    city: "Jackson",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15933,
    density: 652.5,
    county_fips: 28049,
    county_name: "Hinds",
    county_weights: {
      28049: 100,
    },
    county_names_all: "Hinds",
    county_fips_all: 28049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39206,
    lat: 32.37237,
    lng: -90.17268,
    city: "Jackson",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23641,
    density: 1032,
    county_fips: 28049,
    county_name: "Hinds",
    county_weights: {
      28049: 100,
    },
    county_names_all: "Hinds",
    county_fips_all: 28049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39208,
    lat: 32.25827,
    lng: -90.08908,
    city: "Pearl",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32926,
    density: 265.9,
    county_fips: 28121,
    county_name: "Rankin",
    county_weights: {
      28121: 100,
    },
    county_names_all: "Rankin",
    county_fips_all: 28121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39209,
    lat: 32.39498,
    lng: -90.30168,
    city: "Jackson",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26835,
    density: 166.3,
    county_fips: 28049,
    county_name: "Hinds",
    county_weights: {
      28049: 96.79,
      28089: 3.21,
    },
    county_names_all: "Hinds|Madison",
    county_fips_all: "28049|28089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39210,
    lat: 32.32255,
    lng: -90.17997,
    city: "Jackson",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 28049,
    county_name: "Hinds",
    county_weights: {
      28049: 100,
    },
    county_names_all: "Hinds",
    county_fips_all: 28049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39211,
    lat: 32.37176,
    lng: -90.12219,
    city: "Jackson",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23872,
    density: 748.7,
    county_fips: 28049,
    county_name: "Hinds",
    county_weights: {
      28049: 100,
    },
    county_names_all: "Hinds",
    county_fips_all: 28049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39212,
    lat: 32.24081,
    lng: -90.26174,
    city: "Jackson",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32680,
    density: 426.2,
    county_fips: 28049,
    county_name: "Hinds",
    county_weights: {
      28049: 100,
    },
    county_names_all: "Hinds",
    county_fips_all: 28049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39213,
    lat: 32.39384,
    lng: -90.23007,
    city: "Jackson",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20379,
    density: 278.2,
    county_fips: 28049,
    county_name: "Hinds",
    county_weights: {
      28049: 97.01,
      28089: 2.99,
    },
    county_names_all: "Hinds|Madison",
    county_fips_all: "28049|28089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39216,
    lat: 32.33463,
    lng: -90.1606,
    city: "Jackson",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4080,
    density: 507.9,
    county_fips: 28049,
    county_name: "Hinds",
    county_weights: {
      28049: 100,
    },
    county_names_all: "Hinds",
    county_fips_all: 28049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39217,
    lat: 32.29754,
    lng: -90.20963,
    city: "Jackson",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 28049,
    county_name: "Hinds",
    county_weights: {
      28049: 100,
    },
    county_names_all: "Hinds",
    county_fips_all: 28049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39218,
    lat: 32.22825,
    lng: -90.15857,
    city: "Richland",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6947,
    density: 151.3,
    county_fips: 28121,
    county_name: "Rankin",
    county_weights: {
      28121: 100,
    },
    county_names_all: "Rankin",
    county_fips_all: 28121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39232,
    lat: 32.3361,
    lng: -90.08693,
    city: "Flowood",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8179,
    density: 123.5,
    county_fips: 28121,
    county_name: "Rankin",
    county_weights: {
      28121: 100,
    },
    county_names_all: "Rankin",
    county_fips_all: 28121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39269,
    lat: 32.30114,
    lng: -90.1889,
    city: "Jackson",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 28049,
    county_name: "Hinds",
    county_weights: {
      28049: 100,
    },
    county_names_all: "Hinds",
    county_fips_all: 28049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39272,
    lat: 32.18838,
    lng: -90.26335,
    city: "Byram",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13073,
    density: 214.8,
    county_fips: 28049,
    county_name: "Hinds",
    county_weights: {
      28049: 100,
    },
    county_names_all: "Hinds",
    county_fips_all: 28049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39301,
    lat: 32.27289,
    lng: -88.59226,
    city: "Meridian",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24911,
    density: 36.9,
    county_fips: 28075,
    county_name: "Lauderdale",
    county_weights: {
      28023: 31.09,
      28075: 68.91,
    },
    county_names_all: "Lauderdale|Clarke",
    county_fips_all: "28075|28023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39305,
    lat: 32.46392,
    lng: -88.72465,
    city: "Meridian",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20419,
    density: 79.5,
    county_fips: 28075,
    county_name: "Lauderdale",
    county_weights: {
      28075: 100,
    },
    county_names_all: "Lauderdale",
    county_fips_all: 28075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39307,
    lat: 32.33847,
    lng: -88.79217,
    city: "Meridian",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16926,
    density: 72.1,
    county_fips: 28075,
    county_name: "Lauderdale",
    county_weights: {
      28075: 100,
    },
    county_names_all: "Lauderdale",
    county_fips_all: 28075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39309,
    lat: 32.55417,
    lng: -88.57422,
    city: "Meridian",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 28075,
    county_name: "Lauderdale",
    county_weights: {
      28075: 100,
    },
    county_names_all: "Lauderdale",
    county_fips_all: 28075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39320,
    lat: 32.56169,
    lng: -88.74507,
    city: "Bailey",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2308,
    density: 19,
    county_fips: 28075,
    county_name: "Lauderdale",
    county_weights: {
      28069: 42.26,
      28075: 57.74,
    },
    county_names_all: "Lauderdale|Kemper",
    county_fips_all: "28075|28069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39322,
    lat: 31.58344,
    lng: -88.53203,
    city: "Buckatunna",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2054,
    density: 10.8,
    county_fips: 28153,
    county_name: "Wayne",
    county_weights: {
      28153: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 28153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39323,
    lat: 32.34971,
    lng: -88.92624,
    city: "Chunky",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1110,
    density: 7.2,
    county_fips: 28101,
    county_name: "Newton",
    county_weights: {
      28075: 33.64,
      28101: 66.36,
    },
    county_names_all: "Newton|Lauderdale",
    county_fips_all: "28101|28075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39324,
    lat: 31.58032,
    lng: -88.69755,
    city: "Clara",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 28153,
    county_name: "Wayne",
    county_weights: {
      28153: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 28153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39325,
    lat: 32.56198,
    lng: -88.87362,
    city: "Collinsville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6434,
    density: 23.3,
    county_fips: 28075,
    county_name: "Lauderdale",
    county_weights: {
      28069: 29.81,
      28075: 56.02,
      28099: 10.15,
      28101: 4.02,
    },
    county_names_all: "Lauderdale|Kemper|Neshoba|Newton",
    county_fips_all: "28075|28069|28099|28101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39326,
    lat: 32.59814,
    lng: -88.67904,
    city: "Daleville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 310,
    density: 3.1,
    county_fips: 28069,
    county_name: "Kemper",
    county_weights: {
      28069: 72.94,
      28075: 27.06,
    },
    county_names_all: "Kemper|Lauderdale",
    county_fips_all: "28069|28075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39327,
    lat: 32.44563,
    lng: -89.12173,
    city: "Decatur",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4044,
    density: 14.9,
    county_fips: 28101,
    county_name: "Newton",
    county_weights: {
      28101: 100,
    },
    county_names_all: "Newton",
    county_fips_all: 28101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39328,
    lat: 32.75012,
    lng: -88.69564,
    city: "De Kalb",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5149,
    density: 6.3,
    county_fips: 28069,
    county_name: "Kemper",
    county_weights: {
      28069: 100,
    },
    county_names_all: "Kemper",
    county_fips_all: 28069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39330,
    lat: 32.19385,
    lng: -88.85689,
    city: "Enterprise",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2450,
    density: 7.4,
    county_fips: 28023,
    county_name: "Clarke",
    county_weights: {
      28023: 58.06,
      28061: 8.81,
      28075: 28.66,
      28101: 4.47,
    },
    county_names_all: "Clarke|Lauderdale|Jasper|Newton",
    county_fips_all: "28023|28075|28061|28101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39332,
    lat: 32.30399,
    lng: -89.0046,
    city: "Hickory",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2107,
    density: 12.7,
    county_fips: 28101,
    county_name: "Newton",
    county_weights: {
      28061: 9.82,
      28101: 90.18,
    },
    county_names_all: "Newton|Jasper",
    county_fips_all: "28101|28061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39335,
    lat: 32.53214,
    lng: -88.49263,
    city: "Lauderdale",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2179,
    density: 8.3,
    county_fips: 28075,
    county_name: "Lauderdale",
    county_weights: {
      28069: 14.58,
      28075: 85.42,
    },
    county_names_all: "Lauderdale|Kemper",
    county_fips_all: "28075|28069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39336,
    lat: 32.29081,
    lng: -89.27253,
    city: "Lawrence",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1113,
    density: 6.1,
    county_fips: 28101,
    county_name: "Newton",
    county_weights: {
      28061: 8.6,
      28101: 86.86,
      28129: 4.54,
    },
    county_names_all: "Newton|Jasper|Smith",
    county_fips_all: "28101|28061|28129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39337,
    lat: 32.51447,
    lng: -88.98528,
    city: "Little Rock",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1714,
    density: 9.8,
    county_fips: 28101,
    county_name: "Newton",
    county_weights: {
      28099: 5.86,
      28101: 94.14,
    },
    county_names_all: "Newton|Neshoba",
    county_fips_all: "28101|28099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39338,
    lat: 32.11034,
    lng: -89.23274,
    city: "Louin",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3954,
    density: 7.3,
    county_fips: 28061,
    county_name: "Jasper",
    county_weights: {
      28061: 81.72,
      28129: 18.28,
    },
    county_names_all: "Jasper|Smith",
    county_fips_all: "28061|28129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39339,
    lat: 33.10417,
    lng: -89.00259,
    city: "Louisville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14845,
    density: 14.6,
    county_fips: 28159,
    county_name: "Winston",
    county_weights: {
      28159: 100,
    },
    county_names_all: "Winston",
    county_fips_all: 28159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39341,
    lat: 33.0998,
    lng: -88.55702,
    city: "Macon",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6599,
    density: 6.7,
    county_fips: 28103,
    county_name: "Noxubee",
    county_weights: {
      28103: 96.32,
      28159: 3.68,
    },
    county_names_all: "Noxubee|Winston",
    county_fips_all: "28103|28159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39342,
    lat: 32.42566,
    lng: -88.64968,
    city: "Marion",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1738,
    density: 216.8,
    county_fips: 28075,
    county_name: "Lauderdale",
    county_weights: {
      28075: 100,
    },
    county_names_all: "Lauderdale",
    county_fips_all: 28075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39345,
    lat: 32.28717,
    lng: -89.12974,
    city: "Newton",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5658,
    density: 15.5,
    county_fips: 28101,
    county_name: "Newton",
    county_weights: {
      28061: 16.42,
      28101: 83.58,
    },
    county_names_all: "Newton|Jasper",
    county_fips_all: "28101|28061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39346,
    lat: 32.96171,
    lng: -89.089,
    city: "Noxapater",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1829,
    density: 9,
    county_fips: 28159,
    county_name: "Winston",
    county_weights: {
      28099: 14.19,
      28159: 85.81,
    },
    county_names_all: "Winston|Neshoba",
    county_fips_all: "28159|28099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39347,
    lat: 32.05507,
    lng: -88.93419,
    city: "Pachuta",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1402,
    density: 6.9,
    county_fips: 28061,
    county_name: "Jasper",
    county_weights: {
      28023: 34.86,
      28061: 65.14,
    },
    county_names_all: "Jasper|Clarke",
    county_fips_all: "28061|28023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39348,
    lat: 32.00007,
    lng: -89.03475,
    city: "Paulding",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 489,
    density: 4.8,
    county_fips: 28061,
    county_name: "Jasper",
    county_weights: {
      28061: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 28061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39350,
    lat: 32.79674,
    lng: -89.12984,
    city: "Philadelphia",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25015,
    density: 23.4,
    county_fips: 28099,
    county_name: "Neshoba",
    county_weights: {
      28069: 1.98,
      28079: 1.66,
      28099: 90.54,
      28159: 5.82,
    },
    county_names_all: "Neshoba|Winston|Kemper|Leake",
    county_fips_all: "28099|28159|28069|28079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39352,
    lat: 32.66834,
    lng: -88.47808,
    city: "Porterville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 582,
    density: 2.5,
    county_fips: 28069,
    county_name: "Kemper",
    county_weights: {
      28069: 100,
    },
    county_names_all: "Kemper",
    county_fips_all: 28069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39354,
    lat: 32.87945,
    lng: -88.83625,
    city: "Preston",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2988,
    density: 9.4,
    county_fips: 28069,
    county_name: "Kemper",
    county_weights: {
      28069: 72.38,
      28099: 7.8,
      28103: 7.95,
      28159: 11.87,
    },
    county_names_all: "Kemper|Winston|Noxubee|Neshoba",
    county_fips_all: "28069|28159|28103|28099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39355,
    lat: 32.05808,
    lng: -88.61965,
    city: "Quitman",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5718,
    density: 7.9,
    county_fips: 28023,
    county_name: "Clarke",
    county_weights: {
      28023: 100,
    },
    county_names_all: "Clarke",
    county_fips_all: 28023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39356,
    lat: 32.13632,
    lng: -89.0283,
    city: "Rose Hill",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 521,
    density: 3.1,
    county_fips: 28061,
    county_name: "Jasper",
    county_weights: {
      28061: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 28061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39358,
    lat: 32.83317,
    lng: -88.45605,
    city: "Scooba",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1335,
    density: 2.9,
    county_fips: 28069,
    county_name: "Kemper",
    county_weights: {
      28069: 96.25,
      28103: 3.75,
    },
    county_names_all: "Kemper|Noxubee",
    county_fips_all: "28069|28103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39359,
    lat: 32.56852,
    lng: -89.33206,
    city: "Sebastopol",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 301,
    density: 103.6,
    county_fips: 28123,
    county_name: "Scott",
    county_weights: {
      28123: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 28123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39360,
    lat: 31.86357,
    lng: -88.7409,
    city: "Shubuta",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3993,
    density: 6.9,
    county_fips: 28023,
    county_name: "Clarke",
    county_weights: {
      28023: 61.57,
      28153: 38.43,
    },
    county_names_all: "Clarke|Wayne",
    county_fips_all: "28023|28153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39361,
    lat: 32.97952,
    lng: -88.61234,
    city: "Shuqualak",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1356,
    density: 4,
    county_fips: 28103,
    county_name: "Noxubee",
    county_weights: {
      28069: 0.15,
      28103: 99.85,
    },
    county_names_all: "Noxubee|Kemper",
    county_fips_all: "28103|28069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39362,
    lat: 31.39326,
    lng: -88.53988,
    city: "State Line",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3994,
    density: 7.9,
    county_fips: 28041,
    county_name: "Greene",
    county_weights: {
      28041: 64.81,
      28153: 35.19,
    },
    county_names_all: "Greene|Wayne",
    county_fips_all: "28041|28153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39363,
    lat: 32.11918,
    lng: -88.77628,
    city: "Stonewall",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1468,
    density: 24.4,
    county_fips: 28023,
    county_name: "Clarke",
    county_weights: {
      28023: 100,
    },
    county_names_all: "Clarke",
    county_fips_all: 28023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39364,
    lat: 32.40597,
    lng: -88.49617,
    city: "Toomsuba",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2743,
    density: 12.7,
    county_fips: 28075,
    county_name: "Lauderdale",
    county_weights: {
      28075: 100,
    },
    county_names_all: "Lauderdale",
    county_fips_all: 28075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39365,
    lat: 32.60486,
    lng: -89.12225,
    city: "Union",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7705,
    density: 15.5,
    county_fips: 28099,
    county_name: "Neshoba",
    county_weights: {
      28069: 0.16,
      28079: 0.55,
      28099: 71.03,
      28101: 28.26,
    },
    county_names_all: "Neshoba|Newton|Leake|Kemper",
    county_fips_all: "28099|28101|28079|28069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39366,
    lat: 31.93795,
    lng: -88.90057,
    city: "Vossburg",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 879,
    density: 5.1,
    county_fips: 28023,
    county_name: "Clarke",
    county_weights: {
      28023: 56.02,
      28061: 43.98,
    },
    county_names_all: "Clarke|Jasper",
    county_fips_all: "28023|28061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39367,
    lat: 31.68219,
    lng: -88.6644,
    city: "Waynesboro",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14522,
    density: 12.2,
    county_fips: 28153,
    county_name: "Wayne",
    county_weights: {
      28023: 4.6,
      28153: 95.4,
    },
    county_names_all: "Wayne|Clarke",
    county_fips_all: "28153|28023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39401,
    lat: 31.23496,
    lng: -89.26912,
    city: "Hattiesburg",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40933,
    density: 83.7,
    county_fips: 28035,
    county_name: "Forrest",
    county_weights: {
      28031: 0.44,
      28035: 95.42,
      28067: 3.93,
      28073: 0.21,
    },
    county_names_all: "Forrest|Jones|Covington|Lamar",
    county_fips_all: "28035|28067|28031|28073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39402,
    lat: 31.33446,
    lng: -89.4132,
    city: "Hattiesburg",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40886,
    density: 169.3,
    county_fips: 28073,
    county_name: "Lamar",
    county_weights: {
      28031: 1.64,
      28035: 41.87,
      28073: 56.49,
    },
    county_names_all: "Lamar|Forrest|Covington",
    county_fips_all: "28073|28035|28031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39406,
    lat: 31.32895,
    lng: -89.33515,
    city: "Hattiesburg",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1727,
    density: 1960.5,
    county_fips: 28035,
    county_name: "Forrest",
    county_weights: {
      28035: 100,
    },
    county_names_all: "Forrest",
    county_fips_all: 28035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39421,
    lat: 31.48411,
    lng: -89.71179,
    city: "Bassfield",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2985,
    density: 17.3,
    county_fips: 28065,
    county_name: "Jefferson Davis",
    county_weights: {
      28065: 82.76,
      28091: 17.24,
    },
    county_names_all: "Jefferson Davis|Marion",
    county_fips_all: "28065|28091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39422,
    lat: 31.95953,
    lng: -89.26745,
    city: "Bay Springs",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4330,
    density: 11.9,
    county_fips: 28061,
    county_name: "Jasper",
    county_weights: {
      28061: 71.46,
      28129: 28.54,
    },
    county_names_all: "Jasper|Smith",
    county_fips_all: "28061|28129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39423,
    lat: 31.17553,
    lng: -88.91103,
    city: "Beaumont",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2832,
    density: 11.3,
    county_fips: 28111,
    county_name: "Perry",
    county_weights: {
      28041: 2.63,
      28111: 97.37,
    },
    county_names_all: "Perry|Greene",
    county_fips_all: "28111|28041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39425,
    lat: 31.05633,
    lng: -89.06322,
    city: "Brooklyn",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2756,
    density: 5,
    county_fips: 28111,
    county_name: "Perry",
    county_weights: {
      28035: 20.53,
      28111: 79.47,
    },
    county_names_all: "Perry|Forrest",
    county_fips_all: "28111|28035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39426,
    lat: 30.65375,
    lng: -89.65709,
    city: "Carriere",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17571,
    density: 37.1,
    county_fips: 28109,
    county_name: "Pearl River",
    county_weights: {
      28045: 10.25,
      28109: 89.75,
    },
    county_names_all: "Pearl River|Hancock",
    county_fips_all: "28109|28045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39427,
    lat: 31.48693,
    lng: -89.82701,
    city: "Carson",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1404,
    density: 9.6,
    county_fips: 28065,
    county_name: "Jefferson Davis",
    county_weights: {
      28065: 100,
    },
    county_names_all: "Jefferson Davis",
    county_fips_all: 28065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39428,
    lat: 31.65017,
    lng: -89.57215,
    city: "Collins",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9410,
    density: 20.4,
    county_fips: 28031,
    county_name: "Covington",
    county_weights: {
      28031: 100,
    },
    county_names_all: "Covington",
    county_fips_all: 28031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39429,
    lat: 31.25052,
    lng: -89.76337,
    city: "Columbia",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16540,
    density: 21.4,
    county_fips: 28091,
    county_name: "Marion",
    county_weights: {
      28065: 1.35,
      28073: 2.69,
      28091: 95.96,
    },
    county_names_all: "Marion|Lamar|Jefferson Davis",
    county_fips_all: "28091|28073|28065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39437,
    lat: 31.57883,
    lng: -89.21981,
    city: "Ellisville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12844,
    density: 29.2,
    county_fips: 28067,
    county_name: "Jones",
    county_weights: {
      28067: 100,
    },
    county_names_all: "Jones",
    county_fips_all: 28067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39439,
    lat: 31.85865,
    lng: -89.00227,
    city: "Heidelberg",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4769,
    density: 13.5,
    county_fips: 28061,
    county_name: "Jasper",
    county_weights: {
      28023: 6.96,
      28061: 67.14,
      28067: 19.02,
      28153: 6.88,
    },
    county_names_all: "Jasper|Jones|Clarke|Wayne",
    county_fips_all: "28061|28067|28023|28153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39440,
    lat: 31.694,
    lng: -89.14791,
    city: "Laurel",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21365,
    density: 466.1,
    county_fips: 28067,
    county_name: "Jones",
    county_weights: {
      28067: 100,
    },
    county_names_all: "Jones",
    county_fips_all: 28067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39443,
    lat: 31.71932,
    lng: -89.07376,
    city: "Laurel",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21505,
    density: 28.4,
    county_fips: 28067,
    county_name: "Jones",
    county_weights: {
      28061: 14.04,
      28067: 68.43,
      28153: 17.53,
    },
    county_names_all: "Jones|Wayne|Jasper",
    county_fips_all: "28067|28153|28061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39451,
    lat: 31.16722,
    lng: -88.61757,
    city: "Leakesville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7377,
    density: 10.9,
    county_fips: 28041,
    county_name: "Greene",
    county_weights: {
      28041: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 28041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39452,
    lat: 30.88002,
    lng: -88.59097,
    city: "Lucedale",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26818,
    density: 19.3,
    county_fips: 28039,
    county_name: "George",
    county_weights: {
      28039: 71.96,
      28041: 16.72,
      28059: 11.32,
    },
    county_names_all: "George|Greene|Jackson",
    county_fips_all: "28039|28041|28059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39455,
    lat: 31.01084,
    lng: -89.46931,
    city: "Lumberton",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10126,
    density: 10.6,
    county_fips: 28073,
    county_name: "Lamar",
    county_weights: {
      28035: 10.67,
      28073: 45.91,
      28091: 3.78,
      28109: 31.17,
      28131: 8.47,
    },
    county_names_all: "Lamar|Pearl River|Forrest|Stone|Marion",
    county_fips_all: "28073|28109|28035|28131|28091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39456,
    lat: 31.0282,
    lng: -88.81819,
    city: "McLain",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 681,
    density: 2.3,
    county_fips: 28041,
    county_name: "Greene",
    county_weights: {
      28039: 23.89,
      28041: 46.42,
      28111: 29.69,
    },
    county_names_all: "Greene|Perry|George",
    county_fips_all: "28041|28111|28039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39459,
    lat: 31.49021,
    lng: -89.30216,
    city: "Moselle",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3816,
    density: 23.6,
    county_fips: 28067,
    county_name: "Jones",
    county_weights: {
      28067: 100,
    },
    county_names_all: "Jones",
    county_fips_all: 28067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39461,
    lat: 31.18703,
    lng: -88.73992,
    city: "Neely",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 463,
    density: 4.1,
    county_fips: 28041,
    county_name: "Greene",
    county_weights: {
      28041: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 28041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39462,
    lat: 31.22105,
    lng: -89.05738,
    city: "New Augusta",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 982,
    density: 6.7,
    county_fips: 28111,
    county_name: "Perry",
    county_weights: {
      28111: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 28111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39464,
    lat: 31.49268,
    lng: -89.06129,
    city: "Ovett",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2887,
    density: 10.5,
    county_fips: 28067,
    county_name: "Jones",
    county_weights: {
      28067: 84.33,
      28111: 15.67,
    },
    county_names_all: "Jones|Perry",
    county_fips_all: "28067|28111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39465,
    lat: 31.34456,
    lng: -89.18751,
    city: "Petal",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22111,
    density: 69.6,
    county_fips: 28035,
    county_name: "Forrest",
    county_weights: {
      28035: 76.58,
      28067: 0.58,
      28111: 22.84,
    },
    county_names_all: "Forrest|Perry|Jones",
    county_fips_all: "28035|28111|28067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39466,
    lat: 30.53328,
    lng: -89.63424,
    city: "Picayune",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28348,
    density: 71.6,
    county_fips: 28109,
    county_name: "Pearl River",
    county_weights: {
      28045: 36.67,
      28109: 63.33,
    },
    county_names_all: "Pearl River|Hancock",
    county_fips_all: "28109|28045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39470,
    lat: 30.81602,
    lng: -89.57581,
    city: "Poplarville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11978,
    density: 10.8,
    county_fips: 28109,
    county_name: "Pearl River",
    county_weights: {
      28045: 1.08,
      28109: 98.8,
      28131: 0.12,
    },
    county_names_all: "Pearl River|Hancock|Stone",
    county_fips_all: "28109|28045|28131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39474,
    lat: 31.61739,
    lng: -89.85458,
    city: "Prentiss",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5526,
    density: 13.9,
    county_fips: 28065,
    county_name: "Jefferson Davis",
    county_weights: {
      28031: 0.64,
      28065: 99.36,
    },
    county_names_all: "Jefferson Davis|Covington",
    county_fips_all: "28065|28031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39475,
    lat: 31.15496,
    lng: -89.4129,
    city: "Purvis",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13915,
    density: 33.9,
    county_fips: 28073,
    county_name: "Lamar",
    county_weights: {
      28035: 17.06,
      28073: 82.94,
    },
    county_names_all: "Lamar|Forrest",
    county_fips_all: "28073|28035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39476,
    lat: 31.37855,
    lng: -88.86764,
    city: "Richton",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7439,
    density: 6.9,
    county_fips: 28111,
    county_name: "Perry",
    county_weights: {
      28041: 32.77,
      28067: 5.7,
      28111: 41.88,
      28153: 19.65,
    },
    county_names_all: "Perry|Greene|Wayne|Jones",
    county_fips_all: "28111|28041|28153|28067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39477,
    lat: 31.79291,
    lng: -89.03579,
    city: "Sandersville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 626,
    density: 46.3,
    county_fips: 28067,
    county_name: "Jones",
    county_weights: {
      28061: 0.16,
      28067: 99.84,
    },
    county_names_all: "Jones|Jasper",
    county_fips_all: "28067|28061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39478,
    lat: 31.05306,
    lng: -89.85768,
    city: "Sandy Hook",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1961,
    density: 10.3,
    county_fips: 28091,
    county_name: "Marion",
    county_weights: {
      28091: 54.07,
      28147: 45.93,
    },
    county_names_all: "Marion|Walthall",
    county_fips_all: "28091|28147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39479,
    lat: 31.53775,
    lng: -89.46065,
    city: "Seminary",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6394,
    density: 19.9,
    county_fips: 28031,
    county_name: "Covington",
    county_weights: {
      28031: 86.88,
      28067: 13.12,
    },
    county_names_all: "Covington|Jones",
    county_fips_all: "28031|28067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39480,
    lat: 31.70889,
    lng: -89.31529,
    city: "Soso",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3201,
    density: 25.2,
    county_fips: 28067,
    county_name: "Jones",
    county_weights: {
      28061: 4.58,
      28067: 95.42,
    },
    county_names_all: "Jones|Jasper",
    county_fips_all: "28067|28061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39481,
    lat: 31.86738,
    lng: -89.24457,
    city: "Stringer",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1746,
    density: 18,
    county_fips: 28061,
    county_name: "Jasper",
    county_weights: {
      28061: 98.69,
      28129: 1.31,
    },
    county_names_all: "Jasper|Smith",
    county_fips_all: "28061|28129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39482,
    lat: 31.37271,
    lng: -89.57966,
    city: "Sumrall",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11369,
    density: 22.3,
    county_fips: 28073,
    county_name: "Lamar",
    county_weights: {
      28031: 9.39,
      28065: 15.75,
      28073: 69.05,
      28091: 5.81,
    },
    county_names_all: "Lamar|Jefferson Davis|Covington|Marion",
    county_fips_all: "28073|28065|28031|28091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39483,
    lat: 31.23515,
    lng: -89.92674,
    city: "Foxworth",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5943,
    density: 15.4,
    county_fips: 28091,
    county_name: "Marion",
    county_weights: {
      28091: 96.69,
      28147: 3.31,
    },
    county_names_all: "Marion|Walthall",
    county_fips_all: "28091|28147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39501,
    lat: 30.3857,
    lng: -89.10309,
    city: "Gulfport",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23807,
    density: 640.1,
    county_fips: 28047,
    county_name: "Harrison",
    county_weights: {
      28047: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 28047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39503,
    lat: 30.47432,
    lng: -89.14752,
    city: "Gulfport",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56418,
    density: 190.6,
    county_fips: 28047,
    county_name: "Harrison",
    county_weights: {
      28047: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 28047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39507,
    lat: 30.39945,
    lng: -89.03628,
    city: "Gulfport",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17004,
    density: 798.7,
    county_fips: 28047,
    county_name: "Harrison",
    county_weights: {
      28047: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 28047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39520,
    lat: 30.26885,
    lng: -89.47132,
    city: "Bay Saint Louis",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19072,
    density: 76,
    county_fips: 28045,
    county_name: "Hancock",
    county_weights: {
      28045: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 28045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39525,
    lat: 30.38123,
    lng: -89.37065,
    city: "Diamondhead",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8076,
    density: 297.7,
    county_fips: 28045,
    county_name: "Hancock",
    county_weights: {
      28045: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 28045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39529,
    lat: 30.37734,
    lng: -89.60211,
    city: "Stennis Space Center",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 28045,
    county_name: "Hancock",
    county_weights: {
      28045: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 28045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39530,
    lat: 30.40344,
    lng: -88.89165,
    city: "Biloxi",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7734,
    density: 663.5,
    county_fips: 28047,
    county_name: "Harrison",
    county_weights: {
      28047: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 28047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39531,
    lat: 30.40459,
    lng: -88.96735,
    city: "Biloxi",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16892,
    density: 982.3,
    county_fips: 28047,
    county_name: "Harrison",
    county_weights: {
      28047: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 28047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39532,
    lat: 30.50155,
    lng: -88.97454,
    city: "Biloxi",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37837,
    density: 177.7,
    county_fips: 28047,
    county_name: "Harrison",
    county_weights: {
      28047: 89.89,
      28059: 10.11,
    },
    county_names_all: "Harrison|Jackson",
    county_fips_all: "28047|28059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39534,
    lat: 30.40856,
    lng: -88.92122,
    city: "Biloxi",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2618,
    density: 577.1,
    county_fips: 28047,
    county_name: "Harrison",
    county_weights: {
      28047: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 28047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39540,
    lat: 30.47108,
    lng: -88.90088,
    city: "Diberville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8805,
    density: 298.6,
    county_fips: 28047,
    county_name: "Harrison",
    county_weights: {
      28047: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 28047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39553,
    lat: 30.41625,
    lng: -88.64848,
    city: "Gautier",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17437,
    density: 238.2,
    county_fips: 28059,
    county_name: "Jackson",
    county_weights: {
      28059: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 28059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39556,
    lat: 30.44457,
    lng: -89.42747,
    city: "Kiln",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7703,
    density: 29,
    county_fips: 28045,
    county_name: "Hancock",
    county_weights: {
      28045: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 28045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39560,
    lat: 30.37356,
    lng: -89.17356,
    city: "Long Beach",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17276,
    density: 329.2,
    county_fips: 28047,
    county_name: "Harrison",
    county_weights: {
      28047: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 28047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39561,
    lat: 30.70633,
    lng: -89.16049,
    city: "McHenry",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1486,
    density: 18.3,
    county_fips: 28131,
    county_name: "Stone",
    county_weights: {
      28131: 100,
    },
    county_names_all: "Stone",
    county_fips_all: 28131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39562,
    lat: 30.54573,
    lng: -88.49039,
    city: "Moss Point",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17447,
    density: 33.4,
    county_fips: 28059,
    county_name: "Jackson",
    county_weights: {
      28059: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 28059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39563,
    lat: 30.42449,
    lng: -88.52601,
    city: "Moss Point",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13396,
    density: 260.2,
    county_fips: 28059,
    county_name: "Jackson",
    county_weights: {
      28059: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 28059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39564,
    lat: 30.40518,
    lng: -88.75471,
    city: "Ocean Springs",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40946,
    density: 296.7,
    county_fips: 28059,
    county_name: "Jackson",
    county_weights: {
      28059: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 28059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39565,
    lat: 30.5759,
    lng: -88.75207,
    city: "Vancleave",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20164,
    density: 28.4,
    county_fips: 28059,
    county_name: "Jackson",
    county_weights: {
      28047: 3.76,
      28059: 96.24,
    },
    county_names_all: "Jackson|Harrison",
    county_fips_all: "28059|28047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39567,
    lat: 30.36192,
    lng: -88.55254,
    city: "Pascagoula",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11095,
    density: 668.9,
    county_fips: 28059,
    county_name: "Jackson",
    county_weights: {
      28059: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 28059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39571,
    lat: 30.41662,
    lng: -89.28125,
    city: "Pass Christian",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13709,
    density: 61.5,
    county_fips: 28047,
    county_name: "Harrison",
    county_weights: {
      28045: 4.28,
      28047: 95.72,
    },
    county_names_all: "Harrison|Hancock",
    county_fips_all: "28047|28045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39572,
    lat: 30.25089,
    lng: -89.60127,
    city: "Pearlington",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 973,
    density: 34.9,
    county_fips: 28045,
    county_name: "Hancock",
    county_weights: {
      28045: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 28045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39573,
    lat: 30.72692,
    lng: -89.08271,
    city: "Perkinston",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8476,
    density: 8,
    county_fips: 28131,
    county_name: "Stone",
    county_weights: {
      28039: 16.09,
      28045: 11.58,
      28047: 2.54,
      28059: 8.15,
      28109: 2.82,
      28131: 58.82,
    },
    county_names_all: "Stone|George|Hancock|Jackson|Pearl River|Harrison",
    county_fips_all: "28131|28039|28045|28059|28109|28047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39574,
    lat: 30.60912,
    lng: -89.10489,
    city: "Saucier",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14361,
    density: 26,
    county_fips: 28047,
    county_name: "Harrison",
    county_weights: {
      28047: 98.5,
      28131: 1.5,
    },
    county_names_all: "Harrison|Stone",
    county_fips_all: "28047|28131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39576,
    lat: 30.28699,
    lng: -89.38511,
    city: "Waveland",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5705,
    density: 337.8,
    county_fips: 28045,
    county_name: "Hancock",
    county_weights: {
      28045: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 28045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39577,
    lat: 30.90213,
    lng: -89.07971,
    city: "Wiggins",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10737,
    density: 16.4,
    county_fips: 28131,
    county_name: "Stone",
    county_weights: {
      28035: 16.7,
      28111: 28.46,
      28131: 54.84,
    },
    county_names_all: "Stone|Perry|Forrest",
    county_fips_all: "28131|28111|28035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39581,
    lat: 30.35048,
    lng: -88.49324,
    city: "Pascagoula",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10639,
    density: 293.3,
    county_fips: 28059,
    county_name: "Jackson",
    county_weights: {
      28059: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 28059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39595,
    lat: 30.33448,
    lng: -88.57587,
    city: "Pascagoula",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 28059,
    county_name: "Jackson",
    county_weights: {
      28059: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 28059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39601,
    lat: 31.56548,
    lng: -90.47762,
    city: "Brookhaven",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23635,
    density: 34.5,
    county_fips: 28085,
    county_name: "Lincoln",
    county_weights: {
      28037: 9.44,
      28085: 90.56,
    },
    county_names_all: "Lincoln|Franklin",
    county_fips_all: "28085|28037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39629,
    lat: 31.43729,
    lng: -90.45737,
    city: "Bogue Chitto",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6736,
    density: 16.9,
    county_fips: 28085,
    county_name: "Lincoln",
    county_weights: {
      28085: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 28085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39630,
    lat: 31.45939,
    lng: -90.84544,
    city: "Bude",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1101,
    density: 130.1,
    county_fips: 28037,
    county_name: "Franklin",
    county_weights: {
      28037: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 28037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39631,
    lat: 31.07321,
    lng: -91.09581,
    city: "Centreville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3442,
    density: 8.4,
    county_fips: 28157,
    county_name: "Wilkinson",
    county_weights: {
      28005: 30.37,
      28157: 69.63,
    },
    county_names_all: "Wilkinson|Amite",
    county_fips_all: "28157|28005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39633,
    lat: 31.287,
    lng: -91.16663,
    city: "Crosby",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1149,
    density: 4,
    county_fips: 28157,
    county_name: "Wilkinson",
    county_weights: {
      28005: 9.82,
      28157: 90.18,
    },
    county_names_all: "Wilkinson|Amite",
    county_fips_all: "28157|28005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39635,
    lat: 31.18432,
    lng: -90.44859,
    city: "Fernwood",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 215,
    density: 571.8,
    county_fips: 28113,
    county_name: "Pike",
    county_weights: {
      28113: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 28113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39638,
    lat: 31.22378,
    lng: -90.99747,
    city: "Gloster",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3451,
    density: 7.2,
    county_fips: 28005,
    county_name: "Amite",
    county_weights: {
      28005: 83.27,
      28157: 16.73,
    },
    county_names_all: "Amite|Wilkinson",
    county_fips_all: "28005|28157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39641,
    lat: 31.35717,
    lng: -90.17042,
    city: "Jayess",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4566,
    density: 12.5,
    county_fips: 28077,
    county_name: "Lawrence",
    county_weights: {
      28077: 50.88,
      28085: 2.3,
      28113: 6.26,
      28147: 40.56,
    },
    county_names_all: "Lawrence|Walthall|Pike|Lincoln",
    county_fips_all: "28077|28147|28113|28085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39643,
    lat: 31.24575,
    lng: -90.01368,
    city: "Kokomo",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1057,
    density: 10.3,
    county_fips: 28091,
    county_name: "Marion",
    county_weights: {
      28091: 73.77,
      28147: 26.23,
    },
    county_names_all: "Marion|Walthall",
    county_fips_all: "28091|28147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39645,
    lat: 31.1485,
    lng: -90.79399,
    city: "Liberty",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4412,
    density: 5.4,
    county_fips: 28005,
    county_name: "Amite",
    county_weights: {
      28005: 100,
    },
    county_names_all: "Amite",
    county_fips_all: 28005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39647,
    lat: 31.51498,
    lng: -90.7143,
    city: "McCall Creek",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 811,
    density: 4.3,
    county_fips: 28037,
    county_name: "Franklin",
    county_weights: {
      28037: 95.44,
      28085: 4.56,
    },
    county_names_all: "Franklin|Lincoln",
    county_fips_all: "28037|28085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39648,
    lat: 31.18611,
    lng: -90.38804,
    city: "Mccomb",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20349,
    density: 72.8,
    county_fips: 28113,
    county_name: "Pike",
    county_weights: {
      28113: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 28113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39652,
    lat: 31.11034,
    lng: -90.46701,
    city: "Magnolia",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8569,
    density: 21.1,
    county_fips: 28113,
    county_name: "Pike",
    county_weights: {
      28005: 27.41,
      28113: 72.59,
    },
    county_names_all: "Pike|Amite",
    county_fips_all: "28113|28005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39653,
    lat: 31.46055,
    lng: -90.86727,
    city: "Meadville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2304,
    density: 3.9,
    county_fips: 28037,
    county_name: "Franklin",
    county_weights: {
      28005: 1.89,
      28037: 94.21,
      28063: 3.9,
    },
    county_names_all: "Franklin|Jefferson|Amite",
    county_fips_all: "28037|28063|28005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39654,
    lat: 31.53716,
    lng: -90.13831,
    city: "Monticello",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5100,
    density: 13,
    county_fips: 28077,
    county_name: "Lawrence",
    county_weights: {
      28077: 96.82,
      28085: 3.18,
    },
    county_names_all: "Lawrence|Lincoln",
    county_fips_all: "28077|28085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39656,
    lat: 31.45055,
    lng: -89.92843,
    city: "Oak Vale",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 671,
    density: 4.7,
    county_fips: 28065,
    county_name: "Jefferson Davis",
    county_weights: {
      28065: 76.17,
      28077: 23.83,
    },
    county_names_all: "Jefferson Davis|Lawrence",
    county_fips_all: "28065|28077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39657,
    lat: 31.02727,
    lng: -90.50334,
    city: "Osyka",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1601,
    density: 6.4,
    county_fips: 28113,
    county_name: "Pike",
    county_weights: {
      28005: 42.11,
      28113: 57.62,
      28147: 0.27,
    },
    county_names_all: "Pike|Amite|Walthall",
    county_fips_all: "28113|28005|28147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39661,
    lat: 31.48704,
    lng: -91.07952,
    city: "Roxie",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2713,
    density: 4.2,
    county_fips: 28037,
    county_name: "Franklin",
    county_weights: {
      28001: 16.6,
      28037: 83.28,
      28063: 0.12,
    },
    county_names_all: "Franklin|Adams|Jefferson",
    county_fips_all: "28037|28001|28063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39662,
    lat: 31.38778,
    lng: -90.29838,
    city: "Ruth",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1237,
    density: 9.9,
    county_fips: 28085,
    county_name: "Lincoln",
    county_weights: {
      28077: 7.24,
      28085: 65.92,
      28113: 26.84,
    },
    county_names_all: "Lincoln|Pike|Lawrence",
    county_fips_all: "28085|28113|28077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39663,
    lat: 31.58615,
    lng: -90.02955,
    city: "Silver Creek",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2424,
    density: 7.4,
    county_fips: 28077,
    county_name: "Lawrence",
    county_weights: {
      28065: 6.72,
      28077: 93.28,
    },
    county_names_all: "Lawrence|Jefferson Davis",
    county_fips_all: "28077|28065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39664,
    lat: 31.32894,
    lng: -90.68252,
    city: "Smithdale",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1909,
    density: 6.5,
    county_fips: 28005,
    county_name: "Amite",
    county_weights: {
      28005: 58.32,
      28037: 31.76,
      28085: 9.92,
    },
    county_names_all: "Amite|Franklin|Lincoln",
    county_fips_all: "28005|28037|28085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39665,
    lat: 31.64125,
    lng: -90.21404,
    city: "Sontag",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1985,
    density: 12.8,
    county_fips: 28077,
    county_name: "Lawrence",
    county_weights: {
      28077: 75.09,
      28085: 24.91,
    },
    county_names_all: "Lawrence|Lincoln",
    county_fips_all: "28077|28085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39666,
    lat: 31.2853,
    lng: -90.48857,
    city: "Summit",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9976,
    density: 23.6,
    county_fips: 28113,
    county_name: "Pike",
    county_weights: {
      28005: 30.12,
      28085: 10.39,
      28113: 59.49,
    },
    county_names_all: "Pike|Amite|Lincoln",
    county_fips_all: "28113|28005|28085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39667,
    lat: 31.1298,
    lng: -90.12656,
    city: "Tylertown",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11543,
    density: 14.1,
    county_fips: 28147,
    county_name: "Walthall",
    county_weights: {
      28091: 2.15,
      28113: 4.13,
      28147: 93.72,
    },
    county_names_all: "Walthall|Pike|Marion",
    county_fips_all: "28147|28113|28091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39668,
    lat: 31.69126,
    lng: -90.79126,
    city: "Union Church",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1121,
    density: 4,
    county_fips: 28063,
    county_name: "Jefferson",
    county_weights: {
      28029: 0.55,
      28037: 2.1,
      28063: 81.43,
      28085: 15.91,
    },
    county_names_all: "Jefferson|Lincoln|Franklin|Copiah",
    county_fips_all: "28063|28085|28037|28029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39669,
    lat: 31.14966,
    lng: -91.39547,
    city: "Woodville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5468,
    density: 4.8,
    county_fips: 28157,
    county_name: "Wilkinson",
    county_weights: {
      28157: 100,
    },
    county_names_all: "Wilkinson",
    county_fips_all: 28157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39701,
    lat: 33.41091,
    lng: -88.50807,
    city: "Columbus",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12798,
    density: 25.9,
    county_fips: 28087,
    county_name: "Lowndes",
    county_weights: {
      28087: 100,
    },
    county_names_all: "Lowndes",
    county_fips_all: 28087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39702,
    lat: 33.43876,
    lng: -88.34493,
    city: "Columbus",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23967,
    density: 92.6,
    county_fips: 28087,
    county_name: "Lowndes",
    county_weights: {
      28087: 100,
    },
    county_names_all: "Lowndes",
    county_fips_all: 28087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39705,
    lat: 33.58669,
    lng: -88.43705,
    city: "Columbus",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12254,
    density: 71.6,
    county_fips: 28087,
    county_name: "Lowndes",
    county_weights: {
      28087: 100,
    },
    county_names_all: "Lowndes",
    county_fips_all: 28087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39730,
    lat: 33.83926,
    lng: -88.56267,
    city: "Aberdeen",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12419,
    density: 19.2,
    county_fips: 28095,
    county_name: "Monroe",
    county_weights: {
      28095: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 28095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39735,
    lat: 33.34511,
    lng: -89.18998,
    city: "Ackerman",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3794,
    density: 9.9,
    county_fips: 28019,
    county_name: "Choctaw",
    county_weights: {
      28019: 100,
    },
    county_names_all: "Choctaw",
    county_fips_all: 28019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39736,
    lat: 33.4169,
    lng: -88.64178,
    city: "Artesia",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 272,
    density: 167,
    county_fips: 28087,
    county_name: "Lowndes",
    county_weights: {
      28087: 100,
    },
    county_names_all: "Lowndes",
    county_fips_all: 28087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39737,
    lat: 33.65211,
    lng: -89.33573,
    city: "Bellefontaine",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 166,
    density: 3.7,
    county_fips: 28155,
    county_name: "Webster",
    county_weights: {
      28155: 100,
    },
    county_names_all: "Webster",
    county_fips_all: 28155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39739,
    lat: 33.23843,
    lng: -88.57855,
    city: "Brooksville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2513,
    density: 5.5,
    county_fips: 28103,
    county_name: "Noxubee",
    county_weights: {
      28103: 100,
    },
    county_names_all: "Noxubee",
    county_fips_all: 28103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39740,
    lat: 33.71668,
    lng: -88.31287,
    city: "Caledonia",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5951,
    density: 28.9,
    county_fips: 28087,
    county_name: "Lowndes",
    county_weights: {
      28087: 68.23,
      28095: 31.77,
    },
    county_names_all: "Lowndes|Monroe",
    county_fips_all: "28087|28095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39741,
    lat: 33.65254,
    lng: -88.85536,
    city: "Cedarbluff",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1789,
    density: 9.7,
    county_fips: 28025,
    county_name: "Clay",
    county_weights: {
      28025: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 28025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39743,
    lat: 33.31913,
    lng: -88.61308,
    city: "Crawford",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1893,
    density: 10.5,
    county_fips: 28087,
    county_name: "Lowndes",
    county_weights: {
      28087: 71.69,
      28103: 5.66,
      28105: 22.65,
    },
    county_names_all: "Lowndes|Oktibbeha|Noxubee",
    county_fips_all: "28087|28105|28103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39744,
    lat: 33.58344,
    lng: -89.30374,
    city: "Eupora",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5503,
    density: 8.7,
    county_fips: 28155,
    county_name: "Webster",
    county_weights: {
      28013: 5.13,
      28019: 15.94,
      28155: 78.93,
    },
    county_names_all: "Webster|Choctaw|Calhoun",
    county_fips_all: "28155|28019|28013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39745,
    lat: 33.29984,
    lng: -89.46277,
    city: "French Camp",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 686,
    density: 4.3,
    county_fips: 28007,
    county_name: "Attala",
    county_weights: {
      28007: 37.14,
      28019: 35.15,
      28097: 27.7,
    },
    county_names_all: "Attala|Choctaw|Montgomery",
    county_fips_all: "28007|28019|28097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39746,
    lat: 33.74697,
    lng: -88.41544,
    city: "Hamilton",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2353,
    density: 10.3,
    county_fips: 28095,
    county_name: "Monroe",
    county_weights: {
      28095: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 28095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39747,
    lat: 33.42283,
    lng: -89.5538,
    city: "Kilmichael",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1426,
    density: 4.3,
    county_fips: 28097,
    county_name: "Montgomery",
    county_weights: {
      28097: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 28097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39750,
    lat: 33.56331,
    lng: -89.05751,
    city: "Maben",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2525,
    density: 10.7,
    county_fips: 28155,
    county_name: "Webster",
    county_weights: {
      28019: 2.8,
      28025: 10.82,
      28105: 40.32,
      28155: 46.06,
    },
    county_names_all: "Webster|Oktibbeha|Clay|Choctaw",
    county_fips_all: "28155|28105|28025|28019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39751,
    lat: 33.70444,
    lng: -89.10004,
    city: "Mantee",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1425,
    density: 7.2,
    county_fips: 28155,
    county_name: "Webster",
    county_weights: {
      28017: 12.12,
      28025: 20.76,
      28155: 67.12,
    },
    county_names_all: "Webster|Clay|Chickasaw",
    county_fips_all: "28155|28025|28017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39752,
    lat: 33.5198,
    lng: -89.15427,
    city: "Mathiston",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2568,
    density: 13.5,
    county_fips: 28019,
    county_name: "Choctaw",
    county_weights: {
      28019: 66.56,
      28155: 33.44,
    },
    county_names_all: "Choctaw|Webster",
    county_fips_all: "28019|28155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39753,
    lat: 33.48441,
    lng: -88.63052,
    city: "Mayhew",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 28087,
    county_name: "Lowndes",
    county_weights: {
      28087: 100,
    },
    county_names_all: "Lowndes",
    county_fips_all: 28087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39755,
    lat: 33.61275,
    lng: -88.95138,
    city: "Pheba",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 755,
    density: 4.1,
    county_fips: 28025,
    county_name: "Clay",
    county_weights: {
      28025: 80.15,
      28105: 19.85,
    },
    county_names_all: "Clay|Oktibbeha",
    county_fips_all: "28025|28105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39756,
    lat: 33.78356,
    lng: -88.74266,
    city: "Prairie",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1997,
    density: 11,
    county_fips: 28025,
    county_name: "Clay",
    county_weights: {
      28017: 14.11,
      28025: 46.1,
      28095: 39.79,
    },
    county_names_all: "Clay|Monroe|Chickasaw",
    county_fips_all: "28025|28095|28017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39759,
    lat: 33.43491,
    lng: -88.82631,
    city: "Starkville",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43941,
    density: 52.4,
    county_fips: 28105,
    county_name: "Oktibbeha",
    county_weights: {
      28087: 2.64,
      28105: 97.36,
    },
    county_names_all: "Oktibbeha|Lowndes",
    county_fips_all: "28105|28087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39762,
    lat: 33.44648,
    lng: -88.79576,
    city: "Mississippi State",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2730,
    density: 858.8,
    county_fips: 28105,
    county_name: "Oktibbeha",
    county_weights: {
      28105: 100,
    },
    county_names_all: "Oktibbeha",
    county_fips_all: 28105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39766,
    lat: 33.5876,
    lng: -88.31598,
    city: "Steens",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2692,
    density: 29.6,
    county_fips: 28087,
    county_name: "Lowndes",
    county_weights: {
      28087: 100,
    },
    county_names_all: "Lowndes",
    county_fips_all: 28087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39767,
    lat: 33.47263,
    lng: -89.45001,
    city: "Stewart",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 942,
    density: 4.3,
    county_fips: 28155,
    county_name: "Webster",
    county_weights: {
      28019: 26.46,
      28097: 19.93,
      28155: 53.61,
    },
    county_names_all: "Webster|Choctaw|Montgomery",
    county_fips_all: "28155|28019|28097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39769,
    lat: 33.31867,
    lng: -89.01136,
    city: "Sturgis",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1252,
    density: 3.7,
    county_fips: 28105,
    county_name: "Oktibbeha",
    county_weights: {
      28019: 5.38,
      28105: 57.86,
      28159: 36.76,
    },
    county_names_all: "Oktibbeha|Winston|Choctaw",
    county_fips_all: "28105|28159|28019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39771,
    lat: 33.60694,
    lng: -89.27873,
    city: "Walthall",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 134,
    density: 53.1,
    county_fips: 28155,
    county_name: "Webster",
    county_weights: {
      28155: 100,
    },
    county_names_all: "Webster",
    county_fips_all: 28155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39772,
    lat: 33.30509,
    lng: -89.29893,
    city: "Weir",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1700,
    density: 8.1,
    county_fips: 28019,
    county_name: "Choctaw",
    county_weights: {
      28007: 5.06,
      28019: 92.31,
      28159: 2.63,
    },
    county_names_all: "Choctaw|Attala|Winston",
    county_fips_all: "28019|28007|28159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39773,
    lat: 33.63892,
    lng: -88.67558,
    city: "West Point",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15329,
    density: 26.9,
    county_fips: 28025,
    county_name: "Clay",
    county_weights: {
      28025: 94.86,
      28095: 5.14,
    },
    county_names_all: "Clay|Monroe",
    county_fips_all: "28025|28095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39776,
    lat: 33.78517,
    lng: -89.03239,
    city: "Woodland",
    state_id: "MS",
    state_name: "Mississippi",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1278,
    density: 5.8,
    county_fips: 28017,
    county_name: "Chickasaw",
    county_weights: {
      28017: 81.36,
      28025: 18.64,
    },
    county_names_all: "Chickasaw|Clay",
    county_fips_all: "28017|28025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 39813,
    lat: 31.42631,
    lng: -84.68361,
    city: "Arlington",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2109,
    density: 6.1,
    county_fips: 13037,
    county_name: "Calhoun",
    county_weights: {
      13007: 13.38,
      13037: 46.82,
      13099: 39.8,
    },
    county_names_all: "Calhoun|Early|Baker",
    county_fips_all: "13037|13099|13007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39815,
    lat: 30.74138,
    lng: -84.4935,
    city: "Attapulgus",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1754,
    density: 12.4,
    county_fips: 13087,
    county_name: "Decatur",
    county_weights: {
      13087: 100,
    },
    county_names_all: "Decatur",
    county_fips_all: 13087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39817,
    lat: 30.93953,
    lng: -84.59132,
    city: "Bainbridge",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10633,
    density: 28.4,
    county_fips: 13087,
    county_name: "Decatur",
    county_weights: {
      13087: 100,
    },
    county_names_all: "Decatur",
    county_fips_all: 13087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39819,
    lat: 30.78485,
    lng: -84.64297,
    city: "Bainbridge",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10492,
    density: 27,
    county_fips: 13087,
    county_name: "Decatur",
    county_weights: {
      13087: 100,
    },
    county_names_all: "Decatur",
    county_fips_all: 13087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39823,
    lat: 31.34004,
    lng: -84.94641,
    city: "Blakely",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7923,
    density: 8.8,
    county_fips: 13099,
    county_name: "Early",
    county_weights: {
      13099: 95.24,
      13201: 4.76,
    },
    county_names_all: "Early|Miller",
    county_fips_all: "13099|13201",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39824,
    lat: 31.52882,
    lng: -84.86552,
    city: "Bluffton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 873,
    density: 8.2,
    county_fips: 13061,
    county_name: "Clay",
    county_weights: {
      13061: 70.74,
      13099: 29.26,
    },
    county_names_all: "Clay|Early",
    county_fips_all: "13061|13099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39825,
    lat: 30.92359,
    lng: -84.73496,
    city: "Brinson",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1314,
    density: 5.4,
    county_fips: 13087,
    county_name: "Decatur",
    county_weights: {
      13087: 85.41,
      13253: 14.59,
    },
    county_names_all: "Decatur|Seminole",
    county_fips_all: "13087|13253",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39826,
    lat: 31.82092,
    lng: -84.32423,
    city: "Bronwood",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 507,
    density: 5.8,
    county_fips: 13273,
    county_name: "Terrell",
    county_weights: {
      13273: 100,
    },
    county_names_all: "Terrell",
    county_fips_all: 13273,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39827,
    lat: 30.94911,
    lng: -84.21674,
    city: "Cairo",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4175,
    density: 23.1,
    county_fips: 13131,
    county_name: "Grady",
    county_weights: {
      13131: 100,
    },
    county_names_all: "Grady",
    county_fips_all: 13131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39828,
    lat: 30.79741,
    lng: -84.22444,
    city: "Cairo",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14539,
    density: 41.3,
    county_fips: 13131,
    county_name: "Grady",
    county_weights: {
      13131: 100,
    },
    county_names_all: "Grady",
    county_fips_all: 13131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39832,
    lat: 31.19304,
    lng: -85.0257,
    city: "Cedar Springs",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 13099,
    county_name: "Early",
    county_weights: {
      13099: 100,
    },
    county_names_all: "Early",
    county_fips_all: 13099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39834,
    lat: 30.89298,
    lng: -84.42749,
    city: "Climax",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2106,
    density: 6.7,
    county_fips: 13087,
    county_name: "Decatur",
    county_weights: {
      13087: 100,
    },
    county_names_all: "Decatur",
    county_fips_all: 13087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39836,
    lat: 31.66293,
    lng: -84.87726,
    city: "Coleman",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 301,
    density: 1.6,
    county_fips: 13243,
    county_name: "Randolph",
    county_weights: {
      13061: 13.83,
      13243: 86.17,
    },
    county_names_all: "Randolph|Clay",
    county_fips_all: "13243|13061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39837,
    lat: 31.15321,
    lng: -84.67283,
    city: "Colquitt",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6113,
    density: 8.2,
    county_fips: 13201,
    county_name: "Miller",
    county_weights: {
      13007: 11.34,
      13087: 10.05,
      13099: 0.39,
      13201: 78.22,
    },
    county_names_all: "Miller|Baker|Decatur|Early",
    county_fips_all: "13201|13007|13087|13099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39840,
    lat: 31.78874,
    lng: -84.75986,
    city: "Cuthbert",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5297,
    density: 9.2,
    county_fips: 13243,
    county_name: "Randolph",
    county_weights: {
      13243: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 13243,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39841,
    lat: 31.29031,
    lng: -84.69124,
    city: "Damascus",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 671,
    density: 3.6,
    county_fips: 13099,
    county_name: "Early",
    county_weights: {
      13007: 17.48,
      13099: 70.88,
      13201: 11.64,
    },
    county_names_all: "Early|Baker|Miller",
    county_fips_all: "13099|13007|13201",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39842,
    lat: 31.75837,
    lng: -84.44314,
    city: "Dawson",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7471,
    density: 10.7,
    county_fips: 13273,
    county_name: "Terrell",
    county_weights: {
      13037: 0.27,
      13273: 99.73,
    },
    county_names_all: "Terrell|Calhoun",
    county_fips_all: "13273|13037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39845,
    lat: 30.95011,
    lng: -84.89329,
    city: "Donalsonville",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7444,
    density: 14.8,
    county_fips: 13253,
    county_name: "Seminole",
    county_weights: {
      13099: 0.42,
      13201: 14.12,
      13253: 85.46,
    },
    county_names_all: "Seminole|Miller|Early",
    county_fips_all: "13253|13201|13099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39846,
    lat: 31.56841,
    lng: -84.74271,
    city: "Edison",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1882,
    density: 9.1,
    county_fips: 13037,
    county_name: "Calhoun",
    county_weights: {
      13037: 90.72,
      13061: 8.04,
      13243: 1.24,
    },
    county_names_all: "Calhoun|Clay|Randolph",
    county_fips_all: "13037|13061|13243",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39851,
    lat: 31.63432,
    lng: -85.00086,
    city: "Fort Gaines",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1730,
    density: 4.9,
    county_fips: 13061,
    county_name: "Clay",
    county_weights: {
      13061: 92.05,
      13243: 7.95,
    },
    county_names_all: "Clay|Randolph",
    county_fips_all: "13061|13243",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39854,
    lat: 31.86713,
    lng: -85.04881,
    city: "Georgetown",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2433,
    density: 8.2,
    county_fips: 13239,
    county_name: "Quitman",
    county_weights: {
      13061: 5.97,
      13239: 94.03,
    },
    county_names_all: "Quitman|Clay",
    county_fips_all: "13239|13061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39859,
    lat: 30.99493,
    lng: -84.80731,
    city: "Iron City",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1084,
    density: 7,
    county_fips: 13253,
    county_name: "Seminole",
    county_weights: {
      13201: 3.26,
      13253: 96.74,
    },
    county_names_all: "Seminole|Miller",
    county_fips_all: "13253|13201",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39861,
    lat: 31.13635,
    lng: -84.9884,
    city: "Jakin",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 932,
    density: 5.8,
    county_fips: 13099,
    county_name: "Early",
    county_weights: {
      13099: 97.96,
      13253: 2.04,
    },
    county_names_all: "Early|Seminole",
    county_fips_all: "13099|13253",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39862,
    lat: 31.45694,
    lng: -84.51615,
    city: "Leary",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1017,
    density: 2.7,
    county_fips: 13037,
    county_name: "Calhoun",
    county_weights: {
      13007: 41.49,
      13037: 58.51,
    },
    county_names_all: "Calhoun|Baker",
    county_fips_all: "13037|13007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39866,
    lat: 31.55954,
    lng: -84.60553,
    city: "Morgan",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2201,
    density: 14.4,
    county_fips: 13037,
    county_name: "Calhoun",
    county_weights: {
      13037: 95.77,
      13243: 4.23,
    },
    county_names_all: "Calhoun|Randolph",
    county_fips_all: "13037|13243",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39867,
    lat: 31.84076,
    lng: -84.93684,
    city: "Morris",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 415,
    density: 1.7,
    county_fips: 13239,
    county_name: "Quitman",
    county_weights: {
      13061: 19.05,
      13239: 45.22,
      13243: 26.59,
      13259: 9.15,
    },
    county_names_all: "Quitman|Randolph|Clay|Stewart",
    county_fips_all: "13239|13243|13061|13259",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39870,
    lat: 31.31944,
    lng: -84.41071,
    city: "Newton",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1994,
    density: 4.2,
    county_fips: 13007,
    county_name: "Baker",
    county_weights: {
      13007: 100,
    },
    county_names_all: "Baker",
    county_fips_all: 13007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39877,
    lat: 31.9183,
    lng: -84.50647,
    city: "Parrott",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 446,
    density: 4,
    county_fips: 13273,
    county_name: "Terrell",
    county_weights: {
      13273: 62.88,
      13307: 37.12,
    },
    county_names_all: "Terrell|Webster",
    county_fips_all: "13273|13307",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39885,
    lat: 31.72189,
    lng: -84.34304,
    city: "Sasser",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 13273,
    county_name: "Terrell",
    county_weights: {
      13273: 100,
    },
    county_names_all: "Terrell",
    county_fips_all: 13273,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39886,
    lat: 31.73469,
    lng: -84.61554,
    city: "Shellman",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1492,
    density: 5.5,
    county_fips: 13243,
    county_name: "Randolph",
    county_weights: {
      13037: 2.88,
      13243: 92.83,
      13273: 4.29,
    },
    county_names_all: "Randolph|Terrell|Calhoun",
    county_fips_all: "13243|13273|13037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 39897,
    lat: 30.91234,
    lng: -84.33297,
    city: "Whigham",
    state_id: "GA",
    state_name: "Georgia",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3534,
    density: 10,
    county_fips: 13131,
    county_name: "Grady",
    county_weights: {
      13087: 8.02,
      13131: 91.98,
    },
    county_names_all: "Grady|Decatur",
    county_fips_all: "13131|13087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40003,
    lat: 38.26863,
    lng: -85.04367,
    city: "Bagdad",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2012,
    density: 17.9,
    county_fips: 21211,
    county_name: "Shelby",
    county_weights: {
      21073: 7.4,
      21211: 92.6,
    },
    county_names_all: "Shelby|Franklin",
    county_fips_all: "21211|21073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40004,
    lat: 37.80279,
    lng: -85.4695,
    city: "Bardstown",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29892,
    density: 79.4,
    county_fips: 21179,
    county_name: "Nelson",
    county_weights: {
      21179: 100,
    },
    county_names_all: "Nelson",
    county_fips_all: 21179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40006,
    lat: 38.59626,
    lng: -85.32861,
    city: "Bedford",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4459,
    density: 18.9,
    county_fips: 21223,
    county_name: "Trimble",
    county_weights: {
      21041: 1.1,
      21223: 98.9,
    },
    county_names_all: "Trimble|Carroll",
    county_fips_all: "21223|21041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40007,
    lat: 38.4524,
    lng: -85.00176,
    city: "Bethlehem",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50,
    density: 2.4,
    county_fips: 21103,
    county_name: "Henry",
    county_weights: {
      21103: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 21103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40008,
    lat: 37.91735,
    lng: -85.28097,
    city: "Bloomfield",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3173,
    density: 13.6,
    county_fips: 21179,
    county_name: "Nelson",
    county_weights: {
      21179: 82.05,
      21215: 17.95,
    },
    county_names_all: "Nelson|Spencer",
    county_fips_all: "21179|21215",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40009,
    lat: 37.47075,
    lng: -85.099,
    city: "Bradfordsville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1277,
    density: 7.7,
    county_fips: 21155,
    county_name: "Marion",
    county_weights: {
      21045: 5.91,
      21155: 72.7,
      21217: 21.39,
    },
    county_names_all: "Marion|Taylor|Casey",
    county_fips_all: "21155|21217|21045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40010,
    lat: 38.37226,
    lng: -85.45431,
    city: "Buckner",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 687,
    density: 173,
    county_fips: 21185,
    county_name: "Oldham",
    county_weights: {
      21185: 100,
    },
    county_names_all: "Oldham",
    county_fips_all: 21185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40011,
    lat: 38.53048,
    lng: -85.1718,
    city: "Campbellsburg",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2973,
    density: 22.1,
    county_fips: 21103,
    county_name: "Henry",
    county_weights: {
      21041: 8.48,
      21103: 71.5,
      21223: 20.02,
    },
    county_names_all: "Henry|Trimble|Carroll",
    county_fips_all: "21103|21223|21041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40012,
    lat: 37.90697,
    lng: -85.17376,
    city: "Chaplin",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 864,
    density: 30,
    county_fips: 21179,
    county_name: "Nelson",
    county_weights: {
      21005: 21.96,
      21179: 78.04,
    },
    county_names_all: "Nelson|Anderson",
    county_fips_all: "21179|21005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40013,
    lat: 37.93427,
    lng: -85.48684,
    city: "Coxs Creek",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5558,
    density: 28.4,
    county_fips: 21179,
    county_name: "Nelson",
    county_weights: {
      21029: 9.7,
      21179: 76.57,
      21215: 13.73,
    },
    county_names_all: "Nelson|Spencer|Bullitt",
    county_fips_all: "21179|21215|21029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40014,
    lat: 38.3412,
    lng: -85.43181,
    city: "Crestwood",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22844,
    density: 169.4,
    county_fips: 21185,
    county_name: "Oldham",
    county_weights: {
      21185: 100,
    },
    county_names_all: "Oldham",
    county_fips_all: 21185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40019,
    lat: 38.37416,
    lng: -85.17437,
    city: "Eminence",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4044,
    density: 40.3,
    county_fips: 21103,
    county_name: "Henry",
    county_weights: {
      21103: 70.92,
      21211: 29.08,
    },
    county_names_all: "Henry|Shelby",
    county_fips_all: "21103|21211",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40020,
    lat: 37.93503,
    lng: -85.38753,
    city: "Fairfield",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 226,
    density: 183.8,
    county_fips: 21179,
    county_name: "Nelson",
    county_weights: {
      21179: 100,
    },
    county_names_all: "Nelson",
    county_fips_all: 21179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40022,
    lat: 38.15242,
    lng: -85.3341,
    city: "Finchville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 957,
    density: 22.6,
    county_fips: 21211,
    county_name: "Shelby",
    county_weights: {
      21211: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 21211,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40023,
    lat: 38.16264,
    lng: -85.42367,
    city: "Fisherville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5067,
    density: 80.6,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 59.93,
      21211: 7.71,
      21215: 32.36,
    },
    county_names_all: "Jefferson|Spencer|Shelby",
    county_fips_all: "21111|21215|21211",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40025,
    lat: 38.30133,
    lng: -85.65202,
    city: "Glenview",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 133,
    density: 39.9,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40026,
    lat: 38.42687,
    lng: -85.52902,
    city: "Goshen",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6313,
    density: 78.7,
    county_fips: 21185,
    county_name: "Oldham",
    county_weights: {
      21185: 100,
    },
    county_names_all: "Oldham",
    county_fips_all: 21185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40031,
    lat: 38.42617,
    lng: -85.39368,
    city: "La Grange",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23907,
    density: 138,
    county_fips: 21185,
    county_name: "Oldham",
    county_weights: {
      21103: 6.45,
      21185: 93.55,
    },
    county_names_all: "Oldham|Henry",
    county_fips_all: "21185|21103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40033,
    lat: 37.55935,
    lng: -85.23928,
    city: "Lebanon",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12032,
    density: 33.1,
    county_fips: 21155,
    county_name: "Marion",
    county_weights: {
      21155: 97.83,
      21229: 2.17,
    },
    county_names_all: "Marion|Washington",
    county_fips_all: "21155|21229",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40036,
    lat: 38.44317,
    lng: -84.97272,
    city: "Lockport",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 286,
    density: 4.2,
    county_fips: 21103,
    county_name: "Henry",
    county_weights: {
      21103: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 21103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40037,
    lat: 37.65409,
    lng: -85.41196,
    city: "Loretto",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2857,
    density: 22,
    county_fips: 21155,
    county_name: "Marion",
    county_weights: {
      21155: 87.97,
      21179: 11.47,
      21229: 0.56,
    },
    county_names_all: "Marion|Nelson|Washington",
    county_fips_all: "21155|21179|21229",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40040,
    lat: 37.77433,
    lng: -85.05727,
    city: "Mackville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 386,
    density: 8.3,
    county_fips: 21229,
    county_name: "Washington",
    county_weights: {
      21229: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 21229,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40041,
    lat: 38.25615,
    lng: -85.66475,
    city: "Masonic Home",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 422,
    density: 1253,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40045,
    lat: 38.69376,
    lng: -85.35641,
    city: "Milton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3780,
    density: 28,
    county_fips: 21223,
    county_name: "Trimble",
    county_weights: {
      21041: 27.68,
      21223: 72.32,
    },
    county_names_all: "Trimble|Carroll",
    county_fips_all: "21223|21041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40046,
    lat: 38.02324,
    lng: -85.17729,
    city: "Mount Eden",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1392,
    density: 11,
    county_fips: 21215,
    county_name: "Spencer",
    county_weights: {
      21005: 16.73,
      21211: 7.09,
      21215: 76.18,
    },
    county_names_all: "Spencer|Anderson|Shelby",
    county_fips_all: "21215|21005|21211",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40047,
    lat: 38.04007,
    lng: -85.55453,
    city: "Mount Washington",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18898,
    density: 244.1,
    county_fips: 21029,
    county_name: "Bullitt",
    county_weights: {
      21029: 95.35,
      21111: 0.38,
      21215: 4.27,
    },
    county_names_all: "Bullitt|Spencer|Jefferson",
    county_fips_all: "21029|21215|21111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40049,
    lat: 37.66442,
    lng: -85.39724,
    city: "Nerinx",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 116,
    density: 140.4,
    county_fips: 21155,
    county_name: "Marion",
    county_weights: {
      21155: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 21155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40050,
    lat: 38.44596,
    lng: -85.17753,
    city: "New Castle",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1460,
    density: 32.7,
    county_fips: 21103,
    county_name: "Henry",
    county_weights: {
      21103: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 21103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40051,
    lat: 37.65293,
    lng: -85.57949,
    city: "New Haven",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4656,
    density: 19.8,
    county_fips: 21179,
    county_name: "Nelson",
    county_weights: {
      21093: 3.23,
      21123: 28.56,
      21179: 68.21,
    },
    county_names_all: "Nelson|Larue|Hardin",
    county_fips_all: "21179|21123|21093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40052,
    lat: 37.58417,
    lng: -85.51154,
    city: "New Hope",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 432,
    density: 7.3,
    county_fips: 21179,
    county_name: "Nelson",
    county_weights: {
      21123: 37.02,
      21155: 18.07,
      21179: 44.91,
    },
    county_names_all: "Nelson|Larue|Marion",
    county_fips_all: "21179|21123|21155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40055,
    lat: 38.49889,
    lng: -85.32867,
    city: "Pendleton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2153,
    density: 35.3,
    county_fips: 21223,
    county_name: "Trimble",
    county_weights: {
      21103: 29.58,
      21185: 22.76,
      21223: 47.67,
    },
    county_names_all: "Trimble|Henry|Oldham",
    county_fips_all: "21223|21103|21185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40056,
    lat: 38.30654,
    lng: -85.48784,
    city: "Pewee Valley",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3264,
    density: 426.9,
    county_fips: 21185,
    county_name: "Oldham",
    county_weights: {
      21185: 100,
    },
    county_names_all: "Oldham",
    county_fips_all: 21185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40057,
    lat: 38.38636,
    lng: -85.0491,
    city: "Pleasureville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4031,
    density: 16.5,
    county_fips: 21103,
    county_name: "Henry",
    county_weights: {
      21103: 80.26,
      21211: 19.74,
    },
    county_names_all: "Henry|Shelby",
    county_fips_all: "21103|21211",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40058,
    lat: 38.43265,
    lng: -85.17002,
    city: "Port Royal",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 79,
    density: 1541.9,
    county_fips: 21103,
    county_name: "Henry",
    county_weights: {
      21103: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 21103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40059,
    lat: 38.35784,
    lng: -85.58441,
    city: "Prospect",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20869,
    density: 286,
    county_fips: 21185,
    county_name: "Oldham",
    county_weights: {
      21111: 39.38,
      21185: 60.62,
    },
    county_names_all: "Oldham|Jefferson",
    county_fips_all: "21185|21111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40060,
    lat: 37.53529,
    lng: -85.44371,
    city: "Raywick",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1294,
    density: 12,
    county_fips: 21155,
    county_name: "Marion",
    county_weights: {
      21155: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 21155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40061,
    lat: 37.70954,
    lng: -85.26353,
    city: "Saint Catharine",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 21229,
    county_name: "Washington",
    county_weights: {
      21229: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 21229,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40062,
    lat: 37.59969,
    lng: -85.43161,
    city: "Saint Francis",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 162,
    density: 10.9,
    county_fips: 21155,
    county_name: "Marion",
    county_weights: {
      21155: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 21155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40063,
    lat: 37.57052,
    lng: -85.34336,
    city: "Saint Mary",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 505,
    density: 2601.4,
    county_fips: 21155,
    county_name: "Marion",
    county_weights: {
      21155: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 21155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40065,
    lat: 38.21225,
    lng: -85.20734,
    city: "Shelbyville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30561,
    density: 70.4,
    county_fips: 21211,
    county_name: "Shelby",
    county_weights: {
      21211: 99.53,
      21215: 0.47,
    },
    county_names_all: "Shelby|Spencer",
    county_fips_all: "21211|21215",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40067,
    lat: 38.2269,
    lng: -85.364,
    city: "Simpsonville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6783,
    density: 60.2,
    county_fips: 21211,
    county_name: "Shelby",
    county_weights: {
      21211: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 21211,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40068,
    lat: 38.38933,
    lng: -85.27131,
    city: "Smithfield",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2237,
    density: 20,
    county_fips: 21103,
    county_name: "Henry",
    county_weights: {
      21103: 68.97,
      21185: 14.33,
      21211: 16.7,
    },
    county_names_all: "Henry|Shelby|Oldham",
    county_fips_all: "21103|21211|21185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40069,
    lat: 37.71627,
    lng: -85.21764,
    city: "Springfield",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8590,
    density: 17.6,
    county_fips: 21229,
    county_name: "Washington",
    county_weights: {
      21155: 2.27,
      21229: 97.73,
    },
    county_names_all: "Washington|Marion",
    county_fips_all: "21229|21155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40070,
    lat: 38.47969,
    lng: -85.24405,
    city: "Sulphur",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 488,
    density: 15,
    county_fips: 21103,
    county_name: "Henry",
    county_weights: {
      21103: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 21103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40071,
    lat: 38.04327,
    lng: -85.37069,
    city: "Taylorsville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16314,
    density: 51.9,
    county_fips: 21215,
    county_name: "Spencer",
    county_weights: {
      21029: 5.02,
      21211: 1.11,
      21215: 93.87,
    },
    county_names_all: "Spencer|Bullitt|Shelby",
    county_fips_all: "21215|21029|21211",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40075,
    lat: 38.56169,
    lng: -85.11346,
    city: "Turners Station",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1009,
    density: 8,
    county_fips: 21103,
    county_name: "Henry",
    county_weights: {
      21041: 21.19,
      21103: 78.81,
    },
    county_names_all: "Henry|Carroll",
    county_fips_all: "21103|21041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40076,
    lat: 38.11301,
    lng: -85.08671,
    city: "Waddy",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3215,
    density: 21.7,
    county_fips: 21211,
    county_name: "Shelby",
    county_weights: {
      21005: 8.58,
      21073: 3.77,
      21211: 86.89,
      21215: 0.76,
    },
    county_names_all: "Shelby|Anderson|Franklin|Spencer",
    county_fips_all: "21211|21005|21073|21215",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40077,
    lat: 38.49996,
    lng: -85.43768,
    city: "Westport",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 555,
    density: 27.6,
    county_fips: 21185,
    county_name: "Oldham",
    county_weights: {
      21185: 100,
    },
    county_names_all: "Oldham",
    county_fips_all: 21185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40078,
    lat: 37.84272,
    lng: -85.14902,
    city: "Willisburg",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2585,
    density: 16.3,
    county_fips: 21229,
    county_name: "Washington",
    county_weights: {
      21229: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 21229,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40104,
    lat: 38.09012,
    lng: -86.34053,
    city: "Battletown",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1019,
    density: 6.6,
    county_fips: 21163,
    county_name: "Meade",
    county_weights: {
      21163: 100,
    },
    county_names_all: "Meade",
    county_fips_all: 21163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40107,
    lat: 37.76952,
    lng: -85.63798,
    city: "Boston",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2470,
    density: 18.1,
    county_fips: 21179,
    county_name: "Nelson",
    county_weights: {
      21179: 100,
    },
    county_names_all: "Nelson",
    county_fips_all: 21179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40108,
    lat: 37.96964,
    lng: -86.16791,
    city: "Brandenburg",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12190,
    density: 68.2,
    county_fips: 21163,
    county_name: "Meade",
    county_weights: {
      21163: 100,
    },
    county_names_all: "Meade",
    county_fips_all: 21163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40109,
    lat: 38.05857,
    lng: -85.75469,
    city: "Brooks",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1957,
    density: 56.5,
    county_fips: 21029,
    county_name: "Bullitt",
    county_weights: {
      21029: 97.01,
      21111: 2.99,
    },
    county_names_all: "Bullitt|Jefferson",
    county_fips_all: "21029|21111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40110,
    lat: 37.93478,
    lng: -85.64015,
    city: "Clermont",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 21029,
    county_name: "Bullitt",
    county_weights: {
      21029: 100,
    },
    county_names_all: "Bullitt",
    county_fips_all: 21029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40111,
    lat: 37.77881,
    lng: -86.62881,
    city: "Cloverport",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1780,
    density: 20.2,
    county_fips: 21027,
    county_name: "Breckinridge",
    county_weights: {
      21027: 100,
    },
    county_names_all: "Breckinridge",
    county_fips_all: 21027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 40115,
    lat: 37.73784,
    lng: -86.22707,
    city: "Custer",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 765,
    density: 16.7,
    county_fips: 21027,
    county_name: "Breckinridge",
    county_weights: {
      21027: 100,
    },
    county_names_all: "Breckinridge",
    county_fips_all: 21027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 40117,
    lat: 37.89919,
    lng: -86.1247,
    city: "Ekron",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2264,
    density: 41.4,
    county_fips: 21163,
    county_name: "Meade",
    county_weights: {
      21163: 100,
    },
    county_names_all: "Meade",
    county_fips_all: 21163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40118,
    lat: 38.09805,
    lng: -85.75572,
    city: "Fairdale",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9268,
    density: 238.2,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40119,
    lat: 37.60799,
    lng: -86.54925,
    city: "Falls Of Rough",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2077,
    density: 7.5,
    county_fips: 21027,
    county_name: "Breckinridge",
    county_weights: {
      21027: 53.12,
      21085: 42.45,
      21183: 4.43,
    },
    county_names_all: "Breckinridge|Grayson|Ohio",
    county_fips_all: "21027|21085|21183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 40121,
    lat: 37.92614,
    lng: -85.95292,
    city: "Fort Knox",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8865,
    density: 97.2,
    county_fips: 21093,
    county_name: "Hardin",
    county_weights: {
      21093: 84.08,
      21163: 15.92,
    },
    county_names_all: "Hardin|Meade",
    county_fips_all: "21093|21163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40140,
    lat: 37.71867,
    lng: -86.29047,
    city: "Garfield",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 745,
    density: 10.7,
    county_fips: 21027,
    county_name: "Breckinridge",
    county_weights: {
      21027: 96.35,
      21093: 3.65,
    },
    county_names_all: "Breckinridge|Hardin",
    county_fips_all: "21027|21093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 40142,
    lat: 37.88898,
    lng: -86.21095,
    city: "Guston",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1980,
    density: 16.9,
    county_fips: 21163,
    county_name: "Meade",
    county_weights: {
      21027: 6.45,
      21163: 93.55,
    },
    county_names_all: "Meade|Breckinridge",
    county_fips_all: "21163|21027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40143,
    lat: 37.78541,
    lng: -86.50507,
    city: "Hardinsburg",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6305,
    density: 17.2,
    county_fips: 21027,
    county_name: "Breckinridge",
    county_weights: {
      21027: 100,
    },
    county_names_all: "Breckinridge",
    county_fips_all: 21027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 40144,
    lat: 37.75899,
    lng: -86.37732,
    city: "Harned",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1117,
    density: 7.6,
    county_fips: 21027,
    county_name: "Breckinridge",
    county_weights: {
      21027: 100,
    },
    county_names_all: "Breckinridge",
    county_fips_all: 21027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 40145,
    lat: 37.64607,
    lng: -86.32019,
    city: "Hudson",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 722,
    density: 7.4,
    county_fips: 21027,
    county_name: "Breckinridge",
    county_weights: {
      21027: 99.81,
      21093: 0.19,
    },
    county_names_all: "Breckinridge|Hardin",
    county_fips_all: "21027|21093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 40146,
    lat: 37.84622,
    lng: -86.31954,
    city: "Irvington",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3809,
    density: 19.5,
    county_fips: 21027,
    county_name: "Breckinridge",
    county_weights: {
      21027: 96.67,
      21163: 3.33,
    },
    county_names_all: "Breckinridge|Meade",
    county_fips_all: "21027|21163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 40150,
    lat: 37.87458,
    lng: -85.68799,
    city: "Lebanon Junction",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4892,
    density: 30.7,
    county_fips: 21029,
    county_name: "Bullitt",
    county_weights: {
      21029: 96.05,
      21093: 3.95,
    },
    county_names_all: "Bullitt|Hardin",
    county_fips_all: "21029|21093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40152,
    lat: 37.61389,
    lng: -86.44185,
    city: "McDaniels",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 971,
    density: 37.7,
    county_fips: 21027,
    county_name: "Breckinridge",
    county_weights: {
      21027: 100,
    },
    county_names_all: "Breckinridge",
    county_fips_all: 21027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 40155,
    lat: 37.94684,
    lng: -85.99303,
    city: "Muldraugh",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1078,
    density: 329,
    county_fips: 21163,
    county_name: "Meade",
    county_weights: {
      21163: 100,
    },
    county_names_all: "Meade",
    county_fips_all: 21163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40157,
    lat: 38.02111,
    lng: -86.37694,
    city: "Payneville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 762,
    density: 9.1,
    county_fips: 21163,
    county_name: "Meade",
    county_weights: {
      21027: 10.34,
      21163: 89.66,
    },
    county_names_all: "Meade|Breckinridge",
    county_fips_all: "21163|21027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40160,
    lat: 37.8144,
    lng: -85.93971,
    city: "Radcliff",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23659,
    density: 533.2,
    county_fips: 21093,
    county_name: "Hardin",
    county_weights: {
      21093: 100,
    },
    county_names_all: "Hardin",
    county_fips_all: 21093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40161,
    lat: 38.00422,
    lng: -86.39887,
    city: "Rhodelia",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 212,
    density: 10.9,
    county_fips: 21163,
    county_name: "Meade",
    county_weights: {
      21027: 0.84,
      21163: 99.16,
    },
    county_names_all: "Meade|Breckinridge",
    county_fips_all: "21163|21027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40162,
    lat: 37.7517,
    lng: -86.04394,
    city: "Rineyville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5473,
    density: 42.9,
    county_fips: 21093,
    county_name: "Hardin",
    county_weights: {
      21093: 100,
    },
    county_names_all: "Hardin",
    county_fips_all: 21093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40165,
    lat: 37.99407,
    lng: -85.68918,
    city: "Shepherdsville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37522,
    density: 127.9,
    county_fips: 21029,
    county_name: "Bullitt",
    county_weights: {
      21029: 100,
    },
    county_names_all: "Bullitt",
    county_fips_all: 21029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40170,
    lat: 37.96479,
    lng: -86.49607,
    city: "Stephensport",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 474,
    density: 8,
    county_fips: 21027,
    county_name: "Breckinridge",
    county_weights: {
      21027: 100,
    },
    county_names_all: "Breckinridge",
    county_fips_all: 21027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 40171,
    lat: 37.96435,
    lng: -86.43577,
    city: "Union Star",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 151,
    density: 2.9,
    county_fips: 21027,
    county_name: "Breckinridge",
    county_weights: {
      21027: 99.69,
      21163: 0.31,
    },
    county_names_all: "Breckinridge|Meade",
    county_fips_all: "21027|21163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 40175,
    lat: 37.81907,
    lng: -86.08635,
    city: "Vine Grove",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14678,
    density: 70.3,
    county_fips: 21163,
    county_name: "Meade",
    county_weights: {
      21027: 19.38,
      21093: 34.67,
      21163: 45.95,
    },
    county_names_all: "Meade|Hardin|Breckinridge",
    county_fips_all: "21163|21093|21027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40176,
    lat: 37.92377,
    lng: -86.34652,
    city: "Webster",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 943,
    density: 10,
    county_fips: 21027,
    county_name: "Breckinridge",
    county_weights: {
      21027: 64.32,
      21163: 35.68,
    },
    county_names_all: "Breckinridge|Meade",
    county_fips_all: "21027|21163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 40177,
    lat: 38.0009,
    lng: -85.92502,
    city: "West Point",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1706,
    density: 42.5,
    county_fips: 21029,
    county_name: "Bullitt",
    county_weights: {
      21029: 48.44,
      21093: 44.37,
      21111: 7.19,
    },
    county_names_all: "Bullitt|Hardin|Jefferson",
    county_fips_all: "21029|21093|21111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40178,
    lat: 37.65834,
    lng: -86.40853,
    city: "Westview",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 519,
    density: 24.5,
    county_fips: 21027,
    county_name: "Breckinridge",
    county_weights: {
      21027: 100,
    },
    county_names_all: "Breckinridge",
    county_fips_all: 21027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 40202,
    lat: 38.25288,
    lng: -85.75205,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7796,
    density: 1864.2,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 40203,
    lat: 38.24722,
    lng: -85.765,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17568,
    density: 2342.8,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 40204,
    lat: 38.23873,
    lng: -85.7208,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14395,
    density: 1751.3,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40205,
    lat: 38.22313,
    lng: -85.68275,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24859,
    density: 1393.6,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40206,
    lat: 38.25788,
    lng: -85.70205,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19557,
    density: 1292.5,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40207,
    lat: 38.26357,
    lng: -85.65543,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29871,
    density: 982.6,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40208,
    lat: 38.2176,
    lng: -85.7659,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15190,
    density: 2247.7,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40209,
    lat: 38.18492,
    lng: -85.74372,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 350,
    density: 31.2,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40210,
    lat: 38.23161,
    lng: -85.78592,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14385,
    density: 1749.7,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 40211,
    lat: 38.23425,
    lng: -85.82147,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22516,
    density: 1189.3,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 40212,
    lat: 38.26787,
    lng: -85.80256,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16248,
    density: 1638.2,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 40213,
    lat: 38.177,
    lng: -85.71571,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15383,
    density: 620,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40214,
    lat: 38.15141,
    lng: -85.78285,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46002,
    density: 1186.6,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40215,
    lat: 38.19052,
    lng: -85.78555,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20644,
    density: 2283.5,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40216,
    lat: 38.18707,
    lng: -85.83738,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43367,
    density: 1069.7,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 40217,
    lat: 38.21689,
    lng: -85.73725,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12879,
    density: 2073.3,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40218,
    lat: 38.19036,
    lng: -85.65698,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34427,
    density: 1477,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40219,
    lat: 38.13907,
    lng: -85.68877,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38258,
    density: 994.1,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40220,
    lat: 38.21535,
    lng: -85.61794,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34347,
    density: 1731.6,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40221,
    lat: 38.18644,
    lng: -85.75302,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40222,
    lat: 38.26436,
    lng: -85.61173,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22141,
    density: 904.2,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40223,
    lat: 38.26153,
    lng: -85.54328,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23509,
    density: 752.9,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40228,
    lat: 38.13931,
    lng: -85.62947,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15814,
    density: 704.9,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40229,
    lat: 38.09074,
    lng: -85.65597,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40709,
    density: 897.7,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21029: 29.35,
      21111: 70.65,
    },
    county_names_all: "Jefferson|Bullitt",
    county_fips_all: "21111|21029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40231,
    lat: 38.19551,
    lng: -85.69523,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40241,
    lat: 38.30339,
    lng: -85.5774,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29748,
    density: 877.1,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 97.84,
      21185: 2.16,
    },
    county_names_all: "Jefferson|Oldham",
    county_fips_all: "21111|21185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40242,
    lat: 38.27639,
    lng: -85.59042,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11635,
    density: 1570.9,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40243,
    lat: 38.23917,
    lng: -85.53188,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10290,
    density: 967.1,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40245,
    lat: 38.26574,
    lng: -85.45327,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34802,
    density: 412.6,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 72.07,
      21185: 0.59,
      21211: 27.34,
    },
    county_names_all: "Jefferson|Shelby|Oldham",
    county_fips_all: "21111|21211|21185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40258,
    lat: 38.14514,
    lng: -85.87253,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26664,
    density: 881.6,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 40272,
    lat: 38.08291,
    lng: -85.85315,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37401,
    density: 433.9,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21029: 4.33,
      21111: 95.67,
    },
    county_names_all: "Jefferson|Bullitt",
    county_fips_all: "21111|21029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40280,
    lat: 38.24764,
    lng: -85.68704,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 631,
    density: 3445.7,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40291,
    lat: 38.1275,
    lng: -85.57823,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38416,
    density: 655.4,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21111: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 21111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40299,
    lat: 38.16319,
    lng: -85.51613,
    city: "Louisville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42219,
    density: 302,
    county_fips: 21111,
    county_name: "Jefferson",
    county_weights: {
      21029: 0.62,
      21111: 99.38,
    },
    county_names_all: "Jefferson|Bullitt",
    county_fips_all: "21111|21029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40310,
    lat: 37.752,
    lng: -84.76941,
    city: "Burgin",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 319,
    density: 216.6,
    county_fips: 21167,
    county_name: "Mercer",
    county_weights: {
      21167: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 21167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40311,
    lat: 38.32407,
    lng: -84.02256,
    city: "Carlisle",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7384,
    density: 16.8,
    county_fips: 21181,
    county_name: "Nicholas",
    county_weights: {
      21011: 0.91,
      21017: 9.51,
      21181: 89.33,
      21201: 0.25,
    },
    county_names_all: "Nicholas|Bourbon|Bath|Robertson",
    county_fips_all: "21181|21017|21011|21201",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40312,
    lat: 37.84386,
    lng: -83.93013,
    city: "Clay City",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5238,
    density: 35.6,
    county_fips: 21197,
    county_name: "Powell",
    county_weights: {
      21197: 100,
    },
    county_names_all: "Powell",
    county_fips_all: 21197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40313,
    lat: 38.13215,
    lng: -83.38973,
    city: "Clearfield",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2664,
    density: 37.1,
    county_fips: 21205,
    county_name: "Rowan",
    county_weights: {
      21205: 100,
    },
    county_names_all: "Rowan",
    county_fips_all: 21205,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40316,
    lat: 37.93419,
    lng: -83.52895,
    city: "Denniston",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 429,
    density: 18.6,
    county_fips: 21165,
    county_name: "Menifee",
    county_weights: {
      21165: 100,
    },
    county_names_all: "Menifee",
    county_fips_all: 21165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40322,
    lat: 37.93367,
    lng: -83.63329,
    city: "Frenchburg",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3419,
    density: 11.8,
    county_fips: 21165,
    county_name: "Menifee",
    county_weights: {
      21165: 100,
    },
    county_names_all: "Menifee",
    county_fips_all: 21165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40324,
    lat: 38.24786,
    lng: -84.54956,
    city: "Georgetown",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49062,
    density: 122.1,
    county_fips: 21209,
    county_name: "Scott",
    county_weights: {
      21017: 2.2,
      21067: 1.74,
      21209: 96.06,
    },
    county_names_all: "Scott|Bourbon|Fayette",
    county_fips_all: "21209|21017|21067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40328,
    lat: 37.56632,
    lng: -85.02565,
    city: "Gravel Switch",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 911,
    density: 5.8,
    county_fips: 21155,
    county_name: "Marion",
    county_weights: {
      21021: 33.85,
      21045: 26.91,
      21155: 39.24,
    },
    county_names_all: "Marion|Boyle|Casey",
    county_fips_all: "21155|21021|21045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40330,
    lat: 37.78912,
    lng: -84.89016,
    city: "Harrodsburg",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19546,
    density: 34.2,
    county_fips: 21167,
    county_name: "Mercer",
    county_weights: {
      21167: 88.39,
      21229: 11.61,
    },
    county_names_all: "Mercer|Washington",
    county_fips_all: "21167|21229",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40334,
    lat: 38.0197,
    lng: -83.74943,
    city: "Hope",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45,
    density: 14.8,
    county_fips: 21011,
    county_name: "Bath",
    county_weights: {
      21011: 100,
    },
    county_names_all: "Bath",
    county_fips_all: 21011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40336,
    lat: 37.68352,
    lng: -83.9832,
    city: "Irvine",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12364,
    density: 22.8,
    county_fips: 21065,
    county_name: "Estill",
    county_weights: {
      21065: 94.02,
      21109: 1.73,
      21129: 4.25,
    },
    county_names_all: "Estill|Lee|Jackson",
    county_fips_all: "21065|21129|21109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40337,
    lat: 37.95286,
    lng: -83.85644,
    city: "Jeffersonville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5970,
    density: 40.9,
    county_fips: 21173,
    county_name: "Montgomery",
    county_weights: {
      21173: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 21173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40339,
    lat: 37.94313,
    lng: -84.64107,
    city: "Keene",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 214,
    density: 672.4,
    county_fips: 21113,
    county_name: "Jessamine",
    county_weights: {
      21113: 100,
    },
    county_names_all: "Jessamine",
    county_fips_all: 21113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40342,
    lat: 38.0036,
    lng: -84.9837,
    city: "Lawrenceburg",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22367,
    density: 46.7,
    county_fips: 21005,
    county_name: "Anderson",
    county_weights: {
      21005: 99.14,
      21167: 0.45,
      21211: 0.41,
    },
    county_names_all: "Anderson|Mercer|Shelby",
    county_fips_all: "21005|21167|21211",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40346,
    lat: 37.98339,
    lng: -83.74384,
    city: "Means",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 632,
    density: 12.9,
    county_fips: 21165,
    county_name: "Menifee",
    county_weights: {
      21011: 20.07,
      21165: 64.06,
      21173: 15.87,
    },
    county_names_all: "Menifee|Bath|Montgomery",
    county_fips_all: "21165|21011|21173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40347,
    lat: 38.15794,
    lng: -84.71915,
    city: "Midway",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3276,
    density: 31.2,
    county_fips: 21239,
    county_name: "Woodford",
    county_weights: {
      21073: 12.65,
      21209: 11.2,
      21239: 76.15,
    },
    county_names_all: "Woodford|Franklin|Scott",
    county_fips_all: "21239|21073|21209",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40348,
    lat: 38.30296,
    lng: -84.14613,
    city: "Millersburg",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 562,
    density: 355.5,
    county_fips: 21017,
    county_name: "Bourbon",
    county_weights: {
      21017: 100,
    },
    county_names_all: "Bourbon",
    county_fips_all: 21017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40350,
    lat: 38.30512,
    lng: -83.87881,
    city: "Moorefield",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64,
    density: 1.7,
    county_fips: 21181,
    county_name: "Nicholas",
    county_weights: {
      21181: 100,
    },
    county_names_all: "Nicholas",
    county_fips_all: 21181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40351,
    lat: 38.19817,
    lng: -83.4133,
    city: "Morehead",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22097,
    density: 31.8,
    county_fips: 21205,
    county_name: "Rowan",
    county_weights: {
      21043: 0.3,
      21063: 5.69,
      21205: 94.01,
    },
    county_names_all: "Rowan|Elliott|Carter",
    county_fips_all: "21205|21063|21043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40353,
    lat: 38.06514,
    lng: -83.94853,
    city: "Mount Sterling",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21936,
    density: 59.9,
    county_fips: 21173,
    county_name: "Montgomery",
    county_weights: {
      21011: 0.61,
      21017: 0.13,
      21049: 5.79,
      21173: 93.47,
    },
    county_names_all: "Montgomery|Clark|Bath|Bourbon",
    county_fips_all: "21173|21049|21011|21017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40355,
    lat: 38.61023,
    lng: -84.86535,
    city: "New Liberty",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 21187,
    county_name: "Owen",
    county_weights: {
      21187: 100,
    },
    county_names_all: "Owen",
    county_fips_all: 21187,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40356,
    lat: 37.87307,
    lng: -84.56554,
    city: "Nicholasville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44249,
    density: 122.5,
    county_fips: 21113,
    county_name: "Jessamine",
    county_weights: {
      21113: 100,
    },
    county_names_all: "Jessamine",
    county_fips_all: 21113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40357,
    lat: 38.14519,
    lng: -84.10843,
    city: "North Middletown",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 21017,
    county_name: "Bourbon",
    county_weights: {
      21017: 100,
    },
    county_names_all: "Bourbon",
    county_fips_all: 21017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40358,
    lat: 38.05769,
    lng: -83.6831,
    city: "Olympia",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1133,
    density: 25.5,
    county_fips: 21011,
    county_name: "Bath",
    county_weights: {
      21011: 100,
    },
    county_names_all: "Bath",
    county_fips_all: 21011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40359,
    lat: 38.48224,
    lng: -84.8209,
    city: "Owenton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6598,
    density: 11.7,
    county_fips: 21187,
    county_name: "Owen",
    county_weights: {
      21187: 100,
    },
    county_names_all: "Owen",
    county_fips_all: 21187,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40360,
    lat: 38.15665,
    lng: -83.76679,
    city: "Owingsville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6880,
    density: 17.9,
    county_fips: 21011,
    county_name: "Bath",
    county_weights: {
      21011: 96.04,
      21173: 3.96,
    },
    county_names_all: "Bath|Montgomery",
    county_fips_all: "21011|21173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40361,
    lat: 38.20536,
    lng: -84.22415,
    city: "Paris",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18478,
    density: 27.7,
    county_fips: 21017,
    county_name: "Bourbon",
    county_weights: {
      21017: 97.73,
      21067: 0.8,
      21097: 1.18,
      21181: 0.29,
    },
    county_names_all: "Bourbon|Harrison|Fayette|Nicholas",
    county_fips_all: "21017|21097|21067|21181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40363,
    lat: 38.51439,
    lng: -85.00976,
    city: "Perry Park",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17,
    density: 314.6,
    county_fips: 21187,
    county_name: "Owen",
    county_weights: {
      21187: 100,
    },
    county_names_all: "Owen",
    county_fips_all: 21187,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40370,
    lat: 38.39382,
    lng: -84.52971,
    city: "Sadieville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2623,
    density: 12.4,
    county_fips: 21209,
    county_name: "Scott",
    county_weights: {
      21097: 22.38,
      21209: 77.62,
    },
    county_names_all: "Scott|Harrison",
    county_fips_all: "21209|21097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40371,
    lat: 38.07716,
    lng: -83.59561,
    city: "Salt Lick",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2980,
    density: 14.8,
    county_fips: 21011,
    county_name: "Bath",
    county_weights: {
      21011: 78.75,
      21165: 21.25,
    },
    county_names_all: "Bath|Menifee",
    county_fips_all: "21011|21165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40372,
    lat: 37.90899,
    lng: -84.88537,
    city: "Salvisa",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2455,
    density: 17.6,
    county_fips: 21167,
    county_name: "Mercer",
    county_weights: {
      21005: 5.53,
      21167: 94.47,
    },
    county_names_all: "Mercer|Anderson",
    county_fips_all: "21167|21005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40374,
    lat: 38.21419,
    lng: -83.90359,
    city: "Sharpsburg",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1924,
    density: 12.1,
    county_fips: 21011,
    county_name: "Bath",
    county_weights: {
      21011: 83.93,
      21017: 4.31,
      21181: 11.76,
    },
    county_names_all: "Bath|Nicholas|Bourbon",
    county_fips_all: "21011|21181|21017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40376,
    lat: 37.7839,
    lng: -83.69604,
    city: "Slade",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31,
    density: 1.3,
    county_fips: 21197,
    county_name: "Powell",
    county_weights: {
      21197: 100,
    },
    county_names_all: "Powell",
    county_fips_all: 21197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40379,
    lat: 38.30778,
    lng: -84.68992,
    city: "Stamping Ground",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3911,
    density: 23.1,
    county_fips: 21209,
    county_name: "Scott",
    county_weights: {
      21073: 6.74,
      21187: 3.24,
      21209: 90.02,
    },
    county_names_all: "Scott|Franklin|Owen",
    county_fips_all: "21209|21073|21187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40380,
    lat: 37.81965,
    lng: -83.78006,
    city: "Stanton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7014,
    density: 22.2,
    county_fips: 21197,
    county_name: "Powell",
    county_weights: {
      21065: 7.6,
      21197: 92.4,
    },
    county_names_all: "Powell|Estill",
    county_fips_all: "21197|21065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40383,
    lat: 38.01022,
    lng: -84.73919,
    city: "Versailles",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23787,
    density: 61.1,
    county_fips: 21239,
    county_name: "Woodford",
    county_weights: {
      21113: 2.83,
      21239: 97.17,
    },
    county_names_all: "Woodford|Jessamine",
    county_fips_all: "21239|21113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40385,
    lat: 37.73866,
    lng: -84.13085,
    city: "Waco",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2853,
    density: 24.1,
    county_fips: 21151,
    county_name: "Madison",
    county_weights: {
      21151: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 21151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40387,
    lat: 37.93494,
    lng: -83.49027,
    city: "Wellington",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1933,
    density: 10.8,
    county_fips: 21165,
    county_name: "Menifee",
    county_weights: {
      21165: 77.61,
      21175: 22.39,
    },
    county_names_all: "Menifee|Morgan",
    county_fips_all: "21165|21175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40390,
    lat: 37.85407,
    lng: -84.67075,
    city: "Wilmore",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8015,
    density: 125.3,
    county_fips: 21113,
    county_name: "Jessamine",
    county_weights: {
      21113: 100,
    },
    county_names_all: "Jessamine",
    county_fips_all: 21113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40391,
    lat: 37.96969,
    lng: -84.14507,
    city: "Winchester",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35800,
    density: 58.2,
    county_fips: 21049,
    county_name: "Clark",
    county_weights: {
      21049: 99.35,
      21067: 0.65,
    },
    county_names_all: "Clark|Fayette",
    county_fips_all: "21049|21067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40402,
    lat: 37.29663,
    lng: -83.97008,
    city: "Annville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1902,
    density: 15.2,
    county_fips: 21109,
    county_name: "Jackson",
    county_weights: {
      21109: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 21109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40403,
    lat: 37.57052,
    lng: -84.26622,
    city: "Berea",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24875,
    density: 86.5,
    county_fips: 21151,
    county_name: "Madison",
    county_weights: {
      21079: 14.37,
      21151: 76.54,
      21203: 9.09,
    },
    county_names_all: "Madison|Garrard|Rockcastle",
    county_fips_all: "21151|21079|21203",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40404,
    lat: 37.57311,
    lng: -84.29037,
    city: "Berea",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 872,
    density: 1704.1,
    county_fips: 21151,
    county_name: "Madison",
    county_weights: {
      21151: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 21151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40409,
    lat: 37.37667,
    lng: -84.42971,
    city: "Brodhead",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3725,
    density: 32,
    county_fips: 21203,
    county_name: "Rockcastle",
    county_weights: {
      21137: 3.43,
      21199: 2.1,
      21203: 94.47,
    },
    county_names_all: "Rockcastle|Lincoln|Pulaski",
    county_fips_all: "21203|21137|21199",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40419,
    lat: 37.44791,
    lng: -84.49204,
    city: "Crab Orchard",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4140,
    density: 16.8,
    county_fips: 21137,
    county_name: "Lincoln",
    county_weights: {
      21079: 20.82,
      21137: 55.75,
      21199: 5.17,
      21203: 18.26,
    },
    county_names_all: "Lincoln|Garrard|Rockcastle|Pulaski",
    county_fips_all: "21137|21079|21203|21199",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40422,
    lat: 37.64235,
    lng: -84.80488,
    city: "Danville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25662,
    density: 91.5,
    county_fips: 21021,
    county_name: "Boyle",
    county_weights: {
      21021: 94.3,
      21137: 5.7,
    },
    county_names_all: "Boyle|Lincoln",
    county_fips_all: "21021|21137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40434,
    lat: 37.39364,
    lng: -83.93949,
    city: "Gray Hawk",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 21109,
    county_name: "Jackson",
    county_weights: {
      21109: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 21109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40437,
    lat: 37.44531,
    lng: -84.85486,
    city: "Hustonville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5746,
    density: 20.6,
    county_fips: 21045,
    county_name: "Casey",
    county_weights: {
      21045: 52.36,
      21137: 47.64,
    },
    county_names_all: "Casey|Lincoln",
    county_fips_all: "21045|21137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40440,
    lat: 37.57628,
    lng: -84.8322,
    city: "Junction City",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2140,
    density: 62.6,
    county_fips: 21021,
    county_name: "Boyle",
    county_weights: {
      21021: 99.88,
      21137: 0.12,
    },
    county_names_all: "Boyle|Lincoln",
    county_fips_all: "21021|21137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40442,
    lat: 37.35205,
    lng: -84.72868,
    city: "Kings Mountain",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 868,
    density: 12.6,
    county_fips: 21137,
    county_name: "Lincoln",
    county_weights: {
      21045: 46.15,
      21137: 53.85,
    },
    county_names_all: "Lincoln|Casey",
    county_fips_all: "21137|21045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40444,
    lat: 37.67893,
    lng: -84.58819,
    city: "Lancaster",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14732,
    density: 35.7,
    county_fips: 21079,
    county_name: "Garrard",
    county_weights: {
      21079: 96.57,
      21137: 3.43,
    },
    county_names_all: "Garrard|Lincoln",
    county_fips_all: "21079|21137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40445,
    lat: 37.3125,
    lng: -84.21159,
    city: "Livingston",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 728,
    density: 5.8,
    county_fips: 21203,
    county_name: "Rockcastle",
    county_weights: {
      21203: 100,
    },
    county_names_all: "Rockcastle",
    county_fips_all: 21203,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40447,
    lat: 37.45496,
    lng: -84.0299,
    city: "McKee",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8359,
    density: 13.3,
    county_fips: 21109,
    county_name: "Jackson",
    county_weights: {
      21065: 0.68,
      21109: 94.52,
      21189: 4.13,
      21203: 0.67,
    },
    county_names_all: "Jackson|Owsley|Estill|Rockcastle",
    county_fips_all: "21109|21189|21065|21203",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40448,
    lat: 37.45624,
    lng: -84.75799,
    city: "McKinney",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14,
    density: 60.9,
    county_fips: 21137,
    county_name: "Lincoln",
    county_weights: {
      21137: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 21137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40456,
    lat: 37.3538,
    lng: -84.32099,
    city: "Mount Vernon",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9240,
    density: 21.9,
    county_fips: 21203,
    county_name: "Rockcastle",
    county_weights: {
      21203: 100,
    },
    county_names_all: "Rockcastle",
    county_fips_all: 21203,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40460,
    lat: 37.39385,
    lng: -84.23985,
    city: "Orlando",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1458,
    density: 16.9,
    county_fips: 21203,
    county_name: "Rockcastle",
    county_weights: {
      21203: 100,
    },
    county_names_all: "Rockcastle",
    county_fips_all: 21203,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40461,
    lat: 37.59014,
    lng: -84.40849,
    city: "Paint Lick",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3495,
    density: 24.2,
    county_fips: 21079,
    county_name: "Garrard",
    county_weights: {
      21079: 65.15,
      21151: 34.85,
    },
    county_names_all: "Garrard|Madison",
    county_fips_all: "21079|21151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40464,
    lat: 37.55579,
    lng: -84.91148,
    city: "Parksville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1092,
    density: 14.2,
    county_fips: 21021,
    county_name: "Boyle",
    county_weights: {
      21021: 72.12,
      21045: 27.88,
    },
    county_names_all: "Boyle|Casey",
    county_fips_all: "21021|21045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40468,
    lat: 37.65158,
    lng: -84.98782,
    city: "Perryville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1806,
    density: 23.6,
    county_fips: 21021,
    county_name: "Boyle",
    county_weights: {
      21021: 79.21,
      21167: 6.64,
      21229: 14.15,
    },
    county_names_all: "Boyle|Washington|Mercer",
    county_fips_all: "21021|21229|21167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40472,
    lat: 37.71841,
    lng: -83.87562,
    city: "Ravenna",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1842,
    density: 15.8,
    county_fips: 21065,
    county_name: "Estill",
    county_weights: {
      21065: 100,
    },
    county_names_all: "Estill",
    county_fips_all: 21065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40475,
    lat: 37.7635,
    lng: -84.30828,
    city: "Richmond",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63422,
    density: 85.2,
    county_fips: 21151,
    county_name: "Madison",
    county_weights: {
      21151: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 21151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40481,
    lat: 37.42658,
    lng: -84.09116,
    city: "Sandgap",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 103,
    density: 2.4,
    county_fips: 21109,
    county_name: "Jackson",
    county_weights: {
      21109: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 21109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40484,
    lat: 37.5153,
    lng: -84.676,
    city: "Stanford",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11536,
    density: 31.9,
    county_fips: 21137,
    county_name: "Lincoln",
    county_weights: {
      21045: 0.86,
      21079: 2.69,
      21137: 96.45,
    },
    county_names_all: "Lincoln|Garrard|Casey",
    county_fips_all: "21137|21079|21045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40486,
    lat: 37.37238,
    lng: -83.86123,
    city: "Tyner",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3068,
    density: 23,
    county_fips: 21109,
    county_name: "Jackson",
    county_weights: {
      21051: 1.45,
      21109: 90.5,
      21189: 8.05,
    },
    county_names_all: "Jackson|Owsley|Clay",
    county_fips_all: "21109|21189|21051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40489,
    lat: 37.36629,
    lng: -84.64435,
    city: "Waynesburg",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4486,
    density: 26.6,
    county_fips: 21137,
    county_name: "Lincoln",
    county_weights: {
      21045: 14.46,
      21137: 85.54,
    },
    county_names_all: "Lincoln|Casey",
    county_fips_all: "21137|21045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40502,
    lat: 38.01376,
    lng: -84.48189,
    city: "Lexington",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27343,
    density: 1477.3,
    county_fips: 21067,
    county_name: "Fayette",
    county_weights: {
      21067: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 21067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40503,
    lat: 38.0047,
    lng: -84.53434,
    city: "Lexington",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28880,
    density: 1262.3,
    county_fips: 21067,
    county_name: "Fayette",
    county_weights: {
      21067: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 21067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40504,
    lat: 38.04181,
    lng: -84.54133,
    city: "Lexington",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27287,
    density: 1709.3,
    county_fips: 21067,
    county_name: "Fayette",
    county_weights: {
      21067: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 21067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40505,
    lat: 38.06039,
    lng: -84.45679,
    city: "Lexington",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26399,
    density: 1275.9,
    county_fips: 21067,
    county_name: "Fayette",
    county_weights: {
      21067: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 21067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40507,
    lat: 38.04686,
    lng: -84.49628,
    city: "Lexington",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1671,
    density: 1498.1,
    county_fips: 21067,
    county_name: "Fayette",
    county_weights: {
      21067: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 21067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40508,
    lat: 38.05004,
    lng: -84.50018,
    city: "Lexington",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26226,
    density: 2407.2,
    county_fips: 21067,
    county_name: "Fayette",
    county_weights: {
      21067: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 21067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40509,
    lat: 37.99408,
    lng: -84.36791,
    city: "Lexington",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42432,
    density: 343.1,
    county_fips: 21067,
    county_name: "Fayette",
    county_weights: {
      21049: 8.48,
      21067: 91.52,
    },
    county_names_all: "Fayette|Clark",
    county_fips_all: "21067|21049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40510,
    lat: 38.07243,
    lng: -84.60138,
    city: "Lexington",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2027,
    density: 34.5,
    county_fips: 21067,
    county_name: "Fayette",
    county_weights: {
      21067: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 21067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40511,
    lat: 38.13278,
    lng: -84.47392,
    city: "Lexington",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33801,
    density: 151.7,
    county_fips: 21067,
    county_name: "Fayette",
    county_weights: {
      21017: 4.15,
      21067: 90.97,
      21209: 4.88,
    },
    county_names_all: "Fayette|Scott|Bourbon",
    county_fips_all: "21067|21209|21017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40513,
    lat: 38.01626,
    lng: -84.60694,
    city: "Lexington",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11445,
    density: 300.9,
    county_fips: 21067,
    county_name: "Fayette",
    county_weights: {
      21067: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 21067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40514,
    lat: 37.98279,
    lng: -84.56352,
    city: "Lexington",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16607,
    density: 2148,
    county_fips: 21067,
    county_name: "Fayette",
    county_weights: {
      21067: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 21067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40515,
    lat: 37.92021,
    lng: -84.4152,
    city: "Lexington",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36569,
    density: 255.4,
    county_fips: 21067,
    county_name: "Fayette",
    county_weights: {
      21049: 8.02,
      21067: 85.48,
      21113: 6.5,
    },
    county_names_all: "Fayette|Clark|Jessamine",
    county_fips_all: "21067|21049|21113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40516,
    lat: 38.07366,
    lng: -84.36631,
    city: "Lexington",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3446,
    density: 43.4,
    county_fips: 21067,
    county_name: "Fayette",
    county_weights: {
      21017: 13.7,
      21067: 86.3,
    },
    county_names_all: "Fayette|Bourbon",
    county_fips_all: "21067|21017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40517,
    lat: 37.98386,
    lng: -84.48833,
    city: "Lexington",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37358,
    density: 2337,
    county_fips: 21067,
    county_name: "Fayette",
    county_weights: {
      21067: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 21067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40526,
    lat: 38.0297,
    lng: -84.50153,
    city: "Lexington",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 21067,
    county_name: "Fayette",
    county_weights: {
      21067: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 21067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40536,
    lat: 38.02979,
    lng: -84.50732,
    city: "Lexington",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 21067,
    county_name: "Fayette",
    county_weights: {
      21067: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 21067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40601,
    lat: 38.23294,
    lng: -84.88327,
    city: "Frankfort",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51306,
    density: 91.1,
    county_fips: 21073,
    county_name: "Franklin",
    county_weights: {
      21073: 88.9,
      21103: 0.93,
      21211: 4.38,
      21239: 5.79,
    },
    county_names_all: "Franklin|Woodford|Shelby|Henry",
    county_fips_all: "21073|21239|21211|21103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40701,
    lat: 36.91759,
    lng: -84.16651,
    city: "Corbin",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29128,
    density: 74.7,
    county_fips: 21235,
    county_name: "Whitley",
    county_weights: {
      21121: 17.57,
      21125: 21.47,
      21235: 60.96,
    },
    county_names_all: "Whitley|Laurel|Knox",
    county_fips_all: "21235|21125|21121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40729,
    lat: 37.2435,
    lng: -84.14788,
    city: "East Bernstadt",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5741,
    density: 29.5,
    county_fips: 21125,
    county_name: "Laurel",
    county_weights: {
      21125: 100,
    },
    county_names_all: "Laurel",
    county_fips_all: 21125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40734,
    lat: 36.92642,
    lng: -83.96609,
    city: "Gray",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3956,
    density: 33.6,
    county_fips: 21121,
    county_name: "Knox",
    county_weights: {
      21121: 95.56,
      21125: 4.44,
    },
    county_names_all: "Knox|Laurel",
    county_fips_all: "21121|21125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40737,
    lat: 37.00838,
    lng: -84.13902,
    city: "Keavy",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1370,
    density: 65.4,
    county_fips: 21125,
    county_name: "Laurel",
    county_weights: {
      21125: 100,
    },
    county_names_all: "Laurel",
    county_fips_all: 21125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40740,
    lat: 37.02111,
    lng: -84.03888,
    city: "Lily",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3678,
    density: 93.9,
    county_fips: 21125,
    county_name: "Laurel",
    county_weights: {
      21125: 100,
    },
    county_names_all: "Laurel",
    county_fips_all: 21125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40741,
    lat: 37.13349,
    lng: -84.11636,
    city: "London",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24922,
    density: 46.4,
    county_fips: 21125,
    county_name: "Laurel",
    county_weights: {
      21051: 3.05,
      21125: 96.95,
    },
    county_names_all: "Laurel|Clay",
    county_fips_all: "21125|21051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40744,
    lat: 37.03841,
    lng: -84.08864,
    city: "London",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17425,
    density: 64.8,
    county_fips: 21125,
    county_name: "Laurel",
    county_weights: {
      21051: 2.24,
      21125: 97.76,
    },
    county_names_all: "Laurel|Clay",
    county_fips_all: "21125|21051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40759,
    lat: 36.82034,
    lng: -84.0571,
    city: "Rockholds",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2368,
    density: 18.6,
    county_fips: 21235,
    county_name: "Whitley",
    county_weights: {
      21121: 15.51,
      21235: 84.49,
    },
    county_names_all: "Whitley|Knox",
    county_fips_all: "21235|21121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40763,
    lat: 36.68848,
    lng: -83.94403,
    city: "Siler",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 443,
    density: 6.6,
    county_fips: 21235,
    county_name: "Whitley",
    county_weights: {
      21121: 12.14,
      21235: 87.86,
    },
    county_names_all: "Whitley|Knox",
    county_fips_all: "21235|21121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40769,
    lat: 36.7116,
    lng: -84.17284,
    city: "Williamsburg",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18064,
    density: 24.8,
    county_fips: 21235,
    county_name: "Whitley",
    county_weights: {
      21147: 6.53,
      21235: 93.47,
    },
    county_names_all: "Whitley|McCreary",
    county_fips_all: "21235|21147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40771,
    lat: 36.85942,
    lng: -84.03459,
    city: "Woodbine",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1774,
    density: 66.4,
    county_fips: 21121,
    county_name: "Knox",
    county_weights: {
      21121: 86.48,
      21235: 13.52,
    },
    county_names_all: "Knox|Whitley",
    county_fips_all: "21121|21235",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40801,
    lat: 36.85692,
    lng: -83.25493,
    city: "Ages Brookside",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 390,
    density: 799.6,
    county_fips: 21095,
    county_name: "Harlan",
    county_weights: {
      21095: 100,
    },
    county_names_all: "Harlan",
    county_fips_all: 21095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40803,
    lat: 37.04572,
    lng: -83.42185,
    city: "Asher",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 21131,
    county_name: "Leslie",
    county_weights: {
      21131: 100,
    },
    county_names_all: "Leslie",
    county_fips_all: 21131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40806,
    lat: 36.88595,
    lng: -83.2881,
    city: "Baxter",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2591,
    density: 44.7,
    county_fips: 21095,
    county_name: "Harlan",
    county_weights: {
      21095: 100,
    },
    county_names_all: "Harlan",
    county_fips_all: 21095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40807,
    lat: 36.9647,
    lng: -82.95578,
    city: "Benham",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 322,
    density: 749.9,
    county_fips: 21095,
    county_name: "Harlan",
    county_weights: {
      21095: 100,
    },
    county_names_all: "Harlan",
    county_fips_all: 21095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40808,
    lat: 36.9995,
    lng: -83.2801,
    city: "Big Laurel",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63,
    density: 0.7,
    county_fips: 21131,
    county_name: "Leslie",
    county_weights: {
      21095: 14.55,
      21131: 85.45,
    },
    county_names_all: "Leslie|Harlan",
    county_fips_all: "21131|21095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40810,
    lat: 36.93176,
    lng: -83.30451,
    city: "Bledsoe",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 950,
    density: 5.4,
    county_fips: 21095,
    county_name: "Harlan",
    county_weights: {
      21095: 90.42,
      21131: 9.58,
    },
    county_names_all: "Harlan|Leslie",
    county_fips_all: "21095|21131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40813,
    lat: 36.71526,
    lng: -83.59838,
    city: "Calvin",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 328,
    density: 9.8,
    county_fips: 21013,
    county_name: "Bell",
    county_weights: {
      21013: 100,
    },
    county_names_all: "Bell",
    county_fips_all: 21013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40815,
    lat: 36.7876,
    lng: -83.22876,
    city: "Cawood",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 974,
    density: 16,
    county_fips: 21095,
    county_name: "Harlan",
    county_weights: {
      21095: 100,
    },
    county_names_all: "Harlan",
    county_fips_all: 21095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40816,
    lat: 37.00879,
    lng: -83.3667,
    city: "Chappell",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 21131,
    county_name: "Leslie",
    county_weights: {
      21131: 100,
    },
    county_names_all: "Leslie",
    county_fips_all: 21131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40818,
    lat: 36.82003,
    lng: -83.2442,
    city: "Coalgood",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 102,
    density: 9,
    county_fips: 21095,
    county_name: "Harlan",
    county_weights: {
      21095: 100,
    },
    county_names_all: "Harlan",
    county_fips_all: 21095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40819,
    lat: 36.81025,
    lng: -83.46242,
    city: "Coldiron",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 632,
    density: 14.9,
    county_fips: 21095,
    county_name: "Harlan",
    county_weights: {
      21095: 100,
    },
    county_names_all: "Harlan",
    county_fips_all: 21095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40820,
    lat: 36.77552,
    lng: -83.16515,
    city: "Cranks",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 500,
    density: 7.5,
    county_fips: 21095,
    county_name: "Harlan",
    county_weights: {
      21095: 100,
    },
    county_names_all: "Harlan",
    county_fips_all: 21095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40823,
    lat: 36.95664,
    lng: -82.98864,
    city: "Cumberland",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3719,
    density: 29.6,
    county_fips: 21095,
    county_name: "Harlan",
    county_weights: {
      21095: 99.84,
      21133: 0.16,
    },
    county_names_all: "Harlan|Letcher",
    county_fips_all: "21095|21133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40824,
    lat: 36.82489,
    lng: -83.37221,
    city: "Dayhoit",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 417,
    density: 40.1,
    county_fips: 21095,
    county_name: "Harlan",
    county_weights: {
      21095: 100,
    },
    county_names_all: "Harlan",
    county_fips_all: 21095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40826,
    lat: 37.05637,
    lng: -82.7783,
    city: "Eolia",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 607,
    density: 7.5,
    county_fips: 21133,
    county_name: "Letcher",
    county_weights: {
      21133: 100,
    },
    county_names_all: "Letcher",
    county_fips_all: 21133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40827,
    lat: 37.05208,
    lng: -83.47187,
    city: "Essie",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 980,
    density: 20.8,
    county_fips: 21131,
    county_name: "Leslie",
    county_weights: {
      21131: 100,
    },
    county_names_all: "Leslie",
    county_fips_all: 21131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40828,
    lat: 36.87107,
    lng: -83.14868,
    city: "Evarts",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4128,
    density: 31.5,
    county_fips: 21095,
    county_name: "Harlan",
    county_weights: {
      21095: 100,
    },
    county_names_all: "Harlan",
    county_fips_all: 21095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40829,
    lat: 36.798,
    lng: -83.29655,
    city: "Grays Knob",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 102,
    density: 7.5,
    county_fips: 21095,
    county_name: "Harlan",
    county_weights: {
      21095: 100,
    },
    county_names_all: "Harlan",
    county_fips_all: 21095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40830,
    lat: 36.77644,
    lng: -83.33114,
    city: "Gulston",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 316,
    density: 332.5,
    county_fips: 21095,
    county_name: "Harlan",
    county_weights: {
      21095: 100,
    },
    county_names_all: "Harlan",
    county_fips_all: 21095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40831,
    lat: 36.76457,
    lng: -83.33454,
    city: "Harlan",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4837,
    density: 27.7,
    county_fips: 21095,
    county_name: "Harlan",
    county_weights: {
      21095: 100,
    },
    county_names_all: "Harlan",
    county_fips_all: 21095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40840,
    lat: 36.9457,
    lng: -83.41854,
    city: "Helton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 299,
    density: 2.8,
    county_fips: 21131,
    county_name: "Leslie",
    county_weights: {
      21131: 100,
    },
    county_names_all: "Leslie",
    county_fips_all: 21131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40843,
    lat: 36.88826,
    lng: -82.93666,
    city: "Holmes Mill",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 226,
    density: 5.6,
    county_fips: 21095,
    county_name: "Harlan",
    county_weights: {
      21095: 100,
    },
    county_names_all: "Harlan",
    county_fips_all: 21095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40844,
    lat: 37.05506,
    lng: -83.35406,
    city: "Hoskinston",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49,
    density: 1.3,
    county_fips: 21131,
    county_name: "Leslie",
    county_weights: {
      21131: 100,
    },
    county_names_all: "Leslie",
    county_fips_all: 21131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40845,
    lat: 36.79899,
    lng: -83.51755,
    city: "Hulen",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 589,
    density: 26.2,
    county_fips: 21013,
    county_name: "Bell",
    county_weights: {
      21013: 100,
    },
    county_names_all: "Bell",
    county_fips_all: 21013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40847,
    lat: 36.85281,
    lng: -83.15798,
    city: "Kenvir",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 210,
    density: 710.6,
    county_fips: 21095,
    county_name: "Harlan",
    county_weights: {
      21095: 100,
    },
    county_names_all: "Harlan",
    county_fips_all: 21095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40849,
    lat: 36.89941,
    lng: -83.13469,
    city: "Lejunior",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 286,
    density: 1249.4,
    county_fips: 21095,
    county_name: "Harlan",
    county_weights: {
      21095: 100,
    },
    county_names_all: "Harlan",
    county_fips_all: 21095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40854,
    lat: 36.84664,
    lng: -83.35634,
    city: "Loyall",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 946,
    density: 155.5,
    county_fips: 21095,
    county_name: "Harlan",
    county_weights: {
      21095: 100,
    },
    county_names_all: "Harlan",
    county_fips_all: 21095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40855,
    lat: 36.94931,
    lng: -82.89836,
    city: "Lynch",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 668,
    density: 17.2,
    county_fips: 21095,
    county_name: "Harlan",
    county_weights: {
      21095: 100,
    },
    county_names_all: "Harlan",
    county_fips_all: 21095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40856,
    lat: 36.70574,
    lng: -83.52939,
    city: "Miracle",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 907,
    density: 11.4,
    county_fips: 21013,
    county_name: "Bell",
    county_weights: {
      21013: 100,
    },
    county_names_all: "Bell",
    county_fips_all: 21013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40858,
    lat: 37.01592,
    lng: -83.40106,
    city: "Mozelle",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 330,
    density: 16.4,
    county_fips: 21131,
    county_name: "Leslie",
    county_weights: {
      21131: 100,
    },
    county_names_all: "Leslie",
    county_fips_all: 21131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40862,
    lat: 37.01418,
    lng: -82.87096,
    city: "Partridge",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 371,
    density: 7.5,
    county_fips: 21133,
    county_name: "Letcher",
    county_weights: {
      21133: 100,
    },
    county_names_all: "Letcher",
    county_fips_all: 21133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40863,
    lat: 36.74048,
    lng: -83.44567,
    city: "Pathfork",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 382,
    density: 6,
    county_fips: 21095,
    county_name: "Harlan",
    county_weights: {
      21095: 100,
    },
    county_names_all: "Harlan",
    county_fips_all: 21095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40865,
    lat: 36.91637,
    lng: -83.21804,
    city: "Putney",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 392,
    density: 40.9,
    county_fips: 21095,
    county_name: "Harlan",
    county_weights: {
      21095: 100,
    },
    county_names_all: "Harlan",
    county_fips_all: 21095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40868,
    lat: 37.09367,
    lng: -83.41638,
    city: "Stinnett",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 643,
    density: 23.1,
    county_fips: 21131,
    county_name: "Leslie",
    county_weights: {
      21131: 100,
    },
    county_names_all: "Leslie",
    county_fips_all: 21131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40870,
    lat: 36.93211,
    lng: -83.14858,
    city: "Totz",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 323,
    density: 9.7,
    county_fips: 21095,
    county_name: "Harlan",
    county_weights: {
      21095: 100,
    },
    county_names_all: "Harlan",
    county_fips_all: 21095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40873,
    lat: 36.81541,
    lng: -83.40411,
    city: "Wallins Creek",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2308,
    density: 32.5,
    county_fips: 21095,
    county_name: "Harlan",
    county_weights: {
      21095: 100,
    },
    county_names_all: "Harlan",
    county_fips_all: 21095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40874,
    lat: 36.98407,
    lng: -83.47345,
    city: "Warbranch",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 310,
    density: 5.1,
    county_fips: 21131,
    county_name: "Leslie",
    county_weights: {
      21051: 18.41,
      21131: 81.59,
    },
    county_names_all: "Leslie|Clay",
    county_fips_all: "21131|21051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40902,
    lat: 36.84824,
    lng: -83.62435,
    city: "Arjay",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1273,
    density: 14.6,
    county_fips: 21013,
    county_name: "Bell",
    county_weights: {
      21013: 100,
    },
    county_names_all: "Bell",
    county_fips_all: 21013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40903,
    lat: 36.80973,
    lng: -83.83163,
    city: "Artemus",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 770,
    density: 16.4,
    county_fips: 21121,
    county_name: "Knox",
    county_weights: {
      21121: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 21121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40906,
    lat: 36.88828,
    lng: -83.87546,
    city: "Barbourville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11336,
    density: 31.9,
    county_fips: 21121,
    county_name: "Knox",
    county_weights: {
      21121: 97.72,
      21235: 2.28,
    },
    county_names_all: "Knox|Whitley",
    county_fips_all: "21121|21235",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40913,
    lat: 36.94986,
    lng: -83.54367,
    city: "Beverly",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 353,
    density: 8,
    county_fips: 21013,
    county_name: "Bell",
    county_weights: {
      21013: 67.47,
      21051: 32.53,
    },
    county_names_all: "Bell|Clay",
    county_fips_all: "21013|21051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40914,
    lat: 37.0932,
    lng: -83.56154,
    city: "Big Creek",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 388,
    density: 3.3,
    county_fips: 21051,
    county_name: "Clay",
    county_weights: {
      21051: 71.67,
      21131: 28.33,
    },
    county_names_all: "Clay|Leslie",
    county_fips_all: "21051|21131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40915,
    lat: 36.89235,
    lng: -83.82025,
    city: "Bimble",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 917,
    density: 63.8,
    county_fips: 21121,
    county_name: "Knox",
    county_weights: {
      21121: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 21121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40921,
    lat: 36.78195,
    lng: -83.90185,
    city: "Bryants Store",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 139,
    density: 4.3,
    county_fips: 21121,
    county_name: "Knox",
    county_weights: {
      21121: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 21121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40923,
    lat: 36.92059,
    lng: -83.84923,
    city: "Cannon",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 648,
    density: 45.9,
    county_fips: 21121,
    county_name: "Knox",
    county_weights: {
      21121: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 21121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40927,
    lat: 36.89081,
    lng: -83.03445,
    city: "Closplint",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 510,
    density: 7.3,
    county_fips: 21095,
    county_name: "Harlan",
    county_weights: {
      21095: 100,
    },
    county_names_all: "Harlan",
    county_fips_all: 21095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40935,
    lat: 36.91107,
    lng: -83.71264,
    city: "Flat Lick",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2639,
    density: 16.5,
    county_fips: 21121,
    county_name: "Knox",
    county_weights: {
      21121: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 21121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40939,
    lat: 36.81217,
    lng: -83.71152,
    city: "Fourmile",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 198,
    density: 12.1,
    county_fips: 21013,
    county_name: "Bell",
    county_weights: {
      21013: 99.13,
      21121: 0.87,
    },
    county_names_all: "Bell|Knox",
    county_fips_all: "21013|21121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40940,
    lat: 36.60991,
    lng: -83.92988,
    city: "Frakes",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 297,
    density: 3.8,
    county_fips: 21013,
    county_name: "Bell",
    county_weights: {
      21013: 54.08,
      21235: 45.92,
    },
    county_names_all: "Bell|Whitley",
    county_fips_all: "21013|21235",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40941,
    lat: 37.12981,
    lng: -83.74585,
    city: "Garrard",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 167,
    density: 458.1,
    county_fips: 21051,
    county_name: "Clay",
    county_weights: {
      21051: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 21051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40943,
    lat: 36.95494,
    lng: -83.85631,
    city: "Girdler",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 482,
    density: 34,
    county_fips: 21121,
    county_name: "Knox",
    county_weights: {
      21121: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 21121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40946,
    lat: 36.95757,
    lng: -83.82467,
    city: "Green Road",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 302,
    density: 72.3,
    county_fips: 21121,
    county_name: "Knox",
    county_weights: {
      21121: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 21121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40949,
    lat: 36.90253,
    lng: -83.86717,
    city: "Heidrick",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 969,
    density: 191.5,
    county_fips: 21121,
    county_name: "Knox",
    county_weights: {
      21121: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 21121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40953,
    lat: 36.93771,
    lng: -83.80163,
    city: "Hinkle",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 434,
    density: 16.9,
    county_fips: 21121,
    county_name: "Knox",
    county_weights: {
      21121: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 21121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40958,
    lat: 36.8088,
    lng: -83.5878,
    city: "Kettle Island",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 218,
    density: 9.1,
    county_fips: 21013,
    county_name: "Bell",
    county_weights: {
      21013: 100,
    },
    county_names_all: "Bell",
    county_fips_all: 21013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40962,
    lat: 37.14912,
    lng: -83.74922,
    city: "Manchester",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17699,
    density: 20.2,
    county_fips: 21051,
    county_name: "Clay",
    county_weights: {
      21051: 99.81,
      21125: 0.19,
    },
    county_names_all: "Clay|Laurel",
    county_fips_all: "21051|21125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40964,
    lat: 36.78264,
    lng: -83.33763,
    city: "Mary Alice",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 21095,
    county_name: "Harlan",
    county_weights: {
      21095: 100,
    },
    county_names_all: "Harlan",
    county_fips_all: 21095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40965,
    lat: 36.62469,
    lng: -83.73461,
    city: "Middlesboro",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11301,
    density: 50.6,
    county_fips: 21013,
    county_name: "Bell",
    county_weights: {
      21013: 85.05,
      47025: 14.95,
    },
    county_names_all: "Bell|Claiborne",
    county_fips_all: "21013|47025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40972,
    lat: 37.24501,
    lng: -83.60692,
    city: "Oneida",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1220,
    density: 6.4,
    county_fips: 21051,
    county_name: "Clay",
    county_weights: {
      21051: 98.79,
      21131: 1.21,
    },
    county_names_all: "Clay|Leslie",
    county_fips_all: "21051|21131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40977,
    lat: 36.72332,
    lng: -83.72867,
    city: "Pineville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10784,
    density: 31.1,
    county_fips: 21013,
    county_name: "Bell",
    county_weights: {
      21013: 100,
    },
    county_names_all: "Bell",
    county_fips_all: 21013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40979,
    lat: 37.00491,
    lng: -83.495,
    city: "Roark",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 21131,
    county_name: "Leslie",
    county_weights: {
      21131: 100,
    },
    county_names_all: "Leslie",
    county_fips_all: 21131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40981,
    lat: 37.27792,
    lng: -83.48531,
    city: "Saul",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 21193,
    county_name: "Perry",
    county_weights: {
      21131: 0.36,
      21193: 99.64,
    },
    county_names_all: "Perry|Leslie",
    county_fips_all: "21193|21131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40982,
    lat: 36.93241,
    lng: -83.69421,
    city: "Scalf",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 380,
    density: 16.7,
    county_fips: 21121,
    county_name: "Knox",
    county_weights: {
      21121: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 21121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40983,
    lat: 37.34608,
    lng: -83.75339,
    city: "Sextons Creek",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 271,
    density: 6.8,
    county_fips: 21189,
    county_name: "Owsley",
    county_weights: {
      21051: 41.72,
      21189: 58.28,
    },
    county_names_all: "Owsley|Clay",
    county_fips_all: "21189|21051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40988,
    lat: 36.85928,
    lng: -83.52838,
    city: "Stoney Fork",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 729,
    density: 11.9,
    county_fips: 21013,
    county_name: "Bell",
    county_weights: {
      21013: 95.34,
      21095: 4.66,
    },
    county_names_all: "Bell|Harlan",
    county_fips_all: "21013|21095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40995,
    lat: 36.75268,
    lng: -83.82322,
    city: "Trosper",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 94,
    density: 8.3,
    county_fips: 21121,
    county_name: "Knox",
    county_weights: {
      21121: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 21121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 40997,
    lat: 36.88348,
    lng: -83.67711,
    city: "Walker",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 267,
    density: 4,
    county_fips: 21121,
    county_name: "Knox",
    county_weights: {
      21121: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 21121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41001,
    lat: 38.91409,
    lng: -84.40256,
    city: "Alexandria",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17841,
    density: 133.3,
    county_fips: 21037,
    county_name: "Campbell",
    county_weights: {
      21037: 100,
    },
    county_names_all: "Campbell",
    county_fips_all: 21037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41002,
    lat: 38.73002,
    lng: -83.98282,
    city: "Augusta",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2727,
    density: 25.7,
    county_fips: 21023,
    county_name: "Bracken",
    county_weights: {
      21023: 100,
    },
    county_names_all: "Bracken",
    county_fips_all: 21023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41003,
    lat: 38.53181,
    lng: -84.39164,
    city: "Berry",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2144,
    density: 9.3,
    county_fips: 21097,
    county_name: "Harrison",
    county_weights: {
      21081: 5.33,
      21097: 73.92,
      21191: 20.75,
    },
    county_names_all: "Harrison|Pendleton|Grant",
    county_fips_all: "21097|21191|21081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41004,
    lat: 38.65549,
    lng: -84.10134,
    city: "Brooksville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3901,
    density: 13.4,
    county_fips: 21023,
    county_name: "Bracken",
    county_weights: {
      21023: 93.73,
      21191: 0.41,
      21201: 5.86,
    },
    county_names_all: "Bracken|Robertson|Pendleton",
    county_fips_all: "21023|21201|21191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41005,
    lat: 39.00709,
    lng: -84.76541,
    city: "Burlington",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24926,
    density: 183.8,
    county_fips: 21015,
    county_name: "Boone",
    county_weights: {
      21015: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 21015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41006,
    lat: 38.78475,
    lng: -84.34298,
    city: "Butler",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3671,
    density: 25.5,
    county_fips: 21191,
    county_name: "Pendleton",
    county_weights: {
      21037: 11.96,
      21191: 88.04,
    },
    county_names_all: "Pendleton|Campbell",
    county_fips_all: "21191|21037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41007,
    lat: 38.89289,
    lng: -84.30788,
    city: "California",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4952,
    density: 38.5,
    county_fips: 21037,
    county_name: "Campbell",
    county_weights: {
      21037: 89.46,
      21191: 10.54,
    },
    county_names_all: "Campbell|Pendleton",
    county_fips_all: "21037|21191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41008,
    lat: 38.65648,
    lng: -85.16873,
    city: "Carrollton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6869,
    density: 56.3,
    county_fips: 21041,
    county_name: "Carroll",
    county_weights: {
      21041: 95.63,
      21223: 4.37,
    },
    county_names_all: "Carroll|Trimble",
    county_fips_all: "21041|21223",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41010,
    lat: 38.50085,
    lng: -84.60763,
    city: "Corinth",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3203,
    density: 13.5,
    county_fips: 21081,
    county_name: "Grant",
    county_weights: {
      21081: 43.32,
      21097: 14.89,
      21187: 39.31,
      21209: 2.47,
    },
    county_names_all: "Grant|Owen|Harrison|Scott",
    county_fips_all: "21081|21187|21097|21209",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41011,
    lat: 39.06802,
    lng: -84.53065,
    city: "Covington",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27342,
    density: 1500.6,
    county_fips: 21117,
    county_name: "Kenton",
    county_weights: {
      21117: 100,
    },
    county_names_all: "Kenton",
    county_fips_all: 21117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41014,
    lat: 39.0655,
    lng: -84.50464,
    city: "Covington",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6679,
    density: 2511.8,
    county_fips: 21117,
    county_name: "Kenton",
    county_weights: {
      21117: 100,
    },
    county_names_all: "Kenton",
    county_fips_all: 21117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41015,
    lat: 38.97885,
    lng: -84.48456,
    city: "Latonia",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19701,
    density: 298.9,
    county_fips: 21117,
    county_name: "Kenton",
    county_weights: {
      21117: 100,
    },
    county_names_all: "Kenton",
    county_fips_all: 21117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41016,
    lat: 39.08701,
    lng: -84.5487,
    city: "Covington",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6387,
    density: 1665.4,
    county_fips: 21117,
    county_name: "Kenton",
    county_weights: {
      21117: 100,
    },
    county_names_all: "Kenton",
    county_fips_all: 21117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41017,
    lat: 39.02893,
    lng: -84.56177,
    city: "Ft Mitchell",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40557,
    density: 738.2,
    county_fips: 21117,
    county_name: "Kenton",
    county_weights: {
      21117: 100,
    },
    county_names_all: "Kenton",
    county_fips_all: 21117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41018,
    lat: 39.01546,
    lng: -84.60282,
    city: "Erlanger",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28047,
    density: 935.7,
    county_fips: 21117,
    county_name: "Kenton",
    county_weights: {
      21015: 22.72,
      21117: 77.28,
    },
    county_names_all: "Kenton|Boone",
    county_fips_all: "21117|21015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41030,
    lat: 38.78582,
    lng: -84.58754,
    city: "Crittenden",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5981,
    density: 70.8,
    county_fips: 21081,
    county_name: "Grant",
    county_weights: {
      21015: 7.73,
      21081: 62.28,
      21117: 29.19,
      21191: 0.8,
    },
    county_names_all: "Grant|Kenton|Boone|Pendleton",
    county_fips_all: "21081|21117|21015|21191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41031,
    lat: 38.41383,
    lng: -84.28631,
    city: "Cynthiana",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16527,
    density: 28.3,
    county_fips: 21097,
    county_name: "Harrison",
    county_weights: {
      21017: 3.4,
      21097: 90.96,
      21181: 5.64,
    },
    county_names_all: "Harrison|Nicholas|Bourbon",
    county_fips_all: "21097|21181|21017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41033,
    lat: 38.77131,
    lng: -84.46114,
    city: "De Mossville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1869,
    density: 17.7,
    county_fips: 21191,
    county_name: "Pendleton",
    county_weights: {
      21117: 17.39,
      21191: 82.61,
    },
    county_names_all: "Pendleton|Kenton",
    county_fips_all: "21191|21117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41034,
    lat: 38.70104,
    lng: -83.90426,
    city: "Dover",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1002,
    density: 12.6,
    county_fips: 21161,
    county_name: "Mason",
    county_weights: {
      21023: 2.43,
      21161: 97.57,
    },
    county_names_all: "Mason|Bracken",
    county_fips_all: "21161|21023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41035,
    lat: 38.70322,
    lng: -84.66141,
    city: "Dry Ridge",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11492,
    density: 43.4,
    county_fips: 21081,
    county_name: "Grant",
    county_weights: {
      21081: 96.98,
      21187: 1.51,
      21191: 1.51,
    },
    county_names_all: "Grant|Pendleton|Owen",
    county_fips_all: "21081|21191|21187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41039,
    lat: 38.41381,
    lng: -83.88074,
    city: "Ewing",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2724,
    density: 13.3,
    county_fips: 21069,
    county_name: "Fleming",
    county_weights: {
      21069: 84.66,
      21161: 2.43,
      21181: 10.74,
      21201: 2.17,
    },
    county_names_all: "Fleming|Nicholas|Mason|Robertson",
    county_fips_all: "21069|21181|21161|21201",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41040,
    lat: 38.65232,
    lng: -84.33188,
    city: "Falmouth",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7500,
    density: 19.4,
    county_fips: 21191,
    county_name: "Pendleton",
    county_weights: {
      21023: 4.33,
      21191: 95.67,
    },
    county_names_all: "Pendleton|Bracken",
    county_fips_all: "21191|21023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41041,
    lat: 38.40548,
    lng: -83.72338,
    city: "Flemingsburg",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7049,
    density: 25.5,
    county_fips: 21069,
    county_name: "Fleming",
    county_weights: {
      21069: 100,
    },
    county_names_all: "Fleming",
    county_fips_all: 21069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41042,
    lat: 38.98595,
    lng: -84.64906,
    city: "Florence",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54730,
    density: 955.6,
    county_fips: 21015,
    county_name: "Boone",
    county_weights: {
      21015: 94.59,
      21117: 5.41,
    },
    county_names_all: "Boone|Kenton",
    county_fips_all: "21015|21117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41043,
    lat: 38.75644,
    lng: -84.19832,
    city: "Foster",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1601,
    density: 12.4,
    county_fips: 21023,
    county_name: "Bracken",
    county_weights: {
      21023: 71.85,
      21191: 28.15,
    },
    county_names_all: "Bracken|Pendleton",
    county_fips_all: "21023|21191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41044,
    lat: 38.60513,
    lng: -83.97265,
    city: "Germantown",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 928,
    density: 11.8,
    county_fips: 21161,
    county_name: "Mason",
    county_weights: {
      21023: 30.09,
      21161: 38.98,
      21201: 30.93,
    },
    county_names_all: "Mason|Robertson|Bracken",
    county_fips_all: "21161|21201|21023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41045,
    lat: 38.72262,
    lng: -85.02091,
    city: "Ghent",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1373,
    density: 16.4,
    county_fips: 21041,
    county_name: "Carroll",
    county_weights: {
      21041: 64.88,
      21077: 35.12,
    },
    county_names_all: "Carroll|Gallatin",
    county_fips_all: "21041|21077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41046,
    lat: 38.70953,
    lng: -84.80637,
    city: "Glencoe",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1674,
    density: 27.2,
    county_fips: 21187,
    county_name: "Owen",
    county_weights: {
      21077: 36.71,
      21081: 18.16,
      21187: 45.13,
    },
    county_names_all: "Owen|Gallatin|Grant",
    county_fips_all: "21187|21077|21081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41048,
    lat: 39.08366,
    lng: -84.70585,
    city: "Hebron",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15781,
    density: 181.7,
    county_fips: 21015,
    county_name: "Boone",
    county_weights: {
      21015: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 21015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41049,
    lat: 38.27465,
    lng: -83.64581,
    city: "Hillsboro",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2244,
    density: 10.1,
    county_fips: 21069,
    county_name: "Fleming",
    county_weights: {
      21069: 99.74,
      21205: 0.26,
    },
    county_names_all: "Fleming|Rowan",
    county_fips_all: "21069|21205",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41051,
    lat: 38.93233,
    lng: -84.54451,
    city: "Independence",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29846,
    density: 382.3,
    county_fips: 21117,
    county_name: "Kenton",
    county_weights: {
      21117: 100,
    },
    county_names_all: "Kenton",
    county_fips_all: 21117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41052,
    lat: 38.65914,
    lng: -84.77777,
    city: "Jonesville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65,
    density: 2.4,
    county_fips: 21081,
    county_name: "Grant",
    county_weights: {
      21081: 53.09,
      21187: 46.91,
    },
    county_names_all: "Grant|Owen",
    county_fips_all: "21081|21187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41055,
    lat: 38.51787,
    lng: -83.86995,
    city: "Mayslick",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1800,
    density: 10.4,
    county_fips: 21161,
    county_name: "Mason",
    county_weights: {
      21069: 6.73,
      21161: 89.11,
      21201: 4.16,
    },
    county_names_all: "Mason|Fleming|Robertson",
    county_fips_all: "21161|21069|21201",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41056,
    lat: 38.59913,
    lng: -83.77576,
    city: "Maysville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14087,
    density: 39,
    county_fips: 21161,
    county_name: "Mason",
    county_weights: {
      21069: 0.5,
      21135: 1.27,
      21161: 98.23,
    },
    county_names_all: "Mason|Lewis|Fleming",
    county_fips_all: "21161|21135|21069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41059,
    lat: 39.00504,
    lng: -84.35213,
    city: "Melbourne",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3395,
    density: 85.3,
    county_fips: 21037,
    county_name: "Campbell",
    county_weights: {
      21037: 100,
    },
    county_names_all: "Campbell",
    county_fips_all: 21037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41063,
    lat: 38.85323,
    lng: -84.49983,
    city: "Morning View",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3100,
    density: 37.9,
    county_fips: 21117,
    county_name: "Kenton",
    county_weights: {
      21117: 100,
    },
    county_names_all: "Kenton",
    county_fips_all: 21117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41064,
    lat: 38.51462,
    lng: -84.07106,
    city: "Mount Olivet",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1901,
    density: 8.7,
    county_fips: 21201,
    county_name: "Robertson",
    county_weights: {
      21023: 5.43,
      21097: 0.81,
      21201: 93.76,
    },
    county_names_all: "Robertson|Bracken|Harrison",
    county_fips_all: "21201|21023|21097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41071,
    lat: 39.0732,
    lng: -84.48211,
    city: "Newport",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20628,
    density: 1448.2,
    county_fips: 21037,
    county_name: "Campbell",
    county_weights: {
      21037: 100,
    },
    county_names_all: "Campbell",
    county_fips_all: 21037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41073,
    lat: 39.10123,
    lng: -84.47748,
    city: "Bellevue",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5786,
    density: 2467.5,
    county_fips: 21037,
    county_name: "Campbell",
    county_weights: {
      21037: 100,
    },
    county_names_all: "Campbell",
    county_fips_all: 21037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41074,
    lat: 39.11018,
    lng: -84.4607,
    city: "Dayton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5550,
    density: 1477.6,
    county_fips: 21037,
    county_name: "Campbell",
    county_weights: {
      21037: 100,
    },
    county_names_all: "Campbell",
    county_fips_all: 21037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41075,
    lat: 39.07838,
    lng: -84.45248,
    city: "Fort Thomas",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16554,
    density: 1095.5,
    county_fips: 21037,
    county_name: "Campbell",
    county_weights: {
      21037: 100,
    },
    county_names_all: "Campbell",
    county_fips_all: 21037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41076,
    lat: 39.0178,
    lng: -84.44084,
    city: "Newport",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16926,
    density: 340.9,
    county_fips: 21037,
    county_name: "Campbell",
    county_weights: {
      21037: 100,
    },
    county_names_all: "Campbell",
    county_fips_all: 21037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41080,
    lat: 39.0493,
    lng: -84.82938,
    city: "Petersburg",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1956,
    density: 28.2,
    county_fips: 21015,
    county_name: "Boone",
    county_weights: {
      21015: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 21015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41083,
    lat: 38.67513,
    lng: -84.98805,
    city: "Sanders",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1842,
    density: 17.9,
    county_fips: 21041,
    county_name: "Carroll",
    county_weights: {
      21041: 62.22,
      21077: 30.37,
      21187: 7.41,
    },
    county_names_all: "Carroll|Gallatin|Owen",
    county_fips_all: "21041|21077|21187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41085,
    lat: 39.03508,
    lng: -84.39378,
    city: "Silver Grove",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 904,
    density: 1094,
    county_fips: 21037,
    county_name: "Campbell",
    county_weights: {
      21037: 100,
    },
    county_names_all: "Campbell",
    county_fips_all: 21037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41086,
    lat: 38.69219,
    lng: -84.88241,
    city: "Sparta",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2529,
    density: 20.3,
    county_fips: 21077,
    county_name: "Gallatin",
    county_weights: {
      21077: 53.64,
      21187: 46.36,
    },
    county_names_all: "Gallatin|Owen",
    county_fips_all: "21077|21187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41091,
    lat: 38.92056,
    lng: -84.7379,
    city: "Union",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21569,
    density: 148.3,
    county_fips: 21015,
    county_name: "Boone",
    county_weights: {
      21015: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 21015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41092,
    lat: 38.81811,
    lng: -84.70115,
    city: "Verona",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3336,
    density: 33.7,
    county_fips: 21015,
    county_name: "Boone",
    county_weights: {
      21015: 64.91,
      21077: 33.23,
      21081: 1.86,
    },
    county_names_all: "Boone|Gallatin|Grant",
    county_fips_all: "21015|21077|21081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41093,
    lat: 38.39441,
    lng: -83.56269,
    city: "Wallingford",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3315,
    density: 12.5,
    county_fips: 21069,
    county_name: "Fleming",
    county_weights: {
      21069: 81.48,
      21135: 18.52,
    },
    county_names_all: "Fleming|Lewis",
    county_fips_all: "21069|21135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41094,
    lat: 38.88213,
    lng: -84.62292,
    city: "Walton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15612,
    density: 143.3,
    county_fips: 21015,
    county_name: "Boone",
    county_weights: {
      21015: 62.7,
      21117: 37.3,
    },
    county_names_all: "Boone|Kenton",
    county_fips_all: "21015|21117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41095,
    lat: 38.79033,
    lng: -84.81567,
    city: "Warsaw",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3732,
    density: 52.1,
    county_fips: 21077,
    county_name: "Gallatin",
    county_weights: {
      21077: 100,
    },
    county_names_all: "Gallatin",
    county_fips_all: 21077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41097,
    lat: 38.62088,
    lng: -84.58033,
    city: "Williamstown",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7169,
    density: 28.9,
    county_fips: 21081,
    county_name: "Grant",
    county_weights: {
      21081: 87.51,
      21191: 12.49,
    },
    county_names_all: "Grant|Pendleton",
    county_fips_all: "21081|21191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41098,
    lat: 38.59553,
    lng: -84.99513,
    city: "Worthville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2159,
    density: 16.9,
    county_fips: 21187,
    county_name: "Owen",
    county_weights: {
      21041: 16.55,
      21187: 83.45,
    },
    county_names_all: "Owen|Carroll",
    county_fips_all: "21187|21041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41101,
    lat: 38.47392,
    lng: -82.65045,
    city: "Ashland",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19237,
    density: 724.5,
    county_fips: 21019,
    county_name: "Boyd",
    county_weights: {
      21019: 82.64,
      21089: 17.36,
    },
    county_names_all: "Boyd|Greenup",
    county_fips_all: "21019|21089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41102,
    lat: 38.42045,
    lng: -82.72425,
    city: "Ashland",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18600,
    density: 144.3,
    county_fips: 21019,
    county_name: "Boyd",
    county_weights: {
      21019: 88.94,
      21043: 1.36,
      21089: 9.7,
    },
    county_names_all: "Boyd|Greenup|Carter",
    county_fips_all: "21019|21089|21043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41121,
    lat: 38.44911,
    lng: -82.83032,
    city: "Argillite",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2019,
    density: 17,
    county_fips: 21089,
    county_name: "Greenup",
    county_weights: {
      21089: 100,
    },
    county_names_all: "Greenup",
    county_fips_all: 21089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41124,
    lat: 38.02148,
    lng: -82.85118,
    city: "Blaine",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 810,
    density: 5.3,
    county_fips: 21127,
    county_name: "Lawrence",
    county_weights: {
      21127: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 21127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41129,
    lat: 38.31755,
    lng: -82.64073,
    city: "Catlettsburg",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9730,
    density: 42.9,
    county_fips: 21019,
    county_name: "Boyd",
    county_weights: {
      21019: 78.65,
      21127: 21.35,
    },
    county_names_all: "Boyd|Lawrence",
    county_fips_all: "21019|21127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41132,
    lat: 38.25667,
    lng: -82.8314,
    city: "Denton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 356,
    density: 11,
    county_fips: 21043,
    county_name: "Carter",
    county_weights: {
      21043: 93.56,
      21127: 6.44,
    },
    county_names_all: "Carter|Lawrence",
    county_fips_all: "21043|21127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41135,
    lat: 38.36026,
    lng: -83.28796,
    city: "Emerson",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 114,
    density: 3.7,
    county_fips: 21135,
    county_name: "Lewis",
    county_weights: {
      21135: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 21135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41139,
    lat: 38.50927,
    lng: -82.73288,
    city: "Flatwoods",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7778,
    density: 364.4,
    county_fips: 21089,
    county_name: "Greenup",
    county_weights: {
      21089: 100,
    },
    county_names_all: "Greenup",
    county_fips_all: 21089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41141,
    lat: 38.54381,
    lng: -83.13357,
    city: "Garrison",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1930,
    density: 11.1,
    county_fips: 21135,
    county_name: "Lewis",
    county_weights: {
      21089: 42.51,
      21135: 57.49,
    },
    county_names_all: "Lewis|Greenup",
    county_fips_all: "21135|21089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41142,
    lat: 38.27774,
    lng: -83.07308,
    city: "Grahn",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 21043,
    county_name: "Carter",
    county_weights: {
      21043: 100,
    },
    county_names_all: "Carter",
    county_fips_all: 21043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41143,
    lat: 38.33916,
    lng: -82.97704,
    city: "Grayson",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13851,
    density: 27.6,
    county_fips: 21043,
    county_name: "Carter",
    county_weights: {
      21043: 90.47,
      21089: 9.53,
    },
    county_names_all: "Carter|Greenup",
    county_fips_all: "21043|21089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41144,
    lat: 38.53461,
    lng: -82.91208,
    city: "Greenup",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9992,
    density: 27.3,
    county_fips: 21089,
    county_name: "Greenup",
    county_weights: {
      21089: 100,
    },
    county_names_all: "Greenup",
    county_fips_all: 21089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41146,
    lat: 38.27701,
    lng: -82.88969,
    city: "Hitchins",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 349,
    density: 18.7,
    county_fips: 21043,
    county_name: "Carter",
    county_weights: {
      21043: 100,
    },
    county_names_all: "Carter",
    county_fips_all: 21043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41149,
    lat: 38.06008,
    lng: -83.05438,
    city: "Isonville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 627,
    density: 8.6,
    county_fips: 21063,
    county_name: "Elliott",
    county_weights: {
      21063: 100,
    },
    county_names_all: "Elliott",
    county_fips_all: 21063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41159,
    lat: 38.01305,
    lng: -82.96993,
    city: "Martha",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 525,
    density: 9.1,
    county_fips: 21127,
    county_name: "Lawrence",
    county_weights: {
      21127: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 21127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41164,
    lat: 38.28914,
    lng: -83.16231,
    city: "Olive Hill",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13143,
    density: 21,
    county_fips: 21043,
    county_name: "Carter",
    county_weights: {
      21043: 77,
      21063: 22.43,
      21135: 0.42,
      21205: 0.15,
    },
    county_names_all: "Carter|Elliott|Lewis|Rowan",
    county_fips_all: "21043|21063|21135|21205",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41166,
    lat: 38.63464,
    lng: -83.09328,
    city: "Quincy",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1427,
    density: 27.8,
    county_fips: 21135,
    county_name: "Lewis",
    county_weights: {
      21135: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 21135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41168,
    lat: 38.30732,
    lng: -82.76992,
    city: "Rush",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3769,
    density: 24.6,
    county_fips: 21019,
    county_name: "Boyd",
    county_weights: {
      21019: 64.63,
      21043: 35.37,
    },
    county_names_all: "Boyd|Carter",
    county_fips_all: "21019|21043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41169,
    lat: 38.52232,
    lng: -82.71316,
    city: "Russell",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4867,
    density: 302.3,
    county_fips: 21089,
    county_name: "Greenup",
    county_weights: {
      21089: 100,
    },
    county_names_all: "Greenup",
    county_fips_all: 21089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41171,
    lat: 38.09336,
    lng: -83.08901,
    city: "Sandy Hook",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4828,
    density: 15.7,
    county_fips: 21063,
    county_name: "Elliott",
    county_weights: {
      21063: 100,
    },
    county_names_all: "Elliott",
    county_fips_all: 21063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41174,
    lat: 38.69841,
    lng: -83.0139,
    city: "South Portsmouth",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 982,
    density: 30.5,
    county_fips: 21089,
    county_name: "Greenup",
    county_weights: {
      21089: 73.66,
      21135: 26.34,
    },
    county_names_all: "Greenup|Lewis",
    county_fips_all: "21089|21135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41175,
    lat: 38.64574,
    lng: -82.97791,
    city: "South Shore",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5221,
    density: 25.7,
    county_fips: 21089,
    county_name: "Greenup",
    county_weights: {
      21089: 100,
    },
    county_names_all: "Greenup",
    county_fips_all: 21089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41179,
    lat: 38.52483,
    lng: -83.38988,
    city: "Vanceburg",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7351,
    density: 8.4,
    county_fips: 21135,
    county_name: "Lewis",
    county_weights: {
      21135: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 21135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41180,
    lat: 38.13358,
    lng: -82.85999,
    city: "Webbville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 984,
    density: 5,
    county_fips: 21127,
    county_name: "Lawrence",
    county_weights: {
      21043: 5.14,
      21063: 20.66,
      21127: 74.2,
    },
    county_names_all: "Lawrence|Elliott|Carter",
    county_fips_all: "21127|21063|21043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41181,
    lat: 38.20758,
    lng: -82.87425,
    city: "Willard",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 21043,
    county_name: "Carter",
    county_weights: {
      21043: 100,
    },
    county_names_all: "Carter",
    county_fips_all: 21043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41183,
    lat: 38.55,
    lng: -82.73707,
    city: "Worthington",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1639,
    density: 419.1,
    county_fips: 21089,
    county_name: "Greenup",
    county_weights: {
      21089: 100,
    },
    county_names_all: "Greenup",
    county_fips_all: 21089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41189,
    lat: 38.54493,
    lng: -83.56175,
    city: "Tollesboro",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1852,
    density: 14.8,
    county_fips: 21135,
    county_name: "Lewis",
    county_weights: {
      21135: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 21135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41201,
    lat: 38.06201,
    lng: -82.7576,
    city: "Adams",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 183,
    density: 6.4,
    county_fips: 21127,
    county_name: "Lawrence",
    county_weights: {
      21127: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 21127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41203,
    lat: 37.85241,
    lng: -82.46112,
    city: "Beauty",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 556,
    density: 27.8,
    county_fips: 21159,
    county_name: "Martin",
    county_weights: {
      21159: 100,
    },
    county_names_all: "Martin",
    county_fips_all: 21159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41204,
    lat: 37.81784,
    lng: -82.6843,
    city: "Boons Camp",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 651,
    density: 21.1,
    county_fips: 21115,
    county_name: "Johnson",
    county_weights: {
      21115: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 21115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41214,
    lat: 37.79448,
    lng: -82.59839,
    city: "Debord",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 511,
    density: 13,
    county_fips: 21159,
    county_name: "Martin",
    county_weights: {
      21159: 100,
    },
    county_names_all: "Martin",
    county_fips_all: 21159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41216,
    lat: 37.73016,
    lng: -82.81308,
    city: "East Point",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1452,
    density: 32.9,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 66.46,
      21115: 33.54,
    },
    county_names_all: "Floyd|Johnson",
    county_fips_all: "21071|21115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41219,
    lat: 37.92586,
    lng: -82.90882,
    city: "Flatgap",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1700,
    density: 13.6,
    county_fips: 21115,
    county_name: "Johnson",
    county_weights: {
      21115: 96.1,
      21175: 3.9,
    },
    county_names_all: "Johnson|Morgan",
    county_fips_all: "21115|21175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41222,
    lat: 37.77036,
    lng: -82.85032,
    city: "Hagerhill",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2618,
    density: 35.9,
    county_fips: 21115,
    county_name: "Johnson",
    county_weights: {
      21115: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 21115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41224,
    lat: 37.82089,
    lng: -82.53936,
    city: "Inez",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5846,
    density: 27,
    county_fips: 21159,
    county_name: "Martin",
    county_weights: {
      21159: 100,
    },
    county_names_all: "Martin",
    county_fips_all: 21159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41226,
    lat: 37.97853,
    lng: -82.9562,
    city: "Keaton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 136,
    density: 8.5,
    county_fips: 21115,
    county_name: "Johnson",
    county_weights: {
      21115: 99.73,
      21127: 0.27,
    },
    county_names_all: "Johnson|Lawrence",
    county_fips_all: "21115|21127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41230,
    lat: 38.0656,
    lng: -82.66196,
    city: "Louisa",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11513,
    density: 19.2,
    county_fips: 21127,
    county_name: "Lawrence",
    county_weights: {
      21127: 96.75,
      21159: 3.25,
    },
    county_names_all: "Lawrence|Martin",
    county_fips_all: "21127|21159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41231,
    lat: 37.79447,
    lng: -82.38903,
    city: "Lovely",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 627,
    density: 18.5,
    county_fips: 21159,
    county_name: "Martin",
    county_weights: {
      21159: 100,
    },
    county_names_all: "Martin",
    county_fips_all: 21159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41232,
    lat: 37.93602,
    lng: -82.74007,
    city: "Lowmansville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 833,
    density: 25.6,
    county_fips: 21127,
    county_name: "Lawrence",
    county_weights: {
      21115: 30.83,
      21127: 69.17,
    },
    county_names_all: "Lawrence|Johnson",
    county_fips_all: "21127|21115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41234,
    lat: 37.79654,
    lng: -82.74161,
    city: "Meally",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 642,
    density: 52.6,
    county_fips: 21115,
    county_name: "Johnson",
    county_weights: {
      21115: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 21115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41238,
    lat: 37.83943,
    lng: -82.95072,
    city: "Oil Springs",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 615,
    density: 8.5,
    county_fips: 21115,
    county_name: "Johnson",
    county_weights: {
      21115: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 21115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41240,
    lat: 37.82103,
    lng: -82.78927,
    city: "Paintsville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6664,
    density: 69.8,
    county_fips: 21115,
    county_name: "Johnson",
    county_weights: {
      21115: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 21115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41250,
    lat: 37.73511,
    lng: -82.46079,
    city: "Pilgrim",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1436,
    density: 8,
    county_fips: 21159,
    county_name: "Martin",
    county_weights: {
      21159: 100,
    },
    county_names_all: "Martin",
    county_fips_all: 21159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41254,
    lat: 37.8845,
    lng: -82.72711,
    city: "River",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 504,
    density: 15.8,
    county_fips: 21115,
    county_name: "Johnson",
    county_weights: {
      21115: 92.23,
      21127: 7.77,
    },
    county_names_all: "Johnson|Lawrence",
    county_fips_all: "21115|21127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41255,
    lat: 37.91014,
    lng: -82.83765,
    city: "Sitka",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 915,
    density: 27.1,
    county_fips: 21115,
    county_name: "Johnson",
    county_weights: {
      21115: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 21115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41256,
    lat: 37.82446,
    lng: -82.88135,
    city: "Staffordsville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2852,
    density: 58.6,
    county_fips: 21115,
    county_name: "Johnson",
    county_weights: {
      21115: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 21115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41257,
    lat: 37.91372,
    lng: -82.8044,
    city: "Stambaugh",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 807,
    density: 33.4,
    county_fips: 21115,
    county_name: "Johnson",
    county_weights: {
      21115: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 21115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41260,
    lat: 37.82253,
    lng: -82.75126,
    city: "Thelma",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1040,
    density: 141.2,
    county_fips: 21115,
    county_name: "Johnson",
    county_weights: {
      21115: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 21115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41262,
    lat: 37.85112,
    lng: -82.61377,
    city: "Tomahawk",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1138,
    density: 16.7,
    county_fips: 21159,
    county_name: "Martin",
    county_weights: {
      21159: 100,
    },
    county_names_all: "Martin",
    county_fips_all: 21159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41263,
    lat: 37.85717,
    lng: -82.76256,
    city: "Tutor Key",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 332,
    density: 23.6,
    county_fips: 21115,
    county_name: "Johnson",
    county_weights: {
      21115: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 21115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41264,
    lat: 37.94021,
    lng: -82.677,
    city: "Ulysses",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 668,
    density: 19.1,
    county_fips: 21127,
    county_name: "Lawrence",
    county_weights: {
      21127: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 21127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41265,
    lat: 37.75424,
    lng: -82.70446,
    city: "Van Lear",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1007,
    density: 14.4,
    county_fips: 21115,
    county_name: "Johnson",
    county_weights: {
      21071: 21.04,
      21115: 78.96,
    },
    county_names_all: "Johnson|Floyd",
    county_fips_all: "21115|21071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41267,
    lat: 37.87514,
    lng: -82.43591,
    city: "Warfield",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1224,
    density: 79.2,
    county_fips: 21159,
    county_name: "Martin",
    county_weights: {
      21159: 100,
    },
    county_names_all: "Martin",
    county_fips_all: 21159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41268,
    lat: 37.78797,
    lng: -82.78433,
    city: "West Van Lear",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 911,
    density: 1092,
    county_fips: 21115,
    county_name: "Johnson",
    county_weights: {
      21115: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 21115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41271,
    lat: 37.82773,
    lng: -82.72453,
    city: "Williamsport",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 166,
    density: 19.2,
    county_fips: 21115,
    county_name: "Johnson",
    county_weights: {
      21115: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 21115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41274,
    lat: 37.86174,
    lng: -82.81164,
    city: "Wittensville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 378,
    density: 35.6,
    county_fips: 21115,
    county_name: "Johnson",
    county_weights: {
      21115: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 21115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41301,
    lat: 37.72121,
    lng: -83.48941,
    city: "Campton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6341,
    density: 11.7,
    county_fips: 21237,
    county_name: "Wolfe",
    county_weights: {
      21025: 7.93,
      21129: 7.78,
      21237: 84.29,
    },
    county_names_all: "Wolfe|Breathitt|Lee",
    county_fips_all: "21237|21025|21129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41310,
    lat: 37.64068,
    lng: -83.25147,
    city: "Bays",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 21025,
    county_name: "Breathitt",
    county_weights: {
      21025: 100,
    },
    county_names_all: "Breathitt",
    county_fips_all: 21025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41311,
    lat: 37.57896,
    lng: -83.72163,
    city: "Beattyville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6929,
    density: 15.7,
    county_fips: 21129,
    county_name: "Lee",
    county_weights: {
      21025: 0.43,
      21129: 98.62,
      21189: 0.95,
    },
    county_names_all: "Lee|Owsley|Breathitt",
    county_fips_all: "21129|21189|21025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41314,
    lat: 37.44008,
    lng: -83.63743,
    city: "Booneville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4777,
    density: 10.4,
    county_fips: 21189,
    county_name: "Owsley",
    county_weights: {
      21025: 25.23,
      21189: 74.77,
    },
    county_names_all: "Owsley|Breathitt",
    county_fips_all: "21189|21025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41317,
    lat: 37.46029,
    lng: -83.19851,
    city: "Clayhole",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 245,
    density: 2.3,
    county_fips: 21025,
    county_name: "Breathitt",
    county_weights: {
      21025: 100,
    },
    county_names_all: "Breathitt",
    county_fips_all: 21025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41332,
    lat: 37.80029,
    lng: -83.37575,
    city: "Hazel Green",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 843,
    density: 8.2,
    county_fips: 21175,
    county_name: "Morgan",
    county_weights: {
      21175: 61.2,
      21237: 38.8,
    },
    county_names_all: "Morgan|Wolfe",
    county_fips_all: "21175|21237",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41339,
    lat: 37.53158,
    lng: -83.29231,
    city: "Jackson",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10267,
    density: 12,
    county_fips: 21025,
    county_name: "Breathitt",
    county_weights: {
      21025: 92.02,
      21119: 6.55,
      21129: 1.43,
    },
    county_names_all: "Breathitt|Knott|Lee",
    county_fips_all: "21025|21119|21129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41348,
    lat: 37.42577,
    lng: -83.31387,
    city: "Lost Creek",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1038,
    density: 10.3,
    county_fips: 21025,
    county_name: "Breathitt",
    county_weights: {
      21025: 100,
    },
    county_names_all: "Breathitt",
    county_fips_all: 21025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41351,
    lat: 37.32754,
    lng: -83.59363,
    city: "Mistletoe",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 21189,
    county_name: "Owsley",
    county_weights: {
      21189: 100,
    },
    county_names_all: "Owsley",
    county_fips_all: 21189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41352,
    lat: 37.82357,
    lng: -83.33511,
    city: "Mize",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 604,
    density: 11.5,
    county_fips: 21175,
    county_name: "Morgan",
    county_weights: {
      21175: 100,
    },
    county_names_all: "Morgan",
    county_fips_all: 21175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41360,
    lat: 37.78889,
    lng: -83.6264,
    city: "Pine Ridge",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 314,
    density: 7.3,
    county_fips: 21237,
    county_name: "Wolfe",
    county_weights: {
      21197: 1.09,
      21237: 98.91,
    },
    county_names_all: "Wolfe|Powell",
    county_fips_all: "21237|21197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41364,
    lat: 37.37569,
    lng: -83.64172,
    city: "Ricetown",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 21189,
    county_name: "Owsley",
    county_weights: {
      21189: 100,
    },
    county_names_all: "Owsley",
    county_fips_all: 21189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41365,
    lat: 37.71117,
    lng: -83.62663,
    city: "Rogers",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 466,
    density: 12.7,
    county_fips: 21237,
    county_name: "Wolfe",
    county_weights: {
      21237: 100,
    },
    county_names_all: "Wolfe",
    county_fips_all: 21237,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41366,
    lat: 37.62472,
    lng: -83.21959,
    city: "Rousseau",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35,
    density: 1.3,
    county_fips: 21025,
    county_name: "Breathitt",
    county_weights: {
      21025: 100,
    },
    county_names_all: "Breathitt",
    county_fips_all: 21025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41367,
    lat: 37.4045,
    lng: -83.23218,
    city: "Rowdy",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 141,
    density: 7,
    county_fips: 21193,
    county_name: "Perry",
    county_weights: {
      21193: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 21193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41385,
    lat: 37.64998,
    lng: -83.33665,
    city: "Vancleve",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 417,
    density: 6,
    county_fips: 21025,
    county_name: "Breathitt",
    county_weights: {
      21025: 100,
    },
    county_names_all: "Breathitt",
    county_fips_all: 21025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41386,
    lat: 37.47992,
    lng: -83.79273,
    city: "Vincent",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 21189,
    county_name: "Owsley",
    county_weights: {
      21189: 100,
    },
    county_names_all: "Owsley",
    county_fips_all: 21189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41390,
    lat: 37.41872,
    lng: -83.3792,
    city: "Whick",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14,
    density: 3.4,
    county_fips: 21025,
    county_name: "Breathitt",
    county_weights: {
      21025: 100,
    },
    county_names_all: "Breathitt",
    county_fips_all: 21025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41397,
    lat: 37.66683,
    lng: -83.67709,
    city: "Zoe",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11,
    density: 0.4,
    county_fips: 21129,
    county_name: "Lee",
    county_weights: {
      21129: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 21129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41408,
    lat: 37.79508,
    lng: -83.28828,
    city: "Cannel City",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 388,
    density: 27.3,
    county_fips: 21175,
    county_name: "Morgan",
    county_weights: {
      21175: 100,
    },
    county_names_all: "Morgan",
    county_fips_all: 21175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41421,
    lat: 37.99027,
    lng: -83.17397,
    city: "Elkfork",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 407,
    density: 9.5,
    county_fips: 21175,
    county_name: "Morgan",
    county_weights: {
      21175: 100,
    },
    county_names_all: "Morgan",
    county_fips_all: 21175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41425,
    lat: 37.88407,
    lng: -83.42761,
    city: "Ezel",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1243,
    density: 16.3,
    county_fips: 21175,
    county_name: "Morgan",
    county_weights: {
      21175: 98.79,
      21237: 1.21,
    },
    county_names_all: "Morgan|Wolfe",
    county_fips_all: "21175|21237",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41464,
    lat: 37.65974,
    lng: -82.97201,
    city: "Royalton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 679,
    density: 24.9,
    county_fips: 21153,
    county_name: "Magoffin",
    county_weights: {
      21153: 100,
    },
    county_names_all: "Magoffin",
    county_fips_all: 21153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41465,
    lat: 37.72985,
    lng: -83.08494,
    city: "Salyersville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11210,
    density: 16.5,
    county_fips: 21153,
    county_name: "Magoffin",
    county_weights: {
      21153: 100,
    },
    county_names_all: "Magoffin",
    county_fips_all: 21153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41472,
    lat: 37.94179,
    lng: -83.22334,
    city: "West Liberty",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10104,
    density: 14.4,
    county_fips: 21175,
    county_name: "Morgan",
    county_weights: {
      21063: 0.87,
      21175: 99.13,
    },
    county_names_all: "Morgan|Elliott",
    county_fips_all: "21175|21063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41501,
    lat: 37.50805,
    lng: -82.5154,
    city: "Pikeville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22017,
    density: 44.2,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41503,
    lat: 37.66079,
    lng: -82.28446,
    city: "South Williamson",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 516,
    density: 84.9,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41512,
    lat: 37.25251,
    lng: -82.47772,
    city: "Ashcamp",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 796,
    density: 24.7,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41513,
    lat: 37.35282,
    lng: -82.34329,
    city: "Belcher",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 415,
    density: 22.6,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41514,
    lat: 37.67135,
    lng: -82.33169,
    city: "Belfry",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2599,
    density: 18.6,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21159: 2.03,
      21195: 97.97,
    },
    county_names_all: "Pike|Martin",
    county_fips_all: "21195|21159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41517,
    lat: 37.18919,
    lng: -82.60026,
    city: "Burdine",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 119,
    density: 1235.2,
    county_fips: 21133,
    county_name: "Letcher",
    county_weights: {
      21133: 100,
    },
    county_names_all: "Letcher",
    county_fips_all: 21133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41519,
    lat: 37.58359,
    lng: -82.32334,
    city: "Canada",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1015,
    density: 34.7,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41522,
    lat: 37.31644,
    lng: -82.40088,
    city: "Elkhorn City",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5014,
    density: 27.6,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41524,
    lat: 37.43345,
    lng: -82.23444,
    city: "Fedscreek",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 167,
    density: 3.7,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41526,
    lat: 37.43372,
    lng: -82.51256,
    city: "Fords Branch",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 135,
    density: 1641.8,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41527,
    lat: 37.63187,
    lng: -82.29378,
    city: "Forest Hills",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 627,
    density: 61.5,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41528,
    lat: 37.55458,
    lng: -82.13984,
    city: "Freeburn",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1205,
    density: 84.9,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41531,
    lat: 37.59509,
    lng: -82.23131,
    city: "Hardy",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 938,
    density: 35.4,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41534,
    lat: 37.27748,
    lng: -82.49644,
    city: "Hellier",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 237,
    density: 18.7,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41535,
    lat: 37.59368,
    lng: -82.28422,
    city: "Huddy",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 704,
    density: 100.6,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41537,
    lat: 37.22221,
    lng: -82.61619,
    city: "Jenkins",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4508,
    density: 31.8,
    county_fips: 21133,
    county_name: "Letcher",
    county_weights: {
      21133: 50.86,
      21195: 49.14,
    },
    county_names_all: "Letcher|Pike",
    county_fips_all: "21133|21195",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41538,
    lat: 37.30338,
    lng: -82.58891,
    city: "Jonancy",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41539,
    lat: 37.50265,
    lng: -82.32231,
    city: "Kimper",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1443,
    density: 13.1,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41540,
    lat: 37.39013,
    lng: -82.32318,
    city: "Lick Creek",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 115,
    density: 3.1,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41543,
    lat: 37.54837,
    lng: -82.28226,
    city: "McAndrews",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 357,
    density: 34.5,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41544,
    lat: 37.59602,
    lng: -82.17368,
    city: "McCarr",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 685,
    density: 26.3,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41547,
    lat: 37.53821,
    lng: -82.09437,
    city: "Majestic",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 685,
    density: 36.3,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41548,
    lat: 37.37847,
    lng: -82.25372,
    city: "Mouthcard",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1225,
    density: 30.6,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41553,
    lat: 37.48057,
    lng: -82.16025,
    city: "Phelps",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1321,
    density: 13.2,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41554,
    lat: 37.43919,
    lng: -82.32446,
    city: "Phyllis",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1005,
    density: 22.2,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41555,
    lat: 37.53816,
    lng: -82.2589,
    city: "Pinsonfork",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 800,
    density: 36.3,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41557,
    lat: 37.48189,
    lng: -82.41548,
    city: "Raccoon",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1774,
    density: 27.3,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41558,
    lat: 37.53953,
    lng: -82.20819,
    city: "Ransom",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 887,
    density: 22.6,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41559,
    lat: 37.37997,
    lng: -82.39017,
    city: "Regina",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 173,
    density: 12.8,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41560,
    lat: 37.39423,
    lng: -82.57875,
    city: "Robinson Creek",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 167,
    density: 10.6,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41562,
    lat: 37.3991,
    lng: -82.47052,
    city: "Shelbiana",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2622,
    density: 60,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41563,
    lat: 37.22628,
    lng: -82.53694,
    city: "Shelby Gap",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 356,
    density: 19.2,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41564,
    lat: 37.60476,
    lng: -82.3667,
    city: "Sidney",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 732,
    density: 17.9,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41566,
    lat: 37.40836,
    lng: -82.1922,
    city: "Steele",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 743,
    density: 29.8,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41567,
    lat: 37.56897,
    lng: -82.28621,
    city: "Stone",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 90,
    density: 8.4,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41568,
    lat: 37.50369,
    lng: -82.05896,
    city: "Stopover",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1164,
    density: 18.1,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41571,
    lat: 37.62651,
    lng: -82.44437,
    city: "Varney",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 481,
    density: 8.8,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41572,
    lat: 37.31342,
    lng: -82.64368,
    city: "Virgie",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3368,
    density: 28.6,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21195: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 21195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41601,
    lat: 37.60969,
    lng: -82.72037,
    city: "Allen",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 421,
    density: 27.9,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 21071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41602,
    lat: 37.7387,
    lng: -82.75249,
    city: "Auxier",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 983,
    density: 139.1,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 21071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41603,
    lat: 37.55934,
    lng: -82.68704,
    city: "Banner",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1584,
    density: 43.6,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 21071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41604,
    lat: 37.38986,
    lng: -82.66782,
    city: "Beaver",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 477,
    density: 24.4,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 21071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41605,
    lat: 37.55498,
    lng: -82.63009,
    city: "Betsy Layne",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 615,
    density: 72.9,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 72.77,
      21195: 27.23,
    },
    county_names_all: "Floyd|Pike",
    county_fips_all: "21071|21195",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41606,
    lat: 37.34594,
    lng: -82.7375,
    city: "Bevinsville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 872,
    density: 34.4,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 21071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41607,
    lat: 37.62216,
    lng: -82.8438,
    city: "Blue River",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 412,
    density: 28.1,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 21071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41612,
    lat: 37.35451,
    lng: -82.72233,
    city: "Bypro",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 81,
    density: 80.9,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 21071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41615,
    lat: 37.54211,
    lng: -82.68337,
    city: "Dana",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 438,
    density: 30.7,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 21071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41616,
    lat: 37.58522,
    lng: -82.87847,
    city: "David",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 799,
    density: 26.4,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 21071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41619,
    lat: 37.48328,
    lng: -82.74187,
    city: "Drift",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 194,
    density: 10.9,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 21071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41621,
    lat: 37.6269,
    lng: -82.72663,
    city: "Dwale",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 192,
    density: 93.6,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 21071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41622,
    lat: 37.51377,
    lng: -82.80925,
    city: "Eastern",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 83,
    density: 8,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 21071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41630,
    lat: 37.46416,
    lng: -82.84992,
    city: "Garrett",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1148,
    density: 28.6,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 54.14,
      21119: 45.86,
    },
    county_names_all: "Floyd|Knott",
    county_fips_all: "21071|21119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41631,
    lat: 37.46801,
    lng: -82.65365,
    city: "Grethel",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1311,
    density: 53.9,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 21071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41632,
    lat: 37.55029,
    lng: -82.94982,
    city: "Gunlock",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 457,
    density: 5.4,
    county_fips: 21153,
    county_name: "Magoffin",
    county_weights: {
      21153: 100,
    },
    county_names_all: "Magoffin",
    county_fips_all: 21153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41635,
    lat: 37.48009,
    lng: -82.62831,
    city: "Harold",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2612,
    density: 46.4,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 21071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41636,
    lat: 37.39772,
    lng: -82.73087,
    city: "Hi Hat",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 858,
    density: 39.1,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 21071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41640,
    lat: 37.47649,
    lng: -82.92643,
    city: "Hueysville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1222,
    density: 12.4,
    county_fips: 21119,
    county_name: "Knott",
    county_weights: {
      21071: 35.35,
      21119: 56.11,
      21153: 8.54,
    },
    county_names_all: "Knott|Floyd|Magoffin",
    county_fips_all: "21119|21071|21153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41642,
    lat: 37.59569,
    lng: -82.64457,
    city: "Ivel",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 740,
    density: 33.1,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 21071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41643,
    lat: 37.43778,
    lng: -82.84307,
    city: "Lackey",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 111,
    density: 10.4,
    county_fips: 21119,
    county_name: "Knott",
    county_weights: {
      21119: 100,
    },
    county_names_all: "Knott",
    county_fips_all: 21119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41645,
    lat: 37.52872,
    lng: -82.79294,
    city: "Langley",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 768,
    density: 25.8,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 21071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41647,
    lat: 37.43056,
    lng: -82.71737,
    city: "McDowell",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1866,
    density: 38.6,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 21071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41649,
    lat: 37.57139,
    lng: -82.78337,
    city: "Martin",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2187,
    density: 35.2,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 21071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41650,
    lat: 37.34722,
    lng: -82.68166,
    city: "Melvin",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 480,
    density: 33.7,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 21071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41651,
    lat: 37.46716,
    lng: -82.75527,
    city: "Minnie",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 21071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41653,
    lat: 37.6603,
    lng: -82.76466,
    city: "Prestonsburg",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10425,
    density: 32.1,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 21071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41655,
    lat: 37.50496,
    lng: -82.72465,
    city: "Printer",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1266,
    density: 33.9,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 21071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41659,
    lat: 37.58415,
    lng: -82.60064,
    city: "Stanville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 452,
    density: 16.5,
    county_fips: 21195,
    county_name: "Pike",
    county_weights: {
      21071: 25.71,
      21195: 74.29,
    },
    county_names_all: "Pike|Floyd",
    county_fips_all: "21195|21071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41660,
    lat: 37.41341,
    lng: -82.63846,
    city: "Teaberry",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 502,
    density: 28.3,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 21071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41663,
    lat: 37.56844,
    lng: -82.65966,
    city: "Tram",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 384,
    density: 99.6,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 21071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41666,
    lat: 37.4396,
    lng: -82.80621,
    city: "Wayland",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 738,
    density: 30.2,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 21071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41667,
    lat: 37.31138,
    lng: -82.69881,
    city: "Weeksbury",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 468,
    density: 30.8,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 21071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41669,
    lat: 37.33375,
    lng: -82.71469,
    city: "Wheelwright",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 905,
    density: 126.7,
    county_fips: 21071,
    county_name: "Floyd",
    county_weights: {
      21071: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 21071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41701,
    lat: 37.29778,
    lng: -83.18781,
    city: "Hazard",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16108,
    density: 44.3,
    county_fips: 21193,
    county_name: "Perry",
    county_weights: {
      21119: 21.45,
      21193: 78.55,
    },
    county_names_all: "Perry|Knott",
    county_fips_all: "21193|21119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41712,
    lat: 37.3744,
    lng: -83.13751,
    city: "Ary",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 344,
    density: 47,
    county_fips: 21193,
    county_name: "Perry",
    county_weights: {
      21193: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 21193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41713,
    lat: 37.22703,
    lng: -83.27799,
    city: "Avawam",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 21193,
    county_name: "Perry",
    county_weights: {
      21193: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 21193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41714,
    lat: 37.16519,
    lng: -83.5075,
    city: "Bear Branch",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 487,
    density: 15.6,
    county_fips: 21131,
    county_name: "Leslie",
    county_weights: {
      21131: 100,
    },
    county_names_all: "Leslie",
    county_fips_all: 21131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41719,
    lat: 37.29727,
    lng: -83.24526,
    city: "Bonnyman",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1073,
    density: 42.1,
    county_fips: 21193,
    county_name: "Perry",
    county_weights: {
      21193: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 21193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41721,
    lat: 37.31371,
    lng: -83.49949,
    city: "Buckhorn",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 500,
    density: 4.5,
    county_fips: 21193,
    county_name: "Perry",
    county_weights: {
      21025: 11.04,
      21189: 11.39,
      21193: 77.56,
    },
    county_names_all: "Perry|Owsley|Breathitt",
    county_fips_all: "21193|21189|21025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41722,
    lat: 37.40441,
    lng: -83.10329,
    city: "Bulan",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 970,
    density: 9.7,
    county_fips: 21119,
    county_name: "Knott",
    county_weights: {
      21119: 79.14,
      21193: 20.86,
    },
    county_names_all: "Knott|Perry",
    county_fips_all: "21119|21193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41723,
    lat: 37.25469,
    lng: -83.31409,
    city: "Busy",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1182,
    density: 26.1,
    county_fips: 21193,
    county_name: "Perry",
    county_weights: {
      21131: 22.58,
      21193: 77.42,
    },
    county_names_all: "Perry|Leslie",
    county_fips_all: "21193|21131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41725,
    lat: 37.31667,
    lng: -83.03244,
    city: "Carrie",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29,
    density: 2.2,
    county_fips: 21119,
    county_name: "Knott",
    county_weights: {
      21119: 100,
    },
    county_names_all: "Knott",
    county_fips_all: 21119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41727,
    lat: 37.35624,
    lng: -83.32352,
    city: "Chavies",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 989,
    density: 28.2,
    county_fips: 21193,
    county_name: "Perry",
    county_weights: {
      21193: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 21193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41729,
    lat: 37.2681,
    lng: -83.2159,
    city: "Combs",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 21193,
    county_name: "Perry",
    county_weights: {
      21193: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 21193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41731,
    lat: 37.10312,
    lng: -83.08393,
    city: "Cornettsville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 862,
    density: 9.1,
    county_fips: 21193,
    county_name: "Perry",
    county_weights: {
      21133: 23.72,
      21193: 76.28,
    },
    county_names_all: "Perry|Letcher",
    county_fips_all: "21193|21133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41735,
    lat: 37.01793,
    lng: -83.09963,
    city: "Delphia",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 111,
    density: 4.6,
    county_fips: 21193,
    county_name: "Perry",
    county_weights: {
      21193: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 21193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41739,
    lat: 37.32596,
    lng: -83.12802,
    city: "Dwarf",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 249,
    density: 34.3,
    county_fips: 21193,
    county_name: "Perry",
    county_weights: {
      21193: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 21193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41740,
    lat: 37.35649,
    lng: -83.0467,
    city: "Emmalena",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1152,
    density: 25.7,
    county_fips: 21119,
    county_name: "Knott",
    county_weights: {
      21119: 100,
    },
    county_names_all: "Knott",
    county_fips_all: 21119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41745,
    lat: 37.34449,
    lng: -83.42848,
    city: "Gays Creek",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 538,
    density: 33.4,
    county_fips: 21193,
    county_name: "Perry",
    county_weights: {
      21025: 15.68,
      21193: 84.32,
    },
    county_names_all: "Perry|Breathitt",
    county_fips_all: "21193|21025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41746,
    lat: 37.21574,
    lng: -83.09779,
    city: "Happy",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 811,
    density: 69.2,
    county_fips: 21193,
    county_name: "Perry",
    county_weights: {
      21193: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 21193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41749,
    lat: 37.19364,
    lng: -83.4199,
    city: "Hyden",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3136,
    density: 11.6,
    county_fips: 21131,
    county_name: "Leslie",
    county_weights: {
      21131: 100,
    },
    county_names_all: "Leslie",
    county_fips_all: 21131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41751,
    lat: 37.2196,
    lng: -83.12659,
    city: "Jeff",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 208,
    density: 22.4,
    county_fips: 21193,
    county_name: "Perry",
    county_weights: {
      21119: 0.15,
      21193: 99.85,
    },
    county_names_all: "Perry|Knott",
    county_fips_all: "21193|21119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41754,
    lat: 37.30025,
    lng: -83.32459,
    city: "Krypton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 496,
    density: 17.6,
    county_fips: 21193,
    county_name: "Perry",
    county_weights: {
      21131: 18.57,
      21193: 81.43,
    },
    county_names_all: "Perry|Leslie",
    county_fips_all: "21193|21131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41759,
    lat: 37.23211,
    lng: -83.02521,
    city: "Sassafras",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 261,
    density: 9.6,
    county_fips: 21119,
    county_name: "Knott",
    county_weights: {
      21119: 99.72,
      21193: 0.28,
    },
    county_names_all: "Knott|Perry",
    county_fips_all: "21119|21193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41760,
    lat: 37.19456,
    lng: -83.08588,
    city: "Scuddy",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 21193,
    county_name: "Perry",
    county_weights: {
      21193: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 21193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41762,
    lat: 37.20742,
    lng: -83.50077,
    city: "Sizerock",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 21131,
    county_name: "Leslie",
    county_weights: {
      21131: 100,
    },
    county_names_all: "Leslie",
    county_fips_all: 21131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41763,
    lat: 37.05439,
    lng: -83.12157,
    city: "Slemp",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 702,
    density: 15.7,
    county_fips: 21193,
    county_name: "Perry",
    county_weights: {
      21193: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 21193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41764,
    lat: 37.12924,
    lng: -83.25545,
    city: "Smilax",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 715,
    density: 15.7,
    county_fips: 21131,
    county_name: "Leslie",
    county_weights: {
      21131: 100,
    },
    county_names_all: "Leslie",
    county_fips_all: 21131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41766,
    lat: 37.18526,
    lng: -83.44443,
    city: "Thousandsticks",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 205,
    density: 17.7,
    county_fips: 21131,
    county_name: "Leslie",
    county_weights: {
      21131: 100,
    },
    county_names_all: "Leslie",
    county_fips_all: 21131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41772,
    lat: 37.4075,
    lng: -83.01679,
    city: "Vest",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 324,
    density: 7.8,
    county_fips: 21119,
    county_name: "Knott",
    county_weights: {
      21119: 100,
    },
    county_names_all: "Knott",
    county_fips_all: 21119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41773,
    lat: 37.23534,
    lng: -83.01721,
    city: "Vicco",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1211,
    density: 22.2,
    county_fips: 21119,
    county_name: "Knott",
    county_weights: {
      21119: 50.91,
      21193: 49.09,
    },
    county_names_all: "Knott|Perry",
    county_fips_all: "21119|21193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41774,
    lat: 37.15512,
    lng: -83.13847,
    city: "Viper",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2486,
    density: 21.4,
    county_fips: 21193,
    county_name: "Perry",
    county_weights: {
      21193: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 21193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41775,
    lat: 37.09373,
    lng: -83.34207,
    city: "Wendover",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59,
    density: 2.5,
    county_fips: 21131,
    county_name: "Leslie",
    county_weights: {
      21131: 100,
    },
    county_names_all: "Leslie",
    county_fips_all: 21131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41776,
    lat: 37.15933,
    lng: -83.28158,
    city: "Wooton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1369,
    density: 16.3,
    county_fips: 21131,
    county_name: "Leslie",
    county_weights: {
      21131: 100,
    },
    county_names_all: "Leslie",
    county_fips_all: 21131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41777,
    lat: 37.06022,
    lng: -83.23276,
    city: "Yeaddiss",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1057,
    density: 11.4,
    county_fips: 21131,
    county_name: "Leslie",
    county_weights: {
      21131: 100,
    },
    county_names_all: "Leslie",
    county_fips_all: 21131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41778,
    lat: 37.26612,
    lng: -83.3223,
    city: "Yerkes",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 21193,
    county_name: "Perry",
    county_weights: {
      21193: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 21193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41804,
    lat: 37.14923,
    lng: -82.98993,
    city: "Blackey",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 943,
    density: 30.8,
    county_fips: 21133,
    county_name: "Letcher",
    county_weights: {
      21133: 100,
    },
    county_names_all: "Letcher",
    county_fips_all: 21133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41810,
    lat: 37.18492,
    lng: -82.67278,
    city: "Cromona",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 365,
    density: 55.3,
    county_fips: 21133,
    county_name: "Letcher",
    county_weights: {
      21133: 100,
    },
    county_names_all: "Letcher",
    county_fips_all: 21133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41812,
    lat: 37.2473,
    lng: -82.74445,
    city: "Deane",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 245,
    density: 15.6,
    county_fips: 21133,
    county_name: "Letcher",
    county_weights: {
      21133: 100,
    },
    county_names_all: "Letcher",
    county_fips_all: 21133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41815,
    lat: 37.15821,
    lng: -82.79799,
    city: "Ermine",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 714,
    density: 38.4,
    county_fips: 21133,
    county_name: "Letcher",
    county_weights: {
      21133: 100,
    },
    county_names_all: "Letcher",
    county_fips_all: 21133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41817,
    lat: 37.35922,
    lng: -82.90038,
    city: "Garner",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 208,
    density: 6,
    county_fips: 21119,
    county_name: "Knott",
    county_weights: {
      21119: 100,
    },
    county_names_all: "Knott",
    county_fips_all: 21119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41819,
    lat: 36.99191,
    lng: -83.07788,
    city: "Gordon",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 227,
    density: 4.7,
    county_fips: 21133,
    county_name: "Letcher",
    county_weights: {
      21133: 100,
    },
    county_names_all: "Letcher",
    county_fips_all: 21133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41821,
    lat: 37.07563,
    lng: -83.00711,
    city: "Hallie",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 198,
    density: 3.1,
    county_fips: 21133,
    county_name: "Letcher",
    county_weights: {
      21133: 100,
    },
    county_names_all: "Letcher",
    county_fips_all: 21133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41822,
    lat: 37.31991,
    lng: -82.97848,
    city: "Hindman",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2574,
    density: 52,
    county_fips: 21119,
    county_name: "Knott",
    county_weights: {
      21119: 100,
    },
    county_names_all: "Knott",
    county_fips_all: 21119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41824,
    lat: 37.18771,
    lng: -82.88015,
    city: "Isom",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1365,
    density: 104.5,
    county_fips: 21133,
    county_name: "Letcher",
    county_weights: {
      21133: 100,
    },
    county_names_all: "Letcher",
    county_fips_all: 21133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41825,
    lat: 37.23323,
    lng: -82.70854,
    city: "Jackhorn",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 403,
    density: 30,
    county_fips: 21133,
    county_name: "Letcher",
    county_weights: {
      21133: 100,
    },
    county_names_all: "Letcher",
    county_fips_all: 21133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41826,
    lat: 37.17348,
    lng: -82.92115,
    city: "Jeremiah",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 543,
    density: 23.6,
    county_fips: 21133,
    county_name: "Letcher",
    county_weights: {
      21133: 100,
    },
    county_names_all: "Letcher",
    county_fips_all: 21133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41828,
    lat: 37.2971,
    lng: -82.78444,
    city: "Kite",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 837,
    density: 15.4,
    county_fips: 21119,
    county_name: "Knott",
    county_weights: {
      21119: 100,
    },
    county_names_all: "Knott",
    county_fips_all: 21119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41831,
    lat: 37.38531,
    lng: -82.94633,
    city: "Leburn",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 728,
    density: 14.9,
    county_fips: 21119,
    county_name: "Knott",
    county_weights: {
      21119: 100,
    },
    county_names_all: "Knott",
    county_fips_all: 21119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41832,
    lat: 37.15286,
    lng: -82.9548,
    city: "Letcher",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 368,
    density: 19.1,
    county_fips: 21133,
    county_name: "Letcher",
    county_weights: {
      21133: 100,
    },
    county_names_all: "Letcher",
    county_fips_all: 21133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41833,
    lat: 37.02919,
    lng: -82.97323,
    city: "Linefork",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 442,
    density: 8.4,
    county_fips: 21133,
    county_name: "Letcher",
    county_weights: {
      21133: 100,
    },
    county_names_all: "Letcher",
    county_fips_all: 21133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41834,
    lat: 37.26585,
    lng: -82.94661,
    city: "Littcarr",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 220,
    density: 14.8,
    county_fips: 21119,
    county_name: "Knott",
    county_weights: {
      21119: 100,
    },
    county_names_all: "Knott",
    county_fips_all: 21119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41835,
    lat: 37.21196,
    lng: -82.67114,
    city: "McRoberts",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 792,
    density: 48.2,
    county_fips: 21133,
    county_name: "Letcher",
    county_weights: {
      21133: 100,
    },
    county_names_all: "Letcher",
    county_fips_all: 21133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41836,
    lat: 37.25839,
    lng: -82.90887,
    city: "Mallie",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 793,
    density: 18.5,
    county_fips: 21119,
    county_name: "Knott",
    county_weights: {
      21119: 100,
    },
    county_names_all: "Knott",
    county_fips_all: 21119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41837,
    lat: 37.1215,
    lng: -82.75231,
    city: "Mayking",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1216,
    density: 51.6,
    county_fips: 21133,
    county_name: "Letcher",
    county_weights: {
      21133: 100,
    },
    county_names_all: "Letcher",
    county_fips_all: 21133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41838,
    lat: 37.19677,
    lng: -82.75144,
    city: "Millstone",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 811,
    density: 36.5,
    county_fips: 21133,
    county_name: "Letcher",
    county_weights: {
      21133: 100,
    },
    county_names_all: "Letcher",
    county_fips_all: 21133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41839,
    lat: 37.42041,
    lng: -82.87741,
    city: "Mousie",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1272,
    density: 37.9,
    county_fips: 21119,
    county_name: "Knott",
    county_weights: {
      21119: 100,
    },
    county_names_all: "Knott",
    county_fips_all: 21119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41840,
    lat: 37.19962,
    lng: -82.71813,
    city: "Neon",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 788,
    density: 61.3,
    county_fips: 21133,
    county_name: "Letcher",
    county_weights: {
      21133: 100,
    },
    county_names_all: "Letcher",
    county_fips_all: 21133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41843,
    lat: 37.27495,
    lng: -82.85938,
    city: "Pine Top",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 411,
    density: 13.3,
    county_fips: 21119,
    county_name: "Knott",
    county_weights: {
      21119: 100,
    },
    county_names_all: "Knott",
    county_fips_all: 21119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41844,
    lat: 37.32916,
    lng: -82.8643,
    city: "Pippa Passes",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1513,
    density: 38.9,
    county_fips: 21119,
    county_name: "Knott",
    county_weights: {
      21119: 100,
    },
    county_names_all: "Knott",
    county_fips_all: 21119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41845,
    lat: 37.1396,
    lng: -82.90301,
    city: "Premium",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 307,
    density: 16.6,
    county_fips: 21133,
    county_name: "Letcher",
    county_weights: {
      21133: 100,
    },
    county_names_all: "Letcher",
    county_fips_all: 21133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41847,
    lat: 37.20823,
    lng: -82.95961,
    city: "Redfox",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 374,
    density: 12.1,
    county_fips: 21119,
    county_name: "Knott",
    county_weights: {
      21119: 99.89,
      21133: 0.11,
    },
    county_names_all: "Knott|Letcher",
    county_fips_all: "21119|21133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41848,
    lat: 37.11491,
    lng: -82.94384,
    city: "Roxana",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 21133,
    county_name: "Letcher",
    county_weights: {
      21133: 100,
    },
    county_names_all: "Letcher",
    county_fips_all: 21133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41849,
    lat: 37.1744,
    lng: -82.73251,
    city: "Seco",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 125,
    density: 49.9,
    county_fips: 21133,
    county_name: "Letcher",
    county_weights: {
      21133: 100,
    },
    county_names_all: "Letcher",
    county_fips_all: 21133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41855,
    lat: 37.18874,
    lng: -82.78496,
    city: "Thornton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 841,
    density: 43.6,
    county_fips: 21133,
    county_name: "Letcher",
    county_weights: {
      21133: 100,
    },
    county_names_all: "Letcher",
    county_fips_all: 21133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41858,
    lat: 37.1454,
    lng: -82.84697,
    city: "Whitesburg",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7270,
    density: 32.2,
    county_fips: 21133,
    county_name: "Letcher",
    county_weights: {
      21133: 100,
    },
    county_names_all: "Letcher",
    county_fips_all: 21133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41859,
    lat: 37.39922,
    lng: -82.77606,
    city: "Dema",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 302,
    density: 16.4,
    county_fips: 21119,
    county_name: "Knott",
    county_weights: {
      21071: 0.2,
      21119: 99.8,
    },
    county_names_all: "Knott|Floyd",
    county_fips_all: "21119|21071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41861,
    lat: 37.39002,
    lng: -82.8264,
    city: "Raven",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 187,
    density: 7.3,
    county_fips: 21119,
    county_name: "Knott",
    county_weights: {
      21119: 100,
    },
    county_names_all: "Knott",
    county_fips_all: 21119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 41862,
    lat: 37.34971,
    lng: -82.78929,
    city: "Topmost",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 900,
    density: 25.4,
    county_fips: 21119,
    county_name: "Knott",
    county_weights: {
      21119: 100,
    },
    county_names_all: "Knott",
    county_fips_all: 21119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42001,
    lat: 37.03317,
    lng: -88.7135,
    city: "Paducah",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29952,
    density: 155.8,
    county_fips: 21145,
    county_name: "McCracken",
    county_weights: {
      21145: 100,
    },
    county_names_all: "McCracken",
    county_fips_all: 21145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42003,
    lat: 37.00653,
    lng: -88.58472,
    city: "Paducah",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28141,
    density: 157.4,
    county_fips: 21145,
    county_name: "McCracken",
    county_weights: {
      21083: 0.82,
      21145: 99.18,
    },
    county_names_all: "McCracken|Graves",
    county_fips_all: "21145|21083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42020,
    lat: 36.68913,
    lng: -88.29145,
    city: "Almo",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1669,
    density: 26.6,
    county_fips: 21035,
    county_name: "Calloway",
    county_weights: {
      21035: 100,
    },
    county_names_all: "Calloway",
    county_fips_all: 21035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42021,
    lat: 36.80129,
    lng: -88.9957,
    city: "Arlington",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1495,
    density: 10.2,
    county_fips: 21039,
    county_name: "Carlisle",
    county_weights: {
      21039: 90.26,
      21105: 9.74,
    },
    county_names_all: "Carlisle|Hickman",
    county_fips_all: "21039|21105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42022,
    lat: 37.14593,
    lng: -88.94553,
    city: "Bandana",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 131,
    density: 102.9,
    county_fips: 21007,
    county_name: "Ballard",
    county_weights: {
      21007: 100,
    },
    county_names_all: "Ballard",
    county_fips_all: 21007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42023,
    lat: 36.87623,
    lng: -88.98742,
    city: "Bardwell",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2267,
    density: 9.2,
    county_fips: 21039,
    county_name: "Carlisle",
    county_weights: {
      21039: 100,
    },
    county_names_all: "Carlisle",
    county_fips_all: 21039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42024,
    lat: 37.0742,
    lng: -89.05026,
    city: "Barlow",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1059,
    density: 8.8,
    county_fips: 21007,
    county_name: "Ballard",
    county_weights: {
      21007: 100,
    },
    county_names_all: "Ballard",
    county_fips_all: 21007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42025,
    lat: 36.85764,
    lng: -88.33441,
    city: "Benton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19685,
    density: 38.1,
    county_fips: 21157,
    county_name: "Marshall",
    county_weights: {
      21035: 1.42,
      21083: 2.15,
      21157: 96.43,
    },
    county_names_all: "Marshall|Graves|Calloway",
    county_fips_all: "21157|21083|21035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42027,
    lat: 36.91585,
    lng: -88.63018,
    city: "Boaz",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1477,
    density: 12.4,
    county_fips: 21083,
    county_name: "Graves",
    county_weights: {
      21083: 85.69,
      21145: 14.31,
    },
    county_names_all: "Graves|McCracken",
    county_fips_all: "21083|21145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42028,
    lat: 37.23637,
    lng: -88.33946,
    city: "Burna",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 598,
    density: 9,
    county_fips: 21139,
    county_name: "Livingston",
    county_weights: {
      21139: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 21139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42029,
    lat: 37.00963,
    lng: -88.38947,
    city: "Calvert City",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6228,
    density: 52.2,
    county_fips: 21157,
    county_name: "Marshall",
    county_weights: {
      21157: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 21157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42031,
    lat: 36.68741,
    lng: -88.98864,
    city: "Clinton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3330,
    density: 8.7,
    county_fips: 21105,
    county_name: "Hickman",
    county_weights: {
      21105: 100,
    },
    county_names_all: "Hickman",
    county_fips_all: 21105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42032,
    lat: 36.751,
    lng: -89.10378,
    city: "Columbus",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 237,
    density: 13.2,
    county_fips: 21105,
    county_name: "Hickman",
    county_weights: {
      21105: 100,
    },
    county_names_all: "Hickman",
    county_fips_all: 21105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42035,
    lat: 36.90392,
    lng: -88.83674,
    city: "Cunningham",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 992,
    density: 14.3,
    county_fips: 21039,
    county_name: "Carlisle",
    county_weights: {
      21039: 77.72,
      21083: 22.28,
    },
    county_names_all: "Carlisle|Graves",
    county_fips_all: "21039|21083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42036,
    lat: 36.72246,
    lng: -88.23048,
    city: "Dexter",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1068,
    density: 14.9,
    county_fips: 21035,
    county_name: "Calloway",
    county_weights: {
      21035: 98.6,
      21157: 1.4,
    },
    county_names_all: "Calloway|Marshall",
    county_fips_all: "21035|21157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42037,
    lat: 37.15843,
    lng: -88.18441,
    city: "Dycusburg",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61,
    density: 422.7,
    county_fips: 21055,
    county_name: "Crittenden",
    county_weights: {
      21055: 100,
    },
    county_names_all: "Crittenden",
    county_fips_all: 21055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42038,
    lat: 37.04137,
    lng: -88.02364,
    city: "Eddyville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5433,
    density: 24.2,
    county_fips: 21143,
    county_name: "Lyon",
    county_weights: {
      21033: 1.35,
      21143: 98.65,
    },
    county_names_all: "Lyon|Caldwell",
    county_fips_all: "21143|21033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42039,
    lat: 36.78535,
    lng: -88.82809,
    city: "Fancy Farm",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1691,
    density: 13.4,
    county_fips: 21083,
    county_name: "Graves",
    county_weights: {
      21039: 32.62,
      21083: 33.86,
      21105: 33.52,
    },
    county_names_all: "Graves|Hickman|Carlisle",
    county_fips_all: "21083|21105|21039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42040,
    lat: 36.62454,
    lng: -88.50371,
    city: "Farmington",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 830,
    density: 10.1,
    county_fips: 21083,
    county_name: "Graves",
    county_weights: {
      21035: 20.45,
      21083: 79.55,
    },
    county_names_all: "Graves|Calloway",
    county_fips_all: "21083|21035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42041,
    lat: 36.54593,
    lng: -88.87456,
    city: "Fulton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4284,
    density: 15.4,
    county_fips: 21075,
    county_name: "Fulton",
    county_weights: {
      21075: 49.44,
      21083: 27.82,
      21105: 22.75,
    },
    county_names_all: "Fulton|Graves|Hickman",
    county_fips_all: "21075|21083|21105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42044,
    lat: 36.95744,
    lng: -88.26417,
    city: "Gilbertsville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3744,
    density: 61.2,
    county_fips: 21157,
    county_name: "Marshall",
    county_weights: {
      21157: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 21157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42045,
    lat: 37.072,
    lng: -88.26453,
    city: "Grand Rivers",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2156,
    density: 20.4,
    county_fips: 21139,
    county_name: "Livingston",
    county_weights: {
      21139: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 21139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42047,
    lat: 37.30061,
    lng: -88.39046,
    city: "Hampton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 281,
    density: 5.1,
    county_fips: 21139,
    county_name: "Livingston",
    county_weights: {
      21139: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 21139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42048,
    lat: 36.76676,
    lng: -88.23533,
    city: "Hardin",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1460,
    density: 21.1,
    county_fips: 21157,
    county_name: "Marshall",
    county_weights: {
      21035: 6.64,
      21157: 93.36,
    },
    county_names_all: "Marshall|Calloway",
    county_fips_all: "21157|21035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42049,
    lat: 36.51874,
    lng: -88.31828,
    city: "Hazel",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1499,
    density: 12.9,
    county_fips: 21035,
    county_name: "Calloway",
    county_weights: {
      21035: 99.15,
      21083: 0.85,
    },
    county_names_all: "Calloway|Graves",
    county_fips_all: "21035|21083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42050,
    lat: 36.54675,
    lng: -89.20347,
    city: "Hickman",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2928,
    density: 10.3,
    county_fips: 21075,
    county_name: "Fulton",
    county_weights: {
      21075: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 21075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42051,
    lat: 36.85629,
    lng: -88.64522,
    city: "Hickory",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3106,
    density: 22.7,
    county_fips: 21083,
    county_name: "Graves",
    county_weights: {
      21083: 100,
    },
    county_names_all: "Graves",
    county_fips_all: 21083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42053,
    lat: 37.1033,
    lng: -88.87606,
    city: "Kevil",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5193,
    density: 16.7,
    county_fips: 21007,
    county_name: "Ballard",
    county_weights: {
      21007: 50.84,
      21145: 49.16,
    },
    county_names_all: "Ballard|McCracken",
    county_fips_all: "21007|21145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42054,
    lat: 36.71734,
    lng: -88.43149,
    city: "Kirksey",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 876,
    density: 10.3,
    county_fips: 21035,
    county_name: "Calloway",
    county_weights: {
      21035: 85.99,
      21083: 4.27,
      21157: 9.74,
    },
    county_names_all: "Calloway|Marshall|Graves",
    county_fips_all: "21035|21157|21083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42055,
    lat: 37.06959,
    lng: -88.16765,
    city: "Kuttawa",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2470,
    density: 21.3,
    county_fips: 21143,
    county_name: "Lyon",
    county_weights: {
      21143: 100,
    },
    county_names_all: "Lyon",
    county_fips_all: 21143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42056,
    lat: 37.11088,
    lng: -88.98452,
    city: "La Center",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1384,
    density: 10,
    county_fips: 21007,
    county_name: "Ballard",
    county_weights: {
      21007: 100,
    },
    county_names_all: "Ballard",
    county_fips_all: 21007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42058,
    lat: 37.05329,
    lng: -88.4714,
    city: "Ledbetter",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2358,
    density: 57.2,
    county_fips: 21139,
    county_name: "Livingston",
    county_weights: {
      21139: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 21139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42060,
    lat: 36.96385,
    lng: -88.82778,
    city: "Lovelaceville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 21007,
    county_name: "Ballard",
    county_weights: {
      21007: 99.85,
      21039: 0.15,
    },
    county_names_all: "Ballard|Carlisle",
    county_fips_all: "21007|21039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42061,
    lat: 36.88262,
    lng: -88.76959,
    city: "Lowes",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 80,
    density: 88.2,
    county_fips: 21083,
    county_name: "Graves",
    county_weights: {
      21083: 100,
    },
    county_names_all: "Graves",
    county_fips_all: 21083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42064,
    lat: 37.35022,
    lng: -88.09158,
    city: "Marion",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8063,
    density: 10.6,
    county_fips: 21055,
    county_name: "Crittenden",
    county_weights: {
      21033: 4.45,
      21055: 95.55,
    },
    county_names_all: "Crittenden|Caldwell",
    county_fips_all: "21055|21033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42066,
    lat: 36.73328,
    lng: -88.6403,
    city: "Mayfield",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24032,
    density: 42.7,
    county_fips: 21083,
    county_name: "Graves",
    county_weights: {
      21035: 0.17,
      21083: 98.14,
      21157: 1.69,
    },
    county_names_all: "Graves|Marshall|Calloway",
    county_fips_all: "21083|21157|21035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42069,
    lat: 36.92328,
    lng: -88.75828,
    city: "Melber",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 507,
    density: 8,
    county_fips: 21083,
    county_name: "Graves",
    county_weights: {
      21083: 79.16,
      21145: 20.84,
    },
    county_names_all: "Graves|McCracken",
    county_fips_all: "21083|21145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42071,
    lat: 36.62139,
    lng: -88.28291,
    city: "Murray",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32349,
    density: 59.8,
    county_fips: 21035,
    county_name: "Calloway",
    county_weights: {
      21035: 99.47,
      21083: 0.53,
    },
    county_names_all: "Calloway|Graves",
    county_fips_all: "21035|21083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42076,
    lat: 36.55906,
    lng: -88.09473,
    city: "New Concord",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1124,
    density: 10.6,
    county_fips: 21035,
    county_name: "Calloway",
    county_weights: {
      21035: 100,
    },
    county_names_all: "Calloway",
    county_fips_all: 21035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42078,
    lat: 37.28876,
    lng: -88.27202,
    city: "Salem",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1730,
    density: 7.5,
    county_fips: 21139,
    county_name: "Livingston",
    county_weights: {
      21055: 24.26,
      21139: 75.74,
    },
    county_names_all: "Livingston|Crittenden",
    county_fips_all: "21139|21055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42079,
    lat: 36.55978,
    lng: -88.57611,
    city: "Sedalia",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1669,
    density: 11.8,
    county_fips: 21083,
    county_name: "Graves",
    county_weights: {
      21083: 100,
    },
    county_names_all: "Graves",
    county_fips_all: 21083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42081,
    lat: 37.22821,
    lng: -88.40274,
    city: "Smithland",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2013,
    density: 6.8,
    county_fips: 21139,
    county_name: "Livingston",
    county_weights: {
      21139: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 21139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42082,
    lat: 36.91618,
    lng: -88.50092,
    city: "Symsonia",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1579,
    density: 22.1,
    county_fips: 21083,
    county_name: "Graves",
    county_weights: {
      21083: 55.24,
      21145: 14.42,
      21157: 30.34,
    },
    county_names_all: "Graves|Marshall|McCracken",
    county_fips_all: "21083|21157|21145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42083,
    lat: 37.16381,
    lng: -88.27767,
    city: "Tiline",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 406,
    density: 6.2,
    county_fips: 21139,
    county_name: "Livingston",
    county_weights: {
      21139: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 21139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42085,
    lat: 36.56942,
    lng: -88.80044,
    city: "Water Valley",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 778,
    density: 10.5,
    county_fips: 21083,
    county_name: "Graves",
    county_weights: {
      21083: 56.63,
      21105: 43.37,
    },
    county_names_all: "Graves|Hickman",
    county_fips_all: "21083|21105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42086,
    lat: 37.0828,
    lng: -88.76838,
    city: "West Paducah",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4385,
    density: 54.2,
    county_fips: 21145,
    county_name: "McCracken",
    county_weights: {
      21145: 100,
    },
    county_names_all: "McCracken",
    county_fips_all: 21145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42087,
    lat: 36.97328,
    lng: -89.00323,
    city: "Wickliffe",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2636,
    density: 14.9,
    county_fips: 21007,
    county_name: "Ballard",
    county_weights: {
      21007: 100,
    },
    county_names_all: "Ballard",
    county_fips_all: 21007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42088,
    lat: 36.61808,
    lng: -88.75409,
    city: "Wingo",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2138,
    density: 12.2,
    county_fips: 21083,
    county_name: "Graves",
    county_weights: {
      21083: 80.5,
      21105: 19.5,
    },
    county_names_all: "Graves|Hickman",
    county_fips_all: "21083|21105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42101,
    lat: 37.06552,
    lng: -86.47809,
    city: "Bowling Green",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62715,
    density: 86.2,
    county_fips: 21227,
    county_name: "Warren",
    county_weights: {
      21031: 3.31,
      21061: 8.14,
      21227: 88.55,
    },
    county_names_all: "Warren|Edmonson|Butler",
    county_fips_all: "21227|21061|21031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42103,
    lat: 36.94802,
    lng: -86.33396,
    city: "Bowling Green",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20571,
    density: 112.8,
    county_fips: 21227,
    county_name: "Warren",
    county_weights: {
      21227: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 21227,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42104,
    lat: 36.87718,
    lng: -86.45233,
    city: "Bowling Green",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36969,
    density: 245.9,
    county_fips: 21227,
    county_name: "Warren",
    county_weights: {
      21213: 8.71,
      21227: 91.29,
    },
    county_names_all: "Warren|Simpson",
    county_fips_all: "21227|21213",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42120,
    lat: 36.67196,
    lng: -86.27465,
    city: "Adolphus",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3103,
    density: 27.7,
    county_fips: 21003,
    county_name: "Allen",
    county_weights: {
      21003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 21003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42122,
    lat: 36.85885,
    lng: -86.35718,
    city: "Alvaton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5635,
    density: 57.7,
    county_fips: 21227,
    county_name: "Warren",
    county_weights: {
      21003: 5.35,
      21227: 94.65,
    },
    county_names_all: "Warren|Allen",
    county_fips_all: "21227|21003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42123,
    lat: 36.82039,
    lng: -85.99573,
    city: "Austin",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1013,
    density: 17.8,
    county_fips: 21009,
    county_name: "Barren",
    county_weights: {
      21009: 100,
    },
    county_names_all: "Barren",
    county_fips_all: 21009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42124,
    lat: 36.86534,
    lng: -85.64817,
    city: "Beaumont",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32,
    density: 6.2,
    county_fips: 21169,
    county_name: "Metcalfe",
    county_weights: {
      21169: 100,
    },
    county_names_all: "Metcalfe",
    county_fips_all: 21169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42127,
    lat: 37.12167,
    lng: -85.92746,
    city: "Cave City",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6476,
    density: 27.9,
    county_fips: 21009,
    county_name: "Barren",
    county_weights: {
      21009: 85.18,
      21099: 14.82,
    },
    county_names_all: "Barren|Hart",
    county_fips_all: "21009|21099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42129,
    lat: 36.99,
    lng: -85.58992,
    city: "Edmonton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6553,
    density: 13.1,
    county_fips: 21169,
    county_name: "Metcalfe",
    county_weights: {
      21001: 4.9,
      21169: 95.1,
    },
    county_names_all: "Metcalfe|Adair",
    county_fips_all: "21169|21001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42130,
    lat: 36.9224,
    lng: -85.77816,
    city: "Eighty Eight",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 314,
    density: 39.3,
    county_fips: 21009,
    county_name: "Barren",
    county_weights: {
      21009: 100,
    },
    county_names_all: "Barren",
    county_fips_all: 21009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42131,
    lat: 36.82734,
    lng: -85.90915,
    city: "Etoile",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 21009,
    county_name: "Barren",
    county_weights: {
      21009: 100,
    },
    county_names_all: "Barren",
    county_fips_all: 21009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42133,
    lat: 36.72248,
    lng: -85.95468,
    city: "Fountain Run",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1217,
    density: 6.1,
    county_fips: 21171,
    county_name: "Monroe",
    county_weights: {
      21003: 24.45,
      21009: 32.32,
      21171: 43.23,
    },
    county_names_all: "Monroe|Barren|Allen",
    county_fips_all: "21171|21009|21003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42134,
    lat: 36.72626,
    lng: -86.56433,
    city: "Franklin",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17637,
    density: 32,
    county_fips: 21213,
    county_name: "Simpson",
    county_weights: {
      21003: 6.72,
      21213: 93.28,
    },
    county_names_all: "Simpson|Allen",
    county_fips_all: "21213|21003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42140,
    lat: 36.65549,
    lng: -85.83108,
    city: "Gamaliel",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1018,
    density: 10,
    county_fips: 21171,
    county_name: "Monroe",
    county_weights: {
      21171: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 21171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42141,
    lat: 36.94883,
    lng: -85.91489,
    city: "Glasgow",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31455,
    density: 45.2,
    county_fips: 21009,
    county_name: "Barren",
    county_weights: {
      21009: 100,
    },
    county_names_all: "Barren",
    county_fips_all: 21009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42151,
    lat: 36.64848,
    lng: -85.56058,
    city: "Hestand",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 94,
    density: 1.3,
    county_fips: 21171,
    county_name: "Monroe",
    county_weights: {
      21171: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 21171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42153,
    lat: 36.68006,
    lng: -86.04234,
    city: "Holland",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 501,
    density: 48.2,
    county_fips: 21003,
    county_name: "Allen",
    county_weights: {
      21003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 21003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42154,
    lat: 37.04876,
    lng: -85.72421,
    city: "Knob Lick",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 385,
    density: 6.1,
    county_fips: 21169,
    county_name: "Metcalfe",
    county_weights: {
      21009: 12.82,
      21169: 87.18,
    },
    county_names_all: "Metcalfe|Barren",
    county_fips_all: "21169|21009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42156,
    lat: 36.85947,
    lng: -86.04952,
    city: "Lucas",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 345,
    density: 17.5,
    county_fips: 21009,
    county_name: "Barren",
    county_weights: {
      21009: 100,
    },
    county_names_all: "Barren",
    county_fips_all: 21009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42157,
    lat: 36.78872,
    lng: -85.8187,
    city: "Mount Hermon",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 720,
    density: 15,
    county_fips: 21171,
    county_name: "Monroe",
    county_weights: {
      21171: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 21171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42159,
    lat: 36.99594,
    lng: -86.24771,
    city: "Oakland",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1485,
    density: 18.3,
    county_fips: 21227,
    county_name: "Warren",
    county_weights: {
      21227: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 21227,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42160,
    lat: 37.10339,
    lng: -86.08035,
    city: "Park City",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1840,
    density: 11,
    county_fips: 21061,
    county_name: "Edmonson",
    county_weights: {
      21009: 44.79,
      21061: 55.21,
    },
    county_names_all: "Edmonson|Barren",
    county_fips_all: "21061|21009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42163,
    lat: 37.07968,
    lng: -86.13466,
    city: "Rocky Hill",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35,
    density: 16.5,
    county_fips: 21061,
    county_name: "Edmonson",
    county_weights: {
      21061: 100,
    },
    county_names_all: "Edmonson",
    county_fips_all: 21061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42164,
    lat: 36.7704,
    lng: -86.18096,
    city: "Scottsville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16717,
    density: 24.6,
    county_fips: 21003,
    county_name: "Allen",
    county_weights: {
      21003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 21003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42166,
    lat: 36.87768,
    lng: -85.71503,
    city: "Summer Shade",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2512,
    density: 13.7,
    county_fips: 21169,
    county_name: "Metcalfe",
    county_weights: {
      21009: 24.41,
      21169: 61.13,
      21171: 14.46,
    },
    county_names_all: "Metcalfe|Barren|Monroe",
    county_fips_all: "21169|21009|21171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42167,
    lat: 36.72432,
    lng: -85.66998,
    city: "Tompkinsville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8040,
    density: 15.2,
    county_fips: 21171,
    county_name: "Monroe",
    county_weights: {
      21057: 1.27,
      21169: 0.96,
      21171: 97.77,
    },
    county_names_all: "Monroe|Cumberland|Metcalfe",
    county_fips_all: "21171|21057|21169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42170,
    lat: 36.84678,
    lng: -86.57459,
    city: "Woodburn",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1216,
    density: 15.3,
    county_fips: 21227,
    county_name: "Warren",
    county_weights: {
      21213: 49.13,
      21227: 50.87,
    },
    county_names_all: "Warren|Simpson",
    county_fips_all: "21227|21213",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42171,
    lat: 37.03609,
    lng: -86.16728,
    city: "Smiths Grove",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7266,
    density: 27.2,
    county_fips: 21227,
    county_name: "Warren",
    county_weights: {
      21009: 24.59,
      21061: 27.57,
      21227: 47.84,
    },
    county_names_all: "Warren|Edmonson|Barren",
    county_fips_all: "21227|21061|21009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42202,
    lat: 36.68732,
    lng: -86.85916,
    city: "Adairville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2101,
    density: 12.5,
    county_fips: 21141,
    county_name: "Logan",
    county_weights: {
      21141: 97.87,
      21213: 2.13,
    },
    county_names_all: "Logan|Simpson",
    county_fips_all: "21141|21213",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42204,
    lat: 36.69509,
    lng: -87.08096,
    city: "Allensville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 626,
    density: 5.7,
    county_fips: 21219,
    county_name: "Todd",
    county_weights: {
      21141: 28.83,
      21219: 71.17,
    },
    county_names_all: "Todd|Logan",
    county_fips_all: "21219|21141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42206,
    lat: 36.88221,
    lng: -86.72302,
    city: "Auburn",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6094,
    density: 20.7,
    county_fips: 21141,
    county_name: "Logan",
    county_weights: {
      21141: 86.31,
      21213: 12.58,
      21227: 1.11,
    },
    county_names_all: "Logan|Simpson|Warren",
    county_fips_all: "21141|21213|21227",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42207,
    lat: 37.30357,
    lng: -86.27858,
    city: "Bee Spring",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1159,
    density: 23.3,
    county_fips: 21061,
    county_name: "Edmonson",
    county_weights: {
      21061: 97.54,
      21085: 2.46,
    },
    county_names_all: "Edmonson|Grayson",
    county_fips_all: "21061|21085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42210,
    lat: 37.21724,
    lng: -86.31438,
    city: "Brownsville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4294,
    density: 19.8,
    county_fips: 21061,
    county_name: "Edmonson",
    county_weights: {
      21061: 100,
    },
    county_names_all: "Edmonson",
    county_fips_all: 21061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42211,
    lat: 36.82016,
    lng: -87.83709,
    city: "Cadiz",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13451,
    density: 18.3,
    county_fips: 21221,
    county_name: "Trigg",
    county_weights: {
      21033: 0.17,
      21221: 99.83,
    },
    county_names_all: "Trigg|Caldwell",
    county_fips_all: "21221|21033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42214,
    lat: 37.13428,
    lng: -85.68822,
    city: "Center",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 730,
    density: 13.3,
    county_fips: 21169,
    county_name: "Metcalfe",
    county_weights: {
      21087: 18.74,
      21169: 81.26,
    },
    county_names_all: "Metcalfe|Green",
    county_fips_all: "21169|21087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42215,
    lat: 36.99256,
    lng: -87.67018,
    city: "Cerulean",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1495,
    density: 10.2,
    county_fips: 21047,
    county_name: "Christian",
    county_weights: {
      21047: 73.28,
      21221: 26.72,
    },
    county_names_all: "Christian|Trigg",
    county_fips_all: "21047|21221",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42217,
    lat: 37.04915,
    lng: -87.47212,
    city: "Crofton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3099,
    density: 7.5,
    county_fips: 21047,
    county_name: "Christian",
    county_weights: {
      21047: 100,
    },
    county_names_all: "Christian",
    county_fips_all: 21047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42220,
    lat: 36.90129,
    lng: -87.18395,
    city: "Elkton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6467,
    density: 14.9,
    county_fips: 21219,
    county_name: "Todd",
    county_weights: {
      21047: 1.14,
      21177: 0.27,
      21219: 98.59,
    },
    county_names_all: "Todd|Christian|Muhlenberg",
    county_fips_all: "21219|21047|21177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42223,
    lat: 36.6381,
    lng: -87.47258,
    city: "Fort Campbell",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21228,
    density: 377.4,
    county_fips: 47125,
    county_name: "Montgomery",
    county_weights: {
      21047: 44.95,
      47125: 55.05,
    },
    county_names_all: "Montgomery|Christian",
    county_fips_all: "47125|21047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42232,
    lat: 36.86665,
    lng: -87.66167,
    city: "Gracey",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 786,
    density: 13.8,
    county_fips: 21047,
    county_name: "Christian",
    county_weights: {
      21047: 73.14,
      21221: 26.86,
    },
    county_names_all: "Christian|Trigg",
    county_fips_all: "21047|21221",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42234,
    lat: 36.70656,
    lng: -87.17598,
    city: "Guthrie",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2561,
    density: 20,
    county_fips: 21219,
    county_name: "Todd",
    county_weights: {
      21219: 100,
    },
    county_names_all: "Todd",
    county_fips_all: 21219,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42236,
    lat: 36.7196,
    lng: -87.61225,
    city: "Herndon",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 475,
    density: 2.9,
    county_fips: 21047,
    county_name: "Christian",
    county_weights: {
      21047: 92.65,
      21221: 7.35,
    },
    county_names_all: "Christian|Trigg",
    county_fips_all: "21047|21221",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42240,
    lat: 36.88388,
    lng: -87.46024,
    city: "Hopkinsville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41009,
    density: 57.1,
    county_fips: 21047,
    county_name: "Christian",
    county_weights: {
      21047: 100,
    },
    county_names_all: "Christian",
    county_fips_all: 21047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42252,
    lat: 37.23713,
    lng: -86.50029,
    city: "Jetson",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 21031,
    county_name: "Butler",
    county_weights: {
      21031: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 21031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42254,
    lat: 36.66435,
    lng: -87.63852,
    city: "La Fayette",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 168,
    density: 6.9,
    county_fips: 21047,
    county_name: "Christian",
    county_weights: {
      21047: 100,
    },
    county_names_all: "Christian",
    county_fips_all: 21047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42256,
    lat: 37.01666,
    lng: -86.94796,
    city: "Lewisburg",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4567,
    density: 8.9,
    county_fips: 21141,
    county_name: "Logan",
    county_weights: {
      21031: 24.08,
      21141: 61.46,
      21177: 2.38,
      21219: 12.08,
    },
    county_names_all: "Logan|Butler|Todd|Muhlenberg",
    county_fips_all: "21141|21031|21219|21177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42259,
    lat: 37.23524,
    lng: -86.17206,
    city: "Mammoth Cave",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1234,
    density: 6.5,
    county_fips: 21061,
    county_name: "Edmonson",
    county_weights: {
      21061: 100,
    },
    county_names_all: "Edmonson",
    county_fips_all: 21061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42261,
    lat: 37.22405,
    lng: -86.67015,
    city: "Morgantown",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10928,
    density: 14.7,
    county_fips: 21031,
    county_name: "Butler",
    county_weights: {
      21031: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 21031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42262,
    lat: 36.68386,
    lng: -87.44714,
    city: "Oak Grove",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8486,
    density: 105,
    county_fips: 21047,
    county_name: "Christian",
    county_weights: {
      21047: 100,
    },
    county_names_all: "Christian",
    county_fips_all: 21047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42265,
    lat: 36.739,
    lng: -87.00141,
    city: "Olmstead",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 830,
    density: 5.9,
    county_fips: 21141,
    county_name: "Logan",
    county_weights: {
      21141: 87.8,
      21219: 12.2,
    },
    county_names_all: "Logan|Todd",
    county_fips_all: "21141|21219",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42266,
    lat: 36.76562,
    lng: -87.3601,
    city: "Pembroke",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2176,
    density: 11.6,
    county_fips: 21047,
    county_name: "Christian",
    county_weights: {
      21047: 87.96,
      21219: 12.04,
    },
    county_names_all: "Christian|Todd",
    county_fips_all: "21047|21219",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42273,
    lat: 37.20128,
    lng: -86.85916,
    city: "Rochester",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 409,
    density: 9.6,
    county_fips: 21031,
    county_name: "Butler",
    county_weights: {
      21031: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 21031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42274,
    lat: 36.94915,
    lng: -86.60534,
    city: "Rockfield",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1905,
    density: 17.9,
    county_fips: 21227,
    county_name: "Warren",
    county_weights: {
      21141: 11.28,
      21227: 88.72,
    },
    county_names_all: "Warren|Logan",
    county_fips_all: "21227|21141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42275,
    lat: 37.22701,
    lng: -86.44628,
    city: "Roundhill",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 854,
    density: 7.1,
    county_fips: 21031,
    county_name: "Butler",
    county_weights: {
      21031: 72.88,
      21061: 27.12,
    },
    county_names_all: "Butler|Edmonson",
    county_fips_all: "21031|21061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42276,
    lat: 36.86093,
    lng: -86.87727,
    city: "Russellville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14643,
    density: 27.6,
    county_fips: 21141,
    county_name: "Logan",
    county_weights: {
      21031: 0.14,
      21141: 99.86,
    },
    county_names_all: "Logan|Butler",
    county_fips_all: "21141|21031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42280,
    lat: 36.95055,
    lng: -87.09927,
    city: "Sharon Grove",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 369,
    density: 5.9,
    county_fips: 21219,
    county_name: "Todd",
    county_weights: {
      21219: 100,
    },
    county_names_all: "Todd",
    county_fips_all: 21219,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42285,
    lat: 37.26418,
    lng: -86.29751,
    city: "Sweeden",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 481,
    density: 22.2,
    county_fips: 21061,
    county_name: "Edmonson",
    county_weights: {
      21061: 100,
    },
    county_names_all: "Edmonson",
    county_fips_all: 21061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42286,
    lat: 36.72749,
    lng: -87.26959,
    city: "Trenton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1692,
    density: 9.5,
    county_fips: 21219,
    county_name: "Todd",
    county_weights: {
      21047: 5.69,
      21219: 94.31,
    },
    county_names_all: "Todd|Christian",
    county_fips_all: "21219|21047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42301,
    lat: 37.73983,
    lng: -87.24643,
    city: "Owensboro",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44347,
    density: 99,
    county_fips: 21059,
    county_name: "Daviess",
    county_weights: {
      21059: 95.38,
      21101: 4.14,
      21149: 0.48,
    },
    county_names_all: "Daviess|Henderson|McLean",
    county_fips_all: "21059|21101|21149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42303,
    lat: 37.76138,
    lng: -87.04889,
    city: "Owensboro",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41790,
    density: 330.4,
    county_fips: 21059,
    county_name: "Daviess",
    county_weights: {
      21059: 100,
    },
    county_names_all: "Daviess",
    county_fips_all: 21059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42320,
    lat: 37.35093,
    lng: -86.87291,
    city: "Beaver Dam",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8744,
    density: 22.7,
    county_fips: 21183,
    county_name: "Ohio",
    county_weights: {
      21031: 7.64,
      21183: 92.36,
    },
    county_names_all: "Ohio|Butler",
    county_fips_all: "21183|21031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42321,
    lat: 37.17977,
    lng: -87.05195,
    city: "Beech Creek",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 118,
    density: 12.5,
    county_fips: 21177,
    county_name: "Muhlenberg",
    county_weights: {
      21177: 100,
    },
    county_names_all: "Muhlenberg",
    county_fips_all: 21177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42322,
    lat: 37.62083,
    lng: -87.38821,
    city: "Beech Grove",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 21149,
    county_name: "McLean",
    county_weights: {
      21149: 100,
    },
    county_names_all: "McLean",
    county_fips_all: 21149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42323,
    lat: 37.17406,
    lng: -87.03261,
    city: "Beechmont",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 685,
    density: 179.4,
    county_fips: 21177,
    county_name: "Muhlenberg",
    county_weights: {
      21177: 100,
    },
    county_names_all: "Muhlenberg",
    county_fips_all: 21177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42324,
    lat: 37.13863,
    lng: -87.00974,
    city: "Belton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1074,
    density: 13.2,
    county_fips: 21177,
    county_name: "Muhlenberg",
    county_weights: {
      21177: 100,
    },
    county_names_all: "Muhlenberg",
    county_fips_all: 21177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42325,
    lat: 37.32537,
    lng: -87.27375,
    city: "Bremen",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2132,
    density: 28.3,
    county_fips: 21177,
    county_name: "Muhlenberg",
    county_weights: {
      21177: 100,
    },
    county_names_all: "Muhlenberg",
    county_fips_all: 21177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42326,
    lat: 37.23666,
    lng: -87.00835,
    city: "Browder",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 406,
    density: 10,
    county_fips: 21177,
    county_name: "Muhlenberg",
    county_weights: {
      21177: 100,
    },
    county_names_all: "Muhlenberg",
    county_fips_all: 21177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42327,
    lat: 37.58721,
    lng: -87.30042,
    city: "Calhoun",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4394,
    density: 13.7,
    county_fips: 21149,
    county_name: "McLean",
    county_weights: {
      21059: 0.98,
      21149: 99.02,
    },
    county_names_all: "McLean|Daviess",
    county_fips_all: "21149|21059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42328,
    lat: 37.41898,
    lng: -87.0429,
    city: "Centertown",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1177,
    density: 7.1,
    county_fips: 21183,
    county_name: "Ohio",
    county_weights: {
      21183: 100,
    },
    county_names_all: "Ohio",
    county_fips_all: 21183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42330,
    lat: 37.31436,
    lng: -87.12245,
    city: "Central City",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9081,
    density: 33.7,
    county_fips: 21177,
    county_name: "Muhlenberg",
    county_weights: {
      21177: 100,
    },
    county_names_all: "Muhlenberg",
    county_fips_all: 21177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42332,
    lat: 37.25099,
    lng: -87.08935,
    city: "Cleaton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 128,
    density: 93.8,
    county_fips: 21177,
    county_name: "Muhlenberg",
    county_weights: {
      21177: 100,
    },
    county_names_all: "Muhlenberg",
    county_fips_all: 21177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42333,
    lat: 37.37718,
    lng: -86.75609,
    city: "Cromwell",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1211,
    density: 13,
    county_fips: 21183,
    county_name: "Ohio",
    county_weights: {
      21031: 5.32,
      21183: 94.68,
    },
    county_names_all: "Ohio|Butler",
    county_fips_all: "21183|21031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42337,
    lat: 37.22309,
    lng: -86.99964,
    city: "Drakesboro",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2019,
    density: 21,
    county_fips: 21177,
    county_name: "Muhlenberg",
    county_weights: {
      21177: 100,
    },
    county_names_all: "Muhlenberg",
    county_fips_all: 21177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42338,
    lat: 37.55295,
    lng: -86.77408,
    city: "Dundee",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26,
    density: 3.2,
    county_fips: 21183,
    county_name: "Ohio",
    county_weights: {
      21183: 100,
    },
    county_names_all: "Ohio",
    county_fips_all: 21183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42339,
    lat: 37.11326,
    lng: -86.95033,
    city: "Dunmor",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 818,
    density: 8.7,
    county_fips: 21177,
    county_name: "Muhlenberg",
    county_weights: {
      21031: 17.5,
      21177: 82.5,
    },
    county_names_all: "Muhlenberg|Butler",
    county_fips_all: "21177|21031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42343,
    lat: 37.63594,
    lng: -86.69795,
    city: "Fordsville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1686,
    density: 8.4,
    county_fips: 21183,
    county_name: "Ohio",
    county_weights: {
      21027: 2.99,
      21091: 20.75,
      21183: 76.26,
    },
    county_names_all: "Ohio|Hancock|Breckinridge",
    county_fips_all: "21183|21091|21027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42344,
    lat: 37.25681,
    lng: -87.32053,
    city: "Graham",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 743,
    density: 8.3,
    county_fips: 21177,
    county_name: "Muhlenberg",
    county_weights: {
      21177: 100,
    },
    county_names_all: "Muhlenberg",
    county_fips_all: 21177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42345,
    lat: 37.14839,
    lng: -87.18943,
    city: "Greenville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12019,
    density: 30.1,
    county_fips: 21177,
    county_name: "Muhlenberg",
    county_weights: {
      21177: 99.41,
      21219: 0.59,
    },
    county_names_all: "Muhlenberg|Todd",
    county_fips_all: "21177|21219",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42347,
    lat: 37.52414,
    lng: -86.88715,
    city: "Hartford",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6202,
    density: 19.7,
    county_fips: 21183,
    county_name: "Ohio",
    county_weights: {
      21183: 100,
    },
    county_names_all: "Ohio",
    county_fips_all: 21183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42348,
    lat: 37.83379,
    lng: -86.76578,
    city: "Hawesville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4737,
    density: 17.6,
    county_fips: 21091,
    county_name: "Hancock",
    county_weights: {
      21059: 11.64,
      21091: 88.36,
    },
    county_names_all: "Hancock|Daviess",
    county_fips_all: "21091|21059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42349,
    lat: 37.42695,
    lng: -86.67425,
    city: "Horse Branch",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1899,
    density: 13,
    county_fips: 21183,
    county_name: "Ohio",
    county_weights: {
      21085: 10.27,
      21183: 89.73,
    },
    county_names_all: "Ohio|Grayson",
    county_fips_all: "21183|21085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42350,
    lat: 37.44852,
    lng: -87.1831,
    city: "Island",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1626,
    density: 15.1,
    county_fips: 21149,
    county_name: "McLean",
    county_weights: {
      21149: 100,
    },
    county_names_all: "McLean",
    county_fips_all: 21149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42351,
    lat: 37.9026,
    lng: -86.87903,
    city: "Lewisport",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4443,
    density: 24.2,
    county_fips: 21091,
    county_name: "Hancock",
    county_weights: {
      21059: 23.77,
      21091: 76.23,
    },
    county_names_all: "Hancock|Daviess",
    county_fips_all: "21091|21059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42352,
    lat: 37.51333,
    lng: -87.0833,
    city: "Livermore",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1759,
    density: 29.6,
    county_fips: 21149,
    county_name: "McLean",
    county_weights: {
      21149: 59.18,
      21183: 40.82,
    },
    county_names_all: "McLean|Ohio",
    county_fips_all: "21149|21183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42354,
    lat: 37.37915,
    lng: -86.9273,
    city: "McHenry",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 171,
    density: 82.1,
    county_fips: 21183,
    county_name: "Ohio",
    county_weights: {
      21183: 100,
    },
    county_names_all: "Ohio",
    county_fips_all: 21183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42355,
    lat: 37.86206,
    lng: -86.9895,
    city: "Maceo",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1668,
    density: 23,
    county_fips: 21059,
    county_name: "Daviess",
    county_weights: {
      21059: 100,
    },
    county_names_all: "Daviess",
    county_fips_all: 21059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42356,
    lat: 37.69364,
    lng: -87.32289,
    city: "Maple Mount",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 94,
    density: 808.5,
    county_fips: 21059,
    county_name: "Daviess",
    county_weights: {
      21059: 100,
    },
    county_names_all: "Daviess",
    county_fips_all: 21059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42361,
    lat: 37.51791,
    lng: -86.69183,
    city: "Olaton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 413,
    density: 4.2,
    county_fips: 21183,
    county_name: "Ohio",
    county_weights: {
      21085: 30.72,
      21183: 69.28,
    },
    county_names_all: "Ohio|Grayson",
    county_fips_all: "21183|21085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42366,
    lat: 37.72404,
    lng: -86.93988,
    city: "Philpot",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5227,
    density: 23,
    county_fips: 21059,
    county_name: "Daviess",
    county_weights: {
      21059: 94.76,
      21091: 1.06,
      21183: 4.18,
    },
    county_names_all: "Daviess|Ohio|Hancock",
    county_fips_all: "21059|21183|21091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42367,
    lat: 37.2448,
    lng: -87.16133,
    city: "Powderly",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 694,
    density: 112.8,
    county_fips: 21177,
    county_name: "Muhlenberg",
    county_weights: {
      21177: 100,
    },
    county_names_all: "Muhlenberg",
    county_fips_all: 21177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42368,
    lat: 37.71258,
    lng: -86.75133,
    city: "Reynolds Station",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1220,
    density: 10.7,
    county_fips: 21091,
    county_name: "Hancock",
    county_weights: {
      21091: 55.67,
      21183: 44.33,
    },
    county_names_all: "Hancock|Ohio",
    county_fips_all: "21091|21183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42369,
    lat: 37.3517,
    lng: -87.00719,
    city: "Rockport",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 262,
    density: 33.4,
    county_fips: 21183,
    county_name: "Ohio",
    county_weights: {
      21177: 0.1,
      21183: 99.9,
    },
    county_names_all: "Ohio|Muhlenberg",
    county_fips_all: "21183|21177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42370,
    lat: 37.4497,
    lng: -86.74121,
    city: "Rosine",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3,
    density: 8.4,
    county_fips: 21183,
    county_name: "Ohio",
    county_weights: {
      21183: 100,
    },
    county_names_all: "Ohio",
    county_fips_all: 21183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42371,
    lat: 37.4978,
    lng: -87.29362,
    city: "Rumsey",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 304,
    density: 3.1,
    county_fips: 21149,
    county_name: "McLean",
    county_weights: {
      21149: 100,
    },
    county_names_all: "McLean",
    county_fips_all: 21149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42372,
    lat: 37.40588,
    lng: -87.2773,
    city: "Sacramento",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1324,
    density: 13.5,
    county_fips: 21149,
    county_name: "McLean",
    county_weights: {
      21149: 72.06,
      21177: 27.94,
    },
    county_names_all: "McLean|Muhlenberg",
    county_fips_all: "21149|21177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42374,
    lat: 37.33333,
    lng: -87.14045,
    city: "South Carrollton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 442,
    density: 759.9,
    county_fips: 21177,
    county_name: "Muhlenberg",
    county_weights: {
      21177: 100,
    },
    county_names_all: "Muhlenberg",
    county_fips_all: 21177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42376,
    lat: 37.61626,
    lng: -87.08619,
    city: "Utica",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5659,
    density: 22.3,
    county_fips: 21059,
    county_name: "Daviess",
    county_weights: {
      21059: 80.9,
      21149: 8.48,
      21183: 10.62,
    },
    county_names_all: "Daviess|Ohio|McLean",
    county_fips_all: "21059|21183|21149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42378,
    lat: 37.65093,
    lng: -86.87258,
    city: "Whitesville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3275,
    density: 20.6,
    county_fips: 21183,
    county_name: "Ohio",
    county_weights: {
      21059: 36.93,
      21183: 63.07,
    },
    county_names_all: "Ohio|Daviess",
    county_fips_all: "21183|21059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42404,
    lat: 37.47878,
    lng: -87.83636,
    city: "Clay",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2300,
    density: 10.1,
    county_fips: 21233,
    county_name: "Webster",
    county_weights: {
      21225: 5.7,
      21233: 94.3,
    },
    county_names_all: "Webster|Union",
    county_fips_all: "21233|21225",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42406,
    lat: 37.77792,
    lng: -87.74496,
    city: "Corydon",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2763,
    density: 9.7,
    county_fips: 21101,
    county_name: "Henderson",
    county_weights: {
      21101: 100,
    },
    county_names_all: "Henderson",
    county_fips_all: 21101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42408,
    lat: 37.1797,
    lng: -87.69229,
    city: "Dawson Springs",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7161,
    density: 19.2,
    county_fips: 21107,
    county_name: "Hopkins",
    county_weights: {
      21033: 26.79,
      21047: 15.3,
      21107: 57.91,
    },
    county_names_all: "Hopkins|Caldwell|Christian",
    county_fips_all: "21107|21033|21047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42409,
    lat: 37.5436,
    lng: -87.69947,
    city: "Dixon",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2709,
    density: 12.9,
    county_fips: 21233,
    county_name: "Webster",
    county_weights: {
      21233: 100,
    },
    county_names_all: "Webster",
    county_fips_all: 21233,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42410,
    lat: 37.27655,
    lng: -87.51078,
    city: "Earlington",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1043,
    density: 134.9,
    county_fips: 21107,
    county_name: "Hopkins",
    county_weights: {
      21107: 100,
    },
    county_names_all: "Hopkins",
    county_fips_all: 21107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42411,
    lat: 37.20315,
    lng: -88.02852,
    city: "Fredonia",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1771,
    density: 8.7,
    county_fips: 21033,
    county_name: "Caldwell",
    county_weights: {
      21033: 67.88,
      21055: 24.6,
      21143: 7.52,
    },
    county_names_all: "Caldwell|Crittenden|Lyon",
    county_fips_all: "21033|21055|21143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42413,
    lat: 37.44257,
    lng: -87.46919,
    city: "Hanson",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3146,
    density: 25.9,
    county_fips: 21107,
    county_name: "Hopkins",
    county_weights: {
      21107: 100,
    },
    county_names_all: "Hopkins",
    county_fips_all: 21107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42420,
    lat: 37.79875,
    lng: -87.51517,
    city: "Henderson",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38159,
    density: 76.9,
    county_fips: 21101,
    county_name: "Henderson",
    county_weights: {
      21101: 100,
    },
    county_names_all: "Henderson",
    county_fips_all: 21101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42431,
    lat: 37.33319,
    lng: -87.47512,
    city: "Madisonville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26035,
    density: 60.3,
    county_fips: 21107,
    county_name: "Hopkins",
    county_weights: {
      21107: 100,
    },
    county_names_all: "Hopkins",
    county_fips_all: 21107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42436,
    lat: 37.41462,
    lng: -87.56946,
    city: "Manitou",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1402,
    density: 25.1,
    county_fips: 21107,
    county_name: "Hopkins",
    county_weights: {
      21107: 100,
    },
    county_names_all: "Hopkins",
    county_fips_all: 21107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42437,
    lat: 37.66234,
    lng: -87.92067,
    city: "Morganfield",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8069,
    density: 18.4,
    county_fips: 21225,
    county_name: "Union",
    county_weights: {
      21225: 97.1,
      21233: 2.9,
    },
    county_names_all: "Union|Webster",
    county_fips_all: "21225|21233",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42440,
    lat: 37.23887,
    lng: -87.46782,
    city: "Mortons Gap",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 967,
    density: 264.2,
    county_fips: 21107,
    county_name: "Hopkins",
    county_weights: {
      21107: 100,
    },
    county_names_all: "Hopkins",
    county_fips_all: 21107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42441,
    lat: 37.36768,
    lng: -87.65962,
    city: "Nebo",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1226,
    density: 8.8,
    county_fips: 21107,
    county_name: "Hopkins",
    county_weights: {
      21107: 93.03,
      21233: 6.97,
    },
    county_names_all: "Hopkins|Webster",
    county_fips_all: "21107|21233",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42442,
    lat: 37.17408,
    lng: -87.48652,
    city: "Nortonville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3434,
    density: 28.1,
    county_fips: 21107,
    county_name: "Hopkins",
    county_weights: {
      21047: 0.95,
      21107: 99.05,
    },
    county_names_all: "Hopkins|Christian",
    county_fips_all: "21107|21047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42444,
    lat: 37.64152,
    lng: -87.6455,
    city: "Poole",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 21233,
    county_name: "Webster",
    county_weights: {
      21101: 0.15,
      21233: 99.85,
    },
    county_names_all: "Webster|Henderson",
    county_fips_all: "21233|21101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42445,
    lat: 37.12861,
    lng: -87.86052,
    city: "Princeton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10461,
    density: 15.5,
    county_fips: 21033,
    county_name: "Caldwell",
    county_weights: {
      21033: 90.97,
      21107: 4.15,
      21143: 4.65,
      21221: 0.23,
    },
    county_names_all: "Caldwell|Lyon|Hopkins|Trigg",
    county_fips_all: "21033|21143|21107|21221",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42450,
    lat: 37.38741,
    lng: -87.77535,
    city: "Providence",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3776,
    density: 20.1,
    county_fips: 21233,
    county_name: "Webster",
    county_weights: {
      21055: 18.38,
      21107: 31.84,
      21233: 49.78,
    },
    county_names_all: "Webster|Hopkins|Crittenden",
    county_fips_all: "21233|21107|21055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42451,
    lat: 37.88165,
    lng: -87.38966,
    city: "Reed",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 725,
    density: 7.1,
    county_fips: 21101,
    county_name: "Henderson",
    county_weights: {
      21101: 100,
    },
    county_names_all: "Henderson",
    county_fips_all: 21101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42452,
    lat: 37.68531,
    lng: -87.53654,
    city: "Robards",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2338,
    density: 15,
    county_fips: 21101,
    county_name: "Henderson",
    county_weights: {
      21101: 91.69,
      21233: 8.31,
    },
    county_names_all: "Henderson|Webster",
    county_fips_all: "21101|21233",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42453,
    lat: 37.14888,
    lng: -87.58275,
    city: "Saint Charles",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 532,
    density: 8.9,
    county_fips: 21107,
    county_name: "Hopkins",
    county_weights: {
      21047: 6.79,
      21107: 93.21,
    },
    county_names_all: "Hopkins|Christian",
    county_fips_all: "21107|21047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42455,
    lat: 37.5858,
    lng: -87.53938,
    city: "Sebree",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3259,
    density: 17.3,
    county_fips: 21233,
    county_name: "Webster",
    county_weights: {
      21233: 100,
    },
    county_names_all: "Webster",
    county_fips_all: 21233,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42456,
    lat: 37.51182,
    lng: -87.49929,
    city: "Slaughters",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1280,
    density: 7.2,
    county_fips: 21233,
    county_name: "Webster",
    county_weights: {
      21107: 36.52,
      21233: 63.48,
    },
    county_names_all: "Webster|Hopkins",
    county_fips_all: "21233|21107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42458,
    lat: 37.85249,
    lng: -87.42367,
    city: "Spottsville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1425,
    density: 50.2,
    county_fips: 21101,
    county_name: "Henderson",
    county_weights: {
      21101: 100,
    },
    county_names_all: "Henderson",
    county_fips_all: 21101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42459,
    lat: 37.5637,
    lng: -88.01837,
    city: "Sturgis",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3982,
    density: 12.2,
    county_fips: 21225,
    county_name: "Union",
    county_weights: {
      21055: 17.62,
      21225: 82.38,
    },
    county_names_all: "Union|Crittenden",
    county_fips_all: "21225|21055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42461,
    lat: 37.78668,
    lng: -87.88807,
    city: "Uniontown",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1134,
    density: 13.8,
    county_fips: 21225,
    county_name: "Union",
    county_weights: {
      21101: 1.25,
      21225: 98.75,
    },
    county_names_all: "Union|Henderson",
    county_fips_all: "21225|21101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42462,
    lat: 37.74123,
    lng: -87.79834,
    city: "Waverly",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1695,
    density: 13.4,
    county_fips: 21225,
    county_name: "Union",
    county_weights: {
      21101: 31.95,
      21225: 68.05,
    },
    county_names_all: "Union|Henderson",
    county_fips_all: "21225|21101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42463,
    lat: 37.47897,
    lng: -87.86717,
    city: "Wheatcroft",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 115,
    density: 29,
    county_fips: 21233,
    county_name: "Webster",
    county_weights: {
      21233: 100,
    },
    county_names_all: "Webster",
    county_fips_all: 21233,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42464,
    lat: 37.18132,
    lng: -87.37148,
    city: "White Plains",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1386,
    density: 8.9,
    county_fips: 21107,
    county_name: "Hopkins",
    county_weights: {
      21047: 15.4,
      21107: 71.08,
      21177: 13.52,
    },
    county_names_all: "Hopkins|Christian|Muhlenberg",
    county_fips_all: "21107|21047|21177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42501,
    lat: 37.06174,
    lng: -84.44973,
    city: "Somerset",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16787,
    density: 32.5,
    county_fips: 21199,
    county_name: "Pulaski",
    county_weights: {
      21199: 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: 21199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42503,
    lat: 37.15677,
    lng: -84.52511,
    city: "Somerset",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25463,
    density: 75.9,
    county_fips: 21199,
    county_name: "Pulaski",
    county_weights: {
      21199: 99.85,
      21203: 0.15,
    },
    county_names_all: "Pulaski|Rockcastle",
    county_fips_all: "21199|21203",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42516,
    lat: 37.22247,
    lng: -84.77881,
    city: "Bethelridge",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 930,
    density: 28.6,
    county_fips: 21045,
    county_name: "Casey",
    county_weights: {
      21045: 100,
    },
    county_names_all: "Casey",
    county_fips_all: 21045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42518,
    lat: 36.9253,
    lng: -84.64265,
    city: "Bronston",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3386,
    density: 38.2,
    county_fips: 21199,
    county_name: "Pulaski",
    county_weights: {
      21199: 52.46,
      21231: 47.54,
    },
    county_names_all: "Pulaski|Wayne",
    county_fips_all: "21199|21231",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42519,
    lat: 36.93932,
    lng: -84.53573,
    city: "Burnside",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3262,
    density: 25.5,
    county_fips: 21199,
    county_name: "Pulaski",
    county_weights: {
      21199: 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: 21199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42528,
    lat: 37.18335,
    lng: -85.01712,
    city: "Dunnville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1628,
    density: 11.9,
    county_fips: 21045,
    county_name: "Casey",
    county_weights: {
      21001: 16.17,
      21045: 66.3,
      21207: 17.53,
    },
    county_names_all: "Casey|Russell|Adair",
    county_fips_all: "21045|21207|21001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42533,
    lat: 37.06752,
    lng: -84.59382,
    city: "Ferguson",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 738,
    density: 175.6,
    county_fips: 21199,
    county_name: "Pulaski",
    county_weights: {
      21199: 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: 21199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42539,
    lat: 37.30566,
    lng: -84.95265,
    city: "Liberty",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9463,
    density: 16.6,
    county_fips: 21045,
    county_name: "Casey",
    county_weights: {
      21001: 1.05,
      21045: 98.95,
    },
    county_names_all: "Casey|Adair",
    county_fips_all: "21045|21001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42541,
    lat: 37.37325,
    lng: -84.80778,
    city: "Middleburg",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 345,
    density: 9,
    county_fips: 21045,
    county_name: "Casey",
    county_weights: {
      21045: 100,
    },
    county_names_all: "Casey",
    county_fips_all: 21045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42544,
    lat: 37.03473,
    lng: -84.8143,
    city: "Nancy",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5569,
    density: 15.1,
    county_fips: 21199,
    county_name: "Pulaski",
    county_weights: {
      21199: 73.6,
      21207: 16.53,
      21231: 9.87,
    },
    county_names_all: "Pulaski|Russell|Wayne",
    county_fips_all: "21199|21207|21231",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42553,
    lat: 37.1716,
    lng: -84.70056,
    city: "Science Hill",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5914,
    density: 34.8,
    county_fips: 21199,
    county_name: "Pulaski",
    county_weights: {
      21199: 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: 21199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42565,
    lat: 37.15008,
    lng: -84.90086,
    city: "Windsor",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 848,
    density: 13.8,
    county_fips: 21045,
    county_name: "Casey",
    county_weights: {
      21045: 99.3,
      21207: 0.7,
    },
    county_names_all: "Casey|Russell",
    county_fips_all: "21045|21207",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42566,
    lat: 37.28389,
    lng: -84.77932,
    city: "Yosemite",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 345,
    density: 7.8,
    county_fips: 21045,
    county_name: "Casey",
    county_weights: {
      21045: 100,
    },
    county_names_all: "Casey",
    county_fips_all: 21045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42567,
    lat: 37.26441,
    lng: -84.60454,
    city: "Eubank",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5268,
    density: 23.1,
    county_fips: 21199,
    county_name: "Pulaski",
    county_weights: {
      21137: 12.24,
      21199: 87.76,
    },
    county_names_all: "Pulaski|Lincoln",
    county_fips_all: "21199|21137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42602,
    lat: 36.73201,
    lng: -85.13324,
    city: "Albany",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10164,
    density: 20.8,
    county_fips: 21053,
    county_name: "Clinton",
    county_weights: {
      21053: 97.63,
      21207: 1.25,
      21231: 0.96,
      47137: 0.16,
    },
    county_names_all: "Clinton|Russell|Wayne|Pickett",
    county_fips_all: "21053|21207|21231|47137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42603,
    lat: 36.77875,
    lng: -85.01093,
    city: "Alpha",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54,
    density: 1.8,
    county_fips: 21231,
    county_name: "Wayne",
    county_weights: {
      21053: 44.84,
      21231: 55.16,
    },
    county_names_all: "Wayne|Clinton",
    county_fips_all: "21231|21053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Monticello",
  },
  {
    zip: 42629,
    lat: 36.92551,
    lng: -85.11732,
    city: "Jamestown",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5457,
    density: 20.9,
    county_fips: 21207,
    county_name: "Russell",
    county_weights: {
      21207: 100,
    },
    county_names_all: "Russell",
    county_fips_all: 21207,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42631,
    lat: 36.74039,
    lng: -84.48098,
    city: "Marshes Siding",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 200,
    density: 593.2,
    county_fips: 21147,
    county_name: "McCreary",
    county_weights: {
      21147: 100,
    },
    county_names_all: "McCreary",
    county_fips_all: 21147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42633,
    lat: 36.79245,
    lng: -84.83155,
    city: "Monticello",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19448,
    density: 17.9,
    county_fips: 21231,
    county_name: "Wayne",
    county_weights: {
      21231: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 21231,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Monticello",
  },
  {
    zip: 42634,
    lat: 36.88043,
    lng: -84.41601,
    city: "Parkers Lake",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2023,
    density: 8.8,
    county_fips: 21147,
    county_name: "McCreary",
    county_weights: {
      21147: 100,
    },
    county_names_all: "McCreary",
    county_fips_all: 21147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42635,
    lat: 36.67601,
    lng: -84.40033,
    city: "Pine Knot",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5007,
    density: 76.6,
    county_fips: 21147,
    county_name: "McCreary",
    county_weights: {
      21147: 100,
    },
    county_names_all: "McCreary",
    county_fips_all: 21147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42638,
    lat: 36.67487,
    lng: -84.4689,
    city: "Revelo",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74,
    density: 25.2,
    county_fips: 21147,
    county_name: "McCreary",
    county_weights: {
      21147: 100,
    },
    county_names_all: "McCreary",
    county_fips_all: 21147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42642,
    lat: 37.05624,
    lng: -85.0352,
    city: "Russell Springs",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12292,
    density: 33.8,
    county_fips: 21207,
    county_name: "Russell",
    county_weights: {
      21001: 10.01,
      21045: 0.71,
      21199: 2.94,
      21207: 86.34,
    },
    county_names_all: "Russell|Adair|Pulaski|Casey",
    county_fips_all: "21207|21001|21199|21045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42647,
    lat: 36.6922,
    lng: -84.61144,
    city: "Stearns",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3568,
    density: 10,
    county_fips: 21147,
    county_name: "McCreary",
    county_weights: {
      21147: 100,
    },
    county_names_all: "McCreary",
    county_fips_all: 21147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42649,
    lat: 36.6253,
    lng: -84.41798,
    city: "Strunk",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1709,
    density: 9,
    county_fips: 21147,
    county_name: "McCreary",
    county_weights: {
      21147: 100,
    },
    county_names_all: "McCreary",
    county_fips_all: 21147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42653,
    lat: 36.78117,
    lng: -84.4618,
    city: "Whitley City",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4543,
    density: 21.6,
    county_fips: 21147,
    county_name: "McCreary",
    county_weights: {
      21147: 100,
    },
    county_names_all: "McCreary",
    county_fips_all: 21147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42701,
    lat: 37.70502,
    lng: -85.83881,
    city: "Elizabethtown",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50851,
    density: 121.3,
    county_fips: 21093,
    county_name: "Hardin",
    county_weights: {
      21093: 100,
    },
    county_names_all: "Hardin",
    county_fips_all: 21093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42712,
    lat: 37.56098,
    lng: -86.15791,
    city: "Big Clifty",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1651,
    density: 11.7,
    county_fips: 21093,
    county_name: "Hardin",
    county_weights: {
      21085: 47.6,
      21093: 52.4,
    },
    county_names_all: "Hardin|Grayson",
    county_fips_all: "21093|21085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42713,
    lat: 37.37631,
    lng: -85.88282,
    city: "Bonnieville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1736,
    density: 14.1,
    county_fips: 21099,
    county_name: "Hart",
    county_weights: {
      21099: 100,
    },
    county_names_all: "Hart",
    county_fips_all: 21099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42715,
    lat: 36.94352,
    lng: -85.4134,
    city: "Breeding",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 172,
    density: 2.6,
    county_fips: 21001,
    county_name: "Adair",
    county_weights: {
      21001: 61.76,
      21057: 15.71,
      21169: 22.53,
    },
    county_names_all: "Adair|Metcalfe|Cumberland",
    county_fips_all: "21001|21169|21057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42716,
    lat: 37.47495,
    lng: -85.61925,
    city: "Buffalo",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1541,
    density: 19,
    county_fips: 21123,
    county_name: "Larue",
    county_weights: {
      21087: 14.82,
      21123: 74.84,
      21217: 10.34,
    },
    county_names_all: "Larue|Green|Taylor",
    county_fips_all: "21123|21087|21217",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42717,
    lat: 36.78169,
    lng: -85.38331,
    city: "Burkesville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6522,
    density: 8.3,
    county_fips: 21057,
    county_name: "Cumberland",
    county_weights: {
      21053: 2.62,
      21057: 97.38,
    },
    county_names_all: "Cumberland|Clinton",
    county_fips_all: "21057|21053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42718,
    lat: 37.38994,
    lng: -85.37561,
    city: "Campbellsville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25645,
    density: 37.3,
    county_fips: 21217,
    county_name: "Taylor",
    county_weights: {
      21087: 7.12,
      21123: 5,
      21155: 13.06,
      21217: 74.82,
    },
    county_names_all: "Taylor|Marion|Green|Larue",
    county_fips_all: "21217|21155|21087|21123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42721,
    lat: 37.42173,
    lng: -86.49593,
    city: "Caneyville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3538,
    density: 9.6,
    county_fips: 21085,
    county_name: "Grayson",
    county_weights: {
      21031: 6.12,
      21061: 3.94,
      21085: 89.94,
    },
    county_names_all: "Grayson|Butler|Edmonson",
    county_fips_all: "21085|21031|21061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42722,
    lat: 37.27628,
    lng: -85.71703,
    city: "Canmer",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 429,
    density: 9.8,
    county_fips: 21099,
    county_name: "Hart",
    county_weights: {
      21099: 100,
    },
    county_names_all: "Hart",
    county_fips_all: 21099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42724,
    lat: 37.67293,
    lng: -86.06461,
    city: "Cecilia",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5588,
    density: 28.3,
    county_fips: 21093,
    county_name: "Hardin",
    county_weights: {
      21093: 100,
    },
    county_names_all: "Hardin",
    county_fips_all: 21093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42726,
    lat: 37.42423,
    lng: -86.15035,
    city: "Clarkson",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5260,
    density: 19.7,
    county_fips: 21085,
    county_name: "Grayson",
    county_weights: {
      21085: 100,
    },
    county_names_all: "Grayson",
    county_fips_all: 21085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42728,
    lat: 37.10943,
    lng: -85.28873,
    city: "Columbia",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16675,
    density: 20.1,
    county_fips: 21001,
    county_name: "Adair",
    county_weights: {
      21001: 96.09,
      21169: 0.1,
      21217: 3.81,
    },
    county_names_all: "Adair|Taylor|Metcalfe",
    county_fips_all: "21001|21217|21169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42729,
    lat: 37.30167,
    lng: -86.09719,
    city: "Cub Run",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1532,
    density: 14.4,
    county_fips: 21099,
    county_name: "Hart",
    county_weights: {
      21061: 29.11,
      21099: 70.89,
    },
    county_names_all: "Hart|Edmonson",
    county_fips_all: "21099|21061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42732,
    lat: 37.61,
    lng: -86.11235,
    city: "Eastview",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2551,
    density: 18.2,
    county_fips: 21093,
    county_name: "Hardin",
    county_weights: {
      21093: 100,
    },
    county_names_all: "Hardin",
    county_fips_all: 21093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42733,
    lat: 37.34008,
    lng: -85.18028,
    city: "Elk Horn",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1468,
    density: 10.2,
    county_fips: 21217,
    county_name: "Taylor",
    county_weights: {
      21001: 2.39,
      21045: 25.04,
      21217: 72.57,
    },
    county_names_all: "Taylor|Casey|Adair",
    county_fips_all: "21217|21045|21001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42740,
    lat: 37.59174,
    lng: -85.94358,
    city: "Glendale",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2372,
    density: 29.5,
    county_fips: 21093,
    county_name: "Hardin",
    county_weights: {
      21093: 100,
    },
    county_names_all: "Hardin",
    county_fips_all: 21093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42741,
    lat: 36.9888,
    lng: -85.25183,
    city: "Glens Fork",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 715,
    density: 21.6,
    county_fips: 21001,
    county_name: "Adair",
    county_weights: {
      21001: 98.33,
      21207: 1.67,
    },
    county_names_all: "Adair|Russell",
    county_fips_all: "21001|21207",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42742,
    lat: 37.07774,
    lng: -85.47888,
    city: "Gradyville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 21001,
    county_name: "Adair",
    county_weights: {
      21001: 100,
    },
    county_names_all: "Adair",
    county_fips_all: 21001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42743,
    lat: 37.22958,
    lng: -85.53175,
    city: "Greensburg",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9017,
    density: 16.9,
    county_fips: 21087,
    county_name: "Green",
    county_weights: {
      21001: 2.68,
      21087: 97.32,
    },
    county_names_all: "Green|Adair",
    county_fips_all: "21087|21001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42746,
    lat: 37.21233,
    lng: -85.73304,
    city: "Hardyville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2232,
    density: 18.2,
    county_fips: 21099,
    county_name: "Hart",
    county_weights: {
      21087: 15.29,
      21099: 78.66,
      21169: 6.05,
    },
    county_names_all: "Hart|Green|Metcalfe",
    county_fips_all: "21099|21087|21169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42748,
    lat: 37.57029,
    lng: -85.70952,
    city: "Hodgenville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9425,
    density: 28.4,
    county_fips: 21123,
    county_name: "Larue",
    county_weights: {
      21093: 0.19,
      21123: 99.81,
    },
    county_names_all: "Larue|Hardin",
    county_fips_all: "21123|21093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42749,
    lat: 37.18983,
    lng: -85.87516,
    city: "Horse Cave",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5491,
    density: 23.1,
    county_fips: 21099,
    county_name: "Hart",
    county_weights: {
      21009: 6.39,
      21099: 80.3,
      21169: 13.31,
    },
    county_names_all: "Hart|Metcalfe|Barren",
    county_fips_all: "21099|21169|21009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42753,
    lat: 37.22299,
    lng: -85.17411,
    city: "Knifley",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 866,
    density: 13.2,
    county_fips: 21001,
    county_name: "Adair",
    county_weights: {
      21001: 100,
    },
    county_names_all: "Adair",
    county_fips_all: 21001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42754,
    lat: 37.47814,
    lng: -86.31379,
    city: "Leitchfield",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15809,
    density: 32.3,
    county_fips: 21085,
    county_name: "Grayson",
    county_weights: {
      21027: 9.3,
      21061: 0.6,
      21085: 90.1,
    },
    county_names_all: "Grayson|Breckinridge|Edmonson",
    county_fips_all: "21085|21027|21061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42757,
    lat: 37.40192,
    lng: -85.72501,
    city: "Magnolia",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2851,
    density: 14.1,
    county_fips: 21099,
    county_name: "Hart",
    county_weights: {
      21087: 7.15,
      21099: 63.22,
      21123: 29.63,
    },
    county_names_all: "Hart|Larue|Green",
    county_fips_all: "21099|21123|21087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42758,
    lat: 37.37656,
    lng: -85.19756,
    city: "Mannsville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 85,
    density: 81,
    county_fips: 21217,
    county_name: "Taylor",
    county_weights: {
      21217: 100,
    },
    county_names_all: "Taylor",
    county_fips_all: 21217,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42759,
    lat: 36.82909,
    lng: -85.51334,
    city: "Marrowbone",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 21057,
    county_name: "Cumberland",
    county_weights: {
      21057: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 21057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42762,
    lat: 37.45366,
    lng: -86.39527,
    city: "Millwood",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 162,
    density: 6.6,
    county_fips: 21085,
    county_name: "Grayson",
    county_weights: {
      21085: 100,
    },
    county_names_all: "Grayson",
    county_fips_all: 21085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42764,
    lat: 37.42948,
    lng: -85.62507,
    city: "Mount Sherman",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 381,
    density: 8.1,
    county_fips: 21087,
    county_name: "Green",
    county_weights: {
      21087: 86.92,
      21123: 13.08,
    },
    county_names_all: "Green|Larue",
    county_fips_all: "21087|21123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42765,
    lat: 37.30699,
    lng: -85.93115,
    city: "Munfordville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6561,
    density: 22.1,
    county_fips: 21099,
    county_name: "Hart",
    county_weights: {
      21099: 100,
    },
    county_names_all: "Hart",
    county_fips_all: 21099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42776,
    lat: 37.51577,
    lng: -85.91834,
    city: "Sonora",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2632,
    density: 15.4,
    county_fips: 21093,
    county_name: "Hardin",
    county_weights: {
      21093: 69.11,
      21123: 30.89,
    },
    county_names_all: "Hardin|Larue",
    county_fips_all: "21093|21123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 42782,
    lat: 37.34475,
    lng: -85.63702,
    city: "Summersville",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 721,
    density: 8.3,
    county_fips: 21087,
    county_name: "Green",
    county_weights: {
      21087: 87.17,
      21099: 12.83,
    },
    county_names_all: "Green|Hart",
    county_fips_all: "21087|21099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42784,
    lat: 37.4503,
    lng: -85.92272,
    city: "Upton",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2071,
    density: 12.1,
    county_fips: 21099,
    county_name: "Hart",
    county_weights: {
      21093: 36.33,
      21099: 39.47,
      21123: 24.2,
    },
    county_names_all: "Hart|Hardin|Larue",
    county_fips_all: "21099|21093|21123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 42788,
    lat: 37.52774,
    lng: -86.0372,
    city: "White Mills",
    state_id: "KY",
    state_name: "Kentucky",
    zcta: "TRUE",
    parent_zcta: "",
    population: 269,
    density: 13.7,
    county_fips: 21093,
    county_name: "Hardin",
    county_weights: {
      21093: 100,
    },
    county_names_all: "Hardin",
    county_fips_all: 21093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43001,
    lat: 40.08794,
    lng: -82.61289,
    city: "Alexandria",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2507,
    density: 33,
    county_fips: 39089,
    county_name: "Licking",
    county_weights: {
      39089: 100,
    },
    county_names_all: "Licking",
    county_fips_all: 39089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43002,
    lat: 40.05982,
    lng: -83.17305,
    city: "Amlin",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3431,
    density: 3715.1,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43003,
    lat: 40.41017,
    lng: -82.96866,
    city: "Ashley",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2936,
    density: 33.5,
    county_fips: 39041,
    county_name: "Delaware",
    county_weights: {
      39041: 50.82,
      39117: 49.18,
    },
    county_names_all: "Delaware|Morrow",
    county_fips_all: "39041|39117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43004,
    lat: 40.01664,
    lng: -82.80025,
    city: "Blacklick",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27972,
    density: 863.8,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43005,
    lat: 40.28241,
    lng: -82.26728,
    city: "Bladensburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 392,
    density: 77.6,
    county_fips: 39083,
    county_name: "Knox",
    county_weights: {
      39083: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 39083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43006,
    lat: 40.4591,
    lng: -82.14554,
    city: "Brinkhaven",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 543,
    density: 9.3,
    county_fips: 39031,
    county_name: "Coshocton",
    county_weights: {
      39031: 45.62,
      39075: 44.07,
      39083: 10.31,
    },
    county_names_all: "Coshocton|Holmes|Knox",
    county_fips_all: "39031|39075|39083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43007,
    lat: 40.33154,
    lng: -83.40595,
    city: "Broadway",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39159,
    county_name: "Union",
    county_weights: {
      39159: 100,
    },
    county_names_all: "Union",
    county_fips_all: 39159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43008,
    lat: 39.93348,
    lng: -82.4817,
    city: "Buckeye Lake",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2689,
    density: 691.3,
    county_fips: 39089,
    county_name: "Licking",
    county_weights: {
      39089: 100,
    },
    county_names_all: "Licking",
    county_fips_all: 39089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43009,
    lat: 40.17188,
    lng: -83.64234,
    city: "Cable",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2226,
    density: 25.4,
    county_fips: 39021,
    county_name: "Champaign",
    county_weights: {
      39021: 100,
    },
    county_names_all: "Champaign",
    county_fips_all: 39021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43010,
    lat: 39.99964,
    lng: -83.6219,
    city: "Catawba",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 290,
    density: 485.2,
    county_fips: 39023,
    county_name: "Clark",
    county_weights: {
      39023: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 39023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43011,
    lat: 40.30946,
    lng: -82.68456,
    city: "Centerburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8106,
    density: 39.1,
    county_fips: 39083,
    county_name: "Knox",
    county_weights: {
      39041: 13.61,
      39083: 51.72,
      39089: 19.3,
      39117: 15.37,
    },
    county_names_all: "Knox|Licking|Morrow|Delaware",
    county_fips_all: "39083|39089|39117|39041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43013,
    lat: 40.23101,
    lng: -82.6895,
    city: "Croton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1465,
    density: 28.1,
    county_fips: 39089,
    county_name: "Licking",
    county_weights: {
      39041: 0.95,
      39089: 99.05,
    },
    county_names_all: "Licking|Delaware",
    county_fips_all: "39089|39041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43014,
    lat: 40.46646,
    lng: -82.25242,
    city: "Danville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3624,
    density: 20,
    county_fips: 39083,
    county_name: "Knox",
    county_weights: {
      39005: 0.54,
      39031: 5.05,
      39083: 94.41,
    },
    county_names_all: "Knox|Coshocton|Ashland",
    county_fips_all: "39083|39031|39005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43015,
    lat: 40.29812,
    lng: -83.06049,
    city: "Delaware",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57893,
    density: 174.7,
    county_fips: 39041,
    county_name: "Delaware",
    county_weights: {
      39041: 99.49,
      39159: 0.51,
    },
    county_names_all: "Delaware|Union",
    county_fips_all: "39041|39159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43016,
    lat: 40.09732,
    lng: -83.15535,
    city: "Dublin",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38834,
    density: 789,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39041: 0.67,
      39049: 90.84,
      39159: 8.49,
    },
    county_names_all: "Franklin|Union|Delaware",
    county_fips_all: "39049|39159|39041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43017,
    lat: 40.1189,
    lng: -83.13314,
    city: "Dublin",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40419,
    density: 966.6,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39041: 21.92,
      39049: 74.02,
      39159: 4.06,
    },
    county_names_all: "Franklin|Delaware|Union",
    county_fips_all: "39049|39041|39159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43018,
    lat: 39.95377,
    lng: -82.67613,
    city: "Etna",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39089,
    county_name: "Licking",
    county_weights: {
      39089: 100,
    },
    county_names_all: "Licking",
    county_fips_all: 39089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43019,
    lat: 40.49527,
    lng: -82.57831,
    city: "Fredericktown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8754,
    density: 30.7,
    county_fips: 39083,
    county_name: "Knox",
    county_weights: {
      39083: 68.99,
      39117: 28.3,
      39139: 2.71,
    },
    county_names_all: "Knox|Morrow|Richland",
    county_fips_all: "39083|39117|39139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43021,
    lat: 40.20301,
    lng: -82.88476,
    city: "Galena",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12298,
    density: 122.1,
    county_fips: 39041,
    county_name: "Delaware",
    county_weights: {
      39041: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 39041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43022,
    lat: 40.33765,
    lng: -82.34135,
    city: "Gambier",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4137,
    density: 38,
    county_fips: 39083,
    county_name: "Knox",
    county_weights: {
      39083: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 39083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43023,
    lat: 40.07603,
    lng: -82.53061,
    city: "Granville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14475,
    density: 111.9,
    county_fips: 39089,
    county_name: "Licking",
    county_weights: {
      39089: 100,
    },
    county_names_all: "Licking",
    county_fips_all: 39089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43025,
    lat: 39.96653,
    lng: -82.51529,
    city: "Hebron",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5000,
    density: 54.4,
    county_fips: 39089,
    county_name: "Licking",
    county_weights: {
      39089: 100,
    },
    county_names_all: "Licking",
    county_fips_all: 39089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43026,
    lat: 40.02197,
    lng: -83.18472,
    city: "Hilliard",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63456,
    density: 694.2,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 99,
      39097: 1,
    },
    county_names_all: "Franklin|Madison",
    county_fips_all: "39049|39097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43027,
    lat: 40.25375,
    lng: -82.52253,
    city: "Homer",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39089,
    county_name: "Licking",
    county_weights: {
      39089: 100,
    },
    county_names_all: "Licking",
    county_fips_all: 39089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43028,
    lat: 40.40335,
    lng: -82.29783,
    city: "Howard",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8041,
    density: 61.3,
    county_fips: 39083,
    county_name: "Knox",
    county_weights: {
      39083: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 39083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43029,
    lat: 40.09598,
    lng: -83.45408,
    city: "Irwin",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 521,
    density: 8.6,
    county_fips: 39097,
    county_name: "Madison",
    county_weights: {
      39097: 78.67,
      39159: 21.33,
    },
    county_names_all: "Madison|Union",
    county_fips_all: "39097|39159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43030,
    lat: 39.96783,
    lng: -82.40667,
    city: "Jacksontown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39089,
    county_name: "Licking",
    county_weights: {
      39089: 100,
    },
    county_names_all: "Licking",
    county_fips_all: 39089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43031,
    lat: 40.16292,
    lng: -82.66378,
    city: "Johnstown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13653,
    density: 62,
    county_fips: 39089,
    county_name: "Licking",
    county_weights: {
      39041: 5.32,
      39089: 94.68,
    },
    county_names_all: "Licking|Delaware",
    county_fips_all: "39089|39041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43032,
    lat: 40.32836,
    lng: -82.95812,
    city: "Kilbourne",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14,
    density: 261,
    county_fips: 39041,
    county_name: "Delaware",
    county_weights: {
      39041: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 39041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43033,
    lat: 39.96098,
    lng: -82.59984,
    city: "Kirkersville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 431,
    density: 229.1,
    county_fips: 39089,
    county_name: "Licking",
    county_weights: {
      39089: 100,
    },
    county_names_all: "Licking",
    county_fips_all: 39089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43035,
    lat: 40.18622,
    lng: -82.9969,
    city: "Lewis Center",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28687,
    density: 564.9,
    county_fips: 39041,
    county_name: "Delaware",
    county_weights: {
      39041: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 39041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43036,
    lat: 40.3524,
    lng: -83.26325,
    city: "Magnetic Springs",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 332,
    density: 786.6,
    county_fips: 39159,
    county_name: "Union",
    county_weights: {
      39159: 100,
    },
    county_names_all: "Union",
    county_fips_all: 39159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43037,
    lat: 40.28062,
    lng: -82.31654,
    city: "Martinsburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 263,
    density: 31.3,
    county_fips: 39083,
    county_name: "Knox",
    county_weights: {
      39083: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 39083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43040,
    lat: 40.26115,
    lng: -83.35812,
    city: "Marysville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35169,
    density: 81.6,
    county_fips: 39159,
    county_name: "Union",
    county_weights: {
      39041: 0.78,
      39159: 99.22,
    },
    county_names_all: "Union|Delaware",
    county_fips_all: "39159|39041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43044,
    lat: 40.05145,
    lng: -83.56423,
    city: "Mechanicsburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4944,
    density: 24,
    county_fips: 39021,
    county_name: "Champaign",
    county_weights: {
      39021: 68.94,
      39023: 15,
      39097: 16.06,
    },
    county_names_all: "Champaign|Madison|Clark",
    county_fips_all: "39021|39097|39023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43045,
    lat: 40.16932,
    lng: -83.44975,
    city: "Milford Center",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2194,
    density: 22.6,
    county_fips: 39159,
    county_name: "Union",
    county_weights: {
      39021: 7.13,
      39159: 92.87,
    },
    county_names_all: "Union|Champaign",
    county_fips_all: "39159|39021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43046,
    lat: 39.89917,
    lng: -82.53844,
    city: "Millersport",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3463,
    density: 50.1,
    county_fips: 39045,
    county_name: "Fairfield",
    county_weights: {
      39045: 88.57,
      39089: 11.43,
    },
    county_names_all: "Fairfield|Licking",
    county_fips_all: "39045|39089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43047,
    lat: 40.20795,
    lng: -83.63797,
    city: "Mingo",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39021,
    county_name: "Champaign",
    county_weights: {
      39021: 100,
    },
    county_names_all: "Champaign",
    county_fips_all: 39021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43050,
    lat: 40.37188,
    lng: -82.49536,
    city: "Mount Vernon",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29609,
    density: 74.2,
    county_fips: 39083,
    county_name: "Knox",
    county_weights: {
      39083: 99.39,
      39117: 0.61,
    },
    county_names_all: "Knox|Morrow",
    county_fips_all: "39083|39117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43054,
    lat: 40.07998,
    lng: -82.79253,
    city: "New Albany",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26953,
    density: 405.3,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39041: 1.51,
      39049: 78.75,
      39089: 19.74,
    },
    county_names_all: "Franklin|Licking|Delaware",
    county_fips_all: "39049|39089|39041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43055,
    lat: 40.1168,
    lng: -82.37672,
    city: "Newark",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62215,
    density: 213.1,
    county_fips: 39089,
    county_name: "Licking",
    county_weights: {
      39089: 100,
    },
    county_names_all: "Licking",
    county_fips_all: 39089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43056,
    lat: 40.00895,
    lng: -82.33057,
    city: "Heath",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18997,
    density: 84.3,
    county_fips: 39089,
    county_name: "Licking",
    county_weights: {
      39089: 97.67,
      39119: 2.33,
    },
    county_names_all: "Licking|Muskingum",
    county_fips_all: "39089|39119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43060,
    lat: 40.21978,
    lng: -83.57295,
    city: "North Lewisburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2758,
    density: 40.8,
    county_fips: 39021,
    county_name: "Champaign",
    county_weights: {
      39021: 69.13,
      39091: 21.79,
      39159: 9.08,
    },
    county_names_all: "Champaign|Logan|Union",
    county_fips_all: "39021|39091|39159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43061,
    lat: 40.28775,
    lng: -83.20256,
    city: "Ostrander",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4908,
    density: 41.9,
    county_fips: 39041,
    county_name: "Delaware",
    county_weights: {
      39041: 83.63,
      39159: 16.37,
    },
    county_names_all: "Delaware|Union",
    county_fips_all: "39041|39159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43062,
    lat: 40.00556,
    lng: -82.67964,
    city: "Pataskala",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28914,
    density: 150.3,
    county_fips: 39089,
    county_name: "Licking",
    county_weights: {
      39045: 1.67,
      39089: 98.33,
    },
    county_names_all: "Licking|Fairfield",
    county_fips_all: "39089|39045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43064,
    lat: 40.09819,
    lng: -83.28863,
    city: "Plain City",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14069,
    density: 52.4,
    county_fips: 39097,
    county_name: "Madison",
    county_weights: {
      39049: 0.29,
      39097: 56.33,
      39159: 43.38,
    },
    county_names_all: "Madison|Union|Franklin",
    county_fips_all: "39097|39159|39049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43065,
    lat: 40.17655,
    lng: -83.09445,
    city: "Powell",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42971,
    density: 590.9,
    county_fips: 39041,
    county_name: "Delaware",
    county_weights: {
      39041: 95.57,
      39049: 4.43,
    },
    county_names_all: "Delaware|Franklin",
    county_fips_all: "39041|39049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43066,
    lat: 40.39877,
    lng: -83.16313,
    city: "Radnor",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1353,
    density: 14.5,
    county_fips: 39041,
    county_name: "Delaware",
    county_weights: {
      39041: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 39041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43067,
    lat: 40.34368,
    lng: -83.48388,
    city: "Raymond",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1258,
    density: 14.8,
    county_fips: 39159,
    county_name: "Union",
    county_weights: {
      39091: 10.4,
      39159: 89.6,
    },
    county_names_all: "Union|Logan",
    county_fips_all: "39159|39091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43068,
    lat: 39.95667,
    lng: -82.78468,
    city: "Reynoldsburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55498,
    density: 1092.9,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39045: 8.89,
      39049: 49.4,
      39089: 41.71,
    },
    county_names_all: "Franklin|Licking|Fairfield",
    county_fips_all: "39049|39089|39045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43070,
    lat: 40.22056,
    lng: -83.95651,
    city: "Rosewood",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 110,
    density: 103.6,
    county_fips: 39021,
    county_name: "Champaign",
    county_weights: {
      39021: 100,
    },
    county_names_all: "Champaign",
    county_fips_all: 39021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43071,
    lat: 40.18479,
    lng: -82.35509,
    city: "Saint Louisville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2206,
    density: 23.9,
    county_fips: 39089,
    county_name: "Licking",
    county_weights: {
      39089: 100,
    },
    county_names_all: "Licking",
    county_fips_all: 39089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43072,
    lat: 40.1172,
    lng: -83.95514,
    city: "Saint Paris",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5896,
    density: 29.8,
    county_fips: 39021,
    county_name: "Champaign",
    county_weights: {
      39021: 100,
    },
    county_names_all: "Champaign",
    county_fips_all: 39021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43074,
    lat: 40.28008,
    lng: -82.84899,
    city: "Sunbury",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14298,
    density: 64.8,
    county_fips: 39041,
    county_name: "Delaware",
    county_weights: {
      39041: 97.92,
      39089: 2.08,
    },
    county_names_all: "Delaware|Licking",
    county_fips_all: "39041|39089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43076,
    lat: 39.89594,
    lng: -82.39497,
    city: "Thornville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8935,
    density: 52.9,
    county_fips: 39127,
    county_name: "Perry",
    county_weights: {
      39045: 10.92,
      39089: 31.74,
      39127: 57.34,
    },
    county_names_all: "Perry|Licking|Fairfield",
    county_fips_all: "39127|39089|39045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43077,
    lat: 40.13675,
    lng: -83.34165,
    city: "Unionville Center",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 345,
    density: 835.8,
    county_fips: 39159,
    county_name: "Union",
    county_weights: {
      39159: 100,
    },
    county_names_all: "Union",
    county_fips_all: 39159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43078,
    lat: 40.11302,
    lng: -83.77538,
    city: "Urbana",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20634,
    density: 53,
    county_fips: 39021,
    county_name: "Champaign",
    county_weights: {
      39021: 99.18,
      39023: 0.82,
    },
    county_names_all: "Champaign|Clark",
    county_fips_all: "39021|39023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43080,
    lat: 40.24284,
    lng: -82.43126,
    city: "Utica",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5455,
    density: 28.7,
    county_fips: 39089,
    county_name: "Licking",
    county_weights: {
      39083: 40.07,
      39089: 59.93,
    },
    county_names_all: "Licking|Knox",
    county_fips_all: "39089|39083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43081,
    lat: 40.11064,
    lng: -82.89083,
    city: "Westerville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65592,
    density: 1008.4,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39041: 0.62,
      39049: 99.38,
    },
    county_names_all: "Franklin|Delaware",
    county_fips_all: "39049|39041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43082,
    lat: 40.15537,
    lng: -82.88437,
    city: "Westerville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35244,
    density: 649.6,
    county_fips: 39041,
    county_name: "Delaware",
    county_weights: {
      39041: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 39041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43084,
    lat: 40.15764,
    lng: -83.54223,
    city: "Woodstock",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 750,
    density: 13.9,
    county_fips: 39021,
    county_name: "Champaign",
    county_weights: {
      39021: 97.94,
      39159: 2.06,
    },
    county_names_all: "Champaign|Union",
    county_fips_all: "39021|39159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43085,
    lat: 40.09959,
    lng: -83.01639,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26395,
    density: 1393.2,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43101,
    lat: 39.46466,
    lng: -82.74563,
    city: "Adelphi",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 371,
    density: 523,
    county_fips: 39141,
    county_name: "Ross",
    county_weights: {
      39141: 100,
    },
    county_names_all: "Ross",
    county_fips_all: 39141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43102,
    lat: 39.64076,
    lng: -82.76118,
    city: "Amanda",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4002,
    density: 26.9,
    county_fips: 39045,
    county_name: "Fairfield",
    county_weights: {
      39045: 95.96,
      39073: 3.45,
      39129: 0.59,
    },
    county_names_all: "Fairfield|Hocking|Pickaway",
    county_fips_all: "39045|39073|39129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43103,
    lat: 39.72484,
    lng: -82.93428,
    city: "Ashville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11346,
    density: 52.4,
    county_fips: 39129,
    county_name: "Pickaway",
    county_weights: {
      39045: 0.61,
      39129: 99.39,
    },
    county_names_all: "Pickaway|Fairfield",
    county_fips_all: "39129|39045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43105,
    lat: 39.86513,
    lng: -82.61826,
    city: "Baltimore",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8540,
    density: 58.2,
    county_fips: 39045,
    county_name: "Fairfield",
    county_weights: {
      39045: 99.47,
      39089: 0.53,
    },
    county_names_all: "Fairfield|Licking",
    county_fips_all: "39045|39089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43106,
    lat: 39.6448,
    lng: -83.41853,
    city: "Bloomingburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1660,
    density: 16.3,
    county_fips: 39047,
    county_name: "Fayette",
    county_weights: {
      39047: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 39047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43107,
    lat: 39.69254,
    lng: -82.40993,
    city: "Bremen",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3442,
    density: 44.7,
    county_fips: 39045,
    county_name: "Fairfield",
    county_weights: {
      39045: 87.37,
      39073: 7.96,
      39127: 4.67,
    },
    county_names_all: "Fairfield|Hocking|Perry",
    county_fips_all: "39045|39073|39127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43109,
    lat: 39.9127,
    lng: -82.83385,
    city: "Brice",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 184,
    density: 423.1,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43110,
    lat: 39.82825,
    lng: -82.80143,
    city: "Canal Winchester",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38942,
    density: 322.1,
    county_fips: 39045,
    county_name: "Fairfield",
    county_weights: {
      39045: 59.07,
      39049: 39.01,
      39129: 1.92,
    },
    county_names_all: "Fairfield|Franklin|Pickaway",
    county_fips_all: "39045|39049|39129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43111,
    lat: 39.50212,
    lng: -82.24257,
    city: "Carbon Hill",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 222,
    density: 211.9,
    county_fips: 39073,
    county_name: "Hocking",
    county_weights: {
      39073: 100,
    },
    county_names_all: "Hocking",
    county_fips_all: 39073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43112,
    lat: 39.79719,
    lng: -82.70472,
    city: "Carroll",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5070,
    density: 55.2,
    county_fips: 39045,
    county_name: "Fairfield",
    county_weights: {
      39045: 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: 39045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43113,
    lat: 39.59114,
    lng: -82.96192,
    city: "Circleville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25002,
    density: 59.5,
    county_fips: 39129,
    county_name: "Pickaway",
    county_weights: {
      39045: 0.41,
      39129: 99.59,
    },
    county_names_all: "Pickaway|Fairfield",
    county_fips_all: "39129|39045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43115,
    lat: 39.48989,
    lng: -83.16579,
    city: "Clarksburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1989,
    density: 17.3,
    county_fips: 39141,
    county_name: "Ross",
    county_weights: {
      39129: 16.73,
      39141: 83.27,
    },
    county_names_all: "Ross|Pickaway",
    county_fips_all: "39141|39129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43116,
    lat: 39.77284,
    lng: -83.06275,
    city: "Commercial Point",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1992,
    density: 759.6,
    county_fips: 39129,
    county_name: "Pickaway",
    county_weights: {
      39129: 100,
    },
    county_names_all: "Pickaway",
    county_fips_all: 39129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43117,
    lat: 39.76874,
    lng: -83.20622,
    city: "Derby",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64,
    density: 1483.2,
    county_fips: 39129,
    county_name: "Pickaway",
    county_weights: {
      39129: 100,
    },
    county_names_all: "Pickaway",
    county_fips_all: 39129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43119,
    lat: 39.93487,
    lng: -83.20059,
    city: "Galloway",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27424,
    density: 329.8,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 88.73,
      39097: 11.27,
    },
    county_names_all: "Franklin|Madison",
    county_fips_all: "39049|39097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43123,
    lat: 39.86801,
    lng: -83.12088,
    city: "Grove City",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 66649,
    density: 430.7,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43125,
    lat: 39.83747,
    lng: -82.88588,
    city: "Groveport",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14723,
    density: 180.7,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 87.04,
      39129: 12.96,
    },
    county_names_all: "Franklin|Pickaway",
    county_fips_all: "39049|39129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43126,
    lat: 39.81077,
    lng: -83.16857,
    city: "Harrisburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 494,
    density: 1216.4,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43127,
    lat: 39.47559,
    lng: -82.32183,
    city: "Haydenville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 182,
    density: 68.4,
    county_fips: 39073,
    county_name: "Hocking",
    county_weights: {
      39073: 100,
    },
    county_names_all: "Hocking",
    county_fips_all: 39073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43128,
    lat: 39.66359,
    lng: -83.57893,
    city: "Jeffersonville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2331,
    density: 18.5,
    county_fips: 39047,
    county_name: "Fayette",
    county_weights: {
      39047: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 39047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43130,
    lat: 39.70013,
    lng: -82.60992,
    city: "Lancaster",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62127,
    density: 145.8,
    county_fips: 39045,
    county_name: "Fairfield",
    county_weights: {
      39045: 99.81,
      39073: 0.19,
    },
    county_names_all: "Fairfield|Hocking",
    county_fips_all: "39045|39073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43135,
    lat: 39.4711,
    lng: -82.69736,
    city: "Laurelville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3805,
    density: 16,
    county_fips: 39073,
    county_name: "Hocking",
    county_weights: {
      39073: 79.12,
      39129: 12.19,
      39141: 7.91,
      39163: 0.78,
    },
    county_names_all: "Hocking|Pickaway|Ross|Vinton",
    county_fips_all: "39073|39129|39141|39163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43136,
    lat: 39.80157,
    lng: -82.81543,
    city: "Lithopolis",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 913,
    density: 295.2,
    county_fips: 39045,
    county_name: "Fairfield",
    county_weights: {
      39045: 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: 39045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43137,
    lat: 39.80486,
    lng: -82.98694,
    city: "Lockbourne",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2055,
    density: 24.9,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 50.24,
      39129: 49.76,
    },
    county_names_all: "Franklin|Pickaway",
    county_fips_all: "39049|39129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43138,
    lat: 39.52225,
    lng: -82.41335,
    city: "Logan",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18619,
    density: 40.9,
    county_fips: 39073,
    county_name: "Hocking",
    county_weights: {
      39073: 94.09,
      39127: 5.42,
      39163: 0.49,
    },
    county_names_all: "Hocking|Perry|Vinton",
    county_fips_all: "39073|39127|39163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43140,
    lat: 39.88406,
    lng: -83.42946,
    city: "London",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24352,
    density: 42.8,
    county_fips: 39097,
    county_name: "Madison",
    county_weights: {
      39023: 1.34,
      39049: 2.21,
      39097: 96.45,
    },
    county_names_all: "Madison|Franklin|Clark",
    county_fips_all: "39097|39049|39023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43142,
    lat: 39.59289,
    lng: -83.58777,
    city: "Milledgeville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 116,
    density: 502.5,
    county_fips: 39047,
    county_name: "Fayette",
    county_weights: {
      39047: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 39047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43143,
    lat: 39.71801,
    lng: -83.29672,
    city: "Mount Sterling",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5361,
    density: 15.5,
    county_fips: 39097,
    county_name: "Madison",
    county_weights: {
      39047: 17.3,
      39097: 52.99,
      39129: 29.71,
    },
    county_names_all: "Madison|Pickaway|Fayette",
    county_fips_all: "39097|39129|39047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43144,
    lat: 39.52797,
    lng: -82.19155,
    city: "Murray City",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 382,
    density: 22.1,
    county_fips: 39073,
    county_name: "Hocking",
    county_weights: {
      39073: 100,
    },
    county_names_all: "Hocking",
    county_fips_all: 39073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43145,
    lat: 39.56281,
    lng: -83.2594,
    city: "New Holland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2154,
    density: 15.5,
    county_fips: 39129,
    county_name: "Pickaway",
    county_weights: {
      39047: 48.83,
      39129: 51.17,
    },
    county_names_all: "Pickaway|Fayette",
    county_fips_all: "39129|39047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43146,
    lat: 39.77293,
    lng: -83.14333,
    city: "Orient",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13356,
    density: 66.2,
    county_fips: 39129,
    county_name: "Pickaway",
    county_weights: {
      39049: 17.9,
      39097: 1.2,
      39129: 80.9,
    },
    county_names_all: "Pickaway|Franklin|Madison",
    county_fips_all: "39129|39049|39097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43147,
    lat: 39.8982,
    lng: -82.74227,
    city: "Pickerington",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42463,
    density: 548.1,
    county_fips: 39045,
    county_name: "Fairfield",
    county_weights: {
      39045: 98.44,
      39049: 0.64,
      39089: 0.92,
    },
    county_names_all: "Fairfield|Licking|Franklin",
    county_fips_all: "39045|39089|39049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43148,
    lat: 39.81809,
    lng: -82.49887,
    city: "Pleasantville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2102,
    density: 30.1,
    county_fips: 39045,
    county_name: "Fairfield",
    county_weights: {
      39045: 89.8,
      39127: 10.2,
    },
    county_names_all: "Fairfield|Perry",
    county_fips_all: "39045|39127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43149,
    lat: 39.53742,
    lng: -82.57188,
    city: "Rockbridge",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2399,
    density: 17.1,
    county_fips: 39073,
    county_name: "Hocking",
    county_weights: {
      39073: 100,
    },
    county_names_all: "Hocking",
    county_fips_all: 39073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43150,
    lat: 39.77446,
    lng: -82.40565,
    city: "Rushville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2365,
    density: 37.5,
    county_fips: 39045,
    county_name: "Fairfield",
    county_weights: {
      39045: 57.66,
      39127: 42.34,
    },
    county_names_all: "Fairfield|Perry",
    county_fips_all: "39045|39127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43151,
    lat: 39.73317,
    lng: -83.47661,
    city: "Sedalia",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 300,
    density: 445.9,
    county_fips: 39097,
    county_name: "Madison",
    county_weights: {
      39097: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 39097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43152,
    lat: 39.39211,
    lng: -82.61433,
    city: "South Bloomingville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 613,
    density: 5,
    county_fips: 39073,
    county_name: "Hocking",
    county_weights: {
      39073: 76.96,
      39163: 23.04,
    },
    county_names_all: "Hocking|Vinton",
    county_fips_all: "39073|39163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43153,
    lat: 39.74071,
    lng: -83.56781,
    city: "South Solon",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1199,
    density: 8.9,
    county_fips: 39097,
    county_name: "Madison",
    county_weights: {
      39023: 13.91,
      39047: 9.04,
      39057: 2.44,
      39097: 74.61,
    },
    county_names_all: "Madison|Clark|Fayette|Greene",
    county_fips_all: "39097|39023|39047|39057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43154,
    lat: 39.60327,
    lng: -82.82622,
    city: "Stoutsville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3946,
    density: 57.9,
    county_fips: 39045,
    county_name: "Fairfield",
    county_weights: {
      39045: 66.4,
      39129: 33.6,
    },
    county_names_all: "Fairfield|Pickaway",
    county_fips_all: "39045|39129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43155,
    lat: 39.6251,
    lng: -82.52618,
    city: "Sugar Grove",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2679,
    density: 34.8,
    county_fips: 39045,
    county_name: "Fairfield",
    county_weights: {
      39045: 61,
      39073: 39,
    },
    county_names_all: "Fairfield|Hocking",
    county_fips_all: "39045|39073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43156,
    lat: 39.55389,
    lng: -82.77621,
    city: "Tarlton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 229,
    density: 295.7,
    county_fips: 39129,
    county_name: "Pickaway",
    county_weights: {
      39129: 100,
    },
    county_names_all: "Pickaway",
    county_fips_all: 39129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43157,
    lat: 39.84303,
    lng: -82.54675,
    city: "Thurston",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 711,
    density: 693.4,
    county_fips: 39045,
    county_name: "Fairfield",
    county_weights: {
      39045: 100,
    },
    county_names_all: "Fairfield",
    county_fips_all: 39045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43158,
    lat: 39.44968,
    lng: -82.35546,
    city: "Union Furnace",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 347,
    density: 58.1,
    county_fips: 39073,
    county_name: "Hocking",
    county_weights: {
      39073: 100,
    },
    county_names_all: "Hocking",
    county_fips_all: 39073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43160,
    lat: 39.52871,
    lng: -83.43917,
    city: "Washington Court House",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21529,
    density: 39,
    county_fips: 39047,
    county_name: "Fayette",
    county_weights: {
      39047: 94.09,
      39141: 5.91,
    },
    county_names_all: "Fayette|Ross",
    county_fips_all: "39047|39141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43162,
    lat: 39.94369,
    lng: -83.30633,
    city: "West Jefferson",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7128,
    density: 58.6,
    county_fips: 39097,
    county_name: "Madison",
    county_weights: {
      39097: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 39097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43164,
    lat: 39.58349,
    lng: -83.12009,
    city: "Williamsport",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2277,
    density: 14.2,
    county_fips: 39129,
    county_name: "Pickaway",
    county_weights: {
      39129: 91.58,
      39141: 8.42,
    },
    county_names_all: "Pickaway|Ross",
    county_fips_all: "39129|39141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43201,
    lat: 39.99114,
    lng: -83.00056,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33792,
    density: 4271.2,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43202,
    lat: 40.02126,
    lng: -83.01394,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20424,
    density: 3136.8,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43203,
    lat: 39.9729,
    lng: -82.96922,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8415,
    density: 2254.9,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43204,
    lat: 39.96135,
    lng: -83.08052,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43592,
    density: 1799.6,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43205,
    lat: 39.9575,
    lng: -82.96244,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12590,
    density: 2034.2,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43206,
    lat: 39.94205,
    lng: -82.97346,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22430,
    density: 2868.3,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43207,
    lat: 39.89599,
    lng: -82.96392,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47118,
    density: 786.8,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43209,
    lat: 39.95462,
    lng: -82.92992,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29013,
    density: 1830.2,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43210,
    lat: 40.00487,
    lng: -83.02182,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12506,
    density: 3249.9,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43211,
    lat: 40.01163,
    lng: -82.97244,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24085,
    density: 1973,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43212,
    lat: 39.98763,
    lng: -83.04215,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22181,
    density: 2292,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43213,
    lat: 39.97117,
    lng: -82.86746,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32807,
    density: 1227,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43214,
    lat: 40.0523,
    lng: -83.01996,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26917,
    density: 1525.2,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43215,
    lat: 39.96633,
    lng: -83.01262,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14950,
    density: 1122.9,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43217,
    lat: 39.81667,
    lng: -82.93279,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2069,
    density: 185.9,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43218,
    lat: 40.01765,
    lng: -82.92367,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43219,
    lat: 40.00774,
    lng: -82.92233,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31404,
    density: 759.8,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43220,
    lat: 40.04847,
    lng: -83.07161,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28019,
    density: 1636.2,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43221,
    lat: 40.02334,
    lng: -83.07744,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34354,
    density: 1390.3,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43222,
    lat: 39.961,
    lng: -83.03581,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4992,
    density: 1365.8,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43223,
    lat: 39.92636,
    lng: -83.03395,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27458,
    density: 1059.9,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43224,
    lat: 40.04256,
    lng: -82.9664,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45533,
    density: 2127.6,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43227,
    lat: 39.94511,
    lng: -82.88858,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24857,
    density: 2313.3,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43228,
    lat: 39.96367,
    lng: -83.12478,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55186,
    density: 1071.2,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43229,
    lat: 40.08569,
    lng: -82.97636,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56760,
    density: 2424.8,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43230,
    lat: 40.03648,
    lng: -82.87057,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59853,
    density: 1132.5,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43231,
    lat: 40.07843,
    lng: -82.93914,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23202,
    density: 2154.7,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43232,
    lat: 39.92189,
    lng: -82.87053,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46914,
    density: 1455.5,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39049: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 39049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43235,
    lat: 40.10193,
    lng: -83.05442,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44158,
    density: 1204.9,
    county_fips: 39049,
    county_name: "Franklin",
    county_weights: {
      39041: 0.13,
      39049: 99.87,
    },
    county_names_all: "Franklin|Delaware",
    county_fips_all: "39049|39041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43240,
    lat: 40.14501,
    lng: -82.98209,
    city: "Columbus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4543,
    density: 713.4,
    county_fips: 39041,
    county_name: "Delaware",
    county_weights: {
      39041: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 39041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43302,
    lat: 40.59995,
    lng: -83.12967,
    city: "Marion",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54413,
    density: 107.8,
    county_fips: 39101,
    county_name: "Marion",
    county_weights: {
      39033: 4.71,
      39101: 95.06,
      39159: 0.23,
    },
    county_names_all: "Marion|Crawford|Union",
    county_fips_all: "39101|39033|39159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43310,
    lat: 40.5346,
    lng: -83.78029,
    city: "Belle Center",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3144,
    density: 18.3,
    county_fips: 39065,
    county_name: "Hardin",
    county_weights: {
      39065: 54.72,
      39091: 45.28,
    },
    county_names_all: "Hardin|Logan",
    county_fips_all: "39065|39091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43311,
    lat: 40.36427,
    lng: -83.75812,
    city: "Bellefontaine",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18753,
    density: 69.7,
    county_fips: 39091,
    county_name: "Logan",
    county_weights: {
      39091: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 39091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43314,
    lat: 40.6474,
    lng: -82.96122,
    city: "Caledonia",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2935,
    density: 20.9,
    county_fips: 39101,
    county_name: "Marion",
    county_weights: {
      39033: 11.91,
      39101: 79.94,
      39117: 8.15,
    },
    county_names_all: "Marion|Crawford|Morrow",
    county_fips_all: "39101|39033|39117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43315,
    lat: 40.4841,
    lng: -82.87872,
    city: "Cardington",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7501,
    density: 34.5,
    county_fips: 39117,
    county_name: "Morrow",
    county_weights: {
      39101: 9.73,
      39117: 90.27,
    },
    county_names_all: "Morrow|Marion",
    county_fips_all: "39117|39101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43316,
    lat: 40.95184,
    lng: -83.38596,
    city: "Carey",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5901,
    density: 30,
    county_fips: 39175,
    county_name: "Wyandot",
    county_weights: {
      39063: 3.72,
      39147: 17.03,
      39175: 79.25,
    },
    county_names_all: "Wyandot|Seneca|Hancock",
    county_fips_all: "39175|39147|39063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43317,
    lat: 40.47748,
    lng: -82.68202,
    city: "Chesterville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 163,
    density: 286,
    county_fips: 39117,
    county_name: "Morrow",
    county_weights: {
      39117: 100,
    },
    county_names_all: "Morrow",
    county_fips_all: 39117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43318,
    lat: 40.30948,
    lng: -83.91378,
    city: "De Graff",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3823,
    density: 23,
    county_fips: 39091,
    county_name: "Logan",
    county_weights: {
      39021: 32.12,
      39091: 67.88,
    },
    county_names_all: "Logan|Champaign",
    county_fips_all: "39091|39021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43319,
    lat: 40.30525,
    lng: -83.57738,
    city: "East Liberty",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 930,
    density: 19.1,
    county_fips: 39091,
    county_name: "Logan",
    county_weights: {
      39091: 99.16,
      39159: 0.84,
    },
    county_names_all: "Logan|Union",
    county_fips_all: "39091|39159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43320,
    lat: 40.5886,
    lng: -82.89994,
    city: "Edison",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1147,
    density: 14,
    county_fips: 39117,
    county_name: "Morrow",
    county_weights: {
      39117: 100,
    },
    county_names_all: "Morrow",
    county_fips_all: 39117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43321,
    lat: 40.463,
    lng: -82.82889,
    city: "Fulton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 272,
    density: 686.3,
    county_fips: 39117,
    county_name: "Morrow",
    county_weights: {
      39117: 100,
    },
    county_names_all: "Morrow",
    county_fips_all: 39117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43322,
    lat: 40.5327,
    lng: -83.20815,
    city: "Green Camp",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 328,
    density: 428.5,
    county_fips: 39101,
    county_name: "Marion",
    county_weights: {
      39101: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 39101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43323,
    lat: 40.73116,
    lng: -83.25211,
    city: "Harpster",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 639,
    density: 6.8,
    county_fips: 39175,
    county_name: "Wyandot",
    county_weights: {
      39101: 3.67,
      39175: 96.33,
    },
    county_names_all: "Wyandot|Marion",
    county_fips_all: "39175|39101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43324,
    lat: 40.44632,
    lng: -83.81207,
    city: "Huntsville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2783,
    density: 37.5,
    county_fips: 39091,
    county_name: "Logan",
    county_weights: {
      39091: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 39091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43325,
    lat: 40.66939,
    lng: -82.83102,
    city: "Iberia",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39117,
    county_name: "Morrow",
    county_weights: {
      39117: 100,
    },
    county_names_all: "Morrow",
    county_fips_all: 39117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43326,
    lat: 40.64149,
    lng: -83.61443,
    city: "Kenton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13393,
    density: 27.7,
    county_fips: 39065,
    county_name: "Hardin",
    county_weights: {
      39065: 99.31,
      39101: 0.69,
    },
    county_names_all: "Hardin|Marion",
    county_fips_all: "39065|39101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43330,
    lat: 40.81349,
    lng: -83.41935,
    city: "Kirby",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 103,
    density: 369.1,
    county_fips: 39175,
    county_name: "Wyandot",
    county_weights: {
      39175: 100,
    },
    county_names_all: "Wyandot",
    county_fips_all: 39175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43331,
    lat: 40.51794,
    lng: -83.9191,
    city: "Lakeview",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4344,
    density: 54.4,
    county_fips: 39091,
    county_name: "Logan",
    county_weights: {
      39011: 25.08,
      39065: 5.12,
      39091: 69.8,
    },
    county_names_all: "Logan|Auglaize|Hardin",
    county_fips_all: "39091|39011|39065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43332,
    lat: 40.58369,
    lng: -83.37769,
    city: "La Rue",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1566,
    density: 9.9,
    county_fips: 39101,
    county_name: "Marion",
    county_weights: {
      39065: 9.42,
      39101: 86.71,
      39175: 3.87,
    },
    county_names_all: "Marion|Hardin|Wyandot",
    county_fips_all: "39101|39065|39175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43333,
    lat: 40.43927,
    lng: -83.93221,
    city: "Lewistown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 720,
    density: 9.1,
    county_fips: 39091,
    county_name: "Logan",
    county_weights: {
      39091: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 39091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43334,
    lat: 40.39912,
    lng: -82.79863,
    city: "Marengo",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6080,
    density: 35.5,
    county_fips: 39117,
    county_name: "Morrow",
    county_weights: {
      39041: 2.52,
      39117: 97.48,
    },
    county_names_all: "Morrow|Delaware",
    county_fips_all: "39117|39041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43336,
    lat: 40.28337,
    lng: -83.57651,
    city: "Middleburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 39091,
    county_name: "Logan",
    county_weights: {
      39091: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 39091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43337,
    lat: 40.68336,
    lng: -83.24107,
    city: "Morral",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1104,
    density: 12,
    county_fips: 39101,
    county_name: "Marion",
    county_weights: {
      39101: 79.33,
      39175: 20.67,
    },
    county_names_all: "Marion|Wyandot",
    county_fips_all: "39101|39175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43338,
    lat: 40.56207,
    lng: -82.75958,
    city: "Mount Gilead",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10483,
    density: 42.6,
    county_fips: 39117,
    county_name: "Morrow",
    county_weights: {
      39117: 100,
    },
    county_names_all: "Morrow",
    county_fips_all: 39117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43340,
    lat: 40.53748,
    lng: -83.48,
    city: "Mount Victory",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2153,
    density: 17.1,
    county_fips: 39065,
    county_name: "Hardin",
    county_weights: {
      39065: 79.95,
      39159: 20.05,
    },
    county_names_all: "Hardin|Union",
    county_fips_all: "39065|39159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43341,
    lat: 40.59577,
    lng: -83.31544,
    city: "New Bloomington",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 748,
    density: 12.9,
    county_fips: 39101,
    county_name: "Marion",
    county_weights: {
      39101: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 39101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43342,
    lat: 40.47533,
    lng: -83.17994,
    city: "Prospect",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3531,
    density: 31.9,
    county_fips: 39101,
    county_name: "Marion",
    county_weights: {
      39041: 4.64,
      39101: 88.7,
      39159: 6.66,
    },
    county_names_all: "Marion|Union|Delaware",
    county_fips_all: "39101|39159|39041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43343,
    lat: 40.3073,
    lng: -83.97647,
    city: "Quincy",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1198,
    density: 12.9,
    county_fips: 39091,
    county_name: "Logan",
    county_weights: {
      39021: 23.2,
      39091: 76.8,
    },
    county_names_all: "Logan|Champaign",
    county_fips_all: "39091|39021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43344,
    lat: 40.43219,
    lng: -83.33832,
    city: "Richwood",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6280,
    density: 24.7,
    county_fips: 39159,
    county_name: "Union",
    county_weights: {
      39041: 4.73,
      39101: 0.87,
      39159: 94.4,
    },
    county_names_all: "Union|Delaware|Marion",
    county_fips_all: "39159|39041|39101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43345,
    lat: 40.51341,
    lng: -83.58167,
    city: "Ridgeway",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1013,
    density: 13.7,
    county_fips: 39091,
    county_name: "Logan",
    county_weights: {
      39065: 46.51,
      39091: 53.08,
      39159: 0.41,
    },
    county_names_all: "Logan|Hardin|Union",
    county_fips_all: "39091|39065|39159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43346,
    lat: 40.5768,
    lng: -83.84518,
    city: "Roundhead",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39065,
    county_name: "Hardin",
    county_weights: {
      39065: 100,
    },
    county_names_all: "Hardin",
    county_fips_all: 39065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43347,
    lat: 40.47771,
    lng: -83.65804,
    city: "Rushsylvania",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1344,
    density: 16.9,
    county_fips: 39091,
    county_name: "Logan",
    county_weights: {
      39065: 10.25,
      39091: 89.75,
    },
    county_names_all: "Logan|Hardin",
    county_fips_all: "39091|39065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43348,
    lat: 40.46754,
    lng: -83.88857,
    city: "Russells Point",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2062,
    density: 343.6,
    county_fips: 39091,
    county_name: "Logan",
    county_weights: {
      39091: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 39091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43350,
    lat: 40.39557,
    lng: -82.69977,
    city: "Sparta",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39117,
    county_name: "Morrow",
    county_weights: {
      39117: 100,
    },
    county_names_all: "Morrow",
    county_fips_all: 39117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43351,
    lat: 40.82501,
    lng: -83.30424,
    city: "Upper Sandusky",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10678,
    density: 26.8,
    county_fips: 39175,
    county_name: "Wyandot",
    county_weights: {
      39175: 100,
    },
    county_names_all: "Wyandot",
    county_fips_all: 39175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43356,
    lat: 40.45748,
    lng: -83.04788,
    city: "Waldo",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1212,
    density: 22.6,
    county_fips: 39101,
    county_name: "Marion",
    county_weights: {
      39041: 17.66,
      39101: 72.56,
      39117: 9.78,
    },
    county_names_all: "Marion|Delaware|Morrow",
    county_fips_all: "39101|39041|39117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43357,
    lat: 40.25316,
    lng: -83.74711,
    city: "West Liberty",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4123,
    density: 23.4,
    county_fips: 39091,
    county_name: "Logan",
    county_weights: {
      39021: 43.74,
      39091: 56.26,
    },
    county_names_all: "Logan|Champaign",
    county_fips_all: "39091|39021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43358,
    lat: 40.41898,
    lng: -83.53129,
    city: "West Mansfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2838,
    density: 18,
    county_fips: 39159,
    county_name: "Union",
    county_weights: {
      39091: 48.3,
      39159: 51.7,
    },
    county_names_all: "Union|Logan",
    county_fips_all: "39159|39091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43359,
    lat: 40.86977,
    lng: -83.45319,
    city: "Wharton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 814,
    density: 14.5,
    county_fips: 39175,
    county_name: "Wyandot",
    county_weights: {
      39175: 100,
    },
    county_names_all: "Wyandot",
    county_fips_all: 39175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43360,
    lat: 40.33272,
    lng: -83.63114,
    city: "Zanesfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1642,
    density: 21,
    county_fips: 39091,
    county_name: "Logan",
    county_weights: {
      39091: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 39091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43402,
    lat: 41.40957,
    lng: -83.65389,
    city: "Bowling Green",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32864,
    density: 114.7,
    county_fips: 39173,
    county_name: "Wood",
    county_weights: {
      39173: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 39173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43403,
    lat: 41.37784,
    lng: -83.63653,
    city: "Bowling Green",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5036,
    density: 6229.3,
    county_fips: 39173,
    county_name: "Wood",
    county_weights: {
      39173: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 39173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43406,
    lat: 41.33605,
    lng: -83.4372,
    city: "Bradner",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1869,
    density: 38.4,
    county_fips: 39173,
    county_name: "Wood",
    county_weights: {
      39143: 16.51,
      39173: 83.49,
    },
    county_names_all: "Wood|Sandusky",
    county_fips_all: "39173|39143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43407,
    lat: 41.27717,
    lng: -83.24994,
    city: "Burgoon",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 518,
    density: 13.6,
    county_fips: 39143,
    county_name: "Sandusky",
    county_weights: {
      39143: 99.82,
      39147: 0.18,
    },
    county_names_all: "Sandusky|Seneca",
    county_fips_all: "39143|39147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43408,
    lat: 41.57179,
    lng: -83.36352,
    city: "Clay Center",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 398,
    density: 233.7,
    county_fips: 39123,
    county_name: "Ottawa",
    county_weights: {
      39123: 100,
    },
    county_names_all: "Ottawa",
    county_fips_all: 39123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43410,
    lat: 41.30792,
    lng: -82.95807,
    city: "Clyde",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9681,
    density: 72.7,
    county_fips: 39143,
    county_name: "Sandusky",
    county_weights: {
      39143: 90.96,
      39147: 9.04,
    },
    county_names_all: "Sandusky|Seneca",
    county_fips_all: "39143|39147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43412,
    lat: 41.62933,
    lng: -83.31961,
    city: "Curtice",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4218,
    density: 58.9,
    county_fips: 39095,
    county_name: "Lucas",
    county_weights: {
      39095: 61.64,
      39123: 38.36,
    },
    county_names_all: "Lucas|Ottawa",
    county_fips_all: "39095|39123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43413,
    lat: 41.24205,
    lng: -83.65476,
    city: "Cygnet",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 993,
    density: 11.5,
    county_fips: 39173,
    county_name: "Wood",
    county_weights: {
      39173: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 39173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43414,
    lat: 41.45165,
    lng: -83.61724,
    city: "Dunbridge",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39173,
    county_name: "Wood",
    county_weights: {
      39173: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 39173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43416,
    lat: 41.48532,
    lng: -83.27055,
    city: "Elmore",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3121,
    density: 42.7,
    county_fips: 39123,
    county_name: "Ottawa",
    county_weights: {
      39123: 85.72,
      39143: 14.28,
    },
    county_names_all: "Ottawa|Sandusky",
    county_fips_all: "39123|39143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43420,
    lat: 41.35749,
    lng: -83.11265,
    city: "Fremont",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29761,
    density: 84.3,
    county_fips: 39143,
    county_name: "Sandusky",
    county_weights: {
      39123: 0.19,
      39143: 99.81,
    },
    county_names_all: "Sandusky|Ottawa",
    county_fips_all: "39143|39123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43430,
    lat: 41.5238,
    lng: -83.37329,
    city: "Genoa",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4786,
    density: 72.2,
    county_fips: 39123,
    county_name: "Ottawa",
    county_weights: {
      39123: 79.07,
      39143: 7.43,
      39173: 13.5,
    },
    county_names_all: "Ottawa|Wood|Sandusky",
    county_fips_all: "39123|39173|39143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43431,
    lat: 41.38998,
    lng: -83.33964,
    city: "Gibsonburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4855,
    density: 37.5,
    county_fips: 39143,
    county_name: "Sandusky",
    county_weights: {
      39143: 97.44,
      39173: 2.56,
    },
    county_names_all: "Sandusky|Wood",
    county_fips_all: "39143|39173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43432,
    lat: 41.56115,
    lng: -83.24934,
    city: "Graytown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1359,
    density: 24.1,
    county_fips: 39123,
    county_name: "Ottawa",
    county_weights: {
      39123: 100,
    },
    county_names_all: "Ottawa",
    county_fips_all: 39123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43433,
    lat: 41.50463,
    lng: -82.88033,
    city: "Gypsum",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54,
    density: 42.5,
    county_fips: 39123,
    county_name: "Ottawa",
    county_weights: {
      39123: 100,
    },
    county_names_all: "Ottawa",
    county_fips_all: 39123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43434,
    lat: 41.69319,
    lng: -83.44474,
    city: "Harbor View",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 156,
    density: 2576.9,
    county_fips: 39095,
    county_name: "Lucas",
    county_weights: {
      39095: 100,
    },
    county_names_all: "Lucas",
    county_fips_all: 39095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43435,
    lat: 41.32634,
    lng: -83.31197,
    city: "Helena",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1196,
    density: 13.2,
    county_fips: 39143,
    county_name: "Sandusky",
    county_weights: {
      39143: 100,
    },
    county_names_all: "Sandusky",
    county_fips_all: 39143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43436,
    lat: 41.71522,
    lng: -82.82098,
    city: "Isle Saint George",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39123,
    county_name: "Ottawa",
    county_weights: {
      39123: 100,
    },
    county_names_all: "Ottawa",
    county_fips_all: 39123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43437,
    lat: 41.25396,
    lng: -83.60176,
    city: "Jerry City",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 585,
    density: 239,
    county_fips: 39173,
    county_name: "Wood",
    county_weights: {
      39173: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 39173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43438,
    lat: 41.60343,
    lng: -82.70268,
    city: "Kelleys Island",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 283,
    density: 25.1,
    county_fips: 39043,
    county_name: "Erie",
    county_weights: {
      39043: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 39043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43439,
    lat: 41.51758,
    lng: -83.04275,
    city: "Lacarne",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53,
    density: 965.6,
    county_fips: 39123,
    county_name: "Ottawa",
    county_weights: {
      39123: 100,
    },
    county_names_all: "Ottawa",
    county_fips_all: 39123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43440,
    lat: 41.52662,
    lng: -82.78145,
    city: "Lakeside Marblehead",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4309,
    density: 104.7,
    county_fips: 39123,
    county_name: "Ottawa",
    county_weights: {
      39123: 100,
    },
    county_names_all: "Ottawa",
    county_fips_all: 39123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43442,
    lat: 41.42911,
    lng: -83.21496,
    city: "Lindsey",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 781,
    density: 17.2,
    county_fips: 39143,
    county_name: "Sandusky",
    county_weights: {
      39123: 4.04,
      39143: 95.96,
    },
    county_names_all: "Sandusky|Ottawa",
    county_fips_all: "39143|39123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43443,
    lat: 41.46099,
    lng: -83.46906,
    city: "Luckey",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1778,
    density: 55.5,
    county_fips: 39173,
    county_name: "Wood",
    county_weights: {
      39173: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 39173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43445,
    lat: 41.58644,
    lng: -83.29488,
    city: "Martin",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 959,
    density: 18.2,
    county_fips: 39123,
    county_name: "Ottawa",
    county_weights: {
      39095: 17.98,
      39123: 82.02,
    },
    county_names_all: "Ottawa|Lucas",
    county_fips_all: "39123|39095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43446,
    lat: 41.68483,
    lng: -82.80863,
    city: "Middle Bass",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74,
    density: 22.7,
    county_fips: 39123,
    county_name: "Ottawa",
    county_weights: {
      39123: 100,
    },
    county_names_all: "Ottawa",
    county_fips_all: 39123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43447,
    lat: 41.56654,
    lng: -83.43429,
    city: "Millbury",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3229,
    density: 71.9,
    county_fips: 39173,
    county_name: "Wood",
    county_weights: {
      39123: 30.03,
      39173: 69.97,
    },
    county_names_all: "Wood|Ottawa",
    county_fips_all: "39173|39123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43449,
    lat: 41.5357,
    lng: -83.14151,
    city: "Oak Harbor",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8321,
    density: 38.3,
    county_fips: 39123,
    county_name: "Ottawa",
    county_weights: {
      39123: 97.63,
      39143: 2.37,
    },
    county_names_all: "Ottawa|Sandusky",
    county_fips_all: "39123|39143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43450,
    lat: 41.40013,
    lng: -83.49324,
    city: "Pemberville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3539,
    density: 33.5,
    county_fips: 39173,
    county_name: "Wood",
    county_weights: {
      39173: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 39173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43451,
    lat: 41.31551,
    lng: -83.61614,
    city: "Portage",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1177,
    density: 18.3,
    county_fips: 39173,
    county_name: "Wood",
    county_weights: {
      39173: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 39173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43452,
    lat: 41.51568,
    lng: -82.96522,
    city: "Port Clinton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13966,
    density: 116.7,
    county_fips: 39123,
    county_name: "Ottawa",
    county_weights: {
      39123: 100,
    },
    county_names_all: "Ottawa",
    county_fips_all: 39123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43456,
    lat: 41.64934,
    lng: -82.82497,
    city: "Put In Bay",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 445,
    density: 67.9,
    county_fips: 39123,
    county_name: "Ottawa",
    county_weights: {
      39123: 100,
    },
    county_names_all: "Ottawa",
    county_fips_all: 39123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43457,
    lat: 41.26788,
    lng: -83.42508,
    city: "Risingsun",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1628,
    density: 32.9,
    county_fips: 39173,
    county_name: "Wood",
    county_weights: {
      39143: 37.6,
      39147: 6.27,
      39173: 56.13,
    },
    county_names_all: "Wood|Sandusky|Seneca",
    county_fips_all: "39173|39143|39147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43458,
    lat: 41.53105,
    lng: -83.21258,
    city: "Rocky Ridge",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 405,
    density: 157.4,
    county_fips: 39123,
    county_name: "Ottawa",
    county_weights: {
      39123: 100,
    },
    county_names_all: "Ottawa",
    county_fips_all: 39123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43460,
    lat: 41.60392,
    lng: -83.56328,
    city: "Rossford",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6483,
    density: 963,
    county_fips: 39173,
    county_name: "Wood",
    county_weights: {
      39173: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 39173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43462,
    lat: 41.28352,
    lng: -83.71887,
    city: "Rudolph",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1243,
    density: 18.8,
    county_fips: 39173,
    county_name: "Wood",
    county_weights: {
      39173: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 39173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43463,
    lat: 41.51141,
    lng: -83.50511,
    city: "Stony Ridge",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39173,
    county_name: "Wood",
    county_weights: {
      39173: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 39173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43464,
    lat: 41.40318,
    lng: -82.93116,
    city: "Vickery",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1861,
    density: 21.8,
    county_fips: 39143,
    county_name: "Sandusky",
    county_weights: {
      39043: 5.81,
      39143: 94.19,
    },
    county_names_all: "Sandusky|Erie",
    county_fips_all: "39143|39043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43465,
    lat: 41.56593,
    lng: -83.50489,
    city: "Walbridge",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5259,
    density: 165.6,
    county_fips: 39173,
    county_name: "Wood",
    county_weights: {
      39173: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 39173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43466,
    lat: 41.29234,
    lng: -83.51394,
    city: "Wayne",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2424,
    density: 33.1,
    county_fips: 39173,
    county_name: "Wood",
    county_weights: {
      39173: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 39173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43467,
    lat: 41.24328,
    lng: -83.49098,
    city: "West Millgrove",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 90,
    density: 160.7,
    county_fips: 39173,
    county_name: "Wood",
    county_weights: {
      39173: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 39173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43468,
    lat: 41.59974,
    lng: -83.34661,
    city: "Williston",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 426,
    density: 100.1,
    county_fips: 39123,
    county_name: "Ottawa",
    county_weights: {
      39123: 100,
    },
    county_names_all: "Ottawa",
    county_fips_all: 39123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43469,
    lat: 41.45947,
    lng: -83.36474,
    city: "Woodville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2901,
    density: 48.8,
    county_fips: 39143,
    county_name: "Sandusky",
    county_weights: {
      39123: 8.16,
      39143: 91.84,
    },
    county_names_all: "Sandusky|Ottawa",
    county_fips_all: "39143|39123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43501,
    lat: 41.66966,
    lng: -84.46095,
    city: "Alvordton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1002,
    density: 14.6,
    county_fips: 39171,
    county_name: "Williams",
    county_weights: {
      39171: 100,
    },
    county_names_all: "Williams",
    county_fips_all: 39171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43502,
    lat: 41.53181,
    lng: -84.30201,
    city: "Archbold",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6342,
    density: 33.6,
    county_fips: 39051,
    county_name: "Fulton",
    county_weights: {
      39051: 77.62,
      39069: 20.19,
      39171: 2.19,
    },
    county_names_all: "Fulton|Henry|Williams",
    county_fips_all: "39051|39069|39171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43504,
    lat: 41.69736,
    lng: -83.8369,
    city: "Berkey",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1077,
    density: 27.5,
    county_fips: 39095,
    county_name: "Lucas",
    county_weights: {
      39051: 2.88,
      39095: 97.12,
    },
    county_names_all: "Lucas|Fulton",
    county_fips_all: "39095|39051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43505,
    lat: 41.52429,
    lng: -84.73101,
    city: "Blakeslee",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 94,
    density: 412.9,
    county_fips: 39171,
    county_name: "Williams",
    county_weights: {
      39171: 100,
    },
    county_names_all: "Williams",
    county_fips_all: 39171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43506,
    lat: 41.46739,
    lng: -84.55704,
    city: "Bryan",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14045,
    density: 52.4,
    county_fips: 39171,
    county_name: "Williams",
    county_weights: {
      39039: 17.83,
      39171: 82.17,
    },
    county_names_all: "Williams|Defiance",
    county_fips_all: "39171|39039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43510,
    lat: 41.46484,
    lng: -83.94712,
    city: "Colton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39069,
    county_name: "Henry",
    county_weights: {
      39069: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 39069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43511,
    lat: 41.26384,
    lng: -83.82376,
    city: "Custar",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1199,
    density: 10.5,
    county_fips: 39173,
    county_name: "Wood",
    county_weights: {
      39069: 6.46,
      39173: 93.54,
    },
    county_names_all: "Wood|Henry",
    county_fips_all: "39173|39069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43512,
    lat: 41.30309,
    lng: -84.35874,
    city: "Defiance",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28172,
    density: 50,
    county_fips: 39039,
    county_name: "Defiance",
    county_weights: {
      39039: 92.95,
      39069: 1.02,
      39125: 6.03,
    },
    county_names_all: "Defiance|Paulding|Henry",
    county_fips_all: "39039|39125|39069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43515,
    lat: 41.58656,
    lng: -84.00746,
    city: "Delta",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7374,
    density: 34.8,
    county_fips: 39051,
    county_name: "Fulton",
    county_weights: {
      39051: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 39051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43516,
    lat: 41.21579,
    lng: -83.91081,
    city: "Deshler",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2911,
    density: 15.5,
    county_fips: 39069,
    county_name: "Henry",
    county_weights: {
      39063: 3.68,
      39069: 67.72,
      39137: 1.33,
      39173: 27.27,
    },
    county_names_all: "Henry|Wood|Hancock|Putnam",
    county_fips_all: "39069|39173|39063|39137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43517,
    lat: 41.44003,
    lng: -84.72833,
    city: "Edgerton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3855,
    density: 23.3,
    county_fips: 39171,
    county_name: "Williams",
    county_weights: {
      39039: 40.47,
      39171: 59.53,
    },
    county_names_all: "Williams|Defiance",
    county_fips_all: "39171|39039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43518,
    lat: 41.58977,
    lng: -84.75385,
    city: "Edon",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2976,
    density: 16.8,
    county_fips: 39171,
    county_name: "Williams",
    county_weights: {
      39171: 100,
    },
    county_names_all: "Williams",
    county_fips_all: 39171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43519,
    lat: 41.42092,
    lng: -84.40854,
    city: "Evansport",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 207,
    density: 62.2,
    county_fips: 39039,
    county_name: "Defiance",
    county_weights: {
      39039: 100,
    },
    county_names_all: "Defiance",
    county_fips_all: 39039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43520,
    lat: 41.38008,
    lng: -84.63565,
    city: "Farmer",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39039,
    county_name: "Defiance",
    county_weights: {
      39039: 100,
    },
    county_names_all: "Defiance",
    county_fips_all: 39039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43521,
    lat: 41.66377,
    lng: -84.29717,
    city: "Fayette",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3039,
    density: 17.7,
    county_fips: 39051,
    county_name: "Fulton",
    county_weights: {
      39051: 97.54,
      39171: 2.46,
    },
    county_names_all: "Fulton|Williams",
    county_fips_all: "39051|39171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43522,
    lat: 41.42058,
    lng: -83.84352,
    city: "Grand Rapids",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3382,
    density: 41.9,
    county_fips: 39173,
    county_name: "Wood",
    county_weights: {
      39069: 0.54,
      39095: 43.2,
      39173: 56.26,
    },
    county_names_all: "Wood|Lucas|Henry",
    county_fips_all: "39173|39095|39069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43523,
    lat: 41.33875,
    lng: -83.99865,
    city: "Grelton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18,
    density: 2.3,
    county_fips: 39069,
    county_name: "Henry",
    county_weights: {
      39069: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 39069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43524,
    lat: 41.22839,
    lng: -84.039,
    city: "Hamler",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1073,
    density: 13,
    county_fips: 39069,
    county_name: "Henry",
    county_weights: {
      39069: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 39069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43525,
    lat: 41.46663,
    lng: -83.70098,
    city: "Haskins",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1079,
    density: 519.8,
    county_fips: 39173,
    county_name: "Wood",
    county_weights: {
      39173: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 39173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43526,
    lat: 41.31339,
    lng: -84.73024,
    city: "Hicksville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5854,
    density: 29.7,
    county_fips: 39039,
    county_name: "Defiance",
    county_weights: {
      39039: 93.11,
      39125: 6.89,
    },
    county_names_all: "Defiance|Paulding",
    county_fips_all: "39039|39125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43527,
    lat: 41.25121,
    lng: -84.1593,
    city: "Holgate",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2249,
    density: 17.2,
    county_fips: 39069,
    county_name: "Henry",
    county_weights: {
      39039: 8.6,
      39069: 91.4,
    },
    county_names_all: "Henry|Defiance",
    county_fips_all: "39069|39039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43528,
    lat: 41.62908,
    lng: -83.74923,
    city: "Holland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16302,
    density: 336.6,
    county_fips: 39095,
    county_name: "Lucas",
    county_weights: {
      39095: 100,
    },
    county_names_all: "Lucas",
    county_fips_all: 39095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43529,
    lat: 41.18998,
    lng: -83.78431,
    city: "Hoytville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 295,
    density: 153.6,
    county_fips: 39173,
    county_name: "Wood",
    county_weights: {
      39173: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 39173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43530,
    lat: 41.32794,
    lng: -84.28933,
    city: "Jewell",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39039,
    county_name: "Defiance",
    county_weights: {
      39039: 100,
    },
    county_names_all: "Defiance",
    county_fips_all: 39039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43531,
    lat: 41.63511,
    lng: -84.4957,
    city: "Kunkle",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 352,
    density: 788.3,
    county_fips: 39171,
    county_name: "Williams",
    county_weights: {
      39171: 100,
    },
    county_names_all: "Williams",
    county_fips_all: 39171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43532,
    lat: 41.45486,
    lng: -83.97008,
    city: "Liberty Center",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4110,
    density: 35.1,
    county_fips: 39069,
    county_name: "Henry",
    county_weights: {
      39051: 3.49,
      39069: 94.37,
      39095: 2.14,
    },
    county_names_all: "Henry|Fulton|Lucas",
    county_fips_all: "39069|39051|39095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43533,
    lat: 41.69335,
    lng: -84.07997,
    city: "Lyons",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1666,
    density: 27.6,
    county_fips: 39051,
    county_name: "Fulton",
    county_weights: {
      39051: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 39051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43534,
    lat: 41.35446,
    lng: -83.92914,
    city: "McClure",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1770,
    density: 19,
    county_fips: 39069,
    county_name: "Henry",
    county_weights: {
      39069: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 39069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43535,
    lat: 41.30592,
    lng: -84.02416,
    city: "Malinta",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 554,
    density: 9.1,
    county_fips: 39069,
    county_name: "Henry",
    county_weights: {
      39069: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 39069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43536,
    lat: 41.31345,
    lng: -84.634,
    city: "Mark Center",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 167,
    density: 3.8,
    county_fips: 39039,
    county_name: "Defiance",
    county_weights: {
      39039: 100,
    },
    county_names_all: "Defiance",
    county_fips_all: 39039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43537,
    lat: 41.57433,
    lng: -83.68542,
    city: "Maumee",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28762,
    density: 597.5,
    county_fips: 39095,
    county_name: "Lucas",
    county_weights: {
      39095: 100,
    },
    county_names_all: "Lucas",
    county_fips_all: 39095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43540,
    lat: 41.69545,
    lng: -83.943,
    city: "Metamora",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1315,
    density: 28.1,
    county_fips: 39051,
    county_name: "Fulton",
    county_weights: {
      39051: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 39051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43541,
    lat: 41.30075,
    lng: -83.82953,
    city: "Milton Center",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 135,
    density: 131,
    county_fips: 39173,
    county_name: "Wood",
    county_weights: {
      39173: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 39173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43542,
    lat: 41.56642,
    lng: -83.76531,
    city: "Monclova",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3266,
    density: 84.6,
    county_fips: 39095,
    county_name: "Lucas",
    county_weights: {
      39095: 100,
    },
    county_names_all: "Lucas",
    county_fips_all: 39095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43543,
    lat: 41.60575,
    lng: -84.6338,
    city: "Montpelier",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7413,
    density: 33.8,
    county_fips: 39171,
    county_name: "Williams",
    county_weights: {
      39171: 100,
    },
    county_names_all: "Williams",
    county_fips_all: 39171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43545,
    lat: 41.39163,
    lng: -84.12719,
    city: "Napoleon",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13894,
    density: 39.7,
    county_fips: 39069,
    county_name: "Henry",
    county_weights: {
      39039: 0.94,
      39069: 99.06,
    },
    county_names_all: "Henry|Defiance",
    county_fips_all: "39069|39039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43547,
    lat: 41.49214,
    lng: -83.87634,
    city: "Neapolis",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 529,
    density: 471.5,
    county_fips: 39095,
    county_name: "Lucas",
    county_weights: {
      39095: 100,
    },
    county_names_all: "Lucas",
    county_fips_all: 39095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43548,
    lat: 41.18867,
    lng: -84.17296,
    city: "New Bavaria",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 708,
    density: 11.1,
    county_fips: 39069,
    county_name: "Henry",
    county_weights: {
      39039: 12.31,
      39069: 86.39,
      39137: 1.3,
    },
    county_names_all: "Henry|Defiance|Putnam",
    county_fips_all: "39069|39039|39137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43549,
    lat: 41.37519,
    lng: -84.51818,
    city: "Ney",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1280,
    density: 16.8,
    county_fips: 39039,
    county_name: "Defiance",
    county_weights: {
      39039: 100,
    },
    county_names_all: "Defiance",
    county_fips_all: 39039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43551,
    lat: 41.52095,
    lng: -83.57503,
    city: "Perrysburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39280,
    density: 195.3,
    county_fips: 39173,
    county_name: "Wood",
    county_weights: {
      39173: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 39173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43553,
    lat: 41.53096,
    lng: -84.22382,
    city: "Pettisville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 300,
    density: 384.1,
    county_fips: 39051,
    county_name: "Fulton",
    county_weights: {
      39051: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 39051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43554,
    lat: 41.66024,
    lng: -84.56239,
    city: "Pioneer",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2271,
    density: 25.5,
    county_fips: 39171,
    county_name: "Williams",
    county_weights: {
      39171: 100,
    },
    county_names_all: "Williams",
    county_fips_all: 39171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43555,
    lat: 41.43772,
    lng: -84.25596,
    city: "Ridgeville Corners",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 194,
    density: 112.7,
    county_fips: 39069,
    county_name: "Henry",
    county_weights: {
      39069: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 39069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43556,
    lat: 41.30575,
    lng: -84.56984,
    city: "Sherwood",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1863,
    density: 22.5,
    county_fips: 39039,
    county_name: "Defiance",
    county_weights: {
      39039: 100,
    },
    county_names_all: "Defiance",
    county_fips_all: 39039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43557,
    lat: 41.48354,
    lng: -84.39693,
    city: "Stryker",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3239,
    density: 29.9,
    county_fips: 39171,
    county_name: "Williams",
    county_weights: {
      39051: 1.51,
      39069: 6.32,
      39171: 92.17,
    },
    county_names_all: "Williams|Henry|Fulton",
    county_fips_all: "39171|39069|39051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43558,
    lat: 41.5935,
    lng: -83.8781,
    city: "Swanton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13742,
    density: 63.7,
    county_fips: 39051,
    county_name: "Fulton",
    county_weights: {
      39051: 51.18,
      39095: 48.82,
    },
    county_names_all: "Fulton|Lucas",
    county_fips_all: "39051|39095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43560,
    lat: 41.70067,
    lng: -83.73799,
    city: "Sylvania",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31967,
    density: 582.3,
    county_fips: 39095,
    county_name: "Lucas",
    county_weights: {
      39095: 100,
    },
    county_names_all: "Lucas",
    county_fips_all: 39095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43565,
    lat: 41.42044,
    lng: -83.74011,
    city: "Tontogany",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 406,
    density: 952.3,
    county_fips: 39173,
    county_name: "Wood",
    county_weights: {
      39173: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 39173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43566,
    lat: 41.49467,
    lng: -83.75838,
    city: "Waterville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7952,
    density: 167.1,
    county_fips: 39095,
    county_name: "Lucas",
    county_weights: {
      39095: 100,
    },
    county_names_all: "Lucas",
    county_fips_all: 39095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43567,
    lat: 41.57592,
    lng: -84.15248,
    city: "Wauseon",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13105,
    density: 44.3,
    county_fips: 39051,
    county_name: "Fulton",
    county_weights: {
      39051: 98.51,
      39069: 1.49,
    },
    county_names_all: "Fulton|Henry",
    county_fips_all: "39051|39069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43569,
    lat: 41.3513,
    lng: -83.78844,
    city: "Weston",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3069,
    density: 33.6,
    county_fips: 39173,
    county_name: "Wood",
    county_weights: {
      39173: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 39173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43570,
    lat: 41.58616,
    lng: -84.44116,
    city: "West Unity",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3217,
    density: 27.7,
    county_fips: 39171,
    county_name: "Williams",
    county_weights: {
      39051: 6.91,
      39171: 93.09,
    },
    county_names_all: "Williams|Fulton",
    county_fips_all: "39171|39051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43571,
    lat: 41.51574,
    lng: -83.81796,
    city: "Whitehouse",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6741,
    density: 118.6,
    county_fips: 39095,
    county_name: "Lucas",
    county_weights: {
      39095: 100,
    },
    county_names_all: "Lucas",
    county_fips_all: 39095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43604,
    lat: 41.65217,
    lng: -83.53977,
    city: "Toledo",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9386,
    density: 1286.4,
    county_fips: 39095,
    county_name: "Lucas",
    county_weights: {
      39095: 100,
    },
    county_names_all: "Lucas",
    county_fips_all: 39095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43605,
    lat: 41.64734,
    lng: -83.50722,
    city: "Toledo",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25843,
    density: 1391.2,
    county_fips: 39095,
    county_name: "Lucas",
    county_weights: {
      39095: 98.65,
      39173: 1.35,
    },
    county_names_all: "Lucas|Wood",
    county_fips_all: "39095|39173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43606,
    lat: 41.67178,
    lng: -83.61085,
    city: "Toledo",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25582,
    density: 1531.2,
    county_fips: 39095,
    county_name: "Lucas",
    county_weights: {
      39095: 100,
    },
    county_names_all: "Lucas",
    county_fips_all: 39095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43607,
    lat: 41.64761,
    lng: -83.60582,
    city: "Toledo",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19920,
    density: 1061.6,
    county_fips: 39095,
    county_name: "Lucas",
    county_weights: {
      39095: 100,
    },
    county_names_all: "Lucas",
    county_fips_all: 39095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43608,
    lat: 41.68008,
    lng: -83.53062,
    city: "Toledo",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14326,
    density: 1666.9,
    county_fips: 39095,
    county_name: "Lucas",
    county_weights: {
      39095: 100,
    },
    county_names_all: "Lucas",
    county_fips_all: 39095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43609,
    lat: 41.62849,
    lng: -83.57824,
    city: "Toledo",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21296,
    density: 1705.8,
    county_fips: 39095,
    county_name: "Lucas",
    county_weights: {
      39095: 100,
    },
    county_names_all: "Lucas",
    county_fips_all: 39095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43610,
    lat: 41.67775,
    lng: -83.5614,
    city: "Toledo",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4277,
    density: 1330,
    county_fips: 39095,
    county_name: "Lucas",
    county_weights: {
      39095: 100,
    },
    county_names_all: "Lucas",
    county_fips_all: 39095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43611,
    lat: 41.70241,
    lng: -83.49154,
    city: "Toledo",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19018,
    density: 1004.2,
    county_fips: 39095,
    county_name: "Lucas",
    county_weights: {
      39095: 100,
    },
    county_names_all: "Lucas",
    county_fips_all: 39095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43612,
    lat: 41.70946,
    lng: -83.54899,
    city: "Toledo",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29445,
    density: 986.6,
    county_fips: 39095,
    county_name: "Lucas",
    county_weights: {
      39095: 100,
    },
    county_names_all: "Lucas",
    county_fips_all: 39095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43613,
    lat: 41.70628,
    lng: -83.60374,
    city: "Toledo",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32811,
    density: 2068.2,
    county_fips: 39095,
    county_name: "Lucas",
    county_weights: {
      39095: 100,
    },
    county_names_all: "Lucas",
    county_fips_all: 39095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43614,
    lat: 41.60336,
    lng: -83.62715,
    city: "Toledo",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29983,
    density: 1288.8,
    county_fips: 39095,
    county_name: "Lucas",
    county_weights: {
      39095: 100,
    },
    county_names_all: "Lucas",
    county_fips_all: 39095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43615,
    lat: 41.65045,
    lng: -83.67255,
    city: "Toledo",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39957,
    density: 935.9,
    county_fips: 39095,
    county_name: "Lucas",
    county_weights: {
      39095: 100,
    },
    county_names_all: "Lucas",
    county_fips_all: 39095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43616,
    lat: 41.65727,
    lng: -83.40931,
    city: "Oregon",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20455,
    density: 205.4,
    county_fips: 39095,
    county_name: "Lucas",
    county_weights: {
      39095: 100,
    },
    county_names_all: "Lucas",
    county_fips_all: 39095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43617,
    lat: 41.66416,
    lng: -83.72808,
    city: "Toledo",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7662,
    density: 564.9,
    county_fips: 39095,
    county_name: "Lucas",
    county_weights: {
      39095: 100,
    },
    county_names_all: "Lucas",
    county_fips_all: 39095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43619,
    lat: 41.60424,
    lng: -83.47348,
    city: "Northwood",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7379,
    density: 244.7,
    county_fips: 39173,
    county_name: "Wood",
    county_weights: {
      39173: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 39173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43620,
    lat: 41.66519,
    lng: -83.5547,
    city: "Toledo",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5386,
    density: 1937.3,
    county_fips: 39095,
    county_name: "Lucas",
    county_weights: {
      39095: 100,
    },
    county_names_all: "Lucas",
    county_fips_all: 39095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43623,
    lat: 41.70419,
    lng: -83.65095,
    city: "Toledo",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19457,
    density: 1123.1,
    county_fips: 39095,
    county_name: "Lucas",
    county_weights: {
      39095: 100,
    },
    county_names_all: "Lucas",
    county_fips_all: 39095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43701,
    lat: 39.95986,
    lng: -81.99498,
    city: "Zanesville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55231,
    density: 118.1,
    county_fips: 39119,
    county_name: "Muskingum",
    county_weights: {
      39119: 100,
    },
    county_names_all: "Muskingum",
    county_fips_all: 39119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43711,
    lat: 39.84262,
    lng: -81.57738,
    city: "Ava",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 66,
    density: 137,
    county_fips: 39121,
    county_name: "Noble",
    county_weights: {
      39121: 100,
    },
    county_names_all: "Noble",
    county_fips_all: 39121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43713,
    lat: 39.98979,
    lng: -81.17368,
    city: "Barnesville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6715,
    density: 28.5,
    county_fips: 39013,
    county_name: "Belmont",
    county_weights: {
      39013: 100,
    },
    county_names_all: "Belmont",
    county_fips_all: 39013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43716,
    lat: 39.83683,
    lng: -81.00752,
    city: "Beallsville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1900,
    density: 11.3,
    county_fips: 39111,
    county_name: "Monroe",
    county_weights: {
      39013: 27.64,
      39111: 72.36,
    },
    county_names_all: "Monroe|Belmont",
    county_fips_all: "39111|39013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43717,
    lat: 39.78943,
    lng: -81.5548,
    city: "Belle Valley",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 142,
    density: 192.4,
    county_fips: 39121,
    county_name: "Noble",
    county_weights: {
      39121: 100,
    },
    county_names_all: "Noble",
    county_fips_all: 39121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43718,
    lat: 40.00926,
    lng: -81.00596,
    city: "Belmont",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2672,
    density: 17.9,
    county_fips: 39013,
    county_name: "Belmont",
    county_weights: {
      39013: 100,
    },
    county_names_all: "Belmont",
    county_fips_all: 39013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43719,
    lat: 39.98907,
    lng: -81.07938,
    city: "Bethesda",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2747,
    density: 31.7,
    county_fips: 39013,
    county_name: "Belmont",
    county_weights: {
      39013: 100,
    },
    county_names_all: "Belmont",
    county_fips_all: 39013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43720,
    lat: 39.79272,
    lng: -81.86886,
    city: "Blue Rock",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1217,
    density: 9.8,
    county_fips: 39119,
    county_name: "Muskingum",
    county_weights: {
      39115: 7.32,
      39119: 92.68,
    },
    county_names_all: "Muskingum|Morgan",
    county_fips_all: "39119|39115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43721,
    lat: 39.94927,
    lng: -82.26015,
    city: "Brownsville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 237,
    density: 256.9,
    county_fips: 39089,
    county_name: "Licking",
    county_weights: {
      39089: 100,
    },
    county_names_all: "Licking",
    county_fips_all: 39089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43722,
    lat: 39.91933,
    lng: -81.52001,
    city: "Buffalo",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 636,
    density: 502.8,
    county_fips: 39059,
    county_name: "Guernsey",
    county_weights: {
      39059: 100,
    },
    county_names_all: "Guernsey",
    county_fips_all: 39059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43723,
    lat: 39.96022,
    lng: -81.5412,
    city: "Byesville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5034,
    density: 123.8,
    county_fips: 39059,
    county_name: "Guernsey",
    county_weights: {
      39059: 100,
    },
    county_names_all: "Guernsey",
    county_fips_all: 39059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43724,
    lat: 39.73267,
    lng: -81.5166,
    city: "Caldwell",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9354,
    density: 23.2,
    county_fips: 39121,
    county_name: "Noble",
    county_weights: {
      39059: 0.23,
      39115: 5.81,
      39121: 93.96,
    },
    county_names_all: "Noble|Morgan|Guernsey",
    county_fips_all: "39121|39115|39059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43725,
    lat: 40.03949,
    lng: -81.59934,
    city: "Cambridge",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20002,
    density: 62.2,
    county_fips: 39059,
    county_name: "Guernsey",
    county_weights: {
      39059: 100,
    },
    county_names_all: "Guernsey",
    county_fips_all: 39059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43727,
    lat: 39.8714,
    lng: -81.79884,
    city: "Chandlersville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1054,
    density: 5.7,
    county_fips: 39119,
    county_name: "Muskingum",
    county_weights: {
      39119: 100,
    },
    county_names_all: "Muskingum",
    county_fips_all: 39119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43728,
    lat: 39.49188,
    lng: -81.89676,
    city: "Chesterhill",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1551,
    density: 16.4,
    county_fips: 39115,
    county_name: "Morgan",
    county_weights: {
      39009: 3.44,
      39115: 96.56,
    },
    county_names_all: "Morgan|Athens",
    county_fips_all: "39115|39009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43730,
    lat: 39.6294,
    lng: -82.09435,
    city: "Corning",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2610,
    density: 22.6,
    county_fips: 39127,
    county_name: "Perry",
    county_weights: {
      39127: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 39127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43731,
    lat: 39.72768,
    lng: -82.0675,
    city: "Crooksville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5068,
    density: 37.5,
    county_fips: 39127,
    county_name: "Perry",
    county_weights: {
      39115: 40.62,
      39127: 59.38,
    },
    county_names_all: "Perry|Morgan",
    county_fips_all: "39127|39115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43732,
    lat: 39.84409,
    lng: -81.65883,
    city: "Cumberland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1470,
    density: 7.2,
    county_fips: 39059,
    county_name: "Guernsey",
    county_weights: {
      39059: 44.05,
      39119: 22.37,
      39121: 33.58,
    },
    county_names_all: "Guernsey|Noble|Muskingum",
    county_fips_all: "39059|39121|39119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43733,
    lat: 39.92736,
    lng: -81.53807,
    city: "Derwent",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 79,
    density: 33,
    county_fips: 39059,
    county_name: "Guernsey",
    county_weights: {
      39059: 100,
    },
    county_names_all: "Guernsey",
    county_fips_all: 39059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43734,
    lat: 39.88144,
    lng: -81.90489,
    city: "Duncan Falls",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1962,
    density: 214.4,
    county_fips: 39119,
    county_name: "Muskingum",
    county_weights: {
      39119: 100,
    },
    county_names_all: "Muskingum",
    county_fips_all: 39119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43735,
    lat: 39.85437,
    lng: -82.11917,
    city: "East Fultonham",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 369,
    density: 205.8,
    county_fips: 39119,
    county_name: "Muskingum",
    county_weights: {
      39119: 100,
    },
    county_names_all: "Muskingum",
    county_fips_all: 39119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43736,
    lat: 40.05755,
    lng: -81.23689,
    city: "Fairview",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42,
    density: 394.5,
    county_fips: 39059,
    county_name: "Guernsey",
    county_weights: {
      39059: 100,
    },
    county_names_all: "Guernsey",
    county_fips_all: 39059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43738,
    lat: 39.8554,
    lng: -82.14063,
    city: "Fultonham",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 181,
    density: 1119.4,
    county_fips: 39119,
    county_name: "Muskingum",
    county_weights: {
      39119: 100,
    },
    county_names_all: "Muskingum",
    county_fips_all: 39119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43739,
    lat: 39.90693,
    lng: -82.29025,
    city: "Glenford",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2394,
    density: 26.5,
    county_fips: 39127,
    county_name: "Perry",
    county_weights: {
      39089: 36.3,
      39127: 63.7,
    },
    county_names_all: "Perry|Licking",
    county_fips_all: "39127|39089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43740,
    lat: 39.9515,
    lng: -82.21706,
    city: "Gratiot",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 239,
    density: 648.4,
    county_fips: 39089,
    county_name: "Licking",
    county_weights: {
      39089: 55.93,
      39119: 44.07,
    },
    county_names_all: "Licking|Muskingum",
    county_fips_all: "39089|39119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43746,
    lat: 39.97146,
    lng: -82.17287,
    city: "Hopewell",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1343,
    density: 28.9,
    county_fips: 39119,
    county_name: "Muskingum",
    county_weights: {
      39089: 7.89,
      39119: 92.11,
    },
    county_names_all: "Muskingum|Licking",
    county_fips_all: "39119|39089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43747,
    lat: 39.85784,
    lng: -81.12128,
    city: "Jerusalem",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 961,
    density: 10.2,
    county_fips: 39013,
    county_name: "Belmont",
    county_weights: {
      39013: 50.06,
      39111: 49.94,
    },
    county_names_all: "Belmont|Monroe",
    county_fips_all: "39013|39111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43748,
    lat: 39.69788,
    lng: -82.30899,
    city: "Junction City",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2866,
    density: 30.1,
    county_fips: 39127,
    county_name: "Perry",
    county_weights: {
      39127: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 39127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43749,
    lat: 40.15932,
    lng: -81.56411,
    city: "Kimbolton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1901,
    density: 6.9,
    county_fips: 39059,
    county_name: "Guernsey",
    county_weights: {
      39031: 12.62,
      39059: 86.99,
      39157: 0.39,
    },
    county_names_all: "Guernsey|Coshocton|Tuscarawas",
    county_fips_all: "39059|39031|39157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43750,
    lat: 39.99353,
    lng: -81.50975,
    city: "Kipling",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 151,
    density: 56.9,
    county_fips: 39059,
    county_name: "Guernsey",
    county_weights: {
      39059: 100,
    },
    county_names_all: "Guernsey",
    county_fips_all: 39059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43754,
    lat: 39.75586,
    lng: -81.24017,
    city: "Lewisville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1397,
    density: 7.5,
    county_fips: 39111,
    county_name: "Monroe",
    county_weights: {
      39111: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 39111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43755,
    lat: 40.0537,
    lng: -81.43318,
    city: "Lore City",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1893,
    density: 19,
    county_fips: 39059,
    county_name: "Guernsey",
    county_weights: {
      39059: 100,
    },
    county_names_all: "Guernsey",
    county_fips_all: 39059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43756,
    lat: 39.68993,
    lng: -81.79574,
    city: "Mcconnelsville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5007,
    density: 14,
    county_fips: 39115,
    county_name: "Morgan",
    county_weights: {
      39115: 98.64,
      39119: 1.36,
    },
    county_names_all: "Morgan|Muskingum",
    county_fips_all: "39115|39119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43758,
    lat: 39.62482,
    lng: -81.9432,
    city: "Malta",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3013,
    density: 13.7,
    county_fips: 39115,
    county_name: "Morgan",
    county_weights: {
      39115: 100,
    },
    county_names_all: "Morgan",
    county_fips_all: 39115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43759,
    lat: 40.06393,
    lng: -81.06942,
    city: "Morristown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 112,
    density: 70.3,
    county_fips: 39013,
    county_name: "Belmont",
    county_weights: {
      39013: 100,
    },
    county_names_all: "Belmont",
    county_fips_all: 39013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43760,
    lat: 39.8858,
    lng: -82.19577,
    city: "Mount Perry",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1215,
    density: 13.5,
    county_fips: 39127,
    county_name: "Perry",
    county_weights: {
      39089: 7.65,
      39119: 32.82,
      39127: 59.53,
    },
    county_names_all: "Perry|Muskingum|Licking",
    county_fips_all: "39127|39119|39089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43761,
    lat: 39.66829,
    lng: -82.14798,
    city: "Moxahala",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 96,
    density: 64.8,
    county_fips: 39127,
    county_name: "Perry",
    county_weights: {
      39127: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 39127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43762,
    lat: 40.03156,
    lng: -81.74007,
    city: "New Concord",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5723,
    density: 29.6,
    county_fips: 39119,
    county_name: "Muskingum",
    county_weights: {
      39059: 25.78,
      39119: 74.22,
    },
    county_names_all: "Muskingum|Guernsey",
    county_fips_all: "39119|39059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43764,
    lat: 39.71485,
    lng: -82.19239,
    city: "New Lexington",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8405,
    density: 53.4,
    county_fips: 39127,
    county_name: "Perry",
    county_weights: {
      39127: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 39127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43766,
    lat: 39.59492,
    lng: -82.2501,
    city: "New Straitsville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1483,
    density: 14.7,
    county_fips: 39127,
    county_name: "Perry",
    county_weights: {
      39073: 18.98,
      39127: 81.02,
    },
    county_names_all: "Perry|Hocking",
    county_fips_all: "39127|39073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43767,
    lat: 40.00653,
    lng: -81.80198,
    city: "Norwich",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 894,
    density: 12,
    county_fips: 39119,
    county_name: "Muskingum",
    county_weights: {
      39119: 100,
    },
    county_names_all: "Muskingum",
    county_fips_all: 39119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43768,
    lat: 40.03776,
    lng: -81.44477,
    city: "Old Washington",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 484,
    density: 290.1,
    county_fips: 39059,
    county_name: "Guernsey",
    county_weights: {
      39059: 100,
    },
    county_names_all: "Guernsey",
    county_fips_all: 39059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43771,
    lat: 39.83586,
    lng: -81.94135,
    city: "Philo",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2248,
    density: 37.7,
    county_fips: 39119,
    county_name: "Muskingum",
    county_weights: {
      39119: 100,
    },
    county_names_all: "Muskingum",
    county_fips_all: 39119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43772,
    lat: 39.88063,
    lng: -81.52448,
    city: "Pleasant City",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1827,
    density: 20.7,
    county_fips: 39121,
    county_name: "Noble",
    county_weights: {
      39059: 29.87,
      39121: 70.13,
    },
    county_names_all: "Noble|Guernsey",
    county_fips_all: "39121|39059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43773,
    lat: 39.98758,
    lng: -81.29636,
    city: "Quaker City",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3238,
    density: 11.9,
    county_fips: 39059,
    county_name: "Guernsey",
    county_weights: {
      39059: 59.17,
      39111: 1.45,
      39121: 39.38,
    },
    county_names_all: "Guernsey|Noble|Monroe",
    county_fips_all: "39059|39121|39111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43777,
    lat: 39.81896,
    lng: -82.08543,
    city: "Roseville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5369,
    density: 39.2,
    county_fips: 39119,
    county_name: "Muskingum",
    county_weights: {
      39119: 70.12,
      39127: 29.88,
    },
    county_names_all: "Muskingum|Perry",
    county_fips_all: "39119|39127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43778,
    lat: 40.01111,
    lng: -81.37001,
    city: "Salesville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1400,
    density: 13.2,
    county_fips: 39059,
    county_name: "Guernsey",
    county_weights: {
      39059: 95.98,
      39121: 4.02,
    },
    county_names_all: "Guernsey|Noble",
    county_fips_all: "39059|39121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43779,
    lat: 39.81718,
    lng: -81.42528,
    city: "Sarahsville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 671,
    density: 7.1,
    county_fips: 39121,
    county_name: "Noble",
    county_weights: {
      39121: 100,
    },
    county_names_all: "Noble",
    county_fips_all: 39121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43780,
    lat: 39.92229,
    lng: -81.44024,
    city: "Senecaville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1765,
    density: 17.5,
    county_fips: 39059,
    county_name: "Guernsey",
    county_weights: {
      39059: 61.74,
      39121: 38.26,
    },
    county_names_all: "Guernsey|Noble",
    county_fips_all: "39059|39121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43782,
    lat: 39.62129,
    lng: -82.2185,
    city: "Shawnee",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 714,
    density: 21.3,
    county_fips: 39127,
    county_name: "Perry",
    county_weights: {
      39127: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 39127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43783,
    lat: 39.80389,
    lng: -82.28878,
    city: "Somerset",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5358,
    density: 36.2,
    county_fips: 39127,
    county_name: "Perry",
    county_weights: {
      39127: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 39127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43786,
    lat: 39.71086,
    lng: -81.27704,
    city: "Stafford",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23,
    density: 38.2,
    county_fips: 39111,
    county_name: "Monroe",
    county_weights: {
      39111: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 39111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43787,
    lat: 39.53292,
    lng: -81.80554,
    city: "Stockport",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3123,
    density: 16,
    county_fips: 39115,
    county_name: "Morgan",
    county_weights: {
      39115: 83.79,
      39167: 16.21,
    },
    county_names_all: "Morgan|Washington",
    county_fips_all: "39115|39167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43788,
    lat: 39.80175,
    lng: -81.3334,
    city: "Summerfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 651,
    density: 6.2,
    county_fips: 39121,
    county_name: "Noble",
    county_weights: {
      39111: 28.8,
      39121: 71.2,
    },
    county_names_all: "Noble|Monroe",
    county_fips_all: "39121|39111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43791,
    lat: 39.87757,
    lng: -82.08877,
    city: "White Cottage",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39119,
    county_name: "Muskingum",
    county_weights: {
      39119: 100,
    },
    county_names_all: "Muskingum",
    county_fips_all: 39119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43793,
    lat: 39.74362,
    lng: -81.10219,
    city: "Woodsfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4708,
    density: 17.2,
    county_fips: 39111,
    county_name: "Monroe",
    county_weights: {
      39111: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 39111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43802,
    lat: 40.09346,
    lng: -81.85687,
    city: "Adamsville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1334,
    density: 12.4,
    county_fips: 39119,
    county_name: "Muskingum",
    county_weights: {
      39119: 100,
    },
    county_names_all: "Muskingum",
    county_fips_all: 39119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43804,
    lat: 40.4545,
    lng: -81.73704,
    city: "Baltic",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3840,
    density: 48.3,
    county_fips: 39075,
    county_name: "Holmes",
    county_weights: {
      39031: 14.72,
      39075: 66.55,
      39157: 18.73,
    },
    county_names_all: "Holmes|Tuscarawas|Coshocton",
    county_fips_all: "39075|39157|39031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43805,
    lat: 40.39177,
    lng: -81.97223,
    city: "Blissfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 244,
    density: 91.9,
    county_fips: 39031,
    county_name: "Coshocton",
    county_weights: {
      39031: 100,
    },
    county_names_all: "Coshocton",
    county_fips_all: 39031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43811,
    lat: 40.18285,
    lng: -81.93232,
    city: "Conesville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 649,
    density: 11.8,
    county_fips: 39031,
    county_name: "Coshocton",
    county_weights: {
      39031: 100,
    },
    county_names_all: "Coshocton",
    county_fips_all: 39031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43812,
    lat: 40.27268,
    lng: -81.88347,
    city: "Coshocton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18917,
    density: 46.5,
    county_fips: 39031,
    county_name: "Coshocton",
    county_weights: {
      39031: 100,
    },
    county_names_all: "Coshocton",
    county_fips_all: 39031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43821,
    lat: 40.13559,
    lng: -82.00695,
    city: "Dresden",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3729,
    density: 17.7,
    county_fips: 39119,
    county_name: "Muskingum",
    county_weights: {
      39031: 28.07,
      39119: 71.93,
    },
    county_names_all: "Muskingum|Coshocton",
    county_fips_all: "39119|39031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43822,
    lat: 40.17409,
    lng: -82.16958,
    city: "Frazeysburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5146,
    density: 22.4,
    county_fips: 39119,
    county_name: "Muskingum",
    county_weights: {
      39031: 21.26,
      39083: 11.17,
      39089: 28.65,
      39119: 38.92,
    },
    county_names_all: "Muskingum|Licking|Coshocton|Knox",
    county_fips_all: "39119|39089|39031|39083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43824,
    lat: 40.36407,
    lng: -81.76116,
    city: "Fresno",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4029,
    density: 19.6,
    county_fips: 39031,
    county_name: "Coshocton",
    county_weights: {
      39031: 94.05,
      39157: 5.95,
    },
    county_names_all: "Coshocton|Tuscarawas",
    county_fips_all: "39031|39157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43830,
    lat: 40.06116,
    lng: -82.14812,
    city: "Nashport",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6171,
    density: 47.6,
    county_fips: 39119,
    county_name: "Muskingum",
    county_weights: {
      39089: 28.33,
      39119: 71.67,
    },
    county_names_all: "Muskingum|Licking",
    county_fips_all: "39119|39089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43832,
    lat: 40.27333,
    lng: -81.57931,
    city: "Newcomerstown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7687,
    density: 29.4,
    county_fips: 39157,
    county_name: "Tuscarawas",
    county_weights: {
      39031: 30.84,
      39059: 8.85,
      39157: 60.31,
    },
    county_names_all: "Tuscarawas|Coshocton|Guernsey",
    county_fips_all: "39157|39031|39059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43836,
    lat: 40.2087,
    lng: -81.71854,
    city: "Plainfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 135,
    density: 427.1,
    county_fips: 39031,
    county_name: "Coshocton",
    county_weights: {
      39031: 100,
    },
    county_names_all: "Coshocton",
    county_fips_all: 39031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43837,
    lat: 40.29773,
    lng: -81.47846,
    city: "Port Washington",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1791,
    density: 14,
    county_fips: 39157,
    county_name: "Tuscarawas",
    county_weights: {
      39059: 7.42,
      39157: 92.58,
    },
    county_names_all: "Tuscarawas|Guernsey",
    county_fips_all: "39157|39059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43840,
    lat: 40.40511,
    lng: -81.60025,
    city: "Stone Creek",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1226,
    density: 13.8,
    county_fips: 39157,
    county_name: "Tuscarawas",
    county_weights: {
      39031: 0.37,
      39157: 99.63,
    },
    county_names_all: "Tuscarawas|Coshocton",
    county_fips_all: "39157|39031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43842,
    lat: 40.13749,
    lng: -82.01182,
    city: "Trinway",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 306,
    density: 438.4,
    county_fips: 39119,
    county_name: "Muskingum",
    county_weights: {
      39119: 100,
    },
    county_names_all: "Muskingum",
    county_fips_all: 39119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43843,
    lat: 40.33485,
    lng: -82.17711,
    city: "Walhonding",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 736,
    density: 6.4,
    county_fips: 39031,
    county_name: "Coshocton",
    county_weights: {
      39031: 71.27,
      39083: 28.73,
    },
    county_names_all: "Coshocton|Knox",
    county_fips_all: "39031|39083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43844,
    lat: 40.33349,
    lng: -82.05163,
    city: "Warsaw",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4255,
    density: 13.3,
    county_fips: 39031,
    county_name: "Coshocton",
    county_weights: {
      39031: 100,
    },
    county_names_all: "Coshocton",
    county_fips_all: 39031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43845,
    lat: 40.25692,
    lng: -81.73144,
    city: "West Lafayette",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4488,
    density: 61.1,
    county_fips: 39031,
    county_name: "Coshocton",
    county_weights: {
      39031: 100,
    },
    county_names_all: "Coshocton",
    county_fips_all: 39031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43901,
    lat: 40.21691,
    lng: -80.86637,
    city: "Adena",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1909,
    density: 23.9,
    county_fips: 39081,
    county_name: "Jefferson",
    county_weights: {
      39013: 8.4,
      39067: 25.93,
      39081: 65.67,
    },
    county_names_all: "Jefferson|Harrison|Belmont",
    county_fips_all: "39081|39067|39013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43902,
    lat: 39.88731,
    lng: -80.95596,
    city: "Alledonia",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 237,
    density: 5.6,
    county_fips: 39013,
    county_name: "Belmont",
    county_weights: {
      39013: 100,
    },
    county_names_all: "Belmont",
    county_fips_all: 39013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43903,
    lat: 40.47042,
    lng: -80.95131,
    city: "Amsterdam",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1873,
    density: 19.5,
    county_fips: 39019,
    county_name: "Carroll",
    county_weights: {
      39019: 65.2,
      39081: 34.8,
    },
    county_names_all: "Carroll|Jefferson",
    county_fips_all: "39019|39081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43905,
    lat: 40.11159,
    lng: -80.8408,
    city: "Barton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 134,
    density: 25.6,
    county_fips: 39013,
    county_name: "Belmont",
    county_weights: {
      39013: 100,
    },
    county_names_all: "Belmont",
    county_fips_all: 39013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43906,
    lat: 40.0132,
    lng: -80.80118,
    city: "Bellaire",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8076,
    density: 96.9,
    county_fips: 39013,
    county_name: "Belmont",
    county_weights: {
      39013: 100,
    },
    county_names_all: "Belmont",
    county_fips_all: 39013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43907,
    lat: 40.25697,
    lng: -81.0205,
    city: "Cadiz",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5430,
    density: 13,
    county_fips: 39067,
    county_name: "Harrison",
    county_weights: {
      39067: 96.71,
      39081: 3.29,
    },
    county_names_all: "Harrison|Jefferson",
    county_fips_all: "39067|39081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43908,
    lat: 40.50867,
    lng: -80.87349,
    city: "Bergholz",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1425,
    density: 18,
    county_fips: 39081,
    county_name: "Jefferson",
    county_weights: {
      39019: 7.23,
      39081: 92.77,
    },
    county_names_all: "Jefferson|Carroll",
    county_fips_all: "39081|39019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43909,
    lat: 40.06774,
    lng: -80.81552,
    city: "Blaine",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39013,
    county_name: "Belmont",
    county_weights: {
      39013: 100,
    },
    county_names_all: "Belmont",
    county_fips_all: 39013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43910,
    lat: 40.37039,
    lng: -80.8214,
    city: "Bloomingdale",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3331,
    density: 23.6,
    county_fips: 39081,
    county_name: "Jefferson",
    county_weights: {
      39067: 6.22,
      39081: 93.78,
    },
    county_names_all: "Jefferson|Harrison",
    county_fips_all: "39081|39067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43912,
    lat: 40.08708,
    lng: -80.79255,
    city: "Bridgeport",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6298,
    density: 135.9,
    county_fips: 39013,
    county_name: "Belmont",
    county_weights: {
      39013: 100,
    },
    county_names_all: "Belmont",
    county_fips_all: 39013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43913,
    lat: 40.27048,
    lng: -80.63154,
    city: "Brilliant",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1302,
    density: 207.3,
    county_fips: 39081,
    county_name: "Jefferson",
    county_weights: {
      39081: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 39081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43914,
    lat: 39.77532,
    lng: -80.95288,
    city: "Cameron",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63,
    density: 41.7,
    county_fips: 39111,
    county_name: "Monroe",
    county_weights: {
      39111: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 39111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43915,
    lat: 39.75775,
    lng: -80.89729,
    city: "Clarington",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1044,
    density: 7.3,
    county_fips: 39111,
    county_name: "Monroe",
    county_weights: {
      39111: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 39111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43917,
    lat: 40.22396,
    lng: -80.80546,
    city: "Dillonvale",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3523,
    density: 42.1,
    county_fips: 39081,
    county_name: "Jefferson",
    county_weights: {
      39013: 8.69,
      39081: 91.31,
    },
    county_names_all: "Jefferson|Belmont",
    county_fips_all: "39081|39013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43920,
    lat: 40.67608,
    lng: -80.57965,
    city: "East Liverpool",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21975,
    density: 202.6,
    county_fips: 39029,
    county_name: "Columbiana",
    county_weights: {
      39029: 100,
    },
    county_names_all: "Columbiana",
    county_fips_all: 39029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43925,
    lat: 40.44583,
    lng: -80.86242,
    city: "East Springfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 161,
    density: 297.7,
    county_fips: 39081,
    county_name: "Jefferson",
    county_weights: {
      39081: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 39081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43926,
    lat: 40.51068,
    lng: -80.62252,
    city: "Empire",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 191,
    density: 243.8,
    county_fips: 39081,
    county_name: "Jefferson",
    county_weights: {
      39081: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 39081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43928,
    lat: 40.01088,
    lng: -80.88172,
    city: "Glencoe",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 114,
    density: 38,
    county_fips: 39013,
    county_name: "Belmont",
    county_weights: {
      39013: 100,
    },
    county_names_all: "Belmont",
    county_fips_all: 39013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43930,
    lat: 40.56978,
    lng: -80.77372,
    city: "Hammondsville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 852,
    density: 10.1,
    county_fips: 39081,
    county_name: "Jefferson",
    county_weights: {
      39029: 18.25,
      39081: 81.75,
    },
    county_names_all: "Jefferson|Columbiana",
    county_fips_all: "39081|39029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43931,
    lat: 39.67288,
    lng: -80.87137,
    city: "Hannibal",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 269,
    density: 264.2,
    county_fips: 39111,
    county_name: "Monroe",
    county_weights: {
      39111: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 39111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43932,
    lat: 40.53145,
    lng: -80.74699,
    city: "Irondale",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 934,
    density: 16.3,
    county_fips: 39081,
    county_name: "Jefferson",
    county_weights: {
      39029: 7.27,
      39081: 92.73,
    },
    county_names_all: "Jefferson|Columbiana",
    county_fips_all: "39081|39029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43933,
    lat: 39.93917,
    lng: -80.89588,
    city: "Jacobsburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2137,
    density: 17.3,
    county_fips: 39013,
    county_name: "Belmont",
    county_weights: {
      39013: 100,
    },
    county_names_all: "Belmont",
    county_fips_all: 39013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43934,
    lat: 40.0752,
    lng: -80.79123,
    city: "Lansing",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 387,
    density: 982.3,
    county_fips: 39013,
    county_name: "Belmont",
    county_weights: {
      39013: 100,
    },
    county_names_all: "Belmont",
    county_fips_all: 39013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43935,
    lat: 40.1247,
    lng: -80.75225,
    city: "Martins Ferry",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8498,
    density: 169.9,
    county_fips: 39013,
    county_name: "Belmont",
    county_weights: {
      39013: 100,
    },
    county_names_all: "Belmont",
    county_fips_all: 39013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43938,
    lat: 40.30138,
    lng: -80.67199,
    city: "Mingo Junction",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5773,
    density: 68.3,
    county_fips: 39081,
    county_name: "Jefferson",
    county_weights: {
      39081: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 39081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43939,
    lat: 40.16723,
    lng: -80.79993,
    city: "Mount Pleasant",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 416,
    density: 175.4,
    county_fips: 39081,
    county_name: "Jefferson",
    county_weights: {
      39081: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 39081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43940,
    lat: 40.02863,
    lng: -80.82541,
    city: "Neffs",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 578,
    density: 455.1,
    county_fips: 39013,
    county_name: "Belmont",
    county_weights: {
      39013: 100,
    },
    county_names_all: "Belmont",
    county_fips_all: 39013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43942,
    lat: 39.86367,
    lng: -80.84875,
    city: "Powhatan Point",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2756,
    density: 50.9,
    county_fips: 39013,
    county_name: "Belmont",
    county_weights: {
      39013: 73.24,
      39111: 26.76,
    },
    county_names_all: "Belmont|Monroe",
    county_fips_all: "39013|39111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43943,
    lat: 40.2242,
    lng: -80.73269,
    city: "Rayland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2878,
    density: 24.6,
    county_fips: 39081,
    county_name: "Jefferson",
    county_weights: {
      39013: 2.07,
      39081: 97.93,
    },
    county_names_all: "Jefferson|Belmont",
    county_fips_all: "39081|39013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43944,
    lat: 40.43623,
    lng: -80.76853,
    city: "Richmond",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2549,
    density: 31.8,
    county_fips: 39081,
    county_name: "Jefferson",
    county_weights: {
      39081: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 39081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43945,
    lat: 40.63156,
    lng: -80.84797,
    city: "Salineville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2912,
    density: 16.6,
    county_fips: 39029,
    county_name: "Columbiana",
    county_weights: {
      39019: 28.76,
      39029: 59.22,
      39081: 12.02,
    },
    county_names_all: "Columbiana|Carroll|Jefferson",
    county_fips_all: "39029|39019|39081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43946,
    lat: 39.64792,
    lng: -80.96887,
    city: "Sardis",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2195,
    density: 14.8,
    county_fips: 39111,
    county_name: "Monroe",
    county_weights: {
      39111: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 39111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43947,
    lat: 39.95448,
    lng: -80.78755,
    city: "Shadyside",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5147,
    density: 115.4,
    county_fips: 39013,
    county_name: "Belmont",
    county_weights: {
      39013: 100,
    },
    county_names_all: "Belmont",
    county_fips_all: 39013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43948,
    lat: 40.26847,
    lng: -80.78002,
    city: "Smithfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 689,
    density: 442.7,
    county_fips: 39081,
    county_name: "Jefferson",
    county_weights: {
      39081: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 39081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43950,
    lat: 40.09164,
    lng: -80.92193,
    city: "Saint Clairsville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16352,
    density: 77.2,
    county_fips: 39013,
    county_name: "Belmont",
    county_weights: {
      39013: 97.79,
      39067: 2.21,
    },
    county_names_all: "Belmont|Harrison",
    county_fips_all: "39013|39067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43951,
    lat: 40.11475,
    lng: -81.01405,
    city: "Lafferty",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47,
    density: 16.3,
    county_fips: 39013,
    county_name: "Belmont",
    county_weights: {
      39013: 100,
    },
    county_names_all: "Belmont",
    county_fips_all: 39013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43952,
    lat: 40.39763,
    lng: -80.66278,
    city: "Steubenville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18084,
    density: 271.8,
    county_fips: 39081,
    county_name: "Jefferson",
    county_weights: {
      39081: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 39081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43953,
    lat: 40.35815,
    lng: -80.70548,
    city: "Steubenville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11059,
    density: 230.8,
    county_fips: 39081,
    county_name: "Jefferson",
    county_weights: {
      39081: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 39081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43961,
    lat: 40.52343,
    lng: -80.63025,
    city: "Stratton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 353,
    density: 657.9,
    county_fips: 39081,
    county_name: "Jefferson",
    county_weights: {
      39081: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 39081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43962,
    lat: 40.67315,
    lng: -80.88919,
    city: "Summitville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 82,
    density: 59.3,
    county_fips: 39029,
    county_name: "Columbiana",
    county_weights: {
      39029: 100,
    },
    county_names_all: "Columbiana",
    county_fips_all: 39029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43963,
    lat: 40.17155,
    lng: -80.69698,
    city: "Tiltonsville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1328,
    density: 1163.3,
    county_fips: 39081,
    county_name: "Jefferson",
    county_weights: {
      39081: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 39081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43964,
    lat: 40.48695,
    lng: -80.66928,
    city: "Toronto",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8980,
    density: 73.3,
    county_fips: 39081,
    county_name: "Jefferson",
    county_weights: {
      39081: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 39081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43967,
    lat: 40.02309,
    lng: -80.94371,
    city: "Warnock",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 39013,
    county_name: "Belmont",
    county_weights: {
      39013: 100,
    },
    county_names_all: "Belmont",
    county_fips_all: 39013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43968,
    lat: 40.63365,
    lng: -80.68729,
    city: "Wellsville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6563,
    density: 74.6,
    county_fips: 39029,
    county_name: "Columbiana",
    county_weights: {
      39029: 100,
    },
    county_names_all: "Columbiana",
    county_fips_all: 39029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43971,
    lat: 40.15811,
    lng: -80.71301,
    city: "Yorkville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1045,
    density: 318.3,
    county_fips: 39081,
    county_name: "Jefferson",
    county_weights: {
      39013: 32.71,
      39081: 67.29,
    },
    county_names_all: "Jefferson|Belmont",
    county_fips_all: "39081|39013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43972,
    lat: 40.10164,
    lng: -80.9749,
    city: "Bannock",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 112,
    density: 328.3,
    county_fips: 39013,
    county_name: "Belmont",
    county_weights: {
      39013: 100,
    },
    county_names_all: "Belmont",
    county_fips_all: 39013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43973,
    lat: 40.19111,
    lng: -81.27688,
    city: "Freeport",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2317,
    density: 10.3,
    county_fips: 39067,
    county_name: "Harrison",
    county_weights: {
      39059: 47.24,
      39067: 52.14,
      39157: 0.62,
    },
    county_names_all: "Harrison|Guernsey|Tuscarawas",
    county_fips_all: "39067|39059|39157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43974,
    lat: 40.18205,
    lng: -80.88728,
    city: "Harrisville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 71,
    density: 363.5,
    county_fips: 39067,
    county_name: "Harrison",
    county_weights: {
      39067: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 39067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43976,
    lat: 40.36981,
    lng: -80.90655,
    city: "Hopedale",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1618,
    density: 28.7,
    county_fips: 39067,
    county_name: "Harrison",
    county_weights: {
      39067: 99.9,
      39081: 0.1,
    },
    county_names_all: "Harrison|Jefferson",
    county_fips_all: "39067|39081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43977,
    lat: 40.14519,
    lng: -81.10451,
    city: "Flushing",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2111,
    density: 15.5,
    county_fips: 39013,
    county_name: "Belmont",
    county_weights: {
      39013: 78.97,
      39067: 21.03,
    },
    county_names_all: "Belmont|Harrison",
    county_fips_all: "39013|39067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43981,
    lat: 40.18401,
    lng: -80.99466,
    city: "New Athens",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39067,
    county_name: "Harrison",
    county_weights: {
      39067: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 39067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43983,
    lat: 40.13886,
    lng: -81.20296,
    city: "Piedmont",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 395,
    density: 8.4,
    county_fips: 39013,
    county_name: "Belmont",
    county_weights: {
      39013: 75.13,
      39059: 12.62,
      39067: 12.25,
    },
    county_names_all: "Belmont|Guernsey|Harrison",
    county_fips_all: "39013|39059|39067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43985,
    lat: 40.16168,
    lng: -81.13155,
    city: "Holloway",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 70,
    density: 41.3,
    county_fips: 39013,
    county_name: "Belmont",
    county_weights: {
      39013: 100,
    },
    county_names_all: "Belmont",
    county_fips_all: 39013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43986,
    lat: 40.3784,
    lng: -80.99036,
    city: "Jewett",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1950,
    density: 18.5,
    county_fips: 39067,
    county_name: "Harrison",
    county_weights: {
      39019: 2.97,
      39067: 97.03,
    },
    county_names_all: "Harrison|Carroll",
    county_fips_all: "39067|39019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 43988,
    lat: 40.40486,
    lng: -81.09925,
    city: "Scio",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2407,
    density: 16.9,
    county_fips: 39067,
    county_name: "Harrison",
    county_weights: {
      39019: 33.59,
      39067: 66.41,
    },
    county_names_all: "Harrison|Carroll",
    county_fips_all: "39067|39019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44001,
    lat: 41.36825,
    lng: -82.25958,
    city: "Amherst",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20986,
    density: 244,
    county_fips: 39093,
    county_name: "Lorain",
    county_weights: {
      39093: 100,
    },
    county_names_all: "Lorain",
    county_fips_all: 39093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44003,
    lat: 41.6202,
    lng: -80.58361,
    city: "Andover",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5700,
    density: 36.2,
    county_fips: 39007,
    county_name: "Ashtabula",
    county_weights: {
      39007: 100,
    },
    county_names_all: "Ashtabula",
    county_fips_all: 39007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44004,
    lat: 41.85255,
    lng: -80.78738,
    city: "Ashtabula",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31234,
    density: 162.8,
    county_fips: 39007,
    county_name: "Ashtabula",
    county_weights: {
      39007: 100,
    },
    county_names_all: "Ashtabula",
    county_fips_all: 39007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44010,
    lat: 41.76087,
    lng: -80.85152,
    city: "Austinburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1632,
    density: 34.4,
    county_fips: 39007,
    county_name: "Ashtabula",
    county_weights: {
      39007: 100,
    },
    county_names_all: "Ashtabula",
    county_fips_all: 39007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44011,
    lat: 41.44855,
    lng: -82.0187,
    city: "Avon",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23233,
    density: 431.5,
    county_fips: 39093,
    county_name: "Lorain",
    county_weights: {
      39093: 100,
    },
    county_names_all: "Lorain",
    county_fips_all: 39093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44012,
    lat: 41.49443,
    lng: -82.01594,
    city: "Avon Lake",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24309,
    density: 843.3,
    county_fips: 39093,
    county_name: "Lorain",
    county_weights: {
      39093: 100,
    },
    county_names_all: "Lorain",
    county_fips_all: 39093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44017,
    lat: 41.36867,
    lng: -81.86303,
    city: "Berea",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18714,
    density: 1176.1,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44021,
    lat: 41.44141,
    lng: -81.14579,
    city: "Burton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5834,
    density: 55.8,
    county_fips: 39055,
    county_name: "Geauga",
    county_weights: {
      39055: 100,
    },
    county_names_all: "Geauga",
    county_fips_all: 39055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44022,
    lat: 41.44747,
    lng: -81.4045,
    city: "Chagrin Falls",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16479,
    density: 211,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 72.59,
      39055: 27.41,
    },
    county_names_all: "Cuyahoga|Geauga",
    county_fips_all: "39035|39055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44023,
    lat: 41.38732,
    lng: -81.28858,
    city: "Chagrin Falls",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17423,
    density: 130.3,
    county_fips: 39055,
    county_name: "Geauga",
    county_weights: {
      39055: 100,
    },
    county_names_all: "Geauga",
    county_fips_all: 39055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44024,
    lat: 41.57668,
    lng: -81.19112,
    city: "Chardon",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23945,
    density: 102.7,
    county_fips: 39055,
    county_name: "Geauga",
    county_weights: {
      39055: 97.69,
      39085: 2.31,
    },
    county_names_all: "Geauga|Lake",
    county_fips_all: "39055|39085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44026,
    lat: 41.53182,
    lng: -81.3305,
    city: "Chesterland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10928,
    density: 146.1,
    county_fips: 39055,
    county_name: "Geauga",
    county_weights: {
      39055: 100,
    },
    county_names_all: "Geauga",
    county_fips_all: 39055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44028,
    lat: 41.30986,
    lng: -81.93959,
    city: "Columbia Station",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9330,
    density: 107.1,
    county_fips: 39093,
    county_name: "Lorain",
    county_weights: {
      39093: 100,
    },
    county_names_all: "Lorain",
    county_fips_all: 39093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44030,
    lat: 41.8973,
    lng: -80.58061,
    city: "Conneaut",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16394,
    density: 107.8,
    county_fips: 39007,
    county_name: "Ashtabula",
    county_weights: {
      39007: 100,
    },
    county_names_all: "Ashtabula",
    county_fips_all: 39007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44032,
    lat: 41.6658,
    lng: -80.66954,
    city: "Dorset",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1385,
    density: 12.9,
    county_fips: 39007,
    county_name: "Ashtabula",
    county_weights: {
      39007: 100,
    },
    county_names_all: "Ashtabula",
    county_fips_all: 39007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44035,
    lat: 41.36539,
    lng: -82.13025,
    city: "Elyria",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63198,
    density: 513,
    county_fips: 39093,
    county_name: "Lorain",
    county_weights: {
      39093: 100,
    },
    county_names_all: "Lorain",
    county_fips_all: 39093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44039,
    lat: 41.38404,
    lng: -82.02014,
    city: "North Ridgeville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34038,
    density: 545.5,
    county_fips: 39093,
    county_name: "Lorain",
    county_weights: {
      39093: 100,
    },
    county_names_all: "Lorain",
    county_fips_all: 39093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44040,
    lat: 41.53128,
    lng: -81.4112,
    city: "Gates Mills",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3014,
    density: 118.5,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44041,
    lat: 41.77579,
    lng: -80.95223,
    city: "Geneva",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14422,
    density: 85.5,
    county_fips: 39007,
    county_name: "Ashtabula",
    county_weights: {
      39007: 97.98,
      39085: 2.02,
    },
    county_names_all: "Ashtabula|Lake",
    county_fips_all: "39007|39085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44044,
    lat: 41.26779,
    lng: -82.04188,
    city: "Grafton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14755,
    density: 105.3,
    county_fips: 39093,
    county_name: "Lorain",
    county_weights: {
      39093: 100,
    },
    county_names_all: "Lorain",
    county_fips_all: 39093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44045,
    lat: 41.7461,
    lng: -81.28512,
    city: "Grand River",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 604,
    density: 248.8,
    county_fips: 39085,
    county_name: "Lake",
    county_weights: {
      39085: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 39085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44046,
    lat: 41.54157,
    lng: -81.07227,
    city: "Huntsburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2779,
    density: 71.8,
    county_fips: 39055,
    county_name: "Geauga",
    county_weights: {
      39055: 100,
    },
    county_names_all: "Geauga",
    county_fips_all: 39055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44047,
    lat: 41.71887,
    lng: -80.73921,
    city: "Jefferson",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8317,
    density: 30,
    county_fips: 39007,
    county_name: "Ashtabula",
    county_weights: {
      39007: 100,
    },
    county_names_all: "Ashtabula",
    county_fips_all: 39007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44048,
    lat: 41.84697,
    lng: -80.64343,
    city: "Kingsville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2259,
    density: 31.1,
    county_fips: 39007,
    county_name: "Ashtabula",
    county_weights: {
      39007: 100,
    },
    county_names_all: "Ashtabula",
    county_fips_all: 39007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44049,
    lat: 41.26626,
    lng: -82.30553,
    city: "Kipton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 196,
    density: 217.2,
    county_fips: 39093,
    county_name: "Lorain",
    county_weights: {
      39093: 100,
    },
    county_names_all: "Lorain",
    county_fips_all: 39093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44050,
    lat: 41.24853,
    lng: -82.13119,
    city: "Lagrange",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6695,
    density: 101.2,
    county_fips: 39093,
    county_name: "Lorain",
    county_weights: {
      39093: 100,
    },
    county_names_all: "Lorain",
    county_fips_all: 39093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44052,
    lat: 41.45519,
    lng: -82.16133,
    city: "Lorain",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28586,
    density: 1162.1,
    county_fips: 39093,
    county_name: "Lorain",
    county_weights: {
      39093: 100,
    },
    county_names_all: "Lorain",
    county_fips_all: 39093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44053,
    lat: 41.42694,
    lng: -82.22138,
    city: "Lorain",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19634,
    density: 699.8,
    county_fips: 39093,
    county_name: "Lorain",
    county_weights: {
      39093: 100,
    },
    county_names_all: "Lorain",
    county_fips_all: 39093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44054,
    lat: 41.46419,
    lng: -82.0931,
    city: "Sheffield Lake",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12734,
    density: 392.7,
    county_fips: 39093,
    county_name: "Lorain",
    county_weights: {
      39093: 100,
    },
    county_names_all: "Lorain",
    county_fips_all: 39093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44055,
    lat: 41.43309,
    lng: -82.13354,
    city: "Lorain",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19281,
    density: 1181.7,
    county_fips: 39093,
    county_name: "Lorain",
    county_weights: {
      39093: 100,
    },
    county_names_all: "Lorain",
    county_fips_all: 39093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44056,
    lat: 41.31465,
    lng: -81.49868,
    city: "Macedonia",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11942,
    density: 472.4,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39153: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 39153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44057,
    lat: 41.76675,
    lng: -81.05965,
    city: "Madison",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19611,
    density: 151.2,
    county_fips: 39085,
    county_name: "Lake",
    county_weights: {
      39007: 0.53,
      39055: 5.15,
      39085: 94.32,
    },
    county_names_all: "Lake|Geauga|Ashtabula",
    county_fips_all: "39085|39055|39007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44060,
    lat: 41.67742,
    lng: -81.32806,
    city: "Mentor",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59882,
    density: 579,
    county_fips: 39085,
    county_name: "Lake",
    county_weights: {
      39055: 5.93,
      39085: 94.07,
    },
    county_names_all: "Lake|Geauga",
    county_fips_all: "39085|39055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44062,
    lat: 41.45899,
    lng: -81.02698,
    city: "Middlefield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15369,
    density: 79.5,
    county_fips: 39055,
    county_name: "Geauga",
    county_weights: {
      39007: 5.54,
      39055: 69.75,
      39155: 24.71,
    },
    county_names_all: "Geauga|Trumbull|Ashtabula",
    county_fips_all: "39055|39155|39007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44064,
    lat: 41.60567,
    lng: -81.0477,
    city: "Montville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1546,
    density: 26.4,
    county_fips: 39055,
    county_name: "Geauga",
    county_weights: {
      39007: 2.69,
      39055: 97.31,
    },
    county_names_all: "Geauga|Ashtabula",
    county_fips_all: "39055|39007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44065,
    lat: 41.46308,
    lng: -81.24408,
    city: "Newbury",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4298,
    density: 75.9,
    county_fips: 39055,
    county_name: "Geauga",
    county_weights: {
      39055: 100,
    },
    county_names_all: "Geauga",
    county_fips_all: 39055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44067,
    lat: 41.31386,
    lng: -81.5476,
    city: "Northfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20449,
    density: 459.1,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39153: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 39153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44068,
    lat: 41.90619,
    lng: -80.67886,
    city: "North Kingsville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39007,
    county_name: "Ashtabula",
    county_weights: {
      39007: 100,
    },
    county_names_all: "Ashtabula",
    county_fips_all: 39007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44070,
    lat: 41.41493,
    lng: -81.91905,
    city: "North Olmsted",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31794,
    density: 1051.7,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44072,
    lat: 41.47196,
    lng: -81.32917,
    city: "Novelty",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4385,
    density: 91.7,
    county_fips: 39055,
    county_name: "Geauga",
    county_weights: {
      39055: 100,
    },
    county_names_all: "Geauga",
    county_fips_all: 39055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44074,
    lat: 41.28858,
    lng: -82.23643,
    city: "Oberlin",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11662,
    density: 88.4,
    county_fips: 39093,
    county_name: "Lorain",
    county_weights: {
      39093: 100,
    },
    county_names_all: "Lorain",
    county_fips_all: 39093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44076,
    lat: 41.52728,
    lng: -80.81867,
    city: "Orwell",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4772,
    density: 27,
    county_fips: 39007,
    county_name: "Ashtabula",
    county_weights: {
      39007: 85.06,
      39155: 14.94,
    },
    county_names_all: "Ashtabula|Trumbull",
    county_fips_all: "39007|39155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44077,
    lat: 41.69933,
    lng: -81.21142,
    city: "Painesville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56702,
    density: 361.6,
    county_fips: 39085,
    county_name: "Lake",
    county_weights: {
      39085: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 39085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44080,
    lat: 41.36886,
    lng: -81.05966,
    city: "Parkman",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 162,
    density: 263.7,
    county_fips: 39055,
    county_name: "Geauga",
    county_weights: {
      39055: 100,
    },
    county_names_all: "Geauga",
    county_fips_all: 39055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44081,
    lat: 41.76589,
    lng: -81.14551,
    city: "Perry",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7182,
    density: 134.4,
    county_fips: 39085,
    county_name: "Lake",
    county_weights: {
      39085: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 39085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44082,
    lat: 41.76012,
    lng: -80.56558,
    city: "Pierpont",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1553,
    density: 16.2,
    county_fips: 39007,
    county_name: "Ashtabula",
    county_weights: {
      39007: 100,
    },
    county_names_all: "Ashtabula",
    county_fips_all: 39007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44084,
    lat: 41.67242,
    lng: -80.89605,
    city: "Rock Creek",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3295,
    density: 29.9,
    county_fips: 39007,
    county_name: "Ashtabula",
    county_weights: {
      39007: 100,
    },
    county_names_all: "Ashtabula",
    county_fips_all: 39007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44085,
    lat: 41.60463,
    lng: -80.87128,
    city: "Rome",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3297,
    density: 25.5,
    county_fips: 39007,
    county_name: "Ashtabula",
    county_weights: {
      39007: 100,
    },
    county_names_all: "Ashtabula",
    county_fips_all: 39007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44086,
    lat: 41.67443,
    lng: -81.05599,
    city: "Thompson",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2344,
    density: 33.9,
    county_fips: 39055,
    county_name: "Geauga",
    county_weights: {
      39007: 1.7,
      39055: 86.54,
      39085: 11.76,
    },
    county_names_all: "Geauga|Lake|Ashtabula",
    county_fips_all: "39055|39085|39007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44087,
    lat: 41.31706,
    lng: -81.44106,
    city: "Twinsburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21124,
    density: 453.8,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39153: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 39153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44089,
    lat: 41.38894,
    lng: -82.36552,
    city: "Vermilion",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15570,
    density: 173.9,
    county_fips: 39043,
    county_name: "Erie",
    county_weights: {
      39043: 62.08,
      39093: 37.92,
    },
    county_names_all: "Erie|Lorain",
    county_fips_all: "39043|39093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44090,
    lat: 41.16757,
    lng: -82.22836,
    city: "Wellington",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12005,
    density: 46,
    county_fips: 39093,
    county_name: "Lorain",
    county_weights: {
      39093: 98.92,
      39103: 1.08,
    },
    county_names_all: "Lorain|Medina",
    county_fips_all: "39093|39103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44092,
    lat: 41.59797,
    lng: -81.46867,
    city: "Wickliffe",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16713,
    density: 875.1,
    county_fips: 39085,
    county_name: "Lake",
    county_weights: {
      39085: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 39085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44093,
    lat: 41.53478,
    lng: -80.61637,
    city: "Williamsfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 982,
    density: 10.7,
    county_fips: 39007,
    county_name: "Ashtabula",
    county_weights: {
      39007: 100,
    },
    county_names_all: "Ashtabula",
    county_fips_all: 39007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44094,
    lat: 41.60985,
    lng: -81.3791,
    city: "Willoughby",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35926,
    density: 349.6,
    county_fips: 39085,
    county_name: "Lake",
    county_weights: {
      39055: 1.02,
      39085: 98.98,
    },
    county_names_all: "Lake|Geauga",
    county_fips_all: "39085|39055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44095,
    lat: 41.65223,
    lng: -81.44209,
    city: "Eastlake",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33075,
    density: 1401.3,
    county_fips: 39085,
    county_name: "Lake",
    county_weights: {
      39085: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 39085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44099,
    lat: 41.55125,
    lng: -80.97446,
    city: "Windsor",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2405,
    density: 41.1,
    county_fips: 39007,
    county_name: "Ashtabula",
    county_weights: {
      39007: 85.75,
      39055: 14.25,
    },
    county_names_all: "Ashtabula|Geauga",
    county_fips_all: "39007|39055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44101,
    lat: 41.48988,
    lng: -81.6717,
    city: "Cleveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 643,
    density: 2781.1,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44102,
    lat: 41.4749,
    lng: -81.73751,
    city: "Cleveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44320,
    density: 2810.3,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44103,
    lat: 41.51559,
    lng: -81.64301,
    city: "Cleveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15711,
    density: 1492.2,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44104,
    lat: 41.48238,
    lng: -81.62702,
    city: "Cleveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19295,
    density: 1587.2,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44105,
    lat: 41.45069,
    lng: -81.63032,
    city: "Cleveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35238,
    density: 1526.4,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44106,
    lat: 41.5062,
    lng: -81.60679,
    city: "Cleveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25658,
    density: 2304.7,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44107,
    lat: 41.48263,
    lng: -81.80025,
    city: "Lakewood",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50092,
    density: 3595.1,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44108,
    lat: 41.53992,
    lng: -81.60988,
    city: "Cleveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22234,
    density: 1923.6,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44109,
    lat: 41.44457,
    lng: -81.69681,
    city: "Cleveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39451,
    density: 2147.3,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44110,
    lat: 41.56365,
    lng: -81.57111,
    city: "Cleveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18829,
    density: 1755.8,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44111,
    lat: 41.45775,
    lng: -81.78986,
    city: "Cleveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42591,
    density: 2511.5,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44112,
    lat: 41.53562,
    lng: -81.57369,
    city: "Cleveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21251,
    density: 2045.1,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44113,
    lat: 41.48343,
    lng: -81.69638,
    city: "Cleveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20182,
    density: 2034,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44114,
    lat: 41.5137,
    lng: -81.67625,
    city: "Cleveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6671,
    density: 845.3,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44115,
    lat: 41.49211,
    lng: -81.66999,
    city: "Cleveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9199,
    density: 1679.8,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44116,
    lat: 41.47011,
    lng: -81.85194,
    city: "Rocky River",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20144,
    density: 1590.9,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44117,
    lat: 41.57145,
    lng: -81.52695,
    city: "Euclid",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10271,
    density: 1043.4,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44118,
    lat: 41.5016,
    lng: -81.55653,
    city: "Cleveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39273,
    density: 2151,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44119,
    lat: 41.58673,
    lng: -81.54748,
    city: "Cleveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13378,
    density: 2325.5,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44120,
    lat: 41.47337,
    lng: -81.58015,
    city: "Cleveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35046,
    density: 2583.7,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44121,
    lat: 41.52626,
    lng: -81.53246,
    city: "Cleveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31586,
    density: 1917.5,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44122,
    lat: 41.4701,
    lng: -81.51272,
    city: "Beachwood",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33163,
    density: 1027.4,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44123,
    lat: 41.60365,
    lng: -81.52441,
    city: "Euclid",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16828,
    density: 2566,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44124,
    lat: 41.49999,
    lng: -81.46774,
    city: "Cleveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36877,
    density: 939.3,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44125,
    lat: 41.40658,
    lng: -81.61548,
    city: "Cleveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26847,
    density: 740.5,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44126,
    lat: 41.44263,
    lng: -81.85278,
    city: "Cleveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16190,
    density: 1392.3,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44127,
    lat: 41.471,
    lng: -81.64874,
    city: "Cleveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4752,
    density: 1023.7,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44128,
    lat: 41.43766,
    lng: -81.54036,
    city: "Cleveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28588,
    density: 1257.1,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44129,
    lat: 41.39035,
    lng: -81.73536,
    city: "Cleveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28542,
    density: 1886,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44130,
    lat: 41.378,
    lng: -81.7868,
    city: "Cleveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49666,
    density: 1118.8,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44131,
    lat: 41.3835,
    lng: -81.65349,
    city: "Independence",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20338,
    density: 499.6,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44132,
    lat: 41.60484,
    lng: -81.49958,
    city: "Euclid",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13602,
    density: 1647.9,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44133,
    lat: 41.31388,
    lng: -81.74497,
    city: "North Royalton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29992,
    density: 540.2,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44134,
    lat: 41.38496,
    lng: -81.70459,
    city: "Cleveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35923,
    density: 1429.8,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44135,
    lat: 41.42472,
    lng: -81.82135,
    city: "Cleveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27732,
    density: 1054.3,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44136,
    lat: 41.31265,
    lng: -81.81064,
    city: "Strongsville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25024,
    density: 714.3,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44137,
    lat: 41.40903,
    lng: -81.56274,
    city: "Maple Heights",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23001,
    density: 1710.8,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44138,
    lat: 41.37363,
    lng: -81.92302,
    city: "Olmsted Falls",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22116,
    density: 618.5,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44139,
    lat: 41.38325,
    lng: -81.44439,
    city: "Solon",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23882,
    density: 402.1,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44140,
    lat: 41.48508,
    lng: -81.93171,
    city: "Bay Village",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15258,
    density: 1290.3,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44141,
    lat: 41.30139,
    lng: -81.61439,
    city: "Brecksville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13638,
    density: 217.7,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 82.15,
      39153: 17.85,
    },
    county_names_all: "Cuyahoga|Summit",
    county_fips_all: "39035|39153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44142,
    lat: 41.40205,
    lng: -81.82406,
    city: "Brookpark",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18486,
    density: 959.7,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44143,
    lat: 41.55358,
    lng: -81.47513,
    city: "Cleveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23811,
    density: 653.2,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44144,
    lat: 41.43738,
    lng: -81.74272,
    city: "Cleveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21661,
    density: 1507.1,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44145,
    lat: 41.45245,
    lng: -81.92944,
    city: "Westlake",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32154,
    density: 779.2,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44146,
    lat: 41.38161,
    lng: -81.53018,
    city: "Bedford",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28894,
    density: 557.2,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44147,
    lat: 41.31956,
    lng: -81.67797,
    city: "Broadview Heights",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19407,
    density: 577.1,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 100,
    },
    county_names_all: "Cuyahoga",
    county_fips_all: 39035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44149,
    lat: 41.31223,
    lng: -81.8563,
    city: "Strongsville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19662,
    density: 671.4,
    county_fips: 39035,
    county_name: "Cuyahoga",
    county_weights: {
      39035: 98.16,
      39103: 1.84,
    },
    county_names_all: "Cuyahoga|Medina",
    county_fips_all: "39035|39103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44201,
    lat: 41.02741,
    lng: -81.18354,
    city: "Atwater",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6871,
    density: 50.3,
    county_fips: 39133,
    county_name: "Portage",
    county_weights: {
      39133: 98.22,
      39151: 1.78,
    },
    county_names_all: "Portage|Stark",
    county_fips_all: "39133|39151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44202,
    lat: 41.31645,
    lng: -81.34243,
    city: "Aurora",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20234,
    density: 257.5,
    county_fips: 39133,
    county_name: "Portage",
    county_weights: {
      39055: 5.25,
      39133: 88.43,
      39153: 6.32,
    },
    county_names_all: "Portage|Summit|Geauga",
    county_fips_all: "39133|39153|39055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44203,
    lat: 41.02013,
    lng: -81.62896,
    city: "Barberton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40318,
    density: 444.3,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39103: 1.49,
      39153: 97.65,
      39169: 0.86,
    },
    county_names_all: "Summit|Medina|Wayne",
    county_fips_all: "39153|39103|39169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44212,
    lat: 41.24386,
    lng: -81.82863,
    city: "Brunswick",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44878,
    density: 823.4,
    county_fips: 39103,
    county_name: "Medina",
    county_weights: {
      39103: 100,
    },
    county_names_all: "Medina",
    county_fips_all: 39103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44214,
    lat: 40.95081,
    lng: -81.99935,
    city: "Burbank",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2246,
    density: 32.8,
    county_fips: 39169,
    county_name: "Wayne",
    county_weights: {
      39103: 14.23,
      39169: 85.77,
    },
    county_names_all: "Wayne|Medina",
    county_fips_all: "39169|39103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44215,
    lat: 41.07195,
    lng: -81.8994,
    city: "Chippewa Lake",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2279,
    density: 396.5,
    county_fips: 39103,
    county_name: "Medina",
    county_weights: {
      39103: 100,
    },
    county_names_all: "Medina",
    county_fips_all: 39103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44216,
    lat: 40.93848,
    lng: -81.58397,
    city: "Clinton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8739,
    density: 143.4,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39151: 4.09,
      39153: 95.37,
      39169: 0.54,
    },
    county_names_all: "Summit|Stark|Wayne",
    county_fips_all: "39153|39151|39169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44217,
    lat: 40.95561,
    lng: -81.9133,
    city: "Creston",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3559,
    density: 46.7,
    county_fips: 39169,
    county_name: "Wayne",
    county_weights: {
      39103: 12.15,
      39169: 87.85,
    },
    county_names_all: "Wayne|Medina",
    county_fips_all: "39169|39103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44221,
    lat: 41.13898,
    lng: -81.47624,
    city: "Cuyahoga Falls",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28271,
    density: 1707.6,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39153: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 39153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44223,
    lat: 41.16968,
    lng: -81.53051,
    city: "Cuyahoga Falls",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18021,
    density: 470,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39153: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 39153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44224,
    lat: 41.17697,
    lng: -81.44016,
    city: "Stow",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39306,
    density: 743.6,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39133: 1.7,
      39153: 98.3,
    },
    county_names_all: "Summit|Portage",
    county_fips_all: "39153|39133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44230,
    lat: 40.96237,
    lng: -81.69064,
    city: "Doylestown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8480,
    density: 180.8,
    county_fips: 39169,
    county_name: "Wayne",
    county_weights: {
      39103: 5.95,
      39153: 0.8,
      39169: 93.25,
    },
    county_names_all: "Wayne|Medina|Summit",
    county_fips_all: "39169|39103|39153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44231,
    lat: 41.30692,
    lng: -81.07197,
    city: "Garrettsville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8787,
    density: 69.4,
    county_fips: 39133,
    county_name: "Portage",
    county_weights: {
      39055: 15.08,
      39133: 84.92,
    },
    county_names_all: "Portage|Geauga",
    county_fips_all: "39133|39055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44232,
    lat: 40.93254,
    lng: -81.46354,
    city: "Green",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39153: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 39153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44233,
    lat: 41.23943,
    lng: -81.73513,
    city: "Hinckley",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8028,
    density: 116.1,
    county_fips: 39103,
    county_name: "Medina",
    county_weights: {
      39103: 100,
    },
    county_names_all: "Medina",
    county_fips_all: 39103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44234,
    lat: 41.33454,
    lng: -81.15822,
    city: "Hiram",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4016,
    density: 61.6,
    county_fips: 39133,
    county_name: "Portage",
    county_weights: {
      39055: 34.79,
      39133: 65.21,
    },
    county_names_all: "Portage|Geauga",
    county_fips_all: "39133|39055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44235,
    lat: 41.0316,
    lng: -82.12246,
    city: "Homerville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1714,
    density: 26,
    county_fips: 39103,
    county_name: "Medina",
    county_weights: {
      39005: 2.03,
      39103: 97.97,
    },
    county_names_all: "Medina|Ashland",
    county_fips_all: "39103|39005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44236,
    lat: 41.24669,
    lng: -81.44775,
    city: "Hudson",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25281,
    density: 304.8,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39133: 0.71,
      39153: 99.29,
    },
    county_names_all: "Summit|Portage",
    county_fips_all: "39153|39133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44240,
    lat: 41.13329,
    lng: -81.34241,
    city: "Kent",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39778,
    density: 386.5,
    county_fips: 39133,
    county_name: "Portage",
    county_weights: {
      39133: 99.68,
      39153: 0.32,
    },
    county_names_all: "Portage|Summit",
    county_fips_all: "39133|39153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44241,
    lat: 41.23945,
    lng: -81.34728,
    city: "Streetsboro",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16974,
    density: 295.1,
    county_fips: 39133,
    county_name: "Portage",
    county_weights: {
      39133: 100,
    },
    county_names_all: "Portage",
    county_fips_all: 39133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44243,
    lat: 41.14793,
    lng: -81.34046,
    city: "Kent",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4946,
    density: 4514.6,
    county_fips: 39133,
    county_name: "Portage",
    county_weights: {
      39133: 100,
    },
    county_names_all: "Portage",
    county_fips_all: 39133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44250,
    lat: 41.02159,
    lng: -81.43331,
    city: "Lakemore",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1091,
    density: 595.3,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39153: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 39153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44251,
    lat: 41.02814,
    lng: -81.92764,
    city: "Westfield Center",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 914,
    density: 239.9,
    county_fips: 39103,
    county_name: "Medina",
    county_weights: {
      39103: 100,
    },
    county_names_all: "Medina",
    county_fips_all: 39103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44253,
    lat: 41.16571,
    lng: -82.03767,
    city: "Litchfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3311,
    density: 46.5,
    county_fips: 39103,
    county_name: "Medina",
    county_weights: {
      39093: 16.75,
      39103: 83.25,
    },
    county_names_all: "Medina|Lorain",
    county_fips_all: "39103|39093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44254,
    lat: 41.04522,
    lng: -82.01282,
    city: "Lodi",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4684,
    density: 69.7,
    county_fips: 39103,
    county_name: "Medina",
    county_weights: {
      39103: 100,
    },
    county_names_all: "Medina",
    county_fips_all: 39103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44255,
    lat: 41.28658,
    lng: -81.22982,
    city: "Mantua",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7949,
    density: 71.8,
    county_fips: 39133,
    county_name: "Portage",
    county_weights: {
      39133: 100,
    },
    county_names_all: "Portage",
    county_fips_all: 39133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44256,
    lat: 41.14092,
    lng: -81.85954,
    city: "Medina",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63462,
    density: 187.4,
    county_fips: 39103,
    county_name: "Medina",
    county_weights: {
      39093: 0.5,
      39103: 99.5,
    },
    county_names_all: "Medina|Lorain",
    county_fips_all: "39103|39093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44260,
    lat: 41.03684,
    lng: -81.34079,
    city: "Mogadore",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13126,
    density: 153.6,
    county_fips: 39133,
    county_name: "Portage",
    county_weights: {
      39133: 93.7,
      39151: 1.16,
      39153: 5.14,
    },
    county_names_all: "Portage|Summit|Stark",
    county_fips_all: "39133|39153|39151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44262,
    lat: 41.13901,
    lng: -81.43492,
    city: "Munroe Falls",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5016,
    density: 724.2,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39153: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 39153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44264,
    lat: 41.22966,
    lng: -81.54311,
    city: "Peninsula",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3027,
    density: 52.3,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39153: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 39153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44266,
    lat: 41.1662,
    lng: -81.19829,
    city: "Ravenna",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33386,
    density: 140.3,
    county_fips: 39133,
    county_name: "Portage",
    county_weights: {
      39133: 100,
    },
    county_names_all: "Portage",
    county_fips_all: 39133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44270,
    lat: 40.96317,
    lng: -81.77696,
    city: "Rittman",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8661,
    density: 171.4,
    county_fips: 39169,
    county_name: "Wayne",
    county_weights: {
      39103: 16.44,
      39169: 83.56,
    },
    county_names_all: "Wayne|Medina",
    county_fips_all: "39169|39103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44272,
    lat: 41.08691,
    lng: -81.18244,
    city: "Rootstown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5358,
    density: 85.2,
    county_fips: 39133,
    county_name: "Portage",
    county_weights: {
      39133: 100,
    },
    county_names_all: "Portage",
    county_fips_all: 39133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44273,
    lat: 41.0291,
    lng: -81.87739,
    city: "Seville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7941,
    density: 79.2,
    county_fips: 39103,
    county_name: "Medina",
    county_weights: {
      39103: 98.76,
      39169: 1.24,
    },
    county_names_all: "Medina|Wayne",
    county_fips_all: "39103|39169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44274,
    lat: 41.09944,
    lng: -81.7285,
    city: "Sharon Center",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 209,
    density: 71.3,
    county_fips: 39103,
    county_name: "Medina",
    county_weights: {
      39103: 100,
    },
    county_names_all: "Medina",
    county_fips_all: 39103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44275,
    lat: 41.09976,
    lng: -82.09927,
    city: "Spencer",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3270,
    density: 34,
    county_fips: 39103,
    county_name: "Medina",
    county_weights: {
      39093: 6.71,
      39103: 93.29,
    },
    county_names_all: "Medina|Lorain",
    county_fips_all: "39103|39093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44276,
    lat: 40.93667,
    lng: -81.83502,
    city: "Sterling",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1899,
    density: 35.6,
    county_fips: 39169,
    county_name: "Wayne",
    county_weights: {
      39169: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 39169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44278,
    lat: 41.10052,
    lng: -81.42137,
    city: "Tallmadge",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17921,
    density: 474.9,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39133: 3.91,
      39153: 96.09,
    },
    county_names_all: "Summit|Portage",
    county_fips_all: "39153|39133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44280,
    lat: 41.23812,
    lng: -81.92339,
    city: "Valley City",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4762,
    density: 72.5,
    county_fips: 39103,
    county_name: "Medina",
    county_weights: {
      39093: 1.63,
      39103: 98.37,
    },
    county_names_all: "Medina|Lorain",
    county_fips_all: "39103|39093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44281,
    lat: 41.05851,
    lng: -81.73854,
    city: "Wadsworth",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32569,
    density: 263.1,
    county_fips: 39103,
    county_name: "Medina",
    county_weights: {
      39103: 97.96,
      39153: 2.04,
    },
    county_names_all: "Medina|Summit",
    county_fips_all: "39103|39153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44285,
    lat: 41.16241,
    lng: -81.06595,
    city: "Wayland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36,
    density: 17,
    county_fips: 39133,
    county_name: "Portage",
    county_weights: {
      39133: 100,
    },
    county_names_all: "Portage",
    county_fips_all: 39133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44286,
    lat: 41.23668,
    lng: -81.64017,
    city: "Richfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6201,
    density: 101.4,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39153: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 39153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44287,
    lat: 40.94,
    lng: -82.1005,
    city: "West Salem",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7790,
    density: 45.1,
    county_fips: 39169,
    county_name: "Wayne",
    county_weights: {
      39005: 27,
      39103: 8.17,
      39169: 64.83,
    },
    county_names_all: "Wayne|Ashland|Medina",
    county_fips_all: "39169|39005|39103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44288,
    lat: 41.2392,
    lng: -81.08354,
    city: "Windham",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3502,
    density: 79.8,
    county_fips: 39133,
    county_name: "Portage",
    county_weights: {
      39133: 97.92,
      39155: 2.08,
    },
    county_names_all: "Portage|Trumbull",
    county_fips_all: "39133|39155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44301,
    lat: 41.04398,
    lng: -81.52449,
    city: "Akron",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15431,
    density: 1675.7,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39153: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 39153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44302,
    lat: 41.08951,
    lng: -81.53857,
    city: "Akron",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4534,
    density: 1947.6,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39153: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 39153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44303,
    lat: 41.10448,
    lng: -81.53732,
    city: "Akron",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8422,
    density: 1543.7,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39153: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 39153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44304,
    lat: 41.08585,
    lng: -81.50908,
    city: "Akron",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4897,
    density: 1438.3,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39153: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 39153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44305,
    lat: 41.07643,
    lng: -81.46226,
    city: "Akron",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22130,
    density: 1271.9,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39153: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 39153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44306,
    lat: 41.03927,
    lng: -81.48316,
    city: "Akron",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21281,
    density: 984.9,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39153: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 39153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44307,
    lat: 41.07049,
    lng: -81.546,
    city: "Akron",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6111,
    density: 1208.7,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39153: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 39153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44308,
    lat: 41.0818,
    lng: -81.51751,
    city: "Akron",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1132,
    density: 946.5,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39153: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 39153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44310,
    lat: 41.10771,
    lng: -81.49948,
    city: "Akron",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26325,
    density: 1647.2,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39153: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 39153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44311,
    lat: 41.06427,
    lng: -81.52047,
    city: "Akron",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8244,
    density: 1703.9,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39153: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 39153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44312,
    lat: 41.01462,
    lng: -81.4412,
    city: "Akron",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31887,
    density: 649.6,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39133: 0.66,
      39153: 99.34,
    },
    county_names_all: "Summit|Portage",
    county_fips_all: "39153|39133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44313,
    lat: 41.13239,
    lng: -81.56512,
    city: "Akron",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26729,
    density: 765,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39153: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 39153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44314,
    lat: 41.04048,
    lng: -81.55838,
    city: "Akron",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18388,
    density: 1625.8,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39153: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 39153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44319,
    lat: 40.98402,
    lng: -81.53169,
    city: "Akron",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22635,
    density: 459,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39153: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 39153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44320,
    lat: 41.07818,
    lng: -81.58379,
    city: "Akron",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18809,
    density: 724.2,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39153: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 39153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44321,
    lat: 41.09994,
    lng: -81.65182,
    city: "Akron",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15285,
    density: 404.1,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39103: 2.85,
      39153: 97.15,
    },
    county_names_all: "Summit|Medina",
    county_fips_all: "39153|39103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44325,
    lat: 41.07605,
    lng: -81.51221,
    city: "Akron",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39153: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 39153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44333,
    lat: 41.16195,
    lng: -81.63419,
    city: "Akron",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18669,
    density: 253.7,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39103: 1.63,
      39153: 98.37,
    },
    county_names_all: "Summit|Medina",
    county_fips_all: "39153|39103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44401,
    lat: 41.02457,
    lng: -80.94658,
    city: "Berlin Center",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2737,
    density: 34.6,
    county_fips: 39099,
    county_name: "Mahoning",
    county_weights: {
      39099: 100,
    },
    county_names_all: "Mahoning",
    county_fips_all: 39099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44402,
    lat: 41.38893,
    lng: -80.85513,
    city: "Bristolville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3027,
    density: 32.2,
    county_fips: 39155,
    county_name: "Trumbull",
    county_weights: {
      39155: 100,
    },
    county_names_all: "Trumbull",
    county_fips_all: 39155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44403,
    lat: 41.24053,
    lng: -80.58265,
    city: "Brookfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3790,
    density: 101.9,
    county_fips: 39155,
    county_name: "Trumbull",
    county_weights: {
      39155: 100,
    },
    county_names_all: "Trumbull",
    county_fips_all: 39155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44404,
    lat: 41.3277,
    lng: -80.54861,
    city: "Burghill",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1720,
    density: 42.5,
    county_fips: 39155,
    county_name: "Trumbull",
    county_weights: {
      39155: 100,
    },
    county_names_all: "Trumbull",
    county_fips_all: 39155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44405,
    lat: 41.07787,
    lng: -80.59136,
    city: "Campbell",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7847,
    density: 846.1,
    county_fips: 39099,
    county_name: "Mahoning",
    county_weights: {
      39099: 100,
    },
    county_names_all: "Mahoning",
    county_fips_all: 39099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44406,
    lat: 41.01132,
    lng: -80.77194,
    city: "Canfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21555,
    density: 152.7,
    county_fips: 39099,
    county_name: "Mahoning",
    county_weights: {
      39099: 100,
    },
    county_names_all: "Mahoning",
    county_fips_all: 39099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44408,
    lat: 40.88487,
    lng: -80.68569,
    city: "Columbiana",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9887,
    density: 107.1,
    county_fips: 39029,
    county_name: "Columbiana",
    county_weights: {
      39029: 62.87,
      39099: 37.13,
    },
    county_names_all: "Columbiana|Mahoning",
    county_fips_all: "39029|39099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44410,
    lat: 41.34817,
    lng: -80.72629,
    city: "Cortland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17266,
    density: 102,
    county_fips: 39155,
    county_name: "Trumbull",
    county_weights: {
      39155: 100,
    },
    county_names_all: "Trumbull",
    county_fips_all: 39155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44411,
    lat: 41.0326,
    lng: -81.05092,
    city: "Deerfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2141,
    density: 41.5,
    county_fips: 39133,
    county_name: "Portage",
    county_weights: {
      39133: 100,
    },
    county_names_all: "Portage",
    county_fips_all: 39133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44412,
    lat: 41.09671,
    lng: -81.0229,
    city: "Diamond",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2479,
    density: 42.5,
    county_fips: 39133,
    county_name: "Portage",
    county_weights: {
      39099: 24.88,
      39133: 75.12,
    },
    county_names_all: "Portage|Mahoning",
    county_fips_all: "39133|39099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44413,
    lat: 40.84803,
    lng: -80.5549,
    city: "East Palestine",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6964,
    density: 109.7,
    county_fips: 39029,
    county_name: "Columbiana",
    county_weights: {
      39029: 100,
    },
    county_names_all: "Columbiana",
    county_fips_all: 39029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44415,
    lat: 40.77068,
    lng: -80.70455,
    city: "Elkton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39029,
    county_name: "Columbiana",
    county_weights: {
      39029: 100,
    },
    county_names_all: "Columbiana",
    county_fips_all: 39029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44417,
    lat: 41.43336,
    lng: -80.66329,
    city: "Farmdale",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1524,
    density: 17.1,
    county_fips: 39155,
    county_name: "Trumbull",
    county_weights: {
      39155: 100,
    },
    county_names_all: "Trumbull",
    county_fips_all: 39155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44418,
    lat: 41.30692,
    lng: -80.60465,
    city: "Fowler",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1170,
    density: 27.2,
    county_fips: 39155,
    county_name: "Trumbull",
    county_weights: {
      39155: 100,
    },
    county_names_all: "Trumbull",
    county_fips_all: 39155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44420,
    lat: 41.17384,
    lng: -80.67726,
    city: "Girard",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14975,
    density: 390,
    county_fips: 39155,
    county_name: "Trumbull",
    county_weights: {
      39155: 100,
    },
    county_names_all: "Trumbull",
    county_fips_all: 39155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44423,
    lat: 40.7524,
    lng: -80.89963,
    city: "Hanoverton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2864,
    density: 38,
    county_fips: 39029,
    county_name: "Columbiana",
    county_weights: {
      39029: 100,
    },
    county_names_all: "Columbiana",
    county_fips_all: 39029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44424,
    lat: 41.32201,
    lng: -80.58326,
    city: "Hartford",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39155,
    county_name: "Trumbull",
    county_weights: {
      39155: 100,
    },
    county_names_all: "Trumbull",
    county_fips_all: 39155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44425,
    lat: 41.17022,
    lng: -80.57395,
    city: "Hubbard",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13457,
    density: 170.5,
    county_fips: 39155,
    county_name: "Trumbull",
    county_weights: {
      39099: 4.3,
      39155: 95.7,
    },
    county_names_all: "Trumbull|Mahoning",
    county_fips_all: "39155|39099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44427,
    lat: 40.71672,
    lng: -80.95686,
    city: "Kensington",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 892,
    density: 10.8,
    county_fips: 39019,
    county_name: "Carroll",
    county_weights: {
      39019: 52.36,
      39029: 47.64,
    },
    county_names_all: "Carroll|Columbiana",
    county_fips_all: "39019|39029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44428,
    lat: 41.43458,
    lng: -80.5779,
    city: "Kinsman",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2975,
    density: 21.3,
    county_fips: 39155,
    county_name: "Trumbull",
    county_weights: {
      39007: 2.8,
      39155: 97.2,
    },
    county_names_all: "Trumbull|Ashtabula",
    county_fips_all: "39155|39007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44429,
    lat: 41.09648,
    lng: -80.98156,
    city: "Lake Milton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2628,
    density: 154.7,
    county_fips: 39099,
    county_name: "Mahoning",
    county_weights: {
      39099: 97,
      39133: 3,
    },
    county_names_all: "Mahoning|Portage",
    county_fips_all: "39099|39133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44430,
    lat: 41.24011,
    lng: -80.90804,
    city: "Leavittsburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5335,
    density: 158.3,
    county_fips: 39155,
    county_name: "Trumbull",
    county_weights: {
      39155: 100,
    },
    county_names_all: "Trumbull",
    county_fips_all: 39155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44431,
    lat: 40.84748,
    lng: -80.75365,
    city: "Leetonia",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4647,
    density: 65.4,
    county_fips: 39029,
    county_name: "Columbiana",
    county_weights: {
      39029: 100,
    },
    county_names_all: "Columbiana",
    county_fips_all: 39029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44432,
    lat: 40.74974,
    lng: -80.75149,
    city: "Lisbon",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12700,
    density: 46.4,
    county_fips: 39029,
    county_name: "Columbiana",
    county_weights: {
      39029: 100,
    },
    county_names_all: "Columbiana",
    county_fips_all: 39029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44436,
    lat: 41.05775,
    lng: -80.54241,
    city: "Lowellville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3704,
    density: 64.7,
    county_fips: 39099,
    county_name: "Mahoning",
    county_weights: {
      39099: 100,
    },
    county_names_all: "Mahoning",
    county_fips_all: 39099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44437,
    lat: 41.15536,
    lng: -80.73,
    city: "McDonald",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3880,
    density: 385.6,
    county_fips: 39155,
    county_name: "Trumbull",
    county_weights: {
      39099: 5.79,
      39155: 94.21,
    },
    county_names_all: "Trumbull|Mahoning",
    county_fips_all: "39155|39099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44438,
    lat: 41.24252,
    lng: -80.5345,
    city: "Masury",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4599,
    density: 188.7,
    county_fips: 39155,
    county_name: "Trumbull",
    county_weights: {
      39155: 100,
    },
    county_names_all: "Trumbull",
    county_fips_all: 39155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44439,
    lat: 41.45436,
    lng: -80.95552,
    city: "Mesopotamia",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39155,
    county_name: "Trumbull",
    county_weights: {
      39155: 100,
    },
    county_names_all: "Trumbull",
    county_fips_all: 39155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44440,
    lat: 41.1482,
    lng: -80.78439,
    city: "Mineral Ridge",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5055,
    density: 231.9,
    county_fips: 39155,
    county_name: "Trumbull",
    county_weights: {
      39099: 8.44,
      39155: 91.56,
    },
    county_names_all: "Trumbull|Mahoning",
    county_fips_all: "39155|39099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44441,
    lat: 40.75802,
    lng: -80.55264,
    city: "Negley",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1774,
    density: 41.9,
    county_fips: 39029,
    county_name: "Columbiana",
    county_weights: {
      39029: 100,
    },
    county_names_all: "Columbiana",
    county_fips_all: 39029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44442,
    lat: 40.96591,
    lng: -80.54963,
    city: "New Middletown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3898,
    density: 166.4,
    county_fips: 39099,
    county_name: "Mahoning",
    county_weights: {
      39099: 100,
    },
    county_names_all: "Mahoning",
    county_fips_all: 39099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44443,
    lat: 40.92351,
    lng: -80.59473,
    city: "New Springfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1676,
    density: 47.9,
    county_fips: 39099,
    county_name: "Mahoning",
    county_weights: {
      39029: 6.75,
      39099: 93.25,
    },
    county_names_all: "Mahoning|Columbiana",
    county_fips_all: "39099|39029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44444,
    lat: 41.17559,
    lng: -80.97647,
    city: "Newton Falls",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9488,
    density: 89.2,
    county_fips: 39155,
    county_name: "Trumbull",
    county_weights: {
      39099: 6.55,
      39133: 21.25,
      39155: 72.2,
    },
    county_names_all: "Trumbull|Portage|Mahoning",
    county_fips_all: "39155|39133|39099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44445,
    lat: 40.84834,
    lng: -80.61732,
    city: "New Waterford",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2923,
    density: 72.9,
    county_fips: 39029,
    county_name: "Columbiana",
    county_weights: {
      39029: 100,
    },
    county_names_all: "Columbiana",
    county_fips_all: 39029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44446,
    lat: 41.18958,
    lng: -80.74692,
    city: "Niles",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20170,
    density: 557,
    county_fips: 39155,
    county_name: "Trumbull",
    county_weights: {
      39155: 100,
    },
    county_names_all: "Trumbull",
    county_fips_all: 39155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44449,
    lat: 40.97957,
    lng: -81.02446,
    city: "North Benton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1280,
    density: 36.5,
    county_fips: 39099,
    county_name: "Mahoning",
    county_weights: {
      39099: 75.17,
      39133: 24.83,
    },
    county_names_all: "Mahoning|Portage",
    county_fips_all: "39099|39133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44450,
    lat: 41.45397,
    lng: -80.82576,
    city: "North Bloomfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2335,
    density: 20.5,
    county_fips: 39155,
    county_name: "Trumbull",
    county_weights: {
      39155: 100,
    },
    county_names_all: "Trumbull",
    county_fips_all: 39155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44451,
    lat: 41.08104,
    lng: -80.86887,
    city: "North Jackson",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2676,
    density: 26.7,
    county_fips: 39099,
    county_name: "Mahoning",
    county_weights: {
      39099: 100,
    },
    county_names_all: "Mahoning",
    county_fips_all: 39099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44452,
    lat: 40.94711,
    lng: -80.66232,
    city: "North Lima",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3530,
    density: 99.7,
    county_fips: 39099,
    county_name: "Mahoning",
    county_weights: {
      39099: 100,
    },
    county_names_all: "Mahoning",
    county_fips_all: 39099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44454,
    lat: 40.9197,
    lng: -80.53976,
    city: "Petersburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1076,
    density: 60.5,
    county_fips: 39099,
    county_name: "Mahoning",
    county_weights: {
      39029: 8.46,
      39099: 91.54,
    },
    county_names_all: "Mahoning|Columbiana",
    county_fips_all: "39099|39029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44455,
    lat: 40.77581,
    lng: -80.60485,
    city: "Rogers",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2292,
    density: 49.3,
    county_fips: 39029,
    county_name: "Columbiana",
    county_weights: {
      39029: 100,
    },
    county_names_all: "Columbiana",
    county_fips_all: 39029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44460,
    lat: 40.90221,
    lng: -80.87026,
    city: "Salem",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24785,
    density: 89.1,
    county_fips: 39029,
    county_name: "Columbiana",
    county_weights: {
      39029: 54.81,
      39099: 45.19,
    },
    county_names_all: "Columbiana|Mahoning",
    county_fips_all: "39029|39099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44470,
    lat: 41.29783,
    lng: -80.95999,
    city: "Southington",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4031,
    density: 57.3,
    county_fips: 39155,
    county_name: "Trumbull",
    county_weights: {
      39155: 100,
    },
    county_names_all: "Trumbull",
    county_fips_all: 39155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44471,
    lat: 41.04793,
    lng: -80.58973,
    city: "Struthers",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10589,
    density: 912.5,
    county_fips: 39099,
    county_name: "Mahoning",
    county_weights: {
      39099: 100,
    },
    county_names_all: "Mahoning",
    county_fips_all: 39099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44473,
    lat: 41.24684,
    lng: -80.66326,
    city: "Vienna",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3484,
    density: 54.9,
    county_fips: 39155,
    county_name: "Trumbull",
    county_weights: {
      39155: 100,
    },
    county_names_all: "Trumbull",
    county_fips_all: 39155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44481,
    lat: 41.22736,
    lng: -80.86344,
    city: "Warren",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9320,
    density: 63.2,
    county_fips: 39155,
    county_name: "Trumbull",
    county_weights: {
      39099: 3.11,
      39155: 96.89,
    },
    county_names_all: "Trumbull|Mahoning",
    county_fips_all: "39155|39099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44483,
    lat: 41.26537,
    lng: -80.81575,
    city: "Warren",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24743,
    density: 521,
    county_fips: 39155,
    county_name: "Trumbull",
    county_weights: {
      39155: 100,
    },
    county_names_all: "Trumbull",
    county_fips_all: 39155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44484,
    lat: 41.2348,
    lng: -80.74962,
    city: "Warren",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21402,
    density: 461.3,
    county_fips: 39155,
    county_name: "Trumbull",
    county_weights: {
      39155: 100,
    },
    county_names_all: "Trumbull",
    county_fips_all: 39155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44485,
    lat: 41.24032,
    lng: -80.848,
    city: "Warren",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15039,
    density: 743.5,
    county_fips: 39155,
    county_name: "Trumbull",
    county_weights: {
      39155: 100,
    },
    county_names_all: "Trumbull",
    county_fips_all: 39155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44490,
    lat: 40.90041,
    lng: -80.76801,
    city: "Washingtonville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 827,
    density: 405.6,
    county_fips: 39029,
    county_name: "Columbiana",
    county_weights: {
      39029: 52.76,
      39099: 47.24,
    },
    county_names_all: "Columbiana|Mahoning",
    county_fips_all: "39029|39099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44491,
    lat: 41.37368,
    lng: -80.96478,
    city: "West Farmington",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3080,
    density: 38.9,
    county_fips: 39155,
    county_name: "Trumbull",
    county_weights: {
      39055: 14.9,
      39133: 1.47,
      39155: 83.63,
    },
    county_names_all: "Trumbull|Geauga|Portage",
    county_fips_all: "39155|39055|39133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44493,
    lat: 40.82192,
    lng: -80.88864,
    city: "Winona",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55,
    density: 18.9,
    county_fips: 39029,
    county_name: "Columbiana",
    county_weights: {
      39029: 100,
    },
    county_names_all: "Columbiana",
    county_fips_all: 39029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44502,
    lat: 41.08365,
    lng: -80.64253,
    city: "Youngstown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9127,
    density: 631.1,
    county_fips: 39099,
    county_name: "Mahoning",
    county_weights: {
      39099: 100,
    },
    county_names_all: "Mahoning",
    county_fips_all: 39099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44503,
    lat: 41.09918,
    lng: -80.64912,
    city: "Youngstown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1124,
    density: 977.2,
    county_fips: 39099,
    county_name: "Mahoning",
    county_weights: {
      39099: 100,
    },
    county_names_all: "Mahoning",
    county_fips_all: 39099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44504,
    lat: 41.12327,
    lng: -80.65363,
    city: "Youngstown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5418,
    density: 1702.1,
    county_fips: 39099,
    county_name: "Mahoning",
    county_weights: {
      39099: 98.43,
      39155: 1.57,
    },
    county_names_all: "Mahoning|Trumbull",
    county_fips_all: "39099|39155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44505,
    lat: 41.12735,
    lng: -80.61687,
    city: "Youngstown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16955,
    density: 363.4,
    county_fips: 39099,
    county_name: "Mahoning",
    county_weights: {
      39099: 63.82,
      39155: 36.18,
    },
    county_names_all: "Mahoning|Trumbull",
    county_fips_all: "39099|39155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44506,
    lat: 41.09356,
    lng: -80.62583,
    city: "Youngstown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2772,
    density: 579.4,
    county_fips: 39099,
    county_name: "Mahoning",
    county_weights: {
      39099: 100,
    },
    county_names_all: "Mahoning",
    county_fips_all: 39099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44507,
    lat: 41.07436,
    lng: -80.65542,
    city: "Youngstown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4964,
    density: 1098.4,
    county_fips: 39099,
    county_name: "Mahoning",
    county_weights: {
      39099: 100,
    },
    county_names_all: "Mahoning",
    county_fips_all: 39099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44509,
    lat: 41.10986,
    lng: -80.69655,
    city: "Youngstown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12062,
    density: 826.6,
    county_fips: 39099,
    county_name: "Mahoning",
    county_weights: {
      39099: 93.91,
      39155: 6.09,
    },
    county_names_all: "Mahoning|Trumbull",
    county_fips_all: "39099|39155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44510,
    lat: 41.12246,
    lng: -80.67424,
    city: "Youngstown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2297,
    density: 462.7,
    county_fips: 39099,
    county_name: "Mahoning",
    county_weights: {
      39099: 100,
    },
    county_names_all: "Mahoning",
    county_fips_all: 39099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44511,
    lat: 41.06927,
    lng: -80.69617,
    city: "Youngstown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19605,
    density: 1024.2,
    county_fips: 39099,
    county_name: "Mahoning",
    county_weights: {
      39099: 100,
    },
    county_names_all: "Mahoning",
    county_fips_all: 39099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44512,
    lat: 41.0249,
    lng: -80.66757,
    city: "Youngstown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32096,
    density: 728.3,
    county_fips: 39099,
    county_name: "Mahoning",
    county_weights: {
      39099: 100,
    },
    county_names_all: "Mahoning",
    county_fips_all: 39099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44514,
    lat: 40.99838,
    lng: -80.60868,
    city: "Youngstown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21912,
    density: 380.7,
    county_fips: 39099,
    county_name: "Mahoning",
    county_weights: {
      39099: 100,
    },
    county_names_all: "Mahoning",
    county_fips_all: 39099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44515,
    lat: 41.1029,
    lng: -80.76201,
    city: "Youngstown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27196,
    density: 568.5,
    county_fips: 39099,
    county_name: "Mahoning",
    county_weights: {
      39099: 100,
    },
    county_names_all: "Mahoning",
    county_fips_all: 39099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44555,
    lat: 41.10726,
    lng: -80.64875,
    city: "Youngstown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39099,
    county_name: "Mahoning",
    county_weights: {
      39099: 100,
    },
    county_names_all: "Mahoning",
    county_fips_all: 39099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44601,
    lat: 40.91978,
    lng: -81.1278,
    city: "Alliance",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34302,
    density: 161.5,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39029: 12.33,
      39099: 14.38,
      39151: 73.29,
    },
    county_names_all: "Stark|Mahoning|Columbiana",
    county_fips_all: "39151|39099|39029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44606,
    lat: 40.73313,
    lng: -81.79625,
    city: "Apple Creek",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8412,
    density: 76.5,
    county_fips: 39169,
    county_name: "Wayne",
    county_weights: {
      39169: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 39169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44607,
    lat: 40.69589,
    lng: -81.02685,
    city: "Augusta",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 128,
    density: 37.1,
    county_fips: 39019,
    county_name: "Carroll",
    county_weights: {
      39019: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 39019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44608,
    lat: 40.65241,
    lng: -81.59714,
    city: "Beach City",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1735,
    density: 30.2,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39151: 72.05,
      39157: 27.95,
    },
    county_names_all: "Stark|Tuscarawas",
    county_fips_all: "39151|39157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44609,
    lat: 40.9121,
    lng: -80.9879,
    city: "Beloit",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3828,
    density: 54.9,
    county_fips: 39099,
    county_name: "Mahoning",
    county_weights: {
      39029: 42.87,
      39099: 57.13,
    },
    county_names_all: "Mahoning|Columbiana",
    county_fips_all: "39099|39029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44610,
    lat: 40.56078,
    lng: -81.80139,
    city: "Berlin",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 128,
    density: 187.9,
    county_fips: 39075,
    county_name: "Holmes",
    county_weights: {
      39075: 100,
    },
    county_names_all: "Holmes",
    county_fips_all: 39075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44611,
    lat: 40.60785,
    lng: -82.08141,
    city: "Big Prairie",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2283,
    density: 33.1,
    county_fips: 39075,
    county_name: "Holmes",
    county_weights: {
      39075: 95.05,
      39169: 4.95,
    },
    county_names_all: "Holmes|Wayne",
    county_fips_all: "39075|39169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44612,
    lat: 40.63488,
    lng: -81.46098,
    city: "Bolivar",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5116,
    density: 74.6,
    county_fips: 39157,
    county_name: "Tuscarawas",
    county_weights: {
      39151: 16.27,
      39157: 83.73,
    },
    county_names_all: "Tuscarawas|Stark",
    county_fips_all: "39157|39151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44613,
    lat: 40.71338,
    lng: -81.60026,
    city: "Brewster",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2128,
    density: 409.3,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39151: 100,
    },
    county_names_all: "Stark",
    county_fips_all: 39151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44614,
    lat: 40.88689,
    lng: -81.58747,
    city: "Canal Fulton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12832,
    density: 217,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39151: 91.44,
      39153: 5.05,
      39169: 3.51,
    },
    county_names_all: "Stark|Summit|Wayne",
    county_fips_all: "39151|39153|39169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44615,
    lat: 40.5669,
    lng: -81.0739,
    city: "Carrollton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9694,
    density: 26,
    county_fips: 39019,
    county_name: "Carroll",
    county_weights: {
      39019: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 39019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44618,
    lat: 40.7722,
    lng: -81.68925,
    city: "Dalton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6768,
    density: 62.1,
    county_fips: 39169,
    county_name: "Wayne",
    county_weights: {
      39151: 8.08,
      39169: 91.92,
    },
    county_names_all: "Wayne|Stark",
    county_fips_all: "39169|39151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44619,
    lat: 40.90536,
    lng: -80.95381,
    city: "Damascus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39099,
    county_name: "Mahoning",
    county_weights: {
      39029: 2.21,
      39099: 97.79,
    },
    county_names_all: "Mahoning|Columbiana",
    county_fips_all: "39099|39029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44620,
    lat: 40.5811,
    lng: -81.21592,
    city: "Dellroy",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2043,
    density: 35.3,
    county_fips: 39019,
    county_name: "Carroll",
    county_weights: {
      39019: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 39019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44621,
    lat: 40.42878,
    lng: -81.28955,
    city: "Dennison",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4342,
    density: 52.3,
    county_fips: 39157,
    county_name: "Tuscarawas",
    county_weights: {
      39019: 15.48,
      39067: 19.03,
      39157: 65.49,
    },
    county_names_all: "Tuscarawas|Harrison|Carroll",
    county_fips_all: "39157|39067|39019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44622,
    lat: 40.54883,
    lng: -81.48375,
    city: "Dover",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18152,
    density: 126.1,
    county_fips: 39157,
    county_name: "Tuscarawas",
    county_weights: {
      39157: 100,
    },
    county_names_all: "Tuscarawas",
    county_fips_all: 39157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44624,
    lat: 40.61249,
    lng: -81.66157,
    city: "Dundee",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5712,
    density: 45.2,
    county_fips: 39075,
    county_name: "Holmes",
    county_weights: {
      39075: 44.2,
      39151: 1.57,
      39157: 43.45,
      39169: 10.78,
    },
    county_names_all: "Holmes|Tuscarawas|Wayne|Stark",
    county_fips_all: "39075|39157|39169|39151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44625,
    lat: 40.7623,
    lng: -80.99919,
    city: "East Rochester",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1552,
    density: 31.1,
    county_fips: 39029,
    county_name: "Columbiana",
    county_weights: {
      39019: 22.01,
      39029: 77.99,
    },
    county_names_all: "Columbiana|Carroll",
    county_fips_all: "39029|39019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44626,
    lat: 40.68994,
    lng: -81.38404,
    city: "East Sparta",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2836,
    density: 38.7,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39151: 94.58,
      39157: 5.42,
    },
    county_names_all: "Stark|Tuscarawas",
    county_fips_all: "39151|39157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44627,
    lat: 40.66665,
    lng: -81.83393,
    city: "Fredericksburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7093,
    density: 57.7,
    county_fips: 39075,
    county_name: "Holmes",
    county_weights: {
      39075: 51.15,
      39169: 48.85,
    },
    county_names_all: "Holmes|Wayne",
    county_fips_all: "39075|39169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44628,
    lat: 40.538,
    lng: -82.1551,
    city: "Glenmont",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 849,
    density: 8,
    county_fips: 39075,
    county_name: "Holmes",
    county_weights: {
      39075: 66.81,
      39083: 33.19,
    },
    county_names_all: "Holmes|Knox",
    county_fips_all: "39075|39083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44629,
    lat: 40.35107,
    lng: -81.44553,
    city: "Gnadenhutten",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3156,
    density: 59.9,
    county_fips: 39157,
    county_name: "Tuscarawas",
    county_weights: {
      39157: 100,
    },
    county_names_all: "Tuscarawas",
    county_fips_all: 39157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44630,
    lat: 40.92695,
    lng: -81.40408,
    city: "Greentown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39151: 100,
    },
    county_names_all: "Stark",
    county_fips_all: 39151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44632,
    lat: 40.96401,
    lng: -81.3048,
    city: "Hartville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10101,
    density: 140.3,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39133: 13.46,
      39151: 86.54,
    },
    county_names_all: "Stark|Portage",
    county_fips_all: "39151|39133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44633,
    lat: 40.63182,
    lng: -81.93601,
    city: "Holmesville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2522,
    density: 43.5,
    county_fips: 39075,
    county_name: "Holmes",
    county_weights: {
      39075: 100,
    },
    county_names_all: "Holmes",
    county_fips_all: 39075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44634,
    lat: 40.83385,
    lng: -81.04685,
    city: "Homeworth",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2030,
    density: 43.1,
    county_fips: 39029,
    county_name: "Columbiana",
    county_weights: {
      39029: 85.44,
      39151: 14.56,
    },
    county_names_all: "Columbiana|Stark",
    county_fips_all: "39029|39151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44637,
    lat: 40.47996,
    lng: -82.03347,
    city: "Killbuck",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2427,
    density: 17.9,
    county_fips: 39075,
    county_name: "Holmes",
    county_weights: {
      39031: 21.54,
      39075: 78.46,
    },
    county_names_all: "Holmes|Coshocton",
    county_fips_all: "39075|39031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44638,
    lat: 40.6502,
    lng: -82.13521,
    city: "Lakeville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1111,
    density: 15.1,
    county_fips: 39075,
    county_name: "Holmes",
    county_weights: {
      39005: 27.48,
      39075: 62.43,
      39169: 10.09,
    },
    county_names_all: "Holmes|Ashland|Wayne",
    county_fips_all: "39075|39005|39169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44639,
    lat: 40.45166,
    lng: -81.20963,
    city: "Leesville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39019,
    county_name: "Carroll",
    county_weights: {
      39019: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 39019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44640,
    lat: 40.98455,
    lng: -81.14858,
    city: "Limaville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 210,
    density: 347.2,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39151: 100,
    },
    county_names_all: "Stark",
    county_fips_all: 39151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44641,
    lat: 40.86528,
    lng: -81.23977,
    city: "Louisville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19523,
    density: 137.3,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39151: 100,
    },
    county_names_all: "Stark",
    county_fips_all: 39151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44643,
    lat: 40.64304,
    lng: -81.2998,
    city: "Magnolia",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4182,
    density: 54,
    county_fips: 39019,
    county_name: "Carroll",
    county_weights: {
      39019: 49.77,
      39151: 36.66,
      39157: 13.56,
    },
    county_names_all: "Carroll|Stark|Tuscarawas",
    county_fips_all: "39019|39151|39157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44644,
    lat: 40.68691,
    lng: -81.17639,
    city: "Malvern",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5114,
    density: 84.8,
    county_fips: 39019,
    county_name: "Carroll",
    county_weights: {
      39019: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 39019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44645,
    lat: 40.90796,
    lng: -81.71845,
    city: "Marshallville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2816,
    density: 44.2,
    county_fips: 39169,
    county_name: "Wayne",
    county_weights: {
      39151: 0.34,
      39153: 0.28,
      39169: 99.38,
    },
    county_names_all: "Wayne|Stark|Summit",
    county_fips_all: "39169|39151|39153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44646,
    lat: 40.81055,
    lng: -81.49835,
    city: "Massillon",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47930,
    density: 643.3,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39151: 100,
    },
    county_names_all: "Stark",
    county_fips_all: 39151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44647,
    lat: 40.79537,
    lng: -81.56575,
    city: "Massillon",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18848,
    density: 251.9,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39151: 100,
    },
    county_names_all: "Stark",
    county_fips_all: 39151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44651,
    lat: 40.6231,
    lng: -80.9556,
    city: "Mechanicstown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1019,
    density: 17.4,
    county_fips: 39019,
    county_name: "Carroll",
    county_weights: {
      39019: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 39019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44652,
    lat: 40.90088,
    lng: -81.33015,
    city: "Middlebranch",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39151: 100,
    },
    county_names_all: "Stark",
    county_fips_all: 39151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44653,
    lat: 40.43711,
    lng: -81.37105,
    city: "Midvale",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 667,
    density: 440.1,
    county_fips: 39157,
    county_name: "Tuscarawas",
    county_weights: {
      39157: 100,
    },
    county_names_all: "Tuscarawas",
    county_fips_all: 39157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44654,
    lat: 40.53861,
    lng: -81.87162,
    city: "Millersburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20376,
    density: 49.1,
    county_fips: 39075,
    county_name: "Holmes",
    county_weights: {
      39031: 6.12,
      39075: 93.88,
    },
    county_names_all: "Holmes|Coshocton",
    county_fips_all: "39075|39031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44656,
    lat: 40.57027,
    lng: -81.33104,
    city: "Mineral City",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2302,
    density: 21.9,
    county_fips: 39157,
    county_name: "Tuscarawas",
    county_weights: {
      39019: 16.4,
      39157: 83.6,
    },
    county_names_all: "Tuscarawas|Carroll",
    county_fips_all: "39157|39019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44657,
    lat: 40.74313,
    lng: -81.09343,
    city: "Minerva",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9484,
    density: 58,
    county_fips: 39019,
    county_name: "Carroll",
    county_weights: {
      39019: 36.47,
      39029: 28.71,
      39151: 34.82,
    },
    county_names_all: "Carroll|Stark|Columbiana",
    county_fips_all: "39019|39151|39029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44659,
    lat: 40.6948,
    lng: -81.70191,
    city: "Mount Eaton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 126,
    density: 307.6,
    county_fips: 39169,
    county_name: "Wayne",
    county_weights: {
      39169: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 39169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44660,
    lat: 40.62382,
    lng: -81.77487,
    city: "Mount Hope",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39075,
    county_name: "Holmes",
    county_weights: {
      39075: 100,
    },
    county_names_all: "Holmes",
    county_fips_all: 39075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44661,
    lat: 40.5874,
    lng: -82.11662,
    city: "Nashville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39075,
    county_name: "Holmes",
    county_weights: {
      39075: 100,
    },
    county_names_all: "Holmes",
    county_fips_all: 39075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44662,
    lat: 40.71036,
    lng: -81.55468,
    city: "Navarre",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10358,
    density: 69.4,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39151: 90.17,
      39169: 9.83,
    },
    county_names_all: "Stark|Wayne",
    county_fips_all: "39151|39169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44663,
    lat: 40.46066,
    lng: -81.44961,
    city: "New Philadelphia",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24735,
    density: 99.2,
    county_fips: 39157,
    county_name: "Tuscarawas",
    county_weights: {
      39157: 100,
    },
    county_names_all: "Tuscarawas",
    county_fips_all: 39157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44665,
    lat: 40.83555,
    lng: -80.98706,
    city: "North Georgetown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39029,
    county_name: "Columbiana",
    county_weights: {
      39029: 100,
    },
    county_names_all: "Columbiana",
    county_fips_all: 39029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44666,
    lat: 40.84232,
    lng: -81.63202,
    city: "North Lawrence",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2769,
    density: 45.5,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39151: 71.29,
      39169: 28.71,
    },
    county_names_all: "Stark|Wayne",
    county_fips_all: "39151|39169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44667,
    lat: 40.83386,
    lng: -81.76495,
    city: "Orrville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13123,
    density: 113.3,
    county_fips: 39169,
    county_name: "Wayne",
    county_weights: {
      39169: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 39169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44669,
    lat: 40.79613,
    lng: -81.15619,
    city: "Paris",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1608,
    density: 34.9,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39151: 100,
    },
    county_names_all: "Stark",
    county_fips_all: 39151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44670,
    lat: 40.76305,
    lng: -81.18788,
    city: "Robertsville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 128,
    density: 348.8,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39151: 100,
    },
    county_names_all: "Stark",
    county_fips_all: 39151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44671,
    lat: 40.64511,
    lng: -81.36565,
    city: "Sandyville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 128,
    density: 55.8,
    county_fips: 39157,
    county_name: "Tuscarawas",
    county_weights: {
      39157: 100,
    },
    county_names_all: "Tuscarawas",
    county_fips_all: 39157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44672,
    lat: 40.92045,
    lng: -81.02375,
    city: "Sebring",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4646,
    density: 569.5,
    county_fips: 39099,
    county_name: "Mahoning",
    county_weights: {
      39099: 100,
    },
    county_names_all: "Mahoning",
    county_fips_all: 39099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44675,
    lat: 40.50245,
    lng: -81.24975,
    city: "Sherrodsville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2046,
    density: 28.8,
    county_fips: 39019,
    county_name: "Carroll",
    county_weights: {
      39019: 70.75,
      39157: 29.25,
    },
    county_names_all: "Carroll|Tuscarawas",
    county_fips_all: "39019|39157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44676,
    lat: 40.6891,
    lng: -82.03266,
    city: "Shreve",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5083,
    density: 35.3,
    county_fips: 39169,
    county_name: "Wayne",
    county_weights: {
      39075: 26.84,
      39169: 73.16,
    },
    county_names_all: "Wayne|Holmes",
    county_fips_all: "39169|39075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44677,
    lat: 40.87254,
    lng: -81.85983,
    city: "Smithville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2338,
    density: 53.1,
    county_fips: 39169,
    county_name: "Wayne",
    county_weights: {
      39169: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 39169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44678,
    lat: 40.56478,
    lng: -81.36408,
    city: "Somerdale",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 227,
    density: 29.4,
    county_fips: 39157,
    county_name: "Tuscarawas",
    county_weights: {
      39157: 100,
    },
    county_names_all: "Tuscarawas",
    county_fips_all: 39157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44680,
    lat: 40.60174,
    lng: -81.54512,
    city: "Strasburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4391,
    density: 93.4,
    county_fips: 39157,
    county_name: "Tuscarawas",
    county_weights: {
      39157: 100,
    },
    county_names_all: "Tuscarawas",
    county_fips_all: 39157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44681,
    lat: 40.50018,
    lng: -81.6625,
    city: "Sugarcreek",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8801,
    density: 60.3,
    county_fips: 39157,
    county_name: "Tuscarawas",
    county_weights: {
      39075: 41.11,
      39157: 58.89,
    },
    county_names_all: "Tuscarawas|Holmes",
    county_fips_all: "39157|39075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44682,
    lat: 40.39765,
    lng: -81.40323,
    city: "Tuscarawas",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 988,
    density: 851,
    county_fips: 39157,
    county_name: "Tuscarawas",
    county_weights: {
      39157: 100,
    },
    county_names_all: "Tuscarawas",
    county_fips_all: 39157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44683,
    lat: 40.35505,
    lng: -81.3218,
    city: "Uhrichsville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8108,
    density: 46.7,
    county_fips: 39157,
    county_name: "Tuscarawas",
    county_weights: {
      39067: 25.11,
      39157: 74.89,
    },
    county_names_all: "Tuscarawas|Harrison",
    county_fips_all: "39157|39067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44685,
    lat: 40.9596,
    lng: -81.42361,
    city: "Uniontown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28029,
    density: 423.3,
    county_fips: 39153,
    county_name: "Summit",
    county_weights: {
      39151: 48.41,
      39153: 51.59,
    },
    county_names_all: "Summit|Stark",
    county_fips_all: "39153|39151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44687,
    lat: 40.53941,
    lng: -81.71189,
    city: "Walnut Creek",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 278,
    density: 202.1,
    county_fips: 39075,
    county_name: "Holmes",
    county_weights: {
      39075: 100,
    },
    county_names_all: "Holmes",
    county_fips_all: 39075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44688,
    lat: 40.68458,
    lng: -81.25757,
    city: "Waynesburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2858,
    density: 47.4,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39019: 29.71,
      39151: 70.29,
    },
    county_names_all: "Stark|Carroll",
    county_fips_all: "39151|39019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44689,
    lat: 40.65071,
    lng: -81.66209,
    city: "Wilmot",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 687,
    density: 97,
    county_fips: 39075,
    county_name: "Holmes",
    county_weights: {
      39075: 86.25,
      39151: 13.75,
    },
    county_names_all: "Holmes|Stark",
    county_fips_all: "39075|39151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44690,
    lat: 40.61353,
    lng: -81.69391,
    city: "Winesburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 165,
    density: 321.9,
    county_fips: 39075,
    county_name: "Holmes",
    county_weights: {
      39075: 100,
    },
    county_names_all: "Holmes",
    county_fips_all: 39075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44691,
    lat: 40.80714,
    lng: -81.97971,
    city: "Wooster",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45210,
    density: 112.7,
    county_fips: 39169,
    county_name: "Wayne",
    county_weights: {
      39005: 0.47,
      39169: 99.53,
    },
    county_names_all: "Wayne|Ashland",
    county_fips_all: "39169|39005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44693,
    lat: 40.2978,
    lng: -81.18821,
    city: "Deersville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12,
    density: 2.9,
    county_fips: 39067,
    county_name: "Harrison",
    county_weights: {
      39067: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 39067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44695,
    lat: 40.43868,
    lng: -81.1754,
    city: "Bowerston",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1738,
    density: 22.9,
    county_fips: 39019,
    county_name: "Carroll",
    county_weights: {
      39019: 58.87,
      39067: 41.13,
    },
    county_names_all: "Carroll|Harrison",
    county_fips_all: "39019|39067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44697,
    lat: 40.60807,
    lng: -81.41175,
    city: "Zoar",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 213,
    density: 53.1,
    county_fips: 39157,
    county_name: "Tuscarawas",
    county_weights: {
      39157: 100,
    },
    county_names_all: "Tuscarawas",
    county_fips_all: 39157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44699,
    lat: 40.27789,
    lng: -81.28752,
    city: "Tippecanoe",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 616,
    density: 4.1,
    county_fips: 39067,
    county_name: "Harrison",
    county_weights: {
      39067: 72.45,
      39157: 27.55,
    },
    county_names_all: "Harrison|Tuscarawas",
    county_fips_all: "39067|39157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44702,
    lat: 40.79992,
    lng: -81.37665,
    city: "Canton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 930,
    density: 639.4,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39151: 100,
    },
    county_names_all: "Stark",
    county_fips_all: 39151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44703,
    lat: 40.81093,
    lng: -81.38134,
    city: "Canton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8417,
    density: 3070.7,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39151: 100,
    },
    county_names_all: "Stark",
    county_fips_all: 39151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44704,
    lat: 40.80001,
    lng: -81.34329,
    city: "Canton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3083,
    density: 579.8,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39151: 100,
    },
    county_names_all: "Stark",
    county_fips_all: 39151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44705,
    lat: 40.83347,
    lng: -81.3327,
    city: "Canton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19353,
    density: 940.3,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39151: 100,
    },
    county_names_all: "Stark",
    county_fips_all: 39151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44706,
    lat: 40.75382,
    lng: -81.4198,
    city: "Canton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16720,
    density: 343.1,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39151: 100,
    },
    county_names_all: "Stark",
    county_fips_all: 39151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44707,
    lat: 40.76031,
    lng: -81.34715,
    city: "Canton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9414,
    density: 237.3,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39151: 100,
    },
    county_names_all: "Stark",
    county_fips_all: 39151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44708,
    lat: 40.81708,
    lng: -81.43486,
    city: "Canton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24498,
    density: 939.9,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39151: 100,
    },
    county_names_all: "Stark",
    county_fips_all: 39151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44709,
    lat: 40.84218,
    lng: -81.38634,
    city: "Canton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17762,
    density: 1181,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39151: 100,
    },
    county_names_all: "Stark",
    county_fips_all: 39151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44710,
    lat: 40.78962,
    lng: -81.42659,
    city: "Canton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8260,
    density: 1448,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39151: 100,
    },
    county_names_all: "Stark",
    county_fips_all: 39151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44714,
    lat: 40.83606,
    lng: -81.35905,
    city: "Canton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9353,
    density: 1385.5,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39151: 100,
    },
    county_names_all: "Stark",
    county_fips_all: 39151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44718,
    lat: 40.85122,
    lng: -81.44806,
    city: "Canton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12126,
    density: 559.5,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39151: 100,
    },
    county_names_all: "Stark",
    county_fips_all: 39151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44720,
    lat: 40.90112,
    lng: -81.43259,
    city: "North Canton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38137,
    density: 428.8,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39151: 72.22,
      39153: 27.78,
    },
    county_names_all: "Stark|Summit",
    county_fips_all: "39151|39153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44721,
    lat: 40.89443,
    lng: -81.32694,
    city: "Canton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14921,
    density: 362.9,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39151: 100,
    },
    county_names_all: "Stark",
    county_fips_all: 39151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44730,
    lat: 40.76706,
    lng: -81.25814,
    city: "East Canton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5996,
    density: 64,
    county_fips: 39151,
    county_name: "Stark",
    county_weights: {
      39019: 3.13,
      39151: 96.87,
    },
    county_names_all: "Stark|Carroll",
    county_fips_all: "39151|39019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44802,
    lat: 41.04534,
    lng: -83.41912,
    city: "Alvada",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1020,
    density: 14.2,
    county_fips: 39147,
    county_name: "Seneca",
    county_weights: {
      39063: 49.07,
      39147: 50.93,
    },
    county_names_all: "Seneca|Hancock",
    county_fips_all: "39147|39063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44804,
    lat: 41.10708,
    lng: -83.53538,
    city: "Arcadia",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1269,
    density: 25.2,
    county_fips: 39063,
    county_name: "Hancock",
    county_weights: {
      39063: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 39063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44805,
    lat: 40.87335,
    lng: -82.32096,
    city: "Ashland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32600,
    density: 83.3,
    county_fips: 39005,
    county_name: "Ashland",
    county_weights: {
      39005: 94.9,
      39139: 5.1,
    },
    county_names_all: "Ashland|Richland",
    county_fips_all: "39005|39139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44807,
    lat: 41.06508,
    lng: -82.87533,
    city: "Attica",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2021,
    density: 11.1,
    county_fips: 39147,
    county_name: "Seneca",
    county_weights: {
      39077: 19.96,
      39147: 80.04,
    },
    county_names_all: "Seneca|Huron",
    county_fips_all: "39147|39077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44809,
    lat: 41.13215,
    lng: -83.29391,
    city: "Bascom",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 189,
    density: 147.8,
    county_fips: 39147,
    county_name: "Seneca",
    county_weights: {
      39147: 100,
    },
    county_names_all: "Seneca",
    county_fips_all: 39147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44811,
    lat: 41.24445,
    lng: -82.84474,
    city: "Bellevue",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12345,
    density: 40.3,
    county_fips: 39077,
    county_name: "Huron",
    county_weights: {
      39043: 14.5,
      39077: 33.25,
      39143: 19.44,
      39147: 32.81,
    },
    county_names_all: "Huron|Seneca|Sandusky|Erie",
    county_fips_all: "39077|39147|39143|39043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44813,
    lat: 40.60135,
    lng: -82.52814,
    city: "Bellville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8637,
    density: 48.9,
    county_fips: 39139,
    county_name: "Richland",
    county_weights: {
      39083: 4.84,
      39117: 9.01,
      39139: 86.15,
    },
    county_names_all: "Richland|Morrow|Knox",
    county_fips_all: "39139|39117|39083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44814,
    lat: 41.32162,
    lng: -82.4714,
    city: "Berlin Heights",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2547,
    density: 38.5,
    county_fips: 39043,
    county_name: "Erie",
    county_weights: {
      39043: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 39043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44815,
    lat: 41.24697,
    lng: -83.23947,
    city: "Bettsville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 644,
    density: 218.5,
    county_fips: 39147,
    county_name: "Seneca",
    county_weights: {
      39147: 100,
    },
    county_names_all: "Seneca",
    county_fips_all: 39147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44817,
    lat: 41.1987,
    lng: -83.54676,
    city: "Bloomdale",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1614,
    density: 20.2,
    county_fips: 39173,
    county_name: "Wood",
    county_weights: {
      39063: 14.65,
      39173: 85.35,
    },
    county_names_all: "Wood|Hancock",
    county_fips_all: "39173|39063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44818,
    lat: 41.0002,
    lng: -82.99645,
    city: "Bloomville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2319,
    density: 11.9,
    county_fips: 39147,
    county_name: "Seneca",
    county_weights: {
      39033: 49.47,
      39147: 50.53,
    },
    county_names_all: "Seneca|Crawford",
    county_fips_all: "39147|39033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44820,
    lat: 40.81829,
    lng: -82.97186,
    city: "Bucyrus",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17495,
    density: 42.1,
    county_fips: 39033,
    county_name: "Crawford",
    county_weights: {
      39033: 99.47,
      39175: 0.53,
    },
    county_names_all: "Crawford|Wyandot",
    county_fips_all: "39033|39175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44822,
    lat: 40.55705,
    lng: -82.39929,
    city: "Butler",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3306,
    density: 28,
    county_fips: 39139,
    county_name: "Richland",
    county_weights: {
      39083: 41.12,
      39139: 58.88,
    },
    county_names_all: "Richland|Knox",
    county_fips_all: "39139|39083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44824,
    lat: 41.37952,
    lng: -82.80422,
    city: "Castalia",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3858,
    density: 59.3,
    county_fips: 39043,
    county_name: "Erie",
    county_weights: {
      39043: 94.28,
      39143: 5.72,
    },
    county_names_all: "Erie|Sandusky",
    county_fips_all: "39043|39143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44825,
    lat: 40.95443,
    lng: -82.94194,
    city: "Chatfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 93,
    density: 366,
    county_fips: 39033,
    county_name: "Crawford",
    county_weights: {
      39033: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 39033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44826,
    lat: 41.23993,
    lng: -82.47931,
    city: "Collins",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1402,
    density: 19.2,
    county_fips: 39077,
    county_name: "Huron",
    county_weights: {
      39043: 9.62,
      39077: 90.38,
    },
    county_names_all: "Huron|Erie",
    county_fips_all: "39077|39043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44827,
    lat: 40.81921,
    lng: -82.75923,
    city: "Crestline",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6836,
    density: 54.4,
    county_fips: 39033,
    county_name: "Crawford",
    county_weights: {
      39033: 78.14,
      39139: 21.86,
    },
    county_names_all: "Crawford|Richland",
    county_fips_all: "39033|39139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44828,
    lat: 41.23367,
    lng: -82.85957,
    city: "Flat Rock",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 157,
    density: 357.7,
    county_fips: 39147,
    county_name: "Seneca",
    county_weights: {
      39147: 100,
    },
    county_names_all: "Seneca",
    county_fips_all: 39147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44830,
    lat: 41.16603,
    lng: -83.40081,
    city: "Fostoria",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18693,
    density: 60.9,
    county_fips: 39147,
    county_name: "Seneca",
    county_weights: {
      39063: 22.2,
      39147: 58.86,
      39173: 18.94,
    },
    county_names_all: "Seneca|Hancock|Wood",
    county_fips_all: "39147|39063|39173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44833,
    lat: 40.71059,
    lng: -82.79484,
    city: "Galion",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15953,
    density: 68.1,
    county_fips: 39117,
    county_name: "Morrow",
    county_weights: {
      39033: 42.52,
      39101: 5.51,
      39117: 43.67,
      39139: 8.31,
    },
    county_names_all: "Morrow|Crawford|Richland|Marion",
    county_fips_all: "39117|39033|39139|39101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44836,
    lat: 41.23772,
    lng: -83.05455,
    city: "Green Springs",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2543,
    density: 27.5,
    county_fips: 39147,
    county_name: "Seneca",
    county_weights: {
      39143: 17.92,
      39147: 82.08,
    },
    county_names_all: "Seneca|Sandusky",
    county_fips_all: "39147|39143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44837,
    lat: 41.01745,
    lng: -82.48241,
    city: "Greenwich",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4289,
    density: 24.8,
    county_fips: 39077,
    county_name: "Huron",
    county_weights: {
      39005: 18.59,
      39077: 64.54,
      39139: 16.87,
    },
    county_names_all: "Huron|Ashland|Richland",
    county_fips_all: "39077|39005|39139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44838,
    lat: 40.77186,
    lng: -82.25947,
    city: "Hayesville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 177,
    density: 245.6,
    county_fips: 39005,
    county_name: "Ashland",
    county_weights: {
      39005: 100,
    },
    county_names_all: "Ashland",
    county_fips_all: 39005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44839,
    lat: 41.3725,
    lng: -82.55656,
    city: "Huron",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12364,
    density: 132.3,
    county_fips: 39043,
    county_name: "Erie",
    county_weights: {
      39043: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 39043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44840,
    lat: 40.79231,
    lng: -82.17973,
    city: "Jeromesville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2763,
    density: 21.9,
    county_fips: 39005,
    county_name: "Ashland",
    county_weights: {
      39005: 99.77,
      39169: 0.23,
    },
    county_names_all: "Ashland|Wayne",
    county_fips_all: "39005|39169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44841,
    lat: 41.25126,
    lng: -83.31139,
    city: "Kansas",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 663,
    density: 12.9,
    county_fips: 39147,
    county_name: "Seneca",
    county_weights: {
      39143: 44.9,
      39147: 55.1,
    },
    county_names_all: "Seneca|Sandusky",
    county_fips_all: "39147|39143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44842,
    lat: 40.64903,
    lng: -82.22498,
    city: "Loudonville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5315,
    density: 28.2,
    county_fips: 39005,
    county_name: "Ashland",
    county_weights: {
      39005: 71.02,
      39075: 26.71,
      39083: 2.27,
    },
    county_names_all: "Ashland|Holmes|Knox",
    county_fips_all: "39005|39075|39083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44843,
    lat: 40.6886,
    lng: -82.40959,
    city: "Lucas",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2334,
    density: 32.9,
    county_fips: 39139,
    county_name: "Richland",
    county_weights: {
      39005: 3.2,
      39139: 96.8,
    },
    county_names_all: "Richland|Ashland",
    county_fips_all: "39139|39005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44844,
    lat: 40.9926,
    lng: -83.25839,
    city: "McCutchenville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 543,
    density: 11.4,
    county_fips: 39147,
    county_name: "Seneca",
    county_weights: {
      39147: 52.37,
      39175: 47.63,
    },
    county_names_all: "Seneca|Wyandot",
    county_fips_all: "39147|39175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44846,
    lat: 41.31589,
    lng: -82.60832,
    city: "Milan",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3407,
    density: 58.9,
    county_fips: 39043,
    county_name: "Erie",
    county_weights: {
      39043: 97.24,
      39077: 2.76,
    },
    county_names_all: "Erie|Huron",
    county_fips_all: "39043|39077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44847,
    lat: 41.23025,
    lng: -82.70821,
    city: "Monroeville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3561,
    density: 20.1,
    county_fips: 39077,
    county_name: "Huron",
    county_weights: {
      39043: 23.76,
      39077: 76.24,
    },
    county_names_all: "Huron|Erie",
    county_fips_all: "39077|39043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44849,
    lat: 40.80863,
    lng: -83.13186,
    city: "Nevada",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2414,
    density: 18.5,
    county_fips: 39175,
    county_name: "Wyandot",
    county_weights: {
      39033: 23.53,
      39101: 3.28,
      39175: 73.19,
    },
    county_names_all: "Wyandot|Crawford|Marion",
    county_fips_all: "39175|39033|39101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44850,
    lat: 41.03539,
    lng: -82.68403,
    city: "New Haven",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27,
    density: 27.5,
    county_fips: 39077,
    county_name: "Huron",
    county_weights: {
      39077: 100,
    },
    county_names_all: "Huron",
    county_fips_all: 39077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44851,
    lat: 41.10577,
    lng: -82.40166,
    city: "New London",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4747,
    density: 24.1,
    county_fips: 39077,
    county_name: "Huron",
    county_weights: {
      39005: 8.49,
      39077: 72.79,
      39093: 18.72,
    },
    county_names_all: "Huron|Lorain|Ashland",
    county_fips_all: "39077|39093|39005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44853,
    lat: 41.05501,
    lng: -83.30399,
    city: "New Riegel",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1443,
    density: 20.4,
    county_fips: 39147,
    county_name: "Seneca",
    county_weights: {
      39147: 100,
    },
    county_names_all: "Seneca",
    county_fips_all: 39147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44854,
    lat: 40.94723,
    lng: -82.85748,
    city: "New Washington",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1465,
    density: 13.8,
    county_fips: 39033,
    county_name: "Crawford",
    county_weights: {
      39033: 92.76,
      39147: 7.24,
    },
    county_names_all: "Crawford|Seneca",
    county_fips_all: "39033|39147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44855,
    lat: 41.10414,
    lng: -82.58664,
    city: "North Fairfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1378,
    density: 19.1,
    county_fips: 39077,
    county_name: "Huron",
    county_weights: {
      39077: 100,
    },
    county_names_all: "Huron",
    county_fips_all: 39077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44856,
    lat: 40.79398,
    lng: -82.85627,
    city: "North Robinson",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 317,
    density: 3067.4,
    county_fips: 39033,
    county_name: "Crawford",
    county_weights: {
      39033: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 39033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44857,
    lat: 41.21785,
    lng: -82.58212,
    city: "Norwalk",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23646,
    density: 111.9,
    county_fips: 39077,
    county_name: "Huron",
    county_weights: {
      39043: 2.57,
      39077: 97.43,
    },
    county_names_all: "Huron|Erie",
    county_fips_all: "39077|39043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44859,
    lat: 41.02103,
    lng: -82.32636,
    city: "Nova",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2473,
    density: 30.7,
    county_fips: 39005,
    county_name: "Ashland",
    county_weights: {
      39005: 96.52,
      39093: 3.48,
    },
    county_names_all: "Ashland|Lorain",
    county_fips_all: "39005|39093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44861,
    lat: 41.24254,
    lng: -83.14626,
    city: "Old Fort",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56,
    density: 101.5,
    county_fips: 39147,
    county_name: "Seneca",
    county_weights: {
      39147: 100,
    },
    county_names_all: "Seneca",
    county_fips_all: 39147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44864,
    lat: 40.66748,
    lng: -82.31871,
    city: "Perrysville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3804,
    density: 24.7,
    county_fips: 39005,
    county_name: "Ashland",
    county_weights: {
      39005: 73.91,
      39139: 26.09,
    },
    county_names_all: "Ashland|Richland",
    county_fips_all: "39005|39139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44865,
    lat: 40.99165,
    lng: -82.68168,
    city: "Plymouth",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3136,
    density: 31.6,
    county_fips: 39077,
    county_name: "Huron",
    county_weights: {
      39033: 9.76,
      39077: 46.09,
      39139: 44.15,
    },
    county_names_all: "Huron|Richland|Crawford",
    county_fips_all: "39077|39139|39033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44866,
    lat: 40.92082,
    lng: -82.19483,
    city: "Polk",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2007,
    density: 28.3,
    county_fips: 39005,
    county_name: "Ashland",
    county_weights: {
      39005: 100,
    },
    county_names_all: "Ashland",
    county_fips_all: 39005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44867,
    lat: 41.14755,
    lng: -82.98963,
    city: "Republic",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2689,
    density: 16.9,
    county_fips: 39147,
    county_name: "Seneca",
    county_weights: {
      39147: 100,
    },
    county_names_all: "Seneca",
    county_fips_all: 39147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44870,
    lat: 41.40623,
    lng: -82.7171,
    city: "Sandusky",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39211,
    density: 249.2,
    county_fips: 39043,
    county_name: "Erie",
    county_weights: {
      39043: 100,
    },
    county_names_all: "Erie",
    county_fips_all: 39043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44874,
    lat: 40.96859,
    lng: -82.36631,
    city: "Savannah",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 305,
    density: 275.9,
    county_fips: 39005,
    county_name: "Ashland",
    county_weights: {
      39005: 100,
    },
    county_names_all: "Ashland",
    county_fips_all: 39005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44875,
    lat: 40.88645,
    lng: -82.6489,
    city: "Shelby",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13621,
    density: 64.5,
    county_fips: 39139,
    county_name: "Richland",
    county_weights: {
      39033: 6.83,
      39139: 93.17,
    },
    county_names_all: "Richland|Crawford",
    county_fips_all: "39139|39033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44878,
    lat: 40.95111,
    lng: -82.51963,
    city: "Shiloh",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2925,
    density: 19.5,
    county_fips: 39139,
    county_name: "Richland",
    county_weights: {
      39005: 4.32,
      39077: 5.86,
      39139: 89.82,
    },
    county_names_all: "Richland|Huron|Ashland",
    county_fips_all: "39139|39077|39005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44880,
    lat: 41.03352,
    lng: -82.21993,
    city: "Sullivan",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3012,
    density: 38.6,
    county_fips: 39005,
    county_name: "Ashland",
    county_weights: {
      39005: 86.05,
      39093: 12.32,
      39103: 1.63,
    },
    county_names_all: "Ashland|Lorain|Medina",
    county_fips_all: "39005|39093|39103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44881,
    lat: 40.8703,
    lng: -82.87687,
    city: "Sulphur Springs",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 66,
    density: 427.8,
    county_fips: 39033,
    county_name: "Crawford",
    county_weights: {
      39033: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 39033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44882,
    lat: 40.94759,
    lng: -83.13734,
    city: "Sycamore",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2568,
    density: 13.8,
    county_fips: 39175,
    county_name: "Wyandot",
    county_weights: {
      39033: 32.85,
      39147: 9.33,
      39175: 57.82,
    },
    county_names_all: "Wyandot|Crawford|Seneca",
    county_fips_all: "39175|39033|39147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44883,
    lat: 41.12395,
    lng: -83.17459,
    city: "Tiffin",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28326,
    density: 66.3,
    county_fips: 39147,
    county_name: "Seneca",
    county_weights: {
      39147: 100,
    },
    county_names_all: "Seneca",
    county_fips_all: 39147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44887,
    lat: 40.9205,
    lng: -82.788,
    city: "Tiro",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 870,
    density: 11.2,
    county_fips: 39033,
    county_name: "Crawford",
    county_weights: {
      39033: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 39033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44889,
    lat: 41.24661,
    lng: -82.38195,
    city: "Wakeman",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7390,
    density: 37.2,
    county_fips: 39077,
    county_name: "Huron",
    county_weights: {
      39043: 23.08,
      39077: 63.9,
      39093: 13.02,
    },
    county_names_all: "Huron|Erie|Lorain",
    county_fips_all: "39077|39043|39093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44890,
    lat: 41.0818,
    lng: -82.71248,
    city: "Willard",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10551,
    density: 48.1,
    county_fips: 39077,
    county_name: "Huron",
    county_weights: {
      39077: 100,
    },
    county_names_all: "Huron",
    county_fips_all: 39077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44901,
    lat: 40.76391,
    lng: -82.51247,
    city: "Mansfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39139,
    county_name: "Richland",
    county_weights: {
      39139: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 39139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44902,
    lat: 40.7589,
    lng: -82.51095,
    city: "Mansfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5587,
    density: 1101.6,
    county_fips: 39139,
    county_name: "Richland",
    county_weights: {
      39139: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 39139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44903,
    lat: 40.77624,
    lng: -82.52655,
    city: "Mansfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23890,
    density: 80.8,
    county_fips: 39139,
    county_name: "Richland",
    county_weights: {
      39005: 1.14,
      39117: 3.83,
      39139: 95.03,
    },
    county_names_all: "Richland|Morrow|Ashland",
    county_fips_all: "39139|39117|39005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44904,
    lat: 40.66578,
    lng: -82.61505,
    city: "Mansfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13607,
    density: 101.1,
    county_fips: 39139,
    county_name: "Richland",
    county_weights: {
      39117: 37.75,
      39139: 62.25,
    },
    county_names_all: "Richland|Morrow",
    county_fips_all: "39139|39117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44905,
    lat: 40.77753,
    lng: -82.46915,
    city: "Mansfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13574,
    density: 408.5,
    county_fips: 39139,
    county_name: "Richland",
    county_weights: {
      39139: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 39139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44906,
    lat: 40.76413,
    lng: -82.57778,
    city: "Mansfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16337,
    density: 323.8,
    county_fips: 39139,
    county_name: "Richland",
    county_weights: {
      39139: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 39139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 44907,
    lat: 40.72761,
    lng: -82.52129,
    city: "Mansfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14896,
    density: 738.8,
    county_fips: 39139,
    county_name: "Richland",
    county_weights: {
      39139: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 39139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45001,
    lat: 39.13713,
    lng: -84.71045,
    city: "Addyston",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 650,
    density: 295,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45002,
    lat: 39.19871,
    lng: -84.73422,
    city: "Cleves",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13106,
    density: 197.3,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45003,
    lat: 39.58427,
    lng: -84.77942,
    city: "College Corner",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 497,
    density: 12.6,
    county_fips: 39135,
    county_name: "Preble",
    county_weights: {
      39017: 17.75,
      39135: 82.25,
    },
    county_names_all: "Preble|Butler",
    county_fips_all: "39135|39017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45005,
    lat: 39.53478,
    lng: -84.3018,
    city: "Franklin",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32011,
    density: 337.3,
    county_fips: 39165,
    county_name: "Warren",
    county_weights: {
      39113: 0.6,
      39165: 99.4,
    },
    county_names_all: "Warren|Montgomery",
    county_fips_all: "39165|39113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45011,
    lat: 39.42892,
    lng: -84.50173,
    city: "Hamilton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 72320,
    density: 462.4,
    county_fips: 39017,
    county_name: "Butler",
    county_weights: {
      39017: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 39017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45013,
    lat: 39.40649,
    lng: -84.6501,
    city: "Hamilton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54440,
    density: 178.7,
    county_fips: 39017,
    county_name: "Butler",
    county_weights: {
      39017: 96.75,
      39061: 3.25,
    },
    county_names_all: "Butler|Hamilton",
    county_fips_all: "39017|39061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45014,
    lat: 39.32822,
    lng: -84.5521,
    city: "Fairfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43681,
    density: 746.6,
    county_fips: 39017,
    county_name: "Butler",
    county_weights: {
      39017: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 39017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45015,
    lat: 39.36273,
    lng: -84.53785,
    city: "Hamilton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11900,
    density: 815.9,
    county_fips: 39017,
    county_name: "Butler",
    county_weights: {
      39017: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 39017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45030,
    lat: 39.25621,
    lng: -84.76287,
    city: "Harrison",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19815,
    density: 190.6,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45032,
    lat: 39.50268,
    lng: -84.00811,
    city: "Harveysburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 458,
    density: 487.8,
    county_fips: 39165,
    county_name: "Warren",
    county_weights: {
      39165: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 39165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45033,
    lat: 39.17962,
    lng: -84.76469,
    city: "Hooven",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 168,
    density: 205,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45034,
    lat: 39.35749,
    lng: -84.24687,
    city: "Kings Mills",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 947,
    density: 488.5,
    county_fips: 39165,
    county_name: "Warren",
    county_weights: {
      39165: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 39165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45036,
    lat: 39.44487,
    lng: -84.21832,
    city: "Lebanon",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39240,
    density: 186.7,
    county_fips: 39165,
    county_name: "Warren",
    county_weights: {
      39165: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 39165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45039,
    lat: 39.32655,
    lng: -84.23586,
    city: "Maineville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26074,
    density: 647.2,
    county_fips: 39165,
    county_name: "Warren",
    county_weights: {
      39165: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 39165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45040,
    lat: 39.35023,
    lng: -84.30996,
    city: "Mason",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56068,
    density: 760.8,
    county_fips: 39165,
    county_name: "Warren",
    county_weights: {
      39165: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 39165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45041,
    lat: 39.21114,
    lng: -84.70292,
    city: "Miamitown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 106,
    density: 227.7,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45042,
    lat: 39.54867,
    lng: -84.43755,
    city: "Middletown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28475,
    density: 223.5,
    county_fips: 39017,
    county_name: "Butler",
    county_weights: {
      39017: 91.96,
      39113: 0.85,
      39135: 6.5,
      39165: 0.69,
    },
    county_names_all: "Butler|Preble|Montgomery|Warren",
    county_fips_all: "39017|39135|39113|39165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45044,
    lat: 39.45028,
    lng: -84.37988,
    city: "Middletown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52554,
    density: 536.9,
    county_fips: 39017,
    county_name: "Butler",
    county_weights: {
      39017: 92.16,
      39165: 7.84,
    },
    county_names_all: "Butler|Warren",
    county_fips_all: "39017|39165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45050,
    lat: 39.44437,
    lng: -84.36594,
    city: "Monroe",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9162,
    density: 419.8,
    county_fips: 39017,
    county_name: "Butler",
    county_weights: {
      39017: 82.81,
      39165: 17.19,
    },
    county_names_all: "Butler|Warren",
    county_fips_all: "39017|39165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45051,
    lat: 39.09983,
    lng: -84.65504,
    city: "Mount Saint Joseph",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 168,
    density: 142.9,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45052,
    lat: 39.14505,
    lng: -84.77849,
    city: "North Bend",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4121,
    density: 120,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45053,
    lat: 39.35273,
    lng: -84.78053,
    city: "Okeana",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4038,
    density: 57.3,
    county_fips: 39017,
    county_name: "Butler",
    county_weights: {
      39017: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 39017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45054,
    lat: 39.43844,
    lng: -84.07418,
    city: "Oregonia",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2845,
    density: 35.3,
    county_fips: 39165,
    county_name: "Warren",
    county_weights: {
      39165: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 39165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45055,
    lat: 39.45701,
    lng: -84.51094,
    city: "Overpeck",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39017,
    county_name: "Butler",
    county_weights: {
      39017: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 39017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45056,
    lat: 39.49029,
    lng: -84.74115,
    city: "Oxford",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28443,
    density: 147,
    county_fips: 39017,
    county_name: "Butler",
    county_weights: {
      39017: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 39017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45062,
    lat: 39.48501,
    lng: -84.55371,
    city: "Seven Mile",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 676,
    density: 330,
    county_fips: 39017,
    county_name: "Butler",
    county_weights: {
      39017: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 39017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45064,
    lat: 39.56806,
    lng: -84.59785,
    city: "Somerville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3380,
    density: 40.7,
    county_fips: 39017,
    county_name: "Butler",
    county_weights: {
      39017: 51.48,
      39135: 48.52,
    },
    county_names_all: "Butler|Preble",
    county_fips_all: "39017|39135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45065,
    lat: 39.37016,
    lng: -84.21426,
    city: "South Lebanon",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5965,
    density: 784.5,
    county_fips: 39165,
    county_name: "Warren",
    county_weights: {
      39165: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 39165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45066,
    lat: 39.54925,
    lng: -84.22265,
    city: "Springboro",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25245,
    density: 477.7,
    county_fips: 39165,
    county_name: "Warren",
    county_weights: {
      39113: 1.01,
      39165: 98.99,
    },
    county_names_all: "Warren|Montgomery",
    county_fips_all: "39165|39113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45067,
    lat: 39.49017,
    lng: -84.47948,
    city: "Trenton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14634,
    density: 288.4,
    county_fips: 39017,
    county_name: "Butler",
    county_weights: {
      39017: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 39017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45068,
    lat: 39.52813,
    lng: -84.05922,
    city: "Waynesville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11796,
    density: 64.5,
    county_fips: 39165,
    county_name: "Warren",
    county_weights: {
      39027: 1.92,
      39057: 9.46,
      39165: 88.62,
    },
    county_names_all: "Warren|Greene|Clinton",
    county_fips_all: "39165|39057|39027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45069,
    lat: 39.34213,
    lng: -84.4105,
    city: "West Chester",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52863,
    density: 704.6,
    county_fips: 39017,
    county_name: "Butler",
    county_weights: {
      39017: 99.23,
      39061: 0.77,
    },
    county_names_all: "Butler|Hamilton",
    county_fips_all: "39017|39061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45070,
    lat: 39.58968,
    lng: -84.55804,
    city: "West Elkton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 116,
    density: 111.2,
    county_fips: 39135,
    county_name: "Preble",
    county_weights: {
      39135: 100,
    },
    county_names_all: "Preble",
    county_fips_all: 39135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45101,
    lat: 38.69164,
    lng: -83.74024,
    city: "Aberdeen",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2145,
    density: 46.6,
    county_fips: 39015,
    county_name: "Brown",
    county_weights: {
      39001: 1.37,
      39015: 98.63,
    },
    county_names_all: "Brown|Adams",
    county_fips_all: "39015|39001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45102,
    lat: 39.01718,
    lng: -84.20602,
    city: "Amelia",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22869,
    density: 399,
    county_fips: 39025,
    county_name: "Clermont",
    county_weights: {
      39025: 100,
    },
    county_names_all: "Clermont",
    county_fips_all: 39025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45103,
    lat: 39.0946,
    lng: -84.14006,
    city: "Batavia",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31976,
    density: 144.7,
    county_fips: 39025,
    county_name: "Clermont",
    county_weights: {
      39025: 100,
    },
    county_names_all: "Clermont",
    county_fips_all: 39025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45105,
    lat: 38.75015,
    lng: -83.61235,
    city: "Bentonville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39001,
    county_name: "Adams",
    county_weights: {
      39001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 39001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45106,
    lat: 38.94633,
    lng: -84.06831,
    city: "Bethel",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13014,
    density: 68.2,
    county_fips: 39025,
    county_name: "Clermont",
    county_weights: {
      39015: 20.87,
      39025: 79.13,
    },
    county_names_all: "Clermont|Brown",
    county_fips_all: "39025|39015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45107,
    lat: 39.28888,
    lng: -83.96967,
    city: "Blanchester",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9459,
    density: 45.3,
    county_fips: 39027,
    county_name: "Clinton",
    county_weights: {
      39015: 18.08,
      39025: 11.07,
      39027: 52.13,
      39165: 18.72,
    },
    county_names_all: "Clinton|Warren|Brown|Clermont",
    county_fips_all: "39027|39165|39015|39025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45111,
    lat: 39.20033,
    lng: -84.28746,
    city: "Camp Dennison",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 345,
    density: 117.8,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45112,
    lat: 38.79377,
    lng: -84.14144,
    city: "Chilo",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62,
    density: 75.5,
    county_fips: 39025,
    county_name: "Clermont",
    county_weights: {
      39025: 100,
    },
    county_names_all: "Clermont",
    county_fips_all: 39025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45113,
    lat: 39.39991,
    lng: -83.98561,
    city: "Clarksville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4182,
    density: 42.8,
    county_fips: 39027,
    county_name: "Clinton",
    county_weights: {
      39027: 57.93,
      39165: 42.07,
    },
    county_names_all: "Clinton|Warren",
    county_fips_all: "39027|39165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45115,
    lat: 38.80818,
    lng: -83.70728,
    city: "Decatur",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 85,
    density: 7.3,
    county_fips: 39015,
    county_name: "Brown",
    county_weights: {
      39015: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 39015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45118,
    lat: 39.17192,
    lng: -83.93107,
    city: "Fayetteville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3768,
    density: 35.6,
    county_fips: 39015,
    county_name: "Brown",
    county_weights: {
      39015: 87.17,
      39025: 3.83,
      39071: 9,
    },
    county_names_all: "Brown|Highland|Clermont",
    county_fips_all: "39015|39071|39025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45119,
    lat: 38.8781,
    lng: -83.99927,
    city: "Feesburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39015,
    county_name: "Brown",
    county_weights: {
      39015: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 39015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45120,
    lat: 38.82597,
    lng: -84.09301,
    city: "Felicity",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2960,
    density: 29.4,
    county_fips: 39025,
    county_name: "Clermont",
    county_weights: {
      39015: 24.75,
      39025: 75.25,
    },
    county_names_all: "Clermont|Brown",
    county_fips_all: "39025|39015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45121,
    lat: 38.86769,
    lng: -83.90911,
    city: "Georgetown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8615,
    density: 31.1,
    county_fips: 39015,
    county_name: "Brown",
    county_weights: {
      39015: 95.19,
      39025: 4.81,
    },
    county_names_all: "Brown|Clermont",
    county_fips_all: "39015|39025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45122,
    lat: 39.22411,
    lng: -84.12698,
    city: "Goshen",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12271,
    density: 112.3,
    county_fips: 39025,
    county_name: "Clermont",
    county_weights: {
      39025: 89.85,
      39165: 10.15,
    },
    county_names_all: "Clermont|Warren",
    county_fips_all: "39025|39165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45123,
    lat: 39.3487,
    lng: -83.38866,
    city: "Greenfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8717,
    density: 31.5,
    county_fips: 39071,
    county_name: "Highland",
    county_weights: {
      39047: 23.84,
      39071: 43.29,
      39141: 32.87,
    },
    county_names_all: "Highland|Ross|Fayette",
    county_fips_all: "39071|39141|39047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45130,
    lat: 38.90886,
    lng: -83.99897,
    city: "Hamersville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4013,
    density: 40.8,
    county_fips: 39015,
    county_name: "Brown",
    county_weights: {
      39015: 82.62,
      39025: 17.38,
    },
    county_names_all: "Brown|Clermont",
    county_fips_all: "39015|39025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45131,
    lat: 38.78997,
    lng: -83.96729,
    city: "Higginsport",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 372,
    density: 572.6,
    county_fips: 39015,
    county_name: "Brown",
    county_weights: {
      39015: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 39015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45132,
    lat: 39.34395,
    lng: -83.5996,
    city: "Highland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 267,
    density: 677.4,
    county_fips: 39071,
    county_name: "Highland",
    county_weights: {
      39071: 100,
    },
    county_names_all: "Highland",
    county_fips_all: 39071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45133,
    lat: 39.15695,
    lng: -83.57282,
    city: "Hillsboro",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23449,
    density: 28.8,
    county_fips: 39071,
    county_name: "Highland",
    county_weights: {
      39015: 0.1,
      39071: 96.66,
      39131: 3.24,
    },
    county_names_all: "Highland|Pike|Brown",
    county_fips_all: "39071|39131|39015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45135,
    lat: 39.35124,
    lng: -83.54859,
    city: "Leesburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5735,
    density: 29.6,
    county_fips: 39071,
    county_name: "Highland",
    county_weights: {
      39027: 9.98,
      39047: 21.26,
      39071: 68.76,
    },
    county_names_all: "Highland|Fayette|Clinton",
    county_fips_all: "39071|39047|39027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45140,
    lat: 39.25603,
    lng: -84.24433,
    city: "Loveland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56093,
    density: 491.3,
    county_fips: 39025,
    county_name: "Clermont",
    county_weights: {
      39025: 53.33,
      39061: 15.7,
      39165: 30.97,
    },
    county_names_all: "Clermont|Warren|Hamilton",
    county_fips_all: "39025|39165|39061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45142,
    lat: 39.21033,
    lng: -83.80553,
    city: "Lynchburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3927,
    density: 24.5,
    county_fips: 39071,
    county_name: "Highland",
    county_weights: {
      39015: 6.9,
      39027: 16.86,
      39071: 76.24,
    },
    county_names_all: "Highland|Clinton|Brown",
    county_fips_all: "39071|39027|39015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45144,
    lat: 38.70534,
    lng: -83.6142,
    city: "Manchester",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3963,
    density: 21.6,
    county_fips: 39001,
    county_name: "Adams",
    county_weights: {
      39001: 90.53,
      39015: 9.47,
    },
    county_names_all: "Adams|Brown",
    county_fips_all: "39001|39015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45146,
    lat: 39.3154,
    lng: -83.79945,
    city: "Martinsville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1623,
    density: 24.2,
    county_fips: 39027,
    county_name: "Clinton",
    county_weights: {
      39027: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 39027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45147,
    lat: 39.21114,
    lng: -84.30192,
    city: "Miamiville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 208,
    density: 400.5,
    county_fips: 39025,
    county_name: "Clermont",
    county_weights: {
      39025: 100,
    },
    county_names_all: "Clermont",
    county_fips_all: 39025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45148,
    lat: 39.28849,
    lng: -83.88466,
    city: "Midland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1457,
    density: 23.2,
    county_fips: 39027,
    county_name: "Clinton",
    county_weights: {
      39015: 1.56,
      39027: 98.44,
    },
    county_names_all: "Clinton|Brown",
    county_fips_all: "39027|39015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45150,
    lat: 39.16567,
    lng: -84.23281,
    city: "Milford",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33169,
    density: 396.9,
    county_fips: 39025,
    county_name: "Clermont",
    county_weights: {
      39025: 99.11,
      39061: 0.89,
    },
    county_names_all: "Clermont|Hamilton",
    county_fips_all: "39025|39061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45152,
    lat: 39.35005,
    lng: -84.12316,
    city: "Morrow",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11958,
    density: 94.8,
    county_fips: 39165,
    county_name: "Warren",
    county_weights: {
      39165: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 39165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45153,
    lat: 38.86977,
    lng: -84.18474,
    city: "Moscow",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1564,
    density: 21.2,
    county_fips: 39025,
    county_name: "Clermont",
    county_weights: {
      39025: 100,
    },
    county_names_all: "Clermont",
    county_fips_all: 39025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45154,
    lat: 39.06137,
    lng: -83.91997,
    city: "Mount Orab",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8789,
    density: 51.8,
    county_fips: 39015,
    county_name: "Brown",
    county_weights: {
      39015: 88.59,
      39071: 11.41,
    },
    county_names_all: "Brown|Highland",
    county_fips_all: "39015|39071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45155,
    lat: 39.04057,
    lng: -83.75181,
    city: "Mowrystown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 412,
    density: 329.9,
    county_fips: 39071,
    county_name: "Highland",
    county_weights: {
      39071: 100,
    },
    county_names_all: "Highland",
    county_fips_all: 39071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45156,
    lat: 38.80947,
    lng: -84.21348,
    city: "Neville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65,
    density: 217.5,
    county_fips: 39025,
    county_name: "Clermont",
    county_weights: {
      39025: 100,
    },
    county_names_all: "Clermont",
    county_fips_all: 39025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45157,
    lat: 38.95599,
    lng: -84.22824,
    city: "New Richmond",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10228,
    density: 96,
    county_fips: 39025,
    county_name: "Clermont",
    county_weights: {
      39025: 100,
    },
    county_names_all: "Clermont",
    county_fips_all: 39025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45158,
    lat: 39.18229,
    lng: -84.07769,
    city: "Newtonsville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39025,
    county_name: "Clermont",
    county_weights: {
      39025: 100,
    },
    county_names_all: "Clermont",
    county_fips_all: 39025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45159,
    lat: 39.33389,
    lng: -83.68972,
    city: "New Vienna",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3659,
    density: 25.9,
    county_fips: 39027,
    county_name: "Clinton",
    county_weights: {
      39027: 61.8,
      39071: 38.2,
    },
    county_names_all: "Clinton|Highland",
    county_fips_all: "39027|39071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45160,
    lat: 39.12358,
    lng: -84.13725,
    city: "Owensville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 837,
    density: 1044.4,
    county_fips: 39025,
    county_name: "Clermont",
    county_weights: {
      39025: 100,
    },
    county_names_all: "Clermont",
    county_fips_all: 39025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45162,
    lat: 39.26913,
    lng: -84.07851,
    city: "Pleasant Plain",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2330,
    density: 37.7,
    county_fips: 39165,
    county_name: "Warren",
    county_weights: {
      39025: 35.99,
      39165: 64.01,
    },
    county_names_all: "Warren|Clermont",
    county_fips_all: "39165|39025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45164,
    lat: 39.55365,
    lng: -83.78532,
    city: "Port William",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 315,
    density: 704.2,
    county_fips: 39027,
    county_name: "Clinton",
    county_weights: {
      39027: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 39027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45166,
    lat: 39.4766,
    lng: -83.68774,
    city: "Reesville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69,
    density: 36,
    county_fips: 39027,
    county_name: "Clinton",
    county_weights: {
      39027: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 39027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45167,
    lat: 38.77234,
    lng: -83.79943,
    city: "Ripley",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3525,
    density: 22,
    county_fips: 39015,
    county_name: "Brown",
    county_weights: {
      39015: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 39015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45168,
    lat: 38.85266,
    lng: -83.76783,
    city: "Russellville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1585,
    density: 22.1,
    county_fips: 39015,
    county_name: "Brown",
    county_weights: {
      39015: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 39015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45169,
    lat: 39.505,
    lng: -83.65035,
    city: "Sabina",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4462,
    density: 18.4,
    county_fips: 39027,
    county_name: "Clinton",
    county_weights: {
      39027: 73.83,
      39047: 19.91,
      39057: 6.26,
    },
    county_names_all: "Clinton|Fayette|Greene",
    county_fips_all: "39027|39047|39057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45171,
    lat: 39.01414,
    lng: -83.7962,
    city: "Sardinia",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5648,
    density: 27,
    county_fips: 39015,
    county_name: "Brown",
    county_weights: {
      39015: 58.21,
      39071: 41.79,
    },
    county_names_all: "Brown|Highland",
    county_fips_all: "39015|39071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45172,
    lat: 39.07447,
    lng: -83.38688,
    city: "Sinking Spring",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 266,
    density: 232.8,
    county_fips: 39071,
    county_name: "Highland",
    county_weights: {
      39071: 100,
    },
    county_names_all: "Highland",
    county_fips_all: 39071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45174,
    lat: 39.1588,
    lng: -84.31073,
    city: "Terrace Park",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2256,
    density: 704.8,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45176,
    lat: 39.08438,
    lng: -84.02205,
    city: "Williamsburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9851,
    density: 71.6,
    county_fips: 39025,
    county_name: "Clermont",
    county_weights: {
      39015: 35.3,
      39025: 64.7,
    },
    county_names_all: "Clermont|Brown",
    county_fips_all: "39025|39015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45177,
    lat: 39.46123,
    lng: -83.83692,
    city: "Wilmington",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21756,
    density: 49.4,
    county_fips: 39027,
    county_name: "Clinton",
    county_weights: {
      39027: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 39027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45202,
    lat: 39.10885,
    lng: -84.50243,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14153,
    density: 2051.5,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45203,
    lat: 39.10403,
    lng: -84.53337,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2430,
    density: 783.8,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45204,
    lat: 39.09536,
    lng: -84.57225,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5790,
    density: 729.1,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45205,
    lat: 39.11057,
    lng: -84.57518,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18839,
    density: 2598.7,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45206,
    lat: 39.12736,
    lng: -84.48451,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10219,
    density: 1933.7,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45207,
    lat: 39.14199,
    lng: -84.4713,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6869,
    density: 2228.7,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45208,
    lat: 39.13522,
    lng: -84.43393,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17650,
    density: 1579.4,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45209,
    lat: 39.15336,
    lng: -84.42762,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10971,
    density: 1871.4,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45211,
    lat: 39.15746,
    lng: -84.59888,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37038,
    density: 1586.3,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45212,
    lat: 39.16403,
    lng: -84.45173,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22484,
    density: 2371,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45213,
    lat: 39.18111,
    lng: -84.42006,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10927,
    density: 1349.1,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45214,
    lat: 39.12271,
    lng: -84.54442,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8944,
    density: 1287.2,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45215,
    lat: 39.23536,
    lng: -84.46221,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30416,
    density: 978.6,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45216,
    lat: 39.20054,
    lng: -84.48114,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9059,
    density: 1253.4,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45217,
    lat: 39.16718,
    lng: -84.49792,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6896,
    density: 1225.9,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45218,
    lat: 39.26623,
    lng: -84.51975,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3771,
    density: 1107.3,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45219,
    lat: 39.12668,
    lng: -84.51201,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19336,
    density: 4703.8,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45220,
    lat: 39.14736,
    lng: -84.52101,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14006,
    density: 1869.2,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45223,
    lat: 39.1696,
    lng: -84.55354,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11585,
    density: 965.6,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45224,
    lat: 39.20215,
    lng: -84.53222,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21337,
    density: 1356.3,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45225,
    lat: 39.14341,
    lng: -84.55267,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9487,
    density: 1251.5,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45226,
    lat: 39.11149,
    lng: -84.41989,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5700,
    density: 385.9,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45227,
    lat: 39.15403,
    lng: -84.38524,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18659,
    density: 1248.2,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45229,
    lat: 39.15342,
    lng: -84.48612,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12966,
    density: 1841.6,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45230,
    lat: 39.07445,
    lng: -84.39082,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27721,
    density: 778.9,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45231,
    lat: 39.24617,
    lng: -84.5383,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41599,
    density: 1086.6,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45232,
    lat: 39.1818,
    lng: -84.51673,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7899,
    density: 755.3,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45233,
    lat: 39.1191,
    lng: -84.66559,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16211,
    density: 578,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45236,
    lat: 39.20949,
    lng: -84.39701,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24719,
    density: 1386,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45237,
    lat: 39.19298,
    lng: -84.45244,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22104,
    density: 1404.6,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45238,
    lat: 39.10927,
    lng: -84.61053,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46635,
    density: 1747.8,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45239,
    lat: 39.20439,
    lng: -84.57979,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29684,
    density: 1831.9,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45240,
    lat: 39.28434,
    lng: -84.52605,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27200,
    density: 1084.7,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45241,
    lat: 39.27659,
    lng: -84.40175,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23915,
    density: 528.2,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39017: 19.42,
      39061: 79.94,
      39165: 0.64,
    },
    county_names_all: "Hamilton|Butler|Warren",
    county_fips_all: "39061|39017|39165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45242,
    lat: 39.24348,
    lng: -84.35621,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21720,
    density: 618.9,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45243,
    lat: 39.18381,
    lng: -84.34171,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15545,
    density: 309.3,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45244,
    lat: 39.12009,
    lng: -84.32764,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28755,
    density: 512.2,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39025: 30.67,
      39061: 69.33,
    },
    county_names_all: "Hamilton|Clermont",
    county_fips_all: "39061|39025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45245,
    lat: 39.06065,
    lng: -84.27748,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21501,
    density: 524.2,
    county_fips: 39025,
    county_name: "Clermont",
    county_weights: {
      39025: 100,
    },
    county_names_all: "Clermont",
    county_fips_all: 39025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45246,
    lat: 39.2906,
    lng: -84.46612,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13919,
    density: 569.8,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39017: 23.27,
      39061: 76.73,
    },
    county_names_all: "Hamilton|Butler",
    county_fips_all: "39061|39017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45247,
    lat: 39.22048,
    lng: -84.65172,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22269,
    density: 406.3,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45248,
    lat: 39.16442,
    lng: -84.66229,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25023,
    density: 848.3,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45249,
    lat: 39.27617,
    lng: -84.32777,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14082,
    density: 799.2,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 92.41,
      39165: 7.59,
    },
    county_names_all: "Hamilton|Warren",
    county_fips_all: "39061|39165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45251,
    lat: 39.26789,
    lng: -84.59422,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21098,
    density: 685.6,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45252,
    lat: 39.27352,
    lng: -84.63214,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4975,
    density: 169.6,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45255,
    lat: 39.05862,
    lng: -84.32675,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21923,
    density: 653.9,
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39025: 31.5,
      39061: 68.5,
    },
    county_names_all: "Hamilton|Clermont",
    county_fips_all: "39061|39025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45267,
    lat: 39.13812,
    lng: -84.5031,
    city: "Cincinnati",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39061,
    county_name: "Hamilton",
    county_weights: {
      39061: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 39061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45301,
    lat: 39.71098,
    lng: -84.02301,
    city: "Alpha",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 302,
    density: 1051.6,
    county_fips: 39057,
    county_name: "Greene",
    county_weights: {
      39057: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 39057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45302,
    lat: 40.40068,
    lng: -84.20756,
    city: "Anna",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4558,
    density: 33.7,
    county_fips: 39149,
    county_name: "Shelby",
    county_weights: {
      39149: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 39149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45303,
    lat: 40.2146,
    lng: -84.65627,
    city: "Ansonia",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2200,
    density: 27.3,
    county_fips: 39037,
    county_name: "Darke",
    county_weights: {
      39037: 100,
    },
    county_names_all: "Darke",
    county_fips_all: 39037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45304,
    lat: 39.98756,
    lng: -84.53145,
    city: "Arcanum",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7073,
    density: 32.1,
    county_fips: 39037,
    county_name: "Darke",
    county_weights: {
      39037: 97.86,
      39109: 0.59,
      39135: 1.55,
    },
    county_names_all: "Darke|Preble|Miami",
    county_fips_all: "39037|39135|39109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45305,
    lat: 39.63628,
    lng: -84.07769,
    city: "Bellbrook",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11145,
    density: 311.1,
    county_fips: 39057,
    county_name: "Greene",
    county_weights: {
      39057: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 39057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45306,
    lat: 40.45856,
    lng: -84.18575,
    city: "Botkins",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2188,
    density: 27.1,
    county_fips: 39149,
    county_name: "Shelby",
    county_weights: {
      39011: 1.66,
      39149: 98.34,
    },
    county_names_all: "Shelby|Auglaize",
    county_fips_all: "39149|39011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45307,
    lat: 39.58065,
    lng: -83.72347,
    city: "Bowersville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 401,
    density: 899.6,
    county_fips: 39057,
    county_name: "Greene",
    county_weights: {
      39057: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 39057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45308,
    lat: 40.12535,
    lng: -84.45699,
    city: "Bradford",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4563,
    density: 34.6,
    county_fips: 39037,
    county_name: "Darke",
    county_weights: {
      39037: 72.47,
      39109: 27.53,
    },
    county_names_all: "Darke|Miami",
    county_fips_all: "39037|39109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45309,
    lat: 39.84475,
    lng: -84.42204,
    city: "Brookville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12496,
    density: 73.2,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39037: 2.41,
      39109: 2.31,
      39113: 94.63,
      39135: 0.65,
    },
    county_names_all: "Montgomery|Darke|Miami|Preble",
    county_fips_all: "39113|39037|39109|39135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45310,
    lat: 40.35299,
    lng: -84.64264,
    city: "Burkettsville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 249,
    density: 554.3,
    county_fips: 39107,
    county_name: "Mercer",
    county_weights: {
      39037: 28.71,
      39107: 71.29,
    },
    county_names_all: "Mercer|Darke",
    county_fips_all: "39107|39037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45311,
    lat: 39.62791,
    lng: -84.66411,
    city: "Camden",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6283,
    density: 28.5,
    county_fips: 39135,
    county_name: "Preble",
    county_weights: {
      39135: 100,
    },
    county_names_all: "Preble",
    county_fips_all: 39135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45312,
    lat: 40.06028,
    lng: -84.07976,
    city: "Casstown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 993,
    density: 14,
    county_fips: 39109,
    county_name: "Miami",
    county_weights: {
      39021: 2,
      39109: 98,
    },
    county_names_all: "Miami|Champaign",
    county_fips_all: "39109|39021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45314,
    lat: 39.74608,
    lng: -83.77363,
    city: "Cedarville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5864,
    density: 44,
    county_fips: 39057,
    county_name: "Greene",
    county_weights: {
      39023: 1.9,
      39057: 98.1,
    },
    county_names_all: "Greene|Clark",
    county_fips_all: "39057|39023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45315,
    lat: 39.85772,
    lng: -84.33875,
    city: "Clayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3443,
    density: 122.2,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39113: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 39113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45316,
    lat: 39.79754,
    lng: -83.82517,
    city: "Clifton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 97,
    density: 288.9,
    county_fips: 39023,
    county_name: "Clark",
    county_weights: {
      39023: 53.8,
      39057: 46.2,
    },
    county_names_all: "Clark|Greene",
    county_fips_all: "39023|39057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45317,
    lat: 40.17328,
    lng: -84.01971,
    city: "Conover",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1139,
    density: 20.4,
    county_fips: 39021,
    county_name: "Champaign",
    county_weights: {
      39021: 48.34,
      39109: 38.1,
      39149: 13.56,
    },
    county_names_all: "Champaign|Miami|Shelby",
    county_fips_all: "39021|39109|39149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45318,
    lat: 40.12745,
    lng: -84.35391,
    city: "Covington",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5684,
    density: 46.8,
    county_fips: 39109,
    county_name: "Miami",
    county_weights: {
      39037: 0.67,
      39109: 99.33,
    },
    county_names_all: "Miami|Darke",
    county_fips_all: "39109|39037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45319,
    lat: 39.91608,
    lng: -83.94324,
    city: "Donnelsville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 327,
    density: 356.3,
    county_fips: 39023,
    county_name: "Clark",
    county_weights: {
      39023: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 39023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45320,
    lat: 39.74673,
    lng: -84.68932,
    city: "Eaton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15304,
    density: 44.1,
    county_fips: 39135,
    county_name: "Preble",
    county_weights: {
      39135: 100,
    },
    county_names_all: "Preble",
    county_fips_all: 39135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45321,
    lat: 39.87134,
    lng: -84.67775,
    city: "Eldorado",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1018,
    density: 27.8,
    county_fips: 39135,
    county_name: "Preble",
    county_weights: {
      39135: 100,
    },
    county_names_all: "Preble",
    county_fips_all: 39135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45322,
    lat: 39.89967,
    lng: -84.33206,
    city: "Englewood",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22218,
    density: 405.4,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39109: 22.72,
      39113: 77.28,
    },
    county_names_all: "Montgomery|Miami",
    county_fips_all: "39113|39109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45323,
    lat: 39.85131,
    lng: -83.92794,
    city: "Enon",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4801,
    density: 296.2,
    county_fips: 39023,
    county_name: "Clark",
    county_weights: {
      39023: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 39023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45324,
    lat: 39.81986,
    lng: -84.00026,
    city: "Fairborn",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41280,
    density: 480.9,
    county_fips: 39057,
    county_name: "Greene",
    county_weights: {
      39023: 23.42,
      39057: 76.58,
    },
    county_names_all: "Greene|Clark",
    county_fips_all: "39057|39023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45325,
    lat: 39.69297,
    lng: -84.4269,
    city: "Farmersville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2424,
    density: 36.4,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39113: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 39113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45326,
    lat: 40.14201,
    lng: -84.09039,
    city: "Fletcher",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 963,
    density: 15.9,
    county_fips: 39109,
    county_name: "Miami",
    county_weights: {
      39109: 100,
    },
    county_names_all: "Miami",
    county_fips_all: 39109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45327,
    lat: 39.63286,
    lng: -84.39841,
    city: "Germantown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8892,
    density: 71.3,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39017: 1.67,
      39113: 94.13,
      39135: 4.2,
    },
    county_names_all: "Montgomery|Preble|Butler",
    county_fips_all: "39113|39135|39017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45328,
    lat: 40.11621,
    lng: -84.49676,
    city: "Gettysburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 653,
    density: 642.1,
    county_fips: 39037,
    county_name: "Darke",
    county_weights: {
      39037: 100,
    },
    county_names_all: "Darke",
    county_fips_all: 39037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45330,
    lat: 39.64821,
    lng: -84.5282,
    city: "Gratis",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 800,
    density: 332.6,
    county_fips: 39135,
    county_name: "Preble",
    county_weights: {
      39135: 100,
    },
    county_names_all: "Preble",
    county_fips_all: 39135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45331,
    lat: 40.09729,
    lng: -84.64616,
    city: "Greenville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22205,
    density: 56.7,
    county_fips: 39037,
    county_name: "Darke",
    county_weights: {
      39037: 100,
    },
    county_names_all: "Darke",
    county_fips_all: 39037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45332,
    lat: 39.99967,
    lng: -84.78776,
    city: "Hollansburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 784,
    density: 22.4,
    county_fips: 39037,
    county_name: "Darke",
    county_weights: {
      39037: 100,
    },
    county_names_all: "Darke",
    county_fips_all: 39037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45333,
    lat: 40.2481,
    lng: -84.33209,
    city: "Houston",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1355,
    density: 23.1,
    county_fips: 39149,
    county_name: "Shelby",
    county_weights: {
      39149: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 39149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45334,
    lat: 40.44662,
    lng: -84.04517,
    city: "Jackson Center",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2117,
    density: 30.3,
    county_fips: 39149,
    county_name: "Shelby",
    county_weights: {
      39011: 4.25,
      39091: 2.09,
      39149: 93.66,
    },
    county_names_all: "Shelby|Auglaize|Logan",
    county_fips_all: "39149|39011|39091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45335,
    lat: 39.63079,
    lng: -83.73353,
    city: "Jamestown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7208,
    density: 33.8,
    county_fips: 39057,
    county_name: "Greene",
    county_weights: {
      39027: 2.9,
      39047: 4.14,
      39057: 92.96,
    },
    county_names_all: "Greene|Fayette|Clinton",
    county_fips_all: "39057|39047|39027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45336,
    lat: 40.44256,
    lng: -84.25988,
    city: "Kettlersville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 129,
    density: 95.3,
    county_fips: 39149,
    county_name: "Shelby",
    county_weights: {
      39149: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 39149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45337,
    lat: 39.98019,
    lng: -84.42095,
    city: "Laura",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1758,
    density: 32.7,
    county_fips: 39109,
    county_name: "Miami",
    county_weights: {
      39037: 37.06,
      39109: 62.94,
    },
    county_names_all: "Miami|Darke",
    county_fips_all: "39109|39037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45338,
    lat: 39.85147,
    lng: -84.54417,
    city: "Lewisburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4762,
    density: 37.3,
    county_fips: 39135,
    county_name: "Preble",
    county_weights: {
      39037: 0.31,
      39135: 99.69,
    },
    county_names_all: "Preble|Darke",
    county_fips_all: "39135|39037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45339,
    lat: 40.00826,
    lng: -84.34315,
    city: "Ludlow Falls",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1245,
    density: 34.4,
    county_fips: 39109,
    county_name: "Miami",
    county_weights: {
      39109: 100,
    },
    county_names_all: "Miami",
    county_fips_all: 39109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45340,
    lat: 40.37184,
    lng: -84.04935,
    city: "Maplewood",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 578,
    density: 9.3,
    county_fips: 39149,
    county_name: "Shelby",
    county_weights: {
      39149: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 39149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45341,
    lat: 39.87589,
    lng: -84.02045,
    city: "Medway",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3403,
    density: 205.2,
    county_fips: 39023,
    county_name: "Clark",
    county_weights: {
      39023: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 39023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45342,
    lat: 39.62943,
    lng: -84.27545,
    city: "Miamisburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35630,
    density: 401,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39113: 98.45,
      39165: 1.55,
    },
    county_names_all: "Montgomery|Warren",
    county_fips_all: "39113|39165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45344,
    lat: 39.95567,
    lng: -84.00734,
    city: "New Carlisle",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16809,
    density: 92.8,
    county_fips: 39023,
    county_name: "Clark",
    county_weights: {
      39021: 1.07,
      39023: 78.42,
      39109: 20.32,
      39113: 0.19,
    },
    county_names_all: "Clark|Miami|Champaign|Montgomery",
    county_fips_all: "39023|39109|39021|39113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45345,
    lat: 39.7392,
    lng: -84.39926,
    city: "New Lebanon",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6335,
    density: 109.4,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39113: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 39113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45346,
    lat: 39.97934,
    lng: -84.70911,
    city: "New Madison",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2210,
    density: 21.2,
    county_fips: 39037,
    county_name: "Darke",
    county_weights: {
      39037: 100,
    },
    county_names_all: "Darke",
    county_fips_all: 39037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45347,
    lat: 39.88378,
    lng: -84.76208,
    city: "New Paris",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4270,
    density: 29.8,
    county_fips: 39135,
    county_name: "Preble",
    county_weights: {
      39037: 25.75,
      39135: 74.25,
    },
    county_names_all: "Preble|Darke",
    county_fips_all: "39135|39037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45348,
    lat: 40.32663,
    lng: -84.65404,
    city: "New Weston",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 883,
    density: 11.4,
    county_fips: 39037,
    county_name: "Darke",
    county_weights: {
      39037: 100,
    },
    county_names_all: "Darke",
    county_fips_all: 39037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45349,
    lat: 39.98916,
    lng: -83.94052,
    city: "North Hampton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 338,
    density: 653.8,
    county_fips: 39023,
    county_name: "Clark",
    county_weights: {
      39023: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 39023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45350,
    lat: 40.32472,
    lng: -84.57359,
    city: "North Star",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60,
    density: 119.3,
    county_fips: 39037,
    county_name: "Darke",
    county_weights: {
      39037: 100,
    },
    county_names_all: "Darke",
    county_fips_all: 39037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45351,
    lat: 40.33954,
    lng: -84.49574,
    city: "Osgood",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 220,
    density: 253.5,
    county_fips: 39037,
    county_name: "Darke",
    county_weights: {
      39037: 100,
    },
    county_names_all: "Darke",
    county_fips_all: 39037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45352,
    lat: 40.05006,
    lng: -84.74432,
    city: "Palestine",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 252,
    density: 658.6,
    county_fips: 39037,
    county_name: "Darke",
    county_weights: {
      39037: 100,
    },
    county_names_all: "Darke",
    county_fips_all: 39037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45353,
    lat: 40.29252,
    lng: -84.04274,
    city: "Pemberton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 171,
    density: 23.5,
    county_fips: 39149,
    county_name: "Shelby",
    county_weights: {
      39149: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 39149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45354,
    lat: 39.91033,
    lng: -84.39983,
    city: "Phillipsburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 637,
    density: 273.6,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39113: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 39113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45356,
    lat: 40.16252,
    lng: -84.23097,
    city: "Piqua",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24918,
    density: 127.4,
    county_fips: 39109,
    county_name: "Miami",
    county_weights: {
      39109: 84.5,
      39149: 15.5,
    },
    county_names_all: "Miami|Shelby",
    county_fips_all: "39109|39149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45358,
    lat: 39.98724,
    lng: -84.48796,
    city: "Pitsburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 247,
    density: 582.8,
    county_fips: 39037,
    county_name: "Darke",
    county_weights: {
      39037: 100,
    },
    county_names_all: "Darke",
    county_fips_all: 39037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45359,
    lat: 40.05067,
    lng: -84.3511,
    city: "Pleasant Hill",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1967,
    density: 55.1,
    county_fips: 39109,
    county_name: "Miami",
    county_weights: {
      39109: 100,
    },
    county_names_all: "Miami",
    county_fips_all: 39109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45360,
    lat: 40.33028,
    lng: -84.09206,
    city: "Port Jefferson",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 412,
    density: 962.8,
    county_fips: 39149,
    county_name: "Shelby",
    county_weights: {
      39149: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 39149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45361,
    lat: 39.96374,
    lng: -84.41484,
    city: "Potsdam",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 338,
    density: 292.7,
    county_fips: 39109,
    county_name: "Miami",
    county_weights: {
      39109: 100,
    },
    county_names_all: "Miami",
    county_fips_all: 39109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45362,
    lat: 40.28684,
    lng: -84.63368,
    city: "Rossburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1187,
    density: 14.4,
    county_fips: 39037,
    county_name: "Darke",
    county_weights: {
      39037: 100,
    },
    county_names_all: "Darke",
    county_fips_all: 39037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45363,
    lat: 40.23925,
    lng: -84.39841,
    city: "Russia",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1630,
    density: 27.6,
    county_fips: 39149,
    county_name: "Shelby",
    county_weights: {
      39149: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 39149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45365,
    lat: 40.2828,
    lng: -84.15582,
    city: "Sidney",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30024,
    density: 74.4,
    county_fips: 39149,
    county_name: "Shelby",
    county_weights: {
      39021: 0.62,
      39149: 99.38,
    },
    county_names_all: "Shelby|Champaign",
    county_fips_all: "39149|39021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45368,
    lat: 39.84376,
    lng: -83.65413,
    city: "South Charleston",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4554,
    density: 22.2,
    county_fips: 39023,
    county_name: "Clark",
    county_weights: {
      39023: 93.18,
      39057: 6.82,
    },
    county_names_all: "Clark|Greene",
    county_fips_all: "39023|39057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45369,
    lat: 39.95304,
    lng: -83.60304,
    city: "South Vienna",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3709,
    density: 33.4,
    county_fips: 39023,
    county_name: "Clark",
    county_weights: {
      39023: 96.88,
      39097: 3.12,
    },
    county_names_all: "Clark|Madison",
    county_fips_all: "39023|39097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45370,
    lat: 39.60853,
    lng: -84.04015,
    city: "Spring Valley",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3125,
    density: 72.4,
    county_fips: 39057,
    county_name: "Greene",
    county_weights: {
      39057: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 39057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45371,
    lat: 39.93885,
    lng: -84.16357,
    city: "Tipp City",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20904,
    density: 157.6,
    county_fips: 39109,
    county_name: "Miami",
    county_weights: {
      39109: 95.71,
      39113: 4.29,
    },
    county_names_all: "Miami|Montgomery",
    county_fips_all: "39109|39113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45372,
    lat: 40.01471,
    lng: -83.83862,
    city: "Tremont City",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 307,
    density: 535.4,
    county_fips: 39023,
    county_name: "Clark",
    county_weights: {
      39023: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 39023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45373,
    lat: 40.03353,
    lng: -84.19588,
    city: "Troy",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35913,
    density: 158.1,
    county_fips: 39109,
    county_name: "Miami",
    county_weights: {
      39109: 100,
    },
    county_names_all: "Miami",
    county_fips_all: 39109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45377,
    lat: 39.89636,
    lng: -84.22774,
    city: "Vandalia",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15439,
    density: 280.6,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39113: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 39113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45378,
    lat: 39.90291,
    lng: -84.48781,
    city: "Verona",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 458,
    density: 577,
    county_fips: 39135,
    county_name: "Preble",
    county_weights: {
      39113: 19.84,
      39135: 80.16,
    },
    county_names_all: "Preble|Montgomery",
    county_fips_all: "39135|39113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45380,
    lat: 40.24511,
    lng: -84.51314,
    city: "Versailles",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5476,
    density: 30.7,
    county_fips: 39037,
    county_name: "Darke",
    county_weights: {
      39037: 98.93,
      39149: 1.07,
    },
    county_names_all: "Darke|Shelby",
    county_fips_all: "39037|39149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45381,
    lat: 39.73223,
    lng: -84.52433,
    city: "West Alexandria",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5532,
    density: 39.6,
    county_fips: 39135,
    county_name: "Preble",
    county_weights: {
      39113: 9.3,
      39135: 90.7,
    },
    county_names_all: "Preble|Montgomery",
    county_fips_all: "39135|39113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45382,
    lat: 39.89621,
    lng: -84.61626,
    city: "West Manchester",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1187,
    density: 22.4,
    county_fips: 39135,
    county_name: "Preble",
    county_weights: {
      39037: 24.05,
      39135: 75.95,
    },
    county_names_all: "Preble|Darke",
    county_fips_all: "39135|39037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45383,
    lat: 39.9572,
    lng: -84.3337,
    city: "West Milton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7094,
    density: 116.6,
    county_fips: 39109,
    county_name: "Miami",
    county_weights: {
      39109: 100,
    },
    county_names_all: "Miami",
    county_fips_all: 39109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45384,
    lat: 39.71444,
    lng: -83.88638,
    city: "Wilberforce",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2252,
    density: 370.2,
    county_fips: 39057,
    county_name: "Greene",
    county_weights: {
      39057: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 39057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45385,
    lat: 39.66813,
    lng: -83.91457,
    city: "Xenia",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39116,
    density: 110,
    county_fips: 39057,
    county_name: "Greene",
    county_weights: {
      39057: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 39057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45387,
    lat: 39.79754,
    lng: -83.88622,
    city: "Yellow Springs",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5605,
    density: 75.7,
    county_fips: 39057,
    county_name: "Greene",
    county_weights: {
      39023: 8.54,
      39057: 91.46,
    },
    county_names_all: "Greene|Clark",
    county_fips_all: "39057|39023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45388,
    lat: 40.32799,
    lng: -84.47901,
    city: "Yorkshire",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 730,
    density: 16.1,
    county_fips: 39037,
    county_name: "Darke",
    county_weights: {
      39037: 95.79,
      39107: 1.94,
      39149: 2.27,
    },
    county_names_all: "Darke|Shelby|Mercer",
    county_fips_all: "39037|39149|39107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45389,
    lat: 40.05639,
    lng: -84.02532,
    city: "Christiansburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 481,
    density: 924.3,
    county_fips: 39021,
    county_name: "Champaign",
    county_weights: {
      39021: 100,
    },
    county_names_all: "Champaign",
    county_fips_all: 39021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45390,
    lat: 40.21894,
    lng: -84.76778,
    city: "Union City",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3235,
    density: 23.3,
    county_fips: 39037,
    county_name: "Darke",
    county_weights: {
      39037: 100,
    },
    county_names_all: "Darke",
    county_fips_all: 39037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45402,
    lat: 39.75983,
    lng: -84.20751,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10119,
    density: 894.9,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39113: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 39113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45403,
    lat: 39.76303,
    lng: -84.14978,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13275,
    density: 1628.8,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39113: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 39113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45404,
    lat: 39.79011,
    lng: -84.15324,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10541,
    density: 538.5,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39113: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 39113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45405,
    lat: 39.79241,
    lng: -84.21592,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18133,
    density: 1764.4,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39113: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 39113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45406,
    lat: 39.78442,
    lng: -84.24178,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20393,
    density: 1580.5,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39113: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 39113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45409,
    lat: 39.72334,
    lng: -84.19039,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15993,
    density: 1679.2,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39113: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 39113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45410,
    lat: 39.74757,
    lng: -84.15907,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16627,
    density: 2667.2,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39113: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 39113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45414,
    lat: 39.84008,
    lng: -84.21115,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20177,
    density: 358,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39113: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 39113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45415,
    lat: 39.83473,
    lng: -84.2568,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12653,
    density: 813.2,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39113: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 39113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45416,
    lat: 39.80754,
    lng: -84.25774,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5298,
    density: 1056.1,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39113: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 39113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45417,
    lat: 39.73427,
    lng: -84.2844,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29072,
    density: 348.6,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39113: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 39113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45419,
    lat: 39.71436,
    lng: -84.1676,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15285,
    density: 1583.7,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39113: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 39113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45420,
    lat: 39.719,
    lng: -84.13045,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24901,
    density: 1492.1,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39113: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 39113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45423,
    lat: 39.7604,
    lng: -84.19112,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39113: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 39113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45424,
    lat: 39.84695,
    lng: -84.11032,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51344,
    density: 629,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39057: 11.42,
      39109: 4.08,
      39113: 84.5,
    },
    county_names_all: "Montgomery|Greene|Miami",
    county_fips_all: "39113|39057|39109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45426,
    lat: 39.80094,
    lng: -84.31461,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15329,
    density: 297.4,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39113: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 39113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45428,
    lat: 39.74211,
    lng: -84.25954,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 353,
    density: 299.4,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39113: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 39113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45429,
    lat: 39.68411,
    lng: -84.16248,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25494,
    density: 994.3,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39113: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 39113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45430,
    lat: 39.71296,
    lng: -84.08435,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7006,
    density: 559,
    county_fips: 39057,
    county_name: "Greene",
    county_weights: {
      39057: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 39057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45431,
    lat: 39.76488,
    lng: -84.08012,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27145,
    density: 893.3,
    county_fips: 39057,
    county_name: "Greene",
    county_weights: {
      39057: 61.69,
      39113: 38.31,
    },
    county_names_all: "Greene|Montgomery",
    county_fips_all: "39057|39113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45432,
    lat: 39.73934,
    lng: -84.08627,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16085,
    density: 870.7,
    county_fips: 39057,
    county_name: "Greene",
    county_weights: {
      39057: 66.53,
      39113: 33.47,
    },
    county_names_all: "Greene|Montgomery",
    county_fips_all: "39057|39113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45433,
    lat: 39.81359,
    lng: -84.05273,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2519,
    density: 136.8,
    county_fips: 39057,
    county_name: "Greene",
    county_weights: {
      39057: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 39057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45434,
    lat: 39.72284,
    lng: -84.03052,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12059,
    density: 446.2,
    county_fips: 39057,
    county_name: "Greene",
    county_weights: {
      39057: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 39057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45435,
    lat: 39.78114,
    lng: -84.06312,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39057,
    county_name: "Greene",
    county_weights: {
      39057: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 39057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45439,
    lat: 39.69867,
    lng: -84.22944,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10496,
    density: 521,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39113: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 39113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45440,
    lat: 39.67498,
    lng: -84.10001,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21667,
    density: 909.6,
    county_fips: 39057,
    county_name: "Greene",
    county_weights: {
      39057: 63.85,
      39113: 36.15,
    },
    county_names_all: "Greene|Montgomery",
    county_fips_all: "39057|39113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45449,
    lat: 39.66472,
    lng: -84.24067,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18428,
    density: 1046.6,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39113: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 39113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45458,
    lat: 39.60036,
    lng: -84.1576,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32515,
    density: 631.8,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39057: 2.08,
      39113: 82.35,
      39165: 15.57,
    },
    county_names_all: "Montgomery|Warren|Greene",
    county_fips_all: "39113|39165|39057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45459,
    lat: 39.64658,
    lng: -84.16693,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26397,
    density: 718,
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39057: 3.37,
      39113: 96.63,
    },
    county_names_all: "Montgomery|Greene",
    county_fips_all: "39113|39057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45469,
    lat: 39.74033,
    lng: -84.17911,
    city: "Dayton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39113,
    county_name: "Montgomery",
    county_weights: {
      39113: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 39113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45501,
    lat: 39.92634,
    lng: -83.80745,
    city: "Springfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39023,
    county_name: "Clark",
    county_weights: {
      39023: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 39023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45502,
    lat: 39.92791,
    lng: -83.81703,
    city: "Springfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15291,
    density: 51.2,
    county_fips: 39023,
    county_name: "Clark",
    county_weights: {
      39021: 1.34,
      39023: 98.66,
    },
    county_names_all: "Clark|Champaign",
    county_fips_all: "39023|39021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45503,
    lat: 39.96073,
    lng: -83.7682,
    city: "Springfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32250,
    density: 713,
    county_fips: 39023,
    county_name: "Clark",
    county_weights: {
      39023: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 39023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45504,
    lat: 39.94811,
    lng: -83.86481,
    city: "Springfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16908,
    density: 297.4,
    county_fips: 39023,
    county_name: "Clark",
    county_weights: {
      39023: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 39023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45505,
    lat: 39.90737,
    lng: -83.7615,
    city: "Springfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20550,
    density: 582.6,
    county_fips: 39023,
    county_name: "Clark",
    county_weights: {
      39023: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 39023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45506,
    lat: 39.89907,
    lng: -83.85233,
    city: "Springfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13876,
    density: 438.3,
    county_fips: 39023,
    county_name: "Clark",
    county_weights: {
      39023: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 39023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45601,
    lat: 39.30996,
    lng: -82.9555,
    city: "Chillicothe",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55220,
    density: 61.1,
    county_fips: 39141,
    county_name: "Ross",
    county_weights: {
      39079: 2.63,
      39131: 3.43,
      39141: 93.94,
    },
    county_names_all: "Ross|Pike|Jackson",
    county_fips_all: "39141|39131|39079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45612,
    lat: 39.21569,
    lng: -83.27171,
    city: "Bainbridge",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4172,
    density: 14.4,
    county_fips: 39141,
    county_name: "Ross",
    county_weights: {
      39071: 11.23,
      39131: 26.76,
      39141: 62.01,
    },
    county_names_all: "Ross|Pike|Highland",
    county_fips_all: "39141|39131|39071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45613,
    lat: 39.0318,
    lng: -82.84885,
    city: "Beaver",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2642,
    density: 12.4,
    county_fips: 39131,
    county_name: "Pike",
    county_weights: {
      39079: 12.75,
      39131: 82.84,
      39145: 4.41,
    },
    county_names_all: "Pike|Jackson|Scioto",
    county_fips_all: "39131|39079|39145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45614,
    lat: 38.92858,
    lng: -82.27819,
    city: "Bidwell",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4759,
    density: 25.9,
    county_fips: 39053,
    county_name: "Gallia",
    county_weights: {
      39053: 100,
    },
    county_names_all: "Gallia",
    county_fips_all: 39053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45616,
    lat: 38.76018,
    lng: -83.30864,
    city: "Blue Creek",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1943,
    density: 10.3,
    county_fips: 39001,
    county_name: "Adams",
    county_weights: {
      39001: 74.45,
      39145: 25.55,
    },
    county_names_all: "Adams|Scioto",
    county_fips_all: "39001|39145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45617,
    lat: 39.27967,
    lng: -83.15559,
    city: "Bourneville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 200,
    density: 461.3,
    county_fips: 39141,
    county_name: "Ross",
    county_weights: {
      39141: 100,
    },
    county_names_all: "Ross",
    county_fips_all: 39141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45618,
    lat: 38.88502,
    lng: -83.61623,
    city: "Cherry Fork",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 39001,
    county_name: "Adams",
    county_weights: {
      39001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 39001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45619,
    lat: 38.47257,
    lng: -82.45157,
    city: "Chesapeake",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7468,
    density: 89.7,
    county_fips: 39087,
    county_name: "Lawrence",
    county_weights: {
      39087: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 39087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45620,
    lat: 38.95564,
    lng: -82.14052,
    city: "Cheshire",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 792,
    density: 14.1,
    county_fips: 39053,
    county_name: "Gallia",
    county_weights: {
      39053: 97.7,
      39105: 2.3,
    },
    county_names_all: "Gallia|Meigs",
    county_fips_all: "39053|39105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45621,
    lat: 39.11138,
    lng: -82.60996,
    city: "Coalton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 300,
    density: 242.1,
    county_fips: 39079,
    county_name: "Jackson",
    county_weights: {
      39079: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 39079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45622,
    lat: 39.35905,
    lng: -82.49522,
    city: "Creola",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48,
    density: 0.8,
    county_fips: 39163,
    county_name: "Vinton",
    county_weights: {
      39073: 17.56,
      39163: 82.44,
    },
    county_names_all: "Vinton|Hocking",
    county_fips_all: "39163|39073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45623,
    lat: 38.64125,
    lng: -82.26748,
    city: "Crown City",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3357,
    density: 17.9,
    county_fips: 39053,
    county_name: "Gallia",
    county_weights: {
      39053: 91.37,
      39087: 8.63,
    },
    county_names_all: "Gallia|Lawrence",
    county_fips_all: "39053|39087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45624,
    lat: 39.17301,
    lng: -83.3487,
    city: "Cynthiana",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29,
    density: 536.2,
    county_fips: 39131,
    county_name: "Pike",
    county_weights: {
      39131: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 39131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45628,
    lat: 39.38959,
    lng: -83.19657,
    city: "Frankfort",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5601,
    density: 28.5,
    county_fips: 39141,
    county_name: "Ross",
    county_weights: {
      39141: 100,
    },
    county_names_all: "Ross",
    county_fips_all: 39141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45629,
    lat: 38.65221,
    lng: -82.81051,
    city: "Franklin Furnace",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2960,
    density: 35.4,
    county_fips: 39145,
    county_name: "Scioto",
    county_weights: {
      39087: 0.81,
      39145: 99.19,
    },
    county_names_all: "Scioto|Lawrence",
    county_fips_all: "39145|39087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45630,
    lat: 38.69758,
    lng: -83.09275,
    city: "Friendship",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75,
    density: 131.3,
    county_fips: 39145,
    county_name: "Scioto",
    county_weights: {
      39145: 100,
    },
    county_names_all: "Scioto",
    county_fips_all: 39145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45631,
    lat: 38.81672,
    lng: -82.25486,
    city: "Gallipolis",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14166,
    density: 47.7,
    county_fips: 39053,
    county_name: "Gallia",
    county_weights: {
      39053: 100,
    },
    county_names_all: "Gallia",
    county_fips_all: 39053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45634,
    lat: 39.17891,
    lng: -82.49037,
    city: "Hamden",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1783,
    density: 19.8,
    county_fips: 39163,
    county_name: "Vinton",
    county_weights: {
      39079: 1.35,
      39163: 98.65,
    },
    county_names_all: "Vinton|Jackson",
    county_fips_all: "39163|39079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45636,
    lat: 38.58416,
    lng: -82.81401,
    city: "Haverhill",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58,
    density: 13.2,
    county_fips: 39145,
    county_name: "Scioto",
    county_weights: {
      39145: 100,
    },
    county_names_all: "Scioto",
    county_fips_all: 39145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45638,
    lat: 38.56217,
    lng: -82.67607,
    city: "Ironton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21514,
    density: 108,
    county_fips: 39087,
    county_name: "Lawrence",
    county_weights: {
      39087: 88.73,
      39145: 11.27,
    },
    county_names_all: "Lawrence|Scioto",
    county_fips_all: "39087|39145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45640,
    lat: 39.02345,
    lng: -82.65032,
    city: "Jackson",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15871,
    density: 35.1,
    county_fips: 39079,
    county_name: "Jackson",
    county_weights: {
      39079: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 39079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45642,
    lat: 39.04692,
    lng: -83.05408,
    city: "Jasper",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 39131,
    county_name: "Pike",
    county_weights: {
      39131: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 39131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45644,
    lat: 39.45245,
    lng: -82.84176,
    city: "Kingston",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5116,
    density: 32.4,
    county_fips: 39141,
    county_name: "Ross",
    county_weights: {
      39129: 32.44,
      39141: 67.56,
    },
    county_names_all: "Ross|Pickaway",
    county_fips_all: "39141|39129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45645,
    lat: 38.57082,
    lng: -82.53159,
    city: "Kitts Hill",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3184,
    density: 26.9,
    county_fips: 39087,
    county_name: "Lawrence",
    county_weights: {
      39087: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 39087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45646,
    lat: 39.07686,
    lng: -83.31627,
    city: "Latham",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 500,
    density: 12.9,
    county_fips: 39131,
    county_name: "Pike",
    county_weights: {
      39001: 0.12,
      39131: 99.88,
    },
    county_names_all: "Pike|Adams",
    county_fips_all: "39131|39001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45647,
    lat: 39.29597,
    lng: -82.73803,
    city: "Londonderry",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3175,
    density: 18.5,
    county_fips: 39163,
    county_name: "Vinton",
    county_weights: {
      39141: 35.67,
      39163: 64.33,
    },
    county_names_all: "Vinton|Ross",
    county_fips_all: "39163|39141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45648,
    lat: 38.92161,
    lng: -83.01393,
    city: "Lucasville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12571,
    density: 34.8,
    county_fips: 39145,
    county_name: "Scioto",
    county_weights: {
      39131: 26.7,
      39145: 73.3,
    },
    county_names_all: "Scioto|Pike",
    county_fips_all: "39145|39131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45650,
    lat: 38.74415,
    lng: -83.42099,
    city: "Lynx",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 331,
    density: 8.6,
    county_fips: 39001,
    county_name: "Adams",
    county_weights: {
      39001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 39001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45651,
    lat: 39.27665,
    lng: -82.47706,
    city: "McArthur",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5530,
    density: 15,
    county_fips: 39163,
    county_name: "Vinton",
    county_weights: {
      39163: 100,
    },
    county_names_all: "Vinton",
    county_fips_all: 39163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45652,
    lat: 38.82911,
    lng: -83.08018,
    city: "McDermott",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3743,
    density: 41.3,
    county_fips: 39145,
    county_name: "Scioto",
    county_weights: {
      39145: 100,
    },
    county_names_all: "Scioto",
    county_fips_all: 39145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45653,
    lat: 38.88976,
    lng: -82.82306,
    city: "Minford",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3928,
    density: 35.5,
    county_fips: 39145,
    county_name: "Scioto",
    county_weights: {
      39079: 1.27,
      39145: 98.73,
    },
    county_names_all: "Scioto|Jackson",
    county_fips_all: "39145|39079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45654,
    lat: 39.36671,
    lng: -82.37774,
    city: "New Plymouth",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1038,
    density: 7.5,
    county_fips: 39163,
    county_name: "Vinton",
    county_weights: {
      39073: 27.57,
      39163: 72.43,
    },
    county_names_all: "Vinton|Hocking",
    county_fips_all: "39163|39073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45656,
    lat: 38.87565,
    lng: -82.59143,
    city: "Oak Hill",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6730,
    density: 19.4,
    county_fips: 39079,
    county_name: "Jackson",
    county_weights: {
      39053: 14.93,
      39079: 73.44,
      39087: 10.82,
      39145: 0.81,
    },
    county_names_all: "Jackson|Gallia|Lawrence|Scioto",
    county_fips_all: "39079|39053|39087|39145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45657,
    lat: 38.85166,
    lng: -83.21011,
    city: "Otway",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1535,
    density: 6.3,
    county_fips: 39145,
    county_name: "Scioto",
    county_weights: {
      39001: 11.65,
      39131: 1.25,
      39145: 87.1,
    },
    county_names_all: "Scioto|Adams|Pike",
    county_fips_all: "39145|39001|39131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45658,
    lat: 38.76324,
    lng: -82.41411,
    city: "Patriot",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3042,
    density: 12.5,
    county_fips: 39053,
    county_name: "Gallia",
    county_weights: {
      39053: 97.93,
      39087: 2.07,
    },
    county_names_all: "Gallia|Lawrence",
    county_fips_all: "39053|39087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45659,
    lat: 38.67117,
    lng: -82.62331,
    city: "Pedro",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2441,
    density: 9.5,
    county_fips: 39087,
    county_name: "Lawrence",
    county_weights: {
      39087: 99.78,
      39145: 0.22,
    },
    county_names_all: "Lawrence|Scioto",
    county_fips_all: "39087|39145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45660,
    lat: 38.98626,
    lng: -83.358,
    city: "Peebles",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7534,
    density: 14.4,
    county_fips: 39001,
    county_name: "Adams",
    county_weights: {
      39001: 74.78,
      39071: 3.15,
      39131: 19.35,
      39145: 2.72,
    },
    county_names_all: "Adams|Pike|Highland|Scioto",
    county_fips_all: "39001|39131|39071|39145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45661,
    lat: 39.04096,
    lng: -83.10479,
    city: "Piketon",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7138,
    density: 27.4,
    county_fips: 39131,
    county_name: "Pike",
    county_weights: {
      39131: 99.6,
      39145: 0.4,
    },
    county_names_all: "Pike|Scioto",
    county_fips_all: "39131|39145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45662,
    lat: 38.78938,
    lng: -82.92114,
    city: "Portsmouth",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29493,
    density: 205,
    county_fips: 39145,
    county_name: "Scioto",
    county_weights: {
      39145: 100,
    },
    county_names_all: "Scioto",
    county_fips_all: 39145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45663,
    lat: 38.74507,
    lng: -83.11198,
    city: "West Portsmouth",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6294,
    density: 36.1,
    county_fips: 39145,
    county_name: "Scioto",
    county_weights: {
      39145: 100,
    },
    county_names_all: "Scioto",
    county_fips_all: 39145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45669,
    lat: 38.4935,
    lng: -82.35857,
    city: "Proctorville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9796,
    density: 106,
    county_fips: 39087,
    county_name: "Lawrence",
    county_weights: {
      39087: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 39087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45671,
    lat: 38.97339,
    lng: -83.23775,
    city: "Rarden",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 284,
    density: 7.4,
    county_fips: 39145,
    county_name: "Scioto",
    county_weights: {
      39001: 0.44,
      39131: 14.71,
      39145: 84.85,
    },
    county_names_all: "Scioto|Pike|Adams",
    county_fips_all: "39145|39131|39001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45672,
    lat: 39.20549,
    lng: -82.67579,
    city: "Ray",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1203,
    density: 8.1,
    county_fips: 39163,
    county_name: "Vinton",
    county_weights: {
      39079: 41.6,
      39141: 0.55,
      39163: 57.85,
    },
    county_names_all: "Vinton|Jackson|Ross",
    county_fips_all: "39163|39079|39141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45673,
    lat: 39.20399,
    lng: -82.81148,
    city: "Richmond Dale",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 584,
    density: 460.3,
    county_fips: 39141,
    county_name: "Ross",
    county_weights: {
      39141: 100,
    },
    county_names_all: "Ross",
    county_fips_all: 39141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45674,
    lat: 38.87798,
    lng: -82.38017,
    city: "Rio Grande",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 576,
    density: 190,
    county_fips: 39053,
    county_name: "Gallia",
    county_weights: {
      39053: 100,
    },
    county_names_all: "Gallia",
    county_fips_all: 39053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45677,
    lat: 38.79555,
    lng: -82.75511,
    city: "Scioto Furnace",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39145,
    county_name: "Scioto",
    county_weights: {
      39145: 100,
    },
    county_names_all: "Scioto",
    county_fips_all: 39145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45678,
    lat: 38.60595,
    lng: -82.37883,
    city: "Scottown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 923,
    density: 7.8,
    county_fips: 39087,
    county_name: "Lawrence",
    county_weights: {
      39053: 18.5,
      39087: 81.5,
    },
    county_names_all: "Lawrence|Gallia",
    county_fips_all: "39087|39053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45679,
    lat: 38.97634,
    lng: -83.56788,
    city: "Seaman",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2714,
    density: 16.7,
    county_fips: 39001,
    county_name: "Adams",
    county_weights: {
      39001: 91.76,
      39071: 8.24,
    },
    county_names_all: "Adams|Highland",
    county_fips_all: "39001|39071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45680,
    lat: 38.45526,
    lng: -82.54489,
    city: "South Point",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12897,
    density: 144,
    county_fips: 39087,
    county_name: "Lawrence",
    county_weights: {
      39087: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 39087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45681,
    lat: 39.30551,
    lng: -83.24807,
    city: "South Salem",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1525,
    density: 16.3,
    county_fips: 39141,
    county_name: "Ross",
    county_weights: {
      39141: 100,
    },
    county_names_all: "Ross",
    county_fips_all: 39141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45682,
    lat: 38.80839,
    lng: -82.69658,
    city: "South Webster",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2082,
    density: 16.6,
    county_fips: 39145,
    county_name: "Scioto",
    county_weights: {
      39079: 2.09,
      39087: 21.15,
      39145: 76.76,
    },
    county_names_all: "Scioto|Lawrence|Jackson",
    county_fips_all: "39145|39087|39079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45684,
    lat: 38.67546,
    lng: -83.27789,
    city: "Stout",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1836,
    density: 8.5,
    county_fips: 39001,
    county_name: "Adams",
    county_weights: {
      39001: 57.8,
      39145: 42.2,
    },
    county_names_all: "Adams|Scioto",
    county_fips_all: "39001|39145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45685,
    lat: 38.9333,
    lng: -82.4527,
    city: "Thurman",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1471,
    density: 18.7,
    county_fips: 39079,
    county_name: "Jackson",
    county_weights: {
      39053: 34.24,
      39079: 65.76,
    },
    county_names_all: "Jackson|Gallia",
    county_fips_all: "39079|39053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45686,
    lat: 39.00901,
    lng: -82.36843,
    city: "Vinton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3527,
    density: 14.1,
    county_fips: 39053,
    county_name: "Gallia",
    county_weights: {
      39053: 61.32,
      39105: 6.3,
      39163: 32.38,
    },
    county_names_all: "Gallia|Vinton|Meigs",
    county_fips_all: "39053|39163|39105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45688,
    lat: 38.73013,
    lng: -82.53155,
    city: "Waterloo",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 520,
    density: 5.9,
    county_fips: 39087,
    county_name: "Lawrence",
    county_weights: {
      39053: 2.43,
      39087: 97.57,
    },
    county_names_all: "Lawrence|Gallia",
    county_fips_all: "39087|39053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45690,
    lat: 39.13106,
    lng: -83.01674,
    city: "Waverly",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15257,
    density: 41.6,
    county_fips: 39131,
    county_name: "Pike",
    county_weights: {
      39131: 88.04,
      39141: 11.96,
    },
    county_names_all: "Pike|Ross",
    county_fips_all: "39131|39141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45692,
    lat: 39.11582,
    lng: -82.5426,
    city: "Wellston",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8644,
    density: 40.9,
    county_fips: 39079,
    county_name: "Jackson",
    county_weights: {
      39079: 99.55,
      39163: 0.45,
    },
    county_names_all: "Jackson|Vinton",
    county_fips_all: "39079|39163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45693,
    lat: 38.80921,
    lng: -83.53406,
    city: "West Union",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9041,
    density: 26.4,
    county_fips: 39001,
    county_name: "Adams",
    county_weights: {
      39001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 39001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45694,
    lat: 38.74807,
    lng: -82.78345,
    city: "Wheelersburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12022,
    density: 68.4,
    county_fips: 39145,
    county_name: "Scioto",
    county_weights: {
      39145: 100,
    },
    county_names_all: "Scioto",
    county_fips_all: 39145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45695,
    lat: 39.1529,
    lng: -82.36334,
    city: "Wilkesville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 670,
    density: 7.9,
    county_fips: 39163,
    county_name: "Vinton",
    county_weights: {
      39163: 100,
    },
    county_names_all: "Vinton",
    county_fips_all: 39163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45696,
    lat: 38.60356,
    lng: -82.45201,
    city: "Willow Wood",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1006,
    density: 11.2,
    county_fips: 39087,
    county_name: "Lawrence",
    county_weights: {
      39087: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 39087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45697,
    lat: 38.9352,
    lng: -83.66525,
    city: "Winchester",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5375,
    density: 21.5,
    county_fips: 39001,
    county_name: "Adams",
    county_weights: {
      39001: 51.27,
      39015: 34.29,
      39071: 14.44,
    },
    county_names_all: "Adams|Brown|Highland",
    county_fips_all: "39001|39015|39071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45698,
    lat: 39.28811,
    lng: -82.39604,
    city: "Zaleski",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 561,
    density: 92.9,
    county_fips: 39163,
    county_name: "Vinton",
    county_weights: {
      39163: 100,
    },
    county_names_all: "Vinton",
    county_fips_all: 39163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45699,
    lat: 38.87414,
    lng: -82.97045,
    city: "Lucasville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39145,
    county_name: "Scioto",
    county_weights: {
      39145: 100,
    },
    county_names_all: "Scioto",
    county_fips_all: 39145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45701,
    lat: 39.31205,
    lng: -82.08079,
    city: "Athens",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36351,
    density: 94.5,
    county_fips: 39009,
    county_name: "Athens",
    county_weights: {
      39009: 100,
    },
    county_names_all: "Athens",
    county_fips_all: 39009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45710,
    lat: 39.19763,
    lng: -82.22574,
    city: "Albany",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5226,
    density: 20.8,
    county_fips: 39105,
    county_name: "Meigs",
    county_weights: {
      39009: 35.81,
      39105: 45.79,
      39163: 18.4,
    },
    county_names_all: "Meigs|Athens|Vinton",
    county_fips_all: "39105|39009|39163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45711,
    lat: 39.42503,
    lng: -81.93038,
    city: "Amesville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 903,
    density: 7,
    county_fips: 39009,
    county_name: "Athens",
    county_weights: {
      39009: 81.66,
      39115: 11.42,
      39167: 6.92,
    },
    county_names_all: "Athens|Morgan|Washington",
    county_fips_all: "39009|39115|39167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45714,
    lat: 39.3183,
    lng: -81.62001,
    city: "Belpre",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9378,
    density: 101.3,
    county_fips: 39167,
    county_name: "Washington",
    county_weights: {
      39167: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 39167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45715,
    lat: 39.60484,
    lng: -81.6268,
    city: "Beverly",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2405,
    density: 22.2,
    county_fips: 39115,
    county_name: "Morgan",
    county_weights: {
      39115: 58.76,
      39121: 14.09,
      39167: 27.15,
    },
    county_names_all: "Morgan|Washington|Noble",
    county_fips_all: "39115|39167|39121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45716,
    lat: 39.46295,
    lng: -82.18401,
    city: "Buchtel",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 440,
    density: 301,
    county_fips: 39009,
    county_name: "Athens",
    county_weights: {
      39009: 100,
    },
    county_names_all: "Athens",
    county_fips_all: 39009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45719,
    lat: 39.39951,
    lng: -82.1285,
    city: "Chauncey",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 840,
    density: 479.1,
    county_fips: 39009,
    county_name: "Athens",
    county_weights: {
      39009: 100,
    },
    county_names_all: "Athens",
    county_fips_all: 39009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45720,
    lat: 39.09404,
    lng: -81.92312,
    city: "Chester",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39105,
    county_name: "Meigs",
    county_weights: {
      39105: 100,
    },
    county_names_all: "Meigs",
    county_fips_all: 39105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45721,
    lat: 39.56563,
    lng: -81.58347,
    city: "Coal Run",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45,
    density: 561.4,
    county_fips: 39167,
    county_name: "Washington",
    county_weights: {
      39167: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 39167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45723,
    lat: 39.22173,
    lng: -81.8268,
    city: "Coolville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3751,
    density: 21.9,
    county_fips: 39009,
    county_name: "Athens",
    county_weights: {
      39009: 78.41,
      39105: 16.63,
      39167: 4.96,
    },
    county_names_all: "Athens|Meigs|Washington",
    county_fips_all: "39009|39105|39167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45724,
    lat: 39.38246,
    lng: -81.79233,
    city: "Cutler",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2468,
    density: 17.6,
    county_fips: 39167,
    county_name: "Washington",
    county_weights: {
      39167: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 39167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45727,
    lat: 39.64495,
    lng: -81.48171,
    city: "Dexter City",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 318,
    density: 3.9,
    county_fips: 39121,
    county_name: "Noble",
    county_weights: {
      39121: 96.67,
      39167: 3.33,
    },
    county_names_all: "Noble|Washington",
    county_fips_all: "39121|39167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45729,
    lat: 39.41653,
    lng: -81.60828,
    city: "Fleming",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1275,
    density: 18.9,
    county_fips: 39167,
    county_name: "Washington",
    county_weights: {
      39167: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 39167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45732,
    lat: 39.51802,
    lng: -82.06705,
    city: "Glouster",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4328,
    density: 21,
    county_fips: 39009,
    county_name: "Athens",
    county_weights: {
      39009: 47.66,
      39115: 36.97,
      39127: 15.37,
    },
    county_names_all: "Athens|Morgan|Perry",
    county_fips_all: "39009|39115|39127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45734,
    lat: 39.63982,
    lng: -81.18816,
    city: "Graysville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 434,
    density: 5.4,
    county_fips: 39111,
    county_name: "Monroe",
    county_weights: {
      39111: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 39111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45735,
    lat: 39.25183,
    lng: -81.9229,
    city: "Guysville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1537,
    density: 12.3,
    county_fips: 39009,
    county_name: "Athens",
    county_weights: {
      39009: 99.82,
      39105: 0.18,
    },
    county_names_all: "Athens|Meigs",
    county_fips_all: "39009|39105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45739,
    lat: 39.19055,
    lng: -81.7462,
    city: "Hockingport",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39009,
    county_name: "Athens",
    county_weights: {
      39009: 100,
    },
    county_names_all: "Athens",
    county_fips_all: 39009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45740,
    lat: 39.47709,
    lng: -82.08023,
    city: "Jacksonville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 334,
    density: 441.4,
    county_fips: 39009,
    county_name: "Athens",
    county_weights: {
      39009: 100,
    },
    county_names_all: "Athens",
    county_fips_all: 39009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45741,
    lat: 39.06648,
    lng: -82.2527,
    city: "Langsville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 688,
    density: 6.4,
    county_fips: 39105,
    county_name: "Meigs",
    county_weights: {
      39105: 100,
    },
    county_names_all: "Meigs",
    county_fips_all: 39105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45742,
    lat: 39.28563,
    lng: -81.73008,
    city: "Little Hocking",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2894,
    density: 41.9,
    county_fips: 39167,
    county_name: "Washington",
    county_weights: {
      39009: 3.04,
      39167: 96.96,
    },
    county_names_all: "Washington|Athens",
    county_fips_all: "39167|39009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45743,
    lat: 39.076,
    lng: -81.85017,
    city: "Long Bottom",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1543,
    density: 16.7,
    county_fips: 39105,
    county_name: "Meigs",
    county_weights: {
      39105: 100,
    },
    county_names_all: "Meigs",
    county_fips_all: 39105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45744,
    lat: 39.5396,
    lng: -81.5077,
    city: "Lowell",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2469,
    density: 17,
    county_fips: 39167,
    county_name: "Washington",
    county_weights: {
      39121: 4.52,
      39167: 95.48,
    },
    county_names_all: "Washington|Noble",
    county_fips_all: "39167|39121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45745,
    lat: 39.61678,
    lng: -81.32689,
    city: "Lower Salem",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1495,
    density: 8,
    county_fips: 39121,
    county_name: "Noble",
    county_weights: {
      39111: 16.85,
      39121: 51.49,
      39167: 31.66,
    },
    county_names_all: "Noble|Washington|Monroe",
    county_fips_all: "39121|39167|39111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45746,
    lat: 39.604,
    lng: -81.44809,
    city: "Macksburg",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 274,
    density: 6.1,
    county_fips: 39167,
    county_name: "Washington",
    county_weights: {
      39121: 24.18,
      39167: 75.82,
    },
    county_names_all: "Washington|Noble",
    county_fips_all: "39167|39121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45750,
    lat: 39.4301,
    lng: -81.42947,
    city: "Marietta",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26710,
    density: 96.6,
    county_fips: 39167,
    county_name: "Washington",
    county_weights: {
      39167: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 39167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45760,
    lat: 39.01395,
    lng: -82.12244,
    city: "Middleport",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4090,
    density: 77.6,
    county_fips: 39105,
    county_name: "Meigs",
    county_weights: {
      39053: 7,
      39105: 93,
    },
    county_names_all: "Meigs|Gallia",
    county_fips_all: "39105|39053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45761,
    lat: 39.42642,
    lng: -82.0964,
    city: "Millfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1537,
    density: 17.3,
    county_fips: 39009,
    county_name: "Athens",
    county_weights: {
      39009: 100,
    },
    county_names_all: "Athens",
    county_fips_all: 39009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45764,
    lat: 39.45116,
    lng: -82.24336,
    city: "Nelsonville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9134,
    density: 44.7,
    county_fips: 39073,
    county_name: "Hocking",
    county_weights: {
      39009: 49.45,
      39073: 50.55,
    },
    county_names_all: "Hocking|Athens",
    county_fips_all: "39073|39009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45766,
    lat: 39.31931,
    lng: -82.26247,
    city: "New Marshfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1233,
    density: 14.7,
    county_fips: 39009,
    county_name: "Athens",
    county_weights: {
      39009: 79.66,
      39163: 20.34,
    },
    county_names_all: "Athens|Vinton",
    county_fips_all: "39009|39163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45767,
    lat: 39.54367,
    lng: -81.1312,
    city: "New Matamoras",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3084,
    density: 10.7,
    county_fips: 39167,
    county_name: "Washington",
    county_weights: {
      39111: 31.9,
      39167: 68.1,
    },
    county_names_all: "Washington|Monroe",
    county_fips_all: "39167|39111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45768,
    lat: 39.4149,
    lng: -81.26468,
    city: "Newport",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1617,
    density: 20,
    county_fips: 39167,
    county_name: "Washington",
    county_weights: {
      39167: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 39167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45769,
    lat: 39.1062,
    lng: -82.04578,
    city: "Pomeroy",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6979,
    density: 25.7,
    county_fips: 39105,
    county_name: "Meigs",
    county_weights: {
      39105: 100,
    },
    county_names_all: "Meigs",
    county_fips_all: 39105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45770,
    lat: 38.98586,
    lng: -81.80238,
    city: "Portland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 656,
    density: 11.6,
    county_fips: 39105,
    county_name: "Meigs",
    county_weights: {
      39105: 100,
    },
    county_names_all: "Meigs",
    county_fips_all: 39105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45771,
    lat: 38.98204,
    lng: -81.89902,
    city: "Racine",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3407,
    density: 21.4,
    county_fips: 39105,
    county_name: "Meigs",
    county_weights: {
      39105: 100,
    },
    county_names_all: "Meigs",
    county_fips_all: 39105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45772,
    lat: 39.1408,
    lng: -81.82268,
    city: "Reedsville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1768,
    density: 16.7,
    county_fips: 39105,
    county_name: "Meigs",
    county_weights: {
      39105: 100,
    },
    county_names_all: "Meigs",
    county_fips_all: 39105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45773,
    lat: 39.45525,
    lng: -81.28656,
    city: "Reno",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 39167,
    county_name: "Washington",
    county_weights: {
      39167: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 39167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45775,
    lat: 39.0876,
    lng: -82.15596,
    city: "Rutland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1009,
    density: 12.5,
    county_fips: 39105,
    county_name: "Meigs",
    county_weights: {
      39105: 100,
    },
    county_names_all: "Meigs",
    county_fips_all: 39105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45776,
    lat: 39.18732,
    lng: -82.0228,
    city: "Shade",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 873,
    density: 18.6,
    county_fips: 39105,
    county_name: "Meigs",
    county_weights: {
      39009: 43.82,
      39105: 56.18,
    },
    county_names_all: "Meigs|Athens",
    county_fips_all: "39105|39009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45778,
    lat: 39.34672,
    lng: -81.89555,
    city: "Stewart",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 877,
    density: 12.5,
    county_fips: 39009,
    county_name: "Athens",
    county_weights: {
      39009: 100,
    },
    county_names_all: "Athens",
    county_fips_all: 39009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45779,
    lat: 38.99884,
    lng: -81.97082,
    city: "Syracuse",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 707,
    density: 313.2,
    county_fips: 39105,
    county_name: "Meigs",
    county_weights: {
      39105: 100,
    },
    county_names_all: "Meigs",
    county_fips_all: 39105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45780,
    lat: 39.36972,
    lng: -82.13112,
    city: "The Plains",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2902,
    density: 383.9,
    county_fips: 39009,
    county_name: "Athens",
    county_weights: {
      39009: 100,
    },
    county_names_all: "Athens",
    county_fips_all: 39009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45782,
    lat: 39.48624,
    lng: -82.08076,
    city: "Trimble",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 605,
    density: 347.8,
    county_fips: 39009,
    county_name: "Athens",
    county_weights: {
      39009: 100,
    },
    county_names_all: "Athens",
    county_fips_all: 39009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45783,
    lat: 39.17505,
    lng: -81.83929,
    city: "Tuppers Plains",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39105,
    county_name: "Meigs",
    county_weights: {
      39105: 100,
    },
    county_names_all: "Meigs",
    county_fips_all: 39105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45784,
    lat: 39.38879,
    lng: -81.68805,
    city: "Vincent",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3539,
    density: 36.3,
    county_fips: 39167,
    county_name: "Washington",
    county_weights: {
      39167: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 39167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45786,
    lat: 39.50365,
    lng: -81.65451,
    city: "Waterford",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3137,
    density: 19.1,
    county_fips: 39167,
    county_name: "Washington",
    county_weights: {
      39115: 4.19,
      39167: 95.81,
    },
    county_names_all: "Washington|Morgan",
    county_fips_all: "39167|39115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45788,
    lat: 39.51349,
    lng: -81.37016,
    city: "Whipple",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1176,
    density: 14,
    county_fips: 39167,
    county_name: "Washington",
    county_weights: {
      39167: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 39167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45789,
    lat: 39.5514,
    lng: -81.25592,
    city: "Wingett Run",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 111,
    density: 3.1,
    county_fips: 39167,
    county_name: "Washington",
    county_weights: {
      39111: 10.06,
      39167: 89.94,
    },
    county_names_all: "Washington|Monroe",
    county_fips_all: "39167|39111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45801,
    lat: 40.77476,
    lng: -84.03703,
    city: "Lima",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22637,
    density: 191.2,
    county_fips: 39003,
    county_name: "Allen",
    county_weights: {
      39003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 39003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45804,
    lat: 40.71569,
    lng: -84.06911,
    city: "Lima",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15582,
    density: 283.1,
    county_fips: 39003,
    county_name: "Allen",
    county_weights: {
      39003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 39003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45805,
    lat: 40.72979,
    lng: -84.16242,
    city: "Lima",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23168,
    density: 613.8,
    county_fips: 39003,
    county_name: "Allen",
    county_weights: {
      39003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 39003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45806,
    lat: 40.67615,
    lng: -84.12651,
    city: "Lima",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10961,
    density: 67.8,
    county_fips: 39003,
    county_name: "Allen",
    county_weights: {
      39003: 78.44,
      39011: 21.56,
    },
    county_names_all: "Allen|Auglaize",
    county_fips_all: "39003|39011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45807,
    lat: 40.8072,
    lng: -84.16699,
    city: "Lima",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12115,
    density: 62,
    county_fips: 39003,
    county_name: "Allen",
    county_weights: {
      39003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 39003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45808,
    lat: 40.83178,
    lng: -83.9729,
    city: "Beaverdam",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 379,
    density: 245.1,
    county_fips: 39003,
    county_name: "Allen",
    county_weights: {
      39003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 39003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45809,
    lat: 40.8431,
    lng: -84.18522,
    city: "Gomer",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 101,
    density: 122.5,
    county_fips: 39003,
    county_name: "Allen",
    county_weights: {
      39003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 39003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45810,
    lat: 40.77721,
    lng: -83.81097,
    city: "Ada",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7841,
    density: 46.2,
    county_fips: 39065,
    county_name: "Hardin",
    county_weights: {
      39003: 8.12,
      39063: 12.22,
      39065: 79.66,
    },
    county_names_all: "Hardin|Hancock|Allen",
    county_fips_all: "39065|39063|39003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45812,
    lat: 40.68341,
    lng: -83.8135,
    city: "Alger",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1938,
    density: 19.3,
    county_fips: 39065,
    county_name: "Hardin",
    county_weights: {
      39003: 2.04,
      39065: 97.96,
    },
    county_names_all: "Hardin|Allen",
    county_fips_all: "39065|39003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45813,
    lat: 41.18914,
    lng: -84.73031,
    city: "Antwerp",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3516,
    density: 24.2,
    county_fips: 39125,
    county_name: "Paulding",
    county_weights: {
      39039: 1.6,
      39125: 98.4,
    },
    county_names_all: "Paulding|Defiance",
    county_fips_all: "39125|39039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45814,
    lat: 40.90119,
    lng: -83.61545,
    city: "Arlington",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3094,
    density: 33.4,
    county_fips: 39063,
    county_name: "Hancock",
    county_weights: {
      39063: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 39063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45815,
    lat: 41.157,
    lng: -83.94267,
    city: "Belmore",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39137,
    county_name: "Putnam",
    county_weights: {
      39137: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 39137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45816,
    lat: 41.00452,
    lng: -83.79392,
    city: "Benton Ridge",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 357,
    density: 521.8,
    county_fips: 39063,
    county_name: "Hancock",
    county_weights: {
      39063: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 39063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45817,
    lat: 40.87691,
    lng: -83.88279,
    city: "Bluffton",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6668,
    density: 40.2,
    county_fips: 39003,
    county_name: "Allen",
    county_weights: {
      39003: 49.8,
      39063: 47.04,
      39137: 3.16,
    },
    county_names_all: "Allen|Hancock|Putnam",
    county_fips_all: "39003|39063|39137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45819,
    lat: 40.62407,
    lng: -84.26033,
    city: "Buckland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 285,
    density: 416.2,
    county_fips: 39011,
    county_name: "Auglaize",
    county_weights: {
      39011: 100,
    },
    county_names_all: "Auglaize",
    county_fips_all: 39011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45820,
    lat: 40.83074,
    lng: -84.08473,
    city: "Cairo",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 681,
    density: 949.2,
    county_fips: 39003,
    county_name: "Allen",
    county_weights: {
      39003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 39003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45821,
    lat: 41.22643,
    lng: -84.56208,
    city: "Cecil",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 892,
    density: 8.8,
    county_fips: 39125,
    county_name: "Paulding",
    county_weights: {
      39039: 3.45,
      39125: 96.55,
    },
    county_names_all: "Paulding|Defiance",
    county_fips_all: "39125|39039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45822,
    lat: 40.55266,
    lng: -84.59664,
    city: "Celina",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18651,
    density: 44.2,
    county_fips: 39107,
    county_name: "Mercer",
    county_weights: {
      39107: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 39107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45826,
    lat: 40.43658,
    lng: -84.49368,
    city: "Chickasaw",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 385,
    density: 619,
    county_fips: 39107,
    county_name: "Mercer",
    county_weights: {
      39107: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 39107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45827,
    lat: 41.00393,
    lng: -84.30122,
    city: "Cloverdale",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2012,
    density: 12.1,
    county_fips: 39137,
    county_name: "Putnam",
    county_weights: {
      39125: 14.3,
      39137: 85.7,
    },
    county_names_all: "Putnam|Paulding",
    county_fips_all: "39137|39125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45828,
    lat: 40.48672,
    lng: -84.67677,
    city: "Coldwater",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6680,
    density: 76.2,
    county_fips: 39107,
    county_name: "Mercer",
    county_weights: {
      39107: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 39107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45830,
    lat: 40.90616,
    lng: -84.09213,
    city: "Columbus Grove",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5212,
    density: 21.3,
    county_fips: 39137,
    county_name: "Putnam",
    county_weights: {
      39003: 32.83,
      39137: 67.17,
    },
    county_names_all: "Putnam|Allen",
    county_fips_all: "39137|39003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45831,
    lat: 41.11141,
    lng: -84.24993,
    city: "Continental",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3752,
    density: 19.5,
    county_fips: 39137,
    county_name: "Putnam",
    county_weights: {
      39039: 2.23,
      39125: 0.69,
      39137: 97.08,
    },
    county_names_all: "Putnam|Defiance|Paulding",
    county_fips_all: "39137|39039|39125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45832,
    lat: 40.92779,
    lng: -84.7336,
    city: "Convoy",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3170,
    density: 17.8,
    county_fips: 39161,
    county_name: "Van Wert",
    county_weights: {
      39125: 3.33,
      39161: 96.67,
    },
    county_names_all: "Van Wert|Paulding",
    county_fips_all: "39161|39125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45833,
    lat: 40.83415,
    lng: -84.35264,
    city: "Delphos",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10451,
    density: 55.8,
    county_fips: 39003,
    county_name: "Allen",
    county_weights: {
      39003: 45.86,
      39137: 9.46,
      39161: 44.68,
    },
    county_names_all: "Allen|Van Wert|Putnam",
    county_fips_all: "39003|39161|39137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45835,
    lat: 40.75898,
    lng: -83.70076,
    city: "Dola",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 542,
    density: 11.3,
    county_fips: 39065,
    county_name: "Hardin",
    county_weights: {
      39065: 100,
    },
    county_names_all: "Hardin",
    county_fips_all: 39065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45836,
    lat: 40.79304,
    lng: -83.64311,
    city: "Dunkirk",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1410,
    density: 22.1,
    county_fips: 39065,
    county_name: "Hardin",
    county_weights: {
      39063: 3.84,
      39065: 96.16,
    },
    county_names_all: "Hardin|Hancock",
    county_fips_all: "39065|39063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45838,
    lat: 40.74041,
    lng: -84.47781,
    city: "Elgin",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 129,
    density: 631.7,
    county_fips: 39161,
    county_name: "Van Wert",
    county_weights: {
      39161: 100,
    },
    county_names_all: "Van Wert",
    county_fips_all: 39161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45840,
    lat: 41.02626,
    lng: -83.64943,
    city: "Findlay",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55834,
    density: 129.5,
    county_fips: 39063,
    county_name: "Hancock",
    county_weights: {
      39063: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 39063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45841,
    lat: 40.87955,
    lng: -83.735,
    city: "Jenera",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 826,
    density: 14.1,
    county_fips: 39063,
    county_name: "Hancock",
    county_weights: {
      39063: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 39063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45843,
    lat: 40.78202,
    lng: -83.53513,
    city: "Forest",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3691,
    density: 14.1,
    county_fips: 39065,
    county_name: "Hardin",
    county_weights: {
      39063: 24.88,
      39065: 37.78,
      39175: 37.34,
    },
    county_names_all: "Hardin|Wyandot|Hancock",
    county_fips_all: "39065|39175|39063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45844,
    lat: 40.91733,
    lng: -84.2856,
    city: "Fort Jennings",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2967,
    density: 19.7,
    county_fips: 39137,
    county_name: "Putnam",
    county_weights: {
      39003: 4.66,
      39137: 86.96,
      39161: 8.38,
    },
    county_names_all: "Putnam|Van Wert|Allen",
    county_fips_all: "39137|39161|39003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45845,
    lat: 40.32995,
    lng: -84.37806,
    city: "Fort Loramie",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2840,
    density: 33.6,
    county_fips: 39149,
    county_name: "Shelby",
    county_weights: {
      39011: 3.38,
      39149: 96.62,
    },
    county_names_all: "Shelby|Auglaize",
    county_fips_all: "39149|39011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45846,
    lat: 40.40986,
    lng: -84.74644,
    city: "Fort Recovery",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4427,
    density: 22.5,
    county_fips: 39107,
    county_name: "Mercer",
    county_weights: {
      39037: 14.07,
      39107: 85.93,
    },
    county_names_all: "Mercer|Darke",
    county_fips_all: "39107|39037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45848,
    lat: 41.02421,
    lng: -84.07695,
    city: "Glandorf",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39137,
    county_name: "Putnam",
    county_weights: {
      39137: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 39137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45849,
    lat: 41.01241,
    lng: -84.45452,
    city: "Grover Hill",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 931,
    density: 8.3,
    county_fips: 39125,
    county_name: "Paulding",
    county_weights: {
      39125: 74.37,
      39137: 2.6,
      39161: 23.03,
    },
    county_names_all: "Paulding|Van Wert|Putnam",
    county_fips_all: "39125|39161|39137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45850,
    lat: 40.70382,
    lng: -83.91817,
    city: "Harrod",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3278,
    density: 21.7,
    county_fips: 39003,
    county_name: "Allen",
    county_weights: {
      39003: 80.82,
      39011: 4.34,
      39065: 14.84,
    },
    county_names_all: "Allen|Hardin|Auglaize",
    county_fips_all: "39003|39065|39011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45851,
    lat: 41.03267,
    lng: -84.60289,
    city: "Haviland",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 737,
    density: 7.8,
    county_fips: 39125,
    county_name: "Paulding",
    county_weights: {
      39125: 100,
    },
    county_names_all: "Paulding",
    county_fips_all: 39125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45853,
    lat: 40.98625,
    lng: -84.19469,
    city: "Kalida",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1620,
    density: 393,
    county_fips: 39137,
    county_name: "Putnam",
    county_weights: {
      39137: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 39137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45854,
    lat: 40.7582,
    lng: -83.95231,
    city: "Lafayette",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 387,
    density: 389.4,
    county_fips: 39003,
    county_name: "Allen",
    county_weights: {
      39003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 39003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45855,
    lat: 41.08819,
    lng: -84.5835,
    city: "Latty",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 142,
    density: 226.2,
    county_fips: 39125,
    county_name: "Paulding",
    county_weights: {
      39125: 100,
    },
    county_names_all: "Paulding",
    county_fips_all: 39125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45856,
    lat: 41.11452,
    lng: -83.99917,
    city: "Leipsic",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5251,
    density: 19.8,
    county_fips: 39137,
    county_name: "Putnam",
    county_weights: {
      39063: 1.06,
      39069: 3.24,
      39137: 95.7,
    },
    county_names_all: "Putnam|Henry|Hancock",
    county_fips_all: "39137|39069|39063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45858,
    lat: 41.10688,
    lng: -83.80338,
    city: "McComb",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2518,
    density: 15.7,
    county_fips: 39063,
    county_name: "Hancock",
    county_weights: {
      39063: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 39063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45859,
    lat: 40.69305,
    lng: -83.78574,
    city: "McGuffey",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 512,
    density: 567.1,
    county_fips: 39065,
    county_name: "Hardin",
    county_weights: {
      39065: 100,
    },
    county_names_all: "Hardin",
    county_fips_all: 39065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45860,
    lat: 40.39365,
    lng: -84.51566,
    city: "Maria Stein",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2517,
    density: 29.3,
    county_fips: 39107,
    county_name: "Mercer",
    county_weights: {
      39107: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 39107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45861,
    lat: 41.08587,
    lng: -84.42569,
    city: "Melrose",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 356,
    density: 101.9,
    county_fips: 39125,
    county_name: "Paulding",
    county_weights: {
      39125: 100,
    },
    county_names_all: "Paulding",
    county_fips_all: 39125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45862,
    lat: 40.67079,
    lng: -84.51356,
    city: "Mendon",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1393,
    density: 14.7,
    county_fips: 39107,
    county_name: "Mercer",
    county_weights: {
      39011: 7.6,
      39107: 92.4,
    },
    county_names_all: "Mercer|Auglaize",
    county_fips_all: "39107|39011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45863,
    lat: 40.9041,
    lng: -84.45477,
    city: "Middle Point",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1312,
    density: 20.8,
    county_fips: 39161,
    county_name: "Van Wert",
    county_weights: {
      39161: 100,
    },
    county_names_all: "Van Wert",
    county_fips_all: 39161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45864,
    lat: 41.09936,
    lng: -84.14077,
    city: "Miller City",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 173,
    density: 59,
    county_fips: 39137,
    county_name: "Putnam",
    county_weights: {
      39137: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 39137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45865,
    lat: 40.39379,
    lng: -84.37219,
    city: "Minster",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4881,
    density: 53.3,
    county_fips: 39011,
    county_name: "Auglaize",
    county_weights: {
      39011: 58.22,
      39107: 2.09,
      39149: 39.69,
    },
    county_names_all: "Auglaize|Shelby|Mercer",
    county_fips_all: "39011|39149|39107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45866,
    lat: 40.48905,
    lng: -84.54969,
    city: "Montezuma",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 107,
    density: 404.1,
    county_fips: 39107,
    county_name: "Mercer",
    county_weights: {
      39107: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 39107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45867,
    lat: 40.89795,
    lng: -83.53825,
    city: "Mount Blanchard",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1058,
    density: 16.6,
    county_fips: 39063,
    county_name: "Hancock",
    county_weights: {
      39063: 96.96,
      39175: 3.04,
    },
    county_names_all: "Hancock|Wyandot",
    county_fips_all: "39063|39175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45868,
    lat: 40.96986,
    lng: -83.84839,
    city: "Mount Cory",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 667,
    density: 14.4,
    county_fips: 39063,
    county_name: "Hancock",
    county_weights: {
      39063: 95.88,
      39137: 4.12,
    },
    county_names_all: "Hancock|Putnam",
    county_fips_all: "39063|39137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45869,
    lat: 40.4573,
    lng: -84.39432,
    city: "New Bremen",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4780,
    density: 51.3,
    county_fips: 39011,
    county_name: "Auglaize",
    county_weights: {
      39011: 76.52,
      39107: 10.07,
      39149: 13.41,
    },
    county_names_all: "Auglaize|Shelby|Mercer",
    county_fips_all: "39011|39149|39107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45870,
    lat: 40.55621,
    lng: -83.95142,
    city: "New Hampshire",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 552,
    density: 649.3,
    county_fips: 39011,
    county_name: "Auglaize",
    county_weights: {
      39011: 100,
    },
    county_names_all: "Auglaize",
    county_fips_all: 39011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45871,
    lat: 40.4932,
    lng: -84.30089,
    city: "New Knoxville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2036,
    density: 33.3,
    county_fips: 39011,
    county_name: "Auglaize",
    county_weights: {
      39011: 72.45,
      39149: 27.55,
    },
    county_names_all: "Auglaize|Shelby",
    county_fips_all: "39011|39149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45872,
    lat: 41.18863,
    lng: -83.68366,
    city: "North Baltimore",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4641,
    density: 58.4,
    county_fips: 39173,
    county_name: "Wood",
    county_weights: {
      39063: 11.41,
      39173: 88.59,
    },
    county_names_all: "Wood|Hancock",
    county_fips_all: "39173|39063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45873,
    lat: 41.11935,
    lng: -84.39628,
    city: "Oakwood",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1547,
    density: 11.4,
    county_fips: 39125,
    county_name: "Paulding",
    county_weights: {
      39125: 98.68,
      39137: 1.32,
    },
    county_names_all: "Paulding|Putnam",
    county_fips_all: "39125|39137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45874,
    lat: 40.78765,
    lng: -84.67777,
    city: "Ohio City",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2150,
    density: 14.3,
    county_fips: 39161,
    county_name: "Van Wert",
    county_weights: {
      39161: 100,
    },
    county_names_all: "Van Wert",
    county_fips_all: 39161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45875,
    lat: 41.02271,
    lng: -84.06118,
    city: "Ottawa",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11063,
    density: 41.6,
    county_fips: 39137,
    county_name: "Putnam",
    county_weights: {
      39137: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 39137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45876,
    lat: 40.93414,
    lng: -84.33835,
    city: "Ottoville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 779,
    density: 319.4,
    county_fips: 39137,
    county_name: "Putnam",
    county_weights: {
      39137: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 39137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45877,
    lat: 40.95393,
    lng: -83.93779,
    city: "Pandora",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2047,
    density: 29.6,
    county_fips: 39137,
    county_name: "Putnam",
    county_weights: {
      39003: 8.92,
      39063: 0.94,
      39137: 90.14,
    },
    county_names_all: "Putnam|Allen|Hancock",
    county_fips_all: "39137|39003|39063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45879,
    lat: 41.12918,
    lng: -84.56471,
    city: "Paulding",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6293,
    density: 23.5,
    county_fips: 39125,
    county_name: "Paulding",
    county_weights: {
      39125: 100,
    },
    county_names_all: "Paulding",
    county_fips_all: 39125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45880,
    lat: 41.0662,
    lng: -84.73782,
    city: "Payne",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2805,
    density: 18.7,
    county_fips: 39125,
    county_name: "Paulding",
    county_weights: {
      39125: 100,
    },
    county_names_all: "Paulding",
    county_fips_all: 39125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45881,
    lat: 40.94976,
    lng: -83.77426,
    city: "Rawson",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1460,
    density: 18.5,
    county_fips: 39063,
    county_name: "Hancock",
    county_weights: {
      39063: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 39063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45882,
    lat: 40.67823,
    lng: -84.6754,
    city: "Rockford",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2676,
    density: 12.1,
    county_fips: 39107,
    county_name: "Mercer",
    county_weights: {
      39107: 93.91,
      39161: 6.09,
    },
    county_names_all: "Mercer|Van Wert",
    county_fips_all: "39107|39161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45883,
    lat: 40.40574,
    lng: -84.62791,
    city: "Saint Henry",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3940,
    density: 41.8,
    county_fips: 39107,
    county_name: "Mercer",
    county_weights: {
      39037: 2.6,
      39107: 97.4,
    },
    county_names_all: "Mercer|Darke",
    county_fips_all: "39107|39037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45884,
    lat: 40.54865,
    lng: -84.08333,
    city: "Saint Johns",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61,
    density: 42,
    county_fips: 39011,
    county_name: "Auglaize",
    county_weights: {
      39011: 100,
    },
    county_names_all: "Auglaize",
    county_fips_all: 39011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45885,
    lat: 40.57182,
    lng: -84.3871,
    city: "Saint Marys",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12703,
    density: 67.8,
    county_fips: 39011,
    county_name: "Auglaize",
    county_weights: {
      39011: 100,
    },
    county_names_all: "Auglaize",
    county_fips_all: 39011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45886,
    lat: 40.99083,
    lng: -84.61062,
    city: "Scott",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 531,
    density: 10.7,
    county_fips: 39125,
    county_name: "Paulding",
    county_weights: {
      39125: 52.96,
      39161: 47.04,
    },
    county_names_all: "Paulding|Van Wert",
    county_fips_all: "39125|39161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45887,
    lat: 40.71107,
    lng: -84.36359,
    city: "Spencerville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4282,
    density: 23.7,
    county_fips: 39003,
    county_name: "Allen",
    county_weights: {
      39003: 55.25,
      39011: 24.42,
      39107: 2.53,
      39161: 17.8,
    },
    county_names_all: "Allen|Auglaize|Van Wert|Mercer",
    county_fips_all: "39003|39011|39161|39107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45888,
    lat: 40.60244,
    lng: -84.08583,
    city: "Uniopolis",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 281,
    density: 408.3,
    county_fips: 39011,
    county_name: "Auglaize",
    county_weights: {
      39011: 100,
    },
    county_names_all: "Auglaize",
    county_fips_all: 39011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45889,
    lat: 41.14606,
    lng: -83.64101,
    city: "Van Buren",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1518,
    density: 30.6,
    county_fips: 39063,
    county_name: "Hancock",
    county_weights: {
      39063: 99.72,
      39173: 0.28,
    },
    county_names_all: "Hancock|Wood",
    county_fips_all: "39063|39173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45890,
    lat: 40.97752,
    lng: -83.49105,
    city: "Vanlue",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 728,
    density: 19.7,
    county_fips: 39063,
    county_name: "Hancock",
    county_weights: {
      39063: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 39063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45891,
    lat: 40.8748,
    lng: -84.57785,
    city: "Van Wert",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14824,
    density: 42.6,
    county_fips: 39161,
    county_name: "Van Wert",
    county_weights: {
      39161: 100,
    },
    county_names_all: "Van Wert",
    county_fips_all: 39161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45893,
    lat: 40.88146,
    lng: -84.14536,
    city: "Vaughnsville",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 39137,
    county_name: "Putnam",
    county_weights: {
      39137: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 39137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45894,
    lat: 40.76252,
    lng: -84.4684,
    city: "Venedocia",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 881,
    density: 10.1,
    county_fips: 39161,
    county_name: "Van Wert",
    county_weights: {
      39107: 3.02,
      39161: 96.98,
    },
    county_names_all: "Van Wert|Mercer",
    county_fips_all: "39161|39107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45895,
    lat: 40.56991,
    lng: -84.15197,
    city: "Wapakoneta",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17394,
    density: 35.9,
    county_fips: 39011,
    county_name: "Auglaize",
    county_weights: {
      39003: 0.13,
      39011: 98.29,
      39091: 1.58,
    },
    county_names_all: "Auglaize|Logan|Allen",
    county_fips_all: "39011|39091|39003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45896,
    lat: 40.60667,
    lng: -83.93775,
    city: "Waynesfield",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1917,
    density: 20.1,
    county_fips: 39011,
    county_name: "Auglaize",
    county_weights: {
      39003: 6.14,
      39011: 81.37,
      39065: 12.49,
    },
    county_names_all: "Auglaize|Hardin|Allen",
    county_fips_all: "39011|39065|39003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45897,
    lat: 40.83434,
    lng: -83.65676,
    city: "Williamstown",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 91,
    density: 29.3,
    county_fips: 39063,
    county_name: "Hancock",
    county_weights: {
      39063: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 39063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45898,
    lat: 40.73617,
    lng: -84.76429,
    city: "Willshire",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 914,
    density: 12.1,
    county_fips: 39161,
    county_name: "Van Wert",
    county_weights: {
      39107: 33.45,
      39161: 66.55,
    },
    county_names_all: "Van Wert|Mercer",
    county_fips_all: "39161|39107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 45899,
    lat: 40.80088,
    lng: -84.77491,
    city: "Wren",
    state_id: "OH",
    state_name: "Ohio",
    zcta: "TRUE",
    parent_zcta: "",
    population: 184,
    density: 266.3,
    county_fips: 39161,
    county_name: "Van Wert",
    county_weights: {
      39161: 100,
    },
    county_names_all: "Van Wert",
    county_fips_all: 39161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 46001,
    lat: 40.25141,
    lng: -85.65838,
    city: "Alexandria",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9877,
    density: 49.4,
    county_fips: 18095,
    county_name: "Madison",
    county_weights: {
      18035: 3.51,
      18095: 96.49,
    },
    county_names_all: "Madison|Delaware",
    county_fips_all: "18095|18035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46011,
    lat: 40.12759,
    lng: -85.76178,
    city: "Anderson",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17619,
    density: 92.1,
    county_fips: 18095,
    county_name: "Madison",
    county_weights: {
      18095: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 18095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46012,
    lat: 40.1492,
    lng: -85.62552,
    city: "Anderson",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19738,
    density: 238,
    county_fips: 18095,
    county_name: "Madison",
    county_weights: {
      18035: 10.68,
      18095: 89.32,
    },
    county_names_all: "Madison|Delaware",
    county_fips_all: "18095|18035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46013,
    lat: 40.05021,
    lng: -85.67829,
    city: "Anderson",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16458,
    density: 303.8,
    county_fips: 18095,
    county_name: "Madison",
    county_weights: {
      18095: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 18095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46016,
    lat: 40.09781,
    lng: -85.68152,
    city: "Anderson",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18282,
    density: 1109.5,
    county_fips: 18095,
    county_name: "Madison",
    county_weights: {
      18095: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 18095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46017,
    lat: 40.07358,
    lng: -85.60687,
    city: "Anderson",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5709,
    density: 124.5,
    county_fips: 18095,
    county_name: "Madison",
    county_weights: {
      18035: 3.15,
      18095: 96.85,
    },
    county_names_all: "Madison|Delaware",
    county_fips_all: "18095|18035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46030,
    lat: 40.17031,
    lng: -86.02118,
    city: "Arcadia",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3059,
    density: 35.7,
    county_fips: 18057,
    county_name: "Hamilton",
    county_weights: {
      18057: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 18057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46031,
    lat: 40.20935,
    lng: -86.01018,
    city: "Atlanta",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2075,
    density: 15.6,
    county_fips: 18057,
    county_name: "Hamilton",
    county_weights: {
      18057: 68.45,
      18159: 31.55,
    },
    county_names_all: "Hamilton|Tipton",
    county_fips_all: "18057|18159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46032,
    lat: 39.96535,
    lng: -86.17104,
    city: "Carmel",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51229,
    density: 780.3,
    county_fips: 18057,
    county_name: "Hamilton",
    county_weights: {
      18057: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 18057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46033,
    lat: 39.97975,
    lng: -86.08595,
    city: "Carmel",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39789,
    density: 881.6,
    county_fips: 18057,
    county_name: "Hamilton",
    county_weights: {
      18057: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 18057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46034,
    lat: 40.13291,
    lng: -86.04128,
    city: "Cicero",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6543,
    density: 80.7,
    county_fips: 18057,
    county_name: "Hamilton",
    county_weights: {
      18057: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 18057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46035,
    lat: 40.18925,
    lng: -86.67902,
    city: "Colfax",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1241,
    density: 19.2,
    county_fips: 18023,
    county_name: "Clinton",
    county_weights: {
      18011: 21.46,
      18023: 46.59,
      18107: 31.95,
    },
    county_names_all: "Clinton|Montgomery|Boone",
    county_fips_all: "18023|18107|18011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46036,
    lat: 40.29689,
    lng: -85.83289,
    city: "Elwood",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11454,
    density: 55.1,
    county_fips: 18095,
    county_name: "Madison",
    county_weights: {
      18053: 1.73,
      18095: 73,
      18159: 25.27,
    },
    county_names_all: "Madison|Tipton|Grant",
    county_fips_all: "18095|18159|18053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46037,
    lat: 39.96077,
    lng: -85.94446,
    city: "Fishers",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41141,
    density: 790.3,
    county_fips: 18057,
    county_name: "Hamilton",
    county_weights: {
      18057: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 18057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46038,
    lat: 39.96722,
    lng: -86.01712,
    city: "Fishers",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45526,
    density: 1133,
    county_fips: 18057,
    county_name: "Hamilton",
    county_weights: {
      18057: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 18057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46039,
    lat: 40.37022,
    lng: -86.31173,
    city: "Forest",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 552,
    density: 7.6,
    county_fips: 18023,
    county_name: "Clinton",
    county_weights: {
      18023: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 18023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46040,
    lat: 39.92773,
    lng: -85.83424,
    city: "Fortville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14520,
    density: 178.3,
    county_fips: 18059,
    county_name: "Hancock",
    county_weights: {
      18057: 20.29,
      18059: 61.44,
      18095: 18.27,
    },
    county_names_all: "Hancock|Hamilton|Madison",
    county_fips_all: "18059|18057|18095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46041,
    lat: 40.29695,
    lng: -86.49216,
    city: "Frankfort",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22043,
    density: 34.3,
    county_fips: 18023,
    county_name: "Clinton",
    county_weights: {
      18015: 3.27,
      18023: 96.73,
    },
    county_names_all: "Clinton|Carroll",
    county_fips_all: "18023|18015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46044,
    lat: 40.2085,
    lng: -85.79026,
    city: "Frankton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3116,
    density: 55.7,
    county_fips: 18095,
    county_name: "Madison",
    county_weights: {
      18095: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 18095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46045,
    lat: 40.2898,
    lng: -86.14832,
    city: "Goldsmith",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 94,
    density: 481.2,
    county_fips: 18159,
    county_name: "Tipton",
    county_weights: {
      18159: 100,
    },
    county_names_all: "Tipton",
    county_fips_all: 18159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46047,
    lat: 40.28418,
    lng: -85.94739,
    city: "Hobbs",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49,
    density: 1369.3,
    county_fips: 18159,
    county_name: "Tipton",
    county_weights: {
      18159: 100,
    },
    county_names_all: "Tipton",
    county_fips_all: 18159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46048,
    lat: 39.9543,
    lng: -85.80755,
    city: "Ingalls",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2396,
    density: 1176.4,
    county_fips: 18095,
    county_name: "Madison",
    county_weights: {
      18095: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 18095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46049,
    lat: 40.29757,
    lng: -86.22165,
    city: "Kempton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1027,
    density: 15.1,
    county_fips: 18159,
    county_name: "Tipton",
    county_weights: {
      18023: 10.07,
      18159: 89.93,
    },
    county_names_all: "Tipton|Clinton",
    county_fips_all: "18159|18023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46050,
    lat: 40.20515,
    lng: -86.34629,
    city: "Kirklin",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2364,
    density: 19.1,
    county_fips: 18023,
    county_name: "Clinton",
    county_weights: {
      18011: 18.73,
      18023: 76.44,
      18057: 1.26,
      18159: 3.57,
    },
    county_names_all: "Clinton|Boone|Tipton|Hamilton",
    county_fips_all: "18023|18011|18159|18057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46051,
    lat: 40.05855,
    lng: -85.83794,
    city: "Lapel",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2818,
    density: 70.2,
    county_fips: 18095,
    county_name: "Madison",
    county_weights: {
      18095: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 18095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46052,
    lat: 40.04448,
    lng: -86.46086,
    city: "Lebanon",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22886,
    density: 49.7,
    county_fips: 18011,
    county_name: "Boone",
    county_weights: {
      18011: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 18011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46055,
    lat: 39.88627,
    lng: -85.90404,
    city: "Mccordsville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12335,
    density: 181.4,
    county_fips: 18059,
    county_name: "Hancock",
    county_weights: {
      18057: 7.75,
      18059: 92.25,
    },
    county_names_all: "Hancock|Hamilton",
    county_fips_all: "18059|18057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46056,
    lat: 39.97351,
    lng: -85.6105,
    city: "Markleville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2067,
    density: 32.5,
    county_fips: 18095,
    county_name: "Madison",
    county_weights: {
      18059: 19.06,
      18065: 3.78,
      18095: 77.16,
    },
    county_names_all: "Madison|Hancock|Henry",
    county_fips_all: "18095|18059|18065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46057,
    lat: 40.33796,
    lng: -86.37801,
    city: "Michigantown",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1336,
    density: 20.3,
    county_fips: 18023,
    county_name: "Clinton",
    county_weights: {
      18023: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 18023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46058,
    lat: 40.35981,
    lng: -86.64777,
    city: "Mulberry",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2280,
    density: 33.2,
    county_fips: 18023,
    county_name: "Clinton",
    county_weights: {
      18023: 99.32,
      18157: 0.68,
    },
    county_names_all: "Clinton|Tippecanoe",
    county_fips_all: "18023|18157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46060,
    lat: 40.06616,
    lng: -85.93137,
    city: "Noblesville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42621,
    density: 204.2,
    county_fips: 18057,
    county_name: "Hamilton",
    county_weights: {
      18057: 98.28,
      18095: 1.72,
    },
    county_names_all: "Hamilton|Madison",
    county_fips_all: "18057|18095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46062,
    lat: 40.06146,
    lng: -86.05523,
    city: "Noblesville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34883,
    density: 401.9,
    county_fips: 18057,
    county_name: "Hamilton",
    county_weights: {
      18057: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 18057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46063,
    lat: 40.27184,
    lng: -85.72389,
    city: "Orestes",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 508,
    density: 588.3,
    county_fips: 18095,
    county_name: "Madison",
    county_weights: {
      18095: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 18095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46064,
    lat: 39.98473,
    lng: -85.74701,
    city: "Pendleton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16411,
    density: 94.9,
    county_fips: 18095,
    county_name: "Madison",
    county_weights: {
      18059: 11.33,
      18095: 88.67,
    },
    county_names_all: "Madison|Hancock",
    county_fips_all: "18095|18059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46065,
    lat: 40.42318,
    lng: -86.60992,
    city: "Rossville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3496,
    density: 37,
    county_fips: 18023,
    county_name: "Clinton",
    county_weights: {
      18015: 33.3,
      18023: 66.7,
    },
    county_names_all: "Clinton|Carroll",
    county_fips_all: "18023|18015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46068,
    lat: 40.37511,
    lng: -86.1112,
    city: "Sharpsville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3072,
    density: 26.3,
    county_fips: 18159,
    county_name: "Tipton",
    county_weights: {
      18067: 2.87,
      18159: 97.13,
    },
    county_names_all: "Tipton|Howard",
    county_fips_all: "18159|18067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46069,
    lat: 40.13829,
    lng: -86.23144,
    city: "Sheridan",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6733,
    density: 29.4,
    county_fips: 18057,
    county_name: "Hamilton",
    county_weights: {
      18011: 35.9,
      18023: 7.06,
      18057: 57.04,
    },
    county_names_all: "Hamilton|Boone|Clinton",
    county_fips_all: "18057|18011|18023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46070,
    lat: 40.34315,
    lng: -85.65928,
    city: "Summitville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2313,
    density: 19.7,
    county_fips: 18095,
    county_name: "Madison",
    county_weights: {
      18035: 2.75,
      18053: 0.14,
      18095: 97.11,
    },
    county_names_all: "Madison|Delaware|Grant",
    county_fips_all: "18095|18035|18053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46071,
    lat: 40.11941,
    lng: -86.60549,
    city: "Thorntown",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3204,
    density: 17.7,
    county_fips: 18011,
    county_name: "Boone",
    county_weights: {
      18011: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 18011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46072,
    lat: 40.28526,
    lng: -86.06891,
    city: "Tipton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8357,
    density: 29.4,
    county_fips: 18159,
    county_name: "Tipton",
    county_weights: {
      18159: 100,
    },
    county_names_all: "Tipton",
    county_fips_all: 18159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46074,
    lat: 40.03651,
    lng: -86.17289,
    city: "Westfield",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37070,
    density: 393.5,
    county_fips: 18057,
    county_name: "Hamilton",
    county_weights: {
      18057: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 18057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46075,
    lat: 40.02637,
    lng: -86.3346,
    city: "Whitestown",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7098,
    density: 87.9,
    county_fips: 18011,
    county_name: "Boone",
    county_weights: {
      18011: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 18011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46076,
    lat: 40.36318,
    lng: -85.9374,
    city: "Windfall",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1628,
    density: 14.8,
    county_fips: 18159,
    county_name: "Tipton",
    county_weights: {
      18067: 2.25,
      18159: 97.75,
    },
    county_names_all: "Tipton|Howard",
    county_fips_all: "18159|18067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46077,
    lat: 39.98281,
    lng: -86.28346,
    city: "Zionsville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30795,
    density: 268.2,
    county_fips: 18011,
    county_name: "Boone",
    county_weights: {
      18011: 91.98,
      18057: 6.55,
      18097: 1.47,
    },
    county_names_all: "Boone|Hamilton|Marion",
    county_fips_all: "18011|18057|18097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46102,
    lat: 39.99556,
    lng: -86.61993,
    city: "Advance",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18011,
    county_name: "Boone",
    county_weights: {
      18011: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 18011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46103,
    lat: 39.6896,
    lng: -86.61384,
    city: "Amo",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18063,
    county_name: "Hendricks",
    county_weights: {
      18063: 100,
    },
    county_names_all: "Hendricks",
    county_fips_all: 18063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46104,
    lat: 39.66041,
    lng: -85.59545,
    city: "Arlington",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 898,
    density: 13.3,
    county_fips: 18139,
    county_name: "Rush",
    county_weights: {
      18139: 100,
    },
    county_names_all: "Rush",
    county_fips_all: 18139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46105,
    lat: 39.76388,
    lng: -86.81487,
    city: "Bainbridge",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1677,
    density: 16.1,
    county_fips: 18133,
    county_name: "Putnam",
    county_weights: {
      18133: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 18133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46106,
    lat: 39.51555,
    lng: -86.20524,
    city: "Bargersville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7759,
    density: 106.3,
    county_fips: 18081,
    county_name: "Johnson",
    county_weights: {
      18081: 96.5,
      18109: 3.5,
    },
    county_names_all: "Johnson|Morgan",
    county_fips_all: "18081|18109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46107,
    lat: 39.71661,
    lng: -86.09161,
    city: "Beech Grove",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13245,
    density: 1533.6,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18097: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 18097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46110,
    lat: 39.56021,
    lng: -85.91333,
    city: "Boggstown",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 890,
    density: 23.4,
    county_fips: 18145,
    county_name: "Shelby",
    county_weights: {
      18145: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 18145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46111,
    lat: 39.5417,
    lng: -86.36863,
    city: "Brooklyn",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 219,
    density: 375.9,
    county_fips: 18109,
    county_name: "Morgan",
    county_weights: {
      18109: 100,
    },
    county_names_all: "Morgan",
    county_fips_all: 18109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46112,
    lat: 39.86561,
    lng: -86.38215,
    city: "Brownsburg",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38655,
    density: 354.5,
    county_fips: 18063,
    county_name: "Hendricks",
    county_weights: {
      18011: 3.35,
      18063: 96.65,
    },
    county_names_all: "Hendricks|Boone",
    county_fips_all: "18063|18011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46113,
    lat: 39.635,
    lng: -86.30548,
    city: "Camby",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14860,
    density: 360.1,
    county_fips: 18109,
    county_name: "Morgan",
    county_weights: {
      18063: 14.84,
      18097: 37.16,
      18109: 48,
    },
    county_names_all: "Morgan|Marion|Hendricks",
    county_fips_all: "18109|18097|18063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46115,
    lat: 39.7375,
    lng: -85.56623,
    city: "Carthage",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1930,
    density: 19.1,
    county_fips: 18139,
    county_name: "Rush",
    county_weights: {
      18059: 5.8,
      18139: 94.2,
    },
    county_names_all: "Rush|Hancock",
    county_fips_all: "18139|18059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46117,
    lat: 39.81507,
    lng: -85.61763,
    city: "Charlottesville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 576,
    density: 20.3,
    county_fips: 18059,
    county_name: "Hancock",
    county_weights: {
      18059: 90.76,
      18065: 9.24,
    },
    county_names_all: "Hancock|Henry",
    county_fips_all: "18059|18065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46118,
    lat: 39.65317,
    lng: -86.52394,
    city: "Clayton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4855,
    density: 34.4,
    county_fips: 18063,
    county_name: "Hendricks",
    county_weights: {
      18063: 92.58,
      18109: 7.42,
    },
    county_names_all: "Hendricks|Morgan",
    county_fips_all: "18063|18109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46120,
    lat: 39.51252,
    lng: -86.78711,
    city: "Cloverdale",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5547,
    density: 23.4,
    county_fips: 18133,
    county_name: "Putnam",
    county_weights: {
      18109: 5.76,
      18119: 13,
      18133: 81.24,
    },
    county_names_all: "Putnam|Owen|Morgan",
    county_fips_all: "18133|18119|18109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46121,
    lat: 39.67776,
    lng: -86.67345,
    city: "Coatesville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5357,
    density: 37.4,
    county_fips: 18063,
    county_name: "Hendricks",
    county_weights: {
      18063: 51.98,
      18133: 48.02,
    },
    county_names_all: "Hendricks|Putnam",
    county_fips_all: "18063|18133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46122,
    lat: 39.76822,
    lng: -86.5475,
    city: "Danville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16053,
    density: 70.1,
    county_fips: 18063,
    county_name: "Hendricks",
    county_weights: {
      18063: 100,
    },
    county_names_all: "Hendricks",
    county_fips_all: 18063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46123,
    lat: 39.76502,
    lng: -86.40015,
    city: "Avon",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38655,
    density: 522.2,
    county_fips: 18063,
    county_name: "Hendricks",
    county_weights: {
      18063: 100,
    },
    county_names_all: "Hendricks",
    county_fips_all: 18063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46124,
    lat: 39.36914,
    lng: -85.94551,
    city: "Edinburgh",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8729,
    density: 45.8,
    county_fips: 18145,
    county_name: "Shelby",
    county_weights: {
      18005: 30.44,
      18081: 23.15,
      18145: 46.4,
    },
    county_names_all: "Shelby|Bartholomew|Johnson",
    county_fips_all: "18145|18005|18081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46125,
    lat: 39.52188,
    lng: -86.64179,
    city: "Eminence",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45,
    density: 670.3,
    county_fips: 18109,
    county_name: "Morgan",
    county_weights: {
      18109: 100,
    },
    county_names_all: "Morgan",
    county_fips_all: 18109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46126,
    lat: 39.62053,
    lng: -85.88694,
    city: "Fairland",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4667,
    density: 55.2,
    county_fips: 18145,
    county_name: "Shelby",
    county_weights: {
      18145: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 18145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46127,
    lat: 39.71766,
    lng: -85.3158,
    city: "Falmouth",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 324,
    density: 6.1,
    county_fips: 18139,
    county_name: "Rush",
    county_weights: {
      18041: 28.94,
      18139: 71.06,
    },
    county_names_all: "Rush|Fayette",
    county_fips_all: "18139|18041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46128,
    lat: 39.65634,
    lng: -86.74312,
    city: "Fillmore",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1853,
    density: 21.3,
    county_fips: 18133,
    county_name: "Putnam",
    county_weights: {
      18133: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 18133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46130,
    lat: 39.67464,
    lng: -85.83571,
    city: "Fountaintown",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2698,
    density: 34.5,
    county_fips: 18145,
    county_name: "Shelby",
    county_weights: {
      18059: 13.12,
      18145: 86.88,
    },
    county_names_all: "Shelby|Hancock",
    county_fips_all: "18145|18059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46131,
    lat: 39.47196,
    lng: -86.04233,
    city: "Franklin",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33682,
    density: 103.2,
    county_fips: 18081,
    county_name: "Johnson",
    county_weights: {
      18081: 93.1,
      18145: 6.9,
    },
    county_names_all: "Johnson|Shelby",
    county_fips_all: "18081|18145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46133,
    lat: 39.58945,
    lng: -85.30044,
    city: "Glenwood",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 756,
    density: 11.2,
    county_fips: 18139,
    county_name: "Rush",
    county_weights: {
      18041: 47.18,
      18139: 52.82,
    },
    county_names_all: "Rush|Fayette",
    county_fips_all: "18139|18041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46135,
    lat: 39.65909,
    lng: -86.89107,
    city: "Greencastle",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20180,
    density: 46.6,
    county_fips: 18133,
    county_name: "Putnam",
    county_weights: {
      18121: 1.58,
      18133: 98.42,
    },
    county_names_all: "Putnam|Parke",
    county_fips_all: "18133|18121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46140,
    lat: 39.80358,
    lng: -85.77049,
    city: "Greenfield",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41334,
    density: 92.5,
    county_fips: 18059,
    county_name: "Hancock",
    county_weights: {
      18059: 98.93,
      18139: 0.64,
      18145: 0.43,
    },
    county_names_all: "Hancock|Rush|Shelby",
    county_fips_all: "18059|18139|18145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46142,
    lat: 39.62029,
    lng: -86.1764,
    city: "Greenwood",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32162,
    density: 831.2,
    county_fips: 18081,
    county_name: "Johnson",
    county_weights: {
      18081: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 18081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46143,
    lat: 39.59484,
    lng: -86.11323,
    city: "Greenwood",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55965,
    density: 437.1,
    county_fips: 18081,
    county_name: "Johnson",
    county_weights: {
      18081: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 18081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46144,
    lat: 39.66586,
    lng: -85.64706,
    city: "Gwynneville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 100,
    density: 30.4,
    county_fips: 18145,
    county_name: "Shelby",
    county_weights: {
      18145: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 18145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46146,
    lat: 39.57968,
    lng: -85.56972,
    city: "Homer",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 257,
    density: 89.2,
    county_fips: 18139,
    county_name: "Rush",
    county_weights: {
      18139: 100,
    },
    county_names_all: "Rush",
    county_fips_all: 18139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46147,
    lat: 39.96988,
    lng: -86.62693,
    city: "Jamestown",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3130,
    density: 21.3,
    county_fips: 18011,
    county_name: "Boone",
    county_weights: {
      18011: 90.82,
      18063: 9.18,
    },
    county_names_all: "Boone|Hendricks",
    county_fips_all: "18011|18063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46148,
    lat: 39.80906,
    lng: -85.51296,
    city: "Knightstown",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5464,
    density: 41.3,
    county_fips: 18065,
    county_name: "Henry",
    county_weights: {
      18065: 68.29,
      18139: 31.71,
    },
    county_names_all: "Henry|Rush",
    county_fips_all: "18065|18139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46149,
    lat: 39.88545,
    lng: -86.55758,
    city: "Lizton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2287,
    density: 33.1,
    county_fips: 18063,
    county_name: "Hendricks",
    county_weights: {
      18063: 100,
    },
    county_names_all: "Hendricks",
    county_fips_all: 18063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46150,
    lat: 39.54695,
    lng: -85.60232,
    city: "Manilla",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1024,
    density: 15.3,
    county_fips: 18139,
    county_name: "Rush",
    county_weights: {
      18139: 89.13,
      18145: 10.87,
    },
    county_names_all: "Rush|Shelby",
    county_fips_all: "18139|18145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46151,
    lat: 39.44783,
    lng: -86.4275,
    city: "Martinsville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31129,
    density: 59,
    county_fips: 18109,
    county_name: "Morgan",
    county_weights: {
      18081: 0.22,
      18105: 3.31,
      18109: 96.47,
    },
    county_names_all: "Morgan|Monroe|Johnson",
    county_fips_all: "18109|18105|18081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46154,
    lat: 39.85639,
    lng: -85.77038,
    city: "Maxwell",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18059,
    county_name: "Hancock",
    county_weights: {
      18059: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 18059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46155,
    lat: 39.74355,
    lng: -85.42966,
    city: "Mays",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 164,
    density: 3160.8,
    county_fips: 18139,
    county_name: "Rush",
    county_weights: {
      18139: 100,
    },
    county_names_all: "Rush",
    county_fips_all: 18139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46156,
    lat: 39.48451,
    lng: -85.4806,
    city: "Milroy",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1156,
    density: 11.1,
    county_fips: 18139,
    county_name: "Rush",
    county_weights: {
      18031: 0.8,
      18139: 99.2,
    },
    county_names_all: "Rush|Decatur",
    county_fips_all: "18139|18031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46157,
    lat: 39.55623,
    lng: -86.52741,
    city: "Monrovia",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3844,
    density: 48.5,
    county_fips: 18109,
    county_name: "Morgan",
    county_weights: {
      18109: 100,
    },
    county_names_all: "Morgan",
    county_fips_all: 18109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46158,
    lat: 39.58275,
    lng: -86.37405,
    city: "Mooresville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24279,
    density: 122.2,
    county_fips: 18109,
    county_name: "Morgan",
    county_weights: {
      18063: 11.32,
      18109: 88.68,
    },
    county_names_all: "Morgan|Hendricks",
    county_fips_all: "18109|18063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46160,
    lat: 39.35429,
    lng: -86.26753,
    city: "Morgantown",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6466,
    density: 28.6,
    county_fips: 18013,
    county_name: "Brown",
    county_weights: {
      18013: 48.18,
      18081: 25.62,
      18109: 26.2,
    },
    county_names_all: "Brown|Morgan|Johnson",
    county_fips_all: "18013|18109|18081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46161,
    lat: 39.66959,
    lng: -85.69395,
    city: "Morristown",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2288,
    density: 25.7,
    county_fips: 18145,
    county_name: "Shelby",
    county_weights: {
      18059: 11.04,
      18139: 3.84,
      18145: 85.12,
    },
    county_names_all: "Shelby|Hancock|Rush",
    county_fips_all: "18145|18059|18139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46162,
    lat: 39.55021,
    lng: -85.95242,
    city: "Needham",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 235,
    density: 7.5,
    county_fips: 18081,
    county_name: "Johnson",
    county_weights: {
      18081: 53.76,
      18145: 46.24,
    },
    county_names_all: "Johnson|Shelby",
    county_fips_all: "18081|18145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46163,
    lat: 39.7287,
    lng: -85.90435,
    city: "New Palestine",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13530,
    density: 176.2,
    county_fips: 18059,
    county_name: "Hancock",
    county_weights: {
      18059: 85.94,
      18097: 1,
      18145: 13.06,
    },
    county_names_all: "Hancock|Shelby|Marion",
    county_fips_all: "18059|18145|18097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46164,
    lat: 39.3036,
    lng: -86.12301,
    city: "Nineveh",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4097,
    density: 59.9,
    county_fips: 18013,
    county_name: "Brown",
    county_weights: {
      18013: 85.94,
      18081: 14.06,
    },
    county_names_all: "Brown|Johnson",
    county_fips_all: "18013|18081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46165,
    lat: 39.84522,
    lng: -86.64716,
    city: "North Salem",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1657,
    density: 15.3,
    county_fips: 18063,
    county_name: "Hendricks",
    county_weights: {
      18063: 96.4,
      18133: 3.6,
    },
    county_names_all: "Hendricks|Putnam",
    county_fips_all: "18063|18133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46166,
    lat: 39.42686,
    lng: -86.58755,
    city: "Paragon",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2281,
    density: 22.6,
    county_fips: 18109,
    county_name: "Morgan",
    county_weights: {
      18109: 95.45,
      18119: 4.55,
    },
    county_names_all: "Morgan|Owen",
    county_fips_all: "18109|18119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46167,
    lat: 39.87675,
    lng: -86.46981,
    city: "Pittsboro",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7319,
    density: 97.3,
    county_fips: 18063,
    county_name: "Hendricks",
    county_weights: {
      18063: 100,
    },
    county_names_all: "Hendricks",
    county_fips_all: 18063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46168,
    lat: 39.68985,
    lng: -86.39262,
    city: "Plainfield",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36233,
    density: 426.3,
    county_fips: 18063,
    county_name: "Hendricks",
    county_weights: {
      18063: 100,
    },
    county_names_all: "Hendricks",
    county_fips_all: 18063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46170,
    lat: 39.57164,
    lng: -86.86277,
    city: "Putnamville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18133,
    county_name: "Putnam",
    county_weights: {
      18133: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 18133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46171,
    lat: 39.53527,
    lng: -86.96815,
    city: "Reelsville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2126,
    density: 21.2,
    county_fips: 18133,
    county_name: "Putnam",
    county_weights: {
      18021: 1.53,
      18133: 98.47,
    },
    county_names_all: "Putnam|Clay",
    county_fips_all: "18133|18021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46172,
    lat: 39.82725,
    lng: -86.8144,
    city: "Roachdale",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2640,
    density: 14.8,
    county_fips: 18133,
    county_name: "Putnam",
    county_weights: {
      18107: 5.27,
      18133: 94.73,
    },
    county_names_all: "Putnam|Montgomery",
    county_fips_all: "18133|18107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46173,
    lat: 39.60294,
    lng: -85.42677,
    city: "Rushville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10089,
    density: 17.3,
    county_fips: 18139,
    county_name: "Rush",
    county_weights: {
      18031: 2.23,
      18041: 0.67,
      18047: 1.92,
      18139: 95.18,
    },
    county_names_all: "Rush|Decatur|Franklin|Fayette",
    county_fips_all: "18139|18031|18047|18041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46175,
    lat: 39.82199,
    lng: -86.97292,
    city: "Russellville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 616,
    density: 10.2,
    county_fips: 18133,
    county_name: "Putnam",
    county_weights: {
      18121: 4.16,
      18133: 95.84,
    },
    county_names_all: "Putnam|Parke",
    county_fips_all: "18133|18121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46176,
    lat: 39.52684,
    lng: -85.77297,
    city: "Shelbyville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28014,
    density: 63.8,
    county_fips: 18145,
    county_name: "Shelby",
    county_weights: {
      18145: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 18145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46180,
    lat: 39.59652,
    lng: -86.61801,
    city: "Stilesville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1010,
    density: 15.6,
    county_fips: 18109,
    county_name: "Morgan",
    county_weights: {
      18063: 44.15,
      18109: 55.85,
    },
    county_names_all: "Morgan|Hendricks",
    county_fips_all: "18109|18063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46181,
    lat: 39.38044,
    lng: -86.16119,
    city: "Trafalgar",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5397,
    density: 45.8,
    county_fips: 18081,
    county_name: "Johnson",
    county_weights: {
      18013: 15.36,
      18081: 84.64,
    },
    county_names_all: "Johnson|Brown",
    county_fips_all: "18081|18013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46182,
    lat: 39.46157,
    lng: -85.67005,
    city: "Waldron",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1522,
    density: 16.4,
    county_fips: 18145,
    county_name: "Shelby",
    county_weights: {
      18139: 17.92,
      18145: 82.08,
    },
    county_names_all: "Shelby|Rush",
    county_fips_all: "18145|18139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46183,
    lat: 39.65397,
    lng: -86.28121,
    city: "West Newton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18097: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 18097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46184,
    lat: 39.55967,
    lng: -86.07361,
    city: "Whiteland",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14074,
    density: 300,
    county_fips: 18081,
    county_name: "Johnson",
    county_weights: {
      18081: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 18081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46186,
    lat: 39.89126,
    lng: -85.64264,
    city: "Wilkinson",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1703,
    density: 23.6,
    county_fips: 18059,
    county_name: "Hancock",
    county_weights: {
      18059: 97.72,
      18065: 2.28,
    },
    county_names_all: "Hancock|Henry",
    county_fips_all: "18059|18065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46201,
    lat: 39.77369,
    lng: -86.10949,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31233,
    density: 2159.6,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18097: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 18097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46202,
    lat: 39.78363,
    lng: -86.16187,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20061,
    density: 1414.1,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18097: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 18097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46203,
    lat: 39.7368,
    lng: -86.09586,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38184,
    density: 1057.7,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18097: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 18097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46204,
    lat: 39.77134,
    lng: -86.15703,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9410,
    density: 3195.3,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18097: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 18097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46205,
    lat: 39.82813,
    lng: -86.13499,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28367,
    density: 1754.7,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18097: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 18097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46206,
    lat: 39.76027,
    lng: -86.16107,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18097: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 18097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46208,
    lat: 39.82307,
    lng: -86.17307,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21976,
    density: 1230.3,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18097: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 18097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46214,
    lat: 39.7917,
    lng: -86.29009,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23644,
    density: 1223.4,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18097: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 18097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46216,
    lat: 39.86593,
    lng: -86.00929,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2073,
    density: 262.4,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18097: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 18097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46217,
    lat: 39.67254,
    lng: -86.19338,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36686,
    density: 669.5,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18097: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 18097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46218,
    lat: 39.80713,
    lng: -86.09958,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28950,
    density: 1171.8,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18097: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 18097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46219,
    lat: 39.78314,
    lng: -86.04444,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37192,
    density: 1101.1,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18097: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 18097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46220,
    lat: 39.8676,
    lng: -86.10818,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37367,
    density: 1229.2,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18097: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 18097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46221,
    lat: 39.69288,
    lng: -86.23664,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27098,
    density: 523.6,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18097: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 18097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46222,
    lat: 39.79088,
    lng: -86.21477,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38629,
    density: 1351,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18097: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 18097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46224,
    lat: 39.79537,
    lng: -86.25624,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37197,
    density: 2008.6,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18097: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 18097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46225,
    lat: 39.74062,
    lng: -86.16294,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5457,
    density: 529.5,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18097: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 18097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46226,
    lat: 39.83968,
    lng: -86.05117,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46718,
    density: 1218.5,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18097: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 18097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46227,
    lat: 39.67607,
    lng: -86.13145,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55806,
    density: 1291,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18097: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 18097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46228,
    lat: 39.8487,
    lng: -86.20045,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16541,
    density: 806.2,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18097: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 18097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46229,
    lat: 39.78852,
    lng: -85.978,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28964,
    density: 985.6,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18059: 10.4,
      18097: 89.6,
    },
    county_names_all: "Marion|Hancock",
    county_fips_all: "18097|18059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46231,
    lat: 39.72086,
    lng: -86.32712,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10904,
    density: 360.8,
    county_fips: 18063,
    county_name: "Hendricks",
    county_weights: {
      18063: 52.39,
      18097: 47.61,
    },
    county_names_all: "Hendricks|Marion",
    county_fips_all: "18063|18097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46234,
    lat: 39.81077,
    lng: -86.32665,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26066,
    density: 813.6,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18063: 48.08,
      18097: 51.92,
    },
    county_names_all: "Marion|Hendricks",
    county_fips_all: "18097|18063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46235,
    lat: 39.83784,
    lng: -85.97651,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32729,
    density: 1318.9,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18097: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 18097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46236,
    lat: 39.89132,
    lng: -85.96766,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29058,
    density: 1068.9,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18059: 0.1,
      18097: 99.9,
    },
    county_names_all: "Marion|Hancock",
    county_fips_all: "18097|18059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46237,
    lat: 39.67247,
    lng: -86.0759,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37026,
    density: 974.2,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18097: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 18097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46239,
    lat: 39.72311,
    lng: -86.0004,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31340,
    density: 428.2,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18059: 0.84,
      18097: 99.16,
    },
    county_names_all: "Marion|Hancock",
    county_fips_all: "18097|18059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46240,
    lat: 39.90697,
    lng: -86.12367,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20284,
    density: 800.1,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18057: 2.1,
      18097: 97.9,
    },
    county_names_all: "Marion|Hamilton",
    county_fips_all: "18097|18057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46241,
    lat: 39.72389,
    lng: -86.26842,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32297,
    density: 521.7,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18097: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 18097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46250,
    lat: 39.90399,
    lng: -86.06864,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17946,
    density: 894.7,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18057: 0.56,
      18097: 99.44,
    },
    county_names_all: "Marion|Hamilton",
    county_fips_all: "18097|18057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46254,
    lat: 39.84796,
    lng: -86.26936,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40206,
    density: 1233.3,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18097: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 18097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46256,
    lat: 39.90682,
    lng: -86.01152,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23894,
    density: 827.8,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18057: 11.25,
      18097: 88.75,
    },
    county_names_all: "Marion|Hamilton",
    county_fips_all: "18097|18057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46259,
    lat: 39.65078,
    lng: -85.98692,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12617,
    density: 214.7,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18081: 21.67,
      18097: 67.91,
      18145: 10.42,
    },
    county_names_all: "Marion|Johnson|Shelby",
    county_fips_all: "18097|18081|18145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46260,
    lat: 39.89744,
    lng: -86.17927,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35582,
    density: 1319.4,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18057: 0.98,
      18097: 99.02,
    },
    county_names_all: "Marion|Hamilton",
    county_fips_all: "18097|18057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46268,
    lat: 39.89769,
    lng: -86.23253,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25123,
    density: 764.4,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18011: 1.71,
      18057: 0.63,
      18097: 97.66,
    },
    county_names_all: "Marion|Boone|Hamilton",
    county_fips_all: "18097|18011|18057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46278,
    lat: 39.89389,
    lng: -86.29606,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9460,
    density: 276.4,
    county_fips: 18097,
    county_name: "Marion",
    county_weights: {
      18063: 4.24,
      18097: 95.76,
    },
    county_names_all: "Marion|Hendricks",
    county_fips_all: "18097|18063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46280,
    lat: 39.93714,
    lng: -86.11786,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7727,
    density: 719.8,
    county_fips: 18057,
    county_name: "Hamilton",
    county_weights: {
      18057: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 18057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46290,
    lat: 39.93376,
    lng: -86.16256,
    city: "Indianapolis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 149,
    density: 90.2,
    county_fips: 18057,
    county_name: "Hamilton",
    county_weights: {
      18057: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 18057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46301,
    lat: 41.68687,
    lng: -86.97438,
    city: "Beverly Shores",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 690,
    density: 60.6,
    county_fips: 18127,
    county_name: "Porter",
    county_weights: {
      18127: 100,
    },
    county_names_all: "Porter",
    county_fips_all: 18127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46302,
    lat: 41.3604,
    lng: -87.12645,
    city: "Boone Grove",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18127,
    county_name: "Porter",
    county_weights: {
      18127: 100,
    },
    county_names_all: "Porter",
    county_fips_all: 18127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46303,
    lat: 41.37198,
    lng: -87.4765,
    city: "Cedar Lake",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14799,
    density: 198.7,
    county_fips: 18089,
    county_name: "Lake",
    county_weights: {
      18089: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 18089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46304,
    lat: 41.61311,
    lng: -87.04905,
    city: "Chesterton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25738,
    density: 172,
    county_fips: 18127,
    county_name: "Porter",
    county_weights: {
      18127: 100,
    },
    county_names_all: "Porter",
    county_fips_all: 18127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46307,
    lat: 41.40215,
    lng: -87.32693,
    city: "Crown Point",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64043,
    density: 283.5,
    county_fips: 18089,
    county_name: "Lake",
    county_weights: {
      18089: 97.07,
      18127: 2.93,
    },
    county_names_all: "Lake|Porter",
    county_fips_all: "18089|18127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46310,
    lat: 41.18205,
    lng: -87.23088,
    city: "Demotte",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13615,
    density: 82.9,
    county_fips: 18073,
    county_name: "Jasper",
    county_weights: {
      18073: 77.98,
      18111: 22.02,
    },
    county_names_all: "Jasper|Newton",
    county_fips_all: "18073|18111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46311,
    lat: 41.46846,
    lng: -87.50918,
    city: "Dyer",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21987,
    density: 673.7,
    county_fips: 18089,
    county_name: "Lake",
    county_weights: {
      18089: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 18089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46312,
    lat: 41.64705,
    lng: -87.45446,
    city: "East Chicago",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28044,
    density: 771.6,
    county_fips: 18089,
    county_name: "Lake",
    county_weights: {
      18089: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 18089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46319,
    lat: 41.52217,
    lng: -87.42091,
    city: "Griffith",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17384,
    density: 700.5,
    county_fips: 18089,
    county_name: "Lake",
    county_weights: {
      18089: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 18089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46320,
    lat: 41.60893,
    lng: -87.49754,
    city: "Hammond",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13142,
    density: 1089.6,
    county_fips: 18089,
    county_name: "Lake",
    county_weights: {
      18089: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 18089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46321,
    lat: 41.54704,
    lng: -87.50402,
    city: "Munster",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22604,
    density: 1149.2,
    county_fips: 18089,
    county_name: "Lake",
    county_weights: {
      18089: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 18089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46322,
    lat: 41.54818,
    lng: -87.45884,
    city: "Highland",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22479,
    density: 1258.2,
    county_fips: 18089,
    county_name: "Lake",
    county_weights: {
      18089: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 18089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46323,
    lat: 41.58961,
    lng: -87.45323,
    city: "Hammond",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22516,
    density: 1401.9,
    county_fips: 18089,
    county_name: "Lake",
    county_weights: {
      18089: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 18089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46324,
    lat: 41.58324,
    lng: -87.50155,
    city: "Hammond",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21643,
    density: 1916.7,
    county_fips: 18089,
    county_name: "Lake",
    county_weights: {
      18089: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 18089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46327,
    lat: 41.64048,
    lng: -87.50677,
    city: "Hammond",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11346,
    density: 952,
    county_fips: 18089,
    county_name: "Lake",
    county_weights: {
      18089: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 18089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46340,
    lat: 41.38339,
    lng: -86.76846,
    city: "Hanna",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1006,
    density: 11.7,
    county_fips: 18091,
    county_name: "LaPorte",
    county_weights: {
      18091: 100,
    },
    county_names_all: "LaPorte",
    county_fips_all: 18091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46341,
    lat: 41.30666,
    lng: -87.21962,
    city: "Hebron",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10291,
    density: 41.6,
    county_fips: 18127,
    county_name: "Porter",
    county_weights: {
      18073: 1.38,
      18089: 48.89,
      18127: 49.72,
    },
    county_names_all: "Porter|Lake|Jasper",
    county_fips_all: "18127|18089|18073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46342,
    lat: 41.51761,
    lng: -87.24468,
    city: "Hobart",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31080,
    density: 342.5,
    county_fips: 18089,
    county_name: "Lake",
    county_weights: {
      18089: 72.16,
      18127: 27.84,
    },
    county_names_all: "Lake|Porter",
    county_fips_all: "18089|18127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46345,
    lat: 41.53032,
    lng: -86.69995,
    city: "Kingsbury",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 168,
    density: 670.5,
    county_fips: 18091,
    county_name: "LaPorte",
    county_weights: {
      18091: 100,
    },
    county_names_all: "LaPorte",
    county_fips_all: 18091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46346,
    lat: 41.47816,
    lng: -86.69332,
    city: "Kingsford Heights",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1381,
    density: 622.1,
    county_fips: 18091,
    county_name: "LaPorte",
    county_weights: {
      18091: 100,
    },
    county_names_all: "LaPorte",
    county_fips_all: 18091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46347,
    lat: 41.30502,
    lng: -87.00859,
    city: "Kouts",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4854,
    density: 26,
    county_fips: 18127,
    county_name: "Porter",
    county_weights: {
      18127: 100,
    },
    county_names_all: "Porter",
    county_fips_all: 18127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46348,
    lat: 41.30981,
    lng: -86.86244,
    city: "La Crosse",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1104,
    density: 8.4,
    county_fips: 18091,
    county_name: "LaPorte",
    county_weights: {
      18091: 98.95,
      18127: 1.05,
    },
    county_names_all: "LaPorte|Porter",
    county_fips_all: "18091|18127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46349,
    lat: 41.10899,
    lng: -87.42359,
    city: "Lake Village",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3100,
    density: 15.1,
    county_fips: 18111,
    county_name: "Newton",
    county_weights: {
      18111: 100,
    },
    county_names_all: "Newton",
    county_fips_all: 18111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46350,
    lat: 41.60697,
    lng: -86.72157,
    city: "La Porte",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43220,
    density: 86.2,
    county_fips: 18091,
    county_name: "LaPorte",
    county_weights: {
      18091: 100,
    },
    county_names_all: "LaPorte",
    county_fips_all: 18091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46356,
    lat: 41.26117,
    lng: -87.41863,
    city: "Lowell",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17890,
    density: 61.4,
    county_fips: 18089,
    county_name: "Lake",
    county_weights: {
      18089: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 18089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46360,
    lat: 41.68739,
    lng: -86.86464,
    city: "Michigan City",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43334,
    density: 218.5,
    county_fips: 18091,
    county_name: "LaPorte",
    county_weights: {
      18091: 84.22,
      18127: 15.78,
    },
    county_names_all: "LaPorte|Porter",
    county_fips_all: "18091|18127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46365,
    lat: 41.60605,
    lng: -86.54112,
    city: "Mill Creek",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 615,
    density: 10.5,
    county_fips: 18091,
    county_name: "LaPorte",
    county_weights: {
      18091: 100,
    },
    county_names_all: "LaPorte",
    county_fips_all: 18091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46366,
    lat: 41.21443,
    lng: -86.76922,
    city: "North Judson",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5510,
    density: 26.5,
    county_fips: 18149,
    county_name: "Starke",
    county_weights: {
      18131: 14.91,
      18149: 85.09,
    },
    county_names_all: "Starke|Pulaski",
    county_fips_all: "18149|18131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Knox",
  },
  {
    zip: 46368,
    lat: 41.5848,
    lng: -87.17937,
    city: "Portage",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38503,
    density: 586.8,
    county_fips: 18127,
    county_name: "Porter",
    county_weights: {
      18127: 100,
    },
    county_names_all: "Porter",
    county_fips_all: 18127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46371,
    lat: 41.67683,
    lng: -86.6005,
    city: "Rolling Prairie",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3348,
    density: 34.4,
    county_fips: 18091,
    county_name: "LaPorte",
    county_weights: {
      18091: 100,
    },
    county_names_all: "LaPorte",
    county_fips_all: 18091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46373,
    lat: 41.44578,
    lng: -87.46954,
    city: "Saint John",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16670,
    density: 591.5,
    county_fips: 18089,
    county_name: "Lake",
    county_weights: {
      18089: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 18089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46374,
    lat: 41.20616,
    lng: -86.895,
    city: "San Pierre",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 952,
    density: 10.6,
    county_fips: 18149,
    county_name: "Starke",
    county_weights: {
      18073: 15.03,
      18131: 13.16,
      18149: 71.8,
    },
    county_names_all: "Starke|Jasper|Pulaski",
    county_fips_all: "18149|18073|18131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Knox",
  },
  {
    zip: 46375,
    lat: 41.49162,
    lng: -87.45193,
    city: "Schererville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23400,
    density: 708.2,
    county_fips: 18089,
    county_name: "Lake",
    county_weights: {
      18089: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 18089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46376,
    lat: 41.1838,
    lng: -87.47603,
    city: "Schneider",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 190,
    density: 8.2,
    county_fips: 18089,
    county_name: "Lake",
    county_weights: {
      18089: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 18089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46377,
    lat: 41.19432,
    lng: -87.34777,
    city: "Shelby",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 370,
    density: 691.4,
    county_fips: 18089,
    county_name: "Lake",
    county_weights: {
      18089: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 18089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46379,
    lat: 41.15682,
    lng: -87.4302,
    city: "Sumava Resorts",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 114,
    density: 14.4,
    county_fips: 18111,
    county_name: "Newton",
    county_weights: {
      18111: 100,
    },
    county_names_all: "Newton",
    county_fips_all: 18111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46381,
    lat: 41.17635,
    lng: -87.33436,
    city: "Thayer",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 202,
    density: 36.5,
    county_fips: 18111,
    county_name: "Newton",
    county_weights: {
      18111: 100,
    },
    county_names_all: "Newton",
    county_fips_all: 18111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46382,
    lat: 41.46868,
    lng: -86.76212,
    city: "Union Mills",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2114,
    density: 16.7,
    county_fips: 18091,
    county_name: "LaPorte",
    county_weights: {
      18091: 100,
    },
    county_names_all: "LaPorte",
    county_fips_all: 18091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46383,
    lat: 41.45838,
    lng: -87.00156,
    city: "Valparaiso",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41474,
    density: 182.9,
    county_fips: 18127,
    county_name: "Porter",
    county_weights: {
      18127: 100,
    },
    county_names_all: "Porter",
    county_fips_all: 18127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46385,
    lat: 41.46395,
    lng: -87.12396,
    city: "Valparaiso",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40239,
    density: 192.4,
    county_fips: 18127,
    county_name: "Porter",
    county_weights: {
      18127: 100,
    },
    county_names_all: "Porter",
    county_fips_all: 18127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46390,
    lat: 41.41677,
    lng: -86.8742,
    city: "Wanatah",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3332,
    density: 26.2,
    county_fips: 18091,
    county_name: "LaPorte",
    county_weights: {
      18091: 99.29,
      18127: 0.71,
    },
    county_names_all: "LaPorte|Porter",
    county_fips_all: "18091|18127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46391,
    lat: 41.5455,
    lng: -86.91446,
    city: "Westville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9183,
    density: 89.4,
    county_fips: 18091,
    county_name: "LaPorte",
    county_weights: {
      18091: 66.88,
      18127: 33.12,
    },
    county_names_all: "LaPorte|Porter",
    county_fips_all: "18091|18127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46392,
    lat: 41.18509,
    lng: -87.04948,
    city: "Wheatfield",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7686,
    density: 27.4,
    county_fips: 18073,
    county_name: "Jasper",
    county_weights: {
      18073: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 18073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46393,
    lat: 41.5139,
    lng: -87.16801,
    city: "Wheeler",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 214,
    density: 48.1,
    county_fips: 18127,
    county_name: "Porter",
    county_weights: {
      18127: 100,
    },
    county_names_all: "Porter",
    county_fips_all: 18127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46394,
    lat: 41.67733,
    lng: -87.50279,
    city: "Whiting",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12295,
    density: 1001,
    county_fips: 18089,
    county_name: "Lake",
    county_weights: {
      18089: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 18089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46402,
    lat: 41.61032,
    lng: -87.33297,
    city: "Gary",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6549,
    density: 299.7,
    county_fips: 18089,
    county_name: "Lake",
    county_weights: {
      18089: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 18089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46403,
    lat: 41.60636,
    lng: -87.25803,
    city: "Gary",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12992,
    density: 548.9,
    county_fips: 18089,
    county_name: "Lake",
    county_weights: {
      18089: 89.6,
      18127: 10.4,
    },
    county_names_all: "Lake|Porter",
    county_fips_all: "18089|18127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46404,
    lat: 41.58475,
    lng: -87.37502,
    city: "Gary",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17848,
    density: 1147.1,
    county_fips: 18089,
    county_name: "Lake",
    county_weights: {
      18089: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 18089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46405,
    lat: 41.57409,
    lng: -87.26285,
    city: "Lake Station",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10504,
    density: 449.3,
    county_fips: 18089,
    county_name: "Lake",
    county_weights: {
      18089: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 18089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46406,
    lat: 41.6022,
    lng: -87.40804,
    city: "Gary",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8779,
    density: 251.5,
    county_fips: 18089,
    county_name: "Lake",
    county_weights: {
      18089: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 18089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46407,
    lat: 41.57844,
    lng: -87.33047,
    city: "Gary",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10885,
    density: 1006.6,
    county_fips: 18089,
    county_name: "Lake",
    county_weights: {
      18089: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 18089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46408,
    lat: 41.54468,
    lng: -87.36941,
    city: "Gary",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16082,
    density: 637.5,
    county_fips: 18089,
    county_name: "Lake",
    county_weights: {
      18089: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 18089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46409,
    lat: 41.54828,
    lng: -87.32422,
    city: "Gary",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7049,
    density: 760.3,
    county_fips: 18089,
    county_name: "Lake",
    county_weights: {
      18089: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 18089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46410,
    lat: 41.48083,
    lng: -87.33293,
    city: "Merrillville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37569,
    density: 482.7,
    county_fips: 18089,
    county_name: "Lake",
    county_weights: {
      18089: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 18089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 46501,
    lat: 41.22327,
    lng: -86.24868,
    city: "Argos",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3440,
    density: 18.7,
    county_fips: 18099,
    county_name: "Marshall",
    county_weights: {
      18049: 3.21,
      18099: 96.79,
    },
    county_names_all: "Marshall|Fulton",
    county_fips_all: "18099|18049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46502,
    lat: 41.26099,
    lng: -85.97699,
    city: "Atwood",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 84,
    density: 2044.9,
    county_fips: 18085,
    county_name: "Kosciusko",
    county_weights: {
      18085: 100,
    },
    county_names_all: "Kosciusko",
    county_fips_all: 18085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46504,
    lat: 41.30057,
    lng: -86.11204,
    city: "Bourbon",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3518,
    density: 20.4,
    county_fips: 18099,
    county_name: "Marshall",
    county_weights: {
      18085: 4.22,
      18099: 95.78,
    },
    county_names_all: "Marshall|Kosciusko",
    county_fips_all: "18099|18085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46506,
    lat: 41.46316,
    lng: -86.16915,
    city: "Bremen",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9746,
    density: 37.2,
    county_fips: 18099,
    county_name: "Marshall",
    county_weights: {
      18085: 0.71,
      18099: 61.78,
      18141: 37.51,
    },
    county_names_all: "Marshall|St. Joseph|Kosciusko",
    county_fips_all: "18099|18141|18085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46507,
    lat: 41.72138,
    lng: -85.81571,
    city: "Bristol",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10158,
    density: 97.2,
    county_fips: 18039,
    county_name: "Elkhart",
    county_weights: {
      18039: 100,
    },
    county_names_all: "Elkhart",
    county_fips_all: 18039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46508,
    lat: 41.15499,
    lng: -85.96904,
    city: "Burket",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 180,
    density: 865.9,
    county_fips: 18085,
    county_name: "Kosciusko",
    county_weights: {
      18085: 100,
    },
    county_names_all: "Kosciusko",
    county_fips_all: 18085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46510,
    lat: 41.12068,
    lng: -85.874,
    city: "Claypool",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3515,
    density: 20.1,
    county_fips: 18085,
    county_name: "Kosciusko",
    county_weights: {
      18085: 100,
    },
    county_names_all: "Kosciusko",
    county_fips_all: 18085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46511,
    lat: 41.22182,
    lng: -86.42889,
    city: "Culver",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4157,
    density: 24.1,
    county_fips: 18099,
    county_name: "Marshall",
    county_weights: {
      18049: 11.46,
      18099: 66.28,
      18131: 0.52,
      18149: 21.74,
    },
    county_names_all: "Marshall|Starke|Fulton|Pulaski",
    county_fips_all: "18099|18149|18049|18131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46513,
    lat: 41.3629,
    lng: -86.44816,
    city: "Donaldson",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18099,
    county_name: "Marshall",
    county_weights: {
      18099: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 18099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46514,
    lat: 41.72328,
    lng: -85.97547,
    city: "Elkhart",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41073,
    density: 409.9,
    county_fips: 18039,
    county_name: "Elkhart",
    county_weights: {
      18039: 100,
    },
    county_names_all: "Elkhart",
    county_fips_all: 18039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46516,
    lat: 41.6756,
    lng: -85.94584,
    city: "Elkhart",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32078,
    density: 707.6,
    county_fips: 18039,
    county_name: "Elkhart",
    county_weights: {
      18039: 100,
    },
    county_names_all: "Elkhart",
    county_fips_all: 18039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46517,
    lat: 41.62429,
    lng: -85.99675,
    city: "Elkhart",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26526,
    density: 277.4,
    county_fips: 18039,
    county_name: "Elkhart",
    county_weights: {
      18039: 100,
    },
    county_names_all: "Elkhart",
    county_fips_all: 18039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46524,
    lat: 41.2979,
    lng: -86.02143,
    city: "Etna Green",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2492,
    density: 27.7,
    county_fips: 18085,
    county_name: "Kosciusko",
    county_weights: {
      18085: 98.58,
      18099: 1.42,
    },
    county_names_all: "Kosciusko|Marshall",
    county_fips_all: "18085|18099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46526,
    lat: 41.55307,
    lng: -85.88448,
    city: "Goshen",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32970,
    density: 189.8,
    county_fips: 18039,
    county_name: "Elkhart",
    county_weights: {
      18039: 100,
    },
    county_names_all: "Elkhart",
    county_fips_all: 18039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46528,
    lat: 41.60698,
    lng: -85.786,
    city: "Goshen",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26456,
    density: 140.9,
    county_fips: 18039,
    county_name: "Elkhart",
    county_weights: {
      18039: 100,
    },
    county_names_all: "Elkhart",
    county_fips_all: 18039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46530,
    lat: 41.74031,
    lng: -86.12749,
    city: "Granger",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31539,
    density: 500.8,
    county_fips: 18141,
    county_name: "St. Joseph",
    county_weights: {
      18039: 11.42,
      18141: 88.58,
    },
    county_names_all: "St. Joseph|Elkhart",
    county_fips_all: "18141|18039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 46531,
    lat: 41.35686,
    lng: -86.51558,
    city: "Grovertown",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1755,
    density: 32,
    county_fips: 18149,
    county_name: "Starke",
    county_weights: {
      18099: 1.08,
      18149: 98.92,
    },
    county_names_all: "Starke|Marshall",
    county_fips_all: "18149|18099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Knox",
  },
  {
    zip: 46532,
    lat: 41.41762,
    lng: -86.62119,
    city: "Hamlet",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1591,
    density: 11.9,
    county_fips: 18149,
    county_name: "Starke",
    county_weights: {
      18091: 41.25,
      18149: 58.75,
    },
    county_names_all: "Starke|LaPorte",
    county_fips_all: "18149|18091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Knox",
  },
  {
    zip: 46534,
    lat: 41.28561,
    lng: -86.61878,
    city: "Knox",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11233,
    density: 36.2,
    county_fips: 18149,
    county_name: "Starke",
    county_weights: {
      18149: 100,
    },
    county_names_all: "Starke",
    county_fips_all: 18149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Knox",
  },
  {
    zip: 46536,
    lat: 41.51913,
    lng: -86.2867,
    city: "Lakeville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2892,
    density: 38.2,
    county_fips: 18141,
    county_name: "St. Joseph",
    county_weights: {
      18099: 8.52,
      18141: 91.48,
    },
    county_names_all: "St. Joseph|Marshall",
    county_fips_all: "18141|18099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46537,
    lat: 41.45724,
    lng: -86.30669,
    city: "Lapaz",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 446,
    density: 415.5,
    county_fips: 18099,
    county_name: "Marshall",
    county_weights: {
      18099: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 18099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46538,
    lat: 41.32829,
    lng: -85.82703,
    city: "Leesburg",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4385,
    density: 52.9,
    county_fips: 18085,
    county_name: "Kosciusko",
    county_weights: {
      18085: 100,
    },
    county_names_all: "Kosciusko",
    county_fips_all: 18085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46539,
    lat: 41.16579,
    lng: -86.02545,
    city: "Mentone",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2467,
    density: 27.3,
    county_fips: 18085,
    county_name: "Kosciusko",
    county_weights: {
      18049: 8.2,
      18085: 86.1,
      18099: 5.7,
    },
    county_names_all: "Kosciusko|Fulton|Marshall",
    county_fips_all: "18085|18049|18099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46540,
    lat: 41.67571,
    lng: -85.69768,
    city: "Middlebury",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12477,
    density: 81.1,
    county_fips: 18039,
    county_name: "Elkhart",
    county_weights: {
      18039: 85.1,
      18087: 14.9,
    },
    county_names_all: "Elkhart|LaGrange",
    county_fips_all: "18039|18087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46542,
    lat: 41.39303,
    lng: -85.87448,
    city: "Milford",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4304,
    density: 32.8,
    county_fips: 18085,
    county_name: "Kosciusko",
    county_weights: {
      18039: 3.67,
      18085: 96.33,
    },
    county_names_all: "Kosciusko|Elkhart",
    county_fips_all: "18085|18039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46543,
    lat: 41.53341,
    lng: -85.67119,
    city: "Millersburg",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3876,
    density: 49.3,
    county_fips: 18039,
    county_name: "Elkhart",
    county_weights: {
      18039: 64.48,
      18087: 33.87,
      18113: 1.65,
    },
    county_names_all: "Elkhart|LaGrange|Noble",
    county_fips_all: "18039|18087|18113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46544,
    lat: 41.61778,
    lng: -86.13715,
    city: "Mishawaka",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31178,
    density: 302.5,
    county_fips: 18141,
    county_name: "St. Joseph",
    county_weights: {
      18141: 100,
    },
    county_names_all: "St. Joseph",
    county_fips_all: 18141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46545,
    lat: 41.69376,
    lng: -86.14602,
    city: "Mishawaka",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25892,
    density: 545.7,
    county_fips: 18141,
    county_name: "St. Joseph",
    county_weights: {
      18141: 100,
    },
    county_names_all: "St. Joseph",
    county_fips_all: 18141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46550,
    lat: 41.44701,
    lng: -86.00028,
    city: "Nappanee",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12451,
    density: 67.1,
    county_fips: 18039,
    county_name: "Elkhart",
    county_weights: {
      18039: 53.66,
      18085: 34.97,
      18099: 6.47,
      18141: 4.9,
    },
    county_names_all: "Elkhart|Kosciusko|Marshall|St. Joseph",
    county_fips_all: "18039|18085|18099|18141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46552,
    lat: 41.70731,
    lng: -86.485,
    city: "New Carlisle",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6724,
    density: 40.7,
    county_fips: 18141,
    county_name: "St. Joseph",
    county_weights: {
      18091: 24.81,
      18141: 75.19,
    },
    county_names_all: "St. Joseph|LaPorte",
    county_fips_all: "18141|18091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46553,
    lat: 41.48004,
    lng: -85.85095,
    city: "New Paris",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3307,
    density: 40.7,
    county_fips: 18039,
    county_name: "Elkhart",
    county_weights: {
      18039: 100,
    },
    county_names_all: "Elkhart",
    county_fips_all: 18039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46554,
    lat: 41.56252,
    lng: -86.41947,
    city: "North Liberty",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4642,
    density: 26.4,
    county_fips: 18141,
    county_name: "St. Joseph",
    county_weights: {
      18091: 4.98,
      18141: 95.02,
    },
    county_names_all: "St. Joseph|LaPorte",
    county_fips_all: "18141|18091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46555,
    lat: 41.32858,
    lng: -85.68833,
    city: "North Webster",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2335,
    density: 89.3,
    county_fips: 18085,
    county_name: "Kosciusko",
    county_weights: {
      18085: 100,
    },
    county_names_all: "Kosciusko",
    county_fips_all: 18085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46556,
    lat: 41.70198,
    lng: -86.24513,
    city: "Notre Dame",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7305,
    density: 1712.7,
    county_fips: 18141,
    county_name: "St. Joseph",
    county_weights: {
      18141: 100,
    },
    county_names_all: "St. Joseph",
    county_fips_all: 18141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46561,
    lat: 41.66683,
    lng: -86.07599,
    city: "Osceola",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13277,
    density: 377.9,
    county_fips: 18141,
    county_name: "St. Joseph",
    county_weights: {
      18039: 11.46,
      18141: 88.54,
    },
    county_names_all: "St. Joseph|Elkhart",
    county_fips_all: "18141|18039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46562,
    lat: 41.20947,
    lng: -85.69757,
    city: "Pierceton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4637,
    density: 29.7,
    county_fips: 18085,
    county_name: "Kosciusko",
    county_weights: {
      18085: 83.78,
      18113: 3.76,
      18183: 12.46,
    },
    county_names_all: "Kosciusko|Whitley|Noble",
    county_fips_all: "18085|18183|18113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46563,
    lat: 41.35541,
    lng: -86.32612,
    city: "Plymouth",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23905,
    density: 60.3,
    county_fips: 18099,
    county_name: "Marshall",
    county_weights: {
      18099: 98.64,
      18141: 0.13,
      18149: 1.23,
    },
    county_names_all: "Marshall|Starke|St. Joseph",
    county_fips_all: "18099|18149|18141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46565,
    lat: 41.69285,
    lng: -85.5831,
    city: "Shipshewana",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8331,
    density: 50.9,
    county_fips: 18087,
    county_name: "LaGrange",
    county_weights: {
      18039: 0.58,
      18087: 99.42,
    },
    county_names_all: "LaGrange|Elkhart",
    county_fips_all: "18087|18039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46567,
    lat: 41.41473,
    lng: -85.73044,
    city: "Syracuse",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9360,
    density: 63.1,
    county_fips: 18085,
    county_name: "Kosciusko",
    county_weights: {
      18039: 34.36,
      18085: 65.64,
    },
    county_names_all: "Kosciusko|Elkhart",
    county_fips_all: "18085|18039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46570,
    lat: 41.20766,
    lng: -86.1207,
    city: "Tippecanoe",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1118,
    density: 21.6,
    county_fips: 18099,
    county_name: "Marshall",
    county_weights: {
      18049: 2.28,
      18099: 97.72,
    },
    county_names_all: "Marshall|Fulton",
    county_fips_all: "18099|18049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46571,
    lat: 41.56795,
    lng: -85.54667,
    city: "Topeka",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5751,
    density: 49.3,
    county_fips: 18087,
    county_name: "LaGrange",
    county_weights: {
      18087: 95.16,
      18113: 4.84,
    },
    county_names_all: "LaGrange|Noble",
    county_fips_all: "18087|18113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46572,
    lat: 41.40804,
    lng: -86.393,
    city: "Tyner",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18099,
    county_name: "Marshall",
    county_weights: {
      18099: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 18099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46573,
    lat: 41.53941,
    lng: -86.06054,
    city: "Wakarusa",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3827,
    density: 42.9,
    county_fips: 18039,
    county_name: "Elkhart",
    county_weights: {
      18039: 51.08,
      18141: 48.92,
    },
    county_names_all: "Elkhart|St. Joseph",
    county_fips_all: "18039|18141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46574,
    lat: 41.47327,
    lng: -86.48829,
    city: "Walkerton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9024,
    density: 35.7,
    county_fips: 18091,
    county_name: "LaPorte",
    county_weights: {
      18091: 32.85,
      18099: 24.78,
      18141: 29.38,
      18149: 13,
    },
    county_names_all: "LaPorte|St. Joseph|Marshall|Starke",
    county_fips_all: "18091|18141|18099|18149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46580,
    lat: 41.20884,
    lng: -85.87212,
    city: "Warsaw",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21999,
    density: 119.4,
    county_fips: 18085,
    county_name: "Kosciusko",
    county_weights: {
      18085: 100,
    },
    county_names_all: "Kosciusko",
    county_fips_all: 18085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46582,
    lat: 41.28323,
    lng: -85.85235,
    city: "Warsaw",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13759,
    density: 92.2,
    county_fips: 18085,
    county_name: "Kosciusko",
    county_weights: {
      18085: 100,
    },
    county_names_all: "Kosciusko",
    county_fips_all: 18085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46590,
    lat: 41.21612,
    lng: -85.80862,
    city: "Winona Lake",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4902,
    density: 679.8,
    county_fips: 18085,
    county_name: "Kosciusko",
    county_weights: {
      18085: 100,
    },
    county_names_all: "Kosciusko",
    county_fips_all: 18085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46595,
    lat: 41.52633,
    lng: -86.16367,
    city: "Wyatt",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 106,
    density: 270.9,
    county_fips: 18141,
    county_name: "St. Joseph",
    county_weights: {
      18141: 100,
    },
    county_names_all: "St. Joseph",
    county_fips_all: 18141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46601,
    lat: 41.67065,
    lng: -86.252,
    city: "South Bend",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5347,
    density: 1049.1,
    county_fips: 18141,
    county_name: "St. Joseph",
    county_weights: {
      18141: 100,
    },
    county_names_all: "St. Joseph",
    county_fips_all: 18141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46613,
    lat: 41.65389,
    lng: -86.264,
    city: "South Bend",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11595,
    density: 1392.3,
    county_fips: 18141,
    county_name: "St. Joseph",
    county_weights: {
      18141: 100,
    },
    county_names_all: "St. Joseph",
    county_fips_all: 18141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46614,
    lat: 41.60359,
    lng: -86.28064,
    city: "South Bend",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30505,
    density: 221.2,
    county_fips: 18141,
    county_name: "St. Joseph",
    county_weights: {
      18141: 100,
    },
    county_names_all: "St. Joseph",
    county_fips_all: 18141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46615,
    lat: 41.67494,
    lng: -86.21151,
    city: "South Bend",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14259,
    density: 1667.5,
    county_fips: 18141,
    county_name: "St. Joseph",
    county_weights: {
      18141: 100,
    },
    county_names_all: "St. Joseph",
    county_fips_all: 18141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46616,
    lat: 41.69693,
    lng: -86.26671,
    city: "South Bend",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5439,
    density: 1462.7,
    county_fips: 18141,
    county_name: "St. Joseph",
    county_weights: {
      18141: 100,
    },
    county_names_all: "St. Joseph",
    county_fips_all: 18141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46617,
    lat: 41.68435,
    lng: -86.23513,
    city: "South Bend",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10171,
    density: 1499.5,
    county_fips: 18141,
    county_name: "St. Joseph",
    county_weights: {
      18141: 100,
    },
    county_names_all: "St. Joseph",
    county_fips_all: 18141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46619,
    lat: 41.65997,
    lng: -86.3532,
    city: "South Bend",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21048,
    density: 345.6,
    county_fips: 18141,
    county_name: "St. Joseph",
    county_weights: {
      18141: 100,
    },
    county_names_all: "St. Joseph",
    county_fips_all: 18141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46624,
    lat: 41.70252,
    lng: -86.25164,
    city: "South Bend",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18141,
    county_name: "St. Joseph",
    county_weights: {
      18141: 100,
    },
    county_names_all: "St. Joseph",
    county_fips_all: 18141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46628,
    lat: 41.72103,
    lng: -86.33465,
    city: "South Bend",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26532,
    density: 299.7,
    county_fips: 18141,
    county_name: "St. Joseph",
    county_weights: {
      18141: 100,
    },
    county_names_all: "St. Joseph",
    county_fips_all: 18141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46635,
    lat: 41.71518,
    lng: -86.20832,
    city: "South Bend",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6544,
    density: 814.6,
    county_fips: 18141,
    county_name: "St. Joseph",
    county_weights: {
      18141: 100,
    },
    county_names_all: "St. Joseph",
    county_fips_all: 18141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46637,
    lat: 41.73358,
    lng: -86.24299,
    city: "South Bend",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16668,
    density: 644,
    county_fips: 18141,
    county_name: "St. Joseph",
    county_weights: {
      18141: 100,
    },
    county_names_all: "St. Joseph",
    county_fips_all: 18141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46701,
    lat: 41.35846,
    lng: -85.43034,
    city: "Albion",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8588,
    density: 34.3,
    county_fips: 18113,
    county_name: "Noble",
    county_weights: {
      18113: 100,
    },
    county_names_all: "Noble",
    county_fips_all: 18113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46702,
    lat: 40.82681,
    lng: -85.61732,
    city: "Andrews",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2242,
    density: 20.6,
    county_fips: 18069,
    county_name: "Huntington",
    county_weights: {
      18069: 81.9,
      18169: 18.1,
    },
    county_names_all: "Huntington|Wabash",
    county_fips_all: "18069|18169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46703,
    lat: 41.65305,
    lng: -85.00976,
    city: "Angola",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18094,
    density: 57.7,
    county_fips: 18151,
    county_name: "Steuben",
    county_weights: {
      18151: 100,
    },
    county_names_all: "Steuben",
    county_fips_all: 18151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46704,
    lat: 41.10371,
    lng: -85.29242,
    city: "Arcola",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33,
    density: 190,
    county_fips: 18003,
    county_name: "Allen",
    county_weights: {
      18003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 18003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46705,
    lat: 41.51816,
    lng: -85.06029,
    city: "Ashley",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2039,
    density: 35.4,
    county_fips: 18033,
    county_name: "DeKalb",
    county_weights: {
      18033: 69.55,
      18151: 30.45,
    },
    county_names_all: "DeKalb|Steuben",
    county_fips_all: "18033|18151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46706,
    lat: 41.34242,
    lng: -85.03922,
    city: "Auburn",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19068,
    density: 83.8,
    county_fips: 18033,
    county_name: "DeKalb",
    county_weights: {
      18003: 3.65,
      18033: 96.35,
    },
    county_names_all: "DeKalb|Allen",
    county_fips_all: "18033|18003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46710,
    lat: 41.35167,
    lng: -85.25168,
    city: "Avilla",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4726,
    density: 41,
    county_fips: 18113,
    county_name: "Noble",
    county_weights: {
      18033: 13.21,
      18113: 86.79,
    },
    county_names_all: "Noble|DeKalb",
    county_fips_all: "18113|18033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46711,
    lat: 40.6635,
    lng: -84.92398,
    city: "Berne",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8228,
    density: 55.1,
    county_fips: 18001,
    county_name: "Adams",
    county_weights: {
      18001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 18001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46714,
    lat: 40.71774,
    lng: -85.17319,
    city: "Bluffton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14652,
    density: 42.5,
    county_fips: 18179,
    county_name: "Wells",
    county_weights: {
      18001: 7.84,
      18179: 92.16,
    },
    county_names_all: "Wells|Adams",
    county_fips_all: "18179|18001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46721,
    lat: 41.4237,
    lng: -84.87425,
    city: "Butler",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5550,
    density: 27.3,
    county_fips: 18033,
    county_name: "DeKalb",
    county_weights: {
      18033: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 18033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46723,
    lat: 41.23828,
    lng: -85.32441,
    city: "Churubusco",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8123,
    density: 53.8,
    county_fips: 18183,
    county_name: "Whitley",
    county_weights: {
      18003: 36.8,
      18113: 22.83,
      18183: 40.36,
    },
    county_names_all: "Whitley|Allen|Noble",
    county_fips_all: "18183|18003|18113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46725,
    lat: 41.1518,
    lng: -85.47655,
    city: "Columbia City",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23098,
    density: 44,
    county_fips: 18183,
    county_name: "Whitley",
    county_weights: {
      18113: 2.21,
      18183: 97.79,
    },
    county_names_all: "Whitley|Noble",
    county_fips_all: "18183|18113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46730,
    lat: 41.454,
    lng: -85.15504,
    city: "Corunna",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 788,
    density: 10.9,
    county_fips: 18033,
    county_name: "DeKalb",
    county_weights: {
      18033: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 18033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46731,
    lat: 40.79751,
    lng: -85.10267,
    city: "Craigville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 684,
    density: 16.8,
    county_fips: 18179,
    county_name: "Wells",
    county_weights: {
      18179: 100,
    },
    county_names_all: "Wells",
    county_fips_all: 18179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46732,
    lat: 41.37697,
    lng: -85.62169,
    city: "Cromwell",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2739,
    density: 45.1,
    county_fips: 18113,
    county_name: "Noble",
    county_weights: {
      18085: 7.13,
      18113: 92.87,
    },
    county_names_all: "Noble|Kosciusko",
    county_fips_all: "18113|18085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46733,
    lat: 40.83033,
    lng: -84.94023,
    city: "Decatur",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19694,
    density: 44.1,
    county_fips: 18001,
    county_name: "Adams",
    county_weights: {
      18001: 97.02,
      18003: 2.98,
    },
    county_names_all: "Adams|Allen",
    county_fips_all: "18001|18003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46737,
    lat: 41.72209,
    lng: -84.92233,
    city: "Fremont",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7442,
    density: 45.1,
    county_fips: 18151,
    county_name: "Steuben",
    county_weights: {
      18151: 100,
    },
    county_names_all: "Steuben",
    county_fips_all: 18151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 46738,
    lat: 41.32189,
    lng: -85.13731,
    city: "Garrett",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8362,
    density: 124,
    county_fips: 18033,
    county_name: "DeKalb",
    county_weights: {
      18033: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 18033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46740,
    lat: 40.60298,
    lng: -84.9638,
    city: "Geneva",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4374,
    density: 27.1,
    county_fips: 18001,
    county_name: "Adams",
    county_weights: {
      18001: 91.82,
      18179: 8.18,
    },
    county_names_all: "Adams|Wells",
    county_fips_all: "18001|18179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46741,
    lat: 41.21161,
    lng: -84.95176,
    city: "Grabill",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5030,
    density: 77.4,
    county_fips: 18003,
    county_name: "Allen",
    county_weights: {
      18003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 18003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46742,
    lat: 41.54919,
    lng: -84.87892,
    city: "Hamilton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3244,
    density: 24.1,
    county_fips: 18151,
    county_name: "Steuben",
    county_weights: {
      18033: 30.5,
      18151: 69.5,
    },
    county_names_all: "Steuben|DeKalb",
    county_fips_all: "18151|18033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46743,
    lat: 41.21511,
    lng: -84.85321,
    city: "Harlan",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2140,
    density: 35.4,
    county_fips: 18003,
    county_name: "Allen",
    county_weights: {
      18003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 18003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46745,
    lat: 40.95194,
    lng: -85.00887,
    city: "Hoagland",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2105,
    density: 43.7,
    county_fips: 18003,
    county_name: "Allen",
    county_weights: {
      18003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 18003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46746,
    lat: 41.72257,
    lng: -85.34914,
    city: "Howe",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4598,
    density: 24.8,
    county_fips: 18087,
    county_name: "LaGrange",
    county_weights: {
      18087: 100,
    },
    county_names_all: "LaGrange",
    county_fips_all: 18087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 46747,
    lat: 41.56042,
    lng: -85.15349,
    city: "Hudson",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2183,
    density: 22.8,
    county_fips: 18151,
    county_name: "Steuben",
    county_weights: {
      18033: 13.5,
      18087: 12.25,
      18151: 74.25,
    },
    county_names_all: "Steuben|DeKalb|LaGrange",
    county_fips_all: "18151|18033|18087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46748,
    lat: 41.24829,
    lng: -85.16727,
    city: "Huntertown",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4633,
    density: 95.8,
    county_fips: 18003,
    county_name: "Allen",
    county_weights: {
      18003: 92.84,
      18033: 2.75,
      18113: 4.41,
    },
    county_names_all: "Allen|Noble|DeKalb",
    county_fips_all: "18003|18113|18033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46750,
    lat: 40.87677,
    lng: -85.49674,
    city: "Huntington",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26618,
    density: 51,
    county_fips: 18069,
    county_name: "Huntington",
    county_weights: {
      18069: 99.59,
      18183: 0.41,
    },
    county_names_all: "Huntington|Whitley",
    county_fips_all: "18069|18183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46755,
    lat: 41.45119,
    lng: -85.27209,
    city: "Kendallville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14734,
    density: 75.9,
    county_fips: 18113,
    county_name: "Noble",
    county_weights: {
      18033: 1.58,
      18113: 98.42,
    },
    county_names_all: "Noble|DeKalb",
    county_fips_all: "18113|18033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46759,
    lat: 40.59855,
    lng: -85.18299,
    city: "Keystone",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 405,
    density: 5.6,
    county_fips: 18179,
    county_name: "Wells",
    county_weights: {
      18179: 100,
    },
    county_names_all: "Wells",
    county_fips_all: 18179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46760,
    lat: 41.34441,
    lng: -85.55654,
    city: "Kimmell",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1291,
    density: 21.2,
    county_fips: 18113,
    county_name: "Noble",
    county_weights: {
      18113: 100,
    },
    county_names_all: "Noble",
    county_fips_all: 18113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46761,
    lat: 41.63576,
    lng: -85.37127,
    city: "Lagrange",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12587,
    density: 39.5,
    county_fips: 18087,
    county_name: "LaGrange",
    county_weights: {
      18087: 99,
      18151: 1,
    },
    county_names_all: "LaGrange|Steuben",
    county_fips_all: "18087|18151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46763,
    lat: 41.29418,
    lng: -85.2415,
    city: "Laotto",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1422,
    density: 22.1,
    county_fips: 18113,
    county_name: "Noble",
    county_weights: {
      18033: 18.7,
      18113: 81.3,
    },
    county_names_all: "Noble|DeKalb",
    county_fips_all: "18113|18033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46764,
    lat: 41.2176,
    lng: -85.62376,
    city: "Larwill",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1523,
    density: 18.3,
    county_fips: 18183,
    county_name: "Whitley",
    county_weights: {
      18113: 10.45,
      18183: 89.55,
    },
    county_names_all: "Whitley|Noble",
    county_fips_all: "18183|18113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46765,
    lat: 41.23361,
    lng: -85.04047,
    city: "Leo",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5547,
    density: 169.3,
    county_fips: 18003,
    county_name: "Allen",
    county_weights: {
      18003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 18003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46766,
    lat: 40.70984,
    lng: -85.29424,
    city: "Liberty Center",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 883,
    density: 23.7,
    county_fips: 18179,
    county_name: "Wells",
    county_weights: {
      18179: 100,
    },
    county_names_all: "Wells",
    county_fips_all: 18179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46767,
    lat: 41.46487,
    lng: -85.5764,
    city: "Ligonier",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8474,
    density: 48.2,
    county_fips: 18113,
    county_name: "Noble",
    county_weights: {
      18039: 5.32,
      18087: 2.05,
      18113: 92.63,
    },
    county_names_all: "Noble|Elkhart|LaGrange",
    county_fips_all: "18113|18039|18087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46770,
    lat: 40.8298,
    lng: -85.31873,
    city: "Markle",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3062,
    density: 22.5,
    county_fips: 18179,
    county_name: "Wells",
    county_weights: {
      18069: 38.65,
      18179: 61.35,
    },
    county_names_all: "Wells|Huntington",
    county_fips_all: "18179|18069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46771,
    lat: 41.69272,
    lng: -85.29639,
    city: "Mongo",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59,
    density: 19.7,
    county_fips: 18087,
    county_name: "LaGrange",
    county_weights: {
      18087: 100,
    },
    county_names_all: "LaGrange",
    county_fips_all: 18087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46772,
    lat: 40.7221,
    lng: -84.91153,
    city: "Monroe",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2913,
    density: 30.2,
    county_fips: 18001,
    county_name: "Adams",
    county_weights: {
      18001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 18001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46773,
    lat: 40.98401,
    lng: -84.8759,
    city: "Monroeville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3508,
    density: 17.1,
    county_fips: 18003,
    county_name: "Allen",
    county_weights: {
      18001: 6.02,
      18003: 93.98,
    },
    county_names_all: "Allen|Adams",
    county_fips_all: "18003|18001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46774,
    lat: 41.09103,
    lng: -84.96955,
    city: "New Haven",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16653,
    density: 122,
    county_fips: 18003,
    county_name: "Allen",
    county_weights: {
      18003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 18003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46776,
    lat: 41.72793,
    lng: -85.16878,
    city: "Orland",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1878,
    density: 29,
    county_fips: 18151,
    county_name: "Steuben",
    county_weights: {
      18087: 20.63,
      18151: 79.37,
    },
    county_names_all: "Steuben|LaGrange",
    county_fips_all: "18151|18087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 46777,
    lat: 40.87248,
    lng: -85.15236,
    city: "Ossian",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6170,
    density: 41.2,
    county_fips: 18179,
    county_name: "Wells",
    county_weights: {
      18001: 2.75,
      18003: 4.95,
      18179: 92.3,
    },
    county_names_all: "Wells|Allen|Adams",
    county_fips_all: "18179|18003|18001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46778,
    lat: 40.61055,
    lng: -85.15491,
    city: "Petroleum",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18179,
    county_name: "Wells",
    county_weights: {
      18179: 100,
    },
    county_names_all: "Wells",
    county_fips_all: 18179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46779,
    lat: 41.5725,
    lng: -85.03094,
    city: "Pleasant Lake",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2363,
    density: 27.9,
    county_fips: 18151,
    county_name: "Steuben",
    county_weights: {
      18151: 100,
    },
    county_names_all: "Steuben",
    county_fips_all: 18151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46781,
    lat: 40.63659,
    lng: -85.27339,
    city: "Poneto",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 674,
    density: 10.1,
    county_fips: 18179,
    county_name: "Wells",
    county_weights: {
      18179: 100,
    },
    county_names_all: "Wells",
    county_fips_all: 18179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46783,
    lat: 40.97399,
    lng: -85.35578,
    city: "Roanoke",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6669,
    density: 42.3,
    county_fips: 18069,
    county_name: "Huntington",
    county_weights: {
      18003: 32.77,
      18069: 45.97,
      18179: 1.86,
      18183: 19.41,
    },
    county_names_all: "Huntington|Allen|Whitley|Wells",
    county_fips_all: "18069|18003|18183|18179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46784,
    lat: 41.49797,
    lng: -85.38797,
    city: "Rome City",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2348,
    density: 67.8,
    county_fips: 18113,
    county_name: "Noble",
    county_weights: {
      18113: 100,
    },
    county_names_all: "Noble",
    county_fips_all: 18113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46785,
    lat: 41.31974,
    lng: -84.88506,
    city: "Saint Joe",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1309,
    density: 19.7,
    county_fips: 18033,
    county_name: "DeKalb",
    county_weights: {
      18033: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 18033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46786,
    lat: 41.53156,
    lng: -85.27269,
    city: "South Milford",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29,
    density: 414.8,
    county_fips: 18087,
    county_name: "LaGrange",
    county_weights: {
      18087: 100,
    },
    county_names_all: "LaGrange",
    county_fips_all: 18087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46787,
    lat: 41.06598,
    lng: -85.62085,
    city: "South Whitley",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4132,
    density: 24.3,
    county_fips: 18183,
    county_name: "Whitley",
    county_weights: {
      18069: 1.36,
      18085: 8.42,
      18183: 90.22,
    },
    county_names_all: "Whitley|Kosciusko|Huntington",
    county_fips_all: "18183|18085|18069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46788,
    lat: 41.27005,
    lng: -84.90876,
    city: "Spencerville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3574,
    density: 39.9,
    county_fips: 18033,
    county_name: "DeKalb",
    county_weights: {
      18003: 46.83,
      18033: 53.17,
    },
    county_names_all: "DeKalb|Allen",
    county_fips_all: "18033|18003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46789,
    lat: 41.58274,
    lng: -85.19742,
    city: "Stroh",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18087,
    county_name: "LaGrange",
    county_weights: {
      18087: 100,
    },
    county_names_all: "LaGrange",
    county_fips_all: 18087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46791,
    lat: 40.83699,
    lng: -85.24325,
    city: "Uniondale",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1080,
    density: 25.8,
    county_fips: 18179,
    county_name: "Wells",
    county_weights: {
      18179: 100,
    },
    county_names_all: "Wells",
    county_fips_all: 18179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46792,
    lat: 40.68472,
    lng: -85.43798,
    city: "Warren",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3601,
    density: 14.1,
    county_fips: 18069,
    county_name: "Huntington",
    county_weights: {
      18069: 76.12,
      18179: 23.88,
    },
    county_names_all: "Huntington|Wells",
    county_fips_all: "18069|18179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46793,
    lat: 41.46106,
    lng: -85.01928,
    city: "Waterloo",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4908,
    density: 35.7,
    county_fips: 18033,
    county_name: "DeKalb",
    county_weights: {
      18033: 99.14,
      18151: 0.86,
    },
    county_names_all: "DeKalb|Steuben",
    county_fips_all: "18033|18151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46794,
    lat: 41.46654,
    lng: -85.45946,
    city: "Wawaka",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1665,
    density: 25.4,
    county_fips: 18113,
    county_name: "Noble",
    county_weights: {
      18113: 100,
    },
    county_names_all: "Noble",
    county_fips_all: 18113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46795,
    lat: 41.55116,
    lng: -85.33941,
    city: "Wolcottville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6460,
    density: 43.7,
    county_fips: 18087,
    county_name: "LaGrange",
    county_weights: {
      18087: 86.5,
      18113: 13.5,
    },
    county_names_all: "LaGrange|Noble",
    county_fips_all: "18087|18113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46796,
    lat: 41.3367,
    lng: -85.49583,
    city: "Wolflake",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18113,
    county_name: "Noble",
    county_weights: {
      18113: 100,
    },
    county_names_all: "Noble",
    county_fips_all: 18113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46797,
    lat: 41.12749,
    lng: -84.86046,
    city: "Woodburn",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4035,
    density: 31.3,
    county_fips: 18003,
    county_name: "Allen",
    county_weights: {
      18003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 18003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46798,
    lat: 40.94256,
    lng: -85.22113,
    city: "Yoder",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1496,
    density: 31.8,
    county_fips: 18003,
    county_name: "Allen",
    county_weights: {
      18003: 96.63,
      18179: 3.37,
    },
    county_names_all: "Allen|Wells",
    county_fips_all: "18003|18179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46799,
    lat: 40.91592,
    lng: -85.27923,
    city: "Zanesville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 161,
    density: 97.8,
    county_fips: 18179,
    county_name: "Wells",
    county_weights: {
      18003: 38.55,
      18179: 61.45,
    },
    county_names_all: "Wells|Allen",
    county_fips_all: "18179|18003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46802,
    lat: 41.06787,
    lng: -85.16299,
    city: "Fort Wayne",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10713,
    density: 984.7,
    county_fips: 18003,
    county_name: "Allen",
    county_weights: {
      18003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 18003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46803,
    lat: 41.06972,
    lng: -85.08532,
    city: "Fort Wayne",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10200,
    density: 526.8,
    county_fips: 18003,
    county_name: "Allen",
    county_weights: {
      18003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 18003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46804,
    lat: 41.05421,
    lng: -85.23913,
    city: "Fort Wayne",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28740,
    density: 626.8,
    county_fips: 18003,
    county_name: "Allen",
    county_weights: {
      18003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 18003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46805,
    lat: 41.09918,
    lng: -85.11762,
    city: "Fort Wayne",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22479,
    density: 1353.8,
    county_fips: 18003,
    county_name: "Allen",
    county_weights: {
      18003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 18003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46806,
    lat: 41.04649,
    lng: -85.09224,
    city: "Fort Wayne",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24821,
    density: 1161,
    county_fips: 18003,
    county_name: "Allen",
    county_weights: {
      18003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 18003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46807,
    lat: 41.04489,
    lng: -85.14763,
    city: "Fort Wayne",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16681,
    density: 2000,
    county_fips: 18003,
    county_name: "Allen",
    county_weights: {
      18003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 18003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46808,
    lat: 41.09887,
    lng: -85.17619,
    city: "Fort Wayne",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19476,
    density: 709.7,
    county_fips: 18003,
    county_name: "Allen",
    county_weights: {
      18003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 18003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46809,
    lat: 41.00088,
    lng: -85.2102,
    city: "Fort Wayne",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9201,
    density: 143.6,
    county_fips: 18003,
    county_name: "Allen",
    county_weights: {
      18003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 18003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46814,
    lat: 41.04616,
    lng: -85.30805,
    city: "Fort Wayne",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12792,
    density: 259.2,
    county_fips: 18003,
    county_name: "Allen",
    county_weights: {
      18003: 88.07,
      18183: 11.93,
    },
    county_names_all: "Allen|Whitley",
    county_fips_all: "18003|18183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46815,
    lat: 41.1034,
    lng: -85.05913,
    city: "Fort Wayne",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29183,
    density: 1166.1,
    county_fips: 18003,
    county_name: "Allen",
    county_weights: {
      18003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 18003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46816,
    lat: 41.00396,
    lng: -85.04169,
    city: "Fort Wayne",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19530,
    density: 209.3,
    county_fips: 18003,
    county_name: "Allen",
    county_weights: {
      18003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 18003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46818,
    lat: 41.14698,
    lng: -85.25111,
    city: "Fort Wayne",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21416,
    density: 123.8,
    county_fips: 18003,
    county_name: "Allen",
    county_weights: {
      18003: 98.1,
      18183: 1.9,
    },
    county_names_all: "Allen|Whitley",
    county_fips_all: "18003|18183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46819,
    lat: 40.96409,
    lng: -85.13256,
    city: "Fort Wayne",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10013,
    density: 148.8,
    county_fips: 18003,
    county_name: "Allen",
    county_weights: {
      18003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 18003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46825,
    lat: 41.15397,
    lng: -85.12425,
    city: "Fort Wayne",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28848,
    density: 714.6,
    county_fips: 18003,
    county_name: "Allen",
    county_weights: {
      18003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 18003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46835,
    lat: 41.15086,
    lng: -85.04536,
    city: "Fort Wayne",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35612,
    density: 635.2,
    county_fips: 18003,
    county_name: "Allen",
    county_weights: {
      18003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 18003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46845,
    lat: 41.2051,
    lng: -85.10789,
    city: "Fort Wayne",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23588,
    density: 398.1,
    county_fips: 18003,
    county_name: "Allen",
    county_weights: {
      18003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 18003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46901,
    lat: 40.52487,
    lng: -86.15639,
    city: "Kokomo",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38459,
    density: 105.4,
    county_fips: 18067,
    county_name: "Howard",
    county_weights: {
      18017: 0.24,
      18067: 84.58,
      18103: 15.18,
    },
    county_names_all: "Howard|Miami|Cass",
    county_fips_all: "18067|18103|18017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46902,
    lat: 40.43743,
    lng: -86.09111,
    city: "Kokomo",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36012,
    density: 274.2,
    county_fips: 18067,
    county_name: "Howard",
    county_weights: {
      18067: 97.64,
      18159: 2.36,
    },
    county_names_all: "Howard|Tipton",
    county_fips_all: "18067|18159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46910,
    lat: 41.04537,
    lng: -86.04151,
    city: "Akron",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3131,
    density: 20.1,
    county_fips: 18049,
    county_name: "Fulton",
    county_weights: {
      18049: 69.36,
      18085: 25,
      18103: 5.64,
    },
    county_names_all: "Fulton|Kosciusko|Miami",
    county_fips_all: "18049|18085|18103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46911,
    lat: 40.62859,
    lng: -85.94673,
    city: "Amboy",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1551,
    density: 15.6,
    county_fips: 18103,
    county_name: "Miami",
    county_weights: {
      18103: 79.19,
      18169: 20.81,
    },
    county_names_all: "Miami|Wabash",
    county_fips_all: "18103|18169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46913,
    lat: 40.50364,
    lng: -86.49739,
    city: "Bringhurst",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1248,
    density: 14.7,
    county_fips: 18015,
    county_name: "Carroll",
    county_weights: {
      18015: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 18015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46914,
    lat: 40.63068,
    lng: -86.09515,
    city: "Bunker Hill",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2733,
    density: 36.3,
    county_fips: 18103,
    county_name: "Miami",
    county_weights: {
      18103: 100,
    },
    county_names_all: "Miami",
    county_fips_all: 18103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46915,
    lat: 40.47832,
    lng: -86.38636,
    city: "Burlington",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 814,
    density: 126.2,
    county_fips: 18015,
    county_name: "Carroll",
    county_weights: {
      18015: 99.87,
      18067: 0.13,
    },
    county_names_all: "Carroll|Howard",
    county_fips_all: "18015|18067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46917,
    lat: 40.62071,
    lng: -86.46893,
    city: "Camden",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1767,
    density: 12.9,
    county_fips: 18015,
    county_name: "Carroll",
    county_weights: {
      18015: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 18015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46919,
    lat: 40.58826,
    lng: -85.8706,
    city: "Converse",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2205,
    density: 19.9,
    county_fips: 18053,
    county_name: "Grant",
    county_weights: {
      18053: 49.6,
      18067: 13.96,
      18103: 36.43,
    },
    county_names_all: "Grant|Miami|Howard",
    county_fips_all: "18053|18103|18067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46920,
    lat: 40.46459,
    lng: -86.49502,
    city: "Cutler",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1097,
    density: 13.3,
    county_fips: 18015,
    county_name: "Carroll",
    county_weights: {
      18015: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 18015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46922,
    lat: 41.13993,
    lng: -86.42197,
    city: "Delong",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 18049,
    county_name: "Fulton",
    county_weights: {
      18049: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 18049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46923,
    lat: 40.606,
    lng: -86.64568,
    city: "Delphi",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7883,
    density: 22.6,
    county_fips: 18015,
    county_name: "Carroll",
    county_weights: {
      18015: 98.62,
      18157: 1.38,
    },
    county_names_all: "Carroll|Tippecanoe",
    county_fips_all: "18015|18157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46926,
    lat: 40.88283,
    lng: -86.04945,
    city: "Denver",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1289,
    density: 13.9,
    county_fips: 18103,
    county_name: "Miami",
    county_weights: {
      18017: 4.16,
      18103: 93.31,
      18169: 2.53,
    },
    county_names_all: "Miami|Cass|Wabash",
    county_fips_all: "18103|18017|18169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46928,
    lat: 40.40763,
    lng: -85.68618,
    city: "Fairmount",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4208,
    density: 22.6,
    county_fips: 18053,
    county_name: "Grant",
    county_weights: {
      18053: 98.11,
      18067: 0.26,
      18095: 1.63,
    },
    county_names_all: "Grant|Madison|Howard",
    county_fips_all: "18053|18095|18067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46929,
    lat: 40.54802,
    lng: -86.47411,
    city: "Flora",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3030,
    density: 24,
    county_fips: 18015,
    county_name: "Carroll",
    county_weights: {
      18015: 88.5,
      18067: 11.5,
    },
    county_names_all: "Carroll|Howard",
    county_fips_all: "18015|18067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46930,
    lat: 40.40946,
    lng: -85.57261,
    city: "Fowlerton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 117,
    density: 240.1,
    county_fips: 18053,
    county_name: "Grant",
    county_weights: {
      18053: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 18053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46931,
    lat: 40.94693,
    lng: -86.26456,
    city: "Fulton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 150,
    density: 320.9,
    county_fips: 18049,
    county_name: "Fulton",
    county_weights: {
      18049: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 18049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46932,
    lat: 40.59675,
    lng: -86.26243,
    city: "Galveston",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3200,
    density: 22.4,
    county_fips: 18017,
    county_name: "Cass",
    county_weights: {
      18015: 0.74,
      18017: 88.32,
      18067: 9.36,
      18103: 1.58,
    },
    county_names_all: "Cass|Howard|Miami|Carroll",
    county_fips_all: "18017|18067|18103|18015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46933,
    lat: 40.47887,
    lng: -85.58091,
    city: "Gas City",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5919,
    density: 206.9,
    county_fips: 18053,
    county_name: "Grant",
    county_weights: {
      18053: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 18053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46936,
    lat: 40.47942,
    lng: -85.93102,
    city: "Greentown",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5787,
    density: 34.3,
    county_fips: 18067,
    county_name: "Howard",
    county_weights: {
      18067: 100,
    },
    county_names_all: "Howard",
    county_fips_all: 18067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46937,
    lat: 40.41523,
    lng: -86.03693,
    city: "Hemlock",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18067,
    county_name: "Howard",
    county_weights: {
      18067: 100,
    },
    county_names_all: "Howard",
    county_fips_all: 18067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46938,
    lat: 40.4482,
    lng: -85.64892,
    city: "Jonesboro",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2716,
    density: 33.7,
    county_fips: 18053,
    county_name: "Grant",
    county_weights: {
      18053: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 18053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46939,
    lat: 40.99337,
    lng: -86.40359,
    city: "Kewanna",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1612,
    density: 6.5,
    county_fips: 18049,
    county_name: "Fulton",
    county_weights: {
      18049: 90.61,
      18131: 9.39,
    },
    county_names_all: "Fulton|Pulaski",
    county_fips_all: "18049|18131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46940,
    lat: 40.6882,
    lng: -85.69857,
    city: "La Fontaine",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3072,
    density: 20.1,
    county_fips: 18169,
    county_name: "Wabash",
    county_weights: {
      18053: 4.06,
      18069: 23.34,
      18169: 72.6,
    },
    county_names_all: "Wabash|Huntington|Grant",
    county_fips_all: "18169|18069|18053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46941,
    lat: 40.82833,
    lng: -85.69723,
    city: "Lagro",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1238,
    density: 18.4,
    county_fips: 18169,
    county_name: "Wabash",
    county_weights: {
      18169: 100,
    },
    county_names_all: "Wabash",
    county_fips_all: 18169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46943,
    lat: 40.9735,
    lng: -85.84038,
    city: "Laketon",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 230,
    density: 323.8,
    county_fips: 18169,
    county_name: "Wabash",
    county_weights: {
      18169: 100,
    },
    county_names_all: "Wabash",
    county_fips_all: 18169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46945,
    lat: 41.1211,
    lng: -86.38516,
    city: "Leiters Ford",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18049,
    county_name: "Fulton",
    county_weights: {
      18049: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 18049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46946,
    lat: 41.03932,
    lng: -85.73019,
    city: "Liberty Mills",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 78,
    density: 91,
    county_fips: 18169,
    county_name: "Wabash",
    county_weights: {
      18085: 0.87,
      18169: 99.13,
    },
    county_names_all: "Wabash|Kosciusko",
    county_fips_all: "18169|18085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46947,
    lat: 40.76044,
    lng: -86.37303,
    city: "Logansport",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28104,
    density: 57,
    county_fips: 18017,
    county_name: "Cass",
    county_weights: {
      18015: 7.88,
      18017: 92.12,
    },
    county_names_all: "Cass|Carroll",
    county_fips_all: "18017|18015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46950,
    lat: 40.88391,
    lng: -86.37162,
    city: "Lucerne",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 511,
    density: 6.7,
    county_fips: 18017,
    county_name: "Cass",
    county_weights: {
      18017: 94.27,
      18049: 5.73,
    },
    county_names_all: "Cass|Fulton",
    county_fips_all: "18017|18049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46951,
    lat: 40.94616,
    lng: -86.10528,
    city: "Macy",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2061,
    density: 11.9,
    county_fips: 18103,
    county_name: "Miami",
    county_weights: {
      18049: 17.13,
      18103: 82.87,
    },
    county_names_all: "Miami|Fulton",
    county_fips_all: "18103|18049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46952,
    lat: 40.59882,
    lng: -85.63249,
    city: "Marion",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18350,
    density: 67.2,
    county_fips: 18053,
    county_name: "Grant",
    county_weights: {
      18009: 2.7,
      18053: 89.57,
      18069: 3.09,
      18179: 4.64,
    },
    county_names_all: "Grant|Wells|Huntington|Blackford",
    county_fips_all: "18053|18179|18069|18009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46953,
    lat: 40.51928,
    lng: -85.643,
    city: "Marion",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23235,
    density: 104.8,
    county_fips: 18053,
    county_name: "Grant",
    county_weights: {
      18053: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 18053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46957,
    lat: 40.38866,
    lng: -85.49917,
    city: "Matthews",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 461,
    density: 415.5,
    county_fips: 18053,
    county_name: "Grant",
    county_weights: {
      18053: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 18053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46958,
    lat: 40.81817,
    lng: -86.12107,
    city: "Mexico",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 513,
    density: 153.2,
    county_fips: 18103,
    county_name: "Miami",
    county_weights: {
      18103: 100,
    },
    county_names_all: "Miami",
    county_fips_all: 18103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46959,
    lat: 40.61272,
    lng: -86.11245,
    city: "Miami",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 714,
    density: 672.4,
    county_fips: 18103,
    county_name: "Miami",
    county_weights: {
      18103: 100,
    },
    county_names_all: "Miami",
    county_fips_all: 18103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46960,
    lat: 41.15735,
    lng: -86.52397,
    city: "Monterey",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1400,
    density: 13.3,
    county_fips: 18131,
    county_name: "Pulaski",
    county_weights: {
      18049: 3.53,
      18131: 60.56,
      18149: 35.91,
    },
    county_names_all: "Pulaski|Starke|Fulton",
    county_fips_all: "18131|18149|18049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Winamac",
  },
  {
    zip: 46961,
    lat: 40.76573,
    lng: -86.18786,
    city: "New Waverly",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 133,
    density: 125.9,
    county_fips: 18017,
    county_name: "Cass",
    county_weights: {
      18017: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 18017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46962,
    lat: 40.98774,
    lng: -85.76675,
    city: "North Manchester",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9122,
    density: 33.2,
    county_fips: 18169,
    county_name: "Wabash",
    county_weights: {
      18085: 8.48,
      18169: 90.27,
      18183: 1.25,
    },
    county_names_all: "Wabash|Kosciusko|Whitley",
    county_fips_all: "18169|18085|18183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46965,
    lat: 40.41601,
    lng: -86.10183,
    city: "Oakford",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18067,
    county_name: "Howard",
    county_weights: {
      18067: 100,
    },
    county_names_all: "Howard",
    county_fips_all: 18067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46967,
    lat: 40.69504,
    lng: -86.19483,
    city: "Onward",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 171,
    density: 747.6,
    county_fips: 18017,
    county_name: "Cass",
    county_weights: {
      18017: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 18017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46968,
    lat: 41.17049,
    lng: -86.55179,
    city: "Ora",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 152,
    density: 51.6,
    county_fips: 18131,
    county_name: "Pulaski",
    county_weights: {
      18131: 59.2,
      18149: 40.8,
    },
    county_names_all: "Pulaski|Starke",
    county_fips_all: "18131|18149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Winamac",
  },
  {
    zip: 46970,
    lat: 40.75827,
    lng: -86.0614,
    city: "Peru",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23280,
    density: 50,
    county_fips: 18103,
    county_name: "Miami",
    county_weights: {
      18017: 7.65,
      18103: 91.54,
      18169: 0.81,
    },
    county_names_all: "Miami|Cass|Wabash",
    county_fips_all: "18103|18017|18169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46971,
    lat: 40.6606,
    lng: -86.16168,
    city: "Grissom Arb",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18103,
    county_name: "Miami",
    county_weights: {
      18103: 100,
    },
    county_names_all: "Miami",
    county_fips_all: 18103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46974,
    lat: 40.94839,
    lng: -85.93041,
    city: "Roann",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1832,
    density: 16.9,
    county_fips: 18169,
    county_name: "Wabash",
    county_weights: {
      18103: 40.18,
      18169: 59.82,
    },
    county_names_all: "Wabash|Miami",
    county_fips_all: "18169|18103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46975,
    lat: 41.0718,
    lng: -86.25177,
    city: "Rochester",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14415,
    density: 26.8,
    county_fips: 18049,
    county_name: "Fulton",
    county_weights: {
      18049: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 18049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46978,
    lat: 40.8587,
    lng: -86.51113,
    city: "Royal Center",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2205,
    density: 12.5,
    county_fips: 18017,
    county_name: "Cass",
    county_weights: {
      18017: 88.92,
      18049: 1.15,
      18131: 5.1,
      18181: 4.83,
    },
    county_names_all: "Cass|Pulaski|White|Fulton",
    county_fips_all: "18017|18131|18181|18049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46979,
    lat: 40.42759,
    lng: -86.27737,
    city: "Russiaville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5257,
    density: 45.4,
    county_fips: 18067,
    county_name: "Howard",
    county_weights: {
      18023: 6.5,
      18067: 88.14,
      18159: 5.36,
    },
    county_names_all: "Howard|Clinton|Tipton",
    county_fips_all: "18067|18023|18159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46980,
    lat: 40.95598,
    lng: -85.74155,
    city: "Servia",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18169,
    county_name: "Wabash",
    county_weights: {
      18169: 100,
    },
    county_names_all: "Wabash",
    county_fips_all: 18169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46982,
    lat: 41.05717,
    lng: -85.8882,
    city: "Silver Lake",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2633,
    density: 22.8,
    county_fips: 18085,
    county_name: "Kosciusko",
    county_weights: {
      18049: 3.29,
      18085: 73.22,
      18169: 23.49,
    },
    county_names_all: "Kosciusko|Wabash|Fulton",
    county_fips_all: "18085|18169|18049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46984,
    lat: 40.66777,
    lng: -85.82975,
    city: "Somerset",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60,
    density: 433,
    county_fips: 18169,
    county_name: "Wabash",
    county_weights: {
      18169: 100,
    },
    county_names_all: "Wabash",
    county_fips_all: 18169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46985,
    lat: 40.95485,
    lng: -86.58225,
    city: "Star City",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1476,
    density: 8.6,
    county_fips: 18131,
    county_name: "Pulaski",
    county_weights: {
      18049: 0.7,
      18131: 95.32,
      18181: 3.98,
    },
    county_names_all: "Pulaski|White|Fulton",
    county_fips_all: "18131|18181|18049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Winamac",
  },
  {
    zip: 46986,
    lat: 40.49481,
    lng: -85.81929,
    city: "Swayzee",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1650,
    density: 18.4,
    county_fips: 18053,
    county_name: "Grant",
    county_weights: {
      18053: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 18053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46987,
    lat: 40.56847,
    lng: -85.76722,
    city: "Sweetser",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 867,
    density: 374.3,
    county_fips: 18053,
    county_name: "Grant",
    county_weights: {
      18053: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 18053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46988,
    lat: 40.8802,
    lng: -86.23451,
    city: "Twelve Mile",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 787,
    density: 11.4,
    county_fips: 18017,
    county_name: "Cass",
    county_weights: {
      18017: 96.25,
      18049: 3.75,
    },
    county_names_all: "Cass|Fulton",
    county_fips_all: "18017|18049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46989,
    lat: 40.45056,
    lng: -85.48115,
    city: "Upland",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5350,
    density: 64.4,
    county_fips: 18053,
    county_name: "Grant",
    county_weights: {
      18009: 1.06,
      18035: 2.14,
      18053: 96.8,
    },
    county_names_all: "Grant|Delaware|Blackford",
    county_fips_all: "18053|18035|18009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46990,
    lat: 40.89851,
    lng: -85.73161,
    city: "Urbana",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 487,
    density: 5.8,
    county_fips: 18169,
    county_name: "Wabash",
    county_weights: {
      18169: 100,
    },
    county_names_all: "Wabash",
    county_fips_all: 18169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46991,
    lat: 40.63034,
    lng: -85.50642,
    city: "Van Buren",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1795,
    density: 21.3,
    county_fips: 18053,
    county_name: "Grant",
    county_weights: {
      18053: 82.85,
      18069: 15.52,
      18179: 1.63,
    },
    county_names_all: "Grant|Huntington|Wells",
    county_fips_all: "18053|18069|18179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46992,
    lat: 40.78509,
    lng: -85.82961,
    city: "Wabash",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15931,
    density: 37.7,
    county_fips: 18169,
    county_name: "Wabash",
    county_weights: {
      18103: 0.45,
      18169: 99.55,
    },
    county_names_all: "Wabash|Miami",
    county_fips_all: "18169|18103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46994,
    lat: 40.66661,
    lng: -86.25766,
    city: "Walton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2382,
    density: 16,
    county_fips: 18017,
    county_name: "Cass",
    county_weights: {
      18017: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 18017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 46996,
    lat: 41.0626,
    lng: -86.65906,
    city: "Winamac",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5771,
    density: 11.8,
    county_fips: 18131,
    county_name: "Pulaski",
    county_weights: {
      18131: 99.25,
      18149: 0.2,
      18181: 0.55,
    },
    county_names_all: "Pulaski|White|Starke",
    county_fips_all: "18131|18181|18149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Winamac",
  },
  {
    zip: 46998,
    lat: 40.57536,
    lng: -86.35081,
    city: "Young America",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18017,
    county_name: "Cass",
    county_weights: {
      18017: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 18017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47001,
    lat: 39.0579,
    lng: -84.95689,
    city: "Aurora",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10080,
    density: 51.1,
    county_fips: 18029,
    county_name: "Dearborn",
    county_weights: {
      18029: 78.52,
      18115: 21.48,
    },
    county_names_all: "Dearborn|Ohio",
    county_fips_all: "18029|18115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 47003,
    lat: 39.55628,
    lng: -84.84491,
    city: "West College Corner",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1027,
    density: 27.1,
    county_fips: 18161,
    county_name: "Union",
    county_weights: {
      18047: 3.55,
      18161: 96.45,
    },
    county_names_all: "Union|Franklin",
    county_fips_all: "18161|18047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47006,
    lat: 39.29141,
    lng: -85.21365,
    city: "Batesville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11900,
    density: 43.3,
    county_fips: 18137,
    county_name: "Ripley",
    county_weights: {
      18031: 0.7,
      18047: 45.26,
      18137: 54.04,
    },
    county_names_all: "Ripley|Franklin|Decatur",
    county_fips_all: "18137|18047|18031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47010,
    lat: 39.4981,
    lng: -84.83925,
    city: "Bath",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57,
    density: 2.3,
    county_fips: 18047,
    county_name: "Franklin",
    county_weights: {
      18047: 90.38,
      18161: 9.62,
    },
    county_names_all: "Franklin|Union",
    county_fips_all: "18047|18161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47011,
    lat: 38.8724,
    lng: -85.06887,
    city: "Bennington",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 838,
    density: 9.7,
    county_fips: 18155,
    county_name: "Switzerland",
    county_weights: {
      18115: 9.38,
      18155: 90.62,
    },
    county_names_all: "Switzerland|Ohio",
    county_fips_all: "18155|18115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vevay",
  },
  {
    zip: 47012,
    lat: 39.41892,
    lng: -84.97944,
    city: "Brookville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9554,
    density: 22.3,
    county_fips: 18047,
    county_name: "Franklin",
    county_weights: {
      18029: 4.62,
      18047: 95.38,
    },
    county_names_all: "Franklin|Dearborn",
    county_fips_all: "18047|18029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47016,
    lat: 39.37414,
    lng: -84.89484,
    city: "Cedar Grove",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 707,
    density: 14.4,
    county_fips: 18047,
    county_name: "Franklin",
    county_weights: {
      18047: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 18047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47017,
    lat: 38.93745,
    lng: -85.17713,
    city: "Cross Plains",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 469,
    density: 8.6,
    county_fips: 18137,
    county_name: "Ripley",
    county_weights: {
      18115: 10.07,
      18137: 74.29,
      18155: 15.64,
    },
    county_names_all: "Ripley|Switzerland|Ohio",
    county_fips_all: "18137|18155|18115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47018,
    lat: 38.98684,
    lng: -85.0866,
    city: "Dillsboro",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4338,
    density: 22.5,
    county_fips: 18029,
    county_name: "Dearborn",
    county_weights: {
      18029: 45.05,
      18115: 27.59,
      18137: 24.29,
      18155: 3.06,
    },
    county_names_all: "Dearborn|Ohio|Ripley|Switzerland",
    county_fips_all: "18029|18115|18137|18155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 47020,
    lat: 38.8119,
    lng: -84.93221,
    city: "Florence",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1447,
    density: 29.6,
    county_fips: 18155,
    county_name: "Switzerland",
    county_weights: {
      18155: 100,
    },
    county_names_all: "Switzerland",
    county_fips_all: 18155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vevay",
  },
  {
    zip: 47021,
    lat: 38.97015,
    lng: -85.14855,
    city: "Friendship",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18137,
    county_name: "Ripley",
    county_weights: {
      18137: 100,
    },
    county_names_all: "Ripley",
    county_fips_all: 18137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47022,
    lat: 39.20722,
    lng: -84.95089,
    city: "Guilford",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3001,
    density: 32.8,
    county_fips: 18029,
    county_name: "Dearborn",
    county_weights: {
      18029: 100,
    },
    county_names_all: "Dearborn",
    county_fips_all: 18029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 47023,
    lat: 39.07255,
    lng: -85.37467,
    city: "Holton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1881,
    density: 14.6,
    county_fips: 18137,
    county_name: "Ripley",
    county_weights: {
      18137: 100,
    },
    county_names_all: "Ripley",
    county_fips_all: 18137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47024,
    lat: 39.47611,
    lng: -85.19724,
    city: "Laurel",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3612,
    density: 21.2,
    county_fips: 18047,
    county_name: "Franklin",
    county_weights: {
      18041: 0.95,
      18047: 99.05,
    },
    county_names_all: "Franklin|Fayette",
    county_fips_all: "18047|18041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47025,
    lat: 39.15415,
    lng: -84.87461,
    city: "Lawrenceburg",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22803,
    density: 168.4,
    county_fips: 18029,
    county_name: "Dearborn",
    county_weights: {
      18029: 100,
    },
    county_names_all: "Dearborn",
    county_fips_all: 18029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 47030,
    lat: 39.42686,
    lng: -85.13319,
    city: "Metamora",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2411,
    density: 32.3,
    county_fips: 18047,
    county_name: "Franklin",
    county_weights: {
      18047: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 18047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47031,
    lat: 39.12872,
    lng: -85.15333,
    city: "Milan",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5218,
    density: 31.8,
    county_fips: 18137,
    county_name: "Ripley",
    county_weights: {
      18029: 10.6,
      18137: 89.4,
    },
    county_names_all: "Ripley|Dearborn",
    county_fips_all: "18137|18029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47032,
    lat: 39.08109,
    lng: -85.05503,
    city: "Moores Hill",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3009,
    density: 30.2,
    county_fips: 18029,
    county_name: "Dearborn",
    county_weights: {
      18029: 92.83,
      18137: 7.17,
    },
    county_names_all: "Dearborn|Ripley",
    county_fips_all: "18029|18137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 47033,
    lat: 39.28127,
    lng: -85.17232,
    city: "Morris",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18137,
    county_name: "Ripley",
    county_weights: {
      18137: 100,
    },
    county_names_all: "Ripley",
    county_fips_all: 18137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47034,
    lat: 39.20428,
    lng: -85.32739,
    city: "Napoleon",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 125,
    density: 373.9,
    county_fips: 18137,
    county_name: "Ripley",
    county_weights: {
      18137: 100,
    },
    county_names_all: "Ripley",
    county_fips_all: 18137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47035,
    lat: 39.31016,
    lng: -84.90394,
    city: "New Trenton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 202,
    density: 198.7,
    county_fips: 18047,
    county_name: "Franklin",
    county_weights: {
      18047: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 18047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47036,
    lat: 39.38563,
    lng: -85.23972,
    city: "Oldenburg",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 900,
    density: 19.5,
    county_fips: 18047,
    county_name: "Franklin",
    county_weights: {
      18047: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 18047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47037,
    lat: 39.16431,
    lng: -85.31908,
    city: "Osgood",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4644,
    density: 22.5,
    county_fips: 18137,
    county_name: "Ripley",
    county_weights: {
      18079: 1.42,
      18137: 98.58,
    },
    county_names_all: "Ripley|Jennings",
    county_fips_all: "18137|18079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47038,
    lat: 38.84588,
    lng: -84.84212,
    city: "Patriot",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1702,
    density: 24.2,
    county_fips: 18155,
    county_name: "Switzerland",
    county_weights: {
      18155: 100,
    },
    county_names_all: "Switzerland",
    county_fips_all: 18155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vevay",
  },
  {
    zip: 47040,
    lat: 38.91703,
    lng: -84.92809,
    city: "Rising Sun",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5103,
    density: 30.4,
    county_fips: 18115,
    county_name: "Ohio",
    county_weights: {
      18115: 68.19,
      18155: 31.81,
    },
    county_names_all: "Ohio|Switzerland",
    county_fips_all: "18115|18155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 47041,
    lat: 39.23432,
    lng: -85.0797,
    city: "Sunman",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6532,
    density: 32.4,
    county_fips: 18029,
    county_name: "Dearborn",
    county_weights: {
      18029: 51.21,
      18047: 1.92,
      18137: 46.87,
    },
    county_names_all: "Dearborn|Ripley|Franklin",
    county_fips_all: "18029|18137|18047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 47042,
    lat: 39.01247,
    lng: -85.25484,
    city: "Versailles",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4143,
    density: 23.4,
    county_fips: 18137,
    county_name: "Ripley",
    county_weights: {
      18137: 100,
    },
    county_names_all: "Ripley",
    county_fips_all: 18137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47043,
    lat: 38.7949,
    lng: -85.10009,
    city: "Vevay",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5290,
    density: 19.8,
    county_fips: 18155,
    county_name: "Switzerland",
    county_weights: {
      18077: 2.57,
      18155: 97.43,
    },
    county_names_all: "Switzerland|Jefferson",
    county_fips_all: "18155|18077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vevay",
  },
  {
    zip: 47060,
    lat: 39.29828,
    lng: -84.8788,
    city: "West Harrison",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6225,
    density: 41.1,
    county_fips: 18029,
    county_name: "Dearborn",
    county_weights: {
      18029: 57.25,
      18047: 42.75,
    },
    county_names_all: "Dearborn|Franklin",
    county_fips_all: "18029|18047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 47102,
    lat: 38.75745,
    lng: -85.7951,
    city: "Austin",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6804,
    density: 62.4,
    county_fips: 18143,
    county_name: "Scott",
    county_weights: {
      18071: 19.28,
      18143: 80.72,
    },
    county_names_all: "Scott|Jackson",
    county_fips_all: "18143|18071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47104,
    lat: 38.54568,
    lng: -85.43665,
    city: "Bethlehem",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18019,
    county_name: "Clark",
    county_weights: {
      18019: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 18019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 47106,
    lat: 38.46071,
    lng: -85.90326,
    city: "Borden",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4825,
    density: 27.6,
    county_fips: 18019,
    county_name: "Clark",
    county_weights: {
      18019: 91.23,
      18043: 4.79,
      18175: 3.98,
    },
    county_names_all: "Clark|Floyd|Washington",
    county_fips_all: "18019|18043|18175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 47108,
    lat: 38.6455,
    lng: -86.25725,
    city: "Campbellsburg",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2650,
    density: 11,
    county_fips: 18175,
    county_name: "Washington",
    county_weights: {
      18117: 2.75,
      18175: 97.25,
    },
    county_names_all: "Washington|Orange",
    county_fips_all: "18175|18117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47110,
    lat: 38.09541,
    lng: -86.2077,
    city: "Central",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 410,
    density: 18.8,
    county_fips: 18061,
    county_name: "Harrison",
    county_weights: {
      18061: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 18061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 47111,
    lat: 38.46604,
    lng: -85.63271,
    city: "Charlestown",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17485,
    density: 78.5,
    county_fips: 18019,
    county_name: "Clark",
    county_weights: {
      18019: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 18019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 47112,
    lat: 38.19235,
    lng: -86.14512,
    city: "Corydon",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16279,
    density: 38.8,
    county_fips: 18061,
    county_name: "Harrison",
    county_weights: {
      18061: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 18061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 47114,
    lat: 38.28754,
    lng: -86.07335,
    city: "Crandall",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 522,
    density: 209.3,
    county_fips: 18061,
    county_name: "Harrison",
    county_weights: {
      18061: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 18061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 47115,
    lat: 38.34465,
    lng: -86.21655,
    city: "Depauw",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3506,
    density: 23.3,
    county_fips: 18061,
    county_name: "Harrison",
    county_weights: {
      18061: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 18061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 47116,
    lat: 38.32521,
    lng: -86.61668,
    city: "Eckerty",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 673,
    density: 10.3,
    county_fips: 18025,
    county_name: "Crawford",
    county_weights: {
      18025: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 18025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Marengo",
  },
  {
    zip: 47117,
    lat: 38.10505,
    lng: -85.97275,
    city: "Elizabeth",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4804,
    density: 22.4,
    county_fips: 18061,
    county_name: "Harrison",
    county_weights: {
      18043: 4.7,
      18061: 95.3,
    },
    county_names_all: "Harrison|Floyd",
    county_fips_all: "18061|18043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 47118,
    lat: 38.29788,
    lng: -86.48449,
    city: "English",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3402,
    density: 9.9,
    county_fips: 18025,
    county_name: "Crawford",
    county_weights: {
      18025: 78.59,
      18117: 9.7,
      18123: 11.71,
    },
    county_names_all: "Crawford|Perry|Orange",
    county_fips_all: "18025|18123|18117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Marengo",
  },
  {
    zip: 47119,
    lat: 38.36699,
    lng: -85.88217,
    city: "Floyds Knobs",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11672,
    density: 108,
    county_fips: 18043,
    county_name: "Floyd",
    county_weights: {
      18019: 13.79,
      18043: 86.21,
    },
    county_names_all: "Floyd|Clark",
    county_fips_all: "18043|18019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 47120,
    lat: 38.45568,
    lng: -86.19075,
    city: "Fredericksburg",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 852,
    density: 17.4,
    county_fips: 18175,
    county_name: "Washington",
    county_weights: {
      18061: 0.98,
      18175: 99.02,
    },
    county_names_all: "Washington|Harrison",
    county_fips_all: "18175|18061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47122,
    lat: 38.3041,
    lng: -85.98303,
    city: "Georgetown",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11022,
    density: 120.4,
    county_fips: 18043,
    county_name: "Floyd",
    county_weights: {
      18043: 66.45,
      18061: 33.55,
    },
    county_names_all: "Floyd|Harrison",
    county_fips_all: "18043|18061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 47123,
    lat: 38.2856,
    lng: -86.47181,
    city: "Grantsburg",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 174,
    density: 47.7,
    county_fips: 18025,
    county_name: "Crawford",
    county_weights: {
      18025: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 18025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Marengo",
  },
  {
    zip: 47124,
    lat: 38.36591,
    lng: -86.00523,
    city: "Greenville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5241,
    density: 84,
    county_fips: 18043,
    county_name: "Floyd",
    county_weights: {
      18043: 78.73,
      18061: 21.27,
    },
    county_names_all: "Floyd|Harrison",
    county_fips_all: "18043|18061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 47125,
    lat: 38.46341,
    lng: -86.30825,
    city: "Hardinsburg",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1485,
    density: 13.4,
    county_fips: 18175,
    county_name: "Washington",
    county_weights: {
      18117: 48.07,
      18175: 51.93,
    },
    county_names_all: "Washington|Orange",
    county_fips_all: "18175|18117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47126,
    lat: 38.54979,
    lng: -85.77844,
    city: "Henryville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4406,
    density: 46.3,
    county_fips: 18019,
    county_name: "Clark",
    county_weights: {
      18019: 96.2,
      18175: 3.8,
    },
    county_names_all: "Clark|Washington",
    county_fips_all: "18019|18175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 47129,
    lat: 38.31378,
    lng: -85.76874,
    city: "Clarksville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19667,
    density: 793.6,
    county_fips: 18019,
    county_name: "Clark",
    county_weights: {
      18019: 99.86,
      18043: 0.14,
    },
    county_names_all: "Clark|Floyd",
    county_fips_all: "18019|18043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 47130,
    lat: 38.33528,
    lng: -85.69689,
    city: "Jeffersonville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47053,
    density: 535.4,
    county_fips: 18019,
    county_name: "Clark",
    county_weights: {
      18019: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 18019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 47135,
    lat: 38.04108,
    lng: -86.0744,
    city: "Laconia",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 898,
    density: 6.8,
    county_fips: 18061,
    county_name: "Harrison",
    county_weights: {
      18061: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 18061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 47136,
    lat: 38.23511,
    lng: -85.96194,
    city: "Lanesville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4424,
    density: 61.9,
    county_fips: 18061,
    county_name: "Harrison",
    county_weights: {
      18043: 45.96,
      18061: 54.04,
    },
    county_names_all: "Harrison|Floyd",
    county_fips_all: "18061|18043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 47137,
    lat: 38.18899,
    lng: -86.37626,
    city: "Leavenworth",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1570,
    density: 9.7,
    county_fips: 18025,
    county_name: "Crawford",
    county_weights: {
      18025: 93.64,
      18061: 3.25,
      18123: 3.11,
    },
    county_names_all: "Crawford|Harrison|Perry",
    county_fips_all: "18025|18061|18123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Marengo",
  },
  {
    zip: 47138,
    lat: 38.68215,
    lng: -85.59759,
    city: "Lexington",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4834,
    density: 25,
    county_fips: 18077,
    county_name: "Jefferson",
    county_weights: {
      18077: 53.55,
      18143: 46.45,
    },
    county_names_all: "Jefferson|Scott",
    county_fips_all: "18077|18143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47140,
    lat: 38.38063,
    lng: -86.36892,
    city: "Marengo",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2356,
    density: 20.4,
    county_fips: 18025,
    county_name: "Crawford",
    county_weights: {
      18025: 58.59,
      18117: 41.41,
    },
    county_names_all: "Crawford|Orange",
    county_fips_all: "18025|18117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Marengo",
  },
  {
    zip: 47141,
    lat: 38.54925,
    lng: -85.60841,
    city: "Marysville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1573,
    density: 18.1,
    county_fips: 18019,
    county_name: "Clark",
    county_weights: {
      18019: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 18019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 47142,
    lat: 38.0684,
    lng: -86.21042,
    city: "Mauckport",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 899,
    density: 11.4,
    county_fips: 18061,
    county_name: "Harrison",
    county_weights: {
      18061: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 18061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 47143,
    lat: 38.46877,
    lng: -85.77314,
    city: "Memphis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3358,
    density: 62.1,
    county_fips: 18019,
    county_name: "Clark",
    county_weights: {
      18019: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 18019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 47145,
    lat: 38.33454,
    lng: -86.30115,
    city: "Milltown",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2154,
    density: 20.8,
    county_fips: 18025,
    county_name: "Crawford",
    county_weights: {
      18025: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 18025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Marengo",
  },
  {
    zip: 47147,
    lat: 38.5942,
    lng: -85.53866,
    city: "Nabb",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 949,
    density: 11.3,
    county_fips: 18019,
    county_name: "Clark",
    county_weights: {
      18019: 59.58,
      18077: 24.21,
      18143: 16.21,
    },
    county_names_all: "Clark|Jefferson|Scott",
    county_fips_all: "18019|18077|18143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 47150,
    lat: 38.28831,
    lng: -85.84775,
    city: "New Albany",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48237,
    density: 413.9,
    county_fips: 18043,
    county_name: "Floyd",
    county_weights: {
      18019: 0.45,
      18043: 99.55,
    },
    county_names_all: "Floyd|Clark",
    county_fips_all: "18043|18019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 47160,
    lat: 38.14817,
    lng: -86.04711,
    city: "New Middletown",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18061,
    county_name: "Harrison",
    county_weights: {
      18061: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 18061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 47161,
    lat: 38.32281,
    lng: -86.10366,
    city: "New Salisbury",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3490,
    density: 59.9,
    county_fips: 18061,
    county_name: "Harrison",
    county_weights: {
      18061: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 18061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 47162,
    lat: 38.55477,
    lng: -85.48873,
    city: "New Washington",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 757,
    density: 16.8,
    county_fips: 18019,
    county_name: "Clark",
    county_weights: {
      18019: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 18019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 47163,
    lat: 38.54101,
    lng: -85.67928,
    city: "Otisco",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1044,
    density: 27.1,
    county_fips: 18019,
    county_name: "Clark",
    county_weights: {
      18019: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 18019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 47164,
    lat: 38.40462,
    lng: -86.09079,
    city: "Palmyra",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4010,
    density: 42.3,
    county_fips: 18061,
    county_name: "Harrison",
    county_weights: {
      18043: 1.63,
      18061: 66.82,
      18175: 31.55,
    },
    county_names_all: "Harrison|Washington|Floyd",
    county_fips_all: "18061|18175|18043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 47165,
    lat: 38.50152,
    lng: -86.00508,
    city: "Pekin",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6443,
    density: 31.5,
    county_fips: 18175,
    county_name: "Washington",
    county_weights: {
      18019: 1.42,
      18043: 2.64,
      18175: 95.94,
    },
    county_names_all: "Washington|Floyd|Clark",
    county_fips_all: "18175|18043|18019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47166,
    lat: 38.30668,
    lng: -86.16901,
    city: "Ramsey",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1108,
    density: 34.3,
    county_fips: 18061,
    county_name: "Harrison",
    county_weights: {
      18061: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 18061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 47167,
    lat: 38.6077,
    lng: -86.09047,
    city: "Salem",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14481,
    density: 26.2,
    county_fips: 18175,
    county_name: "Washington",
    county_weights: {
      18175: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 18175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47170,
    lat: 38.68734,
    lng: -85.84667,
    city: "Scottsburg",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14605,
    density: 38.5,
    county_fips: 18143,
    county_name: "Scott",
    county_weights: {
      18077: 0.22,
      18143: 63.28,
      18175: 36.5,
    },
    county_names_all: "Scott|Washington|Jefferson",
    county_fips_all: "18143|18175|18077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47172,
    lat: 38.39745,
    lng: -85.76886,
    city: "Sellersburg",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17692,
    density: 280.8,
    county_fips: 18019,
    county_name: "Clark",
    county_weights: {
      18019: 87.87,
      18043: 12.13,
    },
    county_names_all: "Clark|Floyd",
    county_fips_all: "18019|18043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Kentucky/Louisville",
  },
  {
    zip: 47174,
    lat: 38.22716,
    lng: -86.482,
    city: "Sulphur",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18025,
    county_name: "Crawford",
    county_weights: {
      18025: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 18025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Marengo",
  },
  {
    zip: 47175,
    lat: 38.35902,
    lng: -86.55236,
    city: "Taswell",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 983,
    density: 14.8,
    county_fips: 18025,
    county_name: "Crawford",
    county_weights: {
      18025: 93.22,
      18117: 6.78,
    },
    county_names_all: "Crawford|Orange",
    county_fips_all: "18025|18117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Marengo",
  },
  {
    zip: 47177,
    lat: 38.59947,
    lng: -85.78197,
    city: "Underwood",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1800,
    density: 29.1,
    county_fips: 18143,
    county_name: "Scott",
    county_weights: {
      18019: 30.13,
      18143: 69.87,
    },
    county_names_all: "Scott|Clark",
    county_fips_all: "18143|18019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47201,
    lat: 39.15074,
    lng: -85.99432,
    city: "Columbus",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47081,
    density: 90.3,
    county_fips: 18005,
    county_name: "Bartholomew",
    county_weights: {
      18005: 84.67,
      18013: 15.33,
    },
    county_names_all: "Bartholomew|Brown",
    county_fips_all: "18005|18013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47203,
    lat: 39.23189,
    lng: -85.83281,
    city: "Columbus",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26033,
    density: 130.4,
    county_fips: 18005,
    county_name: "Bartholomew",
    county_weights: {
      18005: 100,
    },
    county_names_all: "Bartholomew",
    county_fips_all: 18005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47220,
    lat: 38.87786,
    lng: -86.05471,
    city: "Brownstown",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5637,
    density: 26.4,
    county_fips: 18071,
    county_name: "Jackson",
    county_weights: {
      18071: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 18071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47223,
    lat: 39.0555,
    lng: -85.48218,
    city: "Butlerville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 962,
    density: 8.1,
    county_fips: 18079,
    county_name: "Jennings",
    county_weights: {
      18079: 100,
    },
    county_names_all: "Jennings",
    county_fips_all: 18079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47224,
    lat: 38.88816,
    lng: -85.22474,
    city: "Canaan",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 732,
    density: 11.6,
    county_fips: 18077,
    county_name: "Jefferson",
    county_weights: {
      18077: 68.3,
      18155: 31.7,
    },
    county_names_all: "Jefferson|Switzerland",
    county_fips_all: "18077|18155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47225,
    lat: 39.43554,
    lng: -85.34424,
    city: "Clarksburg",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18031,
    county_name: "Decatur",
    county_weights: {
      18031: 100,
    },
    county_names_all: "Decatur",
    county_fips_all: 18031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47226,
    lat: 39.28266,
    lng: -85.86907,
    city: "Clifford",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 195,
    density: 851.6,
    county_fips: 18005,
    county_name: "Bartholomew",
    county_weights: {
      18005: 100,
    },
    county_names_all: "Bartholomew",
    county_fips_all: 18005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47227,
    lat: 38.87506,
    lng: -85.65678,
    city: "Commiskey",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1922,
    density: 15.7,
    county_fips: 18079,
    county_name: "Jennings",
    county_weights: {
      18077: 15.08,
      18079: 84.92,
    },
    county_names_all: "Jennings|Jefferson",
    county_fips_all: "18079|18077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47229,
    lat: 38.80289,
    lng: -85.86688,
    city: "Crothersville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3086,
    density: 24.4,
    county_fips: 18071,
    county_name: "Jackson",
    county_weights: {
      18071: 89,
      18079: 11,
    },
    county_names_all: "Jackson|Jennings",
    county_fips_all: "18071|18079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47230,
    lat: 38.7946,
    lng: -85.63139,
    city: "Deputy",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1372,
    density: 10.4,
    county_fips: 18077,
    county_name: "Jefferson",
    county_weights: {
      18077: 78.61,
      18079: 6.14,
      18143: 15.25,
    },
    county_names_all: "Jefferson|Scott|Jennings",
    county_fips_all: "18077|18143|18079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47231,
    lat: 38.89792,
    lng: -85.4996,
    city: "Dupont",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 867,
    density: 12.5,
    county_fips: 18077,
    county_name: "Jefferson",
    county_weights: {
      18077: 64.13,
      18079: 35.87,
    },
    county_names_all: "Jefferson|Jennings",
    county_fips_all: "18077|18079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47232,
    lat: 39.11297,
    lng: -85.79428,
    city: "Elizabethtown",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3128,
    density: 37.7,
    county_fips: 18005,
    county_name: "Bartholomew",
    county_weights: {
      18005: 70.26,
      18079: 29.74,
    },
    county_names_all: "Bartholomew|Jennings",
    county_fips_all: "18005|18079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47234,
    lat: 39.37611,
    lng: -85.76837,
    city: "Flat Rock",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1564,
    density: 18,
    county_fips: 18145,
    county_name: "Shelby",
    county_weights: {
      18005: 3.08,
      18145: 96.92,
    },
    county_names_all: "Shelby|Bartholomew",
    county_fips_all: "18145|18005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47235,
    lat: 39.01385,
    lng: -86.14046,
    city: "Freetown",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1495,
    density: 13.6,
    county_fips: 18071,
    county_name: "Jackson",
    county_weights: {
      18013: 30.1,
      18071: 69.9,
    },
    county_names_all: "Jackson|Brown",
    county_fips_all: "18071|18013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47236,
    lat: 39.15181,
    lng: -85.72536,
    city: "Grammer",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18005,
    county_name: "Bartholomew",
    county_weights: {
      18005: 100,
    },
    county_names_all: "Bartholomew",
    county_fips_all: 18005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47240,
    lat: 39.32394,
    lng: -85.48028,
    city: "Greensburg",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21858,
    density: 27.8,
    county_fips: 18031,
    county_name: "Decatur",
    county_weights: {
      18031: 95.53,
      18047: 1.45,
      18137: 0.91,
      18139: 0.34,
      18145: 1.77,
    },
    county_names_all: "Decatur|Shelby|Franklin|Ripley|Rush",
    county_fips_all: "18031|18145|18047|18137|18139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47243,
    lat: 38.67214,
    lng: -85.48177,
    city: "Hanover",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6082,
    density: 71,
    county_fips: 18077,
    county_name: "Jefferson",
    county_weights: {
      18077: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 18077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47244,
    lat: 39.21802,
    lng: -85.70232,
    city: "Hartsville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 646,
    density: 14.6,
    county_fips: 18005,
    county_name: "Bartholomew",
    county_weights: {
      18005: 83.53,
      18031: 16.47,
    },
    county_names_all: "Bartholomew|Decatur",
    county_fips_all: "18005|18031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47246,
    lat: 39.29804,
    lng: -85.76606,
    city: "Hope",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4642,
    density: 30.8,
    county_fips: 18005,
    county_name: "Bartholomew",
    county_weights: {
      18005: 99.34,
      18031: 0.66,
    },
    county_names_all: "Bartholomew|Decatur",
    county_fips_all: "18005|18031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47247,
    lat: 39.05993,
    lng: -85.88783,
    city: "Jonesville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 193,
    density: 525.8,
    county_fips: 18005,
    county_name: "Bartholomew",
    county_weights: {
      18005: 100,
    },
    county_names_all: "Bartholomew",
    county_fips_all: 18005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47250,
    lat: 38.81867,
    lng: -85.3552,
    city: "Madison",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22106,
    density: 40.4,
    county_fips: 18077,
    county_name: "Jefferson",
    county_weights: {
      18077: 84.75,
      18137: 10.44,
      18155: 4.81,
    },
    county_names_all: "Jefferson|Ripley|Switzerland",
    county_fips_all: "18077|18137|18155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47260,
    lat: 38.83596,
    lng: -86.19909,
    city: "Medora",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2106,
    density: 14.5,
    county_fips: 18071,
    county_name: "Jackson",
    county_weights: {
      18071: 99.39,
      18093: 0.61,
    },
    county_names_all: "Jackson|Lawrence",
    county_fips_all: "18071|18093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47263,
    lat: 39.30864,
    lng: -85.32832,
    city: "New Point",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 242,
    density: 1071.5,
    county_fips: 18031,
    county_name: "Decatur",
    county_weights: {
      18031: 100,
    },
    county_names_all: "Decatur",
    county_fips_all: 18031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47264,
    lat: 38.96434,
    lng: -86.26313,
    city: "Norman",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1371,
    density: 5.9,
    county_fips: 18071,
    county_name: "Jackson",
    county_weights: {
      18071: 74.4,
      18093: 22.59,
      18105: 3,
    },
    county_names_all: "Jackson|Lawrence|Monroe",
    county_fips_all: "18071|18093|18105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47265,
    lat: 39.00818,
    lng: -85.62685,
    city: "North Vernon",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20949,
    density: 43.6,
    county_fips: 18079,
    county_name: "Jennings",
    county_weights: {
      18031: 0.3,
      18079: 99.7,
    },
    county_names_all: "Jennings|Decatur",
    county_fips_all: "18079|18031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47270,
    lat: 38.8397,
    lng: -85.71913,
    city: "Paris Crossing",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 342,
    density: 7.4,
    county_fips: 18079,
    county_name: "Jennings",
    county_weights: {
      18077: 12.37,
      18079: 87.63,
    },
    county_names_all: "Jennings|Jefferson",
    county_fips_all: "18079|18077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47272,
    lat: 39.41519,
    lng: -85.61942,
    city: "Saint Paul",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2123,
    density: 26.6,
    county_fips: 18031,
    county_name: "Decatur",
    county_weights: {
      18031: 58.82,
      18139: 1.64,
      18145: 39.54,
    },
    county_names_all: "Decatur|Shelby|Rush",
    county_fips_all: "18031|18145|18139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47273,
    lat: 39.07472,
    lng: -85.7359,
    city: "Scipio",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2265,
    density: 27.5,
    county_fips: 18079,
    county_name: "Jennings",
    county_weights: {
      18005: 3.22,
      18079: 96.78,
    },
    county_names_all: "Jennings|Bartholomew",
    county_fips_all: "18079|18005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47274,
    lat: 38.96261,
    lng: -85.92877,
    city: "Seymour",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30891,
    density: 55.5,
    county_fips: 18071,
    county_name: "Jackson",
    county_weights: {
      18005: 5.5,
      18013: 1.62,
      18071: 87.83,
      18079: 5.05,
    },
    county_names_all: "Jackson|Bartholomew|Jennings|Brown",
    county_fips_all: "18071|18005|18079|18013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47280,
    lat: 39.29655,
    lng: -85.95047,
    city: "Taylorsville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 512,
    density: 182.7,
    county_fips: 18005,
    county_name: "Bartholomew",
    county_weights: {
      18005: 100,
    },
    county_names_all: "Bartholomew",
    county_fips_all: 18005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47281,
    lat: 38.78563,
    lng: -86.10324,
    city: "Vallonia",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1298,
    density: 8.5,
    county_fips: 18071,
    county_name: "Jackson",
    county_weights: {
      18071: 60.38,
      18175: 39.62,
    },
    county_names_all: "Jackson|Washington",
    county_fips_all: "18071|18175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47282,
    lat: 38.98538,
    lng: -85.6101,
    city: "Vernon",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 168,
    density: 313,
    county_fips: 18079,
    county_name: "Jennings",
    county_weights: {
      18079: 100,
    },
    county_names_all: "Jennings",
    county_fips_all: 18079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47283,
    lat: 39.16978,
    lng: -85.58647,
    city: "Westport",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3462,
    density: 20,
    county_fips: 18031,
    county_name: "Decatur",
    county_weights: {
      18005: 4.15,
      18031: 81.51,
      18079: 14.34,
    },
    county_names_all: "Decatur|Jennings|Bartholomew",
    county_fips_all: "18031|18079|18005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47302,
    lat: 40.12992,
    lng: -85.37553,
    city: "Muncie",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25307,
    density: 149.9,
    county_fips: 18035,
    county_name: "Delaware",
    county_weights: {
      18035: 96.76,
      18065: 3.24,
    },
    county_names_all: "Delaware|Henry",
    county_fips_all: "18035|18065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47303,
    lat: 40.27108,
    lng: -85.37648,
    city: "Muncie",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24674,
    density: 164.2,
    county_fips: 18035,
    county_name: "Delaware",
    county_weights: {
      18035: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 18035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47304,
    lat: 40.23398,
    lng: -85.45973,
    city: "Muncie",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31992,
    density: 356,
    county_fips: 18035,
    county_name: "Delaware",
    county_weights: {
      18035: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 18035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47305,
    lat: 40.19387,
    lng: -85.38556,
    city: "Muncie",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3373,
    density: 988.3,
    county_fips: 18035,
    county_name: "Delaware",
    county_weights: {
      18035: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 18035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47306,
    lat: 40.20542,
    lng: -85.40726,
    city: "Muncie",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5191,
    density: 7578.5,
    county_fips: 18035,
    county_name: "Delaware",
    county_weights: {
      18035: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 18035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47320,
    lat: 40.2787,
    lng: -85.2672,
    city: "Albany",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3879,
    density: 45.9,
    county_fips: 18035,
    county_name: "Delaware",
    county_weights: {
      18035: 94.43,
      18075: 0.61,
      18135: 4.96,
    },
    county_names_all: "Delaware|Randolph|Jay",
    county_fips_all: "18035|18135|18075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47324,
    lat: 39.74119,
    lng: -84.85172,
    city: "Boston",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 160,
    density: 277,
    county_fips: 18177,
    county_name: "Wayne",
    county_weights: {
      18177: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 18177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47325,
    lat: 39.69395,
    lng: -85.01834,
    city: "Brownsville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 705,
    density: 12.4,
    county_fips: 18161,
    county_name: "Union",
    county_weights: {
      18041: 17.78,
      18161: 71.02,
      18177: 11.2,
    },
    county_names_all: "Union|Fayette|Wayne",
    county_fips_all: "18161|18041|18177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47326,
    lat: 40.54597,
    lng: -84.97018,
    city: "Bryant",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2105,
    density: 12.3,
    county_fips: 18075,
    county_name: "Jay",
    county_weights: {
      18001: 4.04,
      18075: 95.96,
    },
    county_names_all: "Jay|Adams",
    county_fips_all: "18075|18001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47327,
    lat: 39.8318,
    lng: -85.17314,
    city: "Cambridge City",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4277,
    density: 29.7,
    county_fips: 18177,
    county_name: "Wayne",
    county_weights: {
      18065: 22.84,
      18177: 77.16,
    },
    county_names_all: "Wayne|Henry",
    county_fips_all: "18177|18065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47330,
    lat: 39.78792,
    lng: -85.02226,
    city: "Centerville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5051,
    density: 34.9,
    county_fips: 18177,
    county_name: "Wayne",
    county_weights: {
      18177: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 18177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47331,
    lat: 39.63086,
    lng: -85.16313,
    city: "Connersville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22535,
    density: 45.4,
    county_fips: 18041,
    county_name: "Fayette",
    county_weights: {
      18041: 94.48,
      18047: 1.42,
      18161: 3.2,
      18177: 0.9,
    },
    county_names_all: "Fayette|Union|Franklin|Wayne",
    county_fips_all: "18041|18161|18047|18177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47334,
    lat: 40.11267,
    lng: -85.52357,
    city: "Daleville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3219,
    density: 50.7,
    county_fips: 18035,
    county_name: "Delaware",
    county_weights: {
      18035: 96.55,
      18065: 3.45,
    },
    county_names_all: "Delaware|Henry",
    county_fips_all: "18035|18065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47335,
    lat: 39.81171,
    lng: -85.20675,
    city: "Dublin",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 893,
    density: 896.7,
    county_fips: 18177,
    county_name: "Wayne",
    county_weights: {
      18177: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 18177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47336,
    lat: 40.39694,
    lng: -85.20821,
    city: "Dunkirk",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3151,
    density: 25.9,
    county_fips: 18075,
    county_name: "Jay",
    county_weights: {
      18009: 17,
      18035: 29.58,
      18075: 53.42,
    },
    county_names_all: "Jay|Delaware|Blackford",
    county_fips_all: "18075|18035|18009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47337,
    lat: 39.80286,
    lng: -85.43736,
    city: "Dunreith",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 158,
    density: 521.3,
    county_fips: 18065,
    county_name: "Henry",
    county_weights: {
      18065: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 18065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47338,
    lat: 40.34363,
    lng: -85.33977,
    city: "Eaton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2782,
    density: 35.9,
    county_fips: 18035,
    county_name: "Delaware",
    county_weights: {
      18009: 7.1,
      18035: 92.9,
    },
    county_names_all: "Delaware|Blackford",
    county_fips_all: "18035|18009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47339,
    lat: 39.96337,
    lng: -85.09471,
    city: "Economy",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 514,
    density: 14.1,
    county_fips: 18177,
    county_name: "Wayne",
    county_weights: {
      18177: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 18177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47340,
    lat: 40.181,
    lng: -85.1318,
    city: "Farmland",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3175,
    density: 23,
    county_fips: 18135,
    county_name: "Randolph",
    county_weights: {
      18135: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 18135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47341,
    lat: 39.9741,
    lng: -84.89361,
    city: "Fountain City",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2494,
    density: 28.6,
    county_fips: 18177,
    county_name: "Wayne",
    county_weights: {
      18177: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 18177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47342,
    lat: 40.32184,
    lng: -85.5105,
    city: "Gaston",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2492,
    density: 19.6,
    county_fips: 18035,
    county_name: "Delaware",
    county_weights: {
      18035: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 18035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47344,
    lat: 39.87857,
    lng: -85.464,
    city: "Greensboro",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 165,
    density: 576.6,
    county_fips: 18065,
    county_name: "Henry",
    county_weights: {
      18065: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 18065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47345,
    lat: 39.892,
    lng: -85.04765,
    city: "Greens Fork",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1625,
    density: 21.7,
    county_fips: 18177,
    county_name: "Wayne",
    county_weights: {
      18177: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 18177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47346,
    lat: 39.93442,
    lng: -85.16306,
    city: "Hagerstown",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3723,
    density: 31.9,
    county_fips: 18177,
    county_name: "Wayne",
    county_weights: {
      18065: 15.22,
      18177: 84.78,
    },
    county_names_all: "Wayne|Henry",
    county_fips_all: "18177|18065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47348,
    lat: 40.45725,
    lng: -85.34855,
    city: "Hartford City",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8827,
    density: 29.3,
    county_fips: 18009,
    county_name: "Blackford",
    county_weights: {
      18009: 98.26,
      18053: 1.74,
    },
    county_names_all: "Blackford|Grant",
    county_fips_all: "18009|18053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47351,
    lat: 39.90442,
    lng: -85.52001,
    city: "Kennard",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 663,
    density: 973.5,
    county_fips: 18065,
    county_name: "Henry",
    county_weights: {
      18065: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 18065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47352,
    lat: 39.79597,
    lng: -85.3637,
    city: "Lewisville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 820,
    density: 9.9,
    county_fips: 18065,
    county_name: "Henry",
    county_weights: {
      18041: 3.16,
      18065: 61.57,
      18139: 35.27,
    },
    county_names_all: "Henry|Rush|Fayette",
    county_fips_all: "18065|18139|18041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47353,
    lat: 39.62757,
    lng: -84.92057,
    city: "Liberty",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5360,
    density: 16.8,
    county_fips: 18161,
    county_name: "Union",
    county_weights: {
      18047: 0.36,
      18161: 99.64,
    },
    county_names_all: "Union|Franklin",
    county_fips_all: "18161|18047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47354,
    lat: 40.04628,
    lng: -85.19933,
    city: "Losantville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1241,
    density: 16.5,
    county_fips: 18135,
    county_name: "Randolph",
    county_weights: {
      18035: 14.29,
      18065: 22.87,
      18135: 56.83,
      18177: 6.01,
    },
    county_names_all: "Randolph|Henry|Delaware|Wayne",
    county_fips_all: "18135|18065|18035|18177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47355,
    lat: 40.04376,
    lng: -84.9258,
    city: "Lynn",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3027,
    density: 18.5,
    county_fips: 18135,
    county_name: "Randolph",
    county_weights: {
      18135: 98.66,
      18177: 1.34,
    },
    county_names_all: "Randolph|Wayne",
    county_fips_all: "18135|18177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47356,
    lat: 40.03079,
    lng: -85.50415,
    city: "Middletown",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5477,
    density: 38.7,
    county_fips: 18065,
    county_name: "Henry",
    county_weights: {
      18035: 3.88,
      18065: 90.57,
      18095: 5.55,
    },
    county_names_all: "Henry|Madison|Delaware",
    county_fips_all: "18065|18095|18035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47357,
    lat: 39.75773,
    lng: -85.14795,
    city: "Milton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 678,
    density: 7.7,
    county_fips: 18177,
    county_name: "Wayne",
    county_weights: {
      18041: 25.46,
      18177: 74.54,
    },
    county_names_all: "Wayne|Fayette",
    county_fips_all: "18177|18041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47358,
    lat: 40.05488,
    lng: -85.11204,
    city: "Modoc",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 985,
    density: 10.1,
    county_fips: 18135,
    county_name: "Randolph",
    county_weights: {
      18135: 93.57,
      18177: 6.43,
    },
    county_names_all: "Randolph|Wayne",
    county_fips_all: "18135|18177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47359,
    lat: 40.55203,
    lng: -85.28642,
    city: "Montpelier",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3619,
    density: 24.6,
    county_fips: 18009,
    county_name: "Blackford",
    county_weights: {
      18009: 62.72,
      18179: 37.28,
    },
    county_names_all: "Blackford|Wells",
    county_fips_all: "18009|18179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47360,
    lat: 40.01677,
    lng: -85.2614,
    city: "Mooreland",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1259,
    density: 14.7,
    county_fips: 18065,
    county_name: "Henry",
    county_weights: {
      18065: 94.58,
      18135: 1.36,
      18177: 4.06,
    },
    county_names_all: "Henry|Wayne|Randolph",
    county_fips_all: "18065|18177|18135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47361,
    lat: 40.00415,
    lng: -85.38492,
    city: "Mount Summit",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 205,
    density: 1624.4,
    county_fips: 18065,
    county_name: "Henry",
    county_weights: {
      18065: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 18065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47362,
    lat: 39.93186,
    lng: -85.36998,
    city: "New Castle",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29260,
    density: 76.5,
    county_fips: 18065,
    county_name: "Henry",
    county_weights: {
      18065: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 18065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47366,
    lat: 39.86127,
    lng: -85.26068,
    city: "New Lisbon",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18065,
    county_name: "Henry",
    county_weights: {
      18065: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 18065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47367,
    lat: 40.08366,
    lng: -85.39207,
    city: "Oakville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 83,
    density: 126.8,
    county_fips: 18035,
    county_name: "Delaware",
    county_weights: {
      18035: 99.87,
      18065: 0.13,
    },
    county_names_all: "Delaware|Henry",
    county_fips_all: "18035|18065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47368,
    lat: 40.18082,
    lng: -85.20025,
    city: "Parker City",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2230,
    density: 24.5,
    county_fips: 18135,
    county_name: "Randolph",
    county_weights: {
      18035: 23.33,
      18135: 76.67,
    },
    county_names_all: "Randolph|Delaware",
    county_fips_all: "18135|18035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47369,
    lat: 40.50714,
    lng: -85.14715,
    city: "Pennville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1615,
    density: 17.7,
    county_fips: 18075,
    county_name: "Jay",
    county_weights: {
      18009: 5.2,
      18075: 94.8,
    },
    county_names_all: "Jay|Blackford",
    county_fips_all: "18075|18009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47370,
    lat: 39.81281,
    lng: -85.13779,
    city: "Pershing",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18177,
    county_name: "Wayne",
    county_weights: {
      18177: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 18177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47371,
    lat: 40.41874,
    lng: -84.95896,
    city: "Portland",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11892,
    density: 20.9,
    county_fips: 18075,
    county_name: "Jay",
    county_weights: {
      18075: 100,
    },
    county_names_all: "Jay",
    county_fips_all: 18075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47373,
    lat: 40.33863,
    lng: -85.15356,
    city: "Redkey",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2296,
    density: 28.6,
    county_fips: 18075,
    county_name: "Jay",
    county_weights: {
      18075: 94.28,
      18135: 5.72,
    },
    county_names_all: "Jay|Randolph",
    county_fips_all: "18075|18135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47374,
    lat: 39.83376,
    lng: -84.88997,
    city: "Richmond",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45515,
    density: 146.7,
    county_fips: 18177,
    county_name: "Wayne",
    county_weights: {
      18161: 1.14,
      18177: 98.86,
    },
    county_names_all: "Wayne|Union",
    county_fips_all: "18177|18161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47380,
    lat: 40.28553,
    lng: -85.03439,
    city: "Ridgeville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1485,
    density: 9.3,
    county_fips: 18135,
    county_name: "Randolph",
    county_weights: {
      18075: 11.37,
      18135: 88.63,
    },
    county_names_all: "Randolph|Jay",
    county_fips_all: "18135|18075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47381,
    lat: 40.38665,
    lng: -84.86465,
    city: "Salamonia",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 124,
    density: 73.1,
    county_fips: 18075,
    county_name: "Jay",
    county_weights: {
      18075: 100,
    },
    county_names_all: "Jay",
    county_fips_all: 18075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47382,
    lat: 40.23692,
    lng: -84.91845,
    city: "Saratoga",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 226,
    density: 1066.2,
    county_fips: 18135,
    county_name: "Randolph",
    county_weights: {
      18135: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 18135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47383,
    lat: 40.15123,
    lng: -85.26399,
    city: "Selma",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2953,
    density: 35.7,
    county_fips: 18035,
    county_name: "Delaware",
    county_weights: {
      18035: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 18035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47384,
    lat: 39.91365,
    lng: -85.55352,
    city: "Shirley",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2040,
    density: 25.2,
    county_fips: 18065,
    county_name: "Henry",
    county_weights: {
      18059: 13.75,
      18065: 86.25,
    },
    county_names_all: "Henry|Hancock",
    county_fips_all: "18065|18059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47385,
    lat: 39.83194,
    lng: -85.44825,
    city: "Spiceland",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1691,
    density: 43.6,
    county_fips: 18065,
    county_name: "Henry",
    county_weights: {
      18065: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 18065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47386,
    lat: 40.05277,
    lng: -85.38305,
    city: "Springport",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1233,
    density: 28.4,
    county_fips: 18065,
    county_name: "Henry",
    county_weights: {
      18065: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 18065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47387,
    lat: 39.83677,
    lng: -85.2945,
    city: "Straughn",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 745,
    density: 16.3,
    county_fips: 18065,
    county_name: "Henry",
    county_weights: {
      18065: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 18065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47388,
    lat: 40.0056,
    lng: -85.44352,
    city: "Sulphur Springs",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 409,
    density: 792.1,
    county_fips: 18065,
    county_name: "Henry",
    county_weights: {
      18065: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 18065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47390,
    lat: 40.20625,
    lng: -84.84671,
    city: "Union City",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5246,
    density: 26,
    county_fips: 18135,
    county_name: "Randolph",
    county_weights: {
      18075: 6.85,
      18135: 93.15,
    },
    county_names_all: "Randolph|Jay",
    county_fips_all: "18135|18075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47392,
    lat: 39.91005,
    lng: -84.94394,
    city: "Webster",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18177,
    county_name: "Wayne",
    county_weights: {
      18177: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 18177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47393,
    lat: 39.96559,
    lng: -85.00325,
    city: "Williamsburg",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1828,
    density: 18.9,
    county_fips: 18177,
    county_name: "Wayne",
    county_weights: {
      18135: 11.98,
      18177: 88.02,
    },
    county_names_all: "Wayne|Randolph",
    county_fips_all: "18177|18135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47394,
    lat: 40.1679,
    lng: -84.98667,
    city: "Winchester",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7823,
    density: 24.7,
    county_fips: 18135,
    county_name: "Randolph",
    county_weights: {
      18135: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 18135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47396,
    lat: 40.18661,
    lng: -85.51632,
    city: "Yorktown",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7785,
    density: 87.7,
    county_fips: 18035,
    county_name: "Delaware",
    county_weights: {
      18035: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 18035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47401,
    lat: 39.08613,
    lng: -86.45138,
    city: "Bloomington",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43378,
    density: 202.7,
    county_fips: 18105,
    county_name: "Monroe",
    county_weights: {
      18013: 2.71,
      18105: 97.29,
    },
    county_names_all: "Monroe|Brown",
    county_fips_all: "18105|18013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47403,
    lat: 39.08635,
    lng: -86.61082,
    city: "Bloomington",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34090,
    density: 154.8,
    county_fips: 18105,
    county_name: "Monroe",
    county_weights: {
      18055: 1.45,
      18105: 98.55,
    },
    county_names_all: "Monroe|Greene",
    county_fips_all: "18105|18055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47404,
    lat: 39.22064,
    lng: -86.5896,
    city: "Bloomington",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24778,
    density: 182,
    county_fips: 18105,
    county_name: "Monroe",
    county_weights: {
      18105: 98.14,
      18119: 1.86,
    },
    county_names_all: "Monroe|Owen",
    county_fips_all: "18105|18119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47405,
    lat: 39.16761,
    lng: -86.5211,
    city: "Bloomington",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5731,
    density: 8437.9,
    county_fips: 18105,
    county_name: "Monroe",
    county_weights: {
      18105: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 18105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47406,
    lat: 39.17501,
    lng: -86.51516,
    city: "Bloomington",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3404,
    density: 2212.8,
    county_fips: 18105,
    county_name: "Monroe",
    county_weights: {
      18105: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 18105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47408,
    lat: 39.2283,
    lng: -86.46452,
    city: "Bloomington",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23970,
    density: 143.6,
    county_fips: 18105,
    county_name: "Monroe",
    county_weights: {
      18105: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 18105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47420,
    lat: 38.91903,
    lng: -86.54933,
    city: "Avoca",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 368,
    density: 298.2,
    county_fips: 18093,
    county_name: "Lawrence",
    county_weights: {
      18093: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 18093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47421,
    lat: 38.86415,
    lng: -86.45122,
    city: "Bedford",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27178,
    density: 56.9,
    county_fips: 18093,
    county_name: "Lawrence",
    county_weights: {
      18093: 99.79,
      18105: 0.21,
    },
    county_names_all: "Lawrence|Monroe",
    county_fips_all: "18093|18105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47424,
    lat: 39.01918,
    lng: -86.86998,
    city: "Bloomfield",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8788,
    density: 18.2,
    county_fips: 18055,
    county_name: "Greene",
    county_weights: {
      18055: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 18055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47427,
    lat: 39.23915,
    lng: -87.01266,
    city: "Coal City",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 812,
    density: 6.1,
    county_fips: 18119,
    county_name: "Owen",
    county_weights: {
      18021: 11.64,
      18119: 88.36,
    },
    county_names_all: "Owen|Clay",
    county_fips_all: "18119|18021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47429,
    lat: 39.27581,
    lng: -86.61444,
    city: "Ellettsville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9025,
    density: 145.3,
    county_fips: 18105,
    county_name: "Monroe",
    county_weights: {
      18105: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 18105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47431,
    lat: 39.24052,
    lng: -86.90655,
    city: "Freedom",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1463,
    density: 15.4,
    county_fips: 18119,
    county_name: "Owen",
    county_weights: {
      18119: 100,
    },
    county_names_all: "Owen",
    county_fips_all: 18119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47432,
    lat: 38.49268,
    lng: -86.63942,
    city: "French Lick",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4711,
    density: 23.4,
    county_fips: 18117,
    county_name: "Orange",
    county_weights: {
      18037: 10.7,
      18101: 9.61,
      18117: 79.69,
    },
    county_names_all: "Orange|Dubois|Martin",
    county_fips_all: "18117|18037|18101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47433,
    lat: 39.35569,
    lng: -86.655,
    city: "Gosport",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3918,
    density: 19.2,
    county_fips: 18119,
    county_name: "Owen",
    county_weights: {
      18105: 30.24,
      18109: 14.57,
      18119: 55.19,
    },
    county_names_all: "Owen|Monroe|Morgan",
    county_fips_all: "18119|18105|18109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47434,
    lat: 39.01277,
    lng: -86.54569,
    city: "Harrodsburg",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 18105,
    county_name: "Monroe",
    county_weights: {
      18105: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 18105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47435,
    lat: 39.26576,
    lng: -86.29516,
    city: "Helmsburg",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18013,
    county_name: "Brown",
    county_weights: {
      18013: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 18013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47436,
    lat: 38.9598,
    lng: -86.38358,
    city: "Heltonville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1376,
    density: 10.1,
    county_fips: 18093,
    county_name: "Lawrence",
    county_weights: {
      18093: 69.57,
      18105: 30.43,
    },
    county_names_all: "Lawrence|Monroe",
    county_fips_all: "18093|18105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47437,
    lat: 38.7135,
    lng: -86.6769,
    city: "Huron",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 213,
    density: 113.2,
    county_fips: 18093,
    county_name: "Lawrence",
    county_weights: {
      18093: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 18093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47438,
    lat: 39.1582,
    lng: -87.18237,
    city: "Jasonville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4288,
    density: 27.4,
    county_fips: 18055,
    county_name: "Greene",
    county_weights: {
      18021: 35.8,
      18055: 52.04,
      18153: 12.16,
    },
    county_names_all: "Greene|Clay|Sullivan",
    county_fips_all: "18055|18021|18153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47441,
    lat: 39.03976,
    lng: -87.1743,
    city: "Linton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8977,
    density: 52.7,
    county_fips: 18055,
    county_name: "Greene",
    county_weights: {
      18055: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 18055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47443,
    lat: 38.96651,
    lng: -87.09059,
    city: "Lyons",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1419,
    density: 10.8,
    county_fips: 18055,
    county_name: "Greene",
    county_weights: {
      18055: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 18055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47445,
    lat: 39.11289,
    lng: -87.18944,
    city: "Midland",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18055,
    county_name: "Greene",
    county_weights: {
      18055: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 18055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47446,
    lat: 38.73818,
    lng: -86.52031,
    city: "Mitchell",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9982,
    density: 30.7,
    county_fips: 18093,
    county_name: "Lawrence",
    county_weights: {
      18093: 91.02,
      18101: 8.98,
    },
    county_names_all: "Lawrence|Martin",
    county_fips_all: "18093|18101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47448,
    lat: 39.17531,
    lng: -86.24481,
    city: "Nashville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7176,
    density: 14.8,
    county_fips: 18013,
    county_name: "Brown",
    county_weights: {
      18005: 1.02,
      18013: 97.31,
      18105: 1.67,
    },
    county_names_all: "Brown|Monroe|Bartholomew",
    county_fips_all: "18013|18105|18005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47449,
    lat: 38.92672,
    lng: -86.9894,
    city: "Newberry",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 346,
    density: 6.3,
    county_fips: 18055,
    county_name: "Greene",
    county_weights: {
      18055: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 18055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47451,
    lat: 38.89176,
    lng: -86.52536,
    city: "Oolitic",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1470,
    density: 516.6,
    county_fips: 18093,
    county_name: "Lawrence",
    county_weights: {
      18093: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 18093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47452,
    lat: 38.6422,
    lng: -86.41901,
    city: "Orleans",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5249,
    density: 20.5,
    county_fips: 18117,
    county_name: "Orange",
    county_weights: {
      18093: 11.57,
      18117: 87.92,
      18175: 0.51,
    },
    county_names_all: "Orange|Lawrence|Washington",
    county_fips_all: "18117|18093|18175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47453,
    lat: 38.93472,
    lng: -86.76773,
    city: "Owensburg",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 605,
    density: 37.5,
    county_fips: 18055,
    county_name: "Greene",
    county_weights: {
      18055: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 18055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47454,
    lat: 38.51596,
    lng: -86.45989,
    city: "Paoli",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7293,
    density: 21.8,
    county_fips: 18117,
    county_name: "Orange",
    county_weights: {
      18117: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 18117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47455,
    lat: 39.31271,
    lng: -86.95672,
    city: "Patricksburg",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61,
    density: 722.5,
    county_fips: 18119,
    county_name: "Owen",
    county_weights: {
      18119: 100,
    },
    county_names_all: "Owen",
    county_fips_all: 18119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47456,
    lat: 39.46314,
    lng: -86.69781,
    city: "Quincy",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1477,
    density: 20.5,
    county_fips: 18119,
    county_name: "Owen",
    county_weights: {
      18109: 19.77,
      18119: 66,
      18133: 14.23,
    },
    county_names_all: "Owen|Morgan|Putnam",
    county_fips_all: "18119|18109|18133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47457,
    lat: 38.91183,
    lng: -86.9047,
    city: "Scotland",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 146,
    density: 6164.8,
    county_fips: 18055,
    county_name: "Greene",
    county_weights: {
      18055: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 18055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47458,
    lat: 39.07044,
    lng: -86.50712,
    city: "Smithville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49,
    density: 1526.1,
    county_fips: 18105,
    county_name: "Monroe",
    county_weights: {
      18105: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 18105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47459,
    lat: 39.11167,
    lng: -86.75125,
    city: "Solsberry",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3935,
    density: 26,
    county_fips: 18055,
    county_name: "Greene",
    county_weights: {
      18055: 97.6,
      18119: 2.4,
    },
    county_names_all: "Greene|Owen",
    county_fips_all: "18055|18119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47460,
    lat: 39.28153,
    lng: -86.78951,
    city: "Spencer",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10780,
    density: 27.6,
    county_fips: 18119,
    county_name: "Owen",
    county_weights: {
      18055: 1.05,
      18105: 2.12,
      18119: 96.83,
    },
    county_names_all: "Owen|Monroe|Greene",
    county_fips_all: "18119|18105|18055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47462,
    lat: 38.95755,
    lng: -86.64815,
    city: "Springville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4814,
    density: 23.6,
    county_fips: 18093,
    county_name: "Lawrence",
    county_weights: {
      18055: 30.75,
      18093: 56.08,
      18105: 13.17,
    },
    county_names_all: "Lawrence|Greene|Monroe",
    county_fips_all: "18093|18055|18105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47464,
    lat: 39.29995,
    lng: -86.64979,
    city: "Stinesville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 323,
    density: 1076.1,
    county_fips: 18105,
    county_name: "Monroe",
    county_weights: {
      18105: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 18105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47465,
    lat: 39.05474,
    lng: -87.04338,
    city: "Switz City",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 431,
    density: 6.3,
    county_fips: 18055,
    county_name: "Greene",
    county_weights: {
      18055: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 18055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47467,
    lat: 38.76776,
    lng: -86.34463,
    city: "Tunnelton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 159,
    density: 3355.1,
    county_fips: 18093,
    county_name: "Lawrence",
    county_weights: {
      18093: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 18093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47468,
    lat: 39.27801,
    lng: -86.40482,
    city: "Unionville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1501,
    density: 19.1,
    county_fips: 18105,
    county_name: "Monroe",
    county_weights: {
      18013: 21.86,
      18105: 78.14,
    },
    county_names_all: "Monroe|Brown",
    county_fips_all: "18105|18013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47469,
    lat: 38.61892,
    lng: -86.61172,
    city: "West Baden Springs",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1623,
    density: 10,
    county_fips: 18117,
    county_name: "Orange",
    county_weights: {
      18117: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 18117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47470,
    lat: 38.81623,
    lng: -86.64799,
    city: "Williams",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1632,
    density: 14.4,
    county_fips: 18093,
    county_name: "Lawrence",
    county_weights: {
      18093: 82.2,
      18101: 17.8,
    },
    county_names_all: "Lawrence|Martin",
    county_fips_all: "18093|18101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47471,
    lat: 39.14253,
    lng: -86.99788,
    city: "Worthington",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3028,
    density: 18.2,
    county_fips: 18055,
    county_name: "Greene",
    county_weights: {
      18055: 78.93,
      18119: 21.07,
    },
    county_names_all: "Greene|Owen",
    county_fips_all: "18055|18119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47501,
    lat: 38.66139,
    lng: -87.17479,
    city: "Washington",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18737,
    density: 51.9,
    county_fips: 18027,
    county_name: "Daviess",
    county_weights: {
      18027: 100,
    },
    county_names_all: "Daviess",
    county_fips_all: 18027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47512,
    lat: 38.779,
    lng: -87.31809,
    city: "Bicknell",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3970,
    density: 32,
    county_fips: 18083,
    county_name: "Knox",
    county_weights: {
      18083: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 18083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47513,
    lat: 38.30405,
    lng: -86.6995,
    city: "Birdseye",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1915,
    density: 10.7,
    county_fips: 18037,
    county_name: "Dubois",
    county_weights: {
      18025: 26.28,
      18037: 51.94,
      18117: 4.63,
      18123: 17.15,
    },
    county_names_all: "Dubois|Crawford|Perry|Orange",
    county_fips_all: "18037|18025|18123|18117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47514,
    lat: 38.14861,
    lng: -86.59403,
    city: "Branchville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1488,
    density: 81.6,
    county_fips: 18123,
    county_name: "Perry",
    county_weights: {
      18123: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 18123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Tell_City",
  },
  {
    zip: 47515,
    lat: 38.17769,
    lng: -86.70226,
    city: "Bristow",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 835,
    density: 6.3,
    county_fips: 18123,
    county_name: "Perry",
    county_weights: {
      18123: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 18123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Tell_City",
  },
  {
    zip: 47516,
    lat: 38.7645,
    lng: -87.41857,
    city: "Bruceville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1266,
    density: 16.8,
    county_fips: 18083,
    county_name: "Knox",
    county_weights: {
      18083: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 18083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47519,
    lat: 38.5976,
    lng: -86.98793,
    city: "Cannelburg",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 587,
    density: 9.5,
    county_fips: 18027,
    county_name: "Daviess",
    county_weights: {
      18027: 100,
    },
    county_names_all: "Daviess",
    county_fips_all: 18027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47520,
    lat: 37.99351,
    lng: -86.5902,
    city: "Cannelton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2813,
    density: 13.4,
    county_fips: 18123,
    county_name: "Perry",
    county_weights: {
      18123: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 18123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Tell_City",
  },
  {
    zip: 47521,
    lat: 38.39238,
    lng: -86.72941,
    city: "Celestine",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 690,
    density: 12.2,
    county_fips: 18037,
    county_name: "Dubois",
    county_weights: {
      18037: 100,
    },
    county_names_all: "Dubois",
    county_fips_all: 18037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47522,
    lat: 38.88545,
    lng: -86.80543,
    city: "Crane",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 545,
    density: 9.8,
    county_fips: 18101,
    county_name: "Martin",
    county_weights: {
      18101: 100,
    },
    county_names_all: "Martin",
    county_fips_all: 18101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47523,
    lat: 38.17354,
    lng: -87.02934,
    city: "Dale",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3726,
    density: 21.6,
    county_fips: 18173,
    county_name: "Warrick",
    county_weights: {
      18037: 2.09,
      18147: 43.74,
      18173: 54.17,
    },
    county_names_all: "Warrick|Spencer|Dubois",
    county_fips_all: "18173|18147|18037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47524,
    lat: 38.48312,
    lng: -87.61733,
    city: "Decker",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 565,
    density: 4.8,
    county_fips: 18083,
    county_name: "Knox",
    county_weights: {
      18083: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 18083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47525,
    lat: 38.02856,
    lng: -86.55359,
    city: "Derby",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 298,
    density: 4.6,
    county_fips: 18123,
    county_name: "Perry",
    county_weights: {
      18123: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 18123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Tell_City",
  },
  {
    zip: 47527,
    lat: 38.47232,
    lng: -86.77772,
    city: "Dubois",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2348,
    density: 16.4,
    county_fips: 18037,
    county_name: "Dubois",
    county_weights: {
      18037: 98.81,
      18117: 1.19,
    },
    county_names_all: "Dubois|Orange",
    county_fips_all: "18037|18117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47528,
    lat: 38.84447,
    lng: -87.26806,
    city: "Edwardsport",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 516,
    density: 10.1,
    county_fips: 18083,
    county_name: "Knox",
    county_weights: {
      18083: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 18083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47529,
    lat: 38.86386,
    lng: -87.07804,
    city: "Elnora",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1208,
    density: 14.9,
    county_fips: 18027,
    county_name: "Daviess",
    county_weights: {
      18027: 94.66,
      18055: 5.34,
    },
    county_names_all: "Daviess|Greene",
    county_fips_all: "18027|18055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47531,
    lat: 38.04161,
    lng: -86.84867,
    city: "Evanston",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 837,
    density: 8.8,
    county_fips: 18147,
    county_name: "Spencer",
    county_weights: {
      18147: 100,
    },
    county_names_all: "Spencer",
    county_fips_all: 18147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47532,
    lat: 38.2198,
    lng: -86.86036,
    city: "Ferdinand",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4171,
    density: 22.4,
    county_fips: 18037,
    county_name: "Dubois",
    county_weights: {
      18037: 61.89,
      18123: 5.52,
      18147: 32.59,
    },
    county_names_all: "Dubois|Spencer|Perry",
    county_fips_all: "18037|18147|18123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47535,
    lat: 38.86265,
    lng: -87.31285,
    city: "Freelandville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 726,
    density: 58.4,
    county_fips: 18083,
    county_name: "Knox",
    county_weights: {
      18083: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 18083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47537,
    lat: 38.10971,
    lng: -87.06888,
    city: "Gentryville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 865,
    density: 16.4,
    county_fips: 18147,
    county_name: "Spencer",
    county_weights: {
      18147: 54.59,
      18173: 45.41,
    },
    county_names_all: "Spencer|Warrick",
    county_fips_all: "18147|18173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47541,
    lat: 38.23777,
    lng: -87.04673,
    city: "Holland",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1109,
    density: 20.7,
    county_fips: 18037,
    county_name: "Dubois",
    county_weights: {
      18037: 84.73,
      18125: 3.21,
      18147: 1.09,
      18173: 10.97,
    },
    county_names_all: "Dubois|Warrick|Pike|Spencer",
    county_fips_all: "18037|18173|18125|18147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47542,
    lat: 38.29928,
    lng: -86.96712,
    city: "Huntingburg",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9913,
    density: 48.2,
    county_fips: 18037,
    county_name: "Dubois",
    county_weights: {
      18037: 98.68,
      18125: 1.32,
    },
    county_names_all: "Dubois|Pike",
    county_fips_all: "18037|18125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47546,
    lat: 38.42071,
    lng: -86.93469,
    city: "Jasper",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21643,
    density: 68.7,
    county_fips: 18037,
    county_name: "Dubois",
    county_weights: {
      18037: 100,
    },
    county_names_all: "Dubois",
    county_fips_all: 18037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47550,
    lat: 38.06213,
    lng: -86.92877,
    city: "Lamar",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 610,
    density: 7,
    county_fips: 18147,
    county_name: "Spencer",
    county_weights: {
      18147: 100,
    },
    county_names_all: "Spencer",
    county_fips_all: 18147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47551,
    lat: 38.12153,
    lng: -86.56353,
    city: "Leopold",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 776,
    density: 10.2,
    county_fips: 18123,
    county_name: "Perry",
    county_weights: {
      18123: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 18123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Tell_City",
  },
  {
    zip: 47552,
    lat: 38.10862,
    lng: -86.99527,
    city: "Lincoln City",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 250,
    density: 15.1,
    county_fips: 18147,
    county_name: "Spencer",
    county_weights: {
      18147: 100,
    },
    county_names_all: "Spencer",
    county_fips_all: 18147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47553,
    lat: 38.65398,
    lng: -86.91108,
    city: "Loogootee",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8365,
    density: 23.3,
    county_fips: 18101,
    county_name: "Martin",
    county_weights: {
      18027: 39.31,
      18101: 60.69,
    },
    county_names_all: "Martin|Daviess",
    county_fips_all: "18101|18027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47557,
    lat: 38.57005,
    lng: -87.34132,
    city: "Monroe City",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1770,
    density: 14.5,
    county_fips: 18083,
    county_name: "Knox",
    county_weights: {
      18083: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 18083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47558,
    lat: 38.64506,
    lng: -87.04578,
    city: "Montgomery",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4667,
    density: 21,
    county_fips: 18027,
    county_name: "Daviess",
    county_weights: {
      18027: 100,
    },
    county_names_all: "Daviess",
    county_fips_all: 18027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47561,
    lat: 38.85705,
    lng: -87.43611,
    city: "Oaktown",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1644,
    density: 8.3,
    county_fips: 18083,
    county_name: "Knox",
    county_weights: {
      18083: 94.3,
      18153: 5.7,
    },
    county_names_all: "Knox|Sullivan",
    county_fips_all: "18083|18153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47562,
    lat: 38.83493,
    lng: -86.98268,
    city: "Odon",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4616,
    density: 27.1,
    county_fips: 18027,
    county_name: "Daviess",
    county_weights: {
      18027: 98.78,
      18101: 1.22,
    },
    county_names_all: "Daviess|Martin",
    county_fips_all: "18027|18101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47564,
    lat: 38.48166,
    lng: -87.09566,
    city: "Otwell",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1169,
    density: 11.7,
    county_fips: 18125,
    county_name: "Pike",
    county_weights: {
      18037: 26,
      18125: 74,
    },
    county_names_all: "Pike|Dubois",
    county_fips_all: "18125|18037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47567,
    lat: 38.46954,
    lng: -87.30554,
    city: "Petersburg",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6240,
    density: 20.9,
    county_fips: 18125,
    county_name: "Pike",
    county_weights: {
      18125: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 18125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Petersburg",
  },
  {
    zip: 47568,
    lat: 38.79121,
    lng: -87.13654,
    city: "Plainville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 650,
    density: 7.8,
    county_fips: 18027,
    county_name: "Daviess",
    county_weights: {
      18027: 100,
    },
    county_names_all: "Daviess",
    county_fips_all: 18027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47573,
    lat: 38.74418,
    lng: -87.322,
    city: "Ragsdale",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18083,
    county_name: "Knox",
    county_weights: {
      18083: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 18083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47574,
    lat: 37.95265,
    lng: -86.56323,
    city: "Rome",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 72,
    density: 1.6,
    county_fips: 18123,
    county_name: "Perry",
    county_weights: {
      18123: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 18123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Tell_City",
  },
  {
    zip: 47575,
    lat: 38.32314,
    lng: -86.81128,
    city: "Saint Anthony",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 827,
    density: 14.2,
    county_fips: 18037,
    county_name: "Dubois",
    county_weights: {
      18037: 100,
    },
    county_names_all: "Dubois",
    county_fips_all: 18037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47576,
    lat: 38.19089,
    lng: -86.58936,
    city: "Saint Croix",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 534,
    density: 7.7,
    county_fips: 18123,
    county_name: "Perry",
    county_weights: {
      18025: 17.07,
      18123: 82.93,
    },
    county_names_all: "Perry|Crawford",
    county_fips_all: "18123|18025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Tell_City",
  },
  {
    zip: 47577,
    lat: 38.15004,
    lng: -86.80766,
    city: "Saint Meinrad",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1105,
    density: 16.5,
    county_fips: 18147,
    county_name: "Spencer",
    county_weights: {
      18123: 41.5,
      18147: 58.5,
    },
    county_names_all: "Spencer|Perry",
    county_fips_all: "18147|18123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47578,
    lat: 38.89288,
    lng: -87.19055,
    city: "Sandborn",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 681,
    density: 6,
    county_fips: 18083,
    county_name: "Knox",
    county_weights: {
      18055: 32.88,
      18083: 67.12,
    },
    county_names_all: "Knox|Greene",
    county_fips_all: "18083|18055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47579,
    lat: 38.11149,
    lng: -86.91322,
    city: "Santa Claus",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2471,
    density: 83.1,
    county_fips: 18147,
    county_name: "Spencer",
    county_weights: {
      18147: 100,
    },
    county_names_all: "Spencer",
    county_fips_all: 18147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47580,
    lat: 38.35355,
    lng: -86.77008,
    city: "Schnellville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 417,
    density: 38.4,
    county_fips: 18037,
    county_name: "Dubois",
    county_weights: {
      18037: 100,
    },
    county_names_all: "Dubois",
    county_fips_all: 18037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47581,
    lat: 38.65972,
    lng: -86.76908,
    city: "Shoals",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3514,
    density: 9.6,
    county_fips: 18101,
    county_name: "Martin",
    county_weights: {
      18101: 100,
    },
    county_names_all: "Martin",
    county_fips_all: 18101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47584,
    lat: 38.25111,
    lng: -87.25797,
    city: "Spurgeon",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 121,
    density: 156,
    county_fips: 18125,
    county_name: "Pike",
    county_weights: {
      18125: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 18125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Petersburg",
  },
  {
    zip: 47585,
    lat: 38.26787,
    lng: -87.16617,
    city: "Stendal",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 871,
    density: 8.4,
    county_fips: 18125,
    county_name: "Pike",
    county_weights: {
      18125: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 18125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Petersburg",
  },
  {
    zip: 47586,
    lat: 38.03684,
    lng: -86.69297,
    city: "Tell City",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10989,
    density: 43.7,
    county_fips: 18123,
    county_name: "Perry",
    county_weights: {
      18123: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 18123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Tell_City",
  },
  {
    zip: 47588,
    lat: 38.06959,
    lng: -86.77826,
    city: "Troy",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 847,
    density: 21.1,
    county_fips: 18147,
    county_name: "Spencer",
    county_weights: {
      18123: 43.22,
      18147: 56.78,
    },
    county_names_all: "Spencer|Perry",
    county_fips_all: "18147|18123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Tell_City",
  },
  {
    zip: 47590,
    lat: 38.35314,
    lng: -87.10113,
    city: "Velpen",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 286,
    density: 2.7,
    county_fips: 18125,
    county_name: "Pike",
    county_weights: {
      18037: 14.53,
      18125: 85.47,
    },
    county_names_all: "Pike|Dubois",
    county_fips_all: "18125|18037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Petersburg",
  },
  {
    zip: 47591,
    lat: 38.62136,
    lng: -87.50594,
    city: "Vincennes",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25091,
    density: 58.2,
    county_fips: 18083,
    county_name: "Knox",
    county_weights: {
      18083: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 18083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47596,
    lat: 38.86318,
    lng: -87.23382,
    city: "Westphalia",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50,
    density: 4,
    county_fips: 18083,
    county_name: "Knox",
    county_weights: {
      18083: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 18083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47597,
    lat: 38.64745,
    lng: -87.29802,
    city: "Wheatland",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 799,
    density: 6.3,
    county_fips: 18083,
    county_name: "Knox",
    county_weights: {
      18083: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 18083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47598,
    lat: 38.3875,
    lng: -87.20711,
    city: "Winslow",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3130,
    density: 17.5,
    county_fips: 18125,
    county_name: "Pike",
    county_weights: {
      18125: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 18125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Petersburg",
  },
  {
    zip: 47601,
    lat: 38.05301,
    lng: -87.25526,
    city: "Boonville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13566,
    density: 41.1,
    county_fips: 18173,
    county_name: "Warrick",
    county_weights: {
      18147: 5.77,
      18173: 94.23,
    },
    county_names_all: "Warrick|Spencer",
    county_fips_all: "18173|18147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47610,
    lat: 38.06041,
    lng: -87.39988,
    city: "Chandler",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5089,
    density: 54.5,
    county_fips: 18173,
    county_name: "Warrick",
    county_weights: {
      18173: 100,
    },
    county_names_all: "Warrick",
    county_fips_all: 18173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47611,
    lat: 38.02474,
    lng: -87.05812,
    city: "Chrisney",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1346,
    density: 14,
    county_fips: 18147,
    county_name: "Spencer",
    county_weights: {
      18147: 100,
    },
    county_names_all: "Spencer",
    county_fips_all: 18147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47612,
    lat: 38.1946,
    lng: -87.70155,
    city: "Cynthiana",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 733,
    density: 17.5,
    county_fips: 18051,
    county_name: "Gibson",
    county_weights: {
      18051: 60.87,
      18129: 39.13,
    },
    county_names_all: "Gibson|Posey",
    county_fips_all: "18051|18129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47613,
    lat: 38.15413,
    lng: -87.42062,
    city: "Elberfeld",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3136,
    density: 23.1,
    county_fips: 18173,
    county_name: "Warrick",
    county_weights: {
      18051: 17.74,
      18173: 82.26,
    },
    county_names_all: "Warrick|Gibson",
    county_fips_all: "18173|18051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47615,
    lat: 37.97214,
    lng: -86.95643,
    city: "Grandview",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1873,
    density: 18.9,
    county_fips: 18147,
    county_name: "Spencer",
    county_weights: {
      18147: 100,
    },
    county_names_all: "Spencer",
    county_fips_all: 18147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47616,
    lat: 38.23482,
    lng: -87.91038,
    city: "Griffin",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 314,
    density: 2.7,
    county_fips: 18051,
    county_name: "Gibson",
    county_weights: {
      18051: 54.54,
      18129: 45.46,
    },
    county_names_all: "Gibson|Posey",
    county_fips_all: "18051|18129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47619,
    lat: 38.1924,
    lng: -87.30742,
    city: "Lynnville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1860,
    density: 18.7,
    county_fips: 18173,
    county_name: "Warrick",
    county_weights: {
      18051: 12.38,
      18125: 4.55,
      18173: 83.07,
    },
    county_names_all: "Warrick|Gibson|Pike",
    county_fips_all: "18173|18051|18125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47620,
    lat: 37.93284,
    lng: -87.90555,
    city: "Mount Vernon",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12589,
    density: 23.3,
    county_fips: 18129,
    county_name: "Posey",
    county_weights: {
      18129: 100,
    },
    county_names_all: "Posey",
    county_fips_all: 18129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47630,
    lat: 37.95615,
    lng: -87.35569,
    city: "Newburgh",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36863,
    density: 302.9,
    county_fips: 18173,
    county_name: "Warrick",
    county_weights: {
      18173: 100,
    },
    county_names_all: "Warrick",
    county_fips_all: 18173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47631,
    lat: 38.10082,
    lng: -87.90967,
    city: "New Harmony",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2194,
    density: 14.3,
    county_fips: 18129,
    county_name: "Posey",
    county_weights: {
      18129: 100,
    },
    county_names_all: "Posey",
    county_fips_all: 18129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47633,
    lat: 38.16835,
    lng: -87.78736,
    city: "Poseyville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2284,
    density: 14.4,
    county_fips: 18129,
    county_name: "Posey",
    county_weights: {
      18051: 10.41,
      18129: 88.96,
      18163: 0.63,
    },
    county_names_all: "Posey|Gibson|Vanderburgh",
    county_fips_all: "18129|18051|18163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47634,
    lat: 37.93893,
    lng: -87.1848,
    city: "Richland",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2660,
    density: 21.7,
    county_fips: 18147,
    county_name: "Spencer",
    county_weights: {
      18147: 100,
    },
    county_names_all: "Spencer",
    county_fips_all: 18147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47635,
    lat: 37.8862,
    lng: -87.10751,
    city: "Rockport",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5487,
    density: 24.4,
    county_fips: 18147,
    county_name: "Spencer",
    county_weights: {
      18147: 100,
    },
    county_names_all: "Spencer",
    county_fips_all: 18147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47637,
    lat: 38.13679,
    lng: -87.15865,
    city: "Tennyson",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1362,
    density: 8.6,
    county_fips: 18173,
    county_name: "Warrick",
    county_weights: {
      18147: 7.71,
      18173: 92.29,
    },
    county_names_all: "Warrick|Spencer",
    county_fips_all: "18173|18147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47638,
    lat: 38.06959,
    lng: -87.77489,
    city: "Wadesville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3727,
    density: 30.2,
    county_fips: 18129,
    county_name: "Posey",
    county_weights: {
      18129: 100,
    },
    county_names_all: "Posey",
    county_fips_all: 18129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47639,
    lat: 38.18228,
    lng: -87.57132,
    city: "Haubstadt",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4312,
    density: 36,
    county_fips: 18051,
    county_name: "Gibson",
    county_weights: {
      18051: 72.91,
      18163: 26.15,
      18173: 0.94,
    },
    county_names_all: "Gibson|Vanderburgh|Warrick",
    county_fips_all: "18051|18163|18173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47640,
    lat: 38.47708,
    lng: -87.49301,
    city: "Hazleton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 937,
    density: 9.4,
    county_fips: 18051,
    county_name: "Gibson",
    county_weights: {
      18051: 69.03,
      18125: 30.97,
    },
    county_names_all: "Gibson|Pike",
    county_fips_all: "18051|18125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Vincennes",
  },
  {
    zip: 47648,
    lat: 38.24611,
    lng: -87.54851,
    city: "Fort Branch",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4228,
    density: 34,
    county_fips: 18051,
    county_name: "Gibson",
    county_weights: {
      18051: 100,
    },
    county_names_all: "Gibson",
    county_fips_all: 18051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47649,
    lat: 38.35154,
    lng: -87.44786,
    city: "Francisco",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1607,
    density: 14,
    county_fips: 18051,
    county_name: "Gibson",
    county_weights: {
      18051: 100,
    },
    county_names_all: "Gibson",
    county_fips_all: 18051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47654,
    lat: 38.2534,
    lng: -87.391,
    city: "Mackey",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 101,
    density: 1165,
    county_fips: 18051,
    county_name: "Gibson",
    county_weights: {
      18051: 100,
    },
    county_names_all: "Gibson",
    county_fips_all: 18051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47660,
    lat: 38.29712,
    lng: -87.33191,
    city: "Oakland City",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5113,
    density: 22.7,
    county_fips: 18051,
    county_name: "Gibson",
    county_weights: {
      18051: 63.63,
      18125: 35.23,
      18173: 1.14,
    },
    county_names_all: "Gibson|Pike|Warrick",
    county_fips_all: "18051|18125|18173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Petersburg",
  },
  {
    zip: 47665,
    lat: 38.28016,
    lng: -87.72738,
    city: "Owensville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3829,
    density: 18.8,
    county_fips: 18051,
    county_name: "Gibson",
    county_weights: {
      18051: 100,
    },
    county_names_all: "Gibson",
    county_fips_all: 18051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47666,
    lat: 38.41922,
    lng: -87.60042,
    city: "Patoka",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1664,
    density: 13.1,
    county_fips: 18051,
    county_name: "Gibson",
    county_weights: {
      18051: 100,
    },
    county_names_all: "Gibson",
    county_fips_all: 18051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47670,
    lat: 38.34355,
    lng: -87.57797,
    city: "Princeton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12043,
    density: 56.7,
    county_fips: 18051,
    county_name: "Gibson",
    county_weights: {
      18051: 100,
    },
    county_names_all: "Gibson",
    county_fips_all: 18051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47683,
    lat: 38.27696,
    lng: -87.37744,
    city: "Somerville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 199,
    density: 1069.1,
    county_fips: 18051,
    county_name: "Gibson",
    county_weights: {
      18051: 100,
    },
    county_names_all: "Gibson",
    county_fips_all: 18051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47708,
    lat: 37.97387,
    lng: -87.57357,
    city: "Evansville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 496,
    density: 300.7,
    county_fips: 18163,
    county_name: "Vanderburgh",
    county_weights: {
      18163: 100,
    },
    county_names_all: "Vanderburgh",
    county_fips_all: 18163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47710,
    lat: 38.02518,
    lng: -87.57618,
    city: "Evansville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18906,
    density: 851.8,
    county_fips: 18163,
    county_name: "Vanderburgh",
    county_weights: {
      18163: 100,
    },
    county_names_all: "Vanderburgh",
    county_fips_all: 18163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47711,
    lat: 38.0157,
    lng: -87.53606,
    city: "Evansville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32961,
    density: 771.3,
    county_fips: 18163,
    county_name: "Vanderburgh",
    county_weights: {
      18163: 100,
    },
    county_names_all: "Vanderburgh",
    county_fips_all: 18163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47712,
    lat: 37.92869,
    lng: -87.65951,
    city: "Evansville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26921,
    density: 165.8,
    county_fips: 18163,
    county_name: "Vanderburgh",
    county_weights: {
      18129: 18.78,
      18163: 81.22,
    },
    county_names_all: "Vanderburgh|Posey",
    county_fips_all: "18163|18129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47713,
    lat: 37.9475,
    lng: -87.55432,
    city: "Evansville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10205,
    density: 794.5,
    county_fips: 18163,
    county_name: "Vanderburgh",
    county_weights: {
      18163: 100,
    },
    county_names_all: "Vanderburgh",
    county_fips_all: 18163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47714,
    lat: 37.95768,
    lng: -87.52102,
    city: "Evansville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34514,
    density: 1659.2,
    county_fips: 18163,
    county_name: "Vanderburgh",
    county_weights: {
      18163: 100,
    },
    county_names_all: "Vanderburgh",
    county_fips_all: 18163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47715,
    lat: 37.97229,
    lng: -87.48097,
    city: "Evansville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25827,
    density: 453.5,
    county_fips: 18163,
    county_name: "Vanderburgh",
    county_weights: {
      18163: 100,
    },
    county_names_all: "Vanderburgh",
    county_fips_all: 18163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47720,
    lat: 38.06065,
    lng: -87.64247,
    city: "Evansville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17565,
    density: 121.9,
    county_fips: 18163,
    county_name: "Vanderburgh",
    county_weights: {
      18163: 100,
    },
    county_names_all: "Vanderburgh",
    county_fips_all: 18163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47725,
    lat: 38.10721,
    lng: -87.52855,
    city: "Evansville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17703,
    density: 124,
    county_fips: 18163,
    county_name: "Vanderburgh",
    county_weights: {
      18051: 0.68,
      18163: 97.77,
      18173: 1.55,
    },
    county_names_all: "Vanderburgh|Warrick|Gibson",
    county_fips_all: "18163|18173|18051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47802,
    lat: 39.35153,
    lng: -87.4106,
    city: "Terre Haute",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33744,
    density: 82,
    county_fips: 18167,
    county_name: "Vigo",
    county_weights: {
      18021: 0.26,
      18167: 99.74,
    },
    county_names_all: "Vigo|Clay",
    county_fips_all: "18167|18021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47803,
    lat: 39.46433,
    lng: -87.30855,
    city: "Terre Haute",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21498,
    density: 248.4,
    county_fips: 18167,
    county_name: "Vigo",
    county_weights: {
      18167: 100,
    },
    county_names_all: "Vigo",
    county_fips_all: 18167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47804,
    lat: 39.49756,
    lng: -87.39031,
    city: "Terre Haute",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11418,
    density: 666.3,
    county_fips: 18167,
    county_name: "Vigo",
    county_weights: {
      18167: 100,
    },
    county_names_all: "Vigo",
    county_fips_all: 18167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47805,
    lat: 39.54768,
    lng: -87.32739,
    city: "Terre Haute",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12543,
    density: 92.8,
    county_fips: 18167,
    county_name: "Vigo",
    county_weights: {
      18167: 100,
    },
    county_names_all: "Vigo",
    county_fips_all: 18167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47807,
    lat: 39.47061,
    lng: -87.40262,
    city: "Terre Haute",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12550,
    density: 1279.6,
    county_fips: 18167,
    county_name: "Vigo",
    county_weights: {
      18167: 100,
    },
    county_names_all: "Vigo",
    county_fips_all: 18167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47809,
    lat: 39.47136,
    lng: -87.40986,
    city: "Terre Haute",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2325,
    density: 5739.7,
    county_fips: 18167,
    county_name: "Vigo",
    county_weights: {
      18167: 100,
    },
    county_names_all: "Vigo",
    county_fips_all: 18167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47831,
    lat: 39.66549,
    lng: -87.52177,
    city: "Blanford",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18165,
    county_name: "Vermillion",
    county_weights: {
      18165: 100,
    },
    county_names_all: "Vermillion",
    county_fips_all: 18165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47832,
    lat: 39.87879,
    lng: -87.25463,
    city: "Bloomingdale",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1261,
    density: 11.2,
    county_fips: 18121,
    county_name: "Parke",
    county_weights: {
      18121: 100,
    },
    county_names_all: "Parke",
    county_fips_all: 18121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47833,
    lat: 39.35841,
    lng: -86.97773,
    city: "Bowling Green",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 640,
    density: 6.2,
    county_fips: 18021,
    county_name: "Clay",
    county_weights: {
      18021: 57.34,
      18119: 42.66,
    },
    county_names_all: "Clay|Owen",
    county_fips_all: "18021|18119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47834,
    lat: 39.52423,
    lng: -87.12276,
    city: "Brazil",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18808,
    density: 47.1,
    county_fips: 18021,
    county_name: "Clay",
    county_weights: {
      18021: 78.79,
      18121: 12.13,
      18167: 9.08,
    },
    county_names_all: "Clay|Parke|Vigo",
    county_fips_all: "18021|18121|18167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47836,
    lat: 39.64924,
    lng: -87.17221,
    city: "Bridgeton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 18121,
    county_name: "Parke",
    county_weights: {
      18121: 100,
    },
    county_names_all: "Parke",
    county_fips_all: 18121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47837,
    lat: 39.62929,
    lng: -87.11281,
    city: "Carbon",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 944,
    density: 11.5,
    county_fips: 18121,
    county_name: "Parke",
    county_weights: {
      18021: 26.4,
      18121: 73.6,
    },
    county_names_all: "Parke|Clay",
    county_fips_all: "18121|18021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47838,
    lat: 38.95679,
    lng: -87.37812,
    city: "Carlisle",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3744,
    density: 13.9,
    county_fips: 18153,
    county_name: "Sullivan",
    county_weights: {
      18153: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 18153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47840,
    lat: 39.40863,
    lng: -87.05937,
    city: "Centerpoint",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2123,
    density: 16.4,
    county_fips: 18021,
    county_name: "Clay",
    county_weights: {
      18021: 95.35,
      18133: 4.65,
    },
    county_names_all: "Clay|Putnam",
    county_fips_all: "18021|18133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47841,
    lat: 39.27764,
    lng: -87.11492,
    city: "Clay City",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2670,
    density: 15.8,
    county_fips: 18021,
    county_name: "Clay",
    county_weights: {
      18021: 97.1,
      18119: 2.9,
    },
    county_names_all: "Clay|Owen",
    county_fips_all: "18021|18119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47842,
    lat: 39.67569,
    lng: -87.462,
    city: "Clinton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9693,
    density: 51.5,
    county_fips: 18165,
    county_name: "Vermillion",
    county_weights: {
      18165: 98.14,
      18167: 1.86,
    },
    county_names_all: "Vermillion|Vigo",
    county_fips_all: "18165|18167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47845,
    lat: 39.1936,
    lng: -87.23386,
    city: "Coalmont",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18021,
    county_name: "Clay",
    county_weights: {
      18021: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 18021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47846,
    lat: 39.36601,
    lng: -87.20041,
    city: "Cory",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 575,
    density: 6.7,
    county_fips: 18021,
    county_name: "Clay",
    county_weights: {
      18021: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 18021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47847,
    lat: 39.82293,
    lng: -87.48865,
    city: "Dana",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1118,
    density: 8.9,
    county_fips: 18165,
    county_name: "Vermillion",
    county_weights: {
      18165: 100,
    },
    county_names_all: "Vermillion",
    county_fips_all: 18165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47848,
    lat: 39.04159,
    lng: -87.26108,
    city: "Dugger",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1531,
    density: 36.3,
    county_fips: 18153,
    county_name: "Sullivan",
    county_weights: {
      18055: 12.62,
      18153: 87.38,
    },
    county_names_all: "Sullivan|Greene",
    county_fips_all: "18153|18055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47849,
    lat: 39.19196,
    lng: -87.56131,
    city: "Fairbanks",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 563,
    density: 9.5,
    county_fips: 18153,
    county_name: "Sullivan",
    county_weights: {
      18153: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 18153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47850,
    lat: 39.24441,
    lng: -87.43763,
    city: "Farmersburg",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2163,
    density: 16.1,
    county_fips: 18153,
    county_name: "Sullivan",
    county_weights: {
      18153: 75.48,
      18167: 24.52,
    },
    county_names_all: "Sullivan|Vigo",
    county_fips_all: "18153|18167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47851,
    lat: 39.5736,
    lng: -87.24594,
    city: "Fontanet",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18167,
    county_name: "Vigo",
    county_weights: {
      18167: 100,
    },
    county_names_all: "Vigo",
    county_fips_all: 18167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47853,
    lat: 39.53757,
    lng: -87.07277,
    city: "Harmony",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 129,
    density: 861.5,
    county_fips: 18021,
    county_name: "Clay",
    county_weights: {
      18021: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 18021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47854,
    lat: 39.80874,
    lng: -87.41299,
    city: "Hillsdale",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 531,
    density: 6,
    county_fips: 18165,
    county_name: "Vermillion",
    county_weights: {
      18165: 100,
    },
    county_names_all: "Vermillion",
    county_fips_all: 18165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47855,
    lat: 39.18844,
    lng: -87.30216,
    city: "Hymera",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 658,
    density: 231.1,
    county_fips: 18153,
    county_name: "Sullivan",
    county_weights: {
      18153: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 18153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47857,
    lat: 39.52403,
    lng: -87.09111,
    city: "Knightsville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 422,
    density: 325.7,
    county_fips: 18021,
    county_name: "Clay",
    county_weights: {
      18021: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 18021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47858,
    lat: 39.26268,
    lng: -87.22868,
    city: "Lewis",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1277,
    density: 16,
    county_fips: 18021,
    county_name: "Clay",
    county_weights: {
      18021: 61.4,
      18153: 13.69,
      18167: 24.91,
    },
    county_names_all: "Clay|Vigo|Sullivan",
    county_fips_all: "18021|18167|18153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47859,
    lat: 39.88595,
    lng: -87.16999,
    city: "Marshall",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1139,
    density: 10.3,
    county_fips: 18121,
    county_name: "Parke",
    county_weights: {
      18121: 100,
    },
    county_names_all: "Parke",
    county_fips_all: 18121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47860,
    lat: 39.72215,
    lng: -87.33013,
    city: "Mecca",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 605,
    density: 343.2,
    county_fips: 18121,
    county_name: "Parke",
    county_weights: {
      18121: 100,
    },
    county_names_all: "Parke",
    county_fips_all: 18121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47861,
    lat: 39.06528,
    lng: -87.56658,
    city: "Merom",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 608,
    density: 5.3,
    county_fips: 18153,
    county_name: "Sullivan",
    county_weights: {
      18153: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 18153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47862,
    lat: 39.77184,
    lng: -87.34527,
    city: "Montezuma",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1394,
    density: 13.5,
    county_fips: 18121,
    county_name: "Parke",
    county_weights: {
      18121: 100,
    },
    county_names_all: "Parke",
    county_fips_all: 18121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47863,
    lat: 39.57848,
    lng: -87.45921,
    city: "New Goshen",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 276,
    density: 1327.5,
    county_fips: 18167,
    county_name: "Vigo",
    county_weights: {
      18167: 100,
    },
    county_names_all: "Vigo",
    county_fips_all: 18167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47865,
    lat: 39.01908,
    lng: -87.39259,
    city: "Paxton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 116,
    density: 801,
    county_fips: 18153,
    county_name: "Sullivan",
    county_weights: {
      18153: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 18153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47866,
    lat: 39.28302,
    lng: -87.3247,
    city: "Pimento",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 504,
    density: 9.8,
    county_fips: 18167,
    county_name: "Vigo",
    county_weights: {
      18153: 14.97,
      18167: 85.03,
    },
    county_names_all: "Vigo|Sullivan",
    county_fips_all: "18167|18153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47868,
    lat: 39.40892,
    lng: -86.89822,
    city: "Poland",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3156,
    density: 21,
    county_fips: 18119,
    county_name: "Owen",
    county_weights: {
      18021: 13.93,
      18119: 81.22,
      18133: 4.85,
    },
    county_names_all: "Owen|Clay|Putnam",
    county_fips_all: "18119|18021|18133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47869,
    lat: 39.2751,
    lng: -87.49658,
    city: "Prairie Creek",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 114,
    density: 644.2,
    county_fips: 18167,
    county_name: "Vigo",
    county_weights: {
      18167: 100,
    },
    county_names_all: "Vigo",
    county_fips_all: 18167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47870,
    lat: 39.37016,
    lng: -87.47353,
    city: "Prairieton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18167,
    county_name: "Vigo",
    county_weights: {
      18167: 100,
    },
    county_names_all: "Vigo",
    county_fips_all: 18167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47871,
    lat: 39.38978,
    lng: -87.30026,
    city: "Riley",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 453,
    density: 2022.4,
    county_fips: 18167,
    county_name: "Vigo",
    county_weights: {
      18167: 100,
    },
    county_names_all: "Vigo",
    county_fips_all: 18167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47872,
    lat: 39.75331,
    lng: -87.16271,
    city: "Rockville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8290,
    density: 18.9,
    county_fips: 18121,
    county_name: "Parke",
    county_weights: {
      18121: 99.68,
      18133: 0.32,
    },
    county_names_all: "Parke|Putnam",
    county_fips_all: "18121|18133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47874,
    lat: 39.62913,
    lng: -87.27792,
    city: "Rosedale",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3356,
    density: 19.2,
    county_fips: 18121,
    county_name: "Parke",
    county_weights: {
      18021: 4.08,
      18121: 76.44,
      18167: 19.48,
    },
    county_names_all: "Parke|Vigo|Clay",
    county_fips_all: "18121|18167|18021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47875,
    lat: 39.71447,
    lng: -87.52222,
    city: "Saint Bernice",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18165,
    county_name: "Vermillion",
    county_weights: {
      18165: 100,
    },
    county_names_all: "Vermillion",
    county_fips_all: 18165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47876,
    lat: 39.50996,
    lng: -87.46113,
    city: "Saint Mary Of The Woods",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 340,
    density: 467.7,
    county_fips: 18167,
    county_name: "Vigo",
    county_weights: {
      18167: 100,
    },
    county_names_all: "Vigo",
    county_fips_all: 18167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47879,
    lat: 39.18863,
    lng: -87.37619,
    city: "Shelburn",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3430,
    density: 21.4,
    county_fips: 18153,
    county_name: "Sullivan",
    county_weights: {
      18021: 0.98,
      18153: 99.02,
    },
    county_names_all: "Sullivan|Clay",
    county_fips_all: "18153|18021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47880,
    lat: 39.59976,
    lng: -87.41885,
    city: "Shepardsville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 71,
    density: 1162.1,
    county_fips: 18167,
    county_name: "Vigo",
    county_weights: {
      18167: 100,
    },
    county_names_all: "Vigo",
    county_fips_all: 18167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47881,
    lat: 39.48722,
    lng: -87.19029,
    city: "Staunton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 346,
    density: 902,
    county_fips: 18021,
    county_name: "Clay",
    county_weights: {
      18021: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 18021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47882,
    lat: 39.09034,
    lng: -87.41186,
    city: "Sullivan",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7746,
    density: 21.1,
    county_fips: 18153,
    county_name: "Sullivan",
    county_weights: {
      18153: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 18153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47884,
    lat: 39.62308,
    lng: -87.45362,
    city: "Universal",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 232,
    density: 260.2,
    county_fips: 18165,
    county_name: "Vermillion",
    county_weights: {
      18165: 100,
    },
    county_names_all: "Vermillion",
    county_fips_all: 18165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47885,
    lat: 39.50872,
    lng: -87.47679,
    city: "West Terre Haute",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8931,
    density: 41.7,
    county_fips: 18167,
    county_name: "Vigo",
    county_weights: {
      18167: 100,
    },
    county_names_all: "Vigo",
    county_fips_all: 18167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47901,
    lat: 40.4178,
    lng: -86.88995,
    city: "Lafayette",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3970,
    density: 2554.5,
    county_fips: 18157,
    county_name: "Tippecanoe",
    county_weights: {
      18157: 100,
    },
    county_names_all: "Tippecanoe",
    county_fips_all: 18157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47904,
    lat: 40.43835,
    lng: -86.87609,
    city: "Lafayette",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16484,
    density: 1103.7,
    county_fips: 18157,
    county_name: "Tippecanoe",
    county_weights: {
      18157: 100,
    },
    county_names_all: "Tippecanoe",
    county_fips_all: 18157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47905,
    lat: 40.4218,
    lng: -86.76418,
    city: "Lafayette",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42907,
    density: 137.6,
    county_fips: 18157,
    county_name: "Tippecanoe",
    county_weights: {
      18015: 1.44,
      18023: 0.48,
      18157: 98.08,
    },
    county_names_all: "Tippecanoe|Carroll|Clinton",
    county_fips_all: "18157|18015|18023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47906,
    lat: 40.48541,
    lng: -86.98584,
    city: "West Lafayette",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 78767,
    density: 227.7,
    county_fips: 18157,
    county_name: "Tippecanoe",
    county_weights: {
      18157: 92.77,
      18171: 3.29,
      18181: 3.94,
    },
    county_names_all: "Tippecanoe|White|Warren",
    county_fips_all: "18157|18181|18171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47907,
    lat: 40.42474,
    lng: -86.91665,
    city: "West Lafayette",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 18157,
    county_name: "Tippecanoe",
    county_weights: {
      18157: 100,
    },
    county_names_all: "Tippecanoe",
    county_fips_all: 18157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47909,
    lat: 40.32357,
    lng: -86.89933,
    city: "Lafayette",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43328,
    density: 141.7,
    county_fips: 18157,
    county_name: "Tippecanoe",
    county_weights: {
      18157: 100,
    },
    county_names_all: "Tippecanoe",
    county_fips_all: 18157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47916,
    lat: 39.98343,
    lng: -87.05524,
    city: "Alamo",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69,
    density: 427.9,
    county_fips: 18107,
    county_name: "Montgomery",
    county_weights: {
      18107: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 18107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47917,
    lat: 40.46881,
    lng: -87.47633,
    city: "Ambia",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 435,
    density: 4.6,
    county_fips: 18171,
    county_name: "Warren",
    county_weights: {
      18007: 40.9,
      18171: 59.1,
    },
    county_names_all: "Warren|Benton",
    county_fips_all: "18171|18007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47918,
    lat: 40.30388,
    lng: -87.20628,
    city: "Attica",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5719,
    density: 15.8,
    county_fips: 18045,
    county_name: "Fountain",
    county_weights: {
      18045: 59.57,
      18157: 2.42,
      18171: 38.01,
    },
    county_names_all: "Fountain|Warren|Tippecanoe",
    county_fips_all: "18045|18171|18157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47920,
    lat: 40.54712,
    lng: -86.8195,
    city: "Battle Ground",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2592,
    density: 35.7,
    county_fips: 18157,
    county_name: "Tippecanoe",
    county_weights: {
      18015: 3.85,
      18157: 76.53,
      18181: 19.62,
    },
    county_names_all: "Tippecanoe|White|Carroll",
    county_fips_all: "18157|18181|18015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47921,
    lat: 40.47838,
    lng: -87.37485,
    city: "Boswell",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1233,
    density: 11.4,
    county_fips: 18007,
    county_name: "Benton",
    county_weights: {
      18007: 52.53,
      18171: 47.47,
    },
    county_names_all: "Benton|Warren",
    county_fips_all: "18007|18171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47922,
    lat: 40.8762,
    lng: -87.35369,
    city: "Brook",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1551,
    density: 8.8,
    county_fips: 18111,
    county_name: "Newton",
    county_weights: {
      18073: 8.55,
      18111: 91.45,
    },
    county_names_all: "Newton|Jasper",
    county_fips_all: "18111|18073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47923,
    lat: 40.61015,
    lng: -86.92667,
    city: "Brookston",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3289,
    density: 14,
    county_fips: 18181,
    county_name: "White",
    county_weights: {
      18015: 2.89,
      18181: 97.11,
    },
    county_names_all: "White|Carroll",
    county_fips_all: "18181|18015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47924,
    lat: 40.48991,
    lng: -86.75759,
    city: "Buck Creek",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 257,
    density: 421.1,
    county_fips: 18157,
    county_name: "Tippecanoe",
    county_weights: {
      18157: 100,
    },
    county_names_all: "Tippecanoe",
    county_fips_all: 18157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47925,
    lat: 40.88205,
    lng: -86.74477,
    city: "Buffalo",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 164,
    density: 1703.9,
    county_fips: 18181,
    county_name: "White",
    county_weights: {
      18181: 100,
    },
    county_names_all: "White",
    county_fips_all: 18181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47926,
    lat: 40.77789,
    lng: -86.59707,
    city: "Burnettsville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1362,
    density: 14.1,
    county_fips: 18181,
    county_name: "White",
    county_weights: {
      18015: 36.67,
      18181: 63.33,
    },
    county_names_all: "White|Carroll",
    county_fips_all: "18181|18015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47928,
    lat: 39.93237,
    lng: -87.46501,
    city: "Cayuga",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2083,
    density: 18.8,
    county_fips: 18165,
    county_name: "Vermillion",
    county_weights: {
      18165: 100,
    },
    county_names_all: "Vermillion",
    county_fips_all: 18165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47929,
    lat: 40.67587,
    lng: -86.9185,
    city: "Chalmers",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 701,
    density: 6.2,
    county_fips: 18181,
    county_name: "White",
    county_weights: {
      18181: 100,
    },
    county_names_all: "White",
    county_fips_all: 18181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47930,
    lat: 40.23764,
    lng: -86.74137,
    city: "Clarks Hill",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1303,
    density: 19.5,
    county_fips: 18157,
    county_name: "Tippecanoe",
    county_weights: {
      18023: 1.19,
      18107: 17.6,
      18157: 81.21,
    },
    county_names_all: "Tippecanoe|Montgomery|Clinton",
    county_fips_all: "18157|18107|18023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47932,
    lat: 40.12764,
    lng: -87.40761,
    city: "Covington",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5201,
    density: 18.9,
    county_fips: 18045,
    county_name: "Fountain",
    county_weights: {
      18045: 63.78,
      18165: 16.96,
      18171: 19.26,
    },
    county_names_all: "Fountain|Warren|Vermillion",
    county_fips_all: "18045|18171|18165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47933,
    lat: 40.03728,
    lng: -86.90234,
    city: "Crawfordsville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27780,
    density: 45.5,
    county_fips: 18107,
    county_name: "Montgomery",
    county_weights: {
      18011: 0.43,
      18045: 1.37,
      18107: 98.2,
    },
    county_names_all: "Montgomery|Fountain|Boone",
    county_fips_all: "18107|18045|18011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47940,
    lat: 40.11749,
    lng: -86.7447,
    city: "Darlington",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1686,
    density: 15.8,
    county_fips: 18107,
    county_name: "Montgomery",
    county_weights: {
      18107: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 18107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47941,
    lat: 40.37539,
    lng: -86.77128,
    city: "Dayton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1201,
    density: 557.2,
    county_fips: 18157,
    county_name: "Tippecanoe",
    county_weights: {
      18157: 100,
    },
    county_names_all: "Tippecanoe",
    county_fips_all: 18157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47942,
    lat: 40.68791,
    lng: -87.4472,
    city: "Earl Park",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 660,
    density: 4.3,
    county_fips: 18007,
    county_name: "Benton",
    county_weights: {
      18007: 95.73,
      18111: 4.27,
    },
    county_names_all: "Benton|Newton",
    county_fips_all: "18007|18111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47943,
    lat: 41.0594,
    lng: -87.28006,
    city: "Fair Oaks",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1096,
    density: 6.4,
    county_fips: 18111,
    county_name: "Newton",
    county_weights: {
      18073: 45.12,
      18111: 54.88,
    },
    county_names_all: "Newton|Jasper",
    county_fips_all: "18111|18073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47944,
    lat: 40.61067,
    lng: -87.32804,
    city: "Fowler",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3536,
    density: 7.2,
    county_fips: 18007,
    county_name: "Benton",
    county_weights: {
      18007: 97.59,
      18171: 1.88,
      18181: 0.53,
    },
    county_names_all: "Benton|Warren|White",
    county_fips_all: "18007|18171|18181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47946,
    lat: 40.98427,
    lng: -86.87014,
    city: "Francesville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2091,
    density: 8.8,
    county_fips: 18131,
    county_name: "Pulaski",
    county_weights: {
      18073: 19.34,
      18131: 80.66,
    },
    county_names_all: "Pulaski|Jasper",
    county_fips_all: "18131|18073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Winamac",
  },
  {
    zip: 47948,
    lat: 40.77638,
    lng: -87.28676,
    city: "Goodland",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1410,
    density: 9.3,
    county_fips: 18111,
    county_name: "Newton",
    county_weights: {
      18007: 17.5,
      18073: 28.12,
      18111: 54.38,
    },
    county_names_all: "Newton|Jasper|Benton",
    county_fips_all: "18111|18073|18007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47949,
    lat: 40.06288,
    lng: -87.13504,
    city: "Hillsboro",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1107,
    density: 10.4,
    county_fips: 18045,
    county_name: "Fountain",
    county_weights: {
      18045: 96.71,
      18107: 3.29,
    },
    county_names_all: "Fountain|Montgomery",
    county_fips_all: "18045|18107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47950,
    lat: 40.80175,
    lng: -86.65355,
    city: "Idaville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 842,
    density: 9,
    county_fips: 18181,
    county_name: "White",
    county_weights: {
      18015: 9.76,
      18181: 90.24,
    },
    county_names_all: "White|Carroll",
    county_fips_all: "18181|18015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47951,
    lat: 40.79049,
    lng: -87.4435,
    city: "Kentland",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2386,
    density: 15.5,
    county_fips: 18111,
    county_name: "Newton",
    county_weights: {
      18111: 100,
    },
    county_names_all: "Newton",
    county_fips_all: 18111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47952,
    lat: 39.96186,
    lng: -87.30049,
    city: "Kingman",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2917,
    density: 10.2,
    county_fips: 18045,
    county_name: "Fountain",
    county_weights: {
      18045: 65.54,
      18121: 34.46,
    },
    county_names_all: "Fountain|Parke",
    county_fips_all: "18045|18121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47954,
    lat: 39.90048,
    lng: -86.8178,
    city: "Ladoga",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2368,
    density: 14,
    county_fips: 18107,
    county_name: "Montgomery",
    county_weights: {
      18107: 94.4,
      18133: 5.6,
    },
    county_names_all: "Montgomery|Putnam",
    county_fips_all: "18107|18133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47955,
    lat: 40.1954,
    lng: -86.86513,
    city: "Linden",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 920,
    density: 13.6,
    county_fips: 18107,
    county_name: "Montgomery",
    county_weights: {
      18107: 88.44,
      18157: 11.56,
    },
    county_names_all: "Montgomery|Tippecanoe",
    county_fips_all: "18107|18157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47957,
    lat: 41.08937,
    lng: -86.8772,
    city: "Medaryville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2169,
    density: 13.9,
    county_fips: 18131,
    county_name: "Pulaski",
    county_weights: {
      18073: 13.63,
      18131: 86.37,
    },
    county_names_all: "Pulaski|Jasper",
    county_fips_all: "18131|18073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Winamac",
  },
  {
    zip: 47958,
    lat: 40.16452,
    lng: -87.14862,
    city: "Mellott",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 157,
    density: 194.8,
    county_fips: 18045,
    county_name: "Fountain",
    county_weights: {
      18045: 100,
    },
    county_names_all: "Fountain",
    county_fips_all: 18045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47959,
    lat: 40.86603,
    lng: -86.89786,
    city: "Monon",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2630,
    density: 14.9,
    county_fips: 18181,
    county_name: "White",
    county_weights: {
      18073: 11.71,
      18131: 3.06,
      18181: 85.23,
    },
    county_names_all: "White|Jasper|Pulaski",
    county_fips_all: "18181|18073|18131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47960,
    lat: 40.78261,
    lng: -86.74938,
    city: "Monticello",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14735,
    density: 48.1,
    county_fips: 18181,
    county_name: "White",
    county_weights: {
      18015: 15.58,
      18131: 0.26,
      18181: 84.16,
    },
    county_names_all: "White|Carroll|Pulaski",
    county_fips_all: "18181|18015|18131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47963,
    lat: 40.96811,
    lng: -87.44371,
    city: "Morocco",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2305,
    density: 8.5,
    county_fips: 18111,
    county_name: "Newton",
    county_weights: {
      18111: 100,
    },
    county_names_all: "Newton",
    county_fips_all: 18111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47964,
    lat: 40.9523,
    lng: -87.2996,
    city: "Mount Ayr",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 100,
    density: 257.7,
    county_fips: 18111,
    county_name: "Newton",
    county_weights: {
      18111: 100,
    },
    county_names_all: "Newton",
    county_fips_all: 18111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47965,
    lat: 39.95452,
    lng: -86.91996,
    city: "New Market",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 639,
    density: 624.7,
    county_fips: 18107,
    county_name: "Montgomery",
    county_weights: {
      18107: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 18107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47966,
    lat: 39.88843,
    lng: -87.41433,
    city: "Newport",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 301,
    density: 83.1,
    county_fips: 18165,
    county_name: "Vermillion",
    county_weights: {
      18165: 100,
    },
    county_names_all: "Vermillion",
    county_fips_all: 18165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47967,
    lat: 40.1942,
    lng: -86.99899,
    city: "New Richmond",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 722,
    density: 8.3,
    county_fips: 18107,
    county_name: "Montgomery",
    county_weights: {
      18107: 77.08,
      18157: 22.92,
    },
    county_names_all: "Montgomery|Tippecanoe",
    county_fips_all: "18107|18157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47968,
    lat: 39.96209,
    lng: -86.74542,
    city: "New Ross",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1228,
    density: 18.2,
    county_fips: 18107,
    county_name: "Montgomery",
    county_weights: {
      18011: 10.48,
      18063: 1.41,
      18107: 88.11,
    },
    county_names_all: "Montgomery|Boone|Hendricks",
    county_fips_all: "18107|18011|18063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47969,
    lat: 40.20355,
    lng: -87.14892,
    city: "Newtown",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 109,
    density: 105,
    county_fips: 18045,
    county_name: "Fountain",
    county_weights: {
      18045: 100,
    },
    county_names_all: "Fountain",
    county_fips_all: 18045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47970,
    lat: 40.47423,
    lng: -87.13031,
    city: "Otterbein",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1956,
    density: 12.5,
    county_fips: 18171,
    county_name: "Warren",
    county_weights: {
      18007: 46.17,
      18157: 3.63,
      18171: 48.54,
      18181: 1.66,
    },
    county_names_all: "Warren|Benton|Tippecanoe|White",
    county_fips_all: "18171|18007|18157|18181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47971,
    lat: 40.52946,
    lng: -87.23751,
    city: "Oxford",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1839,
    density: 12.7,
    county_fips: 18007,
    county_name: "Benton",
    county_weights: {
      18007: 100,
    },
    county_names_all: "Benton",
    county_fips_all: 18007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47974,
    lat: 40.04297,
    lng: -87.47356,
    city: "Perrysville",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1087,
    density: 10.5,
    county_fips: 18165,
    county_name: "Vermillion",
    county_weights: {
      18165: 100,
    },
    county_names_all: "Vermillion",
    county_fips_all: 18165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47975,
    lat: 40.44436,
    lng: -87.25348,
    city: "Pine Village",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 612,
    density: 6,
    county_fips: 18171,
    county_name: "Warren",
    county_weights: {
      18007: 4.33,
      18171: 95.67,
    },
    county_names_all: "Warren|Benton",
    county_fips_all: "18171|18007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47977,
    lat: 40.76132,
    lng: -87.15786,
    city: "Remington",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2728,
    density: 12.1,
    county_fips: 18073,
    county_name: "Jasper",
    county_weights: {
      18007: 35.62,
      18073: 61.58,
      18181: 2.8,
    },
    county_names_all: "Jasper|Benton|White",
    county_fips_all: "18073|18007|18181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47978,
    lat: 40.97991,
    lng: -87.1163,
    city: "Rensselaer",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11214,
    density: 16.4,
    county_fips: 18073,
    county_name: "Jasper",
    county_weights: {
      18073: 96.54,
      18111: 2.3,
      18181: 1.16,
    },
    county_names_all: "Jasper|Newton|White",
    county_fips_all: "18073|18111|18181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 47980,
    lat: 40.75393,
    lng: -86.90131,
    city: "Reynolds",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1041,
    density: 7.4,
    county_fips: 18181,
    county_name: "White",
    county_weights: {
      18181: 100,
    },
    county_names_all: "White",
    county_fips_all: 18181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47981,
    lat: 40.24599,
    lng: -86.93128,
    city: "Romney",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1043,
    density: 11.6,
    county_fips: 18157,
    county_name: "Tippecanoe",
    county_weights: {
      18107: 1.84,
      18157: 98.16,
    },
    county_names_all: "Tippecanoe|Montgomery",
    county_fips_all: "18157|18107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47982,
    lat: 40.19728,
    lng: -87.5268,
    city: "State Line",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 138,
    density: 406.1,
    county_fips: 18171,
    county_name: "Warren",
    county_weights: {
      18171: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 18171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47983,
    lat: 40.28633,
    lng: -86.77345,
    city: "Stockwell",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 103,
    density: 341.6,
    county_fips: 18157,
    county_name: "Tippecanoe",
    county_weights: {
      18157: 100,
    },
    county_names_all: "Tippecanoe",
    county_fips_all: 18157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47986,
    lat: 40.51384,
    lng: -87.20719,
    city: "Templeton",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 18007,
    county_name: "Benton",
    county_weights: {
      18007: 100,
    },
    county_names_all: "Benton",
    county_fips_all: 18007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47987,
    lat: 40.11916,
    lng: -87.23428,
    city: "Veedersburg",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4182,
    density: 14,
    county_fips: 18045,
    county_name: "Fountain",
    county_weights: {
      18045: 100,
    },
    county_names_all: "Fountain",
    county_fips_all: 18045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47989,
    lat: 39.88871,
    lng: -87.05243,
    city: "Waveland",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1071,
    density: 10.3,
    county_fips: 18107,
    county_name: "Montgomery",
    county_weights: {
      18107: 65.36,
      18121: 32.85,
      18133: 1.79,
    },
    county_names_all: "Montgomery|Parke|Putnam",
    county_fips_all: "18107|18121|18133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47990,
    lat: 40.06118,
    lng: -87.05952,
    city: "Waynetown",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1731,
    density: 15,
    county_fips: 18107,
    county_name: "Montgomery",
    county_weights: {
      18045: 9.34,
      18107: 90.66,
    },
    county_names_all: "Montgomery|Fountain",
    county_fips_all: "18107|18045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47991,
    lat: 40.28034,
    lng: -87.44794,
    city: "West Lebanon",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1180,
    density: 15.3,
    county_fips: 18171,
    county_name: "Warren",
    county_weights: {
      18171: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 18171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47992,
    lat: 40.31933,
    lng: -87.0519,
    city: "Westpoint",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1405,
    density: 15,
    county_fips: 18157,
    county_name: "Tippecanoe",
    county_weights: {
      18157: 100,
    },
    county_names_all: "Tippecanoe",
    county_fips_all: 18157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47993,
    lat: 40.31161,
    lng: -87.41603,
    city: "Williamsport",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3360,
    density: 9,
    county_fips: 18171,
    county_name: "Warren",
    county_weights: {
      18171: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 18171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47994,
    lat: 40.18233,
    lng: -87.08231,
    city: "Wingate",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 349,
    density: 6.2,
    county_fips: 18107,
    county_name: "Montgomery",
    county_weights: {
      18045: 38.46,
      18107: 61.54,
    },
    county_names_all: "Montgomery|Fountain",
    county_fips_all: "18107|18045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47995,
    lat: 40.75861,
    lng: -87.0329,
    city: "Wolcott",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2002,
    density: 9.4,
    county_fips: 18181,
    county_name: "White",
    county_weights: {
      18007: 2.38,
      18073: 1.77,
      18181: 95.85,
    },
    county_names_all: "White|Benton|Jasper",
    county_fips_all: "18181|18007|18073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 47997,
    lat: 40.66769,
    lng: -86.72379,
    city: "Yeoman",
    state_id: "IN",
    state_name: "Indiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 158,
    density: 479.8,
    county_fips: 18015,
    county_name: "Carroll",
    county_weights: {
      18015: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 18015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    zip: 48001,
    lat: 42.63732,
    lng: -82.57949,
    city: "Algonac",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11901,
    density: 241.5,
    county_fips: 26147,
    county_name: "St. Clair",
    county_weights: {
      26147: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 26147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48002,
    lat: 42.93916,
    lng: -82.92601,
    city: "Allenton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3205,
    density: 33.3,
    county_fips: 26147,
    county_name: "St. Clair",
    county_weights: {
      26147: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 26147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48003,
    lat: 42.93228,
    lng: -83.04088,
    city: "Almont",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5837,
    density: 67.8,
    county_fips: 26087,
    county_name: "Lapeer",
    county_weights: {
      26087: 100,
    },
    county_names_all: "Lapeer",
    county_fips_all: 26087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48005,
    lat: 42.85022,
    lng: -82.92317,
    city: "Armada",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5515,
    density: 58.3,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48006,
    lat: 43.0754,
    lng: -82.69642,
    city: "Avoca",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4038,
    density: 21.8,
    county_fips: 26147,
    county_name: "St. Clair",
    county_weights: {
      26147: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 26147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48009,
    lat: 42.54381,
    lng: -83.21765,
    city: "Birmingham",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21277,
    density: 1654.8,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48014,
    lat: 43.02466,
    lng: -82.93115,
    city: "Capac",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4168,
    density: 43.8,
    county_fips: 26147,
    county_name: "St. Clair",
    county_weights: {
      26087: 3.8,
      26147: 96.2,
    },
    county_names_all: "St. Clair|Lapeer",
    county_fips_all: "26147|26087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48015,
    lat: 42.48055,
    lng: -83.02743,
    city: "Center Line",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8212,
    density: 1809.2,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48017,
    lat: 42.53669,
    lng: -83.15039,
    city: "Clawson",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11852,
    density: 2083.7,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48021,
    lat: 42.46567,
    lng: -82.94598,
    city: "Eastpointe",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32149,
    density: 2410.6,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48022,
    lat: 43.02824,
    lng: -82.81111,
    city: "Emmett",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2622,
    density: 28.7,
    county_fips: 26147,
    county_name: "St. Clair",
    county_weights: {
      26147: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 26147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48023,
    lat: 42.70102,
    lng: -82.6593,
    city: "Fair Haven",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5089,
    density: 115.3,
    county_fips: 26147,
    county_name: "St. Clair",
    county_weights: {
      26147: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 26147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48025,
    lat: 42.52032,
    lng: -83.26744,
    city: "Franklin",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14777,
    density: 709.5,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48026,
    lat: 42.53879,
    lng: -82.94964,
    city: "Fraser",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14503,
    density: 1352.2,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48027,
    lat: 42.94466,
    lng: -82.68217,
    city: "Goodells",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3178,
    density: 32.8,
    county_fips: 26147,
    county_name: "St. Clair",
    county_weights: {
      26147: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 26147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48028,
    lat: 42.58947,
    lng: -82.61948,
    city: "Harsens Island",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1026,
    density: 22.3,
    county_fips: 26147,
    county_name: "St. Clair",
    county_weights: {
      26147: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 26147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48030,
    lat: 42.46193,
    lng: -83.09769,
    city: "Hazel Park",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16452,
    density: 2254.1,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48032,
    lat: 43.13278,
    lng: -82.59457,
    city: "Jeddo",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1763,
    density: 18.5,
    county_fips: 26147,
    county_name: "St. Clair",
    county_weights: {
      26147: 80.38,
      26151: 19.62,
    },
    county_names_all: "St. Clair|Sanilac",
    county_fips_all: "26147|26151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48033,
    lat: 42.46478,
    lng: -83.28812,
    city: "Southfield",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17247,
    density: 729.6,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48034,
    lat: 42.49689,
    lng: -83.29102,
    city: "Southfield",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14213,
    density: 1276.4,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48035,
    lat: 42.55615,
    lng: -82.90948,
    city: "Clinton Township",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35279,
    density: 1549.5,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48036,
    lat: 42.59227,
    lng: -82.89971,
    city: "Clinton Township",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20752,
    density: 959.9,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48038,
    lat: 42.6054,
    lng: -82.94152,
    city: "Clinton Township",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44322,
    density: 1569.2,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48039,
    lat: 42.69664,
    lng: -82.55052,
    city: "Marine City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7556,
    density: 126.8,
    county_fips: 26147,
    county_name: "St. Clair",
    county_weights: {
      26147: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 26147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48040,
    lat: 42.90983,
    lng: -82.48022,
    city: "Marysville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9695,
    density: 541.6,
    county_fips: 26147,
    county_name: "St. Clair",
    county_weights: {
      26147: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 26147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48041,
    lat: 42.93861,
    lng: -82.80271,
    city: "Memphis",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4370,
    density: 42.2,
    county_fips: 26147,
    county_name: "St. Clair",
    county_weights: {
      26099: 3.21,
      26147: 96.79,
    },
    county_names_all: "St. Clair|Macomb",
    county_fips_all: "26147|26099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48042,
    lat: 42.68673,
    lng: -82.90857,
    city: "Macomb",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31558,
    density: 535.5,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48043,
    lat: 42.59763,
    lng: -82.88208,
    city: "Mount Clemens",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16212,
    density: 1535.3,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48044,
    lat: 42.64988,
    lng: -82.9296,
    city: "Macomb",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58675,
    density: 1678.6,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48045,
    lat: 42.59121,
    lng: -82.83017,
    city: "Harrison Township",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24949,
    density: 675.9,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48047,
    lat: 42.67754,
    lng: -82.77744,
    city: "New Baltimore",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41119,
    density: 881.5,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48048,
    lat: 42.7417,
    lng: -82.79558,
    city: "New Haven",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8005,
    density: 153.7,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48049,
    lat: 43.0361,
    lng: -82.57504,
    city: "North Street",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5434,
    density: 58.8,
    county_fips: 26147,
    county_name: "St. Clair",
    county_weights: {
      26147: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 26147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48050,
    lat: 42.78486,
    lng: -82.80139,
    city: "New Haven",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1443,
    density: 30,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48051,
    lat: 42.69067,
    lng: -82.82582,
    city: "New Baltimore",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18620,
    density: 506.7,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48054,
    lat: 42.77054,
    lng: -82.54515,
    city: "East China",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7163,
    density: 68.1,
    county_fips: 26147,
    county_name: "St. Clair",
    county_weights: {
      26147: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 26147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48059,
    lat: 43.08253,
    lng: -82.49913,
    city: "Fort Gratiot",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14953,
    density: 182.2,
    county_fips: 26147,
    county_name: "St. Clair",
    county_weights: {
      26147: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 26147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48060,
    lat: 42.97835,
    lng: -82.46297,
    city: "Port Huron",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39269,
    density: 731,
    county_fips: 26147,
    county_name: "St. Clair",
    county_weights: {
      26147: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 26147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48062,
    lat: 42.84899,
    lng: -82.79989,
    city: "Richmond",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9655,
    density: 94.4,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48063,
    lat: 42.85581,
    lng: -82.67676,
    city: "Columbus",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4028,
    density: 42.3,
    county_fips: 26147,
    county_name: "St. Clair",
    county_weights: {
      26147: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 26147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48064,
    lat: 42.76719,
    lng: -82.67233,
    city: "Casco",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4045,
    density: 42.2,
    county_fips: 26147,
    county_name: "St. Clair",
    county_weights: {
      26147: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 26147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48065,
    lat: 42.84554,
    lng: -83.04072,
    city: "Romeo",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11236,
    density: 116.1,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48066,
    lat: 42.50735,
    lng: -82.93697,
    city: "Roseville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47232,
    density: 1849.5,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48067,
    lat: 42.49053,
    lng: -83.13786,
    city: "Royal Oak",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24685,
    density: 2091,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48069,
    lat: 42.47151,
    lng: -83.14447,
    city: "Pleasant Ridge",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2432,
    density: 1643.3,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48070,
    lat: 42.48161,
    lng: -83.16852,
    city: "Huntington Woods",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6303,
    density: 1634.1,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48071,
    lat: 42.50726,
    lng: -83.10337,
    city: "Madison Heights",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30000,
    density: 1632.5,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48072,
    lat: 42.49789,
    lng: -83.18586,
    city: "Berkley",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15352,
    density: 2472.7,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48073,
    lat: 42.51919,
    lng: -83.16437,
    city: "Royal Oak",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34628,
    density: 1808.2,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48074,
    lat: 42.9484,
    lng: -82.56196,
    city: "Smiths Creek",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9220,
    density: 95.7,
    county_fips: 26147,
    county_name: "St. Clair",
    county_weights: {
      26147: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 26147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48075,
    lat: 42.4618,
    lng: -83.2299,
    city: "Southfield",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21810,
    density: 1161.3,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48076,
    lat: 42.49754,
    lng: -83.23067,
    city: "Southfield",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23822,
    density: 1296.6,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48079,
    lat: 42.8576,
    lng: -82.54721,
    city: "Saint Clair",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12291,
    density: 113.4,
    county_fips: 26147,
    county_name: "St. Clair",
    county_weights: {
      26147: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 26147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48080,
    lat: 42.46418,
    lng: -82.90031,
    city: "Saint Clair Shores",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22486,
    density: 1974.1,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48081,
    lat: 42.4955,
    lng: -82.89912,
    city: "Saint Clair Shores",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20522,
    density: 2026.3,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48082,
    lat: 42.5271,
    lng: -82.88711,
    city: "Saint Clair Shores",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16136,
    density: 1883.5,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48083,
    lat: 42.557,
    lng: -83.11676,
    city: "Troy",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22984,
    density: 1030,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48084,
    lat: 42.56065,
    lng: -83.17559,
    city: "Troy",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15438,
    density: 964,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48085,
    lat: 42.6006,
    lng: -83.11982,
    city: "Troy",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26061,
    density: 1081.7,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48088,
    lat: 42.51573,
    lng: -82.98298,
    city: "Warren",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22390,
    density: 1955.5,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48089,
    lat: 42.4702,
    lng: -82.99549,
    city: "Warren",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31411,
    density: 1515.1,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48091,
    lat: 42.4681,
    lng: -83.05819,
    city: "Warren",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29483,
    density: 1439.2,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48092,
    lat: 42.51308,
    lng: -83.05968,
    city: "Warren",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26573,
    density: 1259,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48093,
    lat: 42.51483,
    lng: -83.01554,
    city: "Warren",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24331,
    density: 1594.2,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48094,
    lat: 42.73645,
    lng: -83.03718,
    city: "Washington",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20017,
    density: 441.1,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48095,
    lat: 42.77977,
    lng: -83.03837,
    city: "Washington",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5794,
    density: 131.6,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48096,
    lat: 42.76132,
    lng: -82.9199,
    city: "Ray",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4022,
    density: 42.5,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48097,
    lat: 43.12639,
    lng: -82.82955,
    city: "Yale",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5615,
    density: 28.4,
    county_fips: 26147,
    county_name: "St. Clair",
    county_weights: {
      26147: 77.68,
      26151: 22.32,
    },
    county_names_all: "St. Clair|Sanilac",
    county_fips_all: "26147|26151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48098,
    lat: 42.59903,
    lng: -83.1789,
    city: "Troy",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19563,
    density: 803.7,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48101,
    lat: 42.25976,
    lng: -83.21067,
    city: "Allen Park",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27089,
    density: 1484.8,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48103,
    lat: 42.2581,
    lng: -83.84333,
    city: "Ann Arbor",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55078,
    density: 319.7,
    county_fips: 26161,
    county_name: "Washtenaw",
    county_weights: {
      26161: 100,
    },
    county_names_all: "Washtenaw",
    county_fips_all: 26161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48104,
    lat: 42.26343,
    lng: -83.71748,
    city: "Ann Arbor",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44219,
    density: 2190.3,
    county_fips: 26161,
    county_name: "Washtenaw",
    county_weights: {
      26161: 100,
    },
    county_names_all: "Washtenaw",
    county_fips_all: 26161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48105,
    lat: 42.33117,
    lng: -83.70587,
    city: "Ann Arbor",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36918,
    density: 287.9,
    county_fips: 26161,
    county_name: "Washtenaw",
    county_weights: {
      26161: 100,
    },
    county_names_all: "Washtenaw",
    county_fips_all: 26161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48108,
    lat: 42.22206,
    lng: -83.7317,
    city: "Ann Arbor",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27275,
    density: 627.7,
    county_fips: 26161,
    county_name: "Washtenaw",
    county_weights: {
      26161: 100,
    },
    county_names_all: "Washtenaw",
    county_fips_all: 26161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48109,
    lat: 42.28408,
    lng: -83.72531,
    city: "Ann Arbor",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5025,
    density: 1390.7,
    county_fips: 26161,
    county_name: "Washtenaw",
    county_weights: {
      26161: 100,
    },
    county_names_all: "Washtenaw",
    county_fips_all: 26161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48111,
    lat: 42.17976,
    lng: -83.48762,
    city: "Belleville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41081,
    density: 237.1,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26115: 0.62,
      26161: 2.11,
      26163: 97.27,
    },
    county_names_all: "Wayne|Washtenaw|Monroe",
    county_fips_all: "26163|26161|26115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48114,
    lat: 42.56784,
    lng: -83.75537,
    city: "Brighton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21422,
    density: 285.7,
    county_fips: 26093,
    county_name: "Livingston",
    county_weights: {
      26093: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 26093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48116,
    lat: 42.50428,
    lng: -83.78069,
    city: "Brighton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27422,
    density: 286.7,
    county_fips: 26093,
    county_name: "Livingston",
    county_weights: {
      26093: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 26093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48117,
    lat: 42.04984,
    lng: -83.40997,
    city: "Carleton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10238,
    density: 73.1,
    county_fips: 26115,
    county_name: "Monroe",
    county_weights: {
      26115: 99.35,
      26163: 0.65,
    },
    county_names_all: "Monroe|Wayne",
    county_fips_all: "26115|26163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48118,
    lat: 42.31151,
    lng: -84.03835,
    city: "Chelsea",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12714,
    density: 56.9,
    county_fips: 26161,
    county_name: "Washtenaw",
    county_weights: {
      26161: 100,
    },
    county_names_all: "Washtenaw",
    county_fips_all: 26161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48120,
    lat: 42.30524,
    lng: -83.1718,
    city: "Dearborn",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7737,
    density: 635.5,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48122,
    lat: 42.28018,
    lng: -83.17819,
    city: "Melvindale",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10300,
    density: 1461.9,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48124,
    lat: 42.29828,
    lng: -83.24796,
    city: "Dearborn",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28086,
    density: 1229.1,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48125,
    lat: 42.27793,
    lng: -83.26536,
    city: "Dearborn Heights",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20189,
    density: 1924.7,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48126,
    lat: 42.32999,
    lng: -83.18678,
    city: "Dearborn",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47692,
    density: 2199.1,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48127,
    lat: 42.33663,
    lng: -83.28292,
    city: "Dearborn Heights",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35441,
    density: 1780,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48128,
    lat: 42.32054,
    lng: -83.25952,
    city: "Dearborn",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10813,
    density: 1807.6,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48130,
    lat: 42.3547,
    lng: -83.90272,
    city: "Dexter",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15974,
    density: 96.4,
    county_fips: 26161,
    county_name: "Washtenaw",
    county_weights: {
      26161: 100,
    },
    county_names_all: "Washtenaw",
    county_fips_all: 26161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48131,
    lat: 41.96553,
    lng: -83.67268,
    city: "Dundee",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7085,
    density: 54.6,
    county_fips: 26115,
    county_name: "Monroe",
    county_weights: {
      26115: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 26115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48133,
    lat: 41.78428,
    lng: -83.48816,
    city: "Erie",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5201,
    density: 73.9,
    county_fips: 26115,
    county_name: "Monroe",
    county_weights: {
      26115: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 26115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48134,
    lat: 42.10813,
    lng: -83.29556,
    city: "Flat Rock",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22623,
    density: 471.3,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26115: 15.04,
      26163: 84.96,
    },
    county_names_all: "Wayne|Monroe",
    county_fips_all: "26163|26115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48135,
    lat: 42.32438,
    lng: -83.34122,
    city: "Garden City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26565,
    density: 1749.5,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48137,
    lat: 42.46191,
    lng: -84.07367,
    city: "Gregory",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4696,
    density: 41.9,
    county_fips: 26093,
    county_name: "Livingston",
    county_weights: {
      26093: 72.04,
      26161: 27.96,
    },
    county_names_all: "Livingston|Washtenaw",
    county_fips_all: "26093|26161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48138,
    lat: 42.13156,
    lng: -83.1586,
    city: "Grosse Ile",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10153,
    density: 454.6,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48139,
    lat: 42.45298,
    lng: -83.80796,
    city: "Hamburg",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 129,
    density: 85.2,
    county_fips: 26093,
    county_name: "Livingston",
    county_weights: {
      26093: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 26093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48140,
    lat: 41.88141,
    lng: -83.58274,
    city: "Ida",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3374,
    density: 49.4,
    county_fips: 26115,
    county_name: "Monroe",
    county_weights: {
      26115: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 26115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48141,
    lat: 42.29349,
    lng: -83.31483,
    city: "Inkster",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24398,
    density: 1506.6,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48143,
    lat: 42.45877,
    lng: -83.84701,
    city: "Lakeland",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 26093,
    county_name: "Livingston",
    county_weights: {
      26093: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 26093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48144,
    lat: 41.75325,
    lng: -83.62803,
    city: "Lambertville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9374,
    density: 456.4,
    county_fips: 26115,
    county_name: "Monroe",
    county_weights: {
      26115: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 26115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48145,
    lat: 41.85122,
    lng: -83.46331,
    city: "La Salle",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3489,
    density: 79.4,
    county_fips: 26115,
    county_name: "Monroe",
    county_weights: {
      26115: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 26115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48146,
    lat: 42.24322,
    lng: -83.18114,
    city: "Lincoln Park",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36525,
    density: 2416.3,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48150,
    lat: 42.36859,
    lng: -83.37261,
    city: "Livonia",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26311,
    density: 838.4,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48152,
    lat: 42.42597,
    lng: -83.37433,
    city: "Livonia",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30590,
    density: 982.8,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48154,
    lat: 42.39737,
    lng: -83.37315,
    city: "Livonia",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37069,
    density: 1236.2,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48157,
    lat: 41.81495,
    lng: -83.43776,
    city: "Luna Pier",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1134,
    density: 465.4,
    county_fips: 26115,
    county_name: "Monroe",
    county_weights: {
      26115: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 26115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48158,
    lat: 42.15564,
    lng: -84.03031,
    city: "Manchester",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7840,
    density: 31.8,
    county_fips: 26161,
    county_name: "Washtenaw",
    county_weights: {
      26075: 1.46,
      26161: 98.54,
    },
    county_names_all: "Washtenaw|Jackson",
    county_fips_all: "26161|26075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48159,
    lat: 42.02562,
    lng: -83.55598,
    city: "Maybee",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2489,
    density: 29.9,
    county_fips: 26115,
    county_name: "Monroe",
    county_weights: {
      26115: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 26115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48160,
    lat: 42.08256,
    lng: -83.67978,
    city: "Milan",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14170,
    density: 70.2,
    county_fips: 26115,
    county_name: "Monroe",
    county_weights: {
      26115: 51.87,
      26161: 48.13,
    },
    county_names_all: "Monroe|Washtenaw",
    county_fips_all: "26115|26161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48161,
    lat: 41.90818,
    lng: -83.47263,
    city: "Monroe",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26483,
    density: 228.1,
    county_fips: 26115,
    county_name: "Monroe",
    county_weights: {
      26115: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 26115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48162,
    lat: 41.96045,
    lng: -83.43503,
    city: "Monroe",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27414,
    density: 184.2,
    county_fips: 26115,
    county_name: "Monroe",
    county_weights: {
      26115: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 26115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48164,
    lat: 42.1264,
    lng: -83.39391,
    city: "New Boston",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8803,
    density: 112.2,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26115: 3.72,
      26163: 96.28,
    },
    county_names_all: "Wayne|Monroe",
    county_fips_all: "26163|26115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48165,
    lat: 42.49968,
    lng: -83.61623,
    city: "New Hudson",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8032,
    density: 313.1,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48166,
    lat: 41.98677,
    lng: -83.29375,
    city: "Newport",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11680,
    density: 169.5,
    county_fips: 26115,
    county_name: "Monroe",
    county_weights: {
      26115: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 26115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48167,
    lat: 42.43455,
    lng: -83.5313,
    city: "Northville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22648,
    density: 450.1,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 45.41,
      26161: 24.27,
      26163: 30.32,
    },
    county_names_all: "Oakland|Wayne|Washtenaw",
    county_fips_all: "26125|26163|26161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48168,
    lat: 42.40559,
    lng: -83.54051,
    city: "Northville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23345,
    density: 460.1,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26161: 44.86,
      26163: 55.14,
    },
    county_names_all: "Wayne|Washtenaw",
    county_fips_all: "26163|26161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48169,
    lat: 42.46348,
    lng: -83.94955,
    city: "Pinckney",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21483,
    density: 143.8,
    county_fips: 26093,
    county_name: "Livingston",
    county_weights: {
      26093: 92.99,
      26161: 7.01,
    },
    county_names_all: "Livingston|Washtenaw",
    county_fips_all: "26093|26161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48170,
    lat: 42.36758,
    lng: -83.53271,
    city: "Plymouth",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39578,
    density: 443.1,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26161: 45.35,
      26163: 54.65,
    },
    county_names_all: "Wayne|Washtenaw",
    county_fips_all: "26163|26161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48173,
    lat: 42.07638,
    lng: -83.21521,
    city: "Rockwood",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12553,
    density: 406.5,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48174,
    lat: 42.20862,
    lng: -83.35413,
    city: "Romulus",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30933,
    density: 292.7,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48176,
    lat: 42.15067,
    lng: -83.81477,
    city: "Saline",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23720,
    density: 129.3,
    county_fips: 26161,
    county_name: "Washtenaw",
    county_weights: {
      26091: 0.36,
      26161: 99.64,
    },
    county_names_all: "Washtenaw|Lenawee",
    county_fips_all: "26161|26091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48177,
    lat: 41.8048,
    lng: -83.58157,
    city: "Samaria",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 142,
    density: 77.5,
    county_fips: 26115,
    county_name: "Monroe",
    county_weights: {
      26115: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 26115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48178,
    lat: 42.44463,
    lng: -83.66399,
    city: "South Lyon",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34882,
    density: 280.8,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26093: 30.79,
      26125: 36.03,
      26161: 33.18,
    },
    county_names_all: "Oakland|Washtenaw|Livingston",
    county_fips_all: "26125|26161|26093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48179,
    lat: 42.03882,
    lng: -83.26061,
    city: "South Rockwood",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3877,
    density: 73.6,
    county_fips: 26115,
    county_name: "Monroe",
    county_weights: {
      26115: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 26115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48180,
    lat: 42.22605,
    lng: -83.26881,
    city: "Taylor",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61164,
    density: 1000,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48182,
    lat: 41.7919,
    lng: -83.57831,
    city: "Temperance",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22638,
    density: 222.8,
    county_fips: 26115,
    county_name: "Monroe",
    county_weights: {
      26115: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 26115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48183,
    lat: 42.1361,
    lng: -83.22045,
    city: "Trenton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41681,
    density: 892,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48184,
    lat: 42.27403,
    lng: -83.39494,
    city: "Wayne",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17040,
    density: 913.8,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48185,
    lat: 42.33579,
    lng: -83.38458,
    city: "Westland",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47066,
    density: 1492.9,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48186,
    lat: 42.29481,
    lng: -83.37461,
    city: "Westland",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34647,
    density: 1619.7,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48187,
    lat: 42.3292,
    lng: -83.48784,
    city: "Canton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49919,
    density: 1066.3,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48188,
    lat: 42.28579,
    lng: -83.48638,
    city: "Canton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42910,
    density: 926.6,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48189,
    lat: 42.41137,
    lng: -83.78306,
    city: "Whitmore Lake",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14296,
    density: 161.5,
    county_fips: 26161,
    county_name: "Washtenaw",
    county_weights: {
      26093: 31.57,
      26161: 68.43,
    },
    county_names_all: "Washtenaw|Livingston",
    county_fips_all: "26161|26093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48190,
    lat: 42.13162,
    lng: -83.60327,
    city: "Whittaker",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 185,
    density: 85.1,
    county_fips: 26161,
    county_name: "Washtenaw",
    county_weights: {
      26161: 100,
    },
    county_names_all: "Washtenaw",
    county_fips_all: 26161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48191,
    lat: 42.12022,
    lng: -83.56492,
    city: "Willis",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4408,
    density: 105.6,
    county_fips: 26161,
    county_name: "Washtenaw",
    county_weights: {
      26115: 12.3,
      26161: 87.7,
    },
    county_names_all: "Washtenaw|Monroe",
    county_fips_all: "26161|26115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48192,
    lat: 42.21156,
    lng: -83.15654,
    city: "Wyandotte",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24944,
    density: 1819.8,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48193,
    lat: 42.17341,
    lng: -83.21042,
    city: "Riverview",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16094,
    density: 868.7,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48195,
    lat: 42.20472,
    lng: -83.20568,
    city: "Southgate",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29129,
    density: 1636,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48197,
    lat: 42.1973,
    lng: -83.62903,
    city: "Ypsilanti",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67335,
    density: 630.5,
    county_fips: 26161,
    county_name: "Washtenaw",
    county_weights: {
      26161: 100,
    },
    county_names_all: "Washtenaw",
    county_fips_all: 26161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48198,
    lat: 42.27519,
    lng: -83.58822,
    city: "Ypsilanti",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38818,
    density: 449.3,
    county_fips: 26161,
    county_name: "Washtenaw",
    county_weights: {
      26161: 100,
    },
    county_names_all: "Washtenaw",
    county_fips_all: 26161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48201,
    lat: 42.34706,
    lng: -83.06009,
    city: "Detroit",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16040,
    density: 3267.8,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48202,
    lat: 42.37463,
    lng: -83.07764,
    city: "Detroit",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15611,
    density: 1798.4,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48203,
    lat: 42.42176,
    lng: -83.1031,
    city: "Highland Park",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22901,
    density: 1076.8,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48204,
    lat: 42.36582,
    lng: -83.14286,
    city: "Detroit",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23528,
    density: 1807.4,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48205,
    lat: 42.43317,
    lng: -82.98131,
    city: "Detroit",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33606,
    density: 2042.8,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48206,
    lat: 42.3751,
    lng: -83.10782,
    city: "Detroit",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16535,
    density: 2063.1,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48207,
    lat: 42.34753,
    lng: -83.01104,
    city: "Detroit",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21282,
    density: 1304.8,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48208,
    lat: 42.34844,
    lng: -83.09173,
    city: "Detroit",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9134,
    density: 1099,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48209,
    lat: 42.30524,
    lng: -83.11649,
    city: "Detroit",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30607,
    density: 1737.1,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48210,
    lat: 42.33644,
    lng: -83.12875,
    city: "Detroit",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29663,
    density: 2317.5,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48211,
    lat: 42.38175,
    lng: -83.04616,
    city: "Detroit",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6086,
    density: 553.7,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48212,
    lat: 42.41003,
    lng: -83.05601,
    city: "Hamtramck",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39186,
    density: 2859.8,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48213,
    lat: 42.39787,
    lng: -82.9955,
    city: "Detroit",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22030,
    density: 1303.6,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48214,
    lat: 42.36504,
    lng: -82.98697,
    city: "Detroit",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21317,
    density: 1629.4,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48215,
    lat: 42.37523,
    lng: -82.95428,
    city: "Detroit",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10855,
    density: 1061.4,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48216,
    lat: 42.32637,
    lng: -83.07927,
    city: "Detroit",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5426,
    density: 923.6,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48217,
    lat: 42.27803,
    lng: -83.15409,
    city: "Detroit",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6608,
    density: 1105.5,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48218,
    lat: 42.27049,
    lng: -83.13076,
    city: "River Rouge",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7465,
    density: 1321.3,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48219,
    lat: 42.42573,
    lng: -83.25282,
    city: "Detroit",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45503,
    density: 2083.5,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48220,
    lat: 42.45805,
    lng: -83.13519,
    city: "Ferndale",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22639,
    density: 1976.3,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48221,
    lat: 42.4272,
    lng: -83.14949,
    city: "Detroit",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40905,
    density: 3040.4,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48223,
    lat: 42.39341,
    lng: -83.24619,
    city: "Detroit",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26027,
    density: 1660.7,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48224,
    lat: 42.41074,
    lng: -82.94147,
    city: "Detroit",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42200,
    density: 2824.1,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48225,
    lat: 42.43893,
    lng: -82.92965,
    city: "Harper Woods",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14049,
    density: 2028.9,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48226,
    lat: 42.33182,
    lng: -83.05034,
    city: "Detroit",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7324,
    density: 2326,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48227,
    lat: 42.38732,
    lng: -83.1926,
    city: "Detroit",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40147,
    density: 2065.8,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48228,
    lat: 42.35562,
    lng: -83.21791,
    city: "Detroit",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57698,
    density: 2501.5,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48229,
    lat: 42.24889,
    lng: -83.1399,
    city: "Ecorse",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9456,
    density: 1288.4,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48230,
    lat: 42.38353,
    lng: -82.92304,
    city: "Grosse Pointe",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16284,
    density: 1931.8,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Toronto",
  },
  {
    zip: 48233,
    lat: 42.32324,
    lng: -83.06303,
    city: "Detroit",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48234,
    lat: 42.4312,
    lng: -83.03952,
    city: "Detroit",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33969,
    density: 1678.1,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48235,
    lat: 42.42702,
    lng: -83.1947,
    city: "Detroit",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46426,
    density: 2870.3,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48236,
    lat: 42.42504,
    lng: -82.89687,
    city: "Grosse Pointe",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29592,
    density: 1528,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26099: 2.38,
      26163: 97.62,
    },
    county_names_all: "Wayne|Macomb",
    county_fips_all: "26163|26099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48237,
    lat: 42.46494,
    lng: -83.18241,
    city: "Oak Park",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29603,
    density: 2220.7,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48238,
    lat: 42.39626,
    lng: -83.14136,
    city: "Detroit",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25259,
    density: 1806.2,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48239,
    lat: 42.37638,
    lng: -83.28574,
    city: "Redford",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36470,
    density: 1486.8,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48240,
    lat: 42.42447,
    lng: -83.30128,
    city: "Redford",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16871,
    density: 1737.7,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48242,
    lat: 42.21258,
    lng: -83.35203,
    city: "Detroit",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48243,
    lat: 42.32994,
    lng: -83.03955,
    city: "Detroit",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 26163,
    county_name: "Wayne",
    county_weights: {
      26163: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 26163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48301,
    lat: 42.54441,
    lng: -83.28284,
    city: "Bloomfield Hills",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15024,
    density: 788.6,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48302,
    lat: 42.5849,
    lng: -83.29608,
    city: "Bloomfield Hills",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15623,
    density: 546.8,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48304,
    lat: 42.58745,
    lng: -83.23442,
    city: "Bloomfield Hills",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16390,
    density: 555.3,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48306,
    lat: 42.72243,
    lng: -83.14944,
    city: "Rochester",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27974,
    density: 488.9,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26099: 1.92,
      26125: 98.08,
    },
    county_names_all: "Oakland|Macomb",
    county_fips_all: "26125|26099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48307,
    lat: 42.65953,
    lng: -83.12301,
    city: "Rochester",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44041,
    density: 1117.1,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48309,
    lat: 42.65866,
    lng: -83.18348,
    city: "Rochester",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30165,
    density: 748.4,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48310,
    lat: 42.56511,
    lng: -83.06694,
    city: "Sterling Heights",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43437,
    density: 1897.6,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48312,
    lat: 42.55831,
    lng: -83.00914,
    city: "Sterling Heights",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34635,
    density: 1200,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48313,
    lat: 42.59985,
    lng: -82.99984,
    city: "Sterling Heights",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33600,
    density: 1495.9,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48314,
    lat: 42.60978,
    lng: -83.05426,
    city: "Sterling Heights",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20624,
    density: 1022.4,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48315,
    lat: 42.67254,
    lng: -82.9963,
    city: "Utica",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28188,
    density: 845.1,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48316,
    lat: 42.69059,
    lng: -83.05671,
    city: "Utica",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28203,
    density: 968,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48317,
    lat: 42.64673,
    lng: -83.05334,
    city: "Utica",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28474,
    density: 913.2,
    county_fips: 26099,
    county_name: "Macomb",
    county_weights: {
      26099: 100,
    },
    county_names_all: "Macomb",
    county_fips_all: 26099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48320,
    lat: 42.61274,
    lng: -83.33824,
    city: "Keego Harbor",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4964,
    density: 1750,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48322,
    lat: 42.54214,
    lng: -83.38139,
    city: "West Bloomfield",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32997,
    density: 1086.7,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48323,
    lat: 42.57036,
    lng: -83.37651,
    city: "West Bloomfield",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16467,
    density: 739.9,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48324,
    lat: 42.59702,
    lng: -83.39151,
    city: "West Bloomfield",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18017,
    density: 810.9,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48326,
    lat: 42.67536,
    lng: -83.2531,
    city: "Auburn Hills",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22856,
    density: 520.6,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48327,
    lat: 42.6443,
    lng: -83.41417,
    city: "Waterford",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21659,
    density: 739.1,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48328,
    lat: 42.64597,
    lng: -83.35603,
    city: "Waterford",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27410,
    density: 1185.1,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48329,
    lat: 42.68826,
    lng: -83.38854,
    city: "Waterford",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23658,
    density: 887.3,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48331,
    lat: 42.50389,
    lng: -83.40863,
    city: "Farmington",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21336,
    density: 884.8,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48334,
    lat: 42.50662,
    lng: -83.34964,
    city: "Farmington",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19043,
    density: 810.6,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48335,
    lat: 42.46229,
    lng: -83.40271,
    city: "Farmington",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23574,
    density: 1260.8,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48336,
    lat: 42.46333,
    lng: -83.34803,
    city: "Farmington",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25040,
    density: 1038,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48340,
    lat: 42.67065,
    lng: -83.29019,
    city: "Pontiac",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25190,
    density: 1270,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48341,
    lat: 42.6275,
    lng: -83.29433,
    city: "Pontiac",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17823,
    density: 1021.7,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48342,
    lat: 42.64389,
    lng: -83.27591,
    city: "Pontiac",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16767,
    density: 1238,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48346,
    lat: 42.72156,
    lng: -83.42388,
    city: "Clarkston",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23301,
    density: 496.5,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48348,
    lat: 42.76677,
    lng: -83.40088,
    city: "Clarkston",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25015,
    density: 287.2,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48350,
    lat: 42.74082,
    lng: -83.53374,
    city: "Davisburg",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7845,
    density: 127,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48353,
    lat: 42.64736,
    lng: -83.71627,
    city: "Hartland",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6961,
    density: 213.8,
    county_fips: 26093,
    county_name: "Livingston",
    county_weights: {
      26093: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 26093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48356,
    lat: 42.65532,
    lng: -83.58904,
    city: "Highland",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8630,
    density: 237.9,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48357,
    lat: 42.65358,
    lng: -83.6432,
    city: "Highland",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8091,
    density: 238.5,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48359,
    lat: 42.7218,
    lng: -83.27801,
    city: "Lake Orion",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10611,
    density: 374.4,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48360,
    lat: 42.74903,
    lng: -83.26789,
    city: "Lake Orion",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12184,
    density: 413.7,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48362,
    lat: 42.782,
    lng: -83.2696,
    city: "Lake Orion",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15502,
    density: 592.6,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48363,
    lat: 42.77209,
    lng: -83.16114,
    city: "Oakland",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6523,
    density: 121.1,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48367,
    lat: 42.84282,
    lng: -83.14143,
    city: "Leonard",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4510,
    density: 74.3,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48370,
    lat: 42.83797,
    lng: -83.19981,
    city: "Oxford",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2096,
    density: 73.4,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48371,
    lat: 42.84544,
    lng: -83.28785,
    city: "Oxford",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25730,
    density: 214.8,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26087: 11.76,
      26125: 88.24,
    },
    county_names_all: "Oakland|Lapeer",
    county_fips_all: "26125|26087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48374,
    lat: 42.47083,
    lng: -83.52384,
    city: "Novi",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16653,
    density: 708.6,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48375,
    lat: 42.46537,
    lng: -83.46385,
    city: "Novi",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22018,
    density: 1014.8,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48377,
    lat: 42.50646,
    lng: -83.4727,
    city: "Novi",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17129,
    density: 688.6,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48380,
    lat: 42.57902,
    lng: -83.66602,
    city: "Milford",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7862,
    density: 106,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26093: 37.38,
      26125: 62.62,
    },
    county_names_all: "Oakland|Livingston",
    county_fips_all: "26125|26093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48381,
    lat: 42.5628,
    lng: -83.59336,
    city: "Milford",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13434,
    density: 266,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48382,
    lat: 42.59006,
    lng: -83.507,
    city: "Commerce Township",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23723,
    density: 550.3,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48383,
    lat: 42.65533,
    lng: -83.53485,
    city: "White Lake",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12802,
    density: 296.5,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48386,
    lat: 42.65826,
    lng: -83.47549,
    city: "White Lake",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18631,
    density: 428,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48390,
    lat: 42.55197,
    lng: -83.4752,
    city: "Walled Lake",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24457,
    density: 756.9,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48393,
    lat: 42.52123,
    lng: -83.54532,
    city: "Wixom",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16782,
    density: 477.3,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26125: 100,
    },
    county_names_all: "Oakland",
    county_fips_all: 26125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48401,
    lat: 43.3526,
    lng: -82.66061,
    city: "Applegate",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1346,
    density: 15,
    county_fips: 26151,
    county_name: "Sanilac",
    county_weights: {
      26151: 100,
    },
    county_names_all: "Sanilac",
    county_fips_all: 26151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48410,
    lat: 43.56629,
    lng: -82.9362,
    city: "Argyle",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 26151,
    county_name: "Sanilac",
    county_weights: {
      26151: 100,
    },
    county_names_all: "Sanilac",
    county_fips_all: 26151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48411,
    lat: 42.93577,
    lng: -83.53202,
    city: "Atlas",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28,
    density: 40.7,
    county_fips: 26049,
    county_name: "Genesee",
    county_weights: {
      26049: 100,
    },
    county_names_all: "Genesee",
    county_fips_all: 26049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48412,
    lat: 43.06484,
    lng: -83.16932,
    city: "Attica",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5071,
    density: 39.8,
    county_fips: 26087,
    county_name: "Lapeer",
    county_weights: {
      26087: 100,
    },
    county_names_all: "Lapeer",
    county_fips_all: 26087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48413,
    lat: 43.80231,
    lng: -82.99663,
    city: "Bad Axe",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7391,
    density: 20.8,
    county_fips: 26063,
    county_name: "Huron",
    county_weights: {
      26063: 100,
    },
    county_names_all: "Huron",
    county_fips_all: 26063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48414,
    lat: 42.86391,
    lng: -84.08098,
    city: "Bancroft",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2853,
    density: 34.8,
    county_fips: 26155,
    county_name: "Shiawassee",
    county_weights: {
      26155: 100,
    },
    county_names_all: "Shiawassee",
    county_fips_all: 26155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48415,
    lat: 43.27165,
    lng: -83.80111,
    city: "Birch Run",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9125,
    density: 54.4,
    county_fips: 26145,
    county_name: "Saginaw",
    county_weights: {
      26049: 1.87,
      26145: 95.28,
      26157: 2.85,
    },
    county_names_all: "Saginaw|Tuscola|Genesee",
    county_fips_all: "26145|26157|26049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48416,
    lat: 43.21791,
    lng: -82.98476,
    city: "Brown City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5040,
    density: 17.1,
    county_fips: 26151,
    county_name: "Sanilac",
    county_weights: {
      26087: 40.42,
      26147: 5.86,
      26151: 53.72,
    },
    county_names_all: "Sanilac|Lapeer|St. Clair",
    county_fips_all: "26151|26087|26147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48417,
    lat: 43.25998,
    lng: -83.93686,
    city: "Burt",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2615,
    density: 43.6,
    county_fips: 26145,
    county_name: "Saginaw",
    county_weights: {
      26145: 100,
    },
    county_names_all: "Saginaw",
    county_fips_all: 26145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48418,
    lat: 42.80427,
    lng: -83.97066,
    city: "Byron",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4164,
    density: 39.3,
    county_fips: 26155,
    county_name: "Shiawassee",
    county_weights: {
      26049: 25.22,
      26093: 8.98,
      26155: 65.8,
    },
    county_names_all: "Shiawassee|Genesee|Livingston",
    county_fips_all: "26155|26049|26093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48419,
    lat: 43.42884,
    lng: -82.65762,
    city: "Carsonville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2322,
    density: 11.5,
    county_fips: 26151,
    county_name: "Sanilac",
    county_weights: {
      26151: 100,
    },
    county_names_all: "Sanilac",
    county_fips_all: 26151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48420,
    lat: 43.17968,
    lng: -83.71176,
    city: "Clio",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20698,
    density: 120.3,
    county_fips: 26049,
    county_name: "Genesee",
    county_weights: {
      26049: 96.24,
      26145: 0.49,
      26157: 3.27,
    },
    county_names_all: "Genesee|Tuscola|Saginaw",
    county_fips_all: "26049|26157|26145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48421,
    lat: 43.15321,
    lng: -83.39262,
    city: "Columbiaville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6287,
    density: 58.6,
    county_fips: 26087,
    county_name: "Lapeer",
    county_weights: {
      26049: 4.88,
      26087: 95.12,
    },
    county_names_all: "Lapeer|Genesee",
    county_fips_all: "26087|26049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48422,
    lat: 43.26265,
    lng: -82.65069,
    city: "Croswell",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6033,
    density: 24.5,
    county_fips: 26151,
    county_name: "Sanilac",
    county_weights: {
      26151: 100,
    },
    county_names_all: "Sanilac",
    county_fips_all: 26151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48423,
    lat: 43.03982,
    lng: -83.51404,
    city: "Davison",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31766,
    density: 190.3,
    county_fips: 26049,
    county_name: "Genesee",
    county_weights: {
      26049: 98.75,
      26087: 1.25,
    },
    county_names_all: "Genesee|Lapeer",
    county_fips_all: "26049|26087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48426,
    lat: 43.50856,
    lng: -83.06025,
    city: "Decker",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1309,
    density: 13.5,
    county_fips: 26151,
    county_name: "Sanilac",
    county_weights: {
      26151: 100,
    },
    county_names_all: "Sanilac",
    county_fips_all: 26151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48427,
    lat: 43.53789,
    lng: -82.72378,
    city: "Deckerville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2762,
    density: 11,
    county_fips: 26151,
    county_name: "Sanilac",
    county_weights: {
      26151: 100,
    },
    county_names_all: "Sanilac",
    county_fips_all: 26151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48428,
    lat: 42.93752,
    lng: -83.14756,
    city: "Dryden",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5544,
    density: 64.8,
    county_fips: 26087,
    county_name: "Lapeer",
    county_weights: {
      26087: 98.71,
      26125: 1.29,
    },
    county_names_all: "Lapeer|Oakland",
    county_fips_all: "26087|26125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48429,
    lat: 42.90774,
    lng: -84.00544,
    city: "Durand",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8934,
    density: 64.9,
    county_fips: 26155,
    county_name: "Shiawassee",
    county_weights: {
      26049: 3.22,
      26155: 96.78,
    },
    county_names_all: "Shiawassee|Genesee",
    county_fips_all: "26155|26049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48430,
    lat: 42.75752,
    lng: -83.74208,
    city: "Fenton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36369,
    density: 168.8,
    county_fips: 26093,
    county_name: "Livingston",
    county_weights: {
      26049: 24.42,
      26093: 65.68,
      26125: 9.9,
    },
    county_names_all: "Livingston|Genesee|Oakland",
    county_fips_all: "26093|26049|26125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48432,
    lat: 43.90013,
    lng: -82.97923,
    city: "Filion",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 553,
    density: 7,
    county_fips: 26063,
    county_name: "Huron",
    county_weights: {
      26063: 100,
    },
    county_names_all: "Huron",
    county_fips_all: 26063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48433,
    lat: 43.07632,
    lng: -83.8661,
    city: "Flushing",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24975,
    density: 173.6,
    county_fips: 26049,
    county_name: "Genesee",
    county_weights: {
      26049: 96.18,
      26155: 3.82,
    },
    county_names_all: "Genesee|Shiawassee",
    county_fips_all: "26049|26155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48434,
    lat: 43.65988,
    lng: -82.61263,
    city: "Forestville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 109,
    density: 53,
    county_fips: 26151,
    county_name: "Sanilac",
    county_weights: {
      26151: 100,
    },
    county_names_all: "Sanilac",
    county_fips_all: 26151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48435,
    lat: 43.24863,
    lng: -83.3598,
    city: "Fostoria",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1987,
    density: 29.4,
    county_fips: 26087,
    county_name: "Lapeer",
    county_weights: {
      26087: 50.12,
      26157: 49.88,
    },
    county_names_all: "Lapeer|Tuscola",
    county_fips_all: "26087|26157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48436,
    lat: 42.87017,
    lng: -83.87704,
    city: "Gaines",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3882,
    density: 45.9,
    county_fips: 26049,
    county_name: "Genesee",
    county_weights: {
      26049: 90.5,
      26155: 9.5,
    },
    county_names_all: "Genesee|Shiawassee",
    county_fips_all: "26049|26155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48437,
    lat: 43.11248,
    lng: -83.61893,
    city: "Genesee",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 574,
    density: 383.3,
    county_fips: 26049,
    county_name: "Genesee",
    county_weights: {
      26049: 100,
    },
    county_names_all: "Genesee",
    county_fips_all: 26049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48438,
    lat: 42.91142,
    lng: -83.47819,
    city: "Goodrich",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6793,
    density: 82.3,
    county_fips: 26049,
    county_name: "Genesee",
    county_weights: {
      26049: 71.42,
      26087: 28.58,
    },
    county_names_all: "Genesee|Lapeer",
    county_fips_all: "26049|26087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48439,
    lat: 42.91733,
    lng: -83.63018,
    city: "Grand Blanc",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49023,
    density: 347.3,
    county_fips: 26049,
    county_name: "Genesee",
    county_weights: {
      26049: 98.68,
      26125: 1.32,
    },
    county_names_all: "Genesee|Oakland",
    county_fips_all: "26049|26125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48440,
    lat: 42.95567,
    lng: -83.40785,
    city: "Hadley",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 107,
    density: 157.9,
    county_fips: 26087,
    county_name: "Lapeer",
    county_weights: {
      26087: 100,
    },
    county_names_all: "Lapeer",
    county_fips_all: 26087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48441,
    lat: 43.80515,
    lng: -82.71727,
    city: "Harbor Beach",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4013,
    density: 15.2,
    county_fips: 26063,
    county_name: "Huron",
    county_weights: {
      26063: 98.22,
      26151: 1.78,
    },
    county_names_all: "Huron|Sanilac",
    county_fips_all: "26063|26151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48442,
    lat: 42.79316,
    lng: -83.60224,
    city: "Holly",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21858,
    density: 98.3,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26049: 2.91,
      26093: 1.11,
      26125: 95.98,
    },
    county_names_all: "Oakland|Genesee|Livingston",
    county_fips_all: "26125|26049|26093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48444,
    lat: 43.06455,
    lng: -83.05471,
    city: "Imlay City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9835,
    density: 46.6,
    county_fips: 26087,
    county_name: "Lapeer",
    county_weights: {
      26087: 93.56,
      26147: 6.44,
    },
    county_names_all: "Lapeer|St. Clair",
    county_fips_all: "26087|26147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48445,
    lat: 43.95243,
    lng: -82.98769,
    city: "Kinde",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1144,
    density: 7.6,
    county_fips: 26063,
    county_name: "Huron",
    county_weights: {
      26063: 100,
    },
    county_names_all: "Huron",
    county_fips_all: 26063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48446,
    lat: 43.05259,
    lng: -83.33745,
    city: "Lapeer",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30473,
    density: 96.5,
    county_fips: 26087,
    county_name: "Lapeer",
    county_weights: {
      26087: 100,
    },
    county_names_all: "Lapeer",
    county_fips_all: 26087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48449,
    lat: 42.99518,
    lng: -83.94552,
    city: "Lennon",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2783,
    density: 43.4,
    county_fips: 26155,
    county_name: "Shiawassee",
    county_weights: {
      26049: 27.43,
      26155: 72.57,
    },
    county_names_all: "Shiawassee|Genesee",
    county_fips_all: "26155|26049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48450,
    lat: 43.25289,
    lng: -82.54123,
    city: "Lexington",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4561,
    density: 80.5,
    county_fips: 26151,
    county_name: "Sanilac",
    county_weights: {
      26151: 100,
    },
    county_names_all: "Sanilac",
    county_fips_all: 26151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48451,
    lat: 42.80365,
    lng: -83.81683,
    city: "Linden",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14547,
    density: 164.9,
    county_fips: 26049,
    county_name: "Genesee",
    county_weights: {
      26049: 74.72,
      26093: 25.28,
    },
    county_names_all: "Genesee|Livingston",
    county_fips_all: "26049|26093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48453,
    lat: 43.34374,
    lng: -83.03493,
    city: "Marlette",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5180,
    density: 18.7,
    county_fips: 26151,
    county_name: "Sanilac",
    county_weights: {
      26087: 11.79,
      26151: 82.58,
      26157: 5.63,
    },
    county_names_all: "Sanilac|Lapeer|Tuscola",
    county_fips_all: "26151|26087|26157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48454,
    lat: 43.19999,
    lng: -82.81833,
    city: "Melvin",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1182,
    density: 15.1,
    county_fips: 26151,
    county_name: "Sanilac",
    county_weights: {
      26151: 100,
    },
    county_names_all: "Sanilac",
    county_fips_all: 26151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48455,
    lat: 42.94028,
    lng: -83.29131,
    city: "Metamora",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8348,
    density: 49.9,
    county_fips: 26087,
    county_name: "Lapeer",
    county_weights: {
      26087: 100,
    },
    county_names_all: "Lapeer",
    county_fips_all: 26087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48456,
    lat: 43.67102,
    lng: -82.75818,
    city: "Minden City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 727,
    density: 6.3,
    county_fips: 26151,
    county_name: "Sanilac",
    county_weights: {
      26063: 20.17,
      26151: 79.83,
    },
    county_names_all: "Sanilac|Huron",
    county_fips_all: "26151|26063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48457,
    lat: 43.19018,
    lng: -83.89306,
    city: "Montrose",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8574,
    density: 77,
    county_fips: 26049,
    county_name: "Genesee",
    county_weights: {
      26049: 72.06,
      26145: 27.94,
    },
    county_names_all: "Genesee|Saginaw",
    county_fips_all: "26049|26145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48458,
    lat: 43.1209,
    lng: -83.68308,
    city: "Mount Morris",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18712,
    density: 202.1,
    county_fips: 26049,
    county_name: "Genesee",
    county_weights: {
      26049: 100,
    },
    county_names_all: "Genesee",
    county_fips_all: 26049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48460,
    lat: 43.12734,
    lng: -83.98586,
    city: "New Lothrop",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2567,
    density: 28.7,
    county_fips: 26155,
    county_name: "Shiawassee",
    county_weights: {
      26049: 0.3,
      26145: 40.78,
      26155: 58.92,
    },
    county_names_all: "Shiawassee|Saginaw|Genesee",
    county_fips_all: "26155|26145|26049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48461,
    lat: 43.2024,
    lng: -83.20669,
    city: "North Branch",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8163,
    density: 38.7,
    county_fips: 26087,
    county_name: "Lapeer",
    county_weights: {
      26087: 100,
    },
    county_names_all: "Lapeer",
    county_fips_all: 26087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48462,
    lat: 42.84733,
    lng: -83.42576,
    city: "Ortonville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13531,
    density: 115,
    county_fips: 26125,
    county_name: "Oakland",
    county_weights: {
      26049: 0.41,
      26087: 8.67,
      26125: 90.92,
    },
    county_names_all: "Oakland|Lapeer|Genesee",
    county_fips_all: "26125|26087|26049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48463,
    lat: 43.16418,
    lng: -83.52202,
    city: "Otisville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4560,
    density: 52.8,
    county_fips: 26049,
    county_name: "Genesee",
    county_weights: {
      26049: 99.76,
      26087: 0.24,
    },
    county_names_all: "Genesee|Lapeer",
    county_fips_all: "26049|26087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48464,
    lat: 43.21562,
    lng: -83.41884,
    city: "Otter Lake",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2168,
    density: 49.2,
    county_fips: 26087,
    county_name: "Lapeer",
    county_weights: {
      26049: 7.18,
      26087: 79.77,
      26157: 13.05,
    },
    county_names_all: "Lapeer|Tuscola|Genesee",
    county_fips_all: "26087|26157|26049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48465,
    lat: 43.61485,
    lng: -82.71099,
    city: "Palms",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 665,
    density: 6.1,
    county_fips: 26151,
    county_name: "Sanilac",
    county_weights: {
      26151: 100,
    },
    county_names_all: "Sanilac",
    county_fips_all: 26151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48466,
    lat: 43.27693,
    lng: -82.81731,
    city: "Peck",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1512,
    density: 15.8,
    county_fips: 26151,
    county_name: "Sanilac",
    county_weights: {
      26151: 100,
    },
    county_names_all: "Sanilac",
    county_fips_all: 26151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48467,
    lat: 44.00768,
    lng: -82.98763,
    city: "Port Austin",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2230,
    density: 13.7,
    county_fips: 26063,
    county_name: "Huron",
    county_weights: {
      26063: 100,
    },
    county_names_all: "Huron",
    county_fips_all: 26063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48468,
    lat: 43.94113,
    lng: -82.79021,
    city: "Port Hope",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1164,
    density: 6.9,
    county_fips: 26063,
    county_name: "Huron",
    county_weights: {
      26063: 100,
    },
    county_names_all: "Huron",
    county_fips_all: 26063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48469,
    lat: 43.43927,
    lng: -82.55849,
    city: "Port Sanilac",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1151,
    density: 56.3,
    county_fips: 26151,
    county_name: "Sanilac",
    county_weights: {
      26151: 100,
    },
    county_names_all: "Sanilac",
    county_fips_all: 26151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48470,
    lat: 43.73253,
    lng: -82.76158,
    city: "Ruth",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 680,
    density: 6.5,
    county_fips: 26063,
    county_name: "Huron",
    county_weights: {
      26063: 99.52,
      26151: 0.48,
    },
    county_names_all: "Huron|Sanilac",
    county_fips_all: "26063|26151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48471,
    lat: 43.41868,
    lng: -82.85369,
    city: "Sandusky",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5726,
    density: 21.9,
    county_fips: 26151,
    county_name: "Sanilac",
    county_weights: {
      26151: 100,
    },
    county_names_all: "Sanilac",
    county_fips_all: 26151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48472,
    lat: 43.51211,
    lng: -82.95732,
    city: "Snover",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1652,
    density: 8.6,
    county_fips: 26151,
    county_name: "Sanilac",
    county_weights: {
      26151: 100,
    },
    county_names_all: "Sanilac",
    county_fips_all: 26151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48473,
    lat: 42.94012,
    lng: -83.8274,
    city: "Swartz Creek",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22111,
    density: 151.8,
    county_fips: 26049,
    county_name: "Genesee",
    county_weights: {
      26049: 100,
    },
    county_names_all: "Genesee",
    county_fips_all: 26049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48475,
    lat: 43.67141,
    lng: -82.93732,
    city: "Ubly",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2535,
    density: 9.1,
    county_fips: 26151,
    county_name: "Sanilac",
    county_weights: {
      26063: 46.02,
      26151: 53.98,
    },
    county_names_all: "Sanilac|Huron",
    county_fips_all: "26151|26063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48476,
    lat: 42.93765,
    lng: -84.03319,
    city: "Vernon",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 355,
    density: 200.7,
    county_fips: 26155,
    county_name: "Shiawassee",
    county_weights: {
      26155: 100,
    },
    county_names_all: "Shiawassee",
    county_fips_all: 26155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48502,
    lat: 43.01429,
    lng: -83.68866,
    city: "Flint",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1135,
    density: 957.4,
    county_fips: 26049,
    county_name: "Genesee",
    county_weights: {
      26049: 100,
    },
    county_names_all: "Genesee",
    county_fips_all: 26049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48503,
    lat: 43.01139,
    lng: -83.68901,
    city: "Flint",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26542,
    density: 1212,
    county_fips: 26049,
    county_name: "Genesee",
    county_weights: {
      26049: 100,
    },
    county_names_all: "Genesee",
    county_fips_all: 26049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48504,
    lat: 43.05632,
    lng: -83.74948,
    city: "Flint",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26020,
    density: 682.5,
    county_fips: 26049,
    county_name: "Genesee",
    county_weights: {
      26049: 100,
    },
    county_names_all: "Genesee",
    county_fips_all: 26049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48505,
    lat: 43.06948,
    lng: -83.69079,
    city: "Flint",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19722,
    density: 610.5,
    county_fips: 26049,
    county_name: "Genesee",
    county_weights: {
      26049: 100,
    },
    county_names_all: "Genesee",
    county_fips_all: 26049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48506,
    lat: 43.06775,
    lng: -83.62253,
    city: "Flint",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28308,
    density: 590.9,
    county_fips: 26049,
    county_name: "Genesee",
    county_weights: {
      26049: 100,
    },
    county_names_all: "Genesee",
    county_fips_all: 26049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48507,
    lat: 42.96498,
    lng: -83.71687,
    city: "Flint",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30884,
    density: 540.4,
    county_fips: 26049,
    county_name: "Genesee",
    county_weights: {
      26049: 100,
    },
    county_names_all: "Genesee",
    county_fips_all: 26049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48509,
    lat: 43.02635,
    lng: -83.60527,
    city: "Burton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9380,
    density: 411.8,
    county_fips: 26049,
    county_name: "Genesee",
    county_weights: {
      26049: 100,
    },
    county_names_all: "Genesee",
    county_fips_all: 26049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48519,
    lat: 42.98772,
    lng: -83.60701,
    city: "Burton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7027,
    density: 346,
    county_fips: 26049,
    county_name: "Genesee",
    county_weights: {
      26049: 100,
    },
    county_names_all: "Genesee",
    county_fips_all: 26049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48529,
    lat: 42.97237,
    lng: -83.66221,
    city: "Burton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8812,
    density: 708.2,
    county_fips: 26049,
    county_name: "Genesee",
    county_weights: {
      26049: 100,
    },
    county_names_all: "Genesee",
    county_fips_all: 26049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48532,
    lat: 43.01203,
    lng: -83.79429,
    city: "Flint",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20704,
    density: 501,
    county_fips: 26049,
    county_name: "Genesee",
    county_weights: {
      26049: 100,
    },
    county_names_all: "Genesee",
    county_fips_all: 26049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48601,
    lat: 43.40096,
    lng: -83.8952,
    city: "Saginaw",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34218,
    density: 126.6,
    county_fips: 26145,
    county_name: "Saginaw",
    county_weights: {
      26145: 100,
    },
    county_names_all: "Saginaw",
    county_fips_all: 26145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48602,
    lat: 43.41971,
    lng: -83.97469,
    city: "Saginaw",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30109,
    density: 1487.4,
    county_fips: 26145,
    county_name: "Saginaw",
    county_weights: {
      26145: 100,
    },
    county_names_all: "Saginaw",
    county_fips_all: 26145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48603,
    lat: 43.46332,
    lng: -84.03115,
    city: "Saginaw",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26464,
    density: 560.7,
    county_fips: 26145,
    county_name: "Saginaw",
    county_weights: {
      26145: 100,
    },
    county_names_all: "Saginaw",
    county_fips_all: 26145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48604,
    lat: 43.49749,
    lng: -83.95887,
    city: "Saginaw",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11905,
    density: 175.1,
    county_fips: 26145,
    county_name: "Saginaw",
    county_weights: {
      26017: 8.73,
      26145: 91.27,
    },
    county_names_all: "Saginaw|Bay",
    county_fips_all: "26145|26017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48607,
    lat: 43.43136,
    lng: -83.93409,
    city: "Saginaw",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1772,
    density: 718.8,
    county_fips: 26145,
    county_name: "Saginaw",
    county_weights: {
      26145: 100,
    },
    county_names_all: "Saginaw",
    county_fips_all: 26145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48609,
    lat: 43.3878,
    lng: -84.08786,
    city: "Saginaw",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12375,
    density: 106.5,
    county_fips: 26145,
    county_name: "Saginaw",
    county_weights: {
      26145: 100,
    },
    county_names_all: "Saginaw",
    county_fips_all: 26145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48610,
    lat: 44.12789,
    lng: -84.1801,
    city: "Alger",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2691,
    density: 8.2,
    county_fips: 26051,
    county_name: "Gladwin",
    county_weights: {
      26011: 26.23,
      26051: 48.38,
      26129: 25.39,
    },
    county_names_all: "Gladwin|Arenac|Ogemaw",
    county_fips_all: "26051|26011|26129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48611,
    lat: 43.63187,
    lng: -84.0936,
    city: "Auburn",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6100,
    density: 61.7,
    county_fips: 26017,
    county_name: "Bay",
    county_weights: {
      26017: 100,
    },
    county_names_all: "Bay",
    county_fips_all: 26017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48612,
    lat: 43.88001,
    lng: -84.43637,
    city: "Beaverton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8638,
    density: 26.7,
    county_fips: 26051,
    county_name: "Gladwin",
    county_weights: {
      26035: 2.28,
      26051: 96.56,
      26111: 1.16,
    },
    county_names_all: "Gladwin|Clare|Midland",
    county_fips_all: "26051|26035|26111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48613,
    lat: 43.94355,
    lng: -84.15791,
    city: "Bentley",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 851,
    density: 6.5,
    county_fips: 26017,
    county_name: "Bay",
    county_weights: {
      26017: 58.17,
      26051: 41.83,
    },
    county_names_all: "Bay|Gladwin",
    county_fips_all: "26017|26051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48614,
    lat: 43.25084,
    lng: -84.30147,
    city: "Brant",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1274,
    density: 13.9,
    county_fips: 26145,
    county_name: "Saginaw",
    county_weights: {
      26057: 5.06,
      26145: 94.94,
    },
    county_names_all: "Saginaw|Gratiot",
    county_fips_all: "26145|26057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48615,
    lat: 43.42671,
    lng: -84.47326,
    city: "Breckenridge",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2777,
    density: 19.5,
    county_fips: 26057,
    county_name: "Gratiot",
    county_weights: {
      26057: 67.67,
      26111: 32.33,
    },
    county_names_all: "Gratiot|Midland",
    county_fips_all: "26057|26111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48616,
    lat: 43.19336,
    lng: -84.11311,
    city: "Chesaning",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7118,
    density: 33.9,
    county_fips: 26145,
    county_name: "Saginaw",
    county_weights: {
      26145: 98.32,
      26155: 1.68,
    },
    county_names_all: "Saginaw|Shiawassee",
    county_fips_all: "26145|26155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48617,
    lat: 43.84695,
    lng: -84.71717,
    city: "Clare",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9382,
    density: 26.3,
    county_fips: 26035,
    county_name: "Clare",
    county_weights: {
      26035: 64.86,
      26073: 35.14,
    },
    county_names_all: "Clare|Isabella",
    county_fips_all: "26035|26073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48618,
    lat: 43.73602,
    lng: -84.5584,
    city: "Coleman",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5167,
    density: 19.5,
    county_fips: 26111,
    county_name: "Midland",
    county_weights: {
      26051: 2.13,
      26073: 21.26,
      26111: 76.61,
    },
    county_names_all: "Midland|Isabella|Gladwin",
    county_fips_all: "26111|26073|26051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48619,
    lat: 44.82224,
    lng: -84.01996,
    city: "Comins",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 523,
    density: 2.6,
    county_fips: 26135,
    county_name: "Oscoda",
    county_weights: {
      26119: 18.54,
      26135: 81.46,
    },
    county_names_all: "Oscoda|Montmorency",
    county_fips_all: "26135|26119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48620,
    lat: 43.80865,
    lng: -84.37805,
    city: "Edenville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 26111,
    county_name: "Midland",
    county_weights: {
      26111: 100,
    },
    county_names_all: "Midland",
    county_fips_all: 26111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48621,
    lat: 44.72064,
    lng: -83.99408,
    city: "Fairview",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1058,
    density: 8,
    county_fips: 26135,
    county_name: "Oscoda",
    county_weights: {
      26135: 100,
    },
    county_names_all: "Oscoda",
    county_fips_all: 26135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48622,
    lat: 43.83304,
    lng: -84.884,
    city: "Farwell",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6022,
    density: 27,
    county_fips: 26035,
    county_name: "Clare",
    county_weights: {
      26035: 63.86,
      26073: 36.14,
    },
    county_names_all: "Clare|Isabella",
    county_fips_all: "26035|26073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48623,
    lat: 43.5198,
    lng: -84.13523,
    city: "Freeland",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13690,
    density: 72.6,
    county_fips: 26145,
    county_name: "Saginaw",
    county_weights: {
      26017: 12.23,
      26111: 23.89,
      26145: 63.88,
    },
    county_names_all: "Saginaw|Midland|Bay",
    county_fips_all: "26145|26111|26017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48624,
    lat: 44.05919,
    lng: -84.45859,
    city: "Gladwin",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15880,
    density: 18,
    county_fips: 26051,
    county_name: "Gladwin",
    county_weights: {
      26035: 10.12,
      26051: 76.8,
      26129: 1.11,
      26143: 11.97,
    },
    county_names_all: "Gladwin|Roscommon|Clare|Ogemaw",
    county_fips_all: "26051|26143|26035|26129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48625,
    lat: 44.04976,
    lng: -84.8345,
    city: "Harrison",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12804,
    density: 19.2,
    county_fips: 26035,
    county_name: "Clare",
    county_weights: {
      26035: 100,
    },
    county_names_all: "Clare",
    county_fips_all: 26035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48626,
    lat: 43.4218,
    lng: -84.22686,
    city: "Hemlock",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5702,
    density: 33.6,
    county_fips: 26145,
    county_name: "Saginaw",
    county_weights: {
      26111: 12.15,
      26145: 87.85,
    },
    county_names_all: "Saginaw|Midland",
    county_fips_all: "26145|26111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48627,
    lat: 44.46177,
    lng: -84.74869,
    city: "Higgins Lake",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 112,
    density: 209,
    county_fips: 26143,
    county_name: "Roscommon",
    county_weights: {
      26143: 100,
    },
    county_names_all: "Roscommon",
    county_fips_all: 26143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48628,
    lat: 43.78166,
    lng: -84.32856,
    city: "Hope",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2062,
    density: 23.3,
    county_fips: 26111,
    county_name: "Midland",
    county_weights: {
      26051: 9.35,
      26111: 90.65,
    },
    county_names_all: "Midland|Gladwin",
    county_fips_all: "26111|26051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48629,
    lat: 44.3107,
    lng: -84.77977,
    city: "Houghton Lake",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7746,
    density: 38.6,
    county_fips: 26143,
    county_name: "Roscommon",
    county_weights: {
      26113: 0.15,
      26143: 99.85,
    },
    county_names_all: "Roscommon|Missaukee",
    county_fips_all: "26143|26113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48630,
    lat: 44.32532,
    lng: -84.773,
    city: "Houghton Lake Heights",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45,
    density: 91.5,
    county_fips: 26143,
    county_name: "Roscommon",
    county_weights: {
      26143: 100,
    },
    county_names_all: "Roscommon",
    county_fips_all: 26143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48631,
    lat: 43.6849,
    lng: -84.00155,
    city: "Kawkawlin",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4186,
    density: 49.1,
    county_fips: 26017,
    county_name: "Bay",
    county_weights: {
      26017: 100,
    },
    county_names_all: "Bay",
    county_fips_all: 26017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48632,
    lat: 43.85597,
    lng: -85.01954,
    city: "Lake",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5043,
    density: 15.8,
    county_fips: 26035,
    county_name: "Clare",
    county_weights: {
      26035: 64.29,
      26073: 30.9,
      26107: 0.36,
      26133: 4.45,
    },
    county_names_all: "Clare|Isabella|Osceola|Mecosta",
    county_fips_all: "26035|26073|26133|26107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48633,
    lat: 43.94827,
    lng: -84.93409,
    city: "Lake George",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 82,
    density: 13.6,
    county_fips: 26035,
    county_name: "Clare",
    county_weights: {
      26035: 100,
    },
    county_names_all: "Clare",
    county_fips_all: 26035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48634,
    lat: 43.75405,
    lng: -84.05414,
    city: "Linwood",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4325,
    density: 34.1,
    county_fips: 26017,
    county_name: "Bay",
    county_weights: {
      26017: 100,
    },
    county_names_all: "Bay",
    county_fips_all: 26017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48635,
    lat: 44.39575,
    lng: -83.99699,
    city: "Lupton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1542,
    density: 11.2,
    county_fips: 26129,
    county_name: "Ogemaw",
    county_weights: {
      26129: 100,
    },
    county_names_all: "Ogemaw",
    county_fips_all: 26129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48636,
    lat: 44.58871,
    lng: -84.28569,
    city: "Luzerne",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 906,
    density: 4.5,
    county_fips: 26135,
    county_name: "Oscoda",
    county_weights: {
      26135: 100,
    },
    county_names_all: "Oscoda",
    county_fips_all: 26135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48637,
    lat: 43.41499,
    lng: -84.33646,
    city: "Merrill",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3344,
    density: 18.2,
    county_fips: 26145,
    county_name: "Saginaw",
    county_weights: {
      26057: 12.21,
      26111: 18.9,
      26145: 68.89,
    },
    county_names_all: "Saginaw|Midland|Gratiot",
    county_fips_all: "26145|26111|26057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48638,
    lat: 43.41681,
    lng: -84.01958,
    city: "Saginaw",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11528,
    density: 680.3,
    county_fips: 26145,
    county_name: "Saginaw",
    county_weights: {
      26145: 100,
    },
    county_names_all: "Saginaw",
    county_fips_all: 26145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48640,
    lat: 43.58394,
    lng: -84.33648,
    city: "Midland",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32374,
    density: 118.9,
    county_fips: 26111,
    county_name: "Midland",
    county_weights: {
      26111: 100,
    },
    county_names_all: "Midland",
    county_fips_all: 26111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48642,
    lat: 43.69945,
    lng: -84.22849,
    city: "Midland",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33720,
    density: 124.3,
    county_fips: 26111,
    county_name: "Midland",
    county_weights: {
      26017: 15.97,
      26111: 84.03,
    },
    county_names_all: "Midland|Bay",
    county_fips_all: "26111|26017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48647,
    lat: 44.65309,
    lng: -84.08148,
    city: "Mio",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4389,
    density: 10.1,
    county_fips: 26135,
    county_name: "Oscoda",
    county_weights: {
      26001: 2.93,
      26135: 97.07,
    },
    county_names_all: "Oscoda|Alcona",
    county_fips_all: "26135|26001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48649,
    lat: 43.15695,
    lng: -84.21709,
    city: "Oakley",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1184,
    density: 16.6,
    county_fips: 26145,
    county_name: "Saginaw",
    county_weights: {
      26145: 94.21,
      26155: 5.79,
    },
    county_names_all: "Saginaw|Shiawassee",
    county_fips_all: "26145|26155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48650,
    lat: 43.85181,
    lng: -84.01746,
    city: "Pinconning",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6970,
    density: 28.3,
    county_fips: 26017,
    county_name: "Bay",
    county_weights: {
      26011: 6.44,
      26017: 93.56,
    },
    county_names_all: "Bay|Arenac",
    county_fips_all: "26017|26011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48651,
    lat: 44.25057,
    lng: -84.61687,
    city: "Prudenville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4520,
    density: 24.6,
    county_fips: 26143,
    county_name: "Roscommon",
    county_weights: {
      26143: 100,
    },
    county_names_all: "Roscommon",
    county_fips_all: 26143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48652,
    lat: 43.84834,
    lng: -84.20716,
    city: "Rhodes",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1795,
    density: 11.6,
    county_fips: 26051,
    county_name: "Gladwin",
    county_weights: {
      26017: 22.34,
      26051: 55.81,
      26111: 21.85,
    },
    county_names_all: "Gladwin|Bay|Midland",
    county_fips_all: "26051|26017|26111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48653,
    lat: 44.48936,
    lng: -84.60624,
    city: "Roscommon",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10264,
    density: 16.4,
    county_fips: 26143,
    county_name: "Roscommon",
    county_weights: {
      26039: 38.84,
      26143: 61.16,
    },
    county_names_all: "Roscommon|Crawford",
    county_fips_all: "26143|26039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48654,
    lat: 44.45468,
    lng: -84.12627,
    city: "Rose City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2229,
    density: 8.7,
    county_fips: 26129,
    county_name: "Ogemaw",
    county_weights: {
      26129: 76.86,
      26135: 23.14,
    },
    county_names_all: "Ogemaw|Oscoda",
    county_fips_all: "26129|26135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48655,
    lat: 43.29171,
    lng: -84.15743,
    city: "Saint Charles",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5695,
    density: 23.4,
    county_fips: 26145,
    county_name: "Saginaw",
    county_weights: {
      26145: 100,
    },
    county_names_all: "Saginaw",
    county_fips_all: 26145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48656,
    lat: 44.34953,
    lng: -84.45801,
    city: "Saint Helen",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3840,
    density: 10.4,
    county_fips: 26143,
    county_name: "Roscommon",
    county_weights: {
      26143: 100,
    },
    county_names_all: "Roscommon",
    county_fips_all: 26143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48657,
    lat: 43.70945,
    lng: -84.4213,
    city: "Sanford",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7904,
    density: 49.5,
    county_fips: 26111,
    county_name: "Midland",
    county_weights: {
      26111: 100,
    },
    county_names_all: "Midland",
    county_fips_all: 26111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48658,
    lat: 43.98038,
    lng: -83.94072,
    city: "Standish",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4789,
    density: 22.8,
    county_fips: 26011,
    county_name: "Arenac",
    county_weights: {
      26011: 89.62,
      26017: 10.38,
    },
    county_names_all: "Arenac|Bay",
    county_fips_all: "26011|26017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48659,
    lat: 44.06792,
    lng: -84.05154,
    city: "Sterling",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2806,
    density: 14.2,
    county_fips: 26011,
    county_name: "Arenac",
    county_weights: {
      26011: 97.93,
      26017: 2.07,
    },
    county_names_all: "Arenac|Bay",
    county_fips_all: "26011|26017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48661,
    lat: 44.33005,
    lng: -84.24087,
    city: "West Branch",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10496,
    density: 15.4,
    county_fips: 26129,
    county_name: "Ogemaw",
    county_weights: {
      26129: 100,
    },
    county_names_all: "Ogemaw",
    county_fips_all: 26129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48662,
    lat: 43.40217,
    lng: -84.40961,
    city: "Wheeler",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1495,
    density: 11.5,
    county_fips: 26057,
    county_name: "Gratiot",
    county_weights: {
      26057: 78.25,
      26111: 21.75,
    },
    county_names_all: "Gratiot|Midland",
    county_fips_all: "26057|26111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48701,
    lat: 43.5879,
    lng: -83.54649,
    city: "Akron",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1207,
    density: 11,
    county_fips: 26157,
    county_name: "Tuscola",
    county_weights: {
      26157: 100,
    },
    county_names_all: "Tuscola",
    county_fips_all: 26157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48703,
    lat: 44.06766,
    lng: -83.66904,
    city: "Au Gres",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2895,
    density: 25,
    county_fips: 26011,
    county_name: "Arenac",
    county_weights: {
      26011: 100,
    },
    county_names_all: "Arenac",
    county_fips_all: 26011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48705,
    lat: 44.68715,
    lng: -83.65279,
    city: "Barton City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 398,
    density: 1.9,
    county_fips: 26001,
    county_name: "Alcona",
    county_weights: {
      26001: 100,
    },
    county_names_all: "Alcona",
    county_fips_all: 26001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48706,
    lat: 43.59937,
    lng: -83.95623,
    city: "Bay City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38628,
    density: 224.9,
    county_fips: 26017,
    county_name: "Bay",
    county_weights: {
      26017: 100,
    },
    county_names_all: "Bay",
    county_fips_all: 26017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48708,
    lat: 43.55653,
    lng: -83.84853,
    city: "Bay City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26255,
    density: 348.9,
    county_fips: 26017,
    county_name: "Bay",
    county_weights: {
      26017: 89.82,
      26145: 10.18,
    },
    county_names_all: "Bay|Saginaw",
    county_fips_all: "26017|26145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48710,
    lat: 43.55649,
    lng: -83.98781,
    city: "University Center",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 26017,
    county_name: "Bay",
    county_weights: {
      26017: 100,
    },
    county_names_all: "Bay",
    county_fips_all: 26017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48720,
    lat: 43.8294,
    lng: -83.34808,
    city: "Bay Port",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1065,
    density: 12.2,
    county_fips: 26063,
    county_name: "Huron",
    county_weights: {
      26063: 100,
    },
    county_names_all: "Huron",
    county_fips_all: 26063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48721,
    lat: 44.80453,
    lng: -83.3459,
    city: "Black River",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 419,
    density: 5.8,
    county_fips: 26001,
    county_name: "Alcona",
    county_weights: {
      26001: 100,
    },
    county_names_all: "Alcona",
    county_fips_all: 26001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48722,
    lat: 43.34554,
    lng: -83.83961,
    city: "Bridgeport",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2873,
    density: 63.4,
    county_fips: 26145,
    county_name: "Saginaw",
    county_weights: {
      26145: 100,
    },
    county_names_all: "Saginaw",
    county_fips_all: 26145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48723,
    lat: 43.4861,
    lng: -83.38499,
    city: "Caro",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12327,
    density: 36.1,
    county_fips: 26157,
    county_name: "Tuscola",
    county_weights: {
      26157: 100,
    },
    county_names_all: "Tuscola",
    county_fips_all: 26157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48724,
    lat: 43.4569,
    lng: -83.92709,
    city: "Carrollton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1041,
    density: 802.5,
    county_fips: 26145,
    county_name: "Saginaw",
    county_weights: {
      26145: 100,
    },
    county_names_all: "Saginaw",
    county_fips_all: 26145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48725,
    lat: 43.93763,
    lng: -83.20596,
    city: "Caseville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2003,
    density: 23.1,
    county_fips: 26063,
    county_name: "Huron",
    county_weights: {
      26063: 100,
    },
    county_names_all: "Huron",
    county_fips_all: 26063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48726,
    lat: 43.60776,
    lng: -83.16833,
    city: "Cass City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5534,
    density: 16.8,
    county_fips: 26157,
    county_name: "Tuscola",
    county_weights: {
      26063: 8.95,
      26151: 26.26,
      26157: 64.79,
    },
    county_names_all: "Tuscola|Sanilac|Huron",
    county_fips_all: "26157|26151|26063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48727,
    lat: 43.30695,
    lng: -83.17935,
    city: "Clifford",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1045,
    density: 16.7,
    county_fips: 26087,
    county_name: "Lapeer",
    county_weights: {
      26087: 73.03,
      26157: 26.97,
    },
    county_names_all: "Lapeer|Tuscola",
    county_fips_all: "26087|26157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48728,
    lat: 44.74659,
    lng: -83.82344,
    city: "Curran",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 262,
    density: 0.8,
    county_fips: 26001,
    county_name: "Alcona",
    county_weights: {
      26001: 87.7,
      26135: 12.3,
    },
    county_names_all: "Alcona|Oscoda",
    county_fips_all: "26001|26135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48729,
    lat: 43.49621,
    lng: -83.17828,
    city: "Deford",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1425,
    density: 12.5,
    county_fips: 26157,
    county_name: "Tuscola",
    county_weights: {
      26157: 100,
    },
    county_names_all: "Tuscola",
    county_fips_all: 26157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48730,
    lat: 44.35443,
    lng: -83.48804,
    city: "East Tawas",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4633,
    density: 22,
    county_fips: 26069,
    county_name: "Iosco",
    county_weights: {
      26069: 100,
    },
    county_names_all: "Iosco",
    county_fips_all: 26069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48731,
    lat: 43.83898,
    lng: -83.15784,
    city: "Elkton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1509,
    density: 11.9,
    county_fips: 26063,
    county_name: "Huron",
    county_weights: {
      26063: 100,
    },
    county_names_all: "Huron",
    county_fips_all: 26063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48732,
    lat: 43.60666,
    lng: -83.78274,
    city: "Essexville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11030,
    density: 173,
    county_fips: 26017,
    county_name: "Bay",
    county_weights: {
      26017: 100,
    },
    county_names_all: "Bay",
    county_fips_all: 26017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48733,
    lat: 43.53306,
    lng: -83.59029,
    city: "Fairgrove",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1552,
    density: 11.9,
    county_fips: 26157,
    county_name: "Tuscola",
    county_weights: {
      26157: 100,
    },
    county_names_all: "Tuscola",
    county_fips_all: 26157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48734,
    lat: 43.35519,
    lng: -83.74321,
    city: "Frankenmuth",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7837,
    density: 76,
    county_fips: 26145,
    county_name: "Saginaw",
    county_weights: {
      26145: 89.72,
      26157: 10.28,
    },
    county_names_all: "Saginaw|Tuscola",
    county_fips_all: "26145|26157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48735,
    lat: 43.66861,
    lng: -83.27294,
    city: "Gagetown",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1012,
    density: 10.8,
    county_fips: 26157,
    county_name: "Tuscola",
    county_weights: {
      26063: 46.57,
      26157: 53.43,
    },
    county_names_all: "Tuscola|Huron",
    county_fips_all: "26157|26063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48737,
    lat: 44.54588,
    lng: -83.70871,
    city: "Glennie",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1215,
    density: 4.3,
    county_fips: 26001,
    county_name: "Alcona",
    county_weights: {
      26001: 72.41,
      26069: 27.59,
    },
    county_names_all: "Alcona|Iosco",
    county_fips_all: "26001|26069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48738,
    lat: 44.54995,
    lng: -83.33786,
    city: "Greenbush",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1127,
    density: 34.6,
    county_fips: 26001,
    county_name: "Alcona",
    county_weights: {
      26001: 96.26,
      26069: 3.74,
    },
    county_names_all: "Alcona|Iosco",
    county_fips_all: "26001|26069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48739,
    lat: 44.37597,
    lng: -83.83238,
    city: "Hale",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4077,
    density: 16.4,
    county_fips: 26069,
    county_name: "Iosco",
    county_weights: {
      26069: 70.54,
      26129: 29.46,
    },
    county_names_all: "Iosco|Ogemaw",
    county_fips_all: "26069|26129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48740,
    lat: 44.66014,
    lng: -83.37873,
    city: "Harrisville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2605,
    density: 14.9,
    county_fips: 26001,
    county_name: "Alcona",
    county_weights: {
      26001: 100,
    },
    county_names_all: "Alcona",
    county_fips_all: 26001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48741,
    lat: 43.40487,
    lng: -83.18121,
    city: "Kingston",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1872,
    density: 16,
    county_fips: 26157,
    county_name: "Tuscola",
    county_weights: {
      26157: 100,
    },
    county_names_all: "Tuscola",
    county_fips_all: 26157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48742,
    lat: 44.71934,
    lng: -83.44542,
    city: "Lincoln",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1612,
    density: 9.2,
    county_fips: 26001,
    county_name: "Alcona",
    county_weights: {
      26001: 100,
    },
    county_names_all: "Alcona",
    county_fips_all: 26001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48743,
    lat: 44.44025,
    lng: -83.87066,
    city: "Long Lake",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47,
    density: 8.2,
    county_fips: 26069,
    county_name: "Iosco",
    county_weights: {
      26069: 100,
    },
    county_names_all: "Iosco",
    county_fips_all: 26069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48744,
    lat: 43.34797,
    lng: -83.36051,
    city: "Mayville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4051,
    density: 24.1,
    county_fips: 26157,
    county_name: "Tuscola",
    county_weights: {
      26087: 15.8,
      26157: 84.2,
    },
    county_names_all: "Tuscola|Lapeer",
    county_fips_all: "26157|26087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48745,
    lat: 44.57059,
    lng: -83.47425,
    city: "Mikado",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1279,
    density: 6.9,
    county_fips: 26001,
    county_name: "Alcona",
    county_weights: {
      26001: 97.25,
      26069: 2.75,
    },
    county_names_all: "Alcona|Iosco",
    county_fips_all: "26001|26069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48746,
    lat: 43.26397,
    lng: -83.54155,
    city: "Millington",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8292,
    density: 38.9,
    county_fips: 26157,
    county_name: "Tuscola",
    county_weights: {
      26049: 10.52,
      26157: 89.48,
    },
    county_names_all: "Tuscola|Genesee",
    county_fips_all: "26157|26049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48747,
    lat: 43.52119,
    lng: -83.76085,
    city: "Munger",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1315,
    density: 16,
    county_fips: 26017,
    county_name: "Bay",
    county_weights: {
      26017: 95.88,
      26145: 4.12,
    },
    county_names_all: "Bay|Saginaw",
    county_fips_all: "26017|26145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48748,
    lat: 44.30398,
    lng: -83.67392,
    city: "National City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1578,
    density: 15.2,
    county_fips: 26069,
    county_name: "Iosco",
    county_weights: {
      26069: 100,
    },
    county_names_all: "Iosco",
    county_fips_all: 26069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48749,
    lat: 44.05512,
    lng: -83.89183,
    city: "Omer",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1165,
    density: 11.6,
    county_fips: 26011,
    county_name: "Arenac",
    county_weights: {
      26011: 100,
    },
    county_names_all: "Arenac",
    county_fips_all: 26011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48750,
    lat: 44.44338,
    lng: -83.45652,
    city: "Oscoda",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8775,
    density: 32.7,
    county_fips: 26069,
    county_name: "Iosco",
    county_weights: {
      26001: 3.01,
      26069: 96.99,
    },
    county_names_all: "Iosco|Alcona",
    county_fips_all: "26069|26001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48754,
    lat: 43.734,
    lng: -83.23774,
    city: "Owendale",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 987,
    density: 10.4,
    county_fips: 26063,
    county_name: "Huron",
    county_weights: {
      26063: 100,
    },
    county_names_all: "Huron",
    county_fips_all: 26063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48755,
    lat: 43.83571,
    lng: -83.26832,
    city: "Pigeon",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2759,
    density: 20.5,
    county_fips: 26063,
    county_name: "Huron",
    county_weights: {
      26063: 100,
    },
    county_names_all: "Huron",
    county_fips_all: 26063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48756,
    lat: 44.23142,
    lng: -83.97409,
    city: "Prescott",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4560,
    density: 22,
    county_fips: 26129,
    county_name: "Ogemaw",
    county_weights: {
      26011: 0.33,
      26129: 99.67,
    },
    county_names_all: "Ogemaw|Arenac",
    county_fips_all: "26129|26011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48757,
    lat: 43.46748,
    lng: -83.679,
    city: "Reese",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3831,
    density: 26.8,
    county_fips: 26157,
    county_name: "Tuscola",
    county_weights: {
      26017: 7.41,
      26145: 26.12,
      26157: 66.47,
    },
    county_names_all: "Tuscola|Saginaw|Bay",
    county_fips_all: "26157|26145|26017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48759,
    lat: 43.7265,
    lng: -83.39323,
    city: "Sebewaing",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3250,
    density: 26.1,
    county_fips: 26063,
    county_name: "Huron",
    county_weights: {
      26063: 99.08,
      26157: 0.92,
    },
    county_names_all: "Huron|Tuscola",
    county_fips_all: "26063|26157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48760,
    lat: 43.32095,
    lng: -83.25595,
    city: "Silverwood",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1398,
    density: 20.1,
    county_fips: 26087,
    county_name: "Lapeer",
    county_weights: {
      26087: 54.23,
      26157: 45.77,
    },
    county_names_all: "Lapeer|Tuscola",
    county_fips_all: "26087|26157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48761,
    lat: 44.51129,
    lng: -83.89658,
    city: "South Branch",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 874,
    density: 4.2,
    county_fips: 26129,
    county_name: "Ogemaw",
    county_weights: {
      26001: 30.25,
      26069: 16.76,
      26129: 35.34,
      26135: 17.66,
    },
    county_names_all: "Ogemaw|Alcona|Oscoda|Iosco",
    county_fips_all: "26129|26001|26135|26069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48762,
    lat: 44.80757,
    lng: -83.48695,
    city: "Spruce",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1017,
    density: 6.9,
    county_fips: 26001,
    county_name: "Alcona",
    county_weights: {
      26001: 87.82,
      26007: 12.18,
    },
    county_names_all: "Alcona|Alpena",
    county_fips_all: "26001|26007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48763,
    lat: 44.25017,
    lng: -83.61441,
    city: "Tawas City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4927,
    density: 21.4,
    county_fips: 26069,
    county_name: "Iosco",
    county_weights: {
      26011: 7.33,
      26069: 92.67,
    },
    county_names_all: "Iosco|Arenac",
    county_fips_all: "26069|26011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48765,
    lat: 44.15367,
    lng: -83.71885,
    city: "Turner",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 694,
    density: 4.6,
    county_fips: 26011,
    county_name: "Arenac",
    county_weights: {
      26011: 60.38,
      26069: 39.62,
    },
    county_names_all: "Arenac|Iosco",
    county_fips_all: "26011|26069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48766,
    lat: 44.11128,
    lng: -83.84794,
    city: "Twining",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1340,
    density: 10,
    county_fips: 26011,
    county_name: "Arenac",
    county_weights: {
      26011: 100,
    },
    county_names_all: "Arenac",
    county_fips_all: 26011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48767,
    lat: 43.64172,
    lng: -83.45541,
    city: "Unionville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2307,
    density: 12.2,
    county_fips: 26157,
    county_name: "Tuscola",
    county_weights: {
      26063: 3.1,
      26157: 96.9,
    },
    county_names_all: "Tuscola|Huron",
    county_fips_all: "26157|26063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48768,
    lat: 43.37077,
    lng: -83.57661,
    city: "Vassar",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9245,
    density: 33.7,
    county_fips: 26157,
    county_name: "Tuscola",
    county_weights: {
      26157: 100,
    },
    county_names_all: "Tuscola",
    county_fips_all: 26157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48770,
    lat: 44.24978,
    lng: -83.82037,
    city: "Whittemore",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1607,
    density: 9,
    county_fips: 26069,
    county_name: "Iosco",
    county_weights: {
      26069: 99.4,
      26129: 0.6,
    },
    county_names_all: "Iosco|Ogemaw",
    county_fips_all: "26069|26129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48801,
    lat: 43.37871,
    lng: -84.67667,
    city: "Alma",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13172,
    density: 71.8,
    county_fips: 26057,
    county_name: "Gratiot",
    county_weights: {
      26057: 100,
    },
    county_names_all: "Gratiot",
    county_fips_all: 26057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48806,
    lat: 43.18568,
    lng: -84.49675,
    city: "Ashley",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1780,
    density: 10.7,
    county_fips: 26057,
    county_name: "Gratiot",
    county_weights: {
      26057: 100,
    },
    county_names_all: "Gratiot",
    county_fips_all: 26057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48807,
    lat: 43.15277,
    lng: -84.40671,
    city: "Bannister",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 889,
    density: 13.4,
    county_fips: 26057,
    county_name: "Gratiot",
    county_weights: {
      26057: 79.72,
      26145: 20.28,
    },
    county_names_all: "Gratiot|Saginaw",
    county_fips_all: "26057|26145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48808,
    lat: 42.82591,
    lng: -84.45081,
    city: "Bath",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6957,
    density: 111.5,
    county_fips: 26037,
    county_name: "Clinton",
    county_weights: {
      26037: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 26037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48809,
    lat: 43.0646,
    lng: -85.25712,
    city: "Belding",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11090,
    density: 53.5,
    county_fips: 26067,
    county_name: "Ionia",
    county_weights: {
      26067: 77.38,
      26081: 20.72,
      26117: 1.9,
    },
    county_names_all: "Ionia|Kent|Montcalm",
    county_fips_all: "26067|26081|26117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48811,
    lat: 43.18226,
    lng: -84.85518,
    city: "Carson City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5230,
    density: 32.7,
    county_fips: 26117,
    county_name: "Montcalm",
    county_weights: {
      26057: 36.87,
      26117: 63.13,
    },
    county_names_all: "Montcalm|Gratiot",
    county_fips_all: "26117|26057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48813,
    lat: 42.57862,
    lng: -84.84524,
    city: "Charlotte",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20688,
    density: 47.5,
    county_fips: 26045,
    county_name: "Eaton",
    county_weights: {
      26025: 0.14,
      26045: 99.86,
    },
    county_names_all: "Eaton|Calhoun",
    county_fips_all: "26045|26025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48815,
    lat: 42.84155,
    lng: -85.25387,
    city: "Clarksville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2362,
    density: 34,
    county_fips: 26067,
    county_name: "Ionia",
    county_weights: {
      26067: 98.06,
      26081: 1.94,
    },
    county_names_all: "Ionia|Kent",
    county_fips_all: "26067|26081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48816,
    lat: 42.76151,
    lng: -83.95172,
    city: "Cohoctah",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 381,
    density: 220.3,
    county_fips: 26093,
    county_name: "Livingston",
    county_weights: {
      26093: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 26093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48817,
    lat: 43.01795,
    lng: -84.03772,
    city: "Corunna",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5971,
    density: 39.1,
    county_fips: 26155,
    county_name: "Shiawassee",
    county_weights: {
      26155: 100,
    },
    county_names_all: "Shiawassee",
    county_fips_all: 26155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48818,
    lat: 43.2759,
    lng: -84.89661,
    city: "Crystal",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2451,
    density: 38.3,
    county_fips: 26117,
    county_name: "Montcalm",
    county_weights: {
      26117: 100,
    },
    county_names_all: "Montcalm",
    county_fips_all: 26117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48819,
    lat: 42.54721,
    lng: -84.28521,
    city: "Dansville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2620,
    density: 23.2,
    county_fips: 26065,
    county_name: "Ingham",
    county_weights: {
      26065: 100,
    },
    county_names_all: "Ingham",
    county_fips_all: 26065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48820,
    lat: 42.86277,
    lng: -84.59374,
    city: "Dewitt",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17845,
    density: 104.8,
    county_fips: 26037,
    county_name: "Clinton",
    county_weights: {
      26037: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 26037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48821,
    lat: 42.63873,
    lng: -84.64958,
    city: "Dimondale",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5945,
    density: 115.2,
    county_fips: 26045,
    county_name: "Eaton",
    county_weights: {
      26045: 95.33,
      26065: 4.67,
    },
    county_names_all: "Eaton|Ingham",
    county_fips_all: "26045|26065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48822,
    lat: 42.83407,
    lng: -84.76065,
    city: "Eagle",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2532,
    density: 29.6,
    county_fips: 26037,
    county_name: "Clinton",
    county_weights: {
      26037: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 26037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48823,
    lat: 42.76225,
    lng: -84.45407,
    city: "East Lansing",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50788,
    density: 829.2,
    county_fips: 26065,
    county_name: "Ingham",
    county_weights: {
      26037: 42.61,
      26065: 57.39,
    },
    county_names_all: "Ingham|Clinton",
    county_fips_all: "26065|26037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48824,
    lat: 42.72129,
    lng: -84.47607,
    city: "East Lansing",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 26065,
    county_name: "Ingham",
    county_weights: {
      26065: 100,
    },
    county_names_all: "Ingham",
    county_fips_all: 26065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48825,
    lat: 42.72844,
    lng: -84.48067,
    city: "East Lansing",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12233,
    density: 6870.6,
    county_fips: 26065,
    county_name: "Ingham",
    county_weights: {
      26065: 100,
    },
    county_names_all: "Ingham",
    county_fips_all: 26065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48827,
    lat: 42.509,
    lng: -84.65971,
    city: "Eaton Rapids",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15873,
    density: 53.8,
    county_fips: 26045,
    county_name: "Eaton",
    county_weights: {
      26045: 82.25,
      26065: 15.85,
      26075: 1.9,
    },
    county_names_all: "Eaton|Ingham|Jackson",
    county_fips_all: "26045|26065|26075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48829,
    lat: 43.40027,
    lng: -85.02037,
    city: "Edmore",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3252,
    density: 18.5,
    county_fips: 26117,
    county_name: "Montcalm",
    county_weights: {
      26073: 3.8,
      26117: 96.2,
    },
    county_names_all: "Montcalm|Isabella",
    county_fips_all: "26117|26073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48831,
    lat: 43.10253,
    lng: -84.3744,
    city: "Elsie",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3415,
    density: 18.1,
    county_fips: 26037,
    county_name: "Clinton",
    county_weights: {
      26037: 44.67,
      26057: 1.89,
      26145: 20.44,
      26155: 33,
    },
    county_names_all: "Clinton|Shiawassee|Saginaw|Gratiot",
    county_fips_all: "26037|26155|26145|26057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48832,
    lat: 43.41212,
    lng: -84.77767,
    city: "Elwell",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1257,
    density: 18.9,
    county_fips: 26057,
    county_name: "Gratiot",
    county_weights: {
      26057: 100,
    },
    county_names_all: "Gratiot",
    county_fips_all: 26057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48834,
    lat: 43.12981,
    lng: -85.03108,
    city: "Fenwick",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1926,
    density: 15.4,
    county_fips: 26117,
    county_name: "Montcalm",
    county_weights: {
      26067: 33.06,
      26117: 66.94,
    },
    county_names_all: "Montcalm|Ionia",
    county_fips_all: "26117|26067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48835,
    lat: 43.03008,
    lng: -84.74655,
    city: "Fowler",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3161,
    density: 22.8,
    county_fips: 26037,
    county_name: "Clinton",
    county_weights: {
      26037: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 26037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48836,
    lat: 42.66899,
    lng: -84.07421,
    city: "Fowlerville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14091,
    density: 57.9,
    county_fips: 26093,
    county_name: "Livingston",
    county_weights: {
      26093: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 26093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48837,
    lat: 42.7453,
    lng: -84.76701,
    city: "Grand Ledge",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20551,
    density: 101.2,
    county_fips: 26045,
    county_name: "Eaton",
    county_weights: {
      26037: 24.26,
      26045: 71.21,
      26067: 4.53,
    },
    county_names_all: "Eaton|Clinton|Ionia",
    county_fips_all: "26045|26037|26067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48838,
    lat: 43.18268,
    lng: -85.25943,
    city: "Greenville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17573,
    density: 72.9,
    county_fips: 26117,
    county_name: "Montcalm",
    county_weights: {
      26067: 1.46,
      26081: 21.26,
      26117: 77.28,
    },
    county_names_all: "Montcalm|Kent|Ionia",
    county_fips_all: "26117|26081|26067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48840,
    lat: 42.76685,
    lng: -84.37071,
    city: "Haslett",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12389,
    density: 254.5,
    county_fips: 26065,
    county_name: "Ingham",
    county_weights: {
      26037: 18.19,
      26065: 61.84,
      26155: 19.97,
    },
    county_names_all: "Ingham|Shiawassee|Clinton",
    county_fips_all: "26065|26155|26037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48841,
    lat: 43.11372,
    lng: -84.2392,
    city: "Henderson",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 729,
    density: 12.1,
    county_fips: 26155,
    county_name: "Shiawassee",
    county_weights: {
      26145: 20.4,
      26155: 79.6,
    },
    county_names_all: "Shiawassee|Saginaw",
    county_fips_all: "26155|26145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48842,
    lat: 42.63469,
    lng: -84.53931,
    city: "Holt",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21950,
    density: 492.5,
    county_fips: 26065,
    county_name: "Ingham",
    county_weights: {
      26045: 1.71,
      26065: 98.29,
    },
    county_names_all: "Ingham|Eaton",
    county_fips_all: "26065|26045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48843,
    lat: 42.56891,
    lng: -83.92333,
    city: "Howell",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45906,
    density: 197.7,
    county_fips: 26093,
    county_name: "Livingston",
    county_weights: {
      26093: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 26093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48845,
    lat: 43.10746,
    lng: -84.854,
    city: "Hubbardston",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 853,
    density: 14.2,
    county_fips: 26067,
    county_name: "Ionia",
    county_weights: {
      26037: 29.59,
      26057: 8.55,
      26067: 43.57,
      26117: 18.28,
    },
    county_names_all: "Ionia|Clinton|Montcalm|Gratiot",
    county_fips_all: "26067|26037|26117|26057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48846,
    lat: 42.98611,
    lng: -85.05754,
    city: "Ionia",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20142,
    density: 70.3,
    county_fips: 26067,
    county_name: "Ionia",
    county_weights: {
      26067: 100,
    },
    county_names_all: "Ionia",
    county_fips_all: 26067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48847,
    lat: 43.2714,
    lng: -84.5776,
    city: "Ithaca",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5526,
    density: 17.7,
    county_fips: 26057,
    county_name: "Gratiot",
    county_weights: {
      26057: 100,
    },
    county_names_all: "Gratiot",
    county_fips_all: 26057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48848,
    lat: 42.88584,
    lng: -84.35673,
    city: "Laingsburg",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7730,
    density: 43.8,
    county_fips: 26155,
    county_name: "Shiawassee",
    county_weights: {
      26037: 41.01,
      26155: 58.99,
    },
    county_names_all: "Shiawassee|Clinton",
    county_fips_all: "26155|26037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48849,
    lat: 42.7984,
    lng: -85.13298,
    city: "Lake Odessa",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5990,
    density: 27.6,
    county_fips: 26067,
    county_name: "Ionia",
    county_weights: {
      26015: 17.89,
      26045: 4.94,
      26067: 77.17,
    },
    county_names_all: "Ionia|Barry|Eaton",
    county_fips_all: "26067|26015|26045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48850,
    lat: 43.4374,
    lng: -85.25519,
    city: "Lakeview",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4405,
    density: 20.4,
    county_fips: 26117,
    county_name: "Montcalm",
    county_weights: {
      26107: 32.82,
      26117: 67.18,
    },
    county_names_all: "Montcalm|Mecosta",
    county_fips_all: "26117|26107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48851,
    lat: 42.95469,
    lng: -84.9364,
    city: "Lyons",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2043,
    density: 23.9,
    county_fips: 26067,
    county_name: "Ionia",
    county_weights: {
      26067: 100,
    },
    county_names_all: "Ionia",
    county_fips_all: 26067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48852,
    lat: 43.35256,
    lng: -85.04652,
    city: "Mcbrides",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 138,
    density: 278.9,
    county_fips: 26117,
    county_name: "Montcalm",
    county_weights: {
      26117: 100,
    },
    county_names_all: "Montcalm",
    county_fips_all: 26117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48853,
    lat: 43.10371,
    lng: -84.68999,
    city: "Maple Rapids",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 640,
    density: 390.4,
    county_fips: 26037,
    county_name: "Clinton",
    county_weights: {
      26037: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 26037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48854,
    lat: 42.58199,
    lng: -84.45182,
    city: "Mason",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19739,
    density: 67.2,
    county_fips: 26065,
    county_name: "Ingham",
    county_weights: {
      26065: 100,
    },
    county_names_all: "Ingham",
    county_fips_all: 26065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48855,
    lat: 42.68759,
    lng: -83.91331,
    city: "Howell",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15644,
    density: 66.3,
    county_fips: 26093,
    county_name: "Livingston",
    county_weights: {
      26093: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 26093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48856,
    lat: 43.19994,
    lng: -84.7372,
    city: "Middleton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 876,
    density: 12.1,
    county_fips: 26057,
    county_name: "Gratiot",
    county_weights: {
      26057: 100,
    },
    county_names_all: "Gratiot",
    county_fips_all: 26057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48857,
    lat: 42.84243,
    lng: -84.15503,
    city: "Morrice",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3232,
    density: 50.8,
    county_fips: 26155,
    county_name: "Shiawassee",
    county_weights: {
      26155: 100,
    },
    county_names_all: "Shiawassee",
    county_fips_all: 26155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48858,
    lat: 43.61483,
    lng: -84.79576,
    city: "Mount Pleasant",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50340,
    density: 111.5,
    county_fips: 26073,
    county_name: "Isabella",
    county_weights: {
      26073: 98.61,
      26111: 1.39,
    },
    county_names_all: "Isabella|Midland",
    county_fips_all: "26073|26111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48859,
    lat: 43.58632,
    lng: -84.77341,
    city: "Mount Pleasant",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 26073,
    county_name: "Isabella",
    county_weights: {
      26073: 100,
    },
    county_names_all: "Isabella",
    county_fips_all: 26073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48860,
    lat: 43.05089,
    lng: -84.90939,
    city: "Muir",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1793,
    density: 24.6,
    county_fips: 26067,
    county_name: "Ionia",
    county_weights: {
      26067: 100,
    },
    county_names_all: "Ionia",
    county_fips_all: 26067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48861,
    lat: 42.73002,
    lng: -84.91741,
    city: "Mulliken",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1738,
    density: 25.6,
    county_fips: 26045,
    county_name: "Eaton",
    county_weights: {
      26045: 91.49,
      26067: 8.51,
    },
    county_names_all: "Eaton|Ionia",
    county_fips_all: "26045|26067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48862,
    lat: 43.24987,
    lng: -84.54847,
    city: "North Star",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 26057,
    county_name: "Gratiot",
    county_weights: {
      26057: 100,
    },
    county_names_all: "Gratiot",
    county_fips_all: 26057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48864,
    lat: 42.70215,
    lng: -84.40902,
    city: "Okemos",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23882,
    density: 459.1,
    county_fips: 26065,
    county_name: "Ingham",
    county_weights: {
      26065: 100,
    },
    county_names_all: "Ingham",
    county_fips_all: 26065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48865,
    lat: 43.08785,
    lng: -85.10725,
    city: "Orleans",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2090,
    density: 37.8,
    county_fips: 26067,
    county_name: "Ionia",
    county_weights: {
      26067: 100,
    },
    county_names_all: "Ionia",
    county_fips_all: 26067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48866,
    lat: 42.99303,
    lng: -84.37219,
    city: "Ovid",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4555,
    density: 35.5,
    county_fips: 26037,
    county_name: "Clinton",
    county_weights: {
      26037: 55.39,
      26155: 44.61,
    },
    county_names_all: "Clinton|Shiawassee",
    county_fips_all: "26037|26155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48867,
    lat: 43.00537,
    lng: -84.18766,
    city: "Owosso",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27004,
    density: 76.7,
    county_fips: 26155,
    county_name: "Shiawassee",
    county_weights: {
      26155: 100,
    },
    county_names_all: "Shiawassee",
    county_fips_all: 26155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48870,
    lat: 43.11027,
    lng: -84.98483,
    city: "Palo",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 274,
    density: 1692.5,
    county_fips: 26067,
    county_name: "Ionia",
    county_weights: {
      26067: 100,
    },
    county_names_all: "Ionia",
    county_fips_all: 26067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48871,
    lat: 43.15476,
    lng: -84.67874,
    city: "Perrinton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2023,
    density: 26.8,
    county_fips: 26057,
    county_name: "Gratiot",
    county_weights: {
      26057: 100,
    },
    county_names_all: "Gratiot",
    county_fips_all: 26057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48872,
    lat: 42.80065,
    lng: -84.2189,
    city: "Perry",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6438,
    density: 44.8,
    county_fips: 26155,
    county_name: "Shiawassee",
    county_weights: {
      26065: 16.06,
      26093: 3.66,
      26155: 80.28,
    },
    county_names_all: "Shiawassee|Ingham|Livingston",
    county_fips_all: "26155|26065|26093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48873,
    lat: 43.00978,
    lng: -84.83608,
    city: "Pewamo",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1568,
    density: 19.4,
    county_fips: 26067,
    county_name: "Ionia",
    county_weights: {
      26037: 49.93,
      26067: 50.07,
    },
    county_names_all: "Ionia|Clinton",
    county_fips_all: "26067|26037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48874,
    lat: 43.18644,
    lng: -84.59498,
    city: "Pompeii",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 186,
    density: 124.7,
    county_fips: 26057,
    county_name: "Gratiot",
    county_weights: {
      26057: 100,
    },
    county_names_all: "Gratiot",
    county_fips_all: 26057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48875,
    lat: 42.8578,
    lng: -84.93201,
    city: "Portland",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10887,
    density: 49.3,
    county_fips: 26067,
    county_name: "Ionia",
    county_weights: {
      26037: 9.94,
      26067: 90.06,
    },
    county_names_all: "Ionia|Clinton",
    county_fips_all: "26067|26037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48876,
    lat: 42.64757,
    lng: -84.73631,
    city: "Potterville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4223,
    density: 120.9,
    county_fips: 26045,
    county_name: "Eaton",
    county_weights: {
      26045: 100,
    },
    county_names_all: "Eaton",
    county_fips_all: 26045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48877,
    lat: 43.40068,
    lng: -84.84316,
    city: "Riverdale",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2022,
    density: 21.1,
    county_fips: 26057,
    county_name: "Gratiot",
    county_weights: {
      26057: 46.02,
      26073: 12.52,
      26117: 41.45,
    },
    county_names_all: "Gratiot|Montcalm|Isabella",
    county_fips_all: "26057|26117|26073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48878,
    lat: 43.71225,
    lng: -84.77686,
    city: "Rosebush",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1685,
    density: 20.2,
    county_fips: 26073,
    county_name: "Isabella",
    county_weights: {
      26073: 100,
    },
    county_names_all: "Isabella",
    county_fips_all: 26073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48879,
    lat: 43.00629,
    lng: -84.57981,
    city: "Saint Johns",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18599,
    density: 37.5,
    county_fips: 26037,
    county_name: "Clinton",
    county_weights: {
      26037: 96.12,
      26057: 3.88,
    },
    county_names_all: "Clinton|Gratiot",
    county_fips_all: "26037|26057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48880,
    lat: 43.458,
    lng: -84.57135,
    city: "Saint Louis",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10071,
    density: 52,
    county_fips: 26057,
    county_name: "Gratiot",
    county_weights: {
      26057: 54.06,
      26073: 7.83,
      26111: 38.11,
    },
    county_names_all: "Gratiot|Midland|Isabella",
    county_fips_all: "26057|26111|26073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48881,
    lat: 42.934,
    lng: -85.20214,
    city: "Saranac",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5567,
    density: 39.8,
    county_fips: 26067,
    county_name: "Ionia",
    county_weights: {
      26067: 100,
    },
    county_names_all: "Ionia",
    county_fips_all: 26067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48883,
    lat: 43.54336,
    lng: -84.66771,
    city: "Shepherd",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7114,
    density: 23.9,
    county_fips: 26073,
    county_name: "Isabella",
    county_weights: {
      26057: 0.28,
      26073: 64.7,
      26111: 35.02,
    },
    county_names_all: "Isabella|Midland|Gratiot",
    county_fips_all: "26073|26111|26057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48884,
    lat: 43.20731,
    lng: -85.04249,
    city: "Sheridan",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4938,
    density: 31.1,
    county_fips: 26117,
    county_name: "Montcalm",
    county_weights: {
      26117: 100,
    },
    county_names_all: "Montcalm",
    county_fips_all: 26117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48885,
    lat: 43.24908,
    lng: -85.14356,
    city: "Sidney",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 964,
    density: 21.2,
    county_fips: 26117,
    county_name: "Montcalm",
    county_weights: {
      26117: 100,
    },
    county_names_all: "Montcalm",
    county_fips_all: 26117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48886,
    lat: 43.41994,
    lng: -85.16092,
    city: "Six Lakes",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1843,
    density: 22.7,
    county_fips: 26117,
    county_name: "Montcalm",
    county_weights: {
      26107: 4.4,
      26117: 95.6,
    },
    county_names_all: "Montcalm|Mecosta",
    county_fips_all: "26117|26107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48888,
    lat: 43.3089,
    lng: -85.09566,
    city: "Stanton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5983,
    density: 27.1,
    county_fips: 26117,
    county_name: "Montcalm",
    county_weights: {
      26117: 100,
    },
    county_names_all: "Montcalm",
    county_fips_all: 26117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48889,
    lat: 43.29133,
    lng: -84.79701,
    city: "Sumner",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1248,
    density: 15.5,
    county_fips: 26057,
    county_name: "Gratiot",
    county_weights: {
      26057: 98.51,
      26117: 1.49,
    },
    county_names_all: "Gratiot|Montcalm",
    county_fips_all: "26057|26117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48890,
    lat: 42.76878,
    lng: -84.97167,
    city: "Sunfield",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1976,
    density: 24.1,
    county_fips: 26045,
    county_name: "Eaton",
    county_weights: {
      26045: 53.34,
      26067: 46.66,
    },
    county_names_all: "Eaton|Ionia",
    county_fips_all: "26045|26067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48891,
    lat: 43.39676,
    lng: -84.91469,
    city: "Vestaburg",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3066,
    density: 29.4,
    county_fips: 26117,
    county_name: "Montcalm",
    county_weights: {
      26117: 100,
    },
    county_names_all: "Montcalm",
    county_fips_all: 26117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48892,
    lat: 42.63662,
    lng: -84.17477,
    city: "Webberville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4586,
    density: 32.1,
    county_fips: 26065,
    county_name: "Ingham",
    county_weights: {
      26065: 79.43,
      26093: 20.57,
    },
    county_names_all: "Ingham|Livingston",
    county_fips_all: "26065|26093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48893,
    lat: 43.68329,
    lng: -84.97805,
    city: "Weidman",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5242,
    density: 39.5,
    county_fips: 26073,
    county_name: "Isabella",
    county_weights: {
      26073: 100,
    },
    county_names_all: "Isabella",
    county_fips_all: 26073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48894,
    lat: 42.92841,
    lng: -84.79489,
    city: "Westphalia",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1801,
    density: 20.2,
    county_fips: 26037,
    county_name: "Clinton",
    county_weights: {
      26037: 86.3,
      26067: 13.7,
    },
    county_names_all: "Clinton|Ionia",
    county_fips_all: "26037|26067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48895,
    lat: 42.68946,
    lng: -84.28061,
    city: "Williamston",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11563,
    density: 53.9,
    county_fips: 26065,
    county_name: "Ingham",
    county_weights: {
      26065: 100,
    },
    county_names_all: "Ingham",
    county_fips_all: 26065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48896,
    lat: 43.52127,
    lng: -84.90101,
    city: "Winn",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 372,
    density: 530.8,
    county_fips: 26073,
    county_name: "Isabella",
    county_weights: {
      26073: 100,
    },
    county_names_all: "Isabella",
    county_fips_all: 26073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48897,
    lat: 42.70498,
    lng: -85.13193,
    city: "Woodland",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1585,
    density: 18.9,
    county_fips: 26015,
    county_name: "Barry",
    county_weights: {
      26015: 97.38,
      26045: 2.62,
    },
    county_names_all: "Barry|Eaton",
    county_fips_all: "26015|26045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48906,
    lat: 42.78489,
    lng: -84.58886,
    city: "Lansing",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27253,
    density: 323.5,
    county_fips: 26037,
    county_name: "Clinton",
    county_weights: {
      26037: 77.23,
      26045: 5.73,
      26065: 17.04,
    },
    county_names_all: "Clinton|Ingham|Eaton",
    county_fips_all: "26037|26065|26045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48910,
    lat: 42.6969,
    lng: -84.52541,
    city: "Lansing",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34989,
    density: 950.4,
    county_fips: 26065,
    county_name: "Ingham",
    county_weights: {
      26065: 100,
    },
    county_names_all: "Ingham",
    county_fips_all: 26065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48911,
    lat: 42.67351,
    lng: -84.57285,
    city: "Lansing",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40924,
    density: 911.4,
    county_fips: 26065,
    county_name: "Ingham",
    county_weights: {
      26045: 20.08,
      26065: 79.92,
    },
    county_names_all: "Ingham|Eaton",
    county_fips_all: "26065|26045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48912,
    lat: 42.73896,
    lng: -84.52319,
    city: "Lansing",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17259,
    density: 1270.8,
    county_fips: 26065,
    county_name: "Ingham",
    county_weights: {
      26065: 100,
    },
    county_names_all: "Ingham",
    county_fips_all: 26065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48915,
    lat: 42.73885,
    lng: -84.57076,
    city: "Lansing",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10600,
    density: 2271.8,
    county_fips: 26065,
    county_name: "Ingham",
    county_weights: {
      26065: 100,
    },
    county_names_all: "Ingham",
    county_fips_all: 26065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48917,
    lat: 42.72509,
    lng: -84.63897,
    city: "Lansing",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32191,
    density: 518.4,
    county_fips: 26045,
    county_name: "Eaton",
    county_weights: {
      26045: 86.33,
      26065: 13.67,
    },
    county_names_all: "Eaton|Ingham",
    county_fips_all: "26045|26065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 48933,
    lat: 42.72956,
    lng: -84.55595,
    city: "Lansing",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2596,
    density: 959.5,
    county_fips: 26065,
    county_name: "Ingham",
    county_weights: {
      26065: 100,
    },
    county_names_all: "Ingham",
    county_fips_all: 26065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49001,
    lat: 42.2647,
    lng: -85.56265,
    city: "Kalamazoo",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21808,
    density: 1097.3,
    county_fips: 26077,
    county_name: "Kalamazoo",
    county_weights: {
      26077: 100,
    },
    county_names_all: "Kalamazoo",
    county_fips_all: 26077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49002,
    lat: 42.19867,
    lng: -85.55906,
    city: "Portage",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20619,
    density: 460.4,
    county_fips: 26077,
    county_name: "Kalamazoo",
    county_weights: {
      26077: 100,
    },
    county_names_all: "Kalamazoo",
    county_fips_all: 26077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49004,
    lat: 42.34903,
    lng: -85.55954,
    city: "Kalamazoo",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17005,
    density: 297.8,
    county_fips: 26077,
    county_name: "Kalamazoo",
    county_weights: {
      26077: 100,
    },
    county_names_all: "Kalamazoo",
    county_fips_all: 26077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49006,
    lat: 42.29539,
    lng: -85.6291,
    city: "Kalamazoo",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27793,
    density: 1797,
    county_fips: 26077,
    county_name: "Kalamazoo",
    county_weights: {
      26077: 100,
    },
    county_names_all: "Kalamazoo",
    county_fips_all: 26077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49007,
    lat: 42.30252,
    lng: -85.5883,
    city: "Kalamazoo",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10900,
    density: 1205,
    county_fips: 26077,
    county_name: "Kalamazoo",
    county_weights: {
      26077: 100,
    },
    county_names_all: "Kalamazoo",
    county_fips_all: 26077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49008,
    lat: 42.26337,
    lng: -85.61528,
    city: "Kalamazoo",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16466,
    density: 946,
    county_fips: 26077,
    county_name: "Kalamazoo",
    county_weights: {
      26077: 100,
    },
    county_names_all: "Kalamazoo",
    county_fips_all: 26077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49009,
    lat: 42.30913,
    lng: -85.69278,
    city: "Kalamazoo",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46734,
    density: 176.6,
    county_fips: 26077,
    county_name: "Kalamazoo",
    county_weights: {
      26077: 95.9,
      26159: 4.1,
    },
    county_names_all: "Kalamazoo|Van Buren",
    county_fips_all: "26077|26159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49010,
    lat: 42.53418,
    lng: -85.87298,
    city: "Allegan",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17494,
    density: 43.1,
    county_fips: 26005,
    county_name: "Allegan",
    county_weights: {
      26005: 99.08,
      26159: 0.92,
    },
    county_names_all: "Allegan|Van Buren",
    county_fips_all: "26005|26159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49011,
    lat: 42.10288,
    lng: -85.22285,
    city: "Athens",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2308,
    density: 29.4,
    county_fips: 26025,
    county_name: "Calhoun",
    county_weights: {
      26023: 9.04,
      26025: 89.29,
      26149: 1.67,
    },
    county_names_all: "Calhoun|Branch|St. Joseph",
    county_fips_all: "26025|26023|26149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49012,
    lat: 42.34626,
    lng: -85.34116,
    city: "Augusta",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3256,
    density: 29.8,
    county_fips: 26077,
    county_name: "Kalamazoo",
    county_weights: {
      26025: 1.69,
      26077: 98.31,
    },
    county_names_all: "Kalamazoo|Calhoun",
    county_fips_all: "26077|26025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49013,
    lat: 42.30524,
    lng: -86.10796,
    city: "Bangor",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5631,
    density: 38.1,
    county_fips: 26159,
    county_name: "Van Buren",
    county_weights: {
      26159: 100,
    },
    county_names_all: "Van Buren",
    county_fips_all: 26159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49014,
    lat: 42.30996,
    lng: -85.10711,
    city: "Battle Creek",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21694,
    density: 115.5,
    county_fips: 26025,
    county_name: "Calhoun",
    county_weights: {
      26025: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 26025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49015,
    lat: 42.27467,
    lng: -85.23115,
    city: "Battle Creek",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27287,
    density: 387.4,
    county_fips: 26025,
    county_name: "Calhoun",
    county_weights: {
      26025: 99.89,
      26077: 0.11,
    },
    county_names_all: "Calhoun|Kalamazoo",
    county_fips_all: "26025|26077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49017,
    lat: 42.3979,
    lng: -85.2111,
    city: "Battle Creek",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20710,
    density: 140.9,
    county_fips: 26025,
    county_name: "Calhoun",
    county_weights: {
      26015: 23.51,
      26025: 76.49,
    },
    county_names_all: "Calhoun|Barry",
    county_fips_all: "26025|26015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49021,
    lat: 42.4588,
    lng: -85.06435,
    city: "Bellevue",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6277,
    density: 25.8,
    county_fips: 26045,
    county_name: "Eaton",
    county_weights: {
      26015: 39.02,
      26025: 15.35,
      26045: 45.63,
    },
    county_names_all: "Eaton|Barry|Calhoun",
    county_fips_all: "26045|26015|26025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49022,
    lat: 42.11434,
    lng: -86.3675,
    city: "Benton Harbor",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30761,
    density: 176.6,
    county_fips: 26021,
    county_name: "Berrien",
    county_weights: {
      26021: 97.33,
      26159: 2.67,
    },
    county_names_all: "Berrien|Van Buren",
    county_fips_all: "26021|26159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49024,
    lat: 42.20207,
    lng: -85.61917,
    city: "Portage",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29822,
    density: 667.7,
    county_fips: 26077,
    county_name: "Kalamazoo",
    county_weights: {
      26077: 100,
    },
    county_names_all: "Kalamazoo",
    county_fips_all: 26077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49026,
    lat: 42.37778,
    lng: -85.96273,
    city: "Bloomingdale",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2082,
    density: 27.5,
    county_fips: 26159,
    county_name: "Van Buren",
    county_weights: {
      26005: 12,
      26159: 88,
    },
    county_names_all: "Van Buren|Allegan",
    county_fips_all: "26159|26005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49027,
    lat: 42.3482,
    lng: -86.06939,
    city: "Breedsville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 363,
    density: 291.5,
    county_fips: 26159,
    county_name: "Van Buren",
    county_weights: {
      26159: 100,
    },
    county_names_all: "Van Buren",
    county_fips_all: 26159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49028,
    lat: 41.84438,
    lng: -85.1837,
    city: "Bronson",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5863,
    density: 19.4,
    county_fips: 26023,
    county_name: "Branch",
    county_weights: {
      26023: 100,
    },
    county_names_all: "Branch",
    county_fips_all: 26023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49029,
    lat: 42.1423,
    lng: -85.09107,
    city: "Burlington",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1442,
    density: 14.8,
    county_fips: 26025,
    county_name: "Calhoun",
    county_weights: {
      26025: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 26025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49030,
    lat: 41.85529,
    lng: -85.33129,
    city: "Burr Oak",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2568,
    density: 20.1,
    county_fips: 26149,
    county_name: "St. Joseph",
    county_weights: {
      26023: 13.64,
      26149: 86.36,
    },
    county_names_all: "St. Joseph|Branch",
    county_fips_all: "26149|26023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49031,
    lat: 41.89883,
    lng: -85.98849,
    city: "Cassopolis",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8224,
    density: 28.1,
    county_fips: 26027,
    county_name: "Cass",
    county_weights: {
      26027: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 26027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49032,
    lat: 41.91779,
    lng: -85.50767,
    city: "Centreville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3384,
    density: 36.7,
    county_fips: 26149,
    county_name: "St. Joseph",
    county_weights: {
      26149: 100,
    },
    county_names_all: "St. Joseph",
    county_fips_all: 26149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49033,
    lat: 42.22654,
    lng: -85.09193,
    city: "Ceresco",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1565,
    density: 18.4,
    county_fips: 26025,
    county_name: "Calhoun",
    county_weights: {
      26025: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 26025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49034,
    lat: 42.23178,
    lng: -85.33403,
    city: "Climax",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2542,
    density: 26.5,
    county_fips: 26077,
    county_name: "Kalamazoo",
    county_weights: {
      26025: 20.7,
      26077: 79.3,
    },
    county_names_all: "Kalamazoo|Calhoun",
    county_fips_all: "26077|26025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49036,
    lat: 41.90565,
    lng: -85.02391,
    city: "Coldwater",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23808,
    density: 59.6,
    county_fips: 26023,
    county_name: "Branch",
    county_weights: {
      26023: 100,
    },
    county_names_all: "Branch",
    county_fips_all: 26023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49037,
    lat: 42.33448,
    lng: -85.24706,
    city: "Battle Creek",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20845,
    density: 416.6,
    county_fips: 26025,
    county_name: "Calhoun",
    county_weights: {
      26025: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 26025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49038,
    lat: 42.20554,
    lng: -86.32489,
    city: "Coloma",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9126,
    density: 90.4,
    county_fips: 26021,
    county_name: "Berrien",
    county_weights: {
      26021: 86.67,
      26159: 13.33,
    },
    county_names_all: "Berrien|Van Buren",
    county_fips_all: "26021|26159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49040,
    lat: 41.96847,
    lng: -85.32398,
    city: "Colon",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3356,
    density: 31.5,
    county_fips: 26149,
    county_name: "St. Joseph",
    county_weights: {
      26023: 26.47,
      26149: 73.53,
    },
    county_names_all: "St. Joseph|Branch",
    county_fips_all: "26149|26023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49042,
    lat: 41.85665,
    lng: -85.67142,
    city: "Constantine",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4603,
    density: 31.1,
    county_fips: 26149,
    county_name: "St. Joseph",
    county_weights: {
      26027: 7.9,
      26149: 92.1,
    },
    county_names_all: "St. Joseph|Cass",
    county_fips_all: "26149|26027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49043,
    lat: 42.28658,
    lng: -86.2656,
    city: "Covert",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2269,
    density: 28.5,
    county_fips: 26159,
    county_name: "Van Buren",
    county_weights: {
      26159: 100,
    },
    county_names_all: "Van Buren",
    county_fips_all: 26159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49045,
    lat: 42.1038,
    lng: -86.00219,
    city: "Decatur",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5569,
    density: 24.9,
    county_fips: 26159,
    county_name: "Van Buren",
    county_weights: {
      26027: 20,
      26159: 80,
    },
    county_names_all: "Van Buren|Cass",
    county_fips_all: "26159|26027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49046,
    lat: 42.51229,
    lng: -85.40249,
    city: "Delton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7337,
    density: 35.3,
    county_fips: 26015,
    county_name: "Barry",
    county_weights: {
      26015: 100,
    },
    county_names_all: "Barry",
    county_fips_all: 26015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49047,
    lat: 42.00437,
    lng: -86.12138,
    city: "Dowagiac",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14578,
    density: 47.2,
    county_fips: 26027,
    county_name: "Cass",
    county_weights: {
      26021: 1.83,
      26027: 90.33,
      26159: 7.84,
    },
    county_names_all: "Cass|Van Buren|Berrien",
    county_fips_all: "26027|26159|26021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49048,
    lat: 42.27202,
    lng: -85.49893,
    city: "Kalamazoo",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24279,
    density: 266.7,
    county_fips: 26077,
    county_name: "Kalamazoo",
    county_weights: {
      26077: 100,
    },
    county_names_all: "Kalamazoo",
    county_fips_all: 26077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49050,
    lat: 42.50598,
    lng: -85.23651,
    city: "Dowling",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1556,
    density: 23.6,
    county_fips: 26015,
    county_name: "Barry",
    county_weights: {
      26015: 100,
    },
    county_names_all: "Barry",
    county_fips_all: 26015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49051,
    lat: 42.18207,
    lng: -85.23803,
    city: "East Leroy",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2812,
    density: 38.7,
    county_fips: 26025,
    county_name: "Calhoun",
    county_weights: {
      26025: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 26025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49052,
    lat: 42.11538,
    lng: -85.31936,
    city: "Fulton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 998,
    density: 12.1,
    county_fips: 26077,
    county_name: "Kalamazoo",
    county_weights: {
      26025: 22.98,
      26077: 77.02,
    },
    county_names_all: "Kalamazoo|Calhoun",
    county_fips_all: "26077|26025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49053,
    lat: 42.28877,
    lng: -85.41722,
    city: "Galesburg",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7815,
    density: 123.7,
    county_fips: 26077,
    county_name: "Kalamazoo",
    county_weights: {
      26077: 100,
    },
    county_names_all: "Kalamazoo",
    county_fips_all: 26077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49055,
    lat: 42.37022,
    lng: -85.85327,
    city: "Gobles",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6037,
    density: 40.5,
    county_fips: 26159,
    county_name: "Van Buren",
    county_weights: {
      26005: 7.51,
      26159: 92.49,
    },
    county_names_all: "Van Buren|Allegan",
    county_fips_all: "26159|26005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49056,
    lat: 42.39951,
    lng: -86.05967,
    city: "Grand Junction",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3592,
    density: 24,
    county_fips: 26159,
    county_name: "Van Buren",
    county_weights: {
      26005: 36.38,
      26159: 63.62,
    },
    county_names_all: "Van Buren|Allegan",
    county_fips_all: "26159|26005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49057,
    lat: 42.18647,
    lng: -86.16691,
    city: "Hartford",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6320,
    density: 49.6,
    county_fips: 26159,
    county_name: "Van Buren",
    county_weights: {
      26159: 100,
    },
    county_names_all: "Van Buren",
    county_fips_all: 26159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49058,
    lat: 42.63331,
    lng: -85.29316,
    city: "Hastings",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19642,
    density: 51.4,
    county_fips: 26015,
    county_name: "Barry",
    county_weights: {
      26015: 100,
    },
    county_names_all: "Barry",
    county_fips_all: 26015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49060,
    lat: 42.42738,
    lng: -85.39589,
    city: "Hickory Corners",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2700,
    density: 52.8,
    county_fips: 26015,
    county_name: "Barry",
    county_weights: {
      26015: 73.68,
      26077: 26.32,
    },
    county_names_all: "Barry|Kalamazoo",
    county_fips_all: "26015|26077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49061,
    lat: 41.87964,
    lng: -85.82551,
    city: "Jones",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1675,
    density: 17,
    county_fips: 26027,
    county_name: "Cass",
    county_weights: {
      26027: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 26027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49063,
    lat: 42.4098,
    lng: -86.1396,
    city: "Lacota",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 26159,
    county_name: "Van Buren",
    county_weights: {
      26159: 100,
    },
    county_names_all: "Van Buren",
    county_fips_all: 26159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49064,
    lat: 42.22028,
    lng: -86.04991,
    city: "Lawrence",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3698,
    density: 29.7,
    county_fips: 26159,
    county_name: "Van Buren",
    county_weights: {
      26159: 100,
    },
    county_names_all: "Van Buren",
    county_fips_all: 26159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49065,
    lat: 42.13645,
    lng: -85.83928,
    city: "Lawton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6355,
    density: 54.7,
    county_fips: 26159,
    county_name: "Van Buren",
    county_weights: {
      26077: 1.23,
      26159: 98.77,
    },
    county_names_all: "Van Buren|Kalamazoo",
    county_fips_all: "26159|26077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49066,
    lat: 42.03319,
    lng: -85.35007,
    city: "Leonidas",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 482,
    density: 8.9,
    county_fips: 26149,
    county_name: "St. Joseph",
    county_weights: {
      26149: 100,
    },
    county_names_all: "St. Joseph",
    county_fips_all: 26149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49067,
    lat: 42.02359,
    lng: -85.79982,
    city: "Marcellus",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4150,
    density: 19.5,
    county_fips: 26027,
    county_name: "Cass",
    county_weights: {
      26027: 63.8,
      26149: 28.61,
      26159: 7.59,
    },
    county_names_all: "Cass|St. Joseph|Van Buren",
    county_fips_all: "26027|26149|26159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49068,
    lat: 42.2765,
    lng: -84.94063,
    city: "Marshall",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15222,
    density: 45.2,
    county_fips: 26025,
    county_name: "Calhoun",
    county_weights: {
      26025: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 26025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49070,
    lat: 42.54023,
    lng: -85.62879,
    city: "Martin",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2390,
    density: 35.4,
    county_fips: 26005,
    county_name: "Allegan",
    county_weights: {
      26005: 100,
    },
    county_names_all: "Allegan",
    county_fips_all: 26005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49071,
    lat: 42.2275,
    lng: -85.78002,
    city: "Mattawan",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11022,
    density: 144.7,
    county_fips: 26159,
    county_name: "Van Buren",
    county_weights: {
      26077: 25.86,
      26159: 74.14,
    },
    county_names_all: "Van Buren|Kalamazoo",
    county_fips_all: "26159|26077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49072,
    lat: 42.01295,
    lng: -85.45825,
    city: "Mendon",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2726,
    density: 18,
    county_fips: 26149,
    county_name: "St. Joseph",
    county_weights: {
      26077: 3.67,
      26149: 96.33,
    },
    county_names_all: "St. Joseph|Kalamazoo",
    county_fips_all: "26149|26077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49073,
    lat: 42.57971,
    lng: -85.11717,
    city: "Nashville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4983,
    density: 27.3,
    county_fips: 26015,
    county_name: "Barry",
    county_weights: {
      26015: 84.75,
      26045: 15.25,
    },
    county_names_all: "Barry|Eaton",
    county_fips_all: "26015|26045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49074,
    lat: 42.3198,
    lng: -85.53991,
    city: "Nazareth",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 146,
    density: 224.6,
    county_fips: 26077,
    county_name: "Kalamazoo",
    county_weights: {
      26077: 100,
    },
    county_names_all: "Kalamazoo",
    county_fips_all: 26077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49075,
    lat: 41.91783,
    lng: -85.44899,
    city: "Nottawa",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 241,
    density: 1738.2,
    county_fips: 26149,
    county_name: "St. Joseph",
    county_weights: {
      26149: 100,
    },
    county_names_all: "St. Joseph",
    county_fips_all: 26149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49076,
    lat: 42.4309,
    lng: -84.88657,
    city: "Olivet",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4507,
    density: 30.5,
    county_fips: 26045,
    county_name: "Eaton",
    county_weights: {
      26025: 45.64,
      26045: 54.36,
    },
    county_names_all: "Eaton|Calhoun",
    county_fips_all: "26045|26025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49078,
    lat: 42.46585,
    lng: -85.72846,
    city: "Otsego",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9738,
    density: 75.9,
    county_fips: 26005,
    county_name: "Allegan",
    county_weights: {
      26005: 84.93,
      26077: 12.06,
      26159: 3.01,
    },
    county_names_all: "Allegan|Kalamazoo|Van Buren",
    county_fips_all: "26005|26077|26159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49079,
    lat: 42.23997,
    lng: -85.90901,
    city: "Paw Paw",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12750,
    density: 59.1,
    county_fips: 26159,
    county_name: "Van Buren",
    county_weights: {
      26159: 100,
    },
    county_names_all: "Van Buren",
    county_fips_all: 26159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49080,
    lat: 42.46086,
    lng: -85.57711,
    city: "Plainwell",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15594,
    density: 77.8,
    county_fips: 26005,
    county_name: "Allegan",
    county_weights: {
      26005: 52.32,
      26015: 31.54,
      26077: 16.14,
    },
    county_names_all: "Allegan|Barry|Kalamazoo",
    county_fips_all: "26005|26015|26077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49082,
    lat: 41.94257,
    lng: -84.876,
    city: "Quincy",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6176,
    density: 28.1,
    county_fips: 26023,
    county_name: "Branch",
    county_weights: {
      26023: 92.46,
      26059: 7.54,
    },
    county_names_all: "Branch|Hillsdale",
    county_fips_all: "26023|26059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49083,
    lat: 42.3784,
    lng: -85.45899,
    city: "Richland",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8039,
    density: 92.9,
    county_fips: 26077,
    county_name: "Kalamazoo",
    county_weights: {
      26077: 100,
    },
    county_names_all: "Kalamazoo",
    county_fips_all: 26077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49084,
    lat: 42.18018,
    lng: -86.3852,
    city: "Riverside",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 26021,
    county_name: "Berrien",
    county_weights: {
      26021: 100,
    },
    county_names_all: "Berrien",
    county_fips_all: 26021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49085,
    lat: 42.04883,
    lng: -86.45923,
    city: "Saint Joseph",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23517,
    density: 376.3,
    county_fips: 26021,
    county_name: "Berrien",
    county_weights: {
      26021: 100,
    },
    county_names_all: "Berrien",
    county_fips_all: 26021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49087,
    lat: 42.12209,
    lng: -85.68557,
    city: "Schoolcraft",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6239,
    density: 38.6,
    county_fips: 26077,
    county_name: "Kalamazoo",
    county_weights: {
      26077: 95.31,
      26159: 4.69,
    },
    county_names_all: "Kalamazoo|Van Buren",
    county_fips_all: "26077|26159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49088,
    lat: 42.18602,
    lng: -85.42503,
    city: "Scotts",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3959,
    density: 42.5,
    county_fips: 26077,
    county_name: "Kalamazoo",
    county_weights: {
      26077: 100,
    },
    county_names_all: "Kalamazoo",
    county_fips_all: 26077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49089,
    lat: 42.00181,
    lng: -85.23113,
    city: "Sherwood",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1952,
    density: 19.9,
    county_fips: 26023,
    county_name: "Branch",
    county_weights: {
      26023: 100,
    },
    county_names_all: "Branch",
    county_fips_all: 26023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49090,
    lat: 42.40853,
    lng: -86.2168,
    city: "South Haven",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14001,
    density: 69.1,
    county_fips: 26159,
    county_name: "Van Buren",
    county_weights: {
      26005: 40.92,
      26159: 59.08,
    },
    county_names_all: "Van Buren|Allegan",
    county_fips_all: "26159|26005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49091,
    lat: 41.82509,
    lng: -85.44627,
    city: "Sturgis",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19447,
    density: 86,
    county_fips: 26149,
    county_name: "St. Joseph",
    county_weights: {
      26149: 100,
    },
    county_names_all: "St. Joseph",
    county_fips_all: 26149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49092,
    lat: 42.09822,
    lng: -84.97335,
    city: "Tekonsha",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2018,
    density: 13.6,
    county_fips: 26025,
    county_name: "Calhoun",
    county_weights: {
      26023: 27.76,
      26025: 72.24,
    },
    county_names_all: "Calhoun|Branch",
    county_fips_all: "26025|26023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49093,
    lat: 41.97375,
    lng: -85.64665,
    city: "Three Rivers",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18335,
    density: 67,
    county_fips: 26149,
    county_name: "St. Joseph",
    county_weights: {
      26027: 5.13,
      26149: 94.87,
    },
    county_names_all: "St. Joseph|Cass",
    county_fips_all: "26149|26027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49094,
    lat: 42.04696,
    lng: -85.11752,
    city: "Union City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3818,
    density: 26.3,
    county_fips: 26023,
    county_name: "Branch",
    county_weights: {
      26023: 77.48,
      26025: 22.52,
    },
    county_names_all: "Branch|Calhoun",
    county_fips_all: "26023|26025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49095,
    lat: 41.91008,
    lng: -85.8826,
    city: "Vandalia",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2269,
    density: 30.7,
    county_fips: 26027,
    county_name: "Cass",
    county_weights: {
      26027: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 26027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49096,
    lat: 42.63794,
    lng: -85.01409,
    city: "Vermontville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3341,
    density: 20.3,
    county_fips: 26045,
    county_name: "Eaton",
    county_weights: {
      26045: 100,
    },
    county_names_all: "Eaton",
    county_fips_all: 26045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49097,
    lat: 42.11491,
    lng: -85.48985,
    city: "Vicksburg",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11444,
    density: 63.2,
    county_fips: 26077,
    county_name: "Kalamazoo",
    county_weights: {
      26077: 94.91,
      26149: 5.09,
    },
    county_names_all: "Kalamazoo|St. Joseph",
    county_fips_all: "26077|26149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49098,
    lat: 42.16756,
    lng: -86.2425,
    city: "Watervliet",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6447,
    density: 76.4,
    county_fips: 26021,
    county_name: "Berrien",
    county_weights: {
      26021: 77.07,
      26159: 22.93,
    },
    county_names_all: "Berrien|Van Buren",
    county_fips_all: "26021|26159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49099,
    lat: 41.79139,
    lng: -85.67437,
    city: "White Pigeon",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5947,
    density: 39.6,
    county_fips: 26149,
    county_name: "St. Joseph",
    county_weights: {
      26027: 17.81,
      26149: 82.19,
    },
    county_names_all: "St. Joseph|Cass",
    county_fips_all: "26149|26027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49101,
    lat: 41.94462,
    lng: -86.48429,
    city: "Baroda",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2815,
    density: 52.6,
    county_fips: 26021,
    county_name: "Berrien",
    county_weights: {
      26021: 100,
    },
    county_names_all: "Berrien",
    county_fips_all: 26021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49102,
    lat: 41.95194,
    lng: -86.26037,
    city: "Berrien Center",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1954,
    density: 50.3,
    county_fips: 26021,
    county_name: "Berrien",
    county_weights: {
      26021: 95.79,
      26027: 4.21,
    },
    county_names_all: "Berrien|Cass",
    county_fips_all: "26021|26027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49103,
    lat: 41.94559,
    lng: -86.37519,
    city: "Berrien Springs",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10538,
    density: 90.8,
    county_fips: 26021,
    county_name: "Berrien",
    county_weights: {
      26021: 100,
    },
    county_names_all: "Berrien",
    county_fips_all: 26021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49104,
    lat: 41.96348,
    lng: -86.35877,
    city: "Berrien Springs",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 535,
    density: 1228,
    county_fips: 26021,
    county_name: "Berrien",
    county_weights: {
      26021: 100,
    },
    county_names_all: "Berrien",
    county_fips_all: 26021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49106,
    lat: 41.93452,
    lng: -86.55105,
    city: "Bridgman",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4887,
    density: 128.5,
    county_fips: 26021,
    county_name: "Berrien",
    county_weights: {
      26021: 100,
    },
    county_names_all: "Berrien",
    county_fips_all: 26021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49107,
    lat: 41.84804,
    lng: -86.41396,
    city: "Buchanan",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10153,
    density: 59.1,
    county_fips: 26021,
    county_name: "Berrien",
    county_weights: {
      26021: 100,
    },
    county_names_all: "Berrien",
    county_fips_all: 26021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49111,
    lat: 42.02544,
    lng: -86.28621,
    city: "Eau Claire",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3491,
    density: 31,
    county_fips: 26021,
    county_name: "Berrien",
    county_weights: {
      26021: 95.95,
      26027: 4.05,
    },
    county_names_all: "Berrien|Cass",
    county_fips_all: "26021|26027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49112,
    lat: 41.79833,
    lng: -86.03425,
    city: "Edwardsburg",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10728,
    density: 94.7,
    county_fips: 26027,
    county_name: "Cass",
    county_weights: {
      26027: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 26027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49113,
    lat: 41.80259,
    lng: -86.50044,
    city: "Galien",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1850,
    density: 20,
    county_fips: 26021,
    county_name: "Berrien",
    county_weights: {
      26021: 100,
    },
    county_names_all: "Berrien",
    county_fips_all: 26021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49115,
    lat: 41.87537,
    lng: -86.63389,
    city: "Harbert",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 330,
    density: 149.7,
    county_fips: 26021,
    county_name: "Berrien",
    county_weights: {
      26021: 100,
    },
    county_names_all: "Berrien",
    county_fips_all: 26021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49116,
    lat: 41.84836,
    lng: -86.66637,
    city: "Lakeside",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 177,
    density: 44.2,
    county_fips: 26021,
    county_name: "Berrien",
    county_weights: {
      26021: 100,
    },
    county_names_all: "Berrien",
    county_fips_all: 26021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49117,
    lat: 41.78028,
    lng: -86.72696,
    city: "New Buffalo",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3665,
    density: 74.4,
    county_fips: 26021,
    county_name: "Berrien",
    county_weights: {
      26021: 100,
    },
    county_names_all: "Berrien",
    county_fips_all: 26021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49119,
    lat: 41.87564,
    lng: -86.54862,
    city: "New Troy",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57,
    density: 43.5,
    county_fips: 26021,
    county_name: "Berrien",
    county_weights: {
      26021: 100,
    },
    county_names_all: "Berrien",
    county_fips_all: 26021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49120,
    lat: 41.83148,
    lng: -86.23162,
    city: "Niles",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35679,
    density: 118.2,
    county_fips: 26021,
    county_name: "Berrien",
    county_weights: {
      26021: 53.17,
      26027: 46.83,
    },
    county_names_all: "Berrien|Cass",
    county_fips_all: "26021|26027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49125,
    lat: 41.88698,
    lng: -86.57946,
    city: "Sawyer",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2205,
    density: 65,
    county_fips: 26021,
    county_name: "Berrien",
    county_weights: {
      26021: 100,
    },
    county_names_all: "Berrien",
    county_fips_all: 26021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49126,
    lat: 42.02593,
    lng: -86.36946,
    city: "Sodus",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1259,
    density: 31.6,
    county_fips: 26021,
    county_name: "Berrien",
    county_weights: {
      26021: 100,
    },
    county_names_all: "Berrien",
    county_fips_all: 26021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49127,
    lat: 42.00411,
    lng: -86.51597,
    city: "Stevensville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11012,
    density: 248.1,
    county_fips: 26021,
    county_name: "Berrien",
    county_weights: {
      26021: 100,
    },
    county_names_all: "Berrien",
    county_fips_all: 26021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49128,
    lat: 41.81706,
    lng: -86.60457,
    city: "Three Oaks",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3457,
    density: 30.5,
    county_fips: 26021,
    county_name: "Berrien",
    county_weights: {
      26021: 100,
    },
    county_names_all: "Berrien",
    county_fips_all: 26021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49129,
    lat: 41.81699,
    lng: -86.68839,
    city: "Union Pier",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 545,
    density: 41.9,
    county_fips: 26021,
    county_name: "Berrien",
    county_weights: {
      26021: 100,
    },
    county_names_all: "Berrien",
    county_fips_all: 26021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49130,
    lat: 41.78086,
    lng: -85.85997,
    city: "Union",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1274,
    density: 41.8,
    county_fips: 26027,
    county_name: "Cass",
    county_weights: {
      26027: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 26027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49201,
    lat: 42.25213,
    lng: -84.38301,
    city: "Jackson",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44766,
    density: 111.5,
    county_fips: 26075,
    county_name: "Jackson",
    county_weights: {
      26075: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 26075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49202,
    lat: 42.26737,
    lng: -84.4107,
    city: "Jackson",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19660,
    density: 597.3,
    county_fips: 26075,
    county_name: "Jackson",
    county_weights: {
      26075: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 26075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49203,
    lat: 42.22096,
    lng: -84.40347,
    city: "Jackson",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37997,
    density: 554.1,
    county_fips: 26075,
    county_name: "Jackson",
    county_weights: {
      26075: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 26075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49220,
    lat: 41.99511,
    lng: -84.34108,
    city: "Addison",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2513,
    density: 30.3,
    county_fips: 26091,
    county_name: "Lenawee",
    county_weights: {
      26059: 28.05,
      26091: 71.95,
    },
    county_names_all: "Lenawee|Hillsdale",
    county_fips_all: "26091|26059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49221,
    lat: 41.90343,
    lng: -84.06372,
    city: "Adrian",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40930,
    density: 131.8,
    county_fips: 26091,
    county_name: "Lenawee",
    county_weights: {
      26091: 100,
    },
    county_names_all: "Lenawee",
    county_fips_all: 26091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49224,
    lat: 42.27982,
    lng: -84.74852,
    city: "Albion",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14099,
    density: 54.5,
    county_fips: 26025,
    county_name: "Calhoun",
    county_weights: {
      26025: 69.27,
      26075: 30.73,
    },
    county_names_all: "Calhoun|Jackson",
    county_fips_all: "26025|26075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49227,
    lat: 41.9498,
    lng: -84.77036,
    city: "Allen",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1006,
    density: 15.1,
    county_fips: 26059,
    county_name: "Hillsdale",
    county_weights: {
      26059: 100,
    },
    county_names_all: "Hillsdale",
    county_fips_all: 26059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49228,
    lat: 41.8039,
    lng: -83.88247,
    city: "Blissfield",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5413,
    density: 26.6,
    county_fips: 26091,
    county_name: "Lenawee",
    county_weights: {
      26091: 99.52,
      26115: 0.48,
    },
    county_names_all: "Lenawee|Monroe",
    county_fips_all: "26091|26115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49229,
    lat: 41.99005,
    lng: -83.82655,
    city: "Britton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3079,
    density: 21.2,
    county_fips: 26091,
    county_name: "Lenawee",
    county_weights: {
      26091: 87.87,
      26115: 10.78,
      26161: 1.35,
    },
    county_names_all: "Lenawee|Monroe|Washtenaw",
    county_fips_all: "26091|26115|26161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49230,
    lat: 42.09701,
    lng: -84.22266,
    city: "Brooklyn",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10178,
    density: 61.4,
    county_fips: 26075,
    county_name: "Jackson",
    county_weights: {
      26075: 72.62,
      26091: 27.38,
    },
    county_names_all: "Jackson|Lenawee",
    county_fips_all: "26075|26091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49232,
    lat: 41.74049,
    lng: -84.66858,
    city: "Camden",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2669,
    density: 16.4,
    county_fips: 26059,
    county_name: "Hillsdale",
    county_weights: {
      26059: 100,
    },
    county_names_all: "Hillsdale",
    county_fips_all: 26059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49233,
    lat: 42.0644,
    lng: -84.36512,
    city: "Cement City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2477,
    density: 44.8,
    county_fips: 26059,
    county_name: "Hillsdale",
    county_weights: {
      26059: 36.44,
      26075: 35.29,
      26091: 28.28,
    },
    county_names_all: "Hillsdale|Jackson|Lenawee",
    county_fips_all: "26059|26075|26091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49234,
    lat: 42.12114,
    lng: -84.3673,
    city: "Clarklake",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2716,
    density: 49.1,
    county_fips: 26075,
    county_name: "Jackson",
    county_weights: {
      26075: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 26075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49235,
    lat: 41.86348,
    lng: -84.21348,
    city: "Clayton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1961,
    density: 15.5,
    county_fips: 26091,
    county_name: "Lenawee",
    county_weights: {
      26091: 100,
    },
    county_names_all: "Lenawee",
    county_fips_all: 26091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49236,
    lat: 42.07792,
    lng: -83.95035,
    city: "Clinton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4774,
    density: 49.1,
    county_fips: 26091,
    county_name: "Lenawee",
    county_weights: {
      26091: 54.61,
      26161: 45.39,
    },
    county_names_all: "Lenawee|Washtenaw",
    county_fips_all: "26091|26161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49237,
    lat: 42.1731,
    lng: -84.64906,
    city: "Concord",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2984,
    density: 28.1,
    county_fips: 26075,
    county_name: "Jackson",
    county_weights: {
      26025: 5.78,
      26075: 94.22,
    },
    county_names_all: "Jackson|Calhoun",
    county_fips_all: "26075|26025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49238,
    lat: 41.90593,
    lng: -83.78809,
    city: "Deerfield",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2102,
    density: 27.3,
    county_fips: 26091,
    county_name: "Lenawee",
    county_weights: {
      26091: 70.2,
      26115: 29.8,
    },
    county_names_all: "Lenawee|Monroe",
    county_fips_all: "26091|26115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49240,
    lat: 42.27821,
    lng: -84.18027,
    city: "Grass Lake",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9610,
    density: 35.6,
    county_fips: 26075,
    county_name: "Jackson",
    county_weights: {
      26075: 84.9,
      26161: 15.1,
    },
    county_names_all: "Jackson|Washtenaw",
    county_fips_all: "26075|26161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49241,
    lat: 42.10121,
    lng: -84.60149,
    city: "Hanover",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2653,
    density: 32,
    county_fips: 26075,
    county_name: "Jackson",
    county_weights: {
      26075: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 26075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49242,
    lat: 41.88434,
    lng: -84.61581,
    city: "Hillsdale",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14784,
    density: 63,
    county_fips: 26059,
    county_name: "Hillsdale",
    county_weights: {
      26059: 100,
    },
    county_names_all: "Hillsdale",
    county_fips_all: 26059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49245,
    lat: 42.14085,
    lng: -84.81797,
    city: "Homer",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4682,
    density: 19.5,
    county_fips: 26025,
    county_name: "Calhoun",
    county_weights: {
      26023: 2.06,
      26025: 96.35,
      26075: 1.59,
    },
    county_names_all: "Calhoun|Branch|Jackson",
    county_fips_all: "26025|26023|26075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49246,
    lat: 42.12268,
    lng: -84.50366,
    city: "Horton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3169,
    density: 35.5,
    county_fips: 26075,
    county_name: "Jackson",
    county_weights: {
      26059: 8.25,
      26075: 91.75,
    },
    county_names_all: "Jackson|Hillsdale",
    county_fips_all: "26075|26059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49247,
    lat: 41.84712,
    lng: -84.34189,
    city: "Hudson",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5647,
    density: 25.9,
    county_fips: 26091,
    county_name: "Lenawee",
    county_weights: {
      26059: 36.05,
      26091: 63.95,
    },
    county_names_all: "Lenawee|Hillsdale",
    county_fips_all: "26091|26059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49248,
    lat: 41.75651,
    lng: -84.01137,
    city: "Jasper",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 823,
    density: 9.6,
    county_fips: 26091,
    county_name: "Lenawee",
    county_weights: {
      26091: 100,
    },
    county_names_all: "Lenawee",
    county_fips_all: 26091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49249,
    lat: 42.02275,
    lng: -84.45575,
    city: "Jerome",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3422,
    density: 45,
    county_fips: 26059,
    county_name: "Hillsdale",
    county_weights: {
      26059: 95.64,
      26075: 4.36,
    },
    county_names_all: "Hillsdale|Jackson",
    county_fips_all: "26059|26075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49250,
    lat: 42.01875,
    lng: -84.62168,
    city: "Jonesville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6451,
    density: 31.6,
    county_fips: 26059,
    county_name: "Hillsdale",
    county_weights: {
      26059: 96.17,
      26075: 3.83,
    },
    county_names_all: "Hillsdale|Jackson",
    county_fips_all: "26059|26075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49251,
    lat: 42.46561,
    lng: -84.40916,
    city: "Leslie",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6508,
    density: 43.1,
    county_fips: 26065,
    county_name: "Ingham",
    county_weights: {
      26065: 94.95,
      26075: 5.05,
    },
    county_names_all: "Ingham|Jackson",
    county_fips_all: "26065|26075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49252,
    lat: 42.03853,
    lng: -84.76683,
    city: "Litchfield",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2485,
    density: 22.5,
    county_fips: 26059,
    county_name: "Hillsdale",
    county_weights: {
      26023: 7.9,
      26025: 4.81,
      26059: 80.53,
      26075: 6.76,
    },
    county_names_all: "Hillsdale|Branch|Jackson|Calhoun",
    county_fips_all: "26059|26023|26075|26025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49253,
    lat: 41.96443,
    lng: -84.2697,
    city: "Manitou Beach",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2864,
    density: 46.9,
    county_fips: 26091,
    county_name: "Lenawee",
    county_weights: {
      26091: 100,
    },
    county_names_all: "Lenawee",
    county_fips_all: 26091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49254,
    lat: 42.2268,
    lng: -84.32165,
    city: "Michigan Center",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3355,
    density: 493.6,
    county_fips: 26075,
    county_name: "Jackson",
    county_weights: {
      26075: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 26075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49255,
    lat: 41.77152,
    lng: -84.85499,
    city: "Montgomery",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2332,
    density: 22.6,
    county_fips: 26023,
    county_name: "Branch",
    county_weights: {
      26023: 60.89,
      26059: 39.11,
    },
    county_names_all: "Branch|Hillsdale",
    county_fips_all: "26023|26059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49256,
    lat: 41.74989,
    lng: -84.22122,
    city: "Morenci",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3530,
    density: 22.5,
    county_fips: 26091,
    county_name: "Lenawee",
    county_weights: {
      26091: 100,
    },
    county_names_all: "Lenawee",
    county_fips_all: 26091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49258,
    lat: 42.06,
    lng: -84.65833,
    city: "Mosherville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 26059,
    county_name: "Hillsdale",
    county_weights: {
      26059: 100,
    },
    county_names_all: "Hillsdale",
    county_fips_all: 26059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49259,
    lat: 42.38099,
    lng: -84.25763,
    city: "Munith",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2308,
    density: 30.6,
    county_fips: 26075,
    county_name: "Jackson",
    county_weights: {
      26075: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 26075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49261,
    lat: 42.16174,
    lng: -84.2472,
    city: "Napoleon",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 245,
    density: 129.7,
    county_fips: 26075,
    county_name: "Jackson",
    county_weights: {
      26075: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 26075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49262,
    lat: 41.96162,
    lng: -84.4673,
    city: "North Adams",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1198,
    density: 20.1,
    county_fips: 26059,
    county_name: "Hillsdale",
    county_weights: {
      26059: 100,
    },
    county_names_all: "Hillsdale",
    county_fips_all: 26059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49263,
    lat: 42.15817,
    lng: -84.18225,
    city: "Norvell",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51,
    density: 478,
    county_fips: 26075,
    county_name: "Jackson",
    county_weights: {
      26075: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 26075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49264,
    lat: 42.44118,
    lng: -84.55122,
    city: "Onondaga",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1962,
    density: 28.3,
    county_fips: 26065,
    county_name: "Ingham",
    county_weights: {
      26045: 1.87,
      26065: 71.83,
      26075: 26.3,
    },
    county_names_all: "Ingham|Jackson|Eaton",
    county_fips_all: "26065|26075|26045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49265,
    lat: 42.01022,
    lng: -84.17432,
    city: "Onsted",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5017,
    density: 59.9,
    county_fips: 26091,
    county_name: "Lenawee",
    county_weights: {
      26091: 100,
    },
    county_names_all: "Lenawee",
    county_fips_all: 26091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49266,
    lat: 41.84247,
    lng: -84.54641,
    city: "Osseo",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3095,
    density: 26.6,
    county_fips: 26059,
    county_name: "Hillsdale",
    county_weights: {
      26059: 100,
    },
    county_names_all: "Hillsdale",
    county_fips_all: 26059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49267,
    lat: 41.75979,
    lng: -83.72341,
    city: "Ottawa Lake",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3958,
    density: 39.2,
    county_fips: 26115,
    county_name: "Monroe",
    county_weights: {
      26091: 20.75,
      26115: 79.25,
    },
    county_names_all: "Monroe|Lenawee",
    county_fips_all: "26115|26091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49268,
    lat: 41.87156,
    lng: -83.92565,
    city: "Palmyra",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1167,
    density: 19.7,
    county_fips: 26091,
    county_name: "Lenawee",
    county_weights: {
      26091: 100,
    },
    county_names_all: "Lenawee",
    county_fips_all: 26091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49269,
    lat: 42.29307,
    lng: -84.586,
    city: "Parma",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6138,
    density: 42.5,
    county_fips: 26075,
    county_name: "Jackson",
    county_weights: {
      26075: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 26075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49270,
    lat: 41.86864,
    lng: -83.68206,
    city: "Petersburg",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5325,
    density: 45.8,
    county_fips: 26115,
    county_name: "Monroe",
    county_weights: {
      26115: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 26115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49271,
    lat: 41.83813,
    lng: -84.45382,
    city: "Pittsford",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2026,
    density: 14.6,
    county_fips: 26059,
    county_name: "Hillsdale",
    county_weights: {
      26059: 100,
    },
    county_names_all: "Hillsdale",
    county_fips_all: 26059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49272,
    lat: 42.39299,
    lng: -84.34974,
    city: "Pleasant Lake",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2371,
    density: 82.2,
    county_fips: 26075,
    county_name: "Jackson",
    county_weights: {
      26075: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 26075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49274,
    lat: 41.83689,
    lng: -84.76419,
    city: "Reading",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3310,
    density: 20.7,
    county_fips: 26059,
    county_name: "Hillsdale",
    county_weights: {
      26023: 15.88,
      26059: 84.12,
    },
    county_names_all: "Hillsdale|Branch",
    county_fips_all: "26059|26023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49276,
    lat: 41.79733,
    lng: -83.7843,
    city: "Riga",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 856,
    density: 14.5,
    county_fips: 26091,
    county_name: "Lenawee",
    county_weights: {
      26091: 68.77,
      26115: 31.23,
    },
    county_names_all: "Lenawee|Monroe",
    county_fips_all: "26091|26115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49277,
    lat: 42.38871,
    lng: -84.46679,
    city: "Rives Junction",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3392,
    density: 39.7,
    county_fips: 26075,
    county_name: "Jackson",
    county_weights: {
      26075: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 26075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49279,
    lat: 41.77965,
    lng: -84.10409,
    city: "Sand Creek",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 767,
    density: 11.2,
    county_fips: 26091,
    county_name: "Lenawee",
    county_weights: {
      26091: 100,
    },
    county_names_all: "Lenawee",
    county_fips_all: 26091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49282,
    lat: 42.03496,
    lng: -84.40518,
    city: "Somerset Center",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 410,
    density: 61.7,
    county_fips: 26059,
    county_name: "Hillsdale",
    county_weights: {
      26059: 100,
    },
    county_names_all: "Hillsdale",
    county_fips_all: 26059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49283,
    lat: 42.20486,
    lng: -84.55478,
    city: "Spring Arbor",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3694,
    density: 98.6,
    county_fips: 26075,
    county_name: "Jackson",
    county_weights: {
      26075: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 26075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49284,
    lat: 42.38507,
    lng: -84.69128,
    city: "Springport",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2872,
    density: 20.9,
    county_fips: 26075,
    county_name: "Jackson",
    county_weights: {
      26025: 30.02,
      26045: 7.66,
      26075: 62.32,
    },
    county_names_all: "Jackson|Calhoun|Eaton",
    county_fips_all: "26075|26025|26045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49285,
    lat: 42.46855,
    lng: -84.20752,
    city: "Stockbridge",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6276,
    density: 31.9,
    county_fips: 26065,
    county_name: "Ingham",
    county_weights: {
      26065: 80.17,
      26075: 10.11,
      26093: 6.36,
      26161: 3.36,
    },
    county_names_all: "Ingham|Jackson|Livingston|Washtenaw",
    county_fips_all: "26065|26075|26093|26161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49286,
    lat: 42.01443,
    lng: -83.93447,
    city: "Tecumseh",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14534,
    density: 96.5,
    county_fips: 26091,
    county_name: "Lenawee",
    county_weights: {
      26091: 100,
    },
    county_names_all: "Lenawee",
    county_fips_all: 26091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49287,
    lat: 42.02177,
    lng: -84.08263,
    city: "Tipton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2206,
    density: 30.4,
    county_fips: 26091,
    county_name: "Lenawee",
    county_weights: {
      26091: 94.36,
      26161: 5.64,
    },
    county_names_all: "Lenawee|Washtenaw",
    county_fips_all: "26091|26161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49288,
    lat: 41.73534,
    lng: -84.43211,
    city: "Waldron",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1556,
    density: 15.9,
    county_fips: 26059,
    county_name: "Hillsdale",
    county_weights: {
      26059: 87.41,
      26091: 12.59,
    },
    county_names_all: "Hillsdale|Lenawee",
    county_fips_all: "26059|26091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49289,
    lat: 41.77144,
    lng: -84.10702,
    city: "Weston",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 88,
    density: 143.8,
    county_fips: 26091,
    county_name: "Lenawee",
    county_weights: {
      26091: 100,
    },
    county_names_all: "Lenawee",
    county_fips_all: 26091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49301,
    lat: 42.97716,
    lng: -85.47671,
    city: "Ada",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19922,
    density: 135.4,
    county_fips: 26081,
    county_name: "Kent",
    county_weights: {
      26081: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 26081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49302,
    lat: 42.82307,
    lng: -85.39871,
    city: "Alto",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9216,
    density: 71.2,
    county_fips: 26081,
    county_name: "Kent",
    county_weights: {
      26067: 0.22,
      26081: 99.78,
    },
    county_names_all: "Kent|Ionia",
    county_fips_all: "26081|26067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49303,
    lat: 43.27803,
    lng: -85.85824,
    city: "Bailey",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 937,
    density: 24.5,
    county_fips: 26121,
    county_name: "Muskegon",
    county_weights: {
      26121: 93.51,
      26123: 6.49,
    },
    county_names_all: "Muskegon|Newaygo",
    county_fips_all: "26121|26123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49304,
    lat: 43.91027,
    lng: -85.87417,
    city: "Baldwin",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4015,
    density: 13.6,
    county_fips: 26085,
    county_name: "Lake",
    county_weights: {
      26085: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 26085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49305,
    lat: 43.74926,
    lng: -85.15023,
    city: "Barryton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2210,
    density: 16.7,
    county_fips: 26107,
    county_name: "Mecosta",
    county_weights: {
      26073: 15.64,
      26107: 84.36,
    },
    county_names_all: "Mecosta|Isabella",
    county_fips_all: "26107|26073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49306,
    lat: 43.07296,
    lng: -85.56939,
    city: "Belmont",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10924,
    density: 228.9,
    county_fips: 26081,
    county_name: "Kent",
    county_weights: {
      26081: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 26081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49307,
    lat: 43.69797,
    lng: -85.48272,
    city: "Big Rapids",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21602,
    density: 62,
    county_fips: 26107,
    county_name: "Mecosta",
    county_weights: {
      26107: 80.59,
      26123: 19.41,
    },
    county_names_all: "Mecosta|Newaygo",
    county_fips_all: "26107|26123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49309,
    lat: 43.76021,
    lng: -85.87842,
    city: "Bitely",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1477,
    density: 4.5,
    county_fips: 26123,
    county_name: "Newaygo",
    county_weights: {
      26085: 4.98,
      26123: 95.02,
    },
    county_names_all: "Newaygo|Lake",
    county_fips_all: "26123|26085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49310,
    lat: 43.51525,
    lng: -85.05448,
    city: "Blanchard",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2960,
    density: 13,
    county_fips: 26073,
    county_name: "Isabella",
    county_weights: {
      26073: 62.68,
      26107: 35,
      26117: 2.32,
    },
    county_names_all: "Isabella|Mecosta|Montcalm",
    county_fips_all: "26073|26107|26117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49312,
    lat: 43.69009,
    lng: -85.79992,
    city: "Brohman",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 278,
    density: 4.1,
    county_fips: 26123,
    county_name: "Newaygo",
    county_weights: {
      26123: 100,
    },
    county_names_all: "Newaygo",
    county_fips_all: 26123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49315,
    lat: 42.80101,
    lng: -85.73589,
    city: "Byron Center",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23116,
    density: 161.7,
    county_fips: 26081,
    county_name: "Kent",
    county_weights: {
      26005: 10.09,
      26081: 71.77,
      26139: 18.14,
    },
    county_names_all: "Kent|Ottawa|Allegan",
    county_fips_all: "26081|26139|26005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49316,
    lat: 42.79644,
    lng: -85.55564,
    city: "Caledonia",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24193,
    density: 163.6,
    county_fips: 26081,
    county_name: "Kent",
    county_weights: {
      26005: 18.86,
      26015: 2.87,
      26081: 78.27,
    },
    county_names_all: "Kent|Allegan|Barry",
    county_fips_all: "26081|26005|26015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49318,
    lat: 43.22319,
    lng: -85.82981,
    city: "Casnovia",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1309,
    density: 25.2,
    county_fips: 26121,
    county_name: "Muskegon",
    county_weights: {
      26081: 3.87,
      26121: 72.89,
      26139: 23.24,
    },
    county_names_all: "Muskegon|Ottawa|Kent",
    county_fips_all: "26121|26139|26081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49319,
    lat: 43.22767,
    lng: -85.5281,
    city: "Cedar Springs",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18341,
    density: 82,
    county_fips: 26081,
    county_name: "Kent",
    county_weights: {
      26081: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 26081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49320,
    lat: 43.75264,
    lng: -85.29276,
    city: "Chippewa Lake",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14,
    density: 4.8,
    county_fips: 26107,
    county_name: "Mecosta",
    county_weights: {
      26107: 100,
    },
    county_names_all: "Mecosta",
    county_fips_all: 26107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49321,
    lat: 43.0737,
    lng: -85.68198,
    city: "Comstock Park",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16926,
    density: 248.2,
    county_fips: 26081,
    county_name: "Kent",
    county_weights: {
      26081: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 26081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49322,
    lat: 43.35685,
    lng: -85.35261,
    city: "Coral",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1414,
    density: 21.9,
    county_fips: 26117,
    county_name: "Montcalm",
    county_weights: {
      26117: 100,
    },
    county_names_all: "Montcalm",
    county_fips_all: 26117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49323,
    lat: 42.72541,
    lng: -85.7871,
    city: "Dorr",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10140,
    density: 78.1,
    county_fips: 26005,
    county_name: "Allegan",
    county_weights: {
      26005: 99,
      26139: 1,
    },
    county_names_all: "Allegan|Ottawa",
    county_fips_all: "26005|26139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49325,
    lat: 42.76155,
    lng: -85.30162,
    city: "Freeport",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2339,
    density: 33.9,
    county_fips: 26015,
    county_name: "Barry",
    county_weights: {
      26015: 69.13,
      26067: 20.99,
      26081: 9.88,
    },
    county_names_all: "Barry|Ionia|Kent",
    county_fips_all: "26015|26067|26081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49326,
    lat: 43.25069,
    lng: -85.32083,
    city: "Gowen",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4257,
    density: 68.2,
    county_fips: 26081,
    county_name: "Kent",
    county_weights: {
      26081: 61.73,
      26117: 38.27,
    },
    county_names_all: "Kent|Montcalm",
    county_fips_all: "26081|26117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49327,
    lat: 43.33507,
    lng: -85.84558,
    city: "Grant",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8700,
    density: 36.9,
    county_fips: 26123,
    county_name: "Newaygo",
    county_weights: {
      26081: 0.49,
      26121: 0.61,
      26123: 98.9,
    },
    county_names_all: "Newaygo|Muskegon|Kent",
    county_fips_all: "26123|26121|26081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49328,
    lat: 42.6304,
    lng: -85.75703,
    city: "Hopkins",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4209,
    density: 29.5,
    county_fips: 26005,
    county_name: "Allegan",
    county_weights: {
      26005: 100,
    },
    county_names_all: "Allegan",
    county_fips_all: 26005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49329,
    lat: 43.40567,
    lng: -85.48771,
    city: "Howard City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8750,
    density: 43,
    county_fips: 26117,
    county_name: "Montcalm",
    county_weights: {
      26117: 77.62,
      26123: 22.38,
    },
    county_names_all: "Montcalm|Newaygo",
    county_fips_all: "26117|26123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49330,
    lat: 43.24463,
    lng: -85.73721,
    city: "Kent City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5852,
    density: 51.7,
    county_fips: 26081,
    county_name: "Kent",
    county_weights: {
      26081: 86.96,
      26121: 1.07,
      26123: 8.2,
      26139: 3.77,
    },
    county_names_all: "Kent|Newaygo|Ottawa|Muskegon",
    county_fips_all: "26081|26123|26139|26121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49331,
    lat: 42.95161,
    lng: -85.35139,
    city: "Lowell",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18118,
    density: 76.5,
    county_fips: 26081,
    county_name: "Kent",
    county_weights: {
      26067: 21.26,
      26081: 78.74,
    },
    county_names_all: "Kent|Ionia",
    county_fips_all: "26081|26067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49332,
    lat: 43.62323,
    lng: -85.24468,
    city: "Mecosta",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3327,
    density: 28.9,
    county_fips: 26107,
    county_name: "Mecosta",
    county_weights: {
      26107: 100,
    },
    county_names_all: "Mecosta",
    county_fips_all: 26107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49333,
    lat: 42.69546,
    lng: -85.46343,
    city: "Middleville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11041,
    density: 53.8,
    county_fips: 26015,
    county_name: "Barry",
    county_weights: {
      26005: 1.23,
      26015: 96.51,
      26081: 2.26,
    },
    county_names_all: "Barry|Kent|Allegan",
    county_fips_all: "26015|26081|26005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49335,
    lat: 42.74626,
    lng: -85.66907,
    city: "Moline",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 323,
    density: 290.7,
    county_fips: 26005,
    county_name: "Allegan",
    county_weights: {
      26005: 100,
    },
    county_names_all: "Allegan",
    county_fips_all: 26005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49336,
    lat: 43.50752,
    lng: -85.42862,
    city: "Morley",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4584,
    density: 21.6,
    county_fips: 26107,
    county_name: "Mecosta",
    county_weights: {
      26107: 90.15,
      26117: 9.06,
      26123: 0.79,
    },
    county_names_all: "Mecosta|Montcalm|Newaygo",
    county_fips_all: "26107|26117|26123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49337,
    lat: 43.43472,
    lng: -85.71437,
    city: "Newaygo",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12204,
    density: 42.7,
    county_fips: 26123,
    county_name: "Newaygo",
    county_weights: {
      26107: 2.24,
      26117: 3.14,
      26123: 94.62,
    },
    county_names_all: "Newaygo|Montcalm|Mecosta",
    county_fips_all: "26123|26117|26107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49338,
    lat: 43.75888,
    lng: -85.61033,
    city: "Paris",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1602,
    density: 10.9,
    county_fips: 26123,
    county_name: "Newaygo",
    county_weights: {
      26107: 29.67,
      26123: 70.14,
      26133: 0.19,
    },
    county_names_all: "Newaygo|Mecosta|Osceola",
    county_fips_all: "26123|26107|26133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49339,
    lat: 43.33574,
    lng: -85.49454,
    city: "Pierson",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2409,
    density: 31.1,
    county_fips: 26117,
    county_name: "Montcalm",
    county_weights: {
      26117: 95.15,
      26123: 4.85,
    },
    county_names_all: "Montcalm|Newaygo",
    county_fips_all: "26117|26123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49340,
    lat: 43.62213,
    lng: -85.11222,
    city: "Remus",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2668,
    density: 12.1,
    county_fips: 26107,
    county_name: "Mecosta",
    county_weights: {
      26073: 29.29,
      26107: 70.71,
    },
    county_names_all: "Mecosta|Isabella",
    county_fips_all: "26107|26073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49341,
    lat: 43.12433,
    lng: -85.49246,
    city: "Rockford",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38728,
    density: 176.9,
    county_fips: 26081,
    county_name: "Kent",
    county_weights: {
      26081: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 26081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49342,
    lat: 43.69634,
    lng: -85.32156,
    city: "Rodney",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1566,
    density: 15.3,
    county_fips: 26107,
    county_name: "Mecosta",
    county_weights: {
      26107: 100,
    },
    county_names_all: "Mecosta",
    county_fips_all: 26107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49343,
    lat: 43.29579,
    lng: -85.53115,
    city: "Sand Lake",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5637,
    density: 39.4,
    county_fips: 26081,
    county_name: "Kent",
    county_weights: {
      26081: 52.9,
      26117: 10.17,
      26123: 36.93,
    },
    county_names_all: "Kent|Newaygo|Montcalm",
    county_fips_all: "26081|26123|26117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49344,
    lat: 42.5919,
    lng: -85.59028,
    city: "Shelbyville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3801,
    density: 47.3,
    county_fips: 26005,
    county_name: "Allegan",
    county_weights: {
      26005: 80.72,
      26015: 19.28,
    },
    county_names_all: "Allegan|Barry",
    county_fips_all: "26005|26015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49345,
    lat: 43.15419,
    lng: -85.70224,
    city: "Sparta",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14157,
    density: 104.8,
    county_fips: 26081,
    county_name: "Kent",
    county_weights: {
      26081: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 26081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49346,
    lat: 43.58616,
    lng: -85.42213,
    city: "Stanwood",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5037,
    density: 30.1,
    county_fips: 26107,
    county_name: "Mecosta",
    county_weights: {
      26107: 96.97,
      26123: 3.03,
    },
    county_names_all: "Mecosta|Newaygo",
    county_fips_all: "26107|26123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49347,
    lat: 43.31488,
    lng: -85.34352,
    city: "Trufant",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1633,
    density: 35.5,
    county_fips: 26117,
    county_name: "Montcalm",
    county_weights: {
      26081: 2.99,
      26117: 97.01,
    },
    county_names_all: "Montcalm|Kent",
    county_fips_all: "26117|26081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49348,
    lat: 42.68379,
    lng: -85.61619,
    city: "Wayland",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12423,
    density: 73,
    county_fips: 26005,
    county_name: "Allegan",
    county_weights: {
      26005: 89.89,
      26015: 8.15,
      26081: 1.96,
    },
    county_names_all: "Allegan|Barry|Kent",
    county_fips_all: "26005|26015|26081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49349,
    lat: 43.58291,
    lng: -85.74167,
    city: "White Cloud",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7429,
    density: 14.5,
    county_fips: 26123,
    county_name: "Newaygo",
    county_weights: {
      26123: 100,
    },
    county_names_all: "Newaygo",
    county_fips_all: 26123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49401,
    lat: 42.9763,
    lng: -85.95604,
    city: "Allendale",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24827,
    density: 300.4,
    county_fips: 26139,
    county_name: "Ottawa",
    county_weights: {
      26139: 100,
    },
    county_names_all: "Ottawa",
    county_fips_all: 26139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49402,
    lat: 43.94228,
    lng: -86.03284,
    city: "Branch",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1284,
    density: 3.5,
    county_fips: 26085,
    county_name: "Lake",
    county_weights: {
      26085: 51.85,
      26105: 47.01,
      26127: 1.14,
    },
    county_names_all: "Lake|Mason|Oceana",
    county_fips_all: "26085|26105|26127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49403,
    lat: 43.13316,
    lng: -85.85022,
    city: "Conklin",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2799,
    density: 23.1,
    county_fips: 26139,
    county_name: "Ottawa",
    county_weights: {
      26081: 4.21,
      26121: 6.94,
      26139: 88.85,
    },
    county_names_all: "Ottawa|Muskegon|Kent",
    county_fips_all: "26139|26121|26081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49404,
    lat: 43.06602,
    lng: -85.95129,
    city: "Coopersville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8491,
    density: 52.6,
    county_fips: 26139,
    county_name: "Ottawa",
    county_weights: {
      26121: 6.44,
      26139: 93.56,
    },
    county_names_all: "Ottawa|Muskegon",
    county_fips_all: "26139|26121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49405,
    lat: 43.91051,
    lng: -86.18931,
    city: "Custer",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1633,
    density: 9,
    county_fips: 26105,
    county_name: "Mason",
    county_weights: {
      26105: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 26105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49406,
    lat: 42.64224,
    lng: -86.209,
    city: "Douglas",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 702,
    density: 180.5,
    county_fips: 26005,
    county_name: "Allegan",
    county_weights: {
      26005: 100,
    },
    county_names_all: "Allegan",
    county_fips_all: 26005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49408,
    lat: 42.57077,
    lng: -86.11479,
    city: "Fennville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10151,
    density: 36.3,
    county_fips: 26005,
    county_name: "Allegan",
    county_weights: {
      26005: 100,
    },
    county_names_all: "Allegan",
    county_fips_all: 26005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49409,
    lat: 43.08077,
    lng: -86.21826,
    city: "Ferrysburg",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 26139,
    county_name: "Ottawa",
    county_weights: {
      26139: 100,
    },
    county_names_all: "Ottawa",
    county_fips_all: 26139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49410,
    lat: 44.01986,
    lng: -86.14265,
    city: "Fountain",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1917,
    density: 19.7,
    county_fips: 26105,
    county_name: "Mason",
    county_weights: {
      26105: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 26105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49411,
    lat: 44.11006,
    lng: -86.25385,
    city: "Free Soil",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1504,
    density: 5.3,
    county_fips: 26105,
    county_name: "Mason",
    county_weights: {
      26101: 4.93,
      26105: 95.07,
    },
    county_names_all: "Mason|Manistee",
    county_fips_all: "26105|26101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49412,
    lat: 43.4699,
    lng: -85.94747,
    city: "Fremont",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11871,
    density: 41.5,
    county_fips: 26123,
    county_name: "Newaygo",
    county_weights: {
      26121: 0.75,
      26123: 97.26,
      26127: 1.99,
    },
    county_names_all: "Newaygo|Oceana|Muskegon",
    county_fips_all: "26123|26127|26121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49415,
    lat: 43.15238,
    lng: -86.1166,
    city: "Fruitport",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7070,
    density: 98.8,
    county_fips: 26121,
    county_name: "Muskegon",
    county_weights: {
      26121: 91.8,
      26139: 8.2,
    },
    county_names_all: "Muskegon|Ottawa",
    county_fips_all: "26121|26139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49417,
    lat: 43.01519,
    lng: -86.14387,
    city: "Grand Haven",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32374,
    density: 266.8,
    county_fips: 26139,
    county_name: "Ottawa",
    county_weights: {
      26139: 100,
    },
    county_names_all: "Ottawa",
    county_fips_all: 26139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49418,
    lat: 42.8774,
    lng: -85.77226,
    city: "Grandville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28607,
    density: 581.7,
    county_fips: 26081,
    county_name: "Kent",
    county_weights: {
      26081: 64.35,
      26139: 35.65,
    },
    county_names_all: "Kent|Ottawa",
    county_fips_all: "26081|26139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49419,
    lat: 42.67768,
    lng: -85.97826,
    city: "Hamilton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8850,
    density: 46.7,
    county_fips: 26005,
    county_name: "Allegan",
    county_weights: {
      26005: 100,
    },
    county_names_all: "Allegan",
    county_fips_all: 26005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49420,
    lat: 43.71958,
    lng: -86.2811,
    city: "Hart",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6342,
    density: 20.8,
    county_fips: 26127,
    county_name: "Oceana",
    county_weights: {
      26127: 100,
    },
    county_names_all: "Oceana",
    county_fips_all: 26127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49421,
    lat: 43.59945,
    lng: -86.06658,
    city: "Hesperia",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5567,
    density: 16.9,
    county_fips: 26127,
    county_name: "Oceana",
    county_weights: {
      26123: 40.24,
      26127: 59.76,
    },
    county_names_all: "Oceana|Newaygo",
    county_fips_all: "26127|26123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49423,
    lat: 42.73964,
    lng: -86.09015,
    city: "Holland",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45517,
    density: 225.7,
    county_fips: 26005,
    county_name: "Allegan",
    county_weights: {
      26005: 82.64,
      26139: 17.36,
    },
    county_names_all: "Allegan|Ottawa",
    county_fips_all: "26005|26139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49424,
    lat: 42.84269,
    lng: -86.12431,
    city: "Holland",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47997,
    density: 323.5,
    county_fips: 26139,
    county_name: "Ottawa",
    county_weights: {
      26139: 100,
    },
    county_names_all: "Ottawa",
    county_fips_all: 26139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49425,
    lat: 43.43941,
    lng: -86.09981,
    city: "Holton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3977,
    density: 24,
    county_fips: 26121,
    county_name: "Muskegon",
    county_weights: {
      26121: 63.19,
      26123: 9.29,
      26127: 27.52,
    },
    county_names_all: "Muskegon|Oceana|Newaygo",
    county_fips_all: "26121|26127|26123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49426,
    lat: 42.86636,
    lng: -85.89038,
    city: "Hudsonville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38022,
    density: 243.5,
    county_fips: 26139,
    county_name: "Ottawa",
    county_weights: {
      26005: 0.47,
      26139: 99.53,
    },
    county_names_all: "Ottawa|Allegan",
    county_fips_all: "26139|26005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49428,
    lat: 42.92042,
    lng: -85.83712,
    city: "Jenison",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28299,
    density: 680.2,
    county_fips: 26139,
    county_name: "Ottawa",
    county_weights: {
      26139: 100,
    },
    county_names_all: "Ottawa",
    county_fips_all: 26139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49430,
    lat: 43.01192,
    lng: -85.90053,
    city: "Lamont",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 26139,
    county_name: "Ottawa",
    county_weights: {
      26139: 100,
    },
    county_names_all: "Ottawa",
    county_fips_all: 26139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49431,
    lat: 43.97251,
    lng: -86.39792,
    city: "Ludington",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17286,
    density: 69.5,
    county_fips: 26105,
    county_name: "Mason",
    county_weights: {
      26105: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 26105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49434,
    lat: 42.76975,
    lng: -86.20774,
    city: "Macatawa",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 26139,
    county_name: "Ottawa",
    county_weights: {
      26005: 12.2,
      26139: 87.8,
    },
    county_names_all: "Ottawa|Allegan",
    county_fips_all: "26139|26005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49435,
    lat: 43.02683,
    lng: -85.84049,
    city: "Marne",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3828,
    density: 68.5,
    county_fips: 26139,
    county_name: "Ottawa",
    county_weights: {
      26081: 1.57,
      26139: 98.43,
    },
    county_names_all: "Ottawa|Kent",
    county_fips_all: "26139|26081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49436,
    lat: 43.68042,
    lng: -86.46203,
    city: "Mears",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1615,
    density: 19.5,
    county_fips: 26127,
    county_name: "Oceana",
    county_weights: {
      26127: 100,
    },
    county_names_all: "Oceana",
    county_fips_all: 26127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49437,
    lat: 43.4588,
    lng: -86.38121,
    city: "Montague",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6667,
    density: 39.3,
    county_fips: 26121,
    county_name: "Muskegon",
    county_weights: {
      26121: 62.33,
      26127: 37.67,
    },
    county_names_all: "Muskegon|Oceana",
    county_fips_all: "26121|26127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49440,
    lat: 43.23852,
    lng: -86.25387,
    city: "Muskegon",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 800,
    density: 510.9,
    county_fips: 26121,
    county_name: "Muskegon",
    county_weights: {
      26121: 100,
    },
    county_names_all: "Muskegon",
    county_fips_all: 26121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49441,
    lat: 43.18745,
    lng: -86.2736,
    city: "Muskegon",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35045,
    density: 623.4,
    county_fips: 26121,
    county_name: "Muskegon",
    county_weights: {
      26121: 100,
    },
    county_names_all: "Muskegon",
    county_fips_all: 26121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49442,
    lat: 43.23995,
    lng: -86.13278,
    city: "Muskegon",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41823,
    density: 393.7,
    county_fips: 26121,
    county_name: "Muskegon",
    county_weights: {
      26121: 100,
    },
    county_names_all: "Muskegon",
    county_fips_all: 26121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49443,
    lat: 43.22204,
    lng: -86.24155,
    city: "Muskegon",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 26121,
    county_name: "Muskegon",
    county_weights: {
      26121: 100,
    },
    county_names_all: "Muskegon",
    county_fips_all: 26121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49444,
    lat: 43.17671,
    lng: -86.19892,
    city: "Muskegon",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30003,
    density: 469.5,
    county_fips: 26121,
    county_name: "Muskegon",
    county_weights: {
      26121: 100,
    },
    county_names_all: "Muskegon",
    county_fips_all: 26121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49445,
    lat: 43.297,
    lng: -86.27481,
    city: "Muskegon",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21476,
    density: 135.8,
    county_fips: 26121,
    county_name: "Muskegon",
    county_weights: {
      26121: 100,
    },
    county_names_all: "Muskegon",
    county_fips_all: 26121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49446,
    lat: 43.55306,
    lng: -86.39096,
    city: "New Era",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2396,
    density: 29,
    county_fips: 26127,
    county_name: "Oceana",
    county_weights: {
      26127: 100,
    },
    county_names_all: "Oceana",
    county_fips_all: 26127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49448,
    lat: 43.09074,
    lng: -86.07432,
    city: "Nunica",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3854,
    density: 45.1,
    county_fips: 26139,
    county_name: "Ottawa",
    county_weights: {
      26121: 19.36,
      26139: 80.64,
    },
    county_names_all: "Ottawa|Muskegon",
    county_fips_all: "26139|26121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49449,
    lat: 43.79927,
    lng: -86.37496,
    city: "Pentwater",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2790,
    density: 25.8,
    county_fips: 26127,
    county_name: "Oceana",
    county_weights: {
      26105: 31.35,
      26127: 68.65,
    },
    county_names_all: "Oceana|Mason",
    county_fips_all: "26127|26105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49450,
    lat: 42.48333,
    lng: -86.08051,
    city: "Pullman",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3628,
    density: 47.8,
    county_fips: 26005,
    county_name: "Allegan",
    county_weights: {
      26005: 100,
    },
    county_names_all: "Allegan",
    county_fips_all: 26005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49451,
    lat: 43.21177,
    lng: -85.96966,
    city: "Ravenna",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6175,
    density: 28.5,
    county_fips: 26121,
    county_name: "Muskegon",
    county_weights: {
      26121: 95.29,
      26123: 0.79,
      26139: 3.92,
    },
    county_names_all: "Muskegon|Ottawa|Newaygo",
    county_fips_all: "26121|26139|26123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49452,
    lat: 43.51316,
    lng: -86.25548,
    city: "Rothbury",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2073,
    density: 17.8,
    county_fips: 26127,
    county_name: "Oceana",
    county_weights: {
      26127: 100,
    },
    county_names_all: "Oceana",
    county_fips_all: 26127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49453,
    lat: 42.66511,
    lng: -86.17388,
    city: "Saugatuck",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2941,
    density: 109.4,
    county_fips: 26005,
    county_name: "Allegan",
    county_weights: {
      26005: 100,
    },
    county_names_all: "Allegan",
    county_fips_all: 26005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49454,
    lat: 43.95208,
    lng: -86.28638,
    city: "Scottville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4858,
    density: 25.8,
    county_fips: 26105,
    county_name: "Mason",
    county_weights: {
      26105: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 26105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49455,
    lat: 43.60976,
    lng: -86.36723,
    city: "Shelby",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4832,
    density: 22,
    county_fips: 26127,
    county_name: "Oceana",
    county_weights: {
      26127: 100,
    },
    county_names_all: "Oceana",
    county_fips_all: 26127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49456,
    lat: 43.09026,
    lng: -86.19347,
    city: "Spring Lake",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19527,
    density: 297.8,
    county_fips: 26139,
    county_name: "Ottawa",
    county_weights: {
      26121: 11.85,
      26139: 88.15,
    },
    county_names_all: "Ottawa|Muskegon",
    county_fips_all: "26139|26121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49457,
    lat: 43.35105,
    lng: -86.14455,
    city: "Twin Lake",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10109,
    density: 48.2,
    county_fips: 26121,
    county_name: "Muskegon",
    county_weights: {
      26121: 97.17,
      26123: 2.83,
    },
    county_names_all: "Muskegon|Newaygo",
    county_fips_all: "26121|26123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49458,
    lat: 43.94818,
    lng: -86.11529,
    city: "Walhalla",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 106,
    density: 87.1,
    county_fips: 26105,
    county_name: "Mason",
    county_weights: {
      26105: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 26105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49459,
    lat: 43.73678,
    lng: -86.10805,
    city: "Walkerville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1556,
    density: 7.6,
    county_fips: 26127,
    county_name: "Oceana",
    county_weights: {
      26123: 5.46,
      26127: 94.54,
    },
    county_names_all: "Oceana|Newaygo",
    county_fips_all: "26127|26123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49460,
    lat: 42.93473,
    lng: -86.1429,
    city: "West Olive",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8783,
    density: 65.5,
    county_fips: 26139,
    county_name: "Ottawa",
    county_weights: {
      26139: 100,
    },
    county_names_all: "Ottawa",
    county_fips_all: 26139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49461,
    lat: 43.38215,
    lng: -86.32317,
    city: "Whitehall",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9494,
    density: 84.8,
    county_fips: 26121,
    county_name: "Muskegon",
    county_weights: {
      26121: 100,
    },
    county_names_all: "Muskegon",
    county_fips_all: 26121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49464,
    lat: 42.84183,
    lng: -85.98338,
    city: "Zeeland",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30340,
    density: 160.1,
    county_fips: 26139,
    county_name: "Ottawa",
    county_weights: {
      26005: 5.24,
      26139: 94.76,
    },
    county_names_all: "Ottawa|Allegan",
    county_fips_all: "26139|26005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49503,
    lat: 42.96282,
    lng: -85.65872,
    city: "Grand Rapids",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37036,
    density: 1969.8,
    county_fips: 26081,
    county_name: "Kent",
    county_weights: {
      26081: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 26081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49504,
    lat: 42.98047,
    lng: -85.70937,
    city: "Grand Rapids",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40498,
    density: 1414.9,
    county_fips: 26081,
    county_name: "Kent",
    county_weights: {
      26081: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 26081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49505,
    lat: 42.9984,
    lng: -85.63699,
    city: "Grand Rapids",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33239,
    density: 1465.7,
    county_fips: 26081,
    county_name: "Kent",
    county_weights: {
      26081: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 26081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49506,
    lat: 42.94515,
    lng: -85.6136,
    city: "Grand Rapids",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34058,
    density: 1806.3,
    county_fips: 26081,
    county_name: "Kent",
    county_weights: {
      26081: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 26081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49507,
    lat: 42.93054,
    lng: -85.65524,
    city: "Grand Rapids",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39731,
    density: 2769,
    county_fips: 26081,
    county_name: "Kent",
    county_weights: {
      26081: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 26081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49508,
    lat: 42.87459,
    lng: -85.62586,
    city: "Grand Rapids",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40409,
    density: 1325.1,
    county_fips: 26081,
    county_name: "Kent",
    county_weights: {
      26081: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 26081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49509,
    lat: 42.89773,
    lng: -85.69299,
    city: "Wyoming",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28946,
    density: 1536.6,
    county_fips: 26081,
    county_name: "Kent",
    county_weights: {
      26081: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 26081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49512,
    lat: 42.8821,
    lng: -85.54764,
    city: "Grand Rapids",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18464,
    density: 309.7,
    county_fips: 26081,
    county_name: "Kent",
    county_weights: {
      26081: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 26081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49519,
    lat: 42.89914,
    lng: -85.7192,
    city: "Wyoming",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28262,
    density: 1364.9,
    county_fips: 26081,
    county_name: "Kent",
    county_weights: {
      26081: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 26081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49525,
    lat: 43.02144,
    lng: -85.5918,
    city: "Grand Rapids",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30205,
    density: 497.9,
    county_fips: 26081,
    county_name: "Kent",
    county_weights: {
      26081: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 26081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49534,
    lat: 42.97106,
    lng: -85.78834,
    city: "Grand Rapids",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22206,
    density: 243.1,
    county_fips: 26139,
    county_name: "Ottawa",
    county_weights: {
      26081: 49.15,
      26139: 50.85,
    },
    county_names_all: "Ottawa|Kent",
    county_fips_all: "26139|26081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49544,
    lat: 43.04591,
    lng: -85.7417,
    city: "Grand Rapids",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10181,
    density: 197.7,
    county_fips: 26081,
    county_name: "Kent",
    county_weights: {
      26081: 96.17,
      26139: 3.83,
    },
    county_names_all: "Kent|Ottawa",
    county_fips_all: "26081|26139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49546,
    lat: 42.92815,
    lng: -85.53629,
    city: "Grand Rapids",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33968,
    density: 734.1,
    county_fips: 26081,
    county_name: "Kent",
    county_weights: {
      26081: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 26081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49548,
    lat: 42.86795,
    lng: -85.66273,
    city: "Grand Rapids",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33608,
    density: 1206.3,
    county_fips: 26081,
    county_name: "Kent",
    county_weights: {
      26081: 100,
    },
    county_names_all: "Kent",
    county_fips_all: 26081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49601,
    lat: 44.2385,
    lng: -85.5211,
    city: "Cadillac",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22312,
    density: 39.2,
    county_fips: 26165,
    county_name: "Wexford",
    county_weights: {
      26085: 8.68,
      26113: 2.9,
      26165: 88.42,
    },
    county_names_all: "Wexford|Lake|Missaukee",
    county_fips_all: "26165|26085|26113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49611,
    lat: 44.97995,
    lng: -84.97873,
    city: "Alba",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 461,
    density: 86.8,
    county_fips: 26009,
    county_name: "Antrim",
    county_weights: {
      26009: 100,
    },
    county_names_all: "Antrim",
    county_fips_all: 26009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49612,
    lat: 44.86212,
    lng: -85.22561,
    city: "Alden",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1307,
    density: 20.3,
    county_fips: 26009,
    county_name: "Antrim",
    county_weights: {
      26009: 50.66,
      26079: 49.34,
    },
    county_names_all: "Antrim|Kalkaska",
    county_fips_all: "26009|26079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49613,
    lat: 44.50538,
    lng: -86.20412,
    city: "Arcadia",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 597,
    density: 9.5,
    county_fips: 26101,
    county_name: "Manistee",
    county_weights: {
      26019: 42.12,
      26101: 57.88,
    },
    county_names_all: "Manistee|Benzie",
    county_fips_all: "26101|26019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49614,
    lat: 44.43886,
    lng: -86.10879,
    city: "Bear Lake",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3014,
    density: 12.7,
    county_fips: 26101,
    county_name: "Manistee",
    county_weights: {
      26101: 100,
    },
    county_names_all: "Manistee",
    county_fips_all: 26101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49615,
    lat: 44.97219,
    lng: -85.20683,
    city: "Bellaire",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3681,
    density: 20.8,
    county_fips: 26009,
    county_name: "Antrim",
    county_weights: {
      26009: 100,
    },
    county_names_all: "Antrim",
    county_fips_all: 26009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49616,
    lat: 44.57491,
    lng: -86.08448,
    city: "Benzonia",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2193,
    density: 23.4,
    county_fips: 26019,
    county_name: "Benzie",
    county_weights: {
      26019: 100,
    },
    county_names_all: "Benzie",
    county_fips_all: 26019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49617,
    lat: 44.64105,
    lng: -86.03505,
    city: "Beulah",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3360,
    density: 28.6,
    county_fips: 26019,
    county_name: "Benzie",
    county_weights: {
      26019: 100,
    },
    county_names_all: "Benzie",
    county_fips_all: 26019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49618,
    lat: 44.30096,
    lng: -85.59853,
    city: "Boon",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 855,
    density: 11.1,
    county_fips: 26165,
    county_name: "Wexford",
    county_weights: {
      26165: 100,
    },
    county_names_all: "Wexford",
    county_fips_all: 26165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49619,
    lat: 44.30331,
    lng: -85.98784,
    city: "Brethren",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1001,
    density: 6.6,
    county_fips: 26101,
    county_name: "Manistee",
    county_weights: {
      26101: 100,
    },
    county_names_all: "Manistee",
    county_fips_all: 26101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49620,
    lat: 44.5188,
    lng: -85.68976,
    city: "Buckley",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2634,
    density: 17.3,
    county_fips: 26055,
    county_name: "Grand Traverse",
    county_weights: {
      26055: 52.62,
      26165: 47.38,
    },
    county_names_all: "Grand Traverse|Wexford",
    county_fips_all: "26055|26165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49621,
    lat: 44.86229,
    lng: -85.77555,
    city: "Cedar",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3833,
    density: 27,
    county_fips: 26089,
    county_name: "Leelanau",
    county_weights: {
      26089: 100,
    },
    county_names_all: "Leelanau",
    county_fips_all: 26089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49622,
    lat: 45.0785,
    lng: -85.26583,
    city: "Central Lake",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2654,
    density: 22.7,
    county_fips: 26009,
    county_name: "Antrim",
    county_weights: {
      26009: 100,
    },
    county_names_all: "Antrim",
    county_fips_all: 26009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49623,
    lat: 43.90367,
    lng: -85.68285,
    city: "Chase",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1165,
    density: 6.5,
    county_fips: 26085,
    county_name: "Lake",
    county_weights: {
      26085: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 26085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49625,
    lat: 44.42785,
    lng: -85.87348,
    city: "Copemish",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1198,
    density: 6.1,
    county_fips: 26101,
    county_name: "Manistee",
    county_weights: {
      26101: 91.76,
      26165: 8.24,
    },
    county_names_all: "Manistee|Wexford",
    county_fips_all: "26101|26165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49626,
    lat: 44.24284,
    lng: -86.29252,
    city: "Eastlake",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 289,
    density: 210.1,
    county_fips: 26101,
    county_name: "Manistee",
    county_weights: {
      26101: 100,
    },
    county_names_all: "Manistee",
    county_fips_all: 26101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49627,
    lat: 45.11261,
    lng: -85.35677,
    city: "Eastport",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 175,
    density: 41.1,
    county_fips: 26009,
    county_name: "Antrim",
    county_weights: {
      26009: 100,
    },
    county_names_all: "Antrim",
    county_fips_all: 26009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49628,
    lat: 44.62087,
    lng: -86.23095,
    city: "Elberta",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 190,
    density: 97.8,
    county_fips: 26019,
    county_name: "Benzie",
    county_weights: {
      26019: 100,
    },
    county_names_all: "Benzie",
    county_fips_all: 26019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49629,
    lat: 44.90835,
    lng: -85.39424,
    city: "Elk Rapids",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2129,
    density: 219,
    county_fips: 26009,
    county_name: "Antrim",
    county_weights: {
      26009: 100,
    },
    county_names_all: "Antrim",
    county_fips_all: 26009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49630,
    lat: 44.92262,
    lng: -86.00074,
    city: "Empire",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1441,
    density: 9.2,
    county_fips: 26089,
    county_name: "Leelanau",
    county_weights: {
      26019: 3.26,
      26089: 96.74,
    },
    county_names_all: "Leelanau|Benzie",
    county_fips_all: "26089|26019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49631,
    lat: 43.91707,
    lng: -85.25788,
    city: "Evart",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5941,
    density: 15.9,
    county_fips: 26133,
    county_name: "Osceola",
    county_weights: {
      26107: 15.01,
      26133: 84.99,
    },
    county_names_all: "Osceola|Mecosta",
    county_fips_all: "26133|26107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49632,
    lat: 44.23993,
    lng: -84.97268,
    city: "Falmouth",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1042,
    density: 4.8,
    county_fips: 26113,
    county_name: "Missaukee",
    county_weights: {
      26113: 100,
    },
    county_names_all: "Missaukee",
    county_fips_all: 26113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49633,
    lat: 44.55709,
    lng: -85.19318,
    city: "Fife Lake",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3476,
    density: 8,
    county_fips: 26079,
    county_name: "Kalkaska",
    county_weights: {
      26055: 18.08,
      26079: 72.15,
      26113: 4.16,
      26165: 5.61,
    },
    county_names_all: "Kalkaska|Grand Traverse|Wexford|Missaukee",
    county_fips_all: "26079|26055|26165|26113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49634,
    lat: 44.2149,
    lng: -86.28896,
    city: "Filer City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67,
    density: 99.8,
    county_fips: 26101,
    county_name: "Manistee",
    county_weights: {
      26101: 100,
    },
    county_names_all: "Manistee",
    county_fips_all: 26101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49635,
    lat: 44.62261,
    lng: -86.18914,
    city: "Frankfort",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3273,
    density: 32.8,
    county_fips: 26019,
    county_name: "Benzie",
    county_weights: {
      26019: 100,
    },
    county_names_all: "Benzie",
    county_fips_all: 26019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49636,
    lat: 44.87261,
    lng: -85.99292,
    city: "Glen Arbor",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 434,
    density: 12.4,
    county_fips: 26089,
    county_name: "Leelanau",
    county_weights: {
      26089: 100,
    },
    county_names_all: "Leelanau",
    county_fips_all: 26089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49637,
    lat: 44.62897,
    lng: -85.71083,
    city: "Grawn",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3349,
    density: 58.2,
    county_fips: 26055,
    county_name: "Grand Traverse",
    county_weights: {
      26055: 100,
    },
    county_names_all: "Grand Traverse",
    county_fips_all: 26055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49638,
    lat: 44.28463,
    lng: -85.75073,
    city: "Harrietta",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 858,
    density: 4.5,
    county_fips: 26165,
    county_name: "Wexford",
    county_weights: {
      26101: 21.71,
      26165: 78.29,
    },
    county_names_all: "Wexford|Manistee",
    county_fips_all: "26165|26101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49639,
    lat: 43.8467,
    lng: -85.39768,
    city: "Hersey",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2522,
    density: 15.8,
    county_fips: 26133,
    county_name: "Osceola",
    county_weights: {
      26107: 22.85,
      26133: 77.15,
    },
    county_names_all: "Osceola|Mecosta",
    county_fips_all: "26133|26107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49640,
    lat: 44.72088,
    lng: -86.03664,
    city: "Honor",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1369,
    density: 8.3,
    county_fips: 26019,
    county_name: "Benzie",
    county_weights: {
      26019: 97.03,
      26089: 2.97,
    },
    county_names_all: "Benzie|Leelanau",
    county_fips_all: "26019|26089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49642,
    lat: 43.87927,
    lng: -85.77059,
    city: "Idlewild",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 918,
    density: 23.3,
    county_fips: 26085,
    county_name: "Lake",
    county_weights: {
      26085: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 26085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49643,
    lat: 44.63959,
    lng: -85.83357,
    city: "Interlochen",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7066,
    density: 45.8,
    county_fips: 26019,
    county_name: "Benzie",
    county_weights: {
      26019: 57.45,
      26055: 42.55,
    },
    county_names_all: "Benzie|Grand Traverse",
    county_fips_all: "26019|26055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49644,
    lat: 44.10787,
    lng: -85.91989,
    city: "Irons",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2104,
    density: 7.3,
    county_fips: 26085,
    county_name: "Lake",
    county_weights: {
      26085: 93.58,
      26101: 2.77,
      26105: 3.65,
    },
    county_names_all: "Lake|Mason|Manistee",
    county_fips_all: "26085|26105|26101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49645,
    lat: 44.37157,
    lng: -86.02411,
    city: "Kaleva",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1617,
    density: 14.1,
    county_fips: 26101,
    county_name: "Manistee",
    county_weights: {
      26101: 100,
    },
    county_names_all: "Manistee",
    county_fips_all: 26101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49646,
    lat: 44.72727,
    lng: -85.04926,
    city: "Kalkaska",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8246,
    density: 14.5,
    county_fips: 26079,
    county_name: "Kalkaska",
    county_weights: {
      26079: 100,
    },
    county_names_all: "Kalkaska",
    county_fips_all: 26079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49648,
    lat: 44.98359,
    lng: -85.3435,
    city: "Kewadin",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2442,
    density: 34.6,
    county_fips: 26009,
    county_name: "Antrim",
    county_weights: {
      26009: 100,
    },
    county_names_all: "Antrim",
    county_fips_all: 26009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49649,
    lat: 44.5685,
    lng: -85.52596,
    city: "Kingsley",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7089,
    density: 24.8,
    county_fips: 26055,
    county_name: "Grand Traverse",
    county_weights: {
      26055: 91,
      26165: 9,
    },
    county_names_all: "Grand Traverse|Wexford",
    county_fips_all: "26055|26165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49650,
    lat: 44.73359,
    lng: -85.88033,
    city: "Lake Ann",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3465,
    density: 55.7,
    county_fips: 26019,
    county_name: "Benzie",
    county_weights: {
      26019: 100,
    },
    county_names_all: "Benzie",
    county_fips_all: 26019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49651,
    lat: 44.39603,
    lng: -85.10862,
    city: "Lake City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7868,
    density: 12.9,
    county_fips: 26113,
    county_name: "Missaukee",
    county_weights: {
      26113: 100,
    },
    county_names_all: "Missaukee",
    county_fips_all: 26113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49653,
    lat: 44.97184,
    lng: -85.7302,
    city: "Lake Leelanau",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1863,
    density: 25.9,
    county_fips: 26089,
    county_name: "Leelanau",
    county_weights: {
      26089: 100,
    },
    county_names_all: "Leelanau",
    county_fips_all: 26089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49654,
    lat: 45.0268,
    lng: -86.00875,
    city: "Leland",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 572,
    density: 18.9,
    county_fips: 26089,
    county_name: "Leelanau",
    county_weights: {
      26089: 100,
    },
    county_names_all: "Leelanau",
    county_fips_all: 26089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49655,
    lat: 44.02718,
    lng: -85.43875,
    city: "Leroy",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3657,
    density: 16.1,
    county_fips: 26133,
    county_name: "Osceola",
    county_weights: {
      26085: 2.26,
      26133: 97.74,
    },
    county_names_all: "Osceola|Lake",
    county_fips_all: "26133|26085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49656,
    lat: 44.05248,
    lng: -85.69789,
    city: "Luther",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1588,
    density: 5.2,
    county_fips: 26085,
    county_name: "Lake",
    county_weights: {
      26085: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 26085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49657,
    lat: 44.21523,
    lng: -85.17653,
    city: "McBain",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3562,
    density: 14.9,
    county_fips: 26113,
    county_name: "Missaukee",
    county_weights: {
      26113: 99.67,
      26165: 0.33,
    },
    county_names_all: "Missaukee|Wexford",
    county_fips_all: "26113|26165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49659,
    lat: 44.90265,
    lng: -85.02679,
    city: "Mancelona",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6988,
    density: 15.4,
    county_fips: 26009,
    county_name: "Antrim",
    county_weights: {
      26009: 74.53,
      26079: 25.47,
    },
    county_names_all: "Antrim|Kalkaska",
    county_fips_all: "26009|26079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49660,
    lat: 44.23236,
    lng: -86.21125,
    city: "Manistee",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14295,
    density: 32.2,
    county_fips: 26101,
    county_name: "Manistee",
    county_weights: {
      26101: 82.3,
      26105: 17.7,
    },
    county_names_all: "Manistee|Mason",
    county_fips_all: "26101|26105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49663,
    lat: 44.42494,
    lng: -85.39147,
    city: "Manton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6083,
    density: 14.4,
    county_fips: 26165,
    county_name: "Wexford",
    county_weights: {
      26113: 33.53,
      26165: 66.47,
    },
    county_names_all: "Wexford|Missaukee",
    county_fips_all: "26165|26113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49664,
    lat: 44.87457,
    lng: -85.89058,
    city: "Maple City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1798,
    density: 11.7,
    county_fips: 26089,
    county_name: "Leelanau",
    county_weights: {
      26089: 100,
    },
    county_names_all: "Leelanau",
    county_fips_all: 26089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49665,
    lat: 44.0995,
    lng: -85.1309,
    city: "Marion",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4329,
    density: 10.7,
    county_fips: 26133,
    county_name: "Osceola",
    county_weights: {
      26035: 29.06,
      26113: 6.6,
      26133: 64.34,
    },
    county_names_all: "Osceola|Clare|Missaukee",
    county_fips_all: "26133|26035|26113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49667,
    lat: 44.34892,
    lng: -84.91898,
    city: "Merritt",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 549,
    density: 3.3,
    county_fips: 26113,
    county_name: "Missaukee",
    county_weights: {
      26113: 100,
    },
    county_names_all: "Missaukee",
    county_fips_all: 26113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49668,
    lat: 44.4028,
    lng: -85.70965,
    city: "Mesick",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3190,
    density: 11.5,
    county_fips: 26165,
    county_name: "Wexford",
    county_weights: {
      26101: 1.92,
      26165: 98.08,
    },
    county_names_all: "Wexford|Manistee",
    county_fips_all: "26165|26101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49670,
    lat: 45.12088,
    lng: -85.62096,
    city: "Northport",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2060,
    density: 21.6,
    county_fips: 26089,
    county_name: "Leelanau",
    county_weights: {
      26089: 100,
    },
    county_names_all: "Leelanau",
    county_fips_all: 26089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49674,
    lat: 45.0544,
    lng: -85.58882,
    city: "Omena",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44,
    density: 7.4,
    county_fips: 26089,
    county_name: "Leelanau",
    county_weights: {
      26089: 100,
    },
    county_names_all: "Leelanau",
    county_fips_all: 26089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49675,
    lat: 44.37506,
    lng: -86.21978,
    city: "Onekama",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 888,
    density: 33.6,
    county_fips: 26101,
    county_name: "Manistee",
    county_weights: {
      26101: 100,
    },
    county_names_all: "Manistee",
    county_fips_all: 26101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49676,
    lat: 44.84147,
    lng: -85.29028,
    city: "Rapid City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3742,
    density: 35.3,
    county_fips: 26079,
    county_name: "Kalkaska",
    county_weights: {
      26009: 47.29,
      26079: 52.71,
    },
    county_names_all: "Kalkaska|Antrim",
    county_fips_all: "26079|26009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49677,
    lat: 43.89533,
    lng: -85.54254,
    city: "Reed City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6999,
    density: 21.3,
    county_fips: 26133,
    county_name: "Osceola",
    county_weights: {
      26085: 30.13,
      26123: 11.82,
      26133: 58.05,
    },
    county_names_all: "Osceola|Lake|Newaygo",
    county_fips_all: "26133|26085|26123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49679,
    lat: 43.8747,
    lng: -85.14895,
    city: "Sears",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1109,
    density: 7.7,
    county_fips: 26133,
    county_name: "Osceola",
    county_weights: {
      26107: 13.39,
      26133: 86.61,
    },
    county_names_all: "Osceola|Mecosta",
    county_fips_all: "26133|26107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49680,
    lat: 44.64174,
    lng: -85.25089,
    city: "South Boardman",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2033,
    density: 14.2,
    county_fips: 26079,
    county_name: "Kalkaska",
    county_weights: {
      26079: 100,
    },
    county_names_all: "Kalkaska",
    county_fips_all: 26079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49682,
    lat: 44.97954,
    lng: -85.6512,
    city: "Suttons Bay",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4224,
    density: 39.5,
    county_fips: 26089,
    county_name: "Leelanau",
    county_weights: {
      26089: 100,
    },
    county_names_all: "Leelanau",
    county_fips_all: 26089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49683,
    lat: 44.53948,
    lng: -85.93009,
    city: "Thompsonville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2100,
    density: 9.4,
    county_fips: 26019,
    county_name: "Benzie",
    county_weights: {
      26019: 70.7,
      26055: 5.38,
      26101: 22.66,
      26165: 1.26,
    },
    county_names_all: "Benzie|Manistee|Grand Traverse|Wexford",
    county_fips_all: "26019|26101|26055|26165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49684,
    lat: 44.80191,
    lng: -85.70549,
    city: "Traverse City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40363,
    density: 295.4,
    county_fips: 26089,
    county_name: "Leelanau",
    county_weights: {
      26019: 6.06,
      26055: 31.71,
      26089: 62.23,
    },
    county_names_all: "Leelanau|Grand Traverse|Benzie",
    county_fips_all: "26089|26055|26019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49685,
    lat: 44.69859,
    lng: -85.70425,
    city: "Traverse City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 26055,
    county_name: "Grand Traverse",
    county_weights: {
      26055: 100,
    },
    county_names_all: "Grand Traverse",
    county_fips_all: 26055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49686,
    lat: 44.82841,
    lng: -85.53597,
    city: "Traverse City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34341,
    density: 280.3,
    county_fips: 26055,
    county_name: "Grand Traverse",
    county_weights: {
      26055: 100,
    },
    county_names_all: "Grand Traverse",
    county_fips_all: 26055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49688,
    lat: 44.12115,
    lng: -85.44349,
    city: "Tustin",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2369,
    density: 10,
    county_fips: 26133,
    county_name: "Osceola",
    county_weights: {
      26085: 10.47,
      26133: 88.64,
      26165: 0.89,
    },
    county_names_all: "Osceola|Lake|Wexford",
    county_fips_all: "26133|26085|26165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49689,
    lat: 44.21165,
    lng: -85.91484,
    city: "Wellston",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1550,
    density: 7.4,
    county_fips: 26101,
    county_name: "Manistee",
    county_weights: {
      26101: 83.85,
      26165: 16.15,
    },
    county_names_all: "Manistee|Wexford",
    county_fips_all: "26101|26165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49690,
    lat: 44.77915,
    lng: -85.38964,
    city: "Williamsburg",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6868,
    density: 32.1,
    county_fips: 26055,
    county_name: "Grand Traverse",
    county_weights: {
      26009: 5.09,
      26055: 77.39,
      26079: 17.52,
    },
    county_names_all: "Grand Traverse|Kalkaska|Antrim",
    county_fips_all: "26055|26079|26009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49696,
    lat: 44.6764,
    lng: -85.48413,
    city: "Traverse City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 26055,
    county_name: "Grand Traverse",
    county_weights: {
      26055: 100,
    },
    county_names_all: "Grand Traverse",
    county_fips_all: 26055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49701,
    lat: 45.75195,
    lng: -84.7426,
    city: "Mackinaw City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 805,
    density: 17.9,
    county_fips: 26047,
    county_name: "Emmet",
    county_weights: {
      26031: 35.9,
      26047: 64.1,
    },
    county_names_all: "Emmet|Cheboygan",
    county_fips_all: "26047|26031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49705,
    lat: 45.34826,
    lng: -84.45824,
    city: "Afton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 922,
    density: 5.3,
    county_fips: 26031,
    county_name: "Cheboygan",
    county_weights: {
      26031: 100,
    },
    county_names_all: "Cheboygan",
    county_fips_all: 26031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49706,
    lat: 45.44129,
    lng: -84.77915,
    city: "Alanson",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4495,
    density: 29.7,
    county_fips: 26047,
    county_name: "Emmet",
    county_weights: {
      26031: 26.96,
      26047: 73.04,
    },
    county_names_all: "Emmet|Cheboygan",
    county_fips_all: "26047|26031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49707,
    lat: 45.09375,
    lng: -83.50186,
    city: "Alpena",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21675,
    density: 38.8,
    county_fips: 26007,
    county_name: "Alpena",
    county_weights: {
      26007: 96.17,
      26141: 3.83,
    },
    county_names_all: "Alpena|Presque Isle",
    county_fips_all: "26007|26141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49709,
    lat: 45.03102,
    lng: -84.17094,
    city: "Atlanta",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3540,
    density: 5.9,
    county_fips: 26119,
    county_name: "Montmorency",
    county_weights: {
      26119: 100,
    },
    county_names_all: "Montmorency",
    county_fips_all: 26119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49710,
    lat: 46.27717,
    lng: -84.18478,
    city: "Barbeau",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 360,
    density: 4,
    county_fips: 26033,
    county_name: "Chippewa",
    county_weights: {
      26033: 100,
    },
    county_names_all: "Chippewa",
    county_fips_all: 26033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49712,
    lat: 45.2113,
    lng: -85.01089,
    city: "Boyne City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8015,
    density: 42.4,
    county_fips: 26029,
    county_name: "Charlevoix",
    county_weights: {
      26009: 8.42,
      26029: 91.58,
    },
    county_names_all: "Charlevoix|Antrim",
    county_fips_all: "26029|26009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49713,
    lat: 45.21602,
    lng: -84.85185,
    city: "Boyne Falls",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1991,
    density: 7.6,
    county_fips: 26029,
    county_name: "Charlevoix",
    county_weights: {
      26009: 1.95,
      26029: 94.41,
      26047: 3.64,
    },
    county_names_all: "Charlevoix|Emmet|Antrim",
    county_fips_all: "26029|26047|26009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49715,
    lat: 46.3923,
    lng: -84.69493,
    city: "Brimley",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3434,
    density: 7.6,
    county_fips: 26033,
    county_name: "Chippewa",
    county_weights: {
      26033: 100,
    },
    county_names_all: "Chippewa",
    county_fips_all: 26033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49716,
    lat: 45.50975,
    lng: -84.75104,
    city: "Brutus",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 950,
    density: 16,
    county_fips: 26047,
    county_name: "Emmet",
    county_weights: {
      26031: 28.29,
      26047: 71.71,
    },
    county_names_all: "Emmet|Cheboygan",
    county_fips_all: "26047|26031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49717,
    lat: 45.43671,
    lng: -84.69796,
    city: "Burt Lake",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 93,
    density: 28.4,
    county_fips: 26031,
    county_name: "Cheboygan",
    county_weights: {
      26031: 100,
    },
    county_names_all: "Cheboygan",
    county_fips_all: 26031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49718,
    lat: 45.71438,
    lng: -84.81275,
    city: "Carp Lake",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 754,
    density: 6.6,
    county_fips: 26047,
    county_name: "Emmet",
    county_weights: {
      26031: 18.59,
      26047: 81.41,
    },
    county_names_all: "Emmet|Cheboygan",
    county_fips_all: "26047|26031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49719,
    lat: 46.0073,
    lng: -84.29304,
    city: "Cedarville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1283,
    density: 7.4,
    county_fips: 26097,
    county_name: "Mackinac",
    county_weights: {
      26033: 15.93,
      26097: 84.07,
    },
    county_names_all: "Mackinac|Chippewa",
    county_fips_all: "26097|26033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49720,
    lat: 45.27555,
    lng: -85.23984,
    city: "Charlevoix",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8971,
    density: 36.3,
    county_fips: 26029,
    county_name: "Charlevoix",
    county_weights: {
      26009: 8.02,
      26029: 91.98,
    },
    county_names_all: "Charlevoix|Antrim",
    county_fips_all: "26029|26009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49721,
    lat: 45.57181,
    lng: -84.45711,
    city: "Cheboygan",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13824,
    density: 20,
    county_fips: 26031,
    county_name: "Cheboygan",
    county_weights: {
      26031: 100,
    },
    county_names_all: "Cheboygan",
    county_fips_all: 26031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49722,
    lat: 45.42135,
    lng: -84.86459,
    city: "Conway",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 127,
    density: 123,
    county_fips: 26047,
    county_name: "Emmet",
    county_weights: {
      26047: 100,
    },
    county_names_all: "Emmet",
    county_fips_all: 26047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49724,
    lat: 46.32744,
    lng: -84.3884,
    city: "Dafter",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1166,
    density: 7.4,
    county_fips: 26033,
    county_name: "Chippewa",
    county_weights: {
      26033: 100,
    },
    county_names_all: "Chippewa",
    county_fips_all: 26033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49725,
    lat: 46.00337,
    lng: -84.01308,
    city: "De Tour Village",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 610,
    density: 5.2,
    county_fips: 26033,
    county_name: "Chippewa",
    county_weights: {
      26033: 100,
    },
    county_names_all: "Chippewa",
    county_fips_all: 26033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49726,
    lat: 46.00169,
    lng: -83.66277,
    city: "Drummond Island",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1012,
    density: 3,
    county_fips: 26033,
    county_name: "Chippewa",
    county_weights: {
      26033: 100,
    },
    county_names_all: "Chippewa",
    county_fips_all: 26033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49727,
    lat: 45.13452,
    lng: -85.10679,
    city: "East Jordan",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6951,
    density: 22.4,
    county_fips: 26029,
    county_name: "Charlevoix",
    county_weights: {
      26009: 46.61,
      26029: 53.39,
    },
    county_names_all: "Charlevoix|Antrim",
    county_fips_all: "26029|26009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49728,
    lat: 46.3702,
    lng: -84.99387,
    city: "Eckerman",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 359,
    density: 0.8,
    county_fips: 26033,
    county_name: "Chippewa",
    county_weights: {
      26033: 100,
    },
    county_names_all: "Chippewa",
    county_fips_all: 26033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49729,
    lat: 45.16123,
    lng: -85.28255,
    city: "Ellsworth",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1507,
    density: 15.6,
    county_fips: 26009,
    county_name: "Antrim",
    county_weights: {
      26009: 84.16,
      26029: 15.84,
    },
    county_names_all: "Antrim|Charlevoix",
    county_fips_all: "26009|26029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49730,
    lat: 45.04641,
    lng: -84.87644,
    city: "Elmira",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2163,
    density: 8.7,
    county_fips: 26009,
    county_name: "Antrim",
    county_weights: {
      26009: 63.14,
      26029: 15.12,
      26137: 21.74,
    },
    county_names_all: "Antrim|Otsego|Charlevoix",
    county_fips_all: "26009|26137|26029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49733,
    lat: 44.80368,
    lng: -84.7291,
    city: "Frederic",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1832,
    density: 6.6,
    county_fips: 26039,
    county_name: "Crawford",
    county_weights: {
      26039: 87.3,
      26137: 12.7,
    },
    county_names_all: "Crawford|Otsego",
    county_fips_all: "26039|26137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49735,
    lat: 44.99576,
    lng: -84.67117,
    city: "Gaylord",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19865,
    density: 30.9,
    county_fips: 26137,
    county_name: "Otsego",
    county_weights: {
      26137: 100,
    },
    county_names_all: "Otsego",
    county_fips_all: 26137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49736,
    lat: 46.07877,
    lng: -84.14573,
    city: "Goetzville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 415,
    density: 2.2,
    county_fips: 26033,
    county_name: "Chippewa",
    county_weights: {
      26033: 100,
    },
    county_names_all: "Chippewa",
    county_fips_all: 26033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49738,
    lat: 44.69296,
    lng: -84.60578,
    city: "Grayling",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9922,
    density: 11.5,
    county_fips: 26039,
    county_name: "Crawford",
    county_weights: {
      26039: 93.95,
      26079: 4.01,
      26137: 2.04,
    },
    county_names_all: "Crawford|Kalkaska|Otsego",
    county_fips_all: "26039|26079|26137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49740,
    lat: 45.52303,
    lng: -84.99887,
    city: "Harbor Springs",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7098,
    density: 21.9,
    county_fips: 26047,
    county_name: "Emmet",
    county_weights: {
      26047: 100,
    },
    county_names_all: "Emmet",
    county_fips_all: 26047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49743,
    lat: 45.27124,
    lng: -83.89394,
    city: "Hawks",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 842,
    density: 3.7,
    county_fips: 26141,
    county_name: "Presque Isle",
    county_weights: {
      26141: 100,
    },
    county_names_all: "Presque Isle",
    county_fips_all: 26141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49744,
    lat: 45.00354,
    lng: -83.66405,
    city: "Herron",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 596,
    density: 6.2,
    county_fips: 26007,
    county_name: "Alpena",
    county_weights: {
      26007: 100,
    },
    county_names_all: "Alpena",
    county_fips_all: 26007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49745,
    lat: 46.05065,
    lng: -84.519,
    city: "Hessel",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 956,
    density: 4.6,
    county_fips: 26097,
    county_name: "Mackinac",
    county_weights: {
      26097: 100,
    },
    county_names_all: "Mackinac",
    county_fips_all: 26097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49746,
    lat: 45.06437,
    lng: -83.95239,
    city: "Hillman",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3387,
    density: 6.2,
    county_fips: 26119,
    county_name: "Montmorency",
    county_weights: {
      26007: 19.08,
      26119: 80.92,
    },
    county_names_all: "Montmorency|Alpena",
    county_fips_all: "26119|26007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49747,
    lat: 44.85132,
    lng: -83.64516,
    city: "Hubbard Lake",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2305,
    density: 8.7,
    county_fips: 26001,
    county_name: "Alcona",
    county_weights: {
      26001: 54.76,
      26007: 45.24,
    },
    county_names_all: "Alcona|Alpena",
    county_fips_all: "26001|26007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49748,
    lat: 46.37491,
    lng: -85.18039,
    city: "Hulbert",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 183,
    density: 0.6,
    county_fips: 26033,
    county_name: "Chippewa",
    county_weights: {
      26033: 91.66,
      26095: 8.34,
    },
    county_names_all: "Chippewa|Luce",
    county_fips_all: "26033|26095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49749,
    lat: 45.41634,
    lng: -84.57891,
    city: "Indian River",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4326,
    density: 25.8,
    county_fips: 26031,
    county_name: "Cheboygan",
    county_weights: {
      26031: 100,
    },
    county_names_all: "Cheboygan",
    county_fips_all: 26031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49751,
    lat: 44.99496,
    lng: -84.41309,
    city: "Johannesburg",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2097,
    density: 5.2,
    county_fips: 26137,
    county_name: "Otsego",
    county_weights: {
      26119: 29.84,
      26137: 70.16,
    },
    county_names_all: "Otsego|Montmorency",
    county_fips_all: "26137|26119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49752,
    lat: 46.27629,
    lng: -84.46091,
    city: "Kinross",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 603,
    density: 11.2,
    county_fips: 26033,
    county_name: "Chippewa",
    county_weights: {
      26033: 100,
    },
    county_names_all: "Chippewa",
    county_fips_all: 26033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49753,
    lat: 45.01566,
    lng: -83.77644,
    city: "Lachine",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1972,
    density: 4.8,
    county_fips: 26007,
    county_name: "Alpena",
    county_weights: {
      26007: 100,
    },
    county_names_all: "Alpena",
    county_fips_all: 26007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49755,
    lat: 45.63886,
    lng: -84.80524,
    city: "Levering",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1861,
    density: 7,
    county_fips: 26047,
    county_name: "Emmet",
    county_weights: {
      26031: 26.8,
      26047: 73.2,
    },
    county_names_all: "Emmet|Cheboygan",
    county_fips_all: "26047|26031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49756,
    lat: 44.81482,
    lng: -84.27339,
    city: "Lewiston",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3575,
    density: 7.3,
    county_fips: 26135,
    county_name: "Oscoda",
    county_weights: {
      26039: 2.49,
      26119: 34.83,
      26135: 60.73,
      26137: 1.95,
    },
    county_names_all: "Oscoda|Montmorency|Crawford|Otsego",
    county_fips_all: "26135|26119|26039|26137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49757,
    lat: 45.85933,
    lng: -84.62533,
    city: "Mackinac Island",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 992,
    density: 88,
    county_fips: 26097,
    county_name: "Mackinac",
    county_weights: {
      26097: 100,
    },
    county_names_all: "Mackinac",
    county_fips_all: 26097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49759,
    lat: 45.40545,
    lng: -84.10055,
    city: "Millersburg",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1398,
    density: 3.4,
    county_fips: 26141,
    county_name: "Presque Isle",
    county_weights: {
      26141: 100,
    },
    county_names_all: "Presque Isle",
    county_fips_all: 26141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49760,
    lat: 46.05715,
    lng: -84.88881,
    city: "Moran",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 673,
    density: 1.9,
    county_fips: 26097,
    county_name: "Mackinac",
    county_weights: {
      26033: 4.18,
      26097: 95.82,
    },
    county_names_all: "Mackinac|Chippewa",
    county_fips_all: "26097|26033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49762,
    lat: 46.13126,
    lng: -85.24115,
    city: "Naubinway",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 587,
    density: 1,
    county_fips: 26097,
    county_name: "Mackinac",
    county_weights: {
      26097: 100,
    },
    county_names_all: "Mackinac",
    county_fips_all: 26097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49764,
    lat: 45.42356,
    lng: -84.82824,
    city: "Oden",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 401,
    density: 4211.5,
    county_fips: 26047,
    county_name: "Emmet",
    county_weights: {
      26047: 100,
    },
    county_names_all: "Emmet",
    county_fips_all: 26047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49765,
    lat: 45.33379,
    lng: -84.25229,
    city: "Onaway",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4120,
    density: 6.7,
    county_fips: 26141,
    county_name: "Presque Isle",
    county_weights: {
      26031: 49.18,
      26141: 50.82,
    },
    county_names_all: "Presque Isle|Cheboygan",
    county_fips_all: "26141|26031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49766,
    lat: 44.90643,
    lng: -83.4512,
    city: "Ossineke",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2218,
    density: 18.7,
    county_fips: 26007,
    county_name: "Alpena",
    county_weights: {
      26007: 100,
    },
    county_names_all: "Alpena",
    county_fips_all: 26007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49768,
    lat: 46.63217,
    lng: -85.13434,
    city: "Paradise",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 475,
    density: 1,
    county_fips: 26033,
    county_name: "Chippewa",
    county_weights: {
      26033: 100,
    },
    county_names_all: "Chippewa",
    county_fips_all: 26033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49769,
    lat: 45.56797,
    lng: -84.85681,
    city: "Pellston",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1680,
    density: 11.4,
    county_fips: 26047,
    county_name: "Emmet",
    county_weights: {
      26031: 14.44,
      26047: 85.56,
    },
    county_names_all: "Emmet|Cheboygan",
    county_fips_all: "26047|26031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49770,
    lat: 45.34396,
    lng: -84.88903,
    city: "Petoskey",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17205,
    density: 60.7,
    county_fips: 26047,
    county_name: "Emmet",
    county_weights: {
      26029: 4.19,
      26031: 1.06,
      26047: 94.75,
    },
    county_names_all: "Emmet|Charlevoix|Cheboygan",
    county_fips_all: "26047|26029|26031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49774,
    lat: 46.16081,
    lng: -84.33798,
    city: "Pickford",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1774,
    density: 4.5,
    county_fips: 26033,
    county_name: "Chippewa",
    county_weights: {
      26033: 78.21,
      26097: 21.79,
    },
    county_names_all: "Chippewa|Mackinac",
    county_fips_all: "26033|26097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49775,
    lat: 45.76941,
    lng: -84.46333,
    city: "Pointe Aux Pins",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63,
    density: 0.7,
    county_fips: 26097,
    county_name: "Mackinac",
    county_weights: {
      26097: 100,
    },
    county_names_all: "Mackinac",
    county_fips_all: 26097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49776,
    lat: 45.24634,
    lng: -83.6873,
    city: "Posen",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1528,
    density: 4.4,
    county_fips: 26141,
    county_name: "Presque Isle",
    county_weights: {
      26007: 24.59,
      26141: 75.41,
    },
    county_names_all: "Presque Isle|Alpena",
    county_fips_all: "26141|26007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49777,
    lat: 45.28323,
    lng: -83.49624,
    city: "Presque Isle",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1880,
    density: 13.5,
    county_fips: 26141,
    county_name: "Presque Isle",
    county_weights: {
      26141: 100,
    },
    county_names_all: "Presque Isle",
    county_fips_all: 26141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49779,
    lat: 45.39651,
    lng: -83.87153,
    city: "Rogers City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4379,
    density: 12.7,
    county_fips: 26141,
    county_name: "Presque Isle",
    county_weights: {
      26141: 100,
    },
    county_names_all: "Presque Isle",
    county_fips_all: 26141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49780,
    lat: 46.20913,
    lng: -84.6854,
    city: "Rudyard",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1725,
    density: 2.5,
    county_fips: 26033,
    county_name: "Chippewa",
    county_weights: {
      26033: 74.57,
      26097: 25.43,
    },
    county_names_all: "Chippewa|Mackinac",
    county_fips_all: "26033|26097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49781,
    lat: 45.95272,
    lng: -84.77652,
    city: "Saint Ignace",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3471,
    density: 16.4,
    county_fips: 26097,
    county_name: "Mackinac",
    county_weights: {
      26097: 100,
    },
    county_names_all: "Mackinac",
    county_fips_all: 26097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49782,
    lat: 45.65547,
    lng: -85.55199,
    city: "Beaver Island",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 578,
    density: 4,
    county_fips: 26029,
    county_name: "Charlevoix",
    county_weights: {
      26029: 100,
    },
    county_names_all: "Charlevoix",
    county_fips_all: 26029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49783,
    lat: 46.41495,
    lng: -84.28006,
    city: "Sault Sainte Marie",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19250,
    density: 50,
    county_fips: 26033,
    county_name: "Chippewa",
    county_weights: {
      26033: 100,
    },
    county_names_all: "Chippewa",
    county_fips_all: 26033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49784,
    lat: 46.2577,
    lng: -84.45483,
    city: "Kincheloe",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 26033,
    county_name: "Chippewa",
    county_weights: {
      26033: 100,
    },
    county_names_all: "Chippewa",
    county_fips_all: 26033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49788,
    lat: 46.26418,
    lng: -84.46779,
    city: "Kincheloe",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6283,
    density: 320.1,
    county_fips: 26033,
    county_name: "Chippewa",
    county_weights: {
      26033: 100,
    },
    county_names_all: "Chippewa",
    county_fips_all: 26033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49791,
    lat: 45.48093,
    lng: -84.59945,
    city: "Topinabee",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 361,
    density: 266.8,
    county_fips: 26031,
    county_name: "Cheboygan",
    county_weights: {
      26031: 100,
    },
    county_names_all: "Cheboygan",
    county_fips_all: 26031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49793,
    lat: 46.21221,
    lng: -85.04417,
    city: "Trout Lake",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 164,
    density: 0.8,
    county_fips: 26033,
    county_name: "Chippewa",
    county_weights: {
      26033: 79.41,
      26097: 20.59,
    },
    county_names_all: "Chippewa|Mackinac",
    county_fips_all: "26033|26097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49795,
    lat: 45.15835,
    lng: -84.57563,
    city: "Vanderbilt",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1903,
    density: 5.5,
    county_fips: 26137,
    county_name: "Otsego",
    county_weights: {
      26029: 8.12,
      26031: 7.48,
      26137: 84.4,
    },
    county_names_all: "Otsego|Charlevoix|Cheboygan",
    county_fips_all: "26137|26029|26031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49796,
    lat: 45.27407,
    lng: -84.94712,
    city: "Walloon Lake",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 321,
    density: 78.3,
    county_fips: 26029,
    county_name: "Charlevoix",
    county_weights: {
      26029: 100,
    },
    county_names_all: "Charlevoix",
    county_fips_all: 26029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49799,
    lat: 45.26597,
    lng: -84.58177,
    city: "Wolverine",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2123,
    density: 6.9,
    county_fips: 26031,
    county_name: "Cheboygan",
    county_weights: {
      26031: 100,
    },
    county_names_all: "Cheboygan",
    county_fips_all: 26031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49801,
    lat: 45.9191,
    lng: -88.01795,
    city: "Iron Mountain",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11328,
    density: 35.3,
    county_fips: 26043,
    county_name: "Dickinson",
    county_weights: {
      26043: 100,
    },
    county_names_all: "Dickinson",
    county_fips_all: 26043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49802,
    lat: 45.80053,
    lng: -88.07718,
    city: "Kingsford",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5866,
    density: 287.2,
    county_fips: 26043,
    county_name: "Dickinson",
    county_weights: {
      26043: 100,
    },
    county_names_all: "Dickinson",
    county_fips_all: 26043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49805,
    lat: 47.3481,
    lng: -88.38535,
    city: "Allouez",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 442,
    density: 5.3,
    county_fips: 26083,
    county_name: "Keweenaw",
    county_weights: {
      26061: 0.26,
      26083: 99.74,
    },
    county_names_all: "Keweenaw|Houghton",
    county_fips_all: "26083|26061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49806,
    lat: 46.43802,
    lng: -86.90056,
    city: "Au Train",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 679,
    density: 7.5,
    county_fips: 26003,
    county_name: "Alger",
    county_weights: {
      26003: 100,
    },
    county_names_all: "Alger",
    county_fips_all: 26003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49807,
    lat: 45.71211,
    lng: -87.28885,
    city: "Bark River",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3510,
    density: 9.4,
    county_fips: 26041,
    county_name: "Delta",
    county_weights: {
      26041: 75.58,
      26109: 24.42,
    },
    county_names_all: "Delta|Menominee",
    county_fips_all: "26041|26109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49808,
    lat: 46.8109,
    lng: -87.8764,
    city: "Big Bay",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 587,
    density: 1.3,
    county_fips: 26103,
    county_name: "Marquette",
    county_weights: {
      26103: 100,
    },
    county_names_all: "Marquette",
    county_fips_all: 26103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49812,
    lat: 45.59094,
    lng: -87.50269,
    city: "Carney",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 808,
    density: 3.7,
    county_fips: 26109,
    county_name: "Menominee",
    county_weights: {
      26109: 100,
    },
    county_names_all: "Menominee",
    county_fips_all: 26109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49814,
    lat: 46.54459,
    lng: -87.94395,
    city: "Champion",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1327,
    density: 2.5,
    county_fips: 26103,
    county_name: "Marquette",
    county_weights: {
      26103: 100,
    },
    county_names_all: "Marquette",
    county_fips_all: 26103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49815,
    lat: 46.18465,
    lng: -87.95967,
    city: "Channing",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 239,
    density: 0.7,
    county_fips: 26043,
    county_name: "Dickinson",
    county_weights: {
      26043: 100,
    },
    county_names_all: "Dickinson",
    county_fips_all: 26043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49816,
    lat: 46.27517,
    lng: -86.89863,
    city: "Chatham",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 746,
    density: 5,
    county_fips: 26003,
    county_name: "Alger",
    county_weights: {
      26003: 100,
    },
    county_names_all: "Alger",
    county_fips_all: 26003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49817,
    lat: 45.94711,
    lng: -86.49946,
    city: "Cooks",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 619,
    density: 2.9,
    county_fips: 26041,
    county_name: "Delta",
    county_weights: {
      26041: 60.12,
      26153: 39.88,
    },
    county_names_all: "Delta|Schoolcraft",
    county_fips_all: "26041|26153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49818,
    lat: 45.98223,
    lng: -87.34745,
    city: "Cornell",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1126,
    density: 2.3,
    county_fips: 26103,
    county_name: "Marquette",
    county_weights: {
      26041: 47.64,
      26103: 52.36,
    },
    county_names_all: "Marquette|Delta",
    county_fips_all: "26103|26041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49820,
    lat: 46.18965,
    lng: -85.67951,
    city: "Curtis",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 270,
    density: 4.1,
    county_fips: 26097,
    county_name: "Mackinac",
    county_weights: {
      26097: 100,
    },
    county_names_all: "Mackinac",
    county_fips_all: 26097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49821,
    lat: 45.52167,
    lng: -87.63052,
    city: "Daggett",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1333,
    density: 3.8,
    county_fips: 26109,
    county_name: "Menominee",
    county_weights: {
      26109: 100,
    },
    county_names_all: "Menominee",
    county_fips_all: 26109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49822,
    lat: 46.45095,
    lng: -87.02812,
    city: "Deerton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 206,
    density: 1.4,
    county_fips: 26003,
    county_name: "Alger",
    county_weights: {
      26003: 97.46,
      26103: 2.54,
    },
    county_names_all: "Alger|Marquette",
    county_fips_all: "26003|26103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49825,
    lat: 46.36039,
    lng: -86.98462,
    city: "Eben Junction",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 265,
    density: 3.9,
    county_fips: 26003,
    county_name: "Alger",
    county_weights: {
      26003: 100,
    },
    county_names_all: "Alger",
    county_fips_all: 26003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49826,
    lat: 46.32316,
    lng: -87.04567,
    city: "Rumely",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 78,
    density: 2.1,
    county_fips: 26003,
    county_name: "Alger",
    county_weights: {
      26003: 100,
    },
    county_names_all: "Alger",
    county_fips_all: 26003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49827,
    lat: 46.1751,
    lng: -85.53607,
    city: "Engadine",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1171,
    density: 4,
    county_fips: 26097,
    county_name: "Mackinac",
    county_weights: {
      26097: 100,
    },
    county_names_all: "Mackinac",
    county_fips_all: 26097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49829,
    lat: 45.76773,
    lng: -87.16522,
    city: "Escanaba",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16704,
    density: 96.6,
    county_fips: 26041,
    county_name: "Delta",
    county_weights: {
      26041: 100,
    },
    county_names_all: "Delta",
    county_fips_all: 26041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49831,
    lat: 46.05777,
    lng: -87.7356,
    city: "Felch",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 675,
    density: 1.9,
    county_fips: 26043,
    county_name: "Dickinson",
    county_weights: {
      26043: 68.03,
      26103: 31.97,
    },
    county_names_all: "Dickinson|Marquette",
    county_fips_all: "26043|26103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49833,
    lat: 46.27504,
    lng: -87.29142,
    city: "Little Lake",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 346,
    density: 9.4,
    county_fips: 26103,
    county_name: "Marquette",
    county_weights: {
      26103: 100,
    },
    county_names_all: "Marquette",
    county_fips_all: 26103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49834,
    lat: 45.96829,
    lng: -87.70292,
    city: "Foster City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 224,
    density: 1.1,
    county_fips: 26043,
    county_name: "Dickinson",
    county_weights: {
      26043: 100,
    },
    county_names_all: "Dickinson",
    county_fips_all: 26043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49835,
    lat: 45.74396,
    lng: -86.57555,
    city: "Garden",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 804,
    density: 3.7,
    county_fips: 26041,
    county_name: "Delta",
    county_weights: {
      26041: 100,
    },
    county_names_all: "Delta",
    county_fips_all: 26041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49836,
    lat: 46.1971,
    lng: -85.88725,
    city: "Germfask",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 988,
    density: 3.9,
    county_fips: 26153,
    county_name: "Schoolcraft",
    county_weights: {
      26095: 0.11,
      26097: 27.26,
      26153: 72.63,
    },
    county_names_all: "Schoolcraft|Mackinac|Luce",
    county_fips_all: "26153|26097|26095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49837,
    lat: 45.87129,
    lng: -87.09781,
    city: "Gladstone",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9173,
    density: 51.3,
    county_fips: 26041,
    county_name: "Delta",
    county_weights: {
      26041: 100,
    },
    county_names_all: "Delta",
    county_fips_all: 26041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49838,
    lat: 46.06473,
    lng: -85.75035,
    city: "Gould City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 421,
    density: 1.2,
    county_fips: 26097,
    county_name: "Mackinac",
    county_weights: {
      26097: 100,
    },
    county_names_all: "Mackinac",
    county_fips_all: 26097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49839,
    lat: 46.59994,
    lng: -86.11555,
    city: "Grand Marais",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 366,
    density: 0.9,
    county_fips: 26003,
    county_name: "Alger",
    county_weights: {
      26003: 100,
    },
    county_names_all: "Alger",
    county_fips_all: 26003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49840,
    lat: 46.13742,
    lng: -86.06009,
    city: "Gulliver",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 578,
    density: 0.9,
    county_fips: 26153,
    county_name: "Schoolcraft",
    county_weights: {
      26153: 100,
    },
    county_names_all: "Schoolcraft",
    county_fips_all: 26153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49841,
    lat: 46.27145,
    lng: -87.49873,
    city: "Gwinn",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6987,
    density: 11.9,
    county_fips: 26103,
    county_name: "Marquette",
    county_weights: {
      26103: 100,
    },
    county_names_all: "Marquette",
    county_fips_all: 26103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49847,
    lat: 45.70585,
    lng: -87.63267,
    city: "Hermansville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1115,
    density: 7.2,
    county_fips: 26109,
    county_name: "Menominee",
    county_weights: {
      26109: 100,
    },
    county_names_all: "Menominee",
    county_fips_all: 26109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49848,
    lat: 45.37926,
    lng: -87.63576,
    city: "Ingalls",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 84,
    density: 8,
    county_fips: 26109,
    county_name: "Menominee",
    county_weights: {
      26109: 100,
    },
    county_names_all: "Menominee",
    county_fips_all: 26109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49849,
    lat: 46.423,
    lng: -87.76797,
    city: "Ishpeming",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12375,
    density: 19.8,
    county_fips: 26103,
    county_name: "Marquette",
    county_weights: {
      26103: 100,
    },
    county_names_all: "Marquette",
    county_fips_all: 26103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49852,
    lat: 45.78399,
    lng: -87.81807,
    city: "Loretto",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 126,
    density: 207.1,
    county_fips: 26043,
    county_name: "Dickinson",
    county_weights: {
      26043: 100,
    },
    county_names_all: "Dickinson",
    county_fips_all: 26043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49853,
    lat: 46.36112,
    lng: -85.74494,
    city: "McMillan",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1262,
    density: 2.9,
    county_fips: 26095,
    county_name: "Luce",
    county_weights: {
      26095: 98.74,
      26097: 1.26,
    },
    county_names_all: "Luce|Mackinac",
    county_fips_all: "26095|26097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49854,
    lat: 46.09581,
    lng: -86.36453,
    city: "Manistique",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6196,
    density: 5,
    county_fips: 26153,
    county_name: "Schoolcraft",
    county_weights: {
      26041: 5.49,
      26153: 94.51,
    },
    county_names_all: "Schoolcraft|Delta",
    county_fips_all: "26153|26041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49855,
    lat: 46.56603,
    lng: -87.45932,
    city: "Marquette",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32863,
    density: 61.3,
    county_fips: 26103,
    county_name: "Marquette",
    county_weights: {
      26103: 100,
    },
    county_names_all: "Marquette",
    county_fips_all: 26103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49858,
    lat: 45.21989,
    lng: -87.58325,
    city: "Menominee",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11520,
    density: 51.2,
    county_fips: 26109,
    county_name: "Menominee",
    county_weights: {
      26109: 100,
    },
    county_names_all: "Menominee",
    county_fips_all: 26109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49861,
    lat: 46.57639,
    lng: -88.16043,
    city: "Michigamme",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 494,
    density: 1,
    county_fips: 26013,
    county_name: "Baraga",
    county_weights: {
      26013: 87.57,
      26103: 12.43,
    },
    county_names_all: "Baraga|Marquette",
    county_fips_all: "26013|26103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49862,
    lat: 46.38021,
    lng: -86.7153,
    city: "Munising",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4765,
    density: 10.8,
    county_fips: 26003,
    county_name: "Alger",
    county_weights: {
      26003: 100,
    },
    county_names_all: "Alger",
    county_fips_all: 26003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49863,
    lat: 45.61295,
    lng: -87.55163,
    city: "Nadeau",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 168,
    density: 116.2,
    county_fips: 26109,
    county_name: "Menominee",
    county_weights: {
      26109: 100,
    },
    county_names_all: "Menominee",
    county_fips_all: 26109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49864,
    lat: 45.84444,
    lng: -86.65104,
    city: "Nahma",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46,
    density: 17.2,
    county_fips: 26041,
    county_name: "Delta",
    county_weights: {
      26041: 100,
    },
    county_names_all: "Delta",
    county_fips_all: 26041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49866,
    lat: 46.54989,
    lng: -87.66246,
    city: "Negaunee",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8090,
    density: 15.5,
    county_fips: 26103,
    county_name: "Marquette",
    county_weights: {
      26103: 100,
    },
    county_names_all: "Marquette",
    county_fips_all: 26103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49868,
    lat: 46.49317,
    lng: -85.50586,
    city: "Newberry",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5101,
    density: 2.8,
    county_fips: 26095,
    county_name: "Luce",
    county_weights: {
      26095: 100,
    },
    county_names_all: "Luce",
    county_fips_all: 26095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49870,
    lat: 45.87315,
    lng: -87.89964,
    city: "Norway",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3379,
    density: 22.6,
    county_fips: 26043,
    county_name: "Dickinson",
    county_weights: {
      26043: 100,
    },
    county_names_all: "Dickinson",
    county_fips_all: 26043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49871,
    lat: 46.42433,
    lng: -87.53282,
    city: "Palmer",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 536,
    density: 12.4,
    county_fips: 26103,
    county_name: "Marquette",
    county_weights: {
      26103: 100,
    },
    county_names_all: "Marquette",
    county_fips_all: 26103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49872,
    lat: 46.01824,
    lng: -87.08222,
    city: "Perkins",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 204,
    density: 3.6,
    county_fips: 26041,
    county_name: "Delta",
    county_weights: {
      26041: 100,
    },
    county_names_all: "Delta",
    county_fips_all: 26041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49873,
    lat: 45.876,
    lng: -87.51824,
    city: "Perronville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74,
    density: 0.1,
    county_fips: 26109,
    county_name: "Menominee",
    county_weights: {
      26109: 100,
    },
    county_names_all: "Menominee",
    county_fips_all: 26109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49874,
    lat: 45.70394,
    lng: -87.50568,
    city: "Powers",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1008,
    density: 9.2,
    county_fips: 26109,
    county_name: "Menominee",
    county_weights: {
      26109: 100,
    },
    county_names_all: "Menominee",
    county_fips_all: 26109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49876,
    lat: 45.80211,
    lng: -87.97729,
    city: "Quinnesec",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1220,
    density: 113.1,
    county_fips: 26043,
    county_name: "Dickinson",
    county_weights: {
      26043: 100,
    },
    county_names_all: "Dickinson",
    county_fips_all: 26043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49877,
    lat: 46.15651,
    lng: -87.7425,
    city: "Ralph",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16,
    density: 0.1,
    county_fips: 26043,
    county_name: "Dickinson",
    county_weights: {
      26043: 100,
    },
    county_names_all: "Dickinson",
    county_fips_all: 26043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49878,
    lat: 45.95852,
    lng: -86.86516,
    city: "Rapid River",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3369,
    density: 2.9,
    county_fips: 26041,
    county_name: "Delta",
    county_weights: {
      26003: 2.79,
      26041: 97.21,
    },
    county_names_all: "Delta|Alger",
    county_fips_all: "26041|26003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49879,
    lat: 46.3437,
    lng: -88.08432,
    city: "Republic",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 915,
    density: 2,
    county_fips: 26103,
    county_name: "Marquette",
    county_weights: {
      26071: 35.35,
      26103: 64.65,
    },
    county_names_all: "Marquette|Iron",
    county_fips_all: "26103|26071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49880,
    lat: 46.11693,
    lng: -87.22515,
    city: "Rock",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1133,
    density: 2,
    county_fips: 26103,
    county_name: "Marquette",
    county_weights: {
      26041: 42.73,
      26103: 57.27,
    },
    county_names_all: "Marquette|Delta",
    county_fips_all: "26103|26041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49881,
    lat: 46.07852,
    lng: -88.03259,
    city: "Sagola",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 440,
    density: 3.6,
    county_fips: 26043,
    county_name: "Dickinson",
    county_weights: {
      26043: 100,
    },
    county_names_all: "Dickinson",
    county_fips_all: 26043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49883,
    lat: 46.42885,
    lng: -86.0318,
    city: "Seney",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 182,
    density: 0.2,
    county_fips: 26153,
    county_name: "Schoolcraft",
    county_weights: {
      26003: 18.83,
      26153: 81.17,
    },
    county_names_all: "Schoolcraft|Alger",
    county_fips_all: "26153|26003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49884,
    lat: 46.41734,
    lng: -86.35554,
    city: "Shingleton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 456,
    density: 0.7,
    county_fips: 26003,
    county_name: "Alger",
    county_weights: {
      26003: 56.28,
      26153: 43.72,
    },
    county_names_all: "Alger|Schoolcraft",
    county_fips_all: "26003|26153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49885,
    lat: 46.34658,
    lng: -87.19238,
    city: "Skandia",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1777,
    density: 4.7,
    county_fips: 26103,
    county_name: "Marquette",
    county_weights: {
      26003: 15.52,
      26103: 84.48,
    },
    county_names_all: "Marquette|Alger",
    county_fips_all: "26103|26003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49886,
    lat: 45.69748,
    lng: -87.49409,
    city: "Spalding",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 534,
    density: 51.9,
    county_fips: 26109,
    county_name: "Menominee",
    county_weights: {
      26109: 100,
    },
    county_names_all: "Menominee",
    county_fips_all: 26109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49887,
    lat: 45.43104,
    lng: -87.56773,
    city: "Stephenson",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2711,
    density: 5.1,
    county_fips: 26109,
    county_name: "Menominee",
    county_weights: {
      26109: 100,
    },
    county_names_all: "Menominee",
    county_fips_all: 26109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49891,
    lat: 46.23206,
    lng: -87.02828,
    city: "Trenary",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 825,
    density: 4.4,
    county_fips: 26003,
    county_name: "Alger",
    county_weights: {
      26003: 100,
    },
    county_names_all: "Alger",
    county_fips_all: 26003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49892,
    lat: 45.77547,
    lng: -87.77243,
    city: "Vulcan",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1867,
    density: 4.7,
    county_fips: 26043,
    county_name: "Dickinson",
    county_weights: {
      26043: 69.67,
      26109: 30.33,
    },
    county_names_all: "Dickinson|Menominee",
    county_fips_all: "26043|26109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49893,
    lat: 45.29767,
    lng: -87.59927,
    city: "Wallace",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1273,
    density: 6.6,
    county_fips: 26109,
    county_name: "Menominee",
    county_weights: {
      26109: 100,
    },
    county_names_all: "Menominee",
    county_fips_all: 26109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49894,
    lat: 45.78292,
    lng: -87.07634,
    city: "Wells",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 776,
    density: 411.1,
    county_fips: 26041,
    county_name: "Delta",
    county_weights: {
      26041: 100,
    },
    county_names_all: "Delta",
    county_fips_all: 26041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49895,
    lat: 46.16807,
    lng: -86.66593,
    city: "Wetmore",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 590,
    density: 1,
    county_fips: 26041,
    county_name: "Delta",
    county_weights: {
      26003: 44.35,
      26041: 49,
      26153: 6.65,
    },
    county_names_all: "Delta|Alger|Schoolcraft",
    county_fips_all: "26041|26003|26153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49896,
    lat: 45.67748,
    lng: -87.38953,
    city: "Wilson",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1660,
    density: 10.5,
    county_fips: 26109,
    county_name: "Menominee",
    county_weights: {
      26109: 100,
    },
    county_names_all: "Menominee",
    county_fips_all: 26109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49901,
    lat: 47.29384,
    lng: -88.39094,
    city: "Ahmeek",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 228,
    density: 111.9,
    county_fips: 26083,
    county_name: "Keweenaw",
    county_weights: {
      26083: 100,
    },
    county_names_all: "Keweenaw",
    county_fips_all: 26083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49902,
    lat: 46.04905,
    lng: -88.37744,
    city: "Alpha",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 192,
    density: 102.6,
    county_fips: 26071,
    county_name: "Iron",
    county_weights: {
      26071: 100,
    },
    county_names_all: "Iron",
    county_fips_all: 26071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49903,
    lat: 46.33455,
    lng: -88.48496,
    city: "Amasa",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 85,
    density: 0.2,
    county_fips: 26071,
    county_name: "Iron",
    county_weights: {
      26071: 100,
    },
    county_names_all: "Iron",
    county_fips_all: 26071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49905,
    lat: 47.10694,
    lng: -88.71395,
    city: "Atlantic Mine",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2416,
    density: 11.9,
    county_fips: 26061,
    county_name: "Houghton",
    county_weights: {
      26061: 100,
    },
    county_names_all: "Houghton",
    county_fips_all: 26061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49908,
    lat: 46.75276,
    lng: -88.57034,
    city: "Baraga",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3333,
    density: 11.8,
    county_fips: 26013,
    county_name: "Baraga",
    county_weights: {
      26013: 100,
    },
    county_names_all: "Baraga",
    county_fips_all: 26013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49910,
    lat: 46.61815,
    lng: -89.54308,
    city: "Bergland",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 315,
    density: 2.9,
    county_fips: 26131,
    county_name: "Ontonagon",
    county_weights: {
      26131: 100,
    },
    county_names_all: "Ontonagon",
    county_fips_all: 26131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49911,
    lat: 46.49247,
    lng: -90.05235,
    city: "Bessemer",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2515,
    density: 21.4,
    county_fips: 26053,
    county_name: "Gogebic",
    county_weights: {
      26053: 100,
    },
    county_names_all: "Gogebic",
    county_fips_all: 26053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49912,
    lat: 46.49393,
    lng: -89.20017,
    city: "Bruce Crossing",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 963,
    density: 1.8,
    county_fips: 26131,
    county_name: "Ontonagon",
    county_weights: {
      26131: 100,
    },
    county_names_all: "Ontonagon",
    county_fips_all: 26131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49913,
    lat: 47.23746,
    lng: -88.44994,
    city: "Calumet",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6423,
    density: 32.9,
    county_fips: 26061,
    county_name: "Houghton",
    county_weights: {
      26061: 92.79,
      26083: 7.21,
    },
    county_names_all: "Houghton|Keweenaw",
    county_fips_all: "26061|26083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49915,
    lat: 46.06464,
    lng: -88.62708,
    city: "Caspian",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 324,
    density: 103.9,
    county_fips: 26071,
    county_name: "Iron",
    county_weights: {
      26071: 100,
    },
    county_names_all: "Iron",
    county_fips_all: 26071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49916,
    lat: 46.97891,
    lng: -88.59519,
    city: "Chassell",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3020,
    density: 10.6,
    county_fips: 26061,
    county_name: "Houghton",
    county_weights: {
      26061: 100,
    },
    county_names_all: "Houghton",
    county_fips_all: 26061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49917,
    lat: 47.28138,
    lng: -88.35908,
    city: "Copper City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 234,
    density: 52.6,
    county_fips: 26061,
    county_name: "Houghton",
    county_weights: {
      26061: 100,
    },
    county_names_all: "Houghton",
    county_fips_all: 26061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49918,
    lat: 47.43585,
    lng: -87.81238,
    city: "Copper Harbor",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 135,
    density: 1.4,
    county_fips: 26083,
    county_name: "Keweenaw",
    county_weights: {
      26083: 100,
    },
    county_names_all: "Keweenaw",
    county_fips_all: 26083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49919,
    lat: 46.50995,
    lng: -88.43518,
    city: "Covington",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 173,
    density: 0.5,
    county_fips: 26013,
    county_name: "Baraga",
    county_weights: {
      26013: 100,
    },
    county_names_all: "Baraga",
    county_fips_all: 26013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49920,
    lat: 46.14087,
    lng: -88.30079,
    city: "Crystal Falls",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4103,
    density: 3.9,
    county_fips: 26071,
    county_name: "Iron",
    county_weights: {
      26071: 100,
    },
    county_names_all: "Iron",
    county_fips_all: 26071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49921,
    lat: 47.09084,
    lng: -88.5818,
    city: "Dodgeville",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 350,
    density: 286.9,
    county_fips: 26061,
    county_name: "Houghton",
    county_weights: {
      26061: 100,
    },
    county_names_all: "Houghton",
    county_fips_all: 26061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49922,
    lat: 47.12369,
    lng: -88.49522,
    city: "Dollar Bay",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 640,
    density: 88,
    county_fips: 26061,
    county_name: "Houghton",
    county_weights: {
      26061: 100,
    },
    county_names_all: "Houghton",
    county_fips_all: 26061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49925,
    lat: 46.55088,
    lng: -89.37681,
    city: "Ewen",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 498,
    density: 1.1,
    county_fips: 26131,
    county_name: "Ontonagon",
    county_weights: {
      26131: 100,
    },
    county_names_all: "Ontonagon",
    county_fips_all: 26131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49927,
    lat: 46.04475,
    lng: -88.57108,
    city: "Gaastra",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 484,
    density: 11.3,
    county_fips: 26071,
    county_name: "Iron",
    county_weights: {
      26071: 100,
    },
    county_names_all: "Iron",
    county_fips_all: 26071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49929,
    lat: 46.79874,
    lng: -89.09567,
    city: "Greenland",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 186,
    density: 3.4,
    county_fips: 26131,
    county_name: "Ontonagon",
    county_weights: {
      26131: 100,
    },
    county_names_all: "Ontonagon",
    county_fips_all: 26131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49930,
    lat: 47.15577,
    lng: -88.53542,
    city: "Hancock",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7032,
    density: 54.9,
    county_fips: 26061,
    county_name: "Houghton",
    county_weights: {
      26061: 100,
    },
    county_names_all: "Houghton",
    county_fips_all: 26061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49931,
    lat: 47.13652,
    lng: -88.6063,
    city: "Houghton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9497,
    density: 139.1,
    county_fips: 26061,
    county_name: "Houghton",
    county_weights: {
      26061: 100,
    },
    county_names_all: "Houghton",
    county_fips_all: 26061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49934,
    lat: 47.16539,
    lng: -88.43967,
    city: "Hubbell",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 809,
    density: 243.4,
    county_fips: 26061,
    county_name: "Houghton",
    county_weights: {
      26061: 100,
    },
    county_names_all: "Houghton",
    county_fips_all: 26061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49935,
    lat: 46.19493,
    lng: -88.7463,
    city: "Iron River",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5821,
    density: 4.9,
    county_fips: 26071,
    county_name: "Iron",
    county_weights: {
      26071: 100,
    },
    county_names_all: "Iron",
    county_fips_all: 26071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49938,
    lat: 46.51493,
    lng: -90.13264,
    city: "Ironwood",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7493,
    density: 12.8,
    county_fips: 26053,
    county_name: "Gogebic",
    county_weights: {
      26053: 100,
    },
    county_names_all: "Gogebic",
    county_fips_all: 26053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49942,
    lat: 47.26179,
    lng: -88.4175,
    city: "Kearsarge",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 436,
    density: 307.3,
    county_fips: 26061,
    county_name: "Houghton",
    county_weights: {
      26061: 100,
    },
    county_names_all: "Houghton",
    county_fips_all: 26061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49945,
    lat: 47.16956,
    lng: -88.30752,
    city: "Lake Linden",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2620,
    density: 6.8,
    county_fips: 26061,
    county_name: "Houghton",
    county_weights: {
      26061: 65.23,
      26083: 34.77,
    },
    county_names_all: "Houghton|Keweenaw",
    county_fips_all: "26061|26083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49946,
    lat: 46.7189,
    lng: -88.33725,
    city: "Lanse",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3870,
    density: 6.1,
    county_fips: 26013,
    county_name: "Baraga",
    county_weights: {
      26013: 100,
    },
    county_names_all: "Baraga",
    county_fips_all: 26013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49947,
    lat: 46.42589,
    lng: -89.60536,
    city: "Marenisco",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1142,
    density: 1.1,
    county_fips: 26053,
    county_name: "Gogebic",
    county_weights: {
      26053: 80.38,
      26131: 19.62,
    },
    county_names_all: "Gogebic|Ontonagon",
    county_fips_all: "26053|26131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49948,
    lat: 46.74567,
    lng: -88.99919,
    city: "Mass City",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 541,
    density: 1.9,
    county_fips: 26131,
    county_name: "Ontonagon",
    county_weights: {
      26061: 1.57,
      26131: 98.43,
    },
    county_names_all: "Ontonagon|Houghton",
    county_fips_all: "26131|26061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49950,
    lat: 47.37834,
    lng: -88.12035,
    city: "Mohawk",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1041,
    density: 2,
    county_fips: 26083,
    county_name: "Keweenaw",
    county_weights: {
      26083: 100,
    },
    county_names_all: "Keweenaw",
    county_fips_all: 26083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49952,
    lat: 46.68309,
    lng: -88.78408,
    city: "Nisula",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 111,
    density: 0.5,
    county_fips: 26061,
    county_name: "Houghton",
    county_weights: {
      26061: 97.64,
      26131: 2.36,
    },
    county_names_all: "Houghton|Ontonagon",
    county_fips_all: "26061|26131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49953,
    lat: 46.79328,
    lng: -89.42477,
    city: "Ontonagon",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2212,
    density: 1.8,
    county_fips: 26131,
    county_name: "Ontonagon",
    county_weights: {
      26131: 100,
    },
    county_names_all: "Ontonagon",
    county_fips_all: 26131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49955,
    lat: 47.00788,
    lng: -88.69373,
    city: "Painesdale",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 364,
    density: 17.5,
    county_fips: 26061,
    county_name: "Houghton",
    county_weights: {
      26061: 100,
    },
    county_names_all: "Houghton",
    county_fips_all: 26061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49958,
    lat: 46.8165,
    lng: -88.67595,
    city: "Pelkie",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 664,
    density: 1.9,
    county_fips: 26061,
    county_name: "Houghton",
    county_weights: {
      26013: 30.26,
      26061: 69.74,
    },
    county_names_all: "Houghton|Baraga",
    county_fips_all: "26061|26013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49959,
    lat: 46.46987,
    lng: -89.99803,
    city: "Ramsay",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 334,
    density: 128.7,
    county_fips: 26053,
    county_name: "Gogebic",
    county_weights: {
      26053: 100,
    },
    county_names_all: "Gogebic",
    county_fips_all: 26053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49960,
    lat: 46.71139,
    lng: -89.25085,
    city: "Rockland",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 210,
    density: 2,
    county_fips: 26131,
    county_name: "Ontonagon",
    county_weights: {
      26131: 100,
    },
    county_names_all: "Ontonagon",
    county_fips_all: 26131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49961,
    lat: 46.50667,
    lng: -88.74358,
    city: "Sidnaw",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 158,
    density: 0.9,
    county_fips: 26061,
    county_name: "Houghton",
    county_weights: {
      26061: 100,
    },
    county_names_all: "Houghton",
    county_fips_all: 26061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49962,
    lat: 46.82142,
    lng: -88.1409,
    city: "Skanee",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 207,
    density: 0.8,
    county_fips: 26013,
    county_name: "Baraga",
    county_weights: {
      26013: 100,
    },
    county_names_all: "Baraga",
    county_fips_all: 26013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49963,
    lat: 47.04897,
    lng: -88.64002,
    city: "South Range",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 886,
    density: 77.8,
    county_fips: 26061,
    county_name: "Houghton",
    county_weights: {
      26061: 100,
    },
    county_names_all: "Houghton",
    county_fips_all: 26061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49965,
    lat: 46.94752,
    lng: -88.85878,
    city: "Toivola",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 658,
    density: 1.3,
    county_fips: 26061,
    county_name: "Houghton",
    county_weights: {
      26061: 87.07,
      26131: 12.93,
    },
    county_names_all: "Houghton|Ontonagon",
    county_fips_all: "26061|26131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49967,
    lat: 46.49377,
    lng: -88.95551,
    city: "Trout Creek",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 416,
    density: 0.5,
    county_fips: 26061,
    county_name: "Houghton",
    county_weights: {
      26061: 43.55,
      26071: 19.68,
      26131: 36.77,
    },
    county_names_all: "Houghton|Ontonagon|Iron",
    county_fips_all: "26061|26131|26071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49968,
    lat: 46.50199,
    lng: -89.88314,
    city: "Wakefield",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2146,
    density: 3.1,
    county_fips: 26053,
    county_name: "Gogebic",
    county_weights: {
      26053: 100,
    },
    county_names_all: "Gogebic",
    county_fips_all: 26053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49969,
    lat: 46.24608,
    lng: -89.21431,
    city: "Watersmeet",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1170,
    density: 1.8,
    county_fips: 26053,
    county_name: "Gogebic",
    county_weights: {
      26053: 100,
    },
    county_names_all: "Gogebic",
    county_fips_all: 26053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 49970,
    lat: 46.53555,
    lng: -88.59783,
    city: "Watton",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 263,
    density: 1.1,
    county_fips: 26013,
    county_name: "Baraga",
    county_weights: {
      26013: 100,
    },
    county_names_all: "Baraga",
    county_fips_all: 26013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 49971,
    lat: 46.71043,
    lng: -89.62866,
    city: "White Pine",
    state_id: "MI",
    state_name: "Michigan",
    zcta: "TRUE",
    parent_zcta: "",
    population: 469,
    density: 7.8,
    county_fips: 26131,
    county_name: "Ontonagon",
    county_weights: {
      26131: 100,
    },
    county_names_all: "Ontonagon",
    county_fips_all: 26131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Detroit",
  },
  {
    zip: 50001,
    lat: 41.3611,
    lng: -93.43321,
    city: "Ackworth",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 749,
    density: 12.3,
    county_fips: 19181,
    county_name: "Warren",
    county_weights: {
      19181: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 19181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50002,
    lat: 41.51236,
    lng: -94.64801,
    city: "Adair",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1359,
    density: 4.7,
    county_fips: 19077,
    county_name: "Guthrie",
    county_weights: {
      19001: 45.18,
      19009: 1.39,
      19077: 53.43,
    },
    county_names_all: "Guthrie|Adair|Audubon",
    county_fips_all: "19077|19001|19009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50003,
    lat: 41.61192,
    lng: -94.04352,
    city: "Adel",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7872,
    density: 26.4,
    county_fips: 19049,
    county_name: "Dallas",
    county_weights: {
      19049: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 19049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50005,
    lat: 42.1295,
    lng: -93.02683,
    city: "Albion",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1060,
    density: 15.1,
    county_fips: 19127,
    county_name: "Marshall",
    county_weights: {
      19127: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 19127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50006,
    lat: 42.51354,
    lng: -93.40227,
    city: "Alden",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1596,
    density: 5,
    county_fips: 19083,
    county_name: "Hardin",
    county_weights: {
      19069: 30.34,
      19079: 0.87,
      19083: 68.79,
    },
    county_names_all: "Hardin|Franklin|Hamilton",
    county_fips_all: "19083|19069|19079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50007,
    lat: 41.80365,
    lng: -93.60043,
    city: "Alleman",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 557,
    density: 39.7,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19153: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 19153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50008,
    lat: 40.67847,
    lng: -93.38549,
    city: "Allerton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 845,
    density: 3.7,
    county_fips: 19185,
    county_name: "Wayne",
    county_weights: {
      19185: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 19185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50009,
    lat: 41.64313,
    lng: -93.45945,
    city: "Altoona",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20033,
    density: 277.1,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19153: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 19153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50010,
    lat: 42.03316,
    lng: -93.58761,
    city: "Ames",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33616,
    density: 215.3,
    county_fips: 19169,
    county_name: "Story",
    county_weights: {
      19169: 100,
    },
    county_names_all: "Story",
    county_fips_all: 19169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50012,
    lat: 42.02904,
    lng: -93.65086,
    city: "Ames",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4578,
    density: 5145.5,
    county_fips: 19169,
    county_name: "Story",
    county_weights: {
      19169: 100,
    },
    county_names_all: "Story",
    county_fips_all: 19169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50013,
    lat: 42.01732,
    lng: -93.64809,
    city: "Ames",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19169,
    county_name: "Story",
    county_weights: {
      19169: 100,
    },
    county_names_all: "Story",
    county_fips_all: 19169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50014,
    lat: 42.04993,
    lng: -93.69342,
    city: "Ames",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31246,
    density: 222.5,
    county_fips: 19169,
    county_name: "Story",
    county_weights: {
      19015: 43.84,
      19169: 56.16,
    },
    county_names_all: "Story|Boone",
    county_fips_all: "19169|19015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50020,
    lat: 41.43364,
    lng: -94.75215,
    city: "Anita",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1150,
    density: 4.6,
    county_fips: 19029,
    county_name: "Cass",
    county_weights: {
      19001: 11.71,
      19009: 9.77,
      19029: 77.51,
      19077: 1.01,
    },
    county_names_all: "Cass|Adair|Audubon|Guthrie",
    county_fips_all: "19029|19001|19009|19077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50021,
    lat: 41.7207,
    lng: -93.56838,
    city: "Ankeny",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27566,
    density: 442,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19153: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 19153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50022,
    lat: 41.41737,
    lng: -95.00352,
    city: "Atlantic",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8361,
    density: 18.7,
    county_fips: 19029,
    county_name: "Cass",
    county_weights: {
      19009: 6.58,
      19029: 89.3,
      19165: 4.12,
    },
    county_names_all: "Cass|Audubon|Shelby",
    county_fips_all: "19029|19009|19165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50023,
    lat: 41.72768,
    lng: -93.63412,
    city: "Ankeny",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40518,
    density: 745.9,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19153: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 19153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50025,
    lat: 41.75628,
    lng: -94.92034,
    city: "Audubon",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2976,
    density: 5.8,
    county_fips: 19009,
    county_name: "Audubon",
    county_weights: {
      19009: 98.48,
      19077: 1.52,
    },
    county_names_all: "Audubon|Guthrie",
    county_fips_all: "19009|19077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50026,
    lat: 41.85823,
    lng: -94.44958,
    city: "Bagley",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 461,
    density: 3.2,
    county_fips: 19077,
    county_name: "Guthrie",
    county_weights: {
      19073: 42.94,
      19077: 57.06,
    },
    county_names_all: "Guthrie|Greene",
    county_fips_all: "19077|19073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50027,
    lat: 41.4739,
    lng: -92.47194,
    city: "Barnes City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 357,
    density: 5,
    county_fips: 19123,
    county_name: "Mahaska",
    county_weights: {
      19123: 99.26,
      19157: 0.74,
    },
    county_names_all: "Mahaska|Poweshiek",
    county_fips_all: "19123|19157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50028,
    lat: 41.81729,
    lng: -93.15102,
    city: "Baxter",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1648,
    density: 14.1,
    county_fips: 19099,
    county_name: "Jasper",
    county_weights: {
      19099: 95.53,
      19127: 4.47,
    },
    county_names_all: "Jasper|Marshall",
    county_fips_all: "19099|19127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50029,
    lat: 41.82497,
    lng: -94.55075,
    city: "Bayard",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 537,
    density: 5.4,
    county_fips: 19077,
    county_name: "Guthrie",
    county_weights: {
      19073: 7.87,
      19077: 92.13,
    },
    county_names_all: "Guthrie|Greene",
    county_fips_all: "19077|19073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50031,
    lat: 42.03881,
    lng: -94.14003,
    city: "Beaver",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19015,
    county_name: "Boone",
    county_weights: {
      19015: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 19015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50032,
    lat: 41.66591,
    lng: -93.54301,
    city: "Berwick",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 563,
    density: 511.4,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19153: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 19153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50033,
    lat: 41.36048,
    lng: -93.79416,
    city: "Bevington",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20,
    density: 39.6,
    county_fips: 19121,
    county_name: "Madison",
    county_weights: {
      19121: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 19121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50034,
    lat: 42.52921,
    lng: -93.65438,
    city: "Blairsburg",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 420,
    density: 2.6,
    county_fips: 19079,
    county_name: "Hamilton",
    county_weights: {
      19079: 66.12,
      19197: 33.88,
    },
    county_names_all: "Hamilton|Wright",
    county_fips_all: "19079|19197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50035,
    lat: 41.7248,
    lng: -93.45957,
    city: "Bondurant",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8453,
    density: 75.5,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19153: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 19153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50036,
    lat: 42.0892,
    lng: -93.85378,
    city: "Boone",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16609,
    density: 33.5,
    county_fips: 19015,
    county_name: "Boone",
    county_weights: {
      19015: 98.44,
      19079: 1.56,
    },
    county_names_all: "Boone|Hamilton",
    county_fips_all: "19015|19079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50038,
    lat: 41.52186,
    lng: -93.90064,
    city: "Booneville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 155,
    density: 15.5,
    county_fips: 19049,
    county_name: "Dallas",
    county_weights: {
      19049: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 19049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50039,
    lat: 41.82615,
    lng: -94.00653,
    city: "Bouton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 472,
    density: 8.8,
    county_fips: 19049,
    county_name: "Dallas",
    county_weights: {
      19015: 6.01,
      19049: 93.99,
    },
    county_names_all: "Dallas|Boone",
    county_fips_all: "19049|19015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50040,
    lat: 42.17363,
    lng: -94.10121,
    city: "Boxholm",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19015,
    county_name: "Boone",
    county_weights: {
      19015: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 19015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50041,
    lat: 42.63429,
    lng: -93.24662,
    city: "Bradford",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61,
    density: 166.2,
    county_fips: 19069,
    county_name: "Franklin",
    county_weights: {
      19069: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 19069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50042,
    lat: 41.53326,
    lng: -94.90004,
    city: "Brayton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 231,
    density: 2.7,
    county_fips: 19009,
    county_name: "Audubon",
    county_weights: {
      19009: 97.56,
      19029: 2.44,
    },
    county_names_all: "Audubon|Cass",
    county_fips_all: "19009|19029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50044,
    lat: 41.20247,
    lng: -92.88907,
    city: "Bussey",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 956,
    density: 7.7,
    county_fips: 19125,
    county_name: "Marion",
    county_weights: {
      19123: 36.51,
      19125: 59.41,
      19135: 4.08,
    },
    county_names_all: "Marion|Mahaska|Monroe",
    county_fips_all: "19125|19123|19135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50046,
    lat: 41.88974,
    lng: -93.5234,
    city: "Cambridge",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1776,
    density: 14.4,
    county_fips: 19169,
    county_name: "Story",
    county_weights: {
      19153: 27.21,
      19169: 72.79,
    },
    county_names_all: "Story|Polk",
    county_fips_all: "19169|19153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50047,
    lat: 41.47551,
    lng: -93.46556,
    city: "Carlisle",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6497,
    density: 37.3,
    county_fips: 19181,
    county_name: "Warren",
    county_weights: {
      19153: 26.14,
      19181: 73.86,
    },
    county_names_all: "Warren|Polk",
    county_fips_all: "19181|19153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50048,
    lat: 41.51167,
    lng: -94.51936,
    city: "Casey",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 900,
    density: 4,
    county_fips: 19077,
    county_name: "Guthrie",
    county_weights: {
      19001: 44.17,
      19077: 55.83,
    },
    county_names_all: "Guthrie|Adair",
    county_fips_all: "19077|19001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50049,
    lat: 41.03741,
    lng: -93.29566,
    city: "Chariton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6336,
    density: 11.7,
    county_fips: 19117,
    county_name: "Lucas",
    county_weights: {
      19117: 97.46,
      19125: 0.91,
      19185: 1.63,
    },
    county_names_all: "Lucas|Wayne|Marion",
    county_fips_all: "19117|19185|19125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50050,
    lat: 42.16459,
    lng: -94.51054,
    city: "Churdan",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 692,
    density: 3.4,
    county_fips: 19073,
    county_name: "Greene",
    county_weights: {
      19025: 3.87,
      19027: 2.56,
      19073: 93.57,
    },
    county_names_all: "Greene|Calhoun|Carroll",
    county_fips_all: "19073|19025|19027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50051,
    lat: 42.13875,
    lng: -93.13736,
    city: "Clemons",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 277,
    density: 4.7,
    county_fips: 19127,
    county_name: "Marshall",
    county_weights: {
      19127: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 19127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50052,
    lat: 40.64417,
    lng: -93.44538,
    city: "Clio",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 71,
    density: 1.5,
    county_fips: 19185,
    county_name: "Wayne",
    county_weights: {
      19185: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 19185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50054,
    lat: 41.68729,
    lng: -93.23196,
    city: "Colfax",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2912,
    density: 18.4,
    county_fips: 19099,
    county_name: "Jasper",
    county_weights: {
      19099: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 19099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50055,
    lat: 41.88456,
    lng: -93.2889,
    city: "Collins",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 979,
    density: 7.3,
    county_fips: 19169,
    county_name: "Story",
    county_weights: {
      19099: 30.45,
      19127: 4.38,
      19169: 65.17,
    },
    county_names_all: "Story|Jasper|Marshall",
    county_fips_all: "19169|19099|19127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50056,
    lat: 42.01925,
    lng: -93.29701,
    city: "Colo",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1288,
    density: 8.2,
    county_fips: 19169,
    county_name: "Story",
    county_weights: {
      19169: 100,
    },
    county_names_all: "Story",
    county_fips_all: 19169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50057,
    lat: 41.17859,
    lng: -93.14554,
    city: "Columbia",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 288,
    density: 6,
    county_fips: 19125,
    county_name: "Marion",
    county_weights: {
      19125: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 19125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50058,
    lat: 41.85773,
    lng: -94.69044,
    city: "Coon Rapids",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1864,
    density: 5.2,
    county_fips: 19077,
    county_name: "Guthrie",
    county_weights: {
      19009: 12.08,
      19027: 39.02,
      19073: 9.45,
      19077: 39.45,
    },
    county_names_all: "Guthrie|Carroll|Audubon|Greene",
    county_fips_all: "19077|19027|19009|19073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50060,
    lat: 40.75508,
    lng: -93.31922,
    city: "Corydon",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2629,
    density: 5.9,
    county_fips: 19185,
    county_name: "Wayne",
    county_weights: {
      19185: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 19185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50061,
    lat: 41.48022,
    lng: -93.79343,
    city: "Cumming",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2474,
    density: 30.8,
    county_fips: 19121,
    county_name: "Madison",
    county_weights: {
      19049: 7.44,
      19121: 51.93,
      19153: 6.93,
      19181: 33.7,
    },
    county_names_all: "Madison|Warren|Dallas|Polk",
    county_fips_all: "19121|19181|19049|19153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50062,
    lat: 41.23499,
    lng: -93.24425,
    city: "Melcher Dallas",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 715,
    density: 9,
    county_fips: 19125,
    county_name: "Marion",
    county_weights: {
      19125: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 19125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50063,
    lat: 41.69669,
    lng: -93.93677,
    city: "Dallas Center",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2424,
    density: 14.1,
    county_fips: 19049,
    county_name: "Dallas",
    county_weights: {
      19049: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 19049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50064,
    lat: 42.10671,
    lng: -94.229,
    city: "Dana",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 140,
    density: 2.8,
    county_fips: 19073,
    county_name: "Greene",
    county_weights: {
      19015: 10.55,
      19073: 89.45,
    },
    county_names_all: "Greene|Boone",
    county_fips_all: "19073|19015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50065,
    lat: 40.60859,
    lng: -93.78089,
    city: "Davis City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 689,
    density: 5,
    county_fips: 19053,
    county_name: "Decatur",
    county_weights: {
      19053: 100,
    },
    county_names_all: "Decatur",
    county_fips_all: 19053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50066,
    lat: 41.8051,
    lng: -94.22708,
    city: "Dawson",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 201,
    density: 3.1,
    county_fips: 19049,
    county_name: "Dallas",
    county_weights: {
      19049: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 19049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50067,
    lat: 40.70452,
    lng: -93.85914,
    city: "Decatur",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 287,
    density: 3,
    county_fips: 19053,
    county_name: "Decatur",
    county_weights: {
      19053: 100,
    },
    county_names_all: "Decatur",
    county_fips_all: 19053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50068,
    lat: 40.94229,
    lng: -93.46704,
    city: "Derby",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 274,
    density: 2.5,
    county_fips: 19117,
    county_name: "Lucas",
    county_weights: {
      19117: 90.9,
      19185: 9.1,
    },
    county_names_all: "Lucas|Wayne",
    county_fips_all: "19117|19185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50069,
    lat: 41.52104,
    lng: -94.02993,
    city: "De Soto",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1077,
    density: 78.9,
    county_fips: 19049,
    county_name: "Dallas",
    county_weights: {
      19049: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 19049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50070,
    lat: 41.45402,
    lng: -94.23745,
    city: "Dexter",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1234,
    density: 7.3,
    county_fips: 19121,
    county_name: "Madison",
    county_weights: {
      19001: 28.23,
      19049: 15.81,
      19077: 16.09,
      19121: 39.86,
    },
    county_names_all: "Madison|Adair|Guthrie|Dallas",
    county_fips_all: "19121|19001|19077|19049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50071,
    lat: 42.64931,
    lng: -93.50597,
    city: "Dows",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 919,
    density: 3.2,
    county_fips: 19197,
    county_name: "Wright",
    county_weights: {
      19069: 44.16,
      19197: 55.84,
    },
    county_names_all: "Wright|Franklin",
    county_fips_all: "19197|19069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50072,
    lat: 41.46984,
    lng: -94.12115,
    city: "Earlham",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2558,
    density: 11,
    county_fips: 19121,
    county_name: "Madison",
    county_weights: {
      19049: 25.27,
      19121: 74.73,
    },
    county_names_all: "Madison|Dallas",
    county_fips_all: "19121|19049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50073,
    lat: 41.79234,
    lng: -93.52463,
    city: "Elkhart",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1104,
    density: 16.3,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19153: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 19153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50074,
    lat: 40.85685,
    lng: -94.07524,
    city: "Ellston",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 303,
    density: 2.4,
    county_fips: 19159,
    county_name: "Ringgold",
    county_weights: {
      19159: 85.09,
      19175: 14.91,
    },
    county_names_all: "Ringgold|Union",
    county_fips_all: "19159|19175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50075,
    lat: 42.33516,
    lng: -93.56054,
    city: "Ellsworth",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 793,
    density: 6.5,
    county_fips: 19079,
    county_name: "Hamilton",
    county_weights: {
      19079: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 19079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50076,
    lat: 41.595,
    lng: -94.8576,
    city: "Exira",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1559,
    density: 5.5,
    county_fips: 19009,
    county_name: "Audubon",
    county_weights: {
      19009: 99.07,
      19077: 0.93,
    },
    county_names_all: "Audubon|Guthrie",
    county_fips_all: "19009|19077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50078,
    lat: 41.93862,
    lng: -92.8629,
    city: "Ferguson",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 125,
    density: 188.6,
    county_fips: 19127,
    county_name: "Marshall",
    county_weights: {
      19127: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 19127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50101,
    lat: 42.66713,
    lng: -93.63423,
    city: "Galt",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35,
    density: 1.3,
    county_fips: 19197,
    county_name: "Wright",
    county_weights: {
      19197: 100,
    },
    county_names_all: "Wright",
    county_fips_all: 19197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50102,
    lat: 42.24554,
    lng: -93.40022,
    city: "Garden City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 150,
    density: 114.9,
    county_fips: 19083,
    county_name: "Hardin",
    county_weights: {
      19083: 100,
    },
    county_names_all: "Hardin",
    county_fips_all: 19083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50103,
    lat: 40.79292,
    lng: -93.61079,
    city: "Garden Grove",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 336,
    density: 2.2,
    county_fips: 19053,
    county_name: "Decatur",
    county_weights: {
      19053: 100,
    },
    county_names_all: "Decatur",
    county_fips_all: 19053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50104,
    lat: 41.49458,
    lng: -92.38841,
    city: "Gibson",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 66,
    density: 1.7,
    county_fips: 19107,
    county_name: "Keokuk",
    county_weights: {
      19107: 64.37,
      19123: 9.67,
      19157: 25.96,
    },
    county_names_all: "Keokuk|Poweshiek|Mahaska",
    county_fips_all: "19107|19157|19123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50105,
    lat: 42.11754,
    lng: -93.63912,
    city: "Gilbert",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1088,
    density: 46.1,
    county_fips: 19169,
    county_name: "Story",
    county_weights: {
      19169: 100,
    },
    county_names_all: "Story",
    county_fips_all: 19169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50106,
    lat: 41.88213,
    lng: -92.80749,
    city: "Gilman",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 863,
    density: 4.9,
    county_fips: 19127,
    county_name: "Marshall",
    county_weights: {
      19099: 23.29,
      19127: 51.06,
      19157: 5.41,
      19171: 20.24,
    },
    county_names_all: "Marshall|Jasper|Tama|Poweshiek",
    county_fips_all: "19127|19099|19171|19157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50107,
    lat: 42.03547,
    lng: -94.2191,
    city: "Grand Junction",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1025,
    density: 7.7,
    county_fips: 19073,
    county_name: "Greene",
    county_weights: {
      19015: 11.84,
      19073: 88.16,
    },
    county_names_all: "Greene|Boone",
    county_fips_all: "19073|19015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50108,
    lat: 40.82479,
    lng: -93.9577,
    city: "Grand River",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 384,
    density: 1.8,
    county_fips: 19053,
    county_name: "Decatur",
    county_weights: {
      19039: 11.68,
      19053: 88.32,
    },
    county_names_all: "Decatur|Clarke",
    county_fips_all: "19053|19039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50109,
    lat: 41.76802,
    lng: -93.80775,
    city: "Granger",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3221,
    density: 64.2,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19049: 41.78,
      19153: 58.22,
    },
    county_names_all: "Polk|Dallas",
    county_fips_all: "19153|19049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50110,
    lat: 41.84424,
    lng: -94.98612,
    city: "Gray",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19009,
    county_name: "Audubon",
    county_weights: {
      19009: 100,
    },
    county_names_all: "Audubon",
    county_fips_all: 19009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50111,
    lat: 41.69353,
    lng: -93.80358,
    city: "Grimes",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15510,
    density: 238.5,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19049: 33.81,
      19153: 66.19,
    },
    county_names_all: "Polk|Dallas",
    county_fips_all: "19153|19049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50112,
    lat: 41.7319,
    lng: -92.71591,
    city: "Grinnell",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11704,
    density: 24.8,
    county_fips: 19157,
    county_name: "Poweshiek",
    county_weights: {
      19099: 25.97,
      19157: 74.03,
    },
    county_names_all: "Poweshiek|Jasper",
    county_fips_all: "19157|19099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50115,
    lat: 41.68765,
    lng: -94.55501,
    city: "Guthrie Center",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2647,
    density: 5.9,
    county_fips: 19077,
    county_name: "Guthrie",
    county_weights: {
      19077: 100,
    },
    county_names_all: "Guthrie",
    county_fips_all: 19077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50116,
    lat: 41.17812,
    lng: -92.98247,
    city: "Hamilton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 139,
    density: 3.3,
    county_fips: 19125,
    county_name: "Marion",
    county_weights: {
      19125: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 19125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50117,
    lat: 41.66903,
    lng: -94.85419,
    city: "Hamlin",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 138,
    density: 2,
    county_fips: 19009,
    county_name: "Audubon",
    county_weights: {
      19009: 100,
    },
    county_names_all: "Audubon",
    county_fips_all: 19009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50118,
    lat: 41.45957,
    lng: -93.37673,
    city: "Hartford",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 890,
    density: 30.4,
    county_fips: 19181,
    county_name: "Warren",
    county_weights: {
      19181: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 19181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50119,
    lat: 41.31089,
    lng: -92.94587,
    city: "Harvey",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 264,
    density: 6.4,
    county_fips: 19125,
    county_name: "Marion",
    county_weights: {
      19125: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 19125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50120,
    lat: 41.93373,
    lng: -92.9828,
    city: "Haverhill",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 440,
    density: 10,
    county_fips: 19127,
    county_name: "Marshall",
    county_weights: {
      19127: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 19127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50122,
    lat: 42.30218,
    lng: -93.3087,
    city: "Hubbard",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1438,
    density: 6.6,
    county_fips: 19083,
    county_name: "Hardin",
    county_weights: {
      19083: 100,
    },
    county_names_all: "Hardin",
    county_fips_all: 19083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50123,
    lat: 40.83938,
    lng: -93.50634,
    city: "Humeston",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 739,
    density: 3.4,
    county_fips: 19185,
    county_name: "Wayne",
    county_weights: {
      19039: 2.42,
      19053: 6.9,
      19117: 11.16,
      19185: 79.52,
    },
    county_names_all: "Wayne|Lucas|Decatur|Clarke",
    county_fips_all: "19185|19117|19053|19039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50124,
    lat: 41.88516,
    lng: -93.60446,
    city: "Huxley",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4259,
    density: 79.3,
    county_fips: 19169,
    county_name: "Story",
    county_weights: {
      19153: 26.01,
      19169: 73.99,
    },
    county_names_all: "Story|Polk",
    county_fips_all: "19169|19153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50125,
    lat: 41.33286,
    lng: -93.57957,
    city: "Indianola",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20476,
    density: 48.7,
    county_fips: 19181,
    county_name: "Warren",
    county_weights: {
      19181: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 19181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50126,
    lat: 42.50875,
    lng: -93.24815,
    city: "Iowa Falls",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6412,
    density: 18.1,
    county_fips: 19083,
    county_name: "Hardin",
    county_weights: {
      19069: 25.68,
      19083: 74.32,
    },
    county_names_all: "Hardin|Franklin",
    county_fips_all: "19083|19069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50127,
    lat: 41.78122,
    lng: -93.21129,
    city: "Ira",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19099,
    county_name: "Jasper",
    county_weights: {
      19099: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 19099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50128,
    lat: 41.85173,
    lng: -94.29853,
    city: "Jamaica",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 412,
    density: 5.6,
    county_fips: 19077,
    county_name: "Guthrie",
    county_weights: {
      19049: 12.44,
      19073: 39.09,
      19077: 48.47,
    },
    county_names_all: "Guthrie|Greene|Dallas",
    county_fips_all: "19077|19073|19049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50129,
    lat: 42.01335,
    lng: -94.3764,
    city: "Jefferson",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5119,
    density: 12,
    county_fips: 19073,
    county_name: "Greene",
    county_weights: {
      19073: 99.84,
      19077: 0.16,
    },
    county_names_all: "Greene|Guthrie",
    county_fips_all: "19073|19077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50130,
    lat: 42.30074,
    lng: -93.67331,
    city: "Jewell",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1596,
    density: 9.6,
    county_fips: 19079,
    county_name: "Hamilton",
    county_weights: {
      19079: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 19079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50131,
    lat: 41.69749,
    lng: -93.72021,
    city: "Johnston",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21907,
    density: 357,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19153: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 19153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50132,
    lat: 42.39392,
    lng: -93.68256,
    city: "Kamrar",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 321,
    density: 4,
    county_fips: 19079,
    county_name: "Hamilton",
    county_weights: {
      19079: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 19079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50133,
    lat: 40.71592,
    lng: -94.07576,
    city: "Kellerton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 483,
    density: 2.6,
    county_fips: 19159,
    county_name: "Ringgold",
    county_weights: {
      19053: 2.14,
      19159: 97.86,
    },
    county_names_all: "Ringgold|Decatur",
    county_fips_all: "19159|19053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50134,
    lat: 41.93992,
    lng: -93.67429,
    city: "Kelley",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 896,
    density: 17.8,
    county_fips: 19169,
    county_name: "Story",
    county_weights: {
      19015: 26.77,
      19169: 73.23,
    },
    county_names_all: "Story|Boone",
    county_fips_all: "19169|19015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50135,
    lat: 41.7475,
    lng: -92.89096,
    city: "Kellogg",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1350,
    density: 7.1,
    county_fips: 19099,
    county_name: "Jasper",
    county_weights: {
      19099: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 19099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50136,
    lat: 41.46984,
    lng: -92.28927,
    city: "Keswick",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 470,
    density: 4.6,
    county_fips: 19107,
    county_name: "Keokuk",
    county_weights: {
      19095: 5.65,
      19107: 94.35,
    },
    county_names_all: "Keokuk|Iowa",
    county_fips_all: "19107|19095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50137,
    lat: 41.60872,
    lng: -92.92126,
    city: "Killduff",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19099,
    county_name: "Jasper",
    county_weights: {
      19099: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 19099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50138,
    lat: 41.30246,
    lng: -93.10534,
    city: "Knoxville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11725,
    density: 26.9,
    county_fips: 19125,
    county_name: "Marion",
    county_weights: {
      19125: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 19125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50139,
    lat: 41.19237,
    lng: -93.36683,
    city: "Lacona",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1154,
    density: 5.2,
    county_fips: 19181,
    county_name: "Warren",
    county_weights: {
      19117: 22.37,
      19125: 24.83,
      19181: 52.8,
    },
    county_names_all: "Warren|Marion|Lucas",
    county_fips_all: "19181|19125|19117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50140,
    lat: 40.63753,
    lng: -93.99198,
    city: "Lamoni",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2925,
    density: 12.2,
    county_fips: 19053,
    county_name: "Decatur",
    county_weights: {
      19053: 69.18,
      19159: 30.82,
    },
    county_names_all: "Decatur|Ringgold",
    county_fips_all: "19053|19159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50141,
    lat: 41.86889,
    lng: -92.95634,
    city: "Laurel",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 419,
    density: 4.3,
    county_fips: 19127,
    county_name: "Marshall",
    county_weights: {
      19099: 42.87,
      19127: 57.13,
    },
    county_names_all: "Marshall|Jasper",
    county_fips_all: "19127|19099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50142,
    lat: 42.0055,
    lng: -92.77582,
    city: "Le Grand",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 840,
    density: 468.4,
    county_fips: 19127,
    county_name: "Marshall",
    county_weights: {
      19127: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 19127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50143,
    lat: 41.34245,
    lng: -92.79893,
    city: "Leighton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 622,
    density: 6.8,
    county_fips: 19123,
    county_name: "Mahaska",
    county_weights: {
      19123: 98.57,
      19125: 1.43,
    },
    county_names_all: "Mahaska|Marion",
    county_fips_all: "19123|19125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50144,
    lat: 40.73327,
    lng: -93.73615,
    city: "Leon",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2694,
    density: 7.3,
    county_fips: 19053,
    county_name: "Decatur",
    county_weights: {
      19053: 100,
    },
    county_names_all: "Decatur",
    county_fips_all: 19053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50145,
    lat: 41.20387,
    lng: -93.48515,
    city: "Liberty Center",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19181,
    county_name: "Warren",
    county_weights: {
      19181: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 19181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50146,
    lat: 41.68038,
    lng: -94.24905,
    city: "Linden",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 509,
    density: 6.1,
    county_fips: 19049,
    county_name: "Dallas",
    county_weights: {
      19049: 88.63,
      19077: 11.37,
    },
    county_names_all: "Dallas|Guthrie",
    county_fips_all: "19049|19077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50147,
    lat: 40.62381,
    lng: -93.54597,
    city: "Lineville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 354,
    density: 2.1,
    county_fips: 19185,
    county_name: "Wayne",
    county_weights: {
      19053: 47.23,
      19185: 52.77,
    },
    county_names_all: "Wayne|Decatur",
    county_fips_all: "19185|19053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50148,
    lat: 42.18142,
    lng: -92.99567,
    city: "Liscomb",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 419,
    density: 8.6,
    county_fips: 19127,
    county_name: "Marshall",
    county_weights: {
      19127: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 19127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50149,
    lat: 41.1512,
    lng: -94.08194,
    city: "Lorimor",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 963,
    density: 4.5,
    county_fips: 19121,
    county_name: "Madison",
    county_weights: {
      19121: 51.13,
      19175: 48.87,
    },
    county_names_all: "Madison|Union",
    county_fips_all: "19121|19175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50150,
    lat: 41.12771,
    lng: -92.97404,
    city: "Lovilia",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 941,
    density: 6.5,
    county_fips: 19135,
    county_name: "Monroe",
    county_weights: {
      19125: 0.79,
      19135: 99.21,
    },
    county_names_all: "Monroe|Marion",
    county_fips_all: "19135|19125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50151,
    lat: 41.08074,
    lng: -93.49717,
    city: "Lucas",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 612,
    density: 3,
    county_fips: 19117,
    county_name: "Lucas",
    county_weights: {
      19117: 91.32,
      19181: 8.68,
    },
    county_names_all: "Lucas|Warren",
    county_fips_all: "19117|19181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50152,
    lat: 41.96873,
    lng: -93.81765,
    city: "Luther",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19015,
    county_name: "Boone",
    county_weights: {
      19015: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 19015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50153,
    lat: 41.57669,
    lng: -92.80033,
    city: "Lynnville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 853,
    density: 9.9,
    county_fips: 19099,
    county_name: "Jasper",
    county_weights: {
      19099: 87.91,
      19123: 8.82,
      19157: 3.27,
    },
    county_names_all: "Jasper|Mahaska|Poweshiek",
    county_fips_all: "19099|19123|19157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50154,
    lat: 42.17625,
    lng: -93.39068,
    city: "McCallsburg",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 540,
    density: 8.8,
    county_fips: 19169,
    county_name: "Story",
    county_weights: {
      19083: 15.65,
      19169: 84.35,
    },
    county_names_all: "Story|Hardin",
    county_fips_all: "19169|19083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50155,
    lat: 41.21288,
    lng: -94.19713,
    city: "Macksburg",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 192,
    density: 2.4,
    county_fips: 19121,
    county_name: "Madison",
    county_weights: {
      19001: 6.51,
      19121: 93.49,
    },
    county_names_all: "Madison|Adair",
    county_fips_all: "19121|19001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50156,
    lat: 41.90349,
    lng: -93.80001,
    city: "Madrid",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4856,
    density: 21.2,
    county_fips: 19015,
    county_name: "Boone",
    county_weights: {
      19015: 76.41,
      19049: 6.59,
      19153: 17,
    },
    county_names_all: "Boone|Polk|Dallas",
    county_fips_all: "19015|19153|19049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50157,
    lat: 41.74545,
    lng: -92.56183,
    city: "Malcom",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 881,
    density: 5.1,
    county_fips: 19157,
    county_name: "Poweshiek",
    county_weights: {
      19157: 100,
    },
    county_names_all: "Poweshiek",
    county_fips_all: 19157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50158,
    lat: 42.05016,
    lng: -92.90143,
    city: "Marshalltown",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30736,
    density: 55.9,
    county_fips: 19127,
    county_name: "Marshall",
    county_weights: {
      19127: 98.63,
      19171: 1.37,
    },
    county_names_all: "Marshall|Tama",
    county_fips_all: "19127|19171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50160,
    lat: 41.37385,
    lng: -93.7387,
    city: "Martensdale",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 504,
    density: 528.9,
    county_fips: 19181,
    county_name: "Warren",
    county_weights: {
      19181: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 19181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50161,
    lat: 41.84764,
    lng: -93.39914,
    city: "Maxwell",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2033,
    density: 9.9,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19099: 3.32,
      19153: 55.74,
      19169: 40.94,
    },
    county_names_all: "Polk|Story|Jasper",
    county_fips_all: "19153|19169|19099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50162,
    lat: 41.92563,
    lng: -93.06781,
    city: "Melbourne",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1246,
    density: 9.6,
    county_fips: 19127,
    county_name: "Marshall",
    county_weights: {
      19099: 3.64,
      19127: 96.36,
    },
    county_names_all: "Marshall|Jasper",
    county_fips_all: "19127|19099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50163,
    lat: 41.2223,
    lng: -93.24101,
    city: "Melcher Dallas",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 839,
    density: 680.7,
    county_fips: 19125,
    county_name: "Marion",
    county_weights: {
      19125: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 19125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50164,
    lat: 41.49921,
    lng: -94.42176,
    city: "Menlo",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 576,
    density: 4.5,
    county_fips: 19077,
    county_name: "Guthrie",
    county_weights: {
      19001: 47.64,
      19077: 52.36,
    },
    county_names_all: "Guthrie|Adair",
    county_fips_all: "19077|19001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50165,
    lat: 40.84808,
    lng: -93.30937,
    city: "Millerton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 125,
    density: 113,
    county_fips: 19185,
    county_name: "Wayne",
    county_weights: {
      19185: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 19185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50166,
    lat: 41.28289,
    lng: -93.42629,
    city: "Milo",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1829,
    density: 11.8,
    county_fips: 19181,
    county_name: "Warren",
    county_weights: {
      19181: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 19181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50167,
    lat: 41.74613,
    lng: -94.04871,
    city: "Minburn",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 865,
    density: 8,
    county_fips: 19049,
    county_name: "Dallas",
    county_weights: {
      19049: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 19049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50168,
    lat: 41.77725,
    lng: -93.27248,
    city: "Mingo",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 990,
    density: 10,
    county_fips: 19099,
    county_name: "Jasper",
    county_weights: {
      19099: 95.76,
      19153: 4.24,
    },
    county_names_all: "Jasper|Polk",
    county_fips_all: "19099|19153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50169,
    lat: 41.65617,
    lng: -93.35062,
    city: "Mitchellville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2954,
    density: 25,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19099: 43.92,
      19153: 56.08,
    },
    county_names_all: "Polk|Jasper",
    county_fips_all: "19153|19099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50170,
    lat: 41.52911,
    lng: -93.11546,
    city: "Monroe",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3045,
    density: 14.1,
    county_fips: 19099,
    county_name: "Jasper",
    county_weights: {
      19099: 68.29,
      19125: 31.71,
    },
    county_names_all: "Jasper|Marion",
    county_fips_all: "19099|19125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50171,
    lat: 41.58434,
    lng: -92.52584,
    city: "Montezuma",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2585,
    density: 9.1,
    county_fips: 19157,
    county_name: "Poweshiek",
    county_weights: {
      19123: 1.65,
      19157: 98.35,
    },
    county_names_all: "Poweshiek|Mahaska",
    county_fips_all: "19157|19123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50173,
    lat: 41.97461,
    lng: -92.71044,
    city: "Montour",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 895,
    density: 10.4,
    county_fips: 19171,
    county_name: "Tama",
    county_weights: {
      19171: 100,
    },
    county_names_all: "Tama",
    county_fips_all: 19171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50174,
    lat: 41.03723,
    lng: -93.96167,
    city: "Murray",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1459,
    density: 5.4,
    county_fips: 19039,
    county_name: "Clarke",
    county_weights: {
      19039: 91.09,
      19175: 8.91,
    },
    county_names_all: "Clarke|Union",
    county_fips_all: "19039|19175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50201,
    lat: 42.03337,
    lng: -93.44434,
    city: "Nevada",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7940,
    density: 26.1,
    county_fips: 19169,
    county_name: "Story",
    county_weights: {
      19169: 100,
    },
    county_names_all: "Story",
    county_fips_all: 19169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50206,
    lat: 42.25018,
    lng: -93.18941,
    city: "New Providence",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 531,
    density: 4.5,
    county_fips: 19083,
    county_name: "Hardin",
    county_weights: {
      19083: 81.18,
      19127: 16.15,
      19169: 2.67,
    },
    county_names_all: "Hardin|Marshall|Story",
    county_fips_all: "19083|19127|19169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50207,
    lat: 41.43344,
    lng: -92.6381,
    city: "New Sharon",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2196,
    density: 5.9,
    county_fips: 19123,
    county_name: "Mahaska",
    county_weights: {
      19123: 97.61,
      19157: 2.39,
    },
    county_names_all: "Mahaska|Poweshiek",
    county_fips_all: "19123|19157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50208,
    lat: 41.71129,
    lng: -93.03924,
    city: "Newton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20189,
    density: 49.2,
    county_fips: 19099,
    county_name: "Jasper",
    county_weights: {
      19099: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 19099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50210,
    lat: 41.18998,
    lng: -93.6978,
    city: "New Virginia",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1380,
    density: 7.3,
    county_fips: 19181,
    county_name: "Warren",
    county_weights: {
      19039: 20.83,
      19121: 1.94,
      19181: 77.23,
    },
    county_names_all: "Warren|Clarke|Madison",
    county_fips_all: "19181|19039|19121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50211,
    lat: 41.45614,
    lng: -93.6887,
    city: "Norwalk",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13404,
    density: 88.3,
    county_fips: 19181,
    county_name: "Warren",
    county_weights: {
      19121: 4.08,
      19181: 95.92,
    },
    county_names_all: "Warren|Madison",
    county_fips_all: "19181|19121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50212,
    lat: 42.03515,
    lng: -94.05996,
    city: "Ogden",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2820,
    density: 8.2,
    county_fips: 19015,
    county_name: "Boone",
    county_weights: {
      19015: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 19015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50213,
    lat: 41.03292,
    lng: -93.76557,
    city: "Osceola",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7076,
    density: 13,
    county_fips: 19039,
    county_name: "Clarke",
    county_weights: {
      19039: 100,
    },
    county_names_all: "Clarke",
    county_fips_all: 19039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50214,
    lat: 41.46246,
    lng: -93.05528,
    city: "Otley",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 832,
    density: 8.3,
    county_fips: 19125,
    county_name: "Marion",
    county_weights: {
      19125: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 19125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50216,
    lat: 41.69798,
    lng: -94.35023,
    city: "Panora",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2653,
    density: 19.8,
    county_fips: 19077,
    county_name: "Guthrie",
    county_weights: {
      19077: 100,
    },
    county_names_all: "Guthrie",
    county_fips_all: 19077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50217,
    lat: 42.17206,
    lng: -94.24984,
    city: "Paton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 570,
    density: 3.1,
    county_fips: 19073,
    county_name: "Greene",
    county_weights: {
      19015: 15.64,
      19073: 84.36,
    },
    county_names_all: "Greene|Boone",
    county_fips_all: "19073|19015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50218,
    lat: 41.34844,
    lng: -93.87755,
    city: "Patterson",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 221,
    density: 190.6,
    county_fips: 19121,
    county_name: "Madison",
    county_weights: {
      19121: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 19121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50219,
    lat: 41.42243,
    lng: -92.90132,
    city: "Pella",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13298,
    density: 44.5,
    county_fips: 19125,
    county_name: "Marion",
    county_weights: {
      19123: 34.75,
      19125: 65.25,
    },
    county_names_all: "Marion|Mahaska",
    county_fips_all: "19125|19123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50220,
    lat: 41.8366,
    lng: -94.12293,
    city: "Perry",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8971,
    density: 34.5,
    county_fips: 19049,
    county_name: "Dallas",
    county_weights: {
      19015: 32.77,
      19049: 63.5,
      19073: 3.73,
    },
    county_names_all: "Dallas|Boone|Greene",
    county_fips_all: "19049|19015|19073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50222,
    lat: 41.21701,
    lng: -93.95369,
    city: "Peru",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 516,
    density: 4.8,
    county_fips: 19121,
    county_name: "Madison",
    county_weights: {
      19039: 3.4,
      19121: 96.6,
    },
    county_names_all: "Madison|Clarke",
    county_fips_all: "19121|19039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50223,
    lat: 42.17117,
    lng: -94.02831,
    city: "Pilot Mound",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 452,
    density: 6,
    county_fips: 19015,
    county_name: "Boone",
    county_weights: {
      19015: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 19015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50225,
    lat: 41.3823,
    lng: -93.27103,
    city: "Pleasantville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3319,
    density: 14.9,
    county_fips: 19125,
    county_name: "Marion",
    county_weights: {
      19125: 84.59,
      19181: 15.41,
    },
    county_names_all: "Marion|Warren",
    county_fips_all: "19125|19181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50226,
    lat: 41.79716,
    lng: -93.70566,
    city: "Polk City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7197,
    density: 76.4,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19153: 99.44,
      19169: 0.56,
    },
    county_names_all: "Polk|Story",
    county_fips_all: "19153|19169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50227,
    lat: 42.59388,
    lng: -93.42818,
    city: "Popejoy",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 76,
    density: 41.6,
    county_fips: 19069,
    county_name: "Franklin",
    county_weights: {
      19069: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 19069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50228,
    lat: 41.57008,
    lng: -93.24154,
    city: "Prairie City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2849,
    density: 15.9,
    county_fips: 19099,
    county_name: "Jasper",
    county_weights: {
      19099: 89.28,
      19125: 9.8,
      19153: 0.92,
    },
    county_names_all: "Jasper|Marion|Polk",
    county_fips_all: "19099|19125|19153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50229,
    lat: 41.37416,
    lng: -93.77906,
    city: "Prole",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 892,
    density: 8.2,
    county_fips: 19181,
    county_name: "Warren",
    county_weights: {
      19121: 48.79,
      19181: 51.21,
    },
    county_names_all: "Warren|Madison",
    county_fips_all: "19181|19121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50230,
    lat: 42.30655,
    lng: -93.44718,
    city: "Radcliffe",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1015,
    density: 4.4,
    county_fips: 19083,
    county_name: "Hardin",
    county_weights: {
      19079: 38.43,
      19083: 61.02,
      19169: 0.55,
    },
    county_names_all: "Hardin|Hamilton|Story",
    county_fips_all: "19083|19079|19169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50231,
    lat: 42.23765,
    lng: -93.60257,
    city: "Randall",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 154,
    density: 133,
    county_fips: 19079,
    county_name: "Hamilton",
    county_weights: {
      19079: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 19079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50232,
    lat: 41.55761,
    lng: -92.96868,
    city: "Reasnor",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 565,
    density: 6.4,
    county_fips: 19099,
    county_name: "Jasper",
    county_weights: {
      19099: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 19099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50233,
    lat: 41.61221,
    lng: -94.21095,
    city: "Redfield",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1510,
    density: 11.6,
    county_fips: 19049,
    county_name: "Dallas",
    county_weights: {
      19049: 82.09,
      19077: 17.91,
    },
    county_names_all: "Dallas|Guthrie",
    county_fips_all: "19049|19077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50234,
    lat: 41.89165,
    lng: -93.17916,
    city: "Rhodes",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 558,
    density: 7.9,
    county_fips: 19127,
    county_name: "Marshall",
    county_weights: {
      19099: 16.9,
      19127: 83.1,
    },
    county_names_all: "Marshall|Jasper",
    county_fips_all: "19127|19099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50235,
    lat: 41.92974,
    lng: -94.20873,
    city: "Rippey",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 331,
    density: 2.7,
    county_fips: 19073,
    county_name: "Greene",
    county_weights: {
      19015: 10.42,
      19049: 4.02,
      19073: 85.56,
    },
    county_names_all: "Greene|Boone|Dallas",
    county_fips_all: "19073|19015|19049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50236,
    lat: 42.1675,
    lng: -93.4834,
    city: "Roland",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1689,
    density: 19.2,
    county_fips: 19169,
    county_name: "Story",
    county_weights: {
      19169: 100,
    },
    county_names_all: "Story",
    county_fips_all: 19169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50237,
    lat: 41.54238,
    lng: -93.36859,
    city: "Runnells",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3105,
    density: 24.7,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19099: 12.94,
      19125: 9.1,
      19153: 77.96,
    },
    county_names_all: "Polk|Jasper|Marion",
    county_fips_all: "19153|19099|19125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50238,
    lat: 40.97124,
    lng: -93.17502,
    city: "Russell",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1400,
    density: 5.4,
    county_fips: 19117,
    county_name: "Lucas",
    county_weights: {
      19117: 78.65,
      19185: 21.35,
    },
    county_names_all: "Lucas|Wayne",
    county_fips_all: "19117|19185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50239,
    lat: 42.14431,
    lng: -93.20144,
    city: "Saint Anthony",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44,
    density: 0.8,
    county_fips: 19127,
    county_name: "Marshall",
    county_weights: {
      19127: 93.99,
      19169: 6.01,
    },
    county_names_all: "Marshall|Story",
    county_fips_all: "19127|19169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50240,
    lat: 41.29368,
    lng: -93.796,
    city: "Saint Charles",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2967,
    density: 15.2,
    county_fips: 19121,
    county_name: "Madison",
    county_weights: {
      19121: 51.28,
      19181: 48.72,
    },
    county_names_all: "Madison|Warren",
    county_fips_all: "19121|19181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50241,
    lat: 41.30771,
    lng: -93.73368,
    city: "Saint Marys",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19181,
    county_name: "Warren",
    county_weights: {
      19181: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 19181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50242,
    lat: 41.56332,
    lng: -92.69428,
    city: "Searsboro",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 490,
    density: 4.7,
    county_fips: 19157,
    county_name: "Poweshiek",
    county_weights: {
      19157: 100,
    },
    county_names_all: "Poweshiek",
    county_fips_all: 19157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50243,
    lat: 41.86457,
    lng: -93.6967,
    city: "Sheldahl",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 246,
    density: 118.4,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19015: 31.31,
      19153: 36.69,
      19169: 32.01,
    },
    county_names_all: "Polk|Story|Boone",
    county_fips_all: "19153|19169|19015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50244,
    lat: 41.85083,
    lng: -93.65126,
    city: "Slater",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1875,
    density: 28.8,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19015: 2.17,
      19153: 59.82,
      19169: 38.01,
    },
    county_names_all: "Polk|Story|Boone",
    county_fips_all: "19153|19169|19015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50246,
    lat: 42.28411,
    lng: -93.78198,
    city: "Stanhope",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 813,
    density: 7.7,
    county_fips: 19079,
    county_name: "Hamilton",
    county_weights: {
      19079: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 19079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50247,
    lat: 42.01832,
    lng: -93.1665,
    city: "State Center",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2653,
    density: 12,
    county_fips: 19127,
    county_name: "Marshall",
    county_weights: {
      19127: 93.36,
      19169: 6.64,
    },
    county_names_all: "Marshall|Story",
    county_fips_all: "19127|19169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50248,
    lat: 42.19256,
    lng: -93.61297,
    city: "Story City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4114,
    density: 19.3,
    county_fips: 19169,
    county_name: "Story",
    county_weights: {
      19015: 10.5,
      19079: 35.54,
      19169: 53.96,
    },
    county_names_all: "Story|Hamilton|Boone",
    county_fips_all: "19169|19079|19015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50249,
    lat: 42.26991,
    lng: -93.89973,
    city: "Stratford",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1198,
    density: 5.8,
    county_fips: 19079,
    county_name: "Hamilton",
    county_weights: {
      19015: 10.81,
      19079: 70.02,
      19187: 19.17,
    },
    county_names_all: "Hamilton|Webster|Boone",
    county_fips_all: "19079|19187|19015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50250,
    lat: 41.48088,
    lng: -94.34062,
    city: "Stuart",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2384,
    density: 8.5,
    county_fips: 19001,
    county_name: "Adair",
    county_weights: {
      19001: 65.92,
      19077: 34.08,
    },
    county_names_all: "Adair|Guthrie",
    county_fips_all: "19001|19077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50251,
    lat: 41.56883,
    lng: -92.87007,
    city: "Sully",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1465,
    density: 13,
    county_fips: 19099,
    county_name: "Jasper",
    county_weights: {
      19099: 96.79,
      19123: 3.21,
    },
    county_names_all: "Jasper|Mahaska",
    county_fips_all: "19099|19123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50252,
    lat: 41.45881,
    lng: -93.31518,
    city: "Swan",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 146,
    density: 3.9,
    county_fips: 19125,
    county_name: "Marion",
    county_weights: {
      19125: 63.28,
      19181: 36.72,
    },
    county_names_all: "Marion|Warren",
    county_fips_all: "19125|19181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50254,
    lat: 40.99045,
    lng: -94.06917,
    city: "Thayer",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 291,
    density: 2.6,
    county_fips: 19175,
    county_name: "Union",
    county_weights: {
      19175: 100,
    },
    county_names_all: "Union",
    county_fips_all: 19175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50255,
    lat: 41.45593,
    lng: -92.33207,
    city: "Thornburg",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51,
    density: 103.1,
    county_fips: 19107,
    county_name: "Keokuk",
    county_weights: {
      19107: 100,
    },
    county_names_all: "Keokuk",
    county_fips_all: 19107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50256,
    lat: 41.2664,
    lng: -92.91114,
    city: "Tracy",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 573,
    density: 8,
    county_fips: 19125,
    county_name: "Marion",
    county_weights: {
      19123: 23.43,
      19125: 76.57,
    },
    county_names_all: "Marion|Mahaska",
    county_fips_all: "19125|19123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50257,
    lat: 41.19092,
    lng: -93.85048,
    city: "Truro",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1236,
    density: 10.9,
    county_fips: 19121,
    county_name: "Madison",
    county_weights: {
      19039: 20.47,
      19121: 75.87,
      19181: 3.66,
    },
    county_names_all: "Madison|Clarke|Warren",
    county_fips_all: "19121|19039|19181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50258,
    lat: 42.22781,
    lng: -93.07788,
    city: "Union",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1068,
    density: 7.6,
    county_fips: 19083,
    county_name: "Hardin",
    county_weights: {
      19083: 71.49,
      19127: 28.51,
    },
    county_names_all: "Hardin|Marshall",
    county_fips_all: "19083|19127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50261,
    lat: 41.47014,
    lng: -93.92286,
    city: "Van Meter",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2606,
    density: 15.5,
    county_fips: 19121,
    county_name: "Madison",
    county_weights: {
      19049: 20.48,
      19121: 79.52,
    },
    county_names_all: "Madison|Dallas",
    county_fips_all: "19121|19049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50262,
    lat: 40.85625,
    lng: -93.82091,
    city: "Van Wert",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 301,
    density: 3.3,
    county_fips: 19053,
    county_name: "Decatur",
    county_weights: {
      19053: 100,
    },
    county_names_all: "Decatur",
    county_fips_all: 19053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50263,
    lat: 41.60391,
    lng: -93.87989,
    city: "Waukee",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26838,
    density: 377.4,
    county_fips: 19049,
    county_name: "Dallas",
    county_weights: {
      19049: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 19049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50264,
    lat: 40.89919,
    lng: -93.70071,
    city: "Weldon",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 485,
    density: 2.8,
    county_fips: 19039,
    county_name: "Clarke",
    county_weights: {
      19039: 55.25,
      19053: 44.75,
    },
    county_names_all: "Clarke|Decatur",
    county_fips_all: "19039|19053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50265,
    lat: 41.55129,
    lng: -93.73821,
    city: "West Des Moines",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32539,
    density: 651.1,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19153: 96.88,
      19181: 3.12,
    },
    county_names_all: "Polk|Warren",
    county_fips_all: "19153|19181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50266,
    lat: 41.56323,
    lng: -93.81107,
    city: "West Des Moines",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30515,
    density: 528.1,
    county_fips: 19049,
    county_name: "Dallas",
    county_weights: {
      19049: 74.72,
      19153: 25.28,
    },
    county_names_all: "Dallas|Polk",
    county_fips_all: "19049|19153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50268,
    lat: 41.40695,
    lng: -92.36227,
    city: "What Cheer",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1061,
    density: 8.8,
    county_fips: 19107,
    county_name: "Keokuk",
    county_weights: {
      19107: 81.65,
      19123: 18.35,
    },
    county_names_all: "Keokuk|Mahaska",
    county_fips_all: "19107|19123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50269,
    lat: 42.26236,
    lng: -93.01064,
    city: "Whitten",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19083,
    county_name: "Hardin",
    county_weights: {
      19083: 100,
    },
    county_names_all: "Hardin",
    county_fips_all: 19083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50271,
    lat: 42.48444,
    lng: -93.54489,
    city: "Williams",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 535,
    density: 3.1,
    county_fips: 19079,
    county_name: "Hamilton",
    county_weights: {
      19079: 93.58,
      19197: 6.42,
    },
    county_names_all: "Hamilton|Wright",
    county_fips_all: "19079|19197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50272,
    lat: 41.08809,
    lng: -93.25682,
    city: "Williamson",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 184,
    density: 195.7,
    county_fips: 19117,
    county_name: "Lucas",
    county_weights: {
      19117: 100,
    },
    county_names_all: "Lucas",
    county_fips_all: 19117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50273,
    lat: 41.32838,
    lng: -94.05606,
    city: "Winterset",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8444,
    density: 16.7,
    county_fips: 19121,
    county_name: "Madison",
    county_weights: {
      19001: 1.18,
      19121: 98.82,
    },
    county_names_all: "Madison|Adair",
    county_fips_all: "19121|19001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50274,
    lat: 41.38261,
    lng: -94.85756,
    city: "Wiota",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 139,
    density: 1.1,
    county_fips: 19029,
    county_name: "Cass",
    county_weights: {
      19029: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 19029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50275,
    lat: 41.04375,
    lng: -93.58852,
    city: "Woodburn",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 476,
    density: 3.4,
    county_fips: 19039,
    county_name: "Clarke",
    county_weights: {
      19039: 94.9,
      19117: 5.1,
    },
    county_names_all: "Clarke|Lucas",
    county_fips_all: "19039|19117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50276,
    lat: 41.85997,
    lng: -93.923,
    city: "Woodward",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2724,
    density: 12.8,
    county_fips: 19015,
    county_name: "Boone",
    county_weights: {
      19015: 50.77,
      19049: 49.23,
    },
    county_names_all: "Boone|Dallas",
    county_fips_all: "19015|19049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50277,
    lat: 41.77867,
    lng: -94.347,
    city: "Yale",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 429,
    density: 4.2,
    county_fips: 19077,
    county_name: "Guthrie",
    county_weights: {
      19049: 16.94,
      19077: 83.06,
    },
    county_names_all: "Guthrie|Dallas",
    county_fips_all: "19077|19049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50278,
    lat: 42.1528,
    lng: -93.29926,
    city: "Zearing",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 747,
    density: 6.2,
    county_fips: 19169,
    county_name: "Story",
    county_weights: {
      19169: 100,
    },
    county_names_all: "Story",
    county_fips_all: 19169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50309,
    lat: 41.58448,
    lng: -93.62152,
    city: "Des Moines",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8228,
    density: 1170.7,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19153: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 19153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50310,
    lat: 41.62777,
    lng: -93.67297,
    city: "Des Moines",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31965,
    density: 1535.8,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19153: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 19153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50311,
    lat: 41.601,
    lng: -93.67335,
    city: "Des Moines",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15936,
    density: 2411.4,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19153: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 19153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50312,
    lat: 41.58064,
    lng: -93.67622,
    city: "Des Moines",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15732,
    density: 1078.9,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19153: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 19153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50313,
    lat: 41.65538,
    lng: -93.62287,
    city: "Des Moines",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19306,
    density: 412.9,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19153: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 19153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50314,
    lat: 41.6049,
    lng: -93.63102,
    city: "Des Moines",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11231,
    density: 1756.4,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19153: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 19153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50315,
    lat: 41.5449,
    lng: -93.62063,
    city: "Des Moines",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36097,
    density: 1353.3,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19153: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 19153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50316,
    lat: 41.60877,
    lng: -93.59775,
    city: "Des Moines",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15892,
    density: 1720.2,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19153: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 19153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50317,
    lat: 41.61572,
    lng: -93.54881,
    city: "Des Moines",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36665,
    density: 640,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19153: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 19153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50319,
    lat: 41.59115,
    lng: -93.60314,
    city: "Des Moines",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19153: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 19153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50320,
    lat: 41.53208,
    lng: -93.57217,
    city: "Des Moines",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23724,
    density: 544.9,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19153: 78.48,
      19181: 21.52,
    },
    county_names_all: "Polk|Warren",
    county_fips_all: "19153|19181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50321,
    lat: 41.53997,
    lng: -93.67184,
    city: "Des Moines",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8663,
    density: 295,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19153: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 19153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50322,
    lat: 41.63383,
    lng: -93.73589,
    city: "Urbandale",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30980,
    density: 1105.1,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19153: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 19153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50323,
    lat: 41.63894,
    lng: -93.8185,
    city: "Urbandale",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14870,
    density: 566.7,
    county_fips: 19049,
    county_name: "Dallas",
    county_weights: {
      19049: 60.52,
      19153: 39.48,
    },
    county_names_all: "Dallas|Polk",
    county_fips_all: "19049|19153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50324,
    lat: 41.60471,
    lng: -93.71273,
    city: "Windsor Heights",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4889,
    density: 1344.8,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19153: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 19153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50325,
    lat: 41.61475,
    lng: -93.79864,
    city: "Clive",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17278,
    density: 863.5,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19049: 39.28,
      19153: 60.72,
    },
    county_names_all: "Polk|Dallas",
    county_fips_all: "19153|19049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50327,
    lat: 41.58402,
    lng: -93.48856,
    city: "Pleasant Hill",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12025,
    density: 294.4,
    county_fips: 19153,
    county_name: "Polk",
    county_weights: {
      19153: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 19153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50401,
    lat: 43.15389,
    lng: -93.20006,
    city: "Mason City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28647,
    density: 74.7,
    county_fips: 19033,
    county_name: "Cerro Gordo",
    county_weights: {
      19033: 100,
    },
    county_names_all: "Cerro Gordo",
    county_fips_all: 19033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50420,
    lat: 42.80621,
    lng: -93.45677,
    city: "Alexander",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 324,
    density: 2.6,
    county_fips: 19069,
    county_name: "Franklin",
    county_weights: {
      19069: 84.85,
      19197: 15.15,
    },
    county_names_all: "Franklin|Wright",
    county_fips_all: "19069|19197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50421,
    lat: 42.84246,
    lng: -93.62148,
    city: "Belmond",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2790,
    density: 11.7,
    county_fips: 19197,
    county_name: "Wright",
    county_weights: {
      19197: 100,
    },
    county_names_all: "Wright",
    county_fips_all: 19197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50423,
    lat: 43.11054,
    lng: -93.81244,
    city: "Britt",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2428,
    density: 6.6,
    county_fips: 19081,
    county_name: "Hancock",
    county_weights: {
      19081: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 19081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50424,
    lat: 43.40366,
    lng: -93.94939,
    city: "Buffalo Center",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1419,
    density: 3.9,
    county_fips: 19189,
    county_name: "Winnebago",
    county_weights: {
      19109: 37.85,
      19189: 62.15,
    },
    county_names_all: "Winnebago|Kossuth",
    county_fips_all: "19189|19109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50426,
    lat: 43.41507,
    lng: -93.01718,
    city: "Carpenter",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19131,
    county_name: "Mitchell",
    county_weights: {
      19131: 100,
    },
    county_names_all: "Mitchell",
    county_fips_all: 19131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50427,
    lat: 42.83557,
    lng: -93.22116,
    city: "Chapin",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19069,
    county_name: "Franklin",
    county_weights: {
      19069: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 19069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50428,
    lat: 43.13573,
    lng: -93.38815,
    city: "Clear Lake",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9064,
    density: 29.8,
    county_fips: 19033,
    county_name: "Cerro Gordo",
    county_weights: {
      19033: 100,
    },
    county_names_all: "Cerro Gordo",
    county_fips_all: 19033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50430,
    lat: 42.97734,
    lng: -93.95653,
    city: "Corwith",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 395,
    density: 2.4,
    county_fips: 19081,
    county_name: "Hancock",
    county_weights: {
      19081: 60.44,
      19091: 1.17,
      19109: 36.55,
      19197: 1.84,
    },
    county_names_all: "Hancock|Kossuth|Wright|Humboldt",
    county_fips_all: "19081|19109|19197|19091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50431,
    lat: 42.73648,
    lng: -93.36989,
    city: "Coulter",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 203,
    density: 104.9,
    county_fips: 19069,
    county_name: "Franklin",
    county_weights: {
      19069: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 19069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50432,
    lat: 43.22394,
    lng: -93.79794,
    city: "Crystal Lake",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 264,
    density: 234.5,
    county_fips: 19081,
    county_name: "Hancock",
    county_weights: {
      19081: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 19081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50433,
    lat: 42.92852,
    lng: -93.04774,
    city: "Dougherty",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 194,
    density: 1.6,
    county_fips: 19033,
    county_name: "Cerro Gordo",
    county_weights: {
      19023: 7.1,
      19033: 53.01,
      19067: 20.57,
      19069: 19.32,
    },
    county_names_all: "Cerro Gordo|Floyd|Franklin|Butler",
    county_fips_all: "19033|19067|19069|19023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50434,
    lat: 43.25857,
    lng: -93.45758,
    city: "Fertile",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 448,
    density: 17.2,
    county_fips: 19195,
    county_name: "Worth",
    county_weights: {
      19033: 40.96,
      19195: 59.04,
    },
    county_names_all: "Worth|Cerro Gordo",
    county_fips_all: "19195|19033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50435,
    lat: 43.15752,
    lng: -92.76877,
    city: "Floyd",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 606,
    density: 5.8,
    county_fips: 19067,
    county_name: "Floyd",
    county_weights: {
      19067: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 19067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50436,
    lat: 43.26256,
    lng: -93.66242,
    city: "Forest City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5617,
    density: 16,
    county_fips: 19189,
    county_name: "Winnebago",
    county_weights: {
      19081: 42.23,
      19189: 57.77,
    },
    county_names_all: "Winnebago|Hancock",
    county_fips_all: "19189|19081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50438,
    lat: 43.11018,
    lng: -93.61841,
    city: "Garner",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4092,
    density: 12.4,
    county_fips: 19081,
    county_name: "Hancock",
    county_weights: {
      19081: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 19081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50439,
    lat: 42.94578,
    lng: -93.6345,
    city: "Goodell",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 245,
    density: 2.9,
    county_fips: 19081,
    county_name: "Hancock",
    county_weights: {
      19081: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 19081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50440,
    lat: 43.33213,
    lng: -93.06891,
    city: "Grafton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 368,
    density: 4.9,
    county_fips: 19195,
    county_name: "Worth",
    county_weights: {
      19195: 100,
    },
    county_names_all: "Worth",
    county_fips_all: 19195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50441,
    lat: 42.73938,
    lng: -93.22146,
    city: "Hampton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5251,
    density: 13.7,
    county_fips: 19069,
    county_name: "Franklin",
    county_weights: {
      19069: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 19069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50444,
    lat: 43.29258,
    lng: -93.38601,
    city: "Hanlontown",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 284,
    density: 5.2,
    county_fips: 19195,
    county_name: "Worth",
    county_weights: {
      19033: 5.71,
      19195: 94.29,
    },
    county_names_all: "Worth|Cerro Gordo",
    county_fips_all: "19195|19033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50446,
    lat: 43.33821,
    lng: -93.45394,
    city: "Joice",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 526,
    density: 5.2,
    county_fips: 19195,
    county_name: "Worth",
    county_weights: {
      19189: 11.5,
      19195: 88.5,
    },
    county_names_all: "Worth|Winnebago",
    county_fips_all: "19195|19189",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50447,
    lat: 42.92719,
    lng: -93.80118,
    city: "Kanawha",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1238,
    density: 4.6,
    county_fips: 19081,
    county_name: "Hancock",
    county_weights: {
      19081: 63.99,
      19197: 36.01,
    },
    county_names_all: "Hancock|Wright",
    county_fips_all: "19081|19197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50448,
    lat: 43.35053,
    lng: -93.24753,
    city: "Kensett",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 651,
    density: 4,
    county_fips: 19195,
    county_name: "Worth",
    county_weights: {
      19195: 100,
    },
    county_names_all: "Worth",
    county_fips_all: 19195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50449,
    lat: 43.00129,
    lng: -93.55629,
    city: "Klemme",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 830,
    density: 7.8,
    county_fips: 19081,
    county_name: "Hancock",
    county_weights: {
      19033: 9.88,
      19081: 90.12,
    },
    county_names_all: "Hancock|Cerro Gordo",
    county_fips_all: "19081|19033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50450,
    lat: 43.42045,
    lng: -93.51998,
    city: "Lake Mills",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2890,
    density: 13.2,
    county_fips: 19189,
    county_name: "Winnebago",
    county_weights: {
      19189: 67.63,
      19195: 32.37,
    },
    county_names_all: "Winnebago|Worth",
    county_fips_all: "19189|19195",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50451,
    lat: 43.37746,
    lng: -94.09134,
    city: "Lakota",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 523,
    density: 3.3,
    county_fips: 19109,
    county_name: "Kossuth",
    county_weights: {
      19109: 100,
    },
    county_names_all: "Kossuth",
    county_fips_all: 19109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50452,
    lat: 42.77969,
    lng: -93.37542,
    city: "Latimer",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1121,
    density: 9.1,
    county_fips: 19069,
    county_name: "Franklin",
    county_weights: {
      19069: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 19069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50453,
    lat: 43.3664,
    lng: -93.65258,
    city: "Leland",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 627,
    density: 5.5,
    county_fips: 19189,
    county_name: "Winnebago",
    county_weights: {
      19189: 100,
    },
    county_names_all: "Winnebago",
    county_fips_all: 19189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50454,
    lat: 43.38505,
    lng: -92.73935,
    city: "Little Cedar",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48,
    density: 1.3,
    county_fips: 19131,
    county_name: "Mitchell",
    county_weights: {
      19131: 100,
    },
    county_names_all: "Mitchell",
    county_fips_all: 19131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50455,
    lat: 43.45695,
    lng: -92.64981,
    city: "McIntire",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 506,
    density: 6,
    county_fips: 19131,
    county_name: "Mitchell",
    county_weights: {
      19131: 100,
    },
    county_names_all: "Mitchell",
    county_fips_all: 19131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50456,
    lat: 43.28812,
    lng: -93.21579,
    city: "Manly",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1854,
    density: 14.3,
    county_fips: 19195,
    county_name: "Worth",
    county_weights: {
      19033: 1.83,
      19195: 98.17,
    },
    county_names_all: "Worth|Cerro Gordo",
    county_fips_all: "19195|19033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50457,
    lat: 42.91418,
    lng: -93.4928,
    city: "Meservey",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 438,
    density: 5,
    county_fips: 19081,
    county_name: "Hancock",
    county_weights: {
      19033: 29.67,
      19069: 27.75,
      19081: 30.11,
      19197: 12.48,
    },
    county_names_all: "Hancock|Cerro Gordo|Franklin|Wright",
    county_fips_all: "19081|19033|19069|19197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50458,
    lat: 43.15969,
    lng: -93.00609,
    city: "Nora Springs",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2404,
    density: 13.1,
    county_fips: 19067,
    county_name: "Floyd",
    county_weights: {
      19033: 35.68,
      19067: 53.29,
      19131: 11.03,
    },
    county_names_all: "Floyd|Cerro Gordo|Mitchell",
    county_fips_all: "19067|19033|19131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50459,
    lat: 43.4458,
    lng: -93.25445,
    city: "Northwood",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2967,
    density: 8,
    county_fips: 19195,
    county_name: "Worth",
    county_weights: {
      19189: 0.17,
      19195: 99.83,
    },
    county_names_all: "Worth|Winnebago",
    county_fips_all: "19195|19189",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50460,
    lat: 43.2259,
    lng: -92.6902,
    city: "Orchard",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 357,
    density: 3.9,
    county_fips: 19131,
    county_name: "Mitchell",
    county_weights: {
      19067: 22.2,
      19131: 77.8,
    },
    county_names_all: "Mitchell|Floyd",
    county_fips_all: "19131|19067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50461,
    lat: 43.29995,
    lng: -92.81412,
    city: "Osage",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5488,
    density: 11.9,
    county_fips: 19131,
    county_name: "Mitchell",
    county_weights: {
      19067: 0.16,
      19131: 99.84,
    },
    county_names_all: "Mitchell|Floyd",
    county_fips_all: "19131|19067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50464,
    lat: 43.25146,
    lng: -93.0765,
    city: "Plymouth",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 601,
    density: 9.4,
    county_fips: 19033,
    county_name: "Cerro Gordo",
    county_weights: {
      19033: 54.98,
      19131: 2.66,
      19195: 42.36,
    },
    county_names_all: "Cerro Gordo|Worth|Mitchell",
    county_fips_all: "19033|19195|19131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50465,
    lat: 43.48703,
    lng: -93.91056,
    city: "Rake",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 153,
    density: 17.8,
    county_fips: 19189,
    county_name: "Winnebago",
    county_weights: {
      19189: 100,
    },
    county_names_all: "Winnebago",
    county_fips_all: 19189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50466,
    lat: 43.38782,
    lng: -92.53815,
    city: "Riceville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1921,
    density: 5.3,
    county_fips: 19089,
    county_name: "Howard",
    county_weights: {
      19089: 60.36,
      19131: 39.64,
    },
    county_names_all: "Howard|Mitchell",
    county_fips_all: "19089|19131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50467,
    lat: 43.20916,
    lng: -93.06608,
    city: "Rock Falls",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19033,
    county_name: "Cerro Gordo",
    county_weights: {
      19033: 100,
    },
    county_names_all: "Cerro Gordo",
    county_fips_all: 19033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50468,
    lat: 43.04631,
    lng: -92.95703,
    city: "Rockford",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1304,
    density: 5.1,
    county_fips: 19067,
    county_name: "Floyd",
    county_weights: {
      19033: 24.75,
      19067: 75.25,
    },
    county_names_all: "Floyd|Cerro Gordo",
    county_fips_all: "19067|19033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50469,
    lat: 42.99922,
    lng: -93.19767,
    city: "Rockwell",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1540,
    density: 6.9,
    county_fips: 19033,
    county_name: "Cerro Gordo",
    county_weights: {
      19033: 100,
    },
    county_names_all: "Cerro Gordo",
    county_fips_all: 19033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50470,
    lat: 42.74652,
    lng: -93.55374,
    city: "Rowan",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 219,
    density: 3.6,
    county_fips: 19197,
    county_name: "Wright",
    county_weights: {
      19069: 3.55,
      19197: 96.45,
    },
    county_names_all: "Wright|Franklin",
    county_fips_all: "19197|19069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50471,
    lat: 43.16486,
    lng: -92.87834,
    city: "Rudd",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 648,
    density: 5.8,
    county_fips: 19067,
    county_name: "Floyd",
    county_weights: {
      19067: 93.99,
      19131: 6.01,
    },
    county_names_all: "Floyd|Mitchell",
    county_fips_all: "19067|19131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50472,
    lat: 43.42265,
    lng: -92.94644,
    city: "Saint Ansgar",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2398,
    density: 7.5,
    county_fips: 19131,
    county_name: "Mitchell",
    county_weights: {
      19131: 84.8,
      19195: 15.2,
    },
    county_names_all: "Mitchell|Worth",
    county_fips_all: "19131|19195",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50473,
    lat: 43.46402,
    lng: -93.67429,
    city: "Scarville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 213,
    density: 2.4,
    county_fips: 19189,
    county_name: "Winnebago",
    county_weights: {
      19189: 100,
    },
    county_names_all: "Winnebago",
    county_fips_all: 19189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50475,
    lat: 42.87902,
    lng: -93.21852,
    city: "Sheffield",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1411,
    density: 5.7,
    county_fips: 19069,
    county_name: "Franklin",
    county_weights: {
      19033: 23.19,
      19069: 76.81,
    },
    county_names_all: "Franklin|Cerro Gordo",
    county_fips_all: "19069|19033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50476,
    lat: 43.4527,
    lng: -92.76311,
    city: "Stacyville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 668,
    density: 6.7,
    county_fips: 19131,
    county_name: "Mitchell",
    county_weights: {
      19131: 100,
    },
    county_names_all: "Mitchell",
    county_fips_all: 19131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50477,
    lat: 42.98743,
    lng: -93.32731,
    city: "Swaledale",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 306,
    density: 6.3,
    county_fips: 19033,
    county_name: "Cerro Gordo",
    county_weights: {
      19033: 100,
    },
    county_names_all: "Cerro Gordo",
    county_fips_all: 19033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50478,
    lat: 43.40377,
    lng: -93.78448,
    city: "Thompson",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 709,
    density: 3.6,
    county_fips: 19189,
    county_name: "Winnebago",
    county_weights: {
      19189: 100,
    },
    county_names_all: "Winnebago",
    county_fips_all: 19189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50479,
    lat: 42.94121,
    lng: -93.4082,
    city: "Thornton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 644,
    density: 4.3,
    county_fips: 19033,
    county_name: "Cerro Gordo",
    county_weights: {
      19033: 72.51,
      19069: 27.49,
    },
    county_names_all: "Cerro Gordo|Franklin",
    county_fips_all: "19033|19069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50480,
    lat: 43.25097,
    lng: -94.05272,
    city: "Titonka",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 840,
    density: 5.1,
    county_fips: 19109,
    county_name: "Kossuth",
    county_weights: {
      19081: 2.2,
      19109: 96.66,
      19189: 1.14,
    },
    county_names_all: "Kossuth|Hancock|Winnebago",
    county_fips_all: "19109|19081|19189",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50482,
    lat: 43.12356,
    lng: -93.48167,
    city: "Ventura",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 750,
    density: 9.7,
    county_fips: 19033,
    county_name: "Cerro Gordo",
    county_weights: {
      19033: 79.05,
      19081: 20.95,
    },
    county_names_all: "Cerro Gordo|Hancock",
    county_fips_all: "19033|19081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50483,
    lat: 43.11174,
    lng: -93.99719,
    city: "Wesley",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 738,
    density: 3.5,
    county_fips: 19109,
    county_name: "Kossuth",
    county_weights: {
      19081: 29.43,
      19109: 70.57,
    },
    county_names_all: "Kossuth|Hancock",
    county_fips_all: "19109|19081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50484,
    lat: 43.23609,
    lng: -93.91084,
    city: "Woden",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 357,
    density: 3.2,
    county_fips: 19081,
    county_name: "Hancock",
    county_weights: {
      19081: 64.65,
      19109: 2.33,
      19189: 33.02,
    },
    county_names_all: "Hancock|Winnebago|Kossuth",
    county_fips_all: "19081|19189|19109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50501,
    lat: 42.49244,
    lng: -94.18967,
    city: "Fort Dodge",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27881,
    density: 70.7,
    county_fips: 19187,
    county_name: "Webster",
    county_weights: {
      19187: 100,
    },
    county_names_all: "Webster",
    county_fips_all: 19187,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50510,
    lat: 42.76084,
    lng: -94.98216,
    city: "Albert City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 994,
    density: 4.4,
    county_fips: 19021,
    county_name: "Buena Vista",
    county_weights: {
      19021: 84.19,
      19151: 15.81,
    },
    county_names_all: "Buena Vista|Pocahontas",
    county_fips_all: "19021|19151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50511,
    lat: 43.07483,
    lng: -94.21894,
    city: "Algona",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6819,
    density: 20.3,
    county_fips: 19109,
    county_name: "Kossuth",
    county_weights: {
      19109: 100,
    },
    county_names_all: "Kossuth",
    county_fips_all: 19109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50514,
    lat: 43.41374,
    lng: -94.47361,
    city: "Armstrong",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1287,
    density: 4.4,
    county_fips: 19063,
    county_name: "Emmet",
    county_weights: {
      19063: 64.73,
      19109: 35.27,
    },
    county_names_all: "Emmet|Kossuth",
    county_fips_all: "19063|19109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50515,
    lat: 43.01993,
    lng: -94.87812,
    city: "Ayrshire",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 209,
    density: 2.1,
    county_fips: 19147,
    county_name: "Palo Alto",
    county_weights: {
      19041: 23.27,
      19147: 76.73,
    },
    county_names_all: "Palo Alto|Clay",
    county_fips_all: "19147|19041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50516,
    lat: 42.62566,
    lng: -94.13545,
    city: "Badger",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 578,
    density: 8.6,
    county_fips: 19187,
    county_name: "Webster",
    county_weights: {
      19091: 23.58,
      19187: 76.42,
    },
    county_names_all: "Webster|Humboldt",
    county_fips_all: "19187|19091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50517,
    lat: 43.30099,
    lng: -94.23452,
    city: "Bancroft",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1079,
    density: 5.5,
    county_fips: 19109,
    county_name: "Kossuth",
    county_weights: {
      19109: 100,
    },
    county_names_all: "Kossuth",
    county_fips_all: 19109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50518,
    lat: 42.51212,
    lng: -94.38241,
    city: "Barnum",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 446,
    density: 6,
    county_fips: 19187,
    county_name: "Webster",
    county_weights: {
      19187: 100,
    },
    county_names_all: "Webster",
    county_fips_all: 19187,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50519,
    lat: 42.90314,
    lng: -94.26542,
    city: "Bode",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 660,
    density: 4.7,
    county_fips: 19091,
    county_name: "Humboldt",
    county_weights: {
      19091: 54.98,
      19109: 45.02,
    },
    county_names_all: "Humboldt|Kossuth",
    county_fips_all: "19091|19109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50520,
    lat: 42.80524,
    lng: -94.39772,
    city: "Bradgate",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 175,
    density: 3,
    county_fips: 19091,
    county_name: "Humboldt",
    county_weights: {
      19091: 93.43,
      19151: 6.57,
    },
    county_names_all: "Humboldt|Pocahontas",
    county_fips_all: "19091|19151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50521,
    lat: 42.3462,
    lng: -94.10276,
    city: "Burnside",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 77,
    density: 24.4,
    county_fips: 19187,
    county_name: "Webster",
    county_weights: {
      19187: 100,
    },
    county_names_all: "Webster",
    county_fips_all: 19187,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50522,
    lat: 43.18562,
    lng: -94.18576,
    city: "Burt",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 978,
    density: 5.7,
    county_fips: 19109,
    county_name: "Kossuth",
    county_weights: {
      19109: 100,
    },
    county_names_all: "Kossuth",
    county_fips_all: 19109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50523,
    lat: 42.36783,
    lng: -94.29357,
    city: "Callender",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 561,
    density: 5.2,
    county_fips: 19187,
    county_name: "Webster",
    county_weights: {
      19187: 100,
    },
    county_names_all: "Webster",
    county_fips_all: 19187,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50524,
    lat: 42.59992,
    lng: -94.35799,
    city: "Clare",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 582,
    density: 3.9,
    county_fips: 19187,
    county_name: "Webster",
    county_weights: {
      19151: 4.31,
      19187: 95.69,
    },
    county_names_all: "Webster|Pocahontas",
    county_fips_all: "19187|19151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50525,
    lat: 42.73875,
    lng: -93.74907,
    city: "Clarion",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3440,
    density: 9.8,
    county_fips: 19197,
    county_name: "Wright",
    county_weights: {
      19197: 100,
    },
    county_names_all: "Wright",
    county_fips_all: 19197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50527,
    lat: 42.96899,
    lng: -94.79288,
    city: "Curlew",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 178,
    density: 1.4,
    county_fips: 19147,
    county_name: "Palo Alto",
    county_weights: {
      19147: 100,
    },
    county_names_all: "Palo Alto",
    county_fips_all: 19147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50528,
    lat: 43.13717,
    lng: -94.54023,
    city: "Cylinder",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 364,
    density: 1.9,
    county_fips: 19147,
    county_name: "Palo Alto",
    county_weights: {
      19147: 100,
    },
    county_names_all: "Palo Alto",
    county_fips_all: 19147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50529,
    lat: 42.72216,
    lng: -94.20101,
    city: "Dakota City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 751,
    density: 571.7,
    county_fips: 19091,
    county_name: "Humboldt",
    county_weights: {
      19091: 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: 19091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50530,
    lat: 42.27021,
    lng: -94.04173,
    city: "Dayton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1220,
    density: 7.5,
    county_fips: 19187,
    county_name: "Webster",
    county_weights: {
      19015: 3.99,
      19187: 96.01,
    },
    county_names_all: "Webster|Boone",
    county_fips_all: "19187|19015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50531,
    lat: 43.45841,
    lng: -94.61417,
    city: "Dolliver",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 212,
    density: 2.1,
    county_fips: 19063,
    county_name: "Emmet",
    county_weights: {
      19063: 100,
    },
    county_names_all: "Emmet",
    county_fips_all: 19063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50532,
    lat: 42.46212,
    lng: -94.00175,
    city: "Duncombe",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 863,
    density: 4.4,
    county_fips: 19187,
    county_name: "Webster",
    county_weights: {
      19079: 9.83,
      19187: 90.17,
    },
    county_names_all: "Webster|Hamilton",
    county_fips_all: "19187|19079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50533,
    lat: 42.65251,
    lng: -93.91109,
    city: "Eagle Grove",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4051,
    density: 16,
    county_fips: 19197,
    county_name: "Wright",
    county_weights: {
      19091: 11.07,
      19187: 9.36,
      19197: 79.57,
    },
    county_names_all: "Wright|Humboldt|Webster",
    county_fips_all: "19197|19091|19187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50535,
    lat: 42.45138,
    lng: -95.16167,
    city: "Early",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1021,
    density: 6.3,
    county_fips: 19161,
    county_name: "Sac",
    county_weights: {
      19161: 100,
    },
    county_names_all: "Sac",
    county_fips_all: 19161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50536,
    lat: 43.11605,
    lng: -94.69716,
    city: "Emmetsburg",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4286,
    density: 11.6,
    county_fips: 19147,
    county_name: "Palo Alto",
    county_weights: {
      19147: 100,
    },
    county_names_all: "Palo Alto",
    county_fips_all: 19147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50538,
    lat: 42.28422,
    lng: -94.43024,
    city: "Farnhamville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 479,
    density: 5.2,
    county_fips: 19025,
    county_name: "Calhoun",
    county_weights: {
      19025: 93.03,
      19187: 6.97,
    },
    county_names_all: "Calhoun|Webster",
    county_fips_all: "19025|19187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50539,
    lat: 43.23543,
    lng: -94.41849,
    city: "Fenton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 454,
    density: 3.1,
    county_fips: 19109,
    county_name: "Kossuth",
    county_weights: {
      19109: 77.73,
      19147: 22.27,
    },
    county_names_all: "Kossuth|Palo Alto",
    county_fips_all: "19109|19147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50540,
    lat: 42.60019,
    lng: -94.8407,
    city: "Fonda",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1054,
    density: 3.8,
    county_fips: 19151,
    county_name: "Pocahontas",
    county_weights: {
      19025: 24.9,
      19151: 72.51,
      19161: 2.59,
    },
    county_names_all: "Pocahontas|Calhoun|Sac",
    county_fips_all: "19151|19025|19161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50541,
    lat: 42.71569,
    lng: -94.44715,
    city: "Gilmore City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 938,
    density: 4,
    county_fips: 19151,
    county_name: "Pocahontas",
    county_weights: {
      19091: 47.14,
      19151: 52.86,
    },
    county_names_all: "Pocahontas|Humboldt",
    county_fips_all: "19151|19091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50542,
    lat: 42.7794,
    lng: -93.94594,
    city: "Goldfield",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 873,
    density: 5.1,
    county_fips: 19197,
    county_name: "Wright",
    county_weights: {
      19091: 31.46,
      19197: 68.54,
    },
    county_names_all: "Wright|Humboldt",
    county_fips_all: "19197|19091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50543,
    lat: 42.27434,
    lng: -94.30666,
    city: "Gowrie",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1404,
    density: 6.8,
    county_fips: 19187,
    county_name: "Webster",
    county_weights: {
      19187: 100,
    },
    county_names_all: "Webster",
    county_fips_all: 19187,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50544,
    lat: 42.2537,
    lng: -94.17042,
    city: "Harcourt",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 573,
    density: 7,
    county_fips: 19187,
    county_name: "Webster",
    county_weights: {
      19187: 100,
    },
    county_names_all: "Webster",
    county_fips_all: 19187,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50545,
    lat: 42.79651,
    lng: -94.08111,
    city: "Hardy",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 166,
    density: 1.8,
    county_fips: 19091,
    county_name: "Humboldt",
    county_weights: {
      19091: 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: 19091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50546,
    lat: 42.84388,
    lng: -94.70347,
    city: "Havelock",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 327,
    density: 2.4,
    county_fips: 19151,
    county_name: "Pocahontas",
    county_weights: {
      19147: 4.75,
      19151: 95.25,
    },
    county_names_all: "Pocahontas|Palo Alto",
    county_fips_all: "19151|19147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50548,
    lat: 42.71275,
    lng: -94.22645,
    city: "Humboldt",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5458,
    density: 17,
    county_fips: 19091,
    county_name: "Humboldt",
    county_weights: {
      19091: 92.37,
      19187: 7.63,
    },
    county_names_all: "Humboldt|Webster",
    county_fips_all: "19091|19187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50551,
    lat: 42.48242,
    lng: -94.75484,
    city: "Jolley",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 90,
    density: 1.3,
    county_fips: 19025,
    county_name: "Calhoun",
    county_weights: {
      19025: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 19025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50552,
    lat: 42.45638,
    lng: -94.46068,
    city: "Knierim",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19025,
    county_name: "Calhoun",
    county_weights: {
      19025: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 19025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50554,
    lat: 42.84648,
    lng: -94.84118,
    city: "Laurens",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1581,
    density: 6.6,
    county_fips: 19151,
    county_name: "Pocahontas",
    county_weights: {
      19021: 3.59,
      19147: 11.88,
      19151: 84.53,
    },
    county_names_all: "Pocahontas|Palo Alto|Buena Vista",
    county_fips_all: "19151|19147|19021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50556,
    lat: 43.45276,
    lng: -94.20114,
    city: "Ledyard",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 187,
    density: 1.9,
    county_fips: 19109,
    county_name: "Kossuth",
    county_weights: {
      19109: 100,
    },
    county_names_all: "Kossuth",
    county_fips_all: 19109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50557,
    lat: 42.35544,
    lng: -94.04409,
    city: "Lehigh",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 740,
    density: 6,
    county_fips: 19187,
    county_name: "Webster",
    county_weights: {
      19187: 100,
    },
    county_names_all: "Webster",
    county_fips_all: 19187,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50558,
    lat: 42.86717,
    lng: -94.16607,
    city: "Livermore",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 728,
    density: 5.7,
    county_fips: 19091,
    county_name: "Humboldt",
    county_weights: {
      19091: 82.87,
      19109: 17.13,
    },
    county_names_all: "Humboldt|Kossuth",
    county_fips_all: "19091|19109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50559,
    lat: 43.20912,
    lng: -94.32477,
    city: "Lone Rock",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 359,
    density: 3.9,
    county_fips: 19109,
    county_name: "Kossuth",
    county_weights: {
      19109: 100,
    },
    county_names_all: "Kossuth",
    county_fips_all: 19109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50560,
    lat: 42.95581,
    lng: -94.1043,
    city: "Lu Verne",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 586,
    density: 2.9,
    county_fips: 19109,
    county_name: "Kossuth",
    county_weights: {
      19091: 14.64,
      19109: 85.36,
    },
    county_names_all: "Kossuth|Humboldt",
    county_fips_all: "19109|19091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50561,
    lat: 42.42122,
    lng: -94.84794,
    city: "Lytton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 535,
    density: 4.3,
    county_fips: 19025,
    county_name: "Calhoun",
    county_weights: {
      19025: 57.65,
      19161: 42.35,
    },
    county_names_all: "Calhoun|Sac",
    county_fips_all: "19025|19161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50562,
    lat: 42.96158,
    lng: -94.64173,
    city: "Mallard",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 355,
    density: 2.2,
    county_fips: 19147,
    county_name: "Palo Alto",
    county_weights: {
      19147: 92.87,
      19151: 7.13,
    },
    county_names_all: "Palo Alto|Pocahontas",
    county_fips_all: "19147|19151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50563,
    lat: 42.52802,
    lng: -94.52515,
    city: "Manson",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2524,
    density: 9.6,
    county_fips: 19025,
    county_name: "Calhoun",
    county_weights: {
      19025: 68.99,
      19151: 26.24,
      19187: 4.77,
    },
    county_names_all: "Calhoun|Pocahontas|Webster",
    county_fips_all: "19025|19151|19187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50565,
    lat: 42.86118,
    lng: -94.99698,
    city: "Marathon",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 369,
    density: 3.3,
    county_fips: 19021,
    county_name: "Buena Vista",
    county_weights: {
      19021: 95.37,
      19041: 4.63,
    },
    county_names_all: "Buena Vista|Clay",
    county_fips_all: "19021|19041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50566,
    lat: 42.43925,
    lng: -94.32889,
    city: "Moorland",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 422,
    density: 4.5,
    county_fips: 19187,
    county_name: "Webster",
    county_weights: {
      19025: 3.27,
      19187: 96.73,
    },
    county_names_all: "Webster|Calhoun",
    county_fips_all: "19187|19025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50567,
    lat: 42.52146,
    lng: -95.08935,
    city: "Nemaha",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 256,
    density: 3.2,
    county_fips: 19161,
    county_name: "Sac",
    county_weights: {
      19161: 100,
    },
    county_names_all: "Sac",
    county_fips_all: 19161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50568,
    lat: 42.62171,
    lng: -94.99395,
    city: "Newell",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1380,
    density: 6.5,
    county_fips: 19021,
    county_name: "Buena Vista",
    county_weights: {
      19021: 88.26,
      19161: 11.74,
    },
    county_names_all: "Buena Vista|Sac",
    county_fips_all: "19021|19161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50569,
    lat: 42.4032,
    lng: -94.13841,
    city: "Otho",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 645,
    density: 11.9,
    county_fips: 19187,
    county_name: "Webster",
    county_weights: {
      19187: 100,
    },
    county_names_all: "Webster",
    county_fips_all: 19187,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50570,
    lat: 42.89359,
    lng: -94.36585,
    city: "Ottosen",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 211,
    density: 1.9,
    county_fips: 19091,
    county_name: "Humboldt",
    county_weights: {
      19091: 64.16,
      19109: 35.84,
    },
    county_names_all: "Humboldt|Kossuth",
    county_fips_all: "19091|19109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50571,
    lat: 42.63485,
    lng: -94.5806,
    city: "Palmer",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 285,
    density: 2.3,
    county_fips: 19151,
    county_name: "Pocahontas",
    county_weights: {
      19151: 100,
    },
    county_names_all: "Pocahontas",
    county_fips_all: 19151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50573,
    lat: 42.8768,
    lng: -94.62255,
    city: "Plover",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 97,
    density: 88,
    county_fips: 19151,
    county_name: "Pocahontas",
    county_weights: {
      19151: 100,
    },
    county_names_all: "Pocahontas",
    county_fips_all: 19151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50574,
    lat: 42.71891,
    lng: -94.69967,
    city: "Pocahontas",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1946,
    density: 6.9,
    county_fips: 19151,
    county_name: "Pocahontas",
    county_weights: {
      19151: 100,
    },
    county_names_all: "Pocahontas",
    county_fips_all: 19151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50575,
    lat: 42.5588,
    lng: -94.70065,
    city: "Pomeroy",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 743,
    density: 4.6,
    county_fips: 19025,
    county_name: "Calhoun",
    county_weights: {
      19025: 53.1,
      19151: 46.9,
    },
    county_names_all: "Calhoun|Pocahontas",
    county_fips_all: "19025|19151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50576,
    lat: 42.80267,
    lng: -95.17727,
    city: "Rembrandt",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 287,
    density: 3.1,
    county_fips: 19021,
    county_name: "Buena Vista",
    county_weights: {
      19021: 100,
    },
    county_names_all: "Buena Vista",
    county_fips_all: 19021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50577,
    lat: 42.85774,
    lng: -93.97902,
    city: "Renwick",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 352,
    density: 3.5,
    county_fips: 19091,
    county_name: "Humboldt",
    county_weights: {
      19091: 57.19,
      19197: 42.81,
    },
    county_names_all: "Humboldt|Wright",
    county_fips_all: "19091|19197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50578,
    lat: 43.30081,
    lng: -94.54775,
    city: "Ringsted",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 590,
    density: 3.3,
    county_fips: 19063,
    county_name: "Emmet",
    county_weights: {
      19063: 89.49,
      19147: 10.51,
    },
    county_names_all: "Emmet|Palo Alto",
    county_fips_all: "19063|19147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50579,
    lat: 42.39356,
    lng: -94.6345,
    city: "Rockwell City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2729,
    density: 7.5,
    county_fips: 19025,
    county_name: "Calhoun",
    county_weights: {
      19025: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 19025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50581,
    lat: 42.84735,
    lng: -94.54506,
    city: "Rolfe",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 865,
    density: 3.5,
    county_fips: 19151,
    county_name: "Pocahontas",
    county_weights: {
      19147: 8.2,
      19151: 91.8,
    },
    county_names_all: "Pocahontas|Palo Alto",
    county_fips_all: "19151|19147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50582,
    lat: 42.79338,
    lng: -94.30217,
    city: "Rutland",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 248,
    density: 4.5,
    county_fips: 19091,
    county_name: "Humboldt",
    county_weights: {
      19091: 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: 19091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50583,
    lat: 42.43049,
    lng: -94.98595,
    city: "Sac City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2415,
    density: 8.1,
    county_fips: 19161,
    county_name: "Sac",
    county_weights: {
      19025: 2.59,
      19161: 97.41,
    },
    county_names_all: "Sac|Calhoun",
    county_fips_all: "19161|19025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50585,
    lat: 42.91154,
    lng: -95.1407,
    city: "Sioux Rapids",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1303,
    density: 7.5,
    county_fips: 19021,
    county_name: "Buena Vista",
    county_weights: {
      19021: 51.53,
      19041: 48.47,
    },
    county_names_all: "Buena Vista|Clay",
    county_fips_all: "19021|19041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50586,
    lat: 42.40472,
    lng: -94.43204,
    city: "Somers",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 259,
    density: 3.1,
    county_fips: 19025,
    county_name: "Calhoun",
    county_weights: {
      19025: 93.12,
      19187: 6.88,
    },
    county_names_all: "Calhoun|Webster",
    county_fips_all: "19025|19187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50588,
    lat: 42.65777,
    lng: -95.16391,
    city: "Storm Lake",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12695,
    density: 35.3,
    county_fips: 19021,
    county_name: "Buena Vista",
    county_weights: {
      19021: 99.37,
      19161: 0.63,
    },
    county_names_all: "Buena Vista|Sac",
    county_fips_all: "19021|19161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50590,
    lat: 43.40647,
    lng: -94.30303,
    city: "Swea City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 845,
    density: 4,
    county_fips: 19109,
    county_name: "Kossuth",
    county_weights: {
      19109: 100,
    },
    county_names_all: "Kossuth",
    county_fips_all: 19109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50591,
    lat: 42.67683,
    lng: -94.05478,
    city: "Thor",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 472,
    density: 6.2,
    county_fips: 19091,
    county_name: "Humboldt",
    county_weights: {
      19091: 88.11,
      19187: 11.89,
    },
    county_names_all: "Humboldt|Webster",
    county_fips_all: "19091|19187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50592,
    lat: 42.72927,
    lng: -95.18345,
    city: "Truesdale",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19021,
    county_name: "Buena Vista",
    county_weights: {
      19021: 100,
    },
    county_names_all: "Buena Vista",
    county_fips_all: 19021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50593,
    lat: 42.65796,
    lng: -94.89832,
    city: "Varina",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32,
    density: 65.3,
    county_fips: 19151,
    county_name: "Pocahontas",
    county_weights: {
      19151: 100,
    },
    county_names_all: "Pocahontas",
    county_fips_all: 19151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50594,
    lat: 42.58561,
    lng: -94.03949,
    city: "Vincent",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 166,
    density: 2.4,
    county_fips: 19187,
    county_name: "Webster",
    county_weights: {
      19187: 100,
    },
    county_names_all: "Webster",
    county_fips_all: 19187,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50595,
    lat: 42.46097,
    lng: -93.82154,
    city: "Webster City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8875,
    density: 22.3,
    county_fips: 19079,
    county_name: "Hamilton",
    county_weights: {
      19079: 97.92,
      19187: 0.67,
      19197: 1.41,
    },
    county_names_all: "Hamilton|Wright|Webster",
    county_fips_all: "19079|19197|19187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50597,
    lat: 42.97379,
    lng: -94.45048,
    city: "West Bend",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1038,
    density: 4.8,
    county_fips: 19147,
    county_name: "Palo Alto",
    county_weights: {
      19091: 1.34,
      19109: 42.19,
      19147: 55.54,
      19151: 0.93,
    },
    county_names_all: "Palo Alto|Kossuth|Humboldt|Pocahontas",
    county_fips_all: "19147|19109|19091|19151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50598,
    lat: 43.08023,
    lng: -94.41841,
    city: "Whittemore",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1015,
    density: 5.7,
    county_fips: 19109,
    county_name: "Kossuth",
    county_weights: {
      19109: 70,
      19147: 30,
    },
    county_names_all: "Kossuth|Palo Alto",
    county_fips_all: "19109|19147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50599,
    lat: 42.58089,
    lng: -93.81471,
    city: "Woolstock",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 444,
    density: 3.5,
    county_fips: 19197,
    county_name: "Wright",
    county_weights: {
      19079: 16.32,
      19197: 83.68,
    },
    county_names_all: "Wright|Hamilton",
    county_fips_all: "19197|19079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50601,
    lat: 42.56612,
    lng: -93.05665,
    city: "Ackley",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2571,
    density: 7.1,
    county_fips: 19069,
    county_name: "Franklin",
    county_weights: {
      19023: 17.74,
      19069: 36.48,
      19075: 15.97,
      19083: 29.82,
    },
    county_names_all: "Franklin|Hardin|Butler|Grundy",
    county_fips_all: "19069|19083|19023|19075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50602,
    lat: 42.74036,
    lng: -92.80581,
    city: "Allison",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1545,
    density: 7.6,
    county_fips: 19023,
    county_name: "Butler",
    county_weights: {
      19023: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 19023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50603,
    lat: 43.18893,
    lng: -92.45834,
    city: "Alta Vista",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 418,
    density: 3.6,
    county_fips: 19037,
    county_name: "Chickasaw",
    county_weights: {
      19037: 83.24,
      19089: 16.76,
    },
    county_names_all: "Chickasaw|Howard",
    county_fips_all: "19037|19089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50604,
    lat: 42.60484,
    lng: -92.90299,
    city: "Aplington",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1643,
    density: 8.9,
    county_fips: 19023,
    county_name: "Butler",
    county_weights: {
      19023: 79.53,
      19075: 20.47,
    },
    county_names_all: "Butler|Grundy",
    county_fips_all: "19023|19075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50605,
    lat: 42.83559,
    lng: -93.03276,
    city: "Aredale",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 232,
    density: 5.3,
    county_fips: 19069,
    county_name: "Franklin",
    county_weights: {
      19023: 38.93,
      19069: 61.07,
    },
    county_names_all: "Franklin|Butler",
    county_fips_all: "19069|19023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50606,
    lat: 42.74669,
    lng: -91.68299,
    city: "Arlington",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 893,
    density: 5.1,
    county_fips: 19065,
    county_name: "Fayette",
    county_weights: {
      19043: 4.36,
      19065: 95.64,
    },
    county_names_all: "Fayette|Clayton",
    county_fips_all: "19065|19043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50607,
    lat: 42.60872,
    lng: -91.74747,
    city: "Aurora",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 366,
    density: 3,
    county_fips: 19019,
    county_name: "Buchanan",
    county_weights: {
      19019: 70.37,
      19065: 29.63,
    },
    county_names_all: "Buchanan|Fayette",
    county_fips_all: "19019|19065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50608,
    lat: 42.58815,
    lng: -92.96075,
    city: "Austinville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19023,
    county_name: "Butler",
    county_weights: {
      19023: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 19023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50609,
    lat: 42.23066,
    lng: -92.81046,
    city: "Beaman",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 287,
    density: 3.4,
    county_fips: 19075,
    county_name: "Grundy",
    county_weights: {
      19075: 65.84,
      19127: 30.65,
      19171: 3.51,
    },
    county_names_all: "Grundy|Marshall|Tama",
    county_fips_all: "19075|19127|19171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50611,
    lat: 42.8193,
    lng: -92.91114,
    city: "Bristow",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 340,
    density: 4.1,
    county_fips: 19023,
    county_name: "Butler",
    county_weights: {
      19023: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 19023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50612,
    lat: 42.28546,
    lng: -92.38687,
    city: "Buckingham",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 331,
    density: 4.6,
    county_fips: 19171,
    county_name: "Tama",
    county_weights: {
      19013: 27.4,
      19171: 72.6,
    },
    county_names_all: "Tama|Black Hawk",
    county_fips_all: "19171|19013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50613,
    lat: 42.53358,
    lng: -92.49069,
    city: "Cedar Falls",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43945,
    density: 133,
    county_fips: 19013,
    county_name: "Black Hawk",
    county_weights: {
      19013: 80.92,
      19023: 3.81,
      19075: 15.27,
    },
    county_names_all: "Black Hawk|Grundy|Butler",
    county_fips_all: "19013|19075|19023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50616,
    lat: 43.07978,
    lng: -92.66104,
    city: "Charles City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10031,
    density: 22,
    county_fips: 19067,
    county_name: "Floyd",
    county_weights: {
      19037: 6.28,
      19067: 93.72,
    },
    county_names_all: "Floyd|Chickasaw",
    county_fips_all: "19067|19037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50619,
    lat: 42.79725,
    lng: -92.66266,
    city: "Clarksville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2126,
    density: 9.8,
    county_fips: 19023,
    county_name: "Butler",
    county_weights: {
      19023: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 19023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50620,
    lat: 43.15712,
    lng: -92.5912,
    city: "Colwell",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46,
    density: 122.2,
    county_fips: 19067,
    county_name: "Floyd",
    county_weights: {
      19067: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 19067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50621,
    lat: 42.24738,
    lng: -92.91904,
    city: "Conrad",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1632,
    density: 10,
    county_fips: 19075,
    county_name: "Grundy",
    county_weights: {
      19075: 83.77,
      19127: 16.23,
    },
    county_names_all: "Grundy|Marshall",
    county_fips_all: "19075|19127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50622,
    lat: 42.67358,
    lng: -92.33358,
    city: "Denver",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3067,
    density: 46.2,
    county_fips: 19017,
    county_name: "Bremer",
    county_weights: {
      19017: 100,
    },
    county_names_all: "Bremer",
    county_fips_all: 19017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50623,
    lat: 42.52693,
    lng: -92.20962,
    city: "Dewar",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19013,
    county_name: "Black Hawk",
    county_weights: {
      19013: 100,
    },
    county_names_all: "Black Hawk",
    county_fips_all: 19013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50624,
    lat: 42.46874,
    lng: -92.65879,
    city: "Dike",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1460,
    density: 11,
    county_fips: 19075,
    county_name: "Grundy",
    county_weights: {
      19075: 100,
    },
    county_names_all: "Grundy",
    county_fips_all: 19075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50625,
    lat: 42.75071,
    lng: -92.98691,
    city: "Dumont",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1023,
    density: 6.5,
    county_fips: 19023,
    county_name: "Butler",
    county_weights: {
      19023: 82.78,
      19069: 17.22,
    },
    county_names_all: "Butler|Franklin",
    county_fips_all: "19023|19069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50626,
    lat: 42.58028,
    lng: -92.17049,
    city: "Dunkerton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1660,
    density: 12.7,
    county_fips: 19013,
    county_name: "Black Hawk",
    county_weights: {
      19013: 99.58,
      19019: 0.42,
    },
    county_names_all: "Black Hawk|Buchanan",
    county_fips_all: "19013|19019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50627,
    lat: 42.34982,
    lng: -93.095,
    city: "Eldora",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3165,
    density: 11.6,
    county_fips: 19083,
    county_name: "Hardin",
    county_weights: {
      19075: 17.27,
      19083: 82.73,
    },
    county_names_all: "Hardin|Grundy",
    county_fips_all: "19083|19075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50628,
    lat: 43.26655,
    lng: -92.39134,
    city: "Elma",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1136,
    density: 3.9,
    county_fips: 19089,
    county_name: "Howard",
    county_weights: {
      19089: 93.05,
      19131: 6.95,
    },
    county_names_all: "Howard|Mitchell",
    county_fips_all: "19089|19131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50629,
    lat: 42.64222,
    lng: -92.081,
    city: "Fairbank",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2645,
    density: 13.6,
    county_fips: 19019,
    county_name: "Buchanan",
    county_weights: {
      19013: 16.34,
      19017: 29.43,
      19019: 32.25,
      19065: 21.97,
    },
    county_names_all: "Buchanan|Bremer|Fayette|Black Hawk",
    county_fips_all: "19019|19017|19065|19013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50630,
    lat: 42.95651,
    lng: -92.21346,
    city: "Fredericksburg",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1576,
    density: 7.2,
    county_fips: 19037,
    county_name: "Chickasaw",
    county_weights: {
      19017: 10.31,
      19037: 89.69,
    },
    county_names_all: "Chickasaw|Bremer",
    county_fips_all: "19037|19017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50631,
    lat: 42.88254,
    lng: -92.30929,
    city: "Frederika",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19017,
    county_name: "Bremer",
    county_weights: {
      19017: 100,
    },
    county_names_all: "Bremer",
    county_fips_all: 19017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50632,
    lat: 42.07667,
    lng: -92.70299,
    city: "Garwin",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1227,
    density: 11.2,
    county_fips: 19171,
    county_name: "Tama",
    county_weights: {
      19127: 1.32,
      19171: 98.68,
    },
    county_names_all: "Tama|Marshall",
    county_fips_all: "19171|19127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50633,
    lat: 42.67203,
    lng: -93.12664,
    city: "Geneva",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 446,
    density: 4.1,
    county_fips: 19069,
    county_name: "Franklin",
    county_weights: {
      19069: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 19069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50634,
    lat: 42.4181,
    lng: -92.21422,
    city: "Gilbertville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 771,
    density: 831.6,
    county_fips: 19013,
    county_name: "Black Hawk",
    county_weights: {
      19013: 100,
    },
    county_names_all: "Black Hawk",
    county_fips_all: 19013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50635,
    lat: 42.19886,
    lng: -92.69896,
    city: "Gladbrook",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1445,
    density: 6.7,
    county_fips: 19171,
    county_name: "Tama",
    county_weights: {
      19127: 4.04,
      19171: 95.96,
    },
    county_names_all: "Tama|Marshall",
    county_fips_all: "19171|19127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50636,
    lat: 42.89439,
    lng: -92.80745,
    city: "Greene",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1868,
    density: 6.2,
    county_fips: 19023,
    county_name: "Butler",
    county_weights: {
      19023: 62.25,
      19067: 37.75,
    },
    county_names_all: "Butler|Floyd",
    county_fips_all: "19023|19067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50638,
    lat: 42.35654,
    lng: -92.79495,
    city: "Grundy Center",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3307,
    density: 13.6,
    county_fips: 19075,
    county_name: "Grundy",
    county_weights: {
      19075: 100,
    },
    county_names_all: "Grundy",
    county_fips_all: 19075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50641,
    lat: 42.59746,
    lng: -91.91961,
    city: "Hazleton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1358,
    density: 11.6,
    county_fips: 19019,
    county_name: "Buchanan",
    county_weights: {
      19019: 100,
    },
    county_names_all: "Buchanan",
    county_fips_all: 19019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50642,
    lat: 42.44024,
    lng: -92.81243,
    city: "Holland",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 636,
    density: 7.8,
    county_fips: 19075,
    county_name: "Grundy",
    county_weights: {
      19075: 100,
    },
    county_names_all: "Grundy",
    county_fips_all: 19075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50643,
    lat: 42.36413,
    lng: -92.47402,
    city: "Hudson",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2847,
    density: 19.1,
    county_fips: 19013,
    county_name: "Black Hawk",
    county_weights: {
      19013: 90.66,
      19075: 9.34,
    },
    county_names_all: "Black Hawk|Grundy",
    county_fips_all: "19013|19075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50644,
    lat: 42.47751,
    lng: -91.89721,
    city: "Independence",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8863,
    density: 23.6,
    county_fips: 19019,
    county_name: "Buchanan",
    county_weights: {
      19019: 100,
    },
    county_names_all: "Buchanan",
    county_fips_all: 19019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50645,
    lat: 43.02174,
    lng: -92.44952,
    city: "Ionia",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1108,
    density: 5,
    county_fips: 19037,
    county_name: "Chickasaw",
    county_weights: {
      19017: 6.81,
      19037: 90.25,
      19067: 2.94,
    },
    county_names_all: "Chickasaw|Bremer|Floyd",
    county_fips_all: "19037|19017|19067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50647,
    lat: 42.64787,
    lng: -92.48026,
    city: "Janesville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2403,
    density: 30.5,
    county_fips: 19017,
    county_name: "Bremer",
    county_weights: {
      19013: 38.3,
      19017: 61.7,
    },
    county_names_all: "Bremer|Black Hawk",
    county_fips_all: "19017|19013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50648,
    lat: 42.45182,
    lng: -92.09465,
    city: "Jesup",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4223,
    density: 19.6,
    county_fips: 19013,
    county_name: "Black Hawk",
    county_weights: {
      19013: 58.35,
      19019: 41.65,
    },
    county_names_all: "Black Hawk|Buchanan",
    county_fips_all: "19013|19019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50649,
    lat: 42.66249,
    lng: -92.90973,
    city: "Kesley",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19023,
    county_name: "Butler",
    county_weights: {
      19023: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 19023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50650,
    lat: 42.61915,
    lng: -91.65429,
    city: "Lamont",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 792,
    density: 7.5,
    county_fips: 19019,
    county_name: "Buchanan",
    county_weights: {
      19019: 69.12,
      19065: 30.88,
    },
    county_names_all: "Buchanan|Fayette",
    county_fips_all: "19019|19065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50651,
    lat: 42.32271,
    lng: -92.19993,
    city: "La Porte City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3657,
    density: 12.3,
    county_fips: 19013,
    county_name: "Black Hawk",
    county_weights: {
      19011: 25.54,
      19013: 71.71,
      19171: 2.75,
    },
    county_names_all: "Black Hawk|Benton|Tama",
    county_fips_all: "19013|19011|19171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50652,
    lat: 42.26454,
    lng: -92.69234,
    city: "Lincoln",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 90,
    density: 93.1,
    county_fips: 19171,
    county_name: "Tama",
    county_weights: {
      19171: 100,
    },
    county_names_all: "Tama",
    county_fips_all: 19171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50653,
    lat: 42.96737,
    lng: -92.88927,
    city: "Marble Rock",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 713,
    density: 5.3,
    county_fips: 19067,
    county_name: "Floyd",
    county_weights: {
      19067: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 19067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50654,
    lat: 42.45812,
    lng: -91.60933,
    city: "Masonville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 405,
    density: 2.9,
    county_fips: 19019,
    county_name: "Buchanan",
    county_weights: {
      19019: 52.07,
      19055: 47.93,
    },
    county_names_all: "Buchanan|Delaware",
    county_fips_all: "19019|19055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50655,
    lat: 42.77232,
    lng: -91.9016,
    city: "Maynard",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 856,
    density: 9.2,
    county_fips: 19065,
    county_name: "Fayette",
    county_weights: {
      19065: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 19065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50657,
    lat: 42.34454,
    lng: -92.67399,
    city: "Morrison",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19075,
    county_name: "Grundy",
    county_weights: {
      19075: 100,
    },
    county_names_all: "Grundy",
    county_fips_all: 19075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50658,
    lat: 42.95024,
    lng: -92.53782,
    city: "Nashua",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2247,
    density: 11.1,
    county_fips: 19037,
    county_name: "Chickasaw",
    county_weights: {
      19017: 4.15,
      19023: 6.53,
      19037: 55.66,
      19067: 33.66,
    },
    county_names_all: "Chickasaw|Floyd|Butler|Bremer",
    county_fips_all: "19037|19067|19023|19017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50659,
    lat: 43.08749,
    lng: -92.3221,
    city: "New Hampton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5929,
    density: 15,
    county_fips: 19037,
    county_name: "Chickasaw",
    county_weights: {
      19037: 100,
    },
    county_names_all: "Chickasaw",
    county_fips_all: 19037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50660,
    lat: 42.58099,
    lng: -92.63752,
    city: "New Hartford",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1241,
    density: 13.7,
    county_fips: 19023,
    county_name: "Butler",
    county_weights: {
      19023: 78.92,
      19075: 21.08,
    },
    county_names_all: "Butler|Grundy",
    county_fips_all: "19023|19075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50662,
    lat: 42.68748,
    lng: -91.93396,
    city: "Oelwein",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6432,
    density: 35.3,
    county_fips: 19065,
    county_name: "Fayette",
    county_weights: {
      19019: 6.27,
      19065: 93.73,
    },
    county_names_all: "Fayette|Buchanan",
    county_fips_all: "19065|19019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50664,
    lat: 42.70698,
    lng: -92.07222,
    city: "Oran",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19065,
    county_name: "Fayette",
    county_weights: {
      19065: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 19065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50665,
    lat: 42.58078,
    lng: -92.7717,
    city: "Parkersburg",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2871,
    density: 11.2,
    county_fips: 19023,
    county_name: "Butler",
    county_weights: {
      19023: 64.44,
      19075: 35.56,
    },
    county_names_all: "Butler|Grundy",
    county_fips_all: "19023|19075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50666,
    lat: 42.85995,
    lng: -92.50933,
    city: "Plainfield",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 955,
    density: 7.5,
    county_fips: 19017,
    county_name: "Bremer",
    county_weights: {
      19017: 76.21,
      19023: 23.79,
    },
    county_names_all: "Bremer|Butler",
    county_fips_all: "19017|19023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50667,
    lat: 42.47003,
    lng: -92.22545,
    city: "Raymond",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 818,
    density: 166.1,
    county_fips: 19013,
    county_name: "Black Hawk",
    county_weights: {
      19013: 100,
    },
    county_names_all: "Black Hawk",
    county_fips_all: 19013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50668,
    lat: 42.69087,
    lng: -92.2265,
    city: "Readlyn",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1118,
    density: 12.8,
    county_fips: 19017,
    county_name: "Bremer",
    county_weights: {
      19017: 100,
    },
    county_names_all: "Bremer",
    county_fips_all: 19017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50669,
    lat: 42.33309,
    lng: -92.6124,
    city: "Reinbeck",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2400,
    density: 9.6,
    county_fips: 19075,
    county_name: "Grundy",
    county_weights: {
      19013: 1.03,
      19075: 69.13,
      19171: 29.84,
    },
    county_names_all: "Grundy|Tama|Black Hawk",
    county_fips_all: "19075|19171|19013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50670,
    lat: 42.68425,
    lng: -92.61586,
    city: "Shell Rock",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2278,
    density: 16,
    county_fips: 19023,
    county_name: "Butler",
    county_weights: {
      19013: 0.87,
      19017: 1.92,
      19023: 97.21,
    },
    county_names_all: "Butler|Bremer|Black Hawk",
    county_fips_all: "19023|19017|19013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50671,
    lat: 42.6523,
    lng: -91.7997,
    city: "Stanley",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 208,
    density: 3.7,
    county_fips: 19065,
    county_name: "Fayette",
    county_weights: {
      19019: 39.24,
      19065: 60.76,
    },
    county_names_all: "Fayette|Buchanan",
    county_fips_all: "19065|19019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50672,
    lat: 42.4247,
    lng: -93.06545,
    city: "Steamboat Rock",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 520,
    density: 5.4,
    county_fips: 19083,
    county_name: "Hardin",
    county_weights: {
      19075: 9.33,
      19083: 90.67,
    },
    county_names_all: "Hardin|Grundy",
    county_fips_all: "19083|19075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50673,
    lat: 42.52505,
    lng: -92.7113,
    city: "Stout",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 189,
    density: 433,
    county_fips: 19075,
    county_name: "Grundy",
    county_weights: {
      19075: 100,
    },
    county_names_all: "Grundy",
    county_fips_all: 19075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50674,
    lat: 42.84202,
    lng: -92.11746,
    city: "Sumner",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3861,
    density: 9.4,
    county_fips: 19017,
    county_name: "Bremer",
    county_weights: {
      19017: 61.82,
      19037: 6,
      19065: 32.18,
    },
    county_names_all: "Bremer|Fayette|Chickasaw",
    county_fips_all: "19017|19065|19037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50675,
    lat: 42.19884,
    lng: -92.4928,
    city: "Traer",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2525,
    density: 8.7,
    county_fips: 19171,
    county_name: "Tama",
    county_weights: {
      19013: 2.23,
      19171: 97.77,
    },
    county_names_all: "Tama|Black Hawk",
    county_fips_all: "19171|19013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50676,
    lat: 42.7943,
    lng: -92.27895,
    city: "Tripoli",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2388,
    density: 16.4,
    county_fips: 19017,
    county_name: "Bremer",
    county_weights: {
      19017: 100,
    },
    county_names_all: "Bremer",
    county_fips_all: 19017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50677,
    lat: 42.76363,
    lng: -92.43775,
    city: "Waverly",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12428,
    density: 37.3,
    county_fips: 19017,
    county_name: "Bremer",
    county_weights: {
      19017: 96.97,
      19023: 3.03,
    },
    county_names_all: "Bremer|Butler",
    county_fips_all: "19017|19023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50680,
    lat: 42.44956,
    lng: -92.92505,
    city: "Wellsburg",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1048,
    density: 7,
    county_fips: 19075,
    county_name: "Grundy",
    county_weights: {
      19075: 99.15,
      19083: 0.85,
    },
    county_names_all: "Grundy|Hardin",
    county_fips_all: "19075|19083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50681,
    lat: 42.77754,
    lng: -92.00931,
    city: "Westgate",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 371,
    density: 5.9,
    county_fips: 19065,
    county_name: "Fayette",
    county_weights: {
      19065: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 19065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50682,
    lat: 42.45241,
    lng: -91.69893,
    city: "Winthrop",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1906,
    density: 8.5,
    county_fips: 19019,
    county_name: "Buchanan",
    county_weights: {
      19019: 100,
    },
    county_names_all: "Buchanan",
    county_fips_all: 19019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50701,
    lat: 42.4171,
    lng: -92.34448,
    city: "Waterloo",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30515,
    density: 148.9,
    county_fips: 19013,
    county_name: "Black Hawk",
    county_weights: {
      19013: 100,
    },
    county_names_all: "Black Hawk",
    county_fips_all: 19013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50702,
    lat: 42.45745,
    lng: -92.31283,
    city: "Waterloo",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19833,
    density: 783.3,
    county_fips: 19013,
    county_name: "Black Hawk",
    county_weights: {
      19013: 100,
    },
    county_names_all: "Black Hawk",
    county_fips_all: 19013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50703,
    lat: 42.54817,
    lng: -92.28195,
    city: "Waterloo",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18906,
    density: 78.3,
    county_fips: 19013,
    county_name: "Black Hawk",
    county_weights: {
      19013: 100,
    },
    county_names_all: "Black Hawk",
    county_fips_all: 19013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50707,
    lat: 42.4771,
    lng: -92.27918,
    city: "Evansdale",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8132,
    density: 382.3,
    county_fips: 19013,
    county_name: "Black Hawk",
    county_weights: {
      19013: 100,
    },
    county_names_all: "Black Hawk",
    county_fips_all: 19013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50801,
    lat: 41.07959,
    lng: -94.39224,
    city: "Creston",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9252,
    density: 17.2,
    county_fips: 19175,
    county_name: "Union",
    county_weights: {
      19001: 10.75,
      19003: 20.52,
      19175: 68.73,
    },
    county_names_all: "Union|Adams|Adair",
    county_fips_all: "19175|19003|19001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50830,
    lat: 41.0242,
    lng: -94.19037,
    city: "Afton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1885,
    density: 6,
    county_fips: 19175,
    county_name: "Union",
    county_weights: {
      19175: 100,
    },
    county_names_all: "Union",
    county_fips_all: 19175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50831,
    lat: 40.94938,
    lng: -94.22341,
    city: "Arispe",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19175,
    county_name: "Union",
    county_weights: {
      19175: 100,
    },
    county_names_all: "Union",
    county_fips_all: 19175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50833,
    lat: 40.66956,
    lng: -94.70309,
    city: "Bedford",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2162,
    density: 3.9,
    county_fips: 19173,
    county_name: "Taylor",
    county_weights: {
      19173: 100,
    },
    county_names_all: "Taylor",
    county_fips_all: 19173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50835,
    lat: 40.70769,
    lng: -94.3675,
    city: "Benton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75,
    density: 1.9,
    county_fips: 19159,
    county_name: "Ringgold",
    county_weights: {
      19159: 100,
    },
    county_names_all: "Ringgold",
    county_fips_all: 19159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50836,
    lat: 40.63116,
    lng: -94.49689,
    city: "Blockton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 281,
    density: 1.2,
    county_fips: 19173,
    county_name: "Taylor",
    county_weights: {
      19159: 40.19,
      19173: 59.81,
    },
    county_names_all: "Taylor|Ringgold",
    county_fips_all: "19173|19159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50837,
    lat: 41.22878,
    lng: -94.68367,
    city: "Bridgewater",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 330,
    density: 2.4,
    county_fips: 19001,
    county_name: "Adair",
    county_weights: {
      19001: 70.17,
      19003: 13.39,
      19029: 16.44,
    },
    county_names_all: "Adair|Cass|Adams",
    county_fips_all: "19001|19029|19003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50839,
    lat: 41.04874,
    lng: -94.82206,
    city: "Carbon",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52,
    density: 40,
    county_fips: 19003,
    county_name: "Adams",
    county_weights: {
      19003: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 19003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50840,
    lat: 40.79378,
    lng: -94.48413,
    city: "Clearfield",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 675,
    density: 5.6,
    county_fips: 19173,
    county_name: "Taylor",
    county_weights: {
      19159: 39.5,
      19173: 60.5,
    },
    county_names_all: "Taylor|Ringgold",
    county_fips_all: "19173|19159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50841,
    lat: 41.01147,
    lng: -94.76342,
    city: "Corning",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2393,
    density: 4,
    county_fips: 19003,
    county_name: "Adams",
    county_weights: {
      19003: 89.06,
      19173: 10.94,
    },
    county_names_all: "Adams|Taylor",
    county_fips_all: "19003|19173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50842,
    lat: 41.03991,
    lng: -94.4618,
    city: "Cromwell",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69,
    density: 103.1,
    county_fips: 19175,
    county_name: "Union",
    county_weights: {
      19175: 100,
    },
    county_names_all: "Union",
    county_fips_all: 19175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50843,
    lat: 41.24057,
    lng: -94.88913,
    city: "Cumberland",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 402,
    density: 2.1,
    county_fips: 19029,
    county_name: "Cass",
    county_weights: {
      19003: 7.63,
      19029: 92.37,
    },
    county_names_all: "Cass|Adams",
    county_fips_all: "19029|19003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50845,
    lat: 40.81683,
    lng: -94.3523,
    city: "Diagonal",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 803,
    density: 2.8,
    county_fips: 19159,
    county_name: "Ringgold",
    county_weights: {
      19159: 91.58,
      19175: 8.42,
    },
    county_names_all: "Ringgold|Union",
    county_fips_all: "19159|19175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50846,
    lat: 41.31081,
    lng: -94.56839,
    city: "Fontanelle",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1044,
    density: 4.2,
    county_fips: 19001,
    county_name: "Adair",
    county_weights: {
      19001: 100,
    },
    county_names_all: "Adair",
    county_fips_all: 19001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50847,
    lat: 41.14168,
    lng: -94.98405,
    city: "Grant",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51,
    density: 86.4,
    county_fips: 19137,
    county_name: "Montgomery",
    county_weights: {
      19137: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 19137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50848,
    lat: 40.78685,
    lng: -94.76758,
    city: "Gravity",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 225,
    density: 1.8,
    county_fips: 19173,
    county_name: "Taylor",
    county_weights: {
      19173: 100,
    },
    county_names_all: "Taylor",
    county_fips_all: 19173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50849,
    lat: 41.30004,
    lng: -94.40176,
    city: "Greenfield",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2434,
    density: 8.2,
    county_fips: 19001,
    county_name: "Adair",
    county_weights: {
      19001: 100,
    },
    county_names_all: "Adair",
    county_fips_all: 19001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50851,
    lat: 40.90327,
    lng: -94.53637,
    city: "Lenox",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2100,
    density: 6.1,
    county_fips: 19173,
    county_name: "Taylor",
    county_weights: {
      19003: 34.13,
      19159: 4.4,
      19173: 44.12,
      19175: 17.35,
    },
    county_names_all: "Taylor|Adams|Union|Ringgold",
    county_fips_all: "19173|19003|19175|19159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50853,
    lat: 41.23869,
    lng: -94.77455,
    city: "Massena",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 817,
    density: 4.2,
    county_fips: 19029,
    county_name: "Cass",
    county_weights: {
      19003: 1.91,
      19029: 98.09,
    },
    county_names_all: "Cass|Adams",
    county_fips_all: "19029|19003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50854,
    lat: 40.69089,
    lng: -94.21977,
    city: "Mount Ayr",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2598,
    density: 7.2,
    county_fips: 19159,
    county_name: "Ringgold",
    county_weights: {
      19159: 100,
    },
    county_names_all: "Ringgold",
    county_fips_all: 19159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50857,
    lat: 40.94045,
    lng: -94.88011,
    city: "Nodaway",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 165,
    density: 1.3,
    county_fips: 19003,
    county_name: "Adams",
    county_weights: {
      19003: 72.7,
      19137: 1.41,
      19173: 25.89,
    },
    county_names_all: "Adams|Taylor|Montgomery",
    county_fips_all: "19003|19173|19137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50858,
    lat: 41.20961,
    lng: -94.40902,
    city: "Orient",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 693,
    density: 3.3,
    county_fips: 19001,
    county_name: "Adair",
    county_weights: {
      19001: 100,
    },
    county_names_all: "Adair",
    county_fips_all: 19001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50859,
    lat: 41.06505,
    lng: -94.60027,
    city: "Prescott",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 703,
    density: 3.4,
    county_fips: 19003,
    county_name: "Adams",
    county_weights: {
      19001: 4.62,
      19003: 95.38,
    },
    county_names_all: "Adams|Adair",
    county_fips_all: "19003|19001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50860,
    lat: 40.62253,
    lng: -94.34949,
    city: "Redding",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 135,
    density: 1.3,
    county_fips: 19159,
    county_name: "Ringgold",
    county_weights: {
      19159: 100,
    },
    county_names_all: "Ringgold",
    county_fips_all: 19159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50861,
    lat: 40.91163,
    lng: -94.25685,
    city: "Shannon City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 289,
    density: 2.8,
    county_fips: 19175,
    county_name: "Union",
    county_weights: {
      19159: 31.31,
      19175: 68.69,
    },
    county_names_all: "Union|Ringgold",
    county_fips_all: "19175|19159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50862,
    lat: 40.81304,
    lng: -94.65136,
    city: "Sharpsburg",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 222,
    density: 3.9,
    county_fips: 19173,
    county_name: "Taylor",
    county_weights: {
      19173: 100,
    },
    county_names_all: "Taylor",
    county_fips_all: 19173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50863,
    lat: 40.84701,
    lng: -94.17318,
    city: "Tingley",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 215,
    density: 3,
    county_fips: 19159,
    county_name: "Ringgold",
    county_weights: {
      19159: 100,
    },
    county_names_all: "Ringgold",
    county_fips_all: 19159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 50864,
    lat: 40.97648,
    lng: -94.98009,
    city: "Villisca",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1858,
    density: 4.9,
    county_fips: 19137,
    county_name: "Montgomery",
    county_weights: {
      19003: 3.95,
      19029: 1.72,
      19137: 65.59,
      19145: 19.82,
      19173: 8.92,
    },
    county_names_all: "Montgomery|Page|Taylor|Adams|Cass",
    county_fips_all: "19137|19145|19173|19003|19029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51001,
    lat: 42.83854,
    lng: -96.54551,
    city: "Akron",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2167,
    density: 5.1,
    county_fips: 19149,
    county_name: "Plymouth",
    county_weights: {
      19149: 60.2,
      46127: 39.8,
    },
    county_names_all: "Plymouth|Union",
    county_fips_all: "19149|46127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51002,
    lat: 42.69859,
    lng: -95.31863,
    city: "Alta",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2682,
    density: 9.4,
    county_fips: 19021,
    county_name: "Buena Vista",
    county_weights: {
      19021: 98.62,
      19035: 1.38,
    },
    county_names_all: "Buena Vista|Cherokee",
    county_fips_all: "19021|19035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51003,
    lat: 42.98355,
    lng: -95.98642,
    city: "Alton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1920,
    density: 13.6,
    county_fips: 19167,
    county_name: "Sioux",
    county_weights: {
      19167: 100,
    },
    county_names_all: "Sioux",
    county_fips_all: 19167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51004,
    lat: 42.3762,
    lng: -95.916,
    city: "Anthon",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 865,
    density: 4,
    county_fips: 19193,
    county_name: "Woodbury",
    county_weights: {
      19193: 100,
    },
    county_names_all: "Woodbury",
    county_fips_all: 19193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51005,
    lat: 42.72044,
    lng: -95.42405,
    city: "Aurelia",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1318,
    density: 5.4,
    county_fips: 19035,
    county_name: "Cherokee",
    county_weights: {
      19021: 13.86,
      19035: 86.14,
    },
    county_names_all: "Cherokee|Buena Vista",
    county_fips_all: "19035|19021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51006,
    lat: 42.31088,
    lng: -95.61299,
    city: "Battle Creek",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1176,
    density: 5.8,
    county_fips: 19093,
    county_name: "Ida",
    county_weights: {
      19047: 1.88,
      19093: 85.87,
      19193: 12.25,
    },
    county_names_all: "Ida|Woodbury|Crawford",
    county_fips_all: "19093|19193|19047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51007,
    lat: 42.40225,
    lng: -96.18857,
    city: "Bronson",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 521,
    density: 5.7,
    county_fips: 19193,
    county_name: "Woodbury",
    county_weights: {
      19193: 100,
    },
    county_names_all: "Woodbury",
    county_fips_all: 19193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51008,
    lat: 42.81127,
    lng: -96.26724,
    city: "Brunsville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 140,
    density: 191.8,
    county_fips: 19149,
    county_name: "Plymouth",
    county_weights: {
      19149: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 19149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51009,
    lat: 42.94499,
    lng: -95.55142,
    city: "Calumet",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 147,
    density: 213.1,
    county_fips: 19141,
    county_name: "O'Brien",
    county_weights: {
      19141: 100,
    },
    county_names_all: "O'Brien",
    county_fips_all: 19141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51010,
    lat: 42.09309,
    lng: -95.92044,
    city: "Castana",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 365,
    density: 2,
    county_fips: 19133,
    county_name: "Monona",
    county_weights: {
      19133: 100,
    },
    county_names_all: "Monona",
    county_fips_all: 19133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51011,
    lat: 42.91562,
    lng: -96.51388,
    city: "Chatsworth",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56,
    density: 51.6,
    county_fips: 19167,
    county_name: "Sioux",
    county_weights: {
      19167: 100,
    },
    county_names_all: "Sioux",
    county_fips_all: 19167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51012,
    lat: 42.74474,
    lng: -95.56171,
    city: "Cherokee",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6139,
    density: 16,
    county_fips: 19035,
    county_name: "Cherokee",
    county_weights: {
      19035: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 19035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51014,
    lat: 42.78428,
    lng: -95.71155,
    city: "Cleghorn",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 415,
    density: 2.9,
    county_fips: 19035,
    county_name: "Cherokee",
    county_weights: {
      19035: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 19035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51015,
    lat: 42.33936,
    lng: -96.08107,
    city: "Climbing Hill",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19193,
    county_name: "Woodbury",
    county_weights: {
      19193: 100,
    },
    county_names_all: "Woodbury",
    county_fips_all: 19193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51016,
    lat: 42.46907,
    lng: -95.80113,
    city: "Correctionville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1366,
    density: 5,
    county_fips: 19193,
    county_name: "Woodbury",
    county_weights: {
      19093: 9.51,
      19193: 90.49,
    },
    county_names_all: "Woodbury|Ida",
    county_fips_all: "19193|19093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51018,
    lat: 42.44884,
    lng: -95.67814,
    city: "Cushing",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 570,
    density: 6.7,
    county_fips: 19093,
    county_name: "Ida",
    county_weights: {
      19093: 56.28,
      19193: 43.72,
    },
    county_names_all: "Ida|Woodbury",
    county_fips_all: "19093|19193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51019,
    lat: 42.2721,
    lng: -95.72615,
    city: "Danbury",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 721,
    density: 3.1,
    county_fips: 19193,
    county_name: "Woodbury",
    county_weights: {
      19047: 8.25,
      19093: 11.76,
      19133: 0.76,
      19193: 79.23,
    },
    county_names_all: "Woodbury|Ida|Crawford|Monona",
    county_fips_all: "19193|19093|19047|19133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51020,
    lat: 42.51215,
    lng: -95.41249,
    city: "Galva",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 682,
    density: 4.6,
    county_fips: 19093,
    county_name: "Ida",
    county_weights: {
      19021: 3.63,
      19035: 12.01,
      19093: 71.53,
      19161: 12.83,
    },
    county_names_all: "Ida|Sac|Cherokee|Buena Vista",
    county_fips_all: "19093|19161|19035|19021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51022,
    lat: 42.97819,
    lng: -95.84722,
    city: "Granville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 824,
    density: 4.2,
    county_fips: 19141,
    county_name: "O'Brien",
    county_weights: {
      19141: 58,
      19149: 2.55,
      19167: 39.45,
    },
    county_names_all: "O'Brien|Sioux|Plymouth",
    county_fips_all: "19141|19167|19149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51023,
    lat: 43.00893,
    lng: -96.46845,
    city: "Hawarden",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3536,
    density: 11.4,
    county_fips: 19167,
    county_name: "Sioux",
    county_weights: {
      19167: 70.36,
      46127: 29.64,
    },
    county_names_all: "Sioux|Union",
    county_fips_all: "19167|46127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51024,
    lat: 42.6201,
    lng: -96.26564,
    city: "Hinton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2076,
    density: 9.2,
    county_fips: 19149,
    county_name: "Plymouth",
    county_weights: {
      19149: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 19149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51025,
    lat: 42.4973,
    lng: -95.55853,
    city: "Holstein",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1903,
    density: 6.9,
    county_fips: 19093,
    county_name: "Ida",
    county_weights: {
      19035: 12.66,
      19093: 87.34,
    },
    county_names_all: "Ida|Cherokee",
    county_fips_all: "19093|19035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51026,
    lat: 42.24857,
    lng: -96.07592,
    city: "Hornick",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 970,
    density: 3.4,
    county_fips: 19193,
    county_name: "Woodbury",
    county_weights: {
      19133: 35.26,
      19193: 64.74,
    },
    county_names_all: "Woodbury|Monona",
    county_fips_all: "19193|19133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51027,
    lat: 42.96575,
    lng: -96.32791,
    city: "Ireton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1140,
    density: 4.9,
    county_fips: 19167,
    county_name: "Sioux",
    county_weights: {
      19149: 16.07,
      19167: 83.93,
    },
    county_names_all: "Sioux|Plymouth",
    county_fips_all: "19167|19149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51028,
    lat: 42.59909,
    lng: -95.99199,
    city: "Kingsley",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2231,
    density: 6.9,
    county_fips: 19149,
    county_name: "Plymouth",
    county_weights: {
      19149: 80.04,
      19193: 19.96,
    },
    county_names_all: "Plymouth|Woodbury",
    county_fips_all: "19149|19193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51029,
    lat: 42.88549,
    lng: -95.5414,
    city: "Larrabee",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 290,
    density: 4.2,
    county_fips: 19035,
    county_name: "Cherokee",
    county_weights: {
      19035: 85.16,
      19141: 14.84,
    },
    county_names_all: "Cherokee|O'Brien",
    county_fips_all: "19035|19141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51030,
    lat: 42.49791,
    lng: -96.19365,
    city: "Lawton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1624,
    density: 10.6,
    county_fips: 19193,
    county_name: "Woodbury",
    county_weights: {
      19193: 100,
    },
    county_names_all: "Woodbury",
    county_fips_all: 19193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51031,
    lat: 42.80282,
    lng: -96.18092,
    city: "Le Mars",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12021,
    density: 19.8,
    county_fips: 19149,
    county_name: "Plymouth",
    county_weights: {
      19149: 98.92,
      19167: 1.08,
    },
    county_names_all: "Plymouth|Sioux",
    county_fips_all: "19149|19167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51033,
    lat: 42.91653,
    lng: -95.25324,
    city: "Linn Grove",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 419,
    density: 2.6,
    county_fips: 19041,
    county_name: "Clay",
    county_weights: {
      19021: 49.89,
      19041: 50.11,
    },
    county_names_all: "Clay|Buena Vista",
    county_fips_all: "19041|19021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51034,
    lat: 42.16241,
    lng: -95.78947,
    city: "Mapleton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1621,
    density: 5.4,
    county_fips: 19133,
    county_name: "Monona",
    county_weights: {
      19047: 3.81,
      19133: 80.43,
      19193: 15.76,
    },
    county_names_all: "Monona|Woodbury|Crawford",
    county_fips_all: "19133|19193|19047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51035,
    lat: 42.78086,
    lng: -95.80054,
    city: "Marcus",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1688,
    density: 6.1,
    county_fips: 19035,
    county_name: "Cherokee",
    county_weights: {
      19035: 99.04,
      19149: 0.96,
    },
    county_names_all: "Cherokee|Plymouth",
    county_fips_all: "19035|19149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51036,
    lat: 42.97074,
    lng: -96.18938,
    city: "Maurice",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 805,
    density: 7.3,
    county_fips: 19167,
    county_name: "Sioux",
    county_weights: {
      19167: 100,
    },
    county_names_all: "Sioux",
    county_fips_all: 19167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51037,
    lat: 42.82567,
    lng: -95.64269,
    city: "Meriden",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 332,
    density: 5.4,
    county_fips: 19035,
    county_name: "Cherokee",
    county_weights: {
      19035: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 19035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51038,
    lat: 42.7056,
    lng: -96.31569,
    city: "Merrill",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1831,
    density: 7.9,
    county_fips: 19149,
    county_name: "Plymouth",
    county_weights: {
      19149: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 19149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51039,
    lat: 42.45655,
    lng: -96.05381,
    city: "Moville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2800,
    density: 12.5,
    county_fips: 19193,
    county_name: "Woodbury",
    county_weights: {
      19193: 100,
    },
    county_names_all: "Woodbury",
    county_fips_all: 19193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51040,
    lat: 42.03073,
    lng: -96.0706,
    city: "Onawa",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3458,
    density: 10.3,
    county_fips: 19133,
    county_name: "Monona",
    county_weights: {
      19133: 100,
    },
    county_names_all: "Monona",
    county_fips_all: 19133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51041,
    lat: 43.02443,
    lng: -96.07701,
    city: "Orange City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7070,
    density: 38.5,
    county_fips: 19167,
    county_name: "Sioux",
    county_weights: {
      19167: 100,
    },
    county_names_all: "Sioux",
    county_fips_all: 19167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51044,
    lat: 42.30113,
    lng: -95.91716,
    city: "Oto",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 332,
    density: 3.8,
    county_fips: 19193,
    county_name: "Woodbury",
    county_weights: {
      19193: 100,
    },
    county_names_all: "Woodbury",
    county_fips_all: 19193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51045,
    lat: 42.82019,
    lng: -96.05772,
    city: "Oyens",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19149,
    county_name: "Plymouth",
    county_weights: {
      19149: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 19149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51046,
    lat: 42.96621,
    lng: -95.67949,
    city: "Paullina",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1461,
    density: 6,
    county_fips: 19141,
    county_name: "O'Brien",
    county_weights: {
      19035: 5.4,
      19141: 94.6,
    },
    county_names_all: "O'Brien|Cherokee",
    county_fips_all: "19141|19035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51047,
    lat: 42.93523,
    lng: -95.35752,
    city: "Peterson",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 829,
    density: 4.2,
    county_fips: 19041,
    county_name: "Clay",
    county_weights: {
      19021: 26.54,
      19035: 13.25,
      19041: 55.15,
      19141: 5.06,
    },
    county_names_all: "Clay|Buena Vista|Cherokee|O'Brien",
    county_fips_all: "19041|19021|19035|19141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51048,
    lat: 42.57963,
    lng: -95.86412,
    city: "Pierson",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 558,
    density: 5.8,
    county_fips: 19193,
    county_name: "Woodbury",
    county_weights: {
      19035: 40.09,
      19149: 11.35,
      19193: 48.56,
    },
    county_names_all: "Woodbury|Cherokee|Plymouth",
    county_fips_all: "19193|19035|19149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51049,
    lat: 42.63005,
    lng: -95.64463,
    city: "Quimby",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 512,
    density: 4.4,
    county_fips: 19035,
    county_name: "Cherokee",
    county_weights: {
      19035: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 19035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51050,
    lat: 42.79545,
    lng: -95.94772,
    city: "Remsen",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2763,
    density: 7.6,
    county_fips: 19149,
    county_name: "Plymouth",
    county_weights: {
      19149: 98.55,
      19167: 1.45,
    },
    county_names_all: "Plymouth|Sioux",
    county_fips_all: "19149|19167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51051,
    lat: 42.20443,
    lng: -95.96988,
    city: "Rodney",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 89,
    density: 10.3,
    county_fips: 19133,
    county_name: "Monona",
    county_weights: {
      19133: 100,
    },
    county_names_all: "Monona",
    county_fips_all: 19133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51052,
    lat: 42.31063,
    lng: -96.26343,
    city: "Salix",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1000,
    density: 6.3,
    county_fips: 19193,
    county_name: "Woodbury",
    county_weights: {
      19193: 100,
    },
    county_names_all: "Woodbury",
    county_fips_all: 19193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51053,
    lat: 42.4938,
    lng: -95.28842,
    city: "Schaller",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1078,
    density: 5.6,
    county_fips: 19161,
    county_name: "Sac",
    county_weights: {
      19093: 10.74,
      19161: 89.26,
    },
    county_names_all: "Sac|Ida",
    county_fips_all: "19161|19093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51054,
    lat: 42.37832,
    lng: -96.33159,
    city: "Sergeant Bluff",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5423,
    density: 54.1,
    county_fips: 19193,
    county_name: "Woodbury",
    county_weights: {
      19193: 100,
    },
    county_names_all: "Woodbury",
    county_fips_all: 19193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51055,
    lat: 42.21162,
    lng: -96.26069,
    city: "Sloan",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1290,
    density: 7.9,
    county_fips: 19193,
    county_name: "Woodbury",
    county_weights: {
      19133: 49.02,
      19193: 50.98,
    },
    county_names_all: "Woodbury|Monona",
    county_fips_all: "19193|19133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51056,
    lat: 42.23443,
    lng: -95.95391,
    city: "Smithland",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 461,
    density: 5.3,
    county_fips: 19193,
    county_name: "Woodbury",
    county_weights: {
      19133: 14.76,
      19193: 85.24,
    },
    county_names_all: "Woodbury|Monona",
    county_fips_all: "19193|19133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51058,
    lat: 42.98367,
    lng: -95.46879,
    city: "Sutherland",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 911,
    density: 4.1,
    county_fips: 19141,
    county_name: "O'Brien",
    county_weights: {
      19035: 6.19,
      19041: 1.19,
      19141: 92.62,
    },
    county_names_all: "O'Brien|Cherokee|Clay",
    county_fips_all: "19141|19035|19041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51060,
    lat: 42.04189,
    lng: -95.69844,
    city: "Ute",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 535,
    density: 3.5,
    county_fips: 19133,
    county_name: "Monona",
    county_weights: {
      19047: 23.36,
      19133: 76.64,
    },
    county_names_all: "Monona|Crawford",
    county_fips_all: "19133|19047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51061,
    lat: 42.57983,
    lng: -95.72036,
    city: "Washta",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 440,
    density: 3.5,
    county_fips: 19035,
    county_name: "Cherokee",
    county_weights: {
      19035: 79.44,
      19093: 20.56,
    },
    county_names_all: "Cherokee|Ida",
    county_fips_all: "19035|19093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51062,
    lat: 42.70623,
    lng: -96.53511,
    city: "Westfield",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 389,
    density: 2.7,
    county_fips: 19149,
    county_name: "Plymouth",
    county_weights: {
      19149: 100,
    },
    county_names_all: "Plymouth",
    county_fips_all: 19149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51063,
    lat: 42.13103,
    lng: -96.18611,
    city: "Whiting",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1082,
    density: 5.7,
    county_fips: 19133,
    county_name: "Monona",
    county_weights: {
      19133: 100,
    },
    county_names_all: "Monona",
    county_fips_all: 19133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51101,
    lat: 42.49413,
    lng: -96.39361,
    city: "Sioux City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 685,
    density: 219.8,
    county_fips: 19193,
    county_name: "Woodbury",
    county_weights: {
      19193: 100,
    },
    county_names_all: "Woodbury",
    county_fips_all: 19193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51103,
    lat: 42.52173,
    lng: -96.44642,
    city: "Sioux City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16784,
    density: 537.2,
    county_fips: 19193,
    county_name: "Woodbury",
    county_weights: {
      19193: 100,
    },
    county_names_all: "Woodbury",
    county_fips_all: 19193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51104,
    lat: 42.53518,
    lng: -96.40389,
    city: "Sioux City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22066,
    density: 1139.7,
    county_fips: 19193,
    county_name: "Woodbury",
    county_weights: {
      19193: 100,
    },
    county_names_all: "Woodbury",
    county_fips_all: 19193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51105,
    lat: 42.50808,
    lng: -96.3671,
    city: "Sioux City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10690,
    density: 693.5,
    county_fips: 19193,
    county_name: "Woodbury",
    county_weights: {
      19193: 100,
    },
    county_names_all: "Woodbury",
    county_fips_all: 19193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51106,
    lat: 42.46292,
    lng: -96.32,
    city: "Sioux City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26494,
    density: 305.4,
    county_fips: 19193,
    county_name: "Woodbury",
    county_weights: {
      19193: 100,
    },
    county_names_all: "Woodbury",
    county_fips_all: 19193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51108,
    lat: 42.56625,
    lng: -96.34858,
    city: "Sioux City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5961,
    density: 50,
    county_fips: 19149,
    county_name: "Plymouth",
    county_weights: {
      19149: 53.25,
      19193: 46.75,
    },
    county_names_all: "Plymouth|Woodbury",
    county_fips_all: "19149|19193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51109,
    lat: 42.59873,
    lng: -96.47804,
    city: "Sioux City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3218,
    density: 70.6,
    county_fips: 19149,
    county_name: "Plymouth",
    county_weights: {
      19149: 88.97,
      19193: 11.03,
    },
    county_names_all: "Plymouth|Woodbury",
    county_fips_all: "19149|19193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51111,
    lat: 42.41129,
    lng: -96.38606,
    city: "Sioux City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 123,
    density: 7.8,
    county_fips: 19193,
    county_name: "Woodbury",
    county_weights: {
      19193: 100,
    },
    county_names_all: "Woodbury",
    county_fips_all: 19193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51201,
    lat: 43.18331,
    lng: -95.8657,
    city: "Sheldon",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5900,
    density: 19.7,
    county_fips: 19167,
    county_name: "Sioux",
    county_weights: {
      19119: 2.2,
      19141: 48.64,
      19167: 49.16,
    },
    county_names_all: "Sioux|O'Brien|Lyon",
    county_fips_all: "19167|19141|19119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51230,
    lat: 43.3562,
    lng: -96.32217,
    city: "Alvord",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 367,
    density: 6,
    county_fips: 19119,
    county_name: "Lyon",
    county_weights: {
      19119: 100,
    },
    county_names_all: "Lyon",
    county_fips_all: 19119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51231,
    lat: 43.10567,
    lng: -95.74131,
    city: "Archer",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 583,
    density: 9.3,
    county_fips: 19141,
    county_name: "O'Brien",
    county_weights: {
      19141: 100,
    },
    county_names_all: "O'Brien",
    county_fips_all: 19141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51232,
    lat: 43.30097,
    lng: -95.8162,
    city: "Ashton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 738,
    density: 4.7,
    county_fips: 19143,
    county_name: "Osceola",
    county_weights: {
      19119: 25.68,
      19141: 1.59,
      19143: 72.73,
    },
    county_names_all: "Osceola|Lyon|O'Brien",
    county_fips_all: "19143|19119|19141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51234,
    lat: 43.19412,
    lng: -96.01992,
    city: "Boyden",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1235,
    density: 9.6,
    county_fips: 19167,
    county_name: "Sioux",
    county_weights: {
      19167: 100,
    },
    county_names_all: "Sioux",
    county_fips_all: 19167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51235,
    lat: 43.29488,
    lng: -96.21531,
    city: "Doon",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1147,
    density: 8.3,
    county_fips: 19119,
    county_name: "Lyon",
    county_weights: {
      19119: 96.88,
      19167: 3.12,
    },
    county_names_all: "Lyon|Sioux",
    county_fips_all: "19119|19167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51237,
    lat: 43.33885,
    lng: -96.0005,
    city: "George",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1541,
    density: 6.1,
    county_fips: 19119,
    county_name: "Lyon",
    county_weights: {
      19119: 100,
    },
    county_names_all: "Lyon",
    county_fips_all: 19119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51238,
    lat: 43.0758,
    lng: -95.89071,
    city: "Hospers",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1185,
    density: 9.3,
    county_fips: 19167,
    county_name: "Sioux",
    county_weights: {
      19141: 32.32,
      19167: 67.68,
    },
    county_names_all: "Sioux|O'Brien",
    county_fips_all: "19167|19141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51239,
    lat: 43.20238,
    lng: -96.14522,
    city: "Hull",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2967,
    density: 17.1,
    county_fips: 19167,
    county_name: "Sioux",
    county_weights: {
      19119: 7.31,
      19167: 92.69,
    },
    county_names_all: "Sioux|Lyon",
    county_fips_all: "19167|19119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51240,
    lat: 43.30986,
    lng: -96.45727,
    city: "Inwood",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2172,
    density: 8.4,
    county_fips: 19119,
    county_name: "Lyon",
    county_weights: {
      19119: 85.42,
      19167: 14.58,
    },
    county_names_all: "Lyon|Sioux",
    county_fips_all: "19119|19167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51241,
    lat: 43.44992,
    lng: -96.46001,
    city: "Larchwood",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2025,
    density: 8.7,
    county_fips: 19119,
    county_name: "Lyon",
    county_weights: {
      19119: 100,
    },
    county_names_all: "Lyon",
    county_fips_all: 19119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51242,
    lat: 43.43227,
    lng: -96.33806,
    city: "Lester",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19119,
    county_name: "Lyon",
    county_weights: {
      19119: 100,
    },
    county_names_all: "Lyon",
    county_fips_all: 19119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51243,
    lat: 43.4425,
    lng: -95.90287,
    city: "Little Rock",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 639,
    density: 4.7,
    county_fips: 19119,
    county_name: "Lyon",
    county_weights: {
      19119: 85.94,
      19143: 14.06,
    },
    county_names_all: "Lyon|Osceola",
    county_fips_all: "19119|19143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51244,
    lat: 43.2443,
    lng: -95.93436,
    city: "Matlock",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 114,
    density: 116.4,
    county_fips: 19167,
    county_name: "Sioux",
    county_weights: {
      19167: 100,
    },
    county_names_all: "Sioux",
    county_fips_all: 19167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51245,
    lat: 43.07788,
    lng: -95.60149,
    city: "Primghar",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1389,
    density: 6.9,
    county_fips: 19141,
    county_name: "O'Brien",
    county_weights: {
      19141: 100,
    },
    county_names_all: "O'Brien",
    county_fips_all: 19141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51246,
    lat: 43.42764,
    lng: -96.16564,
    city: "Rock Rapids",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3853,
    density: 9.2,
    county_fips: 19119,
    county_name: "Lyon",
    county_weights: {
      19119: 100,
    },
    county_names_all: "Lyon",
    county_fips_all: 19119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51247,
    lat: 43.19259,
    lng: -96.33723,
    city: "Rock Valley",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4905,
    density: 16.8,
    county_fips: 19167,
    county_name: "Sioux",
    county_weights: {
      19119: 4.54,
      19167: 95.46,
    },
    county_names_all: "Sioux|Lyon",
    county_fips_all: "19167|19119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51248,
    lat: 43.20445,
    lng: -95.65911,
    city: "Sanborn",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1689,
    density: 8.2,
    county_fips: 19141,
    county_name: "O'Brien",
    county_weights: {
      19141: 89.83,
      19143: 10.17,
    },
    county_names_all: "O'Brien|Osceola",
    county_fips_all: "19141|19143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51249,
    lat: 43.41068,
    lng: -95.73203,
    city: "Sibley",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3186,
    density: 9.7,
    county_fips: 19143,
    county_name: "Osceola",
    county_weights: {
      19143: 100,
    },
    county_names_all: "Osceola",
    county_fips_all: 19143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51250,
    lat: 43.08437,
    lng: -96.21232,
    city: "Sioux Center",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9032,
    density: 47.6,
    county_fips: 19167,
    county_name: "Sioux",
    county_weights: {
      19167: 100,
    },
    county_names_all: "Sioux",
    county_fips_all: 19167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51301,
    lat: 43.15314,
    lng: -95.14973,
    city: "Spencer",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12161,
    density: 29.8,
    county_fips: 19041,
    county_name: "Clay",
    county_weights: {
      19041: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 19041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51331,
    lat: 43.36431,
    lng: -95.13028,
    city: "Arnolds Park",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 976,
    density: 234.8,
    county_fips: 19059,
    county_name: "Dickinson",
    county_weights: {
      19059: 100,
    },
    county_names_all: "Dickinson",
    county_fips_all: 19059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51333,
    lat: 43.1324,
    lng: -95.00437,
    city: "Dickens",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 436,
    density: 2.8,
    county_fips: 19041,
    county_name: "Clay",
    county_weights: {
      19041: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 19041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51334,
    lat: 43.40379,
    lng: -94.80698,
    city: "Estherville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6875,
    density: 14.3,
    county_fips: 19063,
    county_name: "Emmet",
    county_weights: {
      19059: 10.96,
      19063: 89.04,
    },
    county_names_all: "Emmet|Dickinson",
    county_fips_all: "19063|19059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51338,
    lat: 43.2065,
    lng: -95.32378,
    city: "Everly",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 938,
    density: 5,
    county_fips: 19041,
    county_name: "Clay",
    county_weights: {
      19041: 79.17,
      19059: 20.83,
    },
    county_names_all: "Clay|Dickinson",
    county_fips_all: "19041|19059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51340,
    lat: 43.2404,
    lng: -95.15613,
    city: "Fostoria",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19041,
    county_name: "Clay",
    county_weights: {
      19041: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 19041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51341,
    lat: 43.01665,
    lng: -95.04132,
    city: "Gillett Grove",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26,
    density: 29.5,
    county_fips: 19041,
    county_name: "Clay",
    county_weights: {
      19041: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 19041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51342,
    lat: 43.24359,
    lng: -94.73832,
    city: "Graettinger",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1471,
    density: 7.1,
    county_fips: 19147,
    county_name: "Palo Alto",
    county_weights: {
      19063: 34.03,
      19147: 65.97,
    },
    county_names_all: "Palo Alto|Emmet",
    county_fips_all: "19147|19063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51343,
    lat: 43.01804,
    lng: -95.11445,
    city: "Greenville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 287,
    density: 3.9,
    county_fips: 19041,
    county_name: "Clay",
    county_weights: {
      19041: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 19041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51345,
    lat: 43.4181,
    lng: -95.43209,
    city: "Harris",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 451,
    density: 3,
    county_fips: 19143,
    county_name: "Osceola",
    county_weights: {
      19059: 2.73,
      19143: 97.27,
    },
    county_names_all: "Osceola|Dickinson",
    county_fips_all: "19143|19059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51346,
    lat: 43.18638,
    lng: -95.45927,
    city: "Hartley",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2108,
    density: 5.6,
    county_fips: 19141,
    county_name: "O'Brien",
    county_weights: {
      19041: 8.19,
      19141: 71.4,
      19143: 20.41,
    },
    county_names_all: "O'Brien|Osceola|Clay",
    county_fips_all: "19141|19143|19041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51347,
    lat: 43.42547,
    lng: -95.31363,
    city: "Lake Park",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1515,
    density: 7.2,
    county_fips: 19059,
    county_name: "Dickinson",
    county_weights: {
      19059: 100,
    },
    county_names_all: "Dickinson",
    county_fips_all: 19059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51350,
    lat: 43.30752,
    lng: -95.59827,
    city: "Melvin",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 486,
    density: 4.2,
    county_fips: 19143,
    county_name: "Osceola",
    county_weights: {
      19141: 6.6,
      19143: 93.4,
    },
    county_names_all: "Osceola|O'Brien",
    county_fips_all: "19143|19141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51351,
    lat: 43.31656,
    lng: -95.18626,
    city: "Milford",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4577,
    density: 16.4,
    county_fips: 19059,
    county_name: "Dickinson",
    county_weights: {
      19059: 100,
    },
    county_names_all: "Dickinson",
    county_fips_all: 19059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51354,
    lat: 43.41267,
    lng: -95.54352,
    city: "Ocheyedan",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1107,
    density: 5,
    county_fips: 19143,
    county_name: "Osceola",
    county_weights: {
      19143: 100,
    },
    county_names_all: "Osceola",
    county_fips_all: 19143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51355,
    lat: 43.38996,
    lng: -95.14082,
    city: "Okoboji",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 951,
    density: 144.6,
    county_fips: 19059,
    county_name: "Dickinson",
    county_weights: {
      19059: 100,
    },
    county_names_all: "Dickinson",
    county_fips_all: 19059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51357,
    lat: 43.06215,
    lng: -95.28762,
    city: "Royal",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 716,
    density: 7.4,
    county_fips: 19041,
    county_name: "Clay",
    county_weights: {
      19041: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 19041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51358,
    lat: 43.13033,
    lng: -94.89579,
    city: "Ruthven",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1364,
    density: 6.6,
    county_fips: 19147,
    county_name: "Palo Alto",
    county_weights: {
      19041: 36.72,
      19147: 63.28,
    },
    county_names_all: "Palo Alto|Clay",
    county_fips_all: "19147|19041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51360,
    lat: 43.43626,
    lng: -95.08556,
    city: "Spirit Lake",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8282,
    density: 30.4,
    county_fips: 19059,
    county_name: "Dickinson",
    county_weights: {
      19059: 97.22,
      27063: 2.78,
    },
    county_names_all: "Dickinson|Jackson",
    county_fips_all: "19059|27063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51363,
    lat: 43.43363,
    lng: -94.94678,
    city: "Superior",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 250,
    density: 227.5,
    county_fips: 19059,
    county_name: "Dickinson",
    county_weights: {
      19059: 100,
    },
    county_names_all: "Dickinson",
    county_fips_all: 19059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51364,
    lat: 43.2993,
    lng: -94.96293,
    city: "Terril",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 869,
    density: 5.3,
    county_fips: 19059,
    county_name: "Dickinson",
    county_weights: {
      19041: 12.83,
      19059: 75.68,
      19063: 11.49,
    },
    county_names_all: "Dickinson|Clay|Emmet",
    county_fips_all: "19059|19041|19063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51365,
    lat: 43.30652,
    lng: -94.7349,
    city: "Wallingford",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 385,
    density: 6.9,
    county_fips: 19063,
    county_name: "Emmet",
    county_weights: {
      19063: 100,
    },
    county_names_all: "Emmet",
    county_fips_all: 19063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51366,
    lat: 42.96008,
    lng: -95.0095,
    city: "Webb",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 336,
    density: 2.1,
    county_fips: 19041,
    county_name: "Clay",
    county_weights: {
      19021: 2.72,
      19041: 97.28,
    },
    county_names_all: "Clay|Buena Vista",
    county_fips_all: "19041|19021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51401,
    lat: 42.06516,
    lng: -94.87068,
    city: "Carroll",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11838,
    density: 27.1,
    county_fips: 19027,
    county_name: "Carroll",
    county_weights: {
      19027: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 19027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51430,
    lat: 42.0869,
    lng: -95.02633,
    city: "Arcadia",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1350,
    density: 13,
    county_fips: 19027,
    county_name: "Carroll",
    county_weights: {
      19027: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 19027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51431,
    lat: 42.34446,
    lng: -95.35146,
    city: "Arthur",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 341,
    density: 3.5,
    county_fips: 19093,
    county_name: "Ida",
    county_weights: {
      19093: 89.04,
      19161: 10.96,
    },
    county_names_all: "Ida|Sac",
    county_fips_all: "19093|19161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51432,
    lat: 41.91009,
    lng: -95.13795,
    city: "Aspinwall",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19047,
    county_name: "Crawford",
    county_weights: {
      19047: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 19047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51433,
    lat: 42.27635,
    lng: -94.87057,
    city: "Auburn",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 643,
    density: 4.4,
    county_fips: 19161,
    county_name: "Sac",
    county_weights: {
      19025: 41.67,
      19161: 58.33,
    },
    county_names_all: "Sac|Calhoun",
    county_fips_all: "19161|19025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51436,
    lat: 42.18254,
    lng: -95.01247,
    city: "Breda",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 924,
    density: 5.9,
    county_fips: 19027,
    county_name: "Carroll",
    county_weights: {
      19027: 68.48,
      19047: 18.37,
      19161: 13.15,
    },
    county_names_all: "Carroll|Crawford|Sac",
    county_fips_all: "19027|19047|19161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51439,
    lat: 42.08298,
    lng: -95.58347,
    city: "Charter Oak",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 943,
    density: 4.2,
    county_fips: 19047,
    county_name: "Crawford",
    county_weights: {
      19047: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 19047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51440,
    lat: 41.9117,
    lng: -94.81379,
    city: "Dedham",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 304,
    density: 4.4,
    county_fips: 19027,
    county_name: "Carroll",
    county_weights: {
      19027: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 19027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51441,
    lat: 42.11784,
    lng: -95.3157,
    city: "Deloit",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 431,
    density: 8.3,
    county_fips: 19047,
    county_name: "Crawford",
    county_weights: {
      19047: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 19047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51442,
    lat: 42.02696,
    lng: -95.35915,
    city: "Denison",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9615,
    density: 23.3,
    county_fips: 19047,
    county_name: "Crawford",
    county_weights: {
      19047: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 19047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51443,
    lat: 42.07748,
    lng: -94.70517,
    city: "Glidden",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1355,
    density: 5.2,
    county_fips: 19027,
    county_name: "Carroll",
    county_weights: {
      19027: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 19027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51444,
    lat: 42.01228,
    lng: -94.97352,
    city: "Halbur",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 250,
    density: 69.6,
    county_fips: 19027,
    county_name: "Carroll",
    county_weights: {
      19027: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 19027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51445,
    lat: 42.32719,
    lng: -95.46724,
    city: "Ida Grove",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2583,
    density: 8,
    county_fips: 19093,
    county_name: "Ida",
    county_weights: {
      19093: 100,
    },
    county_names_all: "Ida",
    county_fips_all: 19093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51446,
    lat: 41.77663,
    lng: -95.19277,
    city: "Irwin",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 570,
    density: 6.2,
    county_fips: 19165,
    county_name: "Shelby",
    county_weights: {
      19165: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 19165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51447,
    lat: 41.72101,
    lng: -95.19196,
    city: "Kirkman",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 210,
    density: 2.2,
    county_fips: 19165,
    county_name: "Shelby",
    county_weights: {
      19165: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 19165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51448,
    lat: 42.20238,
    lng: -95.30839,
    city: "Kiron",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 582,
    density: 3.9,
    county_fips: 19047,
    county_name: "Crawford",
    county_weights: {
      19047: 61.61,
      19093: 18.45,
      19161: 19.94,
    },
    county_names_all: "Crawford|Sac|Ida",
    county_fips_all: "19047|19161|19093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51449,
    lat: 42.26614,
    lng: -94.73475,
    city: "Lake City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2050,
    density: 8.8,
    county_fips: 19025,
    county_name: "Calhoun",
    county_weights: {
      19025: 87.72,
      19027: 12.28,
    },
    county_names_all: "Calhoun|Carroll",
    county_fips_all: "19025|19027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51450,
    lat: 42.31205,
    lng: -95.02722,
    city: "Lake View",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1445,
    density: 9.9,
    county_fips: 19161,
    county_name: "Sac",
    county_weights: {
      19161: 100,
    },
    county_names_all: "Sac",
    county_fips_all: 19161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51451,
    lat: 42.1846,
    lng: -94.69471,
    city: "Lanesboro",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 96,
    density: 98.5,
    county_fips: 19027,
    county_name: "Carroll",
    county_weights: {
      19027: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 19027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51452,
    lat: 42.12242,
    lng: -94.78366,
    city: "Lidderdale",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19027,
    county_name: "Carroll",
    county_weights: {
      19027: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 19027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51453,
    lat: 42.26366,
    lng: -94.55155,
    city: "Lohrville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 607,
    density: 3,
    county_fips: 19025,
    county_name: "Calhoun",
    county_weights: {
      19025: 90.65,
      19027: 8.13,
      19073: 1.22,
    },
    county_names_all: "Calhoun|Carroll|Greene",
    county_fips_all: "19025|19027|19073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51454,
    lat: 41.8798,
    lng: -95.2072,
    city: "Manilla",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1421,
    density: 5.7,
    county_fips: 19047,
    county_name: "Crawford",
    county_weights: {
      19047: 57.58,
      19165: 42.42,
    },
    county_names_all: "Crawford|Shelby",
    county_fips_all: "19047|19165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51455,
    lat: 41.90829,
    lng: -95.0559,
    city: "Manning",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2223,
    density: 7.6,
    county_fips: 19027,
    county_name: "Carroll",
    county_weights: {
      19009: 18.23,
      19027: 55.78,
      19047: 23.48,
      19165: 2.51,
    },
    county_names_all: "Carroll|Crawford|Audubon|Shelby",
    county_fips_all: "19027|19047|19009|19165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51458,
    lat: 42.32141,
    lng: -95.23524,
    city: "Odebolt",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1220,
    density: 4.9,
    county_fips: 19161,
    county_name: "Sac",
    county_weights: {
      19161: 100,
    },
    county_names_all: "Sac",
    county_fips_all: 19161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51459,
    lat: 42.04495,
    lng: -94.63779,
    city: "Ralston",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 90,
    density: 62.9,
    county_fips: 19027,
    county_name: "Carroll",
    county_weights: {
      19027: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 19027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51460,
    lat: 42.1324,
    lng: -95.571,
    city: "Ricketts",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19047,
    county_name: "Crawford",
    county_weights: {
      19047: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 19047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51461,
    lat: 42.172,
    lng: -95.47579,
    city: "Schleswig",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1207,
    density: 8.6,
    county_fips: 19047,
    county_name: "Crawford",
    county_weights: {
      19047: 92.71,
      19093: 7.29,
    },
    county_names_all: "Crawford|Ida",
    county_fips_all: "19047|19093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51462,
    lat: 42.01319,
    lng: -94.55744,
    city: "Scranton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1014,
    density: 3.4,
    county_fips: 19073,
    county_name: "Greene",
    county_weights: {
      19027: 2.59,
      19073: 97.41,
    },
    county_names_all: "Greene|Carroll",
    county_fips_all: "19073|19027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51463,
    lat: 41.90743,
    lng: -94.91265,
    city: "Templeton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 488,
    density: 6.3,
    county_fips: 19027,
    county_name: "Carroll",
    county_weights: {
      19027: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 19027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51465,
    lat: 42.08964,
    lng: -95.19872,
    city: "Vail",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 905,
    density: 5.5,
    county_fips: 19047,
    county_name: "Crawford",
    county_weights: {
      19047: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 19047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51466,
    lat: 42.25302,
    lng: -95.09837,
    city: "Wall Lake",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1303,
    density: 9.6,
    county_fips: 19161,
    county_name: "Sac",
    county_weights: {
      19047: 1.41,
      19161: 98.59,
    },
    county_names_all: "Sac|Crawford",
    county_fips_all: "19161|19047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51467,
    lat: 42.07377,
    lng: -95.10919,
    city: "Westside",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 575,
    density: 3.9,
    county_fips: 19047,
    county_name: "Crawford",
    county_weights: {
      19027: 29.99,
      19047: 70.01,
    },
    county_names_all: "Crawford|Carroll",
    county_fips_all: "19047|19027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51501,
    lat: 41.22828,
    lng: -95.87889,
    city: "Council Bluffs",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35511,
    density: 572.6,
    county_fips: 19155,
    county_name: "Pottawattamie",
    county_weights: {
      19155: 100,
    },
    county_names_all: "Pottawattamie",
    county_fips_all: 19155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51503,
    lat: 41.2304,
    lng: -95.77795,
    city: "Council Bluffs",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36846,
    density: 116.9,
    county_fips: 19155,
    county_name: "Pottawattamie",
    county_weights: {
      19129: 15.5,
      19155: 84.5,
    },
    county_names_all: "Pottawattamie|Mills",
    county_fips_all: "19155|19129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51510,
    lat: 41.28844,
    lng: -95.91715,
    city: "Carter Lake",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3799,
    density: 817.4,
    county_fips: 19155,
    county_name: "Pottawattamie",
    county_weights: {
      19155: 100,
    },
    county_names_all: "Pottawattamie",
    county_fips_all: 19155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51520,
    lat: 41.9692,
    lng: -95.4593,
    city: "Arion",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 233,
    density: 4.2,
    county_fips: 19047,
    county_name: "Crawford",
    county_weights: {
      19047: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 19047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51521,
    lat: 41.47987,
    lng: -95.34526,
    city: "Avoca",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1731,
    density: 7.6,
    county_fips: 19155,
    county_name: "Pottawattamie",
    county_weights: {
      19155: 69.12,
      19165: 30.88,
    },
    county_names_all: "Pottawattamie|Shelby",
    county_fips_all: "19155|19165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51523,
    lat: 41.9122,
    lng: -96.07172,
    city: "Blencoe",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 394,
    density: 3,
    county_fips: 19133,
    county_name: "Monona",
    county_weights: {
      19085: 8.16,
      19133: 91.84,
    },
    county_names_all: "Monona|Harrison",
    county_fips_all: "19133|19085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51525,
    lat: 41.23443,
    lng: -95.41999,
    city: "Carson",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1131,
    density: 7.1,
    county_fips: 19155,
    county_name: "Pottawattamie",
    county_weights: {
      19155: 100,
    },
    county_names_all: "Pottawattamie",
    county_fips_all: 19155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51526,
    lat: 41.37186,
    lng: -95.87818,
    city: "Crescent",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1871,
    density: 16.6,
    county_fips: 19155,
    county_name: "Pottawattamie",
    county_weights: {
      19155: 100,
    },
    county_names_all: "Pottawattamie",
    county_fips_all: 19155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51527,
    lat: 41.82875,
    lng: -95.348,
    city: "Defiance",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 607,
    density: 5.5,
    county_fips: 19165,
    county_name: "Shelby",
    county_weights: {
      19047: 16.72,
      19165: 83.28,
    },
    county_names_all: "Shelby|Crawford",
    county_fips_all: "19165|19047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51528,
    lat: 41.92724,
    lng: -95.50185,
    city: "Dow City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 713,
    density: 3.9,
    county_fips: 19047,
    county_name: "Crawford",
    county_weights: {
      19047: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 19047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51529,
    lat: 41.8618,
    lng: -95.62591,
    city: "Dunlap",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1887,
    density: 5.5,
    county_fips: 19085,
    county_name: "Harrison",
    county_weights: {
      19047: 28.13,
      19085: 38.22,
      19133: 18.18,
      19165: 15.47,
    },
    county_names_all: "Harrison|Crawford|Monona|Shelby",
    county_fips_all: "19085|19047|19133|19165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51530,
    lat: 41.78247,
    lng: -95.42613,
    city: "Earling",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 616,
    density: 4.4,
    county_fips: 19165,
    county_name: "Shelby",
    county_weights: {
      19165: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 19165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51531,
    lat: 41.58751,
    lng: -95.08837,
    city: "Elk Horn",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 732,
    density: 10.4,
    county_fips: 19165,
    county_name: "Shelby",
    county_weights: {
      19009: 21.44,
      19165: 78.56,
    },
    county_names_all: "Shelby|Audubon",
    county_fips_all: "19165|19009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51532,
    lat: 41.13408,
    lng: -95.11167,
    city: "Elliott",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 661,
    density: 4.3,
    county_fips: 19137,
    county_name: "Montgomery",
    county_weights: {
      19029: 2.85,
      19137: 86.25,
      19155: 10.9,
    },
    county_names_all: "Montgomery|Pottawattamie|Cass",
    county_fips_all: "19137|19155|19029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51533,
    lat: 41.03606,
    lng: -95.37933,
    city: "Emerson",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 933,
    density: 4.5,
    county_fips: 19137,
    county_name: "Montgomery",
    county_weights: {
      19129: 45.22,
      19137: 54.78,
    },
    county_names_all: "Montgomery|Mills",
    county_fips_all: "19137|19129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51534,
    lat: 41.04092,
    lng: -95.71853,
    city: "Glenwood",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9498,
    density: 36.5,
    county_fips: 19129,
    county_name: "Mills",
    county_weights: {
      19129: 100,
    },
    county_names_all: "Mills",
    county_fips_all: 19129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51535,
    lat: 41.2264,
    lng: -95.13241,
    city: "Griswold",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1873,
    density: 5.3,
    county_fips: 19029,
    county_name: "Cass",
    county_weights: {
      19029: 56.48,
      19155: 43.52,
    },
    county_names_all: "Cass|Pottawattamie",
    county_fips_all: "19029|19155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51536,
    lat: 41.38385,
    lng: -95.36025,
    city: "Hancock",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 395,
    density: 3,
    county_fips: 19155,
    county_name: "Pottawattamie",
    county_weights: {
      19155: 100,
    },
    county_names_all: "Pottawattamie",
    county_fips_all: 19155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51537,
    lat: 41.64646,
    lng: -95.29531,
    city: "Harlan",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6478,
    density: 15.3,
    county_fips: 19165,
    county_name: "Shelby",
    county_weights: {
      19165: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 19165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51540,
    lat: 41.02488,
    lng: -95.49802,
    city: "Hastings",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 360,
    density: 2.4,
    county_fips: 19129,
    county_name: "Mills",
    county_weights: {
      19129: 100,
    },
    county_names_all: "Mills",
    county_fips_all: 19129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51541,
    lat: 41.13664,
    lng: -95.41623,
    city: "Henderson",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 419,
    density: 3.8,
    county_fips: 19129,
    county_name: "Mills",
    county_weights: {
      19129: 71,
      19137: 15.86,
      19155: 13.14,
    },
    county_names_all: "Mills|Montgomery|Pottawattamie",
    county_fips_all: "19129|19137|19155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51542,
    lat: 41.43354,
    lng: -95.84072,
    city: "Honey Creek",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1062,
    density: 10.8,
    county_fips: 19155,
    county_name: "Pottawattamie",
    county_weights: {
      19155: 100,
    },
    county_names_all: "Pottawattamie",
    county_fips_all: 19155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51543,
    lat: 41.65792,
    lng: -95.07317,
    city: "Kimballton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 419,
    density: 7.4,
    county_fips: 19009,
    county_name: "Audubon",
    county_weights: {
      19009: 69.77,
      19165: 30.23,
    },
    county_names_all: "Audubon|Shelby",
    county_fips_all: "19009|19165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51544,
    lat: 41.31316,
    lng: -95.10817,
    city: "Lewis",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 668,
    density: 5.2,
    county_fips: 19029,
    county_name: "Cass",
    county_weights: {
      19029: 73.98,
      19155: 26.02,
    },
    county_names_all: "Cass|Pottawattamie",
    county_fips_all: "19029|19155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51545,
    lat: 41.83897,
    lng: -96.02072,
    city: "Little Sioux",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 334,
    density: 2.8,
    county_fips: 19085,
    county_name: "Harrison",
    county_weights: {
      19085: 72.66,
      19133: 27.34,
    },
    county_names_all: "Harrison|Monona",
    county_fips_all: "19085|19133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51546,
    lat: 41.6399,
    lng: -95.77209,
    city: "Logan",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2966,
    density: 9.4,
    county_fips: 19085,
    county_name: "Harrison",
    county_weights: {
      19085: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 19085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51548,
    lat: 41.31713,
    lng: -95.63553,
    city: "McClelland",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 500,
    density: 7.2,
    county_fips: 19155,
    county_name: "Pottawattamie",
    county_weights: {
      19155: 100,
    },
    county_names_all: "Pottawattamie",
    county_fips_all: 19155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51549,
    lat: 41.18253,
    lng: -95.45445,
    city: "Macedonia",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 517,
    density: 6.4,
    county_fips: 19155,
    county_name: "Pottawattamie",
    county_weights: {
      19155: 100,
    },
    county_names_all: "Pottawattamie",
    county_fips_all: 19155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51550,
    lat: 41.69203,
    lng: -95.87399,
    city: "Magnolia",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 138,
    density: 98.3,
    county_fips: 19085,
    county_name: "Harrison",
    county_weights: {
      19085: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 19085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51551,
    lat: 40.99129,
    lng: -95.58907,
    city: "Malvern",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1618,
    density: 7.6,
    county_fips: 19129,
    county_name: "Mills",
    county_weights: {
      19129: 100,
    },
    county_names_all: "Mills",
    county_fips_all: 19129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51552,
    lat: 41.48613,
    lng: -95.11439,
    city: "Marne",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 254,
    density: 3.2,
    county_fips: 19029,
    county_name: "Cass",
    county_weights: {
      19029: 63.11,
      19165: 36.89,
    },
    county_names_all: "Cass|Shelby",
    county_fips_all: "19029|19165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51553,
    lat: 41.41577,
    lng: -95.54638,
    city: "Minden",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1035,
    density: 8.8,
    county_fips: 19155,
    county_name: "Pottawattamie",
    county_weights: {
      19155: 100,
    },
    county_names_all: "Pottawattamie",
    county_fips_all: 19155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51554,
    lat: 41.14512,
    lng: -95.68122,
    city: "Mineola",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 220,
    density: 25.6,
    county_fips: 19129,
    county_name: "Mills",
    county_weights: {
      19129: 100,
    },
    county_names_all: "Mills",
    county_fips_all: 19129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51555,
    lat: 41.55937,
    lng: -95.91398,
    city: "Missouri Valley",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4493,
    density: 11.9,
    county_fips: 19085,
    county_name: "Harrison",
    county_weights: {
      19085: 81.15,
      19155: 18.85,
    },
    county_names_all: "Harrison|Pottawattamie",
    county_fips_all: "19085|19155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51556,
    lat: 41.63548,
    lng: -96.04198,
    city: "Modale",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 445,
    density: 3.5,
    county_fips: 19085,
    county_name: "Harrison",
    county_weights: {
      19085: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 19085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51557,
    lat: 41.72903,
    lng: -96.00233,
    city: "Mondamin",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 828,
    density: 4.2,
    county_fips: 19085,
    county_name: "Harrison",
    county_weights: {
      19085: 89.2,
      31021: 10.8,
    },
    county_names_all: "Harrison|Burt",
    county_fips_all: "19085|31021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51558,
    lat: 41.91497,
    lng: -95.87023,
    city: "Moorhead",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 603,
    density: 2.7,
    county_fips: 19133,
    county_name: "Monona",
    county_weights: {
      19085: 9.17,
      19133: 90.83,
    },
    county_names_all: "Monona|Harrison",
    county_fips_all: "19133|19085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51559,
    lat: 41.46034,
    lng: -95.66049,
    city: "Neola",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1820,
    density: 8.2,
    county_fips: 19155,
    county_name: "Pottawattamie",
    county_weights: {
      19085: 15.96,
      19155: 84.04,
    },
    county_names_all: "Pottawattamie|Harrison",
    county_fips_all: "19155|19085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51560,
    lat: 41.31746,
    lng: -95.39838,
    city: "Oakland",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2047,
    density: 8.6,
    county_fips: 19155,
    county_name: "Pottawattamie",
    county_weights: {
      19155: 100,
    },
    county_names_all: "Pottawattamie",
    county_fips_all: 19155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51561,
    lat: 41.00571,
    lng: -95.80992,
    city: "Pacific Junction",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1199,
    density: 8.2,
    county_fips: 19129,
    county_name: "Mills",
    county_weights: {
      19129: 100,
    },
    county_names_all: "Mills",
    county_fips_all: 19129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51562,
    lat: 41.72591,
    lng: -95.50128,
    city: "Panama",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 451,
    density: 5.1,
    county_fips: 19165,
    county_name: "Shelby",
    county_weights: {
      19165: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 19165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51563,
    lat: 41.5769,
    lng: -95.59405,
    city: "Persia",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 738,
    density: 5.3,
    county_fips: 19085,
    county_name: "Harrison",
    county_weights: {
      19085: 99.73,
      19165: 0.27,
    },
    county_names_all: "Harrison|Shelby",
    county_fips_all: "19085|19165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51564,
    lat: 41.81309,
    lng: -95.90801,
    city: "Pisgah",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 364,
    density: 3.8,
    county_fips: 19085,
    county_name: "Harrison",
    county_weights: {
      19085: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 19085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51565,
    lat: 41.64555,
    lng: -95.52391,
    city: "Portsmouth",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 538,
    density: 4.5,
    county_fips: 19165,
    county_name: "Shelby",
    county_weights: {
      19085: 25.95,
      19165: 74.05,
    },
    county_names_all: "Shelby|Harrison",
    county_fips_all: "19165|19085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51566,
    lat: 41.0151,
    lng: -95.22994,
    city: "Red Oak",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6526,
    density: 14.3,
    county_fips: 19137,
    county_name: "Montgomery",
    county_weights: {
      19137: 91.46,
      19145: 6.58,
      19155: 1.96,
    },
    county_names_all: "Montgomery|Page|Pottawattamie",
    county_fips_all: "19137|19145|19155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51570,
    lat: 41.52271,
    lng: -95.46039,
    city: "Shelby",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 930,
    density: 5.7,
    county_fips: 19165,
    county_name: "Shelby",
    county_weights: {
      19085: 13.68,
      19155: 32.9,
      19165: 53.42,
    },
    county_names_all: "Shelby|Pottawattamie|Harrison",
    county_fips_all: "19165|19155|19085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51571,
    lat: 41.14582,
    lng: -95.60994,
    city: "Silver City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 673,
    density: 5.6,
    county_fips: 19129,
    county_name: "Mills",
    county_weights: {
      19129: 66.05,
      19155: 33.95,
    },
    county_names_all: "Mills|Pottawattamie",
    county_fips_all: "19129|19155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51572,
    lat: 41.9896,
    lng: -95.79053,
    city: "Soldier",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 442,
    density: 4.1,
    county_fips: 19133,
    county_name: "Monona",
    county_weights: {
      19133: 100,
    },
    county_names_all: "Monona",
    county_fips_all: 19133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51573,
    lat: 40.97949,
    lng: -95.09451,
    city: "Stanton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1055,
    density: 7,
    county_fips: 19137,
    county_name: "Montgomery",
    county_weights: {
      19137: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 19137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51575,
    lat: 41.24111,
    lng: -95.60218,
    city: "Treynor",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1442,
    density: 11.6,
    county_fips: 19155,
    county_name: "Pottawattamie",
    county_weights: {
      19155: 100,
    },
    county_names_all: "Pottawattamie",
    county_fips_all: 19155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51576,
    lat: 41.3777,
    lng: -95.70945,
    city: "Underwood",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2301,
    density: 19.2,
    county_fips: 19155,
    county_name: "Pottawattamie",
    county_weights: {
      19155: 100,
    },
    county_names_all: "Pottawattamie",
    county_fips_all: 19155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51577,
    lat: 41.4644,
    lng: -95.20296,
    city: "Walnut",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1084,
    density: 5,
    county_fips: 19155,
    county_name: "Pottawattamie",
    county_weights: {
      19029: 2.31,
      19155: 66.46,
      19165: 31.23,
    },
    county_names_all: "Pottawattamie|Shelby|Cass",
    county_fips_all: "19155|19165|19029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51578,
    lat: 41.72002,
    lng: -95.39508,
    city: "Westphalia",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 86,
    density: 483.1,
    county_fips: 19165,
    county_name: "Shelby",
    county_weights: {
      19165: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 19165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51579,
    lat: 41.75171,
    lng: -95.7069,
    city: "Woodbine",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2252,
    density: 7.4,
    county_fips: 19085,
    county_name: "Harrison",
    county_weights: {
      19085: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 19085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51601,
    lat: 40.72938,
    lng: -95.35037,
    city: "Shenandoah",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5680,
    density: 21.2,
    county_fips: 19145,
    county_name: "Page",
    county_weights: {
      19071: 37.28,
      19145: 62.72,
    },
    county_names_all: "Page|Fremont",
    county_fips_all: "19145|19071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51630,
    lat: 40.60101,
    lng: -95.19427,
    city: "Blanchard",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 152,
    density: 2.2,
    county_fips: 19145,
    county_name: "Page",
    county_weights: {
      19145: 100,
    },
    county_names_all: "Page",
    county_fips_all: 19145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51631,
    lat: 40.60267,
    lng: -95.00918,
    city: "Braddyville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 278,
    density: 2.8,
    county_fips: 19145,
    county_name: "Page",
    county_weights: {
      19145: 100,
    },
    county_names_all: "Page",
    county_fips_all: 19145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51632,
    lat: 40.7478,
    lng: -95.04939,
    city: "Clarinda",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6993,
    density: 12.8,
    county_fips: 19145,
    county_name: "Page",
    county_weights: {
      19145: 98.51,
      19173: 1.49,
    },
    county_names_all: "Page|Taylor",
    county_fips_all: "19145|19173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51636,
    lat: 40.66713,
    lng: -95.23519,
    city: "Coin",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 460,
    density: 3.2,
    county_fips: 19145,
    county_name: "Page",
    county_weights: {
      19145: 100,
    },
    county_names_all: "Page",
    county_fips_all: 19145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51637,
    lat: 40.62046,
    lng: -95.11832,
    city: "College Springs",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 249,
    density: 76.8,
    county_fips: 19145,
    county_name: "Page",
    county_weights: {
      19145: 100,
    },
    county_names_all: "Page",
    county_fips_all: 19145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51638,
    lat: 40.83919,
    lng: -95.26663,
    city: "Essex",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1149,
    density: 5.5,
    county_fips: 19145,
    county_name: "Page",
    county_weights: {
      19137: 1.98,
      19145: 98.02,
    },
    county_names_all: "Page|Montgomery",
    county_fips_all: "19145|19137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51639,
    lat: 40.71859,
    lng: -95.47362,
    city: "Farragut",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 758,
    density: 4.3,
    county_fips: 19071,
    county_name: "Fremont",
    county_weights: {
      19071: 100,
    },
    county_names_all: "Fremont",
    county_fips_all: 19071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51640,
    lat: 40.62262,
    lng: -95.6634,
    city: "Hamburg",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1660,
    density: 5.6,
    county_fips: 19071,
    county_name: "Fremont",
    county_weights: {
      19071: 81.66,
      29005: 18.34,
    },
    county_names_all: "Fremont|Atchison",
    county_fips_all: "19071|29005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51645,
    lat: 40.88206,
    lng: -95.4229,
    city: "Imogene",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 213,
    density: 1.8,
    county_fips: 19071,
    county_name: "Fremont",
    county_weights: {
      19071: 57.47,
      19129: 30.08,
      19137: 6.99,
      19145: 5.46,
    },
    county_names_all: "Fremont|Mills|Montgomery|Page",
    county_fips_all: "19071|19129|19137|19145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51646,
    lat: 40.75315,
    lng: -94.8725,
    city: "New Market",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 933,
    density: 6.4,
    county_fips: 19173,
    county_name: "Taylor",
    county_weights: {
      19173: 100,
    },
    county_names_all: "Taylor",
    county_fips_all: 19173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51647,
    lat: 40.60539,
    lng: -95.34509,
    city: "Northboro",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 116,
    density: 1.8,
    county_fips: 19145,
    county_name: "Page",
    county_weights: {
      19071: 24.76,
      19145: 75.24,
    },
    county_names_all: "Page|Fremont",
    county_fips_all: "19145|19071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51648,
    lat: 40.74215,
    lng: -95.80325,
    city: "Percival",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 215,
    density: 1.5,
    county_fips: 19071,
    county_name: "Fremont",
    county_weights: {
      19071: 100,
    },
    county_names_all: "Fremont",
    county_fips_all: 19071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51649,
    lat: 40.8518,
    lng: -95.53565,
    city: "Randolph",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 418,
    density: 3.8,
    county_fips: 19071,
    county_name: "Fremont",
    county_weights: {
      19071: 100,
    },
    county_names_all: "Fremont",
    county_fips_all: 19071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51650,
    lat: 40.673,
    lng: -95.5492,
    city: "Riverton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 282,
    density: 3.5,
    county_fips: 19071,
    county_name: "Fremont",
    county_weights: {
      19071: 100,
    },
    county_names_all: "Fremont",
    county_fips_all: 19071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51651,
    lat: 40.65652,
    lng: -95.03473,
    city: "Shambaugh",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19145,
    county_name: "Page",
    county_weights: {
      19145: 100,
    },
    county_names_all: "Page",
    county_fips_all: 19145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51652,
    lat: 40.77032,
    lng: -95.62815,
    city: "Sidney",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1545,
    density: 8,
    county_fips: 19071,
    county_name: "Fremont",
    county_weights: {
      19071: 100,
    },
    county_names_all: "Fremont",
    county_fips_all: 19071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51653,
    lat: 40.88444,
    lng: -95.67179,
    city: "Tabor",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1484,
    density: 16.3,
    county_fips: 19071,
    county_name: "Fremont",
    county_weights: {
      19071: 74.55,
      19129: 25.45,
    },
    county_names_all: "Fremont|Mills",
    county_fips_all: "19071|19129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51654,
    lat: 40.831,
    lng: -95.76038,
    city: "Thurman",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 387,
    density: 3.2,
    county_fips: 19071,
    county_name: "Fremont",
    county_weights: {
      19071: 100,
    },
    county_names_all: "Fremont",
    county_fips_all: 19071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 51656,
    lat: 40.73527,
    lng: -95.15437,
    city: "Yorktown",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47,
    density: 66.9,
    county_fips: 19145,
    county_name: "Page",
    county_weights: {
      19145: 100,
    },
    county_names_all: "Page",
    county_fips_all: 19145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52001,
    lat: 42.54819,
    lng: -90.69348,
    city: "Dubuque",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42710,
    density: 631.3,
    county_fips: 19061,
    county_name: "Dubuque",
    county_weights: {
      19061: 100,
    },
    county_names_all: "Dubuque",
    county_fips_all: 19061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52002,
    lat: 42.52481,
    lng: -90.77184,
    city: "Dubuque",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17484,
    density: 231.4,
    county_fips: 19061,
    county_name: "Dubuque",
    county_weights: {
      19061: 100,
    },
    county_names_all: "Dubuque",
    county_fips_all: 19061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52003,
    lat: 42.43434,
    lng: -90.67506,
    city: "Dubuque",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13507,
    density: 92.5,
    county_fips: 19061,
    county_name: "Dubuque",
    county_weights: {
      19061: 100,
    },
    county_names_all: "Dubuque",
    county_fips_all: 19061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52030,
    lat: 42.15322,
    lng: -90.59219,
    city: "Andrew",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 451,
    density: 702.2,
    county_fips: 19097,
    county_name: "Jackson",
    county_weights: {
      19097: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 19097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52031,
    lat: 42.24874,
    lng: -90.48922,
    city: "Bellevue",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5298,
    density: 12.3,
    county_fips: 19097,
    county_name: "Jackson",
    county_weights: {
      19061: 5.13,
      19097: 94.87,
    },
    county_names_all: "Jackson|Dubuque",
    county_fips_all: "19097|19061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52032,
    lat: 42.29006,
    lng: -90.84317,
    city: "Bernard",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1519,
    density: 5.7,
    county_fips: 19061,
    county_name: "Dubuque",
    county_weights: {
      19061: 46.96,
      19097: 45.64,
      19105: 7.4,
    },
    county_names_all: "Dubuque|Jackson|Jones",
    county_fips_all: "19061|19097|19105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52033,
    lat: 42.27941,
    lng: -91.00177,
    city: "Cascade",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3242,
    density: 12.7,
    county_fips: 19105,
    county_name: "Jones",
    county_weights: {
      19061: 42.04,
      19105: 57.96,
    },
    county_names_all: "Jones|Dubuque",
    county_fips_all: "19105|19061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52035,
    lat: 42.65996,
    lng: -91.18784,
    city: "Colesburg",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 965,
    density: 7.4,
    county_fips: 19043,
    county_name: "Clayton",
    county_weights: {
      19043: 62.27,
      19055: 37.73,
    },
    county_names_all: "Clayton|Delaware",
    county_fips_all: "19043|19055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52036,
    lat: 42.47285,
    lng: -91.34086,
    city: "Delaware",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19055,
    county_name: "Delaware",
    county_weights: {
      19055: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 19055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52037,
    lat: 41.96712,
    lng: -90.62899,
    city: "Delmar",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 959,
    density: 5.4,
    county_fips: 19045,
    county_name: "Clinton",
    county_weights: {
      19045: 97.77,
      19097: 2.23,
    },
    county_names_all: "Clinton|Jackson",
    county_fips_all: "19045|19097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52038,
    lat: 42.58586,
    lng: -91.55685,
    city: "Dundee",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 537,
    density: 7.7,
    county_fips: 19055,
    county_name: "Delaware",
    county_weights: {
      19055: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 19055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52039,
    lat: 42.53807,
    lng: -90.85745,
    city: "Durango",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 962,
    density: 10.5,
    county_fips: 19061,
    county_name: "Dubuque",
    county_weights: {
      19061: 100,
    },
    county_names_all: "Dubuque",
    county_fips_all: 19061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52040,
    lat: 42.51114,
    lng: -91.13884,
    city: "Dyersville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5553,
    density: 34.6,
    county_fips: 19055,
    county_name: "Delaware",
    county_weights: {
      19055: 53.67,
      19061: 46.33,
    },
    county_names_all: "Delaware|Dubuque",
    county_fips_all: "19055|19061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52041,
    lat: 42.5051,
    lng: -91.25515,
    city: "Earlville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1886,
    density: 12.3,
    county_fips: 19055,
    county_name: "Delaware",
    county_weights: {
      19055: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 19055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52042,
    lat: 42.68098,
    lng: -91.36517,
    city: "Edgewood",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1571,
    density: 10,
    county_fips: 19043,
    county_name: "Clayton",
    county_weights: {
      19043: 81.35,
      19055: 18.65,
    },
    county_names_all: "Clayton|Delaware",
    county_fips_all: "19043|19055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52043,
    lat: 42.84403,
    lng: -91.42201,
    city: "Elkader",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2287,
    density: 9.1,
    county_fips: 19043,
    county_name: "Clayton",
    county_weights: {
      19043: 100,
    },
    county_names_all: "Clayton",
    county_fips_all: 19043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52044,
    lat: 42.76808,
    lng: -91.32328,
    city: "Elkport",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 305,
    density: 9.3,
    county_fips: 19043,
    county_name: "Clayton",
    county_weights: {
      19043: 100,
    },
    county_names_all: "Clayton",
    county_fips_all: 19043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52045,
    lat: 42.45485,
    lng: -90.93113,
    city: "Epworth",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2645,
    density: 21.3,
    county_fips: 19061,
    county_name: "Dubuque",
    county_weights: {
      19061: 100,
    },
    county_names_all: "Dubuque",
    county_fips_all: 19061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52046,
    lat: 42.44024,
    lng: -91.0119,
    city: "Farley",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2655,
    density: 21.2,
    county_fips: 19061,
    county_name: "Dubuque",
    county_weights: {
      19061: 100,
    },
    county_names_all: "Dubuque",
    county_fips_all: 19061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52047,
    lat: 42.96401,
    lng: -91.34301,
    city: "Farmersburg",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 829,
    density: 8.4,
    county_fips: 19043,
    county_name: "Clayton",
    county_weights: {
      19043: 100,
    },
    county_names_all: "Clayton",
    county_fips_all: 19043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52048,
    lat: 42.73735,
    lng: -91.25584,
    city: "Garber",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 320,
    density: 3.5,
    county_fips: 19043,
    county_name: "Clayton",
    county_weights: {
      19043: 100,
    },
    county_names_all: "Clayton",
    county_fips_all: 19043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52049,
    lat: 42.8823,
    lng: -91.20521,
    city: "Garnavillo",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1237,
    density: 7.1,
    county_fips: 19043,
    county_name: "Clayton",
    county_weights: {
      19043: 100,
    },
    county_names_all: "Clayton",
    county_fips_all: 19043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52050,
    lat: 42.60532,
    lng: -91.33204,
    city: "Greeley",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 518,
    density: 6.2,
    county_fips: 19055,
    county_name: "Delaware",
    county_weights: {
      19043: 11.74,
      19055: 88.26,
    },
    county_names_all: "Delaware|Clayton",
    county_fips_all: "19055|19043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52052,
    lat: 42.7411,
    lng: -91.12083,
    city: "Guttenberg",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2999,
    density: 12.9,
    county_fips: 19043,
    county_name: "Clayton",
    county_weights: {
      19043: 90.38,
      19061: 9.62,
    },
    county_names_all: "Clayton|Dubuque",
    county_fips_all: "19043|19061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52053,
    lat: 42.60656,
    lng: -90.96399,
    city: "Holy Cross",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 941,
    density: 6.2,
    county_fips: 19061,
    county_name: "Dubuque",
    county_weights: {
      19043: 21.72,
      19061: 78.28,
    },
    county_names_all: "Dubuque|Clayton",
    county_fips_all: "19061|19043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52054,
    lat: 42.30569,
    lng: -90.62811,
    city: "La Motte",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 769,
    density: 5.3,
    county_fips: 19097,
    county_name: "Jackson",
    county_weights: {
      19061: 7.03,
      19097: 92.97,
    },
    county_names_all: "Jackson|Dubuque",
    county_fips_all: "19097|19061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52056,
    lat: 42.60401,
    lng: -91.07257,
    city: "Luxemburg",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19061,
    county_name: "Dubuque",
    county_weights: {
      19061: 100,
    },
    county_names_all: "Dubuque",
    county_fips_all: 19061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52057,
    lat: 42.4916,
    lng: -91.45333,
    city: "Manchester",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7963,
    density: 22.1,
    county_fips: 19055,
    county_name: "Delaware",
    county_weights: {
      19055: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 19055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52060,
    lat: 42.10217,
    lng: -90.67961,
    city: "Maquoketa",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8107,
    density: 19.7,
    county_fips: 19097,
    county_name: "Jackson",
    county_weights: {
      19045: 11.83,
      19097: 88.17,
    },
    county_names_all: "Jackson|Clinton",
    county_fips_all: "19097|19045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52064,
    lat: 42.08977,
    lng: -90.31076,
    city: "Miles",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 846,
    density: 7.7,
    county_fips: 19097,
    county_name: "Jackson",
    county_weights: {
      19045: 13.94,
      19097: 86.06,
    },
    county_names_all: "Jackson|Clinton",
    county_fips_all: "19097|19045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52065,
    lat: 42.58353,
    lng: -91.10202,
    city: "New Vienna",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 875,
    density: 7,
    county_fips: 19061,
    county_name: "Dubuque",
    county_weights: {
      19055: 25.18,
      19061: 74.82,
    },
    county_names_all: "Dubuque|Delaware",
    county_fips_all: "19061|19055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52066,
    lat: 42.693,
    lng: -90.96925,
    city: "North Buena Vista",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19043,
    county_name: "Clayton",
    county_weights: {
      19043: 100,
    },
    county_names_all: "Clayton",
    county_fips_all: 19043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52068,
    lat: 42.42382,
    lng: -90.81128,
    city: "Peosta",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4649,
    density: 41.6,
    county_fips: 19061,
    county_name: "Dubuque",
    county_weights: {
      19061: 100,
    },
    county_names_all: "Dubuque",
    county_fips_all: 19061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52069,
    lat: 42.05772,
    lng: -90.4279,
    city: "Preston",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1610,
    density: 12.7,
    county_fips: 19097,
    county_name: "Jackson",
    county_weights: {
      19045: 22.34,
      19097: 77.66,
    },
    county_names_all: "Jackson|Clinton",
    county_fips_all: "19097|19045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52070,
    lat: 42.08146,
    lng: -90.21771,
    city: "Sabula",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1067,
    density: 8.5,
    county_fips: 19097,
    county_name: "Jackson",
    county_weights: {
      19045: 17.91,
      19097: 82.09,
    },
    county_names_all: "Jackson|Clinton",
    county_fips_all: "19097|19045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52071,
    lat: 42.36245,
    lng: -90.54234,
    city: "Saint Donatus",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19097,
    county_name: "Jackson",
    county_weights: {
      19097: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 19097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52072,
    lat: 42.92022,
    lng: -91.38025,
    city: "Saint Olaf",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 417,
    density: 4.8,
    county_fips: 19043,
    county_name: "Clayton",
    county_weights: {
      19043: 100,
    },
    county_names_all: "Clayton",
    county_fips_all: 19043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52073,
    lat: 42.62331,
    lng: -90.82069,
    city: "Sherrill",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1553,
    density: 12.5,
    county_fips: 19061,
    county_name: "Dubuque",
    county_weights: {
      19043: 7.18,
      19061: 92.82,
    },
    county_names_all: "Dubuque|Clayton",
    county_fips_all: "19061|19043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52074,
    lat: 42.10966,
    lng: -90.4724,
    city: "Spragueville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 395,
    density: 4.9,
    county_fips: 19097,
    county_name: "Jackson",
    county_weights: {
      19097: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 19097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52075,
    lat: 42.16577,
    lng: -90.47916,
    city: "Springbrook",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19097,
    county_name: "Jackson",
    county_weights: {
      19097: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 19097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52076,
    lat: 42.69805,
    lng: -91.50984,
    city: "Strawberry Point",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2023,
    density: 7.7,
    county_fips: 19043,
    county_name: "Clayton",
    county_weights: {
      19043: 82.71,
      19055: 16.61,
      19065: 0.68,
    },
    county_names_all: "Clayton|Delaware|Fayette",
    county_fips_all: "19043|19055|19065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52077,
    lat: 42.82258,
    lng: -91.55393,
    city: "Volga",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 317,
    density: 4,
    county_fips: 19043,
    county_name: "Clayton",
    county_weights: {
      19043: 100,
    },
    county_names_all: "Clayton",
    county_fips_all: 19043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52078,
    lat: 42.39506,
    lng: -91.11534,
    city: "Worthington",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 503,
    density: 4.7,
    county_fips: 19061,
    county_name: "Dubuque",
    county_weights: {
      19055: 35.82,
      19061: 64.18,
    },
    county_names_all: "Dubuque|Delaware",
    county_fips_all: "19061|19055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52079,
    lat: 42.28781,
    lng: -90.71908,
    city: "Zwingle",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 642,
    density: 4.2,
    county_fips: 19097,
    county_name: "Jackson",
    county_weights: {
      19061: 45.5,
      19097: 54.5,
    },
    county_names_all: "Jackson|Dubuque",
    county_fips_all: "19097|19061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52101,
    lat: 43.35741,
    lng: -91.76494,
    city: "Decorah",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13145,
    density: 16,
    county_fips: 19191,
    county_name: "Winneshiek",
    county_weights: {
      19005: 2.93,
      19191: 97.07,
    },
    county_names_all: "Winneshiek|Allamakee",
    county_fips_all: "19191|19005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52132,
    lat: 43.2067,
    lng: -91.91881,
    city: "Calmar",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2049,
    density: 12.8,
    county_fips: 19191,
    county_name: "Winneshiek",
    county_weights: {
      19089: 1.66,
      19191: 98.34,
    },
    county_names_all: "Winneshiek|Howard",
    county_fips_all: "19191|19089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52133,
    lat: 43.10702,
    lng: -91.66854,
    city: "Castalia",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 662,
    density: 5.8,
    county_fips: 19191,
    county_name: "Winneshiek",
    county_weights: {
      19065: 29.71,
      19191: 70.29,
    },
    county_names_all: "Winneshiek|Fayette",
    county_fips_all: "19191|19065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52134,
    lat: 43.47156,
    lng: -92.40078,
    city: "Chester",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 272,
    density: 3.8,
    county_fips: 19089,
    county_name: "Howard",
    county_weights: {
      19089: 100,
    },
    county_names_all: "Howard",
    county_fips_all: 19089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52135,
    lat: 43.01945,
    lng: -91.66204,
    city: "Clermont",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 586,
    density: 8.1,
    county_fips: 19065,
    county_name: "Fayette",
    county_weights: {
      19043: 7.51,
      19065: 92.49,
    },
    county_names_all: "Fayette|Clayton",
    county_fips_all: "19065|19043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52136,
    lat: 43.37139,
    lng: -92.11289,
    city: "Cresco",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5485,
    density: 10.1,
    county_fips: 19089,
    county_name: "Howard",
    county_weights: {
      19089: 66.89,
      19191: 33.11,
    },
    county_names_all: "Howard|Winneshiek",
    county_fips_all: "19089|19191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52140,
    lat: 43.44173,
    lng: -91.53108,
    city: "Dorchester",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 474,
    density: 2.5,
    county_fips: 19005,
    county_name: "Allamakee",
    county_weights: {
      19005: 91.08,
      19191: 8.92,
    },
    county_names_all: "Allamakee|Winneshiek",
    county_fips_all: "19005|19191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52141,
    lat: 42.93924,
    lng: -91.63007,
    city: "Elgin",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1273,
    density: 5.9,
    county_fips: 19065,
    county_name: "Fayette",
    county_weights: {
      19043: 41.53,
      19065: 58.47,
    },
    county_names_all: "Fayette|Clayton",
    county_fips_all: "19065|19043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52142,
    lat: 42.82752,
    lng: -91.79441,
    city: "Fayette",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1678,
    density: 8.6,
    county_fips: 19065,
    county_name: "Fayette",
    county_weights: {
      19065: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 19065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52144,
    lat: 43.13961,
    lng: -91.96075,
    city: "Fort Atkinson",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1026,
    density: 5.3,
    county_fips: 19191,
    county_name: "Winneshiek",
    county_weights: {
      19065: 5.69,
      19191: 94.31,
    },
    county_names_all: "Winneshiek|Fayette",
    county_fips_all: "19191|19065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52146,
    lat: 43.18826,
    lng: -91.19588,
    city: "Harpers Ferry",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 783,
    density: 3.7,
    county_fips: 19005,
    county_name: "Allamakee",
    county_weights: {
      19005: 100,
    },
    county_names_all: "Allamakee",
    county_fips_all: 19005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52147,
    lat: 42.94957,
    lng: -91.96106,
    city: "Hawkeye",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1007,
    density: 5.7,
    county_fips: 19065,
    county_name: "Fayette",
    county_weights: {
      19065: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 19065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52151,
    lat: 43.34706,
    lng: -91.28013,
    city: "Lansing",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1850,
    density: 6.2,
    county_fips: 19005,
    county_name: "Allamakee",
    county_weights: {
      19005: 100,
    },
    county_names_all: "Allamakee",
    county_fips_all: 19005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52154,
    lat: 43.12201,
    lng: -92.16519,
    city: "Lawler",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 795,
    density: 4.2,
    county_fips: 19037,
    county_name: "Chickasaw",
    county_weights: {
      19037: 98.58,
      19089: 1.42,
    },
    county_names_all: "Chickasaw|Howard",
    county_fips_all: "19037|19089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52155,
    lat: 43.41412,
    lng: -92.29683,
    city: "Lime Springs",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1608,
    density: 6,
    county_fips: 19089,
    county_name: "Howard",
    county_weights: {
      19089: 100,
    },
    county_names_all: "Howard",
    county_fips_all: 19089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52156,
    lat: 43.05316,
    lng: -91.46534,
    city: "Luana",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 529,
    density: 4.3,
    county_fips: 19043,
    county_name: "Clayton",
    county_weights: {
      19005: 27.44,
      19043: 72.56,
    },
    county_names_all: "Clayton|Allamakee",
    county_fips_all: "19043|19005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52157,
    lat: 43.01661,
    lng: -91.23216,
    city: "McGregor",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1825,
    density: 12.4,
    county_fips: 19043,
    county_name: "Clayton",
    county_weights: {
      19043: 100,
    },
    county_names_all: "Clayton",
    county_fips_all: 19043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52158,
    lat: 43.04388,
    lng: -91.18647,
    city: "Marquette",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 250,
    density: 75.4,
    county_fips: 19043,
    county_name: "Clayton",
    county_weights: {
      19043: 100,
    },
    county_names_all: "Clayton",
    county_fips_all: 19043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52159,
    lat: 43.07979,
    lng: -91.36134,
    city: "Monona",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2412,
    density: 12.8,
    county_fips: 19005,
    county_name: "Allamakee",
    county_weights: {
      19005: 50.78,
      19043: 49.22,
    },
    county_names_all: "Allamakee|Clayton",
    county_fips_all: "19005|19043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52160,
    lat: 43.46733,
    lng: -91.3521,
    city: "New Albin",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1003,
    density: 8.6,
    county_fips: 19005,
    county_name: "Allamakee",
    county_weights: {
      19005: 100,
    },
    county_names_all: "Allamakee",
    county_fips_all: 19005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52161,
    lat: 43.12733,
    lng: -91.75623,
    city: "Ossian",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1295,
    density: 9.4,
    county_fips: 19191,
    county_name: "Winneshiek",
    county_weights: {
      19065: 13.72,
      19191: 86.28,
    },
    county_names_all: "Winneshiek|Fayette",
    county_fips_all: "19191|19065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52162,
    lat: 43.11062,
    lng: -91.55266,
    city: "Postville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3445,
    density: 13.8,
    county_fips: 19005,
    county_name: "Allamakee",
    county_weights: {
      19005: 59.92,
      19043: 27.38,
      19065: 3.11,
      19191: 9.59,
    },
    county_names_all: "Allamakee|Clayton|Winneshiek|Fayette",
    county_fips_all: "19005|19043|19191|19065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52163,
    lat: 43.21976,
    lng: -92.10315,
    city: "Protivin",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 352,
    density: 76.7,
    county_fips: 19089,
    county_name: "Howard",
    county_weights: {
      19089: 100,
    },
    county_names_all: "Howard",
    county_fips_all: 19089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52164,
    lat: 42.85212,
    lng: -91.89941,
    city: "Randalia",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 315,
    density: 4.8,
    county_fips: 19065,
    county_name: "Fayette",
    county_weights: {
      19065: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 19065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52165,
    lat: 43.30671,
    lng: -91.98465,
    city: "Ridgeway",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 963,
    density: 5.6,
    county_fips: 19191,
    county_name: "Winneshiek",
    county_weights: {
      19191: 100,
    },
    county_names_all: "Winneshiek",
    county_fips_all: 19191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52166,
    lat: 43.06791,
    lng: -91.93547,
    city: "Saint Lucas",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 93,
    density: 139.1,
    county_fips: 19065,
    county_name: "Fayette",
    county_weights: {
      19065: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 19065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52168,
    lat: 43.20339,
    lng: -91.95338,
    city: "Spillville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 193,
    density: 196.7,
    county_fips: 19191,
    county_name: "Winneshiek",
    county_weights: {
      19191: 100,
    },
    county_names_all: "Winneshiek",
    county_fips_all: 19191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52169,
    lat: 42.84739,
    lng: -91.65971,
    city: "Wadena",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 310,
    density: 3.6,
    county_fips: 19065,
    county_name: "Fayette",
    county_weights: {
      19043: 5.98,
      19065: 94.02,
    },
    county_names_all: "Fayette|Clayton",
    county_fips_all: "19065|19043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52170,
    lat: 43.22886,
    lng: -91.30485,
    city: "Waterville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 541,
    density: 4.3,
    county_fips: 19005,
    county_name: "Allamakee",
    county_weights: {
      19005: 100,
    },
    county_names_all: "Allamakee",
    county_fips_all: 19005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52171,
    lat: 43.07451,
    lng: -92.04808,
    city: "Waucoma",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1144,
    density: 5.4,
    county_fips: 19065,
    county_name: "Fayette",
    county_weights: {
      19037: 31.15,
      19065: 50.39,
      19191: 18.46,
    },
    county_names_all: "Fayette|Chickasaw|Winneshiek",
    county_fips_all: "19065|19037|19191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52172,
    lat: 43.27117,
    lng: -91.48382,
    city: "Waukon",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6051,
    density: 14.6,
    county_fips: 19005,
    county_name: "Allamakee",
    county_weights: {
      19005: 95.49,
      19191: 4.51,
    },
    county_names_all: "Allamakee|Winneshiek",
    county_fips_all: "19005|19191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52175,
    lat: 42.99372,
    lng: -91.82389,
    city: "West Union",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3630,
    density: 16.4,
    county_fips: 19065,
    county_name: "Fayette",
    county_weights: {
      19065: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 19065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52201,
    lat: 41.33218,
    lng: -91.54704,
    city: "Ainsworth",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1541,
    density: 9.1,
    county_fips: 19183,
    county_name: "Washington",
    county_weights: {
      19183: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 19183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52202,
    lat: 42.15836,
    lng: -91.63792,
    city: "Alburnett",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1111,
    density: 16.7,
    county_fips: 19113,
    county_name: "Linn",
    county_weights: {
      19113: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 19113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52203,
    lat: 41.81035,
    lng: -91.8906,
    city: "Amana",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2509,
    density: 18.4,
    county_fips: 19095,
    county_name: "Iowa",
    county_weights: {
      19095: 78.74,
      19103: 21.26,
    },
    county_names_all: "Iowa|Johnson",
    county_fips_all: "19095|19103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52205,
    lat: 42.11754,
    lng: -91.28806,
    city: "Anamosa",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8526,
    density: 26.7,
    county_fips: 19105,
    county_name: "Jones",
    county_weights: {
      19105: 85.19,
      19113: 14.81,
    },
    county_names_all: "Jones|Linn",
    county_fips_all: "19105|19113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52206,
    lat: 41.99187,
    lng: -91.88718,
    city: "Atkins",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2644,
    density: 35.8,
    county_fips: 19011,
    county_name: "Benton",
    county_weights: {
      19011: 100,
    },
    county_names_all: "Benton",
    county_fips_all: 19011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52207,
    lat: 42.09286,
    lng: -90.83,
    city: "Baldwin",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 412,
    density: 4.3,
    county_fips: 19097,
    county_name: "Jackson",
    county_weights: {
      19045: 12.78,
      19097: 87.22,
    },
    county_names_all: "Jackson|Clinton",
    county_fips_all: "19097|19045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52208,
    lat: 41.88568,
    lng: -92.26475,
    city: "Belle Plaine",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2997,
    density: 19.1,
    county_fips: 19011,
    county_name: "Benton",
    county_weights: {
      19011: 55.79,
      19095: 27.33,
      19157: 3.42,
      19171: 13.46,
    },
    county_names_all: "Benton|Iowa|Tama|Poweshiek",
    county_fips_all: "19011|19095|19171|19157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52209,
    lat: 41.90809,
    lng: -92.09462,
    city: "Blairstown",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1092,
    density: 10.7,
    county_fips: 19011,
    county_name: "Benton",
    county_weights: {
      19011: 96.28,
      19095: 3.72,
    },
    county_names_all: "Benton|Iowa",
    county_fips_all: "19011|19095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52210,
    lat: 42.33905,
    lng: -92.00537,
    city: "Brandon",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 903,
    density: 10.1,
    county_fips: 19019,
    county_name: "Buchanan",
    county_weights: {
      19011: 1.38,
      19019: 98.62,
    },
    county_names_all: "Buchanan|Benton",
    county_fips_all: "19019|19011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52211,
    lat: 41.75978,
    lng: -92.45062,
    city: "Brooklyn",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2435,
    density: 10.7,
    county_fips: 19157,
    county_name: "Poweshiek",
    county_weights: {
      19157: 100,
    },
    county_names_all: "Poweshiek",
    county_fips_all: 19157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52212,
    lat: 42.10954,
    lng: -91.08929,
    city: "Center Junction",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 258,
    density: 4.5,
    county_fips: 19105,
    county_name: "Jones",
    county_weights: {
      19105: 100,
    },
    county_names_all: "Jones",
    county_fips_all: 19105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52213,
    lat: 42.1995,
    lng: -91.77222,
    city: "Center Point",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3887,
    density: 20.6,
    county_fips: 19113,
    county_name: "Linn",
    county_weights: {
      19011: 23.84,
      19113: 76.16,
    },
    county_names_all: "Linn|Benton",
    county_fips_all: "19113|19011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52214,
    lat: 42.19056,
    lng: -91.50704,
    city: "Central City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3460,
    density: 14.8,
    county_fips: 19113,
    county_name: "Linn",
    county_weights: {
      19113: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 19113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52215,
    lat: 41.91018,
    lng: -92.40106,
    city: "Chelsea",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1086,
    density: 5.3,
    county_fips: 19171,
    county_name: "Tama",
    county_weights: {
      19157: 18.97,
      19171: 81.03,
    },
    county_names_all: "Tama|Poweshiek",
    county_fips_all: "19171|19157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52216,
    lat: 41.89321,
    lng: -91.0431,
    city: "Clarence",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1352,
    density: 9,
    county_fips: 19031,
    county_name: "Cedar",
    county_weights: {
      19031: 85.83,
      19105: 14.17,
    },
    county_names_all: "Cedar|Jones",
    county_fips_all: "19031|19105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52217,
    lat: 42.07948,
    lng: -92.41067,
    city: "Clutier",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 593,
    density: 4.2,
    county_fips: 19171,
    county_name: "Tama",
    county_weights: {
      19171: 100,
    },
    county_names_all: "Tama",
    county_fips_all: 19171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52218,
    lat: 42.2946,
    lng: -91.53826,
    city: "Coggon",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1957,
    density: 10,
    county_fips: 19113,
    county_name: "Linn",
    county_weights: {
      19019: 24.15,
      19055: 20.09,
      19113: 55.76,
    },
    county_names_all: "Linn|Buchanan|Delaware",
    county_fips_all: "19113|19019|19055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52219,
    lat: 42.23758,
    lng: -91.42576,
    city: "Prairieburg",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 165,
    density: 142.1,
    county_fips: 19113,
    county_name: "Linn",
    county_weights: {
      19113: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 19113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52220,
    lat: 41.72661,
    lng: -91.99853,
    city: "Conroy",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 221,
    density: 111.9,
    county_fips: 19095,
    county_name: "Iowa",
    county_weights: {
      19095: 100,
    },
    county_names_all: "Iowa",
    county_fips_all: 19095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52221,
    lat: 41.64151,
    lng: -92.33215,
    city: "Guernsey",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 209,
    density: 3.8,
    county_fips: 19157,
    county_name: "Poweshiek",
    county_weights: {
      19095: 15.38,
      19157: 84.62,
    },
    county_names_all: "Poweshiek|Iowa",
    county_fips_all: "19157|19095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52222,
    lat: 41.57623,
    lng: -92.33693,
    city: "Deep River",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 531,
    density: 2.7,
    county_fips: 19157,
    county_name: "Poweshiek",
    county_weights: {
      19095: 29.28,
      19157: 70.72,
    },
    county_names_all: "Poweshiek|Iowa",
    county_fips_all: "19157|19095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52223,
    lat: 42.41315,
    lng: -91.32408,
    city: "Delhi",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 937,
    density: 7.6,
    county_fips: 19055,
    county_name: "Delaware",
    county_weights: {
      19055: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 19055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52224,
    lat: 42.16386,
    lng: -92.29836,
    city: "Dysart",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1788,
    density: 7,
    county_fips: 19011,
    county_name: "Benton",
    county_weights: {
      19011: 52.18,
      19171: 47.82,
    },
    county_names_all: "Benton|Tama",
    county_fips_all: "19011|19171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52225,
    lat: 42.01289,
    lng: -92.32636,
    city: "Elberon",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 323,
    density: 3.3,
    county_fips: 19171,
    county_name: "Tama",
    county_weights: {
      19011: 27.65,
      19171: 72.35,
    },
    county_names_all: "Tama|Benton",
    county_fips_all: "19171|19011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52227,
    lat: 41.89647,
    lng: -91.5626,
    city: "Ely",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2871,
    density: 37.7,
    county_fips: 19113,
    county_name: "Linn",
    county_weights: {
      19103: 6.45,
      19113: 93.55,
    },
    county_names_all: "Linn|Johnson",
    county_fips_all: "19113|19103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52228,
    lat: 41.90282,
    lng: -91.79132,
    city: "Fairfax",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3668,
    density: 38,
    county_fips: 19113,
    county_name: "Linn",
    county_weights: {
      19011: 13.04,
      19103: 11.27,
      19113: 75.69,
    },
    county_names_all: "Linn|Benton|Johnson",
    county_fips_all: "19113|19011|19103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52229,
    lat: 42.14609,
    lng: -92.16884,
    city: "Garrison",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 730,
    density: 5.4,
    county_fips: 19011,
    county_name: "Benton",
    county_weights: {
      19011: 100,
    },
    county_names_all: "Benton",
    county_fips_all: 19011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52231,
    lat: 41.36371,
    lng: -92.05912,
    city: "Harper",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 310,
    density: 3.5,
    county_fips: 19107,
    county_name: "Keokuk",
    county_weights: {
      19107: 100,
    },
    county_names_all: "Keokuk",
    county_fips_all: 19107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52232,
    lat: 41.80128,
    lng: -92.34043,
    city: "Hartwick",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 362,
    density: 6.6,
    county_fips: 19157,
    county_name: "Poweshiek",
    county_weights: {
      19157: 100,
    },
    county_names_all: "Poweshiek",
    county_fips_all: 19157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52233,
    lat: 42.04934,
    lng: -91.68732,
    city: "Hiawatha",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7039,
    density: 694.4,
    county_fips: 19113,
    county_name: "Linn",
    county_weights: {
      19113: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 19113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52235,
    lat: 41.57024,
    lng: -91.53281,
    city: "Hills",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 819,
    density: 147.4,
    county_fips: 19103,
    county_name: "Johnson",
    county_weights: {
      19103: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 19103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52236,
    lat: 41.73143,
    lng: -91.87647,
    city: "Homestead",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 607,
    density: 9,
    county_fips: 19095,
    county_name: "Iowa",
    county_weights: {
      19095: 100,
    },
    county_names_all: "Iowa",
    county_fips_all: 19095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52237,
    lat: 42.34368,
    lng: -91.25193,
    city: "Hopkinton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1633,
    density: 7.5,
    county_fips: 19055,
    county_name: "Delaware",
    county_weights: {
      19055: 95.59,
      19061: 1.51,
      19105: 2.9,
    },
    county_names_all: "Delaware|Jones|Dubuque",
    county_fips_all: "19055|19105|19061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52240,
    lat: 41.63143,
    lng: -91.49924,
    city: "Iowa City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35965,
    density: 97.7,
    county_fips: 19103,
    county_name: "Johnson",
    county_weights: {
      19103: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 19103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52241,
    lat: 41.69708,
    lng: -91.59746,
    city: "Coralville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21473,
    density: 613.8,
    county_fips: 19103,
    county_name: "Johnson",
    county_weights: {
      19103: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 19103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52242,
    lat: 41.66195,
    lng: -91.54317,
    city: "Iowa City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1417,
    density: 764.5,
    county_fips: 19103,
    county_name: "Johnson",
    county_weights: {
      19103: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 19103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52245,
    lat: 41.67071,
    lng: -91.50666,
    city: "Iowa City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25664,
    density: 1180.1,
    county_fips: 19103,
    county_name: "Johnson",
    county_weights: {
      19103: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 19103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52246,
    lat: 41.64903,
    lng: -91.59718,
    city: "Iowa City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23233,
    density: 536.8,
    county_fips: 19103,
    county_name: "Johnson",
    county_weights: {
      19103: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 19103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52247,
    lat: 41.51503,
    lng: -91.71774,
    city: "Kalona",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4837,
    density: 23.2,
    county_fips: 19103,
    county_name: "Johnson",
    county_weights: {
      19103: 55.02,
      19183: 44.98,
    },
    county_names_all: "Johnson|Washington",
    county_fips_all: "19103|19183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52248,
    lat: 41.34386,
    lng: -91.93891,
    city: "Keota",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1684,
    density: 5.8,
    county_fips: 19183,
    county_name: "Washington",
    county_weights: {
      19107: 48.41,
      19183: 51.59,
    },
    county_names_all: "Washington|Keokuk",
    county_fips_all: "19183|19107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52249,
    lat: 42.01202,
    lng: -92.20517,
    city: "Keystone",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 941,
    density: 7.3,
    county_fips: 19011,
    county_name: "Benton",
    county_weights: {
      19011: 100,
    },
    county_names_all: "Benton",
    county_fips_all: 19011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52251,
    lat: 41.71218,
    lng: -92.20314,
    city: "Ladora",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 742,
    density: 7.4,
    county_fips: 19095,
    county_name: "Iowa",
    county_weights: {
      19095: 100,
    },
    county_names_all: "Iowa",
    county_fips_all: 19095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52252,
    lat: 42.19712,
    lng: -91.22727,
    city: "Langworthy",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19105,
    county_name: "Jones",
    county_weights: {
      19105: 100,
    },
    county_names_all: "Jones",
    county_fips_all: 19105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52253,
    lat: 41.89713,
    lng: -91.35154,
    city: "Lisbon",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2966,
    density: 24.3,
    county_fips: 19031,
    county_name: "Cedar",
    county_weights: {
      19031: 49.91,
      19103: 8.79,
      19105: 17.73,
      19113: 23.56,
    },
    county_names_all: "Cedar|Linn|Jones|Johnson",
    county_fips_all: "19031|19113|19105|19103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52254,
    lat: 41.95232,
    lng: -90.80538,
    city: "Lost Nation",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 796,
    density: 5.2,
    county_fips: 19045,
    county_name: "Clinton",
    county_weights: {
      19045: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 19045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52255,
    lat: 41.86294,
    lng: -90.96129,
    city: "Lowden",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1426,
    density: 12.9,
    county_fips: 19031,
    county_name: "Cedar",
    county_weights: {
      19031: 100,
    },
    county_names_all: "Cedar",
    county_fips_all: 19031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52257,
    lat: 41.91836,
    lng: -92.17742,
    city: "Luzerne",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 191,
    density: 4.4,
    county_fips: 19011,
    county_name: "Benton",
    county_weights: {
      19011: 100,
    },
    county_names_all: "Benton",
    county_fips_all: 19011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52301,
    lat: 41.78658,
    lng: -92.09013,
    city: "Marengo",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3493,
    density: 10.7,
    county_fips: 19095,
    county_name: "Iowa",
    county_weights: {
      19011: 3.57,
      19095: 96.43,
    },
    county_names_all: "Iowa|Benton",
    county_fips_all: "19095|19011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52302,
    lat: 42.0656,
    lng: -91.57091,
    city: "Marion",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41745,
    density: 216.8,
    county_fips: 19113,
    county_name: "Linn",
    county_weights: {
      19113: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 19113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52305,
    lat: 42.01801,
    lng: -91.34207,
    city: "Martelle",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 731,
    density: 10.4,
    county_fips: 19105,
    county_name: "Jones",
    county_weights: {
      19105: 78.09,
      19113: 21.91,
    },
    county_names_all: "Jones|Linn",
    county_fips_all: "19105|19113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52306,
    lat: 41.89729,
    lng: -91.25296,
    city: "Mechanicsville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1436,
    density: 7.4,
    county_fips: 19031,
    county_name: "Cedar",
    county_weights: {
      19031: 79.09,
      19105: 20.91,
    },
    county_names_all: "Cedar|Jones",
    county_fips_all: "19031|19105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52307,
    lat: 41.79158,
    lng: -91.90244,
    city: "Middle Amana",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 89,
    density: 64.1,
    county_fips: 19095,
    county_name: "Iowa",
    county_weights: {
      19095: 100,
    },
    county_names_all: "Iowa",
    county_fips_all: 19095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52308,
    lat: 41.5733,
    lng: -92.1592,
    city: "Millersburg",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 168,
    density: 533.4,
    county_fips: 19095,
    county_name: "Iowa",
    county_weights: {
      19095: 100,
    },
    county_names_all: "Iowa",
    county_fips_all: 19095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52309,
    lat: 42.12415,
    lng: -90.88733,
    city: "Monmouth",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 629,
    density: 7.1,
    county_fips: 19097,
    county_name: "Jackson",
    county_weights: {
      19097: 72.13,
      19105: 27.87,
    },
    county_names_all: "Jackson|Jones",
    county_fips_all: "19097|19105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52310,
    lat: 42.21983,
    lng: -91.19737,
    city: "Monticello",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6504,
    density: 17.3,
    county_fips: 19105,
    county_name: "Jones",
    county_weights: {
      19055: 0.5,
      19105: 95.34,
      19113: 4.16,
    },
    county_names_all: "Jones|Linn|Delaware",
    county_fips_all: "19105|19113|19055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52312,
    lat: 42.00617,
    lng: -91.24526,
    city: "Morley",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46,
    density: 247.4,
    county_fips: 19105,
    county_name: "Jones",
    county_weights: {
      19105: 100,
    },
    county_names_all: "Jones",
    county_fips_all: 19105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52313,
    lat: 42.25955,
    lng: -92.09726,
    city: "Mount Auburn",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 237,
    density: 3,
    county_fips: 19011,
    county_name: "Benton",
    county_weights: {
      19011: 100,
    },
    county_names_all: "Benton",
    county_fips_all: 19011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52314,
    lat: 41.93439,
    lng: -91.44985,
    city: "Mount Vernon",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5827,
    density: 37.9,
    county_fips: 19113,
    county_name: "Linn",
    county_weights: {
      19113: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 19113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52315,
    lat: 42.00181,
    lng: -91.96985,
    city: "Newhall",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1200,
    density: 16.2,
    county_fips: 19011,
    county_name: "Benton",
    county_weights: {
      19011: 100,
    },
    county_names_all: "Benton",
    county_fips_all: 19011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52316,
    lat: 41.53727,
    lng: -92.09367,
    city: "North English",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1665,
    density: 8.8,
    county_fips: 19095,
    county_name: "Iowa",
    county_weights: {
      19095: 87.15,
      19107: 12.85,
    },
    county_names_all: "Iowa|Keokuk",
    county_fips_all: "19095|19107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52317,
    lat: 41.76277,
    lng: -91.63142,
    city: "North Liberty",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20874,
    density: 234.5,
    county_fips: 19103,
    county_name: "Johnson",
    county_weights: {
      19103: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 19103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52318,
    lat: 41.89012,
    lng: -91.89656,
    city: "Norway",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 950,
    density: 10.5,
    county_fips: 19011,
    county_name: "Benton",
    county_weights: {
      19011: 81.72,
      19095: 18.28,
    },
    county_names_all: "Benton|Iowa",
    county_fips_all: "19011|19095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52320,
    lat: 41.99997,
    lng: -91.14643,
    city: "Olin",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1329,
    density: 8.8,
    county_fips: 19105,
    county_name: "Jones",
    county_weights: {
      19031: 12.86,
      19105: 87.14,
    },
    county_names_all: "Jones|Cedar",
    county_fips_all: "19105|19031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52321,
    lat: 42.14168,
    lng: -90.98307,
    city: "Onslow",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 385,
    density: 4,
    county_fips: 19105,
    county_name: "Jones",
    county_weights: {
      19105: 100,
    },
    county_names_all: "Jones",
    county_fips_all: 19105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52322,
    lat: 41.69221,
    lng: -91.76284,
    city: "Oxford",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2014,
    density: 8.9,
    county_fips: 19103,
    county_name: "Johnson",
    county_weights: {
      19095: 0.82,
      19103: 99.18,
    },
    county_names_all: "Johnson|Iowa",
    county_fips_all: "19103|19095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52323,
    lat: 41.98445,
    lng: -90.95344,
    city: "Oxford Junction",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1079,
    density: 8.8,
    county_fips: 19105,
    county_name: "Jones",
    county_weights: {
      19031: 8.58,
      19045: 13.11,
      19105: 78.31,
    },
    county_names_all: "Jones|Clinton|Cedar",
    county_fips_all: "19105|19045|19031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52324,
    lat: 42.06421,
    lng: -91.80583,
    city: "Palo",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1740,
    density: 16,
    county_fips: 19113,
    county_name: "Linn",
    county_weights: {
      19011: 18.13,
      19113: 81.87,
    },
    county_names_all: "Linn|Benton",
    county_fips_all: "19113|19011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52325,
    lat: 41.58028,
    lng: -91.92305,
    city: "Parnell",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 604,
    density: 5.8,
    county_fips: 19095,
    county_name: "Iowa",
    county_weights: {
      19095: 86.17,
      19103: 13.83,
    },
    county_names_all: "Iowa|Johnson",
    county_fips_all: "19095|19103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52326,
    lat: 42.39513,
    lng: -91.75641,
    city: "Quasqueton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 710,
    density: 276.4,
    county_fips: 19019,
    county_name: "Buchanan",
    county_weights: {
      19019: 100,
    },
    county_names_all: "Buchanan",
    county_fips_all: 19019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52327,
    lat: 41.477,
    lng: -91.58046,
    city: "Riverside",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3455,
    density: 16.6,
    county_fips: 19183,
    county_name: "Washington",
    county_weights: {
      19103: 27.2,
      19115: 0.13,
      19183: 72.67,
    },
    county_names_all: "Washington|Johnson|Louisa",
    county_fips_all: "19183|19103|19115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52328,
    lat: 42.07195,
    lng: -91.66641,
    city: "Robins",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3098,
    density: 443,
    county_fips: 19113,
    county_name: "Linn",
    county_weights: {
      19113: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 19113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52329,
    lat: 42.35894,
    lng: -91.85405,
    city: "Rowley",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 820,
    density: 6.3,
    county_fips: 19019,
    county_name: "Buchanan",
    county_weights: {
      19019: 100,
    },
    county_names_all: "Buchanan",
    county_fips_all: 19019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52330,
    lat: 42.35261,
    lng: -91.50076,
    city: "Ryan",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 849,
    density: 6.9,
    county_fips: 19055,
    county_name: "Delaware",
    county_weights: {
      19055: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 19055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52332,
    lat: 42.09861,
    lng: -91.88772,
    city: "Shellsburg",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2027,
    density: 19.7,
    county_fips: 19011,
    county_name: "Benton",
    county_weights: {
      19011: 91.09,
      19113: 8.91,
    },
    county_names_all: "Benton|Linn",
    county_fips_all: "19011|19113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52333,
    lat: 41.80376,
    lng: -91.48685,
    city: "Solon",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7116,
    density: 32.1,
    county_fips: 19103,
    county_name: "Johnson",
    county_weights: {
      19031: 4.5,
      19103: 95.5,
    },
    county_names_all: "Johnson|Cedar",
    county_fips_all: "19103|19031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52334,
    lat: 41.73084,
    lng: -91.94355,
    city: "South Amana",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 236,
    density: 6.8,
    county_fips: 19095,
    county_name: "Iowa",
    county_weights: {
      19095: 100,
    },
    county_names_all: "Iowa",
    county_fips_all: 19095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52335,
    lat: 41.45935,
    lng: -92.05895,
    city: "South English",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 740,
    density: 5.9,
    county_fips: 19107,
    county_name: "Keokuk",
    county_weights: {
      19107: 100,
    },
    county_names_all: "Keokuk",
    county_fips_all: 19107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52336,
    lat: 42.0689,
    lng: -91.44111,
    city: "Springville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2602,
    density: 20.9,
    county_fips: 19113,
    county_name: "Linn",
    county_weights: {
      19113: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 19113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52337,
    lat: 41.88217,
    lng: -91.14282,
    city: "Stanwood",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 872,
    density: 11.2,
    county_fips: 19031,
    county_name: "Cedar",
    county_weights: {
      19031: 100,
    },
    county_names_all: "Cedar",
    county_fips_all: 19031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52338,
    lat: 41.82904,
    lng: -91.70858,
    city: "Swisher",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3672,
    density: 42.5,
    county_fips: 19103,
    county_name: "Johnson",
    county_weights: {
      19103: 93.99,
      19113: 6.01,
    },
    county_names_all: "Johnson|Linn",
    county_fips_all: "19103|19113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52339,
    lat: 41.92313,
    lng: -92.58307,
    city: "Tama",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3887,
    density: 15.2,
    county_fips: 19171,
    county_name: "Tama",
    county_weights: {
      19157: 2.72,
      19171: 97.28,
    },
    county_names_all: "Tama|Poweshiek",
    county_fips_all: "19171|19157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52340,
    lat: 41.70615,
    lng: -91.68019,
    city: "Tiffin",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3881,
    density: 78.7,
    county_fips: 19103,
    county_name: "Johnson",
    county_weights: {
      19103: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 19103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52341,
    lat: 42.10535,
    lng: -91.7341,
    city: "Toddville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1331,
    density: 37.9,
    county_fips: 19113,
    county_name: "Linn",
    county_weights: {
      19113: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 19113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52342,
    lat: 42.05047,
    lng: -92.55849,
    city: "Toledo",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3005,
    density: 13.1,
    county_fips: 19171,
    county_name: "Tama",
    county_weights: {
      19171: 100,
    },
    county_names_all: "Tama",
    county_fips_all: 19171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52344,
    lat: 42.29202,
    lng: -91.68325,
    city: "Troy Mills",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19113,
    county_name: "Linn",
    county_weights: {
      19113: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 19113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52345,
    lat: 42.22239,
    lng: -91.89177,
    city: "Urbana",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1462,
    density: 177.5,
    county_fips: 19011,
    county_name: "Benton",
    county_weights: {
      19011: 100,
    },
    county_names_all: "Benton",
    county_fips_all: 19011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52346,
    lat: 42.01298,
    lng: -92.08119,
    city: "Van Horne",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1425,
    density: 11.3,
    county_fips: 19011,
    county_name: "Benton",
    county_weights: {
      19011: 100,
    },
    county_names_all: "Benton",
    county_fips_all: 19011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52347,
    lat: 41.71345,
    lng: -92.28591,
    city: "Victor",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1346,
    density: 8.1,
    county_fips: 19095,
    county_name: "Iowa",
    county_weights: {
      19095: 66.92,
      19157: 33.08,
    },
    county_names_all: "Iowa|Poweshiek",
    county_fips_all: "19095|19157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52348,
    lat: 41.99331,
    lng: -92.38597,
    city: "Vining",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 80,
    density: 107,
    county_fips: 19171,
    county_name: "Tama",
    county_weights: {
      19171: 100,
    },
    county_names_all: "Tama",
    county_fips_all: 19171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52349,
    lat: 42.17246,
    lng: -92.00566,
    city: "Vinton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7765,
    density: 20,
    county_fips: 19011,
    county_name: "Benton",
    county_weights: {
      19011: 100,
    },
    county_names_all: "Benton",
    county_fips_all: 19011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52351,
    lat: 41.87496,
    lng: -91.83529,
    city: "Walford",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1307,
    density: 273.6,
    county_fips: 19011,
    county_name: "Benton",
    county_weights: {
      19011: 67.34,
      19095: 0.17,
      19113: 32.49,
    },
    county_names_all: "Benton|Linn|Iowa",
    county_fips_all: "19011|19113|19095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52352,
    lat: 42.28706,
    lng: -91.77897,
    city: "Walker",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1832,
    density: 8.8,
    county_fips: 19113,
    county_name: "Linn",
    county_weights: {
      19011: 16.38,
      19019: 36.49,
      19113: 47.12,
    },
    county_names_all: "Linn|Buchanan|Benton",
    county_fips_all: "19113|19019|19011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52353,
    lat: 41.29923,
    lng: -91.71596,
    city: "Washington",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9372,
    density: 23,
    county_fips: 19183,
    county_name: "Washington",
    county_weights: {
      19183: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 19183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52354,
    lat: 41.91883,
    lng: -91.98856,
    city: "Watkins",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 315,
    density: 4.1,
    county_fips: 19011,
    county_name: "Benton",
    county_weights: {
      19011: 100,
    },
    county_names_all: "Benton",
    county_fips_all: 19011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52355,
    lat: 41.4576,
    lng: -92.18387,
    city: "Webster",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 328,
    density: 3.6,
    county_fips: 19107,
    county_name: "Keokuk",
    county_weights: {
      19095: 8.17,
      19107: 91.83,
    },
    county_names_all: "Keokuk|Iowa",
    county_fips_all: "19107|19095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52356,
    lat: 41.4749,
    lng: -91.84769,
    city: "Wellman",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2600,
    density: 10.6,
    county_fips: 19183,
    county_name: "Washington",
    county_weights: {
      19095: 16.85,
      19103: 8.16,
      19107: 1.28,
      19183: 73.71,
    },
    county_names_all: "Washington|Iowa|Johnson|Keokuk",
    county_fips_all: "19183|19095|19103|19107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52358,
    lat: 41.69644,
    lng: -91.32097,
    city: "West Branch",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3774,
    density: 18.5,
    county_fips: 19031,
    county_name: "Cedar",
    county_weights: {
      19031: 82.52,
      19103: 17.48,
    },
    county_names_all: "Cedar|Johnson",
    county_fips_all: "19031|19103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52359,
    lat: 41.35428,
    lng: -91.81006,
    city: "West Chester",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 204,
    density: 5.7,
    county_fips: 19183,
    county_name: "Washington",
    county_weights: {
      19183: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 19183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52361,
    lat: 41.6446,
    lng: -92.0154,
    city: "Williamsburg",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4294,
    density: 12.8,
    county_fips: 19095,
    county_name: "Iowa",
    county_weights: {
      19095: 100,
    },
    county_names_all: "Iowa",
    county_fips_all: 19095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52362,
    lat: 42.05881,
    lng: -91.00258,
    city: "Wyoming",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1061,
    density: 7.7,
    county_fips: 19105,
    county_name: "Jones",
    county_weights: {
      19105: 100,
    },
    county_names_all: "Jones",
    county_fips_all: 19105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52401,
    lat: 41.97534,
    lng: -91.65871,
    city: "Cedar Rapids",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2173,
    density: 704.8,
    county_fips: 19113,
    county_name: "Linn",
    county_weights: {
      19113: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 19113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52402,
    lat: 42.02272,
    lng: -91.66001,
    city: "Cedar Rapids",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41471,
    density: 1169.9,
    county_fips: 19113,
    county_name: "Linn",
    county_weights: {
      19113: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 19113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52403,
    lat: 41.96813,
    lng: -91.57964,
    city: "Cedar Rapids",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23968,
    density: 352,
    county_fips: 19113,
    county_name: "Linn",
    county_weights: {
      19113: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 19113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52404,
    lat: 41.92153,
    lng: -91.69077,
    city: "Cedar Rapids",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39628,
    density: 270.1,
    county_fips: 19113,
    county_name: "Linn",
    county_weights: {
      19103: 5.01,
      19113: 94.99,
    },
    county_names_all: "Linn|Johnson",
    county_fips_all: "19113|19103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52405,
    lat: 41.98644,
    lng: -91.74774,
    city: "Cedar Rapids",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25942,
    density: 668.9,
    county_fips: 19113,
    county_name: "Linn",
    county_weights: {
      19113: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 19113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52411,
    lat: 42.05093,
    lng: -91.72723,
    city: "Cedar Rapids",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8530,
    density: 200.9,
    county_fips: 19113,
    county_name: "Linn",
    county_weights: {
      19113: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 19113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52501,
    lat: 41.03828,
    lng: -92.43252,
    city: "Ottumwa",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29613,
    density: 50.7,
    county_fips: 19179,
    county_name: "Wapello",
    county_weights: {
      19107: 0.43,
      19123: 0.22,
      19179: 99.35,
    },
    county_names_all: "Wapello|Keokuk|Mahaska",
    county_fips_all: "19179|19107|19123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52530,
    lat: 40.98953,
    lng: -92.29492,
    city: "Agency",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1065,
    density: 23.3,
    county_fips: 19179,
    county_name: "Wapello",
    county_weights: {
      19179: 100,
    },
    county_names_all: "Wapello",
    county_fips_all: 19179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52531,
    lat: 41.02684,
    lng: -92.81562,
    city: "Albia",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5823,
    density: 10.1,
    county_fips: 19135,
    county_name: "Monroe",
    county_weights: {
      19135: 99.05,
      19179: 0.95,
    },
    county_names_all: "Monroe|Wapello",
    county_fips_all: "19135|19179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52533,
    lat: 41.01228,
    lng: -92.15043,
    city: "Batavia",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1211,
    density: 5.3,
    county_fips: 19101,
    county_name: "Jefferson",
    county_weights: {
      19101: 68.91,
      19179: 31.09,
    },
    county_names_all: "Jefferson|Wapello",
    county_fips_all: "19101|19179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52534,
    lat: 41.27342,
    lng: -92.6806,
    city: "Beacon",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 359,
    density: 180.4,
    county_fips: 19123,
    county_name: "Mahaska",
    county_weights: {
      19123: 100,
    },
    county_names_all: "Mahaska",
    county_fips_all: 19123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52535,
    lat: 40.86533,
    lng: -91.96407,
    city: "Birmingham",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 952,
    density: 6.6,
    county_fips: 19177,
    county_name: "Van Buren",
    county_weights: {
      19101: 17.38,
      19177: 82.62,
    },
    county_names_all: "Van Buren|Jefferson",
    county_fips_all: "19177|19101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52536,
    lat: 40.95291,
    lng: -92.61802,
    city: "Blakesburg",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 821,
    density: 5.2,
    county_fips: 19179,
    county_name: "Wapello",
    county_weights: {
      19135: 32.45,
      19179: 67.55,
    },
    county_names_all: "Wapello|Monroe",
    county_fips_all: "19179|19135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52537,
    lat: 40.7355,
    lng: -92.41426,
    city: "Bloomfield",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6962,
    density: 7.9,
    county_fips: 19051,
    county_name: "Davis",
    county_weights: {
      19051: 95.55,
      19179: 4.45,
    },
    county_names_all: "Davis|Wapello",
    county_fips_all: "19051|19179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52540,
    lat: 41.15769,
    lng: -91.82281,
    city: "Brighton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1224,
    density: 4.9,
    county_fips: 19101,
    county_name: "Jefferson",
    county_weights: {
      19101: 52.97,
      19183: 47.03,
    },
    county_names_all: "Jefferson|Washington",
    county_fips_all: "19101|19183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52542,
    lat: 40.62712,
    lng: -92.05164,
    city: "Cantril",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 298,
    density: 2.5,
    county_fips: 19177,
    county_name: "Van Buren",
    county_weights: {
      19177: 80.48,
      29199: 19.52,
    },
    county_names_all: "Van Buren|Scotland",
    county_fips_all: "19177|29199",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52543,
    lat: 41.20065,
    lng: -92.51773,
    city: "Cedar",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 540,
    density: 9.7,
    county_fips: 19123,
    county_name: "Mahaska",
    county_weights: {
      19123: 100,
    },
    county_names_all: "Mahaska",
    county_fips_all: 19123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52544,
    lat: 40.71774,
    lng: -92.90831,
    city: "Centerville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7612,
    density: 21.2,
    county_fips: 19007,
    county_name: "Appanoose",
    county_weights: {
      19007: 100,
    },
    county_names_all: "Appanoose",
    county_fips_all: 19007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52548,
    lat: 41.0855,
    lng: -92.5306,
    city: "Chillicothe",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 99,
    density: 194.6,
    county_fips: 19179,
    county_name: "Wapello",
    county_weights: {
      19179: 100,
    },
    county_names_all: "Wapello",
    county_fips_all: 19179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52549,
    lat: 40.61392,
    lng: -92.94602,
    city: "Cincinnati",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 946,
    density: 8.3,
    county_fips: 19007,
    county_name: "Appanoose",
    county_weights: {
      19007: 100,
    },
    county_names_all: "Appanoose",
    county_fips_all: 19007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52550,
    lat: 41.31635,
    lng: -92.36254,
    city: "Delta",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 602,
    density: 6.1,
    county_fips: 19107,
    county_name: "Keokuk",
    county_weights: {
      19107: 97.62,
      19123: 2.38,
    },
    county_names_all: "Keokuk|Mahaska",
    county_fips_all: "19107|19123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52551,
    lat: 40.81877,
    lng: -92.1058,
    city: "Douds",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 580,
    density: 3.8,
    county_fips: 19177,
    county_name: "Van Buren",
    county_weights: {
      19051: 8.01,
      19177: 91.99,
    },
    county_names_all: "Van Buren|Davis",
    county_fips_all: "19177|19051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52552,
    lat: 40.83552,
    lng: -92.53633,
    city: "Drakesville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1044,
    density: 6.9,
    county_fips: 19051,
    county_name: "Davis",
    county_weights: {
      19051: 95.83,
      19179: 4.17,
    },
    county_names_all: "Davis|Wapello",
    county_fips_all: "19051|19179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52553,
    lat: 41.14865,
    lng: -92.65668,
    city: "Eddyville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1777,
    density: 8.3,
    county_fips: 19179,
    county_name: "Wapello",
    county_weights: {
      19123: 33.86,
      19135: 29.07,
      19179: 37.07,
    },
    county_names_all: "Wapello|Mahaska|Monroe",
    county_fips_all: "19179|19123|19135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52554,
    lat: 40.92562,
    lng: -92.23387,
    city: "Eldon",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1206,
    density: 12.3,
    county_fips: 19179,
    county_name: "Wapello",
    county_weights: {
      19051: 10.44,
      19101: 9.1,
      19177: 4.05,
      19179: 76.41,
    },
    county_names_all: "Wapello|Davis|Jefferson|Van Buren",
    county_fips_all: "19179|19051|19101|19177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52555,
    lat: 40.63905,
    lng: -92.81046,
    city: "Exline",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 281,
    density: 5.1,
    county_fips: 19007,
    county_name: "Appanoose",
    county_weights: {
      19007: 100,
    },
    county_names_all: "Appanoose",
    county_fips_all: 19007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52556,
    lat: 41.01842,
    lng: -91.9264,
    city: "Fairfield",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13440,
    density: 29.6,
    county_fips: 19101,
    county_name: "Jefferson",
    county_weights: {
      19101: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 19101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52557,
    lat: 41.02026,
    lng: -91.96653,
    city: "Fairfield",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74,
    density: 106.9,
    county_fips: 19101,
    county_name: "Jefferson",
    county_weights: {
      19101: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 19101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52560,
    lat: 40.85491,
    lng: -92.25312,
    city: "Floris",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 229,
    density: 2.9,
    county_fips: 19051,
    county_name: "Davis",
    county_weights: {
      19051: 100,
    },
    county_names_all: "Davis",
    county_fips_all: 19051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52561,
    lat: 41.22135,
    lng: -92.44081,
    city: "Fremont",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 906,
    density: 9.4,
    county_fips: 19123,
    county_name: "Mahaska",
    county_weights: {
      19107: 16.3,
      19123: 83.7,
    },
    county_names_all: "Mahaska|Keokuk",
    county_fips_all: "19123|19107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52562,
    lat: 41.26539,
    lng: -92.24858,
    city: "Hayesville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19107,
    county_name: "Keokuk",
    county_weights: {
      19107: 100,
    },
    county_names_all: "Keokuk",
    county_fips_all: 19107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52563,
    lat: 41.17295,
    lng: -92.27765,
    city: "Hedrick",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1709,
    density: 6.1,
    county_fips: 19107,
    county_name: "Keokuk",
    county_weights: {
      19101: 3.49,
      19107: 58.29,
      19179: 38.22,
    },
    county_names_all: "Keokuk|Wapello|Jefferson",
    county_fips_all: "19107|19179|19101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52565,
    lat: 40.74005,
    lng: -91.94332,
    city: "Keosauqua",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1714,
    density: 5.8,
    county_fips: 19177,
    county_name: "Van Buren",
    county_weights: {
      19177: 100,
    },
    county_names_all: "Van Buren",
    county_fips_all: 19177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52566,
    lat: 41.12887,
    lng: -92.50547,
    city: "Kirkville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 251,
    density: 58.6,
    county_fips: 19179,
    county_name: "Wapello",
    county_weights: {
      19179: 100,
    },
    county_names_all: "Wapello",
    county_fips_all: 19179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52567,
    lat: 40.93174,
    lng: -92.07224,
    city: "Libertyville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 651,
    density: 9.9,
    county_fips: 19101,
    county_name: "Jefferson",
    county_weights: {
      19101: 89.28,
      19177: 10.72,
    },
    county_names_all: "Jefferson|Van Buren",
    county_fips_all: "19101|19177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52568,
    lat: 41.1779,
    lng: -92.25077,
    city: "Martinsburg",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19107,
    county_name: "Keokuk",
    county_weights: {
      19107: 100,
    },
    county_names_all: "Keokuk",
    county_fips_all: 19107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52569,
    lat: 40.97968,
    lng: -93.04939,
    city: "Melrose",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 621,
    density: 2.4,
    county_fips: 19135,
    county_name: "Monroe",
    county_weights: {
      19007: 7.15,
      19117: 5.88,
      19135: 80.6,
      19185: 6.37,
    },
    county_names_all: "Monroe|Appanoose|Wayne|Lucas",
    county_fips_all: "19135|19007|19185|19117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52570,
    lat: 40.68656,
    lng: -92.14853,
    city: "Milton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1026,
    density: 6,
    county_fips: 19177,
    county_name: "Van Buren",
    county_weights: {
      19051: 26.38,
      19177: 73.62,
    },
    county_names_all: "Van Buren|Davis",
    county_fips_all: "19177|19051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52571,
    lat: 40.87739,
    lng: -92.83114,
    city: "Moravia",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1468,
    density: 5.9,
    county_fips: 19007,
    county_name: "Appanoose",
    county_weights: {
      19007: 72.52,
      19135: 27.48,
    },
    county_names_all: "Appanoose|Monroe",
    county_fips_all: "19007|19135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52572,
    lat: 40.67795,
    lng: -92.69163,
    city: "Moulton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1184,
    density: 4.6,
    county_fips: 19007,
    county_name: "Appanoose",
    county_weights: {
      19007: 84.12,
      19051: 15.88,
    },
    county_names_all: "Appanoose|Davis",
    county_fips_all: "19007|19051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52573,
    lat: 40.62378,
    lng: -91.92979,
    city: "Mount Sterling",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 193,
    density: 2,
    county_fips: 19177,
    county_name: "Van Buren",
    county_weights: {
      19177: 65.33,
      29045: 23.85,
      29199: 10.82,
    },
    county_names_all: "Van Buren|Clark|Scotland",
    county_fips_all: "19177|29045|29199",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52574,
    lat: 40.80822,
    lng: -92.96948,
    city: "Mystic",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 566,
    density: 5.6,
    county_fips: 19007,
    county_name: "Appanoose",
    county_weights: {
      19007: 100,
    },
    county_names_all: "Appanoose",
    county_fips_all: 19007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52576,
    lat: 41.21337,
    lng: -92.1125,
    city: "Ollie",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 483,
    density: 4,
    county_fips: 19107,
    county_name: "Keokuk",
    county_weights: {
      19101: 1.1,
      19107: 98.9,
    },
    county_names_all: "Keokuk|Jefferson",
    county_fips_all: "19107|19101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52577,
    lat: 41.27174,
    lng: -92.6602,
    city: "Oskaloosa",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15088,
    density: 36.8,
    county_fips: 19123,
    county_name: "Mahaska",
    county_weights: {
      19123: 100,
    },
    county_names_all: "Mahaska",
    county_fips_all: 19123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52580,
    lat: 41.12039,
    lng: -92.09069,
    city: "Packwood",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1000,
    density: 9.6,
    county_fips: 19101,
    county_name: "Jefferson",
    county_weights: {
      19101: 97.57,
      19107: 2.43,
    },
    county_names_all: "Jefferson|Keokuk",
    county_fips_all: "19101|19107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52581,
    lat: 40.80504,
    lng: -93.06265,
    city: "Plano",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 287,
    density: 2.9,
    county_fips: 19007,
    county_name: "Appanoose",
    county_weights: {
      19007: 96.24,
      19185: 3.76,
    },
    county_names_all: "Appanoose|Wayne",
    county_fips_all: "19007|19185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52583,
    lat: 40.80284,
    lng: -93.1555,
    city: "Promise City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 371,
    density: 3.2,
    county_fips: 19185,
    county_name: "Wayne",
    county_weights: {
      19185: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 19185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52584,
    lat: 40.65273,
    lng: -92.24936,
    city: "Pulaski",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 643,
    density: 9,
    county_fips: 19051,
    county_name: "Davis",
    county_weights: {
      19051: 100,
    },
    county_names_all: "Davis",
    county_fips_all: 19051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52585,
    lat: 41.18902,
    lng: -91.98863,
    city: "Richland",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 882,
    density: 6.3,
    county_fips: 19107,
    county_name: "Keokuk",
    county_weights: {
      19101: 29.09,
      19107: 60.35,
      19183: 10.56,
    },
    county_names_all: "Keokuk|Jefferson|Washington",
    county_fips_all: "19107|19101|19183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52586,
    lat: 41.34573,
    lng: -92.46694,
    city: "Rose Hill",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 600,
    density: 5,
    county_fips: 19123,
    county_name: "Mahaska",
    county_weights: {
      19107: 3.14,
      19123: 96.86,
    },
    county_names_all: "Mahaska|Keokuk",
    county_fips_all: "19123|19107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52588,
    lat: 40.86325,
    lng: -92.16315,
    city: "Selma",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26,
    density: 0.6,
    county_fips: 19177,
    county_name: "Van Buren",
    county_weights: {
      19051: 30.95,
      19101: 1.91,
      19177: 67.14,
    },
    county_names_all: "Van Buren|Davis|Jefferson",
    county_fips_all: "19177|19051|19101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52590,
    lat: 40.6654,
    lng: -93.13594,
    city: "Seymour",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1003,
    density: 4.8,
    county_fips: 19185,
    county_name: "Wayne",
    county_weights: {
      19007: 21.1,
      19185: 78.9,
    },
    county_names_all: "Wayne|Appanoose",
    county_fips_all: "19185|19007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52591,
    lat: 41.31988,
    lng: -92.19465,
    city: "Sigourney",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2966,
    density: 9.2,
    county_fips: 19107,
    county_name: "Keokuk",
    county_weights: {
      19107: 100,
    },
    county_names_all: "Keokuk",
    county_fips_all: 19107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52593,
    lat: 40.77363,
    lng: -92.73955,
    city: "Udell",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 165,
    density: 3.9,
    county_fips: 19007,
    county_name: "Appanoose",
    county_weights: {
      19007: 100,
    },
    county_names_all: "Appanoose",
    county_fips_all: 19007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52594,
    lat: 40.83561,
    lng: -92.64957,
    city: "Unionville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 495,
    density: 4.1,
    county_fips: 19007,
    county_name: "Appanoose",
    county_weights: {
      19007: 61.7,
      19051: 38.3,
    },
    county_names_all: "Appanoose|Davis",
    county_fips_all: "19007|19051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52595,
    lat: 41.28847,
    lng: -92.61506,
    city: "University Park",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 485,
    density: 396.9,
    county_fips: 19123,
    county_name: "Mahaska",
    county_weights: {
      19123: 100,
    },
    county_names_all: "Mahaska",
    county_fips_all: 19123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52601,
    lat: 40.8551,
    lng: -91.111,
    city: "Burlington",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28354,
    density: 100.1,
    county_fips: 19057,
    county_name: "Des Moines",
    county_weights: {
      19057: 100,
    },
    county_names_all: "Des Moines",
    county_fips_all: 19057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52619,
    lat: 40.5246,
    lng: -91.56566,
    city: "Argyle",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 743,
    density: 8.1,
    county_fips: 19111,
    county_name: "Lee",
    county_weights: {
      19111: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 19111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52620,
    lat: 40.7032,
    lng: -91.79563,
    city: "Bonaparte",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 898,
    density: 6.4,
    county_fips: 19177,
    county_name: "Van Buren",
    county_weights: {
      19177: 100,
    },
    county_names_all: "Van Buren",
    county_fips_all: 19177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52621,
    lat: 41.20821,
    lng: -91.53209,
    city: "Crawfordsville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 820,
    density: 7.7,
    county_fips: 19183,
    county_name: "Washington",
    county_weights: {
      19115: 15.36,
      19183: 84.64,
    },
    county_names_all: "Washington|Louisa",
    county_fips_all: "19183|19115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52623,
    lat: 40.85569,
    lng: -91.33998,
    city: "Danville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1850,
    density: 12.7,
    county_fips: 19057,
    county_name: "Des Moines",
    county_weights: {
      19057: 77.18,
      19087: 22.82,
    },
    county_names_all: "Des Moines|Henry",
    county_fips_all: "19057|19087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52624,
    lat: 40.7348,
    lng: -91.33609,
    city: "Denmark",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 422,
    density: 176.2,
    county_fips: 19111,
    county_name: "Lee",
    county_weights: {
      19111: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 19111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52625,
    lat: 40.66604,
    lng: -91.57094,
    city: "Donnellson",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2529,
    density: 9.1,
    county_fips: 19111,
    county_name: "Lee",
    county_weights: {
      19111: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 19111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52626,
    lat: 40.63201,
    lng: -91.72119,
    city: "Farmington",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1264,
    density: 5.5,
    county_fips: 19111,
    county_name: "Lee",
    county_weights: {
      19111: 54.1,
      19177: 24.67,
      29045: 21.23,
    },
    county_names_all: "Lee|Van Buren|Clark",
    county_fips_all: "19111|19177|29045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52627,
    lat: 40.65973,
    lng: -91.35145,
    city: "Fort Madison",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12486,
    density: 75.5,
    county_fips: 19111,
    county_name: "Lee",
    county_weights: {
      19111: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 19111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52630,
    lat: 40.80375,
    lng: -91.7038,
    city: "Hillsboro",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 313,
    density: 3,
    county_fips: 19111,
    county_name: "Lee",
    county_weights: {
      19087: 27.87,
      19111: 38.8,
      19177: 33.33,
    },
    county_names_all: "Lee|Van Buren|Henry",
    county_fips_all: "19111|19177|19087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52631,
    lat: 40.78308,
    lng: -91.61209,
    city: "Houghton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19111,
    county_name: "Lee",
    county_weights: {
      19111: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 19111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52632,
    lat: 40.44072,
    lng: -91.43973,
    city: "Keokuk",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12651,
    density: 94.3,
    county_fips: 19111,
    county_name: "Lee",
    county_weights: {
      19111: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 19111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52635,
    lat: 40.99117,
    lng: -91.75843,
    city: "Lockridge",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1232,
    density: 11,
    county_fips: 19101,
    county_name: "Jefferson",
    county_weights: {
      19087: 6.45,
      19101: 93.55,
    },
    county_names_all: "Jefferson|Henry",
    county_fips_all: "19101|19087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52637,
    lat: 41.01949,
    lng: -91.13774,
    city: "Mediapolis",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3014,
    density: 16.6,
    county_fips: 19057,
    county_name: "Des Moines",
    county_weights: {
      19057: 100,
    },
    county_names_all: "Des Moines",
    county_fips_all: 19057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52638,
    lat: 40.79864,
    lng: -91.24577,
    city: "Middletown",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 607,
    density: 6.9,
    county_fips: 19057,
    county_name: "Des Moines",
    county_weights: {
      19057: 100,
    },
    county_names_all: "Des Moines",
    county_fips_all: 19057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52639,
    lat: 40.52763,
    lng: -91.46409,
    city: "Montrose",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1782,
    density: 17.6,
    county_fips: 19111,
    county_name: "Lee",
    county_weights: {
      19111: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 19111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52640,
    lat: 41.09649,
    lng: -91.28205,
    city: "Morning Sun",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1510,
    density: 8.5,
    county_fips: 19115,
    county_name: "Louisa",
    county_weights: {
      19057: 33.4,
      19115: 66.6,
    },
    county_names_all: "Louisa|Des Moines",
    county_fips_all: "19115|19057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52641,
    lat: 40.98799,
    lng: -91.58531,
    city: "Mount Pleasant",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11941,
    density: 21.8,
    county_fips: 19087,
    county_name: "Henry",
    county_weights: {
      19087: 96,
      19101: 1.82,
      19183: 2.18,
    },
    county_names_all: "Henry|Washington|Jefferson",
    county_fips_all: "19087|19183|19101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52644,
    lat: 41.03988,
    lng: -91.41535,
    city: "Mount Union",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 414,
    density: 3.7,
    county_fips: 19087,
    county_name: "Henry",
    county_weights: {
      19057: 14.88,
      19087: 85.12,
    },
    county_names_all: "Henry|Des Moines",
    county_fips_all: "19087|19057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52645,
    lat: 40.91429,
    lng: -91.40138,
    city: "New London",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3761,
    density: 20.6,
    county_fips: 19087,
    county_name: "Henry",
    county_weights: {
      19057: 29.84,
      19087: 70.16,
    },
    county_names_all: "Henry|Des Moines",
    county_fips_all: "19087|19057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52646,
    lat: 41.06706,
    lng: -91.00072,
    city: "Oakville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 334,
    density: 2.4,
    county_fips: 19057,
    county_name: "Des Moines",
    county_weights: {
      19057: 53.14,
      19115: 46.86,
    },
    county_names_all: "Des Moines|Louisa",
    county_fips_all: "19057|19115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52647,
    lat: 41.1342,
    lng: -91.54506,
    city: "Olds",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 166,
    density: 225.3,
    county_fips: 19087,
    county_name: "Henry",
    county_weights: {
      19087: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 19087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52649,
    lat: 40.83827,
    lng: -91.60647,
    city: "Salem",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1006,
    density: 9.3,
    county_fips: 19087,
    county_name: "Henry",
    county_weights: {
      19087: 74.69,
      19111: 25.31,
    },
    county_names_all: "Henry|Lee",
    county_fips_all: "19087|19111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52650,
    lat: 40.94782,
    lng: -91.15687,
    city: "Sperry",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 652,
    density: 6.6,
    county_fips: 19057,
    county_name: "Des Moines",
    county_weights: {
      19057: 100,
    },
    county_names_all: "Des Moines",
    county_fips_all: 19057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52651,
    lat: 40.85819,
    lng: -91.81323,
    city: "Stockport",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 571,
    density: 3.5,
    county_fips: 19177,
    county_name: "Van Buren",
    county_weights: {
      19101: 10.41,
      19177: 89.59,
    },
    county_names_all: "Van Buren|Jefferson",
    county_fips_all: "19177|19101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52652,
    lat: 41.09796,
    lng: -91.5542,
    city: "Swedesburg",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19087,
    county_name: "Henry",
    county_weights: {
      19087: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 19087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52653,
    lat: 41.16642,
    lng: -91.15597,
    city: "Wapello",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3175,
    density: 11,
    county_fips: 19115,
    county_name: "Louisa",
    county_weights: {
      19115: 100,
    },
    county_names_all: "Louisa",
    county_fips_all: 19115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52654,
    lat: 41.13581,
    lng: -91.66898,
    city: "Wayland",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1668,
    density: 11.8,
    county_fips: 19087,
    county_name: "Henry",
    county_weights: {
      19087: 67.2,
      19101: 2.32,
      19183: 30.48,
    },
    county_names_all: "Henry|Washington|Jefferson",
    county_fips_all: "19087|19183|19101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52655,
    lat: 40.84768,
    lng: -91.21174,
    city: "West Burlington",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3978,
    density: 87.7,
    county_fips: 19057,
    county_name: "Des Moines",
    county_weights: {
      19057: 100,
    },
    county_names_all: "Des Moines",
    county_fips_all: 19057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52656,
    lat: 40.73844,
    lng: -91.4611,
    city: "West Point",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2097,
    density: 8.2,
    county_fips: 19111,
    county_name: "Lee",
    county_weights: {
      19087: 1.17,
      19111: 98.83,
    },
    county_names_all: "Lee|Henry",
    county_fips_all: "19111|19087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52657,
    lat: 40.76784,
    lng: -91.5164,
    city: "Saint Paul",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53,
    density: 53.8,
    county_fips: 19111,
    county_name: "Lee",
    county_weights: {
      19111: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 19111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52658,
    lat: 40.69998,
    lng: -91.22657,
    city: "Wever",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 857,
    density: 7,
    county_fips: 19111,
    county_name: "Lee",
    county_weights: {
      19057: 1.71,
      19111: 98.29,
    },
    county_names_all: "Lee|Des Moines",
    county_fips_all: "19111|19057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52659,
    lat: 41.13285,
    lng: -91.43658,
    city: "Winfield",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1341,
    density: 7.7,
    county_fips: 19087,
    county_name: "Henry",
    county_weights: {
      19087: 70.58,
      19115: 29.42,
    },
    county_names_all: "Henry|Louisa",
    county_fips_all: "19087|19115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52660,
    lat: 40.99146,
    lng: -91.29998,
    city: "Yarmouth",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 144,
    density: 2.3,
    county_fips: 19057,
    county_name: "Des Moines",
    county_weights: {
      19057: 100,
    },
    county_names_all: "Des Moines",
    county_fips_all: 19057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52701,
    lat: 41.98198,
    lng: -90.24908,
    city: "Andover",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 160,
    density: 98,
    county_fips: 19045,
    county_name: "Clinton",
    county_weights: {
      19045: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 19045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52720,
    lat: 41.59064,
    lng: -91.16578,
    city: "Atalissa",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 751,
    density: 7,
    county_fips: 19139,
    county_name: "Muscatine",
    county_weights: {
      19031: 36.76,
      19139: 63.24,
    },
    county_names_all: "Muscatine|Cedar",
    county_fips_all: "19139|19031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52721,
    lat: 41.75588,
    lng: -90.9633,
    city: "Bennett",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 928,
    density: 8.8,
    county_fips: 19031,
    county_name: "Cedar",
    county_weights: {
      19031: 100,
    },
    county_names_all: "Cedar",
    county_fips_all: 19031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52722,
    lat: 41.56633,
    lng: -90.4673,
    city: "Bettendorf",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37835,
    density: 555.2,
    county_fips: 19163,
    county_name: "Scott",
    county_weights: {
      19163: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 19163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52726,
    lat: 41.50092,
    lng: -90.78419,
    city: "Blue Grass",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5374,
    density: 63.3,
    county_fips: 19163,
    county_name: "Scott",
    county_weights: {
      19139: 45.29,
      19163: 54.71,
    },
    county_names_all: "Scott|Muscatine",
    county_fips_all: "19163|19139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52727,
    lat: 41.95834,
    lng: -90.33341,
    city: "Bryant",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 284,
    density: 4.5,
    county_fips: 19045,
    county_name: "Clinton",
    county_weights: {
      19045: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 19045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52728,
    lat: 41.45907,
    lng: -90.72592,
    city: "Buffalo",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1013,
    density: 127.3,
    county_fips: 19163,
    county_name: "Scott",
    county_weights: {
      19163: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 19163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52729,
    lat: 41.80063,
    lng: -90.74312,
    city: "Calamus",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 886,
    density: 8.6,
    county_fips: 19045,
    county_name: "Clinton",
    county_weights: {
      19045: 98.79,
      19163: 1.21,
    },
    county_names_all: "Clinton|Scott",
    county_fips_all: "19045|19163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52730,
    lat: 41.77366,
    lng: -90.34364,
    city: "Camanche",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4906,
    density: 50,
    county_fips: 19045,
    county_name: "Clinton",
    county_weights: {
      19045: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 19045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52731,
    lat: 41.96637,
    lng: -90.48551,
    city: "Charlotte",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 662,
    density: 4.9,
    county_fips: 19045,
    county_name: "Clinton",
    county_weights: {
      19045: 98.22,
      19097: 1.78,
    },
    county_names_all: "Clinton|Jackson",
    county_fips_all: "19045|19097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52732,
    lat: 41.90126,
    lng: -90.25083,
    city: "Clinton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26717,
    density: 94.1,
    county_fips: 19045,
    county_name: "Clinton",
    county_weights: {
      19045: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 19045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52737,
    lat: 41.25918,
    lng: -91.37478,
    city: "Columbus City",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 387,
    density: 621.5,
    county_fips: 19115,
    county_name: "Louisa",
    county_weights: {
      19115: 100,
    },
    county_names_all: "Louisa",
    county_fips_all: 19115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52738,
    lat: 41.2736,
    lng: -91.38072,
    city: "Columbus Junction",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3649,
    density: 11.5,
    county_fips: 19115,
    county_name: "Louisa",
    county_weights: {
      19115: 97.37,
      19183: 2.63,
    },
    county_names_all: "Louisa|Washington",
    county_fips_all: "19115|19183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52739,
    lat: 41.3728,
    lng: -91.36823,
    city: "Conesville",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 763,
    density: 9,
    county_fips: 19115,
    county_name: "Louisa",
    county_weights: {
      19115: 56.6,
      19139: 43.4,
    },
    county_names_all: "Louisa|Muscatine",
    county_fips_all: "19115|19139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52742,
    lat: 41.83616,
    lng: -90.51076,
    city: "De Witt",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7385,
    density: 24.4,
    county_fips: 19045,
    county_name: "Clinton",
    county_weights: {
      19045: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 19045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52745,
    lat: 41.71502,
    lng: -90.75783,
    city: "Dixon",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 419,
    density: 6.1,
    county_fips: 19163,
    county_name: "Scott",
    county_weights: {
      19163: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 19163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52746,
    lat: 41.71945,
    lng: -90.67172,
    city: "Donahue",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1126,
    density: 16.5,
    county_fips: 19163,
    county_name: "Scott",
    county_weights: {
      19163: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 19163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52747,
    lat: 41.59758,
    lng: -90.91147,
    city: "Durant",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1945,
    density: 25,
    county_fips: 19139,
    county_name: "Muscatine",
    county_weights: {
      19031: 36.12,
      19139: 45.43,
      19163: 18.45,
    },
    county_names_all: "Muscatine|Cedar|Scott",
    county_fips_all: "19139|19031|19163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52748,
    lat: 41.66471,
    lng: -90.55713,
    city: "Eldridge",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10421,
    density: 100.1,
    county_fips: 19163,
    county_name: "Scott",
    county_weights: {
      19163: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 19163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52749,
    lat: 41.34608,
    lng: -91.13112,
    city: "Fruitland",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1083,
    density: 194.9,
    county_fips: 19139,
    county_name: "Muscatine",
    county_weights: {
      19115: 0.22,
      19139: 99.78,
    },
    county_names_all: "Muscatine|Louisa",
    county_fips_all: "19139|19115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52750,
    lat: 41.933,
    lng: -90.39302,
    city: "Goose Lake",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 569,
    density: 7.5,
    county_fips: 19045,
    county_name: "Clinton",
    county_weights: {
      19045: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 19045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52751,
    lat: 41.8519,
    lng: -90.68398,
    city: "Grand Mound",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 850,
    density: 6.5,
    county_fips: 19045,
    county_name: "Clinton",
    county_weights: {
      19045: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 19045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52752,
    lat: 41.27465,
    lng: -91.1911,
    city: "Grandview",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 416,
    density: 415.2,
    county_fips: 19115,
    county_name: "Louisa",
    county_weights: {
      19115: 100,
    },
    county_names_all: "Louisa",
    county_fips_all: 19115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52753,
    lat: 41.62544,
    lng: -90.38989,
    city: "Le Claire",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5461,
    density: 85.3,
    county_fips: 19163,
    county_name: "Scott",
    county_weights: {
      19163: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 19163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52754,
    lat: 41.34254,
    lng: -91.24144,
    city: "Letts",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1328,
    density: 7.1,
    county_fips: 19139,
    county_name: "Muscatine",
    county_weights: {
      19115: 46.44,
      19139: 53.56,
    },
    county_names_all: "Muscatine|Louisa",
    county_fips_all: "19139|19115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52755,
    lat: 41.48015,
    lng: -91.43349,
    city: "Lone Tree",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2284,
    density: 15.3,
    county_fips: 19103,
    county_name: "Johnson",
    county_weights: {
      19103: 91.39,
      19115: 8.61,
    },
    county_names_all: "Johnson|Louisa",
    county_fips_all: "19103|19115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52756,
    lat: 41.72966,
    lng: -90.54084,
    city: "Long Grove",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1650,
    density: 14.4,
    county_fips: 19163,
    county_name: "Scott",
    county_weights: {
      19163: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 19163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52757,
    lat: 41.80337,
    lng: -90.3552,
    city: "Low Moor",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 263,
    density: 207.1,
    county_fips: 19045,
    county_name: "Clinton",
    county_weights: {
      19045: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 19045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52758,
    lat: 41.74405,
    lng: -90.44104,
    city: "McCausland",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 311,
    density: 143.3,
    county_fips: 19163,
    county_name: "Scott",
    county_weights: {
      19163: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 19163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52759,
    lat: 41.46043,
    lng: -90.80989,
    city: "Montpelier",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19139,
    county_name: "Muscatine",
    county_weights: {
      19139: 100,
    },
    county_names_all: "Muscatine",
    county_fips_all: 19139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52760,
    lat: 41.58255,
    lng: -91.09853,
    city: "Moscow",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 424,
    density: 7.5,
    county_fips: 19139,
    county_name: "Muscatine",
    county_weights: {
      19031: 41.42,
      19139: 58.58,
    },
    county_names_all: "Muscatine|Cedar",
    county_fips_all: "19139|19031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52761,
    lat: 41.43798,
    lng: -91.05802,
    city: "Muscatine",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30353,
    density: 65.8,
    county_fips: 19139,
    county_name: "Muscatine",
    county_weights: {
      19115: 10.01,
      19139: 89.99,
    },
    county_names_all: "Muscatine|Louisa",
    county_fips_all: "19139|19115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52765,
    lat: 41.72182,
    lng: -90.87274,
    city: "New Liberty",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 332,
    density: 4,
    county_fips: 19163,
    county_name: "Scott",
    county_weights: {
      19031: 23.04,
      19163: 76.96,
    },
    county_names_all: "Scott|Cedar",
    county_fips_all: "19163|19031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52766,
    lat: 41.46407,
    lng: -91.30061,
    city: "Nichols",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 758,
    density: 6,
    county_fips: 19139,
    county_name: "Muscatine",
    county_weights: {
      19103: 5.46,
      19139: 94.54,
    },
    county_names_all: "Muscatine|Johnson",
    county_fips_all: "19139|19103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52767,
    lat: 41.57356,
    lng: -90.42326,
    city: "Pleasant Valley",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75,
    density: 21.1,
    county_fips: 19163,
    county_name: "Scott",
    county_weights: {
      19163: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 19163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52768,
    lat: 41.69906,
    lng: -90.38977,
    city: "Princeton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1446,
    density: 17.4,
    county_fips: 19163,
    county_name: "Scott",
    county_weights: {
      19163: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 19163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52769,
    lat: 41.60836,
    lng: -90.8416,
    city: "Stockton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 636,
    density: 5.8,
    county_fips: 19163,
    county_name: "Scott",
    county_weights: {
      19139: 49.12,
      19163: 50.88,
    },
    county_names_all: "Scott|Muscatine",
    county_fips_all: "19163|19139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52771,
    lat: 42.01958,
    lng: -90.25707,
    city: "Teeds Grove",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 19045,
    county_name: "Clinton",
    county_weights: {
      19045: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 19045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52772,
    lat: 41.75006,
    lng: -91.14083,
    city: "Tipton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5368,
    density: 15.9,
    county_fips: 19031,
    county_name: "Cedar",
    county_weights: {
      19031: 100,
    },
    county_names_all: "Cedar",
    county_fips_all: 19031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52773,
    lat: 41.62187,
    lng: -90.75529,
    city: "Walcott",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2912,
    density: 20.3,
    county_fips: 19163,
    county_name: "Scott",
    county_weights: {
      19139: 3.58,
      19163: 96.42,
    },
    county_names_all: "Scott|Muscatine",
    county_fips_all: "19163|19139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52774,
    lat: 41.90743,
    lng: -90.59596,
    city: "Welton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 121,
    density: 156.4,
    county_fips: 19045,
    county_name: "Clinton",
    county_weights: {
      19045: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 19045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52776,
    lat: 41.5795,
    lng: -91.275,
    city: "West Liberty",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4993,
    density: 22.1,
    county_fips: 19139,
    county_name: "Muscatine",
    county_weights: {
      19031: 34.31,
      19103: 3.3,
      19139: 62.39,
    },
    county_names_all: "Muscatine|Cedar|Johnson",
    county_fips_all: "19139|19031|19103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52777,
    lat: 41.84739,
    lng: -90.85529,
    city: "Wheatland",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1409,
    density: 9.8,
    county_fips: 19045,
    county_name: "Clinton",
    county_weights: {
      19031: 7.46,
      19045: 92.54,
    },
    county_names_all: "Clinton|Cedar",
    county_fips_all: "19045|19031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52778,
    lat: 41.61115,
    lng: -91.00066,
    city: "Wilton",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3866,
    density: 19.8,
    county_fips: 19031,
    county_name: "Cedar",
    county_weights: {
      19031: 60.33,
      19139: 39.67,
    },
    county_names_all: "Cedar|Muscatine",
    county_fips_all: "19031|19139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52801,
    lat: 41.52082,
    lng: -90.57483,
    city: "Davenport",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1297,
    density: 1293.4,
    county_fips: 19163,
    county_name: "Scott",
    county_weights: {
      19163: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 19163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52802,
    lat: 41.49908,
    lng: -90.63621,
    city: "Davenport",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9913,
    density: 367,
    county_fips: 19163,
    county_name: "Scott",
    county_weights: {
      19163: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 19163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52803,
    lat: 41.53871,
    lng: -90.55623,
    city: "Davenport",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21291,
    density: 1599.5,
    county_fips: 19163,
    county_name: "Scott",
    county_weights: {
      19163: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 19163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52804,
    lat: 41.53584,
    lng: -90.68081,
    city: "Davenport",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28169,
    density: 330.7,
    county_fips: 19163,
    county_name: "Scott",
    county_weights: {
      19163: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 19163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52806,
    lat: 41.58918,
    lng: -90.62553,
    city: "Davenport",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27869,
    density: 346.2,
    county_fips: 19163,
    county_name: "Scott",
    county_weights: {
      19163: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 19163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 52807,
    lat: 41.61061,
    lng: -90.51634,
    city: "Davenport",
    state_id: "IA",
    state_name: "Iowa",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16357,
    density: 220.9,
    county_fips: 19163,
    county_name: "Scott",
    county_weights: {
      19163: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 19163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53001,
    lat: 43.60562,
    lng: -88.05217,
    city: "Adell",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1806,
    density: 24.4,
    county_fips: 55117,
    county_name: "Sheboygan",
    county_weights: {
      55117: 100,
    },
    county_names_all: "Sheboygan",
    county_fips_all: 55117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53002,
    lat: 43.46896,
    lng: -88.35454,
    city: "Allenton",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2181,
    density: 24.5,
    county_fips: 55131,
    county_name: "Washington",
    county_weights: {
      55027: 2.09,
      55131: 97.91,
    },
    county_names_all: "Washington|Dodge",
    county_fips_all: "55131|55027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53003,
    lat: 43.21226,
    lng: -88.51957,
    city: "Ashippun",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 138,
    density: 322.2,
    county_fips: 55027,
    county_name: "Dodge",
    county_weights: {
      55027: 100,
    },
    county_names_all: "Dodge",
    county_fips_all: 55027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53004,
    lat: 43.4995,
    lng: -87.8805,
    city: "Belgium",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3428,
    density: 39.4,
    county_fips: 55089,
    county_name: "Ozaukee",
    county_weights: {
      55089: 100,
    },
    county_names_all: "Ozaukee",
    county_fips_all: 55089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53005,
    lat: 43.0625,
    lng: -88.0992,
    city: "Brookfield",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20514,
    density: 539.2,
    county_fips: 55133,
    county_name: "Waukesha",
    county_weights: {
      55133: 100,
    },
    county_names_all: "Waukesha",
    county_fips_all: 55133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53006,
    lat: 43.62103,
    lng: -88.53534,
    city: "Brownsville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1735,
    density: 16.7,
    county_fips: 55027,
    county_name: "Dodge",
    county_weights: {
      55027: 73.94,
      55039: 26.06,
    },
    county_names_all: "Dodge|Fond du Lac",
    county_fips_all: "55027|55039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53007,
    lat: 43.10825,
    lng: -88.07116,
    city: "Butler",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1964,
    density: 985.7,
    county_fips: 55133,
    county_name: "Waukesha",
    county_weights: {
      55133: 100,
    },
    county_names_all: "Waukesha",
    county_fips_all: 55133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53010,
    lat: 43.61121,
    lng: -88.27901,
    city: "Campbellsport",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8099,
    density: 29.9,
    county_fips: 55039,
    county_name: "Fond du Lac",
    county_weights: {
      55027: 0.21,
      55039: 95.02,
      55131: 4.77,
    },
    county_names_all: "Fond du Lac|Washington|Dodge",
    county_fips_all: "55039|55131|55027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53011,
    lat: 43.65755,
    lng: -88.08123,
    city: "Cascade",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2051,
    density: 20.7,
    county_fips: 55117,
    county_name: "Sheboygan",
    county_weights: {
      55039: 1.34,
      55117: 98.66,
    },
    county_names_all: "Sheboygan|Fond du Lac",
    county_fips_all: "55117|55039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53012,
    lat: 43.31369,
    lng: -88.03704,
    city: "Cedarburg",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18532,
    density: 211.3,
    county_fips: 55089,
    county_name: "Ozaukee",
    county_weights: {
      55089: 68.62,
      55131: 31.38,
    },
    county_names_all: "Ozaukee|Washington",
    county_fips_all: "55089|55131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53013,
    lat: 43.56585,
    lng: -87.85172,
    city: "Cedar Grove",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3428,
    density: 44.5,
    county_fips: 55117,
    county_name: "Sheboygan",
    county_weights: {
      55089: 18.6,
      55117: 81.4,
    },
    county_names_all: "Sheboygan|Ozaukee",
    county_fips_all: "55117|55089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53014,
    lat: 44.02298,
    lng: -88.17549,
    city: "Chilton",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7512,
    density: 22.2,
    county_fips: 55015,
    county_name: "Calumet",
    county_weights: {
      55015: 87.72,
      55039: 1.06,
      55071: 11.22,
    },
    county_names_all: "Calumet|Manitowoc|Fond du Lac",
    county_fips_all: "55015|55071|55039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53015,
    lat: 43.90534,
    lng: -87.79296,
    city: "Cleveland",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2916,
    density: 27.6,
    county_fips: 55071,
    county_name: "Manitowoc",
    county_weights: {
      55071: 64.8,
      55117: 35.2,
    },
    county_names_all: "Manitowoc|Sheboygan",
    county_fips_all: "55071|55117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53016,
    lat: 43.31104,
    lng: -88.71794,
    city: "Clyman",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 346,
    density: 217.5,
    county_fips: 55027,
    county_name: "Dodge",
    county_weights: {
      55027: 100,
    },
    county_names_all: "Dodge",
    county_fips_all: 55027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53017,
    lat: 43.2044,
    lng: -88.2526,
    city: "Colgate",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5494,
    density: 123,
    county_fips: 55131,
    county_name: "Washington",
    county_weights: {
      55131: 87.52,
      55133: 12.48,
    },
    county_names_all: "Washington|Waukesha",
    county_fips_all: "55131|55133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53018,
    lat: 43.04809,
    lng: -88.39278,
    city: "Delafield",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8031,
    density: 276.4,
    county_fips: 55133,
    county_name: "Waukesha",
    county_weights: {
      55133: 100,
    },
    county_names_all: "Waukesha",
    county_fips_all: 55133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53019,
    lat: 43.69667,
    lng: -88.30752,
    city: "Eden",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1763,
    density: 19.2,
    county_fips: 55039,
    county_name: "Fond du Lac",
    county_weights: {
      55039: 100,
    },
    county_names_all: "Fond du Lac",
    county_fips_all: 55039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53020,
    lat: 43.86231,
    lng: -88.01364,
    city: "Elkhart Lake",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3845,
    density: 23.7,
    county_fips: 55117,
    county_name: "Sheboygan",
    county_weights: {
      55015: 1.74,
      55071: 2.97,
      55117: 95.29,
    },
    county_names_all: "Sheboygan|Manitowoc|Calumet",
    county_fips_all: "55117|55071|55015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53021,
    lat: 43.49425,
    lng: -88.00111,
    city: "Fredonia",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4619,
    density: 53.4,
    county_fips: 55089,
    county_name: "Ozaukee",
    county_weights: {
      55089: 80.88,
      55117: 0.84,
      55131: 18.28,
    },
    county_names_all: "Ozaukee|Washington|Sheboygan",
    county_fips_all: "55089|55131|55117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53022,
    lat: 43.23062,
    lng: -88.11286,
    city: "Germantown",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19665,
    density: 274,
    county_fips: 55131,
    county_name: "Washington",
    county_weights: {
      55131: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 55131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53023,
    lat: 43.78198,
    lng: -88.10745,
    city: "Glenbeulah",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2435,
    density: 24.1,
    county_fips: 55117,
    county_name: "Sheboygan",
    county_weights: {
      55117: 100,
    },
    county_names_all: "Sheboygan",
    county_fips_all: 55117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53024,
    lat: 43.33233,
    lng: -87.93299,
    city: "Grafton",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17977,
    density: 252.2,
    county_fips: 55089,
    county_name: "Ozaukee",
    county_weights: {
      55089: 100,
    },
    county_names_all: "Ozaukee",
    county_fips_all: 55089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53027,
    lat: 43.31697,
    lng: -88.37356,
    city: "Hartford",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23361,
    density: 99.1,
    county_fips: 55131,
    county_name: "Washington",
    county_weights: {
      55027: 17.16,
      55131: 82.84,
    },
    county_names_all: "Washington|Dodge",
    county_fips_all: "55131|55027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53029,
    lat: 43.14381,
    lng: -88.34624,
    city: "Hartland",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21484,
    density: 220.6,
    county_fips: 55133,
    county_name: "Waukesha",
    county_weights: {
      55131: 2.86,
      55133: 97.14,
    },
    county_names_all: "Waukesha|Washington",
    county_fips_all: "55133|55131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53031,
    lat: 43.64036,
    lng: -87.91778,
    city: "Hingham",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 55117,
    county_name: "Sheboygan",
    county_weights: {
      55117: 100,
    },
    county_names_all: "Sheboygan",
    county_fips_all: 55117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53032,
    lat: 43.44708,
    lng: -88.6234,
    city: "Horicon",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4860,
    density: 63.5,
    county_fips: 55027,
    county_name: "Dodge",
    county_weights: {
      55027: 100,
    },
    county_names_all: "Dodge",
    county_fips_all: 55027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53033,
    lat: 43.23716,
    lng: -88.25634,
    city: "Hubertus",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4924,
    density: 119,
    county_fips: 55131,
    county_name: "Washington",
    county_weights: {
      55131: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 55131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53034,
    lat: 43.34014,
    lng: -88.60746,
    city: "Hustisford",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1629,
    density: 81.5,
    county_fips: 55027,
    county_name: "Dodge",
    county_weights: {
      55027: 100,
    },
    county_names_all: "Dodge",
    county_fips_all: 55027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53035,
    lat: 43.39135,
    lng: -88.54355,
    city: "Iron Ridge",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2206,
    density: 25,
    county_fips: 55027,
    county_name: "Dodge",
    county_weights: {
      55027: 100,
    },
    county_names_all: "Dodge",
    county_fips_all: 55027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53036,
    lat: 43.17141,
    lng: -88.57693,
    city: "Ixonia",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3009,
    density: 40.6,
    county_fips: 55055,
    county_name: "Jefferson",
    county_weights: {
      55027: 24.76,
      55055: 70.41,
      55133: 4.83,
    },
    county_names_all: "Jefferson|Dodge|Waukesha",
    county_fips_all: "55055|55027|55133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53037,
    lat: 43.31255,
    lng: -88.16108,
    city: "Jackson",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9823,
    density: 164.2,
    county_fips: 55131,
    county_name: "Washington",
    county_weights: {
      55131: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 55131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53038,
    lat: 43.08592,
    lng: -88.79031,
    city: "Johnson Creek",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4402,
    density: 55,
    county_fips: 55055,
    county_name: "Jefferson",
    county_weights: {
      55055: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 55055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53039,
    lat: 43.36931,
    lng: -88.71148,
    city: "Juneau",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4637,
    density: 25,
    county_fips: 55027,
    county_name: "Dodge",
    county_weights: {
      55027: 100,
    },
    county_names_all: "Dodge",
    county_fips_all: 55027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53040,
    lat: 43.52126,
    lng: -88.19198,
    city: "Kewaskum",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8252,
    density: 50.6,
    county_fips: 55131,
    county_name: "Washington",
    county_weights: {
      55039: 10.67,
      55117: 12.64,
      55131: 76.69,
    },
    county_names_all: "Washington|Sheboygan|Fond du Lac",
    county_fips_all: "55131|55117|55039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53042,
    lat: 43.95144,
    lng: -87.98216,
    city: "Kiel",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6432,
    density: 40.1,
    county_fips: 55071,
    county_name: "Manitowoc",
    county_weights: {
      55015: 8.94,
      55071: 91.06,
    },
    county_names_all: "Manitowoc|Calumet",
    county_fips_all: "55071|55015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53044,
    lat: 43.73793,
    lng: -87.78327,
    city: "Kohler",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2115,
    density: 145.3,
    county_fips: 55117,
    county_name: "Sheboygan",
    county_weights: {
      55117: 100,
    },
    county_names_all: "Sheboygan",
    county_fips_all: 55117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53045,
    lat: 43.061,
    lng: -88.15145,
    city: "Brookfield",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21464,
    density: 574.9,
    county_fips: 55133,
    county_name: "Waukesha",
    county_weights: {
      55133: 100,
    },
    county_names_all: "Waukesha",
    county_fips_all: 55133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53046,
    lat: 43.15215,
    lng: -88.16045,
    city: "Lannon",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1184,
    density: 184.9,
    county_fips: 55133,
    county_name: "Waukesha",
    county_weights: {
      55133: 100,
    },
    county_names_all: "Waukesha",
    county_fips_all: 55133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53047,
    lat: 43.25904,
    lng: -88.63002,
    city: "Lebanon",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45,
    density: 43.4,
    county_fips: 55027,
    county_name: "Dodge",
    county_weights: {
      55027: 100,
    },
    county_names_all: "Dodge",
    county_fips_all: 55027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53048,
    lat: 43.57935,
    lng: -88.45554,
    city: "Lomira",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3119,
    density: 44.8,
    county_fips: 55027,
    county_name: "Dodge",
    county_weights: {
      55027: 96.35,
      55039: 3.65,
    },
    county_names_all: "Dodge|Fond du Lac",
    county_fips_all: "55027|55039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53049,
    lat: 43.8853,
    lng: -88.28917,
    city: "Malone",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2704,
    density: 27.3,
    county_fips: 55039,
    county_name: "Fond du Lac",
    county_weights: {
      55015: 4.43,
      55039: 95.57,
    },
    county_names_all: "Fond du Lac|Calumet",
    county_fips_all: "55039|55015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53050,
    lat: 43.50992,
    lng: -88.54734,
    city: "Mayville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6820,
    density: 37.3,
    county_fips: 55027,
    county_name: "Dodge",
    county_weights: {
      55027: 100,
    },
    county_names_all: "Dodge",
    county_fips_all: 55027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53051,
    lat: 43.14905,
    lng: -88.12348,
    city: "Menomonee Falls",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37668,
    density: 436.9,
    county_fips: 55133,
    county_name: "Waukesha",
    county_weights: {
      55133: 100,
    },
    county_names_all: "Waukesha",
    county_fips_all: 55133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53057,
    lat: 43.79099,
    lng: -88.24671,
    city: "Mount Calvary",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1712,
    density: 20.9,
    county_fips: 55039,
    county_name: "Fond du Lac",
    county_weights: {
      55039: 100,
    },
    county_names_all: "Fond du Lac",
    county_fips_all: 55039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53058,
    lat: 43.11003,
    lng: -88.40624,
    city: "Nashotah",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3348,
    density: 232.8,
    county_fips: 55133,
    county_name: "Waukesha",
    county_weights: {
      55133: 100,
    },
    county_names_all: "Waukesha",
    county_fips_all: 55133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53059,
    lat: 43.28954,
    lng: -88.53012,
    city: "Neosho",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1975,
    density: 23.7,
    county_fips: 55027,
    county_name: "Dodge",
    county_weights: {
      55027: 100,
    },
    county_names_all: "Dodge",
    county_fips_all: 55027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53061,
    lat: 43.94588,
    lng: -88.11803,
    city: "New Holstein",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4882,
    density: 44.2,
    county_fips: 55015,
    county_name: "Calumet",
    county_weights: {
      55015: 82.03,
      55039: 17.02,
      55071: 0.95,
    },
    county_names_all: "Calumet|Fond du Lac|Manitowoc",
    county_fips_all: "55015|55039|55071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53063,
    lat: 43.96297,
    lng: -87.80232,
    city: "Newton",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1553,
    density: 15.2,
    county_fips: 55071,
    county_name: "Manitowoc",
    county_weights: {
      55071: 100,
    },
    county_names_all: "Manitowoc",
    county_fips_all: 55071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53065,
    lat: 43.68227,
    lng: -88.56866,
    city: "Oakfield",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2333,
    density: 21,
    county_fips: 55039,
    county_name: "Fond du Lac",
    county_weights: {
      55027: 3.7,
      55039: 96.3,
    },
    county_names_all: "Fond du Lac|Dodge",
    county_fips_all: "55039|55027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53066,
    lat: 43.11451,
    lng: -88.49068,
    city: "Oconomowoc",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35414,
    density: 132.5,
    county_fips: 55133,
    county_name: "Waukesha",
    county_weights: {
      55027: 12.77,
      55055: 15.9,
      55131: 0.21,
      55133: 71.12,
    },
    county_names_all: "Waukesha|Jefferson|Dodge|Washington",
    county_fips_all: "55133|55055|55027|55131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53069,
    lat: 43.1131,
    lng: -88.43094,
    city: "Okauchee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 762,
    density: 758,
    county_fips: 55133,
    county_name: "Waukesha",
    county_weights: {
      55133: 100,
    },
    county_names_all: "Waukesha",
    county_fips_all: 55133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53070,
    lat: 43.62429,
    lng: -87.80872,
    city: "Oostburg",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5005,
    density: 65.5,
    county_fips: 55117,
    county_name: "Sheboygan",
    county_weights: {
      55117: 100,
    },
    county_names_all: "Sheboygan",
    county_fips_all: 55117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53072,
    lat: 43.07989,
    lng: -88.26638,
    city: "Pewaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25850,
    density: 334.7,
    county_fips: 55133,
    county_name: "Waukesha",
    county_weights: {
      55133: 100,
    },
    county_names_all: "Waukesha",
    county_fips_all: 55133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53073,
    lat: 43.75011,
    lng: -87.99191,
    city: "Plymouth",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14913,
    density: 68.1,
    county_fips: 55117,
    county_name: "Sheboygan",
    county_weights: {
      55117: 100,
    },
    county_names_all: "Sheboygan",
    county_fips_all: 55117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53074,
    lat: 43.42716,
    lng: -87.88265,
    city: "Port Washington",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12788,
    density: 163.2,
    county_fips: 55089,
    county_name: "Ozaukee",
    county_weights: {
      55089: 100,
    },
    county_names_all: "Ozaukee",
    county_fips_all: 55089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53075,
    lat: 43.56318,
    lng: -87.99559,
    city: "Random Lake",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3106,
    density: 32.8,
    county_fips: 55117,
    county_name: "Sheboygan",
    county_weights: {
      55089: 10.11,
      55117: 86.66,
      55131: 3.23,
    },
    county_names_all: "Sheboygan|Ozaukee|Washington",
    county_fips_all: "55117|55089|55131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53076,
    lat: 43.26966,
    lng: -88.20905,
    city: "Richfield",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3854,
    density: 66.4,
    county_fips: 55131,
    county_name: "Washington",
    county_weights: {
      55131: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 55131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53078,
    lat: 43.31386,
    lng: -88.45924,
    city: "Rubicon",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1608,
    density: 18.5,
    county_fips: 55027,
    county_name: "Dodge",
    county_weights: {
      55027: 100,
    },
    county_names_all: "Dodge",
    county_fips_all: 55027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53079,
    lat: 43.81132,
    lng: -88.1888,
    city: "Saint Cloud",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1421,
    density: 14.9,
    county_fips: 55039,
    county_name: "Fond du Lac",
    county_weights: {
      55039: 96.39,
      55117: 3.61,
    },
    county_names_all: "Fond du Lac|Sheboygan",
    county_fips_all: "55039|55117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53080,
    lat: 43.40733,
    lng: -87.98789,
    city: "Saukville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5388,
    density: 72.8,
    county_fips: 55089,
    county_name: "Ozaukee",
    county_weights: {
      55089: 100,
    },
    county_names_all: "Ozaukee",
    county_fips_all: 55089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53081,
    lat: 43.71343,
    lng: -87.73725,
    city: "Sheboygan",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41666,
    density: 690,
    county_fips: 55117,
    county_name: "Sheboygan",
    county_weights: {
      55117: 100,
    },
    county_names_all: "Sheboygan",
    county_fips_all: 55117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53083,
    lat: 43.81511,
    lng: -87.77108,
    city: "Sheboygan",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20969,
    density: 249.1,
    county_fips: 55117,
    county_name: "Sheboygan",
    county_weights: {
      55117: 100,
    },
    county_names_all: "Sheboygan",
    county_fips_all: 55117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53085,
    lat: 43.73562,
    lng: -87.85137,
    city: "Sheboygan Falls",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11644,
    density: 64.5,
    county_fips: 55117,
    county_name: "Sheboygan",
    county_weights: {
      55117: 100,
    },
    county_names_all: "Sheboygan",
    county_fips_all: 55117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53086,
    lat: 43.32508,
    lng: -88.27124,
    city: "Slinger",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8246,
    density: 148,
    county_fips: 55131,
    county_name: "Washington",
    county_weights: {
      55131: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 55131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53088,
    lat: 44.07178,
    lng: -88.29966,
    city: "Stockbridge",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 363,
    density: 912.9,
    county_fips: 55015,
    county_name: "Calumet",
    county_weights: {
      55015: 100,
    },
    county_names_all: "Calumet",
    county_fips_all: 55015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53089,
    lat: 43.14646,
    lng: -88.23594,
    city: "Sussex",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19223,
    density: 276.3,
    county_fips: 55133,
    county_name: "Waukesha",
    county_weights: {
      55133: 100,
    },
    county_names_all: "Waukesha",
    county_fips_all: 55133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53090,
    lat: 43.45685,
    lng: -88.17985,
    city: "West Bend",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22118,
    density: 147.6,
    county_fips: 55131,
    county_name: "Washington",
    county_weights: {
      55089: 3.1,
      55131: 96.9,
    },
    county_names_all: "Washington|Ozaukee",
    county_fips_all: "55131|55089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53091,
    lat: 43.49667,
    lng: -88.43674,
    city: "Theresa",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1949,
    density: 29.3,
    county_fips: 55027,
    county_name: "Dodge",
    county_weights: {
      55027: 96.45,
      55131: 3.55,
    },
    county_names_all: "Dodge|Washington",
    county_fips_all: "55027|55131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53092,
    lat: 43.22139,
    lng: -87.95351,
    city: "Mequon",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20625,
    density: 392.2,
    county_fips: 55089,
    county_name: "Ozaukee",
    county_weights: {
      55089: 100,
    },
    county_names_all: "Ozaukee",
    county_fips_all: 55089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53093,
    lat: 43.65348,
    lng: -87.93894,
    city: "Waldo",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2026,
    density: 36.5,
    county_fips: 55117,
    county_name: "Sheboygan",
    county_weights: {
      55117: 100,
    },
    county_names_all: "Sheboygan",
    county_fips_all: 55117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53094,
    lat: 43.1462,
    lng: -88.73365,
    city: "Watertown",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19175,
    density: 83.3,
    county_fips: 55055,
    county_name: "Jefferson",
    county_weights: {
      55055: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 55055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53095,
    lat: 43.38838,
    lng: -88.15895,
    city: "West Bend",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27596,
    density: 151.2,
    county_fips: 55131,
    county_name: "Washington",
    county_weights: {
      55089: 5.92,
      55131: 94.08,
    },
    county_names_all: "Washington|Ozaukee",
    county_fips_all: "55131|55089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53097,
    lat: 43.24574,
    lng: -88.0069,
    city: "Mequon",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6881,
    density: 98.3,
    county_fips: 55089,
    county_name: "Ozaukee",
    county_weights: {
      55089: 100,
    },
    county_names_all: "Ozaukee",
    county_fips_all: 55089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53098,
    lat: 43.24955,
    lng: -88.71461,
    city: "Watertown",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11748,
    density: 44.6,
    county_fips: 55027,
    county_name: "Dodge",
    county_weights: {
      55027: 100,
    },
    county_names_all: "Dodge",
    county_fips_all: 55027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53099,
    lat: 43.38035,
    lng: -88.52525,
    city: "Woodland",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 55027,
    county_name: "Dodge",
    county_weights: {
      55027: 100,
    },
    county_names_all: "Dodge",
    county_fips_all: 55027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53103,
    lat: 42.88175,
    lng: -88.21542,
    city: "Big Bend",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3669,
    density: 116.2,
    county_fips: 55133,
    county_name: "Waukesha",
    county_weights: {
      55133: 100,
    },
    county_names_all: "Waukesha",
    county_fips_all: 55133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53104,
    lat: 42.55731,
    lng: -88.03416,
    city: "Bristol",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5610,
    density: 62.8,
    county_fips: 55059,
    county_name: "Kenosha",
    county_weights: {
      55059: 100,
    },
    county_names_all: "Kenosha",
    county_fips_all: 55059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53105,
    lat: 42.66412,
    lng: -88.28045,
    city: "Burlington",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29302,
    density: 70.9,
    county_fips: 55101,
    county_name: "Racine",
    county_weights: {
      55059: 21.55,
      55101: 41.48,
      55127: 36.97,
    },
    county_names_all: "Racine|Walworth|Kenosha",
    county_fips_all: "55101|55127|55059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53108,
    lat: 42.82043,
    lng: -87.94696,
    city: "Caledonia",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3329,
    density: 66.2,
    county_fips: 55101,
    county_name: "Racine",
    county_weights: {
      55101: 100,
    },
    county_names_all: "Racine",
    county_fips_all: 55101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53110,
    lat: 42.94671,
    lng: -87.86403,
    city: "Cudahy",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18211,
    density: 1475.6,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53114,
    lat: 42.60721,
    lng: -88.75089,
    city: "Darien",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2560,
    density: 33,
    county_fips: 55127,
    county_name: "Walworth",
    county_weights: {
      55105: 24.65,
      55127: 75.35,
    },
    county_names_all: "Walworth|Rock",
    county_fips_all: "55127|55105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53115,
    lat: 42.65443,
    lng: -88.6713,
    city: "Delavan",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15722,
    density: 84.4,
    county_fips: 55127,
    county_name: "Walworth",
    county_weights: {
      55127: 100,
    },
    county_names_all: "Walworth",
    county_fips_all: 55127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53118,
    lat: 42.9725,
    lng: -88.48859,
    city: "Dousman",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6860,
    density: 67.4,
    county_fips: 55133,
    county_name: "Waukesha",
    county_weights: {
      55055: 12.63,
      55133: 87.37,
    },
    county_names_all: "Waukesha|Jefferson",
    county_fips_all: "55133|55055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53119,
    lat: 42.88356,
    lng: -88.4862,
    city: "Eagle",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6055,
    density: 58.4,
    county_fips: 55133,
    county_name: "Waukesha",
    county_weights: {
      55055: 2.12,
      55127: 8.82,
      55133: 89.06,
    },
    county_names_all: "Waukesha|Walworth|Jefferson",
    county_fips_all: "55133|55127|55055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53120,
    lat: 42.80066,
    lng: -88.41783,
    city: "East Troy",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10476,
    density: 71.5,
    county_fips: 55127,
    county_name: "Walworth",
    county_weights: {
      55101: 8.66,
      55127: 91.34,
    },
    county_names_all: "Walworth|Racine",
    county_fips_all: "55127|55101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53121,
    lat: 42.70989,
    lng: -88.53028,
    city: "Elkhorn",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18993,
    density: 64.1,
    county_fips: 55127,
    county_name: "Walworth",
    county_weights: {
      55127: 100,
    },
    county_names_all: "Walworth",
    county_fips_all: 55127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53122,
    lat: 43.04811,
    lng: -88.08674,
    city: "Elm Grove",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6156,
    density: 727.4,
    county_fips: 55133,
    county_name: "Waukesha",
    county_weights: {
      55133: 100,
    },
    county_names_all: "Waukesha",
    county_fips_all: 55133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53125,
    lat: 42.54532,
    lng: -88.56216,
    city: "Fontana",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1700,
    density: 106.6,
    county_fips: 55127,
    county_name: "Walworth",
    county_weights: {
      55127: 100,
    },
    county_names_all: "Walworth",
    county_fips_all: 55127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53126,
    lat: 42.78848,
    lng: -87.9966,
    city: "Franksville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7265,
    density: 53.4,
    county_fips: 55101,
    county_name: "Racine",
    county_weights: {
      55079: 0.3,
      55101: 99.7,
    },
    county_names_all: "Racine|Milwaukee",
    county_fips_all: "55101|55079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53127,
    lat: 42.95991,
    lng: -88.3777,
    city: "Genesee Depot",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 55133,
    county_name: "Waukesha",
    county_weights: {
      55133: 100,
    },
    county_names_all: "Waukesha",
    county_fips_all: 55133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53128,
    lat: 42.52979,
    lng: -88.33857,
    city: "Genoa City",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9161,
    density: 139.7,
    county_fips: 55127,
    county_name: "Walworth",
    county_weights: {
      55059: 15.87,
      55127: 84.13,
    },
    county_names_all: "Walworth|Kenosha",
    county_fips_all: "55127|55059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53129,
    lat: 42.93795,
    lng: -88.00003,
    city: "Greendale",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14005,
    density: 1050,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53130,
    lat: 42.94092,
    lng: -88.04909,
    city: "Hales Corners",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7789,
    density: 942.9,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53132,
    lat: 42.88589,
    lng: -88.01063,
    city: "Franklin",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35619,
    density: 396.2,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53137,
    lat: 43.00472,
    lng: -88.66975,
    city: "Helenville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1614,
    density: 18.8,
    county_fips: 55055,
    county_name: "Jefferson",
    county_weights: {
      55055: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 55055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53139,
    lat: 42.68795,
    lng: -88.12,
    city: "Kansasville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2330,
    density: 28.3,
    county_fips: 55101,
    county_name: "Racine",
    county_weights: {
      55059: 34.38,
      55101: 65.62,
    },
    county_names_all: "Racine|Kenosha",
    county_fips_all: "55101|55059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53140,
    lat: 42.61963,
    lng: -87.82987,
    city: "Kenosha",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30425,
    density: 1488.1,
    county_fips: 55059,
    county_name: "Kenosha",
    county_weights: {
      55059: 100,
    },
    county_names_all: "Kenosha",
    county_fips_all: 55059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53142,
    lat: 42.54464,
    lng: -87.93765,
    city: "Kenosha",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33967,
    density: 634,
    county_fips: 55059,
    county_name: "Kenosha",
    county_weights: {
      55059: 100,
    },
    county_names_all: "Kenosha",
    county_fips_all: 55059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53143,
    lat: 42.56109,
    lng: -87.83038,
    city: "Kenosha",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21675,
    density: 2019.8,
    county_fips: 55059,
    county_name: "Kenosha",
    county_weights: {
      55059: 100,
    },
    county_names_all: "Kenosha",
    county_fips_all: 55059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53144,
    lat: 42.61991,
    lng: -87.92291,
    city: "Kenosha",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26843,
    density: 238.9,
    county_fips: 55059,
    county_name: "Kenosha",
    county_weights: {
      55059: 100,
    },
    county_names_all: "Kenosha",
    county_fips_all: 55059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53146,
    lat: 42.9718,
    lng: -88.15885,
    city: "New Berlin",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7509,
    density: 158.4,
    county_fips: 55133,
    county_name: "Waukesha",
    county_weights: {
      55133: 100,
    },
    county_names_all: "Waukesha",
    county_fips_all: 55133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53147,
    lat: 42.57075,
    lng: -88.45024,
    city: "Lake Geneva",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17092,
    density: 94.6,
    county_fips: 55127,
    county_name: "Walworth",
    county_weights: {
      55127: 100,
    },
    county_names_all: "Walworth",
    county_fips_all: 55127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53149,
    lat: 42.87436,
    lng: -88.34077,
    city: "Mukwonago",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19849,
    density: 132.4,
    county_fips: 55133,
    county_name: "Waukesha",
    county_weights: {
      55101: 6.7,
      55127: 9.3,
      55133: 84,
    },
    county_names_all: "Waukesha|Walworth|Racine",
    county_fips_all: "55133|55127|55101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53150,
    lat: 42.8845,
    lng: -88.12824,
    city: "Muskego",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25913,
    density: 292.2,
    county_fips: 55133,
    county_name: "Waukesha",
    county_weights: {
      55101: 4.68,
      55133: 95.32,
    },
    county_names_all: "Waukesha|Racine",
    county_fips_all: "55133|55101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53151,
    lat: 42.97467,
    lng: -88.09845,
    city: "New Berlin",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32154,
    density: 708.5,
    county_fips: 55133,
    county_name: "Waukesha",
    county_weights: {
      55133: 100,
    },
    county_names_all: "Waukesha",
    county_fips_all: 55133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53153,
    lat: 42.94056,
    lng: -88.40237,
    city: "North Prairie",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2624,
    density: 212.3,
    county_fips: 55133,
    county_name: "Waukesha",
    county_weights: {
      55133: 100,
    },
    county_names_all: "Waukesha",
    county_fips_all: 55133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53154,
    lat: 42.8803,
    lng: -87.90092,
    city: "Oak Creek",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36321,
    density: 492.9,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53156,
    lat: 42.89069,
    lng: -88.59012,
    city: "Palmyra",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3364,
    density: 42.2,
    county_fips: 55055,
    county_name: "Jefferson",
    county_weights: {
      55055: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 55055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53157,
    lat: 42.5377,
    lng: -88.36855,
    city: "Pell Lake",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 55127,
    county_name: "Walworth",
    county_weights: {
      55127: 100,
    },
    county_names_all: "Walworth",
    county_fips_all: 55127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53158,
    lat: 42.52418,
    lng: -87.88869,
    city: "Pleasant Prairie",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17085,
    density: 218,
    county_fips: 55059,
    county_name: "Kenosha",
    county_weights: {
      55059: 100,
    },
    county_names_all: "Kenosha",
    county_fips_all: 55059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53167,
    lat: 42.73526,
    lng: -88.22552,
    city: "Rochester",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 552,
    density: 482.6,
    county_fips: 55101,
    county_name: "Racine",
    county_weights: {
      55101: 100,
    },
    county_names_all: "Racine",
    county_fips_all: 55101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53168,
    lat: 42.57858,
    lng: -88.12999,
    city: "Salem",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9512,
    density: 112.9,
    county_fips: 55059,
    county_name: "Kenosha",
    county_weights: {
      55059: 100,
    },
    county_names_all: "Kenosha",
    county_fips_all: 55059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53170,
    lat: 42.5519,
    lng: -88.16149,
    city: "Silver Lake",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2389,
    density: 907.8,
    county_fips: 55059,
    county_name: "Kenosha",
    county_weights: {
      55059: 100,
    },
    county_names_all: "Kenosha",
    county_fips_all: 55059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53172,
    lat: 42.91197,
    lng: -87.86266,
    city: "South Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20857,
    density: 1667.8,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53176,
    lat: 42.64307,
    lng: -88.41444,
    city: "Springfield",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 55127,
    county_name: "Walworth",
    county_weights: {
      55127: 100,
    },
    county_names_all: "Walworth",
    county_fips_all: 55127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53177,
    lat: 42.70047,
    lng: -87.93474,
    city: "Sturtevant",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7970,
    density: 111.3,
    county_fips: 55101,
    county_name: "Racine",
    county_weights: {
      55059: 13.05,
      55101: 86.95,
    },
    county_names_all: "Racine|Kenosha",
    county_fips_all: "55101|55059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53178,
    lat: 43.02335,
    lng: -88.59894,
    city: "Sullivan",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2552,
    density: 30.9,
    county_fips: 55055,
    county_name: "Jefferson",
    county_weights: {
      55055: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 55055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53179,
    lat: 42.5133,
    lng: -88.13159,
    city: "Trevor",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7036,
    density: 258.1,
    county_fips: 55059,
    county_name: "Kenosha",
    county_weights: {
      55059: 100,
    },
    county_names_all: "Kenosha",
    county_fips_all: 55059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53181,
    lat: 42.51711,
    lng: -88.24305,
    city: "Twin Lakes",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7338,
    density: 206.6,
    county_fips: 55059,
    county_name: "Kenosha",
    county_weights: {
      55059: 100,
    },
    county_names_all: "Kenosha",
    county_fips_all: 55059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53182,
    lat: 42.69815,
    lng: -88.04096,
    city: "Union Grove",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9873,
    density: 69,
    county_fips: 55101,
    county_name: "Racine",
    county_weights: {
      55059: 32.65,
      55101: 67.35,
    },
    county_names_all: "Racine|Kenosha",
    county_fips_all: "55101|55059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53183,
    lat: 43.00441,
    lng: -88.3739,
    city: "Wales",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2779,
    density: 303,
    county_fips: 55133,
    county_name: "Waukesha",
    county_weights: {
      55133: 100,
    },
    county_names_all: "Waukesha",
    county_fips_all: 55133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53184,
    lat: 42.53075,
    lng: -88.60945,
    city: "Walworth",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4115,
    density: 51.3,
    county_fips: 55127,
    county_name: "Walworth",
    county_weights: {
      55127: 100,
    },
    county_names_all: "Walworth",
    county_fips_all: 55127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53185,
    lat: 42.79519,
    lng: -88.19313,
    city: "Waterford",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18706,
    density: 158,
    county_fips: 55101,
    county_name: "Racine",
    county_weights: {
      55101: 99.19,
      55133: 0.81,
    },
    county_names_all: "Racine|Waukesha",
    county_fips_all: "55101|55133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53186,
    lat: 43.02305,
    lng: -88.20319,
    city: "Waukesha",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34092,
    density: 1045.5,
    county_fips: 55133,
    county_name: "Waukesha",
    county_weights: {
      55133: 100,
    },
    county_names_all: "Waukesha",
    county_fips_all: 55133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53188,
    lat: 43.02106,
    lng: -88.29265,
    city: "Waukesha",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35045,
    density: 504.6,
    county_fips: 55133,
    county_name: "Waukesha",
    county_weights: {
      55133: 100,
    },
    county_names_all: "Waukesha",
    county_fips_all: 55133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53189,
    lat: 42.95216,
    lng: -88.28068,
    city: "Waukesha",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27399,
    density: 221.2,
    county_fips: 55133,
    county_name: "Waukesha",
    county_weights: {
      55133: 100,
    },
    county_names_all: "Waukesha",
    county_fips_all: 55133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53190,
    lat: 42.80775,
    lng: -88.73129,
    city: "Whitewater",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19484,
    density: 57.5,
    county_fips: 55127,
    county_name: "Walworth",
    county_weights: {
      55055: 23.52,
      55105: 26.94,
      55127: 49.54,
    },
    county_names_all: "Walworth|Rock|Jefferson",
    county_fips_all: "55127|55105|55055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53191,
    lat: 42.5776,
    lng: -88.54574,
    city: "Williams Bay",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2927,
    density: 285.6,
    county_fips: 55127,
    county_name: "Walworth",
    county_weights: {
      55127: 100,
    },
    county_names_all: "Walworth",
    county_fips_all: 55127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53192,
    lat: 42.51172,
    lng: -88.18412,
    city: "Wilmot",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11,
    density: 3.2,
    county_fips: 55059,
    county_name: "Kenosha",
    county_weights: {
      55059: 100,
    },
    county_names_all: "Kenosha",
    county_fips_all: 55059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53195,
    lat: 42.51397,
    lng: -88.49016,
    city: "Zenda",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 138,
    density: 162.3,
    county_fips: 55127,
    county_name: "Walworth",
    county_weights: {
      55127: 100,
    },
    county_names_all: "Walworth",
    county_fips_all: 55127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53202,
    lat: 43.04561,
    lng: -87.89893,
    city: "Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24967,
    density: 4539.1,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53203,
    lat: 43.03828,
    lng: -87.91603,
    city: "Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1743,
    density: 1514.3,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53204,
    lat: 43.01806,
    lng: -87.92552,
    city: "Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38778,
    density: 4641.9,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53205,
    lat: 43.05359,
    lng: -87.93363,
    city: "Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9119,
    density: 2436.3,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53206,
    lat: 43.07524,
    lng: -87.93349,
    city: "Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23612,
    density: 3437.9,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53207,
    lat: 42.97148,
    lng: -87.90152,
    city: "Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37103,
    density: 1439.4,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53208,
    lat: 43.04556,
    lng: -87.96556,
    city: "Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29205,
    density: 2669,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53209,
    lat: 43.12871,
    lng: -87.94717,
    city: "Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48321,
    density: 1713.2,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53210,
    lat: 43.06889,
    lng: -87.97381,
    city: "Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25800,
    density: 3897.1,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53211,
    lat: 43.08308,
    lng: -87.88485,
    city: "Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34389,
    density: 3348.7,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53212,
    lat: 43.07464,
    lng: -87.90845,
    city: "Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30115,
    density: 2855.5,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53213,
    lat: 43.04889,
    lng: -88.00176,
    city: "Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27755,
    density: 2736.9,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53214,
    lat: 43.02061,
    lng: -88.01634,
    city: "Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35210,
    density: 1903.7,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53215,
    lat: 42.99931,
    lng: -87.94625,
    city: "Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61028,
    density: 4271.7,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53216,
    lat: 43.08634,
    lng: -87.97636,
    city: "Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31476,
    density: 2636.1,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53217,
    lat: 43.15767,
    lng: -87.91633,
    city: "Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28398,
    density: 778.4,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 99.36,
      55089: 0.64,
    },
    county_names_all: "Milwaukee|Ozaukee",
    county_fips_all: "55079|55089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53218,
    lat: 43.11469,
    lng: -87.99301,
    city: "Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42728,
    density: 2812.8,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53219,
    lat: 42.99537,
    lng: -87.99171,
    city: "Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34315,
    density: 2626.5,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53220,
    lat: 42.96515,
    lng: -87.99142,
    city: "Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27224,
    density: 1892.9,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53221,
    lat: 42.95445,
    lng: -87.94374,
    city: "Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39602,
    density: 1697.2,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53222,
    lat: 43.08205,
    lng: -88.03496,
    city: "Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26340,
    density: 1883.2,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53223,
    lat: 43.16304,
    lng: -87.98996,
    city: "Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28640,
    density: 1122,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53224,
    lat: 43.16357,
    lng: -88.03894,
    city: "Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22320,
    density: 850,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53225,
    lat: 43.11443,
    lng: -88.042,
    city: "Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26036,
    density: 1439.4,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 98.52,
      55133: 1.48,
    },
    county_names_all: "Milwaukee|Waukesha",
    county_fips_all: "55079|55133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53226,
    lat: 43.04975,
    lng: -88.04209,
    city: "Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18985,
    density: 1070.9,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53227,
    lat: 42.99562,
    lng: -88.04264,
    city: "Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23975,
    density: 1808.9,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 99.59,
      55133: 0.41,
    },
    county_names_all: "Milwaukee|Waukesha",
    county_fips_all: "55079|55133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53228,
    lat: 42.96678,
    lng: -88.04333,
    city: "Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14718,
    density: 1082.7,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53233,
    lat: 43.03694,
    lng: -87.93364,
    city: "Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14850,
    density: 3271.3,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53235,
    lat: 42.97161,
    lng: -87.87298,
    city: "Saint Francis",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9555,
    density: 1435.4,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53295,
    lat: 43.02222,
    lng: -87.97665,
    city: "Milwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 169,
    density: 273.2,
    county_fips: 55079,
    county_name: "Milwaukee",
    county_weights: {
      55079: 100,
    },
    county_names_all: "Milwaukee",
    county_fips_all: 55079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53402,
    lat: 42.7989,
    lng: -87.82385,
    city: "Racine",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33780,
    density: 651,
    county_fips: 55101,
    county_name: "Racine",
    county_weights: {
      55101: 100,
    },
    county_names_all: "Racine",
    county_fips_all: 55101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53403,
    lat: 42.68738,
    lng: -87.82587,
    city: "Racine",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26486,
    density: 1007.2,
    county_fips: 55101,
    county_name: "Racine",
    county_weights: {
      55059: 9.23,
      55101: 90.77,
    },
    county_names_all: "Racine|Kenosha",
    county_fips_all: "55101|55059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53404,
    lat: 42.7572,
    lng: -87.81246,
    city: "Racine",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13935,
    density: 1097.6,
    county_fips: 55101,
    county_name: "Racine",
    county_weights: {
      55101: 100,
    },
    county_names_all: "Racine",
    county_fips_all: 55101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53405,
    lat: 42.72712,
    lng: -87.82588,
    city: "Racine",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26450,
    density: 1544.5,
    county_fips: 55101,
    county_name: "Racine",
    county_weights: {
      55101: 100,
    },
    county_names_all: "Racine",
    county_fips_all: 55101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53406,
    lat: 42.73014,
    lng: -87.86549,
    city: "Racine",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25624,
    density: 604,
    county_fips: 55101,
    county_name: "Racine",
    county_weights: {
      55101: 100,
    },
    county_names_all: "Racine",
    county_fips_all: 55101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53501,
    lat: 42.60484,
    lng: -89.07165,
    city: "Afton",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 55105,
    county_name: "Rock",
    county_weights: {
      55105: 100,
    },
    county_names_all: "Rock",
    county_fips_all: 55105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53502,
    lat: 42.73219,
    lng: -89.44071,
    city: "Albany",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2375,
    density: 17.7,
    county_fips: 55045,
    county_name: "Green",
    county_weights: {
      55045: 98.47,
      55105: 1.53,
    },
    county_names_all: "Green|Rock",
    county_fips_all: "55045|55105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53503,
    lat: 43.13935,
    lng: -89.95623,
    city: "Arena",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1909,
    density: 13.1,
    county_fips: 55049,
    county_name: "Iowa",
    county_weights: {
      55049: 100,
    },
    county_names_all: "Iowa",
    county_fips_all: 55049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53504,
    lat: 42.70388,
    lng: -89.85801,
    city: "Argyle",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2182,
    density: 9.2,
    county_fips: 55065,
    county_name: "Lafayette",
    county_weights: {
      55045: 44.33,
      55065: 55.67,
    },
    county_names_all: "Lafayette|Green",
    county_fips_all: "55065|55045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53505,
    lat: 42.66063,
    lng: -88.8176,
    city: "Avalon",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 363,
    density: 6.3,
    county_fips: 55105,
    county_name: "Rock",
    county_weights: {
      55105: 100,
    },
    county_names_all: "Rock",
    county_fips_all: 55105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53506,
    lat: 43.15017,
    lng: -90.28422,
    city: "Avoca",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1017,
    density: 6.4,
    county_fips: 55049,
    county_name: "Iowa",
    county_weights: {
      55049: 100,
    },
    county_names_all: "Iowa",
    county_fips_all: 55049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53507,
    lat: 43.00153,
    lng: -89.90173,
    city: "Barneveld",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2214,
    density: 13.7,
    county_fips: 55049,
    county_name: "Iowa",
    county_weights: {
      55025: 0.64,
      55049: 99.36,
    },
    county_names_all: "Iowa|Dane",
    county_fips_all: "55049|55025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53508,
    lat: 42.86783,
    lng: -89.5618,
    city: "Belleville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5826,
    density: 33.1,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 66.02,
      55045: 33.98,
    },
    county_names_all: "Dane|Green",
    county_fips_all: "55025|55045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53510,
    lat: 42.74065,
    lng: -90.32147,
    city: "Belmont",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1517,
    density: 13.9,
    county_fips: 55065,
    county_name: "Lafayette",
    county_weights: {
      55065: 100,
    },
    county_names_all: "Lafayette",
    county_fips_all: 55065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53511,
    lat: 42.54627,
    lng: -89.09792,
    city: "Beloit",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48897,
    density: 164.4,
    county_fips: 55105,
    county_name: "Rock",
    county_weights: {
      55105: 100,
    },
    county_names_all: "Rock",
    county_fips_all: 55105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53515,
    lat: 43.11708,
    lng: -89.74915,
    city: "Black Earth",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2180,
    density: 21.5,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 100,
    },
    county_names_all: "Dane",
    county_fips_all: 55025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53516,
    lat: 42.80073,
    lng: -89.8676,
    city: "Blanchardville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2349,
    density: 10.5,
    county_fips: 55065,
    county_name: "Lafayette",
    county_weights: {
      55025: 3.09,
      55045: 35.51,
      55049: 13.72,
      55065: 47.68,
    },
    county_names_all: "Lafayette|Green|Iowa|Dane",
    county_fips_all: "55065|55045|55049|55025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53517,
    lat: 43.03686,
    lng: -89.82967,
    city: "Blue Mounds",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1815,
    density: 15.3,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 60.86,
      55049: 39.14,
    },
    county_names_all: "Dane|Iowa",
    county_fips_all: "55025|55049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53518,
    lat: 43.2458,
    lng: -90.59108,
    city: "Blue River",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1431,
    density: 6.6,
    county_fips: 55103,
    county_name: "Richland",
    county_weights: {
      55023: 4.02,
      55043: 17.43,
      55103: 78.55,
    },
    county_names_all: "Richland|Grant|Crawford",
    county_fips_all: "55103|55043|55023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53520,
    lat: 42.60133,
    lng: -89.36123,
    city: "Brodhead",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6670,
    density: 21.5,
    county_fips: 55105,
    county_name: "Rock",
    county_weights: {
      55045: 46.56,
      55105: 53.44,
    },
    county_names_all: "Rock|Green",
    county_fips_all: "55105|55045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53521,
    lat: 42.84217,
    lng: -89.40814,
    city: "Brooklyn",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3491,
    density: 22.6,
    county_fips: 55045,
    county_name: "Green",
    county_weights: {
      55025: 41.19,
      55045: 50.32,
      55105: 8.49,
    },
    county_names_all: "Green|Dane|Rock",
    county_fips_all: "55045|55025|55105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53522,
    lat: 42.55674,
    lng: -89.78983,
    city: "Browntown",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 971,
    density: 9.6,
    county_fips: 55045,
    county_name: "Green",
    county_weights: {
      55045: 94.95,
      55065: 5.05,
    },
    county_names_all: "Green|Lafayette",
    county_fips_all: "55045|55065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53523,
    lat: 42.98338,
    lng: -89.03172,
    city: "Cambridge",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5008,
    density: 41.3,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 64.32,
      55055: 35.68,
    },
    county_names_all: "Dane|Jefferson",
    county_fips_all: "55025|55055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53525,
    lat: 42.54579,
    lng: -88.84907,
    city: "Clinton",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4132,
    density: 28,
    county_fips: 55105,
    county_name: "Rock",
    county_weights: {
      55105: 94.6,
      55127: 5.4,
    },
    county_names_all: "Rock|Walworth",
    county_fips_all: "55105|55127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53526,
    lat: 42.97433,
    lng: -90.34438,
    city: "Cobb",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 555,
    density: 27.4,
    county_fips: 55049,
    county_name: "Iowa",
    county_weights: {
      55049: 100,
    },
    county_names_all: "Iowa",
    county_fips_all: 55049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53527,
    lat: 43.06346,
    lng: -89.19141,
    city: "Cottage Grove",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11112,
    density: 119.9,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 100,
    },
    county_names_all: "Dane",
    county_fips_all: 55025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53528,
    lat: 43.11854,
    lng: -89.63739,
    city: "Cross Plains",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6376,
    density: 55.7,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 100,
    },
    county_names_all: "Dane",
    county_fips_all: 55025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53529,
    lat: 43.24075,
    lng: -89.52496,
    city: "Dane",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2342,
    density: 23.2,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 100,
    },
    county_names_all: "Dane",
    county_fips_all: 55025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53530,
    lat: 42.69356,
    lng: -90.11163,
    city: "Darlington",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4455,
    density: 13.2,
    county_fips: 55065,
    county_name: "Lafayette",
    county_weights: {
      55065: 100,
    },
    county_names_all: "Lafayette",
    county_fips_all: 55065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53531,
    lat: 43.05696,
    lng: -89.10114,
    city: "Deerfield",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4465,
    density: 41.9,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 100,
    },
    county_names_all: "Dane",
    county_fips_all: 55025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53532,
    lat: 43.24881,
    lng: -89.32547,
    city: "Deforest",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15997,
    density: 114,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55021: 14.7,
      55025: 85.3,
    },
    county_names_all: "Dane|Columbia",
    county_fips_all: "55025|55021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53533,
    lat: 42.99285,
    lng: -90.14915,
    city: "Dodgeville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7072,
    density: 19.2,
    county_fips: 55049,
    county_name: "Iowa",
    county_weights: {
      55049: 100,
    },
    county_names_all: "Iowa",
    county_fips_all: 55049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53534,
    lat: 42.84763,
    lng: -89.09032,
    city: "Edgerton",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11764,
    density: 53.3,
    county_fips: 55105,
    county_name: "Rock",
    county_weights: {
      55025: 43.37,
      55055: 4.81,
      55105: 51.82,
    },
    county_names_all: "Rock|Dane|Jefferson",
    county_fips_all: "55105|55025|55055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53536,
    lat: 42.76366,
    lng: -89.26983,
    city: "Evansville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8813,
    density: 38.3,
    county_fips: 55105,
    county_name: "Rock",
    county_weights: {
      55105: 100,
    },
    county_names_all: "Rock",
    county_fips_all: 55105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53537,
    lat: 42.67267,
    lng: -89.21056,
    city: "Footville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 998,
    density: 442.1,
    county_fips: 55105,
    county_name: "Rock",
    county_weights: {
      55105: 100,
    },
    county_names_all: "Rock",
    county_fips_all: 55105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53538,
    lat: 42.91697,
    lng: -88.87194,
    city: "Fort Atkinson",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18657,
    density: 74.2,
    county_fips: 55055,
    county_name: "Jefferson",
    county_weights: {
      55055: 98.59,
      55105: 1.41,
    },
    county_names_all: "Jefferson|Rock",
    county_fips_all: "55055|55105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53540,
    lat: 43.22173,
    lng: -90.29356,
    city: "Gotham",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 231,
    density: 1180.2,
    county_fips: 55103,
    county_name: "Richland",
    county_weights: {
      55103: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 55103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53541,
    lat: 42.56969,
    lng: -90.02963,
    city: "Gratiot",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 916,
    density: 5.6,
    county_fips: 55065,
    county_name: "Lafayette",
    county_weights: {
      55065: 100,
    },
    county_names_all: "Lafayette",
    county_fips_all: 55065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53543,
    lat: 43.0556,
    lng: -90.36233,
    city: "Highland",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1787,
    density: 8.9,
    county_fips: 55049,
    county_name: "Iowa",
    county_weights: {
      55043: 17.8,
      55049: 82.2,
    },
    county_names_all: "Iowa|Grant",
    county_fips_all: "55049|55043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53544,
    lat: 42.88199,
    lng: -89.9153,
    city: "Hollandale",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 824,
    density: 7.8,
    county_fips: 55049,
    county_name: "Iowa",
    county_weights: {
      55025: 0.87,
      55049: 99.13,
    },
    county_names_all: "Iowa|Dane",
    county_fips_all: "55049|55025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53545,
    lat: 42.73113,
    lng: -89.03613,
    city: "Janesville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22763,
    density: 390.5,
    county_fips: 55105,
    county_name: "Rock",
    county_weights: {
      55105: 100,
    },
    county_names_all: "Rock",
    county_fips_all: 55105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53546,
    lat: 42.65126,
    lng: -88.94854,
    city: "Janesville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30123,
    density: 143.4,
    county_fips: 55105,
    county_name: "Rock",
    county_weights: {
      55105: 100,
    },
    county_names_all: "Rock",
    county_fips_all: 55105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53548,
    lat: 42.68907,
    lng: -89.13095,
    city: "Janesville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20165,
    density: 103.8,
    county_fips: 55105,
    county_name: "Rock",
    county_weights: {
      55105: 100,
    },
    county_names_all: "Rock",
    county_fips_all: 55105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53549,
    lat: 42.99056,
    lng: -88.77675,
    city: "Jefferson",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10193,
    density: 55.3,
    county_fips: 55055,
    county_name: "Jefferson",
    county_weights: {
      55055: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 55055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53550,
    lat: 42.5581,
    lng: -89.49348,
    city: "Juda",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1286,
    density: 10.2,
    county_fips: 55045,
    county_name: "Green",
    county_weights: {
      55045: 100,
    },
    county_names_all: "Green",
    county_fips_all: 55045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53551,
    lat: 43.07831,
    lng: -88.91508,
    city: "Lake Mills",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9055,
    density: 88.4,
    county_fips: 55055,
    county_name: "Jefferson",
    county_weights: {
      55055: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 55055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53553,
    lat: 42.91235,
    lng: -90.29693,
    city: "Linden",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 717,
    density: 40.5,
    county_fips: 55049,
    county_name: "Iowa",
    county_weights: {
      55049: 100,
    },
    county_names_all: "Iowa",
    county_fips_all: 55049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53554,
    lat: 42.90205,
    lng: -90.44919,
    city: "Livingston",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1022,
    density: 8.8,
    county_fips: 55043,
    county_name: "Grant",
    county_weights: {
      55043: 67.36,
      55049: 32.64,
    },
    county_names_all: "Grant|Iowa",
    county_fips_all: "55043|55049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53555,
    lat: 43.32163,
    lng: -89.55625,
    city: "Lodi",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8625,
    density: 44,
    county_fips: 55021,
    county_name: "Columbia",
    county_weights: {
      55021: 79.31,
      55025: 20.69,
    },
    county_names_all: "Columbia|Dane",
    county_fips_all: "55021|55025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53556,
    lat: 43.24014,
    lng: -90.24525,
    city: "Lone Rock",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2325,
    density: 18.5,
    county_fips: 55103,
    county_name: "Richland",
    county_weights: {
      55103: 89.37,
      55111: 10.63,
    },
    county_names_all: "Richland|Sauk",
    county_fips_all: "55103|55111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53557,
    lat: 43.33996,
    lng: -88.79449,
    city: "Lowell",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 394,
    density: 33.2,
    county_fips: 55027,
    county_name: "Dodge",
    county_weights: {
      55027: 100,
    },
    county_names_all: "Dodge",
    county_fips_all: 55027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53558,
    lat: 43.00286,
    lng: -89.28409,
    city: "Mcfarland",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12609,
    density: 280.6,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 100,
    },
    county_names_all: "Dane",
    county_fips_all: 55025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53559,
    lat: 43.16557,
    lng: -89.08066,
    city: "Marshall",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6478,
    density: 37.7,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 99.28,
      55055: 0.72,
    },
    county_names_all: "Dane|Jefferson",
    county_fips_all: "55025|55055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53560,
    lat: 43.19418,
    lng: -89.75413,
    city: "Mazomanie",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3569,
    density: 22.9,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 91.9,
      55049: 8.1,
    },
    county_names_all: "Dane|Iowa",
    county_fips_all: "55025|55049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53561,
    lat: 43.39594,
    lng: -89.64414,
    city: "Merrimac",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2077,
    density: 22,
    county_fips: 55111,
    county_name: "Sauk",
    county_weights: {
      55021: 28.66,
      55111: 71.34,
    },
    county_names_all: "Sauk|Columbia",
    county_fips_all: "55111|55021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53562,
    lat: 43.11592,
    lng: -89.54188,
    city: "Middleton",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26490,
    density: 328.8,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 100,
    },
    county_names_all: "Dane",
    county_fips_all: 55025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53563,
    lat: 42.78276,
    lng: -88.93127,
    city: "Milton",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11282,
    density: 65,
    county_fips: 55105,
    county_name: "Rock",
    county_weights: {
      55055: 2.02,
      55105: 97.98,
    },
    county_names_all: "Rock|Jefferson",
    county_fips_all: "55105|55055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53565,
    lat: 42.84025,
    lng: -90.16982,
    city: "Mineral Point",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4685,
    density: 9.7,
    county_fips: 55049,
    county_name: "Iowa",
    county_weights: {
      55049: 70.82,
      55065: 29.18,
    },
    county_names_all: "Iowa|Lafayette",
    county_fips_all: "55049|55065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53566,
    lat: 42.60912,
    lng: -89.64817,
    city: "Monroe",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15015,
    density: 37.9,
    county_fips: 55045,
    county_name: "Green",
    county_weights: {
      55045: 100,
    },
    county_names_all: "Green",
    county_fips_all: 55045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53569,
    lat: 42.98105,
    lng: -90.42966,
    city: "Montfort",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1216,
    density: 10.8,
    county_fips: 55043,
    county_name: "Grant",
    county_weights: {
      55043: 53.95,
      55049: 46.05,
    },
    county_names_all: "Grant|Iowa",
    county_fips_all: "55043|55049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53570,
    lat: 42.73857,
    lng: -89.61966,
    city: "Monticello",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2555,
    density: 14.1,
    county_fips: 55045,
    county_name: "Green",
    county_weights: {
      55045: 100,
    },
    county_names_all: "Green",
    county_fips_all: 55045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53571,
    lat: 43.27793,
    lng: -89.35358,
    city: "Morrisonville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48,
    density: 43.2,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 100,
    },
    county_names_all: "Dane",
    county_fips_all: 55025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53572,
    lat: 42.96016,
    lng: -89.73754,
    city: "Mount Horeb",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11455,
    density: 44.6,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 99.34,
      55045: 0.66,
    },
    county_names_all: "Dane|Green",
    county_fips_all: "55025|55045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53573,
    lat: 43.18196,
    lng: -90.46326,
    city: "Muscoda",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3061,
    density: 11,
    county_fips: 55043,
    county_name: "Grant",
    county_weights: {
      55043: 41.94,
      55049: 17,
      55103: 41.06,
    },
    county_names_all: "Grant|Richland|Iowa",
    county_fips_all: "55043|55103|55049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53574,
    lat: 42.81851,
    lng: -89.65181,
    city: "New Glarus",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3986,
    density: 35.4,
    county_fips: 55045,
    county_name: "Green",
    county_weights: {
      55025: 2.59,
      55045: 97.41,
    },
    county_names_all: "Green|Dane",
    county_fips_all: "55045|55025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53575,
    lat: 42.93148,
    lng: -89.38627,
    city: "Oregon",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17518,
    density: 122.3,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 100,
    },
    county_names_all: "Dane",
    county_fips_all: 55025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53576,
    lat: 42.62543,
    lng: -89.23949,
    city: "Orfordville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2379,
    density: 29.5,
    county_fips: 55105,
    county_name: "Rock",
    county_weights: {
      55105: 100,
    },
    county_names_all: "Rock",
    county_fips_all: 55105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53577,
    lat: 43.31428,
    lng: -90.07117,
    city: "Plain",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1388,
    density: 11.7,
    county_fips: 55111,
    county_name: "Sauk",
    county_weights: {
      55111: 100,
    },
    county_names_all: "Sauk",
    county_fips_all: 55111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53578,
    lat: 43.31356,
    lng: -89.77408,
    city: "Prairie Du Sac",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6406,
    density: 57.4,
    county_fips: 55111,
    county_name: "Sauk",
    county_weights: {
      55021: 19.97,
      55111: 80.03,
    },
    county_names_all: "Sauk|Columbia",
    county_fips_all: "55111|55021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53579,
    lat: 43.2894,
    lng: -88.87545,
    city: "Reeseville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1693,
    density: 16.4,
    county_fips: 55027,
    county_name: "Dodge",
    county_weights: {
      55027: 100,
    },
    county_names_all: "Dodge",
    county_fips_all: 55027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53580,
    lat: 42.85943,
    lng: -90.38131,
    city: "Rewey",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 527,
    density: 11,
    county_fips: 55049,
    county_name: "Iowa",
    county_weights: {
      55049: 100,
    },
    county_names_all: "Iowa",
    county_fips_all: 55049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53581,
    lat: 43.37504,
    lng: -90.41637,
    city: "Richland Center",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10080,
    density: 16.7,
    county_fips: 55103,
    county_name: "Richland",
    county_weights: {
      55103: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 55103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53582,
    lat: 43.01791,
    lng: -89.99106,
    city: "Ridgeway",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1100,
    density: 12.1,
    county_fips: 55049,
    county_name: "Iowa",
    county_weights: {
      55049: 100,
    },
    county_names_all: "Iowa",
    county_fips_all: 55049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53583,
    lat: 43.25671,
    lng: -89.81178,
    city: "Sauk City",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6029,
    density: 31.2,
    county_fips: 55111,
    county_name: "Sauk",
    county_weights: {
      55021: 0.21,
      55025: 27.44,
      55111: 72.35,
    },
    county_names_all: "Sauk|Dane|Columbia",
    county_fips_all: "55111|55025|55021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53584,
    lat: 43.27937,
    lng: -90.29477,
    city: "Sextonville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 55103,
    county_name: "Richland",
    county_weights: {
      55103: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 55103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53585,
    lat: 42.53049,
    lng: -88.72056,
    city: "Sharon",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2134,
    density: 30.2,
    county_fips: 55127,
    county_name: "Walworth",
    county_weights: {
      55105: 4.57,
      55127: 95.43,
    },
    county_names_all: "Walworth|Rock",
    county_fips_all: "55127|55105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53586,
    lat: 42.57271,
    lng: -90.22702,
    city: "Shullsburg",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2133,
    density: 8.2,
    county_fips: 55065,
    county_name: "Lafayette",
    county_weights: {
      55065: 100,
    },
    county_names_all: "Lafayette",
    county_fips_all: 55065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53587,
    lat: 42.57736,
    lng: -89.90511,
    city: "South Wayne",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1210,
    density: 7.9,
    county_fips: 55065,
    county_name: "Lafayette",
    county_weights: {
      55065: 100,
    },
    county_names_all: "Lafayette",
    county_fips_all: 55065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53588,
    lat: 43.18949,
    lng: -90.08201,
    city: "Spring Green",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3930,
    density: 10.8,
    county_fips: 55111,
    county_name: "Sauk",
    county_weights: {
      55049: 32.93,
      55103: 0.99,
      55111: 66.08,
    },
    county_names_all: "Sauk|Iowa|Richland",
    county_fips_all: "55111|55049|55103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53589,
    lat: 42.92684,
    lng: -89.21182,
    city: "Stoughton",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20300,
    density: 92.3,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 98.08,
      55105: 1.92,
    },
    county_names_all: "Dane|Rock",
    county_fips_all: "55025|55105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53590,
    lat: 43.19936,
    lng: -89.20804,
    city: "Sun Prairie",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40911,
    density: 239.7,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 100,
    },
    county_names_all: "Dane",
    county_fips_all: 55025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53593,
    lat: 42.98533,
    lng: -89.57992,
    city: "Verona",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24775,
    density: 125.6,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 100,
    },
    county_names_all: "Dane",
    county_fips_all: 55025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53594,
    lat: 43.18291,
    lng: -88.97168,
    city: "Waterloo",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5117,
    density: 27.2,
    county_fips: 55055,
    county_name: "Jefferson",
    county_weights: {
      55025: 14.13,
      55027: 34.17,
      55055: 51.7,
    },
    county_names_all: "Jefferson|Dodge|Dane",
    county_fips_all: "55055|55027|55025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53597,
    lat: 43.18258,
    lng: -89.45726,
    city: "Waunakee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19579,
    density: 142.8,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 100,
    },
    county_names_all: "Dane",
    county_fips_all: 55025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53598,
    lat: 43.20641,
    lng: -89.3387,
    city: "Windsor",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2857,
    density: 359.7,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 100,
    },
    county_names_all: "Dane",
    county_fips_all: 55025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53599,
    lat: 42.64765,
    lng: -89.85986,
    city: "Woodford",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45,
    density: 72.1,
    county_fips: 55065,
    county_name: "Lafayette",
    county_weights: {
      55065: 100,
    },
    county_names_all: "Lafayette",
    county_fips_all: 55065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53703,
    lat: 43.07981,
    lng: -89.37734,
    city: "Madison",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35834,
    density: 7480.7,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 100,
    },
    county_names_all: "Dane",
    county_fips_all: 55025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53704,
    lat: 43.13633,
    lng: -89.34684,
    city: "Madison",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46614,
    density: 823.4,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 100,
    },
    county_names_all: "Dane",
    county_fips_all: 55025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53705,
    lat: 43.07427,
    lng: -89.46246,
    city: "Madison",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25256,
    density: 1544.8,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 100,
    },
    county_names_all: "Dane",
    county_fips_all: 55025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53706,
    lat: 43.07505,
    lng: -89.40987,
    city: "Madison",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6226,
    density: 5734.2,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 100,
    },
    county_names_all: "Dane",
    county_fips_all: 55025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53711,
    lat: 43.01521,
    lng: -89.40641,
    city: "Madison",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48455,
    density: 720.9,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 100,
    },
    county_names_all: "Dane",
    county_fips_all: 55025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53713,
    lat: 43.03743,
    lng: -89.39254,
    city: "Madison",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22726,
    density: 896.3,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 100,
    },
    county_names_all: "Dane",
    county_fips_all: 55025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53714,
    lat: 43.09884,
    lng: -89.31287,
    city: "Madison",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15750,
    density: 1308.1,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 100,
    },
    county_names_all: "Dane",
    county_fips_all: 55025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53715,
    lat: 43.06038,
    lng: -89.39861,
    city: "Madison",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13202,
    density: 3852.9,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 100,
    },
    county_names_all: "Dane",
    county_fips_all: 55025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53716,
    lat: 43.06506,
    lng: -89.31454,
    city: "Madison",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18756,
    density: 1142.5,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 100,
    },
    county_names_all: "Dane",
    county_fips_all: 55025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53717,
    lat: 43.07372,
    lng: -89.51945,
    city: "Madison",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12859,
    density: 1364.6,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 100,
    },
    county_names_all: "Dane",
    county_fips_all: 55025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53718,
    lat: 43.0977,
    lng: -89.27332,
    city: "Madison",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15882,
    density: 294.3,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 100,
    },
    county_names_all: "Dane",
    county_fips_all: 55025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53719,
    lat: 43.0281,
    lng: -89.50003,
    city: "Madison",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32594,
    density: 1236.6,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 100,
    },
    county_names_all: "Dane",
    county_fips_all: 55025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53726,
    lat: 43.07036,
    lng: -89.4223,
    city: "Madison",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5270,
    density: 3607.1,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 100,
    },
    county_names_all: "Dane",
    county_fips_all: 55025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53792,
    lat: 43.07711,
    lng: -89.43044,
    city: "Madison",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 55025,
    county_name: "Dane",
    county_weights: {
      55025: 100,
    },
    county_names_all: "Dane",
    county_fips_all: 55025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53801,
    lat: 42.92505,
    lng: -91.06959,
    city: "Bagley",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1046,
    density: 6.8,
    county_fips: 55043,
    county_name: "Grant",
    county_weights: {
      55043: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 55043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53802,
    lat: 42.80538,
    lng: -90.89358,
    city: "Beetown",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39,
    density: 8.9,
    county_fips: 55043,
    county_name: "Grant",
    county_weights: {
      55043: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 55043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53803,
    lat: 42.55915,
    lng: -90.35508,
    city: "Benton",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1183,
    density: 36.2,
    county_fips: 55065,
    county_name: "Lafayette",
    county_weights: {
      55065: 100,
    },
    county_names_all: "Lafayette",
    county_fips_all: 55065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53804,
    lat: 42.87645,
    lng: -90.90798,
    city: "Bloomington",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1396,
    density: 10.3,
    county_fips: 55043,
    county_name: "Grant",
    county_weights: {
      55043: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 55043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53805,
    lat: 43.14236,
    lng: -90.68445,
    city: "Boscobel",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5336,
    density: 15.6,
    county_fips: 55043,
    county_name: "Grant",
    county_weights: {
      55023: 36.01,
      55043: 63.99,
    },
    county_names_all: "Grant|Crawford",
    county_fips_all: "55043|55023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53806,
    lat: 42.73554,
    lng: -90.92544,
    city: "Cassville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1580,
    density: 8.8,
    county_fips: 55043,
    county_name: "Grant",
    county_weights: {
      55043: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 55043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53807,
    lat: 42.61123,
    lng: -90.46668,
    city: "Cuba City",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4742,
    density: 17.4,
    county_fips: 55043,
    county_name: "Grant",
    county_weights: {
      55043: 59.18,
      55065: 40.82,
    },
    county_names_all: "Grant|Lafayette",
    county_fips_all: "55043|55065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53808,
    lat: 42.63745,
    lng: -90.59204,
    city: "Dickeyville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 971,
    density: 151.3,
    county_fips: 55043,
    county_name: "Grant",
    county_weights: {
      55043: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 55043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53809,
    lat: 42.99362,
    lng: -90.63323,
    city: "Fennimore",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4318,
    density: 16.3,
    county_fips: 55043,
    county_name: "Grant",
    county_weights: {
      55043: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 55043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53810,
    lat: 42.82144,
    lng: -90.9984,
    city: "Glen Haven",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 357,
    density: 3.7,
    county_fips: 55043,
    county_name: "Grant",
    county_weights: {
      55043: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 55043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53811,
    lat: 42.53576,
    lng: -90.51541,
    city: "Hazel Green",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3325,
    density: 27.3,
    county_fips: 55043,
    county_name: "Grant",
    county_weights: {
      55043: 83.45,
      55065: 16.55,
    },
    county_names_all: "Grant|Lafayette",
    county_fips_all: "55043|55065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53812,
    lat: 42.5808,
    lng: -90.60239,
    city: "Kieler",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 55043,
    county_name: "Grant",
    county_weights: {
      55043: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 55043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53813,
    lat: 42.84402,
    lng: -90.71641,
    city: "Lancaster",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6003,
    density: 16.1,
    county_fips: 55043,
    county_name: "Grant",
    county_weights: {
      55043: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 55043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53816,
    lat: 42.97794,
    lng: -90.85773,
    city: "Mount Hope",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 911,
    density: 5.8,
    county_fips: 55043,
    county_name: "Grant",
    county_weights: {
      55043: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 55043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53817,
    lat: 42.94028,
    lng: -90.97234,
    city: "Patch Grove",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 172,
    density: 175.1,
    county_fips: 55043,
    county_name: "Grant",
    county_weights: {
      55043: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 55043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53818,
    lat: 42.74725,
    lng: -90.49177,
    city: "Platteville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16158,
    density: 40.4,
    county_fips: 55043,
    county_name: "Grant",
    county_weights: {
      55043: 81.1,
      55049: 2.1,
      55065: 16.8,
    },
    county_names_all: "Grant|Lafayette|Iowa",
    county_fips_all: "55043|55065|55049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53820,
    lat: 42.69649,
    lng: -90.70984,
    city: "Potosi",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2251,
    density: 9.7,
    county_fips: 55043,
    county_name: "Grant",
    county_weights: {
      55043: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 55043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53821,
    lat: 43.04769,
    lng: -91.06569,
    city: "Prairie Du Chien",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7962,
    density: 31.8,
    county_fips: 55023,
    county_name: "Crawford",
    county_weights: {
      55023: 78.66,
      55043: 21.34,
    },
    county_names_all: "Crawford|Grant",
    county_fips_all: "55023|55043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53825,
    lat: 42.91833,
    lng: -90.58851,
    city: "Stitzer",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 544,
    density: 6.6,
    county_fips: 55043,
    county_name: "Grant",
    county_weights: {
      55043: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 55043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53826,
    lat: 43.12225,
    lng: -90.91039,
    city: "Wauzeka",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1330,
    density: 6.5,
    county_fips: 55023,
    county_name: "Crawford",
    county_weights: {
      55023: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 55023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53827,
    lat: 43.05049,
    lng: -90.83702,
    city: "Woodman",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 205,
    density: 2.2,
    county_fips: 55043,
    county_name: "Grant",
    county_weights: {
      55043: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 55043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53901,
    lat: 43.55606,
    lng: -89.48606,
    city: "Portage",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14729,
    density: 38.6,
    county_fips: 55021,
    county_name: "Columbia",
    county_weights: {
      55021: 98.83,
      55077: 1.17,
    },
    county_names_all: "Columbia|Marquette",
    county_fips_all: "55021|55077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53910,
    lat: 43.89073,
    lng: -89.80708,
    city: "Adams",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3468,
    density: 23.5,
    county_fips: 55001,
    county_name: "Adams",
    county_weights: {
      55001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 55001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53911,
    lat: 43.3258,
    lng: -89.36478,
    city: "Arlington",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1322,
    density: 14,
    county_fips: 55021,
    county_name: "Columbia",
    county_weights: {
      55021: 92.24,
      55025: 7.76,
    },
    county_names_all: "Columbia|Dane",
    county_fips_all: "55021|55025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53913,
    lat: 43.49213,
    lng: -89.72858,
    city: "Baraboo",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20534,
    density: 57.1,
    county_fips: 55111,
    county_name: "Sauk",
    county_weights: {
      55021: 1.34,
      55111: 98.66,
    },
    county_names_all: "Sauk|Columbia",
    county_fips_all: "55111|55021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53916,
    lat: 43.45538,
    lng: -88.85813,
    city: "Beaver Dam",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22485,
    density: 83.8,
    county_fips: 55027,
    county_name: "Dodge",
    county_weights: {
      55027: 100,
    },
    county_names_all: "Dodge",
    county_fips_all: 55027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53919,
    lat: 43.73462,
    lng: -88.77564,
    city: "Brandon",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2462,
    density: 14.5,
    county_fips: 55039,
    county_name: "Fond du Lac",
    county_weights: {
      55039: 100,
    },
    county_names_all: "Fond du Lac",
    county_fips_all: 55039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53920,
    lat: 43.66579,
    lng: -89.60364,
    city: "Briggsville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 502,
    density: 34,
    county_fips: 55001,
    county_name: "Adams",
    county_weights: {
      55001: 50.85,
      55077: 49.15,
    },
    county_names_all: "Adams|Marquette",
    county_fips_all: "55001|55077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53922,
    lat: 43.51558,
    lng: -88.70916,
    city: "Burnett",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1049,
    density: 9.9,
    county_fips: 55027,
    county_name: "Dodge",
    county_weights: {
      55027: 100,
    },
    county_names_all: "Dodge",
    county_fips_all: 55027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53923,
    lat: 43.57326,
    lng: -89.13753,
    city: "Cambria",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2243,
    density: 11.3,
    county_fips: 55021,
    county_name: "Columbia",
    county_weights: {
      55021: 89.95,
      55047: 10.05,
    },
    county_names_all: "Columbia|Green Lake",
    county_fips_all: "55021|55047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53924,
    lat: 43.47971,
    lng: -90.25455,
    city: "Cazenovia",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1284,
    density: 6.9,
    county_fips: 55103,
    county_name: "Richland",
    county_weights: {
      55103: 94.84,
      55111: 5.16,
    },
    county_names_all: "Richland|Sauk",
    county_fips_all: "55103|55111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53925,
    lat: 43.3325,
    lng: -89.05075,
    city: "Columbus",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8097,
    density: 24.6,
    county_fips: 55021,
    county_name: "Columbia",
    county_weights: {
      55021: 53.87,
      55025: 10.01,
      55027: 36.12,
    },
    county_names_all: "Columbia|Dodge|Dane",
    county_fips_all: "55021|55027|55025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53926,
    lat: 43.67164,
    lng: -89.21497,
    city: "Dalton",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1581,
    density: 11.8,
    county_fips: 55047,
    county_name: "Green Lake",
    county_weights: {
      55021: 18.76,
      55047: 55.19,
      55077: 26.05,
    },
    county_names_all: "Green Lake|Marquette|Columbia",
    county_fips_all: "55047|55077|55021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53928,
    lat: 43.42051,
    lng: -89.1547,
    city: "Doylestown",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 92,
    density: 36.3,
    county_fips: 55021,
    county_name: "Columbia",
    county_weights: {
      55021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 55021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53929,
    lat: 43.75415,
    lng: -90.28376,
    city: "Elroy",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2602,
    density: 13.6,
    county_fips: 55057,
    county_name: "Juneau",
    county_weights: {
      55057: 72.2,
      55081: 16.81,
      55123: 10.99,
    },
    county_names_all: "Juneau|Monroe|Vernon",
    county_fips_all: "55057|55081|55123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53930,
    lat: 43.683,
    lng: -89.49506,
    city: "Endeavor",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1329,
    density: 12.3,
    county_fips: 55077,
    county_name: "Marquette",
    county_weights: {
      55077: 100,
    },
    county_names_all: "Marquette",
    county_fips_all: 55077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53931,
    lat: 43.74236,
    lng: -88.86798,
    city: "Fairwater",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 232,
    density: 121.9,
    county_fips: 55039,
    county_name: "Fond du Lac",
    county_weights: {
      55039: 100,
    },
    county_names_all: "Fond du Lac",
    county_fips_all: 55039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53932,
    lat: 43.4202,
    lng: -89.06543,
    city: "Fall River",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2495,
    density: 25.3,
    county_fips: 55021,
    county_name: "Columbia",
    county_weights: {
      55021: 91.71,
      55027: 8.29,
    },
    county_names_all: "Columbia|Dodge",
    county_fips_all: "55021|55027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53933,
    lat: 43.57235,
    lng: -88.88338,
    city: "Fox Lake",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4572,
    density: 46.8,
    county_fips: 55027,
    county_name: "Dodge",
    county_weights: {
      55027: 100,
    },
    county_names_all: "Dodge",
    county_fips_all: 55027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53934,
    lat: 43.98044,
    lng: -89.82184,
    city: "Friendship",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4244,
    density: 13.5,
    county_fips: 55001,
    county_name: "Adams",
    county_weights: {
      55001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 55001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53935,
    lat: 43.58864,
    lng: -89.06697,
    city: "Friesland",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 246,
    density: 95,
    county_fips: 55021,
    county_name: "Columbia",
    county_weights: {
      55021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 55021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53936,
    lat: 43.87477,
    lng: -89.71071,
    city: "Grand Marsh",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2343,
    density: 14.1,
    county_fips: 55001,
    county_name: "Adams",
    county_weights: {
      55001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 55001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53937,
    lat: 43.38841,
    lng: -90.15753,
    city: "Hillpoint",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1121,
    density: 8.2,
    county_fips: 55111,
    county_name: "Sauk",
    county_weights: {
      55103: 27.74,
      55111: 72.26,
    },
    county_names_all: "Sauk|Richland",
    county_fips_all: "55111|55103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53939,
    lat: 43.69185,
    lng: -89.13199,
    city: "Kingston",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 306,
    density: 115.8,
    county_fips: 55047,
    county_name: "Green Lake",
    county_weights: {
      55047: 100,
    },
    county_names_all: "Green Lake",
    county_fips_all: 55047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53940,
    lat: 43.59126,
    lng: -89.7944,
    city: "Lake Delton",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 55111,
    county_name: "Sauk",
    county_weights: {
      55111: 100,
    },
    county_names_all: "Sauk",
    county_fips_all: 55111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53941,
    lat: 43.57947,
    lng: -90.13694,
    city: "La Valle",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3151,
    density: 17.7,
    county_fips: 55111,
    county_name: "Sauk",
    county_weights: {
      55057: 5.57,
      55103: 0.33,
      55111: 94.1,
    },
    county_names_all: "Sauk|Juneau|Richland",
    county_fips_all: "55111|55057|55103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53942,
    lat: 43.46393,
    lng: -90.16536,
    city: "Lime Ridge",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 55111,
    county_name: "Sauk",
    county_weights: {
      55111: 100,
    },
    county_names_all: "Sauk",
    county_fips_all: 55111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53943,
    lat: 43.38999,
    lng: -90.03018,
    city: "Loganville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1169,
    density: 8.9,
    county_fips: 55111,
    county_name: "Sauk",
    county_weights: {
      55111: 100,
    },
    county_names_all: "Sauk",
    county_fips_all: 55111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53944,
    lat: 43.68759,
    lng: -89.92791,
    city: "Lyndon Station",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2267,
    density: 11.2,
    county_fips: 55057,
    county_name: "Juneau",
    county_weights: {
      55057: 83.12,
      55111: 16.88,
    },
    county_names_all: "Juneau|Sauk",
    county_fips_all: "55057|55111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53946,
    lat: 43.71822,
    lng: -89.02189,
    city: "Markesan",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4243,
    density: 12.8,
    county_fips: 55047,
    county_name: "Green Lake",
    county_weights: {
      55027: 0.86,
      55039: 4.25,
      55047: 93.85,
      55077: 1.04,
    },
    county_names_all: "Green Lake|Fond du Lac|Marquette|Dodge",
    county_fips_all: "55047|55039|55077|55027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53947,
    lat: 43.74676,
    lng: -89.13769,
    city: "Marquette",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 175,
    density: 193.4,
    county_fips: 55047,
    county_name: "Green Lake",
    county_weights: {
      55047: 100,
    },
    county_names_all: "Green Lake",
    county_fips_all: 55047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53948,
    lat: 43.77846,
    lng: -90.05161,
    city: "Mauston",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8384,
    density: 21.4,
    county_fips: 55057,
    county_name: "Juneau",
    county_weights: {
      55057: 100,
    },
    county_names_all: "Juneau",
    county_fips_all: 55057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53949,
    lat: 43.78323,
    lng: -89.33978,
    city: "Montello",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6188,
    density: 14.5,
    county_fips: 55077,
    county_name: "Marquette",
    county_weights: {
      55047: 4.13,
      55077: 95.87,
    },
    county_names_all: "Marquette|Green Lake",
    county_fips_all: "55077|55047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53950,
    lat: 43.90477,
    lng: -90.13463,
    city: "New Lisbon",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5431,
    density: 21.6,
    county_fips: 55057,
    county_name: "Juneau",
    county_weights: {
      55057: 100,
    },
    county_names_all: "Juneau",
    county_fips_all: 55057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53951,
    lat: 43.39087,
    lng: -89.86633,
    city: "North Freedom",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2671,
    density: 14.1,
    county_fips: 55111,
    county_name: "Sauk",
    county_weights: {
      55111: 100,
    },
    county_names_all: "Sauk",
    county_fips_all: 55111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53952,
    lat: 43.78718,
    lng: -89.5963,
    city: "Oxford",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3130,
    density: 12.4,
    county_fips: 55077,
    county_name: "Marquette",
    county_weights: {
      55001: 49.96,
      55077: 50.04,
    },
    county_names_all: "Marquette|Adams",
    county_fips_all: "55077|55001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53953,
    lat: 43.76606,
    lng: -89.458,
    city: "Packwaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 267,
    density: 305.3,
    county_fips: 55077,
    county_name: "Marquette",
    county_weights: {
      55077: 100,
    },
    county_names_all: "Marquette",
    county_fips_all: 55077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53954,
    lat: 43.55518,
    lng: -89.31325,
    city: "Pardeeville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6822,
    density: 33.3,
    county_fips: 55021,
    county_name: "Columbia",
    county_weights: {
      55021: 90.86,
      55077: 9.14,
    },
    county_names_all: "Columbia|Marquette",
    county_fips_all: "55021|55077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53955,
    lat: 43.40025,
    lng: -89.40051,
    city: "Poynette",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5530,
    density: 29.2,
    county_fips: 55021,
    county_name: "Columbia",
    county_weights: {
      55021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 55021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53956,
    lat: 43.54166,
    lng: -89.01849,
    city: "Randolph",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3141,
    density: 15.5,
    county_fips: 55021,
    county_name: "Columbia",
    county_weights: {
      55021: 55.27,
      55027: 40.09,
      55047: 4.64,
    },
    county_names_all: "Columbia|Dodge|Green Lake",
    county_fips_all: "55021|55027|55047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53959,
    lat: 43.53407,
    lng: -89.99702,
    city: "Reedsburg",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13717,
    density: 47.5,
    county_fips: 55111,
    county_name: "Sauk",
    county_weights: {
      55111: 100,
    },
    county_names_all: "Sauk",
    county_fips_all: 55111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53960,
    lat: 43.4224,
    lng: -89.23212,
    city: "Rio",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3383,
    density: 14.6,
    county_fips: 55021,
    county_name: "Columbia",
    county_weights: {
      55021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 55021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53961,
    lat: 43.46055,
    lng: -89.93858,
    city: "Rock Springs",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 838,
    density: 13.7,
    county_fips: 55111,
    county_name: "Sauk",
    county_weights: {
      55111: 100,
    },
    county_names_all: "Sauk",
    county_fips_all: 55111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53962,
    lat: 43.68352,
    lng: -90.2652,
    city: "Union Center",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 55057,
    county_name: "Juneau",
    county_weights: {
      55057: 100,
    },
    county_names_all: "Juneau",
    county_fips_all: 55057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53963,
    lat: 43.63492,
    lng: -88.73828,
    city: "Waupun",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13788,
    density: 59.3,
    county_fips: 55039,
    county_name: "Fond du Lac",
    county_weights: {
      55027: 46.35,
      55039: 53.65,
    },
    county_names_all: "Fond du Lac|Dodge",
    county_fips_all: "55039|55027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53964,
    lat: 43.91253,
    lng: -89.5025,
    city: "Westfield",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3560,
    density: 12.6,
    county_fips: 55077,
    county_name: "Marquette",
    county_weights: {
      55001: 8.34,
      55077: 90.07,
      55137: 1.59,
    },
    county_names_all: "Marquette|Adams|Waushara",
    county_fips_all: "55077|55001|55137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53965,
    lat: 43.67651,
    lng: -89.75681,
    city: "Wisconsin Dells",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10625,
    density: 24.3,
    county_fips: 55001,
    county_name: "Adams",
    county_weights: {
      55001: 55.37,
      55021: 20.93,
      55057: 7.05,
      55111: 16.65,
    },
    county_names_all: "Adams|Columbia|Sauk|Juneau",
    county_fips_all: "55001|55021|55111|55057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53968,
    lat: 43.64072,
    lng: -90.2326,
    city: "Wonewoc",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2399,
    density: 12.1,
    county_fips: 55057,
    county_name: "Juneau",
    county_weights: {
      55057: 55.03,
      55103: 1.95,
      55111: 37.39,
      55123: 5.63,
    },
    county_names_all: "Juneau|Sauk|Vernon|Richland",
    county_fips_all: "55057|55111|55123|55103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 53969,
    lat: 43.49567,
    lng: -89.30176,
    city: "Wyocena",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 416,
    density: 263.5,
    county_fips: 55021,
    county_name: "Columbia",
    county_weights: {
      55021: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 55021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54001,
    lat: 45.33417,
    lng: -92.38703,
    city: "Amery",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7648,
    density: 25,
    county_fips: 55095,
    county_name: "Polk",
    county_weights: {
      55095: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 55095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54002,
    lat: 44.95871,
    lng: -92.37121,
    city: "Baldwin",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6454,
    density: 32.1,
    county_fips: 55109,
    county_name: "St. Croix",
    county_weights: {
      55093: 3.07,
      55109: 96.93,
    },
    county_names_all: "St. Croix|Pierce",
    county_fips_all: "55109|55093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54003,
    lat: 44.79019,
    lng: -92.44218,
    city: "Beldenville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1108,
    density: 13.8,
    county_fips: 55093,
    county_name: "Pierce",
    county_weights: {
      55093: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 55093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54004,
    lat: 45.30699,
    lng: -92.12414,
    city: "Clayton",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2317,
    density: 11.5,
    county_fips: 55005,
    county_name: "Barron",
    county_weights: {
      55005: 66.73,
      55095: 33.27,
    },
    county_names_all: "Barron|Polk",
    county_fips_all: "55005|55095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54005,
    lat: 45.23447,
    lng: -92.23051,
    city: "Clear Lake",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3017,
    density: 13.9,
    county_fips: 55095,
    county_name: "Polk",
    county_weights: {
      55005: 8.46,
      55033: 6.87,
      55095: 65.03,
      55109: 19.64,
    },
    county_names_all: "Polk|St. Croix|Barron|Dunn",
    county_fips_all: "55095|55109|55005|55033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54006,
    lat: 45.58958,
    lng: -92.64824,
    city: "Cushing",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 675,
    density: 9.5,
    county_fips: 55095,
    county_name: "Polk",
    county_weights: {
      55095: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 55095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54007,
    lat: 45.18781,
    lng: -92.35734,
    city: "Deer Park",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 960,
    density: 8.2,
    county_fips: 55109,
    county_name: "St. Croix",
    county_weights: {
      55095: 22.08,
      55109: 77.92,
    },
    county_names_all: "St. Croix|Polk",
    county_fips_all: "55109|55095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54009,
    lat: 45.35358,
    lng: -92.57693,
    city: "Dresser",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2528,
    density: 29.2,
    county_fips: 55095,
    county_name: "Polk",
    county_weights: {
      55095: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 55095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54011,
    lat: 44.71648,
    lng: -92.46279,
    city: "Ellsworth",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6706,
    density: 24.8,
    county_fips: 55093,
    county_name: "Pierce",
    county_weights: {
      55093: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 55093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54013,
    lat: 45.08134,
    lng: -92.22929,
    city: "Glenwood City",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3318,
    density: 12.2,
    county_fips: 55109,
    county_name: "St. Croix",
    county_weights: {
      55033: 3.53,
      55109: 96.47,
    },
    county_names_all: "St. Croix|Dunn",
    county_fips_all: "55109|55033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54014,
    lat: 44.64578,
    lng: -92.57048,
    city: "Hager City",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2074,
    density: 18.9,
    county_fips: 55093,
    county_name: "Pierce",
    county_weights: {
      55093: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 55093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54015,
    lat: 44.96899,
    lng: -92.45419,
    city: "Hammond",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3743,
    density: 41.3,
    county_fips: 55109,
    county_name: "St. Croix",
    county_weights: {
      55109: 100,
    },
    county_names_all: "St. Croix",
    county_fips_all: 55109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54016,
    lat: 44.97949,
    lng: -92.69305,
    city: "Hudson",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32171,
    density: 185.2,
    county_fips: 55109,
    county_name: "St. Croix",
    county_weights: {
      55109: 100,
    },
    county_names_all: "St. Croix",
    county_fips_all: 55109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54017,
    lat: 45.11907,
    lng: -92.52091,
    city: "New Richmond",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18289,
    density: 50.7,
    county_fips: 55109,
    county_name: "St. Croix",
    county_weights: {
      55095: 3.15,
      55109: 96.85,
    },
    county_names_all: "St. Croix|Polk",
    county_fips_all: "55109|55095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54020,
    lat: 45.27937,
    lng: -92.65235,
    city: "Osceola",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7306,
    density: 38.3,
    county_fips: 55095,
    county_name: "Polk",
    county_weights: {
      55095: 99.02,
      55109: 0.98,
    },
    county_names_all: "Polk|St. Croix",
    county_fips_all: "55095|55109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54021,
    lat: 44.74048,
    lng: -92.71144,
    city: "Prescott",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7202,
    density: 63.7,
    county_fips: 55093,
    county_name: "Pierce",
    county_weights: {
      55093: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 55093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54022,
    lat: 44.84796,
    lng: -92.6096,
    city: "River Falls",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23775,
    density: 66.6,
    county_fips: 55093,
    county_name: "Pierce",
    county_weights: {
      55093: 61.25,
      55109: 38.75,
    },
    county_names_all: "Pierce|St. Croix",
    county_fips_all: "55093|55109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54023,
    lat: 44.97708,
    lng: -92.55218,
    city: "Roberts",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4412,
    density: 37.9,
    county_fips: 55109,
    county_name: "St. Croix",
    county_weights: {
      55109: 100,
    },
    county_names_all: "St. Croix",
    county_fips_all: 55109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54024,
    lat: 45.49873,
    lng: -92.64781,
    city: "Saint Croix Falls",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4602,
    density: 21.3,
    county_fips: 55095,
    county_name: "Polk",
    county_weights: {
      55095: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 55095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54025,
    lat: 45.14184,
    lng: -92.68997,
    city: "Somerset",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7179,
    density: 55.3,
    county_fips: 55109,
    county_name: "St. Croix",
    county_weights: {
      55109: 100,
    },
    county_names_all: "St. Croix",
    county_fips_all: 55109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54026,
    lat: 45.22688,
    lng: -92.53459,
    city: "Star Prairie",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2038,
    density: 28.3,
    county_fips: 55095,
    county_name: "Polk",
    county_weights: {
      55095: 75.98,
      55109: 24.02,
    },
    county_names_all: "Polk|St. Croix",
    county_fips_all: "55095|55109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54027,
    lat: 44.92403,
    lng: -92.19985,
    city: "Wilson",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1002,
    density: 11.9,
    county_fips: 55109,
    county_name: "St. Croix",
    county_weights: {
      55109: 100,
    },
    county_names_all: "St. Croix",
    county_fips_all: 55109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54028,
    lat: 44.95532,
    lng: -92.28279,
    city: "Woodville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2665,
    density: 27.5,
    county_fips: 55109,
    county_name: "St. Croix",
    county_weights: {
      55109: 100,
    },
    county_names_all: "St. Croix",
    county_fips_all: 55109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54082,
    lat: 45.0696,
    lng: -92.75403,
    city: "Houlton",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1649,
    density: 51.4,
    county_fips: 55109,
    county_name: "St. Croix",
    county_weights: {
      55109: 100,
    },
    county_names_all: "St. Croix",
    county_fips_all: 55109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54101,
    lat: 44.78786,
    lng: -88.05927,
    city: "Abrams",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2694,
    density: 20.9,
    county_fips: 55083,
    county_name: "Oconto",
    county_weights: {
      55083: 100,
    },
    county_names_all: "Oconto",
    county_fips_all: 55083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54102,
    lat: 45.50278,
    lng: -88.00524,
    city: "Amberg",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 737,
    density: 3,
    county_fips: 55075,
    county_name: "Marinette",
    county_weights: {
      55075: 100,
    },
    county_names_all: "Marinette",
    county_fips_all: 55075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54103,
    lat: 45.64972,
    lng: -88.49885,
    city: "Armstrong Creek",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 483,
    density: 2.4,
    county_fips: 55041,
    county_name: "Forest",
    county_weights: {
      55041: 96.76,
      55075: 3.24,
    },
    county_names_all: "Forest|Marinette",
    county_fips_all: "55041|55075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54104,
    lat: 45.44018,
    lng: -88.26518,
    city: "Athelstane",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1094,
    density: 2.3,
    county_fips: 55075,
    county_name: "Marinette",
    county_weights: {
      55041: 0.83,
      55075: 99.17,
    },
    county_names_all: "Marinette|Forest",
    county_fips_all: "55075|55041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54106,
    lat: 44.48172,
    lng: -88.45551,
    city: "Black Creek",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5566,
    density: 24.6,
    county_fips: 55087,
    county_name: "Outagamie",
    county_weights: {
      55087: 98.54,
      55115: 1.46,
    },
    county_names_all: "Outagamie|Shawano",
    county_fips_all: "55087|55115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54107,
    lat: 44.70068,
    lng: -88.44436,
    city: "Bonduel",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3600,
    density: 18.9,
    county_fips: 55115,
    county_name: "Shawano",
    county_weights: {
      55087: 2.72,
      55115: 97.28,
    },
    county_names_all: "Shawano|Outagamie",
    county_fips_all: "55115|55087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54110,
    lat: 44.18533,
    lng: -88.08105,
    city: "Brillion",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5308,
    density: 32,
    county_fips: 55015,
    county_name: "Calumet",
    county_weights: {
      55009: 2.74,
      55015: 72.77,
      55071: 24.49,
    },
    county_names_all: "Calumet|Manitowoc|Brown",
    county_fips_all: "55015|55071|55009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54111,
    lat: 44.81572,
    lng: -88.37992,
    city: "Cecil",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2243,
    density: 17.4,
    county_fips: 55115,
    county_name: "Shawano",
    county_weights: {
      55083: 7.29,
      55115: 92.71,
    },
    county_names_all: "Shawano|Oconto",
    county_fips_all: "55115|55083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54112,
    lat: 45.04527,
    lng: -88.04743,
    city: "Coleman",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2450,
    density: 15.6,
    county_fips: 55075,
    county_name: "Marinette",
    county_weights: {
      55075: 71.7,
      55083: 28.3,
    },
    county_names_all: "Marinette|Oconto",
    county_fips_all: "55075|55083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54113,
    lat: 44.26404,
    lng: -88.30705,
    city: "Combined Locks",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3588,
    density: 776.7,
    county_fips: 55087,
    county_name: "Outagamie",
    county_weights: {
      55087: 100,
    },
    county_names_all: "Outagamie",
    county_fips_all: 55087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54114,
    lat: 45.25254,
    lng: -88.12197,
    city: "Crivitz",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5302,
    density: 8.8,
    county_fips: 55075,
    county_name: "Marinette",
    county_weights: {
      55075: 91.77,
      55083: 8.23,
    },
    county_names_all: "Marinette|Oconto",
    county_fips_all: "55075|55083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54115,
    lat: 44.40552,
    lng: -88.09195,
    city: "De Pere",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46443,
    density: 144.6,
    county_fips: 55009,
    county_name: "Brown",
    county_weights: {
      55009: 85.18,
      55087: 14.82,
    },
    county_names_all: "Brown|Outagamie",
    county_fips_all: "55009|55087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54119,
    lat: 45.62488,
    lng: -88.18285,
    city: "Dunbar",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 751,
    density: 2.2,
    county_fips: 55075,
    county_name: "Marinette",
    county_weights: {
      55075: 100,
    },
    county_names_all: "Marinette",
    county_fips_all: 55075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54120,
    lat: 45.75892,
    lng: -88.49089,
    city: "Fence",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 229,
    density: 1,
    county_fips: 55037,
    county_name: "Florence",
    county_weights: {
      55037: 85.31,
      55075: 14.69,
    },
    county_names_all: "Florence|Marinette",
    county_fips_all: "55037|55075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54121,
    lat: 45.86385,
    lng: -88.32899,
    city: "Florence",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3097,
    density: 4.4,
    county_fips: 55037,
    county_name: "Florence",
    county_weights: {
      55037: 100,
    },
    county_names_all: "Florence",
    county_fips_all: 55037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54123,
    lat: 44.20642,
    lng: -88.15201,
    city: "Forest Junction",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 256,
    density: 134.9,
    county_fips: 55015,
    county_name: "Calumet",
    county_weights: {
      55015: 100,
    },
    county_names_all: "Calumet",
    county_fips_all: 55015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54124,
    lat: 44.90701,
    lng: -88.36616,
    city: "Gillett",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3570,
    density: 14.8,
    county_fips: 55083,
    county_name: "Oconto",
    county_weights: {
      55078: 8.24,
      55083: 91.57,
      55115: 0.19,
    },
    county_names_all: "Oconto|Menominee|Shawano",
    county_fips_all: "55083|55078|55115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54125,
    lat: 45.58995,
    lng: -88.38325,
    city: "Goodman",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 550,
    density: 2.5,
    county_fips: 55075,
    county_name: "Marinette",
    county_weights: {
      55041: 29.34,
      55075: 70.66,
    },
    county_names_all: "Marinette|Forest",
    county_fips_all: "55075|55041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54126,
    lat: 44.28925,
    lng: -88.03218,
    city: "Greenleaf",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3475,
    density: 16.7,
    county_fips: 55009,
    county_name: "Brown",
    county_weights: {
      55009: 99.36,
      55071: 0.64,
    },
    county_names_all: "Brown|Manitowoc",
    county_fips_all: "55009|55071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54127,
    lat: 44.79693,
    lng: -88.26815,
    city: "Green Valley",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43,
    density: 88.6,
    county_fips: 55115,
    county_name: "Shawano",
    county_weights: {
      55115: 100,
    },
    county_names_all: "Shawano",
    county_fips_all: 55115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54128,
    lat: 44.86675,
    lng: -88.80525,
    city: "Gresham",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2080,
    density: 15.9,
    county_fips: 55115,
    county_name: "Shawano",
    county_weights: {
      55115: 100,
    },
    county_names_all: "Shawano",
    county_fips_all: 55115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54129,
    lat: 44.12902,
    lng: -88.20146,
    city: "Hilbert",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3233,
    density: 17.7,
    county_fips: 55015,
    county_name: "Calumet",
    county_weights: {
      55015: 100,
    },
    county_names_all: "Calumet",
    county_fips_all: 55015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54130,
    lat: 44.31194,
    lng: -88.24301,
    city: "Kaukauna",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27076,
    density: 133.9,
    county_fips: 55087,
    county_name: "Outagamie",
    county_weights: {
      55009: 10.23,
      55015: 10.69,
      55087: 79.08,
    },
    county_names_all: "Outagamie|Calumet|Brown",
    county_fips_all: "55087|55015|55009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54135,
    lat: 44.91468,
    lng: -88.61209,
    city: "Keshena",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3396,
    density: 25.1,
    county_fips: 55078,
    county_name: "Menominee",
    county_weights: {
      55078: 100,
    },
    county_names_all: "Menominee",
    county_fips_all: 55078,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54136,
    lat: 44.26834,
    lng: -88.33852,
    city: "Kimberly",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6517,
    density: 1232.3,
    county_fips: 55087,
    county_name: "Outagamie",
    county_weights: {
      55087: 100,
    },
    county_names_all: "Outagamie",
    county_fips_all: 55087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54137,
    lat: 44.75843,
    lng: -88.25605,
    city: "Krakow",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1083,
    density: 16.7,
    county_fips: 55115,
    county_name: "Shawano",
    county_weights: {
      55083: 41.11,
      55115: 58.89,
    },
    county_names_all: "Shawano|Oconto",
    county_fips_all: "55115|55083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54138,
    lat: 45.33064,
    lng: -88.42783,
    city: "Lakewood",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 933,
    density: 5,
    county_fips: 55083,
    county_name: "Oconto",
    county_weights: {
      55083: 100,
    },
    county_names_all: "Oconto",
    county_fips_all: 55083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54139,
    lat: 44.9539,
    lng: -88.07152,
    city: "Lena",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3220,
    density: 12.5,
    county_fips: 55083,
    county_name: "Oconto",
    county_weights: {
      55075: 1.54,
      55083: 98.46,
    },
    county_names_all: "Oconto|Marinette",
    county_fips_all: "55083|55075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54140,
    lat: 44.28689,
    lng: -88.31045,
    city: "Little Chute",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8890,
    density: 1095,
    county_fips: 55087,
    county_name: "Outagamie",
    county_weights: {
      55087: 100,
    },
    county_names_all: "Outagamie",
    county_fips_all: 55087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54141,
    lat: 44.72753,
    lng: -88.00567,
    city: "Little Suamico",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2125,
    density: 32.2,
    county_fips: 55083,
    county_name: "Oconto",
    county_weights: {
      55009: 0.24,
      55083: 99.76,
    },
    county_names_all: "Oconto|Brown",
    county_fips_all: "55083|55009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54143,
    lat: 45.08708,
    lng: -87.70045,
    city: "Marinette",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14811,
    density: 86.3,
    county_fips: 55075,
    county_name: "Marinette",
    county_weights: {
      55075: 100,
    },
    county_names_all: "Marinette",
    county_fips_all: 55075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54149,
    lat: 45.204,
    lng: -88.47445,
    city: "Mountain",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1211,
    density: 3.6,
    county_fips: 55083,
    county_name: "Oconto",
    county_weights: {
      55083: 100,
    },
    county_names_all: "Oconto",
    county_fips_all: 55083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54150,
    lat: 44.97237,
    lng: -88.7906,
    city: "Neopit",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1072,
    density: 8.7,
    county_fips: 55078,
    county_name: "Menominee",
    county_weights: {
      55078: 97.03,
      55115: 2.97,
    },
    county_names_all: "Menominee|Shawano",
    county_fips_all: "55078|55115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54151,
    lat: 45.72352,
    lng: -87.99752,
    city: "Niagara",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3198,
    density: 9.6,
    county_fips: 55075,
    county_name: "Marinette",
    county_weights: {
      55037: 28.36,
      55075: 71.64,
    },
    county_names_all: "Marinette|Florence",
    county_fips_all: "55075|55037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54152,
    lat: 44.56645,
    lng: -88.47049,
    city: "Nichols",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 55087,
    county_name: "Outagamie",
    county_weights: {
      55087: 100,
    },
    county_names_all: "Outagamie",
    county_fips_all: 55087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54153,
    lat: 44.89939,
    lng: -87.92516,
    city: "Oconto",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7069,
    density: 26.9,
    county_fips: 55083,
    county_name: "Oconto",
    county_weights: {
      55083: 100,
    },
    county_names_all: "Oconto",
    county_fips_all: 55083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54154,
    lat: 44.86702,
    lng: -88.19058,
    city: "Oconto Falls",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5534,
    density: 26.6,
    county_fips: 55083,
    county_name: "Oconto",
    county_weights: {
      55083: 89.64,
      55115: 10.36,
    },
    county_names_all: "Oconto|Shawano",
    county_fips_all: "55083|55115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54155,
    lat: 44.51979,
    lng: -88.19038,
    city: "Oneida",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7715,
    density: 94.2,
    county_fips: 55009,
    county_name: "Brown",
    county_weights: {
      55009: 50.18,
      55087: 49.82,
    },
    county_names_all: "Brown|Outagamie",
    county_fips_all: "55009|55087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54156,
    lat: 45.60099,
    lng: -87.93963,
    city: "Pembine",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1414,
    density: 5.5,
    county_fips: 55075,
    county_name: "Marinette",
    county_weights: {
      55075: 100,
    },
    county_names_all: "Marinette",
    county_fips_all: 55075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54157,
    lat: 45.05001,
    lng: -87.81217,
    city: "Peshtigo",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6026,
    density: 25.9,
    county_fips: 55075,
    county_name: "Marinette",
    county_weights: {
      55075: 98.09,
      55083: 1.91,
    },
    county_names_all: "Marinette|Oconto",
    county_fips_all: "55075|55083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54159,
    lat: 45.20027,
    lng: -87.82682,
    city: "Porterfield",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1142,
    density: 6.1,
    county_fips: 55075,
    county_name: "Marinette",
    county_weights: {
      55075: 100,
    },
    county_names_all: "Marinette",
    county_fips_all: 55075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54160,
    lat: 44.12029,
    lng: -88.09895,
    city: "Potter",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 238,
    density: 181.8,
    county_fips: 55015,
    county_name: "Calumet",
    county_weights: {
      55015: 100,
    },
    county_names_all: "Calumet",
    county_fips_all: 55015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54161,
    lat: 45.12449,
    lng: -88.15696,
    city: "Pound",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2564,
    density: 7.9,
    county_fips: 55083,
    county_name: "Oconto",
    county_weights: {
      55075: 47.65,
      55083: 52.35,
    },
    county_names_all: "Oconto|Marinette",
    county_fips_all: "55083|55075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54162,
    lat: 44.66417,
    lng: -88.27689,
    city: "Pulaski",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9351,
    density: 32.4,
    county_fips: 55115,
    county_name: "Shawano",
    county_weights: {
      55009: 22.49,
      55083: 16.34,
      55115: 61.17,
    },
    county_names_all: "Shawano|Brown|Oconto",
    county_fips_all: "55115|55009|55083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54165,
    lat: 44.52063,
    lng: -88.31683,
    city: "Seymour",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7653,
    density: 29.6,
    county_fips: 55087,
    county_name: "Outagamie",
    county_weights: {
      55009: 1.12,
      55087: 87.73,
      55115: 11.15,
    },
    county_names_all: "Outagamie|Shawano|Brown",
    county_fips_all: "55087|55115|55009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54166,
    lat: 44.77894,
    lng: -88.63567,
    city: "Shawano",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16547,
    density: 43.8,
    county_fips: 55115,
    county_name: "Shawano",
    county_weights: {
      55115: 100,
    },
    county_names_all: "Shawano",
    county_fips_all: 55115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54169,
    lat: 44.17799,
    lng: -88.2772,
    city: "Sherwood",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2794,
    density: 289.4,
    county_fips: 55015,
    county_name: "Calumet",
    county_weights: {
      55015: 100,
    },
    county_names_all: "Calumet",
    county_fips_all: 55015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54170,
    lat: 44.51783,
    lng: -88.57241,
    city: "Shiocton",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3704,
    density: 11.8,
    county_fips: 55087,
    county_name: "Outagamie",
    county_weights: {
      55087: 74.99,
      55115: 21.92,
      55135: 3.09,
    },
    county_names_all: "Outagamie|Shawano|Waupaca",
    county_fips_all: "55087|55115|55135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54171,
    lat: 44.71957,
    lng: -88.12017,
    city: "Sobieski",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3803,
    density: 58.9,
    county_fips: 55083,
    county_name: "Oconto",
    county_weights: {
      55083: 100,
    },
    county_names_all: "Oconto",
    county_fips_all: 55083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54173,
    lat: 44.64228,
    lng: -88.03212,
    city: "Suamico",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4324,
    density: 117.2,
    county_fips: 55009,
    county_name: "Brown",
    county_weights: {
      55009: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 55009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54174,
    lat: 45.03553,
    lng: -88.43492,
    city: "Suring",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3165,
    density: 6,
    county_fips: 55083,
    county_name: "Oconto",
    county_weights: {
      55078: 36,
      55083: 64,
    },
    county_names_all: "Oconto|Menominee",
    county_fips_all: "55083|55078",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54175,
    lat: 45.30552,
    lng: -88.62394,
    city: "Townsend",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1055,
    density: 7.5,
    county_fips: 55083,
    county_name: "Oconto",
    county_weights: {
      55067: 1.04,
      55083: 98.96,
    },
    county_names_all: "Oconto|Langlade",
    county_fips_all: "55083|55067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54177,
    lat: 45.36428,
    lng: -87.89183,
    city: "Wausaukee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2684,
    density: 5.9,
    county_fips: 55075,
    county_name: "Marinette",
    county_weights: {
      55075: 100,
    },
    county_names_all: "Marinette",
    county_fips_all: 55075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54180,
    lat: 44.33139,
    lng: -88.17462,
    city: "Wrightstown",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3494,
    density: 228,
    county_fips: 55009,
    county_name: "Brown",
    county_weights: {
      55009: 85.77,
      55087: 14.23,
    },
    county_names_all: "Brown|Outagamie",
    county_fips_all: "55009|55087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54201,
    lat: 44.61987,
    lng: -87.49399,
    city: "Algoma",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5094,
    density: 26.1,
    county_fips: 55061,
    county_name: "Kewaunee",
    county_weights: {
      55029: 8.38,
      55061: 91.62,
    },
    county_names_all: "Kewaunee|Door",
    county_fips_all: "55061|55029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54202,
    lat: 45.0779,
    lng: -87.13837,
    city: "Baileys Harbor",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1536,
    density: 13.7,
    county_fips: 55029,
    county_name: "Door",
    county_weights: {
      55029: 100,
    },
    county_names_all: "Door",
    county_fips_all: 55029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54204,
    lat: 44.76189,
    lng: -87.61552,
    city: "Brussels",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1613,
    density: 12.9,
    county_fips: 55029,
    county_name: "Door",
    county_weights: {
      55029: 100,
    },
    county_names_all: "Door",
    county_fips_all: 55029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54205,
    lat: 44.60444,
    lng: -87.62912,
    city: "Casco",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2130,
    density: 18.6,
    county_fips: 55061,
    county_name: "Kewaunee",
    county_weights: {
      55029: 2.19,
      55061: 97.81,
    },
    county_names_all: "Kewaunee|Door",
    county_fips_all: "55061|55029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54207,
    lat: 44.08425,
    lng: -87.98093,
    city: "Collins",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 145,
    density: 50.2,
    county_fips: 55071,
    county_name: "Manitowoc",
    county_weights: {
      55071: 100,
    },
    county_names_all: "Manitowoc",
    county_fips_all: 55071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54208,
    lat: 44.36239,
    lng: -87.79619,
    city: "Denmark",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6487,
    density: 25.2,
    county_fips: 55009,
    county_name: "Brown",
    county_weights: {
      55009: 58.68,
      55061: 29.58,
      55071: 11.74,
    },
    county_names_all: "Brown|Kewaunee|Manitowoc",
    county_fips_all: "55009|55061|55071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54209,
    lat: 45.01126,
    lng: -87.27278,
    city: "Egg Harbor",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1397,
    density: 14.2,
    county_fips: 55029,
    county_name: "Door",
    county_weights: {
      55029: 100,
    },
    county_names_all: "Door",
    county_fips_all: 55029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54210,
    lat: 45.2535,
    lng: -87.0352,
    city: "Ellison Bay",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 661,
    density: 9.6,
    county_fips: 55029,
    county_name: "Door",
    county_weights: {
      55029: 100,
    },
    county_names_all: "Door",
    county_fips_all: 55029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54211,
    lat: 45.15942,
    lng: -87.16783,
    city: "Ephraim",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 227,
    density: 24.7,
    county_fips: 55029,
    county_name: "Door",
    county_weights: {
      55029: 100,
    },
    county_names_all: "Door",
    county_fips_all: 55029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54212,
    lat: 45.12169,
    lng: -87.23024,
    city: "Fish Creek",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 910,
    density: 10.9,
    county_fips: 55029,
    county_name: "Door",
    county_weights: {
      55029: 100,
    },
    county_names_all: "Door",
    county_fips_all: 55029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54213,
    lat: 44.69926,
    lng: -87.52114,
    city: "Forestville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1267,
    density: 12.7,
    county_fips: 55029,
    county_name: "Door",
    county_weights: {
      55029: 89.89,
      55061: 10.11,
    },
    county_names_all: "Door|Kewaunee",
    county_fips_all: "55029|55061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54214,
    lat: 44.19893,
    lng: -87.71441,
    city: "Francis Creek",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 291,
    density: 235.3,
    county_fips: 55071,
    county_name: "Manitowoc",
    county_weights: {
      55071: 100,
    },
    county_names_all: "Manitowoc",
    county_fips_all: 55071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54215,
    lat: 44.22608,
    lng: -87.80357,
    city: "Kellnersville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 55071,
    county_name: "Manitowoc",
    county_weights: {
      55071: 100,
    },
    county_names_all: "Manitowoc",
    county_fips_all: 55071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54216,
    lat: 44.43651,
    lng: -87.58069,
    city: "Kewaunee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6254,
    density: 22.5,
    county_fips: 55061,
    county_name: "Kewaunee",
    county_weights: {
      55061: 100,
    },
    county_names_all: "Kewaunee",
    county_fips_all: 55061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54217,
    lat: 44.54694,
    lng: -87.71748,
    city: "Luxemburg",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7393,
    density: 25.5,
    county_fips: 55061,
    county_name: "Kewaunee",
    county_weights: {
      55009: 11.81,
      55029: 7.94,
      55061: 80.25,
    },
    county_names_all: "Kewaunee|Brown|Door",
    county_fips_all: "55061|55009|55029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54220,
    lat: 44.09644,
    lng: -87.73131,
    city: "Manitowoc",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38653,
    density: 151.1,
    county_fips: 55071,
    county_name: "Manitowoc",
    county_weights: {
      55071: 100,
    },
    county_names_all: "Manitowoc",
    county_fips_all: 55071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54227,
    lat: 44.28096,
    lng: -87.80656,
    city: "Maribel",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1433,
    density: 17.2,
    county_fips: 55071,
    county_name: "Manitowoc",
    county_weights: {
      55071: 100,
    },
    county_names_all: "Manitowoc",
    county_fips_all: 55071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54228,
    lat: 44.27677,
    lng: -87.64875,
    city: "Mishicot",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2919,
    density: 28,
    county_fips: 55071,
    county_name: "Manitowoc",
    county_weights: {
      55071: 100,
    },
    county_names_all: "Manitowoc",
    county_fips_all: 55071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54229,
    lat: 44.56411,
    lng: -87.82081,
    city: "New Franken",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5386,
    density: 53.9,
    county_fips: 55009,
    county_name: "Brown",
    county_weights: {
      55009: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 55009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54230,
    lat: 44.15749,
    lng: -87.91202,
    city: "Reedsville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4594,
    density: 16.3,
    county_fips: 55071,
    county_name: "Manitowoc",
    county_weights: {
      55071: 100,
    },
    county_names_all: "Manitowoc",
    county_fips_all: 55071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54232,
    lat: 44.00668,
    lng: -87.92462,
    city: "Saint Nazianz",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 936,
    density: 455.4,
    county_fips: 55071,
    county_name: "Manitowoc",
    county_weights: {
      55071: 100,
    },
    county_names_all: "Manitowoc",
    county_fips_all: 55071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54234,
    lat: 45.18377,
    lng: -87.09239,
    city: "Sister Bay",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1846,
    density: 30.4,
    county_fips: 55029,
    county_name: "Door",
    county_weights: {
      55029: 100,
    },
    county_names_all: "Door",
    county_fips_all: 55029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54235,
    lat: 44.84218,
    lng: -87.37677,
    city: "Sturgeon Bay",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16822,
    density: 34.1,
    county_fips: 55029,
    county_name: "Door",
    county_weights: {
      55029: 100,
    },
    county_names_all: "Door",
    county_fips_all: 55029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54241,
    lat: 44.21758,
    lng: -87.59723,
    city: "Two Rivers",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13893,
    density: 79.6,
    county_fips: 55071,
    county_name: "Manitowoc",
    county_weights: {
      55071: 100,
    },
    county_names_all: "Manitowoc",
    county_fips_all: 55071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54245,
    lat: 44.02728,
    lng: -87.8977,
    city: "Valders",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1950,
    density: 19.2,
    county_fips: 55071,
    county_name: "Manitowoc",
    county_weights: {
      55071: 100,
    },
    county_names_all: "Manitowoc",
    county_fips_all: 55071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54246,
    lat: 45.37538,
    lng: -86.89721,
    city: "Washington Island",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 828,
    density: 12.6,
    county_fips: 55029,
    county_name: "Door",
    county_weights: {
      55029: 100,
    },
    county_names_all: "Door",
    county_fips_all: 55029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54247,
    lat: 44.19686,
    lng: -87.78564,
    city: "Whitelaw",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2449,
    density: 28.7,
    county_fips: 55071,
    county_name: "Manitowoc",
    county_weights: {
      55071: 100,
    },
    county_names_all: "Manitowoc",
    county_fips_all: 55071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54301,
    lat: 44.48193,
    lng: -88.02029,
    city: "Green Bay",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21485,
    density: 1276.7,
    county_fips: 55009,
    county_name: "Brown",
    county_weights: {
      55009: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 55009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54302,
    lat: 44.50663,
    lng: -87.97668,
    city: "Green Bay",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31670,
    density: 1325.4,
    county_fips: 55009,
    county_name: "Brown",
    county_weights: {
      55009: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 55009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54303,
    lat: 44.53931,
    lng: -88.05115,
    city: "Green Bay",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26142,
    density: 878.2,
    county_fips: 55009,
    county_name: "Brown",
    county_weights: {
      55009: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 55009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54304,
    lat: 44.49419,
    lng: -88.06758,
    city: "Green Bay",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27524,
    density: 911.3,
    county_fips: 55009,
    county_name: "Brown",
    county_weights: {
      55009: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 55009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54307,
    lat: 44.47049,
    lng: -88.0366,
    city: "Green Bay",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1237,
    density: 5710.9,
    county_fips: 55009,
    county_name: "Brown",
    county_weights: {
      55009: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 55009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54311,
    lat: 44.48377,
    lng: -87.89483,
    city: "Green Bay",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35754,
    density: 202.4,
    county_fips: 55009,
    county_name: "Brown",
    county_weights: {
      55009: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 55009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54313,
    lat: 44.58923,
    lng: -88.11088,
    city: "Green Bay",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40083,
    density: 274,
    county_fips: 55009,
    county_name: "Brown",
    county_weights: {
      55009: 98.76,
      55087: 1.24,
    },
    county_names_all: "Brown|Outagamie",
    county_fips_all: "55009|55087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54401,
    lat: 44.96647,
    lng: -89.70794,
    city: "Wausau",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30625,
    density: 140.5,
    county_fips: 55073,
    county_name: "Marathon",
    county_weights: {
      55073: 100,
    },
    county_names_all: "Marathon",
    county_fips_all: 55073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54403,
    lat: 45.03142,
    lng: -89.51343,
    city: "Wausau",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23977,
    density: 69.3,
    county_fips: 55073,
    county_name: "Marathon",
    county_weights: {
      55073: 100,
    },
    county_names_all: "Marathon",
    county_fips_all: 55073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54405,
    lat: 44.96289,
    lng: -90.2797,
    city: "Abbotsford",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2697,
    density: 34.9,
    county_fips: 55073,
    county_name: "Marathon",
    county_weights: {
      55019: 24.7,
      55073: 75.3,
    },
    county_names_all: "Marathon|Clark",
    county_fips_all: "55073|55019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54406,
    lat: 44.41122,
    lng: -89.31211,
    city: "Amherst",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3502,
    density: 20.4,
    county_fips: 55097,
    county_name: "Portage",
    county_weights: {
      55097: 100,
    },
    county_names_all: "Portage",
    county_fips_all: 55097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54407,
    lat: 44.52712,
    lng: -89.29418,
    city: "Amherst Junction",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1333,
    density: 11,
    county_fips: 55097,
    county_name: "Portage",
    county_weights: {
      55097: 100,
    },
    county_names_all: "Portage",
    county_fips_all: 55097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54408,
    lat: 45.02861,
    lng: -89.30922,
    city: "Aniwa",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1063,
    density: 8.3,
    county_fips: 55073,
    county_name: "Marathon",
    county_weights: {
      55067: 4.23,
      55073: 86.71,
      55115: 9.06,
    },
    county_names_all: "Marathon|Shawano|Langlade",
    county_fips_all: "55073|55115|55067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54409,
    lat: 45.11928,
    lng: -89.16909,
    city: "Antigo",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12953,
    density: 24.2,
    county_fips: 55067,
    county_name: "Langlade",
    county_weights: {
      55067: 87.83,
      55073: 8.42,
      55115: 3.75,
    },
    county_names_all: "Langlade|Marathon|Shawano",
    county_fips_all: "55067|55073|55115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54410,
    lat: 44.54158,
    lng: -90.02877,
    city: "Arpin",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2633,
    density: 15.7,
    county_fips: 55141,
    county_name: "Wood",
    county_weights: {
      55141: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 55141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54411,
    lat: 45.05023,
    lng: -90.02837,
    city: "Athens",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5017,
    density: 10.2,
    county_fips: 55073,
    county_name: "Marathon",
    county_weights: {
      55073: 94.25,
      55119: 5.75,
    },
    county_names_all: "Marathon|Taylor",
    county_fips_all: "55073|55119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54412,
    lat: 44.66859,
    lng: -89.98238,
    city: "Auburndale",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2043,
    density: 11.1,
    county_fips: 55141,
    county_name: "Wood",
    county_weights: {
      55073: 37.18,
      55141: 62.82,
    },
    county_names_all: "Wood|Marathon",
    county_fips_all: "55141|55073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54413,
    lat: 44.28363,
    lng: -90.15185,
    city: "Babcock",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 160,
    density: 1.4,
    county_fips: 55141,
    county_name: "Wood",
    county_weights: {
      55141: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 55141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54414,
    lat: 44.95589,
    lng: -89.18202,
    city: "Birnamwood",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3409,
    density: 10,
    county_fips: 55115,
    county_name: "Shawano",
    county_weights: {
      55067: 0.41,
      55073: 38.75,
      55115: 60.84,
    },
    county_names_all: "Shawano|Marathon|Langlade",
    county_fips_all: "55115|55073|55067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54416,
    lat: 44.8822,
    lng: -88.94153,
    city: "Bowler",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1671,
    density: 7.9,
    county_fips: 55115,
    county_name: "Shawano",
    county_weights: {
      55115: 100,
    },
    county_names_all: "Shawano",
    county_fips_all: 55115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54417,
    lat: 45.02749,
    lng: -89.65418,
    city: "Brokaw",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20,
    density: 19.4,
    county_fips: 55073,
    county_name: "Marathon",
    county_weights: {
      55073: 100,
    },
    county_names_all: "Marathon",
    county_fips_all: 55073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54418,
    lat: 45.21566,
    lng: -88.98003,
    city: "Bryant",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 993,
    density: 4.4,
    county_fips: 55067,
    county_name: "Langlade",
    county_weights: {
      55067: 100,
    },
    county_names_all: "Langlade",
    county_fips_all: 55067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54420,
    lat: 44.61043,
    lng: -90.35036,
    city: "Chili",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1304,
    density: 12.5,
    county_fips: 55019,
    county_name: "Clark",
    county_weights: {
      55019: 91.21,
      55141: 8.79,
    },
    county_names_all: "Clark|Wood",
    county_fips_all: "55019|55141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54421,
    lat: 44.89866,
    lng: -90.29532,
    city: "Colby",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4330,
    density: 23.9,
    county_fips: 55073,
    county_name: "Marathon",
    county_weights: {
      55019: 44.85,
      55073: 55.15,
    },
    county_names_all: "Marathon|Clark",
    county_fips_all: "55073|55019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54422,
    lat: 44.98279,
    lng: -90.45264,
    city: "Curtiss",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1284,
    density: 12.2,
    county_fips: 55019,
    county_name: "Clark",
    county_weights: {
      55019: 77.18,
      55119: 22.82,
    },
    county_names_all: "Clark|Taylor",
    county_fips_all: "55019|55119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54423,
    lat: 44.58049,
    lng: -89.41642,
    city: "Custer",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2422,
    density: 19.3,
    county_fips: 55097,
    county_name: "Portage",
    county_weights: {
      55097: 100,
    },
    county_names_all: "Portage",
    county_fips_all: 55097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54424,
    lat: 45.28471,
    lng: -89.18701,
    city: "Deerbrook",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1641,
    density: 3.9,
    county_fips: 55067,
    county_name: "Langlade",
    county_weights: {
      55067: 100,
    },
    county_names_all: "Langlade",
    county_fips_all: 55067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54425,
    lat: 45.0086,
    lng: -90.34249,
    city: "Dorchester",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2016,
    density: 18.7,
    county_fips: 55019,
    county_name: "Clark",
    county_weights: {
      55019: 57.6,
      55073: 31.26,
      55119: 11.14,
    },
    county_names_all: "Clark|Marathon|Taylor",
    county_fips_all: "55019|55073|55119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54426,
    lat: 44.90804,
    lng: -89.98832,
    city: "Edgar",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4339,
    density: 15.8,
    county_fips: 55073,
    county_name: "Marathon",
    county_weights: {
      55073: 100,
    },
    county_names_all: "Marathon",
    county_fips_all: 55073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54427,
    lat: 44.82401,
    lng: -89.25789,
    city: "Eland",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1298,
    density: 11.3,
    county_fips: 55073,
    county_name: "Marathon",
    county_weights: {
      55073: 76.02,
      55115: 23.98,
    },
    county_names_all: "Marathon|Shawano",
    county_fips_all: "55073|55115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54428,
    lat: 45.43511,
    lng: -89.17282,
    city: "Elcho",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 941,
    density: 5.2,
    county_fips: 55067,
    county_name: "Langlade",
    county_weights: {
      55067: 95.77,
      55085: 4.23,
    },
    county_names_all: "Langlade|Oneida",
    county_fips_all: "55067|55085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54430,
    lat: 45.1395,
    lng: -88.8872,
    city: "Elton",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 153,
    density: 5.8,
    county_fips: 55067,
    county_name: "Langlade",
    county_weights: {
      55067: 99.74,
      55078: 0.26,
    },
    county_names_all: "Langlade|Menominee",
    county_fips_all: "55067|55078",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54433,
    lat: 45.20649,
    lng: -90.81756,
    city: "Gilman",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1888,
    density: 4.6,
    county_fips: 55119,
    county_name: "Taylor",
    county_weights: {
      55017: 11.07,
      55119: 88.93,
    },
    county_names_all: "Taylor|Chippewa",
    county_fips_all: "55119|55017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54435,
    lat: 45.35084,
    lng: -89.44349,
    city: "Gleason",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1959,
    density: 3.8,
    county_fips: 55069,
    county_name: "Lincoln",
    county_weights: {
      55067: 41.23,
      55069: 58.77,
    },
    county_names_all: "Lincoln|Langlade",
    county_fips_all: "55069|55067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54436,
    lat: 44.54149,
    lng: -90.43101,
    city: "Granton",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2320,
    density: 8.6,
    county_fips: 55019,
    county_name: "Clark",
    county_weights: {
      55019: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 55019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54437,
    lat: 44.77867,
    lng: -90.63866,
    city: "Greenwood",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2988,
    density: 9.2,
    county_fips: 55019,
    county_name: "Clark",
    county_weights: {
      55019: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 55019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54440,
    lat: 44.80621,
    lng: -89.38838,
    city: "Hatley",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2844,
    density: 13.3,
    county_fips: 55073,
    county_name: "Marathon",
    county_weights: {
      55073: 100,
    },
    county_names_all: "Marathon",
    county_fips_all: 55073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54441,
    lat: 44.64202,
    lng: -90.10604,
    city: "Hewitt",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1016,
    density: 382.9,
    county_fips: 55141,
    county_name: "Wood",
    county_weights: {
      55141: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 55141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54442,
    lat: 45.36532,
    lng: -89.65439,
    city: "Irma",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1287,
    density: 6.6,
    county_fips: 55069,
    county_name: "Lincoln",
    county_weights: {
      55069: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 55069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54443,
    lat: 44.61243,
    lng: -89.75264,
    city: "Junction City",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2156,
    density: 9.3,
    county_fips: 55097,
    county_name: "Portage",
    county_weights: {
      55073: 0.1,
      55097: 99.1,
      55141: 0.8,
    },
    county_names_all: "Portage|Wood|Marathon",
    county_fips_all: "55097|55141|55073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54446,
    lat: 44.7533,
    lng: -90.47149,
    city: "Loyal",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3080,
    density: 15.5,
    county_fips: 55019,
    county_name: "Clark",
    county_weights: {
      55019: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 55019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54447,
    lat: 45.09061,
    lng: -90.72911,
    city: "Lublin",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 431,
    density: 3.7,
    county_fips: 55119,
    county_name: "Taylor",
    county_weights: {
      55119: 100,
    },
    county_names_all: "Taylor",
    county_fips_all: 55119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54448,
    lat: 44.93094,
    lng: -89.83422,
    city: "Marathon",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4384,
    density: 18.6,
    county_fips: 55073,
    county_name: "Marathon",
    county_weights: {
      55073: 100,
    },
    county_names_all: "Marathon",
    county_fips_all: 55073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54449,
    lat: 44.63914,
    lng: -90.19755,
    city: "Marshfield",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26324,
    density: 58.9,
    county_fips: 55141,
    county_name: "Wood",
    county_weights: {
      55019: 0.21,
      55073: 28.59,
      55141: 71.2,
    },
    county_names_all: "Wood|Marathon|Clark",
    county_fips_all: "55141|55073|55019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54450,
    lat: 45.00367,
    lng: -89.04172,
    city: "Mattoon",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 406,
    density: 107.6,
    county_fips: 55115,
    county_name: "Shawano",
    county_weights: {
      55115: 100,
    },
    county_names_all: "Shawano",
    county_fips_all: 55115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54451,
    lat: 45.19131,
    lng: -90.40172,
    city: "Medford",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11261,
    density: 12.9,
    county_fips: 55119,
    county_name: "Taylor",
    county_weights: {
      55073: 1.7,
      55119: 98.3,
    },
    county_names_all: "Taylor|Marathon",
    county_fips_all: "55119|55073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54452,
    lat: 45.20879,
    lng: -89.76743,
    city: "Merrill",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18649,
    density: 16.4,
    county_fips: 55069,
    county_name: "Lincoln",
    county_weights: {
      55069: 89.44,
      55073: 10.56,
    },
    county_names_all: "Lincoln|Marathon",
    county_fips_all: "55069|55073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54454,
    lat: 44.60259,
    lng: -89.8846,
    city: "Milladore",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1395,
    density: 12,
    county_fips: 55141,
    county_name: "Wood",
    county_weights: {
      55097: 5.04,
      55141: 94.96,
    },
    county_names_all: "Wood|Portage",
    county_fips_all: "55141|55097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54455,
    lat: 44.7625,
    lng: -89.68559,
    city: "Mosinee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18105,
    density: 29.7,
    county_fips: 55073,
    county_name: "Marathon",
    county_weights: {
      55073: 92.64,
      55097: 7.36,
    },
    county_names_all: "Marathon|Portage",
    county_fips_all: "55073|55097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54456,
    lat: 44.54511,
    lng: -90.63824,
    city: "Neillsville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5644,
    density: 9.7,
    county_fips: 55019,
    county_name: "Clark",
    county_weights: {
      55019: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 55019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54457,
    lat: 44.22965,
    lng: -89.89502,
    city: "Nekoosa",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7592,
    density: 21,
    county_fips: 55001,
    county_name: "Adams",
    county_weights: {
      55001: 42.83,
      55057: 24.82,
      55141: 32.34,
    },
    county_names_all: "Adams|Wood|Juneau",
    county_fips_all: "55001|55141|55057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54458,
    lat: 44.49867,
    lng: -89.31027,
    city: "Nelsonville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 104,
    density: 90.3,
    county_fips: 55097,
    county_name: "Portage",
    county_weights: {
      55097: 100,
    },
    county_names_all: "Portage",
    county_fips_all: 55097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54459,
    lat: 45.42515,
    lng: -90.26924,
    city: "Ogema",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1218,
    density: 3.5,
    county_fips: 55099,
    county_name: "Price",
    county_weights: {
      55069: 1.41,
      55099: 98.59,
    },
    county_names_all: "Price|Lincoln",
    county_fips_all: "55099|55069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54460,
    lat: 44.94703,
    lng: -90.53728,
    city: "Owen",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2757,
    density: 12.7,
    county_fips: 55019,
    county_name: "Clark",
    county_weights: {
      55019: 81.79,
      55119: 18.21,
    },
    county_names_all: "Clark|Taylor",
    county_fips_all: "55019|55119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54462,
    lat: 45.39408,
    lng: -89.00031,
    city: "Pearson",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 425,
    density: 3.6,
    county_fips: 55067,
    county_name: "Langlade",
    county_weights: {
      55067: 100,
    },
    county_names_all: "Langlade",
    county_fips_all: 55067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54463,
    lat: 45.50876,
    lng: -89.22536,
    city: "Pelican Lake",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 567,
    density: 2.4,
    county_fips: 55085,
    county_name: "Oneida",
    county_weights: {
      55067: 1.88,
      55085: 98.12,
    },
    county_names_all: "Oneida|Langlade",
    county_fips_all: "55085|55067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54464,
    lat: 45.05486,
    lng: -89.01748,
    city: "Phlox",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 55067,
    county_name: "Langlade",
    county_weights: {
      55067: 100,
    },
    county_names_all: "Langlade",
    county_fips_all: 55067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54465,
    lat: 45.39327,
    lng: -88.88334,
    city: "Pickerel",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 489,
    density: 5,
    county_fips: 55041,
    county_name: "Forest",
    county_weights: {
      55041: 63.71,
      55067: 36.29,
    },
    county_names_all: "Forest|Langlade",
    county_fips_all: "55041|55067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54466,
    lat: 44.3855,
    lng: -90.31687,
    city: "Pittsville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2765,
    density: 3.5,
    county_fips: 55141,
    county_name: "Wood",
    county_weights: {
      55019: 4.4,
      55053: 42.18,
      55141: 53.42,
    },
    county_names_all: "Wood|Jackson|Clark",
    county_fips_all: "55141|55053|55019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54467,
    lat: 44.41575,
    lng: -89.54062,
    city: "Plover",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13893,
    density: 80.8,
    county_fips: 55097,
    county_name: "Portage",
    county_weights: {
      55097: 100,
    },
    county_names_all: "Portage",
    county_fips_all: 55097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54469,
    lat: 44.34642,
    lng: -89.87028,
    city: "Port Edwards",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1775,
    density: 261.1,
    county_fips: 55141,
    county_name: "Wood",
    county_weights: {
      55141: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 55141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54470,
    lat: 45.29419,
    lng: -90.13852,
    city: "Rib Lake",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2059,
    density: 7.5,
    county_fips: 55119,
    county_name: "Taylor",
    county_weights: {
      55099: 2.36,
      55119: 97.64,
    },
    county_names_all: "Taylor|Price",
    county_fips_all: "55119|55099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54471,
    lat: 44.93361,
    lng: -89.41914,
    city: "Ringle",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1786,
    density: 15.4,
    county_fips: 55073,
    county_name: "Marathon",
    county_weights: {
      55073: 100,
    },
    county_names_all: "Marathon",
    county_fips_all: 55073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54473,
    lat: 44.64984,
    lng: -89.35634,
    city: "Rosholt",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2640,
    density: 12.1,
    county_fips: 55097,
    county_name: "Portage",
    county_weights: {
      55073: 23.84,
      55097: 76.16,
    },
    county_names_all: "Portage|Marathon",
    county_fips_all: "55097|55073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54474,
    lat: 44.87395,
    lng: -89.62223,
    city: "Rothschild",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4004,
    density: 308.2,
    county_fips: 55073,
    county_name: "Marathon",
    county_weights: {
      55073: 100,
    },
    county_names_all: "Marathon",
    county_fips_all: 55073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54475,
    lat: 44.48204,
    lng: -89.78825,
    city: "Rudolph",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1484,
    density: 15.4,
    county_fips: 55141,
    county_name: "Wood",
    county_weights: {
      55097: 17.61,
      55141: 82.39,
    },
    county_names_all: "Wood|Portage",
    county_fips_all: "55141|55097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54476,
    lat: 44.88816,
    lng: -89.52389,
    city: "Schofield",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19001,
    density: 174.6,
    county_fips: 55073,
    county_name: "Marathon",
    county_weights: {
      55073: 100,
    },
    county_names_all: "Marathon",
    county_fips_all: 55073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54479,
    lat: 44.75688,
    lng: -90.32525,
    city: "Spencer",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3705,
    density: 18.6,
    county_fips: 55019,
    county_name: "Clark",
    county_weights: {
      55019: 56.25,
      55073: 43.75,
    },
    county_names_all: "Clark|Marathon",
    county_fips_all: "55019|55073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54480,
    lat: 45.05908,
    lng: -90.27597,
    city: "Stetsonville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1396,
    density: 15.2,
    county_fips: 55119,
    county_name: "Taylor",
    county_weights: {
      55073: 7.82,
      55119: 92.18,
    },
    county_names_all: "Taylor|Marathon",
    county_fips_all: "55119|55073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54481,
    lat: 44.51935,
    lng: -89.63678,
    city: "Stevens Point",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28166,
    density: 165.9,
    county_fips: 55097,
    county_name: "Portage",
    county_weights: {
      55097: 100,
    },
    county_names_all: "Portage",
    county_fips_all: 55097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54482,
    lat: 44.55174,
    lng: -89.5092,
    city: "Stevens Point",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10717,
    density: 45.5,
    county_fips: 55097,
    county_name: "Portage",
    county_weights: {
      55097: 100,
    },
    county_names_all: "Portage",
    county_fips_all: 55097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54484,
    lat: 44.79988,
    lng: -90.07962,
    city: "Stratford",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5349,
    density: 19.6,
    county_fips: 55073,
    county_name: "Marathon",
    county_weights: {
      55073: 100,
    },
    county_names_all: "Marathon",
    county_fips_all: 55073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54485,
    lat: 45.39373,
    lng: -89.21894,
    city: "Summit Lake",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 268,
    density: 4.6,
    county_fips: 55067,
    county_name: "Langlade",
    county_weights: {
      55067: 100,
    },
    county_names_all: "Langlade",
    county_fips_all: 55067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54486,
    lat: 44.72595,
    lng: -89.05124,
    city: "Tigerton",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1851,
    density: 5.8,
    county_fips: 55115,
    county_name: "Shawano",
    county_weights: {
      55115: 81.22,
      55135: 18.78,
    },
    county_names_all: "Shawano|Waupaca",
    county_fips_all: "55115|55135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54487,
    lat: 45.50429,
    lng: -89.75114,
    city: "Tomahawk",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9337,
    density: 12.4,
    county_fips: 55069,
    county_name: "Lincoln",
    county_weights: {
      55069: 73.84,
      55085: 26.16,
    },
    county_names_all: "Lincoln|Oneida",
    county_fips_all: "55069|55085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54488,
    lat: 44.84335,
    lng: -90.33778,
    city: "Unity",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1162,
    density: 11.6,
    county_fips: 55019,
    county_name: "Clark",
    county_weights: {
      55019: 53.65,
      55073: 46.35,
    },
    county_names_all: "Clark|Marathon",
    county_fips_all: "55019|55073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54489,
    lat: 44.45445,
    lng: -90.0075,
    city: "Vesper",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1642,
    density: 13.3,
    county_fips: 55141,
    county_name: "Wood",
    county_weights: {
      55141: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 55141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54490,
    lat: 45.33622,
    lng: -90.41102,
    city: "Westboro",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 904,
    density: 2.8,
    county_fips: 55119,
    county_name: "Taylor",
    county_weights: {
      55099: 0.51,
      55119: 99.49,
    },
    county_names_all: "Taylor|Price",
    county_fips_all: "55119|55099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54491,
    lat: 45.2343,
    lng: -88.76541,
    city: "White Lake",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1457,
    density: 2.8,
    county_fips: 55067,
    county_name: "Langlade",
    county_weights: {
      55067: 90.96,
      55083: 9.04,
    },
    county_names_all: "Langlade|Oconto",
    county_fips_all: "55067|55083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54493,
    lat: 44.70083,
    lng: -90.80107,
    city: "Willard",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 685,
    density: 2.5,
    county_fips: 55019,
    county_name: "Clark",
    county_weights: {
      55019: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 55019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54494,
    lat: 44.34414,
    lng: -89.74054,
    city: "Wisconsin Rapids",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26936,
    density: 83,
    county_fips: 55141,
    county_name: "Wood",
    county_weights: {
      55001: 3.11,
      55097: 39.77,
      55141: 57.12,
    },
    county_names_all: "Wood|Portage|Adams",
    county_fips_all: "55141|55097|55001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54495,
    lat: 44.39081,
    lng: -89.95351,
    city: "Wisconsin Rapids",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7284,
    density: 27,
    county_fips: 55141,
    county_name: "Wood",
    county_weights: {
      55141: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 55141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54498,
    lat: 45.03278,
    lng: -90.62105,
    city: "Withee",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2376,
    density: 8.2,
    county_fips: 55019,
    county_name: "Clark",
    county_weights: {
      55019: 50.7,
      55119: 49.3,
    },
    county_names_all: "Clark|Taylor",
    county_fips_all: "55019|55119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54499,
    lat: 44.78963,
    lng: -89.1801,
    city: "Wittenberg",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2842,
    density: 9.8,
    county_fips: 55115,
    county_name: "Shawano",
    county_weights: {
      55073: 29.9,
      55097: 1.51,
      55115: 68.59,
    },
    county_names_all: "Shawano|Marathon|Portage",
    county_fips_all: "55115|55073|55097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54501,
    lat: 45.65973,
    lng: -89.34303,
    city: "Rhinelander",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20306,
    density: 21.4,
    county_fips: 55085,
    county_name: "Oneida",
    county_weights: {
      55069: 2,
      55085: 98,
    },
    county_names_all: "Oneida|Lincoln",
    county_fips_all: "55085|55069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54511,
    lat: 45.72365,
    lng: -88.83177,
    city: "Argonne",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1280,
    density: 1.8,
    county_fips: 55041,
    county_name: "Forest",
    county_weights: {
      55041: 100,
    },
    county_names_all: "Forest",
    county_fips_all: 55041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54512,
    lat: 46.0957,
    lng: -89.66748,
    city: "Boulder Junction",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 975,
    density: 4.5,
    county_fips: 55125,
    county_name: "Vilas",
    county_weights: {
      55125: 100,
    },
    county_names_all: "Vilas",
    county_fips_all: 55125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54513,
    lat: 45.58246,
    lng: -90.11986,
    city: "Brantwood",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 435,
    density: 1.6,
    county_fips: 55099,
    county_name: "Price",
    county_weights: {
      55099: 100,
    },
    county_names_all: "Price",
    county_fips_all: 55099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54514,
    lat: 46.03761,
    lng: -90.49378,
    city: "Butternut",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1922,
    density: 3.3,
    county_fips: 55003,
    county_name: "Ashland",
    county_weights: {
      55003: 80.49,
      55051: 6.46,
      55099: 13.05,
    },
    county_names_all: "Ashland|Price|Iron",
    county_fips_all: "55003|55099|55051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54515,
    lat: 45.5146,
    lng: -90.50217,
    city: "Catawba",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 485,
    density: 2.3,
    county_fips: 55099,
    county_name: "Price",
    county_weights: {
      55099: 100,
    },
    county_names_all: "Price",
    county_fips_all: 55099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54517,
    lat: 46.11899,
    lng: -90.93035,
    city: "Clam Lake",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 121,
    density: 0.5,
    county_fips: 55003,
    county_name: "Ashland",
    county_weights: {
      55003: 56.22,
      55007: 12.83,
      55113: 30.95,
    },
    county_names_all: "Ashland|Sawyer|Bayfield",
    county_fips_all: "55003|55113|55007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54519,
    lat: 46.05355,
    lng: -89.26877,
    city: "Conover",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1295,
    density: 5.9,
    county_fips: 55125,
    county_name: "Vilas",
    county_weights: {
      55125: 100,
    },
    county_names_all: "Vilas",
    county_fips_all: 55125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54520,
    lat: 45.53773,
    lng: -88.92303,
    city: "Crandon",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4138,
    density: 13,
    county_fips: 55041,
    county_name: "Forest",
    county_weights: {
      55041: 100,
    },
    county_names_all: "Forest",
    county_fips_all: 55041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54521,
    lat: 45.9162,
    lng: -89.25451,
    city: "Eagle River",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7986,
    density: 16.4,
    county_fips: 55125,
    county_name: "Vilas",
    county_weights: {
      55041: 5.09,
      55085: 30.25,
      55125: 64.66,
    },
    county_names_all: "Vilas|Oneida|Forest",
    county_fips_all: "55125|55085|55041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54524,
    lat: 45.84416,
    lng: -90.38922,
    city: "Fifield",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 686,
    density: 4.5,
    county_fips: 55099,
    county_name: "Price",
    county_weights: {
      55099: 100,
    },
    county_names_all: "Price",
    county_fips_all: 55099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54525,
    lat: 46.4335,
    lng: -90.22603,
    city: "Gile",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 293,
    density: 121.1,
    county_fips: 55051,
    county_name: "Iron",
    county_weights: {
      55051: 100,
    },
    county_names_all: "Iron",
    county_fips_all: 55051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Menominee",
  },
  {
    zip: 54526,
    lat: 45.50969,
    lng: -90.85872,
    city: "Glen Flora",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 755,
    density: 2.5,
    county_fips: 55107,
    county_name: "Rusk",
    county_weights: {
      55107: 100,
    },
    county_names_all: "Rusk",
    county_fips_all: 55107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54527,
    lat: 46.13543,
    lng: -90.6366,
    city: "Glidden",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 817,
    density: 1.6,
    county_fips: 55003,
    county_name: "Ashland",
    county_weights: {
      55003: 100,
    },
    county_names_all: "Ashland",
    county_fips_all: 55003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54529,
    lat: 45.67821,
    lng: -89.66006,
    city: "Harshaw",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1154,
    density: 6.2,
    county_fips: 55085,
    county_name: "Oneida",
    county_weights: {
      55085: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 55085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54530,
    lat: 45.53202,
    lng: -90.71537,
    city: "Hawkins",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 726,
    density: 2.4,
    county_fips: 55107,
    county_name: "Rusk",
    county_weights: {
      55099: 24.1,
      55107: 71.32,
      55113: 4.58,
    },
    county_names_all: "Rusk|Price|Sawyer",
    county_fips_all: "55107|55099|55113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54531,
    lat: 45.74968,
    lng: -89.78822,
    city: "Hazelhurst",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1294,
    density: 7.8,
    county_fips: 55085,
    county_name: "Oneida",
    county_weights: {
      55085: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 55085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54534,
    lat: 46.3545,
    lng: -90.23769,
    city: "Hurley",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2333,
    density: 6.7,
    county_fips: 55051,
    county_name: "Iron",
    county_weights: {
      55051: 100,
    },
    county_names_all: "Iron",
    county_fips_all: 55051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54536,
    lat: 46.33603,
    lng: -90.34488,
    city: "Iron Belt",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 157,
    density: 1.5,
    county_fips: 55051,
    county_name: "Iron",
    county_weights: {
      55051: 100,
    },
    county_names_all: "Iron",
    county_fips_all: 55051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54537,
    lat: 45.53136,
    lng: -90.60213,
    city: "Kennan",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 512,
    density: 2.3,
    county_fips: 55099,
    county_name: "Price",
    county_weights: {
      55099: 100,
    },
    county_names_all: "Price",
    county_fips_all: 55099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54538,
    lat: 45.97244,
    lng: -89.91484,
    city: "Lac Du Flambeau",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2991,
    density: 11,
    county_fips: 55125,
    county_name: "Vilas",
    county_weights: {
      55051: 10.53,
      55085: 9.77,
      55099: 0.98,
      55125: 78.72,
    },
    county_names_all: "Vilas|Iron|Oneida|Price",
    county_fips_all: "55125|55051|55085|55099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54539,
    lat: 45.80705,
    lng: -89.5762,
    city: "Lake Tomahawk",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1261,
    density: 8.7,
    county_fips: 55085,
    county_name: "Oneida",
    county_weights: {
      55085: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 55085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54540,
    lat: 46.15505,
    lng: -89.38216,
    city: "Land O'Lakes",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 880,
    density: 4.3,
    county_fips: 55125,
    county_name: "Vilas",
    county_weights: {
      26053: 0.65,
      55125: 99.35,
    },
    county_names_all: "Vilas|Gogebic",
    county_fips_all: "55125|26053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54541,
    lat: 45.55218,
    lng: -88.65937,
    city: "Laona",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1392,
    density: 3.9,
    county_fips: 55041,
    county_name: "Forest",
    county_weights: {
      55041: 100,
    },
    county_names_all: "Forest",
    county_fips_all: 55041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54542,
    lat: 45.92127,
    lng: -88.72536,
    city: "Long Lake",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 500,
    density: 0.7,
    county_fips: 55041,
    county_name: "Forest",
    county_weights: {
      55037: 39.23,
      55041: 60.77,
    },
    county_names_all: "Forest|Florence",
    county_fips_all: "55041|55037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54545,
    lat: 46.1326,
    lng: -89.85208,
    city: "Manitowish Waters",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 859,
    density: 6.9,
    county_fips: 55125,
    county_name: "Vilas",
    county_weights: {
      55051: 0.13,
      55125: 99.87,
    },
    county_names_all: "Vilas|Iron",
    county_fips_all: "55125|55051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54546,
    lat: 46.28685,
    lng: -90.70977,
    city: "Mellen",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1084,
    density: 2,
    county_fips: 55003,
    county_name: "Ashland",
    county_weights: {
      55003: 100,
    },
    county_names_all: "Ashland",
    county_fips_all: 55003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54547,
    lat: 46.18951,
    lng: -90.0994,
    city: "Mercer",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1363,
    density: 2.4,
    county_fips: 55051,
    county_name: "Iron",
    county_weights: {
      55051: 100,
    },
    county_names_all: "Iron",
    county_fips_all: 55051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54548,
    lat: 45.86218,
    lng: -89.82663,
    city: "Minocqua",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4975,
    density: 19.4,
    county_fips: 55085,
    county_name: "Oneida",
    county_weights: {
      55085: 78.89,
      55125: 21.11,
    },
    county_names_all: "Oneida|Vilas",
    county_fips_all: "55085|55125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54550,
    lat: 46.35775,
    lng: -90.26409,
    city: "Montreal",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 559,
    density: 8,
    county_fips: 55051,
    county_name: "Iron",
    county_weights: {
      55051: 100,
    },
    county_names_all: "Iron",
    county_fips_all: 55051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54552,
    lat: 45.93615,
    lng: -90.29081,
    city: "Park Falls",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4009,
    density: 4.3,
    county_fips: 55099,
    county_name: "Price",
    county_weights: {
      55051: 28,
      55099: 69.02,
      55113: 2.98,
    },
    county_names_all: "Price|Iron|Sawyer",
    county_fips_all: "55099|55051|55113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54554,
    lat: 46.05481,
    lng: -89.06138,
    city: "Phelps",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1163,
    density: 5.6,
    county_fips: 55125,
    county_name: "Vilas",
    county_weights: {
      55125: 100,
    },
    county_names_all: "Vilas",
    county_fips_all: 55125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54555,
    lat: 45.71977,
    lng: -90.36403,
    city: "Phillips",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4769,
    density: 5.1,
    county_fips: 55099,
    county_name: "Price",
    county_weights: {
      55099: 100,
    },
    county_names_all: "Price",
    county_fips_all: 55099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54556,
    lat: 45.53586,
    lng: -90.31386,
    city: "Prentice",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1131,
    density: 4.2,
    county_fips: 55099,
    county_name: "Price",
    county_weights: {
      55099: 100,
    },
    county_names_all: "Price",
    county_fips_all: 55099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54557,
    lat: 46.22178,
    lng: -89.75453,
    city: "Presque Isle",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 838,
    density: 3.6,
    county_fips: 55125,
    county_name: "Vilas",
    county_weights: {
      55051: 1,
      55125: 99,
    },
    county_names_all: "Vilas|Iron",
    county_fips_all: "55125|55051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54558,
    lat: 45.92417,
    lng: -89.49746,
    city: "Saint Germain",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1910,
    density: 17.1,
    county_fips: 55125,
    county_name: "Vilas",
    county_weights: {
      55085: 23.72,
      55125: 76.28,
    },
    county_names_all: "Vilas|Oneida",
    county_fips_all: "55125|55085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54559,
    lat: 46.49382,
    lng: -90.47083,
    city: "Saxon",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 711,
    density: 2.3,
    county_fips: 55051,
    county_name: "Iron",
    county_weights: {
      55003: 14.65,
      55051: 85.35,
    },
    county_names_all: "Iron|Ashland",
    county_fips_all: "55051|55003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54560,
    lat: 46.00997,
    lng: -89.54365,
    city: "Sayner",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 580,
    density: 7,
    county_fips: 55125,
    county_name: "Vilas",
    county_weights: {
      55125: 100,
    },
    county_names_all: "Vilas",
    county_fips_all: 55125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54561,
    lat: 46.07102,
    lng: -89.46451,
    city: "Star Lake",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 55125,
    county_name: "Vilas",
    county_weights: {
      55125: 100,
    },
    county_names_all: "Vilas",
    county_fips_all: 55125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54562,
    lat: 45.81081,
    lng: -89.0813,
    city: "Three Lakes",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1701,
    density: 4.5,
    county_fips: 55085,
    county_name: "Oneida",
    county_weights: {
      55041: 34.98,
      55085: 65.02,
    },
    county_names_all: "Oneida|Forest",
    county_fips_all: "55085|55041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54563,
    lat: 45.46448,
    lng: -90.97428,
    city: "Tony",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 816,
    density: 7.5,
    county_fips: 55107,
    county_name: "Rusk",
    county_weights: {
      55107: 100,
    },
    county_names_all: "Rusk",
    county_fips_all: 55107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54564,
    lat: 45.6105,
    lng: -89.97223,
    city: "Tripoli",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 306,
    density: 0.6,
    county_fips: 55085,
    county_name: "Oneida",
    county_weights: {
      55069: 33.37,
      55085: 65.26,
      55099: 1.37,
    },
    county_names_all: "Oneida|Lincoln|Price",
    county_fips_all: "55085|55069|55099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54565,
    lat: 46.30474,
    lng: -90.45182,
    city: "Upson",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36,
    density: 0.1,
    county_fips: 55051,
    county_name: "Iron",
    county_weights: {
      55051: 100,
    },
    county_names_all: "Iron",
    county_fips_all: 55051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54566,
    lat: 45.42481,
    lng: -88.63263,
    city: "Wabeno",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1183,
    density: 3.4,
    county_fips: 55041,
    county_name: "Forest",
    county_weights: {
      55041: 92.17,
      55067: 7.83,
    },
    county_names_all: "Forest|Langlade",
    county_fips_all: "55041|55067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54568,
    lat: 45.94876,
    lng: -89.67546,
    city: "Woodruff",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4981,
    density: 27,
    county_fips: 55125,
    county_name: "Vilas",
    county_weights: {
      55085: 13.77,
      55125: 86.23,
    },
    county_names_all: "Vilas|Oneida",
    county_fips_all: "55125|55085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54601,
    lat: 43.80199,
    lng: -91.14559,
    city: "La Crosse",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51063,
    density: 261.3,
    county_fips: 55063,
    county_name: "La Crosse",
    county_weights: {
      55063: 100,
    },
    county_names_all: "La Crosse",
    county_fips_all: 55063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54603,
    lat: 43.85729,
    lng: -91.24791,
    city: "La Crosse",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13770,
    density: 600.3,
    county_fips: 55063,
    county_name: "La Crosse",
    county_weights: {
      55063: 100,
    },
    county_names_all: "La Crosse",
    county_fips_all: 55063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54610,
    lat: 44.37077,
    lng: -91.82549,
    city: "Alma",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1546,
    density: 4.7,
    county_fips: 55011,
    county_name: "Buffalo",
    county_weights: {
      55011: 100,
    },
    county_names_all: "Buffalo",
    county_fips_all: 55011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54611,
    lat: 44.44624,
    lng: -90.95164,
    city: "Alma Center",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1243,
    density: 8.9,
    county_fips: 55053,
    county_name: "Jackson",
    county_weights: {
      55053: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 55053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54612,
    lat: 44.24882,
    lng: -91.50066,
    city: "Arcadia",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5015,
    density: 12.8,
    county_fips: 55121,
    county_name: "Trempealeau",
    county_weights: {
      55011: 27.69,
      55121: 72.31,
    },
    county_names_all: "Trempealeau|Buffalo",
    county_fips_all: "55121|55011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54613,
    lat: 44.07549,
    lng: -89.92131,
    city: "Arkdale",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1799,
    density: 9.4,
    county_fips: 55001,
    county_name: "Adams",
    county_weights: {
      55001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 55001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54614,
    lat: 43.90242,
    lng: -90.9729,
    city: "Bangor",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2548,
    density: 12.5,
    county_fips: 55063,
    county_name: "La Crosse",
    county_weights: {
      55063: 100,
    },
    county_names_all: "La Crosse",
    county_fips_all: 55063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54615,
    lat: 44.26158,
    lng: -90.78049,
    city: "Black River Falls",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10525,
    density: 12.9,
    county_fips: 55053,
    county_name: "Jackson",
    county_weights: {
      55053: 97.14,
      55081: 2.86,
    },
    county_names_all: "Jackson|Monroe",
    county_fips_all: "55053|55081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54616,
    lat: 44.30402,
    lng: -91.2283,
    city: "Blair",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2488,
    density: 10.3,
    county_fips: 55121,
    county_name: "Trempealeau",
    county_weights: {
      55053: 12.81,
      55121: 87.19,
    },
    county_names_all: "Trempealeau|Jackson",
    county_fips_all: "55121|55053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54618,
    lat: 43.95921,
    lng: -90.28967,
    city: "Camp Douglas",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2319,
    density: 9.4,
    county_fips: 55057,
    county_name: "Juneau",
    county_weights: {
      55057: 70.73,
      55081: 29.27,
    },
    county_names_all: "Juneau|Monroe",
    county_fips_all: "55057|55081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54619,
    lat: 43.75562,
    lng: -90.77968,
    city: "Cashton",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3568,
    density: 13.1,
    county_fips: 55081,
    county_name: "Monroe",
    county_weights: {
      55063: 3.84,
      55081: 73.82,
      55123: 22.34,
    },
    county_names_all: "Monroe|Vernon|La Crosse",
    county_fips_all: "55081|55123|55063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54621,
    lat: 43.65632,
    lng: -91.08199,
    city: "Chaseburg",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1350,
    density: 14.3,
    county_fips: 55123,
    county_name: "Vernon",
    county_weights: {
      55123: 100,
    },
    county_names_all: "Vernon",
    county_fips_all: 55123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54622,
    lat: 44.26953,
    lng: -91.76629,
    city: "Cochrane",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1975,
    density: 13.5,
    county_fips: 55011,
    county_name: "Buffalo",
    county_weights: {
      55011: 100,
    },
    county_names_all: "Buffalo",
    county_fips_all: 55011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54623,
    lat: 43.72894,
    lng: -91.03065,
    city: "Coon Valley",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2142,
    density: 16.3,
    county_fips: 55063,
    county_name: "La Crosse",
    county_weights: {
      55063: 57.41,
      55123: 42.59,
    },
    county_names_all: "La Crosse|Vernon",
    county_fips_all: "55063|55123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54624,
    lat: 43.46575,
    lng: -91.14066,
    city: "De Soto",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1530,
    density: 9,
    county_fips: 55123,
    county_name: "Vernon",
    county_weights: {
      55023: 14.14,
      55123: 85.86,
    },
    county_names_all: "Vernon|Crawford",
    county_fips_all: "55123|55023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54625,
    lat: 44.13287,
    lng: -91.52507,
    city: "Dodge",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 225,
    density: 13.4,
    county_fips: 55121,
    county_name: "Trempealeau",
    county_weights: {
      55121: 100,
    },
    county_names_all: "Trempealeau",
    county_fips_all: 55121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54626,
    lat: 43.2162,
    lng: -91.03608,
    city: "Eastman",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1289,
    density: 7,
    county_fips: 55023,
    county_name: "Crawford",
    county_weights: {
      55023: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 55023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54627,
    lat: 44.16873,
    lng: -91.23634,
    city: "Ettrick",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1754,
    density: 8,
    county_fips: 55121,
    county_name: "Trempealeau",
    county_weights: {
      55053: 11.84,
      55121: 88.16,
    },
    county_names_all: "Trempealeau|Jackson",
    county_fips_all: "55121|55053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54628,
    lat: 43.37572,
    lng: -91.02618,
    city: "Ferryville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 924,
    density: 4.8,
    county_fips: 55023,
    county_name: "Crawford",
    county_weights: {
      55023: 91.49,
      55123: 8.51,
    },
    county_names_all: "Crawford|Vernon",
    county_fips_all: "55023|55123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54629,
    lat: 44.15928,
    lng: -91.66661,
    city: "Fountain City",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2643,
    density: 9.1,
    county_fips: 55011,
    county_name: "Buffalo",
    county_weights: {
      55011: 100,
    },
    county_names_all: "Buffalo",
    county_fips_all: 55011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54630,
    lat: 44.10339,
    lng: -91.35881,
    city: "Galesville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4106,
    density: 19.5,
    county_fips: 55121,
    county_name: "Trempealeau",
    county_weights: {
      55121: 100,
    },
    county_names_all: "Trempealeau",
    county_fips_all: 55121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54631,
    lat: 43.28795,
    lng: -90.8327,
    city: "Gays Mills",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1668,
    density: 6.2,
    county_fips: 55023,
    county_name: "Crawford",
    county_weights: {
      55023: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 55023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54632,
    lat: 43.56249,
    lng: -91.14695,
    city: "Genoa",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1210,
    density: 10,
    county_fips: 55123,
    county_name: "Vernon",
    county_weights: {
      55123: 100,
    },
    county_names_all: "Vernon",
    county_fips_all: 55123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54634,
    lat: 43.59753,
    lng: -90.42553,
    city: "Hillsboro",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4463,
    density: 12.3,
    county_fips: 55123,
    county_name: "Vernon",
    county_weights: {
      55057: 0.62,
      55103: 29.97,
      55123: 69.41,
    },
    county_names_all: "Vernon|Richland|Juneau",
    county_fips_all: "55123|55103|55057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54635,
    lat: 44.40871,
    lng: -91.04455,
    city: "Hixton",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1787,
    density: 8.6,
    county_fips: 55053,
    county_name: "Jackson",
    county_weights: {
      55053: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 55053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54636,
    lat: 44.00732,
    lng: -91.22682,
    city: "Holmen",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14838,
    density: 69,
    county_fips: 55063,
    county_name: "La Crosse",
    county_weights: {
      55063: 100,
    },
    county_names_all: "La Crosse",
    county_fips_all: 55063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54637,
    lat: 43.87874,
    lng: -90.27076,
    city: "Hustler",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 207,
    density: 232.3,
    county_fips: 55057,
    county_name: "Juneau",
    county_weights: {
      55057: 100,
    },
    county_names_all: "Juneau",
    county_fips_all: 55057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54638,
    lat: 43.79088,
    lng: -90.3875,
    city: "Kendall",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1614,
    density: 10.2,
    county_fips: 55081,
    county_name: "Monroe",
    county_weights: {
      55057: 2.75,
      55081: 83.99,
      55123: 13.26,
    },
    county_names_all: "Monroe|Vernon|Juneau",
    county_fips_all: "55081|55123|55057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54639,
    lat: 43.60566,
    lng: -90.62021,
    city: "La Farge",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2713,
    density: 11.7,
    county_fips: 55123,
    county_name: "Vernon",
    county_weights: {
      55103: 4.07,
      55123: 95.93,
    },
    county_names_all: "Vernon|Richland",
    county_fips_all: "55123|55103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54642,
    lat: 44.14978,
    lng: -91.05303,
    city: "Melrose",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2162,
    density: 9.1,
    county_fips: 55053,
    county_name: "Jackson",
    county_weights: {
      55053: 92.83,
      55063: 2.86,
      55121: 4.31,
    },
    county_names_all: "Jackson|Trempealeau|La Crosse",
    county_fips_all: "55053|55121|55063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54643,
    lat: 44.18758,
    lng: -90.63432,
    city: "Millston",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2,
    density: 2.5,
    county_fips: 55053,
    county_name: "Jackson",
    county_weights: {
      55053: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 55053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54644,
    lat: 44.03089,
    lng: -91.04326,
    city: "Mindoro",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1420,
    density: 9,
    county_fips: 55063,
    county_name: "La Crosse",
    county_weights: {
      55053: 6.99,
      55063: 93.01,
    },
    county_names_all: "La Crosse|Jackson",
    county_fips_all: "55063|55053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54645,
    lat: 43.32084,
    lng: -90.92901,
    city: "Mount Sterling",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56,
    density: 31.2,
    county_fips: 55023,
    county_name: "Crawford",
    county_weights: {
      55023: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 55023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54646,
    lat: 44.08807,
    lng: -90.0912,
    city: "Necedah",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4070,
    density: 9.5,
    county_fips: 55057,
    county_name: "Juneau",
    county_weights: {
      55057: 100,
    },
    county_names_all: "Juneau",
    county_fips_all: 55057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54648,
    lat: 43.83544,
    lng: -90.63553,
    city: "Norwalk",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1703,
    density: 8.9,
    county_fips: 55081,
    county_name: "Monroe",
    county_weights: {
      55081: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 55081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54650,
    lat: 43.9099,
    lng: -91.22424,
    city: "Onalaska",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24794,
    density: 309.7,
    county_fips: 55063,
    county_name: "La Crosse",
    county_weights: {
      55063: 100,
    },
    county_names_all: "La Crosse",
    county_fips_all: 55063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54651,
    lat: 43.72368,
    lng: -90.57004,
    city: "Ontario",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1613,
    density: 10.5,
    county_fips: 55123,
    county_name: "Vernon",
    county_weights: {
      55081: 42.98,
      55123: 57.02,
    },
    county_names_all: "Vernon|Monroe",
    county_fips_all: "55123|55081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54652,
    lat: 43.46133,
    lng: -90.76825,
    city: "Readstown",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1095,
    density: 12.7,
    county_fips: 55123,
    county_name: "Vernon",
    county_weights: {
      55123: 100,
    },
    county_names_all: "Vernon",
    county_fips_all: 55123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54653,
    lat: 43.82586,
    lng: -90.9129,
    city: "Rockland",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 910,
    density: 16.3,
    county_fips: 55063,
    county_name: "La Crosse",
    county_weights: {
      55063: 60.9,
      55081: 39.1,
    },
    county_names_all: "La Crosse|Monroe",
    county_fips_all: "55063|55081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54654,
    lat: 43.26853,
    lng: -90.95419,
    city: "Seneca",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 291,
    density: 306.3,
    county_fips: 55023,
    county_name: "Crawford",
    county_weights: {
      55023: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 55023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54655,
    lat: 43.37877,
    lng: -90.76423,
    city: "Soldiers Grove",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1802,
    density: 7.7,
    county_fips: 55023,
    county_name: "Crawford",
    county_weights: {
      55023: 82.2,
      55103: 15.52,
      55123: 2.28,
    },
    county_names_all: "Crawford|Richland|Vernon",
    county_fips_all: "55023|55103|55123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54656,
    lat: 44.00291,
    lng: -90.79601,
    city: "Sparta",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18096,
    density: 24.8,
    county_fips: 55081,
    county_name: "Monroe",
    county_weights: {
      55063: 0.11,
      55081: 99.89,
    },
    county_names_all: "Monroe|La Crosse",
    county_fips_all: "55081|55063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54657,
    lat: 43.19447,
    lng: -90.90678,
    city: "Steuben",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 368,
    density: 4.9,
    county_fips: 55023,
    county_name: "Crawford",
    county_weights: {
      55023: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 55023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54658,
    lat: 43.67768,
    lng: -91.19248,
    city: "Stoddard",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2586,
    density: 28.1,
    county_fips: 55123,
    county_name: "Vernon",
    county_weights: {
      55063: 6.22,
      55123: 93.78,
    },
    county_names_all: "Vernon|La Crosse",
    county_fips_all: "55123|55063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54659,
    lat: 44.29704,
    lng: -91.10065,
    city: "Taylor",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1307,
    density: 8.6,
    county_fips: 55053,
    county_name: "Jackson",
    county_weights: {
      55053: 97.55,
      55121: 2.45,
    },
    county_names_all: "Jackson|Trempealeau",
    county_fips_all: "55053|55121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54660,
    lat: 43.98525,
    lng: -90.50496,
    city: "Tomah",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15822,
    density: 35.3,
    county_fips: 55081,
    county_name: "Monroe",
    county_weights: {
      55081: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 55081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54661,
    lat: 44.05943,
    lng: -91.47133,
    city: "Trempealeau",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3913,
    density: 29.2,
    county_fips: 55121,
    county_name: "Trempealeau",
    county_weights: {
      55063: 0.24,
      55121: 99.76,
    },
    county_names_all: "Trempealeau|La Crosse",
    county_fips_all: "55121|55063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54664,
    lat: 43.49912,
    lng: -90.64076,
    city: "Viola",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1770,
    density: 8.3,
    county_fips: 55103,
    county_name: "Richland",
    county_weights: {
      55103: 65.09,
      55123: 34.91,
    },
    county_names_all: "Richland|Vernon",
    county_fips_all: "55103|55123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54665,
    lat: 43.5319,
    lng: -90.92134,
    city: "Viroqua",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8476,
    density: 18.1,
    county_fips: 55123,
    county_name: "Vernon",
    county_weights: {
      55023: 0.98,
      55123: 99.02,
    },
    county_names_all: "Vernon|Crawford",
    county_fips_all: "55123|55023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54666,
    lat: 44.16201,
    lng: -90.4399,
    city: "Warrens",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2915,
    density: 4.8,
    county_fips: 55081,
    county_name: "Monroe",
    county_weights: {
      55053: 43.99,
      55057: 10.97,
      55081: 45.04,
    },
    county_names_all: "Monroe|Jackson|Juneau",
    county_fips_all: "55081|55053|55057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54667,
    lat: 43.66703,
    lng: -90.86166,
    city: "Westby",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4885,
    density: 21.2,
    county_fips: 55123,
    county_name: "Vernon",
    county_weights: {
      55063: 3.34,
      55123: 96.66,
    },
    county_names_all: "Vernon|La Crosse",
    county_fips_all: "55123|55063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54669,
    lat: 43.91171,
    lng: -91.09046,
    city: "West Salem",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7825,
    density: 58.5,
    county_fips: 55063,
    county_name: "La Crosse",
    county_weights: {
      55063: 100,
    },
    county_names_all: "La Crosse",
    county_fips_all: 55063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54670,
    lat: 43.83802,
    lng: -90.48273,
    city: "Wilton",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1788,
    density: 13.1,
    county_fips: 55081,
    county_name: "Monroe",
    county_weights: {
      55081: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 55081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54701,
    lat: 44.7432,
    lng: -91.50899,
    city: "Eau Claire",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41358,
    density: 185.6,
    county_fips: 55035,
    county_name: "Eau Claire",
    county_weights: {
      55033: 4.84,
      55035: 95.16,
    },
    county_names_all: "Eau Claire|Dunn",
    county_fips_all: "55035|55033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54703,
    lat: 44.83311,
    lng: -91.5185,
    city: "Eau Claire",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43089,
    density: 205.2,
    county_fips: 55035,
    county_name: "Eau Claire",
    county_weights: {
      55017: 20.37,
      55033: 1.66,
      55035: 77.97,
    },
    county_names_all: "Eau Claire|Chippewa|Dunn",
    county_fips_all: "55035|55017|55033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54720,
    lat: 44.80511,
    lng: -91.43646,
    city: "Altoona",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7857,
    density: 638.9,
    county_fips: 55035,
    county_name: "Eau Claire",
    county_weights: {
      55035: 100,
    },
    county_names_all: "Eau Claire",
    county_fips_all: 55035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54721,
    lat: 44.6304,
    lng: -92.07098,
    city: "Arkansaw",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1425,
    density: 8.4,
    county_fips: 55091,
    county_name: "Pepin",
    county_weights: {
      55033: 11.88,
      55091: 85.88,
      55093: 2.24,
    },
    county_names_all: "Pepin|Dunn|Pierce",
    county_fips_all: "55091|55033|55093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54722,
    lat: 44.71702,
    lng: -91.09874,
    city: "Augusta",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3859,
    density: 10,
    county_fips: 55035,
    county_name: "Eau Claire",
    county_weights: {
      55035: 100,
    },
    county_names_all: "Eau Claire",
    county_fips_all: 55035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54723,
    lat: 44.61063,
    lng: -92.42893,
    city: "Bay City",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1049,
    density: 12.4,
    county_fips: 55093,
    county_name: "Pierce",
    county_weights: {
      55093: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 55093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54724,
    lat: 45.10793,
    lng: -91.48458,
    city: "Bloomer",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7188,
    density: 17.1,
    county_fips: 55017,
    county_name: "Chippewa",
    county_weights: {
      55017: 99.43,
      55033: 0.57,
    },
    county_names_all: "Chippewa|Dunn",
    county_fips_all: "55017|55033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54725,
    lat: 45.07103,
    lng: -92.01062,
    city: "Boyceville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2900,
    density: 11.4,
    county_fips: 55033,
    county_name: "Dunn",
    county_weights: {
      55033: 100,
    },
    county_names_all: "Dunn",
    county_fips_all: 55033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54726,
    lat: 44.94151,
    lng: -91.01975,
    city: "Boyd",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1854,
    density: 8.8,
    county_fips: 55017,
    county_name: "Chippewa",
    county_weights: {
      55017: 72.15,
      55035: 27.85,
    },
    county_names_all: "Chippewa|Eau Claire",
    county_fips_all: "55017|55035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54727,
    lat: 44.95827,
    lng: -91.15873,
    city: "Cadott",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4513,
    density: 12.2,
    county_fips: 55017,
    county_name: "Chippewa",
    county_weights: {
      55017: 94.5,
      55035: 5.5,
    },
    county_names_all: "Chippewa|Eau Claire",
    county_fips_all: "55017|55035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54728,
    lat: 45.30778,
    lng: -91.6417,
    city: "Chetek",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5997,
    density: 18.4,
    county_fips: 55005,
    county_name: "Barron",
    county_weights: {
      55005: 79.95,
      55033: 0.77,
      55107: 19.28,
    },
    county_names_all: "Barron|Rusk|Dunn",
    county_fips_all: "55005|55107|55033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54729,
    lat: 44.94533,
    lng: -91.39342,
    city: "Chippewa Falls",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32927,
    density: 77,
    county_fips: 55017,
    county_name: "Chippewa",
    county_weights: {
      55017: 97.14,
      55035: 2.86,
    },
    county_names_all: "Chippewa|Eau Claire",
    county_fips_all: "55017|55035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54730,
    lat: 45.01836,
    lng: -91.72143,
    city: "Colfax",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5188,
    density: 14.5,
    county_fips: 55033,
    county_name: "Dunn",
    county_weights: {
      55017: 21.72,
      55033: 78.28,
    },
    county_names_all: "Dunn|Chippewa",
    county_fips_all: "55033|55017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54731,
    lat: 45.34656,
    lng: -91.08304,
    city: "Conrath",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 723,
    density: 6,
    county_fips: 55107,
    county_name: "Rusk",
    county_weights: {
      55107: 100,
    },
    county_names_all: "Rusk",
    county_fips_all: 55107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54732,
    lat: 45.14571,
    lng: -91.16543,
    city: "Cornell",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3199,
    density: 12.7,
    county_fips: 55017,
    county_name: "Chippewa",
    county_weights: {
      55017: 100,
    },
    county_names_all: "Chippewa",
    county_fips_all: 55017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54733,
    lat: 45.28331,
    lng: -91.85641,
    city: "Dallas",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1216,
    density: 10.5,
    county_fips: 55005,
    county_name: "Barron",
    county_weights: {
      55005: 100,
    },
    county_names_all: "Barron",
    county_fips_all: 55005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54734,
    lat: 45.09045,
    lng: -92.11358,
    city: "Downing",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 720,
    density: 8.9,
    county_fips: 55033,
    county_name: "Dunn",
    county_weights: {
      55033: 94,
      55109: 6,
    },
    county_names_all: "Dunn|St. Croix",
    county_fips_all: "55033|55109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54736,
    lat: 44.60345,
    lng: -91.90455,
    city: "Durand",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4193,
    density: 12.6,
    county_fips: 55091,
    county_name: "Pepin",
    county_weights: {
      55011: 44.79,
      55033: 4.91,
      55091: 50.3,
    },
    county_names_all: "Pepin|Buffalo|Dunn",
    county_fips_all: "55091|55011|55033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54737,
    lat: 44.71593,
    lng: -91.98298,
    city: "Eau Galle",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 679,
    density: 12.4,
    county_fips: 55033,
    county_name: "Dunn",
    county_weights: {
      55033: 94.83,
      55091: 5.17,
    },
    county_names_all: "Dunn|Pepin",
    county_fips_all: "55033|55091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54738,
    lat: 44.59478,
    lng: -91.47892,
    city: "Eleva",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3491,
    density: 13.7,
    county_fips: 55035,
    county_name: "Eau Claire",
    county_weights: {
      55011: 1.08,
      55035: 53.46,
      55121: 45.46,
    },
    county_names_all: "Eau Claire|Trempealeau|Buffalo",
    county_fips_all: "55035|55121|55011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54739,
    lat: 44.86177,
    lng: -91.70097,
    city: "Elk Mound",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5429,
    density: 20.4,
    county_fips: 55033,
    county_name: "Dunn",
    county_weights: {
      55017: 18,
      55033: 81.86,
      55035: 0.14,
    },
    county_names_all: "Dunn|Chippewa|Eau Claire",
    county_fips_all: "55033|55017|55035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54740,
    lat: 44.74427,
    lng: -92.15853,
    city: "Elmwood",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1964,
    density: 9.1,
    county_fips: 55093,
    county_name: "Pierce",
    county_weights: {
      55033: 42.39,
      55093: 57.61,
    },
    county_names_all: "Pierce|Dunn",
    county_fips_all: "55093|55033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54741,
    lat: 44.61237,
    lng: -90.98121,
    city: "Fairchild",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1901,
    density: 7.6,
    county_fips: 55035,
    county_name: "Eau Claire",
    county_weights: {
      55019: 12.85,
      55035: 47.93,
      55053: 39.22,
    },
    county_names_all: "Eau Claire|Jackson|Clark",
    county_fips_all: "55035|55053|55019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54742,
    lat: 44.76319,
    lng: -91.2722,
    city: "Fall Creek",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5347,
    density: 19.1,
    county_fips: 55035,
    county_name: "Eau Claire",
    county_weights: {
      55035: 100,
    },
    county_names_all: "Eau Claire",
    county_fips_all: 55035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54745,
    lat: 45.24875,
    lng: -91.13494,
    city: "Holcombe",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2114,
    density: 6.3,
    county_fips: 55017,
    county_name: "Chippewa",
    county_weights: {
      55017: 85.17,
      55107: 14.83,
    },
    county_names_all: "Chippewa|Rusk",
    county_fips_all: "55017|55107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54746,
    lat: 44.54543,
    lng: -90.87217,
    city: "Humbird",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 710,
    density: 6.2,
    county_fips: 55019,
    county_name: "Clark",
    county_weights: {
      55019: 82.79,
      55053: 17.21,
    },
    county_names_all: "Clark|Jackson",
    county_fips_all: "55019|55053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54747,
    lat: 44.39438,
    lng: -91.5035,
    city: "Independence",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2299,
    density: 7.5,
    county_fips: 55121,
    county_name: "Trempealeau",
    county_weights: {
      55011: 36.76,
      55121: 63.24,
    },
    county_names_all: "Trempealeau|Buffalo",
    county_fips_all: "55121|55011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54748,
    lat: 45.07919,
    lng: -91.26586,
    city: "Jim Falls",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1234,
    density: 11.9,
    county_fips: 55017,
    county_name: "Chippewa",
    county_weights: {
      55017: 100,
    },
    county_names_all: "Chippewa",
    county_fips_all: 55017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54749,
    lat: 44.94862,
    lng: -92.09785,
    city: "Knapp",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1552,
    density: 15,
    county_fips: 55033,
    county_name: "Dunn",
    county_weights: {
      55033: 83.85,
      55109: 16.15,
    },
    county_names_all: "Dunn|St. Croix",
    county_fips_all: "55033|55109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54750,
    lat: 44.62052,
    lng: -92.29513,
    city: "Maiden Rock",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 936,
    density: 5.5,
    county_fips: 55093,
    county_name: "Pierce",
    county_weights: {
      55093: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 55093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54751,
    lat: 44.84971,
    lng: -91.92994,
    city: "Menomonie",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25931,
    density: 43.9,
    county_fips: 55033,
    county_name: "Dunn",
    county_weights: {
      55033: 100,
    },
    county_names_all: "Dunn",
    county_fips_all: 55033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54754,
    lat: 44.42913,
    lng: -90.77527,
    city: "Merrillan",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1769,
    density: 9.1,
    county_fips: 55053,
    county_name: "Jackson",
    county_weights: {
      55019: 17.85,
      55053: 82.15,
    },
    county_names_all: "Jackson|Clark",
    county_fips_all: "55053|55019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54755,
    lat: 44.57513,
    lng: -91.67971,
    city: "Mondovi",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7073,
    density: 10.5,
    county_fips: 55011,
    county_name: "Buffalo",
    county_weights: {
      55011: 60,
      55033: 14.57,
      55035: 12.03,
      55091: 13.4,
    },
    county_names_all: "Buffalo|Dunn|Pepin|Eau Claire",
    county_fips_all: "55011|55033|55091|55035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54756,
    lat: 44.46153,
    lng: -91.94552,
    city: "Nelson",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 891,
    density: 4.4,
    county_fips: 55011,
    county_name: "Buffalo",
    county_weights: {
      55011: 100,
    },
    county_names_all: "Buffalo",
    county_fips_all: 55011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54757,
    lat: 45.23085,
    lng: -91.52498,
    city: "New Auburn",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3463,
    density: 8.6,
    county_fips: 55017,
    county_name: "Chippewa",
    county_weights: {
      55005: 18.79,
      55017: 56.89,
      55033: 15.62,
      55107: 8.7,
    },
    county_names_all: "Chippewa|Barron|Dunn|Rusk",
    county_fips_all: "55017|55005|55033|55107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54758,
    lat: 44.54546,
    lng: -91.2173,
    city: "Osseo",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4779,
    density: 11.8,
    county_fips: 55121,
    county_name: "Trempealeau",
    county_weights: {
      55035: 22.66,
      55053: 24.54,
      55121: 52.8,
    },
    county_names_all: "Trempealeau|Jackson|Eau Claire",
    county_fips_all: "55121|55053|55035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54759,
    lat: 44.48936,
    lng: -92.1232,
    city: "Pepin",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1437,
    density: 10.9,
    county_fips: 55091,
    county_name: "Pepin",
    county_weights: {
      55091: 100,
    },
    county_names_all: "Pepin",
    county_fips_all: 55091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54760,
    lat: 44.42412,
    lng: -91.20626,
    city: "Pigeon Falls",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 235,
    density: 595.5,
    county_fips: 55121,
    county_name: "Trempealeau",
    county_weights: {
      55121: 100,
    },
    county_names_all: "Trempealeau",
    county_fips_all: 55121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54761,
    lat: 44.62667,
    lng: -92.17908,
    city: "Plum City",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1307,
    density: 12.5,
    county_fips: 55093,
    county_name: "Pierce",
    county_weights: {
      55093: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 55093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54762,
    lat: 45.25107,
    lng: -91.98967,
    city: "Prairie Farm",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1235,
    density: 9,
    county_fips: 55005,
    county_name: "Barron",
    county_weights: {
      55005: 86.91,
      55033: 13.09,
    },
    county_names_all: "Barron|Dunn",
    county_fips_all: "55005|55033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54763,
    lat: 45.179,
    lng: -91.87683,
    city: "Ridgeland",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1082,
    density: 6.9,
    county_fips: 55033,
    county_name: "Dunn",
    county_weights: {
      55005: 16.54,
      55033: 83.46,
    },
    county_names_all: "Dunn|Barron",
    county_fips_all: "55033|55005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54766,
    lat: 45.33667,
    lng: -90.86566,
    city: "Sheldon",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1878,
    density: 5.6,
    county_fips: 55119,
    county_name: "Taylor",
    county_weights: {
      55017: 10.3,
      55107: 38.04,
      55119: 51.66,
    },
    county_names_all: "Taylor|Rusk|Chippewa",
    county_fips_all: "55119|55107|55017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54767,
    lat: 44.82645,
    lng: -92.25513,
    city: "Spring Valley",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3484,
    density: 16.1,
    county_fips: 55093,
    county_name: "Pierce",
    county_weights: {
      55033: 5.39,
      55093: 81.97,
      55109: 12.64,
    },
    county_names_all: "Pierce|St. Croix|Dunn",
    county_fips_all: "55093|55109|55033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54768,
    lat: 44.96312,
    lng: -90.92761,
    city: "Stanley",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6450,
    density: 18.5,
    county_fips: 55017,
    county_name: "Chippewa",
    county_weights: {
      55017: 45.47,
      55019: 32.4,
      55035: 9.43,
      55119: 12.7,
    },
    county_names_all: "Chippewa|Clark|Taylor|Eau Claire",
    county_fips_all: "55017|55019|55119|55035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54769,
    lat: 44.50897,
    lng: -92.23304,
    city: "Stockholm",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 539,
    density: 6.4,
    county_fips: 55091,
    county_name: "Pepin",
    county_weights: {
      55091: 79.65,
      55093: 20.35,
    },
    county_names_all: "Pepin|Pierce",
    county_fips_all: "55091|55093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54770,
    lat: 44.55121,
    lng: -91.37259,
    city: "Strum",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2145,
    density: 12.8,
    county_fips: 55121,
    county_name: "Trempealeau",
    county_weights: {
      55035: 26.5,
      55121: 73.5,
    },
    county_names_all: "Trempealeau|Eau Claire",
    county_fips_all: "55121|55035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54771,
    lat: 44.92356,
    lng: -90.80579,
    city: "Thorp",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4303,
    density: 11.1,
    county_fips: 55019,
    county_name: "Clark",
    county_weights: {
      55019: 88.19,
      55119: 11.81,
    },
    county_names_all: "Clark|Taylor",
    county_fips_all: "55019|55119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54772,
    lat: 45.09668,
    lng: -91.87303,
    city: "Wheeler",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1022,
    density: 6.7,
    county_fips: 55033,
    county_name: "Dunn",
    county_weights: {
      55033: 100,
    },
    county_names_all: "Dunn",
    county_fips_all: 55033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54773,
    lat: 44.39301,
    lng: -91.3002,
    city: "Whitehall",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3483,
    density: 19.2,
    county_fips: 55121,
    county_name: "Trempealeau",
    county_weights: {
      55121: 100,
    },
    county_names_all: "Trempealeau",
    county_fips_all: 55121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54801,
    lat: 45.86711,
    lng: -91.92266,
    city: "Spooner",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6527,
    density: 12.8,
    county_fips: 55129,
    county_name: "Washburn",
    county_weights: {
      55013: 21.81,
      55129: 78.19,
    },
    county_names_all: "Washburn|Burnett",
    county_fips_all: "55129|55013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54805,
    lat: 45.41465,
    lng: -92.02311,
    city: "Almena",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1534,
    density: 19,
    county_fips: 55005,
    county_name: "Barron",
    county_weights: {
      55005: 100,
    },
    county_names_all: "Barron",
    county_fips_all: 55005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54806,
    lat: 46.54784,
    lng: -90.85061,
    city: "Ashland",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11210,
    density: 15,
    county_fips: 55003,
    county_name: "Ashland",
    county_weights: {
      55003: 66.88,
      55007: 33.12,
    },
    county_names_all: "Ashland|Bayfield",
    county_fips_all: "55003|55007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54810,
    lat: 45.46126,
    lng: -92.38403,
    city: "Balsam Lake",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2625,
    density: 21.8,
    county_fips: 55095,
    county_name: "Polk",
    county_weights: {
      55095: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 55095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54812,
    lat: 45.39911,
    lng: -91.88103,
    city: "Barron",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5554,
    density: 23.8,
    county_fips: 55005,
    county_name: "Barron",
    county_weights: {
      55005: 100,
    },
    county_names_all: "Barron",
    county_fips_all: 55005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54813,
    lat: 45.65477,
    lng: -92.03071,
    city: "Barronett",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 659,
    density: 4.6,
    county_fips: 55013,
    county_name: "Burnett",
    county_weights: {
      55005: 32.21,
      55013: 51.43,
      55129: 16.36,
    },
    county_names_all: "Burnett|Barron|Washburn",
    county_fips_all: "55013|55005|55129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54814,
    lat: 46.85672,
    lng: -90.91876,
    city: "Bayfield",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2728,
    density: 6.9,
    county_fips: 55007,
    county_name: "Bayfield",
    county_weights: {
      55007: 100,
    },
    county_names_all: "Bayfield",
    county_fips_all: 55007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54817,
    lat: 45.67056,
    lng: -91.53942,
    city: "Birchwood",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1889,
    density: 4.6,
    county_fips: 55129,
    county_name: "Washburn",
    county_weights: {
      55005: 13.83,
      55107: 18.24,
      55113: 32.84,
      55129: 35.1,
    },
    county_names_all: "Washburn|Sawyer|Rusk|Barron",
    county_fips_all: "55129|55113|55107|55005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54819,
    lat: 45.47636,
    lng: -91.30307,
    city: "Bruce",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2321,
    density: 5.9,
    county_fips: 55107,
    county_name: "Rusk",
    county_weights: {
      55107: 100,
    },
    county_names_all: "Rusk",
    county_fips_all: 55107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54820,
    lat: 46.56024,
    lng: -91.55475,
    city: "Brule",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 941,
    density: 3.1,
    county_fips: 55031,
    county_name: "Douglas",
    county_weights: {
      55007: 47.66,
      55031: 52.34,
    },
    county_names_all: "Douglas|Bayfield",
    county_fips_all: "55031|55007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54821,
    lat: 46.22428,
    lng: -91.16508,
    city: "Cable",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1133,
    density: 2.3,
    county_fips: 55007,
    county_name: "Bayfield",
    county_weights: {
      55007: 97.89,
      55113: 2.11,
    },
    county_names_all: "Bayfield|Sawyer",
    county_fips_all: "55007|55113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54822,
    lat: 45.3944,
    lng: -91.69995,
    city: "Cameron",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4602,
    density: 38.9,
    county_fips: 55005,
    county_name: "Barron",
    county_weights: {
      55005: 100,
    },
    county_names_all: "Barron",
    county_fips_all: 55005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54824,
    lat: 45.4753,
    lng: -92.54017,
    city: "Centuria",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2326,
    density: 23.1,
    county_fips: 55095,
    county_name: "Polk",
    county_weights: {
      55095: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 55095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54826,
    lat: 45.49971,
    lng: -92.16422,
    city: "Comstock",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 675,
    density: 5.6,
    county_fips: 55095,
    county_name: "Polk",
    county_weights: {
      55005: 45.01,
      55095: 54.99,
    },
    county_names_all: "Polk|Barron",
    county_fips_all: "55095|55005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54827,
    lat: 46.80215,
    lng: -91.10069,
    city: "Cornucopia",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 315,
    density: 3.4,
    county_fips: 55007,
    county_name: "Bayfield",
    county_weights: {
      55007: 100,
    },
    county_names_all: "Bayfield",
    county_fips_all: 55007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54828,
    lat: 45.84201,
    lng: -91.2934,
    city: "Couderay",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 838,
    density: 4.7,
    county_fips: 55113,
    county_name: "Sawyer",
    county_weights: {
      55113: 100,
    },
    county_names_all: "Sawyer",
    county_fips_all: 55113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54829,
    lat: 45.5592,
    lng: -92.06603,
    city: "Cumberland",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5280,
    density: 14.2,
    county_fips: 55005,
    county_name: "Barron",
    county_weights: {
      55005: 75.31,
      55095: 24.69,
    },
    county_names_all: "Barron|Polk",
    county_fips_all: "55005|55095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54830,
    lat: 46.10571,
    lng: -92.22305,
    city: "Danbury",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2771,
    density: 3,
    county_fips: 55013,
    county_name: "Burnett",
    county_weights: {
      55013: 63.81,
      55031: 36.04,
      55129: 0.15,
    },
    county_names_all: "Burnett|Douglas|Washburn",
    county_fips_all: "55013|55031|55129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54832,
    lat: 46.32661,
    lng: -91.33073,
    city: "Drummond",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 367,
    density: 1.4,
    county_fips: 55007,
    county_name: "Bayfield",
    county_weights: {
      55007: 100,
    },
    county_names_all: "Bayfield",
    county_fips_all: 55007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54835,
    lat: 45.67974,
    lng: -91.2522,
    city: "Exeland",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 950,
    density: 2.5,
    county_fips: 55113,
    county_name: "Sawyer",
    county_weights: {
      55107: 17.68,
      55113: 82.32,
    },
    county_names_all: "Sawyer|Rusk",
    county_fips_all: "55113|55107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54836,
    lat: 46.43238,
    lng: -92.19225,
    city: "Foxboro",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1042,
    density: 2.9,
    county_fips: 55031,
    county_name: "Douglas",
    county_weights: {
      55031: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 55031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54837,
    lat: 45.6746,
    lng: -92.35754,
    city: "Frederic",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3622,
    density: 8.2,
    county_fips: 55095,
    county_name: "Polk",
    county_weights: {
      55013: 18.26,
      55095: 81.74,
    },
    county_names_all: "Polk|Burnett",
    county_fips_all: "55095|55013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54838,
    lat: 46.24836,
    lng: -91.79179,
    city: "Gordon",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1090,
    density: 1.7,
    county_fips: 55031,
    county_name: "Douglas",
    county_weights: {
      55007: 2.02,
      55031: 97.98,
    },
    county_names_all: "Douglas|Bayfield",
    county_fips_all: "55031|55007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54839,
    lat: 46.35683,
    lng: -91.14689,
    city: "Grand View",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 263,
    density: 2.4,
    county_fips: 55007,
    county_name: "Bayfield",
    county_weights: {
      55007: 100,
    },
    county_names_all: "Bayfield",
    county_fips_all: 55007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54840,
    lat: 45.7556,
    lng: -92.68928,
    city: "Grantsburg",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4360,
    density: 6.6,
    county_fips: 55013,
    county_name: "Burnett",
    county_weights: {
      55013: 88.31,
      55095: 11.69,
    },
    county_names_all: "Burnett|Polk",
    county_fips_all: "55013|55095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54841,
    lat: 45.60776,
    lng: -91.77887,
    city: "Haugen",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 250,
    density: 193.4,
    county_fips: 55005,
    county_name: "Barron",
    county_weights: {
      55005: 100,
    },
    county_names_all: "Barron",
    county_fips_all: 55005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54842,
    lat: 46.49891,
    lng: -91.86234,
    city: "Hawthorne",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 261,
    density: 20.6,
    county_fips: 55031,
    county_name: "Douglas",
    county_weights: {
      55031: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 55031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54843,
    lat: 46.0251,
    lng: -91.29494,
    city: "Hayward",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11514,
    density: 10.1,
    county_fips: 55113,
    county_name: "Sawyer",
    county_weights: {
      55113: 92.83,
      55129: 7.17,
    },
    county_names_all: "Sawyer|Washburn",
    county_fips_all: "55113|55129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54844,
    lat: 46.78649,
    lng: -91.21441,
    city: "Herbster",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 227,
    density: 1.3,
    county_fips: 55007,
    county_name: "Bayfield",
    county_weights: {
      55007: 100,
    },
    county_names_all: "Bayfield",
    county_fips_all: 55007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54845,
    lat: 45.80724,
    lng: -92.13786,
    city: "Hertel",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 111,
    density: 8.2,
    county_fips: 55013,
    county_name: "Burnett",
    county_weights: {
      55013: 100,
    },
    county_names_all: "Burnett",
    county_fips_all: 55013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54846,
    lat: 46.37737,
    lng: -90.72481,
    city: "High Bridge",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 675,
    density: 8,
    county_fips: 55003,
    county_name: "Ashland",
    county_weights: {
      55003: 100,
    },
    county_names_all: "Ashland",
    county_fips_all: 55003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54847,
    lat: 46.57047,
    lng: -91.40055,
    city: "Iron River",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2328,
    density: 4.7,
    county_fips: 55007,
    county_name: "Bayfield",
    county_weights: {
      55007: 100,
    },
    county_names_all: "Bayfield",
    county_fips_all: 55007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54848,
    lat: 45.51546,
    lng: -91.10284,
    city: "Ladysmith",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5776,
    density: 11.7,
    county_fips: 55107,
    county_name: "Rusk",
    county_weights: {
      55107: 100,
    },
    county_names_all: "Rusk",
    county_fips_all: 55107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54849,
    lat: 46.47881,
    lng: -91.71642,
    city: "Lake Nebagamon",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1702,
    density: 7.6,
    county_fips: 55031,
    county_name: "Douglas",
    county_weights: {
      55031: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 55031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54850,
    lat: 46.92255,
    lng: -90.62389,
    city: "La Pointe",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 239,
    density: 1.2,
    county_fips: 55003,
    county_name: "Ashland",
    county_weights: {
      55003: 100,
    },
    county_names_all: "Ashland",
    county_fips_all: 55003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54853,
    lat: 45.57106,
    lng: -92.45211,
    city: "Luck",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4006,
    density: 17.6,
    county_fips: 55095,
    county_name: "Polk",
    county_weights: {
      55013: 4,
      55095: 96,
    },
    county_names_all: "Polk|Burnett",
    county_fips_all: "55095|55013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54854,
    lat: 46.64127,
    lng: -91.66864,
    city: "Maple",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 905,
    density: 4.2,
    county_fips: 55031,
    county_name: "Douglas",
    county_weights: {
      55031: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 55031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54855,
    lat: 46.37492,
    lng: -90.84397,
    city: "Marengo",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 933,
    density: 5.1,
    county_fips: 55003,
    county_name: "Ashland",
    county_weights: {
      55003: 100,
    },
    county_names_all: "Ashland",
    county_fips_all: 55003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54856,
    lat: 46.43401,
    lng: -91.10279,
    city: "Mason",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1671,
    density: 3.1,
    county_fips: 55007,
    county_name: "Bayfield",
    county_weights: {
      55003: 1.52,
      55007: 98.48,
    },
    county_names_all: "Bayfield|Ashland",
    county_fips_all: "55007|55003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54857,
    lat: 45.59347,
    lng: -91.59927,
    city: "Mikana",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 55005,
    county_name: "Barron",
    county_weights: {
      55005: 100,
    },
    county_names_all: "Barron",
    county_fips_all: 55005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54858,
    lat: 45.51824,
    lng: -92.46031,
    city: "Milltown",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1685,
    density: 37,
    county_fips: 55095,
    county_name: "Polk",
    county_weights: {
      55095: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 55095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54859,
    lat: 46.12121,
    lng: -91.82337,
    city: "Minong",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1803,
    density: 3.9,
    county_fips: 55129,
    county_name: "Washburn",
    county_weights: {
      55013: 3.16,
      55031: 16,
      55129: 80.84,
    },
    county_names_all: "Washburn|Douglas|Burnett",
    county_fips_all: "55129|55031|55013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54861,
    lat: 46.59896,
    lng: -90.64345,
    city: "Odanah",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 143,
    density: 42.2,
    county_fips: 55003,
    county_name: "Ashland",
    county_weights: {
      55003: 100,
    },
    county_names_all: "Ashland",
    county_fips_all: 55003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54862,
    lat: 45.80385,
    lng: -91.12132,
    city: "Ojibwa",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 289,
    density: 2,
    county_fips: 55113,
    county_name: "Sawyer",
    county_weights: {
      55113: 100,
    },
    county_names_all: "Sawyer",
    county_fips_all: 55113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54864,
    lat: 46.60431,
    lng: -91.79443,
    city: "Poplar",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1376,
    density: 10.3,
    county_fips: 55031,
    county_name: "Douglas",
    county_weights: {
      55031: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 55031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54865,
    lat: 46.74787,
    lng: -91.37517,
    city: "Port Wing",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 489,
    density: 2.9,
    county_fips: 55007,
    county_name: "Bayfield",
    county_weights: {
      55007: 100,
    },
    county_names_all: "Bayfield",
    county_fips_all: 55007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54867,
    lat: 45.78195,
    lng: -91.21521,
    city: "Radisson",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 475,
    density: 5.1,
    county_fips: 55113,
    county_name: "Sawyer",
    county_weights: {
      55113: 100,
    },
    county_names_all: "Sawyer",
    county_fips_all: 55113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54868,
    lat: 45.52723,
    lng: -91.70977,
    city: "Rice Lake",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15380,
    density: 28,
    county_fips: 55005,
    county_name: "Barron",
    county_weights: {
      55005: 94.33,
      55107: 4.4,
      55129: 1.27,
    },
    county_names_all: "Barron|Rusk|Washburn",
    county_fips_all: "55005|55107|55129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54870,
    lat: 45.71205,
    lng: -91.76967,
    city: "Sarona",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1689,
    density: 7.9,
    county_fips: 55129,
    county_name: "Washburn",
    county_weights: {
      55005: 2.6,
      55129: 97.4,
    },
    county_names_all: "Washburn|Barron",
    county_fips_all: "55129|55005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54871,
    lat: 45.7412,
    lng: -92.01503,
    city: "Shell Lake",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3026,
    density: 10.1,
    county_fips: 55129,
    county_name: "Washburn",
    county_weights: {
      55013: 40.7,
      55129: 59.3,
    },
    county_names_all: "Washburn|Burnett",
    county_fips_all: "55129|55013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54872,
    lat: 45.76965,
    lng: -92.39622,
    city: "Siren",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2702,
    density: 16.3,
    county_fips: 55013,
    county_name: "Burnett",
    county_weights: {
      55013: 94.59,
      55095: 5.41,
    },
    county_names_all: "Burnett|Polk",
    county_fips_all: "55013|55095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54873,
    lat: 46.3448,
    lng: -91.69292,
    city: "Solon Springs",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3016,
    density: 4.4,
    county_fips: 55031,
    county_name: "Douglas",
    county_weights: {
      55007: 36.87,
      55031: 63.13,
    },
    county_names_all: "Douglas|Bayfield",
    county_fips_all: "55031|55007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54874,
    lat: 46.56911,
    lng: -91.94304,
    city: "South Range",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3932,
    density: 10.5,
    county_fips: 55031,
    county_name: "Douglas",
    county_weights: {
      55031: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 55031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54875,
    lat: 45.97405,
    lng: -91.6948,
    city: "Springbrook",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1151,
    density: 4,
    county_fips: 55129,
    county_name: "Washburn",
    county_weights: {
      55129: 100,
    },
    county_names_all: "Washburn",
    county_fips_all: 55129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54876,
    lat: 45.82811,
    lng: -91.51439,
    city: "Stone Lake",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1665,
    density: 6.9,
    county_fips: 55113,
    county_name: "Sawyer",
    county_weights: {
      55113: 60.55,
      55129: 39.45,
    },
    county_names_all: "Sawyer|Washburn",
    county_fips_all: "55113|55129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54880,
    lat: 46.59342,
    lng: -92.12701,
    city: "Superior",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29792,
    density: 69.2,
    county_fips: 55031,
    county_name: "Douglas",
    county_weights: {
      55031: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 55031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54888,
    lat: 45.98046,
    lng: -91.88803,
    city: "Trego",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1152,
    density: 4.5,
    county_fips: 55129,
    county_name: "Washburn",
    county_weights: {
      55129: 100,
    },
    county_names_all: "Washburn",
    county_fips_all: 55129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54889,
    lat: 45.41374,
    lng: -92.17112,
    city: "Turtle Lake",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2514,
    density: 13.2,
    county_fips: 55095,
    county_name: "Polk",
    county_weights: {
      55005: 44.97,
      55095: 55.03,
    },
    county_names_all: "Polk|Barron",
    county_fips_all: "55095|55005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54891,
    lat: 46.69727,
    lng: -90.9688,
    city: "Washburn",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3150,
    density: 17.7,
    county_fips: 55007,
    county_name: "Bayfield",
    county_weights: {
      55007: 100,
    },
    county_names_all: "Bayfield",
    county_fips_all: 55007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54893,
    lat: 45.87094,
    lng: -92.30837,
    city: "Webster",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3800,
    density: 9.6,
    county_fips: 55013,
    county_name: "Burnett",
    county_weights: {
      55013: 100,
    },
    county_names_all: "Burnett",
    county_fips_all: 55013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54895,
    lat: 45.44233,
    lng: -91.44605,
    city: "Weyerhaeuser",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 781,
    density: 2.8,
    county_fips: 55107,
    county_name: "Rusk",
    county_weights: {
      55107: 100,
    },
    county_names_all: "Rusk",
    county_fips_all: 55107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54896,
    lat: 45.81178,
    lng: -90.87888,
    city: "Winter",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1294,
    density: 1.2,
    county_fips: 55113,
    county_name: "Sawyer",
    county_weights: {
      55113: 100,
    },
    county_names_all: "Sawyer",
    county_fips_all: 55113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54901,
    lat: 44.06265,
    lng: -88.53335,
    city: "Oshkosh",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37765,
    density: 876.3,
    county_fips: 55139,
    county_name: "Winnebago",
    county_weights: {
      55139: 100,
    },
    county_names_all: "Winnebago",
    county_fips_all: 55139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54902,
    lat: 43.94934,
    lng: -88.53969,
    city: "Oshkosh",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22094,
    density: 243.7,
    county_fips: 55139,
    county_name: "Winnebago",
    county_weights: {
      55139: 100,
    },
    county_names_all: "Winnebago",
    county_fips_all: 55139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54904,
    lat: 44.02346,
    lng: -88.62592,
    city: "Oshkosh",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22437,
    density: 111.2,
    county_fips: 55139,
    county_name: "Winnebago",
    county_weights: {
      55039: 0.46,
      55139: 99.54,
    },
    county_names_all: "Winnebago|Fond du Lac",
    county_fips_all: "55139|55039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54909,
    lat: 44.28575,
    lng: -89.35343,
    city: "Almond",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2249,
    density: 9,
    county_fips: 55097,
    county_name: "Portage",
    county_weights: {
      55097: 82.52,
      55137: 17.48,
    },
    county_names_all: "Portage|Waushara",
    county_fips_all: "55097|55137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54911,
    lat: 44.28174,
    lng: -88.38086,
    city: "Appleton",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25911,
    density: 1187.6,
    county_fips: 55087,
    county_name: "Outagamie",
    county_weights: {
      55087: 100,
    },
    county_names_all: "Outagamie",
    county_fips_all: 55087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54913,
    lat: 44.34145,
    lng: -88.40136,
    city: "Appleton",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22184,
    density: 133.4,
    county_fips: 55087,
    county_name: "Outagamie",
    county_weights: {
      55087: 100,
    },
    county_names_all: "Outagamie",
    county_fips_all: 55087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54914,
    lat: 44.26353,
    lng: -88.48239,
    city: "Appleton",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30555,
    density: 613.6,
    county_fips: 55087,
    county_name: "Outagamie",
    county_weights: {
      55087: 96.13,
      55139: 3.87,
    },
    county_names_all: "Outagamie|Winnebago",
    county_fips_all: "55087|55139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54915,
    lat: 44.24279,
    lng: -88.35928,
    city: "Appleton",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43401,
    density: 1114.1,
    county_fips: 55015,
    county_name: "Calumet",
    county_weights: {
      55015: 49.11,
      55087: 45.09,
      55139: 5.81,
    },
    county_names_all: "Calumet|Outagamie|Winnebago",
    county_fips_all: "55015|55087|55139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54921,
    lat: 44.30155,
    lng: -89.57341,
    city: "Bancroft",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1188,
    density: 5.3,
    county_fips: 55097,
    county_name: "Portage",
    county_weights: {
      55001: 13.62,
      55097: 86.38,
    },
    county_names_all: "Portage|Adams",
    county_fips_all: "55097|55001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54922,
    lat: 44.54281,
    lng: -88.74529,
    city: "Bear Creek",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1195,
    density: 10,
    county_fips: 55087,
    county_name: "Outagamie",
    county_weights: {
      55087: 54.8,
      55135: 45.2,
    },
    county_names_all: "Outagamie|Waupaca",
    county_fips_all: "55087|55135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54923,
    lat: 43.99456,
    lng: -88.96883,
    city: "Berlin",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8770,
    density: 25,
    county_fips: 55137,
    county_name: "Waushara",
    county_weights: {
      55047: 43.73,
      55137: 47.89,
      55139: 8.38,
    },
    county_names_all: "Waushara|Green Lake|Winnebago",
    county_fips_all: "55137|55047|55139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54926,
    lat: 44.61553,
    lng: -89.01823,
    city: "Big Falls",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 55135,
    county_name: "Waupaca",
    county_weights: {
      55135: 100,
    },
    county_names_all: "Waupaca",
    county_fips_all: 55135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54927,
    lat: 44.10192,
    lng: -88.6548,
    city: "Butte Des Morts",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 443,
    density: 785.4,
    county_fips: 55139,
    county_name: "Winnebago",
    county_weights: {
      55139: 100,
    },
    county_names_all: "Winnebago",
    county_fips_all: 55139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54928,
    lat: 44.73894,
    lng: -88.88546,
    city: "Caroline",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 541,
    density: 18.9,
    county_fips: 55115,
    county_name: "Shawano",
    county_weights: {
      55115: 100,
    },
    county_names_all: "Shawano",
    county_fips_all: 55115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54929,
    lat: 44.63704,
    lng: -88.7372,
    city: "Clintonville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8511,
    density: 26.9,
    county_fips: 55135,
    county_name: "Waupaca",
    county_weights: {
      55087: 1.9,
      55115: 25.81,
      55135: 72.29,
    },
    county_names_all: "Waupaca|Shawano|Outagamie",
    county_fips_all: "55135|55115|55087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54930,
    lat: 44.02884,
    lng: -89.56383,
    city: "Coloma",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1835,
    density: 7.6,
    county_fips: 55137,
    county_name: "Waushara",
    county_weights: {
      55001: 40.97,
      55077: 2.92,
      55137: 56.11,
    },
    county_names_all: "Waushara|Adams|Marquette",
    county_fips_all: "55137|55001|55077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54931,
    lat: 44.2703,
    lng: -88.66835,
    city: "Dale",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 432,
    density: 333.1,
    county_fips: 55087,
    county_name: "Outagamie",
    county_weights: {
      55087: 100,
    },
    county_names_all: "Outagamie",
    county_fips_all: 55087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54932,
    lat: 43.83143,
    lng: -88.61861,
    city: "Eldorado",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1425,
    density: 19.5,
    county_fips: 55039,
    county_name: "Fond du Lac",
    county_weights: {
      55039: 100,
    },
    county_names_all: "Fond du Lac",
    county_fips_all: 55039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54933,
    lat: 44.66535,
    lng: -88.70966,
    city: "Embarrass",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 353,
    density: 191.7,
    county_fips: 55135,
    county_name: "Waupaca",
    county_weights: {
      55135: 100,
    },
    county_names_all: "Waupaca",
    county_fips_all: 55135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54935,
    lat: 43.77542,
    lng: -88.43396,
    city: "Fond Du Lac",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41636,
    density: 1030.9,
    county_fips: 55039,
    county_name: "Fond du Lac",
    county_weights: {
      55039: 100,
    },
    county_names_all: "Fond du Lac",
    county_fips_all: 55039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54937,
    lat: 43.75959,
    lng: -88.43335,
    city: "Fond Du Lac",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20596,
    density: 66.2,
    county_fips: 55039,
    county_name: "Fond du Lac",
    county_weights: {
      55039: 100,
    },
    county_names_all: "Fond du Lac",
    county_fips_all: 55039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54940,
    lat: 44.22696,
    lng: -88.84446,
    city: "Fremont",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4385,
    density: 18.7,
    county_fips: 55139,
    county_name: "Winnebago",
    county_weights: {
      55087: 9.7,
      55135: 30.04,
      55137: 29.92,
      55139: 30.34,
    },
    county_names_all: "Winnebago|Waupaca|Waushara|Outagamie",
    county_fips_all: "55139|55135|55137|55087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54941,
    lat: 43.85067,
    lng: -88.99103,
    city: "Green Lake",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2409,
    density: 28.7,
    county_fips: 55047,
    county_name: "Green Lake",
    county_weights: {
      55047: 100,
    },
    county_names_all: "Green Lake",
    county_fips_all: 55047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54942,
    lat: 44.29904,
    lng: -88.54265,
    city: "Greenville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10124,
    density: 244.8,
    county_fips: 55087,
    county_name: "Outagamie",
    county_weights: {
      55087: 100,
    },
    county_names_all: "Outagamie",
    county_fips_all: 55087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54943,
    lat: 44.12377,
    lng: -89.58199,
    city: "Hancock",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1938,
    density: 6.2,
    county_fips: 55137,
    county_name: "Waushara",
    county_weights: {
      55001: 46.61,
      55137: 53.39,
    },
    county_names_all: "Waushara|Adams",
    county_fips_all: "55137|55001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54944,
    lat: 44.32409,
    lng: -88.6274,
    city: "Hortonville",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8838,
    density: 49.5,
    county_fips: 55087,
    county_name: "Outagamie",
    county_weights: {
      55087: 100,
    },
    county_names_all: "Outagamie",
    county_fips_all: 55087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54945,
    lat: 44.57604,
    lng: -89.13739,
    city: "Iola",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3424,
    density: 12.3,
    county_fips: 55135,
    county_name: "Waupaca",
    county_weights: {
      55097: 1.51,
      55135: 98.49,
    },
    county_names_all: "Waupaca|Portage",
    county_fips_all: "55135|55097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54946,
    lat: 44.33704,
    lng: -89.14503,
    city: "King",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 94,
    density: 514.9,
    county_fips: 55135,
    county_name: "Waupaca",
    county_weights: {
      55135: 100,
    },
    county_names_all: "Waupaca",
    county_fips_all: 55135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54947,
    lat: 44.20003,
    lng: -88.68995,
    city: "Larsen",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2259,
    density: 18.8,
    county_fips: 55139,
    county_name: "Winnebago",
    county_weights: {
      55139: 100,
    },
    county_names_all: "Winnebago",
    county_fips_all: 55139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54948,
    lat: 44.7774,
    lng: -88.88823,
    city: "Leopolis",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 207,
    density: 7.7,
    county_fips: 55115,
    county_name: "Shawano",
    county_weights: {
      55115: 100,
    },
    county_names_all: "Shawano",
    county_fips_all: 55115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54949,
    lat: 44.48561,
    lng: -88.91416,
    city: "Manawa",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3271,
    density: 19.3,
    county_fips: 55135,
    county_name: "Waupaca",
    county_weights: {
      55135: 100,
    },
    county_names_all: "Waupaca",
    county_fips_all: 55135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54950,
    lat: 44.65408,
    lng: -88.90614,
    city: "Marion",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2826,
    density: 13.3,
    county_fips: 55135,
    county_name: "Waupaca",
    county_weights: {
      55115: 32.3,
      55135: 67.7,
    },
    county_names_all: "Waupaca|Shawano",
    county_fips_all: "55135|55115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54952,
    lat: 44.20086,
    lng: -88.33719,
    city: "Menasha",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27182,
    density: 373.8,
    county_fips: 55015,
    county_name: "Calumet",
    county_weights: {
      55015: 71.79,
      55139: 28.21,
    },
    county_names_all: "Calumet|Winnebago",
    county_fips_all: "55015|55139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54956,
    lat: 44.18444,
    lng: -88.52778,
    city: "Neenah",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44481,
    density: 278.4,
    county_fips: 55139,
    county_name: "Winnebago",
    county_weights: {
      55087: 3.47,
      55139: 96.53,
    },
    county_names_all: "Winnebago|Outagamie",
    county_fips_all: "55139|55087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54960,
    lat: 43.94569,
    lng: -89.22386,
    city: "Neshkoro",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2451,
    density: 9.2,
    county_fips: 55077,
    county_name: "Marquette",
    county_weights: {
      55047: 18.72,
      55077: 62.05,
      55137: 19.23,
    },
    county_names_all: "Marquette|Waushara|Green Lake",
    county_fips_all: "55077|55137|55047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54961,
    lat: 44.41173,
    lng: -88.7628,
    city: "New London",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14037,
    density: 43.7,
    county_fips: 55135,
    county_name: "Waupaca",
    county_weights: {
      55087: 35.87,
      55135: 64.13,
    },
    county_names_all: "Waupaca|Outagamie",
    county_fips_all: "55135|55087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54962,
    lat: 44.48059,
    lng: -89.02486,
    city: "Ogdensburg",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1154,
    density: 9.7,
    county_fips: 55135,
    county_name: "Waupaca",
    county_weights: {
      55135: 100,
    },
    county_names_all: "Waupaca",
    county_fips_all: 55135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54963,
    lat: 44.04524,
    lng: -88.76661,
    city: "Omro",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7152,
    density: 36.3,
    county_fips: 55139,
    county_name: "Winnebago",
    county_weights: {
      55137: 0.35,
      55139: 99.65,
    },
    county_names_all: "Winnebago|Waushara",
    county_fips_all: "55139|55137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54964,
    lat: 43.9178,
    lng: -88.71836,
    city: "Pickett",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1057,
    density: 11.8,
    county_fips: 55139,
    county_name: "Winnebago",
    county_weights: {
      55039: 27.3,
      55139: 72.7,
    },
    county_names_all: "Winnebago|Fond du Lac",
    county_fips_all: "55139|55039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54965,
    lat: 44.16429,
    lng: -89.0324,
    city: "Pine River",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1397,
    density: 9.1,
    county_fips: 55137,
    county_name: "Waushara",
    county_weights: {
      55135: 1.31,
      55137: 98.69,
    },
    county_names_all: "Waushara|Waupaca",
    county_fips_all: "55137|55135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54966,
    lat: 44.21276,
    lng: -89.50579,
    city: "Plainfield",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2089,
    density: 9.9,
    county_fips: 55137,
    county_name: "Waushara",
    county_weights: {
      55001: 7.48,
      55097: 18.85,
      55137: 73.67,
    },
    county_names_all: "Waushara|Portage|Adams",
    county_fips_all: "55137|55097|55001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54967,
    lat: 44.12954,
    lng: -88.98487,
    city: "Poy Sippi",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 467,
    density: 80.3,
    county_fips: 55137,
    county_name: "Waushara",
    county_weights: {
      55137: 100,
    },
    county_names_all: "Waushara",
    county_fips_all: 55137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54968,
    lat: 43.84872,
    lng: -89.13255,
    city: "Princeton",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2873,
    density: 18.1,
    county_fips: 55047,
    county_name: "Green Lake",
    county_weights: {
      55047: 81.88,
      55077: 18.12,
    },
    county_names_all: "Green Lake|Marquette",
    county_fips_all: "55047|55077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54970,
    lat: 44.07091,
    lng: -89.09352,
    city: "Redgranite",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3862,
    density: 32.6,
    county_fips: 55137,
    county_name: "Waushara",
    county_weights: {
      55137: 100,
    },
    county_names_all: "Waushara",
    county_fips_all: 55137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54971,
    lat: 43.85546,
    lng: -88.83109,
    city: "Ripon",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10467,
    density: 36.4,
    county_fips: 55039,
    county_name: "Fond du Lac",
    county_weights: {
      55039: 57.52,
      55047: 20.58,
      55139: 21.9,
    },
    county_names_all: "Fond du Lac|Winnebago|Green Lake",
    county_fips_all: "55039|55139|55047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54974,
    lat: 43.7801,
    lng: -88.65997,
    city: "Rosendale",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1369,
    density: 20.1,
    county_fips: 55039,
    county_name: "Fond du Lac",
    county_weights: {
      55039: 100,
    },
    county_names_all: "Fond du Lac",
    county_fips_all: 55039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54977,
    lat: 44.45696,
    lng: -89.16471,
    city: "Scandinavia",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1485,
    density: 15,
    county_fips: 55135,
    county_name: "Waupaca",
    county_weights: {
      55097: 11.83,
      55135: 88.17,
    },
    county_names_all: "Waupaca|Portage",
    county_fips_all: "55135|55097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54978,
    lat: 44.79423,
    lng: -88.91405,
    city: "Tilleda",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 55115,
    county_name: "Shawano",
    county_weights: {
      55115: 100,
    },
    county_names_all: "Shawano",
    county_fips_all: 55115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54979,
    lat: 43.8688,
    lng: -88.53875,
    city: "Van Dyne",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1321,
    density: 19.2,
    county_fips: 55039,
    county_name: "Fond du Lac",
    county_weights: {
      55039: 95.68,
      55139: 4.32,
    },
    county_names_all: "Fond du Lac|Winnebago",
    county_fips_all: "55039|55139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54980,
    lat: 43.98625,
    lng: -88.76906,
    city: "Waukau",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 139,
    density: 154,
    county_fips: 55139,
    county_name: "Winnebago",
    county_weights: {
      55139: 100,
    },
    county_names_all: "Winnebago",
    county_fips_all: 55139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54981,
    lat: 44.32733,
    lng: -89.12558,
    city: "Waupaca",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14989,
    density: 44,
    county_fips: 55135,
    county_name: "Waupaca",
    county_weights: {
      55097: 4.91,
      55135: 91.11,
      55137: 3.98,
    },
    county_names_all: "Waupaca|Portage|Waushara",
    county_fips_all: "55135|55097|55137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54982,
    lat: 44.07007,
    lng: -89.29223,
    city: "Wautoma",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6819,
    density: 20.6,
    county_fips: 55137,
    county_name: "Waushara",
    county_weights: {
      55077: 2.39,
      55137: 97.61,
    },
    county_names_all: "Waushara|Marquette",
    county_fips_all: "55137|55077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54983,
    lat: 44.31651,
    lng: -88.93614,
    city: "Weyauwega",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4299,
    density: 20.2,
    county_fips: 55135,
    county_name: "Waupaca",
    county_weights: {
      55135: 93.09,
      55137: 6.91,
    },
    county_names_all: "Waupaca|Waushara",
    county_fips_all: "55135|55137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54984,
    lat: 44.18728,
    lng: -89.21967,
    city: "Wild Rose",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3081,
    density: 15.2,
    county_fips: 55137,
    county_name: "Waushara",
    county_weights: {
      55097: 2.82,
      55137: 97.18,
    },
    county_names_all: "Waushara|Portage",
    county_fips_all: "55137|55097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54985,
    lat: 44.07562,
    lng: -88.51953,
    city: "Winnebago",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 300,
    density: 1289.1,
    county_fips: 55139,
    county_name: "Winnebago",
    county_weights: {
      55139: 100,
    },
    county_names_all: "Winnebago",
    county_fips_all: 55139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 54986,
    lat: 44.11981,
    lng: -88.75127,
    city: "Winneconne",
    state_id: "WI",
    state_name: "Wisconsin",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5457,
    density: 72.6,
    county_fips: 55139,
    county_name: "Winnebago",
    county_weights: {
      55137: 0.81,
      55139: 99.19,
    },
    county_names_all: "Winnebago|Waushara",
    county_fips_all: "55139|55137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55001,
    lat: 44.90138,
    lng: -92.81969,
    city: "Afton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3029,
    density: 43.3,
    county_fips: 27163,
    county_name: "Washington",
    county_weights: {
      27163: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 27163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55003,
    lat: 45.01183,
    lng: -92.77883,
    city: "Bayport",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3758,
    density: 698.4,
    county_fips: 27163,
    county_name: "Washington",
    county_weights: {
      27163: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 27163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55005,
    lat: 45.39281,
    lng: -93.21725,
    city: "Bethel",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4714,
    density: 96.1,
    county_fips: 27003,
    county_name: "Anoka",
    county_weights: {
      27003: 100,
    },
    county_names_all: "Anoka",
    county_fips_all: 27003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55006,
    lat: 45.74002,
    lng: -93.20504,
    city: "Braham",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3651,
    density: 18.5,
    county_fips: 27065,
    county_name: "Kanabec",
    county_weights: {
      27025: 7.71,
      27059: 34.51,
      27065: 38.18,
      27115: 19.61,
    },
    county_names_all: "Kanabec|Isanti|Pine|Chisago",
    county_fips_all: "27065|27059|27115|27025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55007,
    lat: 45.97511,
    lng: -93.12223,
    city: "Brook Park",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2361,
    density: 7.7,
    county_fips: 27065,
    county_name: "Kanabec",
    county_weights: {
      27065: 61.85,
      27115: 38.15,
    },
    county_names_all: "Kanabec|Pine",
    county_fips_all: "27065|27115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55008,
    lat: 45.57149,
    lng: -93.26734,
    city: "Cambridge",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15396,
    density: 59.2,
    county_fips: 27059,
    county_name: "Isanti",
    county_weights: {
      27025: 0.69,
      27059: 99.31,
    },
    county_names_all: "Isanti|Chisago",
    county_fips_all: "27059|27025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55009,
    lat: 44.48378,
    lng: -92.86686,
    city: "Cannon Falls",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8017,
    density: 25.3,
    county_fips: 27049,
    county_name: "Goodhue",
    county_weights: {
      27037: 18.35,
      27049: 81.65,
    },
    county_names_all: "Goodhue|Dakota",
    county_fips_all: "27049|27037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55011,
    lat: 45.34108,
    lng: -93.2521,
    city: "Cedar",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10825,
    density: 91.1,
    county_fips: 27003,
    county_name: "Anoka",
    county_weights: {
      27003: 100,
    },
    county_names_all: "Anoka",
    county_fips_all: 27003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55012,
    lat: 45.44166,
    lng: -92.78952,
    city: "Center City",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2023,
    density: 32.9,
    county_fips: 27025,
    county_name: "Chisago",
    county_weights: {
      27025: 100,
    },
    county_names_all: "Chisago",
    county_fips_all: 27025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55013,
    lat: 45.35558,
    lng: -92.89469,
    city: "Chisago City",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7015,
    density: 98,
    county_fips: 27025,
    county_name: "Chisago",
    county_weights: {
      27025: 100,
    },
    county_names_all: "Chisago",
    county_fips_all: 27025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55014,
    lat: 45.16802,
    lng: -93.12431,
    city: "Circle Pines",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28782,
    density: 548.4,
    county_fips: 27003,
    county_name: "Anoka",
    county_weights: {
      27003: 100,
    },
    county_names_all: "Anoka",
    county_fips_all: 27003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55016,
    lat: 44.8172,
    lng: -92.93373,
    city: "Cottage Grove",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36643,
    density: 470,
    county_fips: 27163,
    county_name: "Washington",
    county_weights: {
      27163: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 27163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55017,
    lat: 45.67291,
    lng: -93.4314,
    city: "Dalbo",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 905,
    density: 13.5,
    county_fips: 27059,
    county_name: "Isanti",
    county_weights: {
      27059: 100,
    },
    county_names_all: "Isanti",
    county_fips_all: 27059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55018,
    lat: 44.41832,
    lng: -92.98822,
    city: "Dennison",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 839,
    density: 7.3,
    county_fips: 27049,
    county_name: "Goodhue",
    county_weights: {
      27049: 91.16,
      27131: 8.84,
    },
    county_names_all: "Goodhue|Rice",
    county_fips_all: "27049|27131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55019,
    lat: 44.41318,
    lng: -93.25016,
    city: "Dundas",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2243,
    density: 42.3,
    county_fips: 27131,
    county_name: "Rice",
    county_weights: {
      27131: 100,
    },
    county_names_all: "Rice",
    county_fips_all: 27131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55020,
    lat: 44.57707,
    lng: -93.37387,
    city: "Elko New Market",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4529,
    density: 73.4,
    county_fips: 27139,
    county_name: "Scott",
    county_weights: {
      27139: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 27139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55021,
    lat: 44.2973,
    lng: -93.27414,
    city: "Faribault",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30334,
    density: 66.2,
    county_fips: 27131,
    county_name: "Rice",
    county_weights: {
      27131: 100,
    },
    county_names_all: "Rice",
    county_fips_all: 27131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55024,
    lat: 44.62738,
    lng: -93.13605,
    city: "Farmington",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36897,
    density: 167.4,
    county_fips: 27037,
    county_name: "Dakota",
    county_weights: {
      27037: 100,
    },
    county_names_all: "Dakota",
    county_fips_all: 27037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55025,
    lat: 45.26391,
    lng: -93.0212,
    city: "Forest Lake",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25709,
    density: 128.8,
    county_fips: 27003,
    county_name: "Anoka",
    county_weights: {
      27003: 52.25,
      27025: 6.97,
      27163: 40.78,
    },
    county_names_all: "Anoka|Washington|Chisago",
    county_fips_all: "27003|27163|27025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55026,
    lat: 44.52179,
    lng: -92.3369,
    city: "Frontenac",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 426,
    density: 45.9,
    county_fips: 27049,
    county_name: "Goodhue",
    county_weights: {
      27049: 100,
    },
    county_names_all: "Goodhue",
    county_fips_all: 27049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55027,
    lat: 44.40868,
    lng: -92.62058,
    city: "Goodhue",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2946,
    density: 9.7,
    county_fips: 27049,
    county_name: "Goodhue",
    county_weights: {
      27049: 99.19,
      27157: 0.81,
    },
    county_names_all: "Goodhue|Wabasha",
    county_fips_all: "27049|27157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55029,
    lat: 45.63573,
    lng: -93.20098,
    city: "Grandy",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 78,
    density: 117.6,
    county_fips: 27059,
    county_name: "Isanti",
    county_weights: {
      27059: 100,
    },
    county_names_all: "Isanti",
    county_fips_all: 27059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55030,
    lat: 45.83911,
    lng: -93.11493,
    city: "Grasston",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1430,
    density: 14.1,
    county_fips: 27115,
    county_name: "Pine",
    county_weights: {
      27065: 20.09,
      27115: 79.91,
    },
    county_names_all: "Pine|Kanabec",
    county_fips_all: "27115|27065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55031,
    lat: 44.60772,
    lng: -92.96647,
    city: "Hampton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1848,
    density: 17.5,
    county_fips: 27037,
    county_name: "Dakota",
    county_weights: {
      27037: 100,
    },
    county_names_all: "Dakota",
    county_fips_all: 27037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55032,
    lat: 45.58851,
    lng: -92.99279,
    city: "Harris",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3744,
    density: 21.3,
    county_fips: 27025,
    county_name: "Chisago",
    county_weights: {
      27025: 100,
    },
    county_names_all: "Chisago",
    county_fips_all: 27025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55033,
    lat: 44.71139,
    lng: -92.8585,
    city: "Hastings",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30402,
    density: 81.4,
    county_fips: 27037,
    county_name: "Dakota",
    county_weights: {
      27037: 75.38,
      27049: 3.15,
      27163: 21.47,
    },
    county_names_all: "Dakota|Washington|Goodhue",
    county_fips_all: "27037|27163|27049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55036,
    lat: 45.87114,
    lng: -93.11999,
    city: "Henriette",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59,
    density: 81.2,
    county_fips: 27115,
    county_name: "Pine",
    county_weights: {
      27115: 100,
    },
    county_names_all: "Pine",
    county_fips_all: 27115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55037,
    lat: 46.01071,
    lng: -92.78934,
    city: "Hinckley",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4717,
    density: 5.9,
    county_fips: 27115,
    county_name: "Pine",
    county_weights: {
      27065: 7.02,
      27115: 92.98,
    },
    county_names_all: "Pine|Kanabec",
    county_fips_all: "27115|27065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55038,
    lat: 45.169,
    lng: -92.98059,
    city: "Hugo",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22921,
    density: 175.3,
    county_fips: 27163,
    county_name: "Washington",
    county_weights: {
      27003: 30.73,
      27123: 0.32,
      27163: 68.95,
    },
    county_names_all: "Washington|Anoka|Ramsey",
    county_fips_all: "27163|27003|27123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55040,
    lat: 45.4678,
    lng: -93.27951,
    city: "Isanti",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13490,
    density: 53.1,
    county_fips: 27059,
    county_name: "Isanti",
    county_weights: {
      27059: 100,
    },
    county_names_all: "Isanti",
    county_fips_all: 27059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55041,
    lat: 44.39544,
    lng: -92.31923,
    city: "Lake City",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7498,
    density: 20.1,
    county_fips: 27157,
    county_name: "Wabasha",
    county_weights: {
      27049: 16.55,
      27157: 83.45,
    },
    county_names_all: "Wabasha|Goodhue",
    county_fips_all: "27157|27049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55042,
    lat: 44.99253,
    lng: -92.898,
    city: "Lake Elmo",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9918,
    density: 153.9,
    county_fips: 27163,
    county_name: "Washington",
    county_weights: {
      27163: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 27163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55043,
    lat: 44.94064,
    lng: -92.76902,
    city: "Lakeland",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3659,
    density: 375.4,
    county_fips: 27163,
    county_name: "Washington",
    county_weights: {
      27163: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 27163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55044,
    lat: 44.64156,
    lng: -93.27858,
    city: "Lakeville",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55722,
    density: 329.6,
    county_fips: 27037,
    county_name: "Dakota",
    county_weights: {
      27037: 70.37,
      27139: 29.63,
    },
    county_names_all: "Dakota|Scott",
    county_fips_all: "27037|27139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55045,
    lat: 45.39777,
    lng: -92.83074,
    city: "Lindstrom",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7362,
    density: 81.6,
    county_fips: 27025,
    county_name: "Chisago",
    county_weights: {
      27025: 100,
    },
    county_names_all: "Chisago",
    county_fips_all: 27025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55046,
    lat: 44.44629,
    lng: -93.4162,
    city: "Lonsdale",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5621,
    density: 48.7,
    county_fips: 27131,
    county_name: "Rice",
    county_weights: {
      27131: 100,
    },
    county_names_all: "Rice",
    county_fips_all: 27131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55047,
    lat: 45.20553,
    lng: -92.82137,
    city: "Marine On Saint Croix",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2405,
    density: 31.8,
    county_fips: 27163,
    county_name: "Washington",
    county_weights: {
      27163: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 27163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55049,
    lat: 44.17628,
    lng: -93.24101,
    city: "Medford",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2607,
    density: 21.7,
    county_fips: 27147,
    county_name: "Steele",
    county_weights: {
      27131: 9.15,
      27147: 90.85,
    },
    county_names_all: "Steele|Rice",
    county_fips_all: "27147|27131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55051,
    lat: 45.93818,
    lng: -93.33201,
    city: "Mora",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9445,
    density: 16.7,
    county_fips: 27065,
    county_name: "Kanabec",
    county_weights: {
      27065: 86.48,
      27095: 13.52,
    },
    county_names_all: "Kanabec|Mille Lacs",
    county_fips_all: "27065|27095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55052,
    lat: 44.23369,
    lng: -93.4398,
    city: "Morristown",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2123,
    density: 18.2,
    county_fips: 27131,
    county_name: "Rice",
    county_weights: {
      27131: 84.91,
      27147: 5.5,
      27161: 9.59,
    },
    county_names_all: "Rice|Waseca|Steele",
    county_fips_all: "27131|27161|27147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55053,
    lat: 44.34957,
    lng: -93.06579,
    city: "Nerstrand",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 957,
    density: 7.5,
    county_fips: 27131,
    county_name: "Rice",
    county_weights: {
      27049: 31.3,
      27131: 68.7,
    },
    county_names_all: "Rice|Goodhue",
    county_fips_all: "27131|27049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55054,
    lat: 44.57148,
    lng: -93.35087,
    city: "Elko New Market",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2502,
    density: 943.5,
    county_fips: 27139,
    county_name: "Scott",
    county_weights: {
      27139: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 27139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55055,
    lat: 44.87437,
    lng: -92.99746,
    city: "Newport",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3664,
    density: 390.5,
    county_fips: 27163,
    county_name: "Washington",
    county_weights: {
      27163: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 27163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55056,
    lat: 45.50915,
    lng: -92.9543,
    city: "North Branch",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14088,
    density: 54.7,
    county_fips: 27025,
    county_name: "Chisago",
    county_weights: {
      27025: 69.39,
      27059: 30.61,
    },
    county_names_all: "Chisago|Isanti",
    county_fips_all: "27025|27059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55057,
    lat: 44.47281,
    lng: -93.17939,
    city: "Northfield",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25247,
    density: 78.2,
    county_fips: 27131,
    county_name: "Rice",
    county_weights: {
      27037: 45.88,
      27049: 0.23,
      27131: 53.89,
    },
    county_names_all: "Rice|Dakota|Goodhue",
    county_fips_all: "27131|27037|27049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55060,
    lat: 44.05966,
    lng: -93.22639,
    city: "Owatonna",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29100,
    density: 55.2,
    county_fips: 27147,
    county_name: "Steele",
    county_weights: {
      27147: 100,
    },
    county_names_all: "Steele",
    county_fips_all: 27147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55063,
    lat: 45.83263,
    lng: -92.90584,
    city: "Pine City",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9640,
    density: 23.4,
    county_fips: 27115,
    county_name: "Pine",
    county_weights: {
      27115: 100,
    },
    county_names_all: "Pine",
    county_fips_all: 27115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55065,
    lat: 44.54662,
    lng: -93.01835,
    city: "Randolph",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1328,
    density: 15.7,
    county_fips: 27037,
    county_name: "Dakota",
    county_weights: {
      27037: 98.37,
      27049: 1.63,
    },
    county_names_all: "Dakota|Goodhue",
    county_fips_all: "27037|27049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55066,
    lat: 44.51581,
    lng: -92.5441,
    city: "Red Wing",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18679,
    density: 59.6,
    county_fips: 27049,
    county_name: "Goodhue",
    county_weights: {
      27049: 100,
    },
    county_names_all: "Goodhue",
    county_fips_all: 27049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55068,
    lat: 44.73555,
    lng: -93.06876,
    city: "Rosemount",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30178,
    density: 253.5,
    county_fips: 27037,
    county_name: "Dakota",
    county_weights: {
      27037: 100,
    },
    county_names_all: "Dakota",
    county_fips_all: 27037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55069,
    lat: 45.6928,
    lng: -92.96768,
    city: "Rush City",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5522,
    density: 28.8,
    county_fips: 27025,
    county_name: "Chisago",
    county_weights: {
      27025: 83.14,
      27115: 16.86,
    },
    county_names_all: "Chisago|Pine",
    county_fips_all: "27025|27115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55070,
    lat: 45.41413,
    lng: -93.3849,
    city: "Saint Francis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8567,
    density: 129.8,
    county_fips: 27003,
    county_name: "Anoka",
    county_weights: {
      27003: 63.78,
      27059: 36.22,
    },
    county_names_all: "Anoka|Isanti",
    county_fips_all: "27003|27059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55071,
    lat: 44.82257,
    lng: -92.99677,
    city: "Saint Paul Park",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5692,
    density: 439.7,
    county_fips: 27163,
    county_name: "Washington",
    county_weights: {
      27163: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 27163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55072,
    lat: 46.15118,
    lng: -92.59274,
    city: "Sandstone",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4543,
    density: 5,
    county_fips: 27115,
    county_name: "Pine",
    county_weights: {
      27065: 5.96,
      27115: 94.04,
    },
    county_names_all: "Pine|Kanabec",
    county_fips_all: "27115|27065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55073,
    lat: 45.27363,
    lng: -92.82783,
    city: "Scandia",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3599,
    density: 49.6,
    county_fips: 27163,
    county_name: "Washington",
    county_weights: {
      27025: 13.53,
      27163: 86.47,
    },
    county_names_all: "Washington|Chisago",
    county_fips_all: "27163|27025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55074,
    lat: 45.38351,
    lng: -92.73292,
    city: "Shafer",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2197,
    density: 24.7,
    county_fips: 27025,
    county_name: "Chisago",
    county_weights: {
      27025: 100,
    },
    county_names_all: "Chisago",
    county_fips_all: 27025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55075,
    lat: 44.88794,
    lng: -93.0411,
    city: "South Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20132,
    density: 1390.5,
    county_fips: 27037,
    county_name: "Dakota",
    county_weights: {
      27037: 100,
    },
    county_names_all: "Dakota",
    county_fips_all: 27037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55076,
    lat: 44.83318,
    lng: -93.0334,
    city: "Inver Grove Heights",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22681,
    density: 882.6,
    county_fips: 27037,
    county_name: "Dakota",
    county_weights: {
      27037: 100,
    },
    county_names_all: "Dakota",
    county_fips_all: 27037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55077,
    lat: 44.81989,
    lng: -93.07574,
    city: "Inver Grove Heights",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12742,
    density: 271,
    county_fips: 27037,
    county_name: "Dakota",
    county_weights: {
      27037: 100,
    },
    county_names_all: "Dakota",
    county_fips_all: 27037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55079,
    lat: 45.41385,
    lng: -93.03117,
    city: "Stacy",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8682,
    density: 52.7,
    county_fips: 27025,
    county_name: "Chisago",
    county_weights: {
      27003: 26.7,
      27025: 42.59,
      27059: 30.71,
    },
    county_names_all: "Chisago|Isanti|Anoka",
    county_fips_all: "27025|27059|27003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55080,
    lat: 45.66322,
    lng: -93.21881,
    city: "Stanchfield",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2887,
    density: 16.3,
    county_fips: 27059,
    county_name: "Isanti",
    county_weights: {
      27025: 24.64,
      27059: 75.36,
    },
    county_names_all: "Isanti|Chisago",
    county_fips_all: "27059|27025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55082,
    lat: 45.07446,
    lng: -92.84006,
    city: "Stillwater",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36736,
    density: 179.1,
    county_fips: 27163,
    county_name: "Washington",
    county_weights: {
      27163: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 27163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55084,
    lat: 45.46029,
    lng: -92.70747,
    city: "Taylors Falls",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1855,
    density: 28.9,
    county_fips: 27025,
    county_name: "Chisago",
    county_weights: {
      27025: 100,
    },
    county_names_all: "Chisago",
    county_fips_all: 27025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55085,
    lat: 44.6731,
    lng: -92.96432,
    city: "Vermillion",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 477,
    density: 200.3,
    county_fips: 27037,
    county_name: "Dakota",
    county_weights: {
      27037: 100,
    },
    county_names_all: "Dakota",
    county_fips_all: 27037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55087,
    lat: 44.23894,
    lng: -93.40614,
    city: "Warsaw",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 447,
    density: 156.2,
    county_fips: 27131,
    county_name: "Rice",
    county_weights: {
      27131: 100,
    },
    county_names_all: "Rice",
    county_fips_all: 27131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55088,
    lat: 44.52945,
    lng: -93.38479,
    city: "Webster",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1573,
    density: 16.5,
    county_fips: 27131,
    county_name: "Rice",
    county_weights: {
      27131: 75.49,
      27139: 24.51,
    },
    county_names_all: "Rice|Scott",
    county_fips_all: "27131|27139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55089,
    lat: 44.59296,
    lng: -92.70223,
    city: "Welch",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1544,
    density: 8.9,
    county_fips: 27049,
    county_name: "Goodhue",
    county_weights: {
      27037: 2.76,
      27049: 97.24,
    },
    county_names_all: "Goodhue|Dakota",
    county_fips_all: "27049|27037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55090,
    lat: 45.05382,
    lng: -92.9573,
    city: "Willernie",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 331,
    density: 1123.7,
    county_fips: 27163,
    county_name: "Washington",
    county_weights: {
      27163: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 27163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55092,
    lat: 45.33647,
    lng: -93.07214,
    city: "Wyoming",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10925,
    density: 125.4,
    county_fips: 27003,
    county_name: "Anoka",
    county_weights: {
      27003: 67.16,
      27025: 32.84,
    },
    county_names_all: "Anoka|Chisago",
    county_fips_all: "27003|27025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55101,
    lat: 44.95111,
    lng: -93.08739,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7306,
    density: 3626.1,
    county_fips: 27123,
    county_name: "Ramsey",
    county_weights: {
      27123: 100,
    },
    county_names_all: "Ramsey",
    county_fips_all: 27123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55102,
    lat: 44.93216,
    lng: -93.12149,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18757,
    density: 2206,
    county_fips: 27123,
    county_name: "Ramsey",
    county_weights: {
      27123: 100,
    },
    county_names_all: "Ramsey",
    county_fips_all: 27123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55103,
    lat: 44.96399,
    lng: -93.12418,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13483,
    density: 2637.8,
    county_fips: 27123,
    county_name: "Ramsey",
    county_weights: {
      27123: 100,
    },
    county_names_all: "Ramsey",
    county_fips_all: 27123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55104,
    lat: 44.95423,
    lng: -93.16283,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45211,
    density: 2892.6,
    county_fips: 27123,
    county_name: "Ramsey",
    county_weights: {
      27123: 100,
    },
    county_names_all: "Ramsey",
    county_fips_all: 27123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55105,
    lat: 44.93465,
    lng: -93.16689,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27014,
    density: 2981.3,
    county_fips: 27123,
    county_name: "Ramsey",
    county_weights: {
      27123: 100,
    },
    county_names_all: "Ramsey",
    county_fips_all: 27123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55106,
    lat: 44.95743,
    lng: -93.04679,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58335,
    density: 2390.7,
    county_fips: 27123,
    county_name: "Ramsey",
    county_weights: {
      27123: 100,
    },
    county_names_all: "Ramsey",
    county_fips_all: 27123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55107,
    lat: 44.93105,
    lng: -93.07945,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14575,
    density: 1369.6,
    county_fips: 27123,
    county_name: "Ramsey",
    county_weights: {
      27123: 100,
    },
    county_names_all: "Ramsey",
    county_fips_all: 27123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55108,
    lat: 44.98095,
    lng: -93.1749,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15810,
    density: 1527.3,
    county_fips: 27123,
    county_name: "Ramsey",
    county_weights: {
      27123: 100,
    },
    county_names_all: "Ramsey",
    county_fips_all: 27123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55109,
    lat: 45.0144,
    lng: -93.02616,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33926,
    density: 1121.1,
    county_fips: 27123,
    county_name: "Ramsey",
    county_weights: {
      27123: 100,
    },
    county_names_all: "Ramsey",
    county_fips_all: 27123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55110,
    lat: 45.08961,
    lng: -93.00418,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40302,
    density: 629.2,
    county_fips: 27123,
    county_name: "Ramsey",
    county_weights: {
      27003: 3.81,
      27123: 63.48,
      27163: 32.71,
    },
    county_names_all: "Ramsey|Washington|Anoka",
    county_fips_all: "27123|27163|27003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55111,
    lat: 44.885,
    lng: -93.19518,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64,
    density: 10.8,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55112,
    lat: 45.07443,
    lng: -93.19169,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46244,
    density: 1022.4,
    county_fips: 27123,
    county_name: "Ramsey",
    county_weights: {
      27123: 100,
    },
    county_names_all: "Ramsey",
    county_fips_all: 27123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55113,
    lat: 45.01295,
    lng: -93.15512,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42242,
    density: 1098.7,
    county_fips: 27123,
    county_name: "Ramsey",
    county_weights: {
      27123: 100,
    },
    county_names_all: "Ramsey",
    county_fips_all: 27123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55114,
    lat: 44.9662,
    lng: -93.19407,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3136,
    density: 912.8,
    county_fips: 27123,
    county_name: "Ramsey",
    county_weights: {
      27123: 100,
    },
    county_names_all: "Ramsey",
    county_fips_all: 27123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55115,
    lat: 45.06675,
    lng: -92.95087,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9342,
    density: 592.3,
    county_fips: 27163,
    county_name: "Washington",
    county_weights: {
      27163: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 27163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55116,
    lat: 44.91001,
    lng: -93.17033,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25125,
    density: 1754.1,
    county_fips: 27123,
    county_name: "Ramsey",
    county_weights: {
      27123: 100,
    },
    county_names_all: "Ramsey",
    county_fips_all: 27123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55117,
    lat: 44.99918,
    lng: -93.09713,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46053,
    density: 1941.9,
    county_fips: 27123,
    county_name: "Ramsey",
    county_weights: {
      27123: 100,
    },
    county_names_all: "Ramsey",
    county_fips_all: 27123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55118,
    lat: 44.8968,
    lng: -93.10365,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27767,
    density: 1024.3,
    county_fips: 27037,
    county_name: "Dakota",
    county_weights: {
      27037: 99.87,
      27123: 0.13,
    },
    county_names_all: "Dakota|Ramsey",
    county_fips_all: "27037|27123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55119,
    lat: 44.93972,
    lng: -93.0066,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43876,
    density: 1282.8,
    county_fips: 27123,
    county_name: "Ramsey",
    county_weights: {
      27123: 100,
    },
    county_names_all: "Ramsey",
    county_fips_all: 27123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55120,
    lat: 44.87259,
    lng: -93.14881,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5036,
    density: 359.6,
    county_fips: 27037,
    county_name: "Dakota",
    county_weights: {
      27037: 100,
    },
    county_names_all: "Dakota",
    county_fips_all: 27037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55121,
    lat: 44.84591,
    lng: -93.15932,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8679,
    density: 348.6,
    county_fips: 27037,
    county_name: "Dakota",
    county_weights: {
      27037: 100,
    },
    county_names_all: "Dakota",
    county_fips_all: 27037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55122,
    lat: 44.80326,
    lng: -93.1962,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30976,
    density: 1110.8,
    county_fips: 27037,
    county_name: "Dakota",
    county_weights: {
      27037: 100,
    },
    county_names_all: "Dakota",
    county_fips_all: 27037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55123,
    lat: 44.8043,
    lng: -93.13699,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26821,
    density: 962,
    county_fips: 27037,
    county_name: "Dakota",
    county_weights: {
      27037: 100,
    },
    county_names_all: "Dakota",
    county_fips_all: 27037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55124,
    lat: 44.74566,
    lng: -93.20042,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53781,
    density: 1231.3,
    county_fips: 27037,
    county_name: "Dakota",
    county_weights: {
      27037: 100,
    },
    county_names_all: "Dakota",
    county_fips_all: 27037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55125,
    lat: 44.91998,
    lng: -92.94388,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44446,
    density: 1118.1,
    county_fips: 27163,
    county_name: "Washington",
    county_weights: {
      27163: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 27163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55126,
    lat: 45.08614,
    lng: -93.13581,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27125,
    density: 763.9,
    county_fips: 27123,
    county_name: "Ramsey",
    county_weights: {
      27003: 3.18,
      27123: 96.82,
    },
    county_names_all: "Ramsey|Anoka",
    county_fips_all: "27123|27003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55127,
    lat: 45.08394,
    lng: -93.08243,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19037,
    density: 545.9,
    county_fips: 27123,
    county_name: "Ramsey",
    county_weights: {
      27123: 100,
    },
    county_names_all: "Ramsey",
    county_fips_all: 27123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55128,
    lat: 44.98812,
    lng: -92.96405,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28752,
    density: 988.6,
    county_fips: 27163,
    county_name: "Washington",
    county_weights: {
      27163: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 27163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55129,
    lat: 44.89422,
    lng: -92.90638,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26852,
    density: 531,
    county_fips: 27163,
    county_name: "Washington",
    county_weights: {
      27163: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 27163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55130,
    lat: 44.97315,
    lng: -93.08241,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19510,
    density: 3731,
    county_fips: 27123,
    county_name: "Ramsey",
    county_weights: {
      27123: 100,
    },
    county_names_all: "Ramsey",
    county_fips_all: 27123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55150,
    lat: 44.88717,
    lng: -93.16157,
    city: "Mendota",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 143,
    density: 183.6,
    county_fips: 27037,
    county_name: "Dakota",
    county_weights: {
      27037: 100,
    },
    county_names_all: "Dakota",
    county_fips_all: 27037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55155,
    lat: 44.95419,
    lng: -93.09756,
    city: "Saint Paul",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 27123,
    county_name: "Ramsey",
    county_weights: {
      27123: 100,
    },
    county_names_all: "Ramsey",
    county_fips_all: 27123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55301,
    lat: 45.24448,
    lng: -93.66219,
    city: "Albertville",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13708,
    density: 647.4,
    county_fips: 27171,
    county_name: "Wright",
    county_weights: {
      27171: 100,
    },
    county_names_all: "Wright",
    county_fips_all: 27171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55302,
    lat: 45.24464,
    lng: -94.11638,
    city: "Annandale",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7393,
    density: 42.1,
    county_fips: 27171,
    county_name: "Wright",
    county_weights: {
      27171: 100,
    },
    county_names_all: "Wright",
    county_fips_all: 27171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55303,
    lat: 45.28872,
    lng: -93.42333,
    city: "Anoka",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49786,
    density: 298.7,
    county_fips: 27003,
    county_name: "Anoka",
    county_weights: {
      27003: 100,
    },
    county_names_all: "Anoka",
    county_fips_all: 27003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55304,
    lat: 45.25583,
    lng: -93.26455,
    city: "Andover",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50177,
    density: 282.3,
    county_fips: 27003,
    county_name: "Anoka",
    county_weights: {
      27003: 100,
    },
    county_names_all: "Anoka",
    county_fips_all: 27003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55305,
    lat: 44.95477,
    lng: -93.43229,
    city: "Hopkins",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21337,
    density: 884.8,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55306,
    lat: 44.73071,
    lng: -93.29195,
    city: "Burnsville",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15824,
    density: 982.3,
    county_fips: 27037,
    county_name: "Dakota",
    county_weights: {
      27037: 100,
    },
    county_names_all: "Dakota",
    county_fips_all: 27037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55307,
    lat: 44.59871,
    lng: -94.10475,
    city: "Arlington",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3441,
    density: 17.9,
    county_fips: 27143,
    county_name: "Sibley",
    county_weights: {
      27143: 100,
    },
    county_names_all: "Sibley",
    county_fips_all: 27143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55308,
    lat: 45.42944,
    lng: -93.83561,
    city: "Becker",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9946,
    density: 63.5,
    county_fips: 27141,
    county_name: "Sherburne",
    county_weights: {
      27141: 100,
    },
    county_names_all: "Sherburne",
    county_fips_all: 27141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55309,
    lat: 45.37758,
    lng: -93.74107,
    city: "Big Lake",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19733,
    density: 122.3,
    county_fips: 27141,
    county_name: "Sherburne",
    county_weights: {
      27141: 100,
    },
    county_names_all: "Sherburne",
    county_fips_all: 27141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55310,
    lat: 44.75599,
    lng: -94.87624,
    city: "Bird Island",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1297,
    density: 5.2,
    county_fips: 27129,
    county_name: "Renville",
    county_weights: {
      27129: 100,
    },
    county_names_all: "Renville",
    county_fips_all: 27129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55311,
    lat: 45.1052,
    lng: -93.49495,
    city: "Maple Grove",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39229,
    density: 922,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55312,
    lat: 44.70853,
    lng: -94.34489,
    city: "Brownton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1448,
    density: 7.6,
    county_fips: 27085,
    county_name: "McLeod",
    county_weights: {
      27085: 99.26,
      27143: 0.74,
    },
    county_names_all: "McLeod|Sibley",
    county_fips_all: "27085|27143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55313,
    lat: 45.17382,
    lng: -93.84859,
    city: "Buffalo",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25150,
    density: 90.1,
    county_fips: 27171,
    county_name: "Wright",
    county_weights: {
      27053: 0.1,
      27171: 99.9,
    },
    county_names_all: "Wright|Hennepin",
    county_fips_all: "27171|27053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55314,
    lat: 44.77214,
    lng: -94.6,
    city: "Buffalo Lake",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1114,
    density: 5.9,
    county_fips: 27129,
    county_name: "Renville",
    county_weights: {
      27129: 75.62,
      27143: 24.38,
    },
    county_names_all: "Renville|Sibley",
    county_fips_all: "27129|27143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55315,
    lat: 44.71731,
    lng: -93.68347,
    city: "Carver",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5932,
    density: 83.5,
    county_fips: 27019,
    county_name: "Carver",
    county_weights: {
      27019: 100,
    },
    county_names_all: "Carver",
    county_fips_all: 27019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55316,
    lat: 45.17021,
    lng: -93.39032,
    city: "Champlin",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24980,
    density: 1183.3,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55317,
    lat: 44.85711,
    lng: -93.55096,
    city: "Chanhassen",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22003,
    density: 646.1,
    county_fips: 27019,
    county_name: "Carver",
    county_weights: {
      27019: 98.36,
      27053: 1.64,
    },
    county_names_all: "Carver|Hennepin",
    county_fips_all: "27019|27053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55318,
    lat: 44.81169,
    lng: -93.63703,
    city: "Chaska",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28959,
    density: 280.1,
    county_fips: 27019,
    county_name: "Carver",
    county_weights: {
      27019: 100,
    },
    county_names_all: "Carver",
    county_fips_all: 27019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55319,
    lat: 45.47181,
    lng: -93.94359,
    city: "Clear Lake",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5567,
    density: 30.1,
    county_fips: 27141,
    county_name: "Sherburne",
    county_weights: {
      27141: 100,
    },
    county_names_all: "Sherburne",
    county_fips_all: 27141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55320,
    lat: 45.39613,
    lng: -94.08366,
    city: "Clearwater",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5755,
    density: 45.6,
    county_fips: 27145,
    county_name: "Stearns",
    county_weights: {
      27145: 58.72,
      27171: 41.28,
    },
    county_names_all: "Stearns|Wright",
    county_fips_all: "27145|27171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55321,
    lat: 45.08406,
    lng: -94.193,
    city: "Cokato",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5238,
    density: 25,
    county_fips: 27171,
    county_name: "Wright",
    county_weights: {
      27171: 100,
    },
    county_names_all: "Wright",
    county_fips_all: 27171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55322,
    lat: 44.77006,
    lng: -93.7861,
    city: "Cologne",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3872,
    density: 26.1,
    county_fips: 27019,
    county_name: "Carver",
    county_weights: {
      27019: 100,
    },
    county_names_all: "Carver",
    county_fips_all: 27019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55324,
    lat: 45.05676,
    lng: -94.42554,
    city: "Darwin",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1085,
    density: 11.9,
    county_fips: 27093,
    county_name: "Meeker",
    county_weights: {
      27093: 100,
    },
    county_names_all: "Meeker",
    county_fips_all: 27093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55325,
    lat: 45.08432,
    lng: -94.32031,
    city: "Dassel",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4757,
    density: 24,
    county_fips: 27093,
    county_name: "Meeker",
    county_weights: {
      27093: 100,
    },
    county_names_all: "Meeker",
    county_fips_all: 27093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55327,
    lat: 45.19922,
    lng: -93.4753,
    city: "Dayton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3925,
    density: 86.3,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55328,
    lat: 45.03246,
    lng: -93.80981,
    city: "Delano",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9626,
    density: 82.8,
    county_fips: 27171,
    county_name: "Wright",
    county_weights: {
      27019: 6.84,
      27053: 6.82,
      27171: 86.34,
    },
    county_names_all: "Wright|Carver|Hennepin",
    county_fips_all: "27171|27019|27053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55329,
    lat: 45.30798,
    lng: -94.57039,
    city: "Eden Valley",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2077,
    density: 15.9,
    county_fips: 27093,
    county_name: "Meeker",
    county_weights: {
      27093: 68.41,
      27145: 31.59,
    },
    county_names_all: "Meeker|Stearns",
    county_fips_all: "27093|27145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55330,
    lat: 45.33359,
    lng: -93.5679,
    city: "Elk River",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39634,
    density: 143.5,
    county_fips: 27141,
    county_name: "Sherburne",
    county_weights: {
      27003: 21.2,
      27141: 62.01,
      27171: 16.79,
    },
    county_names_all: "Sherburne|Anoka|Wright",
    county_fips_all: "27141|27003|27171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55331,
    lat: 44.90124,
    lng: -93.60832,
    city: "Excelsior",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19696,
    density: 466.1,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27019: 28.52,
      27053: 71.48,
    },
    county_names_all: "Hennepin|Carver",
    county_fips_all: "27053|27019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55332,
    lat: 44.51852,
    lng: -94.70761,
    city: "Fairfax",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1761,
    density: 5.9,
    county_fips: 27129,
    county_name: "Renville",
    county_weights: {
      27103: 16.58,
      27129: 81.85,
      27143: 1.57,
    },
    county_names_all: "Renville|Nicollet|Sibley",
    county_fips_all: "27129|27103|27143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55333,
    lat: 44.55987,
    lng: -94.86593,
    city: "Franklin",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 839,
    density: 4.7,
    county_fips: 27129,
    county_name: "Renville",
    county_weights: {
      27015: 4.36,
      27127: 3.9,
      27129: 91.74,
    },
    county_names_all: "Renville|Brown|Redwood",
    county_fips_all: "27129|27015|27127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55334,
    lat: 44.53578,
    lng: -94.20772,
    city: "Gaylord",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2667,
    density: 12.1,
    county_fips: 27143,
    county_name: "Sibley",
    county_weights: {
      27085: 0.68,
      27103: 11.4,
      27143: 87.92,
    },
    county_names_all: "Sibley|Nicollet|McLeod",
    county_fips_all: "27143|27103|27085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55335,
    lat: 44.52969,
    lng: -94.54621,
    city: "Gibbon",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1570,
    density: 5.4,
    county_fips: 27143,
    county_name: "Sibley",
    county_weights: {
      27103: 16.29,
      27143: 83.71,
    },
    county_names_all: "Sibley|Nicollet",
    county_fips_all: "27143|27103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55336,
    lat: 44.76627,
    lng: -94.17803,
    city: "Glencoe",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7930,
    density: 22.5,
    county_fips: 27085,
    county_name: "McLeod",
    county_weights: {
      27085: 79.46,
      27143: 20.54,
    },
    county_names_all: "McLeod|Sibley",
    county_fips_all: "27085|27143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55337,
    lat: 44.77673,
    lng: -93.27491,
    city: "Burnsville",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45659,
    density: 941.9,
    county_fips: 27037,
    county_name: "Dakota",
    county_weights: {
      27037: 100,
    },
    county_names_all: "Dakota",
    county_fips_all: 27037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55338,
    lat: 44.66996,
    lng: -93.99688,
    city: "Green Isle",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1047,
    density: 9.9,
    county_fips: 27143,
    county_name: "Sibley",
    county_weights: {
      27143: 100,
    },
    county_names_all: "Sibley",
    county_fips_all: 27143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55339,
    lat: 44.7289,
    lng: -93.95905,
    city: "Hamburg",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1016,
    density: 17.1,
    county_fips: 27019,
    county_name: "Carver",
    county_weights: {
      27019: 65.35,
      27085: 3.92,
      27143: 30.73,
    },
    county_names_all: "Carver|Sibley|McLeod",
    county_fips_all: "27019|27143|27085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55340,
    lat: 45.07761,
    lng: -93.57508,
    city: "Hamel",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8679,
    density: 94,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55341,
    lat: 45.15917,
    lng: -93.65913,
    city: "Hanover",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3300,
    density: 262.7,
    county_fips: 27171,
    county_name: "Wright",
    county_weights: {
      27053: 42.44,
      27171: 57.56,
    },
    county_names_all: "Wright|Hennepin",
    county_fips_all: "27171|27053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55342,
    lat: 44.74152,
    lng: -94.72982,
    city: "Hector",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1761,
    density: 4.2,
    county_fips: 27129,
    county_name: "Renville",
    county_weights: {
      27093: 0.27,
      27129: 99.73,
    },
    county_names_all: "Renville|Meeker",
    county_fips_all: "27129|27093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55343,
    lat: 44.91433,
    lng: -93.41568,
    city: "Hopkins",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25734,
    density: 1291,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55344,
    lat: 44.86452,
    lng: -93.43037,
    city: "Eden Prairie",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15907,
    density: 693.2,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55345,
    lat: 44.91526,
    lng: -93.4838,
    city: "Minnetonka",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22081,
    density: 750,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55346,
    lat: 44.87882,
    lng: -93.48157,
    city: "Eden Prairie",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17907,
    density: 1022.5,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55347,
    lat: 44.82931,
    lng: -93.46638,
    city: "Eden Prairie",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30667,
    density: 702.2,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55349,
    lat: 45.06238,
    lng: -94.07438,
    city: "Howard Lake",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3723,
    density: 23.1,
    county_fips: 27171,
    county_name: "Wright",
    county_weights: {
      27171: 100,
    },
    county_names_all: "Wright",
    county_fips_all: 27171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55350,
    lat: 44.89743,
    lng: -94.39195,
    city: "Hutchinson",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17938,
    density: 43.3,
    county_fips: 27085,
    county_name: "McLeod",
    county_weights: {
      27085: 86.48,
      27093: 11.43,
      27129: 2.09,
    },
    county_names_all: "McLeod|Meeker|Renville",
    county_fips_all: "27085|27093|27129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55352,
    lat: 44.65505,
    lng: -93.5862,
    city: "Jordan",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9760,
    density: 55.7,
    county_fips: 27139,
    county_name: "Scott",
    county_weights: {
      27139: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 27139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55353,
    lat: 45.32034,
    lng: -94.31607,
    city: "Kimball",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3535,
    density: 16.8,
    county_fips: 27145,
    county_name: "Stearns",
    county_weights: {
      27093: 32.95,
      27145: 67.05,
    },
    county_names_all: "Stearns|Meeker",
    county_fips_all: "27145|27093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55354,
    lat: 44.88466,
    lng: -94.0701,
    city: "Lester Prairie",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2859,
    density: 34,
    county_fips: 27085,
    county_name: "McLeod",
    county_weights: {
      27085: 100,
    },
    county_names_all: "McLeod",
    county_fips_all: 27085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55355,
    lat: 45.09709,
    lng: -94.54017,
    city: "Litchfield",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9581,
    density: 21.5,
    county_fips: 27093,
    county_name: "Meeker",
    county_weights: {
      27093: 100,
    },
    county_names_all: "Meeker",
    county_fips_all: 27093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55356,
    lat: 44.99565,
    lng: -93.58628,
    city: "Long Lake",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6027,
    density: 178.3,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55357,
    lat: 45.09906,
    lng: -93.65913,
    city: "Loretto",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3438,
    density: 68,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55358,
    lat: 45.24637,
    lng: -94.00049,
    city: "Maple Lake",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5031,
    density: 35.6,
    county_fips: 27171,
    county_name: "Wright",
    county_weights: {
      27171: 100,
    },
    county_names_all: "Wright",
    county_fips_all: 27171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55359,
    lat: 45.00464,
    lng: -93.70112,
    city: "Maple Plain",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6601,
    density: 59.7,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55360,
    lat: 44.91331,
    lng: -93.92065,
    city: "Mayer",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3130,
    density: 39.5,
    county_fips: 27019,
    county_name: "Carver",
    county_weights: {
      27019: 100,
    },
    county_names_all: "Carver",
    county_fips_all: 27019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55362,
    lat: 45.30099,
    lng: -93.83563,
    city: "Monticello",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19253,
    density: 113.9,
    county_fips: 27171,
    county_name: "Wright",
    county_weights: {
      27171: 100,
    },
    county_names_all: "Wright",
    county_fips_all: 27171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55363,
    lat: 45.04385,
    lng: -93.91352,
    city: "Montrose",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5240,
    density: 72.2,
    county_fips: 27171,
    county_name: "Wright",
    county_weights: {
      27019: 0.88,
      27171: 99.12,
    },
    county_names_all: "Wright|Carver",
    county_fips_all: "27171|27019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55364,
    lat: 44.93974,
    lng: -93.67486,
    city: "Mound",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14970,
    density: 380.9,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55366,
    lat: 44.67233,
    lng: -94.2346,
    city: "New Auburn",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 484,
    density: 391.3,
    county_fips: 27143,
    county_name: "Sibley",
    county_weights: {
      27143: 100,
    },
    county_names_all: "Sibley",
    county_fips_all: 27143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55367,
    lat: 44.89142,
    lng: -93.97499,
    city: "New Germany",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 941,
    density: 18.8,
    county_fips: 27019,
    county_name: "Carver",
    county_weights: {
      27019: 100,
    },
    county_names_all: "Carver",
    county_fips_all: 27019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55368,
    lat: 44.7458,
    lng: -93.89679,
    city: "Norwood Young America",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2001,
    density: 22.6,
    county_fips: 27019,
    county_name: "Carver",
    county_weights: {
      27019: 100,
    },
    county_names_all: "Carver",
    county_fips_all: 27019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55369,
    lat: 45.12834,
    lng: -93.44837,
    city: "Osseo",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38081,
    density: 594,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55370,
    lat: 44.78077,
    lng: -94.03892,
    city: "Plato",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 617,
    density: 11.5,
    county_fips: 27085,
    county_name: "McLeod",
    county_weights: {
      27085: 100,
    },
    county_names_all: "McLeod",
    county_fips_all: 27085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55371,
    lat: 45.57677,
    lng: -93.59581,
    city: "Princeton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16859,
    density: 33.2,
    county_fips: 27095,
    county_name: "Mille Lacs",
    county_weights: {
      27009: 2.23,
      27059: 27.08,
      27095: 41.02,
      27141: 29.66,
    },
    county_names_all: "Mille Lacs|Sherburne|Isanti|Benton",
    county_fips_all: "27095|27141|27059|27009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55372,
    lat: 44.67791,
    lng: -93.41237,
    city: "Prior Lake",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34188,
    density: 225.6,
    county_fips: 27139,
    county_name: "Scott",
    county_weights: {
      27139: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 27139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55373,
    lat: 45.08779,
    lng: -93.72282,
    city: "Rockford",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5590,
    density: 202.1,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 76.78,
      27171: 23.22,
    },
    county_names_all: "Hennepin|Wright",
    county_fips_all: "27053|27171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55374,
    lat: 45.17715,
    lng: -93.58035,
    city: "Rogers",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15959,
    density: 180,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 95.36,
      27171: 4.64,
    },
    county_names_all: "Hennepin|Wright",
    county_fips_all: "27053|27171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55375,
    lat: 44.89475,
    lng: -93.73129,
    city: "Saint Bonifacius",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4405,
    density: 330.6,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27019: 37.96,
      27053: 62.04,
    },
    county_names_all: "Hennepin|Carver",
    county_fips_all: "27053|27019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55376,
    lat: 45.21161,
    lng: -93.68508,
    city: "Saint Michael",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17793,
    density: 234.9,
    county_fips: 27171,
    county_name: "Wright",
    county_weights: {
      27171: 100,
    },
    county_names_all: "Wright",
    county_fips_all: 27171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55378,
    lat: 44.75685,
    lng: -93.36209,
    city: "Savage",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31829,
    density: 858,
    county_fips: 27139,
    county_name: "Scott",
    county_weights: {
      27139: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 27139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55379,
    lat: 44.75492,
    lng: -93.51713,
    city: "Shakopee",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45001,
    density: 300.2,
    county_fips: 27139,
    county_name: "Scott",
    county_weights: {
      27139: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 27139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55381,
    lat: 44.92763,
    lng: -94.18623,
    city: "Silver Lake",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1987,
    density: 17.4,
    county_fips: 27085,
    county_name: "McLeod",
    county_weights: {
      27085: 100,
    },
    county_names_all: "McLeod",
    county_fips_all: 27085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55382,
    lat: 45.30521,
    lng: -94.20438,
    city: "South Haven",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3455,
    density: 17.5,
    county_fips: 27145,
    county_name: "Stearns",
    county_weights: {
      27093: 12.92,
      27145: 49.45,
      27171: 37.63,
    },
    county_names_all: "Stearns|Wright|Meeker",
    county_fips_all: "27145|27171|27093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55384,
    lat: 44.9364,
    lng: -93.63201,
    city: "Spring Park",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2136,
    density: 2336,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55385,
    lat: 44.73732,
    lng: -94.49281,
    city: "Stewart",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1300,
    density: 5.1,
    county_fips: 27085,
    county_name: "McLeod",
    county_weights: {
      27085: 52.68,
      27129: 29.24,
      27143: 18.08,
    },
    county_names_all: "McLeod|Renville|Sibley",
    county_fips_all: "27085|27129|27143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55386,
    lat: 44.85686,
    lng: -93.66435,
    city: "Victoria",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8211,
    density: 495.7,
    county_fips: 27019,
    county_name: "Carver",
    county_weights: {
      27019: 100,
    },
    county_names_all: "Carver",
    county_fips_all: 27019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55387,
    lat: 44.85643,
    lng: -93.77903,
    city: "Waconia",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13501,
    density: 165.3,
    county_fips: 27019,
    county_name: "Carver",
    county_weights: {
      27019: 99.36,
      27053: 0.64,
    },
    county_names_all: "Carver|Hennepin",
    county_fips_all: "27019|27053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55388,
    lat: 44.95,
    lng: -93.84729,
    city: "Watertown",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5955,
    density: 61.1,
    county_fips: 27019,
    county_name: "Carver",
    county_weights: {
      27019: 80.01,
      27053: 4.84,
      27171: 15.15,
    },
    county_names_all: "Carver|Wright|Hennepin",
    county_fips_all: "27019|27171|27053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55389,
    lat: 45.2998,
    lng: -94.43748,
    city: "Watkins",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2571,
    density: 13.3,
    county_fips: 27093,
    county_name: "Meeker",
    county_weights: {
      27093: 62.98,
      27145: 37.02,
    },
    county_names_all: "Meeker|Stearns",
    county_fips_all: "27093|27145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55390,
    lat: 45.06812,
    lng: -93.97912,
    city: "Waverly",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2692,
    density: 28.2,
    county_fips: 27171,
    county_name: "Wright",
    county_weights: {
      27171: 100,
    },
    county_names_all: "Wright",
    county_fips_all: 27171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55391,
    lat: 44.96009,
    lng: -93.54225,
    city: "Wayzata",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15730,
    density: 367.6,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55395,
    lat: 44.9572,
    lng: -94.06085,
    city: "Winsted",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2595,
    density: 41.9,
    county_fips: 27085,
    county_name: "McLeod",
    county_weights: {
      27019: 11.12,
      27085: 76.98,
      27171: 11.9,
    },
    county_names_all: "McLeod|Wright|Carver",
    county_fips_all: "27085|27171|27019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55396,
    lat: 44.54473,
    lng: -94.36755,
    city: "Winthrop",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2175,
    density: 7.8,
    county_fips: 27143,
    county_name: "Sibley",
    county_weights: {
      27085: 0.82,
      27143: 99.18,
    },
    county_names_all: "Sibley|McLeod",
    county_fips_all: "27143|27085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55397,
    lat: 44.81712,
    lng: -93.93452,
    city: "Young America",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3020,
    density: 41.2,
    county_fips: 27019,
    county_name: "Carver",
    county_weights: {
      27019: 96.67,
      27085: 3.33,
    },
    county_names_all: "Carver|McLeod",
    county_fips_all: "27019|27085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55398,
    lat: 45.45787,
    lng: -93.5903,
    city: "Zimmerman",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17039,
    density: 90,
    county_fips: 27141,
    county_name: "Sherburne",
    county_weights: {
      27059: 17.36,
      27141: 82.64,
    },
    county_names_all: "Sherburne|Isanti",
    county_fips_all: "27141|27059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55401,
    lat: 44.98526,
    lng: -93.26984,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10942,
    density: 5339.2,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55402,
    lat: 44.97608,
    lng: -93.27119,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 514,
    density: 1177,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55403,
    lat: 44.97023,
    lng: -93.28588,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16437,
    density: 4670.6,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55404,
    lat: 44.9619,
    lng: -93.26145,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28586,
    density: 6112.5,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55405,
    lat: 44.97034,
    lng: -93.30461,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16277,
    density: 2218,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55406,
    lat: 44.93932,
    lng: -93.22071,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33709,
    density: 2600.4,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55407,
    lat: 44.93484,
    lng: -93.25263,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40792,
    density: 3923.4,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55408,
    lat: 44.94364,
    lng: -93.2937,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32276,
    density: 4638,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55409,
    lat: 44.93018,
    lng: -93.28146,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11631,
    density: 3432.7,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55410,
    lat: 44.91364,
    lng: -93.31725,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20087,
    density: 2526.5,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55411,
    lat: 44.9993,
    lng: -93.2979,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31685,
    density: 3037.3,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55412,
    lat: 45.02612,
    lng: -93.29952,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24402,
    density: 2765.8,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55413,
    lat: 44.99826,
    lng: -93.24276,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14769,
    density: 1817.7,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55414,
    lat: 44.97915,
    lng: -93.2259,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36017,
    density: 4452.1,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55415,
    lat: 44.97463,
    lng: -93.2578,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5177,
    density: 4562.3,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55416,
    lat: 44.94961,
    lng: -93.34157,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32956,
    density: 1734.5,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55417,
    lat: 44.9059,
    lng: -93.23534,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26035,
    density: 2275.2,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55418,
    lat: 45.0208,
    lng: -93.24244,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30209,
    density: 1669,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 99.84,
      27123: 0.16,
    },
    county_names_all: "Hennepin|Ramsey",
    county_fips_all: "27053|27123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55419,
    lat: 44.90586,
    lng: -93.28743,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28792,
    density: 2647.9,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55420,
    lat: 44.83564,
    lng: -93.27745,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22215,
    density: 1288.1,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55421,
    lat: 45.05083,
    lng: -93.25249,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28784,
    density: 1772,
    county_fips: 27003,
    county_name: "Anoka",
    county_weights: {
      27003: 91.19,
      27053: 0.41,
      27123: 8.4,
    },
    county_names_all: "Anoka|Ramsey|Hennepin",
    county_fips_all: "27003|27123|27053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55422,
    lat: 45.00922,
    lng: -93.33941,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28967,
    density: 1318.7,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55423,
    lat: 44.87663,
    lng: -93.28144,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36311,
    density: 1984.2,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55424,
    lat: 44.90509,
    lng: -93.33978,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10383,
    density: 1662.6,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55425,
    lat: 44.84249,
    lng: -93.23601,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10260,
    density: 873.2,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55426,
    lat: 44.95635,
    lng: -93.38139,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26110,
    density: 1522.1,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55427,
    lat: 45.00665,
    lng: -93.38031,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24017,
    density: 1280.8,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55428,
    lat: 45.06354,
    lng: -93.38094,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32251,
    density: 1536.2,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55429,
    lat: 45.06443,
    lng: -93.34105,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28257,
    density: 1813.5,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55430,
    lat: 45.0632,
    lng: -93.30148,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22324,
    density: 1467.4,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55431,
    lat: 44.82607,
    lng: -93.31195,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18478,
    density: 911.7,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55432,
    lat: 45.09693,
    lng: -93.25466,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30401,
    density: 1188.3,
    county_fips: 27003,
    county_name: "Anoka",
    county_weights: {
      27003: 99.49,
      27123: 0.51,
    },
    county_names_all: "Anoka|Ramsey",
    county_fips_all: "27003|27123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55433,
    lat: 45.16132,
    lng: -93.31638,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34461,
    density: 1143.4,
    county_fips: 27003,
    county_name: "Anoka",
    county_weights: {
      27003: 100,
    },
    county_names_all: "Anoka",
    county_fips_all: 27003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55434,
    lat: 45.1681,
    lng: -93.25069,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31267,
    density: 1353,
    county_fips: 27003,
    county_name: "Anoka",
    county_weights: {
      27003: 100,
    },
    county_names_all: "Anoka",
    county_fips_all: 27003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55435,
    lat: 44.87343,
    lng: -93.3347,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13771,
    density: 1788.2,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55436,
    lat: 44.90345,
    lng: -93.37409,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13718,
    density: 1129.3,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55437,
    lat: 44.82434,
    lng: -93.34488,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17845,
    density: 1022.8,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55438,
    lat: 44.82489,
    lng: -93.37826,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16428,
    density: 764.7,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55439,
    lat: 44.87452,
    lng: -93.37475,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9416,
    density: 771.7,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55441,
    lat: 45.00475,
    lng: -93.42845,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18725,
    density: 842.6,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55442,
    lat: 45.04856,
    lng: -93.4269,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12681,
    density: 924.4,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55443,
    lat: 45.11894,
    lng: -93.33802,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30978,
    density: 1320.9,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55444,
    lat: 45.10747,
    lng: -93.30234,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15381,
    density: 1283.1,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27003: 0.1,
      27053: 99.9,
    },
    county_names_all: "Hennepin|Anoka",
    county_fips_all: "27053|27003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55445,
    lat: 45.12317,
    lng: -93.3798,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13030,
    density: 641.5,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55446,
    lat: 45.04427,
    lng: -93.4878,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26616,
    density: 1019.9,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55447,
    lat: 45.00132,
    lng: -93.48888,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21332,
    density: 922.2,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55448,
    lat: 45.1908,
    lng: -93.30209,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28258,
    density: 1007.8,
    county_fips: 27003,
    county_name: "Anoka",
    county_weights: {
      27003: 100,
    },
    county_names_all: "Anoka",
    county_fips_all: 27003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55449,
    lat: 45.17284,
    lng: -93.1953,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28947,
    density: 521.2,
    county_fips: 27003,
    county_name: "Anoka",
    county_weights: {
      27003: 99.16,
      27123: 0.84,
    },
    county_names_all: "Anoka|Ramsey",
    county_fips_all: "27003|27123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55450,
    lat: 44.87901,
    lng: -93.22549,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7,
    density: 0.6,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55454,
    lat: 44.97075,
    lng: -93.24381,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9798,
    density: 6355.8,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55455,
    lat: 44.97453,
    lng: -93.23432,
    city: "Minneapolis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1077,
    density: 772.7,
    county_fips: 27053,
    county_name: "Hennepin",
    county_weights: {
      27053: 100,
    },
    county_names_all: "Hennepin",
    county_fips_all: 27053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55601,
    lat: 47.23404,
    lng: -91.36425,
    city: "Beaver Bay",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 114,
    density: 2.9,
    county_fips: 27075,
    county_name: "Lake",
    county_weights: {
      27075: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 27075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55602,
    lat: 47.33207,
    lng: -91.91047,
    city: "Brimson",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 255,
    density: 0.4,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27075: 7.58,
      27137: 92.42,
    },
    county_names_all: "St. Louis|Lake",
    county_fips_all: "27137|27075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55603,
    lat: 47.5441,
    lng: -91.19441,
    city: "Finland",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 443,
    density: 0.6,
    county_fips: 27075,
    county_name: "Lake",
    county_weights: {
      27075: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 27075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55604,
    lat: 47.96201,
    lng: -90.55792,
    city: "Grand Marais",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3515,
    density: 1.7,
    county_fips: 27031,
    county_name: "Cook",
    county_weights: {
      27031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 27031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55605,
    lat: 47.96242,
    lng: -89.75529,
    city: "Grand Portage",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 722,
    density: 3.8,
    county_fips: 27031,
    county_name: "Cook",
    county_weights: {
      27031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 27031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55606,
    lat: 47.96785,
    lng: -90.02818,
    city: "Hovland",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 201,
    density: 0.5,
    county_fips: 27031,
    county_name: "Cook",
    county_weights: {
      27031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 27031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55607,
    lat: 47.63363,
    lng: -91.51106,
    city: "Isabella",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 212,
    density: 0.3,
    county_fips: 27075,
    county_name: "Lake",
    county_weights: {
      27075: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 27075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55609,
    lat: 46.9636,
    lng: -91.78554,
    city: "Knife River",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 163,
    density: 25.2,
    county_fips: 27075,
    county_name: "Lake",
    county_weights: {
      27075: 99.63,
      27137: 0.37,
    },
    county_names_all: "Lake|St. Louis",
    county_fips_all: "27075|27137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55612,
    lat: 47.77937,
    lng: -90.70401,
    city: "Lutsen",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 483,
    density: 1.1,
    county_fips: 27031,
    county_name: "Cook",
    county_weights: {
      27031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 27031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55613,
    lat: 47.57023,
    lng: -90.97293,
    city: "Schroeder",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 213,
    density: 1.5,
    county_fips: 27031,
    county_name: "Cook",
    county_weights: {
      27031: 99.86,
      27075: 0.14,
    },
    county_names_all: "Cook|Lake",
    county_fips_all: "27031|27075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55614,
    lat: 47.36412,
    lng: -91.40387,
    city: "Silver Bay",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2165,
    density: 3.8,
    county_fips: 27075,
    county_name: "Lake",
    county_weights: {
      27075: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 27075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55615,
    lat: 47.74561,
    lng: -90.87695,
    city: "Tofte",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 268,
    density: 0.5,
    county_fips: 27031,
    county_name: "Cook",
    county_weights: {
      27031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 27031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55616,
    lat: 47.25095,
    lng: -91.66982,
    city: "Two Harbors",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7027,
    density: 5.7,
    county_fips: 27075,
    county_name: "Lake",
    county_weights: {
      27075: 91.1,
      27137: 8.9,
    },
    county_names_all: "Lake|St. Louis",
    county_fips_all: "27075|27137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55702,
    lat: 46.97121,
    lng: -92.6448,
    city: "Alborn",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 518,
    density: 4,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55703,
    lat: 47.73932,
    lng: -92.78119,
    city: "Angora",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1423,
    density: 3.7,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55704,
    lat: 46.2057,
    lng: -92.76581,
    city: "Askov",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1042,
    density: 7.4,
    county_fips: 27115,
    county_name: "Pine",
    county_weights: {
      27115: 100,
    },
    county_names_all: "Pine",
    county_fips_all: 27115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55705,
    lat: 47.46789,
    lng: -92.24446,
    city: "Aurora",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3294,
    density: 15.2,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55706,
    lat: 47.67432,
    lng: -91.95261,
    city: "Babbitt",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1615,
    density: 4.6,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55707,
    lat: 46.55076,
    lng: -92.64655,
    city: "Barnum",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3670,
    density: 9.1,
    county_fips: 27017,
    county_name: "Carlton",
    county_weights: {
      27017: 100,
    },
    county_names_all: "Carlton",
    county_fips_all: 27017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55708,
    lat: 47.53527,
    lng: -92.34766,
    city: "Biwabik",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 629,
    density: 50.2,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55709,
    lat: 47.40431,
    lng: -93.3804,
    city: "Bovey",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4120,
    density: 7.1,
    county_fips: 27061,
    county_name: "Itasca",
    county_weights: {
      27061: 100,
    },
    county_names_all: "Itasca",
    county_fips_all: 27061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55710,
    lat: 47.64542,
    lng: -92.69457,
    city: "Britt",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1142,
    density: 5.1,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55711,
    lat: 46.84066,
    lng: -92.69498,
    city: "Brookston",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 547,
    density: 2.7,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55712,
    lat: 46.29398,
    lng: -92.52513,
    city: "Bruno",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 702,
    density: 1.7,
    county_fips: 27115,
    county_name: "Pine",
    county_weights: {
      27115: 100,
    },
    county_names_all: "Pine",
    county_fips_all: 27115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55713,
    lat: 47.4894,
    lng: -92.76583,
    city: "Buhl",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1137,
    density: 59.2,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55716,
    lat: 47.32169,
    lng: -93.26432,
    city: "Calumet",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 312,
    density: 94.8,
    county_fips: 27061,
    county_name: "Itasca",
    county_weights: {
      27061: 100,
    },
    county_names_all: "Itasca",
    county_fips_all: 27061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55717,
    lat: 47.05026,
    lng: -92.38642,
    city: "Canyon",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 429,
    density: 1.4,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55718,
    lat: 46.6249,
    lng: -92.48505,
    city: "Carlton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3267,
    density: 20.9,
    county_fips: 27017,
    county_name: "Carlton",
    county_weights: {
      27017: 100,
    },
    county_names_all: "Carlton",
    county_fips_all: 27017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55719,
    lat: 47.55408,
    lng: -92.85807,
    city: "Chisholm",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5792,
    density: 26.5,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55720,
    lat: 46.75138,
    lng: -92.5399,
    city: "Cloquet",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17131,
    density: 42.3,
    county_fips: 27017,
    county_name: "Carlton",
    county_weights: {
      27017: 58.59,
      27137: 41.41,
    },
    county_names_all: "Carlton|St. Louis",
    county_fips_all: "27017|27137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55721,
    lat: 47.21837,
    lng: -93.68841,
    city: "Cohasset",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3558,
    density: 14.7,
    county_fips: 27061,
    county_name: "Itasca",
    county_weights: {
      27061: 100,
    },
    county_names_all: "Itasca",
    county_fips_all: 27061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55722,
    lat: 47.28253,
    lng: -93.4338,
    city: "Coleraine",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 902,
    density: 285,
    county_fips: 27061,
    county_name: "Itasca",
    county_weights: {
      27061: 100,
    },
    county_names_all: "Itasca",
    county_fips_all: 27061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55723,
    lat: 47.83764,
    lng: -92.86715,
    city: "Cook",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1901,
    density: 1.9,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27061: 26.71,
      27137: 73.29,
    },
    county_names_all: "St. Louis|Itasca",
    county_fips_all: "27137|27061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55724,
    lat: 47.17874,
    lng: -92.37277,
    city: "Cotton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 763,
    density: 1.2,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55725,
    lat: 48.33849,
    lng: -92.5811,
    city: "Crane Lake",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 99,
    density: 0.3,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55726,
    lat: 46.67027,
    lng: -92.83209,
    city: "Cromwell",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1059,
    density: 4.6,
    county_fips: 27017,
    county_name: "Carlton",
    county_weights: {
      27017: 100,
    },
    county_names_all: "Carlton",
    county_fips_all: 27017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55731,
    lat: 47.98832,
    lng: -91.7489,
    city: "Ely",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5770,
    density: 1.4,
    county_fips: 27075,
    county_name: "Lake",
    county_weights: {
      27075: 51.07,
      27137: 48.93,
    },
    county_names_all: "Lake|St. Louis",
    county_fips_all: "27075|27137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55732,
    lat: 47.6791,
    lng: -92.22125,
    city: "Embarrass",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1352,
    density: 2.5,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55733,
    lat: 46.71141,
    lng: -92.36297,
    city: "Esko",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5032,
    density: 55,
    county_fips: 27017,
    county_name: "Carlton",
    county_weights: {
      27017: 99.22,
      27137: 0.78,
    },
    county_names_all: "Carlton|St. Louis",
    county_fips_all: "27017|27137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55734,
    lat: 47.38274,
    lng: -92.4938,
    city: "Eveleth",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6234,
    density: 30.8,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55735,
    lat: 46.21756,
    lng: -93.01688,
    city: "Finlayson",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1744,
    density: 5.4,
    county_fips: 27115,
    county_name: "Pine",
    county_weights: {
      27001: 33.88,
      27115: 66.12,
    },
    county_names_all: "Pine|Aitkin",
    county_fips_all: "27115|27001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55736,
    lat: 46.97542,
    lng: -92.92136,
    city: "Floodwood",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1340,
    density: 1.5,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27061: 7.06,
      27137: 92.94,
    },
    county_names_all: "St. Louis|Itasca",
    county_fips_all: "27137|27061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55738,
    lat: 47.27342,
    lng: -92.65826,
    city: "Forbes",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 558,
    density: 1.8,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55741,
    lat: 47.4582,
    lng: -92.38683,
    city: "Gilbert",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3453,
    density: 19.1,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55742,
    lat: 47.17195,
    lng: -93.14076,
    city: "Goodland",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 269,
    density: 2.8,
    county_fips: 27061,
    county_name: "Itasca",
    county_weights: {
      27061: 100,
    },
    county_names_all: "Itasca",
    county_fips_all: 27061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55744,
    lat: 47.23306,
    lng: -93.51299,
    city: "Grand Rapids",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20142,
    density: 32.5,
    county_fips: 27061,
    county_name: "Itasca",
    county_weights: {
      27061: 100,
    },
    county_names_all: "Itasca",
    county_fips_all: 27061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55746,
    lat: 47.35766,
    lng: -92.95698,
    city: "Hibbing",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16735,
    density: 18.6,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27061: 7.54,
      27137: 92.46,
    },
    county_names_all: "St. Louis|Itasca",
    county_fips_all: "27137|27061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55748,
    lat: 46.99372,
    lng: -93.59693,
    city: "Hill City",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1462,
    density: 3.7,
    county_fips: 27001,
    county_name: "Aitkin",
    county_weights: {
      27001: 64.64,
      27061: 35.36,
    },
    county_names_all: "Aitkin|Itasca",
    county_fips_all: "27001|27061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55749,
    lat: 46.44701,
    lng: -92.43128,
    city: "Holyoke",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 414,
    density: 1.8,
    county_fips: 27017,
    county_name: "Carlton",
    county_weights: {
      27017: 80.17,
      27115: 19.83,
    },
    county_names_all: "Carlton|Pine",
    county_fips_all: "27017|27115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55750,
    lat: 47.53251,
    lng: -91.99517,
    city: "Hoyt Lakes",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2106,
    density: 4.6,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55751,
    lat: 47.39283,
    lng: -92.66815,
    city: "Iron",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1604,
    density: 10.3,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55752,
    lat: 46.95494,
    lng: -93.25323,
    city: "Jacobson",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 369,
    density: 0.8,
    county_fips: 27001,
    county_name: "Aitkin",
    county_weights: {
      27001: 98.19,
      27061: 1.64,
      27137: 0.17,
    },
    county_names_all: "Aitkin|Itasca|St. Louis",
    county_fips_all: "27001|27061|27137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55753,
    lat: 47.39692,
    lng: -93.07991,
    city: "Keewatin",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1173,
    density: 514.6,
    county_fips: 27061,
    county_name: "Itasca",
    county_weights: {
      27061: 100,
    },
    county_names_all: "Itasca",
    county_fips_all: 27061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55756,
    lat: 46.37535,
    lng: -92.60128,
    city: "Kerrick",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 331,
    density: 2.8,
    county_fips: 27115,
    county_name: "Pine",
    county_weights: {
      27017: 14.64,
      27115: 85.36,
    },
    county_names_all: "Pine|Carlton",
    county_fips_all: "27115|27017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55757,
    lat: 46.51594,
    lng: -92.93475,
    city: "Kettle River",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 690,
    density: 2.6,
    county_fips: 27017,
    county_name: "Carlton",
    county_weights: {
      27017: 100,
    },
    county_names_all: "Carlton",
    county_fips_all: 27017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55758,
    lat: 47.50823,
    lng: -92.72141,
    city: "Kinney",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 192,
    density: 44,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55760,
    lat: 46.62491,
    lng: -93.27049,
    city: "Mcgregor",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2889,
    density: 3.7,
    county_fips: 27001,
    county_name: "Aitkin",
    county_weights: {
      27001: 100,
    },
    county_names_all: "Aitkin",
    county_fips_all: 27001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55763,
    lat: 47.33127,
    lng: -92.22262,
    city: "Makinen",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 569,
    density: 1.4,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55764,
    lat: 47.33041,
    lng: -93.29298,
    city: "Marble",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 500,
    density: 52.1,
    county_fips: 27061,
    county_name: "Itasca",
    county_weights: {
      27061: 100,
    },
    county_names_all: "Itasca",
    county_fips_all: 27061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55765,
    lat: 47.10057,
    lng: -92.74545,
    city: "Meadowlands",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 820,
    density: 2.2,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55767,
    lat: 46.45236,
    lng: -92.76536,
    city: "Moose Lake",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4297,
    density: 29.4,
    county_fips: 27017,
    county_name: "Carlton",
    county_weights: {
      27017: 95.83,
      27115: 4.17,
    },
    county_names_all: "Carlton|Pine",
    county_fips_all: "27017|27115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55768,
    lat: 47.51444,
    lng: -92.67263,
    city: "Mountain Iron",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2745,
    density: 11.9,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55769,
    lat: 47.47994,
    lng: -93.18579,
    city: "Nashwauk",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2373,
    density: 5.2,
    county_fips: 27061,
    county_name: "Itasca",
    county_weights: {
      27061: 100,
    },
    county_names_all: "Itasca",
    county_fips_all: 27061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55771,
    lat: 48.12398,
    lng: -92.93101,
    city: "Orr",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1500,
    density: 0.5,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27071: 27.57,
      27137: 72.43,
    },
    county_names_all: "St. Louis|Koochiching",
    county_fips_all: "27137|27071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55772,
    lat: 48.11019,
    lng: -93.10032,
    city: "Nett Lake",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 89,
    density: 167.1,
    county_fips: 27071,
    county_name: "Koochiching",
    county_weights: {
      27071: 94.45,
      27137: 5.55,
    },
    county_names_all: "Koochiching|St. Louis",
    county_fips_all: "27071|27137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55775,
    lat: 47.30588,
    lng: -93.1646,
    city: "Pengilly",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1593,
    density: 9.9,
    county_fips: 27061,
    county_name: "Itasca",
    county_weights: {
      27061: 100,
    },
    county_names_all: "Itasca",
    county_fips_all: 27061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55779,
    lat: 46.90915,
    lng: -92.4548,
    city: "Saginaw",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3913,
    density: 12.2,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55780,
    lat: 46.67505,
    lng: -92.68321,
    city: "Sawyer",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 176,
    density: 3.6,
    county_fips: 27017,
    county_name: "Carlton",
    county_weights: {
      27017: 100,
    },
    county_names_all: "Carlton",
    county_fips_all: 27017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55781,
    lat: 47.67587,
    lng: -93.06524,
    city: "Side Lake",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 778,
    density: 3.7,
    county_fips: 27061,
    county_name: "Itasca",
    county_weights: {
      27061: 54.03,
      27137: 45.97,
    },
    county_names_all: "Itasca|St. Louis",
    county_fips_all: "27061|27137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55782,
    lat: 47.82314,
    lng: -92.20524,
    city: "Soudan",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 493,
    density: 17.7,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55783,
    lat: 46.40836,
    lng: -92.92625,
    city: "Sturgeon Lake",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2330,
    density: 6.5,
    county_fips: 27115,
    county_name: "Pine",
    county_weights: {
      27001: 26.07,
      27017: 11.76,
      27115: 62.17,
    },
    county_names_all: "Pine|Aitkin|Carlton",
    county_fips_all: "27115|27001|27017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55784,
    lat: 47.05306,
    lng: -93.18769,
    city: "Swan River",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 101,
    density: 1.5,
    county_fips: 27061,
    county_name: "Itasca",
    county_weights: {
      27061: 100,
    },
    county_names_all: "Itasca",
    county_fips_all: 27061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55785,
    lat: 46.92332,
    lng: -93.74591,
    city: "Swatara",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 256,
    density: 0.9,
    county_fips: 27001,
    county_name: "Aitkin",
    county_weights: {
      27001: 74.15,
      27021: 25.85,
    },
    county_names_all: "Aitkin|Cass",
    county_fips_all: "27001|27021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55786,
    lat: 47.31916,
    lng: -93.38227,
    city: "Taconite",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 308,
    density: 46.7,
    county_fips: 27061,
    county_name: "Itasca",
    county_weights: {
      27061: 100,
    },
    county_names_all: "Itasca",
    county_fips_all: 27061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55787,
    lat: 46.73707,
    lng: -93.11756,
    city: "Tamarack",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 628,
    density: 1.8,
    county_fips: 27001,
    county_name: "Aitkin",
    county_weights: {
      27001: 88.38,
      27017: 11.52,
      27137: 0.1,
    },
    county_names_all: "Aitkin|Carlton|St. Louis",
    county_fips_all: "27001|27017|27137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55790,
    lat: 47.8288,
    lng: -92.37596,
    city: "Tower",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2086,
    density: 5.6,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55792,
    lat: 47.60027,
    lng: -92.48261,
    city: "Virginia",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9689,
    density: 39.1,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55793,
    lat: 47.11585,
    lng: -93.28442,
    city: "Warba",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 742,
    density: 3.6,
    county_fips: 27061,
    county_name: "Itasca",
    county_weights: {
      27061: 100,
    },
    county_names_all: "Itasca",
    county_fips_all: 27061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55795,
    lat: 46.31337,
    lng: -92.87031,
    city: "Willow River",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1903,
    density: 8.5,
    county_fips: 27115,
    county_name: "Pine",
    county_weights: {
      27115: 100,
    },
    county_names_all: "Pine",
    county_fips_all: 27115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55796,
    lat: 47.92905,
    lng: -91.79732,
    city: "Winton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 27075,
    county_name: "Lake",
    county_weights: {
      27075: 56.68,
      27137: 43.32,
    },
    county_names_all: "Lake|St. Louis",
    county_fips_all: "27075|27137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55797,
    lat: 46.56978,
    lng: -92.36431,
    city: "Wrenshall",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1588,
    density: 9.3,
    county_fips: 27017,
    county_name: "Carlton",
    county_weights: {
      27017: 100,
    },
    county_names_all: "Carlton",
    county_fips_all: 27017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55798,
    lat: 46.72138,
    lng: -92.97907,
    city: "Wright",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 602,
    density: 2.2,
    county_fips: 27017,
    county_name: "Carlton",
    county_weights: {
      27001: 9.82,
      27017: 72.16,
      27137: 18.02,
    },
    county_names_all: "Carlton|St. Louis|Aitkin",
    county_fips_all: "27017|27137|27001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55802,
    lat: 46.75267,
    lng: -92.08197,
    city: "Duluth",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2492,
    density: 371.5,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55803,
    lat: 47.03398,
    lng: -92.07104,
    city: "Duluth",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17804,
    density: 23.3,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55804,
    lat: 46.9381,
    lng: -91.93089,
    city: "Duluth",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15416,
    density: 63.3,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55805,
    lat: 46.80065,
    lng: -92.09552,
    city: "Duluth",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9563,
    density: 2558.2,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55806,
    lat: 46.76826,
    lng: -92.12835,
    city: "Duluth",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8821,
    density: 995.2,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55807,
    lat: 46.73508,
    lng: -92.1686,
    city: "Duluth",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9019,
    density: 601.5,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55808,
    lat: 46.6792,
    lng: -92.23686,
    city: "Duluth",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5746,
    density: 184.5,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55810,
    lat: 46.75894,
    lng: -92.27445,
    city: "Duluth",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8318,
    density: 67.9,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27017: 6.05,
      27137: 93.95,
    },
    county_names_all: "St. Louis|Carlton",
    county_fips_all: "27137|27017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55811,
    lat: 46.83767,
    lng: -92.21993,
    city: "Duluth",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28146,
    density: 168.5,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55812,
    lat: 46.81236,
    lng: -92.07564,
    city: "Duluth",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10984,
    density: 2190.8,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55814,
    lat: 46.83519,
    lng: -92.19716,
    city: "Duluth",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 526,
    density: 2602,
    county_fips: 27137,
    county_name: "St. Louis",
    county_weights: {
      27137: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 27137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55901,
    lat: 44.07679,
    lng: -92.5018,
    city: "Rochester",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56879,
    density: 663.9,
    county_fips: 27109,
    county_name: "Olmsted",
    county_weights: {
      27109: 100,
    },
    county_names_all: "Olmsted",
    county_fips_all: 27109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55902,
    lat: 43.9671,
    lng: -92.51584,
    city: "Rochester",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25063,
    density: 235.2,
    county_fips: 27109,
    county_name: "Olmsted",
    county_weights: {
      27109: 100,
    },
    county_names_all: "Olmsted",
    county_fips_all: 27109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55903,
    lat: 44.02391,
    lng: -92.43657,
    city: "Rochester",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 27109,
    county_name: "Olmsted",
    county_weights: {
      27109: 100,
    },
    county_names_all: "Olmsted",
    county_fips_all: 27109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55904,
    lat: 43.96204,
    lng: -92.39931,
    city: "Rochester",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27293,
    density: 175.3,
    county_fips: 27109,
    county_name: "Olmsted",
    county_weights: {
      27109: 100,
    },
    county_names_all: "Olmsted",
    county_fips_all: 27109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55905,
    lat: 44.05595,
    lng: -92.52589,
    city: "Rochester",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 27109,
    county_name: "Olmsted",
    county_weights: {
      27109: 100,
    },
    county_names_all: "Olmsted",
    county_fips_all: 27109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55906,
    lat: 44.10751,
    lng: -92.40142,
    city: "Rochester",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19616,
    density: 123.2,
    county_fips: 27109,
    county_name: "Olmsted",
    county_weights: {
      27109: 91.93,
      27157: 8.07,
    },
    county_names_all: "Olmsted|Wabasha",
    county_fips_all: "27109|27157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55909,
    lat: 43.56312,
    lng: -92.73461,
    city: "Adams",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1508,
    density: 11.1,
    county_fips: 27099,
    county_name: "Mower",
    county_weights: {
      27099: 100,
    },
    county_names_all: "Mower",
    county_fips_all: 27099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55910,
    lat: 44.13285,
    lng: -91.97285,
    city: "Altura",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1260,
    density: 5.5,
    county_fips: 27169,
    county_name: "Winona",
    county_weights: {
      27157: 12.38,
      27169: 87.62,
    },
    county_names_all: "Winona|Wabasha",
    county_fips_all: "27169|27157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55912,
    lat: 43.6827,
    lng: -92.99148,
    city: "Austin",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28658,
    density: 58.9,
    county_fips: 27099,
    county_name: "Mower",
    county_weights: {
      27047: 24.35,
      27099: 75.65,
    },
    county_names_all: "Mower|Freeborn",
    county_fips_all: "27099|27047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55917,
    lat: 43.88164,
    lng: -93.0716,
    city: "Blooming Prairie",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3626,
    density: 10.5,
    county_fips: 27147,
    county_name: "Steele",
    county_weights: {
      27039: 27.51,
      27047: 15.98,
      27099: 12.17,
      27147: 44.34,
    },
    county_names_all: "Steele|Dodge|Freeborn|Mower",
    county_fips_all: "27147|27039|27047|27099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55918,
    lat: 43.74236,
    lng: -92.84673,
    city: "Brownsdale",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 926,
    density: 12.7,
    county_fips: 27099,
    county_name: "Mower",
    county_weights: {
      27099: 100,
    },
    county_names_all: "Mower",
    county_fips_all: 27099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55919,
    lat: 43.61443,
    lng: -91.2941,
    city: "Brownsville",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1070,
    density: 9.2,
    county_fips: 27055,
    county_name: "Houston",
    county_weights: {
      27055: 100,
    },
    county_names_all: "Houston",
    county_fips_all: 27055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55920,
    lat: 44.01246,
    lng: -92.62111,
    city: "Byron",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7555,
    density: 42.4,
    county_fips: 27109,
    county_name: "Olmsted",
    county_weights: {
      27109: 100,
    },
    county_names_all: "Olmsted",
    county_fips_all: 27109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55921,
    lat: 43.62265,
    lng: -91.46388,
    city: "Caledonia",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4649,
    density: 10.2,
    county_fips: 27055,
    county_name: "Houston",
    county_weights: {
      27055: 100,
    },
    county_names_all: "Houston",
    county_fips_all: 27055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55922,
    lat: 43.5621,
    lng: -91.89562,
    city: "Canton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1196,
    density: 14.1,
    county_fips: 27045,
    county_name: "Fillmore",
    county_weights: {
      27045: 100,
    },
    county_names_all: "Fillmore",
    county_fips_all: 27045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55923,
    lat: 43.8494,
    lng: -92.18315,
    city: "Chatfield",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4268,
    density: 13.1,
    county_fips: 27045,
    county_name: "Fillmore",
    county_weights: {
      27045: 50.38,
      27109: 46.37,
      27169: 3.25,
    },
    county_names_all: "Fillmore|Olmsted|Winona",
    county_fips_all: "27045|27109|27169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55924,
    lat: 44.0354,
    lng: -93.01838,
    city: "Claremont",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1446,
    density: 7.3,
    county_fips: 27039,
    county_name: "Dodge",
    county_weights: {
      27039: 69.6,
      27147: 30.4,
    },
    county_names_all: "Dodge|Steele",
    county_fips_all: "27039|27147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55925,
    lat: 43.90962,
    lng: -91.46503,
    city: "Dakota",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1220,
    density: 15.3,
    county_fips: 27169,
    county_name: "Winona",
    county_weights: {
      27169: 100,
    },
    county_names_all: "Winona",
    county_fips_all: 27169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55926,
    lat: 43.74279,
    lng: -92.70689,
    city: "Dexter",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 823,
    density: 5.2,
    county_fips: 27099,
    county_name: "Mower",
    county_weights: {
      27099: 100,
    },
    county_names_all: "Mower",
    county_fips_all: 27099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55927,
    lat: 44.0335,
    lng: -92.87291,
    city: "Dodge Center",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4286,
    density: 20.6,
    county_fips: 27039,
    county_name: "Dodge",
    county_weights: {
      27039: 100,
    },
    county_names_all: "Dodge",
    county_fips_all: 27039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55929,
    lat: 43.97765,
    lng: -92.14412,
    city: "Dover",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1220,
    density: 10.7,
    county_fips: 27109,
    county_name: "Olmsted",
    county_weights: {
      27109: 100,
    },
    county_names_all: "Olmsted",
    county_fips_all: 27109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55931,
    lat: 43.51424,
    lng: -91.39703,
    city: "Eitzen",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 359,
    density: 7.6,
    county_fips: 27055,
    county_name: "Houston",
    county_weights: {
      27055: 100,
    },
    county_names_all: "Houston",
    county_fips_all: 27055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55932,
    lat: 44.13804,
    lng: -92.30081,
    city: "Elgin",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1996,
    density: 14.7,
    county_fips: 27109,
    county_name: "Olmsted",
    county_weights: {
      27109: 52.15,
      27157: 47.85,
    },
    county_names_all: "Olmsted|Wabasha",
    county_fips_all: "27109|27157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55933,
    lat: 43.64787,
    lng: -92.68504,
    city: "Elkton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 264,
    density: 4.8,
    county_fips: 27099,
    county_name: "Mower",
    county_weights: {
      27099: 100,
    },
    county_names_all: "Mower",
    county_fips_all: 27099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55934,
    lat: 44.00388,
    lng: -92.26573,
    city: "Eyota",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3552,
    density: 17.5,
    county_fips: 27109,
    county_name: "Olmsted",
    county_weights: {
      27109: 100,
    },
    county_names_all: "Olmsted",
    county_fips_all: 27109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55935,
    lat: 43.74737,
    lng: -92.12734,
    city: "Fountain",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 927,
    density: 7.1,
    county_fips: 27045,
    county_name: "Fillmore",
    county_weights: {
      27045: 100,
    },
    county_names_all: "Fillmore",
    county_fips_all: 27045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55936,
    lat: 43.70943,
    lng: -92.58524,
    city: "Grand Meadow",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1914,
    density: 8.5,
    county_fips: 27099,
    county_name: "Mower",
    county_weights: {
      27099: 100,
    },
    county_names_all: "Mower",
    county_fips_all: 27099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55939,
    lat: 43.54682,
    lng: -92.08144,
    city: "Harmony",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1941,
    density: 8.1,
    county_fips: 27045,
    county_name: "Fillmore",
    county_weights: {
      27045: 100,
    },
    county_names_all: "Fillmore",
    county_fips_all: 27045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55940,
    lat: 43.89417,
    lng: -92.80775,
    city: "Hayfield",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2744,
    density: 11.4,
    county_fips: 27039,
    county_name: "Dodge",
    county_weights: {
      27039: 90.08,
      27099: 1.29,
      27109: 8.63,
    },
    county_names_all: "Dodge|Olmsted|Mower",
    county_fips_all: "27039|27109|27099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55941,
    lat: 43.72558,
    lng: -91.35382,
    city: "Hokah",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1008,
    density: 14.7,
    county_fips: 27055,
    county_name: "Houston",
    county_weights: {
      27055: 100,
    },
    county_names_all: "Houston",
    county_fips_all: 27055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55943,
    lat: 43.7903,
    lng: -91.58343,
    city: "Houston",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2946,
    density: 6.7,
    county_fips: 27055,
    county_name: "Houston",
    county_weights: {
      27055: 80.5,
      27169: 19.5,
    },
    county_names_all: "Houston|Winona",
    county_fips_all: "27055|27169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55944,
    lat: 43.98754,
    lng: -92.73758,
    city: "Kasson",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7552,
    density: 49.2,
    county_fips: 27039,
    county_name: "Dodge",
    county_weights: {
      27039: 93.76,
      27109: 6.24,
    },
    county_names_all: "Dodge|Olmsted",
    county_fips_all: "27039|27109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55945,
    lat: 44.26788,
    lng: -92.05591,
    city: "Kellogg",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1325,
    density: 5,
    county_fips: 27157,
    county_name: "Wabasha",
    county_weights: {
      27157: 100,
    },
    county_names_all: "Wabasha",
    county_fips_all: 27157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55946,
    lat: 44.26129,
    lng: -92.95998,
    city: "Kenyon",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3315,
    density: 9.7,
    county_fips: 27049,
    county_name: "Goodhue",
    county_weights: {
      27039: 5.59,
      27049: 76.1,
      27131: 16.13,
      27147: 2.18,
    },
    county_names_all: "Goodhue|Rice|Dodge|Steele",
    county_fips_all: "27049|27131|27039|27147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55947,
    lat: 43.82412,
    lng: -91.35666,
    city: "La Crescent",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7357,
    density: 38.7,
    county_fips: 27055,
    county_name: "Houston",
    county_weights: {
      27055: 65.11,
      27169: 34.89,
    },
    county_names_all: "Houston|Winona",
    county_fips_all: "27055|27169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55949,
    lat: 43.71156,
    lng: -91.94032,
    city: "Lanesboro",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1852,
    density: 6.3,
    county_fips: 27045,
    county_name: "Fillmore",
    county_weights: {
      27045: 100,
    },
    county_names_all: "Fillmore",
    county_fips_all: 27045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55950,
    lat: 43.74341,
    lng: -92.96618,
    city: "Lansing",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 169,
    density: 205.6,
    county_fips: 27099,
    county_name: "Mower",
    county_weights: {
      27099: 100,
    },
    county_names_all: "Mower",
    county_fips_all: 27099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55951,
    lat: 43.53529,
    lng: -92.48414,
    city: "Le Roy",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1579,
    density: 8.3,
    county_fips: 27099,
    county_name: "Mower",
    county_weights: {
      27045: 34.63,
      27099: 65.37,
    },
    county_names_all: "Mower|Fillmore",
    county_fips_all: "27099|27045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55952,
    lat: 43.94399,
    lng: -91.84337,
    city: "Lewiston",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2756,
    density: 16,
    county_fips: 27169,
    county_name: "Winona",
    county_weights: {
      27169: 100,
    },
    county_names_all: "Winona",
    county_fips_all: 27169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55953,
    lat: 43.52772,
    lng: -92.96521,
    city: "Lyle",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 832,
    density: 9.1,
    county_fips: 27099,
    county_name: "Mower",
    county_weights: {
      27047: 6.76,
      27099: 93.24,
    },
    county_names_all: "Mower|Freeborn",
    county_fips_all: "27099|27047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55954,
    lat: 43.56422,
    lng: -91.78455,
    city: "Mabel",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1326,
    density: 7.1,
    county_fips: 27045,
    county_name: "Fillmore",
    county_weights: {
      27045: 87.57,
      27055: 12.43,
    },
    county_names_all: "Fillmore|Houston",
    county_fips_all: "27045|27055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55955,
    lat: 44.09179,
    lng: -92.73985,
    city: "Mantorville",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2594,
    density: 29.3,
    county_fips: 27039,
    county_name: "Dodge",
    county_weights: {
      27039: 96.87,
      27109: 3.13,
    },
    county_names_all: "Dodge|Olmsted",
    county_fips_all: "27039|27109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55956,
    lat: 44.28382,
    lng: -92.53068,
    city: "Mazeppa",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2043,
    density: 14.4,
    county_fips: 27157,
    county_name: "Wabasha",
    county_weights: {
      27049: 26.28,
      27109: 2.27,
      27157: 71.45,
    },
    county_names_all: "Wabasha|Goodhue|Olmsted",
    county_fips_all: "27157|27049|27109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55957,
    lat: 44.25494,
    lng: -92.28373,
    city: "Millville",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 794,
    density: 7.5,
    county_fips: 27157,
    county_name: "Wabasha",
    county_weights: {
      27157: 100,
    },
    county_names_all: "Wabasha",
    county_fips_all: 27157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55959,
    lat: 44.11287,
    lng: -91.78365,
    city: "Minnesota City",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2403,
    density: 25.4,
    county_fips: 27169,
    county_name: "Winona",
    county_weights: {
      27169: 100,
    },
    county_names_all: "Winona",
    county_fips_all: 27169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55960,
    lat: 44.14226,
    lng: -92.53564,
    city: "Oronoco",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3041,
    density: 33.5,
    county_fips: 27109,
    county_name: "Olmsted",
    county_weights: {
      27109: 100,
    },
    county_names_all: "Olmsted",
    county_fips_all: 27109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55961,
    lat: 43.60541,
    lng: -92.47544,
    city: "Ostrander",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 501,
    density: 6.5,
    county_fips: 27099,
    county_name: "Mower",
    county_weights: {
      27045: 25.75,
      27099: 74.25,
    },
    county_names_all: "Mower|Fillmore",
    county_fips_all: "27099|27045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55962,
    lat: 43.76213,
    lng: -91.84219,
    city: "Peterson",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 810,
    density: 5,
    county_fips: 27045,
    county_name: "Fillmore",
    county_weights: {
      27045: 95.48,
      27169: 4.52,
    },
    county_names_all: "Fillmore|Winona",
    county_fips_all: "27045|27169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55963,
    lat: 44.18784,
    lng: -92.66227,
    city: "Pine Island",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5465,
    density: 26.2,
    county_fips: 27049,
    county_name: "Goodhue",
    county_weights: {
      27039: 19.78,
      27049: 46.08,
      27109: 34.14,
    },
    county_names_all: "Goodhue|Olmsted|Dodge",
    county_fips_all: "27049|27109|27039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55964,
    lat: 44.16448,
    lng: -92.15483,
    city: "Plainview",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4441,
    density: 19.3,
    county_fips: 27157,
    county_name: "Wabasha",
    county_weights: {
      27109: 10.52,
      27157: 78.98,
      27169: 10.5,
    },
    county_names_all: "Wabasha|Olmsted|Winona",
    county_fips_all: "27157|27109|27169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55965,
    lat: 43.62913,
    lng: -92.13282,
    city: "Preston",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2294,
    density: 8.2,
    county_fips: 27045,
    county_name: "Fillmore",
    county_weights: {
      27045: 100,
    },
    county_names_all: "Fillmore",
    county_fips_all: 27045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55967,
    lat: 43.79343,
    lng: -92.51354,
    city: "Racine",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1192,
    density: 12.6,
    county_fips: 27099,
    county_name: "Mower",
    county_weights: {
      27099: 100,
    },
    county_names_all: "Mower",
    county_fips_all: 27099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55968,
    lat: 44.39793,
    lng: -92.0898,
    city: "Reads Landing",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 122,
    density: 29.4,
    county_fips: 27157,
    county_name: "Wabasha",
    county_weights: {
      27157: 100,
    },
    county_names_all: "Wabasha",
    county_fips_all: 27157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55969,
    lat: 44.08263,
    lng: -91.87658,
    city: "Rollingstone",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1162,
    density: 15.4,
    county_fips: 27169,
    county_name: "Winona",
    county_weights: {
      27169: 100,
    },
    county_names_all: "Winona",
    county_fips_all: 27169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55970,
    lat: 43.59681,
    lng: -92.83118,
    city: "Rose Creek",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1161,
    density: 7.3,
    county_fips: 27099,
    county_name: "Mower",
    county_weights: {
      27099: 100,
    },
    county_names_all: "Mower",
    county_fips_all: 27099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55971,
    lat: 43.81968,
    lng: -91.75527,
    city: "Rushford",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2848,
    density: 13,
    county_fips: 27045,
    county_name: "Fillmore",
    county_weights: {
      27045: 43.81,
      27055: 18.17,
      27169: 38.03,
    },
    county_names_all: "Fillmore|Winona|Houston",
    county_fips_all: "27045|27169|27055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55972,
    lat: 43.99396,
    lng: -92.05092,
    city: "Saint Charles",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5196,
    density: 22.7,
    county_fips: 27169,
    county_name: "Winona",
    county_weights: {
      27109: 26.33,
      27169: 73.67,
    },
    county_names_all: "Winona|Olmsted",
    county_fips_all: "27169|27109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55973,
    lat: 43.80794,
    lng: -92.772,
    city: "Sargeant",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 217,
    density: 2.8,
    county_fips: 27099,
    county_name: "Mower",
    county_weights: {
      27039: 3.44,
      27099: 96.56,
    },
    county_names_all: "Mower|Dodge",
    county_fips_all: "27099|27039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55974,
    lat: 43.57968,
    lng: -91.64382,
    city: "Spring Grove",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2180,
    density: 10.2,
    county_fips: 27055,
    county_name: "Houston",
    county_weights: {
      27045: 3.97,
      27055: 96.03,
    },
    county_names_all: "Houston|Fillmore",
    county_fips_all: "27055|27045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55975,
    lat: 43.67569,
    lng: -92.37296,
    city: "Spring Valley",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4475,
    density: 10.8,
    county_fips: 27045,
    county_name: "Fillmore",
    county_weights: {
      27045: 88.07,
      27099: 11.93,
    },
    county_names_all: "Fillmore|Mower",
    county_fips_all: "27045|27099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55976,
    lat: 43.86378,
    lng: -92.48394,
    city: "Stewartville",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7948,
    density: 33.7,
    county_fips: 27109,
    county_name: "Olmsted",
    county_weights: {
      27045: 15.39,
      27099: 1.6,
      27109: 83.01,
    },
    county_names_all: "Olmsted|Fillmore|Mower",
    county_fips_all: "27109|27045|27099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55977,
    lat: 43.55371,
    lng: -92.64792,
    city: "Taopi",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 174,
    density: 2.8,
    county_fips: 27099,
    county_name: "Mower",
    county_weights: {
      27099: 100,
    },
    county_names_all: "Mower",
    county_fips_all: 27099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55979,
    lat: 43.92312,
    lng: -91.95132,
    city: "Utica",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1130,
    density: 7.4,
    county_fips: 27169,
    county_name: "Winona",
    county_weights: {
      27045: 7.73,
      27169: 92.27,
    },
    county_names_all: "Winona|Fillmore",
    county_fips_all: "27169|27045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55981,
    lat: 44.35375,
    lng: -92.06518,
    city: "Wabasha",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3815,
    density: 28.9,
    county_fips: 27157,
    county_name: "Wabasha",
    county_weights: {
      27157: 100,
    },
    county_names_all: "Wabasha",
    county_fips_all: 27157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55982,
    lat: 43.81582,
    lng: -92.886,
    city: "Waltham",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 479,
    density: 6.6,
    county_fips: 27099,
    county_name: "Mower",
    county_weights: {
      27099: 100,
    },
    county_names_all: "Mower",
    county_fips_all: 27099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55983,
    lat: 44.29344,
    lng: -92.80827,
    city: "Wanamingo",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1565,
    density: 16.1,
    county_fips: 27049,
    county_name: "Goodhue",
    county_weights: {
      27049: 100,
    },
    county_names_all: "Goodhue",
    county_fips_all: 27049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55985,
    lat: 44.15669,
    lng: -92.90259,
    city: "West Concord",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1813,
    density: 8.7,
    county_fips: 27039,
    county_name: "Dodge",
    county_weights: {
      27039: 89.14,
      27049: 6.5,
      27147: 4.36,
    },
    county_names_all: "Dodge|Goodhue|Steele",
    county_fips_all: "27039|27049|27147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55987,
    lat: 43.98469,
    lng: -91.63143,
    city: "Winona",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34599,
    density: 85,
    county_fips: 27169,
    county_name: "Winona",
    county_weights: {
      27169: 100,
    },
    county_names_all: "Winona",
    county_fips_all: 27169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55990,
    lat: 43.7285,
    lng: -92.2591,
    city: "Wykoff",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 937,
    density: 8.4,
    county_fips: 27045,
    county_name: "Fillmore",
    county_weights: {
      27045: 100,
    },
    county_names_all: "Fillmore",
    county_fips_all: 27045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55991,
    lat: 44.25903,
    lng: -92.41986,
    city: "Zumbro Falls",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1546,
    density: 11,
    county_fips: 27157,
    county_name: "Wabasha",
    county_weights: {
      27109: 0.9,
      27157: 99.1,
    },
    county_names_all: "Wabasha|Olmsted",
    county_fips_all: "27157|27109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 55992,
    lat: 44.30557,
    lng: -92.6827,
    city: "Zumbrota",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5319,
    density: 28.2,
    county_fips: 27049,
    county_name: "Goodhue",
    county_weights: {
      27049: 100,
    },
    county_names_all: "Goodhue",
    county_fips_all: 27049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56001,
    lat: 44.13193,
    lng: -93.97789,
    city: "Mankato",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49017,
    density: 165.3,
    county_fips: 27013,
    county_name: "Blue Earth",
    county_weights: {
      27013: 100,
    },
    county_names_all: "Blue Earth",
    county_fips_all: 27013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56003,
    lat: 44.21273,
    lng: -94.08877,
    city: "Mankato",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15121,
    density: 132.7,
    county_fips: 27103,
    county_name: "Nicollet",
    county_weights: {
      27013: 0.3,
      27103: 99.7,
    },
    county_names_all: "Nicollet|Blue Earth",
    county_fips_all: "27103|27013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56007,
    lat: 43.66085,
    lng: -93.3238,
    city: "Albert Lea",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20994,
    density: 47.9,
    county_fips: 27047,
    county_name: "Freeborn",
    county_weights: {
      27047: 100,
    },
    county_names_all: "Freeborn",
    county_fips_all: 27047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56009,
    lat: 43.66125,
    lng: -93.55904,
    city: "Alden",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1437,
    density: 5.7,
    county_fips: 27047,
    county_name: "Freeborn",
    county_weights: {
      27043: 1.52,
      27047: 98.48,
    },
    county_names_all: "Freeborn|Faribault",
    county_fips_all: "27047|27043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56010,
    lat: 43.89112,
    lng: -94.17869,
    city: "Amboy",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1198,
    density: 5.7,
    county_fips: 27013,
    county_name: "Blue Earth",
    county_weights: {
      27013: 100,
    },
    county_names_all: "Blue Earth",
    county_fips_all: 27013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56011,
    lat: 44.60344,
    lng: -93.777,
    city: "Belle Plaine",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9518,
    density: 35.9,
    county_fips: 27139,
    county_name: "Scott",
    county_weights: {
      27019: 9.41,
      27079: 6.59,
      27139: 67.13,
      27143: 16.87,
    },
    county_names_all: "Scott|Sibley|Carver|Le Sueur",
    county_fips_all: "27139|27143|27019|27079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56013,
    lat: 43.62142,
    lng: -94.10734,
    city: "Blue Earth",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4301,
    density: 9.8,
    county_fips: 27043,
    county_name: "Faribault",
    county_weights: {
      27043: 90.04,
      27091: 9.96,
    },
    county_names_all: "Faribault|Martin",
    county_fips_all: "27043|27091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56014,
    lat: 43.58363,
    lng: -93.82568,
    city: "Bricelyn",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 646,
    density: 3.3,
    county_fips: 27043,
    county_name: "Faribault",
    county_weights: {
      27043: 100,
    },
    county_names_all: "Faribault",
    county_fips_all: 27043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56016,
    lat: 43.76378,
    lng: -93.34855,
    city: "Clarks Grove",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 909,
    density: 13.6,
    county_fips: 27047,
    county_name: "Freeborn",
    county_weights: {
      27047: 100,
    },
    county_names_all: "Freeborn",
    county_fips_all: 27047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56017,
    lat: 44.30535,
    lng: -93.81915,
    city: "Cleveland",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1708,
    density: 22.6,
    county_fips: 27079,
    county_name: "Le Sueur",
    county_weights: {
      27079: 100,
    },
    county_names_all: "Le Sueur",
    county_fips_all: 27079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56019,
    lat: 44.11476,
    lng: -94.89016,
    city: "Comfrey",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 767,
    density: 3,
    county_fips: 27015,
    county_name: "Brown",
    county_weights: {
      27015: 58.56,
      27033: 33.3,
      27165: 8.14,
    },
    county_names_all: "Brown|Cottonwood|Watonwan",
    county_fips_all: "27015|27033|27165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56020,
    lat: 43.6146,
    lng: -93.53019,
    city: "Conger",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 107,
    density: 656.1,
    county_fips: 27047,
    county_name: "Freeborn",
    county_weights: {
      27047: 100,
    },
    county_names_all: "Freeborn",
    county_fips_all: 27047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56021,
    lat: 44.28339,
    lng: -94.31391,
    city: "Courtland",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1013,
    density: 10.9,
    county_fips: 27103,
    county_name: "Nicollet",
    county_weights: {
      27103: 100,
    },
    county_names_all: "Nicollet",
    county_fips_all: 27103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56022,
    lat: 44.05264,
    lng: -94.83869,
    city: "Darfur",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42,
    density: 118.3,
    county_fips: 27165,
    county_name: "Watonwan",
    county_weights: {
      27165: 100,
    },
    county_names_all: "Watonwan",
    county_fips_all: 27165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56023,
    lat: 43.77224,
    lng: -94.01402,
    city: "Delavan",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 551,
    density: 3.7,
    county_fips: 27043,
    county_name: "Faribault",
    county_weights: {
      27043: 100,
    },
    county_names_all: "Faribault",
    county_fips_all: 27043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56024,
    lat: 44.14768,
    lng: -93.84419,
    city: "Eagle Lake",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3430,
    density: 71.4,
    county_fips: 27013,
    county_name: "Blue Earth",
    county_weights: {
      27013: 100,
    },
    county_names_all: "Blue Earth",
    county_fips_all: 27013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56025,
    lat: 43.7516,
    lng: -93.90877,
    city: "Easton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 462,
    density: 3.4,
    county_fips: 27043,
    county_name: "Faribault",
    county_weights: {
      27043: 100,
    },
    county_names_all: "Faribault",
    county_fips_all: 27043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56026,
    lat: 43.87485,
    lng: -93.29124,
    city: "Ellendale",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2139,
    density: 8,
    county_fips: 27147,
    county_name: "Steele",
    county_weights: {
      27047: 38.9,
      27147: 60.45,
      27161: 0.65,
    },
    county_names_all: "Steele|Freeborn|Waseca",
    county_fips_all: "27147|27047|27161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56027,
    lat: 43.51935,
    lng: -94.12432,
    city: "Elmore",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 618,
    density: 3.8,
    county_fips: 27043,
    county_name: "Faribault",
    county_weights: {
      19109: 13.35,
      27043: 77.15,
      27091: 9.5,
    },
    county_names_all: "Faribault|Kossuth|Martin",
    county_fips_all: "27043|19109|27091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56028,
    lat: 44.22435,
    lng: -93.71052,
    city: "Elysian",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1180,
    density: 25.5,
    county_fips: 27079,
    county_name: "Le Sueur",
    county_weights: {
      27079: 90.95,
      27161: 9.05,
    },
    county_names_all: "Le Sueur|Waseca",
    county_fips_all: "27079|27161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56029,
    lat: 43.52519,
    lng: -93.53003,
    city: "Emmons",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 661,
    density: 6.1,
    county_fips: 27047,
    county_name: "Freeborn",
    county_weights: {
      27047: 100,
    },
    county_names_all: "Freeborn",
    county_fips_all: 27047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56030,
    lat: 44.32485,
    lng: -94.60485,
    city: "Essig",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 27015,
    county_name: "Brown",
    county_weights: {
      27015: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 27015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56031,
    lat: 43.62246,
    lng: -94.46757,
    city: "Fairmont",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11553,
    density: 28.5,
    county_fips: 27091,
    county_name: "Martin",
    county_weights: {
      27091: 100,
    },
    county_names_all: "Martin",
    county_fips_all: 27091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56032,
    lat: 43.77583,
    lng: -93.56078,
    city: "Freeborn",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 331,
    density: 41.6,
    county_fips: 27047,
    county_name: "Freeborn",
    county_weights: {
      27047: 100,
    },
    county_names_all: "Freeborn",
    county_fips_all: 27047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56033,
    lat: 43.55926,
    lng: -93.93118,
    city: "Frost",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 343,
    density: 3.9,
    county_fips: 27043,
    county_name: "Faribault",
    county_weights: {
      27043: 100,
    },
    county_names_all: "Faribault",
    county_fips_all: 27043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56034,
    lat: 44.03036,
    lng: -94.18285,
    city: "Garden City",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 431,
    density: 5.9,
    county_fips: 27013,
    county_name: "Blue Earth",
    county_weights: {
      27013: 100,
    },
    county_names_all: "Blue Earth",
    county_fips_all: 27013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56035,
    lat: 43.82187,
    lng: -93.26875,
    city: "Geneva",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 446,
    density: 316.6,
    county_fips: 27047,
    county_name: "Freeborn",
    county_weights: {
      27047: 100,
    },
    county_names_all: "Freeborn",
    county_fips_all: 27047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56036,
    lat: 43.5513,
    lng: -93.22152,
    city: "Glenville",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1867,
    density: 6.2,
    county_fips: 27047,
    county_name: "Freeborn",
    county_weights: {
      27047: 100,
    },
    county_names_all: "Freeborn",
    county_fips_all: 27047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56037,
    lat: 44.0172,
    lng: -94.0465,
    city: "Good Thunder",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1662,
    density: 8.7,
    county_fips: 27013,
    county_name: "Blue Earth",
    county_weights: {
      27013: 100,
    },
    county_names_all: "Blue Earth",
    county_fips_all: 27013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56039,
    lat: 43.66246,
    lng: -94.32287,
    city: "Granada",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 811,
    density: 3.4,
    county_fips: 27091,
    county_name: "Martin",
    county_weights: {
      27043: 1.94,
      27091: 98.06,
    },
    county_names_all: "Martin|Faribault",
    county_fips_all: "27091|27043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56041,
    lat: 44.15514,
    lng: -94.52238,
    city: "Hanska",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1020,
    density: 5.4,
    county_fips: 27015,
    county_name: "Brown",
    county_weights: {
      27013: 0.99,
      27015: 99.01,
    },
    county_names_all: "Brown|Blue Earth",
    county_fips_all: "27015|27013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56042,
    lat: 43.80408,
    lng: -93.48387,
    city: "Hartland",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 787,
    density: 5.7,
    county_fips: 27047,
    county_name: "Freeborn",
    county_weights: {
      27047: 100,
    },
    county_names_all: "Freeborn",
    county_fips_all: 27047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56043,
    lat: 43.65236,
    lng: -93.22809,
    city: "Hayward",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 443,
    density: 8.2,
    county_fips: 27047,
    county_name: "Freeborn",
    county_weights: {
      27047: 100,
    },
    county_names_all: "Freeborn",
    county_fips_all: 27047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56044,
    lat: 44.56173,
    lng: -93.93539,
    city: "Henderson",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2171,
    density: 10.1,
    county_fips: 27143,
    county_name: "Sibley",
    county_weights: {
      27079: 16.59,
      27143: 83.41,
    },
    county_names_all: "Sibley|Le Sueur",
    county_fips_all: "27143|27079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56045,
    lat: 43.75977,
    lng: -93.20948,
    city: "Hollandale",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 975,
    density: 12.9,
    county_fips: 27047,
    county_name: "Freeborn",
    county_weights: {
      27047: 100,
    },
    county_names_all: "Freeborn",
    county_fips_all: 27047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56046,
    lat: 43.9678,
    lng: -93.26889,
    city: "Hope",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 117,
    density: 22.9,
    county_fips: 27147,
    county_name: "Steele",
    county_weights: {
      27147: 100,
    },
    county_names_all: "Steele",
    county_fips_all: 27147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56048,
    lat: 44.09478,
    lng: -93.71589,
    city: "Janesville",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4229,
    density: 13.3,
    county_fips: 27161,
    county_name: "Waseca",
    county_weights: {
      27013: 23.66,
      27161: 76.34,
    },
    county_names_all: "Waseca|Blue Earth",
    county_fips_all: "27161|27013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56050,
    lat: 44.26006,
    lng: -93.94706,
    city: "Kasota",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1248,
    density: 20.8,
    county_fips: 27079,
    county_name: "Le Sueur",
    county_weights: {
      27013: 11.8,
      27079: 88.2,
    },
    county_names_all: "Le Sueur|Blue Earth",
    county_fips_all: "27079|27013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56051,
    lat: 43.53649,
    lng: -93.70868,
    city: "Kiester",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 713,
    density: 9.4,
    county_fips: 27043,
    county_name: "Faribault",
    county_weights: {
      27043: 100,
    },
    county_names_all: "Faribault",
    county_fips_all: 27043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56052,
    lat: 44.32158,
    lng: -93.5576,
    city: "Kilkenny",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 595,
    density: 4.5,
    county_fips: 27079,
    county_name: "Le Sueur",
    county_weights: {
      27079: 71.06,
      27131: 28.94,
    },
    county_names_all: "Le Sueur|Rice",
    county_fips_all: "27079|27131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56054,
    lat: 44.4357,
    lng: -94.37043,
    city: "Lafayette",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 995,
    density: 7.2,
    county_fips: 27103,
    county_name: "Nicollet",
    county_weights: {
      27103: 83.53,
      27143: 16.47,
    },
    county_names_all: "Nicollet|Sibley",
    county_fips_all: "27103|27143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56055,
    lat: 44.12693,
    lng: -94.24531,
    city: "Lake Crystal",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3916,
    density: 12.8,
    county_fips: 27013,
    county_name: "Blue Earth",
    county_weights: {
      27013: 100,
    },
    county_names_all: "Blue Earth",
    county_fips_all: 27013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56056,
    lat: 44.07278,
    lng: -94.57945,
    city: "La Salle",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 80,
    density: 30.2,
    county_fips: 27165,
    county_name: "Watonwan",
    county_weights: {
      27165: 100,
    },
    county_names_all: "Watonwan",
    county_fips_all: 27165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56057,
    lat: 44.3954,
    lng: -93.72045,
    city: "Le Center",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4065,
    density: 18.4,
    county_fips: 27079,
    county_name: "Le Sueur",
    county_weights: {
      27079: 100,
    },
    county_names_all: "Le Sueur",
    county_fips_all: 27079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56058,
    lat: 44.44424,
    lng: -93.91441,
    city: "Le Sueur",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5838,
    density: 17.8,
    county_fips: 27079,
    county_name: "Le Sueur",
    county_weights: {
      27079: 63.22,
      27103: 11.26,
      27143: 25.52,
    },
    county_names_all: "Le Sueur|Sibley|Nicollet",
    county_fips_all: "27079|27143|27103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56060,
    lat: 43.93221,
    lng: -94.43691,
    city: "Lewisville",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 527,
    density: 5.7,
    county_fips: 27165,
    county_name: "Watonwan",
    county_weights: {
      27013: 5.91,
      27165: 94.09,
    },
    county_names_all: "Watonwan|Blue Earth",
    county_fips_all: "27165|27013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56062,
    lat: 44.0483,
    lng: -94.41469,
    city: "Madelia",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3467,
    density: 10.8,
    county_fips: 27165,
    county_name: "Watonwan",
    county_weights: {
      27013: 28.76,
      27015: 7.14,
      27165: 64.1,
    },
    county_names_all: "Watonwan|Blue Earth|Brown",
    county_fips_all: "27165|27013|27015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56063,
    lat: 44.218,
    lng: -93.81791,
    city: "Madison Lake",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2835,
    density: 27.3,
    county_fips: 27013,
    county_name: "Blue Earth",
    county_weights: {
      27013: 60.2,
      27079: 34.08,
      27161: 5.72,
    },
    county_names_all: "Blue Earth|Le Sueur|Waseca",
    county_fips_all: "27013|27079|27161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56065,
    lat: 43.93376,
    lng: -93.91799,
    city: "Mapleton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2744,
    density: 9.1,
    county_fips: 27013,
    county_name: "Blue Earth",
    county_weights: {
      27013: 96.96,
      27043: 2.18,
      27161: 0.86,
    },
    county_names_all: "Blue Earth|Faribault|Waseca",
    county_fips_all: "27013|27043|27161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56068,
    lat: 43.86303,
    lng: -93.80601,
    city: "Minnesota Lake",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 892,
    density: 5.3,
    county_fips: 27013,
    county_name: "Blue Earth",
    county_weights: {
      27013: 39.84,
      27043: 35.77,
      27161: 24.39,
    },
    county_names_all: "Blue Earth|Faribault|Waseca",
    county_fips_all: "27013|27043|27161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56069,
    lat: 44.41801,
    lng: -93.54988,
    city: "Montgomery",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4643,
    density: 25.2,
    county_fips: 27079,
    county_name: "Le Sueur",
    county_weights: {
      27079: 63.78,
      27131: 36.22,
    },
    county_names_all: "Le Sueur|Rice",
    county_fips_all: "27079|27131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56071,
    lat: 44.53459,
    lng: -93.58209,
    city: "New Prague",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13097,
    density: 58.8,
    county_fips: 27079,
    county_name: "Le Sueur",
    county_weights: {
      27079: 46.07,
      27131: 11.86,
      27139: 42.07,
    },
    county_names_all: "Le Sueur|Scott|Rice",
    county_fips_all: "27079|27139|27131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56072,
    lat: 43.89677,
    lng: -93.5125,
    city: "New Richland",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2143,
    density: 6.8,
    county_fips: 27161,
    county_name: "Waseca",
    county_weights: {
      27043: 0.25,
      27047: 7.97,
      27147: 14.16,
      27161: 77.62,
    },
    county_names_all: "Waseca|Steele|Freeborn|Faribault",
    county_fips_all: "27161|27147|27047|27043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56073,
    lat: 44.30757,
    lng: -94.46878,
    city: "New Ulm",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16688,
    density: 32.1,
    county_fips: 27015,
    county_name: "Brown",
    county_weights: {
      27013: 6.01,
      27015: 55.35,
      27103: 38.64,
    },
    county_names_all: "Brown|Nicollet|Blue Earth",
    county_fips_all: "27015|27103|27013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56074,
    lat: 44.32344,
    lng: -94.20181,
    city: "Nicollet",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1891,
    density: 9.4,
    county_fips: 27103,
    county_name: "Nicollet",
    county_weights: {
      27103: 100,
    },
    county_names_all: "Nicollet",
    county_fips_all: 27103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56075,
    lat: 43.73516,
    lng: -94.43663,
    city: "Northrop",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 136,
    density: 981.7,
    county_fips: 27091,
    county_name: "Martin",
    county_weights: {
      27091: 100,
    },
    county_names_all: "Martin",
    county_fips_all: 27091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56078,
    lat: 44.00525,
    lng: -93.76757,
    city: "Pemberton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 523,
    density: 7.9,
    county_fips: 27013,
    county_name: "Blue Earth",
    county_weights: {
      27013: 50.19,
      27161: 49.81,
    },
    county_names_all: "Blue Earth|Waseca",
    county_fips_all: "27013|27161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56080,
    lat: 44.08166,
    lng: -93.85781,
    city: "Saint Clair",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 728,
    density: 636.1,
    county_fips: 27013,
    county_name: "Blue Earth",
    county_weights: {
      27013: 100,
    },
    county_names_all: "Blue Earth",
    county_fips_all: 27013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56081,
    lat: 43.99345,
    lng: -94.63062,
    city: "Saint James",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5717,
    density: 12.4,
    county_fips: 27165,
    county_name: "Watonwan",
    county_weights: {
      27015: 4.07,
      27165: 95.93,
    },
    county_names_all: "Watonwan|Brown",
    county_fips_all: "27165|27015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56082,
    lat: 44.35217,
    lng: -94.03329,
    city: "Saint Peter",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14599,
    density: 45.4,
    county_fips: 27103,
    county_name: "Nicollet",
    county_weights: {
      27079: 13.23,
      27103: 86.77,
    },
    county_names_all: "Nicollet|Le Sueur",
    county_fips_all: "27103|27079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56083,
    lat: 44.20734,
    lng: -95.13434,
    city: "Sanborn",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 751,
    density: 3,
    county_fips: 27127,
    county_name: "Redwood",
    county_weights: {
      27015: 20.02,
      27033: 34.57,
      27127: 45.41,
    },
    county_names_all: "Redwood|Cottonwood|Brown",
    county_fips_all: "27127|27033|27015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56085,
    lat: 44.29279,
    lng: -94.73547,
    city: "Sleepy Eye",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5237,
    density: 9.8,
    county_fips: 27015,
    county_name: "Brown",
    county_weights: {
      27015: 95.76,
      27127: 4.24,
    },
    county_names_all: "Brown|Redwood",
    county_fips_all: "27015|27127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56087,
    lat: 44.24012,
    lng: -94.97538,
    city: "Springfield",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3075,
    density: 8.1,
    county_fips: 27015,
    county_name: "Brown",
    county_weights: {
      27015: 75.03,
      27127: 24.97,
    },
    county_names_all: "Brown|Redwood",
    county_fips_all: "27015|27127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56088,
    lat: 43.82647,
    lng: -94.45031,
    city: "Truman",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1811,
    density: 5.6,
    county_fips: 27091,
    county_name: "Martin",
    county_weights: {
      27013: 7.83,
      27091: 68.34,
      27165: 23.83,
    },
    county_names_all: "Martin|Watonwan|Blue Earth",
    county_fips_all: "27091|27165|27013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56089,
    lat: 43.55631,
    lng: -93.4508,
    city: "Twin Lakes",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 210,
    density: 14.8,
    county_fips: 27047,
    county_name: "Freeborn",
    county_weights: {
      27047: 100,
    },
    county_names_all: "Freeborn",
    county_fips_all: 27047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56090,
    lat: 43.9584,
    lng: -94.23303,
    city: "Vernon Center",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 637,
    density: 5.7,
    county_fips: 27013,
    county_name: "Blue Earth",
    county_weights: {
      27013: 100,
    },
    county_names_all: "Blue Earth",
    county_fips_all: 27013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56091,
    lat: 43.91813,
    lng: -93.68831,
    city: "Waldorf",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 288,
    density: 6.2,
    county_fips: 27161,
    county_name: "Waseca",
    county_weights: {
      27161: 100,
    },
    county_names_all: "Waseca",
    county_fips_all: 27161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56093,
    lat: 44.06342,
    lng: -93.51683,
    city: "Waseca",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12297,
    density: 26.3,
    county_fips: 27161,
    county_name: "Waseca",
    county_weights: {
      27131: 0.76,
      27147: 6.08,
      27161: 93.16,
    },
    county_names_all: "Waseca|Steele|Rice",
    county_fips_all: "27161|27147|27131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56096,
    lat: 44.24393,
    lng: -93.60097,
    city: "Waterville",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2896,
    density: 20.1,
    county_fips: 27079,
    county_name: "Le Sueur",
    county_weights: {
      27079: 79.56,
      27131: 11.55,
      27161: 8.89,
    },
    county_names_all: "Le Sueur|Rice|Waseca",
    county_fips_all: "27079|27131|27161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56097,
    lat: 43.72261,
    lng: -93.71593,
    city: "Wells",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3770,
    density: 8.3,
    county_fips: 27043,
    county_name: "Faribault",
    county_weights: {
      27043: 82,
      27047: 15.27,
      27161: 2.73,
    },
    county_names_all: "Faribault|Freeborn|Waseca",
    county_fips_all: "27043|27047|27161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56098,
    lat: 43.77565,
    lng: -94.18528,
    city: "Winnebago",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1968,
    density: 6.7,
    county_fips: 27043,
    county_name: "Faribault",
    county_weights: {
      27043: 80.87,
      27091: 19.13,
    },
    county_names_all: "Faribault|Martin",
    county_fips_all: "27043|27091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56101,
    lat: 43.88404,
    lng: -95.13991,
    city: "Windom",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5849,
    density: 13.1,
    county_fips: 27033,
    county_name: "Cottonwood",
    county_weights: {
      27033: 63.53,
      27063: 36.47,
    },
    county_names_all: "Cottonwood|Jackson",
    county_fips_all: "27033|27063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56110,
    lat: 43.62115,
    lng: -95.94093,
    city: "Adrian",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1741,
    density: 6.1,
    county_fips: 27105,
    county_name: "Nobles",
    county_weights: {
      27105: 100,
    },
    county_names_all: "Nobles",
    county_fips_all: 27105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56111,
    lat: 43.64155,
    lng: -94.8799,
    city: "Alpha",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 369,
    density: 2.7,
    county_fips: 27063,
    county_name: "Jackson",
    county_weights: {
      27063: 93.62,
      27091: 6.38,
    },
    county_names_all: "Jackson|Martin",
    county_fips_all: "27063|27091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56113,
    lat: 44.40218,
    lng: -96.14904,
    city: "Arco",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 240,
    density: 2.3,
    county_fips: 27081,
    county_name: "Lincoln",
    county_weights: {
      27081: 93.91,
      27083: 6.09,
    },
    county_names_all: "Lincoln|Lyon",
    county_fips_all: "27081|27083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56114,
    lat: 43.97897,
    lng: -95.59345,
    city: "Avoca",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 367,
    density: 2.9,
    county_fips: 27101,
    county_name: "Murray",
    county_weights: {
      27101: 100,
    },
    county_names_all: "Murray",
    county_fips_all: 27101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56115,
    lat: 44.21514,
    lng: -95.90038,
    city: "Balaton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1405,
    density: 4.4,
    county_fips: 27083,
    county_name: "Lyon",
    county_weights: {
      27083: 62.59,
      27101: 37.41,
    },
    county_names_all: "Lyon|Murray",
    county_fips_all: "27083|27101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56116,
    lat: 43.61782,
    lng: -96.37893,
    city: "Beaver Creek",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 771,
    density: 6.8,
    county_fips: 27133,
    county_name: "Rock",
    county_weights: {
      27133: 100,
    },
    county_names_all: "Rock",
    county_fips_all: 27133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56117,
    lat: 43.52662,
    lng: -95.68607,
    city: "Bigelow",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 419,
    density: 6.9,
    county_fips: 27105,
    county_name: "Nobles",
    county_weights: {
      27105: 100,
    },
    county_names_all: "Nobles",
    county_fips_all: 27105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56118,
    lat: 43.93616,
    lng: -95.03555,
    city: "Bingham Lake",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 483,
    density: 3.5,
    county_fips: 27033,
    county_name: "Cottonwood",
    county_weights: {
      27033: 90.85,
      27063: 9.15,
    },
    county_names_all: "Cottonwood|Jackson",
    county_fips_all: "27033|27063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56119,
    lat: 43.71159,
    lng: -95.46702,
    city: "Brewster",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1085,
    density: 4.5,
    county_fips: 27105,
    county_name: "Nobles",
    county_weights: {
      27063: 40.85,
      27105: 59.15,
    },
    county_names_all: "Nobles|Jackson",
    county_fips_all: "27105|27063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56120,
    lat: 43.96083,
    lng: -94.79139,
    city: "Butterfield",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 969,
    density: 3.7,
    county_fips: 27165,
    county_name: "Watonwan",
    county_weights: {
      27165: 100,
    },
    county_names_all: "Watonwan",
    county_fips_all: 27165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56121,
    lat: 43.53858,
    lng: -94.61051,
    city: "Ceylon",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 595,
    density: 6.2,
    county_fips: 27091,
    county_name: "Martin",
    county_weights: {
      27091: 100,
    },
    county_names_all: "Martin",
    county_fips_all: 27091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56122,
    lat: 43.89729,
    lng: -95.95026,
    city: "Chandler",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 593,
    density: 4.2,
    county_fips: 27101,
    county_name: "Murray",
    county_weights: {
      27101: 90.18,
      27105: 9.82,
    },
    county_names_all: "Murray|Nobles",
    county_fips_all: "27101|27105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56123,
    lat: 44.08467,
    lng: -95.59624,
    city: "Currie",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 412,
    density: 2.3,
    county_fips: 27101,
    county_name: "Murray",
    county_weights: {
      27101: 100,
    },
    county_names_all: "Murray",
    county_fips_all: 27101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56125,
    lat: 44.05452,
    lng: -95.54774,
    city: "Dovray",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43,
    density: 66.7,
    county_fips: 27101,
    county_name: "Murray",
    county_weights: {
      27101: 100,
    },
    county_names_all: "Murray",
    county_fips_all: 27101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56127,
    lat: 43.54892,
    lng: -94.77261,
    city: "Dunnell",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 539,
    density: 3.8,
    county_fips: 27091,
    county_name: "Martin",
    county_weights: {
      27091: 100,
    },
    county_names_all: "Martin",
    county_fips_all: 27091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56128,
    lat: 43.88199,
    lng: -96.11579,
    city: "Edgerton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2048,
    density: 6.8,
    county_fips: 27117,
    county_name: "Pipestone",
    county_weights: {
      27101: 12.34,
      27105: 9.18,
      27117: 58.81,
      27133: 19.67,
    },
    county_names_all: "Pipestone|Rock|Murray|Nobles",
    county_fips_all: "27117|27133|27101|27105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56129,
    lat: 43.52775,
    lng: -96.04327,
    city: "Ellsworth",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 813,
    density: 6.6,
    county_fips: 27105,
    county_name: "Nobles",
    county_weights: {
      27105: 52.79,
      27133: 47.21,
    },
    county_names_all: "Nobles|Rock",
    county_fips_all: "27105|27133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56131,
    lat: 43.86305,
    lng: -95.57219,
    city: "Fulda",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2215,
    density: 5,
    county_fips: 27101,
    county_name: "Murray",
    county_weights: {
      27033: 15.06,
      27063: 0.48,
      27101: 44.81,
      27105: 39.65,
    },
    county_names_all: "Murray|Nobles|Cottonwood|Jackson",
    county_fips_all: "27101|27105|27033|27063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56132,
    lat: 44.20196,
    lng: -95.75792,
    city: "Garvin",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 446,
    density: 2.9,
    county_fips: 27083,
    county_name: "Lyon",
    county_weights: {
      27083: 53.86,
      27101: 46.14,
    },
    county_names_all: "Lyon|Murray",
    county_fips_all: "27083|27101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56134,
    lat: 43.78956,
    lng: -96.23126,
    city: "Hardwick",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 369,
    density: 2.8,
    county_fips: 27133,
    county_name: "Rock",
    county_weights: {
      27133: 100,
    },
    county_names_all: "Rock",
    county_fips_all: 27133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56136,
    lat: 44.50187,
    lng: -96.41645,
    city: "Hendricks",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1106,
    density: 3.8,
    county_fips: 27081,
    county_name: "Lincoln",
    county_weights: {
      27081: 77.68,
      46011: 22.32,
    },
    county_names_all: "Lincoln|Brookings",
    county_fips_all: "27081|46011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56137,
    lat: 43.83246,
    lng: -95.32424,
    city: "Heron Lake",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1084,
    density: 3.7,
    county_fips: 27063,
    county_name: "Jackson",
    county_weights: {
      27033: 34.48,
      27063: 65.52,
    },
    county_names_all: "Jackson|Cottonwood",
    county_fips_all: "27063|27033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56138,
    lat: 43.53279,
    lng: -96.38348,
    city: "Hills",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 996,
    density: 11.8,
    county_fips: 27133,
    county_name: "Rock",
    county_weights: {
      27133: 100,
    },
    county_names_all: "Rock",
    county_fips_all: 27133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56139,
    lat: 44.10368,
    lng: -96.1757,
    city: "Holland",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 428,
    density: 3.4,
    county_fips: 27117,
    county_name: "Pipestone",
    county_weights: {
      27117: 100,
    },
    county_names_all: "Pipestone",
    county_fips_all: 27117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56140,
    lat: 43.90959,
    lng: -96.36703,
    city: "Ihlen",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48,
    density: 195.7,
    county_fips: 27117,
    county_name: "Pipestone",
    county_weights: {
      27117: 100,
    },
    county_names_all: "Pipestone",
    county_fips_all: 27117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56141,
    lat: 43.88184,
    lng: -95.78962,
    city: "Iona",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 311,
    density: 2.9,
    county_fips: 27101,
    county_name: "Murray",
    county_weights: {
      27101: 91.61,
      27105: 8.39,
    },
    county_names_all: "Murray|Nobles",
    county_fips_all: "27101|27105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56142,
    lat: 44.4711,
    lng: -96.2327,
    city: "Ivanhoe",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 961,
    density: 4.1,
    county_fips: 27081,
    county_name: "Lincoln",
    county_weights: {
      27081: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 27081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56143,
    lat: 43.62803,
    lng: -95.00759,
    city: "Jackson",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4179,
    density: 8.6,
    county_fips: 27063,
    county_name: "Jackson",
    county_weights: {
      27063: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 27063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56144,
    lat: 43.84078,
    lng: -96.38702,
    city: "Jasper",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1071,
    density: 3.4,
    county_fips: 27133,
    county_name: "Rock",
    county_weights: {
      27117: 38.93,
      27133: 47.95,
      46101: 13.12,
    },
    county_names_all: "Rock|Pipestone|Moody",
    county_fips_all: "27133|27117|46101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56145,
    lat: 44.05577,
    lng: -95.17384,
    city: "Jeffers",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 526,
    density: 4.1,
    county_fips: 27033,
    county_name: "Cottonwood",
    county_weights: {
      27033: 100,
    },
    county_names_all: "Cottonwood",
    county_fips_all: 27033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56146,
    lat: 43.58006,
    lng: -96.10343,
    city: "Kanaranzi",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69,
    density: 26.8,
    county_fips: 27133,
    county_name: "Rock",
    county_weights: {
      27133: 100,
    },
    county_names_all: "Rock",
    county_fips_all: 27133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56147,
    lat: 43.75726,
    lng: -96.05985,
    city: "Kenneth",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 177,
    density: 2.3,
    county_fips: 27133,
    county_name: "Rock",
    county_weights: {
      27105: 46.47,
      27133: 53.53,
    },
    county_names_all: "Rock|Nobles",
    county_fips_all: "27133|27105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56149,
    lat: 44.30059,
    lng: -96.30454,
    city: "Lake Benton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1075,
    density: 3.7,
    county_fips: 27081,
    county_name: "Lincoln",
    county_weights: {
      27081: 95.83,
      27117: 4.17,
    },
    county_names_all: "Lincoln|Pipestone",
    county_fips_all: "27081|27117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56150,
    lat: 43.63469,
    lng: -95.21266,
    city: "Lakefield",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2700,
    density: 6,
    county_fips: 27063,
    county_name: "Jackson",
    county_weights: {
      27063: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 27063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56151,
    lat: 44.03304,
    lng: -95.92833,
    city: "Lake Wilson",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 738,
    density: 3,
    county_fips: 27101,
    county_name: "Murray",
    county_weights: {
      27101: 100,
    },
    county_names_all: "Murray",
    county_fips_all: 27101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56152,
    lat: 44.22702,
    lng: -95.2733,
    city: "Lamberton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1313,
    density: 3.7,
    county_fips: 27127,
    county_name: "Redwood",
    county_weights: {
      27033: 37.53,
      27127: 62.47,
    },
    county_names_all: "Redwood|Cottonwood",
    county_fips_all: "27127|27033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56153,
    lat: 43.83012,
    lng: -96.01506,
    city: "Leota",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 171,
    density: 24.2,
    county_fips: 27105,
    county_name: "Nobles",
    county_weights: {
      27105: 100,
    },
    county_names_all: "Nobles",
    county_fips_all: 27105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56155,
    lat: 43.76707,
    lng: -95.94117,
    city: "Lismore",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 487,
    density: 4.3,
    county_fips: 27105,
    county_name: "Nobles",
    county_weights: {
      27105: 100,
    },
    county_names_all: "Nobles",
    county_fips_all: 27105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56156,
    lat: 43.66196,
    lng: -96.22466,
    city: "Luverne",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5950,
    density: 13.8,
    county_fips: 27133,
    county_name: "Rock",
    county_weights: {
      27133: 100,
    },
    county_names_all: "Rock",
    county_fips_all: 27133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56157,
    lat: 44.39702,
    lng: -95.94805,
    city: "Lynd",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 731,
    density: 6.5,
    county_fips: 27083,
    county_name: "Lyon",
    county_weights: {
      27083: 100,
    },
    county_names_all: "Lyon",
    county_fips_all: 27083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56158,
    lat: 43.6337,
    lng: -96.07465,
    city: "Magnolia",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 346,
    density: 3.6,
    county_fips: 27133,
    county_name: "Rock",
    county_weights: {
      27105: 24.43,
      27133: 75.57,
    },
    county_names_all: "Rock|Nobles",
    county_fips_all: "27133|27105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56159,
    lat: 43.94363,
    lng: -94.93598,
    city: "Mountain Lake",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2652,
    density: 8.1,
    county_fips: 27033,
    county_name: "Cottonwood",
    county_weights: {
      27033: 86.03,
      27063: 13.97,
    },
    county_names_all: "Cottonwood|Jackson",
    county_fips_all: "27033|27063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56160,
    lat: 43.83311,
    lng: -94.81041,
    city: "Odin",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 255,
    density: 4.8,
    county_fips: 27091,
    county_name: "Martin",
    county_weights: {
      27063: 29.33,
      27091: 50.84,
      27165: 19.83,
    },
    county_names_all: "Martin|Jackson|Watonwan",
    county_fips_all: "27091|27063|27165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56161,
    lat: 43.70637,
    lng: -95.32519,
    city: "Okabena",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 317,
    density: 4.3,
    county_fips: 27063,
    county_name: "Jackson",
    county_weights: {
      27063: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 27063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56162,
    lat: 43.84034,
    lng: -94.66736,
    city: "Ormsby",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 234,
    density: 3.9,
    county_fips: 27091,
    county_name: "Martin",
    county_weights: {
      27091: 64.19,
      27165: 35.81,
    },
    county_names_all: "Martin|Watonwan",
    county_fips_all: "27091|27165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56164,
    lat: 44.04936,
    lng: -96.33361,
    city: "Pipestone",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5410,
    density: 8.7,
    county_fips: 27117,
    county_name: "Pipestone",
    county_weights: {
      27081: 9.35,
      27117: 87.29,
      46101: 3.36,
    },
    county_names_all: "Pipestone|Lincoln|Moody",
    county_fips_all: "27117|27081|46101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56165,
    lat: 43.7251,
    lng: -95.7097,
    city: "Reading",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 313,
    density: 3.1,
    county_fips: 27105,
    county_name: "Nobles",
    county_weights: {
      27105: 100,
    },
    county_names_all: "Nobles",
    county_fips_all: 27105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56166,
    lat: 44.20248,
    lng: -95.37401,
    city: "Revere",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 237,
    density: 2.8,
    county_fips: 27127,
    county_name: "Redwood",
    county_weights: {
      27033: 48.63,
      27127: 51.37,
    },
    county_names_all: "Redwood|Cottonwood",
    county_fips_all: "27127|27033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56167,
    lat: 43.55082,
    lng: -95.40524,
    city: "Round Lake",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 684,
    density: 5,
    county_fips: 27063,
    county_name: "Jackson",
    county_weights: {
      27063: 79.99,
      27105: 20.01,
    },
    county_names_all: "Jackson|Nobles",
    county_fips_all: "27063|27105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56168,
    lat: 43.61552,
    lng: -95.80358,
    city: "Rushmore",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 769,
    density: 3.1,
    county_fips: 27105,
    county_name: "Nobles",
    county_weights: {
      27105: 100,
    },
    county_names_all: "Nobles",
    county_fips_all: 27105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56169,
    lat: 44.33136,
    lng: -96.00555,
    city: "Russell",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 697,
    density: 4.9,
    county_fips: 27083,
    county_name: "Lyon",
    county_weights: {
      27083: 100,
    },
    county_names_all: "Lyon",
    county_fips_all: 27083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56170,
    lat: 44.16694,
    lng: -96.08647,
    city: "Ruthton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 612,
    density: 3.8,
    county_fips: 27117,
    county_name: "Pipestone",
    county_weights: {
      27081: 4.81,
      27083: 7.9,
      27101: 37.84,
      27117: 49.45,
    },
    county_names_all: "Pipestone|Murray|Lyon|Lincoln",
    county_fips_all: "27117|27101|27083|27081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56171,
    lat: 43.66902,
    lng: -94.75925,
    city: "Sherburn",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1734,
    density: 7.5,
    county_fips: 27091,
    county_name: "Martin",
    county_weights: {
      27091: 100,
    },
    county_names_all: "Martin",
    county_fips_all: 27091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56172,
    lat: 44.01212,
    lng: -95.7702,
    city: "Slayton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2994,
    density: 9.9,
    county_fips: 27101,
    county_name: "Murray",
    county_weights: {
      27101: 100,
    },
    county_names_all: "Murray",
    county_fips_all: 27101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56173,
    lat: 43.52505,
    lng: -96.24186,
    city: "Steen",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 323,
    density: 5.2,
    county_fips: 27133,
    county_name: "Rock",
    county_weights: {
      27133: 100,
    },
    county_names_all: "Rock",
    county_fips_all: 27133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56174,
    lat: 44.01525,
    lng: -95.30466,
    city: "Storden",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 353,
    density: 3.4,
    county_fips: 27033,
    county_name: "Cottonwood",
    county_weights: {
      27033: 100,
    },
    county_names_all: "Cottonwood",
    county_fips_all: 27033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56175,
    lat: 44.25595,
    lng: -95.63733,
    city: "Tracy",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3041,
    density: 8.7,
    county_fips: 27083,
    county_name: "Lyon",
    county_weights: {
      27083: 53.9,
      27101: 24.05,
      27127: 22.05,
    },
    county_names_all: "Lyon|Murray|Redwood",
    county_fips_all: "27083|27101|27127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56176,
    lat: 43.78319,
    lng: -94.72835,
    city: "Trimont",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1069,
    density: 6.6,
    county_fips: 27091,
    county_name: "Martin",
    county_weights: {
      27091: 100,
    },
    county_names_all: "Martin",
    county_fips_all: 27091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56178,
    lat: 44.28593,
    lng: -96.12997,
    city: "Tyler",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1846,
    density: 8.5,
    county_fips: 27081,
    county_name: "Lincoln",
    county_weights: {
      27081: 85.62,
      27083: 14.38,
    },
    county_names_all: "Lincoln|Lyon",
    county_fips_all: "27081|27083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56180,
    lat: 44.24424,
    lng: -95.46655,
    city: "Walnut Grove",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1151,
    density: 3.8,
    county_fips: 27127,
    county_name: "Redwood",
    county_weights: {
      27033: 12.68,
      27101: 15.87,
      27127: 71.45,
    },
    county_names_all: "Redwood|Murray|Cottonwood",
    county_fips_all: "27127|27101|27033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56181,
    lat: 43.67951,
    lng: -94.61549,
    city: "Welcome",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1224,
    density: 7.6,
    county_fips: 27091,
    county_name: "Martin",
    county_weights: {
      27091: 100,
    },
    county_names_all: "Martin",
    county_fips_all: 27091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56183,
    lat: 44.03404,
    lng: -95.42334,
    city: "Westbrook",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1395,
    density: 5.7,
    county_fips: 27033,
    county_name: "Cottonwood",
    county_weights: {
      27033: 73.6,
      27101: 26.4,
    },
    county_names_all: "Cottonwood|Murray",
    county_fips_all: "27033|27101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56185,
    lat: 43.7932,
    lng: -95.82659,
    city: "Wilmont",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 475,
    density: 4.2,
    county_fips: 27105,
    county_name: "Nobles",
    county_weights: {
      27105: 100,
    },
    county_names_all: "Nobles",
    county_fips_all: 27105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56186,
    lat: 44.02823,
    lng: -96.08131,
    city: "Woodstock",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 357,
    density: 2.2,
    county_fips: 27117,
    county_name: "Pipestone",
    county_weights: {
      27101: 39.44,
      27117: 60.56,
    },
    county_names_all: "Pipestone|Murray",
    county_fips_all: "27117|27101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56187,
    lat: 43.62357,
    lng: -95.58507,
    city: "Worthington",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14713,
    density: 33.7,
    county_fips: 27105,
    county_name: "Nobles",
    county_weights: {
      27063: 7.45,
      27105: 92.55,
    },
    county_names_all: "Nobles|Jackson",
    county_fips_all: "27105|27063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56201,
    lat: 45.10181,
    lng: -95.04226,
    city: "Willmar",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23465,
    density: 76.7,
    county_fips: 27067,
    county_name: "Kandiyohi",
    county_weights: {
      27067: 100,
    },
    county_names_all: "Kandiyohi",
    county_fips_all: 27067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56207,
    lat: 45.50266,
    lng: -96.0708,
    city: "Alberta",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 252,
    density: 2,
    county_fips: 27149,
    county_name: "Stevens",
    county_weights: {
      27149: 94.16,
      27151: 5.84,
    },
    county_names_all: "Stevens|Swift",
    county_fips_all: "27149|27151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56208,
    lat: 45.24422,
    lng: -96.00961,
    city: "Appleton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1988,
    density: 3.9,
    county_fips: 27151,
    county_name: "Swift",
    county_weights: {
      27011: 4.46,
      27023: 2.11,
      27073: 12.05,
      27151: 81.38,
    },
    county_names_all: "Swift|Lac qui Parle|Big Stone|Chippewa",
    county_fips_all: "27151|27073|27011|27023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56209,
    lat: 45.124,
    lng: -94.79931,
    city: "Atwater",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2446,
    density: 9.3,
    county_fips: 27067,
    county_name: "Kandiyohi",
    county_weights: {
      27067: 81.14,
      27093: 18.86,
    },
    county_names_all: "Kandiyohi|Meeker",
    county_fips_all: "27067|27093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56210,
    lat: 45.55739,
    lng: -96.55958,
    city: "Barry",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7,
    density: 15,
    county_fips: 27011,
    county_name: "Big Stone",
    county_weights: {
      27011: 100,
    },
    county_names_all: "Big Stone",
    county_fips_all: 27011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56211,
    lat: 45.58641,
    lng: -96.6828,
    city: "Beardsley",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 452,
    density: 1.7,
    county_fips: 27011,
    county_name: "Big Stone",
    county_weights: {
      27011: 54.12,
      27155: 45.88,
    },
    county_names_all: "Big Stone|Traverse",
    county_fips_all: "27011|27155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56212,
    lat: 45.13499,
    lng: -96.32459,
    city: "Bellingham",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 507,
    density: 2.4,
    county_fips: 27073,
    county_name: "Lac qui Parle",
    county_weights: {
      27073: 100,
    },
    county_names_all: "Lac qui Parle",
    county_fips_all: 27073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56214,
    lat: 44.60804,
    lng: -95.32943,
    city: "Belview",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 693,
    density: 4.2,
    county_fips: 27127,
    county_name: "Redwood",
    county_weights: {
      27127: 84.52,
      27173: 15.48,
    },
    county_names_all: "Redwood|Yellow Medicine",
    county_fips_all: "27127|27173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56215,
    lat: 45.31077,
    lng: -95.57233,
    city: "Benson",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4258,
    density: 7.8,
    county_fips: 27151,
    county_name: "Swift",
    county_weights: {
      27121: 7.5,
      27151: 92.5,
    },
    county_names_all: "Swift|Pope",
    county_fips_all: "27151|27121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56216,
    lat: 44.93886,
    lng: -95.05532,
    city: "Blomkest",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 728,
    density: 7.4,
    county_fips: 27067,
    county_name: "Kandiyohi",
    county_weights: {
      27067: 100,
    },
    county_names_all: "Kandiyohi",
    county_fips_all: 27067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56218,
    lat: 44.82642,
    lng: -95.94363,
    city: "Boyd",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 440,
    density: 1.7,
    county_fips: 27073,
    county_name: "Lac qui Parle",
    county_weights: {
      27073: 61.71,
      27173: 38.29,
    },
    county_names_all: "Lac qui Parle|Yellow Medicine",
    county_fips_all: "27073|27173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56219,
    lat: 45.5977,
    lng: -96.81913,
    city: "Browns Valley",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1224,
    density: 5.3,
    county_fips: 46109,
    county_name: "Roberts",
    county_weights: {
      27011: 8.28,
      27155: 36.6,
      46109: 55.12,
    },
    county_names_all: "Roberts|Traverse|Big Stone",
    county_fips_all: "46109|27155|27011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56220,
    lat: 44.73125,
    lng: -96.29339,
    city: "Canby",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2664,
    density: 3.7,
    county_fips: 27173,
    county_name: "Yellow Medicine",
    county_weights: {
      27073: 19.36,
      27081: 12.35,
      27173: 68.07,
      46039: 0.22,
    },
    county_names_all: "Yellow Medicine|Lac qui Parle|Lincoln|Deuel",
    county_fips_all: "27173|27073|27081|46039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56221,
    lat: 45.55583,
    lng: -96.1938,
    city: "Chokio",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 745,
    density: 2.1,
    county_fips: 27149,
    county_name: "Stevens",
    county_weights: {
      27011: 10.1,
      27149: 87.8,
      27155: 2.1,
    },
    county_names_all: "Stevens|Big Stone|Traverse",
    county_fips_all: "27149|27011|27155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56222,
    lat: 44.98586,
    lng: -95.36229,
    city: "Clara City",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2199,
    density: 9,
    county_fips: 27023,
    county_name: "Chippewa",
    county_weights: {
      27023: 100,
    },
    county_names_all: "Chippewa",
    county_fips_all: 27023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56223,
    lat: 44.76259,
    lng: -95.81691,
    city: "Clarkfield",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1468,
    density: 4.9,
    county_fips: 27173,
    county_name: "Yellow Medicine",
    county_weights: {
      27173: 100,
    },
    county_names_all: "Yellow Medicine",
    county_fips_all: 27173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56224,
    lat: 44.37628,
    lng: -95.05854,
    city: "Clements",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 333,
    density: 3.6,
    county_fips: 27127,
    county_name: "Redwood",
    county_weights: {
      27127: 100,
    },
    county_names_all: "Redwood",
    county_fips_all: 27127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56225,
    lat: 45.45325,
    lng: -96.4482,
    city: "Clinton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 660,
    density: 2.4,
    county_fips: 27011,
    county_name: "Big Stone",
    county_weights: {
      27011: 100,
    },
    county_names_all: "Big Stone",
    county_fips_all: 27011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56226,
    lat: 45.41065,
    lng: -95.67705,
    city: "Clontarf",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 211,
    density: 2.3,
    county_fips: 27121,
    county_name: "Pope",
    county_weights: {
      27121: 50.67,
      27151: 49.33,
    },
    county_names_all: "Pope|Swift",
    county_fips_all: "27121|27151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56227,
    lat: 45.29436,
    lng: -96.16938,
    city: "Correll",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 249,
    density: 1.7,
    county_fips: 27011,
    county_name: "Big Stone",
    county_weights: {
      27011: 100,
    },
    county_names_all: "Big Stone",
    county_fips_all: 27011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56228,
    lat: 44.93619,
    lng: -94.67715,
    city: "Cosmos",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 951,
    density: 6.4,
    county_fips: 27093,
    county_name: "Meeker",
    county_weights: {
      27093: 93.01,
      27129: 6.99,
    },
    county_names_all: "Meeker|Renville",
    county_fips_all: "27093|27129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56229,
    lat: 44.59385,
    lng: -95.72398,
    city: "Cottonwood",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1782,
    density: 6.7,
    county_fips: 27083,
    county_name: "Lyon",
    county_weights: {
      27083: 78.33,
      27173: 21.67,
    },
    county_names_all: "Lyon|Yellow Medicine",
    county_fips_all: "27083|27173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56230,
    lat: 44.79284,
    lng: -95.09288,
    city: "Danube",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 776,
    density: 4.8,
    county_fips: 27129,
    county_name: "Renville",
    county_weights: {
      27129: 100,
    },
    county_names_all: "Renville",
    county_fips_all: 27129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56231,
    lat: 45.2788,
    lng: -95.76381,
    city: "Danvers",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 411,
    density: 1.7,
    county_fips: 27151,
    county_name: "Swift",
    county_weights: {
      27151: 100,
    },
    county_names_all: "Swift",
    county_fips_all: 27151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56232,
    lat: 44.92836,
    lng: -96.03968,
    city: "Dawson",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2299,
    density: 6.3,
    county_fips: 27073,
    county_name: "Lac qui Parle",
    county_weights: {
      27073: 100,
    },
    county_names_all: "Lac qui Parle",
    county_fips_all: 27073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56235,
    lat: 45.70588,
    lng: -96.01079,
    city: "Donnelly",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 502,
    density: 2.4,
    county_fips: 27149,
    county_name: "Stevens",
    county_weights: {
      27149: 100,
    },
    county_names_all: "Stevens",
    county_fips_all: 27149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56236,
    lat: 45.66341,
    lng: -96.40312,
    city: "Dumont",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 297,
    density: 1.1,
    county_fips: 27155,
    county_name: "Traverse",
    county_weights: {
      27011: 6.06,
      27155: 93.94,
    },
    county_names_all: "Traverse|Big Stone",
    county_fips_all: "27155|27011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56237,
    lat: 44.61956,
    lng: -95.43489,
    city: "Echo",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 550,
    density: 3.4,
    county_fips: 27173,
    county_name: "Yellow Medicine",
    county_weights: {
      27173: 100,
    },
    county_names_all: "Yellow Medicine",
    county_fips_all: 27173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56239,
    lat: 44.50416,
    lng: -95.91079,
    city: "Ghent",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 691,
    density: 10.2,
    county_fips: 27083,
    county_name: "Lyon",
    county_weights: {
      27083: 100,
    },
    county_names_all: "Lyon",
    county_fips_all: 27083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56240,
    lat: 45.56327,
    lng: -96.47475,
    city: "Graceville",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 910,
    density: 2.4,
    county_fips: 27011,
    county_name: "Big Stone",
    county_weights: {
      27011: 64.45,
      27155: 35.55,
    },
    county_names_all: "Big Stone|Traverse",
    county_fips_all: "27011|27155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56241,
    lat: 44.79654,
    lng: -95.57944,
    city: "Granite Falls",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3753,
    density: 9.9,
    county_fips: 27173,
    county_name: "Yellow Medicine",
    county_weights: {
      27023: 22.51,
      27129: 9.7,
      27173: 67.79,
    },
    county_names_all: "Yellow Medicine|Chippewa|Renville",
    county_fips_all: "27173|27023|27129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56243,
    lat: 45.16868,
    lng: -94.6799,
    city: "Grove City",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1802,
    density: 7.5,
    county_fips: 27093,
    county_name: "Meeker",
    county_weights: {
      27093: 100,
    },
    county_names_all: "Meeker",
    county_fips_all: 27093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56244,
    lat: 45.48372,
    lng: -95.77963,
    city: "Hancock",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1608,
    density: 4.7,
    county_fips: 27149,
    county_name: "Stevens",
    county_weights: {
      27121: 34.3,
      27149: 59.37,
      27151: 6.33,
    },
    county_names_all: "Stevens|Pope|Swift",
    county_fips_all: "27149|27121|27151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56245,
    lat: 44.68508,
    lng: -95.67574,
    city: "Hanley Falls",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 735,
    density: 6.2,
    county_fips: 27173,
    county_name: "Yellow Medicine",
    county_weights: {
      27173: 100,
    },
    county_names_all: "Yellow Medicine",
    county_fips_all: 27173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56248,
    lat: 45.79317,
    lng: -96.13677,
    city: "Herman",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 854,
    density: 2.4,
    county_fips: 27051,
    county_name: "Grant",
    county_weights: {
      27051: 69.16,
      27149: 17.31,
      27155: 13.53,
    },
    county_names_all: "Grant|Stevens|Traverse",
    county_fips_all: "27051|27149|27155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56249,
    lat: 45.31795,
    lng: -95.89899,
    city: "Holloway",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 308,
    density: 1.8,
    county_fips: 27151,
    county_name: "Swift",
    county_weights: {
      27151: 100,
    },
    county_names_all: "Swift",
    county_fips_all: 27151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56251,
    lat: 45.14046,
    lng: -94.9198,
    city: "Kandiyohi",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 810,
    density: 9.3,
    county_fips: 27067,
    county_name: "Kandiyohi",
    county_weights: {
      27067: 100,
    },
    county_names_all: "Kandiyohi",
    county_fips_all: 27067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56252,
    lat: 45.17785,
    lng: -95.30397,
    city: "Kerkhoven",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1175,
    density: 6.1,
    county_fips: 27151,
    county_name: "Swift",
    county_weights: {
      27023: 32.1,
      27067: 8.18,
      27151: 59.72,
    },
    county_names_all: "Swift|Chippewa|Kandiyohi",
    county_fips_all: "27151|27023|27067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56253,
    lat: 44.9628,
    lng: -94.87889,
    city: "Lake Lillian",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 980,
    density: 3.6,
    county_fips: 27067,
    county_name: "Kandiyohi",
    county_weights: {
      27067: 100,
    },
    county_names_all: "Kandiyohi",
    county_fips_all: 27067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56255,
    lat: 44.39426,
    lng: -95.41707,
    city: "Lucan",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 375,
    density: 3.8,
    county_fips: 27127,
    county_name: "Redwood",
    county_weights: {
      27127: 100,
    },
    county_names_all: "Redwood",
    county_fips_all: 27127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56256,
    lat: 45.02306,
    lng: -96.19986,
    city: "Madison",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2417,
    density: 4,
    county_fips: 27073,
    county_name: "Lac qui Parle",
    county_weights: {
      27073: 100,
    },
    county_names_all: "Lac qui Parle",
    county_fips_all: 27073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56257,
    lat: 44.9684,
    lng: -96.40275,
    city: "Marietta",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 514,
    density: 2.2,
    county_fips: 27073,
    county_name: "Lac qui Parle",
    county_weights: {
      27073: 95.08,
      46039: 4.92,
    },
    county_names_all: "Lac qui Parle|Deuel",
    county_fips_all: "27073|46039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56258,
    lat: 44.44121,
    lng: -95.75906,
    city: "Marshall",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15666,
    density: 31.2,
    county_fips: 27083,
    county_name: "Lyon",
    county_weights: {
      27083: 96.02,
      27127: 3.98,
    },
    county_names_all: "Lyon|Redwood",
    county_fips_all: "27083|27127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56260,
    lat: 44.96338,
    lng: -95.48571,
    city: "Maynard",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 969,
    density: 3.8,
    county_fips: 27023,
    county_name: "Chippewa",
    county_weights: {
      27023: 87.39,
      27129: 12.61,
    },
    county_names_all: "Chippewa|Renville",
    county_fips_all: "27023|27129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56262,
    lat: 45.12276,
    lng: -95.86843,
    city: "Milan",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 716,
    density: 4,
    county_fips: 27023,
    county_name: "Chippewa",
    county_weights: {
      27023: 80.38,
      27151: 19.62,
    },
    county_names_all: "Chippewa|Swift",
    county_fips_all: "27023|27151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56263,
    lat: 44.41577,
    lng: -95.54086,
    city: "Milroy",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 437,
    density: 3.3,
    county_fips: 27127,
    county_name: "Redwood",
    county_weights: {
      27083: 16.15,
      27127: 83.85,
    },
    county_names_all: "Redwood|Lyon",
    county_fips_all: "27127|27083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56264,
    lat: 44.57529,
    lng: -95.98001,
    city: "Minneota",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2117,
    density: 6.3,
    county_fips: 27083,
    county_name: "Lyon",
    county_weights: {
      27081: 4.29,
      27083: 69.91,
      27173: 25.8,
    },
    county_names_all: "Lyon|Yellow Medicine|Lincoln",
    county_fips_all: "27083|27173|27081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56265,
    lat: 45.0064,
    lng: -95.70098,
    city: "Montevideo",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7019,
    density: 10.3,
    county_fips: 27023,
    county_name: "Chippewa",
    county_weights: {
      27023: 75.15,
      27073: 18.9,
      27173: 5.95,
    },
    county_names_all: "Chippewa|Lac qui Parle|Yellow Medicine",
    county_fips_all: "27023|27073|27173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56266,
    lat: 44.41637,
    lng: -94.9133,
    city: "Morgan",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1393,
    density: 5.4,
    county_fips: 27127,
    county_name: "Redwood",
    county_weights: {
      27015: 24.4,
      27127: 75.6,
    },
    county_names_all: "Redwood|Brown",
    county_fips_all: "27127|27015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56267,
    lat: 45.58512,
    lng: -95.9322,
    city: "Morris",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6955,
    density: 13.8,
    county_fips: 27149,
    county_name: "Stevens",
    county_weights: {
      27149: 100,
    },
    county_names_all: "Stevens",
    county_fips_all: 27149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56270,
    lat: 44.56013,
    lng: -94.97962,
    city: "Morton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1157,
    density: 9.3,
    county_fips: 27129,
    county_name: "Renville",
    county_weights: {
      27127: 37.01,
      27129: 62.99,
    },
    county_names_all: "Renville|Redwood",
    county_fips_all: "27129|27127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56271,
    lat: 45.24125,
    lng: -95.41288,
    city: "Murdock",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1202,
    density: 3.1,
    county_fips: 27151,
    county_name: "Swift",
    county_weights: {
      27023: 17.96,
      27151: 82.04,
    },
    county_names_all: "Swift|Chippewa",
    county_fips_all: "27151|27023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56273,
    lat: 45.32163,
    lng: -94.96777,
    city: "New London",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5066,
    density: 20.2,
    county_fips: 27067,
    county_name: "Kandiyohi",
    county_weights: {
      27067: 100,
    },
    county_names_all: "Kandiyohi",
    county_fips_all: 27067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56274,
    lat: 45.90145,
    lng: -96.2383,
    city: "Norcross",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 211,
    density: 1,
    county_fips: 27051,
    county_name: "Grant",
    county_weights: {
      27051: 62.59,
      27155: 37.41,
    },
    county_names_all: "Grant|Traverse",
    county_fips_all: "27051|27155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56276,
    lat: 45.24134,
    lng: -96.31249,
    city: "Odessa",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 180,
    density: 1.3,
    county_fips: 27073,
    county_name: "Lac qui Parle",
    county_weights: {
      27011: 48.16,
      27073: 51.84,
    },
    county_names_all: "Lac qui Parle|Big Stone",
    county_fips_all: "27073|27011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56277,
    lat: 44.76742,
    lng: -94.99036,
    city: "Olivia",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3123,
    density: 10.8,
    county_fips: 27129,
    county_name: "Renville",
    county_weights: {
      27129: 100,
    },
    county_names_all: "Renville",
    county_fips_all: 27129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56278,
    lat: 45.345,
    lng: -96.37718,
    city: "Ortonville",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2710,
    density: 7.7,
    county_fips: 27011,
    county_name: "Big Stone",
    county_weights: {
      27011: 90.19,
      27073: 9.81,
    },
    county_names_all: "Big Stone|Lac qui Parle",
    county_fips_all: "27011|27073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56279,
    lat: 45.21651,
    lng: -95.17585,
    city: "Pennock",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1272,
    density: 7.9,
    county_fips: 27067,
    county_name: "Kandiyohi",
    county_weights: {
      27067: 100,
    },
    county_names_all: "Kandiyohi",
    county_fips_all: 27067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56280,
    lat: 44.63212,
    lng: -96.16719,
    city: "Porter",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 465,
    density: 2.6,
    county_fips: 27081,
    county_name: "Lincoln",
    county_weights: {
      27081: 50.32,
      27173: 49.68,
    },
    county_names_all: "Lincoln|Yellow Medicine",
    county_fips_all: "27081|27173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56281,
    lat: 44.94833,
    lng: -95.16479,
    city: "Prinsburg",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 702,
    density: 21,
    county_fips: 27067,
    county_name: "Kandiyohi",
    county_weights: {
      27067: 100,
    },
    county_names_all: "Kandiyohi",
    county_fips_all: 27067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56282,
    lat: 45.03089,
    lng: -95.21862,
    city: "Raymond",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1615,
    density: 5.8,
    county_fips: 27067,
    county_name: "Kandiyohi",
    county_weights: {
      27023: 32.71,
      27067: 67.29,
    },
    county_names_all: "Kandiyohi|Chippewa",
    county_fips_all: "27067|27023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56283,
    lat: 44.53208,
    lng: -95.14225,
    city: "Redwood Falls",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6308,
    density: 13.7,
    county_fips: 27127,
    county_name: "Redwood",
    county_weights: {
      27127: 83.97,
      27129: 16.03,
    },
    county_names_all: "Redwood|Renville",
    county_fips_all: "27127|27129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56284,
    lat: 44.77729,
    lng: -95.20204,
    city: "Renville",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2078,
    density: 5.9,
    county_fips: 27129,
    county_name: "Renville",
    county_weights: {
      27067: 9.02,
      27127: 3.16,
      27129: 87.82,
    },
    county_names_all: "Renville|Kandiyohi|Redwood",
    county_fips_all: "27129|27067|27127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56285,
    lat: 44.78837,
    lng: -95.34797,
    city: "Sacred Heart",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1138,
    density: 4.4,
    county_fips: 27129,
    county_name: "Renville",
    county_weights: {
      27129: 100,
    },
    county_names_all: "Renville",
    county_fips_all: 27129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56287,
    lat: 44.47537,
    lng: -95.3262,
    city: "Seaforth",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63,
    density: 54.8,
    county_fips: 27127,
    county_name: "Redwood",
    county_weights: {
      27127: 100,
    },
    county_names_all: "Redwood",
    county_fips_all: 27127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56288,
    lat: 45.24218,
    lng: -94.94847,
    city: "Spicer",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4724,
    density: 37.4,
    county_fips: 27067,
    county_name: "Kandiyohi",
    county_weights: {
      27067: 100,
    },
    county_names_all: "Kandiyohi",
    county_fips_all: 27067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56289,
    lat: 45.33334,
    lng: -95.2236,
    city: "Sunburg",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 656,
    density: 4.9,
    county_fips: 27067,
    county_name: "Kandiyohi",
    county_weights: {
      27067: 70.36,
      27151: 29.64,
    },
    county_names_all: "Kandiyohi|Swift",
    county_fips_all: "27067|27151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56291,
    lat: 44.62254,
    lng: -96.06933,
    city: "Taunton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 381,
    density: 2.2,
    county_fips: 27173,
    county_name: "Yellow Medicine",
    county_weights: {
      27081: 26.14,
      27083: 31.43,
      27173: 42.43,
    },
    county_names_all: "Yellow Medicine|Lyon|Lincoln",
    county_fips_all: "27173|27083|27081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56292,
    lat: 44.49734,
    lng: -95.44863,
    city: "Vesta",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 606,
    density: 4.1,
    county_fips: 27127,
    county_name: "Redwood",
    county_weights: {
      27127: 96.48,
      27173: 3.52,
    },
    county_names_all: "Redwood|Yellow Medicine",
    county_fips_all: "27127|27173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56293,
    lat: 44.41598,
    lng: -95.26559,
    city: "Wabasso",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1254,
    density: 5.7,
    county_fips: 27127,
    county_name: "Redwood",
    county_weights: {
      27127: 100,
    },
    county_names_all: "Redwood",
    county_fips_all: 27127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56294,
    lat: 44.31481,
    lng: -95.21313,
    city: "Wanda",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 94,
    density: 140.1,
    county_fips: 27127,
    county_name: "Redwood",
    county_weights: {
      27127: 100,
    },
    county_names_all: "Redwood",
    county_fips_all: 27127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56295,
    lat: 45.0437,
    lng: -95.84292,
    city: "Watson",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 262,
    density: 4.5,
    county_fips: 27023,
    county_name: "Chippewa",
    county_weights: {
      27023: 100,
    },
    county_names_all: "Chippewa",
    county_fips_all: 27023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56296,
    lat: 45.82981,
    lng: -96.46953,
    city: "Wheaton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1845,
    density: 3,
    county_fips: 27155,
    county_name: "Traverse",
    county_weights: {
      27155: 100,
    },
    county_names_all: "Traverse",
    county_fips_all: 27155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56297,
    lat: 44.63005,
    lng: -95.54428,
    city: "Wood Lake",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 794,
    density: 4.5,
    county_fips: 27173,
    county_name: "Yellow Medicine",
    county_weights: {
      27127: 5.94,
      27173: 94.06,
    },
    county_names_all: "Yellow Medicine|Redwood",
    county_fips_all: "27173|27127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56301,
    lat: 45.48718,
    lng: -94.24307,
    city: "Saint Cloud",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34862,
    density: 175.8,
    county_fips: 27145,
    county_name: "Stearns",
    county_weights: {
      27145: 100,
    },
    county_names_all: "Stearns",
    county_fips_all: 27145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56303,
    lat: 45.57422,
    lng: -94.21117,
    city: "Saint Cloud",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25086,
    density: 883.7,
    county_fips: 27145,
    county_name: "Stearns",
    county_weights: {
      27145: 100,
    },
    county_names_all: "Stearns",
    county_fips_all: 27145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56304,
    lat: 45.52512,
    lng: -94.05199,
    city: "Saint Cloud",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16713,
    density: 106.4,
    county_fips: 27141,
    county_name: "Sherburne",
    county_weights: {
      27009: 13.19,
      27141: 86.81,
    },
    county_names_all: "Sherburne|Benton",
    county_fips_all: "27141|27009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56307,
    lat: 45.62666,
    lng: -94.58769,
    city: "Albany",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5428,
    density: 19.8,
    county_fips: 27145,
    county_name: "Stearns",
    county_weights: {
      27097: 0.69,
      27145: 99.31,
    },
    county_names_all: "Stearns|Morrison",
    county_fips_all: "27145|27097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56308,
    lat: 45.87047,
    lng: -95.38985,
    city: "Alexandria",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25281,
    density: 62.6,
    county_fips: 27041,
    county_name: "Douglas",
    county_weights: {
      27041: 96.13,
      27121: 3.87,
    },
    county_names_all: "Douglas|Pope",
    county_fips_all: "27041|27121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56309,
    lat: 46.08035,
    lng: -95.80202,
    city: "Ashby",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1430,
    density: 9.6,
    county_fips: 27051,
    county_name: "Grant",
    county_weights: {
      27041: 5.21,
      27051: 59.94,
      27111: 34.85,
    },
    county_names_all: "Grant|Otter Tail|Douglas",
    county_fips_all: "27051|27111|27041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56310,
    lat: 45.63399,
    lng: -94.44352,
    city: "Avon",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5754,
    density: 31,
    county_fips: 27145,
    county_name: "Stearns",
    county_weights: {
      27145: 100,
    },
    county_names_all: "Stearns",
    county_fips_all: 27145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56311,
    lat: 45.89756,
    lng: -95.89852,
    city: "Barrett",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 724,
    density: 3.9,
    county_fips: 27051,
    county_name: "Grant",
    county_weights: {
      27051: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 27051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56312,
    lat: 45.46285,
    lng: -94.95323,
    city: "Belgrade",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2670,
    density: 6,
    county_fips: 27145,
    county_name: "Stearns",
    county_weights: {
      27067: 25.53,
      27145: 74.47,
    },
    county_names_all: "Stearns|Kandiyohi",
    county_fips_all: "27145|27067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56313,
    lat: 45.78403,
    lng: -93.55273,
    city: "Bock",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 90,
    density: 240.6,
    county_fips: 27095,
    county_name: "Mille Lacs",
    county_weights: {
      27095: 100,
    },
    county_names_all: "Mille Lacs",
    county_fips_all: 27095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56314,
    lat: 45.81139,
    lng: -94.43189,
    city: "Bowlus",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1238,
    density: 11.3,
    county_fips: 27097,
    county_name: "Morrison",
    county_weights: {
      27097: 90.31,
      27145: 9.69,
    },
    county_names_all: "Morrison|Stearns",
    county_fips_all: "27097|27145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56315,
    lat: 45.97996,
    lng: -95.59211,
    city: "Brandon",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1810,
    density: 10.1,
    county_fips: 27041,
    county_name: "Douglas",
    county_weights: {
      27041: 96.83,
      27111: 3.17,
    },
    county_names_all: "Douglas|Otter Tail",
    county_fips_all: "27041|27111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56316,
    lat: 45.49959,
    lng: -95.14992,
    city: "Brooten",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1505,
    density: 4.3,
    county_fips: 27121,
    county_name: "Pope",
    county_weights: {
      27067: 11.43,
      27121: 52.3,
      27145: 36.27,
    },
    county_names_all: "Pope|Stearns|Kandiyohi",
    county_fips_all: "27121|27145|27067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56318,
    lat: 45.85332,
    lng: -94.67085,
    city: "Burtrum",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 967,
    density: 9.3,
    county_fips: 27153,
    county_name: "Todd",
    county_weights: {
      27097: 31.86,
      27153: 68.14,
    },
    county_names_all: "Todd|Morrison",
    county_fips_all: "27153|27097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56319,
    lat: 46.00488,
    lng: -95.22322,
    city: "Carlos",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1246,
    density: 11.9,
    county_fips: 27041,
    county_name: "Douglas",
    county_weights: {
      27041: 80.76,
      27153: 19.24,
    },
    county_names_all: "Douglas|Todd",
    county_fips_all: "27041|27153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56320,
    lat: 45.4629,
    lng: -94.4171,
    city: "Cold Spring",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8625,
    density: 65.2,
    county_fips: 27145,
    county_name: "Stearns",
    county_weights: {
      27145: 100,
    },
    county_names_all: "Stearns",
    county_fips_all: 27145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56321,
    lat: 45.57969,
    lng: -94.39288,
    city: "Collegeville",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1464,
    density: 892,
    county_fips: 27145,
    county_name: "Stearns",
    county_weights: {
      27145: 100,
    },
    county_names_all: "Stearns",
    county_fips_all: 27145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56323,
    lat: 45.63321,
    lng: -95.72586,
    city: "Cyrus",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 512,
    density: 4.6,
    county_fips: 27121,
    county_name: "Pope",
    county_weights: {
      27121: 79.94,
      27149: 20.06,
    },
    county_names_all: "Pope|Stevens",
    county_fips_all: "27121|27149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56324,
    lat: 46.16385,
    lng: -95.90766,
    city: "Dalton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1090,
    density: 7.2,
    county_fips: 27111,
    county_name: "Otter Tail",
    county_weights: {
      27051: 1.77,
      27111: 98.23,
    },
    county_names_all: "Otter Tail|Grant",
    county_fips_all: "27111|27051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56325,
    lat: 45.56303,
    lng: -94.94732,
    city: "Elrosa",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 200,
    density: 484,
    county_fips: 27145,
    county_name: "Stearns",
    county_weights: {
      27145: 100,
    },
    county_names_all: "Stearns",
    county_fips_all: 27145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56326,
    lat: 46.02506,
    lng: -95.68596,
    city: "Evansville",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1740,
    density: 7.1,
    county_fips: 27041,
    county_name: "Douglas",
    county_weights: {
      27041: 89.2,
      27051: 2.11,
      27111: 8.69,
    },
    county_names_all: "Douglas|Otter Tail|Grant",
    county_fips_all: "27041|27111|27051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56327,
    lat: 45.75893,
    lng: -95.61336,
    city: "Farwell",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 829,
    density: 6.6,
    county_fips: 27121,
    county_name: "Pope",
    county_weights: {
      27041: 46.63,
      27121: 53.37,
    },
    county_names_all: "Pope|Douglas",
    county_fips_all: "27121|27041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56328,
    lat: 45.9519,
    lng: -94.52147,
    city: "Flensburg",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 150,
    density: 27.9,
    county_fips: 27097,
    county_name: "Morrison",
    county_weights: {
      27097: 100,
    },
    county_names_all: "Morrison",
    county_fips_all: 27097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56329,
    lat: 45.70934,
    lng: -93.90577,
    city: "Foley",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7377,
    density: 14.8,
    county_fips: 27009,
    county_name: "Benton",
    county_weights: {
      27009: 88.02,
      27097: 11.63,
      27141: 0.35,
    },
    county_names_all: "Benton|Morrison|Sherburne",
    county_fips_all: "27009|27097|27141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56330,
    lat: 45.75018,
    lng: -93.75117,
    city: "Foreston",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1692,
    density: 16.5,
    county_fips: 27095,
    county_name: "Mille Lacs",
    county_weights: {
      27009: 37.38,
      27095: 62.62,
    },
    county_names_all: "Mille Lacs|Benton",
    county_fips_all: "27095|27009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56331,
    lat: 45.67926,
    lng: -94.6742,
    city: "Freeport",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2462,
    density: 13.7,
    county_fips: 27145,
    county_name: "Stearns",
    county_weights: {
      27097: 1.12,
      27145: 98.88,
    },
    county_names_all: "Stearns|Morrison",
    county_fips_all: "27145|27097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56332,
    lat: 45.96993,
    lng: -95.50554,
    city: "Garfield",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1589,
    density: 11.8,
    county_fips: 27041,
    county_name: "Douglas",
    county_weights: {
      27041: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 27041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56334,
    lat: 45.58402,
    lng: -95.34765,
    city: "Glenwood",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5590,
    density: 10.5,
    county_fips: 27121,
    county_name: "Pope",
    county_weights: {
      27041: 1.23,
      27121: 98.77,
    },
    county_names_all: "Pope|Douglas",
    county_fips_all: "27121|27041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56335,
    lat: 45.60137,
    lng: -94.85941,
    city: "Greenwald",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 217,
    density: 117.6,
    county_fips: 27145,
    county_name: "Stearns",
    county_weights: {
      27145: 100,
    },
    county_names_all: "Stearns",
    county_fips_all: 27145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56336,
    lat: 45.82349,
    lng: -94.76175,
    city: "Grey Eagle",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1521,
    density: 12,
    county_fips: 27153,
    county_name: "Todd",
    county_weights: {
      27145: 3,
      27153: 97,
    },
    county_names_all: "Todd|Stearns",
    county_fips_all: "27153|27145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56338,
    lat: 46.00631,
    lng: -93.88089,
    city: "Hillman",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1507,
    density: 3.4,
    county_fips: 27097,
    county_name: "Morrison",
    county_weights: {
      27035: 5.83,
      27097: 94.17,
    },
    county_names_all: "Morrison|Crow Wing",
    county_fips_all: "27097|27035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56339,
    lat: 45.8258,
    lng: -95.82129,
    city: "Hoffman",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 988,
    density: 6.3,
    county_fips: 27051,
    county_name: "Grant",
    county_weights: {
      27041: 14.28,
      27051: 85.72,
    },
    county_names_all: "Grant|Douglas",
    county_fips_all: "27051|27041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56340,
    lat: 45.75534,
    lng: -94.44871,
    city: "Holdingford",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2366,
    density: 17.9,
    county_fips: 27145,
    county_name: "Stearns",
    county_weights: {
      27097: 28.42,
      27145: 71.58,
    },
    county_names_all: "Stearns|Morrison",
    county_fips_all: "27145|27097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56342,
    lat: 46.18347,
    lng: -93.40392,
    city: "Isle",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2660,
    density: 5.3,
    county_fips: 27001,
    county_name: "Aitkin",
    county_weights: {
      27001: 39.72,
      27065: 34.63,
      27095: 25.65,
    },
    county_names_all: "Aitkin|Kanabec|Mille Lacs",
    county_fips_all: "27001|27065|27095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56343,
    lat: 45.79088,
    lng: -95.69765,
    city: "Kensington",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 953,
    density: 5.3,
    county_fips: 27041,
    county_name: "Douglas",
    county_weights: {
      27041: 67.75,
      27051: 5.28,
      27121: 16.8,
      27149: 10.17,
    },
    county_names_all: "Douglas|Pope|Stevens|Grant",
    county_fips_all: "27041|27121|27149|27051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56345,
    lat: 46.00748,
    lng: -94.38032,
    city: "Little Falls",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14635,
    density: 21.9,
    county_fips: 27097,
    county_name: "Morrison",
    county_weights: {
      27097: 100,
    },
    county_names_all: "Morrison",
    county_fips_all: 27097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56347,
    lat: 45.96978,
    lng: -94.86155,
    city: "Long Prairie",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7519,
    density: 14.9,
    county_fips: 27153,
    county_name: "Todd",
    county_weights: {
      27097: 3.35,
      27153: 96.65,
    },
    county_names_all: "Todd|Morrison",
    county_fips_all: "27153|27097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56349,
    lat: 45.72373,
    lng: -95.52456,
    city: "Lowry",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 764,
    density: 7.1,
    county_fips: 27121,
    county_name: "Pope",
    county_weights: {
      27041: 12.66,
      27121: 87.34,
    },
    county_names_all: "Pope|Douglas",
    county_fips_all: "27121|27041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56350,
    lat: 46.31101,
    lng: -93.23922,
    city: "McGrath",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 514,
    density: 0.9,
    county_fips: 27001,
    county_name: "Aitkin",
    county_weights: {
      27001: 100,
    },
    county_names_all: "Aitkin",
    county_fips_all: 27001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56352,
    lat: 45.65078,
    lng: -94.80076,
    city: "Melrose",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6022,
    density: 21.2,
    county_fips: 27145,
    county_name: "Stearns",
    county_weights: {
      27145: 100,
    },
    county_names_all: "Stearns",
    county_fips_all: 27145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56353,
    lat: 45.79667,
    lng: -93.62587,
    city: "Milaca",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9142,
    density: 18.6,
    county_fips: 27095,
    county_name: "Mille Lacs",
    county_weights: {
      27059: 2.69,
      27065: 2.6,
      27095: 94.59,
      27097: 0.12,
    },
    county_names_all: "Mille Lacs|Isanti|Kanabec|Morrison",
    county_fips_all: "27095|27059|27065|27097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56354,
    lat: 46.06034,
    lng: -95.27496,
    city: "Miltona",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1320,
    density: 12.1,
    county_fips: 27041,
    county_name: "Douglas",
    county_weights: {
      27041: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 27041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56355,
    lat: 45.94007,
    lng: -95.24031,
    city: "Nelson",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 551,
    density: 8.3,
    county_fips: 27041,
    county_name: "Douglas",
    county_weights: {
      27041: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 27041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56356,
    lat: 45.63334,
    lng: -94.73332,
    city: "New Munich",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 297,
    density: 69.4,
    county_fips: 27145,
    county_name: "Stearns",
    county_weights: {
      27145: 100,
    },
    county_names_all: "Stearns",
    county_fips_all: 27145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56357,
    lat: 45.69684,
    lng: -93.8007,
    city: "Oak Park",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1303,
    density: 13.8,
    county_fips: 27009,
    county_name: "Benton",
    county_weights: {
      27009: 79.37,
      27095: 20.63,
    },
    county_names_all: "Benton|Mille Lacs",
    county_fips_all: "27009|27095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56358,
    lat: 45.84069,
    lng: -93.4488,
    city: "Ogilvie",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3318,
    density: 10.2,
    county_fips: 27065,
    county_name: "Kanabec",
    county_weights: {
      27059: 4.63,
      27065: 82.21,
      27095: 13.16,
    },
    county_names_all: "Kanabec|Mille Lacs|Isanti",
    county_fips_all: "27065|27095|27059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56359,
    lat: 46.08979,
    lng: -93.67786,
    city: "Onamia",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3568,
    density: 8.1,
    county_fips: 27095,
    county_name: "Mille Lacs",
    county_weights: {
      27095: 100,
    },
    county_names_all: "Mille Lacs",
    county_fips_all: 27095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56360,
    lat: 45.87482,
    lng: -95.12686,
    city: "Osakis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3824,
    density: 11.1,
    county_fips: 27153,
    county_name: "Todd",
    county_weights: {
      27041: 44.96,
      27153: 55.04,
    },
    county_names_all: "Todd|Douglas",
    county_fips_all: "27153|27041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56361,
    lat: 46.16146,
    lng: -95.3351,
    city: "Parkers Prairie",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2547,
    density: 6.2,
    county_fips: 27111,
    county_name: "Otter Tail",
    county_weights: {
      27041: 16.45,
      27111: 83.55,
    },
    county_names_all: "Otter Tail|Douglas",
    county_fips_all: "27111|27041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56362,
    lat: 45.40524,
    lng: -94.71525,
    city: "Paynesville",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5657,
    density: 14.6,
    county_fips: 27145,
    county_name: "Stearns",
    county_weights: {
      27067: 9.6,
      27093: 13.57,
      27145: 76.83,
    },
    county_names_all: "Stearns|Meeker|Kandiyohi",
    county_fips_all: "27145|27093|27067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56363,
    lat: 45.69627,
    lng: -93.65409,
    city: "Pease",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 156,
    density: 54.2,
    county_fips: 27095,
    county_name: "Mille Lacs",
    county_weights: {
      27095: 100,
    },
    county_names_all: "Mille Lacs",
    county_fips_all: 27095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56364,
    lat: 46.01605,
    lng: -94.06704,
    city: "Pierz",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5742,
    density: 9.2,
    county_fips: 27097,
    county_name: "Morrison",
    county_weights: {
      27035: 4.57,
      27097: 95.43,
    },
    county_names_all: "Morrison|Crow Wing",
    county_fips_all: "27097|27035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56367,
    lat: 45.76107,
    lng: -94.17026,
    city: "Rice",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6910,
    density: 26.2,
    county_fips: 27009,
    county_name: "Benton",
    county_weights: {
      27009: 82.48,
      27145: 17.52,
    },
    county_names_all: "Benton|Stearns",
    county_fips_all: "27009|27145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56368,
    lat: 45.45158,
    lng: -94.5392,
    city: "Richmond",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4371,
    density: 23.9,
    county_fips: 27145,
    county_name: "Stearns",
    county_weights: {
      27145: 100,
    },
    county_names_all: "Stearns",
    county_fips_all: 27145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56369,
    lat: 45.46904,
    lng: -94.3359,
    city: "Rockville",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 569,
    density: 387.6,
    county_fips: 27145,
    county_name: "Stearns",
    county_weights: {
      27145: 100,
    },
    county_names_all: "Stearns",
    county_fips_all: 27145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56371,
    lat: 45.43333,
    lng: -94.63707,
    city: "Roscoe",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 129,
    density: 103,
    county_fips: 27145,
    county_name: "Stearns",
    county_weights: {
      27145: 100,
    },
    county_names_all: "Stearns",
    county_fips_all: 27145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56373,
    lat: 45.85456,
    lng: -94.23789,
    city: "Royalton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3155,
    density: 12.2,
    county_fips: 27097,
    county_name: "Morrison",
    county_weights: {
      27009: 9.65,
      27097: 90.35,
    },
    county_names_all: "Morrison|Benton",
    county_fips_all: "27097|27009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56374,
    lat: 45.60381,
    lng: -94.33816,
    city: "Saint Joseph",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11050,
    density: 64.2,
    county_fips: 27145,
    county_name: "Stearns",
    county_weights: {
      27145: 100,
    },
    county_names_all: "Stearns",
    county_fips_all: 27145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56375,
    lat: 45.70122,
    lng: -94.27458,
    city: "Saint Stephen",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 851,
    density: 87.1,
    county_fips: 27145,
    county_name: "Stearns",
    county_weights: {
      27145: 100,
    },
    county_names_all: "Stearns",
    county_fips_all: 27145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56376,
    lat: 45.50241,
    lng: -94.66731,
    city: "Saint Martin",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 353,
    density: 176.9,
    county_fips: 27145,
    county_name: "Stearns",
    county_weights: {
      27145: 100,
    },
    county_names_all: "Stearns",
    county_fips_all: 27145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56377,
    lat: 45.6405,
    lng: -94.23033,
    city: "Sartell",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20013,
    density: 345.5,
    county_fips: 27145,
    county_name: "Stearns",
    county_weights: {
      27009: 3.49,
      27145: 96.51,
    },
    county_names_all: "Stearns|Benton",
    county_fips_all: "27145|27009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56378,
    lat: 45.72308,
    lng: -94.97982,
    city: "Sauk Centre",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8132,
    density: 15.5,
    county_fips: 27145,
    county_name: "Stearns",
    county_weights: {
      27145: 71.23,
      27153: 28.77,
    },
    county_names_all: "Stearns|Todd",
    county_fips_all: "27145|27153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56379,
    lat: 45.63966,
    lng: -94.08394,
    city: "Sauk Rapids",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17225,
    density: 74.4,
    county_fips: 27009,
    county_name: "Benton",
    county_weights: {
      27009: 99.51,
      27141: 0.49,
    },
    county_names_all: "Benton|Sherburne",
    county_fips_all: "27009|27141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56381,
    lat: 45.55523,
    lng: -95.54669,
    city: "Starbuck",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2470,
    density: 6.6,
    county_fips: 27121,
    county_name: "Pope",
    county_weights: {
      27121: 100,
    },
    county_names_all: "Pope",
    county_fips_all: 27121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56382,
    lat: 45.9146,
    lng: -94.611,
    city: "Swanville",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1393,
    density: 8,
    county_fips: 27097,
    county_name: "Morrison",
    county_weights: {
      27097: 76.2,
      27153: 23.8,
    },
    county_names_all: "Morrison|Todd",
    county_fips_all: "27097|27153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56384,
    lat: 45.8099,
    lng: -94.56759,
    city: "Upsala",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 379,
    density: 145.1,
    county_fips: 27097,
    county_name: "Morrison",
    county_weights: {
      27097: 100,
    },
    county_names_all: "Morrison",
    county_fips_all: 27097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56385,
    lat: 45.70349,
    lng: -95.20681,
    city: "Villard",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 867,
    density: 4.5,
    county_fips: 27121,
    county_name: "Pope",
    county_weights: {
      27041: 2.63,
      27121: 83.53,
      27145: 13.84,
    },
    county_names_all: "Pope|Stearns|Douglas",
    county_fips_all: "27121|27145|27041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56386,
    lat: 46.11402,
    lng: -93.52176,
    city: "Wahkon",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 743,
    density: 16.1,
    county_fips: 27095,
    county_name: "Mille Lacs",
    county_weights: {
      27095: 100,
    },
    county_names_all: "Mille Lacs",
    county_fips_all: 27095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56387,
    lat: 45.53215,
    lng: -94.24141,
    city: "Waite Park",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7317,
    density: 315.8,
    county_fips: 27145,
    county_name: "Stearns",
    county_weights: {
      27145: 100,
    },
    county_names_all: "Stearns",
    county_fips_all: 27145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56389,
    lat: 45.79961,
    lng: -95.08832,
    city: "West Union",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 81,
    density: 45.2,
    county_fips: 27153,
    county_name: "Todd",
    county_weights: {
      27153: 100,
    },
    county_names_all: "Todd",
    county_fips_all: 27153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56401,
    lat: 46.32259,
    lng: -94.11974,
    city: "Brainerd",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30350,
    density: 36.3,
    county_fips: 27035,
    county_name: "Crow Wing",
    county_weights: {
      27021: 8.22,
      27035: 91.78,
    },
    county_names_all: "Crow Wing|Cass",
    county_fips_all: "27035|27021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56425,
    lat: 46.34162,
    lng: -94.28308,
    city: "Baxter",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8393,
    density: 177.5,
    county_fips: 27035,
    county_name: "Crow Wing",
    county_weights: {
      27035: 100,
    },
    county_names_all: "Crow Wing",
    county_fips_all: 27035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56431,
    lat: 46.4828,
    lng: -93.64356,
    city: "Aitkin",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8793,
    density: 7.3,
    county_fips: 27001,
    county_name: "Aitkin",
    county_weights: {
      27001: 87.1,
      27035: 12.9,
    },
    county_names_all: "Aitkin|Crow Wing",
    county_fips_all: "27001|27035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56433,
    lat: 46.9598,
    lng: -94.68519,
    city: "Akeley",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1650,
    density: 5.8,
    county_fips: 27057,
    county_name: "Hubbard",
    county_weights: {
      27021: 30.37,
      27057: 69.63,
    },
    county_names_all: "Hubbard|Cass",
    county_fips_all: "27057|27021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56434,
    lat: 46.33797,
    lng: -94.93437,
    city: "Aldrich",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 291,
    density: 7.6,
    county_fips: 27153,
    county_name: "Todd",
    county_weights: {
      27153: 83.73,
      27159: 16.27,
    },
    county_names_all: "Todd|Wadena",
    county_fips_all: "27153|27159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56435,
    lat: 46.80872,
    lng: -94.53089,
    city: "Backus",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2760,
    density: 6.7,
    county_fips: 27021,
    county_name: "Cass",
    county_weights: {
      27021: 99.08,
      27035: 0.92,
    },
    county_names_all: "Cass|Crow Wing",
    county_fips_all: "27021|27035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56437,
    lat: 46.25049,
    lng: -95.05654,
    city: "Bertha",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1451,
    density: 8.5,
    county_fips: 27153,
    county_name: "Todd",
    county_weights: {
      27111: 11.51,
      27153: 88.49,
    },
    county_names_all: "Todd|Otter Tail",
    county_fips_all: "27153|27111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56438,
    lat: 46.13873,
    lng: -94.80874,
    city: "Browerville",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2668,
    density: 7.3,
    county_fips: 27153,
    county_name: "Todd",
    county_weights: {
      27153: 100,
    },
    county_names_all: "Todd",
    county_fips_all: 27153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56440,
    lat: 46.14658,
    lng: -94.9573,
    city: "Clarissa",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1368,
    density: 9.5,
    county_fips: 27153,
    county_name: "Todd",
    county_weights: {
      27153: 100,
    },
    county_names_all: "Todd",
    county_fips_all: 27153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56441,
    lat: 46.58625,
    lng: -93.9865,
    city: "Crosby",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3900,
    density: 16.9,
    county_fips: 27035,
    county_name: "Crow Wing",
    county_weights: {
      27035: 100,
    },
    county_names_all: "Crow Wing",
    county_fips_all: 27035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56442,
    lat: 46.67629,
    lng: -94.09726,
    city: "Crosslake",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2591,
    density: 28.4,
    county_fips: 27035,
    county_name: "Crow Wing",
    county_weights: {
      27035: 100,
    },
    county_names_all: "Crow Wing",
    county_fips_all: 27035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56443,
    lat: 46.1916,
    lng: -94.57565,
    city: "Cushing",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1334,
    density: 4,
    county_fips: 27097,
    county_name: "Morrison",
    county_weights: {
      27097: 69.31,
      27153: 30.69,
    },
    county_names_all: "Morrison|Todd",
    county_fips_all: "27097|27153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56444,
    lat: 46.4175,
    lng: -93.87804,
    city: "Deerwood",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3442,
    density: 25.7,
    county_fips: 27035,
    county_name: "Crow Wing",
    county_weights: {
      27035: 100,
    },
    county_names_all: "Crow Wing",
    county_fips_all: 27035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56446,
    lat: 46.12448,
    lng: -95.08966,
    city: "Eagle Bend",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1818,
    density: 7.3,
    county_fips: 27153,
    county_name: "Todd",
    county_weights: {
      27041: 4.64,
      27111: 12.5,
      27153: 82.86,
    },
    county_names_all: "Todd|Otter Tail|Douglas",
    county_fips_all: "27153|27111|27041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56447,
    lat: 46.74151,
    lng: -93.90262,
    city: "Emily",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 849,
    density: 3.9,
    county_fips: 27035,
    county_name: "Crow Wing",
    county_weights: {
      27035: 100,
    },
    county_names_all: "Crow Wing",
    county_fips_all: 27035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56448,
    lat: 46.78604,
    lng: -94.09014,
    city: "Fifty Lakes",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 370,
    density: 3.1,
    county_fips: 27035,
    county_name: "Crow Wing",
    county_weights: {
      27021: 34.75,
      27035: 65.25,
    },
    county_names_all: "Crow Wing|Cass",
    county_fips_all: "27035|27021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56449,
    lat: 46.17436,
    lng: -94.27214,
    city: "Fort Ripley",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1817,
    density: 7.8,
    county_fips: 27035,
    county_name: "Crow Wing",
    county_weights: {
      27035: 66.83,
      27097: 33.17,
    },
    county_names_all: "Crow Wing|Morrison",
    county_fips_all: "27035|27097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56450,
    lat: 46.23341,
    lng: -93.8361,
    city: "Garrison",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 888,
    density: 13,
    county_fips: 27035,
    county_name: "Crow Wing",
    county_weights: {
      27035: 89.16,
      27095: 10.84,
    },
    county_names_all: "Crow Wing|Mille Lacs",
    county_fips_all: "27035|27095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56452,
    lat: 46.94808,
    lng: -94.46123,
    city: "Hackensack",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1968,
    density: 8,
    county_fips: 27021,
    county_name: "Cass",
    county_weights: {
      27021: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 27021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56453,
    lat: 46.31374,
    lng: -95.16161,
    city: "Hewitt",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 809,
    density: 5.9,
    county_fips: 27111,
    county_name: "Otter Tail",
    county_weights: {
      27111: 59.12,
      27153: 40.88,
    },
    county_names_all: "Otter Tail|Todd",
    county_fips_all: "27111|27153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56455,
    lat: 46.44953,
    lng: -94.00681,
    city: "Ironton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1699,
    density: 26.8,
    county_fips: 27035,
    county_name: "Crow Wing",
    county_weights: {
      27035: 100,
    },
    county_names_all: "Crow Wing",
    county_fips_all: 27035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56458,
    lat: 47.19924,
    lng: -94.99341,
    city: "Lake George",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 422,
    density: 7.6,
    county_fips: 27057,
    county_name: "Hubbard",
    county_weights: {
      27057: 100,
    },
    county_names_all: "Hubbard",
    county_fips_all: 27057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56461,
    lat: 47.22817,
    lng: -94.85877,
    city: "Laporte",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3234,
    density: 4.4,
    county_fips: 27057,
    county_name: "Hubbard",
    county_weights: {
      27021: 2.86,
      27057: 97.14,
    },
    county_names_all: "Hubbard|Cass",
    county_fips_all: "27057|27021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56464,
    lat: 46.76538,
    lng: -95.10382,
    city: "Menahga",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4727,
    density: 7.1,
    county_fips: 27159,
    county_name: "Wadena",
    county_weights: {
      27005: 33.56,
      27021: 0.86,
      27057: 14.42,
      27111: 4.23,
      27159: 46.93,
    },
    county_names_all: "Wadena|Becker|Hubbard|Otter Tail|Cass",
    county_fips_all: "27159|27005|27057|27111|27021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56465,
    lat: 46.53459,
    lng: -94.11381,
    city: "Merrifield",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2071,
    density: 20.8,
    county_fips: 27035,
    county_name: "Crow Wing",
    county_weights: {
      27035: 100,
    },
    county_names_all: "Crow Wing",
    county_fips_all: 27035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56466,
    lat: 46.41522,
    lng: -94.63137,
    city: "Motley",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2744,
    density: 5.5,
    county_fips: 27021,
    county_name: "Cass",
    county_weights: {
      27021: 69.91,
      27097: 19.43,
      27153: 10.66,
    },
    county_names_all: "Cass|Morrison|Todd",
    county_fips_all: "27021|27097|27153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56467,
    lat: 46.97714,
    lng: -94.83753,
    city: "Nevis",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2685,
    density: 8.3,
    county_fips: 27057,
    county_name: "Hubbard",
    county_weights: {
      27057: 100,
    },
    county_names_all: "Hubbard",
    county_fips_all: 27057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56468,
    lat: 46.49141,
    lng: -94.29856,
    city: "Nisswa",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4215,
    density: 32.7,
    county_fips: 27035,
    county_name: "Crow Wing",
    county_weights: {
      27021: 38.88,
      27035: 61.12,
    },
    county_names_all: "Crow Wing|Cass",
    county_fips_all: "27035|27021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56469,
    lat: 46.77701,
    lng: -93.5463,
    city: "Palisade",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1013,
    density: 1.5,
    county_fips: 27001,
    county_name: "Aitkin",
    county_weights: {
      27001: 100,
    },
    county_names_all: "Aitkin",
    county_fips_all: 27001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56470,
    lat: 47.02368,
    lng: -95.09433,
    city: "Park Rapids",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10654,
    density: 10.8,
    county_fips: 27057,
    county_name: "Hubbard",
    county_weights: {
      27005: 22.15,
      27029: 10.12,
      27057: 67.13,
      27159: 0.6,
    },
    county_names_all: "Hubbard|Becker|Clearwater|Wadena",
    county_fips_all: "27057|27005|27029|27159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56472,
    lat: 46.57507,
    lng: -94.34884,
    city: "Pequot Lakes",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8250,
    density: 20.6,
    county_fips: 27021,
    county_name: "Cass",
    county_weights: {
      27021: 54.64,
      27035: 45.36,
    },
    county_names_all: "Cass|Crow Wing",
    county_fips_all: "27021|27035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56473,
    lat: 46.35649,
    lng: -94.48355,
    city: "Pillager",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3176,
    density: 13.6,
    county_fips: 27021,
    county_name: "Cass",
    county_weights: {
      27021: 80.53,
      27097: 19.47,
    },
    county_names_all: "Cass|Morrison",
    county_fips_all: "27021|27097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56474,
    lat: 46.72238,
    lng: -94.39597,
    city: "Pine River",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4270,
    density: 7.2,
    county_fips: 27021,
    county_name: "Cass",
    county_weights: {
      27021: 70.46,
      27035: 29.54,
    },
    county_names_all: "Cass|Crow Wing",
    county_fips_all: "27021|27035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56475,
    lat: 46.08361,
    lng: -94.53985,
    city: "Randall",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1590,
    density: 9.8,
    county_fips: 27097,
    county_name: "Morrison",
    county_weights: {
      27097: 100,
    },
    county_names_all: "Morrison",
    county_fips_all: 27097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56477,
    lat: 46.64363,
    lng: -94.99653,
    city: "Sebeka",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2777,
    density: 4.3,
    county_fips: 27159,
    county_name: "Wadena",
    county_weights: {
      27021: 11.42,
      27111: 21.03,
      27159: 67.55,
    },
    county_names_all: "Wadena|Otter Tail|Cass",
    county_fips_all: "27159|27111|27021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56479,
    lat: 46.43719,
    lng: -94.78939,
    city: "Staples",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4983,
    density: 9.7,
    county_fips: 27153,
    county_name: "Todd",
    county_weights: {
      27021: 31.62,
      27153: 36.22,
      27159: 32.16,
    },
    county_names_all: "Todd|Wadena|Cass",
    county_fips_all: "27153|27159|27021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56481,
    lat: 46.46706,
    lng: -94.93446,
    city: "Verndale",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2210,
    density: 6,
    county_fips: 27159,
    county_name: "Wadena",
    county_weights: {
      27021: 7.63,
      27153: 18.18,
      27159: 74.19,
    },
    county_names_all: "Wadena|Todd|Cass",
    county_fips_all: "27159|27153|27021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56482,
    lat: 46.46555,
    lng: -95.14307,
    city: "Wadena",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7075,
    density: 20.1,
    county_fips: 27159,
    county_name: "Wadena",
    county_weights: {
      27111: 44.49,
      27153: 1.1,
      27159: 54.41,
    },
    county_names_all: "Wadena|Otter Tail|Todd",
    county_fips_all: "27159|27111|27153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56484,
    lat: 47.09744,
    lng: -94.47416,
    city: "Walker",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2958,
    density: 12.4,
    county_fips: 27021,
    county_name: "Cass",
    county_weights: {
      27021: 99.7,
      27057: 0.3,
    },
    county_names_all: "Cass|Hubbard",
    county_fips_all: "27021|27057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56501,
    lat: 46.83665,
    lng: -95.82233,
    city: "Detroit Lakes",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17696,
    density: 36.6,
    county_fips: 27005,
    county_name: "Becker",
    county_weights: {
      27005: 92.04,
      27111: 7.96,
    },
    county_names_all: "Becker|Otter Tail",
    county_fips_all: "27005|27111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56510,
    lat: 47.35811,
    lng: -96.52316,
    city: "Ada",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2366,
    density: 4.1,
    county_fips: 27107,
    county_name: "Norman",
    county_weights: {
      27107: 100,
    },
    county_names_all: "Norman",
    county_fips_all: 27107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56511,
    lat: 46.8532,
    lng: -96.00763,
    city: "Audubon",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1876,
    density: 11.4,
    county_fips: 27005,
    county_name: "Becker",
    county_weights: {
      27005: 100,
    },
    county_names_all: "Becker",
    county_fips_all: 27005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56514,
    lat: 46.64892,
    lng: -96.43486,
    city: "Barnesville",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3796,
    density: 6.9,
    county_fips: 27027,
    county_name: "Clay",
    county_weights: {
      27027: 61.86,
      27111: 2.44,
      27167: 35.7,
    },
    county_names_all: "Clay|Wilkin|Otter Tail",
    county_fips_all: "27027|27167|27111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56515,
    lat: 46.29444,
    lng: -95.708,
    city: "Battle Lake",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2840,
    density: 11.4,
    county_fips: 27111,
    county_name: "Otter Tail",
    county_weights: {
      27111: 100,
    },
    county_names_all: "Otter Tail",
    county_fips_all: 27111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56516,
    lat: 47.44368,
    lng: -95.96663,
    city: "Bejou",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 292,
    density: 1.3,
    county_fips: 27087,
    county_name: "Mahnomen",
    county_weights: {
      27087: 88.15,
      27107: 11.85,
    },
    county_names_all: "Mahnomen|Norman",
    county_fips_all: "27087|27107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56517,
    lat: 47.55474,
    lng: -96.53825,
    city: "Beltrami",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 303,
    density: 1.2,
    county_fips: 27119,
    county_name: "Polk",
    county_weights: {
      27107: 4.37,
      27119: 95.63,
    },
    county_names_all: "Polk|Norman",
    county_fips_all: "27119|27107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56518,
    lat: 46.48926,
    lng: -95.24506,
    city: "Bluffton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 379,
    density: 7.9,
    county_fips: 27111,
    county_name: "Otter Tail",
    county_weights: {
      27111: 100,
    },
    county_names_all: "Otter Tail",
    county_fips_all: 27111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56519,
    lat: 47.15914,
    lng: -96.4877,
    city: "Borup",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 252,
    density: 1,
    county_fips: 27107,
    county_name: "Norman",
    county_weights: {
      27027: 39.85,
      27107: 60.15,
    },
    county_names_all: "Norman|Clay",
    county_fips_all: "27107|27027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56520,
    lat: 46.28645,
    lng: -96.50361,
    city: "Breckenridge",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3751,
    density: 11.5,
    county_fips: 27167,
    county_name: "Wilkin",
    county_weights: {
      27167: 100,
    },
    county_names_all: "Wilkin",
    county_fips_all: 27167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56521,
    lat: 46.99691,
    lng: -95.89783,
    city: "Callaway",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 834,
    density: 5.1,
    county_fips: 27005,
    county_name: "Becker",
    county_weights: {
      27005: 100,
    },
    county_names_all: "Becker",
    county_fips_all: 27005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56522,
    lat: 46.1352,
    lng: -96.3887,
    city: "Campbell",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 403,
    density: 1,
    county_fips: 27167,
    county_name: "Wilkin",
    county_weights: {
      27111: 12.37,
      27167: 87.63,
    },
    county_names_all: "Wilkin|Otter Tail",
    county_fips_all: "27167|27111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56523,
    lat: 47.63838,
    lng: -96.80871,
    city: "Climax",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 499,
    density: 2.4,
    county_fips: 27119,
    county_name: "Polk",
    county_weights: {
      27119: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 27119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56524,
    lat: 46.21115,
    lng: -95.606,
    city: "Clitherall",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 656,
    density: 5.7,
    county_fips: 27111,
    county_name: "Otter Tail",
    county_weights: {
      27111: 100,
    },
    county_names_all: "Otter Tail",
    county_fips_all: 27111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56525,
    lat: 46.6716,
    lng: -96.75195,
    city: "Comstock",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 78,
    density: 25.7,
    county_fips: 27027,
    county_name: "Clay",
    county_weights: {
      27027: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 27027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56527,
    lat: 46.37383,
    lng: -95.31806,
    city: "Deer Creek",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 924,
    density: 6.5,
    county_fips: 27111,
    county_name: "Otter Tail",
    county_weights: {
      27111: 100,
    },
    county_names_all: "Otter Tail",
    county_fips_all: 27111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56528,
    lat: 46.53066,
    lng: -95.80983,
    city: "Dent",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1626,
    density: 10.2,
    county_fips: 27111,
    county_name: "Otter Tail",
    county_weights: {
      27111: 100,
    },
    county_names_all: "Otter Tail",
    county_fips_all: 27111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56529,
    lat: 46.88027,
    lng: -96.69754,
    city: "Dilworth",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4434,
    density: 463.9,
    county_fips: 27027,
    county_name: "Clay",
    county_weights: {
      27027: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 27027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56531,
    lat: 45.98967,
    lng: -95.98376,
    city: "Elbow Lake",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1910,
    density: 4.9,
    county_fips: 27051,
    county_name: "Grant",
    county_weights: {
      27051: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 27051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56533,
    lat: 46.40393,
    lng: -96.15144,
    city: "Elizabeth",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 288,
    density: 8,
    county_fips: 27111,
    county_name: "Otter Tail",
    county_weights: {
      27111: 100,
    },
    county_names_all: "Otter Tail",
    county_fips_all: 27111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56534,
    lat: 46.46325,
    lng: -96.01431,
    city: "Erhard",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1339,
    density: 8,
    county_fips: 27111,
    county_name: "Otter Tail",
    county_weights: {
      27111: 100,
    },
    county_names_all: "Otter Tail",
    county_fips_all: 27111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56535,
    lat: 47.67541,
    lng: -96.04611,
    city: "Erskine",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1227,
    density: 5.3,
    county_fips: 27119,
    county_name: "Polk",
    county_weights: {
      27119: 88.11,
      27125: 11.89,
    },
    county_names_all: "Polk|Red Lake",
    county_fips_all: "27119|27125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56536,
    lat: 47.04596,
    lng: -96.53173,
    city: "Felton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 338,
    density: 1.4,
    county_fips: 27027,
    county_name: "Clay",
    county_weights: {
      27027: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 27027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56537,
    lat: 46.27697,
    lng: -96.08977,
    city: "Fergus Falls",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18914,
    density: 25.8,
    county_fips: 27111,
    county_name: "Otter Tail",
    county_weights: {
      27111: 100,
    },
    county_names_all: "Otter Tail",
    county_fips_all: 27111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56540,
    lat: 47.54255,
    lng: -96.27671,
    city: "Fertile",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2120,
    density: 4.7,
    county_fips: 27119,
    county_name: "Polk",
    county_weights: {
      27107: 26.13,
      27119: 73.87,
    },
    county_names_all: "Polk|Norman",
    county_fips_all: "27119|27107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56541,
    lat: 47.16606,
    lng: -96.13081,
    city: "Flom",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29,
    density: 2.8,
    county_fips: 27107,
    county_name: "Norman",
    county_weights: {
      27107: 100,
    },
    county_names_all: "Norman",
    county_fips_all: 27107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56542,
    lat: 47.56679,
    lng: -95.72331,
    city: "Fosston",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2656,
    density: 5.7,
    county_fips: 27119,
    county_name: "Polk",
    county_weights: {
      27087: 19.77,
      27119: 80.23,
    },
    county_names_all: "Polk|Mahnomen",
    county_fips_all: "27119|27087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56543,
    lat: 46.28541,
    lng: -96.33654,
    city: "Foxhome",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 243,
    density: 1.4,
    county_fips: 27167,
    county_name: "Wilkin",
    county_weights: {
      27167: 100,
    },
    county_names_all: "Wilkin",
    county_fips_all: 27167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56544,
    lat: 46.75894,
    lng: -95.59693,
    city: "Frazee",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5281,
    density: 10.3,
    county_fips: 27005,
    county_name: "Becker",
    county_weights: {
      27005: 76.81,
      27111: 23.19,
    },
    county_names_all: "Becker|Otter Tail",
    county_fips_all: "27005|27111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56545,
    lat: 47.38527,
    lng: -96.2399,
    city: "Gary",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 654,
    density: 1.6,
    county_fips: 27107,
    county_name: "Norman",
    county_weights: {
      27107: 100,
    },
    county_names_all: "Norman",
    county_fips_all: 27107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56546,
    lat: 47.10107,
    lng: -96.73038,
    city: "Georgetown",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 231,
    density: 1.5,
    county_fips: 27027,
    county_name: "Clay",
    county_weights: {
      27027: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 27027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56547,
    lat: 46.89068,
    lng: -96.55043,
    city: "Glyndon",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3063,
    density: 7.8,
    county_fips: 27027,
    county_name: "Clay",
    county_weights: {
      27027: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 27027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56548,
    lat: 47.37025,
    lng: -96.75392,
    city: "Halstad",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 735,
    density: 4.2,
    county_fips: 27107,
    county_name: "Norman",
    county_weights: {
      27107: 100,
    },
    county_names_all: "Norman",
    county_fips_all: 27107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56549,
    lat: 46.85287,
    lng: -96.31285,
    city: "Hawley",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4934,
    density: 9.2,
    county_fips: 27027,
    county_name: "Clay",
    county_weights: {
      27027: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 27027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56550,
    lat: 47.2697,
    lng: -96.74867,
    city: "Hendrum",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 316,
    density: 2.5,
    county_fips: 27107,
    county_name: "Norman",
    county_weights: {
      27107: 100,
    },
    county_names_all: "Norman",
    county_fips_all: 27107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56551,
    lat: 46.31856,
    lng: -95.45081,
    city: "Henning",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2101,
    density: 7.7,
    county_fips: 27111,
    county_name: "Otter Tail",
    county_weights: {
      27111: 100,
    },
    county_names_all: "Otter Tail",
    county_fips_all: 27111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56552,
    lat: 46.9814,
    lng: -96.21602,
    city: "Hitterdal",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 579,
    density: 4.8,
    county_fips: 27027,
    county_name: "Clay",
    county_weights: {
      27005: 26.7,
      27027: 73.3,
    },
    county_names_all: "Clay|Becker",
    county_fips_all: "27027|27005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56553,
    lat: 46.42946,
    lng: -96.61757,
    city: "Kent",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 184,
    density: 1.1,
    county_fips: 27167,
    county_name: "Wilkin",
    county_weights: {
      27167: 100,
    },
    county_names_all: "Wilkin",
    county_fips_all: 27167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56554,
    lat: 46.88408,
    lng: -96.11483,
    city: "Lake Park",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2584,
    density: 8.7,
    county_fips: 27005,
    county_name: "Becker",
    county_weights: {
      27005: 92.09,
      27027: 7.91,
    },
    county_names_all: "Becker|Clay",
    county_fips_all: "27005|27027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56556,
    lat: 47.66403,
    lng: -95.88349,
    city: "Mcintosh",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1028,
    density: 3.9,
    county_fips: 27119,
    county_name: "Polk",
    county_weights: {
      27119: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 27119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56557,
    lat: 47.32422,
    lng: -95.837,
    city: "Mahnomen",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2885,
    density: 4.7,
    county_fips: 27087,
    county_name: "Mahnomen",
    county_weights: {
      27029: 2.68,
      27087: 93.42,
      27107: 3.9,
    },
    county_names_all: "Mahnomen|Norman|Clearwater",
    county_fips_all: "27087|27107|27029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56560,
    lat: 46.83637,
    lng: -96.73467,
    city: "Moorhead",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44763,
    density: 109.8,
    county_fips: 27027,
    county_name: "Clay",
    county_weights: {
      27027: 98.76,
      27167: 1.24,
    },
    county_names_all: "Clay|Wilkin",
    county_fips_all: "27027|27167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56562,
    lat: 46.86458,
    lng: -96.77021,
    city: "Moorhead",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 27027,
    county_name: "Clay",
    county_weights: {
      27027: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 27027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56563,
    lat: 46.8668,
    lng: -96.75522,
    city: "Moorhead",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 27027,
    county_name: "Clay",
    county_weights: {
      27027: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 27027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56565,
    lat: 46.04861,
    lng: -96.31511,
    city: "Nashua",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 81,
    density: 1,
    county_fips: 27167,
    county_name: "Wilkin",
    county_weights: {
      27051: 24.97,
      27167: 75.03,
    },
    county_names_all: "Wilkin|Grant",
    county_fips_all: "27167|27051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56566,
    lat: 47.24724,
    lng: -95.61322,
    city: "Naytahwaush",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 613,
    density: 17.9,
    county_fips: 27087,
    county_name: "Mahnomen",
    county_weights: {
      27087: 100,
    },
    county_names_all: "Mahnomen",
    county_fips_all: 27087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56567,
    lat: 46.54896,
    lng: -95.36707,
    city: "New York Mills",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3066,
    density: 8,
    county_fips: 27111,
    county_name: "Otter Tail",
    county_weights: {
      27111: 100,
    },
    county_names_all: "Otter Tail",
    county_fips_all: 27111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56568,
    lat: 47.5292,
    lng: -96.77925,
    city: "Nielsville",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 161,
    density: 2.1,
    county_fips: 27119,
    county_name: "Polk",
    county_weights: {
      27107: 6.67,
      27119: 93.33,
    },
    county_names_all: "Polk|Norman",
    county_fips_all: "27119|27107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56569,
    lat: 47.07482,
    lng: -95.81956,
    city: "Ogema",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1287,
    density: 3.1,
    county_fips: 27005,
    county_name: "Becker",
    county_weights: {
      27005: 100,
    },
    county_names_all: "Becker",
    county_fips_all: 27005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56570,
    lat: 46.91051,
    lng: -95.35552,
    city: "Osage",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1227,
    density: 4.8,
    county_fips: 27005,
    county_name: "Becker",
    county_weights: {
      27005: 100,
    },
    county_names_all: "Becker",
    county_fips_all: 27005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56571,
    lat: 46.43856,
    lng: -95.53939,
    city: "Ottertail",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1748,
    density: 14.6,
    county_fips: 27111,
    county_name: "Otter Tail",
    county_weights: {
      27111: 100,
    },
    county_names_all: "Otter Tail",
    county_fips_all: 27111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56572,
    lat: 46.60485,
    lng: -96.08682,
    city: "Pelican Rapids",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5531,
    density: 12.5,
    county_fips: 27111,
    county_name: "Otter Tail",
    county_weights: {
      27005: 3.43,
      27027: 3.94,
      27111: 92.13,
      27167: 0.5,
    },
    county_names_all: "Otter Tail|Clay|Becker|Wilkin",
    county_fips_all: "27111|27027|27005|27167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56573,
    lat: 46.61443,
    lng: -95.55216,
    city: "Perham",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6498,
    density: 18.2,
    county_fips: 27111,
    county_name: "Otter Tail",
    county_weights: {
      27111: 100,
    },
    county_names_all: "Otter Tail",
    county_fips_all: 27111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56574,
    lat: 47.20085,
    lng: -96.70242,
    city: "Perley",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 219,
    density: 1.2,
    county_fips: 27107,
    county_name: "Norman",
    county_weights: {
      27027: 1.44,
      27107: 98.56,
    },
    county_names_all: "Norman|Clay",
    county_fips_all: "27107|27027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56575,
    lat: 47.03827,
    lng: -95.43146,
    city: "Ponsford",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 794,
    density: 2.2,
    county_fips: 27005,
    county_name: "Becker",
    county_weights: {
      27005: 100,
    },
    county_names_all: "Becker",
    county_fips_all: 27005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56576,
    lat: 46.47164,
    lng: -95.70537,
    city: "Richville",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 835,
    density: 8,
    county_fips: 27111,
    county_name: "Otter Tail",
    county_weights: {
      27111: 100,
    },
    county_names_all: "Otter Tail",
    county_fips_all: 27111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56578,
    lat: 46.9264,
    lng: -95.65563,
    city: "Rochert",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 716,
    density: 5,
    county_fips: 27005,
    county_name: "Becker",
    county_weights: {
      27005: 100,
    },
    county_names_all: "Becker",
    county_fips_all: 27005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56579,
    lat: 46.4688,
    lng: -96.34229,
    city: "Rothsay",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1044,
    density: 2,
    county_fips: 27167,
    county_name: "Wilkin",
    county_weights: {
      27111: 26.95,
      27167: 73.05,
    },
    county_names_all: "Wilkin|Otter Tail",
    county_fips_all: "27167|27111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56580,
    lat: 46.73944,
    lng: -96.61004,
    city: "Sabin",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1221,
    density: 7.4,
    county_fips: 27027,
    county_name: "Clay",
    county_weights: {
      27027: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 27027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56581,
    lat: 47.45725,
    lng: -96.76141,
    city: "Shelly",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 234,
    density: 2.3,
    county_fips: 27107,
    county_name: "Norman",
    county_weights: {
      27107: 100,
    },
    county_names_all: "Norman",
    county_fips_all: 27107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56583,
    lat: 46.00332,
    lng: -96.40667,
    city: "Tintah",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 177,
    density: 0.9,
    county_fips: 27155,
    county_name: "Traverse",
    county_weights: {
      27155: 71.7,
      27167: 28.3,
    },
    county_names_all: "Traverse|Wilkin",
    county_fips_all: "27155|27167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56584,
    lat: 47.23087,
    lng: -96.23496,
    city: "Twin Valley",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1379,
    density: 4,
    county_fips: 27107,
    county_name: "Norman",
    county_weights: {
      27107: 100,
    },
    county_names_all: "Norman",
    county_fips_all: 27107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56585,
    lat: 47.08896,
    lng: -96.24492,
    city: "Ulen",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 972,
    density: 3,
    county_fips: 27027,
    county_name: "Clay",
    county_weights: {
      27005: 32.43,
      27027: 66.79,
      27107: 0.78,
    },
    county_names_all: "Clay|Becker|Norman",
    county_fips_all: "27027|27005|27107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56586,
    lat: 46.32324,
    lng: -95.84,
    city: "Underwood",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1850,
    density: 9.7,
    county_fips: 27111,
    county_name: "Otter Tail",
    county_weights: {
      27111: 100,
    },
    county_names_all: "Otter Tail",
    county_fips_all: 27111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56587,
    lat: 46.63721,
    lng: -95.8628,
    city: "Vergas",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1372,
    density: 10,
    county_fips: 27111,
    county_name: "Otter Tail",
    county_weights: {
      27111: 100,
    },
    county_names_all: "Otter Tail",
    county_fips_all: 27111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56588,
    lat: 46.22028,
    lng: -95.5006,
    city: "Vining",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 427,
    density: 3.5,
    county_fips: 27111,
    county_name: "Otter Tail",
    county_weights: {
      27111: 100,
    },
    county_names_all: "Otter Tail",
    county_fips_all: 27111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56589,
    lat: 47.17959,
    lng: -95.71984,
    city: "Waubun",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2234,
    density: 3.5,
    county_fips: 27087,
    county_name: "Mahnomen",
    county_weights: {
      27005: 26.2,
      27029: 13.91,
      27087: 59.89,
    },
    county_names_all: "Mahnomen|Becker|Clearwater",
    county_fips_all: "27087|27005|27029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56590,
    lat: 46.03514,
    lng: -96.16093,
    city: "Wendell",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 296,
    density: 1.4,
    county_fips: 27051,
    county_name: "Grant",
    county_weights: {
      27051: 99.4,
      27111: 0.6,
    },
    county_names_all: "Grant|Otter Tail",
    county_fips_all: "27051|27111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56591,
    lat: 47.09968,
    lng: -95.84357,
    city: "White Earth",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 155,
    density: 22.3,
    county_fips: 27005,
    county_name: "Becker",
    county_weights: {
      27005: 100,
    },
    county_names_all: "Becker",
    county_fips_all: 27005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56592,
    lat: 47.53542,
    lng: -96.00769,
    city: "Winger",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 502,
    density: 3.3,
    county_fips: 27119,
    county_name: "Polk",
    county_weights: {
      27087: 10.04,
      27119: 89.96,
    },
    county_names_all: "Polk|Mahnomen",
    county_fips_all: "27119|27087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56594,
    lat: 46.54906,
    lng: -96.64493,
    city: "Wolverton",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 489,
    density: 2,
    county_fips: 27167,
    county_name: "Wilkin",
    county_weights: {
      27167: 100,
    },
    county_names_all: "Wilkin",
    county_fips_all: 27167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56601,
    lat: 47.50985,
    lng: -94.84921,
    city: "Bemidji",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34505,
    density: 35.9,
    county_fips: 27007,
    county_name: "Beltrami",
    county_weights: {
      27007: 83.99,
      27057: 16.01,
    },
    county_names_all: "Beltrami|Hubbard",
    county_fips_all: "27007|27057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56621,
    lat: 47.40975,
    lng: -95.41597,
    city: "Bagley",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4880,
    density: 5.9,
    county_fips: 27029,
    county_name: "Clearwater",
    county_weights: {
      27029: 98.02,
      27087: 0.29,
      27119: 1.69,
    },
    county_names_all: "Clearwater|Polk|Mahnomen",
    county_fips_all: "27029|27119|27087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56623,
    lat: 48.59722,
    lng: -94.56913,
    city: "Baudette",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2471,
    density: 2.1,
    county_fips: 27077,
    county_name: "Lake of the Woods",
    county_weights: {
      27071: 17.25,
      27077: 82.75,
    },
    county_names_all: "Lake of the Woods|Koochiching",
    county_fips_all: "27077|27071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56626,
    lat: 47.36404,
    lng: -94.18421,
    city: "Bena",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 227,
    density: 1,
    county_fips: 27021,
    county_name: "Cass",
    county_weights: {
      27021: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 27021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56627,
    lat: 48.1953,
    lng: -94.04118,
    city: "Big Falls",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 242,
    density: 0.1,
    county_fips: 27071,
    county_name: "Koochiching",
    county_weights: {
      27071: 100,
    },
    county_names_all: "Koochiching",
    county_fips_all: 27071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56628,
    lat: 47.69575,
    lng: -93.5215,
    city: "Bigfork",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1603,
    density: 1.9,
    county_fips: 27061,
    county_name: "Itasca",
    county_weights: {
      27061: 100,
    },
    county_names_all: "Itasca",
    county_fips_all: 27061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56629,
    lat: 48.51494,
    lng: -94.12546,
    city: "Birchdale",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 314,
    density: 0.4,
    county_fips: 27071,
    county_name: "Koochiching",
    county_weights: {
      27071: 100,
    },
    county_names_all: "Koochiching",
    county_fips_all: 27071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56630,
    lat: 47.74432,
    lng: -94.49852,
    city: "Blackduck",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2255,
    density: 2.8,
    county_fips: 27007,
    county_name: "Beltrami",
    county_weights: {
      27007: 71.1,
      27061: 28.9,
    },
    county_names_all: "Beltrami|Itasca",
    county_fips_all: "27007|27061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56633,
    lat: 47.31957,
    lng: -94.50911,
    city: "Cass Lake",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5095,
    density: 9.1,
    county_fips: 27021,
    county_name: "Cass",
    county_weights: {
      27007: 13.57,
      27021: 80.27,
      27057: 6.16,
    },
    county_names_all: "Cass|Beltrami|Hubbard",
    county_fips_all: "27021|27007|27057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56634,
    lat: 47.68577,
    lng: -95.40169,
    city: "Clearbrook",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1723,
    density: 5.5,
    county_fips: 27029,
    county_name: "Clearwater",
    county_weights: {
      27029: 100,
    },
    county_names_all: "Clearwater",
    county_fips_all: 27029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56636,
    lat: 47.40283,
    lng: -93.86518,
    city: "Deer River",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5090,
    density: 4.5,
    county_fips: 27061,
    county_name: "Itasca",
    county_weights: {
      27021: 25.51,
      27061: 74.49,
    },
    county_names_all: "Itasca|Cass",
    county_fips_all: "27061|27021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56637,
    lat: 47.61872,
    lng: -93.83941,
    city: "Talmoon",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 187,
    density: 2.8,
    county_fips: 27061,
    county_name: "Itasca",
    county_weights: {
      27061: 100,
    },
    county_names_all: "Itasca",
    county_fips_all: 27061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56639,
    lat: 47.90275,
    lng: -93.53399,
    city: "Effie",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 412,
    density: 0.5,
    county_fips: 27061,
    county_name: "Itasca",
    county_weights: {
      27061: 52.82,
      27071: 47.18,
    },
    county_names_all: "Itasca|Koochiching",
    county_fips_all: "27061|27071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56641,
    lat: 47.19848,
    lng: -94.25804,
    city: "Federal Dam",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 358,
    density: 4.4,
    county_fips: 27021,
    county_name: "Cass",
    county_weights: {
      27021: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 27021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56644,
    lat: 47.78095,
    lng: -95.51263,
    city: "Gonvick",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 712,
    density: 2.8,
    county_fips: 27029,
    county_name: "Clearwater",
    county_weights: {
      27029: 95.07,
      27119: 4.93,
    },
    county_names_all: "Clearwater|Polk",
    county_fips_all: "27029|27119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56646,
    lat: 47.78925,
    lng: -95.62865,
    city: "Gully",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 565,
    density: 2.9,
    county_fips: 27119,
    county_name: "Polk",
    county_weights: {
      27029: 8.39,
      27119: 91.61,
    },
    county_names_all: "Polk|Clearwater",
    county_fips_all: "27119|27029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56647,
    lat: 47.68782,
    lng: -94.62187,
    city: "Hines",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 695,
    density: 3.4,
    county_fips: 27007,
    county_name: "Beltrami",
    county_weights: {
      27007: 100,
    },
    county_names_all: "Beltrami",
    county_fips_all: 27007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56649,
    lat: 48.53122,
    lng: -93.13224,
    city: "International Falls",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9014,
    density: 12.2,
    county_fips: 27071,
    county_name: "Koochiching",
    county_weights: {
      27071: 54.86,
      27137: 45.14,
    },
    county_names_all: "Koochiching|St. Louis",
    county_fips_all: "27071|27137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56650,
    lat: 47.9979,
    lng: -94.56351,
    city: "Kelliher",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 907,
    density: 2,
    county_fips: 27007,
    county_name: "Beltrami",
    county_weights: {
      27007: 100,
    },
    county_names_all: "Beltrami",
    county_fips_all: 27007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56651,
    lat: 47.43883,
    lng: -95.6172,
    city: "Lengby",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 634,
    density: 3.5,
    county_fips: 27087,
    county_name: "Mahnomen",
    county_weights: {
      27087: 82.59,
      27119: 17.41,
    },
    county_names_all: "Mahnomen|Polk",
    county_fips_all: "27087|27119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56652,
    lat: 47.71104,
    lng: -95.23721,
    city: "Leonard",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 474,
    density: 2.8,
    county_fips: 27029,
    county_name: "Clearwater",
    county_weights: {
      27007: 11.59,
      27029: 88.41,
    },
    county_names_all: "Clearwater|Beltrami",
    county_fips_all: "27029|27007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56653,
    lat: 48.28327,
    lng: -93.58558,
    city: "Littlefork",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1340,
    density: 1.1,
    county_fips: 27071,
    county_name: "Koochiching",
    county_weights: {
      27071: 100,
    },
    county_names_all: "Koochiching",
    county_fips_all: 27071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56654,
    lat: 48.47285,
    lng: -93.94153,
    city: "Loman",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 116,
    density: 0.4,
    county_fips: 27071,
    county_name: "Koochiching",
    county_weights: {
      27071: 100,
    },
    county_names_all: "Koochiching",
    county_fips_all: 27071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56655,
    lat: 46.98292,
    lng: -94.23014,
    city: "Longville",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1452,
    density: 5.9,
    county_fips: 27021,
    county_name: "Cass",
    county_weights: {
      27021: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 27021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56657,
    lat: 47.57237,
    lng: -93.61544,
    city: "Marcell",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 247,
    density: 1.8,
    county_fips: 27061,
    county_name: "Itasca",
    county_weights: {
      27061: 100,
    },
    county_names_all: "Itasca",
    county_fips_all: 27061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56658,
    lat: 48.11248,
    lng: -93.93302,
    city: "Margie",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 27071,
    county_name: "Koochiching",
    county_weights: {
      27071: 100,
    },
    county_names_all: "Koochiching",
    county_fips_all: 27071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56659,
    lat: 47.62116,
    lng: -94.01899,
    city: "Max",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 99,
    density: 1.2,
    county_fips: 27061,
    county_name: "Itasca",
    county_weights: {
      27061: 100,
    },
    county_names_all: "Itasca",
    county_fips_all: 27061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56660,
    lat: 47.96653,
    lng: -94.17022,
    city: "Mizpah",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 305,
    density: 0.9,
    county_fips: 27071,
    county_name: "Koochiching",
    county_weights: {
      27071: 100,
    },
    county_names_all: "Koochiching",
    county_fips_all: 27071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56661,
    lat: 47.84302,
    lng: -94.13856,
    city: "Northome",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1030,
    density: 1.1,
    county_fips: 27071,
    county_name: "Koochiching",
    county_weights: {
      27007: 6.41,
      27061: 43.96,
      27071: 49.63,
    },
    county_names_all: "Koochiching|Itasca|Beltrami",
    county_fips_all: "27071|27061|27007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56662,
    lat: 46.84524,
    lng: -93.89926,
    city: "Outing",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 438,
    density: 2.8,
    county_fips: 27021,
    county_name: "Cass",
    county_weights: {
      27021: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 27021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56663,
    lat: 47.49997,
    lng: -94.45431,
    city: "Pennington",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 201,
    density: 1.9,
    county_fips: 27007,
    county_name: "Beltrami",
    county_weights: {
      27007: 100,
    },
    county_names_all: "Beltrami",
    county_fips_all: 27007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56666,
    lat: 48.03391,
    lng: -94.8365,
    city: "Ponemah",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1085,
    density: 9.9,
    county_fips: 27007,
    county_name: "Beltrami",
    county_weights: {
      27007: 100,
    },
    county_names_all: "Beltrami",
    county_fips_all: 27007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56667,
    lat: 47.73569,
    lng: -94.94199,
    city: "Puposky",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 750,
    density: 3,
    county_fips: 27007,
    county_name: "Beltrami",
    county_weights: {
      27007: 100,
    },
    county_names_all: "Beltrami",
    county_fips_all: 27007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56668,
    lat: 48.61454,
    lng: -93.3467,
    city: "Ranier",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 126,
    density: 237.5,
    county_fips: 27071,
    county_name: "Koochiching",
    county_weights: {
      27071: 100,
    },
    county_names_all: "Koochiching",
    county_fips_all: 27071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Winnipeg",
  },
  {
    zip: 56669,
    lat: 48.37718,
    lng: -93.22655,
    city: "Kabetogama",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 241,
    density: 0.4,
    county_fips: 27071,
    county_name: "Koochiching",
    county_weights: {
      27071: 86.12,
      27137: 13.88,
    },
    county_names_all: "Koochiching|St. Louis",
    county_fips_all: "27071|27137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56670,
    lat: 47.85001,
    lng: -94.86912,
    city: "Redby",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1548,
    density: 21.2,
    county_fips: 27007,
    county_name: "Beltrami",
    county_weights: {
      27007: 100,
    },
    county_names_all: "Beltrami",
    county_fips_all: 27007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56671,
    lat: 47.94006,
    lng: -95.31791,
    city: "Redlake",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3144,
    density: 3.8,
    county_fips: 27029,
    county_name: "Clearwater",
    county_weights: {
      27007: 41.89,
      27029: 58.11,
    },
    county_names_all: "Clearwater|Beltrami",
    county_fips_all: "27029|27007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56672,
    lat: 47.0734,
    lng: -94.02267,
    city: "Remer",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1947,
    density: 1.9,
    county_fips: 27021,
    county_name: "Cass",
    county_weights: {
      27021: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 27021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56673,
    lat: 48.74365,
    lng: -95.13896,
    city: "Roosevelt",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 628,
    density: 1.2,
    county_fips: 27077,
    county_name: "Lake of the Woods",
    county_weights: {
      27077: 81.19,
      27135: 18.81,
    },
    county_names_all: "Lake of the Woods|Roseau",
    county_fips_all: "27077|27135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56676,
    lat: 47.52188,
    lng: -95.19877,
    city: "Shevlin",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1635,
    density: 2.9,
    county_fips: 27029,
    county_name: "Clearwater",
    county_weights: {
      27007: 38.52,
      27029: 61.48,
    },
    county_names_all: "Clearwater|Beltrami",
    county_fips_all: "27029|27007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56678,
    lat: 47.4298,
    lng: -95.11768,
    city: "Solway",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1335,
    density: 4.1,
    county_fips: 27007,
    county_name: "Beltrami",
    county_weights: {
      27007: 52.41,
      27029: 4.59,
      27057: 43,
    },
    county_names_all: "Beltrami|Hubbard|Clearwater",
    county_fips_all: "27007|27057|27029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56680,
    lat: 47.6456,
    lng: -93.96124,
    city: "Spring Lake",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 118,
    density: 2,
    county_fips: 27061,
    county_name: "Itasca",
    county_weights: {
      27061: 100,
    },
    county_names_all: "Itasca",
    county_fips_all: 27061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56681,
    lat: 47.5488,
    lng: -94.25132,
    city: "Squaw Lake",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 269,
    density: 0.6,
    county_fips: 27061,
    county_name: "Itasca",
    county_weights: {
      27061: 100,
    },
    county_names_all: "Itasca",
    county_fips_all: 27061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56683,
    lat: 47.72124,
    lng: -94.7512,
    city: "Tenstrike",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 658,
    density: 4.4,
    county_fips: 27007,
    county_name: "Beltrami",
    county_weights: {
      27007: 100,
    },
    county_names_all: "Beltrami",
    county_fips_all: 27007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56684,
    lat: 47.87109,
    lng: -95.70401,
    city: "Trail",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 279,
    density: 0.9,
    county_fips: 27119,
    county_name: "Polk",
    county_weights: {
      27113: 33,
      27119: 62.13,
      27125: 4.87,
    },
    county_names_all: "Polk|Pennington|Red Lake",
    county_fips_all: "27119|27113|27125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56685,
    lat: 48.23841,
    lng: -94.51997,
    city: "Waskish",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 132,
    density: 0.4,
    county_fips: 27007,
    county_name: "Beltrami",
    county_weights: {
      27007: 100,
    },
    county_names_all: "Beltrami",
    county_fips_all: 27007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56686,
    lat: 48.78595,
    lng: -94.91001,
    city: "Williams",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1038,
    density: 2.2,
    county_fips: 27077,
    county_name: "Lake of the Woods",
    county_weights: {
      27077: 100,
    },
    county_names_all: "Lake of the Woods",
    county_fips_all: 27077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56688,
    lat: 47.7699,
    lng: -93.89172,
    city: "Wirt",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 92,
    density: 0.3,
    county_fips: 27061,
    county_name: "Itasca",
    county_weights: {
      27061: 100,
    },
    county_names_all: "Itasca",
    county_fips_all: 27061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56701,
    lat: 48.12021,
    lng: -96.1994,
    city: "Thief River Falls",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13061,
    density: 13.2,
    county_fips: 27113,
    county_name: "Pennington",
    county_weights: {
      27089: 23.78,
      27113: 74.38,
      27119: 1.84,
    },
    county_names_all: "Pennington|Marshall|Polk",
    county_fips_all: "27113|27089|27119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56710,
    lat: 48.2182,
    lng: -96.99776,
    city: "Alvarado",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 543,
    density: 4.7,
    county_fips: 27089,
    county_name: "Marshall",
    county_weights: {
      27089: 81.42,
      27119: 18.58,
    },
    county_names_all: "Marshall|Polk",
    county_fips_all: "27089|27119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56711,
    lat: 49.09907,
    lng: -94.97591,
    city: "Angle Inlet",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 27077,
    county_name: "Lake of the Woods",
    county_weights: {
      27077: 100,
    },
    county_names_all: "Lake of the Woods",
    county_fips_all: 27077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56713,
    lat: 48.3487,
    lng: -96.81717,
    city: "Argyle",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1050,
    density: 2.2,
    county_fips: 27089,
    county_name: "Marshall",
    county_weights: {
      27089: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 27089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56714,
    lat: 48.78845,
    lng: -96.00529,
    city: "Badger",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1229,
    density: 2.3,
    county_fips: 27135,
    county_name: "Roseau",
    county_weights: {
      27135: 100,
    },
    county_names_all: "Roseau",
    county_fips_all: 27135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56715,
    lat: 47.80636,
    lng: -95.94904,
    city: "Brooks",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 327,
    density: 2.1,
    county_fips: 27125,
    county_name: "Red Lake",
    county_weights: {
      27119: 4.15,
      27125: 95.85,
    },
    county_names_all: "Red Lake|Polk",
    county_fips_all: "27125|27119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56716,
    lat: 47.74189,
    lng: -96.55522,
    city: "Crookston",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9293,
    density: 11,
    county_fips: 27119,
    county_name: "Polk",
    county_weights: {
      27119: 98.5,
      27125: 1.5,
    },
    county_names_all: "Polk|Red Lake",
    county_fips_all: "27119|27125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56720,
    lat: 48.56788,
    lng: -96.90632,
    city: "Donaldson",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7,
    density: 0.3,
    county_fips: 27069,
    county_name: "Kittson",
    county_weights: {
      27069: 100,
    },
    county_names_all: "Kittson",
    county_fips_all: 27069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56721,
    lat: 47.97108,
    lng: -96.94336,
    city: "East Grand Forks",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10296,
    density: 20.7,
    county_fips: 27119,
    county_name: "Polk",
    county_weights: {
      27119: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 27119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56722,
    lat: 47.9825,
    lng: -96.64644,
    city: "Euclid",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 402,
    density: 1.1,
    county_fips: 27119,
    county_name: "Polk",
    county_weights: {
      27119: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 27119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56723,
    lat: 47.80493,
    lng: -96.8059,
    city: "Fisher",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 881,
    density: 2.8,
    county_fips: 27119,
    county_name: "Polk",
    county_weights: {
      27119: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 27119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56724,
    lat: 48.44534,
    lng: -95.73473,
    city: "Gatzke",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 107,
    density: 0.3,
    county_fips: 27089,
    county_name: "Marshall",
    county_weights: {
      27089: 98.38,
      27135: 1.62,
    },
    county_names_all: "Marshall|Roseau",
    county_fips_all: "27089|27135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56725,
    lat: 48.1477,
    lng: -95.70485,
    city: "Goodridge",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 880,
    density: 0.8,
    county_fips: 27113,
    county_name: "Pennington",
    county_weights: {
      27007: 27.45,
      27089: 30.15,
      27113: 42.4,
    },
    county_names_all: "Pennington|Marshall|Beltrami",
    county_fips_all: "27113|27089|27007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56726,
    lat: 48.7258,
    lng: -96.22712,
    city: "Greenbush",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1600,
    density: 2.3,
    county_fips: 27135,
    county_name: "Roseau",
    county_weights: {
      27135: 100,
    },
    county_names_all: "Roseau",
    county_fips_all: 27135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56727,
    lat: 48.34945,
    lng: -95.38946,
    city: "Grygla",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 993,
    density: 0.6,
    county_fips: 27007,
    county_name: "Beltrami",
    county_weights: {
      27007: 85.35,
      27089: 14.65,
    },
    county_names_all: "Beltrami|Marshall",
    county_fips_all: "27007|27089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56728,
    lat: 48.78736,
    lng: -96.99149,
    city: "Hallock",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1287,
    density: 2.6,
    county_fips: 27069,
    county_name: "Kittson",
    county_weights: {
      27069: 100,
    },
    county_names_all: "Kittson",
    county_fips_all: 27069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56729,
    lat: 48.66558,
    lng: -96.59438,
    city: "Halma",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 94,
    density: 0.8,
    county_fips: 27069,
    county_name: "Kittson",
    county_weights: {
      27069: 100,
    },
    county_names_all: "Kittson",
    county_fips_all: 27069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56731,
    lat: 48.90771,
    lng: -97.07475,
    city: "Humboldt",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 132,
    density: 1.3,
    county_fips: 27069,
    county_name: "Kittson",
    county_weights: {
      27069: 100,
    },
    county_names_all: "Kittson",
    county_fips_all: 27069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56732,
    lat: 48.5863,
    lng: -96.49276,
    city: "Karlstad",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1030,
    density: 2.5,
    county_fips: 27069,
    county_name: "Kittson",
    county_weights: {
      27069: 70.59,
      27089: 18.09,
      27135: 11.32,
    },
    county_names_all: "Kittson|Marshall|Roseau",
    county_fips_all: "27069|27089|27135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56733,
    lat: 48.63342,
    lng: -96.89149,
    city: "Kennedy",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 328,
    density: 0.8,
    county_fips: 27069,
    county_name: "Kittson",
    county_weights: {
      27069: 100,
    },
    county_names_all: "Kittson",
    county_fips_all: 27069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56734,
    lat: 48.76776,
    lng: -96.58134,
    city: "Lake Bronson",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 615,
    density: 1.4,
    county_fips: 27069,
    county_name: "Kittson",
    county_weights: {
      27069: 100,
    },
    county_names_all: "Kittson",
    county_fips_all: 27069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56735,
    lat: 48.91328,
    lng: -96.63659,
    city: "Lancaster",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 769,
    density: 0.8,
    county_fips: 27069,
    county_name: "Kittson",
    county_weights: {
      27069: 81.23,
      27135: 18.77,
    },
    county_names_all: "Kittson|Roseau",
    county_fips_all: "27069|27135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56736,
    lat: 47.71212,
    lng: -96.20567,
    city: "Mentor",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 768,
    density: 2.7,
    county_fips: 27119,
    county_name: "Polk",
    county_weights: {
      27119: 84.95,
      27125: 15.05,
    },
    county_names_all: "Polk|Red Lake",
    county_fips_all: "27119|27125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56737,
    lat: 48.41144,
    lng: -96.01081,
    city: "Middle River",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 813,
    density: 1.3,
    county_fips: 27089,
    county_name: "Marshall",
    county_weights: {
      27089: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 27089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56738,
    lat: 48.34448,
    lng: -96.33456,
    city: "Newfolden",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1516,
    density: 3.2,
    county_fips: 27089,
    county_name: "Marshall",
    county_weights: {
      27089: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 27089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56742,
    lat: 47.92728,
    lng: -95.82076,
    city: "Oklee",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 988,
    density: 3.5,
    county_fips: 27125,
    county_name: "Red Lake",
    county_weights: {
      27113: 27.17,
      27119: 4.05,
      27125: 68.78,
    },
    county_names_all: "Red Lake|Pennington|Polk",
    county_fips_all: "27125|27113|27119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56744,
    lat: 48.23456,
    lng: -97.1089,
    city: "Oslo",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 492,
    density: 2,
    county_fips: 27089,
    county_name: "Marshall",
    county_weights: {
      27089: 49.96,
      27119: 23.26,
      38035: 3.67,
      38099: 23.11,
    },
    county_names_all: "Marshall|Polk|Walsh|Grand Forks",
    county_fips_all: "27089|27119|38099|38035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56748,
    lat: 47.92066,
    lng: -96.00743,
    city: "Plummer",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 625,
    density: 2.7,
    county_fips: 27125,
    county_name: "Red Lake",
    county_weights: {
      27113: 19.51,
      27125: 80.49,
    },
    county_names_all: "Red Lake|Pennington",
    county_fips_all: "27125|27113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56750,
    lat: 47.89027,
    lng: -96.30172,
    city: "Red Lake Falls",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2257,
    density: 3.7,
    county_fips: 27125,
    county_name: "Red Lake",
    county_weights: {
      27113: 13.89,
      27119: 6.78,
      27125: 79.33,
    },
    county_names_all: "Red Lake|Pennington|Polk",
    county_fips_all: "27125|27113|27119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56751,
    lat: 48.80929,
    lng: -95.76035,
    city: "Roseau",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5588,
    density: 4.6,
    county_fips: 27135,
    county_name: "Roseau",
    county_weights: {
      27135: 100,
    },
    county_names_all: "Roseau",
    county_fips_all: 27135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56754,
    lat: 47.99065,
    lng: -96.18199,
    city: "Saint Hilaire",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 589,
    density: 5.9,
    county_fips: 27113,
    county_name: "Pennington",
    county_weights: {
      27113: 91,
      27125: 9,
    },
    county_names_all: "Pennington|Red Lake",
    county_fips_all: "27113|27125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56755,
    lat: 48.97141,
    lng: -97.1152,
    city: "Saint Vincent",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67,
    density: 0.6,
    county_fips: 27069,
    county_name: "Kittson",
    county_weights: {
      27069: 100,
    },
    county_names_all: "Kittson",
    county_fips_all: 27069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56756,
    lat: 48.90302,
    lng: -95.56388,
    city: "Salol",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 649,
    density: 1.9,
    county_fips: 27135,
    county_name: "Roseau",
    county_weights: {
      27135: 100,
    },
    county_names_all: "Roseau",
    county_fips_all: 27135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56757,
    lat: 48.47641,
    lng: -96.90596,
    city: "Stephen",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 843,
    density: 1.4,
    county_fips: 27089,
    county_name: "Marshall",
    county_weights: {
      27069: 5.04,
      27089: 94.96,
    },
    county_names_all: "Marshall|Kittson",
    county_fips_all: "27089|27069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56758,
    lat: 48.46201,
    lng: -96.51891,
    city: "Strandquist",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 295,
    density: 1.1,
    county_fips: 27089,
    county_name: "Marshall",
    county_weights: {
      27089: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 27089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56759,
    lat: 48.55188,
    lng: -96.08011,
    city: "Strathcona",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 290,
    density: 0.7,
    county_fips: 27135,
    county_name: "Roseau",
    county_weights: {
      27089: 36.25,
      27135: 63.75,
    },
    county_names_all: "Roseau|Marshall",
    county_fips_all: "27135|27089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56760,
    lat: 48.24037,
    lng: -96.44586,
    city: "Viking",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 391,
    density: 1.8,
    county_fips: 27089,
    county_name: "Marshall",
    county_weights: {
      27089: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 27089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56761,
    lat: 48.60862,
    lng: -95.69725,
    city: "Wannaska",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 440,
    density: 1.7,
    county_fips: 27135,
    county_name: "Roseau",
    county_weights: {
      27135: 100,
    },
    county_names_all: "Roseau",
    county_fips_all: 27135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56762,
    lat: 48.1688,
    lng: -96.7415,
    city: "Warren",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2515,
    density: 2.9,
    county_fips: 27119,
    county_name: "Polk",
    county_weights: {
      27089: 48.25,
      27119: 51.75,
    },
    county_names_all: "Polk|Marshall",
    county_fips_all: "27119|27089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 56763,
    lat: 48.80879,
    lng: -95.34167,
    city: "Warroad",
    state_id: "MN",
    state_name: "Minnesota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5150,
    density: 7.6,
    county_fips: 27135,
    county_name: "Roseau",
    county_weights: {
      27135: 100,
    },
    county_names_all: "Roseau",
    county_fips_all: 27135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57001,
    lat: 42.9981,
    lng: -96.65492,
    city: "Alcester",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1742,
    density: 6.8,
    county_fips: 46127,
    county_name: "Union",
    county_weights: {
      46083: 6.57,
      46127: 93.43,
    },
    county_names_all: "Union|Lincoln",
    county_fips_all: "46127|46083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57002,
    lat: 44.28785,
    lng: -96.67752,
    city: "Aurora",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1234,
    density: 7.5,
    county_fips: 46011,
    county_name: "Brookings",
    county_weights: {
      46011: 92.4,
      46101: 7.6,
    },
    county_names_all: "Brookings|Moody",
    county_fips_all: "46011|46101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57003,
    lat: 43.73705,
    lng: -96.75784,
    city: "Baltic",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1730,
    density: 13.1,
    county_fips: 46099,
    county_name: "Minnehaha",
    county_weights: {
      46099: 100,
    },
    county_names_all: "Minnehaha",
    county_fips_all: 46099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57004,
    lat: 43.07571,
    lng: -96.79376,
    city: "Beresford",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4040,
    density: 8,
    county_fips: 46083,
    county_name: "Lincoln",
    county_weights: {
      46027: 26.46,
      46083: 47.03,
      46127: 26.52,
    },
    county_names_all: "Lincoln|Union|Clay",
    county_fips_all: "46083|46127|46027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57005,
    lat: 43.59281,
    lng: -96.58728,
    city: "Brandon",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11576,
    density: 91.3,
    county_fips: 46099,
    county_name: "Minnehaha",
    county_weights: {
      46099: 100,
    },
    county_names_all: "Minnehaha",
    county_fips_all: 46099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57006,
    lat: 44.31588,
    lng: -96.79518,
    city: "Brookings",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26561,
    density: 67.6,
    county_fips: 46011,
    county_name: "Brookings",
    county_weights: {
      46011: 88.81,
      46101: 11.19,
    },
    county_names_all: "Brookings|Moody",
    county_fips_all: "46011|46101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57007,
    lat: 44.31924,
    lng: -96.78408,
    city: "Brookings",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 46011,
    county_name: "Brookings",
    county_weights: {
      46011: 100,
    },
    county_names_all: "Brookings",
    county_fips_all: 46011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57010,
    lat: 42.8119,
    lng: -96.82403,
    city: "Burbank",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 527,
    density: 3.3,
    county_fips: 46027,
    county_name: "Clay",
    county_weights: {
      46027: 69.56,
      46127: 30.44,
    },
    county_names_all: "Clay|Union",
    county_fips_all: "46027|46127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57012,
    lat: 43.59683,
    lng: -97.27986,
    city: "Canistota",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1149,
    density: 5.3,
    county_fips: 46087,
    county_name: "McCook",
    county_weights: {
      46087: 100,
    },
    county_names_all: "McCook",
    county_fips_all: 46087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57013,
    lat: 43.28595,
    lng: -96.62178,
    city: "Canton",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4901,
    density: 14.3,
    county_fips: 46083,
    county_name: "Lincoln",
    county_weights: {
      46083: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 46083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57014,
    lat: 43.11238,
    lng: -96.95347,
    city: "Centerville",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1579,
    density: 4.5,
    county_fips: 46125,
    county_name: "Turner",
    county_weights: {
      46027: 32.96,
      46083: 24.53,
      46125: 42.51,
    },
    county_names_all: "Turner|Clay|Lincoln",
    county_fips_all: "46125|46027|46083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57015,
    lat: 43.42182,
    lng: -96.98006,
    city: "Chancellor",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 728,
    density: 5.7,
    county_fips: 46125,
    county_name: "Turner",
    county_weights: {
      46099: 2.03,
      46125: 97.97,
    },
    county_names_all: "Turner|Minnehaha",
    county_fips_all: "46125|46099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57016,
    lat: 43.88874,
    lng: -96.96139,
    city: "Chester",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 879,
    density: 12.8,
    county_fips: 46079,
    county_name: "Lake",
    county_weights: {
      46079: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 46079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57017,
    lat: 44.02246,
    lng: -96.82788,
    city: "Colman",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1357,
    density: 4.8,
    county_fips: 46101,
    county_name: "Moody",
    county_weights: {
      46079: 0.93,
      46101: 99.07,
    },
    county_names_all: "Moody|Lake",
    county_fips_all: "46101|46079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57018,
    lat: 43.79995,
    lng: -96.97901,
    city: "Colton",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1470,
    density: 6.7,
    county_fips: 46099,
    county_name: "Minnehaha",
    county_weights: {
      46079: 3.5,
      46099: 96.5,
    },
    county_names_all: "Minnehaha|Lake",
    county_fips_all: "46099|46079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57020,
    lat: 43.67796,
    lng: -96.82665,
    city: "Crooks",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1501,
    density: 32.5,
    county_fips: 46099,
    county_name: "Minnehaha",
    county_weights: {
      46099: 100,
    },
    county_names_all: "Minnehaha",
    county_fips_all: 46099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57021,
    lat: 43.2723,
    lng: -96.97797,
    city: "Davis",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 408,
    density: 5.2,
    county_fips: 46125,
    county_name: "Turner",
    county_weights: {
      46125: 100,
    },
    county_names_all: "Turner",
    county_fips_all: 46125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57022,
    lat: 43.85081,
    lng: -96.7327,
    city: "Dell Rapids",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5417,
    density: 14.8,
    county_fips: 46099,
    county_name: "Minnehaha",
    county_weights: {
      46079: 2.88,
      46099: 51.2,
      46101: 45.92,
    },
    county_names_all: "Minnehaha|Moody|Lake",
    county_fips_all: "46099|46101|46079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57024,
    lat: 43.98538,
    lng: -96.68146,
    city: "Egan",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 496,
    density: 6.6,
    county_fips: 46101,
    county_name: "Moody",
    county_weights: {
      46101: 100,
    },
    county_names_all: "Moody",
    county_fips_all: 46101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57025,
    lat: 42.71718,
    lng: -96.68894,
    city: "Elk Point",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2894,
    density: 9,
    county_fips: 46127,
    county_name: "Union",
    county_weights: {
      46127: 100,
    },
    county_names_all: "Union",
    county_fips_all: 46127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57026,
    lat: 44.24996,
    lng: -96.50149,
    city: "Elkton",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1287,
    density: 2.8,
    county_fips: 46011,
    county_name: "Brookings",
    county_weights: {
      27081: 13.62,
      27117: 9.67,
      46011: 56.79,
      46101: 19.92,
    },
    county_names_all: "Brookings|Moody|Lincoln|Pipestone",
    county_fips_all: "46011|46101|27081|27117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57027,
    lat: 43.19461,
    lng: -96.50933,
    city: "Fairview",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 237,
    density: 9.6,
    county_fips: 46083,
    county_name: "Lincoln",
    county_weights: {
      46083: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 46083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57028,
    lat: 44.05766,
    lng: -96.60443,
    city: "Flandreau",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3427,
    density: 6.6,
    county_fips: 46101,
    county_name: "Moody",
    county_weights: {
      46101: 100,
    },
    county_names_all: "Moody",
    county_fips_all: 46101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57029,
    lat: 43.33696,
    lng: -97.47936,
    city: "Freeman",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2422,
    density: 4.9,
    county_fips: 46067,
    county_name: "Hutchinson",
    county_weights: {
      46067: 76.79,
      46125: 23.21,
    },
    county_names_all: "Hutchinson|Turner",
    county_fips_all: "46067|46125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57030,
    lat: 43.73435,
    lng: -96.53549,
    city: "Garretson",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2953,
    density: 8.6,
    county_fips: 46099,
    county_name: "Minnehaha",
    county_weights: {
      27133: 10.03,
      46099: 89.97,
    },
    county_names_all: "Minnehaha|Rock",
    county_fips_all: "46099|27133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57031,
    lat: 42.87058,
    lng: -97.18655,
    city: "Gayville",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 810,
    density: 7.9,
    county_fips: 46135,
    county_name: "Yankton",
    county_weights: {
      46027: 22.57,
      46135: 77.43,
    },
    county_names_all: "Yankton|Clay",
    county_fips_all: "46135|46027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57032,
    lat: 43.42326,
    lng: -96.68708,
    city: "Harrisburg",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8536,
    density: 67.5,
    county_fips: 46083,
    county_name: "Lincoln",
    county_weights: {
      46083: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 46083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57033,
    lat: 43.61613,
    lng: -96.96037,
    city: "Hartford",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5602,
    density: 17.9,
    county_fips: 46099,
    county_name: "Minnehaha",
    county_weights: {
      46099: 100,
    },
    county_names_all: "Minnehaha",
    county_fips_all: 46099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57034,
    lat: 43.12493,
    lng: -96.54575,
    city: "Hudson",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 964,
    density: 4.9,
    county_fips: 46083,
    county_name: "Lincoln",
    county_weights: {
      19167: 7.72,
      46083: 83.55,
      46127: 8.73,
    },
    county_names_all: "Lincoln|Union|Sioux",
    county_fips_all: "46083|46127|19167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57035,
    lat: 43.64651,
    lng: -97.07627,
    city: "Humboldt",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1306,
    density: 5.9,
    county_fips: 46099,
    county_name: "Minnehaha",
    county_weights: {
      46087: 7.7,
      46099: 92.3,
    },
    county_names_all: "Minnehaha|McCook",
    county_fips_all: "46099|46087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57036,
    lat: 43.27067,
    lng: -97.14364,
    city: "Hurley",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 576,
    density: 2.4,
    county_fips: 46125,
    county_name: "Turner",
    county_weights: {
      46125: 100,
    },
    county_names_all: "Turner",
    county_fips_all: 46125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57037,
    lat: 43.10146,
    lng: -97.25318,
    city: "Irene",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 943,
    density: 3.5,
    county_fips: 46135,
    county_name: "Yankton",
    county_weights: {
      46027: 6.8,
      46125: 11.07,
      46135: 82.13,
    },
    county_names_all: "Yankton|Turner|Clay",
    county_fips_all: "46135|46125|46027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57038,
    lat: 42.57924,
    lng: -96.57957,
    city: "Jefferson",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1673,
    density: 12.8,
    county_fips: 46127,
    county_name: "Union",
    county_weights: {
      46127: 100,
    },
    county_names_all: "Union",
    county_fips_all: 46127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57039,
    lat: 43.33659,
    lng: -96.86755,
    city: "Lennox",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3796,
    density: 15.9,
    county_fips: 46083,
    county_name: "Lincoln",
    county_weights: {
      46083: 92.11,
      46125: 7.89,
    },
    county_names_all: "Lincoln|Turner",
    county_fips_all: "46083|46125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57040,
    lat: 43.06206,
    lng: -97.58582,
    city: "Lesterville",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 314,
    density: 1.7,
    county_fips: 46135,
    county_name: "Yankton",
    county_weights: {
      46009: 3.48,
      46135: 96.52,
    },
    county_names_all: "Yankton|Bon Homme",
    county_fips_all: "46135|46009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57041,
    lat: 43.72184,
    lng: -96.88415,
    city: "Lyons",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47,
    density: 5.8,
    county_fips: 46099,
    county_name: "Minnehaha",
    county_weights: {
      46099: 100,
    },
    county_names_all: "Minnehaha",
    county_fips_all: 46099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57042,
    lat: 43.97744,
    lng: -97.15133,
    city: "Madison",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9348,
    density: 18.7,
    county_fips: 46079,
    county_name: "Lake",
    county_weights: {
      46079: 99.22,
      46087: 0.78,
    },
    county_names_all: "Lake|McCook",
    county_fips_all: "46079|46087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57043,
    lat: 43.41954,
    lng: -97.30889,
    city: "Marion",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1393,
    density: 4.7,
    county_fips: 46125,
    county_name: "Turner",
    county_weights: {
      46067: 3.43,
      46087: 11.1,
      46125: 85.47,
    },
    county_names_all: "Turner|McCook|Hutchinson",
    county_fips_all: "46125|46087|46067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57045,
    lat: 43.20051,
    lng: -97.52425,
    city: "Menno",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1130,
    density: 3.6,
    county_fips: 46067,
    county_name: "Hutchinson",
    county_weights: {
      46067: 69.3,
      46125: 2.17,
      46135: 28.53,
    },
    county_names_all: "Hutchinson|Yankton|Turner",
    county_fips_all: "46067|46135|46125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57046,
    lat: 42.9563,
    lng: -97.30113,
    city: "Mission Hill",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 887,
    density: 6.8,
    county_fips: 46135,
    county_name: "Yankton",
    county_weights: {
      46135: 100,
    },
    county_names_all: "Yankton",
    county_fips_all: 46135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57047,
    lat: 43.51755,
    lng: -97.21525,
    city: "Monroe",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 339,
    density: 8.9,
    county_fips: 46087,
    county_name: "McCook",
    county_weights: {
      46087: 77.04,
      46125: 22.96,
    },
    county_names_all: "McCook|Turner",
    county_fips_all: "46087|46125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57048,
    lat: 43.74081,
    lng: -97.20034,
    city: "Montrose",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1266,
    density: 3.8,
    county_fips: 46087,
    county_name: "McCook",
    county_weights: {
      46087: 90.15,
      46099: 9.85,
    },
    county_names_all: "McCook|Minnehaha",
    county_fips_all: "46087|46099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57049,
    lat: 42.52486,
    lng: -96.50732,
    city: "North Sioux City",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6684,
    density: 182.1,
    county_fips: 46127,
    county_name: "Union",
    county_weights: {
      46127: 100,
    },
    county_names_all: "Union",
    county_fips_all: 46127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57050,
    lat: 44.15725,
    lng: -97.01467,
    city: "Nunda",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 315,
    density: 3,
    county_fips: 46079,
    county_name: "Lake",
    county_weights: {
      46079: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 46079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57051,
    lat: 44.21741,
    lng: -97.35066,
    city: "Oldham",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 250,
    density: 1.2,
    county_fips: 46077,
    county_name: "Kingsbury",
    county_weights: {
      46077: 77.72,
      46079: 4.65,
      46097: 17.63,
    },
    county_names_all: "Kingsbury|Miner|Lake",
    county_fips_all: "46077|46097|46079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57052,
    lat: 43.29471,
    lng: -97.7054,
    city: "Olivet",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 263,
    density: 1.2,
    county_fips: 46067,
    county_name: "Hutchinson",
    county_weights: {
      46067: 100,
    },
    county_names_all: "Hutchinson",
    county_fips_all: 46067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57053,
    lat: 43.40963,
    lng: -97.13716,
    city: "Parker",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1813,
    density: 4.9,
    county_fips: 46125,
    county_name: "Turner",
    county_weights: {
      46087: 5.85,
      46099: 2.12,
      46125: 92.03,
    },
    county_names_all: "Turner|McCook|Minnehaha",
    county_fips_all: "46125|46087|46099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57054,
    lat: 44.12162,
    lng: -97.25799,
    city: "Ramona",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 651,
    density: 2.2,
    county_fips: 46079,
    county_name: "Lake",
    county_weights: {
      46079: 99.14,
      46097: 0.86,
    },
    county_names_all: "Lake|Miner",
    county_fips_all: "46079|46097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57055,
    lat: 43.66638,
    lng: -96.73973,
    city: "Renner",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1367,
    density: 31.3,
    county_fips: 46099,
    county_name: "Minnehaha",
    county_weights: {
      46099: 100,
    },
    county_names_all: "Minnehaha",
    county_fips_all: 46099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57057,
    lat: 44.10261,
    lng: -96.95717,
    city: "Rutland",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 324,
    density: 3.9,
    county_fips: 46079,
    county_name: "Lake",
    county_weights: {
      46079: 93.98,
      46101: 6.02,
    },
    county_names_all: "Lake|Moody",
    county_fips_all: "46079|46101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57058,
    lat: 43.74602,
    lng: -97.40468,
    city: "Salem",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1841,
    density: 4.5,
    county_fips: 46087,
    county_name: "McCook",
    county_weights: {
      46079: 2.54,
      46087: 95.58,
      46097: 1.88,
    },
    county_names_all: "McCook|Lake|Miner",
    county_fips_all: "46087|46079|46097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57059,
    lat: 43.12476,
    lng: -97.76365,
    city: "Scotland",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1181,
    density: 3.1,
    county_fips: 46009,
    county_name: "Bon Homme",
    county_weights: {
      46009: 78.49,
      46067: 21.51,
    },
    county_names_all: "Bon Homme|Hutchinson",
    county_fips_all: "46009|46067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57061,
    lat: 44.24452,
    lng: -97.04399,
    city: "Sinai",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 144,
    density: 151.2,
    county_fips: 46011,
    county_name: "Brookings",
    county_weights: {
      46011: 100,
    },
    county_names_all: "Brookings",
    county_fips_all: 46011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57062,
    lat: 42.85046,
    lng: -97.95327,
    city: "Springfield",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2409,
    density: 9.3,
    county_fips: 46009,
    county_name: "Bon Homme",
    county_weights: {
      46009: 100,
    },
    county_names_all: "Bon Homme",
    county_fips_all: 46009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57063,
    lat: 42.92483,
    lng: -97.68668,
    city: "Tabor",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 818,
    density: 3.4,
    county_fips: 46009,
    county_name: "Bon Homme",
    county_weights: {
      46009: 79.93,
      46135: 20.07,
    },
    county_names_all: "Bon Homme|Yankton",
    county_fips_all: "46009|46135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57064,
    lat: 43.45563,
    lng: -96.87489,
    city: "Tea",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7233,
    density: 109,
    county_fips: 46083,
    county_name: "Lincoln",
    county_weights: {
      46083: 85.67,
      46125: 14.33,
    },
    county_names_all: "Lincoln|Turner",
    county_fips_all: "46083|46125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57065,
    lat: 43.90041,
    lng: -96.60631,
    city: "Trent",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 378,
    density: 4.8,
    county_fips: 46101,
    county_name: "Moody",
    county_weights: {
      46101: 100,
    },
    county_names_all: "Moody",
    county_fips_all: 46101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57066,
    lat: 42.98874,
    lng: -97.86703,
    city: "Tyndall",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1484,
    density: 5,
    county_fips: 46009,
    county_name: "Bon Homme",
    county_weights: {
      46009: 100,
    },
    county_names_all: "Bon Homme",
    county_fips_all: 46009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57067,
    lat: 43.04095,
    lng: -97.47169,
    city: "Utica",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 273,
    density: 1.9,
    county_fips: 46135,
    county_name: "Yankton",
    county_weights: {
      46135: 100,
    },
    county_names_all: "Yankton",
    county_fips_all: 46135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57068,
    lat: 43.57435,
    lng: -96.49361,
    city: "Valley Springs",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1478,
    density: 12.4,
    county_fips: 46099,
    county_name: "Minnehaha",
    county_weights: {
      27133: 6.78,
      46099: 93.22,
    },
    county_names_all: "Minnehaha|Rock",
    county_fips_all: "46099|27133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57069,
    lat: 42.84348,
    lng: -96.98774,
    city: "Vermillion",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12077,
    density: 27.5,
    county_fips: 46027,
    county_name: "Clay",
    county_weights: {
      46027: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 46027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57070,
    lat: 43.182,
    lng: -97.1702,
    city: "Viborg",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1399,
    density: 6.1,
    county_fips: 46125,
    county_name: "Turner",
    county_weights: {
      46125: 88.06,
      46135: 11.94,
    },
    county_names_all: "Turner|Yankton",
    county_fips_all: "46125|46135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57071,
    lat: 44.26986,
    lng: -96.95934,
    city: "Volga",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3030,
    density: 9.8,
    county_fips: 46011,
    county_name: "Brookings",
    county_weights: {
      46011: 92.03,
      46079: 6.39,
      46101: 1.58,
    },
    county_names_all: "Brookings|Lake|Moody",
    county_fips_all: "46011|46079|46101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57072,
    lat: 42.98747,
    lng: -97.20363,
    city: "Volin",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 659,
    density: 3.4,
    county_fips: 46135,
    county_name: "Yankton",
    county_weights: {
      46027: 27.93,
      46135: 72.07,
    },
    county_names_all: "Yankton|Clay",
    county_fips_all: "46135|46027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57073,
    lat: 43.00227,
    lng: -97.05754,
    city: "Wakonda",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 648,
    density: 3.6,
    county_fips: 46027,
    county_name: "Clay",
    county_weights: {
      46027: 95.58,
      46125: 4.42,
    },
    county_names_all: "Clay|Turner",
    county_fips_all: "46027|46125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57075,
    lat: 43.99605,
    lng: -96.96749,
    city: "Wentworth",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 974,
    density: 4.7,
    county_fips: 46079,
    county_name: "Lake",
    county_weights: {
      46079: 97.8,
      46101: 2.2,
    },
    county_names_all: "Lake|Moody",
    county_fips_all: "46079|46101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57076,
    lat: 43.97673,
    lng: -97.35307,
    city: "Winfred",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 487,
    density: 1.8,
    county_fips: 46079,
    county_name: "Lake",
    county_weights: {
      46079: 53.38,
      46097: 46.62,
    },
    county_names_all: "Lake|Miner",
    county_fips_all: "46079|46097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57077,
    lat: 43.31574,
    lng: -96.75699,
    city: "Worthing",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1511,
    density: 13.1,
    county_fips: 46083,
    county_name: "Lincoln",
    county_weights: {
      46083: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 46083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57078,
    lat: 42.91782,
    lng: -97.44702,
    city: "Yankton",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19428,
    density: 67.4,
    county_fips: 46135,
    county_name: "Yankton",
    county_weights: {
      46135: 100,
    },
    county_names_all: "Yankton",
    county_fips_all: 46135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57103,
    lat: 43.538,
    lng: -96.69241,
    city: "Sioux Falls",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36761,
    density: 1499.6,
    county_fips: 46099,
    county_name: "Minnehaha",
    county_weights: {
      46099: 100,
    },
    county_names_all: "Minnehaha",
    county_fips_all: 46099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57104,
    lat: 43.6041,
    lng: -96.70442,
    city: "Sioux Falls",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26217,
    density: 333.2,
    county_fips: 46099,
    county_name: "Minnehaha",
    county_weights: {
      46099: 100,
    },
    county_names_all: "Minnehaha",
    county_fips_all: 46099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57105,
    lat: 43.52125,
    lng: -96.73587,
    city: "Sioux Falls",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22647,
    density: 1162.9,
    county_fips: 46099,
    county_name: "Minnehaha",
    county_weights: {
      46099: 100,
    },
    county_names_all: "Minnehaha",
    county_fips_all: 46099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57106,
    lat: 43.50953,
    lng: -96.83919,
    city: "Sioux Falls",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47855,
    density: 610.5,
    county_fips: 46099,
    county_name: "Minnehaha",
    county_weights: {
      46083: 33.3,
      46099: 66.7,
    },
    county_names_all: "Minnehaha|Lincoln",
    county_fips_all: "46099|46083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57107,
    lat: 43.59468,
    lng: -96.81962,
    city: "Sioux Falls",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10317,
    density: 85.2,
    county_fips: 46099,
    county_name: "Minnehaha",
    county_weights: {
      46099: 100,
    },
    county_names_all: "Minnehaha",
    county_fips_all: 46099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57108,
    lat: 43.47776,
    lng: -96.70571,
    city: "Sioux Falls",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24866,
    density: 315.8,
    county_fips: 46083,
    county_name: "Lincoln",
    county_weights: {
      46083: 98.67,
      46099: 1.33,
    },
    county_names_all: "Lincoln|Minnehaha",
    county_fips_all: "46083|46099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57110,
    lat: 43.54445,
    lng: -96.63812,
    city: "Sioux Falls",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18470,
    density: 341.4,
    county_fips: 46099,
    county_name: "Minnehaha",
    county_weights: {
      46099: 100,
    },
    county_names_all: "Minnehaha",
    county_fips_all: 46099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57117,
    lat: 43.53124,
    lng: -96.75497,
    city: "Sioux Falls",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2,
    density: 8.2,
    county_fips: 46099,
    county_name: "Minnehaha",
    county_weights: {
      46099: 100,
    },
    county_names_all: "Minnehaha",
    county_fips_all: 46099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57197,
    lat: 43.52455,
    lng: -96.73862,
    city: "Sioux Falls",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1008,
    density: 4636.9,
    county_fips: 46099,
    county_name: "Minnehaha",
    county_weights: {
      46099: 100,
    },
    county_names_all: "Minnehaha",
    county_fips_all: 46099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57201,
    lat: 44.93412,
    lng: -97.09424,
    city: "Watertown",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25582,
    density: 31,
    county_fips: 46029,
    county_name: "Codington",
    county_weights: {
      46029: 99.1,
      46057: 0.9,
    },
    county_names_all: "Codington|Hamlin",
    county_fips_all: "46029|46057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57212,
    lat: 44.38111,
    lng: -97.14344,
    city: "Arlington",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2138,
    density: 3.6,
    county_fips: 46077,
    county_name: "Kingsbury",
    county_weights: {
      46011: 41.72,
      46057: 3.54,
      46077: 53.94,
      46079: 0.8,
    },
    county_names_all: "Kingsbury|Brookings|Hamlin|Lake",
    county_fips_all: "46077|46011|46057|46079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57213,
    lat: 44.57112,
    lng: -96.5323,
    city: "Astoria",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 712,
    density: 5.8,
    county_fips: 46039,
    county_name: "Deuel",
    county_weights: {
      46011: 23.99,
      46039: 76.01,
    },
    county_names_all: "Deuel|Brookings",
    county_fips_all: "46039|46011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57214,
    lat: 44.47764,
    lng: -97.19575,
    city: "Badger",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61,
    density: 4.2,
    county_fips: 46077,
    county_name: "Kingsbury",
    county_weights: {
      46077: 100,
    },
    county_names_all: "Kingsbury",
    county_fips_all: 46077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57216,
    lat: 45.30041,
    lng: -96.52471,
    city: "Big Stone City",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1203,
    density: 7.6,
    county_fips: 46051,
    county_name: "Grant",
    county_weights: {
      46051: 63.64,
      46109: 36.36,
    },
    county_names_all: "Grant|Roberts",
    county_fips_all: "46051|46109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57217,
    lat: 45.0845,
    lng: -97.67004,
    city: "Bradley",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 249,
    density: 1.2,
    county_fips: 46025,
    county_name: "Clark",
    county_weights: {
      46025: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 46025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57218,
    lat: 44.65787,
    lng: -96.59624,
    city: "Brandt",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 285,
    density: 1.6,
    county_fips: 46039,
    county_name: "Deuel",
    county_weights: {
      46039: 100,
    },
    county_names_all: "Deuel",
    county_fips_all: 46039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57219,
    lat: 45.2877,
    lng: -97.801,
    city: "Bristol",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 482,
    density: 1.1,
    county_fips: 46037,
    county_name: "Day",
    county_weights: {
      46037: 100,
    },
    county_names_all: "Day",
    county_fips_all: 46037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57220,
    lat: 44.45927,
    lng: -96.92022,
    city: "Bruce",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 843,
    density: 3,
    county_fips: 46011,
    county_name: "Brookings",
    county_weights: {
      46011: 100,
    },
    county_names_all: "Brookings",
    county_fips_all: 46011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57221,
    lat: 44.60654,
    lng: -97.44853,
    city: "Bryant",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 973,
    density: 3.2,
    county_fips: 46057,
    county_name: "Hamlin",
    county_weights: {
      46025: 26.76,
      46057: 73.24,
    },
    county_names_all: "Hamlin|Clark",
    county_fips_all: "46057|46025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57223,
    lat: 44.71019,
    lng: -97.00567,
    city: "Castlewood",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1217,
    density: 3.8,
    county_fips: 46057,
    county_name: "Hamlin",
    county_weights: {
      46039: 2.31,
      46057: 97.69,
    },
    county_names_all: "Hamlin|Deuel",
    county_fips_all: "46057|46039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57224,
    lat: 45.81332,
    lng: -97.15672,
    city: "Claire City",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 108,
    density: 0.9,
    county_fips: 46109,
    county_name: "Roberts",
    county_weights: {
      46109: 100,
    },
    county_names_all: "Roberts",
    county_fips_all: 46109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57225,
    lat: 44.88359,
    lng: -97.72676,
    city: "Clark",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1871,
    density: 2.5,
    county_fips: 46025,
    county_name: "Clark",
    county_weights: {
      46025: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 46025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57226,
    lat: 44.78565,
    lng: -96.72368,
    city: "Clear Lake",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1906,
    density: 3.9,
    county_fips: 46039,
    county_name: "Deuel",
    county_weights: {
      46039: 96.42,
      46057: 3.58,
    },
    county_names_all: "Deuel|Hamlin",
    county_fips_all: "46039|46057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57227,
    lat: 45.36184,
    lng: -96.72105,
    city: "Corona",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 428,
    density: 3.8,
    county_fips: 46109,
    county_name: "Roberts",
    county_weights: {
      46051: 7,
      46109: 93,
    },
    county_names_all: "Roberts|Grant",
    county_fips_all: "46109|46051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57231,
    lat: 44.3749,
    lng: -97.58243,
    city: "De Smet",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1731,
    density: 2.7,
    county_fips: 46077,
    county_name: "Kingsbury",
    county_weights: {
      46077: 100,
    },
    county_names_all: "Kingsbury",
    county_fips_all: 46077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57232,
    lat: 45.61752,
    lng: -97.38393,
    city: "Eden",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 380,
    density: 1.9,
    county_fips: 46091,
    county_name: "Marshall",
    county_weights: {
      46091: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 46091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57233,
    lat: 44.50992,
    lng: -97.3993,
    city: "Erwin",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 264,
    density: 2.8,
    county_fips: 46077,
    county_name: "Kingsbury",
    county_weights: {
      46077: 100,
    },
    county_names_all: "Kingsbury",
    county_fips_all: 46077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57234,
    lat: 44.59719,
    lng: -96.89929,
    city: "Estelline",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1315,
    density: 5,
    county_fips: 46039,
    county_name: "Deuel",
    county_weights: {
      46011: 6.07,
      46039: 47.98,
      46057: 45.94,
    },
    county_names_all: "Deuel|Hamlin|Brookings",
    county_fips_all: "46039|46057|46011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57235,
    lat: 45.06896,
    lng: -97.31338,
    city: "Florence",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 940,
    density: 2.8,
    county_fips: 46029,
    county_name: "Codington",
    county_weights: {
      46029: 94.95,
      46037: 5.05,
    },
    county_names_all: "Codington|Day",
    county_fips_all: "46029|46037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57236,
    lat: 44.98724,
    lng: -97.59033,
    city: "Garden City",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 150,
    density: 1.1,
    county_fips: 46025,
    county_name: "Clark",
    county_weights: {
      46025: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 46025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57237,
    lat: 44.79323,
    lng: -96.51991,
    city: "Gary",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 658,
    density: 2.6,
    county_fips: 46039,
    county_name: "Deuel",
    county_weights: {
      46039: 100,
    },
    county_names_all: "Deuel",
    county_fips_all: 46039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57238,
    lat: 44.87287,
    lng: -96.86231,
    city: "Goodwin",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 517,
    density: 2.7,
    county_fips: 46039,
    county_name: "Deuel",
    county_weights: {
      46029: 31.23,
      46039: 64.03,
      46057: 4.74,
    },
    county_names_all: "Deuel|Codington|Hamlin",
    county_fips_all: "46039|46029|46057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57239,
    lat: 45.51223,
    lng: -97.30938,
    city: "Grenville",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 294,
    density: 2.5,
    county_fips: 46037,
    county_name: "Day",
    county_weights: {
      46037: 100,
    },
    county_names_all: "Day",
    county_fips_all: 46037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57241,
    lat: 44.69742,
    lng: -97.21747,
    city: "Hayti",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1012,
    density: 3.8,
    county_fips: 46057,
    county_name: "Hamlin",
    county_weights: {
      46057: 100,
    },
    county_names_all: "Hamlin",
    county_fips_all: 46057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57242,
    lat: 44.77352,
    lng: -97.35902,
    city: "Hazel",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 482,
    density: 2.1,
    county_fips: 46057,
    county_name: "Hamlin",
    county_weights: {
      46029: 20.34,
      46057: 79.66,
    },
    county_names_all: "Hamlin|Codington",
    county_fips_all: "46057|46029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57243,
    lat: 44.91177,
    lng: -97.42072,
    city: "Henry",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 628,
    density: 2.1,
    county_fips: 46029,
    county_name: "Codington",
    county_weights: {
      46025: 10.89,
      46029: 87.53,
      46057: 1.58,
    },
    county_names_all: "Codington|Clark|Hamlin",
    county_fips_all: "46029|46025|46057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57245,
    lat: 44.89365,
    lng: -96.91835,
    city: "Kranzburg",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 182,
    density: 282.8,
    county_fips: 46029,
    county_name: "Codington",
    county_weights: {
      46029: 100,
    },
    county_names_all: "Codington",
    county_fips_all: 46029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57246,
    lat: 45.05639,
    lng: -96.66914,
    city: "Labolt",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 210,
    density: 2.7,
    county_fips: 46051,
    county_name: "Grant",
    county_weights: {
      46051: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 46051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57247,
    lat: 45.71675,
    lng: -97.45817,
    city: "Lake City",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 210,
    density: 1.1,
    county_fips: 46091,
    county_name: "Marshall",
    county_weights: {
      46091: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 46091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57248,
    lat: 44.58063,
    lng: -97.19328,
    city: "Lake Norden",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1101,
    density: 6.3,
    county_fips: 46057,
    county_name: "Hamlin",
    county_weights: {
      46057: 83.26,
      46077: 16.74,
    },
    county_names_all: "Hamlin|Kingsbury",
    county_fips_all: "46057|46077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57249,
    lat: 44.37111,
    lng: -97.3646,
    city: "Lake Preston",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 777,
    density: 2.1,
    county_fips: 46077,
    county_name: "Kingsbury",
    county_weights: {
      46077: 100,
    },
    county_names_all: "Kingsbury",
    county_fips_all: 46077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57251,
    lat: 45.27717,
    lng: -96.93677,
    city: "Marvin",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 152,
    density: 1.2,
    county_fips: 46051,
    county_name: "Grant",
    county_weights: {
      46051: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 46051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57252,
    lat: 45.20507,
    lng: -96.61053,
    city: "Milbank",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4516,
    density: 10.6,
    county_fips: 46051,
    county_name: "Grant",
    county_weights: {
      46051: 96.39,
      46109: 3.61,
    },
    county_names_all: "Grant|Roberts",
    county_fips_all: "46051|46109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57255,
    lat: 45.86702,
    lng: -96.94985,
    city: "New Effington",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 430,
    density: 1.6,
    county_fips: 46109,
    county_name: "Roberts",
    county_weights: {
      38077: 4.52,
      46109: 95.48,
    },
    county_names_all: "Roberts|Richland",
    county_fips_all: "46109|38077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57256,
    lat: 45.24918,
    lng: -97.20156,
    city: "Ortley",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 172,
    density: 1.5,
    county_fips: 46051,
    county_name: "Grant",
    county_weights: {
      46029: 4.69,
      46037: 12.97,
      46051: 62.22,
      46109: 20.12,
    },
    county_names_all: "Grant|Roberts|Day|Codington",
    county_fips_all: "46051|46109|46037|46029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57257,
    lat: 45.49975,
    lng: -97.02982,
    city: "Peever",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 739,
    density: 3.8,
    county_fips: 46109,
    county_name: "Roberts",
    county_weights: {
      46109: 100,
    },
    county_names_all: "Roberts",
    county_fips_all: 46109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57258,
    lat: 44.88434,
    lng: -97.9246,
    city: "Raymond",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75,
    density: 0.2,
    county_fips: 46025,
    county_name: "Clark",
    county_weights: {
      46025: 93.39,
      46115: 6.61,
    },
    county_names_all: "Clark|Spink",
    county_fips_all: "46025|46115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57259,
    lat: 45.00047,
    lng: -96.56786,
    city: "Revillo",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 527,
    density: 1.5,
    county_fips: 46051,
    county_name: "Grant",
    county_weights: {
      46039: 38.69,
      46051: 61.31,
    },
    county_names_all: "Grant|Deuel",
    county_fips_all: "46051|46039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57260,
    lat: 45.83641,
    lng: -96.7172,
    city: "Rosholt",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1112,
    density: 2.6,
    county_fips: 46109,
    county_name: "Roberts",
    county_weights: {
      46109: 100,
    },
    county_names_all: "Roberts",
    county_fips_all: 46109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57261,
    lat: 45.54051,
    lng: -97.49412,
    city: "Roslyn",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 320,
    density: 1.8,
    county_fips: 46037,
    county_name: "Day",
    county_weights: {
      46037: 100,
    },
    county_names_all: "Day",
    county_fips_all: 46037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57262,
    lat: 45.67288,
    lng: -97.06641,
    city: "Sisseton",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5314,
    density: 6.1,
    county_fips: 46109,
    county_name: "Roberts",
    county_weights: {
      46091: 8.85,
      46109: 91.15,
    },
    county_names_all: "Roberts|Marshall",
    county_fips_all: "46109|46091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57263,
    lat: 45.14106,
    lng: -97.00589,
    city: "South Shore",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 489,
    density: 1.7,
    county_fips: 46029,
    county_name: "Codington",
    county_weights: {
      46029: 65.69,
      46051: 34.31,
    },
    county_names_all: "Codington|Grant",
    county_fips_all: "46029|46051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57264,
    lat: 45.10863,
    lng: -96.80254,
    city: "Stockholm",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 282,
    density: 2.5,
    county_fips: 46051,
    county_name: "Grant",
    county_weights: {
      46051: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 46051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57265,
    lat: 44.98866,
    lng: -96.79591,
    city: "Strandburg",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 192,
    density: 0.9,
    county_fips: 46051,
    county_name: "Grant",
    county_weights: {
      46029: 3.42,
      46039: 38.01,
      46051: 58.57,
    },
    county_names_all: "Grant|Deuel|Codington",
    county_fips_all: "46051|46039|46029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57266,
    lat: 45.28619,
    lng: -97.08985,
    city: "Summit",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 542,
    density: 1.6,
    county_fips: 46051,
    county_name: "Grant",
    county_weights: {
      46051: 51.59,
      46109: 48.41,
    },
    county_names_all: "Grant|Roberts",
    county_fips_all: "46051|46109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57268,
    lat: 44.56885,
    lng: -96.68781,
    city: "Toronto",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 488,
    density: 2.9,
    county_fips: 46039,
    county_name: "Deuel",
    county_weights: {
      46011: 22.06,
      46039: 77.94,
    },
    county_names_all: "Deuel|Brookings",
    county_fips_all: "46039|46011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57269,
    lat: 45.22273,
    lng: -96.80182,
    city: "Twin Brooks",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 241,
    density: 1,
    county_fips: 46051,
    county_name: "Grant",
    county_weights: {
      46051: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 46051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57270,
    lat: 45.84824,
    lng: -97.32999,
    city: "Veblen",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 834,
    density: 2,
    county_fips: 46091,
    county_name: "Marshall",
    county_weights: {
      46091: 86.85,
      46109: 13.15,
    },
    county_names_all: "Marshall|Roberts",
    county_fips_all: "46091|46109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57271,
    lat: 44.75179,
    lng: -97.55161,
    city: "Vienna",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 279,
    density: 1.7,
    county_fips: 46025,
    county_name: "Clark",
    county_weights: {
      46025: 83.01,
      46057: 16.99,
    },
    county_names_all: "Clark|Hamlin",
    county_fips_all: "46025|46057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57272,
    lat: 45.09564,
    lng: -97.48002,
    city: "Wallace",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 207,
    density: 1.8,
    county_fips: 46029,
    county_name: "Codington",
    county_weights: {
      46025: 39.41,
      46029: 60.59,
    },
    county_names_all: "Codington|Clark",
    county_fips_all: "46029|46025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57273,
    lat: 45.33334,
    lng: -97.27574,
    city: "Waubay",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1078,
    density: 2.4,
    county_fips: 46037,
    county_name: "Day",
    county_weights: {
      46037: 77.42,
      46109: 22.58,
    },
    county_names_all: "Day|Roberts",
    county_fips_all: "46037|46109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57274,
    lat: 45.30943,
    lng: -97.55533,
    city: "Webster",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2591,
    density: 2.7,
    county_fips: 46037,
    county_name: "Day",
    county_weights: {
      46025: 7.37,
      46037: 92.63,
    },
    county_names_all: "Day|Clark",
    county_fips_all: "46037|46025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57276,
    lat: 44.43308,
    lng: -96.61983,
    city: "White",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1222,
    density: 3.8,
    county_fips: 46011,
    county_name: "Brookings",
    county_weights: {
      46011: 100,
    },
    county_names_all: "Brookings",
    county_fips_all: 46011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57278,
    lat: 44.64689,
    lng: -97.68227,
    city: "Willow Lake",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 877,
    density: 2.1,
    county_fips: 46025,
    county_name: "Clark",
    county_weights: {
      46025: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 46025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57279,
    lat: 45.41816,
    lng: -96.87274,
    city: "Wilmot",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1081,
    density: 3,
    county_fips: 46109,
    county_name: "Roberts",
    county_weights: {
      46109: 100,
    },
    county_names_all: "Roberts",
    county_fips_all: 46109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57301,
    lat: 43.71136,
    lng: -98.04155,
    city: "Mitchell",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18719,
    density: 30.3,
    county_fips: 46035,
    county_name: "Davison",
    county_weights: {
      46035: 77.51,
      46061: 22.49,
    },
    county_names_all: "Davison|Hanson",
    county_fips_all: "46035|46061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57311,
    lat: 43.65112,
    lng: -97.76483,
    city: "Alexandria",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1654,
    density: 3.4,
    county_fips: 46061,
    county_name: "Hanson",
    county_weights: {
      46061: 99.04,
      46067: 0.96,
    },
    county_names_all: "Hanson|Hutchinson",
    county_fips_all: "46061|46067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57312,
    lat: 44.19646,
    lng: -98.38564,
    city: "Alpena",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 619,
    density: 1.8,
    county_fips: 46005,
    county_name: "Beadle",
    county_weights: {
      46005: 54.32,
      46073: 42.59,
      46111: 3.09,
    },
    county_names_all: "Beadle|Jerauld|Sanborn",
    county_fips_all: "46005|46073|46111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57313,
    lat: 43.31085,
    lng: -98.36327,
    city: "Armour",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1121,
    density: 2.4,
    county_fips: 46043,
    county_name: "Douglas",
    county_weights: {
      46023: 34.09,
      46043: 65.91,
    },
    county_names_all: "Douglas|Charles Mix",
    county_fips_all: "46043|46023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57314,
    lat: 44.0509,
    lng: -97.98904,
    city: "Artesian",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 690,
    density: 1,
    county_fips: 46111,
    county_name: "Sanborn",
    county_weights: {
      46111: 100,
    },
    county_names_all: "Sanborn",
    county_fips_all: 46111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57315,
    lat: 42.99391,
    lng: -98.04852,
    city: "Avon",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1271,
    density: 3.8,
    county_fips: 46009,
    county_name: "Bon Homme",
    county_weights: {
      46009: 96.02,
      46023: 3.98,
    },
    county_names_all: "Bon Homme|Charles Mix",
    county_fips_all: "46009|46023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57317,
    lat: 43.13153,
    lng: -98.97891,
    city: "Bonesteel",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 688,
    density: 1.7,
    county_fips: 46053,
    county_name: "Gregory",
    county_weights: {
      46053: 100,
    },
    county_names_all: "Gregory",
    county_fips_all: 46053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57319,
    lat: 43.53853,
    lng: -97.48353,
    city: "Bridgewater",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 871,
    density: 2.3,
    county_fips: 46087,
    county_name: "McCook",
    county_weights: {
      46067: 26.05,
      46087: 70.62,
      46125: 3.33,
    },
    county_names_all: "McCook|Hutchinson|Turner",
    county_fips_all: "46087|46067|46125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57321,
    lat: 43.87294,
    lng: -97.54864,
    city: "Canova",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 374,
    density: 1.3,
    county_fips: 46097,
    county_name: "Miner",
    county_weights: {
      46061: 6.66,
      46087: 17.05,
      46097: 76.29,
    },
    county_names_all: "Miner|McCook|Hanson",
    county_fips_all: "46097|46087|46061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57322,
    lat: 44.63498,
    lng: -97.96129,
    city: "Carpenter",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 300,
    density: 0.7,
    county_fips: 46005,
    county_name: "Beadle",
    county_weights: {
      46005: 43.69,
      46025: 36.12,
      46115: 20.19,
    },
    county_names_all: "Beadle|Clark|Spink",
    county_fips_all: "46005|46025|46115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57323,
    lat: 44.16259,
    lng: -97.72115,
    city: "Carthage",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 285,
    density: 0.9,
    county_fips: 46097,
    county_name: "Miner",
    county_weights: {
      46077: 22.78,
      46097: 73.94,
      46111: 3.28,
    },
    county_names_all: "Miner|Kingsbury|Sanborn",
    county_fips_all: "46097|46077|46111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57324,
    lat: 44.30154,
    lng: -98.04535,
    city: "Cavour",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 530,
    density: 2.4,
    county_fips: 46005,
    county_name: "Beadle",
    county_weights: {
      46005: 100,
    },
    county_names_all: "Beadle",
    county_fips_all: 46005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57325,
    lat: 43.83961,
    lng: -99.31144,
    city: "Chamberlain",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3096,
    density: 4.2,
    county_fips: 46015,
    county_name: "Brule",
    county_weights: {
      46015: 65.53,
      46017: 34.47,
    },
    county_names_all: "Brule|Buffalo",
    county_fips_all: "46015|46017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57328,
    lat: 43.43413,
    lng: -98.44207,
    city: "Corsica",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1345,
    density: 3.2,
    county_fips: 46043,
    county_name: "Douglas",
    county_weights: {
      46003: 2.43,
      46043: 97.57,
    },
    county_names_all: "Douglas|Aurora",
    county_fips_all: "46043|46003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57329,
    lat: 42.97814,
    lng: -98.1522,
    city: "Dante",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 410,
    density: 3.1,
    county_fips: 46023,
    county_name: "Charles Mix",
    county_weights: {
      46023: 100,
    },
    county_names_all: "Charles Mix",
    county_fips_all: 46023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57330,
    lat: 43.26147,
    lng: -98.16082,
    city: "Delmont",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 455,
    density: 1.5,
    county_fips: 46043,
    county_name: "Douglas",
    county_weights: {
      46023: 25.92,
      46043: 60.67,
      46067: 13.41,
    },
    county_names_all: "Douglas|Charles Mix|Hutchinson",
    county_fips_all: "46043|46023|46067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57331,
    lat: 43.47337,
    lng: -98.04619,
    city: "Dimock",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 425,
    density: 2.4,
    county_fips: 46067,
    county_name: "Hutchinson",
    county_weights: {
      46035: 10.93,
      46043: 23.26,
      46067: 65.81,
    },
    county_names_all: "Hutchinson|Douglas|Davison",
    county_fips_all: "46067|46043|46035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57332,
    lat: 43.5465,
    lng: -97.64762,
    city: "Emery",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 876,
    density: 3.4,
    county_fips: 46061,
    county_name: "Hanson",
    county_weights: {
      46061: 51.22,
      46067: 32.58,
      46087: 16.2,
    },
    county_names_all: "Hanson|Hutchinson|McCook",
    county_fips_all: "46061|46067|46087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57334,
    lat: 43.54199,
    lng: -97.99492,
    city: "Ethan",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 921,
    density: 3.3,
    county_fips: 46035,
    county_name: "Davison",
    county_weights: {
      46035: 51.59,
      46061: 35.66,
      46067: 12.75,
    },
    county_names_all: "Davison|Hanson|Hutchinson",
    county_fips_all: "46035|46061|46067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57335,
    lat: 43.06005,
    lng: -98.77255,
    city: "Fairfax",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 261,
    density: 1,
    county_fips: 46053,
    county_name: "Gregory",
    county_weights: {
      46053: 100,
    },
    county_names_all: "Gregory",
    county_fips_all: 46053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57337,
    lat: 44.00108,
    lng: -97.79048,
    city: "Fedora",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 84,
    density: 0.4,
    county_fips: 46097,
    county_name: "Miner",
    county_weights: {
      46097: 94.49,
      46111: 5.51,
    },
    county_names_all: "Miner|Sanborn",
    county_fips_all: "46097|46111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57339,
    lat: 44.11233,
    lng: -99.47862,
    city: "Fort Thompson",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1547,
    density: 11,
    county_fips: 46017,
    county_name: "Buffalo",
    county_weights: {
      46017: 100,
    },
    county_names_all: "Buffalo",
    county_fips_all: 46017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57340,
    lat: 43.79392,
    lng: -97.85036,
    city: "Fulton",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 219,
    density: 1.1,
    county_fips: 46061,
    county_name: "Hanson",
    county_weights: {
      46061: 83.95,
      46097: 16.05,
    },
    county_names_all: "Hanson|Miner",
    county_fips_all: "46061|46097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57341,
    lat: 44.08077,
    lng: -99.08974,
    city: "Gann Valley",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 172,
    density: 0.3,
    county_fips: 46017,
    county_name: "Buffalo",
    county_weights: {
      46015: 3.85,
      46017: 96.15,
    },
    county_names_all: "Buffalo|Brule",
    county_fips_all: "46017|46015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57342,
    lat: 43.24561,
    lng: -98.70054,
    city: "Geddes",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 455,
    density: 1.1,
    county_fips: 46023,
    county_name: "Charles Mix",
    county_weights: {
      46023: 100,
    },
    county_names_all: "Charles Mix",
    county_fips_all: 46023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57344,
    lat: 43.45575,
    lng: -98.61796,
    city: "Harrison",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 66,
    density: 0.7,
    county_fips: 46043,
    county_name: "Douglas",
    county_weights: {
      46043: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 46043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57345,
    lat: 44.5687,
    lng: -99.45009,
    city: "Highmore",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1217,
    density: 0.7,
    county_fips: 46069,
    county_name: "Hyde",
    county_weights: {
      46069: 100,
    },
    county_names_all: "Hyde",
    county_fips_all: 46069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57346,
    lat: 44.24818,
    lng: -99.45756,
    city: "Stephan",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 113,
    density: 158,
    county_fips: 46069,
    county_name: "Hyde",
    county_weights: {
      46069: 100,
    },
    county_names_all: "Hyde",
    county_fips_all: 46069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57348,
    lat: 44.62147,
    lng: -98.36483,
    city: "Hitchcock",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 781,
    density: 1.1,
    county_fips: 46005,
    county_name: "Beadle",
    county_weights: {
      46005: 58.29,
      46115: 41.71,
    },
    county_names_all: "Beadle|Spink",
    county_fips_all: "46005|46115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57349,
    lat: 44.02671,
    lng: -97.57521,
    city: "Howard",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1330,
    density: 2.2,
    county_fips: 46097,
    county_name: "Miner",
    county_weights: {
      46097: 100,
    },
    county_names_all: "Miner",
    county_fips_all: 46097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57350,
    lat: 44.3948,
    lng: -98.20037,
    city: "Huron",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15051,
    density: 19.9,
    county_fips: 46005,
    county_name: "Beadle",
    county_weights: {
      46005: 99.24,
      46111: 0.76,
    },
    county_names_all: "Beadle|Sanborn",
    county_fips_all: "46005|46111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57353,
    lat: 44.36944,
    lng: -97.83438,
    city: "Iroquois",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 789,
    density: 1,
    county_fips: 46077,
    county_name: "Kingsbury",
    county_weights: {
      46005: 41.21,
      46025: 3.01,
      46077: 55.78,
    },
    county_names_all: "Kingsbury|Beadle|Clark",
    county_fips_all: "46077|46005|46025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57354,
    lat: 43.19099,
    lng: -97.84236,
    city: "Kaylor",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 46067,
    county_name: "Hutchinson",
    county_weights: {
      46067: 100,
    },
    county_names_all: "Hutchinson",
    county_fips_all: 46067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57355,
    lat: 43.7747,
    lng: -98.95045,
    city: "Kimball",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1289,
    density: 1.3,
    county_fips: 46015,
    county_name: "Brule",
    county_weights: {
      46015: 88.81,
      46017: 4.04,
      46073: 7.15,
    },
    county_names_all: "Brule|Jerauld|Buffalo",
    county_fips_all: "46015|46073|46017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57356,
    lat: 43.1468,
    lng: -98.51803,
    city: "Lake Andes",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2139,
    density: 4.9,
    county_fips: 46023,
    county_name: "Charles Mix",
    county_weights: {
      46023: 100,
    },
    county_names_all: "Charles Mix",
    county_fips_all: 46023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57358,
    lat: 44.07521,
    lng: -98.42201,
    city: "Lane",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20,
    density: 8,
    county_fips: 46073,
    county_name: "Jerauld",
    county_weights: {
      46073: 100,
    },
    county_names_all: "Jerauld",
    county_fips_all: 46073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57359,
    lat: 43.90105,
    lng: -98.15589,
    city: "Letcher",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 621,
    density: 1.6,
    county_fips: 46111,
    county_name: "Sanborn",
    county_weights: {
      46003: 14.94,
      46035: 8.85,
      46111: 76.21,
    },
    county_names_all: "Sanborn|Aurora|Davison",
    county_fips_all: "46111|46003|46035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57361,
    lat: 42.99459,
    lng: -98.43463,
    city: "Marty",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 108,
    density: 16.8,
    county_fips: 46023,
    county_name: "Charles Mix",
    county_weights: {
      46023: 100,
    },
    county_names_all: "Charles Mix",
    county_fips_all: 46023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57362,
    lat: 44.47488,
    lng: -99.06447,
    city: "Miller",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1996,
    density: 1.7,
    county_fips: 46059,
    county_name: "Hand",
    county_weights: {
      46017: 3.04,
      46059: 96.96,
    },
    county_names_all: "Hand|Buffalo",
    county_fips_all: "46059|46017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57363,
    lat: 43.68723,
    lng: -98.25491,
    city: "Mount Vernon",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 901,
    density: 1.8,
    county_fips: 46035,
    county_name: "Davison",
    county_weights: {
      46003: 2.48,
      46035: 91.21,
      46111: 6.31,
    },
    county_names_all: "Davison|Sanborn|Aurora",
    county_fips_all: "46035|46111|46003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57364,
    lat: 43.43442,
    lng: -98.61786,
    city: "New Holland",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 46043,
    county_name: "Douglas",
    county_weights: {
      46043: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 46043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57365,
    lat: 43.81148,
    lng: -99.41723,
    city: "Oacoma",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 518,
    density: 3.2,
    county_fips: 46085,
    county_name: "Lyman",
    county_weights: {
      46085: 100,
    },
    county_names_all: "Lyman",
    county_fips_all: 46085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57366,
    lat: 43.3855,
    lng: -97.94306,
    city: "Parkston",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2439,
    density: 4.3,
    county_fips: 46067,
    county_name: "Hutchinson",
    county_weights: {
      46043: 11.11,
      46067: 88.89,
    },
    county_names_all: "Hutchinson|Douglas",
    county_fips_all: "46067|46043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57367,
    lat: 43.06348,
    lng: -98.5133,
    city: "Pickstown",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 288,
    density: 23.4,
    county_fips: 46023,
    county_name: "Charles Mix",
    county_weights: {
      46023: 100,
    },
    county_names_all: "Charles Mix",
    county_fips_all: 46023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57368,
    lat: 43.75117,
    lng: -98.47593,
    city: "Plankinton",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1199,
    density: 2,
    county_fips: 46003,
    county_name: "Aurora",
    county_weights: {
      46003: 100,
    },
    county_names_all: "Aurora",
    county_fips_all: 46003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57369,
    lat: 43.42544,
    lng: -98.94606,
    city: "Platte",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2415,
    density: 2.1,
    county_fips: 46023,
    county_name: "Charles Mix",
    county_weights: {
      46003: 0.92,
      46015: 21.88,
      46023: 75.13,
      46043: 2.07,
    },
    county_names_all: "Charles Mix|Brule|Douglas|Aurora",
    county_fips_all: "46023|46015|46043|46003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57370,
    lat: 43.80508,
    lng: -99.17211,
    city: "Pukwana",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 700,
    density: 1.3,
    county_fips: 46015,
    county_name: "Brule",
    county_weights: {
      46015: 78.7,
      46017: 21.3,
    },
    county_names_all: "Brule|Buffalo",
    county_fips_all: "46015|46017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57371,
    lat: 44.43146,
    lng: -99.23104,
    city: "Ree Heights",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 183,
    density: 0.3,
    county_fips: 46059,
    county_name: "Hand",
    county_weights: {
      46059: 97.48,
      46069: 2.52,
    },
    county_names_all: "Hand|Hyde",
    county_fips_all: "46059|46069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57373,
    lat: 44.52936,
    lng: -98.86987,
    city: "Saint Lawrence",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 427,
    density: 0.8,
    county_fips: 46059,
    county_name: "Hand",
    county_weights: {
      46059: 100,
    },
    county_names_all: "Hand",
    county_fips_all: 46059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57374,
    lat: 43.75582,
    lng: -97.60361,
    city: "Spencer",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 325,
    density: 1.6,
    county_fips: 46087,
    county_name: "McCook",
    county_weights: {
      46061: 45.99,
      46087: 54.01,
    },
    county_names_all: "McCook|Hanson",
    county_fips_all: "46087|46061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57375,
    lat: 43.56222,
    lng: -98.47877,
    city: "Stickney",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 641,
    density: 1.8,
    county_fips: 46003,
    county_name: "Aurora",
    county_weights: {
      46003: 98.57,
      46035: 1.43,
    },
    county_names_all: "Aurora|Davison",
    county_fips_all: "46003|46035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57376,
    lat: 43.21948,
    lng: -97.94176,
    city: "Tripp",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 813,
    density: 2.1,
    county_fips: 46067,
    county_name: "Hutchinson",
    county_weights: {
      46009: 21.86,
      46067: 78.14,
    },
    county_names_all: "Hutchinson|Bon Homme",
    county_fips_all: "46067|46009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57379,
    lat: 44.26428,
    lng: -98.53795,
    city: "Virgil",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 82,
    density: 0.6,
    county_fips: 46005,
    county_name: "Beadle",
    county_weights: {
      46005: 100,
    },
    county_names_all: "Beadle",
    county_fips_all: 46005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57380,
    lat: 43.03387,
    lng: -98.28916,
    city: "Wagner",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3771,
    density: 5.2,
    county_fips: 46023,
    county_name: "Charles Mix",
    county_weights: {
      46023: 100,
    },
    county_names_all: "Charles Mix",
    county_fips_all: 46023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57381,
    lat: 44.38717,
    lng: -98.73267,
    city: "Wessington",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 424,
    density: 0.5,
    county_fips: 46059,
    county_name: "Hand",
    county_weights: {
      46005: 38.58,
      46059: 61.42,
    },
    county_names_all: "Hand|Beadle",
    county_fips_all: "46059|46005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57382,
    lat: 44.05561,
    lng: -98.67303,
    city: "Wessington Springs",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1388,
    density: 1.2,
    county_fips: 46073,
    county_name: "Jerauld",
    county_weights: {
      46003: 11.69,
      46005: 3.31,
      46073: 85,
    },
    county_names_all: "Jerauld|Aurora|Beadle",
    county_fips_all: "46073|46003|46005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57383,
    lat: 43.7177,
    lng: -98.71382,
    city: "White Lake",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 831,
    density: 1.3,
    county_fips: 46003,
    county_name: "Aurora",
    county_weights: {
      46003: 95.49,
      46015: 4.51,
    },
    county_names_all: "Aurora|Brule",
    county_fips_all: "46003|46015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57384,
    lat: 44.42044,
    lng: -98.48477,
    city: "Wolsey",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1118,
    density: 2.1,
    county_fips: 46005,
    county_name: "Beadle",
    county_weights: {
      46005: 100,
    },
    county_names_all: "Beadle",
    county_fips_all: 46005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57385,
    lat: 44.04433,
    lng: -98.29507,
    city: "Woonsocket",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1285,
    density: 2.1,
    county_fips: 46111,
    county_name: "Sanborn",
    county_weights: {
      46003: 3.78,
      46073: 30.38,
      46111: 65.84,
    },
    county_names_all: "Sanborn|Jerauld|Aurora",
    county_fips_all: "46111|46073|46003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57386,
    lat: 44.50908,
    lng: -97.99845,
    city: "Yale",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 279,
    density: 1.6,
    county_fips: 46005,
    county_name: "Beadle",
    county_weights: {
      46005: 100,
    },
    county_names_all: "Beadle",
    county_fips_all: 46005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57401,
    lat: 45.4753,
    lng: -98.53042,
    city: "Aberdeen",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32468,
    density: 45,
    county_fips: 46013,
    county_name: "Brown",
    county_weights: {
      46013: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 46013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57420,
    lat: 45.2852,
    lng: -100.14319,
    city: "Akaska",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 139,
    density: 1.2,
    county_fips: 46129,
    county_name: "Walworth",
    county_weights: {
      46129: 100,
    },
    county_names_all: "Walworth",
    county_fips_all: 46129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57421,
    lat: 45.75045,
    lng: -97.90618,
    city: "Amherst",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 98,
    density: 1.1,
    county_fips: 46091,
    county_name: "Marshall",
    county_weights: {
      46091: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 46091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57422,
    lat: 45.42288,
    lng: -97.92199,
    city: "Andover",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 201,
    density: 0.7,
    county_fips: 46037,
    county_name: "Day",
    county_weights: {
      46013: 4.45,
      46037: 95.55,
    },
    county_names_all: "Day|Brown",
    county_fips_all: "46037|46013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57424,
    lat: 45.02012,
    lng: -98.53101,
    city: "Ashton",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 160,
    density: 0.4,
    county_fips: 46115,
    county_name: "Spink",
    county_weights: {
      46049: 7.03,
      46115: 92.97,
    },
    county_names_all: "Spink|Faulk",
    county_fips_all: "46115|46049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57426,
    lat: 45.73485,
    lng: -98.4936,
    city: "Barnard",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32,
    density: 2.1,
    county_fips: 46013,
    county_name: "Brown",
    county_weights: {
      46013: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 46013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57427,
    lat: 45.48109,
    lng: -98.31786,
    city: "Bath",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 562,
    density: 3.5,
    county_fips: 46013,
    county_name: "Brown",
    county_weights: {
      46013: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 46013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57428,
    lat: 45.44984,
    lng: -99.67922,
    city: "Bowdle",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 554,
    density: 1.1,
    county_fips: 46045,
    county_name: "Edmunds",
    county_weights: {
      46045: 62.98,
      46129: 37.02,
    },
    county_names_all: "Edmunds|Walworth",
    county_fips_all: "46045|46129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57429,
    lat: 45.16116,
    lng: -98.3005,
    city: "Brentford",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63,
    density: 1.7,
    county_fips: 46115,
    county_name: "Spink",
    county_weights: {
      46115: 100,
    },
    county_names_all: "Spink",
    county_fips_all: 46115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57430,
    lat: 45.82203,
    lng: -97.72205,
    city: "Britton",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2290,
    density: 2.5,
    county_fips: 46091,
    county_name: "Marshall",
    county_weights: {
      38081: 0.87,
      46091: 99.13,
    },
    county_names_all: "Marshall|Sargent",
    county_fips_all: "46091|38081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57432,
    lat: 45.6839,
    lng: -98.02453,
    city: "Claremont",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 395,
    density: 1.4,
    county_fips: 46013,
    county_name: "Brown",
    county_weights: {
      46013: 75.93,
      46091: 24.07,
    },
    county_names_all: "Brown|Marshall",
    county_fips_all: "46013|46091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57433,
    lat: 45.64311,
    lng: -98.32104,
    city: "Columbia",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 382,
    density: 1.2,
    county_fips: 46013,
    county_name: "Brown",
    county_weights: {
      46013: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 46013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57434,
    lat: 45.16669,
    lng: -98.07049,
    city: "Conde",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 461,
    density: 0.6,
    county_fips: 46115,
    county_name: "Spink",
    county_weights: {
      46013: 17.37,
      46025: 17.55,
      46037: 8.79,
      46115: 56.29,
    },
    county_names_all: "Spink|Clark|Brown|Day",
    county_fips_all: "46115|46025|46013|46037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57435,
    lat: 45.16916,
    lng: -98.90975,
    city: "Cresbard",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 264,
    density: 0.7,
    county_fips: 46049,
    county_name: "Faulk",
    county_weights: {
      46045: 23.27,
      46049: 76.73,
    },
    county_names_all: "Faulk|Edmunds",
    county_fips_all: "46049|46045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57436,
    lat: 44.84864,
    lng: -98.09131,
    city: "Doland",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 557,
    density: 1.1,
    county_fips: 46115,
    county_name: "Spink",
    county_weights: {
      46115: 100,
    },
    county_names_all: "Spink",
    county_fips_all: 46115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57437,
    lat: 45.78368,
    lng: -99.618,
    city: "Eureka",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1455,
    density: 1.1,
    county_fips: 46089,
    county_name: "McPherson",
    county_weights: {
      46021: 30.85,
      46089: 69.15,
    },
    county_names_all: "McPherson|Campbell",
    county_fips_all: "46089|46021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57438,
    lat: 45.06899,
    lng: -99.15462,
    city: "Faulkton",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1360,
    density: 1.2,
    county_fips: 46049,
    county_name: "Faulk",
    county_weights: {
      46049: 100,
    },
    county_names_all: "Faulk",
    county_fips_all: 46049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57439,
    lat: 45.33464,
    lng: -98.10007,
    city: "Ferney",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37,
    density: 35.8,
    county_fips: 46013,
    county_name: "Brown",
    county_weights: {
      46013: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 46013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57440,
    lat: 44.8502,
    lng: -98.25956,
    city: "Frankfort",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 536,
    density: 1.5,
    county_fips: 46115,
    county_name: "Spink",
    county_weights: {
      46115: 100,
    },
    county_names_all: "Spink",
    county_fips_all: 46115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57441,
    lat: 45.82275,
    lng: -98.51474,
    city: "Frederick",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 545,
    density: 0.8,
    county_fips: 46013,
    county_name: "Brown",
    county_weights: {
      46013: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 46013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57442,
    lat: 45.05721,
    lng: -100.14997,
    city: "Gettysburg",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1909,
    density: 1.2,
    county_fips: 46107,
    county_name: "Potter",
    county_weights: {
      46041: 15.18,
      46107: 82.85,
      46119: 1.97,
    },
    county_names_all: "Potter|Dewey|Sully",
    county_fips_all: "46107|46041|46119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57445,
    lat: 45.45828,
    lng: -98.12094,
    city: "Groton",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2063,
    density: 3.1,
    county_fips: 46013,
    county_name: "Brown",
    county_weights: {
      46013: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 46013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57446,
    lat: 45.86698,
    lng: -98.15423,
    city: "Hecla",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 753,
    density: 1.9,
    county_fips: 46013,
    county_name: "Brown",
    county_weights: {
      46013: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 46013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57448,
    lat: 45.61196,
    lng: -99.41859,
    city: "Hosmer",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 408,
    density: 1,
    county_fips: 46089,
    county_name: "McPherson",
    county_weights: {
      46045: 41.58,
      46089: 58.42,
    },
    county_names_all: "McPherson|Edmunds",
    county_fips_all: "46089|46045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57449,
    lat: 45.73101,
    lng: -98.17553,
    city: "Houghton",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 290,
    density: 1.3,
    county_fips: 46013,
    county_name: "Brown",
    county_weights: {
      46013: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 46013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57450,
    lat: 45.21599,
    lng: -99.83696,
    city: "Hoven",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 485,
    density: 0.9,
    county_fips: 46107,
    county_name: "Potter",
    county_weights: {
      46107: 64.42,
      46129: 35.58,
    },
    county_names_all: "Potter|Walworth",
    county_fips_all: "46107|46129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57451,
    lat: 45.43488,
    lng: -98.93473,
    city: "Ipswich",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2243,
    density: 2,
    county_fips: 46045,
    county_name: "Edmunds",
    county_weights: {
      46013: 7.52,
      46045: 92.48,
    },
    county_names_all: "Edmunds|Brown",
    county_fips_all: "46045|46013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57452,
    lat: 45.52873,
    lng: -99.87334,
    city: "Java",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 230,
    density: 0.4,
    county_fips: 46129,
    county_name: "Walworth",
    county_weights: {
      46021: 29.24,
      46129: 70.76,
    },
    county_names_all: "Walworth|Campbell",
    county_fips_all: "46129|46021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57454,
    lat: 45.61058,
    lng: -97.77286,
    city: "Langford",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 823,
    density: 2.1,
    county_fips: 46091,
    county_name: "Marshall",
    county_weights: {
      46037: 30.15,
      46091: 69.85,
    },
    county_names_all: "Marshall|Day",
    county_fips_all: "46091|46037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57455,
    lat: 44.99301,
    lng: -99.74011,
    city: "Lebanon",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 119,
    density: 0.4,
    county_fips: 46107,
    county_name: "Potter",
    county_weights: {
      46107: 100,
    },
    county_names_all: "Potter",
    county_fips_all: 46107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57456,
    lat: 45.72104,
    lng: -98.99589,
    city: "Leola",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 836,
    density: 0.9,
    county_fips: 46089,
    county_name: "McPherson",
    county_weights: {
      46045: 2.74,
      46089: 97.26,
    },
    county_names_all: "McPherson|Edmunds",
    county_fips_all: "46089|46045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57457,
    lat: 45.87281,
    lng: -99.15812,
    city: "Long Lake",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 70,
    density: 0.2,
    county_fips: 46089,
    county_name: "McPherson",
    county_weights: {
      46089: 100,
    },
    county_names_all: "McPherson",
    county_fips_all: 46089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57460,
    lat: 45.27323,
    lng: -98.66585,
    city: "Mansfield",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 375,
    density: 1.2,
    county_fips: 46013,
    county_name: "Brown",
    county_weights: {
      46013: 58.07,
      46045: 21.16,
      46049: 9.84,
      46115: 10.93,
    },
    county_names_all: "Brown|Edmunds|Spink|Faulk",
    county_fips_all: "46013|46045|46115|46049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57461,
    lat: 45.16085,
    lng: -98.43327,
    city: "Mellette",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 340,
    density: 1.2,
    county_fips: 46115,
    county_name: "Spink",
    county_weights: {
      46013: 1.84,
      46115: 98.16,
    },
    county_names_all: "Spink|Brown",
    county_fips_all: "46115|46013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57465,
    lat: 45.14443,
    lng: -98.68573,
    city: "Northville",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 371,
    density: 0.9,
    county_fips: 46115,
    county_name: "Spink",
    county_weights: {
      46049: 39.78,
      46115: 60.22,
    },
    county_names_all: "Spink|Faulk",
    county_fips_all: "46115|46049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57466,
    lat: 45.20045,
    lng: -99.45885,
    city: "Onaka",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 218,
    density: 0.6,
    county_fips: 46049,
    county_name: "Faulk",
    county_weights: {
      46045: 23.76,
      46049: 76.24,
    },
    county_names_all: "Faulk|Edmunds",
    county_fips_all: "46049|46045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57467,
    lat: 44.82754,
    lng: -99.14221,
    city: "Orient",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 259,
    density: 0.5,
    county_fips: 46059,
    county_name: "Hand",
    county_weights: {
      46049: 9.95,
      46059: 90.05,
    },
    county_names_all: "Hand|Faulk",
    county_fips_all: "46059|46049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57468,
    lat: 45.49797,
    lng: -97.75318,
    city: "Pierpont",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 477,
    density: 2.5,
    county_fips: 46037,
    county_name: "Day",
    county_weights: {
      46037: 100,
    },
    county_names_all: "Day",
    county_fips_all: 46037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57469,
    lat: 44.85858,
    lng: -98.57535,
    city: "Redfield",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3281,
    density: 4.2,
    county_fips: 46115,
    county_name: "Spink",
    county_weights: {
      46049: 5.96,
      46059: 16.92,
      46115: 77.12,
    },
    county_names_all: "Spink|Hand|Faulk",
    county_fips_all: "46115|46059|46049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57470,
    lat: 44.87726,
    lng: -98.86709,
    city: "Rockham",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67,
    density: 0.2,
    county_fips: 46059,
    county_name: "Hand",
    county_weights: {
      46049: 40.64,
      46059: 59.36,
    },
    county_names_all: "Hand|Faulk",
    county_fips_all: "46059|46049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57471,
    lat: 45.40967,
    lng: -99.31359,
    city: "Roscoe",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 543,
    density: 0.6,
    county_fips: 46045,
    county_name: "Edmunds",
    county_weights: {
      46045: 96.31,
      46089: 3.69,
    },
    county_names_all: "Edmunds|McPherson",
    county_fips_all: "46045|46089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57472,
    lat: 45.4284,
    lng: -100.10393,
    city: "Selby",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 877,
    density: 1.2,
    county_fips: 46129,
    county_name: "Walworth",
    county_weights: {
      46021: 0.69,
      46129: 99.31,
    },
    county_names_all: "Walworth|Campbell",
    county_fips_all: "46129|46021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57473,
    lat: 44.98993,
    lng: -99.483,
    city: "Seneca",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 255,
    density: 0.5,
    county_fips: 46049,
    county_name: "Faulk",
    county_weights: {
      46049: 81.76,
      46107: 18.24,
    },
    county_names_all: "Faulk|Potter",
    county_fips_all: "46049|46107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57474,
    lat: 45.28577,
    lng: -98.27526,
    city: "Stratford",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 152,
    density: 0.7,
    county_fips: 46013,
    county_name: "Brown",
    county_weights: {
      46013: 82.15,
      46115: 17.85,
    },
    county_names_all: "Brown|Spink",
    county_fips_all: "46013|46115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57475,
    lat: 45.22843,
    lng: -99.62031,
    city: "Tolstoy",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 125,
    density: 0.4,
    county_fips: 46107,
    county_name: "Potter",
    county_weights: {
      46045: 48.68,
      46107: 51.32,
    },
    county_names_all: "Potter|Edmunds",
    county_fips_all: "46107|46045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57476,
    lat: 44.71277,
    lng: -98.62127,
    city: "Tulare",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 472,
    density: 1.2,
    county_fips: 46115,
    county_name: "Spink",
    county_weights: {
      46059: 24.03,
      46115: 75.97,
    },
    county_names_all: "Spink|Hand",
    county_fips_all: "46115|46059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57477,
    lat: 45.03363,
    lng: -98.15024,
    city: "Turton",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 159,
    density: 0.6,
    county_fips: 46115,
    county_name: "Spink",
    county_weights: {
      46115: 100,
    },
    county_names_all: "Spink",
    county_fips_all: 46115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57479,
    lat: 45.30415,
    lng: -98.4382,
    city: "Warner",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 614,
    density: 4.9,
    county_fips: 46013,
    county_name: "Brown",
    county_weights: {
      46013: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 46013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57481,
    lat: 45.65279,
    lng: -98.66821,
    city: "Westport",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 478,
    density: 1,
    county_fips: 46013,
    county_name: "Brown",
    county_weights: {
      46013: 56.47,
      46045: 12.25,
      46089: 31.28,
    },
    county_names_all: "Brown|McPherson|Edmunds",
    county_fips_all: "46013|46089|46045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57501,
    lat: 44.53525,
    lng: -100.31906,
    city: "Pierre",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16831,
    density: 11.5,
    county_fips: 46065,
    county_name: "Hughes",
    county_weights: {
      46065: 55.15,
      46119: 44.85,
    },
    county_names_all: "Hughes|Sully",
    county_fips_all: "46065|46119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57520,
    lat: 44.84159,
    lng: -100.16447,
    city: "Agar",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 93,
    density: 0.2,
    county_fips: 46119,
    county_name: "Sully",
    county_weights: {
      46119: 100,
    },
    county_names_all: "Sully",
    county_fips_all: 46119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57521,
    lat: 43.79349,
    lng: -101.18682,
    city: "Belvidere",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 239,
    density: 0.2,
    county_fips: 46095,
    county_name: "Mellette",
    county_weights: {
      46071: 49.83,
      46095: 50.17,
    },
    county_names_all: "Mellette|Jackson",
    county_fips_all: "46095|46071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57522,
    lat: 44.51014,
    lng: -99.96352,
    city: "Blunt",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 639,
    density: 1.4,
    county_fips: 46065,
    county_name: "Hughes",
    county_weights: {
      46065: 69.14,
      46119: 30.86,
    },
    county_names_all: "Hughes|Sully",
    county_fips_all: "46065|46119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57523,
    lat: 43.24437,
    lng: -99.23795,
    city: "Burke",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1023,
    density: 1.6,
    county_fips: 46053,
    county_name: "Gregory",
    county_weights: {
      46053: 100,
    },
    county_names_all: "Gregory",
    county_fips_all: 46053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57528,
    lat: 43.17814,
    lng: -99.75901,
    city: "Colome",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 942,
    density: 1.7,
    county_fips: 46123,
    county_name: "Tripp",
    county_weights: {
      46123: 100,
    },
    county_names_all: "Tripp",
    county_fips_all: 46123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57529,
    lat: 43.22931,
    lng: -99.57019,
    city: "Dallas",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 352,
    density: 0.6,
    county_fips: 46123,
    county_name: "Tripp",
    county_weights: {
      46053: 29.86,
      46123: 70.14,
    },
    county_names_all: "Tripp|Gregory",
    county_fips_all: "46123|46053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57531,
    lat: 43.98038,
    lng: -100.48601,
    city: "Draper",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 96,
    density: 0.1,
    county_fips: 46075,
    county_name: "Jones",
    county_weights: {
      46075: 97.98,
      46117: 2.02,
    },
    county_names_all: "Jones|Stanley",
    county_fips_all: "46075|46117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57532,
    lat: 44.36129,
    lng: -100.56405,
    city: "Fort Pierre",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3020,
    density: 0.9,
    county_fips: 46117,
    county_name: "Stanley",
    county_weights: {
      46085: 14.7,
      46117: 85.3,
    },
    county_names_all: "Stanley|Lyman",
    county_fips_all: "46117|46085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57533,
    lat: 43.3463,
    lng: -99.41692,
    city: "Gregory",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1848,
    density: 1.9,
    county_fips: 46053,
    county_name: "Gregory",
    county_weights: {
      46053: 71.14,
      46085: 27.84,
      46123: 1.02,
    },
    county_names_all: "Gregory|Lyman|Tripp",
    county_fips_all: "46053|46085|46123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57534,
    lat: 43.5709,
    lng: -99.65975,
    city: "Hamill",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 259,
    density: 0.5,
    county_fips: 46123,
    county_name: "Tripp",
    county_weights: {
      46085: 20.34,
      46123: 79.66,
    },
    county_names_all: "Tripp|Lyman",
    county_fips_all: "46123|46085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57536,
    lat: 44.41502,
    lng: -99.76694,
    city: "Harrold",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 308,
    density: 0.3,
    county_fips: 46065,
    county_name: "Hughes",
    county_weights: {
      46065: 72.59,
      46119: 27.41,
    },
    county_names_all: "Hughes|Sully",
    county_fips_all: "46065|46119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57537,
    lat: 44.58366,
    lng: -101.07399,
    city: "Hayes",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 96,
    density: 0.2,
    county_fips: 46117,
    county_name: "Stanley",
    county_weights: {
      46055: 16.4,
      46117: 83.6,
    },
    county_names_all: "Stanley|Haakon",
    county_fips_all: "46117|46055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57538,
    lat: 43.12167,
    lng: -99.15551,
    city: "Herrick",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 214,
    density: 0.7,
    county_fips: 46053,
    county_name: "Gregory",
    county_weights: {
      46053: 100,
    },
    county_names_all: "Gregory",
    county_fips_all: 46053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57540,
    lat: 44.46477,
    lng: -99.60377,
    city: "Holabird",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 107,
    density: 0.2,
    county_fips: 46069,
    county_name: "Hyde",
    county_weights: {
      46069: 100,
    },
    county_names_all: "Hyde",
    county_fips_all: 46069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57541,
    lat: 43.60001,
    lng: -99.90895,
    city: "Ideal",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 163,
    density: 0.5,
    county_fips: 46123,
    county_name: "Tripp",
    county_weights: {
      46123: 100,
    },
    county_names_all: "Tripp",
    county_fips_all: 46123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57543,
    lat: 43.74785,
    lng: -101.52268,
    city: "Kadoka",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 726,
    density: 0.6,
    county_fips: 46071,
    county_name: "Jackson",
    county_weights: {
      46071: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 46071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57544,
    lat: 43.88374,
    lng: -99.83647,
    city: "Kennebec",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 465,
    density: 0.7,
    county_fips: 46085,
    county_name: "Lyman",
    county_weights: {
      46085: 93.88,
      46123: 6.12,
    },
    county_names_all: "Lyman|Tripp",
    county_fips_all: "46085|46123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57547,
    lat: 43.48337,
    lng: -101.44054,
    city: "Long Valley",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 174,
    density: 0.3,
    county_fips: 46071,
    county_name: "Jackson",
    county_weights: {
      46071: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 46071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57548,
    lat: 44.08429,
    lng: -99.62373,
    city: "Lower Brule",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1611,
    density: 6.5,
    county_fips: 46085,
    county_name: "Lyman",
    county_weights: {
      46085: 100,
    },
    county_names_all: "Lyman",
    county_fips_all: 46085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57551,
    lat: 43.18087,
    lng: -101.70012,
    city: "Martin",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2492,
    density: 1.3,
    county_fips: 46007,
    county_name: "Bennett",
    county_weights: {
      46007: 100,
    },
    county_names_all: "Bennett",
    county_fips_all: 46007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57552,
    lat: 44.25903,
    lng: -101.20833,
    city: "Midland",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 537,
    density: 0.2,
    county_fips: 46055,
    county_name: "Haakon",
    county_weights: {
      46055: 71.5,
      46071: 3.65,
      46075: 10.27,
      46117: 14.58,
    },
    county_names_all: "Haakon|Stanley|Jones|Jackson",
    county_fips_all: "46055|46117|46075|46071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57553,
    lat: 44.48547,
    lng: -101.64489,
    city: "Milesville",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 104,
    density: 0.2,
    county_fips: 46055,
    county_name: "Haakon",
    county_weights: {
      46055: 100,
    },
    county_names_all: "Haakon",
    county_fips_all: 46055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57555,
    lat: 43.29828,
    lng: -100.6601,
    city: "Mission",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4369,
    density: 5,
    county_fips: 46121,
    county_name: "Todd",
    county_weights: {
      46121: 100,
    },
    county_names_all: "Todd",
    county_fips_all: 46121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57559,
    lat: 43.93654,
    lng: -100.72054,
    city: "Murdo",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 587,
    density: 0.5,
    county_fips: 46075,
    county_name: "Jones",
    county_weights: {
      46075: 99.17,
      46095: 0.83,
    },
    county_names_all: "Jones|Mellette",
    county_fips_all: "46075|46095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57560,
    lat: 43.44006,
    lng: -101.21226,
    city: "Norris",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 503,
    density: 1.1,
    county_fips: 46095,
    county_name: "Mellette",
    county_weights: {
      46007: 24.97,
      46071: 18.75,
      46095: 56.28,
    },
    county_names_all: "Mellette|Bennett|Jackson",
    county_fips_all: "46095|46007|46071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57562,
    lat: 43.89962,
    lng: -100.95816,
    city: "Okaton",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 138,
    density: 0.5,
    county_fips: 46075,
    county_name: "Jones",
    county_weights: {
      46075: 100,
    },
    county_names_all: "Jones",
    county_fips_all: 46075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57563,
    lat: 43.36039,
    lng: -100.40149,
    city: "Okreek",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 178,
    density: 2.3,
    county_fips: 46121,
    county_name: "Todd",
    county_weights: {
      46121: 100,
    },
    county_names_all: "Todd",
    county_fips_all: 46121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57564,
    lat: 44.72401,
    lng: -100.0121,
    city: "Onida",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 956,
    density: 0.8,
    county_fips: 46119,
    county_name: "Sully",
    county_weights: {
      46069: 2.25,
      46119: 97.75,
    },
    county_names_all: "Sully|Hyde",
    county_fips_all: "46119|46069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57566,
    lat: 43.31237,
    lng: -101.10019,
    city: "Parmelee",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 962,
    density: 2.4,
    county_fips: 46121,
    county_name: "Todd",
    county_weights: {
      46095: 9.3,
      46121: 90.7,
    },
    county_names_all: "Todd|Mellette",
    county_fips_all: "46121|46095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57567,
    lat: 44.13519,
    lng: -101.7152,
    city: "Philip",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1356,
    density: 0.5,
    county_fips: 46055,
    county_name: "Haakon",
    county_weights: {
      46055: 74.01,
      46071: 25.99,
    },
    county_names_all: "Haakon|Jackson",
    county_fips_all: "46055|46071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57568,
    lat: 43.88498,
    lng: -100.08857,
    city: "Presho",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 724,
    density: 0.7,
    county_fips: 46085,
    county_name: "Lyman",
    county_weights: {
      46085: 100,
    },
    county_names_all: "Lyman",
    county_fips_all: 46085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57569,
    lat: 43.8605,
    lng: -99.57582,
    city: "Reliance",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 226,
    density: 0.2,
    county_fips: 46085,
    county_name: "Lyman",
    county_weights: {
      46085: 100,
    },
    county_names_all: "Lyman",
    county_fips_all: 46085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57570,
    lat: 43.24284,
    lng: -100.87127,
    city: "Rosebud",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2376,
    density: 19.4,
    county_fips: 46121,
    county_name: "Todd",
    county_weights: {
      46121: 100,
    },
    county_names_all: "Todd",
    county_fips_all: 46121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57571,
    lat: 43.04152,
    lng: -99.09042,
    city: "Saint Charles",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 46053,
    county_name: "Gregory",
    county_weights: {
      46053: 100,
    },
    county_names_all: "Gregory",
    county_fips_all: 46053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57572,
    lat: 43.12009,
    lng: -101.08491,
    city: "Saint Francis",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1887,
    density: 3.3,
    county_fips: 46121,
    county_name: "Todd",
    county_weights: {
      46121: 100,
    },
    county_names_all: "Todd",
    county_fips_all: 46121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57574,
    lat: 43.10954,
    lng: -101.36238,
    city: "Tuthill",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 70,
    density: 0.1,
    county_fips: 46007,
    county_name: "Bennett",
    county_weights: {
      46007: 100,
    },
    county_names_all: "Bennett",
    county_fips_all: 46007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57576,
    lat: 43.90804,
    lng: -100.29411,
    city: "Vivian",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 181,
    density: 0.4,
    county_fips: 46085,
    county_name: "Lyman",
    county_weights: {
      46075: 8.67,
      46085: 91.33,
    },
    county_names_all: "Lyman|Jones",
    county_fips_all: "46085|46075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57577,
    lat: 43.52353,
    lng: -101.66029,
    city: "Wanblee",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1733,
    density: 3.1,
    county_fips: 46071,
    county_name: "Jackson",
    county_weights: {
      46007: 3.91,
      46071: 96.09,
    },
    county_names_all: "Jackson|Bennett",
    county_fips_all: "46071|46007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57579,
    lat: 43.57484,
    lng: -100.78578,
    city: "White River",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1406,
    density: 0.9,
    county_fips: 46095,
    county_name: "Mellette",
    county_weights: {
      46095: 100,
    },
    county_names_all: "Mellette",
    county_fips_all: 46095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57580,
    lat: 43.28987,
    lng: -100.05772,
    city: "Winner",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3984,
    density: 1.5,
    county_fips: 46123,
    county_name: "Tripp",
    county_weights: {
      46095: 3.25,
      46121: 17.09,
      46123: 79.66,
    },
    county_names_all: "Tripp|Todd|Mellette",
    county_fips_all: "46123|46121|46095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57584,
    lat: 43.49115,
    lng: -100.06382,
    city: "Witten",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36,
    density: 0.2,
    county_fips: 46123,
    county_name: "Tripp",
    county_weights: {
      46123: 100,
    },
    county_names_all: "Tripp",
    county_fips_all: 46123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57585,
    lat: 43.55508,
    lng: -100.39752,
    city: "Wood",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 103,
    density: 0.1,
    county_fips: 46095,
    county_name: "Mellette",
    county_weights: {
      46095: 100,
    },
    county_names_all: "Mellette",
    county_fips_all: 46095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57601,
    lat: 45.36646,
    lng: -100.51108,
    city: "Mobridge",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3974,
    density: 3.6,
    county_fips: 46041,
    county_name: "Dewey",
    county_weights: {
      46031: 9.4,
      46041: 84.06,
      46129: 6.54,
    },
    county_names_all: "Dewey|Corson|Walworth",
    county_fips_all: "46041|46031|46129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57620,
    lat: 45.38425,
    lng: -102.53897,
    city: "Bison",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 548,
    density: 0.6,
    county_fips: 46105,
    county_name: "Perkins",
    county_weights: {
      46105: 100,
    },
    county_names_all: "Perkins",
    county_fips_all: 46105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57621,
    lat: 45.76891,
    lng: -101.0808,
    city: "Bullhead",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 320,
    density: 40.3,
    county_fips: 46031,
    county_name: "Corson",
    county_weights: {
      46031: 100,
    },
    county_names_all: "Corson",
    county_fips_all: 46031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57622,
    lat: 44.65177,
    lng: -101.54572,
    city: "Cherry Creek",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 359,
    density: 1.5,
    county_fips: 46137,
    county_name: "Ziebach",
    county_weights: {
      46137: 100,
    },
    county_names_all: "Ziebach",
    county_fips_all: 46137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57623,
    lat: 45.01587,
    lng: -101.65925,
    city: "Dupree",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1126,
    density: 0.7,
    county_fips: 46137,
    county_name: "Ziebach",
    county_weights: {
      46137: 100,
    },
    county_names_all: "Ziebach",
    county_fips_all: 46137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57625,
    lat: 44.95738,
    lng: -101.00369,
    city: "Eagle Butte",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4336,
    density: 1.3,
    county_fips: 46041,
    county_name: "Dewey",
    county_weights: {
      46041: 78.65,
      46137: 21.35,
    },
    county_names_all: "Dewey|Ziebach",
    county_fips_all: "46041|46137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57626,
    lat: 44.99662,
    lng: -102.17571,
    city: "Faith",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 792,
    density: 0.2,
    county_fips: 46105,
    county_name: "Perkins",
    county_weights: {
      46093: 32.9,
      46105: 39.21,
      46137: 27.88,
    },
    county_names_all: "Perkins|Meade|Ziebach",
    county_fips_all: "46105|46093|46137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57630,
    lat: 45.36358,
    lng: -100.89192,
    city: "Glencross",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 46041,
    county_name: "Dewey",
    county_weights: {
      46041: 100,
    },
    county_names_all: "Dewey",
    county_fips_all: 46041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57631,
    lat: 45.58195,
    lng: -100.28779,
    city: "Glenham",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 444,
    density: 1.3,
    county_fips: 46129,
    county_name: "Walworth",
    county_weights: {
      46021: 49.41,
      46129: 50.59,
    },
    county_names_all: "Walworth|Campbell",
    county_fips_all: "46129|46021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57632,
    lat: 45.82924,
    lng: -100.04927,
    city: "Herreid",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 586,
    density: 1.1,
    county_fips: 46021,
    county_name: "Campbell",
    county_weights: {
      46021: 100,
    },
    county_names_all: "Campbell",
    county_fips_all: 46021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57633,
    lat: 45.44584,
    lng: -101.50046,
    city: "Isabel",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 417,
    density: 0.2,
    county_fips: 46031,
    county_name: "Corson",
    county_weights: {
      46031: 44.39,
      46041: 21.18,
      46137: 34.43,
    },
    county_names_all: "Corson|Ziebach|Dewey",
    county_fips_all: "46031|46137|46041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57634,
    lat: 45.75231,
    lng: -101.87895,
    city: "Keldron",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 202,
    density: 0.4,
    county_fips: 46031,
    county_name: "Corson",
    county_weights: {
      46031: 100,
    },
    county_names_all: "Corson",
    county_fips_all: 46031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57636,
    lat: 45.02905,
    lng: -101.45414,
    city: "Lantry",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 92,
    density: 1.7,
    county_fips: 46041,
    county_name: "Dewey",
    county_weights: {
      46041: 100,
    },
    county_names_all: "Dewey",
    county_fips_all: 46041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57638,
    lat: 45.86899,
    lng: -102.20758,
    city: "Lemmon",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1790,
    density: 0.7,
    county_fips: 46105,
    county_name: "Perkins",
    county_weights: {
      38001: 25.18,
      38037: 5.1,
      38085: 4.66,
      46031: 4.64,
      46105: 60.42,
    },
    county_names_all: "Perkins|Adams|Grant|Sioux|Corson",
    county_fips_all: "46105|38001|38037|38085|46031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57639,
    lat: 45.679,
    lng: -100.80324,
    city: "Little Eagle",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 372,
    density: 72.6,
    county_fips: 46031,
    county_name: "Corson",
    county_weights: {
      46031: 100,
    },
    county_names_all: "Corson",
    county_fips_all: 46031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57640,
    lat: 45.7656,
    lng: -102.70435,
    city: "Lodgepole",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 184,
    density: 0.3,
    county_fips: 46105,
    county_name: "Perkins",
    county_weights: {
      46105: 100,
    },
    county_names_all: "Perkins",
    county_fips_all: 46105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57641,
    lat: 45.89317,
    lng: -101.30624,
    city: "McIntosh",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 325,
    density: 0.3,
    county_fips: 46031,
    county_name: "Corson",
    county_weights: {
      38037: 9.75,
      38085: 27.78,
      46031: 62.47,
    },
    county_names_all: "Corson|Sioux|Grant",
    county_fips_all: "46031|38085|38037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57642,
    lat: 45.78609,
    lng: -100.72458,
    city: "McLaughlin",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1994,
    density: 1.1,
    county_fips: 46031,
    county_name: "Corson",
    county_weights: {
      38085: 2.83,
      46031: 97.17,
    },
    county_names_all: "Corson|Sioux",
    county_fips_all: "46031|38085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57644,
    lat: 45.45155,
    lng: -102.08224,
    city: "Meadow",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 292,
    density: 0.2,
    county_fips: 46105,
    county_name: "Perkins",
    county_weights: {
      46031: 20.75,
      46105: 63.3,
      46137: 15.95,
    },
    county_names_all: "Perkins|Corson|Ziebach",
    county_fips_all: "46105|46031|46137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57645,
    lat: 45.9119,
    lng: -101.71855,
    city: "Morristown",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 141,
    density: 0.2,
    county_fips: 46031,
    county_name: "Corson",
    county_weights: {
      38037: 26.84,
      38085: 21.3,
      46031: 51.86,
    },
    county_names_all: "Corson|Grant|Sioux",
    county_fips_all: "46031|38037|38085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57646,
    lat: 45.68753,
    lng: -100.05395,
    city: "Mound City",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 324,
    density: 1,
    county_fips: 46021,
    county_name: "Campbell",
    county_weights: {
      46021: 100,
    },
    county_names_all: "Campbell",
    county_fips_all: 46021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57648,
    lat: 45.92722,
    lng: -100.31755,
    city: "Pollock",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 312,
    density: 0.5,
    county_fips: 46021,
    county_name: "Campbell",
    county_weights: {
      38029: 47.39,
      46021: 52.61,
    },
    county_names_all: "Campbell|Emmons",
    county_fips_all: "46021|38029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 57649,
    lat: 45.48999,
    lng: -102.86149,
    city: "Prairie City",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 314,
    density: 0.2,
    county_fips: 46105,
    county_name: "Perkins",
    county_weights: {
      46063: 24.28,
      46105: 75.72,
    },
    county_names_all: "Perkins|Harding",
    county_fips_all: "46105|46063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57650,
    lat: 45.8346,
    lng: -103.03033,
    city: "Ralph",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50,
    density: 0.3,
    county_fips: 46063,
    county_name: "Harding",
    county_weights: {
      46063: 100,
    },
    county_names_all: "Harding",
    county_fips_all: 46063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57651,
    lat: 45.48394,
    lng: -103.07746,
    city: "Reva",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 122,
    density: 0.1,
    county_fips: 46063,
    county_name: "Harding",
    county_weights: {
      46063: 84.92,
      46105: 15.08,
    },
    county_names_all: "Harding|Perkins",
    county_fips_all: "46063|46105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57652,
    lat: 45.13787,
    lng: -100.68883,
    city: "Ridgeview",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 550,
    density: 0.9,
    county_fips: 46041,
    county_name: "Dewey",
    county_weights: {
      46041: 100,
    },
    county_names_all: "Dewey",
    county_fips_all: 46041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57656,
    lat: 45.42387,
    lng: -101.10696,
    city: "Timber Lake",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 881,
    density: 0.9,
    county_fips: 46041,
    county_name: "Dewey",
    county_weights: {
      46031: 36.71,
      46041: 63.29,
    },
    county_names_all: "Dewey|Corson",
    county_fips_all: "46041|46031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57657,
    lat: 45.51599,
    lng: -100.7776,
    city: "Trail City",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 195,
    density: 0.4,
    county_fips: 46031,
    county_name: "Corson",
    county_weights: {
      46031: 77.87,
      46041: 22.13,
    },
    county_names_all: "Corson|Dewey",
    county_fips_all: "46031|46041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57658,
    lat: 45.65744,
    lng: -100.55835,
    city: "Wakpala",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 409,
    density: 2.5,
    county_fips: 46031,
    county_name: "Corson",
    county_weights: {
      46031: 100,
    },
    county_names_all: "Corson",
    county_fips_all: 46031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57659,
    lat: 45.8958,
    lng: -101.09808,
    city: "Walker",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 46031,
    county_name: "Corson",
    county_weights: {
      46031: 100,
    },
    county_names_all: "Corson",
    county_fips_all: 46031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57660,
    lat: 45.83052,
    lng: -101.53311,
    city: "Watauga",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65,
    density: 0.1,
    county_fips: 46031,
    county_name: "Corson",
    county_weights: {
      38085: 12.02,
      46031: 87.98,
    },
    county_names_all: "Corson|Sioux",
    county_fips_all: "46031|38085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57661,
    lat: 45.27005,
    lng: -100.96433,
    city: "Whitehorse",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 127,
    density: 1.7,
    county_fips: 46041,
    county_name: "Dewey",
    county_weights: {
      46041: 100,
    },
    county_names_all: "Dewey",
    county_fips_all: 46041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57701,
    lat: 44.1209,
    lng: -103.20562,
    city: "Rapid City",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47155,
    density: 348.7,
    county_fips: 46103,
    county_name: "Pennington",
    county_weights: {
      46093: 35.74,
      46103: 64.26,
    },
    county_names_all: "Pennington|Meade",
    county_fips_all: "46103|46093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57702,
    lat: 44.03085,
    lng: -103.38433,
    city: "Rapid City",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34973,
    density: 47.2,
    county_fips: 46103,
    county_name: "Pennington",
    county_weights: {
      46093: 5.66,
      46103: 94.34,
    },
    county_names_all: "Pennington|Meade",
    county_fips_all: "46103|46093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57703,
    lat: 44.00331,
    lng: -103.04528,
    city: "Rapid City",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17748,
    density: 52.8,
    county_fips: 46103,
    county_name: "Pennington",
    county_weights: {
      46103: 100,
    },
    county_names_all: "Pennington",
    county_fips_all: 46103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57706,
    lat: 44.1564,
    lng: -103.09561,
    city: "Ellsworth Afb",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3244,
    density: 204.1,
    county_fips: 46093,
    county_name: "Meade",
    county_weights: {
      46093: 93.42,
      46103: 6.58,
    },
    county_names_all: "Meade|Pennington",
    county_fips_all: "46093|46103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57714,
    lat: 43.32689,
    lng: -101.91843,
    city: "Allen",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 793,
    density: 1.9,
    county_fips: 46007,
    county_name: "Bennett",
    county_weights: {
      46007: 92.96,
      46071: 7.04,
    },
    county_names_all: "Bennett|Jackson",
    county_fips_all: "46007|46071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57716,
    lat: 43.07753,
    lng: -102.2179,
    city: "Batesland",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 502,
    density: 1.1,
    county_fips: 46102,
    county_name: "Oglala Lakota",
    county_weights: {
      46007: 7.74,
      46102: 92.26,
    },
    county_names_all: "Oglala Lakota|Bennett",
    county_fips_all: "46102|46007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57717,
    lat: 44.96667,
    lng: -103.92396,
    city: "Belle Fourche",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8186,
    density: 2.3,
    county_fips: 46019,
    county_name: "Butte",
    county_weights: {
      30011: 10.15,
      46019: 65.6,
      46063: 8.64,
      46081: 0.56,
      56011: 15.05,
    },
    county_names_all: "Butte|Crook|Carter|Harding|Lawrence",
    county_fips_all: "46019|56011|30011|46063|46081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57718,
    lat: 44.17925,
    lng: -103.36801,
    city: "Black Hawk",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7637,
    density: 111,
    county_fips: 46093,
    county_name: "Meade",
    county_weights: {
      46093: 98.69,
      46103: 1.31,
    },
    county_names_all: "Meade|Pennington",
    county_fips_all: "46093|46103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57719,
    lat: 44.23059,
    lng: -102.98312,
    city: "Box Elder",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8156,
    density: 18.8,
    county_fips: 46093,
    county_name: "Meade",
    county_weights: {
      46093: 76.57,
      46103: 23.43,
    },
    county_names_all: "Meade|Pennington",
    county_fips_all: "46093|46103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57720,
    lat: 45.5497,
    lng: -103.60655,
    city: "Buffalo",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 576,
    density: 0.2,
    county_fips: 46063,
    county_name: "Harding",
    county_weights: {
      46063: 100,
    },
    county_names_all: "Harding",
    county_fips_all: 46063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57722,
    lat: 43.45722,
    lng: -102.98149,
    city: "Buffalo Gap",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 213,
    density: 0.2,
    county_fips: 46102,
    county_name: "Oglala Lakota",
    county_weights: {
      46033: 31.26,
      46047: 14.27,
      46102: 54.47,
    },
    county_names_all: "Oglala Lakota|Custer|Fall River",
    county_fips_all: "46102|46033|46047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57724,
    lat: 45.66696,
    lng: -104.06056,
    city: "Camp Crook",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 251,
    density: 0.3,
    county_fips: 46063,
    county_name: "Harding",
    county_weights: {
      30011: 37.28,
      46063: 62.72,
    },
    county_names_all: "Harding|Carter",
    county_fips_all: "46063|30011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57725,
    lat: 43.93723,
    lng: -102.80324,
    city: "Caputa",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 354,
    density: 1.2,
    county_fips: 46103,
    county_name: "Pennington",
    county_weights: {
      46103: 100,
    },
    county_names_all: "Pennington",
    county_fips_all: 46103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57730,
    lat: 43.72561,
    lng: -103.63733,
    city: "Custer",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5995,
    density: 4.5,
    county_fips: 46033,
    county_name: "Custer",
    county_weights: {
      46033: 91.64,
      46103: 8.36,
    },
    county_names_all: "Custer|Pennington",
    county_fips_all: "46033|46103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57732,
    lat: 44.23782,
    lng: -103.64335,
    city: "Deadwood",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2108,
    density: 6.5,
    county_fips: 46081,
    county_name: "Lawrence",
    county_weights: {
      46081: 89.79,
      46103: 10.21,
    },
    county_names_all: "Lawrence|Pennington",
    county_fips_all: "46081|46103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57735,
    lat: 43.29086,
    lng: -103.85626,
    city: "Edgemont",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1292,
    density: 0.6,
    county_fips: 46047,
    county_name: "Fall River",
    county_weights: {
      31165: 1.87,
      46033: 20.78,
      46047: 77.35,
    },
    county_names_all: "Fall River|Custer|Sioux",
    county_fips_all: "46047|46033|31165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57737,
    lat: 44.55618,
    lng: -102.52096,
    city: "Enning",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 46093,
    county_name: "Meade",
    county_weights: {
      46093: 100,
    },
    county_names_all: "Meade",
    county_fips_all: 46093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57738,
    lat: 43.66281,
    lng: -103.13024,
    city: "Fairburn",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 122,
    density: 0.3,
    county_fips: 46033,
    county_name: "Custer",
    county_weights: {
      46033: 100,
    },
    county_names_all: "Custer",
    county_fips_all: 46033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57741,
    lat: 44.41044,
    lng: -103.47273,
    city: "Fort Meade",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 154,
    density: 361.7,
    county_fips: 46093,
    county_name: "Meade",
    county_weights: {
      46093: 100,
    },
    county_names_all: "Meade",
    county_fips_all: 46093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57744,
    lat: 43.7773,
    lng: -103.02415,
    city: "Hermosa",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2222,
    density: 1.8,
    county_fips: 46033,
    county_name: "Custer",
    county_weights: {
      46033: 63.67,
      46102: 14.79,
      46103: 21.54,
    },
    county_names_all: "Custer|Pennington|Oglala Lakota",
    county_fips_all: "46033|46103|46102",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57745,
    lat: 44.01304,
    lng: -103.78616,
    city: "Hill City",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2111,
    density: 2.1,
    county_fips: 46103,
    county_name: "Pennington",
    county_weights: {
      46103: 100,
    },
    county_names_all: "Pennington",
    county_fips_all: 46103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57747,
    lat: 43.37973,
    lng: -103.5231,
    city: "Hot Springs",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5802,
    density: 4.4,
    county_fips: 46047,
    county_name: "Fall River",
    county_weights: {
      46033: 26.73,
      46047: 73.27,
    },
    county_names_all: "Fall River|Custer",
    county_fips_all: "46047|46033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57748,
    lat: 44.58484,
    lng: -102.01082,
    city: "Howes",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 292,
    density: 0.3,
    county_fips: 46093,
    county_name: "Meade",
    county_weights: {
      46093: 55.59,
      46137: 44.41,
    },
    county_names_all: "Meade|Ziebach",
    county_fips_all: "46093|46137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57750,
    lat: 43.60109,
    lng: -101.94858,
    city: "Interior",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 115,
    density: 0.1,
    county_fips: 46071,
    county_name: "Jackson",
    county_weights: {
      46071: 97.99,
      46103: 2.01,
    },
    county_names_all: "Jackson|Pennington",
    county_fips_all: "46071|46103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57751,
    lat: 43.86767,
    lng: -103.42346,
    city: "Keystone",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1169,
    density: 10.2,
    county_fips: 46103,
    county_name: "Pennington",
    county_weights: {
      46033: 33.26,
      46103: 66.74,
    },
    county_names_all: "Pennington|Custer",
    county_fips_all: "46103|46033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57752,
    lat: 43.43593,
    lng: -102.20738,
    city: "Kyle",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1723,
    density: 1.5,
    county_fips: 46102,
    county_name: "Oglala Lakota",
    county_weights: {
      46007: 3.29,
      46071: 13.98,
      46102: 82.73,
    },
    county_names_all: "Oglala Lakota|Jackson|Bennett",
    county_fips_all: "46102|46071|46007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57754,
    lat: 44.26193,
    lng: -103.87478,
    city: "Lead",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3736,
    density: 5.4,
    county_fips: 46081,
    county_name: "Lawrence",
    county_weights: {
      46081: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 46081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57755,
    lat: 45.83763,
    lng: -103.35784,
    city: "Ludlow",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 107,
    density: 0.2,
    county_fips: 46063,
    county_name: "Harding",
    county_weights: {
      46063: 100,
    },
    county_names_all: "Harding",
    county_fips_all: 46063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57756,
    lat: 43.23729,
    lng: -102.47544,
    city: "Manderson",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 721,
    density: 4.2,
    county_fips: 46102,
    county_name: "Oglala Lakota",
    county_weights: {
      46102: 100,
    },
    county_names_all: "Oglala Lakota",
    county_fips_all: 46102,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57758,
    lat: 44.98737,
    lng: -102.75985,
    city: "Mud Butte",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67,
    density: 0,
    county_fips: 46093,
    county_name: "Meade",
    county_weights: {
      46019: 18.88,
      46093: 63.28,
      46105: 17.84,
    },
    county_names_all: "Meade|Butte|Perkins",
    county_fips_all: "46093|46019|46105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57759,
    lat: 44.2202,
    lng: -103.55373,
    city: "Nemo",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 559,
    density: 4.1,
    county_fips: 46081,
    county_name: "Lawrence",
    county_weights: {
      46081: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 46081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57760,
    lat: 44.93063,
    lng: -103.30329,
    city: "Newell",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1142,
    density: 0.4,
    county_fips: 46019,
    county_name: "Butte",
    county_weights: {
      46019: 98.21,
      46063: 1.79,
    },
    county_names_all: "Butte|Harding",
    county_fips_all: "46019|46063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57761,
    lat: 44.21858,
    lng: -102.75943,
    city: "New Underwood",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1470,
    density: 1.3,
    county_fips: 46093,
    county_name: "Meade",
    county_weights: {
      46093: 66.89,
      46103: 33.11,
    },
    county_names_all: "Meade|Pennington",
    county_fips_all: "46093|46103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57762,
    lat: 44.75285,
    lng: -103.60902,
    city: "Nisland",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 445,
    density: 1.6,
    county_fips: 46019,
    county_name: "Butte",
    county_weights: {
      46019: 100,
    },
    county_names_all: "Butte",
    county_fips_all: 46019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57763,
    lat: 43.12,
    lng: -103.24944,
    city: "Oelrichs",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 323,
    density: 0.3,
    county_fips: 46047,
    county_name: "Fall River",
    county_weights: {
      46047: 100,
    },
    county_names_all: "Fall River",
    county_fips_all: 46047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57764,
    lat: 43.23676,
    lng: -102.75539,
    city: "Oglala",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2568,
    density: 3.6,
    county_fips: 46102,
    county_name: "Oglala Lakota",
    county_weights: {
      46102: 100,
    },
    county_names_all: "Oglala Lakota",
    county_fips_all: 46102,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57766,
    lat: 43.35772,
    lng: -103.18252,
    city: "Oral",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 140,
    density: 0.4,
    county_fips: 46047,
    county_name: "Fall River",
    county_weights: {
      46047: 100,
    },
    county_names_all: "Fall River",
    county_fips_all: 46047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57767,
    lat: 44.13841,
    lng: -102.5721,
    city: "Owanka",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 158,
    density: 0.4,
    county_fips: 46093,
    county_name: "Meade",
    county_weights: {
      46093: 50.68,
      46103: 49.32,
    },
    county_names_all: "Meade|Pennington",
    county_fips_all: "46093|46103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57769,
    lat: 44.24326,
    lng: -103.29704,
    city: "Piedmont",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3984,
    density: 11.3,
    county_fips: 46093,
    county_name: "Meade",
    county_weights: {
      46093: 100,
    },
    county_names_all: "Meade",
    county_fips_all: 46093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57770,
    lat: 43.07579,
    lng: -102.6258,
    city: "Pine Ridge",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6349,
    density: 12.6,
    county_fips: 46102,
    county_name: "Oglala Lakota",
    county_weights: {
      46102: 100,
    },
    county_names_all: "Oglala Lakota",
    county_fips_all: 46102,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57772,
    lat: 43.48182,
    lng: -102.51903,
    city: "Porcupine",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2060,
    density: 1.6,
    county_fips: 46102,
    county_name: "Oglala Lakota",
    county_weights: {
      46102: 100,
    },
    county_names_all: "Oglala Lakota",
    county_fips_all: 46102,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57773,
    lat: 43.59443,
    lng: -103.59246,
    city: "Pringle",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 254,
    density: 16.4,
    county_fips: 46033,
    county_name: "Custer",
    county_weights: {
      46033: 100,
    },
    county_names_all: "Custer",
    county_fips_all: 46033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57775,
    lat: 44.08368,
    lng: -102.00607,
    city: "Quinn",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 362,
    density: 0.5,
    county_fips: 46103,
    county_name: "Pennington",
    county_weights: {
      46055: 40.37,
      46071: 14.1,
      46103: 45.53,
    },
    county_names_all: "Pennington|Haakon|Jackson",
    county_fips_all: "46103|46055|46071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57776,
    lat: 45.24878,
    lng: -103.51704,
    city: "Redig",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 46063,
    county_name: "Harding",
    county_weights: {
      46063: 100,
    },
    county_names_all: "Harding",
    county_fips_all: 46063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57779,
    lat: 44.56449,
    lng: -103.75969,
    city: "Saint Onge",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 140,
    density: 1.3,
    county_fips: 46081,
    county_name: "Lawrence",
    county_weights: {
      46019: 3.68,
      46081: 96.32,
    },
    county_names_all: "Lawrence|Butte",
    county_fips_all: "46081|46019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57780,
    lat: 43.7773,
    lng: -102.45844,
    city: "Scenic",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36,
    density: 0,
    county_fips: 46103,
    county_name: "Pennington",
    county_weights: {
      46102: 8.89,
      46103: 91.11,
    },
    county_names_all: "Pennington|Oglala Lakota",
    county_fips_all: "46103|46102",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57782,
    lat: 43.25182,
    lng: -103.1844,
    city: "Smithwick",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42,
    density: 0.3,
    county_fips: 46047,
    county_name: "Fall River",
    county_weights: {
      46047: 100,
    },
    county_names_all: "Fall River",
    county_fips_all: 46047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57783,
    lat: 44.47106,
    lng: -103.9219,
    city: "Spearfish",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16001,
    density: 29,
    county_fips: 46081,
    county_name: "Lawrence",
    county_weights: {
      46019: 3.74,
      46081: 96.26,
    },
    county_names_all: "Lawrence|Butte",
    county_fips_all: "46081|46019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57785,
    lat: 44.41905,
    lng: -103.21534,
    city: "Sturgis",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9728,
    density: 6.6,
    county_fips: 46093,
    county_name: "Meade",
    county_weights: {
      46081: 5.91,
      46093: 94.09,
    },
    county_names_all: "Meade|Lawrence",
    county_fips_all: "46093|46081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57787,
    lat: 44.6643,
    lng: -102.66097,
    city: "Union Center",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 305,
    density: 0.2,
    county_fips: 46093,
    county_name: "Meade",
    county_weights: {
      46093: 100,
    },
    county_names_all: "Meade",
    county_fips_all: 46093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57788,
    lat: 44.61855,
    lng: -103.2167,
    city: "Vale",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 446,
    density: 0.7,
    county_fips: 46019,
    county_name: "Butte",
    county_weights: {
      46019: 59.14,
      46093: 40.86,
    },
    county_names_all: "Butte|Meade",
    county_fips_all: "46019|46093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57790,
    lat: 44.10378,
    lng: -102.20683,
    city: "Wall",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1122,
    density: 0.6,
    county_fips: 46103,
    county_name: "Pennington",
    county_weights: {
      46071: 1.94,
      46103: 98.06,
    },
    county_names_all: "Pennington|Jackson",
    county_fips_all: "46103|46071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57791,
    lat: 44.24388,
    lng: -102.46514,
    city: "Wasta",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 177,
    density: 0.2,
    county_fips: 46093,
    county_name: "Meade",
    county_weights: {
      46093: 70.73,
      46103: 29.27,
    },
    county_names_all: "Meade|Pennington",
    county_fips_all: "46093|46103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57792,
    lat: 44.59559,
    lng: -102.36376,
    city: "White Owl",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 127,
    density: 0.3,
    county_fips: 46093,
    county_name: "Meade",
    county_weights: {
      46093: 100,
    },
    county_names_all: "Meade",
    county_fips_all: 46093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57793,
    lat: 44.51824,
    lng: -103.581,
    city: "Whitewood",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2192,
    density: 5.6,
    county_fips: 46081,
    county_name: "Lawrence",
    county_weights: {
      46019: 7.21,
      46081: 54.19,
      46093: 38.6,
    },
    county_names_all: "Lawrence|Meade|Butte",
    county_fips_all: "46081|46093|46019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57794,
    lat: 43.12071,
    lng: -102.40695,
    city: "Wounded Knee",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 281,
    density: 2.1,
    county_fips: 46102,
    county_name: "Oglala Lakota",
    county_weights: {
      46102: 100,
    },
    county_names_all: "Oglala Lakota",
    county_fips_all: 46102,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 57799,
    lat: 44.49817,
    lng: -103.87256,
    city: "Spearfish",
    state_id: "SD",
    state_name: "South Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 680,
    density: 1395.4,
    county_fips: 46081,
    county_name: "Lawrence",
    county_weights: {
      46081: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 46081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58001,
    lat: 46.44837,
    lng: -96.74134,
    city: "Abercrombie",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 38077,
    county_name: "Richland",
    county_weights: {
      38077: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 38077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58002,
    lat: 46.97562,
    lng: -97.40785,
    city: "Absaraka",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5,
    density: 0.6,
    county_fips: 38017,
    county_name: "Cass",
    county_weights: {
      38017: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 38017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58004,
    lat: 47.02713,
    lng: -97.26212,
    city: "Amenia",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 298,
    density: 2.2,
    county_fips: 38017,
    county_name: "Cass",
    county_weights: {
      38017: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 38017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58005,
    lat: 47.05261,
    lng: -96.951,
    city: "Argusville",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1034,
    density: 3.9,
    county_fips: 38017,
    county_name: "Cass",
    county_weights: {
      38017: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 38017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58006,
    lat: 47.09682,
    lng: -97.20359,
    city: "Arthur",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 363,
    density: 2.8,
    county_fips: 38017,
    county_name: "Cass",
    county_weights: {
      38017: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 38017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58007,
    lat: 47.02519,
    lng: -97.45724,
    city: "Ayr",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 94,
    density: 0.7,
    county_fips: 38017,
    county_name: "Cass",
    county_weights: {
      38017: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 38017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58008,
    lat: 46.30816,
    lng: -97.00237,
    city: "Barney",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 172,
    density: 1.2,
    county_fips: 38077,
    county_name: "Richland",
    county_weights: {
      38077: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 38077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58009,
    lat: 47.32658,
    lng: -97.24435,
    city: "Blanchard",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35,
    density: 0.4,
    county_fips: 38097,
    county_name: "Traill",
    county_weights: {
      38097: 100,
    },
    county_names_all: "Traill",
    county_fips_all: 38097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58011,
    lat: 46.92711,
    lng: -97.54465,
    city: "Buffalo",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 527,
    density: 1.8,
    county_fips: 38017,
    county_name: "Cass",
    county_weights: {
      38017: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 38017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58012,
    lat: 46.93639,
    lng: -97.16113,
    city: "Casselton",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3021,
    density: 15.9,
    county_fips: 38017,
    county_name: "Cass",
    county_weights: {
      38017: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 38017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58013,
    lat: 46.06037,
    lng: -97.35877,
    city: "Cayuga",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 130,
    density: 0.7,
    county_fips: 38081,
    county_name: "Sargent",
    county_weights: {
      38081: 100,
    },
    county_names_all: "Sargent",
    county_fips_all: 38081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58015,
    lat: 46.59225,
    lng: -96.81544,
    city: "Christine",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 229,
    density: 4.2,
    county_fips: 38077,
    county_name: "Richland",
    county_weights: {
      38077: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 38077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58016,
    lat: 47.36609,
    lng: -97.46293,
    city: "Clifford",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 191,
    density: 1.1,
    county_fips: 38097,
    county_name: "Traill",
    county_weights: {
      38091: 45.4,
      38097: 54.6,
    },
    county_names_all: "Traill|Steele",
    county_fips_all: "38097|38091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58017,
    lat: 46.04157,
    lng: -97.84535,
    city: "Cogswell",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 284,
    density: 0.6,
    county_fips: 38081,
    county_name: "Sargent",
    county_weights: {
      38081: 100,
    },
    county_names_all: "Sargent",
    county_fips_all: 38081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58018,
    lat: 46.43458,
    lng: -96.8887,
    city: "Colfax",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 495,
    density: 2.6,
    county_fips: 38077,
    county_name: "Richland",
    county_weights: {
      38077: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 38077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58021,
    lat: 46.73837,
    lng: -97.08102,
    city: "Davenport",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 501,
    density: 3,
    county_fips: 38017,
    county_name: "Cass",
    county_weights: {
      38017: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 38017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58027,
    lat: 46.63217,
    lng: -97.61816,
    city: "Enderlin",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1375,
    density: 2.9,
    county_fips: 38073,
    county_name: "Ransom",
    county_weights: {
      38003: 13.99,
      38017: 41.51,
      38073: 44.5,
    },
    county_names_all: "Ransom|Cass|Barnes",
    county_fips_all: "38073|38017|38003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58029,
    lat: 47.11726,
    lng: -97.39001,
    city: "Erie",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47,
    density: 0.4,
    county_fips: 38017,
    county_name: "Cass",
    county_weights: {
      38017: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 38017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58030,
    lat: 46.03035,
    lng: -96.66818,
    city: "Fairmount",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 613,
    density: 1.8,
    county_fips: 38077,
    county_name: "Richland",
    county_weights: {
      27167: 1.33,
      38077: 98.67,
    },
    county_names_all: "Richland|Wilkin",
    county_fips_all: "38077|27167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58031,
    lat: 46.76222,
    lng: -97.6686,
    city: "Fingal",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 417,
    density: 1.1,
    county_fips: 38017,
    county_name: "Cass",
    county_weights: {
      38003: 46.21,
      38017: 53.79,
    },
    county_names_all: "Cass|Barnes",
    county_fips_all: "38017|38003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58032,
    lat: 46.07071,
    lng: -97.64413,
    city: "Forman",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 651,
    density: 2.3,
    county_fips: 38081,
    county_name: "Sargent",
    county_weights: {
      38081: 100,
    },
    county_names_all: "Sargent",
    county_fips_all: 38081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58033,
    lat: 46.44019,
    lng: -97.92628,
    city: "Fort Ransom",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 491,
    density: 1.3,
    county_fips: 38073,
    county_name: "Ransom",
    county_weights: {
      38073: 100,
    },
    county_names_all: "Ransom",
    county_fips_all: 38073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58035,
    lat: 47.25599,
    lng: -97.41589,
    city: "Galesburg",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 244,
    density: 1,
    county_fips: 38097,
    county_name: "Traill",
    county_weights: {
      38017: 33.66,
      38091: 24.01,
      38097: 42.33,
    },
    county_names_all: "Traill|Cass|Steele",
    county_fips_all: "38097|38017|38091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58036,
    lat: 47.15463,
    lng: -96.96318,
    city: "Gardner",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 221,
    density: 1,
    county_fips: 38017,
    county_name: "Cass",
    county_weights: {
      38017: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 38017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58038,
    lat: 47.24505,
    lng: -96.99484,
    city: "Grandin",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 251,
    density: 1.2,
    county_fips: 38097,
    county_name: "Traill",
    county_weights: {
      38017: 40.07,
      38097: 59.93,
    },
    county_names_all: "Traill|Cass",
    county_fips_all: "38097|38017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58040,
    lat: 46.21618,
    lng: -97.75204,
    city: "Gwinner",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1187,
    density: 6.1,
    county_fips: 38081,
    county_name: "Sargent",
    county_weights: {
      38081: 100,
    },
    county_names_all: "Sargent",
    county_fips_all: 38081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58041,
    lat: 46.04775,
    lng: -96.91006,
    city: "Hankinson",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1565,
    density: 3.1,
    county_fips: 38077,
    county_name: "Richland",
    county_weights: {
      38077: 99.24,
      46109: 0.76,
    },
    county_names_all: "Richland|Roberts",
    county_fips_all: "38077|46109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58042,
    lat: 46.96952,
    lng: -96.95719,
    city: "Harwood",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1334,
    density: 11.9,
    county_fips: 38017,
    county_name: "Cass",
    county_weights: {
      38017: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 38017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58043,
    lat: 45.97356,
    lng: -97.53205,
    city: "Havana",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 197,
    density: 1.3,
    county_fips: 38081,
    county_name: "Sargent",
    county_weights: {
      38081: 95.17,
      46091: 4.83,
    },
    county_names_all: "Sargent|Marshall",
    county_fips_all: "38081|46091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58045,
    lat: 47.38241,
    lng: -97.02686,
    city: "Hillsboro",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2003,
    density: 3.7,
    county_fips: 38097,
    county_name: "Traill",
    county_weights: {
      38097: 100,
    },
    county_names_all: "Traill",
    county_fips_all: 38097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58046,
    lat: 47.32203,
    lng: -97.72747,
    city: "Hope",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 527,
    density: 0.9,
    county_fips: 38091,
    county_name: "Steele",
    county_weights: {
      38003: 12.99,
      38017: 1.66,
      38091: 85.35,
    },
    county_names_all: "Steele|Barnes|Cass",
    county_fips_all: "38091|38003|38017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58047,
    lat: 46.7159,
    lng: -96.87946,
    city: "Horace",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4075,
    density: 22.4,
    county_fips: 38017,
    county_name: "Cass",
    county_weights: {
      38017: 97.37,
      38077: 2.63,
    },
    county_names_all: "Cass|Richland",
    county_fips_all: "38017|38077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58048,
    lat: 47.19882,
    lng: -97.22742,
    city: "Hunter",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 484,
    density: 1.7,
    county_fips: 38017,
    county_name: "Cass",
    county_weights: {
      38017: 76.12,
      38097: 23.88,
    },
    county_names_all: "Cass|Traill",
    county_fips_all: "38017|38097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58049,
    lat: 46.66291,
    lng: -98.00054,
    city: "Kathryn",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 304,
    density: 0.9,
    county_fips: 38003,
    county_name: "Barnes",
    county_weights: {
      38003: 69.78,
      38045: 7.54,
      38073: 22.68,
    },
    county_names_all: "Barnes|Ransom|LaMoure",
    county_fips_all: "38003|38073|38045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58051,
    lat: 46.63952,
    lng: -97.0302,
    city: "Kindred",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1781,
    density: 6.2,
    county_fips: 38017,
    county_name: "Cass",
    county_weights: {
      38017: 59.32,
      38077: 40.68,
    },
    county_names_all: "Cass|Richland",
    county_fips_all: "38017|38077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58052,
    lat: 46.63552,
    lng: -97.28011,
    city: "Leonard",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 602,
    density: 1.5,
    county_fips: 38017,
    county_name: "Cass",
    county_weights: {
      38017: 55.98,
      38073: 11.11,
      38077: 32.91,
    },
    county_names_all: "Cass|Richland|Ransom",
    county_fips_all: "38017|38077|38073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58053,
    lat: 46.05058,
    lng: -97.18007,
    city: "Lidgerwood",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1184,
    density: 2,
    county_fips: 38077,
    county_name: "Richland",
    county_weights: {
      38077: 71.39,
      38081: 20.86,
      46091: 1.95,
      46109: 5.8,
    },
    county_names_all: "Richland|Sargent|Roberts|Marshall",
    county_fips_all: "38077|38081|46109|46091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58054,
    lat: 46.42622,
    lng: -97.66845,
    city: "Lisbon",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2804,
    density: 3.8,
    county_fips: 38073,
    county_name: "Ransom",
    county_weights: {
      38073: 100,
    },
    county_names_all: "Ransom",
    county_fips_all: 38073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58056,
    lat: 47.23868,
    lng: -97.93621,
    city: "Luverne",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 129,
    density: 0.6,
    county_fips: 38003,
    county_name: "Barnes",
    county_weights: {
      38003: 43.57,
      38039: 13,
      38091: 43.43,
    },
    county_names_all: "Barnes|Steele|Griggs",
    county_fips_all: "38003|38091|38039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58057,
    lat: 46.42548,
    lng: -97.26747,
    city: "Mcleod",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 141,
    density: 0.6,
    county_fips: 38077,
    county_name: "Richland",
    county_weights: {
      38073: 41.43,
      38077: 58.57,
    },
    county_names_all: "Richland|Ransom",
    county_fips_all: "38077|38073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58058,
    lat: 46.1806,
    lng: -96.97159,
    city: "Mantador",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 118,
    density: 2,
    county_fips: 38077,
    county_name: "Richland",
    county_weights: {
      38077: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 38077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58059,
    lat: 46.83825,
    lng: -97.11812,
    city: "Mapleton",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1632,
    density: 5.6,
    county_fips: 38017,
    county_name: "Cass",
    county_weights: {
      38017: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 38017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58060,
    lat: 46.26745,
    lng: -97.43423,
    city: "Milnor",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1111,
    density: 1.8,
    county_fips: 38081,
    county_name: "Sargent",
    county_weights: {
      38073: 41.16,
      38077: 0.37,
      38081: 58.47,
    },
    county_names_all: "Sargent|Ransom|Richland",
    county_fips_all: "38081|38073|38077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58061,
    lat: 46.27721,
    lng: -96.89564,
    city: "Mooreton",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 276,
    density: 1.6,
    county_fips: 38077,
    county_name: "Richland",
    county_weights: {
      38077: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 38077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58062,
    lat: 46.64361,
    lng: -97.82937,
    city: "Nome",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 176,
    density: 1.4,
    county_fips: 38003,
    county_name: "Barnes",
    county_weights: {
      38003: 58.86,
      38073: 41.14,
    },
    county_names_all: "Barnes|Ransom",
    county_fips_all: "38003|38073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58063,
    lat: 46.96773,
    lng: -97.80471,
    city: "Oriska",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 458,
    density: 1.4,
    county_fips: 38003,
    county_name: "Barnes",
    county_weights: {
      38003: 100,
    },
    county_names_all: "Barnes",
    county_fips_all: 38003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58064,
    lat: 47.15036,
    lng: -97.62761,
    city: "Page",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 534,
    density: 1.2,
    county_fips: 38017,
    county_name: "Cass",
    county_weights: {
      38003: 23.88,
      38017: 74.42,
      38091: 1.7,
    },
    county_names_all: "Cass|Barnes|Steele",
    county_fips_all: "38017|38003|38091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58065,
    lat: 47.20035,
    lng: -97.76612,
    city: "Pillsbury",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33,
    density: 3,
    county_fips: 38003,
    county_name: "Barnes",
    county_weights: {
      38003: 100,
    },
    county_names_all: "Barnes",
    county_fips_all: 38003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58067,
    lat: 46.06826,
    lng: -97.48906,
    city: "Rutland",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 244,
    density: 1.6,
    county_fips: 38081,
    county_name: "Sargent",
    county_weights: {
      38081: 100,
    },
    county_names_all: "Sargent",
    county_fips_all: 38081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58068,
    lat: 46.54619,
    lng: -97.40896,
    city: "Sheldon",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 404,
    density: 1.5,
    county_fips: 38073,
    county_name: "Ransom",
    county_weights: {
      38017: 1.78,
      38073: 98.22,
    },
    county_names_all: "Ransom|Cass",
    county_fips_all: "38073|38017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58069,
    lat: 46.24102,
    lng: -97.83194,
    city: "Stirum",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 110,
    density: 0.6,
    county_fips: 38081,
    county_name: "Sargent",
    county_weights: {
      38073: 4.44,
      38081: 95.56,
    },
    county_names_all: "Sargent|Ransom",
    county_fips_all: "38081|38073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58071,
    lat: 46.9436,
    lng: -97.68278,
    city: "Tower City",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 410,
    density: 1.5,
    county_fips: 38017,
    county_name: "Cass",
    county_weights: {
      38003: 43.97,
      38017: 56.03,
    },
    county_names_all: "Cass|Barnes",
    county_fips_all: "38017|38003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58072,
    lat: 46.92731,
    lng: -98.00791,
    city: "Valley City",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7514,
    density: 8.9,
    county_fips: 38003,
    county_name: "Barnes",
    county_weights: {
      38003: 100,
    },
    county_names_all: "Barnes",
    county_fips_all: 38003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58074,
    lat: 46.21807,
    lng: -96.87603,
    city: "Wahpeton",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 38077,
    county_name: "Richland",
    county_weights: {
      38077: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 38077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58075,
    lat: 46.27426,
    lng: -96.72211,
    city: "Wahpeton",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9300,
    density: 15.3,
    county_fips: 38077,
    county_name: "Richland",
    county_weights: {
      38077: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 38077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58076,
    lat: 46.27416,
    lng: -96.60746,
    city: "Wahpeton",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 334,
    density: 1782,
    county_fips: 38077,
    county_name: "Richland",
    county_weights: {
      38077: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 38077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58077,
    lat: 46.52457,
    lng: -96.97593,
    city: "Walcott",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 804,
    density: 2.3,
    county_fips: 38077,
    county_name: "Richland",
    county_weights: {
      38077: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 38077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58078,
    lat: 46.86276,
    lng: -96.93125,
    city: "West Fargo",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36825,
    density: 357,
    county_fips: 38017,
    county_name: "Cass",
    county_weights: {
      38017: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 38017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58079,
    lat: 46.86816,
    lng: -97.34827,
    city: "Wheatland",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 414,
    density: 1.1,
    county_fips: 38017,
    county_name: "Cass",
    county_weights: {
      38017: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 38017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58081,
    lat: 46.31392,
    lng: -97.14378,
    city: "Wyndmere",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 835,
    density: 1.8,
    county_fips: 38077,
    county_name: "Richland",
    county_weights: {
      38077: 99.72,
      38081: 0.28,
    },
    county_names_all: "Richland|Sargent",
    county_fips_all: "38077|38081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58102,
    lat: 46.9207,
    lng: -96.83175,
    city: "Fargo",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30329,
    density: 370.1,
    county_fips: 38017,
    county_name: "Cass",
    county_weights: {
      38017: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 38017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58103,
    lat: 46.85639,
    lng: -96.82234,
    city: "Fargo",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49209,
    density: 1658.6,
    county_fips: 38017,
    county_name: "Cass",
    county_weights: {
      38017: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 38017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58104,
    lat: 46.79371,
    lng: -96.83838,
    city: "Fargo",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43925,
    density: 604.7,
    county_fips: 38017,
    county_name: "Cass",
    county_weights: {
      38017: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 38017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58105,
    lat: 46.89586,
    lng: -96.80363,
    city: "Fargo",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2242,
    density: 3644,
    county_fips: 38017,
    county_name: "Cass",
    county_weights: {
      38017: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 38017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58201,
    lat: 47.86938,
    lng: -97.14013,
    city: "Grand Forks",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41096,
    density: 229.8,
    county_fips: 38035,
    county_name: "Grand Forks",
    county_weights: {
      38035: 100,
    },
    county_names_all: "Grand Forks",
    county_fips_all: 38035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58202,
    lat: 47.92224,
    lng: -97.07435,
    city: "Grand Forks",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1598,
    density: 1427.5,
    county_fips: 38035,
    county_name: "Grand Forks",
    county_weights: {
      38035: 100,
    },
    county_names_all: "Grand Forks",
    county_fips_all: 38035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58203,
    lat: 47.97181,
    lng: -97.15425,
    city: "Grand Forks",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16010,
    density: 90,
    county_fips: 38035,
    county_name: "Grand Forks",
    county_weights: {
      38035: 100,
    },
    county_names_all: "Grand Forks",
    county_fips_all: 38035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58204,
    lat: 47.96046,
    lng: -97.37079,
    city: "Grand Forks Afb",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2383,
    density: 754.9,
    county_fips: 38035,
    county_name: "Grand Forks",
    county_weights: {
      38035: 100,
    },
    county_names_all: "Grand Forks",
    county_fips_all: 38035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58205,
    lat: 47.95475,
    lng: -97.39525,
    city: "Grand Forks Afb",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 38035,
    county_name: "Grand Forks",
    county_weights: {
      38035: 100,
    },
    county_names_all: "Grand Forks",
    county_fips_all: 38035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58210,
    lat: 48.4081,
    lng: -98.11446,
    city: "Adams",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 340,
    density: 0.8,
    county_fips: 38099,
    county_name: "Walsh",
    county_weights: {
      38099: 100,
    },
    county_names_all: "Walsh",
    county_fips_all: 38099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58212,
    lat: 47.6987,
    lng: -97.99541,
    city: "Aneta",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 382,
    density: 0.7,
    county_fips: 38063,
    county_name: "Nelson",
    county_weights: {
      38035: 12.32,
      38039: 34,
      38063: 47.33,
      38091: 6.35,
    },
    county_names_all: "Nelson|Griggs|Grand Forks|Steele",
    county_fips_all: "38063|38039|38035|38091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58214,
    lat: 47.92694,
    lng: -97.49747,
    city: "Arvilla",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 289,
    density: 1.4,
    county_fips: 38035,
    county_name: "Grand Forks",
    county_weights: {
      38035: 100,
    },
    county_names_all: "Grand Forks",
    county_fips_all: 38035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58216,
    lat: 48.87937,
    lng: -97.4429,
    city: "Bathgate",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 239,
    density: 1.3,
    county_fips: 38067,
    county_name: "Pembina",
    county_weights: {
      38067: 100,
    },
    county_names_all: "Pembina",
    county_fips_all: 38067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58218,
    lat: 47.59689,
    lng: -97.05412,
    city: "Buxton",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 810,
    density: 2.6,
    county_fips: 38097,
    county_name: "Traill",
    county_weights: {
      38097: 100,
    },
    county_names_all: "Traill",
    county_fips_all: 38097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58219,
    lat: 47.47606,
    lng: -96.87831,
    city: "Caledonia",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48,
    density: 3.2,
    county_fips: 38097,
    county_name: "Traill",
    county_weights: {
      38097: 100,
    },
    county_names_all: "Traill",
    county_fips_all: 38097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58220,
    lat: 48.79446,
    lng: -97.73789,
    city: "Cavalier",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2048,
    density: 4.5,
    county_fips: 38067,
    county_name: "Pembina",
    county_weights: {
      38019: 8.2,
      38067: 91.8,
    },
    county_names_all: "Pembina|Cavalier",
    county_fips_all: "38067|38019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58222,
    lat: 48.61853,
    lng: -97.68221,
    city: "Crystal",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 254,
    density: 1.4,
    county_fips: 38067,
    county_name: "Pembina",
    county_weights: {
      38067: 100,
    },
    county_names_all: "Pembina",
    county_fips_all: 38067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58223,
    lat: 47.51384,
    lng: -97.02573,
    city: "Cummings",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 118,
    density: 0.6,
    county_fips: 38097,
    county_name: "Traill",
    county_weights: {
      38097: 100,
    },
    county_names_all: "Traill",
    county_fips_all: 38097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58224,
    lat: 48.16777,
    lng: -97.94307,
    city: "Dahlen",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41,
    density: 1.1,
    county_fips: 38063,
    county_name: "Nelson",
    county_weights: {
      38063: 100,
    },
    county_names_all: "Nelson",
    county_fips_all: 38063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58225,
    lat: 48.61208,
    lng: -97.21753,
    city: "Drayton",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1009,
    density: 1.7,
    county_fips: 38067,
    county_name: "Pembina",
    county_weights: {
      27069: 11.38,
      38067: 65.71,
      38099: 22.91,
    },
    county_names_all: "Pembina|Walsh|Kittson",
    county_fips_all: "38067|38099|27069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58227,
    lat: 48.55247,
    lng: -97.90549,
    city: "Edinburg",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 515,
    density: 1.8,
    county_fips: 38099,
    county_name: "Walsh",
    county_weights: {
      38019: 11.23,
      38067: 39.53,
      38099: 49.25,
    },
    county_names_all: "Walsh|Pembina|Cavalier",
    county_fips_all: "38099|38067|38019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58228,
    lat: 47.87394,
    lng: -97.34278,
    city: "Emerado",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 839,
    density: 3,
    county_fips: 38035,
    county_name: "Grand Forks",
    county_weights: {
      38035: 100,
    },
    county_names_all: "Grand Forks",
    county_fips_all: 38035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58229,
    lat: 48.5182,
    lng: -98.25087,
    city: "Fairdale",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74,
    density: 0.3,
    county_fips: 38099,
    county_name: "Walsh",
    county_weights: {
      38019: 32.92,
      38071: 6.43,
      38099: 60.65,
    },
    county_names_all: "Walsh|Cavalier|Ramsey",
    county_fips_all: "38099|38019|38071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58230,
    lat: 47.49097,
    lng: -97.82622,
    city: "Finley",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 678,
    density: 1.5,
    county_fips: 38091,
    county_name: "Steele",
    county_weights: {
      38091: 100,
    },
    county_names_all: "Steele",
    county_fips_all: 38091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58231,
    lat: 48.20208,
    lng: -97.82544,
    city: "Fordville",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 328,
    density: 1.1,
    county_fips: 38099,
    county_name: "Walsh",
    county_weights: {
      38035: 40.18,
      38099: 59.82,
    },
    county_names_all: "Walsh|Grand Forks",
    county_fips_all: "38099|38035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58233,
    lat: 48.20253,
    lng: -97.54982,
    city: "Forest River",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 241,
    density: 0.9,
    county_fips: 38099,
    county_name: "Walsh",
    county_weights: {
      38035: 38.4,
      38099: 61.6,
    },
    county_names_all: "Walsh|Grand Forks",
    county_fips_all: "38099|38035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58235,
    lat: 48.09007,
    lng: -97.48307,
    city: "Gilby",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 519,
    density: 2.5,
    county_fips: 38035,
    county_name: "Grand Forks",
    county_weights: {
      38035: 100,
    },
    county_names_all: "Grand Forks",
    county_fips_all: 38035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58236,
    lat: 48.71848,
    lng: -97.50479,
    city: "Glasston",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 38067,
    county_name: "Pembina",
    county_weights: {
      38067: 100,
    },
    county_names_all: "Pembina",
    county_fips_all: 38067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58237,
    lat: 48.41522,
    lng: -97.40086,
    city: "Grafton",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5116,
    density: 7.9,
    county_fips: 38099,
    county_name: "Walsh",
    county_weights: {
      38099: 100,
    },
    county_names_all: "Walsh",
    county_fips_all: 38099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58238,
    lat: 48.77953,
    lng: -97.39791,
    city: "Hamilton",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 149,
    density: 0.7,
    county_fips: 38067,
    county_name: "Pembina",
    county_weights: {
      38067: 100,
    },
    county_names_all: "Pembina",
    county_fips_all: 38067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58239,
    lat: 48.93842,
    lng: -98.70877,
    city: "Hannah",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8,
    density: 0,
    county_fips: 38019,
    county_name: "Cavalier",
    county_weights: {
      38019: 100,
    },
    county_names_all: "Cavalier",
    county_fips_all: 38019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58240,
    lat: 47.63491,
    lng: -97.47675,
    city: "Hatton",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1316,
    density: 3.6,
    county_fips: 38091,
    county_name: "Steele",
    county_weights: {
      38035: 19.22,
      38091: 47.77,
      38097: 33.01,
    },
    county_names_all: "Steele|Traill|Grand Forks",
    county_fips_all: "38091|38097|38035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58241,
    lat: 48.70442,
    lng: -97.69772,
    city: "Hensel",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 137,
    density: 0.9,
    county_fips: 38067,
    county_name: "Pembina",
    county_weights: {
      38067: 100,
    },
    county_names_all: "Pembina",
    county_fips_all: 38067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58243,
    lat: 48.51423,
    lng: -97.67956,
    city: "Hoople",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 634,
    density: 2.9,
    county_fips: 38099,
    county_name: "Walsh",
    county_weights: {
      38067: 20.52,
      38099: 79.48,
    },
    county_names_all: "Walsh|Pembina",
    county_fips_all: "38099|38067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58244,
    lat: 48.11035,
    lng: -97.65752,
    city: "Inkster",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63,
    density: 1,
    county_fips: 38035,
    county_name: "Grand Forks",
    county_weights: {
      38035: 100,
    },
    county_names_all: "Grand Forks",
    county_fips_all: 38035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58249,
    lat: 48.82113,
    lng: -98.32514,
    city: "Langdon",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2459,
    density: 2.2,
    county_fips: 38019,
    county_name: "Cavalier",
    county_weights: {
      38019: 100,
    },
    county_names_all: "Cavalier",
    county_fips_all: 38019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58250,
    lat: 48.27496,
    lng: -98.02897,
    city: "Lankin",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 257,
    density: 1.1,
    county_fips: 38099,
    county_name: "Walsh",
    county_weights: {
      38099: 100,
    },
    county_names_all: "Walsh",
    county_fips_all: 38099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58251,
    lat: 47.94945,
    lng: -97.6906,
    city: "Larimore",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1955,
    density: 4.1,
    county_fips: 38035,
    county_name: "Grand Forks",
    county_weights: {
      38035: 100,
    },
    county_names_all: "Grand Forks",
    county_fips_all: 38035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58254,
    lat: 47.77111,
    lng: -98.14748,
    city: "Mcville",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 452,
    density: 1.6,
    county_fips: 38063,
    county_name: "Nelson",
    county_weights: {
      38063: 100,
    },
    county_names_all: "Nelson",
    county_fips_all: 38063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58255,
    lat: 48.99683,
    lng: -98.35392,
    city: "Maida",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 38019,
    county_name: "Cavalier",
    county_weights: {
      38019: 100,
    },
    county_names_all: "Cavalier",
    county_fips_all: 38019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Winnipeg",
  },
  {
    zip: 58256,
    lat: 48.08739,
    lng: -97.20203,
    city: "Manvel",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 721,
    density: 3.3,
    county_fips: 38035,
    county_name: "Grand Forks",
    county_weights: {
      38035: 100,
    },
    county_names_all: "Grand Forks",
    county_fips_all: 38035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58257,
    lat: 47.49033,
    lng: -97.28505,
    city: "Mayville",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2177,
    density: 6.8,
    county_fips: 38097,
    county_name: "Traill",
    county_weights: {
      38097: 100,
    },
    county_names_all: "Traill",
    county_fips_all: 38097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58258,
    lat: 48.01142,
    lng: -97.33984,
    city: "Mekinock",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 433,
    density: 5.6,
    county_fips: 38035,
    county_name: "Grand Forks",
    county_weights: {
      38035: 100,
    },
    county_names_all: "Grand Forks",
    county_fips_all: 38035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58259,
    lat: 48.02053,
    lng: -98.12168,
    city: "Michigan",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 427,
    density: 1,
    county_fips: 38063,
    county_name: "Nelson",
    county_weights: {
      38063: 100,
    },
    county_names_all: "Nelson",
    county_fips_all: 38063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58260,
    lat: 48.63254,
    lng: -98.04709,
    city: "Milton",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 164,
    density: 0.5,
    county_fips: 38019,
    county_name: "Cavalier",
    county_weights: {
      38019: 98.32,
      38099: 1.68,
    },
    county_names_all: "Cavalier|Walsh",
    county_fips_all: "38019|38099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58261,
    lat: 48.22385,
    lng: -97.31663,
    city: "Minto",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1353,
    density: 3.1,
    county_fips: 38099,
    county_name: "Walsh",
    county_weights: {
      38035: 36.06,
      38099: 63.94,
    },
    county_names_all: "Walsh|Grand Forks",
    county_fips_all: "38099|38035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58262,
    lat: 48.681,
    lng: -97.87759,
    city: "Mountain",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 97,
    density: 2.3,
    county_fips: 38067,
    county_name: "Pembina",
    county_weights: {
      38067: 100,
    },
    county_names_all: "Pembina",
    county_fips_all: 38067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58265,
    lat: 48.95321,
    lng: -97.5959,
    city: "Neche",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 479,
    density: 2.2,
    county_fips: 38067,
    county_name: "Pembina",
    county_weights: {
      38067: 100,
    },
    county_names_all: "Pembina",
    county_fips_all: 38067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58266,
    lat: 48.00127,
    lng: -97.84967,
    city: "Niagara",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 131,
    density: 0.4,
    county_fips: 38035,
    county_name: "Grand Forks",
    county_weights: {
      38035: 71.88,
      38063: 28.12,
    },
    county_names_all: "Grand Forks|Nelson",
    county_fips_all: "38035|38063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58267,
    lat: 47.75614,
    lng: -97.62651,
    city: "Northwood",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1325,
    density: 2.2,
    county_fips: 38035,
    county_name: "Grand Forks",
    county_weights: {
      38035: 96.31,
      38091: 3.69,
    },
    county_names_all: "Grand Forks|Steele",
    county_fips_all: "38035|38091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58269,
    lat: 48.70158,
    lng: -98.15518,
    city: "Osnabrock",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 239,
    density: 1.4,
    county_fips: 38019,
    county_name: "Cavalier",
    county_weights: {
      38019: 100,
    },
    county_names_all: "Cavalier",
    county_fips_all: 38019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58270,
    lat: 48.39336,
    lng: -97.78848,
    city: "Park River",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1836,
    density: 4.6,
    county_fips: 38099,
    county_name: "Walsh",
    county_weights: {
      38099: 100,
    },
    county_names_all: "Walsh",
    county_fips_all: 38099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58271,
    lat: 48.90905,
    lng: -97.28932,
    city: "Pembina",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 519,
    density: 2,
    county_fips: 38067,
    county_name: "Pembina",
    county_weights: {
      38067: 100,
    },
    county_names_all: "Pembina",
    county_fips_all: 38067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58272,
    lat: 48.00868,
    lng: -97.9854,
    city: "Petersburg",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 228,
    density: 0.7,
    county_fips: 38063,
    county_name: "Nelson",
    county_weights: {
      38063: 100,
    },
    county_names_all: "Nelson",
    county_fips_all: 38063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58273,
    lat: 48.29747,
    lng: -97.66275,
    city: "Pisek",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 146,
    density: 0.9,
    county_fips: 38099,
    county_name: "Walsh",
    county_weights: {
      38099: 100,
    },
    county_names_all: "Walsh",
    county_fips_all: 38099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58274,
    lat: 47.49158,
    lng: -97.48989,
    city: "Portland",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1025,
    density: 3,
    county_fips: 38091,
    county_name: "Steele",
    county_weights: {
      38091: 54.45,
      38097: 45.55,
    },
    county_names_all: "Steele|Traill",
    county_fips_all: "38091|38097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58275,
    lat: 47.68956,
    lng: -97.10609,
    city: "Reynolds",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 665,
    density: 2.2,
    county_fips: 38035,
    county_name: "Grand Forks",
    county_weights: {
      38035: 70.48,
      38097: 29.52,
    },
    county_names_all: "Grand Forks|Traill",
    county_fips_all: "38035|38097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58276,
    lat: 48.62239,
    lng: -97.45675,
    city: "Saint Thomas",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 504,
    density: 1.7,
    county_fips: 38067,
    county_name: "Pembina",
    county_weights: {
      38067: 100,
    },
    county_names_all: "Pembina",
    county_fips_all: 38067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58277,
    lat: 47.61403,
    lng: -97.83176,
    city: "Sharon",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 167,
    density: 0.8,
    county_fips: 38091,
    county_name: "Steele",
    county_weights: {
      38091: 100,
    },
    county_names_all: "Steele",
    county_fips_all: 38091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58278,
    lat: 47.77761,
    lng: -97.13084,
    city: "Thompson",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1928,
    density: 7.1,
    county_fips: 38035,
    county_name: "Grand Forks",
    county_weights: {
      38035: 100,
    },
    county_names_all: "Grand Forks",
    county_fips_all: 38035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58281,
    lat: 48.85941,
    lng: -98.61086,
    city: "Wales",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 88,
    density: 0.3,
    county_fips: 38019,
    county_name: "Cavalier",
    county_weights: {
      38019: 100,
    },
    county_names_all: "Cavalier",
    county_fips_all: 38019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58282,
    lat: 48.90897,
    lng: -97.93252,
    city: "Walhalla",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1295,
    density: 2.3,
    county_fips: 38067,
    county_name: "Pembina",
    county_weights: {
      38019: 44.19,
      38067: 55.81,
    },
    county_names_all: "Pembina|Cavalier",
    county_fips_all: "38067|38019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58301,
    lat: 48.13015,
    lng: -98.88798,
    city: "Devils Lake",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10221,
    density: 14.4,
    county_fips: 38071,
    county_name: "Ramsey",
    county_weights: {
      38005: 7.44,
      38071: 92.56,
    },
    county_names_all: "Ramsey|Benson",
    county_fips_all: "38071|38005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58310,
    lat: 48.57485,
    lng: -99.5307,
    city: "Agate",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 38079,
    county_name: "Rolette",
    county_weights: {
      38079: 93.05,
      38095: 6.95,
    },
    county_names_all: "Rolette|Towner",
    county_fips_all: "38079|38095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58311,
    lat: 48.65111,
    lng: -98.57312,
    city: "Alsen",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60,
    density: 0.2,
    county_fips: 38019,
    county_name: "Cavalier",
    county_weights: {
      38019: 100,
    },
    county_names_all: "Cavalier",
    county_fips_all: 38019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58313,
    lat: 48.16615,
    lng: -100.03685,
    city: "Balta",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 38069,
    county_name: "Pierce",
    county_weights: {
      38069: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 38069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58316,
    lat: 48.83532,
    lng: -99.78207,
    city: "Belcourt",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6922,
    density: 26.6,
    county_fips: 38079,
    county_name: "Rolette",
    county_weights: {
      38079: 100,
    },
    county_names_all: "Rolette",
    county_fips_all: 38079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58317,
    lat: 48.62576,
    lng: -99.38679,
    city: "Bisbee",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 149,
    density: 0.4,
    county_fips: 38095,
    county_name: "Towner",
    county_weights: {
      38079: 4.79,
      38095: 95.21,
    },
    county_names_all: "Towner|Rolette",
    county_fips_all: "38095|38079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58318,
    lat: 48.85121,
    lng: -100.40303,
    city: "Bottineau",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3865,
    density: 5,
    county_fips: 38009,
    county_name: "Bottineau",
    county_weights: {
      38009: 100,
    },
    county_names_all: "Bottineau",
    county_fips_all: 38009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58321,
    lat: 48.2025,
    lng: -98.32707,
    city: "Brocket",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45,
    density: 0.1,
    county_fips: 38071,
    county_name: "Ramsey",
    county_weights: {
      38063: 37.9,
      38071: 45.6,
      38099: 16.49,
    },
    county_names_all: "Ramsey|Nelson|Walsh",
    county_fips_all: "38071|38063|38099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58323,
    lat: 48.84252,
    lng: -98.91923,
    city: "Calvin",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 91,
    density: 0.5,
    county_fips: 38019,
    county_name: "Cavalier",
    county_weights: {
      38019: 81.58,
      38095: 18.42,
    },
    county_names_all: "Cavalier|Towner",
    county_fips_all: "38019|38095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58324,
    lat: 48.48213,
    lng: -99.21931,
    city: "Cando",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1409,
    density: 2.2,
    county_fips: 38095,
    county_name: "Towner",
    county_weights: {
      38005: 0.9,
      38095: 99.1,
    },
    county_names_all: "Towner|Benson",
    county_fips_all: "38095|38005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58325,
    lat: 48.28613,
    lng: -99.15569,
    city: "Churchs Ferry",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 92,
    density: 0.4,
    county_fips: 38071,
    county_name: "Ramsey",
    county_weights: {
      38005: 29.72,
      38071: 70.28,
    },
    county_names_all: "Ramsey|Benson",
    county_fips_all: "38071|38005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58327,
    lat: 48.10137,
    lng: -98.5731,
    city: "Crary",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 319,
    density: 0.7,
    county_fips: 38071,
    county_name: "Ramsey",
    county_weights: {
      38071: 100,
    },
    county_names_all: "Ramsey",
    county_fips_all: 38071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58329,
    lat: 48.8682,
    lng: -100.08927,
    city: "Dunseith",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3211,
    density: 6.1,
    county_fips: 38079,
    county_name: "Rolette",
    county_weights: {
      38009: 13.62,
      38079: 86.38,
    },
    county_names_all: "Rolette|Bottineau",
    county_fips_all: "38079|38009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58330,
    lat: 48.44208,
    lng: -98.48275,
    city: "Edmore",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 435,
    density: 0.9,
    county_fips: 38071,
    county_name: "Ramsey",
    county_weights: {
      38019: 2.33,
      38071: 97.67,
    },
    county_names_all: "Ramsey|Cavalier",
    county_fips_all: "38071|38019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58331,
    lat: 48.64014,
    lng: -99.09293,
    city: "Egeland",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 118,
    density: 0.4,
    county_fips: 38095,
    county_name: "Towner",
    county_weights: {
      38095: 100,
    },
    county_names_all: "Towner",
    county_fips_all: 38095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58332,
    lat: 48.04596,
    lng: -99.76725,
    city: "Esmond",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 299,
    density: 0.5,
    county_fips: 38005,
    county_name: "Benson",
    county_weights: {
      38005: 76.91,
      38069: 23.09,
    },
    county_names_all: "Benson|Pierce",
    county_fips_all: "38005|38069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58335,
    lat: 47.97229,
    lng: -99.00412,
    city: "Fort Totten",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1818,
    density: 25,
    county_fips: 38005,
    county_name: "Benson",
    county_weights: {
      38005: 100,
    },
    county_names_all: "Benson",
    county_fips_all: 38005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58338,
    lat: 48.52879,
    lng: -98.6313,
    city: "Hampden",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 92,
    density: 0.4,
    county_fips: 38071,
    county_name: "Ramsey",
    county_weights: {
      38019: 45.98,
      38071: 54.02,
    },
    county_names_all: "Ramsey|Cavalier",
    county_fips_all: "38071|38019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58339,
    lat: 48.97175,
    lng: -99.32709,
    city: "Hansboro",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 38095,
    county_name: "Towner",
    county_weights: {
      38095: 100,
    },
    county_names_all: "Towner",
    county_fips_all: 38095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58341,
    lat: 47.77117,
    lng: -99.85599,
    city: "Harvey",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2525,
    density: 2.2,
    county_fips: 38103,
    county_name: "Wells",
    county_weights: {
      38005: 2.73,
      38069: 20.88,
      38083: 2.65,
      38103: 73.74,
    },
    county_names_all: "Wells|Pierce|Benson|Sheridan",
    county_fips_all: "38103|38069|38005|38083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58343,
    lat: 48.29643,
    lng: -99.72583,
    city: "Knox",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33,
    density: 0.2,
    county_fips: 38005,
    county_name: "Benson",
    county_weights: {
      38005: 100,
    },
    county_names_all: "Benson",
    county_fips_all: 38005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58344,
    lat: 48.01471,
    lng: -98.33857,
    city: "Lakota",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 991,
    density: 1.8,
    county_fips: 38063,
    county_name: "Nelson",
    county_weights: {
      38063: 93.35,
      38071: 6.65,
    },
    county_names_all: "Nelson|Ramsey",
    county_fips_all: "38063|38071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58345,
    lat: 48.30564,
    lng: -98.37436,
    city: "Lawton",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 135,
    density: 0.4,
    county_fips: 38071,
    county_name: "Ramsey",
    county_weights: {
      38071: 64.86,
      38099: 35.14,
    },
    county_names_all: "Ramsey|Walsh",
    county_fips_all: "38071|38099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58346,
    lat: 48.28953,
    lng: -99.42218,
    city: "Leeds",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 570,
    density: 1.1,
    county_fips: 38005,
    county_name: "Benson",
    county_weights: {
      38005: 86.07,
      38069: 1.49,
      38095: 12.44,
    },
    county_names_all: "Benson|Towner|Pierce",
    county_fips_all: "38005|38095|38069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58348,
    lat: 47.95509,
    lng: -99.52365,
    city: "Maddock",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 904,
    density: 1.4,
    county_fips: 38005,
    county_name: "Benson",
    county_weights: {
      38005: 89.49,
      38103: 10.51,
    },
    county_names_all: "Benson|Wells",
    county_fips_all: "38005|38103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58351,
    lat: 48.10218,
    lng: -99.31394,
    city: "Minnewaukan",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 359,
    density: 0.8,
    county_fips: 38005,
    county_name: "Benson",
    county_weights: {
      38005: 100,
    },
    county_names_all: "Benson",
    county_fips_all: 38005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58352,
    lat: 48.70188,
    lng: -98.86099,
    city: "Munich",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 446,
    density: 0.8,
    county_fips: 38019,
    county_name: "Cavalier",
    county_weights: {
      38019: 88.24,
      38095: 11.76,
    },
    county_names_all: "Cavalier|Towner",
    county_fips_all: "38019|38095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58353,
    lat: 48.64005,
    lng: -99.59928,
    city: "Mylo",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 138,
    density: 0.8,
    county_fips: 38079,
    county_name: "Rolette",
    county_weights: {
      38079: 100,
    },
    county_names_all: "Rolette",
    county_fips_all: 38079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58355,
    lat: 48.57504,
    lng: -98.38528,
    city: "Nekoma",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 66,
    density: 1,
    county_fips: 38019,
    county_name: "Cavalier",
    county_weights: {
      38019: 100,
    },
    county_names_all: "Cavalier",
    county_fips_all: 38019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58356,
    lat: 47.67103,
    lng: -99.07804,
    city: "New Rockford",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1674,
    density: 2.3,
    county_fips: 38027,
    county_name: "Eddy",
    county_weights: {
      38027: 81.29,
      38031: 5.99,
      38103: 12.72,
    },
    county_names_all: "Eddy|Wells|Foster",
    county_fips_all: "38027|38103|38031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58357,
    lat: 47.94429,
    lng: -99.21831,
    city: "Oberon",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 365,
    density: 1.1,
    county_fips: 38005,
    county_name: "Benson",
    county_weights: {
      38005: 100,
    },
    county_names_all: "Benson",
    county_fips_all: 38005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58361,
    lat: 47.75841,
    lng: -98.35458,
    city: "Pekin",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 246,
    density: 0.7,
    county_fips: 38063,
    county_name: "Nelson",
    county_weights: {
      38063: 100,
    },
    county_names_all: "Nelson",
    county_fips_all: 38063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58362,
    lat: 48.23099,
    lng: -99.0554,
    city: "Penn",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 38071,
    county_name: "Ramsey",
    county_weights: {
      38071: 100,
    },
    county_names_all: "Ramsey",
    county_fips_all: 38071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58363,
    lat: 48.76417,
    lng: -99.46669,
    city: "Perth",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 122,
    density: 0.7,
    county_fips: 38095,
    county_name: "Towner",
    county_weights: {
      38079: 18.81,
      38095: 81.19,
    },
    county_names_all: "Towner|Rolette",
    county_fips_all: "38095|38079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58365,
    lat: 48.83655,
    lng: -99.23626,
    city: "Rocklake",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 218,
    density: 0.4,
    county_fips: 38095,
    county_name: "Towner",
    county_weights: {
      38095: 100,
    },
    county_names_all: "Towner",
    county_fips_all: 38095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58366,
    lat: 48.65242,
    lng: -99.86654,
    city: "Rolette",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1202,
    density: 1.7,
    county_fips: 38079,
    county_name: "Rolette",
    county_weights: {
      38069: 6.54,
      38079: 93.46,
    },
    county_names_all: "Rolette|Pierce",
    county_fips_all: "38079|38069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58367,
    lat: 48.88179,
    lng: -99.55163,
    city: "Rolla",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1707,
    density: 3.4,
    county_fips: 38079,
    county_name: "Rolette",
    county_weights: {
      38079: 62.63,
      38095: 37.37,
    },
    county_names_all: "Rolette|Towner",
    county_fips_all: "38079|38095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58368,
    lat: 48.25124,
    lng: -100.04105,
    city: "Rugby",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3427,
    density: 2.1,
    county_fips: 38069,
    county_name: "Pierce",
    county_weights: {
      38005: 5.12,
      38049: 6.82,
      38069: 88.06,
    },
    county_names_all: "Pierce|McHenry|Benson",
    county_fips_all: "38069|38049|38005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58369,
    lat: 48.95257,
    lng: -99.83603,
    city: "Saint John",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1308,
    density: 6,
    county_fips: 38079,
    county_name: "Rolette",
    county_weights: {
      38079: 100,
    },
    county_names_all: "Rolette",
    county_fips_all: 38079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58370,
    lat: 47.9842,
    lng: -98.85977,
    city: "Saint Michael",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1429,
    density: 10.5,
    county_fips: 38005,
    county_name: "Benson",
    county_weights: {
      38005: 100,
    },
    county_names_all: "Benson",
    county_fips_all: 38005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58372,
    lat: 48.93906,
    lng: -99.00628,
    city: "Sarles",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 133,
    density: 0.4,
    county_fips: 38095,
    county_name: "Towner",
    county_weights: {
      38019: 43.11,
      38095: 56.89,
    },
    county_names_all: "Towner|Cavalier",
    county_fips_all: "38095|38019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58374,
    lat: 47.82865,
    lng: -99.09171,
    city: "Sheyenne",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 631,
    density: 1,
    county_fips: 38027,
    county_name: "Eddy",
    county_weights: {
      38005: 35.6,
      38027: 52.39,
      38103: 12.01,
    },
    county_names_all: "Eddy|Benson|Wells",
    county_fips_all: "38027|38005|38103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58377,
    lat: 48.46481,
    lng: -98.87416,
    city: "Starkweather",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 301,
    density: 0.6,
    county_fips: 38071,
    county_name: "Ramsey",
    county_weights: {
      38019: 14.51,
      38071: 68.02,
      38095: 17.47,
    },
    county_names_all: "Ramsey|Towner|Cavalier",
    county_fips_all: "38071|38095|38019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58379,
    lat: 47.90707,
    lng: -98.81907,
    city: "Tokio",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 360,
    density: 20.5,
    county_fips: 38005,
    county_name: "Benson",
    county_weights: {
      38005: 100,
    },
    county_names_all: "Benson",
    county_fips_all: 38005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58380,
    lat: 47.82872,
    lng: -98.52029,
    city: "Tolna",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 344,
    density: 0.9,
    county_fips: 38063,
    county_name: "Nelson",
    county_weights: {
      38005: 13.94,
      38027: 34.6,
      38063: 51.46,
    },
    county_names_all: "Nelson|Eddy|Benson",
    county_fips_all: "38063|38027|38005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58381,
    lat: 47.82731,
    lng: -98.74476,
    city: "Warwick",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 371,
    density: 0.8,
    county_fips: 38027,
    county_name: "Eddy",
    county_weights: {
      38005: 39.56,
      38027: 60.44,
    },
    county_names_all: "Eddy|Benson",
    county_fips_all: "38027|38005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58382,
    lat: 48.31727,
    lng: -98.79252,
    city: "Webster",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 121,
    density: 0.4,
    county_fips: 38071,
    county_name: "Ramsey",
    county_weights: {
      38071: 100,
    },
    county_names_all: "Ramsey",
    county_fips_all: 38071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58384,
    lat: 48.59401,
    lng: -100.26465,
    city: "Willow City",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 386,
    density: 0.4,
    county_fips: 38009,
    county_name: "Bottineau",
    county_weights: {
      38009: 42.77,
      38049: 22.36,
      38069: 20.75,
      38079: 14.11,
    },
    county_names_all: "Bottineau|McHenry|Pierce|Rolette",
    county_fips_all: "38009|38049|38069|38079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58385,
    lat: 48.47945,
    lng: -99.65989,
    city: "Wolford",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 232,
    density: 0.8,
    county_fips: 38069,
    county_name: "Pierce",
    county_weights: {
      38069: 95.58,
      38079: 4.42,
    },
    county_names_all: "Pierce|Rolette",
    county_fips_all: "38069|38079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58386,
    lat: 48.31696,
    lng: -99.59227,
    city: "York",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 113,
    density: 0.4,
    county_fips: 38005,
    county_name: "Benson",
    county_weights: {
      38005: 67.33,
      38069: 32.67,
    },
    county_names_all: "Benson|Pierce",
    county_fips_all: "38005|38069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58401,
    lat: 46.88145,
    lng: -98.76883,
    city: "Jamestown",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16957,
    density: 15.3,
    county_fips: 38093,
    county_name: "Stutsman",
    county_weights: {
      38093: 100,
    },
    county_names_all: "Stutsman",
    county_fips_all: 38093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58402,
    lat: 46.88191,
    lng: -98.68755,
    city: "Jamestown",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 260,
    density: 2443.3,
    county_fips: 38093,
    county_name: "Stutsman",
    county_weights: {
      38093: 100,
    },
    county_names_all: "Stutsman",
    county_fips_all: 38093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58405,
    lat: 46.91454,
    lng: -98.69673,
    city: "Jamestown",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 440,
    density: 1028.5,
    county_fips: 38093,
    county_name: "Stutsman",
    county_weights: {
      38093: 100,
    },
    county_names_all: "Stutsman",
    county_fips_all: 38093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58413,
    lat: 46.02963,
    lng: -99.34235,
    city: "Ashley",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 987,
    density: 0.8,
    county_fips: 38051,
    county_name: "McIntosh",
    county_weights: {
      38021: 8.35,
      38051: 85.08,
      46089: 6.57,
    },
    county_names_all: "McIntosh|Dickey|McPherson",
    county_fips_all: "38051|38021|46089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58415,
    lat: 46.36602,
    lng: -98.48587,
    city: "Berlin",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 215,
    density: 1.4,
    county_fips: 38045,
    county_name: "LaMoure",
    county_weights: {
      38045: 100,
    },
    county_names_all: "LaMoure",
    county_fips_all: 38045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58416,
    lat: 47.54767,
    lng: -98.35694,
    city: "Binford",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 325,
    density: 0.6,
    county_fips: 38039,
    county_name: "Griggs",
    county_weights: {
      38039: 100,
    },
    county_names_all: "Griggs",
    county_fips_all: 38039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58418,
    lat: 47.41493,
    lng: -99.63524,
    city: "Bowdon",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 355,
    density: 0.6,
    county_fips: 38103,
    county_name: "Wells",
    county_weights: {
      38043: 17.73,
      38103: 82.27,
    },
    county_names_all: "Wells|Kidder",
    county_fips_all: "38103|38043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58420,
    lat: 47.06072,
    lng: -98.86734,
    city: "Buchanan",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 254,
    density: 0.7,
    county_fips: 38093,
    county_name: "Stutsman",
    county_weights: {
      38093: 100,
    },
    county_names_all: "Stutsman",
    county_fips_all: 38093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58421,
    lat: 47.43974,
    lng: -99.06968,
    city: "Carrington",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2746,
    density: 2.6,
    county_fips: 38031,
    county_name: "Foster",
    county_weights: {
      38027: 3.39,
      38031: 82.9,
      38093: 8.08,
      38103: 5.63,
    },
    county_names_all: "Foster|Stutsman|Wells|Eddy",
    county_fips_all: "38031|38093|38103|38027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58422,
    lat: 47.59853,
    lng: -99.39531,
    city: "Cathay",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 114,
    density: 0.3,
    county_fips: 38103,
    county_name: "Wells",
    county_weights: {
      38103: 100,
    },
    county_names_all: "Wells",
    county_fips_all: 38103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58423,
    lat: 47.41899,
    lng: -99.82951,
    city: "Chaseley",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52,
    density: 0.2,
    county_fips: 38103,
    county_name: "Wells",
    county_weights: {
      38043: 26.45,
      38103: 73.55,
    },
    county_names_all: "Wells|Kidder",
    county_fips_all: "38103|38043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58424,
    lat: 46.87554,
    lng: -99.10217,
    city: "Cleveland",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 314,
    density: 0.7,
    county_fips: 38093,
    county_name: "Stutsman",
    county_weights: {
      38093: 100,
    },
    county_names_all: "Stutsman",
    county_fips_all: 38093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58425,
    lat: 47.45391,
    lng: -98.12378,
    city: "Cooperstown",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1448,
    density: 2.7,
    county_fips: 38039,
    county_name: "Griggs",
    county_weights: {
      38039: 98.65,
      38091: 1.35,
    },
    county_names_all: "Griggs|Steele",
    county_fips_all: "38039|38091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58426,
    lat: 47.21972,
    lng: -98.58075,
    city: "Courtenay",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 311,
    density: 0.9,
    county_fips: 38093,
    county_name: "Stutsman",
    county_weights: {
      38031: 4.48,
      38093: 95.52,
    },
    county_names_all: "Stutsman|Foster",
    county_fips_all: "38093|38031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58428,
    lat: 46.81162,
    lng: -99.75809,
    city: "Dawson",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 197,
    density: 0.5,
    county_fips: 38043,
    county_name: "Kidder",
    county_weights: {
      38043: 100,
    },
    county_names_all: "Kidder",
    county_fips_all: 38043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58429,
    lat: 47.18768,
    lng: -98.16282,
    city: "Dazey",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 355,
    density: 1.1,
    county_fips: 38003,
    county_name: "Barnes",
    county_weights: {
      38003: 97.71,
      38039: 2.29,
    },
    county_names_all: "Barnes|Griggs",
    county_fips_all: "38003|38039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58430,
    lat: 47.50831,
    lng: -100.25954,
    city: "Denhoff",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 141,
    density: 0.6,
    county_fips: 38083,
    county_name: "Sheridan",
    county_weights: {
      38083: 100,
    },
    county_names_all: "Sheridan",
    county_fips_all: 38083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58431,
    lat: 46.50522,
    lng: -98.49658,
    city: "Dickey",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 113,
    density: 0.6,
    county_fips: 38045,
    county_name: "LaMoure",
    county_weights: {
      38045: 100,
    },
    county_names_all: "LaMoure",
    county_fips_all: 38045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58433,
    lat: 46.36989,
    lng: -98.72157,
    city: "Edgeley",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1181,
    density: 1.4,
    county_fips: 38045,
    county_name: "LaMoure",
    county_weights: {
      38021: 19.73,
      38045: 80.27,
    },
    county_names_all: "LaMoure|Dickey",
    county_fips_all: "38045|38021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58436,
    lat: 46.08203,
    lng: -98.58773,
    city: "Ellendale",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1581,
    density: 1.9,
    county_fips: 38021,
    county_name: "Dickey",
    county_weights: {
      38021: 95.42,
      46013: 4.58,
    },
    county_names_all: "Dickey|Brown",
    county_fips_all: "38021|46013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58438,
    lat: 47.66247,
    lng: -99.57983,
    city: "Fessenden",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 831,
    density: 2,
    county_fips: 38103,
    county_name: "Wells",
    county_weights: {
      38103: 100,
    },
    county_names_all: "Wells",
    county_fips_all: 38103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58439,
    lat: 45.96738,
    lng: -98.82994,
    city: "Forbes",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 114,
    density: 0.2,
    county_fips: 38021,
    county_name: "Dickey",
    county_weights: {
      38021: 62.89,
      46013: 2.26,
      46089: 34.85,
    },
    county_names_all: "Dickey|McPherson|Brown",
    county_fips_all: "38021|46089|46013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58440,
    lat: 46.27941,
    lng: -99.16324,
    city: "Fredonia",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 93,
    density: 0.2,
    county_fips: 38047,
    county_name: "Logan",
    county_weights: {
      38047: 53.73,
      38051: 46.27,
    },
    county_names_all: "Logan|McIntosh",
    county_fips_all: "38047|38051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58441,
    lat: 46.17119,
    lng: -98.37844,
    city: "Fullerton",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 448,
    density: 1.1,
    county_fips: 38021,
    county_name: "Dickey",
    county_weights: {
      38021: 100,
    },
    county_names_all: "Dickey",
    county_fips_all: 38021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58442,
    lat: 46.56518,
    lng: -99.18184,
    city: "Gackle",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 388,
    density: 0.7,
    county_fips: 38047,
    county_name: "Logan",
    county_weights: {
      38047: 79.45,
      38093: 20.55,
    },
    county_names_all: "Logan|Stutsman",
    county_fips_all: "38047|38093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58443,
    lat: 47.46374,
    lng: -98.67239,
    city: "Glenfield",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 161,
    density: 0.6,
    county_fips: 38031,
    county_name: "Foster",
    county_weights: {
      38031: 100,
    },
    county_names_all: "Foster",
    county_fips_all: 38031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58444,
    lat: 47.48278,
    lng: -100.13156,
    city: "Goodrich",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 127,
    density: 0.3,
    county_fips: 38083,
    county_name: "Sheridan",
    county_weights: {
      38083: 100,
    },
    county_names_all: "Sheridan",
    county_fips_all: 38083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58445,
    lat: 47.57036,
    lng: -98.78869,
    city: "Grace City",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 224,
    density: 1.2,
    county_fips: 38031,
    county_name: "Foster",
    county_weights: {
      38027: 34.56,
      38031: 65.44,
    },
    county_names_all: "Foster|Eddy",
    county_fips_all: "38031|38027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58448,
    lat: 47.30944,
    lng: -98.21451,
    city: "Hannaford",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 296,
    density: 0.8,
    county_fips: 38039,
    county_name: "Griggs",
    county_weights: {
      38003: 0.6,
      38039: 99.4,
    },
    county_names_all: "Griggs|Barnes",
    county_fips_all: "38039|38003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58451,
    lat: 47.45167,
    lng: -99.95275,
    city: "Hurdsfield",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 91,
    density: 0.3,
    county_fips: 38103,
    county_name: "Wells",
    county_weights: {
      38103: 100,
    },
    county_names_all: "Wells",
    county_fips_all: 38103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58452,
    lat: 47.54019,
    lng: -98.22911,
    city: "Jessie",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37,
    density: 30.1,
    county_fips: 38039,
    county_name: "Griggs",
    county_weights: {
      38039: 100,
    },
    county_names_all: "Griggs",
    county_fips_all: 38039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58454,
    lat: 46.5978,
    lng: -98.94038,
    city: "Jud",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 349,
    density: 0.6,
    county_fips: 38045,
    county_name: "LaMoure",
    county_weights: {
      38045: 63.84,
      38093: 36.16,
    },
    county_names_all: "LaMoure|Stutsman",
    county_fips_all: "38045|38093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58455,
    lat: 47.30094,
    lng: -98.72667,
    city: "Kensal",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 429,
    density: 1.1,
    county_fips: 38093,
    county_name: "Stutsman",
    county_weights: {
      38031: 40.72,
      38093: 59.28,
    },
    county_names_all: "Stutsman|Foster",
    county_fips_all: "38093|38031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58456,
    lat: 46.25674,
    lng: -98.95475,
    city: "Kulm",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 583,
    density: 1,
    county_fips: 38021,
    county_name: "Dickey",
    county_weights: {
      38021: 44.06,
      38045: 37.06,
      38051: 18.89,
    },
    county_names_all: "Dickey|LaMoure|McIntosh",
    county_fips_all: "38021|38045|38051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58458,
    lat: 46.36921,
    lng: -98.29257,
    city: "Lamoure",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1203,
    density: 2.5,
    county_fips: 38045,
    county_name: "LaMoure",
    county_weights: {
      38021: 6.3,
      38045: 93.7,
    },
    county_names_all: "LaMoure|Dickey",
    county_fips_all: "38045|38021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58460,
    lat: 46.30991,
    lng: -99.31907,
    city: "Lehr",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 193,
    density: 0.4,
    county_fips: 38047,
    county_name: "Logan",
    county_weights: {
      38047: 59.55,
      38051: 40.45,
    },
    county_names_all: "Logan|McIntosh",
    county_fips_all: "38047|38051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58461,
    lat: 46.64958,
    lng: -98.19248,
    city: "Litchville",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 390,
    density: 0.7,
    county_fips: 38003,
    county_name: "Barnes",
    county_weights: {
      38003: 55.75,
      38045: 44.25,
    },
    county_names_all: "Barnes|LaMoure",
    county_fips_all: "38003|38045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58463,
    lat: 47.49662,
    lng: -100.46281,
    city: "Mcclusky",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 586,
    density: 0.6,
    county_fips: 38083,
    county_name: "Sheridan",
    county_weights: {
      38083: 100,
    },
    county_names_all: "Sheridan",
    county_fips_all: 38083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58464,
    lat: 47.60786,
    lng: -98.58849,
    city: "Mchenry",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 199,
    density: 0.5,
    county_fips: 38027,
    county_name: "Eddy",
    county_weights: {
      38027: 54.97,
      38031: 35.35,
      38039: 9.68,
    },
    county_names_all: "Eddy|Foster|Griggs",
    county_fips_all: "38027|38031|38039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58466,
    lat: 46.61489,
    lng: -98.36493,
    city: "Marion",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 515,
    density: 1.2,
    county_fips: 38045,
    county_name: "LaMoure",
    county_weights: {
      38003: 35.93,
      38045: 61.63,
      38093: 2.44,
    },
    county_names_all: "LaMoure|Barnes|Stutsman",
    county_fips_all: "38045|38003|38093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58467,
    lat: 46.8746,
    lng: -99.34103,
    city: "Medina",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 752,
    density: 1.3,
    county_fips: 38093,
    county_name: "Stutsman",
    county_weights: {
      38043: 16.07,
      38093: 83.93,
    },
    county_names_all: "Stutsman|Kidder",
    county_fips_all: "38093|38043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58472,
    lat: 46.64135,
    lng: -98.66055,
    city: "Montpelier",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 465,
    density: 1.1,
    county_fips: 38093,
    county_name: "Stutsman",
    county_weights: {
      38045: 36.71,
      38093: 63.29,
    },
    county_names_all: "Stutsman|LaMoure",
    county_fips_all: "38093|38045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58474,
    lat: 46.09588,
    lng: -98.13574,
    city: "Oakes",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2652,
    density: 2.6,
    county_fips: 38021,
    county_name: "Dickey",
    county_weights: {
      38021: 86.67,
      38045: 0.73,
      38081: 12.6,
    },
    county_names_all: "Dickey|Sargent|LaMoure",
    county_fips_all: "38021|38081|38045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58475,
    lat: 47.14118,
    lng: -99.53717,
    city: "Pettibone",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 150,
    density: 0.4,
    county_fips: 38043,
    county_name: "Kidder",
    county_weights: {
      38043: 79.24,
      38093: 20.76,
    },
    county_names_all: "Kidder|Stutsman",
    county_fips_all: "38043|38093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58476,
    lat: 47.19398,
    lng: -99.00263,
    city: "Pingree",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 342,
    density: 0.6,
    county_fips: 38093,
    county_name: "Stutsman",
    county_weights: {
      38093: 100,
    },
    county_names_all: "Stutsman",
    county_fips_all: 38093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58477,
    lat: 47.2208,
    lng: -100.52294,
    city: "Regan",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 143,
    density: 0.5,
    county_fips: 38015,
    county_name: "Burleigh",
    county_weights: {
      38015: 100,
    },
    county_names_all: "Burleigh",
    county_fips_all: 38015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58478,
    lat: 47.16008,
    lng: -99.74543,
    city: "Robinson",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 121,
    density: 0.3,
    county_fips: 38043,
    county_name: "Kidder",
    county_weights: {
      38043: 100,
    },
    county_names_all: "Kidder",
    county_fips_all: 38043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58479,
    lat: 47.09254,
    lng: -98.19948,
    city: "Rogers",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 174,
    density: 0.9,
    county_fips: 38003,
    county_name: "Barnes",
    county_weights: {
      38003: 100,
    },
    county_names_all: "Barnes",
    county_fips_all: 38003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58480,
    lat: 46.94707,
    lng: -98.25685,
    city: "Sanborn",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 249,
    density: 0.8,
    county_fips: 38003,
    county_name: "Barnes",
    county_weights: {
      38003: 100,
    },
    county_names_all: "Barnes",
    county_fips_all: 38003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58481,
    lat: 46.9346,
    lng: -98.42814,
    city: "Spiritwood",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 219,
    density: 0.6,
    county_fips: 38003,
    county_name: "Barnes",
    county_weights: {
      38003: 65.22,
      38093: 34.78,
    },
    county_names_all: "Barnes|Stutsman",
    county_fips_all: "38003|38093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58482,
    lat: 46.86669,
    lng: -99.90465,
    city: "Steele",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1070,
    density: 2,
    county_fips: 38043,
    county_name: "Kidder",
    county_weights: {
      38043: 100,
    },
    county_names_all: "Kidder",
    county_fips_all: 38043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58483,
    lat: 46.66176,
    lng: -99.42186,
    city: "Streeter",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 294,
    density: 0.7,
    county_fips: 38093,
    county_name: "Stutsman",
    county_weights: {
      38043: 30.71,
      38047: 28.22,
      38093: 41.07,
    },
    county_names_all: "Stutsman|Kidder|Logan",
    county_fips_all: "38093|38043|38047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58484,
    lat: 47.37821,
    lng: -98.4687,
    city: "Sutton",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62,
    density: 0.4,
    county_fips: 38039,
    county_name: "Griggs",
    county_weights: {
      38031: 26.7,
      38039: 73.3,
    },
    county_names_all: "Griggs|Foster",
    county_fips_all: "38039|38031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58486,
    lat: 47.39421,
    lng: -99.39279,
    city: "Sykeston",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 226,
    density: 0.6,
    county_fips: 38103,
    county_name: "Wells",
    county_weights: {
      38093: 20.12,
      38103: 79.88,
    },
    county_names_all: "Wells|Stutsman",
    county_fips_all: "38103|38093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58487,
    lat: 46.85278,
    lng: -99.60283,
    city: "Tappen",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 518,
    density: 0.9,
    county_fips: 38043,
    county_name: "Kidder",
    county_weights: {
      38043: 100,
    },
    county_names_all: "Kidder",
    county_fips_all: 38043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58488,
    lat: 47.17552,
    lng: -99.99709,
    city: "Tuttle",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 134,
    density: 0.2,
    county_fips: 38043,
    county_name: "Kidder",
    county_weights: {
      38043: 100,
    },
    county_names_all: "Kidder",
    county_fips_all: 38043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58490,
    lat: 46.38137,
    lng: -98.06063,
    city: "Verona",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 216,
    density: 0.7,
    county_fips: 38045,
    county_name: "LaMoure",
    county_weights: {
      38045: 70.46,
      38073: 29.54,
    },
    county_names_all: "LaMoure|Ransom",
    county_fips_all: "38045|38073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58492,
    lat: 47.15793,
    lng: -98.43787,
    city: "Wimbledon",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 424,
    density: 1.2,
    county_fips: 38003,
    county_name: "Barnes",
    county_weights: {
      38003: 54.65,
      38039: 16.39,
      38093: 28.96,
    },
    county_names_all: "Barnes|Stutsman|Griggs",
    county_fips_all: "38003|38093|38039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58494,
    lat: 47.16306,
    lng: -100.2744,
    city: "Wing",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 412,
    density: 0.5,
    county_fips: 38015,
    county_name: "Burleigh",
    county_weights: {
      38015: 100,
    },
    county_names_all: "Burleigh",
    county_fips_all: 38015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58495,
    lat: 46.27202,
    lng: -99.60077,
    city: "Wishek",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1256,
    density: 1.3,
    county_fips: 38051,
    county_name: "McIntosh",
    county_weights: {
      38047: 39.65,
      38051: 60.35,
    },
    county_names_all: "McIntosh|Logan",
    county_fips_all: "38051|38047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58496,
    lat: 47.14063,
    lng: -99.30794,
    city: "Woodworth",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 132,
    density: 0.2,
    county_fips: 38093,
    county_name: "Stutsman",
    county_weights: {
      38093: 100,
    },
    county_names_all: "Stutsman",
    county_fips_all: 38093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58497,
    lat: 46.76738,
    lng: -98.54076,
    city: "Ypsilanti",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 102,
    density: 0.4,
    county_fips: 38093,
    county_name: "Stutsman",
    county_weights: {
      38003: 7.9,
      38093: 92.1,
    },
    county_names_all: "Stutsman|Barnes",
    county_fips_all: "38093|38003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58501,
    lat: 46.8189,
    lng: -100.70234,
    city: "Bismarck",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29419,
    density: 498.1,
    county_fips: 38015,
    county_name: "Burleigh",
    county_weights: {
      38015: 100,
    },
    county_names_all: "Burleigh",
    county_fips_all: 38015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58503,
    lat: 46.90587,
    lng: -100.75262,
    city: "Bismarck",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34970,
    density: 99.6,
    county_fips: 38015,
    county_name: "Burleigh",
    county_weights: {
      38015: 100,
    },
    county_names_all: "Burleigh",
    county_fips_all: 38015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58504,
    lat: 46.7273,
    lng: -100.6808,
    city: "Bismarck",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27607,
    density: 103.2,
    county_fips: 38015,
    county_name: "Burleigh",
    county_weights: {
      38015: 100,
    },
    county_names_all: "Burleigh",
    county_fips_all: 38015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58505,
    lat: 46.82035,
    lng: -100.78106,
    city: "Bismarck",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 38015,
    county_name: "Burleigh",
    county_weights: {
      38015: 100,
    },
    county_names_all: "Burleigh",
    county_fips_all: 38015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58520,
    lat: 46.6758,
    lng: -101.5409,
    city: "Almont",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 223,
    density: 0.4,
    county_fips: 38059,
    county_name: "Morton",
    county_weights: {
      38037: 31.15,
      38059: 68.85,
    },
    county_names_all: "Morton|Grant",
    county_fips_all: "38059|38037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/North_Dakota/New_Salem",
  },
  {
    zip: 58521,
    lat: 47.0269,
    lng: -100.66963,
    city: "Baldwin",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 599,
    density: 1.4,
    county_fips: 38015,
    county_name: "Burleigh",
    county_weights: {
      38015: 100,
    },
    county_names_all: "Burleigh",
    county_fips_all: 38015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58523,
    lat: 47.26581,
    lng: -101.78138,
    city: "Beulah",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3607,
    density: 5.6,
    county_fips: 38057,
    county_name: "Mercer",
    county_weights: {
      38057: 72.5,
      38065: 27.5,
    },
    county_names_all: "Mercer|Oliver",
    county_fips_all: "38057|38065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/North_Dakota/Beulah",
  },
  {
    zip: 58524,
    lat: 46.61297,
    lng: -100.07506,
    city: "Braddock",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68,
    density: 0.2,
    county_fips: 38029,
    county_name: "Emmons",
    county_weights: {
      38015: 18.36,
      38029: 56.65,
      38043: 24.99,
    },
    county_names_all: "Emmons|Kidder|Burleigh",
    county_fips_all: "38029|38043|38015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58528,
    lat: 46.34174,
    lng: -100.62751,
    city: "Cannon Ball",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 779,
    density: 5.1,
    county_fips: 38085,
    county_name: "Sioux",
    county_weights: {
      38085: 100,
    },
    county_names_all: "Sioux",
    county_fips_all: 38085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58529,
    lat: 46.30116,
    lng: -101.56952,
    city: "Carson",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 622,
    density: 0.6,
    county_fips: 38037,
    county_name: "Grant",
    county_weights: {
      38037: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 38037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58530,
    lat: 47.13357,
    lng: -101.15257,
    city: "Center",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1153,
    density: 1.3,
    county_fips: 38065,
    county_name: "Oliver",
    county_weights: {
      38057: 0.36,
      38065: 99.64,
    },
    county_names_all: "Oliver|Mercer",
    county_fips_all: "38065|38057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/North_Dakota/Center",
  },
  {
    zip: 58531,
    lat: 47.58387,
    lng: -101.20289,
    city: "Coleharbor",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 416,
    density: 1.4,
    county_fips: 38055,
    county_name: "McLean",
    county_weights: {
      38055: 100,
    },
    county_names_all: "McLean",
    county_fips_all: 38055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58532,
    lat: 46.84571,
    lng: -100.10631,
    city: "Driscoll",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 278,
    density: 0.5,
    county_fips: 38015,
    county_name: "Burleigh",
    county_weights: {
      38015: 61.44,
      38043: 38.56,
    },
    county_names_all: "Burleigh|Kidder",
    county_fips_all: "38015|38043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58533,
    lat: 46.39433,
    lng: -101.79598,
    city: "Elgin",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 994,
    density: 1.1,
    county_fips: 38037,
    county_name: "Grant",
    county_weights: {
      38037: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 38037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58535,
    lat: 46.48724,
    lng: -101.24558,
    city: "Flasher",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 434,
    density: 0.5,
    county_fips: 38059,
    county_name: "Morton",
    county_weights: {
      38037: 37.26,
      38059: 62.74,
    },
    county_names_all: "Morton|Grant",
    county_fips_all: "38059|38037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/North_Dakota/New_Salem",
  },
  {
    zip: 58538,
    lat: 46.08833,
    lng: -100.66983,
    city: "Fort Yates",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2548,
    density: 6.1,
    county_fips: 38085,
    county_name: "Sioux",
    county_weights: {
      38085: 100,
    },
    county_names_all: "Sioux",
    county_fips_all: 38085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58540,
    lat: 47.62427,
    lng: -101.72538,
    city: "Garrison",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3065,
    density: 3.3,
    county_fips: 38055,
    county_name: "McLean",
    county_weights: {
      38055: 100,
    },
    county_names_all: "McLean",
    county_fips_all: 38055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58541,
    lat: 47.33929,
    lng: -102.05177,
    city: "Golden Valley",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 632,
    density: 1.1,
    county_fips: 38057,
    county_name: "Mercer",
    county_weights: {
      38057: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 38057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/North_Dakota/Beulah",
  },
  {
    zip: 58542,
    lat: 46.04976,
    lng: -100.00269,
    city: "Hague",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 278,
    density: 0.6,
    county_fips: 38029,
    county_name: "Emmons",
    county_weights: {
      38029: 100,
    },
    county_names_all: "Emmons",
    county_fips_all: 38029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58544,
    lat: 46.49833,
    lng: -100.37062,
    city: "Hazelton",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 544,
    density: 0.7,
    county_fips: 38029,
    county_name: "Emmons",
    county_weights: {
      38029: 100,
    },
    county_names_all: "Emmons",
    county_fips_all: 38029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58545,
    lat: 47.34916,
    lng: -101.58921,
    city: "Hazen",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3327,
    density: 4.1,
    county_fips: 38057,
    county_name: "Mercer",
    county_weights: {
      38057: 77.68,
      38065: 22.32,
    },
    county_names_all: "Mercer|Oliver",
    county_fips_all: "38057|38065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/North_Dakota/Beulah",
  },
  {
    zip: 58549,
    lat: 46.46853,
    lng: -99.93305,
    city: "Kintyre",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 278,
    density: 0.6,
    county_fips: 38029,
    county_name: "Emmons",
    county_weights: {
      38029: 56.87,
      38043: 3.04,
      38047: 40.09,
    },
    county_names_all: "Emmons|Logan|Kidder",
    county_fips_all: "38029|38047|38043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58552,
    lat: 46.26042,
    lng: -100.29955,
    city: "Linton",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1538,
    density: 1.2,
    county_fips: 38029,
    county_name: "Emmons",
    county_weights: {
      38029: 100,
    },
    county_names_all: "Emmons",
    county_fips_all: 38029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58554,
    lat: 46.75148,
    lng: -100.95036,
    city: "Mandan",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26551,
    density: 17.9,
    county_fips: 38059,
    county_name: "Morton",
    county_weights: {
      38059: 94.46,
      38065: 5.54,
    },
    county_names_all: "Morton|Oliver",
    county_fips_all: "38059|38065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/North_Dakota/New_Salem",
  },
  {
    zip: 58558,
    lat: 46.82106,
    lng: -100.52127,
    city: "Menoken",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1202,
    density: 3.4,
    county_fips: 38015,
    county_name: "Burleigh",
    county_weights: {
      38015: 100,
    },
    county_names_all: "Burleigh",
    county_fips_all: 38015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58559,
    lat: 47.4849,
    lng: -100.71295,
    city: "Mercer",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 208,
    density: 0.5,
    county_fips: 38055,
    county_name: "McLean",
    county_weights: {
      38055: 73.38,
      38083: 26.62,
    },
    county_names_all: "McLean|Sheridan",
    county_fips_all: "38055|38083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58560,
    lat: 46.65182,
    lng: -100.32407,
    city: "Moffit",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 195,
    density: 0.6,
    county_fips: 38015,
    county_name: "Burleigh",
    county_weights: {
      38015: 64.17,
      38029: 35.83,
    },
    county_names_all: "Burleigh|Emmons",
    county_fips_all: "38015|38029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58561,
    lat: 46.49706,
    lng: -99.68118,
    city: "Napoleon",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 972,
    density: 1.1,
    county_fips: 38047,
    county_name: "Logan",
    county_weights: {
      38047: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 38047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58562,
    lat: 46.36354,
    lng: -102.01095,
    city: "New Leipzig",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 403,
    density: 0.5,
    county_fips: 38037,
    county_name: "Grant",
    county_weights: {
      38001: 8.38,
      38037: 62.96,
      38041: 28.66,
    },
    county_names_all: "Grant|Hettinger|Adams",
    county_fips_all: "38037|38041|38001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58563,
    lat: 46.90178,
    lng: -101.43257,
    city: "New Salem",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2261,
    density: 1.5,
    county_fips: 38059,
    county_name: "Morton",
    county_weights: {
      38037: 1.69,
      38059: 68.13,
      38065: 30.18,
    },
    county_names_all: "Morton|Oliver|Grant",
    county_fips_all: "38059|38065|38037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/North_Dakota/New_Salem",
  },
  {
    zip: 58564,
    lat: 46.26252,
    lng: -101.35,
    city: "Raleigh",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69,
    density: 0.3,
    county_fips: 38037,
    county_name: "Grant",
    county_weights: {
      38037: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 38037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58565,
    lat: 47.49639,
    lng: -101.37148,
    city: "Riverdale",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 192,
    density: 46.2,
    county_fips: 38055,
    county_name: "McLean",
    county_weights: {
      38055: 100,
    },
    county_names_all: "McLean",
    county_fips_all: 38055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58566,
    lat: 46.57835,
    lng: -100.90673,
    city: "Saint Anthony",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 144,
    density: 0.5,
    county_fips: 38059,
    county_name: "Morton",
    county_weights: {
      38059: 100,
    },
    county_names_all: "Morton",
    county_fips_all: 38059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/North_Dakota/New_Salem",
  },
  {
    zip: 58568,
    lat: 46.09274,
    lng: -101.01538,
    city: "Selfridge",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 728,
    density: 0.7,
    county_fips: 38085,
    county_name: "Sioux",
    county_weights: {
      38085: 99.62,
      46031: 0.38,
    },
    county_names_all: "Sioux|Corson",
    county_fips_all: "38085|46031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58569,
    lat: 46.25777,
    lng: -101.19276,
    city: "Shields",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 82,
    density: 0.2,
    county_fips: 38037,
    county_name: "Grant",
    county_weights: {
      38037: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 38037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58570,
    lat: 46.37243,
    lng: -100.87237,
    city: "Solen",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 493,
    density: 0.6,
    county_fips: 38059,
    county_name: "Morton",
    county_weights: {
      38059: 51.53,
      38085: 48.47,
    },
    county_names_all: "Morton|Sioux",
    county_fips_all: "38059|38085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/North_Dakota/New_Salem",
  },
  {
    zip: 58571,
    lat: 47.29134,
    lng: -101.41043,
    city: "Stanton",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 569,
    density: 1.9,
    county_fips: 38057,
    county_name: "Mercer",
    county_weights: {
      38057: 70.38,
      38065: 29.62,
    },
    county_names_all: "Mercer|Oliver",
    county_fips_all: "38057|38065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/North_Dakota/Beulah",
  },
  {
    zip: 58572,
    lat: 46.86455,
    lng: -100.34313,
    city: "Sterling",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 280,
    density: 0.5,
    county_fips: 38015,
    county_name: "Burleigh",
    county_weights: {
      38015: 100,
    },
    county_names_all: "Burleigh",
    county_fips_all: 38015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58573,
    lat: 46.12542,
    lng: -100.20709,
    city: "Strasburg",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 650,
    density: 1.3,
    county_fips: 38029,
    county_name: "Emmons",
    county_weights: {
      38029: 100,
    },
    county_names_all: "Emmons",
    county_fips_all: 38029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58575,
    lat: 47.55749,
    lng: -100.89971,
    city: "Turtle Lake",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 796,
    density: 1.3,
    county_fips: 38055,
    county_name: "McLean",
    county_weights: {
      38055: 100,
    },
    county_names_all: "McLean",
    county_fips_all: 38055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58576,
    lat: 47.4406,
    lng: -101.21597,
    city: "Underwood",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 999,
    density: 2.3,
    county_fips: 38055,
    county_name: "McLean",
    county_weights: {
      38055: 100,
    },
    county_names_all: "McLean",
    county_fips_all: 38055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58577,
    lat: 47.31983,
    lng: -101.05319,
    city: "Washburn",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1828,
    density: 3.6,
    county_fips: 38055,
    county_name: "McLean",
    county_weights: {
      38055: 100,
    },
    county_names_all: "McLean",
    county_fips_all: 38055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58579,
    lat: 47.18059,
    lng: -100.74422,
    city: "Wilton",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1258,
    density: 2,
    county_fips: 38015,
    county_name: "Burleigh",
    county_weights: {
      38015: 69.52,
      38055: 30.48,
    },
    county_names_all: "Burleigh|McLean",
    county_fips_all: "38015|38055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58580,
    lat: 47.2665,
    lng: -101.93301,
    city: "Zap",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 318,
    density: 0.8,
    county_fips: 38057,
    county_name: "Mercer",
    county_weights: {
      38057: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 38057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/North_Dakota/Beulah",
  },
  {
    zip: 58581,
    lat: 46.04646,
    lng: -99.7983,
    city: "Zeeland",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 235,
    density: 0.7,
    county_fips: 38051,
    county_name: "McIntosh",
    county_weights: {
      38051: 100,
    },
    county_names_all: "McIntosh",
    county_fips_all: 38051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58601,
    lat: 46.90964,
    lng: -102.82766,
    city: "Dickinson",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27075,
    density: 18.3,
    county_fips: 38089,
    county_name: "Stark",
    county_weights: {
      38025: 33.79,
      38089: 66.21,
    },
    county_names_all: "Stark|Dunn",
    county_fips_all: "38089|38025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58620,
    lat: 46.49732,
    lng: -103.3551,
    city: "Amidon",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 132,
    density: 0.2,
    county_fips: 38087,
    county_name: "Slope",
    county_weights: {
      38007: 1.5,
      38087: 98.5,
    },
    county_names_all: "Slope|Billings",
    county_fips_all: "38087|38007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58621,
    lat: 47.09771,
    lng: -103.92652,
    city: "Beach",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1301,
    density: 1.2,
    county_fips: 38033,
    county_name: "Golden Valley",
    county_weights: {
      30109: 4.38,
      38007: 2.13,
      38033: 90.64,
      38053: 2.85,
    },
    county_names_all: "Golden Valley|Wibaux|McKenzie|Billings",
    county_fips_all: "38033|30109|38053|38007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58622,
    lat: 46.88035,
    lng: -103.24434,
    city: "Belfield",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1795,
    density: 1.3,
    county_fips: 38007,
    county_name: "Billings",
    county_weights: {
      38007: 70.96,
      38087: 0.44,
      38089: 28.6,
    },
    county_names_all: "Billings|Stark|Slope",
    county_fips_all: "38007|38089|38087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58623,
    lat: 46.16001,
    lng: -103.42168,
    city: "Bowman",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2083,
    density: 1.5,
    county_fips: 38011,
    county_name: "Bowman",
    county_weights: {
      38011: 72.6,
      38087: 25.46,
      46063: 1.94,
    },
    county_names_all: "Bowman|Slope|Harding",
    county_fips_all: "38011|38087|46063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58625,
    lat: 47.28146,
    lng: -102.19748,
    city: "Dodge",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 261,
    density: 1,
    county_fips: 38025,
    county_name: "Dunn",
    county_weights: {
      38025: 72.37,
      38057: 27.63,
    },
    county_names_all: "Dunn|Mercer",
    county_fips_all: "38025|38057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58626,
    lat: 47.37739,
    lng: -102.60575,
    city: "Dunn Center",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 648,
    density: 1.4,
    county_fips: 38025,
    county_name: "Dunn",
    county_weights: {
      38025: 100,
    },
    county_names_all: "Dunn",
    county_fips_all: 38025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58627,
    lat: 47.23532,
    lng: -103.29713,
    city: "Fairfield",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 182,
    density: 0.2,
    county_fips: 38007,
    county_name: "Billings",
    county_weights: {
      38007: 100,
    },
    county_names_all: "Billings",
    county_fips_all: 38007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58630,
    lat: 46.91981,
    lng: -102.57603,
    city: "Gladstone",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 704,
    density: 1.6,
    county_fips: 38089,
    county_name: "Stark",
    county_weights: {
      38025: 37.7,
      38089: 62.3,
    },
    county_names_all: "Stark|Dunn",
    county_fips_all: "38089|38025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58631,
    lat: 46.7969,
    lng: -101.82156,
    city: "Glen Ullin",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1027,
    density: 1.1,
    county_fips: 38059,
    county_name: "Morton",
    county_weights: {
      38037: 29.75,
      38057: 8.81,
      38059: 61.44,
    },
    county_names_all: "Morton|Grant|Mercer",
    county_fips_all: "38059|38037|38057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/North_Dakota/New_Salem",
  },
  {
    zip: 58632,
    lat: 46.68316,
    lng: -103.95078,
    city: "Golva",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 197,
    density: 1.1,
    county_fips: 38033,
    county_name: "Golden Valley",
    county_weights: {
      38033: 100,
    },
    county_names_all: "Golden Valley",
    county_fips_all: 38033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58634,
    lat: 47.43683,
    lng: -103.35647,
    city: "Grassy Butte",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 255,
    density: 0.3,
    county_fips: 38053,
    county_name: "McKenzie",
    county_weights: {
      38007: 2.4,
      38053: 97.6,
    },
    county_names_all: "McKenzie|Billings",
    county_fips_all: "38053|38007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58636,
    lat: 47.38924,
    lng: -102.35351,
    city: "Halliday",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1016,
    density: 1,
    county_fips: 38025,
    county_name: "Dunn",
    county_weights: {
      38025: 94.09,
      38057: 5.91,
    },
    county_names_all: "Dunn|Mercer",
    county_fips_all: "38025|38057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58638,
    lat: 46.92201,
    lng: -102.04867,
    city: "Hebron",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 996,
    density: 1.2,
    county_fips: 38059,
    county_name: "Morton",
    county_weights: {
      38025: 4.08,
      38037: 6.63,
      38057: 30.26,
      38059: 42.59,
      38089: 16.44,
    },
    county_names_all: "Morton|Mercer|Stark|Grant|Dunn",
    county_fips_all: "38059|38057|38089|38037|38025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/North_Dakota/New_Salem",
  },
  {
    zip: 58639,
    lat: 46.04056,
    lng: -102.63905,
    city: "Hettinger",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1725,
    density: 1.2,
    county_fips: 38001,
    county_name: "Adams",
    county_weights: {
      38001: 78.81,
      46105: 21.19,
    },
    county_names_all: "Adams|Perkins",
    county_fips_all: "38001|46105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58640,
    lat: 47.44409,
    lng: -102.89681,
    city: "Killdeer",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1436,
    density: 1.3,
    county_fips: 38025,
    county_name: "Dunn",
    county_weights: {
      38007: 1.18,
      38025: 97.96,
      38053: 0.86,
    },
    county_names_all: "Dunn|Billings|McKenzie",
    county_fips_all: "38025|38007|38053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58641,
    lat: 46.66732,
    lng: -102.48551,
    city: "Lefor",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 87,
    density: 0.4,
    county_fips: 38089,
    county_name: "Stark",
    county_weights: {
      38089: 100,
    },
    county_names_all: "Stark",
    county_fips_all: 38089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58642,
    lat: 47.20145,
    lng: -102.83667,
    city: "Manning",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 332,
    density: 0.7,
    county_fips: 38025,
    county_name: "Dunn",
    county_weights: {
      38007: 5.35,
      38025: 94.65,
    },
    county_names_all: "Dunn|Billings",
    county_fips_all: "38025|38007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58643,
    lat: 46.22974,
    lng: -103.95091,
    city: "Marmarth",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 180,
    density: 0.5,
    county_fips: 38011,
    county_name: "Bowman",
    county_weights: {
      38011: 70.28,
      38087: 29.72,
    },
    county_names_all: "Bowman|Slope",
    county_fips_all: "38011|38087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58644,
    lat: 47.14095,
    lng: -102.35867,
    city: "Marshall",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 38025,
    county_name: "Dunn",
    county_weights: {
      38025: 100,
    },
    county_names_all: "Dunn",
    county_fips_all: 38025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58645,
    lat: 46.95845,
    lng: -103.52945,
    city: "Medora",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 227,
    density: 0.2,
    county_fips: 38007,
    county_name: "Billings",
    county_weights: {
      38007: 92.08,
      38033: 7.92,
    },
    county_names_all: "Billings|Golden Valley",
    county_fips_all: "38007|38033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58646,
    lat: 46.39826,
    lng: -102.28782,
    city: "Mott",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1114,
    density: 0.7,
    county_fips: 38041,
    county_name: "Hettinger",
    county_weights: {
      38001: 8.94,
      38041: 89.66,
      38089: 1.4,
    },
    county_names_all: "Hettinger|Adams|Stark",
    county_fips_all: "38041|38001|38089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58647,
    lat: 46.51695,
    lng: -102.93466,
    city: "New England",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1367,
    density: 1,
    county_fips: 38087,
    county_name: "Slope",
    county_weights: {
      38041: 44.44,
      38087: 47.37,
      38089: 8.19,
    },
    county_names_all: "Slope|Hettinger|Stark",
    county_fips_all: "38087|38041|38089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58649,
    lat: 46.13762,
    lng: -102.90857,
    city: "Reeder",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 319,
    density: 0.5,
    county_fips: 38001,
    county_name: "Adams",
    county_weights: {
      38001: 72.67,
      38011: 4.71,
      38041: 11.11,
      38087: 2.11,
      46063: 9.4,
    },
    county_names_all: "Adams|Hettinger|Harding|Bowman|Slope",
    county_fips_all: "38001|38041|46063|38011|38087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58650,
    lat: 46.43241,
    lng: -102.59033,
    city: "Regent",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 307,
    density: 0.4,
    county_fips: 38041,
    county_name: "Hettinger",
    county_weights: {
      38001: 6.92,
      38041: 93.08,
    },
    county_names_all: "Hettinger|Adams",
    county_fips_all: "38041|38001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58651,
    lat: 46.26201,
    lng: -103.74228,
    city: "Rhame",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 538,
    density: 0.3,
    county_fips: 38011,
    county_name: "Bowman",
    county_weights: {
      38011: 55.01,
      38087: 44.99,
    },
    county_names_all: "Bowman|Slope",
    county_fips_all: "38011|38087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58652,
    lat: 46.88854,
    lng: -102.27037,
    city: "Richardton",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1371,
    density: 1.3,
    county_fips: 38089,
    county_name: "Stark",
    county_weights: {
      38025: 27.57,
      38089: 72.43,
    },
    county_names_all: "Stark|Dunn",
    county_fips_all: "38089|38025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58653,
    lat: 46.09645,
    lng: -103.12946,
    city: "Scranton",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 763,
    density: 0.8,
    county_fips: 38011,
    county_name: "Bowman",
    county_weights: {
      38011: 71.3,
      38087: 14.12,
      46063: 14.58,
    },
    county_names_all: "Bowman|Harding|Slope",
    county_fips_all: "38011|46063|38087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58654,
    lat: 46.77817,
    lng: -103.81757,
    city: "Sentinel Butte",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 304,
    density: 0.2,
    county_fips: 38033,
    county_name: "Golden Valley",
    county_weights: {
      38033: 79.91,
      38087: 20.09,
    },
    county_names_all: "Golden Valley|Slope",
    county_fips_all: "38033|38087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58655,
    lat: 46.77921,
    lng: -103.03163,
    city: "South Heart",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 625,
    density: 2.2,
    county_fips: 38089,
    county_name: "Stark",
    county_weights: {
      38089: 100,
    },
    county_names_all: "Stark",
    county_fips_all: 38089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58656,
    lat: 46.95207,
    lng: -102.46801,
    city: "Taylor",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 423,
    density: 0.9,
    county_fips: 38089,
    county_name: "Stark",
    county_weights: {
      38025: 36.59,
      38089: 63.41,
    },
    county_names_all: "Stark|Dunn",
    county_fips_all: "38089|38025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58701,
    lat: 48.14027,
    lng: -101.32406,
    city: "Minot",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32112,
    density: 52.6,
    county_fips: 38101,
    county_name: "Ward",
    county_weights: {
      38101: 100,
    },
    county_names_all: "Ward",
    county_fips_all: 38101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58703,
    lat: 48.32646,
    lng: -101.31637,
    city: "Minot",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22524,
    density: 55.7,
    county_fips: 38101,
    county_name: "Ward",
    county_weights: {
      38101: 100,
    },
    county_names_all: "Ward",
    county_fips_all: 38101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58704,
    lat: 48.4232,
    lng: -101.33152,
    city: "Minot Afb",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5086,
    density: 415,
    county_fips: 38101,
    county_name: "Ward",
    county_weights: {
      38101: 100,
    },
    county_names_all: "Ward",
    county_fips_all: 38101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58705,
    lat: 48.41608,
    lng: -101.35182,
    city: "Minot Afb",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 38101,
    county_name: "Ward",
    county_weights: {
      38101: 100,
    },
    county_names_all: "Ward",
    county_fips_all: 38101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58707,
    lat: 48.24767,
    lng: -101.30127,
    city: "Minot",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 424,
    density: 1431.4,
    county_fips: 38101,
    county_name: "Ward",
    county_weights: {
      38101: 100,
    },
    county_names_all: "Ward",
    county_fips_all: 38101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58710,
    lat: 47.86959,
    lng: -100.23912,
    city: "Anamoose",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 730,
    density: 1.5,
    county_fips: 38049,
    county_name: "McHenry",
    county_weights: {
      38049: 40.06,
      38069: 21.63,
      38083: 38.32,
    },
    county_names_all: "McHenry|Sheridan|Pierce",
    county_fips_all: "38049|38083|38069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58711,
    lat: 48.93262,
    lng: -101.2752,
    city: "Antler",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 271,
    density: 0.9,
    county_fips: 38009,
    county_name: "Bottineau",
    county_weights: {
      38009: 100,
    },
    county_names_all: "Bottineau",
    county_fips_all: 38009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58712,
    lat: 47.96799,
    lng: -100.54559,
    city: "Balfour",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 77,
    density: 0.3,
    county_fips: 38049,
    county_name: "McHenry",
    county_weights: {
      38049: 100,
    },
    county_names_all: "McHenry",
    county_fips_all: 38049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58713,
    lat: 48.51876,
    lng: -100.60497,
    city: "Bantry",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 218,
    density: 4.5,
    county_fips: 38049,
    county_name: "McHenry",
    county_weights: {
      38049: 100,
    },
    county_names_all: "McHenry",
    county_fips_all: 38049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58716,
    lat: 47.80049,
    lng: -101.06003,
    city: "Benedict",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 146,
    density: 0.7,
    county_fips: 38055,
    county_name: "McLean",
    county_weights: {
      38055: 61.42,
      38101: 38.58,
    },
    county_names_all: "McLean|Ward",
    county_fips_all: "38055|38101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58718,
    lat: 48.31128,
    lng: -101.82989,
    city: "Berthold",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1178,
    density: 1.1,
    county_fips: 38101,
    county_name: "Ward",
    county_weights: {
      38061: 31.91,
      38075: 4.11,
      38101: 63.98,
    },
    county_names_all: "Ward|Mountrail|Renville",
    county_fips_all: "38101|38061|38075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58721,
    lat: 48.82069,
    lng: -102.25667,
    city: "Bowbells",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 426,
    density: 0.8,
    county_fips: 38013,
    county_name: "Burke",
    county_weights: {
      38013: 94.69,
      38101: 5.31,
    },
    county_names_all: "Burke|Ward",
    county_fips_all: "38013|38101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58722,
    lat: 48.25238,
    lng: -101.50079,
    city: "Burlington",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1685,
    density: 9.9,
    county_fips: 38101,
    county_name: "Ward",
    county_weights: {
      38101: 100,
    },
    county_names_all: "Ward",
    county_fips_all: 38101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58723,
    lat: 47.75433,
    lng: -100.60281,
    city: "Butte",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 183,
    density: 0.4,
    county_fips: 38055,
    county_name: "McLean",
    county_weights: {
      38049: 0.96,
      38055: 54.59,
      38083: 44.45,
    },
    county_names_all: "McLean|Sheridan|McHenry",
    county_fips_all: "38055|38083|38049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58725,
    lat: 48.48699,
    lng: -101.68361,
    city: "Carpio",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 350,
    density: 0.9,
    county_fips: 38075,
    county_name: "Renville",
    county_weights: {
      38075: 61.1,
      38101: 38.9,
    },
    county_names_all: "Renville|Ward",
    county_fips_all: "38075|38101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58727,
    lat: 48.85542,
    lng: -102.80479,
    city: "Columbus",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 173,
    density: 0.3,
    county_fips: 38013,
    county_name: "Burke",
    county_weights: {
      38013: 100,
    },
    county_names_all: "Burke",
    county_fips_all: 38013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58730,
    lat: 48.86171,
    lng: -103.30652,
    city: "Crosby",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1535,
    density: 2.3,
    county_fips: 38023,
    county_name: "Divide",
    county_weights: {
      38023: 100,
    },
    county_names_all: "Divide",
    county_fips_all: 38023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58731,
    lat: 48.44752,
    lng: -100.98029,
    city: "Deering",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 305,
    density: 1.2,
    county_fips: 38049,
    county_name: "McHenry",
    county_weights: {
      38049: 89.97,
      38101: 10.03,
    },
    county_names_all: "McHenry|Ward",
    county_fips_all: "38049|38101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58733,
    lat: 48.16911,
    lng: -101.59463,
    city: "Des Lacs",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 435,
    density: 2,
    county_fips: 38101,
    county_name: "Ward",
    county_weights: {
      38101: 100,
    },
    county_names_all: "Ward",
    county_fips_all: 38101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58734,
    lat: 48.51508,
    lng: -101.95757,
    city: "Donnybrook",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 381,
    density: 0.7,
    county_fips: 38101,
    county_name: "Ward",
    county_weights: {
      38061: 37.58,
      38075: 21.38,
      38101: 41.04,
    },
    county_names_all: "Ward|Mountrail|Renville",
    county_fips_all: "38101|38061|38075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58735,
    lat: 47.87771,
    lng: -101.48366,
    city: "Douglas",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 549,
    density: 1.1,
    county_fips: 38101,
    county_name: "Ward",
    county_weights: {
      38055: 40.14,
      38101: 59.86,
    },
    county_names_all: "Ward|McLean",
    county_fips_all: "38101|38055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58736,
    lat: 47.92804,
    lng: -100.38732,
    city: "Drake",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 540,
    density: 1.3,
    county_fips: 38049,
    county_name: "McHenry",
    county_weights: {
      38049: 72.86,
      38083: 27.14,
    },
    county_names_all: "McHenry|Sheridan",
    county_fips_all: "38049|38083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58737,
    lat: 48.90743,
    lng: -102.39392,
    city: "Flaxton",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 155,
    density: 0.4,
    county_fips: 38013,
    county_name: "Burke",
    county_weights: {
      38013: 100,
    },
    county_names_all: "Burke",
    county_fips_all: 38013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58740,
    lat: 48.4711,
    lng: -101.22744,
    city: "Glenburn",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 720,
    density: 1.7,
    county_fips: 38075,
    county_name: "Renville",
    county_weights: {
      38009: 2.38,
      38049: 2.31,
      38075: 58.31,
      38101: 37,
    },
    county_names_all: "Renville|Ward|Bottineau|McHenry",
    county_fips_all: "38075|38101|38009|38049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58741,
    lat: 48.27336,
    lng: -100.83352,
    city: "Granville",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 646,
    density: 1.4,
    county_fips: 38049,
    county_name: "McHenry",
    county_weights: {
      38049: 100,
    },
    county_names_all: "McHenry",
    county_fips_all: 38049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58744,
    lat: 48.12073,
    lng: -100.58774,
    city: "Karlsruhe",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 93,
    density: 0.4,
    county_fips: 38049,
    county_name: "McHenry",
    county_weights: {
      38049: 100,
    },
    county_names_all: "McHenry",
    county_fips_all: 38049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58746,
    lat: 48.71921,
    lng: -102.10115,
    city: "Kenmare",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1335,
    density: 1.2,
    county_fips: 38101,
    county_name: "Ward",
    county_weights: {
      38013: 33.79,
      38075: 19.45,
      38101: 46.76,
    },
    county_names_all: "Ward|Burke|Renville",
    county_fips_all: "38101|38013|38075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58748,
    lat: 48.66895,
    lng: -100.64487,
    city: "Kramer",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 114,
    density: 0.4,
    county_fips: 38009,
    county_name: "Bottineau",
    county_weights: {
      38009: 78.81,
      38049: 21.19,
    },
    county_names_all: "Bottineau|McHenry",
    county_fips_all: "38009|38049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58750,
    lat: 48.6166,
    lng: -101.39941,
    city: "Lansford",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 386,
    density: 0.6,
    county_fips: 38009,
    county_name: "Bottineau",
    county_weights: {
      38009: 59.97,
      38075: 40.03,
    },
    county_names_all: "Bottineau|Renville",
    county_fips_all: "38009|38075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58752,
    lat: 48.82146,
    lng: -102.59927,
    city: "Lignite",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 292,
    density: 1.4,
    county_fips: 38013,
    county_name: "Burke",
    county_weights: {
      38013: 100,
    },
    county_names_all: "Burke",
    county_fips_all: 38013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58755,
    lat: 48.62857,
    lng: -102.94666,
    city: "Mcgregor",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 182,
    density: 0.8,
    county_fips: 38105,
    county_name: "Williams",
    county_weights: {
      38013: 13.06,
      38023: 43.04,
      38105: 43.89,
    },
    county_names_all: "Williams|Divide|Burke",
    county_fips_all: "38105|38023|38013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58756,
    lat: 47.96746,
    lng: -101.81431,
    city: "Makoti",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 198,
    density: 0.7,
    county_fips: 38101,
    county_name: "Ward",
    county_weights: {
      38055: 3.72,
      38061: 20.87,
      38101: 75.41,
    },
    county_names_all: "Ward|Mountrail|McLean",
    county_fips_all: "38101|38061|38055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58757,
    lat: 47.67643,
    lng: -102.54685,
    city: "Mandaree",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 821,
    density: 0.9,
    county_fips: 38025,
    county_name: "Dunn",
    county_weights: {
      38025: 82.01,
      38053: 17.99,
    },
    county_names_all: "Dunn|McKenzie",
    county_fips_all: "38025|38053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58758,
    lat: 47.76643,
    lng: -100.10424,
    city: "Martin",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 261,
    density: 0.8,
    county_fips: 38083,
    county_name: "Sheridan",
    county_weights: {
      38069: 15.15,
      38083: 67.53,
      38103: 17.32,
    },
    county_names_all: "Sheridan|Wells|Pierce",
    county_fips_all: "38083|38103|38069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58759,
    lat: 47.84776,
    lng: -101.25026,
    city: "Max",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 794,
    density: 1.3,
    county_fips: 38055,
    county_name: "McLean",
    county_weights: {
      38055: 52.87,
      38101: 47.13,
    },
    county_names_all: "McLean|Ward",
    county_fips_all: "38055|38101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58760,
    lat: 48.69854,
    lng: -101.14158,
    city: "Maxbass",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 257,
    density: 0.7,
    county_fips: 38009,
    county_name: "Bottineau",
    county_weights: {
      38009: 100,
    },
    county_names_all: "Bottineau",
    county_fips_all: 38009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58761,
    lat: 48.78736,
    lng: -101.53019,
    city: "Mohall",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 885,
    density: 1.2,
    county_fips: 38075,
    county_name: "Renville",
    county_weights: {
      38009: 39.54,
      38075: 60.46,
    },
    county_names_all: "Renville|Bottineau",
    county_fips_all: "38075|38009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58762,
    lat: 48.67409,
    lng: -100.94225,
    city: "Newburg",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 286,
    density: 1.2,
    county_fips: 38009,
    county_name: "Bottineau",
    county_weights: {
      38009: 76.85,
      38049: 23.15,
    },
    county_names_all: "Bottineau|McHenry",
    county_fips_all: "38009|38049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58763,
    lat: 47.98362,
    lng: -102.58401,
    city: "New Town",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4001,
    density: 2.9,
    county_fips: 38061,
    county_name: "Mountrail",
    county_weights: {
      38053: 38.72,
      38061: 61.28,
    },
    county_names_all: "Mountrail|McKenzie",
    county_fips_all: "38061|38053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58765,
    lat: 48.87261,
    lng: -103.03805,
    city: "Noonan",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 277,
    density: 0.7,
    county_fips: 38023,
    county_name: "Divide",
    county_weights: {
      38023: 100,
    },
    county_names_all: "Divide",
    county_fips_all: 38023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58768,
    lat: 48.25115,
    lng: -101.01456,
    city: "Norwich",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 249,
    density: 1.3,
    county_fips: 38049,
    county_name: "McHenry",
    county_weights: {
      38049: 50.06,
      38101: 49.94,
    },
    county_names_all: "McHenry|Ward",
    county_fips_all: "38049|38101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58769,
    lat: 48.30082,
    lng: -102.22721,
    city: "Palermo",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 277,
    density: 0.6,
    county_fips: 38061,
    county_name: "Mountrail",
    county_weights: {
      38061: 100,
    },
    county_names_all: "Mountrail",
    county_fips_all: 38061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58770,
    lat: 47.86531,
    lng: -102.16251,
    city: "Parshall",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1677,
    density: 2.4,
    county_fips: 38061,
    county_name: "Mountrail",
    county_weights: {
      38055: 44.72,
      38061: 55.28,
    },
    county_names_all: "Mountrail|McLean",
    county_fips_all: "38061|38055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58771,
    lat: 48.08711,
    lng: -101.98534,
    city: "Plaza",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 505,
    density: 0.8,
    county_fips: 38061,
    county_name: "Mountrail",
    county_weights: {
      38055: 3.29,
      38061: 76.19,
      38101: 20.52,
    },
    county_names_all: "Mountrail|Ward|McLean",
    county_fips_all: "38061|38101|38055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58772,
    lat: 48.96035,
    lng: -102.61236,
    city: "Portal",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 139,
    density: 0.9,
    county_fips: 38013,
    county_name: "Burke",
    county_weights: {
      38013: 100,
    },
    county_names_all: "Burke",
    county_fips_all: 38013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58773,
    lat: 48.58631,
    lng: -102.66852,
    city: "Powers Lake",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1078,
    density: 1.4,
    county_fips: 38013,
    county_name: "Burke",
    county_weights: {
      38013: 68.91,
      38061: 31.09,
    },
    county_names_all: "Burke|Mountrail",
    county_fips_all: "38013|38061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58775,
    lat: 47.71424,
    lng: -101.85203,
    city: "Roseglen",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 123,
    density: 0.6,
    county_fips: 38055,
    county_name: "McLean",
    county_weights: {
      38055: 100,
    },
    county_names_all: "McLean",
    county_fips_all: 38055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58776,
    lat: 48.25079,
    lng: -102.61543,
    city: "Ross",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 352,
    density: 0.9,
    county_fips: 38061,
    county_name: "Mountrail",
    county_weights: {
      38061: 100,
    },
    county_names_all: "Mountrail",
    county_fips_all: 38061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58778,
    lat: 47.78307,
    lng: -100.91268,
    city: "Ruso",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 111,
    density: 0.3,
    county_fips: 38055,
    county_name: "McLean",
    county_weights: {
      38049: 7.81,
      38055: 92.19,
    },
    county_names_all: "McLean|McHenry",
    county_fips_all: "38055|38049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58779,
    lat: 47.85507,
    lng: -101.7621,
    city: "Ryder",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 256,
    density: 0.4,
    county_fips: 38055,
    county_name: "McLean",
    county_weights: {
      38055: 53.27,
      38101: 46.73,
    },
    county_names_all: "McLean|Ward",
    county_fips_all: "38055|38101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58781,
    lat: 48.02451,
    lng: -101.13468,
    city: "Sawyer",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 695,
    density: 2.4,
    county_fips: 38101,
    county_name: "Ward",
    county_weights: {
      38101: 100,
    },
    county_names_all: "Ward",
    county_fips_all: 38101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58782,
    lat: 48.94055,
    lng: -101.71325,
    city: "Sherwood",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 605,
    density: 1.2,
    county_fips: 38075,
    county_name: "Renville",
    county_weights: {
      38009: 7.32,
      38075: 92.68,
    },
    county_names_all: "Renville|Bottineau",
    county_fips_all: "38075|38009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58783,
    lat: 48.88375,
    lng: -100.75035,
    city: "Souris",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 405,
    density: 0.5,
    county_fips: 38009,
    county_name: "Bottineau",
    county_weights: {
      38009: 100,
    },
    county_names_all: "Bottineau",
    county_fips_all: 38009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58784,
    lat: 48.36212,
    lng: -102.42273,
    city: "Stanley",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3262,
    density: 3.6,
    county_fips: 38061,
    county_name: "Mountrail",
    county_weights: {
      38013: 10.22,
      38061: 89.78,
    },
    county_names_all: "Mountrail|Burke",
    county_fips_all: "38061|38013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58785,
    lat: 48.31121,
    lng: -101.09706,
    city: "Surrey",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1130,
    density: 10.7,
    county_fips: 38101,
    county_name: "Ward",
    county_weights: {
      38101: 100,
    },
    county_names_all: "Ward",
    county_fips_all: 38101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58787,
    lat: 48.76057,
    lng: -101.80832,
    city: "Tolley",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 140,
    density: 0.5,
    county_fips: 38075,
    county_name: "Renville",
    county_weights: {
      38075: 100,
    },
    county_names_all: "Renville",
    county_fips_all: 38075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58788,
    lat: 48.33198,
    lng: -100.48045,
    city: "Towner",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1038,
    density: 0.8,
    county_fips: 38049,
    county_name: "McHenry",
    county_weights: {
      38049: 96.88,
      38069: 3.12,
    },
    county_names_all: "McHenry|Pierce",
    county_fips_all: "38049|38069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58789,
    lat: 48.54778,
    lng: -100.81898,
    city: "Upham",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 297,
    density: 0.7,
    county_fips: 38049,
    county_name: "McHenry",
    county_weights: {
      38009: 9.69,
      38049: 90.31,
    },
    county_names_all: "McHenry|Bottineau",
    county_fips_all: "38049|38009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58790,
    lat: 48.03071,
    lng: -100.93952,
    city: "Velva",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1736,
    density: 3.6,
    county_fips: 38049,
    county_name: "McHenry",
    county_weights: {
      38049: 78.72,
      38101: 21.28,
    },
    county_names_all: "McHenry|Ward",
    county_fips_all: "38049|38101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58792,
    lat: 47.97385,
    lng: -100.7424,
    city: "Voltaire",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 175,
    density: 0.4,
    county_fips: 38049,
    county_name: "McHenry",
    county_weights: {
      38049: 100,
    },
    county_names_all: "McHenry",
    county_fips_all: 38049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58793,
    lat: 48.86442,
    lng: -101.05424,
    city: "Westhope",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 483,
    density: 1.1,
    county_fips: 38009,
    county_name: "Bottineau",
    county_weights: {
      38009: 100,
    },
    county_names_all: "Bottineau",
    county_fips_all: 38009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58794,
    lat: 48.25916,
    lng: -102.76683,
    city: "White Earth",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 258,
    density: 1,
    county_fips: 38061,
    county_name: "Mountrail",
    county_weights: {
      38061: 100,
    },
    county_names_all: "Mountrail",
    county_fips_all: 38061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58795,
    lat: 48.64198,
    lng: -103.15094,
    city: "Wildrose",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 109,
    density: 0.2,
    county_fips: 38023,
    county_name: "Divide",
    county_weights: {
      38023: 53.85,
      38105: 46.15,
    },
    county_names_all: "Divide|Williams",
    county_fips_all: "38023|38105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58801,
    lat: 48.23522,
    lng: -103.76747,
    city: "Williston",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32297,
    density: 17.4,
    county_fips: 38105,
    county_name: "Williams",
    county_weights: {
      38105: 100,
    },
    county_names_all: "Williams",
    county_fips_all: 38105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58830,
    lat: 48.60272,
    lng: -103.46608,
    city: "Alamo",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 242,
    density: 0.3,
    county_fips: 38105,
    county_name: "Williams",
    county_weights: {
      38023: 40.19,
      38105: 59.81,
    },
    county_names_all: "Williams|Divide",
    county_fips_all: "38105|38023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58831,
    lat: 47.84878,
    lng: -103.65843,
    city: "Alexander",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 668,
    density: 0.6,
    county_fips: 38053,
    county_name: "McKenzie",
    county_weights: {
      38053: 100,
    },
    county_names_all: "McKenzie",
    county_fips_all: 38053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58833,
    lat: 48.89186,
    lng: -103.52517,
    city: "Ambrose",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 209,
    density: 0.8,
    county_fips: 38023,
    county_name: "Divide",
    county_weights: {
      38023: 100,
    },
    county_names_all: "Divide",
    county_fips_all: 38023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58835,
    lat: 47.7328,
    lng: -103.45268,
    city: "Arnegard",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 580,
    density: 0.9,
    county_fips: 38053,
    county_name: "McKenzie",
    county_weights: {
      38053: 100,
    },
    county_names_all: "McKenzie",
    county_fips_all: 38053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58838,
    lat: 47.7721,
    lng: -103.90289,
    city: "Cartwright",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 237,
    density: 0.4,
    county_fips: 38053,
    county_name: "McKenzie",
    county_weights: {
      38053: 100,
    },
    county_names_all: "McKenzie",
    county_fips_all: 38053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 58843,
    lat: 48.23141,
    lng: -103.38142,
    city: "Epping",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 650,
    density: 1.1,
    county_fips: 38105,
    county_name: "Williams",
    county_weights: {
      38105: 100,
    },
    county_names_all: "Williams",
    county_fips_all: 38105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58844,
    lat: 48.89167,
    lng: -103.74304,
    city: "Fortuna",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47,
    density: 0.1,
    county_fips: 38023,
    county_name: "Divide",
    county_weights: {
      38023: 100,
    },
    county_names_all: "Divide",
    county_fips_all: 38023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58845,
    lat: 48.63928,
    lng: -103.92207,
    city: "Grenora",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 433,
    density: 0.7,
    county_fips: 38105,
    county_name: "Williams",
    county_weights: {
      38023: 49.71,
      38105: 50.29,
    },
    county_names_all: "Williams|Divide",
    county_fips_all: "38105|38023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58847,
    lat: 47.89012,
    lng: -102.90094,
    city: "Keene",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 516,
    density: 1.1,
    county_fips: 38053,
    county_name: "McKenzie",
    county_weights: {
      38053: 100,
    },
    county_names_all: "McKenzie",
    county_fips_all: 38053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58849,
    lat: 48.30906,
    lng: -103.15697,
    city: "Ray",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 959,
    density: 1.2,
    county_fips: 38105,
    county_name: "Williams",
    county_weights: {
      38105: 100,
    },
    county_names_all: "Williams",
    county_fips_all: 38105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58852,
    lat: 48.38037,
    lng: -102.93276,
    city: "Tioga",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1283,
    density: 1.6,
    county_fips: 38105,
    county_name: "Williams",
    county_weights: {
      38061: 21.05,
      38105: 78.95,
    },
    county_names_all: "Williams|Mountrail",
    county_fips_all: "38105|38061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58853,
    lat: 48.06237,
    lng: -103.78588,
    city: "Trenton",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 198,
    density: 5.2,
    county_fips: 38105,
    county_name: "Williams",
    county_weights: {
      38105: 100,
    },
    county_names_all: "Williams",
    county_fips_all: 38105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58854,
    lat: 47.81412,
    lng: -103.15229,
    city: "Watford City",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9737,
    density: 5.6,
    county_fips: 38053,
    county_name: "McKenzie",
    county_weights: {
      38025: 7.65,
      38053: 92.35,
    },
    county_names_all: "McKenzie|Dunn",
    county_fips_all: "38053|38025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 58856,
    lat: 48.59123,
    lng: -103.72546,
    city: "Zahl",
    state_id: "ND",
    state_name: "North Dakota",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54,
    density: 0.1,
    county_fips: 38105,
    county_name: "Williams",
    county_weights: {
      38023: 33.68,
      38105: 66.32,
    },
    county_names_all: "Williams|Divide",
    county_fips_all: "38105|38023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 59001,
    lat: 45.52952,
    lng: -109.54022,
    city: "Absarokee",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1574,
    density: 4.3,
    county_fips: 30095,
    county_name: "Stillwater",
    county_weights: {
      30009: 5.71,
      30095: 94.29,
    },
    county_names_all: "Stillwater|Carbon",
    county_fips_all: "30095|30009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59002,
    lat: 45.99832,
    lng: -108.6649,
    city: "Acton",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 197,
    density: 1,
    county_fips: 30111,
    county_name: "Yellowstone",
    county_weights: {
      30111: 100,
    },
    county_names_all: "Yellowstone",
    county_fips_all: 30111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59003,
    lat: 45.48179,
    lng: -106.20153,
    city: "Ashland",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1168,
    density: 0.6,
    county_fips: 30075,
    county_name: "Powder River",
    county_weights: {
      30075: 61.44,
      30087: 38.56,
    },
    county_names_all: "Powder River|Rosebud",
    county_fips_all: "30075|30087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59006,
    lat: 45.90755,
    lng: -108.08535,
    city: "Ballantine",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1538,
    density: 9.6,
    county_fips: 30111,
    county_name: "Yellowstone",
    county_weights: {
      30111: 100,
    },
    county_names_all: "Yellowstone",
    county_fips_all: 30111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59007,
    lat: 45.15555,
    lng: -109.15805,
    city: "Bearcreek",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 157,
    density: 1.9,
    county_fips: 30009,
    county_name: "Carbon",
    county_weights: {
      30009: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 30009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59008,
    lat: 45.07982,
    lng: -109.07496,
    city: "Belfry",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 519,
    density: 1.6,
    county_fips: 30009,
    county_name: "Carbon",
    county_weights: {
      30009: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 30009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59010,
    lat: 45.97505,
    lng: -107.3037,
    city: "Bighorn",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 154,
    density: 0.2,
    county_fips: 30103,
    county_name: "Treasure",
    county_weights: {
      30003: 45.05,
      30103: 54.95,
    },
    county_names_all: "Treasure|Big Horn",
    county_fips_all: "30103|30003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59011,
    lat: 45.92453,
    lng: -109.97244,
    city: "Big Timber",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3083,
    density: 1.3,
    county_fips: 30097,
    county_name: "Sweet Grass",
    county_weights: {
      30097: 100,
    },
    county_names_all: "Sweet Grass",
    county_fips_all: 30097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59012,
    lat: 45.29922,
    lng: -106.6006,
    city: "Birney",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 278,
    density: 0.5,
    county_fips: 30087,
    county_name: "Rosebud",
    county_weights: {
      30087: 100,
    },
    county_names_all: "Rosebud",
    county_fips_all: 30087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59013,
    lat: 45.46131,
    lng: -109.08054,
    city: "Boyd",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 132,
    density: 11.8,
    county_fips: 30009,
    county_name: "Carbon",
    county_weights: {
      30009: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 30009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59014,
    lat: 45.15351,
    lng: -108.66421,
    city: "Bridger",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1710,
    density: 0.9,
    county_fips: 30009,
    county_name: "Carbon",
    county_weights: {
      30009: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 30009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59015,
    lat: 46.08464,
    lng: -108.83464,
    city: "Broadview",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 439,
    density: 0.7,
    county_fips: 30111,
    county_name: "Yellowstone",
    county_weights: {
      30065: 19.41,
      30095: 28.85,
      30111: 51.74,
    },
    county_names_all: "Yellowstone|Stillwater|Musselshell",
    county_fips_all: "30111|30095|30065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59016,
    lat: 45.41871,
    lng: -106.93872,
    city: "Busby",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1155,
    density: 1.1,
    county_fips: 30003,
    county_name: "Big Horn",
    county_weights: {
      30003: 100,
    },
    county_names_all: "Big Horn",
    county_fips_all: 30003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59018,
    lat: 45.85791,
    lng: -110.62326,
    city: "Clyde Park",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 475,
    density: 1,
    county_fips: 30067,
    county_name: "Park",
    county_weights: {
      30067: 100,
    },
    county_names_all: "Park",
    county_fips_all: 30067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59019,
    lat: 45.62995,
    lng: -109.24208,
    city: "Columbus",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4275,
    density: 5.4,
    county_fips: 30095,
    county_name: "Stillwater",
    county_weights: {
      30009: 2.17,
      30095: 97.83,
    },
    county_names_all: "Stillwater|Carbon",
    county_fips_all: "30095|30009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59020,
    lat: 45.08831,
    lng: -110.01499,
    city: "Cooke City",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69,
    density: 0.1,
    county_fips: 30067,
    county_name: "Park",
    county_weights: {
      30067: 100,
    },
    county_names_all: "Park",
    county_fips_all: 30067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59022,
    lat: 45.57541,
    lng: -107.26756,
    city: "Crow Agency",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2357,
    density: 5.8,
    county_fips: 30003,
    county_name: "Big Horn",
    county_weights: {
      30003: 100,
    },
    county_names_all: "Big Horn",
    county_fips_all: 30003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59024,
    lat: 46.20549,
    lng: -107.71464,
    city: "Custer",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 334,
    density: 0.3,
    county_fips: 30111,
    county_name: "Yellowstone",
    county_weights: {
      30003: 7.88,
      30111: 92.12,
    },
    county_names_all: "Yellowstone|Big Horn",
    county_fips_all: "30111|30003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59025,
    lat: 45.09503,
    lng: -106.7178,
    city: "Decker",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65,
    density: 0,
    county_fips: 30003,
    county_name: "Big Horn",
    county_weights: {
      30003: 100,
    },
    county_names_all: "Big Horn",
    county_fips_all: 30003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59026,
    lat: 45.46385,
    lng: -108.78392,
    city: "Edgar",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 177,
    density: 3,
    county_fips: 30009,
    county_name: "Carbon",
    county_weights: {
      30009: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 30009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59027,
    lat: 45.26118,
    lng: -110.90674,
    city: "Emigrant",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 721,
    density: 1.2,
    county_fips: 30067,
    county_name: "Park",
    county_weights: {
      30067: 100,
    },
    county_names_all: "Park",
    county_fips_all: 30067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59028,
    lat: 45.32093,
    lng: -109.7434,
    city: "Fishtail",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 525,
    density: 0.6,
    county_fips: 30095,
    county_name: "Stillwater",
    county_weights: {
      30095: 100,
    },
    county_names_all: "Stillwater",
    county_fips_all: 30095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59029,
    lat: 45.4085,
    lng: -108.80467,
    city: "Fromberg",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 764,
    density: 3.1,
    county_fips: 30009,
    county_name: "Carbon",
    county_weights: {
      30009: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 30009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59030,
    lat: 45.08882,
    lng: -110.59376,
    city: "Gardiner",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1249,
    density: 1,
    county_fips: 30067,
    county_name: "Park",
    county_weights: {
      30067: 100,
    },
    county_names_all: "Park",
    county_fips_all: 30067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59031,
    lat: 45.50005,
    lng: -107.37964,
    city: "Garryowen",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 308,
    density: 1.1,
    county_fips: 30003,
    county_name: "Big Horn",
    county_weights: {
      30003: 100,
    },
    county_names_all: "Big Horn",
    county_fips_all: 30003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59032,
    lat: 47.0106,
    lng: -108.75808,
    city: "Grass Range",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 461,
    density: 0.3,
    county_fips: 30027,
    county_name: "Fergus",
    county_weights: {
      30027: 76.55,
      30069: 23.45,
    },
    county_names_all: "Fergus|Petroleum",
    county_fips_all: "30027|30069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59033,
    lat: 45.72296,
    lng: -109.73246,
    city: "Greycliff",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 298,
    density: 3.3,
    county_fips: 30097,
    county_name: "Sweet Grass",
    county_weights: {
      30097: 100,
    },
    county_names_all: "Sweet Grass",
    county_fips_all: 30097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59034,
    lat: 45.70121,
    lng: -107.7078,
    city: "Hardin",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5348,
    density: 2.6,
    county_fips: 30003,
    county_name: "Big Horn",
    county_weights: {
      30003: 100,
    },
    county_names_all: "Big Horn",
    county_fips_all: 30003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59035,
    lat: 45.29814,
    lng: -107.96042,
    city: "Fort Smith",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 226,
    density: 1,
    county_fips: 30003,
    county_name: "Big Horn",
    county_weights: {
      30003: 100,
    },
    county_names_all: "Big Horn",
    county_fips_all: 30003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59036,
    lat: 46.46606,
    lng: -109.89035,
    city: "Harlowton",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1405,
    density: 0.8,
    county_fips: 30107,
    county_name: "Wheatland",
    county_weights: {
      30107: 100,
    },
    county_names_all: "Wheatland",
    county_fips_all: 30107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59037,
    lat: 45.852,
    lng: -108.20927,
    city: "Huntley",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2642,
    density: 8.2,
    county_fips: 30111,
    county_name: "Yellowstone",
    county_weights: {
      30003: 7.24,
      30111: 92.76,
    },
    county_names_all: "Yellowstone|Big Horn",
    county_fips_all: "30111|30003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59038,
    lat: 46.18917,
    lng: -107.23069,
    city: "Hysham",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 513,
    density: 0.2,
    county_fips: 30103,
    county_name: "Treasure",
    county_weights: {
      30003: 12.76,
      30103: 87.24,
    },
    county_names_all: "Treasure|Big Horn",
    county_fips_all: "30103|30003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59039,
    lat: 46.68533,
    lng: -107.28458,
    city: "Ingomar",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47,
    density: 0,
    county_fips: 30087,
    county_name: "Rosebud",
    county_weights: {
      30087: 100,
    },
    county_names_all: "Rosebud",
    county_fips_all: 30087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59041,
    lat: 45.50239,
    lng: -108.9663,
    city: "Joliet",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1971,
    density: 4,
    county_fips: 30009,
    county_name: "Carbon",
    county_weights: {
      30009: 97.36,
      30111: 2.64,
    },
    county_names_all: "Carbon|Yellowstone",
    county_fips_all: "30009|30111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59043,
    lat: 45.53266,
    lng: -106.6568,
    city: "Lame Deer",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3140,
    density: 3.6,
    county_fips: 30087,
    county_name: "Rosebud",
    county_weights: {
      30003: 30,
      30087: 70,
    },
    county_names_all: "Rosebud|Big Horn",
    county_fips_all: "30087|30003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59044,
    lat: 45.64251,
    lng: -108.74975,
    city: "Laurel",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12300,
    density: 27.1,
    county_fips: 30111,
    county_name: "Yellowstone",
    county_weights: {
      30009: 8.99,
      30111: 91.01,
    },
    county_names_all: "Yellowstone|Carbon",
    county_fips_all: "30111|30009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59046,
    lat: 46.39147,
    lng: -108.98604,
    city: "Lavina",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 379,
    density: 0.2,
    county_fips: 30037,
    county_name: "Golden Valley",
    county_weights: {
      30037: 91.74,
      30065: 8.26,
    },
    county_names_all: "Golden Valley|Musselshell",
    county_fips_all: "30037|30065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59047,
    lat: 45.56852,
    lng: -110.55174,
    city: "Livingston",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12711,
    density: 6.3,
    county_fips: 30067,
    county_name: "Park",
    county_weights: {
      30067: 100,
    },
    county_names_all: "Park",
    county_fips_all: 30067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59050,
    lat: 45.25013,
    lng: -107.47849,
    city: "Lodge Grass",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1661,
    density: 0.9,
    county_fips: 30003,
    county_name: "Big Horn",
    county_weights: {
      30003: 100,
    },
    county_names_all: "Big Horn",
    county_fips_all: 30003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59052,
    lat: 45.43651,
    lng: -110.18676,
    city: "McLeod",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 149,
    density: 0.1,
    county_fips: 30097,
    county_name: "Sweet Grass",
    county_weights: {
      30067: 41.17,
      30097: 58.83,
    },
    county_names_all: "Sweet Grass|Park",
    county_fips_all: "30097|30067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59053,
    lat: 46.45713,
    lng: -110.43492,
    city: "Martinsdale",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 370,
    density: 0.3,
    county_fips: 30059,
    county_name: "Meagher",
    county_weights: {
      30059: 96.81,
      30107: 3.19,
    },
    county_names_all: "Meagher|Wheatland",
    county_fips_all: "30059|30107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59054,
    lat: 46.66809,
    lng: -107.7691,
    city: "Melstone",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 253,
    density: 0.2,
    county_fips: 30087,
    county_name: "Rosebud",
    county_weights: {
      30065: 42.27,
      30087: 57.73,
    },
    county_names_all: "Rosebud|Musselshell",
    county_fips_all: "30087|30065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59055,
    lat: 46.10282,
    lng: -109.78662,
    city: "Melville",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 85,
    density: 0.1,
    county_fips: 30097,
    county_name: "Sweet Grass",
    county_weights: {
      30097: 100,
    },
    county_names_all: "Sweet Grass",
    county_fips_all: 30097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59057,
    lat: 45.85358,
    lng: -108.95377,
    city: "Molt",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 878,
    density: 1.2,
    county_fips: 30095,
    county_name: "Stillwater",
    county_weights: {
      30095: 68.46,
      30111: 31.54,
    },
    county_names_all: "Stillwater|Yellowstone",
    county_fips_all: "30095|30111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59058,
    lat: 46.98517,
    lng: -107.79652,
    city: "Mosby",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24,
    density: 0,
    county_fips: 30033,
    county_name: "Garfield",
    county_weights: {
      30033: 74.43,
      30069: 25.57,
    },
    county_names_all: "Garfield|Petroleum",
    county_fips_all: "30033|30069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59059,
    lat: 46.51161,
    lng: -108.088,
    city: "Musselshell",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 205,
    density: 0.2,
    county_fips: 30065,
    county_name: "Musselshell",
    county_weights: {
      30065: 100,
    },
    county_names_all: "Musselshell",
    county_fips_all: 30065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59061,
    lat: 45.39634,
    lng: -109.87728,
    city: "Nye",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 260,
    density: 0.6,
    county_fips: 30095,
    county_name: "Stillwater",
    county_weights: {
      30095: 100,
    },
    county_names_all: "Stillwater",
    county_fips_all: 30095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59062,
    lat: 45.15773,
    lng: -106.20895,
    city: "Otter",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29,
    density: 0,
    county_fips: 30075,
    county_name: "Powder River",
    county_weights: {
      30075: 69.03,
      30087: 30.97,
    },
    county_names_all: "Powder River|Rosebud",
    county_fips_all: "30075|30087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59063,
    lat: 45.65079,
    lng: -108.97028,
    city: "Park City",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2205,
    density: 13.9,
    county_fips: 30095,
    county_name: "Stillwater",
    county_weights: {
      30095: 99.58,
      30111: 0.42,
    },
    county_names_all: "Stillwater|Yellowstone",
    county_fips_all: "30095|30111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59064,
    lat: 45.88011,
    lng: -107.87245,
    city: "Pompeys Pillar",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 182,
    density: 0.3,
    county_fips: 30003,
    county_name: "Big Horn",
    county_weights: {
      30003: 71.23,
      30111: 28.77,
    },
    county_names_all: "Big Horn|Yellowstone",
    county_fips_all: "30003|30111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59065,
    lat: 45.26883,
    lng: -110.6784,
    city: "Pray",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 125,
    density: 0.4,
    county_fips: 30067,
    county_name: "Park",
    county_weights: {
      30067: 100,
    },
    county_names_all: "Park",
    county_fips_all: 30067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59066,
    lat: 45.33907,
    lng: -108.49718,
    city: "Pryor",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 594,
    density: 0.8,
    county_fips: 30003,
    county_name: "Big Horn",
    county_weights: {
      30003: 100,
    },
    county_names_all: "Big Horn",
    county_fips_all: 30003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59067,
    lat: 45.96827,
    lng: -109.23433,
    city: "Rapelje",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 262,
    density: 0.3,
    county_fips: 30095,
    county_name: "Stillwater",
    county_weights: {
      30095: 100,
    },
    county_names_all: "Stillwater",
    county_fips_all: 30095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59068,
    lat: 45.15929,
    lng: -109.45626,
    city: "Red Lodge",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3178,
    density: 2.4,
    county_fips: 30009,
    county_name: "Carbon",
    county_weights: {
      30009: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 30009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59069,
    lat: 45.72204,
    lng: -109.57945,
    city: "Reed Point",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 517,
    density: 0.5,
    county_fips: 30095,
    county_name: "Stillwater",
    county_weights: {
      30095: 50.66,
      30097: 49.34,
    },
    county_names_all: "Stillwater|Sweet Grass",
    county_fips_all: "30095|30097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59070,
    lat: 45.36289,
    lng: -109.17961,
    city: "Roberts",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1163,
    density: 2.5,
    county_fips: 30009,
    county_name: "Carbon",
    county_weights: {
      30009: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 30009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59071,
    lat: 45.26582,
    lng: -109.57003,
    city: "Roscoe",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 160,
    density: 0.7,
    county_fips: 30009,
    county_name: "Carbon",
    county_weights: {
      30009: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 30009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59072,
    lat: 46.51839,
    lng: -108.54969,
    city: "Roundup",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4249,
    density: 1.3,
    county_fips: 30065,
    county_name: "Musselshell",
    county_weights: {
      30065: 93.07,
      30069: 6.93,
    },
    county_names_all: "Musselshell|Petroleum",
    county_fips_all: "30065|30069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59074,
    lat: 46.36062,
    lng: -109.30181,
    city: "Ryegate",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 430,
    density: 0.3,
    county_fips: 30037,
    county_name: "Golden Valley",
    county_weights: {
      30037: 91.48,
      30095: 6.76,
      30107: 1.76,
    },
    county_names_all: "Golden Valley|Stillwater|Wheatland",
    county_fips_all: "30037|30095|30107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59075,
    lat: 45.40457,
    lng: -107.85051,
    city: "Saint Xavier",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 297,
    density: 0.6,
    county_fips: 30003,
    county_name: "Big Horn",
    county_weights: {
      30003: 100,
    },
    county_names_all: "Big Horn",
    county_fips_all: 30003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59076,
    lat: 46.28252,
    lng: -107.06847,
    city: "Sanders",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48,
    density: 1.3,
    county_fips: 30103,
    county_name: "Treasure",
    county_weights: {
      30103: 100,
    },
    county_names_all: "Treasure",
    county_fips_all: 30103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59077,
    lat: 47.22224,
    lng: -107.58999,
    city: "Sand Springs",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 103,
    density: 0.1,
    county_fips: 30033,
    county_name: "Garfield",
    county_weights: {
      30033: 100,
    },
    county_names_all: "Garfield",
    county_fips_all: 30033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59078,
    lat: 46.32585,
    lng: -109.5442,
    city: "Shawmut",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 167,
    density: 0.2,
    county_fips: 30107,
    county_name: "Wheatland",
    county_weights: {
      30037: 22.1,
      30097: 8.09,
      30107: 69.81,
    },
    county_names_all: "Wheatland|Golden Valley|Sweet Grass",
    county_fips_all: "30107|30037|30097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59079,
    lat: 46.0607,
    lng: -108.36718,
    city: "Shepherd",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3632,
    density: 4.2,
    county_fips: 30111,
    county_name: "Yellowstone",
    county_weights: {
      30111: 100,
    },
    county_names_all: "Yellowstone",
    county_fips_all: 30111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59081,
    lat: 45.01979,
    lng: -109.98295,
    city: "Silver Gate",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 82,
    density: 7.3,
    county_fips: 30067,
    county_name: "Park",
    county_weights: {
      30067: 100,
    },
    county_names_all: "Park",
    county_fips_all: 30067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59082,
    lat: 45.84041,
    lng: -110.29227,
    city: "Springdale",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 30067,
    county_name: "Park",
    county_weights: {
      30067: 65.8,
      30097: 34.2,
    },
    county_names_all: "Park|Sweet Grass",
    county_fips_all: "30067|30097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59083,
    lat: 46.55133,
    lng: -107.56312,
    city: "Sumatra",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 30087,
    county_name: "Rosebud",
    county_weights: {
      30087: 100,
    },
    county_names_all: "Rosebud",
    county_fips_all: 30087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59085,
    lat: 46.36172,
    lng: -110.14019,
    city: "Two Dot",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 199,
    density: 0.3,
    county_fips: 30107,
    county_name: "Wheatland",
    county_weights: {
      30107: 100,
    },
    county_names_all: "Wheatland",
    county_fips_all: 30107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59086,
    lat: 46.05608,
    lng: -110.65293,
    city: "Wilsall",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 832,
    density: 0.5,
    county_fips: 30067,
    county_name: "Park",
    county_weights: {
      30031: 31.45,
      30059: 2.27,
      30067: 66.28,
    },
    county_names_all: "Park|Gallatin|Meagher",
    county_fips_all: "30067|30031|30059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59087,
    lat: 47.16806,
    lng: -108.22779,
    city: "Winnett",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 396,
    density: 0.1,
    county_fips: 30069,
    county_name: "Petroleum",
    county_weights: {
      30069: 100,
    },
    county_names_all: "Petroleum",
    county_fips_all: 30069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59088,
    lat: 46.13006,
    lng: -108.02933,
    city: "Worden",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1168,
    density: 1.3,
    county_fips: 30111,
    county_name: "Yellowstone",
    county_weights: {
      30111: 100,
    },
    county_names_all: "Yellowstone",
    county_fips_all: 30111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59089,
    lat: 45.09259,
    lng: -107.34476,
    city: "Wyola",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 495,
    density: 0.8,
    county_fips: 30003,
    county_name: "Big Horn",
    county_weights: {
      30003: 100,
    },
    county_names_all: "Big Horn",
    county_fips_all: 30003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59101,
    lat: 45.63013,
    lng: -108.36445,
    city: "Billings",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41048,
    density: 26.8,
    county_fips: 30111,
    county_name: "Yellowstone",
    county_weights: {
      30003: 2.29,
      30111: 97.71,
    },
    county_names_all: "Yellowstone|Big Horn",
    county_fips_all: "30111|30003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59102,
    lat: 45.77479,
    lng: -108.58133,
    city: "Billings",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45549,
    density: 1169.5,
    county_fips: 30111,
    county_name: "Yellowstone",
    county_weights: {
      30111: 100,
    },
    county_names_all: "Yellowstone",
    county_fips_all: 30111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59105,
    lat: 45.87708,
    lng: -108.50145,
    city: "Billings",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32168,
    density: 129.6,
    county_fips: 30111,
    county_name: "Yellowstone",
    county_weights: {
      30111: 100,
    },
    county_names_all: "Yellowstone",
    county_fips_all: 30111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59106,
    lat: 45.80637,
    lng: -108.6948,
    city: "Billings",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19170,
    density: 66.1,
    county_fips: 30111,
    county_name: "Yellowstone",
    county_weights: {
      30111: 100,
    },
    county_names_all: "Yellowstone",
    county_fips_all: 30111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59201,
    lat: 48.15981,
    lng: -105.64647,
    city: "Wolf Point",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5745,
    density: 1.7,
    county_fips: 30085,
    county_name: "Roosevelt",
    county_weights: {
      30055: 37.76,
      30085: 54.22,
      30105: 8.02,
    },
    county_names_all: "Roosevelt|McCone|Valley",
    county_fips_all: "30085|30055|30105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59211,
    lat: 48.69582,
    lng: -104.35493,
    city: "Antelope",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 259,
    density: 1,
    county_fips: 30091,
    county_name: "Sheridan",
    county_weights: {
      30091: 100,
    },
    county_names_all: "Sheridan",
    county_fips_all: 30091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59212,
    lat: 48.19231,
    lng: -104.16968,
    city: "Bainville",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 383,
    density: 0.5,
    county_fips: 30085,
    county_name: "Roosevelt",
    county_weights: {
      30085: 100,
    },
    county_names_all: "Roosevelt",
    county_fips_all: 30085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59213,
    lat: 48.17553,
    lng: -104.85612,
    city: "Brockton",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 778,
    density: 0.8,
    county_fips: 30085,
    county_name: "Roosevelt",
    county_weights: {
      30083: 43.38,
      30085: 56.62,
    },
    county_names_all: "Roosevelt|Richland",
    county_fips_all: "30085|30083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59214,
    lat: 47.28325,
    lng: -106.02221,
    city: "Brockway",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 76,
    density: 0.1,
    county_fips: 30055,
    county_name: "McCone",
    county_weights: {
      30033: 5.06,
      30055: 83.91,
      30079: 11.03,
    },
    county_names_all: "McCone|Prairie|Garfield",
    county_fips_all: "30055|30079|30033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59215,
    lat: 47.50431,
    lng: -105.74543,
    city: "Circle",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 973,
    density: 0.3,
    county_fips: 30055,
    county_name: "McCone",
    county_weights: {
      30021: 9.05,
      30055: 90.95,
    },
    county_names_all: "McCone|Dawson",
    county_fips_all: "30055|30021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59217,
    lat: 47.58449,
    lng: -104.24455,
    city: "Crane",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 237,
    density: 24.9,
    county_fips: 30083,
    county_name: "Richland",
    county_weights: {
      30083: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 30083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59218,
    lat: 48.09993,
    lng: -104.52361,
    city: "Culbertson",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 932,
    density: 0.9,
    county_fips: 30085,
    county_name: "Roosevelt",
    county_weights: {
      30083: 49.84,
      30085: 50.16,
    },
    county_names_all: "Roosevelt|Richland",
    county_fips_all: "30085|30083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59219,
    lat: 48.5579,
    lng: -104.15541,
    city: "Dagmar",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 302,
    density: 0.6,
    county_fips: 30091,
    county_name: "Sheridan",
    county_weights: {
      30091: 100,
    },
    county_names_all: "Sheridan",
    county_fips_all: 30091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59221,
    lat: 47.91952,
    lng: -104.1816,
    city: "Fairview",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1927,
    density: 2.8,
    county_fips: 30083,
    county_name: "Richland",
    county_weights: {
      30083: 84.02,
      38053: 15.98,
    },
    county_names_all: "Richland|McKenzie",
    county_fips_all: "30083|38053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59222,
    lat: 48.7007,
    lng: -105.1557,
    city: "Flaxville",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 191,
    density: 0.3,
    county_fips: 30019,
    county_name: "Daniels",
    county_weights: {
      30019: 98.41,
      30085: 1.59,
    },
    county_names_all: "Daniels|Roosevelt",
    county_fips_all: "30019|30085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59223,
    lat: 47.90319,
    lng: -106.19348,
    city: "Fort Peck",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 362,
    density: 0.5,
    county_fips: 30055,
    county_name: "McCone",
    county_weights: {
      30033: 8.68,
      30055: 88.84,
      30105: 2.48,
    },
    county_names_all: "McCone|Garfield|Valley",
    county_fips_all: "30055|30033|30105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59225,
    lat: 48.27723,
    lng: -105.97413,
    city: "Frazer",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 617,
    density: 0.7,
    county_fips: 30105,
    county_name: "Valley",
    county_weights: {
      30105: 100,
    },
    county_names_all: "Valley",
    county_fips_all: 30105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59226,
    lat: 48.34283,
    lng: -104.51545,
    city: "Froid",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 744,
    density: 0.9,
    county_fips: 30085,
    county_name: "Roosevelt",
    county_weights: {
      30085: 86.95,
      30091: 13.05,
    },
    county_names_all: "Roosevelt|Sheridan",
    county_fips_all: "30085|30091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59230,
    lat: 48.09992,
    lng: -106.80196,
    city: "Glasgow",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4483,
    density: 1.2,
    county_fips: 30105,
    county_name: "Valley",
    county_weights: {
      30105: 100,
    },
    county_names_all: "Valley",
    county_fips_all: 30105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59231,
    lat: 48.40395,
    lng: -106.54411,
    city: "Saint Marie",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 325,
    density: 225.9,
    county_fips: 30105,
    county_name: "Valley",
    county_weights: {
      30105: 100,
    },
    county_names_all: "Valley",
    county_fips_all: 30105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59240,
    lat: 48.84222,
    lng: -106.24046,
    city: "Glentana",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13,
    density: 0.1,
    county_fips: 30105,
    county_name: "Valley",
    county_weights: {
      30105: 100,
    },
    county_names_all: "Valley",
    county_fips_all: 30105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59241,
    lat: 48.46125,
    lng: -107.04602,
    city: "Hinsdale",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 420,
    density: 0.1,
    county_fips: 30105,
    county_name: "Valley",
    county_weights: {
      30105: 100,
    },
    county_names_all: "Valley",
    county_fips_all: 30105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59242,
    lat: 48.4387,
    lng: -104.55787,
    city: "Homestead",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 77,
    density: 0.3,
    county_fips: 30091,
    county_name: "Sheridan",
    county_weights: {
      30085: 35.71,
      30091: 64.29,
    },
    county_names_all: "Sheridan|Roosevelt",
    county_fips_all: "30091|30085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59243,
    lat: 47.76062,
    lng: -104.67387,
    city: "Lambert",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 258,
    density: 0.3,
    county_fips: 30083,
    county_name: "Richland",
    county_weights: {
      30083: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 30083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59244,
    lat: 48.62832,
    lng: -106.30945,
    city: "Larslan",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21,
    density: 0,
    county_fips: 30105,
    county_name: "Valley",
    county_weights: {
      30105: 100,
    },
    county_names_all: "Valley",
    county_fips_all: 30105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59247,
    lat: 48.51848,
    lng: -104.52209,
    city: "Medicine Lake",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 252,
    density: 0.7,
    county_fips: 30091,
    county_name: "Sheridan",
    county_weights: {
      30091: 100,
    },
    county_names_all: "Sheridan",
    county_fips_all: 30091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59248,
    lat: 48.27555,
    lng: -106.25841,
    city: "Nashua",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 766,
    density: 0.5,
    county_fips: 30105,
    county_name: "Valley",
    county_weights: {
      30105: 100,
    },
    county_names_all: "Valley",
    county_fips_all: 30105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59250,
    lat: 48.86715,
    lng: -106.63905,
    city: "Opheim",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 194,
    density: 0.2,
    county_fips: 30105,
    county_name: "Valley",
    county_weights: {
      30105: 100,
    },
    county_names_all: "Valley",
    county_fips_all: 30105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59252,
    lat: 48.92728,
    lng: -104.82152,
    city: "Outlook",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 96,
    density: 0.2,
    county_fips: 30091,
    county_name: "Sheridan",
    county_weights: {
      30091: 100,
    },
    county_names_all: "Sheridan",
    county_fips_all: 30091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59253,
    lat: 48.70422,
    lng: -105.83496,
    city: "Peerless",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 90,
    density: 0.1,
    county_fips: 30019,
    county_name: "Daniels",
    county_weights: {
      30019: 98.03,
      30105: 1.97,
    },
    county_names_all: "Daniels|Valley",
    county_fips_all: "30019|30105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59254,
    lat: 48.75753,
    lng: -104.61123,
    city: "Plentywood",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1739,
    density: 2.4,
    county_fips: 30091,
    county_name: "Sheridan",
    county_weights: {
      30091: 100,
    },
    county_names_all: "Sheridan",
    county_fips_all: 30091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59255,
    lat: 48.23115,
    lng: -105.16825,
    city: "Poplar",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3209,
    density: 1.8,
    county_fips: 30085,
    county_name: "Roosevelt",
    county_weights: {
      30055: 3.01,
      30083: 19.44,
      30085: 77.55,
    },
    county_names_all: "Roosevelt|Richland|McCone",
    county_fips_all: "30085|30083|30055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59256,
    lat: 48.91919,
    lng: -104.54965,
    city: "Raymond",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52,
    density: 0.3,
    county_fips: 30091,
    county_name: "Sheridan",
    county_weights: {
      30091: 100,
    },
    county_names_all: "Sheridan",
    county_fips_all: 30091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59257,
    lat: 48.75364,
    lng: -104.94239,
    city: "Redstone",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 82,
    density: 0.2,
    county_fips: 30091,
    county_name: "Sheridan",
    county_weights: {
      30091: 100,
    },
    county_names_all: "Sheridan",
    county_fips_all: 30091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59258,
    lat: 48.57025,
    lng: -104.735,
    city: "Reserve",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 143,
    density: 0.2,
    county_fips: 30091,
    county_name: "Sheridan",
    county_weights: {
      30085: 35.58,
      30091: 64.42,
    },
    county_names_all: "Sheridan|Roosevelt",
    county_fips_all: "30091|30085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59259,
    lat: 47.69109,
    lng: -105.08416,
    city: "Richey",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 239,
    density: 0.1,
    county_fips: 30021,
    county_name: "Dawson",
    county_weights: {
      30021: 54.37,
      30083: 45.63,
    },
    county_names_all: "Dawson|Richland",
    county_fips_all: "30021|30083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59260,
    lat: 48.84027,
    lng: -106.10217,
    city: "Richland",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 86,
    density: 0.1,
    county_fips: 30105,
    county_name: "Valley",
    county_weights: {
      30019: 39.18,
      30105: 60.82,
    },
    county_names_all: "Valley|Daniels",
    county_fips_all: "30105|30019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59261,
    lat: 48.53327,
    lng: -107.3599,
    city: "Saco",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 551,
    density: 0.3,
    county_fips: 30071,
    county_name: "Phillips",
    county_weights: {
      30071: 79.05,
      30105: 20.95,
    },
    county_names_all: "Phillips|Valley",
    county_fips_all: "30071|30105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59262,
    lat: 47.49341,
    lng: -104.50518,
    city: "Savage",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 503,
    density: 0.6,
    county_fips: 30083,
    county_name: "Richland",
    county_weights: {
      30021: 42.51,
      30083: 57.49,
    },
    county_names_all: "Richland|Dawson",
    county_fips_all: "30083|30021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59263,
    lat: 48.78921,
    lng: -105.51838,
    city: "Scobey",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1378,
    density: 0.9,
    county_fips: 30019,
    county_name: "Daniels",
    county_weights: {
      30019: 98.01,
      30085: 1.99,
    },
    county_names_all: "Daniels|Roosevelt",
    county_fips_all: "30019|30085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59270,
    lat: 47.57233,
    lng: -104.08264,
    city: "Sidney",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8664,
    density: 3.8,
    county_fips: 30083,
    county_name: "Richland",
    county_weights: {
      30083: 60.71,
      38053: 39.29,
    },
    county_names_all: "Richland|McKenzie",
    county_fips_all: "30083|38053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59273,
    lat: 48.29491,
    lng: -106.93589,
    city: "Vandalia",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 30105,
    county_name: "Valley",
    county_weights: {
      30105: 100,
    },
    county_names_all: "Valley",
    county_fips_all: 30105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59274,
    lat: 47.83944,
    lng: -105.42204,
    city: "Vida",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 297,
    density: 0.4,
    county_fips: 30055,
    county_name: "McCone",
    county_weights: {
      30055: 100,
    },
    county_names_all: "McCone",
    county_fips_all: 30055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59275,
    lat: 48.87415,
    lng: -104.17865,
    city: "Westby",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 460,
    density: 0.5,
    county_fips: 30091,
    county_name: "Sheridan",
    county_weights: {
      30091: 75.76,
      38023: 24.24,
    },
    county_names_all: "Sheridan|Divide",
    county_fips_all: "30091|38023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59276,
    lat: 48.92979,
    lng: -105.20108,
    city: "Whitetail",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28,
    density: 0.1,
    county_fips: 30019,
    county_name: "Daniels",
    county_weights: {
      30019: 100,
    },
    county_names_all: "Daniels",
    county_fips_all: 30019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59301,
    lat: 46.36022,
    lng: -105.85055,
    city: "Miles City",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11212,
    density: 1.5,
    county_fips: 30017,
    county_name: "Custer",
    county_weights: {
      30017: 81.2,
      30033: 5.1,
      30075: 2.26,
      30079: 1.38,
      30087: 10.06,
    },
    county_names_all: "Custer|Rosebud|Garfield|Powder River|Prairie",
    county_fips_all: "30017|30087|30033|30075|30079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59311,
    lat: 45.16944,
    lng: -104.53017,
    city: "Alzada",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 148,
    density: 0.1,
    county_fips: 30011,
    county_name: "Carter",
    county_weights: {
      30011: 100,
    },
    county_names_all: "Carter",
    county_fips_all: 30011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59312,
    lat: 47.0541,
    lng: -106.26872,
    city: "Angela",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28,
    density: 0,
    county_fips: 30033,
    county_name: "Garfield",
    county_weights: {
      30033: 100,
    },
    county_names_all: "Garfield",
    county_fips_all: 30033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59313,
    lat: 46.27497,
    lng: -104.25016,
    city: "Baker",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2427,
    density: 1,
    county_fips: 30025,
    county_name: "Fallon",
    county_weights: {
      30011: 6.37,
      30025: 93.63,
    },
    county_names_all: "Fallon|Carter",
    county_fips_all: "30025|30011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59314,
    lat: 45.07847,
    lng: -105.43933,
    city: "Biddle",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 89,
    density: 0.1,
    county_fips: 30075,
    county_name: "Powder River",
    county_weights: {
      30075: 100,
    },
    county_names_all: "Powder River",
    county_fips_all: 30075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59315,
    lat: 47.44241,
    lng: -104.87483,
    city: "Bloomfield",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57,
    density: 0.1,
    county_fips: 30021,
    county_name: "Dawson",
    county_weights: {
      30021: 100,
    },
    county_names_all: "Dawson",
    county_fips_all: 30021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59316,
    lat: 45.33726,
    lng: -105.04973,
    city: "Boyes",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 30075,
    county_name: "Powder River",
    county_weights: {
      30011: 29.67,
      30075: 70.33,
    },
    county_names_all: "Powder River|Carter",
    county_fips_all: "30075|30011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59317,
    lat: 45.33477,
    lng: -105.52106,
    city: "Broadus",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1144,
    density: 0.3,
    county_fips: 30075,
    county_name: "Powder River",
    county_weights: {
      30075: 100,
    },
    county_names_all: "Powder River",
    county_fips_all: 30075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59318,
    lat: 47.48955,
    lng: -107.4784,
    city: "Brusett",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 121,
    density: 0.1,
    county_fips: 30033,
    county_name: "Garfield",
    county_weights: {
      30033: 100,
    },
    county_names_all: "Garfield",
    county_fips_all: 30033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59319,
    lat: 45.40696,
    lng: -104.17379,
    city: "Capitol",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 30011,
    county_name: "Carter",
    county_weights: {
      30011: 100,
    },
    county_names_all: "Carter",
    county_fips_all: 30011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59322,
    lat: 47.03521,
    lng: -106.64069,
    city: "Cohagen",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59,
    density: 0,
    county_fips: 30033,
    county_name: "Garfield",
    county_weights: {
      30033: 100,
    },
    county_names_all: "Garfield",
    county_fips_all: 30033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59323,
    lat: 45.91234,
    lng: -106.7032,
    city: "Colstrip",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2375,
    density: 17.2,
    county_fips: 30087,
    county_name: "Rosebud",
    county_weights: {
      30087: 100,
    },
    county_names_all: "Rosebud",
    county_fips_all: 30087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59324,
    lat: 45.76652,
    lng: -104.58732,
    city: "Ekalaka",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 926,
    density: 0.3,
    county_fips: 30011,
    county_name: "Carter",
    county_weights: {
      30011: 100,
    },
    county_names_all: "Carter",
    county_fips_all: 30011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59326,
    lat: 46.77178,
    lng: -104.85183,
    city: "Fallon",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 308,
    density: 0.3,
    county_fips: 30079,
    county_name: "Prairie",
    county_weights: {
      30021: 12.63,
      30079: 87.37,
    },
    county_names_all: "Prairie|Dawson",
    county_fips_all: "30079|30021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59327,
    lat: 46.2389,
    lng: -106.7082,
    city: "Forsyth",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2619,
    density: 0.5,
    county_fips: 30087,
    county_name: "Rosebud",
    county_weights: {
      30087: 100,
    },
    county_names_all: "Rosebud",
    county_fips_all: 30087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59330,
    lat: 47.11812,
    lng: -104.76469,
    city: "Glendive",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8401,
    density: 3.2,
    county_fips: 30021,
    county_name: "Dawson",
    county_weights: {
      30021: 96.85,
      30079: 3.15,
    },
    county_names_all: "Dawson|Prairie",
    county_fips_all: "30021|30079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59332,
    lat: 45.37589,
    lng: -104.72542,
    city: "Hammond",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 203,
    density: 0.2,
    county_fips: 30011,
    county_name: "Carter",
    county_weights: {
      30011: 100,
    },
    county_names_all: "Carter",
    county_fips_all: 30011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59333,
    lat: 46.28123,
    lng: -106.24765,
    city: "Hathaway",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6,
    density: 0.3,
    county_fips: 30087,
    county_name: "Rosebud",
    county_weights: {
      30087: 100,
    },
    county_names_all: "Rosebud",
    county_fips_all: 30087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59336,
    lat: 46.342,
    lng: -104.95063,
    city: "Ismay",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 213,
    density: 0.1,
    county_fips: 30017,
    county_name: "Custer",
    county_weights: {
      30011: 5.66,
      30017: 65.46,
      30025: 28.19,
      30079: 0.69,
    },
    county_names_all: "Custer|Fallon|Carter|Prairie",
    county_fips_all: "30017|30025|30011|30079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59337,
    lat: 47.39098,
    lng: -106.81486,
    city: "Jordan",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 711,
    density: 0.1,
    county_fips: 30033,
    county_name: "Garfield",
    county_weights: {
      30033: 100,
    },
    county_names_all: "Garfield",
    county_fips_all: 30033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59338,
    lat: 46.63392,
    lng: -105.65584,
    city: "Kinsey",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 136,
    density: 0.7,
    county_fips: 30017,
    county_name: "Custer",
    county_weights: {
      30017: 100,
    },
    county_names_all: "Custer",
    county_fips_all: 30017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59339,
    lat: 47.22587,
    lng: -105.19934,
    city: "Lindsay",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 114,
    density: 0.1,
    county_fips: 30021,
    county_name: "Dawson",
    county_weights: {
      30021: 98.9,
      30079: 1.1,
    },
    county_names_all: "Dawson|Prairie",
    county_fips_all: "30021|30079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59343,
    lat: 45.65602,
    lng: -105.43296,
    city: "Olive",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31,
    density: 0.1,
    county_fips: 30075,
    county_name: "Powder River",
    county_weights: {
      30075: 100,
    },
    county_names_all: "Powder River",
    county_fips_all: 30075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59344,
    lat: 46.3516,
    lng: -104.5713,
    city: "Plevna",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 446,
    density: 0.4,
    county_fips: 30025,
    county_name: "Fallon",
    county_weights: {
      30011: 6.02,
      30025: 93.98,
    },
    county_names_all: "Fallon|Carter",
    county_fips_all: "30025|30011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59345,
    lat: 45.85367,
    lng: -105.20436,
    city: "Powderville",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 30017,
    county_name: "Custer",
    county_weights: {
      30017: 68.17,
      30075: 31.83,
    },
    county_names_all: "Custer|Powder River",
    county_fips_all: "30017|30075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59347,
    lat: 46.45434,
    lng: -106.34614,
    city: "Rosebud",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 298,
    density: 0.1,
    county_fips: 30087,
    county_name: "Rosebud",
    county_weights: {
      30017: 7.57,
      30087: 92.43,
    },
    county_names_all: "Rosebud|Custer",
    county_fips_all: "30087|30017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59349,
    lat: 46.87278,
    lng: -105.48388,
    city: "Terry",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 875,
    density: 0.3,
    county_fips: 30079,
    county_name: "Prairie",
    county_weights: {
      30017: 1.37,
      30079: 98.63,
    },
    county_names_all: "Prairie|Custer",
    county_fips_all: "30079|30017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59351,
    lat: 45.7633,
    lng: -105.70844,
    city: "Volborg",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 165,
    density: 0.1,
    county_fips: 30075,
    county_name: "Powder River",
    county_weights: {
      30017: 39.62,
      30075: 60.38,
    },
    county_names_all: "Powder River|Custer",
    county_fips_all: "30075|30017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59353,
    lat: 46.96394,
    lng: -104.28218,
    city: "Wibaux",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1037,
    density: 0.4,
    county_fips: 30109,
    county_name: "Wibaux",
    county_weights: {
      30021: 13.92,
      30025: 2.17,
      30109: 83.91,
    },
    county_names_all: "Wibaux|Dawson|Fallon",
    county_fips_all: "30109|30021|30025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59354,
    lat: 46.18924,
    lng: -104.41939,
    city: "Willard",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33,
    density: 0.2,
    county_fips: 30025,
    county_name: "Fallon",
    county_weights: {
      30025: 100,
    },
    county_names_all: "Fallon",
    county_fips_all: 30025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59401,
    lat: 47.51083,
    lng: -111.27691,
    city: "Great Falls",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13410,
    density: 1748.1,
    county_fips: 30013,
    county_name: "Cascade",
    county_weights: {
      30013: 100,
    },
    county_names_all: "Cascade",
    county_fips_all: 30013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59404,
    lat: 47.63197,
    lng: -111.34807,
    city: "Great Falls",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27914,
    density: 32.5,
    county_fips: 30013,
    county_name: "Cascade",
    county_weights: {
      30013: 71.68,
      30015: 28.32,
    },
    county_names_all: "Cascade|Chouteau",
    county_fips_all: "30013|30015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59405,
    lat: 47.28102,
    lng: -111.25937,
    city: "Great Falls",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31745,
    density: 25.6,
    county_fips: 30013,
    county_name: "Cascade",
    county_weights: {
      30013: 98.85,
      30015: 1.15,
    },
    county_names_all: "Cascade|Chouteau",
    county_fips_all: "30013|30015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59410,
    lat: 47.49442,
    lng: -112.64299,
    city: "Augusta",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 519,
    density: 0.2,
    county_fips: 30049,
    county_name: "Lewis and Clark",
    county_weights: {
      30049: 97.51,
      30099: 2.49,
    },
    county_names_all: "Lewis and Clark|Teton",
    county_fips_all: "30049|30099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59411,
    lat: 48.88965,
    lng: -113.41403,
    city: "Babb",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1188,
    density: 2.1,
    county_fips: 30035,
    county_name: "Glacier",
    county_weights: {
      30035: 100,
    },
    county_names_all: "Glacier",
    county_fips_all: 30035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59412,
    lat: 47.32538,
    lng: -110.8762,
    city: "Belt",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1490,
    density: 1.5,
    county_fips: 30013,
    county_name: "Cascade",
    county_weights: {
      30013: 96.88,
      30045: 3.12,
    },
    county_names_all: "Cascade|Judith Basin",
    county_fips_all: "30013|30045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59414,
    lat: 47.5276,
    lng: -111.26871,
    city: "Black Eagle",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 836,
    density: 185.1,
    county_fips: 30013,
    county_name: "Cascade",
    county_weights: {
      30013: 100,
    },
    county_names_all: "Cascade",
    county_fips_all: 30013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59416,
    lat: 48.04059,
    lng: -111.52359,
    city: "Brady",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 268,
    density: 0.3,
    county_fips: 30073,
    county_name: "Pondera",
    county_weights: {
      30015: 41.1,
      30051: 1.13,
      30073: 56.26,
      30099: 1.51,
    },
    county_names_all: "Pondera|Chouteau|Teton|Liberty",
    county_fips_all: "30073|30015|30099|30051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59417,
    lat: 48.54483,
    lng: -113.0086,
    city: "Browning",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7680,
    density: 3.9,
    county_fips: 30035,
    county_name: "Glacier",
    county_weights: {
      30035: 100,
    },
    county_names_all: "Glacier",
    county_fips_all: 30035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59418,
    lat: 46.80258,
    lng: -109.87849,
    city: "Buffalo",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65,
    density: 0.2,
    county_fips: 30045,
    county_name: "Judith Basin",
    county_weights: {
      30027: 23.14,
      30045: 76.86,
    },
    county_names_all: "Judith Basin|Fergus",
    county_fips_all: "30045|30027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59419,
    lat: 48.00641,
    lng: -112.40855,
    city: "Bynum",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 94,
    density: 0.4,
    county_fips: 30099,
    county_name: "Teton",
    county_weights: {
      30099: 100,
    },
    county_names_all: "Teton",
    county_fips_all: 30099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59420,
    lat: 47.89688,
    lng: -111.04034,
    city: "Carter",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 255,
    density: 0.4,
    county_fips: 30015,
    county_name: "Chouteau",
    county_weights: {
      30015: 100,
    },
    county_names_all: "Chouteau",
    county_fips_all: 30015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59421,
    lat: 47.20179,
    lng: -111.72,
    city: "Cascade",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1838,
    density: 1,
    county_fips: 30013,
    county_name: "Cascade",
    county_weights: {
      30013: 95.54,
      30049: 4.46,
    },
    county_names_all: "Cascade|Lewis and Clark",
    county_fips_all: "30013|30049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59422,
    lat: 47.83957,
    lng: -112.48266,
    city: "Choteau",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2718,
    density: 0.9,
    county_fips: 30099,
    county_name: "Teton",
    county_weights: {
      30099: 100,
    },
    county_names_all: "Teton",
    county_fips_all: 30099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59424,
    lat: 47.34929,
    lng: -110.1022,
    city: "Coffee Creek",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16,
    density: 0.1,
    county_fips: 30027,
    county_name: "Fergus",
    county_weights: {
      30027: 66.71,
      30045: 33.29,
    },
    county_names_all: "Fergus|Judith Basin",
    county_fips_all: "30027|30045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59425,
    lat: 48.18641,
    lng: -111.88738,
    city: "Conrad",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3616,
    density: 2.5,
    county_fips: 30073,
    county_name: "Pondera",
    county_weights: {
      30073: 91.09,
      30099: 8.91,
    },
    county_names_all: "Pondera|Teton",
    county_fips_all: "30073|30099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59427,
    lat: 48.77357,
    lng: -112.61639,
    city: "Cut Bank",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4417,
    density: 1.2,
    county_fips: 30035,
    county_name: "Glacier",
    county_weights: {
      30035: 97.28,
      30101: 2.72,
    },
    county_names_all: "Glacier|Toole",
    county_fips_all: "30035|30101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59430,
    lat: 47.43089,
    lng: -109.83434,
    city: "Denton",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 448,
    density: 0.3,
    county_fips: 30027,
    county_name: "Fergus",
    county_weights: {
      30027: 94.67,
      30045: 5.33,
    },
    county_names_all: "Fergus|Judith Basin",
    county_fips_all: "30027|30045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59432,
    lat: 48.14595,
    lng: -112.58853,
    city: "Dupuyer",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 114,
    density: 0.2,
    county_fips: 30073,
    county_name: "Pondera",
    county_weights: {
      30073: 73.19,
      30099: 26.81,
    },
    county_names_all: "Pondera|Teton",
    county_fips_all: "30073|30099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59433,
    lat: 47.89565,
    lng: -111.68483,
    city: "Dutton",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 484,
    density: 0.6,
    county_fips: 30099,
    county_name: "Teton",
    county_weights: {
      30073: 0.35,
      30099: 99.65,
    },
    county_names_all: "Teton|Pondera",
    county_fips_all: "30099|30073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59434,
    lat: 48.68682,
    lng: -113.55678,
    city: "East Glacier Park",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 421,
    density: 0.2,
    county_fips: 30035,
    county_name: "Glacier",
    county_weights: {
      30035: 100,
    },
    county_names_all: "Glacier",
    county_fips_all: 30035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59435,
    lat: 48.5616,
    lng: -112.06059,
    city: "Ethridge",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 30101,
    county_name: "Toole",
    county_weights: {
      30101: 100,
    },
    county_names_all: "Toole",
    county_fips_all: 30101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59436,
    lat: 47.6135,
    lng: -112.0907,
    city: "Fairfield",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2045,
    density: 3.2,
    county_fips: 30099,
    county_name: "Teton",
    county_weights: {
      30013: 0.42,
      30099: 99.58,
    },
    county_names_all: "Teton|Cascade",
    county_fips_all: "30099|30013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59440,
    lat: 47.72489,
    lng: -111.14261,
    city: "Floweree",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 221,
    density: 0.4,
    county_fips: 30015,
    county_name: "Chouteau",
    county_weights: {
      30013: 32.48,
      30015: 67.52,
    },
    county_names_all: "Chouteau|Cascade",
    county_fips_all: "30015|30013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59441,
    lat: 46.852,
    lng: -108.98933,
    city: "Forest Grove",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63,
    density: 0.1,
    county_fips: 30027,
    county_name: "Fergus",
    county_weights: {
      30027: 100,
    },
    county_names_all: "Fergus",
    county_fips_all: 30027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59442,
    lat: 47.93005,
    lng: -110.64697,
    city: "Fort Benton",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1742,
    density: 0.9,
    county_fips: 30015,
    county_name: "Chouteau",
    county_weights: {
      30015: 100,
    },
    county_names_all: "Chouteau",
    county_fips_all: 30015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59443,
    lat: 47.5621,
    lng: -111.82647,
    city: "Fort Shaw",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 383,
    density: 2.5,
    county_fips: 30013,
    county_name: "Cascade",
    county_weights: {
      30013: 93.54,
      30099: 6.46,
    },
    county_names_all: "Cascade|Teton",
    county_fips_all: "30013|30099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59444,
    lat: 48.65227,
    lng: -111.34881,
    city: "Galata",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 262,
    density: 0.2,
    county_fips: 30101,
    county_name: "Toole",
    county_weights: {
      30051: 19.5,
      30101: 80.5,
    },
    county_names_all: "Toole|Liberty",
    county_fips_all: "30101|30051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59446,
    lat: 47.64083,
    lng: -110.17894,
    city: "Geraldine",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 580,
    density: 0.3,
    county_fips: 30015,
    county_name: "Chouteau",
    county_weights: {
      30015: 100,
    },
    county_names_all: "Chouteau",
    county_fips_all: 30015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59447,
    lat: 47.28116,
    lng: -110.45955,
    city: "Geyser",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 271,
    density: 0.3,
    county_fips: 30045,
    county_name: "Judith Basin",
    county_weights: {
      30015: 3.01,
      30045: 96.99,
    },
    county_names_all: "Judith Basin|Chouteau",
    county_fips_all: "30045|30015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59448,
    lat: 48.25789,
    lng: -112.86703,
    city: "Heart Butte",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 775,
    density: 3.9,
    county_fips: 30073,
    county_name: "Pondera",
    county_weights: {
      30035: 0.86,
      30073: 99.14,
    },
    county_names_all: "Pondera|Glacier",
    county_fips_all: "30073|30035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59450,
    lat: 47.5992,
    lng: -110.73923,
    city: "Highwood",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 584,
    density: 0.6,
    county_fips: 30015,
    county_name: "Chouteau",
    county_weights: {
      30015: 100,
    },
    county_names_all: "Chouteau",
    county_fips_all: 30015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59451,
    lat: 47.38984,
    lng: -109.39779,
    city: "Hilger",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 127,
    density: 0.2,
    county_fips: 30027,
    county_name: "Fergus",
    county_weights: {
      30027: 100,
    },
    county_names_all: "Fergus",
    county_fips_all: 30027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59452,
    lat: 46.86946,
    lng: -110.09831,
    city: "Hobson",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 470,
    density: 0.5,
    county_fips: 30045,
    county_name: "Judith Basin",
    county_weights: {
      30045: 100,
    },
    county_names_all: "Judith Basin",
    county_fips_all: 30045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59453,
    lat: 46.65903,
    lng: -109.66996,
    city: "Judith Gap",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 301,
    density: 0.3,
    county_fips: 30107,
    county_name: "Wheatland",
    county_weights: {
      30027: 18.54,
      30045: 4.87,
      30107: 76.59,
    },
    county_names_all: "Wheatland|Fergus|Judith Basin",
    county_fips_all: "30107|30027|30045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59454,
    lat: 48.74481,
    lng: -111.97769,
    city: "Kevin",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 202,
    density: 0.7,
    county_fips: 30101,
    county_name: "Toole",
    county_weights: {
      30101: 100,
    },
    county_names_all: "Toole",
    county_fips_all: 30101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59456,
    lat: 48.27221,
    lng: -111.35432,
    city: "Ledger",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 175,
    density: 0.2,
    county_fips: 30051,
    county_name: "Liberty",
    county_weights: {
      30051: 52.28,
      30073: 9.37,
      30101: 38.35,
    },
    county_names_all: "Liberty|Toole|Pondera",
    county_fips_all: "30051|30101|30073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59457,
    lat: 47.08027,
    lng: -109.38656,
    city: "Lewistown",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9058,
    density: 3.5,
    county_fips: 30027,
    county_name: "Fergus",
    county_weights: {
      30027: 100,
    },
    county_names_all: "Fergus",
    county_fips_all: 30027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59460,
    lat: 48.07682,
    lng: -110.50908,
    city: "Loma",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 170,
    density: 0.3,
    county_fips: 30015,
    county_name: "Chouteau",
    county_weights: {
      30015: 100,
    },
    county_names_all: "Chouteau",
    county_fips_all: 30015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59461,
    lat: 48.4894,
    lng: -111.19985,
    city: "Lothair",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12,
    density: 0.1,
    county_fips: 30051,
    county_name: "Liberty",
    county_weights: {
      30051: 100,
    },
    county_names_all: "Liberty",
    county_fips_all: 30051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59462,
    lat: 47.10833,
    lng: -109.88513,
    city: "Moccasin",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 159,
    density: 0.5,
    county_fips: 30045,
    county_name: "Judith Basin",
    county_weights: {
      30045: 100,
    },
    county_names_all: "Judith Basin",
    county_fips_all: 30045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59463,
    lat: 47.0489,
    lng: -110.86668,
    city: "Monarch",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 97,
    density: 0.2,
    county_fips: 30013,
    county_name: "Cascade",
    county_weights: {
      30013: 94.01,
      30045: 5.99,
    },
    county_names_all: "Cascade|Judith Basin",
    county_fips_all: "30013|30045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59464,
    lat: 46.87409,
    lng: -109.60589,
    city: "Moore",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 418,
    density: 0.7,
    county_fips: 30027,
    county_name: "Fergus",
    county_weights: {
      30027: 94.58,
      30045: 5.42,
    },
    county_names_all: "Fergus|Judith Basin",
    county_fips_all: "30027|30045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59465,
    lat: 46.93777,
    lng: -110.70788,
    city: "Neihart",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35,
    density: 0.1,
    county_fips: 30013,
    county_name: "Cascade",
    county_weights: {
      30013: 100,
    },
    county_names_all: "Cascade",
    county_fips_all: 30013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59466,
    lat: 48.78746,
    lng: -111.69124,
    city: "Oilmont",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 109,
    density: 0.3,
    county_fips: 30101,
    county_name: "Toole",
    county_weights: {
      30101: 100,
    },
    county_names_all: "Toole",
    county_fips_all: 30101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59467,
    lat: 48.07149,
    lng: -112.37794,
    city: "Pendroy",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 107,
    density: 0.4,
    county_fips: 30099,
    county_name: "Teton",
    county_weights: {
      30099: 100,
    },
    county_names_all: "Teton",
    county_fips_all: 30099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59468,
    lat: 47.71253,
    lng: -111.62842,
    city: "Power",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 587,
    density: 0.9,
    county_fips: 30099,
    county_name: "Teton",
    county_weights: {
      30013: 28.77,
      30099: 71.23,
    },
    county_names_all: "Teton|Cascade",
    county_fips_all: "30099|30013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59469,
    lat: 47.19087,
    lng: -110.68378,
    city: "Raynesford",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 143,
    density: 0.5,
    county_fips: 30045,
    county_name: "Judith Basin",
    county_weights: {
      30045: 100,
    },
    county_names_all: "Judith Basin",
    county_fips_all: 30045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59471,
    lat: 47.4161,
    lng: -108.77191,
    city: "Roy",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 303,
    density: 0.1,
    county_fips: 30027,
    county_name: "Fergus",
    county_weights: {
      30027: 100,
    },
    county_names_all: "Fergus",
    county_fips_all: 30027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59472,
    lat: 47.37939,
    lng: -111.17095,
    city: "Sand Coulee",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 843,
    density: 5.9,
    county_fips: 30013,
    county_name: "Cascade",
    county_weights: {
      30013: 100,
    },
    county_names_all: "Cascade",
    county_fips_all: 30013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59474,
    lat: 48.53314,
    lng: -111.69254,
    city: "Shelby",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3286,
    density: 2.3,
    county_fips: 30101,
    county_name: "Toole",
    county_weights: {
      30101: 100,
    },
    county_names_all: "Toole",
    county_fips_all: 30101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59477,
    lat: 47.44467,
    lng: -111.97419,
    city: "Simms",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 390,
    density: 2.3,
    county_fips: 30013,
    county_name: "Cascade",
    county_weights: {
      30013: 100,
    },
    county_names_all: "Cascade",
    county_fips_all: 30013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59479,
    lat: 47.016,
    lng: -110.33696,
    city: "Stanford",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 766,
    density: 0.4,
    county_fips: 30045,
    county_name: "Judith Basin",
    county_weights: {
      30045: 100,
    },
    county_names_all: "Judith Basin",
    county_fips_all: 30045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59480,
    lat: 47.22696,
    lng: -111.12013,
    city: "Stockett",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 365,
    density: 1,
    county_fips: 30013,
    county_name: "Cascade",
    county_weights: {
      30013: 100,
    },
    county_names_all: "Cascade",
    county_fips_all: 30013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59482,
    lat: 48.88446,
    lng: -111.86622,
    city: "Sunburst",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 923,
    density: 1.7,
    county_fips: 30101,
    county_name: "Toole",
    county_weights: {
      30101: 100,
    },
    county_names_all: "Toole",
    county_fips_all: 30101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59483,
    lat: 47.47212,
    lng: -111.72261,
    city: "Sun River",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 621,
    density: 3,
    county_fips: 30013,
    county_name: "Cascade",
    county_weights: {
      30013: 100,
    },
    county_names_all: "Cascade",
    county_fips_all: 30013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59484,
    lat: 48.95074,
    lng: -111.76795,
    city: "Sweet Grass",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 101,
    density: 0.2,
    county_fips: 30101,
    county_name: "Toole",
    county_weights: {
      30101: 100,
    },
    county_names_all: "Toole",
    county_fips_all: 30101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59485,
    lat: 47.43264,
    lng: -111.56667,
    city: "Ulm",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 482,
    density: 3.3,
    county_fips: 30013,
    county_name: "Cascade",
    county_weights: {
      30013: 100,
    },
    county_names_all: "Cascade",
    county_fips_all: 30013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59486,
    lat: 48.33709,
    lng: -112.35552,
    city: "Valier",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1200,
    density: 0.9,
    county_fips: 30073,
    county_name: "Pondera",
    county_weights: {
      30073: 100,
    },
    county_names_all: "Pondera",
    county_fips_all: 30073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59487,
    lat: 47.58393,
    lng: -111.64592,
    city: "Vaughn",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1291,
    density: 9.1,
    county_fips: 30013,
    county_name: "Cascade",
    county_weights: {
      30013: 92.37,
      30099: 7.63,
    },
    county_names_all: "Cascade|Teton",
    county_fips_all: "30013|30099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59489,
    lat: 47.64007,
    lng: -109.25586,
    city: "Winifred",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 334,
    density: 0.2,
    county_fips: 30027,
    county_name: "Fergus",
    county_weights: {
      30027: 100,
    },
    county_names_all: "Fergus",
    county_fips_all: 30027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59501,
    lat: 48.69591,
    lng: -109.78556,
    city: "Havre",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12528,
    density: 3.6,
    county_fips: 30041,
    county_name: "Hill",
    county_weights: {
      30005: 4.26,
      30041: 95.74,
    },
    county_names_all: "Hill|Blaine",
    county_fips_all: "30041|30005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59520,
    lat: 48.03822,
    lng: -109.93749,
    city: "Big Sandy",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1093,
    density: 0.4,
    county_fips: 30015,
    county_name: "Chouteau",
    county_weights: {
      30005: 2.33,
      30015: 97.14,
      30041: 0.53,
    },
    county_names_all: "Chouteau|Blaine|Hill",
    county_fips_all: "30015|30005|30041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59521,
    lat: 48.30489,
    lng: -109.972,
    city: "Box Elder",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3863,
    density: 5.3,
    county_fips: 30041,
    county_name: "Hill",
    county_weights: {
      30015: 18.39,
      30041: 81.61,
    },
    county_names_all: "Hill|Chouteau",
    county_fips_all: "30041|30015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59522,
    lat: 48.56497,
    lng: -110.98827,
    city: "Chester",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1908,
    density: 0.9,
    county_fips: 30051,
    county_name: "Liberty",
    county_weights: {
      30051: 100,
    },
    county_names_all: "Liberty",
    county_fips_all: 30051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59523,
    lat: 48.52013,
    lng: -109.20829,
    city: "Chinook",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2034,
    density: 0.5,
    county_fips: 30005,
    county_name: "Blaine",
    county_weights: {
      30005: 98.86,
      30041: 1.14,
    },
    county_names_all: "Blaine|Hill",
    county_fips_all: "30005|30041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59524,
    lat: 48.12273,
    lng: -108.40374,
    city: "Dodson",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 808,
    density: 0.3,
    county_fips: 30071,
    county_name: "Phillips",
    county_weights: {
      30005: 11.91,
      30071: 88.09,
    },
    county_names_all: "Phillips|Blaine",
    county_fips_all: "30071|30005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59525,
    lat: 48.6524,
    lng: -110.27405,
    city: "Gildford",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 237,
    density: 0.3,
    county_fips: 30041,
    county_name: "Hill",
    county_weights: {
      30041: 100,
    },
    county_names_all: "Hill",
    county_fips_all: 30041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59526,
    lat: 48.4414,
    lng: -108.67155,
    city: "Harlem",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2675,
    density: 1.4,
    county_fips: 30005,
    county_name: "Blaine",
    county_weights: {
      30005: 100,
    },
    county_names_all: "Blaine",
    county_fips_all: 30005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59527,
    lat: 48.04527,
    lng: -108.74677,
    city: "Hays",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1041,
    density: 1.9,
    county_fips: 30005,
    county_name: "Blaine",
    county_weights: {
      30005: 100,
    },
    county_names_all: "Blaine",
    county_fips_all: 30005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59528,
    lat: 48.6233,
    lng: -110.42628,
    city: "Hingham",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 264,
    density: 0.5,
    county_fips: 30041,
    county_name: "Hill",
    county_weights: {
      30041: 100,
    },
    county_names_all: "Hill",
    county_fips_all: 30041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59529,
    lat: 48.79655,
    lng: -108.69059,
    city: "Hogeland",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 164,
    density: 0.2,
    county_fips: 30005,
    county_name: "Blaine",
    county_weights: {
      30005: 100,
    },
    county_names_all: "Blaine",
    county_fips_all: 30005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59530,
    lat: 48.60212,
    lng: -110.68802,
    city: "Inverness",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 125,
    density: 0.2,
    county_fips: 30041,
    county_name: "Hill",
    county_weights: {
      30041: 100,
    },
    county_names_all: "Hill",
    county_fips_all: 30041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59531,
    lat: 48.77294,
    lng: -110.78334,
    city: "Joplin",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 291,
    density: 0.4,
    county_fips: 30051,
    county_name: "Liberty",
    county_weights: {
      30041: 27.07,
      30051: 72.93,
    },
    county_names_all: "Liberty|Hill",
    county_fips_all: "30051|30041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59532,
    lat: 48.58837,
    lng: -110.08515,
    city: "Kremlin",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 115,
    density: 0.2,
    county_fips: 30041,
    county_name: "Hill",
    county_weights: {
      30041: 100,
    },
    county_names_all: "Hill",
    county_fips_all: 30041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59535,
    lat: 47.94123,
    lng: -109.26059,
    city: "Lloyd",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 80,
    density: 0.1,
    county_fips: 30005,
    county_name: "Blaine",
    county_weights: {
      30005: 100,
    },
    county_names_all: "Blaine",
    county_fips_all: 30005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59537,
    lat: 48.84762,
    lng: -107.93725,
    city: "Loring",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 70,
    density: 0.1,
    county_fips: 30071,
    county_name: "Phillips",
    county_weights: {
      30071: 100,
    },
    county_names_all: "Phillips",
    county_fips_all: 30071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59538,
    lat: 48.02231,
    lng: -107.8657,
    city: "Malta",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2779,
    density: 0.4,
    county_fips: 30071,
    county_name: "Phillips",
    county_weights: {
      30071: 100,
    },
    county_names_all: "Phillips",
    county_fips_all: 30071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59540,
    lat: 48.60665,
    lng: -110.56418,
    city: "Rudyard",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 343,
    density: 0.3,
    county_fips: 30041,
    county_name: "Hill",
    county_weights: {
      30015: 3.83,
      30041: 96.17,
    },
    county_names_all: "Hill|Chouteau",
    county_fips_all: "30041|30015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59542,
    lat: 48.81907,
    lng: -108.33693,
    city: "Turner",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 204,
    density: 0.1,
    county_fips: 30005,
    county_name: "Blaine",
    county_weights: {
      30005: 65.31,
      30071: 34.69,
    },
    county_names_all: "Blaine|Phillips",
    county_fips_all: "30005|30071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59544,
    lat: 48.81294,
    lng: -107.59147,
    city: "Whitewater",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 166,
    density: 0.1,
    county_fips: 30071,
    county_name: "Phillips",
    county_weights: {
      30071: 100,
    },
    county_names_all: "Phillips",
    county_fips_all: 30071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59545,
    lat: 48.94067,
    lng: -111.21768,
    city: "Whitlash",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48,
    density: 0.2,
    county_fips: 30051,
    county_name: "Liberty",
    county_weights: {
      30051: 67.98,
      30101: 32.02,
    },
    county_names_all: "Liberty|Toole",
    county_fips_all: "30051|30101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59546,
    lat: 47.88208,
    lng: -108.55654,
    city: "Zortman",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 135,
    density: 0.6,
    county_fips: 30071,
    county_name: "Phillips",
    county_weights: {
      30071: 100,
    },
    county_names_all: "Phillips",
    county_fips_all: 30071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59547,
    lat: 48.70576,
    lng: -108.98747,
    city: "Zurich",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65,
    density: 0.2,
    county_fips: 30005,
    county_name: "Blaine",
    county_weights: {
      30005: 100,
    },
    county_names_all: "Blaine",
    county_fips_all: 30005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59601,
    lat: 46.54199,
    lng: -112.17474,
    city: "Helena",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32165,
    density: 95.4,
    county_fips: 30049,
    county_name: "Lewis and Clark",
    county_weights: {
      30049: 100,
    },
    county_names_all: "Lewis and Clark",
    county_fips_all: 30049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59602,
    lat: 46.73577,
    lng: -111.90753,
    city: "Helena",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27154,
    density: 20,
    county_fips: 30049,
    county_name: "Lewis and Clark",
    county_weights: {
      30049: 100,
    },
    county_names_all: "Lewis and Clark",
    county_fips_all: 30049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59623,
    lat: 46.58991,
    lng: -112.04068,
    city: "Helena",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 30049,
    county_name: "Lewis and Clark",
    county_weights: {
      30049: 100,
    },
    county_names_all: "Lewis and Clark",
    county_fips_all: 30049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59625,
    lat: 46.60135,
    lng: -112.03891,
    city: "Helena",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 30049,
    county_name: "Lewis and Clark",
    county_weights: {
      30049: 100,
    },
    county_names_all: "Lewis and Clark",
    county_fips_all: 30049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59631,
    lat: 46.29168,
    lng: -112.38687,
    city: "Basin",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 278,
    density: 0.7,
    county_fips: 30043,
    county_name: "Jefferson",
    county_weights: {
      30043: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 30043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59632,
    lat: 46.16522,
    lng: -111.99918,
    city: "Boulder",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1836,
    density: 1.6,
    county_fips: 30043,
    county_name: "Jefferson",
    county_weights: {
      30043: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 30043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59633,
    lat: 46.82338,
    lng: -112.36362,
    city: "Canyon Creek",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 317,
    density: 0.6,
    county_fips: 30049,
    county_name: "Lewis and Clark",
    county_weights: {
      30049: 100,
    },
    county_names_all: "Lewis and Clark",
    county_fips_all: 30049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59634,
    lat: 46.43583,
    lng: -112.00986,
    city: "Clancy",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5320,
    density: 8.2,
    county_fips: 30043,
    county_name: "Jefferson",
    county_weights: {
      30043: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 30043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59635,
    lat: 46.5546,
    lng: -111.81749,
    city: "East Helena",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7172,
    density: 34.8,
    county_fips: 30049,
    county_name: "Lewis and Clark",
    county_weights: {
      30007: 25.72,
      30043: 36.11,
      30049: 38.17,
    },
    county_names_all: "Lewis and Clark|Jefferson|Broadwater",
    county_fips_all: "30049|30043|30007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59636,
    lat: 46.61614,
    lng: -112.11399,
    city: "Fort Harrison",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54,
    density: 6.4,
    county_fips: 30049,
    county_name: "Lewis and Clark",
    county_weights: {
      30049: 100,
    },
    county_names_all: "Lewis and Clark",
    county_fips_all: 30049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59638,
    lat: 46.3579,
    lng: -112.02772,
    city: "Jefferson City",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 705,
    density: 4.5,
    county_fips: 30043,
    county_name: "Jefferson",
    county_weights: {
      30043: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 30043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59639,
    lat: 47.09436,
    lng: -112.69371,
    city: "Lincoln",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1184,
    density: 0.7,
    county_fips: 30049,
    county_name: "Lewis and Clark",
    county_weights: {
      30049: 100,
    },
    county_names_all: "Lewis and Clark",
    county_fips_all: 30049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59640,
    lat: 46.76814,
    lng: -112.34922,
    city: "Marysville",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 30049,
    county_name: "Lewis and Clark",
    county_weights: {
      30049: 100,
    },
    county_names_all: "Lewis and Clark",
    county_fips_all: 30049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59642,
    lat: 46.28045,
    lng: -110.75624,
    city: "Ringling",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36,
    density: 0,
    county_fips: 30059,
    county_name: "Meagher",
    county_weights: {
      30059: 100,
    },
    county_names_all: "Meagher",
    county_fips_all: 30059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59643,
    lat: 46.13283,
    lng: -111.57884,
    city: "Toston",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 302,
    density: 0.4,
    county_fips: 30007,
    county_name: "Broadwater",
    county_weights: {
      30007: 100,
    },
    county_names_all: "Broadwater",
    county_fips_all: 30007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59644,
    lat: 46.419,
    lng: -111.43885,
    city: "Townsend",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4334,
    density: 2.3,
    county_fips: 30007,
    county_name: "Broadwater",
    county_weights: {
      30007: 100,
    },
    county_names_all: "Broadwater",
    county_fips_all: 30007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59645,
    lat: 46.69476,
    lng: -111.04729,
    city: "White Sulphur Springs",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1513,
    density: 0.4,
    county_fips: 30059,
    county_name: "Meagher",
    county_weights: {
      30007: 1.38,
      30059: 98.62,
    },
    county_names_all: "Meagher|Broadwater",
    county_fips_all: "30059|30007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59647,
    lat: 46.46726,
    lng: -111.65138,
    city: "Winston",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 522,
    density: 2.4,
    county_fips: 30007,
    county_name: "Broadwater",
    county_weights: {
      30007: 100,
    },
    county_names_all: "Broadwater",
    county_fips_all: 30007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59648,
    lat: 47.07221,
    lng: -112.14059,
    city: "Wolf Creek",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 402,
    density: 0.2,
    county_fips: 30049,
    county_name: "Lewis and Clark",
    county_weights: {
      30049: 100,
    },
    county_names_all: "Lewis and Clark",
    county_fips_all: 30049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59701,
    lat: 46.03497,
    lng: -112.46087,
    city: "Butte",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33685,
    density: 25.5,
    county_fips: 30093,
    county_name: "Silver Bow",
    county_weights: {
      30023: 4.64,
      30043: 46.89,
      30093: 48.47,
    },
    county_names_all: "Silver Bow|Jefferson|Deer Lodge",
    county_fips_all: "30093|30043|30023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59710,
    lat: 45.06801,
    lng: -112.08613,
    city: "Alder",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 243,
    density: 0.1,
    county_fips: 30057,
    county_name: "Madison",
    county_weights: {
      30057: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 30057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59711,
    lat: 46.09734,
    lng: -113.10317,
    city: "Anaconda",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8855,
    density: 6.1,
    county_fips: 30023,
    county_name: "Deer Lodge",
    county_weights: {
      30023: 63.42,
      30039: 25.78,
      30093: 10.8,
    },
    county_names_all: "Deer Lodge|Granite|Silver Bow",
    county_fips_all: "30023|30039|30093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59713,
    lat: 46.67973,
    lng: -112.61228,
    city: "Avon",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 182,
    density: 0.3,
    county_fips: 30077,
    county_name: "Powell",
    county_weights: {
      30077: 100,
    },
    county_names_all: "Powell",
    county_fips_all: 30077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59714,
    lat: 45.97538,
    lng: -111.13112,
    city: "Belgrade",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21530,
    density: 19.9,
    county_fips: 30031,
    county_name: "Gallatin",
    county_weights: {
      30031: 100,
    },
    county_names_all: "Gallatin",
    county_fips_all: 30031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59715,
    lat: 45.6928,
    lng: -110.9065,
    city: "Bozeman",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36760,
    density: 48.1,
    county_fips: 30031,
    county_name: "Gallatin",
    county_weights: {
      30031: 91.81,
      30067: 8.19,
    },
    county_names_all: "Gallatin|Park",
    county_fips_all: "30031|30067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59716,
    lat: 45.28578,
    lng: -111.3873,
    city: "Big Sky",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2477,
    density: 14.8,
    county_fips: 30057,
    county_name: "Madison",
    county_weights: {
      30031: 44.13,
      30057: 55.87,
    },
    county_names_all: "Madison|Gallatin",
    county_fips_all: "30057|30031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59718,
    lat: 45.63999,
    lng: -111.16978,
    city: "Bozeman",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39282,
    density: 92.2,
    county_fips: 30031,
    county_name: "Gallatin",
    county_weights: {
      30031: 100,
    },
    county_names_all: "Gallatin",
    county_fips_all: 30031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59720,
    lat: 44.95821,
    lng: -111.59366,
    city: "Cameron",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 126,
    density: 0.1,
    county_fips: 30057,
    county_name: "Madison",
    county_weights: {
      30057: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 30057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59721,
    lat: 45.85189,
    lng: -111.88177,
    city: "Cardwell",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 565,
    density: 1,
    county_fips: 30043,
    county_name: "Jefferson",
    county_weights: {
      30043: 61.65,
      30057: 38.35,
    },
    county_names_all: "Jefferson|Madison",
    county_fips_all: "30043|30057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59722,
    lat: 46.35143,
    lng: -112.75684,
    city: "Deer Lodge",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5655,
    density: 5.6,
    county_fips: 30077,
    county_name: "Powell",
    county_weights: {
      30023: 14.25,
      30077: 85.75,
    },
    county_names_all: "Powell|Deer Lodge",
    county_fips_all: "30077|30023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59724,
    lat: 44.67716,
    lng: -112.79359,
    city: "Dell",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 81,
    density: 0.1,
    county_fips: 30001,
    county_name: "Beaverhead",
    county_weights: {
      30001: 100,
    },
    county_names_all: "Beaverhead",
    county_fips_all: 30001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59725,
    lat: 45.06267,
    lng: -112.85714,
    city: "Dillon",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8018,
    density: 1.6,
    county_fips: 30001,
    county_name: "Beaverhead",
    county_weights: {
      30001: 96.05,
      30057: 3.95,
    },
    county_names_all: "Beaverhead|Madison",
    county_fips_all: "30001|30057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59727,
    lat: 45.78797,
    lng: -112.79394,
    city: "Divide",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 269,
    density: 0.3,
    county_fips: 30093,
    county_name: "Silver Bow",
    county_weights: {
      30001: 20.36,
      30093: 79.64,
    },
    county_names_all: "Silver Bow|Beaverhead",
    county_fips_all: "30093|30001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59728,
    lat: 46.50487,
    lng: -112.41135,
    city: "Elliston",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 327,
    density: 0.7,
    county_fips: 30077,
    county_name: "Powell",
    county_weights: {
      30077: 100,
    },
    county_names_all: "Powell",
    county_fips_all: 30077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59729,
    lat: 45.31343,
    lng: -111.64827,
    city: "Ennis",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2384,
    density: 2,
    county_fips: 30057,
    county_name: "Madison",
    county_weights: {
      30057: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 30057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59730,
    lat: 45.30988,
    lng: -111.19025,
    city: "Gallatin Gateway",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2092,
    density: 1.2,
    county_fips: 30031,
    county_name: "Gallatin",
    county_weights: {
      30031: 94.04,
      30057: 5.96,
    },
    county_names_all: "Gallatin|Madison",
    county_fips_all: "30031|30057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59731,
    lat: 46.58455,
    lng: -112.76326,
    city: "Garrison",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 142,
    density: 0.4,
    county_fips: 30077,
    county_name: "Powell",
    county_weights: {
      30077: 100,
    },
    county_names_all: "Powell",
    county_fips_all: 30077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59732,
    lat: 45.48899,
    lng: -112.69457,
    city: "Glen",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 334,
    density: 0.6,
    county_fips: 30001,
    county_name: "Beaverhead",
    county_weights: {
      30001: 58.45,
      30057: 41.55,
    },
    county_names_all: "Beaverhead|Madison",
    county_fips_all: "30001|30057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59733,
    lat: 46.54922,
    lng: -112.94987,
    city: "Gold Creek",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 234,
    density: 0.6,
    county_fips: 30077,
    county_name: "Powell",
    county_weights: {
      30077: 100,
    },
    county_names_all: "Powell",
    county_fips_all: 30077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59735,
    lat: 45.65775,
    lng: -111.84615,
    city: "Harrison",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 260,
    density: 0.9,
    county_fips: 30057,
    county_name: "Madison",
    county_weights: {
      30057: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 30057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59736,
    lat: 45.34242,
    lng: -113.3458,
    city: "Jackson",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 146,
    density: 0.2,
    county_fips: 30001,
    county_name: "Beaverhead",
    county_weights: {
      30001: 100,
    },
    county_names_all: "Beaverhead",
    county_fips_all: 30001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59739,
    lat: 44.65378,
    lng: -112.16963,
    city: "Lima",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 267,
    density: 0.1,
    county_fips: 30001,
    county_name: "Beaverhead",
    county_weights: {
      30001: 100,
    },
    county_names_all: "Beaverhead",
    county_fips_all: 30001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59740,
    lat: 45.49871,
    lng: -111.81159,
    city: "McAllister",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 458,
    density: 1.1,
    county_fips: 30057,
    county_name: "Madison",
    county_weights: {
      30057: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 30057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59741,
    lat: 45.77265,
    lng: -111.3638,
    city: "Manhattan",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5041,
    density: 11.8,
    county_fips: 30031,
    county_name: "Gallatin",
    county_weights: {
      30031: 100,
    },
    county_names_all: "Gallatin",
    county_fips_all: 30031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59743,
    lat: 45.60068,
    lng: -112.74964,
    city: "Melrose",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 153,
    density: 0.3,
    county_fips: 30001,
    county_name: "Beaverhead",
    county_weights: {
      30001: 62.75,
      30057: 27.89,
      30093: 9.36,
    },
    county_names_all: "Beaverhead|Madison|Silver Bow",
    county_fips_all: "30001|30057|30093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59745,
    lat: 45.5941,
    lng: -111.60658,
    city: "Norris",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67,
    density: 0.2,
    county_fips: 30057,
    county_name: "Madison",
    county_weights: {
      30057: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 30057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59746,
    lat: 45.37137,
    lng: -113.05332,
    city: "Polaris",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 147,
    density: 0.3,
    county_fips: 30001,
    county_name: "Beaverhead",
    county_weights: {
      30001: 100,
    },
    county_names_all: "Beaverhead",
    county_fips_all: 30001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59747,
    lat: 45.69862,
    lng: -111.93281,
    city: "Pony",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 165,
    density: 1.6,
    county_fips: 30057,
    county_name: "Madison",
    county_weights: {
      30057: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 30057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59748,
    lat: 46.04611,
    lng: -112.69601,
    city: "Ramsay",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 245,
    density: 4.4,
    county_fips: 30093,
    county_name: "Silver Bow",
    county_weights: {
      30093: 100,
    },
    county_names_all: "Silver Bow",
    county_fips_all: 30093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59749,
    lat: 45.44332,
    lng: -112.09548,
    city: "Sheridan",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2080,
    density: 3.4,
    county_fips: 30057,
    county_name: "Madison",
    county_weights: {
      30057: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 30057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59750,
    lat: 45.91857,
    lng: -112.68323,
    city: "Butte",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 390,
    density: 1.5,
    county_fips: 30093,
    county_name: "Silver Bow",
    county_weights: {
      30093: 100,
    },
    county_names_all: "Silver Bow",
    county_fips_all: 30093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59751,
    lat: 45.69001,
    lng: -112.29755,
    city: "Silver Star",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 277,
    density: 4,
    county_fips: 30057,
    county_name: "Madison",
    county_weights: {
      30057: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 30057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59752,
    lat: 45.92412,
    lng: -111.52577,
    city: "Three Forks",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3878,
    density: 3.7,
    county_fips: 30031,
    county_name: "Gallatin",
    county_weights: {
      30007: 18.36,
      30031: 62.21,
      30043: 19.43,
    },
    county_names_all: "Gallatin|Jefferson|Broadwater",
    county_fips_all: "30031|30043|30007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59754,
    lat: 45.52435,
    lng: -112.35339,
    city: "Twin Bridges",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 966,
    density: 1,
    county_fips: 30057,
    county_name: "Madison",
    county_weights: {
      30057: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 30057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59755,
    lat: 45.27174,
    lng: -111.94274,
    city: "Virginia City",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 169,
    density: 1,
    county_fips: 30057,
    county_name: "Madison",
    county_weights: {
      30057: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 30057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59756,
    lat: 46.17418,
    lng: -112.83453,
    city: "Warm Springs",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 475,
    density: 17.8,
    county_fips: 30023,
    county_name: "Deer Lodge",
    county_weights: {
      30023: 100,
    },
    county_names_all: "Deer Lodge",
    county_fips_all: 30023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59758,
    lat: 44.78962,
    lng: -111.19348,
    city: "West Yellowstone",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1623,
    density: 1.5,
    county_fips: 30031,
    county_name: "Gallatin",
    county_weights: {
      30031: 100,
    },
    county_names_all: "Gallatin",
    county_fips_all: 30031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59759,
    lat: 45.83972,
    lng: -112.16233,
    city: "Whitehall",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3784,
    density: 3.3,
    county_fips: 30043,
    county_name: "Jefferson",
    county_weights: {
      30043: 61.27,
      30057: 32.24,
      30093: 6.49,
    },
    county_names_all: "Jefferson|Madison|Silver Bow",
    county_fips_all: "30043|30057|30093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59760,
    lat: 45.76267,
    lng: -111.60386,
    city: "Willow Creek",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 251,
    density: 2.1,
    county_fips: 30031,
    county_name: "Gallatin",
    county_weights: {
      30031: 100,
    },
    county_names_all: "Gallatin",
    county_fips_all: 30031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59761,
    lat: 45.60427,
    lng: -113.52661,
    city: "Wisdom",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 319,
    density: 0.1,
    county_fips: 30001,
    county_name: "Beaverhead",
    county_weights: {
      30001: 100,
    },
    county_names_all: "Beaverhead",
    county_fips_all: 30001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59762,
    lat: 45.82231,
    lng: -113.15271,
    city: "Wise River",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 199,
    density: 0.1,
    county_fips: 30023,
    county_name: "Deer Lodge",
    county_weights: {
      30001: 43.89,
      30023: 56.11,
    },
    county_names_all: "Deer Lodge|Beaverhead",
    county_fips_all: "30023|30001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59801,
    lat: 46.85505,
    lng: -114.01009,
    city: "Missoula",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33427,
    density: 1673.8,
    county_fips: 30063,
    county_name: "Missoula",
    county_weights: {
      30063: 100,
    },
    county_names_all: "Missoula",
    county_fips_all: 30063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59802,
    lat: 46.90569,
    lng: -113.92077,
    city: "Missoula",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20778,
    density: 176.8,
    county_fips: 30063,
    county_name: "Missoula",
    county_weights: {
      30063: 100,
    },
    county_names_all: "Missoula",
    county_fips_all: 30063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59803,
    lat: 46.77781,
    lng: -113.95826,
    city: "Missoula",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18156,
    density: 72.3,
    county_fips: 30063,
    county_name: "Missoula",
    county_weights: {
      30063: 100,
    },
    county_names_all: "Missoula",
    county_fips_all: 30063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59804,
    lat: 46.90084,
    lng: -114.25066,
    city: "Missoula",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8072,
    density: 24.7,
    county_fips: 30063,
    county_name: "Missoula",
    county_weights: {
      30063: 100,
    },
    county_names_all: "Missoula",
    county_fips_all: 30063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59808,
    lat: 46.97984,
    lng: -114.064,
    city: "Missoula",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20165,
    density: 49.6,
    county_fips: 30063,
    county_name: "Missoula",
    county_weights: {
      30063: 100,
    },
    county_names_all: "Missoula",
    county_fips_all: 30063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59812,
    lat: 46.86121,
    lng: -113.98442,
    city: "Missoula",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 30063,
    county_name: "Missoula",
    county_weights: {
      30063: 100,
    },
    county_names_all: "Missoula",
    county_fips_all: 30063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59820,
    lat: 46.89803,
    lng: -114.61474,
    city: "Alberton",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2064,
    density: 2.1,
    county_fips: 30061,
    county_name: "Mineral",
    county_weights: {
      30061: 72.05,
      30063: 27.95,
    },
    county_names_all: "Mineral|Missoula",
    county_fips_all: "30061|30063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59821,
    lat: 47.17603,
    lng: -114.00431,
    city: "Arlee",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2650,
    density: 3.2,
    county_fips: 30063,
    county_name: "Missoula",
    county_weights: {
      30047: 37.18,
      30063: 43.96,
      30089: 18.86,
    },
    county_names_all: "Missoula|Lake|Sanders",
    county_fips_all: "30063|30047|30089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59823,
    lat: 46.96334,
    lng: -113.59753,
    city: "Bonner",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1840,
    density: 1.4,
    county_fips: 30063,
    county_name: "Missoula",
    county_weights: {
      30063: 100,
    },
    county_names_all: "Missoula",
    county_fips_all: 30063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59824,
    lat: 47.41817,
    lng: -114.20362,
    city: "Charlo",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1258,
    density: 5.2,
    county_fips: 30047,
    county_name: "Lake",
    county_weights: {
      30047: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 30047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59825,
    lat: 46.66009,
    lng: -113.66421,
    city: "Clinton",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2341,
    density: 2.2,
    county_fips: 30039,
    county_name: "Granite",
    county_weights: {
      30039: 61.49,
      30063: 38.51,
    },
    county_names_all: "Granite|Missoula",
    county_fips_all: "30039|30063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59826,
    lat: 47.46339,
    lng: -113.69827,
    city: "Condon",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 578,
    density: 0.6,
    county_fips: 30063,
    county_name: "Missoula",
    county_weights: {
      30063: 100,
    },
    county_names_all: "Missoula",
    county_fips_all: 30063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59827,
    lat: 45.88649,
    lng: -114.08346,
    city: "Conner",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 335,
    density: 7.9,
    county_fips: 30081,
    county_name: "Ravalli",
    county_weights: {
      30081: 100,
    },
    county_names_all: "Ravalli",
    county_fips_all: 30081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59828,
    lat: 46.33478,
    lng: -113.96444,
    city: "Corvallis",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5709,
    density: 13.4,
    county_fips: 30081,
    county_name: "Ravalli",
    county_weights: {
      30081: 100,
    },
    county_names_all: "Ravalli",
    county_fips_all: 30081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59829,
    lat: 45.79814,
    lng: -114.2614,
    city: "Darby",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2432,
    density: 1.1,
    county_fips: 30081,
    county_name: "Ravalli",
    county_weights: {
      30081: 100,
    },
    county_names_all: "Ravalli",
    county_fips_all: 30081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59830,
    lat: 47.43419,
    lng: -115.45896,
    city: "De Borgia",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 183,
    density: 0.7,
    county_fips: 30061,
    county_name: "Mineral",
    county_weights: {
      30061: 100,
    },
    county_names_all: "Mineral",
    county_fips_all: 30061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59831,
    lat: 47.27732,
    lng: -114.36296,
    city: "Dixon",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 498,
    density: 1.9,
    county_fips: 30089,
    county_name: "Sanders",
    county_weights: {
      30089: 100,
    },
    county_names_all: "Sanders",
    county_fips_all: 30089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59832,
    lat: 46.67864,
    lng: -113.22904,
    city: "Drummond",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 625,
    density: 1,
    county_fips: 30039,
    county_name: "Granite",
    county_weights: {
      30039: 100,
    },
    county_names_all: "Granite",
    county_fips_all: 30039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59833,
    lat: 46.64437,
    lng: -114.07678,
    city: "Florence",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5444,
    density: 13.7,
    county_fips: 30081,
    county_name: "Ravalli",
    county_weights: {
      30063: 29.8,
      30081: 70.2,
    },
    county_names_all: "Ravalli|Missoula",
    county_fips_all: "30081|30063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59834,
    lat: 47.06979,
    lng: -114.2221,
    city: "Frenchtown",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2161,
    density: 12.5,
    county_fips: 30063,
    county_name: "Missoula",
    county_weights: {
      30063: 100,
    },
    county_names_all: "Missoula",
    county_fips_all: 30063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59837,
    lat: 46.53898,
    lng: -113.27688,
    city: "Hall",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 560,
    density: 1.1,
    county_fips: 30039,
    county_name: "Granite",
    county_weights: {
      30039: 100,
    },
    county_names_all: "Granite",
    county_fips_all: 30039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59840,
    lat: 46.17558,
    lng: -114.11674,
    city: "Hamilton",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13966,
    density: 10,
    county_fips: 30081,
    county_name: "Ravalli",
    county_weights: {
      30081: 100,
    },
    county_names_all: "Ravalli",
    county_fips_all: 30081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59841,
    lat: 46.33384,
    lng: -114.22319,
    city: "Pinesdale",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 987,
    density: 292.2,
    county_fips: 30081,
    county_name: "Ravalli",
    county_weights: {
      30081: 100,
    },
    county_names_all: "Ravalli",
    county_fips_all: 30081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59842,
    lat: 47.32526,
    lng: -115.40107,
    city: "Haugan",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 91,
    density: 0.3,
    county_fips: 30061,
    county_name: "Mineral",
    county_weights: {
      30061: 100,
    },
    county_names_all: "Mineral",
    county_fips_all: 30061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59843,
    lat: 46.84897,
    lng: -113.01114,
    city: "Helmville",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 295,
    density: 0.3,
    county_fips: 30077,
    county_name: "Powell",
    county_weights: {
      30077: 100,
    },
    county_names_all: "Powell",
    county_fips_all: 30077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59844,
    lat: 48.00803,
    lng: -115.9707,
    city: "Heron",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 783,
    density: 4,
    county_fips: 30089,
    county_name: "Sanders",
    county_weights: {
      30089: 100,
    },
    county_names_all: "Sanders",
    county_fips_all: 30089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59845,
    lat: 47.65892,
    lng: -114.54734,
    city: "Hot Springs",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1355,
    density: 1.2,
    county_fips: 30089,
    county_name: "Sanders",
    county_weights: {
      30029: 15.7,
      30047: 17.32,
      30089: 66.98,
    },
    county_names_all: "Sanders|Lake|Flathead",
    county_fips_all: "30089|30047|30029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59846,
    lat: 47.14899,
    lng: -114.50615,
    city: "Huson",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1236,
    density: 2.3,
    county_fips: 30063,
    county_name: "Missoula",
    county_weights: {
      30063: 100,
    },
    county_names_all: "Missoula",
    county_fips_all: 30063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59847,
    lat: 46.73105,
    lng: -114.37782,
    city: "Lolo",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6005,
    density: 7.7,
    county_fips: 30063,
    county_name: "Missoula",
    county_weights: {
      16049: 5.15,
      30063: 94.85,
    },
    county_names_all: "Missoula|Idaho",
    county_fips_all: "30063|16049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59848,
    lat: 47.71526,
    lng: -114.68162,
    city: "Lonepine",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 108,
    density: 1.4,
    county_fips: 30089,
    county_name: "Sanders",
    county_weights: {
      30089: 100,
    },
    county_names_all: "Sanders",
    county_fips_all: 30089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59851,
    lat: 46.87215,
    lng: -113.87348,
    city: "Milltown",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 99,
    density: 108.4,
    county_fips: 30063,
    county_name: "Missoula",
    county_weights: {
      30063: 100,
    },
    county_names_all: "Missoula",
    county_fips_all: 30063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59853,
    lat: 48.0571,
    lng: -115.81522,
    city: "Noxon",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 699,
    density: 0.9,
    county_fips: 30089,
    county_name: "Sanders",
    county_weights: {
      30089: 100,
    },
    county_names_all: "Sanders",
    county_fips_all: 30089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59854,
    lat: 47.26481,
    lng: -113.18997,
    city: "Ovando",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 155,
    density: 0.1,
    county_fips: 30077,
    county_name: "Powell",
    county_weights: {
      30077: 100,
    },
    county_names_all: "Powell",
    county_fips_all: 30077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59855,
    lat: 47.60032,
    lng: -114.11787,
    city: "Pablo",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 675,
    density: 738.5,
    county_fips: 30047,
    county_name: "Lake",
    county_weights: {
      30047: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 30047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59856,
    lat: 47.38237,
    lng: -114.73627,
    city: "Paradise",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 526,
    density: 10.5,
    county_fips: 30089,
    county_name: "Sanders",
    county_weights: {
      30089: 100,
    },
    county_names_all: "Sanders",
    county_fips_all: 30089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59858,
    lat: 46.29584,
    lng: -113.48371,
    city: "Philipsburg",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1640,
    density: 0.7,
    county_fips: 30039,
    county_name: "Granite",
    county_weights: {
      30039: 100,
    },
    county_names_all: "Granite",
    county_fips_all: 30039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59859,
    lat: 47.5205,
    lng: -114.80396,
    city: "Plains",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3194,
    density: 1.7,
    county_fips: 30089,
    county_name: "Sanders",
    county_weights: {
      30089: 100,
    },
    county_names_all: "Sanders",
    county_fips_all: 30089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59860,
    lat: 47.71314,
    lng: -114.17832,
    city: "Polson",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10834,
    density: 16,
    county_fips: 30047,
    county_name: "Lake",
    county_weights: {
      30047: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 30047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59863,
    lat: 47.29397,
    lng: -114.17637,
    city: "Ravalli",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 220,
    density: 11.1,
    county_fips: 30047,
    county_name: "Lake",
    county_weights: {
      30047: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 30047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59864,
    lat: 47.53324,
    lng: -114.11741,
    city: "Ronan",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6757,
    density: 14,
    county_fips: 30047,
    county_name: "Lake",
    county_weights: {
      30047: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 30047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59865,
    lat: 47.33184,
    lng: -114.0045,
    city: "Saint Ignatius",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3958,
    density: 9.4,
    county_fips: 30047,
    county_name: "Lake",
    county_weights: {
      30047: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 30047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59866,
    lat: 47.32207,
    lng: -115.12329,
    city: "Saint Regis",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 869,
    density: 1.5,
    county_fips: 30061,
    county_name: "Mineral",
    county_weights: {
      30061: 90.51,
      30089: 9.49,
    },
    county_names_all: "Mineral|Sanders",
    county_fips_all: "30061|30089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59867,
    lat: 47.4028,
    lng: -115.54993,
    city: "Saltese",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53,
    density: 0.9,
    county_fips: 30061,
    county_name: "Mineral",
    county_weights: {
      30061: 100,
    },
    county_names_all: "Mineral",
    county_fips_all: 30061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59868,
    lat: 47.21401,
    lng: -113.53535,
    city: "Seeley Lake",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1963,
    density: 3,
    county_fips: 30063,
    county_name: "Missoula",
    county_weights: {
      30063: 95.82,
      30077: 4.18,
    },
    county_names_all: "Missoula|Powell",
    county_fips_all: "30063|30077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59870,
    lat: 46.51596,
    lng: -114.0618,
    city: "Stevensville",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11305,
    density: 17.1,
    county_fips: 30081,
    county_name: "Ravalli",
    county_weights: {
      30081: 100,
    },
    county_names_all: "Ravalli",
    county_fips_all: 30081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59871,
    lat: 45.89666,
    lng: -113.81366,
    city: "Sula",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 268,
    density: 0.3,
    county_fips: 30081,
    county_name: "Ravalli",
    county_weights: {
      30081: 100,
    },
    county_names_all: "Ravalli",
    county_fips_all: 30081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59872,
    lat: 47.10282,
    lng: -114.90339,
    city: "Superior",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2049,
    density: 1.5,
    county_fips: 30061,
    county_name: "Mineral",
    county_weights: {
      30061: 100,
    },
    county_names_all: "Mineral",
    county_fips_all: 30061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59873,
    lat: 47.6972,
    lng: -115.27357,
    city: "Thompson Falls",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3139,
    density: 1.6,
    county_fips: 30089,
    county_name: "Sanders",
    county_weights: {
      30089: 100,
    },
    county_names_all: "Sanders",
    county_fips_all: 30089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59874,
    lat: 47.80675,
    lng: -115.60749,
    city: "Trout Creek",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1554,
    density: 1.6,
    county_fips: 30089,
    county_name: "Sanders",
    county_weights: {
      30089: 100,
    },
    county_names_all: "Sanders",
    county_fips_all: 30089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59875,
    lat: 46.40793,
    lng: -114.26151,
    city: "Victor",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3895,
    density: 11.7,
    county_fips: 30081,
    county_name: "Ravalli",
    county_weights: {
      30081: 100,
    },
    county_names_all: "Ravalli",
    county_fips_all: 30081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59901,
    lat: 48.22873,
    lng: -114.40564,
    city: "Kalispell",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56951,
    density: 46.9,
    county_fips: 30029,
    county_name: "Flathead",
    county_weights: {
      30029: 100,
    },
    county_names_all: "Flathead",
    county_fips_all: 30029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59910,
    lat: 47.82409,
    lng: -114.23271,
    city: "Big Arm",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 455,
    density: 9.1,
    county_fips: 30047,
    county_name: "Lake",
    county_weights: {
      30047: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 30047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59911,
    lat: 47.86041,
    lng: -113.88552,
    city: "Bigfork",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8905,
    density: 7,
    county_fips: 30047,
    county_name: "Lake",
    county_weights: {
      30029: 16.38,
      30047: 83.62,
    },
    county_names_all: "Lake|Flathead",
    county_fips_all: "30047|30029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59912,
    lat: 48.43879,
    lng: -114.16898,
    city: "Columbia Falls",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15673,
    density: 32,
    county_fips: 30029,
    county_name: "Flathead",
    county_weights: {
      30029: 100,
    },
    county_names_all: "Flathead",
    county_fips_all: 30029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59913,
    lat: 48.41391,
    lng: -113.95045,
    city: "Coram",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 456,
    density: 3.4,
    county_fips: 30029,
    county_name: "Flathead",
    county_weights: {
      30029: 100,
    },
    county_names_all: "Flathead",
    county_fips_all: 30029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59914,
    lat: 47.86878,
    lng: -114.29546,
    city: "Dayton",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 326,
    density: 11.2,
    county_fips: 30047,
    county_name: "Lake",
    county_weights: {
      30047: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 30047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59915,
    lat: 47.82025,
    lng: -114.41124,
    city: "Elmo",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 563,
    density: 3.8,
    county_fips: 30047,
    county_name: "Lake",
    county_weights: {
      30047: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 30047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59916,
    lat: 48.31716,
    lng: -113.65779,
    city: "Essex",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 178,
    density: 0.6,
    county_fips: 30029,
    county_name: "Flathead",
    county_weights: {
      30029: 100,
    },
    county_names_all: "Flathead",
    county_fips_all: 30029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59917,
    lat: 48.90614,
    lng: -114.91359,
    city: "Eureka",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5008,
    density: 7.9,
    county_fips: 30053,
    county_name: "Lincoln",
    county_weights: {
      30053: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 30053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59918,
    lat: 48.75766,
    lng: -114.8077,
    city: "Fortine",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 808,
    density: 3.3,
    county_fips: 30053,
    county_name: "Lincoln",
    county_weights: {
      30053: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 30053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59919,
    lat: 48.3776,
    lng: -114.05645,
    city: "Hungry Horse",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 650,
    density: 110.5,
    county_fips: 30029,
    county_name: "Flathead",
    county_weights: {
      30029: 100,
    },
    county_names_all: "Flathead",
    county_fips_all: 30029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59920,
    lat: 48.06412,
    lng: -114.53464,
    city: "Kila",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1630,
    density: 3.4,
    county_fips: 30029,
    county_name: "Flathead",
    county_weights: {
      30029: 100,
    },
    county_names_all: "Flathead",
    county_fips_all: 30029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59922,
    lat: 47.99962,
    lng: -114.22227,
    city: "Lakeside",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2128,
    density: 21.5,
    county_fips: 30029,
    county_name: "Flathead",
    county_weights: {
      30029: 93.2,
      30047: 6.8,
    },
    county_names_all: "Flathead|Lake",
    county_fips_all: "30029|30047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59923,
    lat: 48.26996,
    lng: -115.31073,
    city: "Libby",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9154,
    density: 2.5,
    county_fips: 30053,
    county_name: "Lincoln",
    county_weights: {
      30053: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 30053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59925,
    lat: 48.04732,
    lng: -114.83045,
    city: "Marion",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1526,
    density: 1.6,
    county_fips: 30029,
    county_name: "Flathead",
    county_weights: {
      30029: 100,
    },
    county_names_all: "Flathead",
    county_fips_all: 30029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59926,
    lat: 48.36294,
    lng: -114.00459,
    city: "Martin City",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 369,
    density: 14.2,
    county_fips: 30029,
    county_name: "Flathead",
    county_weights: {
      30029: 100,
    },
    county_names_all: "Flathead",
    county_fips_all: 30029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59927,
    lat: 48.56021,
    lng: -114.717,
    city: "Olney",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 270,
    density: 0.5,
    county_fips: 30029,
    county_name: "Flathead",
    county_weights: {
      30029: 100,
    },
    county_names_all: "Flathead",
    county_fips_all: 30029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59928,
    lat: 48.79745,
    lng: -114.29117,
    city: "Polebridge",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 202,
    density: 0.1,
    county_fips: 30029,
    county_name: "Flathead",
    county_weights: {
      30029: 100,
    },
    county_names_all: "Flathead",
    county_fips_all: 30029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59929,
    lat: 47.92365,
    lng: -114.40272,
    city: "Proctor",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 234,
    density: 2.2,
    county_fips: 30047,
    county_name: "Lake",
    county_weights: {
      30047: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 30047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59930,
    lat: 48.86277,
    lng: -115.14514,
    city: "Rexford",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 399,
    density: 1.6,
    county_fips: 30053,
    county_name: "Lincoln",
    county_weights: {
      30053: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 30053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59931,
    lat: 47.9208,
    lng: -114.25486,
    city: "Rollins",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 325,
    density: 4.4,
    county_fips: 30047,
    county_name: "Lake",
    county_weights: {
      30047: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 30047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59932,
    lat: 48.0502,
    lng: -114.24624,
    city: "Somers",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1355,
    density: 19.2,
    county_fips: 30029,
    county_name: "Flathead",
    county_weights: {
      30029: 100,
    },
    county_names_all: "Flathead",
    county_fips_all: 30029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59933,
    lat: 48.70858,
    lng: -114.76694,
    city: "Stryker",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 66,
    density: 1.3,
    county_fips: 30053,
    county_name: "Lincoln",
    county_weights: {
      30053: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 30053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59934,
    lat: 48.63437,
    lng: -114.94446,
    city: "Trego",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 794,
    density: 2.5,
    county_fips: 30053,
    county_name: "Lincoln",
    county_weights: {
      30053: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 30053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59935,
    lat: 48.64726,
    lng: -115.83505,
    city: "Troy",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3616,
    density: 1.3,
    county_fips: 30053,
    county_name: "Lincoln",
    county_weights: {
      30053: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 30053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59936,
    lat: 48.17178,
    lng: -113.46357,
    city: "West Glacier",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 491,
    density: 0.1,
    county_fips: 30029,
    county_name: "Flathead",
    county_weights: {
      30029: 100,
    },
    county_names_all: "Flathead",
    county_fips_all: 30029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 59937,
    lat: 48.43893,
    lng: -114.49769,
    city: "Whitefish",
    state_id: "MT",
    state_name: "Montana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13962,
    density: 17.4,
    county_fips: 30029,
    county_name: "Flathead",
    county_weights: {
      30029: 100,
    },
    county_names_all: "Flathead",
    county_fips_all: 30029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 60002,
    lat: 42.4674,
    lng: -88.09419,
    city: "Antioch",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23914,
    density: 277.2,
    county_fips: 17097,
    county_name: "Lake",
    county_weights: {
      17097: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 17097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60004,
    lat: 42.11206,
    lng: -87.97895,
    city: "Arlington Heights",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51504,
    density: 1788.7,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60005,
    lat: 42.06518,
    lng: -87.98676,
    city: "Arlington Heights",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29109,
    density: 1710.7,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60007,
    lat: 42.01431,
    lng: -87.99828,
    city: "Elk Grove Village",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32792,
    density: 699.2,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 96.01,
      17043: 3.99,
    },
    county_names_all: "Cook|DuPage",
    county_fips_all: "17031|17043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60008,
    lat: 42.0739,
    lng: -88.0229,
    city: "Rolling Meadows",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22007,
    density: 1657.1,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60010,
    lat: 42.15255,
    lng: -88.16519,
    city: "Barrington",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46326,
    density: 241.4,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 50.63,
      17089: 1.65,
      17097: 38.48,
      17111: 9.24,
    },
    county_names_all: "Cook|Lake|McHenry|Kane",
    county_fips_all: "17031|17097|17111|17089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60012,
    lat: 42.27199,
    lng: -88.31157,
    city: "Crystal Lake",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11456,
    density: 255.7,
    county_fips: 17111,
    county_name: "McHenry",
    county_weights: {
      17111: 100,
    },
    county_names_all: "McHenry",
    county_fips_all: 17111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60013,
    lat: 42.22027,
    lng: -88.23568,
    city: "Cary",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26520,
    density: 707.9,
    county_fips: 17111,
    county_name: "McHenry",
    county_weights: {
      17097: 10.61,
      17111: 89.39,
    },
    county_names_all: "McHenry|Lake",
    county_fips_all: "17111|17097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60014,
    lat: 42.23126,
    lng: -88.32679,
    city: "Crystal Lake",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46866,
    density: 720.8,
    county_fips: 17111,
    county_name: "McHenry",
    county_weights: {
      17111: 100,
    },
    county_names_all: "McHenry",
    county_fips_all: 17111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60015,
    lat: 42.17239,
    lng: -87.87486,
    city: "Deerfield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26942,
    density: 763,
    county_fips: 17097,
    county_name: "Lake",
    county_weights: {
      17031: 3.72,
      17097: 96.28,
    },
    county_names_all: "Lake|Cook",
    county_fips_all: "17097|17031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60016,
    lat: 42.05232,
    lng: -87.8899,
    city: "Des Plaines",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59663,
    density: 1900.2,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60018,
    lat: 41.99629,
    lng: -87.89846,
    city: "Des Plaines",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28477,
    density: 663.1,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60020,
    lat: 42.39543,
    lng: -88.17349,
    city: "Fox Lake",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10500,
    density: 860.6,
    county_fips: 17097,
    county_name: "Lake",
    county_weights: {
      17097: 99.5,
      17111: 0.5,
    },
    county_names_all: "Lake|McHenry",
    county_fips_all: "17097|17111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60021,
    lat: 42.19511,
    lng: -88.21768,
    city: "Fox River Grove",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5592,
    density: 1054.3,
    county_fips: 17111,
    county_name: "McHenry",
    county_weights: {
      17097: 5.81,
      17111: 94.19,
    },
    county_names_all: "McHenry|Lake",
    county_fips_all: "17111|17097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60022,
    lat: 42.13637,
    lng: -87.7664,
    city: "Glencoe",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8245,
    density: 839.4,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60025,
    lat: 42.07466,
    lng: -87.81204,
    city: "Glenview",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41552,
    density: 1529.3,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60026,
    lat: 42.09221,
    lng: -87.83789,
    city: "Glenview",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13667,
    density: 1294.5,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60029,
    lat: 42.05857,
    lng: -87.78496,
    city: "Golf",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 512,
    density: 440.9,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60030,
    lat: 42.33536,
    lng: -88.04519,
    city: "Grayslake",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35440,
    density: 511.3,
    county_fips: 17097,
    county_name: "Lake",
    county_weights: {
      17097: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 17097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60031,
    lat: 42.37494,
    lng: -87.94119,
    city: "Gurnee",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37636,
    density: 764,
    county_fips: 17097,
    county_name: "Lake",
    county_weights: {
      17097: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 17097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60033,
    lat: 42.42333,
    lng: -88.61104,
    city: "Harvard",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13479,
    density: 44.3,
    county_fips: 17111,
    county_name: "McHenry",
    county_weights: {
      17007: 5.93,
      17111: 94.07,
    },
    county_names_all: "McHenry|Boone",
    county_fips_all: "17111|17007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60034,
    lat: 42.45869,
    lng: -88.42665,
    city: "Hebron",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2230,
    density: 27.9,
    county_fips: 17111,
    county_name: "McHenry",
    county_weights: {
      17111: 100,
    },
    county_names_all: "McHenry",
    county_fips_all: 17111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60035,
    lat: 42.18358,
    lng: -87.8106,
    city: "Highland Park",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29604,
    density: 902.4,
    county_fips: 17097,
    county_name: "Lake",
    county_weights: {
      17097: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 17097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60040,
    lat: 42.20652,
    lng: -87.81274,
    city: "Highwood",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5293,
    density: 2669.7,
    county_fips: 17097,
    county_name: "Lake",
    county_weights: {
      17097: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 17097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60041,
    lat: 42.36939,
    lng: -88.15309,
    city: "Ingleside",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8224,
    density: 332.4,
    county_fips: 17097,
    county_name: "Lake",
    county_weights: {
      17097: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 17097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60042,
    lat: 42.27913,
    lng: -88.19777,
    city: "Island Lake",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8519,
    density: 720.3,
    county_fips: 17097,
    county_name: "Lake",
    county_weights: {
      17097: 56.75,
      17111: 43.25,
    },
    county_names_all: "Lake|McHenry",
    county_fips_all: "17097|17111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60043,
    lat: 42.08882,
    lng: -87.71445,
    city: "Kenilworth",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2356,
    density: 1497.5,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60044,
    lat: 42.2842,
    lng: -87.86392,
    city: "Lake Bluff",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10259,
    density: 583.7,
    county_fips: 17097,
    county_name: "Lake",
    county_weights: {
      17097: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 17097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60045,
    lat: 42.23807,
    lng: -87.87006,
    city: "Lake Forest",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21460,
    density: 388.8,
    county_fips: 17097,
    county_name: "Lake",
    county_weights: {
      17097: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 17097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60046,
    lat: 42.41572,
    lng: -88.06094,
    city: "Lake Villa",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34849,
    density: 586.2,
    county_fips: 17097,
    county_name: "Lake",
    county_weights: {
      17097: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 17097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60047,
    lat: 42.20202,
    lng: -88.04522,
    city: "Lake Zurich",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42242,
    density: 467.7,
    county_fips: 17097,
    county_name: "Lake",
    county_weights: {
      17097: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 17097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60048,
    lat: 42.29494,
    lng: -87.9466,
    city: "Libertyville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29306,
    density: 398.5,
    county_fips: 17097,
    county_name: "Lake",
    county_weights: {
      17097: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 17097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60050,
    lat: 42.32915,
    lng: -88.29363,
    city: "Mchenry",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32000,
    density: 467.5,
    county_fips: 17111,
    county_name: "McHenry",
    county_weights: {
      17097: 0.51,
      17111: 99.49,
    },
    county_names_all: "McHenry|Lake",
    county_fips_all: "17111|17097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60051,
    lat: 42.35099,
    lng: -88.22412,
    city: "Mchenry",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23190,
    density: 269.9,
    county_fips: 17111,
    county_name: "McHenry",
    county_weights: {
      17097: 17.87,
      17111: 82.13,
    },
    county_names_all: "McHenry|Lake",
    county_fips_all: "17111|17097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60053,
    lat: 42.04224,
    lng: -87.78895,
    city: "Morton Grove",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22937,
    density: 1751.1,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60056,
    lat: 42.06618,
    lng: -87.93473,
    city: "Mount Prospect",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54023,
    density: 1919.7,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60060,
    lat: 42.26945,
    lng: -88.03997,
    city: "Mundelein",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37268,
    density: 619.6,
    county_fips: 17097,
    county_name: "Lake",
    county_weights: {
      17097: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 17097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60061,
    lat: 42.2334,
    lng: -87.96046,
    city: "Vernon Hills",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27105,
    density: 1252.3,
    county_fips: 17097,
    county_name: "Lake",
    county_weights: {
      17097: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 17097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60062,
    lat: 42.12663,
    lng: -87.84235,
    city: "Northbrook",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39917,
    density: 815.3,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60064,
    lat: 42.3237,
    lng: -87.86122,
    city: "North Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15208,
    density: 1110.4,
    county_fips: 17097,
    county_name: "Lake",
    county_weights: {
      17097: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 17097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60067,
    lat: 42.10773,
    lng: -88.06478,
    city: "Palatine",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38660,
    density: 1147.2,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60068,
    lat: 42.01276,
    lng: -87.84435,
    city: "Park Ridge",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37407,
    density: 1975.4,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60069,
    lat: 42.19588,
    lng: -87.92439,
    city: "Lincolnshire",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8218,
    density: 535.1,
    county_fips: 17097,
    county_name: "Lake",
    county_weights: {
      17097: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 17097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60070,
    lat: 42.10406,
    lng: -87.92768,
    city: "Prospect Heights",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15729,
    density: 1527.6,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60071,
    lat: 42.46403,
    lng: -88.30975,
    city: "Richmond",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3602,
    density: 56,
    county_fips: 17111,
    county_name: "McHenry",
    county_weights: {
      17111: 100,
    },
    county_names_all: "McHenry",
    county_fips_all: 17111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60072,
    lat: 42.40647,
    lng: -88.30637,
    city: "Ringwood",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1020,
    density: 40.7,
    county_fips: 17111,
    county_name: "McHenry",
    county_weights: {
      17111: 100,
    },
    county_names_all: "McHenry",
    county_fips_all: 17111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60073,
    lat: 42.3516,
    lng: -88.10597,
    city: "Round Lake",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61856,
    density: 1293,
    county_fips: 17097,
    county_name: "Lake",
    county_weights: {
      17097: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 17097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60074,
    lat: 42.13179,
    lng: -88.02658,
    city: "Palatine",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37632,
    density: 2045.6,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 94.79,
      17097: 5.21,
    },
    county_names_all: "Cook|Lake",
    county_fips_all: "17031|17097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60075,
    lat: 42.49245,
    lng: -87.91205,
    city: "Russell",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 17097,
    county_name: "Lake",
    county_weights: {
      17097: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 17097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60076,
    lat: 42.03412,
    lng: -87.72943,
    city: "Skokie",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31393,
    density: 2360.4,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60077,
    lat: 42.03617,
    lng: -87.75633,
    city: "Skokie",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27653,
    density: 2523.6,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60081,
    lat: 42.45115,
    lng: -88.22173,
    city: "Spring Grove",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9532,
    density: 186.6,
    county_fips: 17111,
    county_name: "McHenry",
    county_weights: {
      17097: 19.19,
      17111: 80.81,
    },
    county_names_all: "McHenry|Lake",
    county_fips_all: "17111|17097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60083,
    lat: 42.43716,
    lng: -87.94663,
    city: "Wadsworth",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9511,
    density: 139.1,
    county_fips: 17097,
    county_name: "Lake",
    county_weights: {
      17097: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 17097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60084,
    lat: 42.26807,
    lng: -88.13856,
    city: "Wauconda",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16948,
    density: 465.9,
    county_fips: 17097,
    county_name: "Lake",
    county_weights: {
      17097: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 17097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60085,
    lat: 42.35498,
    lng: -87.86467,
    city: "Waukegan",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 71265,
    density: 1861,
    county_fips: 17097,
    county_name: "Lake",
    county_weights: {
      17097: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 17097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60087,
    lat: 42.40444,
    lng: -87.85631,
    city: "Waukegan",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25301,
    density: 753.5,
    county_fips: 17097,
    county_name: "Lake",
    county_weights: {
      17097: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 17097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60088,
    lat: 42.30685,
    lng: -87.85232,
    city: "Great Lakes",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12968,
    density: 2089.1,
    county_fips: 17097,
    county_name: "Lake",
    county_weights: {
      17097: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 17097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60089,
    lat: 42.16736,
    lng: -87.96076,
    city: "Buffalo Grove",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40749,
    density: 1598.1,
    county_fips: 17097,
    county_name: "Lake",
    county_weights: {
      17031: 21.6,
      17097: 78.4,
    },
    county_names_all: "Lake|Cook",
    county_fips_all: "17097|17031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60090,
    lat: 42.13031,
    lng: -87.92268,
    city: "Wheeling",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38741,
    density: 1665.1,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 99.55,
      17097: 0.45,
    },
    county_names_all: "Cook|Lake",
    county_fips_all: "17031|17097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60091,
    lat: 42.07693,
    lng: -87.72812,
    city: "Wilmette",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27004,
    density: 1951.8,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60093,
    lat: 42.10333,
    lng: -87.75826,
    city: "Winnetka",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19816,
    density: 913.5,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60096,
    lat: 42.48091,
    lng: -87.82978,
    city: "Winthrop Harbor",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6687,
    density: 545,
    county_fips: 17097,
    county_name: "Lake",
    county_weights: {
      17097: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 17097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60097,
    lat: 42.39343,
    lng: -88.36164,
    city: "Wonder Lake",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10727,
    density: 258.1,
    county_fips: 17111,
    county_name: "McHenry",
    county_weights: {
      17111: 100,
    },
    county_names_all: "McHenry",
    county_fips_all: 17111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60098,
    lat: 42.32468,
    lng: -88.45672,
    city: "Woodstock",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32599,
    density: 120.1,
    county_fips: 17111,
    county_name: "McHenry",
    county_weights: {
      17111: 100,
    },
    county_names_all: "McHenry",
    county_fips_all: 17111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60099,
    lat: 42.46053,
    lng: -87.86901,
    city: "Zion",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30145,
    density: 515.3,
    county_fips: 17097,
    county_name: "Lake",
    county_weights: {
      17097: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 17097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60101,
    lat: 41.931,
    lng: -88.01072,
    city: "Addison",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38596,
    density: 1308.4,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 100,
    },
    county_names_all: "DuPage",
    county_fips_all: 17043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60102,
    lat: 42.16406,
    lng: -88.30928,
    city: "Algonquin",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32749,
    density: 802.2,
    county_fips: 17111,
    county_name: "McHenry",
    county_weights: {
      17089: 22.47,
      17111: 77.53,
    },
    county_names_all: "McHenry|Kane",
    county_fips_all: "17111|17089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60103,
    lat: 41.97816,
    lng: -88.20511,
    city: "Bartlett",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41845,
    density: 880.3,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17031: 33.59,
      17043: 65.81,
      17089: 0.6,
    },
    county_names_all: "DuPage|Cook|Kane",
    county_fips_all: "17043|17031|17089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60104,
    lat: 41.88256,
    lng: -87.87646,
    city: "Bellwood",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18799,
    density: 3177.6,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60106,
    lat: 41.9611,
    lng: -87.94194,
    city: "Bensenville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20246,
    density: 844.8,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 100,
    },
    county_names_all: "DuPage",
    county_fips_all: 17043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60107,
    lat: 42.02148,
    lng: -88.1783,
    city: "Streamwood",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39970,
    density: 2003.1,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60108,
    lat: 41.94905,
    lng: -88.09232,
    city: "Bloomingdale",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22980,
    density: 1200.9,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 100,
    },
    county_names_all: "DuPage",
    county_fips_all: 17043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60109,
    lat: 42.04448,
    lng: -88.56261,
    city: "Burlington",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 496,
    density: 34.5,
    county_fips: 17089,
    county_name: "Kane",
    county_weights: {
      17089: 100,
    },
    county_names_all: "Kane",
    county_fips_all: 17089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60110,
    lat: 42.12296,
    lng: -88.2883,
    city: "Carpentersville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39094,
    density: 1799.2,
    county_fips: 17089,
    county_name: "Kane",
    county_weights: {
      17089: 100,
    },
    county_names_all: "Kane",
    county_fips_all: 17089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60111,
    lat: 42.00721,
    lng: -88.83114,
    city: "Clare",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 124,
    density: 2.2,
    county_fips: 17037,
    county_name: "DeKalb",
    county_weights: {
      17037: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 17037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60112,
    lat: 41.92391,
    lng: -88.68994,
    city: "Cortland",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4505,
    density: 475.9,
    county_fips: 17037,
    county_name: "DeKalb",
    county_weights: {
      17037: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 17037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60113,
    lat: 41.93142,
    lng: -88.96421,
    city: "Creston",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 309,
    density: 1251.3,
    county_fips: 17141,
    county_name: "Ogle",
    county_weights: {
      17141: 100,
    },
    county_names_all: "Ogle",
    county_fips_all: 17141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60115,
    lat: 41.90109,
    lng: -88.75469,
    city: "Dekalb",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45143,
    density: 215.1,
    county_fips: 17037,
    county_name: "DeKalb",
    county_weights: {
      17037: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 17037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60118,
    lat: 42.10793,
    lng: -88.30614,
    city: "Dundee",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16040,
    density: 295.8,
    county_fips: 17089,
    county_name: "Kane",
    county_weights: {
      17089: 100,
    },
    county_names_all: "Kane",
    county_fips_all: 17089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60119,
    lat: 41.86154,
    lng: -88.47702,
    city: "Elburn",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10397,
    density: 81,
    county_fips: 17089,
    county_name: "Kane",
    county_weights: {
      17089: 100,
    },
    county_names_all: "Kane",
    county_fips_all: 17089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60120,
    lat: 42.03317,
    lng: -88.2374,
    city: "Elgin",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50319,
    density: 1115,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 72,
      17089: 28,
    },
    county_names_all: "Cook|Kane",
    county_fips_all: "17031|17089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60123,
    lat: 42.04011,
    lng: -88.31166,
    city: "Elgin",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49765,
    density: 1375.7,
    county_fips: 17089,
    county_name: "Kane",
    county_weights: {
      17089: 100,
    },
    county_names_all: "Kane",
    county_fips_all: 17089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60124,
    lat: 42.02621,
    lng: -88.39691,
    city: "Elgin",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22001,
    density: 222.6,
    county_fips: 17089,
    county_name: "Kane",
    county_weights: {
      17089: 100,
    },
    county_names_all: "Kane",
    county_fips_all: 17089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60126,
    lat: 41.89627,
    lng: -87.94194,
    city: "Elmhurst",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48928,
    density: 1685.9,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17031: 2.68,
      17043: 97.32,
    },
    county_names_all: "DuPage|Cook",
    county_fips_all: "17043|17031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60129,
    lat: 42.02963,
    lng: -88.95371,
    city: "Esmond",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 220,
    density: 5.3,
    county_fips: 17141,
    county_name: "Ogle",
    county_weights: {
      17037: 27.35,
      17141: 72.65,
    },
    county_names_all: "Ogle|DeKalb",
    county_fips_all: "17141|17037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60130,
    lat: 41.86704,
    lng: -87.81795,
    city: "Forest Park",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13808,
    density: 1892,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60131,
    lat: 41.9378,
    lng: -87.88304,
    city: "Franklin Park",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17711,
    density: 1257.8,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60133,
    lat: 41.97805,
    lng: -88.14291,
    city: "Hanover Park",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37899,
    density: 1745.4,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17031: 34.57,
      17043: 65.43,
    },
    county_names_all: "DuPage|Cook",
    county_fips_all: "17043|17031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60134,
    lat: 41.8784,
    lng: -88.34189,
    city: "Geneva",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29022,
    density: 769.1,
    county_fips: 17089,
    county_name: "Kane",
    county_weights: {
      17089: 100,
    },
    county_names_all: "Kane",
    county_fips_all: 17089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60135,
    lat: 42.11265,
    lng: -88.67867,
    city: "Genoa",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6994,
    density: 57.7,
    county_fips: 17037,
    county_name: "DeKalb",
    county_weights: {
      17007: 1.63,
      17037: 96.2,
      17111: 2.17,
    },
    county_names_all: "DeKalb|McHenry|Boone",
    county_fips_all: "17037|17111|17007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60136,
    lat: 42.1053,
    lng: -88.37808,
    city: "Gilberts",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7941,
    density: 414.3,
    county_fips: 17089,
    county_name: "Kane",
    county_weights: {
      17089: 100,
    },
    county_names_all: "Kane",
    county_fips_all: 17089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60137,
    lat: 41.86539,
    lng: -88.06225,
    city: "Glen Ellyn",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37857,
    density: 1332.6,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 100,
    },
    county_names_all: "DuPage",
    county_fips_all: 17043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60139,
    lat: 41.91916,
    lng: -88.07735,
    city: "Glendale Heights",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33946,
    density: 2369.7,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 100,
    },
    county_names_all: "DuPage",
    county_fips_all: 17043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60140,
    lat: 42.08003,
    lng: -88.5086,
    city: "Hampshire",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18148,
    density: 86.5,
    county_fips: 17089,
    county_name: "Kane",
    county_weights: {
      17037: 4.19,
      17089: 94.55,
      17111: 1.26,
    },
    county_names_all: "Kane|DeKalb|McHenry",
    county_fips_all: "17089|17037|17111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60141,
    lat: 41.85834,
    lng: -87.8379,
    city: "Hines",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 324,
    density: 297.8,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60142,
    lat: 42.17517,
    lng: -88.44486,
    city: "Huntley",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29206,
    density: 290,
    county_fips: 17111,
    county_name: "McHenry",
    county_weights: {
      17089: 27.59,
      17111: 72.41,
    },
    county_names_all: "McHenry|Kane",
    county_fips_all: "17111|17089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60143,
    lat: 41.97351,
    lng: -88.02071,
    city: "Itasca",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11490,
    density: 636.6,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 100,
    },
    county_names_all: "DuPage",
    county_fips_all: 17043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60144,
    lat: 41.83507,
    lng: -88.51984,
    city: "Kaneville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67,
    density: 529.1,
    county_fips: 17089,
    county_name: "Kane",
    county_weights: {
      17089: 100,
    },
    county_names_all: "Kane",
    county_fips_all: 17089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60145,
    lat: 42.09396,
    lng: -88.77719,
    city: "Kingston",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3158,
    density: 36.1,
    county_fips: 17037,
    county_name: "DeKalb",
    county_weights: {
      17007: 5.37,
      17037: 94.63,
    },
    county_names_all: "DeKalb|Boone",
    county_fips_all: "17037|17007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60146,
    lat: 42.10091,
    lng: -88.88019,
    city: "Kirkland",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2235,
    density: 15.5,
    county_fips: 17037,
    county_name: "DeKalb",
    county_weights: {
      17007: 9.99,
      17037: 88.07,
      17141: 1.94,
    },
    county_names_all: "DeKalb|Boone|Ogle",
    county_fips_all: "17037|17007|17141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60148,
    lat: 41.87505,
    lng: -88.01859,
    city: "Lombard",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52057,
    density: 1454.1,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 100,
    },
    county_names_all: "DuPage",
    county_fips_all: 17043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60150,
    lat: 41.92106,
    lng: -88.88982,
    city: "Malta",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2077,
    density: 14.3,
    county_fips: 17037,
    county_name: "DeKalb",
    county_weights: {
      17037: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 17037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60151,
    lat: 41.9172,
    lng: -88.56613,
    city: "Maple Park",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4248,
    density: 19.9,
    county_fips: 17089,
    county_name: "Kane",
    county_weights: {
      17037: 24.61,
      17089: 75.39,
    },
    county_names_all: "Kane|DeKalb",
    county_fips_all: "17089|17037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60152,
    lat: 42.23882,
    lng: -88.62597,
    city: "Marengo",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12323,
    density: 49.9,
    county_fips: 17111,
    county_name: "McHenry",
    county_weights: {
      17037: 2.01,
      17111: 97.99,
    },
    county_names_all: "McHenry|DeKalb",
    county_fips_all: "17111|17037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60153,
    lat: 41.87984,
    lng: -87.84389,
    city: "Maywood",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23351,
    density: 3175.5,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60154,
    lat: 41.84923,
    lng: -87.88986,
    city: "Westchester",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16255,
    density: 1439.1,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60155,
    lat: 41.8578,
    lng: -87.85631,
    city: "Broadview",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7677,
    density: 1597.2,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60156,
    lat: 42.19121,
    lng: -88.34788,
    city: "Lake In The Hills",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28681,
    density: 1043.8,
    county_fips: 17111,
    county_name: "McHenry",
    county_weights: {
      17111: 100,
    },
    county_names_all: "McHenry",
    county_fips_all: 17111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60157,
    lat: 41.974,
    lng: -88.05476,
    city: "Medinah",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2740,
    density: 684.1,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 100,
    },
    county_names_all: "DuPage",
    county_fips_all: 17043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60160,
    lat: 41.90348,
    lng: -87.86176,
    city: "Melrose Park",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25357,
    density: 2150.9,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60162,
    lat: 41.86753,
    lng: -87.90196,
    city: "Hillside",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7996,
    density: 972.6,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60163,
    lat: 41.88794,
    lng: -87.90948,
    city: "Berkeley",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5079,
    density: 1556.7,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60164,
    lat: 41.91667,
    lng: -87.90112,
    city: "Melrose Park",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21120,
    density: 1660.2,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60165,
    lat: 41.90328,
    lng: -87.88056,
    city: "Stone Park",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4842,
    density: 5474.1,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60169,
    lat: 42.05192,
    lng: -88.11656,
    city: "Hoffman Estates",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33162,
    density: 1670.9,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60171,
    lat: 41.92504,
    lng: -87.83832,
    city: "River Grove",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9957,
    density: 1707.3,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60172,
    lat: 41.97976,
    lng: -88.08937,
    city: "Roselle",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24097,
    density: 1330,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17031: 17.24,
      17043: 82.76,
    },
    county_names_all: "DuPage|Cook",
    county_fips_all: "17043|17031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60173,
    lat: 42.05287,
    lng: -88.0526,
    city: "Schaumburg",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12619,
    density: 758.9,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60174,
    lat: 41.92759,
    lng: -88.29906,
    city: "Saint Charles",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30796,
    density: 866.6,
    county_fips: 17089,
    county_name: "Kane",
    county_weights: {
      17043: 1.33,
      17089: 98.67,
    },
    county_names_all: "Kane|DuPage",
    county_fips_all: "17089|17043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60175,
    lat: 41.94695,
    lng: -88.3913,
    city: "Saint Charles",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26775,
    density: 308.4,
    county_fips: 17089,
    county_name: "Kane",
    county_weights: {
      17089: 100,
    },
    county_names_all: "Kane",
    county_fips_all: 17089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60176,
    lat: 41.9583,
    lng: -87.8697,
    city: "Schiller Park",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11499,
    density: 1750.3,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60177,
    lat: 41.98931,
    lng: -88.30987,
    city: "South Elgin",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23097,
    density: 1004.3,
    county_fips: 17089,
    county_name: "Kane",
    county_weights: {
      17089: 100,
    },
    county_names_all: "Kane",
    county_fips_all: 17089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60178,
    lat: 42.00625,
    lng: -88.67205,
    city: "Sycamore",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22295,
    density: 128.2,
    county_fips: 17037,
    county_name: "DeKalb",
    county_weights: {
      17037: 93.3,
      17089: 6.7,
    },
    county_names_all: "DeKalb|Kane",
    county_fips_all: "17037|17089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60180,
    lat: 42.22342,
    lng: -88.52023,
    city: "Union",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1846,
    density: 34,
    county_fips: 17111,
    county_name: "McHenry",
    county_weights: {
      17111: 100,
    },
    county_names_all: "McHenry",
    county_fips_all: 17111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60181,
    lat: 41.87795,
    lng: -87.97626,
    city: "Villa Park",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29365,
    density: 1742.2,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 100,
    },
    county_names_all: "DuPage",
    county_fips_all: 17043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60183,
    lat: 41.94019,
    lng: -88.40908,
    city: "Wasco",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 17089,
    county_name: "Kane",
    county_weights: {
      17089: 100,
    },
    county_names_all: "Kane",
    county_fips_all: 17089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60184,
    lat: 41.95208,
    lng: -88.25323,
    city: "Wayne",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2447,
    density: 112.2,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 65.75,
      17089: 34.25,
    },
    county_names_all: "DuPage|Kane",
    county_fips_all: "17043|17089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60185,
    lat: 41.89308,
    lng: -88.21498,
    city: "West Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35581,
    density: 445.1,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 96.46,
      17089: 3.54,
    },
    county_names_all: "DuPage|Kane",
    county_fips_all: "17043|17089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60187,
    lat: 41.87231,
    lng: -88.1126,
    city: "Wheaton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29611,
    density: 1724.5,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 100,
    },
    county_names_all: "DuPage",
    county_fips_all: 17043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60188,
    lat: 41.91562,
    lng: -88.12958,
    city: "Carol Stream",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41472,
    density: 1593.2,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 100,
    },
    county_names_all: "DuPage",
    county_fips_all: 17043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60189,
    lat: 41.83957,
    lng: -88.12128,
    city: "Wheaton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30419,
    density: 1125.3,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 100,
    },
    county_names_all: "DuPage",
    county_fips_all: 17043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60190,
    lat: 41.87319,
    lng: -88.1576,
    city: "Winfield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11255,
    density: 891.2,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 100,
    },
    county_names_all: "DuPage",
    county_fips_all: 17043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60191,
    lat: 41.9647,
    lng: -87.98087,
    city: "Wood Dale",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13972,
    density: 1035.1,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 100,
    },
    county_names_all: "DuPage",
    county_fips_all: 17043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60192,
    lat: 42.07265,
    lng: -88.16797,
    city: "Hoffman Estates",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15618,
    density: 541,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60193,
    lat: 42.01195,
    lng: -88.09552,
    city: "Schaumburg",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38884,
    density: 1704.3,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60194,
    lat: 42.03339,
    lng: -88.11125,
    city: "Schaumburg",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19314,
    density: 2021.3,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60195,
    lat: 42.06541,
    lng: -88.08657,
    city: "Schaumburg",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4689,
    density: 1073.1,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60201,
    lat: 42.05665,
    lng: -87.69827,
    city: "Evanston",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41386,
    density: 3542.1,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60202,
    lat: 42.03043,
    lng: -87.68958,
    city: "Evanston",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32593,
    density: 4119,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60203,
    lat: 42.04905,
    lng: -87.71748,
    city: "Evanston",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4248,
    density: 2397.6,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60208,
    lat: 42.05457,
    lng: -87.67412,
    city: "Evanston",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60301,
    lat: 41.88865,
    lng: -87.79648,
    city: "Oak Park",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2998,
    density: 5942.1,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60302,
    lat: 41.8948,
    lng: -87.78983,
    city: "Oak Park",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31568,
    density: 4124.1,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60304,
    lat: 41.87249,
    lng: -87.78933,
    city: "Oak Park",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17536,
    density: 4369.3,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60305,
    lat: 41.89501,
    lng: -87.81943,
    city: "River Forest",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10883,
    density: 1696.3,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60401,
    lat: 41.34683,
    lng: -87.61306,
    city: "Beecher",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7590,
    density: 51.7,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17091: 1.97,
      17197: 98.03,
    },
    county_names_all: "Will|Kankakee",
    county_fips_all: "17197|17091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60402,
    lat: 41.83237,
    lng: -87.78983,
    city: "Berwyn",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62729,
    density: 4222.4,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60403,
    lat: 41.56696,
    lng: -88.12438,
    city: "Crest Hill",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20264,
    density: 1600,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17197: 100,
    },
    county_names_all: "Will",
    county_fips_all: 17197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60404,
    lat: 41.50864,
    lng: -88.22269,
    city: "Shorewood",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19118,
    density: 469.2,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17197: 100,
    },
    county_names_all: "Will",
    county_fips_all: 17197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60406,
    lat: 41.65509,
    lng: -87.68184,
    city: "Blue Island",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25849,
    density: 1858.2,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60407,
    lat: 41.23037,
    lng: -88.26415,
    city: "Braceville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1730,
    density: 49.4,
    county_fips: 17063,
    county_name: "Grundy",
    county_weights: {
      17063: 79.56,
      17197: 20.44,
    },
    county_names_all: "Grundy|Will",
    county_fips_all: "17063|17197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60408,
    lat: 41.26684,
    lng: -88.21733,
    city: "Braidwood",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5601,
    density: 338.6,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17197: 100,
    },
    county_names_all: "Will",
    county_fips_all: 17197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60409,
    lat: 41.61303,
    lng: -87.55142,
    city: "Calumet City",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36229,
    density: 1805.7,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60410,
    lat: 41.42119,
    lng: -88.2171,
    city: "Channahon",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13521,
    density: 216.9,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17063: 16.88,
      17197: 83.12,
    },
    county_names_all: "Will|Grundy",
    county_fips_all: "17197|17063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60411,
    lat: 41.50791,
    lng: -87.59031,
    city: "Chicago Heights",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56862,
    density: 715.4,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60415,
    lat: 41.70341,
    lng: -87.77953,
    city: "Chicago Ridge",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13945,
    density: 2375.9,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60416,
    lat: 41.29357,
    lng: -88.28197,
    city: "Coal City",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9090,
    density: 153.8,
    county_fips: 17063,
    county_name: "Grundy",
    county_weights: {
      17063: 96.26,
      17197: 3.74,
    },
    county_names_all: "Grundy|Will",
    county_fips_all: "17063|17197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60417,
    lat: 41.43056,
    lng: -87.59268,
    city: "Crete",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15187,
    density: 158.1,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17197: 100,
    },
    county_names_all: "Will",
    county_fips_all: 17197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60418,
    lat: 41.64568,
    lng: -87.74084,
    city: "Crestwood",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60419,
    lat: 41.62752,
    lng: -87.59871,
    city: "Dolton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22289,
    density: 2026.9,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60420,
    lat: 41.08795,
    lng: -88.42127,
    city: "Dwight",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4699,
    density: 18.8,
    county_fips: 17105,
    county_name: "Livingston",
    county_weights: {
      17063: 28.41,
      17105: 71.59,
    },
    county_names_all: "Livingston|Grundy",
    county_fips_all: "17105|17063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60421,
    lat: 41.40851,
    lng: -88.08936,
    city: "Elwood",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3907,
    density: 25.2,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17197: 100,
    },
    county_names_all: "Will",
    county_fips_all: 17197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60422,
    lat: 41.53861,
    lng: -87.68443,
    city: "Flossmoor",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9355,
    density: 906.9,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60423,
    lat: 41.47922,
    lng: -87.83961,
    city: "Frankfort",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31328,
    density: 319.3,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17031: 5.34,
      17197: 94.66,
    },
    county_names_all: "Will|Cook",
    county_fips_all: "17197|17031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60424,
    lat: 41.16604,
    lng: -88.32941,
    city: "Gardner",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2279,
    density: 16.7,
    county_fips: 17063,
    county_name: "Grundy",
    county_weights: {
      17063: 93.99,
      17091: 6.01,
    },
    county_names_all: "Grundy|Kankakee",
    county_fips_all: "17063|17091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60425,
    lat: 41.54343,
    lng: -87.61073,
    city: "Glenwood",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8965,
    density: 615,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60426,
    lat: 41.61026,
    lng: -87.65309,
    city: "Harvey",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27863,
    density: 1390.7,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60428,
    lat: 41.5998,
    lng: -87.69062,
    city: "Markham",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12067,
    density: 918.2,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60429,
    lat: 41.5737,
    lng: -87.68331,
    city: "Hazel Crest",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15393,
    density: 1458.7,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60430,
    lat: 41.5584,
    lng: -87.66214,
    city: "Homewood",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19728,
    density: 1106.8,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60431,
    lat: 41.53355,
    lng: -88.20568,
    city: "Joliet",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23860,
    density: 717.4,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17093: 26.22,
      17197: 73.78,
    },
    county_names_all: "Will|Kendall",
    county_fips_all: "17197|17093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60432,
    lat: 41.54087,
    lng: -88.0406,
    city: "Joliet",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20282,
    density: 919.4,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17197: 100,
    },
    county_names_all: "Will",
    county_fips_all: 17197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60433,
    lat: 41.49895,
    lng: -88.04248,
    city: "Joliet",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16029,
    density: 456.4,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17197: 100,
    },
    county_names_all: "Will",
    county_fips_all: 17197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60435,
    lat: 41.54492,
    lng: -88.1288,
    city: "Joliet",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49461,
    density: 1763.4,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17197: 100,
    },
    county_names_all: "Will",
    county_fips_all: 17197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60436,
    lat: 41.48973,
    lng: -88.12392,
    city: "Joliet",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18378,
    density: 394.3,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17197: 100,
    },
    county_names_all: "Will",
    county_fips_all: 17197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60437,
    lat: 41.16168,
    lng: -88.54981,
    city: "Kinsman",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 133,
    density: 2.7,
    county_fips: 17063,
    county_name: "Grundy",
    county_weights: {
      17063: 99.83,
      17105: 0.17,
    },
    county_names_all: "Grundy|Livingston",
    county_fips_all: "17063|17105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60438,
    lat: 41.56625,
    lng: -87.55065,
    city: "Lansing",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28291,
    density: 1354.9,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60439,
    lat: 41.67692,
    lng: -87.97623,
    city: "Lemont",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24697,
    density: 321,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 66.84,
      17043: 24.86,
      17197: 8.3,
    },
    county_names_all: "Cook|DuPage|Will",
    county_fips_all: "17031|17043|17197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60440,
    lat: 41.70125,
    lng: -88.07572,
    city: "Bolingbrook",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52440,
    density: 1342.7,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17043: 1.94,
      17197: 98.06,
    },
    county_names_all: "Will|DuPage",
    county_fips_all: "17197|17043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60441,
    lat: 41.59238,
    lng: -88.05106,
    city: "Lockport",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33934,
    density: 465.5,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17197: 100,
    },
    county_names_all: "Will",
    county_fips_all: 17197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60442,
    lat: 41.39189,
    lng: -87.96062,
    city: "Manhattan",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11310,
    density: 65.1,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17197: 100,
    },
    county_names_all: "Will",
    county_fips_all: 17197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60443,
    lat: 41.50369,
    lng: -87.74637,
    city: "Matteson",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21698,
    density: 744.1,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60444,
    lat: 41.24246,
    lng: -88.40403,
    city: "Mazon",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1927,
    density: 15,
    county_fips: 17063,
    county_name: "Grundy",
    county_weights: {
      17063: 100,
    },
    county_names_all: "Grundy",
    county_fips_all: 17063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60445,
    lat: 41.62833,
    lng: -87.73542,
    city: "Midlothian",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25411,
    density: 2285.7,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60446,
    lat: 41.63304,
    lng: -88.09855,
    city: "Romeoville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40032,
    density: 792.3,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17197: 100,
    },
    county_names_all: "Will",
    county_fips_all: 17197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60447,
    lat: 41.48796,
    lng: -88.32498,
    city: "Minooka",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13907,
    density: 79.4,
    county_fips: 17093,
    county_name: "Kendall",
    county_weights: {
      17063: 21.37,
      17093: 72.89,
      17197: 5.74,
    },
    county_names_all: "Kendall|Grundy|Will",
    county_fips_all: "17093|17063|17197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60448,
    lat: 41.53821,
    lng: -87.89396,
    city: "Mokena",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25878,
    density: 545.7,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17197: 100,
    },
    county_names_all: "Will",
    county_fips_all: 17197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60449,
    lat: 41.41392,
    lng: -87.76978,
    city: "Monee",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9707,
    density: 76.1,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17031: 1.26,
      17197: 98.74,
    },
    county_names_all: "Will|Cook",
    county_fips_all: "17197|17031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60450,
    lat: 41.37011,
    lng: -88.43417,
    city: "Morris",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20600,
    density: 50.5,
    county_fips: 17063,
    county_name: "Grundy",
    county_weights: {
      17063: 97.91,
      17093: 2.09,
    },
    county_names_all: "Grundy|Kendall",
    county_fips_all: "17063|17093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60451,
    lat: 41.50717,
    lng: -87.96088,
    city: "New Lenox",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36036,
    density: 553.1,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17197: 100,
    },
    county_names_all: "Will",
    county_fips_all: 17197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60452,
    lat: 41.60851,
    lng: -87.75434,
    city: "Oak Forest",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27605,
    density: 1241.1,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60453,
    lat: 41.71412,
    lng: -87.75278,
    city: "Oak Lawn",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55515,
    density: 2523.4,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60455,
    lat: 41.74102,
    lng: -87.8068,
    city: "Bridgeview",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15998,
    density: 1456.8,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60456,
    lat: 41.73125,
    lng: -87.73111,
    city: "Hometown",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4216,
    density: 3399.1,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60457,
    lat: 41.72475,
    lng: -87.82987,
    city: "Hickory Hills",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13831,
    density: 1703.9,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60458,
    lat: 41.74892,
    lng: -87.83484,
    city: "Justice",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15318,
    density: 2027.6,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60459,
    lat: 41.74436,
    lng: -87.76872,
    city: "Burbank",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28447,
    density: 2626.1,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60460,
    lat: 40.9997,
    lng: -88.53393,
    city: "Odell",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1206,
    density: 4.7,
    county_fips: 17105,
    county_name: "Livingston",
    county_weights: {
      17105: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 17105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60461,
    lat: 41.51752,
    lng: -87.69148,
    city: "Olympia Fields",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4677,
    density: 536.4,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60462,
    lat: 41.62527,
    lng: -87.83548,
    city: "Orland Park",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40067,
    density: 968.2,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60463,
    lat: 41.66084,
    lng: -87.79033,
    city: "Palos Heights",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14556,
    density: 1067.5,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60464,
    lat: 41.67088,
    lng: -87.86869,
    city: "Palos Park",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9625,
    density: 282.3,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60465,
    lat: 41.69878,
    lng: -87.8267,
    city: "Palos Hills",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17197,
    density: 1542.5,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60466,
    lat: 41.47966,
    lng: -87.68276,
    city: "Park Forest",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20856,
    density: 1274.9,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 72.89,
      17197: 27.11,
    },
    county_names_all: "Cook|Will",
    county_fips_all: "17031|17197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60467,
    lat: 41.59855,
    lng: -87.88848,
    city: "Orland Park",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26056,
    density: 681.2,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 94.05,
      17197: 5.95,
    },
    county_names_all: "Cook|Will",
    county_fips_all: "17031|17197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60468,
    lat: 41.33636,
    lng: -87.80991,
    city: "Peotone",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5986,
    density: 33.2,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17091: 4.74,
      17197: 95.26,
    },
    county_names_all: "Will|Kankakee",
    county_fips_all: "17197|17091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60469,
    lat: 41.62871,
    lng: -87.68634,
    city: "Posen",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5482,
    density: 1867,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60470,
    lat: 41.16592,
    lng: -88.63876,
    city: "Ransom",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 430,
    density: 3.9,
    county_fips: 17099,
    county_name: "LaSalle",
    county_weights: {
      17063: 3.95,
      17099: 91.7,
      17105: 4.35,
    },
    county_names_all: "LaSalle|Livingston|Grundy",
    county_fips_all: "17099|17105|17063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60471,
    lat: 41.48009,
    lng: -87.72981,
    city: "Richton Park",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13875,
    density: 1349.9,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 95.64,
      17197: 4.36,
    },
    county_names_all: "Cook|Will",
    county_fips_all: "17031|17197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60472,
    lat: 41.6437,
    lng: -87.70836,
    city: "Robbins",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4968,
    density: 1135.2,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60473,
    lat: 41.59733,
    lng: -87.60115,
    city: "South Holland",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22187,
    density: 1092.1,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60474,
    lat: 41.1765,
    lng: -88.26983,
    city: "South Wilmington",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 745,
    density: 53.5,
    county_fips: 17063,
    county_name: "Grundy",
    county_weights: {
      17063: 100,
    },
    county_names_all: "Grundy",
    county_fips_all: 17063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60475,
    lat: 41.47193,
    lng: -87.6283,
    city: "Steger",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9782,
    density: 783.9,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 68.23,
      17197: 31.77,
    },
    county_names_all: "Cook|Will",
    county_fips_all: "17031|17197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60476,
    lat: 41.5694,
    lng: -87.60562,
    city: "Thornton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2313,
    density: 269.7,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60477,
    lat: 41.57347,
    lng: -87.78597,
    city: "Tinley Park",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36843,
    density: 1000.3,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 96.35,
      17197: 3.65,
    },
    county_names_all: "Cook|Will",
    county_fips_all: "17031|17197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60478,
    lat: 41.55381,
    lng: -87.73588,
    city: "Country Club Hills",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16573,
    density: 653.9,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60479,
    lat: 41.23174,
    lng: -88.52078,
    city: "Verona",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1082,
    density: 10.7,
    county_fips: 17063,
    county_name: "Grundy",
    county_weights: {
      17063: 100,
    },
    county_names_all: "Grundy",
    county_fips_all: 17063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60480,
    lat: 41.71909,
    lng: -87.87675,
    city: "Willow Springs",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5009,
    density: 172.1,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60481,
    lat: 41.28795,
    lng: -88.12952,
    city: "Wilmington",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11531,
    density: 36,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17063: 0.62,
      17091: 2.31,
      17197: 97.07,
    },
    county_names_all: "Will|Kankakee|Grundy",
    county_fips_all: "17197|17091|17063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60482,
    lat: 41.68737,
    lng: -87.79239,
    city: "Worth",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10732,
    density: 1775.6,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60484,
    lat: 41.44317,
    lng: -87.70948,
    city: "University Park",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6658,
    density: 341.5,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17197: 100,
    },
    county_names_all: "Will",
    county_fips_all: 17197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60487,
    lat: 41.56236,
    lng: -87.83095,
    city: "Tinley Park",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26822,
    density: 1385.2,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 58.98,
      17197: 41.02,
    },
    county_names_all: "Cook|Will",
    county_fips_all: "17031|17197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60490,
    lat: 41.67575,
    lng: -88.14118,
    city: "Bolingbrook",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21851,
    density: 872.4,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17197: 100,
    },
    county_names_all: "Will",
    county_fips_all: 17197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60491,
    lat: 41.60313,
    lng: -87.9595,
    city: "Homer Glen",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22848,
    density: 344.7,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17197: 100,
    },
    county_names_all: "Will",
    county_fips_all: 17197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60501,
    lat: 41.77979,
    lng: -87.82393,
    city: "Summit Argo",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11840,
    density: 1049.5,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60502,
    lat: 41.78911,
    lng: -88.25952,
    city: "Aurora",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22970,
    density: 794.1,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 59.64,
      17089: 40.36,
    },
    county_names_all: "DuPage|Kane",
    county_fips_all: "17043|17089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60503,
    lat: 41.7079,
    lng: -88.25475,
    city: "Aurora",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17229,
    density: 1556.1,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17093: 27.58,
      17197: 72.42,
    },
    county_names_all: "Will|Kendall",
    county_fips_all: "17197|17093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60504,
    lat: 41.74649,
    lng: -88.23957,
    city: "Aurora",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39449,
    density: 1734.4,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 80.05,
      17089: 19.15,
      17093: 0.8,
    },
    county_names_all: "DuPage|Kane|Kendall",
    county_fips_all: "17043|17089|17093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60505,
    lat: 41.76527,
    lng: -88.29576,
    city: "Aurora",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 71617,
    density: 2726.7,
    county_fips: 17089,
    county_name: "Kane",
    county_weights: {
      17089: 100,
    },
    county_names_all: "Kane",
    county_fips_all: 17089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60506,
    lat: 41.76176,
    lng: -88.37125,
    city: "Aurora",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55895,
    density: 1015.8,
    county_fips: 17089,
    county_name: "Kane",
    county_weights: {
      17089: 99.23,
      17093: 0.77,
    },
    county_names_all: "Kane|Kendall",
    county_fips_all: "17089|17093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60510,
    lat: 41.84283,
    lng: -88.31189,
    city: "Batavia",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29352,
    density: 464.7,
    county_fips: 17089,
    county_name: "Kane",
    county_weights: {
      17043: 17.32,
      17089: 82.68,
    },
    county_names_all: "Kane|DuPage",
    county_fips_all: "17089|17043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60511,
    lat: 41.75778,
    lng: -88.55601,
    city: "Big Rock",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1746,
    density: 22.5,
    county_fips: 17089,
    county_name: "Kane",
    county_weights: {
      17037: 3.86,
      17089: 96.14,
    },
    county_names_all: "Kane|DeKalb",
    county_fips_all: "17089|17037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60512,
    lat: 41.70134,
    lng: -88.43986,
    city: "Bristol",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1671,
    density: 98.5,
    county_fips: 17093,
    county_name: "Kendall",
    county_weights: {
      17093: 100,
    },
    county_names_all: "Kendall",
    county_fips_all: 17093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60513,
    lat: 41.82459,
    lng: -87.8469,
    city: "Brookfield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18537,
    density: 2268.8,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60514,
    lat: 41.79655,
    lng: -87.95683,
    city: "Clarendon Hills",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9970,
    density: 1888.9,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 100,
    },
    county_names_all: "DuPage",
    county_fips_all: 17043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60515,
    lat: 41.80991,
    lng: -88.0247,
    city: "Downers Grove",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27978,
    density: 914.1,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 100,
    },
    county_names_all: "DuPage",
    county_fips_all: 17043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60516,
    lat: 41.76327,
    lng: -88.01314,
    city: "Downers Grove",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29639,
    density: 1510.5,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 100,
    },
    county_names_all: "DuPage",
    county_fips_all: 17043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60517,
    lat: 41.73913,
    lng: -88.04161,
    city: "Woodridge",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32099,
    density: 1328.9,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 90.54,
      17197: 9.46,
    },
    county_names_all: "DuPage|Will",
    county_fips_all: "17043|17197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60518,
    lat: 41.59997,
    lng: -88.92215,
    city: "Earlville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3854,
    density: 11.2,
    county_fips: 17099,
    county_name: "LaSalle",
    county_weights: {
      17037: 25.27,
      17099: 66.02,
      17103: 8.71,
    },
    county_names_all: "LaSalle|DeKalb|Lee",
    county_fips_all: "17099|17037|17103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60519,
    lat: 41.77724,
    lng: -88.24255,
    city: "Eola",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26,
    density: 193,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 100,
    },
    county_names_all: "DuPage",
    county_fips_all: 17043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60520,
    lat: 41.7826,
    lng: -88.65808,
    city: "Hinckley",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2958,
    density: 25.4,
    county_fips: 17037,
    county_name: "DeKalb",
    county_weights: {
      17037: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 17037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60521,
    lat: 41.80019,
    lng: -87.92883,
    city: "Hinsdale",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18095,
    density: 1477.2,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17031: 16.62,
      17043: 83.38,
    },
    county_names_all: "DuPage|Cook",
    county_fips_all: "17043|17031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60523,
    lat: 41.83713,
    lng: -87.95406,
    city: "Oak Brook",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9763,
    density: 421,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17031: 0.16,
      17043: 99.84,
    },
    county_names_all: "DuPage|Cook",
    county_fips_all: "17043|17031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60525,
    lat: 41.78371,
    lng: -87.86778,
    city: "La Grange",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30274,
    density: 895.3,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60526,
    lat: 41.83002,
    lng: -87.8836,
    city: "La Grange Park",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13178,
    density: 1310.5,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60527,
    lat: 41.74472,
    lng: -87.93383,
    city: "Willowbrook",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26800,
    density: 718.6,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17031: 20.44,
      17043: 79.56,
    },
    county_names_all: "DuPage|Cook",
    county_fips_all: "17043|17031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60530,
    lat: 41.79613,
    lng: -88.95988,
    city: "Lee",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 779,
    density: 10.8,
    county_fips: 17103,
    county_name: "Lee",
    county_weights: {
      17037: 31.71,
      17103: 68.29,
    },
    county_names_all: "Lee|DeKalb",
    county_fips_all: "17103|17037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60531,
    lat: 41.61563,
    lng: -88.78639,
    city: "Leland",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2004,
    density: 12.6,
    county_fips: 17099,
    county_name: "LaSalle",
    county_weights: {
      17037: 37.89,
      17099: 62.11,
    },
    county_names_all: "LaSalle|DeKalb",
    county_fips_all: "17099|17037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60532,
    lat: 41.79153,
    lng: -88.08576,
    city: "Lisle",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28586,
    density: 1291.8,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 100,
    },
    county_names_all: "DuPage",
    county_fips_all: 17043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60534,
    lat: 41.81311,
    lng: -87.82066,
    city: "Lyons",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10321,
    density: 2128.4,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60536,
    lat: 41.59853,
    lng: -88.55212,
    city: "Millbrook",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 108,
    density: 311,
    county_fips: 17093,
    county_name: "Kendall",
    county_weights: {
      17093: 100,
    },
    county_names_all: "Kendall",
    county_fips_all: 17093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60537,
    lat: 41.56158,
    lng: -88.60246,
    city: "Millington",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 655,
    density: 306.2,
    county_fips: 17099,
    county_name: "LaSalle",
    county_weights: {
      17093: 28.83,
      17099: 71.17,
    },
    county_names_all: "LaSalle|Kendall",
    county_fips_all: "17099|17093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60538,
    lat: 41.72165,
    lng: -88.35637,
    city: "Montgomery",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28206,
    density: 1122.4,
    county_fips: 17093,
    county_name: "Kendall",
    county_weights: {
      17089: 46.5,
      17093: 53.5,
    },
    county_names_all: "Kendall|Kane",
    county_fips_all: "17093|17089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60539,
    lat: 41.825,
    lng: -88.33529,
    city: "Mooseheart",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 175,
    density: 77.8,
    county_fips: 17089,
    county_name: "Kane",
    county_weights: {
      17089: 100,
    },
    county_names_all: "Kane",
    county_fips_all: 17089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60540,
    lat: 41.76361,
    lng: -88.14476,
    city: "Naperville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43887,
    density: 1281.8,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 100,
    },
    county_names_all: "DuPage",
    county_fips_all: 17043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60541,
    lat: 41.5193,
    lng: -88.52552,
    city: "Newark",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3615,
    density: 16.8,
    county_fips: 17093,
    county_name: "Kendall",
    county_weights: {
      17063: 9.3,
      17093: 89.79,
      17099: 0.91,
    },
    county_names_all: "Kendall|Grundy|LaSalle",
    county_fips_all: "17093|17063|17099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60542,
    lat: 41.80878,
    lng: -88.3489,
    city: "North Aurora",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18363,
    density: 748.6,
    county_fips: 17089,
    county_name: "Kane",
    county_weights: {
      17089: 100,
    },
    county_names_all: "Kane",
    county_fips_all: 17089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60543,
    lat: 41.66537,
    lng: -88.32442,
    city: "Oswego",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40930,
    density: 376.7,
    county_fips: 17093,
    county_name: "Kendall",
    county_weights: {
      17089: 0.16,
      17093: 99.25,
      17197: 0.59,
    },
    county_names_all: "Kendall|Will|Kane",
    county_fips_all: "17093|17197|17089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60544,
    lat: 41.61393,
    lng: -88.21777,
    city: "Plainfield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27709,
    density: 441.9,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17093: 24.16,
      17197: 75.84,
    },
    county_names_all: "Will|Kendall",
    county_fips_all: "17197|17093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60545,
    lat: 41.67815,
    lng: -88.53587,
    city: "Plano",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13476,
    density: 142.2,
    county_fips: 17093,
    county_name: "Kendall",
    county_weights: {
      17093: 100,
    },
    county_names_all: "Kendall",
    county_fips_all: 17093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60546,
    lat: 41.83834,
    lng: -87.82132,
    city: "Riverside",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15208,
    density: 1473.3,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60548,
    lat: 41.64811,
    lng: -88.63471,
    city: "Sandwich",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12170,
    density: 113.6,
    county_fips: 17037,
    county_name: "DeKalb",
    county_weights: {
      17037: 53.93,
      17093: 11.84,
      17099: 34.23,
    },
    county_names_all: "DeKalb|LaSalle|Kendall",
    county_fips_all: "17037|17099|17093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60549,
    lat: 41.4908,
    lng: -88.74251,
    city: "Serena",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 337,
    density: 5.5,
    county_fips: 17099,
    county_name: "LaSalle",
    county_weights: {
      17099: 100,
    },
    county_names_all: "LaSalle",
    county_fips_all: 17099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60550,
    lat: 41.77708,
    lng: -88.87777,
    city: "Shabbona",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1261,
    density: 11.8,
    county_fips: 17037,
    county_name: "DeKalb",
    county_weights: {
      17037: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 17037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60551,
    lat: 41.52463,
    lng: -88.68992,
    city: "Sheridan",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5200,
    density: 33.9,
    county_fips: 17099,
    county_name: "LaSalle",
    county_weights: {
      17099: 100,
    },
    county_names_all: "LaSalle",
    county_fips_all: 17099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60552,
    lat: 41.66144,
    lng: -88.70343,
    city: "Somonauk",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4443,
    density: 64.5,
    county_fips: 17037,
    county_name: "DeKalb",
    county_weights: {
      17037: 80.78,
      17099: 19.22,
    },
    county_names_all: "DeKalb|LaSalle",
    county_fips_all: "17037|17099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60553,
    lat: 41.82399,
    lng: -89.02806,
    city: "Steward",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 749,
    density: 5.9,
    county_fips: 17103,
    county_name: "Lee",
    county_weights: {
      17103: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 17103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60554,
    lat: 41.77852,
    lng: -88.45838,
    city: "Sugar Grove",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12458,
    density: 135.4,
    county_fips: 17089,
    county_name: "Kane",
    county_weights: {
      17089: 98.22,
      17093: 1.78,
    },
    county_names_all: "Kane|Kendall",
    county_fips_all: "17089|17093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60555,
    lat: 41.82261,
    lng: -88.18854,
    city: "Warrenville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13282,
    density: 638.2,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 100,
    },
    county_names_all: "DuPage",
    county_fips_all: 17043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60556,
    lat: 41.76507,
    lng: -88.77373,
    city: "Waterman",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2406,
    density: 17.7,
    county_fips: 17037,
    county_name: "DeKalb",
    county_weights: {
      17037: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 17037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60557,
    lat: 41.44383,
    lng: -88.76654,
    city: "Wedron",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 255,
    density: 112.1,
    county_fips: 17099,
    county_name: "LaSalle",
    county_weights: {
      17099: 100,
    },
    county_names_all: "LaSalle",
    county_fips_all: 17099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60558,
    lat: 41.80207,
    lng: -87.90076,
    city: "Western Springs",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13247,
    density: 1798.3,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60559,
    lat: 41.79496,
    lng: -87.97464,
    city: "Westmont",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24642,
    density: 2026.3,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 100,
    },
    county_names_all: "DuPage",
    county_fips_all: 17043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60560,
    lat: 41.60799,
    lng: -88.42841,
    city: "Yorkville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25273,
    density: 122.9,
    county_fips: 17093,
    county_name: "Kendall",
    county_weights: {
      17093: 100,
    },
    county_names_all: "Kendall",
    county_fips_all: 17093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60561,
    lat: 41.74518,
    lng: -87.98174,
    city: "Darien",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22674,
    density: 1317.5,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 100,
    },
    county_names_all: "DuPage",
    county_fips_all: 17043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60563,
    lat: 41.79933,
    lng: -88.16884,
    city: "Naperville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38785,
    density: 1028.2,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 100,
    },
    county_names_all: "DuPage",
    county_fips_all: 17043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60564,
    lat: 41.70901,
    lng: -88.19961,
    city: "Naperville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43667,
    density: 1052.5,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17043: 25.08,
      17197: 74.92,
    },
    county_names_all: "Will|DuPage",
    county_fips_all: "17197|17043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60565,
    lat: 41.7297,
    lng: -88.12312,
    city: "Naperville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39261,
    density: 1177,
    county_fips: 17043,
    county_name: "DuPage",
    county_weights: {
      17043: 62.98,
      17197: 37.02,
    },
    county_names_all: "DuPage|Will",
    county_fips_all: "17043|17197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60585,
    lat: 41.65864,
    lng: -88.22339,
    city: "Plainfield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25503,
    density: 661.6,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17093: 11.81,
      17197: 88.19,
    },
    county_names_all: "Will|Kendall",
    county_fips_all: "17197|17093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60586,
    lat: 41.57036,
    lng: -88.23162,
    city: "Plainfield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46942,
    density: 1038.2,
    county_fips: 17197,
    county_name: "Will",
    county_weights: {
      17093: 26.39,
      17197: 73.61,
    },
    county_names_all: "Will|Kendall",
    county_fips_all: "17197|17093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60601,
    lat: 41.88527,
    lng: -87.62197,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14513,
    density: 14417.8,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60602,
    lat: 41.88304,
    lng: -87.62906,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1596,
    density: 7477.9,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60603,
    lat: 41.88018,
    lng: -87.6274,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1186,
    density: 3859.9,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60604,
    lat: 41.87799,
    lng: -87.62928,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 729,
    density: 3644.3,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60605,
    lat: 41.86644,
    lng: -87.61956,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30950,
    density: 8354.1,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60606,
    lat: 41.88178,
    lng: -87.63724,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3204,
    density: 5330.7,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60607,
    lat: 41.87467,
    lng: -87.65175,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30306,
    density: 5058.2,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60608,
    lat: 41.84887,
    lng: -87.67139,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 80011,
    density: 4945.4,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60609,
    lat: 41.81263,
    lng: -87.65559,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60551,
    density: 3016.8,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60610,
    lat: 41.90388,
    lng: -87.63738,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40954,
    density: 14216.1,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60611,
    lat: 41.89483,
    lng: -87.61944,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33937,
    density: 16525.1,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60612,
    lat: 41.8805,
    lng: -87.68783,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32240,
    density: 3347.3,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60613,
    lat: 41.9558,
    lng: -87.65706,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51399,
    density: 8524.2,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60614,
    lat: 41.92267,
    lng: -87.6506,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 72391,
    density: 8674.5,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60615,
    lat: 41.80226,
    lng: -87.60293,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41198,
    density: 7267.4,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60616,
    lat: 41.84502,
    lng: -87.62745,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52557,
    density: 5340,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60617,
    lat: 41.71337,
    lng: -87.55618,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 82101,
    density: 2318.4,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60618,
    lat: 41.94694,
    lng: -87.70263,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 94646,
    density: 7317.4,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60619,
    lat: 41.74346,
    lng: -87.60532,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61372,
    density: 3869.8,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60620,
    lat: 41.74096,
    lng: -87.65257,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68761,
    density: 3794.1,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60621,
    lat: 41.77624,
    lng: -87.63955,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26736,
    density: 2749.6,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60622,
    lat: 41.90267,
    lng: -87.68355,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52957,
    density: 8179.1,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60623,
    lat: 41.84793,
    lng: -87.71753,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 77732,
    density: 5581.9,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60624,
    lat: 41.88045,
    lng: -87.72366,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35054,
    density: 3815.6,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60625,
    lat: 41.97318,
    lng: -87.69963,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 78820,
    density: 8086.3,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60626,
    lat: 42.00904,
    lng: -87.66955,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51017,
    density: 11475.9,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60628,
    lat: 41.69165,
    lng: -87.61828,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65008,
    density: 2286.4,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60629,
    lat: 41.7754,
    lng: -87.71239,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 107930,
    density: 5912.3,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60630,
    lat: 41.97222,
    lng: -87.75758,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55692,
    density: 4535.1,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60631,
    lat: 41.99473,
    lng: -87.8131,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28864,
    density: 2974.8,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60632,
    lat: 41.81141,
    lng: -87.71348,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 86715,
    density: 4494.5,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60633,
    lat: 41.66315,
    lng: -87.56044,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12720,
    density: 503.8,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60634,
    lat: 41.94627,
    lng: -87.80639,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75604,
    density: 4105.9,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60636,
    lat: 41.77578,
    lng: -87.66909,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30039,
    density: 2964.3,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60637,
    lat: 41.78156,
    lng: -87.6032,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46621,
    density: 3975.7,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60638,
    lat: 41.78175,
    lng: -87.77057,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57057,
    density: 1991,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60639,
    lat: 41.9206,
    lng: -87.75593,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 88515,
    density: 6886.9,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60640,
    lat: 41.97253,
    lng: -87.66372,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69726,
    density: 11400.9,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60641,
    lat: 41.94667,
    lng: -87.74693,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 70163,
    density: 6727.5,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60642,
    lat: 41.90193,
    lng: -87.65804,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20191,
    density: 4674.6,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60643,
    lat: 41.70026,
    lng: -87.663,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48572,
    density: 2549.6,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60644,
    lat: 41.88013,
    lng: -87.75756,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45919,
    density: 5050,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60645,
    lat: 42.00859,
    lng: -87.69457,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46924,
    density: 8139.4,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60646,
    lat: 41.99365,
    lng: -87.76128,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29043,
    density: 2526.8,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60647,
    lat: 41.92074,
    lng: -87.702,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 85658,
    density: 8345.9,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60649,
    lat: 41.75885,
    lng: -87.56368,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47084,
    density: 5022,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60651,
    lat: 41.90202,
    lng: -87.74104,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63679,
    density: 7099.9,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60652,
    lat: 41.74744,
    lng: -87.71445,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42296,
    density: 3375.5,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60653,
    lat: 41.81924,
    lng: -87.61017,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33574,
    density: 5493.8,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60654,
    lat: 41.89209,
    lng: -87.63673,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20812,
    density: 14831.3,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60655,
    lat: 41.69479,
    lng: -87.70374,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27771,
    density: 2432.5,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60656,
    lat: 41.97424,
    lng: -87.82709,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28982,
    density: 3457.1,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60657,
    lat: 41.93965,
    lng: -87.65495,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 70489,
    density: 12515.9,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60659,
    lat: 41.98946,
    lng: -87.70668,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43843,
    density: 7173.8,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60660,
    lat: 41.99113,
    lng: -87.66609,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45131,
    density: 13679.8,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60661,
    lat: 41.88291,
    lng: -87.64409,
    city: "Chicago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10734,
    density: 13562.3,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60706,
    lat: 41.96384,
    lng: -87.81672,
    city: "Harwood Heights",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22804,
    density: 2856.7,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60707,
    lat: 41.92175,
    lng: -87.80744,
    city: "Elmwood Park",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42434,
    density: 4579.2,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60712,
    lat: 42.00543,
    lng: -87.73296,
    city: "Lincolnwood",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12338,
    density: 1769.8,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60714,
    lat: 42.02834,
    lng: -87.81131,
    city: "Niles",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29429,
    density: 1809.5,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60803,
    lat: 41.67233,
    lng: -87.73652,
    city: "Alsip",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22447,
    density: 1117.6,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60804,
    lat: 41.84005,
    lng: -87.75925,
    city: "Cicero",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 81505,
    density: 4422.6,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60805,
    lat: 41.72201,
    lng: -87.70243,
    city: "Evergreen Park",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19290,
    density: 2185.4,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60827,
    lat: 41.64967,
    lng: -87.63013,
    city: "Riverdale",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28327,
    density: 1556.5,
    county_fips: 17031,
    county_name: "Cook",
    county_weights: {
      17031: 100,
    },
    county_names_all: "Cook",
    county_fips_all: 17031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60901,
    lat: 41.11029,
    lng: -87.90049,
    city: "Kankakee",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35432,
    density: 140.6,
    county_fips: 17091,
    county_name: "Kankakee",
    county_weights: {
      17091: 100,
    },
    county_names_all: "Kankakee",
    county_fips_all: 17091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60910,
    lat: 41.06426,
    lng: -87.79991,
    city: "Aroma Park",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 520,
    density: 83.4,
    county_fips: 17091,
    county_name: "Kankakee",
    county_weights: {
      17091: 100,
    },
    county_names_all: "Kankakee",
    county_fips_all: 17091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60911,
    lat: 40.87856,
    lng: -87.98059,
    city: "Ashkum",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1337,
    density: 8.3,
    county_fips: 17075,
    county_name: "Iroquois",
    county_weights: {
      17075: 100,
    },
    county_names_all: "Iroquois",
    county_fips_all: 17075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60912,
    lat: 40.97252,
    lng: -87.60245,
    city: "Beaverville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 533,
    density: 5.6,
    county_fips: 17075,
    county_name: "Iroquois",
    county_weights: {
      17075: 100,
    },
    county_names_all: "Iroquois",
    county_fips_all: 17075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60913,
    lat: 41.14835,
    lng: -88.06206,
    city: "Bonfield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1717,
    density: 14.7,
    county_fips: 17091,
    county_name: "Kankakee",
    county_weights: {
      17091: 100,
    },
    county_names_all: "Kankakee",
    county_fips_all: 17091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60914,
    lat: 41.18706,
    lng: -87.86194,
    city: "Bourbonnais",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29192,
    density: 230.4,
    county_fips: 17091,
    county_name: "Kankakee",
    county_weights: {
      17091: 100,
    },
    county_names_all: "Kankakee",
    county_fips_all: 17091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60915,
    lat: 41.14758,
    lng: -87.86039,
    city: "Bradley",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10313,
    density: 1162.9,
    county_fips: 17091,
    county_name: "Kankakee",
    county_weights: {
      17091: 100,
    },
    county_names_all: "Kankakee",
    county_fips_all: 17091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60917,
    lat: 41.04644,
    lng: -88.19179,
    city: "Buckingham",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 492,
    density: 5.2,
    county_fips: 17091,
    county_name: "Kankakee",
    county_weights: {
      17053: 4.16,
      17091: 79.54,
      17105: 16.3,
    },
    county_names_all: "Kankakee|Livingston|Ford",
    county_fips_all: "17091|17105|17053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60918,
    lat: 40.59681,
    lng: -88.02968,
    city: "Buckley",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 693,
    density: 5.3,
    county_fips: 17075,
    county_name: "Iroquois",
    county_weights: {
      17053: 1.99,
      17075: 98.01,
    },
    county_names_all: "Iroquois|Ford",
    county_fips_all: "17075|17053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60919,
    lat: 40.98753,
    lng: -88.24012,
    city: "Cabery",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 535,
    density: 5.9,
    county_fips: 17053,
    county_name: "Ford",
    county_weights: {
      17053: 44.21,
      17091: 14.25,
      17105: 41.54,
    },
    county_names_all: "Ford|Livingston|Kankakee",
    county_fips_all: "17053|17105|17091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60920,
    lat: 41.03021,
    lng: -88.30378,
    city: "Campus",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 166,
    density: 35.7,
    county_fips: 17105,
    county_name: "Livingston",
    county_weights: {
      17105: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 17105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60921,
    lat: 40.73513,
    lng: -88.28894,
    city: "Chatsworth",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1627,
    density: 8.8,
    county_fips: 17105,
    county_name: "Livingston",
    county_weights: {
      17053: 3.24,
      17105: 96.76,
    },
    county_names_all: "Livingston|Ford",
    county_fips_all: "17105|17053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60922,
    lat: 41.00394,
    lng: -87.92184,
    city: "Chebanse",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2571,
    density: 18.1,
    county_fips: 17091,
    county_name: "Kankakee",
    county_weights: {
      17075: 48.57,
      17091: 51.43,
    },
    county_names_all: "Kankakee|Iroquois",
    county_fips_all: "17091|17075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60924,
    lat: 40.55855,
    lng: -87.88454,
    city: "Cissna Park",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1496,
    density: 8.2,
    county_fips: 17075,
    county_name: "Iroquois",
    county_weights: {
      17075: 100,
    },
    county_names_all: "Iroquois",
    county_fips_all: 17075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60926,
    lat: 40.56937,
    lng: -87.81208,
    city: "Claytonville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45,
    density: 5.5,
    county_fips: 17075,
    county_name: "Iroquois",
    county_weights: {
      17075: 100,
    },
    county_names_all: "Iroquois",
    county_fips_all: 17075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60927,
    lat: 40.93933,
    lng: -87.96744,
    city: "Clifton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2150,
    density: 11.3,
    county_fips: 17075,
    county_name: "Iroquois",
    county_weights: {
      17075: 100,
    },
    county_names_all: "Iroquois",
    county_fips_all: 17075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60928,
    lat: 40.74568,
    lng: -87.85078,
    city: "Crescent City",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 574,
    density: 21.7,
    county_fips: 17075,
    county_name: "Iroquois",
    county_weights: {
      17075: 100,
    },
    county_names_all: "Iroquois",
    county_fips_all: 17075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60929,
    lat: 40.87601,
    lng: -88.29242,
    city: "Cullom",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 627,
    density: 6.3,
    county_fips: 17105,
    county_name: "Livingston",
    county_weights: {
      17053: 11.35,
      17105: 88.65,
    },
    county_names_all: "Livingston|Ford",
    county_fips_all: "17105|17053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60930,
    lat: 40.83231,
    lng: -88.00286,
    city: "Danforth",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 814,
    density: 7.1,
    county_fips: 17075,
    county_name: "Iroquois",
    county_weights: {
      17075: 100,
    },
    county_names_all: "Iroquois",
    county_fips_all: 17075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60931,
    lat: 40.8919,
    lng: -87.58654,
    city: "Donovan",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 547,
    density: 4.4,
    county_fips: 17075,
    county_name: "Iroquois",
    county_weights: {
      17075: 100,
    },
    county_names_all: "Iroquois",
    county_fips_all: 17075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60932,
    lat: 40.46513,
    lng: -87.80013,
    city: "East Lynn",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 379,
    density: 447,
    county_fips: 17183,
    county_name: "Vermilion",
    county_weights: {
      17183: 100,
    },
    county_names_all: "Vermilion",
    county_fips_all: 17183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60933,
    lat: 40.46258,
    lng: -88.27381,
    city: "Elliott",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 312,
    density: 47.8,
    county_fips: 17053,
    county_name: "Ford",
    county_weights: {
      17053: 100,
    },
    county_names_all: "Ford",
    county_fips_all: 17053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60934,
    lat: 40.96119,
    lng: -88.34862,
    city: "Emington",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 189,
    density: 2.3,
    county_fips: 17105,
    county_name: "Livingston",
    county_weights: {
      17105: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 17105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60935,
    lat: 41.17165,
    lng: -88.16853,
    city: "Essex",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1295,
    density: 27,
    county_fips: 17091,
    county_name: "Kankakee",
    county_weights: {
      17091: 100,
    },
    county_names_all: "Kankakee",
    county_fips_all: 17091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60936,
    lat: 40.46456,
    lng: -88.36103,
    city: "Gibson City",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4074,
    density: 16.2,
    county_fips: 17053,
    county_name: "Ford",
    county_weights: {
      17019: 1.81,
      17053: 92.87,
      17113: 5.32,
    },
    county_names_all: "Ford|McLean|Champaign",
    county_fips_all: "17053|17113|17019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60938,
    lat: 40.77456,
    lng: -87.98355,
    city: "Gilman",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1828,
    density: 13.8,
    county_fips: 17075,
    county_name: "Iroquois",
    county_weights: {
      17075: 100,
    },
    county_names_all: "Iroquois",
    county_fips_all: 17075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60939,
    lat: 40.56696,
    lng: -87.77714,
    city: "Goodwine",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 17075,
    county_name: "Iroquois",
    county_weights: {
      17075: 100,
    },
    county_names_all: "Iroquois",
    county_fips_all: 17075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60940,
    lat: 41.25188,
    lng: -87.64259,
    city: "Grant Park",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3062,
    density: 15.4,
    county_fips: 17091,
    county_name: "Kankakee",
    county_weights: {
      17091: 97.55,
      17197: 2.45,
    },
    county_names_all: "Kankakee|Will",
    county_fips_all: "17091|17197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60941,
    lat: 41.03865,
    lng: -88.0859,
    city: "Herscher",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2146,
    density: 16.1,
    county_fips: 17091,
    county_name: "Kankakee",
    county_weights: {
      17053: 3.91,
      17075: 11.72,
      17091: 84.37,
    },
    county_names_all: "Kankakee|Iroquois|Ford",
    county_fips_all: "17091|17075|17053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60942,
    lat: 40.46678,
    lng: -87.66134,
    city: "Hoopeston",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5800,
    density: 19.4,
    county_fips: 17183,
    county_name: "Vermilion",
    county_weights: {
      17075: 31.61,
      17183: 68.39,
    },
    county_names_all: "Vermilion|Iroquois",
    county_fips_all: "17183|17075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60945,
    lat: 40.8315,
    lng: -87.59236,
    city: "Iroquois",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 285,
    density: 47,
    county_fips: 17075,
    county_name: "Iroquois",
    county_weights: {
      17075: 100,
    },
    county_names_all: "Iroquois",
    county_fips_all: 17075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60946,
    lat: 40.91307,
    lng: -88.20072,
    city: "Kempton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 457,
    density: 4,
    county_fips: 17053,
    county_name: "Ford",
    county_weights: {
      17053: 82.39,
      17105: 17.61,
    },
    county_names_all: "Ford|Livingston",
    county_fips_all: "17053|17105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60948,
    lat: 40.52413,
    lng: -88.07698,
    city: "Loda",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1663,
    density: 13,
    county_fips: 17075,
    county_name: "Iroquois",
    county_weights: {
      17053: 29.73,
      17075: 70.27,
    },
    county_names_all: "Iroquois|Ford",
    county_fips_all: "17075|17053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60949,
    lat: 40.38042,
    lng: -88.10239,
    city: "Ludlow",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 626,
    density: 10.6,
    county_fips: 17019,
    county_name: "Champaign",
    county_weights: {
      17019: 93.11,
      17053: 6.89,
    },
    county_names_all: "Champaign|Ford",
    county_fips_all: "17019|17053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60950,
    lat: 41.25135,
    lng: -87.88494,
    city: "Manteno",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11604,
    density: 58.5,
    county_fips: 17091,
    county_name: "Kankakee",
    county_weights: {
      17091: 93.49,
      17197: 6.51,
    },
    county_names_all: "Kankakee|Will",
    county_fips_all: "17091|17197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60951,
    lat: 40.91721,
    lng: -87.74757,
    city: "Martinton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 851,
    density: 6.6,
    county_fips: 17075,
    county_name: "Iroquois",
    county_weights: {
      17075: 100,
    },
    county_names_all: "Iroquois",
    county_fips_all: 17075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60952,
    lat: 40.56373,
    lng: -88.25142,
    city: "Melvin",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 536,
    density: 4.9,
    county_fips: 17053,
    county_name: "Ford",
    county_weights: {
      17053: 94.18,
      17105: 5.82,
    },
    county_names_all: "Ford|Livingston",
    county_fips_all: "17053|17105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60953,
    lat: 40.62854,
    lng: -87.6894,
    city: "Milford",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2651,
    density: 6.7,
    county_fips: 17075,
    county_name: "Iroquois",
    county_weights: {
      17075: 100,
    },
    county_names_all: "Iroquois",
    county_fips_all: 17075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60954,
    lat: 41.15446,
    lng: -87.62827,
    city: "Momence",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5706,
    density: 33.3,
    county_fips: 17091,
    county_name: "Kankakee",
    county_weights: {
      17091: 100,
    },
    county_names_all: "Kankakee",
    county_fips_all: 17091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60955,
    lat: 40.7004,
    lng: -87.98008,
    city: "Onarga",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1626,
    density: 7.3,
    county_fips: 17075,
    county_name: "Iroquois",
    county_weights: {
      17075: 100,
    },
    county_names_all: "Iroquois",
    county_fips_all: 17075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60956,
    lat: 40.96775,
    lng: -87.7163,
    city: "Papineau",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 17075,
    county_name: "Iroquois",
    county_weights: {
      17075: 100,
    },
    county_names_all: "Iroquois",
    county_fips_all: 17075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60957,
    lat: 40.44037,
    lng: -88.13977,
    city: "Paxton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5418,
    density: 19.9,
    county_fips: 17053,
    county_name: "Ford",
    county_weights: {
      17019: 14.56,
      17053: 85.44,
    },
    county_names_all: "Ford|Champaign",
    county_fips_all: "17053|17019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60958,
    lat: 41.06523,
    lng: -87.5916,
    city: "Pembroke Township",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1529,
    density: 11.3,
    county_fips: 17091,
    county_name: "Kankakee",
    county_weights: {
      17091: 100,
    },
    county_names_all: "Kankakee",
    county_fips_all: 17091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60959,
    lat: 40.7895,
    lng: -88.1832,
    city: "Piper City",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1053,
    density: 7.4,
    county_fips: 17053,
    county_name: "Ford",
    county_weights: {
      17053: 95.08,
      17105: 4.92,
    },
    county_names_all: "Ford|Livingston",
    county_fips_all: "17053|17105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60960,
    lat: 40.43879,
    lng: -87.89132,
    city: "Rankin",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 883,
    density: 4.1,
    county_fips: 17183,
    county_name: "Vermilion",
    county_weights: {
      17019: 2.18,
      17053: 22.35,
      17075: 8.9,
      17183: 66.57,
    },
    county_names_all: "Vermilion|Ford|Iroquois|Champaign",
    county_fips_all: "17183|17053|17075|17019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60961,
    lat: 41.10611,
    lng: -88.23098,
    city: "Reddick",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 833,
    density: 8.5,
    county_fips: 17091,
    county_name: "Kankakee",
    county_weights: {
      17063: 5.44,
      17091: 68.54,
      17105: 26.02,
    },
    county_names_all: "Kankakee|Livingston|Grundy",
    county_fips_all: "17091|17105|17063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60962,
    lat: 40.62248,
    lng: -88.18442,
    city: "Roberts",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 609,
    density: 6,
    county_fips: 17053,
    county_name: "Ford",
    county_weights: {
      17053: 100,
    },
    county_names_all: "Ford",
    county_fips_all: 17053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60963,
    lat: 40.36848,
    lng: -87.65115,
    city: "Rossville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1485,
    density: 7.3,
    county_fips: 17183,
    county_name: "Vermilion",
    county_weights: {
      17183: 100,
    },
    county_names_all: "Vermilion",
    county_fips_all: 17183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60964,
    lat: 41.03401,
    lng: -87.7418,
    city: "Saint Anne",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4884,
    density: 25.3,
    county_fips: 17091,
    county_name: "Kankakee",
    county_weights: {
      17075: 27.89,
      17091: 72.11,
    },
    county_names_all: "Kankakee|Iroquois",
    county_fips_all: "17091|17075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60966,
    lat: 40.75144,
    lng: -87.58321,
    city: "Sheldon",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1475,
    density: 9.5,
    county_fips: 17075,
    county_name: "Iroquois",
    county_weights: {
      17075: 100,
    },
    county_names_all: "Iroquois",
    county_fips_all: 17075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60967,
    lat: 40.6241,
    lng: -87.58123,
    city: "Stockland",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 17075,
    county_name: "Iroquois",
    county_weights: {
      17075: 100,
    },
    county_names_all: "Iroquois",
    county_fips_all: 17075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60968,
    lat: 40.6746,
    lng: -88.12049,
    city: "Thawville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 451,
    density: 3.7,
    county_fips: 17075,
    county_name: "Iroquois",
    county_weights: {
      17053: 45.6,
      17075: 52.29,
      17105: 2.11,
    },
    county_names_all: "Iroquois|Ford|Livingston",
    county_fips_all: "17075|17053|17105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60969,
    lat: 41.11101,
    lng: -88.14975,
    city: "Union Hill",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69,
    density: 104.5,
    county_fips: 17091,
    county_name: "Kankakee",
    county_weights: {
      17091: 100,
    },
    county_names_all: "Kankakee",
    county_fips_all: 17091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60970,
    lat: 40.79221,
    lng: -87.74039,
    city: "Watseka",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6509,
    density: 19.7,
    county_fips: 17075,
    county_name: "Iroquois",
    county_weights: {
      17075: 100,
    },
    county_names_all: "Iroquois",
    county_fips_all: 17075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60973,
    lat: 40.53654,
    lng: -87.66265,
    city: "Wellington",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 338,
    density: 4.6,
    county_fips: 17075,
    county_name: "Iroquois",
    county_weights: {
      17075: 100,
    },
    county_names_all: "Iroquois",
    county_fips_all: 17075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 60974,
    lat: 40.71807,
    lng: -87.73588,
    city: "Woodland",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 314,
    density: 100.2,
    county_fips: 17075,
    county_name: "Iroquois",
    county_weights: {
      17075: 100,
    },
    county_names_all: "Iroquois",
    county_fips_all: 17075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61001,
    lat: 42.4612,
    lng: -90.12226,
    city: "Apple River",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1146,
    density: 11,
    county_fips: 17085,
    county_name: "Jo Daviess",
    county_weights: {
      17085: 100,
    },
    county_names_all: "Jo Daviess",
    county_fips_all: 17085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61006,
    lat: 41.86078,
    lng: -89.20836,
    city: "Ashton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1515,
    density: 8.3,
    county_fips: 17103,
    county_name: "Lee",
    county_weights: {
      17103: 73.34,
      17141: 26.66,
    },
    county_names_all: "Lee|Ogle",
    county_fips_all: "17103|17141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61007,
    lat: 42.19941,
    lng: -89.59109,
    city: "Baileyville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 332,
    density: 5.2,
    county_fips: 17141,
    county_name: "Ogle",
    county_weights: {
      17141: 56.72,
      17177: 43.28,
    },
    county_names_all: "Ogle|Stephenson",
    county_fips_all: "17141|17177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61008,
    lat: 42.24579,
    lng: -88.83949,
    city: "Belvidere",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34526,
    density: 158.1,
    county_fips: 17007,
    county_name: "Boone",
    county_weights: {
      17007: 99.9,
      17201: 0.1,
    },
    county_names_all: "Boone|Winnebago",
    county_fips_all: "17007|17201",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61010,
    lat: 42.136,
    lng: -89.26751,
    city: "Byron",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7354,
    density: 74.3,
    county_fips: 17141,
    county_name: "Ogle",
    county_weights: {
      17141: 100,
    },
    county_names_all: "Ogle",
    county_fips_all: 17141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61011,
    lat: 42.38926,
    lng: -88.91266,
    city: "Caledonia",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2308,
    density: 23.1,
    county_fips: 17007,
    county_name: "Boone",
    county_weights: {
      17007: 81.84,
      17201: 18.16,
    },
    county_names_all: "Boone|Winnebago",
    county_fips_all: "17007|17201",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61012,
    lat: 42.40749,
    lng: -88.75446,
    city: "Capron",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2594,
    density: 27.7,
    county_fips: 17007,
    county_name: "Boone",
    county_weights: {
      17007: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 17007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61013,
    lat: 42.37544,
    lng: -89.63623,
    city: "Cedarville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 411,
    density: 337.3,
    county_fips: 17177,
    county_name: "Stephenson",
    county_weights: {
      17177: 100,
    },
    county_names_all: "Stephenson",
    county_fips_all: 17177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61014,
    lat: 41.97501,
    lng: -89.8865,
    city: "Chadwick",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1145,
    density: 7,
    county_fips: 17015,
    county_name: "Carroll",
    county_weights: {
      17015: 85.02,
      17195: 14.98,
    },
    county_names_all: "Carroll|Whiteside",
    county_fips_all: "17015|17195",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61015,
    lat: 41.99443,
    lng: -89.20011,
    city: "Chana",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 944,
    density: 9.3,
    county_fips: 17141,
    county_name: "Ogle",
    county_weights: {
      17141: 100,
    },
    county_names_all: "Ogle",
    county_fips_all: 17141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61016,
    lat: 42.19761,
    lng: -88.94704,
    city: "Cherry Valley",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4925,
    density: 67.3,
    county_fips: 17201,
    county_name: "Winnebago",
    county_weights: {
      17007: 42.61,
      17201: 57.39,
    },
    county_names_all: "Winnebago|Boone",
    county_fips_all: "17201|17007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61018,
    lat: 42.41599,
    lng: -89.55558,
    city: "Dakota",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1042,
    density: 12,
    county_fips: 17177,
    county_name: "Stephenson",
    county_weights: {
      17177: 100,
    },
    county_names_all: "Stephenson",
    county_fips_all: 17177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61019,
    lat: 42.44093,
    lng: -89.40863,
    city: "Davis",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3040,
    density: 31.4,
    county_fips: 17177,
    county_name: "Stephenson",
    county_weights: {
      17177: 61.66,
      17201: 38.34,
    },
    county_names_all: "Stephenson|Winnebago",
    county_fips_all: "17177|17201",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61020,
    lat: 42.11035,
    lng: -89.09807,
    city: "Davis Junction",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2971,
    density: 36.5,
    county_fips: 17141,
    county_name: "Ogle",
    county_weights: {
      17141: 90.55,
      17201: 9.45,
    },
    county_names_all: "Ogle|Winnebago",
    county_fips_all: "17141|17201",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61021,
    lat: 41.82908,
    lng: -89.47764,
    city: "Dixon",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22379,
    density: 57.6,
    county_fips: 17103,
    county_name: "Lee",
    county_weights: {
      17103: 89,
      17141: 11,
    },
    county_names_all: "Lee|Ogle",
    county_fips_all: "17103|17141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61024,
    lat: 42.43629,
    lng: -89.29183,
    city: "Durand",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2515,
    density: 16.4,
    county_fips: 17201,
    county_name: "Winnebago",
    county_weights: {
      17201: 100,
    },
    county_names_all: "Winnebago",
    county_fips_all: 17201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61025,
    lat: 42.46958,
    lng: -90.55904,
    city: "East Dubuque",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4590,
    density: 49.8,
    county_fips: 17085,
    county_name: "Jo Daviess",
    county_weights: {
      17085: 100,
    },
    county_names_all: "Jo Daviess",
    county_fips_all: 17085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61027,
    lat: 42.3333,
    lng: -89.75553,
    city: "Eleroy",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 84,
    density: 64.3,
    county_fips: 17177,
    county_name: "Stephenson",
    county_weights: {
      17177: 100,
    },
    county_names_all: "Stephenson",
    county_fips_all: 17177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61028,
    lat: 42.29366,
    lng: -90.16935,
    city: "Elizabeth",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1809,
    density: 6.2,
    county_fips: 17085,
    county_name: "Jo Daviess",
    county_weights: {
      17015: 0.29,
      17085: 99.71,
    },
    county_names_all: "Jo Daviess|Carroll",
    county_fips_all: "17085|17015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61030,
    lat: 42.11578,
    lng: -89.58898,
    city: "Forreston",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2248,
    density: 14.3,
    county_fips: 17141,
    county_name: "Ogle",
    county_weights: {
      17141: 100,
    },
    county_names_all: "Ogle",
    county_fips_all: 17141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61031,
    lat: 41.83263,
    lng: -89.31626,
    city: "Franklin Grove",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1639,
    density: 14.1,
    county_fips: 17103,
    county_name: "Lee",
    county_weights: {
      17103: 95.07,
      17141: 4.93,
    },
    county_names_all: "Lee|Ogle",
    county_fips_all: "17103|17141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61032,
    lat: 42.31509,
    lng: -89.63598,
    city: "Freeport",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29451,
    density: 76.5,
    county_fips: 17177,
    county_name: "Stephenson",
    county_weights: {
      17177: 100,
    },
    county_names_all: "Stephenson",
    county_fips_all: 17177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61036,
    lat: 42.4172,
    lng: -90.39816,
    city: "Galena",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6652,
    density: 26.8,
    county_fips: 17085,
    county_name: "Jo Daviess",
    county_weights: {
      17085: 100,
    },
    county_names_all: "Jo Daviess",
    county_fips_all: 17085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61037,
    lat: 41.7882,
    lng: -89.75978,
    city: "Galt",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 97,
    density: 275.7,
    county_fips: 17195,
    county_name: "Whiteside",
    county_weights: {
      17195: 100,
    },
    county_names_all: "Whiteside",
    county_fips_all: 17195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61038,
    lat: 42.26344,
    lng: -88.73586,
    city: "Garden Prairie",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 869,
    density: 7.9,
    county_fips: 17007,
    county_name: "Boone",
    county_weights: {
      17007: 92.73,
      17111: 7.27,
    },
    county_names_all: "Boone|McHenry",
    county_fips_all: "17007|17111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61039,
    lat: 42.20805,
    lng: -89.46931,
    city: "German Valley",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 910,
    density: 12.3,
    county_fips: 17177,
    county_name: "Stephenson",
    county_weights: {
      17141: 38.06,
      17177: 61.94,
    },
    county_names_all: "Stephenson|Ogle",
    county_fips_all: "17177|17141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61041,
    lat: 42.272,
    lng: -90.3202,
    city: "Hanover",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1345,
    density: 6.5,
    county_fips: 17085,
    county_name: "Jo Daviess",
    county_weights: {
      17085: 100,
    },
    county_names_all: "Jo Daviess",
    county_fips_all: 17085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61042,
    lat: 41.68819,
    lng: -89.56015,
    city: "Harmon",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 659,
    density: 3.8,
    county_fips: 17103,
    county_name: "Lee",
    county_weights: {
      17103: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 17103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61043,
    lat: 42.06676,
    lng: -89.10499,
    city: "Holcomb",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 130,
    density: 104.5,
    county_fips: 17141,
    county_name: "Ogle",
    county_weights: {
      17141: 100,
    },
    county_names_all: "Ogle",
    county_fips_all: 17141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61044,
    lat: 42.32336,
    lng: -89.9099,
    city: "Kent",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 153,
    density: 4.5,
    county_fips: 17177,
    county_name: "Stephenson",
    county_weights: {
      17085: 34.32,
      17177: 65.68,
    },
    county_names_all: "Stephenson|Jo Daviess",
    county_fips_all: "17177|17085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61046,
    lat: 42.10404,
    lng: -89.81329,
    city: "Lanark",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2325,
    density: 10.7,
    county_fips: 17015,
    county_name: "Carroll",
    county_weights: {
      17015: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 17015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61047,
    lat: 42.15305,
    lng: -89.39597,
    city: "Leaf River",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1749,
    density: 10.2,
    county_fips: 17141,
    county_name: "Ogle",
    county_weights: {
      17141: 92.31,
      17177: 1.68,
      17201: 6.01,
    },
    county_names_all: "Ogle|Winnebago|Stephenson",
    county_fips_all: "17141|17201|17177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61048,
    lat: 42.38524,
    lng: -89.83526,
    city: "Lena",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3775,
    density: 17.8,
    county_fips: 17177,
    county_name: "Stephenson",
    county_weights: {
      17085: 8.76,
      17177: 91.24,
    },
    county_names_all: "Stephenson|Jo Daviess",
    county_fips_all: "17177|17085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61049,
    lat: 42.04417,
    lng: -89.00753,
    city: "Lindenwood",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 700,
    density: 13.2,
    county_fips: 17141,
    county_name: "Ogle",
    county_weights: {
      17141: 100,
    },
    county_names_all: "Ogle",
    county_fips_all: 17141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61050,
    lat: 42.43932,
    lng: -89.7319,
    city: "McConnell",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 329,
    density: 12.4,
    county_fips: 17177,
    county_name: "Stephenson",
    county_weights: {
      17177: 100,
    },
    county_names_all: "Stephenson",
    county_fips_all: 17177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61051,
    lat: 41.98289,
    lng: -89.7619,
    city: "Milledgeville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1493,
    density: 11.4,
    county_fips: 17015,
    county_name: "Carroll",
    county_weights: {
      17015: 96.18,
      17141: 3.82,
    },
    county_names_all: "Carroll|Ogle",
    county_fips_all: "17015|17141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61052,
    lat: 42.11146,
    lng: -89.00011,
    city: "Monroe Center",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 872,
    density: 12.2,
    county_fips: 17141,
    county_name: "Ogle",
    county_weights: {
      17141: 100,
    },
    county_names_all: "Ogle",
    county_fips_all: 17141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61053,
    lat: 42.11506,
    lng: -89.98335,
    city: "Mount Carroll",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2560,
    density: 9.2,
    county_fips: 17015,
    county_name: "Carroll",
    county_weights: {
      17015: 90.26,
      17085: 9.74,
    },
    county_names_all: "Carroll|Jo Daviess",
    county_fips_all: "17015|17085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61054,
    lat: 42.05573,
    lng: -89.44548,
    city: "Mount Morris",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3660,
    density: 33.8,
    county_fips: 17141,
    county_name: "Ogle",
    county_weights: {
      17141: 100,
    },
    county_names_all: "Ogle",
    county_fips_all: 17141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61057,
    lat: 41.83357,
    lng: -89.38401,
    city: "Nachusa",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 84,
    density: 50.4,
    county_fips: 17103,
    county_name: "Lee",
    county_weights: {
      17103: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 17103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61059,
    lat: 42.45465,
    lng: -89.94084,
    city: "Nora",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 237,
    density: 80.1,
    county_fips: 17085,
    county_name: "Jo Daviess",
    county_weights: {
      17085: 99.73,
      17177: 0.27,
    },
    county_names_all: "Jo Daviess|Stephenson",
    county_fips_all: "17085|17177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61060,
    lat: 42.47876,
    lng: -89.61819,
    city: "Orangeville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1452,
    density: 15.3,
    county_fips: 17177,
    county_name: "Stephenson",
    county_weights: {
      17177: 100,
    },
    county_names_all: "Stephenson",
    county_fips_all: 17177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61061,
    lat: 41.99851,
    lng: -89.33819,
    city: "Oregon",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6555,
    density: 24,
    county_fips: 17141,
    county_name: "Ogle",
    county_weights: {
      17141: 100,
    },
    county_names_all: "Ogle",
    county_fips_all: 17141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61062,
    lat: 42.25254,
    lng: -89.84263,
    city: "Pearl City",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2075,
    density: 10.7,
    county_fips: 17177,
    county_name: "Stephenson",
    county_weights: {
      17015: 2.26,
      17085: 6.59,
      17177: 91.15,
    },
    county_names_all: "Stephenson|Jo Daviess|Carroll",
    county_fips_all: "17177|17085|17015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61063,
    lat: 42.31305,
    lng: -89.34691,
    city: "Pecatonica",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4236,
    density: 21.9,
    county_fips: 17201,
    county_name: "Winnebago",
    county_weights: {
      17177: 16.26,
      17201: 83.74,
    },
    county_names_all: "Winnebago|Stephenson",
    county_fips_all: "17201|17177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61064,
    lat: 41.9893,
    lng: -89.5873,
    city: "Polo",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3988,
    density: 14.1,
    county_fips: 17141,
    county_name: "Ogle",
    county_weights: {
      17015: 4.35,
      17103: 1.03,
      17141: 93.9,
      17195: 0.72,
    },
    county_names_all: "Ogle|Carroll|Lee|Whiteside",
    county_fips_all: "17141|17015|17103|17195",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61065,
    lat: 42.40786,
    lng: -88.82747,
    city: "Poplar Grove",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10684,
    density: 81,
    county_fips: 17007,
    county_name: "Boone",
    county_weights: {
      17007: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 17007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61067,
    lat: 42.30472,
    lng: -89.47454,
    city: "Ridott",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 693,
    density: 8.5,
    county_fips: 17177,
    county_name: "Stephenson",
    county_weights: {
      17177: 100,
    },
    county_names_all: "Stephenson",
    county_fips_all: 17177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61068,
    lat: 41.94928,
    lng: -89.0652,
    city: "Rochelle",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14194,
    density: 45.4,
    county_fips: 17141,
    county_name: "Ogle",
    county_weights: {
      17037: 1.22,
      17103: 10.01,
      17141: 88.77,
    },
    county_names_all: "Ogle|Lee|DeKalb",
    county_fips_all: "17141|17103|17037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61070,
    lat: 42.41571,
    lng: -89.47177,
    city: "Rock City",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1598,
    density: 19.1,
    county_fips: 17177,
    county_name: "Stephenson",
    county_weights: {
      17177: 100,
    },
    county_names_all: "Stephenson",
    county_fips_all: 17177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61071,
    lat: 41.72599,
    lng: -89.70006,
    city: "Rock Falls",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14006,
    density: 74.6,
    county_fips: 17195,
    county_name: "Whiteside",
    county_weights: {
      17103: 11.23,
      17195: 88.77,
    },
    county_names_all: "Whiteside|Lee",
    county_fips_all: "17195|17103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61072,
    lat: 42.44661,
    lng: -89.14109,
    city: "Rockton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11121,
    density: 82,
    county_fips: 17201,
    county_name: "Winnebago",
    county_weights: {
      17201: 100,
    },
    county_names_all: "Winnebago",
    county_fips_all: 17201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61073,
    lat: 42.42434,
    lng: -88.99346,
    city: "Roscoe",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20045,
    density: 277,
    county_fips: 17201,
    county_name: "Winnebago",
    county_weights: {
      17007: 4.1,
      17201: 95.9,
    },
    county_names_all: "Winnebago|Boone",
    county_fips_all: "17201|17007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61074,
    lat: 42.12615,
    lng: -90.13061,
    city: "Savanna",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4299,
    density: 22.6,
    county_fips: 17015,
    county_name: "Carroll",
    county_weights: {
      17015: 98.18,
      17085: 1.82,
    },
    county_names_all: "Carroll|Jo Daviess",
    county_fips_all: "17015|17085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61075,
    lat: 42.46546,
    lng: -90.26444,
    city: "Scales Mound",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1024,
    density: 7.6,
    county_fips: 17085,
    county_name: "Jo Daviess",
    county_weights: {
      17085: 100,
    },
    county_names_all: "Jo Daviess",
    county_fips_all: 17085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61077,
    lat: 42.24012,
    lng: -89.34806,
    city: "Seward",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 17201,
    county_name: "Winnebago",
    county_weights: {
      17201: 100,
    },
    county_names_all: "Winnebago",
    county_fips_all: 17201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61078,
    lat: 42.16729,
    lng: -89.73062,
    city: "Shannon",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1270,
    density: 8.9,
    county_fips: 17015,
    county_name: "Carroll",
    county_weights: {
      17015: 66.2,
      17141: 16.26,
      17177: 17.54,
    },
    county_names_all: "Carroll|Stephenson|Ogle",
    county_fips_all: "17015|17177|17141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61079,
    lat: 42.44681,
    lng: -89.20955,
    city: "Shirland",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 189,
    density: 18.9,
    county_fips: 17201,
    county_name: "Winnebago",
    county_weights: {
      17201: 100,
    },
    county_names_all: "Winnebago",
    county_fips_all: 17201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61080,
    lat: 42.47992,
    lng: -88.98989,
    city: "South Beloit",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10053,
    density: 154.9,
    county_fips: 17201,
    county_name: "Winnebago",
    county_weights: {
      17007: 28.4,
      17201: 71.6,
    },
    county_names_all: "Winnebago|Boone",
    county_fips_all: "17201|17007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61081,
    lat: 41.84425,
    lng: -89.73613,
    city: "Sterling",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20910,
    density: 64.9,
    county_fips: 17195,
    county_name: "Whiteside",
    county_weights: {
      17103: 5.46,
      17195: 94.54,
    },
    county_names_all: "Whiteside|Lee",
    county_fips_all: "17195|17103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61084,
    lat: 42.11843,
    lng: -89.18867,
    city: "Stillman Valley",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3102,
    density: 34.4,
    county_fips: 17141,
    county_name: "Ogle",
    county_weights: {
      17141: 93.12,
      17201: 6.88,
    },
    county_names_all: "Ogle|Winnebago",
    county_fips_all: "17141|17201",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61085,
    lat: 42.34268,
    lng: -90.03077,
    city: "Stockton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3042,
    density: 9.2,
    county_fips: 17085,
    county_name: "Jo Daviess",
    county_weights: {
      17085: 100,
    },
    county_names_all: "Jo Daviess",
    county_fips_all: 17085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61087,
    lat: 42.48046,
    lng: -89.99351,
    city: "Warren",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1394,
    density: 19.8,
    county_fips: 17085,
    county_name: "Jo Daviess",
    county_weights: {
      17085: 93.06,
      17177: 6.94,
    },
    county_names_all: "Jo Daviess|Stephenson",
    county_fips_all: "17085|17177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61088,
    lat: 42.26995,
    lng: -89.25509,
    city: "Winnebago",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6348,
    density: 43.3,
    county_fips: 17201,
    county_name: "Winnebago",
    county_weights: {
      17141: 0.23,
      17201: 99.77,
    },
    county_names_all: "Winnebago|Ogle",
    county_fips_all: "17201|17141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61089,
    lat: 42.47349,
    lng: -89.82335,
    city: "Winslow",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 621,
    density: 5.4,
    county_fips: 17177,
    county_name: "Stephenson",
    county_weights: {
      17085: 3.98,
      17177: 96.02,
    },
    county_names_all: "Stephenson|Jo Daviess",
    county_fips_all: "17177|17085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61091,
    lat: 41.90818,
    lng: -89.55234,
    city: "Woosung",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67,
    density: 10.3,
    county_fips: 17141,
    county_name: "Ogle",
    county_weights: {
      17141: 100,
    },
    county_names_all: "Ogle",
    county_fips_all: 17141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61101,
    lat: 42.33727,
    lng: -89.14725,
    city: "Rockford",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19083,
    density: 177.4,
    county_fips: 17201,
    county_name: "Winnebago",
    county_weights: {
      17201: 100,
    },
    county_names_all: "Winnebago",
    county_fips_all: 17201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61102,
    lat: 42.22995,
    lng: -89.15632,
    city: "Rockford",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17506,
    density: 198.1,
    county_fips: 17201,
    county_name: "Winnebago",
    county_weights: {
      17141: 12.1,
      17201: 87.9,
    },
    county_names_all: "Winnebago|Ogle",
    county_fips_all: "17201|17141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61103,
    lat: 42.3453,
    lng: -89.08271,
    city: "Rockford",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23951,
    density: 566.1,
    county_fips: 17201,
    county_name: "Winnebago",
    county_weights: {
      17201: 100,
    },
    county_names_all: "Winnebago",
    county_fips_all: 17201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61104,
    lat: 42.25186,
    lng: -89.07911,
    city: "Rockford",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18886,
    density: 1620.4,
    county_fips: 17201,
    county_name: "Winnebago",
    county_weights: {
      17201: 100,
    },
    county_names_all: "Winnebago",
    county_fips_all: 17201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61107,
    lat: 42.28344,
    lng: -89.00348,
    city: "Rockford",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30412,
    density: 787.1,
    county_fips: 17201,
    county_name: "Winnebago",
    county_weights: {
      17007: 5.73,
      17201: 94.27,
    },
    county_names_all: "Winnebago|Boone",
    county_fips_all: "17201|17007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61108,
    lat: 42.25515,
    lng: -89.00236,
    city: "Rockford",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29084,
    density: 1028.6,
    county_fips: 17201,
    county_name: "Winnebago",
    county_weights: {
      17201: 100,
    },
    county_names_all: "Winnebago",
    county_fips_all: 17201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61109,
    lat: 42.1924,
    lng: -89.05392,
    city: "Rockford",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26462,
    density: 265.2,
    county_fips: 17201,
    county_name: "Winnebago",
    county_weights: {
      17141: 3.25,
      17201: 96.75,
    },
    county_names_all: "Winnebago|Ogle",
    county_fips_all: "17201|17141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61111,
    lat: 42.33538,
    lng: -89.00369,
    city: "Loves Park",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22789,
    density: 618.4,
    county_fips: 17201,
    county_name: "Winnebago",
    county_weights: {
      17007: 4.21,
      17201: 95.79,
    },
    county_names_all: "Winnebago|Boone",
    county_fips_all: "17201|17007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61112,
    lat: 42.24193,
    lng: -88.97523,
    city: "Rockford",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 76,
    density: 37.2,
    county_fips: 17201,
    county_name: "Winnebago",
    county_weights: {
      17201: 100,
    },
    county_names_all: "Winnebago",
    county_fips_all: 17201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61114,
    lat: 42.30854,
    lng: -88.9892,
    city: "Rockford",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14928,
    density: 707.7,
    county_fips: 17201,
    county_name: "Winnebago",
    county_weights: {
      17007: 12.24,
      17201: 87.76,
    },
    county_names_all: "Winnebago|Boone",
    county_fips_all: "17201|17007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61115,
    lat: 42.36365,
    lng: -89.02869,
    city: "Machesney Park",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22404,
    density: 812.3,
    county_fips: 17201,
    county_name: "Winnebago",
    county_weights: {
      17201: 100,
    },
    county_names_all: "Winnebago",
    county_fips_all: 17201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61201,
    lat: 41.47799,
    lng: -90.57608,
    city: "Rock Island",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38018,
    density: 821.3,
    county_fips: 17161,
    county_name: "Rock Island",
    county_weights: {
      17161: 100,
    },
    county_names_all: "Rock Island",
    county_fips_all: 17161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61230,
    lat: 41.74074,
    lng: -90.21447,
    city: "Albany",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 918,
    density: 18.4,
    county_fips: 17195,
    county_name: "Whiteside",
    county_weights: {
      17195: 100,
    },
    county_names_all: "Whiteside",
    county_fips_all: 17195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61231,
    lat: 41.2128,
    lng: -90.72294,
    city: "Aledo",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5319,
    density: 13.4,
    county_fips: 17131,
    county_name: "Mercer",
    county_weights: {
      17131: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 17131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61232,
    lat: 41.43168,
    lng: -90.72734,
    city: "Andalusia",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1249,
    density: 149.3,
    county_fips: 17161,
    county_name: "Rock Island",
    county_weights: {
      17161: 100,
    },
    county_names_all: "Rock Island",
    county_fips_all: 17161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61233,
    lat: 41.29464,
    lng: -90.29129,
    city: "Andover",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 17073,
    county_name: "Henry",
    county_weights: {
      17073: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 17073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61234,
    lat: 41.41804,
    lng: -89.91947,
    city: "Annawan",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1122,
    density: 7.8,
    county_fips: 17073,
    county_name: "Henry",
    county_weights: {
      17073: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 17073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61235,
    lat: 41.39972,
    lng: -90.0237,
    city: "Atkinson",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1706,
    density: 12.6,
    county_fips: 17073,
    county_name: "Henry",
    county_weights: {
      17073: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 17073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61236,
    lat: 41.51242,
    lng: -90.35586,
    city: "Barstow",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 73,
    density: 35.2,
    county_fips: 17161,
    county_name: "Rock Island",
    county_weights: {
      17161: 100,
    },
    county_names_all: "Rock Island",
    county_fips_all: 17161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61237,
    lat: 41.34175,
    lng: -90.86221,
    city: "Buffalo Prairie",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 17161,
    county_name: "Rock Island",
    county_weights: {
      17161: 100,
    },
    county_names_all: "Rock Island",
    county_fips_all: 17161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61238,
    lat: 41.28727,
    lng: -90.17647,
    city: "Cambridge",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3081,
    density: 11.7,
    county_fips: 17073,
    county_name: "Henry",
    county_weights: {
      17073: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 17073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61239,
    lat: 41.49479,
    lng: -90.38966,
    city: "Carbon Cliff",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1225,
    density: 598,
    county_fips: 17161,
    county_name: "Rock Island",
    county_weights: {
      17161: 100,
    },
    county_names_all: "Rock Island",
    county_fips_all: 17161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61240,
    lat: 41.42579,
    lng: -90.4325,
    city: "Coal Valley",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5889,
    density: 62.4,
    county_fips: 17161,
    county_name: "Rock Island",
    county_weights: {
      17073: 45.98,
      17161: 54.02,
    },
    county_names_all: "Rock Island|Henry",
    county_fips_all: "17161|17073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61241,
    lat: 41.48782,
    lng: -90.31997,
    city: "Colona",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7077,
    density: 142.9,
    county_fips: 17073,
    county_name: "Henry",
    county_weights: {
      17073: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 17073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61242,
    lat: 41.70363,
    lng: -90.27858,
    city: "Cordova",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1227,
    density: 15.1,
    county_fips: 17161,
    county_name: "Rock Island",
    county_weights: {
      17161: 100,
    },
    county_names_all: "Rock Island",
    county_fips_all: 17161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61243,
    lat: 41.61849,
    lng: -89.6784,
    city: "Deer Grove",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 209,
    density: 3.1,
    county_fips: 17195,
    county_name: "Whiteside",
    county_weights: {
      17103: 4.66,
      17195: 95.34,
    },
    county_names_all: "Whiteside|Lee",
    county_fips_all: "17195|17103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61244,
    lat: 41.52138,
    lng: -90.39424,
    city: "East Moline",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23194,
    density: 332.3,
    county_fips: 17161,
    county_name: "Rock Island",
    county_weights: {
      17161: 100,
    },
    county_names_all: "Rock Island",
    county_fips_all: 17161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61250,
    lat: 41.65884,
    lng: -90.10081,
    city: "Erie",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2716,
    density: 12,
    county_fips: 17195,
    county_name: "Whiteside",
    county_weights: {
      17073: 5.75,
      17195: 94.25,
    },
    county_names_all: "Whiteside|Henry",
    county_fips_all: "17195|17073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61251,
    lat: 41.72909,
    lng: -90.07291,
    city: "Fenton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 402,
    density: 8.8,
    county_fips: 17195,
    county_name: "Whiteside",
    county_weights: {
      17195: 100,
    },
    county_names_all: "Whiteside",
    county_fips_all: 17195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61252,
    lat: 41.8435,
    lng: -90.12272,
    city: "Fulton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5246,
    density: 34.5,
    county_fips: 17195,
    county_name: "Whiteside",
    county_weights: {
      17195: 100,
    },
    county_names_all: "Whiteside",
    county_fips_all: 17195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61254,
    lat: 41.46692,
    lng: -90.15551,
    city: "Geneseo",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11310,
    density: 26.2,
    county_fips: 17073,
    county_name: "Henry",
    county_weights: {
      17073: 99.4,
      17195: 0.6,
    },
    county_names_all: "Henry|Whiteside",
    county_fips_all: "17073|17195",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61256,
    lat: 41.56017,
    lng: -90.40151,
    city: "Hampton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2041,
    density: 531.1,
    county_fips: 17161,
    county_name: "Rock Island",
    county_weights: {
      17161: 100,
    },
    county_names_all: "Rock Island",
    county_fips_all: 17161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61257,
    lat: 41.59025,
    lng: -90.22322,
    city: "Hillsdale",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1067,
    density: 10,
    county_fips: 17161,
    county_name: "Rock Island",
    county_weights: {
      17161: 100,
    },
    county_names_all: "Rock Island",
    county_fips_all: 17161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61258,
    lat: 41.52185,
    lng: -89.91396,
    city: "Hooppole",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 178,
    density: 184.8,
    county_fips: 17073,
    county_name: "Henry",
    county_weights: {
      17073: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 17073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61259,
    lat: 41.38839,
    lng: -90.92733,
    city: "Illinois City",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1309,
    density: 6.6,
    county_fips: 17161,
    county_name: "Rock Island",
    county_weights: {
      17131: 2.9,
      17161: 97.1,
    },
    county_names_all: "Rock Island|Mercer",
    county_fips_all: "17161|17131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61260,
    lat: 41.24141,
    lng: -90.88407,
    city: "Joy",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 754,
    density: 5,
    county_fips: 17131,
    county_name: "Mercer",
    county_weights: {
      17131: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 17131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61261,
    lat: 41.72928,
    lng: -89.91166,
    city: "Lyndon",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 750,
    density: 17.5,
    county_fips: 17195,
    county_name: "Whiteside",
    county_weights: {
      17195: 100,
    },
    county_names_all: "Whiteside",
    county_fips_all: 17195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61262,
    lat: 41.27799,
    lng: -90.35699,
    city: "Lynn Center",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1007,
    density: 7.6,
    county_fips: 17073,
    county_name: "Henry",
    county_weights: {
      17073: 94.51,
      17131: 5.49,
    },
    county_names_all: "Henry|Mercer",
    county_fips_all: "17073|17131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61263,
    lat: 41.26409,
    lng: -90.59878,
    city: "Matherville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 735,
    density: 207.6,
    county_fips: 17131,
    county_name: "Mercer",
    county_weights: {
      17131: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 17131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61264,
    lat: 41.39765,
    lng: -90.59452,
    city: "Milan",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10413,
    density: 58.4,
    county_fips: 17161,
    county_name: "Rock Island",
    county_weights: {
      17131: 1.95,
      17161: 98.05,
    },
    county_names_all: "Rock Island|Mercer",
    county_fips_all: "17161|17131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61265,
    lat: 41.48195,
    lng: -90.48895,
    city: "Moline",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42746,
    density: 858.7,
    county_fips: 17161,
    county_name: "Rock Island",
    county_weights: {
      17161: 100,
    },
    county_names_all: "Rock Island",
    county_fips_all: 17161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61270,
    lat: 41.82971,
    lng: -89.9656,
    city: "Morrison",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6739,
    density: 17.2,
    county_fips: 17195,
    county_name: "Whiteside",
    county_weights: {
      17015: 1.03,
      17195: 98.97,
    },
    county_names_all: "Whiteside|Carroll",
    county_fips_all: "17195|17015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61272,
    lat: 41.24817,
    lng: -91.00865,
    city: "New Boston",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1227,
    density: 5.3,
    county_fips: 17131,
    county_name: "Mercer",
    county_weights: {
      17131: 97.06,
      17161: 2.94,
    },
    county_names_all: "Mercer|Rock Island",
    county_fips_all: "17131|17161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61273,
    lat: 41.36426,
    lng: -90.39907,
    city: "Orion",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3146,
    density: 26.5,
    county_fips: 17073,
    county_name: "Henry",
    county_weights: {
      17073: 75.59,
      17131: 0.35,
      17161: 24.06,
    },
    county_names_all: "Henry|Rock Island|Mercer",
    county_fips_all: "17073|17161|17131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61274,
    lat: 41.37031,
    lng: -90.27666,
    city: "Osco",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 257,
    density: 4.2,
    county_fips: 17073,
    county_name: "Henry",
    county_weights: {
      17073: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 17073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61275,
    lat: 41.60016,
    lng: -90.29781,
    city: "Port Byron",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4878,
    density: 56.6,
    county_fips: 17161,
    county_name: "Rock Island",
    county_weights: {
      17161: 100,
    },
    county_names_all: "Rock Island",
    county_fips_all: 17161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61276,
    lat: 41.31667,
    lng: -90.57638,
    city: "Preemption",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 17131,
    county_name: "Mercer",
    county_weights: {
      17131: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 17131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61277,
    lat: 41.60425,
    lng: -89.93251,
    city: "Prophetstown",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3247,
    density: 9.4,
    county_fips: 17195,
    county_name: "Whiteside",
    county_weights: {
      17073: 39.86,
      17195: 60.14,
    },
    county_names_all: "Whiteside|Henry",
    county_fips_all: "17195|17073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61278,
    lat: 41.57938,
    lng: -90.34138,
    city: "Rapids City",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 411,
    density: 102.3,
    county_fips: 17161,
    county_name: "Rock Island",
    county_weights: {
      17161: 100,
    },
    county_names_all: "Rock Island",
    county_fips_all: 17161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61279,
    lat: 41.32574,
    lng: -90.72863,
    city: "Reynolds",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1020,
    density: 10,
    county_fips: 17131,
    county_name: "Mercer",
    county_weights: {
      17131: 53.09,
      17161: 46.91,
    },
    county_names_all: "Mercer|Rock Island",
    county_fips_all: "17131|17161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61281,
    lat: 41.3009,
    lng: -90.51992,
    city: "Sherrard",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2455,
    density: 23.6,
    county_fips: 17131,
    county_name: "Mercer",
    county_weights: {
      17131: 83.05,
      17161: 16.95,
    },
    county_names_all: "Mercer|Rock Island",
    county_fips_all: "17131|17161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61282,
    lat: 41.49673,
    lng: -90.41172,
    city: "Silvis",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7693,
    density: 945.5,
    county_fips: 17161,
    county_name: "Rock Island",
    county_weights: {
      17161: 100,
    },
    county_names_all: "Rock Island",
    county_fips_all: 17161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61283,
    lat: 41.59094,
    lng: -89.78854,
    city: "Tampico",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1671,
    density: 7.7,
    county_fips: 17195,
    county_name: "Whiteside",
    county_weights: {
      17011: 46.93,
      17073: 2.39,
      17195: 50.68,
    },
    county_names_all: "Whiteside|Bureau|Henry",
    county_fips_all: "17195|17011|17073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61284,
    lat: 41.3927,
    lng: -90.74874,
    city: "Taylor Ridge",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1669,
    density: 14.5,
    county_fips: 17161,
    county_name: "Rock Island",
    county_weights: {
      17161: 100,
    },
    county_names_all: "Rock Island",
    county_fips_all: 17161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61285,
    lat: 41.98307,
    lng: -90.0811,
    city: "Thomson",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1828,
    density: 15.9,
    county_fips: 17015,
    county_name: "Carroll",
    county_weights: {
      17015: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 17015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61301,
    lat: 41.39368,
    lng: -89.07827,
    city: "La Salle",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9785,
    density: 89.4,
    county_fips: 17099,
    county_name: "LaSalle",
    county_weights: {
      17099: 100,
    },
    county_names_all: "LaSalle",
    county_fips_all: 17099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61310,
    lat: 41.69815,
    lng: -89.34769,
    city: "Amboy",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3764,
    density: 13.4,
    county_fips: 17103,
    county_name: "Lee",
    county_weights: {
      17103: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 17103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61311,
    lat: 41.04018,
    lng: -88.86219,
    city: "Ancona",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 357,
    density: 8.4,
    county_fips: 17105,
    county_name: "Livingston",
    county_weights: {
      17105: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 17105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61312,
    lat: 41.43403,
    lng: -89.22544,
    city: "Arlington",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 466,
    density: 5.5,
    county_fips: 17011,
    county_name: "Bureau",
    county_weights: {
      17011: 100,
    },
    county_names_all: "Bureau",
    county_fips_all: 17011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61313,
    lat: 41.07237,
    lng: -88.66993,
    city: "Blackstone",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 236,
    density: 2.2,
    county_fips: 17105,
    county_name: "Livingston",
    county_weights: {
      17105: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 17105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61314,
    lat: 41.29745,
    lng: -89.67474,
    city: "Buda",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 871,
    density: 7.4,
    county_fips: 17011,
    county_name: "Bureau",
    county_weights: {
      17011: 100,
    },
    county_names_all: "Bureau",
    county_fips_all: 17011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61315,
    lat: 41.2865,
    lng: -89.36477,
    city: "Bureau",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 220,
    density: 68.2,
    county_fips: 17011,
    county_name: "Bureau",
    county_weights: {
      17011: 100,
    },
    county_names_all: "Bureau",
    county_fips_all: 17011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61316,
    lat: 41.25718,
    lng: -89.12538,
    city: "Cedar Point",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 215,
    density: 64.5,
    county_fips: 17099,
    county_name: "LaSalle",
    county_weights: {
      17099: 100,
    },
    county_names_all: "LaSalle",
    county_fips_all: 17099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61317,
    lat: 41.43201,
    lng: -89.20813,
    city: "Cherry",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 479,
    density: 181.5,
    county_fips: 17011,
    county_name: "Bureau",
    county_weights: {
      17011: 100,
    },
    county_names_all: "Bureau",
    county_fips_all: 17011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61318,
    lat: 41.71202,
    lng: -89.08039,
    city: "Compton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 677,
    density: 7.9,
    county_fips: 17103,
    county_name: "Lee",
    county_weights: {
      17103: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 17103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61319,
    lat: 41.01291,
    lng: -88.73942,
    city: "Cornell",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1268,
    density: 9.9,
    county_fips: 17105,
    county_name: "Livingston",
    county_weights: {
      17105: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 17105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61320,
    lat: 41.3553,
    lng: -89.17047,
    city: "Dalzell",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 622,
    density: 281.4,
    county_fips: 17011,
    county_name: "Bureau",
    county_weights: {
      17011: 100,
    },
    county_names_all: "Bureau",
    county_fips_all: 17011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61321,
    lat: 40.96754,
    lng: -88.97621,
    city: "Dana",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 315,
    density: 4.2,
    county_fips: 17099,
    county_name: "LaSalle",
    county_weights: {
      17099: 96.79,
      17123: 3.21,
    },
    county_names_all: "LaSalle|Marshall",
    county_fips_all: "17099|17123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61322,
    lat: 41.3185,
    lng: -89.30566,
    city: "Depue",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1498,
    density: 161.5,
    county_fips: 17011,
    county_name: "Bureau",
    county_weights: {
      17011: 100,
    },
    county_names_all: "Bureau",
    county_fips_all: 17011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61323,
    lat: 41.43544,
    lng: -89.39605,
    city: "Dover",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 102,
    density: 309.9,
    county_fips: 17011,
    county_name: "Bureau",
    county_weights: {
      17011: 100,
    },
    county_names_all: "Bureau",
    county_fips_all: 17011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61324,
    lat: 41.76994,
    lng: -89.4136,
    city: "Eldena",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 101,
    density: 189.8,
    county_fips: 17103,
    county_name: "Lee",
    county_weights: {
      17103: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 17103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61325,
    lat: 41.23673,
    lng: -88.80973,
    city: "Grand Ridge",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1085,
    density: 8.9,
    county_fips: 17099,
    county_name: "LaSalle",
    county_weights: {
      17099: 100,
    },
    county_names_all: "LaSalle",
    county_fips_all: 17099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61326,
    lat: 41.25276,
    lng: -89.22083,
    city: "Granville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2166,
    density: 17.5,
    county_fips: 17155,
    county_name: "Putnam",
    county_weights: {
      17155: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 17155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61327,
    lat: 41.22827,
    lng: -89.30876,
    city: "Hennepin",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1459,
    density: 15.5,
    county_fips: 17155,
    county_name: "Putnam",
    county_weights: {
      17155: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 17155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61328,
    lat: 41.50924,
    lng: -89.459,
    city: "Kasbeer",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 70,
    density: 18,
    county_fips: 17011,
    county_name: "Bureau",
    county_weights: {
      17011: 100,
    },
    county_names_all: "Bureau",
    county_fips_all: 17011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61329,
    lat: 41.37709,
    lng: -89.20791,
    city: "Ladd",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1242,
    density: 225,
    county_fips: 17011,
    county_name: "Bureau",
    county_weights: {
      17011: 100,
    },
    county_names_all: "Bureau",
    county_fips_all: 17011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61330,
    lat: 41.53602,
    lng: -89.27756,
    city: "La Moille",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1295,
    density: 6.8,
    county_fips: 17011,
    county_name: "Bureau",
    county_weights: {
      17011: 91.84,
      17103: 8.16,
    },
    county_names_all: "Bureau|Lee",
    county_fips_all: "17011|17103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61331,
    lat: 41.74771,
    lng: -89.27754,
    city: "Lee Center",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 17103,
    county_name: "Lee",
    county_weights: {
      17103: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 17103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61332,
    lat: 41.18884,
    lng: -88.98456,
    city: "Leonore",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 143,
    density: 74.4,
    county_fips: 17099,
    county_name: "LaSalle",
    county_weights: {
      17099: 100,
    },
    county_names_all: "LaSalle",
    county_fips_all: 17099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61333,
    lat: 40.98845,
    lng: -88.88931,
    city: "Long Point",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 330,
    density: 7.4,
    county_fips: 17105,
    county_name: "Livingston",
    county_weights: {
      17105: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 17105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61334,
    lat: 41.14731,
    lng: -89.09935,
    city: "Lostant",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 677,
    density: 6.7,
    county_fips: 17099,
    county_name: "LaSalle",
    county_weights: {
      17099: 99.29,
      17155: 0.71,
    },
    county_names_all: "LaSalle|Putnam",
    county_fips_all: "17099|17155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61335,
    lat: 41.16141,
    lng: -89.23228,
    city: "McNabb",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 318,
    density: 5.7,
    county_fips: 17155,
    county_name: "Putnam",
    county_weights: {
      17155: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 17155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61336,
    lat: 41.1073,
    lng: -89.21727,
    city: "Magnolia",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 450,
    density: 4.6,
    county_fips: 17155,
    county_name: "Putnam",
    county_weights: {
      17123: 43.1,
      17155: 56.9,
    },
    county_names_all: "Putnam|Marshall",
    county_fips_all: "17155|17123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61337,
    lat: 41.43827,
    lng: -89.3171,
    city: "Malden",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 548,
    density: 29.6,
    county_fips: 17011,
    county_name: "Bureau",
    county_weights: {
      17011: 100,
    },
    county_names_all: "Bureau",
    county_fips_all: 17011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61338,
    lat: 41.47014,
    lng: -89.66517,
    city: "Manlius",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 17011,
    county_name: "Bureau",
    county_weights: {
      17011: 100,
    },
    county_names_all: "Bureau",
    county_fips_all: 17011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61340,
    lat: 41.26396,
    lng: -89.25123,
    city: "Mark",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 373,
    density: 165.2,
    county_fips: 17155,
    county_name: "Putnam",
    county_weights: {
      17155: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 17155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61341,
    lat: 41.34015,
    lng: -88.69246,
    city: "Marseilles",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7599,
    density: 32,
    county_fips: 17099,
    county_name: "LaSalle",
    county_weights: {
      17099: 100,
    },
    county_names_all: "LaSalle",
    county_fips_all: 17099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61342,
    lat: 41.54089,
    lng: -89.0938,
    city: "Mendota",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8474,
    density: 30.3,
    county_fips: 17099,
    county_name: "LaSalle",
    county_weights: {
      17011: 8.11,
      17099: 86.87,
      17103: 5.02,
    },
    county_names_all: "LaSalle|Bureau|Lee",
    county_fips_all: "17099|17011|17103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61344,
    lat: 41.41245,
    lng: -89.8344,
    city: "Mineral",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 445,
    density: 7.9,
    county_fips: 17011,
    county_name: "Bureau",
    county_weights: {
      17011: 94.89,
      17073: 5.11,
    },
    county_names_all: "Bureau|Henry",
    county_fips_all: "17011|17073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61345,
    lat: 41.27981,
    lng: -89.78878,
    city: "Neponset",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 735,
    density: 6,
    county_fips: 17011,
    county_name: "Bureau",
    county_weights: {
      17011: 91.97,
      17175: 8.03,
    },
    county_names_all: "Bureau|Stark",
    county_fips_all: "17011|17175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61346,
    lat: 41.50659,
    lng: -89.7199,
    city: "New Bedford",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57,
    density: 40.5,
    county_fips: 17011,
    county_name: "Bureau",
    county_weights: {
      17011: 100,
    },
    county_names_all: "Bureau",
    county_fips_all: 17011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61348,
    lat: 41.2812,
    lng: -89.03685,
    city: "Oglesby",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4358,
    density: 42.8,
    county_fips: 17099,
    county_name: "LaSalle",
    county_weights: {
      17099: 100,
    },
    county_names_all: "LaSalle",
    county_fips_all: 17099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61349,
    lat: 41.55295,
    lng: -89.44192,
    city: "Ohio",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1083,
    density: 6.7,
    county_fips: 17011,
    county_name: "Bureau",
    county_weights: {
      17011: 73.23,
      17103: 26.77,
    },
    county_names_all: "Bureau|Lee",
    county_fips_all: "17011|17103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61350,
    lat: 41.37152,
    lng: -88.86157,
    city: "Ottawa",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23969,
    density: 60.7,
    county_fips: 17099,
    county_name: "LaSalle",
    county_weights: {
      17099: 100,
    },
    county_names_all: "LaSalle",
    county_fips_all: 17099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61353,
    lat: 41.6967,
    lng: -88.99623,
    city: "Paw Paw",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1346,
    density: 16.1,
    county_fips: 17103,
    county_name: "Lee",
    county_weights: {
      17103: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 17103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61354,
    lat: 41.33158,
    lng: -89.14281,
    city: "Peru",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10435,
    density: 94.6,
    county_fips: 17099,
    county_name: "LaSalle",
    county_weights: {
      17011: 8.02,
      17099: 91.98,
    },
    county_names_all: "LaSalle|Bureau",
    county_fips_all: "17099|17011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61356,
    lat: 41.38914,
    lng: -89.43406,
    city: "Princeton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10513,
    density: 21.4,
    county_fips: 17011,
    county_name: "Bureau",
    county_weights: {
      17011: 100,
    },
    county_names_all: "Bureau",
    county_fips_all: 17011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61358,
    lat: 40.98166,
    lng: -89.04299,
    city: "Rutland",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 308,
    density: 5.1,
    county_fips: 17099,
    county_name: "LaSalle",
    county_weights: {
      17099: 53.61,
      17123: 46.39,
    },
    county_names_all: "LaSalle|Marshall",
    county_fips_all: "17099|17123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61359,
    lat: 41.36341,
    lng: -89.26962,
    city: "Seatonville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 369,
    density: 192.9,
    county_fips: 17011,
    county_name: "Bureau",
    county_weights: {
      17011: 100,
    },
    county_names_all: "Bureau",
    county_fips_all: 17011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61360,
    lat: 41.33439,
    lng: -88.60522,
    city: "Seneca",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3307,
    density: 26.9,
    county_fips: 17099,
    county_name: "LaSalle",
    county_weights: {
      17063: 21.21,
      17099: 78.79,
    },
    county_names_all: "LaSalle|Grundy",
    county_fips_all: "17099|17063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61361,
    lat: 41.40913,
    lng: -89.76778,
    city: "Sheffield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1181,
    density: 5.1,
    county_fips: 17011,
    county_name: "Bureau",
    county_weights: {
      17011: 90.37,
      17073: 9.63,
    },
    county_names_all: "Bureau|Henry",
    county_fips_all: "17011|17073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61362,
    lat: 41.35138,
    lng: -89.22819,
    city: "Spring Valley",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5450,
    density: 82.8,
    county_fips: 17011,
    county_name: "Bureau",
    county_weights: {
      17011: 100,
    },
    county_names_all: "Bureau",
    county_fips_all: 17011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61363,
    lat: 41.25425,
    lng: -89.18248,
    city: "Standard",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 281,
    density: 210.9,
    county_fips: 17155,
    county_name: "Putnam",
    county_weights: {
      17155: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 17155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61364,
    lat: 41.12822,
    lng: -88.85097,
    city: "Streator",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18489,
    density: 45.4,
    county_fips: 17099,
    county_name: "LaSalle",
    county_weights: {
      17099: 78.21,
      17105: 21.79,
    },
    county_names_all: "LaSalle|Livingston",
    county_fips_all: "17099|17105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61367,
    lat: 41.62611,
    lng: -89.26221,
    city: "Sublette",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 760,
    density: 6.8,
    county_fips: 17103,
    county_name: "Lee",
    county_weights: {
      17103: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 17103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61368,
    lat: 41.26113,
    lng: -89.51981,
    city: "Tiskilwa",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1334,
    density: 7.1,
    county_fips: 17011,
    county_name: "Bureau",
    county_weights: {
      17011: 100,
    },
    county_names_all: "Bureau",
    county_fips_all: 17011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61369,
    lat: 40.9827,
    lng: -89.15397,
    city: "Toluca",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1576,
    density: 14,
    county_fips: 17123,
    county_name: "Marshall",
    county_weights: {
      17123: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 17123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61370,
    lat: 41.20854,
    lng: -89.03476,
    city: "Tonica",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1354,
    density: 11.7,
    county_fips: 17099,
    county_name: "LaSalle",
    county_weights: {
      17099: 100,
    },
    county_names_all: "LaSalle",
    county_fips_all: 17099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61371,
    lat: 41.49936,
    lng: -89.01986,
    city: "Triumph",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 17099,
    county_name: "LaSalle",
    county_weights: {
      17099: 100,
    },
    county_names_all: "LaSalle",
    county_fips_all: 17099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61372,
    lat: 41.46582,
    lng: -89.08239,
    city: "Troy Grove",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 156,
    density: 95.3,
    county_fips: 17099,
    county_name: "LaSalle",
    county_weights: {
      17099: 100,
    },
    county_names_all: "LaSalle",
    county_fips_all: 17099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61373,
    lat: 41.4004,
    lng: -88.99456,
    city: "Utica",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2108,
    density: 17.3,
    county_fips: 17099,
    county_name: "LaSalle",
    county_weights: {
      17099: 100,
    },
    county_names_all: "LaSalle",
    county_fips_all: 17099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61374,
    lat: 41.5473,
    lng: -89.35759,
    city: "Van Orin",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 115,
    density: 13.7,
    county_fips: 17011,
    county_name: "Bureau",
    county_weights: {
      17011: 100,
    },
    county_names_all: "Bureau",
    county_fips_all: 17011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61375,
    lat: 41.03254,
    lng: -89.24688,
    city: "Varna",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1049,
    density: 8.3,
    county_fips: 17123,
    county_name: "Marshall",
    county_weights: {
      17123: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 17123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61376,
    lat: 41.54065,
    lng: -89.60726,
    city: "Walnut",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1934,
    density: 7.6,
    county_fips: 17011,
    county_name: "Bureau",
    county_weights: {
      17011: 85.55,
      17103: 14.45,
    },
    county_names_all: "Bureau|Lee",
    county_fips_all: "17011|17103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61377,
    lat: 41.05847,
    lng: -89.04444,
    city: "Wenona",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1531,
    density: 11.5,
    county_fips: 17099,
    county_name: "LaSalle",
    county_weights: {
      17099: 50.17,
      17123: 49.83,
    },
    county_names_all: "LaSalle|Marshall",
    county_fips_all: "17099|17123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61378,
    lat: 41.72614,
    lng: -89.158,
    city: "West Brooklyn",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 307,
    density: 2,
    county_fips: 17103,
    county_name: "Lee",
    county_weights: {
      17103: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 17103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61379,
    lat: 41.38144,
    lng: -89.61077,
    city: "Wyanet",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1454,
    density: 14.1,
    county_fips: 17011,
    county_name: "Bureau",
    county_weights: {
      17011: 100,
    },
    county_names_all: "Bureau",
    county_fips_all: 17011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61401,
    lat: 40.94451,
    lng: -90.38888,
    city: "Galesburg",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32831,
    density: 103.2,
    county_fips: 17095,
    county_name: "Knox",
    county_weights: {
      17095: 79.73,
      17187: 20.27,
    },
    county_names_all: "Knox|Warren",
    county_fips_all: "17095|17187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61402,
    lat: 40.93993,
    lng: -90.40627,
    city: "Galesburg",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 17095,
    county_name: "Knox",
    county_weights: {
      17095: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 17095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61410,
    lat: 40.79779,
    lng: -90.40703,
    city: "Abingdon",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3877,
    density: 33.3,
    county_fips: 17095,
    county_name: "Knox",
    county_weights: {
      17095: 72.37,
      17187: 27.63,
    },
    county_names_all: "Knox|Warren",
    county_fips_all: "17095|17187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61411,
    lat: 40.40105,
    lng: -90.50544,
    city: "Adair",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 367,
    density: 3.6,
    county_fips: 17109,
    county_name: "McDonough",
    county_weights: {
      17109: 100,
    },
    county_names_all: "McDonough",
    county_fips_all: 17109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61412,
    lat: 41.07092,
    lng: -90.58853,
    city: "Alexis",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1377,
    density: 6.7,
    county_fips: 17131,
    county_name: "Mercer",
    county_weights: {
      17131: 54.85,
      17187: 45.15,
    },
    county_names_all: "Mercer|Warren",
    county_fips_all: "17131|17187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61413,
    lat: 41.19135,
    lng: -90.37227,
    city: "Alpha",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 929,
    density: 12.1,
    county_fips: 17073,
    county_name: "Henry",
    county_weights: {
      17073: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 17073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61414,
    lat: 41.12597,
    lng: -90.15495,
    city: "Altona",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 852,
    density: 6,
    county_fips: 17095,
    county_name: "Knox",
    county_weights: {
      17073: 21.47,
      17095: 78.53,
    },
    county_names_all: "Knox|Henry",
    county_fips_all: "17095|17073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61415,
    lat: 40.65425,
    lng: -90.42801,
    city: "Avon",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2041,
    density: 7.2,
    county_fips: 17057,
    county_name: "Fulton",
    county_weights: {
      17057: 62.61,
      17187: 37.39,
    },
    county_names_all: "Fulton|Warren",
    county_fips_all: "17057|17187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61416,
    lat: 40.49592,
    lng: -90.56308,
    city: "Bardolph",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 269,
    density: 168.3,
    county_fips: 17109,
    county_name: "McDonough",
    county_weights: {
      17109: 100,
    },
    county_names_all: "McDonough",
    county_fips_all: 17109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61417,
    lat: 40.77222,
    lng: -90.54413,
    city: "Berwick",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 312,
    density: 5.1,
    county_fips: 17187,
    county_name: "Warren",
    county_weights: {
      17187: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 17187,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61418,
    lat: 40.84714,
    lng: -90.86492,
    city: "Biggsville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 645,
    density: 5,
    county_fips: 17071,
    county_name: "Henderson",
    county_weights: {
      17071: 100,
    },
    county_names_all: "Henderson",
    county_fips_all: 17071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61419,
    lat: 41.19982,
    lng: -90.11751,
    city: "Bishop Hill",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 92,
    density: 66.8,
    county_fips: 17073,
    county_name: "Henry",
    county_weights: {
      17073: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 17073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61420,
    lat: 40.5491,
    lng: -90.86679,
    city: "Blandinsville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1037,
    density: 5.8,
    county_fips: 17109,
    county_name: "McDonough",
    county_weights: {
      17067: 18.86,
      17109: 81.14,
    },
    county_names_all: "McDonough|Hancock",
    county_fips_all: "17109|17067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61421,
    lat: 41.1792,
    lng: -89.65083,
    city: "Bradford",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1398,
    density: 5.4,
    county_fips: 17175,
    county_name: "Stark",
    county_weights: {
      17011: 36.36,
      17123: 9.08,
      17175: 54.56,
    },
    county_names_all: "Stark|Bureau|Marshall",
    county_fips_all: "17175|17011|17123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61422,
    lat: 40.55084,
    lng: -90.53113,
    city: "Bushnell",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3116,
    density: 27.8,
    county_fips: 17109,
    county_name: "McDonough",
    county_weights: {
      17109: 100,
    },
    county_names_all: "McDonough",
    county_fips_all: 17109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61423,
    lat: 40.8855,
    lng: -90.50232,
    city: "Cameron",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 582,
    density: 5.2,
    county_fips: 17187,
    county_name: "Warren",
    county_weights: {
      17187: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 17187,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61424,
    lat: 41.07671,
    lng: -89.63513,
    city: "Camp Grove",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68,
    density: 37.1,
    county_fips: 17123,
    county_name: "Marshall",
    county_weights: {
      17123: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 17123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61425,
    lat: 40.76297,
    lng: -91.04575,
    city: "Carman",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 503,
    density: 5.9,
    county_fips: 17071,
    county_name: "Henderson",
    county_weights: {
      17071: 100,
    },
    county_names_all: "Henderson",
    county_fips_all: 17071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61426,
    lat: 41.11964,
    lng: -89.70601,
    city: "Castleton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 92,
    density: 11.6,
    county_fips: 17175,
    county_name: "Stark",
    county_weights: {
      17175: 100,
    },
    county_names_all: "Stark",
    county_fips_all: 17175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61427,
    lat: 40.49823,
    lng: -90.19319,
    city: "Cuba",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2066,
    density: 13.8,
    county_fips: 17057,
    county_name: "Fulton",
    county_weights: {
      17057: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 17057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61428,
    lat: 40.93262,
    lng: -90.10977,
    city: "Dahinda",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 953,
    density: 12.4,
    county_fips: 17095,
    county_name: "Knox",
    county_weights: {
      17095: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 17095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61430,
    lat: 40.94393,
    lng: -90.31135,
    city: "East Galesburg",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 603,
    density: 157.3,
    county_fips: 17095,
    county_name: "Knox",
    county_weights: {
      17095: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 17095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61431,
    lat: 40.60315,
    lng: -90.2776,
    city: "Ellisville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 214,
    density: 2.4,
    county_fips: 17057,
    county_name: "Fulton",
    county_weights: {
      17057: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 17057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61432,
    lat: 40.65055,
    lng: -90.16086,
    city: "Fairview",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 654,
    density: 6.8,
    county_fips: 17057,
    county_name: "Fulton",
    county_weights: {
      17057: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 17057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61433,
    lat: 40.55749,
    lng: -90.16866,
    city: "Fiatt",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 115,
    density: 41.9,
    county_fips: 17057,
    county_name: "Fulton",
    county_weights: {
      17057: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 17057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61434,
    lat: 41.17387,
    lng: -90.03598,
    city: "Galva",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2859,
    density: 14,
    county_fips: 17073,
    county_name: "Henry",
    county_weights: {
      17073: 74.36,
      17095: 24.84,
      17175: 0.8,
    },
    county_names_all: "Henry|Knox|Stark",
    county_fips_all: "17073|17095|17175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61435,
    lat: 40.99559,
    lng: -90.5686,
    city: "Gerlaw",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13,
    density: 0.3,
    county_fips: 17187,
    county_name: "Warren",
    county_weights: {
      17187: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 17187,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61436,
    lat: 40.86067,
    lng: -90.21739,
    city: "Gilson",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 797,
    density: 5,
    county_fips: 17095,
    county_name: "Knox",
    county_weights: {
      17095: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 17095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61437,
    lat: 40.84911,
    lng: -90.98905,
    city: "Gladstone",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 675,
    density: 6.9,
    county_fips: 17071,
    county_name: "Henderson",
    county_weights: {
      17071: 100,
    },
    county_names_all: "Henderson",
    county_fips_all: 17071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61438,
    lat: 40.58538,
    lng: -90.64942,
    city: "Good Hope",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 776,
    density: 7.4,
    county_fips: 17109,
    county_name: "McDonough",
    county_weights: {
      17109: 100,
    },
    county_names_all: "McDonough",
    county_fips_all: 17109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61439,
    lat: 41.02923,
    lng: -90.35019,
    city: "Henderson",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 277,
    density: 85.6,
    county_fips: 17095,
    county_name: "Knox",
    county_weights: {
      17095: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 17095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61440,
    lat: 40.3079,
    lng: -90.59786,
    city: "Industry",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 771,
    density: 6.9,
    county_fips: 17109,
    county_name: "McDonough",
    county_weights: {
      17109: 82.92,
      17169: 17.08,
    },
    county_names_all: "McDonough|Schuyler",
    county_fips_all: "17109|17169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61441,
    lat: 40.33957,
    lng: -90.29336,
    city: "Ipava",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1030,
    density: 6.6,
    county_fips: 17057,
    county_name: "Fulton",
    county_weights: {
      17057: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 17057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61442,
    lat: 41.10237,
    lng: -90.92303,
    city: "Keithsburg",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 718,
    density: 9.7,
    county_fips: 17131,
    county_name: "Mercer",
    county_weights: {
      17071: 21.3,
      17131: 78.7,
    },
    county_names_all: "Mercer|Henderson",
    county_fips_all: "17131|17071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61443,
    lat: 41.25972,
    lng: -89.94242,
    city: "Kewanee",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13686,
    density: 52.6,
    county_fips: 17073,
    county_name: "Henry",
    county_weights: {
      17011: 2.54,
      17073: 93.96,
      17175: 3.5,
    },
    county_names_all: "Henry|Stark|Bureau",
    county_fips_all: "17073|17175|17011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61447,
    lat: 40.87105,
    lng: -90.76674,
    city: "Kirkwood",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1115,
    density: 10.2,
    county_fips: 17187,
    county_name: "Warren",
    county_weights: {
      17071: 31.12,
      17187: 68.88,
    },
    county_names_all: "Warren|Henderson",
    county_fips_all: "17187|17071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61448,
    lat: 40.93385,
    lng: -90.24374,
    city: "Knoxville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3835,
    density: 36.2,
    county_fips: 17095,
    county_name: "Knox",
    county_weights: {
      17095: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 17095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61449,
    lat: 41.08926,
    lng: -89.97051,
    city: "La Fayette",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 227,
    density: 2.4,
    county_fips: 17175,
    county_name: "Stark",
    county_weights: {
      17095: 30.98,
      17175: 69.02,
    },
    county_names_all: "Stark|Knox",
    county_fips_all: "17175|17095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61450,
    lat: 40.57629,
    lng: -90.98088,
    city: "La Harpe",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1776,
    density: 9,
    county_fips: 17067,
    county_name: "Hancock",
    county_weights: {
      17067: 89.11,
      17071: 7.19,
      17109: 3.7,
    },
    county_names_all: "Hancock|Henderson|McDonough",
    county_fips_all: "17067|17071|17109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61451,
    lat: 40.94117,
    lng: -89.93555,
    city: "Laura",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 236,
    density: 4.2,
    county_fips: 17143,
    county_name: "Peoria",
    county_weights: {
      17143: 99.9,
      17175: 0.1,
    },
    county_names_all: "Peoria|Stark",
    county_fips_all: "17143|17175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61452,
    lat: 40.23836,
    lng: -90.66022,
    city: "Littleton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 205,
    density: 2.6,
    county_fips: 17169,
    county_name: "Schuyler",
    county_weights: {
      17109: 4.27,
      17169: 95.73,
    },
    county_names_all: "Schuyler|McDonough",
    county_fips_all: "17169|17109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61453,
    lat: 41.01345,
    lng: -90.76322,
    city: "Little York",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 644,
    density: 4.4,
    county_fips: 17187,
    county_name: "Warren",
    county_weights: {
      17071: 41.69,
      17187: 58.31,
    },
    county_names_all: "Warren|Henderson",
    county_fips_all: "17187|17071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61454,
    lat: 40.68152,
    lng: -91.04535,
    city: "Lomax",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 440,
    density: 5,
    county_fips: 17071,
    county_name: "Henderson",
    county_weights: {
      17071: 100,
    },
    county_names_all: "Henderson",
    county_fips_all: 17071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61455,
    lat: 40.44047,
    lng: -90.65115,
    city: "Macomb",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20020,
    density: 47.6,
    county_fips: 17109,
    county_name: "McDonough",
    county_weights: {
      17109: 100,
    },
    county_names_all: "McDonough",
    county_fips_all: 17109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61458,
    lat: 40.78027,
    lng: -90.18107,
    city: "Maquon",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 494,
    density: 2.3,
    county_fips: 17095,
    county_name: "Knox",
    county_weights: {
      17095: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 17095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61459,
    lat: 40.50497,
    lng: -90.41453,
    city: "Marietta",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 355,
    density: 3.9,
    county_fips: 17057,
    county_name: "Fulton",
    county_weights: {
      17057: 84.68,
      17109: 15.32,
    },
    county_names_all: "Fulton|McDonough",
    county_fips_all: "17057|17109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61460,
    lat: 40.72159,
    lng: -90.82774,
    city: "Media",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 275,
    density: 3.4,
    county_fips: 17071,
    county_name: "Henderson",
    county_weights: {
      17071: 100,
    },
    county_names_all: "Henderson",
    county_fips_all: 17071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61462,
    lat: 40.91014,
    lng: -90.65176,
    city: "Monmouth",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11177,
    density: 30.3,
    county_fips: 17187,
    county_name: "Warren",
    county_weights: {
      17071: 3.91,
      17187: 96.09,
    },
    county_names_all: "Warren|Henderson",
    county_fips_all: "17187|17071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61465,
    lat: 41.20618,
    lng: -90.46744,
    city: "New Windsor",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1173,
    density: 11.2,
    county_fips: 17131,
    county_name: "Mercer",
    county_weights: {
      17073: 15.71,
      17131: 84.29,
    },
    county_names_all: "Mercer|Henry",
    county_fips_all: "17131|17073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61466,
    lat: 41.11103,
    lng: -90.48222,
    city: "North Henderson",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 319,
    density: 5.2,
    county_fips: 17131,
    county_name: "Mercer",
    county_weights: {
      17131: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 17131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61467,
    lat: 41.07115,
    lng: -90.24338,
    city: "Oneida",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1183,
    density: 8.8,
    county_fips: 17095,
    county_name: "Knox",
    county_weights: {
      17095: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 17095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61468,
    lat: 41.2565,
    lng: -90.38751,
    city: "Ophiem",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 180,
    density: 57.9,
    county_fips: 17073,
    county_name: "Henry",
    county_weights: {
      17073: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 17073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61469,
    lat: 40.96262,
    lng: -90.91066,
    city: "Oquawka",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2160,
    density: 20.2,
    county_fips: 17071,
    county_name: "Henderson",
    county_weights: {
      17071: 100,
    },
    county_names_all: "Henderson",
    county_fips_all: 17071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61470,
    lat: 40.60613,
    lng: -90.50623,
    city: "Prairie City",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 659,
    density: 13.2,
    county_fips: 17109,
    county_name: "McDonough",
    county_weights: {
      17109: 100,
    },
    county_names_all: "McDonough",
    county_fips_all: 17109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61471,
    lat: 40.69583,
    lng: -90.82507,
    city: "Raritan",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 123,
    density: 499.7,
    county_fips: 17071,
    county_name: "Henderson",
    county_weights: {
      17071: 100,
    },
    county_names_all: "Henderson",
    county_fips_all: 17071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61472,
    lat: 41.10327,
    lng: -90.38345,
    city: "Rio",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 565,
    density: 5.6,
    county_fips: 17095,
    county_name: "Knox",
    county_weights: {
      17095: 98.72,
      17131: 1.28,
    },
    county_names_all: "Knox|Mercer",
    county_fips_all: "17095|17131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61473,
    lat: 40.70914,
    lng: -90.64975,
    city: "Roseville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1297,
    density: 4.7,
    county_fips: 17187,
    county_name: "Warren",
    county_weights: {
      17187: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 17187,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61474,
    lat: 40.73419,
    lng: -90.39724,
    city: "Saint Augustine",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 257,
    density: 3.8,
    county_fips: 17095,
    county_name: "Knox",
    county_weights: {
      17057: 6.49,
      17095: 76.16,
      17187: 17.35,
    },
    county_names_all: "Knox|Warren|Fulton",
    county_fips_all: "17095|17187|17057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61475,
    lat: 40.5969,
    lng: -90.7527,
    city: "Sciota",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 206,
    density: 2.4,
    county_fips: 17109,
    county_name: "McDonough",
    county_weights: {
      17071: 1.94,
      17109: 86.03,
      17187: 12.03,
    },
    county_names_all: "McDonough|Warren|Henderson",
    county_fips_all: "17109|17187|17071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61476,
    lat: 41.09191,
    lng: -90.83259,
    city: "Seaton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 448,
    density: 3.9,
    county_fips: 17131,
    county_name: "Mercer",
    county_weights: {
      17071: 28.11,
      17131: 71.89,
    },
    county_names_all: "Mercer|Henderson",
    county_fips_all: "17131|17071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61477,
    lat: 40.4945,
    lng: -90.31402,
    city: "Smithfield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 539,
    density: 4.1,
    county_fips: 17057,
    county_name: "Fulton",
    county_weights: {
      17057: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 17057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61478,
    lat: 40.75633,
    lng: -90.76035,
    city: "Smithshire",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 202,
    density: 2.3,
    county_fips: 17187,
    county_name: "Warren",
    county_weights: {
      17071: 14.05,
      17187: 85.95,
    },
    county_names_all: "Warren|Henderson",
    county_fips_all: "17187|17071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61479,
    lat: 41.00192,
    lng: -89.63939,
    city: "Speer",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 105,
    density: 3.6,
    county_fips: 17123,
    county_name: "Marshall",
    county_weights: {
      17123: 51.06,
      17175: 48.94,
    },
    county_names_all: "Marshall|Stark",
    county_fips_all: "17123|17175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61480,
    lat: 40.72323,
    lng: -90.91827,
    city: "Stronghurst",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1249,
    density: 6.7,
    county_fips: 17071,
    county_name: "Henderson",
    county_weights: {
      17071: 100,
    },
    county_names_all: "Henderson",
    county_fips_all: 17071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61482,
    lat: 40.39362,
    lng: -90.40766,
    city: "Table Grove",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 555,
    density: 4.2,
    county_fips: 17057,
    county_name: "Fulton",
    county_weights: {
      17057: 88.25,
      17109: 11.75,
    },
    county_names_all: "Fulton|McDonough",
    county_fips_all: "17057|17109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61483,
    lat: 41.08157,
    lng: -89.87186,
    city: "Toulon",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1923,
    density: 7.6,
    county_fips: 17175,
    county_name: "Stark",
    county_weights: {
      17175: 100,
    },
    county_names_all: "Stark",
    county_fips_all: 17175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61484,
    lat: 40.29696,
    lng: -90.44153,
    city: "Vermont",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 804,
    density: 6.6,
    county_fips: 17057,
    county_name: "Fulton",
    county_weights: {
      17057: 54.17,
      17109: 41.28,
      17169: 4.55,
    },
    county_names_all: "Fulton|McDonough|Schuyler",
    county_fips_all: "17057|17109|17169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61485,
    lat: 41.01677,
    lng: -90.09764,
    city: "Victoria",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 359,
    density: 2.9,
    county_fips: 17095,
    county_name: "Knox",
    county_weights: {
      17095: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 17095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61486,
    lat: 41.19609,
    lng: -90.57614,
    city: "Viola",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1415,
    density: 12.6,
    county_fips: 17131,
    county_name: "Mercer",
    county_weights: {
      17131: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 17131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61488,
    lat: 41.03004,
    lng: -90.32071,
    city: "Wataga",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1252,
    density: 20.5,
    county_fips: 17095,
    county_name: "Knox",
    county_weights: {
      17095: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 17095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61489,
    lat: 40.93462,
    lng: -90.02664,
    city: "Williamsfield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 847,
    density: 6.9,
    county_fips: 17095,
    county_name: "Knox",
    county_weights: {
      17095: 96.58,
      17143: 3.42,
    },
    county_names_all: "Knox|Peoria",
    county_fips_all: "17095|17143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61490,
    lat: 41.18263,
    lng: -90.26518,
    city: "Woodhull",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1053,
    density: 11.1,
    county_fips: 17073,
    county_name: "Henry",
    county_weights: {
      17073: 86.9,
      17095: 13.1,
    },
    county_names_all: "Henry|Knox",
    county_fips_all: "17073|17095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61491,
    lat: 41.05982,
    lng: -89.72525,
    city: "Wyoming",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2099,
    density: 8.4,
    county_fips: 17175,
    county_name: "Stark",
    county_weights: {
      17123: 10.77,
      17175: 89.23,
    },
    county_names_all: "Stark|Marshall",
    county_fips_all: "17175|17123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61501,
    lat: 40.22797,
    lng: -90.31233,
    city: "Astoria",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1741,
    density: 9,
    county_fips: 17057,
    county_name: "Fulton",
    county_weights: {
      17057: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 17057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61516,
    lat: 40.85555,
    lng: -89.13197,
    city: "Benson",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 769,
    density: 9.5,
    county_fips: 17203,
    county_name: "Woodford",
    county_weights: {
      17203: 100,
    },
    county_names_all: "Woodford",
    county_fips_all: 17203,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61517,
    lat: 40.823,
    lng: -89.85155,
    city: "Brimfield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3442,
    density: 19.4,
    county_fips: 17143,
    county_name: "Peoria",
    county_weights: {
      17143: 100,
    },
    county_names_all: "Peoria",
    county_fips_all: 17143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61519,
    lat: 40.46463,
    lng: -90.09309,
    city: "Bryant",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 225,
    density: 27.7,
    county_fips: 17057,
    county_name: "Fulton",
    county_weights: {
      17057: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 17057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61520,
    lat: 40.54197,
    lng: -90.02156,
    city: "Canton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16509,
    density: 41.9,
    county_fips: 17057,
    county_name: "Fulton",
    county_weights: {
      17057: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 17057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61523,
    lat: 40.91751,
    lng: -89.53562,
    city: "Chillicothe",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10912,
    density: 79.1,
    county_fips: 17143,
    county_name: "Peoria",
    county_weights: {
      17123: 6.12,
      17143: 93.47,
      17203: 0.41,
    },
    county_names_all: "Peoria|Marshall|Woodford",
    county_fips_all: "17143|17123|17203",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61524,
    lat: 40.49125,
    lng: -90.03468,
    city: "Dunfermline",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 359,
    density: 558.9,
    county_fips: 17057,
    county_name: "Fulton",
    county_weights: {
      17057: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 17057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61525,
    lat: 40.84776,
    lng: -89.67047,
    city: "Dunlap",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9318,
    density: 110,
    county_fips: 17143,
    county_name: "Peoria",
    county_weights: {
      17143: 100,
    },
    county_names_all: "Peoria",
    county_fips_all: 17143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61526,
    lat: 40.92899,
    lng: -89.62599,
    city: "Edelstein",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 725,
    density: 9.2,
    county_fips: 17143,
    county_name: "Peoria",
    county_weights: {
      17123: 8.2,
      17143: 91.8,
    },
    county_names_all: "Peoria|Marshall",
    county_fips_all: "17143|17123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61528,
    lat: 40.7757,
    lng: -89.7227,
    city: "Edwards",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2862,
    density: 59.6,
    county_fips: 17143,
    county_name: "Peoria",
    county_weights: {
      17143: 100,
    },
    county_names_all: "Peoria",
    county_fips_all: 17143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61529,
    lat: 40.7809,
    lng: -89.93673,
    city: "Elmwood",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2839,
    density: 17,
    county_fips: 17143,
    county_name: "Peoria",
    county_weights: {
      17095: 2.45,
      17143: 97.55,
    },
    county_names_all: "Peoria|Knox",
    county_fips_all: "17143|17095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61530,
    lat: 40.71146,
    lng: -89.26287,
    city: "Eureka",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6624,
    density: 40.1,
    county_fips: 17203,
    county_name: "Woodford",
    county_weights: {
      17179: 4.1,
      17203: 95.9,
    },
    county_names_all: "Woodford|Tazewell",
    county_fips_all: "17203|17179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61531,
    lat: 40.68291,
    lng: -90.03482,
    city: "Farmington",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3110,
    density: 21.3,
    county_fips: 17057,
    county_name: "Fulton",
    county_weights: {
      17057: 62.59,
      17095: 23.75,
      17143: 13.66,
    },
    county_names_all: "Fulton|Knox|Peoria",
    county_fips_all: "17057|17095|17143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61532,
    lat: 40.34851,
    lng: -89.80692,
    city: "Forest City",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 647,
    density: 8.1,
    county_fips: 17125,
    county_name: "Mason",
    county_weights: {
      17125: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 17125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61533,
    lat: 40.58736,
    lng: -89.84029,
    city: "Glasford",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2315,
    density: 22,
    county_fips: 17143,
    county_name: "Peoria",
    county_weights: {
      17057: 16.79,
      17143: 83.1,
      17179: 0.11,
    },
    county_names_all: "Peoria|Fulton|Tazewell",
    county_fips_all: "17143|17057|17179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61534,
    lat: 40.41499,
    lng: -89.66464,
    city: "Green Valley",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1881,
    density: 13,
    county_fips: 17179,
    county_name: "Tazewell",
    county_weights: {
      17179: 100,
    },
    county_names_all: "Tazewell",
    county_fips_all: 17179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61535,
    lat: 40.58578,
    lng: -89.52316,
    city: "Groveland",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2117,
    density: 110,
    county_fips: 17179,
    county_name: "Tazewell",
    county_weights: {
      17179: 100,
    },
    county_names_all: "Tazewell",
    county_fips_all: 17179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61536,
    lat: 40.69051,
    lng: -89.78688,
    city: "Hanna City",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2907,
    density: 27.5,
    county_fips: 17143,
    county_name: "Peoria",
    county_weights: {
      17143: 100,
    },
    county_names_all: "Peoria",
    county_fips_all: 17143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61537,
    lat: 41.11607,
    lng: -89.47035,
    city: "Henry",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2725,
    density: 18.4,
    county_fips: 17123,
    county_name: "Marshall",
    county_weights: {
      17011: 5.18,
      17123: 94.82,
    },
    county_names_all: "Marshall|Bureau",
    county_fips_all: "17123|17011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61539,
    lat: 40.55375,
    lng: -89.77561,
    city: "Kingston Mines",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 156,
    density: 54.1,
    county_fips: 17143,
    county_name: "Peoria",
    county_weights: {
      17143: 99.2,
      17179: 0.8,
    },
    county_names_all: "Peoria|Tazewell",
    county_fips_all: "17143|17179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61540,
    lat: 41.01856,
    lng: -89.36867,
    city: "Lacon",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2676,
    density: 19.6,
    county_fips: 17123,
    county_name: "Marshall",
    county_weights: {
      17123: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 17123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61541,
    lat: 40.98039,
    lng: -89.23497,
    city: "La Rose",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 107,
    density: 251.7,
    county_fips: 17123,
    county_name: "Marshall",
    county_weights: {
      17123: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 17123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61542,
    lat: 40.38487,
    lng: -90.13402,
    city: "Lewistown",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3439,
    density: 11.7,
    county_fips: 17057,
    county_name: "Fulton",
    county_weights: {
      17057: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 17057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61543,
    lat: 40.42213,
    lng: -89.96842,
    city: "Liverpool",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 137,
    density: 7.1,
    county_fips: 17057,
    county_name: "Fulton",
    county_weights: {
      17057: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 17057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61544,
    lat: 40.69753,
    lng: -90.24273,
    city: "London Mills",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 749,
    density: 7.3,
    county_fips: 17057,
    county_name: "Fulton",
    county_weights: {
      17057: 70.28,
      17095: 29.72,
    },
    county_names_all: "Fulton|Knox",
    county_fips_all: "17057|17095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61545,
    lat: 40.86837,
    lng: -89.35253,
    city: "Lowpoint",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 748,
    density: 10.7,
    county_fips: 17203,
    county_name: "Woodford",
    county_weights: {
      17203: 100,
    },
    county_names_all: "Woodford",
    county_fips_all: 17203,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61546,
    lat: 40.45212,
    lng: -89.80172,
    city: "Manito",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3589,
    density: 14.6,
    county_fips: 17179,
    county_name: "Tazewell",
    county_weights: {
      17125: 37.92,
      17179: 62.08,
    },
    county_names_all: "Tazewell|Mason",
    county_fips_all: "17179|17125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61547,
    lat: 40.60962,
    lng: -89.73847,
    city: "Mapleton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4035,
    density: 70.9,
    county_fips: 17143,
    county_name: "Peoria",
    county_weights: {
      17143: 99.8,
      17179: 0.2,
    },
    county_names_all: "Peoria|Tazewell",
    county_fips_all: "17143|17179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61548,
    lat: 40.80887,
    lng: -89.41311,
    city: "Metamora",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11966,
    density: 61,
    county_fips: 17203,
    county_name: "Woodford",
    county_weights: {
      17203: 100,
    },
    county_names_all: "Woodford",
    county_fips_all: 17203,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61550,
    lat: 40.61054,
    lng: -89.44049,
    city: "Morton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17565,
    density: 164.5,
    county_fips: 17179,
    county_name: "Tazewell",
    county_weights: {
      17179: 100,
    },
    county_names_all: "Tazewell",
    county_fips_all: 17179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61552,
    lat: 40.82133,
    lng: -89.56496,
    city: "Mossville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 249,
    density: 86.6,
    county_fips: 17143,
    county_name: "Peoria",
    county_weights: {
      17143: 100,
    },
    county_names_all: "Peoria",
    county_fips_all: 17143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61553,
    lat: 40.62136,
    lng: -90.02686,
    city: "Norris",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 255,
    density: 94,
    county_fips: 17057,
    county_name: "Fulton",
    county_weights: {
      17057: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 17057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61554,
    lat: 40.54441,
    lng: -89.62181,
    city: "Pekin",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41786,
    density: 218.6,
    county_fips: 17179,
    county_name: "Tazewell",
    county_weights: {
      17179: 100,
    },
    county_names_all: "Tazewell",
    county_fips_all: 17179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61559,
    lat: 40.92101,
    lng: -89.77438,
    city: "Princeville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3493,
    density: 13.9,
    county_fips: 17143,
    county_name: "Peoria",
    county_weights: {
      17143: 90.83,
      17175: 9.17,
    },
    county_names_all: "Peoria|Stark",
    county_fips_all: "17143|17175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61560,
    lat: 41.18581,
    lng: -89.40077,
    city: "Putnam",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 637,
    density: 7.1,
    county_fips: 17155,
    county_name: "Putnam",
    county_weights: {
      17011: 3.09,
      17123: 4.07,
      17155: 92.84,
    },
    county_names_all: "Putnam|Marshall|Bureau",
    county_fips_all: "17155|17123|17011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61561,
    lat: 40.80582,
    lng: -89.20475,
    city: "Roanoke",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2307,
    density: 15.8,
    county_fips: 17203,
    county_name: "Woodford",
    county_weights: {
      17203: 100,
    },
    county_names_all: "Woodford",
    county_fips_all: 17203,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61562,
    lat: 40.88102,
    lng: -89.50144,
    city: "Rome",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58,
    density: 506,
    county_fips: 17143,
    county_name: "Peoria",
    county_weights: {
      17143: 100,
    },
    county_names_all: "Peoria",
    county_fips_all: 17143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61563,
    lat: 40.4931,
    lng: -90.05108,
    city: "Saint David",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 467,
    density: 472.4,
    county_fips: 17057,
    county_name: "Fulton",
    county_weights: {
      17057: 100,
    },
    county_names_all: "Fulton",
    county_fips_all: 17057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61564,
    lat: 40.49848,
    lng: -89.65624,
    city: "South Pekin",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 982,
    density: 388.2,
    county_fips: 17179,
    county_name: "Tazewell",
    county_weights: {
      17179: 100,
    },
    county_names_all: "Tazewell",
    county_fips_all: 17179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61565,
    lat: 41.032,
    lng: -89.50718,
    city: "Sparland",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1418,
    density: 8.4,
    county_fips: 17123,
    county_name: "Marshall",
    county_weights: {
      17123: 98.98,
      17143: 1.02,
    },
    county_names_all: "Marshall|Peoria",
    county_fips_all: "17123|17143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61567,
    lat: 40.35077,
    lng: -89.89899,
    city: "Topeka",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 396,
    density: 3,
    county_fips: 17125,
    county_name: "Mason",
    county_weights: {
      17125: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 17125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61568,
    lat: 40.50484,
    lng: -89.47876,
    city: "Tremont",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4405,
    density: 25.1,
    county_fips: 17179,
    county_name: "Tazewell",
    county_weights: {
      17179: 100,
    },
    county_names_all: "Tazewell",
    county_fips_all: 17179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61569,
    lat: 40.67788,
    lng: -89.89324,
    city: "Trivoli",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 993,
    density: 10.6,
    county_fips: 17143,
    county_name: "Peoria",
    county_weights: {
      17057: 1.66,
      17143: 98.34,
    },
    county_names_all: "Peoria|Fulton",
    county_fips_all: "17143|17057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61570,
    lat: 40.91933,
    lng: -89.31578,
    city: "Washburn",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1767,
    density: 9.9,
    county_fips: 17203,
    county_name: "Woodford",
    county_weights: {
      17123: 41.54,
      17143: 0.19,
      17203: 58.27,
    },
    county_names_all: "Woodford|Marshall|Peoria",
    county_fips_all: "17203|17123|17143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61571,
    lat: 40.70506,
    lng: -89.42294,
    city: "Washington",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24840,
    density: 179.4,
    county_fips: 17179,
    county_name: "Tazewell",
    county_weights: {
      17179: 100,
    },
    county_names_all: "Tazewell",
    county_fips_all: 17179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61572,
    lat: 40.79768,
    lng: -90.0343,
    city: "Yates City",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1217,
    density: 12.2,
    county_fips: 17095,
    county_name: "Knox",
    county_weights: {
      17095: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 17095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61602,
    lat: 40.68005,
    lng: -89.60395,
    city: "Peoria",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 726,
    density: 251.5,
    county_fips: 17143,
    county_name: "Peoria",
    county_weights: {
      17143: 99.76,
      17179: 0.24,
    },
    county_names_all: "Peoria|Tazewell",
    county_fips_all: "17143|17179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61603,
    lat: 40.7122,
    lng: -89.57465,
    city: "Peoria",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16083,
    density: 1469.8,
    county_fips: 17143,
    county_name: "Peoria",
    county_weights: {
      17143: 99.47,
      17179: 0.53,
    },
    county_names_all: "Peoria|Tazewell",
    county_fips_all: "17143|17179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61604,
    lat: 40.70525,
    lng: -89.65297,
    city: "Peoria",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29362,
    density: 746.2,
    county_fips: 17143,
    county_name: "Peoria",
    county_weights: {
      17143: 100,
    },
    county_names_all: "Peoria",
    county_fips_all: 17143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61605,
    lat: 40.6765,
    lng: -89.63317,
    city: "Peoria",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14556,
    density: 1283.6,
    county_fips: 17143,
    county_name: "Peoria",
    county_weights: {
      17143: 100,
    },
    county_names_all: "Peoria",
    county_fips_all: 17143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61606,
    lat: 40.70011,
    lng: -89.61187,
    city: "Peoria",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8317,
    density: 2622.9,
    county_fips: 17143,
    county_name: "Peoria",
    county_weights: {
      17143: 100,
    },
    county_names_all: "Peoria",
    county_fips_all: 17143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61607,
    lat: 40.62895,
    lng: -89.68627,
    city: "Peoria",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10846,
    density: 124.5,
    county_fips: 17143,
    county_name: "Peoria",
    county_weights: {
      17143: 99.66,
      17179: 0.34,
    },
    county_names_all: "Peoria|Tazewell",
    county_fips_all: "17143|17179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61610,
    lat: 40.64294,
    lng: -89.59882,
    city: "Creve Coeur",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5074,
    density: 473.2,
    county_fips: 17179,
    county_name: "Tazewell",
    county_weights: {
      17179: 100,
    },
    county_names_all: "Tazewell",
    county_fips_all: 17179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61611,
    lat: 40.71185,
    lng: -89.53469,
    city: "East Peoria",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24235,
    density: 228.4,
    county_fips: 17179,
    county_name: "Tazewell",
    county_weights: {
      17143: 0.8,
      17179: 64.3,
      17203: 34.9,
    },
    county_names_all: "Tazewell|Woodford|Peoria",
    county_fips_all: "17179|17203|17143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61614,
    lat: 40.75872,
    lng: -89.60486,
    city: "Peoria",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28815,
    density: 925,
    county_fips: 17143,
    county_name: "Peoria",
    county_weights: {
      17143: 100,
    },
    county_names_all: "Peoria",
    county_fips_all: 17143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61615,
    lat: 40.78088,
    lng: -89.63102,
    city: "Peoria",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21878,
    density: 285.2,
    county_fips: 17143,
    county_name: "Peoria",
    county_weights: {
      17143: 98.59,
      17203: 1.41,
    },
    county_names_all: "Peoria|Woodford",
    county_fips_all: "17143|17203",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61616,
    lat: 40.74682,
    lng: -89.57195,
    city: "Peoria Heights",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5825,
    density: 884.9,
    county_fips: 17143,
    county_name: "Peoria",
    county_weights: {
      17143: 99.75,
      17203: 0.25,
    },
    county_names_all: "Peoria|Woodford",
    county_fips_all: "17143|17203",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61625,
    lat: 40.6978,
    lng: -89.61455,
    city: "Peoria",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 399,
    density: 2458.9,
    county_fips: 17143,
    county_name: "Peoria",
    county_weights: {
      17143: 100,
    },
    county_names_all: "Peoria",
    county_fips_all: 17143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61701,
    lat: 40.47697,
    lng: -88.99278,
    city: "Bloomington",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35411,
    density: 1239.9,
    county_fips: 17113,
    county_name: "McLean",
    county_weights: {
      17113: 100,
    },
    county_names_all: "McLean",
    county_fips_all: 17113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61704,
    lat: 40.46951,
    lng: -88.94281,
    city: "Bloomington",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36704,
    density: 744.1,
    county_fips: 17113,
    county_name: "McLean",
    county_weights: {
      17113: 100,
    },
    county_names_all: "McLean",
    county_fips_all: 17113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61705,
    lat: 40.46099,
    lng: -88.99981,
    city: "Bloomington",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12584,
    density: 55.9,
    county_fips: 17113,
    county_name: "McLean",
    county_weights: {
      17113: 100,
    },
    county_names_all: "McLean",
    county_fips_all: 17113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61720,
    lat: 40.55228,
    lng: -88.50498,
    city: "Anchor",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 264,
    density: 3.4,
    county_fips: 17113,
    county_name: "McLean",
    county_weights: {
      17053: 12.78,
      17113: 87.22,
    },
    county_names_all: "McLean|Ford",
    county_fips_all: "17113|17053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61721,
    lat: 40.35349,
    lng: -89.32238,
    city: "Armington",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 707,
    density: 8,
    county_fips: 17179,
    county_name: "Tazewell",
    county_weights: {
      17107: 14.33,
      17179: 85.67,
    },
    county_names_all: "Tazewell|Logan",
    county_fips_all: "17179|17107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61722,
    lat: 40.42018,
    lng: -88.63049,
    city: "Arrowsmith",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 609,
    density: 4.5,
    county_fips: 17113,
    county_name: "McLean",
    county_weights: {
      17113: 100,
    },
    county_names_all: "McLean",
    county_fips_all: 17113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61723,
    lat: 40.26139,
    lng: -89.26703,
    city: "Atlanta",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2688,
    density: 16.4,
    county_fips: 17107,
    county_name: "Logan",
    county_weights: {
      17107: 91.84,
      17113: 8.16,
    },
    county_names_all: "Logan|McLean",
    county_fips_all: "17107|17113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61724,
    lat: 40.33418,
    lng: -88.52654,
    city: "Bellflower",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 518,
    density: 6.1,
    county_fips: 17113,
    county_name: "McLean",
    county_weights: {
      17113: 100,
    },
    county_names_all: "McLean",
    county_fips_all: 17113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61725,
    lat: 40.61201,
    lng: -89.11717,
    city: "Carlock",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2018,
    density: 17.3,
    county_fips: 17203,
    county_name: "Woodford",
    county_weights: {
      17113: 47.34,
      17203: 52.66,
    },
    county_names_all: "Woodford|McLean",
    county_fips_all: "17203|17113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61726,
    lat: 40.74013,
    lng: -88.70014,
    city: "Chenoa",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2442,
    density: 10,
    county_fips: 17113,
    county_name: "McLean",
    county_weights: {
      17105: 35.49,
      17113: 64.51,
    },
    county_names_all: "McLean|Livingston",
    county_fips_all: "17113|17105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61727,
    lat: 40.14701,
    lng: -88.95245,
    city: "Clinton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9425,
    density: 28.6,
    county_fips: 17039,
    county_name: "De Witt",
    county_weights: {
      17039: 100,
    },
    county_names_all: "De Witt",
    county_fips_all: 17039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61728,
    lat: 40.57546,
    lng: -88.62539,
    city: "Colfax",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1252,
    density: 7,
    county_fips: 17113,
    county_name: "McLean",
    county_weights: {
      17113: 100,
    },
    county_names_all: "McLean",
    county_fips_all: 17113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61729,
    lat: 40.62799,
    lng: -89.22393,
    city: "Congerville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1376,
    density: 28.7,
    county_fips: 17203,
    county_name: "Woodford",
    county_weights: {
      17113: 6.06,
      17203: 93.94,
    },
    county_names_all: "Woodford|McLean",
    county_fips_all: "17203|17113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61730,
    lat: 40.53262,
    lng: -88.73437,
    city: "Cooksville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 515,
    density: 6.9,
    county_fips: 17113,
    county_name: "McLean",
    county_weights: {
      17113: 100,
    },
    county_names_all: "McLean",
    county_fips_all: 17113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61731,
    lat: 40.61255,
    lng: -88.48386,
    city: "Cropsey",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 149,
    density: 2.5,
    county_fips: 17113,
    county_name: "McLean",
    county_weights: {
      17053: 12.32,
      17105: 41.32,
      17113: 46.36,
    },
    county_names_all: "McLean|Livingston|Ford",
    county_fips_all: "17113|17105|17053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61732,
    lat: 40.53123,
    lng: -89.20646,
    city: "Danvers",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2116,
    density: 13.1,
    county_fips: 17113,
    county_name: "McLean",
    county_weights: {
      17113: 91.2,
      17179: 8.8,
    },
    county_names_all: "McLean|Tazewell",
    county_fips_all: "17113|17179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61733,
    lat: 40.62421,
    lng: -89.33573,
    city: "Deer Creek",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 911,
    density: 15.7,
    county_fips: 17179,
    county_name: "Tazewell",
    county_weights: {
      17179: 83.92,
      17203: 16.08,
    },
    county_names_all: "Tazewell|Woodford",
    county_fips_all: "17179|17203",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61734,
    lat: 40.37431,
    lng: -89.52549,
    city: "Delavan",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2760,
    density: 13.9,
    county_fips: 17179,
    county_name: "Tazewell",
    county_weights: {
      17179: 100,
    },
    county_names_all: "Tazewell",
    county_fips_all: 17179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61735,
    lat: 40.20561,
    lng: -88.81072,
    city: "Dewitt",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 434,
    density: 8,
    county_fips: 17039,
    county_name: "De Witt",
    county_weights: {
      17039: 100,
    },
    county_names_all: "De Witt",
    county_fips_all: 17039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61736,
    lat: 40.40335,
    lng: -88.83804,
    city: "Downs",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1968,
    density: 21.9,
    county_fips: 17113,
    county_name: "McLean",
    county_weights: {
      17113: 100,
    },
    county_names_all: "McLean",
    county_fips_all: 17113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61737,
    lat: 40.45646,
    lng: -88.73331,
    city: "Ellsworth",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 437,
    density: 4.9,
    county_fips: 17113,
    county_name: "McLean",
    county_weights: {
      17113: 100,
    },
    county_names_all: "McLean",
    county_fips_all: 17113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61738,
    lat: 40.74925,
    lng: -89.02821,
    city: "El Paso",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4484,
    density: 20.1,
    county_fips: 17203,
    county_name: "Woodford",
    county_weights: {
      17113: 6.01,
      17203: 93.99,
    },
    county_names_all: "Woodford|McLean",
    county_fips_all: "17203|17113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61739,
    lat: 40.73342,
    lng: -88.51938,
    city: "Fairbury",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4573,
    density: 16.6,
    county_fips: 17105,
    county_name: "Livingston",
    county_weights: {
      17105: 95.34,
      17113: 4.66,
    },
    county_names_all: "Livingston|McLean",
    county_fips_all: "17105|17113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61740,
    lat: 40.88779,
    lng: -88.86397,
    city: "Flanagan",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1412,
    density: 7.8,
    county_fips: 17105,
    county_name: "Livingston",
    county_weights: {
      17105: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 17105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61741,
    lat: 40.76045,
    lng: -88.40057,
    city: "Forrest",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1679,
    density: 12.3,
    county_fips: 17105,
    county_name: "Livingston",
    county_weights: {
      17105: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 17105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61742,
    lat: 40.63341,
    lng: -89.27322,
    city: "Goodfield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1221,
    density: 76.5,
    county_fips: 17203,
    county_name: "Woodford",
    county_weights: {
      17179: 4.52,
      17203: 95.48,
    },
    county_names_all: "Woodford|Tazewell",
    county_fips_all: "17203|17179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61743,
    lat: 40.87805,
    lng: -88.78142,
    city: "Graymont",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 157,
    density: 3.9,
    county_fips: 17105,
    county_name: "Livingston",
    county_weights: {
      17105: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 17105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61744,
    lat: 40.74377,
    lng: -88.88118,
    city: "Gridley",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1811,
    density: 9,
    county_fips: 17113,
    county_name: "McLean",
    county_weights: {
      17105: 37.9,
      17113: 59.5,
      17203: 2.6,
    },
    county_names_all: "McLean|Livingston|Woodford",
    county_fips_all: "17113|17105|17203",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61745,
    lat: 40.32152,
    lng: -88.96684,
    city: "Heyworth",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4571,
    density: 23.7,
    county_fips: 17113,
    county_name: "McLean",
    county_weights: {
      17039: 17.64,
      17113: 82.36,
    },
    county_names_all: "McLean|De Witt",
    county_fips_all: "17113|17039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61747,
    lat: 40.4174,
    lng: -89.43295,
    city: "Hopedale",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1418,
    density: 19,
    county_fips: 17179,
    county_name: "Tazewell",
    county_weights: {
      17179: 100,
    },
    county_names_all: "Tazewell",
    county_fips_all: 17179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61748,
    lat: 40.61483,
    lng: -88.98898,
    city: "Hudson",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2657,
    density: 23.6,
    county_fips: 17113,
    county_name: "McLean",
    county_weights: {
      17113: 96.08,
      17203: 3.92,
    },
    county_names_all: "McLean|Woodford",
    county_fips_all: "17113|17203",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61749,
    lat: 40.09209,
    lng: -89.10943,
    city: "Kenney",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 552,
    density: 6,
    county_fips: 17039,
    county_name: "De Witt",
    county_weights: {
      17039: 79.86,
      17107: 9.34,
      17115: 10.8,
    },
    county_names_all: "De Witt|Macon|Logan",
    county_fips_all: "17039|17115|17107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61750,
    lat: 40.12251,
    lng: -88.8557,
    city: "Lane",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 187,
    density: 730.8,
    county_fips: 17039,
    county_name: "De Witt",
    county_weights: {
      17039: 100,
    },
    county_names_all: "De Witt",
    county_fips_all: 17039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61751,
    lat: 40.21455,
    lng: -89.29926,
    city: "Lawndale",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 76,
    density: 17.7,
    county_fips: 17107,
    county_name: "Logan",
    county_weights: {
      17107: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 17107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61752,
    lat: 40.33703,
    lng: -88.76168,
    city: "Le Roy",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4388,
    density: 19.6,
    county_fips: 17113,
    county_name: "McLean",
    county_weights: {
      17039: 5.16,
      17113: 94.84,
    },
    county_names_all: "McLean|De Witt",
    county_fips_all: "17113|17039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61753,
    lat: 40.63568,
    lng: -88.78883,
    city: "Lexington",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3094,
    density: 14.5,
    county_fips: 17113,
    county_name: "McLean",
    county_weights: {
      17113: 100,
    },
    county_names_all: "McLean",
    county_fips_all: 17113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61754,
    lat: 40.3287,
    lng: -89.15744,
    city: "McLean",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1157,
    density: 5.7,
    county_fips: 17113,
    county_name: "McLean",
    county_weights: {
      17039: 7.82,
      17107: 4.86,
      17113: 87.32,
    },
    county_names_all: "McLean|De Witt|Logan",
    county_fips_all: "17113|17039|17107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61755,
    lat: 40.52661,
    lng: -89.33909,
    city: "Mackinaw",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4695,
    density: 38.8,
    county_fips: 17179,
    county_name: "Tazewell",
    county_weights: {
      17179: 100,
    },
    county_names_all: "Tazewell",
    county_fips_all: 17179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61756,
    lat: 40.03311,
    lng: -88.96368,
    city: "Maroa",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2575,
    density: 11.8,
    county_fips: 17115,
    county_name: "Macon",
    county_weights: {
      17039: 29.75,
      17115: 70.25,
    },
    county_names_all: "Macon|De Witt",
    county_fips_all: "17115|17039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61759,
    lat: 40.4347,
    lng: -89.32418,
    city: "Minier",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1463,
    density: 16.4,
    county_fips: 17179,
    county_name: "Tazewell",
    county_weights: {
      17179: 100,
    },
    county_names_all: "Tazewell",
    county_fips_all: 17179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61760,
    lat: 40.88713,
    lng: -89.03263,
    city: "Minonk",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2296,
    density: 12.7,
    county_fips: 17203,
    county_name: "Woodford",
    county_weights: {
      17123: 7.8,
      17203: 92.2,
    },
    county_names_all: "Woodford|Marshall",
    county_fips_all: "17203|17123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61761,
    lat: 40.52503,
    lng: -88.95152,
    city: "Normal",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55198,
    density: 500.7,
    county_fips: 17113,
    county_name: "McLean",
    county_weights: {
      17113: 100,
    },
    county_names_all: "McLean",
    county_fips_all: 17113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61764,
    lat: 40.88343,
    lng: -88.6263,
    city: "Pontiac",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14015,
    density: 35,
    county_fips: 17105,
    county_name: "Livingston",
    county_weights: {
      17105: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 17105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61769,
    lat: 40.88106,
    lng: -88.39804,
    city: "Saunemin",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 676,
    density: 7.2,
    county_fips: 17105,
    county_name: "Livingston",
    county_weights: {
      17105: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 17105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61770,
    lat: 40.43965,
    lng: -88.52457,
    city: "Saybrook",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1139,
    density: 7.3,
    county_fips: 17113,
    county_name: "McLean",
    county_weights: {
      17113: 100,
    },
    county_names_all: "McLean",
    county_fips_all: 17113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61771,
    lat: 40.70725,
    lng: -89.14184,
    city: "Secor",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 627,
    density: 9.3,
    county_fips: 17203,
    county_name: "Woodford",
    county_weights: {
      17203: 100,
    },
    county_names_all: "Woodford",
    county_fips_all: 17203,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61772,
    lat: 40.386,
    lng: -89.06351,
    city: "Shirley",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 258,
    density: 4.1,
    county_fips: 17113,
    county_name: "McLean",
    county_weights: {
      17113: 100,
    },
    county_names_all: "McLean",
    county_fips_all: 17113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61773,
    lat: 40.57209,
    lng: -88.37605,
    city: "Sibley",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 320,
    density: 2.9,
    county_fips: 17053,
    county_name: "Ford",
    county_weights: {
      17053: 100,
    },
    county_names_all: "Ford",
    county_fips_all: 17053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61774,
    lat: 40.42945,
    lng: -89.20145,
    city: "Stanford",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1019,
    density: 9.2,
    county_fips: 17113,
    county_name: "McLean",
    county_weights: {
      17113: 100,
    },
    county_names_all: "McLean",
    county_fips_all: 17113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61775,
    lat: 40.64971,
    lng: -88.37069,
    city: "Strawn",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 286,
    density: 3.4,
    county_fips: 17105,
    county_name: "Livingston",
    county_weights: {
      17105: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 17105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61776,
    lat: 40.5713,
    lng: -88.86706,
    city: "Towanda",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1135,
    density: 10.9,
    county_fips: 17113,
    county_name: "McLean",
    county_weights: {
      17113: 100,
    },
    county_names_all: "McLean",
    county_fips_all: 17113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61777,
    lat: 40.243,
    lng: -88.93948,
    city: "Wapella",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1144,
    density: 12.2,
    county_fips: 17039,
    county_name: "De Witt",
    county_weights: {
      17039: 100,
    },
    county_names_all: "De Witt",
    county_fips_all: 17039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61778,
    lat: 40.22575,
    lng: -89.09104,
    city: "Waynesville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 653,
    density: 8.4,
    county_fips: 17039,
    county_name: "De Witt",
    county_weights: {
      17039: 100,
    },
    county_names_all: "De Witt",
    county_fips_all: 17039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61801,
    lat: 40.10937,
    lng: -88.21175,
    city: "Urbana",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30855,
    density: 2205.9,
    county_fips: 17019,
    county_name: "Champaign",
    county_weights: {
      17019: 100,
    },
    county_names_all: "Champaign",
    county_fips_all: 17019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61802,
    lat: 40.12288,
    lng: -88.14863,
    city: "Urbana",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20100,
    density: 94.6,
    county_fips: 17019,
    county_name: "Champaign",
    county_weights: {
      17019: 100,
    },
    county_names_all: "Champaign",
    county_fips_all: 17019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61810,
    lat: 39.91019,
    lng: -87.91837,
    city: "Allerton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 282,
    density: 4.6,
    county_fips: 17183,
    county_name: "Vermilion",
    county_weights: {
      17019: 19.98,
      17045: 21.94,
      17183: 58.08,
    },
    county_names_all: "Vermilion|Edgar|Champaign",
    county_fips_all: "17183|17045|17019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61811,
    lat: 40.29531,
    lng: -87.62162,
    city: "Alvin",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 740,
    density: 10.8,
    county_fips: 17183,
    county_name: "Vermilion",
    county_weights: {
      17183: 100,
    },
    county_names_all: "Vermilion",
    county_fips_all: 17183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61812,
    lat: 40.25869,
    lng: -87.88989,
    city: "Armstrong",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 347,
    density: 6.1,
    county_fips: 17183,
    county_name: "Vermilion",
    county_weights: {
      17183: 100,
    },
    county_names_all: "Vermilion",
    county_fips_all: 17183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61813,
    lat: 39.90933,
    lng: -88.55796,
    city: "Bement",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1618,
    density: 9.8,
    county_fips: 17147,
    county_name: "Piatt",
    county_weights: {
      17147: 100,
    },
    county_names_all: "Piatt",
    county_fips_all: 17147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61814,
    lat: 40.23191,
    lng: -87.57018,
    city: "Bismarck",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1097,
    density: 18,
    county_fips: 17183,
    county_name: "Vermilion",
    county_weights: {
      17183: 100,
    },
    county_names_all: "Vermilion",
    county_fips_all: 17183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61815,
    lat: 40.11075,
    lng: -88.3679,
    city: "Bondville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 240,
    density: 401.9,
    county_fips: 17019,
    county_name: "Champaign",
    county_weights: {
      17019: 100,
    },
    county_names_all: "Champaign",
    county_fips_all: 17019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61816,
    lat: 39.92444,
    lng: -88.00398,
    city: "Broadlands",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 461,
    density: 6.6,
    county_fips: 17019,
    county_name: "Champaign",
    county_weights: {
      17019: 100,
    },
    county_names_all: "Champaign",
    county_fips_all: 17019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61817,
    lat: 40.03088,
    lng: -87.71991,
    city: "Catlin",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2436,
    density: 31.6,
    county_fips: 17183,
    county_name: "Vermilion",
    county_weights: {
      17183: 100,
    },
    county_names_all: "Vermilion",
    county_fips_all: 17183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61818,
    lat: 39.88455,
    lng: -88.71798,
    city: "Cerro Gordo",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1614,
    density: 16,
    county_fips: 17147,
    county_name: "Piatt",
    county_weights: {
      17115: 14.43,
      17147: 85.57,
    },
    county_names_all: "Piatt|Macon",
    county_fips_all: "17147|17115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61820,
    lat: 40.112,
    lng: -88.24423,
    city: "Champaign",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38017,
    density: 2474.2,
    county_fips: 17019,
    county_name: "Champaign",
    county_weights: {
      17019: 100,
    },
    county_names_all: "Champaign",
    county_fips_all: 17019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61821,
    lat: 40.11041,
    lng: -88.27611,
    city: "Champaign",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30937,
    density: 1552.7,
    county_fips: 17019,
    county_name: "Champaign",
    county_weights: {
      17019: 100,
    },
    county_names_all: "Champaign",
    county_fips_all: 17019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61822,
    lat: 40.13693,
    lng: -88.30453,
    city: "Champaign",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26629,
    density: 95.9,
    county_fips: 17019,
    county_name: "Champaign",
    county_weights: {
      17019: 100,
    },
    county_names_all: "Champaign",
    county_fips_all: 17019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61830,
    lat: 40.01122,
    lng: -88.72926,
    city: "Cisco",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 414,
    density: 4.8,
    county_fips: 17147,
    county_name: "Piatt",
    county_weights: {
      17115: 27.96,
      17147: 72.04,
    },
    county_names_all: "Piatt|Macon",
    county_fips_all: "17147|17115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61831,
    lat: 40.22623,
    lng: -87.79705,
    city: "Collison",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 146,
    density: 4.7,
    county_fips: 17183,
    county_name: "Vermilion",
    county_weights: {
      17183: 100,
    },
    county_names_all: "Vermilion",
    county_fips_all: 17183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61832,
    lat: 40.13186,
    lng: -87.63256,
    city: "Danville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34077,
    density: 481.5,
    county_fips: 17183,
    county_name: "Vermilion",
    county_weights: {
      17183: 100,
    },
    county_names_all: "Vermilion",
    county_fips_all: 17183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61833,
    lat: 40.09914,
    lng: -87.64718,
    city: "Tilton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2191,
    density: 579.6,
    county_fips: 17183,
    county_name: "Vermilion",
    county_weights: {
      17183: 100,
    },
    county_names_all: "Vermilion",
    county_fips_all: 17183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61834,
    lat: 40.16428,
    lng: -87.64028,
    city: "Danville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8516,
    density: 30.7,
    county_fips: 17183,
    county_name: "Vermilion",
    county_weights: {
      17183: 100,
    },
    county_names_all: "Vermilion",
    county_fips_all: 17183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61839,
    lat: 40.13184,
    lng: -88.63694,
    city: "De Land",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 662,
    density: 7.9,
    county_fips: 17147,
    county_name: "Piatt",
    county_weights: {
      17147: 100,
    },
    county_names_all: "Piatt",
    county_fips_all: 17147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61840,
    lat: 40.29663,
    lng: -88.30187,
    city: "Dewey",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 614,
    density: 7.6,
    county_fips: 17019,
    county_name: "Champaign",
    county_weights: {
      17019: 100,
    },
    county_names_all: "Champaign",
    county_fips_all: 17019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61841,
    lat: 40.02775,
    lng: -87.82459,
    city: "Fairmount",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1207,
    density: 8.1,
    county_fips: 17183,
    county_name: "Vermilion",
    county_weights: {
      17183: 100,
    },
    county_names_all: "Vermilion",
    county_fips_all: 17183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61842,
    lat: 40.23889,
    lng: -88.66411,
    city: "Farmer City",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2556,
    density: 8.9,
    county_fips: 17039,
    county_name: "De Witt",
    county_weights: {
      17039: 63.69,
      17113: 17.78,
      17147: 18.53,
    },
    county_names_all: "De Witt|Piatt|McLean",
    county_fips_all: "17039|17147|17113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61843,
    lat: 40.31593,
    lng: -88.38053,
    city: "Fisher",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2307,
    density: 24.2,
    county_fips: 17019,
    county_name: "Champaign",
    county_weights: {
      17019: 94.46,
      17113: 5.54,
    },
    county_names_all: "Champaign|McLean",
    county_fips_all: "17019|17113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61844,
    lat: 40.14431,
    lng: -87.8711,
    city: "Fithian",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 827,
    density: 5.3,
    county_fips: 17183,
    county_name: "Vermilion",
    county_weights: {
      17183: 100,
    },
    county_names_all: "Vermilion",
    county_fips_all: 17183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61845,
    lat: 40.37308,
    lng: -88.40076,
    city: "Foosland",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 365,
    density: 4.6,
    county_fips: 17019,
    county_name: "Champaign",
    county_weights: {
      17019: 90.04,
      17053: 9.96,
    },
    county_names_all: "Champaign|Ford",
    county_fips_all: "17019|17053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61846,
    lat: 39.97601,
    lng: -87.61222,
    city: "Georgetown",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4979,
    density: 44.7,
    county_fips: 17183,
    county_name: "Vermilion",
    county_weights: {
      17183: 100,
    },
    county_names_all: "Vermilion",
    county_fips_all: 17183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61847,
    lat: 40.31148,
    lng: -88.01581,
    city: "Gifford",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1304,
    density: 15,
    county_fips: 17019,
    county_name: "Champaign",
    county_weights: {
      17019: 100,
    },
    county_names_all: "Champaign",
    county_fips_all: 17019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61848,
    lat: 40.30694,
    lng: -87.70096,
    city: "Henning",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 186,
    density: 70.7,
    county_fips: 17183,
    county_name: "Vermilion",
    county_weights: {
      17183: 100,
    },
    county_names_all: "Vermilion",
    county_fips_all: 17183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61849,
    lat: 40.01145,
    lng: -87.96185,
    city: "Homer",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2059,
    density: 13.6,
    county_fips: 17019,
    county_name: "Champaign",
    county_weights: {
      17019: 66.32,
      17183: 33.68,
    },
    county_names_all: "Champaign|Vermilion",
    county_fips_all: "17019|17183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61850,
    lat: 39.9301,
    lng: -87.74346,
    city: "Indianola",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 405,
    density: 4.7,
    county_fips: 17183,
    county_name: "Vermilion",
    county_weights: {
      17183: 100,
    },
    county_names_all: "Vermilion",
    county_fips_all: 17183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61851,
    lat: 39.96507,
    lng: -88.43544,
    city: "Ivesdale",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 310,
    density: 3.5,
    county_fips: 17019,
    county_name: "Champaign",
    county_weights: {
      17019: 89.3,
      17147: 10.7,
    },
    county_names_all: "Champaign|Piatt",
    county_fips_all: "17019|17147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61852,
    lat: 39.89951,
    lng: -88.07277,
    city: "Longview",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 240,
    density: 5.1,
    county_fips: 17019,
    county_name: "Champaign",
    county_weights: {
      17019: 78.92,
      17041: 21.08,
    },
    county_names_all: "Champaign|Douglas",
    county_fips_all: "17019|17041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61853,
    lat: 40.22344,
    lng: -88.41555,
    city: "Mahomet",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13963,
    density: 112.4,
    county_fips: 17019,
    county_name: "Champaign",
    county_weights: {
      17019: 92.04,
      17147: 7.96,
    },
    county_names_all: "Champaign|Piatt",
    county_fips_all: "17019|17147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61854,
    lat: 40.20654,
    lng: -88.52129,
    city: "Mansfield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1274,
    density: 8.7,
    county_fips: 17147,
    county_name: "Piatt",
    county_weights: {
      17113: 5.35,
      17147: 94.65,
    },
    county_names_all: "Piatt|McLean",
    county_fips_all: "17147|17113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61855,
    lat: 39.92438,
    lng: -88.66056,
    city: "Milmine",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 103,
    density: 3.4,
    county_fips: 17147,
    county_name: "Piatt",
    county_weights: {
      17147: 100,
    },
    county_names_all: "Piatt",
    county_fips_all: 17147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61856,
    lat: 40.02838,
    lng: -88.58211,
    city: "Monticello",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7935,
    density: 28.4,
    county_fips: 17147,
    county_name: "Piatt",
    county_weights: {
      17147: 100,
    },
    county_names_all: "Piatt",
    county_fips_all: 17147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61857,
    lat: 40.11862,
    lng: -87.84337,
    city: "Muncie",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 136,
    density: 93,
    county_fips: 17183,
    county_name: "Vermilion",
    county_weights: {
      17183: 100,
    },
    county_names_all: "Vermilion",
    county_fips_all: 17183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61858,
    lat: 40.13166,
    lng: -87.76438,
    city: "Oakwood",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2885,
    density: 38.6,
    county_fips: 17183,
    county_name: "Vermilion",
    county_weights: {
      17183: 100,
    },
    county_names_all: "Vermilion",
    county_fips_all: 17183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61859,
    lat: 40.15065,
    lng: -87.96163,
    city: "Ogden",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1276,
    density: 16.3,
    county_fips: 17019,
    county_name: "Champaign",
    county_weights: {
      17019: 85.39,
      17183: 14.61,
    },
    county_names_all: "Champaign|Vermilion",
    county_fips_all: "17019|17183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61862,
    lat: 40.30474,
    lng: -87.95103,
    city: "Penfield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 685,
    density: 6.6,
    county_fips: 17019,
    county_name: "Champaign",
    county_weights: {
      17019: 81.69,
      17183: 18.31,
    },
    county_names_all: "Champaign|Vermilion",
    county_fips_all: "17019|17183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61863,
    lat: 39.90575,
    lng: -88.28194,
    city: "Pesotum",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 764,
    density: 9,
    county_fips: 17019,
    county_name: "Champaign",
    county_weights: {
      17019: 100,
    },
    county_names_all: "Champaign",
    county_fips_all: 17019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61864,
    lat: 39.97989,
    lng: -88.14437,
    city: "Philo",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1769,
    density: 29.8,
    county_fips: 17019,
    county_name: "Champaign",
    county_weights: {
      17019: 100,
    },
    county_names_all: "Champaign",
    county_fips_all: 17019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61865,
    lat: 40.30362,
    lng: -87.80047,
    city: "Potomac",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1580,
    density: 7.7,
    county_fips: 17183,
    county_name: "Vermilion",
    county_weights: {
      17183: 100,
    },
    county_names_all: "Vermilion",
    county_fips_all: 17183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61866,
    lat: 40.31148,
    lng: -88.15837,
    city: "Rantoul",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13863,
    density: 66.9,
    county_fips: 17019,
    county_name: "Champaign",
    county_weights: {
      17019: 100,
    },
    county_names_all: "Champaign",
    county_fips_all: 17019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61870,
    lat: 39.90325,
    lng: -87.61562,
    city: "Ridge Farm",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1183,
    density: 11.2,
    county_fips: 17183,
    county_name: "Vermilion",
    county_weights: {
      17045: 14.34,
      17183: 85.66,
    },
    county_names_all: "Vermilion|Edgar",
    county_fips_all: "17183|17045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61871,
    lat: 40.19118,
    lng: -87.97925,
    city: "Royal",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 17019,
    county_name: "Champaign",
    county_weights: {
      17019: 100,
    },
    county_names_all: "Champaign",
    county_fips_all: 17019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61872,
    lat: 39.93586,
    lng: -88.38018,
    city: "Sadorus",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 581,
    density: 6.1,
    county_fips: 17019,
    county_name: "Champaign",
    county_weights: {
      17019: 90.25,
      17041: 9.75,
    },
    county_names_all: "Champaign|Douglas",
    county_fips_all: "17019|17041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61873,
    lat: 40.14069,
    lng: -88.03817,
    city: "Saint Joseph",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6129,
    density: 37.2,
    county_fips: 17019,
    county_name: "Champaign",
    county_weights: {
      17019: 100,
    },
    county_names_all: "Champaign",
    county_fips_all: 17019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61874,
    lat: 40.05062,
    lng: -88.26078,
    city: "Savoy",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8393,
    density: 530.7,
    county_fips: 17019,
    county_name: "Champaign",
    county_weights: {
      17019: 100,
    },
    county_names_all: "Champaign",
    county_fips_all: 17019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61875,
    lat: 40.10421,
    lng: -88.42267,
    city: "Seymour",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 706,
    density: 8.9,
    county_fips: 17019,
    county_name: "Champaign",
    county_weights: {
      17019: 98.73,
      17147: 1.27,
    },
    county_names_all: "Champaign|Piatt",
    county_fips_all: "17019|17147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61876,
    lat: 39.90534,
    lng: -87.8398,
    city: "Sidell",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 640,
    density: 5.9,
    county_fips: 17183,
    county_name: "Vermilion",
    county_weights: {
      17045: 24.64,
      17183: 75.36,
    },
    county_names_all: "Vermilion|Edgar",
    county_fips_all: "17183|17045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61877,
    lat: 39.99456,
    lng: -88.07764,
    city: "Sidney",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1551,
    density: 20.6,
    county_fips: 17019,
    county_name: "Champaign",
    county_weights: {
      17019: 100,
    },
    county_names_all: "Champaign",
    county_fips_all: 17019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61878,
    lat: 40.23953,
    lng: -88.14945,
    city: "Thomasboro",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1263,
    density: 17.4,
    county_fips: 17019,
    county_name: "Champaign",
    county_weights: {
      17019: 100,
    },
    county_names_all: "Champaign",
    county_fips_all: 17019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61880,
    lat: 39.97482,
    lng: -88.2458,
    city: "Tolono",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3823,
    density: 23.9,
    county_fips: 17019,
    county_name: "Champaign",
    county_weights: {
      17019: 100,
    },
    county_names_all: "Champaign",
    county_fips_all: 17019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61882,
    lat: 40.11203,
    lng: -88.75969,
    city: "Weldon",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 655,
    density: 6.6,
    county_fips: 17039,
    county_name: "De Witt",
    county_weights: {
      17039: 90.43,
      17115: 2.49,
      17147: 7.08,
    },
    county_names_all: "De Witt|Piatt|Macon",
    county_fips_all: "17039|17147|17115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61883,
    lat: 40.03494,
    lng: -87.63992,
    city: "Westville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4262,
    density: 80,
    county_fips: 17183,
    county_name: "Vermilion",
    county_weights: {
      17183: 100,
    },
    county_names_all: "Vermilion",
    county_fips_all: 17183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61884,
    lat: 40.09115,
    lng: -88.48266,
    city: "White Heath",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 984,
    density: 15.8,
    county_fips: 17147,
    county_name: "Piatt",
    county_weights: {
      17019: 20.59,
      17147: 79.41,
    },
    county_names_all: "Piatt|Champaign",
    county_fips_all: "17147|17019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61910,
    lat: 39.67283,
    lng: -88.30035,
    city: "Arcola",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4848,
    density: 18.3,
    county_fips: 17041,
    county_name: "Douglas",
    county_weights: {
      17029: 32.72,
      17041: 67.28,
    },
    county_names_all: "Douglas|Coles",
    county_fips_all: "17041|17029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61911,
    lat: 39.70452,
    lng: -88.47068,
    city: "Arthur",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5021,
    density: 30.5,
    county_fips: 17139,
    county_name: "Moultrie",
    county_weights: {
      17029: 11.67,
      17041: 41.27,
      17139: 47.06,
    },
    county_names_all: "Moultrie|Douglas|Coles",
    county_fips_all: "17139|17041|17029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61912,
    lat: 39.52825,
    lng: -88.03357,
    city: "Ashmore",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1425,
    density: 10.6,
    county_fips: 17029,
    county_name: "Coles",
    county_weights: {
      17029: 100,
    },
    county_names_all: "Coles",
    county_fips_all: 17029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61913,
    lat: 39.82657,
    lng: -88.47156,
    city: "Atwood",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1528,
    density: 14.4,
    county_fips: 17147,
    county_name: "Piatt",
    county_weights: {
      17041: 47.85,
      17139: 3.97,
      17147: 48.18,
    },
    county_names_all: "Piatt|Douglas|Moultrie",
    county_fips_all: "17147|17041|17139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61914,
    lat: 39.63409,
    lng: -88.76783,
    city: "Bethany",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1816,
    density: 11.6,
    county_fips: 17139,
    county_name: "Moultrie",
    county_weights: {
      17115: 3.31,
      17139: 75.98,
      17173: 20.71,
    },
    county_names_all: "Moultrie|Shelby|Macon",
    county_fips_all: "17139|17173|17115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61917,
    lat: 39.71746,
    lng: -87.8941,
    city: "Brocton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 531,
    density: 3,
    county_fips: 17045,
    county_name: "Edgar",
    county_weights: {
      17041: 6.41,
      17045: 93.59,
    },
    county_names_all: "Edgar|Douglas",
    county_fips_all: "17045|17041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61919,
    lat: 39.7789,
    lng: -88.13727,
    city: "Camargo",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 836,
    density: 14.9,
    county_fips: 17041,
    county_name: "Douglas",
    county_weights: {
      17041: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 17041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61920,
    lat: 39.50415,
    lng: -88.16448,
    city: "Charleston",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23642,
    density: 61.5,
    county_fips: 17029,
    county_name: "Coles",
    county_weights: {
      17029: 100,
    },
    county_names_all: "Coles",
    county_fips_all: 17029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61924,
    lat: 39.79269,
    lng: -87.6506,
    city: "Chrisman",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2394,
    density: 6.5,
    county_fips: 17045,
    county_name: "Edgar",
    county_weights: {
      17045: 100,
    },
    county_names_all: "Edgar",
    county_fips_all: 17045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61925,
    lat: 39.72444,
    lng: -88.83548,
    city: "Dalton City",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1179,
    density: 10.3,
    county_fips: 17115,
    county_name: "Macon",
    county_weights: {
      17115: 74.77,
      17139: 25.23,
    },
    county_names_all: "Macon|Moultrie",
    county_fips_all: "17115|17139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61928,
    lat: 39.45524,
    lng: -88.50284,
    city: "Gays",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 712,
    density: 8.9,
    county_fips: 17139,
    county_name: "Moultrie",
    county_weights: {
      17029: 5.98,
      17139: 62.06,
      17173: 31.96,
    },
    county_names_all: "Moultrie|Shelby|Coles",
    county_fips_all: "17139|17173|17029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61929,
    lat: 39.82338,
    lng: -88.62271,
    city: "Hammond",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 690,
    density: 6.8,
    county_fips: 17147,
    county_name: "Piatt",
    county_weights: {
      17139: 0.54,
      17147: 99.46,
    },
    county_names_all: "Piatt|Moultrie",
    county_fips_all: "17147|17139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61930,
    lat: 39.67935,
    lng: -88.12899,
    city: "Hindsboro",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 671,
    density: 7.4,
    county_fips: 17041,
    county_name: "Douglas",
    county_weights: {
      17029: 23.59,
      17041: 76.41,
    },
    county_names_all: "Douglas|Coles",
    county_fips_all: "17041|17029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61931,
    lat: 39.59067,
    lng: -88.35883,
    city: "Humboldt",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1356,
    density: 16.1,
    county_fips: 17029,
    county_name: "Coles",
    county_weights: {
      17029: 100,
    },
    county_names_all: "Coles",
    county_fips_all: 17029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61932,
    lat: 39.79968,
    lng: -87.87493,
    city: "Hume",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 562,
    density: 11.7,
    county_fips: 17045,
    county_name: "Edgar",
    county_weights: {
      17045: 100,
    },
    county_names_all: "Edgar",
    county_fips_all: 17045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61933,
    lat: 39.55099,
    lng: -87.91502,
    city: "Kansas",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1021,
    density: 6.7,
    county_fips: 17045,
    county_name: "Edgar",
    county_weights: {
      17023: 6.31,
      17029: 0.99,
      17045: 92.7,
    },
    county_names_all: "Edgar|Clark|Coles",
    county_fips_all: "17045|17023|17029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61936,
    lat: 39.80319,
    lng: -88.72684,
    city: "La Place",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 270,
    density: 34.3,
    county_fips: 17147,
    county_name: "Piatt",
    county_weights: {
      17147: 100,
    },
    county_names_all: "Piatt",
    county_fips_all: 17147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61937,
    lat: 39.73872,
    lng: -88.65542,
    city: "Lovington",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1796,
    density: 7.3,
    county_fips: 17139,
    county_name: "Moultrie",
    county_weights: {
      17115: 7.24,
      17139: 92.76,
    },
    county_names_all: "Moultrie|Macon",
    county_fips_all: "17139|17115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61938,
    lat: 39.48004,
    lng: -88.37571,
    city: "Mattoon",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21227,
    density: 64.8,
    county_fips: 17029,
    county_name: "Coles",
    county_weights: {
      17029: 98.73,
      17035: 1.27,
    },
    county_names_all: "Coles|Cumberland",
    county_fips_all: "17029|17035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61940,
    lat: 39.80395,
    lng: -87.81249,
    city: "Metcalf",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 338,
    density: 4.1,
    county_fips: 17045,
    county_name: "Edgar",
    county_weights: {
      17045: 100,
    },
    county_names_all: "Edgar",
    county_fips_all: 17045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61941,
    lat: 39.80457,
    lng: -88.07505,
    city: "Murdock",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 181,
    density: 37.8,
    county_fips: 17041,
    county_name: "Douglas",
    county_weights: {
      17041: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 17041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61942,
    lat: 39.81515,
    lng: -88.00818,
    city: "Newman",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1064,
    density: 5.9,
    county_fips: 17041,
    county_name: "Douglas",
    county_weights: {
      17041: 90.52,
      17045: 9.48,
    },
    county_names_all: "Douglas|Edgar",
    county_fips_all: "17041|17045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61943,
    lat: 39.6608,
    lng: -88.0248,
    city: "Oakland",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1711,
    density: 8.9,
    county_fips: 17029,
    county_name: "Coles",
    county_weights: {
      17029: 57.88,
      17041: 34.25,
      17045: 7.87,
    },
    county_names_all: "Coles|Douglas|Edgar",
    county_fips_all: "17029|17041|17045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61944,
    lat: 39.59969,
    lng: -87.70146,
    city: "Paris",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11901,
    density: 17.5,
    county_fips: 17045,
    county_name: "Edgar",
    county_weights: {
      17023: 0.79,
      17045: 99.21,
    },
    county_names_all: "Edgar|Clark",
    county_fips_all: "17045|17023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61949,
    lat: 39.65753,
    lng: -87.85844,
    city: "Redmon",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 165,
    density: 56.9,
    county_fips: 17045,
    county_name: "Edgar",
    county_weights: {
      17045: 100,
    },
    county_names_all: "Edgar",
    county_fips_all: 17045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61951,
    lat: 39.59118,
    lng: -88.5865,
    city: "Sullivan",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7617,
    density: 22.3,
    county_fips: 17139,
    county_name: "Moultrie",
    county_weights: {
      17029: 2.25,
      17139: 97.75,
    },
    county_names_all: "Moultrie|Coles",
    county_fips_all: "17139|17029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61953,
    lat: 39.79803,
    lng: -88.28991,
    city: "Tuscola",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5783,
    density: 17.9,
    county_fips: 17041,
    county_name: "Douglas",
    county_weights: {
      17041: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 17041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61955,
    lat: 39.58162,
    lng: -87.5875,
    city: "Vermilion",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 224,
    density: 219.5,
    county_fips: 17045,
    county_name: "Edgar",
    county_weights: {
      17045: 100,
    },
    county_names_all: "Edgar",
    county_fips_all: 17045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61956,
    lat: 39.8537,
    lng: -88.14433,
    city: "Villa Grove",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2806,
    density: 31.9,
    county_fips: 17041,
    county_name: "Douglas",
    county_weights: {
      17019: 22.93,
      17041: 77.07,
    },
    county_names_all: "Douglas|Champaign",
    county_fips_all: "17041|17019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 61957,
    lat: 39.4397,
    lng: -88.60495,
    city: "Windsor",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1613,
    density: 7.6,
    county_fips: 17173,
    county_name: "Shelby",
    county_weights: {
      17139: 12.34,
      17173: 87.66,
    },
    county_names_all: "Shelby|Moultrie",
    county_fips_all: "17173|17139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62001,
    lat: 38.87971,
    lng: -89.74562,
    city: "Alhambra",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1540,
    density: 12.4,
    county_fips: 17119,
    county_name: "Madison",
    county_weights: {
      17119: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 17119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62002,
    lat: 38.93988,
    lng: -90.12829,
    city: "Alton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30937,
    density: 289.4,
    county_fips: 17119,
    county_name: "Madison",
    county_weights: {
      17117: 7.03,
      17119: 92.97,
    },
    county_names_all: "Madison|Macoupin",
    county_fips_all: "17119|17117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62006,
    lat: 39.06433,
    lng: -90.66714,
    city: "Batchtown",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 503,
    density: 6.1,
    county_fips: 17013,
    county_name: "Calhoun",
    county_weights: {
      17013: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 17013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62009,
    lat: 39.09351,
    lng: -89.79856,
    city: "Benld",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1874,
    density: 251.7,
    county_fips: 17117,
    county_name: "Macoupin",
    county_weights: {
      17117: 100,
    },
    county_names_all: "Macoupin",
    county_fips_all: 17117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62010,
    lat: 38.91944,
    lng: -90.04789,
    city: "Bethalto",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11123,
    density: 202.2,
    county_fips: 17119,
    county_name: "Madison",
    county_weights: {
      17119: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 17119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62011,
    lat: 39.12862,
    lng: -89.21755,
    city: "Bingham",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 200,
    density: 2.7,
    county_fips: 17051,
    county_name: "Fayette",
    county_weights: {
      17051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 17051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62012,
    lat: 39.04225,
    lng: -90.15027,
    city: "Brighton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6605,
    density: 42.3,
    county_fips: 17083,
    county_name: "Jersey",
    county_weights: {
      17083: 49.92,
      17117: 44.71,
      17119: 5.37,
    },
    county_names_all: "Jersey|Macoupin|Madison",
    county_fips_all: "17083|17117|17119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62013,
    lat: 38.96421,
    lng: -90.56518,
    city: "Brussels",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 614,
    density: 10.7,
    county_fips: 17013,
    county_name: "Calhoun",
    county_weights: {
      17013: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 17013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62014,
    lat: 39.04313,
    lng: -89.94999,
    city: "Bunker Hill",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3918,
    density: 25.2,
    county_fips: 17117,
    county_name: "Macoupin",
    county_weights: {
      17117: 100,
    },
    county_names_all: "Macoupin",
    county_fips_all: 17117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62015,
    lat: 39.22011,
    lng: -89.54203,
    city: "Butler",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 578,
    density: 6.4,
    county_fips: 17135,
    county_name: "Montgomery",
    county_weights: {
      17135: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 17135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62016,
    lat: 39.29517,
    lng: -90.41462,
    city: "Carrollton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3604,
    density: 10.3,
    county_fips: 17061,
    county_name: "Greene",
    county_weights: {
      17061: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 17061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62017,
    lat: 39.06597,
    lng: -89.36945,
    city: "Coffeen",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 972,
    density: 10.6,
    county_fips: 17135,
    county_name: "Montgomery",
    county_weights: {
      17005: 6.03,
      17135: 93.97,
    },
    county_names_all: "Montgomery|Bond",
    county_fips_all: "17135|17005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62018,
    lat: 38.90847,
    lng: -90.08574,
    city: "Cottage Hills",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2896,
    density: 336.5,
    county_fips: 17119,
    county_name: "Madison",
    county_weights: {
      17119: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 17119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62019,
    lat: 39.01598,
    lng: -89.45195,
    city: "Donnellson",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 317,
    density: 4.2,
    county_fips: 17005,
    county_name: "Bond",
    county_weights: {
      17005: 65.06,
      17135: 34.94,
    },
    county_names_all: "Bond|Montgomery",
    county_fips_all: "17005|17135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62021,
    lat: 38.97797,
    lng: -89.981,
    city: "Dorsey",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 832,
    density: 15.8,
    county_fips: 17119,
    county_name: "Madison",
    county_weights: {
      17117: 2.32,
      17119: 97.68,
    },
    county_names_all: "Madison|Macoupin",
    county_fips_all: "17119|17117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62022,
    lat: 39.00139,
    lng: -90.32972,
    city: "Dow",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 974,
    density: 18.4,
    county_fips: 17083,
    county_name: "Jersey",
    county_weights: {
      17083: 100,
    },
    county_names_all: "Jersey",
    county_fips_all: 17083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62023,
    lat: 39.10794,
    lng: -89.78278,
    city: "Eagarville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 106,
    density: 52.3,
    county_fips: 17117,
    county_name: "Macoupin",
    county_weights: {
      17117: 100,
    },
    county_names_all: "Macoupin",
    county_fips_all: 17117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62024,
    lat: 38.88343,
    lng: -90.08879,
    city: "East Alton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9731,
    density: 701.3,
    county_fips: 17119,
    county_name: "Madison",
    county_weights: {
      17119: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 17119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62025,
    lat: 38.83004,
    lng: -89.93298,
    city: "Edwardsville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35691,
    density: 122.8,
    county_fips: 17119,
    county_name: "Madison",
    county_weights: {
      17119: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 17119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62026,
    lat: 38.79062,
    lng: -90.00394,
    city: "Edwardsville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 17119,
    county_name: "Madison",
    county_weights: {
      17119: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 17119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62027,
    lat: 39.24686,
    lng: -90.55725,
    city: "Eldred",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 580,
    density: 3.7,
    county_fips: 17061,
    county_name: "Greene",
    county_weights: {
      17061: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 17061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62028,
    lat: 38.95932,
    lng: -90.35353,
    city: "Elsah",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1133,
    density: 73.1,
    county_fips: 17083,
    county_name: "Jersey",
    county_weights: {
      17083: 100,
    },
    county_names_all: "Jersey",
    county_fips_all: 17083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62030,
    lat: 39.15463,
    lng: -90.16445,
    city: "Fidelity",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 172,
    density: 655.5,
    county_fips: 17083,
    county_name: "Jersey",
    county_weights: {
      17083: 100,
    },
    county_names_all: "Jersey",
    county_fips_all: 17083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62031,
    lat: 39.1123,
    lng: -90.53355,
    city: "Fieldon",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 678,
    density: 4.4,
    county_fips: 17083,
    county_name: "Jersey",
    county_weights: {
      17061: 0.23,
      17083: 99.77,
    },
    county_names_all: "Jersey|Greene",
    county_fips_all: "17083|17061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62032,
    lat: 39.1158,
    lng: -89.28833,
    city: "Fillmore",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 887,
    density: 7.3,
    county_fips: 17135,
    county_name: "Montgomery",
    county_weights: {
      17051: 2.95,
      17135: 97.05,
    },
    county_names_all: "Montgomery|Fayette",
    county_fips_all: "17135|17051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62033,
    lat: 39.13561,
    lng: -89.84447,
    city: "Gillespie",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4716,
    density: 38.9,
    county_fips: 17117,
    county_name: "Macoupin",
    county_weights: {
      17117: 100,
    },
    county_names_all: "Macoupin",
    county_fips_all: 17117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62034,
    lat: 38.75639,
    lng: -89.96897,
    city: "Glen Carbon",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13388,
    density: 377.4,
    county_fips: 17119,
    county_name: "Madison",
    county_weights: {
      17119: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 17119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62035,
    lat: 38.96375,
    lng: -90.23917,
    city: "Godfrey",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16460,
    density: 145.2,
    county_fips: 17119,
    county_name: "Madison",
    county_weights: {
      17083: 31.77,
      17119: 68.23,
    },
    county_names_all: "Madison|Jersey",
    county_fips_all: "17119|17083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62036,
    lat: 38.91866,
    lng: -90.59079,
    city: "Golden Eagle",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 644,
    density: 7.9,
    county_fips: 17013,
    county_name: "Calhoun",
    county_weights: {
      17013: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 17013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62037,
    lat: 39.00826,
    lng: -90.4664,
    city: "Grafton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1822,
    density: 12.3,
    county_fips: 17083,
    county_name: "Jersey",
    county_weights: {
      17083: 100,
    },
    county_names_all: "Jersey",
    county_fips_all: 17083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62040,
    lat: 38.71592,
    lng: -90.10078,
    city: "Granite City",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42487,
    density: 411.3,
    county_fips: 17119,
    county_name: "Madison",
    county_weights: {
      17119: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 17119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62044,
    lat: 39.36618,
    lng: -90.20907,
    city: "Greenfield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2487,
    density: 10,
    county_fips: 17061,
    county_name: "Greene",
    county_weights: {
      17061: 80.74,
      17117: 19.26,
    },
    county_names_all: "Greene|Macoupin",
    county_fips_all: "17061|17117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62045,
    lat: 39.26297,
    lng: -90.70921,
    city: "Hamburg",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 498,
    density: 5,
    county_fips: 17013,
    county_name: "Calhoun",
    county_weights: {
      17013: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 17013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62046,
    lat: 38.88935,
    lng: -89.84397,
    city: "Hamel",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 748,
    density: 271.7,
    county_fips: 17119,
    county_name: "Madison",
    county_weights: {
      17119: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 17119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62047,
    lat: 39.13314,
    lng: -90.62273,
    city: "Hardin",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1747,
    density: 17.3,
    county_fips: 17013,
    county_name: "Calhoun",
    county_weights: {
      17013: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 17013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62048,
    lat: 38.77004,
    lng: -90.13895,
    city: "Hartford",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1769,
    density: 39.7,
    county_fips: 17119,
    county_name: "Madison",
    county_weights: {
      17119: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 17119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62049,
    lat: 39.1295,
    lng: -89.48572,
    city: "Hillsboro",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8450,
    density: 39.8,
    county_fips: 17135,
    county_name: "Montgomery",
    county_weights: {
      17135: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 17135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62050,
    lat: 39.43734,
    lng: -90.55544,
    city: "Hillview",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 352,
    density: 2.3,
    county_fips: 17061,
    county_name: "Greene",
    county_weights: {
      17061: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 17061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62051,
    lat: 39.20309,
    lng: -89.40244,
    city: "Irving",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 740,
    density: 7.3,
    county_fips: 17135,
    county_name: "Montgomery",
    county_weights: {
      17135: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 17135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62052,
    lat: 39.11179,
    lng: -90.32004,
    city: "Jerseyville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12599,
    density: 34,
    county_fips: 17083,
    county_name: "Jersey",
    county_weights: {
      17061: 1.19,
      17083: 98.81,
    },
    county_names_all: "Jersey|Greene",
    county_fips_all: "17083|17061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62053,
    lat: 39.31572,
    lng: -90.65763,
    city: "Kampsville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 441,
    density: 3.4,
    county_fips: 17013,
    county_name: "Calhoun",
    county_weights: {
      17013: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 17013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62054,
    lat: 39.2012,
    lng: -90.34693,
    city: "Kane",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 470,
    density: 5.2,
    county_fips: 17061,
    county_name: "Greene",
    county_weights: {
      17061: 65.77,
      17083: 34.23,
    },
    county_names_all: "Greene|Jersey",
    county_fips_all: "17061|17083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62056,
    lat: 39.1765,
    lng: -89.67165,
    city: "Litchfield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8606,
    density: 30.9,
    county_fips: 17135,
    county_name: "Montgomery",
    county_weights: {
      17117: 27.62,
      17135: 72.38,
    },
    county_names_all: "Montgomery|Macoupin",
    county_fips_all: "17135|17117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62058,
    lat: 38.96793,
    lng: -89.76491,
    city: "Livingston",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 780,
    density: 283.4,
    county_fips: 17119,
    county_name: "Madison",
    county_weights: {
      17119: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 17119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62059,
    lat: 38.65434,
    lng: -90.17097,
    city: "Lovejoy",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 416,
    density: 244.5,
    county_fips: 17163,
    county_name: "St. Clair",
    county_weights: {
      17163: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 17163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62060,
    lat: 38.67664,
    lng: -90.14686,
    city: "Madison",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3881,
    density: 424.2,
    county_fips: 17119,
    county_name: "Madison",
    county_weights: {
      17119: 95.76,
      17163: 4.24,
    },
    county_names_all: "Madison|St. Clair",
    county_fips_all: "17119|17163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62061,
    lat: 38.79077,
    lng: -89.77624,
    city: "Marine",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1718,
    density: 28.6,
    county_fips: 17119,
    county_name: "Madison",
    county_weights: {
      17119: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 17119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62062,
    lat: 38.72719,
    lng: -89.96253,
    city: "Maryville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8107,
    density: 495.9,
    county_fips: 17119,
    county_name: "Madison",
    county_weights: {
      17119: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 17119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62063,
    lat: 39.1982,
    lng: -90.14836,
    city: "Medora",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 860,
    density: 6.3,
    county_fips: 17083,
    county_name: "Jersey",
    county_weights: {
      17061: 0.51,
      17083: 51.73,
      17117: 47.76,
    },
    county_names_all: "Jersey|Macoupin|Greene",
    county_fips_all: "17083|17117|17061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62067,
    lat: 38.92961,
    lng: -89.98837,
    city: "Moro",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2200,
    density: 48.9,
    county_fips: 17119,
    county_name: "Madison",
    county_weights: {
      17119: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 17119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62069,
    lat: 39.08892,
    lng: -89.74044,
    city: "Mount Olive",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3216,
    density: 42.6,
    county_fips: 17117,
    county_name: "Macoupin",
    county_weights: {
      17117: 97.3,
      17135: 2.7,
    },
    county_names_all: "Macoupin|Montgomery",
    county_fips_all: "17117|17135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62074,
    lat: 38.95594,
    lng: -89.68338,
    city: "New Douglas",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1223,
    density: 11.1,
    county_fips: 17119,
    county_name: "Madison",
    county_weights: {
      17005: 13.27,
      17117: 7.99,
      17119: 75.04,
      17135: 3.7,
    },
    county_names_all: "Madison|Bond|Macoupin|Montgomery",
    county_fips_all: "17119|17005|17117|17135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62075,
    lat: 39.30143,
    lng: -89.29676,
    city: "Nokomis",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3564,
    density: 12.8,
    county_fips: 17135,
    county_name: "Montgomery",
    county_weights: {
      17021: 18.45,
      17051: 0.54,
      17135: 81.01,
    },
    county_names_all: "Montgomery|Christian|Fayette",
    county_fips_all: "17135|17021|17051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62076,
    lat: 39.34186,
    lng: -89.23383,
    city: "Ohlman",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 103,
    density: 21.4,
    county_fips: 17135,
    county_name: "Montgomery",
    county_weights: {
      17135: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 17135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62077,
    lat: 39.03133,
    lng: -89.51605,
    city: "Panama",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 221,
    density: 34.6,
    county_fips: 17135,
    county_name: "Montgomery",
    county_weights: {
      17005: 45.17,
      17135: 54.83,
    },
    county_names_all: "Montgomery|Bond",
    county_fips_all: "17135|17005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62078,
    lat: 39.47984,
    lng: -90.48686,
    city: "Patterson",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 89,
    density: 65,
    county_fips: 17061,
    county_name: "Greene",
    county_weights: {
      17061: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 17061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62079,
    lat: 39.11457,
    lng: -90.12642,
    city: "Piasa",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 267,
    density: 9.4,
    county_fips: 17117,
    county_name: "Macoupin",
    county_weights: {
      17083: 18.56,
      17117: 81.44,
    },
    county_names_all: "Macoupin|Jersey",
    county_fips_all: "17117|17083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62080,
    lat: 39.14115,
    lng: -89.10569,
    city: "Ramsey",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2278,
    density: 7.4,
    county_fips: 17051,
    county_name: "Fayette",
    county_weights: {
      17051: 94.17,
      17135: 3.93,
      17173: 1.9,
    },
    county_names_all: "Fayette|Montgomery|Shelby",
    county_fips_all: "17051|17135|17173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62081,
    lat: 39.26262,
    lng: -90.23452,
    city: "Rockbridge",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 331,
    density: 4.9,
    county_fips: 17061,
    county_name: "Greene",
    county_weights: {
      17061: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 17061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62082,
    lat: 39.49392,
    lng: -90.32157,
    city: "Roodhouse",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2584,
    density: 9.5,
    county_fips: 17061,
    county_name: "Greene",
    county_weights: {
      17061: 82.96,
      17137: 0.83,
      17171: 16.21,
    },
    county_names_all: "Greene|Scott|Morgan",
    county_fips_all: "17061|17171|17137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62083,
    lat: 39.35122,
    lng: -89.19842,
    city: "Rosamond",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 168,
    density: 3,
    county_fips: 17021,
    county_name: "Christian",
    county_weights: {
      17021: 61.76,
      17135: 38.24,
    },
    county_names_all: "Christian|Montgomery",
    county_fips_all: "17021|17135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62084,
    lat: 38.84082,
    lng: -90.06365,
    city: "Roxana",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1592,
    density: 133.2,
    county_fips: 17119,
    county_name: "Madison",
    county_weights: {
      17119: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 17119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62085,
    lat: 39.07839,
    lng: -89.80308,
    city: "Sawyerville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 165,
    density: 71.1,
    county_fips: 17117,
    county_name: "Macoupin",
    county_weights: {
      17117: 100,
    },
    county_names_all: "Macoupin",
    county_fips_all: 17117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62086,
    lat: 38.98302,
    lng: -89.58556,
    city: "Sorento",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1261,
    density: 10.1,
    county_fips: 17005,
    county_name: "Bond",
    county_weights: {
      17005: 76.26,
      17119: 2.92,
      17135: 20.82,
    },
    county_names_all: "Bond|Montgomery|Madison",
    county_fips_all: "17005|17135|17119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62087,
    lat: 38.81754,
    lng: -90.06767,
    city: "South Roxana",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2304,
    density: 253.5,
    county_fips: 17119,
    county_name: "Madison",
    county_weights: {
      17119: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 17119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62088,
    lat: 39.01318,
    lng: -89.79764,
    city: "Staunton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6376,
    density: 56.1,
    county_fips: 17117,
    county_name: "Macoupin",
    county_weights: {
      17117: 63.58,
      17119: 36.42,
    },
    county_names_all: "Macoupin|Madison",
    county_fips_all: "17117|17119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62089,
    lat: 39.12111,
    lng: -89.48673,
    city: "Taylor Springs",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 392,
    density: 66.7,
    county_fips: 17135,
    county_name: "Montgomery",
    county_weights: {
      17135: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 17135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62090,
    lat: 38.66925,
    lng: -90.17044,
    city: "Venice",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1217,
    density: 314,
    county_fips: 17119,
    county_name: "Madison",
    county_weights: {
      17119: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 17119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62091,
    lat: 39.05594,
    lng: -89.61222,
    city: "Walshville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 444,
    density: 5.4,
    county_fips: 17135,
    county_name: "Montgomery",
    county_weights: {
      17135: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 17135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62092,
    lat: 39.41839,
    lng: -90.41291,
    city: "White Hall",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2814,
    density: 16.9,
    county_fips: 17061,
    county_name: "Greene",
    county_weights: {
      17061: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 17061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62093,
    lat: 39.06858,
    lng: -89.84573,
    city: "Wilsonville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 292,
    density: 50.7,
    county_fips: 17117,
    county_name: "Macoupin",
    county_weights: {
      17117: 100,
    },
    county_names_all: "Macoupin",
    county_fips_all: 17117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62094,
    lat: 39.2441,
    lng: -89.34871,
    city: "Witt",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 882,
    density: 10.8,
    county_fips: 17135,
    county_name: "Montgomery",
    county_weights: {
      17135: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 17135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62095,
    lat: 38.86307,
    lng: -90.07545,
    city: "Wood River",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10415,
    density: 565.9,
    county_fips: 17119,
    county_name: "Madison",
    county_weights: {
      17119: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 17119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62097,
    lat: 38.93719,
    lng: -89.85507,
    city: "Worden",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2883,
    density: 27,
    county_fips: 17119,
    county_name: "Madison",
    county_weights: {
      17119: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 17119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62098,
    lat: 39.38377,
    lng: -90.29946,
    city: "Wrights",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15,
    density: 1.1,
    county_fips: 17061,
    county_name: "Greene",
    county_weights: {
      17061: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 17061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62201,
    lat: 38.63567,
    lng: -90.14162,
    city: "East Saint Louis",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6542,
    density: 209.8,
    county_fips: 17163,
    county_name: "St. Clair",
    county_weights: {
      17119: 3.85,
      17163: 96.15,
    },
    county_names_all: "St. Clair|Madison",
    county_fips_all: "17163|17119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62203,
    lat: 38.60223,
    lng: -90.07534,
    city: "East Saint Louis",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8393,
    density: 573.6,
    county_fips: 17163,
    county_name: "St. Clair",
    county_weights: {
      17163: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 17163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62204,
    lat: 38.63033,
    lng: -90.09642,
    city: "East Saint Louis",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8215,
    density: 686.8,
    county_fips: 17163,
    county_name: "St. Clair",
    county_weights: {
      17163: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 17163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62205,
    lat: 38.60259,
    lng: -90.11469,
    city: "East Saint Louis",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7016,
    density: 426.1,
    county_fips: 17163,
    county_name: "St. Clair",
    county_weights: {
      17163: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 17163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62206,
    lat: 38.56796,
    lng: -90.16981,
    city: "East Saint Louis",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15157,
    density: 402.5,
    county_fips: 17163,
    county_name: "St. Clair",
    county_weights: {
      17163: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 17163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62207,
    lat: 38.58327,
    lng: -90.12544,
    city: "East Saint Louis",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9561,
    density: 595.3,
    county_fips: 17163,
    county_name: "St. Clair",
    county_weights: {
      17163: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 17163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62208,
    lat: 38.59641,
    lng: -90.00528,
    city: "Fairview Heights",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16517,
    density: 476.2,
    county_fips: 17163,
    county_name: "St. Clair",
    county_weights: {
      17163: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 17163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62214,
    lat: 38.37682,
    lng: -89.60529,
    city: "Addieville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1449,
    density: 10.4,
    county_fips: 17189,
    county_name: "Washington",
    county_weights: {
      17189: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 17189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62215,
    lat: 38.50672,
    lng: -89.60515,
    city: "Albers",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2102,
    density: 73.2,
    county_fips: 17027,
    county_name: "Clinton",
    county_weights: {
      17027: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 17027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62216,
    lat: 38.62559,
    lng: -89.60313,
    city: "Aviston",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2793,
    density: 44.9,
    county_fips: 17027,
    county_name: "Clinton",
    county_weights: {
      17027: 91.9,
      17119: 8.1,
    },
    county_names_all: "Clinton|Madison",
    county_fips_all: "17027|17119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62217,
    lat: 38.1732,
    lng: -89.83954,
    city: "Baldwin",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 833,
    density: 10.3,
    county_fips: 17157,
    county_name: "Randolph",
    county_weights: {
      17157: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 17157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62218,
    lat: 38.52069,
    lng: -89.47738,
    city: "Bartelso",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1896,
    density: 16,
    county_fips: 17027,
    county_name: "Clinton",
    county_weights: {
      17027: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 17027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62219,
    lat: 38.60371,
    lng: -89.43698,
    city: "Beckemeyer",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1006,
    density: 456,
    county_fips: 17027,
    county_name: "Clinton",
    county_weights: {
      17027: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 17027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62220,
    lat: 38.47247,
    lng: -89.98704,
    city: "Belleville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17949,
    density: 239.9,
    county_fips: 17163,
    county_name: "St. Clair",
    county_weights: {
      17163: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 17163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62221,
    lat: 38.51187,
    lng: -89.89922,
    city: "Belleville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30009,
    density: 331.3,
    county_fips: 17163,
    county_name: "St. Clair",
    county_weights: {
      17163: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 17163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62223,
    lat: 38.53491,
    lng: -90.06027,
    city: "Belleville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16642,
    density: 250.3,
    county_fips: 17163,
    county_name: "St. Clair",
    county_weights: {
      17163: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 17163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62225,
    lat: 38.54065,
    lng: -89.85503,
    city: "Scott Air Force Base",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5323,
    density: 391.6,
    county_fips: 17163,
    county_name: "St. Clair",
    county_weights: {
      17163: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 17163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62226,
    lat: 38.53634,
    lng: -90.00057,
    city: "Belleville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28575,
    density: 795.2,
    county_fips: 17163,
    county_name: "St. Clair",
    county_weights: {
      17163: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 17163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62230,
    lat: 38.63855,
    lng: -89.52742,
    city: "Breese",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6359,
    density: 47.7,
    county_fips: 17027,
    county_name: "Clinton",
    county_weights: {
      17027: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 17027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62231,
    lat: 38.64402,
    lng: -89.32642,
    city: "Carlyle",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6776,
    density: 13.6,
    county_fips: 17027,
    county_name: "Clinton",
    county_weights: {
      17027: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 17027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62232,
    lat: 38.63266,
    lng: -90.00509,
    city: "Caseyville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6442,
    density: 193.9,
    county_fips: 17163,
    county_name: "St. Clair",
    county_weights: {
      17163: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 17163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62233,
    lat: 37.93719,
    lng: -89.78842,
    city: "Chester",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9482,
    density: 53.6,
    county_fips: 17157,
    county_name: "Randolph",
    county_weights: {
      17157: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 17157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62234,
    lat: 38.68214,
    lng: -89.9815,
    city: "Collinsville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32579,
    density: 337.6,
    county_fips: 17119,
    county_name: "Madison",
    county_weights: {
      17119: 83.6,
      17163: 16.4,
    },
    county_names_all: "Madison|St. Clair",
    county_fips_all: "17119|17163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62236,
    lat: 38.43391,
    lng: -90.21141,
    city: "Columbia",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13956,
    density: 89.3,
    county_fips: 17133,
    county_name: "Monroe",
    county_weights: {
      17133: 82.69,
      17163: 17.31,
    },
    county_names_all: "Monroe|St. Clair",
    county_fips_all: "17133|17163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62237,
    lat: 38.1916,
    lng: -89.57046,
    city: "Coulterville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2269,
    density: 9.5,
    county_fips: 17145,
    county_name: "Perry",
    county_weights: {
      17145: 49.24,
      17157: 25.24,
      17189: 25.52,
    },
    county_names_all: "Perry|Washington|Randolph",
    county_fips_all: "17145|17189|17157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62238,
    lat: 38.04499,
    lng: -89.5319,
    city: "Cutler",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 661,
    density: 5.1,
    county_fips: 17145,
    county_name: "Perry",
    county_weights: {
      17145: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 17145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62239,
    lat: 38.528,
    lng: -90.1803,
    city: "Dupo",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4919,
    density: 222.2,
    county_fips: 17163,
    county_name: "St. Clair",
    county_weights: {
      17163: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 17163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62240,
    lat: 38.52084,
    lng: -90.21011,
    city: "East Carondelet",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1499,
    density: 38.9,
    county_fips: 17163,
    county_name: "St. Clair",
    county_weights: {
      17163: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 17163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62241,
    lat: 38.01474,
    lng: -89.88845,
    city: "Ellis Grove",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 855,
    density: 8.6,
    county_fips: 17157,
    county_name: "Randolph",
    county_weights: {
      17157: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 17157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62242,
    lat: 38.09257,
    lng: -89.94339,
    city: "Evansville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1292,
    density: 10,
    county_fips: 17157,
    county_name: "Randolph",
    county_weights: {
      17157: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 17157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62243,
    lat: 38.41841,
    lng: -89.88978,
    city: "Freeburg",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6023,
    density: 45,
    county_fips: 17163,
    county_name: "St. Clair",
    county_weights: {
      17163: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 17163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62244,
    lat: 38.19142,
    lng: -90.1965,
    city: "Fults",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 931,
    density: 7.6,
    county_fips: 17133,
    county_name: "Monroe",
    county_weights: {
      17133: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 17133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62245,
    lat: 38.54783,
    lng: -89.57446,
    city: "Germantown",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1933,
    density: 40.6,
    county_fips: 17027,
    county_name: "Clinton",
    county_weights: {
      17027: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 17027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62246,
    lat: 38.88834,
    lng: -89.42533,
    city: "Greenville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9885,
    density: 26.7,
    county_fips: 17005,
    county_name: "Bond",
    county_weights: {
      17005: 100,
    },
    county_names_all: "Bond",
    county_fips_all: 17005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62248,
    lat: 38.30543,
    lng: -89.99341,
    city: "Hecker",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 406,
    density: 622.5,
    county_fips: 17133,
    county_name: "Monroe",
    county_weights: {
      17133: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 17133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62249,
    lat: 38.75469,
    lng: -89.66436,
    city: "Highland",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15811,
    density: 68.8,
    county_fips: 17119,
    county_name: "Madison",
    county_weights: {
      17005: 2.27,
      17027: 7.35,
      17119: 90.38,
    },
    county_names_all: "Madison|Clinton|Bond",
    county_fips_all: "17119|17027|17005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62250,
    lat: 38.54042,
    lng: -89.26436,
    city: "Hoffman",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 773,
    density: 587.5,
    county_fips: 17027,
    county_name: "Clinton",
    county_weights: {
      17027: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 17027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62253,
    lat: 38.77554,
    lng: -89.29738,
    city: "Keyesport",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 665,
    density: 8.2,
    county_fips: 17005,
    county_name: "Bond",
    county_weights: {
      17005: 80.1,
      17027: 6.96,
      17051: 12.94,
    },
    county_names_all: "Bond|Fayette|Clinton",
    county_fips_all: "17005|17051|17027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62254,
    lat: 38.6098,
    lng: -89.81901,
    city: "Lebanon",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5896,
    density: 55.7,
    county_fips: 17163,
    county_name: "St. Clair",
    county_weights: {
      17119: 1.73,
      17163: 98.27,
    },
    county_names_all: "St. Clair|Madison",
    county_fips_all: "17163|17119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62255,
    lat: 38.31244,
    lng: -89.77842,
    city: "Lenzburg",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 914,
    density: 13.3,
    county_fips: 17163,
    county_name: "St. Clair",
    county_weights: {
      17163: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 17163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62256,
    lat: 38.22623,
    lng: -90.23152,
    city: "Maeystown",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 17133,
    county_name: "Monroe",
    county_weights: {
      17133: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 17133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62257,
    lat: 38.28048,
    lng: -89.73262,
    city: "Marissa",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2236,
    density: 10.7,
    county_fips: 17163,
    county_name: "St. Clair",
    county_weights: {
      17157: 7.34,
      17163: 57.41,
      17189: 35.25,
    },
    county_names_all: "St. Clair|Washington|Randolph",
    county_fips_all: "17163|17189|17157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62258,
    lat: 38.46014,
    lng: -89.77287,
    city: "Mascoutah",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9985,
    density: 51.1,
    county_fips: 17163,
    county_name: "St. Clair",
    county_weights: {
      17163: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 17163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62260,
    lat: 38.46097,
    lng: -90.09891,
    city: "Millstadt",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6845,
    density: 60.2,
    county_fips: 17163,
    county_name: "St. Clair",
    county_weights: {
      17163: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 17163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62261,
    lat: 38.01218,
    lng: -89.99774,
    city: "Modoc",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47,
    density: 0.7,
    county_fips: 17157,
    county_name: "Randolph",
    county_weights: {
      17157: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 17157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62262,
    lat: 38.9371,
    lng: -89.26916,
    city: "Mulberry Grove",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1838,
    density: 10.6,
    county_fips: 17005,
    county_name: "Bond",
    county_weights: {
      17005: 60.62,
      17051: 39.38,
    },
    county_names_all: "Bond|Fayette",
    county_fips_all: "17005|17051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62263,
    lat: 38.33168,
    lng: -89.39706,
    city: "Nashville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4785,
    density: 12.5,
    county_fips: 17189,
    county_name: "Washington",
    county_weights: {
      17145: 0.76,
      17189: 99.24,
    },
    county_names_all: "Washington|Perry",
    county_fips_all: "17189|17145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62264,
    lat: 38.31612,
    lng: -89.90721,
    city: "New Athens",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3357,
    density: 19.8,
    county_fips: 17163,
    county_name: "St. Clair",
    county_weights: {
      17133: 5.58,
      17163: 94.42,
    },
    county_names_all: "St. Clair|Monroe",
    county_fips_all: "17163|17133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62265,
    lat: 38.50808,
    lng: -89.67797,
    city: "New Baden",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4019,
    density: 46.1,
    county_fips: 17027,
    county_name: "Clinton",
    county_weights: {
      17027: 86.38,
      17163: 13.62,
    },
    county_names_all: "Clinton|St. Clair",
    county_fips_all: "17027|17163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62266,
    lat: 38.47481,
    lng: -89.64988,
    city: "New Memphis",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 17027,
    county_name: "Clinton",
    county_weights: {
      17027: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 17027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62268,
    lat: 38.27208,
    lng: -89.52612,
    city: "Oakdale",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 909,
    density: 6.6,
    county_fips: 17189,
    county_name: "Washington",
    county_weights: {
      17145: 4.79,
      17189: 95.21,
    },
    county_names_all: "Washington|Perry",
    county_fips_all: "17189|17145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62269,
    lat: 38.59844,
    lng: -89.91294,
    city: "O'Fallon",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31755,
    density: 411,
    county_fips: 17163,
    county_name: "St. Clair",
    county_weights: {
      17163: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 17163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62271,
    lat: 38.44028,
    lng: -89.52209,
    city: "Okawville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1914,
    density: 11.7,
    county_fips: 17189,
    county_name: "Washington",
    county_weights: {
      17189: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 17189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62272,
    lat: 38.00241,
    lng: -89.61562,
    city: "Percy",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1947,
    density: 23.4,
    county_fips: 17157,
    county_name: "Randolph",
    county_weights: {
      17077: 1.14,
      17145: 16.97,
      17157: 81.89,
    },
    county_names_all: "Randolph|Perry|Jackson",
    county_fips_all: "17157|17145|17077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62273,
    lat: 38.78673,
    lng: -89.58389,
    city: "Pierron",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 174,
    density: 49.8,
    county_fips: 17005,
    county_name: "Bond",
    county_weights: {
      17005: 100,
    },
    county_names_all: "Bond",
    county_fips_all: 17005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62274,
    lat: 38.09312,
    lng: -89.40064,
    city: "Pinckneyville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8237,
    density: 22.3,
    county_fips: 17145,
    county_name: "Perry",
    county_weights: {
      17077: 0.92,
      17145: 99.08,
    },
    county_names_all: "Perry|Jackson",
    county_fips_all: "17145|17077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62275,
    lat: 38.81507,
    lng: -89.54496,
    city: "Pocahontas",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3373,
    density: 13.1,
    county_fips: 17005,
    county_name: "Bond",
    county_weights: {
      17005: 76.14,
      17027: 6.42,
      17119: 17.44,
    },
    county_names_all: "Bond|Madison|Clinton",
    county_fips_all: "17005|17119|17027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62277,
    lat: 38.09844,
    lng: -90.11081,
    city: "Prairie Du Rocher",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1081,
    density: 6.4,
    county_fips: 17157,
    county_name: "Randolph",
    county_weights: {
      17133: 38,
      17157: 62,
    },
    county_names_all: "Randolph|Monroe",
    county_fips_all: "17157|17133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62278,
    lat: 38.20528,
    lng: -89.99116,
    city: "Red Bud",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6345,
    density: 23.4,
    county_fips: 17133,
    county_name: "Monroe",
    county_weights: {
      17133: 53.82,
      17157: 46.18,
    },
    county_names_all: "Monroe|Randolph",
    county_fips_all: "17133|17157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62279,
    lat: 38.13796,
    lng: -90.13695,
    city: "Renault",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 17133,
    county_name: "Monroe",
    county_weights: {
      17133: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 17133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62280,
    lat: 37.83179,
    lng: -89.65952,
    city: "Rockwood",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 572,
    density: 4.2,
    county_fips: 17077,
    county_name: "Jackson",
    county_weights: {
      17077: 55.27,
      17157: 44.73,
    },
    county_names_all: "Jackson|Randolph",
    county_fips_all: "17077|17157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62281,
    lat: 38.70405,
    lng: -89.78288,
    city: "Saint Jacob",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2718,
    density: 31.5,
    county_fips: 17119,
    county_name: "Madison",
    county_weights: {
      17119: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 17119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62282,
    lat: 38.35644,
    lng: -89.71334,
    city: "Saint Libory",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 480,
    density: 96.6,
    county_fips: 17163,
    county_name: "St. Clair",
    county_weights: {
      17163: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 17163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62284,
    lat: 38.86867,
    lng: -89.31107,
    city: "Smithboro",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 565,
    density: 8,
    county_fips: 17005,
    county_name: "Bond",
    county_weights: {
      17005: 100,
    },
    county_names_all: "Bond",
    county_fips_all: 17005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62285,
    lat: 38.38845,
    lng: -90.00773,
    city: "Smithton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4744,
    density: 112.8,
    county_fips: 17163,
    county_name: "St. Clair",
    county_weights: {
      17163: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 17163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62286,
    lat: 38.11756,
    lng: -89.7154,
    city: "Sparta",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6066,
    density: 23.4,
    county_fips: 17157,
    county_name: "Randolph",
    county_weights: {
      17157: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 17157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62288,
    lat: 37.99267,
    lng: -89.69106,
    city: "Steeleville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2774,
    density: 29.1,
    county_fips: 17157,
    county_name: "Randolph",
    county_weights: {
      17157: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 17157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62289,
    lat: 38.59788,
    lng: -89.75096,
    city: "Summerfield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 286,
    density: 73.7,
    county_fips: 17163,
    county_name: "St. Clair",
    county_weights: {
      17163: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 17163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62292,
    lat: 38.21299,
    lng: -89.68261,
    city: "Tilden",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 961,
    density: 219.7,
    county_fips: 17157,
    county_name: "Randolph",
    county_weights: {
      17157: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 17157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62293,
    lat: 38.61838,
    lng: -89.69748,
    city: "Trenton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4176,
    density: 31,
    county_fips: 17027,
    county_name: "Clinton",
    county_weights: {
      17027: 46.37,
      17119: 16.49,
      17163: 37.15,
    },
    county_names_all: "Clinton|St. Clair|Madison",
    county_fips_all: "17027|17163|17119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62294,
    lat: 38.70374,
    lng: -89.87242,
    city: "Troy",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14036,
    density: 183.8,
    county_fips: 17119,
    county_name: "Madison",
    county_weights: {
      17119: 97.2,
      17163: 2.8,
    },
    county_names_all: "Madison|St. Clair",
    county_fips_all: "17119|17163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62295,
    lat: 38.27126,
    lng: -90.30895,
    city: "Valmeyer",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1454,
    density: 8,
    county_fips: 17133,
    county_name: "Monroe",
    county_weights: {
      17133: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 17133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62297,
    lat: 38.04938,
    lng: -89.81239,
    city: "Walsh",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 402,
    density: 6.9,
    county_fips: 17157,
    county_name: "Randolph",
    county_weights: {
      17157: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 17157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62298,
    lat: 38.30906,
    lng: -90.15132,
    city: "Waterloo",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17101,
    density: 46.2,
    county_fips: 17133,
    county_name: "Monroe",
    county_weights: {
      17133: 90.87,
      17163: 9.13,
    },
    county_names_all: "Monroe|St. Clair",
    county_fips_all: "17133|17163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62301,
    lat: 39.93139,
    lng: -91.38741,
    city: "Quincy",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31744,
    density: 1097.2,
    county_fips: 17001,
    county_name: "Adams",
    county_weights: {
      17001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 17001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62305,
    lat: 39.92915,
    lng: -91.34441,
    city: "Quincy",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19016,
    density: 52.7,
    county_fips: 17001,
    county_name: "Adams",
    county_weights: {
      17001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 17001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62311,
    lat: 40.22195,
    lng: -90.9212,
    city: "Augusta",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 759,
    density: 6,
    county_fips: 17067,
    county_name: "Hancock",
    county_weights: {
      17001: 11.53,
      17067: 48.57,
      17169: 39.9,
    },
    county_names_all: "Hancock|Schuyler|Adams",
    county_fips_all: "17067|17169|17001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62312,
    lat: 39.71035,
    lng: -91.02518,
    city: "Barry",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2101,
    density: 8.7,
    county_fips: 17149,
    county_name: "Pike",
    county_weights: {
      17001: 22.51,
      17149: 77.49,
    },
    county_names_all: "Pike|Adams",
    county_fips_all: "17149|17001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62313,
    lat: 40.31782,
    lng: -91.2251,
    city: "Basco",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 415,
    density: 3.9,
    county_fips: 17067,
    county_name: "Hancock",
    county_weights: {
      17067: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 17067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62314,
    lat: 39.76967,
    lng: -90.89204,
    city: "Baylis",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 621,
    density: 3.7,
    county_fips: 17149,
    county_name: "Pike",
    county_weights: {
      17001: 15.43,
      17149: 84.57,
    },
    county_names_all: "Pike|Adams",
    county_fips_all: "17149|17001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62316,
    lat: 40.23341,
    lng: -91.05495,
    city: "Bowen",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 785,
    density: 6.8,
    county_fips: 17067,
    county_name: "Hancock",
    county_weights: {
      17001: 10.92,
      17067: 89.08,
    },
    county_names_all: "Hancock|Adams",
    county_fips_all: "17067|17001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62319,
    lat: 40.15293,
    lng: -90.72997,
    city: "Camden",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 185,
    density: 1.9,
    county_fips: 17169,
    county_name: "Schuyler",
    county_weights: {
      17169: 100,
    },
    county_names_all: "Schuyler",
    county_fips_all: 17169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62320,
    lat: 40.02343,
    lng: -91.08295,
    city: "Camp Point",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2461,
    density: 11.7,
    county_fips: 17001,
    county_name: "Adams",
    county_weights: {
      17001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 17001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62321,
    lat: 40.40948,
    lng: -91.10606,
    city: "Carthage",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3589,
    density: 8.3,
    county_fips: 17067,
    county_name: "Hancock",
    county_weights: {
      17067: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 17067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62323,
    lat: 39.81306,
    lng: -90.68607,
    city: "Chambersburg",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 188,
    density: 1.7,
    county_fips: 17149,
    county_name: "Pike",
    county_weights: {
      17009: 1.79,
      17149: 98.21,
    },
    county_names_all: "Pike|Brown",
    county_fips_all: "17149|17009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62324,
    lat: 39.9901,
    lng: -90.96302,
    city: "Clayton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1229,
    density: 5,
    county_fips: 17001,
    county_name: "Adams",
    county_weights: {
      17001: 92.85,
      17009: 7.15,
    },
    county_names_all: "Adams|Brown",
    county_fips_all: "17001|17009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62325,
    lat: 40.05307,
    lng: -91.16564,
    city: "Coatsburg",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 421,
    density: 8.9,
    county_fips: 17001,
    county_name: "Adams",
    county_weights: {
      17001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 17001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62326,
    lat: 40.42248,
    lng: -90.81501,
    city: "Colchester",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2434,
    density: 12.2,
    county_fips: 17109,
    county_name: "McDonough",
    county_weights: {
      17067: 4.96,
      17109: 95.04,
    },
    county_names_all: "McDonough|Hancock",
    county_fips_all: "17109|17067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62330,
    lat: 40.57217,
    lng: -91.12187,
    city: "Dallas City",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1807,
    density: 8,
    county_fips: 17067,
    county_name: "Hancock",
    county_weights: {
      17067: 90.09,
      17071: 9.91,
    },
    county_names_all: "Hancock|Henderson",
    county_fips_all: "17067|17071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62334,
    lat: 40.39598,
    lng: -91.24912,
    city: "Elvaston",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 151,
    density: 71.8,
    county_fips: 17067,
    county_name: "Hancock",
    county_weights: {
      17067: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 17067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62336,
    lat: 40.46759,
    lng: -91.17333,
    city: "Ferris",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26,
    density: 63.5,
    county_fips: 17067,
    county_name: "Hancock",
    county_weights: {
      17067: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 17067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62338,
    lat: 39.99309,
    lng: -91.23889,
    city: "Fowler",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1105,
    density: 12.3,
    county_fips: 17001,
    county_name: "Adams",
    county_weights: {
      17001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 17001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62339,
    lat: 40.12898,
    lng: -91.04196,
    city: "Golden",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 917,
    density: 12.7,
    county_fips: 17001,
    county_name: "Adams",
    county_weights: {
      17001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 17001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62340,
    lat: 39.7228,
    lng: -90.72588,
    city: "Griggsville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1879,
    density: 8,
    county_fips: 17149,
    county_name: "Pike",
    county_weights: {
      17149: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 17149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62341,
    lat: 40.42566,
    lng: -91.30555,
    city: "Hamilton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3449,
    density: 28.6,
    county_fips: 17067,
    county_name: "Hancock",
    county_weights: {
      17067: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 17067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62343,
    lat: 39.70275,
    lng: -91.2418,
    city: "Hull",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 823,
    density: 4.2,
    county_fips: 17149,
    county_name: "Pike",
    county_weights: {
      17001: 5.29,
      17149: 94.71,
    },
    county_names_all: "Pike|Adams",
    county_fips_all: "17149|17001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62344,
    lat: 40.1799,
    lng: -90.82497,
    city: "Huntsville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22,
    density: 0.3,
    county_fips: 17169,
    county_name: "Schuyler",
    county_weights: {
      17169: 100,
    },
    county_names_all: "Schuyler",
    county_fips_all: 17169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62345,
    lat: 39.70655,
    lng: -91.12758,
    city: "Kinderhook",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 407,
    density: 7.4,
    county_fips: 17149,
    county_name: "Pike",
    county_weights: {
      17149: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 17149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62346,
    lat: 40.14367,
    lng: -90.93418,
    city: "La Prairie",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 146,
    density: 1.3,
    county_fips: 17001,
    county_name: "Adams",
    county_weights: {
      17001: 61.97,
      17169: 38.03,
    },
    county_names_all: "Adams|Schuyler",
    county_fips_all: "17001|17169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62347,
    lat: 39.86648,
    lng: -91.08905,
    city: "Liberty",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1726,
    density: 5.7,
    county_fips: 17001,
    county_name: "Adams",
    county_weights: {
      17001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 17001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62348,
    lat: 40.18836,
    lng: -91.37126,
    city: "Lima",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 85,
    density: 13.5,
    county_fips: 17001,
    county_name: "Adams",
    county_weights: {
      17001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 17001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62349,
    lat: 40.16958,
    lng: -91.19986,
    city: "Loraine",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 781,
    density: 6.5,
    county_fips: 17001,
    county_name: "Adams",
    county_weights: {
      17001: 90.47,
      17067: 9.53,
    },
    county_names_all: "Adams|Hancock",
    county_fips_all: "17001|17067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62351,
    lat: 40.11374,
    lng: -91.26751,
    city: "Mendon",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1933,
    density: 10.2,
    county_fips: 17001,
    county_name: "Adams",
    county_weights: {
      17001: 95.14,
      17067: 4.86,
    },
    county_names_all: "Adams|Hancock",
    county_fips_all: "17001|17067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62352,
    lat: 39.56818,
    lng: -90.65455,
    city: "Milton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 317,
    density: 122.1,
    county_fips: 17149,
    county_name: "Pike",
    county_weights: {
      17149: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 17149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62353,
    lat: 39.97277,
    lng: -90.75735,
    city: "Mount Sterling",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5103,
    density: 10.4,
    county_fips: 17009,
    county_name: "Brown",
    county_weights: {
      17009: 98.1,
      17149: 1.21,
      17169: 0.69,
    },
    county_names_all: "Brown|Pike|Schuyler",
    county_fips_all: "17009|17149|17169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62354,
    lat: 40.52087,
    lng: -91.33305,
    city: "Nauvoo",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1486,
    density: 15.7,
    county_fips: 17067,
    county_name: "Hancock",
    county_weights: {
      17067: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 17067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62355,
    lat: 39.40963,
    lng: -90.77936,
    city: "Nebo",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 824,
    density: 3.6,
    county_fips: 17149,
    county_name: "Pike",
    county_weights: {
      17013: 47.96,
      17149: 52.04,
    },
    county_names_all: "Pike|Calhoun",
    county_fips_all: "17149|17013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62356,
    lat: 39.60092,
    lng: -91.08508,
    city: "New Canton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 695,
    density: 4.3,
    county_fips: 17149,
    county_name: "Pike",
    county_weights: {
      17149: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 17149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62357,
    lat: 39.68671,
    lng: -90.86374,
    city: "New Salem",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 335,
    density: 6.3,
    county_fips: 17149,
    county_name: "Pike",
    county_weights: {
      17149: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 17149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62358,
    lat: 40.58527,
    lng: -91.26113,
    city: "Niota",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 612,
    density: 5.6,
    county_fips: 17067,
    county_name: "Hancock",
    county_weights: {
      17067: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 17067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62359,
    lat: 40.03239,
    lng: -91.20851,
    city: "Paloma",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 174,
    density: 19.2,
    county_fips: 17001,
    county_name: "Adams",
    county_weights: {
      17001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 17001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62360,
    lat: 39.81731,
    lng: -91.26143,
    city: "Payson",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1949,
    density: 20.2,
    county_fips: 17001,
    county_name: "Adams",
    county_weights: {
      17001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 17001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62361,
    lat: 39.48734,
    lng: -90.64191,
    city: "Pearl",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 247,
    density: 1.6,
    county_fips: 17149,
    county_name: "Pike",
    county_weights: {
      17149: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 17149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62362,
    lat: 39.77618,
    lng: -90.76429,
    city: "Perry",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 17149,
    county_name: "Pike",
    county_weights: {
      17149: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 17149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62363,
    lat: 39.59163,
    lng: -90.7784,
    city: "Pittsfield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5472,
    density: 13.7,
    county_fips: 17149,
    county_name: "Pike",
    county_weights: {
      17149: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 17149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62365,
    lat: 39.79559,
    lng: -91.16018,
    city: "Plainville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 549,
    density: 7.7,
    county_fips: 17001,
    county_name: "Adams",
    county_weights: {
      17001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 17001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62366,
    lat: 39.46253,
    lng: -90.89402,
    city: "Pleasant Hill",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1702,
    density: 9.9,
    county_fips: 17149,
    county_name: "Pike",
    county_weights: {
      17149: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 17149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62367,
    lat: 40.30325,
    lng: -90.86687,
    city: "Plymouth",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1154,
    density: 3.6,
    county_fips: 17067,
    county_name: "Hancock",
    county_weights: {
      17067: 37.69,
      17109: 34.5,
      17169: 27.81,
    },
    county_names_all: "Hancock|McDonough|Schuyler",
    county_fips_all: "17067|17109|17169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62370,
    lat: 39.51818,
    lng: -90.99881,
    city: "Rockport",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 285,
    density: 1.8,
    county_fips: 17149,
    county_name: "Pike",
    county_weights: {
      17149: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 17149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62373,
    lat: 40.23643,
    lng: -91.35863,
    city: "Sutter",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 202,
    density: 1.6,
    county_fips: 17067,
    county_name: "Hancock",
    county_weights: {
      17001: 3.48,
      17067: 96.52,
    },
    county_names_all: "Hancock|Adams",
    county_fips_all: "17067|17001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62374,
    lat: 40.40765,
    lng: -90.91052,
    city: "Tennessee",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 302,
    density: 4.8,
    county_fips: 17067,
    county_name: "Hancock",
    county_weights: {
      17067: 50.93,
      17109: 49.07,
    },
    county_names_all: "Hancock|McDonough",
    county_fips_all: "17067|17109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62375,
    lat: 39.99782,
    lng: -90.87176,
    city: "Timewell",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 568,
    density: 4.8,
    county_fips: 17009,
    county_name: "Brown",
    county_weights: {
      17009: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 17009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62376,
    lat: 40.1148,
    lng: -91.40662,
    city: "Ursa",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1065,
    density: 6.5,
    county_fips: 17001,
    county_name: "Adams",
    county_weights: {
      17001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 17001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62378,
    lat: 39.89602,
    lng: -90.63652,
    city: "Versailles",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 928,
    density: 5.4,
    county_fips: 17009,
    county_name: "Brown",
    county_weights: {
      17009: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 17009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62379,
    lat: 40.26867,
    lng: -91.4061,
    city: "Warsaw",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1800,
    density: 7,
    county_fips: 17067,
    county_name: "Hancock",
    county_weights: {
      17001: 22.8,
      17067: 77.2,
    },
    county_names_all: "Hancock|Adams",
    county_fips_all: "17067|17001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62380,
    lat: 40.24249,
    lng: -91.19174,
    city: "West Point",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 515,
    density: 5.1,
    county_fips: 17067,
    county_name: "Hancock",
    county_weights: {
      17067: 100,
    },
    county_names_all: "Hancock",
    county_fips_all: 17067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62401,
    lat: 39.11843,
    lng: -88.56467,
    city: "Effingham",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19068,
    density: 70.9,
    county_fips: 17049,
    county_name: "Effingham",
    county_weights: {
      17049: 97.24,
      17173: 2.76,
    },
    county_names_all: "Effingham|Shelby",
    county_fips_all: "17049|17173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62410,
    lat: 38.53254,
    lng: -87.72783,
    city: "Allendale",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1383,
    density: 14,
    county_fips: 17185,
    county_name: "Wabash",
    county_weights: {
      17185: 100,
    },
    county_names_all: "Wabash",
    county_fips_all: 17185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62411,
    lat: 39.06865,
    lng: -88.72936,
    city: "Altamont",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4170,
    density: 18.9,
    county_fips: 17049,
    county_name: "Effingham",
    county_weights: {
      17049: 96.63,
      17051: 3.37,
    },
    county_names_all: "Effingham|Fayette",
    county_fips_all: "17049|17051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62413,
    lat: 39.14081,
    lng: -87.84012,
    city: "Annapolis",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 299,
    density: 3.5,
    county_fips: 17033,
    county_name: "Crawford",
    county_weights: {
      17023: 9,
      17033: 91,
    },
    county_names_all: "Crawford|Clark",
    county_fips_all: "17033|17023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62414,
    lat: 39.17277,
    lng: -88.82611,
    city: "Beecher City",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1724,
    density: 8.8,
    county_fips: 17051,
    county_name: "Fayette",
    county_weights: {
      17049: 26.53,
      17051: 54.42,
      17173: 19.05,
    },
    county_names_all: "Fayette|Effingham|Shelby",
    county_fips_all: "17051|17049|17173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62417,
    lat: 38.70304,
    lng: -87.76779,
    city: "Bridgeport",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2854,
    density: 30.8,
    county_fips: 17101,
    county_name: "Lawrence",
    county_weights: {
      17101: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 17101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62418,
    lat: 39.02009,
    lng: -88.97463,
    city: "Brownstown",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2101,
    density: 8.7,
    county_fips: 17051,
    county_name: "Fayette",
    county_weights: {
      17051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 17051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62419,
    lat: 38.62201,
    lng: -87.98425,
    city: "Calhoun",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 214,
    density: 3.9,
    county_fips: 17159,
    county_name: "Richland",
    county_weights: {
      17159: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 17159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62420,
    lat: 39.29065,
    lng: -88.0005,
    city: "Casey",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4510,
    density: 14.1,
    county_fips: 17023,
    county_name: "Clark",
    county_weights: {
      17023: 56.86,
      17029: 5.49,
      17035: 36.11,
      17079: 1.54,
    },
    county_names_all: "Clark|Cumberland|Coles|Jasper",
    county_fips_all: "17023|17035|17029|17079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62421,
    lat: 38.75219,
    lng: -87.94345,
    city: "Claremont",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 536,
    density: 3.9,
    county_fips: 17159,
    county_name: "Richland",
    county_weights: {
      17033: 6.01,
      17101: 1.46,
      17159: 92.53,
    },
    county_names_all: "Richland|Crawford|Lawrence",
    county_fips_all: "17159|17033|17101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62422,
    lat: 39.23327,
    lng: -88.88855,
    city: "Cowden",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1032,
    density: 8.7,
    county_fips: 17173,
    county_name: "Shelby",
    county_weights: {
      17051: 35.09,
      17173: 64.91,
    },
    county_names_all: "Shelby|Fayette",
    county_fips_all: "17173|17051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62423,
    lat: 39.46208,
    lng: -87.5819,
    city: "Dennison",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 546,
    density: 8.7,
    county_fips: 17023,
    county_name: "Clark",
    county_weights: {
      17023: 66.56,
      17045: 33.44,
    },
    county_names_all: "Clark|Edgar",
    county_fips_all: "17023|17045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62424,
    lat: 38.98784,
    lng: -88.42124,
    city: "Dieterich",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2447,
    density: 11,
    county_fips: 17049,
    county_name: "Effingham",
    county_weights: {
      17025: 1.25,
      17049: 91.21,
      17079: 7.54,
    },
    county_names_all: "Effingham|Jasper|Clay",
    county_fips_all: "17049|17079|17025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62425,
    lat: 38.83363,
    lng: -88.10383,
    city: "Dundas",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 468,
    density: 4.5,
    county_fips: 17159,
    county_name: "Richland",
    county_weights: {
      17079: 16.87,
      17159: 83.13,
    },
    county_names_all: "Richland|Jasper",
    county_fips_all: "17159|17079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62426,
    lat: 38.8999,
    lng: -88.66639,
    city: "Edgewood",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 853,
    density: 8.1,
    county_fips: 17025,
    county_name: "Clay",
    county_weights: {
      17025: 55.79,
      17049: 31.93,
      17051: 12.28,
    },
    county_names_all: "Clay|Effingham|Fayette",
    county_fips_all: "17025|17049|17051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62427,
    lat: 38.87301,
    lng: -87.65891,
    city: "Flat Rock",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1957,
    density: 9,
    county_fips: 17033,
    county_name: "Crawford",
    county_weights: {
      17033: 76.25,
      17101: 23.75,
    },
    county_names_all: "Crawford|Lawrence",
    county_fips_all: "17033|17101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62428,
    lat: 39.26396,
    lng: -88.1302,
    city: "Greenup",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2764,
    density: 11.1,
    county_fips: 17035,
    county_name: "Cumberland",
    county_weights: {
      17035: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 17035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62431,
    lat: 39.22981,
    lng: -88.99382,
    city: "Herrick",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 903,
    density: 6.3,
    county_fips: 17173,
    county_name: "Shelby",
    county_weights: {
      17051: 37.73,
      17173: 62.27,
    },
    county_names_all: "Shelby|Fayette",
    county_fips_all: "17173|17051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62432,
    lat: 39.13353,
    lng: -88.14176,
    city: "Hidalgo",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 784,
    density: 7.4,
    county_fips: 17079,
    county_name: "Jasper",
    county_weights: {
      17035: 0.28,
      17079: 99.72,
    },
    county_names_all: "Jasper|Cumberland",
    county_fips_all: "17079|17035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62433,
    lat: 39.11276,
    lng: -87.70514,
    city: "Hutsonville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 957,
    density: 11.5,
    county_fips: 17033,
    county_name: "Crawford",
    county_weights: {
      17033: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 17033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62434,
    lat: 38.84217,
    lng: -88.3253,
    city: "Ingraham",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 283,
    density: 3.7,
    county_fips: 17025,
    county_name: "Clay",
    county_weights: {
      17025: 61.3,
      17079: 38.7,
    },
    county_names_all: "Clay|Jasper",
    county_fips_all: "17025|17079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62436,
    lat: 39.18247,
    lng: -88.25613,
    city: "Jewett",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 600,
    density: 9.7,
    county_fips: 17035,
    county_name: "Cumberland",
    county_weights: {
      17035: 61.86,
      17079: 38.14,
    },
    county_names_all: "Cumberland|Jasper",
    county_fips_all: "17035|17079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62438,
    lat: 39.32553,
    lng: -88.87005,
    city: "Lakewood",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 331,
    density: 5.5,
    county_fips: 17173,
    county_name: "Shelby",
    county_weights: {
      17173: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 17173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62439,
    lat: 38.74668,
    lng: -87.63754,
    city: "Lawrenceville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7143,
    density: 18.6,
    county_fips: 17101,
    county_name: "Lawrence",
    county_weights: {
      17101: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 17101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62440,
    lat: 39.39433,
    lng: -88.26325,
    city: "Lerna",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1155,
    density: 11,
    county_fips: 17029,
    county_name: "Coles",
    county_weights: {
      17029: 73.84,
      17035: 26.16,
    },
    county_names_all: "Coles|Cumberland",
    county_fips_all: "17029|17035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62441,
    lat: 39.39392,
    lng: -87.69795,
    city: "Marshall",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6953,
    density: 15.2,
    county_fips: 17023,
    county_name: "Clark",
    county_weights: {
      17023: 96.37,
      17045: 3.63,
    },
    county_names_all: "Clark|Edgar",
    county_fips_all: "17023|17045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62442,
    lat: 39.31269,
    lng: -87.85602,
    city: "Martinsville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2763,
    density: 7.6,
    county_fips: 17023,
    county_name: "Clark",
    county_weights: {
      17023: 97.92,
      17033: 2.08,
    },
    county_names_all: "Clark|Crawford",
    county_fips_all: "17023|17033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62443,
    lat: 38.95397,
    lng: -88.62902,
    city: "Mason",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1618,
    density: 8,
    county_fips: 17049,
    county_name: "Effingham",
    county_weights: {
      17025: 10.59,
      17049: 89.41,
    },
    county_names_all: "Effingham|Clay",
    county_fips_all: "17049|17025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62444,
    lat: 39.27853,
    lng: -88.73474,
    city: "Mode",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 396,
    density: 5.4,
    county_fips: 17173,
    county_name: "Shelby",
    county_weights: {
      17173: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 17173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62445,
    lat: 39.16687,
    lng: -88.32322,
    city: "Montrose",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1143,
    density: 9.6,
    county_fips: 17079,
    county_name: "Jasper",
    county_weights: {
      17035: 42.56,
      17049: 10.58,
      17079: 46.86,
    },
    county_names_all: "Jasper|Cumberland|Effingham",
    county_fips_all: "17079|17035|17049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62446,
    lat: 38.49115,
    lng: -88.21478,
    city: "Mount Erie",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 375,
    density: 2.3,
    county_fips: 17191,
    county_name: "Wayne",
    county_weights: {
      17191: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 17191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62447,
    lat: 39.31303,
    lng: -88.44456,
    city: "Neoga",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3428,
    density: 21.7,
    county_fips: 17035,
    county_name: "Cumberland",
    county_weights: {
      17035: 68.75,
      17173: 31.25,
    },
    county_names_all: "Cumberland|Shelby",
    county_fips_all: "17035|17173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62448,
    lat: 38.96741,
    lng: -88.17988,
    city: "Newton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5417,
    density: 10.2,
    county_fips: 17079,
    county_name: "Jasper",
    county_weights: {
      17025: 1.09,
      17079: 96.63,
      17159: 2.28,
    },
    county_names_all: "Jasper|Richland|Clay",
    county_fips_all: "17079|17159|17025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62449,
    lat: 39.00419,
    lng: -87.91069,
    city: "Oblong",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3069,
    density: 9.9,
    county_fips: 17033,
    county_name: "Crawford",
    county_weights: {
      17023: 1,
      17033: 81.46,
      17079: 17.54,
    },
    county_names_all: "Crawford|Jasper|Clark",
    county_fips_all: "17033|17079|17023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62450,
    lat: 38.71436,
    lng: -88.08777,
    city: "Olney",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12274,
    density: 30.1,
    county_fips: 17159,
    county_name: "Richland",
    county_weights: {
      17159: 99.46,
      17191: 0.54,
    },
    county_names_all: "Richland|Wayne",
    county_fips_all: "17159|17191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62451,
    lat: 38.99394,
    lng: -87.6066,
    city: "Palestine",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2005,
    density: 12.3,
    county_fips: 17033,
    county_name: "Crawford",
    county_weights: {
      17033: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 17033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62452,
    lat: 38.58715,
    lng: -88.01774,
    city: "Parkersburg",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 262,
    density: 4.8,
    county_fips: 17159,
    county_name: "Richland",
    county_weights: {
      17159: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 17159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62454,
    lat: 38.99725,
    lng: -87.75767,
    city: "Robinson",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10788,
    density: 33.7,
    county_fips: 17033,
    county_name: "Crawford",
    county_weights: {
      17033: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 17033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62458,
    lat: 39.02531,
    lng: -88.85441,
    city: "Saint Elmo",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2266,
    density: 14.7,
    county_fips: 17051,
    county_name: "Fayette",
    county_weights: {
      17049: 12.25,
      17051: 87.75,
    },
    county_names_all: "Fayette|Effingham",
    county_fips_all: "17051|17049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62459,
    lat: 38.92997,
    lng: -88.0278,
    city: "Sainte Marie",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 358,
    density: 125.8,
    county_fips: 17079,
    county_name: "Jasper",
    county_weights: {
      17079: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 17079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62460,
    lat: 38.60661,
    lng: -87.69639,
    city: "Saint Francisville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1030,
    density: 9.2,
    county_fips: 17101,
    county_name: "Lawrence",
    county_weights: {
      17101: 98.21,
      17185: 1.79,
    },
    county_names_all: "Lawrence|Wabash",
    county_fips_all: "17101|17185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62461,
    lat: 39.20067,
    lng: -88.6759,
    city: "Shumway",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 688,
    density: 6.4,
    county_fips: 17049,
    county_name: "Effingham",
    county_weights: {
      17049: 70.69,
      17173: 29.31,
    },
    county_names_all: "Effingham|Shelby",
    county_fips_all: "17049|17173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62462,
    lat: 39.23291,
    lng: -88.47066,
    city: "Sigel",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1266,
    density: 12.3,
    county_fips: 17173,
    county_name: "Shelby",
    county_weights: {
      17035: 49.76,
      17049: 0.3,
      17173: 49.93,
    },
    county_names_all: "Shelby|Cumberland|Effingham",
    county_fips_all: "17173|17035|17049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62463,
    lat: 39.27519,
    lng: -88.59683,
    city: "Stewardson",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1076,
    density: 10.7,
    county_fips: 17173,
    county_name: "Shelby",
    county_weights: {
      17173: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 17173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62464,
    lat: 38.99793,
    lng: -87.82385,
    city: "Stoy",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 17033,
    county_name: "Crawford",
    county_weights: {
      17033: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 17033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62465,
    lat: 39.34614,
    lng: -88.63827,
    city: "Strasburg",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 873,
    density: 8,
    county_fips: 17173,
    county_name: "Shelby",
    county_weights: {
      17173: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 17173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62466,
    lat: 38.72707,
    lng: -87.84957,
    city: "Sumner",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4631,
    density: 12.8,
    county_fips: 17101,
    county_name: "Lawrence",
    county_weights: {
      17033: 8.75,
      17101: 88.88,
      17159: 2.37,
    },
    county_names_all: "Lawrence|Crawford|Richland",
    county_fips_all: "17101|17033|17159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62467,
    lat: 39.12809,
    lng: -88.43543,
    city: "Teutopolis",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4168,
    density: 27.7,
    county_fips: 17049,
    county_name: "Effingham",
    county_weights: {
      17035: 9.15,
      17049: 80.37,
      17079: 10.48,
    },
    county_names_all: "Effingham|Jasper|Cumberland",
    county_fips_all: "17049|17079|17035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62468,
    lat: 39.27779,
    lng: -88.27155,
    city: "Toledo",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2383,
    density: 12.4,
    county_fips: 17035,
    county_name: "Cumberland",
    county_weights: {
      17035: 100,
    },
    county_names_all: "Cumberland",
    county_fips_all: 17035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62469,
    lat: 39.34843,
    lng: -88.33911,
    city: "Trilla",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 533,
    density: 10,
    county_fips: 17035,
    county_name: "Cumberland",
    county_weights: {
      17029: 15.04,
      17035: 84.96,
    },
    county_names_all: "Cumberland|Coles",
    county_fips_all: "17035|17029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62471,
    lat: 38.95859,
    lng: -89.13257,
    city: "Vandalia",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10330,
    density: 31.1,
    county_fips: 17051,
    county_name: "Fayette",
    county_weights: {
      17051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 17051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62473,
    lat: 39.01986,
    lng: -88.56556,
    city: "Watson",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1194,
    density: 21.1,
    county_fips: 17049,
    county_name: "Effingham",
    county_weights: {
      17049: 100,
    },
    county_names_all: "Effingham",
    county_fips_all: 17049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62474,
    lat: 39.43526,
    lng: -87.99462,
    city: "Westfield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 719,
    density: 7.7,
    county_fips: 17023,
    county_name: "Clark",
    county_weights: {
      17023: 63.55,
      17029: 36.45,
    },
    county_names_all: "Clark|Coles",
    county_fips_all: "17023|17029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62475,
    lat: 38.88441,
    lng: -88.04645,
    city: "West Liberty",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 583,
    density: 9.6,
    county_fips: 17079,
    county_name: "Jasper",
    county_weights: {
      17079: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 17079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62476,
    lat: 38.53412,
    lng: -88.00509,
    city: "West Salem",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1539,
    density: 7.7,
    county_fips: 17047,
    county_name: "Edwards",
    county_weights: {
      17047: 68.66,
      17101: 1.27,
      17159: 0.76,
      17185: 29.31,
    },
    county_names_all: "Edwards|Wabash|Lawrence|Richland",
    county_fips_all: "17047|17185|17101|17159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62477,
    lat: 39.23369,
    lng: -87.66024,
    city: "West Union",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 597,
    density: 3.9,
    county_fips: 17023,
    county_name: "Clark",
    county_weights: {
      17023: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 17023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62478,
    lat: 39.17874,
    lng: -87.74367,
    city: "West York",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 276,
    density: 3.7,
    county_fips: 17023,
    county_name: "Clark",
    county_weights: {
      17023: 53.69,
      17033: 46.31,
    },
    county_names_all: "Clark|Crawford",
    county_fips_all: "17023|17033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62479,
    lat: 39.03731,
    lng: -88.31239,
    city: "Wheeler",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 874,
    density: 6.3,
    county_fips: 17079,
    county_name: "Jasper",
    county_weights: {
      17049: 1.91,
      17079: 98.09,
    },
    county_names_all: "Jasper|Effingham",
    county_fips_all: "17079|17049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62480,
    lat: 38.99864,
    lng: -88.00129,
    city: "Willow Hill",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 607,
    density: 4,
    county_fips: 17079,
    county_name: "Jasper",
    county_weights: {
      17079: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 17079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62481,
    lat: 39.12657,
    lng: -88.02293,
    city: "Yale",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 344,
    density: 3.8,
    county_fips: 17079,
    county_name: "Jasper",
    county_weights: {
      17079: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 17079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62501,
    lat: 39.92973,
    lng: -88.80528,
    city: "Argenta",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2496,
    density: 12.5,
    county_fips: 17115,
    county_name: "Macon",
    county_weights: {
      17115: 100,
    },
    county_names_all: "Macon",
    county_fips_all: 17115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62510,
    lat: 39.5315,
    lng: -89.02706,
    city: "Assumption",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1554,
    density: 7.8,
    county_fips: 17021,
    county_name: "Christian",
    county_weights: {
      17021: 51.26,
      17173: 48.74,
    },
    county_names_all: "Christian|Shelby",
    county_fips_all: "17021|17173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62512,
    lat: 40.14601,
    lng: -89.20312,
    city: "Beason",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 463,
    density: 3.8,
    county_fips: 17107,
    county_name: "Logan",
    county_weights: {
      17039: 2.2,
      17107: 97.8,
    },
    county_names_all: "Logan|De Witt",
    county_fips_all: "17107|17039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62513,
    lat: 39.72341,
    lng: -89.15296,
    city: "Blue Mound",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1658,
    density: 9.4,
    county_fips: 17021,
    county_name: "Christian",
    county_weights: {
      17021: 52.2,
      17115: 47.8,
    },
    county_names_all: "Christian|Macon",
    county_fips_all: "17021|17115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62514,
    lat: 39.76753,
    lng: -89.04508,
    city: "Boody",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 389,
    density: 158.6,
    county_fips: 17115,
    county_name: "Macon",
    county_weights: {
      17115: 100,
    },
    county_names_all: "Macon",
    county_fips_all: 17115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62515,
    lat: 39.8561,
    lng: -89.36622,
    city: "Buffalo",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1022,
    density: 6.9,
    county_fips: 17167,
    county_name: "Sangamon",
    county_weights: {
      17167: 100,
    },
    county_names_all: "Sangamon",
    county_fips_all: 17167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62517,
    lat: 39.59365,
    lng: -89.43285,
    city: "Bulpitt",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 236,
    density: 189.5,
    county_fips: 17021,
    county_name: "Christian",
    county_weights: {
      17021: 100,
    },
    county_names_all: "Christian",
    county_fips_all: 17021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62518,
    lat: 40.05154,
    lng: -89.19037,
    city: "Chestnut",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 96,
    density: 1.5,
    county_fips: 17107,
    county_name: "Logan",
    county_weights: {
      17107: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 17107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62519,
    lat: 39.92879,
    lng: -89.3953,
    city: "Cornland",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 71,
    density: 18.2,
    county_fips: 17107,
    county_name: "Logan",
    county_weights: {
      17107: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 17107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62520,
    lat: 39.82185,
    lng: -89.45904,
    city: "Dawson",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1646,
    density: 24.6,
    county_fips: 17167,
    county_name: "Sangamon",
    county_weights: {
      17167: 100,
    },
    county_names_all: "Sangamon",
    county_fips_all: 17167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62521,
    lat: 39.81435,
    lng: -88.93086,
    city: "Decatur",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34716,
    density: 203.2,
    county_fips: 17115,
    county_name: "Macon",
    county_weights: {
      17115: 100,
    },
    county_names_all: "Macon",
    county_fips_all: 17115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62522,
    lat: 39.83008,
    lng: -89.04743,
    city: "Decatur",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15256,
    density: 246,
    county_fips: 17115,
    county_name: "Macon",
    county_weights: {
      17115: 100,
    },
    county_names_all: "Macon",
    county_fips_all: 17115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62523,
    lat: 39.84372,
    lng: -88.95289,
    city: "Decatur",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1183,
    density: 1022.4,
    county_fips: 17115,
    county_name: "Macon",
    county_weights: {
      17115: 100,
    },
    county_names_all: "Macon",
    county_fips_all: 17115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62526,
    lat: 39.90322,
    lng: -88.9902,
    city: "Decatur",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30627,
    density: 179.3,
    county_fips: 17115,
    county_name: "Macon",
    county_weights: {
      17115: 100,
    },
    county_names_all: "Macon",
    county_fips_all: 17115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62530,
    lat: 39.56206,
    lng: -89.65626,
    city: "Divernon",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1397,
    density: 20.3,
    county_fips: 17167,
    county_name: "Sangamon",
    county_weights: {
      17167: 100,
    },
    county_names_all: "Sangamon",
    county_fips_all: 17167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62531,
    lat: 39.66754,
    lng: -89.37395,
    city: "Edinburg",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1707,
    density: 10.8,
    county_fips: 17021,
    county_name: "Christian",
    county_weights: {
      17021: 100,
    },
    county_names_all: "Christian",
    county_fips_all: 17021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62532,
    lat: 39.77633,
    lng: -88.97781,
    city: "Elwin",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 71,
    density: 32.9,
    county_fips: 17115,
    county_name: "Macon",
    county_weights: {
      17115: 100,
    },
    county_names_all: "Macon",
    county_fips_all: 17115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62533,
    lat: 39.44483,
    lng: -89.626,
    city: "Farmersville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 965,
    density: 7.8,
    county_fips: 17135,
    county_name: "Montgomery",
    county_weights: {
      17135: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 17135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62534,
    lat: 39.53519,
    lng: -88.79603,
    city: "Findlay",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1208,
    density: 8.4,
    county_fips: 17173,
    county_name: "Shelby",
    county_weights: {
      17139: 0.25,
      17173: 99.75,
    },
    county_names_all: "Shelby|Moultrie",
    county_fips_all: "17173|17139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62535,
    lat: 39.92549,
    lng: -88.96604,
    city: "Forsyth",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3429,
    density: 363.9,
    county_fips: 17115,
    county_name: "Macon",
    county_weights: {
      17115: 100,
    },
    county_names_all: "Macon",
    county_fips_all: 17115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62536,
    lat: 39.63022,
    lng: -89.65023,
    city: "Glenarm",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 480,
    density: 24.1,
    county_fips: 17167,
    county_name: "Sangamon",
    county_weights: {
      17167: 100,
    },
    county_names_all: "Sangamon",
    county_fips_all: 17167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62537,
    lat: 39.85263,
    lng: -89.09324,
    city: "Harristown",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 99,
    density: 34.8,
    county_fips: 17115,
    county_name: "Macon",
    county_weights: {
      17115: 100,
    },
    county_names_all: "Macon",
    county_fips_all: 17115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62538,
    lat: 39.35631,
    lng: -89.52051,
    city: "Harvel",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 514,
    density: 5.8,
    county_fips: 17135,
    county_name: "Montgomery",
    county_weights: {
      17021: 19.3,
      17135: 80.7,
    },
    county_names_all: "Montgomery|Christian",
    county_fips_all: "17135|17021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62539,
    lat: 39.86681,
    lng: -89.24914,
    city: "Illiopolis",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1178,
    density: 9.8,
    county_fips: 17167,
    county_name: "Sangamon",
    county_weights: {
      17115: 23.15,
      17167: 76.85,
    },
    county_names_all: "Sangamon|Macon",
    county_fips_all: "17167|17115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62540,
    lat: 39.58496,
    lng: -89.41938,
    city: "Kincaid",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1449,
    density: 263.2,
    county_fips: 17021,
    county_name: "Christian",
    county_weights: {
      17021: 100,
    },
    county_names_all: "Christian",
    county_fips_all: 17021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62541,
    lat: 39.95657,
    lng: -89.37085,
    city: "Lake Fork",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16,
    density: 2.7,
    county_fips: 17107,
    county_name: "Logan",
    county_weights: {
      17107: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 17107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62543,
    lat: 39.97084,
    lng: -89.1518,
    city: "Latham",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 425,
    density: 8,
    county_fips: 17107,
    county_name: "Logan",
    county_weights: {
      17107: 65.12,
      17115: 34.88,
    },
    county_names_all: "Logan|Macon",
    county_fips_all: "17107|17115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62544,
    lat: 39.70854,
    lng: -88.97375,
    city: "Macon",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1663,
    density: 9.4,
    county_fips: 17115,
    county_name: "Macon",
    county_weights: {
      17115: 100,
    },
    county_names_all: "Macon",
    county_fips_all: 17115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62545,
    lat: 39.7661,
    lng: -89.38737,
    city: "Mechanicsburg",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1318,
    density: 18.9,
    county_fips: 17167,
    county_name: "Sangamon",
    county_weights: {
      17021: 35.31,
      17167: 64.69,
    },
    county_names_all: "Sangamon|Christian",
    county_fips_all: "17167|17021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62546,
    lat: 39.43042,
    lng: -89.44281,
    city: "Morrisonville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1589,
    density: 5.4,
    county_fips: 17021,
    county_name: "Christian",
    county_weights: {
      17021: 89.39,
      17135: 10.61,
    },
    county_names_all: "Christian|Montgomery",
    county_fips_all: "17021|17135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62547,
    lat: 39.76883,
    lng: -89.24929,
    city: "Mount Auburn",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 960,
    density: 8.9,
    county_fips: 17021,
    county_name: "Christian",
    county_weights: {
      17021: 96.26,
      17115: 3.74,
    },
    county_names_all: "Christian|Macon",
    county_fips_all: "17021|17115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62548,
    lat: 39.97849,
    lng: -89.27988,
    city: "Mount Pulaski",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2388,
    density: 10.8,
    county_fips: 17107,
    county_name: "Logan",
    county_weights: {
      17107: 98.69,
      17167: 1.31,
    },
    county_names_all: "Logan|Sangamon",
    county_fips_all: "17107|17167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62549,
    lat: 39.76985,
    lng: -88.8657,
    city: "Mt Zion",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6229,
    density: 297.5,
    county_fips: 17115,
    county_name: "Macon",
    county_weights: {
      17115: 100,
    },
    county_names_all: "Macon",
    county_fips_all: 17115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62550,
    lat: 39.61154,
    lng: -88.99283,
    city: "Moweaqua",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3224,
    density: 13.9,
    county_fips: 17173,
    county_name: "Shelby",
    county_weights: {
      17021: 33.84,
      17115: 6.56,
      17173: 59.6,
    },
    county_names_all: "Shelby|Christian|Macon",
    county_fips_all: "17173|17021|17115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62551,
    lat: 39.85357,
    lng: -89.15631,
    city: "Niantic",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 823,
    density: 12.1,
    county_fips: 17115,
    county_name: "Macon",
    county_weights: {
      17115: 100,
    },
    county_names_all: "Macon",
    county_fips_all: 17115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62553,
    lat: 39.27182,
    lng: -89.10509,
    city: "Oconee",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 377,
    density: 4,
    county_fips: 17173,
    county_name: "Shelby",
    county_weights: {
      17135: 19.53,
      17173: 80.47,
    },
    county_names_all: "Shelby|Montgomery",
    county_fips_all: "17173|17135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62554,
    lat: 39.94976,
    lng: -88.87107,
    city: "Oreana",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1566,
    density: 33.4,
    county_fips: 17115,
    county_name: "Macon",
    county_weights: {
      17115: 100,
    },
    county_names_all: "Macon",
    county_fips_all: 17115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62555,
    lat: 39.46755,
    lng: -89.21982,
    city: "Owaneco",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 475,
    density: 4.9,
    county_fips: 17021,
    county_name: "Christian",
    county_weights: {
      17021: 100,
    },
    county_names_all: "Christian",
    county_fips_all: 17021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62556,
    lat: 39.46674,
    lng: -89.37049,
    city: "Palmer",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 370,
    density: 6.2,
    county_fips: 17021,
    county_name: "Christian",
    county_weights: {
      17021: 100,
    },
    county_names_all: "Christian",
    county_fips_all: 17021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62557,
    lat: 39.39974,
    lng: -89.10503,
    city: "Pana",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7087,
    density: 23.4,
    county_fips: 17021,
    county_name: "Christian",
    county_weights: {
      17021: 73.64,
      17135: 5,
      17173: 21.36,
    },
    county_names_all: "Christian|Shelby|Montgomery",
    county_fips_all: "17021|17173|17135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62558,
    lat: 39.58967,
    lng: -89.54239,
    city: "Pawnee",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3295,
    density: 13.6,
    county_fips: 17167,
    county_name: "Sangamon",
    county_weights: {
      17021: 39.9,
      17135: 8.87,
      17167: 51.23,
    },
    county_names_all: "Sangamon|Christian|Montgomery",
    county_fips_all: "17167|17021|17135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62560,
    lat: 39.3005,
    lng: -89.60377,
    city: "Raymond",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1154,
    density: 6.9,
    county_fips: 17135,
    county_name: "Montgomery",
    county_weights: {
      17117: 11.21,
      17135: 88.79,
    },
    county_names_all: "Montgomery|Macoupin",
    county_fips_all: "17135|17117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62561,
    lat: 39.86754,
    lng: -89.50498,
    city: "Riverton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5289,
    density: 88.1,
    county_fips: 17167,
    county_name: "Sangamon",
    county_weights: {
      17167: 100,
    },
    county_names_all: "Sangamon",
    county_fips_all: 17167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62563,
    lat: 39.71675,
    lng: -89.50017,
    city: "Rochester",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5653,
    density: 36.7,
    county_fips: 17167,
    county_name: "Sangamon",
    county_weights: {
      17021: 4.13,
      17167: 95.87,
    },
    county_names_all: "Sangamon|Christian",
    county_fips_all: "17167|17021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62565,
    lat: 39.41334,
    lng: -88.8026,
    city: "Shelbyville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7162,
    density: 21.8,
    county_fips: 17173,
    county_name: "Shelby",
    county_weights: {
      17173: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 17173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62567,
    lat: 39.64668,
    lng: -89.19082,
    city: "Stonington",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 809,
    density: 7.9,
    county_fips: 17021,
    county_name: "Christian",
    county_weights: {
      17021: 100,
    },
    county_names_all: "Christian",
    county_fips_all: 17021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62568,
    lat: 39.55974,
    lng: -89.29016,
    city: "Taylorville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15532,
    density: 48.1,
    county_fips: 17021,
    county_name: "Christian",
    county_weights: {
      17021: 100,
    },
    county_names_all: "Christian",
    county_fips_all: 17021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62570,
    lat: 39.58023,
    lng: -89.45107,
    city: "Tovey",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 582,
    density: 156.9,
    county_fips: 17021,
    county_name: "Christian",
    county_weights: {
      17021: 100,
    },
    county_names_all: "Christian",
    county_fips_all: 17021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62571,
    lat: 39.38155,
    lng: -88.95998,
    city: "Tower Hill",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1650,
    density: 9.1,
    county_fips: 17173,
    county_name: "Shelby",
    county_weights: {
      17173: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 17173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62572,
    lat: 39.35908,
    lng: -89.69778,
    city: "Waggoner",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 509,
    density: 4.9,
    county_fips: 17135,
    county_name: "Montgomery",
    county_weights: {
      17117: 49.09,
      17135: 50.91,
    },
    county_names_all: "Montgomery|Macoupin",
    county_fips_all: "17135|17117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62573,
    lat: 39.94551,
    lng: -89.07264,
    city: "Warrensburg",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1540,
    density: 14.2,
    county_fips: 17115,
    county_name: "Macon",
    county_weights: {
      17115: 100,
    },
    county_names_all: "Macon",
    county_fips_all: 17115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62601,
    lat: 39.75032,
    lng: -90.03904,
    city: "Alexander",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 271,
    density: 2.4,
    county_fips: 17137,
    county_name: "Morgan",
    county_weights: {
      17137: 100,
    },
    county_names_all: "Morgan",
    county_fips_all: 17137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62610,
    lat: 39.5526,
    lng: -90.42708,
    city: "Alsey",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 17171,
    county_name: "Scott",
    county_weights: {
      17171: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 17171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62611,
    lat: 39.88493,
    lng: -90.39984,
    city: "Arenzville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1222,
    density: 6.5,
    county_fips: 17017,
    county_name: "Cass",
    county_weights: {
      17017: 66.36,
      17137: 33.64,
    },
    county_names_all: "Cass|Morgan",
    county_fips_all: "17017|17137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62612,
    lat: 39.89864,
    lng: -90.0683,
    city: "Ashland",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1590,
    density: 6.6,
    county_fips: 17017,
    county_name: "Cass",
    county_weights: {
      17017: 61.88,
      17137: 38.12,
    },
    county_names_all: "Cass|Morgan",
    county_fips_all: "17017|17137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62613,
    lat: 39.99009,
    lng: -89.67036,
    city: "Athens",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4024,
    density: 24.6,
    county_fips: 17129,
    county_name: "Menard",
    county_weights: {
      17107: 7.24,
      17129: 85.44,
      17167: 7.32,
    },
    county_names_all: "Menard|Sangamon|Logan",
    county_fips_all: "17129|17167|17107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62615,
    lat: 39.58568,
    lng: -89.75406,
    city: "Auburn",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5739,
    density: 44.9,
    county_fips: 17167,
    county_name: "Sangamon",
    county_weights: {
      17167: 100,
    },
    county_names_all: "Sangamon",
    county_fips_all: 17167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62617,
    lat: 40.14948,
    lng: -90.18109,
    city: "Bath",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 538,
    density: 3.4,
    county_fips: 17125,
    county_name: "Mason",
    county_weights: {
      17125: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 17125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62618,
    lat: 40.00534,
    lng: -90.39542,
    city: "Beardstown",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6966,
    density: 26.7,
    county_fips: 17017,
    county_name: "Cass",
    county_weights: {
      17017: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 17017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62621,
    lat: 39.73174,
    lng: -90.5309,
    city: "Bluffs",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1199,
    density: 9.4,
    county_fips: 17171,
    county_name: "Scott",
    county_weights: {
      17137: 7.01,
      17171: 92.99,
    },
    county_names_all: "Scott|Morgan",
    county_fips_all: "17171|17137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62622,
    lat: 39.97786,
    lng: -90.34302,
    city: "Bluff Springs",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 17017,
    county_name: "Cass",
    county_weights: {
      17017: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 17017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62624,
    lat: 40.14993,
    lng: -90.34478,
    city: "Browning",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 417,
    density: 3.6,
    county_fips: 17169,
    county_name: "Schuyler",
    county_weights: {
      17169: 100,
    },
    county_names_all: "Schuyler",
    county_fips_all: 17169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62625,
    lat: 39.90424,
    lng: -89.70185,
    city: "Cantrall",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 808,
    density: 15.9,
    county_fips: 17167,
    county_name: "Sangamon",
    county_weights: {
      17167: 100,
    },
    county_names_all: "Sangamon",
    county_fips_all: 17167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62626,
    lat: 39.28459,
    lng: -89.88362,
    city: "Carlinville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7605,
    density: 17.2,
    county_fips: 17117,
    county_name: "Macoupin",
    county_weights: {
      17117: 100,
    },
    county_names_all: "Macoupin",
    county_fips_all: 17117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62627,
    lat: 40.05425,
    lng: -90.12887,
    city: "Chandlerville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 980,
    density: 4.5,
    county_fips: 17017,
    county_name: "Cass",
    county_weights: {
      17017: 61.15,
      17125: 38.85,
    },
    county_names_all: "Cass|Mason",
    county_fips_all: "17017|17125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62628,
    lat: 39.7794,
    lng: -90.40199,
    city: "Chapin",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 831,
    density: 8.2,
    county_fips: 17137,
    county_name: "Morgan",
    county_weights: {
      17137: 87.26,
      17171: 12.74,
    },
    county_names_all: "Morgan|Scott",
    county_fips_all: "17137|17171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62629,
    lat: 39.67858,
    lng: -89.71978,
    city: "Chatham",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14831,
    density: 164.1,
    county_fips: 17167,
    county_name: "Sangamon",
    county_weights: {
      17167: 100,
    },
    county_names_all: "Sangamon",
    county_fips_all: 17167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62630,
    lat: 39.26255,
    lng: -90.08315,
    city: "Chesterfield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 623,
    density: 5.9,
    county_fips: 17117,
    county_name: "Macoupin",
    county_weights: {
      17061: 5.55,
      17117: 94.45,
    },
    county_names_all: "Macoupin|Greene",
    county_fips_all: "17117|17061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62631,
    lat: 39.82531,
    lng: -90.36122,
    city: "Concord",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 274,
    density: 8.2,
    county_fips: 17137,
    county_name: "Morgan",
    county_weights: {
      17137: 100,
    },
    county_names_all: "Morgan",
    county_fips_all: 17137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62633,
    lat: 40.22577,
    lng: -89.8763,
    city: "Easton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 611,
    density: 3.5,
    county_fips: 17125,
    county_name: "Mason",
    county_weights: {
      17125: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 17125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62634,
    lat: 40.0166,
    lng: -89.45107,
    city: "Elkhart",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1037,
    density: 7.5,
    county_fips: 17107,
    county_name: "Logan",
    county_weights: {
      17107: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 17107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62635,
    lat: 40.29653,
    lng: -89.46573,
    city: "Emden",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 538,
    density: 5.1,
    county_fips: 17107,
    county_name: "Logan",
    county_weights: {
      17107: 91.17,
      17179: 8.83,
    },
    county_names_all: "Logan|Tazewell",
    county_fips_all: "17107|17179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62638,
    lat: 39.60714,
    lng: -90.08226,
    city: "Franklin",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1372,
    density: 7.8,
    county_fips: 17137,
    county_name: "Morgan",
    county_weights: {
      17117: 4.32,
      17137: 95.68,
    },
    county_names_all: "Morgan|Macoupin",
    county_fips_all: "17137|17117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62639,
    lat: 40.0435,
    lng: -90.48753,
    city: "Frederick",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 274,
    density: 3,
    county_fips: 17169,
    county_name: "Schuyler",
    county_weights: {
      17169: 100,
    },
    county_names_all: "Schuyler",
    county_fips_all: 17169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62640,
    lat: 39.43183,
    lng: -89.80746,
    city: "Girard",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3273,
    density: 16.9,
    county_fips: 17117,
    county_name: "Macoupin",
    county_weights: {
      17117: 96.93,
      17135: 3.07,
    },
    county_names_all: "Macoupin|Montgomery",
    county_fips_all: "17117|17135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62642,
    lat: 40.09022,
    lng: -89.71303,
    city: "Greenview",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1346,
    density: 7.1,
    county_fips: 17129,
    county_name: "Menard",
    county_weights: {
      17129: 100,
    },
    county_names_all: "Menard",
    county_fips_all: 17129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62643,
    lat: 40.24154,
    lng: -89.45774,
    city: "Hartsburg",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 738,
    density: 8.1,
    county_fips: 17107,
    county_name: "Logan",
    county_weights: {
      17107: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 17107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62644,
    lat: 40.28553,
    lng: -90.06022,
    city: "Havana",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4814,
    density: 19.3,
    county_fips: 17125,
    county_name: "Mason",
    county_weights: {
      17057: 30.27,
      17125: 69.73,
    },
    county_names_all: "Mason|Fulton",
    county_fips_all: "17125|17057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62649,
    lat: 39.36451,
    lng: -90.0664,
    city: "Hettick",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 479,
    density: 4.8,
    county_fips: 17117,
    county_name: "Macoupin",
    county_weights: {
      17117: 100,
    },
    county_names_all: "Macoupin",
    county_fips_all: 17117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62650,
    lat: 39.73799,
    lng: -90.22027,
    city: "Jacksonville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26008,
    density: 50.8,
    county_fips: 17137,
    county_name: "Morgan",
    county_weights: {
      17137: 98.17,
      17171: 1.83,
    },
    county_names_all: "Morgan|Scott",
    county_fips_all: "17137|17171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62655,
    lat: 40.16523,
    lng: -89.99515,
    city: "Kilbourne",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 599,
    density: 3.9,
    county_fips: 17125,
    county_name: "Mason",
    county_weights: {
      17125: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 17125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62656,
    lat: 40.13948,
    lng: -89.36622,
    city: "Lincoln",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19113,
    density: 51.7,
    county_fips: 17107,
    county_name: "Logan",
    county_weights: {
      17107: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 17107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62661,
    lat: 39.66513,
    lng: -89.84057,
    city: "Loami",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1512,
    density: 15.4,
    county_fips: 17167,
    county_name: "Sangamon",
    county_weights: {
      17167: 100,
    },
    county_names_all: "Sangamon",
    county_fips_all: 17167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62663,
    lat: 39.54106,
    lng: -90.32748,
    city: "Manchester",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 220,
    density: 123.3,
    county_fips: 17171,
    county_name: "Scott",
    county_weights: {
      17171: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 17171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62664,
    lat: 40.21106,
    lng: -89.72629,
    city: "Mason City",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3159,
    density: 11.4,
    county_fips: 17125,
    county_name: "Mason",
    county_weights: {
      17125: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 17125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62665,
    lat: 39.81627,
    lng: -90.53462,
    city: "Meredosia",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1501,
    density: 12.9,
    county_fips: 17137,
    county_name: "Morgan",
    county_weights: {
      17137: 75.1,
      17171: 24.9,
    },
    county_names_all: "Morgan|Scott",
    county_fips_all: "17137|17171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62666,
    lat: 40.08384,
    lng: -89.54364,
    city: "Middletown",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 487,
    density: 6,
    county_fips: 17107,
    county_name: "Logan",
    county_weights: {
      17107: 76.84,
      17129: 23.16,
    },
    county_names_all: "Logan|Menard",
    county_fips_all: "17107|17129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62667,
    lat: 39.49372,
    lng: -89.99016,
    city: "Modesto",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 585,
    density: 6.2,
    county_fips: 17117,
    county_name: "Macoupin",
    county_weights: {
      17117: 94.89,
      17137: 5.11,
    },
    county_names_all: "Macoupin|Morgan",
    county_fips_all: "17117|17137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62668,
    lat: 39.57474,
    lng: -90.23667,
    city: "Murrayville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1418,
    density: 7.8,
    county_fips: 17137,
    county_name: "Morgan",
    county_weights: {
      17137: 87.12,
      17171: 12.88,
    },
    county_names_all: "Morgan|Scott",
    county_fips_all: "17137|17171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62670,
    lat: 39.74431,
    lng: -89.89601,
    city: "New Berlin",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2585,
    density: 10.9,
    county_fips: 17167,
    county_name: "Sangamon",
    county_weights: {
      17137: 7.91,
      17167: 92.09,
    },
    county_names_all: "Sangamon|Morgan",
    county_fips_all: "17167|17137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62671,
    lat: 40.16707,
    lng: -89.55755,
    city: "New Holland",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 519,
    density: 4,
    county_fips: 17107,
    county_name: "Logan",
    county_weights: {
      17107: 89.55,
      17125: 10.45,
    },
    county_names_all: "Logan|Mason",
    county_fips_all: "17107|17125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62672,
    lat: 39.39802,
    lng: -89.80444,
    city: "Nilwood",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 188,
    density: 99,
    county_fips: 17117,
    county_name: "Macoupin",
    county_weights: {
      17117: 100,
    },
    county_names_all: "Macoupin",
    county_fips_all: 17117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62673,
    lat: 40.09586,
    lng: -89.9674,
    city: "Oakford",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 366,
    density: 5,
    county_fips: 17129,
    county_name: "Menard",
    county_weights: {
      17017: 30.67,
      17129: 69.33,
    },
    county_names_all: "Menard|Cass",
    county_fips_all: "17129|17017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62674,
    lat: 39.43486,
    lng: -90.02952,
    city: "Palmyra",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1635,
    density: 8.4,
    county_fips: 17117,
    county_name: "Macoupin",
    county_weights: {
      17117: 100,
    },
    county_names_all: "Macoupin",
    county_fips_all: 17117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62675,
    lat: 40.02109,
    lng: -89.86146,
    city: "Petersburg",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5770,
    density: 19.4,
    county_fips: 17129,
    county_name: "Menard",
    county_weights: {
      17017: 1.97,
      17129: 98.03,
    },
    county_names_all: "Menard|Cass",
    county_fips_all: "17129|17017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62677,
    lat: 39.85168,
    lng: -89.87694,
    city: "Pleasant Plains",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2039,
    density: 8.8,
    county_fips: 17167,
    county_name: "Sangamon",
    county_weights: {
      17129: 1.72,
      17167: 98.28,
    },
    county_names_all: "Sangamon|Menard",
    county_fips_all: "17167|17129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62681,
    lat: 40.13841,
    lng: -90.55885,
    city: "Rushville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5534,
    density: 12.1,
    county_fips: 17169,
    county_name: "Schuyler",
    county_weights: {
      17169: 100,
    },
    county_names_all: "Schuyler",
    county_fips_all: 17169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62682,
    lat: 40.29487,
    lng: -89.63541,
    city: "San Jose",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 705,
    density: 6,
    county_fips: 17125,
    county_name: "Mason",
    county_weights: {
      17107: 30.06,
      17125: 56.14,
      17179: 13.8,
    },
    county_names_all: "Mason|Logan|Tazewell",
    county_fips_all: "17125|17107|17179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62684,
    lat: 39.91019,
    lng: -89.58474,
    city: "Sherman",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5773,
    density: 86,
    county_fips: 17167,
    county_name: "Sangamon",
    county_weights: {
      17167: 100,
    },
    county_names_all: "Sangamon",
    county_fips_all: 17167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62685,
    lat: 39.14209,
    lng: -89.99689,
    city: "Shipman",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2141,
    density: 10.1,
    county_fips: 17117,
    county_name: "Macoupin",
    county_weights: {
      17117: 100,
    },
    county_names_all: "Macoupin",
    county_fips_all: 17117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62688,
    lat: 39.945,
    lng: -89.92415,
    city: "Tallula",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 753,
    density: 6.5,
    county_fips: 17129,
    county_name: "Menard",
    county_weights: {
      17129: 100,
    },
    county_names_all: "Menard",
    county_fips_all: 17129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62689,
    lat: 39.53402,
    lng: -89.76555,
    city: "Thayer",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 588,
    density: 198.2,
    county_fips: 17167,
    county_name: "Sangamon",
    county_weights: {
      17167: 100,
    },
    county_names_all: "Sangamon",
    county_fips_all: 17167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62690,
    lat: 39.50572,
    lng: -89.76662,
    city: "Virden",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3765,
    density: 25.9,
    county_fips: 17117,
    county_name: "Macoupin",
    county_weights: {
      17117: 62.72,
      17135: 21.05,
      17167: 16.23,
    },
    county_names_all: "Macoupin|Montgomery|Sangamon",
    county_fips_all: "17117|17135|17167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62691,
    lat: 39.95731,
    lng: -90.22246,
    city: "Virginia",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2116,
    density: 8,
    county_fips: 17017,
    county_name: "Cass",
    county_weights: {
      17017: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 17017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62692,
    lat: 39.5832,
    lng: -89.93936,
    city: "Waverly",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2148,
    density: 9.5,
    county_fips: 17137,
    county_name: "Morgan",
    county_weights: {
      17137: 52.3,
      17167: 47.7,
    },
    county_names_all: "Morgan|Sangamon",
    county_fips_all: "17137|17167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62693,
    lat: 39.95761,
    lng: -89.52041,
    city: "Williamsville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1639,
    density: 12.5,
    county_fips: 17167,
    county_name: "Sangamon",
    county_weights: {
      17107: 36.51,
      17129: 2.92,
      17167: 60.57,
    },
    county_names_all: "Sangamon|Logan|Menard",
    county_fips_all: "17167|17107|17129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62694,
    lat: 39.62463,
    lng: -90.47274,
    city: "Winchester",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3014,
    density: 7.5,
    county_fips: 17171,
    county_name: "Scott",
    county_weights: {
      17137: 2.32,
      17171: 97.68,
    },
    county_names_all: "Scott|Morgan",
    county_fips_all: "17171|17137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62695,
    lat: 39.61943,
    lng: -90.22418,
    city: "Woodson",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 256,
    density: 120.2,
    county_fips: 17137,
    county_name: "Morgan",
    county_weights: {
      17137: 100,
    },
    county_names_all: "Morgan",
    county_fips_all: 17137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62701,
    lat: 39.80063,
    lng: -89.64902,
    city: "Springfield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1080,
    density: 1071.9,
    county_fips: 17167,
    county_name: "Sangamon",
    county_weights: {
      17167: 100,
    },
    county_names_all: "Sangamon",
    county_fips_all: 17167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62702,
    lat: 39.82377,
    lng: -89.64286,
    city: "Springfield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33243,
    density: 835.3,
    county_fips: 17167,
    county_name: "Sangamon",
    county_weights: {
      17167: 100,
    },
    county_names_all: "Sangamon",
    county_fips_all: 17167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62703,
    lat: 39.76276,
    lng: -89.63106,
    city: "Springfield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29644,
    density: 767.3,
    county_fips: 17167,
    county_name: "Sangamon",
    county_weights: {
      17167: 100,
    },
    county_names_all: "Sangamon",
    county_fips_all: 17167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62704,
    lat: 39.77358,
    lng: -89.68503,
    city: "Springfield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40754,
    density: 1287,
    county_fips: 17167,
    county_name: "Sangamon",
    county_weights: {
      17167: 100,
    },
    county_names_all: "Sangamon",
    county_fips_all: 17167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62706,
    lat: 39.79789,
    lng: -89.6554,
    city: "Springfield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 17167,
    county_name: "Sangamon",
    county_weights: {
      17167: 100,
    },
    county_names_all: "Sangamon",
    county_fips_all: 17167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62707,
    lat: 39.85506,
    lng: -89.64989,
    city: "Springfield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7850,
    density: 72.4,
    county_fips: 17167,
    county_name: "Sangamon",
    county_weights: {
      17167: 100,
    },
    county_names_all: "Sangamon",
    county_fips_all: 17167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62711,
    lat: 39.76662,
    lng: -89.73195,
    city: "Springfield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16331,
    density: 203.9,
    county_fips: 17167,
    county_name: "Sangamon",
    county_weights: {
      17167: 100,
    },
    county_names_all: "Sangamon",
    county_fips_all: 17167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62712,
    lat: 39.74883,
    lng: -89.58344,
    city: "Springfield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10216,
    density: 165.1,
    county_fips: 17167,
    county_name: "Sangamon",
    county_weights: {
      17167: 100,
    },
    county_names_all: "Sangamon",
    county_fips_all: 17167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62801,
    lat: 38.51097,
    lng: -89.1412,
    city: "Centralia",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21070,
    density: 60.5,
    county_fips: 17121,
    county_name: "Marion",
    county_weights: {
      17027: 33.01,
      17081: 13.65,
      17121: 37.65,
      17189: 15.69,
    },
    county_names_all: "Marion|Clinton|Washington|Jefferson",
    county_fips_all: "17121|17027|17189|17081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62803,
    lat: 38.45461,
    lng: -89.29822,
    city: "Hoyleton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1289,
    density: 8.8,
    county_fips: 17189,
    county_name: "Washington",
    county_weights: {
      17189: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 17189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62806,
    lat: 38.38405,
    lng: -88.07492,
    city: "Albion",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3467,
    density: 13,
    county_fips: 17047,
    county_name: "Edwards",
    county_weights: {
      17047: 100,
    },
    county_names_all: "Edwards",
    county_fips_all: 17047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62807,
    lat: 38.74767,
    lng: -88.93412,
    city: "Alma",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 964,
    density: 9.5,
    county_fips: 17121,
    county_name: "Marion",
    county_weights: {
      17121: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 17121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62808,
    lat: 38.30328,
    lng: -89.1884,
    city: "Ashley",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1740,
    density: 9,
    county_fips: 17189,
    county_name: "Washington",
    county_weights: {
      17081: 31.56,
      17189: 68.44,
    },
    county_names_all: "Washington|Jefferson",
    county_fips_all: "17189|17081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62809,
    lat: 38.28023,
    lng: -88.33756,
    city: "Barnhill",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 140,
    density: 3.5,
    county_fips: 17191,
    county_name: "Wayne",
    county_weights: {
      17191: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 17191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62810,
    lat: 38.20515,
    lng: -88.74388,
    city: "Belle Rive",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 908,
    density: 5.6,
    county_fips: 17081,
    county_name: "Jefferson",
    county_weights: {
      17065: 4.53,
      17081: 85.69,
      17191: 9.78,
    },
    county_names_all: "Jefferson|Wayne|Hamilton",
    county_fips_all: "17081|17191|17065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62811,
    lat: 38.38739,
    lng: -87.90361,
    city: "Bellmont",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 288,
    density: 90.5,
    county_fips: 17185,
    county_name: "Wabash",
    county_weights: {
      17185: 100,
    },
    county_names_all: "Wabash",
    county_fips_all: 17185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62812,
    lat: 38.00487,
    lng: -88.92249,
    city: "Benton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11407,
    density: 44.6,
    county_fips: 17055,
    county_name: "Franklin",
    county_weights: {
      17055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 17055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62814,
    lat: 38.37641,
    lng: -88.73054,
    city: "Bluford",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1804,
    density: 9.7,
    county_fips: 17081,
    county_name: "Jefferson",
    county_weights: {
      17081: 82.1,
      17191: 17.9,
    },
    county_names_all: "Jefferson|Wayne",
    county_fips_all: "17081|17191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62815,
    lat: 38.45707,
    lng: -87.98698,
    city: "Bone Gap",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 221,
    density: 4.1,
    county_fips: 17047,
    county_name: "Edwards",
    county_weights: {
      17047: 100,
    },
    county_names_all: "Edwards",
    county_fips_all: 17047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62816,
    lat: 38.18156,
    lng: -88.92473,
    city: "Bonnie",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1208,
    density: 12.5,
    county_fips: 17081,
    county_name: "Jefferson",
    county_weights: {
      17081: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 17081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62817,
    lat: 37.9545,
    lng: -88.47762,
    city: "Broughton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 583,
    density: 3.3,
    county_fips: 17065,
    county_name: "Hamilton",
    county_weights: {
      17065: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 17065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62818,
    lat: 38.37772,
    lng: -87.96749,
    city: "Browns",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 366,
    density: 5.5,
    county_fips: 17047,
    county_name: "Edwards",
    county_weights: {
      17047: 50.08,
      17185: 49.92,
    },
    county_names_all: "Edwards|Wabash",
    county_fips_all: "17047|17185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62819,
    lat: 37.97507,
    lng: -89.00283,
    city: "Buckner",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 340,
    density: 39.6,
    county_fips: 17055,
    county_name: "Franklin",
    county_weights: {
      17055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 17055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62820,
    lat: 38.24873,
    lng: -88.23561,
    city: "Burnt Prairie",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 159,
    density: 2.9,
    county_fips: 17193,
    county_name: "White",
    county_weights: {
      17191: 40.4,
      17193: 59.6,
    },
    county_names_all: "White|Wayne",
    county_fips_all: "17193|17191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62821,
    lat: 38.07301,
    lng: -88.13357,
    city: "Carmi",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7000,
    density: 15.8,
    county_fips: 17193,
    county_name: "White",
    county_weights: {
      17193: 100,
    },
    county_names_all: "White",
    county_fips_all: 17193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62822,
    lat: 37.97473,
    lng: -89.05358,
    city: "Christopher",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2854,
    density: 499.4,
    county_fips: 17055,
    county_name: "Franklin",
    county_weights: {
      17055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 17055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62823,
    lat: 38.51864,
    lng: -88.43816,
    city: "Cisne",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1890,
    density: 9.1,
    county_fips: 17191,
    county_name: "Wayne",
    county_weights: {
      17191: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 17191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62824,
    lat: 38.67076,
    lng: -88.34686,
    city: "Clay City",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1665,
    density: 6.4,
    county_fips: 17025,
    county_name: "Clay",
    county_weights: {
      17025: 84.64,
      17191: 15.36,
    },
    county_names_all: "Clay|Wayne",
    county_fips_all: "17025|17191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62825,
    lat: 37.99832,
    lng: -89.06474,
    city: "Coello",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 187,
    density: 102.6,
    county_fips: 17055,
    county_name: "Franklin",
    county_weights: {
      17055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 17055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62827,
    lat: 38.16573,
    lng: -88.04157,
    city: "Crossville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1189,
    density: 7,
    county_fips: 17193,
    county_name: "White",
    county_weights: {
      17193: 100,
    },
    county_names_all: "White",
    county_fips_all: 17193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62828,
    lat: 38.19536,
    lng: -88.60864,
    city: "Dahlgren",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1580,
    density: 7.4,
    county_fips: 17065,
    county_name: "Hamilton",
    county_weights: {
      17065: 97.14,
      17191: 2.86,
    },
    county_names_all: "Hamilton|Wayne",
    county_fips_all: "17065|17191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62829,
    lat: 37.99956,
    lng: -88.49061,
    city: "Dale",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31,
    density: 12.3,
    county_fips: 17065,
    county_name: "Hamilton",
    county_weights: {
      17065: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 17065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62830,
    lat: 38.44559,
    lng: -88.96424,
    city: "Dix",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1274,
    density: 16.9,
    county_fips: 17081,
    county_name: "Jefferson",
    county_weights: {
      17081: 95.9,
      17121: 4.1,
    },
    county_names_all: "Jefferson|Marion",
    county_fips_all: "17081|17121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62831,
    lat: 38.23042,
    lng: -89.22167,
    city: "Du Bois",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 352,
    density: 3.3,
    county_fips: 17189,
    county_name: "Washington",
    county_weights: {
      17145: 23.08,
      17189: 76.92,
    },
    county_names_all: "Washington|Perry",
    county_fips_all: "17189|17145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62832,
    lat: 38.01001,
    lng: -89.24969,
    city: "Du Quoin",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8479,
    density: 33.5,
    county_fips: 17145,
    county_name: "Perry",
    county_weights: {
      17077: 5.17,
      17145: 94.83,
    },
    county_names_all: "Perry|Jackson",
    county_fips_all: "17145|17077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62833,
    lat: 38.34071,
    lng: -88.16355,
    city: "Ellery",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 285,
    density: 2.2,
    county_fips: 17191,
    county_name: "Wayne",
    county_weights: {
      17047: 29.29,
      17191: 70.71,
    },
    county_names_all: "Wayne|Edwards",
    county_fips_all: "17191|17047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62835,
    lat: 38.10573,
    lng: -88.32406,
    city: "Enfield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1162,
    density: 6,
    county_fips: 17193,
    county_name: "White",
    county_weights: {
      17065: 17.87,
      17193: 82.13,
    },
    county_names_all: "White|Hamilton",
    county_fips_all: "17193|17065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62836,
    lat: 38.0973,
    lng: -88.80568,
    city: "Ewing",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 757,
    density: 7.7,
    county_fips: 17055,
    county_name: "Franklin",
    county_weights: {
      17055: 93.16,
      17081: 6.84,
    },
    county_names_all: "Franklin|Jefferson",
    county_fips_all: "17055|17081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62837,
    lat: 38.36608,
    lng: -88.35999,
    city: "Fairfield",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8836,
    density: 20.8,
    county_fips: 17191,
    county_name: "Wayne",
    county_weights: {
      17191: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 17191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62838,
    lat: 38.86855,
    lng: -88.74889,
    city: "Farina",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1997,
    density: 8.3,
    county_fips: 17051,
    county_name: "Fayette",
    county_weights: {
      17025: 29.15,
      17049: 1.45,
      17051: 61.47,
      17121: 7.93,
    },
    county_names_all: "Fayette|Clay|Marion|Effingham",
    county_fips_all: "17051|17025|17121|17049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62839,
    lat: 38.66403,
    lng: -88.49689,
    city: "Flora",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6409,
    density: 34.8,
    county_fips: 17025,
    county_name: "Clay",
    county_weights: {
      17025: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 17025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62841,
    lat: 37.8588,
    lng: -88.99639,
    city: "Freeman Spur",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 123,
    density: 155.6,
    county_fips: 17199,
    county_name: "Williamson",
    county_weights: {
      17199: 100,
    },
    county_names_all: "Williamson",
    county_fips_all: 17199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62842,
    lat: 38.47038,
    lng: -88.38007,
    city: "Geff",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 720,
    density: 6.1,
    county_fips: 17191,
    county_name: "Wayne",
    county_weights: {
      17191: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 17191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62843,
    lat: 38.3828,
    lng: -88.19893,
    city: "Golden Gate",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 187,
    density: 12.8,
    county_fips: 17191,
    county_name: "Wayne",
    county_weights: {
      17191: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 17191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62844,
    lat: 38.25525,
    lng: -88.05018,
    city: "Grayville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2012,
    density: 16.6,
    county_fips: 17193,
    county_name: "White",
    county_weights: {
      17047: 37.51,
      17193: 62.49,
    },
    county_names_all: "White|Edwards",
    county_fips_all: "17193|17047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62846,
    lat: 38.15042,
    lng: -88.85485,
    city: "Ina",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2563,
    density: 60.3,
    county_fips: 17081,
    county_name: "Jefferson",
    county_weights: {
      17081: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 17081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62848,
    lat: 38.43794,
    lng: -89.16665,
    city: "Irvington",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 551,
    density: 78.3,
    county_fips: 17189,
    county_name: "Washington",
    county_weights: {
      17189: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 17189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62849,
    lat: 38.58803,
    lng: -88.77221,
    city: "Iuka",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2070,
    density: 7.1,
    county_fips: 17121,
    county_name: "Marion",
    county_weights: {
      17121: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 17121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62850,
    lat: 38.49552,
    lng: -88.58841,
    city: "Johnsonville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 645,
    density: 8.7,
    county_fips: 17191,
    county_name: "Wayne",
    county_weights: {
      17191: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 17191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62851,
    lat: 38.42185,
    lng: -88.66237,
    city: "Keenes",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 97,
    density: 1.3,
    county_fips: 17191,
    county_name: "Wayne",
    county_weights: {
      17081: 7.67,
      17121: 2.39,
      17191: 89.94,
    },
    county_names_all: "Wayne|Jefferson|Marion",
    county_fips_all: "17191|17081|17121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62852,
    lat: 38.34992,
    lng: -87.86676,
    city: "Keensburg",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74,
    density: 271.7,
    county_fips: 17185,
    county_name: "Wabash",
    county_weights: {
      17185: 100,
    },
    county_names_all: "Wabash",
    county_fips_all: 17185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62853,
    lat: 38.51734,
    lng: -88.91571,
    city: "Kell",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1096,
    density: 16.1,
    county_fips: 17121,
    county_name: "Marion",
    county_weights: {
      17121: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 17121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62854,
    lat: 38.76458,
    lng: -88.81172,
    city: "Kinmundy",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1515,
    density: 6.3,
    county_fips: 17121,
    county_name: "Marion",
    county_weights: {
      17025: 1.07,
      17051: 0.68,
      17121: 98.25,
    },
    county_names_all: "Marion|Clay|Fayette",
    county_fips_all: "17121|17025|17051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62856,
    lat: 37.95246,
    lng: -88.83549,
    city: "Logan",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 325,
    density: 83.1,
    county_fips: 17055,
    county_name: "Franklin",
    county_weights: {
      17055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 17055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62858,
    lat: 38.81271,
    lng: -88.49353,
    city: "Louisville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2950,
    density: 7.5,
    county_fips: 17025,
    county_name: "Clay",
    county_weights: {
      17025: 98.83,
      17049: 1.17,
    },
    county_names_all: "Clay|Effingham",
    county_fips_all: "17025|17049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62859,
    lat: 38.07094,
    lng: -88.54289,
    city: "McLeansboro",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5610,
    density: 11.1,
    county_fips: 17065,
    county_name: "Hamilton",
    county_weights: {
      17055: 0.46,
      17065: 99.54,
    },
    county_names_all: "Hamilton|Franklin",
    county_fips_all: "17065|17055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62860,
    lat: 38.04022,
    lng: -88.72921,
    city: "Macedonia",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 402,
    density: 4.4,
    county_fips: 17055,
    county_name: "Franklin",
    county_weights: {
      17055: 71.92,
      17065: 28.08,
    },
    county_names_all: "Franklin|Hamilton",
    county_fips_all: "17055|17065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62861,
    lat: 38.03543,
    lng: -88.04569,
    city: "Maunie",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 151,
    density: 367.4,
    county_fips: 17193,
    county_name: "White",
    county_weights: {
      17193: 100,
    },
    county_names_all: "White",
    county_fips_all: 17193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62862,
    lat: 38.2166,
    lng: -88.29685,
    city: "Mill Shoals",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 291,
    density: 4,
    county_fips: 17193,
    county_name: "White",
    county_weights: {
      17193: 100,
    },
    county_names_all: "White",
    county_fips_all: 17193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62863,
    lat: 38.41575,
    lng: -87.85526,
    city: "Mount Carmel",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9461,
    density: 24.8,
    county_fips: 17185,
    county_name: "Wabash",
    county_weights: {
      17185: 100,
    },
    county_names_all: "Wabash",
    county_fips_all: 17185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62864,
    lat: 38.33041,
    lng: -88.90272,
    city: "Mount Vernon",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23287,
    density: 62.9,
    county_fips: 17081,
    county_name: "Jefferson",
    county_weights: {
      17081: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 17081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62865,
    lat: 37.97528,
    lng: -89.08351,
    city: "Mulkeytown",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1973,
    density: 14.3,
    county_fips: 17055,
    county_name: "Franklin",
    county_weights: {
      17055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 17055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62867,
    lat: 37.90503,
    lng: -88.10091,
    city: "New Haven",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 533,
    density: 5.1,
    county_fips: 17193,
    county_name: "White",
    county_weights: {
      17059: 35.65,
      17193: 64.35,
    },
    county_names_all: "White|Gallatin",
    county_fips_all: "17193|17059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62868,
    lat: 38.68073,
    lng: -88.22939,
    city: "Noble",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1852,
    density: 6.9,
    county_fips: 17159,
    county_name: "Richland",
    county_weights: {
      17025: 16.77,
      17159: 67.01,
      17191: 16.22,
    },
    county_names_all: "Richland|Clay|Wayne",
    county_fips_all: "17159|17025|17191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62869,
    lat: 37.96608,
    lng: -88.28336,
    city: "Norris City",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2472,
    density: 10.2,
    county_fips: 17193,
    county_name: "White",
    county_weights: {
      17059: 0.57,
      17065: 3.57,
      17165: 2.19,
      17193: 93.67,
    },
    county_names_all: "White|Hamilton|Saline|Gallatin",
    county_fips_all: "17193|17065|17165|17059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62870,
    lat: 38.63463,
    lng: -89.05063,
    city: "Odin",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2103,
    density: 20.7,
    county_fips: 17121,
    county_name: "Marion",
    county_weights: {
      17121: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 17121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62871,
    lat: 37.8757,
    lng: -88.26499,
    city: "Omaha",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 553,
    density: 3.9,
    county_fips: 17059,
    county_name: "Gallatin",
    county_weights: {
      17059: 98.88,
      17193: 1.12,
    },
    county_names_all: "Gallatin|White",
    county_fips_all: "17059|17193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62872,
    lat: 38.26776,
    lng: -88.8032,
    city: "Opdyke",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1133,
    density: 18.8,
    county_fips: 17081,
    county_name: "Jefferson",
    county_weights: {
      17081: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 17081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62874,
    lat: 37.91767,
    lng: -88.97802,
    city: "Orient",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 434,
    density: 104.3,
    county_fips: 17055,
    county_name: "Franklin",
    county_weights: {
      17055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 17055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62875,
    lat: 38.75789,
    lng: -89.12482,
    city: "Patoka",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1146,
    density: 6.2,
    county_fips: 17121,
    county_name: "Marion",
    county_weights: {
      17027: 6.6,
      17051: 40.63,
      17121: 52.77,
    },
    county_names_all: "Marion|Fayette|Clinton",
    county_fips_all: "17121|17051|17027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62876,
    lat: 38.27713,
    lng: -89.19487,
    city: "Radom",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 142,
    density: 19.8,
    county_fips: 17189,
    county_name: "Washington",
    county_weights: {
      17189: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 17189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62877,
    lat: 38.38983,
    lng: -89.2057,
    city: "Richview",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 497,
    density: 6.1,
    county_fips: 17189,
    county_name: "Washington",
    county_weights: {
      17081: 6.46,
      17189: 93.54,
    },
    county_names_all: "Washington|Jefferson",
    county_fips_all: "17189|17081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62878,
    lat: 38.57718,
    lng: -88.49378,
    city: "Rinard",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 394,
    density: 4.5,
    county_fips: 17191,
    county_name: "Wayne",
    county_weights: {
      17191: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 17191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62879,
    lat: 38.7651,
    lng: -88.35907,
    city: "Sailor Springs",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 108,
    density: 336.1,
    county_fips: 17025,
    county_name: "Clay",
    county_weights: {
      17025: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 17025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62880,
    lat: 38.86751,
    lng: -88.88593,
    city: "Saint Peter",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 724,
    density: 6.7,
    county_fips: 17051,
    county_name: "Fayette",
    county_weights: {
      17051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 17051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62881,
    lat: 38.63544,
    lng: -88.9288,
    city: "Salem",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10688,
    density: 41.6,
    county_fips: 17121,
    county_name: "Marion",
    county_weights: {
      17121: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 17121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62882,
    lat: 38.63474,
    lng: -89.1197,
    city: "Sandoval",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2252,
    density: 27.6,
    county_fips: 17121,
    county_name: "Marion",
    county_weights: {
      17027: 17.21,
      17121: 82.79,
    },
    county_names_all: "Marion|Clinton",
    county_fips_all: "17121|17027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62883,
    lat: 38.162,
    lng: -89.11192,
    city: "Scheller",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 658,
    density: 6,
    county_fips: 17081,
    county_name: "Jefferson",
    county_weights: {
      17055: 13.53,
      17081: 70.45,
      17145: 16.02,
    },
    county_names_all: "Jefferson|Perry|Franklin",
    county_fips_all: "17081|17145|17055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62884,
    lat: 38.08482,
    lng: -89.04196,
    city: "Sesser",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2679,
    density: 34.2,
    county_fips: 17055,
    county_name: "Franklin",
    county_weights: {
      17055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 17055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62885,
    lat: 38.86289,
    lng: -89.06286,
    city: "Shobonier",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 434,
    density: 2.9,
    county_fips: 17051,
    county_name: "Fayette",
    county_weights: {
      17051: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 17051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62886,
    lat: 38.37486,
    lng: -88.53572,
    city: "Sims",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 341,
    density: 5,
    county_fips: 17191,
    county_name: "Wayne",
    county_weights: {
      17191: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 17191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62887,
    lat: 38.18478,
    lng: -88.36871,
    city: "Springerton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 381,
    density: 6,
    county_fips: 17193,
    county_name: "White",
    county_weights: {
      17065: 47.59,
      17193: 52.41,
    },
    county_names_all: "White|Hamilton",
    county_fips_all: "17193|17065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62888,
    lat: 38.12665,
    lng: -89.22828,
    city: "Tamaroa",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2231,
    density: 11.9,
    county_fips: 17145,
    county_name: "Perry",
    county_weights: {
      17145: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 17145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62889,
    lat: 38.46011,
    lng: -88.82893,
    city: "Texico",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1032,
    density: 12.5,
    county_fips: 17081,
    county_name: "Jefferson",
    county_weights: {
      17081: 67.75,
      17121: 32.25,
    },
    county_names_all: "Jefferson|Marion",
    county_fips_all: "17081|17121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62890,
    lat: 37.90574,
    lng: -88.73944,
    city: "Thompsonville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2269,
    density: 8.5,
    county_fips: 17055,
    county_name: "Franklin",
    county_weights: {
      17055: 52.69,
      17065: 16.22,
      17165: 8.03,
      17199: 23.06,
    },
    county_names_all: "Franklin|Williamson|Hamilton|Saline",
    county_fips_all: "17055|17199|17065|17165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62891,
    lat: 38.01569,
    lng: -89.04067,
    city: "Valier",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 722,
    density: 441.2,
    county_fips: 17055,
    county_name: "Franklin",
    county_weights: {
      17055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 17055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62892,
    lat: 38.80623,
    lng: -89.0771,
    city: "Vernon",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 285,
    density: 5,
    county_fips: 17121,
    county_name: "Marion",
    county_weights: {
      17051: 9.72,
      17121: 90.28,
    },
    county_names_all: "Marion|Fayette",
    county_fips_all: "17121|17051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62893,
    lat: 38.46776,
    lng: -89.03087,
    city: "Walnut Hill",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 820,
    density: 15.8,
    county_fips: 17081,
    county_name: "Jefferson",
    county_weights: {
      17081: 54.97,
      17121: 45.03,
    },
    county_names_all: "Jefferson|Marion",
    county_fips_all: "17081|17121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62894,
    lat: 38.20952,
    lng: -89.03931,
    city: "Waltonville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1091,
    density: 9.3,
    county_fips: 17081,
    county_name: "Jefferson",
    county_weights: {
      17081: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 17081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62895,
    lat: 38.30364,
    lng: -88.54702,
    city: "Wayne City",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1662,
    density: 5.8,
    county_fips: 17191,
    county_name: "Wayne",
    county_weights: {
      17065: 24.36,
      17191: 75.64,
    },
    county_names_all: "Wayne|Hamilton",
    county_fips_all: "17191|17065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62896,
    lat: 37.89287,
    lng: -88.91183,
    city: "West Frankfort",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11795,
    density: 75.4,
    county_fips: 17055,
    county_name: "Franklin",
    county_weights: {
      17055: 91,
      17199: 9,
    },
    county_names_all: "Franklin|Williamson",
    county_fips_all: "17055|17199",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62897,
    lat: 38.09763,
    lng: -88.91504,
    city: "Whittington",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 401,
    density: 10.9,
    county_fips: 17055,
    county_name: "Franklin",
    county_weights: {
      17055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 17055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62898,
    lat: 38.35041,
    lng: -89.06209,
    city: "Woodlawn",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2071,
    density: 14.8,
    county_fips: 17081,
    county_name: "Jefferson",
    county_weights: {
      17081: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 17081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62899,
    lat: 38.63032,
    lng: -88.64367,
    city: "Xenia",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1517,
    density: 5.4,
    county_fips: 17025,
    county_name: "Clay",
    county_weights: {
      17025: 59.17,
      17191: 40.83,
    },
    county_names_all: "Clay|Wayne",
    county_fips_all: "17025|17191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62901,
    lat: 37.74003,
    lng: -89.20946,
    city: "Carbondale",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26318,
    density: 375.5,
    county_fips: 17077,
    county_name: "Jackson",
    county_weights: {
      17077: 88.5,
      17199: 11.5,
    },
    county_names_all: "Jackson|Williamson",
    county_fips_all: "17077|17199",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62902,
    lat: 37.67199,
    lng: -89.11509,
    city: "Carbondale",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4161,
    density: 25,
    county_fips: 17199,
    county_name: "Williamson",
    county_weights: {
      17077: 31.55,
      17181: 1.34,
      17199: 67.11,
    },
    county_names_all: "Williamson|Jackson|Union",
    county_fips_all: "17199|17077|17181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62903,
    lat: 37.67162,
    lng: -89.27568,
    city: "Carbondale",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3167,
    density: 60.4,
    county_fips: 17077,
    county_name: "Jackson",
    county_weights: {
      17077: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 17077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62905,
    lat: 37.57381,
    lng: -89.35867,
    city: "Alto Pass",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 583,
    density: 6.8,
    county_fips: 17181,
    county_name: "Union",
    county_weights: {
      17077: 18.61,
      17181: 81.39,
    },
    county_names_all: "Union|Jackson",
    county_fips_all: "17181|17077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62906,
    lat: 37.45746,
    lng: -89.18899,
    city: "Anna",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6892,
    density: 44.1,
    county_fips: 17181,
    county_name: "Union",
    county_weights: {
      17181: 100,
    },
    county_names_all: "Union",
    county_fips_all: 17181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62907,
    lat: 37.86503,
    lng: -89.50009,
    city: "Ava",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1870,
    density: 7.7,
    county_fips: 17077,
    county_name: "Jackson",
    county_weights: {
      17077: 99.06,
      17157: 0.94,
    },
    county_names_all: "Jackson|Randolph",
    county_fips_all: "17077|17157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62908,
    lat: 37.30827,
    lng: -88.86603,
    city: "Belknap",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 619,
    density: 4.8,
    county_fips: 17127,
    county_name: "Massac",
    county_weights: {
      17087: 35.19,
      17127: 64.81,
    },
    county_names_all: "Massac|Johnson",
    county_fips_all: "17127|17087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62910,
    lat: 37.1562,
    lng: -88.53075,
    city: "Brookport",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2224,
    density: 8,
    county_fips: 17127,
    county_name: "Massac",
    county_weights: {
      17127: 55.03,
      17151: 44.97,
    },
    county_names_all: "Massac|Pope",
    county_fips_all: "17127|17151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62912,
    lat: 37.47598,
    lng: -89.0388,
    city: "Buncombe",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1475,
    density: 10.9,
    county_fips: 17087,
    county_name: "Johnson",
    county_weights: {
      17087: 59.36,
      17181: 40.64,
    },
    county_names_all: "Johnson|Union",
    county_fips_all: "17087|17181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62914,
    lat: 37.04076,
    lng: -89.20329,
    city: "Cairo",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2116,
    density: 40.9,
    county_fips: 17003,
    county_name: "Alexander",
    county_weights: {
      17003: 100,
    },
    county_names_all: "Alexander",
    county_fips_all: 17003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62915,
    lat: 37.78413,
    lng: -89.12238,
    city: "Cambria",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 370,
    density: 450.3,
    county_fips: 17199,
    county_name: "Williamson",
    county_weights: {
      17199: 100,
    },
    county_names_all: "Williamson",
    county_fips_all: 17199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62916,
    lat: 37.93722,
    lng: -89.56947,
    city: "Campbell Hill",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 744,
    density: 6.2,
    county_fips: 17077,
    county_name: "Jackson",
    county_weights: {
      17077: 47.41,
      17145: 30.36,
      17157: 22.23,
    },
    county_names_all: "Jackson|Perry|Randolph",
    county_fips_all: "17077|17145|17157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62917,
    lat: 37.69752,
    lng: -88.64882,
    city: "Carrier Mills",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2292,
    density: 29.8,
    county_fips: 17165,
    county_name: "Saline",
    county_weights: {
      17165: 78.43,
      17199: 21.57,
    },
    county_names_all: "Saline|Williamson",
    county_fips_all: "17165|17199",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62918,
    lat: 37.78561,
    lng: -89.08641,
    city: "Carterville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9646,
    density: 99.3,
    county_fips: 17199,
    county_name: "Williamson",
    county_weights: {
      17199: 100,
    },
    county_names_all: "Williamson",
    county_fips_all: 17199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62919,
    lat: 37.52057,
    lng: -88.14653,
    city: "Cave In Rock",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 917,
    density: 7.5,
    county_fips: 17069,
    county_name: "Hardin",
    county_weights: {
      17069: 100,
    },
    county_names_all: "Hardin",
    county_fips_all: 17069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62920,
    lat: 37.55095,
    lng: -89.23208,
    city: "Cobden",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3109,
    density: 16.9,
    county_fips: 17181,
    county_name: "Union",
    county_weights: {
      17077: 4.27,
      17181: 95.73,
    },
    county_names_all: "Union|Jackson",
    county_fips_all: "17181|17077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62921,
    lat: 37.80217,
    lng: -89.08215,
    city: "Colp",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 269,
    density: 194,
    county_fips: 17199,
    county_name: "Williamson",
    county_weights: {
      17199: 100,
    },
    county_names_all: "Williamson",
    county_fips_all: 17199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62922,
    lat: 37.6215,
    lng: -88.81531,
    city: "Creal Springs",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3089,
    density: 18.8,
    county_fips: 17199,
    county_name: "Williamson",
    county_weights: {
      17087: 26.25,
      17199: 73.75,
    },
    county_names_all: "Williamson|Johnson",
    county_fips_all: "17199|17087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62923,
    lat: 37.33709,
    lng: -89.03671,
    city: "Cypress",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 469,
    density: 7.8,
    county_fips: 17087,
    county_name: "Johnson",
    county_weights: {
      17087: 59.62,
      17153: 18.86,
      17181: 21.52,
    },
    county_names_all: "Johnson|Union|Pulaski",
    county_fips_all: "17087|17181|17153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62924,
    lat: 37.82112,
    lng: -89.20448,
    city: "De Soto",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3001,
    density: 29.2,
    county_fips: 17077,
    county_name: "Jackson",
    county_weights: {
      17077: 87.82,
      17199: 12.18,
    },
    county_names_all: "Jackson|Williamson",
    county_fips_all: "17077|17199",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62926,
    lat: 37.3692,
    lng: -89.13589,
    city: "Dongola",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2152,
    density: 10.7,
    county_fips: 17181,
    county_name: "Union",
    county_weights: {
      17153: 22.16,
      17181: 77.84,
    },
    county_names_all: "Union|Pulaski",
    county_fips_all: "17181|17153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62927,
    lat: 37.94129,
    lng: -89.24837,
    city: "Dowell",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 312,
    density: 70.5,
    county_fips: 17077,
    county_name: "Jackson",
    county_weights: {
      17077: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 17077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62928,
    lat: 37.47959,
    lng: -88.5668,
    city: "Eddyville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 151,
    density: 4.5,
    county_fips: 17151,
    county_name: "Pope",
    county_weights: {
      17151: 100,
    },
    county_names_all: "Pope",
    county_fips_all: 17151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62930,
    lat: 37.84379,
    lng: -88.44139,
    city: "Eldorado",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5825,
    density: 31.9,
    county_fips: 17165,
    county_name: "Saline",
    county_weights: {
      17059: 4.82,
      17065: 3.57,
      17165: 91.61,
    },
    county_names_all: "Saline|Gallatin|Hamilton",
    county_fips_all: "17165|17059|17065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62931,
    lat: 37.52813,
    lng: -88.27953,
    city: "Elizabethtown",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1337,
    density: 5.3,
    county_fips: 17069,
    county_name: "Hardin",
    county_weights: {
      17059: 8.32,
      17069: 91.68,
    },
    county_names_all: "Hardin|Gallatin",
    county_fips_all: "17069|17059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62932,
    lat: 37.89878,
    lng: -89.21048,
    city: "Elkville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1148,
    density: 11,
    county_fips: 17077,
    county_name: "Jackson",
    county_weights: {
      17055: 1.5,
      17077: 98.5,
    },
    county_names_all: "Jackson|Franklin",
    county_fips_all: "17077|17055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62933,
    lat: 37.77363,
    lng: -89.02003,
    city: "Energy",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1309,
    density: 209.6,
    county_fips: 17199,
    county_name: "Williamson",
    county_weights: {
      17199: 100,
    },
    county_names_all: "Williamson",
    county_fips_all: 17199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62934,
    lat: 37.70876,
    lng: -88.36175,
    city: "Equality",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 675,
    density: 3.7,
    county_fips: 17059,
    county_name: "Gallatin",
    county_weights: {
      17059: 66.06,
      17165: 33.94,
    },
    county_names_all: "Gallatin|Saline",
    county_fips_all: "17059|17165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62935,
    lat: 37.84281,
    lng: -88.63194,
    city: "Galatia",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2161,
    density: 13.5,
    county_fips: 17165,
    county_name: "Saline",
    county_weights: {
      17065: 7.74,
      17165: 91.46,
      17199: 0.8,
    },
    county_names_all: "Saline|Hamilton|Williamson",
    county_fips_all: "17165|17065|17199",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62938,
    lat: 37.38249,
    lng: -88.54676,
    city: "Golconda",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3379,
    density: 7.7,
    county_fips: 17151,
    county_name: "Pope",
    county_weights: {
      17069: 4.19,
      17127: 1.82,
      17151: 93.99,
    },
    county_names_all: "Pope|Hardin|Massac",
    county_fips_all: "17151|17069|17127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62939,
    lat: 37.5489,
    lng: -88.98088,
    city: "Goreville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2612,
    density: 22.6,
    county_fips: 17087,
    county_name: "Johnson",
    county_weights: {
      17087: 89.65,
      17181: 6.39,
      17199: 3.96,
    },
    county_names_all: "Johnson|Union|Williamson",
    county_fips_all: "17087|17181|17199",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62940,
    lat: 37.7292,
    lng: -89.46279,
    city: "Gorham",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 714,
    density: 9.8,
    county_fips: 17077,
    county_name: "Jackson",
    county_weights: {
      17077: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 17077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62941,
    lat: 37.24142,
    lng: -88.97186,
    city: "Grand Chain",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 674,
    density: 8.6,
    county_fips: 17153,
    county_name: "Pulaski",
    county_weights: {
      17127: 26.5,
      17153: 73.5,
    },
    county_names_all: "Pulaski|Massac",
    county_fips_all: "17153|17127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62942,
    lat: 37.6348,
    lng: -89.47681,
    city: "Grand Tower",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 636,
    density: 9.9,
    county_fips: 17077,
    county_name: "Jackson",
    county_weights: {
      17077: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 17077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62943,
    lat: 37.35586,
    lng: -88.74669,
    city: "Grantsburg",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 304,
    density: 3.1,
    county_fips: 17087,
    county_name: "Johnson",
    county_weights: {
      17087: 60.49,
      17127: 24.51,
      17151: 15,
    },
    county_names_all: "Johnson|Massac|Pope",
    county_fips_all: "17087|17127|17151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62946,
    lat: 37.7028,
    lng: -88.52887,
    city: "Harrisburg",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12225,
    density: 32.4,
    county_fips: 17165,
    county_name: "Saline",
    county_weights: {
      17151: 5.15,
      17165: 94.85,
    },
    county_names_all: "Saline|Pope",
    county_fips_all: "17165|17151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62947,
    lat: 37.55676,
    lng: -88.4348,
    city: "Herod",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 384,
    density: 2,
    county_fips: 17151,
    county_name: "Pope",
    county_weights: {
      17069: 33.91,
      17151: 58.03,
      17165: 8.06,
    },
    county_names_all: "Pope|Hardin|Saline",
    county_fips_all: "17151|17069|17165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62948,
    lat: 37.8204,
    lng: -89.02542,
    city: "Herrin",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13390,
    density: 257.9,
    county_fips: 17199,
    county_name: "Williamson",
    county_weights: {
      17199: 100,
    },
    county_names_all: "Williamson",
    county_fips_all: 17199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62949,
    lat: 37.8278,
    lng: -89.14409,
    city: "Hurst",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 742,
    density: 171.3,
    county_fips: 17199,
    county_name: "Williamson",
    county_weights: {
      17199: 100,
    },
    county_names_all: "Williamson",
    county_fips_all: 17199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62950,
    lat: 37.75184,
    lng: -89.55573,
    city: "Jacob",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 131,
    density: 1.6,
    county_fips: 17077,
    county_name: "Jackson",
    county_weights: {
      17077: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 17077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62951,
    lat: 37.82637,
    lng: -88.92609,
    city: "Johnston City",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4878,
    density: 68.1,
    county_fips: 17199,
    county_name: "Williamson",
    county_weights: {
      17199: 100,
    },
    county_names_all: "Williamson",
    county_fips_all: 17199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62952,
    lat: 37.42065,
    lng: -89.33187,
    city: "Jonesboro",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3006,
    density: 12.4,
    county_fips: 17181,
    county_name: "Union",
    county_weights: {
      17003: 2.4,
      17181: 97.6,
    },
    county_names_all: "Union|Alexander",
    county_fips_all: "17181|17003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62953,
    lat: 37.20684,
    lng: -88.84533,
    city: "Joppa",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 263,
    density: 188.8,
    county_fips: 17127,
    county_name: "Massac",
    county_weights: {
      17127: 100,
    },
    county_names_all: "Massac",
    county_fips_all: 17127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62954,
    lat: 37.69462,
    lng: -88.27428,
    city: "Junction",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 623,
    density: 4.9,
    county_fips: 17059,
    county_name: "Gallatin",
    county_weights: {
      17059: 100,
    },
    county_names_all: "Gallatin",
    county_fips_all: 17059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62956,
    lat: 37.27805,
    lng: -88.93127,
    city: "Karnak",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1071,
    density: 15.3,
    county_fips: 17127,
    county_name: "Massac",
    county_weights: {
      17127: 51.65,
      17153: 48.35,
    },
    county_names_all: "Massac|Pulaski",
    county_fips_all: "17127|17153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62957,
    lat: 37.31355,
    lng: -89.42669,
    city: "McClure",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 710,
    density: 5.9,
    county_fips: 17003,
    county_name: "Alexander",
    county_weights: {
      17003: 77.18,
      17181: 22.82,
    },
    county_names_all: "Alexander|Union",
    county_fips_all: "17003|17181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62958,
    lat: 37.60389,
    lng: -89.14917,
    city: "Makanda",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1999,
    density: 15.8,
    county_fips: 17077,
    county_name: "Jackson",
    county_weights: {
      17077: 38.46,
      17181: 35.31,
      17199: 26.23,
    },
    county_names_all: "Jackson|Union|Williamson",
    county_fips_all: "17077|17181|17199",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62959,
    lat: 37.71442,
    lng: -88.91463,
    city: "Marion",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27630,
    density: 74.6,
    county_fips: 17199,
    county_name: "Williamson",
    county_weights: {
      17199: 100,
    },
    county_names_all: "Williamson",
    county_fips_all: 17199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62960,
    lat: 37.22515,
    lng: -88.71097,
    city: "Metropolis",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10641,
    density: 36.4,
    county_fips: 17127,
    county_name: "Massac",
    county_weights: {
      17127: 98.34,
      17151: 1.66,
    },
    county_names_all: "Massac|Pope",
    county_fips_all: "17127|17151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62961,
    lat: 37.34063,
    lng: -89.25378,
    city: "Millcreek",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28,
    density: 31.5,
    county_fips: 17181,
    county_name: "Union",
    county_weights: {
      17003: 0.14,
      17181: 99.86,
    },
    county_names_all: "Union|Alexander",
    county_fips_all: "17181|17003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62962,
    lat: 37.07431,
    lng: -89.33537,
    city: "Miller City",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 17003,
    county_name: "Alexander",
    county_weights: {
      17003: 100,
    },
    county_names_all: "Alexander",
    county_fips_all: 17003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62963,
    lat: 37.0933,
    lng: -89.16263,
    city: "Mound City",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 777,
    density: 71.8,
    county_fips: 17153,
    county_name: "Pulaski",
    county_weights: {
      17153: 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: 17153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62964,
    lat: 37.12705,
    lng: -89.21526,
    city: "Mounds",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1271,
    density: 19,
    county_fips: 17153,
    county_name: "Pulaski",
    county_weights: {
      17153: 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: 17153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62965,
    lat: 37.76753,
    lng: -88.5177,
    city: "Muddy",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 71,
    density: 32.4,
    county_fips: 17165,
    county_name: "Saline",
    county_weights: {
      17165: 100,
    },
    county_names_all: "Saline",
    county_fips_all: 17165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62966,
    lat: 37.7693,
    lng: -89.35198,
    city: "Murphysboro",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14881,
    density: 51.8,
    county_fips: 17077,
    county_name: "Jackson",
    county_weights: {
      17077: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 17077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62967,
    lat: 37.58092,
    lng: -88.75089,
    city: "New Burnside",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 299,
    density: 17.7,
    county_fips: 17087,
    county_name: "Johnson",
    county_weights: {
      17087: 96.34,
      17199: 3.66,
    },
    county_names_all: "Johnson|Williamson",
    county_fips_all: "17087|17199",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62969,
    lat: 37.15181,
    lng: -89.34674,
    city: "Olive Branch",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 404,
    density: 10.9,
    county_fips: 17003,
    county_name: "Alexander",
    county_weights: {
      17003: 100,
    },
    county_names_all: "Alexander",
    county_fips_all: 17003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62970,
    lat: 37.21362,
    lng: -89.10119,
    city: "Olmsted",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 643,
    density: 8,
    county_fips: 17153,
    county_name: "Pulaski",
    county_weights: {
      17153: 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: 17153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62972,
    lat: 37.5419,
    lng: -88.8162,
    city: "Ozark",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1000,
    density: 7.2,
    county_fips: 17087,
    county_name: "Johnson",
    county_weights: {
      17087: 91.19,
      17151: 8.81,
    },
    county_names_all: "Johnson|Pope",
    county_fips_all: "17087|17151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62974,
    lat: 37.78158,
    lng: -88.79094,
    city: "Pittsburg",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1955,
    density: 29.2,
    county_fips: 17199,
    county_name: "Williamson",
    county_weights: {
      17199: 100,
    },
    county_names_all: "Williamson",
    county_fips_all: 17199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62975,
    lat: 37.64307,
    lng: -89.37274,
    city: "Pomona",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 131,
    density: 1.9,
    county_fips: 17077,
    county_name: "Jackson",
    county_weights: {
      17077: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 17077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62976,
    lat: 37.21954,
    lng: -89.2095,
    city: "Pulaski",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 358,
    density: 5.8,
    county_fips: 17153,
    county_name: "Pulaski",
    county_weights: {
      17153: 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: 17153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62977,
    lat: 37.85179,
    lng: -88.54384,
    city: "Raleigh",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 659,
    density: 12,
    county_fips: 17165,
    county_name: "Saline",
    county_weights: {
      17165: 100,
    },
    county_names_all: "Saline",
    county_fips_all: 17165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62979,
    lat: 37.80813,
    lng: -88.2365,
    city: "Ridgway",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1014,
    density: 8,
    county_fips: 17059,
    county_name: "Gallatin",
    county_weights: {
      17059: 100,
    },
    county_names_all: "Gallatin",
    county_fips_all: 17059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62982,
    lat: 37.42808,
    lng: -88.35967,
    city: "Rosiclare",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1189,
    density: 59,
    county_fips: 17069,
    county_name: "Hardin",
    county_weights: {
      17069: 100,
    },
    county_names_all: "Hardin",
    county_fips_all: 17069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62983,
    lat: 37.90208,
    lng: -89.10883,
    city: "Royalton",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1329,
    density: 22.1,
    county_fips: 17055,
    county_name: "Franklin",
    county_weights: {
      17055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 17055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62984,
    lat: 37.73152,
    lng: -88.14903,
    city: "Shawneetown",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1572,
    density: 6.2,
    county_fips: 17059,
    county_name: "Gallatin",
    county_weights: {
      17059: 100,
    },
    county_names_all: "Gallatin",
    county_fips_all: 17059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62985,
    lat: 37.46768,
    lng: -88.68933,
    city: "Simpson",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 509,
    density: 2.6,
    county_fips: 17151,
    county_name: "Pope",
    county_weights: {
      17087: 36.33,
      17151: 63.67,
    },
    county_names_all: "Pope|Johnson",
    county_fips_all: "17151|17087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62987,
    lat: 37.61114,
    lng: -88.65695,
    city: "Stonefort",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1368,
    density: 5.8,
    county_fips: 17151,
    county_name: "Pope",
    county_weights: {
      17151: 42.19,
      17165: 39.72,
      17199: 18.09,
    },
    county_names_all: "Pope|Saline|Williamson",
    county_fips_all: "17151|17165|17199",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62988,
    lat: 37.23184,
    lng: -89.29629,
    city: "Tamms",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1472,
    density: 8.1,
    county_fips: 17003,
    county_name: "Alexander",
    county_weights: {
      17003: 100,
    },
    county_names_all: "Alexander",
    county_fips_all: 17003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62990,
    lat: 37.22924,
    lng: -89.40493,
    city: "Thebes",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1231,
    density: 10.8,
    county_fips: 17003,
    county_name: "Alexander",
    county_weights: {
      17003: 100,
    },
    county_names_all: "Alexander",
    county_fips_all: 17003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62992,
    lat: 37.27855,
    lng: -89.1556,
    city: "Ullin",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 831,
    density: 8.5,
    county_fips: 17153,
    county_name: "Pulaski",
    county_weights: {
      17003: 17.84,
      17153: 82.16,
    },
    county_names_all: "Pulaski|Alexander",
    county_fips_all: "17153|17003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62994,
    lat: 37.90593,
    lng: -89.34664,
    city: "Vergennes",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 744,
    density: 7.7,
    county_fips: 17077,
    county_name: "Jackson",
    county_weights: {
      17077: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 17077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62995,
    lat: 37.41945,
    lng: -88.88244,
    city: "Vienna",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5875,
    density: 19,
    county_fips: 17087,
    county_name: "Johnson",
    county_weights: {
      17087: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 17087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62996,
    lat: 37.16624,
    lng: -89.15984,
    city: "Villa Ridge",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 363,
    density: 5.3,
    county_fips: 17153,
    county_name: "Pulaski",
    county_weights: {
      17153: 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: 17153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62997,
    lat: 37.98357,
    lng: -89.59013,
    city: "Willisville",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 588,
    density: 481.6,
    county_fips: 17145,
    county_name: "Perry",
    county_weights: {
      17145: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 17145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62998,
    lat: 37.51649,
    lng: -89.44698,
    city: "Wolf Lake",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 232,
    density: 1.9,
    county_fips: 17181,
    county_name: "Union",
    county_weights: {
      17181: 100,
    },
    county_names_all: "Union",
    county_fips_all: 17181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 62999,
    lat: 37.89122,
    lng: -89.05275,
    city: "Zeigler",
    state_id: "IL",
    state_name: "Illinois",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1802,
    density: 322.4,
    county_fips: 17055,
    county_name: "Franklin",
    county_weights: {
      17055: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 17055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63005,
    lat: 38.64306,
    lng: -90.64982,
    city: "Chesterfield",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18854,
    density: 199.4,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29071: 2.53,
      29189: 97.47,
    },
    county_names_all: "St. Louis|Franklin",
    county_fips_all: "29189|29071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63010,
    lat: 38.42964,
    lng: -90.3932,
    city: "Arnold",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35270,
    density: 631.8,
    county_fips: 29099,
    county_name: "Jefferson",
    county_weights: {
      29099: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 29099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63011,
    lat: 38.60337,
    lng: -90.55847,
    city: "Ballwin",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37298,
    density: 1009.4,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63012,
    lat: 38.33532,
    lng: -90.44832,
    city: "Barnhart",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10909,
    density: 167.6,
    county_fips: 29099,
    county_name: "Jefferson",
    county_weights: {
      29099: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 29099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63013,
    lat: 38.41776,
    lng: -91.15182,
    city: "Beaufort",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1113,
    density: 11.5,
    county_fips: 29071,
    county_name: "Franklin",
    county_weights: {
      29071: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 29071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63014,
    lat: 38.64892,
    lng: -91.31566,
    city: "Berger",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 717,
    density: 7.4,
    county_fips: 29071,
    county_name: "Franklin",
    county_weights: {
      29071: 97.62,
      29073: 2.38,
    },
    county_names_all: "Franklin|Gasconade",
    county_fips_all: "29071|29073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63015,
    lat: 38.39633,
    lng: -90.75274,
    city: "Catawissa",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1617,
    density: 38.7,
    county_fips: 29071,
    county_name: "Franklin",
    county_weights: {
      29071: 64.95,
      29099: 35.05,
    },
    county_names_all: "Franklin|Jefferson",
    county_fips_all: "29071|29099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63016,
    lat: 38.35692,
    lng: -90.65014,
    city: "Cedar Hill",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6819,
    density: 94.6,
    county_fips: 29099,
    county_name: "Jefferson",
    county_weights: {
      29099: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 29099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63017,
    lat: 38.65143,
    lng: -90.53722,
    city: "Chesterfield",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41344,
    density: 828.8,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63019,
    lat: 38.229,
    lng: -90.37684,
    city: "Crystal City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4395,
    density: 504.3,
    county_fips: 29099,
    county_name: "Jefferson",
    county_weights: {
      29099: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 29099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63020,
    lat: 38.10706,
    lng: -90.5718,
    city: "De Soto",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21160,
    density: 54.6,
    county_fips: 29099,
    county_name: "Jefferson",
    county_weights: {
      29099: 93.57,
      29221: 6.43,
    },
    county_names_all: "Jefferson|Washington",
    county_fips_all: "29099|29221",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63021,
    lat: 38.5689,
    lng: -90.54564,
    city: "Ballwin",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56154,
    density: 993.5,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63023,
    lat: 38.2659,
    lng: -90.71292,
    city: "Dittmer",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5355,
    density: 32.1,
    county_fips: 29099,
    county_name: "Jefferson",
    county_weights: {
      29099: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 29099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63025,
    lat: 38.4896,
    lng: -90.61666,
    city: "Eureka",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15450,
    density: 143.1,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29099: 42.63,
      29189: 57.37,
    },
    county_names_all: "St. Louis|Jefferson",
    county_fips_all: "29189|29099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63026,
    lat: 38.50195,
    lng: -90.45995,
    city: "Fenton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45451,
    density: 693.4,
    county_fips: 29099,
    county_name: "Jefferson",
    county_weights: {
      29099: 50.35,
      29189: 49.65,
    },
    county_names_all: "Jefferson|St. Louis",
    county_fips_all: "29099|29189",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63028,
    lat: 38.14545,
    lng: -90.39423,
    city: "Festus",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26433,
    density: 81.1,
    county_fips: 29099,
    county_name: "Jefferson",
    county_weights: {
      29099: 83.41,
      29186: 16.05,
      29187: 0.54,
    },
    county_names_all: "Jefferson|Ste. Genevieve|St. Francois",
    county_fips_all: "29099|29186|29187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63030,
    lat: 38.14321,
    lng: -90.7522,
    city: "Fletcher",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 333,
    density: 16.1,
    county_fips: 29221,
    county_name: "Washington",
    county_weights: {
      29099: 6.22,
      29221: 93.78,
    },
    county_names_all: "Washington|Jefferson",
    county_fips_all: "29221|29099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63031,
    lat: 38.81392,
    lng: -90.35224,
    city: "Florissant",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49110,
    density: 1259.1,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63033,
    lat: 38.7958,
    lng: -90.27786,
    city: "Florissant",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41377,
    density: 1313.1,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63034,
    lat: 38.84795,
    lng: -90.28692,
    city: "Florissant",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18075,
    density: 372.6,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63036,
    lat: 37.9817,
    lng: -90.372,
    city: "French Village",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1226,
    density: 19.3,
    county_fips: 29187,
    county_name: "St. Francois",
    county_weights: {
      29186: 24.81,
      29187: 75.19,
    },
    county_names_all: "St. Francois|Ste. Genevieve",
    county_fips_all: "29187|29186",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63037,
    lat: 38.42497,
    lng: -91.3165,
    city: "Gerald",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2672,
    density: 12.8,
    county_fips: 29071,
    county_name: "Franklin",
    county_weights: {
      29071: 98.55,
      29073: 1.45,
    },
    county_names_all: "Franklin|Gasconade",
    county_fips_all: "29071|29073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63038,
    lat: 38.58071,
    lng: -90.67037,
    city: "Wildwood",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7418,
    density: 137.4,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63039,
    lat: 38.49532,
    lng: -90.83527,
    city: "Gray Summit",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 658,
    density: 57.2,
    county_fips: 29071,
    county_name: "Franklin",
    county_weights: {
      29071: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 29071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63040,
    lat: 38.57298,
    lng: -90.63512,
    city: "Wildwood",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8338,
    density: 729,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63041,
    lat: 38.2522,
    lng: -90.79059,
    city: "Grubville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 453,
    density: 13.5,
    county_fips: 29071,
    county_name: "Franklin",
    county_weights: {
      29071: 97.45,
      29099: 2.55,
    },
    county_names_all: "Franklin|Jefferson",
    county_fips_all: "29071|29099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63042,
    lat: 38.78133,
    lng: -90.37909,
    city: "Hazelwood",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18310,
    density: 682.7,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63043,
    lat: 38.72962,
    lng: -90.45659,
    city: "Maryland Heights",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22133,
    density: 681.1,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63044,
    lat: 38.77455,
    lng: -90.42825,
    city: "Bridgeton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10482,
    density: 242.3,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63045,
    lat: 38.76863,
    lng: -90.46556,
    city: "Earth City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63047,
    lat: 38.1954,
    lng: -90.48763,
    city: "Hematite",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54,
    density: 95.1,
    county_fips: 29099,
    county_name: "Jefferson",
    county_weights: {
      29099: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 29099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63048,
    lat: 38.25924,
    lng: -90.39194,
    city: "Herculaneum",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3904,
    density: 416.3,
    county_fips: 29099,
    county_name: "Jefferson",
    county_weights: {
      29099: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 29099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63049,
    lat: 38.47795,
    lng: -90.52867,
    city: "High Ridge",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17163,
    density: 265.9,
    county_fips: 29099,
    county_name: "Jefferson",
    county_weights: {
      29099: 80.41,
      29189: 19.59,
    },
    county_names_all: "Jefferson|St. Louis",
    county_fips_all: "29099|29189",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63050,
    lat: 38.25977,
    lng: -90.57628,
    city: "Hillsboro",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16794,
    density: 70.5,
    county_fips: 29099,
    county_name: "Jefferson",
    county_weights: {
      29099: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 29099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63051,
    lat: 38.39886,
    lng: -90.57303,
    city: "House Springs",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12721,
    density: 114.2,
    county_fips: 29099,
    county_name: "Jefferson",
    county_weights: {
      29099: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 29099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63052,
    lat: 38.38983,
    lng: -90.4358,
    city: "Imperial",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27943,
    density: 326,
    county_fips: 29099,
    county_name: "Jefferson",
    county_weights: {
      29099: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 29099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63053,
    lat: 38.36651,
    lng: -90.36402,
    city: "Kimmswick",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 76,
    density: 1027.2,
    county_fips: 29099,
    county_name: "Jefferson",
    county_weights: {
      29099: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 29099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63055,
    lat: 38.53254,
    lng: -90.8382,
    city: "Labadie",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1997,
    density: 28.5,
    county_fips: 29071,
    county_name: "Franklin",
    county_weights: {
      29071: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 29071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63056,
    lat: 38.38964,
    lng: -91.22072,
    city: "Leslie",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2069,
    density: 13.6,
    county_fips: 29071,
    county_name: "Franklin",
    county_weights: {
      29071: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 29071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63060,
    lat: 38.25656,
    lng: -90.86815,
    city: "Lonedell",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2117,
    density: 18.4,
    county_fips: 29071,
    county_name: "Franklin",
    county_weights: {
      29071: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 29071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63061,
    lat: 38.2679,
    lng: -90.81053,
    city: "Luebbering",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 179,
    density: 16.5,
    county_fips: 29071,
    county_name: "Franklin",
    county_weights: {
      29071: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 29071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63068,
    lat: 38.55747,
    lng: -91.24761,
    city: "New Haven",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5685,
    density: 23.9,
    county_fips: 29071,
    county_name: "Franklin",
    county_weights: {
      29071: 96.24,
      29073: 3.76,
    },
    county_names_all: "Franklin|Gasconade",
    county_fips_all: "29071|29073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63069,
    lat: 38.48286,
    lng: -90.7292,
    city: "Pacific",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15352,
    density: 86.5,
    county_fips: 29071,
    county_name: "Franklin",
    county_weights: {
      29071: 42.97,
      29099: 23.93,
      29189: 33.1,
    },
    county_names_all: "Franklin|St. Louis|Jefferson",
    county_fips_all: "29071|29189|29099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63070,
    lat: 38.28625,
    lng: -90.41822,
    city: "Pevely",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8030,
    density: 206.1,
    county_fips: 29099,
    county_name: "Jefferson",
    county_weights: {
      29099: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 29099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63071,
    lat: 38.15635,
    lng: -90.82558,
    city: "Richwoods",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1110,
    density: 11.1,
    county_fips: 29221,
    county_name: "Washington",
    county_weights: {
      29221: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 29221,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63072,
    lat: 38.36635,
    lng: -90.81354,
    city: "Robertsville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4313,
    density: 40.5,
    county_fips: 29071,
    county_name: "Franklin",
    county_weights: {
      29071: 96.96,
      29099: 3.04,
    },
    county_names_all: "Franklin|Jefferson",
    county_fips_all: "29071|29099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63073,
    lat: 38.58367,
    lng: -90.76933,
    city: "Saint Albans",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 356,
    density: 13.2,
    county_fips: 29071,
    county_name: "Franklin",
    county_weights: {
      29071: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 29071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63074,
    lat: 38.72637,
    lng: -90.38895,
    city: "Saint Ann",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15279,
    density: 1506,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63077,
    lat: 38.32648,
    lng: -90.98537,
    city: "Saint Clair",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10884,
    density: 47.9,
    county_fips: 29071,
    county_name: "Franklin",
    county_weights: {
      29071: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 29071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63079,
    lat: 38.26632,
    lng: -91.1001,
    city: "Stanton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22,
    density: 3.4,
    county_fips: 29071,
    county_name: "Franklin",
    county_weights: {
      29071: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 29071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63080,
    lat: 38.20828,
    lng: -91.08802,
    city: "Sullivan",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13467,
    density: 20.9,
    county_fips: 29071,
    county_name: "Franklin",
    county_weights: {
      29055: 4.03,
      29071: 56.65,
      29221: 39.32,
    },
    county_names_all: "Franklin|Washington|Crawford",
    county_fips_all: "29071|29221|29055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63084,
    lat: 38.41749,
    lng: -91.01438,
    city: "Union",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20017,
    density: 101.4,
    county_fips: 29071,
    county_name: "Franklin",
    county_weights: {
      29071: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 29071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63087,
    lat: 38.00888,
    lng: -90.45835,
    city: "Valles Mines",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1005,
    density: 23.8,
    county_fips: 29187,
    county_name: "St. Francois",
    county_weights: {
      29099: 8.83,
      29187: 91.17,
    },
    county_names_all: "St. Francois|Jefferson",
    county_fips_all: "29187|29099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63088,
    lat: 38.54862,
    lng: -90.50111,
    city: "Valley Park",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8659,
    density: 695.6,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63089,
    lat: 38.45846,
    lng: -90.88286,
    city: "Villa Ridge",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5846,
    density: 61,
    county_fips: 29071,
    county_name: "Franklin",
    county_weights: {
      29071: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 29071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63090,
    lat: 38.53176,
    lng: -91.05047,
    city: "Washington",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21671,
    density: 102.6,
    county_fips: 29071,
    county_name: "Franklin",
    county_weights: {
      29071: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 29071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63091,
    lat: 38.36581,
    lng: -91.39013,
    city: "Rosebud",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1457,
    density: 11,
    county_fips: 29073,
    county_name: "Gasconade",
    county_weights: {
      29071: 20.33,
      29073: 79.67,
    },
    county_names_all: "Gasconade|Franklin",
    county_fips_all: "29073|29071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63101,
    lat: 38.63127,
    lng: -90.19275,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3528,
    density: 3762.9,
    county_fips: 29510,
    county_name: "St. Louis",
    county_weights: {
      29510: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63102,
    lat: 38.63453,
    lng: -90.18627,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2381,
    density: 649.2,
    county_fips: 29510,
    county_name: "St. Louis",
    county_weights: {
      29510: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63103,
    lat: 38.62986,
    lng: -90.217,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9204,
    density: 1617.5,
    county_fips: 29510,
    county_name: "St. Louis",
    county_weights: {
      29510: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63104,
    lat: 38.61078,
    lng: -90.21276,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20150,
    density: 2312.8,
    county_fips: 29510,
    county_name: "St. Louis",
    county_weights: {
      29510: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63105,
    lat: 38.64427,
    lng: -90.32812,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18698,
    density: 2871.2,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 95.7,
      29510: 4.3,
    },
    county_names_all: "St. Louis|St. Louis",
    county_fips_all: "29189|29510",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63106,
    lat: 38.64445,
    lng: -90.20795,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9967,
    density: 1726.5,
    county_fips: 29510,
    county_name: "St. Louis",
    county_weights: {
      29510: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63107,
    lat: 38.66373,
    lng: -90.21201,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9272,
    density: 1527.2,
    county_fips: 29510,
    county_name: "St. Louis",
    county_weights: {
      29510: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63108,
    lat: 38.64485,
    lng: -90.25337,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20442,
    density: 3520,
    county_fips: 29510,
    county_name: "St. Louis",
    county_weights: {
      29510: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63109,
    lat: 38.58483,
    lng: -90.29563,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26768,
    density: 2922.6,
    county_fips: 29510,
    county_name: "St. Louis",
    county_weights: {
      29510: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63110,
    lat: 38.62538,
    lng: -90.26645,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17239,
    density: 1013.2,
    county_fips: 29510,
    county_name: "St. Louis",
    county_weights: {
      29510: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63111,
    lat: 38.55845,
    lng: -90.24993,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20608,
    density: 2477.9,
    county_fips: 29510,
    county_name: "St. Louis",
    county_weights: {
      29510: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63112,
    lat: 38.66,
    lng: -90.28331,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17531,
    density: 2131.5,
    county_fips: 29510,
    county_name: "St. Louis",
    county_weights: {
      29510: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63113,
    lat: 38.65797,
    lng: -90.2475,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11502,
    density: 1721.5,
    county_fips: 29510,
    county_name: "St. Louis",
    county_weights: {
      29510: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63114,
    lat: 38.70218,
    lng: -90.36224,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34862,
    density: 1523.7,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63115,
    lat: 38.68211,
    lng: -90.23994,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16504,
    density: 1485.1,
    county_fips: 29510,
    county_name: "St. Louis",
    county_weights: {
      29510: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63116,
    lat: 38.57999,
    lng: -90.26501,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43980,
    density: 3143.9,
    county_fips: 29510,
    county_name: "St. Louis",
    county_weights: {
      29510: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63117,
    lat: 38.63077,
    lng: -90.33037,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9290,
    density: 1515.8,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 94.4,
      29510: 5.6,
    },
    county_names_all: "St. Louis|St. Louis",
    county_fips_all: "29189|29510",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63118,
    lat: 38.59237,
    lng: -90.22534,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27805,
    density: 3157.2,
    county_fips: 29510,
    county_name: "St. Louis",
    county_weights: {
      29510: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63119,
    lat: 38.58868,
    lng: -90.35104,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33752,
    density: 1554.8,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 99.01,
      29510: 0.99,
    },
    county_names_all: "St. Louis|St. Louis",
    county_fips_all: "29189|29510",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63120,
    lat: 38.69061,
    lng: -90.26211,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7823,
    density: 1266.5,
    county_fips: 29510,
    county_name: "St. Louis",
    county_weights: {
      29189: 6.55,
      29510: 93.45,
    },
    county_names_all: "St. Louis|St. Louis",
    county_fips_all: "29510|29189",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63121,
    lat: 38.70739,
    lng: -90.30023,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25374,
    density: 1446.9,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63122,
    lat: 38.57853,
    lng: -90.42133,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39239,
    density: 1046.2,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63123,
    lat: 38.54949,
    lng: -90.32739,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50463,
    density: 1564.5,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 94.39,
      29510: 5.61,
    },
    county_names_all: "St. Louis|St. Louis",
    county_fips_all: "29189|29510",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63124,
    lat: 38.63832,
    lng: -90.38023,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11107,
    density: 480.3,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63125,
    lat: 38.51867,
    lng: -90.29269,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33619,
    density: 1305.4,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 98.66,
      29510: 1.34,
    },
    county_names_all: "St. Louis|St. Louis",
    county_fips_all: "29189|29510",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63126,
    lat: 38.5496,
    lng: -90.37868,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14949,
    density: 1255.1,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63127,
    lat: 38.53544,
    lng: -90.41297,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5014,
    density: 334.3,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63128,
    lat: 38.49369,
    lng: -90.38306,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30480,
    density: 754.7,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63129,
    lat: 38.45654,
    lng: -90.32202,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52287,
    density: 965.7,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63130,
    lat: 38.66491,
    lng: -90.32495,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29080,
    density: 2228.4,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 98.03,
      29510: 1.97,
    },
    county_names_all: "St. Louis|St. Louis",
    county_fips_all: "29189|29510",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63131,
    lat: 38.6172,
    lng: -90.44365,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17707,
    density: 501.6,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63132,
    lat: 38.67607,
    lng: -90.37745,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12551,
    density: 931.8,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63133,
    lat: 38.68226,
    lng: -90.30677,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7275,
    density: 863,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 99.23,
      29510: 0.77,
    },
    county_names_all: "St. Louis|St. Louis",
    county_fips_all: "29189|29510",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63134,
    lat: 38.74319,
    lng: -90.34549,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14120,
    density: 657.7,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63135,
    lat: 38.75012,
    lng: -90.29934,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22143,
    density: 1377.7,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63136,
    lat: 38.74418,
    lng: -90.25979,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45198,
    density: 1599.1,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 96,
      29510: 4,
    },
    county_names_all: "St. Louis|St. Louis",
    county_fips_all: "29189|29510",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63137,
    lat: 38.74974,
    lng: -90.21297,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20250,
    density: 1104.5,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 73.11,
      29510: 26.89,
    },
    county_names_all: "St. Louis|St. Louis",
    county_fips_all: "29189|29510",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63138,
    lat: 38.79904,
    lng: -90.1822,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18257,
    density: 380.3,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 97.9,
      29510: 2.1,
    },
    county_names_all: "St. Louis|St. Louis",
    county_fips_all: "29189|29510",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63139,
    lat: 38.61041,
    lng: -90.29191,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21510,
    density: 2175.4,
    county_fips: 29510,
    county_name: "St. Louis",
    county_weights: {
      29510: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63140,
    lat: 38.73929,
    lng: -90.32399,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 337,
    density: 247.5,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63141,
    lat: 38.65751,
    lng: -90.45904,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19824,
    density: 520.9,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63143,
    lat: 38.61169,
    lng: -90.32017,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9089,
    density: 1712.3,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 74.27,
      29510: 25.73,
    },
    county_names_all: "St. Louis|St. Louis",
    county_fips_all: "29189|29510",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63144,
    lat: 38.61943,
    lng: -90.3482,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8759,
    density: 1485.4,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63146,
    lat: 38.70135,
    lng: -90.47634,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31148,
    density: 775,
    county_fips: 29189,
    county_name: "St. Louis",
    county_weights: {
      29189: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63147,
    lat: 38.69567,
    lng: -90.21589,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8580,
    density: 558,
    county_fips: 29510,
    county_name: "St. Louis",
    county_weights: {
      29510: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63155,
    lat: 38.62788,
    lng: -90.20545,
    city: "Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 29510,
    county_name: "St. Louis",
    county_weights: {
      29510: 100,
    },
    county_names_all: "St. Louis",
    county_fips_all: 29510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63301,
    lat: 38.86159,
    lng: -90.47207,
    city: "Saint Charles",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51923,
    density: 237.7,
    county_fips: 29183,
    county_name: "St. Charles",
    county_weights: {
      29183: 100,
    },
    county_names_all: "St. Charles",
    county_fips_all: 29183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63303,
    lat: 38.74013,
    lng: -90.54266,
    city: "Saint Charles",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47897,
    density: 936.2,
    county_fips: 29183,
    county_name: "St. Charles",
    county_weights: {
      29183: 100,
    },
    county_names_all: "St. Charles",
    county_fips_all: 29183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63304,
    lat: 38.70583,
    lng: -90.68666,
    city: "Saint Charles",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42586,
    density: 298.4,
    county_fips: 29183,
    county_name: "St. Charles",
    county_weights: {
      29183: 100,
    },
    county_names_all: "St. Charles",
    county_fips_all: 29183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63330,
    lat: 39.26151,
    lng: -90.79214,
    city: "Annada",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 128,
    density: 2.2,
    county_fips: 29163,
    county_name: "Pike",
    county_weights: {
      29163: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 29163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63332,
    lat: 38.60137,
    lng: -90.89195,
    city: "Augusta",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1656,
    density: 11.3,
    county_fips: 29183,
    county_name: "St. Charles",
    county_weights: {
      29183: 100,
    },
    county_names_all: "St. Charles",
    county_fips_all: 29183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63333,
    lat: 39.0351,
    lng: -91.32014,
    city: "Bellflower",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 806,
    density: 6.5,
    county_fips: 29139,
    county_name: "Montgomery",
    county_weights: {
      29113: 7.22,
      29139: 92.78,
    },
    county_names_all: "Montgomery|Lincoln",
    county_fips_all: "29139|29113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63334,
    lat: 39.30747,
    lng: -91.18838,
    city: "Bowling Green",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9099,
    density: 21.1,
    county_fips: 29163,
    county_name: "Pike",
    county_weights: {
      29113: 5.09,
      29163: 94.91,
    },
    county_names_all: "Pike|Lincoln",
    county_fips_all: "29163|29113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63336,
    lat: 39.33335,
    lng: -90.9388,
    city: "Clarksville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1003,
    density: 5,
    county_fips: 29163,
    county_name: "Pike",
    county_weights: {
      29163: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 29163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63339,
    lat: 39.33673,
    lng: -91.36384,
    city: "Curryville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 906,
    density: 5,
    county_fips: 29163,
    county_name: "Pike",
    county_weights: {
      29163: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 29163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63341,
    lat: 38.66493,
    lng: -90.81783,
    city: "Defiance",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3038,
    density: 30.2,
    county_fips: 29183,
    county_name: "St. Charles",
    county_weights: {
      29183: 100,
    },
    county_names_all: "St. Charles",
    county_fips_all: 29183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63343,
    lat: 39.15775,
    lng: -90.82815,
    city: "Elsberry",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4683,
    density: 16.2,
    county_fips: 29113,
    county_name: "Lincoln",
    county_weights: {
      29113: 92.87,
      29163: 7.13,
    },
    county_names_all: "Lincoln|Pike",
    county_fips_all: "29113|29163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63344,
    lat: 39.23078,
    lng: -91.01115,
    city: "Eolia",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1168,
    density: 5.3,
    county_fips: 29163,
    county_name: "Pike",
    county_weights: {
      29113: 46.89,
      29163: 53.11,
    },
    county_names_all: "Pike|Lincoln",
    county_fips_all: "29163|29113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63345,
    lat: 39.27599,
    lng: -91.57311,
    city: "Farber",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 792,
    density: 15.9,
    county_fips: 29007,
    county_name: "Audrain",
    county_weights: {
      29007: 100,
    },
    county_names_all: "Audrain",
    county_fips_all: 29007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63347,
    lat: 39.0708,
    lng: -90.76352,
    city: "Foley",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2910,
    density: 30.7,
    county_fips: 29113,
    county_name: "Lincoln",
    county_weights: {
      29113: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 29113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63348,
    lat: 38.78969,
    lng: -90.94131,
    city: "Foristell",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8060,
    density: 55.7,
    county_fips: 29183,
    county_name: "St. Charles",
    county_weights: {
      29113: 2.12,
      29183: 77.94,
      29219: 19.94,
    },
    county_names_all: "St. Charles|Warren|Lincoln",
    county_fips_all: "29183|29219|29113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63349,
    lat: 38.97979,
    lng: -91.15083,
    city: "Hawk Point",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1916,
    density: 22.2,
    county_fips: 29113,
    county_name: "Lincoln",
    county_weights: {
      29113: 90.83,
      29219: 9.17,
    },
    county_names_all: "Lincoln|Warren",
    county_fips_all: "29113|29219",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63350,
    lat: 38.90243,
    lng: -91.35686,
    city: "High Hill",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 562,
    density: 9.2,
    county_fips: 29139,
    county_name: "Montgomery",
    county_weights: {
      29139: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 29139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63351,
    lat: 38.86041,
    lng: -91.31186,
    city: "Jonesburg",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1943,
    density: 13.5,
    county_fips: 29219,
    county_name: "Warren",
    county_weights: {
      29139: 45.06,
      29219: 54.94,
    },
    county_names_all: "Warren|Montgomery",
    county_fips_all: "29219|29139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63352,
    lat: 39.25097,
    lng: -91.65526,
    city: "Laddonia",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1204,
    density: 4.4,
    county_fips: 29007,
    county_name: "Audrain",
    county_weights: {
      29007: 89.61,
      29173: 10.39,
    },
    county_names_all: "Audrain|Ralls",
    county_fips_all: "29007|29173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63353,
    lat: 39.44375,
    lng: -91.12,
    city: "Louisiana",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4632,
    density: 21.3,
    county_fips: 29163,
    county_name: "Pike",
    county_weights: {
      29163: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 29163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63357,
    lat: 38.65518,
    lng: -91.0947,
    city: "Marthasville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7160,
    density: 22.5,
    county_fips: 29219,
    county_name: "Warren",
    county_weights: {
      29183: 3.64,
      29219: 96.36,
    },
    county_names_all: "Warren|St. Charles",
    county_fips_all: "29219|29183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63359,
    lat: 39.1564,
    lng: -91.34652,
    city: "Middletown",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1391,
    density: 3.6,
    county_fips: 29163,
    county_name: "Pike",
    county_weights: {
      29007: 8.21,
      29113: 2.9,
      29139: 36.32,
      29163: 52.57,
    },
    county_names_all: "Pike|Montgomery|Audrain|Lincoln",
    county_fips_all: "29163|29139|29007|29113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63361,
    lat: 38.95802,
    lng: -91.56056,
    city: "Montgomery City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4109,
    density: 9.9,
    county_fips: 29139,
    county_name: "Montgomery",
    county_weights: {
      29027: 23.99,
      29139: 76.01,
    },
    county_names_all: "Montgomery|Callaway",
    county_fips_all: "29139|29027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63362,
    lat: 38.93276,
    lng: -90.88227,
    city: "Moscow Mills",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7785,
    density: 79.1,
    county_fips: 29113,
    county_name: "Lincoln",
    county_weights: {
      29113: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 29113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63363,
    lat: 38.88187,
    lng: -91.45755,
    city: "New Florence",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1828,
    density: 8.1,
    county_fips: 29139,
    county_name: "Montgomery",
    county_weights: {
      29139: 96.15,
      29219: 3.85,
    },
    county_names_all: "Montgomery|Warren",
    county_fips_all: "29139|29219",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63365,
    lat: 38.70961,
    lng: -90.87334,
    city: "New Melle",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 29183,
    county_name: "St. Charles",
    county_weights: {
      29183: 100,
    },
    county_names_all: "St. Charles",
    county_fips_all: 29183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63366,
    lat: 38.85918,
    lng: -90.71964,
    city: "O'Fallon",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50541,
    density: 281.7,
    county_fips: 29183,
    county_name: "St. Charles",
    county_weights: {
      29183: 100,
    },
    county_names_all: "St. Charles",
    county_fips_all: 29183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63367,
    lat: 38.77805,
    lng: -90.79536,
    city: "Lake Saint Louis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25930,
    density: 773,
    county_fips: 29183,
    county_name: "St. Charles",
    county_weights: {
      29183: 100,
    },
    county_names_all: "St. Charles",
    county_fips_all: 29183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63368,
    lat: 38.7516,
    lng: -90.72895,
    city: "O'Fallon",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46301,
    density: 1102.5,
    county_fips: 29183,
    county_name: "St. Charles",
    county_weights: {
      29183: 100,
    },
    county_names_all: "St. Charles",
    county_fips_all: 29183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63369,
    lat: 38.93758,
    lng: -90.77766,
    city: "Old Monroe",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1870,
    density: 25.2,
    county_fips: 29113,
    county_name: "Lincoln",
    county_weights: {
      29113: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 29113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63373,
    lat: 38.92776,
    lng: -90.39563,
    city: "Portage Des Sioux",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 565,
    density: 11.7,
    county_fips: 29183,
    county_name: "St. Charles",
    county_weights: {
      29183: 100,
    },
    county_names_all: "St. Charles",
    county_fips_all: 29183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63376,
    lat: 38.80022,
    lng: -90.61636,
    city: "Saint Peters",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75031,
    density: 721.7,
    county_fips: 29183,
    county_name: "St. Charles",
    county_weights: {
      29183: 100,
    },
    county_names_all: "St. Charles",
    county_fips_all: 29183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63377,
    lat: 39.11016,
    lng: -91.10053,
    city: "Silex",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2754,
    density: 8.2,
    county_fips: 29113,
    county_name: "Lincoln",
    county_weights: {
      29113: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 29113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63379,
    lat: 38.99817,
    lng: -90.99037,
    city: "Troy",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26594,
    density: 75.6,
    county_fips: 29113,
    county_name: "Lincoln",
    county_weights: {
      29113: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 29113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63380,
    lat: 38.81262,
    lng: -91.12205,
    city: "Truesdale",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 29219,
    county_name: "Warren",
    county_weights: {
      29219: 100,
    },
    county_names_all: "Warren",
    county_fips_all: 29219,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63381,
    lat: 38.98237,
    lng: -91.25429,
    city: "Truxton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 566,
    density: 7.8,
    county_fips: 29219,
    county_name: "Warren",
    county_weights: {
      29113: 32.8,
      29139: 32.84,
      29219: 34.36,
    },
    county_names_all: "Warren|Montgomery|Lincoln",
    county_fips_all: "29219|29139|29113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63382,
    lat: 39.31104,
    lng: -91.49042,
    city: "Vandalia",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4445,
    density: 13.7,
    county_fips: 29007,
    county_name: "Audrain",
    county_weights: {
      29007: 47.54,
      29163: 11.37,
      29173: 41.09,
    },
    county_names_all: "Audrain|Ralls|Pike",
    county_fips_all: "29007|29173|29163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63383,
    lat: 38.80726,
    lng: -91.19319,
    city: "Warrenton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15631,
    density: 37.7,
    county_fips: 29219,
    county_name: "Warren",
    county_weights: {
      29113: 2.66,
      29219: 97.34,
    },
    county_names_all: "Warren|Lincoln",
    county_fips_all: "29219|29113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63384,
    lat: 39.08678,
    lng: -91.56349,
    city: "Wellsville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1967,
    density: 9.2,
    county_fips: 29139,
    county_name: "Montgomery",
    county_weights: {
      29007: 13.26,
      29027: 4.47,
      29139: 82.27,
    },
    county_names_all: "Montgomery|Audrain|Callaway",
    county_fips_all: "29139|29007|29027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63385,
    lat: 38.79732,
    lng: -90.85649,
    city: "Wentzville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46166,
    density: 266.8,
    county_fips: 29183,
    county_name: "St. Charles",
    county_weights: {
      29183: 100,
    },
    county_names_all: "St. Charles",
    county_fips_all: 29183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63386,
    lat: 38.87104,
    lng: -90.22009,
    city: "West Alton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 470,
    density: 5.5,
    county_fips: 29183,
    county_name: "St. Charles",
    county_weights: {
      29183: 100,
    },
    county_names_all: "St. Charles",
    county_fips_all: 29183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63387,
    lat: 39.18415,
    lng: -91.01677,
    city: "Whiteside",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 85,
    density: 350.8,
    county_fips: 29113,
    county_name: "Lincoln",
    county_weights: {
      29113: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 29113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63388,
    lat: 38.88816,
    lng: -91.74995,
    city: "Williamsburg",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 667,
    density: 4.3,
    county_fips: 29027,
    county_name: "Callaway",
    county_weights: {
      29027: 100,
    },
    county_names_all: "Callaway",
    county_fips_all: 29027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63389,
    lat: 38.99969,
    lng: -90.76875,
    city: "Winfield",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7010,
    density: 61.2,
    county_fips: 29113,
    county_name: "Lincoln",
    county_weights: {
      29113: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 29113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63390,
    lat: 38.80499,
    lng: -91.0413,
    city: "Wright City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10310,
    density: 50.9,
    county_fips: 29219,
    county_name: "Warren",
    county_weights: {
      29113: 12.01,
      29219: 87.99,
    },
    county_names_all: "Warren|Lincoln",
    county_fips_all: "29219|29113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63401,
    lat: 39.69046,
    lng: -91.45986,
    city: "Hannibal",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21571,
    density: 75.1,
    county_fips: 29127,
    county_name: "Marion",
    county_weights: {
      29127: 50.13,
      29173: 49.87,
    },
    county_names_all: "Marion|Ralls",
    county_fips_all: "29127|29173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63430,
    lat: 40.38972,
    lng: -91.53958,
    city: "Alexandria",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 724,
    density: 5.7,
    county_fips: 29045,
    county_name: "Clark",
    county_weights: {
      29045: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 29045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63431,
    lat: 39.74887,
    lng: -92.32893,
    city: "Anabel",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 380,
    density: 3.1,
    county_fips: 29121,
    county_name: "Macon",
    county_weights: {
      29121: 100,
    },
    county_names_all: "Macon",
    county_fips_all: 29121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63432,
    lat: 40.50058,
    lng: -91.99551,
    city: "Arbela",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 616,
    density: 2.8,
    county_fips: 29199,
    county_name: "Scotland",
    county_weights: {
      29045: 12.38,
      29199: 87.62,
    },
    county_names_all: "Scotland|Clark",
    county_fips_all: "29199|29045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63433,
    lat: 39.51838,
    lng: -91.11816,
    city: "Ashburn",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 29163,
    county_name: "Pike",
    county_weights: {
      29163: 100,
    },
    county_names_all: "Pike",
    county_fips_all: 29163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63434,
    lat: 39.90591,
    lng: -91.9507,
    city: "Bethel",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 674,
    density: 4,
    county_fips: 29205,
    county_name: "Shelby",
    county_weights: {
      29205: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 29205,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63435,
    lat: 40.20299,
    lng: -91.58267,
    city: "Canton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3940,
    density: 10.5,
    county_fips: 29111,
    county_name: "Lewis",
    county_weights: {
      29045: 31.78,
      29111: 68.22,
    },
    county_names_all: "Lewis|Clark",
    county_fips_all: "29111|29045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63436,
    lat: 39.50093,
    lng: -91.54524,
    city: "Center",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1401,
    density: 6.8,
    county_fips: 29173,
    county_name: "Ralls",
    county_weights: {
      29173: 100,
    },
    county_names_all: "Ralls",
    county_fips_all: 29173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63437,
    lat: 39.72576,
    lng: -92.23679,
    city: "Clarence",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1630,
    density: 5,
    county_fips: 29205,
    county_name: "Shelby",
    county_weights: {
      29121: 4.69,
      29137: 8.46,
      29205: 86.85,
    },
    county_names_all: "Shelby|Monroe|Macon",
    county_fips_all: "29205|29137|29121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63438,
    lat: 39.96084,
    lng: -91.68828,
    city: "Durham",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 322,
    density: 9.4,
    county_fips: 29111,
    county_name: "Lewis",
    county_weights: {
      29111: 67.35,
      29127: 32.65,
    },
    county_names_all: "Lewis|Marion",
    county_fips_all: "29111|29127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63439,
    lat: 39.80382,
    lng: -91.85963,
    city: "Emden",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 203,
    density: 3.6,
    county_fips: 29205,
    county_name: "Shelby",
    county_weights: {
      29127: 27.68,
      29205: 72.32,
    },
    county_names_all: "Shelby|Marion",
    county_fips_all: "29205|29127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63440,
    lat: 39.97551,
    lng: -91.75376,
    city: "Ewing",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1121,
    density: 5,
    county_fips: 29111,
    county_name: "Lewis",
    county_weights: {
      29111: 72.07,
      29127: 25.61,
      29205: 2.32,
    },
    county_names_all: "Lewis|Marion|Shelby",
    county_fips_all: "29111|29127|29205",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63441,
    lat: 39.4766,
    lng: -91.31575,
    city: "Frankford",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 971,
    density: 3.8,
    county_fips: 29163,
    county_name: "Pike",
    county_weights: {
      29163: 90.04,
      29173: 9.96,
    },
    county_names_all: "Pike|Ralls",
    county_fips_all: "29163|29173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63443,
    lat: 39.66222,
    lng: -91.86697,
    city: "Hunnewell",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 240,
    density: 1.8,
    county_fips: 29137,
    county_name: "Monroe",
    county_weights: {
      29127: 17.72,
      29137: 48.68,
      29205: 33.6,
    },
    county_names_all: "Monroe|Shelby|Marion",
    county_fips_all: "29137|29205|29127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63445,
    lat: 40.39681,
    lng: -91.72044,
    city: "Kahoka",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3496,
    density: 8.7,
    county_fips: 29045,
    county_name: "Clark",
    county_weights: {
      29045: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 29045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63446,
    lat: 40.13972,
    lng: -92.0055,
    city: "Knox City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 592,
    density: 2.2,
    county_fips: 29103,
    county_name: "Knox",
    county_weights: {
      29103: 91.88,
      29111: 8.12,
    },
    county_names_all: "Knox|Lewis",
    county_fips_all: "29103|29111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63447,
    lat: 40.09251,
    lng: -91.90494,
    city: "La Belle",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1217,
    density: 5.2,
    county_fips: 29111,
    county_name: "Lewis",
    county_weights: {
      29103: 4.46,
      29111: 95.54,
    },
    county_names_all: "Lewis|Knox",
    county_fips_all: "29111|29103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63448,
    lat: 40.02168,
    lng: -91.55416,
    city: "La Grange",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1466,
    density: 11.4,
    county_fips: 29111,
    county_name: "Lewis",
    county_weights: {
      29111: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 29111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63450,
    lat: 39.66808,
    lng: -92.14857,
    city: "Lentner",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 160,
    density: 2.4,
    county_fips: 29205,
    county_name: "Shelby",
    county_weights: {
      29137: 43.6,
      29205: 56.4,
    },
    county_names_all: "Shelby|Monroe",
    county_fips_all: "29205|29137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63451,
    lat: 39.91135,
    lng: -92.19728,
    city: "Leonard",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 167,
    density: 1,
    county_fips: 29205,
    county_name: "Shelby",
    county_weights: {
      29103: 9.67,
      29205: 90.33,
    },
    county_names_all: "Shelby|Knox",
    county_fips_all: "29205|29103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63452,
    lat: 40.09316,
    lng: -91.78551,
    city: "Lewistown",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1477,
    density: 5.7,
    county_fips: 29111,
    county_name: "Lewis",
    county_weights: {
      29111: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 29111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63453,
    lat: 40.49511,
    lng: -91.86495,
    city: "Luray",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 484,
    density: 3.5,
    county_fips: 29045,
    county_name: "Clark",
    county_weights: {
      29045: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 29045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63454,
    lat: 39.92389,
    lng: -91.64897,
    city: "Maywood",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1019,
    density: 9.4,
    county_fips: 29127,
    county_name: "Marion",
    county_weights: {
      29111: 28.35,
      29127: 71.65,
    },
    county_names_all: "Marion|Lewis",
    county_fips_all: "29127|29111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63456,
    lat: 39.65364,
    lng: -91.72693,
    city: "Monroe City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4500,
    density: 9.6,
    county_fips: 29127,
    county_name: "Marion",
    county_weights: {
      29127: 38.25,
      29137: 26.65,
      29173: 35.11,
    },
    county_names_all: "Marion|Ralls|Monroe",
    county_fips_all: "29127|29173|29137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63457,
    lat: 40.17272,
    lng: -91.70115,
    city: "Monticello",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 240,
    density: 2.6,
    county_fips: 29111,
    county_name: "Lewis",
    county_weights: {
      29111: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 29111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63458,
    lat: 39.98751,
    lng: -92.01745,
    city: "Newark",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 88,
    density: 1.2,
    county_fips: 29103,
    county_name: "Knox",
    county_weights: {
      29103: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 29103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63459,
    lat: 39.58392,
    lng: -91.3795,
    city: "New London",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4055,
    density: 11.3,
    county_fips: 29173,
    county_name: "Ralls",
    county_weights: {
      29163: 8.55,
      29173: 91.45,
    },
    county_names_all: "Ralls|Pike",
    county_fips_all: "29173|29163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63460,
    lat: 40.00237,
    lng: -92.21002,
    city: "Novelty",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 329,
    density: 1.6,
    county_fips: 29103,
    county_name: "Knox",
    county_weights: {
      29103: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 29103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63461,
    lat: 39.79757,
    lng: -91.55577,
    city: "Palmyra",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5395,
    density: 13.4,
    county_fips: 29127,
    county_name: "Marion",
    county_weights: {
      29127: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 29127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63462,
    lat: 39.42279,
    lng: -91.69977,
    city: "Perry",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1744,
    density: 5.4,
    county_fips: 29173,
    county_name: "Ralls",
    county_weights: {
      29137: 41.42,
      29173: 58.58,
    },
    county_names_all: "Ralls|Monroe",
    county_fips_all: "29173|29137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63463,
    lat: 39.84533,
    lng: -91.75976,
    city: "Philadelphia",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 697,
    density: 5.8,
    county_fips: 29127,
    county_name: "Marion",
    county_weights: {
      29127: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 29127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63465,
    lat: 40.52307,
    lng: -91.6898,
    city: "Revere",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 340,
    density: 2.3,
    county_fips: 29045,
    county_name: "Clark",
    county_weights: {
      29045: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 29045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63466,
    lat: 40.26627,
    lng: -91.61751,
    city: "Saint Patrick",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 29045,
    county_name: "Clark",
    county_weights: {
      29045: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 29045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63467,
    lat: 39.64849,
    lng: -91.26655,
    city: "Saverton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37,
    density: 46.7,
    county_fips: 29173,
    county_name: "Ralls",
    county_weights: {
      29173: 100,
    },
    county_names_all: "Ralls",
    county_fips_all: 29173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63468,
    lat: 39.67857,
    lng: -92.01267,
    city: "Shelbina",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2456,
    density: 6.5,
    county_fips: 29205,
    county_name: "Shelby",
    county_weights: {
      29137: 37.92,
      29205: 62.08,
    },
    county_names_all: "Shelby|Monroe",
    county_fips_all: "29205|29137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63469,
    lat: 39.8323,
    lng: -92.04401,
    city: "Shelbyville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1000,
    density: 3,
    county_fips: 29205,
    county_name: "Shelby",
    county_weights: {
      29103: 2.96,
      29205: 97.04,
    },
    county_names_all: "Shelby|Knox",
    county_fips_all: "29205|29103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63471,
    lat: 39.92511,
    lng: -91.50652,
    city: "Taylor",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 982,
    density: 8.2,
    county_fips: 29127,
    county_name: "Marion",
    county_weights: {
      29111: 22.27,
      29127: 77.73,
    },
    county_names_all: "Marion|Lewis",
    county_fips_all: "29127|29111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63472,
    lat: 40.4053,
    lng: -91.57734,
    city: "Wayland",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 728,
    density: 336.9,
    county_fips: 29045,
    county_name: "Clark",
    county_weights: {
      29045: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 29045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63473,
    lat: 40.25263,
    lng: -91.77803,
    city: "Williamstown",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 251,
    density: 1.6,
    county_fips: 29111,
    county_name: "Lewis",
    county_weights: {
      29045: 47.96,
      29111: 52.04,
    },
    county_names_all: "Lewis|Clark",
    county_fips_all: "29111|29045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63474,
    lat: 40.3473,
    lng: -91.89674,
    city: "Wyaconda",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 393,
    density: 1.9,
    county_fips: 29045,
    county_name: "Clark",
    county_weights: {
      29045: 93.81,
      29111: 1.89,
      29199: 4.3,
    },
    county_names_all: "Clark|Scotland|Lewis",
    county_fips_all: "29045|29199|29111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63501,
    lat: 40.16745,
    lng: -92.59078,
    city: "Kirksville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20947,
    density: 39.2,
    county_fips: 29001,
    county_name: "Adair",
    county_weights: {
      29001: 100,
    },
    county_names_all: "Adair",
    county_fips_all: 29001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63530,
    lat: 39.90732,
    lng: -92.45037,
    city: "Atlanta",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1212,
    density: 4.4,
    county_fips: 29121,
    county_name: "Macon",
    county_weights: {
      29121: 100,
    },
    county_names_all: "Macon",
    county_fips_all: 29121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63531,
    lat: 40.30002,
    lng: -92.25248,
    city: "Baring",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 423,
    density: 2,
    county_fips: 29103,
    county_name: "Knox",
    county_weights: {
      29103: 53.66,
      29199: 46.34,
    },
    county_names_all: "Knox|Scotland",
    county_fips_all: "29103|29199",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63532,
    lat: 39.7677,
    lng: -92.57434,
    city: "Bevier",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1158,
    density: 9,
    county_fips: 29121,
    county_name: "Macon",
    county_weights: {
      29121: 100,
    },
    county_names_all: "Macon",
    county_fips_all: 29121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63533,
    lat: 40.20471,
    lng: -92.39608,
    city: "Brashear",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 864,
    density: 5.3,
    county_fips: 29001,
    county_name: "Adair",
    county_weights: {
      29001: 91.18,
      29103: 8.82,
    },
    county_names_all: "Adair|Knox",
    county_fips_all: "29001|29103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63534,
    lat: 39.74061,
    lng: -92.64838,
    city: "Callao",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 926,
    density: 4.8,
    county_fips: 29121,
    county_name: "Macon",
    county_weights: {
      29121: 98.1,
      29175: 1.9,
    },
    county_names_all: "Macon|Randolph",
    county_fips_all: "29121|29175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63535,
    lat: 40.57244,
    lng: -92.67946,
    city: "Coatsville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24,
    density: 0.6,
    county_fips: 29197,
    county_name: "Schuyler",
    county_weights: {
      29171: 31.68,
      29197: 68.32,
    },
    county_names_all: "Schuyler|Putnam",
    county_fips_all: "29197|29171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63536,
    lat: 40.48423,
    lng: -92.3574,
    city: "Downing",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1017,
    density: 4.7,
    county_fips: 29197,
    county_name: "Schuyler",
    county_weights: {
      29197: 55.07,
      29199: 44.93,
    },
    county_names_all: "Schuyler|Scotland",
    county_fips_all: "29197|29199",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63537,
    lat: 40.14776,
    lng: -92.16172,
    city: "Edina",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2295,
    density: 6.7,
    county_fips: 29103,
    county_name: "Knox",
    county_weights: {
      29103: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 29103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63538,
    lat: 39.9526,
    lng: -92.67327,
    city: "Elmer",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 298,
    density: 2,
    county_fips: 29121,
    county_name: "Macon",
    county_weights: {
      29121: 100,
    },
    county_names_all: "Macon",
    county_fips_all: 29121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63539,
    lat: 39.9279,
    lng: -92.76781,
    city: "Ethel",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 233,
    density: 1.5,
    county_fips: 29121,
    county_name: "Macon",
    county_weights: {
      29121: 100,
    },
    county_names_all: "Macon",
    county_fips_all: 29121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63540,
    lat: 40.09782,
    lng: -92.40792,
    city: "Gibbs",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 115,
    density: 3.2,
    county_fips: 29001,
    county_name: "Adair",
    county_weights: {
      29001: 100,
    },
    county_names_all: "Adair",
    county_fips_all: 29001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63541,
    lat: 40.50355,
    lng: -92.63331,
    city: "Glenwood",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 594,
    density: 5.3,
    county_fips: 29197,
    county_name: "Schuyler",
    county_weights: {
      29197: 100,
    },
    county_names_all: "Schuyler",
    county_fips_all: 29197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63543,
    lat: 40.35765,
    lng: -92.00976,
    city: "Gorin",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 223,
    density: 2.3,
    county_fips: 29199,
    county_name: "Scotland",
    county_weights: {
      29199: 100,
    },
    county_names_all: "Scotland",
    county_fips_all: 29199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63544,
    lat: 40.24603,
    lng: -92.84943,
    city: "Green Castle",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 903,
    density: 2.5,
    county_fips: 29001,
    county_name: "Adair",
    county_weights: {
      29001: 45,
      29171: 12.06,
      29211: 42.94,
    },
    county_names_all: "Adair|Sullivan|Putnam",
    county_fips_all: "29001|29211|29171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63545,
    lat: 40.26721,
    lng: -92.9677,
    city: "Green City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 907,
    density: 3.4,
    county_fips: 29211,
    county_name: "Sullivan",
    county_weights: {
      29211: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 29211,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63546,
    lat: 40.33129,
    lng: -92.50882,
    city: "Greentop",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1885,
    density: 6.4,
    county_fips: 29001,
    county_name: "Adair",
    county_weights: {
      29001: 64.99,
      29197: 32.95,
      29199: 2.06,
    },
    county_names_all: "Adair|Schuyler|Scotland",
    county_fips_all: "29001|29197|29199",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63547,
    lat: 40.13492,
    lng: -92.30651,
    city: "Hurdland",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 392,
    density: 2.2,
    county_fips: 29103,
    county_name: "Knox",
    county_weights: {
      29001: 11,
      29103: 89,
    },
    county_names_all: "Knox|Adair",
    county_fips_all: "29103|29001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63548,
    lat: 40.53405,
    lng: -92.4953,
    city: "Lancaster",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1086,
    density: 5,
    county_fips: 29197,
    county_name: "Schuyler",
    county_weights: {
      29197: 100,
    },
    county_names_all: "Schuyler",
    county_fips_all: 29197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63549,
    lat: 40.0167,
    lng: -92.49172,
    city: "La Plata",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2562,
    density: 7.3,
    county_fips: 29121,
    county_name: "Macon",
    county_weights: {
      29001: 29.2,
      29103: 2.32,
      29121: 68.48,
    },
    county_names_all: "Macon|Adair|Knox",
    county_fips_all: "29121|29001|29103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63551,
    lat: 40.49921,
    lng: -92.74252,
    city: "Livonia",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 388,
    density: 3.4,
    county_fips: 29171,
    county_name: "Putnam",
    county_weights: {
      29171: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 29171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63552,
    lat: 39.75349,
    lng: -92.45075,
    city: "Macon",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7378,
    density: 21.4,
    county_fips: 29121,
    county_name: "Macon",
    county_weights: {
      29121: 100,
    },
    county_names_all: "Macon",
    county_fips_all: 29121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63555,
    lat: 40.48458,
    lng: -92.18698,
    city: "Memphis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3380,
    density: 6.7,
    county_fips: 29199,
    county_name: "Scotland",
    county_weights: {
      29199: 100,
    },
    county_names_all: "Scotland",
    county_fips_all: 29199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63556,
    lat: 40.18251,
    lng: -93.11723,
    city: "Milan",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3608,
    density: 5.8,
    county_fips: 29211,
    county_name: "Sullivan",
    county_weights: {
      29211: 100,
    },
    county_names_all: "Sullivan",
    county_fips_all: 29211,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63557,
    lat: 39.98297,
    lng: -92.88045,
    city: "New Boston",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 248,
    density: 1.1,
    county_fips: 29115,
    county_name: "Linn",
    county_weights: {
      29001: 9.19,
      29115: 66.35,
      29121: 21.28,
      29211: 3.18,
    },
    county_names_all: "Linn|Macon|Adair|Sullivan",
    county_fips_all: "29115|29121|29001|29211",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63558,
    lat: 39.74168,
    lng: -92.75244,
    city: "New Cambria",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 633,
    density: 2.2,
    county_fips: 29121,
    county_name: "Macon",
    county_weights: {
      29041: 31.29,
      29121: 68.71,
    },
    county_names_all: "Macon|Chariton",
    county_fips_all: "29121|29041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63559,
    lat: 40.22674,
    lng: -92.74528,
    city: "Novinger",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1837,
    density: 6.4,
    county_fips: 29001,
    county_name: "Adair",
    county_weights: {
      29001: 88.31,
      29171: 11.69,
    },
    county_names_all: "Adair|Putnam",
    county_fips_all: "29001|29171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63560,
    lat: 40.3574,
    lng: -93.12291,
    city: "Pollock",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 128,
    density: 1.3,
    county_fips: 29211,
    county_name: "Sullivan",
    county_weights: {
      29171: 12.79,
      29211: 87.21,
    },
    county_names_all: "Sullivan|Putnam",
    county_fips_all: "29211|29171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63561,
    lat: 40.41408,
    lng: -92.54317,
    city: "Queen City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1065,
    density: 4.8,
    county_fips: 29197,
    county_name: "Schuyler",
    county_weights: {
      29197: 100,
    },
    county_names_all: "Schuyler",
    county_fips_all: 29197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63563,
    lat: 40.30387,
    lng: -92.07439,
    city: "Rutledge",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 540,
    density: 2.8,
    county_fips: 29103,
    county_name: "Knox",
    county_weights: {
      29103: 51.96,
      29199: 48.04,
    },
    county_names_all: "Knox|Scotland",
    county_fips_all: "29103|29199",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63565,
    lat: 40.48263,
    lng: -92.95447,
    city: "Unionville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3640,
    density: 5.2,
    county_fips: 29171,
    county_name: "Putnam",
    county_weights: {
      29171: 98.28,
      29211: 1.72,
    },
    county_names_all: "Putnam|Sullivan",
    county_fips_all: "29171|29211",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63566,
    lat: 40.03139,
    lng: -92.94793,
    city: "Winigan",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 104,
    density: 2.1,
    county_fips: 29115,
    county_name: "Linn",
    county_weights: {
      29115: 60.79,
      29211: 39.21,
    },
    county_names_all: "Linn|Sullivan",
    county_fips_all: "29115|29211",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63567,
    lat: 40.41332,
    lng: -92.70461,
    city: "Worthington",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 163,
    density: 8.9,
    county_fips: 29171,
    county_name: "Putnam",
    county_weights: {
      29171: 99.8,
      29197: 0.2,
    },
    county_names_all: "Putnam|Schuyler",
    county_fips_all: "29171|29197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63601,
    lat: 37.8212,
    lng: -90.5439,
    city: "Park Hills",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16051,
    density: 103.8,
    county_fips: 29187,
    county_name: "St. Francois",
    county_weights: {
      29187: 100,
    },
    county_names_all: "St. Francois",
    county_fips_all: 29187,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63620,
    lat: 37.40101,
    lng: -90.6521,
    city: "Annapolis",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1319,
    density: 2.7,
    county_fips: 29093,
    county_name: "Iron",
    county_weights: {
      29093: 68.36,
      29123: 20.92,
      29179: 10.72,
    },
    county_names_all: "Iron|Madison|Reynolds",
    county_fips_all: "29093|29123|29179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63621,
    lat: 37.48225,
    lng: -90.57916,
    city: "Arcadia",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1445,
    density: 7.3,
    county_fips: 29093,
    county_name: "Iron",
    county_weights: {
      29093: 68.87,
      29123: 31.13,
    },
    county_names_all: "Iron|Madison",
    county_fips_all: "29093|29123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63622,
    lat: 37.78901,
    lng: -90.90584,
    city: "Belgrade",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1167,
    density: 9.9,
    county_fips: 29221,
    county_name: "Washington",
    county_weights: {
      29221: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 29221,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63623,
    lat: 37.67532,
    lng: -90.8941,
    city: "Belleview",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 764,
    density: 2.8,
    county_fips: 29093,
    county_name: "Iron",
    county_weights: {
      29093: 100,
    },
    county_names_all: "Iron",
    county_fips_all: 29093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63624,
    lat: 37.7531,
    lng: -90.63923,
    city: "Bismarck",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3801,
    density: 24.1,
    county_fips: 29187,
    county_name: "St. Francois",
    county_weights: {
      29093: 16.22,
      29187: 54.83,
      29221: 28.95,
    },
    county_names_all: "St. Francois|Washington|Iron",
    county_fips_all: "29187|29221|29093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63625,
    lat: 37.56374,
    lng: -90.98734,
    city: "Black",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 424,
    density: 2,
    county_fips: 29179,
    county_name: "Reynolds",
    county_weights: {
      29093: 18.06,
      29179: 81.94,
    },
    county_names_all: "Reynolds|Iron",
    county_fips_all: "29179|29093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63626,
    lat: 38.07721,
    lng: -90.71471,
    city: "Blackwell",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1057,
    density: 19.2,
    county_fips: 29221,
    county_name: "Washington",
    county_weights: {
      29187: 18.36,
      29221: 81.64,
    },
    county_names_all: "Washington|St. Francois",
    county_fips_all: "29221|29187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63627,
    lat: 38.03625,
    lng: -90.25317,
    city: "Bloomsdale",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3504,
    density: 18.5,
    county_fips: 29186,
    county_name: "Ste. Genevieve",
    county_weights: {
      29099: 5.6,
      29186: 94.4,
    },
    county_names_all: "Ste. Genevieve|Jefferson",
    county_fips_all: "29186|29099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63628,
    lat: 37.9392,
    lng: -90.52466,
    city: "Bonne Terre",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15011,
    density: 48.2,
    county_fips: 29187,
    county_name: "St. Francois",
    county_weights: {
      29099: 1.96,
      29186: 7.71,
      29187: 84.03,
      29221: 6.3,
    },
    county_names_all: "St. Francois|Ste. Genevieve|Washington|Jefferson",
    county_fips_all: "29187|29186|29221|29099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63629,
    lat: 37.39847,
    lng: -91.23861,
    city: "Bunker",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1109,
    density: 1.5,
    county_fips: 29203,
    county_name: "Shannon",
    county_weights: {
      29065: 19.3,
      29179: 32.9,
      29203: 47.81,
    },
    county_names_all: "Shannon|Reynolds|Dent",
    county_fips_all: "29203|29179|29065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63630,
    lat: 38.01874,
    lng: -90.72727,
    city: "Cadet",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3956,
    density: 22.6,
    county_fips: 29221,
    county_name: "Washington",
    county_weights: {
      29187: 6.68,
      29221: 93.32,
    },
    county_names_all: "Washington|St. Francois",
    county_fips_all: "29221|29187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63631,
    lat: 37.74912,
    lng: -90.78873,
    city: "Caledonia",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 932,
    density: 8.7,
    county_fips: 29221,
    county_name: "Washington",
    county_weights: {
      29093: 35.5,
      29221: 64.5,
    },
    county_names_all: "Washington|Iron",
    county_fips_all: "29221|29093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63633,
    lat: 37.41993,
    lng: -91.01082,
    city: "Centerville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 788,
    density: 3.3,
    county_fips: 29179,
    county_name: "Reynolds",
    county_weights: {
      29179: 100,
    },
    county_names_all: "Reynolds",
    county_fips_all: 29179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63636,
    lat: 37.29542,
    lng: -90.57549,
    city: "Des Arc",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 594,
    density: 5.2,
    county_fips: 29093,
    county_name: "Iron",
    county_weights: {
      29093: 45.93,
      29123: 23.52,
      29223: 30.55,
    },
    county_names_all: "Iron|Wayne|Madison",
    county_fips_all: "29093|29223|29123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63637,
    lat: 37.70511,
    lng: -90.51875,
    city: "Doe Run",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1177,
    density: 22.9,
    county_fips: 29187,
    county_name: "St. Francois",
    county_weights: {
      29187: 100,
    },
    county_names_all: "St. Francois",
    county_fips_all: 29187,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63638,
    lat: 37.21727,
    lng: -91.01135,
    city: "Ellington",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2808,
    density: 3.7,
    county_fips: 29179,
    county_name: "Reynolds",
    county_weights: {
      29179: 82.04,
      29203: 17.96,
    },
    county_names_all: "Reynolds|Shannon",
    county_fips_all: "29179|29203",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63640,
    lat: 37.75446,
    lng: -90.36525,
    city: "Farmington",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28762,
    density: 53.1,
    county_fips: 29187,
    county_name: "St. Francois",
    county_weights: {
      29186: 33.98,
      29187: 66.02,
    },
    county_names_all: "St. Francois|Ste. Genevieve",
    county_fips_all: "29187|29186",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63645,
    lat: 37.54204,
    lng: -90.32428,
    city: "Fredericktown",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11424,
    density: 12.3,
    county_fips: 29123,
    county_name: "Madison",
    county_weights: {
      29123: 87.49,
      29186: 4.26,
      29187: 8.25,
    },
    county_names_all: "Madison|St. Francois|Ste. Genevieve",
    county_fips_all: "29123|29187|29186",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63648,
    lat: 37.8187,
    lng: -90.69878,
    city: "Irondale",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1411,
    density: 17.4,
    county_fips: 29221,
    county_name: "Washington",
    county_weights: {
      29187: 7.39,
      29221: 92.61,
    },
    county_names_all: "Washington|St. Francois",
    county_fips_all: "29221|29187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63650,
    lat: 37.6103,
    lng: -90.62994,
    city: "Ironton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4065,
    density: 14,
    county_fips: 29093,
    county_name: "Iron",
    county_weights: {
      29093: 75.31,
      29123: 3.08,
      29187: 21.61,
    },
    county_names_all: "Iron|St. Francois|Madison",
    county_fips_all: "29093|29187|29123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63653,
    lat: 37.86139,
    lng: -90.58789,
    city: "Leadwood",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1472,
    density: 522.2,
    county_fips: 29187,
    county_name: "St. Francois",
    county_weights: {
      29187: 100,
    },
    county_names_all: "St. Francois",
    county_fips_all: 29187,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63654,
    lat: 37.45941,
    lng: -90.85156,
    city: "Lesterville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 573,
    density: 3.1,
    county_fips: 29179,
    county_name: "Reynolds",
    county_weights: {
      29093: 1.21,
      29179: 98.79,
    },
    county_names_all: "Reynolds|Iron",
    county_fips_all: "29179|29093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63655,
    lat: 37.39312,
    lng: -90.20552,
    city: "Marquand",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1435,
    density: 3.6,
    county_fips: 29123,
    county_name: "Madison",
    county_weights: {
      29017: 22.24,
      29123: 65.75,
      29223: 12.01,
    },
    county_names_all: "Madison|Bollinger|Wayne",
    county_fips_all: "29123|29017|29223",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63656,
    lat: 37.59664,
    lng: -90.79483,
    city: "Middle Brook",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 286,
    density: 1.6,
    county_fips: 29093,
    county_name: "Iron",
    county_weights: {
      29093: 50.71,
      29179: 49.29,
    },
    county_names_all: "Iron|Reynolds",
    county_fips_all: "29093|29179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63660,
    lat: 37.91241,
    lng: -90.70241,
    city: "Mineral Point",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3912,
    density: 43,
    county_fips: 29221,
    county_name: "Washington",
    county_weights: {
      29221: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 29221,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63662,
    lat: 37.53782,
    lng: -90.05321,
    city: "Patton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1751,
    density: 11.3,
    county_fips: 29017,
    county_name: "Bollinger",
    county_weights: {
      29017: 100,
    },
    county_names_all: "Bollinger",
    county_fips_all: 29017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63663,
    lat: 37.62446,
    lng: -90.64638,
    city: "Pilot Knob",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 789,
    density: 388.2,
    county_fips: 29093,
    county_name: "Iron",
    county_weights: {
      29093: 100,
    },
    county_names_all: "Iron",
    county_fips_all: 29093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63664,
    lat: 37.92161,
    lng: -90.91661,
    city: "Potosi",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9153,
    density: 12.3,
    county_fips: 29221,
    county_name: "Washington",
    county_weights: {
      29221: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 29221,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63665,
    lat: 37.29055,
    lng: -90.84087,
    city: "Redford",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 185,
    density: 0.8,
    county_fips: 29179,
    county_name: "Reynolds",
    county_weights: {
      29179: 100,
    },
    county_names_all: "Reynolds",
    county_fips_all: 29179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63670,
    lat: 37.89667,
    lng: -90.16245,
    city: "Sainte Genevieve",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11540,
    density: 17.7,
    county_fips: 29186,
    county_name: "Ste. Genevieve",
    county_weights: {
      29186: 100,
    },
    county_names_all: "Ste. Genevieve",
    county_fips_all: 29186,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63673,
    lat: 37.83641,
    lng: -89.98861,
    city: "Saint Mary",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1688,
    density: 5.7,
    county_fips: 29186,
    county_name: "Ste. Genevieve",
    county_weights: {
      17157: 21.64,
      29157: 29.55,
      29186: 48.82,
    },
    county_names_all: "Ste. Genevieve|Perry|Randolph",
    county_fips_all: "29186|29157|17157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63674,
    lat: 38.03126,
    lng: -90.65933,
    city: "Tiff",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 29221,
    county_name: "Washington",
    county_weights: {
      29187: 0.11,
      29221: 99.89,
    },
    county_names_all: "Washington|St. Francois",
    county_fips_all: "29221|29187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63675,
    lat: 37.30112,
    lng: -90.697,
    city: "Vulcan",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 87,
    density: 2.2,
    county_fips: 29093,
    county_name: "Iron",
    county_weights: {
      29093: 100,
    },
    county_names_all: "Iron",
    county_fips_all: 29093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63701,
    lat: 37.33522,
    lng: -89.58043,
    city: "Cape Girardeau",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38310,
    density: 111.5,
    county_fips: 29031,
    county_name: "Cape Girardeau",
    county_weights: {
      29031: 100,
    },
    county_names_all: "Cape Girardeau",
    county_fips_all: 29031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63703,
    lat: 37.27373,
    lng: -89.53981,
    city: "Cape Girardeau",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8476,
    density: 253.3,
    county_fips: 29031,
    county_name: "Cape Girardeau",
    county_weights: {
      29031: 100,
    },
    county_names_all: "Cape Girardeau",
    county_fips_all: 29031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63730,
    lat: 37.09496,
    lng: -89.91841,
    city: "Advance",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3543,
    density: 12.1,
    county_fips: 29207,
    county_name: "Stoddard",
    county_weights: {
      29017: 33.9,
      29031: 11.54,
      29207: 54.56,
    },
    county_names_all: "Stoddard|Bollinger|Cape Girardeau",
    county_fips_all: "29207|29017|29031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63732,
    lat: 37.59428,
    lng: -89.59123,
    city: "Altenburg",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1048,
    density: 12,
    county_fips: 29157,
    county_name: "Perry",
    county_weights: {
      29031: 37.71,
      29157: 62.29,
    },
    county_names_all: "Perry|Cape Girardeau",
    county_fips_all: "29157|29031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63735,
    lat: 36.98015,
    lng: -89.78139,
    city: "Bell City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 748,
    density: 5.1,
    county_fips: 29207,
    county_name: "Stoddard",
    county_weights: {
      29201: 10.56,
      29207: 89.44,
    },
    county_names_all: "Stoddard|Scott",
    county_fips_all: "29207|29201",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63736,
    lat: 37.08033,
    lng: -89.52072,
    city: "Benton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3793,
    density: 24.1,
    county_fips: 29201,
    county_name: "Scott",
    county_weights: {
      29201: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 29201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63738,
    lat: 37.08936,
    lng: -89.95729,
    city: "Brownwood",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 29207,
    county_name: "Stoddard",
    county_weights: {
      29207: 100,
    },
    county_names_all: "Stoddard",
    county_fips_all: 29207,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63739,
    lat: 37.35686,
    lng: -89.80216,
    city: "Burfordville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 555,
    density: 14.7,
    county_fips: 29031,
    county_name: "Cape Girardeau",
    county_weights: {
      29031: 100,
    },
    county_names_all: "Cape Girardeau",
    county_fips_all: 29031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63740,
    lat: 37.17564,
    lng: -89.68557,
    city: "Chaffee",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5561,
    density: 24.4,
    county_fips: 29201,
    county_name: "Scott",
    county_weights: {
      29031: 49.64,
      29201: 50.36,
    },
    county_names_all: "Scott|Cape Girardeau",
    county_fips_all: "29201|29031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63742,
    lat: 37.1583,
    lng: -89.44672,
    city: "Commerce",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 79,
    density: 88.2,
    county_fips: 29201,
    county_name: "Scott",
    county_weights: {
      29201: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 29201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63743,
    lat: 37.51886,
    lng: -89.83261,
    city: "Daisy",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59,
    density: 5.7,
    county_fips: 29031,
    county_name: "Cape Girardeau",
    county_weights: {
      29031: 100,
    },
    county_names_all: "Cape Girardeau",
    county_fips_all: 29031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63744,
    lat: 37.19331,
    lng: -89.71831,
    city: "Delta",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 29031,
    county_name: "Cape Girardeau",
    county_weights: {
      29031: 100,
    },
    county_names_all: "Cape Girardeau",
    county_fips_all: 29031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63745,
    lat: 37.25596,
    lng: -89.65946,
    city: "Dutchtown",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8,
    density: 9.5,
    county_fips: 29031,
    county_name: "Cape Girardeau",
    county_weights: {
      29031: 100,
    },
    county_names_all: "Cape Girardeau",
    county_fips_all: 29031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63746,
    lat: 37.70783,
    lng: -89.69484,
    city: "Farrar",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38,
    density: 11.6,
    county_fips: 29157,
    county_name: "Perry",
    county_weights: {
      29157: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 29157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63747,
    lat: 37.55993,
    lng: -89.81121,
    city: "Friedheim",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 537,
    density: 10.6,
    county_fips: 29031,
    county_name: "Cape Girardeau",
    county_weights: {
      29031: 100,
    },
    county_names_all: "Cape Girardeau",
    county_fips_all: 29031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63748,
    lat: 37.66912,
    lng: -89.61282,
    city: "Frohna",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1180,
    density: 6.1,
    county_fips: 29157,
    county_name: "Perry",
    county_weights: {
      29157: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 29157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63750,
    lat: 37.1508,
    lng: -90.16917,
    city: "Gipsy",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20,
    density: 0.9,
    county_fips: 29017,
    county_name: "Bollinger",
    county_weights: {
      29017: 100,
    },
    county_names_all: "Bollinger",
    county_fips_all: 29017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63751,
    lat: 37.2742,
    lng: -90.12404,
    city: "Glenallen",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1416,
    density: 5,
    county_fips: 29017,
    county_name: "Bollinger",
    county_weights: {
      29017: 100,
    },
    county_names_all: "Bollinger",
    county_fips_all: 29017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63755,
    lat: 37.44351,
    lng: -89.64193,
    city: "Jackson",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25051,
    density: 54.6,
    county_fips: 29031,
    county_name: "Cape Girardeau",
    county_weights: {
      29031: 100,
    },
    county_names_all: "Cape Girardeau",
    county_fips_all: 29031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63758,
    lat: 37.19212,
    lng: -89.55064,
    city: "Kelso",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 268,
    density: 562.1,
    county_fips: 29201,
    county_name: "Scott",
    county_weights: {
      29201: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 29201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63760,
    lat: 37.25084,
    lng: -89.90374,
    city: "Leopold",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 668,
    density: 7.2,
    county_fips: 29017,
    county_name: "Bollinger",
    county_weights: {
      29017: 100,
    },
    county_names_all: "Bollinger",
    county_fips_all: 29017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63763,
    lat: 37.05885,
    lng: -90.18058,
    city: "McGee",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 207,
    density: 4,
    county_fips: 29223,
    county_name: "Wayne",
    county_weights: {
      29223: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 29223,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63764,
    lat: 37.32944,
    lng: -89.9837,
    city: "Marble Hill",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5297,
    density: 11.9,
    county_fips: 29017,
    county_name: "Bollinger",
    county_weights: {
      29017: 97.66,
      29031: 2.34,
    },
    county_names_all: "Bollinger|Cape Girardeau",
    county_fips_all: "29017|29031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63766,
    lat: 37.43558,
    lng: -89.84424,
    city: "Millersville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1388,
    density: 11.1,
    county_fips: 29031,
    county_name: "Cape Girardeau",
    county_weights: {
      29017: 32.59,
      29031: 67.41,
    },
    county_names_all: "Cape Girardeau|Bollinger",
    county_fips_all: "29031|29017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63767,
    lat: 37.04356,
    lng: -89.61038,
    city: "Morley",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 689,
    density: 295.4,
    county_fips: 29201,
    county_name: "Scott",
    county_weights: {
      29201: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 29201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63769,
    lat: 37.52312,
    lng: -89.74203,
    city: "Oak Ridge",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1403,
    density: 10.5,
    county_fips: 29031,
    county_name: "Cape Girardeau",
    county_weights: {
      29031: 100,
    },
    county_names_all: "Cape Girardeau",
    county_fips_all: 29031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63770,
    lat: 37.59456,
    lng: -89.70049,
    city: "Old Appleton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 152,
    density: 21.7,
    county_fips: 29157,
    county_name: "Perry",
    county_weights: {
      29031: 46.33,
      29157: 53.67,
    },
    county_names_all: "Perry|Cape Girardeau",
    county_fips_all: "29157|29031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63771,
    lat: 37.07431,
    lng: -89.71299,
    city: "Oran",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2655,
    density: 9.7,
    county_fips: 29201,
    county_name: "Scott",
    county_weights: {
      29031: 1.74,
      29201: 73.28,
      29207: 24.98,
    },
    county_names_all: "Scott|Stoddard|Cape Girardeau",
    county_fips_all: "29201|29207|29031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63774,
    lat: 37.09424,
    lng: -89.77469,
    city: "Perkins",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 181,
    density: 423.4,
    county_fips: 29201,
    county_name: "Scott",
    county_weights: {
      29201: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 29201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63775,
    lat: 37.71051,
    lng: -89.87919,
    city: "Perryville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16806,
    density: 18.9,
    county_fips: 29157,
    county_name: "Perry",
    county_weights: {
      29017: 1.25,
      29031: 1.15,
      29157: 97.6,
    },
    county_names_all: "Perry|Bollinger|Cape Girardeau",
    county_fips_all: "29157|29017|29031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63780,
    lat: 37.17797,
    lng: -89.50138,
    city: "Scott City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6324,
    density: 39,
    county_fips: 29201,
    county_name: "Scott",
    county_weights: {
      29031: 3.06,
      29201: 96.94,
    },
    county_names_all: "Scott|Cape Girardeau",
    county_fips_all: "29201|29031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63781,
    lat: 37.5329,
    lng: -89.93078,
    city: "Sedgewickville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1141,
    density: 7.2,
    county_fips: 29017,
    county_name: "Bollinger",
    county_weights: {
      29017: 99.01,
      29157: 0.99,
    },
    county_names_all: "Bollinger|Perry",
    county_fips_all: "29017|29157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63782,
    lat: 37.11369,
    lng: -90.02788,
    city: "Sturdivant",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 241,
    density: 6,
    county_fips: 29017,
    county_name: "Bollinger",
    county_weights: {
      29017: 100,
    },
    county_names_all: "Bollinger",
    county_fips_all: 29017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63783,
    lat: 37.60958,
    lng: -89.6823,
    city: "Uniontown",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 70,
    density: 4.7,
    county_fips: 29157,
    county_name: "Perry",
    county_weights: {
      29157: 100,
    },
    county_names_all: "Perry",
    county_fips_all: 29157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63784,
    lat: 36.99497,
    lng: -89.69601,
    city: "Vanduser",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 229,
    density: 53.7,
    county_fips: 29201,
    county_name: "Scott",
    county_weights: {
      29201: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 29201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63785,
    lat: 37.26336,
    lng: -89.81554,
    city: "Whitewater",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1015,
    density: 7.9,
    county_fips: 29031,
    county_name: "Cape Girardeau",
    county_weights: {
      29017: 2.58,
      29031: 97.42,
    },
    county_names_all: "Cape Girardeau|Bollinger",
    county_fips_all: "29031|29017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63787,
    lat: 37.12284,
    lng: -90.12263,
    city: "Zalma",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 614,
    density: 3.9,
    county_fips: 29017,
    county_name: "Bollinger",
    county_weights: {
      29017: 95.29,
      29223: 4.71,
    },
    county_names_all: "Bollinger|Wayne",
    county_fips_all: "29017|29223",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63801,
    lat: 36.89698,
    lng: -89.60672,
    city: "Sikeston",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22423,
    density: 40.7,
    county_fips: 29201,
    county_name: "Scott",
    county_weights: {
      29133: 1.33,
      29143: 29.76,
      29201: 57.9,
      29207: 11.01,
    },
    county_names_all: "Scott|New Madrid|Stoddard|Mississippi",
    county_fips_all: "29201|29143|29207|29133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63820,
    lat: 36.82427,
    lng: -89.32564,
    city: "Anniston",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 216,
    density: 171.1,
    county_fips: 29133,
    county_name: "Mississippi",
    county_weights: {
      29133: 100,
    },
    county_names_all: "Mississippi",
    county_fips_all: 29133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63821,
    lat: 36.04878,
    lng: -90.23963,
    city: "Arbyrd",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 698,
    density: 6.8,
    county_fips: 29069,
    county_name: "Dunklin",
    county_weights: {
      29069: 100,
    },
    county_names_all: "Dunklin",
    county_fips_all: 29069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63822,
    lat: 36.65904,
    lng: -90.00103,
    city: "Bernie",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2365,
    density: 11.8,
    county_fips: 29207,
    county_name: "Stoddard",
    county_weights: {
      29069: 7.82,
      29207: 92.18,
    },
    county_names_all: "Stoddard|Dunklin",
    county_fips_all: "29207|29069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63823,
    lat: 36.89628,
    lng: -89.45367,
    city: "Bertrand",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1157,
    density: 11.4,
    county_fips: 29133,
    county_name: "Mississippi",
    county_weights: {
      29133: 82.16,
      29201: 17.84,
    },
    county_names_all: "Mississippi|Scott",
    county_fips_all: "29133|29201",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63824,
    lat: 37.00513,
    lng: -89.52638,
    city: "Blodgett",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 105,
    density: 340.9,
    county_fips: 29201,
    county_name: "Scott",
    county_weights: {
      29201: 100,
    },
    county_names_all: "Scott",
    county_fips_all: 29201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63825,
    lat: 36.93033,
    lng: -89.94432,
    city: "Bloomfield",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4495,
    density: 16.6,
    county_fips: 29207,
    county_name: "Stoddard",
    county_weights: {
      29207: 100,
    },
    county_names_all: "Stoddard",
    county_fips_all: 29207,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63826,
    lat: 36.18361,
    lng: -89.84486,
    city: "Braggadocio",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38,
    density: 2.6,
    county_fips: 29155,
    county_name: "Pemiscot",
    county_weights: {
      29155: 100,
    },
    county_names_all: "Pemiscot",
    county_fips_all: 29155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63827,
    lat: 36.26133,
    lng: -89.89226,
    city: "Bragg City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 694,
    density: 3.6,
    county_fips: 29155,
    county_name: "Pemiscot",
    county_weights: {
      29155: 100,
    },
    county_names_all: "Pemiscot",
    county_fips_all: 29155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63828,
    lat: 36.75038,
    lng: -89.69182,
    city: "Canalou",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 186,
    density: 73.3,
    county_fips: 29143,
    county_name: "New Madrid",
    county_weights: {
      29143: 100,
    },
    county_names_all: "New Madrid",
    county_fips_all: 29143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63829,
    lat: 36.03652,
    lng: -90.31173,
    city: "Cardwell",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1310,
    density: 21.8,
    county_fips: 29069,
    county_name: "Dunklin",
    county_weights: {
      29069: 100,
    },
    county_names_all: "Dunklin",
    county_fips_all: 29069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63830,
    lat: 36.14065,
    lng: -89.6871,
    city: "Caruthersville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6663,
    density: 41.4,
    county_fips: 29155,
    county_name: "Pemiscot",
    county_weights: {
      29155: 100,
    },
    county_names_all: "Pemiscot",
    county_fips_all: 29155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63833,
    lat: 36.64779,
    lng: -89.73023,
    city: "Catron",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 117,
    density: 0.6,
    county_fips: 29143,
    county_name: "New Madrid",
    county_weights: {
      29143: 53.08,
      29207: 46.92,
    },
    county_names_all: "New Madrid|Stoddard",
    county_fips_all: "29143|29207",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63834,
    lat: 36.91989,
    lng: -89.27885,
    city: "Charleston",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6522,
    density: 10.1,
    county_fips: 29133,
    county_name: "Mississippi",
    county_weights: {
      29133: 85.25,
      29201: 14.75,
    },
    county_names_all: "Mississippi|Scott",
    county_fips_all: "29133|29201",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63837,
    lat: 36.44907,
    lng: -89.98023,
    city: "Clarkton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1511,
    density: 18.6,
    county_fips: 29069,
    county_name: "Dunklin",
    county_weights: {
      29069: 72.32,
      29143: 27.68,
    },
    county_names_all: "Dunklin|New Madrid",
    county_fips_all: "29069|29143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63839,
    lat: 36.04748,
    lng: -89.8097,
    city: "Cooter",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 419,
    density: 189.6,
    county_fips: 29155,
    county_name: "Pemiscot",
    county_weights: {
      29155: 100,
    },
    county_names_all: "Pemiscot",
    county_fips_all: 29155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63840,
    lat: 36.19113,
    lng: -89.88426,
    city: "Deering",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 29155,
    county_name: "Pemiscot",
    county_weights: {
      29155: 100,
    },
    county_names_all: "Pemiscot",
    county_fips_all: 29155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63841,
    lat: 36.77198,
    lng: -89.98169,
    city: "Dexter",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13104,
    density: 39.2,
    county_fips: 29207,
    county_name: "Stoddard",
    county_weights: {
      29207: 100,
    },
    county_names_all: "Stoddard",
    county_fips_all: 29207,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63845,
    lat: 36.70944,
    lng: -89.31505,
    city: "East Prairie",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5628,
    density: 11.5,
    county_fips: 29133,
    county_name: "Mississippi",
    county_weights: {
      29133: 86.87,
      29143: 13.13,
    },
    county_names_all: "Mississippi|New Madrid",
    county_fips_all: "29133|29143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63846,
    lat: 36.82229,
    lng: -89.80199,
    city: "Essex",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1431,
    density: 5.4,
    county_fips: 29207,
    county_name: "Stoddard",
    county_weights: {
      29207: 100,
    },
    county_names_all: "Stoddard",
    county_fips_all: 29207,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63847,
    lat: 36.44271,
    lng: -90.03474,
    city: "Gibson",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18,
    density: 3.2,
    county_fips: 29069,
    county_name: "Dunklin",
    county_weights: {
      29069: 100,
    },
    county_names_all: "Dunklin",
    county_fips_all: 29069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63848,
    lat: 36.44053,
    lng: -89.88219,
    city: "Gideon",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1068,
    density: 5.1,
    county_fips: 29143,
    county_name: "New Madrid",
    county_weights: {
      29143: 83.36,
      29155: 16.64,
    },
    county_names_all: "New Madrid|Pemiscot",
    county_fips_all: "29143|29155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63849,
    lat: 36.13287,
    lng: -89.99109,
    city: "Gobler",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 205,
    density: 3.6,
    county_fips: 29069,
    county_name: "Dunklin",
    county_weights: {
      29069: 84.74,
      29155: 15.26,
    },
    county_names_all: "Dunklin|Pemiscot",
    county_fips_all: "29069|29155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63850,
    lat: 36.82227,
    lng: -89.78214,
    city: "Grayridge",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 29207,
    county_name: "Stoddard",
    county_weights: {
      29207: 100,
    },
    county_names_all: "Stoddard",
    county_fips_all: 29207,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63851,
    lat: 36.25762,
    lng: -89.72352,
    city: "Hayti",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3543,
    density: 13.6,
    county_fips: 29155,
    county_name: "Pemiscot",
    county_weights: {
      29155: 100,
    },
    county_names_all: "Pemiscot",
    county_fips_all: 29155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63852,
    lat: 36.36748,
    lng: -90.01435,
    city: "Holcomb",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1376,
    density: 10.9,
    county_fips: 29069,
    county_name: "Dunklin",
    county_weights: {
      29069: 86.86,
      29155: 13.14,
    },
    county_names_all: "Dunklin|Pemiscot",
    county_fips_all: "29069|29155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63853,
    lat: 36.05834,
    lng: -89.86738,
    city: "Holland",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 138,
    density: 177.9,
    county_fips: 29155,
    county_name: "Pemiscot",
    county_weights: {
      29155: 100,
    },
    county_names_all: "Pemiscot",
    county_fips_all: 29155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63855,
    lat: 36.05332,
    lng: -90.07123,
    city: "Hornersville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 922,
    density: 4.9,
    county_fips: 29069,
    county_name: "Dunklin",
    county_weights: {
      29069: 100,
    },
    county_names_all: "Dunklin",
    county_fips_all: 29069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63857,
    lat: 36.22402,
    lng: -90.04612,
    city: "Kennett",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12082,
    density: 44,
    county_fips: 29069,
    county_name: "Dunklin",
    county_weights: {
      29069: 97.13,
      29155: 2.87,
    },
    county_names_all: "Dunklin|Pemiscot",
    county_fips_all: "29069|29155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63860,
    lat: 36.67462,
    lng: -89.59449,
    city: "Kewanee",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 164,
    density: 15.1,
    county_fips: 29143,
    county_name: "New Madrid",
    county_weights: {
      29143: 100,
    },
    county_names_all: "New Madrid",
    county_fips_all: 29143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63862,
    lat: 36.58974,
    lng: -89.67345,
    city: "Lilbourn",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1636,
    density: 9.5,
    county_fips: 29143,
    county_name: "New Madrid",
    county_weights: {
      29143: 100,
    },
    county_names_all: "New Madrid",
    county_fips_all: 29143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63863,
    lat: 36.56282,
    lng: -89.97671,
    city: "Malden",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5970,
    density: 40.9,
    county_fips: 29069,
    county_name: "Dunklin",
    county_weights: {
      29069: 72.03,
      29143: 27.97,
    },
    county_names_all: "Dunklin|New Madrid",
    county_fips_all: "29069|29143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63866,
    lat: 36.52606,
    lng: -89.60654,
    city: "Marston",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 424,
    density: 42.3,
    county_fips: 29143,
    county_name: "New Madrid",
    county_weights: {
      29143: 100,
    },
    county_names_all: "New Madrid",
    county_fips_all: 29143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63867,
    lat: 36.74475,
    lng: -89.5465,
    city: "Matthews",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1098,
    density: 4.8,
    county_fips: 29143,
    county_name: "New Madrid",
    county_weights: {
      29143: 100,
    },
    county_names_all: "New Madrid",
    county_fips_all: 29143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63868,
    lat: 36.84579,
    lng: -89.68971,
    city: "Morehouse",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 650,
    density: 254.1,
    county_fips: 29143,
    county_name: "New Madrid",
    county_weights: {
      29143: 100,
    },
    county_names_all: "New Madrid",
    county_fips_all: 29143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63869,
    lat: 36.60768,
    lng: -89.48111,
    city: "New Madrid",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3381,
    density: 12.5,
    county_fips: 29143,
    county_name: "New Madrid",
    county_weights: {
      29143: 100,
    },
    county_names_all: "New Madrid",
    county_fips_all: 29143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63870,
    lat: 36.61942,
    lng: -89.84471,
    city: "Parma",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1112,
    density: 5.1,
    county_fips: 29143,
    county_name: "New Madrid",
    county_weights: {
      29143: 64.18,
      29207: 35.82,
    },
    county_names_all: "New Madrid|Stoddard",
    county_fips_all: "29143|29207",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63873,
    lat: 36.42791,
    lng: -89.65965,
    city: "Portageville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4431,
    density: 8.9,
    county_fips: 29143,
    county_name: "New Madrid",
    county_weights: {
      29143: 68.98,
      29155: 31.02,
    },
    county_names_all: "New Madrid|Pemiscot",
    county_fips_all: "29143|29155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63874,
    lat: 36.55566,
    lng: -89.81645,
    city: "Risco",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 257,
    density: 102.5,
    county_fips: 29143,
    county_name: "New Madrid",
    county_weights: {
      29143: 100,
    },
    county_names_all: "New Madrid",
    county_fips_all: 29143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63876,
    lat: 36.13206,
    lng: -90.16487,
    city: "Senath",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2321,
    density: 15.1,
    county_fips: 29069,
    county_name: "Dunklin",
    county_weights: {
      29069: 100,
    },
    county_names_all: "Dunklin",
    county_fips_all: 29069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63877,
    lat: 36.07377,
    lng: -89.85118,
    city: "Steele",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3537,
    density: 9.2,
    county_fips: 29155,
    county_name: "Pemiscot",
    county_weights: {
      29069: 5.84,
      29155: 94.16,
    },
    county_names_all: "Pemiscot|Dunklin",
    county_fips_all: "29155|29069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63878,
    lat: 36.50302,
    lng: -89.82234,
    city: "Tallapoosa",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 112,
    density: 80.7,
    county_fips: 29143,
    county_name: "New Madrid",
    county_weights: {
      29143: 100,
    },
    county_names_all: "New Madrid",
    county_fips_all: 29143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63879,
    lat: 36.35752,
    lng: -89.80945,
    city: "Wardell",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 728,
    density: 12.6,
    county_fips: 29155,
    county_name: "Pemiscot",
    county_weights: {
      29155: 100,
    },
    county_names_all: "Pemiscot",
    county_fips_all: 29155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63880,
    lat: 36.32986,
    lng: -90.02585,
    city: "Whiteoak",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 150,
    density: 817.6,
    county_fips: 29069,
    county_name: "Dunklin",
    county_weights: {
      29069: 100,
    },
    county_names_all: "Dunklin",
    county_fips_all: 29069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63882,
    lat: 36.91639,
    lng: -89.21974,
    city: "Wyatt",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 304,
    density: 172.5,
    county_fips: 29133,
    county_name: "Mississippi",
    county_weights: {
      29133: 100,
    },
    county_names_all: "Mississippi",
    county_fips_all: 29133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63901,
    lat: 36.77168,
    lng: -90.45012,
    city: "Poplar Bluff",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35218,
    density: 47.7,
    county_fips: 29023,
    county_name: "Butler",
    county_weights: {
      29023: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 29023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63932,
    lat: 36.6879,
    lng: -90.24533,
    city: "Broseley",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1032,
    density: 7.8,
    county_fips: 29023,
    county_name: "Butler",
    county_weights: {
      29023: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 29023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63933,
    lat: 36.52102,
    lng: -90.10876,
    city: "Campbell",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3337,
    density: 12.6,
    county_fips: 29069,
    county_name: "Dunklin",
    county_weights: {
      29069: 100,
    },
    county_names_all: "Dunklin",
    county_fips_all: 29069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63934,
    lat: 37.20014,
    lng: -90.37254,
    city: "Clubb",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 128,
    density: 10.6,
    county_fips: 29223,
    county_name: "Wayne",
    county_weights: {
      29223: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 29223,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63935,
    lat: 36.67053,
    lng: -90.92055,
    city: "Doniphan",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10066,
    density: 8.5,
    county_fips: 29181,
    county_name: "Ripley",
    county_weights: {
      29035: 0.78,
      29149: 6.73,
      29181: 92.49,
    },
    county_names_all: "Ripley|Oregon|Carter",
    county_fips_all: "29181|29149|29035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63936,
    lat: 36.80731,
    lng: -90.12979,
    city: "Dudley",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 661,
    density: 3,
    county_fips: 29207,
    county_name: "Stoddard",
    county_weights: {
      29207: 100,
    },
    county_names_all: "Stoddard",
    county_fips_all: 29207,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63937,
    lat: 36.94403,
    lng: -90.74907,
    city: "Ellsinore",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2866,
    density: 6.5,
    county_fips: 29035,
    county_name: "Carter",
    county_weights: {
      29023: 14.12,
      29035: 78.52,
      29223: 7.36,
    },
    county_names_all: "Carter|Butler|Wayne",
    county_fips_all: "29035|29023|29223",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63939,
    lat: 36.68456,
    lng: -90.68253,
    city: "Fairdealing",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1308,
    density: 9.5,
    county_fips: 29181,
    county_name: "Ripley",
    county_weights: {
      29181: 100,
    },
    county_names_all: "Ripley",
    county_fips_all: 29181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63940,
    lat: 36.77218,
    lng: -90.22892,
    city: "Fisk",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1499,
    density: 10.6,
    county_fips: 29023,
    county_name: "Butler",
    county_weights: {
      29023: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 29023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63941,
    lat: 36.8711,
    lng: -91.16607,
    city: "Fremont",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 150,
    density: 0.4,
    county_fips: 29035,
    county_name: "Carter",
    county_weights: {
      29035: 66.38,
      29149: 32.9,
      29181: 0.72,
    },
    county_names_all: "Carter|Oregon|Ripley",
    county_fips_all: "29035|29149|29181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63942,
    lat: 36.55434,
    lng: -91.07821,
    city: "Gatewood",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 647,
    density: 2.8,
    county_fips: 29181,
    county_name: "Ripley",
    county_weights: {
      29149: 28.53,
      29181: 71.47,
    },
    county_names_all: "Ripley|Oregon",
    county_fips_all: "29181|29149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63943,
    lat: 36.84046,
    lng: -90.79995,
    city: "Grandin",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 560,
    density: 2.6,
    county_fips: 29035,
    county_name: "Carter",
    county_weights: {
      29035: 71.82,
      29181: 28.18,
    },
    county_names_all: "Carter|Ripley",
    county_fips_all: "29035|29181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63944,
    lat: 37.10876,
    lng: -90.36286,
    city: "Greenville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1679,
    density: 3.9,
    county_fips: 29223,
    county_name: "Wayne",
    county_weights: {
      29223: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 29223,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63945,
    lat: 36.6381,
    lng: -90.5524,
    city: "Harviell",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 799,
    density: 9.8,
    county_fips: 29023,
    county_name: "Butler",
    county_weights: {
      29023: 89.65,
      29181: 10.35,
    },
    county_names_all: "Butler|Ripley",
    county_fips_all: "29023|29181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63950,
    lat: 37.26924,
    lng: -90.43474,
    city: "Lodi",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 29223,
    county_name: "Wayne",
    county_weights: {
      29223: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 29223,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63951,
    lat: 37.10875,
    lng: -90.26055,
    city: "Lowndes",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 144,
    density: 1.5,
    county_fips: 29223,
    county_name: "Wayne",
    county_weights: {
      29223: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 29223,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63952,
    lat: 37.00828,
    lng: -90.64916,
    city: "Mill Spring",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 404,
    density: 3,
    county_fips: 29223,
    county_name: "Wayne",
    county_weights: {
      29223: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 29223,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63953,
    lat: 36.59134,
    lng: -90.62995,
    city: "Naylor",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1310,
    density: 8.7,
    county_fips: 29181,
    county_name: "Ripley",
    county_weights: {
      29023: 17.82,
      29181: 82.18,
    },
    county_names_all: "Ripley|Butler",
    county_fips_all: "29181|29023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63954,
    lat: 36.56365,
    lng: -90.47337,
    city: "Neelyville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 833,
    density: 3,
    county_fips: 29023,
    county_name: "Butler",
    county_weights: {
      29023: 93.63,
      29181: 6.37,
    },
    county_names_all: "Butler|Ripley",
    county_fips_all: "29023|29181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63955,
    lat: 36.60211,
    lng: -90.67864,
    city: "Oxly",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 106,
    density: 5.4,
    county_fips: 29181,
    county_name: "Ripley",
    county_weights: {
      29181: 100,
    },
    county_names_all: "Ripley",
    county_fips_all: 29181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63956,
    lat: 37.21741,
    lng: -90.51665,
    city: "Patterson",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1102,
    density: 6.1,
    county_fips: 29223,
    county_name: "Wayne",
    county_weights: {
      29223: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 29223,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63957,
    lat: 37.14218,
    lng: -90.68903,
    city: "Piedmont",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6222,
    density: 11.8,
    county_fips: 29223,
    county_name: "Wayne",
    county_weights: {
      29179: 24.28,
      29223: 75.72,
    },
    county_names_all: "Wayne|Reynolds",
    county_fips_all: "29223|29179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63960,
    lat: 36.96074,
    lng: -90.12434,
    city: "Puxico",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3495,
    density: 11.6,
    county_fips: 29207,
    county_name: "Stoddard",
    county_weights: {
      29017: 9.09,
      29207: 90.91,
    },
    county_names_all: "Stoddard|Bollinger",
    county_fips_all: "29207|29017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63961,
    lat: 36.56848,
    lng: -90.2749,
    city: "Qulin",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1862,
    density: 8,
    county_fips: 29023,
    county_name: "Butler",
    county_weights: {
      29023: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 29023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63962,
    lat: 36.84406,
    lng: -90.28149,
    city: "Rombauer",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 250,
    density: 5352.2,
    county_fips: 29023,
    county_name: "Butler",
    county_weights: {
      29023: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 29023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63964,
    lat: 37.23954,
    lng: -90.39662,
    city: "Silva",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 356,
    density: 2,
    county_fips: 29223,
    county_name: "Wayne",
    county_weights: {
      29123: 4.68,
      29223: 95.32,
    },
    county_names_all: "Wayne|Madison",
    county_fips_all: "29223|29123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63965,
    lat: 36.97391,
    lng: -91.02294,
    city: "Van Buren",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2877,
    density: 4.9,
    county_fips: 29035,
    county_name: "Carter",
    county_weights: {
      29035: 97.18,
      29179: 2.82,
    },
    county_names_all: "Carter|Reynolds",
    county_fips_all: "29035|29179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63966,
    lat: 36.96956,
    lng: -90.26216,
    city: "Wappapello",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2467,
    density: 15.9,
    county_fips: 29223,
    county_name: "Wayne",
    county_weights: {
      29023: 20.38,
      29223: 79.62,
    },
    county_names_all: "Wayne|Butler",
    county_fips_all: "29223|29023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 63967,
    lat: 36.94867,
    lng: -90.47721,
    city: "Williamsville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1699,
    density: 5.4,
    county_fips: 29223,
    county_name: "Wayne",
    county_weights: {
      29023: 29.76,
      29223: 70.24,
    },
    county_names_all: "Wayne|Butler",
    county_fips_all: "29223|29023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64001,
    lat: 39.10464,
    lng: -93.53683,
    city: "Alma",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 877,
    density: 9.5,
    county_fips: 29107,
    county_name: "Lafayette",
    county_weights: {
      29107: 100,
    },
    county_names_all: "Lafayette",
    county_fips_all: 29107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64011,
    lat: 38.95963,
    lng: -94.06688,
    city: "Bates City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4060,
    density: 43.9,
    county_fips: 29107,
    county_name: "Lafayette",
    county_weights: {
      29101: 20.62,
      29107: 79.38,
    },
    county_names_all: "Lafayette|Johnson",
    county_fips_all: "29107|29101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64012,
    lat: 38.78906,
    lng: -94.55204,
    city: "Belton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27298,
    density: 223.3,
    county_fips: 29037,
    county_name: "Cass",
    county_weights: {
      29037: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 29037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64014,
    lat: 39.00893,
    lng: -94.25533,
    city: "Blue Springs",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26468,
    density: 913,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64015,
    lat: 39.02099,
    lng: -94.3006,
    city: "Blue Springs",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30128,
    density: 594.7,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64016,
    lat: 39.11642,
    lng: -94.21385,
    city: "Buckner",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4582,
    density: 54.5,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64017,
    lat: 39.199,
    lng: -94.02951,
    city: "Camden",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 322,
    density: 5.9,
    county_fips: 29177,
    county_name: "Ray",
    county_weights: {
      29107: 41.83,
      29177: 58.17,
    },
    county_names_all: "Ray|Lafayette",
    county_fips_all: "29177|29107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64018,
    lat: 39.45052,
    lng: -94.73329,
    city: "Camden Point",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1003,
    density: 19,
    county_fips: 29165,
    county_name: "Platte",
    county_weights: {
      29165: 100,
    },
    county_names_all: "Platte",
    county_fips_all: 29165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64019,
    lat: 38.77543,
    lng: -93.86665,
    city: "Centerview",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2052,
    density: 9.3,
    county_fips: 29101,
    county_name: "Johnson",
    county_weights: {
      29101: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 29101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64020,
    lat: 38.96795,
    lng: -93.59098,
    city: "Concordia",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3496,
    density: 12.8,
    county_fips: 29107,
    county_name: "Lafayette",
    county_weights: {
      29101: 22.28,
      29107: 73.51,
      29195: 4.21,
    },
    county_names_all: "Lafayette|Johnson|Saline",
    county_fips_all: "29107|29101|29195",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64021,
    lat: 39.11498,
    lng: -93.624,
    city: "Corder",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 714,
    density: 6.5,
    county_fips: 29107,
    county_name: "Lafayette",
    county_weights: {
      29107: 100,
    },
    county_names_all: "Lafayette",
    county_fips_all: 29107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64022,
    lat: 39.20191,
    lng: -93.67836,
    city: "Dover",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 149,
    density: 7.8,
    county_fips: 29107,
    county_name: "Lafayette",
    county_weights: {
      29107: 100,
    },
    county_names_all: "Lafayette",
    county_fips_all: 29107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64024,
    lat: 39.32523,
    lng: -94.22707,
    city: "Excelsior Springs",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15989,
    density: 87.7,
    county_fips: 29047,
    county_name: "Clay",
    county_weights: {
      29047: 62.82,
      29177: 37.18,
    },
    county_names_all: "Clay|Ray",
    county_fips_all: "29047|29177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64028,
    lat: 39.29658,
    lng: -94.82153,
    city: "Farley",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 29165,
    county_name: "Platte",
    county_weights: {
      29165: 100,
    },
    county_names_all: "Platte",
    county_fips_all: 29165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64029,
    lat: 39.00634,
    lng: -94.21473,
    city: "Grain Valley",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19054,
    density: 231.2,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64030,
    lat: 38.87996,
    lng: -94.52312,
    city: "Grandview",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24909,
    density: 662.4,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64034,
    lat: 38.85052,
    lng: -94.30203,
    city: "Greenwood",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9114,
    density: 154.4,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29037: 20.88,
      29095: 79.12,
    },
    county_names_all: "Jackson|Cass",
    county_fips_all: "29095|29037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64035,
    lat: 39.28796,
    lng: -93.81972,
    city: "Hardin",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1095,
    density: 6.6,
    county_fips: 29177,
    county_name: "Ray",
    county_weights: {
      29033: 3.89,
      29177: 96.11,
    },
    county_names_all: "Ray|Carroll",
    county_fips_all: "29177|29033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64036,
    lat: 39.20047,
    lng: -93.937,
    city: "Henrietta",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 382,
    density: 6.9,
    county_fips: 29177,
    county_name: "Ray",
    county_weights: {
      29177: 100,
    },
    county_names_all: "Ray",
    county_fips_all: 29177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64037,
    lat: 39.05116,
    lng: -93.73386,
    city: "Higginsville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5770,
    density: 20.7,
    county_fips: 29107,
    county_name: "Lafayette",
    county_weights: {
      29101: 2.79,
      29107: 97.21,
    },
    county_names_all: "Lafayette|Johnson",
    county_fips_all: "29107|29101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64040,
    lat: 38.71928,
    lng: -93.98725,
    city: "Holden",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6297,
    density: 14.7,
    county_fips: 29101,
    county_name: "Johnson",
    county_weights: {
      29037: 0.93,
      29101: 99.07,
    },
    county_names_all: "Johnson|Cass",
    county_fips_all: "29101|29037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64048,
    lat: 39.44439,
    lng: -94.3634,
    city: "Holt",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4566,
    density: 38.5,
    county_fips: 29047,
    county_name: "Clay",
    county_weights: {
      29047: 63.23,
      29049: 36.77,
    },
    county_names_all: "Clay|Clinton",
    county_fips_all: "29047|29049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64050,
    lat: 39.11424,
    lng: -94.40641,
    city: "Independence",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21580,
    density: 647.9,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64052,
    lat: 39.07355,
    lng: -94.45082,
    city: "Independence",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21190,
    density: 1296.5,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64053,
    lat: 39.10791,
    lng: -94.46735,
    city: "Independence",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5894,
    density: 840,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64054,
    lat: 39.11627,
    lng: -94.44003,
    city: "Independence",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3022,
    density: 379.4,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64055,
    lat: 39.05061,
    lng: -94.39848,
    city: "Independence",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34260,
    density: 1058.4,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64056,
    lat: 39.11114,
    lng: -94.32008,
    city: "Independence",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17037,
    density: 334.4,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64057,
    lat: 39.0692,
    lng: -94.32203,
    city: "Independence",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13710,
    density: 360.5,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64058,
    lat: 39.17805,
    lng: -94.31408,
    city: "Independence",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6744,
    density: 78.1,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64060,
    lat: 39.37134,
    lng: -94.36821,
    city: "Kearney",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16323,
    density: 107.5,
    county_fips: 29047,
    county_name: "Clay",
    county_weights: {
      29047: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 29047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64061,
    lat: 38.77981,
    lng: -94.0885,
    city: "Kingsville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2904,
    density: 18.1,
    county_fips: 29101,
    county_name: "Johnson",
    county_weights: {
      29037: 15.34,
      29095: 0.62,
      29101: 84.04,
    },
    county_names_all: "Johnson|Cass|Jackson",
    county_fips_all: "29101|29037|29095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64062,
    lat: 39.45533,
    lng: -94.17244,
    city: "Lawson",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6391,
    density: 28.6,
    county_fips: 29177,
    county_name: "Ray",
    county_weights: {
      29025: 2.32,
      29047: 13.61,
      29049: 11,
      29177: 73.07,
    },
    county_names_all: "Ray|Clay|Clinton|Caldwell",
    county_fips_all: "29177|29047|29049|29025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64063,
    lat: 38.91224,
    lng: -94.35341,
    city: "Lees Summit",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20455,
    density: 1292.7,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64064,
    lat: 38.98222,
    lng: -94.34284,
    city: "Lees Summit",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18987,
    density: 386.7,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64065,
    lat: 38.95146,
    lng: -94.40467,
    city: "Lees Summit",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38,
    density: 30.3,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64066,
    lat: 39.13961,
    lng: -94.13857,
    city: "Levasy",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18,
    density: 6.7,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64067,
    lat: 39.15594,
    lng: -93.83747,
    city: "Lexington",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6148,
    density: 32.5,
    county_fips: 29107,
    county_name: "Lafayette",
    county_weights: {
      29107: 100,
    },
    county_names_all: "Lafayette",
    county_fips_all: 29107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64068,
    lat: 39.25924,
    lng: -94.39042,
    city: "Liberty",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38976,
    density: 177.5,
    county_fips: 29047,
    county_name: "Clay",
    county_weights: {
      29047: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 29047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64070,
    lat: 38.8897,
    lng: -94.14863,
    city: "Lone Jack",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3404,
    density: 34.8,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 82.34,
      29101: 17.66,
    },
    county_names_all: "Jackson|Johnson",
    county_fips_all: "29095|29101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64071,
    lat: 39.02961,
    lng: -93.83379,
    city: "Mayview",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 669,
    density: 7.5,
    county_fips: 29107,
    county_name: "Lafayette",
    county_weights: {
      29107: 100,
    },
    county_names_all: "Lafayette",
    county_fips_all: 29107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64072,
    lat: 39.23286,
    lng: -94.30021,
    city: "Missouri City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 474,
    density: 165.6,
    county_fips: 29047,
    county_name: "Clay",
    county_weights: {
      29047: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 29047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64074,
    lat: 39.08106,
    lng: -94.07658,
    city: "Napoleon",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 615,
    density: 11.4,
    county_fips: 29107,
    county_name: "Lafayette",
    county_weights: {
      29107: 100,
    },
    county_names_all: "Lafayette",
    county_fips_all: 29107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64075,
    lat: 38.99751,
    lng: -94.14544,
    city: "Oak Grove",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12124,
    density: 95,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 90.86,
      29107: 9.14,
    },
    county_names_all: "Jackson|Lafayette",
    county_fips_all: "29095|29107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64076,
    lat: 38.98145,
    lng: -93.94536,
    city: "Odessa",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8623,
    density: 26.8,
    county_fips: 29107,
    county_name: "Lafayette",
    county_weights: {
      29101: 10.19,
      29107: 89.81,
    },
    county_names_all: "Lafayette|Johnson",
    county_fips_all: "29107|29101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64077,
    lat: 39.2224,
    lng: -94.13887,
    city: "Orrick",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1836,
    density: 10.3,
    county_fips: 29177,
    county_name: "Ray",
    county_weights: {
      29047: 10.36,
      29177: 89.64,
    },
    county_names_all: "Ray|Clay",
    county_fips_all: "29177|29047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64078,
    lat: 38.70711,
    lng: -94.46375,
    city: "Peculiar",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9587,
    density: 69.4,
    county_fips: 29037,
    county_name: "Cass",
    county_weights: {
      29037: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 29037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64079,
    lat: 39.36267,
    lng: -94.79351,
    city: "Platte City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14143,
    density: 57.6,
    county_fips: 29165,
    county_name: "Platte",
    county_weights: {
      29165: 100,
    },
    county_names_all: "Platte",
    county_fips_all: 29165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64080,
    lat: 38.7691,
    lng: -94.25639,
    city: "Pleasant Hill",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13419,
    density: 42.6,
    county_fips: 29037,
    county_name: "Cass",
    county_weights: {
      29037: 97.06,
      29095: 2.55,
      29101: 0.39,
    },
    county_names_all: "Cass|Jackson|Johnson",
    county_fips_all: "29037|29095|29101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64081,
    lat: 38.90971,
    lng: -94.40953,
    city: "Lees Summit",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24814,
    density: 736.4,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64082,
    lat: 38.86601,
    lng: -94.4039,
    city: "Lees Summit",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18024,
    density: 339.2,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29037: 10.14,
      29095: 89.86,
    },
    county_names_all: "Jackson|Cass",
    county_fips_all: "29095|29037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64083,
    lat: 38.80082,
    lng: -94.4483,
    city: "Raymore",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23269,
    density: 349.9,
    county_fips: 29037,
    county_name: "Cass",
    county_weights: {
      29037: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 29037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64084,
    lat: 39.38697,
    lng: -94.0653,
    city: "Rayville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1437,
    density: 10.3,
    county_fips: 29177,
    county_name: "Ray",
    county_weights: {
      29177: 100,
    },
    county_names_all: "Ray",
    county_fips_all: 29177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64085,
    lat: 39.33838,
    lng: -93.95158,
    city: "Richmond",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8270,
    density: 19.9,
    county_fips: 29177,
    county_name: "Ray",
    county_weights: {
      29177: 100,
    },
    county_names_all: "Ray",
    county_fips_all: 29177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64086,
    lat: 38.91181,
    lng: -94.29293,
    city: "Lees Summit",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23843,
    density: 243.7,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64088,
    lat: 39.16173,
    lng: -94.1848,
    city: "Sibley",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1155,
    density: 14.5,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64089,
    lat: 39.39007,
    lng: -94.56483,
    city: "Smithville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13757,
    density: 87.2,
    county_fips: 29047,
    county_name: "Clay",
    county_weights: {
      29047: 75.47,
      29165: 24.53,
    },
    county_names_all: "Clay|Platte",
    county_fips_all: "29047|29165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64090,
    lat: 38.75991,
    lng: -94.16387,
    city: "Strasburg",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 154,
    density: 411.4,
    county_fips: 29037,
    county_name: "Cass",
    county_weights: {
      29037: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 29037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64092,
    lat: 39.22248,
    lng: -94.8088,
    city: "Waldron",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 93,
    density: 7.5,
    county_fips: 29165,
    county_name: "Platte",
    county_weights: {
      29165: 100,
    },
    county_names_all: "Platte",
    county_fips_all: 29165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64093,
    lat: 38.79057,
    lng: -93.73206,
    city: "Warrensburg",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27853,
    density: 56.5,
    county_fips: 29101,
    county_name: "Johnson",
    county_weights: {
      29101: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 29101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64096,
    lat: 39.20176,
    lng: -93.55611,
    city: "Waverly",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1244,
    density: 10.9,
    county_fips: 29107,
    county_name: "Lafayette",
    county_weights: {
      29107: 93.95,
      29195: 6.05,
    },
    county_names_all: "Lafayette|Saline",
    county_fips_all: "29107|29195",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64097,
    lat: 39.11237,
    lng: -93.99146,
    city: "Wellington",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1078,
    density: 12.9,
    county_fips: 29107,
    county_name: "Lafayette",
    county_weights: {
      29107: 100,
    },
    county_names_all: "Lafayette",
    county_fips_all: 29107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64098,
    lat: 39.45661,
    lng: -94.89456,
    city: "Weston",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3282,
    density: 17.1,
    county_fips: 29165,
    county_name: "Platte",
    county_weights: {
      29165: 100,
    },
    county_names_all: "Platte",
    county_fips_all: 29165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64101,
    lat: 39.10355,
    lng: -94.60051,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 322,
    density: 305.2,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64102,
    lat: 39.09433,
    lng: -94.60329,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64105,
    lat: 39.10599,
    lng: -94.58985,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4881,
    density: 2355.7,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29047: 0.27,
      29095: 99.73,
    },
    county_names_all: "Jackson|Clay",
    county_fips_all: "29095|29047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64106,
    lat: 39.10526,
    lng: -94.57013,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11292,
    density: 2709.9,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64108,
    lat: 39.08413,
    lng: -94.58449,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9074,
    density: 959.7,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64109,
    lat: 39.06646,
    lng: -94.56709,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10733,
    density: 1939.1,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64110,
    lat: 39.03445,
    lng: -94.57265,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17517,
    density: 2264.4,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64111,
    lat: 39.05707,
    lng: -94.59393,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17165,
    density: 2446.2,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64112,
    lat: 39.03599,
    lng: -94.59529,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8569,
    density: 2255.1,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64113,
    lat: 39.01414,
    lng: -94.5956,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12080,
    density: 1843.6,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64114,
    lat: 38.9581,
    lng: -94.59715,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25314,
    density: 1381.3,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64116,
    lat: 39.14875,
    lng: -94.57444,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16556,
    density: 589.8,
    county_fips: 29047,
    county_name: "Clay",
    county_weights: {
      29047: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 29047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64117,
    lat: 39.16522,
    lng: -94.52251,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14492,
    density: 926.4,
    county_fips: 29047,
    county_name: "Clay",
    county_weights: {
      29047: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 29047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64118,
    lat: 39.21301,
    lng: -94.57497,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43649,
    density: 1319.1,
    county_fips: 29047,
    county_name: "Clay",
    county_weights: {
      29047: 98.87,
      29165: 1.13,
    },
    county_names_all: "Clay|Platte",
    county_fips_all: "29047|29165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64119,
    lat: 39.21137,
    lng: -94.5186,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29450,
    density: 784.1,
    county_fips: 29047,
    county_name: "Clay",
    county_weights: {
      29047: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 29047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64120,
    lat: 39.13142,
    lng: -94.51489,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 386,
    density: 18.8,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64123,
    lat: 39.11436,
    lng: -94.52167,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10469,
    density: 2248.7,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64124,
    lat: 39.10718,
    lng: -94.5391,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11809,
    density: 2706.3,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64125,
    lat: 39.1065,
    lng: -94.49388,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2286,
    density: 574.8,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64126,
    lat: 39.09095,
    lng: -94.49581,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5889,
    density: 876.3,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64127,
    lat: 39.08912,
    lng: -94.53837,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15402,
    density: 1423.1,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64128,
    lat: 39.06555,
    lng: -94.53484,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12164,
    density: 1562.3,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64129,
    lat: 39.04935,
    lng: -94.49682,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8460,
    density: 315.8,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64130,
    lat: 39.03345,
    lng: -94.54119,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19310,
    density: 1052.4,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64131,
    lat: 38.95723,
    lng: -94.57449,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22208,
    density: 1004,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64132,
    lat: 38.98551,
    lng: -94.5396,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14095,
    density: 505.3,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64133,
    lat: 39.01406,
    lng: -94.45689,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35504,
    density: 806.9,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64134,
    lat: 38.9308,
    lng: -94.48667,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22850,
    density: 740.7,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64136,
    lat: 39.01361,
    lng: -94.40181,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1716,
    density: 154.7,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64137,
    lat: 38.93196,
    lng: -94.54287,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11220,
    density: 750.7,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64138,
    lat: 38.96852,
    lng: -94.47088,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24516,
    density: 710.3,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64139,
    lat: 38.96832,
    lng: -94.40677,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2435,
    density: 196.5,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64145,
    lat: 38.88046,
    lng: -94.59652,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4775,
    density: 331.5,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64146,
    lat: 38.87888,
    lng: -94.57436,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1766,
    density: 127.9,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64147,
    lat: 38.85387,
    lng: -94.54688,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 463,
    density: 54.2,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29037: 9.82,
      29095: 90.18,
    },
    county_names_all: "Jackson|Cass",
    county_fips_all: "29095|29037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64149,
    lat: 38.86524,
    lng: -94.46666,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 461,
    density: 19.7,
    county_fips: 29095,
    county_name: "Jackson",
    county_weights: {
      29095: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 29095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64150,
    lat: 39.17052,
    lng: -94.6303,
    city: "Riverside",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3501,
    density: 240.3,
    county_fips: 29165,
    county_name: "Platte",
    county_weights: {
      29047: 0.21,
      29165: 99.79,
    },
    county_names_all: "Platte|Clay",
    county_fips_all: "29165|29047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64151,
    lat: 39.21494,
    lng: -94.63115,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26451,
    density: 778.5,
    county_fips: 29165,
    county_name: "Platte",
    county_weights: {
      29047: 0.16,
      29165: 99.84,
    },
    county_names_all: "Platte|Clay",
    county_fips_all: "29165|29047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64152,
    lat: 39.21278,
    lng: -94.72271,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31010,
    density: 387.6,
    county_fips: 29165,
    county_name: "Platte",
    county_weights: {
      29165: 100,
    },
    county_names_all: "Platte",
    county_fips_all: 29165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64153,
    lat: 39.27999,
    lng: -94.73148,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5981,
    density: 63.4,
    county_fips: 29165,
    county_name: "Platte",
    county_weights: {
      29165: 100,
    },
    county_names_all: "Platte",
    county_fips_all: 29165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64154,
    lat: 39.27653,
    lng: -94.62967,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12004,
    density: 358.2,
    county_fips: 29165,
    county_name: "Platte",
    county_weights: {
      29165: 100,
    },
    county_names_all: "Platte",
    county_fips_all: 29165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64155,
    lat: 39.28031,
    lng: -94.56801,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24099,
    density: 637.3,
    county_fips: 29047,
    county_name: "Clay",
    county_weights: {
      29047: 99.58,
      29165: 0.42,
    },
    county_names_all: "Clay|Platte",
    county_fips_all: "29047|29165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64156,
    lat: 39.2762,
    lng: -94.5195,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7549,
    density: 269.3,
    county_fips: 29047,
    county_name: "Clay",
    county_weights: {
      29047: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 29047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64157,
    lat: 39.27657,
    lng: -94.47103,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19762,
    density: 706,
    county_fips: 29047,
    county_name: "Clay",
    county_weights: {
      29047: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 29047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64158,
    lat: 39.23493,
    lng: -94.47839,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5875,
    density: 987.8,
    county_fips: 29047,
    county_name: "Clay",
    county_weights: {
      29047: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 29047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64161,
    lat: 39.16184,
    lng: -94.44943,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 346,
    density: 8.4,
    county_fips: 29047,
    county_name: "Clay",
    county_weights: {
      29047: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 29047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64163,
    lat: 39.33674,
    lng: -94.68922,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 750,
    density: 32.1,
    county_fips: 29165,
    county_name: "Platte",
    county_weights: {
      29165: 100,
    },
    county_names_all: "Platte",
    county_fips_all: 29165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64164,
    lat: 39.32988,
    lng: -94.63113,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 112,
    density: 4.3,
    county_fips: 29165,
    county_name: "Platte",
    county_weights: {
      29165: 100,
    },
    county_names_all: "Platte",
    county_fips_all: 29165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64165,
    lat: 39.32081,
    lng: -94.57749,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 476,
    density: 46.3,
    county_fips: 29047,
    county_name: "Clay",
    county_weights: {
      29047: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 29047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64166,
    lat: 39.32215,
    lng: -94.52301,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 316,
    density: 24.8,
    county_fips: 29047,
    county_name: "Clay",
    county_weights: {
      29047: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 29047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64167,
    lat: 39.31939,
    lng: -94.48187,
    city: "Kansas City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 414,
    density: 92.2,
    county_fips: 29047,
    county_name: "Clay",
    county_weights: {
      29047: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 29047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64401,
    lat: 39.63452,
    lng: -94.71522,
    city: "Agency",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1172,
    density: 12.2,
    county_fips: 29021,
    county_name: "Buchanan",
    county_weights: {
      29021: 100,
    },
    county_names_all: "Buchanan",
    county_fips_all: 29021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64402,
    lat: 40.25201,
    lng: -94.32276,
    city: "Albany",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2437,
    density: 7.8,
    county_fips: 29075,
    county_name: "Gentry",
    county_weights: {
      29075: 100,
    },
    county_names_all: "Gentry",
    county_fips_all: 29075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64420,
    lat: 40.48645,
    lng: -94.2892,
    city: "Allendale",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64,
    density: 56.2,
    county_fips: 29227,
    county_name: "Worth",
    county_weights: {
      29227: 100,
    },
    county_names_all: "Worth",
    county_fips_all: 29227,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64421,
    lat: 39.9082,
    lng: -94.92779,
    city: "Amazonia",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1175,
    density: 18.5,
    county_fips: 29003,
    county_name: "Andrew",
    county_weights: {
      29003: 100,
    },
    county_names_all: "Andrew",
    county_fips_all: 29003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64422,
    lat: 39.90022,
    lng: -94.4941,
    city: "Amity",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 555,
    density: 4.9,
    county_fips: 29063,
    county_name: "DeKalb",
    county_weights: {
      29063: 100,
    },
    county_names_all: "DeKalb",
    county_fips_all: 29063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64423,
    lat: 40.18695,
    lng: -94.8552,
    city: "Barnard",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 798,
    density: 4.3,
    county_fips: 29147,
    county_name: "Nodaway",
    county_weights: {
      29003: 2.08,
      29147: 97.92,
    },
    county_names_all: "Nodaway|Andrew",
    county_fips_all: "29147|29003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64424,
    lat: 40.26453,
    lng: -94.03242,
    city: "Bethany",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4047,
    density: 9.4,
    county_fips: 29081,
    county_name: "Harrison",
    county_weights: {
      29081: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 29081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64426,
    lat: 40.51747,
    lng: -93.86158,
    city: "Blythedale",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 441,
    density: 3.1,
    county_fips: 29081,
    county_name: "Harrison",
    county_weights: {
      29081: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 29081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64427,
    lat: 40.10828,
    lng: -94.84136,
    city: "Bolckow",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 558,
    density: 3.5,
    county_fips: 29003,
    county_name: "Andrew",
    county_weights: {
      29003: 82.33,
      29147: 17.67,
    },
    county_names_all: "Andrew|Nodaway",
    county_fips_all: "29003|29147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64428,
    lat: 40.4418,
    lng: -95.08836,
    city: "Burlington Junction",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 664,
    density: 2.8,
    county_fips: 29147,
    county_name: "Nodaway",
    county_weights: {
      29005: 13.45,
      29147: 86.55,
    },
    county_names_all: "Nodaway|Atchison",
    county_fips_all: "29147|29005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64429,
    lat: 39.73895,
    lng: -94.2285,
    city: "Cameron",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12282,
    density: 31.4,
    county_fips: 29063,
    county_name: "DeKalb",
    county_weights: {
      29025: 30.87,
      29049: 30.54,
      29061: 5.61,
      29063: 32.98,
    },
    county_names_all: "DeKalb|Caldwell|Clinton|Daviess",
    county_fips_all: "29063|29025|29049|29061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64430,
    lat: 39.83771,
    lng: -94.56924,
    city: "Clarksdale",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 784,
    density: 6.9,
    county_fips: 29063,
    county_name: "DeKalb",
    county_weights: {
      29003: 15.46,
      29063: 84.54,
    },
    county_names_all: "DeKalb|Andrew",
    county_fips_all: "29063|29003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64431,
    lat: 40.53046,
    lng: -94.99357,
    city: "Clearmont",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 459,
    density: 3.8,
    county_fips: 29147,
    county_name: "Nodaway",
    county_weights: {
      29147: 100,
    },
    county_names_all: "Nodaway",
    county_fips_all: 29147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64432,
    lat: 40.26399,
    lng: -94.66119,
    city: "Clyde",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 114,
    density: 40.7,
    county_fips: 29147,
    county_name: "Nodaway",
    county_weights: {
      29147: 100,
    },
    county_names_all: "Nodaway",
    county_fips_all: 29147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64433,
    lat: 40.24107,
    lng: -94.68053,
    city: "Conception",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 291,
    density: 149.9,
    county_fips: 29147,
    county_name: "Nodaway",
    county_weights: {
      29147: 100,
    },
    county_names_all: "Nodaway",
    county_fips_all: 29147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64434,
    lat: 40.2584,
    lng: -94.73615,
    city: "Conception Junction",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 498,
    density: 5.2,
    county_fips: 29147,
    county_name: "Nodaway",
    county_weights: {
      29147: 100,
    },
    county_names_all: "Nodaway",
    county_fips_all: 29147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64436,
    lat: 39.85362,
    lng: -94.69034,
    city: "Cosby",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 989,
    density: 12.5,
    county_fips: 29003,
    county_name: "Andrew",
    county_weights: {
      29003: 99.85,
      29021: 0.15,
    },
    county_names_all: "Andrew|Buchanan",
    county_fips_all: "29003|29021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64437,
    lat: 40.14292,
    lng: -95.35546,
    city: "Craig",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 476,
    density: 1.2,
    county_fips: 29087,
    county_name: "Holt",
    county_weights: {
      29005: 0.42,
      29087: 99.58,
    },
    county_names_all: "Holt|Atchison",
    county_fips_all: "29087|29005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64438,
    lat: 40.16106,
    lng: -94.41091,
    city: "Darlington",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 138,
    density: 1.2,
    county_fips: 29075,
    county_name: "Gentry",
    county_weights: {
      29075: 100,
    },
    county_names_all: "Gentry",
    county_fips_all: 29075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64439,
    lat: 39.52371,
    lng: -94.74986,
    city: "Dearborn",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1418,
    density: 10.1,
    county_fips: 29165,
    county_name: "Platte",
    county_weights: {
      29021: 41.5,
      29165: 58.5,
    },
    county_names_all: "Platte|Buchanan",
    county_fips_all: "29165|29021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64440,
    lat: 39.57849,
    lng: -94.91841,
    city: "De Kalb",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 814,
    density: 8.7,
    county_fips: 29021,
    county_name: "Buchanan",
    county_weights: {
      29021: 90.66,
      29165: 9.34,
    },
    county_names_all: "Buchanan|Platte",
    county_fips_all: "29021|29165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64441,
    lat: 40.39883,
    lng: -94.2642,
    city: "Denver",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58,
    density: 0.4,
    county_fips: 29227,
    county_name: "Worth",
    county_weights: {
      29075: 38.25,
      29227: 61.75,
    },
    county_names_all: "Worth|Gentry",
    county_fips_all: "29227|29075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64442,
    lat: 40.49935,
    lng: -94.00645,
    city: "Eagleville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 827,
    density: 4,
    county_fips: 29081,
    county_name: "Harrison",
    county_weights: {
      29081: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 29081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64443,
    lat: 39.74724,
    lng: -94.65205,
    city: "Easton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1813,
    density: 14.4,
    county_fips: 29021,
    county_name: "Buchanan",
    county_weights: {
      29021: 100,
    },
    county_names_all: "Buchanan",
    county_fips_all: 29021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64444,
    lat: 39.48334,
    lng: -94.63856,
    city: "Edgerton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1422,
    density: 15.9,
    county_fips: 29165,
    county_name: "Platte",
    county_weights: {
      29021: 18.96,
      29049: 4.19,
      29165: 76.85,
    },
    county_names_all: "Platte|Buchanan|Clinton",
    county_fips_all: "29165|29021|29049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64445,
    lat: 40.53533,
    lng: -95.13881,
    city: "Elmo",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 266,
    density: 2.4,
    county_fips: 29147,
    county_name: "Nodaway",
    county_weights: {
      29147: 100,
    },
    county_names_all: "Nodaway",
    county_fips_all: 29147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64446,
    lat: 40.32176,
    lng: -95.40297,
    city: "Fairfax",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1004,
    density: 2.8,
    county_fips: 29005,
    county_name: "Atchison",
    county_weights: {
      29005: 100,
    },
    county_names_all: "Atchison",
    county_fips_all: 29005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64448,
    lat: 39.60258,
    lng: -94.81856,
    city: "Faucett",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1085,
    density: 10.4,
    county_fips: 29021,
    county_name: "Buchanan",
    county_weights: {
      29021: 100,
    },
    county_names_all: "Buchanan",
    county_fips_all: 29021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64449,
    lat: 40.04135,
    lng: -94.97754,
    city: "Fillmore",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 687,
    density: 6.9,
    county_fips: 29003,
    county_name: "Andrew",
    county_weights: {
      29003: 100,
    },
    county_names_all: "Andrew",
    county_fips_all: 29003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64451,
    lat: 39.99067,
    lng: -95.20664,
    city: "Forest City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 460,
    density: 3.2,
    county_fips: 29087,
    county_name: "Holt",
    county_weights: {
      29087: 100,
    },
    county_names_all: "Holt",
    county_fips_all: 29087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64453,
    lat: 40.34471,
    lng: -94.46947,
    city: "Gentry",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 212,
    density: 2,
    county_fips: 29075,
    county_name: "Gentry",
    county_weights: {
      29075: 99.85,
      29227: 0.15,
    },
    county_names_all: "Gentry|Worth",
    county_fips_all: "29075|29227",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64454,
    lat: 39.60771,
    lng: -94.59423,
    city: "Gower",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2426,
    density: 13.1,
    county_fips: 29049,
    county_name: "Clinton",
    county_weights: {
      29021: 44.2,
      29049: 55.8,
    },
    county_names_all: "Clinton|Buchanan",
    county_fips_all: "29049|29021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64455,
    lat: 40.18592,
    lng: -95.00594,
    city: "Graham",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 361,
    density: 2.5,
    county_fips: 29147,
    county_name: "Nodaway",
    county_weights: {
      29003: 8.96,
      29147: 91.04,
    },
    county_names_all: "Nodaway|Andrew",
    county_fips_all: "29147|29003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64456,
    lat: 40.49433,
    lng: -94.38733,
    city: "Grant City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1461,
    density: 3.4,
    county_fips: 29227,
    county_name: "Worth",
    county_weights: {
      29081: 6.1,
      29227: 93.9,
    },
    county_names_all: "Worth|Harrison",
    county_fips_all: "29227|29081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64457,
    lat: 40.15886,
    lng: -94.68368,
    city: "Guilford",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 198,
    density: 2,
    county_fips: 29147,
    county_name: "Nodaway",
    county_weights: {
      29003: 14.53,
      29147: 85.47,
    },
    county_names_all: "Nodaway|Andrew",
    county_fips_all: "29147|29003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64458,
    lat: 40.52246,
    lng: -94.14491,
    city: "Hatfield",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 289,
    density: 1.8,
    county_fips: 29081,
    county_name: "Harrison",
    county_weights: {
      29081: 95.11,
      29227: 4.89,
    },
    county_names_all: "Harrison|Worth",
    county_fips_all: "29081|29227",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64459,
    lat: 39.93129,
    lng: -94.65017,
    city: "Helena",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 454,
    density: 7.4,
    county_fips: 29003,
    county_name: "Andrew",
    county_weights: {
      29003: 100,
    },
    county_names_all: "Andrew",
    county_fips_all: 29003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64461,
    lat: 40.52459,
    lng: -94.81063,
    city: "Hopkins",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 796,
    density: 3.9,
    county_fips: 29147,
    county_name: "Nodaway",
    county_weights: {
      29147: 100,
    },
    county_names_all: "Nodaway",
    county_fips_all: 29147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64463,
    lat: 40.06526,
    lng: -94.4869,
    city: "King City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1565,
    density: 4.4,
    county_fips: 29075,
    county_name: "Gentry",
    county_weights: {
      29003: 7.67,
      29063: 26.22,
      29075: 66.11,
    },
    county_names_all: "Gentry|DeKalb|Andrew",
    county_fips_all: "29075|29063|29003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64465,
    lat: 39.54853,
    lng: -94.29525,
    city: "Lathrop",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4050,
    density: 16.6,
    county_fips: 29049,
    county_name: "Clinton",
    county_weights: {
      29025: 13.72,
      29049: 86.28,
    },
    county_names_all: "Clinton|Caldwell",
    county_fips_all: "29049|29025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64466,
    lat: 40.16865,
    lng: -95.1067,
    city: "Maitland",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 354,
    density: 2.4,
    county_fips: 29087,
    county_name: "Holt",
    county_weights: {
      29087: 100,
    },
    county_names_all: "Holt",
    county_fips_all: 29087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64467,
    lat: 40.39772,
    lng: -94.16236,
    city: "Martinsville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 186,
    density: 1.6,
    county_fips: 29081,
    county_name: "Harrison",
    county_weights: {
      29081: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 29081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64468,
    lat: 40.34241,
    lng: -94.8811,
    city: "Maryville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15497,
    density: 41.3,
    county_fips: 29147,
    county_name: "Nodaway",
    county_weights: {
      29147: 100,
    },
    county_names_all: "Nodaway",
    county_fips_all: 29147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64469,
    lat: 39.93085,
    lng: -94.35762,
    city: "Maysville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1957,
    density: 6.3,
    county_fips: 29063,
    county_name: "DeKalb",
    county_weights: {
      29063: 98.33,
      29075: 1.67,
    },
    county_names_all: "DeKalb|Gentry",
    county_fips_all: "29063|29075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64470,
    lat: 40.17036,
    lng: -95.22138,
    city: "Mound City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1637,
    density: 8.3,
    county_fips: 29087,
    county_name: "Holt",
    county_weights: {
      29087: 100,
    },
    county_names_all: "Holt",
    county_fips_all: 29087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64471,
    lat: 40.26548,
    lng: -94.1936,
    city: "New Hampton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 455,
    density: 4.1,
    county_fips: 29081,
    county_name: "Harrison",
    county_weights: {
      29075: 20.92,
      29081: 79.08,
    },
    county_names_all: "Harrison|Gentry",
    county_fips_all: "29081|29075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64473,
    lat: 39.97606,
    lng: -95.08446,
    city: "Oregon",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1408,
    density: 4.9,
    county_fips: 29087,
    county_name: "Holt",
    county_weights: {
      29087: 100,
    },
    county_names_all: "Holt",
    county_fips_all: 29087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64474,
    lat: 39.75829,
    lng: -94.38103,
    city: "Osborn",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 912,
    density: 6.2,
    county_fips: 29063,
    county_name: "DeKalb",
    county_weights: {
      29049: 42.06,
      29063: 57.94,
    },
    county_names_all: "DeKalb|Clinton",
    county_fips_all: "29063|29049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64475,
    lat: 40.43561,
    lng: -94.63049,
    city: "Parnell",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 309,
    density: 1.7,
    county_fips: 29147,
    county_name: "Nodaway",
    county_weights: {
      29075: 1.96,
      29147: 60.05,
      29227: 37.99,
    },
    county_names_all: "Nodaway|Worth|Gentry",
    county_fips_all: "29147|29227|29075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64476,
    lat: 40.45115,
    lng: -94.83034,
    city: "Pickering",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 285,
    density: 3.2,
    county_fips: 29147,
    county_name: "Nodaway",
    county_weights: {
      29147: 100,
    },
    county_names_all: "Nodaway",
    county_fips_all: 29147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64477,
    lat: 39.57872,
    lng: -94.45289,
    city: "Plattsburg",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3484,
    density: 15.3,
    county_fips: 29049,
    county_name: "Clinton",
    county_weights: {
      29049: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 29049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64479,
    lat: 40.34853,
    lng: -94.66636,
    city: "Ravenwood",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1014,
    density: 6,
    county_fips: 29147,
    county_name: "Nodaway",
    county_weights: {
      29075: 15.74,
      29147: 84.26,
    },
    county_names_all: "Nodaway|Gentry",
    county_fips_all: "29147|29075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64480,
    lat: 40.06102,
    lng: -94.70826,
    city: "Rea",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 238,
    density: 3.5,
    county_fips: 29003,
    county_name: "Andrew",
    county_weights: {
      29003: 100,
    },
    county_names_all: "Andrew",
    county_fips_all: 29003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64481,
    lat: 40.35622,
    lng: -93.8957,
    city: "Ridgeway",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 958,
    density: 2.9,
    county_fips: 29081,
    county_name: "Harrison",
    county_weights: {
      29081: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 29081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64482,
    lat: 40.45345,
    lng: -95.54329,
    city: "Rock Port",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2150,
    density: 6.3,
    county_fips: 29005,
    county_name: "Atchison",
    county_weights: {
      29005: 100,
    },
    county_names_all: "Atchison",
    county_fips_all: 29005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64483,
    lat: 40.04335,
    lng: -94.83471,
    city: "Rosendale",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 695,
    density: 8,
    county_fips: 29003,
    county_name: "Andrew",
    county_weights: {
      29003: 100,
    },
    county_names_all: "Andrew",
    county_fips_all: 29003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64484,
    lat: 39.55638,
    lng: -95.01974,
    city: "Rushville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 918,
    density: 4.9,
    county_fips: 29021,
    county_name: "Buchanan",
    county_weights: {
      29021: 65.72,
      29165: 34.28,
    },
    county_names_all: "Buchanan|Platte",
    county_fips_all: "29021|29165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64485,
    lat: 39.95325,
    lng: -94.8184,
    city: "Savannah",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7651,
    density: 27.2,
    county_fips: 29003,
    county_name: "Andrew",
    county_weights: {
      29003: 100,
    },
    county_names_all: "Andrew",
    county_fips_all: 29003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64486,
    lat: 40.52951,
    lng: -94.61471,
    city: "Sheridan",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 327,
    density: 2.5,
    county_fips: 29227,
    county_name: "Worth",
    county_weights: {
      29147: 39.32,
      29227: 60.68,
    },
    county_names_all: "Worth|Nodaway",
    county_fips_all: "29227|29147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64487,
    lat: 40.31218,
    lng: -95.10293,
    city: "Skidmore",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 600,
    density: 1.8,
    county_fips: 29147,
    county_name: "Nodaway",
    county_weights: {
      29005: 16.26,
      29087: 8.66,
      29147: 75.08,
    },
    county_names_all: "Nodaway|Atchison|Holt",
    county_fips_all: "29147|29005|29087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64489,
    lat: 40.23543,
    lng: -94.54969,
    city: "Stanberry",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2270,
    density: 6.7,
    county_fips: 29075,
    county_name: "Gentry",
    county_weights: {
      29075: 77.48,
      29147: 22.52,
    },
    county_names_all: "Gentry|Nodaway",
    county_fips_all: "29075|29147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64490,
    lat: 39.73837,
    lng: -94.50984,
    city: "Stewartsville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1729,
    density: 7.7,
    county_fips: 29049,
    county_name: "Clinton",
    county_weights: {
      29021: 0.18,
      29049: 59.63,
      29063: 40.19,
    },
    county_names_all: "Clinton|DeKalb|Buchanan",
    county_fips_all: "29049|29063|29021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64491,
    lat: 40.44868,
    lng: -95.34499,
    city: "Tarkio",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1732,
    density: 5.8,
    county_fips: 29005,
    county_name: "Atchison",
    county_weights: {
      29005: 100,
    },
    county_names_all: "Atchison",
    county_fips_all: 29005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64492,
    lat: 39.48067,
    lng: -94.53363,
    city: "Trimble",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1694,
    density: 18.3,
    county_fips: 29049,
    county_name: "Clinton",
    county_weights: {
      29047: 21.73,
      29049: 72.66,
      29165: 5.61,
    },
    county_names_all: "Clinton|Clay|Platte",
    county_fips_all: "29049|29047|29165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64493,
    lat: 39.63058,
    lng: -94.30454,
    city: "Turney",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 398,
    density: 4.7,
    county_fips: 29049,
    county_name: "Clinton",
    county_weights: {
      29049: 100,
    },
    county_names_all: "Clinton",
    county_fips_all: 29049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64494,
    lat: 39.99234,
    lng: -94.61465,
    city: "Union Star",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 995,
    density: 6.8,
    county_fips: 29003,
    county_name: "Andrew",
    county_weights: {
      29003: 53.27,
      29063: 46.73,
    },
    county_names_all: "Andrew|DeKalb",
    county_fips_all: "29003|29063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64496,
    lat: 40.49563,
    lng: -95.62372,
    city: "Watson",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 86,
    density: 0.9,
    county_fips: 29005,
    county_name: "Atchison",
    county_weights: {
      29005: 100,
    },
    county_names_all: "Atchison",
    county_fips_all: 29005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64497,
    lat: 39.92929,
    lng: -94.22275,
    city: "Weatherby",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 523,
    density: 4.9,
    county_fips: 29063,
    county_name: "DeKalb",
    county_weights: {
      29061: 34.02,
      29063: 65.98,
    },
    county_names_all: "DeKalb|Daviess",
    county_fips_all: "29063|29061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64498,
    lat: 40.54023,
    lng: -95.31255,
    city: "Westboro",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 201,
    density: 1.1,
    county_fips: 29005,
    county_name: "Atchison",
    county_weights: {
      29005: 100,
    },
    county_names_all: "Atchison",
    county_fips_all: 29005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64499,
    lat: 40.39707,
    lng: -94.41521,
    city: "Worth",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 102,
    density: 1.5,
    county_fips: 29227,
    county_name: "Worth",
    county_weights: {
      29075: 29.81,
      29227: 70.19,
    },
    county_names_all: "Worth|Gentry",
    county_fips_all: "29227|29075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64501,
    lat: 39.76584,
    lng: -94.84448,
    city: "Saint Joseph",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11482,
    density: 1193.9,
    county_fips: 29021,
    county_name: "Buchanan",
    county_weights: {
      29021: 100,
    },
    county_names_all: "Buchanan",
    county_fips_all: 29021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64503,
    lat: 39.74973,
    lng: -94.84545,
    city: "Saint Joseph",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12302,
    density: 328.1,
    county_fips: 29021,
    county_name: "Buchanan",
    county_weights: {
      29021: 100,
    },
    county_names_all: "Buchanan",
    county_fips_all: 29021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64504,
    lat: 39.68605,
    lng: -94.91264,
    city: "Saint Joseph",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11797,
    density: 97,
    county_fips: 29021,
    county_name: "Buchanan",
    county_weights: {
      29021: 100,
    },
    county_names_all: "Buchanan",
    county_fips_all: 29021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64505,
    lat: 39.84431,
    lng: -94.83354,
    city: "Saint Joseph",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13217,
    density: 111.8,
    county_fips: 29003,
    county_name: "Andrew",
    county_weights: {
      29003: 76.78,
      29021: 23.22,
    },
    county_names_all: "Andrew|Buchanan",
    county_fips_all: "29003|29021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64506,
    lat: 39.79048,
    lng: -94.80277,
    city: "Saint Joseph",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23296,
    density: 897.1,
    county_fips: 29021,
    county_name: "Buchanan",
    county_weights: {
      29003: 4.04,
      29021: 95.96,
    },
    county_names_all: "Buchanan|Andrew",
    county_fips_all: "29021|29003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64507,
    lat: 39.73324,
    lng: -94.75735,
    city: "Saint Joseph",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13916,
    density: 96.3,
    county_fips: 29021,
    county_name: "Buchanan",
    county_weights: {
      29003: 1.06,
      29021: 98.94,
    },
    county_names_all: "Buchanan|Andrew",
    county_fips_all: "29021|29003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64601,
    lat: 39.8044,
    lng: -93.57334,
    city: "Chillicothe",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11980,
    density: 19.4,
    county_fips: 29117,
    county_name: "Livingston",
    county_weights: {
      29061: 0.3,
      29117: 99.7,
    },
    county_names_all: "Livingston|Daviess",
    county_fips_all: "29117|29061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64620,
    lat: 39.89617,
    lng: -94.09094,
    city: "Altamont",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 544,
    density: 10.2,
    county_fips: 29061,
    county_name: "Daviess",
    county_weights: {
      29061: 100,
    },
    county_names_all: "Daviess",
    county_fips_all: 29061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64622,
    lat: 39.49535,
    lng: -93.54569,
    city: "Bogard",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 583,
    density: 3.6,
    county_fips: 29033,
    county_name: "Carroll",
    county_weights: {
      29033: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 29033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64623,
    lat: 39.47,
    lng: -93.33344,
    city: "Bosworth",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 379,
    density: 2.1,
    county_fips: 29033,
    county_name: "Carroll",
    county_weights: {
      29033: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 29033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64624,
    lat: 39.57189,
    lng: -93.7848,
    city: "Braymer",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1514,
    density: 4.8,
    county_fips: 29025,
    county_name: "Caldwell",
    county_weights: {
      29025: 49.65,
      29033: 26.17,
      29117: 5.83,
      29177: 18.35,
    },
    county_names_all: "Caldwell|Carroll|Ray|Livingston",
    county_fips_all: "29025|29033|29177|29117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64625,
    lat: 39.74378,
    lng: -93.80527,
    city: "Breckenridge",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 723,
    density: 4.3,
    county_fips: 29025,
    county_name: "Caldwell",
    county_weights: {
      29025: 66.59,
      29061: 22.93,
      29117: 10.48,
    },
    county_names_all: "Caldwell|Daviess|Livingston",
    county_fips_all: "29025|29061|29117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64628,
    lat: 39.79711,
    lng: -93.05002,
    city: "Brookfield",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5872,
    density: 15.2,
    county_fips: 29115,
    county_name: "Linn",
    county_weights: {
      29041: 13.14,
      29115: 86.86,
    },
    county_names_all: "Linn|Chariton",
    county_fips_all: "29115|29041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64630,
    lat: 40.03726,
    lng: -93.15435,
    city: "Browning",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 601,
    density: 2.2,
    county_fips: 29211,
    county_name: "Sullivan",
    county_weights: {
      29115: 47.34,
      29211: 52.66,
    },
    county_names_all: "Sullivan|Linn",
    county_fips_all: "29211|29115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64631,
    lat: 39.82018,
    lng: -92.88213,
    city: "Bucklin",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 584,
    density: 2.5,
    county_fips: 29115,
    county_name: "Linn",
    county_weights: {
      29115: 68.8,
      29121: 31.2,
    },
    county_names_all: "Linn|Macon",
    county_fips_all: "29115|29121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64632,
    lat: 40.46915,
    lng: -93.76862,
    city: "Cainsville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 377,
    density: 1.5,
    county_fips: 29129,
    county_name: "Mercer",
    county_weights: {
      29081: 41.54,
      29129: 58.46,
    },
    county_names_all: "Mercer|Harrison",
    county_fips_all: "29129|29081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64633,
    lat: 39.35951,
    lng: -93.48171,
    city: "Carrollton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4597,
    density: 7.4,
    county_fips: 29033,
    county_name: "Carroll",
    county_weights: {
      29033: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 29033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64635,
    lat: 39.93943,
    lng: -93.43632,
    city: "Chula",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 451,
    density: 2.8,
    county_fips: 29117,
    county_name: "Livingston",
    county_weights: {
      29079: 10.07,
      29115: 15.46,
      29117: 74.47,
    },
    county_names_all: "Livingston|Linn|Grundy",
    county_fips_all: "29117|29115|29079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64636,
    lat: 40.11989,
    lng: -93.98769,
    city: "Coffey",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 273,
    density: 4.8,
    county_fips: 29061,
    county_name: "Daviess",
    county_weights: {
      29061: 74.29,
      29081: 25.71,
    },
    county_names_all: "Daviess|Harrison",
    county_fips_all: "29061|29081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64637,
    lat: 39.57439,
    lng: -93.91573,
    city: "Cowgill",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 541,
    density: 2.9,
    county_fips: 29025,
    county_name: "Caldwell",
    county_weights: {
      29025: 76.57,
      29177: 23.43,
    },
    county_names_all: "Caldwell|Ray",
    county_fips_all: "29025|29177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64638,
    lat: 39.61894,
    lng: -93.61498,
    city: "Dawn",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 571,
    density: 3.3,
    county_fips: 29117,
    county_name: "Livingston",
    county_weights: {
      29033: 40.91,
      29117: 59.09,
    },
    county_names_all: "Livingston|Carroll",
    county_fips_all: "29117|29033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64639,
    lat: 39.3962,
    lng: -93.22276,
    city: "De Witt",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 157,
    density: 1.7,
    county_fips: 29033,
    county_name: "Carroll",
    county_weights: {
      29033: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 29033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64640,
    lat: 39.90172,
    lng: -93.94542,
    city: "Gallatin",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3161,
    density: 8.5,
    county_fips: 29061,
    county_name: "Daviess",
    county_weights: {
      29061: 100,
    },
    county_names_all: "Daviess",
    county_fips_all: 29061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64641,
    lat: 40.16221,
    lng: -93.3992,
    city: "Galt",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 571,
    density: 2.8,
    county_fips: 29079,
    county_name: "Grundy",
    county_weights: {
      29079: 78.47,
      29211: 21.53,
    },
    county_names_all: "Grundy|Sullivan",
    county_fips_all: "29079|29211",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64642,
    lat: 40.16979,
    lng: -93.83574,
    city: "Gilman City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 878,
    density: 3,
    county_fips: 29081,
    county_name: "Harrison",
    county_weights: {
      29061: 23.76,
      29079: 11.74,
      29081: 64.5,
    },
    county_names_all: "Harrison|Daviess|Grundy",
    county_fips_all: "29081|29061|29079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64643,
    lat: 39.61366,
    lng: -93.36883,
    city: "Hale",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1179,
    density: 4.2,
    county_fips: 29033,
    county_name: "Carroll",
    county_weights: {
      29033: 53.96,
      29117: 46.04,
    },
    county_names_all: "Carroll|Livingston",
    county_fips_all: "29033|29117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64644,
    lat: 39.7418,
    lng: -93.97384,
    city: "Hamilton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3493,
    density: 12.5,
    county_fips: 29025,
    county_name: "Caldwell",
    county_weights: {
      29025: 80.4,
      29061: 19.6,
    },
    county_names_all: "Caldwell|Daviess",
    county_fips_all: "29025|29061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64645,
    lat: 40.29834,
    lng: -93.32575,
    city: "Harris",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 128,
    density: 0.7,
    county_fips: 29211,
    county_name: "Sullivan",
    county_weights: {
      29129: 29.2,
      29211: 70.8,
    },
    county_names_all: "Sullivan|Mercer",
    county_fips_all: "29211|29129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64646,
    lat: 40.10456,
    lng: -93.30819,
    city: "Humphreys",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 246,
    density: 2,
    county_fips: 29211,
    county_name: "Sullivan",
    county_weights: {
      29115: 12.21,
      29211: 87.79,
    },
    county_names_all: "Sullivan|Linn",
    county_fips_all: "29211|29115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64647,
    lat: 40.03016,
    lng: -93.96862,
    city: "Jameson",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 411,
    density: 3.2,
    county_fips: 29061,
    county_name: "Daviess",
    county_weights: {
      29061: 100,
    },
    county_names_all: "Daviess",
    county_fips_all: 29061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64648,
    lat: 39.98517,
    lng: -93.79922,
    city: "Jamesport",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2372,
    density: 7.9,
    county_fips: 29061,
    county_name: "Daviess",
    county_weights: {
      29061: 78.16,
      29079: 14.86,
      29117: 6.98,
    },
    county_names_all: "Daviess|Grundy|Livingston",
    county_fips_all: "29061|29079|29117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64649,
    lat: 39.77428,
    lng: -94.09183,
    city: "Kidder",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 619,
    density: 6.6,
    county_fips: 29025,
    county_name: "Caldwell",
    county_weights: {
      29025: 57.97,
      29061: 42.03,
    },
    county_names_all: "Caldwell|Daviess",
    county_fips_all: "29025|29061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64650,
    lat: 39.63716,
    lng: -94.0548,
    city: "Kingston",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 685,
    density: 6.2,
    county_fips: 29025,
    county_name: "Caldwell",
    county_weights: {
      29025: 100,
    },
    county_names_all: "Caldwell",
    county_fips_all: 29025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64651,
    lat: 39.7759,
    lng: -93.1797,
    city: "Laclede",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 555,
    density: 5.4,
    county_fips: 29115,
    county_name: "Linn",
    county_weights: {
      29115: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 29115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64652,
    lat: 40.01979,
    lng: -93.42103,
    city: "Laredo",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 336,
    density: 2.9,
    county_fips: 29079,
    county_name: "Grundy",
    county_weights: {
      29079: 96.79,
      29115: 0.93,
      29211: 2.28,
    },
    county_names_all: "Grundy|Sullivan|Linn",
    county_fips_all: "29079|29211|29115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64653,
    lat: 39.89403,
    lng: -93.20403,
    city: "Linneus",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 586,
    density: 2.8,
    county_fips: 29115,
    county_name: "Linn",
    county_weights: {
      29115: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 29115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64654,
    lat: 39.84864,
    lng: -93.77552,
    city: "Lock Springs",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50,
    density: 199.4,
    county_fips: 29061,
    county_name: "Daviess",
    county_weights: {
      29061: 100,
    },
    county_names_all: "Daviess",
    county_fips_all: 29061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64655,
    lat: 40.44017,
    lng: -93.23684,
    city: "Lucerne",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 162,
    density: 1,
    county_fips: 29171,
    county_name: "Putnam",
    county_weights: {
      29171: 100,
    },
    county_names_all: "Putnam",
    county_fips_all: 29171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64656,
    lat: 39.67803,
    lng: -93.69375,
    city: "Ludlow",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 327,
    density: 5.9,
    county_fips: 29117,
    county_name: "Livingston",
    county_weights: {
      29117: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 29117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64657,
    lat: 40.13269,
    lng: -94.21292,
    city: "McFall",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 491,
    density: 2.8,
    county_fips: 29075,
    county_name: "Gentry",
    county_weights: {
      29061: 10.22,
      29075: 53.92,
      29081: 35.86,
    },
    county_names_all: "Gentry|Harrison|Daviess",
    county_fips_all: "29075|29081|29061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64658,
    lat: 39.66124,
    lng: -92.92181,
    city: "Marceline",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3262,
    density: 13.4,
    county_fips: 29041,
    county_name: "Chariton",
    county_weights: {
      29041: 75.06,
      29115: 22.27,
      29121: 2.67,
    },
    county_names_all: "Chariton|Linn|Macon",
    county_fips_all: "29041|29115|29121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64659,
    lat: 39.78138,
    lng: -93.29224,
    city: "Meadville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1100,
    density: 6.4,
    county_fips: 29115,
    county_name: "Linn",
    county_weights: {
      29115: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 29115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64660,
    lat: 39.57226,
    lng: -93.08923,
    city: "Mendon",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 455,
    density: 2.1,
    county_fips: 29041,
    county_name: "Chariton",
    county_weights: {
      29041: 100,
    },
    county_names_all: "Chariton",
    county_fips_all: 29041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64661,
    lat: 40.53031,
    lng: -93.51901,
    city: "Mercer",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 906,
    density: 3.5,
    county_fips: 29129,
    county_name: "Mercer",
    county_weights: {
      29129: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 29129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64664,
    lat: 39.74601,
    lng: -93.66027,
    city: "Mooresville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 314,
    density: 2.5,
    county_fips: 29117,
    county_name: "Livingston",
    county_weights: {
      29117: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 29117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64667,
    lat: 40.39434,
    lng: -93.33618,
    city: "Newtown",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 399,
    density: 2,
    county_fips: 29211,
    county_name: "Sullivan",
    county_weights: {
      29129: 34.54,
      29171: 27.11,
      29211: 38.35,
    },
    county_names_all: "Sullivan|Mercer|Putnam",
    county_fips_all: "29211|29129|29171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64668,
    lat: 39.35226,
    lng: -93.70704,
    city: "Norborne",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1561,
    density: 3.7,
    county_fips: 29033,
    county_name: "Carroll",
    county_weights: {
      29033: 80.21,
      29177: 19.79,
    },
    county_names_all: "Carroll|Ray",
    county_fips_all: "29033|29177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64670,
    lat: 40.04986,
    lng: -94.13833,
    city: "Pattonsburg",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 925,
    density: 2.8,
    county_fips: 29061,
    county_name: "Daviess",
    county_weights: {
      29061: 78.04,
      29063: 12.11,
      29075: 5.16,
      29081: 4.69,
    },
    county_names_all: "Daviess|DeKalb|Gentry|Harrison",
    county_fips_all: "29061|29063|29075|29081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64671,
    lat: 39.53655,
    lng: -94.0518,
    city: "Polo",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1863,
    density: 7.8,
    county_fips: 29025,
    county_name: "Caldwell",
    county_weights: {
      29025: 60.94,
      29177: 39.06,
    },
    county_names_all: "Caldwell|Ray",
    county_fips_all: "29025|29177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64672,
    lat: 40.53869,
    lng: -93.26015,
    city: "Powersville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 96,
    density: 0.5,
    county_fips: 29171,
    county_name: "Putnam",
    county_weights: {
      29129: 4.22,
      29171: 95.78,
    },
    county_names_all: "Putnam|Mercer",
    county_fips_all: "29171|29129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64673,
    lat: 40.38001,
    lng: -93.59094,
    city: "Princeton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2473,
    density: 4,
    county_fips: 29129,
    county_name: "Mercer",
    county_weights: {
      29129: 100,
    },
    county_names_all: "Mercer",
    county_fips_all: 29129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64674,
    lat: 39.96491,
    lng: -93.15884,
    city: "Purdin",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 287,
    density: 1.7,
    county_fips: 29115,
    county_name: "Linn",
    county_weights: {
      29115: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 29115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64676,
    lat: 39.6471,
    lng: -93.03729,
    city: "Rothville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 164,
    density: 3,
    county_fips: 29041,
    county_name: "Chariton",
    county_weights: {
      29041: 100,
    },
    county_names_all: "Chariton",
    county_fips_all: 29041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64679,
    lat: 40.23246,
    lng: -93.58181,
    city: "Spickard",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 879,
    density: 3.6,
    county_fips: 29079,
    county_name: "Grundy",
    county_weights: {
      29079: 88.02,
      29129: 11.98,
    },
    county_names_all: "Grundy|Mercer",
    county_fips_all: "29079|29129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64681,
    lat: 39.64706,
    lng: -93.21375,
    city: "Sumner",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 138,
    density: 1,
    county_fips: 29041,
    county_name: "Chariton",
    county_weights: {
      29041: 94.08,
      29115: 5.92,
    },
    county_names_all: "Chariton|Linn",
    county_fips_all: "29041|29115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64682,
    lat: 39.55251,
    lng: -93.49132,
    city: "Tina",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 424,
    density: 4.5,
    county_fips: 29033,
    county_name: "Carroll",
    county_weights: {
      29033: 100,
    },
    county_names_all: "Carroll",
    county_fips_all: 29033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64683,
    lat: 40.07395,
    lng: -93.60346,
    city: "Trenton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7867,
    density: 13.3,
    county_fips: 29079,
    county_name: "Grundy",
    county_weights: {
      29079: 92.15,
      29117: 7.85,
    },
    county_names_all: "Grundy|Livingston",
    county_fips_all: "29079|29117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64686,
    lat: 39.75005,
    lng: -93.62449,
    city: "Utica",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 222,
    density: 54.9,
    county_fips: 29117,
    county_name: "Livingston",
    county_weights: {
      29117: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 29117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64688,
    lat: 39.8139,
    lng: -93.37664,
    city: "Wheeling",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 794,
    density: 4.6,
    county_fips: 29117,
    county_name: "Livingston",
    county_weights: {
      29115: 25.67,
      29117: 74.33,
    },
    county_names_all: "Livingston|Linn",
    county_fips_all: "29117|29115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64689,
    lat: 39.87461,
    lng: -94.152,
    city: "Winston",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 603,
    density: 7.1,
    county_fips: 29061,
    county_name: "Daviess",
    county_weights: {
      29061: 100,
    },
    county_names_all: "Daviess",
    county_fips_all: 29061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64701,
    lat: 38.62053,
    lng: -94.3378,
    city: "Harrisonville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14461,
    density: 45,
    county_fips: 29037,
    county_name: "Cass",
    county_weights: {
      29037: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 29037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64720,
    lat: 38.40533,
    lng: -94.33742,
    city: "Adrian",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3987,
    density: 11.6,
    county_fips: 29013,
    county_name: "Bates",
    county_weights: {
      29013: 100,
    },
    county_names_all: "Bates",
    county_fips_all: 29013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64722,
    lat: 38.27388,
    lng: -94.55188,
    city: "Amoret",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 458,
    density: 4.9,
    county_fips: 29013,
    county_name: "Bates",
    county_weights: {
      29013: 100,
    },
    county_names_all: "Bates",
    county_fips_all: 29013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64723,
    lat: 38.3615,
    lng: -94.55298,
    city: "Amsterdam",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 733,
    density: 5.5,
    county_fips: 29013,
    county_name: "Bates",
    county_weights: {
      29013: 100,
    },
    county_names_all: "Bates",
    county_fips_all: 29013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64724,
    lat: 38.15188,
    lng: -94.01025,
    city: "Appleton City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2121,
    density: 6.4,
    county_fips: 29185,
    county_name: "St. Clair",
    county_weights: {
      29013: 35.46,
      29083: 1.45,
      29185: 63.09,
    },
    county_names_all: "St. Clair|Bates|Henry",
    county_fips_all: "29185|29013|29083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64725,
    lat: 38.49482,
    lng: -94.36609,
    city: "Archie",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2162,
    density: 15.3,
    county_fips: 29037,
    county_name: "Cass",
    county_weights: {
      29013: 18.26,
      29037: 81.74,
    },
    county_names_all: "Cass|Bates",
    county_fips_all: "29037|29013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64726,
    lat: 38.52921,
    lng: -93.92492,
    city: "Blairstown",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 367,
    density: 3.1,
    county_fips: 29083,
    county_name: "Henry",
    county_weights: {
      29083: 92.12,
      29101: 7.88,
    },
    county_names_all: "Henry|Johnson",
    county_fips_all: "29083|29101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64728,
    lat: 37.70217,
    lng: -94.5174,
    city: "Bronaugh",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 501,
    density: 2.4,
    county_fips: 29217,
    county_name: "Vernon",
    county_weights: {
      29217: 100,
    },
    county_names_all: "Vernon",
    county_fips_all: 29217,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64730,
    lat: 38.25789,
    lng: -94.29236,
    city: "Butler",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6740,
    density: 9.2,
    county_fips: 29013,
    county_name: "Bates",
    county_weights: {
      29013: 100,
    },
    county_names_all: "Bates",
    county_fips_all: 29013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64733,
    lat: 38.58016,
    lng: -93.8283,
    city: "Chilhowee",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1355,
    density: 7.1,
    county_fips: 29101,
    county_name: "Johnson",
    county_weights: {
      29083: 34.13,
      29101: 65.87,
    },
    county_names_all: "Johnson|Henry",
    county_fips_all: "29101|29083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64734,
    lat: 38.64888,
    lng: -94.57405,
    city: "Cleveland",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2596,
    density: 24.3,
    county_fips: 29037,
    county_name: "Cass",
    county_weights: {
      29037: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 29037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64735,
    lat: 38.36612,
    lng: -93.73644,
    city: "Clinton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12904,
    density: 19,
    county_fips: 29083,
    county_name: "Henry",
    county_weights: {
      29015: 2.12,
      29083: 97.88,
    },
    county_names_all: "Henry|Benton",
    county_fips_all: "29083|29015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64738,
    lat: 37.90098,
    lng: -93.65987,
    city: "Collins",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1242,
    density: 6,
    county_fips: 29185,
    county_name: "St. Clair",
    county_weights: {
      29185: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 29185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64739,
    lat: 38.51139,
    lng: -94.09389,
    city: "Creighton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 978,
    density: 7.2,
    county_fips: 29037,
    county_name: "Cass",
    county_weights: {
      29037: 71.48,
      29083: 28.52,
    },
    county_names_all: "Cass|Henry",
    county_fips_all: "29037|29083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64740,
    lat: 38.22349,
    lng: -93.71204,
    city: "Deepwater",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1670,
    density: 6.2,
    county_fips: 29083,
    county_name: "Henry",
    county_weights: {
      29083: 70.06,
      29185: 29.94,
    },
    county_names_all: "Henry|St. Clair",
    county_fips_all: "29083|29185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64741,
    lat: 37.81671,
    lng: -94.5629,
    city: "Deerfield",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 126,
    density: 1.4,
    county_fips: 29217,
    county_name: "Vernon",
    county_weights: {
      29217: 100,
    },
    county_names_all: "Vernon",
    county_fips_all: 29217,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64742,
    lat: 38.50034,
    lng: -94.54329,
    city: "Drexel",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2189,
    density: 11,
    county_fips: 29037,
    county_name: "Cass",
    county_weights: {
      29013: 31.12,
      29037: 68.88,
    },
    county_names_all: "Cass|Bates",
    county_fips_all: "29037|29013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64743,
    lat: 38.66596,
    lng: -94.21827,
    city: "East Lynne",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 184,
    density: 52.2,
    county_fips: 29037,
    county_name: "Cass",
    county_weights: {
      29037: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 29037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64744,
    lat: 37.84963,
    lng: -93.97755,
    city: "El Dorado Springs",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7989,
    density: 12.3,
    county_fips: 29039,
    county_name: "Cedar",
    county_weights: {
      29039: 57.08,
      29185: 27.94,
      29217: 14.98,
    },
    county_names_all: "Cedar|St. Clair|Vernon",
    county_fips_all: "29039|29185|29217",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64745,
    lat: 38.15662,
    lng: -94.50384,
    city: "Foster",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64,
    density: 16.1,
    county_fips: 29013,
    county_name: "Bates",
    county_weights: {
      29013: 100,
    },
    county_names_all: "Bates",
    county_fips_all: 29013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64746,
    lat: 38.61054,
    lng: -94.49304,
    city: "Freeman",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1345,
    density: 16.7,
    county_fips: 29037,
    county_name: "Cass",
    county_weights: {
      29037: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 29037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64747,
    lat: 38.57353,
    lng: -94.17399,
    city: "Garden City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3999,
    density: 12.3,
    county_fips: 29037,
    county_name: "Cass",
    county_weights: {
      29037: 80.72,
      29101: 19.28,
    },
    county_names_all: "Cass|Johnson",
    county_fips_all: "29037|29101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64748,
    lat: 37.36497,
    lng: -94.10017,
    city: "Golden City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1584,
    density: 5.6,
    county_fips: 29011,
    county_name: "Barton",
    county_weights: {
      29011: 45.74,
      29057: 28.65,
      29097: 18.77,
      29109: 6.85,
    },
    county_names_all: "Barton|Dade|Jasper|Lawrence",
    county_fips_all: "29011|29057|29097|29109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64750,
    lat: 37.93033,
    lng: -94.11427,
    city: "Harwood",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 517,
    density: 6.7,
    county_fips: 29217,
    county_name: "Vernon",
    county_weights: {
      29185: 10.61,
      29217: 89.39,
    },
    county_names_all: "Vernon|St. Clair",
    county_fips_all: "29217|29185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64752,
    lat: 38.0689,
    lng: -94.56862,
    city: "Hume",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 622,
    density: 3.5,
    county_fips: 29217,
    county_name: "Vernon",
    county_weights: {
      29013: 47.7,
      29217: 52.3,
    },
    county_names_all: "Vernon|Bates",
    county_fips_all: "29217|29013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64755,
    lat: 37.33685,
    lng: -94.31112,
    city: "Jasper",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2844,
    density: 7.5,
    county_fips: 29097,
    county_name: "Jasper",
    county_weights: {
      29011: 34.76,
      29097: 65.24,
    },
    county_names_all: "Jasper|Barton",
    county_fips_all: "29097|29011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64756,
    lat: 37.61931,
    lng: -94.01462,
    city: "Jerico Springs",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 641,
    density: 4.1,
    county_fips: 29039,
    county_name: "Cedar",
    county_weights: {
      29039: 76.73,
      29057: 23.27,
    },
    county_names_all: "Cedar|Dade",
    county_fips_all: "29039|29057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64759,
    lat: 37.52655,
    lng: -94.26775,
    city: "Lamar",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7701,
    density: 11.2,
    county_fips: 29011,
    county_name: "Barton",
    county_weights: {
      29011: 99,
      29057: 1,
    },
    county_names_all: "Barton|Dade",
    county_fips_all: "29011|29057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64761,
    lat: 38.59463,
    lng: -93.68657,
    city: "Leeton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1470,
    density: 8.1,
    county_fips: 29101,
    county_name: "Johnson",
    county_weights: {
      29083: 20.41,
      29101: 79.59,
    },
    county_names_all: "Johnson|Henry",
    county_fips_all: "29101|29083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64762,
    lat: 37.54628,
    lng: -94.50176,
    city: "Liberal",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1614,
    density: 4.9,
    county_fips: 29011,
    county_name: "Barton",
    county_weights: {
      29011: 100,
    },
    county_names_all: "Barton",
    county_fips_all: 29011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64763,
    lat: 38.14354,
    lng: -93.71573,
    city: "Lowry City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1339,
    density: 7.4,
    county_fips: 29185,
    county_name: "St. Clair",
    county_weights: {
      29185: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 29185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64765,
    lat: 37.9965,
    lng: -94.44297,
    city: "Metz",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15,
    density: 45.6,
    county_fips: 29217,
    county_name: "Vernon",
    county_weights: {
      29217: 100,
    },
    county_names_all: "Vernon",
    county_fips_all: 29217,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64767,
    lat: 37.7499,
    lng: -94.1997,
    city: "Milo",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 635,
    density: 4.1,
    county_fips: 29217,
    county_name: "Vernon",
    county_weights: {
      29217: 100,
    },
    county_names_all: "Vernon",
    county_fips_all: 29217,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64769,
    lat: 37.48028,
    lng: -94.56688,
    city: "Mindenmines",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 709,
    density: 6.7,
    county_fips: 29011,
    county_name: "Barton",
    county_weights: {
      29011: 100,
    },
    county_names_all: "Barton",
    county_fips_all: 29011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64770,
    lat: 38.27528,
    lng: -93.98662,
    city: "Montrose",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1166,
    density: 4.1,
    county_fips: 29083,
    county_name: "Henry",
    county_weights: {
      29013: 11.38,
      29083: 84.01,
      29185: 4.61,
    },
    county_names_all: "Henry|Bates|St. Clair",
    county_fips_all: "29083|29013|29185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64771,
    lat: 37.77091,
    lng: -94.45967,
    city: "Moundville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 428,
    density: 4.4,
    county_fips: 29217,
    county_name: "Vernon",
    county_weights: {
      29217: 100,
    },
    county_names_all: "Vernon",
    county_fips_all: 29217,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64772,
    lat: 37.82712,
    lng: -94.33355,
    city: "Nevada",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13498,
    density: 40.4,
    county_fips: 29217,
    county_name: "Vernon",
    county_weights: {
      29217: 100,
    },
    county_names_all: "Vernon",
    county_fips_all: 29217,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64776,
    lat: 38.04242,
    lng: -93.67469,
    city: "Osceola",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3765,
    density: 6.1,
    county_fips: 29185,
    county_name: "St. Clair",
    county_weights: {
      29015: 5.45,
      29185: 94.55,
    },
    county_names_all: "St. Clair|Benton",
    county_fips_all: "29185|29015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64778,
    lat: 37.92283,
    lng: -94.4841,
    city: "Richards",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 536,
    density: 1.8,
    county_fips: 29217,
    county_name: "Vernon",
    county_weights: {
      29217: 100,
    },
    county_names_all: "Vernon",
    county_fips_all: 29217,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64779,
    lat: 38.09214,
    lng: -94.40152,
    city: "Rich Hill",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2780,
    density: 5.4,
    county_fips: 29013,
    county_name: "Bates",
    county_weights: {
      29013: 72.81,
      29217: 27.19,
    },
    county_names_all: "Bates|Vernon",
    county_fips_all: "29013|29217",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64780,
    lat: 38.06246,
    lng: -94.04276,
    city: "Rockville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 455,
    density: 1.8,
    county_fips: 29185,
    county_name: "St. Clair",
    county_weights: {
      29013: 41.91,
      29185: 58.09,
    },
    county_names_all: "St. Clair|Bates",
    county_fips_all: "29185|29013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64781,
    lat: 37.97837,
    lng: -93.81242,
    city: "Roscoe",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 100,
    density: 48.2,
    county_fips: 29185,
    county_name: "St. Clair",
    county_weights: {
      29185: 100,
    },
    county_names_all: "St. Clair",
    county_fips_all: 29185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64783,
    lat: 37.99972,
    lng: -94.10688,
    city: "Schell City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 726,
    density: 4.3,
    county_fips: 29217,
    county_name: "Vernon",
    county_weights: {
      29185: 27.21,
      29217: 72.79,
    },
    county_names_all: "Vernon|St. Clair",
    county_fips_all: "29217|29185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64784,
    lat: 37.66624,
    lng: -94.23131,
    city: "Sheldon",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1302,
    density: 4.5,
    county_fips: 29217,
    county_name: "Vernon",
    county_weights: {
      29011: 24.06,
      29039: 1.53,
      29217: 74.41,
    },
    county_names_all: "Vernon|Barton|Cedar",
    county_fips_all: "29217|29011|29039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64788,
    lat: 38.42868,
    lng: -94.02045,
    city: "Urich",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1629,
    density: 6.1,
    county_fips: 29083,
    county_name: "Henry",
    county_weights: {
      29013: 25.31,
      29083: 74.69,
    },
    county_names_all: "Henry|Bates",
    county_fips_all: "29083|29013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64790,
    lat: 37.92924,
    lng: -94.22969,
    city: "Walker",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 906,
    density: 4.1,
    county_fips: 29217,
    county_name: "Vernon",
    county_weights: {
      29217: 100,
    },
    county_names_all: "Vernon",
    county_fips_all: 29217,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64801,
    lat: 37.11056,
    lng: -94.4974,
    city: "Joplin",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37360,
    density: 250.8,
    county_fips: 29097,
    county_name: "Jasper",
    county_weights: {
      29097: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 29097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64804,
    lat: 37.01955,
    lng: -94.51137,
    city: "Joplin",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36116,
    density: 152.5,
    county_fips: 29145,
    county_name: "Newton",
    county_weights: {
      29097: 18.61,
      29145: 81.39,
    },
    county_names_all: "Newton|Jasper",
    county_fips_all: "29145|29097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64830,
    lat: 37.2308,
    lng: -94.41053,
    city: "Alba",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 837,
    density: 212.1,
    county_fips: 29097,
    county_name: "Jasper",
    county_weights: {
      29097: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 29097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64831,
    lat: 36.65598,
    lng: -94.4541,
    city: "Anderson",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6942,
    density: 23,
    county_fips: 29119,
    county_name: "McDonald",
    county_weights: {
      29119: 100,
    },
    county_names_all: "McDonald",
    county_fips_all: 29119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64832,
    lat: 37.33951,
    lng: -94.57264,
    city: "Asbury",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1134,
    density: 6.2,
    county_fips: 29097,
    county_name: "Jasper",
    county_weights: {
      29011: 39.9,
      29097: 60.1,
    },
    county_names_all: "Jasper|Barton",
    county_fips_all: "29097|29011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64833,
    lat: 37.1938,
    lng: -94.12982,
    city: "Avilla",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41,
    density: 81,
    county_fips: 29097,
    county_name: "Jasper",
    county_weights: {
      29097: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 29097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64834,
    lat: 37.18714,
    lng: -94.56865,
    city: "Carl Junction",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10247,
    density: 122.8,
    county_fips: 29097,
    county_name: "Jasper",
    county_weights: {
      29097: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 29097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64835,
    lat: 37.14749,
    lng: -94.43824,
    city: "Carterville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2228,
    density: 400,
    county_fips: 29097,
    county_name: "Jasper",
    county_weights: {
      29097: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 29097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64836,
    lat: 37.18886,
    lng: -94.28898,
    city: "Carthage",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24375,
    density: 51.1,
    county_fips: 29097,
    county_name: "Jasper",
    county_weights: {
      29097: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 29097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64840,
    lat: 37.01826,
    lng: -94.33536,
    city: "Diamond",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3049,
    density: 22.6,
    county_fips: 29145,
    county_name: "Newton",
    county_weights: {
      29097: 12.75,
      29145: 87.25,
    },
    county_names_all: "Newton|Jasper",
    county_fips_all: "29145|29097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64841,
    lat: 37.07873,
    lng: -94.41101,
    city: "Duenweg",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 350,
    density: 322.4,
    county_fips: 29097,
    county_name: "Jasper",
    county_weights: {
      29097: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 29097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64842,
    lat: 36.7914,
    lng: -94.10427,
    city: "Fairview",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 894,
    density: 15.8,
    county_fips: 29145,
    county_name: "Newton",
    county_weights: {
      29009: 5.57,
      29145: 94.43,
    },
    county_names_all: "Newton|Barry",
    county_fips_all: "29145|29009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64843,
    lat: 36.73345,
    lng: -94.45319,
    city: "Goodman",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3764,
    density: 24.9,
    county_fips: 29119,
    county_name: "McDonald",
    county_weights: {
      29119: 86.34,
      29145: 13.66,
    },
    county_names_all: "McDonald|Newton",
    county_fips_all: "29119|29145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64844,
    lat: 36.91388,
    lng: -94.24038,
    city: "Granby",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4880,
    density: 28.6,
    county_fips: 29145,
    county_name: "Newton",
    county_weights: {
      29145: 100,
    },
    county_names_all: "Newton",
    county_fips_all: 29145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64847,
    lat: 36.59217,
    lng: -94.43863,
    city: "Lanagan",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 461,
    density: 50.1,
    county_fips: 29119,
    county_name: "McDonald",
    county_weights: {
      29119: 100,
    },
    county_names_all: "McDonald",
    county_fips_all: 29119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64848,
    lat: 37.18061,
    lng: -93.99523,
    city: "La Russell",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 451,
    density: 4.1,
    county_fips: 29109,
    county_name: "Lawrence",
    county_weights: {
      29097: 1.22,
      29109: 98.78,
    },
    county_names_all: "Lawrence|Jasper",
    county_fips_all: "29109|29097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64849,
    lat: 37.2544,
    lng: -94.44529,
    city: "Neck City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 199,
    density: 221.1,
    county_fips: 29097,
    county_name: "Jasper",
    county_weights: {
      29097: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 29097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64850,
    lat: 36.86008,
    lng: -94.3975,
    city: "Neosho",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23217,
    density: 44.1,
    county_fips: 29145,
    county_name: "Newton",
    county_weights: {
      29119: 3.86,
      29145: 96.14,
    },
    county_names_all: "Newton|McDonald",
    county_fips_all: "29145|29119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64854,
    lat: 36.54369,
    lng: -94.44144,
    city: "Noel",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4106,
    density: 21.3,
    county_fips: 29119,
    county_name: "McDonald",
    county_weights: {
      29119: 100,
    },
    county_names_all: "McDonald",
    county_fips_all: 29119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64855,
    lat: 37.29548,
    lng: -94.48637,
    city: "Oronogo",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2317,
    density: 21,
    county_fips: 29097,
    county_name: "Jasper",
    county_weights: {
      29011: 13.03,
      29097: 86.97,
    },
    county_names_all: "Jasper|Barton",
    county_fips_all: "29097|29011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64856,
    lat: 36.5652,
    lng: -94.26346,
    city: "Pineville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3734,
    density: 15.9,
    county_fips: 29119,
    county_name: "McDonald",
    county_weights: {
      29119: 100,
    },
    county_names_all: "McDonald",
    county_fips_all: 29119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64857,
    lat: 37.24587,
    lng: -94.43861,
    city: "Purcell",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 400,
    density: 257.8,
    county_fips: 29097,
    county_name: "Jasper",
    county_weights: {
      29097: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 29097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64858,
    lat: 36.89981,
    lng: -94.52888,
    city: "Racine",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 419,
    density: 475.5,
    county_fips: 29145,
    county_name: "Newton",
    county_weights: {
      29145: 100,
    },
    county_names_all: "Newton",
    county_fips_all: 29145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64859,
    lat: 37.15822,
    lng: -94.14703,
    city: "Reeds",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1360,
    density: 10.3,
    county_fips: 29097,
    county_name: "Jasper",
    county_weights: {
      29097: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 29097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64861,
    lat: 36.6953,
    lng: -94.14864,
    city: "Rocky Comfort",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 997,
    density: 6.6,
    county_fips: 29119,
    county_name: "McDonald",
    county_weights: {
      29119: 96.07,
      29145: 3.93,
    },
    county_names_all: "McDonald|Newton",
    county_fips_all: "29119|29145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64862,
    lat: 37.10128,
    lng: -94.11469,
    city: "Sarcoxie",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3943,
    density: 16.8,
    county_fips: 29097,
    county_name: "Jasper",
    county_weights: {
      29097: 60.84,
      29109: 14.14,
      29145: 25.02,
    },
    county_names_all: "Jasper|Newton|Lawrence",
    county_fips_all: "29097|29145|29109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64863,
    lat: 36.55511,
    lng: -94.58444,
    city: "South West City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1641,
    density: 20.5,
    county_fips: 29119,
    county_name: "McDonald",
    county_weights: {
      29119: 100,
    },
    county_names_all: "McDonald",
    county_fips_all: 29119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64865,
    lat: 36.84253,
    lng: -94.57797,
    city: "Seneca",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5679,
    density: 29.2,
    county_fips: 29145,
    county_name: "Newton",
    county_weights: {
      29119: 15.68,
      29145: 84.32,
    },
    county_names_all: "Newton|McDonald",
    county_fips_all: "29145|29119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64866,
    lat: 36.8677,
    lng: -94.14317,
    city: "Stark City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 934,
    density: 6.8,
    county_fips: 29145,
    county_name: "Newton",
    county_weights: {
      29145: 100,
    },
    county_names_all: "Newton",
    county_fips_all: 29145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64867,
    lat: 36.73023,
    lng: -94.23316,
    city: "Stella",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1302,
    density: 8.7,
    county_fips: 29119,
    county_name: "McDonald",
    county_weights: {
      29119: 62.79,
      29145: 37.21,
    },
    county_names_all: "McDonald|Newton",
    county_fips_all: "29119|29145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64868,
    lat: 36.68742,
    lng: -94.61285,
    city: "Tiff City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 29119,
    county_name: "McDonald",
    county_weights: {
      29119: 100,
    },
    county_names_all: "McDonald",
    county_fips_all: 29119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64870,
    lat: 37.18474,
    lng: -94.48136,
    city: "Webb City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14982,
    density: 171.9,
    county_fips: 29097,
    county_name: "Jasper",
    county_weights: {
      29097: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 29097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64873,
    lat: 37.01565,
    lng: -94.05358,
    city: "Wentworth",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 775,
    density: 7.1,
    county_fips: 29109,
    county_name: "Lawrence",
    county_weights: {
      29109: 53.53,
      29145: 46.47,
    },
    county_names_all: "Lawrence|Newton",
    county_fips_all: "29109|29145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 64874,
    lat: 36.75617,
    lng: -94.05444,
    city: "Wheaton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 563,
    density: 119.2,
    county_fips: 29009,
    county_name: "Barry",
    county_weights: {
      29009: 100,
    },
    county_names_all: "Barry",
    county_fips_all: 29009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65001,
    lat: 38.27141,
    lng: -92.00077,
    city: "Argyle",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 247,
    density: 4.3,
    county_fips: 29125,
    county_name: "Maries",
    county_weights: {
      29125: 73.22,
      29151: 26.78,
    },
    county_names_all: "Maries|Osage",
    county_fips_all: "29125|29151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65010,
    lat: 38.78757,
    lng: -92.24301,
    city: "Ashland",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6083,
    density: 38.7,
    county_fips: 29019,
    county_name: "Boone",
    county_weights: {
      29019: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 29019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65011,
    lat: 38.39493,
    lng: -92.70815,
    city: "Barnett",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2689,
    density: 12.6,
    county_fips: 29141,
    county_name: "Morgan",
    county_weights: {
      29135: 12.72,
      29141: 87.28,
    },
    county_names_all: "Morgan|Moniteau",
    county_fips_all: "29141|29135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65013,
    lat: 38.26868,
    lng: -91.75493,
    city: "Belle",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2597,
    density: 7.7,
    county_fips: 29125,
    county_name: "Maries",
    county_weights: {
      29125: 61.28,
      29151: 38.72,
    },
    county_names_all: "Maries|Osage",
    county_fips_all: "29125|29151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65014,
    lat: 38.32184,
    lng: -91.6247,
    city: "Bland",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2658,
    density: 7.2,
    county_fips: 29073,
    county_name: "Gasconade",
    county_weights: {
      29073: 69.32,
      29125: 3.28,
      29151: 27.4,
    },
    county_names_all: "Gasconade|Osage|Maries",
    county_fips_all: "29073|29151|29125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65016,
    lat: 38.56167,
    lng: -91.91896,
    city: "Bonnots Mill",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1414,
    density: 10.6,
    county_fips: 29151,
    county_name: "Osage",
    county_weights: {
      29151: 100,
    },
    county_names_all: "Osage",
    county_fips_all: 29151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65017,
    lat: 38.09185,
    lng: -92.49548,
    city: "Brumley",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 844,
    density: 5.3,
    county_fips: 29131,
    county_name: "Miller",
    county_weights: {
      29029: 1.41,
      29131: 98.59,
    },
    county_names_all: "Miller|Camden",
    county_fips_all: "29131|29029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65018,
    lat: 38.62038,
    lng: -92.56314,
    city: "California",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7696,
    density: 19,
    county_fips: 29135,
    county_name: "Moniteau",
    county_weights: {
      29053: 7.19,
      29135: 92.81,
    },
    county_names_all: "Moniteau|Cooper",
    county_fips_all: "29135|29053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65020,
    lat: 38.00517,
    lng: -92.78193,
    city: "Camdenton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16055,
    density: 50.1,
    county_fips: 29029,
    county_name: "Camden",
    county_weights: {
      29029: 99.51,
      29105: 0.49,
    },
    county_names_all: "Camden|Laclede",
    county_fips_all: "29029|29105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65023,
    lat: 38.65274,
    lng: -92.39915,
    city: "Centertown",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1741,
    density: 12.3,
    county_fips: 29051,
    county_name: "Cole",
    county_weights: {
      29051: 75.63,
      29135: 24.37,
    },
    county_names_all: "Cole|Moniteau",
    county_fips_all: "29051|29135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65024,
    lat: 38.62444,
    lng: -91.75712,
    city: "Chamois",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1061,
    density: 4.2,
    county_fips: 29151,
    county_name: "Osage",
    county_weights: {
      29151: 100,
    },
    county_names_all: "Osage",
    county_fips_all: 29151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65025,
    lat: 38.66618,
    lng: -92.68119,
    city: "Clarksburg",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 742,
    density: 5.5,
    county_fips: 29135,
    county_name: "Moniteau",
    county_weights: {
      29053: 39.12,
      29135: 60.88,
    },
    county_names_all: "Moniteau|Cooper",
    county_fips_all: "29135|29053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65026,
    lat: 38.32105,
    lng: -92.57099,
    city: "Eldon",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10928,
    density: 29.4,
    county_fips: 29131,
    county_name: "Miller",
    county_weights: {
      29131: 97.84,
      29141: 2.16,
    },
    county_names_all: "Miller|Morgan",
    county_fips_all: "29131|29141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65032,
    lat: 38.34024,
    lng: -92.37942,
    city: "Eugene",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1551,
    density: 10.3,
    county_fips: 29131,
    county_name: "Miller",
    county_weights: {
      29051: 31.52,
      29131: 68.48,
    },
    county_names_all: "Miller|Cole",
    county_fips_all: "29131|29051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65034,
    lat: 38.55637,
    lng: -92.82183,
    city: "Fortuna",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1235,
    density: 15.8,
    county_fips: 29141,
    county_name: "Morgan",
    county_weights: {
      29135: 24.97,
      29141: 75.03,
    },
    county_names_all: "Morgan|Moniteau",
    county_fips_all: "29141|29135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65035,
    lat: 38.36338,
    lng: -91.93585,
    city: "Freeburg",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1884,
    density: 10.2,
    county_fips: 29151,
    county_name: "Osage",
    county_weights: {
      29151: 100,
    },
    county_names_all: "Osage",
    county_fips_all: 29151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65037,
    lat: 38.23845,
    lng: -92.85749,
    city: "Gravois Mills",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4246,
    density: 20.7,
    county_fips: 29141,
    county_name: "Morgan",
    county_weights: {
      29029: 14.47,
      29141: 85.53,
    },
    county_names_all: "Morgan|Camden",
    county_fips_all: "29141|29029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65039,
    lat: 38.71388,
    lng: -92.2984,
    city: "Hartsburg",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2888,
    density: 18.8,
    county_fips: 29019,
    county_name: "Boone",
    county_weights: {
      29019: 92.2,
      29027: 7.8,
    },
    county_names_all: "Boone|Callaway",
    county_fips_all: "29019|29027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65040,
    lat: 38.36367,
    lng: -92.31252,
    city: "Henley",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1007,
    density: 9.5,
    county_fips: 29051,
    county_name: "Cole",
    county_weights: {
      29051: 83.52,
      29131: 16.48,
    },
    county_names_all: "Cole|Miller",
    county_fips_all: "29051|29131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65041,
    lat: 38.64088,
    lng: -91.47712,
    city: "Hermann",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5465,
    density: 8.8,
    county_fips: 29073,
    county_name: "Gasconade",
    county_weights: {
      29073: 70.79,
      29139: 17.64,
      29219: 11.57,
    },
    county_names_all: "Gasconade|Montgomery|Warren",
    county_fips_all: "29073|29139|29219",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65043,
    lat: 38.62563,
    lng: -92.10774,
    city: "Holts Summit",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10327,
    density: 68.6,
    county_fips: 29027,
    county_name: "Callaway",
    county_weights: {
      29027: 100,
    },
    county_names_all: "Callaway",
    county_fips_all: 29027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65046,
    lat: 38.77658,
    lng: -92.47889,
    city: "Jamestown",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1548,
    density: 8.1,
    county_fips: 29135,
    county_name: "Moniteau",
    county_weights: {
      29135: 100,
    },
    county_names_all: "Moniteau",
    county_fips_all: 29135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65047,
    lat: 38.15483,
    lng: -92.57774,
    city: "Kaiser",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1756,
    density: 22.1,
    county_fips: 29131,
    county_name: "Miller",
    county_weights: {
      29029: 23.56,
      29131: 76.44,
    },
    county_names_all: "Miller|Camden",
    county_fips_all: "29131|29029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65048,
    lat: 38.35745,
    lng: -92.0365,
    city: "Koeltztown",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 131,
    density: 2.4,
    county_fips: 29151,
    county_name: "Osage",
    county_weights: {
      29151: 100,
    },
    county_names_all: "Osage",
    county_fips_all: 29151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65049,
    lat: 38.20127,
    lng: -92.67067,
    city: "Lake Ozark",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7455,
    density: 155.3,
    county_fips: 29029,
    county_name: "Camden",
    county_weights: {
      29029: 58.06,
      29131: 41.94,
    },
    county_names_all: "Camden|Miller",
    county_fips_all: "29029|29131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65050,
    lat: 38.5305,
    lng: -92.68867,
    city: "Latham",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 774,
    density: 16.8,
    county_fips: 29135,
    county_name: "Moniteau",
    county_weights: {
      29135: 100,
    },
    county_names_all: "Moniteau",
    county_fips_all: 29135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65051,
    lat: 38.46519,
    lng: -91.79758,
    city: "Linn",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4668,
    density: 14.2,
    county_fips: 29151,
    county_name: "Osage",
    county_weights: {
      29073: 0.57,
      29151: 99.43,
    },
    county_names_all: "Osage|Gasconade",
    county_fips_all: "29151|29073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65052,
    lat: 38.05068,
    lng: -92.65568,
    city: "Linn Creek",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4028,
    density: 32.8,
    county_fips: 29029,
    county_name: "Camden",
    county_weights: {
      29029: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 29029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65053,
    lat: 38.54132,
    lng: -92.36966,
    city: "Lohman",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1721,
    density: 19.1,
    county_fips: 29051,
    county_name: "Cole",
    county_weights: {
      29051: 100,
    },
    county_names_all: "Cole",
    county_fips_all: 29051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65054,
    lat: 38.49103,
    lng: -91.95003,
    city: "Loose Creek",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1209,
    density: 22.4,
    county_fips: 29151,
    county_name: "Osage",
    county_weights: {
      29151: 100,
    },
    county_names_all: "Osage",
    county_fips_all: 29151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65058,
    lat: 38.25777,
    lng: -92.12946,
    city: "Meta",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 794,
    density: 3.1,
    county_fips: 29125,
    county_name: "Maries",
    county_weights: {
      29051: 0.49,
      29125: 68.93,
      29131: 11.69,
      29151: 18.89,
    },
    county_names_all: "Maries|Osage|Miller|Cole",
    county_fips_all: "29125|29151|29131|29051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65059,
    lat: 38.70365,
    lng: -91.88447,
    city: "Mokane",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1090,
    density: 11.9,
    county_fips: 29027,
    county_name: "Callaway",
    county_weights: {
      29027: 100,
    },
    county_names_all: "Callaway",
    county_fips_all: 29027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65061,
    lat: 38.59773,
    lng: -91.638,
    city: "Morrison",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 593,
    density: 4.3,
    county_fips: 29073,
    county_name: "Gasconade",
    county_weights: {
      29073: 53.64,
      29151: 46.36,
    },
    county_names_all: "Gasconade|Osage",
    county_fips_all: "29073|29151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65062,
    lat: 38.49486,
    lng: -91.65059,
    city: "Mount Sterling",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47,
    density: 4.4,
    county_fips: 29151,
    county_name: "Osage",
    county_weights: {
      29073: 34.62,
      29151: 65.38,
    },
    county_names_all: "Osage|Gasconade",
    county_fips_all: "29151|29073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65063,
    lat: 38.72635,
    lng: -92.08743,
    city: "New Bloomfield",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3423,
    density: 15.4,
    county_fips: 29027,
    county_name: "Callaway",
    county_weights: {
      29027: 100,
    },
    county_names_all: "Callaway",
    county_fips_all: 29027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65064,
    lat: 38.40634,
    lng: -92.47664,
    city: "Olean",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 666,
    density: 15.1,
    county_fips: 29131,
    county_name: "Miller",
    county_weights: {
      29131: 98.94,
      29135: 1.06,
    },
    county_names_all: "Miller|Moniteau",
    county_fips_all: "29131|29135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65065,
    lat: 38.13462,
    lng: -92.66593,
    city: "Osage Beach",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6944,
    density: 162.3,
    county_fips: 29029,
    county_name: "Camden",
    county_weights: {
      29029: 90.79,
      29131: 9.21,
    },
    county_names_all: "Camden|Miller",
    county_fips_all: "29029|29131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65066,
    lat: 38.3454,
    lng: -91.48898,
    city: "Owensville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5932,
    density: 13.1,
    county_fips: 29073,
    county_name: "Gasconade",
    county_weights: {
      29055: 9.92,
      29073: 90.08,
    },
    county_names_all: "Gasconade|Crawford",
    county_fips_all: "29073|29055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65067,
    lat: 38.75365,
    lng: -91.72369,
    city: "Portland",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 563,
    density: 4.3,
    county_fips: 29027,
    county_name: "Callaway",
    county_weights: {
      29027: 100,
    },
    county_names_all: "Callaway",
    county_fips_all: 29027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65068,
    lat: 38.82757,
    lng: -92.59909,
    city: "Prairie Home",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 798,
    density: 6.3,
    county_fips: 29053,
    county_name: "Cooper",
    county_weights: {
      29053: 95.07,
      29135: 4.93,
    },
    county_names_all: "Cooper|Moniteau",
    county_fips_all: "29053|29135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65069,
    lat: 38.75573,
    lng: -91.5966,
    city: "Rhineland",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 506,
    density: 2.7,
    county_fips: 29139,
    county_name: "Montgomery",
    county_weights: {
      29027: 16,
      29139: 84,
    },
    county_names_all: "Montgomery|Callaway",
    county_fips_all: "29139|29027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65072,
    lat: 38.26635,
    lng: -92.72178,
    city: "Rocky Mount",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1757,
    density: 35.6,
    county_fips: 29141,
    county_name: "Morgan",
    county_weights: {
      29131: 9.84,
      29141: 90.16,
    },
    county_names_all: "Morgan|Miller",
    county_fips_all: "29141|29131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65074,
    lat: 38.47967,
    lng: -92.47306,
    city: "Russellville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2787,
    density: 11.4,
    county_fips: 29135,
    county_name: "Moniteau",
    county_weights: {
      29051: 48.56,
      29131: 1.99,
      29135: 49.45,
    },
    county_names_all: "Moniteau|Cole|Miller",
    county_fips_all: "29135|29051|29131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65075,
    lat: 38.24849,
    lng: -92.26388,
    city: "Saint Elizabeth",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1082,
    density: 8.4,
    county_fips: 29131,
    county_name: "Miller",
    county_weights: {
      29131: 100,
    },
    county_names_all: "Miller",
    county_fips_all: 29131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65076,
    lat: 38.37064,
    lng: -92.20376,
    city: "Saint Thomas",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 758,
    density: 11.5,
    county_fips: 29051,
    county_name: "Cole",
    county_weights: {
      29051: 67.86,
      29151: 32.14,
    },
    county_names_all: "Cole|Osage",
    county_fips_all: "29051|29151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65077,
    lat: 38.7691,
    lng: -91.80305,
    city: "Steedman",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 392,
    density: 5.6,
    county_fips: 29027,
    county_name: "Callaway",
    county_weights: {
      29027: 100,
    },
    county_names_all: "Callaway",
    county_fips_all: 29027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65078,
    lat: 38.38473,
    lng: -93.01085,
    city: "Stover",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3620,
    density: 8.9,
    county_fips: 29141,
    county_name: "Morgan",
    county_weights: {
      29015: 6.31,
      29141: 93.69,
    },
    county_names_all: "Morgan|Benton",
    county_fips_all: "29141|29015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65079,
    lat: 38.15283,
    lng: -92.75225,
    city: "Sunrise Beach",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4615,
    density: 56,
    county_fips: 29029,
    county_name: "Camden",
    county_weights: {
      29029: 97.14,
      29141: 2.86,
    },
    county_names_all: "Camden|Morgan",
    county_fips_all: "29029|29141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65080,
    lat: 38.63231,
    lng: -91.97713,
    city: "Tebbetts",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1155,
    density: 10.8,
    county_fips: 29027,
    county_name: "Callaway",
    county_weights: {
      29027: 100,
    },
    county_names_all: "Callaway",
    county_fips_all: 29027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65081,
    lat: 38.64086,
    lng: -92.78424,
    city: "Tipton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4013,
    density: 21,
    county_fips: 29135,
    county_name: "Moniteau",
    county_weights: {
      29053: 21.41,
      29135: 70.27,
      29141: 8.32,
    },
    county_names_all: "Moniteau|Cooper|Morgan",
    county_fips_all: "29135|29053|29141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65082,
    lat: 38.22243,
    lng: -92.42632,
    city: "Tuscumbia",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1124,
    density: 6.1,
    county_fips: 29131,
    county_name: "Miller",
    county_weights: {
      29131: 100,
    },
    county_names_all: "Miller",
    county_fips_all: 29131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65083,
    lat: 38.14318,
    lng: -92.44089,
    city: "Ulman",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 231,
    density: 6.3,
    county_fips: 29131,
    county_name: "Miller",
    county_weights: {
      29131: 100,
    },
    county_names_all: "Miller",
    county_fips_all: 29131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65084,
    lat: 38.43574,
    lng: -92.85119,
    city: "Versailles",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6534,
    density: 15,
    county_fips: 29141,
    county_name: "Morgan",
    county_weights: {
      29135: 1.25,
      29141: 98.75,
    },
    county_names_all: "Morgan|Moniteau",
    county_fips_all: "29141|29135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65085,
    lat: 38.40304,
    lng: -92.07272,
    city: "Westphalia",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1349,
    density: 9.1,
    county_fips: 29151,
    county_name: "Osage",
    county_weights: {
      29151: 100,
    },
    county_names_all: "Osage",
    county_fips_all: 29151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65101,
    lat: 38.49143,
    lng: -92.15009,
    city: "Jefferson City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29665,
    density: 87.5,
    county_fips: 29051,
    county_name: "Cole",
    county_weights: {
      29027: 4.87,
      29051: 89.25,
      29151: 5.88,
    },
    county_names_all: "Cole|Osage|Callaway",
    county_fips_all: "29051|29151|29027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65109,
    lat: 38.57365,
    lng: -92.27791,
    city: "Jefferson City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39593,
    density: 189.4,
    county_fips: 29051,
    county_name: "Cole",
    county_weights: {
      29051: 100,
    },
    county_names_all: "Cole",
    county_fips_all: 29051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65201,
    lat: 38.89595,
    lng: -92.24365,
    city: "Columbia",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47215,
    density: 208.7,
    county_fips: 29019,
    county_name: "Boone",
    county_weights: {
      29019: 98.1,
      29027: 1.9,
    },
    county_names_all: "Boone|Callaway",
    county_fips_all: "29019|29027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65202,
    lat: 39.01721,
    lng: -92.29822,
    city: "Columbia",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48027,
    density: 131.2,
    county_fips: 29019,
    county_name: "Boone",
    county_weights: {
      29019: 90.67,
      29027: 9.33,
    },
    county_names_all: "Boone|Callaway",
    county_fips_all: "29019|29027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65203,
    lat: 38.89497,
    lng: -92.39928,
    city: "Columbia",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58271,
    density: 301.3,
    county_fips: 29019,
    county_name: "Boone",
    county_weights: {
      29019: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 29019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65215,
    lat: 38.95171,
    lng: -92.32043,
    city: "Columbia",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 277,
    density: 3000,
    county_fips: 29019,
    county_name: "Boone",
    county_weights: {
      29019: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 29019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65216,
    lat: 38.95818,
    lng: -92.32629,
    city: "Columbia",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 29019,
    county_name: "Boone",
    county_weights: {
      29019: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 29019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65230,
    lat: 39.28715,
    lng: -92.69218,
    city: "Armstrong",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 552,
    density: 3.3,
    county_fips: 29089,
    county_name: "Howard",
    county_weights: {
      29089: 78.67,
      29175: 21.33,
    },
    county_names_all: "Howard|Randolph",
    county_fips_all: "29089|29175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65231,
    lat: 39.01773,
    lng: -91.90803,
    city: "Auxvasse",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3277,
    density: 10.2,
    county_fips: 29027,
    county_name: "Callaway",
    county_weights: {
      29007: 2.49,
      29027: 97.51,
    },
    county_names_all: "Callaway|Audrain",
    county_fips_all: "29027|29007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65232,
    lat: 39.15901,
    lng: -91.75516,
    city: "Benton City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 207,
    density: 3.4,
    county_fips: 29007,
    county_name: "Audrain",
    county_weights: {
      29007: 100,
    },
    county_names_all: "Audrain",
    county_fips_all: 29007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65233,
    lat: 38.91528,
    lng: -92.72035,
    city: "Boonville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11785,
    density: 32.1,
    county_fips: 29053,
    county_name: "Cooper",
    county_weights: {
      29053: 100,
    },
    county_names_all: "Cooper",
    county_fips_all: 29053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65236,
    lat: 39.44596,
    lng: -93.08305,
    city: "Brunswick",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1440,
    density: 8,
    county_fips: 29041,
    county_name: "Chariton",
    county_weights: {
      29041: 100,
    },
    county_names_all: "Chariton",
    county_fips_all: 29041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65237,
    lat: 38.78078,
    lng: -92.78438,
    city: "Bunceton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1022,
    density: 4,
    county_fips: 29053,
    county_name: "Cooper",
    county_weights: {
      29053: 100,
    },
    county_names_all: "Cooper",
    county_fips_all: 29053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65239,
    lat: 39.53312,
    lng: -92.42334,
    city: "Cairo",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1695,
    density: 11.5,
    county_fips: 29175,
    county_name: "Randolph",
    county_weights: {
      29175: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 29175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65240,
    lat: 39.22085,
    lng: -92.13026,
    city: "Centralia",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9051,
    density: 19.4,
    county_fips: 29007,
    county_name: "Audrain",
    county_weights: {
      29007: 58.47,
      29019: 36.68,
      29027: 1.44,
      29137: 3.41,
    },
    county_names_all: "Audrain|Boone|Monroe|Callaway",
    county_fips_all: "29007|29019|29137|29027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65243,
    lat: 39.27654,
    lng: -92.35207,
    city: "Clark",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2383,
    density: 9.4,
    county_fips: 29175,
    county_name: "Randolph",
    county_weights: {
      29007: 24.22,
      29019: 25.9,
      29089: 5.43,
      29137: 2.83,
      29175: 41.62,
    },
    county_names_all: "Randolph|Boone|Audrain|Howard|Monroe",
    county_fips_all: "29175|29019|29007|29089|29137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65244,
    lat: 39.4807,
    lng: -92.65982,
    city: "Clifton Hill",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 352,
    density: 2,
    county_fips: 29175,
    county_name: "Randolph",
    county_weights: {
      29175: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 29175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65246,
    lat: 39.37725,
    lng: -93.00059,
    city: "Dalton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48,
    density: 0.5,
    county_fips: 29041,
    county_name: "Chariton",
    county_weights: {
      29041: 100,
    },
    county_names_all: "Chariton",
    county_fips_all: 29041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65247,
    lat: 39.63502,
    lng: -92.47296,
    city: "Excello",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 897,
    density: 8.1,
    county_fips: 29121,
    county_name: "Macon",
    county_weights: {
      29121: 100,
    },
    county_names_all: "Macon",
    county_fips_all: 29121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65248,
    lat: 39.13952,
    lng: -92.65894,
    city: "Fayette",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4724,
    density: 10.6,
    county_fips: 29089,
    county_name: "Howard",
    county_weights: {
      29089: 100,
    },
    county_names_all: "Howard",
    county_fips_all: 29089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65250,
    lat: 39.03524,
    lng: -92.83991,
    city: "Franklin",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 473,
    density: 3.5,
    county_fips: 29089,
    county_name: "Howard",
    county_weights: {
      29089: 100,
    },
    county_names_all: "Howard",
    county_fips_all: 29089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65251,
    lat: 38.84902,
    lng: -91.97911,
    city: "Fulton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22347,
    density: 40.5,
    county_fips: 29027,
    county_name: "Callaway",
    county_weights: {
      29027: 100,
    },
    county_names_all: "Callaway",
    county_fips_all: 29027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65254,
    lat: 39.21228,
    lng: -92.85351,
    city: "Glasgow",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1865,
    density: 6.9,
    county_fips: 29089,
    county_name: "Howard",
    county_weights: {
      29041: 32.74,
      29089: 67.26,
    },
    county_names_all: "Howard|Chariton",
    county_fips_all: "29089|29041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65255,
    lat: 39.09632,
    lng: -92.23463,
    city: "Hallsville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4067,
    density: 27.8,
    county_fips: 29019,
    county_name: "Boone",
    county_weights: {
      29019: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 29019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65256,
    lat: 39.12713,
    lng: -92.45568,
    city: "Harrisburg",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1452,
    density: 10.1,
    county_fips: 29019,
    county_name: "Boone",
    county_weights: {
      29019: 76.87,
      29089: 23.13,
    },
    county_names_all: "Boone|Howard",
    county_fips_all: "29019|29089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65257,
    lat: 39.28404,
    lng: -92.53112,
    city: "Higbee",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1756,
    density: 7.9,
    county_fips: 29175,
    county_name: "Randolph",
    county_weights: {
      29089: 39.53,
      29175: 60.47,
    },
    county_names_all: "Randolph|Howard",
    county_fips_all: "29175|29089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65258,
    lat: 39.52339,
    lng: -92.13706,
    city: "Holliday",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 553,
    density: 4.2,
    county_fips: 29137,
    county_name: "Monroe",
    county_weights: {
      29137: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 29137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65259,
    lat: 39.47122,
    lng: -92.56536,
    city: "Huntsville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3020,
    density: 11.2,
    county_fips: 29175,
    county_name: "Randolph",
    county_weights: {
      29175: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 29175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65260,
    lat: 39.58806,
    lng: -92.40227,
    city: "Jacksonville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 386,
    density: 3,
    county_fips: 29175,
    county_name: "Randolph",
    county_weights: {
      29121: 19.14,
      29137: 11.89,
      29175: 68.97,
    },
    county_names_all: "Randolph|Macon|Monroe",
    county_fips_all: "29175|29121|29137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65261,
    lat: 39.47542,
    lng: -92.92388,
    city: "Keytesville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1104,
    density: 4.3,
    county_fips: 29041,
    county_name: "Chariton",
    county_weights: {
      29041: 100,
    },
    county_names_all: "Chariton",
    county_fips_all: 29041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65262,
    lat: 38.9548,
    lng: -91.95285,
    city: "Kingdom City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 768,
    density: 6.4,
    county_fips: 29027,
    county_name: "Callaway",
    county_weights: {
      29027: 100,
    },
    county_names_all: "Callaway",
    county_fips_all: 29027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65263,
    lat: 39.45244,
    lng: -92.22062,
    city: "Madison",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1471,
    density: 4.5,
    county_fips: 29137,
    county_name: "Monroe",
    county_weights: {
      29137: 97.09,
      29175: 2.91,
    },
    county_names_all: "Monroe|Randolph",
    county_fips_all: "29137|29175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65264,
    lat: 39.08852,
    lng: -91.69544,
    city: "Martinsburg",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 954,
    density: 6,
    county_fips: 29007,
    county_name: "Audrain",
    county_weights: {
      29007: 71.2,
      29027: 24.34,
      29139: 4.46,
    },
    county_names_all: "Audrain|Callaway|Montgomery",
    county_fips_all: "29007|29027|29139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65265,
    lat: 39.20531,
    lng: -91.88728,
    city: "Mexico",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14961,
    density: 25.8,
    county_fips: 29007,
    county_name: "Audrain",
    county_weights: {
      29007: 94.34,
      29137: 5.66,
    },
    county_names_all: "Audrain|Monroe",
    county_fips_all: "29007|29137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65270,
    lat: 39.41552,
    lng: -92.39917,
    city: "Moberly",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16914,
    density: 57.7,
    county_fips: 29175,
    county_name: "Randolph",
    county_weights: {
      29137: 5.93,
      29175: 94.07,
    },
    county_names_all: "Randolph|Monroe",
    county_fips_all: "29175|29137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65274,
    lat: 39.01342,
    lng: -92.68321,
    city: "New Franklin",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1904,
    density: 14.8,
    county_fips: 29089,
    county_name: "Howard",
    county_weights: {
      29089: 100,
    },
    county_names_all: "Howard",
    county_fips_all: 29089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65275,
    lat: 39.45935,
    lng: -91.99414,
    city: "Paris",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2545,
    density: 5.7,
    county_fips: 29137,
    county_name: "Monroe",
    county_weights: {
      29137: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 29137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65276,
    lat: 38.84581,
    lng: -92.95498,
    city: "Pilot Grove",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1605,
    density: 6.3,
    county_fips: 29053,
    county_name: "Cooper",
    county_weights: {
      29053: 100,
    },
    county_names_all: "Cooper",
    county_fips_all: 29053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65278,
    lat: 39.34217,
    lng: -92.41251,
    city: "Renick",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 80,
    density: 267.7,
    county_fips: 29175,
    county_name: "Randolph",
    county_weights: {
      29175: 100,
    },
    county_names_all: "Randolph",
    county_fips_all: 29175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65279,
    lat: 39.01284,
    lng: -92.52062,
    city: "Rocheport",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1621,
    density: 12,
    county_fips: 29019,
    county_name: "Boone",
    county_weights: {
      29019: 75.09,
      29089: 24.91,
    },
    county_names_all: "Boone|Howard",
    county_fips_all: "29019|29089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65280,
    lat: 39.23487,
    lng: -91.75048,
    city: "Rush Hill",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 338,
    density: 6.9,
    county_fips: 29007,
    county_name: "Audrain",
    county_weights: {
      29007: 100,
    },
    county_names_all: "Audrain",
    county_fips_all: 29007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65281,
    lat: 39.46431,
    lng: -92.79099,
    city: "Salisbury",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2729,
    density: 5.4,
    county_fips: 29041,
    county_name: "Chariton",
    county_weights: {
      29041: 98.4,
      29089: 1.3,
      29175: 0.3,
    },
    county_names_all: "Chariton|Howard|Randolph",
    county_fips_all: "29041|29089|29175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65282,
    lat: 39.38975,
    lng: -91.83302,
    city: "Santa Fe",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 114,
    density: 4,
    county_fips: 29137,
    county_name: "Monroe",
    county_weights: {
      29137: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 29137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65283,
    lat: 39.50811,
    lng: -91.83449,
    city: "Stoutsville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 654,
    density: 4.6,
    county_fips: 29137,
    county_name: "Monroe",
    county_weights: {
      29137: 100,
    },
    county_names_all: "Monroe",
    county_fips_all: 29137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65284,
    lat: 39.19658,
    lng: -92.30361,
    city: "Sturgeon",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2237,
    density: 14.3,
    county_fips: 29019,
    county_name: "Boone",
    county_weights: {
      29007: 14.33,
      29019: 85.67,
    },
    county_names_all: "Boone|Audrain",
    county_fips_all: "29019|29007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65285,
    lat: 39.2067,
    lng: -92.02056,
    city: "Thompson",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 420,
    density: 2.9,
    county_fips: 29007,
    county_name: "Audrain",
    county_weights: {
      29007: 100,
    },
    county_names_all: "Audrain",
    county_fips_all: 29007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65286,
    lat: 39.50616,
    lng: -93.22059,
    city: "Triplett",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 130,
    density: 1.2,
    county_fips: 29041,
    county_name: "Chariton",
    county_weights: {
      29041: 100,
    },
    county_names_all: "Chariton",
    county_fips_all: 29041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65287,
    lat: 38.88443,
    lng: -92.51953,
    city: "Wooldridge",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 284,
    density: 5.1,
    county_fips: 29135,
    county_name: "Moniteau",
    county_weights: {
      29053: 45.11,
      29135: 54.89,
    },
    county_names_all: "Moniteau|Cooper",
    county_fips_all: "29135|29053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65301,
    lat: 38.69922,
    lng: -93.22104,
    city: "Sedalia",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34335,
    density: 59.3,
    county_fips: 29159,
    county_name: "Pettis",
    county_weights: {
      29053: 0.66,
      29159: 99.34,
    },
    county_names_all: "Pettis|Cooper",
    county_fips_all: "29159|29053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65305,
    lat: 38.72944,
    lng: -93.55446,
    city: "Whiteman Air Force Base",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4052,
    density: 273.1,
    county_fips: 29101,
    county_name: "Johnson",
    county_weights: {
      29101: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 29101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65320,
    lat: 39.06606,
    lng: -92.94415,
    city: "Arrow Rock",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37,
    density: 26.8,
    county_fips: 29195,
    county_name: "Saline",
    county_weights: {
      29195: 100,
    },
    county_names_all: "Saline",
    county_fips_all: 29195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65321,
    lat: 39.08604,
    lng: -93.4526,
    city: "Blackburn",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 357,
    density: 3.6,
    county_fips: 29195,
    county_name: "Saline",
    county_weights: {
      29107: 13.74,
      29195: 86.26,
    },
    county_names_all: "Saline|Lafayette",
    county_fips_all: "29195|29107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65322,
    lat: 38.9729,
    lng: -92.95535,
    city: "Blackwater",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 632,
    density: 4,
    county_fips: 29053,
    county_name: "Cooper",
    county_weights: {
      29053: 100,
    },
    county_names_all: "Cooper",
    county_fips_all: 29053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65323,
    lat: 38.45289,
    lng: -93.6212,
    city: "Calhoun",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 864,
    density: 6.5,
    county_fips: 29083,
    county_name: "Henry",
    county_weights: {
      29083: 100,
    },
    county_names_all: "Henry",
    county_fips_all: 29083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65324,
    lat: 38.11104,
    lng: -92.99997,
    city: "Climax Springs",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1130,
    density: 6.9,
    county_fips: 29029,
    county_name: "Camden",
    county_weights: {
      29029: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 29029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65325,
    lat: 38.43239,
    lng: -93.18535,
    city: "Cole Camp",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3308,
    density: 8.9,
    county_fips: 29015,
    county_name: "Benton",
    county_weights: {
      29015: 98.64,
      29141: 0.34,
      29159: 1.02,
    },
    county_names_all: "Benton|Pettis|Morgan",
    county_fips_all: "29015|29159|29141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65326,
    lat: 38.16271,
    lng: -93.1458,
    city: "Edwards",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1665,
    density: 4.3,
    county_fips: 29015,
    county_name: "Benton",
    county_weights: {
      29015: 81.2,
      29029: 16.83,
      29085: 1.97,
    },
    county_names_all: "Benton|Camden|Hickory",
    county_fips_all: "29015|29029|29085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65327,
    lat: 38.97525,
    lng: -93.48909,
    city: "Emma",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 205,
    density: 70.4,
    county_fips: 29195,
    county_name: "Saline",
    county_weights: {
      29107: 25.55,
      29195: 74.45,
    },
    county_names_all: "Saline|Lafayette",
    county_fips_all: "29195|29107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65329,
    lat: 38.60937,
    lng: -92.96132,
    city: "Florence",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 358,
    density: 3.7,
    county_fips: 29141,
    county_name: "Morgan",
    county_weights: {
      29141: 100,
    },
    county_names_all: "Morgan",
    county_fips_all: 29141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65330,
    lat: 39.22096,
    lng: -92.94945,
    city: "Gilliam",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 494,
    density: 3.7,
    county_fips: 29195,
    county_name: "Saline",
    county_weights: {
      29195: 100,
    },
    county_names_all: "Saline",
    county_fips_all: 29195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65332,
    lat: 38.61973,
    lng: -93.41324,
    city: "Green Ridge",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1681,
    density: 7.8,
    county_fips: 29159,
    county_name: "Pettis",
    county_weights: {
      29101: 2.93,
      29159: 97.07,
    },
    county_names_all: "Pettis|Johnson",
    county_fips_all: "29159|29101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65333,
    lat: 38.90687,
    lng: -93.30724,
    city: "Houstonia",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 543,
    density: 3.2,
    county_fips: 29159,
    county_name: "Pettis",
    county_weights: {
      29159: 85.06,
      29195: 14.94,
    },
    county_names_all: "Pettis|Saline",
    county_fips_all: "29159|29195",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65334,
    lat: 38.8348,
    lng: -93.24558,
    city: "Hughesville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1082,
    density: 6.4,
    county_fips: 29159,
    county_name: "Pettis",
    county_weights: {
      29159: 100,
    },
    county_names_all: "Pettis",
    county_fips_all: 29159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65335,
    lat: 38.51338,
    lng: -93.32667,
    city: "Ionia",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 135,
    density: 3,
    county_fips: 29159,
    county_name: "Pettis",
    county_weights: {
      29015: 45.26,
      29159: 54.74,
    },
    county_names_all: "Pettis|Benton",
    county_fips_all: "29159|29015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65336,
    lat: 38.78169,
    lng: -93.56241,
    city: "Knob Noster",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6280,
    density: 20.8,
    county_fips: 29101,
    county_name: "Johnson",
    county_weights: {
      29101: 93.38,
      29159: 6.62,
    },
    county_names_all: "Johnson|Pettis",
    county_fips_all: "29101|29159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65337,
    lat: 38.79202,
    lng: -93.42573,
    city: "La Monte",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1787,
    density: 7.9,
    county_fips: 29159,
    county_name: "Pettis",
    county_weights: {
      29159: 100,
    },
    county_names_all: "Pettis",
    county_fips_all: 29159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65338,
    lat: 38.36227,
    lng: -93.29523,
    city: "Lincoln",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3099,
    density: 10.1,
    county_fips: 29015,
    county_name: "Benton",
    county_weights: {
      29015: 100,
    },
    county_names_all: "Benton",
    county_fips_all: 29015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65339,
    lat: 39.19407,
    lng: -93.37671,
    city: "Malta Bend",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 382,
    density: 1.6,
    county_fips: 29195,
    county_name: "Saline",
    county_weights: {
      29195: 100,
    },
    county_names_all: "Saline",
    county_fips_all: 29195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65340,
    lat: 39.09149,
    lng: -93.18041,
    city: "Marshall",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15596,
    density: 23.7,
    county_fips: 29195,
    county_name: "Saline",
    county_weights: {
      29159: 3.85,
      29195: 96.15,
    },
    county_names_all: "Saline|Pettis",
    county_fips_all: "29195|29159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65344,
    lat: 39.31174,
    lng: -93.1976,
    city: "Miami",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 177,
    density: 0.9,
    county_fips: 29195,
    county_name: "Saline",
    county_weights: {
      29195: 100,
    },
    county_names_all: "Saline",
    county_fips_all: 29195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65345,
    lat: 38.54111,
    lng: -93.1254,
    city: "Mora",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 349,
    density: 3.3,
    county_fips: 29015,
    county_name: "Benton",
    county_weights: {
      29015: 42.21,
      29141: 18.02,
      29159: 39.77,
    },
    county_names_all: "Benton|Pettis|Morgan",
    county_fips_all: "29015|29159|29141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65347,
    lat: 38.98453,
    lng: -93.0495,
    city: "Nelson",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 932,
    density: 4.6,
    county_fips: 29195,
    county_name: "Saline",
    county_weights: {
      29053: 5.5,
      29159: 22.97,
      29195: 71.53,
    },
    county_names_all: "Saline|Pettis|Cooper",
    county_fips_all: "29195|29159|29053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65348,
    lat: 38.70963,
    lng: -92.98344,
    city: "Otterville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1346,
    density: 7.3,
    county_fips: 29053,
    county_name: "Cooper",
    county_weights: {
      29053: 70.37,
      29141: 26.62,
      29159: 3.01,
    },
    county_names_all: "Cooper|Morgan|Pettis",
    county_fips_all: "29053|29141|29159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65349,
    lat: 39.22863,
    lng: -93.05581,
    city: "Slater",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2568,
    density: 10.2,
    county_fips: 29195,
    county_name: "Saline",
    county_weights: {
      29195: 100,
    },
    county_names_all: "Saline",
    county_fips_all: 29195,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65350,
    lat: 38.65557,
    lng: -93.10038,
    city: "Smithton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2014,
    density: 12.2,
    county_fips: 29159,
    county_name: "Pettis",
    county_weights: {
      29053: 0.35,
      29141: 13.19,
      29159: 86.46,
    },
    county_names_all: "Pettis|Morgan|Cooper",
    county_fips_all: "29159|29141|29053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65351,
    lat: 38.98445,
    lng: -93.38628,
    city: "Sweet Springs",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2406,
    density: 8.7,
    county_fips: 29195,
    county_name: "Saline",
    county_weights: {
      29101: 1.49,
      29159: 16,
      29195: 82.51,
    },
    county_names_all: "Saline|Pettis|Johnson",
    county_fips_all: "29195|29159|29101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65354,
    lat: 38.64841,
    lng: -92.88786,
    city: "Syracuse",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1196,
    density: 18.7,
    county_fips: 29141,
    county_name: "Morgan",
    county_weights: {
      29053: 14.11,
      29141: 85.89,
    },
    county_names_all: "Morgan|Cooper",
    county_fips_all: "29141|29053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65355,
    lat: 38.22137,
    lng: -93.37144,
    city: "Warsaw",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10707,
    density: 19.1,
    county_fips: 29015,
    county_name: "Benton",
    county_weights: {
      29015: 98.48,
      29085: 0.61,
      29185: 0.91,
    },
    county_names_all: "Benton|St. Clair|Hickory",
    county_fips_all: "29015|29185|29085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65360,
    lat: 38.51989,
    lng: -93.51334,
    city: "Windsor",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4932,
    density: 12.1,
    county_fips: 29083,
    county_name: "Henry",
    county_weights: {
      29015: 25.42,
      29083: 32.44,
      29101: 20.86,
      29159: 21.28,
    },
    county_names_all: "Henry|Benton|Pettis|Johnson",
    county_fips_all: "29083|29015|29159|29101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65401,
    lat: 37.90691,
    lng: -91.76374,
    city: "Rolla",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33502,
    density: 50,
    county_fips: 29161,
    county_name: "Phelps",
    county_weights: {
      29065: 12.72,
      29125: 4.27,
      29161: 83.01,
    },
    county_names_all: "Phelps|Dent|Maries",
    county_fips_all: "29161|29065|29125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65409,
    lat: 37.95103,
    lng: -91.77948,
    city: "Rolla",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 29161,
    county_name: "Phelps",
    county_weights: {
      29161: 100,
    },
    county_names_all: "Phelps",
    county_fips_all: 29161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65436,
    lat: 37.62239,
    lng: -91.9726,
    city: "Beulah",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18,
    density: 0.3,
    county_fips: 29161,
    county_name: "Phelps",
    county_weights: {
      29161: 95.23,
      29215: 4.77,
    },
    county_names_all: "Phelps|Texas",
    county_fips_all: "29161|29215",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65438,
    lat: 36.9375,
    lng: -91.50739,
    city: "Birch Tree",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2681,
    density: 3.5,
    county_fips: 29203,
    county_name: "Shannon",
    county_weights: {
      29149: 32.81,
      29203: 67.19,
    },
    county_names_all: "Shannon|Oregon",
    county_fips_all: "29203|29149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65439,
    lat: 37.65718,
    lng: -91.09535,
    city: "Bixby",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 140,
    density: 1.6,
    county_fips: 29093,
    county_name: "Iron",
    county_weights: {
      29093: 100,
    },
    county_names_all: "Iron",
    county_fips_all: 29093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65440,
    lat: 37.60388,
    lng: -91.18539,
    city: "Boss",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 584,
    density: 2.1,
    county_fips: 29065,
    county_name: "Dent",
    county_weights: {
      29065: 54.45,
      29093: 5.35,
      29179: 40.2,
    },
    county_names_all: "Dent|Reynolds|Iron",
    county_fips_all: "29065|29179|29093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65441,
    lat: 38.09394,
    lng: -91.15842,
    city: "Bourbon",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5817,
    density: 13.2,
    county_fips: 29055,
    county_name: "Crawford",
    county_weights: {
      29055: 72.64,
      29071: 1.36,
      29221: 26,
    },
    county_names_all: "Crawford|Washington|Franklin",
    county_fips_all: "29055|29221|29071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65443,
    lat: 38.13089,
    lng: -92.0918,
    city: "Brinktown",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 95,
    density: 3.4,
    county_fips: 29125,
    county_name: "Maries",
    county_weights: {
      29125: 100,
    },
    county_names_all: "Maries",
    county_fips_all: 29125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65444,
    lat: 37.37772,
    lng: -92.06308,
    city: "Bucyrus",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 907,
    density: 4.2,
    county_fips: 29215,
    county_name: "Texas",
    county_weights: {
      29215: 100,
    },
    county_names_all: "Texas",
    county_fips_all: 29215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65446,
    lat: 37.80902,
    lng: -91.26999,
    city: "Cherryville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 556,
    density: 6,
    county_fips: 29055,
    county_name: "Crawford",
    county_weights: {
      29055: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 29055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65449,
    lat: 37.84745,
    lng: -91.48722,
    city: "Cook Sta",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 230,
    density: 2,
    county_fips: 29055,
    county_name: "Crawford",
    county_weights: {
      29055: 91.52,
      29161: 8.48,
    },
    county_names_all: "Crawford|Phelps",
    county_fips_all: "29055|29161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65452,
    lat: 37.96271,
    lng: -92.26702,
    city: "Crocker",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2527,
    density: 10.7,
    county_fips: 29169,
    county_name: "Pulaski",
    county_weights: {
      29131: 6.75,
      29169: 93.25,
    },
    county_names_all: "Pulaski|Miller",
    county_fips_all: "29169|29131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65453,
    lat: 38.10706,
    lng: -91.42509,
    city: "Cuba",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9220,
    density: 24.9,
    county_fips: 29055,
    county_name: "Crawford",
    county_weights: {
      29055: 88.57,
      29073: 11.43,
    },
    county_names_all: "Crawford|Gasconade",
    county_fips_all: "29055|29073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65456,
    lat: 37.78048,
    lng: -91.20267,
    city: "Davisville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 512,
    density: 3.2,
    county_fips: 29055,
    county_name: "Crawford",
    county_weights: {
      29055: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 29055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65457,
    lat: 37.82647,
    lng: -92.05047,
    city: "Devils Elbow",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 243,
    density: 7.3,
    county_fips: 29169,
    county_name: "Pulaski",
    county_weights: {
      29169: 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: 29169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65459,
    lat: 38.02919,
    lng: -92.08337,
    city: "Dixon",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7310,
    density: 12.2,
    county_fips: 29125,
    county_name: "Maries",
    county_weights: {
      29125: 53.27,
      29131: 5.36,
      29161: 5.57,
      29169: 35.8,
    },
    county_names_all: "Maries|Pulaski|Phelps|Miller",
    county_fips_all: "29125|29169|29161|29131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65461,
    lat: 37.68406,
    lng: -92.02379,
    city: "Duke",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 111,
    density: 1.6,
    county_fips: 29169,
    county_name: "Pulaski",
    county_weights: {
      29161: 48.68,
      29169: 51.32,
    },
    county_names_all: "Pulaski|Phelps",
    county_fips_all: "29169|29161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65462,
    lat: 37.68654,
    lng: -91.86417,
    city: "Edgar Springs",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1273,
    density: 5.1,
    county_fips: 29161,
    county_name: "Phelps",
    county_weights: {
      29065: 15.22,
      29161: 84.78,
    },
    county_names_all: "Phelps|Dent",
    county_fips_all: "29161|29065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65463,
    lat: 37.84536,
    lng: -92.7811,
    city: "Eldridge",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1383,
    density: 8.1,
    county_fips: 29105,
    county_name: "Laclede",
    county_weights: {
      29029: 3.84,
      29059: 3.39,
      29105: 92.77,
    },
    county_names_all: "Laclede|Camden|Dallas",
    county_fips_all: "29105|29029|29059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65464,
    lat: 37.18353,
    lng: -91.89236,
    city: "Elk Creek",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 624,
    density: 4.3,
    county_fips: 29215,
    county_name: "Texas",
    county_weights: {
      29215: 100,
    },
    county_names_all: "Texas",
    county_fips_all: 29215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65466,
    lat: 37.2113,
    lng: -91.38645,
    city: "Eminence",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2031,
    density: 4.5,
    county_fips: 29203,
    county_name: "Shannon",
    county_weights: {
      29203: 100,
    },
    county_names_all: "Shannon",
    county_fips_all: 29203,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65468,
    lat: 37.25434,
    lng: -91.79824,
    city: "Eunice",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 29215,
    county_name: "Texas",
    county_weights: {
      29215: 100,
    },
    county_names_all: "Texas",
    county_fips_all: 29215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65470,
    lat: 37.54872,
    lng: -92.40287,
    city: "Falcon",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1250,
    density: 4.5,
    county_fips: 29105,
    county_name: "Laclede",
    county_weights: {
      29105: 88.01,
      29229: 11.99,
    },
    county_names_all: "Laclede|Wright",
    county_fips_all: "29105|29229",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65473,
    lat: 37.71215,
    lng: -92.14811,
    city: "Fort Leonard Wood",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14759,
    density: 54,
    county_fips: 29169,
    county_name: "Pulaski",
    county_weights: {
      29169: 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: 29169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65479,
    lat: 37.3368,
    lng: -91.63382,
    city: "Hartshorn",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 143,
    density: 0.6,
    county_fips: 29203,
    county_name: "Shannon",
    county_weights: {
      29203: 60.54,
      29215: 39.46,
    },
    county_names_all: "Shannon|Texas",
    county_fips_all: "29203|29215",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65483,
    lat: 37.30463,
    lng: -91.94911,
    city: "Houston",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4534,
    density: 16.4,
    county_fips: 29215,
    county_name: "Texas",
    county_weights: {
      29215: 100,
    },
    county_names_all: "Texas",
    county_fips_all: 29215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65484,
    lat: 37.36348,
    lng: -92.22052,
    city: "Huggins",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68,
    density: 0.9,
    county_fips: 29215,
    county_name: "Texas",
    county_weights: {
      29215: 100,
    },
    county_names_all: "Texas",
    county_fips_all: 29215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65486,
    lat: 38.10007,
    lng: -92.3107,
    city: "Iberia",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3669,
    density: 11.5,
    county_fips: 29131,
    county_name: "Miller",
    county_weights: {
      29131: 100,
    },
    county_names_all: "Miller",
    county_fips_all: 29131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65501,
    lat: 37.47319,
    lng: -91.5549,
    city: "Jadwin",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 127,
    density: 2,
    county_fips: 29065,
    county_name: "Dent",
    county_weights: {
      29065: 100,
    },
    county_names_all: "Dent",
    county_fips_all: 29065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65529,
    lat: 37.92912,
    lng: -91.98926,
    city: "Jerome",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 322,
    density: 90.3,
    county_fips: 29161,
    county_name: "Phelps",
    county_weights: {
      29161: 100,
    },
    county_names_all: "Phelps",
    county_fips_all: 29161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65534,
    lat: 37.70236,
    lng: -92.27656,
    city: "Laquey",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 680,
    density: 6.9,
    county_fips: 29169,
    county_name: "Pulaski",
    county_weights: {
      29105: 21.06,
      29169: 78.94,
    },
    county_names_all: "Pulaski|Laclede",
    county_fips_all: "29169|29105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65535,
    lat: 38.07194,
    lng: -91.2752,
    city: "Leasburg",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1463,
    density: 12.5,
    county_fips: 29055,
    county_name: "Crawford",
    county_weights: {
      29055: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 29055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65536,
    lat: 37.68942,
    lng: -92.64974,
    city: "Lebanon",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29288,
    density: 28.1,
    county_fips: 29105,
    county_name: "Laclede",
    county_weights: {
      29029: 1.48,
      29059: 4.66,
      29105: 93.86,
    },
    county_names_all: "Laclede|Dallas|Camden",
    county_fips_all: "29105|29059|29029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65541,
    lat: 37.64401,
    lng: -91.75624,
    city: "Lenox",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 293,
    density: 4.7,
    county_fips: 29065,
    county_name: "Dent",
    county_weights: {
      29065: 100,
    },
    county_names_all: "Dent",
    county_fips_all: 29065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65542,
    lat: 37.50497,
    lng: -91.88432,
    city: "Licking",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6587,
    density: 11.7,
    county_fips: 29215,
    county_name: "Texas",
    county_weights: {
      29065: 7.65,
      29161: 0.95,
      29215: 91.4,
    },
    county_names_all: "Texas|Dent|Phelps",
    county_fips_all: "29215|29065|29161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65543,
    lat: 37.47172,
    lng: -92.3045,
    city: "Lynchburg",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 273,
    density: 1.8,
    county_fips: 29229,
    county_name: "Wright",
    county_weights: {
      29105: 46.65,
      29229: 53.35,
    },
    county_names_all: "Wright|Laclede",
    county_fips_all: "29229|29105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65548,
    lat: 37.00545,
    lng: -91.71131,
    city: "Mountain View",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6268,
    density: 12.9,
    county_fips: 29091,
    county_name: "Howell",
    county_weights: {
      29091: 60.55,
      29203: 31.69,
      29215: 7.76,
    },
    county_names_all: "Howell|Shannon|Texas",
    county_fips_all: "29091|29203|29215",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65550,
    lat: 37.84425,
    lng: -91.9433,
    city: "Newburg",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2624,
    density: 5.8,
    county_fips: 29161,
    county_name: "Phelps",
    county_weights: {
      29161: 92.19,
      29169: 7.81,
    },
    county_names_all: "Phelps|Pulaski",
    county_fips_all: "29161|29169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65552,
    lat: 37.53842,
    lng: -92.16701,
    city: "Plato",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2268,
    density: 6.1,
    county_fips: 29215,
    county_name: "Texas",
    county_weights: {
      29105: 10.13,
      29169: 12.18,
      29215: 77.69,
    },
    county_names_all: "Texas|Pulaski|Laclede",
    county_fips_all: "29215|29169|29105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65555,
    lat: 37.35906,
    lng: -91.77723,
    city: "Raymondville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1319,
    density: 6.9,
    county_fips: 29215,
    county_name: "Texas",
    county_weights: {
      29215: 100,
    },
    county_names_all: "Texas",
    county_fips_all: 29215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65556,
    lat: 37.83582,
    lng: -92.40541,
    city: "Richland",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5833,
    density: 10.1,
    county_fips: 29169,
    county_name: "Pulaski",
    county_weights: {
      29029: 29.05,
      29105: 26.75,
      29169: 44.2,
    },
    county_names_all: "Pulaski|Camden|Laclede",
    county_fips_all: "29169|29029|29105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65557,
    lat: 37.51778,
    lng: -92.14024,
    city: "Roby",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 97,
    density: 4.5,
    county_fips: 29215,
    county_name: "Texas",
    county_weights: {
      29215: 100,
    },
    county_names_all: "Texas",
    county_fips_all: 29215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65559,
    lat: 38.0181,
    lng: -91.60664,
    city: "Saint James",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8557,
    density: 17.4,
    county_fips: 29161,
    county_name: "Phelps",
    county_weights: {
      29055: 2.78,
      29073: 0.58,
      29125: 17.84,
      29161: 78.8,
    },
    county_names_all: "Phelps|Maries|Crawford|Gasconade",
    county_fips_all: "29161|29125|29055|29073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65560,
    lat: 37.59609,
    lng: -91.49943,
    city: "Salem",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14576,
    density: 8.5,
    county_fips: 29065,
    county_name: "Dent",
    county_weights: {
      29055: 5.95,
      29065: 79.16,
      29161: 1.76,
      29203: 12.33,
      29215: 0.8,
    },
    county_names_all: "Dent|Shannon|Crawford|Phelps|Texas",
    county_fips_all: "29065|29203|29055|29161|29215",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65564,
    lat: 37.23476,
    lng: -91.95781,
    city: "Solo",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 107,
    density: 2.6,
    county_fips: 29215,
    county_name: "Texas",
    county_weights: {
      29215: 100,
    },
    county_names_all: "Texas",
    county_fips_all: 29215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65565,
    lat: 37.90573,
    lng: -91.23841,
    city: "Steelville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4728,
    density: 6.6,
    county_fips: 29055,
    county_name: "Crawford",
    county_weights: {
      29055: 81.51,
      29093: 7.81,
      29221: 10.68,
    },
    county_names_all: "Crawford|Washington|Iron",
    county_fips_all: "29055|29221|29093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65566,
    lat: 37.76618,
    lng: -91.14689,
    city: "Viburnum",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 835,
    density: 28.3,
    county_fips: 29055,
    county_name: "Crawford",
    county_weights: {
      29055: 64.38,
      29093: 35.62,
    },
    county_names_all: "Crawford|Iron",
    county_fips_all: "29055|29093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65567,
    lat: 37.85594,
    lng: -92.53699,
    city: "Stoutland",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1774,
    density: 10.7,
    county_fips: 29029,
    county_name: "Camden",
    county_weights: {
      29029: 79.47,
      29105: 20.53,
    },
    county_names_all: "Camden|Laclede",
    county_fips_all: "29029|29105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65570,
    lat: 37.45702,
    lng: -92.10115,
    city: "Success",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 673,
    density: 9.2,
    county_fips: 29215,
    county_name: "Texas",
    county_weights: {
      29215: 100,
    },
    county_names_all: "Texas",
    county_fips_all: 29215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65571,
    lat: 37.18501,
    lng: -91.64546,
    city: "Summersville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1864,
    density: 3.9,
    county_fips: 29215,
    county_name: "Texas",
    county_weights: {
      29203: 48.8,
      29215: 51.2,
    },
    county_names_all: "Texas|Shannon",
    county_fips_all: "29215|29203",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65580,
    lat: 38.11656,
    lng: -91.78617,
    city: "Vichy",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 465,
    density: 3.1,
    county_fips: 29125,
    county_name: "Maries",
    county_weights: {
      29125: 100,
    },
    county_names_all: "Maries",
    county_fips_all: 29125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65582,
    lat: 38.19177,
    lng: -91.92463,
    city: "Vienna",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2458,
    density: 7.7,
    county_fips: 29125,
    county_name: "Maries",
    county_weights: {
      29125: 97.39,
      29151: 2.61,
    },
    county_names_all: "Maries|Osage",
    county_fips_all: "29125|29151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65583,
    lat: 37.82171,
    lng: -92.2541,
    city: "Waynesville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12470,
    density: 76.1,
    county_fips: 29169,
    county_name: "Pulaski",
    county_weights: {
      29169: 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: 29169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65584,
    lat: 37.82901,
    lng: -92.13086,
    city: "Saint Robert",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11986,
    density: 190.4,
    county_fips: 29169,
    county_name: "Pulaski",
    county_weights: {
      29169: 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: 29169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65586,
    lat: 37.86483,
    lng: -91.43294,
    city: "Wesco",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 81,
    density: 9.2,
    county_fips: 29055,
    county_name: "Crawford",
    county_weights: {
      29055: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 29055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65588,
    lat: 36.96196,
    lng: -91.29987,
    city: "Winona",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2219,
    density: 3.7,
    county_fips: 29203,
    county_name: "Shannon",
    county_weights: {
      29149: 32.34,
      29203: 67.66,
    },
    county_names_all: "Shannon|Oregon",
    county_fips_all: "29203|29149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65589,
    lat: 37.23729,
    lng: -91.82747,
    city: "Yukon",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 76,
    density: 2.8,
    county_fips: 29215,
    county_name: "Texas",
    county_weights: {
      29215: 100,
    },
    county_names_all: "Texas",
    county_fips_all: 29215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65590,
    lat: 37.61687,
    lng: -92.95008,
    city: "Long Lane",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 971,
    density: 4.7,
    county_fips: 29059,
    county_name: "Dallas",
    county_weights: {
      29059: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 29059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65591,
    lat: 37.97941,
    lng: -92.59076,
    city: "Montreal",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1619,
    density: 10.3,
    county_fips: 29029,
    county_name: "Camden",
    county_weights: {
      29029: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 29029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65601,
    lat: 37.53155,
    lng: -93.5869,
    city: "Aldrich",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 470,
    density: 3.4,
    county_fips: 29167,
    county_name: "Polk",
    county_weights: {
      29039: 0.68,
      29057: 34.68,
      29167: 64.64,
    },
    county_names_all: "Polk|Dade|Cedar",
    county_fips_all: "29167|29057|29039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65603,
    lat: 37.54574,
    lng: -93.86072,
    city: "Arcola",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 143,
    density: 2.8,
    county_fips: 29057,
    county_name: "Dade",
    county_weights: {
      29057: 100,
    },
    county_names_all: "Dade",
    county_fips_all: 29057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65604,
    lat: 37.27348,
    lng: -93.60367,
    city: "Ash Grove",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3223,
    density: 14.3,
    county_fips: 29077,
    county_name: "Greene",
    county_weights: {
      29057: 7.79,
      29077: 59.16,
      29109: 33.05,
    },
    county_names_all: "Greene|Lawrence|Dade",
    county_fips_all: "29077|29109|29057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65605,
    lat: 36.88408,
    lng: -93.69132,
    city: "Aurora",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12325,
    density: 29.3,
    county_fips: 29009,
    county_name: "Barry",
    county_weights: {
      29009: 56.64,
      29109: 42.17,
      29209: 1.19,
    },
    county_names_all: "Barry|Lawrence|Stone",
    county_fips_all: "29009|29109|29209",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65606,
    lat: 36.69634,
    lng: -91.3586,
    city: "Alton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2962,
    density: 5.4,
    county_fips: 29149,
    county_name: "Oregon",
    county_weights: {
      29149: 100,
    },
    county_names_all: "Oregon",
    county_fips_all: 29149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65608,
    lat: 36.90456,
    lng: -92.66662,
    city: "Ava",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9334,
    density: 8.9,
    county_fips: 29067,
    county_name: "Douglas",
    county_weights: {
      29067: 92.97,
      29153: 3.43,
      29213: 3.6,
    },
    county_names_all: "Douglas|Taney|Ozark",
    county_fips_all: "29067|29213|29153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65609,
    lat: 36.52593,
    lng: -92.1609,
    city: "Bakersfield",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 865,
    density: 10.5,
    county_fips: 29153,
    county_name: "Ozark",
    county_weights: {
      29091: 28.42,
      29153: 71.58,
    },
    county_names_all: "Ozark|Howell",
    county_fips_all: "29153|29091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65610,
    lat: 37.03897,
    lng: -93.52986,
    city: "Billings",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4838,
    density: 21.6,
    county_fips: 29043,
    county_name: "Christian",
    county_weights: {
      29043: 61.19,
      29077: 13.95,
      29109: 0.89,
      29209: 23.97,
    },
    county_names_all: "Christian|Stone|Greene|Lawrence",
    county_fips_all: "29043|29209|29077|29109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65611,
    lat: 36.54339,
    lng: -93.36127,
    city: "Blue Eye",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2493,
    density: 33.7,
    county_fips: 29209,
    county_name: "Stone",
    county_weights: {
      29209: 99.32,
      29213: 0.68,
    },
    county_names_all: "Stone|Taney",
    county_fips_all: "29209|29213",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65612,
    lat: 37.21897,
    lng: -93.54694,
    city: "Bois D Arc",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1775,
    density: 19.1,
    county_fips: 29077,
    county_name: "Greene",
    county_weights: {
      29077: 89.92,
      29109: 10.08,
    },
    county_names_all: "Greene|Lawrence",
    county_fips_all: "29077|29109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65613,
    lat: 37.63557,
    lng: -93.39205,
    city: "Bolivar",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18310,
    density: 38.2,
    county_fips: 29167,
    county_name: "Polk",
    county_weights: {
      29167: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 29167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65614,
    lat: 36.73739,
    lng: -92.88684,
    city: "Bradleyville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 492,
    density: 1.8,
    county_fips: 29213,
    county_name: "Taney",
    county_weights: {
      29043: 7.19,
      29213: 92.81,
    },
    county_names_all: "Taney|Christian",
    county_fips_all: "29213|29043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65616,
    lat: 36.67133,
    lng: -93.24887,
    city: "Branson",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27423,
    density: 138.5,
    county_fips: 29213,
    county_name: "Taney",
    county_weights: {
      29209: 12.28,
      29213: 87.72,
    },
    county_names_all: "Taney|Stone",
    county_fips_all: "29213|29209",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65617,
    lat: 37.4376,
    lng: -93.34063,
    city: "Brighton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1571,
    density: 18.7,
    county_fips: 29167,
    county_name: "Polk",
    county_weights: {
      29077: 36.2,
      29167: 63.8,
    },
    county_names_all: "Polk|Greene",
    county_fips_all: "29167|29077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65618,
    lat: 36.75157,
    lng: -92.38641,
    city: "Brixey",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 133,
    density: 2.2,
    county_fips: 29153,
    county_name: "Ozark",
    county_weights: {
      29153: 100,
    },
    county_names_all: "Ozark",
    county_fips_all: 29153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65619,
    lat: 37.12312,
    lng: -93.38864,
    city: "Brookline",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7826,
    density: 157.2,
    county_fips: 29077,
    county_name: "Greene",
    county_weights: {
      29043: 17.45,
      29077: 82.55,
    },
    county_names_all: "Greene|Christian",
    county_fips_all: "29077|29043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65620,
    lat: 37.02045,
    lng: -92.95594,
    city: "Bruner",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 227,
    density: 5.7,
    county_fips: 29043,
    county_name: "Christian",
    county_weights: {
      29043: 100,
    },
    county_names_all: "Christian",
    county_fips_all: 29043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65622,
    lat: 37.6337,
    lng: -93.10775,
    city: "Buffalo",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8305,
    density: 21.2,
    county_fips: 29059,
    county_name: "Dallas",
    county_weights: {
      29059: 89.57,
      29167: 10.43,
    },
    county_names_all: "Dallas|Polk",
    county_fips_all: "29059|29167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65623,
    lat: 36.7489,
    lng: -93.90659,
    city: "Butterfield",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12,
    density: 234.1,
    county_fips: 29009,
    county_name: "Barry",
    county_weights: {
      29009: 100,
    },
    county_names_all: "Barry",
    county_fips_all: 29009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65624,
    lat: 36.73276,
    lng: -93.56241,
    city: "Cape Fair",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1456,
    density: 9.3,
    county_fips: 29209,
    county_name: "Stone",
    county_weights: {
      29009: 45.79,
      29209: 54.21,
    },
    county_names_all: "Stone|Barry",
    county_fips_all: "29209|29009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65625,
    lat: 36.67635,
    lng: -93.8174,
    city: "Cassville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8951,
    density: 22,
    county_fips: 29009,
    county_name: "Barry",
    county_weights: {
      29009: 100,
    },
    county_names_all: "Barry",
    county_fips_all: 29009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65626,
    lat: 36.59088,
    lng: -92.11697,
    city: "Caulfield",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2057,
    density: 7.6,
    county_fips: 29153,
    county_name: "Ozark",
    county_weights: {
      29091: 49.57,
      29153: 50.43,
    },
    county_names_all: "Ozark|Howell",
    county_fips_all: "29153|29091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65627,
    lat: 36.56247,
    lng: -93.00613,
    city: "Cedarcreek",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 785,
    density: 6.4,
    county_fips: 29213,
    county_name: "Taney",
    county_weights: {
      29213: 100,
    },
    county_names_all: "Taney",
    county_fips_all: 29213,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65629,
    lat: 36.89371,
    lng: -93.00294,
    city: "Chadwick",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 668,
    density: 4.1,
    county_fips: 29043,
    county_name: "Christian",
    county_weights: {
      29043: 100,
    },
    county_names_all: "Christian",
    county_fips_all: 29043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65630,
    lat: 36.83463,
    lng: -93.2204,
    city: "Chestnutridge",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 318,
    density: 10.6,
    county_fips: 29043,
    county_name: "Christian",
    county_weights: {
      29043: 98.14,
      29213: 1.86,
    },
    county_names_all: "Christian|Taney",
    county_fips_all: "29043|29213",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65631,
    lat: 37.00594,
    lng: -93.4232,
    city: "Clever",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6563,
    density: 60.2,
    county_fips: 29043,
    county_name: "Christian",
    county_weights: {
      29043: 66.85,
      29209: 33.15,
    },
    county_names_all: "Christian|Stone",
    county_fips_all: "29043|29209",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65632,
    lat: 37.49961,
    lng: -92.81612,
    city: "Conway",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2180,
    density: 7.5,
    county_fips: 29105,
    county_name: "Laclede",
    county_weights: {
      29059: 23.1,
      29105: 46.8,
      29225: 30.1,
    },
    county_names_all: "Laclede|Webster|Dallas",
    county_fips_all: "29105|29225|29059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65633,
    lat: 36.89841,
    lng: -93.5346,
    city: "Crane",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3832,
    density: 17.7,
    county_fips: 29209,
    county_name: "Stone",
    county_weights: {
      29009: 18.87,
      29209: 81.13,
    },
    county_names_all: "Stone|Barry",
    county_fips_all: "29209|29009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65634,
    lat: 38.02355,
    lng: -93.18827,
    city: "Cross Timbers",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 674,
    density: 3.5,
    county_fips: 29085,
    county_name: "Hickory",
    county_weights: {
      29015: 2.07,
      29029: 0.37,
      29085: 97.56,
    },
    county_names_all: "Hickory|Benton|Camden",
    county_fips_all: "29085|29015|29029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65635,
    lat: 37.53487,
    lng: -93.71812,
    city: "Dadeville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 513,
    density: 4.9,
    county_fips: 29057,
    county_name: "Dade",
    county_weights: {
      29039: 27.22,
      29057: 72.78,
    },
    county_names_all: "Dade|Cedar",
    county_fips_all: "29057|29039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65637,
    lat: 36.76964,
    lng: -92.20371,
    city: "Dora",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1111,
    density: 4.5,
    county_fips: 29153,
    county_name: "Ozark",
    county_weights: {
      29067: 28.69,
      29091: 9.37,
      29153: 61.94,
    },
    county_names_all: "Ozark|Douglas|Howell",
    county_fips_all: "29153|29067|29091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65638,
    lat: 36.84319,
    lng: -92.32418,
    city: "Drury",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 614,
    density: 4.5,
    county_fips: 29067,
    county_name: "Douglas",
    county_weights: {
      29067: 80.64,
      29153: 19.36,
    },
    county_names_all: "Douglas|Ozark",
    county_fips_all: "29067|29153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65640,
    lat: 37.69956,
    lng: -93.57165,
    city: "Dunnegan",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1148,
    density: 11.3,
    county_fips: 29167,
    county_name: "Polk",
    county_weights: {
      29039: 25.83,
      29167: 74.17,
    },
    county_names_all: "Polk|Cedar",
    county_fips_all: "29167|29039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65641,
    lat: 36.5481,
    lng: -93.76198,
    city: "Eagle Rock",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 947,
    density: 6.5,
    county_fips: 29009,
    county_name: "Barry",
    county_weights: {
      29009: 100,
    },
    county_names_all: "Barry",
    county_fips_all: 29009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65644,
    lat: 37.50999,
    lng: -93.03625,
    city: "Elkland",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1898,
    density: 9,
    county_fips: 29059,
    county_name: "Dallas",
    county_weights: {
      29059: 65.19,
      29225: 34.81,
    },
    county_names_all: "Dallas|Webster",
    county_fips_all: "29059|29225",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65646,
    lat: 37.33511,
    lng: -93.7039,
    city: "Everton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1757,
    density: 6.6,
    county_fips: 29057,
    county_name: "Dade",
    county_weights: {
      29057: 75.6,
      29109: 24.4,
    },
    county_names_all: "Dade|Lawrence",
    county_fips_all: "29057|29109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65647,
    lat: 36.68968,
    lng: -94.00624,
    city: "Exeter",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2801,
    density: 19.9,
    county_fips: 29009,
    county_name: "Barry",
    county_weights: {
      29009: 93.11,
      29119: 6.89,
    },
    county_names_all: "Barry|McDonald",
    county_fips_all: "29009|29119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65648,
    lat: 37.40297,
    lng: -93.15402,
    city: "Fair Grove",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5801,
    density: 28.6,
    county_fips: 29077,
    county_name: "Greene",
    county_weights: {
      29059: 26.14,
      29077: 58.18,
      29167: 7.57,
      29225: 8.11,
    },
    county_names_all: "Greene|Dallas|Webster|Polk",
    county_fips_all: "29077|29059|29225|29167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65649,
    lat: 37.621,
    lng: -93.61839,
    city: "Fair Play",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1786,
    density: 10.3,
    county_fips: 29167,
    county_name: "Polk",
    county_weights: {
      29039: 49.68,
      29167: 50.32,
    },
    county_names_all: "Polk|Cedar",
    county_fips_all: "29167|29039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65650,
    lat: 37.81388,
    lng: -93.44749,
    city: "Flemington",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1837,
    density: 9.2,
    county_fips: 29085,
    county_name: "Hickory",
    county_weights: {
      29085: 53.58,
      29167: 46.42,
    },
    county_names_all: "Hickory|Polk",
    county_fips_all: "29085|29167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65652,
    lat: 37.14264,
    lng: -92.94642,
    city: "Fordland",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3823,
    density: 20.7,
    county_fips: 29225,
    county_name: "Webster",
    county_weights: {
      29043: 13.49,
      29067: 1.65,
      29225: 84.86,
    },
    county_names_all: "Webster|Christian|Douglas",
    county_fips_all: "29225|29043|29067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65653,
    lat: 36.78118,
    lng: -93.11631,
    city: "Forsyth",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5824,
    density: 35.3,
    county_fips: 29213,
    county_name: "Taney",
    county_weights: {
      29043: 41.04,
      29213: 58.96,
    },
    county_names_all: "Taney|Christian",
    county_fips_all: "29213|29043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65654,
    lat: 37.02164,
    lng: -93.8975,
    city: "Freistatt",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 327,
    density: 612.7,
    county_fips: 29109,
    county_name: "Lawrence",
    county_weights: {
      29109: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 29109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65655,
    lat: 36.60262,
    lng: -92.42379,
    city: "Gainesville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2555,
    density: 4.9,
    county_fips: 29153,
    county_name: "Ozark",
    county_weights: {
      29153: 100,
    },
    county_names_all: "Ozark",
    county_fips_all: 29153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65656,
    lat: 36.79552,
    lng: -93.46626,
    city: "Galena",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5100,
    density: 17.2,
    county_fips: 29209,
    county_name: "Stone",
    county_weights: {
      29009: 2.48,
      29209: 97.52,
    },
    county_names_all: "Stone|Barry",
    county_fips_all: "29209|29009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65657,
    lat: 36.83934,
    lng: -93.01952,
    city: "Garrison",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 402,
    density: 7.7,
    county_fips: 29043,
    county_name: "Christian",
    county_weights: {
      29043: 100,
    },
    county_names_all: "Christian",
    county_fips_all: 29043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65658,
    lat: 36.5426,
    lng: -93.63984,
    city: "Golden",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1364,
    density: 26.4,
    county_fips: 29009,
    county_name: "Barry",
    county_weights: {
      29009: 100,
    },
    county_names_all: "Barry",
    county_fips_all: 29009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65660,
    lat: 37.32624,
    lng: -92.26998,
    city: "Graff",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 222,
    density: 3.2,
    county_fips: 29229,
    county_name: "Wright",
    county_weights: {
      29215: 18.32,
      29229: 81.68,
    },
    county_names_all: "Wright|Texas",
    county_fips_all: "29229|29215",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65661,
    lat: 37.46095,
    lng: -93.82722,
    city: "Greenfield",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2440,
    density: 10.9,
    county_fips: 29057,
    county_name: "Dade",
    county_weights: {
      29057: 100,
    },
    county_names_all: "Dade",
    county_fips_all: 29057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65662,
    lat: 37.43421,
    lng: -92.5698,
    city: "Grovespring",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1077,
    density: 5.5,
    county_fips: 29229,
    county_name: "Wright",
    county_weights: {
      29105: 22.64,
      29229: 77.36,
    },
    county_names_all: "Wright|Laclede",
    county_fips_all: "29229|29105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65663,
    lat: 37.62732,
    lng: -93.24486,
    city: "Half Way",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2575,
    density: 8.7,
    county_fips: 29167,
    county_name: "Polk",
    county_weights: {
      29167: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 29167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65664,
    lat: 37.19728,
    lng: -93.61732,
    city: "Halltown",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 141,
    density: 69.7,
    county_fips: 29109,
    county_name: "Lawrence",
    county_weights: {
      29109: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 29109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65666,
    lat: 36.57829,
    lng: -92.36065,
    city: "Hardenville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 29153,
    county_name: "Ozark",
    county_weights: {
      29153: 100,
    },
    county_names_all: "Ozark",
    county_fips_all: 29153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65667,
    lat: 37.30574,
    lng: -92.51435,
    city: "Hartville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3446,
    density: 7.3,
    county_fips: 29229,
    county_name: "Wright",
    county_weights: {
      29229: 100,
    },
    county_names_all: "Wright",
    county_fips_all: 29229,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65668,
    lat: 37.9364,
    lng: -93.29177,
    city: "Hermitage",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1875,
    density: 20.7,
    county_fips: 29085,
    county_name: "Hickory",
    county_weights: {
      29085: 100,
    },
    county_names_all: "Hickory",
    county_fips_all: 29085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65669,
    lat: 36.91339,
    lng: -93.30137,
    city: "Highlandville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2067,
    density: 19.5,
    county_fips: 29043,
    county_name: "Christian",
    county_weights: {
      29043: 76.07,
      29209: 23.93,
    },
    county_names_all: "Christian|Stone",
    county_fips_all: "29043|29209",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65672,
    lat: 36.56446,
    lng: -93.21351,
    city: "Hollister",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9631,
    density: 65.3,
    county_fips: 29213,
    county_name: "Taney",
    county_weights: {
      29213: 100,
    },
    county_names_all: "Taney",
    county_fips_all: 29213,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65674,
    lat: 37.78872,
    lng: -93.61018,
    city: "Humansville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3104,
    density: 12.5,
    county_fips: 29167,
    county_name: "Polk",
    county_weights: {
      29039: 38.19,
      29085: 11.33,
      29167: 42.95,
      29185: 7.53,
    },
    county_names_all: "Polk|Cedar|Hickory|St. Clair",
    county_fips_all: "29167|29039|29085|29185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65675,
    lat: 36.93101,
    lng: -93.49245,
    city: "Hurley",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 29209,
    county_name: "Stone",
    county_weights: {
      29209: 100,
    },
    county_names_all: "Stone",
    county_fips_all: 29209,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65676,
    lat: 36.58187,
    lng: -92.60531,
    city: "Isabella",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 443,
    density: 9.2,
    county_fips: 29153,
    county_name: "Ozark",
    county_weights: {
      29153: 100,
    },
    county_names_all: "Ozark",
    county_fips_all: 29153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65679,
    lat: 36.57738,
    lng: -93.10407,
    city: "Kirbyville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2958,
    density: 22.3,
    county_fips: 29213,
    county_name: "Taney",
    county_weights: {
      29213: 100,
    },
    county_names_all: "Taney",
    county_fips_all: 29213,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65680,
    lat: 36.64518,
    lng: -92.98551,
    city: "Kissee Mills",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 992,
    density: 9.6,
    county_fips: 29213,
    county_name: "Taney",
    county_weights: {
      29213: 100,
    },
    county_names_all: "Taney",
    county_fips_all: 29213,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65681,
    lat: 36.55211,
    lng: -93.46658,
    city: "Lampe",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1968,
    density: 21.6,
    county_fips: 29209,
    county_name: "Stone",
    county_weights: {
      29209: 100,
    },
    county_names_all: "Stone",
    county_fips_all: 29209,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65682,
    lat: 37.41722,
    lng: -93.97293,
    city: "Lockwood",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2123,
    density: 5.6,
    county_fips: 29057,
    county_name: "Dade",
    county_weights: {
      29057: 94.57,
      29109: 5.43,
    },
    county_names_all: "Dade|Lawrence",
    county_fips_all: "29057|29109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65685,
    lat: 37.75642,
    lng: -93.1511,
    city: "Louisburg",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 800,
    density: 8.7,
    county_fips: 29059,
    county_name: "Dallas",
    county_weights: {
      29059: 80.38,
      29167: 19.62,
    },
    county_names_all: "Dallas|Polk",
    county_fips_all: "29059|29167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65686,
    lat: 36.62275,
    lng: -93.43625,
    city: "Kimberling City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5351,
    density: 211.3,
    county_fips: 29209,
    county_name: "Stone",
    county_weights: {
      29209: 100,
    },
    county_names_all: "Stone",
    county_fips_all: 29209,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65688,
    lat: 36.64928,
    lng: -91.69328,
    city: "Brandsville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 29091,
    county_name: "Howell",
    county_weights: {
      29091: 100,
    },
    county_names_all: "Howell",
    county_fips_all: 29091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65689,
    lat: 37.13665,
    lng: -92.09794,
    city: "Cabool",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5309,
    density: 11.6,
    county_fips: 29215,
    county_name: "Texas",
    county_weights: {
      29067: 18.9,
      29091: 4.88,
      29215: 76.22,
    },
    county_names_all: "Texas|Douglas|Howell",
    county_fips_all: "29215|29067|29091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65690,
    lat: 36.5856,
    lng: -91.26657,
    city: "Couch",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 169,
    density: 2.2,
    county_fips: 29149,
    county_name: "Oregon",
    county_weights: {
      29149: 100,
    },
    county_names_all: "Oregon",
    county_fips_all: 29149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65692,
    lat: 36.61801,
    lng: -91.65592,
    city: "Koshkonong",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1269,
    density: 4.8,
    county_fips: 29149,
    county_name: "Oregon",
    county_weights: {
      29091: 41.54,
      29149: 58.46,
    },
    county_names_all: "Oregon|Howell",
    county_fips_all: "29149|29091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65702,
    lat: 37.05726,
    lng: -92.488,
    city: "Macomb",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 339,
    density: 4.6,
    county_fips: 29067,
    county_name: "Douglas",
    county_weights: {
      29067: 55.47,
      29229: 44.53,
    },
    county_names_all: "Douglas|Wright",
    county_fips_all: "29067|29229",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65704,
    lat: 37.12657,
    lng: -92.58323,
    city: "Mansfield",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3600,
    density: 11.1,
    county_fips: 29229,
    county_name: "Wright",
    county_weights: {
      29067: 25.12,
      29229: 74.88,
    },
    county_names_all: "Wright|Douglas",
    county_fips_all: "29229|29067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65705,
    lat: 37.02607,
    lng: -93.60835,
    city: "Marionville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4114,
    density: 38.3,
    county_fips: 29109,
    county_name: "Lawrence",
    county_weights: {
      29109: 70.96,
      29209: 29.04,
    },
    county_names_all: "Lawrence|Stone",
    county_fips_all: "29109|29209",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65706,
    lat: 37.3224,
    lng: -92.89421,
    city: "Marshfield",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17263,
    density: 37,
    county_fips: 29225,
    county_name: "Webster",
    county_weights: {
      29077: 0.15,
      29225: 99.85,
    },
    county_names_all: "Webster|Greene",
    county_fips_all: "29225|29077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65707,
    lat: 37.22862,
    lng: -93.84574,
    city: "Miller",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1917,
    density: 7.8,
    county_fips: 29109,
    county_name: "Lawrence",
    county_weights: {
      29109: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 29109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65708,
    lat: 36.91048,
    lng: -93.90899,
    city: "Monett",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13202,
    density: 59.1,
    county_fips: 29009,
    county_name: "Barry",
    county_weights: {
      29009: 69.04,
      29109: 30.96,
    },
    county_names_all: "Barry|Lawrence",
    county_fips_all: "29009|29109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65710,
    lat: 37.48707,
    lng: -93.42099,
    city: "Morrisville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1054,
    density: 13.3,
    county_fips: 29167,
    county_name: "Polk",
    county_weights: {
      29167: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 29167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65711,
    lat: 37.17355,
    lng: -92.27747,
    city: "Mountain Grove",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9160,
    density: 12.1,
    county_fips: 29229,
    county_name: "Wright",
    county_weights: {
      29067: 20.53,
      29215: 27.79,
      29229: 51.68,
    },
    county_names_all: "Wright|Texas|Douglas",
    county_fips_all: "29229|29215|29067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65712,
    lat: 37.10964,
    lng: -93.80645,
    city: "Mount Vernon",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9119,
    density: 29.3,
    county_fips: 29109,
    county_name: "Lawrence",
    county_weights: {
      29109: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 29109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65713,
    lat: 37.40403,
    lng: -92.73971,
    city: "Niangua",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2605,
    density: 9,
    county_fips: 29225,
    county_name: "Webster",
    county_weights: {
      29225: 72.57,
      29229: 27.43,
    },
    county_names_all: "Webster|Wright",
    county_fips_all: "29225|29229",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65714,
    lat: 37.03801,
    lng: -93.31976,
    city: "Nixa",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33646,
    density: 254.1,
    county_fips: 29043,
    county_name: "Christian",
    county_weights: {
      29043: 93.75,
      29209: 6.25,
    },
    county_names_all: "Christian|Stone",
    county_fips_all: "29043|29209",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65715,
    lat: 36.73192,
    lng: -92.57631,
    city: "Noble",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16,
    density: 0.5,
    county_fips: 29153,
    county_name: "Ozark",
    county_weights: {
      29153: 100,
    },
    county_names_all: "Ozark",
    county_fips_all: 29153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65717,
    lat: 37.06017,
    lng: -92.41472,
    city: "Norwood",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2708,
    density: 8.1,
    county_fips: 29229,
    county_name: "Wright",
    county_weights: {
      29067: 47.31,
      29229: 52.69,
    },
    county_names_all: "Wright|Douglas",
    county_fips_all: "29229|29067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65720,
    lat: 36.95513,
    lng: -92.95998,
    city: "Oldfield",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1015,
    density: 13.1,
    county_fips: 29043,
    county_name: "Christian",
    county_weights: {
      29043: 76.95,
      29067: 23.05,
    },
    county_names_all: "Christian|Douglas",
    county_fips_all: "29043|29067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65721,
    lat: 36.9805,
    lng: -93.21045,
    city: "Ozark",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32788,
    density: 132,
    county_fips: 29043,
    county_name: "Christian",
    county_weights: {
      29043: 97.96,
      29077: 2.04,
    },
    county_names_all: "Christian|Greene",
    county_fips_all: "29043|29077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65722,
    lat: 37.58694,
    lng: -92.79967,
    city: "Phillipsburg",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1639,
    density: 12.8,
    county_fips: 29105,
    county_name: "Laclede",
    county_weights: {
      29059: 25.63,
      29105: 74.37,
    },
    county_names_all: "Laclede|Dallas",
    county_fips_all: "29105|29059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65723,
    lat: 36.95635,
    lng: -94.04648,
    city: "Pierce City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2959,
    density: 12.7,
    county_fips: 29109,
    county_name: "Lawrence",
    county_weights: {
      29009: 18.04,
      29109: 46.71,
      29145: 35.24,
    },
    county_names_all: "Lawrence|Newton|Barry",
    county_fips_all: "29109|29145|29009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65724,
    lat: 37.83924,
    lng: -93.31488,
    city: "Pittsburg",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1180,
    density: 19.7,
    county_fips: 29085,
    county_name: "Hickory",
    county_weights: {
      29085: 92.29,
      29167: 7.71,
    },
    county_names_all: "Hickory|Polk",
    county_fips_all: "29085|29167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65725,
    lat: 37.42986,
    lng: -93.27424,
    city: "Pleasant Hope",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3199,
    density: 39.5,
    county_fips: 29167,
    county_name: "Polk",
    county_weights: {
      29077: 38.02,
      29167: 61.98,
    },
    county_names_all: "Polk|Greene",
    county_fips_all: "29167|29077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65726,
    lat: 36.61947,
    lng: -93.2427,
    city: "Point Lookout",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 29213,
    county_name: "Taney",
    county_weights: {
      29213: 100,
    },
    county_names_all: "Taney",
    county_fips_all: 29213,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65727,
    lat: 37.76266,
    lng: -93.28889,
    city: "Polk",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 167,
    density: 6.4,
    county_fips: 29167,
    county_name: "Polk",
    county_weights: {
      29085: 0.57,
      29167: 99.43,
    },
    county_names_all: "Polk|Hickory",
    county_fips_all: "29167|29085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65728,
    lat: 36.87712,
    lng: -93.33533,
    city: "Ponce De Leon",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 29043,
    county_name: "Christian",
    county_weights: {
      29043: 72.75,
      29209: 27.25,
    },
    county_names_all: "Christian|Stone",
    county_fips_all: "29043|29209",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65729,
    lat: 36.53842,
    lng: -92.55661,
    city: "Pontiac",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 169,
    density: 3.2,
    county_fips: 29153,
    county_name: "Ozark",
    county_weights: {
      29153: 89.37,
      "05089": 10.63,
    },
    county_names_all: "Ozark|Marion",
    county_fips_all: "29153|05089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65730,
    lat: 36.61549,
    lng: -94.17001,
    city: "Powell",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8,
    density: 0.2,
    county_fips: 29119,
    county_name: "McDonald",
    county_weights: {
      29119: 100,
    },
    county_names_all: "McDonald",
    county_fips_all: 29119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65731,
    lat: 36.65458,
    lng: -93.12222,
    city: "Powersite",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 250,
    density: 68.5,
    county_fips: 29213,
    county_name: "Taney",
    county_weights: {
      29213: 100,
    },
    county_names_all: "Taney",
    county_fips_all: 29213,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65732,
    lat: 37.93938,
    lng: -93.16763,
    city: "Preston",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1227,
    density: 8.2,
    county_fips: 29085,
    county_name: "Hickory",
    county_weights: {
      29085: 100,
    },
    county_names_all: "Hickory",
    county_fips_all: 29085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65733,
    lat: 36.53157,
    lng: -92.85077,
    city: "Protem",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 863,
    density: 5.1,
    county_fips: 29213,
    county_name: "Taney",
    county_weights: {
      29153: 3.22,
      29213: 77.89,
      "05089": 11.67,
      "05009": 7.22,
    },
    county_names_all: "Taney|Marion|Boone|Ozark",
    county_fips_all: "29213|05089|05009|29153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65734,
    lat: 36.79841,
    lng: -93.95233,
    city: "Purdy",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3184,
    density: 14.5,
    county_fips: 29009,
    county_name: "Barry",
    county_weights: {
      29009: 99.59,
      29145: 0.41,
    },
    county_names_all: "Barry|Newton",
    county_fips_all: "29009|29145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65735,
    lat: 38.03728,
    lng: -93.48391,
    city: "Quincy",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 113,
    density: 1.4,
    county_fips: 29085,
    county_name: "Hickory",
    county_weights: {
      29015: 16.07,
      29085: 63.81,
      29185: 20.12,
    },
    county_names_all: "Hickory|St. Clair|Benton",
    county_fips_all: "29085|29185|29015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65737,
    lat: 36.7146,
    lng: -93.35796,
    city: "Reeds Spring",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8106,
    density: 37.1,
    county_fips: 29209,
    county_name: "Stone",
    county_weights: {
      29043: 2.02,
      29209: 85.24,
      29213: 12.74,
    },
    county_names_all: "Stone|Taney|Christian",
    county_fips_all: "29209|29213|29043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65738,
    lat: 37.13503,
    lng: -93.49424,
    city: "Republic",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19459,
    density: 139.5,
    county_fips: 29077,
    county_name: "Greene",
    county_weights: {
      29043: 13.08,
      29077: 85.53,
      29109: 1.39,
    },
    county_names_all: "Greene|Christian|Lawrence",
    county_fips_all: "29077|29043|29109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65739,
    lat: 36.51925,
    lng: -93.26864,
    city: "Ridgedale",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 772,
    density: 23,
    county_fips: 29213,
    county_name: "Taney",
    county_weights: {
      29213: 100,
    },
    county_names_all: "Taney",
    county_fips_all: 29213,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65740,
    lat: 36.71288,
    lng: -93.16169,
    city: "Rockaway Beach",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3794,
    density: 360,
    county_fips: 29213,
    county_name: "Taney",
    county_weights: {
      29213: 100,
    },
    county_names_all: "Taney",
    county_fips_all: 29213,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65741,
    lat: 36.79545,
    lng: -92.40127,
    city: "Rockbridge",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 29153,
    county_name: "Ozark",
    county_weights: {
      29067: 0.1,
      29153: 99.9,
    },
    county_names_all: "Ozark|Douglas",
    county_fips_all: "29153|29067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65742,
    lat: 37.12543,
    lng: -93.08001,
    city: "Rogersville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14170,
    density: 46.2,
    county_fips: 29077,
    county_name: "Greene",
    county_weights: {
      29043: 27.55,
      29077: 41.75,
      29225: 30.7,
    },
    county_names_all: "Greene|Webster|Christian",
    county_fips_all: "29077|29225|29043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65744,
    lat: 36.62449,
    lng: -92.89337,
    city: "Rueter",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 86,
    density: 1.9,
    county_fips: 29213,
    county_name: "Taney",
    county_weights: {
      29213: 100,
    },
    county_names_all: "Taney",
    county_fips_all: 29213,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65745,
    lat: 36.52928,
    lng: -93.97917,
    city: "Seligman",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2616,
    density: 14.8,
    county_fips: 29009,
    county_name: "Barry",
    county_weights: {
      29009: 81.16,
      29119: 18.84,
    },
    county_names_all: "Barry|McDonald",
    county_fips_all: "29009|29119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65746,
    lat: 37.14278,
    lng: -92.78144,
    city: "Seymour",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8805,
    density: 18.3,
    county_fips: 29225,
    county_name: "Webster",
    county_weights: {
      29067: 14.16,
      29225: 77.07,
      29229: 8.77,
    },
    county_names_all: "Webster|Douglas|Wright",
    county_fips_all: "29225|29067|29229",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65747,
    lat: 36.60248,
    lng: -93.57971,
    city: "Shell Knob",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3204,
    density: 16.1,
    county_fips: 29209,
    county_name: "Stone",
    county_weights: {
      29009: 45.06,
      29209: 54.94,
    },
    county_names_all: "Stone|Barry",
    county_fips_all: "29209|29009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65752,
    lat: 37.32742,
    lng: -93.83842,
    city: "South Greenfield",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 285,
    density: 2.4,
    county_fips: 29057,
    county_name: "Dade",
    county_weights: {
      29057: 92.16,
      29109: 7.84,
    },
    county_names_all: "Dade|Lawrence",
    county_fips_all: "29057|29109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65753,
    lat: 36.9955,
    lng: -93.05386,
    city: "Sparta",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4768,
    density: 25.9,
    county_fips: 29043,
    county_name: "Christian",
    county_weights: {
      29043: 93.18,
      29067: 6.82,
    },
    county_names_all: "Christian|Douglas",
    county_fips_all: "29043|29067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65754,
    lat: 36.85032,
    lng: -93.29595,
    city: "Spokane",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 581,
    density: 11.8,
    county_fips: 29043,
    county_name: "Christian",
    county_weights: {
      29043: 99.38,
      29209: 0.62,
    },
    county_names_all: "Christian|Stone",
    county_fips_all: "29043|29209",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65755,
    lat: 36.7996,
    lng: -92.62858,
    city: "Squires",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 683,
    density: 6.8,
    county_fips: 29067,
    county_name: "Douglas",
    county_weights: {
      29067: 56.26,
      29153: 43.74,
    },
    county_names_all: "Douglas|Ozark",
    county_fips_all: "29067|29153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65756,
    lat: 37.0981,
    lng: -93.96315,
    city: "Stotts City",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 633,
    density: 7.9,
    county_fips: 29109,
    county_name: "Lawrence",
    county_weights: {
      29109: 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: 29109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65757,
    lat: 37.2838,
    lng: -93.09861,
    city: "Strafford",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7077,
    density: 32.8,
    county_fips: 29077,
    county_name: "Greene",
    county_weights: {
      29077: 71.57,
      29225: 28.43,
    },
    county_names_all: "Greene|Webster",
    county_fips_all: "29077|29225",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65759,
    lat: 36.75762,
    lng: -93.03167,
    city: "Taneyville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1287,
    density: 9.8,
    county_fips: 29213,
    county_name: "Taney",
    county_weights: {
      29043: 2.32,
      29213: 97.68,
    },
    county_names_all: "Taney|Christian",
    county_fips_all: "29213|29043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65760,
    lat: 36.62236,
    lng: -92.27943,
    city: "Tecumseh",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 722,
    density: 7.4,
    county_fips: 29153,
    county_name: "Ozark",
    county_weights: {
      29153: 100,
    },
    county_names_all: "Ozark",
    county_fips_all: 29153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65761,
    lat: 36.56974,
    lng: -92.72561,
    city: "Theodosia",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1061,
    density: 3.6,
    county_fips: 29153,
    county_name: "Ozark",
    county_weights: {
      29153: 61.58,
      29213: 20.52,
      "05089": 17.9,
    },
    county_names_all: "Ozark|Taney|Marion",
    county_fips_all: "29153|29213|05089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65762,
    lat: 36.68613,
    lng: -92.65634,
    city: "Thornfield",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 398,
    density: 2,
    county_fips: 29153,
    county_name: "Ozark",
    county_weights: {
      29153: 100,
    },
    county_names_all: "Ozark",
    county_fips_all: 29153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65764,
    lat: 37.82189,
    lng: -92.95682,
    city: "Tunas",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1414,
    density: 5.7,
    county_fips: 29059,
    county_name: "Dallas",
    county_weights: {
      29059: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 29059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65766,
    lat: 36.53933,
    lng: -92.25948,
    city: "Udall",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 89,
    density: 6.3,
    county_fips: 29153,
    county_name: "Ozark",
    county_weights: {
      29153: 100,
    },
    county_names_all: "Ozark",
    county_fips_all: 29153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65767,
    lat: 37.84495,
    lng: -93.1529,
    city: "Urbana",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2066,
    density: 9.9,
    county_fips: 29059,
    county_name: "Dallas",
    county_weights: {
      29059: 66.58,
      29085: 29.4,
      29167: 4.02,
    },
    county_names_all: "Dallas|Hickory|Polk",
    county_fips_all: "29059|29085|29167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65768,
    lat: 36.92072,
    lng: -92.26456,
    city: "Vanzant",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 414,
    density: 3.1,
    county_fips: 29067,
    county_name: "Douglas",
    county_weights: {
      29067: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 29067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65769,
    lat: 36.91676,
    lng: -93.79511,
    city: "Verona",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2944,
    density: 13,
    county_fips: 29009,
    county_name: "Barry",
    county_weights: {
      29009: 51.74,
      29109: 48.26,
    },
    county_names_all: "Barry|Lawrence",
    county_fips_all: "29009|29109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65770,
    lat: 37.42165,
    lng: -93.5456,
    city: "Walnut Grove",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2650,
    density: 10.7,
    county_fips: 29077,
    county_name: "Greene",
    county_weights: {
      29057: 13.92,
      29077: 48.39,
      29167: 37.69,
    },
    county_names_all: "Greene|Polk|Dade",
    county_fips_all: "29077|29167|29057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65771,
    lat: 36.77484,
    lng: -93.2042,
    city: "Walnut Shade",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1454,
    density: 15.6,
    county_fips: 29213,
    county_name: "Taney",
    county_weights: {
      29043: 0.11,
      29213: 99.89,
    },
    county_names_all: "Taney|Christian",
    county_fips_all: "29213|29043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65772,
    lat: 36.59624,
    lng: -94.03479,
    city: "Washburn",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2007,
    density: 10,
    county_fips: 29009,
    county_name: "Barry",
    county_weights: {
      29009: 69.06,
      29119: 30.94,
    },
    county_names_all: "Barry|McDonald",
    county_fips_all: "29009|29119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65773,
    lat: 36.75551,
    lng: -92.51332,
    city: "Wasola",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 667,
    density: 4,
    county_fips: 29153,
    county_name: "Ozark",
    county_weights: {
      29153: 100,
    },
    county_names_all: "Ozark",
    county_fips_all: 29153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65774,
    lat: 37.92806,
    lng: -93.49529,
    city: "Weaubleau",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1251,
    density: 10.1,
    county_fips: 29085,
    county_name: "Hickory",
    county_weights: {
      29085: 78.71,
      29185: 21.29,
    },
    county_names_all: "Hickory|St. Clair",
    county_fips_all: "29085|29185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65775,
    lat: 36.6995,
    lng: -91.85999,
    city: "West Plains",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25289,
    density: 22.1,
    county_fips: 29091,
    county_name: "Howell",
    county_weights: {
      29067: 3.56,
      29091: 91.05,
      29149: 5.39,
    },
    county_names_all: "Howell|Oregon|Douglas",
    county_fips_all: "29091|29149|29067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65777,
    lat: 36.51768,
    lng: -91.98356,
    city: "Moody",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 250,
    density: 7.4,
    county_fips: 29091,
    county_name: "Howell",
    county_weights: {
      29091: 100,
    },
    county_names_all: "Howell",
    county_fips_all: 29091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65778,
    lat: 36.52846,
    lng: -91.2719,
    city: "Myrtle",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 467,
    density: 5,
    county_fips: 29149,
    county_name: "Oregon",
    county_weights: {
      29149: 100,
    },
    county_names_all: "Oregon",
    county_fips_all: 29149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65779,
    lat: 37.9789,
    lng: -93.38561,
    city: "Wheatland",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1457,
    density: 7.2,
    county_fips: 29085,
    county_name: "Hickory",
    county_weights: {
      29015: 2.97,
      29085: 97.03,
    },
    county_names_all: "Hickory|Benton",
    county_fips_all: "29085|29015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65781,
    lat: 37.35035,
    lng: -93.41778,
    city: "Willard",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8755,
    density: 47.2,
    county_fips: 29077,
    county_name: "Greene",
    county_weights: {
      29077: 89.42,
      29167: 10.58,
    },
    county_names_all: "Greene|Polk",
    county_fips_all: "29077|29167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65783,
    lat: 37.7153,
    lng: -92.91623,
    city: "Windyville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 168,
    density: 5.6,
    county_fips: 29059,
    county_name: "Dallas",
    county_weights: {
      29059: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 29059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65784,
    lat: 36.72588,
    lng: -92.31538,
    city: "Zanoni",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 29153,
    county_name: "Ozark",
    county_weights: {
      29153: 100,
    },
    county_names_all: "Ozark",
    county_fips_all: 29153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65785,
    lat: 37.70296,
    lng: -93.82338,
    city: "Stockton",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5538,
    density: 9.8,
    county_fips: 29039,
    county_name: "Cedar",
    county_weights: {
      29039: 90.16,
      29057: 3.76,
      29185: 6.08,
    },
    county_names_all: "Cedar|St. Clair|Dade",
    county_fips_all: "29039|29185|29057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65786,
    lat: 37.96715,
    lng: -92.96516,
    city: "Macks Creek",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2101,
    density: 7.4,
    county_fips: 29029,
    county_name: "Camden",
    county_weights: {
      29029: 96.43,
      29059: 3.57,
    },
    county_names_all: "Camden|Dallas",
    county_fips_all: "29029|29059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65787,
    lat: 38.07306,
    lng: -92.89213,
    city: "Roach",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1526,
    density: 15.3,
    county_fips: 29029,
    county_name: "Camden",
    county_weights: {
      29029: 100,
    },
    county_names_all: "Camden",
    county_fips_all: 29029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65788,
    lat: 36.81442,
    lng: -91.69626,
    city: "Peace Valley",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 339,
    density: 5,
    county_fips: 29091,
    county_name: "Howell",
    county_weights: {
      29091: 91.48,
      29149: 8.52,
    },
    county_names_all: "Howell|Oregon",
    county_fips_all: "29091|29149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65789,
    lat: 36.85719,
    lng: -91.88968,
    city: "Pomona",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2149,
    density: 11.4,
    county_fips: 29091,
    county_name: "Howell",
    county_weights: {
      29091: 100,
    },
    county_names_all: "Howell",
    county_fips_all: 29091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65790,
    lat: 36.69784,
    lng: -92.11326,
    city: "Pottersville",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 724,
    density: 4.9,
    county_fips: 29091,
    county_name: "Howell",
    county_weights: {
      29091: 51.76,
      29153: 48.24,
    },
    county_names_all: "Howell|Ozark",
    county_fips_all: "29091|29153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65791,
    lat: 36.56651,
    lng: -91.49583,
    city: "Thayer",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5042,
    density: 12.7,
    county_fips: 29149,
    county_name: "Oregon",
    county_weights: {
      29149: 100,
    },
    county_names_all: "Oregon",
    county_fips_all: 29149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65793,
    lat: 36.98975,
    lng: -91.9787,
    city: "Willow Springs",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5597,
    density: 8.3,
    county_fips: 29091,
    county_name: "Howell",
    county_weights: {
      29067: 14.09,
      29091: 57.69,
      29215: 28.22,
    },
    county_names_all: "Howell|Texas|Douglas",
    county_fips_all: "29091|29215|29067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65801,
    lat: 37.21421,
    lng: -93.29521,
    city: "Springfield",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 29077,
    county_name: "Greene",
    county_weights: {
      29077: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 29077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65802,
    lat: 37.21048,
    lng: -93.35167,
    city: "Springfield",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47098,
    density: 296.1,
    county_fips: 29077,
    county_name: "Greene",
    county_weights: {
      29077: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 29077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65803,
    lat: 37.28464,
    lng: -93.29036,
    city: "Springfield",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41897,
    density: 173.3,
    county_fips: 29077,
    county_name: "Greene",
    county_weights: {
      29077: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 29077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65804,
    lat: 37.14822,
    lng: -93.25294,
    city: "Springfield",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37782,
    density: 784.3,
    county_fips: 29077,
    county_name: "Greene",
    county_weights: {
      29077: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 29077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65806,
    lat: 37.20567,
    lng: -93.29847,
    city: "Springfield",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13315,
    density: 2407.6,
    county_fips: 29077,
    county_name: "Greene",
    county_weights: {
      29077: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 29077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65807,
    lat: 37.166,
    lng: -93.32483,
    city: "Springfield",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58366,
    density: 1072.3,
    county_fips: 29077,
    county_name: "Greene",
    county_weights: {
      29077: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 29077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65809,
    lat: 37.17071,
    lng: -93.1936,
    city: "Springfield",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10611,
    density: 240.8,
    county_fips: 29077,
    county_name: "Greene",
    county_weights: {
      29077: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 29077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65810,
    lat: 37.1174,
    lng: -93.31707,
    city: "Springfield",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22085,
    density: 712.4,
    county_fips: 29077,
    county_name: "Greene",
    county_weights: {
      29077: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 29077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 65897,
    lat: 37.19985,
    lng: -93.28055,
    city: "Springfield",
    state_id: "MO",
    state_name: "Missouri",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 29077,
    county_name: "Greene",
    county_weights: {
      29077: 100,
    },
    county_names_all: "Greene",
    county_fips_all: 29077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66002,
    lat: 39.5488,
    lng: -95.13881,
    city: "Atchison",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13113,
    density: 26.7,
    county_fips: 20005,
    county_name: "Atchison",
    county_weights: {
      20005: 73.65,
      20043: 17.47,
      20087: 4.81,
      20103: 4.07,
    },
    county_names_all: "Atchison|Doniphan|Jefferson|Leavenworth",
    county_fips_all: "20005|20043|20087|20103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66006,
    lat: 38.79433,
    lng: -95.23936,
    city: "Baldwin City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7859,
    density: 27.9,
    county_fips: 20045,
    county_name: "Douglas",
    county_weights: {
      20045: 94.6,
      20059: 5.4,
    },
    county_names_all: "Douglas|Franklin",
    county_fips_all: "20045|20059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66007,
    lat: 39.1405,
    lng: -94.94548,
    city: "Basehor",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7175,
    density: 88.3,
    county_fips: 20103,
    county_name: "Leavenworth",
    county_weights: {
      20103: 100,
    },
    county_names_all: "Leavenworth",
    county_fips_all: 20103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66008,
    lat: 39.71283,
    lng: -95.17564,
    city: "Bendena",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 185,
    density: 2.5,
    county_fips: 20043,
    county_name: "Doniphan",
    county_weights: {
      20043: 100,
    },
    county_names_all: "Doniphan",
    county_fips_all: 20043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66010,
    lat: 38.09231,
    lng: -94.98853,
    city: "Blue Mound",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 684,
    density: 3,
    county_fips: 20107,
    county_name: "Linn",
    county_weights: {
      20011: 6.34,
      20107: 93.66,
    },
    county_names_all: "Linn|Bourbon",
    county_fips_all: "20107|20011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66012,
    lat: 39.06091,
    lng: -94.91658,
    city: "Bonner Springs",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12330,
    density: 119.9,
    county_fips: 20103,
    county_name: "Leavenworth",
    county_weights: {
      20103: 55.31,
      20209: 44.69,
    },
    county_names_all: "Leavenworth|Wyandotte",
    county_fips_all: "20103|20209",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66013,
    lat: 38.73428,
    lng: -94.68948,
    city: "Bucyrus",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1804,
    density: 15.5,
    county_fips: 20121,
    county_name: "Miami",
    county_weights: {
      20091: 41.8,
      20121: 58.2,
    },
    county_names_all: "Miami|Johnson",
    county_fips_all: "20121|20091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66014,
    lat: 38.22305,
    lng: -94.98371,
    city: "Centerville",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 540,
    density: 3.1,
    county_fips: 20107,
    county_name: "Linn",
    county_weights: {
      20003: 3.72,
      20107: 96.28,
    },
    county_names_all: "Linn|Anderson",
    county_fips_all: "20107|20003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66015,
    lat: 38.06786,
    lng: -95.40395,
    city: "Colony",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 729,
    density: 3,
    county_fips: 20003,
    county_name: "Anderson",
    county_weights: {
      20001: 23.1,
      20003: 76.9,
    },
    county_names_all: "Anderson|Allen",
    county_fips_all: "20003|20001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66016,
    lat: 39.47038,
    lng: -95.23158,
    city: "Cummings",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 636,
    density: 7.8,
    county_fips: 20005,
    county_name: "Atchison",
    county_weights: {
      20005: 100,
    },
    county_names_all: "Atchison",
    county_fips_all: 20005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66017,
    lat: 39.70599,
    lng: -95.27591,
    city: "Denton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 396,
    density: 3.7,
    county_fips: 20043,
    county_name: "Doniphan",
    county_weights: {
      20013: 6.67,
      20043: 93.33,
    },
    county_names_all: "Doniphan|Brown",
    county_fips_all: "20043|20013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66018,
    lat: 38.96524,
    lng: -94.97232,
    city: "De Soto",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6380,
    density: 106.1,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66020,
    lat: 39.34142,
    lng: -95.10779,
    city: "Easton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1660,
    density: 10.1,
    county_fips: 20103,
    county_name: "Leavenworth",
    county_weights: {
      20103: 100,
    },
    county_names_all: "Leavenworth",
    county_fips_all: 20103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66021,
    lat: 38.75939,
    lng: -95.00692,
    city: "Edgerton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2954,
    density: 22.3,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20045: 8.76,
      20091: 60.08,
      20121: 31.16,
    },
    county_names_all: "Johnson|Miami|Douglas",
    county_fips_all: "20091|20121|20045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66023,
    lat: 39.51375,
    lng: -95.40005,
    city: "Effingham",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 904,
    density: 4.8,
    county_fips: 20005,
    county_name: "Atchison",
    county_weights: {
      20005: 100,
    },
    county_names_all: "Atchison",
    county_fips_all: 20005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66024,
    lat: 39.76211,
    lng: -94.87719,
    city: "Elwood",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 673,
    density: 183.1,
    county_fips: 20043,
    county_name: "Doniphan",
    county_weights: {
      20043: 100,
    },
    county_names_all: "Doniphan",
    county_fips_all: 20043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66025,
    lat: 38.89824,
    lng: -95.07863,
    city: "Eudora",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7847,
    density: 40.7,
    county_fips: 20045,
    county_name: "Douglas",
    county_weights: {
      20045: 69.36,
      20091: 30.64,
    },
    county_names_all: "Douglas|Johnson",
    county_fips_all: "20045|20091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66026,
    lat: 38.39047,
    lng: -94.86056,
    city: "Fontana",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 976,
    density: 7.8,
    county_fips: 20121,
    county_name: "Miami",
    county_weights: {
      20107: 49.98,
      20121: 50.02,
    },
    county_names_all: "Miami|Linn",
    county_fips_all: "20121|20107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66027,
    lat: 39.36454,
    lng: -94.91708,
    city: "Fort Leavenworth",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6535,
    density: 271.5,
    county_fips: 20103,
    county_name: "Leavenworth",
    county_weights: {
      20103: 100,
    },
    county_names_all: "Leavenworth",
    county_fips_all: 20103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66030,
    lat: 38.81519,
    lng: -94.94114,
    city: "Gardner",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24088,
    density: 200.4,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66031,
    lat: 38.82975,
    lng: -94.89142,
    city: "New Century",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 628,
    density: 74.3,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66032,
    lat: 38.2806,
    lng: -95.27237,
    city: "Garnett",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4942,
    density: 9,
    county_fips: 20003,
    county_name: "Anderson",
    county_weights: {
      20003: 100,
    },
    county_names_all: "Anderson",
    county_fips_all: 20003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66033,
    lat: 38.35855,
    lng: -95.12842,
    city: "Greeley",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 738,
    density: 5.5,
    county_fips: 20003,
    county_name: "Anderson",
    county_weights: {
      20003: 78.24,
      20059: 14.94,
      20107: 6.82,
    },
    county_names_all: "Anderson|Franklin|Linn",
    county_fips_all: "20003|20059|20107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66035,
    lat: 39.87693,
    lng: -95.26054,
    city: "Highland",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1323,
    density: 11.5,
    county_fips: 20043,
    county_name: "Doniphan",
    county_weights: {
      20043: 100,
    },
    county_names_all: "Doniphan",
    county_fips_all: 20043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66039,
    lat: 38.0987,
    lng: -95.17011,
    city: "Kincaid",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 570,
    density: 2.1,
    county_fips: 20003,
    county_name: "Anderson",
    county_weights: {
      20001: 6.78,
      20003: 93.22,
    },
    county_names_all: "Anderson|Allen",
    county_fips_all: "20003|20001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66040,
    lat: 38.35396,
    lng: -94.73949,
    city: "La Cygne",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3312,
    density: 9.5,
    county_fips: 20107,
    county_name: "Linn",
    county_weights: {
      20107: 71.27,
      20121: 28.73,
    },
    county_names_all: "Linn|Miami",
    county_fips_all: "20107|20121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66041,
    lat: 39.59618,
    lng: -95.30623,
    city: "Lancaster",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 843,
    density: 6.1,
    county_fips: 20005,
    county_name: "Atchison",
    county_weights: {
      20005: 86.87,
      20013: 3.88,
      20043: 9.25,
    },
    county_names_all: "Atchison|Doniphan|Brown",
    county_fips_all: "20005|20043|20013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66042,
    lat: 38.43368,
    lng: -95.08032,
    city: "Lane",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 555,
    density: 7.2,
    county_fips: 20059,
    county_name: "Franklin",
    county_weights: {
      20059: 62.16,
      20121: 37.84,
    },
    county_names_all: "Franklin|Miami",
    county_fips_all: "20059|20121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66043,
    lat: 39.24967,
    lng: -94.90193,
    city: "Lansing",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11378,
    density: 608.8,
    county_fips: 20103,
    county_name: "Leavenworth",
    county_weights: {
      20103: 100,
    },
    county_names_all: "Leavenworth",
    county_fips_all: 20103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66044,
    lat: 39.03187,
    lng: -95.20991,
    city: "Lawrence",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28867,
    density: 173.7,
    county_fips: 20045,
    county_name: "Douglas",
    county_weights: {
      20045: 38.61,
      20087: 32.68,
      20103: 28.71,
    },
    county_names_all: "Douglas|Jefferson|Leavenworth",
    county_fips_all: "20045|20087|20103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66045,
    lat: 38.95408,
    lng: -95.26078,
    city: "Lawrence",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2284,
    density: 790.4,
    county_fips: 20045,
    county_name: "Douglas",
    county_weights: {
      20045: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 20045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66046,
    lat: 38.909,
    lng: -95.21061,
    city: "Lawrence",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19564,
    density: 185,
    county_fips: 20045,
    county_name: "Douglas",
    county_weights: {
      20045: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 20045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66047,
    lat: 38.88484,
    lng: -95.35096,
    city: "Lawrence",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20954,
    density: 139.1,
    county_fips: 20045,
    county_name: "Douglas",
    county_weights: {
      20045: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 20045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66048,
    lat: 39.27891,
    lng: -94.98527,
    city: "Leavenworth",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35952,
    density: 102.5,
    county_fips: 20103,
    county_name: "Leavenworth",
    county_weights: {
      20103: 100,
    },
    county_names_all: "Leavenworth",
    county_fips_all: 20103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66049,
    lat: 38.97773,
    lng: -95.34729,
    city: "Lawrence",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31820,
    density: 271.9,
    county_fips: 20045,
    county_name: "Douglas",
    county_weights: {
      20045: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 20045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66050,
    lat: 39.01961,
    lng: -95.43697,
    city: "Lecompton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2181,
    density: 20.8,
    county_fips: 20045,
    county_name: "Douglas",
    county_weights: {
      20045: 99.21,
      20177: 0.79,
    },
    county_names_all: "Douglas|Shawnee",
    county_fips_all: "20045|20177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66052,
    lat: 39.00998,
    lng: -95.04678,
    city: "Linwood",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2104,
    density: 19.9,
    county_fips: 20103,
    county_name: "Leavenworth",
    county_weights: {
      20103: 100,
    },
    county_names_all: "Leavenworth",
    county_fips_all: 20103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66053,
    lat: 38.57753,
    lng: -94.67029,
    city: "Louisburg",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6967,
    density: 25.9,
    county_fips: 20121,
    county_name: "Miami",
    county_weights: {
      20121: 100,
    },
    county_names_all: "Miami",
    county_fips_all: 20121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66054,
    lat: 39.2055,
    lng: -95.19518,
    city: "McLouth",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2877,
    density: 14.3,
    county_fips: 20087,
    county_name: "Jefferson",
    county_weights: {
      20087: 63.76,
      20103: 36.24,
    },
    county_names_all: "Jefferson|Leavenworth",
    county_fips_all: "20087|20103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66056,
    lat: 38.1509,
    lng: -94.84705,
    city: "Mound City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1335,
    density: 5.7,
    county_fips: 20107,
    county_name: "Linn",
    county_weights: {
      20107: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 20107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66058,
    lat: 39.54018,
    lng: -95.51894,
    city: "Muscotah",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 244,
    density: 2.8,
    county_fips: 20005,
    county_name: "Atchison",
    county_weights: {
      20005: 100,
    },
    county_names_all: "Atchison",
    county_fips_all: 20005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66060,
    lat: 39.41866,
    lng: -95.3325,
    city: "Nortonville",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1364,
    density: 8.8,
    county_fips: 20087,
    county_name: "Jefferson",
    county_weights: {
      20005: 48.42,
      20087: 51.58,
    },
    county_names_all: "Jefferson|Atchison",
    county_fips_all: "20087|20005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66061,
    lat: 38.89633,
    lng: -94.88029,
    city: "Olathe",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65730,
    density: 401,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66062,
    lat: 38.83677,
    lng: -94.78455,
    city: "Olathe",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 82591,
    density: 758,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66064,
    lat: 38.47829,
    lng: -94.98688,
    city: "Osawatomie",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6026,
    density: 31.5,
    county_fips: 20121,
    county_name: "Miami",
    county_weights: {
      20059: 3.48,
      20121: 96.52,
    },
    county_names_all: "Miami|Franklin",
    county_fips_all: "20121|20059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66066,
    lat: 39.20359,
    lng: -95.33142,
    city: "Oskaloosa",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2518,
    density: 12.6,
    county_fips: 20087,
    county_name: "Jefferson",
    county_weights: {
      20087: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 20087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66067,
    lat: 38.61877,
    lng: -95.27566,
    city: "Ottawa",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15518,
    density: 36.5,
    county_fips: 20059,
    county_name: "Franklin",
    county_weights: {
      20059: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 20059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66070,
    lat: 39.21135,
    lng: -95.45132,
    city: "Ozawkie",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2389,
    density: 30.1,
    county_fips: 20087,
    county_name: "Jefferson",
    county_weights: {
      20087: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 20087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66071,
    lat: 38.57367,
    lng: -94.86575,
    city: "Paola",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12675,
    density: 21.3,
    county_fips: 20121,
    county_name: "Miami",
    county_weights: {
      20121: 100,
    },
    county_names_all: "Miami",
    county_fips_all: 20121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66072,
    lat: 38.31772,
    lng: -94.9741,
    city: "Parker",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1357,
    density: 6.9,
    county_fips: 20107,
    county_name: "Linn",
    county_weights: {
      20107: 96.6,
      20121: 3.4,
    },
    county_names_all: "Linn|Miami",
    county_fips_all: "20107|20121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66073,
    lat: 39.09208,
    lng: -95.38144,
    city: "Perry",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2926,
    density: 17.4,
    county_fips: 20087,
    county_name: "Jefferson",
    county_weights: {
      20087: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 20087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66075,
    lat: 38.20362,
    lng: -94.69272,
    city: "Pleasanton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2212,
    density: 8.2,
    county_fips: 20107,
    county_name: "Linn",
    county_weights: {
      20107: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 20107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66076,
    lat: 38.62811,
    lng: -95.43917,
    city: "Pomona",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2388,
    density: 10,
    county_fips: 20059,
    county_name: "Franklin",
    county_weights: {
      20059: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 20059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66078,
    lat: 38.48321,
    lng: -95.2621,
    city: "Princeton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1086,
    density: 6.5,
    county_fips: 20059,
    county_name: "Franklin",
    county_weights: {
      20059: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 20059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66079,
    lat: 38.53828,
    lng: -95.11371,
    city: "Rantoul",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 762,
    density: 7.7,
    county_fips: 20059,
    county_name: "Franklin",
    county_weights: {
      20059: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 20059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66080,
    lat: 38.4053,
    lng: -95.25646,
    city: "Richmond",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 859,
    density: 5.6,
    county_fips: 20059,
    county_name: "Franklin",
    county_weights: {
      20003: 32.48,
      20059: 67.52,
    },
    county_names_all: "Franklin|Anderson",
    county_fips_all: "20059|20003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66083,
    lat: 38.73518,
    lng: -94.83397,
    city: "Spring Hill",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11369,
    density: 70.7,
    county_fips: 20121,
    county_name: "Miami",
    county_weights: {
      20091: 42.36,
      20121: 57.64,
    },
    county_names_all: "Miami|Johnson",
    county_fips_all: "20121|20091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66085,
    lat: 38.80069,
    lng: -94.64729,
    city: "Stilwell",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9780,
    density: 156.1,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66086,
    lat: 39.11578,
    lng: -95.08043,
    city: "Tonganoxie",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10801,
    density: 43.8,
    county_fips: 20103,
    county_name: "Leavenworth",
    county_weights: {
      20087: 1.09,
      20103: 98.91,
    },
    county_names_all: "Leavenworth|Jefferson",
    county_fips_all: "20103|20087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66087,
    lat: 39.80641,
    lng: -95.1378,
    city: "Troy",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1925,
    density: 6.2,
    county_fips: 20043,
    county_name: "Doniphan",
    county_weights: {
      20043: 100,
    },
    county_names_all: "Doniphan",
    county_fips_all: 20043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66088,
    lat: 39.3416,
    lng: -95.4563,
    city: "Valley Falls",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2783,
    density: 9,
    county_fips: 20087,
    county_name: "Jefferson",
    county_weights: {
      20005: 2.95,
      20087: 97.05,
    },
    county_names_all: "Jefferson|Atchison",
    county_fips_all: "20087|20005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66090,
    lat: 39.78391,
    lng: -94.97041,
    city: "Wathena",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2624,
    density: 12.4,
    county_fips: 20043,
    county_name: "Doniphan",
    county_weights: {
      20043: 100,
    },
    county_names_all: "Doniphan",
    county_fips_all: 20043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66091,
    lat: 38.16952,
    lng: -95.32701,
    city: "Welda",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 437,
    density: 2.8,
    county_fips: 20003,
    county_name: "Anderson",
    county_weights: {
      20003: 100,
    },
    county_names_all: "Anderson",
    county_fips_all: 20003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66092,
    lat: 38.69305,
    lng: -95.10548,
    city: "Wellsville",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4116,
    density: 18,
    county_fips: 20059,
    county_name: "Franklin",
    county_weights: {
      20045: 14.59,
      20059: 64.92,
      20121: 20.49,
    },
    county_names_all: "Franklin|Miami|Douglas",
    county_fips_all: "20059|20121|20045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66093,
    lat: 38.21003,
    lng: -95.49771,
    city: "Westphalia",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 724,
    density: 2.5,
    county_fips: 20003,
    county_name: "Anderson",
    county_weights: {
      20003: 60.39,
      20031: 39.61,
    },
    county_names_all: "Anderson|Coffey",
    county_fips_all: "20003|20031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66094,
    lat: 39.95912,
    lng: -95.34298,
    city: "White Cloud",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 325,
    density: 2.6,
    county_fips: 20013,
    county_name: "Brown",
    county_weights: {
      20013: 52.28,
      20043: 47.72,
    },
    county_names_all: "Brown|Doniphan",
    county_fips_all: "20013|20043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66095,
    lat: 38.44631,
    lng: -95.43015,
    city: "Williamsburg",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 944,
    density: 5.1,
    county_fips: 20059,
    county_name: "Franklin",
    county_weights: {
      20003: 7.01,
      20059: 92.99,
    },
    county_names_all: "Franklin|Anderson",
    county_fips_all: "20059|20003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66097,
    lat: 39.32966,
    lng: -95.23992,
    city: "Winchester",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1177,
    density: 9.1,
    county_fips: 20087,
    county_name: "Jefferson",
    county_weights: {
      20087: 95.97,
      20103: 4.03,
    },
    county_names_all: "Jefferson|Leavenworth",
    county_fips_all: "20087|20103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66101,
    lat: 39.11871,
    lng: -94.62592,
    city: "Kansas City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12966,
    density: 1546.9,
    county_fips: 20209,
    county_name: "Wyandotte",
    county_weights: {
      20209: 100,
    },
    county_names_all: "Wyandotte",
    county_fips_all: 20209,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66102,
    lat: 39.11246,
    lng: -94.68842,
    city: "Kansas City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31503,
    density: 1059.2,
    county_fips: 20209,
    county_name: "Wyandotte",
    county_weights: {
      20209: 100,
    },
    county_names_all: "Wyandotte",
    county_fips_all: 20209,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66103,
    lat: 39.06045,
    lng: -94.62707,
    city: "Kansas City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12923,
    density: 1069.2,
    county_fips: 20209,
    county_name: "Wyandotte",
    county_weights: {
      20209: 100,
    },
    county_names_all: "Wyandotte",
    county_fips_all: 20209,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66104,
    lat: 39.15043,
    lng: -94.68861,
    city: "Kansas City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26351,
    density: 629.6,
    county_fips: 20209,
    county_name: "Wyandotte",
    county_weights: {
      20209: 100,
    },
    county_names_all: "Wyandotte",
    county_fips_all: 20209,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66105,
    lat: 39.08593,
    lng: -94.63646,
    city: "Kansas City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2372,
    density: 304.9,
    county_fips: 20209,
    county_name: "Wyandotte",
    county_weights: {
      20209: 100,
    },
    county_names_all: "Wyandotte",
    county_fips_all: 20209,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66106,
    lat: 39.06631,
    lng: -94.70384,
    city: "Kansas City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23212,
    density: 473.1,
    county_fips: 20209,
    county_name: "Wyandotte",
    county_weights: {
      20209: 100,
    },
    county_names_all: "Wyandotte",
    county_fips_all: 20209,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66109,
    lat: 39.16367,
    lng: -94.8283,
    city: "Kansas City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25402,
    density: 213.9,
    county_fips: 20209,
    county_name: "Wyandotte",
    county_weights: {
      20103: 6.67,
      20209: 93.33,
    },
    county_names_all: "Wyandotte|Leavenworth",
    county_fips_all: "20209|20103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66111,
    lat: 39.08529,
    lng: -94.79621,
    city: "Kansas City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10295,
    density: 171.5,
    county_fips: 20209,
    county_name: "Wyandotte",
    county_weights: {
      20209: 100,
    },
    county_names_all: "Wyandotte",
    county_fips_all: 20209,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66112,
    lat: 39.11494,
    lng: -94.7701,
    city: "Kansas City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12521,
    density: 880.3,
    county_fips: 20209,
    county_name: "Wyandotte",
    county_weights: {
      20209: 100,
    },
    county_names_all: "Wyandotte",
    county_fips_all: 20209,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66115,
    lat: 39.14402,
    lng: -94.61104,
    city: "Kansas City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 20209,
    county_name: "Wyandotte",
    county_weights: {
      20209: 100,
    },
    county_names_all: "Wyandotte",
    county_fips_all: 20209,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66118,
    lat: 39.09946,
    lng: -94.61348,
    city: "Kansas City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 20209,
    county_name: "Wyandotte",
    county_weights: {
      20209: 100,
    },
    county_names_all: "Wyandotte",
    county_fips_all: 20209,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66160,
    lat: 39.05576,
    lng: -94.60963,
    city: "Kansas City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 20209,
    county_name: "Wyandotte",
    county_weights: {
      20209: 100,
    },
    county_names_all: "Wyandotte",
    county_fips_all: 20209,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66202,
    lat: 39.02392,
    lng: -94.66909,
    city: "Mission",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16894,
    density: 1239.4,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66203,
    lat: 39.0216,
    lng: -94.70558,
    city: "Shawnee",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18759,
    density: 1156.2,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66204,
    lat: 38.99282,
    lng: -94.67741,
    city: "Overland Park",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18327,
    density: 1429.1,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66205,
    lat: 39.03122,
    lng: -94.6307,
    city: "Mission",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13723,
    density: 1419.4,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66206,
    lat: 38.95851,
    lng: -94.61923,
    city: "Leawood",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11430,
    density: 1093.4,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66207,
    lat: 38.95625,
    lng: -94.64439,
    city: "Overland Park",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14907,
    density: 1259.1,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66208,
    lat: 38.99936,
    lng: -94.62998,
    city: "Prairie Village",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21031,
    density: 1249.1,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66209,
    lat: 38.89874,
    lng: -94.63778,
    city: "Leawood",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20387,
    density: 1220,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66210,
    lat: 38.92372,
    lng: -94.70483,
    city: "Overland Park",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19237,
    density: 1227.2,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66211,
    lat: 38.92422,
    lng: -94.6363,
    city: "Leawood",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5153,
    density: 462.8,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66212,
    lat: 38.9563,
    lng: -94.68154,
    city: "Overland Park",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34347,
    density: 1745,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66213,
    lat: 38.89885,
    lng: -94.70517,
    city: "Overland Park",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28655,
    density: 1415.5,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66214,
    lat: 38.96356,
    lng: -94.71397,
    city: "Overland Park",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11795,
    density: 1181.7,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66215,
    lat: 38.95649,
    lng: -94.74304,
    city: "Lenexa",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25098,
    density: 1192.4,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66216,
    lat: 39.01405,
    lng: -94.74136,
    city: "Shawnee",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24477,
    density: 1197,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 99.73,
      20209: 0.27,
    },
    county_names_all: "Johnson|Wyandotte",
    county_fips_all: "20091|20209",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66217,
    lat: 39.01148,
    lng: -94.77741,
    city: "Shawnee",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6001,
    density: 307.6,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66218,
    lat: 39.01239,
    lng: -94.81647,
    city: "Shawnee",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7416,
    density: 273.2,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66219,
    lat: 38.95124,
    lng: -94.77807,
    city: "Lenexa",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13629,
    density: 635.5,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66220,
    lat: 38.96187,
    lng: -94.8218,
    city: "Lenexa",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7577,
    density: 458.6,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66221,
    lat: 38.84786,
    lng: -94.71437,
    city: "Overland Park",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17601,
    density: 560,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66223,
    lat: 38.86176,
    lng: -94.66831,
    city: "Overland Park",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26639,
    density: 1647.1,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66224,
    lat: 38.86213,
    lng: -94.62866,
    city: "Overland Park",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12659,
    density: 733.2,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66226,
    lat: 39.03039,
    lng: -94.8603,
    city: "Shawnee",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15341,
    density: 513.9,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66227,
    lat: 38.97248,
    lng: -94.87446,
    city: "Lenexa",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7327,
    density: 212.3,
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66251,
    lat: 38.91712,
    lng: -94.65891,
    city: "Overland Park",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 20091,
    county_name: "Johnson",
    county_weights: {
      20091: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 20091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66401,
    lat: 38.96894,
    lng: -96.30539,
    city: "Alma",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1644,
    density: 2.6,
    county_fips: 20197,
    county_name: "Wabaunsee",
    county_weights: {
      20197: 100,
    },
    county_names_all: "Wabaunsee",
    county_fips_all: 20197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66402,
    lat: 38.91782,
    lng: -95.84926,
    city: "Auburn",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3008,
    density: 25.9,
    county_fips: 20177,
    county_name: "Shawnee",
    county_weights: {
      20139: 2.72,
      20177: 97.28,
    },
    county_names_all: "Shawnee|Osage",
    county_fips_all: "20177|20139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66403,
    lat: 39.89424,
    lng: -96.27166,
    city: "Axtell",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 931,
    density: 4.1,
    county_fips: 20117,
    county_name: "Marshall",
    county_weights: {
      20117: 75.25,
      20131: 24.75,
    },
    county_names_all: "Marshall|Nemaha",
    county_fips_all: "20117|20131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66404,
    lat: 39.86786,
    lng: -96.17804,
    city: "Baileyville",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 481,
    density: 3,
    county_fips: 20131,
    county_name: "Nemaha",
    county_weights: {
      20117: 1.91,
      20131: 98.09,
    },
    county_names_all: "Nemaha|Marshall",
    county_fips_all: "20131|20117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66406,
    lat: 39.8927,
    lng: -96.42014,
    city: "Beattie",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 424,
    density: 2.7,
    county_fips: 20117,
    county_name: "Marshall",
    county_weights: {
      20117: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 20117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66407,
    lat: 39.22517,
    lng: -96.19218,
    city: "Belvue",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 244,
    density: 1.7,
    county_fips: 20149,
    county_name: "Pottawatomie",
    county_weights: {
      20149: 59.05,
      20197: 40.95,
    },
    county_names_all: "Pottawatomie|Wabaunsee",
    county_fips_all: "20149|20197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66408,
    lat: 39.95306,
    lng: -95.97607,
    city: "Bern",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 396,
    density: 2.8,
    county_fips: 20131,
    county_name: "Nemaha",
    county_weights: {
      20131: 100,
    },
    county_names_all: "Nemaha",
    county_fips_all: 20131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66409,
    lat: 38.92508,
    lng: -95.55589,
    city: "Berryton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3339,
    density: 18.6,
    county_fips: 20177,
    county_name: "Shawnee",
    county_weights: {
      20045: 24.19,
      20139: 2.25,
      20177: 73.56,
    },
    county_names_all: "Shawnee|Douglas|Osage",
    county_fips_all: "20177|20045|20139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66411,
    lat: 39.64083,
    lng: -96.63948,
    city: "Blue Rapids",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1280,
    density: 4.3,
    county_fips: 20117,
    county_name: "Marshall",
    county_weights: {
      20117: 83.9,
      20161: 16.1,
    },
    county_names_all: "Marshall|Riley",
    county_fips_all: "20117|20161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66412,
    lat: 39.90837,
    lng: -96.77794,
    city: "Bremen",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 142,
    density: 1.1,
    county_fips: 20117,
    county_name: "Marshall",
    county_weights: {
      20117: 83.61,
      20201: 16.39,
    },
    county_names_all: "Marshall|Washington",
    county_fips_all: "20117|20201",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66413,
    lat: 38.77375,
    lng: -95.88305,
    city: "Burlingame",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1792,
    density: 6.8,
    county_fips: 20139,
    county_name: "Osage",
    county_weights: {
      20111: 8.05,
      20139: 88.32,
      20197: 3.63,
    },
    county_names_all: "Osage|Lyon|Wabaunsee",
    county_fips_all: "20139|20111|20197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66414,
    lat: 38.82631,
    lng: -95.68563,
    city: "Carbondale",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2742,
    density: 17,
    county_fips: 20139,
    county_name: "Osage",
    county_weights: {
      20139: 100,
    },
    county_names_all: "Osage",
    county_fips_all: 20139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66415,
    lat: 39.69193,
    lng: -96.14381,
    city: "Centralia",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 829,
    density: 3.5,
    county_fips: 20131,
    county_name: "Nemaha",
    county_weights: {
      20131: 100,
    },
    county_names_all: "Nemaha",
    county_fips_all: 20131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66416,
    lat: 39.52944,
    lng: -95.86353,
    city: "Circleville",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 497,
    density: 5.5,
    county_fips: 20085,
    county_name: "Jackson",
    county_weights: {
      20085: 90.73,
      20131: 9.27,
    },
    county_names_all: "Jackson|Nemaha",
    county_fips_all: "20085|20131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66417,
    lat: 39.65524,
    lng: -96.03824,
    city: "Corning",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 375,
    density: 3.5,
    county_fips: 20131,
    county_name: "Nemaha",
    county_weights: {
      20131: 100,
    },
    county_names_all: "Nemaha",
    county_fips_all: 20131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66418,
    lat: 39.28861,
    lng: -95.93528,
    city: "Delia",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 494,
    density: 2.6,
    county_fips: 20085,
    county_name: "Jackson",
    county_weights: {
      20085: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 20085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66419,
    lat: 39.35643,
    lng: -95.59908,
    city: "Denison",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 291,
    density: 5.6,
    county_fips: 20085,
    county_name: "Jackson",
    county_weights: {
      20085: 69.69,
      20087: 30.31,
    },
    county_names_all: "Jackson|Jefferson",
    county_fips_all: "20085|20087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66422,
    lat: 39.33317,
    lng: -96.08496,
    city: "Emmett",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1031,
    density: 7.1,
    county_fips: 20149,
    county_name: "Pottawatomie",
    county_weights: {
      20085: 22.8,
      20149: 77.2,
    },
    county_names_all: "Pottawatomie|Jackson",
    county_fips_all: "20149|20085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66423,
    lat: 38.8492,
    lng: -96.12934,
    city: "Eskridge",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1061,
    density: 2.7,
    county_fips: 20197,
    county_name: "Wabaunsee",
    county_weights: {
      20197: 100,
    },
    county_names_all: "Wabaunsee",
    county_fips_all: 20197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66424,
    lat: 39.67789,
    lng: -95.40072,
    city: "Everest",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 481,
    density: 3.5,
    county_fips: 20013,
    county_name: "Brown",
    county_weights: {
      20005: 31.86,
      20013: 68.14,
    },
    county_names_all: "Brown|Atchison",
    county_fips_all: "20013|20005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66425,
    lat: 39.81099,
    lng: -95.72225,
    city: "Fairview",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 437,
    density: 3.9,
    county_fips: 20013,
    county_name: "Brown",
    county_weights: {
      20013: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 20013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66427,
    lat: 39.66261,
    lng: -96.449,
    city: "Frankfort",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1051,
    density: 1.9,
    county_fips: 20117,
    county_name: "Marshall",
    county_weights: {
      20117: 89.85,
      20149: 10.15,
    },
    county_names_all: "Marshall|Pottawatomie",
    county_fips_all: "20117|20149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66428,
    lat: 39.67687,
    lng: -95.92504,
    city: "Goff",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 232,
    density: 1.1,
    county_fips: 20131,
    county_name: "Nemaha",
    county_weights: {
      20131: 100,
    },
    county_names_all: "Nemaha",
    county_fips_all: 20131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66429,
    lat: 39.0989,
    lng: -95.53725,
    city: "Grantville",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 465,
    density: 14,
    county_fips: 20087,
    county_name: "Jefferson",
    county_weights: {
      20087: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 20087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66431,
    lat: 38.80851,
    lng: -96.00241,
    city: "Harveyville",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 536,
    density: 3.4,
    county_fips: 20197,
    county_name: "Wabaunsee",
    county_weights: {
      20177: 8.35,
      20197: 91.65,
    },
    county_names_all: "Wabaunsee|Shawnee",
    county_fips_all: "20197|20177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66432,
    lat: 39.48768,
    lng: -96.07348,
    city: "Havensville",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 305,
    density: 1.7,
    county_fips: 20149,
    county_name: "Pottawatomie",
    county_weights: {
      20085: 11.84,
      20131: 11.26,
      20149: 76.9,
    },
    county_names_all: "Pottawatomie|Jackson|Nemaha",
    county_fips_all: "20149|20085|20131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66434,
    lat: 39.86731,
    lng: -95.54679,
    city: "Hiawatha",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4594,
    density: 8.1,
    county_fips: 20013,
    county_name: "Brown",
    county_weights: {
      20013: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 20013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66436,
    lat: 39.4655,
    lng: -95.70278,
    city: "Holton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6158,
    density: 12.9,
    county_fips: 20085,
    county_name: "Jackson",
    county_weights: {
      20005: 13.76,
      20085: 84.87,
      20087: 1.37,
    },
    county_names_all: "Jackson|Atchison|Jefferson",
    county_fips_all: "20085|20005|20087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66438,
    lat: 39.83335,
    lng: -96.50165,
    city: "Home",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 129,
    density: 1.4,
    county_fips: 20117,
    county_name: "Marshall",
    county_weights: {
      20117: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 20117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66439,
    lat: 39.65518,
    lng: -95.54327,
    city: "Horton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2685,
    density: 11.9,
    county_fips: 20013,
    county_name: "Brown",
    county_weights: {
      20005: 38.5,
      20013: 57.77,
      20085: 3.73,
    },
    county_names_all: "Brown|Atchison|Jackson",
    county_fips_all: "20013|20005|20085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66440,
    lat: 39.26326,
    lng: -95.68168,
    city: "Hoyt",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1730,
    density: 14,
    county_fips: 20085,
    county_name: "Jackson",
    county_weights: {
      20085: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 20085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66441,
    lat: 38.98199,
    lng: -96.80289,
    city: "Junction City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25532,
    density: 42.5,
    county_fips: 20061,
    county_name: "Geary",
    county_weights: {
      20041: 4.73,
      20061: 93.84,
      20161: 1.43,
    },
    county_names_all: "Geary|Dickinson|Riley",
    county_fips_all: "20061|20041|20161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66442,
    lat: 39.09302,
    lng: -96.78963,
    city: "Fort Riley",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14629,
    density: 166.2,
    county_fips: 20161,
    county_name: "Riley",
    county_weights: {
      20061: 39.48,
      20161: 60.52,
    },
    county_names_all: "Riley|Geary",
    county_fips_all: "20161|20061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66449,
    lat: 39.38833,
    lng: -96.86007,
    city: "Leonardville",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1150,
    density: 6.7,
    county_fips: 20161,
    county_name: "Riley",
    county_weights: {
      20161: 100,
    },
    county_names_all: "Riley",
    county_fips_all: 20161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66451,
    lat: 38.60841,
    lng: -95.67236,
    city: "Lyndon",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1656,
    density: 8.2,
    county_fips: 20139,
    county_name: "Osage",
    county_weights: {
      20139: 100,
    },
    county_names_all: "Osage",
    county_fips_all: 20139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66501,
    lat: 39.05279,
    lng: -96.23688,
    city: "McFarland",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 363,
    density: 402.5,
    county_fips: 20197,
    county_name: "Wabaunsee",
    county_weights: {
      20197: 100,
    },
    county_names_all: "Wabaunsee",
    county_fips_all: 20197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66502,
    lat: 39.14146,
    lng: -96.52906,
    city: "Manhattan",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44036,
    density: 76.7,
    county_fips: 20161,
    county_name: "Riley",
    county_weights: {
      20061: 15.37,
      20149: 20.74,
      20161: 60.12,
      20197: 3.77,
    },
    county_names_all: "Riley|Pottawatomie|Geary|Wabaunsee",
    county_fips_all: "20161|20149|20061|20197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66503,
    lat: 39.26287,
    lng: -96.68663,
    city: "Manhattan",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16840,
    density: 78.2,
    county_fips: 20161,
    county_name: "Riley",
    county_weights: {
      20161: 100,
    },
    county_names_all: "Riley",
    county_fips_all: 20161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66506,
    lat: 39.19596,
    lng: -96.58148,
    city: "Manhattan",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3521,
    density: 1921.4,
    county_fips: 20161,
    county_name: "Riley",
    county_weights: {
      20161: 100,
    },
    county_names_all: "Riley",
    county_fips_all: 20161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66507,
    lat: 39.04712,
    lng: -96.03942,
    city: "Maple Hill",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1205,
    density: 5,
    county_fips: 20197,
    county_name: "Wabaunsee",
    county_weights: {
      20197: 100,
    },
    county_names_all: "Wabaunsee",
    county_fips_all: 20197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66508,
    lat: 39.85803,
    lng: -96.64287,
    city: "Marysville",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4314,
    density: 9.4,
    county_fips: 20117,
    county_name: "Marshall",
    county_weights: {
      20117: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 20117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66509,
    lat: 39.33239,
    lng: -95.78097,
    city: "Mayetta",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2758,
    density: 8.4,
    county_fips: 20085,
    county_name: "Jackson",
    county_weights: {
      20085: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 20085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66510,
    lat: 38.49297,
    lng: -95.6104,
    city: "Melvern",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 710,
    density: 4.6,
    county_fips: 20139,
    county_name: "Osage",
    county_weights: {
      20139: 100,
    },
    county_names_all: "Osage",
    county_fips_all: 20139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66512,
    lat: 39.20255,
    lng: -95.54701,
    city: "Meriden",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2735,
    density: 15.8,
    county_fips: 20087,
    county_name: "Jefferson",
    county_weights: {
      20085: 11.12,
      20087: 84.11,
      20177: 4.77,
    },
    county_names_all: "Jefferson|Jackson|Shawnee",
    county_fips_all: "20087|20085|20177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66514,
    lat: 39.12635,
    lng: -96.87826,
    city: "Milford",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1435,
    density: 33,
    county_fips: 20061,
    county_name: "Geary",
    county_weights: {
      20061: 100,
    },
    county_names_all: "Geary",
    county_fips_all: 20061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66515,
    lat: 39.94181,
    lng: -95.70681,
    city: "Morrill",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 452,
    density: 5,
    county_fips: 20013,
    county_name: "Brown",
    county_weights: {
      20013: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 20013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66516,
    lat: 39.62193,
    lng: -95.7195,
    city: "Netawaka",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 292,
    density: 2.3,
    county_fips: 20085,
    county_name: "Jackson",
    county_weights: {
      20013: 29.63,
      20085: 70.37,
    },
    county_names_all: "Jackson|Brown",
    county_fips_all: "20085|20013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66517,
    lat: 39.11253,
    lng: -96.70465,
    city: "Ogden",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1475,
    density: 311,
    county_fips: 20161,
    county_name: "Riley",
    county_weights: {
      20161: 100,
    },
    county_names_all: "Riley",
    county_fips_all: 20161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66518,
    lat: 39.97008,
    lng: -96.55533,
    city: "Oketo",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 167,
    density: 1.6,
    county_fips: 20117,
    county_name: "Marshall",
    county_weights: {
      20117: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 20117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66520,
    lat: 39.40963,
    lng: -96.61617,
    city: "Olsburg",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 649,
    density: 2.4,
    county_fips: 20149,
    county_name: "Pottawatomie",
    county_weights: {
      20149: 100,
    },
    county_names_all: "Pottawatomie",
    county_fips_all: 20149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66521,
    lat: 39.47668,
    lng: -96.22128,
    city: "Onaga",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1609,
    density: 3.5,
    county_fips: 20149,
    county_name: "Pottawatomie",
    county_weights: {
      20131: 8.41,
      20149: 91.59,
    },
    county_names_all: "Pottawatomie|Nemaha",
    county_fips_all: "20149|20131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66522,
    lat: 39.86609,
    lng: -95.93826,
    city: "Oneida",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 222,
    density: 663.2,
    county_fips: 20131,
    county_name: "Nemaha",
    county_weights: {
      20131: 100,
    },
    county_names_all: "Nemaha",
    county_fips_all: 20131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66523,
    lat: 38.60993,
    lng: -95.83791,
    city: "Osage City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3664,
    density: 9.2,
    county_fips: 20139,
    county_name: "Osage",
    county_weights: {
      20111: 3.73,
      20139: 96.27,
    },
    county_names_all: "Osage|Lyon",
    county_fips_all: "20139|20111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66524,
    lat: 38.78948,
    lng: -95.50695,
    city: "Overbrook",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2070,
    density: 6.1,
    county_fips: 20139,
    county_name: "Osage",
    county_weights: {
      20045: 44.18,
      20059: 2.29,
      20139: 50.48,
      20177: 3.05,
    },
    county_names_all: "Osage|Douglas|Shawnee|Franklin",
    county_fips_all: "20139|20045|20177|20059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66526,
    lat: 39.06349,
    lng: -96.15567,
    city: "Paxico",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 818,
    density: 4.5,
    county_fips: 20197,
    county_name: "Wabaunsee",
    county_weights: {
      20197: 100,
    },
    county_names_all: "Wabaunsee",
    county_fips_all: 20197,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66527,
    lat: 39.74499,
    lng: -95.67744,
    city: "Powhattan",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 271,
    density: 2.7,
    county_fips: 20013,
    county_name: "Brown",
    county_weights: {
      20013: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 20013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66528,
    lat: 38.59711,
    lng: -95.5344,
    city: "Quenemo",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 733,
    density: 4.2,
    county_fips: 20139,
    county_name: "Osage",
    county_weights: {
      20059: 17.99,
      20139: 82.01,
    },
    county_names_all: "Osage|Franklin",
    county_fips_all: "20139|20059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66531,
    lat: 39.31146,
    lng: -96.83416,
    city: "Riley",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1862,
    density: 20.4,
    county_fips: 20161,
    county_name: "Riley",
    county_weights: {
      20161: 100,
    },
    county_names_all: "Riley",
    county_fips_all: 20161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66532,
    lat: 39.82656,
    lng: -95.37597,
    city: "Robinson",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 740,
    density: 3.3,
    county_fips: 20013,
    county_name: "Brown",
    county_weights: {
      20013: 78.6,
      20043: 21.4,
    },
    county_names_all: "Brown|Doniphan",
    county_fips_all: "20013|20043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66533,
    lat: 39.16097,
    lng: -95.95045,
    city: "Rossville",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1610,
    density: 11.6,
    county_fips: 20177,
    county_name: "Shawnee",
    county_weights: {
      20085: 3.8,
      20177: 96.2,
    },
    county_names_all: "Shawnee|Jackson",
    county_fips_all: "20177|20085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66534,
    lat: 39.87782,
    lng: -95.83635,
    city: "Sabetha",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3912,
    density: 10.3,
    county_fips: 20131,
    county_name: "Nemaha",
    county_weights: {
      20013: 20,
      20131: 80,
    },
    county_names_all: "Nemaha|Brown",
    county_fips_all: "20131|20013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66535,
    lat: 39.26169,
    lng: -96.43896,
    city: "Saint George",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2933,
    density: 27.1,
    county_fips: 20149,
    county_name: "Pottawatomie",
    county_weights: {
      20149: 100,
    },
    county_names_all: "Pottawatomie",
    county_fips_all: 20149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66536,
    lat: 39.2247,
    lng: -96.07396,
    city: "Saint Marys",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4276,
    density: 25.2,
    county_fips: 20149,
    county_name: "Pottawatomie",
    county_weights: {
      20085: 8.26,
      20149: 74.1,
      20177: 10.36,
      20197: 7.28,
    },
    county_names_all: "Pottawatomie|Shawnee|Jackson|Wabaunsee",
    county_fips_all: "20149|20177|20085|20197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66537,
    lat: 38.75118,
    lng: -95.72255,
    city: "Scranton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1307,
    density: 9.5,
    county_fips: 20139,
    county_name: "Osage",
    county_weights: {
      20139: 100,
    },
    county_names_all: "Osage",
    county_fips_all: 20139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66538,
    lat: 39.84942,
    lng: -96.04591,
    city: "Seneca",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3096,
    density: 8.7,
    county_fips: 20131,
    county_name: "Nemaha",
    county_weights: {
      20131: 100,
    },
    county_names_all: "Nemaha",
    county_fips_all: 20131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66539,
    lat: 39.14937,
    lng: -95.84707,
    city: "Silver Lake",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2535,
    density: 23.6,
    county_fips: 20177,
    county_name: "Shawnee",
    county_weights: {
      20085: 3.61,
      20177: 96.39,
    },
    county_names_all: "Shawnee|Jackson",
    county_fips_all: "20177|20085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66540,
    lat: 39.48484,
    lng: -95.97332,
    city: "Soldier",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 567,
    density: 2.5,
    county_fips: 20085,
    county_name: "Jackson",
    county_weights: {
      20085: 86.8,
      20131: 12.64,
      20149: 0.56,
    },
    county_names_all: "Jackson|Nemaha|Pottawatomie",
    county_fips_all: "20085|20131|20149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66541,
    lat: 39.97891,
    lng: -96.34781,
    city: "Summerfield",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 178,
    density: 1.4,
    county_fips: 20117,
    county_name: "Marshall",
    county_weights: {
      20117: 71.72,
      31133: 28.28,
    },
    county_names_all: "Marshall|Pawnee",
    county_fips_all: "20117|31133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66542,
    lat: 39.01273,
    lng: -95.54442,
    city: "Tecumseh",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3024,
    density: 36,
    county_fips: 20177,
    county_name: "Shawnee",
    county_weights: {
      20177: 100,
    },
    county_names_all: "Shawnee",
    county_fips_all: 20177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66543,
    lat: 38.64175,
    lng: -95.60029,
    city: "Vassar",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1133,
    density: 49.3,
    county_fips: 20139,
    county_name: "Osage",
    county_weights: {
      20139: 100,
    },
    county_names_all: "Osage",
    county_fips_all: 20139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66544,
    lat: 39.68807,
    lng: -96.27783,
    city: "Vermillion",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 351,
    density: 1.5,
    county_fips: 20117,
    county_name: "Marshall",
    county_weights: {
      20117: 84.03,
      20131: 15.97,
    },
    county_names_all: "Marshall|Nemaha",
    county_fips_all: "20117|20131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66546,
    lat: 38.8941,
    lng: -95.72589,
    city: "Wakarusa",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1019,
    density: 10.3,
    county_fips: 20177,
    county_name: "Shawnee",
    county_weights: {
      20139: 8.59,
      20177: 91.41,
    },
    county_names_all: "Shawnee|Osage",
    county_fips_all: "20177|20139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66547,
    lat: 39.23469,
    lng: -96.30384,
    city: "Wamego",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8794,
    density: 25.5,
    county_fips: 20149,
    county_name: "Pottawatomie",
    county_weights: {
      20149: 77.06,
      20197: 22.94,
    },
    county_names_all: "Pottawatomie|Wabaunsee",
    county_fips_all: "20149|20197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66548,
    lat: 39.67551,
    lng: -96.76146,
    city: "Waterville",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 876,
    density: 4.2,
    county_fips: 20117,
    county_name: "Marshall",
    county_weights: {
      20117: 95.17,
      20161: 2.34,
      20201: 2.49,
    },
    county_names_all: "Marshall|Washington|Riley",
    county_fips_all: "20117|20201|20161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66549,
    lat: 39.42978,
    lng: -96.43045,
    city: "Westmoreland",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1697,
    density: 3.6,
    county_fips: 20149,
    county_name: "Pottawatomie",
    county_weights: {
      20149: 100,
    },
    county_names_all: "Pottawatomie",
    county_fips_all: 20149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66550,
    lat: 39.65537,
    lng: -95.82113,
    city: "Wetmore",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 594,
    density: 3.4,
    county_fips: 20131,
    county_name: "Nemaha",
    county_weights: {
      20013: 10.32,
      20085: 10.93,
      20131: 78.75,
    },
    county_names_all: "Nemaha|Jackson|Brown",
    county_fips_all: "20131|20085|20013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66552,
    lat: 39.58736,
    lng: -95.621,
    city: "Whiting",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 419,
    density: 3.4,
    county_fips: 20085,
    county_name: "Jackson",
    county_weights: {
      20085: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 20085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66554,
    lat: 39.48899,
    lng: -96.78445,
    city: "Randolph",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 613,
    density: 2.3,
    county_fips: 20161,
    county_name: "Riley",
    county_weights: {
      20161: 100,
    },
    county_names_all: "Riley",
    county_fips_all: 20161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66603,
    lat: 39.05742,
    lng: -95.67539,
    city: "Topeka",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1294,
    density: 558.7,
    county_fips: 20177,
    county_name: "Shawnee",
    county_weights: {
      20177: 100,
    },
    county_names_all: "Shawnee",
    county_fips_all: 20177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66604,
    lat: 39.03875,
    lng: -95.72623,
    city: "Topeka",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21985,
    density: 1255.9,
    county_fips: 20177,
    county_name: "Shawnee",
    county_weights: {
      20177: 100,
    },
    county_names_all: "Shawnee",
    county_fips_all: 20177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66605,
    lat: 39.01167,
    lng: -95.63283,
    city: "Topeka",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20447,
    density: 789.3,
    county_fips: 20177,
    county_name: "Shawnee",
    county_weights: {
      20177: 100,
    },
    county_names_all: "Shawnee",
    county_fips_all: 20177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66606,
    lat: 39.06191,
    lng: -95.72296,
    city: "Topeka",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10178,
    density: 682,
    county_fips: 20177,
    county_name: "Shawnee",
    county_weights: {
      20177: 100,
    },
    county_names_all: "Shawnee",
    county_fips_all: 20177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66607,
    lat: 39.0422,
    lng: -95.63502,
    city: "Topeka",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10099,
    density: 558.3,
    county_fips: 20177,
    county_name: "Shawnee",
    county_weights: {
      20177: 100,
    },
    county_names_all: "Shawnee",
    county_fips_all: 20177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66608,
    lat: 39.07984,
    lng: -95.66708,
    city: "Topeka",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5168,
    density: 459,
    county_fips: 20177,
    county_name: "Shawnee",
    county_weights: {
      20177: 100,
    },
    county_names_all: "Shawnee",
    county_fips_all: 20177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66609,
    lat: 38.98193,
    lng: -95.66974,
    city: "Topeka",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6606,
    density: 203.4,
    county_fips: 20177,
    county_name: "Shawnee",
    county_weights: {
      20177: 100,
    },
    county_names_all: "Shawnee",
    county_fips_all: 20177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66610,
    lat: 38.97277,
    lng: -95.84718,
    city: "Topeka",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11154,
    density: 97.7,
    county_fips: 20177,
    county_name: "Shawnee",
    county_weights: {
      20177: 92.35,
      20197: 7.65,
    },
    county_names_all: "Shawnee|Wabaunsee",
    county_fips_all: "20177|20197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66611,
    lat: 39.01526,
    lng: -95.69601,
    city: "Topeka",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10411,
    density: 1215.9,
    county_fips: 20177,
    county_name: "Shawnee",
    county_weights: {
      20177: 100,
    },
    county_names_all: "Shawnee",
    county_fips_all: 20177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66612,
    lat: 39.04026,
    lng: -95.68037,
    city: "Topeka",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1880,
    density: 681.7,
    county_fips: 20177,
    county_name: "Shawnee",
    county_weights: {
      20177: 100,
    },
    county_names_all: "Shawnee",
    county_fips_all: 20177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66614,
    lat: 39.01362,
    lng: -95.84115,
    city: "Topeka",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32386,
    density: 519.6,
    county_fips: 20177,
    county_name: "Shawnee",
    county_weights: {
      20177: 83.86,
      20197: 16.14,
    },
    county_names_all: "Shawnee|Wabaunsee",
    county_fips_all: "20177|20197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66615,
    lat: 39.05214,
    lng: -95.89491,
    city: "Topeka",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3051,
    density: 26.2,
    county_fips: 20177,
    county_name: "Shawnee",
    county_weights: {
      20177: 77.98,
      20197: 22.02,
    },
    county_names_all: "Shawnee|Wabaunsee",
    county_fips_all: "20177|20197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66616,
    lat: 39.06845,
    lng: -95.62388,
    city: "Topeka",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5567,
    density: 351.4,
    county_fips: 20177,
    county_name: "Shawnee",
    county_weights: {
      20177: 100,
    },
    county_names_all: "Shawnee",
    county_fips_all: 20177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66617,
    lat: 39.13876,
    lng: -95.625,
    city: "Topeka",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8880,
    density: 79.1,
    county_fips: 20177,
    county_name: "Shawnee",
    county_weights: {
      20085: 1.18,
      20087: 17.09,
      20177: 81.73,
    },
    county_names_all: "Shawnee|Jefferson|Jackson",
    county_fips_all: "20177|20087|20085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66618,
    lat: 39.14188,
    lng: -95.74997,
    city: "Topeka",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10278,
    density: 54.5,
    county_fips: 20177,
    county_name: "Shawnee",
    county_weights: {
      20177: 100,
    },
    county_names_all: "Shawnee",
    county_fips_all: 20177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66619,
    lat: 38.94661,
    lng: -95.68993,
    city: "Topeka",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3112,
    density: 141.8,
    county_fips: 20177,
    county_name: "Shawnee",
    county_weights: {
      20177: 100,
    },
    county_names_all: "Shawnee",
    county_fips_all: 20177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66621,
    lat: 39.03313,
    lng: -95.70237,
    city: "Topeka",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 653,
    density: 1249.2,
    county_fips: 20177,
    county_name: "Shawnee",
    county_weights: {
      20177: 100,
    },
    county_names_all: "Shawnee",
    county_fips_all: 20177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66622,
    lat: 39.02631,
    lng: -95.72231,
    city: "Topeka",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 102,
    density: 321.7,
    county_fips: 20177,
    county_name: "Shawnee",
    county_weights: {
      20177: 100,
    },
    county_names_all: "Shawnee",
    county_fips_all: 20177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66701,
    lat: 37.82862,
    lng: -94.75999,
    city: "Fort Scott",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11967,
    density: 16.2,
    county_fips: 20011,
    county_name: "Bourbon",
    county_weights: {
      20011: 97.78,
      20037: 2.22,
    },
    county_names_all: "Bourbon|Crawford",
    county_fips_all: "20011|20037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66710,
    lat: 37.55301,
    lng: -95.63104,
    city: "Altoona",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 505,
    density: 3.2,
    county_fips: 20205,
    county_name: "Wilson",
    county_weights: {
      20205: 100,
    },
    county_names_all: "Wilson",
    county_fips_all: 20205,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66711,
    lat: 37.63974,
    lng: -94.691,
    city: "Arcadia",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 564,
    density: 4.1,
    county_fips: 20037,
    county_name: "Crawford",
    county_weights: {
      20011: 11.47,
      20037: 88.53,
    },
    county_names_all: "Crawford|Bourbon",
    county_fips_all: "20037|20011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66712,
    lat: 37.5636,
    lng: -94.71657,
    city: "Arma",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1763,
    density: 30.6,
    county_fips: 20037,
    county_name: "Crawford",
    county_weights: {
      20037: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 20037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66713,
    lat: 37.03323,
    lng: -94.78637,
    city: "Baxter Springs",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5398,
    density: 35.3,
    county_fips: 20021,
    county_name: "Cherokee",
    county_weights: {
      20021: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 20021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66714,
    lat: 37.63369,
    lng: -95.70484,
    city: "Benedict",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 222,
    density: 2.6,
    county_fips: 20205,
    county_name: "Wilson",
    county_weights: {
      20205: 100,
    },
    county_names_all: "Wilson",
    county_fips_all: 20205,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66716,
    lat: 37.93923,
    lng: -95.04001,
    city: "Bronson",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 435,
    density: 2,
    county_fips: 20011,
    county_name: "Bourbon",
    county_weights: {
      20001: 16.67,
      20011: 83.33,
    },
    county_names_all: "Bourbon|Allen",
    county_fips_all: "20011|20001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66717,
    lat: 37.69671,
    lng: -95.68672,
    city: "Buffalo",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 611,
    density: 5.4,
    county_fips: 20205,
    county_name: "Wilson",
    county_weights: {
      20205: 99.39,
      20207: 0.61,
    },
    county_names_all: "Wilson|Woodson",
    county_fips_all: "20205|20207",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66720,
    lat: 37.64631,
    lng: -95.459,
    city: "Chanute",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11174,
    density: 21.7,
    county_fips: 20133,
    county_name: "Neosho",
    county_weights: {
      20001: 3.03,
      20133: 71.58,
      20205: 24.14,
      20207: 1.25,
    },
    county_names_all: "Neosho|Wilson|Allen|Woodson",
    county_fips_all: "20133|20205|20001|20207",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66724,
    lat: 37.34891,
    lng: -94.86333,
    city: "Cherokee",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 916,
    density: 10.1,
    county_fips: 20037,
    county_name: "Crawford",
    county_weights: {
      20021: 36.89,
      20037: 63.11,
    },
    county_names_all: "Crawford|Cherokee",
    county_fips_all: "20037|20021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66725,
    lat: 37.15906,
    lng: -94.88892,
    city: "Columbus",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5803,
    density: 9.8,
    county_fips: 20021,
    county_name: "Cherokee",
    county_weights: {
      20021: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 20021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66732,
    lat: 37.80097,
    lng: -95.1947,
    city: "Elsmore",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 271,
    density: 2.5,
    county_fips: 20001,
    county_name: "Allen",
    county_weights: {
      20001: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 20001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66733,
    lat: 37.59014,
    lng: -95.25282,
    city: "Erie",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2292,
    density: 6.4,
    county_fips: 20133,
    county_name: "Neosho",
    county_weights: {
      20133: 100,
    },
    county_names_all: "Neosho",
    county_fips_all: 20133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66734,
    lat: 37.61534,
    lng: -94.82172,
    city: "Farlington",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 165,
    density: 2,
    county_fips: 20037,
    county_name: "Crawford",
    county_weights: {
      20037: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 20037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66735,
    lat: 37.52091,
    lng: -94.71313,
    city: "Franklin",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 617,
    density: 51.8,
    county_fips: 20037,
    county_name: "Crawford",
    county_weights: {
      20037: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 20037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66736,
    lat: 37.55335,
    lng: -95.86381,
    city: "Fredonia",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3670,
    density: 5.2,
    county_fips: 20205,
    county_name: "Wilson",
    county_weights: {
      20049: 9.95,
      20073: 0.54,
      20125: 0.53,
      20205: 88.16,
      20207: 0.82,
    },
    county_names_all: "Wilson|Elk|Woodson|Greenwood|Montgomery",
    county_fips_all: "20205|20049|20207|20073|20125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66738,
    lat: 38.01473,
    lng: -94.7162,
    city: "Fulton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 269,
    density: 2.5,
    county_fips: 20011,
    county_name: "Bourbon",
    county_weights: {
      20011: 86.05,
      20107: 13.95,
    },
    county_names_all: "Bourbon|Linn",
    county_fips_all: "20011|20107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66739,
    lat: 37.12084,
    lng: -94.66595,
    city: "Galena",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5365,
    density: 29.5,
    county_fips: 20021,
    county_name: "Cherokee",
    county_weights: {
      20021: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 20021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66740,
    lat: 37.4621,
    lng: -95.36641,
    city: "Galesburg",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 317,
    density: 3.3,
    county_fips: 20133,
    county_name: "Neosho",
    county_weights: {
      20133: 100,
    },
    county_names_all: "Neosho",
    county_fips_all: 20133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66741,
    lat: 37.71745,
    lng: -94.66467,
    city: "Garland",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 152,
    density: 2.7,
    county_fips: 20011,
    county_name: "Bourbon",
    county_weights: {
      20011: 100,
    },
    county_names_all: "Bourbon",
    county_fips_all: 20011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66742,
    lat: 37.92023,
    lng: -95.34755,
    city: "Gas",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 20001,
    county_name: "Allen",
    county_weights: {
      20001: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 20001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66743,
    lat: 37.50551,
    lng: -94.88786,
    city: "Girard",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4420,
    density: 11.8,
    county_fips: 20037,
    county_name: "Crawford",
    county_weights: {
      20037: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 20037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66746,
    lat: 37.6708,
    lng: -94.95317,
    city: "Hepler",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 196,
    density: 1.4,
    county_fips: 20037,
    county_name: "Crawford",
    county_weights: {
      20011: 42.93,
      20037: 57.07,
    },
    county_names_all: "Crawford|Bourbon",
    county_fips_all: "20037|20011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66748,
    lat: 37.79882,
    lng: -95.43577,
    city: "Humboldt",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3057,
    density: 10.3,
    county_fips: 20001,
    county_name: "Allen",
    county_weights: {
      20001: 81.48,
      20133: 2.93,
      20207: 15.59,
    },
    county_names_all: "Allen|Woodson|Neosho",
    county_fips_all: "20001|20207|20133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66749,
    lat: 37.93597,
    lng: -95.41069,
    city: "Iola",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7272,
    density: 25.7,
    county_fips: 20001,
    county_name: "Allen",
    county_weights: {
      20001: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 20001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66751,
    lat: 37.93421,
    lng: -95.28466,
    city: "La Harpe",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 612,
    density: 4.8,
    county_fips: 20001,
    county_name: "Allen",
    county_weights: {
      20001: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 20001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66753,
    lat: 37.36529,
    lng: -95.01444,
    city: "McCune",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1203,
    density: 3.4,
    county_fips: 20037,
    county_name: "Crawford",
    county_weights: {
      20021: 35.38,
      20037: 54.24,
      20099: 7.83,
      20133: 2.55,
    },
    county_names_all: "Crawford|Cherokee|Labette|Neosho",
    county_fips_all: "20037|20021|20099|20133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66754,
    lat: 38.00377,
    lng: -94.88848,
    city: "Mapleton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 456,
    density: 3.7,
    county_fips: 20011,
    county_name: "Bourbon",
    county_weights: {
      20011: 92.53,
      20107: 7.47,
    },
    county_names_all: "Bourbon|Linn",
    county_fips_all: "20011|20107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66755,
    lat: 37.91211,
    lng: -95.16727,
    city: "Moran",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 854,
    density: 2.6,
    county_fips: 20001,
    county_name: "Allen",
    county_weights: {
      20001: 93.65,
      20011: 6.35,
    },
    county_names_all: "Allen|Bourbon",
    county_fips_all: "20001|20011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66756,
    lat: 37.53928,
    lng: -94.64869,
    city: "Mulberry",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1089,
    density: 20.2,
    county_fips: 20037,
    county_name: "Crawford",
    county_weights: {
      20037: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 20037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66757,
    lat: 37.41602,
    lng: -95.69874,
    city: "Neodesha",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3162,
    density: 10.7,
    county_fips: 20205,
    county_name: "Wilson",
    county_weights: {
      20125: 24.06,
      20205: 75.94,
    },
    county_names_all: "Wilson|Montgomery",
    county_fips_all: "20205|20125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66758,
    lat: 38.01862,
    lng: -95.59602,
    city: "Neosho Falls",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 221,
    density: 1.6,
    county_fips: 20207,
    county_name: "Woodson",
    county_weights: {
      20001: 5.85,
      20003: 6.39,
      20031: 16.42,
      20207: 71.34,
    },
    county_names_all: "Woodson|Coffey|Anderson|Allen",
    county_fips_all: "20207|20031|20003|20001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66760,
    lat: 37.34487,
    lng: -94.6245,
    city: "Opolis",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 20037,
    county_name: "Crawford",
    county_weights: {
      20037: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 20037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66761,
    lat: 37.91469,
    lng: -95.56694,
    city: "Piqua",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 265,
    density: 2.4,
    county_fips: 20207,
    county_name: "Woodson",
    county_weights: {
      20207: 100,
    },
    county_names_all: "Woodson",
    county_fips_all: 20207,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66762,
    lat: 37.39443,
    lng: -94.71092,
    city: "Pittsburg",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24498,
    density: 70.6,
    county_fips: 20037,
    county_name: "Crawford",
    county_weights: {
      20021: 17.27,
      20037: 82.73,
    },
    county_names_all: "Crawford|Cherokee",
    county_fips_all: "20037|20021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66763,
    lat: 37.46063,
    lng: -94.6965,
    city: "Frontenac",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3398,
    density: 209.4,
    county_fips: 20037,
    county_name: "Crawford",
    county_weights: {
      20037: 100,
    },
    county_names_all: "Crawford",
    county_fips_all: 20037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66767,
    lat: 38.07741,
    lng: -94.71159,
    city: "Prescott",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 475,
    density: 4,
    county_fips: 20107,
    county_name: "Linn",
    county_weights: {
      20107: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 20107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66769,
    lat: 37.85317,
    lng: -94.89379,
    city: "Redfield",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 595,
    density: 4.6,
    county_fips: 20011,
    county_name: "Bourbon",
    county_weights: {
      20011: 100,
    },
    county_names_all: "Bourbon",
    county_fips_all: 20011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66770,
    lat: 37.08014,
    lng: -94.71601,
    city: "Riverton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1069,
    density: 58.4,
    county_fips: 20021,
    county_name: "Cherokee",
    county_weights: {
      20021: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 20021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66771,
    lat: 37.49211,
    lng: -95.14883,
    city: "Saint Paul",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1056,
    density: 6.6,
    county_fips: 20133,
    county_name: "Neosho",
    county_weights: {
      20133: 100,
    },
    county_names_all: "Neosho",
    county_fips_all: 20133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66772,
    lat: 37.74559,
    lng: -95.18813,
    city: "Savonburg",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 155,
    density: 1.2,
    county_fips: 20001,
    county_name: "Allen",
    county_weights: {
      20001: 67.43,
      20011: 17.3,
      20133: 15.27,
    },
    county_names_all: "Allen|Bourbon|Neosho",
    county_fips_all: "20001|20011|20133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66773,
    lat: 37.26599,
    lng: -94.81262,
    city: "Scammon",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 635,
    density: 7.3,
    county_fips: 20021,
    county_name: "Cherokee",
    county_weights: {
      20021: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 20021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66775,
    lat: 37.69957,
    lng: -95.14855,
    city: "Stark",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 162,
    density: 3,
    county_fips: 20133,
    county_name: "Neosho",
    county_weights: {
      20133: 100,
    },
    county_names_all: "Neosho",
    county_fips_all: 20133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66776,
    lat: 37.46848,
    lng: -95.48893,
    city: "Thayer",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1461,
    density: 5.1,
    county_fips: 20133,
    county_name: "Neosho",
    county_weights: {
      20099: 2.84,
      20125: 0.91,
      20133: 68.73,
      20205: 27.52,
    },
    county_names_all: "Neosho|Wilson|Labette|Montgomery",
    county_fips_all: "20133|20205|20099|20125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66777,
    lat: 37.79087,
    lng: -95.9684,
    city: "Toronto",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 468,
    density: 1.4,
    county_fips: 20073,
    county_name: "Greenwood",
    county_weights: {
      20073: 50.02,
      20205: 5.97,
      20207: 44.01,
    },
    county_names_all: "Greenwood|Woodson|Wilson",
    county_fips_all: "20073|20207|20205",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66778,
    lat: 37.00048,
    lng: -94.839,
    city: "Treece",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 20021,
    county_name: "Cherokee",
    county_weights: {
      20021: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 20021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66779,
    lat: 37.83751,
    lng: -94.97867,
    city: "Uniontown",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 674,
    density: 3.5,
    county_fips: 20011,
    county_name: "Bourbon",
    county_weights: {
      20011: 100,
    },
    county_names_all: "Bourbon",
    county_fips_all: 20011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66780,
    lat: 37.60895,
    lng: -95.05881,
    city: "Walnut",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 513,
    density: 1.9,
    county_fips: 20037,
    county_name: "Crawford",
    county_weights: {
      20011: 9.85,
      20037: 62.91,
      20133: 27.24,
    },
    county_names_all: "Crawford|Neosho|Bourbon",
    county_fips_all: "20037|20133|20011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66781,
    lat: 37.29114,
    lng: -94.72806,
    city: "Weir",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1155,
    density: 9.8,
    county_fips: 20021,
    county_name: "Cherokee",
    county_weights: {
      20021: 94.51,
      20037: 5.49,
    },
    county_names_all: "Cherokee|Crawford",
    county_fips_all: "20021|20037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66782,
    lat: 37.28493,
    lng: -94.92609,
    city: "West Mineral",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 130,
    density: 164.9,
    county_fips: 20021,
    county_name: "Cherokee",
    county_weights: {
      20021: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 20021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66783,
    lat: 37.87682,
    lng: -95.73322,
    city: "Yates Center",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2225,
    density: 3,
    county_fips: 20207,
    county_name: "Woodson",
    county_weights: {
      20207: 100,
    },
    county_names_all: "Woodson",
    county_fips_all: 20207,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66801,
    lat: 38.41105,
    lng: -96.2221,
    city: "Emporia",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28450,
    density: 36.5,
    county_fips: 20111,
    county_name: "Lyon",
    county_weights: {
      20017: 15.38,
      20111: 84.62,
    },
    county_names_all: "Lyon|Chase",
    county_fips_all: "20111|20017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66830,
    lat: 38.59733,
    lng: -96.08755,
    city: "Admire",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 209,
    density: 2.8,
    county_fips: 20111,
    county_name: "Lyon",
    county_weights: {
      20111: 100,
    },
    county_names_all: "Lyon",
    county_fips_all: 20111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66833,
    lat: 38.67694,
    lng: -96.18374,
    city: "Allen",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 465,
    density: 1.3,
    county_fips: 20111,
    county_name: "Lyon",
    county_weights: {
      20111: 100,
    },
    county_names_all: "Lyon",
    county_fips_all: 20111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66834,
    lat: 38.86528,
    lng: -96.44822,
    city: "Alta Vista",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 874,
    density: 2,
    county_fips: 20197,
    county_name: "Wabaunsee",
    county_weights: {
      20061: 23.88,
      20127: 20.1,
      20197: 56.02,
    },
    county_names_all: "Wabaunsee|Geary|Morris",
    county_fips_all: "20197|20061|20127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66835,
    lat: 38.53458,
    lng: -96.26266,
    city: "Americus",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1206,
    density: 8,
    county_fips: 20111,
    county_name: "Lyon",
    county_weights: {
      20111: 98.91,
      20127: 1.09,
    },
    county_names_all: "Lyon|Morris",
    county_fips_all: "20111|20127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66838,
    lat: 38.56207,
    lng: -96.79665,
    city: "Burdick",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 141,
    density: 0.9,
    county_fips: 20127,
    county_name: "Morris",
    county_weights: {
      20017: 2.39,
      20115: 3.23,
      20127: 94.38,
    },
    county_names_all: "Morris|Marion|Chase",
    county_fips_all: "20127|20115|20017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66839,
    lat: 38.21655,
    lng: -95.75371,
    city: "Burlington",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3650,
    density: 9.8,
    county_fips: 20031,
    county_name: "Coffey",
    county_weights: {
      20031: 100,
    },
    county_names_all: "Coffey",
    county_fips_all: 20031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66840,
    lat: 38.07283,
    lng: -96.8719,
    city: "Burns",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 576,
    density: 1.3,
    county_fips: 20015,
    county_name: "Butler",
    county_weights: {
      20015: 53.59,
      20017: 21.15,
      20115: 25.26,
    },
    county_names_all: "Butler|Marion|Chase",
    county_fips_all: "20015|20115|20017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66842,
    lat: 38.0236,
    lng: -96.65836,
    city: "Cassoday",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 554,
    density: 1.8,
    county_fips: 20015,
    county_name: "Butler",
    county_weights: {
      20015: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 20015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66843,
    lat: 38.22846,
    lng: -96.74329,
    city: "Cedar Point",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 162,
    density: 0.5,
    county_fips: 20017,
    county_name: "Chase",
    county_weights: {
      20017: 97.74,
      20115: 2.26,
    },
    county_names_all: "Chase|Marion",
    county_fips_all: "20017|20115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66845,
    lat: 38.29546,
    lng: -96.50762,
    city: "Cottonwood Falls",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1139,
    density: 2.9,
    county_fips: 20017,
    county_name: "Chase",
    county_weights: {
      20017: 100,
    },
    county_names_all: "Chase",
    county_fips_all: 20017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66846,
    lat: 38.64383,
    lng: -96.47187,
    city: "Council Grove",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3270,
    density: 4.2,
    county_fips: 20127,
    county_name: "Morris",
    county_weights: {
      20017: 4.36,
      20111: 10.9,
      20127: 84.08,
      20197: 0.66,
    },
    county_names_all: "Morris|Lyon|Chase|Wabaunsee",
    county_fips_all: "20127|20111|20017|20197",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66849,
    lat: 38.87427,
    lng: -96.59789,
    city: "Dwight",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 479,
    density: 2.9,
    county_fips: 20127,
    county_name: "Morris",
    county_weights: {
      20061: 48.97,
      20127: 51.03,
    },
    county_names_all: "Morris|Geary",
    county_fips_all: "20127|20061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66850,
    lat: 38.40648,
    lng: -96.71764,
    city: "Elmdale",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 292,
    density: 0.9,
    county_fips: 20017,
    county_name: "Chase",
    county_weights: {
      20017: 100,
    },
    county_names_all: "Chase",
    county_fips_all: 20017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66851,
    lat: 38.22463,
    lng: -96.92084,
    city: "Florence",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 505,
    density: 2.9,
    county_fips: 20115,
    county_name: "Marion",
    county_weights: {
      20115: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 20115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66852,
    lat: 38.0716,
    lng: -95.89874,
    city: "Gridley",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 629,
    density: 1.6,
    county_fips: 20031,
    county_name: "Coffey",
    county_weights: {
      20031: 58.04,
      20073: 18.14,
      20207: 23.82,
    },
    county_names_all: "Coffey|Woodson|Greenwood",
    county_fips_all: "20031|20207|20073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66853,
    lat: 38.00653,
    lng: -96.24232,
    city: "Hamilton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 491,
    density: 1.2,
    county_fips: 20073,
    county_name: "Greenwood",
    county_weights: {
      20073: 100,
    },
    county_names_all: "Greenwood",
    county_fips_all: 20073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66854,
    lat: 38.25872,
    lng: -95.98735,
    city: "Hartford",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 627,
    density: 2.5,
    county_fips: 20111,
    county_name: "Lyon",
    county_weights: {
      20031: 29.19,
      20111: 70.81,
    },
    county_names_all: "Lyon|Coffey",
    county_fips_all: "20111|20031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66856,
    lat: 38.39853,
    lng: -95.81838,
    city: "Lebo",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1760,
    density: 4.8,
    county_fips: 20031,
    county_name: "Coffey",
    county_weights: {
      20031: 66.67,
      20139: 33.33,
    },
    county_names_all: "Coffey|Osage",
    county_fips_all: "20031|20139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66857,
    lat: 38.10202,
    lng: -95.63526,
    city: "Le Roy",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1023,
    density: 4.8,
    county_fips: 20031,
    county_name: "Coffey",
    county_weights: {
      20031: 100,
    },
    county_names_all: "Coffey",
    county_fips_all: 20031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66858,
    lat: 38.47462,
    lng: -96.9207,
    city: "Lincolnville",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 280,
    density: 1.4,
    county_fips: 20115,
    county_name: "Marion",
    county_weights: {
      20017: 7.98,
      20115: 92.02,
    },
    county_names_all: "Marion|Chase",
    county_fips_all: "20115|20017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66859,
    lat: 38.55653,
    lng: -96.96315,
    city: "Lost Springs",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 212,
    density: 2,
    county_fips: 20115,
    county_name: "Marion",
    county_weights: {
      20115: 81.05,
      20127: 18.95,
    },
    county_names_all: "Marion|Morris",
    county_fips_all: "20115|20127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66860,
    lat: 38.12775,
    lng: -96.1652,
    city: "Madison",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1146,
    density: 2.4,
    county_fips: 20073,
    county_name: "Greenwood",
    county_weights: {
      20073: 81.54,
      20111: 18.46,
    },
    county_names_all: "Greenwood|Lyon",
    county_fips_all: "20073|20111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66861,
    lat: 38.36415,
    lng: -97.00617,
    city: "Marion",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2759,
    density: 5.2,
    county_fips: 20115,
    county_name: "Marion",
    county_weights: {
      20115: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 20115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66862,
    lat: 38.15532,
    lng: -96.55403,
    city: "Matfield Green",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75,
    density: 0.3,
    county_fips: 20017,
    county_name: "Chase",
    county_weights: {
      20017: 100,
    },
    county_names_all: "Chase",
    county_fips_all: 20017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66863,
    lat: 37.83368,
    lng: -96.07633,
    city: "Neal",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44,
    density: 38.2,
    county_fips: 20073,
    county_name: "Greenwood",
    county_weights: {
      20073: 100,
    },
    county_names_all: "Greenwood",
    county_fips_all: 20073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66864,
    lat: 38.36132,
    lng: -95.98207,
    city: "Neosho Rapids",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 456,
    density: 4.7,
    county_fips: 20111,
    county_name: "Lyon",
    county_weights: {
      20031: 30.62,
      20111: 69.38,
    },
    county_names_all: "Lyon|Coffey",
    county_fips_all: "20111|20031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66865,
    lat: 38.2181,
    lng: -96.27993,
    city: "Olpe",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1242,
    density: 3.2,
    county_fips: 20111,
    county_name: "Lyon",
    county_weights: {
      20017: 33.39,
      20111: 66.61,
    },
    county_names_all: "Lyon|Chase",
    county_fips_all: "20111|20017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66866,
    lat: 38.17438,
    lng: -97.10385,
    city: "Peabody",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1715,
    density: 4.8,
    county_fips: 20115,
    county_name: "Marion",
    county_weights: {
      20079: 9.36,
      20115: 90.64,
    },
    county_names_all: "Marion|Harvey",
    county_fips_all: "20115|20079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66868,
    lat: 38.54284,
    lng: -95.98387,
    city: "Reading",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 860,
    density: 2.6,
    county_fips: 20111,
    county_name: "Lyon",
    county_weights: {
      20031: 1.59,
      20111: 77.85,
      20139: 20.56,
    },
    county_names_all: "Lyon|Osage|Coffey",
    county_fips_all: "20111|20139|20031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66869,
    lat: 38.4548,
    lng: -96.54444,
    city: "Strong City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 671,
    density: 2.4,
    county_fips: 20017,
    county_name: "Chase",
    county_weights: {
      20017: 100,
    },
    county_names_all: "Chase",
    county_fips_all: 20017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66870,
    lat: 37.93809,
    lng: -95.99316,
    city: "Virgil",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 153,
    density: 0.6,
    county_fips: 20073,
    county_name: "Greenwood",
    county_weights: {
      20073: 80.05,
      20207: 19.95,
    },
    county_names_all: "Greenwood|Woodson",
    county_fips_all: "20073|20207",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66871,
    lat: 38.35941,
    lng: -95.61815,
    city: "Waverly",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1327,
    density: 3.9,
    county_fips: 20031,
    county_name: "Coffey",
    county_weights: {
      20031: 94.84,
      20139: 5.16,
    },
    county_names_all: "Coffey|Osage",
    county_fips_all: "20031|20139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66872,
    lat: 38.79878,
    lng: -96.76147,
    city: "White City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 921,
    density: 2.5,
    county_fips: 20127,
    county_name: "Morris",
    county_weights: {
      20061: 5.97,
      20127: 94.03,
    },
    county_names_all: "Morris|Geary",
    county_fips_all: "20127|20061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66873,
    lat: 38.61747,
    lng: -96.66774,
    city: "Wilsey",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 245,
    density: 1.2,
    county_fips: 20127,
    county_name: "Morris",
    county_weights: {
      20127: 100,
    },
    county_names_all: "Morris",
    county_fips_all: 20127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66901,
    lat: 39.55618,
    lng: -97.64317,
    city: "Concordia",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6026,
    density: 9.2,
    county_fips: 20029,
    county_name: "Cloud",
    county_weights: {
      20029: 88.95,
      20157: 11.05,
    },
    county_names_all: "Cloud|Republic",
    county_fips_all: "20029|20157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66930,
    lat: 39.71137,
    lng: -97.48553,
    city: "Agenda",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 248,
    density: 1.5,
    county_fips: 20157,
    county_name: "Republic",
    county_weights: {
      20157: 100,
    },
    county_names_all: "Republic",
    county_fips_all: 20157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66932,
    lat: 39.77925,
    lng: -98.93227,
    city: "Athol",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64,
    density: 0.3,
    county_fips: 20183,
    county_name: "Smith",
    county_weights: {
      20183: 100,
    },
    county_names_all: "Smith",
    county_fips_all: 20183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66933,
    lat: 39.67124,
    lng: -96.86706,
    city: "Barnes",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 281,
    density: 1.3,
    county_fips: 20201,
    county_name: "Washington",
    county_weights: {
      20161: 5.01,
      20201: 94.99,
    },
    county_names_all: "Washington|Riley",
    county_fips_all: "20201|20161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66935,
    lat: 39.82694,
    lng: -97.63538,
    city: "Belleville",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2239,
    density: 7,
    county_fips: 20157,
    county_name: "Republic",
    county_weights: {
      20157: 100,
    },
    county_names_all: "Republic",
    county_fips_all: 20157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66936,
    lat: 39.9213,
    lng: -98.30091,
    city: "Burr Oak",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 285,
    density: 0.8,
    county_fips: 20089,
    county_name: "Jewell",
    county_weights: {
      20089: 100,
    },
    county_names_all: "Jewell",
    county_fips_all: 20089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66937,
    lat: 39.58959,
    lng: -97.26493,
    city: "Clifton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1013,
    density: 2.8,
    county_fips: 20201,
    county_name: "Washington",
    county_weights: {
      20027: 46.7,
      20201: 53.3,
    },
    county_names_all: "Washington|Clay",
    county_fips_all: "20201|20027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66938,
    lat: 39.58018,
    lng: -97.41081,
    city: "Clyde",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1204,
    density: 3.7,
    county_fips: 20029,
    county_name: "Cloud",
    county_weights: {
      20027: 4.69,
      20029: 67.32,
      20157: 9.01,
      20201: 18.98,
    },
    county_names_all: "Cloud|Washington|Republic|Clay",
    county_fips_all: "20029|20201|20157|20027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66939,
    lat: 39.85179,
    lng: -97.89754,
    city: "Courtland",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 483,
    density: 1.7,
    county_fips: 20157,
    county_name: "Republic",
    county_weights: {
      20089: 17.49,
      20157: 82.51,
    },
    county_names_all: "Republic|Jewell",
    county_fips_all: "20157|20089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66940,
    lat: 39.80343,
    lng: -97.45381,
    city: "Cuba",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 362,
    density: 2,
    county_fips: 20157,
    county_name: "Republic",
    county_weights: {
      20157: 100,
    },
    county_names_all: "Republic",
    county_fips_all: 20157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66941,
    lat: 39.83135,
    lng: -98.44777,
    city: "Esbon",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 77,
    density: 0.2,
    county_fips: 20089,
    county_name: "Jewell",
    county_weights: {
      20089: 100,
    },
    county_names_all: "Jewell",
    county_fips_all: 20089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66942,
    lat: 39.79278,
    lng: -98.00448,
    city: "Formoso",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 235,
    density: 1,
    county_fips: 20089,
    county_name: "Jewell",
    county_weights: {
      20089: 98.07,
      20157: 1.93,
    },
    county_names_all: "Jewell|Republic",
    county_fips_all: "20089|20157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66943,
    lat: 39.67209,
    lng: -96.97313,
    city: "Greenleaf",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 542,
    density: 2.3,
    county_fips: 20201,
    county_name: "Washington",
    county_weights: {
      20201: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 20201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66944,
    lat: 39.84007,
    lng: -97.29354,
    city: "Haddam",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 345,
    density: 1.4,
    county_fips: 20201,
    county_name: "Washington",
    county_weights: {
      20201: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 20201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66945,
    lat: 39.88601,
    lng: -96.87761,
    city: "Hanover",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 896,
    density: 3.4,
    county_fips: 20201,
    county_name: "Washington",
    county_weights: {
      20117: 0.96,
      20201: 99.04,
    },
    county_names_all: "Washington|Marshall",
    county_fips_all: "20201|20117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66946,
    lat: 39.96684,
    lng: -97.00192,
    city: "Hollenberg",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 161,
    density: 1.2,
    county_fips: 20201,
    county_name: "Washington",
    county_weights: {
      20201: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 20201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66948,
    lat: 39.59743,
    lng: -97.85141,
    city: "Jamestown",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 417,
    density: 1.3,
    county_fips: 20029,
    county_name: "Cloud",
    county_weights: {
      20029: 77.44,
      20089: 0.79,
      20157: 21.77,
    },
    county_names_all: "Cloud|Republic|Jewell",
    county_fips_all: "20029|20157|20089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66949,
    lat: 39.646,
    lng: -98.19755,
    city: "Jewell",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 602,
    density: 2,
    county_fips: 20089,
    county_name: "Jewell",
    county_weights: {
      20089: 100,
    },
    county_names_all: "Jewell",
    county_fips_all: 20089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66951,
    lat: 39.86239,
    lng: -99.03072,
    city: "Kensington",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 737,
    density: 1.5,
    county_fips: 20183,
    county_name: "Smith",
    county_weights: {
      20147: 26.13,
      20183: 73.87,
    },
    county_names_all: "Smith|Phillips",
    county_fips_all: "20183|20147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66952,
    lat: 39.84269,
    lng: -98.60214,
    city: "Lebanon",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 448,
    density: 0.7,
    county_fips: 20183,
    county_name: "Smith",
    county_weights: {
      20089: 1.33,
      20183: 98.67,
    },
    county_names_all: "Smith|Jewell",
    county_fips_all: "20183|20089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66953,
    lat: 39.67877,
    lng: -97.11934,
    city: "Linn",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 623,
    density: 3.4,
    county_fips: 20201,
    county_name: "Washington",
    county_weights: {
      20201: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 20201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66955,
    lat: 39.97984,
    lng: -97.31715,
    city: "Mahaska",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 87,
    density: 0.6,
    county_fips: 20201,
    county_name: "Washington",
    county_weights: {
      20201: 77.84,
      31169: 22.16,
    },
    county_names_all: "Washington|Thayer",
    county_fips_all: "20201|31169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66956,
    lat: 39.79625,
    lng: -98.21581,
    city: "Mankato",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1118,
    density: 2.2,
    county_fips: 20089,
    county_name: "Jewell",
    county_weights: {
      20089: 100,
    },
    county_names_all: "Jewell",
    county_fips_all: 20089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66958,
    lat: 39.88657,
    lng: -97.1787,
    city: "Morrowville",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 230,
    density: 1.2,
    county_fips: 20201,
    county_name: "Washington",
    county_weights: {
      20201: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 20201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66959,
    lat: 39.92276,
    lng: -97.53551,
    city: "Munden",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 171,
    density: 1.2,
    county_fips: 20157,
    county_name: "Republic",
    county_weights: {
      20157: 100,
    },
    county_names_all: "Republic",
    county_fips_all: 20157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66960,
    lat: 39.93042,
    lng: -97.42134,
    city: "Narka",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 132,
    density: 0.8,
    county_fips: 20157,
    county_name: "Republic",
    county_weights: {
      20157: 95.46,
      20201: 4.54,
    },
    county_names_all: "Republic|Washington",
    county_fips_all: "20157|20201",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66961,
    lat: 39.69337,
    lng: -97.77559,
    city: "Norway",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 20157,
    county_name: "Republic",
    county_weights: {
      20157: 100,
    },
    county_names_all: "Republic",
    county_fips_all: 20157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66962,
    lat: 39.59928,
    lng: -97.12547,
    city: "Palmer",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 228,
    density: 1.6,
    county_fips: 20201,
    county_name: "Washington",
    county_weights: {
      20027: 21.59,
      20201: 78.41,
    },
    county_names_all: "Washington|Clay",
    county_fips_all: "20201|20027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66963,
    lat: 39.64133,
    lng: -98.01064,
    city: "Randall",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 227,
    density: 1.1,
    county_fips: 20089,
    county_name: "Jewell",
    county_weights: {
      20089: 100,
    },
    county_names_all: "Jewell",
    county_fips_all: 20089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66964,
    lat: 39.93465,
    lng: -97.80004,
    city: "Republic",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 117,
    density: 0.9,
    county_fips: 20157,
    county_name: "Republic",
    county_weights: {
      20157: 100,
    },
    county_names_all: "Republic",
    county_fips_all: 20157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66966,
    lat: 39.7793,
    lng: -97.76206,
    city: "Scandia",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 695,
    density: 2.9,
    county_fips: 20157,
    county_name: "Republic",
    county_weights: {
      20157: 100,
    },
    county_names_all: "Republic",
    county_fips_all: 20157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66967,
    lat: 39.82571,
    lng: -98.79366,
    city: "Smith Center",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1969,
    density: 3.2,
    county_fips: 20183,
    county_name: "Smith",
    county_weights: {
      20183: 100,
    },
    county_names_all: "Smith",
    county_fips_all: 20183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66968,
    lat: 39.8294,
    lng: -97.06524,
    city: "Washington",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1258,
    density: 3.7,
    county_fips: 20201,
    county_name: "Washington",
    county_weights: {
      20201: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 20201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 66970,
    lat: 39.94533,
    lng: -98.02336,
    city: "Webber",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 71,
    density: 0.8,
    county_fips: 20089,
    county_name: "Jewell",
    county_weights: {
      20089: 100,
    },
    county_names_all: "Jewell",
    county_fips_all: 20089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67001,
    lat: 37.76069,
    lng: -97.62953,
    city: "Andale",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1781,
    density: 29.8,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67002,
    lat: 37.69575,
    lng: -97.10725,
    city: "Andover",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15085,
    density: 155.4,
    county_fips: 20015,
    county_name: "Butler",
    county_weights: {
      20015: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 20015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67003,
    lat: 37.1109,
    lng: -98.06319,
    city: "Anthony",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2377,
    density: 3.8,
    county_fips: 20077,
    county_name: "Harper",
    county_weights: {
      20077: 100,
    },
    county_names_all: "Harper",
    county_fips_all: 20077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67004,
    lat: 37.28317,
    lng: -97.76401,
    city: "Argonia",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 740,
    density: 2.7,
    county_fips: 20191,
    county_name: "Sumner",
    county_weights: {
      20077: 28.1,
      20191: 71.9,
    },
    county_names_all: "Sumner|Harper",
    county_fips_all: "20191|20077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67005,
    lat: 37.06722,
    lng: -96.99645,
    city: "Arkansas City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15311,
    density: 40.6,
    county_fips: 20035,
    county_name: "Cowley",
    county_weights: {
      20035: 100,
    },
    county_names_all: "Cowley",
    county_fips_all: 20035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67008,
    lat: 37.47796,
    lng: -96.76983,
    city: "Atlanta",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 547,
    density: 1.9,
    county_fips: 20035,
    county_name: "Cowley",
    county_weights: {
      20015: 43.56,
      20035: 56.44,
    },
    county_names_all: "Cowley|Butler",
    county_fips_all: "20035|20015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67009,
    lat: 37.22153,
    lng: -98.26369,
    city: "Attica",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 925,
    density: 2.6,
    county_fips: 20077,
    county_name: "Harper",
    county_weights: {
      20077: 100,
    },
    county_names_all: "Harper",
    county_fips_all: 20077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67010,
    lat: 37.66099,
    lng: -96.97388,
    city: "Augusta",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14447,
    density: 53.7,
    county_fips: 20015,
    county_name: "Butler",
    county_weights: {
      20015: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 20015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67012,
    lat: 37.66175,
    lng: -96.54701,
    city: "Beaumont",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29,
    density: 0.6,
    county_fips: 20015,
    county_name: "Butler",
    county_weights: {
      20015: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 20015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67013,
    lat: 37.37904,
    lng: -97.27378,
    city: "Belle Plaine",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2974,
    density: 15,
    county_fips: 20191,
    county_name: "Sumner",
    county_weights: {
      20191: 100,
    },
    county_names_all: "Sumner",
    county_fips_all: 20191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67016,
    lat: 37.88882,
    lng: -97.51812,
    city: "Bentley",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 474,
    density: 303.9,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67017,
    lat: 37.82778,
    lng: -97.11165,
    city: "Benton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2021,
    density: 12.2,
    county_fips: 20015,
    county_name: "Butler",
    county_weights: {
      20015: 89.51,
      20173: 10.49,
    },
    county_names_all: "Butler|Sedgwick",
    county_fips_all: "20015|20173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67018,
    lat: 37.07108,
    lng: -97.85872,
    city: "Bluff City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 117,
    density: 0.7,
    county_fips: 20077,
    county_name: "Harper",
    county_weights: {
      20077: 91.98,
      20191: 8.02,
    },
    county_names_all: "Harper|Sumner",
    county_fips_all: "20077|20191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67019,
    lat: 37.31225,
    lng: -96.78174,
    city: "Burden",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 932,
    density: 3.5,
    county_fips: 20035,
    county_name: "Cowley",
    county_weights: {
      20035: 100,
    },
    county_names_all: "Cowley",
    county_fips_all: 20035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67020,
    lat: 38.00881,
    lng: -97.66903,
    city: "Burrton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1537,
    density: 4.7,
    county_fips: 20079,
    county_name: "Harvey",
    county_weights: {
      20079: 65.24,
      20155: 29.07,
      20173: 5.69,
    },
    county_names_all: "Harvey|Reno|Sedgwick",
    county_fips_all: "20079|20155|20173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67021,
    lat: 37.77615,
    lng: -98.91045,
    city: "Byers",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33,
    density: 0.3,
    county_fips: 20151,
    county_name: "Pratt",
    county_weights: {
      20151: 100,
    },
    county_names_all: "Pratt",
    county_fips_all: 20151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67022,
    lat: 37.07352,
    lng: -97.63347,
    city: "Caldwell",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1506,
    density: 3.2,
    county_fips: 20191,
    county_name: "Sumner",
    county_weights: {
      20191: 100,
    },
    county_names_all: "Sumner",
    county_fips_all: 20191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67023,
    lat: 37.33467,
    lng: -96.61288,
    city: "Cambridge",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 201,
    density: 0.5,
    county_fips: 20035,
    county_name: "Cowley",
    county_weights: {
      20035: 100,
    },
    county_names_all: "Cowley",
    county_fips_all: 20035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67024,
    lat: 37.11397,
    lng: -96.49164,
    city: "Cedar Vale",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 976,
    density: 1.7,
    county_fips: 20019,
    county_name: "Chautauqua",
    county_weights: {
      20019: 62.65,
      20035: 37.35,
    },
    county_names_all: "Chautauqua|Cowley",
    county_fips_all: "20019|20035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67025,
    lat: 37.64146,
    lng: -97.78789,
    city: "Cheney",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3621,
    density: 12.4,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20095: 36.77,
      20155: 1.79,
      20173: 61.44,
    },
    county_names_all: "Sedgwick|Kingman|Reno",
    county_fips_all: "20173|20095|20155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67026,
    lat: 37.51047,
    lng: -97.49239,
    city: "Clearwater",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4925,
    density: 19.8,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 72.46,
      20191: 27.54,
    },
    county_names_all: "Sedgwick|Sumner",
    county_fips_all: "20173|20191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67028,
    lat: 37.47226,
    lng: -98.96561,
    city: "Coats",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 311,
    density: 0.6,
    county_fips: 20097,
    county_name: "Kiowa",
    county_weights: {
      20007: 19.7,
      20097: 42.17,
      20151: 38.14,
    },
    county_names_all: "Kiowa|Pratt|Barber",
    county_fips_all: "20097|20151|20007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67029,
    lat: 37.16925,
    lng: -99.28026,
    city: "Coldwater",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1065,
    density: 1,
    county_fips: 20033,
    county_name: "Comanche",
    county_weights: {
      20033: 97.88,
      20097: 2.12,
    },
    county_names_all: "Comanche|Kiowa",
    county_fips_all: "20033|20097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67030,
    lat: 37.78548,
    lng: -97.54661,
    city: "Colwich",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2686,
    density: 25.5,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67031,
    lat: 37.40444,
    lng: -97.63848,
    city: "Conway Springs",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2538,
    density: 8.4,
    county_fips: 20191,
    county_name: "Sumner",
    county_weights: {
      20173: 6.04,
      20191: 93.96,
    },
    county_names_all: "Sumner|Sedgwick",
    county_fips_all: "20191|20173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67035,
    lat: 37.64845,
    lng: -98.39338,
    city: "Cunningham",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 925,
    density: 1.6,
    county_fips: 20095,
    county_name: "Kingman",
    county_weights: {
      20095: 65.68,
      20151: 25.32,
      20155: 9,
    },
    county_names_all: "Kingman|Pratt|Reno",
    county_fips_all: "20095|20151|20155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67036,
    lat: 37.28987,
    lng: -97.88262,
    city: "Danville",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 101,
    density: 1,
    county_fips: 20077,
    county_name: "Harper",
    county_weights: {
      20077: 100,
    },
    county_names_all: "Harper",
    county_fips_all: 20077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67037,
    lat: 37.56646,
    lng: -97.22095,
    city: "Derby",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28879,
    density: 208,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67038,
    lat: 37.11702,
    lng: -96.70905,
    city: "Dexter",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1098,
    density: 3,
    county_fips: 20035,
    county_name: "Cowley",
    county_weights: {
      20035: 100,
    },
    county_names_all: "Cowley",
    county_fips_all: 20035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67039,
    lat: 37.52163,
    lng: -96.97322,
    city: "Douglass",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3147,
    density: 11.2,
    county_fips: 20015,
    county_name: "Butler",
    county_weights: {
      20015: 95.7,
      20035: 4.3,
    },
    county_names_all: "Butler|Cowley",
    county_fips_all: "20015|20035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67041,
    lat: 38.05404,
    lng: -97.12755,
    city: "Elbing",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 309,
    density: 841.2,
    county_fips: 20015,
    county_name: "Butler",
    county_weights: {
      20015: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 20015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67042,
    lat: 37.84868,
    lng: -96.79809,
    city: "El Dorado",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17457,
    density: 26.1,
    county_fips: 20015,
    county_name: "Butler",
    county_weights: {
      20015: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 20015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67045,
    lat: 37.85131,
    lng: -96.33863,
    city: "Eureka",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3279,
    density: 2.8,
    county_fips: 20073,
    county_name: "Greenwood",
    county_weights: {
      20015: 0.75,
      20073: 99.25,
    },
    county_names_all: "Greenwood|Butler",
    county_fips_all: "20073|20015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67047,
    lat: 37.63921,
    lng: -96.05327,
    city: "Fall River",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 668,
    density: 1.8,
    county_fips: 20073,
    county_name: "Greenwood",
    county_weights: {
      20049: 26.44,
      20073: 63.52,
      20205: 10.04,
    },
    county_names_all: "Greenwood|Elk|Wilson",
    county_fips_all: "20073|20049|20205",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67049,
    lat: 37.17059,
    lng: -97.84646,
    city: "Freeport",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 129,
    density: 1.3,
    county_fips: 20077,
    county_name: "Harper",
    county_weights: {
      20077: 88.86,
      20191: 11.14,
    },
    county_names_all: "Harper|Sumner",
    county_fips_all: "20077|20191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67050,
    lat: 37.675,
    lng: -97.6769,
    city: "Garden Plain",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2286,
    density: 18.8,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20155: 2.22,
      20173: 97.78,
    },
    county_names_all: "Sedgwick|Reno",
    county_fips_all: "20173|20155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67051,
    lat: 37.08932,
    lng: -97.19399,
    city: "Geuda Springs",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 335,
    density: 1.7,
    county_fips: 20191,
    county_name: "Sumner",
    county_weights: {
      20035: 11.05,
      20191: 88.95,
    },
    county_names_all: "Sumner|Cowley",
    county_fips_all: "20191|20035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67052,
    lat: 37.65812,
    lng: -97.57357,
    city: "Goddard",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8548,
    density: 63.7,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67053,
    lat: 38.24728,
    lng: -97.34545,
    city: "Goessel",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 687,
    density: 700.7,
    county_fips: 20115,
    county_name: "Marion",
    county_weights: {
      20115: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 20115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67054,
    lat: 37.57658,
    lng: -99.31884,
    city: "Greensburg",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1220,
    density: 2.1,
    county_fips: 20097,
    county_name: "Kiowa",
    county_weights: {
      20047: 3.64,
      20097: 96.36,
    },
    county_names_all: "Kiowa|Edwards",
    county_fips_all: "20097|20047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67055,
    lat: 37.78325,
    lng: -97.2037,
    city: "Greenwich",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67,
    density: 203.4,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67056,
    lat: 38.01936,
    lng: -97.52345,
    city: "Halstead",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3145,
    density: 14.3,
    county_fips: 20079,
    county_name: "Harvey",
    county_weights: {
      20079: 100,
    },
    county_names_all: "Harvey",
    county_fips_all: 20079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67057,
    lat: 37.05954,
    lng: -98.77864,
    city: "Hardtner",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 260,
    density: 0.7,
    county_fips: 20007,
    county_name: "Barber",
    county_weights: {
      20007: 100,
    },
    county_names_all: "Barber",
    county_fips_all: 20007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67058,
    lat: 37.32006,
    lng: -98.06493,
    city: "Harper",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1908,
    density: 3.6,
    county_fips: 20077,
    county_name: "Harper",
    county_weights: {
      20077: 85.74,
      20095: 14.26,
    },
    county_names_all: "Harper|Kingman",
    county_fips_all: "20077|20095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67059,
    lat: 37.65102,
    lng: -99.10046,
    city: "Haviland",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 925,
    density: 1.4,
    county_fips: 20097,
    county_name: "Kiowa",
    county_weights: {
      20047: 15.68,
      20097: 71.5,
      20151: 12.82,
    },
    county_names_all: "Kiowa|Edwards|Pratt",
    county_fips_all: "20097|20047|20151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67060,
    lat: 37.54601,
    lng: -97.35952,
    city: "Haysville",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14580,
    density: 200.8,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67061,
    lat: 37.08593,
    lng: -98.37673,
    city: "Hazelton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 107,
    density: 0.4,
    county_fips: 20007,
    county_name: "Barber",
    county_weights: {
      20007: 66.84,
      20077: 33.16,
    },
    county_names_all: "Barber|Harper",
    county_fips_all: "20007|20077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67062,
    lat: 38.1431,
    lng: -97.43296,
    city: "Hesston",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4290,
    density: 52.7,
    county_fips: 20079,
    county_name: "Harvey",
    county_weights: {
      20079: 89.85,
      20113: 7.29,
      20115: 2.86,
    },
    county_names_all: "Harvey|McPherson|Marion",
    county_fips_all: "20079|20113|20115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67063,
    lat: 38.34244,
    lng: -97.23019,
    city: "Hillsboro",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3643,
    density: 10.5,
    county_fips: 20115,
    county_name: "Marion",
    county_weights: {
      20115: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 20115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67065,
    lat: 37.48295,
    lng: -98.52989,
    city: "Isabel",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 308,
    density: 1.6,
    county_fips: 20151,
    county_name: "Pratt",
    county_weights: {
      20007: 40.85,
      20095: 2.68,
      20151: 56.47,
    },
    county_names_all: "Pratt|Barber|Kingman",
    county_fips_all: "20151|20007|20095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67066,
    lat: 37.77374,
    lng: -98.75798,
    city: "Iuka",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 314,
    density: 2.5,
    county_fips: 20151,
    county_name: "Pratt",
    county_weights: {
      20151: 100,
    },
    county_names_all: "Pratt",
    county_fips_all: 20151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67067,
    lat: 37.7951,
    lng: -97.27044,
    city: "Kechi",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2013,
    density: 166.5,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67068,
    lat: 37.61991,
    lng: -98.11473,
    city: "Kingman",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4026,
    density: 5.5,
    county_fips: 20095,
    county_name: "Kingman",
    county_weights: {
      20095: 91.51,
      20155: 8.49,
    },
    county_names_all: "Kingman|Reno",
    county_fips_all: "20095|20155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67070,
    lat: 37.0696,
    lng: -98.53204,
    city: "Kiowa",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1024,
    density: 3.8,
    county_fips: 20007,
    county_name: "Barber",
    county_weights: {
      20007: 100,
    },
    county_names_all: "Barber",
    county_fips_all: 20007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67071,
    lat: 37.21423,
    lng: -98.88522,
    city: "Lake City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 281,
    density: 0.7,
    county_fips: 20007,
    county_name: "Barber",
    county_weights: {
      20007: 100,
    },
    county_names_all: "Barber",
    county_fips_all: 20007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67072,
    lat: 37.5445,
    lng: -96.61632,
    city: "Latham",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 356,
    density: 1.2,
    county_fips: 20015,
    county_name: "Butler",
    county_weights: {
      20015: 90.69,
      20035: 9.31,
    },
    county_names_all: "Butler|Cowley",
    county_fips_all: "20015|20035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67073,
    lat: 38.39167,
    lng: -97.32624,
    city: "Lehigh",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 357,
    density: 4.5,
    county_fips: 20115,
    county_name: "Marion",
    county_weights: {
      20115: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 20115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67074,
    lat: 37.67038,
    lng: -96.72945,
    city: "Leon",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1148,
    density: 2.6,
    county_fips: 20015,
    county_name: "Butler",
    county_weights: {
      20015: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 20015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67101,
    lat: 37.78489,
    lng: -97.46356,
    city: "Maize",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5228,
    density: 132.9,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67102,
    lat: 37.03857,
    lng: -96.78839,
    city: "Maple City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 20035,
    county_name: "Cowley",
    county_weights: {
      20035: 100,
    },
    county_names_all: "Cowley",
    county_fips_all: 20035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67103,
    lat: 37.26439,
    lng: -97.55977,
    city: "Mayfield",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 211,
    density: 1.5,
    county_fips: 20191,
    county_name: "Sumner",
    county_weights: {
      20191: 100,
    },
    county_names_all: "Sumner",
    county_fips_all: 20191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67104,
    lat: 37.27286,
    lng: -98.65223,
    city: "Medicine Lodge",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2040,
    density: 2.4,
    county_fips: 20007,
    county_name: "Barber",
    county_weights: {
      20007: 100,
    },
    county_names_all: "Barber",
    county_fips_all: 20007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67105,
    lat: 37.22001,
    lng: -97.67825,
    city: "Milan",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 182,
    density: 1.2,
    county_fips: 20191,
    county_name: "Sumner",
    county_weights: {
      20191: 100,
    },
    county_names_all: "Sumner",
    county_fips_all: 20191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67106,
    lat: 37.46335,
    lng: -97.75804,
    city: "Milton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 495,
    density: 3.9,
    county_fips: 20191,
    county_name: "Sumner",
    county_weights: {
      20095: 2.9,
      20173: 41.33,
      20191: 55.77,
    },
    county_names_all: "Sumner|Sedgwick|Kingman",
    county_fips_all: "20191|20173|20095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67107,
    lat: 38.19496,
    lng: -97.53911,
    city: "Moundridge",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2926,
    density: 9.7,
    county_fips: 20113,
    county_name: "McPherson",
    county_weights: {
      20079: 30.23,
      20113: 69.77,
    },
    county_names_all: "McPherson|Harvey",
    county_fips_all: "20113|20079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67108,
    lat: 37.81428,
    lng: -97.68621,
    city: "Mount Hope",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1571,
    density: 8.5,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20155: 38.65,
      20173: 61.35,
    },
    county_names_all: "Sedgwick|Reno",
    county_fips_all: "20173|20155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67109,
    lat: 37.56448,
    lng: -99.47914,
    city: "Mullinville",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 361,
    density: 0.7,
    county_fips: 20097,
    county_name: "Kiowa",
    county_weights: {
      20097: 100,
    },
    county_names_all: "Kiowa",
    county_fips_all: 20097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67110,
    lat: 37.47022,
    lng: -97.22425,
    city: "Mulvane",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8870,
    density: 63.1,
    county_fips: 20191,
    county_name: "Sumner",
    county_weights: {
      20035: 3.05,
      20173: 44.13,
      20191: 52.82,
    },
    county_names_all: "Sumner|Sedgwick|Cowley",
    county_fips_all: "20191|20173|20035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67111,
    lat: 37.6151,
    lng: -97.93453,
    city: "Murdock",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 195,
    density: 1.2,
    county_fips: 20095,
    county_name: "Kingman",
    county_weights: {
      20095: 100,
    },
    county_names_all: "Kingman",
    county_fips_all: 20095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67112,
    lat: 37.44915,
    lng: -98.41941,
    city: "Nashville",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 196,
    density: 1,
    county_fips: 20095,
    county_name: "Kingman",
    county_weights: {
      20007: 19.2,
      20095: 80.8,
    },
    county_names_all: "Kingman|Barber",
    county_fips_all: "20095|20007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67114,
    lat: 38.07034,
    lng: -97.28359,
    city: "Newton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21054,
    density: 34.3,
    county_fips: 20079,
    county_name: "Harvey",
    county_weights: {
      20015: 13.08,
      20079: 71.96,
      20113: 1.37,
      20115: 13.59,
    },
    county_names_all: "Harvey|Marion|Butler|McPherson",
    county_fips_all: "20079|20115|20015|20113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67117,
    lat: 38.07416,
    lng: -97.34544,
    city: "North Newton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1990,
    density: 572.2,
    county_fips: 20079,
    county_name: "Harvey",
    county_weights: {
      20079: 100,
    },
    county_names_all: "Harvey",
    county_fips_all: 20079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67118,
    lat: 37.47829,
    lng: -97.8605,
    city: "Norwich",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 659,
    density: 2.9,
    county_fips: 20095,
    county_name: "Kingman",
    county_weights: {
      20077: 2.24,
      20095: 90.38,
      20173: 5.55,
      20191: 1.83,
    },
    county_names_all: "Kingman|Sedgwick|Harper|Sumner",
    county_fips_all: "20095|20173|20077|20191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67119,
    lat: 37.24202,
    lng: -97.18152,
    city: "Oxford",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1331,
    density: 6.7,
    county_fips: 20191,
    county_name: "Sumner",
    county_weights: {
      20035: 26.99,
      20191: 73.01,
    },
    county_names_all: "Sumner|Cowley",
    county_fips_all: "20191|20035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67120,
    lat: 37.46591,
    lng: -97.37592,
    city: "Peck",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 751,
    density: 7.5,
    county_fips: 20191,
    county_name: "Sumner",
    county_weights: {
      20173: 38.65,
      20191: 61.35,
    },
    county_names_all: "Sumner|Sedgwick",
    county_fips_all: "20191|20173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67122,
    lat: 37.62015,
    lng: -96.42392,
    city: "Piedmont",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 125,
    density: 0.4,
    county_fips: 20073,
    county_name: "Greenwood",
    county_weights: {
      20049: 42.15,
      20073: 57.85,
    },
    county_names_all: "Greenwood|Elk",
    county_fips_all: "20073|20049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67123,
    lat: 37.94676,
    lng: -96.99352,
    city: "Potwin",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 899,
    density: 6.6,
    county_fips: 20015,
    county_name: "Butler",
    county_weights: {
      20015: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 20015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67124,
    lat: 37.63644,
    lng: -98.77236,
    city: "Pratt",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7801,
    density: 10.9,
    county_fips: 20151,
    county_name: "Pratt",
    county_weights: {
      20151: 100,
    },
    county_names_all: "Pratt",
    county_fips_all: 20151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67127,
    lat: 37.16009,
    lng: -99.49057,
    city: "Protection",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 555,
    density: 1.2,
    county_fips: 20033,
    county_name: "Comanche",
    county_weights: {
      20025: 11.56,
      20033: 88.44,
    },
    county_names_all: "Comanche|Clark",
    county_fips_all: "20033|20025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67131,
    lat: 37.43261,
    lng: -96.94958,
    city: "Rock",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 240,
    density: 2.1,
    county_fips: 20035,
    county_name: "Cowley",
    county_weights: {
      20035: 100,
    },
    county_names_all: "Cowley",
    county_fips_all: 20035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67132,
    lat: 37.8504,
    lng: -96.58385,
    city: "Rosalia",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 405,
    density: 1.8,
    county_fips: 20015,
    county_name: "Butler",
    county_weights: {
      20015: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 20015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67133,
    lat: 37.57677,
    lng: -97.10451,
    city: "Rose Hill",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6316,
    density: 58.3,
    county_fips: 20015,
    county_name: "Butler",
    county_weights: {
      20015: 99.4,
      20173: 0.6,
    },
    county_names_all: "Butler|Sedgwick",
    county_fips_all: "20015|20173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67134,
    lat: 37.48474,
    lng: -98.6824,
    city: "Sawyer",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 482,
    density: 2.6,
    county_fips: 20151,
    county_name: "Pratt",
    county_weights: {
      20007: 35.28,
      20151: 64.72,
    },
    county_names_all: "Pratt|Barber",
    county_fips_all: "20151|20007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67135,
    lat: 37.91362,
    lng: -97.45942,
    city: "Sedgwick",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3598,
    density: 13.4,
    county_fips: 20079,
    county_name: "Harvey",
    county_weights: {
      20079: 51.73,
      20173: 48.27,
    },
    county_names_all: "Harvey|Sedgwick",
    county_fips_all: "20079|20173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67137,
    lat: 37.63145,
    lng: -96.22196,
    city: "Severy",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 386,
    density: 1.9,
    county_fips: 20073,
    county_name: "Greenwood",
    county_weights: {
      20049: 28.55,
      20073: 71.45,
    },
    county_names_all: "Greenwood|Elk",
    county_fips_all: "20073|20049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67138,
    lat: 37.25996,
    lng: -98.41858,
    city: "Sharon",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 410,
    density: 1.6,
    county_fips: 20007,
    county_name: "Barber",
    county_weights: {
      20007: 100,
    },
    county_names_all: "Barber",
    county_fips_all: 20007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67140,
    lat: 37.07992,
    lng: -97.35748,
    city: "South Haven",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1059,
    density: 3,
    county_fips: 20191,
    county_name: "Sumner",
    county_weights: {
      20191: 100,
    },
    county_names_all: "Sumner",
    county_fips_all: 20191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67142,
    lat: 37.45655,
    lng: -98.1094,
    city: "Spivey",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 404,
    density: 1.4,
    county_fips: 20095,
    county_name: "Kingman",
    county_weights: {
      20095: 100,
    },
    county_names_all: "Kingman",
    county_fips_all: 20095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67143,
    lat: 37.33284,
    lng: -98.94434,
    city: "Sun City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35,
    density: 0.1,
    county_fips: 20007,
    county_name: "Barber",
    county_weights: {
      20007: 100,
    },
    county_names_all: "Barber",
    county_fips_all: 20007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67144,
    lat: 37.81673,
    lng: -97.00539,
    city: "Towanda",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2831,
    density: 23.2,
    county_fips: 20015,
    county_name: "Butler",
    county_weights: {
      20015: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 20015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67146,
    lat: 37.39016,
    lng: -97.10398,
    city: "Udall",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2098,
    density: 10.5,
    county_fips: 20035,
    county_name: "Cowley",
    county_weights: {
      20035: 86.13,
      20191: 13.87,
    },
    county_names_all: "Cowley|Sumner",
    county_fips_all: "20035|20191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67147,
    lat: 37.86062,
    lng: -97.3058,
    city: "Valley Center",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10697,
    density: 39.9,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20079: 7.66,
      20173: 92.34,
    },
    county_names_all: "Sedgwick|Harvey",
    county_fips_all: "20173|20079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67149,
    lat: 37.54243,
    lng: -97.62915,
    city: "Viola",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1256,
    density: 8.7,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67150,
    lat: 37.03207,
    lng: -98.20187,
    city: "Waldron",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26,
    density: 0.6,
    county_fips: 20077,
    county_name: "Harper",
    county_weights: {
      20077: 100,
    },
    county_names_all: "Harper",
    county_fips_all: 20077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67151,
    lat: 38.14499,
    lng: -97.24934,
    city: "Walton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 446,
    density: 5.4,
    county_fips: 20079,
    county_name: "Harvey",
    county_weights: {
      20079: 84.63,
      20115: 15.37,
    },
    county_names_all: "Harvey|Marion",
    county_fips_all: "20079|20115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67152,
    lat: 37.2623,
    lng: -97.41104,
    city: "Wellington",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8918,
    density: 14.7,
    county_fips: 20191,
    county_name: "Sumner",
    county_weights: {
      20191: 100,
    },
    county_names_all: "Sumner",
    county_fips_all: 20191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67154,
    lat: 37.97079,
    lng: -97.12117,
    city: "Whitewater",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2038,
    density: 10.8,
    county_fips: 20015,
    county_name: "Butler",
    county_weights: {
      20015: 69.73,
      20079: 30.27,
    },
    county_names_all: "Butler|Harvey",
    county_fips_all: "20015|20079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67155,
    lat: 37.28171,
    lng: -99.13233,
    city: "Wilmore",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 139,
    density: 0.2,
    county_fips: 20033,
    county_name: "Comanche",
    county_weights: {
      20033: 87.07,
      20097: 12.93,
    },
    county_names_all: "Comanche|Kiowa",
    county_fips_all: "20033|20097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67156,
    lat: 37.25099,
    lng: -96.96503,
    city: "Winfield",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14634,
    density: 22.6,
    county_fips: 20035,
    county_name: "Cowley",
    county_weights: {
      20035: 100,
    },
    county_names_all: "Cowley",
    county_fips_all: 20035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67159,
    lat: 37.42053,
    lng: -98.30948,
    city: "Zenda",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 91,
    density: 0.4,
    county_fips: 20095,
    county_name: "Kingman",
    county_weights: {
      20077: 31.32,
      20095: 68.68,
    },
    county_names_all: "Kingman|Harper",
    county_fips_all: "20095|20077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67202,
    lat: 37.68668,
    lng: -97.33521,
    city: "Wichita",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1940,
    density: 775.7,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67203,
    lat: 37.70402,
    lng: -97.36497,
    city: "Wichita",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30064,
    density: 1620.7,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67204,
    lat: 37.77167,
    lng: -97.36341,
    city: "Wichita",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21958,
    density: 527.2,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67205,
    lat: 37.75012,
    lng: -97.42317,
    city: "Wichita",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20232,
    density: 463,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67206,
    lat: 37.70363,
    lng: -97.22461,
    city: "Wichita",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17393,
    density: 640.2,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67207,
    lat: 37.66567,
    lng: -97.22923,
    city: "Wichita",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27774,
    density: 1029.3,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67208,
    lat: 37.70449,
    lng: -97.27928,
    city: "Wichita",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17624,
    density: 1366.1,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67209,
    lat: 37.6639,
    lng: -97.43463,
    city: "Wichita",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13398,
    density: 420.8,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67210,
    lat: 37.62944,
    lng: -97.24604,
    city: "Wichita",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10001,
    density: 311.6,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67211,
    lat: 37.66708,
    lng: -97.31706,
    city: "Wichita",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19017,
    density: 1448.5,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67212,
    lat: 37.70247,
    lng: -97.43658,
    city: "Wichita",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44396,
    density: 1368.9,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67213,
    lat: 37.66722,
    lng: -97.36498,
    city: "Wichita",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22287,
    density: 1310,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67214,
    lat: 37.70661,
    lng: -97.31755,
    city: "Wichita",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15826,
    density: 1143.1,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67215,
    lat: 37.61637,
    lng: -97.42707,
    city: "Wichita",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5852,
    density: 131.5,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67216,
    lat: 37.6089,
    lng: -97.3143,
    city: "Wichita",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22221,
    density: 700.5,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67217,
    lat: 37.61535,
    lng: -97.36239,
    city: "Wichita",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31134,
    density: 833.2,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67218,
    lat: 37.66851,
    lng: -97.28039,
    city: "Wichita",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22775,
    density: 1765.4,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67219,
    lat: 37.76931,
    lng: -97.31643,
    city: "Wichita",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12240,
    density: 326.6,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67220,
    lat: 37.75191,
    lng: -97.27909,
    city: "Wichita",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13004,
    density: 698.3,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67221,
    lat: 37.63544,
    lng: -97.25819,
    city: "Mcconnell Afb",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67223,
    lat: 37.74195,
    lng: -97.49797,
    city: "Wichita",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 620,
    density: 65.8,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67226,
    lat: 37.76898,
    lng: -97.21915,
    city: "Wichita",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20926,
    density: 327.5,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67227,
    lat: 37.62693,
    lng: -97.50109,
    city: "Wichita",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 211,
    density: 17,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67228,
    lat: 37.77749,
    lng: -97.17274,
    city: "Wichita",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2429,
    density: 75.4,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67230,
    lat: 37.68655,
    lng: -97.17087,
    city: "Wichita",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11121,
    density: 439.9,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20015: 0.6,
      20173: 99.4,
    },
    county_names_all: "Sedgwick|Butler",
    county_fips_all: "20173|20015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67232,
    lat: 37.6368,
    lng: -97.16802,
    city: "Wichita",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 489,
    density: 61.3,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67235,
    lat: 37.68951,
    lng: -97.49929,
    city: "Wichita",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14352,
    density: 513.2,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67260,
    lat: 37.71931,
    lng: -97.2935,
    city: "Wichita",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 20173,
    county_name: "Sedgwick",
    county_weights: {
      20173: 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: 20173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67301,
    lat: 37.21092,
    lng: -95.75224,
    city: "Independence",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12647,
    density: 22.7,
    county_fips: 20125,
    county_name: "Montgomery",
    county_weights: {
      20125: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 20125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67330,
    lat: 37.163,
    lng: -95.31238,
    city: "Altamont",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1331,
    density: 8.4,
    county_fips: 20099,
    county_name: "Labette",
    county_weights: {
      20099: 100,
    },
    county_names_all: "Labette",
    county_fips_all: 20099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67332,
    lat: 37.04345,
    lng: -95.23281,
    city: "Bartlett",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 150,
    density: 2.3,
    county_fips: 20099,
    county_name: "Labette",
    county_weights: {
      20099: 100,
    },
    county_names_all: "Labette",
    county_fips_all: 20099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67333,
    lat: 37.04695,
    lng: -95.87253,
    city: "Caney",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2536,
    density: 18.1,
    county_fips: 20125,
    county_name: "Montgomery",
    county_weights: {
      20125: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 20125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67334,
    lat: 37.0241,
    lng: -96.17736,
    city: "Chautauqua",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55,
    density: 50,
    county_fips: 20019,
    county_name: "Chautauqua",
    county_weights: {
      20019: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 20019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67335,
    lat: 37.28005,
    lng: -95.53381,
    city: "Cherryvale",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3409,
    density: 10.4,
    county_fips: 20125,
    county_name: "Montgomery",
    county_weights: {
      20099: 41,
      20125: 56.95,
      20205: 2.05,
    },
    county_names_all: "Montgomery|Labette|Wilson",
    county_fips_all: "20125|20099|20205",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67336,
    lat: 37.05385,
    lng: -95.07489,
    city: "Chetopa",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1547,
    density: 6.5,
    county_fips: 20021,
    county_name: "Cherokee",
    county_weights: {
      20021: 55.71,
      20099: 44.29,
    },
    county_names_all: "Cherokee|Labette",
    county_fips_all: "20021|20099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67337,
    lat: 37.05486,
    lng: -95.5993,
    city: "Coffeyville",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11569,
    density: 30.3,
    county_fips: 20125,
    county_name: "Montgomery",
    county_weights: {
      20099: 28.18,
      20125: 71.82,
    },
    county_names_all: "Montgomery|Labette",
    county_fips_all: "20125|20099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67340,
    lat: 37.05948,
    lng: -95.71207,
    city: "Dearing",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 512,
    density: 245.5,
    county_fips: 20125,
    county_name: "Montgomery",
    county_weights: {
      20125: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 20125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67341,
    lat: 37.34406,
    lng: -95.42963,
    city: "Dennis",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 379,
    density: 7,
    county_fips: 20099,
    county_name: "Labette",
    county_weights: {
      20099: 100,
    },
    county_names_all: "Labette",
    county_fips_all: 20099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67342,
    lat: 37.05877,
    lng: -95.35513,
    city: "Edna",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 768,
    density: 4.4,
    county_fips: 20099,
    county_name: "Labette",
    county_weights: {
      20099: 100,
    },
    county_names_all: "Labette",
    county_fips_all: 20099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67344,
    lat: 37.28875,
    lng: -95.9514,
    city: "Elk City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 758,
    density: 1.8,
    county_fips: 20125,
    county_name: "Montgomery",
    county_weights: {
      20019: 32.72,
      20049: 12.57,
      20125: 54.71,
    },
    county_names_all: "Montgomery|Chautauqua|Elk",
    county_fips_all: "20125|20019|20049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67345,
    lat: 37.37122,
    lng: -96.20075,
    city: "Elk Falls",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 124,
    density: 1.1,
    county_fips: 20049,
    county_name: "Elk",
    county_weights: {
      20049: 100,
    },
    county_names_all: "Elk",
    county_fips_all: 20049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67346,
    lat: 37.31774,
    lng: -96.44511,
    city: "Grenola",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 340,
    density: 1.1,
    county_fips: 20049,
    county_name: "Elk",
    county_weights: {
      20019: 44.5,
      20049: 55.5,
    },
    county_names_all: "Elk|Chautauqua",
    county_fips_all: "20049|20019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67347,
    lat: 37.12559,
    lng: -95.95188,
    city: "Havana",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 461,
    density: 2.9,
    county_fips: 20125,
    county_name: "Montgomery",
    county_weights: {
      20019: 39.33,
      20125: 60.67,
    },
    county_names_all: "Montgomery|Chautauqua",
    county_fips_all: "20125|20019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67349,
    lat: 37.48811,
    lng: -96.28066,
    city: "Howard",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 876,
    density: 1.4,
    county_fips: 20049,
    county_name: "Elk",
    county_weights: {
      20049: 100,
    },
    county_names_all: "Elk",
    county_fips_all: 20049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67351,
    lat: 37.14066,
    lng: -95.56698,
    city: "Liberty",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 277,
    density: 2.5,
    county_fips: 20125,
    county_name: "Montgomery",
    county_weights: {
      20099: 19.79,
      20125: 80.21,
    },
    county_names_all: "Montgomery|Labette",
    county_fips_all: "20125|20099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67352,
    lat: 37.3574,
    lng: -96.08154,
    city: "Longton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 603,
    density: 2.2,
    county_fips: 20049,
    county_name: "Elk",
    county_weights: {
      20019: 22.02,
      20049: 77.98,
    },
    county_names_all: "Elk|Chautauqua",
    county_fips_all: "20049|20019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67353,
    lat: 37.31371,
    lng: -96.31151,
    city: "Moline",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 497,
    density: 2.3,
    county_fips: 20049,
    county_name: "Elk",
    county_weights: {
      20019: 39.38,
      20049: 60.62,
    },
    county_names_all: "Elk|Chautauqua",
    county_fips_all: "20049|20019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67354,
    lat: 37.20727,
    lng: -95.41126,
    city: "Mound Valley",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 732,
    density: 5,
    county_fips: 20099,
    county_name: "Labette",
    county_weights: {
      20099: 100,
    },
    county_names_all: "Labette",
    county_fips_all: 20099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67355,
    lat: 37.03275,
    lng: -96.00974,
    city: "Niotaze",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 181,
    density: 3,
    county_fips: 20019,
    county_name: "Chautauqua",
    county_weights: {
      20019: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 20019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67356,
    lat: 37.17886,
    lng: -95.14161,
    city: "Oswego",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2897,
    density: 9.2,
    county_fips: 20099,
    county_name: "Labette",
    county_weights: {
      20021: 7.68,
      20099: 92.32,
    },
    county_names_all: "Labette|Cherokee",
    county_fips_all: "20099|20021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67357,
    lat: 37.33951,
    lng: -95.25261,
    city: "Parsons",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11700,
    density: 22.9,
    county_fips: 20099,
    county_name: "Labette",
    county_weights: {
      20099: 73.44,
      20133: 26.56,
    },
    county_names_all: "Labette|Neosho",
    county_fips_all: "20099|20133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67360,
    lat: 37.05148,
    lng: -96.09702,
    city: "Peru",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 403,
    density: 3.4,
    county_fips: 20019,
    county_name: "Chautauqua",
    county_weights: {
      20019: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 20019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67361,
    lat: 37.13733,
    lng: -96.21714,
    city: "Sedan",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1563,
    density: 2.5,
    county_fips: 20019,
    county_name: "Chautauqua",
    county_weights: {
      20019: 100,
    },
    county_names_all: "Chautauqua",
    county_fips_all: 20019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67363,
    lat: 37.32934,
    lng: -95.71819,
    city: "Sycamore",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 162,
    density: 56.5,
    county_fips: 20125,
    county_name: "Montgomery",
    county_weights: {
      20125: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 20125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67364,
    lat: 37.03683,
    lng: -95.82184,
    city: "Tyro",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 310,
    density: 265.7,
    county_fips: 20125,
    county_name: "Montgomery",
    county_weights: {
      20125: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 20125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67401,
    lat: 38.83554,
    lng: -97.64621,
    city: "Salina",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50754,
    density: 77.8,
    county_fips: 20169,
    county_name: "Saline",
    county_weights: {
      20143: 4.46,
      20169: 95.54,
    },
    county_names_all: "Saline|Ottawa",
    county_fips_all: "20169|20143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67410,
    lat: 38.95632,
    lng: -97.22104,
    city: "Abilene",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10358,
    density: 12.7,
    county_fips: 20041,
    county_name: "Dickinson",
    county_weights: {
      20027: 0.55,
      20041: 99.45,
    },
    county_names_all: "Dickinson|Clay",
    county_fips_all: "20041|20027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67416,
    lat: 38.66505,
    lng: -97.5718,
    city: "Assaria",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 903,
    density: 5,
    county_fips: 20169,
    county_name: "Saline",
    county_weights: {
      20113: 12.63,
      20169: 87.37,
    },
    county_names_all: "Saline|McPherson",
    county_fips_all: "20169|20113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67417,
    lat: 39.43382,
    lng: -97.55015,
    city: "Aurora",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 158,
    density: 0.9,
    county_fips: 20029,
    county_name: "Cloud",
    county_weights: {
      20029: 100,
    },
    county_names_all: "Cloud",
    county_fips_all: 20029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67418,
    lat: 39.18692,
    lng: -98.05214,
    city: "Barnard",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 218,
    density: 0.7,
    county_fips: 20105,
    county_name: "Lincoln",
    county_weights: {
      20105: 75.39,
      20123: 24.61,
    },
    county_names_all: "Lincoln|Mitchell",
    county_fips_all: "20105|20123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67420,
    lat: 39.40035,
    lng: -98.08527,
    city: "Beloit",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4190,
    density: 3.8,
    county_fips: 20123,
    county_name: "Mitchell",
    county_weights: {
      20029: 5.79,
      20089: 0.72,
      20123: 93.49,
    },
    county_names_all: "Mitchell|Cloud|Jewell",
    county_fips_all: "20123|20029|20089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67422,
    lat: 39.03127,
    lng: -97.59849,
    city: "Bennington",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1425,
    density: 9.5,
    county_fips: 20143,
    county_name: "Ottawa",
    county_weights: {
      20143: 100,
    },
    county_names_all: "Ottawa",
    county_fips_all: 20143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67423,
    lat: 38.97018,
    lng: -97.98058,
    city: "Beverly",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 213,
    density: 1.3,
    county_fips: 20105,
    county_name: "Lincoln",
    county_weights: {
      20105: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 20105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67425,
    lat: 38.77991,
    lng: -97.92492,
    city: "Brookville",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 724,
    density: 1.3,
    county_fips: 20169,
    county_name: "Saline",
    county_weights: {
      20053: 44.81,
      20169: 55.19,
    },
    county_names_all: "Saline|Ellsworth",
    county_fips_all: "20169|20053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67427,
    lat: 38.50364,
    lng: -98.39977,
    city: "Bushton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 429,
    density: 2.8,
    county_fips: 20159,
    county_name: "Rice",
    county_weights: {
      20053: 31.4,
      20159: 68.6,
    },
    county_names_all: "Rice|Ellsworth",
    county_fips_all: "20159|20053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67428,
    lat: 38.3832,
    lng: -97.41405,
    city: "Canton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1422,
    density: 4.8,
    county_fips: 20113,
    county_name: "McPherson",
    county_weights: {
      20113: 86.55,
      20115: 13.45,
    },
    county_names_all: "McPherson|Marion",
    county_fips_all: "20113|20115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67430,
    lat: 39.57571,
    lng: -98.44193,
    city: "Cawker City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 620,
    density: 2.4,
    county_fips: 20089,
    county_name: "Jewell",
    county_weights: {
      20089: 51.36,
      20123: 39.73,
      20141: 2.9,
      20183: 6.01,
    },
    county_names_all: "Jewell|Mitchell|Smith|Osborne",
    county_fips_all: "20089|20123|20183|20141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67431,
    lat: 38.95833,
    lng: -97.01179,
    city: "Chapman",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1889,
    density: 5.9,
    county_fips: 20041,
    county_name: "Dickinson",
    county_weights: {
      20041: 100,
    },
    county_names_all: "Dickinson",
    county_fips_all: 20041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67432,
    lat: 39.33503,
    lng: -97.17997,
    city: "Clay Center",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5379,
    density: 5.8,
    county_fips: 20027,
    county_name: "Clay",
    county_weights: {
      20027: 90.24,
      20143: 9.37,
      20161: 0.39,
    },
    county_names_all: "Clay|Ottawa|Riley",
    county_fips_all: "20027|20143|20161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67436,
    lat: 39.28071,
    lng: -97.72454,
    city: "Delphos",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 637,
    density: 2.2,
    county_fips: 20143,
    county_name: "Ottawa",
    county_weights: {
      20029: 24.85,
      20143: 75.15,
    },
    county_names_all: "Ottawa|Cloud",
    county_fips_all: "20143|20029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67437,
    lat: 39.50705,
    lng: -98.55857,
    city: "Downs",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 871,
    density: 2.7,
    county_fips: 20141,
    county_name: "Osborne",
    county_weights: {
      20141: 77.3,
      20183: 22.7,
    },
    county_names_all: "Osborne|Smith",
    county_fips_all: "20141|20183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67438,
    lat: 38.50366,
    lng: -97.27861,
    city: "Durham",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 251,
    density: 1.5,
    county_fips: 20115,
    county_name: "Marion",
    county_weights: {
      20115: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 20115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67439,
    lat: 38.76169,
    lng: -98.2201,
    city: "Ellsworth",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3314,
    density: 5.6,
    county_fips: 20053,
    county_name: "Ellsworth",
    county_weights: {
      20053: 95.39,
      20105: 4.61,
    },
    county_names_all: "Ellsworth|Lincoln",
    county_fips_all: "20053|20105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67441,
    lat: 38.87712,
    lng: -97.10399,
    city: "Enterprise",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1115,
    density: 10.9,
    county_fips: 20041,
    county_name: "Dickinson",
    county_weights: {
      20041: 100,
    },
    county_names_all: "Dickinson",
    county_fips_all: 20041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67442,
    lat: 38.64939,
    lng: -97.78073,
    city: "Falun",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 201,
    density: 1.7,
    county_fips: 20169,
    county_name: "Saline",
    county_weights: {
      20169: 100,
    },
    county_names_all: "Saline",
    county_fips_all: 20169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67443,
    lat: 38.37801,
    lng: -97.5208,
    city: "Galva",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1599,
    density: 7,
    county_fips: 20113,
    county_name: "McPherson",
    county_weights: {
      20113: 100,
    },
    county_names_all: "McPherson",
    county_fips_all: 20113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67444,
    lat: 38.54759,
    lng: -98.12702,
    city: "Geneseo",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 549,
    density: 1.3,
    county_fips: 20053,
    county_name: "Ellsworth",
    county_weights: {
      20053: 61.06,
      20159: 38.94,
    },
    county_names_all: "Ellsworth|Rice",
    county_fips_all: "20053|20159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67445,
    lat: 39.37789,
    lng: -97.8172,
    city: "Glasco",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 629,
    density: 2.2,
    county_fips: 20029,
    county_name: "Cloud",
    county_weights: {
      20029: 89.88,
      20143: 10.12,
    },
    county_names_all: "Cloud|Ottawa",
    county_fips_all: "20029|20143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67446,
    lat: 39.47442,
    lng: -98.32363,
    city: "Glen Elder",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 664,
    density: 1.8,
    county_fips: 20123,
    county_name: "Mitchell",
    county_weights: {
      20089: 14.83,
      20123: 85.17,
    },
    county_names_all: "Mitchell|Jewell",
    county_fips_all: "20123|20089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67447,
    lat: 39.48048,
    lng: -96.97153,
    city: "Green",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 338,
    density: 1.7,
    county_fips: 20027,
    county_name: "Clay",
    county_weights: {
      20027: 58.94,
      20161: 41.06,
    },
    county_names_all: "Clay|Riley",
    county_fips_all: "20027|20161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67448,
    lat: 38.65826,
    lng: -97.40756,
    city: "Gypsum",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1192,
    density: 2.2,
    county_fips: 20169,
    county_name: "Saline",
    county_weights: {
      20041: 29.56,
      20113: 25.15,
      20169: 45.29,
    },
    county_names_all: "Saline|Dickinson|McPherson",
    county_fips_all: "20169|20041|20113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67449,
    lat: 38.68214,
    lng: -96.89569,
    city: "Herington",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2846,
    density: 6.8,
    county_fips: 20127,
    county_name: "Morris",
    county_weights: {
      20041: 35.7,
      20127: 64.3,
    },
    county_names_all: "Morris|Dickinson",
    county_fips_all: "20127|20041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67450,
    lat: 38.62746,
    lng: -98.45788,
    city: "Holyrood",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 582,
    density: 4.5,
    county_fips: 20053,
    county_name: "Ellsworth",
    county_weights: {
      20009: 30.13,
      20053: 69.87,
    },
    county_names_all: "Ellsworth|Barton",
    county_fips_all: "20053|20009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67451,
    lat: 38.70094,
    lng: -97.13157,
    city: "Hope",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1093,
    density: 3,
    county_fips: 20041,
    county_name: "Dickinson",
    county_weights: {
      20041: 98.79,
      20115: 1.21,
    },
    county_names_all: "Dickinson|Marion",
    county_fips_all: "20041|20115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67452,
    lat: 39.23549,
    lng: -98.36935,
    city: "Hunter",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 295,
    density: 0.9,
    county_fips: 20123,
    county_name: "Mitchell",
    county_weights: {
      20105: 44.35,
      20123: 55.65,
    },
    county_names_all: "Mitchell|Lincoln",
    county_fips_all: "20123|20105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67454,
    lat: 38.69808,
    lng: -98.11308,
    city: "Kanopolis",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 618,
    density: 6.2,
    county_fips: 20053,
    county_name: "Ellsworth",
    county_weights: {
      20053: 100,
    },
    county_names_all: "Ellsworth",
    county_fips_all: 20053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67455,
    lat: 39.02765,
    lng: -98.16478,
    city: "Lincoln",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1826,
    density: 2.4,
    county_fips: 20105,
    county_name: "Lincoln",
    county_weights: {
      20105: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 20105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67456,
    lat: 38.5949,
    lng: -97.6769,
    city: "Lindsborg",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4123,
    density: 11.1,
    county_fips: 20113,
    county_name: "McPherson",
    county_weights: {
      20113: 68.54,
      20169: 31.46,
    },
    county_names_all: "McPherson|Saline",
    county_fips_all: "20113|20169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67457,
    lat: 38.38746,
    lng: -97.99143,
    city: "Little River",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 772,
    density: 3,
    county_fips: 20159,
    county_name: "Rice",
    county_weights: {
      20159: 100,
    },
    county_names_all: "Rice",
    county_fips_all: 20159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67458,
    lat: 39.16595,
    lng: -97.30441,
    city: "Longford",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 356,
    density: 1.9,
    county_fips: 20027,
    county_name: "Clay",
    county_weights: {
      20027: 76.21,
      20143: 23.79,
    },
    county_names_all: "Clay|Ottawa",
    county_fips_all: "20027|20143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67459,
    lat: 38.60781,
    lng: -98.33913,
    city: "Lorraine",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 402,
    density: 2.1,
    county_fips: 20053,
    county_name: "Ellsworth",
    county_weights: {
      20053: 100,
    },
    county_names_all: "Ellsworth",
    county_fips_all: 20053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67460,
    lat: 38.38431,
    lng: -97.69719,
    city: "Mcpherson",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15454,
    density: 26.3,
    county_fips: 20113,
    county_name: "McPherson",
    county_weights: {
      20113: 100,
    },
    county_names_all: "McPherson",
    county_fips_all: 20113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67464,
    lat: 38.56537,
    lng: -97.90143,
    city: "Marquette",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 851,
    density: 2.9,
    county_fips: 20113,
    county_name: "McPherson",
    county_weights: {
      20053: 42.23,
      20113: 57.77,
    },
    county_names_all: "McPherson|Ellsworth",
    county_fips_all: "20113|20053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67466,
    lat: 39.32787,
    lng: -97.47905,
    city: "Miltonvale",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 716,
    density: 1.9,
    county_fips: 20029,
    county_name: "Cloud",
    county_weights: {
      20027: 9.75,
      20029: 58.61,
      20143: 31.64,
    },
    county_names_all: "Cloud|Ottawa|Clay",
    county_fips_all: "20029|20143|20027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67467,
    lat: 39.14639,
    lng: -97.69907,
    city: "Minneapolis",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2499,
    density: 3.5,
    county_fips: 20143,
    county_name: "Ottawa",
    county_weights: {
      20105: 0.36,
      20143: 99.64,
    },
    county_names_all: "Ottawa|Lincoln",
    county_fips_all: "20143|20105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67468,
    lat: 39.45791,
    lng: -97.25697,
    city: "Morganville",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 342,
    density: 3.2,
    county_fips: 20027,
    county_name: "Clay",
    county_weights: {
      20027: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 20027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67470,
    lat: 38.91077,
    lng: -97.49513,
    city: "New Cambria",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 420,
    density: 3,
    county_fips: 20169,
    county_name: "Saline",
    county_weights: {
      20143: 13.76,
      20169: 86.24,
    },
    county_names_all: "Saline|Ottawa",
    county_fips_all: "20169|20143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67473,
    lat: 39.37567,
    lng: -98.73356,
    city: "Osborne",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1791,
    density: 2.8,
    county_fips: 20141,
    county_name: "Osborne",
    county_weights: {
      20141: 100,
    },
    county_names_all: "Osborne",
    county_fips_all: 20141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67474,
    lat: 39.58523,
    lng: -98.70771,
    city: "Portis",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 239,
    density: 0.9,
    county_fips: 20183,
    county_name: "Smith",
    county_weights: {
      20141: 46.06,
      20183: 53.94,
    },
    county_names_all: "Smith|Osborne",
    county_fips_all: "20183|20141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67475,
    lat: 38.58761,
    lng: -97.05853,
    city: "Ramona",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 123,
    density: 1.7,
    county_fips: 20115,
    county_name: "Marion",
    county_weights: {
      20041: 21.95,
      20115: 78.05,
    },
    county_names_all: "Marion|Dickinson",
    county_fips_all: "20115|20041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67476,
    lat: 38.54867,
    lng: -97.43047,
    city: "Roxbury",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 20113,
    county_name: "McPherson",
    county_weights: {
      20113: 100,
    },
    county_names_all: "McPherson",
    county_fips_all: 20113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67478,
    lat: 39.38572,
    lng: -97.94988,
    city: "Simpson",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 76,
    density: 16.4,
    county_fips: 20123,
    county_name: "Mitchell",
    county_weights: {
      20123: 100,
    },
    county_names_all: "Mitchell",
    county_fips_all: 20123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67480,
    lat: 38.97073,
    lng: -97.40282,
    city: "Solomon",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1617,
    density: 3.8,
    county_fips: 20143,
    county_name: "Ottawa",
    county_weights: {
      20041: 32.7,
      20143: 47.29,
      20169: 20.01,
    },
    county_names_all: "Ottawa|Dickinson|Saline",
    county_fips_all: "20143|20041|20169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67481,
    lat: 39.01244,
    lng: -98.38903,
    city: "Sylvan Grove",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 663,
    density: 1.4,
    county_fips: 20105,
    county_name: "Lincoln",
    county_weights: {
      20105: 97.66,
      20167: 2.34,
    },
    county_names_all: "Lincoln|Russell",
    county_fips_all: "20105|20167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67482,
    lat: 39.02686,
    lng: -97.25976,
    city: "Talmage",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 129,
    density: 507.4,
    county_fips: 20041,
    county_name: "Dickinson",
    county_weights: {
      20041: 100,
    },
    county_names_all: "Dickinson",
    county_fips_all: 20041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67483,
    lat: 38.55322,
    lng: -97.19856,
    city: "Tampa",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 655,
    density: 2.9,
    county_fips: 20115,
    county_name: "Marion",
    county_weights: {
      20115: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 20115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67484,
    lat: 38.99603,
    lng: -97.83617,
    city: "Tescott",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1005,
    density: 2.8,
    county_fips: 20143,
    county_name: "Ottawa",
    county_weights: {
      20105: 8.73,
      20143: 67.16,
      20169: 24.11,
    },
    county_names_all: "Ottawa|Saline|Lincoln",
    county_fips_all: "20143|20169|20105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67485,
    lat: 39.31474,
    lng: -98.49492,
    city: "Tipton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 358,
    density: 1.2,
    county_fips: 20141,
    county_name: "Osborne",
    county_weights: {
      20123: 48.46,
      20141: 51.54,
    },
    county_names_all: "Osborne|Mitchell",
    county_fips_all: "20141|20123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67487,
    lat: 39.17628,
    lng: -97.06653,
    city: "Wakefield",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1328,
    density: 5.2,
    county_fips: 20027,
    county_name: "Clay",
    county_weights: {
      20027: 81.25,
      20041: 12.93,
      20061: 5.82,
    },
    county_names_all: "Clay|Dickinson|Geary",
    county_fips_all: "20027|20041|20061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67490,
    lat: 38.79223,
    lng: -98.44722,
    city: "Wilson",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 852,
    density: 2.2,
    county_fips: 20053,
    county_name: "Ellsworth",
    county_weights: {
      20053: 59.44,
      20105: 8.12,
      20167: 32.44,
    },
    county_names_all: "Ellsworth|Russell|Lincoln",
    county_fips_all: "20053|20167|20105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67491,
    lat: 38.38837,
    lng: -97.90051,
    city: "Windom",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 380,
    density: 2.1,
    county_fips: 20113,
    county_name: "McPherson",
    county_weights: {
      20113: 78.88,
      20159: 21.12,
    },
    county_names_all: "McPherson|Rice",
    county_fips_all: "20113|20159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67492,
    lat: 38.81558,
    lng: -96.96418,
    city: "Woodbine",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 124,
    density: 1.6,
    county_fips: 20041,
    county_name: "Dickinson",
    county_weights: {
      20041: 100,
    },
    county_names_all: "Dickinson",
    county_fips_all: 20041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67501,
    lat: 37.97989,
    lng: -97.9309,
    city: "Hutchinson",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25295,
    density: 52,
    county_fips: 20155,
    county_name: "Reno",
    county_weights: {
      20155: 100,
    },
    county_names_all: "Reno",
    county_fips_all: 20155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67502,
    lat: 38.12146,
    lng: -97.92673,
    city: "Hutchinson",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24051,
    density: 126.6,
    county_fips: 20155,
    county_name: "Reno",
    county_weights: {
      20155: 98.65,
      20159: 1.35,
    },
    county_names_all: "Reno|Rice",
    county_fips_all: "20155|20159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67505,
    lat: 38.02855,
    lng: -97.94333,
    city: "South Hutchinson",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2651,
    density: 371.5,
    county_fips: 20155,
    county_name: "Reno",
    county_weights: {
      20155: 100,
    },
    county_names_all: "Reno",
    county_fips_all: 20155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67510,
    lat: 37.99839,
    lng: -98.21127,
    city: "Abbyville",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 191,
    density: 1.3,
    county_fips: 20155,
    county_name: "Reno",
    county_weights: {
      20155: 100,
    },
    county_names_all: "Reno",
    county_fips_all: 20155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67511,
    lat: 38.43365,
    lng: -99.05058,
    city: "Albert",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 216,
    density: 1.2,
    county_fips: 20165,
    county_name: "Rush",
    county_weights: {
      20009: 35.93,
      20165: 64.07,
    },
    county_names_all: "Rush|Barton",
    county_fips_all: "20165|20009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67512,
    lat: 38.23289,
    lng: -98.32645,
    city: "Alden",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 228,
    density: 2.7,
    county_fips: 20159,
    county_name: "Rice",
    county_weights: {
      20155: 3.98,
      20159: 96.02,
    },
    county_names_all: "Rice|Reno",
    county_fips_all: "20159|20155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67513,
    lat: 38.43892,
    lng: -99.53846,
    city: "Alexander",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69,
    density: 0.5,
    county_fips: 20165,
    county_name: "Rush",
    county_weights: {
      20165: 100,
    },
    county_names_all: "Rush",
    county_fips_all: 20165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67514,
    lat: 37.86278,
    lng: -98.19714,
    city: "Arlington",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 963,
    density: 4.6,
    county_fips: 20155,
    county_name: "Reno",
    county_weights: {
      20155: 100,
    },
    county_names_all: "Reno",
    county_fips_all: 20155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67515,
    lat: 38.59935,
    lng: -100.06518,
    city: "Arnold",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45,
    density: 0.8,
    county_fips: 20135,
    county_name: "Ness",
    county_weights: {
      20135: 100,
    },
    county_names_all: "Ness",
    county_fips_all: 20135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67516,
    lat: 38.38768,
    lng: -99.68486,
    city: "Bazine",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 422,
    density: 1,
    county_fips: 20135,
    county_name: "Ness",
    county_weights: {
      20135: 100,
    },
    county_names_all: "Ness",
    county_fips_all: 20135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67518,
    lat: 38.40403,
    lng: -100.17343,
    city: "Beeler",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31,
    density: 0.1,
    county_fips: 20135,
    county_name: "Ness",
    county_weights: {
      20101: 7.45,
      20135: 92.55,
    },
    county_names_all: "Ness|Lane",
    county_fips_all: "20135|20101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67519,
    lat: 37.93573,
    lng: -99.10292,
    city: "Belpre",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 117,
    density: 0.5,
    county_fips: 20047,
    county_name: "Edwards",
    county_weights: {
      20047: 87.46,
      20145: 12.54,
    },
    county_names_all: "Edwards|Pawnee",
    county_fips_all: "20047|20145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67520,
    lat: 38.58781,
    lng: -99.18302,
    city: "Bison",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 296,
    density: 1,
    county_fips: 20165,
    county_name: "Rush",
    county_weights: {
      20165: 100,
    },
    county_names_all: "Rush",
    county_fips_all: 20165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67521,
    lat: 38.62575,
    lng: -99.72253,
    city: "Brownell",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 160,
    density: 0.4,
    county_fips: 20135,
    county_name: "Ness",
    county_weights: {
      20135: 78.22,
      20195: 21.78,
    },
    county_names_all: "Ness|Trego",
    county_fips_all: "20135|20195",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67522,
    lat: 38.12294,
    lng: -97.74608,
    city: "Buhler",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1942,
    density: 13.1,
    county_fips: 20155,
    county_name: "Reno",
    county_weights: {
      20079: 21.7,
      20155: 78.3,
    },
    county_names_all: "Reno|Harvey",
    county_fips_all: "20155|20079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67523,
    lat: 38.19687,
    lng: -99.55256,
    city: "Burdett",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 557,
    density: 1.5,
    county_fips: 20145,
    county_name: "Pawnee",
    county_weights: {
      20083: 34.25,
      20145: 65.75,
    },
    county_names_all: "Pawnee|Hodgeman",
    county_fips_all: "20145|20083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67524,
    lat: 38.37797,
    lng: -98.37398,
    city: "Chase",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 585,
    density: 3.7,
    county_fips: 20159,
    county_name: "Rice",
    county_weights: {
      20159: 100,
    },
    county_names_all: "Rice",
    county_fips_all: 20159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67525,
    lat: 38.57205,
    lng: -98.57111,
    city: "Claflin",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 970,
    density: 3,
    county_fips: 20009,
    county_name: "Barton",
    county_weights: {
      20009: 97.56,
      20159: 2.44,
    },
    county_names_all: "Barton|Rice",
    county_fips_all: "20009|20159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67526,
    lat: 38.29764,
    lng: -98.54711,
    city: "Ellinwood",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2751,
    density: 4.9,
    county_fips: 20009,
    county_name: "Barton",
    county_weights: {
      20009: 57.12,
      20159: 6.68,
      20185: 36.2,
    },
    county_names_all: "Barton|Stafford|Rice",
    county_fips_all: "20009|20185|20159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67529,
    lat: 38.0728,
    lng: -99.25436,
    city: "Garfield",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 284,
    density: 1,
    county_fips: 20145,
    county_name: "Pawnee",
    county_weights: {
      20145: 100,
    },
    county_names_all: "Pawnee",
    county_fips_all: 20145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67530,
    lat: 38.35149,
    lng: -98.79678,
    city: "Great Bend",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18493,
    density: 30,
    county_fips: 20009,
    county_name: "Barton",
    county_weights: {
      20009: 90.91,
      20185: 9.09,
    },
    county_names_all: "Barton|Stafford",
    county_fips_all: "20009|20185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67543,
    lat: 37.88346,
    lng: -97.79511,
    city: "Haven",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2126,
    density: 9.6,
    county_fips: 20155,
    county_name: "Reno",
    county_weights: {
      20155: 100,
    },
    county_names_all: "Reno",
    county_fips_all: 20155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67544,
    lat: 38.57584,
    lng: -98.75456,
    city: "Hoisington",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3056,
    density: 5.5,
    county_fips: 20009,
    county_name: "Barton",
    county_weights: {
      20009: 100,
    },
    county_names_all: "Barton",
    county_fips_all: 20009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67545,
    lat: 38.17644,
    lng: -98.6417,
    city: "Hudson",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 170,
    density: 1.4,
    county_fips: 20185,
    county_name: "Stafford",
    county_weights: {
      20185: 100,
    },
    county_names_all: "Stafford",
    county_fips_all: 20185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67546,
    lat: 38.22811,
    lng: -97.82116,
    city: "Inman",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2398,
    density: 6.7,
    county_fips: 20113,
    county_name: "McPherson",
    county_weights: {
      20079: 0.69,
      20113: 79.79,
      20155: 3.11,
      20159: 16.41,
    },
    county_names_all: "McPherson|Rice|Reno|Harvey",
    county_fips_all: "20113|20159|20155|20079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67547,
    lat: 37.93926,
    lng: -99.46526,
    city: "Kinsley",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1769,
    density: 2.3,
    county_fips: 20047,
    county_name: "Edwards",
    county_weights: {
      20047: 84.53,
      20083: 15.47,
    },
    county_names_all: "Edwards|Hodgeman",
    county_fips_all: "20047|20083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67548,
    lat: 38.59299,
    lng: -99.33579,
    city: "La Crosse",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1472,
    density: 4.7,
    county_fips: 20165,
    county_name: "Rush",
    county_weights: {
      20165: 100,
    },
    county_names_all: "Rush",
    county_fips_all: 20165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67550,
    lat: 38.18121,
    lng: -99.12487,
    city: "Larned",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5443,
    density: 6.9,
    county_fips: 20145,
    county_name: "Pawnee",
    county_weights: {
      20145: 99.35,
      20185: 0.65,
    },
    county_names_all: "Pawnee|Stafford",
    county_fips_all: "20145|20185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67552,
    lat: 37.8606,
    lng: -99.23651,
    city: "Lewis",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 665,
    density: 1.4,
    county_fips: 20047,
    county_name: "Edwards",
    county_weights: {
      20047: 100,
    },
    county_names_all: "Edwards",
    county_fips_all: 20047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67553,
    lat: 38.65444,
    lng: -99.32017,
    city: "Liebenthal",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 134,
    density: 460.7,
    county_fips: 20165,
    county_name: "Rush",
    county_weights: {
      20165: 100,
    },
    county_names_all: "Rush",
    county_fips_all: 20165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67554,
    lat: 38.37489,
    lng: -98.1858,
    city: "Lyons",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3841,
    density: 8.4,
    county_fips: 20159,
    county_name: "Rice",
    county_weights: {
      20159: 100,
    },
    county_names_all: "Rice",
    county_fips_all: 20159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67556,
    lat: 38.60719,
    lng: -99.52436,
    city: "McCracken",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 173,
    density: 0.3,
    county_fips: 20165,
    county_name: "Rush",
    county_weights: {
      20051: 12.71,
      20135: 23.15,
      20165: 64.14,
    },
    county_names_all: "Rush|Ness|Ellis",
    county_fips_all: "20165|20135|20051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67557,
    lat: 37.91557,
    lng: -98.96678,
    city: "Macksville",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 627,
    density: 1.7,
    county_fips: 20185,
    county_name: "Stafford",
    county_weights: {
      20047: 8.53,
      20145: 18.45,
      20151: 14.63,
      20185: 58.39,
    },
    county_names_all: "Stafford|Pawnee|Pratt|Edwards",
    county_fips_all: "20185|20145|20151|20047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67559,
    lat: 38.37645,
    lng: -99.44966,
    city: "Nekoma",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28,
    density: 0.1,
    county_fips: 20165,
    county_name: "Rush",
    county_weights: {
      20145: 34.07,
      20165: 65.93,
    },
    county_names_all: "Rush|Pawnee",
    county_fips_all: "20165|20145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67560,
    lat: 38.39781,
    lng: -99.94818,
    city: "Ness City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1686,
    density: 2,
    county_fips: 20135,
    county_name: "Ness",
    county_weights: {
      20135: 100,
    },
    county_names_all: "Ness",
    county_fips_all: 20135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67561,
    lat: 38.10427,
    lng: -98.09921,
    city: "Nickerson",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1327,
    density: 7.5,
    county_fips: 20155,
    county_name: "Reno",
    county_weights: {
      20155: 100,
    },
    county_names_all: "Reno",
    county_fips_all: 20155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67563,
    lat: 37.84627,
    lng: -99.55931,
    city: "Offerle",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 353,
    density: 1.3,
    county_fips: 20047,
    county_name: "Edwards",
    county_weights: {
      20047: 51.97,
      20057: 40.4,
      20083: 7.63,
    },
    county_names_all: "Edwards|Ford|Hodgeman",
    county_fips_all: "20047|20057|20083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67564,
    lat: 38.52855,
    lng: -98.92845,
    city: "Olmitz",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 217,
    density: 1,
    county_fips: 20009,
    county_name: "Barton",
    county_weights: {
      20009: 100,
    },
    county_names_all: "Barton",
    county_fips_all: 20009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67565,
    lat: 38.60428,
    lng: -99.04439,
    city: "Otis",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 450,
    density: 1.7,
    county_fips: 20165,
    county_name: "Rush",
    county_weights: {
      20009: 40.12,
      20051: 1,
      20165: 58.88,
    },
    county_names_all: "Rush|Barton|Ellis",
    county_fips_all: "20165|20009|20051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67566,
    lat: 37.944,
    lng: -98.09938,
    city: "Partridge",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 646,
    density: 4.4,
    county_fips: 20155,
    county_name: "Reno",
    county_weights: {
      20155: 100,
    },
    county_names_all: "Reno",
    county_fips_all: 20155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67567,
    lat: 38.26632,
    lng: -98.97241,
    city: "Pawnee Rock",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 654,
    density: 2.7,
    county_fips: 20145,
    county_name: "Pawnee",
    county_weights: {
      20009: 39.4,
      20145: 44.9,
      20165: 3.18,
      20185: 12.53,
    },
    county_names_all: "Pawnee|Barton|Stafford|Rush",
    county_fips_all: "20145|20009|20185|20165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67568,
    lat: 38.01729,
    lng: -98.30888,
    city: "Plevna",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 261,
    density: 1.7,
    county_fips: 20155,
    county_name: "Reno",
    county_weights: {
      20155: 100,
    },
    county_names_all: "Reno",
    county_fips_all: 20155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67570,
    lat: 37.78686,
    lng: -97.968,
    city: "Pretty Prairie",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1330,
    density: 3.7,
    county_fips: 20155,
    county_name: "Reno",
    county_weights: {
      20095: 9.68,
      20155: 90.32,
    },
    county_names_all: "Reno|Kingman",
    county_fips_all: "20155|20095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67572,
    lat: 38.68663,
    lng: -99.90825,
    city: "Ransom",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 392,
    density: 0.7,
    county_fips: 20135,
    county_name: "Ness",
    county_weights: {
      20135: 51.86,
      20195: 48.14,
    },
    county_names_all: "Ness|Trego",
    county_fips_all: "20135|20195",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67573,
    lat: 38.26215,
    lng: -98.41518,
    city: "Raymond",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 173,
    density: 0.9,
    county_fips: 20159,
    county_name: "Rice",
    county_weights: {
      20159: 100,
    },
    county_names_all: "Rice",
    county_fips_all: 20159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67574,
    lat: 38.22045,
    lng: -99.39185,
    city: "Rozel",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 118,
    density: 0.4,
    county_fips: 20145,
    county_name: "Pawnee",
    county_weights: {
      20145: 100,
    },
    county_names_all: "Pawnee",
    county_fips_all: 20145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67575,
    lat: 38.40711,
    lng: -99.25681,
    city: "Rush Center",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 415,
    density: 0.9,
    county_fips: 20165,
    county_name: "Rush",
    county_weights: {
      20145: 14.84,
      20165: 85.16,
    },
    county_names_all: "Rush|Pawnee",
    county_fips_all: "20165|20145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67576,
    lat: 38.03228,
    lng: -98.79343,
    city: "St John",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2067,
    density: 2.5,
    county_fips: 20185,
    county_name: "Stafford",
    county_weights: {
      20151: 0.25,
      20185: 99.75,
    },
    county_names_all: "Stafford|Pratt",
    county_fips_all: "20185|20151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67578,
    lat: 37.96922,
    lng: -98.59105,
    city: "Stafford",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1106,
    density: 2.1,
    county_fips: 20185,
    county_name: "Stafford",
    county_weights: {
      20185: 100,
    },
    county_names_all: "Stafford",
    county_fips_all: 20185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67579,
    lat: 38.18615,
    lng: -98.20861,
    city: "Sterling",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3252,
    density: 6.1,
    county_fips: 20159,
    county_name: "Rice",
    county_weights: {
      20155: 40.39,
      20159: 59.61,
    },
    county_names_all: "Rice|Reno",
    county_fips_all: "20159|20155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67581,
    lat: 37.99316,
    lng: -98.41068,
    city: "Sylvia",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 292,
    density: 1,
    county_fips: 20155,
    county_name: "Reno",
    county_weights: {
      20155: 100,
    },
    county_names_all: "Reno",
    county_fips_all: 20155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67583,
    lat: 37.79997,
    lng: -98.4714,
    city: "Turon",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 893,
    density: 1.5,
    county_fips: 20155,
    county_name: "Reno",
    county_weights: {
      20151: 43.24,
      20155: 47.26,
      20185: 9.5,
    },
    county_names_all: "Reno|Pratt|Stafford",
    county_fips_all: "20155|20151|20185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67584,
    lat: 38.6847,
    lng: -100.16072,
    city: "Utica",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 140,
    density: 0.2,
    county_fips: 20135,
    county_name: "Ness",
    county_weights: {
      20063: 21.08,
      20101: 8.05,
      20135: 45.4,
      20195: 25.47,
    },
    county_names_all: "Ness|Trego|Gove|Lane",
    county_fips_all: "20135|20195|20063|20101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67601,
    lat: 38.873,
    lng: -99.34032,
    city: "Hays",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24020,
    density: 25.8,
    county_fips: 20051,
    county_name: "Ellis",
    county_weights: {
      20051: 100,
    },
    county_names_all: "Ellis",
    county_fips_all: 20051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67621,
    lat: 39.82866,
    lng: -99.12891,
    city: "Agra",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 316,
    density: 1.9,
    county_fips: 20147,
    county_name: "Phillips",
    county_weights: {
      20147: 100,
    },
    county_names_all: "Phillips",
    county_fips_all: 20147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67622,
    lat: 39.89983,
    lng: -99.72522,
    city: "Almena",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 592,
    density: 1.7,
    county_fips: 20137,
    county_name: "Norton",
    county_weights: {
      20137: 96.35,
      20147: 3.65,
    },
    county_names_all: "Norton|Phillips",
    county_fips_all: "20137|20147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67623,
    lat: 39.45363,
    lng: -98.95627,
    city: "Alton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 161,
    density: 0.4,
    county_fips: 20141,
    county_name: "Osborne",
    county_weights: {
      20141: 95.5,
      20183: 4.5,
    },
    county_names_all: "Osborne|Smith",
    county_fips_all: "20141|20183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67625,
    lat: 39.39145,
    lng: -99.68293,
    city: "Bogue",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 148,
    density: 0.5,
    county_fips: 20065,
    county_name: "Graham",
    county_weights: {
      20065: 100,
    },
    county_names_all: "Graham",
    county_fips_all: 20065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67626,
    lat: 38.88375,
    lng: -98.70808,
    city: "Bunker Hill",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 183,
    density: 0.7,
    county_fips: 20167,
    county_name: "Russell",
    county_weights: {
      20167: 100,
    },
    county_names_all: "Russell",
    county_fips_all: 20167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67627,
    lat: 38.92224,
    lng: -99.21343,
    city: "Catharine",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 20051,
    county_name: "Ellis",
    county_weights: {
      20051: 100,
    },
    county_names_all: "Ellis",
    county_fips_all: 20051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67628,
    lat: 39.62741,
    lng: -98.99598,
    city: "Cedar",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 106,
    density: 0.9,
    county_fips: 20183,
    county_name: "Smith",
    county_weights: {
      20183: 100,
    },
    county_names_all: "Smith",
    county_fips_all: 20183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67629,
    lat: 39.70199,
    lng: -100.18031,
    city: "Clayton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 133,
    density: 0.5,
    county_fips: 20137,
    county_name: "Norton",
    county_weights: {
      20039: 46.36,
      20137: 53.64,
    },
    county_names_all: "Norton|Decatur",
    county_fips_all: "20137|20039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67631,
    lat: 39.00837,
    lng: -100.08569,
    city: "Collyer",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 119,
    density: 0.3,
    county_fips: 20195,
    county_name: "Trego",
    county_weights: {
      20065: 13.29,
      20179: 1.21,
      20195: 85.5,
    },
    county_names_all: "Trego|Graham|Sheridan",
    county_fips_all: "20195|20065|20179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67632,
    lat: 39.33557,
    lng: -99.58362,
    city: "Damar",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 219,
    density: 1.3,
    county_fips: 20163,
    county_name: "Rooks",
    county_weights: {
      20065: 35.42,
      20163: 64.58,
    },
    county_names_all: "Rooks|Graham",
    county_fips_all: "20163|20065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67634,
    lat: 38.82654,
    lng: -98.6073,
    city: "Dorrance",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 211,
    density: 0.8,
    county_fips: 20167,
    county_name: "Russell",
    county_weights: {
      20167: 100,
    },
    county_names_all: "Russell",
    county_fips_all: 20167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67635,
    lat: 39.60025,
    lng: -100.45484,
    city: "Dresden",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 156,
    density: 0.6,
    county_fips: 20039,
    county_name: "Decatur",
    county_weights: {
      20039: 69.76,
      20179: 30.24,
    },
    county_names_all: "Decatur|Sheridan",
    county_fips_all: "20039|20179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67637,
    lat: 38.94008,
    lng: -99.59197,
    city: "Ellis",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2873,
    density: 3.2,
    county_fips: 20051,
    county_name: "Ellis",
    county_weights: {
      20051: 50.22,
      20065: 1.17,
      20195: 48.61,
    },
    county_names_all: "Ellis|Trego|Graham",
    county_fips_all: "20051|20195|20065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67638,
    lat: 39.63418,
    lng: -98.8534,
    city: "Gaylord",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 235,
    density: 1.3,
    county_fips: 20183,
    county_name: "Smith",
    county_weights: {
      20183: 100,
    },
    county_names_all: "Smith",
    county_fips_all: 20183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67639,
    lat: 39.62649,
    lng: -99.32133,
    city: "Glade",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 182,
    density: 1.1,
    county_fips: 20147,
    county_name: "Phillips",
    county_weights: {
      20147: 95.91,
      20163: 4.09,
    },
    county_names_all: "Phillips|Rooks",
    county_fips_all: "20147|20163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67640,
    lat: 38.89853,
    lng: -99.04925,
    city: "Gorham",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 690,
    density: 2.3,
    county_fips: 20051,
    county_name: "Ellis",
    county_weights: {
      20051: 55.27,
      20167: 44.73,
    },
    county_names_all: "Ellis|Russell",
    county_fips_all: "20051|20167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67642,
    lat: 39.36989,
    lng: -99.8315,
    city: "Hill City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1940,
    density: 3,
    county_fips: 20065,
    county_name: "Graham",
    county_weights: {
      20065: 100,
    },
    county_names_all: "Graham",
    county_fips_all: 20065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67643,
    lat: 39.6406,
    lng: -100.29135,
    city: "Jennings",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 204,
    density: 0.4,
    county_fips: 20039,
    county_name: "Decatur",
    county_weights: {
      20039: 75.91,
      20179: 24.09,
    },
    county_names_all: "Decatur|Sheridan",
    county_fips_all: "20039|20179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67644,
    lat: 39.63104,
    lng: -99.15993,
    city: "Kirwin",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 281,
    density: 1.2,
    county_fips: 20147,
    county_name: "Phillips",
    county_weights: {
      20147: 93.86,
      20163: 6.14,
    },
    county_names_all: "Phillips|Rooks",
    county_fips_all: "20147|20163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67645,
    lat: 39.60144,
    lng: -99.89604,
    city: "Lenora",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 612,
    density: 0.8,
    county_fips: 20137,
    county_name: "Norton",
    county_weights: {
      20065: 29.65,
      20137: 70.35,
    },
    county_names_all: "Norton|Graham",
    county_fips_all: "20137|20065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67646,
    lat: 39.63921,
    lng: -99.58654,
    city: "Logan",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1012,
    density: 2.1,
    county_fips: 20147,
    county_name: "Phillips",
    county_weights: {
      20065: 5.71,
      20137: 25.81,
      20147: 55.58,
      20163: 12.9,
    },
    county_names_all: "Phillips|Norton|Rooks|Graham",
    county_fips_all: "20147|20137|20163|20065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67647,
    lat: 39.93794,
    lng: -99.53162,
    city: "Long Island",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 198,
    density: 1,
    county_fips: 20147,
    county_name: "Phillips",
    county_weights: {
      20147: 100,
    },
    county_names_all: "Phillips",
    county_fips_all: 20147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67648,
    lat: 39.07746,
    lng: -98.57278,
    city: "Lucas",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 595,
    density: 1.3,
    county_fips: 20167,
    county_name: "Russell",
    county_weights: {
      20105: 4.54,
      20141: 27.96,
      20167: 67.5,
    },
    county_names_all: "Russell|Osborne|Lincoln",
    county_fips_all: "20167|20141|20105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67649,
    lat: 39.13404,
    lng: -98.69232,
    city: "Luray",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 256,
    density: 1.2,
    county_fips: 20167,
    county_name: "Russell",
    county_weights: {
      20141: 49.38,
      20167: 50.62,
    },
    county_names_all: "Russell|Osborne",
    county_fips_all: "20167|20141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67650,
    lat: 39.37477,
    lng: -100.09925,
    city: "Morland",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 206,
    density: 0.5,
    county_fips: 20065,
    county_name: "Graham",
    county_weights: {
      20065: 100,
    },
    county_names_all: "Graham",
    county_fips_all: 20065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67651,
    lat: 39.20926,
    lng: -99.03969,
    city: "Natoma",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 551,
    density: 1,
    county_fips: 20141,
    county_name: "Osborne",
    county_weights: {
      20051: 13.19,
      20141: 42.2,
      20163: 40.28,
      20167: 4.33,
    },
    county_names_all: "Osborne|Rooks|Ellis|Russell",
    county_fips_all: "20141|20163|20051|20167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67653,
    lat: 39.90873,
    lng: -100.20554,
    city: "Norcatur",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 319,
    density: 0.7,
    county_fips: 20039,
    county_name: "Decatur",
    county_weights: {
      20039: 61.58,
      20137: 38.42,
    },
    county_names_all: "Decatur|Norton",
    county_fips_all: "20039|20137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67654,
    lat: 39.83067,
    lng: -99.95573,
    city: "Norton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4118,
    density: 4.6,
    county_fips: 20137,
    county_name: "Norton",
    county_weights: {
      20137: 100,
    },
    county_names_all: "Norton",
    county_fips_all: 20137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67656,
    lat: 38.98565,
    lng: -99.75549,
    city: "Ogallah",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 128,
    density: 0.4,
    county_fips: 20195,
    county_name: "Trego",
    county_weights: {
      20065: 11.22,
      20195: 88.78,
    },
    county_names_all: "Trego|Graham",
    county_fips_all: "20195|20065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67657,
    lat: 39.21126,
    lng: -99.60811,
    city: "Palco",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 217,
    density: 0.7,
    county_fips: 20163,
    county_name: "Rooks",
    county_weights: {
      20065: 48.57,
      20163: 50.32,
      20195: 1.11,
    },
    county_names_all: "Rooks|Graham|Trego",
    county_fips_all: "20163|20065|20195",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67658,
    lat: 39.11524,
    lng: -98.92786,
    city: "Paradise",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 73,
    density: 0.3,
    county_fips: 20167,
    county_name: "Russell",
    county_weights: {
      20141: 35.79,
      20167: 64.21,
    },
    county_names_all: "Russell|Osborne",
    county_fips_all: "20167|20141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67659,
    lat: 39.31804,
    lng: -100.00496,
    city: "Penokee",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 72,
    density: 0.3,
    county_fips: 20065,
    county_name: "Graham",
    county_weights: {
      20065: 100,
    },
    county_names_all: "Graham",
    county_fips_all: 20065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67660,
    lat: 38.71752,
    lng: -99.14806,
    city: "Pfeifer",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38,
    density: 0.9,
    county_fips: 20051,
    county_name: "Ellis",
    county_weights: {
      20051: 100,
    },
    county_names_all: "Ellis",
    county_fips_all: 20051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67661,
    lat: 39.82546,
    lng: -99.33039,
    city: "Phillipsburg",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2980,
    density: 3.1,
    county_fips: 20147,
    county_name: "Phillips",
    county_weights: {
      20147: 100,
    },
    county_names_all: "Phillips",
    county_fips_all: 20147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67663,
    lat: 39.20597,
    lng: -99.34222,
    city: "Plainville",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2521,
    density: 2.9,
    county_fips: 20163,
    county_name: "Rooks",
    county_weights: {
      20051: 23.31,
      20163: 76.69,
    },
    county_names_all: "Rooks|Ellis",
    county_fips_all: "20163|20051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67664,
    lat: 39.81609,
    lng: -99.5875,
    city: "Prairie View",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 258,
    density: 1.1,
    county_fips: 20147,
    county_name: "Phillips",
    county_weights: {
      20137: 30.99,
      20147: 69.01,
    },
    county_names_all: "Phillips|Norton",
    county_fips_all: "20147|20137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67665,
    lat: 38.847,
    lng: -98.88022,
    city: "Russell",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5023,
    density: 6,
    county_fips: 20167,
    county_name: "Russell",
    county_weights: {
      20009: 6.27,
      20167: 93.73,
    },
    county_names_all: "Russell|Barton",
    county_fips_all: "20167|20009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67667,
    lat: 38.71304,
    lng: -99.33249,
    city: "Schoenchen",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 153,
    density: 475.1,
    county_fips: 20051,
    county_name: "Ellis",
    county_weights: {
      20051: 100,
    },
    county_names_all: "Ellis",
    county_fips_all: 20051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67669,
    lat: 39.45631,
    lng: -99.34914,
    city: "Stockton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1930,
    density: 2.3,
    county_fips: 20163,
    county_name: "Rooks",
    county_weights: {
      20163: 100,
    },
    county_names_all: "Rooks",
    county_fips_all: 20163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67671,
    lat: 38.87559,
    lng: -99.14432,
    city: "Victoria",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1562,
    density: 4.8,
    county_fips: 20051,
    county_name: "Ellis",
    county_weights: {
      20051: 100,
    },
    county_names_all: "Ellis",
    county_fips_all: 20051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67672,
    lat: 38.99882,
    lng: -99.90746,
    city: "Wakeeney",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2406,
    density: 3,
    county_fips: 20195,
    county_name: "Trego",
    county_weights: {
      20065: 15.68,
      20195: 84.32,
    },
    county_names_all: "Trego|Graham",
    county_fips_all: "20195|20065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67673,
    lat: 39.14708,
    lng: -98.80714,
    city: "Waldo",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74,
    density: 0.3,
    county_fips: 20141,
    county_name: "Osborne",
    county_weights: {
      20141: 58.5,
      20167: 41.5,
    },
    county_names_all: "Osborne|Russell",
    county_fips_all: "20141|20167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67674,
    lat: 38.87446,
    lng: -99.08197,
    city: "Walker",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48,
    density: 1.6,
    county_fips: 20051,
    county_name: "Ellis",
    county_weights: {
      20051: 100,
    },
    county_names_all: "Ellis",
    county_fips_all: 20051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67675,
    lat: 39.42612,
    lng: -99.09994,
    city: "Woodston",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 189,
    density: 0.7,
    county_fips: 20163,
    county_name: "Rooks",
    county_weights: {
      20141: 3.21,
      20163: 96.79,
    },
    county_names_all: "Rooks|Osborne",
    county_fips_all: "20163|20141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67701,
    lat: 39.39509,
    lng: -101.05034,
    city: "Colby",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6224,
    density: 5.3,
    county_fips: 20193,
    county_name: "Thomas",
    county_weights: {
      20153: 12.84,
      20193: 87.16,
    },
    county_names_all: "Thomas|Rawlins",
    county_fips_all: "20193|20153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67730,
    lat: 39.80366,
    lng: -101.11624,
    city: "Atwood",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1712,
    density: 1.7,
    county_fips: 20153,
    county_name: "Rawlins",
    county_weights: {
      20153: 100,
    },
    county_names_all: "Rawlins",
    county_fips_all: 20153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67731,
    lat: 39.76277,
    lng: -101.53858,
    city: "Bird City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 770,
    density: 0.9,
    county_fips: 20023,
    county_name: "Cheyenne",
    county_weights: {
      20023: 99.7,
      20153: 0.3,
    },
    county_names_all: "Cheyenne|Rawlins",
    county_fips_all: "20023|20153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67732,
    lat: 39.37333,
    lng: -101.3708,
    city: "Brewster",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 622,
    density: 0.7,
    county_fips: 20193,
    county_name: "Thomas",
    county_weights: {
      20109: 12.95,
      20153: 9.68,
      20181: 27.32,
      20193: 50.05,
    },
    county_names_all: "Thomas|Sherman|Logan|Rawlins",
    county_fips_all: "20193|20181|20109|20153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67733,
    lat: 39.32998,
    lng: -101.50653,
    city: "Edson",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 365,
    density: 0.7,
    county_fips: 20181,
    county_name: "Sherman",
    county_weights: {
      20181: 100,
    },
    county_names_all: "Sherman",
    county_fips_all: 20181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 67734,
    lat: 39.54241,
    lng: -100.89298,
    city: "Gem",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 295,
    density: 1.2,
    county_fips: 20193,
    county_name: "Thomas",
    county_weights: {
      20153: 41.16,
      20193: 58.84,
    },
    county_names_all: "Thomas|Rawlins",
    county_fips_all: "20193|20153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67735,
    lat: 39.35119,
    lng: -101.76646,
    city: "Goodland",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5039,
    density: 3,
    county_fips: 20181,
    county_name: "Sherman",
    county_weights: {
      20023: 1.28,
      20181: 98.72,
    },
    county_names_all: "Sherman|Cheyenne",
    county_fips_all: "20181|20023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 67736,
    lat: 38.85492,
    lng: -100.44715,
    city: "Gove",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 194,
    density: 0.3,
    county_fips: 20063,
    county_name: "Gove",
    county_weights: {
      20063: 100,
    },
    county_names_all: "Gove",
    county_fips_all: 20063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67737,
    lat: 39.08798,
    lng: -100.49367,
    city: "Grainfield",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 471,
    density: 1,
    county_fips: 20063,
    county_name: "Gove",
    county_weights: {
      20063: 62.64,
      20179: 37.36,
    },
    county_names_all: "Gove|Sheridan",
    county_fips_all: "20063|20179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67738,
    lat: 39.0027,
    lng: -100.65348,
    city: "Grinnell",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 541,
    density: 0.8,
    county_fips: 20063,
    county_name: "Gove",
    county_weights: {
      20063: 78.4,
      20179: 21.6,
    },
    county_names_all: "Gove|Sheridan",
    county_fips_all: "20063|20179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67739,
    lat: 39.8848,
    lng: -100.80581,
    city: "Herndon",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 199,
    density: 0.6,
    county_fips: 20153,
    county_name: "Rawlins",
    county_weights: {
      20039: 4.19,
      20153: 95.81,
    },
    county_names_all: "Rawlins|Decatur",
    county_fips_all: "20153|20039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67740,
    lat: 39.35576,
    lng: -100.36089,
    city: "Hoxie",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1668,
    density: 1.5,
    county_fips: 20179,
    county_name: "Sheridan",
    county_weights: {
      20065: 3.06,
      20179: 96.94,
    },
    county_names_all: "Sheridan|Graham",
    county_fips_all: "20179|20065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67741,
    lat: 39.38269,
    lng: -102.00822,
    city: "Kanorado",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 374,
    density: 1,
    county_fips: 20181,
    county_name: "Sherman",
    county_weights: {
      20023: 12.42,
      20181: 87.58,
    },
    county_names_all: "Sherman|Cheyenne",
    county_fips_all: "20181|20023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 67743,
    lat: 39.38826,
    lng: -101.24121,
    city: "Levant",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 163,
    density: 0.4,
    county_fips: 20193,
    county_name: "Thomas",
    county_weights: {
      20153: 9.88,
      20193: 90.12,
    },
    county_names_all: "Thomas|Rawlins",
    county_fips_all: "20193|20153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67744,
    lat: 39.85952,
    lng: -100.94095,
    city: "Ludell",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 105,
    density: 0.3,
    county_fips: 20153,
    county_name: "Rawlins",
    county_weights: {
      20153: 100,
    },
    county_names_all: "Rawlins",
    county_fips_all: 20153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67745,
    lat: 39.8147,
    lng: -101.34795,
    city: "McDonald",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 402,
    density: 0.6,
    county_fips: 20153,
    county_name: "Rawlins",
    county_weights: {
      20023: 16.15,
      20153: 83.85,
    },
    county_names_all: "Rawlins|Cheyenne",
    county_fips_all: "20153|20023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67747,
    lat: 39.04208,
    lng: -101.06099,
    city: "Monument",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 135,
    density: 0.4,
    county_fips: 20109,
    county_name: "Logan",
    county_weights: {
      20109: 92.84,
      20193: 7.16,
    },
    county_names_all: "Logan|Thomas",
    county_fips_all: "20109|20193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67748,
    lat: 39.06507,
    lng: -100.85643,
    city: "Oakley",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2425,
    density: 2.2,
    county_fips: 20109,
    county_name: "Logan",
    county_weights: {
      20063: 23.12,
      20109: 41.41,
      20179: 1.68,
      20193: 33.79,
    },
    county_names_all: "Logan|Thomas|Gove|Sheridan",
    county_fips_all: "20109|20193|20063|20179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67749,
    lat: 39.83214,
    lng: -100.56728,
    city: "Oberlin",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2114,
    density: 1.8,
    county_fips: 20039,
    county_name: "Decatur",
    county_weights: {
      20039: 93.93,
      20153: 6.07,
    },
    county_names_all: "Decatur|Rawlins",
    county_fips_all: "20039|20153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67751,
    lat: 39.11799,
    lng: -100.35572,
    city: "Park",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 231,
    density: 1,
    county_fips: 20063,
    county_name: "Gove",
    county_weights: {
      20063: 54.98,
      20179: 45.02,
    },
    county_names_all: "Gove|Sheridan",
    county_fips_all: "20063|20179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67752,
    lat: 38.9924,
    lng: -100.23145,
    city: "Quinter",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1490,
    density: 2.3,
    county_fips: 20063,
    county_name: "Gove",
    county_weights: {
      20063: 84.71,
      20179: 15.29,
    },
    county_names_all: "Gove|Sheridan",
    county_fips_all: "20063|20179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67753,
    lat: 39.43164,
    lng: -100.74805,
    city: "Rexford",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 467,
    density: 0.7,
    county_fips: 20193,
    county_name: "Thomas",
    county_weights: {
      20153: 15.2,
      20179: 32.08,
      20193: 52.72,
    },
    county_names_all: "Thomas|Sheridan|Rawlins",
    county_fips_all: "20193|20179|20153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67756,
    lat: 39.79815,
    lng: -101.84265,
    city: "Saint Francis",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1841,
    density: 1.1,
    county_fips: 20023,
    county_name: "Cheyenne",
    county_weights: {
      20023: 100,
    },
    county_names_all: "Cheyenne",
    county_fips_all: 20023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67757,
    lat: 39.54527,
    lng: -100.60881,
    city: "Selden",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 371,
    density: 0.7,
    county_fips: 20179,
    county_name: "Sheridan",
    county_weights: {
      20039: 38.94,
      20179: 61.06,
    },
    county_names_all: "Sheridan|Decatur",
    county_fips_all: "20179|20039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67758,
    lat: 38.89658,
    lng: -101.7842,
    city: "Sharon Springs",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1255,
    density: 1.1,
    county_fips: 20199,
    county_name: "Wallace",
    county_weights: {
      20199: 100,
    },
    county_names_all: "Wallace",
    county_fips_all: 20199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 67761,
    lat: 38.95066,
    lng: -101.52523,
    city: "Wallace",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 233,
    density: 0.2,
    county_fips: 20199,
    county_name: "Wallace",
    county_weights: {
      20109: 33.65,
      20199: 66.35,
    },
    county_names_all: "Wallace|Logan",
    county_fips_all: "20199|20109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 67762,
    lat: 38.84166,
    lng: -101.98611,
    city: "Weskan",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 167,
    density: 0.3,
    county_fips: 20199,
    county_name: "Wallace",
    county_weights: {
      20071: 19.04,
      20199: 80.96,
    },
    county_names_all: "Wallace|Greeley",
    county_fips_all: "20199|20071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 67764,
    lat: 38.89135,
    lng: -101.15041,
    city: "Winona",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 427,
    density: 0.3,
    county_fips: 20109,
    county_name: "Logan",
    county_weights: {
      20109: 94.07,
      20193: 5.93,
    },
    county_names_all: "Logan|Thomas",
    county_fips_all: "20109|20193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67801,
    lat: 37.72961,
    lng: -100.05406,
    city: "Dodge City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30562,
    density: 32.1,
    county_fips: 20057,
    county_name: "Ford",
    county_weights: {
      20057: 98.65,
      20083: 1.35,
    },
    county_names_all: "Ford|Hodgeman",
    county_fips_all: "20057|20083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67831,
    lat: 37.17956,
    lng: -99.8018,
    city: "Ashland",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1004,
    density: 0.9,
    county_fips: 20025,
    county_name: "Clark",
    county_weights: {
      20025: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 20025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67834,
    lat: 37.53174,
    lng: -99.61886,
    city: "Bucklin",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 855,
    density: 1.7,
    county_fips: 20057,
    county_name: "Ford",
    county_weights: {
      20025: 27.88,
      20057: 66.64,
      20097: 5.48,
    },
    county_names_all: "Ford|Clark|Kiowa",
    county_fips_all: "20057|20025|20097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67835,
    lat: 37.98071,
    lng: -100.31746,
    city: "Cimarron",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2929,
    density: 2.3,
    county_fips: 20069,
    county_name: "Gray",
    county_weights: {
      20055: 43.04,
      20069: 49.28,
      20083: 7.68,
    },
    county_names_all: "Gray|Finney|Hodgeman",
    county_fips_all: "20069|20055|20083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67836,
    lat: 38.03977,
    lng: -101.9942,
    city: "Coolidge",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 127,
    density: 0.5,
    county_fips: 20075,
    county_name: "Hamilton",
    county_weights: {
      20075: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 20075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 67837,
    lat: 37.55615,
    lng: -100.66289,
    city: "Copeland",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1029,
    density: 1.8,
    county_fips: 20081,
    county_name: "Haskell",
    county_weights: {
      20069: 32.63,
      20081: 58.6,
      20119: 8.77,
    },
    county_names_all: "Haskell|Gray|Meade",
    county_fips_all: "20081|20069|20119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67838,
    lat: 38.05641,
    lng: -101.13086,
    city: "Deerfield",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1246,
    density: 6.1,
    county_fips: 20093,
    county_name: "Kearny",
    county_weights: {
      20055: 14.53,
      20093: 85.47,
    },
    county_names_all: "Kearny|Finney",
    county_fips_all: "20093|20055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67839,
    lat: 38.47911,
    lng: -100.43961,
    city: "Dighton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1162,
    density: 0.8,
    county_fips: 20101,
    county_name: "Lane",
    county_weights: {
      20063: 7.19,
      20101: 92.81,
    },
    county_names_all: "Lane|Gove",
    county_fips_all: "20101|20063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67840,
    lat: 37.0736,
    lng: -100.01097,
    city: "Englewood",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 92,
    density: 1.1,
    county_fips: 20025,
    county_name: "Clark",
    county_weights: {
      20025: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 20025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67841,
    lat: 37.62997,
    lng: -100.22878,
    city: "Ensign",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 313,
    density: 1.1,
    county_fips: 20069,
    county_name: "Gray",
    county_weights: {
      20057: 39.15,
      20069: 60.85,
    },
    county_names_all: "Gray|Ford",
    county_fips_all: "20069|20057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67842,
    lat: 37.54766,
    lng: -99.77138,
    city: "Ford",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 362,
    density: 0.8,
    county_fips: 20057,
    county_name: "Ford",
    county_weights: {
      20025: 24.72,
      20057: 75.28,
    },
    county_names_all: "Ford|Clark",
    county_fips_all: "20057|20025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67843,
    lat: 37.73027,
    lng: -99.93728,
    city: "Fort Dodge",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 179,
    density: 420.4,
    county_fips: 20057,
    county_name: "Ford",
    county_weights: {
      20057: 100,
    },
    county_names_all: "Ford",
    county_fips_all: 20057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67844,
    lat: 37.37798,
    lng: -100.19562,
    city: "Fowler",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 744,
    density: 1.2,
    county_fips: 20119,
    county_name: "Meade",
    county_weights: {
      20057: 10.02,
      20069: 7.82,
      20119: 82.16,
    },
    county_names_all: "Meade|Ford|Gray",
    county_fips_all: "20119|20057|20069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67846,
    lat: 38.02311,
    lng: -100.77756,
    city: "Garden City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33098,
    density: 16.3,
    county_fips: 20055,
    county_name: "Finney",
    county_weights: {
      20055: 96.15,
      20069: 2.32,
      20101: 1.53,
    },
    county_names_all: "Finney|Gray|Lane",
    county_fips_all: "20055|20069|20101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67849,
    lat: 38.15061,
    lng: -99.71725,
    city: "Hanston",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 395,
    density: 1.1,
    county_fips: 20083,
    county_name: "Hodgeman",
    county_weights: {
      20083: 94.82,
      20135: 5.18,
    },
    county_names_all: "Hodgeman|Ness",
    county_fips_all: "20083|20135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67850,
    lat: 38.6315,
    lng: -100.63896,
    city: "Healy",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 385,
    density: 0.8,
    county_fips: 20101,
    county_name: "Lane",
    county_weights: {
      20063: 22.22,
      20101: 59.86,
      20171: 17.92,
    },
    county_names_all: "Lane|Gove|Scott",
    county_fips_all: "20101|20063|20171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67851,
    lat: 38.08796,
    lng: -101.01972,
    city: "Holcomb",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2983,
    density: 5.6,
    county_fips: 20055,
    county_name: "Finney",
    county_weights: {
      20055: 96.1,
      20171: 3.9,
    },
    county_names_all: "Finney|Scott",
    county_fips_all: "20055|20171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67853,
    lat: 37.88416,
    lng: -100.51616,
    city: "Ingalls",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 741,
    density: 0.9,
    county_fips: 20069,
    county_name: "Gray",
    county_weights: {
      20055: 16.03,
      20069: 83.97,
    },
    county_names_all: "Gray|Finney",
    county_fips_all: "20069|20055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67854,
    lat: 38.09034,
    lng: -100.0023,
    city: "Jetmore",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1177,
    density: 0.9,
    county_fips: 20083,
    county_name: "Hodgeman",
    county_weights: {
      20083: 100,
    },
    county_names_all: "Hodgeman",
    county_fips_all: 20083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67855,
    lat: 37.54551,
    lng: -101.69477,
    city: "Johnson",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1677,
    density: 1.3,
    county_fips: 20187,
    county_name: "Stanton",
    county_weights: {
      20067: 1.12,
      20129: 9.7,
      20187: 89.18,
    },
    county_names_all: "Stanton|Morton|Grant",
    county_fips_all: "20187|20129|20067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67857,
    lat: 37.99598,
    lng: -101.55154,
    city: "Kendall",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 217,
    density: 0.3,
    county_fips: 20075,
    county_name: "Hamilton",
    county_weights: {
      20075: 52.97,
      20093: 47.03,
    },
    county_names_all: "Hamilton|Kearny",
    county_fips_all: "20075|20093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 67859,
    lat: 37.23636,
    lng: -100.77421,
    city: "Kismet",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 591,
    density: 1.2,
    county_fips: 20175,
    county_name: "Seward",
    county_weights: {
      20175: 100,
    },
    county_names_all: "Seward",
    county_fips_all: 20175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67860,
    lat: 38.0185,
    lng: -101.29831,
    city: "Lakin",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2378,
    density: 1.7,
    county_fips: 20093,
    county_name: "Kearny",
    county_weights: {
      20093: 100,
    },
    county_names_all: "Kearny",
    county_fips_all: 20093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67861,
    lat: 38.46768,
    lng: -101.38914,
    city: "Leoti",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1942,
    density: 1.3,
    county_fips: 20203,
    county_name: "Wichita",
    county_weights: {
      20109: 5.92,
      20199: 0.26,
      20203: 93.82,
    },
    county_names_all: "Wichita|Logan|Wallace",
    county_fips_all: "20203|20109|20199",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67862,
    lat: 37.47961,
    lng: -101.95409,
    city: "Manter",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 369,
    density: 0.5,
    county_fips: 20187,
    county_name: "Stanton",
    county_weights: {
      20129: 25.9,
      20187: 74.1,
    },
    county_names_all: "Stanton|Morton",
    county_fips_all: "20187|20129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67863,
    lat: 38.56533,
    lng: -101.20829,
    city: "Marienthal",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 239,
    density: 0.5,
    county_fips: 20203,
    county_name: "Wichita",
    county_weights: {
      20171: 9.26,
      20203: 90.74,
    },
    county_names_all: "Wichita|Scott",
    county_fips_all: "20203|20171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67864,
    lat: 37.17178,
    lng: -100.31807,
    city: "Meade",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1702,
    density: 1.4,
    county_fips: 20119,
    county_name: "Meade",
    county_weights: {
      20119: 100,
    },
    county_names_all: "Meade",
    county_fips_all: 20119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67865,
    lat: 37.4368,
    lng: -99.96506,
    city: "Minneola",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 980,
    density: 1.4,
    county_fips: 20025,
    county_name: "Clark",
    county_weights: {
      20025: 62.89,
      20057: 37.11,
    },
    county_names_all: "Clark|Ford",
    county_fips_all: "20025|20057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67867,
    lat: 37.56812,
    lng: -100.45804,
    city: "Montezuma",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1752,
    density: 3,
    county_fips: 20069,
    county_name: "Gray",
    county_weights: {
      20069: 84.63,
      20119: 15.37,
    },
    county_names_all: "Gray|Meade",
    county_fips_all: "20069|20119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67868,
    lat: 37.82028,
    lng: -100.71029,
    city: "Pierceville",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 185,
    density: 1.2,
    county_fips: 20055,
    county_name: "Finney",
    county_weights: {
      20055: 100,
    },
    county_names_all: "Finney",
    county_fips_all: 20055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67869,
    lat: 37.24489,
    lng: -100.57358,
    city: "Plains",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1589,
    density: 2,
    county_fips: 20119,
    county_name: "Meade",
    county_weights: {
      20119: 83.53,
      20175: 16.47,
    },
    county_names_all: "Meade|Seward",
    county_fips_all: "20119|20175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67870,
    lat: 37.53255,
    lng: -101.01829,
    city: "Satanta",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1377,
    density: 2,
    county_fips: 20081,
    county_name: "Haskell",
    county_weights: {
      20067: 11.15,
      20081: 75.45,
      20175: 13.4,
    },
    county_names_all: "Haskell|Seward|Grant",
    county_fips_all: "20081|20175|20067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67871,
    lat: 38.49162,
    lng: -100.91145,
    city: "Scott City",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4939,
    density: 2.5,
    county_fips: 20171,
    county_name: "Scott",
    county_weights: {
      20055: 3.16,
      20063: 4.93,
      20109: 3.25,
      20171: 87.63,
      20203: 1.03,
    },
    county_names_all: "Scott|Gove|Logan|Finney|Wichita",
    county_fips_all: "20171|20063|20109|20055|20203",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67876,
    lat: 37.86154,
    lng: -99.73654,
    city: "Spearville",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1533,
    density: 2.6,
    county_fips: 20057,
    county_name: "Ford",
    county_weights: {
      20057: 68.63,
      20083: 31.37,
    },
    county_names_all: "Ford|Hodgeman",
    county_fips_all: "20057|20083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67877,
    lat: 37.54887,
    lng: -100.84342,
    city: "Sublette",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2249,
    density: 3.2,
    county_fips: 20081,
    county_name: "Haskell",
    county_weights: {
      20081: 92.85,
      20175: 7.15,
    },
    county_names_all: "Haskell|Seward",
    county_fips_all: "20081|20175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67878,
    lat: 38.00218,
    lng: -101.80824,
    city: "Syracuse",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2382,
    density: 1.2,
    county_fips: 20075,
    county_name: "Hamilton",
    county_weights: {
      20075: 95.72,
      20187: 4.28,
    },
    county_names_all: "Hamilton|Stanton",
    county_fips_all: "20075|20187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 67879,
    lat: 38.47091,
    lng: -101.79459,
    city: "Tribune",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1156,
    density: 0.6,
    county_fips: 20071,
    county_name: "Greeley",
    county_weights: {
      20071: 100,
    },
    county_names_all: "Greeley",
    county_fips_all: 20071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 67880,
    lat: 37.60489,
    lng: -101.32384,
    city: "Ulysses",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7444,
    density: 4.3,
    county_fips: 20067,
    county_name: "Grant",
    county_weights: {
      20067: 80.44,
      20075: 1.51,
      20093: 18.05,
    },
    county_names_all: "Grant|Kearny|Hamilton",
    county_fips_all: "20067|20093|20075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67882,
    lat: 37.8019,
    lng: -99.88505,
    city: "Wright",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 222,
    density: 0.8,
    county_fips: 20057,
    county_name: "Ford",
    county_weights: {
      20057: 100,
    },
    county_names_all: "Ford",
    county_fips_all: 20057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67901,
    lat: 37.0943,
    lng: -100.89864,
    city: "Liberal",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21282,
    density: 26.5,
    county_fips: 20175,
    county_name: "Seward",
    county_weights: {
      20175: 93.65,
      20189: 6.35,
    },
    county_names_all: "Seward|Stevens",
    county_fips_all: "20175|20189",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67950,
    lat: 37.06277,
    lng: -101.86765,
    city: "Elkhart",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1844,
    density: 3.9,
    county_fips: 20129,
    county_name: "Morton",
    county_weights: {
      20129: 100,
    },
    county_names_all: "Morton",
    county_fips_all: 20129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67951,
    lat: 37.1639,
    lng: -101.33486,
    city: "Hugoton",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4847,
    density: 3.7,
    county_fips: 20189,
    county_name: "Stevens",
    county_weights: {
      20189: 100,
    },
    county_names_all: "Stevens",
    county_fips_all: 20189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67952,
    lat: 37.29886,
    lng: -101.13934,
    city: "Moscow",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 556,
    density: 1.1,
    county_fips: 20189,
    county_name: "Stevens",
    county_weights: {
      20175: 26.96,
      20189: 73.04,
    },
    county_names_all: "Stevens|Seward",
    county_fips_all: "20189|20175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67953,
    lat: 37.22653,
    lng: -101.86093,
    city: "Richfield",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 82,
    density: 0.1,
    county_fips: 20129,
    county_name: "Morton",
    county_weights: {
      20129: 100,
    },
    county_names_all: "Morton",
    county_fips_all: 20129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 67954,
    lat: 37.17999,
    lng: -101.61179,
    city: "Rolla",
    state_id: "KS",
    state_name: "Kansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 817,
    density: 1.2,
    county_fips: 20129,
    county_name: "Morton",
    county_weights: {
      20129: 79.08,
      20189: 20.92,
    },
    county_names_all: "Morton|Stevens",
    county_fips_all: "20129|20189",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68001,
    lat: 41.33369,
    lng: -96.95489,
    city: "Abie",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44,
    density: 11.1,
    county_fips: 31023,
    county_name: "Butler",
    county_weights: {
      31023: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 31023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68002,
    lat: 41.50163,
    lng: -96.33975,
    city: "Arlington",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2475,
    density: 13,
    county_fips: 31177,
    county_name: "Washington",
    county_weights: {
      31177: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 31177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68003,
    lat: 41.07161,
    lng: -96.38013,
    city: "Ashland",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4691,
    density: 16.7,
    county_fips: 31155,
    county_name: "Saunders",
    county_weights: {
      31025: 26.04,
      31155: 73.96,
    },
    county_names_all: "Saunders|Cass",
    county_fips_all: "31155|31025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68004,
    lat: 42.00888,
    lng: -96.62978,
    city: "Bancroft",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 951,
    density: 4.7,
    county_fips: 31039,
    county_name: "Cuming",
    county_weights: {
      31021: 0.92,
      31039: 99.08,
    },
    county_names_all: "Cuming|Burt",
    county_fips_all: "31039|31021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68005,
    lat: 41.14161,
    lng: -95.89394,
    city: "Bellevue",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23240,
    density: 481.1,
    county_fips: 31153,
    county_name: "Sarpy",
    county_weights: {
      31153: 100,
    },
    county_names_all: "Sarpy",
    county_fips_all: 31153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68007,
    lat: 41.37184,
    lng: -96.19524,
    city: "Bennington",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13264,
    density: 135.9,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 74.09,
      31177: 25.91,
    },
    county_names_all: "Douglas|Washington",
    county_fips_all: "31055|31177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68008,
    lat: 41.54573,
    lng: -96.17421,
    city: "Blair",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12356,
    density: 38.5,
    county_fips: 31177,
    county_name: "Washington",
    county_weights: {
      31177: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 31177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68010,
    lat: 41.25616,
    lng: -96.13352,
    city: "Boys Town",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 841,
    density: 235.2,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 31055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68014,
    lat: 41.28219,
    lng: -96.96458,
    city: "Bruno",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 372,
    density: 3.7,
    county_fips: 31023,
    county_name: "Butler",
    county_weights: {
      31023: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 31023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68015,
    lat: 41.38351,
    lng: -96.64737,
    city: "Cedar Bluffs",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1358,
    density: 9.5,
    county_fips: 31155,
    county_name: "Saunders",
    county_weights: {
      31155: 100,
    },
    county_names_all: "Saunders",
    county_fips_all: 31155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68016,
    lat: 41.02518,
    lng: -96.1063,
    city: "Cedar Creek",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 396,
    density: 35.6,
    county_fips: 31025,
    county_name: "Cass",
    county_weights: {
      31025: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 31025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68017,
    lat: 41.05938,
    lng: -96.66179,
    city: "Ceresco",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1804,
    density: 9.4,
    county_fips: 31155,
    county_name: "Saunders",
    county_weights: {
      31109: 31.45,
      31155: 68.55,
    },
    county_names_all: "Saunders|Lancaster",
    county_fips_all: "31155|31109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68018,
    lat: 41.30207,
    lng: -96.61573,
    city: "Colon",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 569,
    density: 4.9,
    county_fips: 31155,
    county_name: "Saunders",
    county_weights: {
      31155: 100,
    },
    county_names_all: "Saunders",
    county_fips_all: 31155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68019,
    lat: 41.77965,
    lng: -96.37323,
    city: "Craig",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 408,
    density: 2,
    county_fips: 31021,
    county_name: "Burt",
    county_weights: {
      31021: 96.92,
      31053: 1.19,
      31177: 1.89,
    },
    county_names_all: "Burt|Washington|Dodge",
    county_fips_all: "31021|31177|31053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68020,
    lat: 41.9762,
    lng: -96.25627,
    city: "Decatur",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 530,
    density: 2.7,
    county_fips: 31021,
    county_name: "Burt",
    county_weights: {
      31021: 86.69,
      31173: 13.31,
    },
    county_names_all: "Burt|Thurston",
    county_fips_all: "31021|31173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68022,
    lat: 41.27744,
    lng: -96.24558,
    city: "Elkhorn",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27039,
    density: 275,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 31055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68023,
    lat: 41.46191,
    lng: -96.02226,
    city: "Fort Calhoun",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2408,
    density: 23.2,
    county_fips: 31177,
    county_name: "Washington",
    county_weights: {
      31177: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 31177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68025,
    lat: 41.43749,
    lng: -96.49158,
    city: "Fremont",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30295,
    density: 94.3,
    county_fips: 31053,
    county_name: "Dodge",
    county_weights: {
      31053: 73.6,
      31155: 26.27,
      31177: 0.13,
    },
    county_names_all: "Dodge|Saunders|Washington",
    county_fips_all: "31053|31155|31177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68028,
    lat: 41.10513,
    lng: -96.26098,
    city: "Gretna",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16507,
    density: 101.1,
    county_fips: 31153,
    county_name: "Sarpy",
    county_weights: {
      31153: 100,
    },
    county_names_all: "Sarpy",
    county_fips_all: 31153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68029,
    lat: 41.65873,
    lng: -96.27394,
    city: "Herman",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 905,
    density: 4.4,
    county_fips: 31177,
    county_name: "Washington",
    county_weights: {
      31021: 21.98,
      31177: 78.02,
    },
    county_names_all: "Washington|Burt",
    county_fips_all: "31177|31021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68030,
    lat: 42.3184,
    lng: -96.45057,
    city: "Homer",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 661,
    density: 6.6,
    county_fips: 31043,
    county_name: "Dakota",
    county_weights: {
      31043: 100,
    },
    county_names_all: "Dakota",
    county_fips_all: 31043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68031,
    lat: 41.64041,
    lng: -96.53046,
    city: "Hooper",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1589,
    density: 5.2,
    county_fips: 31053,
    county_name: "Dodge",
    county_weights: {
      31053: 89.9,
      31177: 10.1,
    },
    county_names_all: "Dodge|Washington",
    county_fips_all: "31053|31177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68033,
    lat: 41.12933,
    lng: -96.52425,
    city: "Ithaca",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 322,
    density: 4.2,
    county_fips: 31155,
    county_name: "Saunders",
    county_weights: {
      31155: 100,
    },
    county_names_all: "Saunders",
    county_fips_all: 31155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68034,
    lat: 41.45558,
    lng: -96.2203,
    city: "Kennard",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 694,
    density: 8.4,
    county_fips: 31177,
    county_name: "Washington",
    county_weights: {
      31177: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 31177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68036,
    lat: 41.39031,
    lng: -96.95086,
    city: "Linwood",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 329,
    density: 2,
    county_fips: 31023,
    county_name: "Butler",
    county_weights: {
      31023: 77.56,
      31155: 22.44,
    },
    county_names_all: "Butler|Saunders",
    county_fips_all: "31023|31155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68037,
    lat: 40.9844,
    lng: -96.12673,
    city: "Louisville",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2822,
    density: 20.4,
    county_fips: 31025,
    county_name: "Cass",
    county_weights: {
      31025: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 31025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68038,
    lat: 41.95458,
    lng: -96.4432,
    city: "Lyons",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1267,
    density: 4.6,
    county_fips: 31021,
    county_name: "Burt",
    county_weights: {
      31021: 94.85,
      31039: 2.8,
      31173: 2.35,
    },
    county_names_all: "Burt|Cuming|Thurston",
    county_fips_all: "31021|31039|31173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68039,
    lat: 42.112,
    lng: -96.34397,
    city: "Macy",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1307,
    density: 11.7,
    county_fips: 31173,
    county_name: "Thurston",
    county_weights: {
      31173: 100,
    },
    county_names_all: "Thurston",
    county_fips_all: 31173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68040,
    lat: 41.28555,
    lng: -96.73815,
    city: "Malmo",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 417,
    density: 4.6,
    county_fips: 31155,
    county_name: "Saunders",
    county_weights: {
      31155: 100,
    },
    county_names_all: "Saunders",
    county_fips_all: 31155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68041,
    lat: 41.23633,
    lng: -96.48793,
    city: "Mead",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1048,
    density: 9.1,
    county_fips: 31155,
    county_name: "Saunders",
    county_weights: {
      31155: 100,
    },
    county_names_all: "Saunders",
    county_fips_all: 31155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68042,
    lat: 41.09426,
    lng: -96.43683,
    city: "Memphis",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63,
    density: 28.4,
    county_fips: 31155,
    county_name: "Saunders",
    county_weights: {
      31155: 100,
    },
    county_names_all: "Saunders",
    county_fips_all: 31155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68044,
    lat: 41.54798,
    lng: -96.44871,
    city: "Nickerson",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 648,
    density: 7,
    county_fips: 31053,
    county_name: "Dodge",
    county_weights: {
      31053: 54.57,
      31177: 45.43,
    },
    county_names_all: "Dodge|Washington",
    county_fips_all: "31053|31177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68045,
    lat: 41.8273,
    lng: -96.49523,
    city: "Oakland",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1979,
    density: 7.8,
    county_fips: 31021,
    county_name: "Burt",
    county_weights: {
      31021: 79.06,
      31039: 19.87,
      31053: 1.07,
    },
    county_names_all: "Burt|Cuming|Dodge",
    county_fips_all: "31021|31039|31053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68046,
    lat: 41.12206,
    lng: -96.06138,
    city: "Papillion",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29091,
    density: 400.6,
    county_fips: 31153,
    county_name: "Sarpy",
    county_weights: {
      31153: 100,
    },
    county_names_all: "Sarpy",
    county_fips_all: 31153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68047,
    lat: 42.10592,
    lng: -96.7325,
    city: "Pender",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1820,
    density: 5.6,
    county_fips: 31173,
    county_name: "Thurston",
    county_weights: {
      31039: 32.54,
      31173: 55.75,
      31179: 11.71,
    },
    county_names_all: "Thurston|Cuming|Wayne",
    county_fips_all: "31173|31039|31179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68048,
    lat: 40.98304,
    lng: -95.9345,
    city: "Plattsmouth",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13034,
    density: 53.3,
    county_fips: 31025,
    county_name: "Cass",
    county_weights: {
      31025: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 31025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68050,
    lat: 41.30593,
    lng: -96.84303,
    city: "Prague",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 631,
    density: 4.3,
    county_fips: 31155,
    county_name: "Saunders",
    county_weights: {
      31155: 100,
    },
    county_names_all: "Saunders",
    county_fips_all: 31155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68055,
    lat: 42.05747,
    lng: -96.47192,
    city: "Rosalie",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 259,
    density: 2.1,
    county_fips: 31173,
    county_name: "Thurston",
    county_weights: {
      31173: 100,
    },
    county_names_all: "Thurston",
    county_fips_all: 31173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68056,
    lat: 41.14123,
    lng: -95.90438,
    city: "St Columbans",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 31153,
    county_name: "Sarpy",
    county_weights: {
      31153: 100,
    },
    county_names_all: "Sarpy",
    county_fips_all: 31153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68057,
    lat: 41.65888,
    lng: -96.71893,
    city: "Scribner",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1430,
    density: 4.3,
    county_fips: 31053,
    county_name: "Dodge",
    county_weights: {
      31039: 1.01,
      31053: 98.99,
    },
    county_names_all: "Dodge|Cuming",
    county_fips_all: "31053|31039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68058,
    lat: 41.00842,
    lng: -96.2483,
    city: "South Bend",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 246,
    density: 145.9,
    county_fips: 31025,
    county_name: "Cass",
    county_weights: {
      31025: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 31025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68059,
    lat: 41.06673,
    lng: -96.1595,
    city: "Springfield",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3472,
    density: 28.1,
    county_fips: 31153,
    county_name: "Sarpy",
    county_weights: {
      31153: 100,
    },
    county_names_all: "Sarpy",
    county_fips_all: 31153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68061,
    lat: 41.80078,
    lng: -96.21165,
    city: "Tekamah",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2350,
    density: 6.2,
    county_fips: 31021,
    county_name: "Burt",
    county_weights: {
      31021: 100,
    },
    county_names_all: "Burt",
    county_fips_all: 31021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68062,
    lat: 42.19538,
    lng: -96.6743,
    city: "Thurston",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 293,
    density: 2.9,
    county_fips: 31173,
    county_name: "Thurston",
    county_weights: {
      31173: 100,
    },
    county_names_all: "Thurston",
    county_fips_all: 31173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68063,
    lat: 41.72124,
    lng: -96.49345,
    city: "Uehling",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 247,
    density: 29.2,
    county_fips: 31053,
    county_name: "Dodge",
    county_weights: {
      31053: 100,
    },
    county_names_all: "Dodge",
    county_fips_all: 31053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68064,
    lat: 41.34925,
    lng: -96.35545,
    city: "Valley",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3464,
    density: 26.2,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31053: 0.93,
      31055: 89.75,
      31155: 9.32,
    },
    county_names_all: "Douglas|Saunders|Dodge",
    county_fips_all: "31055|31155|31053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68065,
    lat: 41.0766,
    lng: -96.84854,
    city: "Valparaiso",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1461,
    density: 6.5,
    county_fips: 31155,
    county_name: "Saunders",
    county_weights: {
      31023: 5.74,
      31109: 23.36,
      31155: 64.07,
      31159: 6.83,
    },
    county_names_all: "Saunders|Lancaster|Seward|Butler",
    county_fips_all: "31155|31109|31159|31023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68066,
    lat: 41.18451,
    lng: -96.61996,
    city: "Wahoo",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5373,
    density: 23.1,
    county_fips: 31155,
    county_name: "Saunders",
    county_weights: {
      31155: 100,
    },
    county_names_all: "Saunders",
    county_fips_all: 31155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68067,
    lat: 42.1519,
    lng: -96.48603,
    city: "Walthill",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1339,
    density: 8.5,
    county_fips: 31173,
    county_name: "Thurston",
    county_weights: {
      31173: 100,
    },
    county_names_all: "Thurston",
    county_fips_all: 31173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68068,
    lat: 41.39759,
    lng: -96.20741,
    city: "Washington",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 124,
    density: 233.8,
    county_fips: 31177,
    county_name: "Washington",
    county_weights: {
      31177: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 31177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68069,
    lat: 41.24166,
    lng: -96.31542,
    city: "Waterloo",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2941,
    density: 38.1,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 88.65,
      31153: 11.35,
    },
    county_names_all: "Douglas|Sarpy",
    county_fips_all: "31055|31153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68070,
    lat: 41.1924,
    lng: -96.79973,
    city: "Weston",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 860,
    density: 5,
    county_fips: 31155,
    county_name: "Saunders",
    county_weights: {
      31155: 100,
    },
    county_names_all: "Saunders",
    county_fips_all: 31155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68071,
    lat: 42.23605,
    lng: -96.47446,
    city: "Winnebago",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2139,
    density: 10.6,
    county_fips: 31173,
    county_name: "Thurston",
    county_weights: {
      31173: 100,
    },
    county_names_all: "Thurston",
    county_fips_all: 31173,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68072,
    lat: 41.61016,
    lng: -96.50473,
    city: "Winslow",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46,
    density: 122.9,
    county_fips: 31053,
    county_name: "Dodge",
    county_weights: {
      31053: 100,
    },
    county_names_all: "Dodge",
    county_fips_all: 31053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68073,
    lat: 41.23931,
    lng: -96.40931,
    city: "Yutan",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2275,
    density: 19.6,
    county_fips: 31155,
    county_name: "Saunders",
    county_weights: {
      31155: 100,
    },
    county_names_all: "Saunders",
    county_fips_all: 31155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68102,
    lat: 41.26231,
    lng: -95.93224,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8727,
    density: 1891.8,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 31055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68104,
    lat: 41.29525,
    lng: -96.00104,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37582,
    density: 2199.6,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 31055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68105,
    lat: 41.2406,
    lng: -95.96429,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22512,
    density: 2423,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 31055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68106,
    lat: 41.23885,
    lng: -96.00244,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20688,
    density: 1550.2,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 31055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68107,
    lat: 41.20888,
    lng: -95.95126,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29206,
    density: 1711.4,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 31055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68108,
    lat: 41.23753,
    lng: -95.93118,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14869,
    density: 1748.7,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 31055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68110,
    lat: 41.29867,
    lng: -95.91143,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9990,
    density: 453.6,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 31055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68111,
    lat: 41.29564,
    lng: -95.96395,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23371,
    density: 1726,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 31055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68112,
    lat: 41.38183,
    lng: -95.95804,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11604,
    density: 247.9,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 58.85,
      31177: 41.15,
    },
    county_names_all: "Douglas|Washington",
    county_fips_all: "31055|31177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68113,
    lat: 41.11745,
    lng: -95.90889,
    city: "Offutt Afb",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 880,
    density: 104.6,
    county_fips: 31153,
    county_name: "Sarpy",
    county_weights: {
      31153: 100,
    },
    county_names_all: "Sarpy",
    county_fips_all: 31153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68114,
    lat: 41.26318,
    lng: -96.05208,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17665,
    density: 1178.7,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 31055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68116,
    lat: 41.29842,
    lng: -96.16629,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32018,
    density: 1454.2,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 31055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68117,
    lat: 41.2062,
    lng: -96.00138,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8335,
    density: 659.2,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 31055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68118,
    lat: 41.263,
    lng: -96.1772,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9521,
    density: 924.2,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 31055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68122,
    lat: 41.36451,
    lng: -96.05036,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11214,
    density: 246.5,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 80.13,
      31177: 19.87,
    },
    county_names_all: "Douglas|Washington",
    county_fips_all: "31055|31177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68123,
    lat: 41.10108,
    lng: -95.94774,
    city: "Bellevue",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32542,
    density: 503.9,
    county_fips: 31153,
    county_name: "Sarpy",
    county_weights: {
      31153: 100,
    },
    county_names_all: "Sarpy",
    county_fips_all: 31153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68124,
    lat: 41.23515,
    lng: -96.0522,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15532,
    density: 1066.4,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 31055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68127,
    lat: 41.2061,
    lng: -96.05245,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21886,
    density: 1324.4,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 31055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68128,
    lat: 41.17972,
    lng: -96.07081,
    city: "La Vista",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19204,
    density: 1107.4,
    county_fips: 31153,
    county_name: "Sarpy",
    county_weights: {
      31153: 100,
    },
    county_names_all: "Sarpy",
    county_fips_all: 31153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68130,
    lat: 41.23394,
    lng: -96.19613,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21041,
    density: 1071.9,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 31055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68131,
    lat: 41.26435,
    lng: -95.96479,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13548,
    density: 2529.5,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 31055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68132,
    lat: 41.26506,
    lng: -96.00153,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15271,
    density: 2293.3,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 31055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68133,
    lat: 41.11754,
    lng: -96.00292,
    city: "Papillion",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11500,
    density: 288.8,
    county_fips: 31153,
    county_name: "Sarpy",
    county_weights: {
      31153: 100,
    },
    county_names_all: "Sarpy",
    county_fips_all: 31153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68134,
    lat: 41.29776,
    lng: -96.0503,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31274,
    density: 1463.8,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 31055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68135,
    lat: 41.2052,
    lng: -96.19576,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29329,
    density: 1439.7,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 31055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68136,
    lat: 41.16932,
    lng: -96.18783,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17735,
    density: 785.6,
    county_fips: 31153,
    county_name: "Sarpy",
    county_weights: {
      31153: 100,
    },
    county_names_all: "Sarpy",
    county_fips_all: 31153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68137,
    lat: 41.20595,
    lng: -96.11924,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24782,
    density: 1145.3,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 31055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68138,
    lat: 41.15661,
    lng: -96.13891,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11811,
    density: 410.4,
    county_fips: 31153,
    county_name: "Sarpy",
    county_weights: {
      31153: 100,
    },
    county_names_all: "Sarpy",
    county_fips_all: 31153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68142,
    lat: 41.37012,
    lng: -96.10276,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4401,
    density: 84.4,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 73.2,
      31177: 26.8,
    },
    county_names_all: "Douglas|Washington",
    county_fips_all: "31055|31177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68144,
    lat: 41.23473,
    lng: -96.11909,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24874,
    density: 1310.2,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 31055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68147,
    lat: 41.17655,
    lng: -95.95678,
    city: "Bellevue",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11433,
    density: 905,
    county_fips: 31153,
    county_name: "Sarpy",
    county_weights: {
      31055: 0.67,
      31153: 99.33,
    },
    county_names_all: "Sarpy|Douglas",
    county_fips_all: "31153|31055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68152,
    lat: 41.36282,
    lng: -95.99995,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6509,
    density: 187.3,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 84.92,
      31177: 15.08,
    },
    county_names_all: "Douglas|Washington",
    county_fips_all: "31055|31177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68154,
    lat: 41.26408,
    lng: -96.11665,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22658,
    density: 1287.9,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 31055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68157,
    lat: 41.17902,
    lng: -95.99536,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7108,
    density: 1066,
    county_fips: 31153,
    county_name: "Sarpy",
    county_weights: {
      31055: 0.28,
      31153: 99.72,
    },
    county_names_all: "Sarpy|Douglas",
    county_fips_all: "31153|31055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68164,
    lat: 41.29886,
    lng: -96.10949,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29124,
    density: 1272.5,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 31055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68178,
    lat: 41.26535,
    lng: -95.94535,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1586,
    density: 2844.6,
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 31055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68182,
    lat: 41.25775,
    lng: -96.01072,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 31055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68183,
    lat: 41.25709,
    lng: -95.93977,
    city: "Omaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 31055,
    county_name: "Douglas",
    county_weights: {
      31055: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 31055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68301,
    lat: 40.46847,
    lng: -96.52244,
    city: "Adams",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1384,
    density: 5,
    county_fips: 31067,
    county_name: "Gage",
    county_weights: {
      31067: 76.76,
      31109: 17.11,
      31131: 6.13,
    },
    county_names_all: "Gage|Lancaster|Otoe",
    county_fips_all: "31067|31109|31131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68303,
    lat: 40.25753,
    lng: -97.41033,
    city: "Alexandria",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 323,
    density: 1.9,
    county_fips: 31169,
    county_name: "Thayer",
    county_weights: {
      31095: 14.99,
      31169: 85.01,
    },
    county_names_all: "Thayer|Jefferson",
    county_fips_all: "31169|31095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68304,
    lat: 40.88971,
    lng: -96.38781,
    city: "Alvo",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 249,
    density: 3.9,
    county_fips: 31025,
    county_name: "Cass",
    county_weights: {
      31025: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 31025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68305,
    lat: 40.36392,
    lng: -95.85788,
    city: "Auburn",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4186,
    density: 11.2,
    county_fips: 31127,
    county_name: "Nemaha",
    county_weights: {
      31127: 100,
    },
    county_names_all: "Nemaha",
    county_fips_all: 31127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68307,
    lat: 40.78769,
    lng: -96.14054,
    city: "Avoca",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 508,
    density: 4.7,
    county_fips: 31025,
    county_name: "Cass",
    county_weights: {
      31025: 54.14,
      31131: 45.86,
    },
    county_names_all: "Cass|Otoe",
    county_fips_all: "31025|31131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68309,
    lat: 40.04907,
    lng: -96.57285,
    city: "Barneston",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 113,
    density: 195.9,
    county_fips: 31067,
    county_name: "Gage",
    county_weights: {
      31067: 100,
    },
    county_names_all: "Gage",
    county_fips_all: 31067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68310,
    lat: 40.24957,
    lng: -96.74943,
    city: "Beatrice",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14038,
    density: 25.1,
    county_fips: 31067,
    county_name: "Gage",
    county_weights: {
      31067: 97.38,
      31095: 2.62,
    },
    county_names_all: "Gage|Jefferson",
    county_fips_all: "31067|31095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68313,
    lat: 40.78142,
    lng: -97.27193,
    city: "Beaver Crossing",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 791,
    density: 4,
    county_fips: 31159,
    county_name: "Seward",
    county_weights: {
      31159: 98.69,
      31185: 1.31,
    },
    county_names_all: "Seward|York",
    county_fips_all: "31159|31185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68314,
    lat: 41.01643,
    lng: -97.0248,
    city: "Bee",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 329,
    density: 4,
    county_fips: 31159,
    county_name: "Seward",
    county_weights: {
      31023: 5.22,
      31159: 94.78,
    },
    county_names_all: "Seward|Butler",
    county_fips_all: "31159|31023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68315,
    lat: 40.24605,
    lng: -97.53841,
    city: "Belvidere",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68,
    density: 0.8,
    county_fips: 31169,
    county_name: "Thayer",
    county_weights: {
      31169: 100,
    },
    county_names_all: "Thayer",
    county_fips_all: 31169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68316,
    lat: 41.01688,
    lng: -97.61577,
    city: "Benedict",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 476,
    density: 3.7,
    county_fips: 31185,
    county_name: "York",
    county_weights: {
      31143: 12.19,
      31185: 87.81,
    },
    county_names_all: "York|Polk",
    county_fips_all: "31185|31143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68317,
    lat: 40.67325,
    lng: -96.50451,
    city: "Bennet",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1841,
    density: 15.5,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 87.75,
      31131: 12.25,
    },
    county_names_all: "Lancaster|Otoe",
    county_fips_all: "31109|31131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68318,
    lat: 40.15598,
    lng: -96.64439,
    city: "Blue Springs",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 533,
    density: 4.8,
    county_fips: 31067,
    county_name: "Gage",
    county_weights: {
      31067: 100,
    },
    county_names_all: "Gage",
    county_fips_all: 31067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68319,
    lat: 40.93656,
    lng: -97.75817,
    city: "Bradshaw",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 711,
    density: 4,
    county_fips: 31185,
    county_name: "York",
    county_weights: {
      31081: 1.43,
      31185: 98.57,
    },
    county_names_all: "York|Hamilton",
    county_fips_all: "31185|31081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68320,
    lat: 40.48148,
    lng: -95.9533,
    city: "Brock",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 357,
    density: 2.5,
    county_fips: 31127,
    county_name: "Nemaha",
    county_weights: {
      31127: 100,
    },
    county_names_all: "Nemaha",
    county_fips_all: 31127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68321,
    lat: 40.39491,
    lng: -95.69371,
    city: "Brownville",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 324,
    density: 4.7,
    county_fips: 31127,
    county_name: "Nemaha",
    county_weights: {
      31127: 100,
    },
    county_names_all: "Nemaha",
    county_fips_all: 31127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68322,
    lat: 40.3346,
    lng: -97.55356,
    city: "Bruning",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 485,
    density: 3,
    county_fips: 31169,
    county_name: "Thayer",
    county_weights: {
      31059: 29.31,
      31169: 70.69,
    },
    county_names_all: "Thayer|Fillmore",
    county_fips_all: "31169|31059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68323,
    lat: 40.13197,
    lng: -96.37034,
    city: "Burchard",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 248,
    density: 0.9,
    county_fips: 31133,
    county_name: "Pawnee",
    county_weights: {
      31133: 100,
    },
    county_names_all: "Pawnee",
    county_fips_all: 31133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68324,
    lat: 40.55407,
    lng: -96.29014,
    city: "Burr",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 99,
    density: 1.3,
    county_fips: 31131,
    county_name: "Otoe",
    county_weights: {
      31097: 9.49,
      31131: 90.51,
    },
    county_names_all: "Otoe|Johnson",
    county_fips_all: "31131|31097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68325,
    lat: 40.0131,
    lng: -97.75156,
    city: "Byron",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 150,
    density: 1.2,
    county_fips: 31169,
    county_name: "Thayer",
    county_weights: {
      20157: 44.82,
      31169: 55.18,
    },
    county_names_all: "Thayer|Republic",
    county_fips_all: "31169|20157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68326,
    lat: 40.28569,
    lng: -97.68243,
    city: "Carleton",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 267,
    density: 1.9,
    county_fips: 31169,
    county_name: "Thayer",
    county_weights: {
      31059: 5.5,
      31169: 94.5,
    },
    county_names_all: "Thayer|Fillmore",
    county_fips_all: "31169|31059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68327,
    lat: 40.01079,
    lng: -97.62113,
    city: "Chester",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 357,
    density: 2.9,
    county_fips: 31169,
    county_name: "Thayer",
    county_weights: {
      20157: 33.93,
      31169: 66.07,
    },
    county_names_all: "Thayer|Republic",
    county_fips_all: "31169|20157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68328,
    lat: 40.47694,
    lng: -96.8384,
    city: "Clatonia",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 479,
    density: 6.2,
    county_fips: 31067,
    county_name: "Gage",
    county_weights: {
      31067: 100,
    },
    county_names_all: "Gage",
    county_fips_all: 31067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68329,
    lat: 40.50089,
    lng: -96.16772,
    city: "Cook",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 525,
    density: 3.1,
    county_fips: 31097,
    county_name: "Johnson",
    county_weights: {
      31097: 72.02,
      31131: 27.98,
    },
    county_names_all: "Johnson|Otoe",
    county_fips_all: "31097|31131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68330,
    lat: 40.70651,
    lng: -97.34041,
    city: "Cordova",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 31159,
    county_name: "Seward",
    county_weights: {
      31159: 100,
    },
    county_names_all: "Seward",
    county_fips_all: 31159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68331,
    lat: 40.4712,
    lng: -96.70863,
    city: "Cortland",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1052,
    density: 8.4,
    county_fips: 31067,
    county_name: "Gage",
    county_weights: {
      31067: 100,
    },
    county_names_all: "Gage",
    county_fips_all: 31067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68332,
    lat: 40.32829,
    lng: -96.41123,
    city: "Crab Orchard",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 101,
    density: 0.9,
    county_fips: 31097,
    county_name: "Johnson",
    county_weights: {
      31097: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 31097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68333,
    lat: 40.62126,
    lng: -96.94901,
    city: "Crete",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8525,
    density: 29.9,
    county_fips: 31151,
    county_name: "Saline",
    county_weights: {
      31109: 33.2,
      31151: 66.8,
    },
    county_names_all: "Saline|Lancaster",
    county_fips_all: "31151|31109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68335,
    lat: 40.28243,
    lng: -97.803,
    city: "Davenport",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 573,
    density: 2.5,
    county_fips: 31169,
    county_name: "Thayer",
    county_weights: {
      31059: 9.74,
      31129: 33.36,
      31169: 56.9,
    },
    county_names_all: "Thayer|Nuckolls|Fillmore",
    county_fips_all: "31169|31129|31059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68336,
    lat: 40.9615,
    lng: -96.68405,
    city: "Davey",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 853,
    density: 19.7,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 31109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68337,
    lat: 40.09504,
    lng: -95.83418,
    city: "Dawson",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 323,
    density: 2.3,
    county_fips: 31147,
    county_name: "Richardson",
    county_weights: {
      31147: 100,
    },
    county_names_all: "Richardson",
    county_fips_all: 31147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68338,
    lat: 40.31865,
    lng: -97.24863,
    city: "Daykin",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 320,
    density: 3.1,
    county_fips: 31095,
    county_name: "Jefferson",
    county_weights: {
      31095: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 31095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68339,
    lat: 40.73214,
    lng: -96.86696,
    city: "Denton",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 987,
    density: 8.5,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 86.75,
      31151: 4.45,
      31159: 8.8,
    },
    county_names_all: "Lancaster|Seward|Saline",
    county_fips_all: "31109|31159|31151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68340,
    lat: 40.12525,
    lng: -97.74126,
    city: "Deshler",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 905,
    density: 6.4,
    county_fips: 31169,
    county_name: "Thayer",
    county_weights: {
      31169: 100,
    },
    county_names_all: "Thayer",
    county_fips_all: 31169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68341,
    lat: 40.3855,
    lng: -96.91378,
    city: "De Witt",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 984,
    density: 3.9,
    county_fips: 31067,
    county_name: "Gage",
    county_weights: {
      31067: 51.87,
      31095: 3.11,
      31151: 45.02,
    },
    county_names_all: "Gage|Saline|Jefferson",
    county_fips_all: "31067|31151|31095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68342,
    lat: 40.1034,
    lng: -96.94496,
    city: "Diller",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 656,
    density: 3.4,
    county_fips: 31095,
    county_name: "Jefferson",
    county_weights: {
      31067: 26.3,
      31095: 73.7,
    },
    county_names_all: "Jefferson|Gage",
    county_fips_all: "31095|31067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68343,
    lat: 40.61989,
    lng: -97.13194,
    city: "Dorchester",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 832,
    density: 3.6,
    county_fips: 31151,
    county_name: "Saline",
    county_weights: {
      31151: 94.9,
      31159: 5.1,
    },
    county_names_all: "Saline|Seward",
    county_fips_all: "31151|31159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68344,
    lat: 40.57159,
    lng: -96.39544,
    city: "Douglas",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 457,
    density: 5.3,
    county_fips: 31131,
    county_name: "Otoe",
    county_weights: {
      31131: 100,
    },
    county_names_all: "Otoe",
    county_fips_all: 31131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68345,
    lat: 40.03692,
    lng: -96.01928,
    city: "Du Bois",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 216,
    density: 1.8,
    county_fips: 31133,
    county_name: "Pawnee",
    county_weights: {
      31133: 65.12,
      31147: 34.88,
    },
    county_names_all: "Pawnee|Richardson",
    county_fips_all: "31133|31147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68346,
    lat: 40.66195,
    lng: -96.03066,
    city: "Dunbar",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 564,
    density: 3.9,
    county_fips: 31131,
    county_name: "Otoe",
    county_weights: {
      31131: 100,
    },
    county_names_all: "Otoe",
    county_fips_all: 31131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68347,
    lat: 40.80347,
    lng: -96.42274,
    city: "Eagle",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2629,
    density: 32.3,
    county_fips: 31025,
    county_name: "Cass",
    county_weights: {
      31025: 65.91,
      31131: 34.09,
    },
    county_names_all: "Cass|Otoe",
    county_fips_all: "31025|31131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68348,
    lat: 40.29569,
    lng: -96.12208,
    city: "Elk Creek",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 229,
    density: 2,
    county_fips: 31097,
    county_name: "Johnson",
    county_weights: {
      31097: 75.38,
      31127: 11.32,
      31133: 13.3,
    },
    county_names_all: "Johnson|Pawnee|Nemaha",
    county_fips_all: "31097|31133|31127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68349,
    lat: 40.82962,
    lng: -96.30028,
    city: "Elmwood",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1064,
    density: 8.5,
    county_fips: 31025,
    county_name: "Cass",
    county_weights: {
      31025: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 31025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68350,
    lat: 40.03961,
    lng: -97.09166,
    city: "Endicott",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 250,
    density: 3.2,
    county_fips: 31095,
    county_name: "Jefferson",
    county_weights: {
      31095: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 31095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68351,
    lat: 40.65393,
    lng: -97.43015,
    city: "Exeter",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 833,
    density: 3.6,
    county_fips: 31059,
    county_name: "Fillmore",
    county_weights: {
      31059: 73.99,
      31185: 26.01,
    },
    county_names_all: "Fillmore|York",
    county_fips_all: "31059|31185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68352,
    lat: 40.15255,
    lng: -97.21931,
    city: "Fairbury",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4722,
    density: 6.7,
    county_fips: 31095,
    county_name: "Jefferson",
    county_weights: {
      31095: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 31095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68354,
    lat: 40.63935,
    lng: -97.58032,
    city: "Fairmont",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 990,
    density: 3.6,
    county_fips: 31059,
    county_name: "Fillmore",
    county_weights: {
      31059: 86.86,
      31185: 13.14,
    },
    county_names_all: "Fillmore|York",
    county_fips_all: "31059|31185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68355,
    lat: 40.11677,
    lng: -95.56702,
    city: "Falls City",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4853,
    density: 12.1,
    county_fips: 31147,
    county_name: "Richardson",
    county_weights: {
      31147: 100,
    },
    county_names_all: "Richardson",
    county_fips_all: 31147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68357,
    lat: 40.31541,
    lng: -96.54658,
    city: "Filley",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 303,
    density: 2.3,
    county_fips: 31067,
    county_name: "Gage",
    county_weights: {
      31067: 98.92,
      31097: 1.08,
    },
    county_names_all: "Gage|Johnson",
    county_fips_all: "31067|31097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68358,
    lat: 40.53321,
    lng: -96.60973,
    city: "Firth",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1544,
    density: 13.2,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31067: 32.55,
      31109: 67.45,
    },
    county_names_all: "Lancaster|Gage",
    county_fips_all: "31109|31067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68359,
    lat: 40.63059,
    lng: -97.28333,
    city: "Friend",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1562,
    density: 5,
    county_fips: 31151,
    county_name: "Saline",
    county_weights: {
      31059: 0.42,
      31151: 85.42,
      31159: 14.16,
    },
    county_names_all: "Saline|Seward|Fillmore",
    county_fips_all: "31151|31159|31059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68360,
    lat: 40.94613,
    lng: -96.95661,
    city: "Garland",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 478,
    density: 7.9,
    county_fips: 31159,
    county_name: "Seward",
    county_weights: {
      31159: 100,
    },
    county_names_all: "Seward",
    county_fips_all: 31159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68361,
    lat: 40.50756,
    lng: -97.60146,
    city: "Geneva",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2207,
    density: 8.1,
    county_fips: 31059,
    county_name: "Fillmore",
    county_weights: {
      31059: 100,
    },
    county_names_all: "Fillmore",
    county_fips_all: 31059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68362,
    lat: 40.15323,
    lng: -97.42553,
    city: "Gilead",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31,
    density: 5.3,
    county_fips: 31169,
    county_name: "Thayer",
    county_weights: {
      31169: 100,
    },
    county_names_all: "Thayer",
    county_fips_all: 31169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68364,
    lat: 40.83656,
    lng: -97.22563,
    city: "Goehner",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 148,
    density: 57.3,
    county_fips: 31159,
    county_name: "Seward",
    county_weights: {
      31159: 100,
    },
    county_names_all: "Seward",
    county_fips_all: 31159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68365,
    lat: 40.61565,
    lng: -97.73065,
    city: "Grafton",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 270,
    density: 2.1,
    county_fips: 31059,
    county_name: "Fillmore",
    county_weights: {
      31059: 97.33,
      31185: 2.67,
    },
    county_names_all: "Fillmore|York",
    county_fips_all: "31059|31185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68366,
    lat: 40.98215,
    lng: -96.44222,
    city: "Greenwood",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 889,
    density: 6.3,
    county_fips: 31025,
    county_name: "Cass",
    county_weights: {
      31025: 62.32,
      31109: 32.58,
      31155: 5.1,
    },
    county_names_all: "Cass|Lancaster|Saunders",
    county_fips_all: "31025|31109|31155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68367,
    lat: 41.03807,
    lng: -97.40128,
    city: "Gresham",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 292,
    density: 1.8,
    county_fips: 31143,
    county_name: "Polk",
    county_weights: {
      31143: 36.37,
      31159: 30.71,
      31185: 32.92,
    },
    county_names_all: "Polk|York|Seward",
    county_fips_all: "31143|31185|31159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68368,
    lat: 40.55598,
    lng: -96.81665,
    city: "Hallam",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 558,
    density: 5.7,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31067: 10.33,
      31109: 89.67,
    },
    county_names_all: "Lancaster|Gage",
    county_fips_all: "31109|31067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68370,
    lat: 40.14148,
    lng: -97.55567,
    city: "Hebron",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1894,
    density: 4.5,
    county_fips: 31169,
    county_name: "Thayer",
    county_weights: {
      31169: 100,
    },
    county_names_all: "Thayer",
    county_fips_all: 31169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68371,
    lat: 40.77304,
    lng: -97.78417,
    city: "Henderson",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1368,
    density: 6.7,
    county_fips: 31185,
    county_name: "York",
    county_weights: {
      31081: 23.09,
      31185: 76.91,
    },
    county_names_all: "York|Hamilton",
    county_fips_all: "31185|31081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68372,
    lat: 40.60498,
    lng: -96.60539,
    city: "Hickman",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3993,
    density: 42.9,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 31109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68375,
    lat: 40.03939,
    lng: -97.48826,
    city: "Hubbell",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 125,
    density: 1.7,
    county_fips: 31169,
    county_name: "Thayer",
    county_weights: {
      31169: 100,
    },
    county_names_all: "Thayer",
    county_fips_all: 31169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68376,
    lat: 40.171,
    lng: -95.93809,
    city: "Humboldt",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1493,
    density: 3.7,
    county_fips: 31147,
    county_name: "Richardson",
    county_weights: {
      31127: 10.33,
      31133: 7.2,
      31147: 82.47,
    },
    county_names_all: "Richardson|Nemaha|Pawnee",
    county_fips_all: "31147|31127|31133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68377,
    lat: 40.217,
    lng: -97.02303,
    city: "Jansen",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 403,
    density: 2.9,
    county_fips: 31095,
    county_name: "Jefferson",
    county_weights: {
      31095: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 31095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68378,
    lat: 40.39355,
    lng: -96.02615,
    city: "Johnson",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 644,
    density: 4.6,
    county_fips: 31127,
    county_name: "Nemaha",
    county_weights: {
      31097: 14.63,
      31127: 85.37,
    },
    county_names_all: "Nemaha|Johnson",
    county_fips_all: "31127|31097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68379,
    lat: 40.52908,
    lng: -95.86979,
    city: "Julian",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 31131,
    county_name: "Otoe",
    county_weights: {
      31127: 7.37,
      31131: 92.63,
    },
    county_names_all: "Otoe|Nemaha",
    county_fips_all: "31131|31127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68380,
    lat: 40.24283,
    lng: -96.4059,
    city: "Lewiston",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47,
    density: 2.6,
    county_fips: 31133,
    county_name: "Pawnee",
    county_weights: {
      31097: 0.1,
      31133: 99.9,
    },
    county_names_all: "Pawnee|Johnson",
    county_fips_all: "31133|31097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68381,
    lat: 40.07979,
    lng: -96.48176,
    city: "Liberty",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 126,
    density: 0.8,
    county_fips: 31067,
    county_name: "Gage",
    county_weights: {
      31067: 71.33,
      31133: 28.67,
    },
    county_names_all: "Gage|Pawnee",
    county_fips_all: "31067|31133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68382,
    lat: 40.59724,
    lng: -96.02425,
    city: "Lorton",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33,
    density: 299.1,
    county_fips: 31131,
    county_name: "Otoe",
    county_weights: {
      31131: 100,
    },
    county_names_all: "Otoe",
    county_fips_all: 31131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68401,
    lat: 40.74233,
    lng: -97.58569,
    city: "McCool Junction",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 889,
    density: 8.8,
    county_fips: 31185,
    county_name: "York",
    county_weights: {
      31185: 100,
    },
    county_names_all: "York",
    county_fips_all: 31185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68402,
    lat: 40.90829,
    lng: -96.8571,
    city: "Malcolm",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1021,
    density: 12.1,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 31109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68403,
    lat: 40.92045,
    lng: -96.16707,
    city: "Manley",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 189,
    density: 98.5,
    county_fips: 31025,
    county_name: "Cass",
    county_weights: {
      31025: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 31025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68404,
    lat: 40.619,
    lng: -96.75566,
    city: "Martell",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1015,
    density: 7.8,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 31109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68405,
    lat: 40.76522,
    lng: -97.07315,
    city: "Milford",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3333,
    density: 16.2,
    county_fips: 31159,
    county_name: "Seward",
    county_weights: {
      31151: 0.96,
      31159: 99.04,
    },
    county_names_all: "Seward|Saline",
    county_fips_all: "31159|31151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68406,
    lat: 40.50566,
    lng: -97.37874,
    city: "Milligan",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 466,
    density: 3.4,
    county_fips: 31059,
    county_name: "Fillmore",
    county_weights: {
      31059: 61.55,
      31151: 38.45,
    },
    county_names_all: "Fillmore|Saline",
    county_fips_all: "31059|31151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68407,
    lat: 40.921,
    lng: -96.26263,
    city: "Murdock",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 834,
    density: 7,
    county_fips: 31025,
    county_name: "Cass",
    county_weights: {
      31025: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 31025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68409,
    lat: 40.90906,
    lng: -95.95074,
    city: "Murray",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 731,
    density: 9.5,
    county_fips: 31025,
    county_name: "Cass",
    county_weights: {
      31025: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 31025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68410,
    lat: 40.63729,
    lng: -95.88584,
    city: "Nebraska City",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8761,
    density: 23.6,
    county_fips: 31131,
    county_name: "Otoe",
    county_weights: {
      31131: 100,
    },
    county_names_all: "Otoe",
    county_fips_all: 31131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68413,
    lat: 40.83775,
    lng: -96.01053,
    city: "Nehawka",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 552,
    density: 3.8,
    county_fips: 31025,
    county_name: "Cass",
    county_weights: {
      31025: 85.49,
      31131: 14.51,
    },
    county_names_all: "Cass|Otoe",
    county_fips_all: "31025|31131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68414,
    lat: 40.31966,
    lng: -95.6991,
    city: "Nemaha",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 237,
    density: 2.9,
    county_fips: 31127,
    county_name: "Nemaha",
    county_weights: {
      31127: 100,
    },
    county_names_all: "Nemaha",
    county_fips_all: 31127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68415,
    lat: 40.06249,
    lng: -96.82157,
    city: "Odell",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 630,
    density: 3.4,
    county_fips: 31067,
    county_name: "Gage",
    county_weights: {
      31067: 100,
    },
    county_names_all: "Gage",
    county_fips_all: 31067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68416,
    lat: 40.41093,
    lng: -97.46185,
    city: "Ohiowa",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 216,
    density: 1.8,
    county_fips: 31059,
    county_name: "Fillmore",
    county_weights: {
      31059: 100,
    },
    county_names_all: "Fillmore",
    county_fips_all: 31059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68417,
    lat: 40.7359,
    lng: -96.09199,
    city: "Otoe",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 356,
    density: 6,
    county_fips: 31131,
    county_name: "Otoe",
    county_weights: {
      31131: 100,
    },
    county_names_all: "Otoe",
    county_fips_all: 31131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68418,
    lat: 40.69568,
    lng: -96.38435,
    city: "Palmyra",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1130,
    density: 6.4,
    county_fips: 31131,
    county_name: "Otoe",
    county_weights: {
      31025: 2.88,
      31131: 97.12,
    },
    county_names_all: "Otoe|Cass",
    county_fips_all: "31131|31025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68419,
    lat: 40.60297,
    lng: -96.51129,
    city: "Panama",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 248,
    density: 95.1,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 31109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68420,
    lat: 40.08556,
    lng: -96.19125,
    city: "Pawnee City",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1356,
    density: 4,
    county_fips: 31133,
    county_name: "Pawnee",
    county_weights: {
      20131: 2.34,
      31133: 97.66,
    },
    county_names_all: "Pawnee|Nemaha",
    county_fips_all: "31133|20131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68421,
    lat: 40.492,
    lng: -95.74426,
    city: "Peru",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1165,
    density: 9.1,
    county_fips: 31127,
    county_name: "Nemaha",
    county_weights: {
      31127: 94.22,
      31131: 5.78,
    },
    county_names_all: "Nemaha|Otoe",
    county_fips_all: "31127|31131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68422,
    lat: 40.38863,
    lng: -96.69755,
    city: "Pickrell",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 505,
    density: 3.8,
    county_fips: 31067,
    county_name: "Gage",
    county_weights: {
      31067: 100,
    },
    county_names_all: "Gage",
    county_fips_all: 31067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68423,
    lat: 40.80112,
    lng: -96.95117,
    city: "Pleasant Dale",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1048,
    density: 7.3,
    county_fips: 31159,
    county_name: "Seward",
    county_weights: {
      31109: 2.82,
      31151: 0.92,
      31159: 96.26,
    },
    county_names_all: "Seward|Lancaster|Saline",
    county_fips_all: "31159|31109|31151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68424,
    lat: 40.30111,
    lng: -97.01818,
    city: "Plymouth",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 621,
    density: 3.7,
    county_fips: 31095,
    county_name: "Jefferson",
    county_weights: {
      31067: 1.43,
      31095: 98.57,
    },
    county_names_all: "Jefferson|Gage",
    county_fips_all: "31095|31067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68428,
    lat: 40.97244,
    lng: -96.79624,
    city: "Raymond",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1377,
    density: 9.3,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 95.75,
      31159: 4.25,
    },
    county_names_all: "Lancaster|Seward",
    county_fips_all: "31109|31159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68429,
    lat: 40.06406,
    lng: -97.37437,
    city: "Reynolds",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 31095,
    county_name: "Jefferson",
    county_weights: {
      31095: 52.11,
      31169: 47.89,
    },
    county_names_all: "Jefferson|Thayer",
    county_fips_all: "31095|31169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68430,
    lat: 40.66599,
    lng: -96.66012,
    city: "Roca",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1559,
    density: 13.2,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 31109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68431,
    lat: 40.0677,
    lng: -95.43402,
    city: "Rulo",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 226,
    density: 1.8,
    county_fips: 31147,
    county_name: "Richardson",
    county_weights: {
      31147: 100,
    },
    county_names_all: "Richardson",
    county_fips_all: 31147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68433,
    lat: 40.05251,
    lng: -95.73969,
    city: "Salem",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 225,
    density: 1.6,
    county_fips: 31147,
    county_name: "Richardson",
    county_weights: {
      31147: 100,
    },
    county_names_all: "Richardson",
    county_fips_all: 31147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68434,
    lat: 40.90947,
    lng: -97.11675,
    city: "Seward",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8705,
    density: 21.4,
    county_fips: 31159,
    county_name: "Seward",
    county_weights: {
      31159: 100,
    },
    county_names_all: "Seward",
    county_fips_all: 31159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68436,
    lat: 40.43357,
    lng: -97.74427,
    city: "Shickley",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 481,
    density: 2.3,
    county_fips: 31059,
    county_name: "Fillmore",
    county_weights: {
      31035: 4.41,
      31059: 95.59,
    },
    county_names_all: "Fillmore|Clay",
    county_fips_all: "31059|31035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68437,
    lat: 40.2513,
    lng: -95.63534,
    city: "Shubert",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 257,
    density: 2.1,
    county_fips: 31147,
    county_name: "Richardson",
    county_weights: {
      31127: 38.55,
      31147: 61.45,
    },
    county_names_all: "Richardson|Nemaha",
    county_fips_all: "31147|31127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68438,
    lat: 40.62656,
    lng: -96.74463,
    city: "Sprague",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 73,
    density: 279.7,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 31109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68439,
    lat: 40.99937,
    lng: -97.21136,
    city: "Staplehurst",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 766,
    density: 8.3,
    county_fips: 31159,
    county_name: "Seward",
    county_weights: {
      31159: 100,
    },
    county_names_all: "Seward",
    county_fips_all: 31159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68440,
    lat: 40.05266,
    lng: -97.01168,
    city: "Steele City",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 94,
    density: 1.6,
    county_fips: 31095,
    county_name: "Jefferson",
    county_weights: {
      31095: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 31095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68441,
    lat: 40.22581,
    lng: -96.25461,
    city: "Steinauer",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 142,
    density: 0.8,
    county_fips: 31133,
    county_name: "Pawnee",
    county_weights: {
      31097: 10.53,
      31133: 89.47,
    },
    county_names_all: "Pawnee|Johnson",
    county_fips_all: "31133|31097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68442,
    lat: 40.239,
    lng: -95.7729,
    city: "Stella",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 224,
    density: 2.4,
    county_fips: 31147,
    county_name: "Richardson",
    county_weights: {
      31127: 19.91,
      31147: 80.09,
    },
    county_names_all: "Richardson|Nemaha",
    county_fips_all: "31147|31127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68443,
    lat: 40.45627,
    lng: -96.36758,
    city: "Sterling",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 925,
    density: 3.7,
    county_fips: 31097,
    county_name: "Johnson",
    county_weights: {
      31097: 98.41,
      31131: 1.59,
    },
    county_names_all: "Johnson|Otoe",
    county_fips_all: "31097|31131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68444,
    lat: 40.41117,
    lng: -97.5847,
    city: "Strang",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46,
    density: 0.7,
    county_fips: 31059,
    county_name: "Fillmore",
    county_weights: {
      31059: 100,
    },
    county_names_all: "Fillmore",
    county_fips_all: 31059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68445,
    lat: 40.40146,
    lng: -97.08662,
    city: "Swanton",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 204,
    density: 3.7,
    county_fips: 31151,
    county_name: "Saline",
    county_weights: {
      31151: 100,
    },
    county_names_all: "Saline",
    county_fips_all: 31151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68446,
    lat: 40.65002,
    lng: -96.17535,
    city: "Syracuse",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2783,
    density: 11,
    county_fips: 31131,
    county_name: "Otoe",
    county_weights: {
      31131: 100,
    },
    county_names_all: "Otoe",
    county_fips_all: 31131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68447,
    lat: 40.20044,
    lng: -96.07366,
    city: "Table Rock",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 548,
    density: 3.9,
    county_fips: 31133,
    county_name: "Pawnee",
    county_weights: {
      31097: 3.89,
      31127: 6.87,
      31133: 89.24,
    },
    county_names_all: "Pawnee|Nemaha|Johnson",
    county_fips_all: "31133|31127|31097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68448,
    lat: 40.54429,
    lng: -96.035,
    city: "Talmage",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 378,
    density: 3.1,
    county_fips: 31131,
    county_name: "Otoe",
    county_weights: {
      31097: 8.62,
      31127: 10.77,
      31131: 80.61,
    },
    county_names_all: "Otoe|Nemaha|Johnson",
    county_fips_all: "31131|31127|31097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68450,
    lat: 40.36197,
    lng: -96.22383,
    city: "Tecumseh",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3280,
    density: 9.6,
    county_fips: 31097,
    county_name: "Johnson",
    county_weights: {
      31097: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 31097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68452,
    lat: 40.39755,
    lng: -97.85036,
    city: "Ong",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 85,
    density: 2.2,
    county_fips: 31035,
    county_name: "Clay",
    county_weights: {
      31035: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 31035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68453,
    lat: 40.40774,
    lng: -97.33455,
    city: "Tobias",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 296,
    density: 1.6,
    county_fips: 31151,
    county_name: "Saline",
    county_weights: {
      31059: 19.63,
      31095: 6.75,
      31151: 69.8,
      31169: 3.82,
    },
    county_names_all: "Saline|Fillmore|Jefferson|Thayer",
    county_fips_all: "31151|31059|31095|31169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68454,
    lat: 40.69275,
    lng: -96.28686,
    city: "Unadilla",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 774,
    density: 5.3,
    county_fips: 31131,
    county_name: "Otoe",
    county_weights: {
      31025: 1.75,
      31131: 98.25,
    },
    county_names_all: "Otoe|Cass",
    county_fips_all: "31131|31025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68455,
    lat: 40.82286,
    lng: -95.90123,
    city: "Union",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 541,
    density: 5.4,
    county_fips: 31025,
    county_name: "Cass",
    county_weights: {
      31025: 92.99,
      31131: 7.01,
    },
    county_names_all: "Cass|Otoe",
    county_fips_all: "31025|31131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68456,
    lat: 40.91278,
    lng: -97.31007,
    city: "Utica",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1337,
    density: 9.8,
    county_fips: 31159,
    county_name: "Seward",
    county_weights: {
      31159: 100,
    },
    county_names_all: "Seward",
    county_fips_all: 31159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68457,
    lat: 40.15618,
    lng: -95.71095,
    city: "Verdon",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 435,
    density: 4.5,
    county_fips: 31147,
    county_name: "Richardson",
    county_weights: {
      31147: 100,
    },
    county_names_all: "Richardson",
    county_fips_all: 31147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68458,
    lat: 40.23107,
    lng: -96.48742,
    city: "Virginia",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 162,
    density: 1.8,
    county_fips: 31067,
    county_name: "Gage",
    county_weights: {
      31067: 74.15,
      31097: 8.62,
      31133: 17.23,
    },
    county_names_all: "Gage|Pawnee|Johnson",
    county_fips_all: "31067|31133|31097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68460,
    lat: 40.89596,
    lng: -97.43169,
    city: "Waco",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 638,
    density: 2.3,
    county_fips: 31185,
    county_name: "York",
    county_weights: {
      31159: 3.21,
      31185: 96.79,
    },
    county_names_all: "York|Seward",
    county_fips_all: "31185|31159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68461,
    lat: 40.76682,
    lng: -96.51419,
    city: "Walton",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1456,
    density: 23.8,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 31109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68462,
    lat: 40.94804,
    lng: -96.52806,
    city: "Waverly",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4391,
    density: 30.7,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31025: 5.34,
      31109: 94.66,
    },
    county_names_all: "Lancaster|Cass",
    county_fips_all: "31109|31025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68463,
    lat: 40.8759,
    lng: -96.13518,
    city: "Weeping Water",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1347,
    density: 9,
    county_fips: 31025,
    county_name: "Cass",
    county_weights: {
      31025: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 31025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68464,
    lat: 40.42232,
    lng: -97.1955,
    city: "Western",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 489,
    density: 2.3,
    county_fips: 31151,
    county_name: "Saline",
    county_weights: {
      31095: 2.28,
      31151: 97.72,
    },
    county_names_all: "Saline|Jefferson",
    county_fips_all: "31151|31095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68465,
    lat: 40.49248,
    lng: -97.01987,
    city: "Wilber",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2680,
    density: 10.1,
    county_fips: 31151,
    county_name: "Saline",
    county_weights: {
      31067: 6.01,
      31109: 2.7,
      31151: 91.29,
    },
    county_names_all: "Saline|Gage|Lancaster",
    county_fips_all: "31151|31067|31109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68466,
    lat: 40.07109,
    lng: -96.63773,
    city: "Wymore",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1719,
    density: 6.3,
    county_fips: 31067,
    county_name: "Gage",
    county_weights: {
      31067: 100,
    },
    county_names_all: "Gage",
    county_fips_all: 31067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68467,
    lat: 40.86528,
    lng: -97.59778,
    city: "York",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9189,
    density: 20.5,
    county_fips: 31185,
    county_name: "York",
    county_weights: {
      31185: 100,
    },
    county_names_all: "York",
    county_fips_all: 31185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68502,
    lat: 40.78361,
    lng: -96.70083,
    city: "Lincoln",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27685,
    density: 1602,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 31109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68503,
    lat: 40.82447,
    lng: -96.67387,
    city: "Lincoln",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15401,
    density: 2037.6,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 31109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68504,
    lat: 40.85451,
    lng: -96.66104,
    city: "Lincoln",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16808,
    density: 927.9,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 31109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68505,
    lat: 40.82446,
    lng: -96.61562,
    city: "Lincoln",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16574,
    density: 1480.1,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 31109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68506,
    lat: 40.78422,
    lng: -96.63959,
    city: "Lincoln",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28161,
    density: 1554.7,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 31109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68507,
    lat: 40.85954,
    lng: -96.61172,
    city: "Lincoln",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15393,
    density: 534.4,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 31109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68508,
    lat: 40.81831,
    lng: -96.70621,
    city: "Lincoln",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17184,
    density: 2237.8,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 31109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68510,
    lat: 40.80654,
    lng: -96.64835,
    city: "Lincoln",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20585,
    density: 1746.5,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 31109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68512,
    lat: 40.73746,
    lng: -96.70567,
    city: "Lincoln",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13900,
    density: 588.6,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 31109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68514,
    lat: 40.93408,
    lng: -96.65076,
    city: "Lincoln",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 130,
    density: 7.4,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 31109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68516,
    lat: 40.73493,
    lng: -96.6428,
    city: "Lincoln",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46626,
    density: 951.7,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 31109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68517,
    lat: 40.93341,
    lng: -96.60487,
    city: "Lincoln",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 523,
    density: 7.7,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 31109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68520,
    lat: 40.79827,
    lng: -96.55313,
    city: "Lincoln",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2713,
    density: 91.4,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 31109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68521,
    lat: 40.8618,
    lng: -96.71519,
    city: "Lincoln",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36166,
    density: 1059.9,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 31109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68522,
    lat: 40.78941,
    lng: -96.76214,
    city: "Lincoln",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13563,
    density: 494.5,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 31109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68523,
    lat: 40.73555,
    lng: -96.75708,
    city: "Lincoln",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1482,
    density: 36.4,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 31109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68524,
    lat: 40.87145,
    lng: -96.80264,
    city: "Lincoln",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6510,
    density: 87.8,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 31109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68526,
    lat: 40.7324,
    lng: -96.58269,
    city: "Lincoln",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6863,
    density: 218.4,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 31109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68527,
    lat: 40.84573,
    lng: -96.51753,
    city: "Lincoln",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 852,
    density: 11.1,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31025: 6.29,
      31109: 93.71,
    },
    county_names_all: "Lancaster|Cass",
    county_fips_all: "31109|31025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68528,
    lat: 40.82244,
    lng: -96.81762,
    city: "Lincoln",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5716,
    density: 134.1,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 99.06,
      31159: 0.94,
    },
    county_names_all: "Lancaster|Seward",
    county_fips_all: "31109|31159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68531,
    lat: 40.90211,
    lng: -96.71415,
    city: "Lincoln",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 747,
    density: 47.9,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 31109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68532,
    lat: 40.79544,
    lng: -96.84332,
    city: "Lincoln",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 517,
    density: 17.7,
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 31109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68588,
    lat: 40.82482,
    lng: -96.69644,
    city: "Lincoln",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 31109,
    county_name: "Lancaster",
    county_weights: {
      31109: 100,
    },
    county_names_all: "Lancaster",
    county_fips_all: 31109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68601,
    lat: 41.45205,
    lng: -97.39477,
    city: "Columbus",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28791,
    density: 38.8,
    county_fips: 31141,
    county_name: "Platte",
    county_weights: {
      31023: 2.09,
      31037: 13.31,
      31141: 73.91,
      31143: 10.69,
    },
    county_names_all: "Platte|Colfax|Polk|Butler",
    county_fips_all: "31141|31037|31143|31023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68620,
    lat: 41.72452,
    lng: -98.05814,
    city: "Albion",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2633,
    density: 3.6,
    county_fips: 31011,
    county_name: "Boone",
    county_weights: {
      31011: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 31011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68621,
    lat: 41.48963,
    lng: -96.63911,
    city: "Ames",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 413,
    density: 5,
    county_fips: 31053,
    county_name: "Dodge",
    county_weights: {
      31053: 100,
    },
    county_names_all: "Dodge",
    county_fips_all: 31053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68622,
    lat: 41.92209,
    lng: -98.53311,
    city: "Bartlett",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 241,
    density: 0.3,
    county_fips: 31183,
    county_name: "Wheeler",
    county_weights: {
      31183: 100,
    },
    county_names_all: "Wheeler",
    county_fips_all: 31183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68623,
    lat: 41.44327,
    lng: -98.11602,
    city: "Belgrade",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 322,
    density: 1.9,
    county_fips: 31125,
    county_name: "Nance",
    county_weights: {
      31011: 6.96,
      31125: 93.04,
    },
    county_names_all: "Nance|Boone",
    county_fips_all: "31125|31011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68624,
    lat: 41.34974,
    lng: -97.22858,
    city: "Bellwood",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 965,
    density: 5.2,
    county_fips: 31023,
    county_name: "Butler",
    county_weights: {
      31023: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 31023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68626,
    lat: 41.16821,
    lng: -96.9921,
    city: "Brainard",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 598,
    density: 3.8,
    county_fips: 31023,
    county_name: "Butler",
    county_weights: {
      31023: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 31023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68627,
    lat: 41.54445,
    lng: -98.17041,
    city: "Cedar Rapids",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 761,
    density: 2,
    county_fips: 31011,
    county_name: "Boone",
    county_weights: {
      31011: 84.75,
      31077: 4.52,
      31125: 10.73,
    },
    county_names_all: "Boone|Nance|Greeley",
    county_fips_all: "31011|31125|31077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68628,
    lat: 41.21694,
    lng: -97.84355,
    city: "Clarks",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 929,
    density: 3.3,
    county_fips: 31121,
    county_name: "Merrick",
    county_weights: {
      31081: 4.65,
      31121: 76.55,
      31143: 18.8,
    },
    county_names_all: "Merrick|Polk|Hamilton",
    county_fips_all: "31121|31143|31081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68629,
    lat: 41.71336,
    lng: -97.12936,
    city: "Clarkson",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1173,
    density: 3.2,
    county_fips: 31037,
    county_name: "Colfax",
    county_weights: {
      31037: 63.7,
      31167: 36.3,
    },
    county_names_all: "Colfax|Stanton",
    county_fips_all: "31037|31167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68631,
    lat: 41.68753,
    lng: -97.35074,
    city: "Creston",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 395,
    density: 3.9,
    county_fips: 31141,
    county_name: "Platte",
    county_weights: {
      31141: 87.69,
      31167: 12.31,
    },
    county_names_all: "Platte|Stanton",
    county_fips_all: "31141|31167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68632,
    lat: 41.24266,
    lng: -97.13288,
    city: "David City",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3623,
    density: 9.1,
    county_fips: 31023,
    county_name: "Butler",
    county_weights: {
      31023: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 31023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68633,
    lat: 41.70585,
    lng: -96.89668,
    city: "Dodge",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1096,
    density: 4.3,
    county_fips: 31053,
    county_name: "Dodge",
    county_weights: {
      31037: 19.78,
      31039: 32.22,
      31053: 48.01,
    },
    county_names_all: "Dodge|Cuming|Colfax",
    county_fips_all: "31053|31039|31037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68634,
    lat: 41.39073,
    lng: -97.50659,
    city: "Duncan",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 31141,
    county_name: "Platte",
    county_weights: {
      31141: 100,
    },
    county_names_all: "Platte",
    county_fips_all: 31141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68635,
    lat: 41.08544,
    lng: -97.02298,
    city: "Dwight",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 514,
    density: 4.1,
    county_fips: 31023,
    county_name: "Butler",
    county_weights: {
      31023: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 31023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68636,
    lat: 42.00494,
    lng: -98.15674,
    city: "Elgin",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1299,
    density: 2.4,
    county_fips: 31003,
    county_name: "Antelope",
    county_weights: {
      31003: 93.73,
      31183: 6.27,
    },
    county_names_all: "Antelope|Wheeler",
    county_fips_all: "31003|31183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68637,
    lat: 41.78778,
    lng: -98.68997,
    city: "Ericson",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 274,
    density: 0.7,
    county_fips: 31183,
    county_name: "Wheeler",
    county_weights: {
      31071: 25.16,
      31077: 19.47,
      31183: 55.37,
    },
    county_names_all: "Wheeler|Garfield|Greeley",
    county_fips_all: "31183|31071|31077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68638,
    lat: 41.36848,
    lng: -97.98977,
    city: "Fullerton",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1955,
    density: 5,
    county_fips: 31125,
    county_name: "Nance",
    county_weights: {
      31121: 2.07,
      31125: 97.93,
    },
    county_names_all: "Nance|Merrick",
    county_fips_all: "31125|31121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68640,
    lat: 41.46111,
    lng: -97.77237,
    city: "Genoa",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1198,
    density: 3.6,
    county_fips: 31125,
    county_name: "Nance",
    county_weights: {
      31125: 75.59,
      31141: 24.41,
    },
    county_names_all: "Nance|Platte",
    county_fips_all: "31125|31141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68641,
    lat: 41.73452,
    lng: -97.00829,
    city: "Howells",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1118,
    density: 4.4,
    county_fips: 31037,
    county_name: "Colfax",
    county_weights: {
      31037: 52.15,
      31039: 22.19,
      31167: 25.66,
    },
    county_names_all: "Colfax|Stanton|Cuming",
    county_fips_all: "31037|31167|31039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68642,
    lat: 41.68717,
    lng: -97.51232,
    city: "Humphrey",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2092,
    density: 6.3,
    county_fips: 31141,
    county_name: "Platte",
    county_weights: {
      31119: 16.54,
      31141: 83.46,
    },
    county_names_all: "Platte|Madison",
    county_fips_all: "31141|31119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68643,
    lat: 41.70231,
    lng: -97.25918,
    city: "Leigh",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1054,
    density: 4.1,
    county_fips: 31141,
    county_name: "Platte",
    county_weights: {
      31037: 31.43,
      31141: 34.54,
      31167: 34.03,
    },
    county_names_all: "Platte|Stanton|Colfax",
    county_fips_all: "31141|31167|31037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68644,
    lat: 41.7079,
    lng: -97.67579,
    city: "Lindsay",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 643,
    density: 2.7,
    county_fips: 31141,
    county_name: "Platte",
    county_weights: {
      31119: 28.81,
      31141: 71.19,
    },
    county_names_all: "Platte|Madison",
    county_fips_all: "31141|31119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68647,
    lat: 41.51971,
    lng: -97.62021,
    city: "Monroe",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 711,
    density: 4.4,
    county_fips: 31141,
    county_name: "Platte",
    county_weights: {
      31141: 100,
    },
    county_names_all: "Platte",
    county_fips_all: 31141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68648,
    lat: 41.40482,
    lng: -96.78949,
    city: "Morse Bluff",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 290,
    density: 2.8,
    county_fips: 31155,
    county_name: "Saunders",
    county_weights: {
      31155: 100,
    },
    county_names_all: "Saunders",
    county_fips_all: 31155,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68649,
    lat: 41.50784,
    lng: -96.78896,
    city: "North Bend",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2109,
    density: 8,
    county_fips: 31053,
    county_name: "Dodge",
    county_weights: {
      31053: 100,
    },
    county_names_all: "Dodge",
    county_fips_all: 31053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68651,
    lat: 41.22443,
    lng: -97.57472,
    city: "Osceola",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1273,
    density: 4.1,
    county_fips: 31143,
    county_name: "Polk",
    county_weights: {
      31143: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 31143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68652,
    lat: 41.86174,
    lng: -98.08906,
    city: "Petersburg",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 647,
    density: 1.7,
    county_fips: 31011,
    county_name: "Boone",
    county_weights: {
      31011: 100,
    },
    county_names_all: "Boone",
    county_fips_all: 31011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68653,
    lat: 41.55551,
    lng: -97.4888,
    city: "Platte Center",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 656,
    density: 4.5,
    county_fips: 31141,
    county_name: "Platte",
    county_weights: {
      31141: 100,
    },
    county_names_all: "Platte",
    county_fips_all: 31141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68654,
    lat: 41.06791,
    lng: -97.7772,
    city: "Polk",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 564,
    density: 3.9,
    county_fips: 31143,
    county_name: "Polk",
    county_weights: {
      31081: 8.85,
      31143: 62.88,
      31185: 28.27,
    },
    county_names_all: "Polk|York|Hamilton",
    county_fips_all: "31143|31185|31081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68655,
    lat: 41.64881,
    lng: -98.26222,
    city: "Primrose",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 84,
    density: 0.8,
    county_fips: 31011,
    county_name: "Boone",
    county_weights: {
      31011: 83.08,
      31077: 16.92,
    },
    county_names_all: "Boone|Greeley",
    county_fips_all: "31011|31077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68658,
    lat: 41.19971,
    lng: -97.2937,
    city: "Rising City",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 798,
    density: 4.2,
    county_fips: 31023,
    county_name: "Butler",
    county_weights: {
      31023: 98.63,
      31143: 1.37,
    },
    county_names_all: "Butler|Polk",
    county_fips_all: "31023|31143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68659,
    lat: 41.54388,
    lng: -96.94438,
    city: "Rogers",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 193,
    density: 2.1,
    county_fips: 31037,
    county_name: "Colfax",
    county_weights: {
      31037: 100,
    },
    county_names_all: "Colfax",
    county_fips_all: 31037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68660,
    lat: 41.57398,
    lng: -97.86792,
    city: "Saint Edward",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1126,
    density: 3.3,
    county_fips: 31011,
    county_name: "Boone",
    county_weights: {
      31011: 56.16,
      31125: 15.69,
      31141: 28.15,
    },
    county_names_all: "Boone|Platte|Nance",
    county_fips_all: "31011|31141|31125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68661,
    lat: 41.49559,
    lng: -97.08347,
    city: "Schuyler",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7480,
    density: 19.9,
    county_fips: 31037,
    county_name: "Colfax",
    county_weights: {
      31037: 100,
    },
    county_names_all: "Colfax",
    county_fips_all: 31037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68662,
    lat: 41.20698,
    lng: -97.41535,
    city: "Shelby",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1275,
    density: 5.3,
    county_fips: 31143,
    county_name: "Polk",
    county_weights: {
      31023: 6.2,
      31143: 93.8,
    },
    county_names_all: "Polk|Butler",
    county_fips_all: "31143|31023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68663,
    lat: 41.31193,
    lng: -97.69927,
    city: "Silver Creek",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 830,
    density: 3.2,
    county_fips: 31121,
    county_name: "Merrick",
    county_weights: {
      31121: 45.78,
      31125: 24.15,
      31143: 30.07,
    },
    county_names_all: "Merrick|Polk|Nance",
    county_fips_all: "31121|31143|31125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68664,
    lat: 41.70453,
    lng: -96.78694,
    city: "Snyder",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 386,
    density: 307.1,
    county_fips: 31053,
    county_name: "Dodge",
    county_weights: {
      31053: 100,
    },
    county_names_all: "Dodge",
    county_fips_all: 31053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68665,
    lat: 41.70543,
    lng: -98.41445,
    city: "Spalding",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 762,
    density: 1.7,
    county_fips: 31077,
    county_name: "Greeley",
    county_weights: {
      31077: 67.01,
      31183: 32.99,
    },
    county_names_all: "Greeley|Wheeler",
    county_fips_all: "31077|31183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68666,
    lat: 41.10775,
    lng: -97.61369,
    city: "Stromsburg",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1635,
    density: 7.4,
    county_fips: 31143,
    county_name: "Polk",
    county_weights: {
      31143: 97.53,
      31185: 2.47,
    },
    county_names_all: "Polk|York",
    county_fips_all: "31143|31185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68667,
    lat: 41.11231,
    lng: -97.30278,
    city: "Surprise",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64,
    density: 1.6,
    county_fips: 31023,
    county_name: "Butler",
    county_weights: {
      31023: 100,
    },
    county_names_all: "Butler",
    county_fips_all: 31023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68669,
    lat: 41.07789,
    lng: -97.23612,
    city: "Ulysses",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 499,
    density: 3.1,
    county_fips: 31023,
    county_name: "Butler",
    county_weights: {
      31023: 90.02,
      31159: 9.98,
    },
    county_names_all: "Butler|Seward",
    county_fips_all: "31023|31159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68701,
    lat: 42.02024,
    lng: -97.44099,
    city: "Norfolk",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30415,
    density: 62.3,
    county_fips: 31119,
    county_name: "Madison",
    county_weights: {
      31119: 68.93,
      31139: 12.22,
      31167: 18.85,
    },
    county_names_all: "Madison|Stanton|Pierce",
    county_fips_all: "31119|31167|31139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68710,
    lat: 42.439,
    lng: -96.84784,
    city: "Allen",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 760,
    density: 3.6,
    county_fips: 31051,
    county_name: "Dixon",
    county_weights: {
      31051: 100,
    },
    county_names_all: "Dixon",
    county_fips_all: 31051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68711,
    lat: 42.2034,
    lng: -99.02407,
    city: "Amelia",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 126,
    density: 0.2,
    county_fips: 31089,
    county_name: "Holt",
    county_weights: {
      31089: 100,
    },
    county_names_all: "Holt",
    county_fips_all: 31089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68713,
    lat: 42.54061,
    lng: -98.9718,
    city: "Atkinson",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2265,
    density: 1.5,
    county_fips: 31089,
    county_name: "Holt",
    county_weights: {
      31089: 100,
    },
    county_names_all: "Holt",
    county_fips_all: 31089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68714,
    lat: 42.36957,
    lng: -99.50258,
    city: "Bassett",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1276,
    density: 0.6,
    county_fips: 31149,
    county_name: "Rock",
    county_weights: {
      31017: 2.1,
      31115: 11.65,
      31149: 86.25,
    },
    county_names_all: "Rock|Loup|Brown",
    county_fips_all: "31149|31115|31017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68715,
    lat: 41.97003,
    lng: -97.60883,
    city: "Battle Creek",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1571,
    density: 11.8,
    county_fips: 31119,
    county_name: "Madison",
    county_weights: {
      31119: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 31119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68716,
    lat: 41.9314,
    lng: -96.82337,
    city: "Beemer",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 952,
    density: 6.5,
    county_fips: 31039,
    county_name: "Cuming",
    county_weights: {
      31039: 100,
    },
    county_names_all: "Cuming",
    county_fips_all: 31039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68717,
    lat: 42.38962,
    lng: -97.2192,
    city: "Belden",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 299,
    density: 6.4,
    county_fips: 31027,
    county_name: "Cedar",
    county_weights: {
      31027: 100,
    },
    county_names_all: "Cedar",
    county_fips_all: 31027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68718,
    lat: 42.6619,
    lng: -97.69844,
    city: "Bloomfield",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1662,
    density: 2.9,
    county_fips: 31107,
    county_name: "Knox",
    county_weights: {
      31107: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 31107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68719,
    lat: 42.96446,
    lng: -98.57426,
    city: "Bristow",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 197,
    density: 1.5,
    county_fips: 31015,
    county_name: "Boyd",
    county_weights: {
      31015: 60.08,
      46053: 39.92,
    },
    county_names_all: "Boyd|Gregory",
    county_fips_all: "31015|46053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68720,
    lat: 42.34659,
    lng: -98.01418,
    city: "Brunswick",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 260,
    density: 1.5,
    county_fips: 31003,
    county_name: "Antelope",
    county_weights: {
      31003: 100,
    },
    county_names_all: "Antelope",
    county_fips_all: 31003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68722,
    lat: 42.92074,
    lng: -98.87123,
    city: "Butte",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 496,
    density: 2,
    county_fips: 31015,
    county_name: "Boyd",
    county_weights: {
      31015: 100,
    },
    county_names_all: "Boyd",
    county_fips_all: 31015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68723,
    lat: 42.28759,
    lng: -97.21456,
    city: "Carroll",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 666,
    density: 3.9,
    county_fips: 31179,
    county_name: "Wayne",
    county_weights: {
      31179: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 31179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68724,
    lat: 42.6276,
    lng: -97.88496,
    city: "Center",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 196,
    density: 1.8,
    county_fips: 31107,
    county_name: "Knox",
    county_weights: {
      31107: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 31107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68725,
    lat: 42.20118,
    lng: -98.77703,
    city: "Chambers",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 582,
    density: 1.3,
    county_fips: 31089,
    county_name: "Holt",
    county_weights: {
      31089: 97.4,
      31183: 2.6,
    },
    county_names_all: "Holt|Wheeler",
    county_fips_all: "31089|31183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68726,
    lat: 42.17877,
    lng: -98.19954,
    city: "Clearwater",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 600,
    density: 1.8,
    county_fips: 31003,
    county_name: "Antelope",
    county_weights: {
      31003: 92.97,
      31089: 7.03,
    },
    county_names_all: "Antelope|Holt",
    county_fips_all: "31003|31089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68727,
    lat: 42.5116,
    lng: -97.20596,
    city: "Coleridge",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 627,
    density: 3.6,
    county_fips: 31027,
    county_name: "Cedar",
    county_weights: {
      31027: 100,
    },
    county_names_all: "Cedar",
    county_fips_all: 31027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68728,
    lat: 42.38085,
    lng: -96.93641,
    city: "Concord",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 262,
    density: 4.2,
    county_fips: 31051,
    county_name: "Dixon",
    county_weights: {
      31051: 100,
    },
    county_names_all: "Dixon",
    county_fips_all: 31051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68729,
    lat: 42.47479,
    lng: -97.90784,
    city: "Creighton",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1796,
    density: 4.1,
    county_fips: 31107,
    county_name: "Knox",
    county_weights: {
      31003: 17.99,
      31107: 82.01,
    },
    county_names_all: "Knox|Antelope",
    county_fips_all: "31107|31003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68730,
    lat: 42.76688,
    lng: -97.53488,
    city: "Crofton",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1937,
    density: 5,
    county_fips: 31107,
    county_name: "Knox",
    county_weights: {
      31027: 30.16,
      31107: 69.84,
    },
    county_names_all: "Knox|Cedar",
    county_fips_all: "31107|31027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68731,
    lat: 42.40993,
    lng: -96.48341,
    city: "Dakota City",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3166,
    density: 33.6,
    county_fips: 31043,
    county_name: "Dakota",
    county_weights: {
      31043: 100,
    },
    county_names_all: "Dakota",
    county_fips_all: 31043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68732,
    lat: 42.48176,
    lng: -96.97387,
    city: "Dixon",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 187,
    density: 1.8,
    county_fips: 31051,
    county_name: "Dixon",
    county_weights: {
      31051: 100,
    },
    county_names_all: "Dixon",
    county_fips_all: 31051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68733,
    lat: 42.28278,
    lng: -96.72245,
    city: "Emerson",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1207,
    density: 5,
    county_fips: 31173,
    county_name: "Thurston",
    county_weights: {
      31043: 26.84,
      31051: 31,
      31173: 42.16,
    },
    county_names_all: "Thurston|Dixon|Dakota",
    county_fips_all: "31173|31051|31043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68734,
    lat: 42.42528,
    lng: -98.8044,
    city: "Emmet",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65,
    density: 0.4,
    county_fips: 31089,
    county_name: "Holt",
    county_weights: {
      31089: 100,
    },
    county_names_all: "Holt",
    county_fips_all: 31089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68735,
    lat: 42.14911,
    lng: -98.45402,
    city: "Ewing",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 819,
    density: 0.9,
    county_fips: 31089,
    county_name: "Holt",
    county_weights: {
      31003: 4.83,
      31089: 64.83,
      31183: 30.34,
    },
    county_names_all: "Holt|Wheeler|Antelope",
    county_fips_all: "31089|31183|31003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68736,
    lat: 42.74481,
    lng: -97.37136,
    city: "Fordyce",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 775,
    density: 5.2,
    county_fips: 31027,
    county_name: "Cedar",
    county_weights: {
      31027: 100,
    },
    county_names_all: "Cedar",
    county_fips_all: 31027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68739,
    lat: 42.6284,
    lng: -97.26265,
    city: "Hartington",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2776,
    density: 4.6,
    county_fips: 31027,
    county_name: "Cedar",
    county_weights: {
      31027: 98.74,
      31051: 1.26,
    },
    county_names_all: "Cedar|Dixon",
    county_fips_all: "31027|31051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68740,
    lat: 42.14561,
    lng: -97.29245,
    city: "Hoskins",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 872,
    density: 5,
    county_fips: 31179,
    county_name: "Wayne",
    county_weights: {
      31167: 6.54,
      31179: 93.46,
    },
    county_names_all: "Wayne|Stanton",
    county_fips_all: "31179|31167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68741,
    lat: 42.35711,
    lng: -96.59375,
    city: "Hubbard",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 699,
    density: 3.9,
    county_fips: 31043,
    county_name: "Dakota",
    county_weights: {
      31043: 100,
    },
    county_names_all: "Dakota",
    county_fips_all: 31043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68742,
    lat: 42.3572,
    lng: -98.51459,
    city: "Inman",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 214,
    density: 2.1,
    county_fips: 31089,
    county_name: "Holt",
    county_weights: {
      31089: 100,
    },
    county_names_all: "Holt",
    county_fips_all: 31089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68743,
    lat: 42.47271,
    lng: -96.62586,
    city: "Jackson",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 567,
    density: 4.2,
    county_fips: 31043,
    county_name: "Dakota",
    county_weights: {
      31043: 100,
    },
    county_names_all: "Dakota",
    county_fips_all: 31043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68745,
    lat: 42.44662,
    lng: -97.08781,
    city: "Laurel",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1582,
    density: 4.7,
    county_fips: 31027,
    county_name: "Cedar",
    county_weights: {
      31027: 88.19,
      31051: 5.73,
      31179: 6.08,
    },
    county_names_all: "Cedar|Wayne|Dixon",
    county_fips_all: "31027|31179|31051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68746,
    lat: 42.80726,
    lng: -98.4354,
    city: "Lynch",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 353,
    density: 0.6,
    county_fips: 31015,
    county_name: "Boyd",
    county_weights: {
      31015: 62.22,
      31089: 37.78,
    },
    county_names_all: "Boyd|Holt",
    county_fips_all: "31015|31089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68747,
    lat: 42.39398,
    lng: -97.48873,
    city: "Mclean",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 154,
    density: 2.3,
    county_fips: 31139,
    county_name: "Pierce",
    county_weights: {
      31027: 3.89,
      31139: 96.11,
    },
    county_names_all: "Pierce|Cedar",
    county_fips_all: "31139|31027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68748,
    lat: 41.83883,
    lng: -97.47638,
    city: "Madison",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2731,
    density: 6.1,
    county_fips: 31119,
    county_name: "Madison",
    county_weights: {
      31119: 82.71,
      31167: 17.29,
    },
    county_names_all: "Madison|Stanton",
    county_fips_all: "31119|31167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68749,
    lat: 42.46032,
    lng: -97.47531,
    city: "Magnet",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53,
    density: 20.3,
    county_fips: 31027,
    county_name: "Cedar",
    county_weights: {
      31027: 100,
    },
    county_names_all: "Cedar",
    county_fips_all: 31027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68751,
    lat: 42.69035,
    lng: -96.98138,
    city: "Maskell",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51,
    density: 142.1,
    county_fips: 31051,
    county_name: "Dixon",
    county_weights: {
      31051: 100,
    },
    county_names_all: "Dixon",
    county_fips_all: 31051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68752,
    lat: 42.02269,
    lng: -97.7154,
    city: "Meadow Grove",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 674,
    density: 1.9,
    county_fips: 31119,
    county_name: "Madison",
    county_weights: {
      31119: 75.87,
      31139: 24.13,
    },
    county_names_all: "Madison|Pierce",
    county_fips_all: "31119|31139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68753,
    lat: 42.84464,
    lng: -99.45588,
    city: "Mills",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 175,
    density: 0.8,
    county_fips: 31103,
    county_name: "Keya Paha",
    county_weights: {
      31103: 100,
    },
    county_names_all: "Keya Paha",
    county_fips_all: 31103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68755,
    lat: 42.92329,
    lng: -99.12963,
    city: "Naper",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 326,
    density: 0.9,
    county_fips: 31015,
    county_name: "Boyd",
    county_weights: {
      31015: 99.57,
      46053: 0.43,
    },
    county_names_all: "Boyd|Gregory",
    county_fips_all: "31015|46053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68756,
    lat: 42.18544,
    lng: -97.97985,
    city: "Neligh",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1893,
    density: 6,
    county_fips: 31003,
    county_name: "Antelope",
    county_weights: {
      31003: 100,
    },
    county_names_all: "Antelope",
    county_fips_all: 31003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68757,
    lat: 42.65247,
    lng: -96.92554,
    city: "Newcastle",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 843,
    density: 2.6,
    county_fips: 31051,
    county_name: "Dixon",
    county_weights: {
      31027: 8.09,
      31051: 91.91,
    },
    county_names_all: "Dixon|Cedar",
    county_fips_all: "31051|31027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68758,
    lat: 41.7829,
    lng: -97.78863,
    city: "Newman Grove",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1433,
    density: 4.9,
    county_fips: 31119,
    county_name: "Madison",
    county_weights: {
      31011: 19.06,
      31119: 56.41,
      31141: 24.53,
    },
    county_names_all: "Madison|Platte|Boone",
    county_fips_all: "31119|31141|31011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68759,
    lat: 42.75096,
    lng: -99.33762,
    city: "Newport",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 202,
    density: 0.3,
    county_fips: 31149,
    county_name: "Rock",
    county_weights: {
      31103: 43.95,
      31149: 56.05,
    },
    county_names_all: "Rock|Keya Paha",
    county_fips_all: "31149|31103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68760,
    lat: 42.76616,
    lng: -98.03831,
    city: "Niobrara",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1335,
    density: 2.6,
    county_fips: 31107,
    county_name: "Knox",
    county_weights: {
      31107: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 31107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68761,
    lat: 42.02287,
    lng: -97.9601,
    city: "Oakdale",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 372,
    density: 2.5,
    county_fips: 31003,
    county_name: "Antelope",
    county_weights: {
      31003: 100,
    },
    county_names_all: "Antelope",
    county_fips_all: 31003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68763,
    lat: 42.51809,
    lng: -98.58254,
    city: "Oneill",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4737,
    density: 3.4,
    county_fips: 31089,
    county_name: "Holt",
    county_weights: {
      31089: 98.58,
      31107: 1.42,
    },
    county_names_all: "Holt|Knox",
    county_fips_all: "31089|31107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68764,
    lat: 42.39881,
    lng: -98.23177,
    city: "Orchard",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 944,
    density: 2.8,
    county_fips: 31003,
    county_name: "Antelope",
    county_weights: {
      31003: 55.32,
      31089: 8.72,
      31107: 35.96,
    },
    county_names_all: "Antelope|Knox|Holt",
    county_fips_all: "31003|31107|31089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68765,
    lat: 42.33397,
    lng: -97.6232,
    city: "Osmond",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1231,
    density: 3.6,
    county_fips: 31139,
    county_name: "Pierce",
    county_weights: {
      31139: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 31139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68766,
    lat: 42.42375,
    lng: -98.40321,
    city: "Page",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 497,
    density: 1.8,
    county_fips: 31089,
    county_name: "Holt",
    county_weights: {
      31089: 100,
    },
    county_names_all: "Holt",
    county_fips_all: 31089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68767,
    lat: 42.1969,
    lng: -97.53622,
    city: "Pierce",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3436,
    density: 6.9,
    county_fips: 31139,
    county_name: "Pierce",
    county_weights: {
      31139: 98.85,
      31179: 1.15,
    },
    county_names_all: "Pierce|Wayne",
    county_fips_all: "31139|31179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68768,
    lat: 41.99871,
    lng: -97.06871,
    city: "Pilger",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 596,
    density: 3.1,
    county_fips: 31167,
    county_name: "Stanton",
    county_weights: {
      31039: 2.35,
      31167: 92.46,
      31179: 5.19,
    },
    county_names_all: "Stanton|Wayne|Cuming",
    county_fips_all: "31167|31179|31039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68769,
    lat: 42.3158,
    lng: -97.81636,
    city: "Plainview",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1728,
    density: 4.2,
    county_fips: 31139,
    county_name: "Pierce",
    county_weights: {
      31003: 35.48,
      31107: 0.48,
      31139: 64.04,
    },
    county_names_all: "Pierce|Antelope|Knox",
    county_fips_all: "31139|31003|31107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68770,
    lat: 42.56287,
    lng: -96.76898,
    city: "Ponca",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1388,
    density: 5.3,
    county_fips: 31051,
    county_name: "Dixon",
    county_weights: {
      31043: 5.49,
      31051: 94.51,
    },
    county_names_all: "Dixon|Dakota",
    county_fips_all: "31051|31043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68771,
    lat: 42.38419,
    lng: -97.35706,
    city: "Randolph",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1502,
    density: 3.8,
    county_fips: 31027,
    county_name: "Cedar",
    county_weights: {
      31027: 49.36,
      31139: 30.95,
      31179: 19.69,
    },
    county_names_all: "Cedar|Pierce|Wayne",
    county_fips_all: "31027|31139|31179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68773,
    lat: 42.36245,
    lng: -98.1199,
    city: "Royal",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 164,
    density: 1.2,
    county_fips: 31003,
    county_name: "Antelope",
    county_weights: {
      31003: 100,
    },
    county_names_all: "Antelope",
    county_fips_all: 31003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68774,
    lat: 42.81403,
    lng: -97.27747,
    city: "Saint Helena",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 200,
    density: 1.9,
    county_fips: 31027,
    county_name: "Cedar",
    county_weights: {
      31027: 100,
    },
    county_names_all: "Cedar",
    county_fips_all: 31027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68776,
    lat: 42.4601,
    lng: -96.44424,
    city: "South Sioux City",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14579,
    density: 253.7,
    county_fips: 31043,
    county_name: "Dakota",
    county_weights: {
      31043: 100,
    },
    county_names_all: "Dakota",
    county_fips_all: 31043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68777,
    lat: 42.86088,
    lng: -98.68504,
    city: "Spencer",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 571,
    density: 1.2,
    county_fips: 31015,
    county_name: "Boyd",
    county_weights: {
      31015: 71.99,
      31089: 28.01,
    },
    county_names_all: "Boyd|Holt",
    county_fips_all: "31015|31089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68778,
    lat: 42.86963,
    lng: -99.79483,
    city: "Springview",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 608,
    density: 0.5,
    county_fips: 31103,
    county_name: "Keya Paha",
    county_weights: {
      31103: 100,
    },
    county_names_all: "Keya Paha",
    county_fips_all: 31103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68779,
    lat: 41.9516,
    lng: -97.21175,
    city: "Stanton",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2759,
    density: 6.2,
    county_fips: 31167,
    county_name: "Stanton",
    county_weights: {
      31167: 100,
    },
    county_names_all: "Stanton",
    county_fips_all: 31167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68780,
    lat: 42.64621,
    lng: -99.14062,
    city: "Stuart",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 910,
    density: 1.2,
    county_fips: 31089,
    county_name: "Holt",
    county_weights: {
      31089: 100,
    },
    county_names_all: "Holt",
    county_fips_all: 31089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68781,
    lat: 42.02743,
    lng: -97.84561,
    city: "Tilden",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1480,
    density: 4.5,
    county_fips: 31003,
    county_name: "Antelope",
    county_weights: {
      31003: 54.51,
      31011: 5.82,
      31119: 27.25,
      31139: 12.42,
    },
    county_names_all: "Antelope|Madison|Pierce|Boone",
    county_fips_all: "31003|31119|31139|31011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68783,
    lat: 42.62523,
    lng: -98.14612,
    city: "Verdigre",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 852,
    density: 1.5,
    county_fips: 31107,
    county_name: "Knox",
    county_weights: {
      31107: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 31107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68784,
    lat: 42.25763,
    lng: -96.88657,
    city: "Wakefield",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1738,
    density: 5.9,
    county_fips: 31051,
    county_name: "Dixon",
    county_weights: {
      31051: 52.49,
      31173: 2.77,
      31179: 44.74,
    },
    county_names_all: "Dixon|Wayne|Thurston",
    county_fips_all: "31051|31179|31173",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68785,
    lat: 42.42796,
    lng: -96.7224,
    city: "Waterbury",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 208,
    density: 2.7,
    county_fips: 31051,
    county_name: "Dixon",
    county_weights: {
      31043: 48.57,
      31051: 51.43,
    },
    county_names_all: "Dixon|Dakota",
    county_fips_all: "31051|31043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68786,
    lat: 42.50351,
    lng: -97.55855,
    city: "Wausa",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 985,
    density: 3,
    county_fips: 31107,
    county_name: "Knox",
    county_weights: {
      31027: 17.24,
      31107: 78.67,
      31139: 4.09,
    },
    county_names_all: "Knox|Cedar|Pierce",
    county_fips_all: "31107|31027|31139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68787,
    lat: 42.21372,
    lng: -97.03351,
    city: "Wayne",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6464,
    density: 17.4,
    county_fips: 31179,
    county_name: "Wayne",
    county_weights: {
      31051: 6.3,
      31179: 93.7,
    },
    county_names_all: "Wayne|Dixon",
    county_fips_all: "31179|31051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68788,
    lat: 41.8387,
    lng: -96.72571,
    city: "West Point",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4469,
    density: 9.2,
    county_fips: 31039,
    county_name: "Cuming",
    county_weights: {
      31039: 99.88,
      31053: 0.12,
    },
    county_names_all: "Cuming|Dodge",
    county_fips_all: "31039|31053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68789,
    lat: 42.53642,
    lng: -97.99182,
    city: "Winnetoon",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 104,
    density: 1.1,
    county_fips: 31107,
    county_name: "Knox",
    county_weights: {
      31107: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 31107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68790,
    lat: 42.17384,
    lng: -97.18616,
    city: "Winside",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1021,
    density: 6.1,
    county_fips: 31179,
    county_name: "Wayne",
    county_weights: {
      31179: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 31179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68791,
    lat: 41.99103,
    lng: -96.93245,
    city: "Wisner",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1883,
    density: 5.2,
    county_fips: 31039,
    county_name: "Cuming",
    county_weights: {
      31039: 94.26,
      31167: 1.4,
      31179: 4.34,
    },
    county_names_all: "Cuming|Wayne|Stanton",
    county_fips_all: "31039|31179|31167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68792,
    lat: 42.73323,
    lng: -97.11427,
    city: "Wynot",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 398,
    density: 2.9,
    county_fips: 31027,
    county_name: "Cedar",
    county_weights: {
      31027: 100,
    },
    county_names_all: "Cedar",
    county_fips_all: 31027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68801,
    lat: 40.94949,
    lng: -98.29295,
    city: "Grand Island",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29619,
    density: 127.1,
    county_fips: 31079,
    county_name: "Hall",
    county_weights: {
      31079: 59.7,
      31121: 40.3,
    },
    county_names_all: "Hall|Merrick",
    county_fips_all: "31079|31121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68803,
    lat: 40.95357,
    lng: -98.41593,
    city: "Grand Island",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25163,
    density: 111.8,
    county_fips: 31079,
    county_name: "Hall",
    county_weights: {
      31079: 100,
    },
    county_names_all: "Hall",
    county_fips_all: 31079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68810,
    lat: 40.86238,
    lng: -98.4675,
    city: "Alda",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 955,
    density: 17.4,
    county_fips: 31079,
    county_name: "Hall",
    county_weights: {
      31079: 100,
    },
    county_names_all: "Hall",
    county_fips_all: 31079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68812,
    lat: 40.9051,
    lng: -99.279,
    city: "Amherst",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 522,
    density: 1.6,
    county_fips: 31019,
    county_name: "Buffalo",
    county_weights: {
      31019: 100,
    },
    county_names_all: "Buffalo",
    county_fips_all: 31019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68813,
    lat: 41.70477,
    lng: -99.8355,
    city: "Anselmo",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 449,
    density: 0.3,
    county_fips: 31041,
    county_name: "Custer",
    county_weights: {
      31009: 25.34,
      31041: 63.84,
      31115: 10.82,
    },
    county_names_all: "Custer|Blaine|Loup",
    county_fips_all: "31041|31009|31115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68814,
    lat: 41.3086,
    lng: -99.4102,
    city: "Ansley",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 912,
    density: 1.7,
    county_fips: 31041,
    county_name: "Custer",
    county_weights: {
      31041: 100,
    },
    county_names_all: "Custer",
    county_fips_all: 31041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68815,
    lat: 41.42941,
    lng: -99.16045,
    city: "Arcadia",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 649,
    density: 1.5,
    county_fips: 31175,
    county_name: "Valley",
    county_weights: {
      31041: 25.97,
      31163: 18.48,
      31175: 55.55,
    },
    county_names_all: "Valley|Custer|Sherman",
    county_fips_all: "31175|31041|31163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68816,
    lat: 41.17484,
    lng: -98.13373,
    city: "Archer",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 199,
    density: 2.3,
    county_fips: 31121,
    county_name: "Merrick",
    county_weights: {
      31121: 100,
    },
    county_names_all: "Merrick",
    county_fips_all: 31121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68817,
    lat: 41.26125,
    lng: -98.7937,
    city: "Ashton",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 341,
    density: 1.6,
    county_fips: 31163,
    county_name: "Sherman",
    county_weights: {
      31093: 14.23,
      31163: 85.77,
    },
    county_names_all: "Sherman|Howard",
    county_fips_all: "31163|31093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68818,
    lat: 40.82211,
    lng: -98.01036,
    city: "Aurora",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5531,
    density: 11.7,
    county_fips: 31081,
    county_name: "Hamilton",
    county_weights: {
      31035: 5.99,
      31081: 94.01,
    },
    county_names_all: "Hamilton|Clay",
    county_fips_all: "31081|31035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68820,
    lat: 41.1066,
    lng: -98.70056,
    city: "Boelus",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 332,
    density: 3.2,
    county_fips: 31093,
    county_name: "Howard",
    county_weights: {
      31093: 100,
    },
    county_names_all: "Howard",
    county_fips_all: 31093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68821,
    lat: 42.00177,
    lng: -99.81628,
    city: "Brewster",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 126,
    density: 0.3,
    county_fips: 31009,
    county_name: "Blaine",
    county_weights: {
      31009: 100,
    },
    county_names_all: "Blaine",
    county_fips_all: 31009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68822,
    lat: 41.38899,
    lng: -99.62766,
    city: "Broken Bow",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4883,
    density: 4.9,
    county_fips: 31041,
    county_name: "Custer",
    county_weights: {
      31041: 100,
    },
    county_names_all: "Custer",
    county_fips_all: 31041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68823,
    lat: 41.93653,
    lng: -99.13255,
    city: "Burwell",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2342,
    density: 1,
    county_fips: 31071,
    county_name: "Garfield",
    county_weights: {
      31041: 2.2,
      31071: 54.92,
      31089: 2.93,
      31115: 23.82,
      31149: 10.17,
      31175: 5.96,
    },
    county_names_all: "Garfield|Loup|Rock|Valley|Holt|Custer",
    county_fips_all: "31071|31115|31149|31175|31089|31041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68824,
    lat: 41.00535,
    lng: -98.61402,
    city: "Cairo",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1611,
    density: 6.9,
    county_fips: 31079,
    county_name: "Hall",
    county_weights: {
      31079: 85.72,
      31093: 14.28,
    },
    county_names_all: "Hall|Howard",
    county_fips_all: "31079|31093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68825,
    lat: 41.27347,
    lng: -99.95758,
    city: "Callaway",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 919,
    density: 1.2,
    county_fips: 31041,
    county_name: "Custer",
    county_weights: {
      31041: 100,
    },
    county_names_all: "Custer",
    county_fips_all: 31041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68826,
    lat: 41.16341,
    lng: -98.0191,
    city: "Central City",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3878,
    density: 10.4,
    county_fips: 31121,
    county_name: "Merrick",
    county_weights: {
      31121: 100,
    },
    county_names_all: "Merrick",
    county_fips_all: 31121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68827,
    lat: 41.04247,
    lng: -98.1811,
    city: "Chapman",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 670,
    density: 4.3,
    county_fips: 31121,
    county_name: "Merrick",
    county_weights: {
      31121: 100,
    },
    county_names_all: "Merrick",
    county_fips_all: 31121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68828,
    lat: 41.55626,
    lng: -99.24776,
    city: "Comstock",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 222,
    density: 1.1,
    county_fips: 31041,
    county_name: "Custer",
    county_weights: {
      31041: 72.84,
      31175: 27.16,
    },
    county_names_all: "Custer|Valley",
    county_fips_all: "31041|31175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68831,
    lat: 41.10937,
    lng: -98.54661,
    city: "Dannebrog",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 591,
    density: 3.2,
    county_fips: 31093,
    county_name: "Howard",
    county_weights: {
      31079: 4,
      31093: 96,
    },
    county_names_all: "Howard|Hall",
    county_fips_all: "31093|31079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68832,
    lat: 40.76963,
    lng: -98.36608,
    city: "Doniphan",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2118,
    density: 8.2,
    county_fips: 31079,
    county_name: "Hall",
    county_weights: {
      31079: 88.36,
      31081: 11.64,
    },
    county_names_all: "Hall|Hamilton",
    county_fips_all: "31079|31081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68833,
    lat: 41.80281,
    lng: -100.09433,
    city: "Dunning",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 265,
    density: 0.2,
    county_fips: 31009,
    county_name: "Blaine",
    county_weights: {
      31009: 69.67,
      31041: 23.74,
      31113: 6.59,
    },
    county_names_all: "Blaine|Custer|Logan",
    county_fips_all: "31009|31041|31113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68834,
    lat: 41.01834,
    lng: -99.65049,
    city: "Eddyville",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 172,
    density: 0.6,
    county_fips: 31047,
    county_name: "Dawson",
    county_weights: {
      31041: 31.07,
      31047: 68.93,
    },
    county_names_all: "Dawson|Custer",
    county_fips_all: "31047|31041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68835,
    lat: 41.33326,
    lng: -98.61769,
    city: "Elba",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 548,
    density: 2.2,
    county_fips: 31093,
    county_name: "Howard",
    county_weights: {
      31077: 9.12,
      31093: 90.88,
    },
    county_names_all: "Howard|Greeley",
    county_fips_all: "31093|31077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68836,
    lat: 40.70709,
    lng: -99.37865,
    city: "Elm Creek",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1740,
    density: 4.6,
    county_fips: 31019,
    county_name: "Buffalo",
    county_weights: {
      31019: 52.82,
      31047: 15.25,
      31137: 31.93,
    },
    county_names_all: "Buffalo|Phelps|Dawson",
    county_fips_all: "31019|31137|31047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68837,
    lat: 41.66139,
    lng: -99.06063,
    city: "Elyria",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 82,
    density: 1.2,
    county_fips: 31175,
    county_name: "Valley",
    county_weights: {
      31175: 100,
    },
    county_names_all: "Valley",
    county_fips_all: 31175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68838,
    lat: 41.2156,
    lng: -98.66755,
    city: "Farwell",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 232,
    density: 1.8,
    county_fips: 31093,
    county_name: "Howard",
    county_weights: {
      31093: 100,
    },
    county_names_all: "Howard",
    county_fips_all: 31093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68840,
    lat: 40.75728,
    lng: -98.88027,
    city: "Gibbon",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3181,
    density: 8.1,
    county_fips: 31019,
    county_name: "Buffalo",
    county_weights: {
      31019: 88.56,
      31099: 11.44,
    },
    county_names_all: "Buffalo|Kearney",
    county_fips_all: "31019|31099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68841,
    lat: 40.76316,
    lng: -98.16677,
    city: "Giltner",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 636,
    density: 3.6,
    county_fips: 31081,
    county_name: "Hamilton",
    county_weights: {
      31081: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 31081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68842,
    lat: 41.58068,
    lng: -98.53462,
    city: "Greeley",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 642,
    density: 1.4,
    county_fips: 31077,
    county_name: "Greeley",
    county_weights: {
      31077: 100,
    },
    county_names_all: "Greeley",
    county_fips_all: 31077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68843,
    lat: 40.90334,
    lng: -97.88018,
    city: "Hampton",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 751,
    density: 3.6,
    county_fips: 31081,
    county_name: "Hamilton",
    county_weights: {
      31081: 96.33,
      31185: 3.67,
    },
    county_names_all: "Hamilton|York",
    county_fips_all: "31081|31185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68844,
    lat: 41.05659,
    lng: -99.05938,
    city: "Hazard",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 220,
    density: 1.8,
    county_fips: 31163,
    county_name: "Sherman",
    county_weights: {
      31019: 35.87,
      31163: 64.13,
    },
    county_names_all: "Sherman|Buffalo",
    county_fips_all: "31163|31019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68845,
    lat: 40.71583,
    lng: -99.17059,
    city: "Kearney",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22340,
    density: 69.7,
    county_fips: 31019,
    county_name: "Buffalo",
    county_weights: {
      31019: 78.83,
      31099: 12.29,
      31137: 8.88,
    },
    county_names_all: "Buffalo|Kearney|Phelps",
    county_fips_all: "31019|31099|31137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68846,
    lat: 41.06499,
    lng: -97.88533,
    city: "Hordville",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 282,
    density: 3.6,
    county_fips: 31081,
    county_name: "Hamilton",
    county_weights: {
      31081: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 31081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68847,
    lat: 40.73465,
    lng: -99.02272,
    city: "Kearney",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15766,
    density: 55.5,
    county_fips: 31019,
    county_name: "Buffalo",
    county_weights: {
      31019: 80.35,
      31099: 19.65,
    },
    county_names_all: "Buffalo|Kearney",
    county_fips_all: "31019|31099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68849,
    lat: 40.70148,
    lng: -99.10082,
    city: "Kearney",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1187,
    density: 2084.5,
    county_fips: 31019,
    county_name: "Buffalo",
    county_weights: {
      31019: 100,
    },
    county_names_all: "Buffalo",
    county_fips_all: 31019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68850,
    lat: 40.82548,
    lng: -99.73574,
    city: "Lexington",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12148,
    density: 17.6,
    county_fips: 31047,
    county_name: "Dawson",
    county_weights: {
      31047: 93.2,
      31073: 6.8,
    },
    county_names_all: "Dawson|Gosper",
    county_fips_all: "31047|31073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68852,
    lat: 41.1672,
    lng: -99.14628,
    city: "Litchfield",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 557,
    density: 1.8,
    county_fips: 31163,
    county_name: "Sherman",
    county_weights: {
      31041: 13.45,
      31163: 86.55,
    },
    county_names_all: "Sherman|Custer",
    county_fips_all: "31163|31041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68853,
    lat: 41.28975,
    lng: -98.98616,
    city: "Loup City",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1448,
    density: 2.8,
    county_fips: 31163,
    county_name: "Sherman",
    county_weights: {
      31163: 100,
    },
    county_names_all: "Sherman",
    county_fips_all: 31163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68854,
    lat: 41.00798,
    lng: -98.00239,
    city: "Marquette",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 737,
    density: 4.1,
    county_fips: 31081,
    county_name: "Hamilton",
    county_weights: {
      31081: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 31081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68855,
    lat: 41.16248,
    lng: -99.32635,
    city: "Mason City",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 396,
    density: 0.9,
    county_fips: 31041,
    county_name: "Custer",
    county_weights: {
      31041: 100,
    },
    county_names_all: "Custer",
    county_fips_all: 31041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68856,
    lat: 41.50167,
    lng: -99.8168,
    city: "Merna",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 698,
    density: 2.2,
    county_fips: 31041,
    county_name: "Custer",
    county_weights: {
      31041: 100,
    },
    county_names_all: "Custer",
    county_fips_all: 31041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68858,
    lat: 40.96171,
    lng: -99.37797,
    city: "Miller",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 334,
    density: 2,
    county_fips: 31019,
    county_name: "Buffalo",
    county_weights: {
      31019: 95.68,
      31041: 4.32,
    },
    county_names_all: "Buffalo|Custer",
    county_fips_all: "31019|31041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68859,
    lat: 41.46103,
    lng: -98.81931,
    city: "North Loup",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 541,
    density: 2.1,
    county_fips: 31175,
    county_name: "Valley",
    county_weights: {
      31163: 11.58,
      31175: 88.42,
    },
    county_names_all: "Valley|Sherman",
    county_fips_all: "31175|31163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68860,
    lat: 41.13378,
    lng: -99.79167,
    city: "Oconto",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 310,
    density: 0.6,
    county_fips: 31041,
    county_name: "Custer",
    county_weights: {
      31041: 96.83,
      31047: 3.17,
    },
    county_names_all: "Custer|Dawson",
    county_fips_all: "31041|31047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68861,
    lat: 40.69892,
    lng: -99.2639,
    city: "Odessa",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57,
    density: 25,
    county_fips: 31019,
    county_name: "Buffalo",
    county_weights: {
      31019: 100,
    },
    county_names_all: "Buffalo",
    county_fips_all: 31019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68862,
    lat: 41.60362,
    lng: -98.93841,
    city: "Ord",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2937,
    density: 3.8,
    county_fips: 31175,
    county_name: "Valley",
    county_weights: {
      31071: 5.05,
      31175: 94.95,
    },
    county_names_all: "Valley|Garfield",
    county_fips_all: "31175|31071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68863,
    lat: 40.76628,
    lng: -99.5252,
    city: "Overton",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1259,
    density: 4.3,
    county_fips: 31047,
    county_name: "Dawson",
    county_weights: {
      31047: 87.13,
      31137: 12.87,
    },
    county_names_all: "Dawson|Phelps",
    county_fips_all: "31047|31137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68864,
    lat: 41.2608,
    lng: -98.24046,
    city: "Palmer",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1061,
    density: 2.3,
    county_fips: 31121,
    county_name: "Merrick",
    county_weights: {
      31093: 24.57,
      31121: 38.05,
      31125: 37.37,
    },
    county_names_all: "Merrick|Nance|Howard",
    county_fips_all: "31121|31125|31093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68865,
    lat: 40.89337,
    lng: -98.187,
    city: "Phillips",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1020,
    density: 6.5,
    county_fips: 31081,
    county_name: "Hamilton",
    county_weights: {
      31081: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 31081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68866,
    lat: 40.96873,
    lng: -99.12297,
    city: "Pleasanton",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1031,
    density: 3.6,
    county_fips: 31019,
    county_name: "Buffalo",
    county_weights: {
      31019: 94.41,
      31041: 5.59,
    },
    county_names_all: "Buffalo|Custer",
    county_fips_all: "31019|31041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68869,
    lat: 40.99944,
    lng: -98.88325,
    city: "Ravenna",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2027,
    density: 3.7,
    county_fips: 31019,
    county_name: "Buffalo",
    county_weights: {
      31019: 73.31,
      31163: 26.69,
    },
    county_names_all: "Buffalo|Sherman",
    county_fips_all: "31019|31163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68870,
    lat: 40.8453,
    lng: -99.15835,
    city: "Riverdale",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 545,
    density: 4.8,
    county_fips: 31019,
    county_name: "Buffalo",
    county_weights: {
      31019: 100,
    },
    county_names_all: "Buffalo",
    county_fips_all: 31019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68871,
    lat: 41.14039,
    lng: -98.84788,
    city: "Rockville",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 293,
    density: 1.8,
    county_fips: 31163,
    county_name: "Sherman",
    county_weights: {
      31163: 100,
    },
    county_names_all: "Sherman",
    county_fips_all: 31163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68872,
    lat: 41.09286,
    lng: -98.33216,
    city: "Saint Libory",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 826,
    density: 5.1,
    county_fips: 31093,
    county_name: "Howard",
    county_weights: {
      31093: 73.57,
      31121: 26.43,
    },
    county_names_all: "Howard|Merrick",
    county_fips_all: "31093|31121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68873,
    lat: 41.24696,
    lng: -98.45149,
    city: "Saint Paul",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3642,
    density: 8.2,
    county_fips: 31093,
    county_name: "Howard",
    county_weights: {
      31093: 100,
    },
    county_names_all: "Howard",
    county_fips_all: 31093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68874,
    lat: 41.63368,
    lng: -99.42635,
    city: "Sargent",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 740,
    density: 1.1,
    county_fips: 31041,
    county_name: "Custer",
    county_weights: {
      31041: 95.27,
      31115: 4.73,
    },
    county_names_all: "Custer|Loup",
    county_fips_all: "31041|31115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68875,
    lat: 41.51328,
    lng: -98.68197,
    city: "Scotia",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 724,
    density: 2.1,
    county_fips: 31077,
    county_name: "Greeley",
    county_weights: {
      31077: 95.92,
      31093: 4.08,
    },
    county_names_all: "Greeley|Howard",
    county_fips_all: "31077|31093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68876,
    lat: 40.82492,
    lng: -98.74663,
    city: "Shelton",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1793,
    density: 7.6,
    county_fips: 31019,
    county_name: "Buffalo",
    county_weights: {
      31019: 72.37,
      31079: 27.63,
    },
    county_names_all: "Buffalo|Hall",
    county_fips_all: "31019|31079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68878,
    lat: 40.98623,
    lng: -99.50567,
    city: "Sumner",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 503,
    density: 1.6,
    county_fips: 31047,
    county_name: "Dawson",
    county_weights: {
      31041: 21.64,
      31047: 78.36,
    },
    county_names_all: "Dawson|Custer",
    county_fips_all: "31047|31041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68879,
    lat: 41.87411,
    lng: -99.50104,
    city: "Taylor",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 486,
    density: 1,
    county_fips: 31115,
    county_name: "Loup",
    county_weights: {
      31115: 100,
    },
    county_names_all: "Loup",
    county_fips_all: 31115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68881,
    lat: 41.43472,
    lng: -99.35957,
    city: "Westerville",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 31041,
    county_name: "Custer",
    county_weights: {
      31041: 100,
    },
    county_names_all: "Custer",
    county_fips_all: 31041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68882,
    lat: 41.42362,
    lng: -98.40366,
    city: "Wolbach",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 433,
    density: 1.2,
    county_fips: 31077,
    county_name: "Greeley",
    county_weights: {
      31077: 67.67,
      31093: 24.78,
      31125: 7.55,
    },
    county_names_all: "Greeley|Howard|Nance",
    county_fips_all: "31077|31093|31125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68883,
    lat: 40.81823,
    lng: -98.58558,
    city: "Wood River",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2777,
    density: 5.8,
    county_fips: 31079,
    county_name: "Hall",
    county_weights: {
      31001: 4.73,
      31079: 95.27,
    },
    county_names_all: "Hall|Adams",
    county_fips_all: "31079|31001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68901,
    lat: 40.59092,
    lng: -98.36599,
    city: "Hastings",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25998,
    density: 66.8,
    county_fips: 31001,
    county_name: "Adams",
    county_weights: {
      31001: 83.28,
      31035: 14.3,
      31079: 2.42,
    },
    county_names_all: "Adams|Clay|Hall",
    county_fips_all: "31001|31035|31079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68920,
    lat: 40.15482,
    lng: -99.33521,
    city: "Alma",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1734,
    density: 5.6,
    county_fips: 31083,
    county_name: "Harlan",
    county_weights: {
      31083: 100,
    },
    county_names_all: "Harlan",
    county_fips_all: 31083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68922,
    lat: 40.33653,
    lng: -99.89976,
    city: "Arapahoe",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1373,
    density: 3.3,
    county_fips: 31065,
    county_name: "Furnas",
    county_weights: {
      31065: 53.55,
      31073: 46.45,
    },
    county_names_all: "Furnas|Gosper",
    county_fips_all: "31065|31073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68923,
    lat: 40.36835,
    lng: -99.47314,
    city: "Atlanta",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 90,
    density: 147.2,
    county_fips: 31137,
    county_name: "Phelps",
    county_weights: {
      31137: 100,
    },
    county_names_all: "Phelps",
    county_fips_all: 31137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68924,
    lat: 40.49557,
    lng: -99.12469,
    city: "Axtell",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1461,
    density: 5.3,
    county_fips: 31099,
    county_name: "Kearney",
    county_weights: {
      31099: 89,
      31137: 11,
    },
    county_names_all: "Kearney|Phelps",
    county_fips_all: "31099|31137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68925,
    lat: 40.42366,
    lng: -98.43821,
    city: "Ayr",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 550,
    density: 3.5,
    county_fips: 31001,
    county_name: "Adams",
    county_weights: {
      31001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 31001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68926,
    lat: 40.09311,
    lng: -99.85139,
    city: "Beaver City",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 527,
    density: 1.4,
    county_fips: 31065,
    county_name: "Furnas",
    county_weights: {
      31065: 100,
    },
    county_names_all: "Furnas",
    county_fips_all: 31065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68927,
    lat: 40.51146,
    lng: -99.62665,
    city: "Bertrand",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1248,
    density: 3.2,
    county_fips: 31137,
    county_name: "Phelps",
    county_weights: {
      31073: 35.08,
      31137: 64.92,
    },
    county_names_all: "Phelps|Gosper",
    county_fips_all: "31137|31073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68928,
    lat: 40.2874,
    lng: -98.60728,
    city: "Bladen",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 311,
    density: 1.1,
    county_fips: 31181,
    county_name: "Webster",
    county_weights: {
      31001: 17.34,
      31181: 82.66,
    },
    county_names_all: "Webster|Adams",
    county_fips_all: "31181|31001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68929,
    lat: 40.15245,
    lng: -99.07124,
    city: "Bloomington",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 193,
    density: 1.3,
    county_fips: 31061,
    county_name: "Franklin",
    county_weights: {
      31061: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 31061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68930,
    lat: 40.28514,
    lng: -98.41846,
    city: "Blue Hill",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1440,
    density: 4,
    county_fips: 31181,
    county_name: "Webster",
    county_weights: {
      31001: 19.25,
      31181: 80.75,
    },
    county_names_all: "Webster|Adams",
    county_fips_all: "31181|31001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68932,
    lat: 40.30258,
    lng: -98.73851,
    city: "Campbell",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 432,
    density: 1.8,
    county_fips: 31061,
    county_name: "Franklin",
    county_weights: {
      31001: 12.74,
      31061: 41.95,
      31099: 12.76,
      31181: 32.56,
    },
    county_names_all: "Franklin|Webster|Kearney|Adams",
    county_fips_all: "31061|31181|31099|31001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68933,
    lat: 40.51786,
    lng: -98.04211,
    city: "Clay Center",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1025,
    density: 5.9,
    county_fips: 31035,
    county_name: "Clay",
    county_weights: {
      31035: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 31035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68934,
    lat: 40.33831,
    lng: -98.15962,
    city: "Deweese",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 132,
    density: 1.4,
    county_fips: 31129,
    county_name: "Nuckolls",
    county_weights: {
      31035: 31.18,
      31129: 68.82,
    },
    county_names_all: "Nuckolls|Clay",
    county_fips_all: "31129|31035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68935,
    lat: 40.38058,
    lng: -97.95859,
    city: "Edgar",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 650,
    density: 2.1,
    county_fips: 31035,
    county_name: "Clay",
    county_weights: {
      31035: 63.84,
      31129: 36.16,
    },
    county_names_all: "Clay|Nuckolls",
    county_fips_all: "31035|31129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68936,
    lat: 40.31655,
    lng: -99.77868,
    city: "Edison",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 279,
    density: 1.2,
    county_fips: 31065,
    county_name: "Furnas",
    county_weights: {
      31065: 63.94,
      31073: 36.06,
    },
    county_names_all: "Furnas|Gosper",
    county_fips_all: "31065|31073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68937,
    lat: 40.57262,
    lng: -99.85494,
    city: "Elwood",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1655,
    density: 3.2,
    county_fips: 31073,
    county_name: "Gosper",
    county_weights: {
      31047: 3.99,
      31063: 3.36,
      31073: 92.65,
    },
    county_names_all: "Gosper|Dawson|Frontier",
    county_fips_all: "31073|31047|31063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68938,
    lat: 40.42093,
    lng: -98.12344,
    city: "Fairfield",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 545,
    density: 3,
    county_fips: 31035,
    county_name: "Clay",
    county_weights: {
      31035: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 31035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68939,
    lat: 40.10977,
    lng: -98.96169,
    city: "Franklin",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1060,
    density: 3.1,
    county_fips: 31061,
    county_name: "Franklin",
    county_weights: {
      31061: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 31061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68940,
    lat: 40.53815,
    lng: -99.25086,
    city: "Funk",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 597,
    density: 3.1,
    county_fips: 31137,
    county_name: "Phelps",
    county_weights: {
      31137: 100,
    },
    county_names_all: "Phelps",
    county_fips_all: 31137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68941,
    lat: 40.46882,
    lng: -98.26792,
    city: "Glenvil",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 822,
    density: 3.4,
    county_fips: 31035,
    county_name: "Clay",
    county_weights: {
      31001: 41.26,
      31035: 58.74,
    },
    county_names_all: "Clay|Adams",
    county_fips_all: "31035|31001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68942,
    lat: 40.09552,
    lng: -98.31143,
    city: "Guide Rock",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 404,
    density: 1.1,
    county_fips: 31181,
    county_name: "Webster",
    county_weights: {
      31129: 27.07,
      31181: 72.93,
    },
    county_names_all: "Webster|Nuckolls",
    county_fips_all: "31181|31129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68943,
    lat: 40.03916,
    lng: -97.88589,
    city: "Hardy",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 288,
    density: 1.9,
    county_fips: 31129,
    county_name: "Nuckolls",
    county_weights: {
      20157: 11.82,
      31129: 84.06,
      31169: 4.12,
    },
    county_names_all: "Nuckolls|Republic|Thayer",
    county_fips_all: "31129|20157|31169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68944,
    lat: 40.63741,
    lng: -98.0949,
    city: "Harvard",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1380,
    density: 4.9,
    county_fips: 31035,
    county_name: "Clay",
    county_weights: {
      31035: 89.34,
      31081: 10.66,
    },
    county_names_all: "Clay|Hamilton",
    county_fips_all: "31035|31081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68945,
    lat: 40.56098,
    lng: -98.77327,
    city: "Heartwell",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 207,
    density: 1.7,
    county_fips: 31099,
    county_name: "Kearney",
    county_weights: {
      31001: 2.15,
      31099: 97.85,
    },
    county_names_all: "Kearney|Adams",
    county_fips_all: "31099|31001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68946,
    lat: 40.1067,
    lng: -99.99048,
    city: "Hendley",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13,
    density: 0.3,
    county_fips: 31065,
    county_name: "Furnas",
    county_weights: {
      31065: 100,
    },
    county_names_all: "Furnas",
    county_fips_all: 31065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68947,
    lat: 40.30139,
    lng: -99.05188,
    city: "Hildreth",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 599,
    density: 2.5,
    county_fips: 31061,
    county_name: "Franklin",
    county_weights: {
      31061: 79.21,
      31099: 20.79,
    },
    county_names_all: "Franklin|Kearney",
    county_fips_all: "31061|31099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68948,
    lat: 40.34151,
    lng: -100.02639,
    city: "Holbrook",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 261,
    density: 0.9,
    county_fips: 31065,
    county_name: "Furnas",
    county_weights: {
      31063: 20.52,
      31065: 48.64,
      31073: 30.84,
    },
    county_names_all: "Furnas|Gosper|Frontier",
    county_fips_all: "31065|31073|31063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68949,
    lat: 40.43193,
    lng: -99.39481,
    city: "Holdrege",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6480,
    density: 11.5,
    county_fips: 31137,
    county_name: "Phelps",
    county_weights: {
      31083: 14.96,
      31137: 85.04,
    },
    county_names_all: "Phelps|Harlan",
    county_fips_all: "31137|31083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68950,
    lat: 40.45586,
    lng: -98.66413,
    city: "Holstein",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 324,
    density: 2.5,
    county_fips: 31001,
    county_name: "Adams",
    county_weights: {
      31001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 31001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68952,
    lat: 40.08443,
    lng: -98.67587,
    city: "Inavale",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55,
    density: 0.4,
    county_fips: 31181,
    county_name: "Webster",
    county_weights: {
      31181: 100,
    },
    county_names_all: "Webster",
    county_fips_all: 31181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68954,
    lat: 40.61215,
    lng: -98.23512,
    city: "Inland",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8,
    density: 0.3,
    county_fips: 31035,
    county_name: "Clay",
    county_weights: {
      31035: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 31035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68955,
    lat: 40.59288,
    lng: -98.53966,
    city: "Juniata",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2259,
    density: 9.2,
    county_fips: 31001,
    county_name: "Adams",
    county_weights: {
      31001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 31001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68956,
    lat: 40.63088,
    lng: -98.6891,
    city: "Kenesaw",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1478,
    density: 6,
    county_fips: 31001,
    county_name: "Adams",
    county_weights: {
      31001: 71.42,
      31019: 1.83,
      31079: 6.51,
      31099: 20.24,
    },
    county_names_all: "Adams|Kearney|Hall|Buffalo",
    county_fips_all: "31001|31099|31079|31019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68957,
    lat: 40.26745,
    lng: -98.24176,
    city: "Lawrence",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 511,
    density: 1.9,
    county_fips: 31129,
    county_name: "Nuckolls",
    county_weights: {
      31001: 2.75,
      31035: 1.85,
      31129: 68.43,
      31181: 26.97,
    },
    county_names_all: "Nuckolls|Webster|Adams|Clay",
    county_fips_all: "31129|31181|31001|31035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68958,
    lat: 40.52772,
    lng: -99.50394,
    city: "Loomis",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 677,
    density: 3.6,
    county_fips: 31137,
    county_name: "Phelps",
    county_weights: {
      31137: 100,
    },
    county_names_all: "Phelps",
    county_fips_all: 31137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68959,
    lat: 40.49009,
    lng: -98.91487,
    city: "Minden",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3692,
    density: 5.7,
    county_fips: 31099,
    county_name: "Kearney",
    county_weights: {
      31099: 100,
    },
    county_names_all: "Kearney",
    county_fips_all: 31099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68960,
    lat: 40.08549,
    lng: -99.13866,
    city: "Naponee",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 183,
    density: 1.6,
    county_fips: 31061,
    county_name: "Franklin",
    county_weights: {
      31061: 98.16,
      31083: 1.84,
    },
    county_names_all: "Franklin|Harlan",
    county_fips_all: "31061|31083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68961,
    lat: 40.20679,
    lng: -98.03502,
    city: "Nelson",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 650,
    density: 1.9,
    county_fips: 31129,
    county_name: "Nuckolls",
    county_weights: {
      31129: 100,
    },
    county_names_all: "Nuckolls",
    county_fips_all: 31129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68964,
    lat: 40.23541,
    lng: -97.90207,
    city: "Oak",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27,
    density: 0.4,
    county_fips: 31129,
    county_name: "Nuckolls",
    county_weights: {
      31129: 96.65,
      31169: 3.35,
    },
    county_names_all: "Nuckolls|Thayer",
    county_fips_all: "31129|31169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68966,
    lat: 40.15765,
    lng: -99.46262,
    city: "Orleans",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 545,
    density: 1.5,
    county_fips: 31083,
    county_name: "Harlan",
    county_weights: {
      31083: 100,
    },
    county_names_all: "Harlan",
    county_fips_all: 31083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68967,
    lat: 40.25263,
    lng: -99.63085,
    city: "Oxford",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1055,
    density: 2.1,
    county_fips: 31065,
    county_name: "Furnas",
    county_weights: {
      31065: 48.82,
      31073: 3.58,
      31083: 47.6,
    },
    county_names_all: "Furnas|Harlan|Gosper",
    county_fips_all: "31065|31083|31073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68970,
    lat: 40.10157,
    lng: -98.52292,
    city: "Red Cloud",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1411,
    density: 3.6,
    county_fips: 31181,
    county_name: "Webster",
    county_weights: {
      31181: 100,
    },
    county_names_all: "Webster",
    county_fips_all: 31181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68971,
    lat: 40.11931,
    lng: -99.24478,
    city: "Republican City",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 358,
    density: 1.5,
    county_fips: 31083,
    county_name: "Harlan",
    county_weights: {
      31083: 100,
    },
    county_names_all: "Harlan",
    county_fips_all: 31083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68972,
    lat: 40.10361,
    lng: -98.80258,
    city: "Riverton",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 241,
    density: 0.8,
    county_fips: 31061,
    county_name: "Franklin",
    county_weights: {
      31061: 99.27,
      31181: 0.73,
    },
    county_names_all: "Franklin|Webster",
    county_fips_all: "31061|31181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68973,
    lat: 40.45014,
    lng: -98.55962,
    city: "Roseland",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 387,
    density: 3.2,
    county_fips: 31001,
    county_name: "Adams",
    county_weights: {
      31001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 31001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68974,
    lat: 40.13235,
    lng: -97.86457,
    city: "Ruskin",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 227,
    density: 2.5,
    county_fips: 31129,
    county_name: "Nuckolls",
    county_weights: {
      31129: 88.99,
      31169: 11.01,
    },
    county_names_all: "Nuckolls|Thayer",
    county_fips_all: "31129|31169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68975,
    lat: 40.61705,
    lng: -97.95483,
    city: "Saronville",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 95,
    density: 1.5,
    county_fips: 31035,
    county_name: "Clay",
    county_weights: {
      31035: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 31035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68976,
    lat: 40.6023,
    lng: -99.70918,
    city: "Smithfield",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 484,
    density: 5.1,
    county_fips: 31073,
    county_name: "Gosper",
    county_weights: {
      31073: 100,
    },
    county_names_all: "Gosper",
    county_fips_all: 31073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68977,
    lat: 40.06697,
    lng: -99.63045,
    city: "Stamford",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 254,
    density: 1,
    county_fips: 31083,
    county_name: "Harlan",
    county_weights: {
      31065: 49.1,
      31083: 50.9,
    },
    county_names_all: "Harlan|Furnas",
    county_fips_all: "31083|31065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68978,
    lat: 40.06339,
    lng: -98.09379,
    city: "Superior",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2495,
    density: 6.3,
    county_fips: 31129,
    county_name: "Nuckolls",
    county_weights: {
      20089: 15.35,
      31129: 84.65,
    },
    county_names_all: "Nuckolls|Jewell",
    county_fips_all: "31129|20089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68979,
    lat: 40.59717,
    lng: -97.85319,
    city: "Sutton",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1629,
    density: 4.6,
    county_fips: 31035,
    county_name: "Clay",
    county_weights: {
      31035: 64.26,
      31059: 29.08,
      31081: 5.19,
      31185: 1.47,
    },
    county_names_all: "Clay|Fillmore|Hamilton|York",
    county_fips_all: "31035|31059|31081|31185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68980,
    lat: 40.68213,
    lng: -98.25814,
    city: "Trumbull",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 470,
    density: 4.8,
    county_fips: 31035,
    county_name: "Clay",
    county_weights: {
      31001: 26.64,
      31035: 46.5,
      31079: 7.99,
      31081: 18.87,
    },
    county_names_all: "Clay|Adams|Hamilton|Hall",
    county_fips_all: "31035|31001|31081|31079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68981,
    lat: 40.28601,
    lng: -98.89237,
    city: "Upland",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 216,
    density: 1,
    county_fips: 31061,
    county_name: "Franklin",
    county_weights: {
      31061: 89.67,
      31099: 10.33,
    },
    county_names_all: "Franklin|Kearney",
    county_fips_all: "31061|31099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 68982,
    lat: 40.33081,
    lng: -99.19521,
    city: "Wilcox",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 739,
    density: 3.3,
    county_fips: 31061,
    county_name: "Franklin",
    county_weights: {
      31061: 30.4,
      31083: 29.69,
      31099: 12.52,
      31137: 27.39,
    },
    county_names_all: "Franklin|Harlan|Phelps|Kearney",
    county_fips_all: "31061|31083|31137|31099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69001,
    lat: 40.25232,
    lng: -100.65782,
    city: "McCook",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8736,
    density: 7.3,
    county_fips: 31145,
    county_name: "Red Willow",
    county_weights: {
      31063: 25.57,
      31085: 5.36,
      31087: 2.96,
      31145: 66.11,
    },
    county_names_all: "Red Willow|Frontier|Hayes|Hitchcock",
    county_fips_all: "31145|31063|31085|31087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69020,
    lat: 40.23522,
    lng: -100.31448,
    city: "Bartley",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 698,
    density: 2,
    county_fips: 31145,
    county_name: "Red Willow",
    county_weights: {
      31063: 17.03,
      31145: 82.97,
    },
    county_names_all: "Red Willow|Frontier",
    county_fips_all: "31145|31063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69021,
    lat: 40.13945,
    lng: -101.53594,
    city: "Benkelman",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1380,
    density: 1.7,
    county_fips: 31057,
    county_name: "Dundy",
    county_weights: {
      31057: 100,
    },
    county_names_all: "Dundy",
    county_fips_all: 31057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69022,
    lat: 40.33938,
    lng: -100.18413,
    city: "Cambridge",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1793,
    density: 2.3,
    county_fips: 31063,
    county_name: "Frontier",
    county_weights: {
      31063: 47.04,
      31065: 35.52,
      31145: 17.44,
    },
    county_names_all: "Frontier|Furnas|Red Willow",
    county_fips_all: "31063|31065|31145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69023,
    lat: 40.48132,
    lng: -101.89668,
    city: "Champion",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 296,
    density: 0.5,
    county_fips: 31029,
    county_name: "Chase",
    county_weights: {
      31029: 100,
    },
    county_names_all: "Chase",
    county_fips_all: 31029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69024,
    lat: 40.23918,
    lng: -100.856,
    city: "Culbertson",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1266,
    density: 1.7,
    county_fips: 31087,
    county_name: "Hitchcock",
    county_weights: {
      31063: 1.49,
      31085: 19.59,
      31087: 76.17,
      31145: 2.75,
    },
    county_names_all: "Hitchcock|Hayes|Red Willow|Frontier",
    county_fips_all: "31087|31085|31145|31063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69025,
    lat: 40.61957,
    lng: -100.50814,
    city: "Curtis",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1077,
    density: 1.7,
    county_fips: 31063,
    county_name: "Frontier",
    county_weights: {
      31063: 74.42,
      31111: 25.58,
    },
    county_names_all: "Frontier|Lincoln",
    county_fips_all: "31063|31111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69026,
    lat: 40.01975,
    lng: -100.41332,
    city: "Danbury",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 167,
    density: 0.8,
    county_fips: 31145,
    county_name: "Red Willow",
    county_weights: {
      20039: 35.67,
      31145: 64.33,
    },
    county_names_all: "Red Willow|Decatur",
    county_fips_all: "31145|20039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69027,
    lat: 40.49841,
    lng: -101.52638,
    city: "Enders",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13,
    density: 0.1,
    county_fips: 31029,
    county_name: "Chase",
    county_weights: {
      31029: 92.75,
      31057: 7.25,
    },
    county_names_all: "Chase|Dundy",
    county_fips_all: "31029|31057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69028,
    lat: 40.64107,
    lng: -100.04708,
    city: "Eustis",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 781,
    density: 1.8,
    county_fips: 31063,
    county_name: "Frontier",
    county_weights: {
      31047: 25.03,
      31063: 67.21,
      31073: 7.76,
    },
    county_names_all: "Frontier|Dawson|Gosper",
    county_fips_all: "31063|31047|31073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69029,
    lat: 40.68537,
    lng: -100.24277,
    city: "Farnam",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 365,
    density: 0.7,
    county_fips: 31063,
    county_name: "Frontier",
    county_weights: {
      31047: 18.45,
      31063: 52.52,
      31111: 29.03,
    },
    county_names_all: "Frontier|Lincoln|Dawson",
    county_fips_all: "31063|31111|31047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69030,
    lat: 40.20318,
    lng: -101.92592,
    city: "Haigler",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 280,
    density: 0.3,
    county_fips: 31057,
    county_name: "Dundy",
    county_weights: {
      31029: 11.42,
      31057: 88.58,
    },
    county_names_all: "Dundy|Chase",
    county_fips_all: "31057|31029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69032,
    lat: 40.56766,
    lng: -101.0471,
    city: "Hayes Center",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 531,
    density: 0.7,
    county_fips: 31085,
    county_name: "Hayes",
    county_weights: {
      31085: 100,
    },
    county_names_all: "Hayes",
    county_fips_all: 31085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69033,
    lat: 40.56447,
    lng: -101.68679,
    city: "Imperial",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2548,
    density: 3,
    county_fips: 31029,
    county_name: "Chase",
    county_weights: {
      31029: 96.09,
      31135: 3.91,
    },
    county_names_all: "Chase|Perkins",
    county_fips_all: "31029|31135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69034,
    lat: 40.24929,
    lng: -100.43866,
    city: "Indianola",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 997,
    density: 2,
    county_fips: 31145,
    county_name: "Red Willow",
    county_weights: {
      31063: 21.27,
      31145: 78.73,
    },
    county_names_all: "Red Willow|Frontier",
    county_fips_all: "31145|31063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69036,
    lat: 40.02788,
    lng: -100.29782,
    city: "Lebanon",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 132,
    density: 2.1,
    county_fips: 31145,
    county_name: "Red Willow",
    county_weights: {
      31145: 100,
    },
    county_names_all: "Red Willow",
    county_fips_all: 31145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69037,
    lat: 40.17759,
    lng: -101.40394,
    city: "Max",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 163,
    density: 1.3,
    county_fips: 31057,
    county_name: "Dundy",
    county_weights: {
      31057: 100,
    },
    county_names_all: "Dundy",
    county_fips_all: 31057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69038,
    lat: 40.60932,
    lng: -100.73703,
    city: "Maywood",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 473,
    density: 0.9,
    county_fips: 31063,
    county_name: "Frontier",
    county_weights: {
      31063: 64.32,
      31085: 35.68,
    },
    county_names_all: "Frontier|Hayes",
    county_fips_all: "31063|31085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69039,
    lat: 40.7013,
    lng: -100.38529,
    city: "Moorefield",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 105,
    density: 0.3,
    county_fips: 31111,
    county_name: "Lincoln",
    county_weights: {
      31063: 45.67,
      31111: 54.33,
    },
    county_names_all: "Lincoln|Frontier",
    county_fips_all: "31111|31063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69040,
    lat: 40.35565,
    lng: -101.12027,
    city: "Palisade",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 616,
    density: 1.2,
    county_fips: 31085,
    county_name: "Hayes",
    county_weights: {
      31085: 51.53,
      31087: 48.47,
    },
    county_names_all: "Hayes|Hitchcock",
    county_fips_all: "31085|31087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69041,
    lat: 40.17288,
    lng: -101.73415,
    city: "Parks",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 66,
    density: 0.2,
    county_fips: 31057,
    county_name: "Dundy",
    county_weights: {
      31057: 100,
    },
    county_names_all: "Dundy",
    county_fips_all: 31057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69042,
    lat: 40.47547,
    lng: -100.37903,
    city: "Stockville",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10,
    density: 0.1,
    county_fips: 31063,
    county_name: "Frontier",
    county_weights: {
      31063: 100,
    },
    county_names_all: "Frontier",
    county_fips_all: 31063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69043,
    lat: 40.13493,
    lng: -101.23754,
    city: "Stratton",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 436,
    density: 0.9,
    county_fips: 31087,
    county_name: "Hitchcock",
    county_weights: {
      31057: 4.65,
      31087: 95.35,
    },
    county_names_all: "Hitchcock|Dundy",
    county_fips_all: "31087|31057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69044,
    lat: 40.13171,
    lng: -101.02837,
    city: "Trenton",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 758,
    density: 1.5,
    county_fips: 31087,
    county_name: "Hitchcock",
    county_weights: {
      31087: 100,
    },
    county_names_all: "Hitchcock",
    county_fips_all: 31087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69045,
    lat: 40.44582,
    lng: -101.36639,
    city: "Wauneta",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 985,
    density: 1.2,
    county_fips: 31029,
    county_name: "Chase",
    county_weights: {
      31029: 42.5,
      31057: 20.31,
      31085: 34.37,
      31087: 2.83,
    },
    county_names_all: "Chase|Hayes|Dundy|Hitchcock",
    county_fips_all: "31029|31085|31057|31087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69046,
    lat: 40.06821,
    lng: -100.10403,
    city: "Wilsonville",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 83,
    density: 0.3,
    county_fips: 31065,
    county_name: "Furnas",
    county_weights: {
      31065: 88.34,
      31145: 11.66,
    },
    county_names_all: "Furnas|Red Willow",
    county_fips_all: "31065|31145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69101,
    lat: 41.1502,
    lng: -100.80319,
    city: "North Platte",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28576,
    density: 18.8,
    county_fips: 31111,
    county_name: "Lincoln",
    county_weights: {
      31111: 94.1,
      31117: 5.9,
    },
    county_names_all: "Lincoln|McPherson",
    county_fips_all: "31111|31117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69120,
    lat: 41.42592,
    lng: -100.23384,
    city: "Arnold",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1169,
    density: 1.2,
    county_fips: 31041,
    county_name: "Custer",
    county_weights: {
      31041: 54.91,
      31111: 20.5,
      31113: 24.59,
    },
    county_names_all: "Custer|Logan|Lincoln",
    county_fips_all: "31041|31113|31111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69121,
    lat: 41.56631,
    lng: -101.71983,
    city: "Arthur",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 381,
    density: 0.3,
    county_fips: 31005,
    county_name: "Arthur",
    county_weights: {
      31005: 100,
    },
    county_names_all: "Arthur",
    county_fips_all: 31005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69122,
    lat: 41.09713,
    lng: -102.08834,
    city: "Big Springs",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 696,
    density: 1.2,
    county_fips: 31049,
    county_name: "Deuel",
    county_weights: {
      31049: 59.71,
      31101: 23.83,
      31135: 16.46,
    },
    county_names_all: "Deuel|Keith|Perkins",
    county_fips_all: "31049|31101|31135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69123,
    lat: 41.04981,
    lng: -100.36627,
    city: "Brady",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 898,
    density: 1.3,
    county_fips: 31111,
    county_name: "Lincoln",
    county_weights: {
      31111: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 31111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69125,
    lat: 41.59087,
    lng: -102.85835,
    city: "Broadwater",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 221,
    density: 0.4,
    county_fips: 31123,
    county_name: "Morrill",
    county_weights: {
      31123: 100,
    },
    county_names_all: "Morrill",
    county_fips_all: 31123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69127,
    lat: 41.10231,
    lng: -101.90774,
    city: "Brule",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 762,
    density: 1.4,
    county_fips: 31101,
    county_name: "Keith",
    county_weights: {
      31101: 83.6,
      31135: 16.4,
    },
    county_names_all: "Keith|Perkins",
    county_fips_all: "31101|31135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69128,
    lat: 41.23252,
    lng: -103.90613,
    city: "Bushnell",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 328,
    density: 0.3,
    county_fips: 31105,
    county_name: "Kimball",
    county_weights: {
      31007: 11.21,
      31105: 88.79,
    },
    county_names_all: "Kimball|Banner",
    county_fips_all: "31105|31007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69129,
    lat: 41.14089,
    lng: -102.37823,
    city: "Chappell",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1076,
    density: 1.2,
    county_fips: 31049,
    county_name: "Deuel",
    county_weights: {
      31049: 80.38,
      31069: 19.62,
    },
    county_names_all: "Deuel|Garden",
    county_fips_all: "31049|31069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69130,
    lat: 40.89924,
    lng: -99.96628,
    city: "Cozad",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4971,
    density: 7.6,
    county_fips: 31047,
    county_name: "Dawson",
    county_weights: {
      31041: 6.95,
      31047: 93.05,
    },
    county_names_all: "Dawson|Custer",
    county_fips_all: "31047|31041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69131,
    lat: 41.4216,
    lng: -103.00047,
    city: "Dalton",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 698,
    density: 1.1,
    county_fips: 31033,
    county_name: "Cheyenne",
    county_weights: {
      31033: 63.03,
      31123: 36.97,
    },
    county_names_all: "Cheyenne|Morrill",
    county_fips_all: "31033|31123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69132,
    lat: 40.81495,
    lng: -101.00664,
    city: "Dickens",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 123,
    density: 0.4,
    county_fips: 31111,
    county_name: "Lincoln",
    county_weights: {
      31111: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 31111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69133,
    lat: 41.21975,
    lng: -103.47178,
    city: "Dix",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 486,
    density: 1.1,
    county_fips: 31105,
    county_name: "Kimball",
    county_weights: {
      31105: 100,
    },
    county_names_all: "Kimball",
    county_fips_all: 31105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69134,
    lat: 40.80733,
    lng: -101.36968,
    city: "Elsie",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 447,
    density: 0.7,
    county_fips: 31135,
    county_name: "Perkins",
    county_weights: {
      31029: 11.09,
      31085: 10.18,
      31135: 78.72,
    },
    county_names_all: "Perkins|Chase|Hayes",
    county_fips_all: "31135|31029|31085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69135,
    lat: 42.21111,
    lng: -100.31028,
    city: "Elsmere",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28,
    density: 0.2,
    county_fips: 31031,
    county_name: "Cherry",
    county_weights: {
      31031: 100,
    },
    county_names_all: "Cherry",
    county_fips_all: 31031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69138,
    lat: 40.99923,
    lng: -100.17684,
    city: "Gothenburg",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3994,
    density: 4.7,
    county_fips: 31047,
    county_name: "Dawson",
    county_weights: {
      31041: 33.38,
      31047: 42.38,
      31111: 24.24,
    },
    county_names_all: "Dawson|Custer|Lincoln",
    county_fips_all: "31047|31041|31111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69140,
    lat: 40.84129,
    lng: -101.7724,
    city: "Grant",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1815,
    density: 2.7,
    county_fips: 31135,
    county_name: "Perkins",
    county_weights: {
      31135: 100,
    },
    county_names_all: "Perkins",
    county_fips_all: 31135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69141,
    lat: 41.30409,
    lng: -102.93602,
    city: "Gurley",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 438,
    density: 1.6,
    county_fips: 31033,
    county_name: "Cheyenne",
    county_weights: {
      31033: 100,
    },
    county_names_all: "Cheyenne",
    county_fips_all: 31033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69142,
    lat: 41.91585,
    lng: -100.31719,
    city: "Halsey",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 115,
    density: 0.4,
    county_fips: 31171,
    county_name: "Thomas",
    county_weights: {
      31171: 100,
    },
    county_names_all: "Thomas",
    county_fips_all: 31171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69143,
    lat: 41.19184,
    lng: -101.01934,
    city: "Hershey",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1461,
    density: 2.2,
    county_fips: 31111,
    county_name: "Lincoln",
    county_weights: {
      31111: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 31111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69144,
    lat: 41.317,
    lng: -101.60261,
    city: "Keystone",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 121,
    density: 0.3,
    county_fips: 31101,
    county_name: "Keith",
    county_weights: {
      31005: 11.4,
      31101: 88.6,
    },
    county_names_all: "Keith|Arthur",
    county_fips_all: "31101|31005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69145,
    lat: 41.24913,
    lng: -103.67097,
    city: "Kimball",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2860,
    density: 2.7,
    county_fips: 31105,
    county_name: "Kimball",
    county_weights: {
      31007: 17.95,
      31105: 82.05,
    },
    county_names_all: "Kimball|Banner",
    county_fips_all: "31105|31007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69146,
    lat: 41.34986,
    lng: -101.82892,
    city: "Lemoyne",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 252,
    density: 0.6,
    county_fips: 31101,
    county_name: "Keith",
    county_weights: {
      31005: 32.57,
      31101: 67.43,
    },
    county_names_all: "Keith|Arthur",
    county_fips_all: "31101|31005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69147,
    lat: 41.51514,
    lng: -102.08813,
    city: "Lewellen",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 443,
    density: 0.4,
    county_fips: 31069,
    county_name: "Garden",
    county_weights: {
      31005: 1.5,
      31069: 86.16,
      31101: 12.34,
    },
    county_names_all: "Garden|Keith|Arthur",
    county_fips_all: "31069|31101|31005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69148,
    lat: 41.61329,
    lng: -102.58773,
    city: "Lisco",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 113,
    density: 0.1,
    county_fips: 31069,
    county_name: "Garden",
    county_weights: {
      31069: 75.06,
      31123: 24.94,
    },
    county_names_all: "Garden|Morrill",
    county_fips_all: "31069|31123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69149,
    lat: 41.22416,
    lng: -102.66362,
    city: "Lodgepole",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 789,
    density: 0.9,
    county_fips: 31033,
    county_name: "Cheyenne",
    county_weights: {
      31033: 77.16,
      31049: 4.28,
      31069: 18.56,
    },
    county_names_all: "Cheyenne|Garden|Deuel",
    county_fips_all: "31033|31069|31049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69150,
    lat: 40.82763,
    lng: -101.54599,
    city: "Madrid",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 386,
    density: 0.9,
    county_fips: 31135,
    county_name: "Perkins",
    county_weights: {
      31135: 100,
    },
    county_names_all: "Perkins",
    county_fips_all: 31135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69151,
    lat: 41.10153,
    lng: -100.52011,
    city: "Maxwell",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 990,
    density: 1.2,
    county_fips: 31111,
    county_name: "Lincoln",
    county_weights: {
      31111: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 31111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69152,
    lat: 42.08697,
    lng: -101.12216,
    city: "Mullen",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 812,
    density: 0.2,
    county_fips: 31091,
    county_name: "Hooker",
    county_weights: {
      31031: 49.06,
      31091: 50.94,
    },
    county_names_all: "Hooker|Cherry",
    county_fips_all: "31091|31031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69153,
    lat: 41.08018,
    lng: -101.67866,
    city: "Ogallala",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5715,
    density: 9.2,
    county_fips: 31101,
    county_name: "Keith",
    county_weights: {
      31101: 85.19,
      31135: 14.81,
    },
    county_names_all: "Keith|Perkins",
    county_fips_all: "31101|31135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69154,
    lat: 41.4642,
    lng: -102.35349,
    city: "Oshkosh",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1266,
    density: 1.2,
    county_fips: 31069,
    county_name: "Garden",
    county_weights: {
      31069: 100,
    },
    county_names_all: "Garden",
    county_fips_all: 31069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69155,
    lat: 41.18974,
    lng: -101.39008,
    city: "Paxton",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1142,
    density: 1.2,
    county_fips: 31101,
    county_name: "Keith",
    county_weights: {
      31005: 0.51,
      31101: 93.13,
      31117: 1.17,
      31135: 5.19,
    },
    county_names_all: "Keith|Perkins|McPherson|Arthur",
    county_fips_all: "31101|31135|31117|31005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69156,
    lat: 41.27689,
    lng: -103.34587,
    city: "Potter",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 556,
    density: 0.6,
    county_fips: 31033,
    county_name: "Cheyenne",
    county_weights: {
      31007: 23.55,
      31033: 62.25,
      31105: 14.2,
    },
    county_names_all: "Cheyenne|Banner|Kimball",
    county_fips_all: "31033|31007|31105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69157,
    lat: 42.02451,
    lng: -100.14824,
    city: "Purdum",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69,
    density: 0.1,
    county_fips: 31009,
    county_name: "Blaine",
    county_weights: {
      31009: 71.33,
      31017: 20.62,
      31031: 8.06,
    },
    county_names_all: "Blaine|Brown|Cherry",
    county_fips_all: "31009|31017|31031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69161,
    lat: 42.12034,
    lng: -100.76679,
    city: "Seneca",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43,
    density: 0.1,
    county_fips: 31031,
    county_name: "Cherry",
    county_weights: {
      31031: 65.06,
      31171: 34.94,
    },
    county_names_all: "Cherry|Thomas",
    county_fips_all: "31031|31171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69162,
    lat: 41.13001,
    lng: -103.02815,
    city: "Sidney",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7080,
    density: 6,
    county_fips: 31033,
    county_name: "Cheyenne",
    county_weights: {
      31033: 100,
    },
    county_names_all: "Cheyenne",
    county_fips_all: 31033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69163,
    lat: 41.59328,
    lng: -100.56795,
    city: "Stapleton",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 980,
    density: 0.5,
    county_fips: 31113,
    county_name: "Logan",
    county_weights: {
      31111: 12.46,
      31113: 62.63,
      31117: 5.23,
      31171: 19.68,
    },
    county_names_all: "Logan|Thomas|Lincoln|McPherson",
    county_fips_all: "31113|31171|31111|31117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69165,
    lat: 41.35102,
    lng: -101.27268,
    city: "Sutherland",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2037,
    density: 1.5,
    county_fips: 31111,
    county_name: "Lincoln",
    county_weights: {
      31005: 17.99,
      31111: 50.32,
      31117: 31.69,
    },
    county_names_all: "Lincoln|McPherson|Arthur",
    county_fips_all: "31111|31117|31005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69166,
    lat: 42.0791,
    lng: -100.56581,
    city: "Thedford",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 655,
    density: 0.3,
    county_fips: 31171,
    county_name: "Thomas",
    county_weights: {
      31031: 47.9,
      31171: 52.1,
    },
    county_names_all: "Thomas|Cherry",
    county_fips_all: "31171|31031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69167,
    lat: 41.58758,
    lng: -101.02296,
    city: "Tryon",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 306,
    density: 0.2,
    county_fips: 31117,
    county_name: "McPherson",
    county_weights: {
      31117: 100,
    },
    county_names_all: "McPherson",
    county_fips_all: 31117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69168,
    lat: 40.74817,
    lng: -101.98129,
    city: "Venango",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 215,
    density: 0.6,
    county_fips: 31135,
    county_name: "Perkins",
    county_weights: {
      31029: 34.21,
      31135: 61.36,
      "08115": 4.43,
    },
    county_names_all: "Perkins|Chase|Sedgwick",
    county_fips_all: "31135|31029|08115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69169,
    lat: 40.82144,
    lng: -101.17663,
    city: "Wallace",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 517,
    density: 0.9,
    county_fips: 31111,
    county_name: "Lincoln",
    county_weights: {
      31085: 5.95,
      31111: 77.68,
      31135: 16.37,
    },
    county_names_all: "Lincoln|Perkins|Hayes",
    county_fips_all: "31111|31135|31085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69170,
    lat: 40.79563,
    lng: -100.74068,
    city: "Wellfleet",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 242,
    density: 0.4,
    county_fips: 31111,
    county_name: "Lincoln",
    county_weights: {
      31111: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 31111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69171,
    lat: 40.89065,
    lng: -100.06814,
    city: "Willow Island",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8,
    density: 1.4,
    county_fips: 31047,
    county_name: "Dawson",
    county_weights: {
      31047: 100,
    },
    county_names_all: "Dawson",
    county_fips_all: 31047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69201,
    lat: 42.70004,
    lng: -100.59663,
    city: "Valentine",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4174,
    density: 1,
    county_fips: 31031,
    county_name: "Cherry",
    county_weights: {
      31031: 83.23,
      46121: 16.77,
    },
    county_names_all: "Cherry|Todd",
    county_fips_all: "31031|46121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69210,
    lat: 42.39766,
    lng: -99.84932,
    city: "Ainsworth",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2183,
    density: 1.6,
    county_fips: 31017,
    county_name: "Brown",
    county_weights: {
      31017: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 31017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69211,
    lat: 42.83965,
    lng: -101.31068,
    city: "Cody",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 412,
    density: 0.4,
    county_fips: 31031,
    county_name: "Cherry",
    county_weights: {
      31031: 100,
    },
    county_names_all: "Cherry",
    county_fips_all: 31031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69212,
    lat: 42.98729,
    lng: -100.80438,
    city: "Crookston",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 248,
    density: 0.4,
    county_fips: 31031,
    county_name: "Cherry",
    county_weights: {
      31031: 57.03,
      46121: 42.97,
    },
    county_names_all: "Cherry|Todd",
    county_fips_all: "31031|46121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69214,
    lat: 42.49121,
    lng: -100.07914,
    city: "Johnstown",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 376,
    density: 0.3,
    county_fips: 31017,
    county_name: "Brown",
    county_weights: {
      31017: 94.19,
      31031: 5.81,
    },
    county_names_all: "Brown|Cherry",
    county_fips_all: "31017|31031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69216,
    lat: 42.94069,
    lng: -100.96897,
    city: "Kilgore",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 152,
    density: 0.3,
    county_fips: 31031,
    county_name: "Cherry",
    county_weights: {
      31031: 70.8,
      46121: 29.2,
    },
    county_names_all: "Cherry|Todd",
    county_fips_all: "31031|46121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69217,
    lat: 42.42045,
    lng: -99.71314,
    city: "Long Pine",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 328,
    density: 0.7,
    county_fips: 31017,
    county_name: "Brown",
    county_weights: {
      31017: 85.28,
      31149: 14.72,
    },
    county_names_all: "Brown|Rock",
    county_fips_all: "31017|31149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69218,
    lat: 42.78005,
    lng: -101.63227,
    city: "Merriman",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 349,
    density: 0.3,
    county_fips: 31031,
    county_name: "Cherry",
    county_weights: {
      31031: 100,
    },
    county_names_all: "Cherry",
    county_fips_all: 31031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69219,
    lat: 42.70144,
    lng: -101.0886,
    city: "Nenzel",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 113,
    density: 0.2,
    county_fips: 31031,
    county_name: "Cherry",
    county_weights: {
      31031: 100,
    },
    county_names_all: "Cherry",
    county_fips_all: 31031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69220,
    lat: 42.92256,
    lng: -100.17198,
    city: "Sparks",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16,
    density: 0.1,
    county_fips: 31103,
    county_name: "Keya Paha",
    county_weights: {
      31031: 33.92,
      31103: 66.08,
    },
    county_names_all: "Keya Paha|Cherry",
    county_fips_all: "31103|31031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69221,
    lat: 42.63515,
    lng: -100.3104,
    city: "Wood Lake",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 180,
    density: 0.2,
    county_fips: 31031,
    county_name: "Cherry",
    county_weights: {
      31031: 100,
    },
    county_names_all: "Cherry",
    county_fips_all: 31031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 69301,
    lat: 42.12297,
    lng: -102.88593,
    city: "Alliance",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9591,
    density: 3.6,
    county_fips: 31013,
    county_name: "Box Butte",
    county_weights: {
      31013: 59.46,
      31123: 17.04,
      31161: 23.5,
    },
    county_names_all: "Box Butte|Sheridan|Morrill",
    county_fips_all: "31013|31161|31123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69331,
    lat: 41.85235,
    lng: -102.96047,
    city: "Angora",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 98,
    density: 0.2,
    county_fips: 31123,
    county_name: "Morrill",
    county_weights: {
      31123: 100,
    },
    county_names_all: "Morrill",
    county_fips_all: 31123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69333,
    lat: 42.04483,
    lng: -101.96962,
    city: "Ashby",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 269,
    density: 0.2,
    county_fips: 31075,
    county_name: "Grant",
    county_weights: {
      31031: 40.47,
      31069: 16.42,
      31075: 42.58,
      31161: 0.53,
    },
    county_names_all: "Grant|Cherry|Garden|Sheridan",
    county_fips_all: "31075|31031|31069|31161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69334,
    lat: 41.82364,
    lng: -103.2842,
    city: "Bayard",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2396,
    density: 3,
    county_fips: 31123,
    county_name: "Morrill",
    county_weights: {
      31007: 5.91,
      31123: 83.04,
      31157: 11.05,
    },
    county_names_all: "Morrill|Scotts Bluff|Banner",
    county_fips_all: "31123|31157|31007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69335,
    lat: 42.02418,
    lng: -102.13908,
    city: "Bingham",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24,
    density: 0.1,
    county_fips: 31161,
    county_name: "Sheridan",
    county_weights: {
      31069: 38.61,
      31161: 61.39,
    },
    county_names_all: "Sheridan|Garden",
    county_fips_all: "31161|31069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69336,
    lat: 41.61845,
    lng: -103.15152,
    city: "Bridgeport",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2167,
    density: 2.2,
    county_fips: 31123,
    county_name: "Morrill",
    county_weights: {
      31007: 2.87,
      31123: 97.13,
    },
    county_names_all: "Morrill|Banner",
    county_fips_all: "31123|31007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69337,
    lat: 42.86566,
    lng: -102.99513,
    city: "Chadron",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6976,
    density: 3.5,
    county_fips: 31045,
    county_name: "Dawes",
    county_weights: {
      31045: 78.95,
      31161: 6.53,
      46047: 3.11,
      46102: 11.41,
    },
    county_names_all: "Dawes|Oglala Lakota|Sheridan|Fall River",
    county_fips_all: "31045|46102|31161|46047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69339,
    lat: 42.60649,
    lng: -103.42939,
    city: "Crawford",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1454,
    density: 1.4,
    county_fips: 31045,
    county_name: "Dawes",
    county_weights: {
      31045: 67.38,
      31165: 32.62,
    },
    county_names_all: "Dawes|Sioux",
    county_fips_all: "31045|31165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69340,
    lat: 42.15192,
    lng: -102.21378,
    city: "Ellsworth",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58,
    density: 0.1,
    county_fips: 31161,
    county_name: "Sheridan",
    county_weights: {
      31031: 6.52,
      31069: 17.27,
      31161: 76.21,
    },
    county_names_all: "Sheridan|Garden|Cherry",
    county_fips_all: "31161|31069|31031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69341,
    lat: 41.74154,
    lng: -103.67937,
    city: "Gering",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10673,
    density: 19.9,
    county_fips: 31157,
    county_name: "Scotts Bluff",
    county_weights: {
      31007: 18.44,
      31157: 81.56,
    },
    county_names_all: "Scotts Bluff|Banner",
    county_fips_all: "31157|31007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69343,
    lat: 42.66842,
    lng: -101.94084,
    city: "Gordon",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2521,
    density: 0.7,
    county_fips: 31031,
    county_name: "Cherry",
    county_weights: {
      31031: 59.95,
      31161: 40.05,
    },
    county_names_all: "Cherry|Sheridan",
    county_fips_all: "31031|31161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69345,
    lat: 41.58164,
    lng: -103.7234,
    city: "Harrisburg",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 411,
    density: 0.4,
    county_fips: 31007,
    county_name: "Banner",
    county_weights: {
      31007: 100,
    },
    county_names_all: "Banner",
    county_fips_all: 31007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69346,
    lat: 42.66459,
    lng: -103.80651,
    city: "Harrison",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 518,
    density: 0.2,
    county_fips: 31165,
    county_name: "Sioux",
    county_weights: {
      31165: 100,
    },
    county_names_all: "Sioux",
    county_fips_all: 31165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69347,
    lat: 42.59693,
    lng: -102.6753,
    city: "Hay Springs",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1327,
    density: 1.1,
    county_fips: 31161,
    county_name: "Sheridan",
    county_weights: {
      31045: 17.65,
      31161: 82.35,
    },
    county_names_all: "Sheridan|Dawes",
    county_fips_all: "31161|31045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69348,
    lat: 42.3299,
    lng: -103.18777,
    city: "Hemingford",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1449,
    density: 1,
    county_fips: 31013,
    county_name: "Box Butte",
    county_weights: {
      31013: 70.04,
      31045: 15.97,
      31165: 13.99,
    },
    county_names_all: "Box Butte|Dawes|Sioux",
    county_fips_all: "31013|31045|31165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69350,
    lat: 41.98667,
    lng: -101.73311,
    city: "Hyannis",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 387,
    density: 0.3,
    county_fips: 31075,
    county_name: "Grant",
    county_weights: {
      31005: 5.8,
      31031: 30.75,
      31075: 63.45,
    },
    county_names_all: "Grant|Cherry|Arthur",
    county_fips_all: "31075|31031|31005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69351,
    lat: 42.1171,
    lng: -102.42096,
    city: "Lakeside",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 248,
    density: 0.1,
    county_fips: 31161,
    county_name: "Sheridan",
    county_weights: {
      31069: 40.28,
      31161: 59.72,
    },
    county_names_all: "Sheridan|Garden",
    county_fips_all: "31161|31069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69352,
    lat: 41.80396,
    lng: -103.97174,
    city: "Lyman",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 649,
    density: 1.9,
    county_fips: 31157,
    county_name: "Scotts Bluff",
    county_weights: {
      31157: 100,
    },
    county_names_all: "Scotts Bluff",
    county_fips_all: 31157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69353,
    lat: 41.74703,
    lng: -103.41898,
    city: "Mcgrew",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29,
    density: 138.9,
    county_fips: 31157,
    county_name: "Scotts Bluff",
    county_weights: {
      31157: 100,
    },
    county_names_all: "Scotts Bluff",
    county_fips_all: 31157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69354,
    lat: 42.40812,
    lng: -103.42469,
    city: "Marsland",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49,
    density: 0.1,
    county_fips: 31165,
    county_name: "Sioux",
    county_weights: {
      31013: 15.49,
      31045: 34.71,
      31165: 49.79,
    },
    county_names_all: "Sioux|Dawes|Box Butte",
    county_fips_all: "31165|31045|31013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69355,
    lat: 41.78192,
    lng: -103.51709,
    city: "Melbeta",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 179,
    density: 719.7,
    county_fips: 31157,
    county_name: "Scotts Bluff",
    county_weights: {
      31157: 100,
    },
    county_names_all: "Scotts Bluff",
    county_fips_all: 31157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69356,
    lat: 41.89318,
    lng: -103.45074,
    city: "Minatare",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2005,
    density: 6,
    county_fips: 31157,
    county_name: "Scotts Bluff",
    county_weights: {
      31157: 100,
    },
    county_names_all: "Scotts Bluff",
    county_fips_all: 31157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69357,
    lat: 42.0776,
    lng: -103.79553,
    city: "Mitchell",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3369,
    density: 3.5,
    county_fips: 31165,
    county_name: "Sioux",
    county_weights: {
      31157: 31.44,
      31165: 68.56,
    },
    county_names_all: "Sioux|Scotts Bluff",
    county_fips_all: "31165|31157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69358,
    lat: 42.07503,
    lng: -103.96617,
    city: "Morrill",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2038,
    density: 4,
    county_fips: 31165,
    county_name: "Sioux",
    county_weights: {
      31157: 28.11,
      31165: 71.89,
    },
    county_names_all: "Sioux|Scotts Bluff",
    county_fips_all: "31165|31157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69360,
    lat: 42.74359,
    lng: -102.48979,
    city: "Rushville",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1294,
    density: 1.5,
    county_fips: 31161,
    county_name: "Sheridan",
    county_weights: {
      31161: 100,
    },
    county_names_all: "Sheridan",
    county_fips_all: 31161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69361,
    lat: 42.01254,
    lng: -103.56802,
    city: "Scottsbluff",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17312,
    density: 28.1,
    county_fips: 31165,
    county_name: "Sioux",
    county_weights: {
      31157: 43.41,
      31165: 56.59,
    },
    county_names_all: "Sioux|Scotts Bluff",
    county_fips_all: "31165|31157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69365,
    lat: 42.94744,
    lng: -102.46095,
    city: "Whiteclay",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 31161,
    county_name: "Sheridan",
    county_weights: {
      31161: 100,
    },
    county_names_all: "Sheridan",
    county_fips_all: 31161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69366,
    lat: 42.13175,
    lng: -101.5421,
    city: "Whitman",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 284,
    density: 0.2,
    county_fips: 31031,
    county_name: "Cherry",
    county_weights: {
      31005: 2.26,
      31031: 58.32,
      31075: 39.42,
    },
    county_names_all: "Cherry|Grant|Arthur",
    county_fips_all: "31031|31075|31005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 69367,
    lat: 42.81651,
    lng: -103.32332,
    city: "Whitney",
    state_id: "NE",
    state_name: "Nebraska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 265,
    density: 0.4,
    county_fips: 31045,
    county_name: "Dawes",
    county_weights: {
      31045: 100,
    },
    county_names_all: "Dawes",
    county_fips_all: 31045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 70001,
    lat: 29.98272,
    lng: -90.16881,
    city: "Metairie",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38103,
    density: 2271.1,
    county_fips: 22051,
    county_name: "Jefferson",
    county_weights: {
      22051: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 22051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70002,
    lat: 30.0102,
    lng: -90.16241,
    city: "Metairie",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20563,
    density: 2460.9,
    county_fips: 22051,
    county_name: "Jefferson",
    county_weights: {
      22051: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 22051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70003,
    lat: 29.99874,
    lng: -90.21418,
    city: "Metairie",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38068,
    density: 2112.4,
    county_fips: 22051,
    county_name: "Jefferson",
    county_weights: {
      22051: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 22051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70005,
    lat: 30.00024,
    lng: -90.13422,
    city: "Metairie",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24897,
    density: 2290,
    county_fips: 22051,
    county_name: "Jefferson",
    county_weights: {
      22051: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 22051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70006,
    lat: 30.01393,
    lng: -90.19171,
    city: "Metairie",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15304,
    density: 2250.6,
    county_fips: 22051,
    county_name: "Jefferson",
    county_weights: {
      22051: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 22051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70030,
    lat: 29.81635,
    lng: -90.43526,
    city: "Des Allemands",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3679,
    density: 50.6,
    county_fips: 22089,
    county_name: "St. Charles",
    county_weights: {
      22057: 17.02,
      22089: 82.98,
    },
    county_names_all: "St. Charles|Lafourche",
    county_fips_all: "22089|22057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70031,
    lat: 29.94401,
    lng: -90.29666,
    city: "Ama",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1052,
    density: 116,
    county_fips: 22089,
    county_name: "St. Charles",
    county_weights: {
      22089: 100,
    },
    county_names_all: "St. Charles",
    county_fips_all: 22089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70032,
    lat: 29.95128,
    lng: -89.9958,
    city: "Arabi",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4207,
    density: 795,
    county_fips: 22087,
    county_name: "St. Bernard",
    county_weights: {
      22087: 100,
    },
    county_names_all: "St. Bernard",
    county_fips_all: 22087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70036,
    lat: 29.69855,
    lng: -90.12667,
    city: "Barataria",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1117,
    density: 54.8,
    county_fips: 22051,
    county_name: "Jefferson",
    county_weights: {
      22051: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 22051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70037,
    lat: 29.78669,
    lng: -90.01523,
    city: "Belle Chasse",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16129,
    density: 124.8,
    county_fips: 22075,
    county_name: "Plaquemines",
    county_weights: {
      22075: 100,
    },
    county_names_all: "Plaquemines",
    county_fips_all: 22075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70038,
    lat: 29.33105,
    lng: -89.4007,
    city: "Boothville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 182,
    density: 279.8,
    county_fips: 22075,
    county_name: "Plaquemines",
    county_weights: {
      22075: 100,
    },
    county_names_all: "Plaquemines",
    county_fips_all: 22075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70039,
    lat: 29.88274,
    lng: -90.37925,
    city: "Boutte",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2579,
    density: 74.3,
    county_fips: 22089,
    county_name: "St. Charles",
    county_weights: {
      22089: 100,
    },
    county_names_all: "St. Charles",
    county_fips_all: 22089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70040,
    lat: 29.75806,
    lng: -89.92327,
    city: "Braithwaite",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 816,
    density: 3.3,
    county_fips: 22075,
    county_name: "Plaquemines",
    county_weights: {
      22075: 99.15,
      22087: 0.85,
    },
    county_names_all: "Plaquemines|St. Bernard",
    county_fips_all: "22075|22087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70041,
    lat: 29.33194,
    lng: -89.46978,
    city: "Buras",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2554,
    density: 32.3,
    county_fips: 22075,
    county_name: "Plaquemines",
    county_weights: {
      22075: 100,
    },
    county_names_all: "Plaquemines",
    county_fips_all: 22075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70043,
    lat: 29.9571,
    lng: -89.96481,
    city: "Chalmette",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23111,
    density: 977,
    county_fips: 22087,
    county_name: "St. Bernard",
    county_weights: {
      22087: 100,
    },
    county_names_all: "St. Bernard",
    county_fips_all: 22087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70047,
    lat: 29.96686,
    lng: -90.36552,
    city: "Destrehan",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12923,
    density: 410,
    county_fips: 22089,
    county_name: "St. Charles",
    county_weights: {
      22089: 100,
    },
    county_names_all: "St. Charles",
    county_fips_all: 22089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70049,
    lat: 30.03062,
    lng: -90.55911,
    city: "Edgard",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1788,
    density: 42.2,
    county_fips: 22095,
    county_name: "St. John the Baptist",
    county_weights: {
      22095: 100,
    },
    county_names_all: "St. John the Baptist",
    county_fips_all: 22095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70050,
    lat: 29.38351,
    lng: -89.59601,
    city: "Empire",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 113,
    density: 119.1,
    county_fips: 22075,
    county_name: "Plaquemines",
    county_weights: {
      22075: 100,
    },
    county_names_all: "Plaquemines",
    county_fips_all: 22075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70051,
    lat: 30.07356,
    lng: -90.63999,
    city: "Garyville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1772,
    density: 84.7,
    county_fips: 22095,
    county_name: "St. John the Baptist",
    county_weights: {
      22095: 100,
    },
    county_names_all: "St. John the Baptist",
    county_fips_all: 22095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70052,
    lat: 30.07103,
    lng: -90.68731,
    city: "Gramercy",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3651,
    density: 183,
    county_fips: 22093,
    county_name: "St. James",
    county_weights: {
      22093: 100,
    },
    county_names_all: "St. James",
    county_fips_all: 22093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70053,
    lat: 29.91456,
    lng: -90.05318,
    city: "Gretna",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16790,
    density: 1893.5,
    county_fips: 22051,
    county_name: "Jefferson",
    county_weights: {
      22051: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 22051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70056,
    lat: 29.88848,
    lng: -90.03028,
    city: "Gretna",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41727,
    density: 2381.8,
    county_fips: 22051,
    county_name: "Jefferson",
    county_weights: {
      22051: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 22051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70057,
    lat: 29.95949,
    lng: -90.45897,
    city: "Hahnville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4766,
    density: 41.3,
    county_fips: 22089,
    county_name: "St. Charles",
    county_weights: {
      22089: 100,
    },
    county_names_all: "St. Charles",
    county_fips_all: 22089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70058,
    lat: 29.8701,
    lng: -90.06708,
    city: "Harvey",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40191,
    density: 1215.9,
    county_fips: 22051,
    county_name: "Jefferson",
    county_weights: {
      22051: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 22051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70062,
    lat: 29.98924,
    lng: -90.25579,
    city: "Kenner",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17463,
    density: 956.2,
    county_fips: 22051,
    county_name: "Jefferson",
    county_weights: {
      22051: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 22051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70065,
    lat: 30.02767,
    lng: -90.25405,
    city: "Kenner",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50973,
    density: 2447.6,
    county_fips: 22051,
    county_name: "Jefferson",
    county_weights: {
      22051: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 22051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70067,
    lat: 29.72008,
    lng: -90.10383,
    city: "Lafitte",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3089,
    density: 118,
    county_fips: 22051,
    county_name: "Jefferson",
    county_weights: {
      22051: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 22051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70068,
    lat: 30.14113,
    lng: -90.43502,
    city: "La Place",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33819,
    density: 264.9,
    county_fips: 22095,
    county_name: "St. John the Baptist",
    county_weights: {
      22089: 7.22,
      22095: 92.78,
    },
    county_names_all: "St. John the Baptist|St. Charles",
    county_fips_all: "22095|22089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70070,
    lat: 29.83302,
    lng: -90.3052,
    city: "Luling",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14827,
    density: 62.6,
    county_fips: 22089,
    county_name: "St. Charles",
    county_weights: {
      22089: 100,
    },
    county_names_all: "St. Charles",
    county_fips_all: 22089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70071,
    lat: 30.05123,
    lng: -90.70291,
    city: "Lutcher",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3272,
    density: 633.1,
    county_fips: 22093,
    county_name: "St. James",
    county_weights: {
      22093: 100,
    },
    county_names_all: "St. James",
    county_fips_all: 22093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70072,
    lat: 29.83012,
    lng: -90.12724,
    city: "Marrero",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55967,
    density: 416.8,
    county_fips: 22051,
    county_name: "Jefferson",
    county_weights: {
      22051: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 22051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70075,
    lat: 29.93158,
    lng: -89.92081,
    city: "Meraux",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5953,
    density: 674.3,
    county_fips: 22087,
    county_name: "St. Bernard",
    county_weights: {
      22071: 0.13,
      22087: 99.87,
    },
    county_names_all: "St. Bernard|Orleans",
    county_fips_all: "22087|22071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70076,
    lat: 30.04945,
    lng: -90.63678,
    city: "Mount Airy",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 194,
    density: 65.6,
    county_fips: 22095,
    county_name: "St. John the Baptist",
    county_weights: {
      22095: 100,
    },
    county_names_all: "St. John the Baptist",
    county_fips_all: 22095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70079,
    lat: 30.00172,
    lng: -90.41218,
    city: "Norco",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2993,
    density: 632.1,
    county_fips: 22089,
    county_name: "St. Charles",
    county_weights: {
      22089: 100,
    },
    county_names_all: "St. Charles",
    county_fips_all: 22089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70080,
    lat: 29.8743,
    lng: -90.43227,
    city: "Paradis",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1568,
    density: 63,
    county_fips: 22089,
    county_name: "St. Charles",
    county_weights: {
      22089: 100,
    },
    county_names_all: "St. Charles",
    county_fips_all: 22089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70082,
    lat: 29.5658,
    lng: -89.75677,
    city: "Pointe A La Hache",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 396,
    density: 13.4,
    county_fips: 22075,
    county_name: "Plaquemines",
    county_weights: {
      22075: 100,
    },
    county_names_all: "Plaquemines",
    county_fips_all: 22075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70083,
    lat: 29.52342,
    lng: -89.85211,
    city: "Port Sulphur",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2738,
    density: 8.2,
    county_fips: 22075,
    county_name: "Plaquemines",
    county_weights: {
      22075: 100,
    },
    county_names_all: "Plaquemines",
    county_fips_all: 22075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70084,
    lat: 30.07242,
    lng: -90.57251,
    city: "Reserve",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6001,
    density: 127.9,
    county_fips: 22095,
    county_name: "St. John the Baptist",
    county_weights: {
      22095: 100,
    },
    county_names_all: "St. John the Baptist",
    county_fips_all: 22095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70085,
    lat: 29.81629,
    lng: -89.76127,
    city: "Saint Bernard",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4822,
    density: 28.2,
    county_fips: 22087,
    county_name: "St. Bernard",
    county_weights: {
      22087: 100,
    },
    county_names_all: "St. Bernard",
    county_fips_all: 22087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70086,
    lat: 30.02628,
    lng: -90.88198,
    city: "Saint James",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2018,
    density: 20.2,
    county_fips: 22093,
    county_name: "St. James",
    county_weights: {
      22093: 100,
    },
    county_names_all: "St. James",
    county_fips_all: 22093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70087,
    lat: 29.98092,
    lng: -90.31264,
    city: "Saint Rose",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6770,
    density: 209.5,
    county_fips: 22089,
    county_name: "St. Charles",
    county_weights: {
      22089: 100,
    },
    county_names_all: "St. Charles",
    county_fips_all: 22089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70090,
    lat: 29.96725,
    lng: -90.6934,
    city: "Vacherie",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7278,
    density: 35.6,
    county_fips: 22093,
    county_name: "St. James",
    county_weights: {
      22093: 61.12,
      22095: 38.88,
    },
    county_names_all: "St. James|St. John the Baptist",
    county_fips_all: "22093|22095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70091,
    lat: 29.17723,
    lng: -89.23204,
    city: "Venice",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 377,
    density: 0.9,
    county_fips: 22075,
    county_name: "Plaquemines",
    county_weights: {
      22075: 100,
    },
    county_names_all: "Plaquemines",
    county_fips_all: 22075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70092,
    lat: 29.90026,
    lng: -89.89598,
    city: "Violet",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8601,
    density: 771.1,
    county_fips: 22087,
    county_name: "St. Bernard",
    county_weights: {
      22087: 100,
    },
    county_names_all: "St. Bernard",
    county_fips_all: 22087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70094,
    lat: 29.91162,
    lng: -90.20876,
    city: "Westwego",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30712,
    density: 328,
    county_fips: 22051,
    county_name: "Jefferson",
    county_weights: {
      22051: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 22051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70112,
    lat: 29.95608,
    lng: -90.07733,
    city: "New Orleans",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3552,
    density: 1395.7,
    county_fips: 22071,
    county_name: "Orleans",
    county_weights: {
      22071: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 22071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70113,
    lat: 29.9422,
    lng: -90.08382,
    city: "New Orleans",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8588,
    density: 3622.3,
    county_fips: 22071,
    county_name: "Orleans",
    county_weights: {
      22071: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 22071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70114,
    lat: 29.93704,
    lng: -90.0321,
    city: "New Orleans",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23654,
    density: 1807.2,
    county_fips: 22071,
    county_name: "Orleans",
    county_weights: {
      22071: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 22071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70115,
    lat: 29.92375,
    lng: -90.10219,
    city: "New Orleans",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34831,
    density: 3496.4,
    county_fips: 22071,
    county_name: "Orleans",
    county_weights: {
      22071: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 22071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70116,
    lat: 29.96697,
    lng: -90.06448,
    city: "New Orleans",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11950,
    density: 3641.3,
    county_fips: 22071,
    county_name: "Orleans",
    county_weights: {
      22071: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 22071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70117,
    lat: 29.9685,
    lng: -90.03004,
    city: "New Orleans",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27404,
    density: 1922.2,
    county_fips: 22071,
    county_name: "Orleans",
    county_weights: {
      22071: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 22071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70118,
    lat: 29.9451,
    lng: -90.1257,
    city: "New Orleans",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36963,
    density: 3085.8,
    county_fips: 22071,
    county_name: "Orleans",
    county_weights: {
      22071: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 22071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70119,
    lat: 29.97567,
    lng: -90.08729,
    city: "New Orleans",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37779,
    density: 3228.8,
    county_fips: 22071,
    county_name: "Orleans",
    county_weights: {
      22071: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 22071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70121,
    lat: 29.9608,
    lng: -90.15881,
    city: "New Orleans",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11361,
    density: 1338.7,
    county_fips: 22051,
    county_name: "Jefferson",
    county_weights: {
      22051: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 22051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70122,
    lat: 30.00835,
    lng: -90.06467,
    city: "New Orleans",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38977,
    density: 2400.6,
    county_fips: 22071,
    county_name: "Orleans",
    county_weights: {
      22071: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 22071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70123,
    lat: 29.951,
    lng: -90.20501,
    city: "New Orleans",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27906,
    density: 1421.3,
    county_fips: 22051,
    county_name: "Jefferson",
    county_weights: {
      22051: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 22051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70124,
    lat: 30.00747,
    lng: -90.10378,
    city: "New Orleans",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19362,
    density: 1119.7,
    county_fips: 22071,
    county_name: "Orleans",
    county_weights: {
      22071: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 22071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70125,
    lat: 29.95202,
    lng: -90.10338,
    city: "New Orleans",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18674,
    density: 3079.2,
    county_fips: 22071,
    county_name: "Orleans",
    county_weights: {
      22071: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 22071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70126,
    lat: 30.01948,
    lng: -90.01739,
    city: "New Orleans",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32024,
    density: 1023.9,
    county_fips: 22071,
    county_name: "Orleans",
    county_weights: {
      22071: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 22071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70127,
    lat: 30.02966,
    lng: -89.9761,
    city: "New Orleans",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24114,
    density: 1702.1,
    county_fips: 22071,
    county_name: "Orleans",
    county_weights: {
      22071: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 22071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70128,
    lat: 30.04896,
    lng: -89.95398,
    city: "New Orleans",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19940,
    density: 1614.1,
    county_fips: 22071,
    county_name: "Orleans",
    county_weights: {
      22071: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 22071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70129,
    lat: 30.08239,
    lng: -89.81617,
    city: "New Orleans",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9892,
    density: 42,
    county_fips: 22071,
    county_name: "Orleans",
    county_weights: {
      22071: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 22071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70130,
    lat: 29.93671,
    lng: -90.06949,
    city: "New Orleans",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14089,
    density: 2549.4,
    county_fips: 22071,
    county_name: "Orleans",
    county_weights: {
      22071: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 22071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70131,
    lat: 29.9081,
    lng: -89.96044,
    city: "New Orleans",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29456,
    density: 971.1,
    county_fips: 22071,
    county_name: "Orleans",
    county_weights: {
      22071: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 22071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70139,
    lat: 29.95023,
    lng: -90.071,
    city: "New Orleans",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 22071,
    county_name: "Orleans",
    county_weights: {
      22071: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 22071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70148,
    lat: 30.0287,
    lng: -90.06753,
    city: "New Orleans",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 22071,
    county_name: "Orleans",
    county_weights: {
      22071: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 22071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70163,
    lat: 29.94998,
    lng: -90.07546,
    city: "New Orleans",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 22071,
    county_name: "Orleans",
    county_weights: {
      22071: 100,
    },
    county_names_all: "Orleans",
    county_fips_all: 22071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70301,
    lat: 29.81431,
    lng: -90.7411,
    city: "Thibodaux",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45099,
    density: 61.4,
    county_fips: 22057,
    county_name: "Lafourche",
    county_weights: {
      22007: 1.66,
      22057: 97.51,
      22109: 0.83,
    },
    county_names_all: "Lafourche|Assumption|Terrebonne",
    county_fips_all: "22057|22007|22109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70310,
    lat: 29.79048,
    lng: -90.80301,
    city: "Thibodaux",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 22057,
    county_name: "Lafourche",
    county_weights: {
      22057: 100,
    },
    county_names_all: "Lafourche",
    county_fips_all: 22057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70339,
    lat: 29.92987,
    lng: -91.18357,
    city: "Pierre Part",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4423,
    density: 31,
    county_fips: 22007,
    county_name: "Assumption",
    county_weights: {
      22007: 89.79,
      22099: 10.21,
    },
    county_names_all: "Assumption|St. Martin",
    county_fips_all: "22007|22099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70340,
    lat: 29.66974,
    lng: -91.1043,
    city: "Amelia",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 187,
    density: 1406,
    county_fips: 22101,
    county_name: "St. Mary",
    county_weights: {
      22101: 100,
    },
    county_names_all: "St. Mary",
    county_fips_all: 22101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70341,
    lat: 30.02579,
    lng: -91.08267,
    city: "Belle Rose",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4635,
    density: 39.7,
    county_fips: 22007,
    county_name: "Assumption",
    county_weights: {
      22007: 100,
    },
    county_names_all: "Assumption",
    county_fips_all: 22007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70342,
    lat: 29.69486,
    lng: -91.23772,
    city: "Berwick",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4636,
    density: 239.9,
    county_fips: 22101,
    county_name: "St. Mary",
    county_weights: {
      22101: 100,
    },
    county_names_all: "St. Mary",
    county_fips_all: 22101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70343,
    lat: 29.55308,
    lng: -90.56402,
    city: "Bourg",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5073,
    density: 85.6,
    county_fips: 22057,
    county_name: "Lafourche",
    county_weights: {
      22057: 50.83,
      22109: 49.17,
    },
    county_names_all: "Lafourche|Terrebonne",
    county_fips_all: "22057|22109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70344,
    lat: 29.39711,
    lng: -90.63777,
    city: "Chauvin",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5651,
    density: 43.1,
    county_fips: 22109,
    county_name: "Terrebonne",
    county_weights: {
      22109: 100,
    },
    county_names_all: "Terrebonne",
    county_fips_all: 22109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70345,
    lat: 29.51815,
    lng: -90.23763,
    city: "Cut Off",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9269,
    density: 27.8,
    county_fips: 22057,
    county_name: "Lafourche",
    county_weights: {
      22057: 100,
    },
    county_names_all: "Lafourche",
    county_fips_all: 22057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70346,
    lat: 30.10774,
    lng: -91.02061,
    city: "Donaldsonville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11177,
    density: 66.5,
    county_fips: 22005,
    county_name: "Ascension",
    county_weights: {
      22005: 80.63,
      22007: 19.37,
    },
    county_names_all: "Ascension|Assumption",
    county_fips_all: "22005|22007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70352,
    lat: 29.68561,
    lng: -90.94486,
    city: "Donner",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 354,
    density: 34.9,
    county_fips: 22109,
    county_name: "Terrebonne",
    county_weights: {
      22109: 100,
    },
    county_names_all: "Terrebonne",
    county_fips_all: 22109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70353,
    lat: 29.36598,
    lng: -90.70554,
    city: "Dulac",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 798,
    density: 15.9,
    county_fips: 22109,
    county_name: "Terrebonne",
    county_weights: {
      22109: 100,
    },
    county_names_all: "Terrebonne",
    county_fips_all: 22109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70354,
    lat: 29.43136,
    lng: -90.34336,
    city: "Galliano",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4334,
    density: 24.5,
    county_fips: 22057,
    county_name: "Lafourche",
    county_weights: {
      22057: 100,
    },
    county_names_all: "Lafourche",
    county_fips_all: 22057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70355,
    lat: 29.69491,
    lng: -90.42916,
    city: "Gheens",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1044,
    density: 3.7,
    county_fips: 22057,
    county_name: "Lafourche",
    county_weights: {
      22057: 100,
    },
    county_names_all: "Lafourche",
    county_fips_all: 22057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70356,
    lat: 29.64142,
    lng: -90.95953,
    city: "Gibson",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1685,
    density: 9.8,
    county_fips: 22109,
    county_name: "Terrebonne",
    county_weights: {
      22109: 100,
    },
    county_names_all: "Terrebonne",
    county_fips_all: 22109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70357,
    lat: 29.28451,
    lng: -90.17463,
    city: "Golden Meadow",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2622,
    density: 5.6,
    county_fips: 22057,
    county_name: "Lafourche",
    county_weights: {
      22057: 100,
    },
    county_names_all: "Lafourche",
    county_fips_all: 22057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70358,
    lat: 29.21367,
    lng: -90.0306,
    city: "Grand Isle",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 672,
    density: 40.1,
    county_fips: 22051,
    county_name: "Jefferson",
    county_weights: {
      22051: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 22051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70359,
    lat: 29.68649,
    lng: -90.77859,
    city: "Gray",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9893,
    density: 265.2,
    county_fips: 22109,
    county_name: "Terrebonne",
    county_weights: {
      22057: 19.55,
      22109: 80.45,
    },
    county_names_all: "Terrebonne|Lafourche",
    county_fips_all: "22109|22057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70360,
    lat: 29.58396,
    lng: -90.81001,
    city: "Houma",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29286,
    density: 188.1,
    county_fips: 22109,
    county_name: "Terrebonne",
    county_weights: {
      22109: 100,
    },
    county_names_all: "Terrebonne",
    county_fips_all: 22109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70363,
    lat: 29.51516,
    lng: -90.70404,
    city: "Houma",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25210,
    density: 124.1,
    county_fips: 22109,
    county_name: "Terrebonne",
    county_weights: {
      22109: 100,
    },
    county_names_all: "Terrebonne",
    county_fips_all: 22109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70364,
    lat: 29.63419,
    lng: -90.68752,
    city: "Houma",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31491,
    density: 288.4,
    county_fips: 22109,
    county_name: "Terrebonne",
    county_weights: {
      22057: 41.62,
      22109: 58.38,
    },
    county_names_all: "Terrebonne|Lafourche",
    county_fips_all: "22109|22057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70372,
    lat: 29.78249,
    lng: -90.9889,
    city: "Labadieville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2176,
    density: 29.2,
    county_fips: 22007,
    county_name: "Assumption",
    county_weights: {
      22007: 100,
    },
    county_names_all: "Assumption",
    county_fips_all: 22007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70373,
    lat: 29.61335,
    lng: -90.31919,
    city: "Larose",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6225,
    density: 43.7,
    county_fips: 22057,
    county_name: "Lafourche",
    county_weights: {
      22057: 100,
    },
    county_names_all: "Lafourche",
    county_fips_all: 22057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70374,
    lat: 29.59924,
    lng: -90.50319,
    city: "Lockport",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7003,
    density: 61.3,
    county_fips: 22057,
    county_name: "Lafourche",
    county_weights: {
      22057: 100,
    },
    county_names_all: "Lafourche",
    county_fips_all: 22057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70375,
    lat: 29.69491,
    lng: -90.53257,
    city: "Mathews",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75,
    density: 3.9,
    county_fips: 22057,
    county_name: "Lafourche",
    county_weights: {
      22057: 100,
    },
    county_names_all: "Lafourche",
    county_fips_all: 22057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70377,
    lat: 29.45808,
    lng: -90.51361,
    city: "Montegut",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4574,
    density: 20.9,
    county_fips: 22109,
    county_name: "Terrebonne",
    county_weights: {
      22057: 36.76,
      22109: 63.24,
    },
    county_names_all: "Terrebonne|Lafourche",
    county_fips_all: "22109|22057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70380,
    lat: 29.71944,
    lng: -91.12634,
    city: "Morgan City",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21351,
    density: 106.2,
    county_fips: 22101,
    county_name: "St. Mary",
    county_weights: {
      22007: 31.63,
      22099: 33.81,
      22101: 34.56,
    },
    county_names_all: "St. Mary|St. Martin|Assumption",
    county_fips_all: "22101|22099|22007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70390,
    lat: 29.89068,
    lng: -91.03616,
    city: "Napoleonville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7527,
    density: 19.7,
    county_fips: 22007,
    county_name: "Assumption",
    county_weights: {
      22007: 100,
    },
    county_names_all: "Assumption",
    county_fips_all: 22007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70391,
    lat: 29.99516,
    lng: -91.06029,
    city: "Paincourtville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 366,
    density: 273.6,
    county_fips: 22007,
    county_name: "Assumption",
    county_weights: {
      22007: 100,
    },
    county_names_all: "Assumption",
    county_fips_all: 22007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70392,
    lat: 29.69847,
    lng: -91.32164,
    city: "Patterson",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8447,
    density: 88.7,
    county_fips: 22101,
    county_name: "St. Mary",
    county_weights: {
      22101: 100,
    },
    county_names_all: "St. Mary",
    county_fips_all: 22101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70393,
    lat: 29.9959,
    lng: -90.99897,
    city: "Plattenville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 729,
    density: 51.4,
    county_fips: 22007,
    county_name: "Assumption",
    county_weights: {
      22007: 100,
    },
    county_names_all: "Assumption",
    county_fips_all: 22007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70394,
    lat: 29.69448,
    lng: -90.61399,
    city: "Raceland",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14935,
    density: 68.9,
    county_fips: 22057,
    county_name: "Lafourche",
    county_weights: {
      22057: 100,
    },
    county_names_all: "Lafourche",
    county_fips_all: 22057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70395,
    lat: 29.69309,
    lng: -90.8513,
    city: "Schriever",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3944,
    density: 31.1,
    county_fips: 22109,
    county_name: "Terrebonne",
    county_weights: {
      22109: 100,
    },
    county_names_all: "Terrebonne",
    county_fips_all: 22109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70397,
    lat: 29.38444,
    lng: -90.823,
    city: "Theriot",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 894,
    density: 4.9,
    county_fips: 22109,
    county_name: "Terrebonne",
    county_weights: {
      22109: 100,
    },
    county_names_all: "Terrebonne",
    county_fips_all: 22109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70401,
    lat: 30.5281,
    lng: -90.45472,
    city: "Hammond",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21172,
    density: 235.6,
    county_fips: 22105,
    county_name: "Tangipahoa",
    county_weights: {
      22105: 100,
    },
    county_names_all: "Tangipahoa",
    county_fips_all: 22105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70402,
    lat: 30.51652,
    lng: -90.46932,
    city: "Hammond",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1804,
    density: 5668.1,
    county_fips: 22105,
    county_name: "Tangipahoa",
    county_weights: {
      22105: 100,
    },
    county_names_all: "Tangipahoa",
    county_fips_all: 22105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70403,
    lat: 30.47989,
    lng: -90.48639,
    city: "Hammond",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30825,
    density: 281.2,
    county_fips: 22105,
    county_name: "Tangipahoa",
    county_weights: {
      22063: 13.86,
      22105: 86.14,
    },
    county_names_all: "Tangipahoa|Livingston",
    county_fips_all: "22105|22063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70420,
    lat: 30.48767,
    lng: -89.95907,
    city: "Abita Springs",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9558,
    density: 57.8,
    county_fips: 22103,
    county_name: "St. Tammany",
    county_weights: {
      22103: 100,
    },
    county_names_all: "St. Tammany",
    county_fips_all: 22103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70422,
    lat: 30.73699,
    lng: -90.491,
    city: "Amite",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12352,
    density: 30.3,
    county_fips: 22105,
    county_name: "Tangipahoa",
    county_weights: {
      22063: 0.4,
      22091: 35.68,
      22105: 63.92,
    },
    county_names_all: "Tangipahoa|St. Helena|Livingston",
    county_fips_all: "22105|22091|22063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70426,
    lat: 30.93142,
    lng: -89.85807,
    city: "Angie",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5990,
    density: 18.6,
    county_fips: 22117,
    county_name: "Washington",
    county_weights: {
      22117: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 22117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70427,
    lat: 30.74587,
    lng: -89.9125,
    city: "Bogalusa",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19327,
    density: 52.8,
    county_fips: 22117,
    county_name: "Washington",
    county_weights: {
      22103: 9.99,
      22117: 90.01,
    },
    county_names_all: "Washington|St. Tammany",
    county_fips_all: "22117|22103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70431,
    lat: 30.61211,
    lng: -89.97215,
    city: "Bush",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4937,
    density: 27.5,
    county_fips: 22103,
    county_name: "St. Tammany",
    county_weights: {
      22103: 93.7,
      22117: 6.3,
    },
    county_names_all: "St. Tammany|Washington",
    county_fips_all: "22103|22117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70433,
    lat: 30.46184,
    lng: -90.13796,
    city: "Covington",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38203,
    density: 303.1,
    county_fips: 22103,
    county_name: "St. Tammany",
    county_weights: {
      22103: 93.35,
      22105: 6.65,
    },
    county_names_all: "St. Tammany|Tangipahoa",
    county_fips_all: "22103|22105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70435,
    lat: 30.55955,
    lng: -90.101,
    city: "Covington",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17339,
    density: 64.3,
    county_fips: 22103,
    county_name: "St. Tammany",
    county_weights: {
      22103: 96.03,
      22105: 3.97,
    },
    county_names_all: "St. Tammany|Tangipahoa",
    county_fips_all: "22103|22105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70436,
    lat: 30.83057,
    lng: -90.53315,
    city: "Fluker",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 602,
    density: 33.4,
    county_fips: 22105,
    county_name: "Tangipahoa",
    county_weights: {
      22105: 100,
    },
    county_names_all: "Tangipahoa",
    county_fips_all: 22105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70437,
    lat: 30.60909,
    lng: -90.20928,
    city: "Folsom",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8011,
    density: 35.8,
    county_fips: 22103,
    county_name: "St. Tammany",
    county_weights: {
      22103: 76.11,
      22105: 23.89,
    },
    county_names_all: "St. Tammany|Tangipahoa",
    county_fips_all: "22103|22105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70438,
    lat: 30.84139,
    lng: -90.11186,
    city: "Franklinton",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19028,
    density: 21.1,
    county_fips: 22117,
    county_name: "Washington",
    county_weights: {
      22103: 2.83,
      22105: 0.82,
      22117: 96.35,
    },
    county_names_all: "Washington|St. Tammany|Tangipahoa",
    county_fips_all: "22117|22103|22105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70441,
    lat: 30.85987,
    lng: -90.7489,
    city: "Greensburg",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5047,
    density: 9.2,
    county_fips: 22091,
    county_name: "St. Helena",
    county_weights: {
      22091: 100,
    },
    county_names_all: "St. Helena",
    county_fips_all: 22091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70442,
    lat: 30.70307,
    lng: -90.33433,
    city: "Husser",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 408,
    density: 9.6,
    county_fips: 22105,
    county_name: "Tangipahoa",
    county_weights: {
      22105: 100,
    },
    county_names_all: "Tangipahoa",
    county_fips_all: 22105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70443,
    lat: 30.62885,
    lng: -90.54257,
    city: "Independence",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8897,
    density: 45.1,
    county_fips: 22105,
    county_name: "Tangipahoa",
    county_weights: {
      22063: 32.89,
      22091: 9.72,
      22105: 57.39,
    },
    county_names_all: "Tangipahoa|Livingston|St. Helena",
    county_fips_all: "22105|22063|22091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70444,
    lat: 30.90833,
    lng: -90.48707,
    city: "Kentwood",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11521,
    density: 18.2,
    county_fips: 22105,
    county_name: "Tangipahoa",
    county_weights: {
      22091: 27.58,
      22105: 71.37,
      22117: 1.05,
    },
    county_names_all: "Tangipahoa|St. Helena|Washington",
    county_fips_all: "22105|22091|22117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70445,
    lat: 30.36352,
    lng: -89.91265,
    city: "Lacombe",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9348,
    density: 33.3,
    county_fips: 22103,
    county_name: "St. Tammany",
    county_weights: {
      22103: 100,
    },
    county_names_all: "St. Tammany",
    county_fips_all: 22103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70446,
    lat: 30.63612,
    lng: -90.35159,
    city: "Loranger",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7241,
    density: 33.9,
    county_fips: 22105,
    county_name: "Tangipahoa",
    county_weights: {
      22105: 100,
    },
    county_names_all: "Tangipahoa",
    county_fips_all: 22105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70447,
    lat: 30.42144,
    lng: -90.20257,
    city: "Madisonville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16496,
    density: 205.7,
    county_fips: 22103,
    county_name: "St. Tammany",
    county_weights: {
      22103: 100,
    },
    county_names_all: "St. Tammany",
    county_fips_all: 22103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70448,
    lat: 30.36278,
    lng: -90.03943,
    city: "Mandeville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26236,
    density: 461.7,
    county_fips: 22103,
    county_name: "St. Tammany",
    county_weights: {
      22103: 100,
    },
    county_names_all: "St. Tammany",
    county_fips_all: 22103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70449,
    lat: 30.26363,
    lng: -90.66345,
    city: "Maurepas",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3438,
    density: 22.6,
    county_fips: 22063,
    county_name: "Livingston",
    county_weights: {
      22005: 0.53,
      22063: 99.47,
    },
    county_names_all: "Livingston|Ascension",
    county_fips_all: "22063|22005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70450,
    lat: 30.93667,
    lng: -90.26755,
    city: "Mount Hermon",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2617,
    density: 13.7,
    county_fips: 22117,
    county_name: "Washington",
    county_weights: {
      22117: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 22117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70451,
    lat: 30.54964,
    lng: -90.48111,
    city: "Natalbany",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 22105,
    county_name: "Tangipahoa",
    county_weights: {
      22105: 100,
    },
    county_names_all: "Tangipahoa",
    county_fips_all: 22105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70452,
    lat: 30.41424,
    lng: -89.76048,
    city: "Pearl River",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13385,
    density: 52.1,
    county_fips: 22103,
    county_name: "St. Tammany",
    county_weights: {
      22103: 100,
    },
    county_names_all: "St. Tammany",
    county_fips_all: 22103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70453,
    lat: 30.69385,
    lng: -90.76918,
    city: "Pine Grove",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 587,
    density: 6.1,
    county_fips: 22091,
    county_name: "St. Helena",
    county_weights: {
      22063: 5.54,
      22091: 94.46,
    },
    county_names_all: "St. Helena|Livingston",
    county_fips_all: "22091|22063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70454,
    lat: 30.39525,
    lng: -90.3682,
    city: "Ponchatoula",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28461,
    density: 63,
    county_fips: 22105,
    county_name: "Tangipahoa",
    county_weights: {
      22105: 100,
    },
    county_names_all: "Tangipahoa",
    county_fips_all: 22105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70455,
    lat: 30.52438,
    lng: -90.31883,
    city: "Robert",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1071,
    density: 18.3,
    county_fips: 22105,
    county_name: "Tangipahoa",
    county_weights: {
      22105: 100,
    },
    county_names_all: "Tangipahoa",
    county_fips_all: 22105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70456,
    lat: 30.79332,
    lng: -90.50702,
    city: "Roseland",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2651,
    density: 31,
    county_fips: 22105,
    county_name: "Tangipahoa",
    county_weights: {
      22105: 100,
    },
    county_names_all: "Tangipahoa",
    county_fips_all: 22105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70457,
    lat: 30.52743,
    lng: -90.11332,
    city: "Saint Benedict",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 22103,
    county_name: "St. Tammany",
    county_weights: {
      22103: 100,
    },
    county_names_all: "St. Tammany",
    county_fips_all: 22103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70458,
    lat: 30.25864,
    lng: -89.79441,
    city: "Slidell",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37164,
    density: 687.1,
    county_fips: 22103,
    county_name: "St. Tammany",
    county_weights: {
      22103: 100,
    },
    county_names_all: "St. Tammany",
    county_fips_all: 22103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70460,
    lat: 30.29925,
    lng: -89.83455,
    city: "Slidell",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22334,
    density: 224.4,
    county_fips: 22103,
    county_name: "St. Tammany",
    county_weights: {
      22103: 100,
    },
    county_names_all: "St. Tammany",
    county_fips_all: 22103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70461,
    lat: 30.2326,
    lng: -89.70931,
    city: "Slidell",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32900,
    density: 237.4,
    county_fips: 22103,
    county_name: "St. Tammany",
    county_weights: {
      22103: 100,
    },
    county_names_all: "St. Tammany",
    county_fips_all: 22103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70462,
    lat: 30.3656,
    lng: -90.58368,
    city: "Springfield",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5317,
    density: 25.8,
    county_fips: 22063,
    county_name: "Livingston",
    county_weights: {
      22063: 99.31,
      22105: 0.69,
    },
    county_names_all: "Livingston|Tangipahoa",
    county_fips_all: "22063|22105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70463,
    lat: 30.6551,
    lng: -89.90162,
    city: "Sun",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 84,
    density: 37.4,
    county_fips: 22103,
    county_name: "St. Tammany",
    county_weights: {
      22103: 100,
    },
    county_names_all: "St. Tammany",
    county_fips_all: 22103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70464,
    lat: 30.54416,
    lng: -89.89221,
    city: "Talisheek",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 532,
    density: 60.5,
    county_fips: 22103,
    county_name: "St. Tammany",
    county_weights: {
      22103: 100,
    },
    county_names_all: "St. Tammany",
    county_fips_all: 22103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70465,
    lat: 30.87577,
    lng: -90.51384,
    city: "Tangipahoa",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 633,
    density: 243.3,
    county_fips: 22105,
    county_name: "Tangipahoa",
    county_weights: {
      22105: 100,
    },
    county_names_all: "Tangipahoa",
    county_fips_all: 22105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70466,
    lat: 30.5685,
    lng: -90.50195,
    city: "Tickfaw",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10753,
    density: 120.9,
    county_fips: 22105,
    county_name: "Tangipahoa",
    county_weights: {
      22063: 4.74,
      22105: 95.26,
    },
    county_names_all: "Tangipahoa|Livingston",
    county_fips_all: "22105|22063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70471,
    lat: 30.407,
    lng: -90.06346,
    city: "Mandeville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22284,
    density: 297.8,
    county_fips: 22103,
    county_name: "St. Tammany",
    county_weights: {
      22103: 100,
    },
    county_names_all: "St. Tammany",
    county_fips_all: 22103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70501,
    lat: 30.2391,
    lng: -91.99122,
    city: "Lafayette",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30044,
    density: 757.7,
    county_fips: 22055,
    county_name: "Lafayette",
    county_weights: {
      22055: 100,
    },
    county_names_all: "Lafayette",
    county_fips_all: 22055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70503,
    lat: 30.17353,
    lng: -92.05901,
    city: "Lafayette",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31542,
    density: 1075.5,
    county_fips: 22055,
    county_name: "Lafayette",
    county_weights: {
      22055: 100,
    },
    county_names_all: "Lafayette",
    county_fips_all: 22055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70506,
    lat: 30.19586,
    lng: -92.08075,
    city: "Lafayette",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41212,
    density: 766.4,
    county_fips: 22055,
    county_name: "Lafayette",
    county_weights: {
      22055: 100,
    },
    county_names_all: "Lafayette",
    county_fips_all: 22055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70507,
    lat: 30.28293,
    lng: -92.02825,
    city: "Lafayette",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18260,
    density: 329,
    county_fips: 22055,
    county_name: "Lafayette",
    county_weights: {
      22055: 100,
    },
    county_names_all: "Lafayette",
    county_fips_all: 22055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70508,
    lat: 30.15627,
    lng: -92.02913,
    city: "Lafayette",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38704,
    density: 614.9,
    county_fips: 22055,
    county_name: "Lafayette",
    county_weights: {
      22055: 100,
    },
    county_names_all: "Lafayette",
    county_fips_all: 22055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70510,
    lat: 29.89493,
    lng: -92.19569,
    city: "Abbeville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25212,
    density: 41.8,
    county_fips: 22113,
    county_name: "Vermilion",
    county_weights: {
      22113: 100,
    },
    county_names_all: "Vermilion",
    county_fips_all: 22113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70512,
    lat: 30.41333,
    lng: -91.92337,
    city: "Arnaudville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10315,
    density: 40.7,
    county_fips: 22097,
    county_name: "St. Landry",
    county_weights: {
      22097: 61.16,
      22099: 38.84,
    },
    county_names_all: "St. Landry|St. Martin",
    county_fips_all: "22097|22099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70513,
    lat: 29.90272,
    lng: -91.90106,
    city: "Avery Island",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 215,
    density: 51.7,
    county_fips: 22045,
    county_name: "Iberia",
    county_weights: {
      22045: 100,
    },
    county_names_all: "Iberia",
    county_fips_all: 22045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70514,
    lat: 29.8452,
    lng: -91.55301,
    city: "Baldwin",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1891,
    density: 158.5,
    county_fips: 22101,
    county_name: "St. Mary",
    county_weights: {
      22101: 100,
    },
    county_names_all: "St. Mary",
    county_fips_all: 22101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70515,
    lat: 30.44843,
    lng: -92.57154,
    city: "Basile",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3953,
    density: 21.2,
    county_fips: 22001,
    county_name: "Acadia",
    county_weights: {
      22001: 56.47,
      22039: 43.53,
    },
    county_names_all: "Acadia|Evangeline",
    county_fips_all: "22001|22039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70516,
    lat: 30.3674,
    lng: -92.30289,
    city: "Branch",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 772,
    density: 7.7,
    county_fips: 22001,
    county_name: "Acadia",
    county_weights: {
      22001: 100,
    },
    county_names_all: "Acadia",
    county_fips_all: 22001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70517,
    lat: 30.28421,
    lng: -91.79615,
    city: "Breaux Bridge",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27580,
    density: 63.1,
    county_fips: 22099,
    county_name: "St. Martin",
    county_weights: {
      22055: 1.04,
      22099: 98.96,
    },
    county_names_all: "St. Martin|Lafayette",
    county_fips_all: "22099|22055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70518,
    lat: 30.13503,
    lng: -91.92922,
    city: "Broussard",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14721,
    density: 136.2,
    county_fips: 22055,
    county_name: "Lafayette",
    county_weights: {
      22045: 3.19,
      22055: 51.37,
      22099: 45.44,
    },
    county_names_all: "Lafayette|St. Martin|Iberia",
    county_fips_all: "22055|22099|22045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70519,
    lat: 30.08178,
    lng: -91.90705,
    city: "Cade",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 195,
    density: 115,
    county_fips: 22099,
    county_name: "St. Martin",
    county_weights: {
      22099: 100,
    },
    county_names_all: "St. Martin",
    county_fips_all: 22099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70520,
    lat: 30.33265,
    lng: -92.03619,
    city: "Carencro",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21805,
    density: 216.7,
    county_fips: 22055,
    county_name: "Lafayette",
    county_weights: {
      22055: 96.73,
      22097: 3.27,
    },
    county_names_all: "Lafayette|St. Landry",
    county_fips_all: "22055|22097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70522,
    lat: 29.74949,
    lng: -91.43287,
    city: "Centerville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 22101,
    county_name: "St. Mary",
    county_weights: {
      22101: 100,
    },
    county_names_all: "St. Mary",
    county_fips_all: 22101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70523,
    lat: 29.87383,
    lng: -91.52956,
    city: "Charenton",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 778,
    density: 217.5,
    county_fips: 22101,
    county_name: "St. Mary",
    county_weights: {
      22101: 100,
    },
    county_names_all: "St. Mary",
    county_fips_all: 22101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70524,
    lat: 30.55737,
    lng: -92.31859,
    city: "Chataignier",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 193,
    density: 27.4,
    county_fips: 22039,
    county_name: "Evangeline",
    county_weights: {
      22039: 100,
    },
    county_names_all: "Evangeline",
    county_fips_all: 22039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70525,
    lat: 30.40765,
    lng: -92.21761,
    city: "Church Point",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15467,
    density: 58.1,
    county_fips: 22001,
    county_name: "Acadia",
    county_weights: {
      22001: 60.95,
      22055: 0.83,
      22097: 38.22,
    },
    county_names_all: "Acadia|St. Landry|Lafayette",
    county_fips_all: "22001|22097|22055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70526,
    lat: 30.21051,
    lng: -92.37951,
    city: "Crowley",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18210,
    density: 55.8,
    county_fips: 22001,
    county_name: "Acadia",
    county_weights: {
      22001: 98.79,
      22113: 1.21,
    },
    county_names_all: "Acadia|Vermilion",
    county_fips_all: "22001|22113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70528,
    lat: 29.89766,
    lng: -91.96692,
    city: "Delcambre",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2370,
    density: 57.3,
    county_fips: 22045,
    county_name: "Iberia",
    county_weights: {
      22045: 88.46,
      22113: 11.54,
    },
    county_names_all: "Iberia|Vermilion",
    county_fips_all: "22045|22113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70529,
    lat: 30.19593,
    lng: -92.16327,
    city: "Duson",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12999,
    density: 137.9,
    county_fips: 22055,
    county_name: "Lafayette",
    county_weights: {
      22001: 2.17,
      22055: 97.07,
      22113: 0.76,
    },
    county_names_all: "Lafayette|Acadia|Vermilion",
    county_fips_all: "22055|22001|22113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70531,
    lat: 30.23101,
    lng: -92.49678,
    city: "Egan",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1757,
    density: 20.3,
    county_fips: 22001,
    county_name: "Acadia",
    county_weights: {
      22001: 100,
    },
    county_names_all: "Acadia",
    county_fips_all: 22001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70532,
    lat: 30.4705,
    lng: -92.6993,
    city: "Elton",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2278,
    density: 9.2,
    county_fips: 22053,
    county_name: "Jefferson Davis",
    county_weights: {
      22003: 36.07,
      22053: 63.93,
    },
    county_names_all: "Jefferson Davis|Allen",
    county_fips_all: "22053|22003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70533,
    lat: 29.90439,
    lng: -92.03536,
    city: "Erath",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7098,
    density: 36.9,
    county_fips: 22113,
    county_name: "Vermilion",
    county_weights: {
      22045: 0.3,
      22113: 99.7,
    },
    county_names_all: "Vermilion|Iberia",
    county_fips_all: "22113|22045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70534,
    lat: 30.16564,
    lng: -92.45499,
    city: "Estherwood",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 676,
    density: 41.1,
    county_fips: 22001,
    county_name: "Acadia",
    county_weights: {
      22001: 100,
    },
    county_names_all: "Acadia",
    county_fips_all: 22001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70535,
    lat: 30.47999,
    lng: -92.42367,
    city: "Eunice",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17344,
    density: 41.7,
    county_fips: 22001,
    county_name: "Acadia",
    county_weights: {
      22001: 52.5,
      22039: 21.14,
      22097: 26.36,
    },
    county_names_all: "Acadia|St. Landry|Evangeline",
    county_fips_all: "22001|22097|22039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70537,
    lat: 30.25747,
    lng: -92.56642,
    city: "Evangeline",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 387,
    density: 25.5,
    county_fips: 22001,
    county_name: "Acadia",
    county_weights: {
      22001: 100,
    },
    county_names_all: "Acadia",
    county_fips_all: 22001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70538,
    lat: 29.74051,
    lng: -91.54092,
    city: "Franklin",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14228,
    density: 23.9,
    county_fips: 22101,
    county_name: "St. Mary",
    county_weights: {
      22101: 100,
    },
    county_names_all: "St. Mary",
    county_fips_all: 22101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70541,
    lat: 30.42062,
    lng: -92.0426,
    city: "Grand Coteau",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 376,
    density: 70.7,
    county_fips: 22097,
    county_name: "St. Landry",
    county_weights: {
      22097: 100,
    },
    county_names_all: "St. Landry",
    county_fips_all: 22097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70542,
    lat: 30.00442,
    lng: -92.5886,
    city: "Gueydan",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3958,
    density: 8,
    county_fips: 22113,
    county_name: "Vermilion",
    county_weights: {
      22023: 31.27,
      22113: 68.73,
    },
    county_names_all: "Vermilion|Cameron",
    county_fips_all: "22113|22023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70543,
    lat: 30.33532,
    lng: -92.5014,
    city: "Iota",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4738,
    density: 25.6,
    county_fips: 22001,
    county_name: "Acadia",
    county_weights: {
      22001: 100,
    },
    county_names_all: "Acadia",
    county_fips_all: 22001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70544,
    lat: 29.9059,
    lng: -91.6575,
    city: "Jeanerette",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10990,
    density: 41.3,
    county_fips: 22045,
    county_name: "Iberia",
    county_weights: {
      22045: 52.48,
      22101: 47.52,
    },
    county_names_all: "Iberia|St. Mary",
    county_fips_all: "22045|22101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70546,
    lat: 30.26756,
    lng: -92.66747,
    city: "Jennings",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16752,
    density: 42.4,
    county_fips: 22053,
    county_name: "Jefferson Davis",
    county_weights: {
      22001: 11.36,
      22053: 88.64,
    },
    county_names_all: "Jefferson Davis|Acadia",
    county_fips_all: "22053|22001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70548,
    lat: 29.79733,
    lng: -92.41875,
    city: "Kaplan",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10199,
    density: 7.7,
    county_fips: 22113,
    county_name: "Vermilion",
    county_weights: {
      22113: 100,
    },
    county_names_all: "Vermilion",
    county_fips_all: 22113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70549,
    lat: 30.04988,
    lng: -92.83139,
    city: "Lake Arthur",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3449,
    density: 8.3,
    county_fips: 22053,
    county_name: "Jefferson Davis",
    county_weights: {
      22019: 0.38,
      22023: 39.37,
      22053: 60.25,
    },
    county_names_all: "Jefferson Davis|Cameron|Calcasieu",
    county_fips_all: "22053|22023|22019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70550,
    lat: 30.5157,
    lng: -92.18966,
    city: "Lawtell",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 22097,
    county_name: "St. Landry",
    county_weights: {
      22097: 100,
    },
    county_names_all: "St. Landry",
    county_fips_all: 22097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70551,
    lat: 30.46675,
    lng: -91.98028,
    city: "Leonville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 22097,
    county_name: "St. Landry",
    county_weights: {
      22097: 100,
    },
    county_names_all: "St. Landry",
    county_fips_all: 22097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70552,
    lat: 30.0617,
    lng: -91.66641,
    city: "Loreauville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1544,
    density: 30.6,
    county_fips: 22045,
    county_name: "Iberia",
    county_weights: {
      22045: 100,
    },
    county_names_all: "Iberia",
    county_fips_all: 22045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70554,
    lat: 30.63633,
    lng: -92.48885,
    city: "Mamou",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5611,
    density: 16.2,
    county_fips: 22039,
    county_name: "Evangeline",
    county_weights: {
      22039: 100,
    },
    county_names_all: "Evangeline",
    county_fips_all: 22039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70555,
    lat: 30.08188,
    lng: -92.14123,
    city: "Maurice",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8409,
    density: 68.8,
    county_fips: 22113,
    county_name: "Vermilion",
    county_weights: {
      22055: 2.93,
      22113: 97.07,
    },
    county_names_all: "Vermilion|Lafayette",
    county_fips_all: "22113|22055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70556,
    lat: 30.19072,
    lng: -92.58325,
    city: "Mermentau",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 362,
    density: 79,
    county_fips: 22001,
    county_name: "Acadia",
    county_weights: {
      22001: 100,
    },
    county_names_all: "Acadia",
    county_fips_all: 22001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70558,
    lat: 30.10042,
    lng: -92.07573,
    city: "Milton",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13,
    density: 42.2,
    county_fips: 22055,
    county_name: "Lafayette",
    county_weights: {
      22055: 100,
    },
    county_names_all: "Lafayette",
    county_fips_all: 22055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70559,
    lat: 30.12876,
    lng: -92.50903,
    city: "Morse",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3144,
    density: 14.2,
    county_fips: 22001,
    county_name: "Acadia",
    county_weights: {
      22001: 100,
    },
    county_names_all: "Acadia",
    county_fips_all: 22001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70560,
    lat: 29.93965,
    lng: -91.8642,
    city: "New Iberia",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39448,
    density: 86.5,
    county_fips: 22045,
    county_name: "Iberia",
    county_weights: {
      22045: 97.77,
      22055: 0.15,
      22099: 1.02,
      22113: 1.06,
    },
    county_names_all: "Iberia|Vermilion|St. Martin|Lafayette",
    county_fips_all: "22045|22113|22099|22055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70563,
    lat: 30.02454,
    lng: -91.73053,
    city: "New Iberia",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18381,
    density: 113.2,
    county_fips: 22045,
    county_name: "Iberia",
    county_weights: {
      22045: 100,
    },
    county_names_all: "Iberia",
    county_fips_all: 22045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70570,
    lat: 30.5315,
    lng: -92.10852,
    city: "Opelousas",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39184,
    density: 88.1,
    county_fips: 22097,
    county_name: "St. Landry",
    county_weights: {
      22097: 100,
    },
    county_names_all: "St. Landry",
    county_fips_all: 22097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70575,
    lat: 29.94892,
    lng: -92.15808,
    city: "Perry",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 22113,
    county_name: "Vermilion",
    county_weights: {
      22113: 100,
    },
    county_names_all: "Vermilion",
    county_fips_all: 22113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70576,
    lat: 30.78097,
    lng: -92.41826,
    city: "Pine Prairie",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1576,
    density: 541.1,
    county_fips: 22039,
    county_name: "Evangeline",
    county_weights: {
      22039: 100,
    },
    county_names_all: "Evangeline",
    county_fips_all: 22039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70577,
    lat: 30.54848,
    lng: -91.92018,
    city: "Port Barre",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3272,
    density: 16.6,
    county_fips: 22097,
    county_name: "St. Landry",
    county_weights: {
      22097: 100,
    },
    county_names_all: "St. Landry",
    county_fips_all: 22097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70578,
    lat: 30.2291,
    lng: -92.26261,
    city: "Rayne",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17727,
    density: 59.6,
    county_fips: 22001,
    county_name: "Acadia",
    county_weights: {
      22001: 67.9,
      22055: 18.19,
      22113: 13.91,
    },
    county_names_all: "Acadia|Lafayette|Vermilion",
    county_fips_all: "22001|22055|22113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70580,
    lat: 30.67551,
    lng: -92.4284,
    city: "Reddell",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 160,
    density: 440.7,
    county_fips: 22039,
    county_name: "Evangeline",
    county_weights: {
      22039: 100,
    },
    county_names_all: "Evangeline",
    county_fips_all: 22039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70581,
    lat: 30.25496,
    lng: -92.73588,
    city: "Roanoke",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 918,
    density: 13.9,
    county_fips: 22053,
    county_name: "Jefferson Davis",
    county_weights: {
      22053: 100,
    },
    county_names_all: "Jefferson Davis",
    county_fips_all: 22053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70582,
    lat: 30.15961,
    lng: -91.7854,
    city: "Saint Martinville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19806,
    density: 51.7,
    county_fips: 22099,
    county_name: "St. Martin",
    county_weights: {
      22045: 5.41,
      22099: 94.59,
    },
    county_names_all: "St. Martin|Iberia",
    county_fips_all: "22099|22045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70583,
    lat: 30.25846,
    lng: -92.12204,
    city: "Scott",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11072,
    density: 150.7,
    county_fips: 22055,
    county_name: "Lafayette",
    county_weights: {
      22001: 14.5,
      22055: 85.5,
    },
    county_names_all: "Lafayette|Acadia",
    county_fips_all: "22055|22001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70584,
    lat: 30.38856,
    lng: -92.10193,
    city: "Sunset",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7051,
    density: 78.6,
    county_fips: 22097,
    county_name: "St. Landry",
    county_weights: {
      22097: 100,
    },
    county_names_all: "St. Landry",
    county_fips_all: 22097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70585,
    lat: 30.87832,
    lng: -92.4077,
    city: "Turkey Creek",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 340,
    density: 218.4,
    county_fips: 22039,
    county_name: "Evangeline",
    county_weights: {
      22039: 100,
    },
    county_names_all: "Evangeline",
    county_fips_all: 22039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70586,
    lat: 30.74504,
    lng: -92.34151,
    city: "Ville Platte",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19374,
    density: 24.1,
    county_fips: 22039,
    county_name: "Evangeline",
    county_weights: {
      22039: 98.31,
      22097: 1.69,
    },
    county_names_all: "Evangeline|St. Landry",
    county_fips_all: "22039|22097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70589,
    lat: 30.68584,
    lng: -92.04098,
    city: "Washington",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2675,
    density: 8.7,
    county_fips: 22097,
    county_name: "St. Landry",
    county_weights: {
      22039: 2.99,
      22097: 97.01,
    },
    county_names_all: "St. Landry|Evangeline",
    county_fips_all: "22097|22039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70591,
    lat: 30.25604,
    lng: -92.8397,
    city: "Welsh",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4929,
    density: 11.1,
    county_fips: 22053,
    county_name: "Jefferson Davis",
    county_weights: {
      22053: 100,
    },
    county_names_all: "Jefferson Davis",
    county_fips_all: 22053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70592,
    lat: 30.08024,
    lng: -92.01338,
    city: "Youngsville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26442,
    density: 240.3,
    county_fips: 22055,
    county_name: "Lafayette",
    county_weights: {
      22045: 1.9,
      22055: 74.36,
      22113: 23.74,
    },
    county_names_all: "Lafayette|Vermilion|Iberia",
    county_fips_all: "22055|22113|22045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70601,
    lat: 30.22627,
    lng: -93.21525,
    city: "Lake Charles",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31831,
    density: 762.5,
    county_fips: 22019,
    county_name: "Calcasieu",
    county_weights: {
      22019: 100,
    },
    county_names_all: "Calcasieu",
    county_fips_all: 22019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70605,
    lat: 30.13048,
    lng: -93.27418,
    city: "Lake Charles",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38280,
    density: 344,
    county_fips: 22019,
    county_name: "Calcasieu",
    county_weights: {
      22019: 100,
    },
    county_names_all: "Calcasieu",
    county_fips_all: 22019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70607,
    lat: 30.04982,
    lng: -93.20606,
    city: "Lake Charles",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29157,
    density: 97.6,
    county_fips: 22023,
    county_name: "Cameron",
    county_weights: {
      22019: 46.73,
      22023: 53.27,
    },
    county_names_all: "Cameron|Calcasieu",
    county_fips_all: "22023|22019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70609,
    lat: 30.17907,
    lng: -93.21482,
    city: "Lake Charles",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 22019,
    county_name: "Calcasieu",
    county_weights: {
      22019: 100,
    },
    county_names_all: "Calcasieu",
    county_fips_all: 22019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70611,
    lat: 30.34594,
    lng: -93.20156,
    city: "Lake Charles",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19132,
    density: 90.4,
    county_fips: 22019,
    county_name: "Calcasieu",
    county_weights: {
      22019: 100,
    },
    county_names_all: "Calcasieu",
    county_fips_all: 22019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70615,
    lat: 30.25609,
    lng: -93.12346,
    city: "Lake Charles",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13473,
    density: 113.2,
    county_fips: 22019,
    county_name: "Calcasieu",
    county_weights: {
      22019: 100,
    },
    county_names_all: "Calcasieu",
    county_fips_all: 22019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70629,
    lat: 30.23107,
    lng: -93.21864,
    city: "Lake Charles",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 22019,
    county_name: "Calcasieu",
    county_weights: {
      22019: 100,
    },
    county_names_all: "Calcasieu",
    county_fips_all: 22019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70630,
    lat: 30.02723,
    lng: -93.04966,
    city: "Bell City",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2504,
    density: 7,
    county_fips: 22023,
    county_name: "Cameron",
    county_weights: {
      22019: 40.72,
      22023: 59.28,
    },
    county_names_all: "Cameron|Calcasieu",
    county_fips_all: "22023|22019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70631,
    lat: 29.86692,
    lng: -93.55404,
    city: "Cameron",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 457,
    density: 0.4,
    county_fips: 22023,
    county_name: "Cameron",
    county_weights: {
      22023: 100,
    },
    county_names_all: "Cameron",
    county_fips_all: 22023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70632,
    lat: 29.86747,
    lng: -92.87987,
    city: "Creole",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 465,
    density: 1,
    county_fips: 22023,
    county_name: "Cameron",
    county_weights: {
      22023: 100,
    },
    county_names_all: "Cameron",
    county_fips_all: 22023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70633,
    lat: 30.42762,
    lng: -93.3925,
    city: "Dequincy",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8506,
    density: 18.4,
    county_fips: 22019,
    county_name: "Calcasieu",
    county_weights: {
      22011: 41.59,
      22019: 58.41,
    },
    county_names_all: "Calcasieu|Beauregard",
    county_fips_all: "22019|22011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70634,
    lat: 30.80142,
    lng: -93.24309,
    city: "Deridder",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28024,
    density: 24.3,
    county_fips: 22011,
    county_name: "Beauregard",
    county_weights: {
      22011: 79.65,
      22115: 20.35,
    },
    county_names_all: "Beauregard|Vernon",
    county_fips_all: "22011|22115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70637,
    lat: 30.70508,
    lng: -92.97207,
    city: "Dry Creek",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 920,
    density: 8.3,
    county_fips: 22003,
    county_name: "Allen",
    county_weights: {
      22003: 51.83,
      22011: 48.17,
    },
    county_names_all: "Allen|Beauregard",
    county_fips_all: "22003|22011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70638,
    lat: 30.84948,
    lng: -92.78436,
    city: "Elizabeth",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1322,
    density: 14.9,
    county_fips: 22003,
    county_name: "Allen",
    county_weights: {
      22003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 22003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70639,
    lat: 30.98235,
    lng: -93.49793,
    city: "Evans",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 300,
    density: 1.8,
    county_fips: 22115,
    county_name: "Vernon",
    county_weights: {
      22115: 100,
    },
    county_names_all: "Vernon",
    county_fips_all: 22115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70640,
    lat: 30.36587,
    lng: -92.91652,
    city: "Fenton",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 259,
    density: 470.2,
    county_fips: 22053,
    county_name: "Jefferson Davis",
    county_weights: {
      22053: 100,
    },
    county_names_all: "Jefferson Davis",
    county_fips_all: 22053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70643,
    lat: 29.73649,
    lng: -92.7939,
    city: "Grand Chenier",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 313,
    density: 0.5,
    county_fips: 22023,
    county_name: "Cameron",
    county_weights: {
      22023: 100,
    },
    county_names_all: "Cameron",
    county_fips_all: 22023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70644,
    lat: 30.79078,
    lng: -92.94924,
    city: "Grant",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 582,
    density: 20.4,
    county_fips: 22003,
    county_name: "Allen",
    county_weights: {
      22003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 22003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70645,
    lat: 29.96154,
    lng: -93.40854,
    city: "Hackberry",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1315,
    density: 4.7,
    county_fips: 22023,
    county_name: "Cameron",
    county_weights: {
      22023: 100,
    },
    county_names_all: "Cameron",
    county_fips_all: 22023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70646,
    lat: 30.10767,
    lng: -92.92938,
    city: "Hayes",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 623,
    density: 24.7,
    county_fips: 22019,
    county_name: "Calcasieu",
    county_weights: {
      22019: 100,
    },
    county_names_all: "Calcasieu",
    county_fips_all: 22019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70647,
    lat: 30.24752,
    lng: -93.01605,
    city: "Iowa",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10153,
    density: 21.9,
    county_fips: 22019,
    county_name: "Calcasieu",
    county_weights: {
      22019: 51.86,
      22053: 48.14,
    },
    county_names_all: "Calcasieu|Jefferson Davis",
    county_fips_all: "22019|22053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70648,
    lat: 30.50568,
    lng: -92.88387,
    city: "Kinder",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8587,
    density: 15.7,
    county_fips: 22003,
    county_name: "Allen",
    county_weights: {
      22003: 72.6,
      22053: 27.4,
    },
    county_names_all: "Allen|Jefferson Davis",
    county_fips_all: "22003|22053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70650,
    lat: 30.23376,
    lng: -92.92067,
    city: "Lacassine",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57,
    density: 13,
    county_fips: 22053,
    county_name: "Jefferson Davis",
    county_weights: {
      22053: 100,
    },
    county_names_all: "Jefferson Davis",
    county_fips_all: 22053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70651,
    lat: 30.54333,
    lng: -92.95127,
    city: "Leblanc",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 238,
    density: 3.4,
    county_fips: 22003,
    county_name: "Allen",
    county_weights: {
      22003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 22003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70652,
    lat: 30.60547,
    lng: -93.24646,
    city: "Longville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1465,
    density: 5.3,
    county_fips: 22011,
    county_name: "Beauregard",
    county_weights: {
      22011: 100,
    },
    county_names_all: "Beauregard",
    county_fips_all: 22011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70653,
    lat: 30.66744,
    lng: -93.55994,
    city: "Merryville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3467,
    density: 5,
    county_fips: 22011,
    county_name: "Beauregard",
    county_weights: {
      22011: 100,
    },
    county_names_all: "Beauregard",
    county_fips_all: 22011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70654,
    lat: 30.69212,
    lng: -92.88075,
    city: "Mittie",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 185,
    density: 3,
    county_fips: 22003,
    county_name: "Allen",
    county_weights: {
      22003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 22003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70655,
    lat: 30.63022,
    lng: -92.70234,
    city: "Oberlin",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2960,
    density: 9.2,
    county_fips: 22003,
    county_name: "Allen",
    county_weights: {
      22003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 22003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70656,
    lat: 30.91647,
    lng: -92.94272,
    city: "Pitkin",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3169,
    density: 3.9,
    county_fips: 22115,
    county_name: "Vernon",
    county_weights: {
      22003: 23.54,
      22079: 12.5,
      22115: 63.96,
    },
    county_names_all: "Vernon|Allen|Rapides",
    county_fips_all: "22115|22003|22079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70657,
    lat: 30.5004,
    lng: -93.14279,
    city: "Ragley",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4300,
    density: 10.5,
    county_fips: 22011,
    county_name: "Beauregard",
    county_weights: {
      22003: 25.24,
      22011: 67.06,
      22019: 0.3,
      22053: 7.4,
    },
    county_names_all: "Beauregard|Allen|Jefferson Davis|Calcasieu",
    county_fips_all: "22011|22003|22053|22019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70658,
    lat: 30.52324,
    lng: -93.03297,
    city: "Reeves",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 858,
    density: 5.1,
    county_fips: 22003,
    county_name: "Allen",
    county_weights: {
      22003: 100,
    },
    county_names_all: "Allen",
    county_fips_all: 22003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70659,
    lat: 30.92161,
    lng: -93.284,
    city: "Rosepine",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1413,
    density: 244.6,
    county_fips: 22115,
    county_name: "Vernon",
    county_weights: {
      22115: 100,
    },
    county_names_all: "Vernon",
    county_fips_all: 22115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70660,
    lat: 30.575,
    lng: -93.44478,
    city: "Singer",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2243,
    density: 6,
    county_fips: 22011,
    county_name: "Beauregard",
    county_weights: {
      22011: 100,
    },
    county_names_all: "Beauregard",
    county_fips_all: 22011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70661,
    lat: 30.36683,
    lng: -93.64833,
    city: "Starks",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1450,
    density: 3,
    county_fips: 22019,
    county_name: "Calcasieu",
    county_weights: {
      22011: 31.49,
      22019: 68.51,
    },
    county_names_all: "Calcasieu|Beauregard",
    county_fips_all: "22019|22011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70662,
    lat: 30.80072,
    lng: -92.99834,
    city: "Sugartown",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 199,
    density: 2.7,
    county_fips: 22011,
    county_name: "Beauregard",
    county_weights: {
      22003: 5.26,
      22011: 94.74,
    },
    county_names_all: "Beauregard|Allen",
    county_fips_all: "22011|22003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70663,
    lat: 30.2772,
    lng: -93.39086,
    city: "Sulphur",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28475,
    density: 112.4,
    county_fips: 22019,
    county_name: "Calcasieu",
    county_weights: {
      22019: 100,
    },
    county_names_all: "Calcasieu",
    county_fips_all: 22019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70665,
    lat: 30.12756,
    lng: -93.44555,
    city: "Sulphur",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12343,
    density: 31.1,
    county_fips: 22019,
    county_name: "Calcasieu",
    county_weights: {
      22019: 100,
    },
    county_names_all: "Calcasieu",
    county_fips_all: 22019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70668,
    lat: 30.17678,
    lng: -93.60488,
    city: "Vinton",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7019,
    density: 19.2,
    county_fips: 22019,
    county_name: "Calcasieu",
    county_weights: {
      22019: 100,
    },
    county_names_all: "Calcasieu",
    county_fips_all: 22019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70669,
    lat: 30.24216,
    lng: -93.27731,
    city: "Westlake",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9800,
    density: 129.5,
    county_fips: 22019,
    county_name: "Calcasieu",
    county_weights: {
      22019: 100,
    },
    county_names_all: "Calcasieu",
    county_fips_all: 22019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70706,
    lat: 30.61453,
    lng: -90.90086,
    city: "Denham Springs",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23426,
    density: 171,
    county_fips: 22063,
    county_name: "Livingston",
    county_weights: {
      22063: 72.86,
      22091: 27.14,
    },
    county_names_all: "Livingston|St. Helena",
    county_fips_all: "22063|22091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70710,
    lat: 30.3559,
    lng: -91.26773,
    city: "Addis",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5635,
    density: 271.6,
    county_fips: 22121,
    county_name: "West Baton Rouge",
    county_weights: {
      22121: 100,
    },
    county_names_all: "West Baton Rouge",
    county_fips_all: 22121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70711,
    lat: 30.53065,
    lng: -90.60229,
    city: "Albany",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5612,
    density: 117.9,
    county_fips: 22063,
    county_name: "Livingston",
    county_weights: {
      22063: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 22063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70712,
    lat: 30.96574,
    lng: -91.58573,
    city: "Angola",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3804,
    density: 71.4,
    county_fips: 22125,
    county_name: "West Feliciana",
    county_weights: {
      22125: 100,
    },
    county_names_all: "West Feliciana",
    county_fips_all: 22125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70714,
    lat: 30.58634,
    lng: -91.12812,
    city: "Baker",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18775,
    density: 209.4,
    county_fips: 22033,
    county_name: "East Baton Rouge",
    county_weights: {
      22033: 100,
    },
    county_names_all: "East Baton Rouge",
    county_fips_all: 22033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70715,
    lat: 30.81204,
    lng: -91.66262,
    city: "Batchelor",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1480,
    density: 4.5,
    county_fips: 22077,
    county_name: "Pointe Coupee",
    county_weights: {
      22077: 100,
    },
    county_names_all: "Pointe Coupee",
    county_fips_all: 22077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70719,
    lat: 30.37734,
    lng: -91.29077,
    city: "Brusly",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4047,
    density: 100.5,
    county_fips: 22121,
    county_name: "West Baton Rouge",
    county_weights: {
      22121: 100,
    },
    county_names_all: "West Baton Rouge",
    county_fips_all: 22121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70721,
    lat: 30.21639,
    lng: -91.09301,
    city: "Carville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 503,
    density: 54.3,
    county_fips: 22047,
    county_name: "Iberville",
    county_weights: {
      22047: 100,
    },
    county_names_all: "Iberville",
    county_fips_all: 22047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70722,
    lat: 30.84337,
    lng: -90.93244,
    city: "Clinton",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5154,
    density: 11.8,
    county_fips: 22037,
    county_name: "East Feliciana",
    county_weights: {
      22033: 3.75,
      22037: 96.25,
    },
    county_names_all: "East Feliciana|East Baton Rouge",
    county_fips_all: "22037|22033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70723,
    lat: 30.06379,
    lng: -90.84111,
    city: "Convent",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1306,
    density: 15.9,
    county_fips: 22093,
    county_name: "St. James",
    county_weights: {
      22093: 100,
    },
    county_names_all: "St. James",
    county_fips_all: 22093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70725,
    lat: 30.13652,
    lng: -90.97255,
    city: "Darrow",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1764,
    density: 79.2,
    county_fips: 22005,
    county_name: "Ascension",
    county_weights: {
      22005: 100,
    },
    county_names_all: "Ascension",
    county_fips_all: 22005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70726,
    lat: 30.42994,
    lng: -90.90361,
    city: "Denham Springs",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57561,
    density: 252,
    county_fips: 22063,
    county_name: "Livingston",
    county_weights: {
      22063: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 22063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70729,
    lat: 30.58891,
    lng: -91.34671,
    city: "Erwinville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1083,
    density: 24.2,
    county_fips: 22121,
    county_name: "West Baton Rouge",
    county_weights: {
      22077: 22.18,
      22121: 77.82,
    },
    county_names_all: "West Baton Rouge|Pointe Coupee",
    county_fips_all: "22121|22077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70730,
    lat: 30.81588,
    lng: -91.10869,
    city: "Ethel",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2789,
    density: 14.9,
    county_fips: 22037,
    county_name: "East Feliciana",
    county_weights: {
      22037: 100,
    },
    county_names_all: "East Feliciana",
    county_fips_all: 22037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70732,
    lat: 30.6322,
    lng: -91.60678,
    city: "Fordoche",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1235,
    density: 11,
    county_fips: 22077,
    county_name: "Pointe Coupee",
    county_weights: {
      22077: 100,
    },
    county_names_all: "Pointe Coupee",
    county_fips_all: 22077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70733,
    lat: 30.30437,
    lng: -90.79487,
    city: "French Settlement",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1165,
    density: 40.3,
    county_fips: 22063,
    county_name: "Livingston",
    county_weights: {
      22063: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 22063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70734,
    lat: 30.20812,
    lng: -91.00095,
    city: "Geismar",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8869,
    density: 123.4,
    county_fips: 22005,
    county_name: "Ascension",
    county_weights: {
      22005: 100,
    },
    county_names_all: "Ascension",
    county_fips_all: 22005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70736,
    lat: 30.63748,
    lng: -91.33915,
    city: "Glynn",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 808,
    density: 54.7,
    county_fips: 22077,
    county_name: "Pointe Coupee",
    county_weights: {
      22077: 100,
    },
    county_names_all: "Pointe Coupee",
    county_fips_all: 22077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70737,
    lat: 30.22587,
    lng: -90.92271,
    city: "Gonzales",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44744,
    density: 320,
    county_fips: 22005,
    county_name: "Ascension",
    county_weights: {
      22005: 100,
    },
    county_names_all: "Ascension",
    county_fips_all: 22005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70739,
    lat: 30.60107,
    lng: -90.9684,
    city: "Greenwell Springs",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13922,
    density: 113.5,
    county_fips: 22033,
    county_name: "East Baton Rouge",
    county_weights: {
      22033: 100,
    },
    county_names_all: "East Baton Rouge",
    county_fips_all: 22033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70740,
    lat: 30.33777,
    lng: -91.43311,
    city: "Grosse Tete",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1556,
    density: 7.1,
    county_fips: 22047,
    county_name: "Iberville",
    county_weights: {
      22047: 100,
    },
    county_names_all: "Iberville",
    county_fips_all: 22047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70743,
    lat: 30.02655,
    lng: -90.7729,
    city: "Hester",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 383,
    density: 50.8,
    county_fips: 22093,
    county_name: "St. James",
    county_weights: {
      22093: 100,
    },
    county_names_all: "St. James",
    county_fips_all: 22093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70744,
    lat: 30.56173,
    lng: -90.67689,
    city: "Holden",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7202,
    density: 27,
    county_fips: 22063,
    county_name: "Livingston",
    county_weights: {
      22063: 85.35,
      22091: 14.65,
    },
    county_names_all: "Livingston|St. Helena",
    county_fips_all: "22063|22091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70747,
    lat: 30.87291,
    lng: -91.68245,
    city: "Innis",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 215,
    density: 15.3,
    county_fips: 22077,
    county_name: "Pointe Coupee",
    county_weights: {
      22077: 100,
    },
    county_names_all: "Pointe Coupee",
    county_fips_all: 22077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70748,
    lat: 30.8164,
    lng: -91.20613,
    city: "Jackson",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7531,
    density: 39.2,
    county_fips: 22037,
    county_name: "East Feliciana",
    county_weights: {
      22033: 1.25,
      22037: 98.75,
    },
    county_names_all: "East Feliciana|East Baton Rouge",
    county_fips_all: "22037|22033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70749,
    lat: 30.6326,
    lng: -91.40985,
    city: "Jarreau",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1323,
    density: 37.4,
    county_fips: 22077,
    county_name: "Pointe Coupee",
    county_weights: {
      22077: 100,
    },
    county_names_all: "Pointe Coupee",
    county_fips_all: 22077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70750,
    lat: 30.46433,
    lng: -91.7865,
    city: "Krotz Springs",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1403,
    density: 8.1,
    county_fips: 22097,
    county_name: "St. Landry",
    county_weights: {
      22097: 100,
    },
    county_names_all: "St. Landry",
    county_fips_all: 22097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70752,
    lat: 30.57986,
    lng: -91.41915,
    city: "Lakeland",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 791,
    density: 52.2,
    county_fips: 22077,
    county_name: "Pointe Coupee",
    county_weights: {
      22077: 100,
    },
    county_names_all: "Pointe Coupee",
    county_fips_all: 22077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70753,
    lat: 30.7999,
    lng: -91.72106,
    city: "Lettsworth",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 944,
    density: 2.9,
    county_fips: 22077,
    county_name: "Pointe Coupee",
    county_weights: {
      22077: 100,
    },
    county_names_all: "Pointe Coupee",
    county_fips_all: 22077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70754,
    lat: 30.40542,
    lng: -90.74462,
    city: "Livingston",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12485,
    density: 37.9,
    county_fips: 22063,
    county_name: "Livingston",
    county_weights: {
      22063: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 22063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70755,
    lat: 30.59473,
    lng: -91.52981,
    city: "Livonia",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1683,
    density: 29.6,
    county_fips: 22077,
    county_name: "Pointe Coupee",
    county_weights: {
      22077: 100,
    },
    county_names_all: "Pointe Coupee",
    county_fips_all: 22077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70756,
    lat: 30.53256,
    lng: -91.64705,
    city: "Lottie",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 526,
    density: 4.1,
    county_fips: 22077,
    county_name: "Pointe Coupee",
    county_weights: {
      22077: 100,
    },
    county_names_all: "Pointe Coupee",
    county_fips_all: 22077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70757,
    lat: 30.37204,
    lng: -91.53468,
    city: "Maringouin",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2246,
    density: 8.2,
    county_fips: 22047,
    county_name: "Iberville",
    county_weights: {
      22047: 82.48,
      22077: 17.52,
    },
    county_names_all: "Iberville|Pointe Coupee",
    county_fips_all: "22047|22077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70759,
    lat: 30.71346,
    lng: -91.58762,
    city: "Morganza",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1468,
    density: 23.7,
    county_fips: 22077,
    county_name: "Pointe Coupee",
    county_weights: {
      22077: 100,
    },
    county_names_all: "Pointe Coupee",
    county_fips_all: 22077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70760,
    lat: 30.69839,
    lng: -91.48085,
    city: "New Roads",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6587,
    density: 51.2,
    county_fips: 22077,
    county_name: "Pointe Coupee",
    county_weights: {
      22077: 100,
    },
    county_names_all: "Pointe Coupee",
    county_fips_all: 22077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70761,
    lat: 30.97429,
    lng: -91.03129,
    city: "Norwood",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 370,
    density: 2.2,
    county_fips: 22037,
    county_name: "East Feliciana",
    county_weights: {
      22037: 100,
    },
    county_names_all: "East Feliciana",
    county_fips_all: 22037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70762,
    lat: 30.57843,
    lng: -91.46695,
    city: "Oscar",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 855,
    density: 16.1,
    county_fips: 22077,
    county_name: "Pointe Coupee",
    county_weights: {
      22077: 100,
    },
    county_names_all: "Pointe Coupee",
    county_fips_all: 22077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70763,
    lat: 30.04929,
    lng: -90.73736,
    city: "Paulina",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4774,
    density: 124.2,
    county_fips: 22093,
    county_name: "St. James",
    county_weights: {
      22093: 100,
    },
    county_names_all: "St. James",
    county_fips_all: 22093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70764,
    lat: 30.22505,
    lng: -91.30656,
    city: "Plaquemine",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16667,
    density: 34.1,
    county_fips: 22047,
    county_name: "Iberville",
    county_weights: {
      22047: 94.1,
      22121: 5.9,
    },
    county_names_all: "Iberville|West Baton Rouge",
    county_fips_all: "22047|22121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70767,
    lat: 30.47737,
    lng: -91.32787,
    city: "Port Allen",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15675,
    density: 39.7,
    county_fips: 22121,
    county_name: "West Baton Rouge",
    county_weights: {
      22077: 3.88,
      22121: 96.12,
    },
    county_names_all: "West Baton Rouge|Pointe Coupee",
    county_fips_all: "22121|22077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70769,
    lat: 30.30802,
    lng: -90.93967,
    city: "Prairieville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46186,
    density: 372.5,
    county_fips: 22005,
    county_name: "Ascension",
    county_weights: {
      22005: 99.64,
      22063: 0.36,
    },
    county_names_all: "Ascension|Livingston",
    county_fips_all: "22005|22063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70770,
    lat: 30.65134,
    lng: -90.99316,
    city: "Pride",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2900,
    density: 52.6,
    county_fips: 22033,
    county_name: "East Baton Rouge",
    county_weights: {
      22033: 100,
    },
    county_names_all: "East Baton Rouge",
    county_fips_all: 22033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70772,
    lat: 30.43748,
    lng: -91.46484,
    city: "Rosedale",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 869,
    density: 22.5,
    county_fips: 22047,
    county_name: "Iberville",
    county_weights: {
      22047: 100,
    },
    county_names_all: "Iberville",
    county_fips_all: 22047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70773,
    lat: 30.59678,
    lng: -91.37333,
    city: "Rougon",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 225,
    density: 13.4,
    county_fips: 22077,
    county_name: "Pointe Coupee",
    county_weights: {
      22077: 100,
    },
    county_names_all: "Pointe Coupee",
    county_fips_all: 22077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70774,
    lat: 30.22741,
    lng: -90.78815,
    city: "Saint Amant",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10206,
    density: 75,
    county_fips: 22005,
    county_name: "Ascension",
    county_weights: {
      22005: 80.24,
      22063: 19.76,
    },
    county_names_all: "Ascension|Livingston",
    county_fips_all: "22005|22063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70775,
    lat: 30.85982,
    lng: -91.36847,
    city: "Saint Francisville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11120,
    density: 13.7,
    county_fips: 22125,
    county_name: "West Feliciana",
    county_weights: {
      22037: 0.16,
      22125: 99.84,
    },
    county_names_all: "West Feliciana|East Feliciana",
    county_fips_all: "22125|22037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70776,
    lat: 30.26051,
    lng: -91.08923,
    city: "Saint Gabriel",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6316,
    density: 69.8,
    county_fips: 22047,
    county_name: "Iberville",
    county_weights: {
      22047: 100,
    },
    county_names_all: "Iberville",
    county_fips_all: 22047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70777,
    lat: 30.73898,
    lng: -91.07319,
    city: "Slaughter",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3681,
    density: 21.8,
    county_fips: 22037,
    county_name: "East Feliciana",
    county_weights: {
      22033: 12.59,
      22037: 87.41,
    },
    county_names_all: "East Feliciana|East Baton Rouge",
    county_fips_all: "22037|22033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70778,
    lat: 30.16085,
    lng: -90.81777,
    city: "Sorrento",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2858,
    density: 24.1,
    county_fips: 22005,
    county_name: "Ascension",
    county_weights: {
      22005: 100,
    },
    county_names_all: "Ascension",
    county_fips_all: 22005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70780,
    lat: 30.29538,
    lng: -91.16993,
    city: "Sunshine",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1403,
    density: 42.8,
    county_fips: 22047,
    county_name: "Iberville",
    county_weights: {
      22047: 100,
    },
    county_names_all: "Iberville",
    county_fips_all: 22047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70782,
    lat: 30.94378,
    lng: -91.51856,
    city: "Tunica",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 103,
    density: 1.5,
    county_fips: 22125,
    county_name: "West Feliciana",
    county_weights: {
      22125: 100,
    },
    county_names_all: "West Feliciana",
    county_fips_all: 22125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70783,
    lat: 30.67032,
    lng: -91.4087,
    city: "Ventress",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2500,
    density: 33.4,
    county_fips: 22077,
    county_name: "Pointe Coupee",
    county_weights: {
      22077: 100,
    },
    county_names_all: "Pointe Coupee",
    county_fips_all: 22077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70785,
    lat: 30.55621,
    lng: -90.81858,
    city: "Walker",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22474,
    density: 93,
    county_fips: 22063,
    county_name: "Livingston",
    county_weights: {
      22063: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 22063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70786,
    lat: 30.58236,
    lng: -90.95429,
    city: "Watson",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 22063,
    county_name: "Livingston",
    county_weights: {
      22063: 100,
    },
    county_names_all: "Livingston",
    county_fips_all: 22063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70787,
    lat: 30.9629,
    lng: -91.44342,
    city: "Weyanoke",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 287,
    density: 22.9,
    county_fips: 22125,
    county_name: "West Feliciana",
    county_weights: {
      22125: 100,
    },
    county_names_all: "West Feliciana",
    county_fips_all: 22125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70788,
    lat: 30.13618,
    lng: -91.17939,
    city: "White Castle",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4264,
    density: 14.7,
    county_fips: 22047,
    county_name: "Iberville",
    county_weights: {
      22047: 100,
    },
    county_names_all: "Iberville",
    county_fips_all: 22047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70789,
    lat: 30.92973,
    lng: -91.07109,
    city: "Wilson",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 624,
    density: 12.8,
    county_fips: 22037,
    county_name: "East Feliciana",
    county_weights: {
      22037: 100,
    },
    county_names_all: "East Feliciana",
    county_fips_all: 22037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70791,
    lat: 30.65013,
    lng: -91.15734,
    city: "Zachary",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27365,
    density: 88.7,
    county_fips: 22033,
    county_name: "East Baton Rouge",
    county_weights: {
      22033: 96.46,
      22037: 3.54,
    },
    county_names_all: "East Baton Rouge|East Feliciana",
    county_fips_all: "22033|22037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70801,
    lat: 30.44954,
    lng: -91.18608,
    city: "Baton Rouge",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 362,
    density: 1304.3,
    county_fips: 22033,
    county_name: "East Baton Rouge",
    county_weights: {
      22033: 100,
    },
    county_names_all: "East Baton Rouge",
    county_fips_all: 22033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70802,
    lat: 30.44691,
    lng: -91.17554,
    city: "Baton Rouge",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23295,
    density: 1272.1,
    county_fips: 22033,
    county_name: "East Baton Rouge",
    county_weights: {
      22033: 100,
    },
    county_names_all: "East Baton Rouge",
    county_fips_all: 22033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70803,
    lat: 30.41165,
    lng: -91.17783,
    city: "Baton Rouge",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1298,
    density: 2151.9,
    county_fips: 22033,
    county_name: "East Baton Rouge",
    county_weights: {
      22033: 100,
    },
    county_names_all: "East Baton Rouge",
    county_fips_all: 22033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70805,
    lat: 30.48831,
    lng: -91.15951,
    city: "Baton Rouge",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26263,
    density: 892.2,
    county_fips: 22033,
    county_name: "East Baton Rouge",
    county_weights: {
      22033: 100,
    },
    county_names_all: "East Baton Rouge",
    county_fips_all: 22033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70806,
    lat: 30.44879,
    lng: -91.1247,
    city: "Baton Rouge",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30180,
    density: 1307.5,
    county_fips: 22033,
    county_name: "East Baton Rouge",
    county_weights: {
      22033: 100,
    },
    county_names_all: "East Baton Rouge",
    county_fips_all: 22033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70807,
    lat: 30.5425,
    lng: -91.2068,
    city: "Baton Rouge",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17037,
    density: 260.1,
    county_fips: 22033,
    county_name: "East Baton Rouge",
    county_weights: {
      22033: 100,
    },
    county_names_all: "East Baton Rouge",
    county_fips_all: 22033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70808,
    lat: 30.4057,
    lng: -91.14236,
    city: "Baton Rouge",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36576,
    density: 1178.8,
    county_fips: 22033,
    county_name: "East Baton Rouge",
    county_weights: {
      22033: 100,
    },
    county_names_all: "East Baton Rouge",
    county_fips_all: 22033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70809,
    lat: 30.39408,
    lng: -91.07063,
    city: "Baton Rouge",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26306,
    density: 706.1,
    county_fips: 22033,
    county_name: "East Baton Rouge",
    county_weights: {
      22033: 100,
    },
    county_names_all: "East Baton Rouge",
    county_fips_all: 22033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70810,
    lat: 30.34637,
    lng: -91.07998,
    city: "Baton Rouge",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40179,
    density: 592,
    county_fips: 22033,
    county_name: "East Baton Rouge",
    county_weights: {
      22033: 100,
    },
    county_names_all: "East Baton Rouge",
    county_fips_all: 22033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70811,
    lat: 30.53122,
    lng: -91.11617,
    city: "Baton Rouge",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14127,
    density: 482.1,
    county_fips: 22033,
    county_name: "East Baton Rouge",
    county_weights: {
      22033: 100,
    },
    county_names_all: "East Baton Rouge",
    county_fips_all: 22033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70812,
    lat: 30.50018,
    lng: -91.11051,
    city: "Baton Rouge",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12341,
    density: 1062.8,
    county_fips: 22033,
    county_name: "East Baton Rouge",
    county_weights: {
      22033: 100,
    },
    county_names_all: "East Baton Rouge",
    county_fips_all: 22033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70813,
    lat: 30.52777,
    lng: -91.19742,
    city: "Baton Rouge",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 22033,
    county_name: "East Baton Rouge",
    county_weights: {
      22033: 100,
    },
    county_names_all: "East Baton Rouge",
    county_fips_all: 22033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70814,
    lat: 30.48502,
    lng: -91.06164,
    city: "Baton Rouge",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11646,
    density: 504.2,
    county_fips: 22033,
    county_name: "East Baton Rouge",
    county_weights: {
      22033: 100,
    },
    county_names_all: "East Baton Rouge",
    county_fips_all: 22033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70815,
    lat: 30.45537,
    lng: -91.06648,
    city: "Baton Rouge",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30124,
    density: 1230.4,
    county_fips: 22033,
    county_name: "East Baton Rouge",
    county_weights: {
      22033: 100,
    },
    county_names_all: "East Baton Rouge",
    county_fips_all: 22033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70816,
    lat: 30.4288,
    lng: -91.02144,
    city: "Baton Rouge",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41818,
    density: 991.8,
    county_fips: 22033,
    county_name: "East Baton Rouge",
    county_weights: {
      22033: 100,
    },
    county_names_all: "East Baton Rouge",
    county_fips_all: 22033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70817,
    lat: 30.37558,
    lng: -90.98026,
    city: "Baton Rouge",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34491,
    density: 524.7,
    county_fips: 22033,
    county_name: "East Baton Rouge",
    county_weights: {
      22033: 100,
    },
    county_names_all: "East Baton Rouge",
    county_fips_all: 22033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70818,
    lat: 30.54233,
    lng: -91.05006,
    city: "Baton Rouge",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10072,
    density: 263.5,
    county_fips: 22033,
    county_name: "East Baton Rouge",
    county_weights: {
      22033: 100,
    },
    county_names_all: "East Baton Rouge",
    county_fips_all: 22033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70819,
    lat: 30.47133,
    lng: -91.00748,
    city: "Baton Rouge",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4445,
    density: 373.7,
    county_fips: 22033,
    county_name: "East Baton Rouge",
    county_weights: {
      22033: 100,
    },
    county_names_all: "East Baton Rouge",
    county_fips_all: 22033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70820,
    lat: 30.36812,
    lng: -91.18279,
    city: "Baton Rouge",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18770,
    density: 352,
    county_fips: 22033,
    county_name: "East Baton Rouge",
    county_weights: {
      22033: 100,
    },
    county_names_all: "East Baton Rouge",
    county_fips_all: 22033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70825,
    lat: 30.45197,
    lng: -91.18776,
    city: "Baton Rouge",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 22033,
    county_name: "East Baton Rouge",
    county_weights: {
      22033: 100,
    },
    county_names_all: "East Baton Rouge",
    county_fips_all: 22033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 70836,
    lat: 30.38758,
    lng: -91.08357,
    city: "Baton Rouge",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 22033,
    county_name: "East Baton Rouge",
    county_weights: {
      22033: 100,
    },
    county_names_all: "East Baton Rouge",
    county_fips_all: 22033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71001,
    lat: 32.59188,
    lng: -92.90028,
    city: "Arcadia",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4036,
    density: 11.8,
    county_fips: 22013,
    county_name: "Bienville",
    county_weights: {
      22013: 44.98,
      22027: 30.67,
      22061: 24.36,
    },
    county_names_all: "Bienville|Claiborne|Lincoln",
    county_fips_all: "22013|22027|22061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71002,
    lat: 32.11675,
    lng: -93.116,
    city: "Ashland",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 22069,
    county_name: "Natchitoches",
    county_weights: {
      22069: 100,
    },
    county_names_all: "Natchitoches",
    county_fips_all: 22069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71003,
    lat: 32.62969,
    lng: -93.02787,
    city: "Athens",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1050,
    density: 6.4,
    county_fips: 22027,
    county_name: "Claiborne",
    county_weights: {
      22027: 100,
    },
    county_names_all: "Claiborne",
    county_fips_all: 22027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71004,
    lat: 32.74403,
    lng: -93.85843,
    city: "Belcher",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 564,
    density: 4.8,
    county_fips: 22017,
    county_name: "Caddo",
    county_weights: {
      22017: 100,
    },
    county_names_all: "Caddo",
    county_fips_all: 22017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71006,
    lat: 32.72871,
    lng: -93.63511,
    city: "Benton",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13582,
    density: 25.6,
    county_fips: 22015,
    county_name: "Bossier",
    county_weights: {
      22015: 100,
    },
    county_names_all: "Bossier",
    county_fips_all: 22015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71007,
    lat: 32.36854,
    lng: -94.00502,
    city: "Bethany",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1268,
    density: 25.8,
    county_fips: 22017,
    county_name: "Caddo",
    county_weights: {
      22017: 100,
    },
    county_names_all: "Caddo",
    county_fips_all: 22017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71008,
    lat: 32.33318,
    lng: -92.96396,
    city: "Bienville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 724,
    density: 1.9,
    county_fips: 22013,
    county_name: "Bienville",
    county_weights: {
      22013: 100,
    },
    county_names_all: "Bienville",
    county_fips_all: 22013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71009,
    lat: 32.57793,
    lng: -93.89185,
    city: "Blanchard",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 22017,
    county_name: "Caddo",
    county_weights: {
      22017: 100,
    },
    county_names_all: "Caddo",
    county_fips_all: 22017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71016,
    lat: 32.22899,
    lng: -93.10818,
    city: "Castor",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1792,
    density: 5.8,
    county_fips: 22013,
    county_name: "Bienville",
    county_weights: {
      22013: 100,
    },
    county_names_all: "Bienville",
    county_fips_all: 22013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71018,
    lat: 32.82178,
    lng: -93.42972,
    city: "Cotton Valley",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1643,
    density: 7.6,
    county_fips: 22119,
    county_name: "Webster",
    county_weights: {
      22015: 32.82,
      22119: 67.18,
    },
    county_names_all: "Webster|Bossier",
    county_fips_all: "22119|22015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71019,
    lat: 32.03951,
    lng: -93.30701,
    city: "Coushatta",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7952,
    density: 9.2,
    county_fips: 22081,
    county_name: "Red River",
    county_weights: {
      22069: 13.45,
      22081: 86.55,
    },
    county_names_all: "Red River|Natchitoches",
    county_fips_all: "22081|22069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71021,
    lat: 32.96721,
    lng: -93.44597,
    city: "Cullen",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 733,
    density: 417.6,
    county_fips: 22119,
    county_name: "Webster",
    county_weights: {
      22119: 100,
    },
    county_names_all: "Webster",
    county_fips_all: 22119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71023,
    lat: 32.4662,
    lng: -93.40797,
    city: "Doyline",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3048,
    density: 24.1,
    county_fips: 22119,
    county_name: "Webster",
    county_weights: {
      22015: 26.25,
      22119: 73.75,
    },
    county_names_all: "Webster|Bossier",
    county_fips_all: "22119|22015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71024,
    lat: 32.47897,
    lng: -93.20336,
    city: "Dubberly",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1593,
    density: 9.5,
    county_fips: 22119,
    county_name: "Webster",
    county_weights: {
      22013: 34.66,
      22119: 65.34,
    },
    county_names_all: "Webster|Bienville",
    county_fips_all: "22119|22013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71027,
    lat: 32.24953,
    lng: -93.68698,
    city: "Frierson",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1587,
    density: 10.3,
    county_fips: 22031,
    county_name: "De Soto",
    county_weights: {
      22031: 100,
    },
    county_names_all: "De Soto",
    county_fips_all: 22031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71028,
    lat: 32.48961,
    lng: -93.07315,
    city: "Gibsland",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1231,
    density: 3.7,
    county_fips: 22013,
    county_name: "Bienville",
    county_weights: {
      22013: 100,
    },
    county_names_all: "Bienville",
    county_fips_all: 22013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71029,
    lat: 32.83733,
    lng: -93.83446,
    city: "Gilliam",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 151,
    density: 2.3,
    county_fips: 22017,
    county_name: "Caddo",
    county_weights: {
      22017: 100,
    },
    county_names_all: "Caddo",
    county_fips_all: 22017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71030,
    lat: 32.19267,
    lng: -93.78932,
    city: "Gloster",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1382,
    density: 13.3,
    county_fips: 22031,
    county_name: "De Soto",
    county_weights: {
      22031: 100,
    },
    county_names_all: "De Soto",
    county_fips_all: 22031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71031,
    lat: 32.01097,
    lng: -92.89372,
    city: "Goldonna",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 758,
    density: 2.5,
    county_fips: 22127,
    county_name: "Winn",
    county_weights: {
      22069: 47.49,
      22127: 52.51,
    },
    county_names_all: "Winn|Natchitoches",
    county_fips_all: "22127|22069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71032,
    lat: 32.09383,
    lng: -93.79247,
    city: "Grand Cane",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2492,
    density: 8.2,
    county_fips: 22031,
    county_name: "De Soto",
    county_weights: {
      22031: 100,
    },
    county_names_all: "De Soto",
    county_fips_all: 22031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71033,
    lat: 32.44121,
    lng: -94.00364,
    city: "Greenwood",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3370,
    density: 44,
    county_fips: 22017,
    county_name: "Caddo",
    county_weights: {
      22017: 100,
    },
    county_names_all: "Caddo",
    county_fips_all: 22017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71034,
    lat: 32.18442,
    lng: -93.30553,
    city: "Hall Summit",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 379,
    density: 48.6,
    county_fips: 22081,
    county_name: "Red River",
    county_weights: {
      22081: 100,
    },
    county_names_all: "Red River",
    county_fips_all: 22081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71037,
    lat: 32.56359,
    lng: -93.52804,
    city: "Haughton",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18845,
    density: 56.5,
    county_fips: 22015,
    county_name: "Bossier",
    county_weights: {
      22015: 100,
    },
    county_names_all: "Bossier",
    county_fips_all: 22015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71038,
    lat: 32.94372,
    lng: -93.0699,
    city: "Haynesville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4767,
    density: 8.7,
    county_fips: 22027,
    county_name: "Claiborne",
    county_weights: {
      22027: 99.51,
      22119: 0.49,
    },
    county_names_all: "Claiborne|Webster",
    county_fips_all: "22027|22119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71039,
    lat: 32.4265,
    lng: -93.29064,
    city: "Heflin",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1607,
    density: 13.1,
    county_fips: 22119,
    county_name: "Webster",
    county_weights: {
      22013: 34.74,
      22119: 65.26,
    },
    county_names_all: "Webster|Bienville",
    county_fips_all: "22119|22013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71040,
    lat: 32.78564,
    lng: -93.01238,
    city: "Homer",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8474,
    density: 11.2,
    county_fips: 22027,
    county_name: "Claiborne",
    county_weights: {
      22027: 100,
    },
    county_names_all: "Claiborne",
    county_fips_all: 22027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71043,
    lat: 32.88789,
    lng: -93.88906,
    city: "Hosston",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 662,
    density: 16.3,
    county_fips: 22017,
    county_name: "Caddo",
    county_weights: {
      22017: 100,
    },
    county_names_all: "Caddo",
    county_fips_all: 22017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71044,
    lat: 32.96662,
    lng: -93.88083,
    city: "Ida",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 557,
    density: 3.9,
    county_fips: 22017,
    county_name: "Caddo",
    county_weights: {
      22017: 100,
    },
    county_names_all: "Caddo",
    county_fips_all: 22017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71045,
    lat: 32.3461,
    lng: -93.16595,
    city: "Jamestown",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 754,
    density: 5.8,
    county_fips: 22013,
    county_name: "Bienville",
    county_weights: {
      22013: 100,
    },
    county_names_all: "Bienville",
    county_fips_all: 22013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71046,
    lat: 32.16647,
    lng: -93.94589,
    city: "Keatchie",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1040,
    density: 4.7,
    county_fips: 22031,
    county_name: "De Soto",
    county_weights: {
      22017: 12.7,
      22031: 87.3,
    },
    county_names_all: "De Soto|Caddo",
    county_fips_all: "22031|22017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71047,
    lat: 32.29972,
    lng: -93.91673,
    city: "Keithville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12052,
    density: 42.7,
    county_fips: 22017,
    county_name: "Caddo",
    county_weights: {
      22017: 100,
    },
    county_names_all: "Caddo",
    county_fips_all: 22017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71048,
    lat: 32.83597,
    lng: -92.85071,
    city: "Lisbon",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 109,
    density: 1.9,
    county_fips: 22027,
    county_name: "Claiborne",
    county_weights: {
      22027: 100,
    },
    county_names_all: "Claiborne",
    county_fips_all: 22027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71049,
    lat: 32.01603,
    lng: -93.96663,
    city: "Logansport",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3515,
    density: 14.5,
    county_fips: 22031,
    county_name: "De Soto",
    county_weights: {
      22031: 100,
    },
    county_names_all: "De Soto",
    county_fips_all: 22031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71051,
    lat: 32.3417,
    lng: -93.49639,
    city: "Elm Grove",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2193,
    density: 8.9,
    county_fips: 22015,
    county_name: "Bossier",
    county_weights: {
      22015: 99.03,
      22017: 0.97,
    },
    county_names_all: "Bossier|Caddo",
    county_fips_all: "22015|22017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71052,
    lat: 32.01814,
    lng: -93.66243,
    city: "Mansfield",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9231,
    density: 11.1,
    county_fips: 22031,
    county_name: "De Soto",
    county_weights: {
      22031: 95.71,
      22081: 4.29,
    },
    county_names_all: "De Soto|Red River",
    county_fips_all: "22031|22081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71055,
    lat: 32.67335,
    lng: -93.29713,
    city: "Minden",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19328,
    density: 28.7,
    county_fips: 22119,
    county_name: "Webster",
    county_weights: {
      22013: 0.84,
      22027: 11.34,
      22119: 87.82,
    },
    county_names_all: "Webster|Claiborne|Bienville",
    county_fips_all: "22119|22027|22013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71060,
    lat: 32.63933,
    lng: -93.987,
    city: "Mooringsport",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2237,
    density: 13.3,
    county_fips: 22017,
    county_name: "Caddo",
    county_weights: {
      22017: 100,
    },
    county_names_all: "Caddo",
    county_fips_all: 22017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71061,
    lat: 32.75342,
    lng: -93.97742,
    city: "Oil City",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1540,
    density: 29.3,
    county_fips: 22017,
    county_name: "Caddo",
    county_weights: {
      22017: 100,
    },
    county_names_all: "Caddo",
    county_fips_all: 22017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71063,
    lat: 31.91051,
    lng: -93.51569,
    city: "Pelican",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 699,
    density: 2.5,
    county_fips: 22031,
    county_name: "De Soto",
    county_weights: {
      22031: 100,
    },
    county_names_all: "De Soto",
    county_fips_all: 22031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71064,
    lat: 32.91356,
    lng: -93.68761,
    city: "Plain Dealing",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2679,
    density: 4.9,
    county_fips: 22015,
    county_name: "Bossier",
    county_weights: {
      22015: 100,
    },
    county_names_all: "Bossier",
    county_fips_all: 22015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71065,
    lat: 31.81028,
    lng: -93.49957,
    city: "Pleasant Hill",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1184,
    density: 7.5,
    county_fips: 22085,
    county_name: "Sabine",
    county_weights: {
      22031: 0.59,
      22069: 15.35,
      22085: 84.06,
    },
    county_names_all: "Sabine|Natchitoches|De Soto",
    county_fips_all: "22085|22069|22031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71066,
    lat: 31.87478,
    lng: -93.19829,
    city: "Powhatan",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 22069,
    county_name: "Natchitoches",
    county_weights: {
      22069: 100,
    },
    county_names_all: "Natchitoches",
    county_fips_all: 22069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71067,
    lat: 32.59836,
    lng: -93.49118,
    city: "Princeton",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3778,
    density: 38.3,
    county_fips: 22015,
    county_name: "Bossier",
    county_weights: {
      22015: 92.26,
      22119: 7.74,
    },
    county_names_all: "Bossier|Webster",
    county_fips_all: "22015|22119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71068,
    lat: 32.28464,
    lng: -93.32186,
    city: "Ringgold",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3727,
    density: 10,
    county_fips: 22013,
    county_name: "Bienville",
    county_weights: {
      22013: 75.15,
      22081: 24.85,
    },
    county_names_all: "Bienville|Red River",
    county_fips_all: "22013|22081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71069,
    lat: 32.9726,
    lng: -93.9887,
    city: "Rodessa",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 670,
    density: 8.7,
    county_fips: 22017,
    county_name: "Caddo",
    county_weights: {
      22017: 100,
    },
    county_names_all: "Caddo",
    county_fips_all: 22017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71070,
    lat: 32.08629,
    lng: -92.99618,
    city: "Saline",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1539,
    density: 3,
    county_fips: 22069,
    county_name: "Natchitoches",
    county_weights: {
      22013: 29.6,
      22069: 70.4,
    },
    county_names_all: "Natchitoches|Bienville",
    county_fips_all: "22069|22013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71071,
    lat: 32.91747,
    lng: -93.45099,
    city: "Sarepta",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2399,
    density: 17.5,
    county_fips: 22119,
    county_name: "Webster",
    county_weights: {
      22015: 19.27,
      22119: 80.73,
    },
    county_names_all: "Webster|Bossier",
    county_fips_all: "22119|22015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71072,
    lat: 32.9373,
    lng: -93.31141,
    city: "Shongaloo",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1537,
    density: 6.2,
    county_fips: 22119,
    county_name: "Webster",
    county_weights: {
      22119: 100,
    },
    county_names_all: "Webster",
    county_fips_all: 22119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71073,
    lat: 32.5241,
    lng: -93.30547,
    city: "Sibley",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2073,
    density: 26.8,
    county_fips: 22119,
    county_name: "Webster",
    county_weights: {
      22119: 100,
    },
    county_names_all: "Webster",
    county_fips_all: 22119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71075,
    lat: 32.99349,
    lng: -93.49199,
    city: "Springhill",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5958,
    density: 65.3,
    county_fips: 22119,
    county_name: "Webster",
    county_weights: {
      22015: 28.61,
      22119: 71.39,
    },
    county_names_all: "Webster|Bossier",
    county_fips_all: "22119|22015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71078,
    lat: 32.27721,
    lng: -93.7976,
    city: "Stonewall",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7246,
    density: 69.3,
    county_fips: 22031,
    county_name: "De Soto",
    county_weights: {
      22031: 100,
    },
    county_names_all: "De Soto",
    county_fips_all: 22031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71079,
    lat: 32.94811,
    lng: -92.81941,
    city: "Summerfield",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 122,
    density: 1.4,
    county_fips: 22027,
    county_name: "Claiborne",
    county_weights: {
      22027: 100,
    },
    county_names_all: "Claiborne",
    county_fips_all: 22027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71082,
    lat: 32.84389,
    lng: -93.97763,
    city: "Vivian",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4562,
    density: 22.4,
    county_fips: 22017,
    county_name: "Caddo",
    county_weights: {
      22017: 100,
    },
    county_names_all: "Caddo",
    county_fips_all: 22017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71101,
    lat: 32.5062,
    lng: -93.74822,
    city: "Shreveport",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7229,
    density: 663.1,
    county_fips: 22017,
    county_name: "Caddo",
    county_weights: {
      22017: 100,
    },
    county_names_all: "Caddo",
    county_fips_all: 22017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71103,
    lat: 32.49154,
    lng: -93.7717,
    city: "Shreveport",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6572,
    density: 651,
    county_fips: 22017,
    county_name: "Caddo",
    county_weights: {
      22017: 100,
    },
    county_names_all: "Caddo",
    county_fips_all: 22017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71104,
    lat: 32.48525,
    lng: -93.73171,
    city: "Shreveport",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13834,
    density: 1362.7,
    county_fips: 22017,
    county_name: "Caddo",
    county_weights: {
      22015: 4.88,
      22017: 95.12,
    },
    county_names_all: "Caddo|Bossier",
    county_fips_all: "22017|22015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71105,
    lat: 32.45512,
    lng: -93.71012,
    city: "Shreveport",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20660,
    density: 843,
    county_fips: 22017,
    county_name: "Caddo",
    county_weights: {
      22015: 4.61,
      22017: 95.39,
    },
    county_names_all: "Caddo|Bossier",
    county_fips_all: "22017|22015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71106,
    lat: 32.38507,
    lng: -93.73558,
    city: "Shreveport",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36713,
    density: 427,
    county_fips: 22017,
    county_name: "Caddo",
    county_weights: {
      22017: 100,
    },
    county_names_all: "Caddo",
    county_fips_all: 22017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71107,
    lat: 32.59509,
    lng: -93.85909,
    city: "Shreveport",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35048,
    density: 98.6,
    county_fips: 22017,
    county_name: "Caddo",
    county_weights: {
      22015: 0.77,
      22017: 99.23,
    },
    county_names_all: "Caddo|Bossier",
    county_fips_all: "22017|22015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71108,
    lat: 32.44236,
    lng: -93.78881,
    city: "Shreveport",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18943,
    density: 863.2,
    county_fips: 22017,
    county_name: "Caddo",
    county_weights: {
      22017: 100,
    },
    county_names_all: "Caddo",
    county_fips_all: 22017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71109,
    lat: 32.46859,
    lng: -93.814,
    city: "Shreveport",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18106,
    density: 547.2,
    county_fips: 22017,
    county_name: "Caddo",
    county_weights: {
      22017: 100,
    },
    county_names_all: "Caddo",
    county_fips_all: 22017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71110,
    lat: 32.50289,
    lng: -93.63027,
    city: "Barksdale Afb",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4862,
    density: 105,
    county_fips: 22015,
    county_name: "Bossier",
    county_weights: {
      22015: 100,
    },
    county_names_all: "Bossier",
    county_fips_all: 22015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71111,
    lat: 32.57904,
    lng: -93.70379,
    city: "Bossier City",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43247,
    density: 369.1,
    county_fips: 22015,
    county_name: "Bossier",
    county_weights: {
      22015: 100,
    },
    county_names_all: "Bossier",
    county_fips_all: 22015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71112,
    lat: 32.44373,
    lng: -93.63874,
    city: "Bossier City",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34921,
    density: 323,
    county_fips: 22015,
    county_name: "Bossier",
    county_weights: {
      22015: 100,
    },
    county_names_all: "Bossier",
    county_fips_all: 22015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71115,
    lat: 32.26472,
    lng: -93.56247,
    city: "Shreveport",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14141,
    density: 47,
    county_fips: 22017,
    county_name: "Caddo",
    county_weights: {
      22017: 58.62,
      22081: 41.38,
    },
    county_names_all: "Caddo|Red River",
    county_fips_all: "22017|22081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71118,
    lat: 32.39262,
    lng: -93.80498,
    city: "Shreveport",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23585,
    density: 696.5,
    county_fips: 22017,
    county_name: "Caddo",
    county_weights: {
      22017: 100,
    },
    county_names_all: "Caddo",
    county_fips_all: 22017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71119,
    lat: 32.48542,
    lng: -93.92296,
    city: "Shreveport",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10953,
    density: 105.2,
    county_fips: 22017,
    county_name: "Caddo",
    county_weights: {
      22017: 100,
    },
    county_names_all: "Caddo",
    county_fips_all: 22017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71129,
    lat: 32.38697,
    lng: -93.92685,
    city: "Shreveport",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12789,
    density: 115.6,
    county_fips: 22017,
    county_name: "Caddo",
    county_weights: {
      22017: 100,
    },
    county_names_all: "Caddo",
    county_fips_all: 22017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71201,
    lat: 32.53915,
    lng: -92.1069,
    city: "Monroe",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20631,
    density: 535.3,
    county_fips: 22073,
    county_name: "Ouachita",
    county_weights: {
      22073: 100,
    },
    county_names_all: "Ouachita",
    county_fips_all: 22073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71202,
    lat: 32.39549,
    lng: -92.05663,
    city: "Monroe",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27985,
    density: 93.6,
    county_fips: 22073,
    county_name: "Ouachita",
    county_weights: {
      22073: 100,
    },
    county_names_all: "Ouachita",
    county_fips_all: 22073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71203,
    lat: 32.58398,
    lng: -92.01351,
    city: "Monroe",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40196,
    density: 130.9,
    county_fips: 22073,
    county_name: "Ouachita",
    county_weights: {
      22073: 100,
    },
    county_names_all: "Ouachita",
    county_fips_all: 22073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71209,
    lat: 32.53036,
    lng: -92.07206,
    city: "Monroe",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 179,
    density: 1328.5,
    county_fips: 22073,
    county_name: "Ouachita",
    county_weights: {
      22073: 100,
    },
    county_names_all: "Ouachita",
    county_fips_all: 22073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71212,
    lat: 32.52725,
    lng: -92.0734,
    city: "Monroe",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 22073,
    county_name: "Ouachita",
    county_weights: {
      22073: 100,
    },
    county_names_all: "Ouachita",
    county_fips_all: 22073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71218,
    lat: 32.35081,
    lng: -91.78739,
    city: "Archibald",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 22083,
    county_name: "Richland",
    county_weights: {
      22083: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 22083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71219,
    lat: 32.32344,
    lng: -91.6842,
    city: "Baskin",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1205,
    density: 7.7,
    county_fips: 22041,
    county_name: "Franklin",
    county_weights: {
      22041: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 22041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71220,
    lat: 32.8622,
    lng: -91.91236,
    city: "Bastrop",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20837,
    density: 21.5,
    county_fips: 22067,
    county_name: "Morehouse",
    county_weights: {
      22067: 99.06,
      22073: 0.94,
    },
    county_names_all: "Morehouse|Ouachita",
    county_fips_all: "22067|22073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71222,
    lat: 32.82859,
    lng: -92.65918,
    city: "Bernice",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3057,
    density: 8.2,
    county_fips: 22111,
    county_name: "Union",
    county_weights: {
      22027: 26.28,
      22111: 73.72,
    },
    county_names_all: "Union|Claiborne",
    county_fips_all: "22111|22027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71223,
    lat: 32.90084,
    lng: -91.67443,
    city: "Bonita",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 333,
    density: 2.5,
    county_fips: 22067,
    county_name: "Morehouse",
    county_weights: {
      22067: 100,
    },
    county_names_all: "Morehouse",
    county_fips_all: 22067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71225,
    lat: 32.50784,
    lng: -92.3477,
    city: "Calhoun",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6992,
    density: 45.1,
    county_fips: 22073,
    county_name: "Ouachita",
    county_weights: {
      22073: 100,
    },
    county_names_all: "Ouachita",
    county_fips_all: 22073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71226,
    lat: 32.24729,
    lng: -92.44234,
    city: "Chatham",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1857,
    density: 4.9,
    county_fips: 22049,
    county_name: "Jackson",
    county_weights: {
      22049: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 22049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71227,
    lat: 32.52866,
    lng: -92.48353,
    city: "Choudrant",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4169,
    density: 14,
    county_fips: 22061,
    county_name: "Lincoln",
    county_weights: {
      22049: 36.81,
      22061: 60.38,
      22073: 2.81,
    },
    county_names_all: "Lincoln|Jackson|Ouachita",
    county_fips_all: "22061|22049|22073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71229,
    lat: 32.6374,
    lng: -91.89251,
    city: "Collinston",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1330,
    density: 9.4,
    county_fips: 22067,
    county_name: "Morehouse",
    county_weights: {
      22067: 90.58,
      22073: 9.42,
    },
    county_names_all: "Morehouse|Ouachita",
    county_fips_all: "22067|22073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71230,
    lat: 32.2403,
    lng: -91.59269,
    city: "Crowville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 22041,
    county_name: "Franklin",
    county_weights: {
      22041: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 22041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71232,
    lat: 32.41554,
    lng: -91.493,
    city: "Delhi",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6289,
    density: 9.8,
    county_fips: 22065,
    county_name: "Madison",
    county_weights: {
      22041: 22.04,
      22065: 45.64,
      22083: 32.31,
    },
    county_names_all: "Madison|Richland|Franklin",
    county_fips_all: "22065|22083|22041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71233,
    lat: 32.32509,
    lng: -90.93177,
    city: "Delta",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 277,
    density: 181.7,
    county_fips: 22065,
    county_name: "Madison",
    county_weights: {
      22065: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 22065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71234,
    lat: 32.64306,
    lng: -92.33954,
    city: "Downsville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4600,
    density: 15.2,
    county_fips: 22111,
    county_name: "Union",
    county_weights: {
      22061: 6.31,
      22073: 7.47,
      22111: 86.22,
    },
    county_names_all: "Union|Ouachita|Lincoln",
    county_fips_all: "22111|22073|22061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71235,
    lat: 32.68988,
    lng: -92.6726,
    city: "Dubach",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4198,
    density: 10,
    county_fips: 22061,
    county_name: "Lincoln",
    county_weights: {
      22027: 1.22,
      22061: 95.55,
      22111: 3.23,
    },
    county_names_all: "Lincoln|Union|Claiborne",
    county_fips_all: "22061|22111|22027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71237,
    lat: 32.58413,
    lng: -91.48024,
    city: "Epps",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1481,
    density: 7,
    county_fips: 22123,
    county_name: "West Carroll",
    county_weights: {
      22035: 25.95,
      22065: 9.22,
      22083: 16.66,
      22123: 48.17,
    },
    county_names_all: "West Carroll|East Carroll|Richland|Madison",
    county_fips_all: "22123|22035|22083|22065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71238,
    lat: 32.36716,
    lng: -92.38139,
    city: "Eros",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2383,
    density: 8.6,
    county_fips: 22049,
    county_name: "Jackson",
    county_weights: {
      22049: 64.81,
      22073: 35.19,
    },
    county_names_all: "Jackson|Ouachita",
    county_fips_all: "22049|22073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71241,
    lat: 32.77107,
    lng: -92.36531,
    city: "Farmerville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9862,
    density: 19.7,
    county_fips: 22111,
    county_name: "Union",
    county_weights: {
      22111: 100,
    },
    county_names_all: "Union",
    county_fips_all: 22111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71242,
    lat: 32.79223,
    lng: -91.41291,
    city: "Forest",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 22123,
    county_name: "West Carroll",
    county_weights: {
      22123: 100,
    },
    county_names_all: "West Carroll",
    county_fips_all: 22123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71243,
    lat: 31.96055,
    lng: -91.80745,
    city: "Fort Necessity",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 236,
    density: 3.6,
    county_fips: 22041,
    county_name: "Franklin",
    county_weights: {
      22041: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 22041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71245,
    lat: 32.52697,
    lng: -92.7145,
    city: "Grambling",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4316,
    density: 307.4,
    county_fips: 22061,
    county_name: "Lincoln",
    county_weights: {
      22061: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 22061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71247,
    lat: 32.27255,
    lng: -92.72077,
    city: "Hodge",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1533,
    density: 431.4,
    county_fips: 22049,
    county_name: "Jackson",
    county_weights: {
      22049: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 22049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71250,
    lat: 32.95983,
    lng: -91.57327,
    city: "Jones",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 168,
    density: 0.7,
    county_fips: 22067,
    county_name: "Morehouse",
    county_weights: {
      22067: 100,
    },
    county_names_all: "Morehouse",
    county_fips_all: 22067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71251,
    lat: 32.21891,
    lng: -92.67162,
    city: "Jonesboro",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8677,
    density: 18.1,
    county_fips: 22049,
    county_name: "Jackson",
    county_weights: {
      22013: 13.5,
      22049: 86.5,
    },
    county_names_all: "Jackson|Bienville",
    county_fips_all: "22049|22013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71253,
    lat: 32.99597,
    lng: -91.31576,
    city: "Kilbourne",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 156,
    density: 62.1,
    county_fips: 22123,
    county_name: "West Carroll",
    county_weights: {
      22123: 100,
    },
    county_names_all: "West Carroll",
    county_fips_all: 22123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71254,
    lat: 32.79429,
    lng: -91.23914,
    city: "Lake Providence",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5485,
    density: 7.6,
    county_fips: 22035,
    county_name: "East Carroll",
    county_weights: {
      22035: 100,
    },
    county_names_all: "East Carroll",
    county_fips_all: 22035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71256,
    lat: 32.94852,
    lng: -92.71471,
    city: "Lillie",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 972,
    density: 7.2,
    county_fips: 22111,
    county_name: "Union",
    county_weights: {
      22027: 38.36,
      22111: 61.64,
    },
    county_names_all: "Union|Claiborne",
    county_fips_all: "22111|22027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71259,
    lat: 32.2713,
    lng: -91.84558,
    city: "Mangham",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1725,
    density: 7.3,
    county_fips: 22083,
    county_name: "Richland",
    county_weights: {
      22083: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 22083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71260,
    lat: 32.90615,
    lng: -92.23793,
    city: "Marion",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2789,
    density: 3.7,
    county_fips: 22111,
    county_name: "Union",
    county_weights: {
      22111: 100,
    },
    county_names_all: "Union",
    county_fips_all: 22111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71261,
    lat: 32.77802,
    lng: -91.69515,
    city: "Mer Rouge",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1235,
    density: 3.4,
    county_fips: 22067,
    county_name: "Morehouse",
    county_weights: {
      22067: 100,
    },
    county_names_all: "Morehouse",
    county_fips_all: 22067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71263,
    lat: 32.87497,
    lng: -91.428,
    city: "Oak Grove",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7613,
    density: 14.9,
    county_fips: 22123,
    county_name: "West Carroll",
    county_weights: {
      22123: 100,
    },
    county_names_all: "West Carroll",
    county_fips_all: 22123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71264,
    lat: 32.6029,
    lng: -91.7734,
    city: "Oak Ridge",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1632,
    density: 5.6,
    county_fips: 22067,
    county_name: "Morehouse",
    county_weights: {
      22067: 80.64,
      22083: 19.36,
    },
    county_names_all: "Morehouse|Richland",
    county_fips_all: "22067|22083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71266,
    lat: 32.70359,
    lng: -91.48362,
    city: "Pioneer",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1859,
    density: 5.8,
    county_fips: 22123,
    county_name: "West Carroll",
    county_weights: {
      22123: 100,
    },
    county_names_all: "West Carroll",
    county_fips_all: 22123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71268,
    lat: 32.34696,
    lng: -92.74418,
    city: "Quitman",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2547,
    density: 8.1,
    county_fips: 22049,
    county_name: "Jackson",
    county_weights: {
      22013: 42.47,
      22049: 57.53,
    },
    county_names_all: "Jackson|Bienville",
    county_fips_all: "22049|22013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71269,
    lat: 32.44592,
    lng: -91.78718,
    city: "Rayville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12685,
    density: 15.1,
    county_fips: 22083,
    county_name: "Richland",
    county_weights: {
      22083: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 22083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71270,
    lat: 32.49378,
    lng: -92.64139,
    city: "Ruston",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31545,
    density: 58.9,
    county_fips: 22061,
    county_name: "Lincoln",
    county_weights: {
      22049: 38.64,
      22061: 61.36,
    },
    county_names_all: "Lincoln|Jackson",
    county_fips_all: "22061|22049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71272,
    lat: 32.52928,
    lng: -92.6517,
    city: "Ruston",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1272,
    density: 1321,
    county_fips: 22061,
    county_name: "Lincoln",
    county_weights: {
      22061: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 22061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71275,
    lat: 32.51276,
    lng: -92.81991,
    city: "Simsboro",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2638,
    density: 10.5,
    county_fips: 22061,
    county_name: "Lincoln",
    county_weights: {
      22013: 23.05,
      22061: 76.95,
    },
    county_names_all: "Lincoln|Bienville",
    county_fips_all: "22061|22013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71276,
    lat: 32.57727,
    lng: -91.16277,
    city: "Sondheimer",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47,
    density: 0.3,
    county_fips: 22035,
    county_name: "East Carroll",
    county_weights: {
      22035: 100,
    },
    county_names_all: "East Carroll",
    county_fips_all: 22035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71277,
    lat: 32.94902,
    lng: -92.55554,
    city: "Spearsville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1314,
    density: 4.7,
    county_fips: 22111,
    county_name: "Union",
    county_weights: {
      22111: 100,
    },
    county_names_all: "Union",
    county_fips_all: 22111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71279,
    lat: 32.48667,
    lng: -91.85671,
    city: "Start",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47,
    density: 240.5,
    county_fips: 22083,
    county_name: "Richland",
    county_weights: {
      22083: 100,
    },
    county_names_all: "Richland",
    county_fips_all: 22083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71280,
    lat: 32.72344,
    lng: -92.10389,
    city: "Sterlington",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5185,
    density: 33.7,
    county_fips: 22111,
    county_name: "Union",
    county_weights: {
      22067: 6.22,
      22073: 22.63,
      22111: 71.15,
    },
    county_names_all: "Union|Ouachita|Morehouse",
    county_fips_all: "22111|22073|22067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71282,
    lat: 32.35662,
    lng: -91.20042,
    city: "Tallulah",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10285,
    density: 8,
    county_fips: 22065,
    county_name: "Madison",
    county_weights: {
      22065: 99.18,
      22107: 0.82,
    },
    county_names_all: "Madison|Tensas",
    county_fips_all: "22065|22107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71286,
    lat: 32.65244,
    lng: -91.23397,
    city: "Transylvania",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1324,
    density: 8.3,
    county_fips: 22035,
    county_name: "East Carroll",
    county_weights: {
      22035: 100,
    },
    county_names_all: "East Carroll",
    county_fips_all: 22035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71291,
    lat: 32.56977,
    lng: -92.18277,
    city: "West Monroe",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32670,
    density: 192.7,
    county_fips: 22073,
    county_name: "Ouachita",
    county_weights: {
      22073: 100,
    },
    county_names_all: "Ouachita",
    county_fips_all: 22073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71292,
    lat: 32.40147,
    lng: -92.21569,
    city: "West Monroe",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19200,
    density: 48.2,
    county_fips: 22073,
    county_name: "Ouachita",
    county_weights: {
      22073: 100,
    },
    county_names_all: "Ouachita",
    county_fips_all: 22073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71295,
    lat: 32.14565,
    lng: -91.70795,
    city: "Winnsboro",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13799,
    density: 16.9,
    county_fips: 22041,
    county_name: "Franklin",
    county_weights: {
      22041: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 22041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71301,
    lat: 31.27446,
    lng: -92.46864,
    city: "Alexandria",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21634,
    density: 669.1,
    county_fips: 22079,
    county_name: "Rapides",
    county_weights: {
      22079: 100,
    },
    county_names_all: "Rapides",
    county_fips_all: 22079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71302,
    lat: 31.2053,
    lng: -92.36667,
    city: "Alexandria",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13734,
    density: 91.7,
    county_fips: 22079,
    county_name: "Rapides",
    county_weights: {
      22079: 100,
    },
    county_names_all: "Rapides",
    county_fips_all: 22079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71303,
    lat: 31.28081,
    lng: -92.54308,
    city: "Alexandria",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21189,
    density: 129,
    county_fips: 22079,
    county_name: "Rapides",
    county_weights: {
      22079: 100,
    },
    county_names_all: "Rapides",
    county_fips_all: 22079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71316,
    lat: 31.27665,
    lng: -91.76231,
    city: "Acme",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6,
    density: 0,
    county_fips: 22029,
    county_name: "Concordia",
    county_weights: {
      22029: 100,
    },
    county_names_all: "Concordia",
    county_fips_all: 22029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71320,
    lat: 31.09114,
    lng: -91.76985,
    city: "Bordelonville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 22009,
    county_name: "Avoyelles",
    county_weights: {
      22009: 100,
    },
    county_names_all: "Avoyelles",
    county_fips_all: 22009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71322,
    lat: 30.86731,
    lng: -92.15188,
    city: "Bunkie",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6612,
    density: 13,
    county_fips: 22009,
    county_name: "Avoyelles",
    county_weights: {
      22009: 49.54,
      22079: 6.31,
      22097: 44.15,
    },
    county_names_all: "Avoyelles|St. Landry|Rapides",
    county_fips_all: "22009|22097|22079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71323,
    lat: 31.26656,
    lng: -92.21037,
    city: "Center Point",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1601,
    density: 29.9,
    county_fips: 22009,
    county_name: "Avoyelles",
    county_weights: {
      22009: 94.85,
      22079: 5.15,
    },
    county_names_all: "Avoyelles|Rapides",
    county_fips_all: "22009|22079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71325,
    lat: 31.01153,
    lng: -92.32434,
    city: "Cheneyville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1404,
    density: 8.2,
    county_fips: 22079,
    county_name: "Rapides",
    county_weights: {
      22039: 28.9,
      22079: 71.1,
    },
    county_names_all: "Rapides|Evangeline",
    county_fips_all: "22079|22039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71326,
    lat: 31.77363,
    lng: -91.58702,
    city: "Clayton",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 776,
    density: 4.5,
    county_fips: 22025,
    county_name: "Catahoula",
    county_weights: {
      22025: 73.7,
      22029: 26.3,
    },
    county_names_all: "Catahoula|Concordia",
    county_fips_all: "22025|22029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71327,
    lat: 30.97895,
    lng: -92.03863,
    city: "Cottonport",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5712,
    density: 45.5,
    county_fips: 22009,
    county_name: "Avoyelles",
    county_weights: {
      22009: 100,
    },
    county_names_all: "Avoyelles",
    county_fips_all: 22009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71328,
    lat: 31.35276,
    lng: -92.19097,
    city: "Deville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7902,
    density: 25.8,
    county_fips: 22079,
    county_name: "Rapides",
    county_weights: {
      22009: 17.4,
      22079: 82.6,
    },
    county_names_all: "Rapides|Avoyelles",
    county_fips_all: "22079|22009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71330,
    lat: 31.11002,
    lng: -92.24145,
    city: "Echo",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 22079,
    county_name: "Rapides",
    county_weights: {
      22079: 100,
    },
    county_names_all: "Rapides",
    county_fips_all: 22079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71331,
    lat: 31.2578,
    lng: -92.07969,
    city: "Effie",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1104,
    density: 7.1,
    county_fips: 22009,
    county_name: "Avoyelles",
    county_weights: {
      22009: 100,
    },
    county_names_all: "Avoyelles",
    county_fips_all: 22009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71333,
    lat: 30.90315,
    lng: -92.0754,
    city: "Evergreen",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 417,
    density: 4.5,
    county_fips: 22009,
    county_name: "Avoyelles",
    county_weights: {
      22009: 100,
    },
    county_names_all: "Avoyelles",
    county_fips_all: 22009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71334,
    lat: 31.66978,
    lng: -91.56864,
    city: "Ferriday",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10351,
    density: 28.5,
    county_fips: 22029,
    county_name: "Concordia",
    county_weights: {
      22029: 100,
    },
    county_names_all: "Concordia",
    county_fips_all: 22029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71336,
    lat: 32.02126,
    lng: -91.5935,
    city: "Gilbert",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1269,
    density: 4.1,
    county_fips: 22041,
    county_name: "Franklin",
    county_weights: {
      22041: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 22041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71339,
    lat: 31.0058,
    lng: -91.93637,
    city: "Hamburg",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 255,
    density: 13.8,
    county_fips: 22009,
    county_name: "Avoyelles",
    county_weights: {
      22009: 100,
    },
    county_names_all: "Avoyelles",
    county_fips_all: 22009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71340,
    lat: 31.7553,
    lng: -91.80696,
    city: "Harrisonburg",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2159,
    density: 6.3,
    county_fips: 22025,
    county_name: "Catahoula",
    county_weights: {
      22025: 100,
    },
    county_names_all: "Catahoula",
    county_fips_all: 22025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71341,
    lat: 31.05969,
    lng: -92.16267,
    city: "Hessmer",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3283,
    density: 48.1,
    county_fips: 22009,
    county_name: "Avoyelles",
    county_weights: {
      22009: 100,
    },
    county_names_all: "Avoyelles",
    county_fips_all: 22009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71342,
    lat: 31.60042,
    lng: -92.1403,
    city: "Jena",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7046,
    density: 17.1,
    county_fips: 22059,
    county_name: "LaSalle",
    county_weights: {
      22059: 100,
    },
    county_names_all: "LaSalle",
    county_fips_all: 22059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71343,
    lat: 31.51117,
    lng: -91.90723,
    city: "Jonesville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5816,
    density: 4.2,
    county_fips: 22025,
    county_name: "Catahoula",
    county_weights: {
      22025: 63.23,
      22029: 17.38,
      22059: 19.39,
    },
    county_names_all: "Catahoula|LaSalle|Concordia",
    county_fips_all: "22025|22059|22029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71345,
    lat: 30.72867,
    lng: -91.97531,
    city: "Lebeau",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 193,
    density: 512.4,
    county_fips: 22097,
    county_name: "St. Landry",
    county_weights: {
      22097: 100,
    },
    county_names_all: "St. Landry",
    county_fips_all: 22097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71346,
    lat: 31.11686,
    lng: -92.38446,
    city: "Lecompte",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2160,
    density: 9.1,
    county_fips: 22079,
    county_name: "Rapides",
    county_weights: {
      22079: 100,
    },
    county_names_all: "Rapides",
    county_fips_all: 22079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71350,
    lat: 31.06871,
    lng: -92.06053,
    city: "Mansura",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3856,
    density: 42.5,
    county_fips: 22009,
    county_name: "Avoyelles",
    county_weights: {
      22009: 100,
    },
    county_names_all: "Avoyelles",
    county_fips_all: 22009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71351,
    lat: 31.17227,
    lng: -91.9604,
    city: "Marksville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11725,
    density: 20.1,
    county_fips: 22009,
    county_name: "Avoyelles",
    county_weights: {
      22009: 99.25,
      22079: 0.75,
    },
    county_names_all: "Avoyelles|Rapides",
    county_fips_all: "22009|22079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71353,
    lat: 30.67949,
    lng: -91.79664,
    city: "Melville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2087,
    density: 9.9,
    county_fips: 22097,
    county_name: "St. Landry",
    county_weights: {
      22097: 100,
    },
    county_names_all: "St. Landry",
    county_fips_all: 22097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71354,
    lat: 31.38364,
    lng: -91.73548,
    city: "Monterey",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2095,
    density: 5.9,
    county_fips: 22029,
    county_name: "Concordia",
    county_weights: {
      22029: 100,
    },
    county_names_all: "Concordia",
    county_fips_all: 22029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71355,
    lat: 31.05257,
    lng: -91.88531,
    city: "Moreauville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2442,
    density: 14.1,
    county_fips: 22009,
    county_name: "Avoyelles",
    county_weights: {
      22009: 100,
    },
    county_names_all: "Avoyelles",
    county_fips_all: 22009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71356,
    lat: 30.83423,
    lng: -92.02988,
    city: "Morrow",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 608,
    density: 12,
    county_fips: 22097,
    county_name: "St. Landry",
    county_weights: {
      22009: 12.54,
      22097: 87.46,
    },
    county_names_all: "St. Landry|Avoyelles",
    county_fips_all: "22097|22009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71357,
    lat: 32.1084,
    lng: -91.29717,
    city: "Newellton",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1668,
    density: 2.2,
    county_fips: 22107,
    county_name: "Tensas",
    county_weights: {
      22107: 100,
    },
    county_names_all: "Tensas",
    county_fips_all: 22107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71358,
    lat: 30.72631,
    lng: -91.87553,
    city: "Palmetto",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1135,
    density: 4.1,
    county_fips: 22097,
    county_name: "St. Landry",
    county_weights: {
      22097: 100,
    },
    county_names_all: "St. Landry",
    county_fips_all: 22097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71359,
    lat: 31.32468,
    lng: -92.4264,
    city: "Pineville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 22079,
    county_name: "Rapides",
    county_weights: {
      22079: 100,
    },
    county_names_all: "Rapides",
    county_fips_all: 22079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71360,
    lat: 31.31597,
    lng: -92.34593,
    city: "Pineville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35994,
    density: 72,
    county_fips: 22079,
    county_name: "Rapides",
    county_weights: {
      22009: 10.7,
      22043: 1.11,
      22079: 88.19,
    },
    county_names_all: "Rapides|Avoyelles|Grant",
    county_fips_all: "22079|22009|22043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71362,
    lat: 30.88839,
    lng: -91.95225,
    city: "Plaucheville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1635,
    density: 9,
    county_fips: 22009,
    county_name: "Avoyelles",
    county_weights: {
      22009: 77.84,
      22097: 22.16,
    },
    county_names_all: "Avoyelles|St. Landry",
    county_fips_all: "22009|22097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71366,
    lat: 31.95051,
    lng: -91.35591,
    city: "Saint Joseph",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1460,
    density: 3.8,
    county_fips: 22107,
    county_name: "Tensas",
    county_weights: {
      22107: 100,
    },
    county_names_all: "Tensas",
    county_fips_all: 22107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71367,
    lat: 30.88784,
    lng: -92.29426,
    city: "Saint Landry",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1644,
    density: 10.2,
    county_fips: 22039,
    county_name: "Evangeline",
    county_weights: {
      22039: 93.54,
      22079: 6.46,
    },
    county_names_all: "Evangeline|Rapides",
    county_fips_all: "22039|22079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71368,
    lat: 31.86392,
    lng: -91.68494,
    city: "Sicily Island",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1791,
    density: 8.1,
    county_fips: 22025,
    county_name: "Catahoula",
    county_weights: {
      22025: 100,
    },
    county_names_all: "Catahoula",
    county_fips_all: 22025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71369,
    lat: 30.92949,
    lng: -91.85605,
    city: "Simmesport",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2257,
    density: 14.4,
    county_fips: 22009,
    county_name: "Avoyelles",
    county_weights: {
      22009: 99.9,
      22097: 0.1,
    },
    county_names_all: "Avoyelles|St. Landry",
    county_fips_all: "22009|22097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71371,
    lat: 31.67542,
    lng: -92.2587,
    city: "Trout",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2344,
    density: 6.5,
    county_fips: 22059,
    county_name: "LaSalle",
    county_weights: {
      22059: 100,
    },
    county_names_all: "LaSalle",
    county_fips_all: 22059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71373,
    lat: 31.35934,
    lng: -91.58607,
    city: "Vidalia",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5803,
    density: 10.3,
    county_fips: 22029,
    county_name: "Concordia",
    county_weights: {
      22029: 100,
    },
    county_names_all: "Concordia",
    county_fips_all: 22029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71375,
    lat: 31.84632,
    lng: -91.47226,
    city: "Waterproof",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1307,
    density: 3.9,
    county_fips: 22107,
    county_name: "Tensas",
    county_weights: {
      22107: 100,
    },
    county_names_all: "Tensas",
    county_fips_all: 22107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71378,
    lat: 31.95481,
    lng: -91.71211,
    city: "Wisner",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2475,
    density: 19.6,
    county_fips: 22041,
    county_name: "Franklin",
    county_weights: {
      22041: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 22041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71401,
    lat: 31.79477,
    lng: -91.94461,
    city: "Aimwell",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 73,
    density: 1.7,
    county_fips: 22025,
    county_name: "Catahoula",
    county_weights: {
      22025: 100,
    },
    county_names_all: "Catahoula",
    county_fips_all: 22025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71403,
    lat: 31.21047,
    lng: -93.44061,
    city: "Anacoco",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4426,
    density: 13,
    county_fips: 22115,
    county_name: "Vernon",
    county_weights: {
      22085: 6.89,
      22115: 93.11,
    },
    county_names_all: "Vernon|Sabine",
    county_fips_all: "22115|22085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71404,
    lat: 31.75404,
    lng: -92.75257,
    city: "Atlanta",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 781,
    density: 2.8,
    county_fips: 22127,
    county_name: "Winn",
    county_weights: {
      22043: 24.95,
      22127: 75.05,
    },
    county_names_all: "Winn|Grant",
    county_fips_all: "22127|22043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71405,
    lat: 31.40971,
    lng: -92.39771,
    city: "Ball",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6184,
    density: 146.4,
    county_fips: 22079,
    county_name: "Rapides",
    county_weights: {
      22079: 100,
    },
    county_names_all: "Rapides",
    county_fips_all: 22079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71406,
    lat: 31.73425,
    lng: -93.50536,
    city: "Belmont",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 138,
    density: 6.6,
    county_fips: 22085,
    county_name: "Sabine",
    county_weights: {
      22085: 100,
    },
    county_names_all: "Sabine",
    county_fips_all: 22085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71407,
    lat: 31.51837,
    lng: -92.48402,
    city: "Bentley",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1028,
    density: 22.5,
    county_fips: 22043,
    county_name: "Grant",
    county_weights: {
      22043: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 22043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71409,
    lat: 31.31287,
    lng: -92.69954,
    city: "Boyce",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5726,
    density: 16.2,
    county_fips: 22079,
    county_name: "Rapides",
    county_weights: {
      22079: 100,
    },
    county_names_all: "Rapides",
    county_fips_all: 22079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71410,
    lat: 31.96419,
    lng: -92.77125,
    city: "Calvin",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 108,
    density: 52.5,
    county_fips: 22127,
    county_name: "Winn",
    county_weights: {
      22127: 100,
    },
    county_names_all: "Winn",
    county_fips_all: 22127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71411,
    lat: 31.90466,
    lng: -93.08894,
    city: "Campti",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3563,
    density: 20.7,
    county_fips: 22069,
    county_name: "Natchitoches",
    county_weights: {
      22069: 100,
    },
    county_names_all: "Natchitoches",
    county_fips_all: 22069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71414,
    lat: 31.82593,
    lng: -93.02515,
    city: "Clarence",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 84,
    density: 47,
    county_fips: 22069,
    county_name: "Natchitoches",
    county_weights: {
      22069: 100,
    },
    county_names_all: "Natchitoches",
    county_fips_all: 22069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71415,
    lat: 32.0253,
    lng: -92.14241,
    city: "Clarks",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 22021,
    county_name: "Caldwell",
    county_weights: {
      22021: 100,
    },
    county_names_all: "Caldwell",
    county_fips_all: 22021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71416,
    lat: 31.53875,
    lng: -92.89558,
    city: "Cloutierville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1281,
    density: 6.6,
    county_fips: 22069,
    county_name: "Natchitoches",
    county_weights: {
      22069: 100,
    },
    county_names_all: "Natchitoches",
    county_fips_all: 22069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71417,
    lat: 31.51611,
    lng: -92.65361,
    city: "Colfax",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5406,
    density: 14.8,
    county_fips: 22043,
    county_name: "Grant",
    county_weights: {
      22043: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 22043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71418,
    lat: 32.13405,
    lng: -92.04589,
    city: "Columbia",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5769,
    density: 6.3,
    county_fips: 22021,
    county_name: "Caldwell",
    county_weights: {
      22021: 83.74,
      22025: 6.09,
      22041: 0.19,
      22073: 2.92,
      22083: 7.06,
    },
    county_names_all: "Caldwell|Richland|Catahoula|Ouachita|Franklin",
    county_fips_all: "22021|22083|22025|22073|22041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71419,
    lat: 31.80188,
    lng: -93.72614,
    city: "Converse",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2025,
    density: 5.5,
    county_fips: 22085,
    county_name: "Sabine",
    county_weights: {
      22031: 20.95,
      22085: 79.05,
    },
    county_names_all: "Sabine|De Soto",
    county_fips_all: "22085|22031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71422,
    lat: 32.07653,
    lng: -92.65767,
    city: "Dodson",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1540,
    density: 3.8,
    county_fips: 22127,
    county_name: "Winn",
    county_weights: {
      22127: 100,
    },
    county_names_all: "Winn",
    county_fips_all: 22127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71423,
    lat: 31.60012,
    lng: -92.56341,
    city: "Dry Prong",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3803,
    density: 11.2,
    county_fips: 22043,
    county_name: "Grant",
    county_weights: {
      22043: 96.51,
      22079: 3.49,
    },
    county_names_all: "Grant|Rapides",
    county_fips_all: "22043|22079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71424,
    lat: 31.17976,
    lng: -92.69207,
    city: "Elmer",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1464,
    density: 15.3,
    county_fips: 22079,
    county_name: "Rapides",
    county_weights: {
      22079: 100,
    },
    county_names_all: "Rapides",
    county_fips_all: 22079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71425,
    lat: 31.89017,
    lng: -91.89786,
    city: "Enterprise",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24,
    density: 0.4,
    county_fips: 22025,
    county_name: "Catahoula",
    county_weights: {
      22025: 100,
    },
    county_names_all: "Catahoula",
    county_fips_all: 22025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71426,
    lat: 31.49182,
    lng: -93.46165,
    city: "Fisher",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 198,
    density: 205.1,
    county_fips: 22085,
    county_name: "Sabine",
    county_weights: {
      22085: 100,
    },
    county_names_all: "Sabine",
    county_fips_all: 22085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71427,
    lat: 31.38879,
    lng: -92.89388,
    city: "Flatwoods",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 565,
    density: 12.1,
    county_fips: 22079,
    county_name: "Rapides",
    county_weights: {
      22069: 39.53,
      22079: 60.47,
    },
    county_names_all: "Rapides|Natchitoches",
    county_fips_all: "22079|22069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71428,
    lat: 31.60921,
    lng: -93.08855,
    city: "Flora",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 22069,
    county_name: "Natchitoches",
    county_weights: {
      22069: 100,
    },
    county_names_all: "Natchitoches",
    county_fips_all: 22069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71429,
    lat: 31.39843,
    lng: -93.43218,
    city: "Florien",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3147,
    density: 4.8,
    county_fips: 22085,
    county_name: "Sabine",
    county_weights: {
      22085: 98,
      22115: 2,
    },
    county_names_all: "Sabine|Vernon",
    county_fips_all: "22085|22115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71430,
    lat: 31.06764,
    lng: -92.53135,
    city: "Forest Hill",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3018,
    density: 9.5,
    county_fips: 22079,
    county_name: "Rapides",
    county_weights: {
      22079: 100,
    },
    county_names_all: "Rapides",
    county_fips_all: 22079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71432,
    lat: 31.75368,
    lng: -92.47435,
    city: "Georgetown",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1084,
    density: 4.2,
    county_fips: 22043,
    county_name: "Grant",
    county_weights: {
      22043: 95.08,
      22127: 4.92,
    },
    county_names_all: "Grant|Winn",
    county_fips_all: "22043|22127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71433,
    lat: 31.00208,
    lng: -92.64803,
    city: "Glenmora",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4064,
    density: 9.8,
    county_fips: 22079,
    county_name: "Rapides",
    county_weights: {
      22079: 100,
    },
    county_names_all: "Rapides",
    county_fips_all: 22079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71434,
    lat: 31.44618,
    lng: -92.944,
    city: "Gorum",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 22069,
    county_name: "Natchitoches",
    county_weights: {
      22069: 100,
    },
    county_names_all: "Natchitoches",
    county_fips_all: 22069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71435,
    lat: 32.02456,
    lng: -92.1539,
    city: "Grayson",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3832,
    density: 7,
    county_fips: 22021,
    county_name: "Caldwell",
    county_weights: {
      22021: 83.76,
      22025: 13.43,
      22059: 2.33,
      22127: 0.48,
    },
    county_names_all: "Caldwell|Catahoula|LaSalle|Winn",
    county_fips_all: "22021|22025|22059|22127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71438,
    lat: 31.10092,
    lng: -92.87511,
    city: "Hineston",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1285,
    density: 3.6,
    county_fips: 22115,
    county_name: "Vernon",
    county_weights: {
      22079: 29.72,
      22115: 70.28,
    },
    county_names_all: "Vernon|Rapides",
    county_fips_all: "22115|22079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71439,
    lat: 31.33707,
    lng: -93.36597,
    city: "Hornbeck",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2349,
    density: 14.4,
    county_fips: 22115,
    county_name: "Vernon",
    county_weights: {
      22085: 33.05,
      22115: 66.95,
    },
    county_names_all: "Vernon|Sabine",
    county_fips_all: "22115|22085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71441,
    lat: 31.94706,
    lng: -92.13805,
    city: "Kelly",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 908,
    density: 6.8,
    county_fips: 22021,
    county_name: "Caldwell",
    county_weights: {
      22021: 69.07,
      22059: 30.93,
    },
    county_names_all: "Caldwell|LaSalle",
    county_fips_all: "22021|22059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71446,
    lat: 31.15585,
    lng: -93.17187,
    city: "Leesville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20754,
    density: 12.1,
    county_fips: 22115,
    county_name: "Vernon",
    county_weights: {
      22115: 100,
    },
    county_names_all: "Vernon",
    county_fips_all: 22115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71447,
    lat: 31.43202,
    lng: -92.8073,
    city: "Lena",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1370,
    density: 3.8,
    county_fips: 22079,
    county_name: "Rapides",
    county_weights: {
      22069: 41.39,
      22079: 58.15,
      22115: 0.46,
    },
    county_names_all: "Rapides|Natchitoches|Vernon",
    county_fips_all: "22079|22069|22115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71449,
    lat: 31.5153,
    lng: -93.54383,
    city: "Many",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8851,
    density: 14.5,
    county_fips: 22085,
    county_name: "Sabine",
    county_weights: {
      22085: 100,
    },
    county_names_all: "Sabine",
    county_fips_all: 22085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71450,
    lat: 31.78137,
    lng: -93.40367,
    city: "Marthaville",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 843,
    density: 5.2,
    county_fips: 22069,
    county_name: "Natchitoches",
    county_weights: {
      22069: 78.87,
      22085: 21.13,
    },
    county_names_all: "Natchitoches|Sabine",
    county_fips_all: "22069|22085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71452,
    lat: 31.58021,
    lng: -92.9414,
    city: "Melrose",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 86,
    density: 3.1,
    county_fips: 22069,
    county_name: "Natchitoches",
    county_weights: {
      22069: 100,
    },
    county_names_all: "Natchitoches",
    county_fips_all: 22069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71454,
    lat: 31.69334,
    lng: -92.86131,
    city: "Montgomery",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2286,
    density: 8.3,
    county_fips: 22043,
    county_name: "Grant",
    county_weights: {
      22043: 61.87,
      22127: 38.13,
    },
    county_names_all: "Grant|Winn",
    county_fips_all: "22043|22127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71455,
    lat: 31.40125,
    lng: -92.98074,
    city: "Mora",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 95,
    density: 0.7,
    county_fips: 22069,
    county_name: "Natchitoches",
    county_weights: {
      22069: 85.03,
      22079: 14.97,
    },
    county_names_all: "Natchitoches|Rapides",
    county_fips_all: "22069|22079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71456,
    lat: 31.63534,
    lng: -92.97429,
    city: "Natchez",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1328,
    density: 14.2,
    county_fips: 22069,
    county_name: "Natchitoches",
    county_weights: {
      22069: 100,
    },
    county_names_all: "Natchitoches",
    county_fips_all: 22069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71457,
    lat: 31.74045,
    lng: -93.09375,
    city: "Natchitoches",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26607,
    density: 38.1,
    county_fips: 22069,
    county_name: "Natchitoches",
    county_weights: {
      22069: 95.97,
      22127: 4.03,
    },
    county_names_all: "Natchitoches|Winn",
    county_fips_all: "22069|22127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71459,
    lat: 31.07854,
    lng: -93.21723,
    city: "Fort Polk",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11223,
    density: 387.8,
    county_fips: 22115,
    county_name: "Vernon",
    county_weights: {
      22115: 100,
    },
    county_names_all: "Vernon",
    county_fips_all: 22115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71461,
    lat: 31.12099,
    lng: -93.29775,
    city: "New Llano",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2623,
    density: 421.3,
    county_fips: 22115,
    county_name: "Vernon",
    county_weights: {
      22115: 100,
    },
    county_names_all: "Vernon",
    county_fips_all: 22115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71462,
    lat: 31.66625,
    lng: -93.7324,
    city: "Noble",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1820,
    density: 15.3,
    county_fips: 22085,
    county_name: "Sabine",
    county_weights: {
      22085: 100,
    },
    county_names_all: "Sabine",
    county_fips_all: 22085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71463,
    lat: 30.80854,
    lng: -92.64853,
    city: "Oakdale",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10152,
    density: 15.6,
    county_fips: 22003,
    county_name: "Allen",
    county_weights: {
      22003: 59.92,
      22039: 29.58,
      22079: 10.5,
    },
    county_names_all: "Allen|Evangeline|Rapides",
    county_fips_all: "22003|22039|22079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71465,
    lat: 31.86499,
    lng: -92.19408,
    city: "Olla",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3676,
    density: 5.7,
    county_fips: 22059,
    county_name: "LaSalle",
    county_weights: {
      22021: 7.26,
      22025: 2.29,
      22059: 73.2,
      22127: 17.25,
    },
    county_names_all: "LaSalle|Winn|Caldwell|Catahoula",
    county_fips_all: "22059|22127|22021|22025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71466,
    lat: 31.21593,
    lng: -92.74886,
    city: "Otis",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 826,
    density: 39,
    county_fips: 22079,
    county_name: "Rapides",
    county_weights: {
      22079: 100,
    },
    county_names_all: "Rapides",
    county_fips_all: 22079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71467,
    lat: 31.55789,
    lng: -92.39338,
    city: "Pollock",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8534,
    density: 19,
    county_fips: 22043,
    county_name: "Grant",
    county_weights: {
      22043: 99.2,
      22079: 0.8,
    },
    county_names_all: "Grant|Rapides",
    county_fips_all: "22043|22079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71468,
    lat: 31.48086,
    lng: -93.14518,
    city: "Provencal",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 532,
    density: 1.1,
    county_fips: 22069,
    county_name: "Natchitoches",
    county_weights: {
      22069: 100,
    },
    county_names_all: "Natchitoches",
    county_fips_all: 22069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71469,
    lat: 31.67755,
    lng: -93.2671,
    city: "Robeline",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2550,
    density: 4.5,
    county_fips: 22069,
    county_name: "Natchitoches",
    county_weights: {
      22069: 84.32,
      22085: 15.68,
    },
    county_names_all: "Natchitoches|Sabine",
    county_fips_all: "22069|22085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71472,
    lat: 31.19834,
    lng: -92.79216,
    city: "Sieper",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 327,
    density: 6.1,
    county_fips: 22079,
    county_name: "Rapides",
    county_weights: {
      22079: 100,
    },
    county_names_all: "Rapides",
    county_fips_all: 22079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71473,
    lat: 32.06989,
    lng: -92.42748,
    city: "Sikes",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 387,
    density: 1.2,
    county_fips: 22127,
    county_name: "Winn",
    county_weights: {
      22049: 0.13,
      22127: 99.87,
    },
    county_names_all: "Winn|Jackson",
    county_fips_all: "22127|22049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71474,
    lat: 31.27724,
    lng: -93.01394,
    city: "Simpson",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 447,
    density: 8.1,
    county_fips: 22115,
    county_name: "Vernon",
    county_weights: {
      22115: 100,
    },
    county_names_all: "Vernon",
    county_fips_all: 22115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71475,
    lat: 31.20123,
    lng: -93.12461,
    city: "Slagle",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 22115,
    county_name: "Vernon",
    county_weights: {
      22115: 100,
    },
    county_names_all: "Vernon",
    county_fips_all: 22115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71479,
    lat: 31.85129,
    lng: -92.36106,
    city: "Tullos",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 866,
    density: 4.1,
    county_fips: 22127,
    county_name: "Winn",
    county_weights: {
      22059: 31.17,
      22127: 68.83,
    },
    county_names_all: "Winn|LaSalle",
    county_fips_all: "22127|22059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71480,
    lat: 31.86661,
    lng: -92.28415,
    city: "Urania",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1464,
    density: 143.7,
    county_fips: 22059,
    county_name: "LaSalle",
    county_weights: {
      22059: 100,
    },
    county_names_all: "LaSalle",
    county_fips_all: 22059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71483,
    lat: 31.89482,
    lng: -92.66373,
    city: "Winnfield",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10262,
    density: 10.9,
    county_fips: 22127,
    county_name: "Winn",
    county_weights: {
      22127: 100,
    },
    county_names_all: "Winn",
    county_fips_all: 22127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71485,
    lat: 31.17811,
    lng: -92.53186,
    city: "Woodworth",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2654,
    density: 22.3,
    county_fips: 22079,
    county_name: "Rapides",
    county_weights: {
      22079: 100,
    },
    county_names_all: "Rapides",
    county_fips_all: 22079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71486,
    lat: 31.62679,
    lng: -93.65876,
    city: "Zwolle",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5739,
    density: 22.1,
    county_fips: 22085,
    county_name: "Sabine",
    county_weights: {
      22085: 100,
    },
    county_names_all: "Sabine",
    county_fips_all: 22085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71497,
    lat: 31.74902,
    lng: -93.09795,
    city: "Natchitoches",
    state_id: "LA",
    state_name: "Louisiana",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 22069,
    county_name: "Natchitoches",
    county_weights: {
      22069: 100,
    },
    county_names_all: "Natchitoches",
    county_fips_all: 22069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71601,
    lat: 34.17409,
    lng: -91.89811,
    city: "Pine Bluff",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14119,
    density: 47.3,
    county_fips: "05069",
    county_name: "Jefferson",
    county_weights: {
      "05069": 99.53,
      "05079": 0.47,
    },
    county_names_all: "Jefferson|Lincoln",
    county_fips_all: "05069|05079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71602,
    lat: 34.27463,
    lng: -92.13302,
    city: "White Hall",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15642,
    density: 46.1,
    county_fips: "05069",
    county_name: "Jefferson",
    county_weights: {
      "05069": 83.32,
      "05053": 16.68,
    },
    county_names_all: "Jefferson|Grant",
    county_fips_all: "05069|05053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71603,
    lat: 34.12881,
    lng: -92.08492,
    city: "Pine Bluff",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30791,
    density: 70.8,
    county_fips: "05069",
    county_name: "Jefferson",
    county_weights: {
      "05069": 84.6,
      "05079": 7.69,
      "05025": 5.23,
      "05053": 2.48,
    },
    county_names_all: "Jefferson|Lincoln|Cleveland|Grant",
    county_fips_all: "05069|05079|05025|05053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71630,
    lat: 33.61827,
    lng: -91.23004,
    city: "Arkansas City",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 513,
    density: 8.4,
    county_fips: "05041",
    county_name: "Desha",
    county_weights: {
      "05041": 100,
    },
    county_names_all: "Desha",
    county_fips_all: "05041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71631,
    lat: 33.58205,
    lng: -92.26415,
    city: "Banks",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 547,
    density: 1.7,
    county_fips: "05011",
    county_name: "Bradley",
    county_weights: {
      "05011": 100,
    },
    county_names_all: "Bradley",
    county_fips_all: "05011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71635,
    lat: 33.1369,
    lng: -92.00133,
    city: "Crossett",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11501,
    density: 20,
    county_fips: "05003",
    county_name: "Ashley",
    county_weights: {
      "05003": 99.84,
      "05011": 0.16,
    },
    county_names_all: "Ashley|Bradley",
    county_fips_all: "05003|05011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71638,
    lat: 33.52008,
    lng: -91.47927,
    city: "Dermott",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3549,
    density: 5.6,
    county_fips: "05043",
    county_name: "Drew",
    county_weights: {
      "05043": 66.05,
      "05017": 25.43,
      "05041": 8.52,
    },
    county_names_all: "Drew|Chicot|Desha",
    county_fips_all: "05043|05017|05041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71639,
    lat: 33.89143,
    lng: -91.54414,
    city: "Dumas",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5633,
    density: 11.8,
    county_fips: "05079",
    county_name: "Lincoln",
    county_weights: {
      "05079": 52.26,
      "05041": 47.74,
    },
    county_names_all: "Lincoln|Desha",
    county_fips_all: "05079|05041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71640,
    lat: 33.1253,
    lng: -91.24753,
    city: "Eudora",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2960,
    density: 5,
    county_fips: "05017",
    county_name: "Chicot",
    county_weights: {
      "05017": 100,
    },
    county_names_all: "Chicot",
    county_fips_all: "05017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71642,
    lat: 33.38842,
    lng: -91.8788,
    city: "Fountain Hill",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 659,
    density: 3.7,
    county_fips: "05003",
    county_name: "Ashley",
    county_weights: {
      "05003": 57.96,
      "05043": 42.04,
    },
    county_names_all: "Ashley|Drew",
    county_fips_all: "05003|05043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71643,
    lat: 34.01953,
    lng: -91.57945,
    city: "Gould",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1023,
    density: 2.9,
    county_fips: "05079",
    county_name: "Lincoln",
    county_weights: {
      "05079": 92.81,
      "05041": 7.19,
    },
    county_names_all: "Lincoln|Desha",
    county_fips_all: "05079|05041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71644,
    lat: 34.11045,
    lng: -91.71213,
    city: "Grady",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5268,
    density: 34.7,
    county_fips: "05079",
    county_name: "Lincoln",
    county_weights: {
      "05079": 69,
      "05069": 31,
    },
    county_names_all: "Lincoln|Jefferson",
    county_fips_all: "05079|05069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71646,
    lat: 33.20444,
    lng: -91.77837,
    city: "Hamburg",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5915,
    density: 6.1,
    county_fips: "05003",
    county_name: "Ashley",
    county_weights: {
      "05003": 96.31,
      "05043": 3.69,
    },
    county_names_all: "Ashley|Drew",
    county_fips_all: "05003|05043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71647,
    lat: 33.36678,
    lng: -92.12219,
    city: "Hermitage",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2276,
    density: 3.4,
    county_fips: "05011",
    county_name: "Bradley",
    county_weights: {
      "05011": 100,
    },
    county_names_all: "Bradley",
    county_fips_all: "05011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71651,
    lat: 33.31472,
    lng: -92.28377,
    city: "Jersey",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55,
    density: 0.3,
    county_fips: "05011",
    county_name: "Bradley",
    county_weights: {
      "05011": 100,
    },
    county_names_all: "Bradley",
    county_fips_all: "05011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71652,
    lat: 33.89338,
    lng: -92.31562,
    city: "Kingsland",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1236,
    density: 4.3,
    county_fips: "05025",
    county_name: "Cleveland",
    county_weights: {
      "05025": 100,
    },
    county_names_all: "Cleveland",
    county_fips_all: "05025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71653,
    lat: 33.36919,
    lng: -91.27676,
    city: "Lake Village",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4300,
    density: 6.4,
    county_fips: "05017",
    county_name: "Chicot",
    county_weights: {
      "05017": 100,
    },
    county_names_all: "Chicot",
    county_fips_all: "05017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71654,
    lat: 33.62476,
    lng: -91.37234,
    city: "McGehee",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4302,
    density: 23.9,
    county_fips: "05041",
    county_name: "Desha",
    county_weights: {
      "05041": 100,
    },
    county_names_all: "Desha",
    county_fips_all: "05041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71655,
    lat: 33.62874,
    lng: -91.7486,
    city: "Monticello",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15445,
    density: 16.3,
    county_fips: "05043",
    county_name: "Drew",
    county_weights: {
      "05043": 99.32,
      "05079": 0.68,
    },
    county_names_all: "Drew|Lincoln",
    county_fips_all: "05043|05079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71658,
    lat: 33.32018,
    lng: -91.57635,
    city: "Montrose",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 745,
    density: 2.4,
    county_fips: "05003",
    county_name: "Ashley",
    county_weights: {
      "05003": 97.36,
      "05043": 2.64,
    },
    county_names_all: "Ashley|Drew",
    county_fips_all: "05003|05043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71659,
    lat: 34.13505,
    lng: -91.78071,
    city: "Moscow",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 182,
    density: 348.7,
    county_fips: "05069",
    county_name: "Jefferson",
    county_weights: {
      "05069": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "05069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71660,
    lat: 33.7627,
    lng: -92.19728,
    city: "New Edinburg",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 901,
    density: 3.1,
    county_fips: "05025",
    county_name: "Cleveland",
    county_weights: {
      "05025": 99.62,
      "05011": 0.38,
    },
    county_names_all: "Cleveland|Bradley",
    county_fips_all: "05025|05011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71661,
    lat: 33.14338,
    lng: -91.51333,
    city: "Parkdale",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 406,
    density: 1.8,
    county_fips: "05003",
    county_name: "Ashley",
    county_weights: {
      "05003": 75.8,
      "05017": 24.2,
    },
    county_names_all: "Ashley|Chicot",
    county_fips_all: "05003|05017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71662,
    lat: 33.82355,
    lng: -91.50391,
    city: "Pickens",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 89,
    density: 1.5,
    county_fips: "05041",
    county_name: "Desha",
    county_weights: {
      "05041": 100,
    },
    county_names_all: "Desha",
    county_fips_all: "05041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71663,
    lat: 33.22755,
    lng: -91.42665,
    city: "Portland",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 560,
    density: 2.6,
    county_fips: "05017",
    county_name: "Chicot",
    county_weights: {
      "05017": 63.95,
      "05003": 36.05,
    },
    county_names_all: "Chicot|Ashley",
    county_fips_all: "05017|05003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71665,
    lat: 33.93812,
    lng: -92.13163,
    city: "Rison",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5359,
    density: 6.4,
    county_fips: "05025",
    county_name: "Cleveland",
    county_weights: {
      "05025": 97.25,
      "05069": 2.75,
    },
    county_names_all: "Cleveland|Jefferson",
    county_fips_all: "05025|05069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71666,
    lat: 33.7372,
    lng: -91.24736,
    city: "Rohwer",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05041",
    county_name: "Desha",
    county_weights: {
      "05041": 100,
    },
    county_names_all: "Desha",
    county_fips_all: "05041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71667,
    lat: 33.93588,
    lng: -91.84412,
    city: "Star City",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6568,
    density: 9.2,
    county_fips: "05079",
    county_name: "Lincoln",
    county_weights: {
      "05079": 94.73,
      "05025": 5.27,
    },
    county_names_all: "Lincoln|Cleveland",
    county_fips_all: "05079|05025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71670,
    lat: 33.74439,
    lng: -91.40974,
    city: "Tillar",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1077,
    density: 2.1,
    county_fips: "05041",
    county_name: "Desha",
    county_weights: {
      "05041": 70.25,
      "05043": 29.75,
    },
    county_names_all: "Desha|Drew",
    county_fips_all: "05041|05043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71671,
    lat: 33.60652,
    lng: -92.10006,
    city: "Warren",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8246,
    density: 17.7,
    county_fips: "05011",
    county_name: "Bradley",
    county_weights: {
      "05011": 92.99,
      "05025": 3.98,
      "05043": 3.03,
    },
    county_names_all: "Bradley|Cleveland|Drew",
    county_fips_all: "05011|05025|05043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71674,
    lat: 33.82694,
    lng: -91.18261,
    city: "Watson",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 579,
    density: 1,
    county_fips: "05041",
    county_name: "Desha",
    county_weights: {
      "05041": 100,
    },
    county_names_all: "Desha",
    county_fips_all: "05041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71675,
    lat: 33.60424,
    lng: -91.93805,
    city: "Wilmar",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1722,
    density: 3.9,
    county_fips: "05043",
    county_name: "Drew",
    county_weights: {
      "05043": 83.71,
      "05011": 10.34,
      "05079": 5.95,
    },
    county_names_all: "Drew|Bradley|Lincoln",
    county_fips_all: "05043|05011|05079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71676,
    lat: 33.05156,
    lng: -91.56023,
    city: "Wilmot",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 569,
    density: 2.4,
    county_fips: "05003",
    county_name: "Ashley",
    county_weights: {
      "05003": 86.8,
      "05017": 13.2,
    },
    county_names_all: "Ashley|Chicot",
    county_fips_all: "05003|05017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71677,
    lat: 33.76572,
    lng: -91.4884,
    city: "Winchester",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 152,
    density: 9.8,
    county_fips: "05043",
    county_name: "Drew",
    county_weights: {
      "05043": 100,
    },
    county_names_all: "Drew",
    county_fips_all: "05043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71678,
    lat: 34.0254,
    lng: -91.81548,
    city: "Yorktown",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05079",
    county_name: "Lincoln",
    county_weights: {
      "05079": 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: "05079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71701,
    lat: 33.57837,
    lng: -92.81309,
    city: "Camden",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18626,
    density: 25,
    county_fips: "05103",
    county_name: "Ouachita",
    county_weights: {
      "05103": 81.16,
      "05013": 18.84,
    },
    county_names_all: "Ouachita|Calhoun",
    county_fips_all: "05103|05013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71720,
    lat: 33.79075,
    lng: -92.64163,
    city: "Bearden",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2103,
    density: 5.6,
    county_fips: "05103",
    county_name: "Ouachita",
    county_weights: {
      "05103": 54.19,
      "05039": 39.88,
      "05013": 5.93,
    },
    county_names_all: "Ouachita|Dallas|Calhoun",
    county_fips_all: "05103|05039|05013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71721,
    lat: 33.89091,
    lng: -93.20635,
    city: "Beirne",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05019",
    county_name: "Clark",
    county_weights: {
      "05019": 100,
    },
    county_names_all: "Clark",
    county_fips_all: "05019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71722,
    lat: 33.71045,
    lng: -93.15537,
    city: "Bluff City",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 83,
    density: 1.7,
    county_fips: "05099",
    county_name: "Nevada",
    county_weights: {
      "05099": 100,
    },
    county_names_all: "Nevada",
    county_fips_all: "05099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71724,
    lat: 33.326,
    lng: -92.54053,
    city: "Calion",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 404,
    density: 86.3,
    county_fips: "05139",
    county_name: "Union",
    county_weights: {
      "05139": 100,
    },
    county_names_all: "Union",
    county_fips_all: "05139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71725,
    lat: 34.03791,
    lng: -92.53252,
    city: "Carthage",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 268,
    density: 0.5,
    county_fips: "05039",
    county_name: "Dallas",
    county_weights: {
      "05039": 84.24,
      "05025": 15.76,
    },
    county_names_all: "Dallas|Cleveland",
    county_fips_all: "05039|05025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71726,
    lat: 33.68016,
    lng: -92.99584,
    city: "Chidester",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 977,
    density: 1.9,
    county_fips: "05103",
    county_name: "Ouachita",
    county_weights: {
      "05103": 99,
      "05099": 1,
    },
    county_names_all: "Ouachita|Nevada",
    county_fips_all: "05103|05099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71728,
    lat: 34.0089,
    lng: -93.1053,
    city: "Curtis",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05019",
    county_name: "Clark",
    county_weights: {
      "05019": 100,
    },
    county_names_all: "Clark",
    county_fips_all: "05019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71730,
    lat: 33.20303,
    lng: -92.63458,
    city: "El Dorado",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29320,
    density: 24.7,
    county_fips: "05139",
    county_name: "Union",
    county_weights: {
      "05139": 100,
    },
    county_names_all: "Union",
    county_fips_all: "05139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71740,
    lat: 33.08121,
    lng: -93.16268,
    city: "Emerson",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1701,
    density: 3.6,
    county_fips: "05027",
    county_name: "Columbia",
    county_weights: {
      "05027": 100,
    },
    county_names_all: "Columbia",
    county_fips_all: "05027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71742,
    lat: 33.83435,
    lng: -92.44545,
    city: "Fordyce",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5373,
    density: 12.2,
    county_fips: "05039",
    county_name: "Dallas",
    county_weights: {
      "05039": 68.66,
      "05013": 31.34,
    },
    county_names_all: "Dallas|Calhoun",
    county_fips_all: "05039|05013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71743,
    lat: 33.88674,
    lng: -93.11724,
    city: "Gurdon",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3617,
    density: 6.7,
    county_fips: "05019",
    county_name: "Clark",
    county_weights: {
      "05019": 100,
    },
    county_names_all: "Clark",
    county_fips_all: "05019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71744,
    lat: 33.49201,
    lng: -92.47536,
    city: "Hampton",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2957,
    density: 2.9,
    county_fips: "05013",
    county_name: "Calhoun",
    county_weights: {
      "05013": 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: "05013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71745,
    lat: 33.4997,
    lng: -92.39496,
    city: "Harrell",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 347,
    density: 100.1,
    county_fips: "05013",
    county_name: "Calhoun",
    county_weights: {
      "05013": 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: "05013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71747,
    lat: 33.05892,
    lng: -92.22238,
    city: "Huttig",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1053,
    density: 4.7,
    county_fips: "05139",
    county_name: "Union",
    county_weights: {
      "05139": 100,
    },
    county_names_all: "Union",
    county_fips_all: "05139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71748,
    lat: 33.90296,
    lng: -92.43322,
    city: "Ivan",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05039",
    county_name: "Dallas",
    county_weights: {
      "05039": 100,
    },
    county_names_all: "Dallas",
    county_fips_all: "05039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71749,
    lat: 33.07049,
    lng: -92.81964,
    city: "Junction City",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2904,
    density: 7,
    county_fips: "05139",
    county_name: "Union",
    county_weights: {
      22027: 1.63,
      22111: 0.13,
      "05139": 98.24,
    },
    county_names_all: "Union|Claiborne|Union",
    county_fips_all: "05139|22027|22111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71751,
    lat: 33.40835,
    lng: -92.77252,
    city: "Louann",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 883,
    density: 4.2,
    county_fips: "05103",
    county_name: "Ouachita",
    county_weights: {
      "05103": 100,
    },
    county_names_all: "Ouachita",
    county_fips_all: "05103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71752,
    lat: 33.40061,
    lng: -93.19454,
    city: "McNeil",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 665,
    density: 6.7,
    county_fips: "05027",
    county_name: "Columbia",
    county_weights: {
      "05027": 98.6,
      "05099": 1.4,
    },
    county_names_all: "Columbia|Nevada",
    county_fips_all: "05027|05099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71753,
    lat: 33.22974,
    lng: -93.18461,
    city: "Magnolia",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16958,
    density: 21,
    county_fips: "05027",
    county_name: "Columbia",
    county_weights: {
      "05027": 95.91,
      "05139": 4.09,
    },
    county_names_all: "Columbia|Union",
    county_fips_all: "05027|05139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71758,
    lat: 33.30899,
    lng: -92.91435,
    city: "Mount Holly",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 121,
    density: 0.7,
    county_fips: "05139",
    county_name: "Union",
    county_weights: {
      "05139": 100,
    },
    county_names_all: "Union",
    county_fips_all: "05139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71759,
    lat: 33.31506,
    lng: -92.65967,
    city: "Norphlet",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 768,
    density: 335,
    county_fips: "05139",
    county_name: "Union",
    county_weights: {
      "05139": 100,
    },
    county_names_all: "Union",
    county_fips_all: "05139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71762,
    lat: 33.33668,
    lng: -92.76767,
    city: "Smackover",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2543,
    density: 16.3,
    county_fips: "05139",
    county_name: "Union",
    county_weights: {
      "05139": 90.71,
      "05103": 9.29,
    },
    county_names_all: "Union|Ouachita",
    county_fips_all: "05139|05103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71763,
    lat: 33.90885,
    lng: -92.80648,
    city: "Sparkman",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1642,
    density: 2.6,
    county_fips: "05039",
    county_name: "Dallas",
    county_weights: {
      "05039": 85.21,
      "05103": 11.03,
      "05019": 3.76,
    },
    county_names_all: "Dallas|Ouachita|Clark",
    county_fips_all: "05039|05103|05019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71764,
    lat: 33.43041,
    lng: -93.04475,
    city: "Stephens",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1879,
    density: 4,
    county_fips: "05103",
    county_name: "Ouachita",
    county_weights: {
      "05103": 63.16,
      "05027": 23.27,
      "05099": 13.05,
      "05139": 0.52,
    },
    county_names_all: "Ouachita|Columbia|Nevada|Union",
    county_fips_all: "05103|05027|05099|05139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71765,
    lat: 33.13358,
    lng: -92.33628,
    city: "Strong",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2397,
    density: 4.7,
    county_fips: "05139",
    county_name: "Union",
    county_weights: {
      "05139": 100,
    },
    county_names_all: "Union",
    county_fips_all: "05139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71766,
    lat: 33.7362,
    lng: -92.50205,
    city: "Thornton",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 786,
    density: 6,
    county_fips: "05013",
    county_name: "Calhoun",
    county_weights: {
      "05013": 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: "05013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71770,
    lat: 33.38847,
    lng: -93.31607,
    city: "Waldo",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2967,
    density: 7.7,
    county_fips: "05027",
    county_name: "Columbia",
    county_weights: {
      "05027": 73.53,
      "05099": 26.47,
    },
    county_names_all: "Columbia|Nevada",
    county_fips_all: "05027|05099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71772,
    lat: 33.83379,
    lng: -93.12646,
    city: "Whelen Springs",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "05019",
    county_name: "Clark",
    county_weights: {
      "05019": 100,
    },
    county_names_all: "Clark",
    county_fips_all: "05019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71801,
    lat: 33.63306,
    lng: -93.59833,
    city: "Hope",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17268,
    density: 22.4,
    county_fips: "05057",
    county_name: "Hempstead",
    county_weights: {
      "05057": 97.91,
      "05073": 2.09,
    },
    county_names_all: "Hempstead|Lafayette",
    county_fips_all: "05057|05073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71820,
    lat: 33.78886,
    lng: -94.24421,
    city: "Alleene",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 106,
    density: 3.5,
    county_fips: "05081",
    county_name: "Little River",
    county_weights: {
      "05081": 100,
    },
    county_names_all: "Little River",
    county_fips_all: "05081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71822,
    lat: 33.66946,
    lng: -94.14755,
    city: "Ashdown",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8320,
    density: 13,
    county_fips: "05081",
    county_name: "Little River",
    county_weights: {
      "05081": 100,
    },
    county_names_all: "Little River",
    county_fips_all: "05081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71823,
    lat: 33.83101,
    lng: -94.12547,
    city: "Ben Lomond",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28,
    density: 8.5,
    county_fips: "05133",
    county_name: "Sevier",
    county_weights: {
      "05133": 100,
    },
    county_names_all: "Sevier",
    county_fips_all: "05133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71825,
    lat: 33.87554,
    lng: -93.56489,
    city: "Blevins",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 480,
    density: 7,
    county_fips: "05057",
    county_name: "Hempstead",
    county_weights: {
      "05057": 100,
    },
    county_names_all: "Hempstead",
    county_fips_all: "05057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71826,
    lat: 33.08994,
    lng: -93.72536,
    city: "Bradley",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1190,
    density: 3.7,
    county_fips: "05073",
    county_name: "Lafayette",
    county_weights: {
      "05073": 100,
    },
    county_names_all: "Lafayette",
    county_fips_all: "05073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71827,
    lat: 33.41186,
    lng: -93.41463,
    city: "Buckner",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 881,
    density: 5.4,
    county_fips: "05073",
    county_name: "Lafayette",
    county_weights: {
      "05073": 63.35,
      "05099": 36.65,
    },
    county_names_all: "Lafayette|Nevada",
    county_fips_all: "05073|05099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71831,
    lat: 33.7762,
    lng: -93.85971,
    city: "Columbus",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05061",
    county_name: "Howard",
    county_weights: {
      "05061": 81.35,
      "05057": 18.65,
    },
    county_names_all: "Howard|Hempstead",
    county_fips_all: "05061|05057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71832,
    lat: 34.0397,
    lng: -94.34791,
    city: "De Queen",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11063,
    density: 23.4,
    county_fips: "05133",
    county_name: "Sevier",
    county_weights: {
      "05133": 100,
    },
    county_names_all: "Sevier",
    county_fips_all: "05133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71833,
    lat: 34.13409,
    lng: -94.02665,
    city: "Dierks",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1943,
    density: 5.1,
    county_fips: "05061",
    county_name: "Howard",
    county_weights: {
      "05061": 89.46,
      "05133": 10.54,
    },
    county_names_all: "Howard|Sevier",
    county_fips_all: "05061|05133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71834,
    lat: 33.11552,
    lng: -93.9577,
    city: "Doddridge",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1611,
    density: 4.3,
    county_fips: "05091",
    county_name: "Miller",
    county_weights: {
      "05091": 100,
    },
    county_names_all: "Miller",
    county_fips_all: "05091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71835,
    lat: 33.66724,
    lng: -93.4425,
    city: "Emmet",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 980,
    density: 4.3,
    county_fips: "05099",
    county_name: "Nevada",
    county_weights: {
      "05099": 81.66,
      "05057": 18.34,
    },
    county_names_all: "Nevada|Hempstead",
    county_fips_all: "05099|05057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71836,
    lat: 33.71297,
    lng: -94.39584,
    city: "Foreman",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2898,
    density: 6.3,
    county_fips: "05081",
    county_name: "Little River",
    county_weights: {
      "05081": 100,
    },
    county_names_all: "Little River",
    county_fips_all: "05081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71837,
    lat: 33.25543,
    lng: -93.85693,
    city: "Fouke",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4843,
    density: 11.6,
    county_fips: "05091",
    county_name: "Miller",
    county_weights: {
      "05091": 100,
    },
    county_names_all: "Miller",
    county_fips_all: "05091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71838,
    lat: 33.64916,
    lng: -93.79753,
    city: "Fulton",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 893,
    density: 2.9,
    county_fips: "05057",
    county_name: "Hempstead",
    county_weights: {
      "05057": 94.05,
      "05091": 5.95,
    },
    county_names_all: "Hempstead|Miller",
    county_fips_all: "05057|05091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71839,
    lat: 33.30619,
    lng: -93.73891,
    city: "Garland City",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 250,
    density: 2.2,
    county_fips: "05091",
    county_name: "Miller",
    county_weights: {
      "05091": 100,
    },
    county_names_all: "Miller",
    county_fips_all: "05091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71841,
    lat: 34.1639,
    lng: -94.34718,
    city: "Gillham",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 943,
    density: 5.6,
    county_fips: "05133",
    county_name: "Sevier",
    county_weights: {
      "05133": 87.35,
      "05113": 12.65,
    },
    county_names_all: "Sevier|Polk",
    county_fips_all: "05133|05113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71842,
    lat: 33.90051,
    lng: -94.29297,
    city: "Horatio",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2263,
    density: 12.8,
    county_fips: "05133",
    county_name: "Sevier",
    county_weights: {
      "05133": 100,
    },
    county_names_all: "Sevier",
    county_fips_all: "05133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71845,
    lat: 33.32005,
    lng: -93.63365,
    city: "Lewisville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1789,
    density: 3.4,
    county_fips: "05073",
    county_name: "Lafayette",
    county_weights: {
      "05073": 100,
    },
    county_names_all: "Lafayette",
    county_fips_all: "05073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71846,
    lat: 33.9265,
    lng: -94.12367,
    city: "Lockesburg",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2743,
    density: 4.6,
    county_fips: "05133",
    county_name: "Sevier",
    county_weights: {
      "05133": 95.91,
      "05081": 4.09,
    },
    county_names_all: "Sevier|Little River",
    county_fips_all: "05133|05081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71847,
    lat: 33.92616,
    lng: -93.63361,
    city: "McCaskill",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 417,
    density: 2.9,
    county_fips: "05057",
    county_name: "Hempstead",
    county_weights: {
      "05057": 100,
    },
    county_names_all: "Hempstead",
    county_fips_all: "05057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71851,
    lat: 33.85728,
    lng: -93.94658,
    city: "Mineral Springs",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1979,
    density: 9.4,
    county_fips: "05061",
    county_name: "Howard",
    county_weights: {
      "05061": 100,
    },
    county_names_all: "Howard",
    county_fips_all: "05061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71852,
    lat: 33.99489,
    lng: -93.85831,
    city: "Nashville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9877,
    density: 15.1,
    county_fips: "05061",
    county_name: "Howard",
    county_weights: {
      "05061": 62.82,
      "05109": 18.89,
      "05057": 18.29,
    },
    county_names_all: "Howard|Pike|Hempstead",
    county_fips_all: "05061|05109|05057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71853,
    lat: 33.59442,
    lng: -93.95635,
    city: "Ogden",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 280,
    density: 2.8,
    county_fips: "05081",
    county_name: "Little River",
    county_weights: {
      "05081": 100,
    },
    county_names_all: "Little River",
    county_fips_all: "05081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71854,
    lat: 33.44445,
    lng: -93.90504,
    city: "Texarkana",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36811,
    density: 52.7,
    county_fips: "05091",
    county_name: "Miller",
    county_weights: {
      "05091": 100,
    },
    county_names_all: "Miller",
    county_fips_all: "05091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71855,
    lat: 33.86612,
    lng: -93.74351,
    city: "Ozan",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 310,
    density: 2.2,
    county_fips: "05057",
    county_name: "Hempstead",
    county_weights: {
      "05057": 100,
    },
    county_names_all: "Hempstead",
    county_fips_all: "05057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71857,
    lat: 33.80422,
    lng: -93.34795,
    city: "Prescott",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4849,
    density: 6.7,
    county_fips: "05099",
    county_name: "Nevada",
    county_weights: {
      "05099": 86.83,
      "05057": 13.17,
    },
    county_names_all: "Nevada|Hempstead",
    county_fips_all: "05099|05057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71858,
    lat: 33.58543,
    lng: -93.26706,
    city: "Rosston",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2216,
    density: 4.4,
    county_fips: "05099",
    county_name: "Nevada",
    county_weights: {
      "05099": 100,
    },
    county_names_all: "Nevada",
    county_fips_all: "05099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71859,
    lat: 33.7143,
    lng: -93.92379,
    city: "Saratoga",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 617,
    density: 9.8,
    county_fips: "05057",
    county_name: "Hempstead",
    county_weights: {
      "05057": 81.64,
      "05061": 18.36,
    },
    county_names_all: "Hempstead|Howard",
    county_fips_all: "05057|05061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71860,
    lat: 33.307,
    lng: -93.49286,
    city: "Stamps",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2180,
    density: 8,
    county_fips: "05073",
    county_name: "Lafayette",
    county_weights: {
      "05073": 74.66,
      "05027": 22.99,
      "05099": 2.35,
    },
    county_names_all: "Lafayette|Columbia|Nevada",
    county_fips_all: "05073|05027|05099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71861,
    lat: 33.1039,
    lng: -93.4941,
    city: "Taylor",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2246,
    density: 5.9,
    county_fips: "05073",
    county_name: "Lafayette",
    county_weights: {
      "05073": 55.47,
      "05027": 44.53,
    },
    county_names_all: "Lafayette|Columbia",
    county_fips_all: "05073|05027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71862,
    lat: 33.76814,
    lng: -93.72321,
    city: "Washington",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 701,
    density: 4.3,
    county_fips: "05057",
    county_name: "Hempstead",
    county_weights: {
      "05057": 100,
    },
    county_names_all: "Hempstead",
    county_fips_all: "05057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71864,
    lat: 33.50997,
    lng: -93.28868,
    city: "Willisville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05099",
    county_name: "Nevada",
    county_weights: {
      "05099": 100,
    },
    county_names_all: "Nevada",
    county_fips_all: "05099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71865,
    lat: 33.74169,
    lng: -94.14598,
    city: "Wilton",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 192,
    density: 88.1,
    county_fips: "05081",
    county_name: "Little River",
    county_weights: {
      "05081": 100,
    },
    county_names_all: "Little River",
    county_fips_all: "05081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71866,
    lat: 33.86738,
    lng: -94.38042,
    city: "Winthrop",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 549,
    density: 4,
    county_fips: "05081",
    county_name: "Little River",
    county_weights: {
      "05081": 99.81,
      "05133": 0.19,
    },
    county_names_all: "Little River|Sevier",
    county_fips_all: "05081|05133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71901,
    lat: 34.52682,
    lng: -92.97247,
    city: "Hot Springs National Park",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29965,
    density: 113.5,
    county_fips: "05051",
    county_name: "Garland",
    county_weights: {
      "05051": 99.41,
      "05059": 0.59,
    },
    county_names_all: "Garland|Hot Spring",
    county_fips_all: "05051|05059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71909,
    lat: 34.64106,
    lng: -92.99608,
    city: "Hot Springs Village",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16049,
    density: 78.1,
    county_fips: "05051",
    county_name: "Garland",
    county_weights: {
      "05051": 72.29,
      "05125": 27.71,
    },
    county_names_all: "Garland|Saline",
    county_fips_all: "05051|05125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71913,
    lat: 34.44677,
    lng: -93.09981,
    city: "Hot Springs National Park",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47190,
    density: 135.8,
    county_fips: "05051",
    county_name: "Garland",
    county_weights: {
      "05051": 77.56,
      "05059": 22.44,
    },
    county_names_all: "Garland|Hot Spring",
    county_fips_all: "05051|05059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71921,
    lat: 34.25435,
    lng: -93.40109,
    city: "Amity",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3552,
    density: 6.8,
    county_fips: "05019",
    county_name: "Clark",
    county_weights: {
      "05019": 69.81,
      "05109": 21.6,
      "05059": 8.59,
    },
    county_names_all: "Clark|Pike|Hot Spring",
    county_fips_all: "05019|05109|05059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71922,
    lat: 34.02444,
    lng: -93.41943,
    city: "Antoine",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 174,
    density: 32.6,
    county_fips: "05109",
    county_name: "Pike",
    county_weights: {
      "05109": 100,
    },
    county_names_all: "Pike",
    county_fips_all: "05109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71923,
    lat: 34.08424,
    lng: -93.05551,
    city: "Arkadelphia",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15334,
    density: 15.5,
    county_fips: "05019",
    county_name: "Clark",
    county_weights: {
      "05019": 89.04,
      "05059": 6.77,
      "05039": 4.19,
    },
    county_names_all: "Clark|Hot Spring|Dallas",
    county_fips_all: "05019|05059|05039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71929,
    lat: 34.30527,
    lng: -93.1553,
    city: "Bismarck",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4552,
    density: 17.6,
    county_fips: "05059",
    county_name: "Hot Spring",
    county_weights: {
      "05059": 97.65,
      "05019": 2.35,
    },
    county_names_all: "Hot Spring|Clark",
    county_fips_all: "05059|05019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71933,
    lat: 34.41037,
    lng: -93.39124,
    city: "Bonnerdale",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1304,
    density: 6.5,
    county_fips: "05051",
    county_name: "Garland",
    county_weights: {
      "05051": 37.35,
      "05097": 34.96,
      "05059": 27.69,
    },
    county_names_all: "Garland|Montgomery|Hot Spring",
    county_fips_all: "05051|05097|05059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71935,
    lat: 34.39338,
    lng: -93.75009,
    city: "Caddo Gap",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 494,
    density: 1.5,
    county_fips: "05097",
    county_name: "Montgomery",
    county_weights: {
      "05097": 99.57,
      "05109": 0.43,
    },
    county_names_all: "Montgomery|Pike",
    county_fips_all: "05097|05109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71937,
    lat: 34.40177,
    lng: -94.38751,
    city: "Cove",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2199,
    density: 10.4,
    county_fips: "05113",
    county_name: "Polk",
    county_weights: {
      40089: 6.22,
      "05113": 93.78,
    },
    county_names_all: "Polk|McCurtain",
    county_fips_all: "05113|40089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71940,
    lat: 34.01527,
    lng: -93.50705,
    city: "Delight",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1770,
    density: 7.1,
    county_fips: "05109",
    county_name: "Pike",
    county_weights: {
      "05109": 100,
    },
    county_names_all: "Pike",
    county_fips_all: "05109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71941,
    lat: 34.2487,
    lng: -92.95312,
    city: "Donaldson",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2333,
    density: 12.8,
    county_fips: "05059",
    county_name: "Hot Spring",
    county_weights: {
      "05059": 100,
    },
    county_names_all: "Hot Spring",
    county_fips_all: "05059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71942,
    lat: 34.22124,
    lng: -92.99429,
    city: "Friendship",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05059",
    county_name: "Hot Spring",
    county_weights: {
      "05059": 100,
    },
    county_names_all: "Hot Spring",
    county_fips_all: "05059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71943,
    lat: 34.33488,
    lng: -93.60633,
    city: "Glenwood",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4162,
    density: 13.6,
    county_fips: "05109",
    county_name: "Pike",
    county_weights: {
      "05109": 64.82,
      "05097": 32.72,
      "05059": 2.46,
    },
    county_names_all: "Pike|Montgomery|Hot Spring",
    county_fips_all: "05109|05097|05059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71944,
    lat: 34.23922,
    lng: -94.32517,
    city: "Grannis",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 814,
    density: 8,
    county_fips: "05113",
    county_name: "Polk",
    county_weights: {
      "05113": 100,
    },
    county_names_all: "Polk",
    county_fips_all: "05113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71945,
    lat: 34.49826,
    lng: -94.38492,
    city: "Hatfield",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1489,
    density: 11.7,
    county_fips: "05113",
    county_name: "Polk",
    county_weights: {
      "05113": 100,
    },
    county_names_all: "Polk",
    county_fips_all: "05113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71949,
    lat: 34.68938,
    lng: -93.21552,
    city: "Jessieville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1186,
    density: 2.4,
    county_fips: "05051",
    county_name: "Garland",
    county_weights: {
      "05051": 100,
    },
    county_names_all: "Garland",
    county_fips_all: "05051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71950,
    lat: 34.25072,
    lng: -93.72767,
    city: "Kirby",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 739,
    density: 13.9,
    county_fips: "05109",
    county_name: "Pike",
    county_weights: {
      "05109": 100,
    },
    county_names_all: "Pike",
    county_fips_all: "05109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71952,
    lat: 34.31067,
    lng: -93.84992,
    city: "Langley",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30,
    density: 0.7,
    county_fips: "05109",
    county_name: "Pike",
    county_weights: {
      "05109": 100,
    },
    county_names_all: "Pike",
    county_fips_all: "05109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71953,
    lat: 34.61291,
    lng: -94.2118,
    city: "Mena",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13192,
    density: 7.4,
    county_fips: "05113",
    county_name: "Polk",
    county_weights: {
      40079: 5.13,
      "05113": 75.39,
      "05127": 19.48,
    },
    county_names_all: "Polk|Scott|Le Flore",
    county_fips_all: "05113|05127|40079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71956,
    lat: 34.60129,
    lng: -93.14977,
    city: "Mountain Pine",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1325,
    density: 20.6,
    county_fips: "05051",
    county_name: "Garland",
    county_weights: {
      "05051": 100,
    },
    county_names_all: "Garland",
    county_fips_all: "05051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71957,
    lat: 34.55799,
    lng: -93.59682,
    city: "Mount Ida",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2803,
    density: 6.8,
    county_fips: "05097",
    county_name: "Montgomery",
    county_weights: {
      "05097": 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: "05097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71958,
    lat: 34.1114,
    lng: -93.6556,
    city: "Murfreesboro",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2311,
    density: 6.4,
    county_fips: "05109",
    county_name: "Pike",
    county_weights: {
      "05109": 100,
    },
    county_names_all: "Pike",
    county_fips_all: "05109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71959,
    lat: 34.25081,
    lng: -93.92633,
    city: "Newhope",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 746,
    density: 4.1,
    county_fips: "05109",
    county_name: "Pike",
    county_weights: {
      "05109": 50.36,
      "05061": 49.64,
    },
    county_names_all: "Pike|Howard",
    county_fips_all: "05109|05061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71960,
    lat: 34.47408,
    lng: -93.69281,
    city: "Norman",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1655,
    density: 4.6,
    county_fips: "05097",
    county_name: "Montgomery",
    county_weights: {
      "05097": 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: "05097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71961,
    lat: 34.59722,
    lng: -93.84676,
    city: "Oden",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1211,
    density: 5.5,
    county_fips: "05097",
    county_name: "Montgomery",
    county_weights: {
      "05097": 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: "05097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71962,
    lat: 34.03756,
    lng: -93.33288,
    city: "Okolona",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 994,
    density: 2.3,
    county_fips: "05019",
    county_name: "Clark",
    county_weights: {
      "05019": 100,
    },
    county_names_all: "Clark",
    county_fips_all: "05019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71964,
    lat: 34.42252,
    lng: -93.24451,
    city: "Pearcy",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4709,
    density: 58.5,
    county_fips: "05051",
    county_name: "Garland",
    county_weights: {
      "05051": 81.5,
      "05059": 18.5,
    },
    county_names_all: "Garland|Hot Spring",
    county_fips_all: "05051|05059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71965,
    lat: 34.65506,
    lng: -93.74053,
    city: "Pencil Bluff",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 296,
    density: 6.9,
    county_fips: "05097",
    county_name: "Montgomery",
    county_weights: {
      "05097": 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: "05097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71968,
    lat: 34.52719,
    lng: -93.29767,
    city: "Royal",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4855,
    density: 19,
    county_fips: "05051",
    county_name: "Garland",
    county_weights: {
      "05051": 100,
    },
    county_names_all: "Garland",
    county_fips_all: "05051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71969,
    lat: 34.66671,
    lng: -93.63442,
    city: "Sims",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 252,
    density: 2.7,
    county_fips: "05097",
    county_name: "Montgomery",
    county_weights: {
      "05097": 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: "05097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71970,
    lat: 34.66686,
    lng: -93.49024,
    city: "Story",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 714,
    density: 3.6,
    county_fips: "05097",
    county_name: "Montgomery",
    county_weights: {
      "05097": 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: "05097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71971,
    lat: 34.30411,
    lng: -94.0313,
    city: "Umpire",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 554,
    density: 3.2,
    county_fips: "05061",
    county_name: "Howard",
    county_weights: {
      "05061": 83.4,
      "05109": 16.6,
    },
    county_names_all: "Howard|Pike",
    county_fips_all: "05061|05109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71972,
    lat: 34.39447,
    lng: -94.24695,
    city: "Vandervoort",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 484,
    density: 4.6,
    county_fips: "05113",
    county_name: "Polk",
    county_weights: {
      "05113": 100,
    },
    county_names_all: "Polk",
    county_fips_all: "05113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71973,
    lat: 34.28755,
    lng: -94.30523,
    city: "Wickes",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1891,
    density: 8.4,
    county_fips: "05113",
    county_name: "Polk",
    county_weights: {
      "05113": 61.38,
      "05061": 38.62,
    },
    county_names_all: "Polk|Howard",
    county_fips_all: "05113|05061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71998,
    lat: 34.12609,
    lng: -93.05275,
    city: "Arkadelphia",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 522,
    density: 2712.9,
    county_fips: "05019",
    county_name: "Clark",
    county_weights: {
      "05019": 100,
    },
    county_names_all: "Clark",
    county_fips_all: "05019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 71999,
    lat: 34.12732,
    lng: -93.05941,
    city: "Arkadelphia",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 589,
    density: 3357.3,
    county_fips: "05019",
    county_name: "Clark",
    county_weights: {
      "05019": 100,
    },
    county_names_all: "Clark",
    county_fips_all: "05019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72001,
    lat: 35.07225,
    lng: -92.87602,
    city: "Adona",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 741,
    density: 12.9,
    county_fips: "05105",
    county_name: "Perry",
    county_weights: {
      "05105": 54.07,
      "05029": 45.93,
    },
    county_names_all: "Perry|Conway",
    county_fips_all: "05105|05029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72002,
    lat: 34.6646,
    lng: -92.5362,
    city: "Alexander",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18352,
    density: 107.6,
    county_fips: "05125",
    county_name: "Saline",
    county_weights: {
      "05125": 92.72,
      "05119": 7.28,
    },
    county_names_all: "Saline|Pulaski",
    county_fips_all: "05125|05119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72003,
    lat: 34.38276,
    lng: -91.40754,
    city: "Almyra",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 834,
    density: 3.3,
    county_fips: "05001",
    county_name: "Arkansas",
    county_weights: {
      "05001": 100,
    },
    county_names_all: "Arkansas",
    county_fips_all: "05001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72004,
    lat: 34.29722,
    lng: -91.7856,
    city: "Altheimer",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 886,
    density: 1.9,
    county_fips: "05069",
    county_name: "Jefferson",
    county_weights: {
      "05069": 97.67,
      "05001": 2.33,
    },
    county_names_all: "Jefferson|Arkansas",
    county_fips_all: "05069|05001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72005,
    lat: 35.53911,
    lng: -91.07271,
    city: "Amagon",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 102,
    density: 2,
    county_fips: "05067",
    county_name: "Jackson",
    county_weights: {
      "05067": 100,
    },
    county_names_all: "Jackson",
    county_fips_all: "05067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72006,
    lat: 35.24602,
    lng: -91.34495,
    city: "Augusta",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2369,
    density: 4.8,
    county_fips: "05147",
    county_name: "Woodruff",
    county_weights: {
      "05147": 100,
    },
    county_names_all: "Woodruff",
    county_fips_all: "05147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72007,
    lat: 35.0004,
    lng: -91.97902,
    city: "Austin",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8259,
    density: 69.4,
    county_fips: "05085",
    county_name: "Lonoke",
    county_weights: {
      "05085": 100,
    },
    county_names_all: "Lonoke",
    county_fips_all: "05085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72010,
    lat: 35.30555,
    lng: -91.52112,
    city: "Bald Knob",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6108,
    density: 13.8,
    county_fips: "05145",
    county_name: "White",
    county_weights: {
      "05145": 100,
    },
    county_names_all: "White",
    county_fips_all: "05145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72011,
    lat: 34.50967,
    lng: -92.46628,
    city: "Bauxite",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4242,
    density: 28,
    county_fips: "05125",
    county_name: "Saline",
    county_weights: {
      "05125": 95.63,
      "05053": 4.37,
    },
    county_names_all: "Saline|Grant",
    county_fips_all: "05125|05053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72012,
    lat: 35.10199,
    lng: -91.91789,
    city: "Beebe",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12172,
    density: 48.9,
    county_fips: "05145",
    county_name: "White",
    county_weights: {
      "05145": 100,
    },
    county_names_all: "White",
    county_fips_all: "05145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72013,
    lat: 35.45709,
    lng: -92.3644,
    city: "Bee Branch",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2142,
    density: 9,
    county_fips: "05141",
    county_name: "Van Buren",
    county_weights: {
      "05141": 93.73,
      "05029": 6.27,
    },
    county_names_all: "Van Buren|Conway",
    county_fips_all: "05141|05029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72014,
    lat: 35.43029,
    lng: -91.11213,
    city: "Beedeville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23,
    density: 9.9,
    county_fips: "05067",
    county_name: "Jackson",
    county_weights: {
      "05067": 100,
    },
    county_names_all: "Jackson",
    county_fips_all: "05067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72015,
    lat: 34.49298,
    lng: -92.58974,
    city: "Benton",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30097,
    density: 136.8,
    county_fips: "05125",
    county_name: "Saline",
    county_weights: {
      "05125": 76.2,
      "05053": 23.8,
    },
    county_names_all: "Saline|Grant",
    county_fips_all: "05125|05053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72016,
    lat: 34.97702,
    lng: -92.62763,
    city: "Bigelow",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3321,
    density: 18.3,
    county_fips: "05105",
    county_name: "Perry",
    county_weights: {
      "05105": 77.85,
      "05119": 22.15,
    },
    county_names_all: "Perry|Pulaski",
    county_fips_all: "05105|05119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72017,
    lat: 34.89215,
    lng: -91.40714,
    city: "Biscoe",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 398,
    density: 3.7,
    county_fips: "05117",
    county_name: "Prairie",
    county_weights: {
      "05117": 100,
    },
    county_names_all: "Prairie",
    county_fips_all: "05117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72019,
    lat: 34.63498,
    lng: -92.69926,
    city: "Benton",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27498,
    density: 61.3,
    county_fips: "05125",
    county_name: "Saline",
    county_weights: {
      "05125": 100,
    },
    county_names_all: "Saline",
    county_fips_all: "05125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72020,
    lat: 35.48054,
    lng: -91.47669,
    city: "Bradford",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3398,
    density: 8.3,
    county_fips: "05067",
    county_name: "Jackson",
    county_weights: {
      "05067": 50.27,
      "05145": 31.69,
      "05063": 18.04,
    },
    county_names_all: "Jackson|White|Independence",
    county_fips_all: "05067|05145|05063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72021,
    lat: 34.85953,
    lng: -91.21193,
    city: "Brinkley",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3666,
    density: 7.3,
    county_fips: "05095",
    county_name: "Monroe",
    county_weights: {
      "05095": 88.51,
      "05147": 9.48,
      "05123": 2.01,
    },
    county_names_all: "Monroe|Woodruff|St. Francis",
    county_fips_all: "05095|05147|05123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72022,
    lat: 34.60859,
    lng: -92.49651,
    city: "Bryant",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16595,
    density: 471,
    county_fips: "05125",
    county_name: "Saline",
    county_weights: {
      "05125": 100,
    },
    county_names_all: "Saline",
    county_fips_all: "05125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72023,
    lat: 34.95909,
    lng: -92.05925,
    city: "Cabot",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37429,
    density: 147.1,
    county_fips: "05085",
    county_name: "Lonoke",
    county_weights: {
      "05085": 68.98,
      "05119": 27.06,
      "05045": 3.96,
    },
    county_names_all: "Lonoke|Pulaski|Faulkner",
    county_fips_all: "05085|05119|05045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72024,
    lat: 34.75168,
    lng: -91.74902,
    city: "Carlisle",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4153,
    density: 8.4,
    county_fips: "05085",
    county_name: "Lonoke",
    county_weights: {
      "05085": 93.28,
      "05117": 6.72,
    },
    county_names_all: "Lonoke|Prairie",
    county_fips_all: "05085|05117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72025,
    lat: 35.0551,
    lng: -92.99604,
    city: "Casa",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 656,
    density: 4.2,
    county_fips: "05105",
    county_name: "Perry",
    county_weights: {
      "05105": 69.16,
      "05029": 23.87,
      "05149": 6.97,
    },
    county_names_all: "Perry|Conway|Yell",
    county_fips_all: "05105|05029|05149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72026,
    lat: 34.51397,
    lng: -91.31687,
    city: "Casscoe",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 331,
    density: 5.3,
    county_fips: "05001",
    county_name: "Arkansas",
    county_weights: {
      "05001": 100,
    },
    county_names_all: "Arkansas",
    county_fips_all: "05001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72027,
    lat: 35.37021,
    lng: -92.57494,
    city: "Center Ridge",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1619,
    density: 9.3,
    county_fips: "05029",
    county_name: "Conway",
    county_weights: {
      "05029": 100,
    },
    county_names_all: "Conway",
    county_fips_all: "05029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72028,
    lat: 35.53771,
    lng: -92.43266,
    city: "Choctaw",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05141",
    county_name: "Van Buren",
    county_weights: {
      "05141": 100,
    },
    county_names_all: "Van Buren",
    county_fips_all: "05141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72029,
    lat: 34.71029,
    lng: -91.27679,
    city: "Clarendon",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1583,
    density: 6.5,
    county_fips: "05095",
    county_name: "Monroe",
    county_weights: {
      "05095": 100,
    },
    county_names_all: "Monroe",
    county_fips_all: "05095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72030,
    lat: 35.43428,
    lng: -92.68003,
    city: "Cleveland",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 514,
    density: 3.6,
    county_fips: "05029",
    county_name: "Conway",
    county_weights: {
      "05029": 77.42,
      "05141": 22.58,
    },
    county_names_all: "Conway|Van Buren",
    county_fips_all: "05029|05141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72031,
    lat: 35.60717,
    lng: -92.52904,
    city: "Clinton",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7089,
    density: 9.3,
    county_fips: "05141",
    county_name: "Van Buren",
    county_weights: {
      "05141": 90.63,
      "05137": 4.81,
      "05029": 4.56,
    },
    county_names_all: "Van Buren|Stone|Conway",
    county_fips_all: "05141|05137|05029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72032,
    lat: 35.07393,
    lng: -92.36451,
    city: "Conway",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33940,
    density: 114.5,
    county_fips: "05045",
    county_name: "Faulkner",
    county_weights: {
      "05045": 100,
    },
    county_names_all: "Faulkner",
    county_fips_all: "05045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72034,
    lat: 35.05405,
    lng: -92.47945,
    city: "Conway",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50619,
    density: 407.8,
    county_fips: "05045",
    county_name: "Faulkner",
    county_weights: {
      "05045": 100,
    },
    county_names_all: "Faulkner",
    county_fips_all: "05045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72035,
    lat: 35.07902,
    lng: -92.45829,
    city: "Conway",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1696,
    density: 4241,
    county_fips: "05045",
    county_name: "Faulkner",
    county_weights: {
      "05045": 100,
    },
    county_names_all: "Faulkner",
    county_fips_all: "05045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72036,
    lat: 35.00673,
    lng: -91.27205,
    city: "Cotton Plant",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 630,
    density: 2.1,
    county_fips: "05147",
    county_name: "Woodruff",
    county_weights: {
      "05147": 80.64,
      "05095": 19.36,
    },
    county_names_all: "Woodruff|Monroe",
    county_fips_all: "05147|05095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72038,
    lat: 34.44606,
    lng: -91.2349,
    city: "Crocketts Bluff",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35,
    density: 0.4,
    county_fips: "05001",
    county_name: "Arkansas",
    county_weights: {
      "05001": 100,
    },
    county_names_all: "Arkansas",
    county_fips_all: "05001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72039,
    lat: 35.35636,
    lng: -92.40338,
    city: "Damascus",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2280,
    density: 14.4,
    county_fips: "05045",
    county_name: "Faulkner",
    county_weights: {
      "05045": 53.98,
      "05141": 46.02,
    },
    county_names_all: "Faulkner|Van Buren",
    county_fips_all: "05045|05141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72040,
    lat: 34.96957,
    lng: -91.52129,
    city: "Des Arc",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2392,
    density: 5.3,
    county_fips: "05117",
    county_name: "Prairie",
    county_weights: {
      "05117": 92.81,
      "05147": 7.19,
    },
    county_names_all: "Prairie|Woodruff",
    county_fips_all: "05117|05147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72041,
    lat: 34.73348,
    lng: -91.46812,
    city: "De Valls Bluff",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1358,
    density: 5,
    county_fips: "05117",
    county_name: "Prairie",
    county_weights: {
      "05117": 100,
    },
    county_names_all: "Prairie",
    county_fips_all: "05117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72042,
    lat: 34.26937,
    lng: -91.31567,
    city: "De Witt",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5151,
    density: 8.4,
    county_fips: "05001",
    county_name: "Arkansas",
    county_weights: {
      "05001": 100,
    },
    county_names_all: "Arkansas",
    county_fips_all: "05001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72044,
    lat: 35.67688,
    lng: -92.16243,
    city: "Edgemont",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1114,
    density: 6.6,
    county_fips: "05023",
    county_name: "Cleburne",
    county_weights: {
      "05023": 72.83,
      "05137": 27.17,
    },
    county_names_all: "Cleburne|Stone",
    county_fips_all: "05023|05137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72045,
    lat: 35.12618,
    lng: -92.05483,
    city: "El Paso",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1726,
    density: 15.9,
    county_fips: "05145",
    county_name: "White",
    county_weights: {
      "05145": 100,
    },
    county_names_all: "White",
    county_fips_all: "05145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72046,
    lat: 34.55542,
    lng: -91.9403,
    city: "England",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4079,
    density: 6.8,
    county_fips: "05085",
    county_name: "Lonoke",
    county_weights: {
      "05085": 70.85,
      "05119": 16.71,
      "05069": 12.44,
    },
    county_names_all: "Lonoke|Pulaski|Jefferson",
    county_fips_all: "05085|05119|05069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72047,
    lat: 35.22809,
    lng: -92.21055,
    city: "Enola",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 655,
    density: 7.5,
    county_fips: "05045",
    county_name: "Faulkner",
    county_weights: {
      "05045": 100,
    },
    county_names_all: "Faulkner",
    county_fips_all: "05045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72048,
    lat: 34.23436,
    lng: -91.12433,
    city: "Ethel",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 85,
    density: 0.4,
    county_fips: "05001",
    county_name: "Arkansas",
    county_weights: {
      "05001": 100,
    },
    county_names_all: "Arkansas",
    county_fips_all: "05001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72051,
    lat: 35.79475,
    lng: -92.31501,
    city: "Fox",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 646,
    density: 7.2,
    county_fips: "05137",
    county_name: "Stone",
    county_weights: {
      "05137": 100,
    },
    county_names_all: "Stone",
    county_fips_all: "05137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72052,
    lat: 35.13965,
    lng: -91.78097,
    city: "Garner",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05145",
    county_name: "White",
    county_weights: {
      "05145": 100,
    },
    county_names_all: "White",
    county_fips_all: "05145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72053,
    lat: 34.70579,
    lng: -92.22852,
    city: "College Station",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05119",
    county_name: "Pulaski",
    county_weights: {
      "05119": 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: "05119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72055,
    lat: 34.10391,
    lng: -91.36196,
    city: "Gillett",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 811,
    density: 3.3,
    county_fips: "05001",
    county_name: "Arkansas",
    county_weights: {
      "05001": 100,
    },
    county_names_all: "Arkansas",
    county_fips_all: "05001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72057,
    lat: 34.14417,
    lng: -92.31507,
    city: "Grapevine",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1415,
    density: 6.1,
    county_fips: "05053",
    county_name: "Grant",
    county_weights: {
      "05053": 100,
    },
    county_names_all: "Grant",
    county_fips_all: "05053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72058,
    lat: 35.24273,
    lng: -92.36998,
    city: "Greenbrier",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17511,
    density: 43,
    county_fips: "05045",
    county_name: "Faulkner",
    county_weights: {
      "05045": 100,
    },
    county_names_all: "Faulkner",
    county_fips_all: "05045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72059,
    lat: 35.15455,
    lng: -91.34209,
    city: "Gregory",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42,
    density: 667.3,
    county_fips: "05147",
    county_name: "Woodruff",
    county_weights: {
      "05147": 100,
    },
    county_names_all: "Woodruff",
    county_fips_all: "05147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72060,
    lat: 35.07609,
    lng: -91.57779,
    city: "Griffithville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 629,
    density: 3.1,
    county_fips: "05145",
    county_name: "White",
    county_weights: {
      "05145": 58.7,
      "05117": 41.3,
    },
    county_names_all: "White|Prairie",
    county_fips_all: "05145|05117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72061,
    lat: 35.32437,
    lng: -92.28992,
    city: "Guy",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 124,
    density: 21.4,
    county_fips: "05045",
    county_name: "Faulkner",
    county_weights: {
      "05045": 100,
    },
    county_names_all: "Faulkner",
    county_fips_all: "05045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72063,
    lat: 35.32205,
    lng: -92.77249,
    city: "Hattieville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2232,
    density: 12.2,
    county_fips: "05029",
    county_name: "Conway",
    county_weights: {
      "05029": 97.77,
      "05115": 2.23,
    },
    county_names_all: "Conway|Pope",
    county_fips_all: "05029|05115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72064,
    lat: 34.79457,
    lng: -91.61226,
    city: "Hazen",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2680,
    density: 6.9,
    county_fips: "05117",
    county_name: "Prairie",
    county_weights: {
      "05117": 100,
    },
    county_names_all: "Prairie",
    county_fips_all: "05117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72065,
    lat: 34.52102,
    lng: -92.28648,
    city: "Hensley",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5252,
    density: 32.4,
    county_fips: "05125",
    county_name: "Saline",
    county_weights: {
      "05125": 57.57,
      "05119": 26.07,
      "05053": 16.36,
    },
    county_names_all: "Saline|Pulaski|Grant",
    county_fips_all: "05125|05119|05053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72066,
    lat: 34.98141,
    lng: -91.7171,
    city: "Hickory Plains",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05117",
    county_name: "Prairie",
    county_weights: {
      "05117": 100,
    },
    county_names_all: "Prairie",
    county_fips_all: "05117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72067,
    lat: 35.56369,
    lng: -92.16589,
    city: "Higden",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2335,
    density: 18.4,
    county_fips: "05023",
    county_name: "Cleburne",
    county_weights: {
      "05023": 83.79,
      "05141": 16.21,
    },
    county_names_all: "Cleburne|Van Buren",
    county_fips_all: "05023|05141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72068,
    lat: 35.15766,
    lng: -91.71547,
    city: "Higginson",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 498,
    density: 46.2,
    county_fips: "05145",
    county_name: "White",
    county_weights: {
      "05145": 100,
    },
    county_names_all: "White",
    county_fips_all: "05145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72069,
    lat: 34.53904,
    lng: -91.13242,
    city: "Holly Grove",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1172,
    density: 1.7,
    county_fips: "05095",
    county_name: "Monroe",
    county_weights: {
      "05095": 92.42,
      "05107": 7.58,
    },
    county_names_all: "Monroe|Phillips",
    county_fips_all: "05095|05107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72070,
    lat: 35.01346,
    lng: -92.6995,
    city: "Houston",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1736,
    density: 9.5,
    county_fips: "05105",
    county_name: "Perry",
    county_weights: {
      "05105": 100,
    },
    county_names_all: "Perry",
    county_fips_all: "05105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72072,
    lat: 34.51279,
    lng: -91.75802,
    city: "Humnoke",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 357,
    density: 3.5,
    county_fips: "05085",
    county_name: "Lonoke",
    county_weights: {
      "05085": 74.07,
      "05069": 25.93,
    },
    county_names_all: "Lonoke|Jefferson",
    county_fips_all: "05085|05069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72073,
    lat: 34.36529,
    lng: -91.65251,
    city: "Humphrey",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 833,
    density: 2.8,
    county_fips: "05001",
    county_name: "Arkansas",
    county_weights: {
      "05001": 90.89,
      "05069": 9.11,
    },
    county_names_all: "Arkansas|Jefferson",
    county_fips_all: "05001|05069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72074,
    lat: 35.06919,
    lng: -91.10538,
    city: "Hunter",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 119,
    density: 4.1,
    county_fips: "05147",
    county_name: "Woodruff",
    county_weights: {
      "05147": 100,
    },
    county_names_all: "Woodruff",
    county_fips_all: "05147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72075,
    lat: 35.64084,
    lng: -91.31089,
    city: "Jacksonport",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05067",
    county_name: "Jackson",
    county_weights: {
      "05067": 100,
    },
    county_names_all: "Jackson",
    county_fips_all: "05067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72076,
    lat: 34.91072,
    lng: -92.14303,
    city: "Jacksonville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38784,
    density: 206,
    county_fips: "05119",
    county_name: "Pulaski",
    county_weights: {
      "05119": 84.76,
      "05085": 10.79,
      "05045": 4.45,
    },
    county_names_all: "Pulaski|Lonoke|Faulkner",
    county_fips_all: "05119|05085|05045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72079,
    lat: 34.38958,
    lng: -92.19919,
    city: "Jefferson",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 905,
    density: 16.8,
    county_fips: "05069",
    county_name: "Jefferson",
    county_weights: {
      "05069": 65.5,
      "05053": 34.5,
    },
    county_names_all: "Jefferson|Grant",
    county_fips_all: "05069|05053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72080,
    lat: 35.52604,
    lng: -92.80909,
    city: "Jerusalem",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 218,
    density: 0.9,
    county_fips: "05141",
    county_name: "Van Buren",
    county_weights: {
      "05141": 44.91,
      "05029": 33.86,
      "05115": 21.23,
    },
    county_names_all: "Van Buren|Conway|Pope",
    county_fips_all: "05141|05029|05115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72081,
    lat: 35.37827,
    lng: -91.66947,
    city: "Judsonia",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7409,
    density: 30.4,
    county_fips: "05145",
    county_name: "White",
    county_weights: {
      "05145": 99.11,
      "05063": 0.89,
    },
    county_names_all: "White|Independence",
    county_fips_all: "05145|05063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72082,
    lat: 35.23713,
    lng: -91.66963,
    city: "Kensett",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2344,
    density: 217.1,
    county_fips: "05145",
    county_name: "White",
    county_weights: {
      "05145": 100,
    },
    county_names_all: "White",
    county_fips_all: "05145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72083,
    lat: 34.6049,
    lng: -92.01189,
    city: "Keo",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 182,
    density: 19.1,
    county_fips: "05085",
    county_name: "Lonoke",
    county_weights: {
      "05085": 100,
    },
    county_names_all: "Lonoke",
    county_fips_all: "05085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72084,
    lat: 34.13687,
    lng: -92.6887,
    city: "Leola",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1206,
    density: 2.6,
    county_fips: "05039",
    county_name: "Dallas",
    county_weights: {
      "05039": 57.89,
      "05053": 30.14,
      "05059": 11.97,
    },
    county_names_all: "Dallas|Grant|Hot Spring",
    county_fips_all: "05039|05053|05059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72085,
    lat: 35.36665,
    lng: -91.82772,
    city: "Letona",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05145",
    county_name: "White",
    county_weights: {
      "05145": 100,
    },
    county_names_all: "White",
    county_fips_all: "05145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72086,
    lat: 34.80418,
    lng: -91.90619,
    city: "Lonoke",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11372,
    density: 26.8,
    county_fips: "05085",
    county_name: "Lonoke",
    county_weights: {
      "05085": 96.18,
      "05117": 3.82,
    },
    county_names_all: "Lonoke|Prairie",
    county_fips_all: "05085|05117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72087,
    lat: 34.59877,
    lng: -92.83391,
    city: "Lonsdale",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2545,
    density: 15.9,
    county_fips: "05125",
    county_name: "Saline",
    county_weights: {
      "05125": 63.81,
      "05051": 36.19,
    },
    county_names_all: "Saline|Garland",
    county_fips_all: "05125|05051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72088,
    lat: 35.59803,
    lng: -92.26239,
    city: "Fairfield Bay",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2387,
    density: 63.4,
    county_fips: "05141",
    county_name: "Van Buren",
    county_weights: {
      "05141": 78.71,
      "05023": 21.29,
    },
    county_names_all: "Van Buren|Cleburne",
    county_fips_all: "05141|05023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72099,
    lat: 34.90103,
    lng: -92.15202,
    city: "Little Rock Air Force Base",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 685,
    density: 220.1,
    county_fips: "05119",
    county_name: "Pulaski",
    county_weights: {
      "05119": 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: "05119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72101,
    lat: 35.23228,
    lng: -91.15242,
    city: "McCrory",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3103,
    density: 4.4,
    county_fips: "05147",
    county_name: "Woodruff",
    county_weights: {
      "05147": 88.92,
      "05067": 10.65,
      "05037": 0.43,
    },
    county_names_all: "Woodruff|Jackson|Cross",
    county_fips_all: "05147|05067|05037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72102,
    lat: 35.14556,
    lng: -91.83352,
    city: "McRae",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3278,
    density: 25.9,
    county_fips: "05145",
    county_name: "White",
    county_weights: {
      "05145": 100,
    },
    county_names_all: "White",
    county_fips_all: "05145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72103,
    lat: 34.59133,
    lng: -92.38316,
    city: "Mabelvale",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13851,
    density: 174.9,
    county_fips: "05125",
    county_name: "Saline",
    county_weights: {
      "05125": 77.19,
      "05119": 22.81,
    },
    county_names_all: "Saline|Pulaski",
    county_fips_all: "05125|05119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72104,
    lat: 34.34774,
    lng: -92.81814,
    city: "Malvern",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23308,
    density: 27.6,
    county_fips: "05059",
    county_name: "Hot Spring",
    county_weights: {
      "05059": 95.29,
      "05051": 2.72,
      "05125": 1.31,
      "05053": 0.68,
    },
    county_names_all: "Hot Spring|Garland|Saline|Grant",
    county_fips_all: "05059|05051|05125|05053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72106,
    lat: 34.96997,
    lng: -92.48727,
    city: "Mayflower",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5987,
    density: 44.2,
    county_fips: "05045",
    county_name: "Faulkner",
    county_weights: {
      "05045": 98.37,
      "05119": 1.63,
    },
    county_names_all: "Faulkner|Pulaski",
    county_fips_all: "05045|05119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72107,
    lat: 35.14255,
    lng: -92.53844,
    city: "Menifee",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 195,
    density: 25.9,
    county_fips: "05029",
    county_name: "Conway",
    county_weights: {
      "05029": 100,
    },
    county_names_all: "Conway",
    county_fips_all: "05029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72108,
    lat: 34.72803,
    lng: -91.10349,
    city: "Monroe",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40,
    density: 26.2,
    county_fips: "05095",
    county_name: "Monroe",
    county_weights: {
      "05095": 100,
    },
    county_names_all: "Monroe",
    county_fips_all: "05095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72110,
    lat: 35.15514,
    lng: -92.77273,
    city: "Morrilton",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11405,
    density: 37.6,
    county_fips: "05029",
    county_name: "Conway",
    county_weights: {
      "05029": 100,
    },
    county_names_all: "Conway",
    county_fips_all: "05029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72111,
    lat: 35.23688,
    lng: -92.13307,
    city: "Mount Vernon",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1277,
    density: 8.6,
    county_fips: "05045",
    county_name: "Faulkner",
    county_weights: {
      "05045": 72.58,
      "05145": 27.42,
    },
    county_names_all: "Faulkner|White",
    county_fips_all: "05045|05145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72112,
    lat: 35.57383,
    lng: -91.22918,
    city: "Newport",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10782,
    density: 12.7,
    county_fips: "05067",
    county_name: "Jackson",
    county_weights: {
      "05067": 92.8,
      "05147": 4.72,
      "05063": 2.48,
    },
    county_names_all: "Jackson|Woodruff|Independence",
    county_fips_all: "05067|05147|05063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72113,
    lat: 34.85926,
    lng: -92.39875,
    city: "Maumelle",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25792,
    density: 378.9,
    county_fips: "05119",
    county_name: "Pulaski",
    county_weights: {
      "05119": 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: "05119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72114,
    lat: 34.7645,
    lng: -92.26024,
    city: "North Little Rock",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11036,
    density: 555.7,
    county_fips: "05119",
    county_name: "Pulaski",
    county_weights: {
      "05119": 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: "05119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72116,
    lat: 34.80025,
    lng: -92.24505,
    city: "North Little Rock",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21459,
    density: 1276.5,
    county_fips: "05119",
    county_name: "Pulaski",
    county_weights: {
      "05119": 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: "05119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72117,
    lat: 34.78076,
    lng: -92.14548,
    city: "North Little Rock",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14872,
    density: 105.6,
    county_fips: "05119",
    county_name: "Pulaski",
    county_weights: {
      "05119": 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: "05119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72118,
    lat: 34.83872,
    lng: -92.32694,
    city: "North Little Rock",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21534,
    density: 300.8,
    county_fips: "05119",
    county_name: "Pulaski",
    county_weights: {
      "05119": 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: "05119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72119,
    lat: 34.8369,
    lng: -92.29505,
    city: "North Little Rock",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "05119",
    county_name: "Pulaski",
    county_weights: {
      "05119": 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: "05119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72120,
    lat: 34.89776,
    lng: -92.24431,
    city: "Sherwood",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33296,
    density: 237.2,
    county_fips: "05119",
    county_name: "Pulaski",
    county_weights: {
      "05119": 69.05,
      "05045": 30.95,
    },
    county_names_all: "Pulaski|Faulkner",
    county_fips_all: "05119|05045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72121,
    lat: 35.45561,
    lng: -91.78525,
    city: "Pangburn",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3520,
    density: 19.2,
    county_fips: "05145",
    county_name: "White",
    county_weights: {
      "05145": 80.54,
      "05023": 19.46,
    },
    county_names_all: "White|Cleburne",
    county_fips_all: "05145|05023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72122,
    lat: 34.77955,
    lng: -92.77549,
    city: "Paron",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 625,
    density: 1.9,
    county_fips: "05125",
    county_name: "Saline",
    county_weights: {
      "05125": 89.97,
      "05119": 10.03,
    },
    county_names_all: "Saline|Pulaski",
    county_fips_all: "05125|05119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72123,
    lat: 35.25774,
    lng: -91.23675,
    city: "Patterson",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 346,
    density: 127.5,
    county_fips: "05147",
    county_name: "Woodruff",
    county_weights: {
      "05147": 100,
    },
    county_names_all: "Woodruff",
    county_fips_all: "05147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72125,
    lat: 35.06421,
    lng: -92.794,
    city: "Perry",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 867,
    density: 13.7,
    county_fips: "05105",
    county_name: "Perry",
    county_weights: {
      "05105": 61.8,
      "05029": 38.2,
    },
    county_names_all: "Perry|Conway",
    county_fips_all: "05105|05029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72126,
    lat: 34.9376,
    lng: -92.91024,
    city: "Perryville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3683,
    density: 7,
    county_fips: "05105",
    county_name: "Perry",
    county_weights: {
      "05105": 95.59,
      "05119": 4.41,
    },
    county_names_all: "Perry|Pulaski",
    county_fips_all: "05105|05119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72127,
    lat: 35.16237,
    lng: -92.59419,
    city: "Plumerville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1990,
    density: 12.6,
    county_fips: "05029",
    county_name: "Conway",
    county_weights: {
      "05029": 100,
    },
    county_names_all: "Conway",
    county_fips_all: "05029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72128,
    lat: 34.31535,
    lng: -92.63846,
    city: "Poyen",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 814,
    density: 13.4,
    county_fips: "05053",
    county_name: "Grant",
    county_weights: {
      "05053": 100,
    },
    county_names_all: "Grant",
    county_fips_all: "05053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72129,
    lat: 34.31215,
    lng: -92.55406,
    city: "Prattsville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1146,
    density: 7.5,
    county_fips: "05053",
    county_name: "Grant",
    county_weights: {
      "05053": 100,
    },
    county_names_all: "Grant",
    county_fips_all: "05053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72130,
    lat: 35.6673,
    lng: -92.06997,
    city: "Prim",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 541,
    density: 7.6,
    county_fips: "05023",
    county_name: "Cleburne",
    county_weights: {
      "05023": 100,
    },
    county_names_all: "Cleburne",
    county_fips_all: "05023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72131,
    lat: 35.40792,
    lng: -92.19362,
    city: "Quitman",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4633,
    density: 13.9,
    county_fips: "05023",
    county_name: "Cleburne",
    county_weights: {
      "05023": 66.87,
      "05045": 25.85,
      "05141": 7.28,
    },
    county_names_all: "Cleburne|Faulkner|Van Buren",
    county_fips_all: "05023|05045|05141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72132,
    lat: 34.44,
    lng: -92.19468,
    city: "Redfield",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2849,
    density: 15.9,
    county_fips: "05069",
    county_name: "Jefferson",
    county_weights: {
      "05069": 57.5,
      "05053": 42.5,
    },
    county_names_all: "Jefferson|Grant",
    county_fips_all: "05069|05053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72133,
    lat: 34.10821,
    lng: -91.53718,
    city: "Reydell",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05069",
    county_name: "Jefferson",
    county_weights: {
      "05069": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "05069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72134,
    lat: 34.61189,
    lng: -91.37247,
    city: "Roe",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 423,
    density: 3.8,
    county_fips: "05095",
    county_name: "Monroe",
    county_weights: {
      "05095": 91.72,
      "05001": 8.28,
    },
    county_names_all: "Monroe|Arkansas",
    county_fips_all: "05095|05001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72135,
    lat: 34.87698,
    lng: -92.56087,
    city: "Roland",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2978,
    density: 15.6,
    county_fips: "05119",
    county_name: "Pulaski",
    county_weights: {
      "05119": 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: "05119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72136,
    lat: 35.23538,
    lng: -92.02129,
    city: "Romance",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1781,
    density: 13.8,
    county_fips: "05145",
    county_name: "White",
    county_weights: {
      "05145": 100,
    },
    county_names_all: "White",
    county_fips_all: "05145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72137,
    lat: 35.33756,
    lng: -92.02933,
    city: "Rose Bud",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2186,
    density: 12.5,
    county_fips: "05145",
    county_name: "White",
    county_weights: {
      "05145": 77.06,
      "05023": 22.94,
    },
    county_names_all: "White|Cleburne",
    county_fips_all: "05145|05023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72139,
    lat: 35.36212,
    lng: -91.50997,
    city: "Russell",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 268,
    density: 506.5,
    county_fips: "05145",
    county_name: "White",
    county_weights: {
      "05145": 100,
    },
    county_names_all: "White",
    county_fips_all: "05145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72140,
    lat: 34.36052,
    lng: -91.1549,
    city: "Saint Charles",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 399,
    density: 10.8,
    county_fips: "05001",
    county_name: "Arkansas",
    county_weights: {
      "05001": 100,
    },
    county_names_all: "Arkansas",
    county_fips_all: "05001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72141,
    lat: 35.51824,
    lng: -92.69158,
    city: "Scotland",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 588,
    density: 2.6,
    county_fips: "05141",
    county_name: "Van Buren",
    county_weights: {
      "05141": 100,
    },
    county_names_all: "Van Buren",
    county_fips_all: "05141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72142,
    lat: 34.67681,
    lng: -92.07488,
    city: "Scott",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2235,
    density: 8.2,
    county_fips: "05085",
    county_name: "Lonoke",
    county_weights: {
      "05085": 58.32,
      "05119": 41.68,
    },
    county_names_all: "Lonoke|Pulaski",
    county_fips_all: "05085|05119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72143,
    lat: 35.2279,
    lng: -91.73613,
    city: "Searcy",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35978,
    density: 46,
    county_fips: "05145",
    county_name: "White",
    county_weights: {
      "05145": 97.49,
      "05023": 2.51,
    },
    county_names_all: "White|Cleburne",
    county_fips_all: "05145|05023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72150,
    lat: 34.30999,
    lng: -92.39642,
    city: "Sheridan",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12421,
    density: 16.3,
    county_fips: "05053",
    county_name: "Grant",
    county_weights: {
      "05053": 99.28,
      "05069": 0.72,
    },
    county_names_all: "Grant|Jefferson",
    county_fips_all: "05053|05069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72152,
    lat: 34.35194,
    lng: -91.98009,
    city: "Sherrill",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 512,
    density: 2.9,
    county_fips: "05069",
    county_name: "Jefferson",
    county_weights: {
      "05069": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "05069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72153,
    lat: 35.65651,
    lng: -92.31988,
    city: "Shirley",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3552,
    density: 13.6,
    county_fips: "05141",
    county_name: "Van Buren",
    county_weights: {
      "05141": 78.65,
      "05137": 15.13,
      "05023": 6.22,
    },
    county_names_all: "Van Buren|Stone|Cleburne",
    county_fips_all: "05141|05137|05023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72156,
    lat: 35.28595,
    lng: -92.68331,
    city: "Solgohachia",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 326,
    density: 4.6,
    county_fips: "05029",
    county_name: "Conway",
    county_weights: {
      "05029": 100,
    },
    county_names_all: "Conway",
    county_fips_all: "05029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72157,
    lat: 35.2714,
    lng: -92.56412,
    city: "Springfield",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1316,
    density: 9.6,
    county_fips: "05029",
    county_name: "Conway",
    county_weights: {
      "05029": 100,
    },
    county_names_all: "Conway",
    county_fips_all: "05029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72160,
    lat: 34.44284,
    lng: -91.53136,
    city: "Stuttgart",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9608,
    density: 11.6,
    county_fips: "05001",
    county_name: "Arkansas",
    county_weights: {
      "05001": 59.71,
      "05117": 28.82,
      "05069": 10.53,
      "05085": 0.94,
    },
    county_names_all: "Arkansas|Prairie|Jefferson|Lonoke",
    county_fips_all: "05001|05117|05069|05085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72165,
    lat: 35.57657,
    lng: -91.46647,
    city: "Thida",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 85,
    density: 5.8,
    county_fips: "05063",
    county_name: "Independence",
    county_weights: {
      "05063": 100,
    },
    county_names_all: "Independence",
    county_fips_all: "05063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72166,
    lat: 34.04821,
    lng: -91.23711,
    city: "Tichnor",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 94,
    density: 0.3,
    county_fips: "05001",
    county_name: "Arkansas",
    county_weights: {
      "05001": 100,
    },
    county_names_all: "Arkansas",
    county_fips_all: "05001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72167,
    lat: 34.42223,
    lng: -92.65477,
    city: "Traskwood",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1823,
    density: 18,
    county_fips: "05125",
    county_name: "Saline",
    county_weights: {
      "05125": 46.1,
      "05053": 35.04,
      "05059": 18.86,
    },
    county_names_all: "Saline|Grant|Hot Spring",
    county_fips_all: "05125|05053|05059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72168,
    lat: 34.43719,
    lng: -91.96771,
    city: "Tucker",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2316,
    density: 27.7,
    county_fips: "05069",
    county_name: "Jefferson",
    county_weights: {
      "05069": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "05069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72169,
    lat: 35.3946,
    lng: -91.22703,
    city: "Tupelo",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62,
    density: 2.2,
    county_fips: "05067",
    county_name: "Jackson",
    county_weights: {
      "05067": 100,
    },
    county_names_all: "Jackson",
    county_fips_all: "05067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72170,
    lat: 34.57819,
    lng: -91.42655,
    city: "Ulm",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 260,
    density: 19.4,
    county_fips: "05117",
    county_name: "Prairie",
    county_weights: {
      "05117": 99.89,
      "05001": 0.11,
    },
    county_names_all: "Prairie|Arkansas",
    county_fips_all: "05117|05001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72173,
    lat: 35.10001,
    lng: -92.20807,
    city: "Vilonia",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9686,
    density: 39.4,
    county_fips: "05045",
    county_name: "Faulkner",
    county_weights: {
      "05045": 100,
    },
    county_names_all: "Faulkner",
    county_fips_all: "05045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72175,
    lat: 34.33792,
    lng: -91.75495,
    city: "Wabbaseka",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 409,
    density: 3.4,
    county_fips: "05069",
    county_name: "Jefferson",
    county_weights: {
      "05069": 95.94,
      "05001": 4.06,
    },
    county_names_all: "Jefferson|Arkansas",
    county_fips_all: "05069|05001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72176,
    lat: 35.00279,
    lng: -91.84212,
    city: "Ward",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8549,
    density: 46.9,
    county_fips: "05085",
    county_name: "Lonoke",
    county_weights: {
      "05085": 67.06,
      "05117": 32.94,
    },
    county_names_all: "Lonoke|Prairie",
    county_fips_all: "05085|05117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72178,
    lat: 35.20381,
    lng: -91.61265,
    city: "West Point",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05145",
    county_name: "White",
    county_weights: {
      "05145": 100,
    },
    county_names_all: "White",
    county_fips_all: "05145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72179,
    lat: 35.49773,
    lng: -91.86565,
    city: "Wilburn",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 365,
    density: 7.4,
    county_fips: "05023",
    county_name: "Cleburne",
    county_weights: {
      "05023": 100,
    },
    county_names_all: "Cleburne",
    county_fips_all: "05023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72180,
    lat: 34.53104,
    lng: -92.21495,
    city: "Woodson",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05119",
    county_name: "Pulaski",
    county_weights: {
      "05119": 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: "05119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72181,
    lat: 35.16237,
    lng: -92.44503,
    city: "Wooster",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2,
    density: 0.6,
    county_fips: "05045",
    county_name: "Faulkner",
    county_weights: {
      "05045": 100,
    },
    county_names_all: "Faulkner",
    county_fips_all: "05045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72182,
    lat: 34.43161,
    lng: -92.08721,
    city: "Wright",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05069",
    county_name: "Jefferson",
    county_weights: {
      "05069": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "05069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72183,
    lat: 34.60002,
    lng: -92.19305,
    city: "Wrightsville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05119",
    county_name: "Pulaski",
    county_weights: {
      "05119": 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: "05119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72199,
    lat: 34.82816,
    lng: -92.28608,
    city: "North Little Rock",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05119",
    county_name: "Pulaski",
    county_weights: {
      "05119": 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: "05119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72201,
    lat: 34.74725,
    lng: -92.28053,
    city: "Little Rock",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1428,
    density: 450,
    county_fips: "05119",
    county_name: "Pulaski",
    county_weights: {
      "05119": 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: "05119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72202,
    lat: 34.74626,
    lng: -92.27016,
    city: "Little Rock",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9778,
    density: 533.4,
    county_fips: "05119",
    county_name: "Pulaski",
    county_weights: {
      "05119": 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: "05119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72204,
    lat: 34.71739,
    lng: -92.3582,
    city: "Little Rock",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30204,
    density: 769.2,
    county_fips: "05119",
    county_name: "Pulaski",
    county_weights: {
      "05119": 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: "05119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72205,
    lat: 34.74948,
    lng: -92.3524,
    city: "Little Rock",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21946,
    density: 1054.7,
    county_fips: "05119",
    county_name: "Pulaski",
    county_weights: {
      "05119": 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: "05119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72206,
    lat: 34.63042,
    lng: -92.23833,
    city: "Little Rock",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23228,
    density: 80.3,
    county_fips: "05119",
    county_name: "Pulaski",
    county_weights: {
      "05119": 94.91,
      "05125": 5.09,
    },
    county_names_all: "Pulaski|Saline",
    county_fips_all: "05119|05125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72207,
    lat: 34.77493,
    lng: -92.34271,
    city: "Little Rock",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10809,
    density: 1102.7,
    county_fips: "05119",
    county_name: "Pulaski",
    county_weights: {
      "05119": 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: "05119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72209,
    lat: 34.6805,
    lng: -92.33974,
    city: "Little Rock",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31748,
    density: 671.1,
    county_fips: "05119",
    county_name: "Pulaski",
    county_weights: {
      "05119": 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: "05119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72210,
    lat: 34.71506,
    lng: -92.50378,
    city: "Little Rock",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15981,
    density: 124.7,
    county_fips: "05119",
    county_name: "Pulaski",
    county_weights: {
      "05119": 72.84,
      "05125": 27.16,
    },
    county_names_all: "Pulaski|Saline",
    county_fips_all: "05119|05125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72211,
    lat: 34.74792,
    lng: -92.41675,
    city: "Little Rock",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22035,
    density: 1024,
    county_fips: "05119",
    county_name: "Pulaski",
    county_weights: {
      "05119": 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: "05119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72212,
    lat: 34.78498,
    lng: -92.4141,
    city: "Little Rock",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13016,
    density: 825.7,
    county_fips: "05119",
    county_name: "Pulaski",
    county_weights: {
      "05119": 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: "05119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72223,
    lat: 34.79251,
    lng: -92.49091,
    city: "Little Rock",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24848,
    density: 197.7,
    county_fips: "05119",
    county_name: "Pulaski",
    county_weights: {
      "05119": 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: "05119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72227,
    lat: 34.7782,
    lng: -92.37498,
    city: "Little Rock",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12123,
    density: 1243.9,
    county_fips: "05119",
    county_name: "Pulaski",
    county_weights: {
      "05119": 100,
    },
    county_names_all: "Pulaski",
    county_fips_all: "05119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72301,
    lat: 35.13363,
    lng: -90.17883,
    city: "West Memphis",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24311,
    density: 317.8,
    county_fips: "05035",
    county_name: "Crittenden",
    county_weights: {
      "05035": 100,
    },
    county_names_all: "Crittenden",
    county_fips_all: "05035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72311,
    lat: 34.72072,
    lng: -90.89688,
    city: "Aubrey",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 136,
    density: 252.9,
    county_fips: "05077",
    county_name: "Lee",
    county_weights: {
      "05077": 100,
    },
    county_names_all: "Lee",
    county_fips_all: "05077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72313,
    lat: 35.53077,
    lng: -90.13952,
    city: "Bassett",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05093",
    county_name: "Mississippi",
    county_weights: {
      "05093": 100,
    },
    county_names_all: "Mississippi",
    county_fips_all: "05093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72315,
    lat: 35.90093,
    lng: -89.9029,
    city: "Blytheville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21305,
    density: 32.6,
    county_fips: "05093",
    county_name: "Mississippi",
    county_weights: {
      "05093": 100,
    },
    county_names_all: "Mississippi",
    county_fips_all: "05093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72320,
    lat: 34.81439,
    lng: -90.5411,
    city: "Brickeys",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1539,
    density: 8.8,
    county_fips: "05077",
    county_name: "Lee",
    county_weights: {
      "05077": 100,
    },
    county_names_all: "Lee",
    county_fips_all: "05077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72322,
    lat: 35.0688,
    lng: -90.808,
    city: "Caldwell",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 128,
    density: 292.7,
    county_fips: "05123",
    county_name: "St. Francis",
    county_weights: {
      "05123": 100,
    },
    county_names_all: "St. Francis",
    county_fips_all: "05123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72324,
    lat: 35.38872,
    lng: -90.78116,
    city: "Cherry Valley",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2334,
    density: 6.9,
    county_fips: "05037",
    county_name: "Cross",
    county_weights: {
      "05037": 96.49,
      "05111": 3.51,
    },
    county_names_all: "Cross|Poinsett",
    county_fips_all: "05037|05111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72325,
    lat: 35.33067,
    lng: -90.25395,
    city: "Clarkedale",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30,
    density: 3.5,
    county_fips: "05035",
    county_name: "Crittenden",
    county_weights: {
      "05035": 100,
    },
    county_names_all: "Crittenden",
    county_fips_all: "05035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72326,
    lat: 35.11183,
    lng: -90.89333,
    city: "Colt",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1837,
    density: 7.6,
    county_fips: "05123",
    county_name: "St. Francis",
    county_weights: {
      "05123": 93.23,
      "05037": 6.77,
    },
    county_names_all: "St. Francis|Cross",
    county_fips_all: "05123|05037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72327,
    lat: 35.2401,
    lng: -90.32783,
    city: "Crawfordsville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1555,
    density: 6.3,
    county_fips: "05035",
    county_name: "Crittenden",
    county_weights: {
      "05035": 100,
    },
    county_names_all: "Crittenden",
    county_fips_all: "05035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72328,
    lat: 34.0684,
    lng: -91.0057,
    city: "Crumrod",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37,
    density: 0.1,
    county_fips: "05041",
    county_name: "Desha",
    county_weights: {
      "05041": 72.88,
      "05107": 27.12,
    },
    county_names_all: "Desha|Phillips",
    county_fips_all: "05041|05107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72329,
    lat: 35.62386,
    lng: -89.97143,
    city: "Driver",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 170,
    density: 15,
    county_fips: "05093",
    county_name: "Mississippi",
    county_weights: {
      "05093": 100,
    },
    county_names_all: "Mississippi",
    county_fips_all: "05093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72330,
    lat: 35.59136,
    lng: -90.20184,
    city: "Dyess",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 591,
    density: 5.7,
    county_fips: "05093",
    county_name: "Mississippi",
    county_weights: {
      "05093": 100,
    },
    county_names_all: "Mississippi",
    county_fips_all: "05093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72331,
    lat: 35.28537,
    lng: -90.46733,
    city: "Earle",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2897,
    density: 7.5,
    county_fips: "05035",
    county_name: "Crittenden",
    county_weights: {
      "05035": 66.69,
      "05037": 33.31,
    },
    county_names_all: "Crittenden|Cross",
    county_fips_all: "05035|05037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72332,
    lat: 35.10117,
    lng: -90.30238,
    city: "Edmondson",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 155,
    density: 194.5,
    county_fips: "05035",
    county_name: "Crittenden",
    county_weights: {
      "05035": 100,
    },
    county_names_all: "Crittenden",
    county_fips_all: "05035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72333,
    lat: 34.29004,
    lng: -90.86971,
    city: "Elaine",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 486,
    density: 2.5,
    county_fips: "05107",
    county_name: "Phillips",
    county_weights: {
      "05107": 100,
    },
    county_names_all: "Phillips",
    county_fips_all: "05107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72335,
    lat: 34.99042,
    lng: -90.75645,
    city: "Forrest City",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18167,
    density: 44.1,
    county_fips: "05123",
    county_name: "St. Francis",
    county_weights: {
      "05123": 95.81,
      "05077": 4.19,
    },
    county_names_all: "St. Francis|Lee",
    county_fips_all: "05123|05077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72338,
    lat: 35.43657,
    lng: -90.13863,
    city: "Frenchmans Bayou",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6,
    density: 0.1,
    county_fips: 47167,
    county_name: "Tipton",
    county_weights: {
      47167: 66.75,
      "05093": 33.25,
    },
    county_names_all: "Tipton|Mississippi",
    county_fips_all: "47167|05093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72339,
    lat: 35.41606,
    lng: -90.26492,
    city: "Gilmore",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 238,
    density: 54.2,
    county_fips: "05035",
    county_name: "Crittenden",
    county_weights: {
      "05035": 100,
    },
    county_names_all: "Crittenden",
    county_fips_all: "05035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72340,
    lat: 34.95687,
    lng: -91.03202,
    city: "Goodwin",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 155,
    density: 9.5,
    county_fips: "05123",
    county_name: "St. Francis",
    county_weights: {
      "05123": 100,
    },
    county_names_all: "St. Francis",
    county_fips_all: "05123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72341,
    lat: 34.88746,
    lng: -90.7705,
    city: "Haynes",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 252,
    density: 5.5,
    county_fips: "05077",
    county_name: "Lee",
    county_weights: {
      "05077": 100,
    },
    county_names_all: "Lee",
    county_fips_all: "05077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72342,
    lat: 34.44492,
    lng: -90.67733,
    city: "Helena",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4487,
    density: 16,
    county_fips: "05107",
    county_name: "Phillips",
    county_weights: {
      "05107": 100,
    },
    county_names_all: "Phillips",
    county_fips_all: "05107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72346,
    lat: 35.08462,
    lng: -90.48198,
    city: "Heth",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 694,
    density: 3.2,
    county_fips: "05123",
    county_name: "St. Francis",
    county_weights: {
      "05123": 90.79,
      "05035": 6.7,
      "05037": 2.51,
    },
    county_names_all: "St. Francis|Crittenden|Cross",
    county_fips_all: "05123|05035|05037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72347,
    lat: 35.38415,
    lng: -90.99892,
    city: "Hickory Ridge",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 766,
    density: 3.1,
    county_fips: "05037",
    county_name: "Cross",
    county_weights: {
      "05037": 76.93,
      "05067": 23.07,
    },
    county_names_all: "Cross|Jackson",
    county_fips_all: "05037|05067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72348,
    lat: 34.93739,
    lng: -90.42016,
    city: "Hughes",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2492,
    density: 5.6,
    county_fips: "05035",
    county_name: "Crittenden",
    county_weights: {
      "05035": 50.64,
      "05123": 38.22,
      "05077": 11.14,
    },
    county_names_all: "Crittenden|St. Francis|Lee",
    county_fips_all: "05035|05123|05077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72350,
    lat: 35.50181,
    lng: -90.11782,
    city: "Joiner",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1006,
    density: 5.1,
    county_fips: "05093",
    county_name: "Mississippi",
    county_weights: {
      "05093": 100,
    },
    county_names_all: "Mississippi",
    county_fips_all: "05093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72351,
    lat: 35.67595,
    lng: -90.09771,
    city: "Keiser",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 860,
    density: 58.7,
    county_fips: "05093",
    county_name: "Mississippi",
    county_weights: {
      "05093": 100,
    },
    county_names_all: "Mississippi",
    county_fips_all: "05093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72352,
    lat: 34.65562,
    lng: -90.7344,
    city: "La Grange",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05077",
    county_name: "Lee",
    county_weights: {
      "05077": 100,
    },
    county_names_all: "Lee",
    county_fips_all: "05077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72353,
    lat: 34.3162,
    lng: -91.00708,
    city: "Lambrook",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 81,
    density: 0.9,
    county_fips: "05107",
    county_name: "Phillips",
    county_weights: {
      "05107": 100,
    },
    county_names_all: "Phillips",
    county_fips_all: "05107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72354,
    lat: 35.63118,
    lng: -90.31797,
    city: "Lepanto",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2471,
    density: 16.1,
    county_fips: "05111",
    county_name: "Poinsett",
    county_weights: {
      "05111": 77.88,
      "05093": 22.12,
    },
    county_names_all: "Poinsett|Mississippi",
    county_fips_all: "05111|05093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72355,
    lat: 34.53902,
    lng: -90.77789,
    city: "Lexa",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2155,
    density: 7,
    county_fips: "05107",
    county_name: "Phillips",
    county_weights: {
      "05107": 92.61,
      "05077": 7.39,
    },
    county_names_all: "Phillips|Lee",
    county_fips_all: "05107|05077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72358,
    lat: 35.79446,
    lng: -89.87723,
    city: "Luxora",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1398,
    density: 8,
    county_fips: "05093",
    county_name: "Mississippi",
    county_weights: {
      "05093": 100,
    },
    county_names_all: "Mississippi",
    county_fips_all: "05093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72359,
    lat: 35.01422,
    lng: -90.7239,
    city: "Madison",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 437,
    density: 228.4,
    county_fips: "05123",
    county_name: "St. Francis",
    county_weights: {
      "05123": 100,
    },
    county_names_all: "St. Francis",
    county_fips_all: "05123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72360,
    lat: 34.75352,
    lng: -90.78875,
    city: "Marianna",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5411,
    density: 7.2,
    county_fips: "05077",
    county_name: "Lee",
    county_weights: {
      "05077": 100,
    },
    county_names_all: "Lee",
    county_fips_all: "05077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72364,
    lat: 35.2126,
    lng: -90.18573,
    city: "Marion",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15536,
    density: 75,
    county_fips: "05035",
    county_name: "Crittenden",
    county_weights: {
      "05035": 100,
    },
    county_names_all: "Crittenden",
    county_fips_all: "05035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72365,
    lat: 35.56181,
    lng: -90.41857,
    city: "Marked Tree",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2454,
    density: 10.5,
    county_fips: "05111",
    county_name: "Poinsett",
    county_weights: {
      "05111": 100,
    },
    county_names_all: "Poinsett",
    county_fips_all: "05111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72366,
    lat: 34.52612,
    lng: -90.95307,
    city: "Marvell",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2248,
    density: 6.7,
    county_fips: "05107",
    county_name: "Phillips",
    county_weights: {
      "05107": 93.59,
      "05095": 3.84,
      "05077": 2.57,
    },
    county_names_all: "Phillips|Monroe|Lee",
    county_fips_all: "05107|05095|05077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72367,
    lat: 34.1891,
    lng: -91.02567,
    city: "Mellwood",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8,
    density: 0.1,
    county_fips: "05107",
    county_name: "Phillips",
    county_weights: {
      "05107": 100,
    },
    county_names_all: "Phillips",
    county_fips_all: "05107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72368,
    lat: 34.81146,
    lng: -91.01996,
    city: "Moro",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1192,
    density: 3.1,
    county_fips: "05077",
    county_name: "Lee",
    county_weights: {
      "05077": 85.48,
      "05095": 14.52,
    },
    county_names_all: "Lee|Monroe",
    county_fips_all: "05077|05095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72369,
    lat: 34.45522,
    lng: -90.78954,
    city: "Oneida",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05107",
    county_name: "Phillips",
    county_weights: {
      "05107": 100,
    },
    county_names_all: "Phillips",
    county_fips_all: "05107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72370,
    lat: 35.68443,
    lng: -90.07734,
    city: "Osceola",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7302,
    density: 22.4,
    county_fips: "05093",
    county_name: "Mississippi",
    county_weights: {
      "05093": 100,
    },
    county_names_all: "Mississippi",
    county_fips_all: "05093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72372,
    lat: 34.96623,
    lng: -90.94726,
    city: "Palestine",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1939,
    density: 6.1,
    county_fips: "05123",
    county_name: "St. Francis",
    county_weights: {
      "05123": 79.84,
      "05077": 20.16,
    },
    county_names_all: "St. Francis|Lee",
    county_fips_all: "05123|05077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72373,
    lat: 35.28861,
    lng: -90.60269,
    city: "Parkin",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 949,
    density: 2.9,
    county_fips: "05037",
    county_name: "Cross",
    county_weights: {
      "05037": 100,
    },
    county_names_all: "Cross",
    county_fips_all: "05037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72374,
    lat: 34.56126,
    lng: -90.83996,
    city: "Poplar Grove",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 609,
    density: 5.6,
    county_fips: "05107",
    county_name: "Phillips",
    county_weights: {
      "05107": 98.28,
      "05077": 1.72,
    },
    county_names_all: "Phillips|Lee",
    county_fips_all: "05107|05077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72376,
    lat: 35.0883,
    lng: -90.30625,
    city: "Proctor",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1531,
    density: 7,
    county_fips: "05035",
    county_name: "Crittenden",
    county_weights: {
      "05035": 97.01,
      "05123": 2.99,
    },
    county_names_all: "Crittenden|St. Francis",
    county_fips_all: "05035|05123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72377,
    lat: 35.67392,
    lng: -90.34158,
    city: "Rivervale",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50,
    density: 298,
    county_fips: "05111",
    county_name: "Poinsett",
    county_weights: {
      "05111": 100,
    },
    county_names_all: "Poinsett",
    county_fips_all: "05111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72379,
    lat: 34.07479,
    lng: -91.05019,
    city: "Snow Lake",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13,
    density: 0.1,
    county_fips: "05041",
    county_name: "Desha",
    county_weights: {
      "05041": 99.87,
      "05107": 0.13,
    },
    county_names_all: "Desha|Phillips",
    county_fips_all: "05041|05107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72383,
    lat: 34.49117,
    lng: -91.03962,
    city: "Turner",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75,
    density: 5.5,
    county_fips: "05107",
    county_name: "Phillips",
    county_weights: {
      "05107": 100,
    },
    county_names_all: "Phillips",
    county_fips_all: "05107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72384,
    lat: 35.37487,
    lng: -90.21825,
    city: "Turrell",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 909,
    density: 3.7,
    county_fips: "05035",
    county_name: "Crittenden",
    county_weights: {
      "05035": 100,
    },
    county_names_all: "Crittenden",
    county_fips_all: "05035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72386,
    lat: 35.45548,
    lng: -90.36183,
    city: "Tyronza",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1724,
    density: 5.8,
    county_fips: "05111",
    county_name: "Poinsett",
    county_weights: {
      "05111": 41.91,
      "05035": 35.34,
      "05093": 22.75,
    },
    county_names_all: "Poinsett|Crittenden|Mississippi",
    county_fips_all: "05111|05035|05093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72387,
    lat: 35.31572,
    lng: -90.77274,
    city: "Vanndale",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05037",
    county_name: "Cross",
    county_weights: {
      "05037": 100,
    },
    county_names_all: "Cross",
    county_fips_all: "05037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72389,
    lat: 34.36985,
    lng: -90.88596,
    city: "Wabash",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 417,
    density: 3.8,
    county_fips: "05107",
    county_name: "Phillips",
    county_weights: {
      "05107": 100,
    },
    county_names_all: "Phillips",
    county_fips_all: "05107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72390,
    lat: 34.55426,
    lng: -90.67756,
    city: "West Helena",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7744,
    density: 89.6,
    county_fips: "05107",
    county_name: "Phillips",
    county_weights: {
      "05107": 100,
    },
    county_names_all: "Phillips",
    county_fips_all: "05107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72391,
    lat: 35.6765,
    lng: -90.26953,
    city: "West Ridge",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05093",
    county_name: "Mississippi",
    county_weights: {
      "05093": 100,
    },
    county_names_all: "Mississippi",
    county_fips_all: "05093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72392,
    lat: 34.95551,
    lng: -91.09466,
    city: "Wheatley",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 664,
    density: 6.3,
    county_fips: "05123",
    county_name: "St. Francis",
    county_weights: {
      "05123": 88.26,
      "05147": 7.48,
      "05095": 4.26,
    },
    county_names_all: "St. Francis|Woodruff|Monroe",
    county_fips_all: "05123|05147|05095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72394,
    lat: 35.05271,
    lng: -90.61599,
    city: "Widener",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 389,
    density: 1.7,
    county_fips: "05123",
    county_name: "St. Francis",
    county_weights: {
      "05123": 100,
    },
    county_names_all: "St. Francis",
    county_fips_all: "05123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72395,
    lat: 35.59149,
    lng: -90.02036,
    city: "Wilson",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1171,
    density: 7.8,
    county_fips: "05093",
    county_name: "Mississippi",
    county_weights: {
      "05093": 100,
    },
    county_names_all: "Mississippi",
    county_fips_all: "05093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72396,
    lat: 35.22966,
    lng: -90.83559,
    city: "Wynne",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12430,
    density: 19.7,
    county_fips: "05037",
    county_name: "Cross",
    county_weights: {
      "05037": 94.76,
      "05123": 5.24,
    },
    county_names_all: "Cross|St. Francis",
    county_fips_all: "05037|05123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72401,
    lat: 35.86835,
    lng: -90.66193,
    city: "Jonesboro",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59098,
    density: 257.8,
    county_fips: "05031",
    county_name: "Craighead",
    county_weights: {
      "05031": 90.71,
      "05055": 9.29,
    },
    county_names_all: "Craighead|Greene",
    county_fips_all: "05031|05055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72404,
    lat: 35.77656,
    lng: -90.78356,
    city: "Jonesboro",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29937,
    density: 90.3,
    county_fips: "05031",
    county_name: "Craighead",
    county_weights: {
      "05031": 100,
    },
    county_names_all: "Craighead",
    county_fips_all: "05031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72405,
    lat: 35.90446,
    lng: -90.64869,
    city: "Jonesboro",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05031",
    county_name: "Craighead",
    county_weights: {
      "05031": 100,
    },
    county_names_all: "Craighead",
    county_fips_all: "05031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72410,
    lat: 35.93854,
    lng: -91.09432,
    city: "Alicia",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 477,
    density: 2.4,
    county_fips: "05075",
    county_name: "Lawrence",
    county_weights: {
      "05075": 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: "05075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72411,
    lat: 35.74165,
    lng: -90.58019,
    city: "Bay",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2680,
    density: 28.6,
    county_fips: "05031",
    county_name: "Craighead",
    county_weights: {
      "05031": 100,
    },
    county_names_all: "Craighead",
    county_fips_all: "05031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72412,
    lat: 36.12572,
    lng: -90.69172,
    city: "Beech Grove",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 434,
    density: 2.8,
    county_fips: "05055",
    county_name: "Greene",
    county_weights: {
      "05055": 100,
    },
    county_names_all: "Greene",
    county_fips_all: "05055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72413,
    lat: 36.30564,
    lng: -90.81251,
    city: "Biggers",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 548,
    density: 3.7,
    county_fips: "05121",
    county_name: "Randolph",
    county_weights: {
      "05121": 80.42,
      "05021": 19.58,
    },
    county_names_all: "Randolph|Clay",
    county_fips_all: "05121|05021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72414,
    lat: 35.82288,
    lng: -90.368,
    city: "Black Oak",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 318,
    density: 7.2,
    county_fips: "05031",
    county_name: "Craighead",
    county_weights: {
      "05031": 100,
    },
    county_names_all: "Craighead",
    county_fips_all: "05031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72415,
    lat: 36.12643,
    lng: -91.17745,
    city: "Black Rock",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1431,
    density: 14.3,
    county_fips: "05075",
    county_name: "Lawrence",
    county_weights: {
      "05075": 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: "05075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72416,
    lat: 35.95731,
    lng: -90.79699,
    city: "Bono",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5233,
    density: 22.8,
    county_fips: "05031",
    county_name: "Craighead",
    county_weights: {
      "05031": 55.15,
      "05055": 44.85,
    },
    county_names_all: "Craighead|Greene",
    county_fips_all: "05031|05055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72417,
    lat: 35.91994,
    lng: -90.54791,
    city: "Brookland",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5274,
    density: 47.3,
    county_fips: "05031",
    county_name: "Craighead",
    county_weights: {
      "05031": 100,
    },
    county_names_all: "Craighead",
    county_fips_all: "05031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72419,
    lat: 35.74158,
    lng: -90.35544,
    city: "Caraway",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1815,
    density: 13.8,
    county_fips: "05031",
    county_name: "Craighead",
    county_weights: {
      "05031": 95.01,
      "05111": 4.99,
    },
    county_names_all: "Craighead|Poinsett",
    county_fips_all: "05031|05111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72421,
    lat: 35.77851,
    lng: -90.97869,
    city: "Cash",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 435,
    density: 2.1,
    county_fips: "05031",
    county_name: "Craighead",
    county_weights: {
      "05031": 92.32,
      "05111": 7.68,
    },
    county_names_all: "Craighead|Poinsett",
    county_fips_all: "05031|05111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72422,
    lat: 36.41893,
    lng: -90.54385,
    city: "Corning",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4329,
    density: 10.1,
    county_fips: "05021",
    county_name: "Clay",
    county_weights: {
      "05021": 100,
    },
    county_names_all: "Clay",
    county_fips_all: "05021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72424,
    lat: 36.39185,
    lng: -90.72874,
    city: "Datto",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69,
    density: 47.5,
    county_fips: "05021",
    county_name: "Clay",
    county_weights: {
      "05021": 100,
    },
    county_names_all: "Clay",
    county_fips_all: "05021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72425,
    lat: 36.22138,
    lng: -90.74308,
    city: "Delaplaine",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 299,
    density: 1.4,
    county_fips: "05055",
    county_name: "Greene",
    county_weights: {
      "05055": 81.88,
      "05121": 17.8,
      "05021": 0.32,
    },
    county_names_all: "Greene|Randolph|Clay",
    county_fips_all: "05055|05121|05021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72426,
    lat: 35.85608,
    lng: -90.04159,
    city: "Dell",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 158,
    density: 158,
    county_fips: "05093",
    county_name: "Mississippi",
    county_weights: {
      "05093": 100,
    },
    county_names_all: "Mississippi",
    county_fips_all: "05093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72427,
    lat: 35.86872,
    lng: -90.94901,
    city: "Egypt",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 313,
    density: 497.3,
    county_fips: "05031",
    county_name: "Craighead",
    county_weights: {
      "05031": 100,
    },
    county_names_all: "Craighead",
    county_fips_all: "05031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72428,
    lat: 35.7414,
    lng: -90.21672,
    city: "Etowah",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 97,
    density: 5.5,
    county_fips: "05093",
    county_name: "Mississippi",
    county_weights: {
      "05093": 100,
    },
    county_names_all: "Mississippi",
    county_fips_all: "05093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72429,
    lat: 35.48895,
    lng: -90.93972,
    city: "Fisher",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 185,
    density: 1.1,
    county_fips: "05111",
    county_name: "Poinsett",
    county_weights: {
      "05111": 100,
    },
    county_names_all: "Poinsett",
    county_fips_all: "05111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72430,
    lat: 36.336,
    lng: -90.17366,
    city: "Greenway",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 345,
    density: 4.9,
    county_fips: "05021",
    county_name: "Clay",
    county_weights: {
      "05021": 100,
    },
    county_names_all: "Clay",
    county_fips_all: "05021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72431,
    lat: 35.63396,
    lng: -91.08184,
    city: "Grubbs",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 435,
    density: 26.7,
    county_fips: "05067",
    county_name: "Jackson",
    county_weights: {
      "05067": 100,
    },
    county_names_all: "Jackson",
    county_fips_all: "05067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72432,
    lat: 35.55438,
    lng: -90.72457,
    city: "Harrisburg",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7115,
    density: 16,
    county_fips: "05111",
    county_name: "Poinsett",
    county_weights: {
      "05111": 100,
    },
    county_names_all: "Poinsett",
    county_fips_all: "05111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72433,
    lat: 36.02582,
    lng: -91.04446,
    city: "Hoxie",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2713,
    density: 20.6,
    county_fips: "05075",
    county_name: "Lawrence",
    county_weights: {
      "05075": 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: "05075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72434,
    lat: 36.21847,
    lng: -91.16025,
    city: "Imboden",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2080,
    density: 9.3,
    county_fips: "05121",
    county_name: "Randolph",
    county_weights: {
      "05121": 68.13,
      "05075": 31.87,
    },
    county_names_all: "Randolph|Lawrence",
    county_fips_all: "05121|05075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72435,
    lat: 36.31177,
    lng: -90.54593,
    city: "Knobel",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 516,
    density: 3.6,
    county_fips: "05021",
    county_name: "Clay",
    county_weights: {
      "05021": 100,
    },
    county_names_all: "Clay",
    county_fips_all: "05021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72436,
    lat: 36.23574,
    lng: -90.48281,
    city: "Lafe",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 881,
    density: 11.1,
    county_fips: "05055",
    county_name: "Greene",
    county_weights: {
      "05055": 70.61,
      "05021": 29.39,
    },
    county_names_all: "Greene|Clay",
    county_fips_all: "05055|05021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72437,
    lat: 35.8343,
    lng: -90.45401,
    city: "Lake City",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3591,
    density: 13.2,
    county_fips: "05031",
    county_name: "Craighead",
    county_weights: {
      "05031": 100,
    },
    county_names_all: "Craighead",
    county_fips_all: "05031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72438,
    lat: 35.94375,
    lng: -90.22787,
    city: "Leachville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2580,
    density: 16.5,
    county_fips: "05093",
    county_name: "Mississippi",
    county_weights: {
      "05093": 92.95,
      "05031": 7.05,
    },
    county_names_all: "Mississippi|Craighead",
    county_fips_all: "05093|05031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72440,
    lat: 35.9924,
    lng: -91.26466,
    city: "Lynn",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 270,
    density: 18.2,
    county_fips: "05075",
    county_name: "Lawrence",
    county_weights: {
      "05075": 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: "05075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72441,
    lat: 36.4355,
    lng: -90.38944,
    city: "McDougal",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38,
    density: 107.2,
    county_fips: "05021",
    county_name: "Clay",
    county_weights: {
      "05021": 100,
    },
    county_names_all: "Clay",
    county_fips_all: "05021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72442,
    lat: 35.82458,
    lng: -90.17948,
    city: "Manila",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4263,
    density: 12.7,
    county_fips: "05093",
    county_name: "Mississippi",
    county_weights: {
      "05093": 100,
    },
    county_names_all: "Mississippi",
    county_fips_all: "05093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72443,
    lat: 36.1812,
    lng: -90.41037,
    city: "Marmaduke",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2967,
    density: 17.1,
    county_fips: "05055",
    county_name: "Greene",
    county_weights: {
      "05055": 100,
    },
    county_names_all: "Greene",
    county_fips_all: "05055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72444,
    lat: 36.4266,
    lng: -90.86106,
    city: "Maynard",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1634,
    density: 6.4,
    county_fips: "05121",
    county_name: "Randolph",
    county_weights: {
      "05121": 100,
    },
    county_names_all: "Randolph",
    county_fips_all: "05121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72445,
    lat: 35.97812,
    lng: -91.02669,
    city: "Minturn",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45,
    density: 40,
    county_fips: "05075",
    county_name: "Lawrence",
    county_weights: {
      "05075": 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: "05075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72447,
    lat: 35.9102,
    lng: -90.33428,
    city: "Monette",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1775,
    density: 12.2,
    county_fips: "05031",
    county_name: "Craighead",
    county_weights: {
      "05031": 100,
    },
    county_names_all: "Craighead",
    county_fips_all: "05031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72449,
    lat: 36.16662,
    lng: -90.81719,
    city: "O'Kean",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 252,
    density: 65.8,
    county_fips: "05121",
    county_name: "Randolph",
    county_weights: {
      "05121": 100,
    },
    county_names_all: "Randolph",
    county_fips_all: "05121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72450,
    lat: 36.0784,
    lng: -90.51695,
    city: "Paragould",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39002,
    density: 52.8,
    county_fips: "05055",
    county_name: "Greene",
    county_weights: {
      "05055": 98.29,
      "05031": 1.71,
    },
    county_names_all: "Greene|Craighead",
    county_fips_all: "05055|05031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72453,
    lat: 36.30909,
    lng: -90.67887,
    city: "Peach Orchard",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 179,
    density: 1.8,
    county_fips: "05021",
    county_name: "Clay",
    county_weights: {
      "05021": 100,
    },
    county_names_all: "Clay",
    county_fips_all: "05021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72454,
    lat: 36.40083,
    lng: -90.20623,
    city: "Piggott",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4642,
    density: 17.9,
    county_fips: "05021",
    county_name: "Clay",
    county_weights: {
      "05021": 100,
    },
    county_names_all: "Clay",
    county_fips_all: "05021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72455,
    lat: 36.3229,
    lng: -91.04909,
    city: "Pocahontas",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13147,
    density: 20,
    county_fips: "05121",
    county_name: "Randolph",
    county_weights: {
      "05121": 100,
    },
    county_names_all: "Randolph",
    county_fips_all: "05121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72456,
    lat: 36.45362,
    lng: -90.32217,
    city: "Pollard",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 473,
    density: 3.5,
    county_fips: "05021",
    county_name: "Clay",
    county_weights: {
      "05021": 100,
    },
    county_names_all: "Clay",
    county_fips_all: "05021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72457,
    lat: 36.08545,
    lng: -91.06827,
    city: "Portia",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 196,
    density: 956.9,
    county_fips: "05075",
    county_name: "Lawrence",
    county_weights: {
      "05075": 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: "05075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72458,
    lat: 36.06844,
    lng: -91.15619,
    city: "Powhatan",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 590,
    density: 9.7,
    county_fips: "05075",
    county_name: "Lawrence",
    county_weights: {
      "05075": 100,
    },
    county_names_all: "Lawrence",
    county_fips_all: "05075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72459,
    lat: 36.27904,
    lng: -91.29976,
    city: "Ravenden",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1242,
    density: 4.2,
    county_fips: "05121",
    county_name: "Randolph",
    county_weights: {
      "05121": 39.33,
      "05075": 36.56,
      "05135": 24.11,
    },
    county_names_all: "Randolph|Lawrence|Sharp",
    county_fips_all: "05121|05075|05135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72460,
    lat: 36.35792,
    lng: -91.15967,
    city: "Ravenden Springs",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 588,
    density: 3.9,
    county_fips: "05121",
    county_name: "Randolph",
    county_weights: {
      "05121": 100,
    },
    county_names_all: "Randolph",
    county_fips_all: "05121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72461,
    lat: 36.26679,
    lng: -90.28254,
    city: "Rector",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3728,
    density: 8.4,
    county_fips: "05021",
    county_name: "Clay",
    county_weights: {
      "05021": 82.93,
      "05055": 17.07,
    },
    county_names_all: "Clay|Greene",
    county_fips_all: "05021|05055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72462,
    lat: 36.38243,
    lng: -90.75916,
    city: "Reyno",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 398,
    density: 41.9,
    county_fips: "05121",
    county_name: "Randolph",
    county_weights: {
      "05121": 99.73,
      "05021": 0.27,
    },
    county_names_all: "Randolph|Clay",
    county_fips_all: "05121|05021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72464,
    lat: 36.45405,
    lng: -90.1434,
    city: "Saint Francis",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 132,
    density: 1928.5,
    county_fips: "05021",
    county_name: "Clay",
    county_weights: {
      "05021": 100,
    },
    county_names_all: "Clay",
    county_fips_all: "05021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72466,
    lat: 36.05121,
    lng: -91.32157,
    city: "Smithville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1508,
    density: 4.8,
    county_fips: "05075",
    county_name: "Lawrence",
    county_weights: {
      "05075": 59.14,
      "05135": 40.86,
    },
    county_names_all: "Lawrence|Sharp",
    county_fips_all: "05075|05135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72467,
    lat: 35.84223,
    lng: -90.6776,
    city: "State University",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 290,
    density: 436.5,
    county_fips: "05031",
    county_name: "Craighead",
    county_weights: {
      "05031": 100,
    },
    county_names_all: "Craighead",
    county_fips_all: "05031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72469,
    lat: 35.95367,
    lng: -91.29949,
    city: "Strawberry",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 892,
    density: 4.6,
    county_fips: "05075",
    county_name: "Lawrence",
    county_weights: {
      "05075": 75.51,
      "05135": 24.49,
    },
    county_names_all: "Lawrence|Sharp",
    county_fips_all: "05075|05135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72470,
    lat: 36.4668,
    lng: -90.70309,
    city: "Success",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 195,
    density: 2.1,
    county_fips: "05021",
    county_name: "Clay",
    county_weights: {
      "05021": 100,
    },
    county_names_all: "Clay",
    county_fips_all: "05021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72471,
    lat: 35.82591,
    lng: -91.11996,
    city: "Swifton",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1413,
    density: 6.4,
    county_fips: "05067",
    county_name: "Jackson",
    county_weights: {
      "05067": 100,
    },
    county_names_all: "Jackson",
    county_fips_all: "05067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72472,
    lat: 35.59264,
    lng: -90.54459,
    city: "Trumann",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8744,
    density: 21.6,
    county_fips: "05111",
    county_name: "Poinsett",
    county_weights: {
      "05111": 100,
    },
    county_names_all: "Poinsett",
    county_fips_all: "05111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72473,
    lat: 35.73531,
    lng: -91.17356,
    city: "Tuckerman",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2297,
    density: 14.1,
    county_fips: "05067",
    county_name: "Jackson",
    county_weights: {
      "05067": 100,
    },
    county_names_all: "Jackson",
    county_fips_all: "05067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72476,
    lat: 36.04533,
    lng: -90.91692,
    city: "Walnut Ridge",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6658,
    density: 11.5,
    county_fips: "05075",
    county_name: "Lawrence",
    county_weights: {
      "05075": 82.64,
      "05121": 8.92,
      "05031": 6.17,
      "05055": 2.27,
    },
    county_names_all: "Lawrence|Randolph|Craighead|Greene",
    county_fips_all: "05075|05121|05031|05055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72478,
    lat: 36.46249,
    lng: -91.05373,
    city: "Warm Springs",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 216,
    density: 1.6,
    county_fips: "05121",
    county_name: "Randolph",
    county_weights: {
      "05121": 100,
    },
    county_names_all: "Randolph",
    county_fips_all: "05121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72479,
    lat: 35.62924,
    lng: -90.90535,
    city: "Weiner",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1499,
    density: 3,
    county_fips: "05111",
    county_name: "Poinsett",
    county_weights: {
      "05111": 87.86,
      "05067": 6.63,
      "05031": 5.51,
    },
    county_names_all: "Poinsett|Jackson|Craighead",
    county_fips_all: "05111|05067|05031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72482,
    lat: 36.26933,
    lng: -91.36402,
    city: "Williford",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1308,
    density: 7.1,
    county_fips: "05135",
    county_name: "Sharp",
    county_weights: {
      "05135": 99.72,
      "05075": 0.28,
    },
    county_names_all: "Sharp|Lawrence",
    county_fips_all: "05135|05075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72501,
    lat: 35.79167,
    lng: -91.65399,
    city: "Batesville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26011,
    density: 33,
    county_fips: "05063",
    county_name: "Independence",
    county_weights: {
      "05063": 99.25,
      "05065": 0.75,
    },
    county_names_all: "Independence|Izard",
    county_fips_all: "05063|05065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72512,
    lat: 36.22326,
    lng: -91.7514,
    city: "Horseshoe Bend",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2692,
    density: 48.4,
    county_fips: "05065",
    county_name: "Izard",
    county_weights: {
      "05065": 99.47,
      "05049": 0.53,
    },
    county_names_all: "Izard|Fulton",
    county_fips_all: "05065|05049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72513,
    lat: 36.23118,
    lng: -91.64722,
    city: "Ash Flat",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2362,
    density: 9.2,
    county_fips: "05135",
    county_name: "Sharp",
    county_weights: {
      "05135": 50.46,
      "05049": 36.54,
      "05065": 13,
    },
    county_names_all: "Sharp|Fulton|Izard",
    county_fips_all: "05135|05049|05065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72515,
    lat: 36.27634,
    lng: -92.05644,
    city: "Bexar",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "05049",
    county_name: "Fulton",
    county_weights: {
      "05049": 99.8,
      "05065": 0.2,
    },
    county_names_all: "Fulton|Izard",
    county_fips_all: "05049|05065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72517,
    lat: 36.1463,
    lng: -91.95403,
    city: "Brockwell",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 207,
    density: 3.6,
    county_fips: "05065",
    county_name: "Izard",
    county_weights: {
      "05065": 100,
    },
    county_names_all: "Izard",
    county_fips_all: "05065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72519,
    lat: 36.11876,
    lng: -92.17802,
    city: "Calico Rock",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3628,
    density: 8.8,
    county_fips: "05005",
    county_name: "Baxter",
    county_weights: {
      "05005": 38.67,
      "05137": 29.64,
      "05065": 28.83,
      "05049": 2.87,
    },
    county_names_all: "Baxter|Stone|Izard|Fulton",
    county_fips_all: "05005|05137|05065|05049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72520,
    lat: 36.39816,
    lng: -91.72476,
    city: "Camp",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 283,
    density: 3.5,
    county_fips: "05049",
    county_name: "Fulton",
    county_weights: {
      "05049": 100,
    },
    county_names_all: "Fulton",
    county_fips_all: "05049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72521,
    lat: 35.95196,
    lng: -91.54522,
    city: "Cave City",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5952,
    density: 19.4,
    county_fips: "05135",
    county_name: "Sharp",
    county_weights: {
      "05135": 67.99,
      "05063": 32.01,
    },
    county_names_all: "Sharp|Independence",
    county_fips_all: "05135|05063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72522,
    lat: 35.80471,
    lng: -91.46683,
    city: "Charlotte",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 391,
    density: 15.5,
    county_fips: "05063",
    county_name: "Independence",
    county_weights: {
      "05063": 100,
    },
    county_names_all: "Independence",
    county_fips_all: "05063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72523,
    lat: 35.64808,
    lng: -91.83632,
    city: "Concord",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1076,
    density: 10,
    county_fips: "05023",
    county_name: "Cleburne",
    county_weights: {
      "05023": 80.48,
      "05063": 19.52,
    },
    county_names_all: "Cleburne|Independence",
    county_fips_all: "05023|05063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72524,
    lat: 35.83551,
    lng: -91.30318,
    city: "Cord",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 362,
    density: 2.5,
    county_fips: "05063",
    county_name: "Independence",
    county_weights: {
      "05063": 100,
    },
    county_names_all: "Independence",
    county_fips_all: "05063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72526,
    lat: 35.87762,
    lng: -91.76623,
    city: "Cushman",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 111,
    density: 5.5,
    county_fips: "05063",
    county_name: "Independence",
    county_weights: {
      "05063": 100,
    },
    county_names_all: "Independence",
    county_fips_all: "05063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72527,
    lat: 35.74038,
    lng: -91.68323,
    city: "Desha",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 731,
    density: 73.4,
    county_fips: "05063",
    county_name: "Independence",
    county_weights: {
      "05063": 100,
    },
    county_names_all: "Independence",
    county_fips_all: "05063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72528,
    lat: 36.23816,
    lng: -92.115,
    city: "Dolph",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32,
    density: 0.8,
    county_fips: "05065",
    county_name: "Izard",
    county_weights: {
      "05065": 99.9,
      "05005": 0.1,
    },
    county_names_all: "Izard|Baxter",
    county_fips_all: "05065|05005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72529,
    lat: 36.29696,
    lng: -91.56676,
    city: "Cherokee Village",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4912,
    density: 92.4,
    county_fips: "05135",
    county_name: "Sharp",
    county_weights: {
      "05135": 55.49,
      "05049": 44.51,
    },
    county_names_all: "Sharp|Fulton",
    county_fips_all: "05135|05049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72530,
    lat: 35.61381,
    lng: -91.95715,
    city: "Drasco",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1157,
    density: 4.1,
    county_fips: "05023",
    county_name: "Cleburne",
    county_weights: {
      "05023": 94.28,
      "05137": 5.72,
    },
    county_names_all: "Cleburne|Stone",
    county_fips_all: "05023|05137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72531,
    lat: 36.32052,
    lng: -92.15121,
    city: "Elizabeth",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1176,
    density: 9.1,
    county_fips: "05049",
    county_name: "Fulton",
    county_weights: {
      "05049": 55.19,
      "05005": 44.81,
    },
    county_names_all: "Fulton|Baxter",
    county_fips_all: "05049|05005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72532,
    lat: 36.09905,
    lng: -91.59508,
    city: "Evening Shade",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 937,
    density: 3.7,
    county_fips: "05135",
    county_name: "Sharp",
    county_weights: {
      "05135": 83.67,
      "05065": 16.33,
    },
    county_names_all: "Sharp|Izard",
    county_fips_all: "05135|05065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72533,
    lat: 35.97921,
    lng: -92.24513,
    city: "Fifty Six",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 266,
    density: 2.1,
    county_fips: "05137",
    county_name: "Stone",
    county_weights: {
      "05137": 100,
    },
    county_names_all: "Stone",
    county_fips_all: "05137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72534,
    lat: 35.59272,
    lng: -91.73265,
    city: "Floral",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1460,
    density: 8.6,
    county_fips: "05063",
    county_name: "Independence",
    county_weights: {
      "05063": 81.22,
      "05023": 18.78,
    },
    county_names_all: "Independence|Cleburne",
    county_fips_all: "05063|05023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72536,
    lat: 36.14673,
    lng: -91.76115,
    city: "Franklin",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 484,
    density: 7.8,
    county_fips: "05065",
    county_name: "Izard",
    county_weights: {
      "05065": 100,
    },
    county_names_all: "Izard",
    county_fips_all: "05065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72537,
    lat: 36.45018,
    lng: -92.23371,
    city: "Gamaliel",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 885,
    density: 11.9,
    county_fips: "05005",
    county_name: "Baxter",
    county_weights: {
      "05005": 100,
    },
    county_names_all: "Baxter",
    county_fips_all: "05005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72538,
    lat: 36.43622,
    lng: -92.10612,
    city: "Gepp",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 858,
    density: 7.5,
    county_fips: "05049",
    county_name: "Fulton",
    county_weights: {
      "05049": 100,
    },
    county_names_all: "Fulton",
    county_fips_all: "05049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72539,
    lat: 36.33015,
    lng: -91.72259,
    city: "Glencoe",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 209,
    density: 4.4,
    county_fips: "05049",
    county_name: "Fulton",
    county_weights: {
      "05049": 100,
    },
    county_names_all: "Fulton",
    county_fips_all: "05049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72540,
    lat: 35.93355,
    lng: -91.9096,
    city: "Guion",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 97,
    density: 3,
    county_fips: "05065",
    county_name: "Izard",
    county_weights: {
      "05065": 100,
    },
    county_names_all: "Izard",
    county_fips_all: "05065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72542,
    lat: 36.29656,
    lng: -91.46925,
    city: "Hardy",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4031,
    density: 10.1,
    county_fips: "05135",
    county_name: "Sharp",
    county_weights: {
      "05135": 81.53,
      "05049": 18.47,
    },
    county_names_all: "Sharp|Fulton",
    county_fips_all: "05135|05049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72543,
    lat: 35.45528,
    lng: -91.99407,
    city: "Heber Springs",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13011,
    density: 44.2,
    county_fips: "05023",
    county_name: "Cleburne",
    county_weights: {
      "05023": 100,
    },
    county_names_all: "Cleburne",
    county_fips_all: "05023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72544,
    lat: 36.40395,
    lng: -92.19022,
    city: "Henderson",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 865,
    density: 11.6,
    county_fips: "05005",
    county_name: "Baxter",
    county_weights: {
      "05005": 100,
    },
    county_names_all: "Baxter",
    county_fips_all: "05005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72546,
    lat: 35.57711,
    lng: -91.94487,
    city: "Ida",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 202,
    density: 23.3,
    county_fips: "05023",
    county_name: "Cleburne",
    county_weights: {
      "05023": 100,
    },
    county_names_all: "Cleburne",
    county_fips_all: "05023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72550,
    lat: 35.70836,
    lng: -91.78387,
    city: "Locust Grove",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 820,
    density: 6.6,
    county_fips: "05063",
    county_name: "Independence",
    county_weights: {
      "05063": 69.01,
      "05023": 18.49,
      "05137": 12.5,
    },
    county_names_all: "Independence|Cleburne|Stone",
    county_fips_all: "05063|05023|05137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72553,
    lat: 35.70093,
    lng: -91.48212,
    city: "Magness",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25,
    density: 23.5,
    county_fips: "05063",
    county_name: "Independence",
    county_weights: {
      "05063": 100,
    },
    county_names_all: "Independence",
    county_fips_all: "05063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72554,
    lat: 36.43902,
    lng: -91.55668,
    city: "Mammoth Spring",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2546,
    density: 6.2,
    county_fips: "05049",
    county_name: "Fulton",
    county_weights: {
      "05049": 82.02,
      "05135": 17.98,
    },
    county_names_all: "Fulton|Sharp",
    county_fips_all: "05049|05135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72555,
    lat: 35.77165,
    lng: -91.88287,
    city: "Marcella",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 204,
    density: 6.2,
    county_fips: "05137",
    county_name: "Stone",
    county_weights: {
      "05137": 100,
    },
    county_names_all: "Stone",
    county_fips_all: "05137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72556,
    lat: 36.02472,
    lng: -91.95831,
    city: "Melbourne",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3472,
    density: 8.3,
    county_fips: "05065",
    county_name: "Izard",
    county_weights: {
      "05065": 100,
    },
    county_names_all: "Izard",
    county_fips_all: "05065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72560,
    lat: 35.84023,
    lng: -92.08032,
    city: "Mountain View",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8574,
    density: 11.1,
    county_fips: "05137",
    county_name: "Stone",
    county_weights: {
      "05137": 99.29,
      "05065": 0.71,
    },
    county_names_all: "Stone|Izard",
    county_fips_all: "05137|05065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72561,
    lat: 35.9428,
    lng: -91.81093,
    city: "Mount Pleasant",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 686,
    density: 5.2,
    county_fips: "05065",
    county_name: "Izard",
    county_weights: {
      "05065": 100,
    },
    county_names_all: "Izard",
    county_fips_all: "05065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72562,
    lat: 35.73074,
    lng: -91.39514,
    city: "Newark",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2189,
    density: 10.7,
    county_fips: "05063",
    county_name: "Independence",
    county_weights: {
      "05063": 100,
    },
    county_names_all: "Independence",
    county_fips_all: "05063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72564,
    lat: 35.60034,
    lng: -91.45585,
    city: "Oil Trough",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 246,
    density: 3.2,
    county_fips: "05063",
    county_name: "Independence",
    county_weights: {
      "05063": 100,
    },
    county_names_all: "Independence",
    county_fips_all: "05063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72565,
    lat: 36.21871,
    lng: -91.90686,
    city: "Oxford",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 781,
    density: 8.9,
    county_fips: "05065",
    county_name: "Izard",
    county_weights: {
      "05065": 100,
    },
    county_names_all: "Izard",
    county_fips_all: "05065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72566,
    lat: 36.20792,
    lng: -92.06468,
    city: "Pineville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 668,
    density: 6.3,
    county_fips: "05065",
    county_name: "Izard",
    county_weights: {
      "05065": 100,
    },
    county_names_all: "Izard",
    county_fips_all: "05065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72567,
    lat: 35.81742,
    lng: -91.91975,
    city: "Pleasant Grove",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 265,
    density: 7.7,
    county_fips: "05137",
    county_name: "Stone",
    county_weights: {
      "05137": 100,
    },
    county_names_all: "Stone",
    county_fips_all: "05137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72568,
    lat: 35.56676,
    lng: -91.62147,
    city: "Pleasant Plains",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1474,
    density: 11.7,
    county_fips: "05063",
    county_name: "Independence",
    county_weights: {
      "05063": 92.52,
      "05145": 7.48,
    },
    county_names_all: "Independence|White",
    county_fips_all: "05063|05145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72569,
    lat: 36.08121,
    lng: -91.45817,
    city: "Poughkeepsie",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 674,
    density: 7.8,
    county_fips: "05135",
    county_name: "Sharp",
    county_weights: {
      "05135": 100,
    },
    county_names_all: "Sharp",
    county_fips_all: "05135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72571,
    lat: 35.64059,
    lng: -91.53568,
    city: "Rosie",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 294,
    density: 6.3,
    county_fips: "05063",
    county_name: "Independence",
    county_weights: {
      "05063": 100,
    },
    county_names_all: "Independence",
    county_fips_all: "05063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72572,
    lat: 35.89762,
    lng: -91.29173,
    city: "Saffell",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 227,
    density: 6.6,
    county_fips: "05075",
    county_name: "Lawrence",
    county_weights: {
      "05075": 75.46,
      "05063": 24.54,
    },
    county_names_all: "Lawrence|Independence",
    county_fips_all: "05075|05063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72573,
    lat: 36.07442,
    lng: -91.79624,
    city: "Sage",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 255,
    density: 6,
    county_fips: "05065",
    county_name: "Izard",
    county_weights: {
      "05065": 100,
    },
    county_names_all: "Izard",
    county_fips_all: "05065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72576,
    lat: 36.35004,
    lng: -91.85081,
    city: "Salem",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3444,
    density: 8.8,
    county_fips: "05049",
    county_name: "Fulton",
    county_weights: {
      "05049": 99.8,
      "05065": 0.2,
    },
    county_names_all: "Fulton|Izard",
    county_fips_all: "05049|05065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72577,
    lat: 36.03094,
    lng: -91.71379,
    city: "Sidney",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 705,
    density: 5.6,
    county_fips: "05065",
    county_name: "Izard",
    county_weights: {
      "05065": 64.76,
      "05135": 35.24,
    },
    county_names_all: "Izard|Sharp",
    county_fips_all: "05065|05135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72578,
    lat: 36.45734,
    lng: -91.87894,
    city: "Sturkie",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 178,
    density: 4.7,
    county_fips: "05049",
    county_name: "Fulton",
    county_weights: {
      "05049": 100,
    },
    county_names_all: "Fulton",
    county_fips_all: "05049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72579,
    lat: 35.84458,
    lng: -91.44428,
    city: "Sulphur Rock",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1404,
    density: 12.4,
    county_fips: "05063",
    county_name: "Independence",
    county_weights: {
      "05063": 78.63,
      "05135": 21.37,
    },
    county_names_all: "Independence|Sharp",
    county_fips_all: "05063|05135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72581,
    lat: 35.54722,
    lng: -91.97035,
    city: "Tumbling Shoals",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1126,
    density: 36,
    county_fips: "05023",
    county_name: "Cleburne",
    county_weights: {
      "05023": 100,
    },
    county_names_all: "Cleburne",
    county_fips_all: "05023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72583,
    lat: 36.40646,
    lng: -91.98797,
    city: "Viola",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2178,
    density: 7.6,
    county_fips: "05049",
    county_name: "Fulton",
    county_weights: {
      "05049": 100,
    },
    county_names_all: "Fulton",
    county_fips_all: "05049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72584,
    lat: 36.14421,
    lng: -91.84427,
    city: "Violet Hill",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 308,
    density: 3.1,
    county_fips: "05065",
    county_name: "Izard",
    county_weights: {
      "05065": 100,
    },
    county_names_all: "Izard",
    county_fips_all: "05065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72585,
    lat: 36.17861,
    lng: -92.01454,
    city: "Wideman",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 208,
    density: 3.4,
    county_fips: "05065",
    county_name: "Izard",
    county_weights: {
      "05065": 100,
    },
    county_names_all: "Izard",
    county_fips_all: "05065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72587,
    lat: 36.21977,
    lng: -91.8173,
    city: "Wiseman",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23,
    density: 1,
    county_fips: "05065",
    county_name: "Izard",
    county_weights: {
      "05065": 100,
    },
    county_names_all: "Izard",
    county_fips_all: "05065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72601,
    lat: 36.23669,
    lng: -93.09181,
    city: "Harrison",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29993,
    density: 31.7,
    county_fips: "05009",
    county_name: "Boone",
    county_weights: {
      "05009": 91.51,
      "05101": 5.76,
      "05089": 2.73,
    },
    county_names_all: "Boone|Newton|Marion",
    county_fips_all: "05009|05101|05089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72611,
    lat: 36.24532,
    lng: -93.32705,
    city: "Alpena",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1568,
    density: 7.4,
    county_fips: "05015",
    county_name: "Carroll",
    county_weights: {
      "05015": 66.74,
      "05009": 30.09,
      "05101": 3.17,
    },
    county_names_all: "Carroll|Boone|Newton",
    county_fips_all: "05015|05009|05101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72615,
    lat: 36.31532,
    lng: -93.01207,
    city: "Bergman",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05009",
    county_name: "Boone",
    county_weights: {
      "05009": 100,
    },
    county_names_all: "Boone",
    county_fips_all: "05009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72616,
    lat: 36.35047,
    lng: -93.55736,
    city: "Berryville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10707,
    density: 20.3,
    county_fips: "05015",
    county_name: "Carroll",
    county_weights: {
      "05015": 100,
    },
    county_names_all: "Carroll",
    county_fips_all: "05015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72617,
    lat: 36.0208,
    lng: -92.36566,
    city: "Big Flat",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 356,
    density: 3.6,
    county_fips: "05005",
    county_name: "Baxter",
    county_weights: {
      "05005": 97.68,
      "05137": 2.32,
    },
    county_names_all: "Baxter|Stone",
    county_fips_all: "05005|05137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72619,
    lat: 36.3781,
    lng: -92.58517,
    city: "Bull Shoals",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1811,
    density: 145.4,
    county_fips: "05089",
    county_name: "Marion",
    county_weights: {
      "05089": 100,
    },
    county_names_all: "Marion",
    county_fips_all: "05089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72623,
    lat: 36.46386,
    lng: -92.3172,
    city: "Clarkridge",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 978,
    density: 15.2,
    county_fips: "05005",
    county_name: "Baxter",
    county_weights: {
      "05005": 100,
    },
    county_names_all: "Baxter",
    county_fips_all: "05005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72624,
    lat: 36.08208,
    lng: -93.35655,
    city: "Compton",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 486,
    density: 3.8,
    county_fips: "05101",
    county_name: "Newton",
    county_weights: {
      "05101": 85.18,
      "05015": 14.82,
    },
    county_names_all: "Newton|Carroll",
    county_fips_all: "05101|05015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72626,
    lat: 36.30451,
    lng: -92.53994,
    city: "Cotter",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1608,
    density: 111.5,
    county_fips: "05005",
    county_name: "Baxter",
    county_weights: {
      "05005": 100,
    },
    county_names_all: "Baxter",
    county_fips_all: "05005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72628,
    lat: 35.82717,
    lng: -93.28785,
    city: "Deer",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 933,
    density: 2.5,
    county_fips: "05101",
    county_name: "Newton",
    county_weights: {
      "05101": 100,
    },
    county_names_all: "Newton",
    county_fips_all: "05101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72629,
    lat: 35.73615,
    lng: -92.56625,
    city: "Dennard",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 475,
    density: 4,
    county_fips: "05141",
    county_name: "Van Buren",
    county_weights: {
      "05141": 100,
    },
    county_names_all: "Van Buren",
    county_fips_all: "05141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72630,
    lat: 36.45856,
    lng: -92.92032,
    city: "Diamond City",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 265,
    density: 692.7,
    county_fips: "05009",
    county_name: "Boone",
    county_weights: {
      "05009": 100,
    },
    county_names_all: "Boone",
    county_fips_all: "05009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72631,
    lat: 36.45146,
    lng: -93.79131,
    city: "Eureka Springs",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4095,
    density: 32,
    county_fips: "05015",
    county_name: "Carroll",
    county_weights: {
      "05015": 100,
    },
    county_names_all: "Carroll",
    county_fips_all: "05015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72632,
    lat: 36.37248,
    lng: -93.74355,
    city: "Eureka Springs",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4380,
    density: 17.3,
    county_fips: "05015",
    county_name: "Carroll",
    county_weights: {
      "05015": 97.81,
      "05087": 2.19,
    },
    county_names_all: "Carroll|Madison",
    county_fips_all: "05015|05087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72633,
    lat: 36.14023,
    lng: -92.87572,
    city: "Everton",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1954,
    density: 8,
    county_fips: "05089",
    county_name: "Marion",
    county_weights: {
      "05089": 52.28,
      "05009": 31.53,
      "05129": 16.19,
    },
    county_names_all: "Marion|Boone|Searcy",
    county_fips_all: "05089|05009|05129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72634,
    lat: 36.23693,
    lng: -92.54891,
    city: "Flippin",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4153,
    density: 16,
    county_fips: "05089",
    county_name: "Marion",
    county_weights: {
      "05089": 100,
    },
    county_names_all: "Marion",
    county_fips_all: "05089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72635,
    lat: 36.31637,
    lng: -92.48484,
    city: "Gassville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3767,
    density: 46.1,
    county_fips: "05005",
    county_name: "Baxter",
    county_weights: {
      "05005": 100,
    },
    county_names_all: "Baxter",
    county_fips_all: "05005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72636,
    lat: 35.99121,
    lng: -92.71651,
    city: "Gilbert",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3,
    density: 7.4,
    county_fips: "05129",
    county_name: "Searcy",
    county_weights: {
      "05129": 100,
    },
    county_names_all: "Searcy",
    county_fips_all: "05129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72638,
    lat: 36.3245,
    lng: -93.40496,
    city: "Green Forest",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7073,
    density: 15.1,
    county_fips: "05015",
    county_name: "Carroll",
    county_weights: {
      "05015": 95.18,
      "05101": 4.82,
    },
    county_names_all: "Carroll|Newton",
    county_fips_all: "05015|05101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72639,
    lat: 36.01948,
    lng: -92.48937,
    city: "Harriet",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 720,
    density: 4,
    county_fips: "05129",
    county_name: "Searcy",
    county_weights: {
      "05129": 90.53,
      "05089": 9.47,
    },
    county_names_all: "Searcy|Marion",
    county_fips_all: "05129|05089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72640,
    lat: 36.00708,
    lng: -93.05061,
    city: "Hasty",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 469,
    density: 8.5,
    county_fips: "05101",
    county_name: "Newton",
    county_weights: {
      "05101": 100,
    },
    county_names_all: "Newton",
    county_fips_all: "05101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72641,
    lat: 35.98829,
    lng: -93.21978,
    city: "Jasper",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2664,
    density: 9.1,
    county_fips: "05101",
    county_name: "Newton",
    county_weights: {
      "05101": 100,
    },
    county_names_all: "Newton",
    county_fips_all: "05101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72642,
    lat: 36.37013,
    lng: -92.54347,
    city: "Lakeview",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1906,
    density: 82.8,
    county_fips: "05005",
    county_name: "Baxter",
    county_weights: {
      "05005": 100,
    },
    county_names_all: "Baxter",
    county_fips_all: "05005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72644,
    lat: 36.42477,
    lng: -92.96673,
    city: "Lead Hill",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2751,
    density: 12.1,
    county_fips: "05009",
    county_name: "Boone",
    county_weights: {
      29213: 1.2,
      "05009": 91.75,
      "05089": 7.05,
    },
    county_names_all: "Boone|Marion|Taney",
    county_fips_all: "05009|05089|29213",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72645,
    lat: 35.80249,
    lng: -92.55778,
    city: "Leslie",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1792,
    density: 4.5,
    county_fips: "05129",
    county_name: "Searcy",
    county_weights: {
      "05129": 66.36,
      "05141": 19.28,
      "05137": 14.36,
    },
    county_names_all: "Searcy|Van Buren|Stone",
    county_fips_all: "05129|05141|05137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72648,
    lat: 36.07516,
    lng: -93.14399,
    city: "Marble Falls",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 568,
    density: 6.1,
    county_fips: "05101",
    county_name: "Newton",
    county_weights: {
      "05101": 100,
    },
    county_names_all: "Newton",
    county_fips_all: "05101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72650,
    lat: 35.87938,
    lng: -92.69308,
    city: "Marshall",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4091,
    density: 5.8,
    county_fips: "05129",
    county_name: "Searcy",
    county_weights: {
      "05129": 97.05,
      "05137": 2.95,
    },
    county_names_all: "Searcy|Stone",
    county_fips_all: "05129|05137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72651,
    lat: 36.388,
    lng: -92.47661,
    city: "Midway",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1015,
    density: 48.6,
    county_fips: "05005",
    county_name: "Baxter",
    county_weights: {
      "05005": 100,
    },
    county_names_all: "Baxter",
    county_fips_all: "05005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72653,
    lat: 36.34292,
    lng: -92.38603,
    city: "Mountain Home",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28157,
    density: 49.2,
    county_fips: "05005",
    county_name: "Baxter",
    county_weights: {
      "05005": 97.12,
      "05089": 2.88,
    },
    county_names_all: "Baxter|Marion",
    county_fips_all: "05005|05089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72655,
    lat: 35.89346,
    lng: -93.03421,
    city: "Mount Judea",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 324,
    density: 1.1,
    county_fips: "05101",
    county_name: "Newton",
    county_weights: {
      "05101": 100,
    },
    county_names_all: "Newton",
    county_fips_all: "05101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72658,
    lat: 36.15468,
    lng: -92.32301,
    city: "Norfork",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1273,
    density: 5.8,
    county_fips: "05005",
    county_name: "Baxter",
    county_weights: {
      "05005": 100,
    },
    county_names_all: "Baxter",
    county_fips_all: "05005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72660,
    lat: 36.48115,
    lng: -93.37454,
    city: "Oak Grove",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 796,
    density: 18.3,
    county_fips: "05015",
    county_name: "Carroll",
    county_weights: {
      "05015": 100,
    },
    county_names_all: "Carroll",
    county_fips_all: "05015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72661,
    lat: 36.45195,
    lng: -92.58963,
    city: "Oakland",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 602,
    density: 9.6,
    county_fips: "05089",
    county_name: "Marion",
    county_weights: {
      "05089": 100,
    },
    county_names_all: "Marion",
    county_fips_all: "05089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72662,
    lat: 36.43184,
    lng: -93.18297,
    city: "Omaha",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2870,
    density: 9.4,
    county_fips: "05009",
    county_name: "Boone",
    county_weights: {
      "05009": 98.59,
      "05015": 1.41,
    },
    county_names_all: "Boone|Carroll",
    county_fips_all: "05009|05015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72663,
    lat: 35.93617,
    lng: -92.33192,
    city: "Onia",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 182,
    density: 3.2,
    county_fips: "05137",
    county_name: "Stone",
    county_weights: {
      "05137": 100,
    },
    county_names_all: "Stone",
    county_fips_all: "05137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72666,
    lat: 35.94876,
    lng: -93.28706,
    city: "Parthenon",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 71,
    density: 0.9,
    county_fips: "05101",
    county_name: "Newton",
    county_weights: {
      "05101": 100,
    },
    county_names_all: "Newton",
    county_fips_all: "05101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72668,
    lat: 36.41914,
    lng: -92.77163,
    city: "Peel",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 136,
    density: 1.8,
    county_fips: "05089",
    county_name: "Marion",
    county_weights: {
      "05089": 100,
    },
    county_names_all: "Marion",
    county_fips_all: "05089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72669,
    lat: 36.06477,
    lng: -92.87359,
    city: "Pindall",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 133,
    density: 34.3,
    county_fips: "05129",
    county_name: "Searcy",
    county_weights: {
      "05129": 100,
    },
    county_names_all: "Searcy",
    county_fips_all: "05129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72670,
    lat: 35.98726,
    lng: -93.37775,
    city: "Ponca",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "05101",
    county_name: "Newton",
    county_weights: {
      "05101": 100,
    },
    county_names_all: "Newton",
    county_fips_all: "05101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72672,
    lat: 36.27725,
    lng: -92.83685,
    city: "Pyatt",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 172,
    density: 3.9,
    county_fips: "05089",
    county_name: "Marion",
    county_weights: {
      "05089": 100,
    },
    county_names_all: "Marion",
    county_fips_all: "05089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72675,
    lat: 36.00711,
    lng: -92.79283,
    city: "Saint Joe",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1396,
    density: 2.8,
    county_fips: "05129",
    county_name: "Searcy",
    county_weights: {
      "05129": 86.54,
      "05089": 13.46,
    },
    county_names_all: "Searcy|Marion",
    county_fips_all: "05129|05089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72677,
    lat: 36.26442,
    lng: -92.70074,
    city: "Summit",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 467,
    density: 32.9,
    county_fips: "05089",
    county_name: "Marion",
    county_weights: {
      "05089": 100,
    },
    county_names_all: "Marion",
    county_fips_all: "05089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72679,
    lat: 35.73555,
    lng: -92.80206,
    city: "Tilly",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7,
    density: 0.2,
    county_fips: "05129",
    county_name: "Searcy",
    county_weights: {
      "05129": 84.95,
      "05141": 11.02,
      "05115": 4.03,
    },
    county_names_all: "Searcy|Van Buren|Pope",
    county_fips_all: "05129|05141|05115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72680,
    lat: 35.88286,
    lng: -92.32986,
    city: "Timbo",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 892,
    density: 8.6,
    county_fips: "05137",
    county_name: "Stone",
    county_weights: {
      "05137": 91.13,
      "05129": 8.87,
    },
    county_names_all: "Stone|Searcy",
    county_fips_all: "05137|05129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72682,
    lat: 36.13405,
    lng: -92.72911,
    city: "Valley Springs",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 148,
    density: 3.2,
    county_fips: "05089",
    county_name: "Marion",
    county_weights: {
      "05089": 100,
    },
    county_names_all: "Marion",
    county_fips_all: "05089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72683,
    lat: 35.93102,
    lng: -93.11629,
    city: "Vendor",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 408,
    density: 9.9,
    county_fips: "05101",
    county_name: "Newton",
    county_weights: {
      "05101": 100,
    },
    county_names_all: "Newton",
    county_fips_all: "05101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72685,
    lat: 36.05539,
    lng: -92.98194,
    city: "Western Grove",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1356,
    density: 10.2,
    county_fips: "05101",
    county_name: "Newton",
    county_weights: {
      "05101": 81.19,
      "05129": 16.88,
      "05009": 1.93,
    },
    county_names_all: "Newton|Searcy|Boone",
    county_fips_all: "05101|05129|05009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72686,
    lat: 35.70352,
    lng: -92.918,
    city: "Witts Springs",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 130,
    density: 0.8,
    county_fips: "05115",
    county_name: "Pope",
    county_weights: {
      "05115": 57.71,
      "05129": 42.29,
    },
    county_names_all: "Pope|Searcy",
    county_fips_all: "05115|05129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72687,
    lat: 36.25628,
    lng: -92.68679,
    city: "Yellville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7737,
    density: 10.9,
    county_fips: "05089",
    county_name: "Marion",
    county_weights: {
      "05089": 99.68,
      "05009": 0.32,
    },
    county_names_all: "Marion|Boone",
    county_fips_all: "05089|05009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72701,
    lat: 35.9873,
    lng: -94.08179,
    city: "Fayetteville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45396,
    density: 139.1,
    county_fips: "05143",
    county_name: "Washington",
    county_weights: {
      "05143": 100,
    },
    county_names_all: "Washington",
    county_fips_all: "05143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72703,
    lat: 36.1155,
    lng: -94.04897,
    city: "Fayetteville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33223,
    density: 319,
    county_fips: "05143",
    county_name: "Washington",
    county_weights: {
      "05143": 95.27,
      "05087": 4.73,
    },
    county_names_all: "Washington|Madison",
    county_fips_all: "05143|05087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72704,
    lat: 36.10475,
    lng: -94.29539,
    city: "Fayetteville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26480,
    density: 132.7,
    county_fips: "05143",
    county_name: "Washington",
    county_weights: {
      "05143": 98.61,
      "05007": 1.39,
    },
    county_names_all: "Washington|Benton",
    county_fips_all: "05143|05007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72712,
    lat: 36.39837,
    lng: -94.22196,
    city: "Bentonville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60096,
    density: 447.6,
    county_fips: "05007",
    county_name: "Benton",
    county_weights: {
      "05007": 100,
    },
    county_names_all: "Benton",
    county_fips_all: "05007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72713,
    lat: 36.30036,
    lng: -94.28372,
    city: "Bentonville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05007",
    county_name: "Benton",
    county_weights: {
      "05007": 100,
    },
    county_names_all: "Benton",
    county_fips_all: "05007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72714,
    lat: 36.46841,
    lng: -94.21649,
    city: "Bella Vista",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13858,
    density: 292.4,
    county_fips: "05007",
    county_name: "Benton",
    county_weights: {
      "05007": 100,
    },
    county_names_all: "Benton",
    county_fips_all: "05007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72715,
    lat: 36.46505,
    lng: -94.30545,
    city: "Bella Vista",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15537,
    density: 207.9,
    county_fips: "05007",
    county_name: "Benton",
    county_weights: {
      "05007": 100,
    },
    county_names_all: "Benton",
    county_fips_all: "05007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72717,
    lat: 35.84054,
    lng: -94.42503,
    city: "Canehill",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1014,
    density: 9,
    county_fips: "05143",
    county_name: "Washington",
    county_weights: {
      "05143": 100,
    },
    county_names_all: "Washington",
    county_fips_all: "05143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72718,
    lat: 36.26347,
    lng: -94.22147,
    city: "Cave Springs",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3971,
    density: 266.8,
    county_fips: "05007",
    county_name: "Benton",
    county_weights: {
      "05007": 100,
    },
    county_names_all: "Benton",
    county_fips_all: "05007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72719,
    lat: 36.36837,
    lng: -94.29551,
    city: "Centerton",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14115,
    density: 594.5,
    county_fips: "05007",
    county_name: "Benton",
    county_weights: {
      "05007": 100,
    },
    county_names_all: "Benton",
    county_fips_all: "05007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72721,
    lat: 35.78383,
    lng: -93.78402,
    city: "Combs",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 398,
    density: 2.4,
    county_fips: "05087",
    county_name: "Madison",
    county_weights: {
      "05087": 51.66,
      "05047": 48.34,
    },
    county_names_all: "Madison|Franklin",
    county_fips_all: "05087|05047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72722,
    lat: 36.34042,
    lng: -94.46397,
    city: "Decatur",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2737,
    density: 26.8,
    county_fips: "05007",
    county_name: "Benton",
    county_weights: {
      "05007": 100,
    },
    county_names_all: "Benton",
    county_fips_all: "05007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72727,
    lat: 35.91456,
    lng: -93.92612,
    city: "Elkins",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6460,
    density: 16,
    county_fips: "05087",
    county_name: "Madison",
    county_weights: {
      "05087": 63.14,
      "05143": 32.37,
      "05047": 4.49,
    },
    county_names_all: "Madison|Washington|Franklin",
    county_fips_all: "05087|05143|05047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72729,
    lat: 35.78992,
    lng: -94.46338,
    city: "Evansville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 96,
    density: 3.3,
    county_fips: "05143",
    county_name: "Washington",
    county_weights: {
      "05143": 100,
    },
    county_names_all: "Washington",
    county_fips_all: "05143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72730,
    lat: 36.03057,
    lng: -94.26588,
    city: "Farmington",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8624,
    density: 160.2,
    county_fips: "05143",
    county_name: "Washington",
    county_weights: {
      "05143": 100,
    },
    county_names_all: "Washington",
    county_fips_all: "05143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72732,
    lat: 36.43187,
    lng: -93.95968,
    city: "Garfield",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4716,
    density: 21,
    county_fips: "05007",
    county_name: "Benton",
    county_weights: {
      "05007": 100,
    },
    county_names_all: "Benton",
    county_fips_all: "05007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72734,
    lat: 36.27217,
    lng: -94.45355,
    city: "Gentry",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9054,
    density: 42.9,
    county_fips: "05007",
    county_name: "Benton",
    county_weights: {
      "05007": 98.78,
      "05143": 1.22,
    },
    county_names_all: "Benton|Washington",
    county_fips_all: "05007|05143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72736,
    lat: 36.41402,
    lng: -94.46548,
    city: "Gravette",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7417,
    density: 29.1,
    county_fips: "05007",
    county_name: "Benton",
    county_weights: {
      "05007": 100,
    },
    county_names_all: "Benton",
    county_fips_all: "05007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72738,
    lat: 36.16258,
    lng: -93.885,
    city: "Hindsville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2573,
    density: 11.7,
    county_fips: "05087",
    county_name: "Madison",
    county_weights: {
      "05087": 79.05,
      "05143": 13.83,
      "05007": 7.12,
    },
    county_names_all: "Madison|Washington|Benton",
    county_fips_all: "05087|05143|05007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72739,
    lat: 36.42715,
    lng: -94.32801,
    city: "Hiwasse",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 508,
    density: 44.3,
    county_fips: "05007",
    county_name: "Benton",
    county_weights: {
      "05007": 100,
    },
    county_names_all: "Benton",
    county_fips_all: "05007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72740,
    lat: 36.10889,
    lng: -93.67599,
    city: "Huntsville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9318,
    density: 9.5,
    county_fips: "05087",
    county_name: "Madison",
    county_weights: {
      "05087": 90.49,
      "05015": 7.67,
      "05101": 1.84,
    },
    county_names_all: "Madison|Carroll|Newton",
    county_fips_all: "05087|05015|05101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72742,
    lat: 35.98159,
    lng: -93.49528,
    city: "Kingston",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 825,
    density: 4.7,
    county_fips: "05087",
    county_name: "Madison",
    county_weights: {
      "05087": 84.81,
      "05101": 15.19,
    },
    county_names_all: "Madison|Newton",
    county_fips_all: "05087|05101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72744,
    lat: 35.96287,
    lng: -94.43851,
    city: "Lincoln",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5291,
    density: 25.9,
    county_fips: "05143",
    county_name: "Washington",
    county_weights: {
      "05143": 100,
    },
    county_names_all: "Washington",
    county_fips_all: "05143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72745,
    lat: 36.2477,
    lng: -94.10046,
    city: "Lowell",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13761,
    density: 166.9,
    county_fips: "05007",
    county_name: "Benton",
    county_weights: {
      "05007": 100,
    },
    county_names_all: "Benton",
    county_fips_all: "05007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72747,
    lat: 36.37023,
    lng: -94.5807,
    city: "Maysville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 293,
    density: 16.8,
    county_fips: "05007",
    county_name: "Benton",
    county_weights: {
      "05007": 100,
    },
    county_names_all: "Benton",
    county_fips_all: "05007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72749,
    lat: 35.86712,
    lng: -94.43932,
    city: "Morrow",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 512,
    density: 169.7,
    county_fips: "05143",
    county_name: "Washington",
    county_weights: {
      "05143": 100,
    },
    county_names_all: "Washington",
    county_fips_all: "05143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72751,
    lat: 36.46255,
    lng: -94.11825,
    city: "Pea Ridge",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8296,
    density: 132.9,
    county_fips: "05007",
    county_name: "Benton",
    county_weights: {
      "05007": 100,
    },
    county_names_all: "Benton",
    county_fips_all: "05007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72752,
    lat: 35.82077,
    lng: -93.56357,
    city: "Pettigrew",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 313,
    density: 1,
    county_fips: "05087",
    county_name: "Madison",
    county_weights: {
      "05087": 49.25,
      "05101": 30.97,
      "05071": 19.77,
    },
    county_names_all: "Madison|Newton|Johnson",
    county_fips_all: "05087|05101|05071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72753,
    lat: 35.93477,
    lng: -94.32607,
    city: "Prairie Grove",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9885,
    density: 42.8,
    county_fips: "05143",
    county_name: "Washington",
    county_weights: {
      "05143": 100,
    },
    county_names_all: "Washington",
    county_fips_all: "05143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72756,
    lat: 36.32214,
    lng: -93.9922,
    city: "Rogers",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42830,
    density: 127.3,
    county_fips: "05007",
    county_name: "Benton",
    county_weights: {
      "05007": 90.29,
      "05087": 9.71,
    },
    county_names_all: "Benton|Madison",
    county_fips_all: "05007|05087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72758,
    lat: 36.29898,
    lng: -94.14099,
    city: "Rogers",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42193,
    density: 520.3,
    county_fips: "05007",
    county_name: "Benton",
    county_weights: {
      "05007": 100,
    },
    county_names_all: "Benton",
    county_fips_all: "05007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72760,
    lat: 35.82898,
    lng: -93.69804,
    city: "Saint Paul",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 294,
    density: 3.9,
    county_fips: "05087",
    county_name: "Madison",
    county_weights: {
      "05087": 100,
    },
    county_names_all: "Madison",
    county_fips_all: "05087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72761,
    lat: 36.17074,
    lng: -94.45778,
    city: "Siloam Springs",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22591,
    density: 76.5,
    county_fips: "05007",
    county_name: "Benton",
    county_weights: {
      "05007": 95.39,
      "05143": 4.61,
    },
    county_names_all: "Benton|Washington",
    county_fips_all: "05007|05143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72762,
    lat: 36.18747,
    lng: -94.22794,
    city: "Springdale",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41669,
    density: 276.7,
    county_fips: "05143",
    county_name: "Washington",
    county_weights: {
      "05143": 78.67,
      "05007": 21.33,
    },
    county_names_all: "Washington|Benton",
    county_fips_all: "05143|05007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72764,
    lat: 36.17746,
    lng: -94.051,
    city: "Springdale",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57561,
    density: 335.9,
    county_fips: "05143",
    county_name: "Washington",
    county_weights: {
      "05143": 91.42,
      "05007": 8.58,
    },
    county_names_all: "Washington|Benton",
    county_fips_all: "05143|05007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72768,
    lat: 36.47884,
    lng: -94.4938,
    city: "Sulphur Springs",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1330,
    density: 16.3,
    county_fips: "05007",
    county_name: "Benton",
    county_weights: {
      "05007": 100,
    },
    county_names_all: "Benton",
    county_fips_all: "05007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72769,
    lat: 36.0347,
    lng: -94.49702,
    city: "Summers",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1611,
    density: 15.3,
    county_fips: "05143",
    county_name: "Washington",
    county_weights: {
      "05143": 100,
    },
    county_names_all: "Washington",
    county_fips_all: "05143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72773,
    lat: 36.01409,
    lng: -93.84723,
    city: "Wesley",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1521,
    density: 12.1,
    county_fips: "05087",
    county_name: "Madison",
    county_weights: {
      "05087": 97.02,
      "05143": 2.98,
    },
    county_names_all: "Madison|Washington",
    county_fips_all: "05087|05143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72774,
    lat: 35.87777,
    lng: -94.21533,
    city: "West Fork",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6298,
    density: 20.2,
    county_fips: "05143",
    county_name: "Washington",
    county_weights: {
      "05143": 100,
    },
    county_names_all: "Washington",
    county_fips_all: "05143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72776,
    lat: 35.90913,
    lng: -93.67307,
    city: "Witter",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 687,
    density: 3.4,
    county_fips: "05087",
    county_name: "Madison",
    county_weights: {
      "05087": 100,
    },
    county_names_all: "Madison",
    county_fips_all: "05087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72801,
    lat: 35.28057,
    lng: -93.14161,
    city: "Russellville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19289,
    density: 929.7,
    county_fips: "05115",
    county_name: "Pope",
    county_weights: {
      "05115": 100,
    },
    county_names_all: "Pope",
    county_fips_all: "05115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72802,
    lat: 35.31334,
    lng: -93.06726,
    city: "Russellville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22751,
    density: 63.8,
    county_fips: "05115",
    county_name: "Pope",
    county_weights: {
      "05115": 100,
    },
    county_names_all: "Pope",
    county_fips_all: "05115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72821,
    lat: 35.4545,
    lng: -93.72024,
    city: "Altus",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1835,
    density: 22.1,
    county_fips: "05047",
    county_name: "Franklin",
    county_weights: {
      "05047": 64.86,
      "05071": 35.14,
    },
    county_names_all: "Franklin|Johnson",
    county_fips_all: "05047|05071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72823,
    lat: 35.25213,
    lng: -92.89847,
    city: "Atkins",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5750,
    density: 17.5,
    county_fips: "05115",
    county_name: "Pope",
    county_weights: {
      "05115": 78.01,
      "05029": 21.99,
    },
    county_names_all: "Pope|Conway",
    county_fips_all: "05115|05029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72824,
    lat: 35.12768,
    lng: -93.41146,
    city: "Belleville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2234,
    density: 11.9,
    county_fips: "05149",
    county_name: "Yell",
    county_weights: {
      "05149": 100,
    },
    county_names_all: "Yell",
    county_fips_all: "05149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72826,
    lat: 35.13,
    lng: -93.71025,
    city: "Blue Mountain",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 90,
    density: 671,
    county_fips: "05083",
    county_name: "Logan",
    county_weights: {
      "05083": 100,
    },
    county_names_all: "Logan",
    county_fips_all: "05083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72827,
    lat: 34.87758,
    lng: -93.61948,
    city: "Bluffton",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 218,
    density: 2.2,
    county_fips: "05149",
    county_name: "Yell",
    county_weights: {
      "05149": 84.42,
      "05127": 15.58,
    },
    county_names_all: "Yell|Scott",
    county_fips_all: "05149|05127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72828,
    lat: 34.92613,
    lng: -93.53951,
    city: "Briggsville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 113,
    density: 2.5,
    county_fips: "05149",
    county_name: "Yell",
    county_weights: {
      "05149": 100,
    },
    county_names_all: "Yell",
    county_fips_all: "05149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72829,
    lat: 35.10351,
    lng: -93.1753,
    city: "Centerville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05149",
    county_name: "Yell",
    county_weights: {
      "05149": 100,
    },
    county_names_all: "Yell",
    county_fips_all: "05149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72830,
    lat: 35.51685,
    lng: -93.50859,
    city: "Clarksville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16080,
    density: 44.5,
    county_fips: "05071",
    county_name: "Johnson",
    county_weights: {
      "05071": 100,
    },
    county_names_all: "Johnson",
    county_fips_all: "05071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72832,
    lat: 35.42748,
    lng: -93.67043,
    city: "Coal Hill",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 991,
    density: 112.3,
    county_fips: "05071",
    county_name: "Johnson",
    county_weights: {
      "05071": 100,
    },
    county_names_all: "Johnson",
    county_fips_all: "05071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72833,
    lat: 35.01845,
    lng: -93.49748,
    city: "Danville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3813,
    density: 6.6,
    county_fips: "05149",
    county_name: "Yell",
    county_weights: {
      "05149": 87.12,
      "05127": 12.88,
    },
    county_names_all: "Yell|Scott",
    county_fips_all: "05149|05127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72834,
    lat: 35.17202,
    lng: -93.19401,
    city: "Dardanelle",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10619,
    density: 25.7,
    county_fips: "05149",
    county_name: "Yell",
    county_weights: {
      "05149": 97.15,
      "05083": 2.85,
    },
    county_names_all: "Yell|Logan",
    county_fips_all: "05149|05083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72835,
    lat: 35.27634,
    lng: -93.3425,
    city: "Delaware",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 793,
    density: 6.7,
    county_fips: "05083",
    county_name: "Logan",
    county_weights: {
      "05083": 99.79,
      "05149": 0.21,
    },
    county_names_all: "Logan|Yell",
    county_fips_all: "05083|05149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72837,
    lat: 35.51387,
    lng: -93.10709,
    city: "Dover",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7837,
    density: 12.4,
    county_fips: "05115",
    county_name: "Pope",
    county_weights: {
      "05115": 100,
    },
    county_names_all: "Pope",
    county_fips_all: "05115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72838,
    lat: 34.88926,
    lng: -93.68009,
    city: "Gravelly",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 160,
    density: 3.4,
    county_fips: "05149",
    county_name: "Yell",
    county_weights: {
      "05149": 83.88,
      "05127": 16.12,
    },
    county_names_all: "Yell|Scott",
    county_fips_all: "05149|05127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72839,
    lat: 35.65131,
    lng: -93.26384,
    city: "Hagarville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 465,
    density: 1.2,
    county_fips: "05071",
    county_name: "Johnson",
    county_weights: {
      "05071": 87.81,
      "05115": 10.97,
      "05101": 1.22,
    },
    county_names_all: "Johnson|Pope|Newton",
    county_fips_all: "05071|05115|05101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72840,
    lat: 35.46164,
    lng: -93.61442,
    city: "Hartman",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2019,
    density: 16.7,
    county_fips: "05071",
    county_name: "Johnson",
    county_weights: {
      "05071": 100,
    },
    county_names_all: "Johnson",
    county_fips_all: "05071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72841,
    lat: 34.86736,
    lng: -93.78515,
    city: "Harvey",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 277,
    density: 2.6,
    county_fips: "05127",
    county_name: "Scott",
    county_weights: {
      "05127": 96.05,
      "05149": 3.95,
    },
    county_names_all: "Scott|Yell",
    county_fips_all: "05127|05149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72842,
    lat: 35.09626,
    lng: -93.59664,
    city: "Havana",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1005,
    density: 4.9,
    county_fips: "05149",
    county_name: "Yell",
    county_weights: {
      "05149": 100,
    },
    county_names_all: "Yell",
    county_fips_all: "05149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72843,
    lat: 35.55608,
    lng: -92.91932,
    city: "Hector",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2481,
    density: 6.1,
    county_fips: "05115",
    county_name: "Pope",
    county_weights: {
      "05115": 100,
    },
    county_names_all: "Pope",
    county_fips_all: "05115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72845,
    lat: 35.36262,
    lng: -93.37619,
    city: "Knoxville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 800,
    density: 27.9,
    county_fips: "05071",
    county_name: "Johnson",
    county_weights: {
      "05071": 100,
    },
    county_names_all: "Johnson",
    county_fips_all: "05071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72846,
    lat: 35.48166,
    lng: -93.31885,
    city: "Lamar",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4125,
    density: 16.1,
    county_fips: "05071",
    county_name: "Johnson",
    county_weights: {
      "05071": 86.59,
      "05115": 13.41,
    },
    county_names_all: "Johnson|Pope",
    county_fips_all: "05071|05115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72847,
    lat: 35.37043,
    lng: -93.27749,
    city: "London",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2983,
    density: 29.5,
    county_fips: "05115",
    county_name: "Pope",
    county_weights: {
      "05115": 71.48,
      "05071": 28.52,
    },
    county_names_all: "Pope|Johnson",
    county_fips_all: "05115|05071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72851,
    lat: 35.26092,
    lng: -93.45693,
    city: "New Blaine",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 495,
    density: 3.6,
    county_fips: "05083",
    county_name: "Logan",
    county_weights: {
      "05083": 100,
    },
    county_names_all: "Logan",
    county_fips_all: "05083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72852,
    lat: 35.68243,
    lng: -93.56684,
    city: "Oark",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 131,
    density: 0.6,
    county_fips: "05071",
    county_name: "Johnson",
    county_weights: {
      "05071": 83.59,
      "05101": 15.79,
      "05087": 0.62,
    },
    county_names_all: "Johnson|Newton|Madison",
    county_fips_all: "05071|05101|05087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72853,
    lat: 35.01146,
    lng: -93.23358,
    city: "Ola",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2040,
    density: 10.1,
    county_fips: "05149",
    county_name: "Yell",
    county_weights: {
      "05149": 87.27,
      "05105": 12.73,
    },
    county_names_all: "Yell|Perry",
    county_fips_all: "05149|05105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72854,
    lat: 35.69644,
    lng: -93.43491,
    city: "Ozone",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 887,
    density: 2.6,
    county_fips: "05071",
    county_name: "Johnson",
    county_weights: {
      "05071": 64.15,
      "05101": 35.85,
    },
    county_names_all: "Johnson|Newton",
    county_fips_all: "05071|05101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72855,
    lat: 35.25249,
    lng: -93.67553,
    city: "Paris",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6319,
    density: 13.6,
    county_fips: "05083",
    county_name: "Logan",
    county_weights: {
      "05083": 98.78,
      "05047": 1.22,
    },
    county_names_all: "Logan|Franklin",
    county_fips_all: "05083|05047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72856,
    lat: 35.76773,
    lng: -93.05658,
    city: "Pelsor",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 401,
    density: 1.6,
    county_fips: "05101",
    county_name: "Newton",
    county_weights: {
      "05101": 83.83,
      "05115": 16.17,
    },
    county_names_all: "Newton|Pope",
    county_fips_all: "05101|05115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72857,
    lat: 34.86217,
    lng: -93.33826,
    city: "Plainview",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1603,
    density: 2.6,
    county_fips: "05149",
    county_name: "Yell",
    county_weights: {
      "05149": 61.9,
      "05105": 38.1,
    },
    county_names_all: "Yell|Perry",
    county_fips_all: "05149|05105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72858,
    lat: 35.20582,
    lng: -93.04433,
    city: "Pottsville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3713,
    density: 43.1,
    county_fips: "05115",
    county_name: "Pope",
    county_weights: {
      "05115": 100,
    },
    county_names_all: "Pope",
    county_fips_all: "05115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72860,
    lat: 34.94556,
    lng: -93.43144,
    city: "Rover",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 261,
    density: 3.9,
    county_fips: "05149",
    county_name: "Yell",
    county_weights: {
      "05149": 100,
    },
    county_names_all: "Yell",
    county_fips_all: "05149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72863,
    lat: 35.36642,
    lng: -93.50878,
    city: "Scranton",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2042,
    density: 15.3,
    county_fips: "05083",
    county_name: "Logan",
    county_weights: {
      "05083": 100,
    },
    county_names_all: "Logan",
    county_fips_all: "05083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72865,
    lat: 35.31143,
    lng: -93.5673,
    city: "Subiaco",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1321,
    density: 20,
    county_fips: "05083",
    county_name: "Logan",
    county_weights: {
      "05083": 100,
    },
    county_names_all: "Logan",
    county_fips_all: "05083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72901,
    lat: 35.3652,
    lng: -94.4155,
    city: "Fort Smith",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21718,
    density: 959.8,
    county_fips: "05131",
    county_name: "Sebastian",
    county_weights: {
      "05131": 100,
    },
    county_names_all: "Sebastian",
    county_fips_all: "05131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72903,
    lat: 35.35241,
    lng: -94.36042,
    city: "Fort Smith",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25824,
    density: 615.3,
    county_fips: "05131",
    county_name: "Sebastian",
    county_weights: {
      "05131": 100,
    },
    county_names_all: "Sebastian",
    county_fips_all: "05131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72904,
    lat: 35.4151,
    lng: -94.38338,
    city: "Fort Smith",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21949,
    density: 619.1,
    county_fips: "05131",
    county_name: "Sebastian",
    county_weights: {
      "05131": 100,
    },
    county_names_all: "Sebastian",
    county_fips_all: "05131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72905,
    lat: 35.26004,
    lng: -94.24265,
    city: "Fort Smith",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "05131",
    county_name: "Sebastian",
    county_weights: {
      "05131": 100,
    },
    county_names_all: "Sebastian",
    county_fips_all: "05131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72908,
    lat: 35.30595,
    lng: -94.4099,
    city: "Fort Smith",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13117,
    density: 660.2,
    county_fips: "05131",
    county_name: "Sebastian",
    county_weights: {
      "05131": 100,
    },
    county_names_all: "Sebastian",
    county_fips_all: "05131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72916,
    lat: 35.27236,
    lng: -94.37256,
    city: "Fort Smith",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10181,
    density: 104.3,
    county_fips: "05131",
    county_name: "Sebastian",
    county_weights: {
      "05131": 100,
    },
    county_names_all: "Sebastian",
    county_fips_all: "05131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72921,
    lat: 35.46953,
    lng: -94.19686,
    city: "Alma",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13904,
    density: 60.4,
    county_fips: "05033",
    county_name: "Crawford",
    county_weights: {
      "05033": 100,
    },
    county_names_all: "Crawford",
    county_fips_all: "05033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72923,
    lat: 35.30904,
    lng: -94.28954,
    city: "Barling",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5023,
    density: 118.5,
    county_fips: "05131",
    county_name: "Sebastian",
    county_weights: {
      "05131": 100,
    },
    county_names_all: "Sebastian",
    county_fips_all: "05131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72926,
    lat: 34.72909,
    lng: -94.0376,
    city: "Boles",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 724,
    density: 2.9,
    county_fips: "05127",
    county_name: "Scott",
    county_weights: {
      "05127": 100,
    },
    county_names_all: "Scott",
    county_fips_all: "05127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72927,
    lat: 35.07254,
    lng: -93.94333,
    city: "Booneville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8034,
    density: 9.6,
    county_fips: "05083",
    county_name: "Logan",
    county_weights: {
      "05083": 67.97,
      "05127": 29.51,
      "05131": 2.52,
    },
    county_names_all: "Logan|Scott|Sebastian",
    county_fips_all: "05083|05127|05131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72928,
    lat: 35.29127,
    lng: -93.93206,
    city: "Branch",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 797,
    density: 13.1,
    county_fips: "05047",
    county_name: "Franklin",
    county_weights: {
      "05047": 100,
    },
    county_names_all: "Franklin",
    county_fips_all: "05047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72930,
    lat: 35.43248,
    lng: -94.00737,
    city: "Cecil",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 184,
    density: 1.9,
    county_fips: "05047",
    county_name: "Franklin",
    county_weights: {
      "05047": 73.79,
      "05131": 26.21,
    },
    county_names_all: "Franklin|Sebastian",
    county_fips_all: "05047|05131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72932,
    lat: 35.60479,
    lng: -94.37682,
    city: "Cedarville",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1587,
    density: 33.1,
    county_fips: "05033",
    county_name: "Crawford",
    county_weights: {
      "05033": 100,
    },
    county_names_all: "Crawford",
    county_fips_all: "05033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72933,
    lat: 35.33408,
    lng: -94.01432,
    city: "Charleston",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5114,
    density: 18.1,
    county_fips: "05047",
    county_name: "Franklin",
    county_weights: {
      "05047": 83.71,
      "05131": 11.68,
      "05083": 4.61,
    },
    county_names_all: "Franklin|Sebastian|Logan",
    county_fips_all: "05047|05131|05083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72934,
    lat: 35.68957,
    lng: -94.2703,
    city: "Chester",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 999,
    density: 5.4,
    county_fips: "05033",
    county_name: "Crawford",
    county_weights: {
      "05033": 100,
    },
    county_names_all: "Crawford",
    county_fips_all: "05033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72935,
    lat: 35.49431,
    lng: -94.13277,
    city: "Dyer",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 495,
    density: 95.6,
    county_fips: "05033",
    county_name: "Crawford",
    county_weights: {
      "05033": 100,
    },
    county_names_all: "Crawford",
    county_fips_all: "05033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72936,
    lat: 35.1896,
    lng: -94.23069,
    city: "Greenwood",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14279,
    density: 68.1,
    county_fips: "05131",
    county_name: "Sebastian",
    county_weights: {
      "05131": 100,
    },
    county_names_all: "Sebastian",
    county_fips_all: "05131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72937,
    lat: 35.13764,
    lng: -94.39545,
    city: "Hackett",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3427,
    density: 21.7,
    county_fips: "05131",
    county_name: "Sebastian",
    county_weights: {
      "05131": 100,
    },
    county_names_all: "Sebastian",
    county_fips_all: "05131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72938,
    lat: 35.00665,
    lng: -94.38097,
    city: "Hartford",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1195,
    density: 8.9,
    county_fips: "05131",
    county_name: "Sebastian",
    county_weights: {
      "05131": 100,
    },
    county_names_all: "Sebastian",
    county_fips_all: "05131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72940,
    lat: 35.11488,
    lng: -94.26427,
    city: "Huntington",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2269,
    density: 20.1,
    county_fips: "05131",
    county_name: "Sebastian",
    county_weights: {
      "05131": 100,
    },
    county_names_all: "Sebastian",
    county_fips_all: "05131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72941,
    lat: 35.35018,
    lng: -94.16214,
    city: "Lavaca",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5124,
    density: 45.6,
    county_fips: "05131",
    county_name: "Sebastian",
    county_weights: {
      "05131": 100,
    },
    county_names_all: "Sebastian",
    county_fips_all: "05131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72943,
    lat: 35.18326,
    lng: -93.78721,
    city: "Magazine",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2370,
    density: 9,
    county_fips: "05083",
    county_name: "Logan",
    county_weights: {
      "05083": 94.96,
      "05149": 4.71,
      "05047": 0.33,
    },
    county_names_all: "Logan|Yell|Franklin",
    county_fips_all: "05083|05149|05047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72944,
    lat: 35.03366,
    lng: -94.24173,
    city: "Mansfield",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2791,
    density: 14.6,
    county_fips: "05131",
    county_name: "Sebastian",
    county_weights: {
      "05131": 67.82,
      "05127": 32.18,
    },
    county_names_all: "Sebastian|Scott",
    county_fips_all: "05131|05127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72945,
    lat: 35.09559,
    lng: -94.36297,
    city: "Midland",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 314,
    density: 94.2,
    county_fips: "05131",
    county_name: "Sebastian",
    county_weights: {
      "05131": 100,
    },
    county_names_all: "Sebastian",
    county_fips_all: "05131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72946,
    lat: 35.65254,
    lng: -94.13706,
    city: "Mountainburg",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3518,
    density: 14.4,
    county_fips: "05033",
    county_name: "Crawford",
    county_weights: {
      "05033": 88.24,
      "05047": 11.76,
    },
    county_names_all: "Crawford|Franklin",
    county_fips_all: "05033|05047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72947,
    lat: 35.54706,
    lng: -94.04021,
    city: "Mulberry",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3588,
    density: 12.1,
    county_fips: "05047",
    county_name: "Franklin",
    county_weights: {
      "05047": 53.66,
      "05033": 46.34,
    },
    county_names_all: "Franklin|Crawford",
    county_fips_all: "05047|05033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72948,
    lat: 35.70692,
    lng: -94.4154,
    city: "Natural Dam",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 200,
    density: 1.2,
    county_fips: "05033",
    county_name: "Crawford",
    county_weights: {
      "05033": 96.59,
      "05143": 3.41,
    },
    county_names_all: "Crawford|Washington",
    county_fips_all: "05033|05143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72949,
    lat: 35.55755,
    lng: -93.80813,
    city: "Ozark",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10613,
    density: 12.9,
    county_fips: "05047",
    county_name: "Franklin",
    county_weights: {
      "05047": 87.8,
      "05071": 10.12,
      "05083": 2.08,
    },
    county_names_all: "Franklin|Johnson|Logan",
    county_fips_all: "05047|05071|05083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72950,
    lat: 34.79317,
    lng: -93.91077,
    city: "Parks",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 677,
    density: 2.5,
    county_fips: "05127",
    county_name: "Scott",
    county_weights: {
      "05127": 100,
    },
    county_names_all: "Scott",
    county_fips_all: "05127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72951,
    lat: 35.31812,
    lng: -93.87593,
    city: "Ratcliff",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 837,
    density: 21.3,
    county_fips: "05083",
    county_name: "Logan",
    county_weights: {
      "05083": 53.32,
      "05047": 46.68,
    },
    county_names_all: "Logan|Franklin",
    county_fips_all: "05083|05047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72952,
    lat: 35.56861,
    lng: -94.30139,
    city: "Rudy",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2138,
    density: 16.9,
    county_fips: "05033",
    county_name: "Crawford",
    county_weights: {
      "05033": 100,
    },
    county_names_all: "Crawford",
    county_fips_all: "05033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72955,
    lat: 35.6081,
    lng: -94.44445,
    city: "Uniontown",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 778,
    density: 21.7,
    county_fips: "05033",
    county_name: "Crawford",
    county_weights: {
      "05033": 100,
    },
    county_names_all: "Crawford",
    county_fips_all: "05033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72956,
    lat: 35.46895,
    lng: -94.3489,
    city: "Van Buren",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36726,
    density: 136.7,
    county_fips: "05033",
    county_name: "Crawford",
    county_weights: {
      "05033": 100,
    },
    county_names_all: "Crawford",
    county_fips_all: "05033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72958,
    lat: 34.90173,
    lng: -94.14659,
    city: "Waldron",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6762,
    density: 8,
    county_fips: "05127",
    county_name: "Scott",
    county_weights: {
      "05127": 100,
    },
    county_names_all: "Scott",
    county_fips_all: "05127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 72959,
    lat: 35.77157,
    lng: -94.06686,
    city: "Winslow",
    state_id: "AR",
    state_name: "Arkansas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3030,
    density: 5.8,
    county_fips: "05143",
    county_name: "Washington",
    county_weights: {
      "05143": 59.17,
      "05033": 25.37,
      "05047": 15.46,
    },
    county_names_all: "Washington|Crawford|Franklin",
    county_fips_all: "05143|05033|05047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73001,
    lat: 35.2262,
    lng: -98.41654,
    city: "Albert",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 40015,
    county_name: "Caddo",
    county_weights: {
      40015: 100,
    },
    county_names_all: "Caddo",
    county_fips_all: 40015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73002,
    lat: 34.96402,
    lng: -97.73237,
    city: "Alex",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1150,
    density: 12.5,
    county_fips: 40051,
    county_name: "Grady",
    county_weights: {
      40051: 99.33,
      40087: 0.67,
    },
    county_names_all: "Grady|McClain",
    county_fips_all: "40051|40087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73003,
    lat: 35.66952,
    lng: -97.49693,
    city: "Edmond",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23406,
    density: 1218.7,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73004,
    lat: 35.14362,
    lng: -97.83875,
    city: "Amber",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 966,
    density: 6,
    county_fips: 40051,
    county_name: "Grady",
    county_weights: {
      40051: 100,
    },
    county_names_all: "Grady",
    county_fips_all: 40051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73005,
    lat: 35.05439,
    lng: -98.23762,
    city: "Anadarko",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9368,
    density: 21.6,
    county_fips: 40015,
    county_name: "Caddo",
    county_weights: {
      40015: 100,
    },
    county_names_all: "Caddo",
    county_fips_all: 40015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73006,
    lat: 34.90587,
    lng: -98.40583,
    city: "Apache",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3037,
    density: 6.7,
    county_fips: 40015,
    county_name: "Caddo",
    county_weights: {
      40015: 80.36,
      40031: 19.64,
    },
    county_names_all: "Caddo|Comanche",
    county_fips_all: "40015|40031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73007,
    lat: 35.69001,
    lng: -97.32009,
    city: "Arcadia",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2305,
    density: 23.1,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40083: 15.98,
      40109: 84.02,
    },
    county_names_all: "Oklahoma|Logan",
    county_fips_all: "40109|40083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73008,
    lat: 35.51383,
    lng: -97.64536,
    city: "Bethany",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20064,
    density: 1029.7,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73009,
    lat: 35.28544,
    lng: -98.37016,
    city: "Binger",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1125,
    density: 5.7,
    county_fips: 40015,
    county_name: "Caddo",
    county_weights: {
      40015: 100,
    },
    county_names_all: "Caddo",
    county_fips_all: 40015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73010,
    lat: 35.09989,
    lng: -97.67197,
    city: "Blanchard",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19612,
    density: 43.4,
    county_fips: 40051,
    county_name: "Grady",
    county_weights: {
      40051: 51.74,
      40087: 48.26,
    },
    county_names_all: "Grady|McClain",
    county_fips_all: "40051|40087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73011,
    lat: 34.84378,
    lng: -97.74498,
    city: "Bradley",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 351,
    density: 2.1,
    county_fips: 40051,
    county_name: "Grady",
    county_weights: {
      40051: 100,
    },
    county_names_all: "Grady",
    county_fips_all: 40051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73012,
    lat: 35.66815,
    lng: -97.59315,
    city: "Edmond",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42001,
    density: 476,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73013,
    lat: 35.62149,
    lng: -97.49614,
    city: "Edmond",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54263,
    density: 641,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73014,
    lat: 35.58152,
    lng: -98.1409,
    city: "Calumet",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1623,
    density: 4,
    county_fips: 40017,
    county_name: "Canadian",
    county_weights: {
      40017: 100,
    },
    county_names_all: "Canadian",
    county_fips_all: 40017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73015,
    lat: 35.07648,
    lng: -98.59016,
    city: "Carnegie",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2930,
    density: 5.4,
    county_fips: 40015,
    county_name: "Caddo",
    county_weights: {
      40015: 74.17,
      40075: 14.56,
      40149: 11.27,
    },
    county_names_all: "Caddo|Kiowa|Washita",
    county_fips_all: "40015|40075|40149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73016,
    lat: 35.79778,
    lng: -97.68831,
    city: "Cashion",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2377,
    density: 14.6,
    county_fips: 40073,
    county_name: "Kingfisher",
    county_weights: {
      40073: 63,
      40083: 37,
    },
    county_names_all: "Kingfisher|Logan",
    county_fips_all: "40073|40083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73017,
    lat: 34.92651,
    lng: -98.09546,
    city: "Cement",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1376,
    density: 6.6,
    county_fips: 40015,
    county_name: "Caddo",
    county_weights: {
      40015: 48.26,
      40031: 4.09,
      40051: 47.64,
    },
    county_names_all: "Caddo|Grady|Comanche",
    county_fips_all: "40015|40051|40031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73018,
    lat: 35.0484,
    lng: -97.93839,
    city: "Chickasha",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20352,
    density: 50.7,
    county_fips: 40051,
    county_name: "Grady",
    county_weights: {
      40051: 100,
    },
    county_names_all: "Grady",
    county_fips_all: 40051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73019,
    lat: 35.20681,
    lng: -97.44213,
    city: "Norman",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 40027,
    county_name: "Cleveland",
    county_weights: {
      40027: 100,
    },
    county_names_all: "Cleveland",
    county_fips_all: 40027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73020,
    lat: 35.45588,
    lng: -97.2619,
    city: "Choctaw",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24852,
    density: 155.8,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40027: 5.62,
      40109: 94.38,
    },
    county_names_all: "Oklahoma|Cleveland",
    county_fips_all: "40109|40027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73021,
    lat: 35.33802,
    lng: -98.67007,
    city: "Colony",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 177,
    density: 1,
    county_fips: 40149,
    county_name: "Washita",
    county_weights: {
      40015: 21.72,
      40149: 78.28,
    },
    county_names_all: "Washita|Caddo",
    county_fips_all: "40149|40015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73022,
    lat: 35.61692,
    lng: -97.99224,
    city: "Concho",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 40017,
    county_name: "Canadian",
    county_weights: {
      40017: 100,
    },
    county_names_all: "Canadian",
    county_fips_all: 40017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73024,
    lat: 35.36608,
    lng: -98.81508,
    city: "Corn",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 717,
    density: 5.8,
    county_fips: 40149,
    county_name: "Washita",
    county_weights: {
      40149: 100,
    },
    county_names_all: "Washita",
    county_fips_all: 40149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73025,
    lat: 35.73199,
    lng: -97.5727,
    city: "Edmond",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14942,
    density: 109.6,
    county_fips: 40083,
    county_name: "Logan",
    county_weights: {
      40083: 57.65,
      40109: 42.35,
    },
    county_names_all: "Logan|Oklahoma",
    county_fips_all: "40083|40109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73026,
    lat: 35.23433,
    lng: -97.2791,
    city: "Norman",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10016,
    density: 35.6,
    county_fips: 40027,
    county_name: "Cleveland",
    county_weights: {
      40027: 100,
    },
    county_names_all: "Cleveland",
    county_fips_all: 40027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73027,
    lat: 35.97102,
    lng: -97.24455,
    city: "Coyle",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1413,
    density: 6.2,
    county_fips: 40083,
    county_name: "Logan",
    county_weights: {
      40083: 50.89,
      40119: 49.11,
    },
    county_names_all: "Logan|Payne",
    county_fips_all: "40083|40119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73028,
    lat: 35.9771,
    lng: -97.62418,
    city: "Crescent",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3802,
    density: 10.3,
    county_fips: 40083,
    county_name: "Logan",
    county_weights: {
      40073: 20.96,
      40083: 79.04,
    },
    county_names_all: "Logan|Kingfisher",
    county_fips_all: "40083|40073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73029,
    lat: 34.89999,
    lng: -98.21016,
    city: "Cyril",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1672,
    density: 15.1,
    county_fips: 40015,
    county_name: "Caddo",
    county_weights: {
      40015: 100,
    },
    county_names_all: "Caddo",
    county_fips_all: 40015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73030,
    lat: 34.47142,
    lng: -97.18584,
    city: "Davis",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4373,
    density: 8.1,
    county_fips: 40099,
    county_name: "Murray",
    county_weights: {
      40049: 10.96,
      40099: 89.04,
    },
    county_names_all: "Murray|Garvin",
    county_fips_all: "40099|40049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73031,
    lat: 35.03376,
    lng: -97.63139,
    city: "Dibble",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 40087,
    county_name: "McClain",
    county_weights: {
      40087: 100,
    },
    county_names_all: "McClain",
    county_fips_all: 40087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73032,
    lat: 34.40051,
    lng: -97.05137,
    city: "Dougherty",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 216,
    density: 222.4,
    county_fips: 40099,
    county_name: "Murray",
    county_weights: {
      40099: 100,
    },
    county_names_all: "Murray",
    county_fips_all: 40099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73033,
    lat: 35.30709,
    lng: -98.55502,
    city: "Eakly",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 523,
    density: 21.1,
    county_fips: 40015,
    county_name: "Caddo",
    county_weights: {
      40015: 100,
    },
    county_names_all: "Caddo",
    county_fips_all: 40015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73034,
    lat: 35.69877,
    lng: -97.42665,
    city: "Edmond",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45732,
    density: 341.8,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40083: 30.01,
      40109: 69.99,
    },
    county_names_all: "Oklahoma|Logan",
    county_fips_all: "40109|40083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73036,
    lat: 35.50752,
    lng: -97.95771,
    city: "El Reno",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22396,
    density: 47,
    county_fips: 40017,
    county_name: "Canadian",
    county_weights: {
      40017: 100,
    },
    county_names_all: "Canadian",
    county_fips_all: 40017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73038,
    lat: 35.1214,
    lng: -98.44306,
    city: "Fort Cobb",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1930,
    density: 5.5,
    county_fips: 40015,
    county_name: "Caddo",
    county_weights: {
      40015: 100,
    },
    county_names_all: "Caddo",
    county_fips_all: 40015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73040,
    lat: 35.64442,
    lng: -98.37861,
    city: "Geary",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1456,
    density: 2.3,
    county_fips: 40011,
    county_name: "Blaine",
    county_weights: {
      40011: 68.88,
      40017: 31.12,
    },
    county_names_all: "Blaine|Canadian",
    county_fips_all: "40011|40017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73041,
    lat: 35.03594,
    lng: -98.88064,
    city: "Gotebo",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 354,
    density: 1.1,
    county_fips: 40075,
    county_name: "Kiowa",
    county_weights: {
      40075: 79.73,
      40149: 20.27,
    },
    county_names_all: "Kiowa|Washita",
    county_fips_all: "40075|40149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73042,
    lat: 35.23019,
    lng: -98.25151,
    city: "Gracemont",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1030,
    density: 3.5,
    county_fips: 40015,
    county_name: "Caddo",
    county_weights: {
      40015: 100,
    },
    county_names_all: "Caddo",
    county_fips_all: 40015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73043,
    lat: 35.73609,
    lng: -98.3939,
    city: "Greenfield",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 189,
    density: 4.7,
    county_fips: 40011,
    county_name: "Blaine",
    county_weights: {
      40011: 100,
    },
    county_names_all: "Blaine",
    county_fips_all: 40011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73044,
    lat: 35.86664,
    lng: -97.43476,
    city: "Guthrie",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23020,
    density: 33.6,
    county_fips: 40083,
    county_name: "Logan",
    county_weights: {
      40083: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 40083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73045,
    lat: 35.51201,
    lng: -97.1414,
    city: "Harrah",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11935,
    density: 70.9,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40081: 39.47,
      40109: 58.61,
      40125: 1.92,
    },
    county_names_all: "Oklahoma|Lincoln|Pottawatomie",
    county_fips_all: "40109|40081|40125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73047,
    lat: 35.45658,
    lng: -98.31553,
    city: "Hinton",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5018,
    density: 13.6,
    county_fips: 40015,
    county_name: "Caddo",
    county_weights: {
      40015: 55.93,
      40017: 44.07,
    },
    county_names_all: "Caddo|Canadian",
    county_fips_all: "40015|40017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73048,
    lat: 35.48929,
    lng: -98.55378,
    city: "Hydro",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2820,
    density: 5.7,
    county_fips: 40015,
    county_name: "Caddo",
    county_weights: {
      40011: 21.49,
      40015: 71.55,
      40039: 6.96,
    },
    county_names_all: "Caddo|Blaine|Custer",
    county_fips_all: "40015|40011|40039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73049,
    lat: 35.58617,
    lng: -97.29695,
    city: "Jones",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6010,
    density: 36.2,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73050,
    lat: 35.93825,
    lng: -97.25595,
    city: "Langston",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1144,
    density: 297.2,
    county_fips: 40083,
    county_name: "Logan",
    county_weights: {
      40083: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 40083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73051,
    lat: 35.03175,
    lng: -97.24629,
    city: "Lexington",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10220,
    density: 31.2,
    county_fips: 40027,
    county_name: "Cleveland",
    county_weights: {
      40027: 99.53,
      40125: 0.47,
    },
    county_names_all: "Cleveland|Pottawatomie",
    county_fips_all: "40027|40125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73052,
    lat: 34.83359,
    lng: -97.59526,
    city: "Lindsay",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6719,
    density: 12.4,
    county_fips: 40049,
    county_name: "Garvin",
    county_weights: {
      40049: 51.68,
      40051: 10.23,
      40087: 38.09,
    },
    county_names_all: "Garvin|McClain|Grady",
    county_fips_all: "40049|40087|40051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73053,
    lat: 35.36248,
    lng: -98.41841,
    city: "Lookeba",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 708,
    density: 3.6,
    county_fips: 40015,
    county_name: "Caddo",
    county_weights: {
      40015: 100,
    },
    county_names_all: "Caddo",
    county_fips_all: 40015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73054,
    lat: 35.67508,
    lng: -97.19487,
    city: "Luther",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4715,
    density: 20.3,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40081: 9.22,
      40083: 19.49,
      40109: 71.29,
    },
    county_names_all: "Oklahoma|Logan|Lincoln",
    county_fips_all: "40109|40083|40081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73055,
    lat: 34.64301,
    lng: -97.91624,
    city: "Marlow",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9891,
    density: 14.9,
    county_fips: 40137,
    county_name: "Stephens",
    county_weights: {
      40031: 1.61,
      40051: 23.13,
      40137: 75.26,
    },
    county_names_all: "Stephens|Grady|Comanche",
    county_fips_all: "40137|40051|40031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73056,
    lat: 36.17036,
    lng: -97.62097,
    city: "Marshall",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 437,
    density: 1.6,
    county_fips: 40047,
    county_name: "Garfield",
    county_weights: {
      40047: 52.38,
      40073: 11.57,
      40083: 36.05,
    },
    county_names_all: "Garfield|Logan|Kingfisher",
    county_fips_all: "40047|40083|40073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73057,
    lat: 34.82998,
    lng: -97.43176,
    city: "Maysville",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2518,
    density: 11.5,
    county_fips: 40049,
    county_name: "Garvin",
    county_weights: {
      40049: 66.2,
      40087: 33.8,
    },
    county_names_all: "Garvin|McClain",
    county_fips_all: "40049|40087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73058,
    lat: 35.8175,
    lng: -97.22571,
    city: "Meridian",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 112,
    density: 1,
    county_fips: 40083,
    county_name: "Logan",
    county_weights: {
      40083: 100,
    },
    county_names_all: "Logan",
    county_fips_all: 40083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73059,
    lat: 35.3251,
    lng: -98.05431,
    city: "Minco",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3102,
    density: 7.4,
    county_fips: 40051,
    county_name: "Grady",
    county_weights: {
      40015: 28.04,
      40017: 12.95,
      40051: 59.01,
    },
    county_names_all: "Grady|Caddo|Canadian",
    county_fips_all: "40051|40015|40017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73061,
    lat: 36.34904,
    lng: -97.01765,
    city: "Morrison",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1686,
    density: 5.7,
    county_fips: 40103,
    county_name: "Noble",
    county_weights: {
      40103: 58.43,
      40117: 41.57,
    },
    county_names_all: "Noble|Pawnee",
    county_fips_all: "40103|40117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73062,
    lat: 35.02929,
    lng: -98.73478,
    city: "Mountain View",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1178,
    density: 2,
    county_fips: 40075,
    county_name: "Kiowa",
    county_weights: {
      40075: 75.24,
      40149: 24.76,
    },
    county_names_all: "Kiowa|Washita",
    county_fips_all: "40075|40149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73063,
    lat: 36.06195,
    lng: -97.41832,
    city: "Mulhall",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 685,
    density: 2.4,
    county_fips: 40083,
    county_name: "Logan",
    county_weights: {
      40083: 77.36,
      40119: 22.64,
    },
    county_names_all: "Logan|Payne",
    county_fips_all: "40083|40119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73064,
    lat: 35.37377,
    lng: -97.75275,
    city: "Mustang",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26362,
    density: 189.4,
    county_fips: 40017,
    county_name: "Canadian",
    county_weights: {
      40017: 100,
    },
    county_names_all: "Canadian",
    county_fips_all: 40017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73065,
    lat: 35.25008,
    lng: -97.61209,
    city: "Newcastle",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8982,
    density: 67,
    county_fips: 40087,
    county_name: "McClain",
    county_weights: {
      40087: 100,
    },
    county_names_all: "McClain",
    county_fips_all: 40087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73066,
    lat: 35.50167,
    lng: -97.32832,
    city: "Nicoma Park",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 346,
    density: 291.7,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73067,
    lat: 34.90315,
    lng: -97.90612,
    city: "Ninnekah",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2503,
    density: 7.9,
    county_fips: 40051,
    county_name: "Grady",
    county_weights: {
      40051: 100,
    },
    county_names_all: "Grady",
    county_fips_all: 40051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73068,
    lat: 35.1384,
    lng: -97.28264,
    city: "Noble",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12402,
    density: 74.2,
    county_fips: 40027,
    county_name: "Cleveland",
    county_weights: {
      40027: 100,
    },
    county_names_all: "Cleveland",
    county_fips_all: 40027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73069,
    lat: 35.25028,
    lng: -97.4633,
    city: "Norman",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25986,
    density: 637.6,
    county_fips: 40027,
    county_name: "Cleveland",
    county_weights: {
      40027: 100,
    },
    county_names_all: "Cleveland",
    county_fips_all: 40027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73070,
    lat: 35.22763,
    lng: -97.42729,
    city: "Norman",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 40027,
    county_name: "Cleveland",
    county_weights: {
      40027: 100,
    },
    county_names_all: "Cleveland",
    county_fips_all: 40027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73071,
    lat: 35.23728,
    lng: -97.4131,
    city: "Norman",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43605,
    density: 722,
    county_fips: 40027,
    county_name: "Cleveland",
    county_weights: {
      40027: 100,
    },
    county_names_all: "Cleveland",
    county_fips_all: 40027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73072,
    lat: 35.21106,
    lng: -97.50518,
    city: "Norman",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47957,
    density: 354.7,
    county_fips: 40027,
    county_name: "Cleveland",
    county_weights: {
      40027: 66.34,
      40087: 33.66,
    },
    county_names_all: "Cleveland|McClain",
    county_fips_all: "40027|40087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73073,
    lat: 36.16302,
    lng: -97.39614,
    city: "Orlando",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 495,
    density: 1.6,
    county_fips: 40103,
    county_name: "Noble",
    county_weights: {
      40047: 17.65,
      40083: 25.79,
      40103: 30.67,
      40119: 25.89,
    },
    county_names_all: "Noble|Payne|Logan|Garfield",
    county_fips_all: "40103|40119|40083|40047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73074,
    lat: 34.83269,
    lng: -97.27917,
    city: "Paoli",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1197,
    density: 10.9,
    county_fips: 40049,
    county_name: "Garvin",
    county_weights: {
      40049: 78.19,
      40087: 21.81,
    },
    county_names_all: "Garvin|McClain",
    county_fips_all: "40049|40087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73075,
    lat: 34.75187,
    lng: -97.23428,
    city: "Pauls Valley",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9678,
    density: 26.8,
    county_fips: 40049,
    county_name: "Garvin",
    county_weights: {
      40049: 100,
    },
    county_names_all: "Garvin",
    county_fips_all: 40049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73077,
    lat: 36.30428,
    lng: -97.26981,
    city: "Perry",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6789,
    density: 10.3,
    county_fips: 40103,
    county_name: "Noble",
    county_weights: {
      40103: 100,
    },
    county_names_all: "Noble",
    county_fips_all: 40103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73078,
    lat: 35.66867,
    lng: -97.75304,
    city: "Piedmont",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11768,
    density: 70,
    county_fips: 40017,
    county_name: "Canadian",
    county_weights: {
      40017: 99.83,
      40109: 0.17,
    },
    county_names_all: "Canadian|Oklahoma",
    county_fips_all: "40017|40109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73079,
    lat: 35.20941,
    lng: -98.01397,
    city: "Pocasset",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 432,
    density: 2,
    county_fips: 40051,
    county_name: "Grady",
    county_weights: {
      40015: 20.8,
      40051: 79.2,
    },
    county_names_all: "Grady|Caddo",
    county_fips_all: "40051|40015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73080,
    lat: 35.00725,
    lng: -97.452,
    city: "Purcell",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9569,
    density: 36.9,
    county_fips: 40087,
    county_name: "McClain",
    county_weights: {
      40087: 100,
    },
    county_names_all: "McClain",
    county_fips_all: 40087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73082,
    lat: 34.77266,
    lng: -97.90385,
    city: "Rush Springs",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3091,
    density: 7.5,
    county_fips: 40051,
    county_name: "Grady",
    county_weights: {
      40031: 2.49,
      40051: 97.51,
    },
    county_names_all: "Grady|Comanche",
    county_fips_all: "40051|40031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73084,
    lat: 35.52567,
    lng: -97.34645,
    city: "Spencer",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6342,
    density: 136.4,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73086,
    lat: 34.48915,
    lng: -96.97251,
    city: "Sulphur",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8644,
    density: 21,
    county_fips: 40099,
    county_name: "Murray",
    county_weights: {
      40069: 1.57,
      40099: 98.43,
    },
    county_names_all: "Murray|Johnston",
    county_fips_all: "40099|40069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73089,
    lat: 35.2661,
    lng: -97.79638,
    city: "Tuttle",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13037,
    density: 47.1,
    county_fips: 40051,
    county_name: "Grady",
    county_weights: {
      40051: 100,
    },
    county_names_all: "Grady",
    county_fips_all: 40051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73090,
    lat: 35.39706,
    lng: -97.96116,
    city: "Union City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1123,
    density: 8.7,
    county_fips: 40017,
    county_name: "Canadian",
    county_weights: {
      40017: 100,
    },
    county_names_all: "Canadian",
    county_fips_all: 40017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73092,
    lat: 35.1238,
    lng: -98.08735,
    city: "Verden",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 825,
    density: 5.9,
    county_fips: 40051,
    county_name: "Grady",
    county_weights: {
      40015: 46.98,
      40051: 53.02,
    },
    county_names_all: "Grady|Caddo",
    county_fips_all: "40051|40015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73093,
    lat: 35.10321,
    lng: -97.4966,
    city: "Washington",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3282,
    density: 21.8,
    county_fips: 40087,
    county_name: "McClain",
    county_weights: {
      40087: 100,
    },
    county_names_all: "McClain",
    county_fips_all: 40087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73095,
    lat: 34.90677,
    lng: -97.28423,
    city: "Wayne",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2097,
    density: 10.5,
    county_fips: 40087,
    county_name: "McClain",
    county_weights: {
      40087: 100,
    },
    county_names_all: "McClain",
    county_fips_all: 40087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73096,
    lat: 35.51305,
    lng: -98.7295,
    city: "Weatherford",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13846,
    density: 27.7,
    county_fips: 40039,
    county_name: "Custer",
    county_weights: {
      40011: 1.03,
      40039: 69.38,
      40149: 29.59,
    },
    county_names_all: "Custer|Washita|Blaine",
    county_fips_all: "40039|40149|40011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73097,
    lat: 35.39893,
    lng: -97.64501,
    city: "Wheatland",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 89,
    density: 34.7,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73098,
    lat: 34.62753,
    lng: -97.16537,
    city: "Wynnewood",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4184,
    density: 11.7,
    county_fips: 40049,
    county_name: "Garvin",
    county_weights: {
      40049: 80.99,
      40099: 19.01,
    },
    county_names_all: "Garvin|Murray",
    county_fips_all: "40049|40099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73099,
    lat: 35.52583,
    lng: -97.76343,
    city: "Yukon",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 72074,
    density: 223.2,
    county_fips: 40017,
    county_name: "Canadian",
    county_weights: {
      40017: 100,
    },
    county_names_all: "Canadian",
    county_fips_all: 40017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73102,
    lat: 35.47065,
    lng: -97.5191,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4226,
    density: 2045.9,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73103,
    lat: 35.48906,
    lng: -97.51897,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5622,
    density: 1846.6,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73104,
    lat: 35.47508,
    lng: -97.5038,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2932,
    density: 721.4,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73105,
    lat: 35.51919,
    lng: -97.50331,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6242,
    density: 536.4,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73106,
    lat: 35.4823,
    lng: -97.53662,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13403,
    density: 1704,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73107,
    lat: 35.48201,
    lng: -97.5744,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25049,
    density: 1277.2,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73108,
    lat: 35.45034,
    lng: -97.56774,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14310,
    density: 723.2,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73109,
    lat: 35.43279,
    lng: -97.52452,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22578,
    density: 1613.4,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73110,
    lat: 35.44808,
    lng: -97.3945,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33431,
    density: 835.1,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73111,
    lat: 35.51889,
    lng: -97.47722,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11901,
    density: 534.9,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73112,
    lat: 35.51823,
    lng: -97.5745,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33901,
    density: 1717.3,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73114,
    lat: 35.57916,
    lng: -97.51784,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18781,
    density: 764.9,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73115,
    lat: 35.44232,
    lng: -97.44153,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20752,
    density: 1356.8,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73116,
    lat: 35.54684,
    lng: -97.56519,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9375,
    density: 655.8,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73117,
    lat: 35.47474,
    lng: -97.45961,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6382,
    density: 382.8,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73118,
    lat: 35.51788,
    lng: -97.53007,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13695,
    density: 1091.9,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73119,
    lat: 35.4215,
    lng: -97.56896,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31392,
    density: 1781.8,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73120,
    lat: 35.58049,
    lng: -97.57248,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35132,
    density: 1227.7,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73121,
    lat: 35.52181,
    lng: -97.44236,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3250,
    density: 129.2,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73122,
    lat: 35.5202,
    lng: -97.61391,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12770,
    density: 1451.2,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73127,
    lat: 35.47785,
    lng: -97.64836,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25327,
    density: 861.7,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40017: 24.21,
      40109: 75.79,
    },
    county_names_all: "Oklahoma|Canadian",
    county_fips_all: "40109|40017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73128,
    lat: 35.44899,
    lng: -97.64595,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5546,
    density: 291.5,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40017: 23.51,
      40109: 76.49,
    },
    county_names_all: "Oklahoma|Canadian",
    county_fips_all: "40109|40017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73129,
    lat: 35.43165,
    lng: -97.48433,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19810,
    density: 610,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73130,
    lat: 35.45879,
    lng: -97.34586,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20400,
    density: 789.9,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73131,
    lat: 35.57653,
    lng: -97.46465,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3773,
    density: 121,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73132,
    lat: 35.54984,
    lng: -97.64074,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27065,
    density: 1374.4,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73134,
    lat: 35.6151,
    lng: -97.56935,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5594,
    density: 492.8,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73135,
    lat: 35.39644,
    lng: -97.42692,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21800,
    density: 766.9,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40027: 2.74,
      40109: 97.26,
    },
    county_names_all: "Oklahoma|Cleveland",
    county_fips_all: "40109|40027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73139,
    lat: 35.38457,
    lng: -97.52572,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17672,
    density: 1549.3,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40027: 32.57,
      40109: 67.43,
    },
    county_names_all: "Oklahoma|Cleveland",
    county_fips_all: "40109|40027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73141,
    lat: 35.51702,
    lng: -97.39876,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2309,
    density: 82.3,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73142,
    lat: 35.60937,
    lng: -97.63895,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14854,
    density: 735.9,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73145,
    lat: 35.42427,
    lng: -97.41403,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3561,
    density: 1001.3,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73149,
    lat: 35.3892,
    lng: -97.48908,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5634,
    density: 401.6,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40027: 6.92,
      40109: 93.08,
    },
    county_names_all: "Oklahoma|Cleveland",
    county_fips_all: "40109|40027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73150,
    lat: 35.40059,
    lng: -97.33214,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5660,
    density: 116.7,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40027: 1.88,
      40109: 98.12,
    },
    county_names_all: "Oklahoma|Cleveland",
    county_fips_all: "40109|40027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73151,
    lat: 35.56783,
    lng: -97.41049,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2132,
    density: 275.5,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73159,
    lat: 35.38563,
    lng: -97.5794,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33345,
    density: 940.9,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40027: 31.57,
      40109: 68.43,
    },
    county_names_all: "Oklahoma|Cleveland",
    county_fips_all: "40109|40027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73160,
    lat: 35.33574,
    lng: -97.47651,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61204,
    density: 1103.1,
    county_fips: 40027,
    county_name: "Cleveland",
    county_weights: {
      40027: 100,
    },
    county_names_all: "Cleveland",
    county_fips_all: 40027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73162,
    lat: 35.58095,
    lng: -97.6415,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28818,
    density: 1578,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40109: 100,
    },
    county_names_all: "Oklahoma",
    county_fips_all: 40109,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73165,
    lat: 35.34181,
    lng: -97.36138,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6496,
    density: 61.3,
    county_fips: 40027,
    county_name: "Cleveland",
    county_weights: {
      40027: 100,
    },
    county_names_all: "Cleveland",
    county_fips_all: 40027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73169,
    lat: 35.3815,
    lng: -97.64538,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3203,
    density: 165.6,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40027: 39.49,
      40109: 60.51,
    },
    county_names_all: "Oklahoma|Cleveland",
    county_fips_all: "40109|40027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73170,
    lat: 35.32743,
    lng: -97.55068,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38060,
    density: 699.9,
    county_fips: 40027,
    county_name: "Cleveland",
    county_weights: {
      40027: 100,
    },
    county_names_all: "Cleveland",
    county_fips_all: 40027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73173,
    lat: 35.34033,
    lng: -97.62463,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3492,
    density: 99.5,
    county_fips: 40027,
    county_name: "Cleveland",
    county_weights: {
      40027: 100,
    },
    county_names_all: "Cleveland",
    county_fips_all: 40027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73179,
    lat: 35.4231,
    lng: -97.64521,
    city: "Oklahoma City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5206,
    density: 170.4,
    county_fips: 40109,
    county_name: "Oklahoma",
    county_weights: {
      40017: 17,
      40109: 83,
    },
    county_names_all: "Oklahoma|Canadian",
    county_fips_all: "40109|40017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73401,
    lat: 34.21045,
    lng: -97.11434,
    city: "Ardmore",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35870,
    density: 39.4,
    county_fips: 40019,
    county_name: "Carter",
    county_weights: {
      40019: 96.86,
      40069: 0.32,
      40085: 2.82,
    },
    county_names_all: "Carter|Love|Johnston",
    county_fips_all: "40019|40085|40069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73425,
    lat: 34.45838,
    lng: -97.56239,
    city: "Countyline",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69,
    density: 5.6,
    county_fips: 40137,
    county_name: "Stephens",
    county_weights: {
      40019: 47.24,
      40137: 52.76,
    },
    county_names_all: "Stephens|Carter",
    county_fips_all: "40137|40019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73430,
    lat: 33.91,
    lng: -97.36106,
    city: "Burneyville",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1378,
    density: 6.4,
    county_fips: 40085,
    county_name: "Love",
    county_weights: {
      40085: 100,
    },
    county_names_all: "Love",
    county_fips_all: 40085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73432,
    lat: 34.25605,
    lng: -96.42311,
    city: "Coleman",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1236,
    density: 8,
    county_fips: 40069,
    county_name: "Johnston",
    county_weights: {
      40005: 32.77,
      40069: 67.23,
    },
    county_names_all: "Johnston|Atoka",
    county_fips_all: "40069|40005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73433,
    lat: 34.62352,
    lng: -97.40868,
    city: "Elmore City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2719,
    density: 6.5,
    county_fips: 40049,
    county_name: "Garvin",
    county_weights: {
      40049: 100,
    },
    county_names_all: "Garvin",
    county_fips_all: 40049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73434,
    lat: 34.62083,
    lng: -97.58286,
    city: "Foster",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 611,
    density: 2.4,
    county_fips: 40137,
    county_name: "Stephens",
    county_weights: {
      40049: 44.79,
      40137: 55.21,
    },
    county_names_all: "Stephens|Garvin",
    county_fips_all: "40137|40049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73435,
    lat: 34.36008,
    lng: -97.49281,
    city: "Fox",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 40019,
    county_name: "Carter",
    county_weights: {
      40019: 100,
    },
    county_names_all: "Carter",
    county_fips_all: 40019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73436,
    lat: 34.28406,
    lng: -97.03856,
    city: "Gene Autry",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 40019,
    county_name: "Carter",
    county_weights: {
      40019: 100,
    },
    county_names_all: "Carter",
    county_fips_all: 40019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73437,
    lat: 34.36193,
    lng: -97.41558,
    city: "Graham",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 92,
    density: 2.7,
    county_fips: 40019,
    county_name: "Carter",
    county_weights: {
      40019: 100,
    },
    county_names_all: "Carter",
    county_fips_all: 40019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73438,
    lat: 34.27967,
    lng: -97.49808,
    city: "Healdton",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3451,
    density: 18.9,
    county_fips: 40019,
    county_name: "Carter",
    county_weights: {
      40019: 100,
    },
    county_names_all: "Carter",
    county_fips_all: 40019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73439,
    lat: 33.93643,
    lng: -96.74708,
    city: "Kingston",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7234,
    density: 21.5,
    county_fips: 40095,
    county_name: "Marshall",
    county_weights: {
      40095: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 40095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73440,
    lat: 33.95163,
    lng: -96.89635,
    city: "Lebanon",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 281,
    density: 13.9,
    county_fips: 40095,
    county_name: "Marshall",
    county_weights: {
      40095: 100,
    },
    county_names_all: "Marshall",
    county_fips_all: 40095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73441,
    lat: 33.8674,
    lng: -97.44021,
    city: "Leon",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 40085,
    county_name: "Love",
    county_weights: {
      40085: 100,
    },
    county_names_all: "Love",
    county_fips_all: 40085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73442,
    lat: 34.31982,
    lng: -97.69569,
    city: "Loco",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 388,
    density: 1.4,
    county_fips: 40137,
    county_name: "Stephens",
    county_weights: {
      40067: 16.84,
      40137: 83.16,
    },
    county_names_all: "Stephens|Jefferson",
    county_fips_all: "40137|40067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73443,
    lat: 34.16258,
    lng: -97.29081,
    city: "Lone Grove",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3815,
    density: 36.2,
    county_fips: 40019,
    county_name: "Carter",
    county_weights: {
      40019: 100,
    },
    county_names_all: "Carter",
    county_fips_all: 40019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73444,
    lat: 34.4875,
    lng: -97.38256,
    city: "Hennepin",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 111,
    density: 2.8,
    county_fips: 40019,
    county_name: "Carter",
    county_weights: {
      40019: 86.23,
      40049: 1.01,
      40099: 12.76,
    },
    county_names_all: "Carter|Murray|Garvin",
    county_fips_all: "40019|40099|40049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73446,
    lat: 34.0891,
    lng: -96.77806,
    city: "Madill",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9173,
    density: 15.1,
    county_fips: 40095,
    county_name: "Marshall",
    county_weights: {
      40019: 0.34,
      40095: 99.66,
    },
    county_names_all: "Marshall|Carter",
    county_fips_all: "40095|40019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73447,
    lat: 34.22463,
    lng: -96.84616,
    city: "Mannsville",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1374,
    density: 8.2,
    county_fips: 40069,
    county_name: "Johnston",
    county_weights: {
      40069: 100,
    },
    county_names_all: "Johnston",
    county_fips_all: 40069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73448,
    lat: 33.94813,
    lng: -97.10581,
    city: "Marietta",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6122,
    density: 10.9,
    county_fips: 40085,
    county_name: "Love",
    county_weights: {
      40085: 100,
    },
    county_names_all: "Love",
    county_fips_all: 40085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73449,
    lat: 33.99471,
    lng: -96.54114,
    city: "Mead",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3222,
    density: 34.1,
    county_fips: 40013,
    county_name: "Bryan",
    county_weights: {
      40013: 100,
    },
    county_names_all: "Bryan",
    county_fips_all: 40013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73450,
    lat: 34.26689,
    lng: -96.53801,
    city: "Milburn",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1274,
    density: 5.5,
    county_fips: 40069,
    county_name: "Johnston",
    county_weights: {
      40069: 100,
    },
    county_names_all: "Johnston",
    county_fips_all: 40069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73453,
    lat: 34.03473,
    lng: -97.27046,
    city: "Overbrook",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 531,
    density: 3,
    county_fips: 40085,
    county_name: "Love",
    county_weights: {
      40019: 1.17,
      40085: 98.83,
    },
    county_names_all: "Love|Carter",
    county_fips_all: "40085|40019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73455,
    lat: 34.22651,
    lng: -96.75997,
    city: "Ravia",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 624,
    density: 31.2,
    county_fips: 40069,
    county_name: "Johnston",
    county_weights: {
      40069: 100,
    },
    county_names_all: "Johnston",
    county_fips_all: 40069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73456,
    lat: 34.12211,
    lng: -97.62412,
    city: "Ringling",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1870,
    density: 3,
    county_fips: 40067,
    county_name: "Jefferson",
    county_weights: {
      40019: 9.83,
      40067: 79.29,
      40085: 10.88,
    },
    county_names_all: "Jefferson|Love|Carter",
    county_fips_all: "40067|40085|40019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73458,
    lat: 34.35818,
    lng: -97.29782,
    city: "Springer",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1031,
    density: 4.3,
    county_fips: 40019,
    county_name: "Carter",
    county_weights: {
      40019: 100,
    },
    county_names_all: "Carter",
    county_fips_all: 40019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73459,
    lat: 33.77534,
    lng: -97.14213,
    city: "Thackerville",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1157,
    density: 12.5,
    county_fips: 40085,
    county_name: "Love",
    county_weights: {
      40085: 100,
    },
    county_names_all: "Love",
    county_fips_all: 40085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73460,
    lat: 34.28789,
    lng: -96.66689,
    city: "Tishomingo",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4626,
    density: 11.7,
    county_fips: 40069,
    county_name: "Johnston",
    county_weights: {
      40069: 100,
    },
    county_names_all: "Johnston",
    county_fips_all: 40069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73461,
    lat: 34.35726,
    lng: -96.43418,
    city: "Wapanucka",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 825,
    density: 4.4,
    county_fips: 40069,
    county_name: "Johnston",
    county_weights: {
      40005: 33.83,
      40069: 66.17,
    },
    county_names_all: "Johnston|Atoka",
    county_fips_all: "40069|40005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73463,
    lat: 34.11584,
    lng: -97.42905,
    city: "Wilson",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3538,
    density: 6.5,
    county_fips: 40019,
    county_name: "Carter",
    county_weights: {
      40019: 68.06,
      40085: 31.94,
    },
    county_names_all: "Carter|Love",
    county_fips_all: "40019|40085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73481,
    lat: 34.42229,
    lng: -97.51955,
    city: "Ratliff City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 970,
    density: 4.8,
    county_fips: 40019,
    county_name: "Carter",
    county_weights: {
      40019: 74.14,
      40049: 8.84,
      40137: 17.02,
    },
    county_names_all: "Carter|Stephens|Garvin",
    county_fips_all: "40019|40137|40049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73487,
    lat: 34.47327,
    lng: -97.4428,
    city: "Tatums",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 187,
    density: 5.1,
    county_fips: 40019,
    county_name: "Carter",
    county_weights: {
      40019: 100,
    },
    county_names_all: "Carter",
    county_fips_all: 40019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73488,
    lat: 34.49502,
    lng: -97.54724,
    city: "Tussy",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 40019,
    county_name: "Carter",
    county_weights: {
      40019: 100,
    },
    county_names_all: "Carter",
    county_fips_all: 40019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73491,
    lat: 34.4637,
    lng: -97.65845,
    city: "Velma",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 726,
    density: 27,
    county_fips: 40137,
    county_name: "Stephens",
    county_weights: {
      40137: 100,
    },
    county_names_all: "Stephens",
    county_fips_all: 40137,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73501,
    lat: 34.56211,
    lng: -98.2864,
    city: "Lawton",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20373,
    density: 74.9,
    county_fips: 40031,
    county_name: "Comanche",
    county_weights: {
      40031: 100,
    },
    county_names_all: "Comanche",
    county_fips_all: 40031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73503,
    lat: 34.67348,
    lng: -98.49649,
    city: "Fort Sill",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10918,
    density: 56.8,
    county_fips: 40031,
    county_name: "Comanche",
    county_weights: {
      40031: 100,
    },
    county_names_all: "Comanche",
    county_fips_all: 40031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73505,
    lat: 34.5718,
    lng: -98.4834,
    city: "Lawton",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49994,
    density: 298.8,
    county_fips: 40031,
    county_name: "Comanche",
    county_weights: {
      40031: 100,
    },
    county_names_all: "Comanche",
    county_fips_all: 40031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73507,
    lat: 34.74802,
    lng: -98.50201,
    city: "Lawton",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21069,
    density: 33.4,
    county_fips: 40031,
    county_name: "Comanche",
    county_weights: {
      40031: 100,
    },
    county_names_all: "Comanche",
    county_fips_all: 40031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73520,
    lat: 34.26148,
    lng: -97.97856,
    city: "Addington",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 105,
    density: 7.9,
    county_fips: 40067,
    county_name: "Jefferson",
    county_weights: {
      40067: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 40067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73521,
    lat: 34.63547,
    lng: -99.31538,
    city: "Altus",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20083,
    density: 41.7,
    county_fips: 40065,
    county_name: "Jackson",
    county_weights: {
      40065: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 40065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73523,
    lat: 34.65526,
    lng: -99.28527,
    city: "Altus Afb",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 40065,
    county_name: "Jackson",
    county_weights: {
      40065: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 40065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73526,
    lat: 34.79244,
    lng: -99.26704,
    city: "Blair",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2298,
    density: 11.1,
    county_fips: 40065,
    county_name: "Jackson",
    county_weights: {
      40055: 14.79,
      40065: 85.21,
    },
    county_names_all: "Jackson|Greer",
    county_fips_all: "40065|40055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73527,
    lat: 34.5724,
    lng: -98.62704,
    city: "Cache",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4439,
    density: 22.5,
    county_fips: 40031,
    county_name: "Comanche",
    county_weights: {
      40031: 100,
    },
    county_names_all: "Comanche",
    county_fips_all: 40031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73528,
    lat: 34.4033,
    lng: -98.6452,
    city: "Chattanooga",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 568,
    density: 2.1,
    county_fips: 40033,
    county_name: "Cotton",
    county_weights: {
      40031: 12.89,
      40033: 47.37,
      40141: 39.74,
    },
    county_names_all: "Cotton|Tillman|Comanche",
    county_fips_all: "40033|40141|40031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73529,
    lat: 34.34146,
    lng: -97.94619,
    city: "Comanche",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5293,
    density: 8.5,
    county_fips: 40137,
    county_name: "Stephens",
    county_weights: {
      40033: 1.67,
      40067: 23.47,
      40137: 74.86,
    },
    county_names_all: "Stephens|Jefferson|Cotton",
    county_fips_all: "40137|40067|40033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73530,
    lat: 34.25845,
    lng: -99.05664,
    city: "Davidson",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 485,
    density: 1.6,
    county_fips: 40141,
    county_name: "Tillman",
    county_weights: {
      40141: 100,
    },
    county_names_all: "Tillman",
    county_fips_all: 40141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73531,
    lat: 34.18845,
    lng: -98.52703,
    city: "Devol",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 293,
    density: 1.5,
    county_fips: 40033,
    county_name: "Cotton",
    county_weights: {
      40033: 100,
    },
    county_names_all: "Cotton",
    county_fips_all: 40033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73532,
    lat: 34.62768,
    lng: -99.59637,
    city: "Duke",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 511,
    density: 1.2,
    county_fips: 40065,
    county_name: "Jackson",
    county_weights: {
      40057: 12.26,
      40065: 87.74,
    },
    county_names_all: "Jackson|Harmon",
    county_fips_all: "40065|40057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73533,
    lat: 34.49484,
    lng: -97.84774,
    city: "Duncan",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27185,
    density: 31.9,
    county_fips: 40137,
    county_name: "Stephens",
    county_weights: {
      40033: 0.31,
      40137: 99.69,
    },
    county_names_all: "Stephens|Cotton",
    county_fips_all: "40137|40033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73537,
    lat: 34.46994,
    lng: -99.67189,
    city: "Eldorado",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 632,
    density: 1.6,
    county_fips: 40065,
    county_name: "Jackson",
    county_weights: {
      40057: 19.72,
      40065: 80.28,
    },
    county_names_all: "Jackson|Harmon",
    county_fips_all: "40065|40057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73538,
    lat: 34.74056,
    lng: -98.30743,
    city: "Elgin",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5517,
    density: 26.3,
    county_fips: 40031,
    county_name: "Comanche",
    county_weights: {
      40031: 100,
    },
    county_names_all: "Comanche",
    county_fips_all: 40031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73539,
    lat: 34.45202,
    lng: -99.27649,
    city: "Elmer",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 198,
    density: 1.1,
    county_fips: 40065,
    county_name: "Jackson",
    county_weights: {
      40065: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 40065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73540,
    lat: 34.47099,
    lng: -98.55756,
    city: "Faxon",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 291,
    density: 1.9,
    county_fips: 40031,
    county_name: "Comanche",
    county_weights: {
      40031: 96.65,
      40033: 3.35,
    },
    county_names_all: "Comanche|Cotton",
    county_fips_all: "40031|40033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73541,
    lat: 34.78716,
    lng: -98.1788,
    city: "Fletcher",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3329,
    density: 14.9,
    county_fips: 40031,
    county_name: "Comanche",
    county_weights: {
      40031: 100,
    },
    county_names_all: "Comanche",
    county_fips_all: 40031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73542,
    lat: 34.4024,
    lng: -98.93893,
    city: "Frederick",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4253,
    density: 5.5,
    county_fips: 40141,
    county_name: "Tillman",
    county_weights: {
      40141: 100,
    },
    county_names_all: "Tillman",
    county_fips_all: 40141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73543,
    lat: 34.46389,
    lng: -98.38385,
    city: "Geronimo",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2101,
    density: 12.1,
    county_fips: 40031,
    county_name: "Comanche",
    county_weights: {
      40031: 71.56,
      40033: 28.44,
    },
    county_names_all: "Comanche|Cotton",
    county_fips_all: "40031|40033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73544,
    lat: 34.65379,
    lng: -99.75016,
    city: "Gould",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 303,
    density: 1,
    county_fips: 40057,
    county_name: "Harmon",
    county_weights: {
      40057: 100,
    },
    county_names_all: "Harmon",
    county_fips_all: 40057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73546,
    lat: 34.22336,
    lng: -98.73053,
    city: "Grandfield",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1181,
    density: 2.7,
    county_fips: 40141,
    county_name: "Tillman",
    county_weights: {
      40033: 7.92,
      40141: 92.08,
    },
    county_names_all: "Tillman|Cotton",
    county_fips_all: "40141|40033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73547,
    lat: 34.98651,
    lng: -99.40507,
    city: "Granite",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1916,
    density: 6.3,
    county_fips: 40055,
    county_name: "Greer",
    county_weights: {
      40055: 100,
    },
    county_names_all: "Greer",
    county_fips_all: 40055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73548,
    lat: 34.21427,
    lng: -98.13818,
    city: "Hastings",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 392,
    density: 2.5,
    county_fips: 40033,
    county_name: "Cotton",
    county_weights: {
      40033: 46,
      40067: 43.54,
      40137: 10.45,
    },
    county_names_all: "Cotton|Jefferson|Stephens",
    county_fips_all: "40033|40067|40137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73549,
    lat: 34.65222,
    lng: -99.15607,
    city: "Headrick",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 220,
    density: 1.1,
    county_fips: 40065,
    county_name: "Jackson",
    county_weights: {
      40065: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 40065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73550,
    lat: 34.7101,
    lng: -99.89631,
    city: "Hollis",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2175,
    density: 3.6,
    county_fips: 40057,
    county_name: "Harmon",
    county_weights: {
      40057: 100,
    },
    county_names_all: "Harmon",
    county_fips_all: 40057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73551,
    lat: 34.30754,
    lng: -98.87487,
    city: "Hollister",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59,
    density: 0.8,
    county_fips: 40141,
    county_name: "Tillman",
    county_weights: {
      40141: 100,
    },
    county_names_all: "Tillman",
    county_fips_all: 40141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73552,
    lat: 34.62709,
    lng: -98.75631,
    city: "Indiahoma",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1372,
    density: 4.9,
    county_fips: 40031,
    county_name: "Comanche",
    county_weights: {
      40031: 98.38,
      40075: 1.62,
    },
    county_names_all: "Comanche|Kiowa",
    county_fips_all: "40031|40075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73553,
    lat: 34.33066,
    lng: -98.70295,
    city: "Loveland",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57,
    density: 0.6,
    county_fips: 40141,
    county_name: "Tillman",
    county_weights: {
      40141: 100,
    },
    county_names_all: "Tillman",
    county_fips_all: 40141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73554,
    lat: 34.85562,
    lng: -99.60118,
    city: "Mangum",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3401,
    density: 3.7,
    county_fips: 40055,
    county_name: "Greer",
    county_weights: {
      40055: 85.55,
      40057: 13.42,
      40065: 1.03,
    },
    county_names_all: "Greer|Harmon|Jackson",
    county_fips_all: "40055|40057|40065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73555,
    lat: 34.50539,
    lng: -98.9639,
    city: "Manitou",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 247,
    density: 5.2,
    county_fips: 40141,
    county_name: "Tillman",
    county_weights: {
      40141: 100,
    },
    county_names_all: "Tillman",
    county_fips_all: 40141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73556,
    lat: 34.72617,
    lng: -99.38673,
    city: "Martha",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 139,
    density: 212.9,
    county_fips: 40065,
    county_name: "Jackson",
    county_weights: {
      40065: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 40065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73557,
    lat: 34.73072,
    lng: -98.50022,
    city: "Medicine Park",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 393,
    density: 166.3,
    county_fips: 40031,
    county_name: "Comanche",
    county_weights: {
      40031: 100,
    },
    county_names_all: "Comanche",
    county_fips_all: 40031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73559,
    lat: 34.73473,
    lng: -98.94317,
    city: "Mountain Park",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 582,
    density: 1.6,
    county_fips: 40075,
    county_name: "Kiowa",
    county_weights: {
      40031: 14.47,
      40075: 85.53,
    },
    county_names_all: "Kiowa|Comanche",
    county_fips_all: "40075|40031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73560,
    lat: 34.54307,
    lng: -99.45024,
    city: "Olustee",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 854,
    density: 2.4,
    county_fips: 40065,
    county_name: "Jackson",
    county_weights: {
      40065: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 40065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73562,
    lat: 34.19469,
    lng: -98.41203,
    city: "Randlett",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 657,
    density: 2.3,
    county_fips: 40033,
    county_name: "Cotton",
    county_weights: {
      40033: 100,
    },
    county_names_all: "Cotton",
    county_fips_all: 40033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73564,
    lat: 34.84444,
    lng: -99.00729,
    city: "Roosevelt",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 407,
    density: 0.9,
    county_fips: 40075,
    county_name: "Kiowa",
    county_weights: {
      40075: 100,
    },
    county_names_all: "Kiowa",
    county_fips_all: 40075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73565,
    lat: 34.02326,
    lng: -97.8751,
    city: "Ryan",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 986,
    density: 2,
    county_fips: 40067,
    county_name: "Jefferson",
    county_weights: {
      40067: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 40067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73566,
    lat: 34.61647,
    lng: -98.94258,
    city: "Snyder",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1549,
    density: 5.4,
    county_fips: 40075,
    county_name: "Kiowa",
    county_weights: {
      40075: 57.35,
      40141: 42.65,
    },
    county_names_all: "Kiowa|Tillman",
    county_fips_all: "40075|40141",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73567,
    lat: 34.7474,
    lng: -98.17093,
    city: "Sterling",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 719,
    density: 225.2,
    county_fips: 40031,
    county_name: "Comanche",
    county_weights: {
      40031: 100,
    },
    county_names_all: "Comanche",
    county_fips_all: 40031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73568,
    lat: 34.26327,
    lng: -98.21629,
    city: "Temple",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 971,
    density: 4.1,
    county_fips: 40033,
    county_name: "Cotton",
    county_weights: {
      40033: 100,
    },
    county_names_all: "Cotton",
    county_fips_all: 40033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73569,
    lat: 33.93772,
    lng: -97.80363,
    city: "Terral",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 508,
    density: 2.7,
    county_fips: 40067,
    county_name: "Jefferson",
    county_weights: {
      40067: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 40067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73570,
    lat: 34.50988,
    lng: -99.1071,
    city: "Tipton",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 949,
    density: 2.9,
    county_fips: 40141,
    county_name: "Tillman",
    county_weights: {
      40141: 100,
    },
    county_names_all: "Tillman",
    county_fips_all: 40141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73571,
    lat: 34.9325,
    lng: -99.92476,
    city: "Vinson",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 127,
    density: 0.5,
    county_fips: 40057,
    county_name: "Harmon",
    county_weights: {
      40057: 100,
    },
    county_names_all: "Harmon",
    county_fips_all: 40057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73572,
    lat: 34.37318,
    lng: -98.32638,
    city: "Walters",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3609,
    density: 5.7,
    county_fips: 40033,
    county_name: "Cotton",
    county_weights: {
      40031: 3.78,
      40033: 96.22,
    },
    county_names_all: "Cotton|Comanche",
    county_fips_all: "40033|40031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73573,
    lat: 34.1556,
    lng: -97.95412,
    city: "Waurika",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2639,
    density: 5.2,
    county_fips: 40067,
    county_name: "Jefferson",
    county_weights: {
      40067: 99.7,
      40137: 0.3,
    },
    county_names_all: "Jefferson|Stephens",
    county_fips_all: "40067|40137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73601,
    lat: 35.49859,
    lng: -98.94694,
    city: "Clinton",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10265,
    density: 28.7,
    county_fips: 40039,
    county_name: "Custer",
    county_weights: {
      40039: 73.55,
      40149: 26.45,
    },
    county_names_all: "Custer|Washita",
    county_fips_all: "40039|40149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73620,
    lat: 35.61387,
    lng: -99.02278,
    city: "Arapaho",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1576,
    density: 5.8,
    county_fips: 40039,
    county_name: "Custer",
    county_weights: {
      40039: 100,
    },
    county_names_all: "Custer",
    county_fips_all: 40039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73622,
    lat: 35.39518,
    lng: -98.99791,
    city: "Bessie",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 323,
    density: 2.7,
    county_fips: 40149,
    county_name: "Washita",
    county_weights: {
      40149: 100,
    },
    county_names_all: "Washita",
    county_fips_all: 40149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73624,
    lat: 35.35969,
    lng: -99.1719,
    city: "Burns Flat",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2087,
    density: 160,
    county_fips: 40149,
    county_name: "Washita",
    county_weights: {
      40149: 100,
    },
    county_names_all: "Washita",
    county_fips_all: 40149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73625,
    lat: 35.6964,
    lng: -99.19698,
    city: "Butler",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 589,
    density: 1.9,
    county_fips: 40039,
    county_name: "Custer",
    county_weights: {
      40039: 100,
    },
    county_names_all: "Custer",
    county_fips_all: 40039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73626,
    lat: 35.43965,
    lng: -99.27941,
    city: "Canute",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1047,
    density: 3.5,
    county_fips: 40149,
    county_name: "Washita",
    county_weights: {
      40039: 45.22,
      40149: 54.78,
    },
    county_names_all: "Washita|Custer",
    county_fips_all: "40149|40039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73627,
    lat: 35.20169,
    lng: -99.45218,
    city: "Carter",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 479,
    density: 1.8,
    county_fips: 40009,
    county_name: "Beckham",
    county_weights: {
      40009: 98.05,
      40149: 1.95,
    },
    county_names_all: "Beckham|Washita",
    county_fips_all: "40009|40149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73628,
    lat: 35.62668,
    lng: -99.68783,
    city: "Cheyenne",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1789,
    density: 1.8,
    county_fips: 40129,
    county_name: "Roger Mills",
    county_weights: {
      40129: 100,
    },
    county_names_all: "Roger Mills",
    county_fips_all: 40129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73632,
    lat: 35.27036,
    lng: -98.90853,
    city: "Cordell",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3063,
    density: 5.3,
    county_fips: 40149,
    county_name: "Washita",
    county_weights: {
      40149: 100,
    },
    county_names_all: "Washita",
    county_fips_all: 40149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73638,
    lat: 35.86532,
    lng: -99.79059,
    city: "Crawford",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 96,
    density: 0.3,
    county_fips: 40129,
    county_name: "Roger Mills",
    county_weights: {
      40129: 100,
    },
    county_names_all: "Roger Mills",
    county_fips_all: 40129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73639,
    lat: 35.72666,
    lng: -98.95578,
    city: "Custer City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 537,
    density: 1.1,
    county_fips: 40039,
    county_name: "Custer",
    county_weights: {
      40039: 100,
    },
    county_names_all: "Custer",
    county_fips_all: 40039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73641,
    lat: 35.26875,
    lng: -99.20252,
    city: "Dill City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 452,
    density: 2.6,
    county_fips: 40149,
    county_name: "Washita",
    county_weights: {
      40149: 100,
    },
    county_names_all: "Washita",
    county_fips_all: 40149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73642,
    lat: 35.81909,
    lng: -99.90887,
    city: "Durham",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 96,
    density: 0.4,
    county_fips: 40129,
    county_name: "Roger Mills",
    county_weights: {
      40129: 100,
    },
    county_names_all: "Roger Mills",
    county_fips_all: 40129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73644,
    lat: 35.40327,
    lng: -99.42718,
    city: "Elk City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14097,
    density: 29.4,
    county_fips: 40009,
    county_name: "Beckham",
    county_weights: {
      40009: 80.3,
      40039: 2.11,
      40129: 2.79,
      40149: 14.8,
    },
    county_names_all: "Beckham|Washita|Roger Mills|Custer",
    county_fips_all: "40009|40149|40129|40039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73645,
    lat: 35.16954,
    lng: -99.87038,
    city: "Erick",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1158,
    density: 1.7,
    county_fips: 40009,
    county_name: "Beckham",
    county_weights: {
      40009: 100,
    },
    county_names_all: "Beckham",
    county_fips_all: 40009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73646,
    lat: 35.82624,
    lng: -98.61928,
    city: "Fay",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 394,
    density: 1.3,
    county_fips: 40011,
    county_name: "Blaine",
    county_weights: {
      40011: 61.3,
      40039: 9.39,
      40043: 29.31,
    },
    county_names_all: "Blaine|Dewey|Custer",
    county_fips_all: "40011|40043|40039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73647,
    lat: 35.44786,
    lng: -99.16124,
    city: "Foss",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 546,
    density: 1.5,
    county_fips: 40149,
    county_name: "Washita",
    county_weights: {
      40039: 40.23,
      40149: 59.77,
    },
    county_names_all: "Washita|Custer",
    county_fips_all: "40149|40039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73650,
    lat: 35.64173,
    lng: -99.41729,
    city: "Hammon",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1017,
    density: 1.9,
    county_fips: 40129,
    county_name: "Roger Mills",
    county_weights: {
      40039: 30.64,
      40129: 69.36,
    },
    county_names_all: "Roger Mills|Custer",
    county_fips_all: "40129|40039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73651,
    lat: 35.02479,
    lng: -99.06957,
    city: "Hobart",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4239,
    density: 9.3,
    county_fips: 40075,
    county_name: "Kiowa",
    county_weights: {
      40075: 100,
    },
    county_names_all: "Kiowa",
    county_fips_all: 40075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73654,
    lat: 35.85908,
    lng: -99.37483,
    city: "Leedey",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 933,
    density: 1.1,
    county_fips: 40129,
    county_name: "Roger Mills",
    county_weights: {
      40039: 14.37,
      40043: 36.18,
      40129: 49.45,
    },
    county_names_all: "Roger Mills|Dewey|Custer",
    county_fips_all: "40129|40043|40039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73655,
    lat: 34.98189,
    lng: -99.25267,
    city: "Lone Wolf",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 814,
    density: 1.8,
    county_fips: 40075,
    county_name: "Kiowa",
    county_weights: {
      40075: 97.29,
      40149: 2.71,
    },
    county_names_all: "Kiowa|Washita",
    county_fips_all: "40075|40149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73658,
    lat: 35.94776,
    lng: -98.71784,
    city: "Oakwood",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 240,
    density: 1,
    county_fips: 40043,
    county_name: "Dewey",
    county_weights: {
      40011: 4.79,
      40043: 95.21,
    },
    county_names_all: "Dewey|Blaine",
    county_fips_all: "40043|40011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73659,
    lat: 35.87337,
    lng: -98.94582,
    city: "Putnam",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 138,
    density: 0.4,
    county_fips: 40043,
    county_name: "Dewey",
    county_weights: {
      40043: 100,
    },
    county_names_all: "Dewey",
    county_fips_all: 40043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73660,
    lat: 35.62561,
    lng: -99.91688,
    city: "Reydon",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 295,
    density: 0.9,
    county_fips: 40129,
    county_name: "Roger Mills",
    county_weights: {
      40129: 100,
    },
    county_names_all: "Roger Mills",
    county_fips_all: 40129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73661,
    lat: 35.17033,
    lng: -99.0176,
    city: "Rocky",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 535,
    density: 2.7,
    county_fips: 40149,
    county_name: "Washita",
    county_weights: {
      40149: 100,
    },
    county_names_all: "Washita",
    county_fips_all: 40149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73662,
    lat: 35.31533,
    lng: -99.66273,
    city: "Sayre",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6509,
    density: 7.5,
    county_fips: 40009,
    county_name: "Beckham",
    county_weights: {
      40009: 90.22,
      40129: 9.78,
    },
    county_names_all: "Beckham|Roger Mills",
    county_fips_all: "40009|40129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73663,
    lat: 36.10622,
    lng: -98.90291,
    city: "Seiling",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1606,
    density: 4.4,
    county_fips: 40043,
    county_name: "Dewey",
    county_weights: {
      40043: 94.54,
      40093: 3.27,
      40153: 2.19,
    },
    county_names_all: "Dewey|Major|Woodward",
    county_fips_all: "40043|40093|40153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73664,
    lat: 35.17475,
    lng: -99.2369,
    city: "Sentinel",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1254,
    density: 4.9,
    county_fips: 40149,
    county_name: "Washita",
    county_weights: {
      40149: 100,
    },
    county_names_all: "Washita",
    county_fips_all: 40149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73666,
    lat: 35.42036,
    lng: -99.92412,
    city: "Sweetwater",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 240,
    density: 0.7,
    county_fips: 40129,
    county_name: "Roger Mills",
    county_weights: {
      40009: 46.66,
      40129: 53.34,
    },
    county_names_all: "Roger Mills|Beckham",
    county_fips_all: "40129|40009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73667,
    lat: 36.00523,
    lng: -99.03062,
    city: "Taloga",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 538,
    density: 1.3,
    county_fips: 40043,
    county_name: "Dewey",
    county_weights: {
      40043: 100,
    },
    county_names_all: "Dewey",
    county_fips_all: 40043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73668,
    lat: 35.22329,
    lng: -99.9802,
    city: "Texola",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 40009,
    county_name: "Beckham",
    county_weights: {
      40009: 100,
    },
    county_names_all: "Beckham",
    county_fips_all: 40009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73669,
    lat: 35.75095,
    lng: -98.74281,
    city: "Thomas",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1721,
    density: 4.6,
    county_fips: 40039,
    county_name: "Custer",
    county_weights: {
      40011: 5.64,
      40039: 75.89,
      40043: 18.47,
    },
    county_names_all: "Custer|Dewey|Blaine",
    county_fips_all: "40039|40043|40011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73673,
    lat: 35.04649,
    lng: -99.63762,
    city: "Willow",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 404,
    density: 0.7,
    county_fips: 40055,
    county_name: "Greer",
    county_weights: {
      40009: 9.02,
      40055: 90.98,
    },
    county_names_all: "Greer|Beckham",
    county_fips_all: "40055|40009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73701,
    lat: 36.42323,
    lng: -97.78833,
    city: "Enid",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25084,
    density: 66.7,
    county_fips: 40047,
    county_name: "Garfield",
    county_weights: {
      40047: 100,
    },
    county_names_all: "Garfield",
    county_fips_all: 40047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73703,
    lat: 36.44022,
    lng: -97.9634,
    city: "Enid",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29077,
    density: 98.4,
    county_fips: 40047,
    county_name: "Garfield",
    county_weights: {
      40047: 96.49,
      40053: 3.51,
    },
    county_names_all: "Garfield|Grant",
    county_fips_all: "40047|40053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73705,
    lat: 36.33918,
    lng: -97.90208,
    city: "Enid",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 331,
    density: 256.4,
    county_fips: 40047,
    county_name: "Garfield",
    county_weights: {
      40047: 100,
    },
    county_names_all: "Garfield",
    county_fips_all: 40047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73716,
    lat: 36.48417,
    lng: -98.55316,
    city: "Aline",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 561,
    density: 1.3,
    county_fips: 40151,
    county_name: "Woods",
    county_weights: {
      40003: 34.37,
      40093: 8.18,
      40151: 57.45,
    },
    county_names_all: "Woods|Alfalfa|Major",
    county_fips_all: "40151|40003|40093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73717,
    lat: 36.84161,
    lng: -98.77807,
    city: "Alva",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6896,
    density: 3.9,
    county_fips: 40151,
    county_name: "Woods",
    county_weights: {
      40003: 5.49,
      40151: 94.51,
    },
    county_names_all: "Woods|Alfalfa",
    county_fips_all: "40151|40003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73718,
    lat: 36.20799,
    lng: -98.16898,
    city: "Ames",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 490,
    density: 2.2,
    county_fips: 40093,
    county_name: "Major",
    county_weights: {
      40047: 6.98,
      40073: 16.75,
      40093: 76.27,
    },
    county_names_all: "Major|Kingfisher|Garfield",
    county_fips_all: "40093|40073|40047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73719,
    lat: 36.96026,
    lng: -98.26746,
    city: "Amorita",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 92,
    density: 0.8,
    county_fips: 40003,
    county_name: "Alfalfa",
    county_weights: {
      40003: 100,
    },
    county_names_all: "Alfalfa",
    county_fips_all: 40003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73720,
    lat: 36.1973,
    lng: -97.87038,
    city: "Bison",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 104,
    density: 0.8,
    county_fips: 40047,
    county_name: "Garfield",
    county_weights: {
      40047: 100,
    },
    county_names_all: "Garfield",
    county_fips_all: 40047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73722,
    lat: 36.90196,
    lng: -98.36445,
    city: "Burlington",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 363,
    density: 0.9,
    county_fips: 40003,
    county_name: "Alfalfa",
    county_weights: {
      40003: 100,
    },
    county_names_all: "Alfalfa",
    county_fips_all: 40003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73724,
    lat: 36.03757,
    lng: -98.67235,
    city: "Canton",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1050,
    density: 3,
    county_fips: 40043,
    county_name: "Dewey",
    county_weights: {
      40011: 43.53,
      40043: 56.47,
    },
    county_names_all: "Dewey|Blaine",
    county_fips_all: "40043|40011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73726,
    lat: 36.58022,
    lng: -98.50405,
    city: "Carmen",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 416,
    density: 1.7,
    county_fips: 40003,
    county_name: "Alfalfa",
    county_weights: {
      40003: 60.11,
      40151: 39.89,
    },
    county_names_all: "Alfalfa|Woods",
    county_fips_all: "40003|40151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73727,
    lat: 36.48309,
    lng: -98.03839,
    city: "Carrier",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 124,
    density: 1.7,
    county_fips: 40047,
    county_name: "Garfield",
    county_weights: {
      40047: 100,
    },
    county_names_all: "Garfield",
    county_fips_all: 40047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73728,
    lat: 36.73508,
    lng: -98.39376,
    city: "Cherokee",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2082,
    density: 3.6,
    county_fips: 40003,
    county_name: "Alfalfa",
    county_weights: {
      40003: 100,
    },
    county_names_all: "Alfalfa",
    county_fips_all: 40003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73729,
    lat: 36.39723,
    lng: -98.45256,
    city: "Cleo Springs",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 624,
    density: 3.3,
    county_fips: 40093,
    county_name: "Major",
    county_weights: {
      40093: 84.25,
      40151: 15.75,
    },
    county_names_all: "Major|Woods",
    county_fips_all: "40093|40151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73730,
    lat: 36.31754,
    lng: -97.54765,
    city: "Covington",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 701,
    density: 4.7,
    county_fips: 40047,
    county_name: "Garfield",
    county_weights: {
      40047: 100,
    },
    county_names_all: "Garfield",
    county_fips_all: 40047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73731,
    lat: 36.64397,
    lng: -98.59915,
    city: "Dacoma",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 111,
    density: 1.2,
    county_fips: 40151,
    county_name: "Woods",
    county_weights: {
      40151: 100,
    },
    county_names_all: "Woods",
    county_fips_all: 40151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73733,
    lat: 36.2497,
    lng: -97.69104,
    city: "Douglas",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 210,
    density: 1.5,
    county_fips: 40047,
    county_name: "Garfield",
    county_weights: {
      40047: 100,
    },
    county_names_all: "Garfield",
    county_fips_all: 40047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73734,
    lat: 35.98453,
    lng: -97.8534,
    city: "Dover",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 718,
    density: 2.6,
    county_fips: 40073,
    county_name: "Kingfisher",
    county_weights: {
      40073: 100,
    },
    county_names_all: "Kingfisher",
    county_fips_all: 40073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73735,
    lat: 36.27594,
    lng: -98.05132,
    city: "Drummond",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 637,
    density: 6,
    county_fips: 40047,
    county_name: "Garfield",
    county_weights: {
      40047: 96.27,
      40093: 3.73,
    },
    county_names_all: "Garfield|Major",
    county_fips_all: "40047|40093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73736,
    lat: 36.34607,
    lng: -97.68751,
    city: "Fairmont",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 658,
    density: 4.7,
    county_fips: 40047,
    county_name: "Garfield",
    county_weights: {
      40047: 100,
    },
    county_names_all: "Garfield",
    county_fips_all: 40047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73737,
    lat: 36.29133,
    lng: -98.58517,
    city: "Fairview",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3656,
    density: 5.4,
    county_fips: 40093,
    county_name: "Major",
    county_weights: {
      40093: 100,
    },
    county_names_all: "Major",
    county_fips_all: 40093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73738,
    lat: 36.44463,
    lng: -97.55315,
    city: "Garber",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 979,
    density: 4.1,
    county_fips: 40047,
    county_name: "Garfield",
    county_weights: {
      40047: 100,
    },
    county_names_all: "Garfield",
    county_fips_all: 40047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73739,
    lat: 36.51999,
    lng: -98.13697,
    city: "Goltry",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 365,
    density: 2.8,
    county_fips: 40003,
    county_name: "Alfalfa",
    county_weights: {
      40003: 76.94,
      40047: 23.06,
    },
    county_names_all: "Alfalfa|Garfield",
    county_fips_all: "40003|40047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73741,
    lat: 36.55071,
    lng: -98.26619,
    city: "Helena",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1540,
    density: 6.6,
    county_fips: 40003,
    county_name: "Alfalfa",
    county_weights: {
      40003: 100,
    },
    county_names_all: "Alfalfa",
    county_fips_all: 40003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73742,
    lat: 36.09632,
    lng: -97.91907,
    city: "Hennessey",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4108,
    density: 7.3,
    county_fips: 40073,
    county_name: "Kingfisher",
    county_weights: {
      40073: 100,
    },
    county_names_all: "Kingfisher",
    county_fips_all: 40073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73743,
    lat: 36.56324,
    lng: -97.9927,
    city: "Hillsdale",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52,
    density: 57.9,
    county_fips: 40047,
    county_name: "Garfield",
    county_weights: {
      40047: 100,
    },
    county_names_all: "Garfield",
    county_fips_all: 40047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73744,
    lat: 35.94912,
    lng: -98.29643,
    city: "Hitchcock",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 108,
    density: 0.4,
    county_fips: 40011,
    county_name: "Blaine",
    county_weights: {
      40011: 95.28,
      40073: 4.72,
    },
    county_names_all: "Blaine|Kingfisher",
    county_fips_all: "40011|40073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73746,
    lat: 36.6882,
    lng: -98.66202,
    city: "Hopeton",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42,
    density: 32.9,
    county_fips: 40151,
    county_name: "Woods",
    county_weights: {
      40151: 100,
    },
    county_names_all: "Woods",
    county_fips_all: 40151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73747,
    lat: 36.23358,
    lng: -98.33964,
    city: "Isabella",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 295,
    density: 2.3,
    county_fips: 40093,
    county_name: "Major",
    county_weights: {
      40093: 100,
    },
    county_names_all: "Major",
    county_fips_all: 40093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73749,
    lat: 36.70566,
    lng: -98.16283,
    city: "Jet",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 498,
    density: 2.1,
    county_fips: 40003,
    county_name: "Alfalfa",
    county_weights: {
      40003: 100,
    },
    county_names_all: "Alfalfa",
    county_fips_all: 40003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73750,
    lat: 35.8534,
    lng: -97.94435,
    city: "Kingfisher",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7309,
    density: 10.4,
    county_fips: 40073,
    county_name: "Kingfisher",
    county_weights: {
      40073: 100,
    },
    county_names_all: "Kingfisher",
    county_fips_all: 40073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73753,
    lat: 36.55277,
    lng: -97.86976,
    city: "Kremlin",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 470,
    density: 2.7,
    county_fips: 40047,
    county_name: "Garfield",
    county_weights: {
      40047: 100,
    },
    county_names_all: "Garfield",
    county_fips_all: 40047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73754,
    lat: 36.39016,
    lng: -98.09455,
    city: "Lahoma",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 981,
    density: 7.8,
    county_fips: 40047,
    county_name: "Garfield",
    county_weights: {
      40003: 2.06,
      40047: 61.87,
      40093: 36.07,
    },
    county_names_all: "Garfield|Major|Alfalfa",
    county_fips_all: "40047|40093|40003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73755,
    lat: 36.13717,
    lng: -98.5889,
    city: "Longdale",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 627,
    density: 2.9,
    county_fips: 40011,
    county_name: "Blaine",
    county_weights: {
      40011: 57.82,
      40043: 15.87,
      40093: 26.31,
    },
    county_names_all: "Blaine|Major|Dewey",
    county_fips_all: "40011|40093|40043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73756,
    lat: 35.97507,
    lng: -98.11439,
    city: "Loyal",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 360,
    density: 1.9,
    county_fips: 40073,
    county_name: "Kingfisher",
    county_weights: {
      40073: 100,
    },
    county_names_all: "Kingfisher",
    county_fips_all: 40073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73757,
    lat: 36.27601,
    lng: -97.44935,
    city: "Lucien",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 175,
    density: 3,
    county_fips: 40103,
    county_name: "Noble",
    county_weights: {
      40047: 26.84,
      40103: 73.16,
    },
    county_names_all: "Noble|Garfield",
    county_fips_all: "40103|40047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73758,
    lat: 36.93239,
    lng: -98.0875,
    city: "Manchester",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 135,
    density: 0.5,
    county_fips: 40053,
    county_name: "Grant",
    county_weights: {
      40003: 40.54,
      40053: 59.46,
    },
    county_names_all: "Grant|Alfalfa",
    county_fips_all: "40053|40003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73759,
    lat: 36.85815,
    lng: -97.71362,
    city: "Medford",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1326,
    density: 1.4,
    county_fips: 40053,
    county_name: "Grant",
    county_weights: {
      40053: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 40053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73760,
    lat: 36.38658,
    lng: -98.1693,
    city: "Meno",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 358,
    density: 2.7,
    county_fips: 40093,
    county_name: "Major",
    county_weights: {
      40003: 4.75,
      40093: 95.25,
    },
    county_names_all: "Major|Alfalfa",
    county_fips_all: "40093|40003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73761,
    lat: 36.68452,
    lng: -98.03647,
    city: "Nash",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 328,
    density: 1.1,
    county_fips: 40053,
    county_name: "Grant",
    county_weights: {
      40047: 9.99,
      40053: 90.01,
    },
    county_names_all: "Grant|Garfield",
    county_fips_all: "40053|40047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73762,
    lat: 35.71197,
    lng: -97.97442,
    city: "Okarche",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1975,
    density: 4.3,
    county_fips: 40017,
    county_name: "Canadian",
    county_weights: {
      40017: 55.63,
      40073: 44.37,
    },
    county_names_all: "Canadian|Kingfisher",
    county_fips_all: "40017|40073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73763,
    lat: 36.10302,
    lng: -98.3201,
    city: "Okeene",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1586,
    density: 3.2,
    county_fips: 40011,
    county_name: "Blaine",
    county_weights: {
      40011: 74.7,
      40073: 13.52,
      40093: 11.78,
    },
    county_names_all: "Blaine|Kingfisher|Major",
    county_fips_all: "40011|40073|40093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73764,
    lat: 35.85738,
    lng: -98.20307,
    city: "Omega",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 245,
    density: 2.1,
    county_fips: 40073,
    county_name: "Kingfisher",
    county_weights: {
      40011: 41.64,
      40073: 58.36,
    },
    county_names_all: "Kingfisher|Blaine",
    county_fips_all: "40073|40011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73766,
    lat: 36.65004,
    lng: -97.83846,
    city: "Pond Creek",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1391,
    density: 4.5,
    county_fips: 40053,
    county_name: "Grant",
    county_weights: {
      40053: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 40053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73768,
    lat: 36.36265,
    lng: -98.27907,
    city: "Ringwood",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1633,
    density: 5.6,
    county_fips: 40093,
    county_name: "Major",
    county_weights: {
      40003: 1.81,
      40093: 98.19,
    },
    county_names_all: "Major|Alfalfa",
    county_fips_all: "40093|40003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73770,
    lat: 36.05406,
    lng: -98.49791,
    city: "Southard",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 40011,
    county_name: "Blaine",
    county_weights: {
      40011: 100,
    },
    county_names_all: "Blaine",
    county_fips_all: 40011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73771,
    lat: 36.87533,
    lng: -97.95653,
    city: "Wakita",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 416,
    density: 1.2,
    county_fips: 40053,
    county_name: "Grant",
    county_weights: {
      40053: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 40053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73772,
    lat: 35.86327,
    lng: -98.42369,
    city: "Watonga",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4057,
    density: 6.5,
    county_fips: 40011,
    county_name: "Blaine",
    county_weights: {
      40011: 100,
    },
    county_names_all: "Blaine",
    county_fips_all: 40011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73773,
    lat: 36.25804,
    lng: -97.91922,
    city: "Waukomis",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1875,
    density: 6.7,
    county_fips: 40047,
    county_name: "Garfield",
    county_weights: {
      40047: 100,
    },
    county_names_all: "Garfield",
    county_fips_all: 40047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73801,
    lat: 36.4733,
    lng: -99.4307,
    city: "Woodward",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15285,
    density: 12.9,
    county_fips: 40153,
    county_name: "Woodward",
    county_weights: {
      40059: 21.63,
      40153: 78.37,
    },
    county_names_all: "Woodward|Harper",
    county_fips_all: "40153|40059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73832,
    lat: 36.05298,
    lng: -99.65687,
    city: "Arnett",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 975,
    density: 0.7,
    county_fips: 40045,
    county_name: "Ellis",
    county_weights: {
      40045: 92.5,
      40153: 7.5,
    },
    county_names_all: "Ellis|Woodward",
    county_fips_all: "40045|40153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73834,
    lat: 36.84807,
    lng: -99.57156,
    city: "Buffalo",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1769,
    density: 1.5,
    county_fips: 40059,
    county_name: "Harper",
    county_weights: {
      40059: 100,
    },
    county_names_all: "Harper",
    county_fips_all: 40059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73835,
    lat: 35.97327,
    lng: -99.21279,
    city: "Camargo",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 233,
    density: 0.6,
    county_fips: 40043,
    county_name: "Dewey",
    county_weights: {
      40043: 100,
    },
    county_names_all: "Dewey",
    county_fips_all: 40043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73838,
    lat: 36.24575,
    lng: -98.87579,
    city: "Chester",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 348,
    density: 0.8,
    county_fips: 40093,
    county_name: "Major",
    county_weights: {
      40093: 82.74,
      40153: 17.26,
    },
    county_names_all: "Major|Woodward",
    county_fips_all: "40093|40153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73840,
    lat: 36.39436,
    lng: -99.64581,
    city: "Fargo",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 632,
    density: 1.7,
    county_fips: 40045,
    county_name: "Ellis",
    county_weights: {
      40045: 74.37,
      40153: 25.63,
    },
    county_names_all: "Ellis|Woodward",
    county_fips_all: "40045|40153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73841,
    lat: 36.54799,
    lng: -99.61924,
    city: "Fort Supply",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1311,
    density: 12.3,
    county_fips: 40045,
    county_name: "Ellis",
    county_weights: {
      40045: 59.22,
      40153: 40.78,
    },
    county_names_all: "Ellis|Woodward",
    county_fips_all: "40045|40153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73842,
    lat: 36.8212,
    lng: -99.21452,
    city: "Freedom",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 606,
    density: 0.6,
    county_fips: 40151,
    county_name: "Woods",
    county_weights: {
      40059: 8.51,
      40151: 66.9,
      40153: 24.59,
    },
    county_names_all: "Woods|Woodward|Harper",
    county_fips_all: "40151|40153|40059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73843,
    lat: 36.39805,
    lng: -99.83566,
    city: "Gage",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 732,
    density: 0.9,
    county_fips: 40045,
    county_name: "Ellis",
    county_weights: {
      40007: 6.23,
      40045: 93.77,
    },
    county_names_all: "Ellis|Beaver",
    county_fips_all: "40045|40007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73844,
    lat: 36.89715,
    lng: -100.16763,
    city: "Gate",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 269,
    density: 0.3,
    county_fips: 40007,
    county_name: "Beaver",
    county_weights: {
      40007: 89.39,
      40059: 10.61,
    },
    county_names_all: "Beaver|Harper",
    county_fips_all: "40007|40059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73848,
    lat: 36.64843,
    lng: -100.023,
    city: "Laverne",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1946,
    density: 1.4,
    county_fips: 40007,
    county_name: "Beaver",
    county_weights: {
      40007: 56.65,
      40059: 43.35,
    },
    county_names_all: "Beaver|Harper",
    county_fips_all: "40007|40059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73851,
    lat: 36.57298,
    lng: -99.78406,
    city: "May",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 134,
    density: 0.6,
    county_fips: 40045,
    county_name: "Ellis",
    county_weights: {
      40045: 69.23,
      40059: 30.77,
    },
    county_names_all: "Ellis|Harper",
    county_fips_all: "40045|40059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73852,
    lat: 36.4873,
    lng: -99.10798,
    city: "Mooreland",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2085,
    density: 1.9,
    county_fips: 40153,
    county_name: "Woodward",
    county_weights: {
      40093: 1.63,
      40153: 98.37,
    },
    county_names_all: "Woodward|Major",
    county_fips_all: "40153|40093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73853,
    lat: 36.24333,
    lng: -99.15664,
    city: "Mutual",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 437,
    density: 1.2,
    county_fips: 40153,
    county_name: "Woodward",
    county_weights: {
      40043: 1.29,
      40153: 98.71,
    },
    county_names_all: "Woodward|Dewey",
    county_fips_all: "40153|40043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73855,
    lat: 36.88481,
    lng: -99.85877,
    city: "Rosston",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 116,
    density: 0.3,
    county_fips: 40059,
    county_name: "Harper",
    county_weights: {
      40059: 100,
    },
    county_names_all: "Harper",
    county_fips_all: 40059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73857,
    lat: 36.27223,
    lng: -99.33235,
    city: "Sharon",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 855,
    density: 4.8,
    county_fips: 40153,
    county_name: "Woodward",
    county_weights: {
      40153: 100,
    },
    county_names_all: "Woodward",
    county_fips_all: 40153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73858,
    lat: 36.17037,
    lng: -99.92442,
    city: "Shattuck",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1766,
    density: 3,
    county_fips: 40045,
    county_name: "Ellis",
    county_weights: {
      40045: 100,
    },
    county_names_all: "Ellis",
    county_fips_all: 40045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73859,
    lat: 36.13309,
    lng: -99.2797,
    city: "Vici",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1311,
    density: 3.3,
    county_fips: 40043,
    county_name: "Dewey",
    county_weights: {
      40043: 64.09,
      40045: 11.51,
      40153: 24.4,
    },
    county_names_all: "Dewey|Woodward|Ellis",
    county_fips_all: "40043|40153|40045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73860,
    lat: 36.53573,
    lng: -98.86265,
    city: "Waynoka",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1271,
    density: 1.5,
    county_fips: 40151,
    county_name: "Woods",
    county_weights: {
      40093: 38.51,
      40151: 61.49,
    },
    county_names_all: "Woods|Major",
    county_fips_all: "40151|40093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73901,
    lat: 36.75458,
    lng: -101.07517,
    city: "Adams",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 306,
    density: 234.2,
    county_fips: 40139,
    county_name: "Texas",
    county_weights: {
      40139: 100,
    },
    county_names_all: "Texas",
    county_fips_all: 40139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73931,
    lat: 36.60097,
    lng: -100.80329,
    city: "Balko",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 559,
    density: 1,
    county_fips: 40007,
    county_name: "Beaver",
    county_weights: {
      40007: 100,
    },
    county_names_all: "Beaver",
    county_fips_all: 40007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73932,
    lat: 36.7,
    lng: -100.51914,
    city: "Beaver",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2074,
    density: 1.5,
    county_fips: 40007,
    county_name: "Beaver",
    county_weights: {
      40007: 100,
    },
    county_names_all: "Beaver",
    county_fips_all: 40007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73933,
    lat: 36.7436,
    lng: -102.58198,
    city: "Boise City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1419,
    density: 0.6,
    county_fips: 40025,
    county_name: "Cimarron",
    county_weights: {
      40025: 100,
    },
    county_names_all: "Cimarron",
    county_fips_all: 40025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73937,
    lat: 36.5642,
    lng: -102.76703,
    city: "Felt",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 188,
    density: 0.3,
    county_fips: 40025,
    county_name: "Cimarron",
    county_weights: {
      40025: 100,
    },
    county_names_all: "Cimarron",
    county_fips_all: 40025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73938,
    lat: 36.92585,
    lng: -100.58497,
    city: "Forgan",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 819,
    density: 1.5,
    county_fips: 40007,
    county_name: "Beaver",
    county_weights: {
      40007: 100,
    },
    county_names_all: "Beaver",
    county_fips_all: 40007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73939,
    lat: 36.76824,
    lng: -101.78344,
    city: "Goodwell",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1530,
    density: 1.5,
    county_fips: 40139,
    county_name: "Texas",
    county_weights: {
      40139: 100,
    },
    county_names_all: "Texas",
    county_fips_all: 40139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73942,
    lat: 36.74452,
    lng: -101.49555,
    city: "Guymon",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12980,
    density: 8.3,
    county_fips: 40139,
    county_name: "Texas",
    county_weights: {
      40139: 100,
    },
    county_names_all: "Texas",
    county_fips_all: 40139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73944,
    lat: 36.58511,
    lng: -101.10339,
    city: "Hardesty",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 463,
    density: 0.9,
    county_fips: 40139,
    county_name: "Texas",
    county_weights: {
      40139: 100,
    },
    county_names_all: "Texas",
    county_fips_all: 40139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73945,
    lat: 36.8321,
    lng: -101.22474,
    city: "Hooker",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2369,
    density: 2.3,
    county_fips: 40139,
    county_name: "Texas",
    county_weights: {
      40139: 100,
    },
    county_names_all: "Texas",
    county_fips_all: 40139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73946,
    lat: 36.92316,
    lng: -102.81258,
    city: "Kenton",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51,
    density: 0.1,
    county_fips: 40025,
    county_name: "Cimarron",
    county_weights: {
      40025: 100,
    },
    county_names_all: "Cimarron",
    county_fips_all: 40025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73947,
    lat: 36.84672,
    lng: -102.17316,
    city: "Keyes",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 498,
    density: 0.5,
    county_fips: 40025,
    county_name: "Cimarron",
    county_weights: {
      40025: 92.87,
      40139: 7.13,
    },
    county_names_all: "Cimarron|Texas",
    county_fips_all: "40025|40139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73949,
    lat: 36.5929,
    lng: -101.98559,
    city: "Texhoma",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1874,
    density: 1.6,
    county_fips: 40139,
    county_name: "Texas",
    county_weights: {
      40025: 27.32,
      40139: 59.05,
      48421: 13.63,
    },
    county_names_all: "Texas|Cimarron|Sherman",
    county_fips_all: "40139|40025|48421",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73950,
    lat: 36.85193,
    lng: -100.88621,
    city: "Turpin",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1471,
    density: 2.5,
    county_fips: 40007,
    county_name: "Beaver",
    county_weights: {
      40007: 80.07,
      40139: 19.93,
    },
    county_names_all: "Beaver|Texas",
    county_fips_all: "40007|40139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73951,
    lat: 36.95004,
    lng: -101.05463,
    city: "Tyrone",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1403,
    density: 6.5,
    county_fips: 40139,
    county_name: "Texas",
    county_weights: {
      40139: 100,
    },
    county_names_all: "Texas",
    county_fips_all: 40139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 73960,
    lat: 36.49167,
    lng: -101.79265,
    city: "Texhoma",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48421,
    county_name: "Sherman",
    county_weights: {
      48421: 100,
    },
    county_names_all: "Sherman",
    county_fips_all: 48421,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74001,
    lat: 36.48857,
    lng: -96.0625,
    city: "Avant",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 373,
    density: 228.4,
    county_fips: 40113,
    county_name: "Osage",
    county_weights: {
      40113: 100,
    },
    county_names_all: "Osage",
    county_fips_all: 40113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74002,
    lat: 36.5613,
    lng: -96.14528,
    city: "Barnsdall",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1808,
    density: 4.5,
    county_fips: 40113,
    county_name: "Osage",
    county_weights: {
      40113: 100,
    },
    county_names_all: "Osage",
    county_fips_all: 40113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74003,
    lat: 36.73107,
    lng: -96.06675,
    city: "Bartlesville",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14509,
    density: 43.2,
    county_fips: 40113,
    county_name: "Osage",
    county_weights: {
      40113: 84.76,
      40147: 15.24,
    },
    county_names_all: "Osage|Washington",
    county_fips_all: "40113|40147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74006,
    lat: 36.71507,
    lng: -95.89391,
    city: "Bartlesville",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26660,
    density: 112.6,
    county_fips: 40147,
    county_name: "Washington",
    county_weights: {
      40147: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 40147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74008,
    lat: 35.92614,
    lng: -95.87575,
    city: "Bixby",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30144,
    density: 156.5,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40143: 95.98,
      40145: 4.02,
    },
    county_names_all: "Tulsa|Wagoner",
    county_fips_all: "40143|40145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74010,
    lat: 35.80945,
    lng: -96.36101,
    city: "Bristow",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10537,
    density: 12.6,
    county_fips: 40037,
    county_name: "Creek",
    county_weights: {
      40037: 99.15,
      40107: 0.85,
    },
    county_names_all: "Creek|Okfuskee",
    county_fips_all: "40037|40107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74011,
    lat: 35.98154,
    lng: -95.81007,
    city: "Broken Arrow",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29680,
    density: 480.5,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40143: 100,
    },
    county_names_all: "Tulsa",
    county_fips_all: 40143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74012,
    lat: 36.05381,
    lng: -95.80509,
    city: "Broken Arrow",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61855,
    density: 962.1,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40143: 100,
    },
    county_names_all: "Tulsa",
    county_fips_all: 40143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74014,
    lat: 36.05538,
    lng: -95.66819,
    city: "Broken Arrow",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42275,
    density: 155.5,
    county_fips: 40145,
    county_name: "Wagoner",
    county_weights: {
      40145: 100,
    },
    county_names_all: "Wagoner",
    county_fips_all: 40145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74015,
    lat: 36.18012,
    lng: -95.70952,
    city: "Catoosa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8771,
    density: 56.1,
    county_fips: 40131,
    county_name: "Rogers",
    county_weights: {
      40131: 69.39,
      40143: 0.24,
      40145: 30.37,
    },
    county_names_all: "Rogers|Wagoner|Tulsa",
    county_fips_all: "40131|40145|40143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74016,
    lat: 36.54093,
    lng: -95.45283,
    city: "Chelsea",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5779,
    density: 15.5,
    county_fips: 40131,
    county_name: "Rogers",
    county_weights: {
      40035: 10.7,
      40097: 15.88,
      40105: 11.94,
      40131: 61.48,
    },
    county_names_all: "Rogers|Mayes|Nowata|Craig",
    county_fips_all: "40131|40097|40105|40035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74017,
    lat: 36.39359,
    lng: -95.57986,
    city: "Claremore",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28285,
    density: 77.7,
    county_fips: 40131,
    county_name: "Rogers",
    county_weights: {
      40131: 100,
    },
    county_names_all: "Rogers",
    county_fips_all: 40131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74019,
    lat: 36.28326,
    lng: -95.60684,
    city: "Claremore",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18256,
    density: 61.6,
    county_fips: 40131,
    county_name: "Rogers",
    county_weights: {
      40131: 100,
    },
    county_names_all: "Rogers",
    county_fips_all: 40131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74020,
    lat: 36.24562,
    lng: -96.41934,
    city: "Cleveland",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7453,
    density: 42.5,
    county_fips: 40117,
    county_name: "Pawnee",
    county_weights: {
      40117: 100,
    },
    county_names_all: "Pawnee",
    county_fips_all: 40117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74021,
    lat: 36.37915,
    lng: -95.84758,
    city: "Collinsville",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21746,
    density: 125.3,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40131: 18.92,
      40143: 66.23,
      40147: 14.85,
    },
    county_names_all: "Tulsa|Rogers|Washington",
    county_fips_all: "40143|40131|40147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74022,
    lat: 36.93055,
    lng: -95.98054,
    city: "Copan",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1908,
    density: 6.2,
    county_fips: 40147,
    county_name: "Washington",
    county_weights: {
      40113: 42.51,
      40147: 57.49,
    },
    county_names_all: "Washington|Osage",
    county_fips_all: "40147|40113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74023,
    lat: 35.95708,
    lng: -96.74963,
    city: "Cushing",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11392,
    density: 25.4,
    county_fips: 40119,
    county_name: "Payne",
    county_weights: {
      40081: 40.84,
      40119: 59.16,
    },
    county_names_all: "Payne|Lincoln",
    county_fips_all: "40119|40081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74026,
    lat: 35.72266,
    lng: -96.78282,
    city: "Davenport",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 791,
    density: 32.1,
    county_fips: 40081,
    county_name: "Lincoln",
    county_weights: {
      40081: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 40081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74027,
    lat: 36.80285,
    lng: -95.58628,
    city: "Delaware",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1041,
    density: 4.1,
    county_fips: 40105,
    county_name: "Nowata",
    county_weights: {
      40105: 100,
    },
    county_names_all: "Nowata",
    county_fips_all: 40105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74028,
    lat: 35.79554,
    lng: -96.52259,
    city: "Depew",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1699,
    density: 6.5,
    county_fips: 40037,
    county_name: "Creek",
    county_weights: {
      40037: 99.42,
      40081: 0.58,
    },
    county_names_all: "Creek|Lincoln",
    county_fips_all: "40037|40081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74029,
    lat: 36.82558,
    lng: -95.88172,
    city: "Dewey",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4625,
    density: 39,
    county_fips: 40147,
    county_name: "Washington",
    county_weights: {
      40147: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 40147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74030,
    lat: 35.98508,
    lng: -96.5673,
    city: "Drumright",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3750,
    density: 20.9,
    county_fips: 40037,
    county_name: "Creek",
    county_weights: {
      40037: 91.65,
      40119: 8.35,
    },
    county_names_all: "Creek|Payne",
    county_fips_all: "40037|40119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74032,
    lat: 36.2115,
    lng: -96.90402,
    city: "Glencoe",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1729,
    density: 6.1,
    county_fips: 40119,
    county_name: "Payne",
    county_weights: {
      40103: 9.1,
      40117: 19.31,
      40119: 71.59,
    },
    county_names_all: "Payne|Pawnee|Noble",
    county_fips_all: "40119|40117|40103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74033,
    lat: 35.94711,
    lng: -96.00636,
    city: "Glenpool",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12663,
    density: 396,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40143: 100,
    },
    county_names_all: "Tulsa",
    county_fips_all: 40143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74034,
    lat: 36.23266,
    lng: -96.56288,
    city: "Hallett",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 81,
    density: 16.4,
    county_fips: 40117,
    county_name: "Pawnee",
    county_weights: {
      40117: 100,
    },
    county_names_all: "Pawnee",
    county_fips_all: 40117,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74035,
    lat: 36.40368,
    lng: -96.37607,
    city: "Hominy",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4197,
    density: 6.9,
    county_fips: 40113,
    county_name: "Osage",
    county_weights: {
      40113: 100,
    },
    county_names_all: "Osage",
    county_fips_all: 40113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74036,
    lat: 36.15713,
    lng: -95.50497,
    city: "Inola",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7258,
    density: 21.8,
    county_fips: 40131,
    county_name: "Rogers",
    county_weights: {
      40097: 10.55,
      40131: 80.61,
      40145: 8.84,
    },
    county_names_all: "Rogers|Mayes|Wagoner",
    county_fips_all: "40131|40097|40145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74037,
    lat: 36.00149,
    lng: -95.98171,
    city: "Jenks",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18972,
    density: 453.2,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40143: 100,
    },
    county_names_all: "Tulsa",
    county_fips_all: 40143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74038,
    lat: 36.1552,
    lng: -96.56151,
    city: "Jennings",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2317,
    density: 8.7,
    county_fips: 40037,
    county_name: "Creek",
    county_weights: {
      40037: 51.61,
      40117: 48.39,
    },
    county_names_all: "Creek|Pawnee",
    county_fips_all: "40037|40117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74039,
    lat: 35.89822,
    lng: -96.22842,
    city: "Kellyville",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3794,
    density: 21.6,
    county_fips: 40037,
    county_name: "Creek",
    county_weights: {
      40037: 100,
    },
    county_names_all: "Creek",
    county_fips_all: 40037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74041,
    lat: 35.93808,
    lng: -96.05545,
    city: "Kiefer",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2913,
    density: 128.1,
    county_fips: 40037,
    county_name: "Creek",
    county_weights: {
      40037: 100,
    },
    county_names_all: "Creek",
    county_fips_all: 40037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74042,
    lat: 36.88381,
    lng: -95.55223,
    city: "Lenapah",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 448,
    density: 3.2,
    county_fips: 40105,
    county_name: "Nowata",
    county_weights: {
      40105: 100,
    },
    county_names_all: "Nowata",
    county_fips_all: 40105,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74044,
    lat: 36.08964,
    lng: -96.38117,
    city: "Mannford",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7602,
    density: 33.5,
    county_fips: 40037,
    county_name: "Creek",
    county_weights: {
      40037: 89.88,
      40117: 10.12,
    },
    county_names_all: "Creek|Pawnee",
    county_fips_all: "40037|40117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74045,
    lat: 36.22153,
    lng: -96.70049,
    city: "Maramec",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 319,
    density: 2.9,
    county_fips: 40117,
    county_name: "Pawnee",
    county_weights: {
      40117: 99.71,
      40119: 0.29,
    },
    county_names_all: "Pawnee|Payne",
    county_fips_all: "40117|40119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74046,
    lat: 35.75455,
    lng: -96.56969,
    city: "Milfay",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 130,
    density: 24.8,
    county_fips: 40037,
    county_name: "Creek",
    county_weights: {
      40037: 100,
    },
    county_names_all: "Creek",
    county_fips_all: 40037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74047,
    lat: 35.85522,
    lng: -96.02583,
    city: "Mounds",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7289,
    density: 28.5,
    county_fips: 40111,
    county_name: "Okmulgee",
    county_weights: {
      40037: 19.91,
      40111: 55.65,
      40143: 24.44,
    },
    county_names_all: "Okmulgee|Tulsa|Creek",
    county_fips_all: "40111|40143|40037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74048,
    lat: 36.69265,
    lng: -95.65192,
    city: "Nowata",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5956,
    density: 10.9,
    county_fips: 40105,
    county_name: "Nowata",
    county_weights: {
      40105: 99.58,
      40147: 0.42,
    },
    county_names_all: "Nowata|Washington",
    county_fips_all: "40105|40147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74050,
    lat: 36.07221,
    lng: -96.06546,
    city: "Oakhurst",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 436,
    density: 402.4,
    county_fips: 40037,
    county_name: "Creek",
    county_weights: {
      40037: 90.52,
      40143: 9.48,
    },
    county_names_all: "Creek|Tulsa",
    county_fips_all: "40037|40143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74051,
    lat: 36.61412,
    lng: -95.96532,
    city: "Ochelata",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2266,
    density: 26.5,
    county_fips: 40147,
    county_name: "Washington",
    county_weights: {
      40113: 9.84,
      40147: 90.16,
    },
    county_names_all: "Washington|Osage",
    county_fips_all: "40147|40113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74052,
    lat: 36.07076,
    lng: -96.5738,
    city: "Oilton",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 919,
    density: 40.2,
    county_fips: 40037,
    county_name: "Creek",
    county_weights: {
      40037: 100,
    },
    county_names_all: "Creek",
    county_fips_all: 40037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74053,
    lat: 36.43419,
    lng: -95.73282,
    city: "Oologah",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5308,
    density: 49.5,
    county_fips: 40131,
    county_name: "Rogers",
    county_weights: {
      40131: 100,
    },
    county_names_all: "Rogers",
    county_fips_all: 40131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74054,
    lat: 36.27299,
    lng: -96.32962,
    city: "Osage",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 749,
    density: 10,
    county_fips: 40113,
    county_name: "Osage",
    county_weights: {
      40113: 100,
    },
    county_names_all: "Osage",
    county_fips_all: 40113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74055,
    lat: 36.27735,
    lng: -95.81998,
    city: "Owasso",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46806,
    density: 354.7,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40131: 45.54,
      40143: 54.46,
    },
    county_names_all: "Tulsa|Rogers",
    county_fips_all: "40143|40131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74056,
    lat: 36.79706,
    lng: -96.33873,
    city: "Pawhuska",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5509,
    density: 3.3,
    county_fips: 40113,
    county_name: "Osage",
    county_weights: {
      40113: 100,
    },
    county_names_all: "Osage",
    county_fips_all: 40113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74058,
    lat: 36.35499,
    lng: -96.75909,
    city: "Pawnee",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3951,
    density: 6,
    county_fips: 40117,
    county_name: "Pawnee",
    county_weights: {
      40113: 0.23,
      40117: 99.77,
    },
    county_names_all: "Pawnee|Osage",
    county_fips_all: "40117|40113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74059,
    lat: 35.95736,
    lng: -97.06255,
    city: "Perkins",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5266,
    density: 18.1,
    county_fips: 40119,
    county_name: "Payne",
    county_weights: {
      40081: 28.45,
      40083: 8.06,
      40119: 63.49,
    },
    county_names_all: "Payne|Lincoln|Logan",
    county_fips_all: "40119|40081|40083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74060,
    lat: 36.2472,
    lng: -96.25434,
    city: "Prue",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 408,
    density: 32.1,
    county_fips: 40113,
    county_name: "Osage",
    county_weights: {
      40113: 100,
    },
    county_names_all: "Osage",
    county_fips_all: 40113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74061,
    lat: 36.53814,
    lng: -95.89974,
    city: "Ramona",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2314,
    density: 9.9,
    county_fips: 40147,
    county_name: "Washington",
    county_weights: {
      40147: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 40147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74062,
    lat: 36.03481,
    lng: -96.89727,
    city: "Ripley",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 873,
    density: 10.6,
    county_fips: 40119,
    county_name: "Payne",
    county_weights: {
      40119: 100,
    },
    county_names_all: "Payne",
    county_fips_all: 40119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74063,
    lat: 36.15201,
    lng: -96.19206,
    city: "Sand Springs",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31487,
    density: 93.6,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40037: 9.02,
      40113: 41.56,
      40143: 49.42,
    },
    county_names_all: "Tulsa|Osage|Creek",
    county_fips_all: "40143|40113|40037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74066,
    lat: 35.99379,
    lng: -96.1676,
    city: "Sapulpa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33179,
    density: 103.6,
    county_fips: 40037,
    county_name: "Creek",
    county_weights: {
      40037: 100,
    },
    county_names_all: "Creek",
    county_fips_all: 40037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74068,
    lat: 35.90829,
    lng: -96.57498,
    city: "Shamrock",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31,
    density: 16.1,
    county_fips: 40037,
    county_name: "Creek",
    county_weights: {
      40037: 100,
    },
    county_names_all: "Creek",
    county_fips_all: 40037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74070,
    lat: 36.3881,
    lng: -96.07253,
    city: "Skiatook",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14864,
    density: 29.3,
    county_fips: 40113,
    county_name: "Osage",
    county_weights: {
      40113: 75.44,
      40143: 16.41,
      40147: 8.15,
    },
    county_names_all: "Osage|Tulsa|Washington",
    county_fips_all: "40113|40143|40147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74071,
    lat: 35.77835,
    lng: -96.26467,
    city: "Slick",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 147,
    density: 24.5,
    county_fips: 40037,
    county_name: "Creek",
    county_weights: {
      40037: 100,
    },
    county_names_all: "Creek",
    county_fips_all: 40037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74072,
    lat: 36.94209,
    lng: -95.54436,
    city: "S Coffeyville",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1807,
    density: 6.3,
    county_fips: 40105,
    county_name: "Nowata",
    county_weights: {
      40035: 11.99,
      40105: 88.01,
    },
    county_names_all: "Nowata|Craig",
    county_fips_all: "40105|40035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74073,
    lat: 36.29818,
    lng: -96.01326,
    city: "Sperry",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6012,
    density: 49.7,
    county_fips: 40113,
    county_name: "Osage",
    county_weights: {
      40113: 60.09,
      40143: 39.91,
    },
    county_names_all: "Osage|Tulsa",
    county_fips_all: "40113|40143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74074,
    lat: 36.07832,
    lng: -97.06452,
    city: "Stillwater",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32339,
    density: 98,
    county_fips: 40119,
    county_name: "Payne",
    county_weights: {
      40119: 100,
    },
    county_names_all: "Payne",
    county_fips_all: 40119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74075,
    lat: 36.17151,
    lng: -97.0774,
    city: "Stillwater",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27347,
    density: 111.3,
    county_fips: 40119,
    county_name: "Payne",
    county_weights: {
      40103: 11.42,
      40119: 88.58,
    },
    county_names_all: "Payne|Noble",
    county_fips_all: "40119|40103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74077,
    lat: 36.12398,
    lng: -97.06901,
    city: "Stillwater",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 40119,
    county_name: "Payne",
    county_weights: {
      40119: 100,
    },
    county_names_all: "Payne",
    county_fips_all: 40119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74078,
    lat: 36.12528,
    lng: -97.07969,
    city: "Stillwater",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2082,
    density: 5827.8,
    county_fips: 40119,
    county_name: "Payne",
    county_weights: {
      40119: 100,
    },
    county_names_all: "Payne",
    county_fips_all: 40119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74079,
    lat: 35.74368,
    lng: -96.65592,
    city: "Stroud",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4218,
    density: 8.7,
    county_fips: 40081,
    county_name: "Lincoln",
    county_weights: {
      40037: 29.12,
      40081: 69.74,
      40107: 1.14,
    },
    county_names_all: "Lincoln|Creek|Okfuskee",
    county_fips_all: "40081|40037|40107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74080,
    lat: 36.52849,
    lng: -95.74192,
    city: "Talala",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2862,
    density: 11.2,
    county_fips: 40131,
    county_name: "Rogers",
    county_weights: {
      40131: 87.06,
      40147: 12.94,
    },
    county_names_all: "Rogers|Washington",
    county_fips_all: "40131|40147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74081,
    lat: 36.17536,
    lng: -96.45875,
    city: "Terlton",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1875,
    density: 20.7,
    county_fips: 40117,
    county_name: "Pawnee",
    county_weights: {
      40037: 32.57,
      40117: 67.43,
    },
    county_names_all: "Pawnee|Creek",
    county_fips_all: "40117|40037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74082,
    lat: 36.44889,
    lng: -95.88091,
    city: "Vera",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63,
    density: 133.4,
    county_fips: 40147,
    county_name: "Washington",
    county_weights: {
      40147: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 40147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74083,
    lat: 36.91504,
    lng: -95.77093,
    city: "Wann",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1040,
    density: 3.7,
    county_fips: 40105,
    county_name: "Nowata",
    county_weights: {
      40105: 69.73,
      40147: 30.27,
    },
    county_names_all: "Nowata|Washington",
    county_fips_all: "40105|40147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74084,
    lat: 36.52849,
    lng: -96.33325,
    city: "Wynona",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 439,
    density: 3.4,
    county_fips: 40113,
    county_name: "Osage",
    county_weights: {
      40113: 100,
    },
    county_names_all: "Osage",
    county_fips_all: 40113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74085,
    lat: 36.10795,
    lng: -96.715,
    city: "Yale",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2143,
    density: 8.5,
    county_fips: 40119,
    county_name: "Payne",
    county_weights: {
      40037: 4.87,
      40117: 8.24,
      40119: 86.89,
    },
    county_names_all: "Payne|Pawnee|Creek",
    county_fips_all: "40119|40117|40037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74103,
    lat: 36.15617,
    lng: -95.9957,
    city: "Tulsa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2092,
    density: 1235.6,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40143: 100,
    },
    county_names_all: "Tulsa",
    county_fips_all: 40143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74104,
    lat: 36.14627,
    lng: -95.9542,
    city: "Tulsa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11599,
    density: 1652.6,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40143: 100,
    },
    county_names_all: "Tulsa",
    county_fips_all: 40143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74105,
    lat: 36.0975,
    lng: -95.9641,
    city: "Tulsa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25857,
    density: 1373.7,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40143: 100,
    },
    county_names_all: "Tulsa",
    county_fips_all: 40143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74106,
    lat: 36.19191,
    lng: -95.98416,
    city: "Tulsa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17104,
    density: 864.7,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40113: 0.86,
      40143: 99.14,
    },
    county_names_all: "Tulsa|Osage",
    county_fips_all: "40143|40113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74107,
    lat: 36.10737,
    lng: -96.04095,
    city: "Tulsa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19704,
    density: 299.8,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40143: 100,
    },
    county_names_all: "Tulsa",
    county_fips_all: 40143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74108,
    lat: 36.14723,
    lng: -95.79154,
    city: "Tulsa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7928,
    density: 352.7,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40143: 86.12,
      40145: 13.88,
    },
    county_names_all: "Tulsa|Wagoner",
    county_fips_all: "40143|40145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74110,
    lat: 36.18856,
    lng: -95.95377,
    city: "Tulsa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14882,
    density: 977.6,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40143: 100,
    },
    county_names_all: "Tulsa",
    county_fips_all: 40143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74112,
    lat: 36.14696,
    lng: -95.90437,
    city: "Tulsa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21261,
    density: 1204.1,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40143: 100,
    },
    county_names_all: "Tulsa",
    county_fips_all: 40143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74114,
    lat: 36.12696,
    lng: -95.94661,
    city: "Tulsa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16290,
    density: 1302,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40143: 100,
    },
    county_names_all: "Tulsa",
    county_fips_all: 40143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74115,
    lat: 36.1923,
    lng: -95.90903,
    city: "Tulsa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23340,
    density: 562.4,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40143: 100,
    },
    county_names_all: "Tulsa",
    county_fips_all: 40143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74116,
    lat: 36.18814,
    lng: -95.83621,
    city: "Tulsa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3551,
    density: 76.2,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40131: 19.2,
      40143: 80.8,
    },
    county_names_all: "Tulsa|Rogers",
    county_fips_all: "40143|40131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74117,
    lat: 36.24146,
    lng: -95.89854,
    city: "Tulsa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32,
    density: 1.1,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40143: 100,
    },
    county_names_all: "Tulsa",
    county_fips_all: 40143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74119,
    lat: 36.14205,
    lng: -95.9894,
    city: "Tulsa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2900,
    density: 1435.5,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40143: 100,
    },
    county_names_all: "Tulsa",
    county_fips_all: 40143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74120,
    lat: 36.1504,
    lng: -95.97689,
    city: "Tulsa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4816,
    density: 883.5,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40143: 100,
    },
    county_names_all: "Tulsa",
    county_fips_all: 40143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74126,
    lat: 36.23502,
    lng: -96.0331,
    city: "Tulsa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10650,
    density: 170.9,
    county_fips: 40113,
    county_name: "Osage",
    county_weights: {
      40113: 74.37,
      40143: 25.63,
    },
    county_names_all: "Osage|Tulsa",
    county_fips_all: "40113|40143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74127,
    lat: 36.17462,
    lng: -96.04511,
    city: "Tulsa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15858,
    density: 287.1,
    county_fips: 40113,
    county_name: "Osage",
    county_weights: {
      40113: 70.56,
      40143: 29.44,
    },
    county_names_all: "Osage|Tulsa",
    county_fips_all: "40113|40143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74128,
    lat: 36.1472,
    lng: -95.85089,
    city: "Tulsa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13327,
    density: 1431.8,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40143: 100,
    },
    county_names_all: "Tulsa",
    county_fips_all: 40143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74129,
    lat: 36.12669,
    lng: -95.8701,
    city: "Tulsa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19223,
    density: 1862.2,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40143: 100,
    },
    county_names_all: "Tulsa",
    county_fips_all: 40143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74130,
    lat: 36.24172,
    lng: -95.95536,
    city: "Tulsa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1958,
    density: 182.8,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40143: 100,
    },
    county_names_all: "Tulsa",
    county_fips_all: 40143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74131,
    lat: 36.05172,
    lng: -96.07291,
    city: "Tulsa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2577,
    density: 103.9,
    county_fips: 40037,
    county_name: "Creek",
    county_weights: {
      40037: 99.88,
      40143: 0.12,
    },
    county_names_all: "Creek|Tulsa",
    county_fips_all: "40037|40143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74132,
    lat: 36.04869,
    lng: -96.01315,
    city: "Tulsa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9914,
    density: 303.6,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40037: 24.94,
      40143: 75.06,
    },
    county_names_all: "Tulsa|Creek",
    county_fips_all: "40143|40037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74133,
    lat: 36.04113,
    lng: -95.87955,
    city: "Tulsa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45958,
    density: 1298.4,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40143: 100,
    },
    county_names_all: "Tulsa",
    county_fips_all: 40143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74134,
    lat: 36.1106,
    lng: -95.80156,
    city: "Tulsa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17681,
    density: 565.5,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40143: 100,
    },
    county_names_all: "Tulsa",
    county_fips_all: 40143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74135,
    lat: 36.09725,
    lng: -95.92315,
    city: "Tulsa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19415,
    density: 1219.5,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40143: 100,
    },
    county_names_all: "Tulsa",
    county_fips_all: 40143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74136,
    lat: 36.06188,
    lng: -95.9419,
    city: "Tulsa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32139,
    density: 1604.3,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40143: 100,
    },
    county_names_all: "Tulsa",
    county_fips_all: 40143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74137,
    lat: 36.02038,
    lng: -95.92932,
    city: "Tulsa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27341,
    density: 1015,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40143: 100,
    },
    county_names_all: "Tulsa",
    county_fips_all: 40143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74145,
    lat: 36.09728,
    lng: -95.88731,
    city: "Tulsa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18957,
    density: 1231.5,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40143: 100,
    },
    county_names_all: "Tulsa",
    county_fips_all: 40143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74146,
    lat: 36.09784,
    lng: -95.85344,
    city: "Tulsa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16143,
    density: 1213.3,
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40143: 100,
    },
    county_names_all: "Tulsa",
    county_fips_all: 40143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74171,
    lat: 36.05064,
    lng: -95.95253,
    city: "Tulsa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 40143,
    county_name: "Tulsa",
    county_weights: {
      40143: 100,
    },
    county_names_all: "Tulsa",
    county_fips_all: 40143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74301,
    lat: 36.68157,
    lng: -95.23687,
    city: "Vinita",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11653,
    density: 11.5,
    county_fips: 40035,
    county_name: "Craig",
    county_weights: {
      40035: 93.76,
      40097: 3.74,
      40105: 2.5,
    },
    county_names_all: "Craig|Mayes|Nowata",
    county_fips_all: "40035|40097|40105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74330,
    lat: 36.4404,
    lng: -95.26851,
    city: "Adair",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2741,
    density: 11,
    county_fips: 40097,
    county_name: "Mayes",
    county_weights: {
      40035: 5.12,
      40097: 94.88,
    },
    county_names_all: "Mayes|Craig",
    county_fips_all: "40097|40035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74331,
    lat: 36.64683,
    lng: -94.9459,
    city: "Afton",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7456,
    density: 23.2,
    county_fips: 40041,
    county_name: "Delaware",
    county_weights: {
      40035: 14.13,
      40041: 57.76,
      40115: 28.11,
    },
    county_names_all: "Delaware|Ottawa|Craig",
    county_fips_all: "40041|40115|40035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74332,
    lat: 36.52111,
    lng: -95.23864,
    city: "Big Cabin",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1610,
    density: 8.9,
    county_fips: 40035,
    county_name: "Craig",
    county_weights: {
      40035: 43.56,
      40097: 35.85,
      40131: 20.59,
    },
    county_names_all: "Craig|Mayes|Rogers",
    county_fips_all: "40035|40097|40131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74333,
    lat: 36.79386,
    lng: -95.08408,
    city: "Bluejacket",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 922,
    density: 3.9,
    county_fips: 40035,
    county_name: "Craig",
    county_weights: {
      40035: 87.94,
      40115: 12.06,
    },
    county_names_all: "Craig|Ottawa",
    county_fips_all: "40035|40115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74337,
    lat: 36.14122,
    lng: -95.33505,
    city: "Chouteau",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5112,
    density: 20.5,
    county_fips: 40097,
    county_name: "Mayes",
    county_weights: {
      40097: 88.22,
      40145: 11.78,
    },
    county_names_all: "Mayes|Wagoner",
    county_fips_all: "40097|40145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74338,
    lat: 36.26234,
    lng: -94.71572,
    city: "Colcord",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5744,
    density: 15.7,
    county_fips: 40041,
    county_name: "Delaware",
    county_weights: {
      40001: 0.26,
      40041: 99.74,
    },
    county_names_all: "Delaware|Adair",
    county_fips_all: "40041|40001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74339,
    lat: 36.934,
    lng: -94.87975,
    city: "Commerce",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2393,
    density: 270.5,
    county_fips: 40115,
    county_name: "Ottawa",
    county_weights: {
      40115: 100,
    },
    county_names_all: "Ottawa",
    county_fips_all: 40115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74340,
    lat: 36.4777,
    lng: -95.01944,
    city: "Disney",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 194,
    density: 65.8,
    county_fips: 40097,
    county_name: "Mayes",
    county_weights: {
      40097: 100,
    },
    county_names_all: "Mayes",
    county_fips_all: 40097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74342,
    lat: 36.42227,
    lng: -94.94113,
    city: "Eucha",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2793,
    density: 14.4,
    county_fips: 40041,
    county_name: "Delaware",
    county_weights: {
      40041: 97,
      40097: 3,
    },
    county_names_all: "Delaware|Mayes",
    county_fips_all: "40041|40097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74343,
    lat: 36.74287,
    lng: -94.825,
    city: "Fairland",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3084,
    density: 18.6,
    county_fips: 40115,
    county_name: "Ottawa",
    county_weights: {
      40115: 100,
    },
    county_names_all: "Ottawa",
    county_fips_all: 40115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74344,
    lat: 36.59604,
    lng: -94.73845,
    city: "Grove",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15381,
    density: 66.3,
    county_fips: 40041,
    county_name: "Delaware",
    county_weights: {
      40041: 97.77,
      40115: 2.23,
    },
    county_names_all: "Delaware|Ottawa",
    county_fips_all: "40041|40115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74346,
    lat: 36.43427,
    lng: -94.75066,
    city: "Jay",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7487,
    density: 12.7,
    county_fips: 40041,
    county_name: "Delaware",
    county_weights: {
      40041: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 40041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74347,
    lat: 36.19573,
    lng: -94.78525,
    city: "Kansas",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2456,
    density: 18.1,
    county_fips: 40041,
    county_name: "Delaware",
    county_weights: {
      40001: 12.79,
      40021: 7.84,
      40041: 79.37,
    },
    county_names_all: "Delaware|Adair|Cherokee",
    county_fips_all: "40041|40001|40021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74349,
    lat: 36.51234,
    lng: -95.02557,
    city: "Ketchum",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 287,
    density: 16.8,
    county_fips: 40035,
    county_name: "Craig",
    county_weights: {
      40035: 53.38,
      40097: 46.62,
    },
    county_names_all: "Craig|Mayes",
    county_fips_all: "40035|40097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74350,
    lat: 36.46643,
    lng: -95.04776,
    city: "Langley",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 668,
    density: 42.4,
    county_fips: 40097,
    county_name: "Mayes",
    county_weights: {
      40097: 100,
    },
    county_names_all: "Mayes",
    county_fips_all: 40097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74352,
    lat: 36.13693,
    lng: -95.18783,
    city: "Locust Grove",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6279,
    density: 19.6,
    county_fips: 40097,
    county_name: "Mayes",
    county_weights: {
      40021: 5.96,
      40097: 78.81,
      40145: 15.23,
    },
    county_names_all: "Mayes|Wagoner|Cherokee",
    county_fips_all: "40097|40145|40021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74354,
    lat: 36.88962,
    lng: -94.88096,
    city: "Miami",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17735,
    density: 37.2,
    county_fips: 40115,
    county_name: "Ottawa",
    county_weights: {
      40035: 3.21,
      40115: 96.79,
    },
    county_names_all: "Ottawa|Craig",
    county_fips_all: "40115|40035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74358,
    lat: 36.91798,
    lng: -94.88052,
    city: "North Miami",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 219,
    density: 630.6,
    county_fips: 40115,
    county_name: "Ottawa",
    county_weights: {
      40115: 100,
    },
    county_names_all: "Ottawa",
    county_fips_all: 40115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74359,
    lat: 36.16846,
    lng: -94.85218,
    city: "Oaks",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 663,
    density: 116.6,
    county_fips: 40041,
    county_name: "Delaware",
    county_weights: {
      40021: 5.36,
      40041: 94.64,
    },
    county_names_all: "Delaware|Cherokee",
    county_fips_all: "40041|40021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74360,
    lat: 36.9801,
    lng: -94.83636,
    city: "Picher",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25,
    density: 2,
    county_fips: 40115,
    county_name: "Ottawa",
    county_weights: {
      40115: 100,
    },
    county_names_all: "Ottawa",
    county_fips_all: 40115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74361,
    lat: 36.30914,
    lng: -95.30732,
    city: "Pryor",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17255,
    density: 40.7,
    county_fips: 40097,
    county_name: "Mayes",
    county_weights: {
      40097: 100,
    },
    county_names_all: "Mayes",
    county_fips_all: 40097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74363,
    lat: 36.95341,
    lng: -94.70965,
    city: "Quapaw",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2832,
    density: 16.7,
    county_fips: 40115,
    county_name: "Ottawa",
    county_weights: {
      40115: 100,
    },
    county_names_all: "Ottawa",
    county_fips_all: 40115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74364,
    lat: 36.19915,
    lng: -94.95683,
    city: "Rose",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1961,
    density: 7.7,
    county_fips: 40041,
    county_name: "Delaware",
    county_weights: {
      40021: 21.03,
      40041: 66.05,
      40097: 12.92,
    },
    county_names_all: "Delaware|Cherokee|Mayes",
    county_fips_all: "40041|40021|40097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74365,
    lat: 36.29072,
    lng: -95.05461,
    city: "Salina",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4478,
    density: 21,
    county_fips: 40097,
    county_name: "Mayes",
    county_weights: {
      40041: 25.11,
      40097: 74.89,
    },
    county_names_all: "Mayes|Delaware",
    county_fips_all: "40097|40041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74366,
    lat: 36.37887,
    lng: -95.04449,
    city: "Spavinaw",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1434,
    density: 15.4,
    county_fips: 40097,
    county_name: "Mayes",
    county_weights: {
      40041: 10.07,
      40097: 89.93,
    },
    county_names_all: "Mayes|Delaware",
    county_fips_all: "40097|40041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74367,
    lat: 36.4222,
    lng: -95.10674,
    city: "Strang",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 482,
    density: 8.8,
    county_fips: 40097,
    county_name: "Mayes",
    county_weights: {
      40097: 100,
    },
    county_names_all: "Mayes",
    county_fips_all: 40097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74368,
    lat: 36.20725,
    lng: -94.84822,
    city: "Twin Oaks",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 91,
    density: 33.7,
    county_fips: 40041,
    county_name: "Delaware",
    county_weights: {
      40041: 100,
    },
    county_names_all: "Delaware",
    county_fips_all: 40041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74369,
    lat: 36.92237,
    lng: -95.19776,
    city: "Welch",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1958,
    density: 3.5,
    county_fips: 40035,
    county_name: "Craig",
    county_weights: {
      40035: 100,
    },
    county_names_all: "Craig",
    county_fips_all: 40035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74370,
    lat: 36.76429,
    lng: -94.68017,
    city: "Wyandotte",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3857,
    density: 13.8,
    county_fips: 40115,
    county_name: "Ottawa",
    county_weights: {
      40041: 7.51,
      40115: 92.49,
    },
    county_names_all: "Ottawa|Delaware",
    county_fips_all: "40115|40041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74401,
    lat: 35.72304,
    lng: -95.45431,
    city: "Muskogee",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15761,
    density: 54.9,
    county_fips: 40101,
    county_name: "Muskogee",
    county_weights: {
      40101: 100,
    },
    county_names_all: "Muskogee",
    county_fips_all: 40101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74403,
    lat: 35.67427,
    lng: -95.305,
    city: "Muskogee",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30742,
    density: 108.2,
    county_fips: 40101,
    county_name: "Muskogee",
    county_weights: {
      40101: 94.76,
      40145: 5.24,
    },
    county_names_all: "Muskogee|Wagoner",
    county_fips_all: "40101|40145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74421,
    lat: 35.75928,
    lng: -96.03615,
    city: "Beggs",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4433,
    density: 13,
    county_fips: 40111,
    county_name: "Okmulgee",
    county_weights: {
      40037: 1.37,
      40111: 98.63,
    },
    county_names_all: "Okmulgee|Creek",
    county_fips_all: "40111|40037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74422,
    lat: 35.64156,
    lng: -95.69143,
    city: "Boynton",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 924,
    density: 4.4,
    county_fips: 40101,
    county_name: "Muskogee",
    county_weights: {
      40101: 57.3,
      40111: 42.7,
    },
    county_names_all: "Muskogee|Okmulgee",
    county_fips_all: "40101|40111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74423,
    lat: 35.64251,
    lng: -95.22339,
    city: "Braggs",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 911,
    density: 15.1,
    county_fips: 40101,
    county_name: "Muskogee",
    county_weights: {
      40101: 100,
    },
    county_names_all: "Muskogee",
    county_fips_all: 40101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74425,
    lat: 35.17184,
    lng: -95.62299,
    city: "Canadian",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1166,
    density: 49.8,
    county_fips: 40121,
    county_name: "Pittsburg",
    county_weights: {
      40121: 100,
    },
    county_names_all: "Pittsburg",
    county_fips_all: 40121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74426,
    lat: 35.44553,
    lng: -95.52759,
    city: "Checotah",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9081,
    density: 15.9,
    county_fips: 40091,
    county_name: "McIntosh",
    county_weights: {
      40091: 99.84,
      40101: 0.16,
    },
    county_names_all: "McIntosh|Muskogee",
    county_fips_all: "40091|40101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74427,
    lat: 35.68638,
    lng: -94.91056,
    city: "Cookson",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1293,
    density: 13.1,
    county_fips: 40021,
    county_name: "Cherokee",
    county_weights: {
      40021: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 40021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74428,
    lat: 35.54835,
    lng: -95.64683,
    city: "Council Hill",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1132,
    density: 8,
    county_fips: 40091,
    county_name: "McIntosh",
    county_weights: {
      40091: 53.44,
      40101: 46.56,
    },
    county_names_all: "McIntosh|Muskogee",
    county_fips_all: "40091|40101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74429,
    lat: 35.94872,
    lng: -95.63065,
    city: "Coweta",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15388,
    density: 70.5,
    county_fips: 40145,
    county_name: "Wagoner",
    county_weights: {
      40145: 100,
    },
    county_names_all: "Wagoner",
    county_fips_all: 40145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74430,
    lat: 35.13175,
    lng: -95.64826,
    city: "Crowder",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 504,
    density: 28.7,
    county_fips: 40121,
    county_name: "Pittsburg",
    county_weights: {
      40121: 100,
    },
    county_names_all: "Pittsburg",
    county_fips_all: 40121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74431,
    lat: 35.45743,
    lng: -95.93934,
    city: "Dewar",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 851,
    density: 74.7,
    county_fips: 40111,
    county_name: "Okmulgee",
    county_weights: {
      40111: 100,
    },
    county_names_all: "Okmulgee",
    county_fips_all: 40111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74432,
    lat: 35.28371,
    lng: -95.64911,
    city: "Eufaula",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10197,
    density: 18.8,
    county_fips: 40091,
    county_name: "McIntosh",
    county_weights: {
      40091: 79.37,
      40121: 20.63,
    },
    county_names_all: "McIntosh|Pittsburg",
    county_fips_all: "40091|40121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74434,
    lat: 35.78174,
    lng: -95.20027,
    city: "Fort Gibson",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9209,
    density: 28.9,
    county_fips: 40101,
    county_name: "Muskogee",
    county_weights: {
      40021: 26.06,
      40101: 61.32,
      40145: 12.62,
    },
    county_names_all: "Muskogee|Cherokee|Wagoner",
    county_fips_all: "40101|40021|40145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74435,
    lat: 35.57862,
    lng: -95.09405,
    city: "Gore",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3622,
    density: 22.3,
    county_fips: 40135,
    county_name: "Sequoyah",
    county_weights: {
      40101: 25.6,
      40135: 74.4,
    },
    county_names_all: "Sequoyah|Muskogee",
    county_fips_all: "40135|40101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74436,
    lat: 35.80034,
    lng: -95.70175,
    city: "Haskell",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5431,
    density: 14.7,
    county_fips: 40101,
    county_name: "Muskogee",
    county_weights: {
      40101: 64.05,
      40111: 14.68,
      40145: 21.27,
    },
    county_names_all: "Muskogee|Wagoner|Okmulgee",
    county_fips_all: "40101|40145|40111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74437,
    lat: 35.44825,
    lng: -95.94417,
    city: "Henryetta",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9945,
    density: 20.2,
    county_fips: 40111,
    county_name: "Okmulgee",
    county_weights: {
      40091: 26.36,
      40107: 6.45,
      40111: 67.19,
    },
    county_names_all: "Okmulgee|McIntosh|Okfuskee",
    county_fips_all: "40111|40091|40107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74438,
    lat: 35.51382,
    lng: -95.75935,
    city: "Hitchita",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 120,
    density: 2.2,
    county_fips: 40091,
    county_name: "McIntosh",
    county_weights: {
      40091: 100,
    },
    county_names_all: "McIntosh",
    county_fips_all: 40091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74441,
    lat: 35.97458,
    lng: -95.14613,
    city: "Hulbert",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5754,
    density: 14.9,
    county_fips: 40021,
    county_name: "Cherokee",
    county_weights: {
      40021: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 40021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74442,
    lat: 35.12983,
    lng: -95.8151,
    city: "Indianola",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 924,
    density: 5.3,
    county_fips: 40121,
    county_name: "Pittsburg",
    county_weights: {
      40121: 100,
    },
    county_names_all: "Pittsburg",
    county_fips_all: 40121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74445,
    lat: 35.62729,
    lng: -95.82605,
    city: "Morris",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3331,
    density: 15.8,
    county_fips: 40111,
    county_name: "Okmulgee",
    county_weights: {
      40091: 2.31,
      40111: 97.69,
    },
    county_names_all: "Okmulgee|McIntosh",
    county_fips_all: "40111|40091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74446,
    lat: 35.85117,
    lng: -95.32264,
    city: "Okay",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 475,
    density: 137.6,
    county_fips: 40145,
    county_name: "Wagoner",
    county_weights: {
      40145: 100,
    },
    county_names_all: "Wagoner",
    county_fips_all: 40145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74447,
    lat: 35.64975,
    lng: -96.00628,
    city: "Okmulgee",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16101,
    density: 26.8,
    county_fips: 40111,
    county_name: "Okmulgee",
    county_weights: {
      40111: 100,
    },
    county_names_all: "Okmulgee",
    county_fips_all: 40111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74450,
    lat: 35.59714,
    lng: -95.47541,
    city: "Oktaha",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1446,
    density: 8.4,
    county_fips: 40101,
    county_name: "Muskogee",
    county_weights: {
      40101: 100,
    },
    county_names_all: "Muskogee",
    county_fips_all: 40101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74451,
    lat: 35.72886,
    lng: -95.00166,
    city: "Park Hill",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4126,
    density: 18,
    county_fips: 40021,
    county_name: "Cherokee",
    county_weights: {
      40021: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 40021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74452,
    lat: 36.12137,
    lng: -95.06829,
    city: "Peggs",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 464,
    density: 7,
    county_fips: 40021,
    county_name: "Cherokee",
    county_weights: {
      40021: 91.79,
      40097: 8.21,
    },
    county_names_all: "Cherokee|Mayes",
    county_fips_all: "40021|40097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74454,
    lat: 35.85464,
    lng: -95.51253,
    city: "Porter",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3466,
    density: 12.6,
    county_fips: 40145,
    county_name: "Wagoner",
    county_weights: {
      40145: 100,
    },
    county_names_all: "Wagoner",
    county_fips_all: 40145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74455,
    lat: 35.36238,
    lng: -95.26867,
    city: "Porum",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3039,
    density: 10.1,
    county_fips: 40101,
    county_name: "Muskogee",
    county_weights: {
      40091: 13.08,
      40101: 86.92,
    },
    county_names_all: "Muskogee|McIntosh",
    county_fips_all: "40101|40091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74456,
    lat: 35.71083,
    lng: -95.99262,
    city: "Preston",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 226,
    density: 352.1,
    county_fips: 40111,
    county_name: "Okmulgee",
    county_weights: {
      40111: 100,
    },
    county_names_all: "Okmulgee",
    county_fips_all: 40111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74457,
    lat: 36.03063,
    lng: -94.82065,
    city: "Proctor",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 317,
    density: 1.7,
    county_fips: 40021,
    county_name: "Cherokee",
    county_weights: {
      40001: 37.92,
      40021: 62.08,
    },
    county_names_all: "Cherokee|Adair",
    county_fips_all: "40021|40001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74458,
    lat: 35.88231,
    lng: -95.58786,
    city: "Redbird",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 78,
    density: 11.8,
    county_fips: 40145,
    county_name: "Wagoner",
    county_weights: {
      40145: 100,
    },
    county_names_all: "Wagoner",
    county_fips_all: 40145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74459,
    lat: 35.51878,
    lng: -95.49217,
    city: "Rentiesville",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56,
    density: 21.7,
    county_fips: 40091,
    county_name: "McIntosh",
    county_weights: {
      40091: 100,
    },
    county_names_all: "McIntosh",
    county_fips_all: 40091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74460,
    lat: 35.50473,
    lng: -95.96452,
    city: "Schulter",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 181,
    density: 33.2,
    county_fips: 40111,
    county_name: "Okmulgee",
    county_weights: {
      40111: 100,
    },
    county_names_all: "Okmulgee",
    county_fips_all: 40111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74462,
    lat: 35.28328,
    lng: -95.15041,
    city: "Stigler",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7595,
    density: 10.9,
    county_fips: 40061,
    county_name: "Haskell",
    county_weights: {
      40061: 96.71,
      40121: 3.29,
    },
    county_names_all: "Haskell|Pittsburg",
    county_fips_all: "40061|40121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74463,
    lat: 35.76943,
    lng: -95.54843,
    city: "Taft",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2089,
    density: 145.9,
    county_fips: 40101,
    county_name: "Muskogee",
    county_weights: {
      40101: 100,
    },
    county_names_all: "Muskogee",
    county_fips_all: 40101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74464,
    lat: 35.94419,
    lng: -94.97365,
    city: "Tahlequah",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31889,
    density: 48.5,
    county_fips: 40021,
    county_name: "Cherokee",
    county_weights: {
      40021: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 40021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74467,
    lat: 35.96681,
    lng: -95.39181,
    city: "Wagoner",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15162,
    density: 38,
    county_fips: 40145,
    county_name: "Wagoner",
    county_weights: {
      40145: 100,
    },
    county_names_all: "Wagoner",
    county_fips_all: 40145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74468,
    lat: 35.62121,
    lng: -95.59025,
    city: "Wainwright",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 274,
    density: 8.7,
    county_fips: 40101,
    county_name: "Muskogee",
    county_weights: {
      40101: 100,
    },
    county_names_all: "Muskogee",
    county_fips_all: 40101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74469,
    lat: 35.5083,
    lng: -95.31545,
    city: "Warner",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2251,
    density: 16.3,
    county_fips: 40101,
    county_name: "Muskogee",
    county_weights: {
      40091: 11.55,
      40101: 88.45,
    },
    county_names_all: "Muskogee|McIntosh",
    county_fips_all: "40101|40091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74470,
    lat: 35.47906,
    lng: -95.16879,
    city: "Webbers Falls",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1642,
    density: 7.9,
    county_fips: 40101,
    county_name: "Muskogee",
    county_weights: {
      40101: 100,
    },
    county_names_all: "Muskogee",
    county_fips_all: 40101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74471,
    lat: 35.82749,
    lng: -94.86454,
    city: "Welling",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1690,
    density: 14.2,
    county_fips: 40021,
    county_name: "Cherokee",
    county_weights: {
      40021: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 40021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74472,
    lat: 35.25028,
    lng: -95.263,
    city: "Whitefield",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 678,
    density: 20.2,
    county_fips: 40061,
    county_name: "Haskell",
    county_weights: {
      40061: 100,
    },
    county_names_all: "Haskell",
    county_fips_all: 40061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74477,
    lat: 36.00394,
    lng: -95.26644,
    city: "Wagoner",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10,
    density: 105.4,
    county_fips: 40145,
    county_name: "Wagoner",
    county_weights: {
      40145: 100,
    },
    county_names_all: "Wagoner",
    county_fips_all: 40145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74501,
    lat: 34.98501,
    lng: -95.78597,
    city: "Mcalester",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28019,
    density: 19.6,
    county_fips: 40121,
    county_name: "Pittsburg",
    county_weights: {
      40121: 100,
    },
    county_names_all: "Pittsburg",
    county_fips_all: 40121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74521,
    lat: 34.66222,
    lng: -95.09934,
    city: "Albion",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 229,
    density: 374.9,
    county_fips: 40127,
    county_name: "Pushmataha",
    county_weights: {
      40127: 100,
    },
    county_names_all: "Pushmataha",
    county_fips_all: 40127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74522,
    lat: 34.88253,
    lng: -95.6767,
    city: "Alderson",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 40121,
    county_name: "Pittsburg",
    county_weights: {
      40121: 100,
    },
    county_names_all: "Pittsburg",
    county_fips_all: 40121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74523,
    lat: 34.25171,
    lng: -95.60018,
    city: "Antlers",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5298,
    density: 7.6,
    county_fips: 40127,
    county_name: "Pushmataha",
    county_weights: {
      40005: 1.68,
      40023: 5.56,
      40127: 92.76,
    },
    county_names_all: "Pushmataha|Choctaw|Atoka",
    county_fips_all: "40127|40023|40005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74525,
    lat: 34.33441,
    lng: -96.05563,
    city: "Atoka",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9345,
    density: 8.3,
    county_fips: 40005,
    county_name: "Atoka",
    county_weights: {
      40005: 99.15,
      40029: 0.85,
    },
    county_names_all: "Atoka|Coal",
    county_fips_all: "40005|40029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74528,
    lat: 34.71644,
    lng: -95.723,
    city: "Blanco",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 168,
    density: 2.2,
    county_fips: 40121,
    county_name: "Pittsburg",
    county_weights: {
      40121: 100,
    },
    county_names_all: "Pittsburg",
    county_fips_all: 40121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74530,
    lat: 34.42677,
    lng: -96.5152,
    city: "Bromide",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 185,
    density: 3.1,
    county_fips: 40069,
    county_name: "Johnston",
    county_weights: {
      40029: 34.8,
      40069: 65.2,
    },
    county_names_all: "Johnston|Coal",
    county_fips_all: "40069|40029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74531,
    lat: 34.8777,
    lng: -96.24035,
    city: "Calvin",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 957,
    density: 3.6,
    county_fips: 40063,
    county_name: "Hughes",
    county_weights: {
      40029: 5.25,
      40063: 94.75,
    },
    county_names_all: "Hughes|Coal",
    county_fips_all: "40063|40029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74533,
    lat: 34.20521,
    lng: -96.18893,
    city: "Caney",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1012,
    density: 9.1,
    county_fips: 40005,
    county_name: "Atoka",
    county_weights: {
      40005: 100,
    },
    county_names_all: "Atoka",
    county_fips_all: 40005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74534,
    lat: 34.61965,
    lng: -96.36634,
    city: "Centrahoma",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 127,
    density: 1.7,
    county_fips: 40029,
    county_name: "Coal",
    county_weights: {
      40029: 100,
    },
    county_names_all: "Coal",
    county_fips_all: 40029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74535,
    lat: 34.48384,
    lng: -96.44202,
    city: "Clarita",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 124,
    density: 10.4,
    county_fips: 40029,
    county_name: "Coal",
    county_weights: {
      40029: 100,
    },
    county_names_all: "Coal",
    county_fips_all: 40029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74536,
    lat: 34.55697,
    lng: -95.45955,
    city: "Clayton",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1617,
    density: 2.1,
    county_fips: 40127,
    county_name: "Pushmataha",
    county_weights: {
      40077: 6.42,
      40121: 3.26,
      40127: 90.32,
    },
    county_names_all: "Pushmataha|Latimer|Pittsburg",
    county_fips_all: "40127|40077|40121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74538,
    lat: 34.57453,
    lng: -96.25575,
    city: "Coalgate",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4062,
    density: 4.3,
    county_fips: 40029,
    county_name: "Coal",
    county_weights: {
      40005: 0.89,
      40029: 99.11,
    },
    county_names_all: "Coal|Atoka",
    county_fips_all: "40029|40005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74540,
    lat: 34.55776,
    lng: -95.70167,
    city: "Daisy",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 165,
    density: 1.6,
    county_fips: 40005,
    county_name: "Atoka",
    county_weights: {
      40005: 79.65,
      40127: 20.35,
    },
    county_names_all: "Atoka|Pushmataha",
    county_fips_all: "40005|40127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74543,
    lat: 34.35927,
    lng: -95.37907,
    city: "Finley",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 364,
    density: 1.1,
    county_fips: 40127,
    county_name: "Pushmataha",
    county_weights: {
      40127: 100,
    },
    county_names_all: "Pushmataha",
    county_fips_all: 40127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74546,
    lat: 34.85186,
    lng: -95.58001,
    city: "Haileyville",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 694,
    density: 115.1,
    county_fips: 40121,
    county_name: "Pittsburg",
    county_weights: {
      40121: 100,
    },
    county_names_all: "Pittsburg",
    county_fips_all: 40121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74547,
    lat: 34.81019,
    lng: -95.59782,
    city: "Hartshorne",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3296,
    density: 12.2,
    county_fips: 40121,
    county_name: "Pittsburg",
    county_weights: {
      40077: 3.84,
      40121: 96.16,
    },
    county_names_all: "Pittsburg|Latimer",
    county_fips_all: "40121|40077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74549,
    lat: 34.57483,
    lng: -94.90993,
    city: "Honobia",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 72,
    density: 0.4,
    county_fips: 40079,
    county_name: "Le Flore",
    county_weights: {
      40079: 65.41,
      40127: 34.59,
    },
    county_names_all: "Le Flore|Pushmataha",
    county_fips_all: "40079|40127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74552,
    lat: 35.11282,
    lng: -95.24734,
    city: "Kinta",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1193,
    density: 5.2,
    county_fips: 40061,
    county_name: "Haskell",
    county_weights: {
      40061: 99.23,
      40121: 0.77,
    },
    county_names_all: "Haskell|Pittsburg",
    county_fips_all: "40061|40121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74553,
    lat: 34.70808,
    lng: -95.91859,
    city: "Kiowa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1259,
    density: 6.2,
    county_fips: 40121,
    county_name: "Pittsburg",
    county_weights: {
      40005: 30.11,
      40121: 69.89,
    },
    county_names_all: "Pittsburg|Atoka",
    county_fips_all: "40121|40005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74554,
    lat: 34.92552,
    lng: -95.7203,
    city: "Krebs",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1785,
    density: 237.9,
    county_fips: 40121,
    county_name: "Pittsburg",
    county_weights: {
      40121: 100,
    },
    county_names_all: "Pittsburg",
    county_fips_all: 40121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74555,
    lat: 34.2459,
    lng: -95.96944,
    city: "Lane",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 602,
    density: 5.1,
    county_fips: 40005,
    county_name: "Atoka",
    county_weights: {
      40005: 100,
    },
    county_names_all: "Atoka",
    county_fips_all: 40005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74556,
    lat: 34.46102,
    lng: -96.19878,
    city: "Lehigh",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 367,
    density: 24.2,
    county_fips: 40029,
    county_name: "Coal",
    county_weights: {
      40029: 100,
    },
    county_names_all: "Coal",
    county_fips_all: 40029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74557,
    lat: 34.40355,
    lng: -95.69344,
    city: "Moyers",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 671,
    density: 2,
    county_fips: 40127,
    county_name: "Pushmataha",
    county_weights: {
      40127: 100,
    },
    county_names_all: "Pushmataha",
    county_fips_all: 40127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74558,
    lat: 34.49174,
    lng: -95.15081,
    city: "Nashoba",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 480,
    density: 2.4,
    county_fips: 40127,
    county_name: "Pushmataha",
    county_weights: {
      40127: 100,
    },
    county_names_all: "Pushmataha",
    county_fips_all: 40127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74560,
    lat: 34.64717,
    lng: -95.74679,
    city: "Pittsburg",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 482,
    density: 0.9,
    county_fips: 40121,
    county_name: "Pittsburg",
    county_weights: {
      40005: 20.5,
      40121: 79.5,
    },
    county_names_all: "Pittsburg|Atoka",
    county_fips_all: "40121|40005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74561,
    lat: 35.12489,
    lng: -95.42929,
    city: "Quinton",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1853,
    density: 5.5,
    county_fips: 40121,
    county_name: "Pittsburg",
    county_weights: {
      40061: 24.23,
      40121: 75.77,
    },
    county_names_all: "Pittsburg|Haskell",
    county_fips_all: "40121|40061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74562,
    lat: 34.29683,
    lng: -95.29637,
    city: "Rattan",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 966,
    density: 3.4,
    county_fips: 40127,
    county_name: "Pushmataha",
    county_weights: {
      40127: 100,
    },
    county_names_all: "Pushmataha",
    county_fips_all: 40127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74563,
    lat: 34.97903,
    lng: -95.07556,
    city: "Red Oak",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2065,
    density: 3.9,
    county_fips: 40077,
    county_name: "Latimer",
    county_weights: {
      40077: 93.69,
      40079: 6.31,
    },
    county_names_all: "Latimer|Le Flore",
    county_fips_all: "40077|40079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74565,
    lat: 34.82222,
    lng: -95.83301,
    city: "Savanna",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 574,
    density: 31.5,
    county_fips: 40121,
    county_name: "Pittsburg",
    county_weights: {
      40121: 100,
    },
    county_names_all: "Pittsburg",
    county_fips_all: 40121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74567,
    lat: 34.44871,
    lng: -95.35575,
    city: "Snow",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 147,
    density: 2.1,
    county_fips: 40127,
    county_name: "Pushmataha",
    county_weights: {
      40127: 100,
    },
    county_names_all: "Pushmataha",
    county_fips_all: 40127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74569,
    lat: 34.47921,
    lng: -95.90315,
    city: "Stringtown",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1248,
    density: 2.6,
    county_fips: 40005,
    county_name: "Atoka",
    county_weights: {
      40005: 100,
    },
    county_names_all: "Atoka",
    county_fips_all: 40005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74570,
    lat: 34.86574,
    lng: -96.10432,
    city: "Stuart",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1047,
    density: 2.6,
    county_fips: 40063,
    county_name: "Hughes",
    county_weights: {
      40063: 59.57,
      40121: 40.43,
    },
    county_names_all: "Hughes|Pittsburg",
    county_fips_all: "40063|40121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74571,
    lat: 34.71915,
    lng: -95.04948,
    city: "Talihina",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3854,
    density: 6.1,
    county_fips: 40077,
    county_name: "Latimer",
    county_weights: {
      40077: 42.9,
      40079: 41.35,
      40127: 15.74,
    },
    county_names_all: "Latimer|Le Flore|Pushmataha",
    county_fips_all: "40077|40079|40127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74572,
    lat: 34.63831,
    lng: -96.42594,
    city: "Tupelo",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 721,
    density: 6.3,
    county_fips: 40029,
    county_name: "Coal",
    county_weights: {
      40029: 83.23,
      40123: 16.77,
    },
    county_names_all: "Coal|Pontotoc",
    county_fips_all: "40029|40123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74574,
    lat: 34.67885,
    lng: -95.27335,
    city: "Tuskahoma",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1034,
    density: 2.8,
    county_fips: 40127,
    county_name: "Pushmataha",
    county_weights: {
      40077: 43.1,
      40127: 56.9,
    },
    county_names_all: "Pushmataha|Latimer",
    county_fips_all: "40127|40077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74576,
    lat: 34.67046,
    lng: -96.04259,
    city: "Wardville",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 194,
    density: 1.3,
    county_fips: 40005,
    county_name: "Atoka",
    county_weights: {
      40005: 55.05,
      40121: 44.95,
    },
    county_names_all: "Atoka|Pittsburg",
    county_fips_all: "40005|40121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74577,
    lat: 34.71967,
    lng: -94.85689,
    city: "Whitesboro",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 273,
    density: 3.7,
    county_fips: 40079,
    county_name: "Le Flore",
    county_weights: {
      40079: 100,
    },
    county_names_all: "Le Flore",
    county_fips_all: 40079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74578,
    lat: 34.90045,
    lng: -95.34872,
    city: "Wilburton",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5790,
    density: 7,
    county_fips: 40077,
    county_name: "Latimer",
    county_weights: {
      40077: 100,
    },
    county_names_all: "Latimer",
    county_fips_all: 40077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74601,
    lat: 36.70436,
    lng: -97.14604,
    city: "Ponca City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18837,
    density: 45.3,
    county_fips: 40071,
    county_name: "Kay",
    county_weights: {
      40071: 95.7,
      40103: 4.3,
    },
    county_names_all: "Kay|Noble",
    county_fips_all: "40071|40103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74604,
    lat: 36.69672,
    lng: -96.98132,
    city: "Ponca City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12378,
    density: 35.6,
    county_fips: 40071,
    county_name: "Kay",
    county_weights: {
      40071: 50.73,
      40113: 49.27,
    },
    county_names_all: "Kay|Osage",
    county_fips_all: "40071|40113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74630,
    lat: 36.49736,
    lng: -97.4296,
    city: "Billings",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 563,
    density: 1.8,
    county_fips: 40103,
    county_name: "Noble",
    county_weights: {
      40047: 26.69,
      40103: 73.31,
    },
    county_names_all: "Noble|Garfield",
    county_fips_all: "40103|40047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74631,
    lat: 36.79858,
    lng: -97.30585,
    city: "Blackwell",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7352,
    density: 27.5,
    county_fips: 40071,
    county_name: "Kay",
    county_weights: {
      40071: 100,
    },
    county_names_all: "Kay",
    county_fips_all: 40071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74632,
    lat: 36.93958,
    lng: -97.34144,
    city: "Braman",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 502,
    density: 1.8,
    county_fips: 40071,
    county_name: "Kay",
    county_weights: {
      40071: 100,
    },
    county_names_all: "Kay",
    county_fips_all: 40071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74633,
    lat: 36.70478,
    lng: -96.79216,
    city: "Burbank",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 700,
    density: 3,
    county_fips: 40113,
    county_name: "Osage",
    county_weights: {
      40113: 100,
    },
    county_names_all: "Osage",
    county_fips_all: 40113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74636,
    lat: 36.82257,
    lng: -97.52222,
    city: "Deer Creek",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 257,
    density: 1.8,
    county_fips: 40053,
    county_name: "Grant",
    county_weights: {
      40053: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 40053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74637,
    lat: 36.59083,
    lng: -96.68172,
    city: "Fairfax",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1600,
    density: 3.4,
    county_fips: 40113,
    county_name: "Osage",
    county_weights: {
      40113: 100,
    },
    county_names_all: "Osage",
    county_fips_all: 40113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74640,
    lat: 36.56589,
    lng: -97.65032,
    city: "Hunter",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 175,
    density: 0.7,
    county_fips: 40047,
    county_name: "Garfield",
    county_weights: {
      40047: 74.26,
      40053: 25.74,
    },
    county_names_all: "Garfield|Grant",
    county_fips_all: "40047|40053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74641,
    lat: 36.8181,
    lng: -96.85709,
    city: "Kaw City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 548,
    density: 5.7,
    county_fips: 40071,
    county_name: "Kay",
    county_weights: {
      40071: 100,
    },
    county_names_all: "Kay",
    county_fips_all: 40071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74643,
    lat: 36.68457,
    lng: -97.55379,
    city: "Lamont",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 512,
    density: 1.7,
    county_fips: 40053,
    county_name: "Grant",
    county_weights: {
      40053: 93.15,
      40071: 6.85,
    },
    county_names_all: "Grant|Kay",
    county_fips_all: "40053|40071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74644,
    lat: 36.55713,
    lng: -97.09768,
    city: "Marland",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 498,
    density: 2.3,
    county_fips: 40103,
    county_name: "Noble",
    county_weights: {
      40103: 100,
    },
    county_names_all: "Noble",
    county_fips_all: 40103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74646,
    lat: 36.82498,
    lng: -97.43993,
    city: "Nardin",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 137,
    density: 1,
    county_fips: 40071,
    county_name: "Kay",
    county_weights: {
      40053: 23.13,
      40071: 76.87,
    },
    county_names_all: "Kay|Grant",
    county_fips_all: "40071|40053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74647,
    lat: 36.91601,
    lng: -97.00272,
    city: "Newkirk",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3398,
    density: 4.7,
    county_fips: 40071,
    county_name: "Kay",
    county_weights: {
      40071: 100,
    },
    county_names_all: "Kay",
    county_fips_all: 40071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74650,
    lat: 36.47993,
    lng: -96.72282,
    city: "Ralston",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 606,
    density: 1.4,
    county_fips: 40113,
    county_name: "Osage",
    county_weights: {
      40113: 75.61,
      40117: 24.39,
    },
    county_names_all: "Osage|Pawnee",
    county_fips_all: "40113|40117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74651,
    lat: 36.46985,
    lng: -97.17197,
    city: "Red Rock",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 816,
    density: 2.2,
    county_fips: 40103,
    county_name: "Noble",
    county_weights: {
      40103: 95.32,
      40117: 4.68,
    },
    county_names_all: "Noble|Pawnee",
    county_fips_all: "40103|40117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74652,
    lat: 36.85639,
    lng: -96.65438,
    city: "Shidler",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 772,
    density: 1.2,
    county_fips: 40113,
    county_name: "Osage",
    county_weights: {
      40071: 10.87,
      40113: 89.13,
    },
    county_names_all: "Osage|Kay",
    county_fips_all: "40113|40071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74653,
    lat: 36.64683,
    lng: -97.3442,
    city: "Tonkawa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3854,
    density: 13.3,
    county_fips: 40071,
    county_name: "Kay",
    county_weights: {
      40071: 90.46,
      40103: 9.54,
    },
    county_names_all: "Kay|Noble",
    county_fips_all: "40071|40103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74701,
    lat: 34.00974,
    lng: -96.3769,
    city: "Durant",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26320,
    density: 57.5,
    county_fips: 40013,
    county_name: "Bryan",
    county_weights: {
      40013: 100,
    },
    county_names_all: "Bryan",
    county_fips_all: 40013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74720,
    lat: 33.83141,
    lng: -96.37768,
    city: "Achille",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 490,
    density: 105.2,
    county_fips: 40013,
    county_name: "Bryan",
    county_weights: {
      40013: 100,
    },
    county_names_all: "Bryan",
    county_fips_all: 40013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74721,
    lat: 33.87977,
    lng: -96.16266,
    city: "Albany",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 40013,
    county_name: "Bryan",
    county_weights: {
      40013: 100,
    },
    county_names_all: "Bryan",
    county_fips_all: 40013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74722,
    lat: 34.38938,
    lng: -94.91671,
    city: "Battiest",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 268,
    density: 7.4,
    county_fips: 40089,
    county_name: "McCurtain",
    county_weights: {
      40089: 100,
    },
    county_names_all: "McCurtain",
    county_fips_all: 40089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74723,
    lat: 33.98958,
    lng: -96.0233,
    city: "Bennington",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1166,
    density: 2.4,
    county_fips: 40013,
    county_name: "Bryan",
    county_weights: {
      40013: 100,
    },
    county_names_all: "Bryan",
    county_fips_all: 40013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74724,
    lat: 34.33926,
    lng: -94.85833,
    city: "Bethel",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 338,
    density: 5,
    county_fips: 40089,
    county_name: "McCurtain",
    county_weights: {
      40089: 100,
    },
    county_names_all: "McCurtain",
    county_fips_all: 40089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74726,
    lat: 33.94966,
    lng: -96.18135,
    city: "Bokchito",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1785,
    density: 4.6,
    county_fips: 40013,
    county_name: "Bryan",
    county_weights: {
      40013: 100,
    },
    county_names_all: "Bryan",
    county_fips_all: 40013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74727,
    lat: 34.01907,
    lng: -95.86018,
    city: "Boswell",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2128,
    density: 3.7,
    county_fips: 40023,
    county_name: "Choctaw",
    county_weights: {
      40005: 10.09,
      40013: 14.38,
      40023: 75.53,
    },
    county_names_all: "Choctaw|Bryan|Atoka",
    county_fips_all: "40023|40013|40005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74728,
    lat: 34.15411,
    lng: -94.81959,
    city: "Broken Bow",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11669,
    density: 11.2,
    county_fips: 40089,
    county_name: "McCurtain",
    county_weights: {
      40089: 89.39,
      40127: 10.61,
    },
    county_names_all: "McCurtain|Pushmataha",
    county_fips_all: "40089|40127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74729,
    lat: 34.14674,
    lng: -96.25289,
    city: "Caddo",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2701,
    density: 6.8,
    county_fips: 40013,
    county_name: "Bryan",
    county_weights: {
      40005: 35.13,
      40013: 64.87,
    },
    county_names_all: "Bryan|Atoka",
    county_fips_all: "40013|40005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74730,
    lat: 33.90466,
    lng: -96.43361,
    city: "Calera",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5518,
    density: 33.4,
    county_fips: 40013,
    county_name: "Bryan",
    county_weights: {
      40013: 100,
    },
    county_names_all: "Bryan",
    county_fips_all: 40013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74731,
    lat: 33.8753,
    lng: -96.57313,
    city: "Cartwright",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1417,
    density: 42.1,
    county_fips: 40013,
    county_name: "Bryan",
    county_weights: {
      40013: 100,
    },
    county_names_all: "Bryan",
    county_fips_all: 40013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74733,
    lat: 33.83053,
    lng: -96.47546,
    city: "Colbert",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3648,
    density: 26.9,
    county_fips: 40013,
    county_name: "Bryan",
    county_weights: {
      40013: 100,
    },
    county_names_all: "Bryan",
    county_fips_all: 40013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74734,
    lat: 34.0888,
    lng: -94.54786,
    city: "Eagletown",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1116,
    density: 2.8,
    county_fips: 40089,
    county_name: "McCurtain",
    county_weights: {
      40089: 100,
    },
    county_names_all: "McCurtain",
    county_fips_all: 40089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74735,
    lat: 34.10142,
    lng: -95.25595,
    city: "Fort Towson",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1511,
    density: 2.8,
    county_fips: 40023,
    county_name: "Choctaw",
    county_weights: {
      40023: 66.38,
      40127: 33.62,
    },
    county_names_all: "Choctaw|Pushmataha",
    county_fips_all: "40023|40127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74736,
    lat: 33.92436,
    lng: -94.98772,
    city: "Garvin",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 977,
    density: 5.3,
    county_fips: 40089,
    county_name: "McCurtain",
    county_weights: {
      40089: 100,
    },
    county_names_all: "McCurtain",
    county_fips_all: 40089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74737,
    lat: 34.0311,
    lng: -94.8995,
    city: "Golden",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 40089,
    county_name: "McCurtain",
    county_weights: {
      40089: 100,
    },
    county_names_all: "McCurtain",
    county_fips_all: 40089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74738,
    lat: 33.90131,
    lng: -95.444,
    city: "Grant",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 642,
    density: 8.7,
    county_fips: 40023,
    county_name: "Choctaw",
    county_weights: {
      40023: 100,
    },
    county_names_all: "Choctaw",
    county_fips_all: 40023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74740,
    lat: 33.7938,
    lng: -94.59614,
    city: "Haworth",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2370,
    density: 3.6,
    county_fips: 40089,
    county_name: "McCurtain",
    county_weights: {
      40089: 100,
    },
    county_names_all: "McCurtain",
    county_fips_all: 40089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74741,
    lat: 33.79571,
    lng: -96.29281,
    city: "Hendrix",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1236,
    density: 8.1,
    county_fips: 40013,
    county_name: "Bryan",
    county_weights: {
      40013: 100,
    },
    county_names_all: "Bryan",
    county_fips_all: 40013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74743,
    lat: 34.00647,
    lng: -95.5107,
    city: "Hugo",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7997,
    density: 13.4,
    county_fips: 40023,
    county_name: "Choctaw",
    county_weights: {
      40023: 100,
    },
    county_names_all: "Choctaw",
    county_fips_all: 40023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74745,
    lat: 33.86017,
    lng: -94.81319,
    city: "Idabel",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9512,
    density: 21.4,
    county_fips: 40089,
    county_name: "McCurtain",
    county_weights: {
      40089: 100,
    },
    county_names_all: "McCurtain",
    county_fips_all: 40089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74747,
    lat: 33.75491,
    lng: -96.31612,
    city: "Kemp",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 40013,
    county_name: "Bryan",
    county_weights: {
      40013: 100,
    },
    county_names_all: "Bryan",
    county_fips_all: 40013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74748,
    lat: 34.16082,
    lng: -96.44879,
    city: "Kenefic",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 577,
    density: 4.7,
    county_fips: 40069,
    county_name: "Johnston",
    county_weights: {
      40005: 35.35,
      40013: 18.49,
      40069: 46.15,
    },
    county_names_all: "Johnston|Atoka|Bryan",
    county_fips_all: "40069|40005|40013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74750,
    lat: 33.98514,
    lng: -95.01175,
    city: "Millerton",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 282,
    density: 143.3,
    county_fips: 40089,
    county_name: "McCurtain",
    county_weights: {
      40089: 100,
    },
    county_names_all: "McCurtain",
    county_fips_all: 40089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74753,
    lat: 33.90777,
    lng: -96.53496,
    city: "Platter",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 40013,
    county_name: "Bryan",
    county_weights: {
      40013: 100,
    },
    county_names_all: "Bryan",
    county_fips_all: 40013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74754,
    lat: 34.19367,
    lng: -95.12231,
    city: "Ringold",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 580,
    density: 4.3,
    county_fips: 40089,
    county_name: "McCurtain",
    county_weights: {
      40023: 2.71,
      40089: 64.7,
      40127: 32.59,
    },
    county_names_all: "McCurtain|Pushmataha|Choctaw",
    county_fips_all: "40089|40127|40023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74755,
    lat: 34.11799,
    lng: -95.14196,
    city: "Rufe",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54,
    density: 1.9,
    county_fips: 40089,
    county_name: "McCurtain",
    county_weights: {
      40023: 34.37,
      40089: 65.63,
    },
    county_names_all: "McCurtain|Choctaw",
    county_fips_all: "40089|40023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74756,
    lat: 34.07049,
    lng: -95.37367,
    city: "Sawyer",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 816,
    density: 7.3,
    county_fips: 40023,
    county_name: "Choctaw",
    county_weights: {
      40023: 100,
    },
    county_names_all: "Choctaw",
    county_fips_all: 40023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74759,
    lat: 34.06088,
    lng: -95.71278,
    city: "Soper",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1411,
    density: 4.3,
    county_fips: 40023,
    county_name: "Choctaw",
    county_weights: {
      40023: 100,
    },
    county_names_all: "Choctaw",
    county_fips_all: 40023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74760,
    lat: 34.15996,
    lng: -95.3612,
    city: "Spencerville",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 314,
    density: 10.9,
    county_fips: 40127,
    county_name: "Pushmataha",
    county_weights: {
      40023: 44.97,
      40127: 55.03,
    },
    county_names_all: "Pushmataha|Choctaw",
    county_fips_all: "40127|40023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74761,
    lat: 34.00938,
    lng: -95.20134,
    city: "Swink",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 70,
    density: 18.6,
    county_fips: 40023,
    county_name: "Choctaw",
    county_weights: {
      40023: 100,
    },
    county_names_all: "Choctaw",
    county_fips_all: 40023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74764,
    lat: 34.09405,
    lng: -95.05512,
    city: "Valliant",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3711,
    density: 7.8,
    county_fips: 40089,
    county_name: "McCurtain",
    county_weights: {
      40023: 6.89,
      40089: 93.11,
    },
    county_names_all: "McCurtain|Choctaw",
    county_fips_all: "40089|40023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74766,
    lat: 34.08597,
    lng: -94.97271,
    city: "Wright City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1440,
    density: 11.6,
    county_fips: 40089,
    county_name: "McCurtain",
    county_weights: {
      40089: 100,
    },
    county_names_all: "McCurtain",
    county_fips_all: 40089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74801,
    lat: 35.31749,
    lng: -96.96824,
    city: "Shawnee",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21835,
    density: 113.8,
    county_fips: 40125,
    county_name: "Pottawatomie",
    county_weights: {
      40125: 100,
    },
    county_names_all: "Pottawatomie",
    county_fips_all: 40125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74804,
    lat: 35.39358,
    lng: -96.92399,
    city: "Shawnee",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21576,
    density: 83.1,
    county_fips: 40125,
    county_name: "Pottawatomie",
    county_weights: {
      40125: 100,
    },
    county_names_all: "Pottawatomie",
    county_fips_all: 40125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74820,
    lat: 34.80691,
    lng: -96.71348,
    city: "Ada",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31293,
    density: 42.3,
    county_fips: 40123,
    county_name: "Pontotoc",
    county_weights: {
      40123: 99.8,
      40125: 0.2,
    },
    county_names_all: "Pontotoc|Pottawatomie",
    county_fips_all: "40123|40125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74824,
    lat: 35.8873,
    lng: -96.87358,
    city: "Agra",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1617,
    density: 15.4,
    county_fips: 40081,
    county_name: "Lincoln",
    county_weights: {
      40081: 91.63,
      40119: 8.37,
    },
    county_names_all: "Lincoln|Payne",
    county_fips_all: "40081|40119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74825,
    lat: 34.80591,
    lng: -96.4028,
    city: "Allen",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2033,
    density: 5.1,
    county_fips: 40123,
    county_name: "Pontotoc",
    county_weights: {
      40029: 18.97,
      40063: 33.1,
      40123: 47.93,
    },
    county_names_all: "Pontotoc|Hughes|Coal",
    county_fips_all: "40123|40063|40029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74826,
    lat: 35.01735,
    lng: -96.90606,
    city: "Asher",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1430,
    density: 7.1,
    county_fips: 40125,
    county_name: "Pottawatomie",
    county_weights: {
      40125: 100,
    },
    county_names_all: "Pottawatomie",
    county_fips_all: 40125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74827,
    lat: 34.94101,
    lng: -96.34208,
    city: "Atwood",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 351,
    density: 3.7,
    county_fips: 40063,
    county_name: "Hughes",
    county_weights: {
      40063: 100,
    },
    county_names_all: "Hughes",
    county_fips_all: 40063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74829,
    lat: 35.51332,
    lng: -96.47392,
    city: "Boley",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1532,
    density: 10.7,
    county_fips: 40107,
    county_name: "Okfuskee",
    county_weights: {
      40107: 100,
    },
    county_names_all: "Okfuskee",
    county_fips_all: 40107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74830,
    lat: 35.14452,
    lng: -96.66464,
    city: "Bowlegs",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 211,
    density: 70.9,
    county_fips: 40133,
    county_name: "Seminole",
    county_weights: {
      40133: 100,
    },
    county_names_all: "Seminole",
    county_fips_all: 40133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74831,
    lat: 34.89841,
    lng: -97.04298,
    city: "Byars",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 700,
    density: 3.9,
    county_fips: 40087,
    county_name: "McClain",
    county_weights: {
      40049: 5.7,
      40087: 86.85,
      40123: 7.45,
    },
    county_names_all: "McClain|Pontotoc|Garvin",
    county_fips_all: "40087|40123|40049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74832,
    lat: 35.82534,
    lng: -97.01077,
    city: "Carney",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 735,
    density: 9.4,
    county_fips: 40081,
    county_name: "Lincoln",
    county_weights: {
      40081: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 40081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74833,
    lat: 35.58262,
    lng: -96.41193,
    city: "Castle",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 681,
    density: 5.8,
    county_fips: 40107,
    county_name: "Okfuskee",
    county_weights: {
      40107: 100,
    },
    county_names_all: "Okfuskee",
    county_fips_all: 40107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74834,
    lat: 35.6961,
    lng: -96.87902,
    city: "Chandler",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8258,
    density: 17.9,
    county_fips: 40081,
    county_name: "Lincoln",
    county_weights: {
      40081: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 40081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74836,
    lat: 34.44436,
    lng: -96.62581,
    city: "Connerville",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 175,
    density: 4.1,
    county_fips: 40069,
    county_name: "Johnston",
    county_weights: {
      40069: 100,
    },
    county_names_all: "Johnston",
    county_fips_all: 40069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74837,
    lat: 35.34321,
    lng: -96.4561,
    city: "Cromwell",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 326,
    density: 388.9,
    county_fips: 40133,
    county_name: "Seminole",
    county_weights: {
      40133: 100,
    },
    county_names_all: "Seminole",
    county_fips_all: 40133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74839,
    lat: 35.2413,
    lng: -96.04642,
    city: "Dustin",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 892,
    density: 3.2,
    county_fips: 40063,
    county_name: "Hughes",
    county_weights: {
      40063: 66.51,
      40091: 14.85,
      40107: 18.64,
    },
    county_names_all: "Hughes|Okfuskee|McIntosh",
    county_fips_all: "40063|40107|40091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74840,
    lat: 35.30488,
    lng: -96.7665,
    city: "Earlsboro",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1896,
    density: 12,
    county_fips: 40133,
    county_name: "Seminole",
    county_weights: {
      40125: 41.37,
      40133: 58.63,
    },
    county_names_all: "Seminole|Pottawatomie",
    county_fips_all: "40133|40125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74842,
    lat: 34.6166,
    lng: -96.61456,
    city: "Fittstown",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 103,
    density: 2.9,
    county_fips: 40123,
    county_name: "Pontotoc",
    county_weights: {
      40123: 100,
    },
    county_names_all: "Pontotoc",
    county_fips_all: 40123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74843,
    lat: 34.65763,
    lng: -96.7125,
    city: "Fitzhugh",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 468,
    density: 5.4,
    county_fips: 40123,
    county_name: "Pontotoc",
    county_weights: {
      40123: 100,
    },
    county_names_all: "Pontotoc",
    county_fips_all: 40123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74844,
    lat: 34.87421,
    lng: -96.58869,
    city: "Francis",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 442,
    density: 189,
    county_fips: 40123,
    county_name: "Pontotoc",
    county_weights: {
      40123: 100,
    },
    county_names_all: "Pontotoc",
    county_fips_all: 40123,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74845,
    lat: 35.25856,
    lng: -95.88302,
    city: "Hanna",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 447,
    density: 1.8,
    county_fips: 40091,
    county_name: "McIntosh",
    county_weights: {
      40091: 100,
    },
    county_names_all: "McIntosh",
    county_fips_all: 40091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74848,
    lat: 35.08197,
    lng: -96.34804,
    city: "Holdenville",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7840,
    density: 11.7,
    county_fips: 40063,
    county_name: "Hughes",
    county_weights: {
      40063: 97.48,
      40133: 2.52,
    },
    county_names_all: "Hughes|Seminole",
    county_fips_all: "40063|40133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74849,
    lat: 34.9846,
    lng: -96.73597,
    city: "Konawa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3030,
    density: 9.2,
    county_fips: 40133,
    county_name: "Seminole",
    county_weights: {
      40125: 28.28,
      40133: 71.72,
    },
    county_names_all: "Seminole|Pottawatomie",
    county_fips_all: "40133|40125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74850,
    lat: 35.11169,
    lng: -96.09045,
    city: "Lamar",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 266,
    density: 1.9,
    county_fips: 40063,
    county_name: "Hughes",
    county_weights: {
      40063: 100,
    },
    county_names_all: "Hughes",
    county_fips_all: 40063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74851,
    lat: 35.42653,
    lng: -97.08072,
    city: "Mcloud",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11329,
    density: 52,
    county_fips: 40125,
    county_name: "Pottawatomie",
    county_weights: {
      40027: 7.45,
      40081: 34.16,
      40125: 58.39,
    },
    county_names_all: "Pottawatomie|Lincoln|Cleveland",
    county_fips_all: "40125|40081|40027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74852,
    lat: 35.12844,
    lng: -97.01301,
    city: "Macomb",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1198,
    density: 5.9,
    county_fips: 40125,
    county_name: "Pottawatomie",
    county_weights: {
      40027: 1.84,
      40125: 98.16,
    },
    county_names_all: "Pottawatomie|Cleveland",
    county_fips_all: "40125|40027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74854,
    lat: 35.11527,
    lng: -96.762,
    city: "Maud",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1894,
    density: 8.6,
    county_fips: 40133,
    county_name: "Seminole",
    county_weights: {
      40125: 49.83,
      40133: 50.17,
    },
    county_names_all: "Seminole|Pottawatomie",
    county_fips_all: "40133|40125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74855,
    lat: 35.51911,
    lng: -96.90376,
    city: "Meeker",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4556,
    density: 16.7,
    county_fips: 40081,
    county_name: "Lincoln",
    county_weights: {
      40081: 90.42,
      40125: 9.58,
    },
    county_names_all: "Lincoln|Pottawatomie",
    county_fips_all: "40081|40125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74856,
    lat: 34.39853,
    lng: -96.81829,
    city: "Mill Creek",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 887,
    density: 1.8,
    county_fips: 40069,
    county_name: "Johnston",
    county_weights: {
      40069: 83.58,
      40099: 16.42,
    },
    county_names_all: "Johnston|Murray",
    county_fips_all: "40069|40099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74857,
    lat: 35.34132,
    lng: -97.19576,
    city: "Newalla",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9580,
    density: 63.4,
    county_fips: 40027,
    county_name: "Cleveland",
    county_weights: {
      40027: 70.07,
      40109: 26.31,
      40125: 3.62,
    },
    county_names_all: "Cleveland|Oklahoma|Pottawatomie",
    county_fips_all: "40027|40109|40125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74859,
    lat: 35.46237,
    lng: -96.31792,
    city: "Okemah",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6217,
    density: 7.8,
    county_fips: 40107,
    county_name: "Okfuskee",
    county_weights: {
      40107: 88.81,
      40133: 11.19,
    },
    county_names_all: "Okfuskee|Seminole",
    county_fips_all: "40107|40133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74860,
    lat: 35.52788,
    lng: -96.56913,
    city: "Paden",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1787,
    density: 8,
    county_fips: 40107,
    county_name: "Okfuskee",
    county_weights: {
      40107: 100,
    },
    county_names_all: "Okfuskee",
    county_fips_all: 40107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74864,
    lat: 35.4921,
    lng: -96.70269,
    city: "Prague",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4525,
    density: 14.9,
    county_fips: 40081,
    county_name: "Lincoln",
    county_weights: {
      40081: 62.34,
      40107: 1.63,
      40125: 36.03,
    },
    county_names_all: "Lincoln|Pottawatomie|Okfuskee",
    county_fips_all: "40081|40125|40107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74865,
    lat: 34.60599,
    lng: -96.80922,
    city: "Roff",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1839,
    density: 4.4,
    county_fips: 40123,
    county_name: "Pontotoc",
    county_weights: {
      40049: 2.55,
      40099: 9.13,
      40123: 88.32,
    },
    county_names_all: "Pontotoc|Murray|Garvin",
    county_fips_all: "40123|40099|40049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74866,
    lat: 35.06647,
    lng: -96.84691,
    city: "Saint Louis",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 40125,
    county_name: "Pottawatomie",
    county_weights: {
      40125: 100,
    },
    county_names_all: "Pottawatomie",
    county_fips_all: 40125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74867,
    lat: 34.96335,
    lng: -96.54663,
    city: "Sasakwa",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 570,
    density: 2.4,
    county_fips: 40133,
    county_name: "Seminole",
    county_weights: {
      40063: 12.27,
      40133: 87.73,
    },
    county_names_all: "Seminole|Hughes",
    county_fips_all: "40133|40063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74868,
    lat: 35.26699,
    lng: -96.64193,
    city: "Seminole",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12929,
    density: 23.6,
    county_fips: 40133,
    county_name: "Seminole",
    county_weights: {
      40133: 100,
    },
    county_names_all: "Seminole",
    county_fips_all: 40133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74869,
    lat: 35.59117,
    lng: -96.75763,
    city: "Sparks",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 579,
    density: 5.1,
    county_fips: 40081,
    county_name: "Lincoln",
    county_weights: {
      40081: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 40081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74871,
    lat: 34.59942,
    lng: -96.5528,
    city: "Stonewall",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2446,
    density: 5.2,
    county_fips: 40123,
    county_name: "Pontotoc",
    county_weights: {
      40029: 17.67,
      40069: 14.4,
      40123: 67.93,
    },
    county_names_all: "Pontotoc|Coal|Johnston",
    county_fips_all: "40123|40029|40069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74872,
    lat: 34.77989,
    lng: -96.97913,
    city: "Stratford",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3303,
    density: 8.6,
    county_fips: 40049,
    county_name: "Garvin",
    county_weights: {
      40049: 73.63,
      40087: 2.66,
      40123: 23.71,
    },
    county_names_all: "Garvin|Pontotoc|McClain",
    county_fips_all: "40049|40123|40087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74873,
    lat: 35.22396,
    lng: -96.97975,
    city: "Tecumseh",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11575,
    density: 32.6,
    county_fips: 40125,
    county_name: "Pottawatomie",
    county_weights: {
      40125: 100,
    },
    county_names_all: "Pottawatomie",
    county_fips_all: 40125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74875,
    lat: 35.8751,
    lng: -96.95877,
    city: "Tryon",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1134,
    density: 9.3,
    county_fips: 40081,
    county_name: "Lincoln",
    county_weights: {
      40081: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 40081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74878,
    lat: 35.00768,
    lng: -97.06999,
    city: "Wanette",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1794,
    density: 6,
    county_fips: 40125,
    county_name: "Pottawatomie",
    county_weights: {
      40027: 6.15,
      40125: 93.85,
    },
    county_names_all: "Pottawatomie|Cleveland",
    county_fips_all: "40125|40027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74880,
    lat: 35.38039,
    lng: -96.1212,
    city: "Weleetka",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1958,
    density: 7.3,
    county_fips: 40107,
    county_name: "Okfuskee",
    county_weights: {
      40107: 91.48,
      40111: 8.52,
    },
    county_names_all: "Okfuskee|Okmulgee",
    county_fips_all: "40107|40111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74881,
    lat: 35.72136,
    lng: -97.08264,
    city: "Wellston",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5358,
    density: 12.8,
    county_fips: 40081,
    county_name: "Lincoln",
    county_weights: {
      40081: 87.56,
      40083: 12.44,
    },
    county_names_all: "Lincoln|Logan",
    county_fips_all: "40081|40083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74883,
    lat: 35.22766,
    lng: -96.24346,
    city: "Wetumka",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2323,
    density: 5.6,
    county_fips: 40063,
    county_name: "Hughes",
    county_weights: {
      40063: 83.61,
      40107: 16.39,
    },
    county_names_all: "Hughes|Okfuskee",
    county_fips_all: "40063|40107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74884,
    lat: 35.18635,
    lng: -96.51882,
    city: "Wewoka",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5834,
    density: 17,
    county_fips: 40133,
    county_name: "Seminole",
    county_weights: {
      40063: 1.84,
      40133: 98.16,
    },
    county_names_all: "Seminole|Hughes",
    county_fips_all: "40133|40063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74901,
    lat: 35.32798,
    lng: -94.47166,
    city: "Arkoma",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1841,
    density: 36.2,
    county_fips: 40079,
    county_name: "Le Flore",
    county_weights: {
      40079: 100,
    },
    county_names_all: "Le Flore",
    county_fips_all: 40079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74902,
    lat: 35.24568,
    lng: -94.47715,
    city: "Pocola",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4158,
    density: 53.2,
    county_fips: 40079,
    county_name: "Le Flore",
    county_weights: {
      40079: 100,
    },
    county_names_all: "Le Flore",
    county_fips_all: 40079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74930,
    lat: 35.18409,
    lng: -94.77573,
    city: "Bokoshe",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2169,
    density: 12.3,
    county_fips: 40079,
    county_name: "Le Flore",
    county_weights: {
      40079: 100,
    },
    county_names_all: "Le Flore",
    county_fips_all: 40079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74931,
    lat: 35.69226,
    lng: -94.76459,
    city: "Bunch",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1296,
    density: 5.5,
    county_fips: 40001,
    county_name: "Adair",
    county_weights: {
      40001: 67.68,
      40021: 25.2,
      40135: 7.12,
    },
    county_names_all: "Adair|Cherokee|Sequoyah",
    county_fips_all: "40001|40021|40135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74932,
    lat: 35.14701,
    lng: -94.53501,
    city: "Cameron",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2454,
    density: 11.7,
    county_fips: 40079,
    county_name: "Le Flore",
    county_weights: {
      40079: 100,
    },
    county_names_all: "Le Flore",
    county_fips_all: 40079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74935,
    lat: 34.95433,
    lng: -94.89687,
    city: "Fanshawe",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 211,
    density: 10.7,
    county_fips: 40079,
    county_name: "Le Flore",
    county_weights: {
      40079: 100,
    },
    county_names_all: "Le Flore",
    county_fips_all: 40079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74936,
    lat: 35.39042,
    lng: -94.72772,
    city: "Gans",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1316,
    density: 20.1,
    county_fips: 40135,
    county_name: "Sequoyah",
    county_weights: {
      40135: 100,
    },
    county_names_all: "Sequoyah",
    county_fips_all: 40135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74937,
    lat: 34.83303,
    lng: -94.58321,
    city: "Heavener",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5545,
    density: 10.7,
    county_fips: 40079,
    county_name: "Le Flore",
    county_weights: {
      40079: 100,
    },
    county_names_all: "Le Flore",
    county_fips_all: 40079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74939,
    lat: 34.70875,
    lng: -94.63843,
    city: "Hodgen",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1093,
    density: 3.4,
    county_fips: 40079,
    county_name: "Le Flore",
    county_weights: {
      40079: 100,
    },
    county_names_all: "Le Flore",
    county_fips_all: 40079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74940,
    lat: 34.94979,
    lng: -94.63167,
    city: "Howe",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3159,
    density: 20.5,
    county_fips: 40079,
    county_name: "Le Flore",
    county_weights: {
      40079: 100,
    },
    county_names_all: "Le Flore",
    county_fips_all: 40079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74941,
    lat: 35.26453,
    lng: -94.87854,
    city: "Keota",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2652,
    density: 8.8,
    county_fips: 40061,
    county_name: "Haskell",
    county_weights: {
      40061: 75.42,
      40079: 24.58,
    },
    county_names_all: "Haskell|Le Flore",
    county_fips_all: "40061|40079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74942,
    lat: 34.89799,
    lng: -94.97661,
    city: "Leflore",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 213,
    density: 59.8,
    county_fips: 40079,
    county_name: "Le Flore",
    county_weights: {
      40079: 100,
    },
    county_names_all: "Le Flore",
    county_fips_all: 40079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74943,
    lat: 35.1007,
    lng: -95.106,
    city: "Lequire",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 105,
    density: 40,
    county_fips: 40061,
    county_name: "Haskell",
    county_weights: {
      40061: 100,
    },
    county_names_all: "Haskell",
    county_fips_all: 40061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74944,
    lat: 35.12421,
    lng: -95.00779,
    city: "Mccurtain",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1305,
    density: 4.2,
    county_fips: 40061,
    county_name: "Haskell",
    county_weights: {
      40061: 82.13,
      40079: 17.87,
    },
    county_names_all: "Haskell|Le Flore",
    county_fips_all: "40061|40079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74945,
    lat: 35.58232,
    lng: -94.81864,
    city: "Marble City",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 365,
    density: 346.8,
    county_fips: 40135,
    county_name: "Sequoyah",
    county_weights: {
      40135: 100,
    },
    county_names_all: "Sequoyah",
    county_fips_all: 40135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74946,
    lat: 35.39613,
    lng: -94.45093,
    city: "Moffett",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 92,
    density: 33.2,
    county_fips: 40135,
    county_name: "Sequoyah",
    county_weights: {
      40135: 100,
    },
    county_names_all: "Sequoyah",
    county_fips_all: 40135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74947,
    lat: 34.99149,
    lng: -94.51589,
    city: "Monroe",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 40079,
    county_name: "Le Flore",
    county_weights: {
      40079: 100,
    },
    county_names_all: "Le Flore",
    county_fips_all: 40079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74948,
    lat: 35.46207,
    lng: -94.56284,
    city: "Muldrow",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11652,
    density: 20.7,
    county_fips: 40135,
    county_name: "Sequoyah",
    county_weights: {
      40001: 2.31,
      40135: 97.69,
    },
    county_names_all: "Sequoyah|Adair",
    county_fips_all: "40135|40001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74949,
    lat: 34.68324,
    lng: -94.7739,
    city: "Muse",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 214,
    density: 1.9,
    county_fips: 40079,
    county_name: "Le Flore",
    county_weights: {
      40079: 100,
    },
    county_names_all: "Le Flore",
    county_fips_all: 40079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74951,
    lat: 35.17099,
    lng: -94.66482,
    city: "Panama",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1460,
    density: 125.7,
    county_fips: 40079,
    county_name: "Le Flore",
    county_weights: {
      40079: 100,
    },
    county_names_all: "Le Flore",
    county_fips_all: 40079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74953,
    lat: 35.03931,
    lng: -94.57156,
    city: "Poteau",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11995,
    density: 38.9,
    county_fips: 40079,
    county_name: "Le Flore",
    county_weights: {
      40079: 100,
    },
    county_names_all: "Le Flore",
    county_fips_all: 40079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74954,
    lat: 35.41596,
    lng: -94.49043,
    city: "Roland",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5303,
    density: 98.3,
    county_fips: 40135,
    county_name: "Sequoyah",
    county_weights: {
      40135: 100,
    },
    county_names_all: "Sequoyah",
    county_fips_all: 40135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74955,
    lat: 35.50213,
    lng: -94.75547,
    city: "Sallisaw",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15446,
    density: 28.2,
    county_fips: 40135,
    county_name: "Sequoyah",
    county_weights: {
      40135: 100,
    },
    county_names_all: "Sequoyah",
    county_fips_all: 40135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74956,
    lat: 35.09487,
    lng: -94.77334,
    city: "Shady Point",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2009,
    density: 12.2,
    county_fips: 40079,
    county_name: "Le Flore",
    county_weights: {
      40079: 100,
    },
    county_names_all: "Le Flore",
    county_fips_all: 40079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74957,
    lat: 34.52522,
    lng: -94.65558,
    city: "Smithville",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1103,
    density: 1.8,
    county_fips: 40079,
    county_name: "Le Flore",
    county_weights: {
      40079: 68.04,
      40089: 31.96,
    },
    county_names_all: "Le Flore|McCurtain",
    county_fips_all: "40079|40089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74959,
    lat: 35.26288,
    lng: -94.63326,
    city: "Spiro",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6459,
    density: 26.9,
    county_fips: 40079,
    county_name: "Le Flore",
    county_weights: {
      40079: 100,
    },
    county_names_all: "Le Flore",
    county_fips_all: 40079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74960,
    lat: 35.80995,
    lng: -94.65027,
    city: "Stilwell",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13379,
    density: 17.2,
    county_fips: 40001,
    county_name: "Adair",
    county_weights: {
      40001: 95.71,
      40021: 4.29,
    },
    county_names_all: "Adair|Cherokee",
    county_fips_all: "40001|40021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74962,
    lat: 35.53703,
    lng: -94.94717,
    city: "Vian",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4418,
    density: 11.1,
    county_fips: 40135,
    county_name: "Sequoyah",
    county_weights: {
      40021: 2.64,
      40135: 97.36,
    },
    county_names_all: "Sequoyah|Cherokee",
    county_fips_all: "40135|40021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74963,
    lat: 34.41424,
    lng: -94.56322,
    city: "Watson",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 572,
    density: 3.8,
    county_fips: 40089,
    county_name: "McCurtain",
    county_weights: {
      40089: 100,
    },
    county_names_all: "McCurtain",
    county_fips_all: 40089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74964,
    lat: 36.11493,
    lng: -94.6665,
    city: "Watts",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2662,
    density: 13,
    county_fips: 40001,
    county_name: "Adair",
    county_weights: {
      40001: 93.36,
      40021: 0.94,
      40041: 5.7,
    },
    county_names_all: "Adair|Delaware|Cherokee",
    county_fips_all: "40001|40041|40021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74965,
    lat: 35.99605,
    lng: -94.62553,
    city: "Westville",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5456,
    density: 18.9,
    county_fips: 40001,
    county_name: "Adair",
    county_weights: {
      40001: 100,
    },
    county_names_all: "Adair",
    county_fips_all: 40001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 74966,
    lat: 34.89556,
    lng: -94.86894,
    city: "Wister",
    state_id: "OK",
    state_name: "Oklahoma",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3670,
    density: 5.4,
    county_fips: 40079,
    county_name: "Le Flore",
    county_weights: {
      40077: 7.11,
      40079: 92.89,
    },
    county_names_all: "Le Flore|Latimer",
    county_fips_all: "40079|40077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75001,
    lat: 32.96015,
    lng: -96.83808,
    city: "Addison",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15418,
    density: 1586.4,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75002,
    lat: 33.08946,
    lng: -96.60639,
    city: "Allen",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 73916,
    density: 759.4,
    county_fips: 48085,
    county_name: "Collin",
    county_weights: {
      48085: 100,
    },
    county_names_all: "Collin",
    county_fips_all: 48085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75006,
    lat: 32.96165,
    lng: -96.89717,
    city: "Carrollton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52231,
    density: 1181.2,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75007,
    lat: 33.00498,
    lng: -96.8959,
    city: "Carrollton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57513,
    density: 1865,
    county_fips: 48121,
    county_name: "Denton",
    county_weights: {
      48085: 1.06,
      48113: 8.52,
      48121: 90.42,
    },
    county_names_all: "Denton|Dallas|Collin",
    county_fips_all: "48121|48113|48085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75009,
    lat: 33.3384,
    lng: -96.75185,
    city: "Celina",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15348,
    density: 60,
    county_fips: 48085,
    county_name: "Collin",
    county_weights: {
      48085: 93.14,
      48121: 6.86,
    },
    county_names_all: "Collin|Denton",
    county_fips_all: "48085|48121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75010,
    lat: 33.03058,
    lng: -96.90148,
    city: "Carrollton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30784,
    density: 1744.8,
    county_fips: 48121,
    county_name: "Denton",
    county_weights: {
      48121: 100,
    },
    county_names_all: "Denton",
    county_fips_all: 48121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75013,
    lat: 33.11463,
    lng: -96.69413,
    city: "Allen",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42956,
    density: 1102.5,
    county_fips: 48085,
    county_name: "Collin",
    county_weights: {
      48085: 100,
    },
    county_names_all: "Collin",
    county_fips_all: 48085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75019,
    lat: 32.96183,
    lng: -96.984,
    city: "Coppell",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43137,
    density: 969.1,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 98.16,
      48121: 1.84,
    },
    county_names_all: "Dallas|Denton",
    county_fips_all: "48113|48121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75020,
    lat: 33.77264,
    lng: -96.60391,
    city: "Denison",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23216,
    density: 146.9,
    county_fips: 48181,
    county_name: "Grayson",
    county_weights: {
      48181: 100,
    },
    county_names_all: "Grayson",
    county_fips_all: 48181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75021,
    lat: 33.72686,
    lng: -96.47552,
    city: "Denison",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9454,
    density: 62.5,
    county_fips: 48181,
    county_name: "Grayson",
    county_weights: {
      48181: 100,
    },
    county_names_all: "Grayson",
    county_fips_all: 48181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75022,
    lat: 33.02554,
    lng: -97.11871,
    city: "Flower Mound",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28773,
    density: 568.4,
    county_fips: 48121,
    county_name: "Denton",
    county_weights: {
      48121: 92.59,
      48439: 7.41,
    },
    county_names_all: "Denton|Tarrant",
    county_fips_all: "48121|48439",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75023,
    lat: 33.05657,
    lng: -96.73286,
    city: "Plano",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50923,
    density: 2137.4,
    county_fips: 48085,
    county_name: "Collin",
    county_weights: {
      48085: 100,
    },
    county_names_all: "Collin",
    county_fips_all: 48085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75024,
    lat: 33.07712,
    lng: -96.80826,
    city: "Plano",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43041,
    density: 1282.9,
    county_fips: 48085,
    county_name: "Collin",
    county_weights: {
      48085: 87.52,
      48121: 12.48,
    },
    county_names_all: "Collin|Denton",
    county_fips_all: "48085|48121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75025,
    lat: 33.09057,
    lng: -96.74061,
    city: "Plano",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54653,
    density: 2208.7,
    county_fips: 48085,
    county_name: "Collin",
    county_weights: {
      48085: 100,
    },
    county_names_all: "Collin",
    county_fips_all: 48085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75028,
    lat: 33.03382,
    lng: -97.0629,
    city: "Flower Mound",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48641,
    density: 1207.1,
    county_fips: 48121,
    county_name: "Denton",
    county_weights: {
      48121: 97.8,
      48439: 2.2,
    },
    county_names_all: "Denton|Tarrant",
    county_fips_all: "48121|48439",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75032,
    lat: 32.85756,
    lng: -96.42858,
    city: "Rockwall",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33956,
    density: 272.4,
    county_fips: 48397,
    county_name: "Rockwall",
    county_weights: {
      48397: 100,
    },
    county_names_all: "Rockwall",
    county_fips_all: 48397,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75033,
    lat: 33.18471,
    lng: -96.84404,
    city: "Frisco",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48121,
    county_name: "Denton",
    county_weights: {
      48085: 45.43,
      48121: 54.57,
    },
    county_names_all: "Denton|Collin",
    county_fips_all: "48121|48085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75034,
    lat: 33.12084,
    lng: -96.83778,
    city: "Frisco",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 116155,
    density: 2812.9,
    county_fips: 48085,
    county_name: "Collin",
    county_weights: {
      48085: 55.89,
      48121: 44.11,
    },
    county_names_all: "Collin|Denton",
    county_fips_all: "48085|48121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75035,
    lat: 33.15814,
    lng: -96.7734,
    city: "Frisco",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 80269,
    density: 1244.6,
    county_fips: 48085,
    county_name: "Collin",
    county_weights: {
      48085: 100,
    },
    county_names_all: "Collin",
    county_fips_all: 48085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75036,
    lat: 33.13339,
    lng: -96.91453,
    city: "Frisco",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48121,
    county_name: "Denton",
    county_weights: {
      48121: 100,
    },
    county_names_all: "Denton",
    county_fips_all: 48121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75038,
    lat: 32.87231,
    lng: -96.97946,
    city: "Irving",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29886,
    density: 1510.7,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75039,
    lat: 32.88592,
    lng: -96.94042,
    city: "Irving",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20627,
    density: 1401.2,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75040,
    lat: 32.92797,
    lng: -96.62006,
    city: "Garland",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61508,
    density: 1512.9,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75041,
    lat: 32.88101,
    lng: -96.65149,
    city: "Garland",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31250,
    density: 1522.7,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75042,
    lat: 32.91401,
    lng: -96.67466,
    city: "Garland",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37458,
    density: 1894.9,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75043,
    lat: 32.8571,
    lng: -96.57986,
    city: "Garland",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62721,
    density: 1651.1,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75044,
    lat: 32.96299,
    lng: -96.6531,
    city: "Garland",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45284,
    density: 1656.3,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48085: 0.38,
      48113: 99.62,
    },
    county_names_all: "Dallas|Collin",
    county_fips_all: "48113|48085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75048,
    lat: 32.9704,
    lng: -96.58139,
    city: "Sachse",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26062,
    density: 1034,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48085: 19.21,
      48113: 80.79,
    },
    county_names_all: "Dallas|Collin",
    county_fips_all: "48113|48085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75050,
    lat: 32.77428,
    lng: -97.0037,
    city: "Grand Prairie",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43190,
    density: 645.7,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 78.86,
      48439: 21.14,
    },
    county_names_all: "Dallas|Tarrant",
    county_fips_all: "48113|48439",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75051,
    lat: 32.72635,
    lng: -96.99375,
    city: "Grand Prairie",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41317,
    density: 1263.5,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 89.34,
      48439: 10.66,
    },
    county_names_all: "Dallas|Tarrant",
    county_fips_all: "48113|48439",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75052,
    lat: 32.66455,
    lng: -97.02809,
    city: "Grand Prairie",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 94060,
    density: 1373.3,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 57.89,
      48439: 42.11,
    },
    county_names_all: "Dallas|Tarrant",
    county_fips_all: "48113|48439",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75054,
    lat: 32.60036,
    lng: -97.03409,
    city: "Grand Prairie",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13045,
    density: 851.2,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 53.41,
      48439: 46.59,
    },
    county_names_all: "Dallas|Tarrant",
    county_fips_all: "48113|48439",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75056,
    lat: 33.07541,
    lng: -96.90978,
    city: "The Colony",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59674,
    density: 975,
    county_fips: 48121,
    county_name: "Denton",
    county_weights: {
      48121: 100,
    },
    county_names_all: "Denton",
    county_fips_all: 48121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75057,
    lat: 33.05012,
    lng: -96.9772,
    city: "Lewisville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16670,
    density: 483,
    county_fips: 48121,
    county_name: "Denton",
    county_weights: {
      48121: 100,
    },
    county_names_all: "Denton",
    county_fips_all: 48121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75058,
    lat: 33.4473,
    lng: -96.73546,
    city: "Gunter",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3329,
    density: 23.9,
    county_fips: 48181,
    county_name: "Grayson",
    county_weights: {
      48181: 100,
    },
    county_names_all: "Grayson",
    county_fips_all: 48181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75060,
    lat: 32.79774,
    lng: -96.95295,
    city: "Irving",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49307,
    density: 1575.1,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75061,
    lat: 32.82607,
    lng: -96.96563,
    city: "Irving",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53983,
    density: 1794.9,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75062,
    lat: 32.847,
    lng: -96.95813,
    city: "Irving",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49296,
    density: 1797,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75063,
    lat: 32.90797,
    lng: -96.9961,
    city: "Irving",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39831,
    density: 760.2,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75065,
    lat: 33.11108,
    lng: -97.01277,
    city: "Lake Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13026,
    density: 608.1,
    county_fips: 48121,
    county_name: "Denton",
    county_weights: {
      48121: 100,
    },
    county_names_all: "Denton",
    county_fips_all: 48121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75067,
    lat: 33.01416,
    lng: -97.00268,
    city: "Lewisville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67197,
    density: 1923.2,
    county_fips: 48121,
    county_name: "Denton",
    county_weights: {
      48113: 3.82,
      48121: 96.18,
    },
    county_names_all: "Denton|Dallas",
    county_fips_all: "48121|48113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75068,
    lat: 33.17713,
    lng: -96.95228,
    city: "Little Elm",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69656,
    density: 965.1,
    county_fips: 48121,
    county_name: "Denton",
    county_weights: {
      48121: 100,
    },
    county_names_all: "Denton",
    county_fips_all: 48121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75069,
    lat: 33.16805,
    lng: -96.59671,
    city: "Mckinney",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37582,
    density: 430.9,
    county_fips: 48085,
    county_name: "Collin",
    county_weights: {
      48085: 100,
    },
    county_names_all: "Collin",
    county_fips_all: 48085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75070,
    lat: 33.15587,
    lng: -96.69742,
    city: "Mckinney",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 109085,
    density: 3732.9,
    county_fips: 48085,
    county_name: "Collin",
    county_weights: {
      48085: 100,
    },
    county_names_all: "Collin",
    county_fips_all: 48085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75071,
    lat: 33.24558,
    lng: -96.62951,
    city: "Mckinney",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62769,
    density: 326.9,
    county_fips: 48085,
    county_name: "Collin",
    county_weights: {
      48085: 100,
    },
    county_names_all: "Collin",
    county_fips_all: 48085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75072,
    lat: 33.1875,
    lng: -96.70099,
    city: "Mckinney",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48085,
    county_name: "Collin",
    county_weights: {
      48085: 100,
    },
    county_names_all: "Collin",
    county_fips_all: 48085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75074,
    lat: 33.03298,
    lng: -96.67304,
    city: "Plano",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53459,
    density: 1292.2,
    county_fips: 48085,
    county_name: "Collin",
    county_weights: {
      48085: 100,
    },
    county_names_all: "Collin",
    county_fips_all: 48085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75075,
    lat: 33.02163,
    lng: -96.74043,
    city: "Plano",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37310,
    density: 1485.1,
    county_fips: 48085,
    county_name: "Collin",
    county_weights: {
      48085: 100,
    },
    county_names_all: "Collin",
    county_fips_all: 48085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75076,
    lat: 33.79608,
    lng: -96.71913,
    city: "Pottsboro",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8297,
    density: 63.6,
    county_fips: 48181,
    county_name: "Grayson",
    county_weights: {
      48181: 100,
    },
    county_names_all: "Grayson",
    county_fips_all: 48181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75077,
    lat: 33.07921,
    lng: -97.06401,
    city: "Lewisville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38764,
    density: 1061.8,
    county_fips: 48121,
    county_name: "Denton",
    county_weights: {
      48121: 100,
    },
    county_names_all: "Denton",
    county_fips_all: 48121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75078,
    lat: 33.24526,
    lng: -96.80791,
    city: "Prosper",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34300,
    density: 419.5,
    county_fips: 48085,
    county_name: "Collin",
    county_weights: {
      48085: 70.28,
      48121: 29.72,
    },
    county_names_all: "Collin|Denton",
    county_fips_all: "48085|48121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75080,
    lat: 32.97382,
    lng: -96.7416,
    city: "Richardson",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53708,
    density: 1833.2,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48085: 29.11,
      48113: 70.89,
    },
    county_names_all: "Dallas|Collin",
    county_fips_all: "48113|48085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75081,
    lat: 32.94969,
    lng: -96.70899,
    city: "Richardson",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40825,
    density: 1748.8,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75082,
    lat: 32.99208,
    lng: -96.66536,
    city: "Richardson",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23418,
    density: 1102.8,
    county_fips: 48085,
    county_name: "Collin",
    county_weights: {
      48085: 84.56,
      48113: 15.44,
    },
    county_names_all: "Collin|Dallas",
    county_fips_all: "48085|48113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75087,
    lat: 32.94581,
    lng: -96.44136,
    city: "Rockwall",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36718,
    density: 481.4,
    county_fips: 48397,
    county_name: "Rockwall",
    county_weights: {
      48085: 5.43,
      48397: 94.57,
    },
    county_names_all: "Rockwall|Collin",
    county_fips_all: "48397|48085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75088,
    lat: 32.89368,
    lng: -96.53929,
    city: "Rowlett",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26823,
    density: 1116.5,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 72.14,
      48397: 27.86,
    },
    county_names_all: "Dallas|Rockwall",
    county_fips_all: "48113|48397",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75089,
    lat: 32.93195,
    lng: -96.54435,
    city: "Rowlett",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37310,
    density: 1190.4,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 86.17,
      48397: 13.83,
    },
    county_names_all: "Dallas|Rockwall",
    county_fips_all: "48113|48397",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75090,
    lat: 33.6054,
    lng: -96.54657,
    city: "Sherman",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25732,
    density: 126.5,
    county_fips: 48181,
    county_name: "Grayson",
    county_weights: {
      48181: 100,
    },
    county_names_all: "Grayson",
    county_fips_all: 48181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75092,
    lat: 33.64869,
    lng: -96.70011,
    city: "Sherman",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26297,
    density: 89.1,
    county_fips: 48181,
    county_name: "Grayson",
    county_weights: {
      48181: 100,
    },
    county_names_all: "Grayson",
    county_fips_all: 48181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75093,
    lat: 33.03521,
    lng: -96.80943,
    city: "Plano",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47908,
    density: 1295.1,
    county_fips: 48085,
    county_name: "Collin",
    county_weights: {
      48085: 90.27,
      48121: 9.73,
    },
    county_names_all: "Collin|Denton",
    county_fips_all: "48085|48121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75094,
    lat: 33.01871,
    lng: -96.61481,
    city: "Plano",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23408,
    density: 1261,
    county_fips: 48085,
    county_name: "Collin",
    county_weights: {
      48085: 100,
    },
    county_names_all: "Collin",
    county_fips_all: 48085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75098,
    lat: 33.01432,
    lng: -96.53531,
    city: "Wylie",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58717,
    density: 708.2,
    county_fips: 48085,
    county_name: "Collin",
    county_weights: {
      48085: 82.66,
      48113: 8.54,
      48397: 8.8,
    },
    county_names_all: "Collin|Rockwall|Dallas",
    county_fips_all: "48085|48397|48113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75101,
    lat: 32.27003,
    lng: -96.70239,
    city: "Bardwell",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 643,
    density: 300.4,
    county_fips: 48139,
    county_name: "Ellis",
    county_weights: {
      48139: 100,
    },
    county_names_all: "Ellis",
    county_fips_all: 48139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75102,
    lat: 32.08274,
    lng: -96.63999,
    city: "Barry",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1455,
    density: 8.1,
    county_fips: 48349,
    county_name: "Navarro",
    county_weights: {
      48349: 100,
    },
    county_names_all: "Navarro",
    county_fips_all: 48349,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75103,
    lat: 32.51201,
    lng: -95.88363,
    city: "Canton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15358,
    density: 30.2,
    county_fips: 48467,
    county_name: "Van Zandt",
    county_weights: {
      48467: 100,
    },
    county_names_all: "Van Zandt",
    county_fips_all: 48467,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75104,
    lat: 32.58295,
    lng: -96.96712,
    city: "Cedar Hill",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48821,
    density: 510.8,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 94.22,
      48139: 5.78,
    },
    county_names_all: "Dallas|Ellis",
    county_fips_all: "48113|48139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75105,
    lat: 32.26717,
    lng: -96.36682,
    city: "Chatfield",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 248,
    density: 2.4,
    county_fips: 48349,
    county_name: "Navarro",
    county_weights: {
      48349: 100,
    },
    county_names_all: "Navarro",
    county_fips_all: 48349,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75109,
    lat: 32.04246,
    lng: -96.35622,
    city: "Corsicana",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4150,
    density: 13.4,
    county_fips: 48349,
    county_name: "Navarro",
    county_weights: {
      48349: 100,
    },
    county_names_all: "Navarro",
    county_fips_all: 48349,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75110,
    lat: 32.08071,
    lng: -96.52344,
    city: "Corsicana",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29665,
    density: 83.3,
    county_fips: 48349,
    county_name: "Navarro",
    county_weights: {
      48349: 100,
    },
    county_names_all: "Navarro",
    county_fips_all: 48349,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75114,
    lat: 32.60769,
    lng: -96.44322,
    city: "Crandall",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6870,
    density: 61.7,
    county_fips: 48257,
    county_name: "Kaufman",
    county_weights: {
      48257: 100,
    },
    county_names_all: "Kaufman",
    county_fips_all: 48257,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75115,
    lat: 32.59831,
    lng: -96.86433,
    city: "Desoto",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53118,
    density: 974.3,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75116,
    lat: 32.66013,
    lng: -96.91402,
    city: "Duncanville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19755,
    density: 1495,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75117,
    lat: 32.71005,
    lng: -95.85268,
    city: "Edgewood",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4505,
    density: 35.2,
    county_fips: 48467,
    county_name: "Van Zandt",
    county_weights: {
      48467: 100,
    },
    county_names_all: "Van Zandt",
    county_fips_all: 48467,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75119,
    lat: 32.32293,
    lng: -96.59107,
    city: "Ennis",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28901,
    density: 42.2,
    county_fips: 48139,
    county_name: "Ellis",
    county_weights: {
      48139: 94.48,
      48349: 5.52,
    },
    county_names_all: "Ellis|Navarro",
    county_fips_all: "48139|48349",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75124,
    lat: 32.32579,
    lng: -95.96932,
    city: "Eustace",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4985,
    density: 21.6,
    county_fips: 48213,
    county_name: "Henderson",
    county_weights: {
      48213: 73.19,
      48467: 26.81,
    },
    county_names_all: "Henderson|Van Zandt",
    county_fips_all: "48213|48467",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75125,
    lat: 32.52983,
    lng: -96.61563,
    city: "Ferris",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7664,
    density: 39.3,
    county_fips: 48139,
    county_name: "Ellis",
    county_weights: {
      48113: 28.58,
      48139: 71.42,
    },
    county_names_all: "Ellis|Dallas",
    county_fips_all: "48139|48113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75126,
    lat: 32.74361,
    lng: -96.45289,
    city: "Forney",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52078,
    density: 246.3,
    county_fips: 48257,
    county_name: "Kaufman",
    county_weights: {
      48257: 97.32,
      48397: 2.68,
    },
    county_names_all: "Kaufman|Rockwall",
    county_fips_all: "48257|48397",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75127,
    lat: 32.6926,
    lng: -95.79262,
    city: "Fruitvale",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1906,
    density: 27.5,
    county_fips: 48467,
    county_name: "Van Zandt",
    county_weights: {
      48467: 100,
    },
    county_names_all: "Van Zandt",
    county_fips_all: 48467,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75132,
    lat: 32.93865,
    lng: -96.38046,
    city: "Fate",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2326,
    density: 7940.4,
    county_fips: 48397,
    county_name: "Rockwall",
    county_weights: {
      48397: 100,
    },
    county_names_all: "Rockwall",
    county_fips_all: 48397,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75134,
    lat: 32.62308,
    lng: -96.78007,
    city: "Lancaster",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20759,
    density: 756.3,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75135,
    lat: 33.06666,
    lng: -96.22567,
    city: "Caddo Mills",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7183,
    density: 42.1,
    county_fips: 48231,
    county_name: "Hunt",
    county_weights: {
      48231: 100,
    },
    county_names_all: "Hunt",
    county_fips_all: 48231,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75137,
    lat: 32.63421,
    lng: -96.91224,
    city: "Duncanville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19341,
    density: 1243.4,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75140,
    lat: 32.64485,
    lng: -95.68854,
    city: "Grand Saline",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6877,
    density: 22.8,
    county_fips: 48467,
    county_name: "Van Zandt",
    county_weights: {
      48423: 1.84,
      48467: 98.16,
    },
    county_names_all: "Van Zandt|Smith",
    county_fips_all: "48467|48423",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75141,
    lat: 32.63984,
    lng: -96.69257,
    city: "Hutchins",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5814,
    density: 192,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75142,
    lat: 32.57004,
    lng: -96.24637,
    city: "Kaufman",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21746,
    density: 46.3,
    county_fips: 48257,
    county_name: "Kaufman",
    county_weights: {
      48257: 100,
    },
    county_names_all: "Kaufman",
    county_fips_all: 48257,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75143,
    lat: 32.36334,
    lng: -96.24929,
    city: "Kemp",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14336,
    density: 30.4,
    county_fips: 48257,
    county_name: "Kaufman",
    county_weights: {
      48213: 45.85,
      48257: 54.15,
    },
    county_names_all: "Kaufman|Henderson",
    county_fips_all: "48257|48213",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75144,
    lat: 32.11157,
    lng: -96.20954,
    city: "Kerens",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3414,
    density: 7.6,
    county_fips: 48349,
    county_name: "Navarro",
    county_weights: {
      48349: 100,
    },
    county_names_all: "Navarro",
    county_fips_all: 48349,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75146,
    lat: 32.57608,
    lng: -96.75137,
    city: "Lancaster",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20663,
    density: 230,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 99.42,
      48139: 0.58,
    },
    county_names_all: "Dallas|Ellis",
    county_fips_all: "48113|48139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75147,
    lat: 32.42256,
    lng: -96.06517,
    city: "Mabank",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6951,
    density: 31.1,
    county_fips: 48467,
    county_name: "Van Zandt",
    county_weights: {
      48213: 4.2,
      48257: 41.84,
      48467: 53.96,
    },
    county_names_all: "Van Zandt|Kaufman|Henderson",
    county_fips_all: "48467|48257|48213",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75148,
    lat: 32.12491,
    lng: -96.01173,
    city: "Malakoff",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6396,
    density: 27.8,
    county_fips: 48213,
    county_name: "Henderson",
    county_weights: {
      48213: 100,
    },
    county_names_all: "Henderson",
    county_fips_all: 48213,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75149,
    lat: 32.76994,
    lng: -96.6151,
    city: "Mesquite",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57758,
    density: 1391.7,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75150,
    lat: 32.81545,
    lng: -96.6308,
    city: "Mesquite",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61863,
    density: 1901.7,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75152,
    lat: 32.43598,
    lng: -96.67444,
    city: "Palmer",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5194,
    density: 48.8,
    county_fips: 48139,
    county_name: "Ellis",
    county_weights: {
      48139: 100,
    },
    county_names_all: "Ellis",
    county_fips_all: 48139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75153,
    lat: 32.17149,
    lng: -96.35331,
    city: "Powell",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 571,
    density: 9,
    county_fips: 48349,
    county_name: "Navarro",
    county_weights: {
      48349: 100,
    },
    county_names_all: "Navarro",
    county_fips_all: 48349,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75154,
    lat: 32.52319,
    lng: -96.80885,
    city: "Red Oak",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42192,
    density: 340.7,
    county_fips: 48139,
    county_name: "Ellis",
    county_weights: {
      48113: 12.47,
      48139: 87.53,
    },
    county_names_all: "Ellis|Dallas",
    county_fips_all: "48139|48113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75155,
    lat: 32.2232,
    lng: -96.46906,
    city: "Rice",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2971,
    density: 27.8,
    county_fips: 48349,
    county_name: "Navarro",
    county_weights: {
      48349: 100,
    },
    county_names_all: "Navarro",
    county_fips_all: 48349,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75156,
    lat: 32.28759,
    lng: -96.09999,
    city: "Mabank",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16718,
    density: 201.3,
    county_fips: 48213,
    county_name: "Henderson",
    county_weights: {
      48213: 100,
    },
    county_names_all: "Henderson",
    county_fips_all: 48213,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75157,
    lat: 32.46168,
    lng: -96.44914,
    city: "Rosser",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 233,
    density: 66.9,
    county_fips: 48257,
    county_name: "Kaufman",
    county_weights: {
      48257: 100,
    },
    county_names_all: "Kaufman",
    county_fips_all: 48257,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75158,
    lat: 32.46694,
    lng: -96.39315,
    city: "Scurry",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4337,
    density: 19.4,
    county_fips: 48257,
    county_name: "Kaufman",
    county_weights: {
      48257: 100,
    },
    county_names_all: "Kaufman",
    county_fips_all: 48257,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75159,
    lat: 32.60652,
    lng: -96.53939,
    city: "Seagoville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20857,
    density: 135.8,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 63.46,
      48257: 36.54,
    },
    county_names_all: "Dallas|Kaufman",
    county_fips_all: "48113|48257",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75160,
    lat: 32.76466,
    lng: -96.29835,
    city: "Terrell",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24494,
    density: 80,
    county_fips: 48257,
    county_name: "Kaufman",
    county_weights: {
      48231: 17.13,
      48257: 82.87,
    },
    county_names_all: "Kaufman|Hunt",
    county_fips_all: "48257|48231",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75161,
    lat: 32.73609,
    lng: -96.17129,
    city: "Terrell",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7483,
    density: 25.7,
    county_fips: 48257,
    county_name: "Kaufman",
    county_weights: {
      48257: 100,
    },
    county_names_all: "Kaufman",
    county_fips_all: 48257,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75163,
    lat: 32.1672,
    lng: -96.10999,
    city: "Trinidad",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2590,
    density: 29.5,
    county_fips: 48213,
    county_name: "Henderson",
    county_weights: {
      48213: 100,
    },
    county_names_all: "Henderson",
    county_fips_all: 48213,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75164,
    lat: 33.06963,
    lng: -96.3041,
    city: "Josephine",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 788,
    density: 305.2,
    county_fips: 48085,
    county_name: "Collin",
    county_weights: {
      48085: 100,
    },
    county_names_all: "Collin",
    county_fips_all: 48085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75165,
    lat: 32.36687,
    lng: -96.79677,
    city: "Waxahachie",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44571,
    density: 145.9,
    county_fips: 48139,
    county_name: "Ellis",
    county_weights: {
      48139: 100,
    },
    county_names_all: "Ellis",
    county_fips_all: 48139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75166,
    lat: 33.01671,
    lng: -96.4495,
    city: "Lavon",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4624,
    density: 138.1,
    county_fips: 48085,
    county_name: "Collin",
    county_weights: {
      48085: 100,
    },
    county_names_all: "Collin",
    county_fips_all: 48085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75167,
    lat: 32.36123,
    lng: -96.91547,
    city: "Waxahachie",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12091,
    density: 48.7,
    county_fips: 48139,
    county_name: "Ellis",
    county_weights: {
      48139: 100,
    },
    county_names_all: "Ellis",
    county_fips_all: 48139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75169,
    lat: 32.70335,
    lng: -95.99754,
    city: "Wills Point",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12937,
    density: 23.3,
    county_fips: 48467,
    county_name: "Van Zandt",
    county_weights: {
      48231: 4.98,
      48257: 8.7,
      48467: 86.32,
    },
    county_names_all: "Van Zandt|Kaufman|Hunt",
    county_fips_all: "48467|48257|48231",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75172,
    lat: 32.60369,
    lng: -96.67458,
    city: "Wilmer",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4814,
    density: 164.4,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75173,
    lat: 33.05986,
    lng: -96.38673,
    city: "Nevada",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4953,
    density: 58.5,
    county_fips: 48085,
    county_name: "Collin",
    county_weights: {
      48085: 100,
    },
    county_names_all: "Collin",
    county_fips_all: 48085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75180,
    lat: 32.71937,
    lng: -96.61841,
    city: "Balch Springs",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23939,
    density: 1188.9,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75181,
    lat: 32.72696,
    lng: -96.555,
    city: "Mesquite",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25264,
    density: 562.8,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75182,
    lat: 32.80033,
    lng: -96.55425,
    city: "Sunnyvale",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6199,
    density: 134.6,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75189,
    lat: 32.94821,
    lng: -96.30941,
    city: "Royse City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30842,
    density: 108.4,
    county_fips: 48397,
    county_name: "Rockwall",
    county_weights: {
      48085: 19.45,
      48231: 38.22,
      48397: 42.33,
    },
    county_names_all: "Rockwall|Hunt|Collin",
    county_fips_all: "48397|48231|48085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75201,
    lat: 32.78826,
    lng: -96.79953,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18032,
    density: 5059,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75202,
    lat: 32.77843,
    lng: -96.8037,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2739,
    density: 1582.1,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75203,
    lat: 32.74439,
    lng: -96.80206,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18295,
    density: 1475,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75204,
    lat: 32.80216,
    lng: -96.78885,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32032,
    density: 4832.7,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75205,
    lat: 32.83657,
    lng: -96.79617,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24726,
    density: 2184.6,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75206,
    lat: 32.83161,
    lng: -96.77032,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39653,
    density: 3615,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75207,
    lat: 32.78693,
    lng: -96.82181,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7715,
    density: 771.8,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75208,
    lat: 32.75409,
    lng: -96.83943,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30064,
    density: 1897.1,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75209,
    lat: 32.8487,
    lng: -96.8257,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14558,
    density: 1606,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75210,
    lat: 32.77141,
    lng: -96.74618,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9504,
    density: 1605.6,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75211,
    lat: 32.73649,
    lng: -96.90214,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 77920,
    density: 1750.3,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75212,
    lat: 32.78203,
    lng: -96.87853,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28017,
    density: 1084.9,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75214,
    lat: 32.82899,
    lng: -96.74348,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34658,
    density: 1831.4,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75215,
    lat: 32.75259,
    lng: -96.76075,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17184,
    density: 866.9,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75216,
    lat: 32.71158,
    lng: -96.78256,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54253,
    density: 1411.8,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75217,
    lat: 32.71291,
    lng: -96.68243,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 86811,
    density: 1207.5,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75218,
    lat: 32.84136,
    lng: -96.70357,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22712,
    density: 1271.1,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75219,
    lat: 32.81087,
    lng: -96.81315,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24038,
    density: 4054.4,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75220,
    lat: 32.86692,
    lng: -96.87571,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41110,
    density: 1402.9,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75223,
    lat: 32.79255,
    lng: -96.74556,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15002,
    density: 1868.8,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75224,
    lat: 32.71117,
    lng: -96.83953,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37602,
    density: 2529,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75225,
    lat: 32.86511,
    lng: -96.79109,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22108,
    density: 1829.3,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75226,
    lat: 32.78315,
    lng: -96.77654,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4774,
    density: 1710.8,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75227,
    lat: 32.77044,
    lng: -96.68831,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60632,
    density: 2025.2,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75228,
    lat: 32.82456,
    lng: -96.6805,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75303,
    density: 2541.7,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75229,
    lat: 32.8939,
    lng: -96.86517,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32739,
    density: 1015.6,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75230,
    lat: 32.90202,
    lng: -96.79226,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27402,
    density: 1482.8,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75231,
    lat: 32.87695,
    lng: -96.74967,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40987,
    density: 2870.4,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75232,
    lat: 32.65878,
    lng: -96.83968,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32823,
    density: 1436,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75233,
    lat: 32.70444,
    lng: -96.87271,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16920,
    density: 1829.9,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75234,
    lat: 32.92423,
    lng: -96.88904,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39644,
    density: 1493.6,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75235,
    lat: 32.83219,
    lng: -96.84798,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19198,
    density: 1113.2,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75236,
    lat: 32.6866,
    lng: -96.93455,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16920,
    density: 489.5,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75237,
    lat: 32.66489,
    lng: -96.87238,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21607,
    density: 1251.6,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75238,
    lat: 32.87855,
    lng: -96.70785,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33396,
    density: 1959.1,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75240,
    lat: 32.93194,
    lng: -96.78924,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26841,
    density: 2742.7,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75241,
    lat: 32.667,
    lng: -96.75903,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30863,
    density: 471.6,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75243,
    lat: 32.91232,
    lng: -96.73633,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68253,
    density: 2861.4,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75244,
    lat: 32.92544,
    lng: -96.83671,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13552,
    density: 1132.5,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75246,
    lat: 32.79296,
    lng: -96.77322,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2553,
    density: 2113.8,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75247,
    lat: 32.81417,
    lng: -96.87803,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 772,
    density: 45,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75248,
    lat: 32.96957,
    lng: -96.79542,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37602,
    density: 1955.5,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48085: 0.59,
      48113: 99.41,
    },
    county_names_all: "Dallas|Collin",
    county_fips_all: "48113|48085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75249,
    lat: 32.6449,
    lng: -96.96257,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18374,
    density: 1291.4,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75251,
    lat: 32.91984,
    lng: -96.77308,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3750,
    density: 2435.6,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75252,
    lat: 32.99696,
    lng: -96.78983,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27880,
    density: 2097.8,
    county_fips: 48085,
    county_name: "Collin",
    county_weights: {
      48085: 92.3,
      48113: 7.7,
    },
    county_names_all: "Collin|Dallas",
    county_fips_all: "48085|48113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75253,
    lat: 32.67278,
    lng: -96.61171,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24666,
    density: 637.3,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75254,
    lat: 32.94571,
    lng: -96.80127,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26700,
    density: 3177,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75261,
    lat: 32.88568,
    lng: -97.05419,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75270,
    lat: 32.78126,
    lng: -96.80192,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75287,
    lat: 33.00015,
    lng: -96.84075,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55060,
    density: 3839.1,
    county_fips: 48085,
    county_name: "Collin",
    county_weights: {
      48085: 58.42,
      48113: 0.28,
      48121: 41.3,
    },
    county_names_all: "Collin|Denton|Dallas",
    county_fips_all: "48085|48121|48113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75390,
    lat: 32.814,
    lng: -96.84283,
    city: "Dallas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48113,
    county_name: "Dallas",
    county_weights: {
      48113: 100,
    },
    county_names_all: "Dallas",
    county_fips_all: 48113,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75401,
    lat: 33.18506,
    lng: -96.11556,
    city: "Greenville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20689,
    density: 73.9,
    county_fips: 48231,
    county_name: "Hunt",
    county_weights: {
      48231: 100,
    },
    county_names_all: "Hunt",
    county_fips_all: 48231,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75402,
    lat: 33.06724,
    lng: -96.08576,
    city: "Greenville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17463,
    density: 74.2,
    county_fips: 48231,
    county_name: "Hunt",
    county_weights: {
      48231: 100,
    },
    county_names_all: "Hunt",
    county_fips_all: 48231,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75407,
    lat: 33.1512,
    lng: -96.48808,
    city: "Princeton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18371,
    density: 142,
    county_fips: 48085,
    county_name: "Collin",
    county_weights: {
      48085: 100,
    },
    county_names_all: "Collin",
    county_fips_all: 48085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75409,
    lat: 33.35223,
    lng: -96.52808,
    city: "Anna",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16750,
    density: 82.6,
    county_fips: 48085,
    county_name: "Collin",
    county_weights: {
      48085: 100,
    },
    county_names_all: "Collin",
    county_fips_all: 48085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75410,
    lat: 32.7921,
    lng: -95.63705,
    city: "Alba",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4332,
    density: 19.5,
    county_fips: 48499,
    county_name: "Wood",
    county_weights: {
      48379: 44.02,
      48499: 55.98,
    },
    county_names_all: "Wood|Rains",
    county_fips_all: "48499|48379",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75411,
    lat: 33.86275,
    lng: -95.63955,
    city: "Arthur City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 740,
    density: 3.6,
    county_fips: 48277,
    county_name: "Lamar",
    county_weights: {
      48277: 100,
    },
    county_names_all: "Lamar",
    county_fips_all: 48277,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75412,
    lat: 33.80295,
    lng: -95.14232,
    city: "Bagwell",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 659,
    density: 2,
    county_fips: 48387,
    county_name: "Red River",
    county_weights: {
      48387: 100,
    },
    county_names_all: "Red River",
    county_fips_all: 48387,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75413,
    lat: 33.43596,
    lng: -96.16477,
    city: "Bailey",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 287,
    density: 438.7,
    county_fips: 48147,
    county_name: "Fannin",
    county_weights: {
      48147: 100,
    },
    county_names_all: "Fannin",
    county_fips_all: 48147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75414,
    lat: 33.62504,
    lng: -96.43193,
    city: "Bells",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3394,
    density: 26.5,
    county_fips: 48181,
    county_name: "Grayson",
    county_weights: {
      48147: 0.12,
      48181: 99.88,
    },
    county_names_all: "Grayson|Fannin",
    county_fips_all: "48181|48147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75415,
    lat: 33.4645,
    lng: -95.74603,
    city: "Ben Franklin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 353,
    density: 7.5,
    county_fips: 48119,
    county_name: "Delta",
    county_weights: {
      48119: 100,
    },
    county_names_all: "Delta",
    county_fips_all: 48119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75416,
    lat: 33.67255,
    lng: -95.35431,
    city: "Blossom",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2946,
    density: 14.9,
    county_fips: 48277,
    county_name: "Lamar",
    county_weights: {
      48277: 98.83,
      48387: 1.17,
    },
    county_names_all: "Lamar|Red River",
    county_fips_all: "48277|48387",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75417,
    lat: 33.43827,
    lng: -95.13114,
    city: "Bogata",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2563,
    density: 6.1,
    county_fips: 48387,
    county_name: "Red River",
    county_weights: {
      48387: 100,
    },
    county_names_all: "Red River",
    county_fips_all: 48387,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75418,
    lat: 33.57235,
    lng: -96.1773,
    city: "Bonham",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14570,
    density: 40,
    county_fips: 48147,
    county_name: "Fannin",
    county_weights: {
      48147: 100,
    },
    county_names_all: "Fannin",
    county_fips_all: 48147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75420,
    lat: 33.05782,
    lng: -95.72503,
    city: "Brashear",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1135,
    density: 12.4,
    county_fips: 48223,
    county_name: "Hopkins",
    county_weights: {
      48223: 99.1,
      48379: 0.9,
    },
    county_names_all: "Hopkins|Rains",
    county_fips_all: "48223|48379",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75421,
    lat: 33.6448,
    lng: -95.71809,
    city: "Brookston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 719,
    density: 5.2,
    county_fips: 48277,
    county_name: "Lamar",
    county_weights: {
      48277: 100,
    },
    county_names_all: "Lamar",
    county_fips_all: 48277,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75422,
    lat: 33.13889,
    lng: -95.93059,
    city: "Campbell",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3084,
    density: 17.6,
    county_fips: 48231,
    county_name: "Hunt",
    county_weights: {
      48231: 100,
    },
    county_names_all: "Hunt",
    county_fips_all: 48231,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75423,
    lat: 33.29279,
    lng: -96.19918,
    city: "Celeste",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3423,
    density: 16.3,
    county_fips: 48231,
    county_name: "Hunt",
    county_weights: {
      48147: 5.78,
      48231: 94.22,
    },
    county_names_all: "Hunt|Fannin",
    county_fips_all: "48231|48147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75424,
    lat: 33.30535,
    lng: -96.39059,
    city: "Blue Ridge",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2891,
    density: 17.6,
    county_fips: 48085,
    county_name: "Collin",
    county_weights: {
      48085: 91.96,
      48147: 8.04,
    },
    county_names_all: "Collin|Fannin",
    county_fips_all: "48085|48147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75426,
    lat: 33.65608,
    lng: -95.01093,
    city: "Clarksville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4177,
    density: 5,
    county_fips: 48387,
    county_name: "Red River",
    county_weights: {
      48387: 100,
    },
    county_names_all: "Red River",
    county_fips_all: 48387,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75428,
    lat: 33.27132,
    lng: -95.91799,
    city: "Commerce",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11474,
    density: 47.7,
    county_fips: 48231,
    county_name: "Hunt",
    county_weights: {
      48119: 16.74,
      48231: 83.26,
    },
    county_names_all: "Hunt|Delta",
    county_fips_all: "48231|48119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75429,
    lat: 33.27847,
    lng: -95.89231,
    city: "Commerce",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48231,
    county_name: "Hunt",
    county_weights: {
      48231: 100,
    },
    county_names_all: "Hunt",
    county_fips_all: 48231,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75431,
    lat: 33.0073,
    lng: -95.4628,
    city: "Como",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1871,
    density: 11.3,
    county_fips: 48223,
    county_name: "Hopkins",
    county_weights: {
      48223: 76.47,
      48499: 23.53,
    },
    county_names_all: "Hopkins|Wood",
    county_fips_all: "48223|48499",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75432,
    lat: 33.38912,
    lng: -95.66804,
    city: "Cooper",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3196,
    density: 12,
    county_fips: 48119,
    county_name: "Delta",
    county_weights: {
      48119: 100,
    },
    county_names_all: "Delta",
    county_fips_all: 48119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75433,
    lat: 33.10883,
    lng: -95.80571,
    city: "Cumby",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3115,
    density: 12.3,
    county_fips: 48223,
    county_name: "Hopkins",
    county_weights: {
      48223: 98.08,
      48231: 1.92,
    },
    county_names_all: "Hopkins|Hunt",
    county_fips_all: "48223|48231",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75434,
    lat: 33.41258,
    lng: -95.35171,
    city: "Cunningham",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48277,
    county_name: "Lamar",
    county_weights: {
      48277: 100,
    },
    county_names_all: "Lamar",
    county_fips_all: 48277,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75435,
    lat: 33.50175,
    lng: -95.29522,
    city: "Deport",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1146,
    density: 7.6,
    county_fips: 48277,
    county_name: "Lamar",
    county_weights: {
      48277: 54.39,
      48387: 45.61,
    },
    county_names_all: "Lamar|Red River",
    county_fips_all: "48277|48387",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75436,
    lat: 33.73507,
    lng: -95.24904,
    city: "Detroit",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2122,
    density: 4.4,
    county_fips: 48387,
    county_name: "Red River",
    county_weights: {
      48277: 6.37,
      48387: 93.63,
    },
    county_names_all: "Red River|Lamar",
    county_fips_all: "48387|48277",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75437,
    lat: 33.25605,
    lng: -95.46567,
    city: "Dike",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1144,
    density: 7.3,
    county_fips: 48223,
    county_name: "Hopkins",
    county_weights: {
      48223: 100,
    },
    county_names_all: "Hopkins",
    county_fips_all: 48223,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75438,
    lat: 33.60701,
    lng: -96.07462,
    city: "Dodd City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 973,
    density: 9.9,
    county_fips: 48147,
    county_name: "Fannin",
    county_weights: {
      48147: 100,
    },
    county_names_all: "Fannin",
    county_fips_all: 48147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75439,
    lat: 33.55261,
    lng: -96.27796,
    city: "Ector",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1186,
    density: 30.9,
    county_fips: 48147,
    county_name: "Fannin",
    county_weights: {
      48147: 100,
    },
    county_names_all: "Fannin",
    county_fips_all: 48147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75440,
    lat: 32.87507,
    lng: -95.75262,
    city: "Emory",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7112,
    density: 26.9,
    county_fips: 48379,
    county_name: "Rains",
    county_weights: {
      48223: 1.6,
      48379: 97.7,
      48499: 0.7,
    },
    county_names_all: "Rains|Hopkins|Wood",
    county_fips_all: "48379|48223|48499",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75441,
    lat: 33.4296,
    lng: -95.65456,
    city: "Enloe",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 192,
    density: 12.4,
    county_fips: 48119,
    county_name: "Delta",
    county_weights: {
      48119: 100,
    },
    county_names_all: "Delta",
    county_fips_all: 48119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75442,
    lat: 33.17717,
    lng: -96.35035,
    city: "Farmersville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9558,
    density: 34.3,
    county_fips: 48085,
    county_name: "Collin",
    county_weights: {
      48085: 84.75,
      48231: 15.25,
    },
    county_names_all: "Collin|Hunt",
    county_fips_all: "48085|48231",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75446,
    lat: 33.61385,
    lng: -95.89177,
    city: "Honey Grove",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3415,
    density: 7.3,
    county_fips: 48147,
    county_name: "Fannin",
    county_weights: {
      48147: 75.26,
      48277: 24.74,
    },
    county_names_all: "Fannin|Lamar",
    county_fips_all: "48147|48277",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75447,
    lat: 33.765,
    lng: -96.11966,
    city: "Ivanhoe",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1201,
    density: 8.8,
    county_fips: 48147,
    county_name: "Fannin",
    county_weights: {
      48147: 100,
    },
    county_names_all: "Fannin",
    county_fips_all: 48147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75448,
    lat: 33.31478,
    lng: -95.79681,
    city: "Klondike",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 784,
    density: 11.7,
    county_fips: 48119,
    county_name: "Delta",
    county_weights: {
      48119: 100,
    },
    county_names_all: "Delta",
    county_fips_all: 48119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75449,
    lat: 33.423,
    lng: -95.9493,
    city: "Ladonia",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1247,
    density: 6.2,
    county_fips: 48147,
    county_name: "Fannin",
    county_weights: {
      48147: 69.38,
      48231: 30.62,
    },
    county_names_all: "Fannin|Hunt",
    county_fips_all: "48147|48231",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75450,
    lat: 33.40465,
    lng: -95.47481,
    city: "Lake Creek",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 197,
    density: 1.3,
    county_fips: 48119,
    county_name: "Delta",
    county_weights: {
      48119: 100,
    },
    county_names_all: "Delta",
    county_fips_all: 48119,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75451,
    lat: 32.96247,
    lng: -95.11835,
    city: "Leesburg",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1375,
    density: 13.5,
    county_fips: 48063,
    county_name: "Camp",
    county_weights: {
      48063: 88.35,
      48459: 3.14,
      48499: 8.51,
    },
    county_names_all: "Camp|Wood|Upshur",
    county_fips_all: "48063|48499|48459",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75452,
    lat: 33.39284,
    lng: -96.24469,
    city: "Leonard",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4673,
    density: 23.5,
    county_fips: 48147,
    county_name: "Fannin",
    county_weights: {
      48085: 5.11,
      48147: 79.65,
      48231: 15.24,
    },
    county_names_all: "Fannin|Hunt|Collin",
    county_fips_all: "48147|48231|48085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75453,
    lat: 33.00025,
    lng: -95.92817,
    city: "Lone Oak",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2661,
    density: 13.1,
    county_fips: 48231,
    county_name: "Hunt",
    county_weights: {
      48223: 9.74,
      48231: 74.91,
      48379: 15.35,
    },
    county_names_all: "Hunt|Rains|Hopkins",
    county_fips_all: "48231|48379|48223",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75454,
    lat: 33.283,
    lng: -96.56073,
    city: "Melissa",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11848,
    density: 213.8,
    county_fips: 48085,
    county_name: "Collin",
    county_weights: {
      48085: 100,
    },
    county_names_all: "Collin",
    county_fips_all: 48085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75455,
    lat: 33.21725,
    lng: -94.98022,
    city: "Mount Pleasant",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27700,
    density: 34.9,
    county_fips: 48449,
    county_name: "Titus",
    county_weights: {
      48159: 3.68,
      48449: 96.32,
    },
    county_names_all: "Titus|Franklin",
    county_fips_all: "48449|48159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75457,
    lat: 33.1746,
    lng: -95.21125,
    city: "Mount Vernon",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6243,
    density: 18.8,
    county_fips: 48159,
    county_name: "Franklin",
    county_weights: {
      48159: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 48159,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75459,
    lat: 33.52988,
    lng: -96.6831,
    city: "Howe",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5260,
    density: 24.8,
    county_fips: 48181,
    county_name: "Grayson",
    county_weights: {
      48181: 100,
    },
    county_names_all: "Grayson",
    county_fips_all: 48181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75460,
    lat: 33.6627,
    lng: -95.60296,
    city: "Paris",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23926,
    density: 90.7,
    county_fips: 48277,
    county_name: "Lamar",
    county_weights: {
      48277: 100,
    },
    county_names_all: "Lamar",
    county_fips_all: 48277,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75462,
    lat: 33.62166,
    lng: -95.48362,
    city: "Paris",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11652,
    density: 23.3,
    county_fips: 48277,
    county_name: "Lamar",
    county_weights: {
      48277: 100,
    },
    county_names_all: "Lamar",
    county_fips_all: 48277,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75468,
    lat: 33.51175,
    lng: -95.40747,
    city: "Pattonville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1228,
    density: 9.3,
    county_fips: 48277,
    county_name: "Lamar",
    county_weights: {
      48277: 100,
    },
    county_names_all: "Lamar",
    county_fips_all: 48277,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75469,
    lat: 33.41269,
    lng: -95.8248,
    city: "Pecan Gap",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 310,
    density: 3.3,
    county_fips: 48119,
    county_name: "Delta",
    county_weights: {
      48119: 85.82,
      48231: 14.18,
    },
    county_names_all: "Delta|Hunt",
    county_fips_all: "48119|48231",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75470,
    lat: 33.58341,
    lng: -95.79836,
    city: "Petty",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 147,
    density: 3.9,
    county_fips: 48277,
    county_name: "Lamar",
    county_weights: {
      48277: 100,
    },
    county_names_all: "Lamar",
    county_fips_all: 48277,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75471,
    lat: 33.04431,
    lng: -95.38883,
    city: "Pickton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1808,
    density: 13.9,
    county_fips: 48223,
    county_name: "Hopkins",
    county_weights: {
      48223: 94.6,
      48499: 5.4,
    },
    county_names_all: "Hopkins|Wood",
    county_fips_all: "48223|48499",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75472,
    lat: 32.89177,
    lng: -95.87239,
    city: "Point",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4014,
    density: 20.6,
    county_fips: 48379,
    county_name: "Rains",
    county_weights: {
      48223: 0.94,
      48379: 99.06,
    },
    county_names_all: "Rains|Hopkins",
    county_fips_all: "48379|48223",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75473,
    lat: 33.81461,
    lng: -95.48433,
    city: "Powderly",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3443,
    density: 19.2,
    county_fips: 48277,
    county_name: "Lamar",
    county_weights: {
      48277: 100,
    },
    county_names_all: "Lamar",
    county_fips_all: 48277,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75474,
    lat: 32.91709,
    lng: -96.10611,
    city: "Quinlan",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15912,
    density: 58.3,
    county_fips: 48231,
    county_name: "Hunt",
    county_weights: {
      48231: 96.28,
      48257: 3.72,
    },
    county_names_all: "Hunt|Kaufman",
    county_fips_all: "48231|48257",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75475,
    lat: 33.48593,
    lng: -96.25757,
    city: "Randolph",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 111,
    density: 94.9,
    county_fips: 48147,
    county_name: "Fannin",
    county_weights: {
      48147: 100,
    },
    county_names_all: "Fannin",
    county_fips_all: 48147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75476,
    lat: 33.70793,
    lng: -96.24342,
    city: "Ravenna",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1031,
    density: 7.9,
    county_fips: 48147,
    county_name: "Fannin",
    county_weights: {
      48147: 100,
    },
    county_names_all: "Fannin",
    county_fips_all: 48147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75477,
    lat: 33.53118,
    lng: -95.73429,
    city: "Roxton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1172,
    density: 7.7,
    county_fips: 48277,
    county_name: "Lamar",
    county_weights: {
      48277: 100,
    },
    county_names_all: "Lamar",
    county_fips_all: 48277,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75478,
    lat: 33.17276,
    lng: -95.35226,
    city: "Saltillo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 947,
    density: 6.5,
    county_fips: 48223,
    county_name: "Hopkins",
    county_weights: {
      48159: 8.43,
      48223: 91.57,
    },
    county_names_all: "Hopkins|Franklin",
    county_fips_all: "48223|48159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75479,
    lat: 33.63007,
    lng: -96.3386,
    city: "Savoy",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1987,
    density: 16.3,
    county_fips: 48147,
    county_name: "Fannin",
    county_weights: {
      48147: 97.06,
      48181: 2.94,
    },
    county_names_all: "Fannin|Grayson",
    county_fips_all: "48147|48181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75480,
    lat: 33.02129,
    lng: -95.19159,
    city: "Scroggins",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2030,
    density: 26.4,
    county_fips: 48159,
    county_name: "Franklin",
    county_weights: {
      48159: 97.35,
      48499: 2.65,
    },
    county_names_all: "Franklin|Wood",
    county_fips_all: "48159|48499",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75481,
    lat: 33.31751,
    lng: -95.37485,
    city: "Sulphur Bluff",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 412,
    density: 2.3,
    county_fips: 48223,
    county_name: "Hopkins",
    county_weights: {
      48159: 7.39,
      48223: 92.61,
    },
    county_names_all: "Hopkins|Franklin",
    county_fips_all: "48223|48159",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75482,
    lat: 33.16929,
    lng: -95.60946,
    city: "Sulphur Springs",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25108,
    density: 30.9,
    county_fips: 48223,
    county_name: "Hopkins",
    county_weights: {
      48223: 100,
    },
    county_names_all: "Hopkins",
    county_fips_all: 48223,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75486,
    lat: 33.75757,
    lng: -95.74663,
    city: "Sumner",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2311,
    density: 8.2,
    county_fips: 48277,
    county_name: "Lamar",
    county_weights: {
      48277: 100,
    },
    county_names_all: "Lamar",
    county_fips_all: 48277,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75487,
    lat: 33.33584,
    lng: -95.16567,
    city: "Talco",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1846,
    density: 7.2,
    county_fips: 48159,
    county_name: "Franklin",
    county_weights: {
      48159: 66.4,
      48449: 33.6,
    },
    county_names_all: "Franklin|Titus",
    county_fips_all: "48159|48449",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75488,
    lat: 33.77628,
    lng: -95.98899,
    city: "Telephone",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 747,
    density: 2.4,
    county_fips: 48147,
    county_name: "Fannin",
    county_weights: {
      48147: 100,
    },
    county_names_all: "Fannin",
    county_fips_all: 48147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75489,
    lat: 33.5204,
    lng: -96.48467,
    city: "Tom Bean",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1110,
    density: 178.2,
    county_fips: 48181,
    county_name: "Grayson",
    county_weights: {
      48181: 100,
    },
    county_names_all: "Grayson",
    county_fips_all: 48181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75490,
    lat: 33.4363,
    lng: -96.30771,
    city: "Trenton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2633,
    density: 31,
    county_fips: 48147,
    county_name: "Fannin",
    county_weights: {
      48147: 96.78,
      48181: 3.22,
    },
    county_names_all: "Fannin|Grayson",
    county_fips_all: "48147|48181",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75491,
    lat: 33.49741,
    lng: -96.39485,
    city: "Whitewright",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4781,
    density: 18.7,
    county_fips: 48181,
    county_name: "Grayson",
    county_weights: {
      48085: 0.62,
      48147: 40.95,
      48181: 58.43,
    },
    county_names_all: "Grayson|Fannin|Collin",
    county_fips_all: "48181|48147|48085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75492,
    lat: 33.59139,
    lng: -96.0004,
    city: "Windom",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 369,
    density: 2.9,
    county_fips: 48147,
    county_name: "Fannin",
    county_weights: {
      48147: 100,
    },
    county_names_all: "Fannin",
    county_fips_all: 48147,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75493,
    lat: 33.14073,
    lng: -95.11316,
    city: "Winfield",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 589,
    density: 57.6,
    county_fips: 48449,
    county_name: "Titus",
    county_weights: {
      48449: 100,
    },
    county_names_all: "Titus",
    county_fips_all: 48449,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75494,
    lat: 32.90898,
    lng: -95.26126,
    city: "Winnsboro",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10741,
    density: 18,
    county_fips: 48499,
    county_name: "Wood",
    county_weights: {
      48159: 17.5,
      48223: 10.12,
      48459: 3.05,
      48499: 69.33,
    },
    county_names_all: "Wood|Franklin|Hopkins|Upshur",
    county_fips_all: "48499|48159|48223|48459",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75495,
    lat: 33.43246,
    lng: -96.55041,
    city: "Van Alstyne",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8621,
    density: 49.2,
    county_fips: 48181,
    county_name: "Grayson",
    county_weights: {
      48085: 5.54,
      48181: 94.46,
    },
    county_names_all: "Grayson|Collin",
    county_fips_all: "48181|48085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75496,
    lat: 33.36276,
    lng: -96.06616,
    city: "Wolfe City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3450,
    density: 11.4,
    county_fips: 48231,
    county_name: "Hunt",
    county_weights: {
      48147: 40.92,
      48231: 59.08,
    },
    county_names_all: "Hunt|Fannin",
    county_fips_all: "48231|48147",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75497,
    lat: 32.92098,
    lng: -95.5764,
    city: "Yantis",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3963,
    density: 24.4,
    county_fips: 48499,
    county_name: "Wood",
    county_weights: {
      48223: 19.4,
      48379: 0.17,
      48499: 80.43,
    },
    county_names_all: "Wood|Hopkins|Rains",
    county_fips_all: "48499|48223|48379",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75501,
    lat: 33.37413,
    lng: -94.13168,
    city: "Texarkana",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35352,
    density: 141.8,
    county_fips: 48037,
    county_name: "Bowie",
    county_weights: {
      48037: 100,
    },
    county_names_all: "Bowie",
    county_fips_all: 48037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75503,
    lat: 33.51345,
    lng: -94.13038,
    city: "Texarkana",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26843,
    density: 132.1,
    county_fips: 48037,
    county_name: "Bowie",
    county_weights: {
      48037: 100,
    },
    county_names_all: "Bowie",
    county_fips_all: 48037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75550,
    lat: 33.49966,
    lng: -94.88454,
    city: "Annona",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 775,
    density: 3.3,
    county_fips: 48387,
    county_name: "Red River",
    county_weights: {
      48387: 100,
    },
    county_names_all: "Red River",
    county_fips_all: 48387,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75551,
    lat: 33.11648,
    lng: -94.20325,
    city: "Atlanta",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11268,
    density: 26.9,
    county_fips: 48067,
    county_name: "Cass",
    county_weights: {
      48067: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 48067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75554,
    lat: 33.58534,
    lng: -94.78563,
    city: "Avery",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2356,
    density: 6.3,
    county_fips: 48387,
    county_name: "Red River",
    county_weights: {
      48037: 18.94,
      48387: 81.06,
    },
    county_names_all: "Red River|Bowie",
    county_fips_all: "48387|48037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75555,
    lat: 32.94564,
    lng: -94.13696,
    city: "Bivins",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1477,
    density: 4.7,
    county_fips: 48067,
    county_name: "Cass",
    county_weights: {
      48067: 91.2,
      48315: 8.8,
    },
    county_names_all: "Cass|Marion",
    county_fips_all: "48067|48315",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75556,
    lat: 33.1512,
    lng: -94.06263,
    city: "Bloomburg",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1292,
    density: 21,
    county_fips: 48067,
    county_name: "Cass",
    county_weights: {
      48067: 99.37,
      "05091": 0.63,
    },
    county_names_all: "Cass|Miller",
    county_fips_all: "48067|05091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75558,
    lat: 33.25017,
    lng: -94.85564,
    city: "Cookville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2216,
    density: 21.1,
    county_fips: 48449,
    county_name: "Titus",
    county_weights: {
      48343: 0.96,
      48449: 99.04,
    },
    county_names_all: "Titus|Morris",
    county_fips_all: "48449|48343",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75559,
    lat: 33.49929,
    lng: -94.63931,
    city: "De Kalb",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5263,
    density: 7,
    county_fips: 48037,
    county_name: "Bowie",
    county_weights: {
      48037: 91.92,
      48387: 8.08,
    },
    county_names_all: "Bowie|Red River",
    county_fips_all: "48037|48387",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75560,
    lat: 33.1957,
    lng: -94.36699,
    city: "Douglassville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1170,
    density: 6.4,
    county_fips: 48067,
    county_name: "Cass",
    county_weights: {
      48067: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 48067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75561,
    lat: 33.517,
    lng: -94.27855,
    city: "Hooks",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5135,
    density: 42.7,
    county_fips: 48037,
    county_name: "Bowie",
    county_weights: {
      48037: 100,
    },
    county_names_all: "Bowie",
    county_fips_all: 48037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75562,
    lat: 32.93588,
    lng: -94.25302,
    city: "Kildare",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 133,
    density: 4.9,
    county_fips: 48067,
    county_name: "Cass",
    county_weights: {
      48067: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 48067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75563,
    lat: 33.01835,
    lng: -94.38871,
    city: "Linden",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4225,
    density: 10.2,
    county_fips: 48067,
    county_name: "Cass",
    county_weights: {
      48067: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 48067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75564,
    lat: 32.88784,
    lng: -94.24962,
    city: "Lodi",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48067,
    county_name: "Cass",
    county_weights: {
      48067: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 48067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75565,
    lat: 32.95202,
    lng: -94.07527,
    city: "McLeod",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 419,
    density: 137.7,
    county_fips: 48067,
    county_name: "Cass",
    county_weights: {
      48067: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 48067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75566,
    lat: 33.15256,
    lng: -94.49018,
    city: "Marietta",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 686,
    density: 5.6,
    county_fips: 48067,
    county_name: "Cass",
    county_weights: {
      48067: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 48067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75567,
    lat: 33.31688,
    lng: -94.31935,
    city: "Maud",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4655,
    density: 24.2,
    county_fips: 48037,
    county_name: "Bowie",
    county_weights: {
      48037: 100,
    },
    county_names_all: "Bowie",
    county_fips_all: 48037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75568,
    lat: 33.19607,
    lng: -94.59362,
    city: "Naples",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2350,
    density: 6.9,
    county_fips: 48067,
    county_name: "Cass",
    county_weights: {
      48067: 73.75,
      48343: 26.25,
    },
    county_names_all: "Cass|Morris",
    county_fips_all: "48067|48343",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75569,
    lat: 33.44127,
    lng: -94.12292,
    city: "Nash",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3554,
    density: 587.4,
    county_fips: 48037,
    county_name: "Bowie",
    county_weights: {
      48037: 100,
    },
    county_names_all: "Bowie",
    county_fips_all: 48037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75570,
    lat: 33.4649,
    lng: -94.4389,
    city: "New Boston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10703,
    density: 31.1,
    county_fips: 48037,
    county_name: "Bowie",
    county_weights: {
      48037: 100,
    },
    county_names_all: "Bowie",
    county_fips_all: 48037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75571,
    lat: 33.20704,
    lng: -94.76407,
    city: "Omaha",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2909,
    density: 9.8,
    county_fips: 48343,
    county_name: "Morris",
    county_weights: {
      48343: 92.33,
      48449: 7.67,
    },
    county_names_all: "Morris|Titus",
    county_fips_all: "48343|48449",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75572,
    lat: 33.23114,
    lng: -94.12934,
    city: "Queen City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3594,
    density: 18.8,
    county_fips: 48067,
    county_name: "Cass",
    county_weights: {
      48067: 100,
    },
    county_names_all: "Cass",
    county_fips_all: 48067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75573,
    lat: 33.34214,
    lng: -94.22454,
    city: "Redwater",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45,
    density: 2.5,
    county_fips: 48037,
    county_name: "Bowie",
    county_weights: {
      48037: 100,
    },
    county_names_all: "Bowie",
    county_fips_all: 48037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75574,
    lat: 33.32892,
    lng: -94.55229,
    city: "Simms",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1369,
    density: 5.2,
    county_fips: 48037,
    county_name: "Bowie",
    county_weights: {
      48037: 100,
    },
    county_names_all: "Bowie",
    county_fips_all: 48037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75601,
    lat: 32.5086,
    lng: -94.72414,
    city: "Longview",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15256,
    density: 645.7,
    county_fips: 48183,
    county_name: "Gregg",
    county_weights: {
      48183: 77.9,
      48203: 22.1,
    },
    county_names_all: "Gregg|Harrison",
    county_fips_all: "48183|48203",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75602,
    lat: 32.45803,
    lng: -94.65712,
    city: "Longview",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20576,
    density: 153.1,
    county_fips: 48203,
    county_name: "Harrison",
    county_weights: {
      48183: 18.53,
      48203: 81.47,
    },
    county_names_all: "Harrison|Gregg",
    county_fips_all: "48203|48183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75603,
    lat: 32.40448,
    lng: -94.71754,
    city: "Longview",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6452,
    density: 47,
    county_fips: 48183,
    county_name: "Gregg",
    county_weights: {
      48183: 87.47,
      48401: 12.53,
    },
    county_names_all: "Gregg|Rusk",
    county_fips_all: "48183|48401",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75604,
    lat: 32.51374,
    lng: -94.82919,
    city: "Longview",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29922,
    density: 261.8,
    county_fips: 48183,
    county_name: "Gregg",
    county_weights: {
      48183: 97.93,
      48459: 2.07,
    },
    county_names_all: "Gregg|Upshur",
    county_fips_all: "48183|48459",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75605,
    lat: 32.58385,
    lng: -94.71554,
    city: "Longview",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32438,
    density: 156,
    county_fips: 48183,
    county_name: "Gregg",
    county_weights: {
      48183: 58.32,
      48203: 40.7,
      48459: 0.98,
    },
    county_names_all: "Gregg|Harrison|Upshur",
    county_fips_all: "48183|48203|48459",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75630,
    lat: 32.87588,
    lng: -94.5572,
    city: "Avinger",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2104,
    density: 7.6,
    county_fips: 48067,
    county_name: "Cass",
    county_weights: {
      48067: 50.82,
      48315: 49.18,
    },
    county_names_all: "Cass|Marion",
    county_fips_all: "48067|48315",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75631,
    lat: 32.25343,
    lng: -94.44957,
    city: "Beckville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3029,
    density: 9.9,
    county_fips: 48365,
    county_name: "Panola",
    county_weights: {
      48365: 100,
    },
    county_names_all: "Panola",
    county_fips_all: 48365,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75633,
    lat: 32.12788,
    lng: -94.28109,
    city: "Carthage",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12831,
    density: 15.3,
    county_fips: 48365,
    county_name: "Panola",
    county_weights: {
      48365: 100,
    },
    county_names_all: "Panola",
    county_fips_all: 48365,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75638,
    lat: 33.01869,
    lng: -94.73173,
    city: "Daingerfield",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5106,
    density: 23,
    county_fips: 48343,
    county_name: "Morris",
    county_weights: {
      48067: 2.98,
      48343: 97.02,
    },
    county_names_all: "Morris|Cass",
    county_fips_all: "48343|48067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75639,
    lat: 32.28441,
    lng: -94.16897,
    city: "De Berry",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2756,
    density: 6.6,
    county_fips: 48365,
    county_name: "Panola",
    county_weights: {
      48365: 100,
    },
    county_names_all: "Panola",
    county_fips_all: 48365,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75640,
    lat: 32.7152,
    lng: -94.68133,
    city: "Diana",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5181,
    density: 23,
    county_fips: 48203,
    county_name: "Harrison",
    county_weights: {
      48203: 57.64,
      48315: 6.01,
      48459: 36.35,
    },
    county_names_all: "Harrison|Upshur|Marion",
    county_fips_all: "48203|48459|48315",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75641,
    lat: 32.3846,
    lng: -94.5757,
    city: "Easton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 138,
    density: 31.7,
    county_fips: 48401,
    county_name: "Rusk",
    county_weights: {
      48183: 20.98,
      48401: 79.02,
    },
    county_names_all: "Rusk|Gregg",
    county_fips_all: "48401|48183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75642,
    lat: 32.35818,
    lng: -94.17821,
    city: "Elysian Fields",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23,
    density: 2.2,
    county_fips: 48365,
    county_name: "Panola",
    county_weights: {
      48203: 34.35,
      48365: 65.65,
    },
    county_names_all: "Panola|Harrison",
    county_fips_all: "48365|48203",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75643,
    lat: 32.01041,
    lng: -94.35518,
    city: "Gary",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2151,
    density: 11.2,
    county_fips: 48365,
    county_name: "Panola",
    county_weights: {
      48365: 87.09,
      48419: 12.91,
    },
    county_names_all: "Panola|Shelby",
    county_fips_all: "48365|48419",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75644,
    lat: 32.79171,
    lng: -94.99498,
    city: "Gilmer",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13883,
    density: 28.7,
    county_fips: 48459,
    county_name: "Upshur",
    county_weights: {
      48459: 100,
    },
    county_names_all: "Upshur",
    county_fips_all: 48459,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75645,
    lat: 32.68375,
    lng: -94.87317,
    city: "Gilmer",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10393,
    density: 27.7,
    county_fips: 48459,
    county_name: "Upshur",
    county_weights: {
      48183: 2.16,
      48459: 97.84,
    },
    county_names_all: "Upshur|Gregg",
    county_fips_all: "48459|48183",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75647,
    lat: 32.5167,
    lng: -94.96429,
    city: "Gladewater",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12328,
    density: 53.7,
    county_fips: 48183,
    county_name: "Gregg",
    county_weights: {
      48183: 42.7,
      48423: 31.9,
      48459: 25.39,
    },
    county_names_all: "Gregg|Smith|Upshur",
    county_fips_all: "48183|48423|48459",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75650,
    lat: 32.51529,
    lng: -94.55358,
    city: "Hallsville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9775,
    density: 32.2,
    county_fips: 48203,
    county_name: "Harrison",
    county_weights: {
      48203: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 48203,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75651,
    lat: 32.67061,
    lng: -94.53064,
    city: "Harleton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2300,
    density: 16,
    county_fips: 48203,
    county_name: "Harrison",
    county_weights: {
      48203: 90.9,
      48315: 9.1,
    },
    county_names_all: "Harrison|Marion",
    county_fips_all: "48203|48315",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75652,
    lat: 32.2301,
    lng: -94.7281,
    city: "Henderson",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16078,
    density: 36.1,
    county_fips: 48401,
    county_name: "Rusk",
    county_weights: {
      48365: 1.62,
      48401: 98.38,
    },
    county_names_all: "Rusk|Panola",
    county_fips_all: "48401|48365",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75654,
    lat: 32.08299,
    lng: -94.82961,
    city: "Henderson",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12268,
    density: 23.9,
    county_fips: 48401,
    county_name: "Rusk",
    county_weights: {
      48073: 1.07,
      48401: 98.93,
    },
    county_names_all: "Rusk|Cherokee",
    county_fips_all: "48401|48073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75656,
    lat: 33.01471,
    lng: -94.58686,
    city: "Hughes Springs",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4897,
    density: 19,
    county_fips: 48067,
    county_name: "Cass",
    county_weights: {
      48067: 91.66,
      48343: 8.34,
    },
    county_names_all: "Cass|Morris",
    county_fips_all: "48067|48343",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75657,
    lat: 32.79437,
    lng: -94.30498,
    city: "Jefferson",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7274,
    density: 8.1,
    county_fips: 48315,
    county_name: "Marion",
    county_weights: {
      48067: 7.17,
      48203: 4.81,
      48315: 88.02,
    },
    county_names_all: "Marion|Cass|Harrison",
    county_fips_all: "48315|48067|48203",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75658,
    lat: 32.17545,
    lng: -94.90362,
    city: "Joinerville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48401,
    county_name: "Rusk",
    county_weights: {
      48401: 100,
    },
    county_names_all: "Rusk",
    county_fips_all: 48401,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75659,
    lat: 32.50725,
    lng: -94.09249,
    city: "Jonesville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48203,
    county_name: "Harrison",
    county_weights: {
      48203: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 48203,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75661,
    lat: 32.63908,
    lng: -94.15655,
    city: "Karnack",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2586,
    density: 7.8,
    county_fips: 48203,
    county_name: "Harrison",
    county_weights: {
      48203: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 48203,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75662,
    lat: 32.38076,
    lng: -94.87503,
    city: "Kilgore",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26318,
    density: 80.1,
    county_fips: 48183,
    county_name: "Gregg",
    county_weights: {
      48183: 52.8,
      48401: 39.5,
      48423: 7.7,
    },
    county_names_all: "Gregg|Rusk|Smith",
    county_fips_all: "48183|48401|48423",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75667,
    lat: 31.988,
    lng: -94.83729,
    city: "Laneville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1327,
    density: 6,
    county_fips: 48401,
    county_name: "Rusk",
    county_weights: {
      48401: 100,
    },
    county_names_all: "Rusk",
    county_fips_all: 48401,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75668,
    lat: 32.90846,
    lng: -94.68485,
    city: "Lone Star",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2469,
    density: 45.4,
    county_fips: 48343,
    county_name: "Morris",
    county_weights: {
      48315: 21.31,
      48343: 78.69,
    },
    county_names_all: "Morris|Marion",
    county_fips_all: "48343|48315",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75669,
    lat: 32.03348,
    lng: -94.55678,
    city: "Long Branch",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1332,
    density: 9.4,
    county_fips: 48365,
    county_name: "Panola",
    county_weights: {
      48365: 83.37,
      48401: 16.63,
    },
    county_names_all: "Panola|Rusk",
    county_fips_all: "48365|48401",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75670,
    lat: 32.56456,
    lng: -94.42326,
    city: "Marshall",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18263,
    density: 55.2,
    county_fips: 48203,
    county_name: "Harrison",
    county_weights: {
      48203: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 48203,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75671,
    lat: 32.48907,
    lng: -94.31494,
    city: "Marshall",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48203,
    county_name: "Harrison",
    county_weights: {
      48203: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 48203,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75672,
    lat: 32.47076,
    lng: -94.29353,
    city: "Marshall",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16480,
    density: 27.4,
    county_fips: 48203,
    county_name: "Harrison",
    county_weights: {
      48203: 99.74,
      48365: 0.26,
    },
    county_names_all: "Harrison|Panola",
    county_fips_all: "48203|48365",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75680,
    lat: 32.01035,
    lng: -94.71824,
    city: "Minden",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48401,
    county_name: "Rusk",
    county_weights: {
      48401: 100,
    },
    county_names_all: "Rusk",
    county_fips_all: 48401,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75681,
    lat: 31.93597,
    lng: -94.685,
    city: "Mount Enterprise",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2425,
    density: 7,
    county_fips: 48401,
    county_name: "Rusk",
    county_weights: {
      48401: 100,
    },
    county_names_all: "Rusk",
    county_fips_all: 48401,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75682,
    lat: 32.25152,
    lng: -94.94713,
    city: "New London",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 572,
    density: 108.3,
    county_fips: 48401,
    county_name: "Rusk",
    county_weights: {
      48401: 100,
    },
    county_names_all: "Rusk",
    county_fips_all: 48401,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75683,
    lat: 32.82182,
    lng: -94.74035,
    city: "Ore City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4053,
    density: 26.1,
    county_fips: 48459,
    county_name: "Upshur",
    county_weights: {
      48315: 19.32,
      48459: 80.68,
    },
    county_names_all: "Upshur|Marion",
    county_fips_all: "48459|48315",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75684,
    lat: 32.27085,
    lng: -94.93147,
    city: "Overton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8086,
    density: 34,
    county_fips: 48401,
    county_name: "Rusk",
    county_weights: {
      48401: 82.69,
      48423: 17.31,
    },
    county_names_all: "Rusk|Smith",
    county_fips_all: "48401|48423",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75686,
    lat: 32.96921,
    lng: -94.94697,
    city: "Pittsburg",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13483,
    density: 22.4,
    county_fips: 48063,
    county_name: "Camp",
    county_weights: {
      48063: 68.14,
      48343: 1.27,
      48449: 12.87,
      48459: 17.72,
    },
    county_names_all: "Camp|Upshur|Titus|Morris",
    county_fips_all: "48063|48459|48449|48343",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75687,
    lat: 32.10575,
    lng: -94.96352,
    city: "Price",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48401,
    county_name: "Rusk",
    county_weights: {
      48401: 100,
    },
    county_names_all: "Rusk",
    county_fips_all: 48401,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75689,
    lat: 32.18196,
    lng: -94.95771,
    city: "Selman City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48401,
    county_name: "Rusk",
    county_weights: {
      48401: 100,
    },
    county_names_all: "Rusk",
    county_fips_all: 48401,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75691,
    lat: 32.31108,
    lng: -94.55725,
    city: "Tatum",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3963,
    density: 16.1,
    county_fips: 48401,
    county_name: "Rusk",
    county_weights: {
      48365: 20.47,
      48401: 79.53,
    },
    county_names_all: "Rusk|Panola",
    county_fips_all: "48401|48365",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75692,
    lat: 32.4718,
    lng: -94.11936,
    city: "Waskom",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4387,
    density: 17.1,
    county_fips: 48203,
    county_name: "Harrison",
    county_weights: {
      48203: 93.86,
      48365: 6.14,
    },
    county_names_all: "Harrison|Panola",
    county_fips_all: "48203|48365",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75693,
    lat: 32.53364,
    lng: -94.86083,
    city: "White Oak",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6863,
    density: 257.6,
    county_fips: 48183,
    county_name: "Gregg",
    county_weights: {
      48183: 100,
    },
    county_names_all: "Gregg",
    county_fips_all: 48183,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75694,
    lat: 32.6383,
    lng: -94.34442,
    city: "Woodlawn",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48203,
    county_name: "Harrison",
    county_weights: {
      48203: 100,
    },
    county_names_all: "Harrison",
    county_fips_all: 48203,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75701,
    lat: 32.32297,
    lng: -95.29679,
    city: "Tyler",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36089,
    density: 990.5,
    county_fips: 48423,
    county_name: "Smith",
    county_weights: {
      48423: 100,
    },
    county_names_all: "Smith",
    county_fips_all: 48423,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75702,
    lat: 32.36403,
    lng: -95.31207,
    city: "Tyler",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27678,
    density: 757.9,
    county_fips: 48423,
    county_name: "Smith",
    county_weights: {
      48423: 100,
    },
    county_names_all: "Smith",
    county_fips_all: 48423,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75703,
    lat: 32.23825,
    lng: -95.31947,
    city: "Tyler",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42955,
    density: 301.2,
    county_fips: 48423,
    county_name: "Smith",
    county_weights: {
      48423: 100,
    },
    county_names_all: "Smith",
    county_fips_all: 48423,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75704,
    lat: 32.40616,
    lng: -95.4407,
    city: "Tyler",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10367,
    density: 60,
    county_fips: 48423,
    county_name: "Smith",
    county_weights: {
      48423: 100,
    },
    county_names_all: "Smith",
    county_fips_all: 48423,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75705,
    lat: 32.35905,
    lng: -95.10149,
    city: "Tyler",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3138,
    density: 47.1,
    county_fips: 48423,
    county_name: "Smith",
    county_weights: {
      48423: 100,
    },
    county_names_all: "Smith",
    county_fips_all: 48423,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75706,
    lat: 32.46822,
    lng: -95.30402,
    city: "Tyler",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10882,
    density: 55.6,
    county_fips: 48423,
    county_name: "Smith",
    county_weights: {
      48423: 100,
    },
    county_names_all: "Smith",
    county_fips_all: 48423,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75707,
    lat: 32.30479,
    lng: -95.171,
    city: "Tyler",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13206,
    density: 97.3,
    county_fips: 48423,
    county_name: "Smith",
    county_weights: {
      48423: 100,
    },
    county_names_all: "Smith",
    county_fips_all: 48423,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75708,
    lat: 32.41436,
    lng: -95.20717,
    city: "Tyler",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9461,
    density: 64.6,
    county_fips: 48423,
    county_name: "Smith",
    county_weights: {
      48423: 100,
    },
    county_names_all: "Smith",
    county_fips_all: 48423,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75709,
    lat: 32.31323,
    lng: -95.38904,
    city: "Tyler",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4624,
    density: 85.7,
    county_fips: 48423,
    county_name: "Smith",
    county_weights: {
      48423: 100,
    },
    county_names_all: "Smith",
    county_fips_all: 48423,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75711,
    lat: 32.33698,
    lng: -95.28382,
    city: "Tyler",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48423,
    county_name: "Smith",
    county_weights: {
      48423: 100,
    },
    county_names_all: "Smith",
    county_fips_all: 48423,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75750,
    lat: 32.27222,
    lng: -95.07124,
    city: "Arp",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3414,
    density: 27,
    county_fips: 48423,
    county_name: "Smith",
    county_weights: {
      48423: 100,
    },
    county_names_all: "Smith",
    county_fips_all: 48423,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75751,
    lat: 32.07875,
    lng: -95.91661,
    city: "Athens",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17356,
    density: 37.2,
    county_fips: 48213,
    county_name: "Henderson",
    county_weights: {
      48001: 31.99,
      48213: 68.01,
    },
    county_names_all: "Henderson|Anderson",
    county_fips_all: "48213|48001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75752,
    lat: 32.24239,
    lng: -95.80751,
    city: "Athens",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7263,
    density: 18.6,
    county_fips: 48213,
    county_name: "Henderson",
    county_weights: {
      48001: 0.78,
      48213: 89.66,
      48467: 9.56,
    },
    county_names_all: "Henderson|Van Zandt|Anderson",
    county_fips_all: "48213|48467|48001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75754,
    lat: 32.42431,
    lng: -95.66462,
    city: "Ben Wheeler",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8021,
    density: 24.6,
    county_fips: 48467,
    county_name: "Van Zandt",
    county_weights: {
      48467: 100,
    },
    county_names_all: "Van Zandt",
    county_fips_all: 48467,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75755,
    lat: 32.63236,
    lng: -95.08662,
    city: "Big Sandy",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4805,
    density: 18.3,
    county_fips: 48459,
    county_name: "Upshur",
    county_weights: {
      48459: 95.29,
      48499: 4.71,
    },
    county_names_all: "Upshur|Wood",
    county_fips_all: "48459|48499",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75756,
    lat: 32.30031,
    lng: -95.59771,
    city: "Brownsboro",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4332,
    density: 22.7,
    county_fips: 48213,
    county_name: "Henderson",
    county_weights: {
      48213: 96.84,
      48467: 3.16,
    },
    county_names_all: "Henderson|Van Zandt",
    county_fips_all: "48213|48467",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75757,
    lat: 32.11584,
    lng: -95.34933,
    city: "Bullard",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13641,
    density: 61.2,
    county_fips: 48073,
    county_name: "Cherokee",
    county_weights: {
      48073: 68.31,
      48423: 31.69,
    },
    county_names_all: "Cherokee|Smith",
    county_fips_all: "48073|48423",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75758,
    lat: 32.27375,
    lng: -95.50484,
    city: "Chandler",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9041,
    density: 79,
    county_fips: 48213,
    county_name: "Henderson",
    county_weights: {
      48213: 85.52,
      48467: 14.48,
    },
    county_names_all: "Henderson|Van Zandt",
    county_fips_all: "48213|48467",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75759,
    lat: 32.03617,
    lng: -95.41573,
    city: "Cuney",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 116,
    density: 12.3,
    county_fips: 48073,
    county_name: "Cherokee",
    county_weights: {
      48073: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 48073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75760,
    lat: 31.80738,
    lng: -94.85758,
    city: "Cushing",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2386,
    density: 7,
    county_fips: 48347,
    county_name: "Nacogdoches",
    county_weights: {
      48347: 67.97,
      48401: 32.03,
    },
    county_names_all: "Nacogdoches|Rusk",
    county_fips_all: "48347|48401",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75762,
    lat: 32.21926,
    lng: -95.41218,
    city: "Flint",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13703,
    density: 118.3,
    county_fips: 48423,
    county_name: "Smith",
    county_weights: {
      48423: 100,
    },
    county_names_all: "Smith",
    county_fips_all: 48423,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75763,
    lat: 32.04154,
    lng: -95.52231,
    city: "Frankston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6359,
    density: 22.7,
    county_fips: 48001,
    county_name: "Anderson",
    county_weights: {
      48001: 66.35,
      48213: 33.65,
    },
    county_names_all: "Anderson|Henderson",
    county_fips_all: "48001|48213",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75764,
    lat: 31.89522,
    lng: -95.14369,
    city: "Gallatin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 212,
    density: 63.5,
    county_fips: 48073,
    county_name: "Cherokee",
    county_weights: {
      48073: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 48073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75765,
    lat: 32.64119,
    lng: -95.2359,
    city: "Hawkins",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7507,
    density: 28,
    county_fips: 48499,
    county_name: "Wood",
    county_weights: {
      48459: 1.04,
      48499: 98.96,
    },
    county_names_all: "Wood|Upshur",
    county_fips_all: "48499|48459",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75766,
    lat: 31.94592,
    lng: -95.25181,
    city: "Jacksonville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26995,
    density: 32.7,
    county_fips: 48073,
    county_name: "Cherokee",
    county_weights: {
      48073: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 48073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75770,
    lat: 32.14058,
    lng: -95.64694,
    city: "Larue",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2552,
    density: 8.3,
    county_fips: 48213,
    county_name: "Henderson",
    county_weights: {
      48213: 100,
    },
    county_names_all: "Henderson",
    county_fips_all: 48213,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75771,
    lat: 32.53542,
    lng: -95.43006,
    city: "Lindale",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20509,
    density: 54.2,
    county_fips: 48423,
    county_name: "Smith",
    county_weights: {
      48423: 100,
    },
    county_names_all: "Smith",
    county_fips_all: 48423,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75773,
    lat: 32.67969,
    lng: -95.44654,
    city: "Mineola",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14305,
    density: 31.2,
    county_fips: 48499,
    county_name: "Wood",
    county_weights: {
      48423: 17.48,
      48499: 82.52,
    },
    county_names_all: "Wood|Smith",
    county_fips_all: "48499|48423",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75778,
    lat: 32.30239,
    lng: -95.71367,
    city: "Murchison",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2468,
    density: 18.1,
    county_fips: 48213,
    county_name: "Henderson",
    county_weights: {
      48213: 86.23,
      48467: 13.77,
    },
    county_names_all: "Henderson|Van Zandt",
    county_fips_all: "48213|48467",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75779,
    lat: 31.86434,
    lng: -95.48486,
    city: "Neches",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 110,
    density: 54.1,
    county_fips: 48001,
    county_name: "Anderson",
    county_weights: {
      48001: 100,
    },
    county_names_all: "Anderson",
    county_fips_all: 48001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75780,
    lat: 31.98905,
    lng: -95.09122,
    city: "New Summerfield",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 242,
    density: 69.6,
    county_fips: 48073,
    county_name: "Cherokee",
    county_weights: {
      48073: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 48073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75782,
    lat: 32.0693,
    lng: -95.58777,
    city: "Poynor",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48213,
    county_name: "Henderson",
    county_weights: {
      48213: 100,
    },
    county_names_all: "Henderson",
    county_fips_all: 48213,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75783,
    lat: 32.82227,
    lng: -95.42386,
    city: "Quitman",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8118,
    density: 26.2,
    county_fips: 48499,
    county_name: "Wood",
    county_weights: {
      48499: 100,
    },
    county_names_all: "Wood",
    county_fips_all: 48499,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75784,
    lat: 31.87344,
    lng: -94.96234,
    city: "Reklaw",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 708,
    density: 7.9,
    county_fips: 48401,
    county_name: "Rusk",
    county_weights: {
      48073: 38.36,
      48401: 61.64,
    },
    county_names_all: "Rusk|Cherokee",
    county_fips_all: "48401|48073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75785,
    lat: 31.76641,
    lng: -95.17446,
    city: "Rusk",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10931,
    density: 14.6,
    county_fips: 48073,
    county_name: "Cherokee",
    county_weights: {
      48073: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 48073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75788,
    lat: 31.82252,
    lng: -94.91617,
    city: "Sacul",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25,
    density: 6.9,
    county_fips: 48347,
    county_name: "Nacogdoches",
    county_weights: {
      48347: 100,
    },
    county_names_all: "Nacogdoches",
    county_fips_all: 48347,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75789,
    lat: 32.1126,
    lng: -95.09405,
    city: "Troup",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8379,
    density: 17.5,
    county_fips: 48073,
    county_name: "Cherokee",
    county_weights: {
      48073: 62.94,
      48401: 0.51,
      48423: 36.55,
    },
    county_names_all: "Cherokee|Smith|Rusk",
    county_fips_all: "48073|48423|48401",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75790,
    lat: 32.52749,
    lng: -95.64255,
    city: "Van",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3656,
    density: 38.7,
    county_fips: 48467,
    county_name: "Van Zandt",
    county_weights: {
      48423: 4.6,
      48467: 95.4,
    },
    county_names_all: "Van Zandt|Smith",
    county_fips_all: "48467|48423",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75791,
    lat: 32.22214,
    lng: -95.22103,
    city: "Whitehouse",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13952,
    density: 136.7,
    county_fips: 48423,
    county_name: "Smith",
    county_weights: {
      48423: 100,
    },
    county_names_all: "Smith",
    county_fips_all: 48423,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75792,
    lat: 32.4679,
    lng: -95.10623,
    city: "Winona",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2861,
    density: 13.8,
    county_fips: 48423,
    county_name: "Smith",
    county_weights: {
      48423: 100,
    },
    county_names_all: "Smith",
    county_fips_all: 48423,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75801,
    lat: 31.74004,
    lng: -95.55116,
    city: "Palestine",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15808,
    density: 32.4,
    county_fips: 48001,
    county_name: "Anderson",
    county_weights: {
      48001: 100,
    },
    county_names_all: "Anderson",
    county_fips_all: 48001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75803,
    lat: 31.87513,
    lng: -95.66704,
    city: "Palestine",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21511,
    density: 25.5,
    county_fips: 48001,
    county_name: "Anderson",
    county_weights: {
      48001: 99.65,
      48213: 0.35,
    },
    county_names_all: "Anderson|Henderson",
    county_fips_all: "48001|48213",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75831,
    lat: 31.45745,
    lng: -96.02275,
    city: "Buffalo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6155,
    density: 9.5,
    county_fips: 48289,
    county_name: "Leon",
    county_weights: {
      48161: 29.81,
      48289: 70.19,
    },
    county_names_all: "Leon|Freestone",
    county_fips_all: "48289|48161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75833,
    lat: 31.26304,
    lng: -95.83999,
    city: "Centerville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2448,
    density: 3.7,
    county_fips: 48289,
    county_name: "Leon",
    county_weights: {
      48289: 100,
    },
    county_names_all: "Leon",
    county_fips_all: 48289,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75835,
    lat: 31.29758,
    lng: -95.48834,
    city: "Crockett",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11425,
    density: 9.4,
    county_fips: 48225,
    county_name: "Houston",
    county_weights: {
      48225: 100,
    },
    county_names_all: "Houston",
    county_fips_all: 48225,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75838,
    lat: 31.47956,
    lng: -96.22844,
    city: "Donie",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 679,
    density: 4.7,
    county_fips: 48161,
    county_name: "Freestone",
    county_weights: {
      48161: 88.9,
      48293: 11.1,
    },
    county_names_all: "Freestone|Limestone",
    county_fips_all: "48161|48293",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75839,
    lat: 31.6181,
    lng: -95.55738,
    city: "Elkhart",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6398,
    density: 14.5,
    county_fips: 48001,
    county_name: "Anderson",
    county_weights: {
      48001: 96.26,
      48225: 3.74,
    },
    county_names_all: "Anderson|Houston",
    county_fips_all: "48001|48225",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75840,
    lat: 31.78412,
    lng: -96.08552,
    city: "Fairfield",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6297,
    density: 9.1,
    county_fips: 48161,
    county_name: "Freestone",
    county_weights: {
      48161: 100,
    },
    county_names_all: "Freestone",
    county_fips_all: 48161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75844,
    lat: 31.51921,
    lng: -95.43481,
    city: "Grapeland",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5632,
    density: 6.2,
    county_fips: 48225,
    county_name: "Houston",
    county_weights: {
      48001: 17.77,
      48225: 82.23,
    },
    county_names_all: "Houston|Anderson",
    county_fips_all: "48225|48001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75845,
    lat: 31.09488,
    lng: -95.08707,
    city: "Groveton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3129,
    density: 3.8,
    county_fips: 48455,
    county_name: "Trinity",
    county_weights: {
      48455: 100,
    },
    county_names_all: "Trinity",
    county_fips_all: 48455,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75846,
    lat: 31.34683,
    lng: -96.18118,
    city: "Jewett",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2944,
    density: 7.4,
    county_fips: 48289,
    county_name: "Leon",
    county_weights: {
      48289: 79.33,
      48293: 20.67,
    },
    county_names_all: "Leon|Limestone",
    county_fips_all: "48289|48293",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75847,
    lat: 31.35204,
    lng: -95.13564,
    city: "Kennard",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1745,
    density: 2.7,
    county_fips: 48225,
    county_name: "Houston",
    county_weights: {
      48225: 86.91,
      48455: 13.09,
    },
    county_names_all: "Houston|Trinity",
    county_fips_all: "48225|48455",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75848,
    lat: 31.77281,
    lng: -96.33408,
    city: "Kirvin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 100,
    density: 70.5,
    county_fips: 48161,
    county_name: "Freestone",
    county_weights: {
      48161: 100,
    },
    county_names_all: "Freestone",
    county_fips_all: 48161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75849,
    lat: 31.39624,
    lng: -95.47618,
    city: "Latexo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51,
    density: 56,
    county_fips: 48225,
    county_name: "Houston",
    county_weights: {
      48225: 100,
    },
    county_names_all: "Houston",
    county_fips_all: 48225,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75850,
    lat: 31.13209,
    lng: -95.91595,
    city: "Leona",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1387,
    density: 9.5,
    county_fips: 48289,
    county_name: "Leon",
    county_weights: {
      48289: 100,
    },
    county_names_all: "Leon",
    county_fips_all: 48289,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75851,
    lat: 31.09458,
    lng: -95.49555,
    city: "Lovelady",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4916,
    density: 7.2,
    county_fips: 48225,
    county_name: "Houston",
    county_weights: {
      48225: 88.17,
      48455: 11.83,
    },
    county_names_all: "Houston|Trinity",
    county_fips_all: "48225|48455",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75852,
    lat: 30.98723,
    lng: -95.72023,
    city: "Midway",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3634,
    density: 9.5,
    county_fips: 48313,
    county_name: "Madison",
    county_weights: {
      48313: 77.6,
      48471: 22.4,
    },
    county_names_all: "Madison|Walker",
    county_fips_all: "48313|48471",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75853,
    lat: 31.93488,
    lng: -95.80963,
    city: "Montalba",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 559,
    density: 3,
    county_fips: 48001,
    county_name: "Anderson",
    county_weights: {
      48001: 97.8,
      48213: 2.2,
    },
    county_names_all: "Anderson|Henderson",
    county_fips_all: "48001|48213",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75855,
    lat: 31.5592,
    lng: -95.85447,
    city: "Oakwood",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2952,
    density: 4,
    county_fips: 48289,
    county_name: "Leon",
    county_weights: {
      48161: 42.1,
      48289: 57.9,
    },
    county_names_all: "Leon|Freestone",
    county_fips_all: "48289|48161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75856,
    lat: 31.20138,
    lng: -95.2537,
    city: "Pennington",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 171,
    density: 2.7,
    county_fips: 48225,
    county_name: "Houston",
    county_weights: {
      48225: 71.01,
      48455: 28.99,
    },
    county_names_all: "Houston|Trinity",
    county_fips_all: "48225|48455",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75858,
    lat: 31.38083,
    lng: -95.13676,
    city: "Ratcliff",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 48225,
    county_name: "Houston",
    county_weights: {
      48225: 100,
    },
    county_names_all: "Houston",
    county_fips_all: 48225,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75859,
    lat: 31.8842,
    lng: -96.25512,
    city: "Streetman",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1825,
    density: 5.3,
    county_fips: 48161,
    county_name: "Freestone",
    county_weights: {
      48161: 68.61,
      48349: 31.39,
    },
    county_names_all: "Freestone|Navarro",
    county_fips_all: "48161|48349",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75860,
    lat: 31.62342,
    lng: -96.24615,
    city: "Teague",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6351,
    density: 13.9,
    county_fips: 48161,
    county_name: "Freestone",
    county_weights: {
      48161: 100,
    },
    county_names_all: "Freestone",
    county_fips_all: 48161,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75861,
    lat: 31.8524,
    lng: -95.88771,
    city: "Tennessee Colony",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9081,
    density: 30.8,
    county_fips: 48001,
    county_name: "Anderson",
    county_weights: {
      48001: 100,
    },
    county_names_all: "Anderson",
    county_fips_all: 48001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75862,
    lat: 30.96193,
    lng: -95.32951,
    city: "Trinity",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10115,
    density: 16.2,
    county_fips: 48455,
    county_name: "Trinity",
    county_weights: {
      48455: 79.94,
      48471: 20.06,
    },
    county_names_all: "Trinity|Walker",
    county_fips_all: "48455|48471",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75865,
    lat: 31.05808,
    lng: -94.96228,
    city: "Woodlake",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48455,
    county_name: "Trinity",
    county_weights: {
      48455: 100,
    },
    county_names_all: "Trinity",
    county_fips_all: 48455,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75884,
    lat: 31.78928,
    lng: -95.89263,
    city: "Tennessee Colony",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48001,
    county_name: "Anderson",
    county_weights: {
      48001: 100,
    },
    county_names_all: "Anderson",
    county_fips_all: 48001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75886,
    lat: 31.78698,
    lng: -95.91234,
    city: "Tennessee Colony",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48001,
    county_name: "Anderson",
    county_weights: {
      48001: 100,
    },
    county_names_all: "Anderson",
    county_fips_all: 48001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75901,
    lat: 31.30264,
    lng: -94.65481,
    city: "Lufkin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29148,
    density: 70.7,
    county_fips: 48005,
    county_name: "Angelina",
    county_weights: {
      48005: 100,
    },
    county_names_all: "Angelina",
    county_fips_all: 48005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75903,
    lat: 31.37428,
    lng: -94.74796,
    city: "Lufkin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48005,
    county_name: "Angelina",
    county_weights: {
      48005: 100,
    },
    county_names_all: "Angelina",
    county_fips_all: 48005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75904,
    lat: 31.33872,
    lng: -94.83467,
    city: "Lufkin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35208,
    density: 84.7,
    county_fips: 48005,
    county_name: "Angelina",
    county_weights: {
      48005: 85.07,
      48455: 14.93,
    },
    county_names_all: "Angelina|Trinity",
    county_fips_all: "48005|48455",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75925,
    lat: 31.61018,
    lng: -95.05327,
    city: "Alto",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3913,
    density: 7.2,
    county_fips: 48073,
    county_name: "Cherokee",
    county_weights: {
      48073: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 48073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75926,
    lat: 31.23281,
    lng: -94.96944,
    city: "Apple Springs",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1207,
    density: 5.2,
    county_fips: 48455,
    county_name: "Trinity",
    county_weights: {
      48455: 100,
    },
    county_names_all: "Trinity",
    county_fips_all: 48455,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75928,
    lat: 30.67111,
    lng: -93.7064,
    city: "Bon Wier",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1318,
    density: 6.1,
    county_fips: 48351,
    county_name: "Newton",
    county_weights: {
      48351: 100,
    },
    county_names_all: "Newton",
    county_fips_all: 48351,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75929,
    lat: 31.23579,
    lng: -94.19735,
    city: "Broaddus",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1653,
    density: 5.4,
    county_fips: 48405,
    county_name: "San Augustine",
    county_weights: {
      48405: 100,
    },
    county_names_all: "San Augustine",
    county_fips_all: 48405,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75930,
    lat: 31.33641,
    lng: -94.03522,
    city: "Bronson",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1655,
    density: 4,
    county_fips: 48405,
    county_name: "San Augustine",
    county_weights: {
      48403: 40.61,
      48405: 59.39,
    },
    county_names_all: "San Augustine|Sabine",
    county_fips_all: "48405|48403",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75931,
    lat: 31.09978,
    lng: -93.98953,
    city: "Brookeland",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1967,
    density: 8.6,
    county_fips: 48241,
    county_name: "Jasper",
    county_weights: {
      48241: 78.55,
      48403: 21.45,
    },
    county_names_all: "Jasper|Sabine",
    county_fips_all: "48241|48403",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75932,
    lat: 31.0551,
    lng: -93.61396,
    city: "Burkeville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1628,
    density: 4.7,
    county_fips: 48351,
    county_name: "Newton",
    county_weights: {
      48351: 100,
    },
    county_names_all: "Newton",
    county_fips_all: 48351,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75933,
    lat: 30.55314,
    lng: -93.81608,
    city: "Call",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1049,
    density: 4.7,
    county_fips: 48351,
    county_name: "Newton",
    county_weights: {
      48241: 8.33,
      48351: 91.67,
    },
    county_names_all: "Newton|Jasper",
    county_fips_all: "48351|48241",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75934,
    lat: 30.89688,
    lng: -94.75153,
    city: "Camden",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 201,
    density: 11.3,
    county_fips: 48373,
    county_name: "Polk",
    county_weights: {
      48373: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 48373,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75935,
    lat: 31.72999,
    lng: -94.20077,
    city: "Center",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12994,
    density: 14.1,
    county_fips: 48419,
    county_name: "Shelby",
    county_weights: {
      48405: 10.61,
      48419: 89.39,
    },
    county_names_all: "Shelby|San Augustine",
    county_fips_all: "48419|48405",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75936,
    lat: 30.95147,
    lng: -94.58883,
    city: "Chester",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 951,
    density: 3.1,
    county_fips: 48457,
    county_name: "Tyler",
    county_weights: {
      48373: 17.76,
      48457: 82.24,
    },
    county_names_all: "Tyler|Polk",
    county_fips_all: "48457|48373",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75937,
    lat: 31.47805,
    lng: -94.38259,
    city: "Chireno",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1033,
    density: 5.8,
    county_fips: 48347,
    county_name: "Nacogdoches",
    county_weights: {
      48347: 100,
    },
    county_names_all: "Nacogdoches",
    county_fips_all: 48347,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75938,
    lat: 30.93436,
    lng: -94.35605,
    city: "Colmesneil",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2425,
    density: 4.9,
    county_fips: 48457,
    county_name: "Tyler",
    county_weights: {
      48457: 100,
    },
    county_names_all: "Tyler",
    county_fips_all: 48457,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75939,
    lat: 31.01496,
    lng: -94.80501,
    city: "Corrigan",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5682,
    density: 8.7,
    county_fips: 48373,
    county_name: "Polk",
    county_weights: {
      48373: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 48373,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75941,
    lat: 31.18078,
    lng: -94.76219,
    city: "Diboll",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8737,
    density: 38.7,
    county_fips: 48005,
    county_name: "Angelina",
    county_weights: {
      48005: 100,
    },
    county_names_all: "Angelina",
    county_fips_all: 48005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75942,
    lat: 30.82567,
    lng: -94.41657,
    city: "Doucette",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48457,
    county_name: "Tyler",
    county_weights: {
      48457: 100,
    },
    county_names_all: "Tyler",
    county_fips_all: 48457,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75943,
    lat: 31.65451,
    lng: -94.88935,
    city: "Douglass",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1338,
    density: 8.1,
    county_fips: 48347,
    county_name: "Nacogdoches",
    county_weights: {
      48347: 100,
    },
    county_names_all: "Nacogdoches",
    county_fips_all: 48347,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75944,
    lat: 31.34514,
    lng: -94.38636,
    city: "Etoile",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 936,
    density: 7.3,
    county_fips: 48347,
    county_name: "Nacogdoches",
    county_weights: {
      48347: 100,
    },
    county_names_all: "Nacogdoches",
    county_fips_all: 48347,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75946,
    lat: 31.81372,
    lng: -94.52392,
    city: "Garrison",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3851,
    density: 10.9,
    county_fips: 48347,
    county_name: "Nacogdoches",
    county_weights: {
      48347: 68.34,
      48401: 31.66,
    },
    county_names_all: "Nacogdoches|Rusk",
    county_fips_all: "48347|48401",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75948,
    lat: 31.29389,
    lng: -93.77573,
    city: "Hemphill",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6072,
    density: 10.2,
    county_fips: 48403,
    county_name: "Sabine",
    county_weights: {
      48351: 3.15,
      48403: 96.85,
    },
    county_names_all: "Sabine|Newton",
    county_fips_all: "48403|48351",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75949,
    lat: 31.22907,
    lng: -94.51782,
    city: "Huntington",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8518,
    density: 16,
    county_fips: 48005,
    county_name: "Angelina",
    county_weights: {
      48005: 100,
    },
    county_names_all: "Angelina",
    county_fips_all: 48005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75951,
    lat: 30.93098,
    lng: -94.05762,
    city: "Jasper",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16154,
    density: 16.7,
    county_fips: 48241,
    county_name: "Jasper",
    county_weights: {
      48241: 99.49,
      48351: 0.51,
    },
    county_names_all: "Jasper|Newton",
    county_fips_all: "48241|48351",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75954,
    lat: 31.92169,
    lng: -94.05523,
    city: "Joaquin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2634,
    density: 9.5,
    county_fips: 48419,
    county_name: "Shelby",
    county_weights: {
      48365: 11.21,
      48419: 88.79,
    },
    county_names_all: "Shelby|Panola",
    county_fips_all: "48419|48365",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75956,
    lat: 30.6721,
    lng: -93.96706,
    city: "Kirbyville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9595,
    density: 15.2,
    county_fips: 48241,
    county_name: "Jasper",
    county_weights: {
      48241: 88.21,
      48351: 11.79,
    },
    county_names_all: "Jasper|Newton",
    county_fips_all: "48241|48351",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75959,
    lat: 31.51021,
    lng: -93.83994,
    city: "Milam",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 859,
    density: 6.3,
    county_fips: 48403,
    county_name: "Sabine",
    county_weights: {
      48403: 100,
    },
    county_names_all: "Sabine",
    county_fips_all: 48403,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75960,
    lat: 30.90372,
    lng: -94.8618,
    city: "Moscow",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 725,
    density: 4.7,
    county_fips: 48373,
    county_name: "Polk",
    county_weights: {
      48373: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 48373,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75961,
    lat: 31.5576,
    lng: -94.51098,
    city: "Nacogdoches",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15447,
    density: 21.3,
    county_fips: 48347,
    county_name: "Nacogdoches",
    county_weights: {
      48347: 100,
    },
    county_names_all: "Nacogdoches",
    county_fips_all: 48347,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75962,
    lat: 31.61981,
    lng: -94.6484,
    city: "Nacogdoches",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3188,
    density: 6030.9,
    county_fips: 48347,
    county_name: "Nacogdoches",
    county_weights: {
      48347: 100,
    },
    county_names_all: "Nacogdoches",
    county_fips_all: 48347,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75964,
    lat: 31.63334,
    lng: -94.75057,
    city: "Nacogdoches",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19410,
    density: 33.7,
    county_fips: 48347,
    county_name: "Nacogdoches",
    county_weights: {
      48347: 100,
    },
    county_names_all: "Nacogdoches",
    county_fips_all: 48347,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75965,
    lat: 31.7284,
    lng: -94.62629,
    city: "Nacogdoches",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18321,
    density: 91.8,
    county_fips: 48347,
    county_name: "Nacogdoches",
    county_weights: {
      48347: 100,
    },
    county_names_all: "Nacogdoches",
    county_fips_all: 48347,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75966,
    lat: 30.83783,
    lng: -93.72611,
    city: "Newton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4534,
    density: 6.5,
    county_fips: 48351,
    county_name: "Newton",
    county_weights: {
      48241: 1.14,
      48351: 98.86,
    },
    county_names_all: "Newton|Jasper",
    county_fips_all: "48351|48241",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75968,
    lat: 31.25882,
    lng: -93.95924,
    city: "Pineland",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2167,
    density: 11.6,
    county_fips: 48403,
    county_name: "Sabine",
    county_weights: {
      48403: 100,
    },
    county_names_all: "Sabine",
    county_fips_all: 48403,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75969,
    lat: 31.44765,
    lng: -94.89758,
    city: "Pollok",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3522,
    density: 16.4,
    county_fips: 48005,
    county_name: "Angelina",
    county_weights: {
      48005: 85.57,
      48073: 14.43,
    },
    county_names_all: "Angelina|Cherokee",
    county_fips_all: "48005|48073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75972,
    lat: 31.49407,
    lng: -94.12173,
    city: "San Augustine",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6252,
    density: 6.7,
    county_fips: 48405,
    county_name: "San Augustine",
    county_weights: {
      48403: 17.31,
      48405: 78.89,
      48419: 3.8,
    },
    county_names_all: "San Augustine|Sabine|Shelby",
    county_fips_all: "48405|48403|48419",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75973,
    lat: 31.71977,
    lng: -93.93259,
    city: "Shelbyville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3036,
    density: 6.6,
    county_fips: 48419,
    county_name: "Shelby",
    county_weights: {
      48419: 100,
    },
    county_names_all: "Shelby",
    county_fips_all: 48419,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75974,
    lat: 31.95674,
    lng: -94.23713,
    city: "Tenaha",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3611,
    density: 13.8,
    county_fips: 48419,
    county_name: "Shelby",
    county_weights: {
      48365: 40.64,
      48419: 59.36,
    },
    county_names_all: "Shelby|Panola",
    county_fips_all: "48419|48365",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75975,
    lat: 31.89535,
    lng: -94.4122,
    city: "Timpson",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4052,
    density: 11.2,
    county_fips: 48419,
    county_name: "Shelby",
    county_weights: {
      48365: 6.76,
      48401: 5.82,
      48419: 87.42,
    },
    county_names_all: "Shelby|Panola|Rusk",
    county_fips_all: "48419|48365|48401",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75976,
    lat: 31.51546,
    lng: -94.93863,
    city: "Wells",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 989,
    density: 14,
    county_fips: 48073,
    county_name: "Cherokee",
    county_weights: {
      48073: 100,
    },
    county_names_all: "Cherokee",
    county_fips_all: 48073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75977,
    lat: 31.05997,
    lng: -93.78455,
    city: "Wiergate",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 444,
    density: 1,
    county_fips: 48351,
    county_name: "Newton",
    county_weights: {
      48351: 100,
    },
    county_names_all: "Newton",
    county_fips_all: 48351,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75979,
    lat: 30.77477,
    lng: -94.4026,
    city: "Woodville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12579,
    density: 15.8,
    county_fips: 48457,
    county_name: "Tyler",
    county_weights: {
      48457: 100,
    },
    county_names_all: "Tyler",
    county_fips_all: 48457,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 75980,
    lat: 31.12387,
    lng: -94.34703,
    city: "Zavalla",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2255,
    density: 5.6,
    county_fips: 48005,
    county_name: "Angelina",
    county_weights: {
      48005: 90.63,
      48241: 9.37,
    },
    county_names_all: "Angelina|Jasper",
    county_fips_all: "48005|48241",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76001,
    lat: 32.63076,
    lng: -97.15408,
    city: "Arlington",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37231,
    density: 1346.3,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76002,
    lat: 32.62233,
    lng: -97.09265,
    city: "Arlington",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36302,
    density: 1965.5,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76005,
    lat: 32.80057,
    lng: -97.08001,
    city: "Arlington",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76006,
    lat: 32.78511,
    lng: -97.10019,
    city: "Arlington",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24057,
    density: 1215.6,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76008,
    lat: 32.68182,
    lng: -97.62738,
    city: "Aledo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20288,
    density: 96.2,
    county_fips: 48367,
    county_name: "Parker",
    county_weights: {
      48367: 92.87,
      48439: 7.13,
    },
    county_names_all: "Parker|Tarrant",
    county_fips_all: "48367|48439",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76009,
    lat: 32.41635,
    lng: -97.20115,
    city: "Alvarado",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19618,
    density: 77.3,
    county_fips: 48251,
    county_name: "Johnson",
    county_weights: {
      48251: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 48251,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76010,
    lat: 32.72271,
    lng: -97.08065,
    city: "Arlington",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59526,
    density: 2608.9,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76011,
    lat: 32.7543,
    lng: -97.08223,
    city: "Arlington",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22878,
    density: 1086.2,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76012,
    lat: 32.75459,
    lng: -97.13901,
    city: "Arlington",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26730,
    density: 1258.9,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76013,
    lat: 32.72027,
    lng: -97.15652,
    city: "Arlington",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34763,
    density: 1495.4,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76014,
    lat: 32.69201,
    lng: -97.08814,
    city: "Arlington",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33289,
    density: 2240.8,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76015,
    lat: 32.69204,
    lng: -97.13341,
    city: "Arlington",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17773,
    density: 1608.7,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76016,
    lat: 32.68907,
    lng: -97.18868,
    city: "Arlington",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31705,
    density: 1383.8,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76017,
    lat: 32.66223,
    lng: -97.16237,
    city: "Arlington",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46312,
    density: 1751.9,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76018,
    lat: 32.66074,
    lng: -97.08967,
    city: "Arlington",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28353,
    density: 1394.1,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76020,
    lat: 32.90102,
    lng: -97.56483,
    city: "Azle",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30487,
    density: 181.3,
    county_fips: 48367,
    county_name: "Parker",
    county_weights: {
      48367: 62.48,
      48439: 33.62,
      48497: 3.9,
    },
    county_names_all: "Parker|Tarrant|Wise",
    county_fips_all: "48367|48439|48497",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76021,
    lat: 32.8523,
    lng: -97.13128,
    city: "Bedford",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35168,
    density: 1871.4,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76022,
    lat: 32.83063,
    lng: -97.14506,
    city: "Bedford",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13945,
    density: 1996,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76023,
    lat: 33.04777,
    lng: -97.60425,
    city: "Boyd",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7090,
    density: 50.9,
    county_fips: 48497,
    county_name: "Wise",
    county_weights: {
      48367: 2.83,
      48497: 97.17,
    },
    county_names_all: "Wise|Parker",
    county_fips_all: "48497|48367",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76028,
    lat: 32.52603,
    lng: -97.30491,
    city: "Burleson",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 72493,
    density: 361.3,
    county_fips: 48251,
    county_name: "Johnson",
    county_weights: {
      48251: 77.07,
      48439: 22.93,
    },
    county_names_all: "Johnson|Tarrant",
    county_fips_all: "48251|48439",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76031,
    lat: 32.34873,
    lng: -97.33267,
    city: "Cleburne",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18432,
    density: 97.9,
    county_fips: 48251,
    county_name: "Johnson",
    county_weights: {
      48251: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 48251,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76033,
    lat: 32.28663,
    lng: -97.52075,
    city: "Cleburne",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25977,
    density: 57,
    county_fips: 48251,
    county_name: "Johnson",
    county_weights: {
      48221: 7.23,
      48251: 85.62,
      48425: 7.15,
    },
    county_names_all: "Johnson|Hood|Somervell",
    county_fips_all: "48251|48221|48425",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76034,
    lat: 32.89121,
    lng: -97.1488,
    city: "Colleyville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26693,
    density: 788.6,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76035,
    lat: 32.56172,
    lng: -97.64251,
    city: "Cresson",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2373,
    density: 16.8,
    county_fips: 48367,
    county_name: "Parker",
    county_weights: {
      48221: 21.65,
      48251: 19.25,
      48367: 59.1,
    },
    county_names_all: "Parker|Hood|Johnson",
    county_fips_all: "48367|48221|48251",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76036,
    lat: 32.57366,
    lng: -97.41434,
    city: "Crowley",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27835,
    density: 243.9,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48251: 22.01,
      48439: 77.99,
    },
    county_names_all: "Tarrant|Johnson",
    county_fips_all: "48439|48251",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76039,
    lat: 32.8592,
    lng: -97.08422,
    city: "Euless",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37896,
    density: 2285.3,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76040,
    lat: 32.82133,
    lng: -97.10488,
    city: "Euless",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33419,
    density: 1645.4,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76041,
    lat: 32.23911,
    lng: -96.85724,
    city: "Forreston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 514,
    density: 16.6,
    county_fips: 48139,
    county_name: "Ellis",
    county_weights: {
      48139: 100,
    },
    county_names_all: "Ellis",
    county_fips_all: 48139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76043,
    lat: 32.20039,
    lng: -97.76129,
    city: "Glen Rose",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7525,
    density: 26.3,
    county_fips: 48425,
    county_name: "Somervell",
    county_weights: {
      48035: 18.18,
      48425: 81.82,
    },
    county_names_all: "Somervell|Bosque",
    county_fips_all: "48425|48035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76044,
    lat: 32.42961,
    lng: -97.54286,
    city: "Godley",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5407,
    density: 19.3,
    county_fips: 48251,
    county_name: "Johnson",
    county_weights: {
      48251: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 48251,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76048,
    lat: 32.40791,
    lng: -97.80117,
    city: "Granbury",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24586,
    density: 93.4,
    county_fips: 48221,
    county_name: "Hood",
    county_weights: {
      48221: 91.76,
      48425: 8.24,
    },
    county_names_all: "Hood|Somervell",
    county_fips_all: "48221|48425",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76049,
    lat: 32.46759,
    lng: -97.70645,
    city: "Granbury",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30062,
    density: 108.4,
    county_fips: 48221,
    county_name: "Hood",
    county_weights: {
      48221: 98.05,
      48251: 0.81,
      48367: 1.14,
    },
    county_names_all: "Hood|Parker|Johnson",
    county_fips_all: "48221|48367|48251",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76050,
    lat: 32.27262,
    lng: -97.16326,
    city: "Grandview",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6094,
    density: 16.9,
    county_fips: 48251,
    county_name: "Johnson",
    county_weights: {
      48139: 18.06,
      48217: 18.28,
      48251: 63.66,
    },
    county_names_all: "Johnson|Hill|Ellis",
    county_fips_all: "48251|48217|48139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76051,
    lat: 32.94192,
    lng: -97.07888,
    city: "Grapevine",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54130,
    density: 937.6,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48113: 1.42,
      48439: 98.58,
    },
    county_names_all: "Tarrant|Dallas",
    county_fips_all: "48439|48113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76052,
    lat: 32.98205,
    lng: -97.38037,
    city: "Haslet",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23080,
    density: 214.9,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48121: 23.64,
      48439: 57.29,
      48497: 19.07,
    },
    county_names_all: "Tarrant|Denton|Wise",
    county_fips_all: "48439|48121|48497",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76053,
    lat: 32.81683,
    lng: -97.17898,
    city: "Hurst",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30317,
    density: 1436.8,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76054,
    lat: 32.85904,
    lng: -97.17789,
    city: "Hurst",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12178,
    density: 1235.8,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76055,
    lat: 32.1596,
    lng: -97.14812,
    city: "Itasca",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3181,
    density: 14.9,
    county_fips: 48217,
    county_name: "Hill",
    county_weights: {
      48217: 100,
    },
    county_names_all: "Hill",
    county_fips_all: 48217,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76058,
    lat: 32.47072,
    lng: -97.4251,
    city: "Joshua",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21037,
    density: 156.4,
    county_fips: 48251,
    county_name: "Johnson",
    county_weights: {
      48251: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 48251,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76059,
    lat: 32.3921,
    lng: -97.32897,
    city: "Keene",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5716,
    density: 891.6,
    county_fips: 48251,
    county_name: "Johnson",
    county_weights: {
      48251: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 48251,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76060,
    lat: 32.63987,
    lng: -97.2161,
    city: "Kennedale",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8606,
    density: 444.6,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76061,
    lat: 32.5026,
    lng: -97.19813,
    city: "Lillian",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59,
    density: 10.2,
    county_fips: 48251,
    county_name: "Johnson",
    county_weights: {
      48251: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 48251,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76063,
    lat: 32.56913,
    lng: -97.14376,
    city: "Mansfield",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 76609,
    density: 591.2,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48139: 1.05,
      48251: 24.53,
      48439: 74.42,
    },
    county_names_all: "Tarrant|Johnson|Ellis",
    county_fips_all: "48439|48251|48139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76064,
    lat: 32.30757,
    lng: -97.03225,
    city: "Maypearl",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2100,
    density: 37.4,
    county_fips: 48139,
    county_name: "Ellis",
    county_weights: {
      48139: 100,
    },
    county_names_all: "Ellis",
    county_fips_all: 48139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76065,
    lat: 32.47042,
    lng: -96.98861,
    city: "Midlothian",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38800,
    density: 148.5,
    county_fips: 48139,
    county_name: "Ellis",
    county_weights: {
      48113: 0.2,
      48139: 99.8,
    },
    county_names_all: "Ellis|Dallas",
    county_fips_all: "48139|48113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76066,
    lat: 32.7058,
    lng: -97.99913,
    city: "Millsap",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4106,
    density: 18,
    county_fips: 48367,
    county_name: "Parker",
    county_weights: {
      48363: 2.39,
      48367: 97.61,
    },
    county_names_all: "Parker|Palo Pinto",
    county_fips_all: "48367|48363",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76067,
    lat: 32.80303,
    lng: -98.1449,
    city: "Mineral Wells",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20437,
    density: 39.9,
    county_fips: 48363,
    county_name: "Palo Pinto",
    county_weights: {
      48363: 90.78,
      48367: 9.22,
    },
    county_names_all: "Palo Pinto|Parker",
    county_fips_all: "48363|48367",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76070,
    lat: 32.24291,
    lng: -97.64991,
    city: "Nemo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 955,
    density: 16.3,
    county_fips: 48425,
    county_name: "Somervell",
    county_weights: {
      48251: 9.1,
      48425: 90.9,
    },
    county_names_all: "Somervell|Johnson",
    county_fips_all: "48425|48251",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76071,
    lat: 33.00613,
    lng: -97.47821,
    city: "Newark",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4173,
    density: 181.8,
    county_fips: 48497,
    county_name: "Wise",
    county_weights: {
      48439: 4.92,
      48497: 95.08,
    },
    county_names_all: "Wise|Tarrant",
    county_fips_all: "48497|48439",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76073,
    lat: 33.10416,
    lng: -97.72571,
    city: "Paradise",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6237,
    density: 28.7,
    county_fips: 48497,
    county_name: "Wise",
    county_weights: {
      48497: 100,
    },
    county_names_all: "Wise",
    county_fips_all: 48497,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76077,
    lat: 32.27886,
    lng: -97.70891,
    city: "Rainbow",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 333,
    density: 13.9,
    county_fips: 48425,
    county_name: "Somervell",
    county_weights: {
      48425: 100,
    },
    county_names_all: "Somervell",
    county_fips_all: 48425,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76078,
    lat: 33.0896,
    lng: -97.46647,
    city: "Rhome",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9024,
    density: 54.3,
    county_fips: 48497,
    county_name: "Wise",
    county_weights: {
      48121: 0.39,
      48497: 99.61,
    },
    county_names_all: "Wise|Denton",
    county_fips_all: "48497|48121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76082,
    lat: 32.97098,
    lng: -97.71783,
    city: "Springtown",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21151,
    density: 79.5,
    county_fips: 48367,
    county_name: "Parker",
    county_weights: {
      48367: 73.79,
      48497: 26.21,
    },
    county_names_all: "Parker|Wise",
    county_fips_all: "48367|48497",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76084,
    lat: 32.43258,
    lng: -97.0888,
    city: "Venus",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9574,
    density: 71.3,
    county_fips: 48251,
    county_name: "Johnson",
    county_weights: {
      48139: 47.8,
      48251: 52.2,
    },
    county_names_all: "Johnson|Ellis",
    county_fips_all: "48251|48139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76085,
    lat: 32.84907,
    lng: -97.70051,
    city: "Weatherford",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10965,
    density: 64.8,
    county_fips: 48367,
    county_name: "Parker",
    county_weights: {
      48367: 100,
    },
    county_names_all: "Parker",
    county_fips_all: 48367,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76086,
    lat: 32.75345,
    lng: -97.78909,
    city: "Weatherford",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23161,
    density: 646.2,
    county_fips: 48367,
    county_name: "Parker",
    county_weights: {
      48367: 100,
    },
    county_names_all: "Parker",
    county_fips_all: 48367,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76087,
    lat: 32.66995,
    lng: -97.79065,
    city: "Weatherford",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29119,
    density: 60.6,
    county_fips: 48367,
    county_name: "Parker",
    county_weights: {
      48221: 4.81,
      48367: 95.19,
    },
    county_names_all: "Parker|Hood",
    county_fips_all: "48367|48221",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76088,
    lat: 32.84554,
    lng: -97.90345,
    city: "Weatherford",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12610,
    density: 30.1,
    county_fips: 48367,
    county_name: "Parker",
    county_weights: {
      48367: 100,
    },
    county_names_all: "Parker",
    county_fips_all: 48367,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76092,
    lat: 32.95562,
    lng: -97.14879,
    city: "Southlake",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31837,
    density: 542.5,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48121: 9.32,
      48439: 90.68,
    },
    county_names_all: "Tarrant|Denton",
    county_fips_all: "48439|48121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76093,
    lat: 32.21459,
    lng: -97.40098,
    city: "Rio Vista",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2930,
    density: 33,
    county_fips: 48251,
    county_name: "Johnson",
    county_weights: {
      48217: 19.89,
      48251: 80.11,
    },
    county_names_all: "Johnson|Hill",
    county_fips_all: "48251|48217",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76102,
    lat: 32.75799,
    lng: -97.32858,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10632,
    density: 910.4,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76103,
    lat: 32.75282,
    lng: -97.26627,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16848,
    density: 1064.9,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76104,
    lat: 32.72848,
    lng: -97.31819,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17653,
    density: 1161,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76105,
    lat: 32.72327,
    lng: -97.26999,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22922,
    density: 1501.9,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76106,
    lat: 32.81417,
    lng: -97.35209,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38906,
    density: 1037.6,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76107,
    lat: 32.74176,
    lng: -97.38202,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29377,
    density: 1058.6,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76108,
    lat: 32.77943,
    lng: -97.51811,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42902,
    density: 384.4,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48367: 26.9,
      48439: 73.1,
    },
    county_names_all: "Tarrant|Parker",
    county_fips_all: "48439|48367",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76109,
    lat: 32.70115,
    lng: -97.38378,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23725,
    density: 1121.9,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76110,
    lat: 32.70678,
    lng: -97.33843,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33720,
    density: 2271.5,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76111,
    lat: 32.7804,
    lng: -97.30116,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22567,
    density: 1175.3,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76112,
    lat: 32.74831,
    lng: -97.21828,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42218,
    density: 1438.6,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76114,
    lat: 32.77365,
    lng: -97.40417,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27151,
    density: 1082.3,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76115,
    lat: 32.67861,
    lng: -97.33117,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21907,
    density: 1821,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76116,
    lat: 32.72128,
    lng: -97.44766,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50371,
    density: 1583.3,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76117,
    lat: 32.80374,
    lng: -97.26766,
    city: "Haltom City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32191,
    density: 1142.1,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76118,
    lat: 32.79606,
    lng: -97.1972,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16594,
    density: 663.5,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76119,
    lat: 32.69026,
    lng: -97.26176,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52279,
    density: 1266.8,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76120,
    lat: 32.76742,
    lng: -97.18286,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19941,
    density: 1028.9,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76123,
    lat: 32.62298,
    lng: -97.40262,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37075,
    density: 1353.4,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76126,
    lat: 32.64374,
    lng: -97.51767,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23844,
    density: 134.1,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48367: 25.18,
      48439: 74.82,
    },
    county_names_all: "Tarrant|Parker",
    county_fips_all: "48439|48367",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76127,
    lat: 32.77663,
    lng: -97.43044,
    city: "Naval Air Station Jrb",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2038,
    density: 363.2,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76129,
    lat: 32.70934,
    lng: -97.36255,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1616,
    density: 7504.5,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76131,
    lat: 32.88227,
    lng: -97.34895,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47377,
    density: 1177.2,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76132,
    lat: 32.66743,
    lng: -97.41827,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26265,
    density: 1367.5,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76133,
    lat: 32.6538,
    lng: -97.37746,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53694,
    density: 2223.7,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76134,
    lat: 32.64331,
    lng: -97.33103,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28852,
    density: 1294.8,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76135,
    lat: 32.83708,
    lng: -97.46621,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20233,
    density: 304.7,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76137,
    lat: 32.85864,
    lng: -97.29137,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59983,
    density: 1704.7,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76140,
    lat: 32.62012,
    lng: -97.27036,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30930,
    density: 437.3,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76148,
    lat: 32.86789,
    lng: -97.25197,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23679,
    density: 1941.9,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76155,
    lat: 32.82404,
    lng: -97.04911,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6329,
    density: 693.3,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76164,
    lat: 32.7808,
    lng: -97.35411,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13628,
    density: 1332.7,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76177,
    lat: 32.96999,
    lng: -97.30611,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10814,
    density: 202.7,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48121: 32.74,
      48439: 67.26,
    },
    county_names_all: "Tarrant|Denton",
    county_fips_all: "48439|48121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76179,
    lat: 32.91397,
    lng: -97.43947,
    city: "Fort Worth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69066,
    density: 514.2,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76180,
    lat: 32.83994,
    lng: -97.22468,
    city: "North Richland Hills",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37117,
    density: 1540.8,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76182,
    lat: 32.88257,
    lng: -97.20969,
    city: "North Richland Hills",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31889,
    density: 1422,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76201,
    lat: 33.22122,
    lng: -97.14715,
    city: "Denton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29447,
    density: 2082.1,
    county_fips: 48121,
    county_name: "Denton",
    county_weights: {
      48121: 100,
    },
    county_names_all: "Denton",
    county_fips_all: 48121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76203,
    lat: 33.21213,
    lng: -97.15181,
    city: "Denton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48121,
    county_name: "Denton",
    county_weights: {
      48121: 100,
    },
    county_names_all: "Denton",
    county_fips_all: 48121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76205,
    lat: 33.19074,
    lng: -97.12894,
    city: "Denton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21657,
    density: 1006.2,
    county_fips: 48121,
    county_name: "Denton",
    county_weights: {
      48121: 100,
    },
    county_names_all: "Denton",
    county_fips_all: 48121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76207,
    lat: 33.22174,
    lng: -97.18505,
    city: "Denton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14794,
    density: 141.6,
    county_fips: 48121,
    county_name: "Denton",
    county_weights: {
      48121: 100,
    },
    county_names_all: "Denton",
    county_fips_all: 48121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76208,
    lat: 33.20917,
    lng: -97.05786,
    city: "Denton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24992,
    density: 352.5,
    county_fips: 48121,
    county_name: "Denton",
    county_weights: {
      48121: 100,
    },
    county_names_all: "Denton",
    county_fips_all: 48121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76209,
    lat: 33.2315,
    lng: -97.11,
    city: "Denton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26244,
    density: 1522.9,
    county_fips: 48121,
    county_name: "Denton",
    county_weights: {
      48121: 100,
    },
    county_names_all: "Denton",
    county_fips_all: 48121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76210,
    lat: 33.14985,
    lng: -97.0962,
    city: "Denton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46046,
    density: 1103.1,
    county_fips: 48121,
    county_name: "Denton",
    county_weights: {
      48121: 100,
    },
    county_names_all: "Denton",
    county_fips_all: 48121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76225,
    lat: 33.36616,
    lng: -97.67345,
    city: "Alvord",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2688,
    density: 9.8,
    county_fips: 48497,
    county_name: "Wise",
    county_weights: {
      48337: 0.73,
      48497: 99.27,
    },
    county_names_all: "Wise|Montague",
    county_fips_all: "48497|48337",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76226,
    lat: 33.10775,
    lng: -97.17196,
    city: "Argyle",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29240,
    density: 226.8,
    county_fips: 48121,
    county_name: "Denton",
    county_weights: {
      48121: 100,
    },
    county_names_all: "Denton",
    county_fips_all: 48121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76227,
    lat: 33.27465,
    lng: -96.99075,
    city: "Aubrey",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36392,
    density: 179.2,
    county_fips: 48121,
    county_name: "Denton",
    county_weights: {
      48121: 100,
    },
    county_names_all: "Denton",
    county_fips_all: 48121,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76228,
    lat: 33.61438,
    lng: -98.06305,
    city: "Bellevue",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1215,
    density: 2.3,
    county_fips: 48077,
    county_name: "Clay",
    county_weights: {
      48077: 89.74,
      48337: 10.26,
    },
    county_names_all: "Clay|Montague",
    county_fips_all: "48077|48337",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76230,
    lat: 33.52264,
    lng: -97.94497,
    city: "Bowie",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9633,
    density: 10.4,
    county_fips: 48337,
    county_name: "Montague",
    county_weights: {
      48077: 7.75,
      48237: 31.33,
      48337: 60.92,
    },
    county_names_all: "Montague|Jack|Clay",
    county_fips_all: "48337|48237|48077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76233,
    lat: 33.54025,
    lng: -96.89696,
    city: "Collinsville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3317,
    density: 21.2,
    county_fips: 48181,
    county_name: "Grayson",
    county_weights: {
      48097: 23.47,
      48181: 76.53,
    },
    county_names_all: "Grayson|Cooke",
    county_fips_all: "48181|48097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76234,
    lat: 33.27587,
    lng: -97.51404,
    city: "Decatur",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18937,
    density: 23.3,
    county_fips: 48497,
    county_name: "Wise",
    county_weights: {
      48097: 5.88,
      48121: 2.21,
      48497: 91.91,
    },
    county_names_all: "Wise|Cooke|Denton",
    county_fips_all: "48497|48097|48121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76238,
    lat: 33.4861,
    lng: -97.34148,
    city: "Era",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 276,
    density: 3.8,
    county_fips: 48097,
    county_name: "Cooke",
    county_weights: {
      48097: 100,
    },
    county_names_all: "Cooke",
    county_fips_all: 48097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76239,
    lat: 33.524,
    lng: -97.57033,
    city: "Forestburg",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1310,
    density: 4.1,
    county_fips: 48337,
    county_name: "Montague",
    county_weights: {
      48097: 11.95,
      48337: 88.05,
    },
    county_names_all: "Montague|Cooke",
    county_fips_all: "48337|48097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76240,
    lat: 33.65654,
    lng: -97.17766,
    city: "Gainesville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28546,
    density: 29.8,
    county_fips: 48097,
    county_name: "Cooke",
    county_weights: {
      48097: 100,
    },
    county_names_all: "Cooke",
    county_fips_all: 48097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76241,
    lat: 33.64542,
    lng: -97.17628,
    city: "Gainesville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48097,
    county_name: "Cooke",
    county_weights: {
      48097: 100,
    },
    county_names_all: "Cooke",
    county_fips_all: 48097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76244,
    lat: 32.93101,
    lng: -97.28076,
    city: "Keller",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 78815,
    density: 2041.4,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76245,
    lat: 33.82885,
    lng: -96.85422,
    city: "Gordonville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1463,
    density: 23.3,
    county_fips: 48181,
    county_name: "Grayson",
    county_weights: {
      48181: 100,
    },
    county_names_all: "Grayson",
    county_fips_all: 48181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76247,
    lat: 33.0965,
    lng: -97.33154,
    city: "Justin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12542,
    density: 65.1,
    county_fips: 48121,
    county_name: "Denton",
    county_weights: {
      48121: 96.58,
      48497: 3.42,
    },
    county_names_all: "Denton|Wise",
    county_fips_all: "48121|48497",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76248,
    lat: 32.92988,
    lng: -97.22972,
    city: "Keller",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39641,
    density: 966.5,
    county_fips: 48439,
    county_name: "Tarrant",
    county_weights: {
      48439: 100,
    },
    county_names_all: "Tarrant",
    county_fips_all: 48439,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76249,
    lat: 33.27993,
    lng: -97.3026,
    city: "Krum",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8196,
    density: 44.5,
    county_fips: 48121,
    county_name: "Denton",
    county_weights: {
      48121: 95.5,
      48497: 4.5,
    },
    county_names_all: "Denton|Wise",
    county_fips_all: "48121|48497",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76250,
    lat: 33.63006,
    lng: -97.24237,
    city: "Lindsay",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 894,
    density: 83.2,
    county_fips: 48097,
    county_name: "Cooke",
    county_weights: {
      48097: 100,
    },
    county_names_all: "Cooke",
    county_fips_all: 48097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76251,
    lat: 33.65455,
    lng: -97.69076,
    city: "Montague",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 763,
    density: 6.7,
    county_fips: 48337,
    county_name: "Montague",
    county_weights: {
      48337: 100,
    },
    county_names_all: "Montague",
    county_fips_all: 48337,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76252,
    lat: 33.67788,
    lng: -97.38695,
    city: "Muenster",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2441,
    density: 5,
    county_fips: 48097,
    county_name: "Cooke",
    county_weights: {
      48097: 97.82,
      48337: 2.18,
    },
    county_names_all: "Cooke|Montague",
    county_fips_all: "48097|48337",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76253,
    lat: 33.62516,
    lng: -97.31327,
    city: "Myra",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 383,
    density: 363.8,
    county_fips: 48097,
    county_name: "Cooke",
    county_weights: {
      48097: 100,
    },
    county_names_all: "Cooke",
    county_fips_all: 48097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76255,
    lat: 33.8179,
    lng: -97.71625,
    city: "Nocona",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5477,
    density: 7.7,
    county_fips: 48337,
    county_name: "Montague",
    county_weights: {
      48337: 100,
    },
    county_names_all: "Montague",
    county_fips_all: 48337,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76258,
    lat: 33.37202,
    lng: -96.9204,
    city: "Pilot Point",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6926,
    density: 29.6,
    county_fips: 48121,
    county_name: "Denton",
    county_weights: {
      48097: 1.37,
      48121: 83.25,
      48181: 15.38,
    },
    county_names_all: "Denton|Grayson|Cooke",
    county_fips_all: "48121|48181|48097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76259,
    lat: 33.19977,
    lng: -97.31603,
    city: "Ponder",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5738,
    density: 43.3,
    county_fips: 48121,
    county_name: "Denton",
    county_weights: {
      48121: 95.93,
      48497: 4.07,
    },
    county_names_all: "Denton|Wise",
    county_fips_all: "48121|48497",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76261,
    lat: 33.80291,
    lng: -97.96233,
    city: "Ringgold",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 261,
    density: 1.4,
    county_fips: 48337,
    county_name: "Montague",
    county_weights: {
      48077: 36.47,
      48337: 63.53,
    },
    county_names_all: "Montague|Clay",
    county_fips_all: "48337|48077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76262,
    lat: 33.01137,
    lng: -97.22101,
    city: "Roanoke",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41158,
    density: 375.4,
    county_fips: 48121,
    county_name: "Denton",
    county_weights: {
      48121: 73.77,
      48439: 26.23,
    },
    county_names_all: "Denton|Tarrant",
    county_fips_all: "48121|48439",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76263,
    lat: 33.50435,
    lng: -97.43735,
    city: "Rosston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23,
    density: 2.2,
    county_fips: 48097,
    county_name: "Cooke",
    county_weights: {
      48097: 100,
    },
    county_names_all: "Cooke",
    county_fips_all: 48097,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76264,
    lat: 33.74172,
    lng: -96.83509,
    city: "Sadler",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1368,
    density: 14.6,
    county_fips: 48181,
    county_name: "Grayson",
    county_weights: {
      48181: 100,
    },
    county_names_all: "Grayson",
    county_fips_all: 48181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76265,
    lat: 33.74079,
    lng: -97.53922,
    city: "Saint Jo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1464,
    density: 3.3,
    county_fips: 48337,
    county_name: "Montague",
    county_weights: {
      48097: 16.24,
      48337: 83.76,
    },
    county_names_all: "Montague|Cooke",
    county_fips_all: "48337|48097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76266,
    lat: 33.36818,
    lng: -97.21513,
    city: "Sanger",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16571,
    density: 52.4,
    county_fips: 48121,
    county_name: "Denton",
    county_weights: {
      48097: 2.72,
      48121: 97.28,
    },
    county_names_all: "Denton|Cooke",
    county_fips_all: "48121|48097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76267,
    lat: 33.36935,
    lng: -97.39711,
    city: "Slidell",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48497,
    county_name: "Wise",
    county_weights: {
      48497: 100,
    },
    county_names_all: "Wise",
    county_fips_all: 48497,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76268,
    lat: 33.62785,
    lng: -96.76539,
    city: "Southmayd",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 224,
    density: 136,
    county_fips: 48181,
    county_name: "Grayson",
    county_weights: {
      48181: 100,
    },
    county_names_all: "Grayson",
    county_fips_all: 48181,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76270,
    lat: 33.45471,
    lng: -97.76247,
    city: "Sunset",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1932,
    density: 7.8,
    county_fips: 48337,
    county_name: "Montague",
    county_weights: {
      48337: 71.54,
      48497: 28.46,
    },
    county_names_all: "Montague|Wise",
    county_fips_all: "48337|48497",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76271,
    lat: 33.46953,
    lng: -96.91412,
    city: "Tioga",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1984,
    density: 17.7,
    county_fips: 48181,
    county_name: "Grayson",
    county_weights: {
      48097: 40.85,
      48181: 59.15,
    },
    county_names_all: "Grayson|Cooke",
    county_fips_all: "48181|48097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76272,
    lat: 33.46421,
    lng: -97.12721,
    city: "Valley View",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4404,
    density: 17.6,
    county_fips: 48097,
    county_name: "Cooke",
    county_weights: {
      48097: 85.42,
      48121: 14.58,
    },
    county_names_all: "Cooke|Denton",
    county_fips_all: "48097|48121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76273,
    lat: 33.74794,
    lng: -96.93935,
    city: "Whitesboro",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9429,
    density: 17.6,
    county_fips: 48181,
    county_name: "Grayson",
    county_weights: {
      48097: 47.37,
      48181: 52.63,
    },
    county_names_all: "Grayson|Cooke",
    county_fips_all: "48181|48097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76301,
    lat: 33.90507,
    lng: -98.48043,
    city: "Wichita Falls",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15113,
    density: 511.1,
    county_fips: 48485,
    county_name: "Wichita",
    county_weights: {
      48485: 100,
    },
    county_names_all: "Wichita",
    county_fips_all: 48485,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76302,
    lat: 33.86607,
    lng: -98.48487,
    city: "Wichita Falls",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12867,
    density: 526.4,
    county_fips: 48485,
    county_name: "Wichita",
    county_weights: {
      48485: 100,
    },
    county_names_all: "Wichita",
    county_fips_all: 48485,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76305,
    lat: 33.99979,
    lng: -98.3909,
    city: "Wichita Falls",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4285,
    density: 7.6,
    county_fips: 48077,
    county_name: "Clay",
    county_weights: {
      48077: 68.74,
      48485: 31.26,
    },
    county_names_all: "Clay|Wichita",
    county_fips_all: "48077|48485",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76306,
    lat: 33.95237,
    lng: -98.52745,
    city: "Wichita Falls",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15726,
    density: 354.2,
    county_fips: 48485,
    county_name: "Wichita",
    county_weights: {
      48485: 100,
    },
    county_names_all: "Wichita",
    county_fips_all: 48485,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76308,
    lat: 33.85684,
    lng: -98.5378,
    city: "Wichita Falls",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19937,
    density: 980.7,
    county_fips: 48485,
    county_name: "Wichita",
    county_weights: {
      48009: 14.34,
      48485: 85.66,
    },
    county_names_all: "Wichita|Archer",
    county_fips_all: "48485|48009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76309,
    lat: 33.89551,
    lng: -98.544,
    city: "Wichita Falls",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13546,
    density: 945.7,
    county_fips: 48485,
    county_name: "Wichita",
    county_weights: {
      48485: 100,
    },
    county_names_all: "Wichita",
    county_fips_all: 48485,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76310,
    lat: 33.81115,
    lng: -98.51178,
    city: "Wichita Falls",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18908,
    density: 42.9,
    county_fips: 48009,
    county_name: "Archer",
    county_weights: {
      48009: 46.69,
      48077: 26.34,
      48485: 26.97,
    },
    county_names_all: "Archer|Wichita|Clay",
    county_fips_all: "48009|48485|48077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76311,
    lat: 33.97324,
    lng: -98.50823,
    city: "Sheppard Afb",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8760,
    density: 1417.4,
    county_fips: 48485,
    county_name: "Wichita",
    county_weights: {
      48485: 100,
    },
    county_names_all: "Wichita",
    county_fips_all: 48485,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76351,
    lat: 33.55553,
    lng: -98.71145,
    city: "Archer City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1805,
    density: 2.7,
    county_fips: 48009,
    county_name: "Archer",
    county_weights: {
      48009: 100,
    },
    county_names_all: "Archer",
    county_fips_all: 48009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76354,
    lat: 34.09521,
    lng: -98.62276,
    city: "Burkburnett",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12323,
    density: 57.6,
    county_fips: 48485,
    county_name: "Wichita",
    county_weights: {
      48485: 100,
    },
    county_names_all: "Wichita",
    county_fips_all: 48485,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76357,
    lat: 34.07875,
    lng: -98.18512,
    city: "Byers",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 517,
    density: 2.8,
    county_fips: 48077,
    county_name: "Clay",
    county_weights: {
      48077: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 48077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76360,
    lat: 33.97361,
    lng: -99.00302,
    city: "Electra",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3581,
    density: 3.6,
    county_fips: 48485,
    county_name: "Wichita",
    county_weights: {
      48009: 6.84,
      48023: 0.44,
      48485: 49.13,
      48487: 43.6,
    },
    county_names_all: "Wichita|Wilbarger|Archer|Baylor",
    county_fips_all: "48485|48487|48009|48023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76363,
    lat: 33.50762,
    lng: -99.53122,
    city: "Goree",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 399,
    density: 2.4,
    county_fips: 48275,
    county_name: "Knox",
    county_weights: {
      48275: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 48275,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76364,
    lat: 34.13998,
    lng: -99.00529,
    city: "Harrold",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 189,
    density: 1.3,
    county_fips: 48487,
    county_name: "Wilbarger",
    county_weights: {
      48487: 100,
    },
    county_names_all: "Wilbarger",
    county_fips_all: 48487,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76365,
    lat: 33.754,
    lng: -98.2076,
    city: "Henrietta",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4598,
    density: 3.3,
    county_fips: 48077,
    county_name: "Clay",
    county_weights: {
      48077: 96.93,
      48237: 3.07,
    },
    county_names_all: "Clay|Jack",
    county_fips_all: "48077|48237",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76366,
    lat: 33.71439,
    lng: -98.77436,
    city: "Holliday",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2152,
    density: 3.2,
    county_fips: 48009,
    county_name: "Archer",
    county_weights: {
      48009: 100,
    },
    county_names_all: "Archer",
    county_fips_all: 48009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76367,
    lat: 33.97361,
    lng: -98.7168,
    city: "Iowa Park",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13385,
    density: 27.9,
    county_fips: 48485,
    county_name: "Wichita",
    county_weights: {
      48485: 100,
    },
    county_names_all: "Wichita",
    county_fips_all: 48485,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76370,
    lat: 33.45624,
    lng: -98.89407,
    city: "Megargel",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 325,
    density: 3.1,
    county_fips: 48009,
    county_name: "Archer",
    county_weights: {
      48009: 100,
    },
    county_names_all: "Archer",
    county_fips_all: 48009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76371,
    lat: 33.48668,
    lng: -99.65453,
    city: "Munday",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1540,
    density: 4.6,
    county_fips: 48275,
    county_name: "Knox",
    county_weights: {
      48207: 3.31,
      48275: 96.69,
    },
    county_names_all: "Knox|Haskell",
    county_fips_all: "48275|48207",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76372,
    lat: 33.25173,
    lng: -98.93643,
    city: "Newcastle",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 953,
    density: 1.4,
    county_fips: 48447,
    county_name: "Throckmorton",
    county_weights: {
      48447: 51.11,
      48503: 48.89,
    },
    county_names_all: "Throckmorton|Young",
    county_fips_all: "48447|48503",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76373,
    lat: 34.15541,
    lng: -99.11973,
    city: "Oklaunion",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 144,
    density: 1.8,
    county_fips: 48487,
    county_name: "Wilbarger",
    county_weights: {
      48487: 100,
    },
    county_names_all: "Wilbarger",
    county_fips_all: 48487,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76374,
    lat: 33.34823,
    lng: -98.7648,
    city: "Olney",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3891,
    density: 5.5,
    county_fips: 48503,
    county_name: "Young",
    county_weights: {
      48009: 18.72,
      48447: 3.13,
      48503: 78.15,
    },
    county_names_all: "Young|Archer|Throckmorton",
    county_fips_all: "48503|48009|48447",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76377,
    lat: 34.0101,
    lng: -98.24191,
    city: "Petrolia",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 415,
    density: 6,
    county_fips: 48077,
    county_name: "Clay",
    county_weights: {
      48077: 100,
    },
    county_names_all: "Clay",
    county_fips_all: 48077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76379,
    lat: 33.67058,
    lng: -98.47453,
    city: "Scotland",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 680,
    density: 5.7,
    county_fips: 48009,
    county_name: "Archer",
    county_weights: {
      48009: 100,
    },
    county_names_all: "Archer",
    county_fips_all: 48009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76380,
    lat: 33.60434,
    lng: -99.22305,
    city: "Seymour",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3601,
    density: 1.6,
    county_fips: 48023,
    county_name: "Baylor",
    county_weights: {
      48023: 92.57,
      48275: 7.43,
    },
    county_names_all: "Baylor|Knox",
    county_fips_all: "48023|48275",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76384,
    lat: 34.14355,
    lng: -99.32067,
    city: "Vernon",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12112,
    density: 9.9,
    county_fips: 48487,
    county_name: "Wilbarger",
    county_weights: {
      48155: 0.43,
      48487: 99.57,
    },
    county_names_all: "Wilbarger|Foard",
    county_fips_all: "48487|48155",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76388,
    lat: 33.31785,
    lng: -99.62931,
    city: "Weinert",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 231,
    density: 0.9,
    county_fips: 48207,
    county_name: "Haskell",
    county_weights: {
      48207: 100,
    },
    county_names_all: "Haskell",
    county_fips_all: 48207,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76389,
    lat: 33.49713,
    lng: -98.47568,
    city: "Windthorst",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1542,
    density: 3.1,
    county_fips: 48009,
    county_name: "Archer",
    county_weights: {
      48009: 71.9,
      48077: 21.38,
      48237: 6.72,
    },
    county_names_all: "Archer|Clay|Jack",
    county_fips_all: "48009|48077|48237",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76401,
    lat: 32.27918,
    lng: -98.19994,
    city: "Stephenville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29904,
    density: 28.1,
    county_fips: 48143,
    county_name: "Erath",
    county_weights: {
      48143: 100,
    },
    county_names_all: "Erath",
    county_fips_all: 48143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76402,
    lat: 32.21728,
    lng: -98.21702,
    city: "Stephenville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 952,
    density: 13159,
    county_fips: 48143,
    county_name: "Erath",
    county_weights: {
      48143: 100,
    },
    county_names_all: "Erath",
    county_fips_all: 48143,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76424,
    lat: 32.80431,
    lng: -98.89236,
    city: "Breckenridge",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8898,
    density: 6.8,
    county_fips: 48429,
    county_name: "Stephens",
    county_weights: {
      48429: 96.71,
      48503: 3.29,
    },
    county_names_all: "Stephens|Young",
    county_fips_all: "48429|48503",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76426,
    lat: 33.16493,
    lng: -97.83772,
    city: "Bridgeport",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12694,
    density: 37.4,
    county_fips: 48497,
    county_name: "Wise",
    county_weights: {
      48237: 12.05,
      48497: 87.95,
    },
    county_names_all: "Wise|Jack",
    county_fips_all: "48497|48237",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76427,
    lat: 33.13145,
    lng: -98.39271,
    city: "Bryson",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1041,
    density: 11.8,
    county_fips: 48237,
    county_name: "Jack",
    county_weights: {
      48237: 100,
    },
    county_names_all: "Jack",
    county_fips_all: 48237,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76429,
    lat: 32.74742,
    lng: -98.67428,
    city: "Caddo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 154,
    density: 0.7,
    county_fips: 48429,
    county_name: "Stephens",
    county_weights: {
      48363: 11.2,
      48429: 88.8,
    },
    county_names_all: "Stephens|Palo Pinto",
    county_fips_all: "48429|48363",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76430,
    lat: 32.80303,
    lng: -99.23519,
    city: "Albany",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2169,
    density: 2.6,
    county_fips: 48417,
    county_name: "Shackelford",
    county_weights: {
      48417: 97.06,
      48447: 2.94,
    },
    county_names_all: "Shackelford|Throckmorton",
    county_fips_all: "48417|48447",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76431,
    lat: 33.31066,
    lng: -97.86228,
    city: "Chico",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3708,
    density: 11.9,
    county_fips: 48497,
    county_name: "Wise",
    county_weights: {
      48237: 23.72,
      48497: 76.28,
    },
    county_names_all: "Wise|Jack",
    county_fips_all: "48497|48237",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76432,
    lat: 31.83945,
    lng: -98.78705,
    city: "Blanket",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1467,
    density: 5.2,
    county_fips: 48049,
    county_name: "Brown",
    county_weights: {
      48049: 57.93,
      48093: 42.07,
    },
    county_names_all: "Brown|Comanche",
    county_fips_all: "48049|48093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76433,
    lat: 32.30662,
    lng: -98.01096,
    city: "Bluff Dale",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1834,
    density: 5.6,
    county_fips: 48143,
    county_name: "Erath",
    county_weights: {
      48143: 75.16,
      48221: 11.71,
      48425: 13.13,
    },
    county_names_all: "Erath|Somervell|Hood",
    county_fips_all: "48143|48425|48221",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76435,
    lat: 32.21754,
    lng: -98.85349,
    city: "Carbon",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 443,
    density: 1.7,
    county_fips: 48133,
    county_name: "Eastland",
    county_weights: {
      48133: 100,
    },
    county_names_all: "Eastland",
    county_fips_all: 48133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76436,
    lat: 31.87404,
    lng: -98.22271,
    city: "Carlton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 148,
    density: 1.1,
    county_fips: 48093,
    county_name: "Comanche",
    county_weights: {
      48093: 85.62,
      48143: 3.16,
      48193: 11.22,
    },
    county_names_all: "Comanche|Hamilton|Erath",
    county_fips_all: "48093|48193|48143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76437,
    lat: 32.388,
    lng: -99.01935,
    city: "Cisco",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5899,
    density: 5.7,
    county_fips: 48133,
    county_name: "Eastland",
    county_weights: {
      48059: 15.59,
      48133: 69.32,
      48429: 15.09,
    },
    county_names_all: "Eastland|Callahan|Stephens",
    county_fips_all: "48133|48059|48429",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76439,
    lat: 32.6176,
    lng: -97.92708,
    city: "Dennis",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48367,
    county_name: "Parker",
    county_weights: {
      48367: 100,
    },
    county_names_all: "Parker",
    county_fips_all: 48367,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76442,
    lat: 31.89015,
    lng: -98.61242,
    city: "Comanche",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7812,
    density: 6.9,
    county_fips: 48093,
    county_name: "Comanche",
    county_weights: {
      48093: 91.02,
      48193: 1.47,
      48333: 7.51,
    },
    county_names_all: "Comanche|Mills|Hamilton",
    county_fips_all: "48093|48333|48193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76443,
    lat: 32.11907,
    lng: -99.20174,
    city: "Cross Plains",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1903,
    density: 5.2,
    county_fips: 48059,
    county_name: "Callahan",
    county_weights: {
      48049: 22.57,
      48059: 72.87,
      48083: 4.56,
    },
    county_names_all: "Callahan|Brown|Coleman",
    county_fips_all: "48059|48049|48083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76444,
    lat: 32.11781,
    lng: -98.5672,
    city: "De Leon",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3515,
    density: 9.3,
    county_fips: 48093,
    county_name: "Comanche",
    county_weights: {
      48093: 98.89,
      48143: 1.11,
    },
    county_names_all: "Comanche|Erath",
    county_fips_all: "48093|48143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76445,
    lat: 32.30318,
    lng: -98.53829,
    city: "Desdemona",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 486,
    density: 3.4,
    county_fips: 48133,
    county_name: "Eastland",
    county_weights: {
      48093: 14.48,
      48133: 80.1,
      48143: 5.42,
    },
    county_names_all: "Eastland|Comanche|Erath",
    county_fips_all: "48133|48093|48143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76446,
    lat: 32.07572,
    lng: -98.35311,
    city: "Dublin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8120,
    density: 7.6,
    county_fips: 48143,
    county_name: "Erath",
    county_weights: {
      48093: 28.71,
      48143: 71.29,
    },
    county_names_all: "Erath|Comanche",
    county_fips_all: "48143|48093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76448,
    lat: 32.39257,
    lng: -98.79541,
    city: "Eastland",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4983,
    density: 15.4,
    county_fips: 48133,
    county_name: "Eastland",
    county_weights: {
      48133: 100,
    },
    county_names_all: "Eastland",
    county_fips_all: 48133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76449,
    lat: 32.91592,
    lng: -98.32512,
    city: "Graford",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2351,
    density: 4.4,
    county_fips: 48363,
    county_name: "Palo Pinto",
    county_weights: {
      48237: 0.8,
      48363: 99.2,
    },
    county_names_all: "Palo Pinto|Jack",
    county_fips_all: "48363|48237",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76450,
    lat: 33.05968,
    lng: -98.64152,
    city: "Graham",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13036,
    density: 10.3,
    county_fips: 48503,
    county_name: "Young",
    county_weights: {
      48363: 6.31,
      48429: 9.07,
      48503: 84.62,
    },
    county_names_all: "Young|Stephens|Palo Pinto",
    county_fips_all: "48503|48429|48363",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76452,
    lat: 31.77119,
    lng: -98.39198,
    city: "Energy",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 80,
    density: 1.3,
    county_fips: 48093,
    county_name: "Comanche",
    county_weights: {
      48093: 100,
    },
    county_names_all: "Comanche",
    county_fips_all: 48093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76453,
    lat: 32.57202,
    lng: -98.33908,
    city: "Gordon",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1438,
    density: 4.5,
    county_fips: 48363,
    county_name: "Palo Pinto",
    county_weights: {
      48143: 19.17,
      48363: 80.83,
    },
    county_names_all: "Palo Pinto|Erath",
    county_fips_all: "48363|48143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76454,
    lat: 32.22983,
    lng: -98.69621,
    city: "Gorman",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1903,
    density: 5.9,
    county_fips: 48133,
    county_name: "Eastland",
    county_weights: {
      48093: 24.25,
      48133: 75.75,
    },
    county_names_all: "Eastland|Comanche",
    county_fips_all: "48133|48093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76455,
    lat: 31.82142,
    lng: -98.36676,
    city: "Gustine",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 926,
    density: 5.2,
    county_fips: 48093,
    county_name: "Comanche",
    county_weights: {
      48093: 100,
    },
    county_names_all: "Comanche",
    county_fips_all: 48093,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76457,
    lat: 31.94968,
    lng: -98.02773,
    city: "Hico",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4045,
    density: 4.8,
    county_fips: 48193,
    county_name: "Hamilton",
    county_weights: {
      48035: 8.05,
      48143: 34.13,
      48193: 57.82,
    },
    county_names_all: "Hamilton|Erath|Bosque",
    county_fips_all: "48193|48143|48035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76458,
    lat: 33.21518,
    lng: -98.18944,
    city: "Jacksboro",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6121,
    density: 4,
    county_fips: 48237,
    county_name: "Jack",
    county_weights: {
      48237: 99.47,
      48497: 0.53,
    },
    county_names_all: "Jack|Wise",
    county_fips_all: "48237|48497",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76459,
    lat: 33.27395,
    lng: -98.38972,
    city: "Jermyn",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 200,
    density: 2.8,
    county_fips: 48237,
    county_name: "Jack",
    county_weights: {
      48237: 100,
    },
    county_names_all: "Jack",
    county_fips_all: 48237,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76460,
    lat: 33.30796,
    lng: -98.49798,
    city: "Loving",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 433,
    density: 1.6,
    county_fips: 48503,
    county_name: "Young",
    county_weights: {
      48503: 100,
    },
    county_names_all: "Young",
    county_fips_all: 48503,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76462,
    lat: 32.52316,
    lng: -98.03421,
    city: "Lipan",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4412,
    density: 9.8,
    county_fips: 48221,
    county_name: "Hood",
    county_weights: {
      48143: 25.56,
      48221: 36.56,
      48363: 13.05,
      48367: 24.83,
    },
    county_names_all: "Hood|Erath|Parker|Palo Pinto",
    county_fips_all: "48221|48143|48367|48363",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76463,
    lat: 32.455,
    lng: -98.41516,
    city: "Mingus",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 450,
    density: 2.3,
    county_fips: 48143,
    county_name: "Erath",
    county_weights: {
      48143: 89.1,
      48363: 10.9,
    },
    county_names_all: "Erath|Palo Pinto",
    county_fips_all: "48143|48363",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76464,
    lat: 32.57554,
    lng: -99.1542,
    city: "Moran",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 516,
    density: 0.9,
    county_fips: 48417,
    county_name: "Shackelford",
    county_weights: {
      48059: 14.1,
      48417: 58.18,
      48429: 27.72,
    },
    county_names_all: "Shackelford|Stephens|Callahan",
    county_fips_all: "48417|48429|48059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76466,
    lat: 32.42887,
    lng: -98.7332,
    city: "Olden",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 125,
    density: 13.6,
    county_fips: 48133,
    county_name: "Eastland",
    county_weights: {
      48133: 100,
    },
    county_names_all: "Eastland",
    county_fips_all: 48133,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76469,
    lat: 32.34696,
    lng: -99.21707,
    city: "Putnam",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 90,
    density: 1.2,
    county_fips: 48059,
    county_name: "Callahan",
    county_weights: {
      48059: 100,
    },
    county_names_all: "Callahan",
    county_fips_all: 48059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76470,
    lat: 32.49977,
    lng: -98.6686,
    city: "Ranger",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3518,
    density: 5.1,
    county_fips: 48133,
    county_name: "Eastland",
    county_weights: {
      48133: 54.44,
      48429: 45.56,
    },
    county_names_all: "Eastland|Stephens",
    county_fips_all: "48133|48429",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76471,
    lat: 32.11117,
    lng: -98.98499,
    city: "Rising Star",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1772,
    density: 4.2,
    county_fips: 48133,
    county_name: "Eastland",
    county_weights: {
      48049: 27.33,
      48093: 8.54,
      48133: 64.13,
    },
    county_names_all: "Eastland|Brown|Comanche",
    county_fips_all: "48133|48049|48093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76472,
    lat: 32.60631,
    lng: -98.17095,
    city: "Santo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1502,
    density: 6.2,
    county_fips: 48363,
    county_name: "Palo Pinto",
    county_weights: {
      48363: 100,
    },
    county_names_all: "Palo Pinto",
    county_fips_all: 48363,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76474,
    lat: 31.97036,
    lng: -98.79142,
    city: "Sidney",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 327,
    density: 4,
    county_fips: 48093,
    county_name: "Comanche",
    county_weights: {
      48049: 3.46,
      48093: 96.54,
    },
    county_names_all: "Comanche|Brown",
    county_fips_all: "48093|48049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76475,
    lat: 32.65296,
    lng: -98.51281,
    city: "Strawn",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1204,
    density: 1.7,
    county_fips: 48363,
    county_name: "Palo Pinto",
    county_weights: {
      48133: 10.81,
      48363: 72.99,
      48429: 16.2,
    },
    county_names_all: "Palo Pinto|Stephens|Eastland",
    county_fips_all: "48363|48429|48133",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76476,
    lat: 32.37055,
    lng: -97.92017,
    city: "Tolar",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3151,
    density: 11.1,
    county_fips: 48221,
    county_name: "Hood",
    county_weights: {
      48221: 100,
    },
    county_names_all: "Hood",
    county_fips_all: 48221,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76481,
    lat: 32.99706,
    lng: -98.70977,
    city: "South Bend",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 191,
    density: 1.9,
    county_fips: 48503,
    county_name: "Young",
    county_weights: {
      48503: 100,
    },
    county_names_all: "Young",
    county_fips_all: 48503,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76483,
    lat: 33.16667,
    lng: -99.25111,
    city: "Throckmorton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 895,
    density: 0.8,
    county_fips: 48447,
    county_name: "Throckmorton",
    county_weights: {
      48447: 100,
    },
    county_names_all: "Throckmorton",
    county_fips_all: 48447,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76484,
    lat: 32.73147,
    lng: -98.30551,
    city: "Palo Pinto",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 909,
    density: 3.6,
    county_fips: 48363,
    county_name: "Palo Pinto",
    county_weights: {
      48363: 100,
    },
    county_names_all: "Palo Pinto",
    county_fips_all: 48363,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76486,
    lat: 33.02138,
    lng: -98.05618,
    city: "Perrin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 970,
    density: 4,
    county_fips: 48237,
    county_name: "Jack",
    county_weights: {
      48237: 66.77,
      48363: 17.07,
      48367: 16.16,
    },
    county_names_all: "Jack|Palo Pinto|Parker",
    county_fips_all: "48237|48363|48367",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76487,
    lat: 32.97912,
    lng: -97.88346,
    city: "Poolville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2230,
    density: 9.7,
    county_fips: 48367,
    county_name: "Parker",
    county_weights: {
      48237: 10.39,
      48367: 66.13,
      48497: 23.48,
    },
    county_names_all: "Parker|Wise|Jack",
    county_fips_all: "48367|48497|48237",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76490,
    lat: 32.95721,
    lng: -98.04033,
    city: "Whitt",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48367,
    county_name: "Parker",
    county_weights: {
      48367: 100,
    },
    county_names_all: "Parker",
    county_fips_all: 48367,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76491,
    lat: 33.05754,
    lng: -99.03834,
    city: "Woodson",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 466,
    density: 1.2,
    county_fips: 48447,
    county_name: "Throckmorton",
    county_weights: {
      48429: 1.41,
      48447: 98.59,
    },
    county_names_all: "Throckmorton|Stephens",
    county_fips_all: "48447|48429",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76501,
    lat: 31.07555,
    lng: -97.25469,
    city: "Temple",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16922,
    density: 55.3,
    county_fips: 48027,
    county_name: "Bell",
    county_weights: {
      48027: 100,
    },
    county_names_all: "Bell",
    county_fips_all: 48027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76502,
    lat: 31.09388,
    lng: -97.41082,
    city: "Temple",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42946,
    density: 284.6,
    county_fips: 48027,
    county_name: "Bell",
    county_weights: {
      48027: 100,
    },
    county_names_all: "Bell",
    county_fips_all: 48027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76504,
    lat: 31.14135,
    lng: -97.37748,
    city: "Temple",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22769,
    density: 285.1,
    county_fips: 48027,
    county_name: "Bell",
    county_weights: {
      48027: 100,
    },
    county_names_all: "Bell",
    county_fips_all: 48027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76511,
    lat: 30.79955,
    lng: -97.42293,
    city: "Bartlett",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2426,
    density: 11.3,
    county_fips: 48027,
    county_name: "Bell",
    county_weights: {
      48027: 57.24,
      48331: 6.15,
      48491: 36.61,
    },
    county_names_all: "Bell|Williamson|Milam",
    county_fips_all: "48027|48491|48331",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76513,
    lat: 31.05777,
    lng: -97.50369,
    city: "Belton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42162,
    density: 150.3,
    county_fips: 48027,
    county_name: "Bell",
    county_weights: {
      48027: 100,
    },
    county_names_all: "Bell",
    county_fips_all: 48027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76518,
    lat: 30.85091,
    lng: -97.13957,
    city: "Buckholts",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1810,
    density: 6.2,
    county_fips: 48331,
    county_name: "Milam",
    county_weights: {
      48331: 100,
    },
    county_names_all: "Milam",
    county_fips_all: 48331,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76519,
    lat: 30.98978,
    lng: -97.03579,
    city: "Burlington",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 350,
    density: 2.1,
    county_fips: 48331,
    county_name: "Milam",
    county_weights: {
      48027: 28.49,
      48145: 14.59,
      48331: 56.92,
    },
    county_names_all: "Milam|Bell|Falls",
    county_fips_all: "48331|48027|48145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76520,
    lat: 30.87266,
    lng: -96.89972,
    city: "Cameron",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8033,
    density: 12.1,
    county_fips: 48331,
    county_name: "Milam",
    county_weights: {
      48331: 100,
    },
    county_names_all: "Milam",
    county_fips_all: 48331,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76522,
    lat: 31.21577,
    lng: -97.97215,
    city: "Copperas Cove",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37382,
    density: 125.5,
    county_fips: 48099,
    county_name: "Coryell",
    county_weights: {
      48099: 80.26,
      48281: 19.74,
    },
    county_names_all: "Coryell|Lampasas",
    county_fips_all: "48099|48281",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76523,
    lat: 30.80366,
    lng: -97.27795,
    city: "Davilla",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48331,
    county_name: "Milam",
    county_weights: {
      48027: 0.24,
      48331: 99.76,
    },
    county_names_all: "Milam|Bell",
    county_fips_all: "48331|48027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76524,
    lat: 31.27445,
    lng: -97.20736,
    city: "Eddy",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4072,
    density: 25.8,
    county_fips: 48145,
    county_name: "Falls",
    county_weights: {
      48145: 80.36,
      48309: 19.64,
    },
    county_names_all: "Falls|McLennan",
    county_fips_all: "48145|48309",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76525,
    lat: 31.47643,
    lng: -98.17321,
    city: "Evant",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1188,
    density: 2.9,
    county_fips: 48193,
    county_name: "Hamilton",
    county_weights: {
      48099: 27.15,
      48193: 51.52,
      48281: 21.33,
    },
    county_names_all: "Hamilton|Coryell|Lampasas",
    county_fips_all: "48193|48099|48281",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76527,
    lat: 30.8379,
    lng: -97.79531,
    city: "Florence",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3696,
    density: 11.9,
    county_fips: 48491,
    county_name: "Williamson",
    county_weights: {
      48027: 6.64,
      48053: 7.62,
      48491: 85.74,
    },
    county_names_all: "Williamson|Burnet|Bell",
    county_fips_all: "48491|48053|48027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76528,
    lat: 31.43589,
    lng: -97.7844,
    city: "Gatesville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19224,
    density: 15.3,
    county_fips: 48099,
    county_name: "Coryell",
    county_weights: {
      48027: 1.94,
      48099: 98.06,
    },
    county_names_all: "Coryell|Bell",
    county_fips_all: "48099|48027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76530,
    lat: 30.71357,
    lng: -97.42434,
    city: "Granger",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1788,
    density: 7.5,
    county_fips: 48491,
    county_name: "Williamson",
    county_weights: {
      48491: 100,
    },
    county_names_all: "Williamson",
    county_fips_all: 48491,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76531,
    lat: 31.68423,
    lng: -98.19058,
    city: "Hamilton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4595,
    density: 4.6,
    county_fips: 48193,
    county_name: "Hamilton",
    county_weights: {
      48093: 2.49,
      48193: 96.13,
      48333: 1.38,
    },
    county_names_all: "Hamilton|Comanche|Mills",
    county_fips_all: "48193|48093|48333",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76534,
    lat: 30.88225,
    lng: -97.36952,
    city: "Holland",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3119,
    density: 13.8,
    county_fips: 48027,
    county_name: "Bell",
    county_weights: {
      48027: 93.28,
      48331: 6.72,
    },
    county_names_all: "Bell|Milam",
    county_fips_all: "48027|48331",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76537,
    lat: 30.81779,
    lng: -97.60645,
    city: "Jarrell",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7065,
    density: 50.8,
    county_fips: 48491,
    county_name: "Williamson",
    county_weights: {
      48491: 100,
    },
    county_names_all: "Williamson",
    county_fips_all: 48491,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76538,
    lat: 31.64261,
    lng: -97.8896,
    city: "Jonesboro",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1167,
    density: 3,
    county_fips: 48193,
    county_name: "Hamilton",
    county_weights: {
      48099: 30.91,
      48193: 69.09,
    },
    county_names_all: "Hamilton|Coryell",
    county_fips_all: "48193|48099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76539,
    lat: 31.09193,
    lng: -97.9992,
    city: "Kempner",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8824,
    density: 28.1,
    county_fips: 48281,
    county_name: "Lampasas",
    county_weights: {
      48027: 5.06,
      48053: 21.94,
      48099: 1.76,
      48281: 71.24,
    },
    county_names_all: "Lampasas|Burnet|Bell|Coryell",
    county_fips_all: "48281|48053|48027|48099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76541,
    lat: 31.11447,
    lng: -97.72922,
    city: "Killeen",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18396,
    density: 1452.1,
    county_fips: 48027,
    county_name: "Bell",
    county_weights: {
      48027: 100,
    },
    county_names_all: "Bell",
    county_fips_all: 48027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76542,
    lat: 31.00062,
    lng: -97.7274,
    city: "Killeen",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49765,
    density: 304.9,
    county_fips: 48027,
    county_name: "Bell",
    county_weights: {
      48027: 100,
    },
    county_names_all: "Bell",
    county_fips_all: 48027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76543,
    lat: 31.12343,
    lng: -97.64077,
    city: "Killeen",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32031,
    density: 347.7,
    county_fips: 48027,
    county_name: "Bell",
    county_weights: {
      48027: 100,
    },
    county_names_all: "Bell",
    county_fips_all: 48027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76544,
    lat: 31.23134,
    lng: -97.75867,
    city: "Fort Hood",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23514,
    density: 244.1,
    county_fips: 48099,
    county_name: "Coryell",
    county_weights: {
      48027: 20.88,
      48099: 79.12,
    },
    county_names_all: "Coryell|Bell",
    county_fips_all: "48099|48027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76548,
    lat: 31.05299,
    lng: -97.64613,
    city: "Harker Heights",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31247,
    density: 749.3,
    county_fips: 48027,
    county_name: "Bell",
    county_weights: {
      48027: 100,
    },
    county_names_all: "Bell",
    county_fips_all: 48027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76549,
    lat: 31.01583,
    lng: -97.82546,
    city: "Killeen",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53490,
    density: 219.5,
    county_fips: 48027,
    county_name: "Bell",
    county_weights: {
      48027: 88.62,
      48053: 11.38,
    },
    county_names_all: "Bell|Burnet",
    county_fips_all: "48027|48053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76550,
    lat: 31.07714,
    lng: -98.22165,
    city: "Lampasas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14169,
    density: 10.1,
    county_fips: 48281,
    county_name: "Lampasas",
    county_weights: {
      48053: 41.63,
      48281: 58.37,
    },
    county_names_all: "Lampasas|Burnet",
    county_fips_all: "48281|48053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76554,
    lat: 30.97583,
    lng: -97.3677,
    city: "Little River Academy",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2461,
    density: 118.7,
    county_fips: 48027,
    county_name: "Bell",
    county_weights: {
      48027: 100,
    },
    county_names_all: "Bell",
    county_fips_all: 48027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76556,
    lat: 30.69481,
    lng: -96.84487,
    city: "Milano",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1707,
    density: 7.8,
    county_fips: 48331,
    county_name: "Milam",
    county_weights: {
      48051: 0.76,
      48331: 99.24,
    },
    county_names_all: "Milam|Burleson",
    county_fips_all: "48331|48051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76557,
    lat: 31.29075,
    lng: -97.39814,
    city: "Moody",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5991,
    density: 18.7,
    county_fips: 48027,
    county_name: "Bell",
    county_weights: {
      48027: 44.38,
      48099: 15.86,
      48309: 39.75,
    },
    county_names_all: "Bell|McLennan|Coryell",
    county_fips_all: "48027|48309|48099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76559,
    lat: 31.07987,
    lng: -97.61079,
    city: "Nolanville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6180,
    density: 423.5,
    county_fips: 48027,
    county_name: "Bell",
    county_weights: {
      48027: 100,
    },
    county_names_all: "Bell",
    county_fips_all: 48027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76561,
    lat: 31.42531,
    lng: -97.54098,
    city: "Oglesby",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 997,
    density: 6.5,
    county_fips: 48099,
    county_name: "Coryell",
    county_weights: {
      48099: 89.52,
      48309: 10.48,
    },
    county_names_all: "Coryell|McLennan",
    county_fips_all: "48099|48309",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76565,
    lat: 31.64508,
    lng: -98.3492,
    city: "Pottsville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 175,
    density: 2.4,
    county_fips: 48193,
    county_name: "Hamilton",
    county_weights: {
      48193: 100,
    },
    county_names_all: "Hamilton",
    county_fips_all: 48193,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76566,
    lat: 31.51664,
    lng: -97.99881,
    city: "Purmela",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 231,
    density: 1.2,
    county_fips: 48099,
    county_name: "Coryell",
    county_weights: {
      48099: 68.38,
      48193: 31.62,
    },
    county_names_all: "Coryell|Hamilton",
    county_fips_all: "48099|48193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76567,
    lat: 30.64535,
    lng: -97.01363,
    city: "Rockdale",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8867,
    density: 16,
    county_fips: 48331,
    county_name: "Milam",
    county_weights: {
      48051: 9.37,
      48331: 90.63,
    },
    county_names_all: "Milam|Burleson",
    county_fips_all: "48331|48051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76569,
    lat: 30.93873,
    lng: -97.21904,
    city: "Rogers",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2614,
    density: 10.5,
    county_fips: 48027,
    county_name: "Bell",
    county_weights: {
      48027: 72.62,
      48331: 27.38,
    },
    county_names_all: "Bell|Milam",
    county_fips_all: "48027|48331",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76570,
    lat: 31.0818,
    lng: -96.94173,
    city: "Rosebud",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2780,
    density: 6,
    county_fips: 48145,
    county_name: "Falls",
    county_weights: {
      48027: 0.42,
      48145: 66.65,
      48331: 32.93,
    },
    county_names_all: "Falls|Milam|Bell",
    county_fips_all: "48145|48331|48027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76571,
    lat: 30.93305,
    lng: -97.58448,
    city: "Salado",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9007,
    density: 27.8,
    county_fips: 48027,
    county_name: "Bell",
    county_weights: {
      48027: 100,
    },
    county_names_all: "Bell",
    county_fips_all: 48027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76573,
    lat: 30.81864,
    lng: -97.50226,
    city: "Schwertner",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28,
    density: 12.2,
    county_fips: 48491,
    county_name: "Williamson",
    county_weights: {
      48027: 0.1,
      48491: 99.9,
    },
    county_names_all: "Williamson|Bell",
    county_fips_all: "48491|48027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76574,
    lat: 30.58297,
    lng: -97.38967,
    city: "Taylor",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19328,
    density: 50.1,
    county_fips: 48491,
    county_name: "Williamson",
    county_weights: {
      48453: 0.14,
      48491: 99.86,
    },
    county_names_all: "Williamson|Travis",
    county_fips_all: "48491|48453",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76577,
    lat: 30.62128,
    lng: -97.1787,
    city: "Thorndale",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3074,
    density: 8.5,
    county_fips: 48331,
    county_name: "Milam",
    county_weights: {
      48331: 90.26,
      48491: 9.74,
    },
    county_names_all: "Milam|Williamson",
    county_fips_all: "48331|48491",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76578,
    lat: 30.53488,
    lng: -97.24092,
    city: "Thrall",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1233,
    density: 7.3,
    county_fips: 48491,
    county_name: "Williamson",
    county_weights: {
      48331: 0.79,
      48491: 99.21,
    },
    county_names_all: "Williamson|Milam",
    county_fips_all: "48491|48331",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76579,
    lat: 31.19894,
    lng: -97.26046,
    city: "Troy",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5547,
    density: 36,
    county_fips: 48027,
    county_name: "Bell",
    county_weights: {
      48027: 85.39,
      48145: 14.61,
    },
    county_names_all: "Bell|Falls",
    county_fips_all: "48027|48145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76596,
    lat: 31.47626,
    lng: -97.72696,
    city: "Gatesville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1268,
    density: 3616.9,
    county_fips: 48099,
    county_name: "Coryell",
    county_weights: {
      48099: 100,
    },
    county_names_all: "Coryell",
    county_fips_all: 48099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76597,
    lat: 31.48446,
    lng: -97.70983,
    city: "Gatesville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17,
    density: 4.9,
    county_fips: 48099,
    county_name: "Coryell",
    county_weights: {
      48099: 100,
    },
    county_names_all: "Coryell",
    county_fips_all: 48099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76598,
    lat: 31.47543,
    lng: -97.73488,
    city: "Gatesville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 482,
    density: 6034.3,
    county_fips: 48099,
    county_name: "Coryell",
    county_weights: {
      48099: 100,
    },
    county_names_all: "Coryell",
    county_fips_all: 48099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76599,
    lat: 31.47092,
    lng: -97.73361,
    city: "Gatesville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2351,
    density: 1181.4,
    county_fips: 48099,
    county_name: "Coryell",
    county_weights: {
      48099: 100,
    },
    county_names_all: "Coryell",
    county_fips_all: 48099,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76621,
    lat: 31.87789,
    lng: -97.08891,
    city: "Abbott",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1061,
    density: 6,
    county_fips: 48217,
    county_name: "Hill",
    county_weights: {
      48217: 96.31,
      48309: 3.69,
    },
    county_names_all: "Hill|McLennan",
    county_fips_all: "48217|48309",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76622,
    lat: 31.82032,
    lng: -97.24942,
    city: "Aquilla",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1537,
    density: 11.1,
    county_fips: 48217,
    county_name: "Hill",
    county_weights: {
      48217: 97.9,
      48309: 2.1,
    },
    county_names_all: "Hill|McLennan",
    county_fips_all: "48217|48309",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76623,
    lat: 32.219,
    lng: -96.78879,
    city: "Avalon",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48139,
    county_name: "Ellis",
    county_weights: {
      48139: 100,
    },
    county_names_all: "Ellis",
    county_fips_all: 48139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76624,
    lat: 31.66671,
    lng: -96.95099,
    city: "Axtell",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2485,
    density: 15.2,
    county_fips: 48309,
    county_name: "McLennan",
    county_weights: {
      48293: 12.45,
      48309: 87.55,
    },
    county_names_all: "McLennan|Limestone",
    county_fips_all: "48309|48293",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76626,
    lat: 32.10522,
    lng: -96.71615,
    city: "Blooming Grove",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1294,
    density: 11.1,
    county_fips: 48349,
    county_name: "Navarro",
    county_weights: {
      48139: 5.21,
      48349: 94.79,
    },
    county_names_all: "Navarro|Ellis",
    county_fips_all: "48349|48139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76627,
    lat: 32.10511,
    lng: -97.3881,
    city: "Blum",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1334,
    density: 5.5,
    county_fips: 48217,
    county_name: "Hill",
    county_weights: {
      48217: 100,
    },
    county_names_all: "Hill",
    county_fips_all: 48217,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76628,
    lat: 32.03007,
    lng: -96.97179,
    city: "Brandon",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 101,
    density: 6.8,
    county_fips: 48217,
    county_name: "Hill",
    county_weights: {
      48217: 100,
    },
    county_names_all: "Hill",
    county_fips_all: 48217,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76629,
    lat: 31.15114,
    lng: -96.65499,
    city: "Bremond",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1954,
    density: 5.2,
    county_fips: 48395,
    county_name: "Robertson",
    county_weights: {
      48145: 18.29,
      48395: 81.71,
    },
    county_names_all: "Robertson|Falls",
    county_fips_all: "48395|48145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76630,
    lat: 31.33993,
    lng: -97.22405,
    city: "Bruceville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1375,
    density: 34,
    county_fips: 48309,
    county_name: "McLennan",
    county_weights: {
      48145: 7.45,
      48309: 92.55,
    },
    county_names_all: "McLennan|Falls",
    county_fips_all: "48309|48145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76631,
    lat: 31.97905,
    lng: -96.96277,
    city: "Bynum",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 681,
    density: 7.6,
    county_fips: 48217,
    county_name: "Hill",
    county_weights: {
      48217: 100,
    },
    county_names_all: "Hill",
    county_fips_all: 48217,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76632,
    lat: 31.29602,
    lng: -97.06158,
    city: "Chilton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1400,
    density: 10.3,
    county_fips: 48145,
    county_name: "Falls",
    county_weights: {
      48145: 100,
    },
    county_names_all: "Falls",
    county_fips_all: 48145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76633,
    lat: 31.6857,
    lng: -97.32503,
    city: "China Spring",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5334,
    density: 36.9,
    county_fips: 48309,
    county_name: "McLennan",
    county_weights: {
      48035: 26.38,
      48309: 73.62,
    },
    county_names_all: "McLennan|Bosque",
    county_fips_all: "48309|48035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76634,
    lat: 31.80953,
    lng: -97.56866,
    city: "Clifton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7610,
    density: 10.3,
    county_fips: 48035,
    county_name: "Bosque",
    county_weights: {
      48035: 97.9,
      48099: 2.1,
    },
    county_names_all: "Bosque|Coryell",
    county_fips_all: "48035|48099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76635,
    lat: 31.72956,
    lng: -96.66483,
    city: "Coolidge",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1330,
    density: 4.4,
    county_fips: 48293,
    county_name: "Limestone",
    county_weights: {
      48293: 100,
    },
    county_names_all: "Limestone",
    county_fips_all: 48293,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76636,
    lat: 32.17213,
    lng: -97.28307,
    city: "Covington",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1509,
    density: 12.9,
    county_fips: 48217,
    county_name: "Hill",
    county_weights: {
      48217: 100,
    },
    county_names_all: "Hill",
    county_fips_all: 48217,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76637,
    lat: 31.76631,
    lng: -97.81817,
    city: "Cranfills Gap",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 461,
    density: 5.1,
    county_fips: 48035,
    county_name: "Bosque",
    county_weights: {
      48035: 56.83,
      48193: 43.17,
    },
    county_names_all: "Bosque|Hamilton",
    county_fips_all: "48035|48193",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76638,
    lat: 31.55487,
    lng: -97.446,
    city: "Crawford",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3355,
    density: 18.1,
    county_fips: 48309,
    county_name: "McLennan",
    county_weights: {
      48309: 100,
    },
    county_names_all: "McLennan",
    county_fips_all: 48309,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76639,
    lat: 31.87254,
    lng: -96.65551,
    city: "Dawson",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1437,
    density: 6.1,
    county_fips: 48349,
    county_name: "Navarro",
    county_weights: {
      48349: 100,
    },
    county_names_all: "Navarro",
    county_fips_all: 48349,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76640,
    lat: 31.69029,
    lng: -97.07323,
    city: "Elm Mott",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3110,
    density: 42.5,
    county_fips: 48309,
    county_name: "McLennan",
    county_weights: {
      48309: 100,
    },
    county_names_all: "McLennan",
    county_fips_all: 48309,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76641,
    lat: 32.03847,
    lng: -96.78723,
    city: "Frost",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1687,
    density: 9,
    county_fips: 48349,
    county_name: "Navarro",
    county_weights: {
      48139: 8.47,
      48349: 91.53,
    },
    county_names_all: "Navarro|Ellis",
    county_fips_all: "48349|48139",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76642,
    lat: 31.50442,
    lng: -96.53271,
    city: "Groesbeck",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6628,
    density: 10.3,
    county_fips: 48293,
    county_name: "Limestone",
    county_weights: {
      48293: 100,
    },
    county_names_all: "Limestone",
    county_fips_all: 48293,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76643,
    lat: 31.45011,
    lng: -97.19732,
    city: "Hewitt",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14705,
    density: 747.1,
    county_fips: 48309,
    county_name: "McLennan",
    county_weights: {
      48309: 100,
    },
    county_names_all: "McLennan",
    county_fips_all: 48309,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76645,
    lat: 32.01224,
    lng: -97.12816,
    city: "Hillsboro",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10513,
    density: 21.6,
    county_fips: 48217,
    county_name: "Hill",
    county_weights: {
      48217: 100,
    },
    county_names_all: "Hill",
    county_fips_all: 48217,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76648,
    lat: 31.84942,
    lng: -96.80659,
    city: "Hubbard",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2697,
    density: 10.1,
    county_fips: 48217,
    county_name: "Hill",
    county_weights: {
      48217: 74.22,
      48293: 14,
      48349: 11.78,
    },
    county_names_all: "Hill|Limestone|Navarro",
    county_fips_all: "48217|48293|48349",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76649,
    lat: 32.00132,
    lng: -97.87816,
    city: "Iredell",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 646,
    density: 2,
    county_fips: 48035,
    county_name: "Bosque",
    county_weights: {
      48035: 79.18,
      48143: 20.82,
    },
    county_names_all: "Bosque|Erath",
    county_fips_all: "48035|48143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76650,
    lat: 31.98994,
    lng: -96.86678,
    city: "Irene",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 153,
    density: 7.6,
    county_fips: 48217,
    county_name: "Hill",
    county_weights: {
      48217: 100,
    },
    county_names_all: "Hill",
    county_fips_all: 48217,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76651,
    lat: 32.18313,
    lng: -96.87158,
    city: "Italy",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4084,
    density: 16.6,
    county_fips: 48139,
    county_name: "Ellis",
    county_weights: {
      48139: 100,
    },
    county_names_all: "Ellis",
    county_fips_all: 48139,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76652,
    lat: 32.11331,
    lng: -97.57648,
    city: "Kopperl",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1089,
    density: 4.4,
    county_fips: 48035,
    county_name: "Bosque",
    county_weights: {
      48035: 100,
    },
    county_names_all: "Bosque",
    county_fips_all: 48035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76653,
    lat: 31.29963,
    lng: -96.60536,
    city: "Kosse",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1481,
    density: 3.8,
    county_fips: 48293,
    county_name: "Limestone",
    county_weights: {
      48145: 32.86,
      48293: 57.59,
      48395: 9.55,
    },
    county_names_all: "Limestone|Falls|Robertson",
    county_fips_all: "48293|48145|48395",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76654,
    lat: 31.72708,
    lng: -97.01346,
    city: "Leroy",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 110,
    density: 47.3,
    county_fips: 48309,
    county_name: "McLennan",
    county_weights: {
      48309: 100,
    },
    county_names_all: "McLennan",
    county_fips_all: 48309,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76655,
    lat: 31.39295,
    lng: -97.1728,
    city: "Lorena",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8168,
    density: 40.6,
    county_fips: 48309,
    county_name: "McLennan",
    county_weights: {
      48145: 16.73,
      48309: 83.27,
    },
    county_names_all: "McLennan|Falls",
    county_fips_all: "48309|48145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76656,
    lat: 31.18555,
    lng: -97.06161,
    city: "Lott",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2656,
    density: 8.5,
    county_fips: 48145,
    county_name: "Falls",
    county_weights: {
      48145: 100,
    },
    county_names_all: "Falls",
    county_fips_all: 48145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76657,
    lat: 31.43851,
    lng: -97.39971,
    city: "McGregor",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11151,
    density: 31.1,
    county_fips: 48309,
    county_name: "McLennan",
    county_weights: {
      48099: 7.51,
      48309: 92.49,
    },
    county_names_all: "McLennan|Coryell",
    county_fips_all: "48309|48099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76660,
    lat: 31.93015,
    lng: -96.89331,
    city: "Malone",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 624,
    density: 7.4,
    county_fips: 48217,
    county_name: "Hill",
    county_weights: {
      48217: 100,
    },
    county_names_all: "Hill",
    county_fips_all: 48217,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76661,
    lat: 31.30785,
    lng: -96.84584,
    city: "Marlin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7824,
    density: 18.2,
    county_fips: 48145,
    county_name: "Falls",
    county_weights: {
      48145: 100,
    },
    county_names_all: "Falls",
    county_fips_all: 48145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76664,
    lat: 31.56202,
    lng: -96.79552,
    city: "Mart",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3387,
    density: 9.9,
    county_fips: 48293,
    county_name: "Limestone",
    county_weights: {
      48145: 7.04,
      48293: 64.69,
      48309: 28.27,
    },
    county_names_all: "Limestone|McLennan|Falls",
    county_fips_all: "48293|48309|48145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76665,
    lat: 31.91784,
    lng: -97.72049,
    city: "Meridian",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2562,
    density: 5.9,
    county_fips: 48035,
    county_name: "Bosque",
    county_weights: {
      48035: 100,
    },
    county_names_all: "Bosque",
    county_fips_all: 48035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76666,
    lat: 32.04653,
    lng: -96.89178,
    city: "Mertens",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 254,
    density: 3.5,
    county_fips: 48217,
    county_name: "Hill",
    county_weights: {
      48217: 63.16,
      48349: 36.84,
    },
    county_names_all: "Hill|Navarro",
    county_fips_all: "48217|48349",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76667,
    lat: 31.65668,
    lng: -96.46511,
    city: "Mexia",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10991,
    density: 27.7,
    county_fips: 48293,
    county_name: "Limestone",
    county_weights: {
      48161: 17.71,
      48293: 82.29,
    },
    county_names_all: "Limestone|Freestone",
    county_fips_all: "48293|48161",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76670,
    lat: 32.12887,
    lng: -96.98836,
    city: "Milford",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1617,
    density: 9.3,
    county_fips: 48139,
    county_name: "Ellis",
    county_weights: {
      48139: 62.55,
      48217: 37.45,
    },
    county_names_all: "Ellis|Hill",
    county_fips_all: "48139|48217",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76671,
    lat: 31.99351,
    lng: -97.52768,
    city: "Morgan",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1748,
    density: 9,
    county_fips: 48035,
    county_name: "Bosque",
    county_weights: {
      48035: 100,
    },
    county_names_all: "Bosque",
    county_fips_all: 48035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76673,
    lat: 31.75371,
    lng: -96.89105,
    city: "Mount Calm",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1804,
    density: 7.8,
    county_fips: 48217,
    county_name: "Hill",
    county_weights: {
      48217: 61.59,
      48293: 37.5,
      48309: 0.91,
    },
    county_names_all: "Hill|Limestone|McLennan",
    county_fips_all: "48217|48293|48309",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76676,
    lat: 31.87169,
    lng: -96.95847,
    city: "Penelope",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 238,
    density: 3.9,
    county_fips: 48217,
    county_name: "Hill",
    county_weights: {
      48217: 100,
    },
    county_names_all: "Hill",
    county_fips_all: 48217,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76678,
    lat: 31.65009,
    lng: -96.75087,
    city: "Prairie Hill",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 246,
    density: 3.4,
    county_fips: 48293,
    county_name: "Limestone",
    county_weights: {
      48293: 100,
    },
    county_names_all: "Limestone",
    county_fips_all: 48293,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76679,
    lat: 31.94557,
    lng: -96.59358,
    city: "Purdon",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1206,
    density: 7,
    county_fips: 48349,
    county_name: "Navarro",
    county_weights: {
      48349: 100,
    },
    county_names_all: "Navarro",
    county_fips_all: 48349,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76680,
    lat: 31.18798,
    lng: -96.80383,
    city: "Reagan",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 189,
    density: 1.6,
    county_fips: 48145,
    county_name: "Falls",
    county_weights: {
      48145: 100,
    },
    county_names_all: "Falls",
    county_fips_all: 48145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76681,
    lat: 31.91071,
    lng: -96.44006,
    city: "Richland",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 732,
    density: 10.9,
    county_fips: 48349,
    county_name: "Navarro",
    county_weights: {
      48349: 100,
    },
    county_names_all: "Navarro",
    county_fips_all: 48349,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76682,
    lat: 31.45235,
    lng: -96.90825,
    city: "Riesel",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3034,
    density: 9.4,
    county_fips: 48145,
    county_name: "Falls",
    county_weights: {
      48145: 60.23,
      48309: 39.77,
    },
    county_names_all: "Falls|McLennan",
    county_fips_all: "48145|48309",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76685,
    lat: 31.34973,
    lng: -97.0101,
    city: "Satin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37,
    density: 1,
    county_fips: 48145,
    county_name: "Falls",
    county_weights: {
      48145: 100,
    },
    county_names_all: "Falls",
    county_fips_all: 48145,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76686,
    lat: 31.74178,
    lng: -96.54464,
    city: "Tehuacana",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 188,
    density: 40.4,
    county_fips: 48293,
    county_name: "Limestone",
    county_weights: {
      48293: 100,
    },
    county_names_all: "Limestone",
    county_fips_all: 48293,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76687,
    lat: 31.36914,
    lng: -96.48691,
    city: "Thornton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1950,
    density: 5.7,
    county_fips: 48293,
    county_name: "Limestone",
    county_weights: {
      48145: 0.93,
      48293: 81.95,
      48395: 17.12,
    },
    county_names_all: "Limestone|Robertson|Falls",
    county_fips_all: "48293|48395|48145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76689,
    lat: 31.66624,
    lng: -97.50471,
    city: "Valley Mills",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3821,
    density: 6.6,
    county_fips: 48035,
    county_name: "Bosque",
    county_weights: {
      48035: 58.75,
      48099: 13.36,
      48309: 27.89,
    },
    county_names_all: "Bosque|McLennan|Coryell",
    county_fips_all: "48035|48309|48099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76690,
    lat: 32.1031,
    lng: -97.79219,
    city: "Walnut Springs",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1081,
    density: 4.7,
    county_fips: 48035,
    county_name: "Bosque",
    county_weights: {
      48035: 61.87,
      48143: 3.31,
      48425: 34.82,
    },
    county_names_all: "Bosque|Somervell|Erath",
    county_fips_all: "48035|48425|48143",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76691,
    lat: 31.77564,
    lng: -97.09721,
    city: "West",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6479,
    density: 25.6,
    county_fips: 48309,
    county_name: "McLennan",
    county_weights: {
      48217: 7.4,
      48309: 92.6,
    },
    county_names_all: "McLennan|Hill",
    county_fips_all: "48309|48217",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76692,
    lat: 31.95902,
    lng: -97.33382,
    city: "Whitney",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10048,
    density: 34.2,
    county_fips: 48217,
    county_name: "Hill",
    county_weights: {
      48217: 100,
    },
    county_names_all: "Hill",
    county_fips_all: 48217,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76693,
    lat: 31.80977,
    lng: -96.43843,
    city: "Wortham",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1825,
    density: 6,
    county_fips: 48161,
    county_name: "Freestone",
    county_weights: {
      48161: 52.13,
      48293: 10.25,
      48349: 37.62,
    },
    county_names_all: "Freestone|Navarro|Limestone",
    county_fips_all: "48161|48349|48293",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76701,
    lat: 31.55201,
    lng: -97.13852,
    city: "Waco",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1872,
    density: 632.5,
    county_fips: 48309,
    county_name: "McLennan",
    county_weights: {
      48309: 100,
    },
    county_names_all: "McLennan",
    county_fips_all: 48309,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76704,
    lat: 31.57558,
    lng: -97.12417,
    city: "Waco",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7681,
    density: 548.9,
    county_fips: 48309,
    county_name: "McLennan",
    county_weights: {
      48309: 100,
    },
    county_names_all: "McLennan",
    county_fips_all: 48309,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76705,
    lat: 31.62448,
    lng: -97.08814,
    city: "Waco",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31868,
    density: 103.7,
    county_fips: 48309,
    county_name: "McLennan",
    county_weights: {
      48309: 100,
    },
    county_names_all: "McLennan",
    county_fips_all: 48309,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76706,
    lat: 31.465,
    lng: -97.09131,
    city: "Waco",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39667,
    density: 211.9,
    county_fips: 48309,
    county_name: "McLennan",
    county_weights: {
      48145: 4.42,
      48309: 95.58,
    },
    county_names_all: "McLennan|Falls",
    county_fips_all: "48309|48145",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76707,
    lat: 31.55365,
    lng: -97.15829,
    city: "Waco",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15595,
    density: 1844.1,
    county_fips: 48309,
    county_name: "McLennan",
    county_weights: {
      48309: 100,
    },
    county_names_all: "McLennan",
    county_fips_all: 48309,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76708,
    lat: 31.62749,
    lng: -97.21186,
    city: "Waco",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27095,
    density: 217.7,
    county_fips: 48309,
    county_name: "McLennan",
    county_weights: {
      48309: 100,
    },
    county_names_all: "McLennan",
    county_fips_all: 48309,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76710,
    lat: 31.5387,
    lng: -97.19554,
    city: "Waco",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24607,
    density: 1018.2,
    county_fips: 48309,
    county_name: "McLennan",
    county_weights: {
      48309: 100,
    },
    county_names_all: "McLennan",
    county_fips_all: 48309,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76711,
    lat: 31.51422,
    lng: -97.15374,
    city: "Waco",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10475,
    density: 1011.5,
    county_fips: 48309,
    county_name: "McLennan",
    county_weights: {
      48309: 100,
    },
    county_names_all: "McLennan",
    county_fips_all: 48309,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76712,
    lat: 31.52411,
    lng: -97.25514,
    city: "Woodway",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26104,
    density: 192.4,
    county_fips: 48309,
    county_name: "McLennan",
    county_weights: {
      48309: 100,
    },
    county_names_all: "McLennan",
    county_fips_all: 48309,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76798,
    lat: 31.54606,
    lng: -97.12085,
    city: "Waco",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48309,
    county_name: "McLennan",
    county_weights: {
      48309: 100,
    },
    county_names_all: "McLennan",
    county_fips_all: 48309,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76801,
    lat: 31.75471,
    lng: -99.05462,
    city: "Brownwood",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24636,
    density: 25.3,
    county_fips: 48049,
    county_name: "Brown",
    county_weights: {
      48049: 94.87,
      48083: 3,
      48333: 2.13,
    },
    county_names_all: "Brown|Coleman|Mills",
    county_fips_all: "48049|48083|48333",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76802,
    lat: 31.7194,
    lng: -98.8949,
    city: "Early",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5271,
    density: 20.2,
    county_fips: 48049,
    county_name: "Brown",
    county_weights: {
      48049: 100,
    },
    county_names_all: "Brown",
    county_fips_all: 48049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76820,
    lat: 30.79295,
    lng: -99.04508,
    city: "Art",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 86,
    density: 0.3,
    county_fips: 48319,
    county_name: "Mason",
    county_weights: {
      48319: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 48319,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76821,
    lat: 31.73862,
    lng: -99.94963,
    city: "Ballinger",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4680,
    density: 6.8,
    county_fips: 48399,
    county_name: "Runnels",
    county_weights: {
      48399: 100,
    },
    county_names_all: "Runnels",
    county_fips_all: 48399,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76823,
    lat: 31.68718,
    lng: -99.16205,
    city: "Bangs",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3139,
    density: 13.2,
    county_fips: 48049,
    county_name: "Brown",
    county_weights: {
      48049: 87.42,
      48083: 12.58,
    },
    county_names_all: "Brown|Coleman",
    county_fips_all: "48049|48083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76824,
    lat: 30.9411,
    lng: -98.46339,
    city: "Bend",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13,
    density: 0.5,
    county_fips: 48411,
    county_name: "San Saba",
    county_weights: {
      48299: 0.11,
      48411: 99.89,
    },
    county_names_all: "San Saba|Llano",
    county_fips_all: "48411|48299",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76825,
    lat: 31.09493,
    lng: -99.39329,
    city: "Brady",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6682,
    density: 5.4,
    county_fips: 48307,
    county_name: "McCulloch",
    county_weights: {
      48307: 97.25,
      48319: 2.75,
    },
    county_names_all: "McCulloch|Mason",
    county_fips_all: "48307|48319",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76827,
    lat: 31.52589,
    lng: -99.13031,
    city: "Brookesmith",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 592,
    density: 2.8,
    county_fips: 48049,
    county_name: "Brown",
    county_weights: {
      48049: 93.12,
      48083: 6.88,
    },
    county_names_all: "Brown|Coleman",
    county_fips_all: "48049|48083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76828,
    lat: 32.00728,
    lng: -99.28435,
    city: "Burkett",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 199,
    density: 1.1,
    county_fips: 48083,
    county_name: "Coleman",
    county_weights: {
      48083: 100,
    },
    county_names_all: "Coleman",
    county_fips_all: 48083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76831,
    lat: 30.74599,
    lng: -98.95543,
    city: "Castell",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 48299,
    county_name: "Llano",
    county_weights: {
      48299: 99.85,
      48319: 0.15,
    },
    county_names_all: "Llano|Mason",
    county_fips_all: "48299|48319",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76832,
    lat: 30.97485,
    lng: -98.74384,
    city: "Cherokee",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 709,
    density: 1.5,
    county_fips: 48411,
    county_name: "San Saba",
    county_weights: {
      48411: 100,
    },
    county_names_all: "San Saba",
    county_fips_all: 48411,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76834,
    lat: 31.87885,
    lng: -99.46843,
    city: "Coleman",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5370,
    density: 4.7,
    county_fips: 48083,
    county_name: "Coleman",
    county_weights: {
      48083: 100,
    },
    county_names_all: "Coleman",
    county_fips_all: 48083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76836,
    lat: 31.42409,
    lng: -99.59196,
    city: "Doole",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3,
    density: 0,
    county_fips: 48307,
    county_name: "McCulloch",
    county_weights: {
      48095: 38.77,
      48307: 61.23,
    },
    county_names_all: "McCulloch|Concho",
    county_fips_all: "48307|48095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76837,
    lat: 31.21098,
    lng: -99.88176,
    city: "Eden",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2070,
    density: 2.1,
    county_fips: 48095,
    county_name: "Concho",
    county_weights: {
      48095: 100,
    },
    county_names_all: "Concho",
    county_fips_all: 48095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76841,
    lat: 30.86695,
    lng: -100.14226,
    city: "Fort McKavett",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 174,
    density: 0.3,
    county_fips: 48413,
    county_name: "Schleicher",
    county_weights: {
      48267: 1.01,
      48327: 31.43,
      48413: 67.56,
    },
    county_names_all: "Schleicher|Menard|Kimble",
    county_fips_all: "48413|48327|48267",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76842,
    lat: 30.91888,
    lng: -99.1023,
    city: "Fredonia",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 277,
    density: 1.3,
    county_fips: 48319,
    county_name: "Mason",
    county_weights: {
      48319: 59.38,
      48411: 40.62,
    },
    county_names_all: "Mason|San Saba",
    county_fips_all: "48319|48411",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76844,
    lat: 31.44387,
    lng: -98.49348,
    city: "Goldthwaite",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3393,
    density: 3.5,
    county_fips: 48333,
    county_name: "Mills",
    county_weights: {
      48193: 3.22,
      48281: 1.38,
      48333: 95.4,
    },
    county_names_all: "Mills|Hamilton|Lampasas",
    county_fips_all: "48333|48193|48281",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76845,
    lat: 31.54305,
    lng: -99.48192,
    city: "Gouldbusk",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 256,
    density: 0.9,
    county_fips: 48083,
    county_name: "Coleman",
    county_weights: {
      48083: 100,
    },
    county_names_all: "Coleman",
    county_fips_all: 48083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76848,
    lat: 30.83928,
    lng: -99.5637,
    city: "Hext",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 79,
    density: 0.4,
    county_fips: 48327,
    county_name: "Menard",
    county_weights: {
      48327: 100,
    },
    county_names_all: "Menard",
    county_fips_all: 48327,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76849,
    lat: 30.45849,
    lng: -99.83805,
    city: "Junction",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3760,
    density: 1.8,
    county_fips: 48267,
    county_name: "Kimble",
    county_weights: {
      48265: 3,
      48267: 97,
    },
    county_names_all: "Kimble|Kerr",
    county_fips_all: "48267|48265",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76852,
    lat: 31.35558,
    lng: -99.44335,
    city: "Lohn",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 291,
    density: 0.7,
    county_fips: 48307,
    county_name: "McCulloch",
    county_weights: {
      48307: 100,
    },
    county_names_all: "McCulloch",
    county_fips_all: 48307,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76853,
    lat: 31.24774,
    lng: -98.39047,
    city: "Lometa",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1333,
    density: 1.8,
    county_fips: 48281,
    county_name: "Lampasas",
    county_weights: {
      48281: 87.7,
      48333: 11.6,
      48411: 0.7,
    },
    county_names_all: "Lampasas|Mills|San Saba",
    county_fips_all: "48281|48333|48411",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76854,
    lat: 30.57125,
    lng: -99.53945,
    city: "London",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 306,
    density: 0.6,
    county_fips: 48267,
    county_name: "Kimble",
    county_weights: {
      48267: 85.78,
      48327: 14.22,
    },
    county_names_all: "Kimble|Menard",
    county_fips_all: "48267|48327",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76856,
    lat: 30.70296,
    lng: -99.26668,
    city: "Mason",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3746,
    density: 2.1,
    county_fips: 48319,
    county_name: "Mason",
    county_weights: {
      48319: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 48319,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76857,
    lat: 31.93361,
    lng: -98.93313,
    city: "May",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1773,
    density: 5.2,
    county_fips: 48049,
    county_name: "Brown",
    county_weights: {
      48049: 95.86,
      48093: 4.14,
    },
    county_names_all: "Brown|Comanche",
    county_fips_all: "48049|48093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76858,
    lat: 31.20758,
    lng: -99.62002,
    city: "Melvin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 300,
    density: 0.8,
    county_fips: 48095,
    county_name: "Concho",
    county_weights: {
      48095: 66.05,
      48307: 33.95,
    },
    county_names_all: "Concho|McCulloch",
    county_fips_all: "48095|48307",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76859,
    lat: 30.87106,
    lng: -99.83123,
    city: "Menard",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1787,
    density: 0.8,
    county_fips: 48327,
    county_name: "Menard",
    county_weights: {
      48267: 14.31,
      48327: 85.69,
    },
    county_names_all: "Menard|Kimble",
    county_fips_all: "48327|48267",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76861,
    lat: 31.59216,
    lng: -100.19637,
    city: "Miles",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1984,
    density: 4.4,
    county_fips: 48451,
    county_name: "Tom Green",
    county_weights: {
      48399: 40.02,
      48451: 59.98,
    },
    county_names_all: "Tom Green|Runnels",
    county_fips_all: "48451|48399",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76862,
    lat: 31.4138,
    lng: -99.70944,
    city: "Millersview",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 210,
    density: 0.8,
    county_fips: 48095,
    county_name: "Concho",
    county_weights: {
      48095: 100,
    },
    county_names_all: "Concho",
    county_fips_all: 48095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76864,
    lat: 31.54561,
    lng: -98.73637,
    city: "Mullin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 857,
    density: 1.3,
    county_fips: 48333,
    county_name: "Mills",
    county_weights: {
      48333: 100,
    },
    county_names_all: "Mills",
    county_fips_all: 48333,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76865,
    lat: 31.84944,
    lng: -100.13663,
    city: "Norton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 216,
    density: 1.8,
    county_fips: 48399,
    county_name: "Runnels",
    county_weights: {
      48399: 100,
    },
    county_names_all: "Runnels",
    county_fips_all: 48399,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76866,
    lat: 31.45181,
    lng: -99.92922,
    city: "Paint Rock",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 662,
    density: 0.9,
    county_fips: 48095,
    county_name: "Concho",
    county_weights: {
      48095: 100,
    },
    county_names_all: "Concho",
    county_fips_all: 48095,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76869,
    lat: 30.90951,
    lng: -98.97464,
    city: "Pontotoc",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37,
    density: 0.4,
    county_fips: 48411,
    county_name: "San Saba",
    county_weights: {
      48299: 22.9,
      48319: 37.99,
      48411: 39.11,
    },
    county_names_all: "San Saba|Mason|Llano",
    county_fips_all: "48411|48319|48299",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76870,
    lat: 31.60386,
    lng: -98.53151,
    city: "Priddy",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 238,
    density: 3.5,
    county_fips: 48333,
    county_name: "Mills",
    county_weights: {
      48333: 100,
    },
    county_names_all: "Mills",
    county_fips_all: 48333,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76871,
    lat: 31.27333,
    lng: -98.995,
    city: "Richland Springs",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 823,
    density: 1.4,
    county_fips: 48411,
    county_name: "San Saba",
    county_weights: {
      48307: 9.2,
      48411: 90.8,
    },
    county_names_all: "San Saba|McCulloch",
    county_fips_all: "48411|48307",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76872,
    lat: 31.3357,
    lng: -99.1603,
    city: "Rochelle",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 876,
    density: 1.1,
    county_fips: 48307,
    county_name: "McCulloch",
    county_weights: {
      48307: 79.34,
      48411: 20.66,
    },
    county_names_all: "McCulloch|San Saba",
    county_fips_all: "48307|48411",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76873,
    lat: 31.50459,
    lng: -99.3696,
    city: "Rockwood",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 93,
    density: 0.8,
    county_fips: 48083,
    county_name: "Coleman",
    county_weights: {
      48083: 100,
    },
    county_names_all: "Coleman",
    county_fips_all: 48083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76874,
    lat: 30.47693,
    lng: -100.12271,
    city: "Roosevelt",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14,
    density: 0.2,
    county_fips: 48267,
    county_name: "Kimble",
    county_weights: {
      48267: 56.68,
      48435: 43.32,
    },
    county_names_all: "Kimble|Sutton",
    county_fips_all: "48267|48435",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76875,
    lat: 31.59928,
    lng: -100.00749,
    city: "Rowena",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 449,
    density: 1.4,
    county_fips: 48399,
    county_name: "Runnels",
    county_weights: {
      48095: 37.37,
      48399: 62.63,
    },
    county_names_all: "Runnels|Concho",
    county_fips_all: "48399|48095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76877,
    lat: 31.15807,
    lng: -98.75361,
    city: "San Saba",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4225,
    density: 2.6,
    county_fips: 48411,
    county_name: "San Saba",
    county_weights: {
      48411: 100,
    },
    county_names_all: "San Saba",
    county_fips_all: 48411,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76878,
    lat: 31.66659,
    lng: -99.29611,
    city: "Santa Anna",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1670,
    density: 2.5,
    county_fips: 48083,
    county_name: "Coleman",
    county_weights: {
      48083: 100,
    },
    county_names_all: "Coleman",
    county_fips_all: 48083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76880,
    lat: 31.44491,
    lng: -98.3151,
    city: "Star",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48333,
    county_name: "Mills",
    county_weights: {
      48333: 100,
    },
    county_names_all: "Mills",
    county_fips_all: 48333,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76882,
    lat: 31.80059,
    lng: -99.71448,
    city: "Talpa",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 250,
    density: 0.5,
    county_fips: 48399,
    county_name: "Runnels",
    county_weights: {
      48083: 45.16,
      48399: 54.84,
    },
    county_names_all: "Runnels|Coleman",
    county_fips_all: "48399|48083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76884,
    lat: 31.69654,
    lng: -99.56407,
    city: "Valera",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 98,
    density: 2.4,
    county_fips: 48083,
    county_name: "Coleman",
    county_weights: {
      48083: 100,
    },
    county_names_all: "Coleman",
    county_fips_all: 48083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76885,
    lat: 30.87304,
    lng: -98.85742,
    city: "Valley Spring",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 234,
    density: 1.3,
    county_fips: 48299,
    county_name: "Llano",
    county_weights: {
      48299: 100,
    },
    county_names_all: "Llano",
    county_fips_all: 48299,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76887,
    lat: 31.02696,
    lng: -99.15806,
    city: "Voca",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 89,
    density: 0.4,
    county_fips: 48307,
    county_name: "McCulloch",
    county_weights: {
      48307: 100,
    },
    county_names_all: "McCulloch",
    county_fips_all: 48307,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76888,
    lat: 31.60919,
    lng: -99.63742,
    city: "Voss",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 137,
    density: 0.5,
    county_fips: 48083,
    county_name: "Coleman",
    county_weights: {
      48083: 100,
    },
    county_names_all: "Coleman",
    county_fips_all: 48083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76890,
    lat: 31.69229,
    lng: -98.7649,
    city: "Zephyr",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 865,
    density: 4,
    county_fips: 48049,
    county_name: "Brown",
    county_weights: {
      48049: 78.21,
      48093: 2.07,
      48333: 19.72,
    },
    county_names_all: "Brown|Mills|Comanche",
    county_fips_all: "48049|48333|48093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76901,
    lat: 31.52352,
    lng: -100.63993,
    city: "San Angelo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30972,
    density: 34.6,
    county_fips: 48451,
    county_name: "Tom Green",
    county_weights: {
      48235: 27.17,
      48451: 72.83,
    },
    county_names_all: "Tom Green|Irion",
    county_fips_all: "48451|48235",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76902,
    lat: 31.54439,
    lng: -100.72459,
    city: "San Angelo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48451,
    county_name: "Tom Green",
    county_weights: {
      48451: 100,
    },
    county_names_all: "Tom Green",
    county_fips_all: 48451,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76903,
    lat: 31.48168,
    lng: -100.43787,
    city: "San Angelo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31429,
    density: 484.5,
    county_fips: 48451,
    county_name: "Tom Green",
    county_weights: {
      48451: 100,
    },
    county_names_all: "Tom Green",
    county_fips_all: 48451,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76904,
    lat: 31.28844,
    lng: -100.41695,
    city: "San Angelo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36688,
    density: 32.1,
    county_fips: 48451,
    county_name: "Tom Green",
    county_weights: {
      48235: 7.74,
      48451: 92.26,
    },
    county_names_all: "Tom Green|Irion",
    county_fips_all: "48451|48235",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76905,
    lat: 31.49987,
    lng: -100.31583,
    city: "San Angelo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12746,
    density: 26.8,
    county_fips: 48451,
    county_name: "Tom Green",
    county_weights: {
      48451: 100,
    },
    county_names_all: "Tom Green",
    county_fips_all: 48451,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76908,
    lat: 31.43226,
    lng: -100.40314,
    city: "Goodfellow Afb",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2541,
    density: 629.8,
    county_fips: 48451,
    county_name: "Tom Green",
    county_weights: {
      48451: 100,
    },
    county_names_all: "Tom Green",
    county_fips_all: 48451,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76909,
    lat: 31.44135,
    lng: -100.46624,
    city: "San Angelo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48451,
    county_name: "Tom Green",
    county_weights: {
      48451: 100,
    },
    county_names_all: "Tom Green",
    county_fips_all: 48451,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76930,
    lat: 31.11075,
    lng: -101.11975,
    city: "Barnhart",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 86,
    density: 0.1,
    county_fips: 48235,
    county_name: "Irion",
    county_weights: {
      48105: 49.79,
      48235: 50.21,
    },
    county_names_all: "Irion|Crockett",
    county_fips_all: "48235|48105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76932,
    lat: 31.19124,
    lng: -101.54984,
    city: "Big Lake",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3941,
    density: 1.4,
    county_fips: 48383,
    county_name: "Reagan",
    county_weights: {
      48105: 36.9,
      48383: 63.1,
    },
    county_names_all: "Reagan|Crockett",
    county_fips_all: "48383|48105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76933,
    lat: 31.87618,
    lng: -100.28544,
    city: "Bronte",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1340,
    density: 1.9,
    county_fips: 48081,
    county_name: "Coke",
    county_weights: {
      48081: 69.84,
      48399: 30.16,
    },
    county_names_all: "Coke|Runnels",
    county_fips_all: "48081|48399",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76934,
    lat: 31.61491,
    lng: -100.67661,
    city: "Carlsbad",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 974,
    density: 8.7,
    county_fips: 48451,
    county_name: "Tom Green",
    county_weights: {
      48451: 100,
    },
    county_names_all: "Tom Green",
    county_fips_all: 48451,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76935,
    lat: 31.07744,
    lng: -100.42261,
    city: "Christoval",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1852,
    density: 1.9,
    county_fips: 48413,
    county_name: "Schleicher",
    county_weights: {
      48413: 51.07,
      48451: 48.93,
    },
    county_names_all: "Schleicher|Tom Green",
    county_fips_all: "48413|48451",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76936,
    lat: 30.88811,
    lng: -100.64723,
    city: "Eldorado",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2898,
    density: 1.2,
    county_fips: 48413,
    county_name: "Schleicher",
    county_weights: {
      48413: 100,
    },
    county_names_all: "Schleicher",
    county_fips_all: 48413,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76937,
    lat: 31.39109,
    lng: -100.15025,
    city: "Eola",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13,
    density: 0.3,
    county_fips: 48451,
    county_name: "Tom Green",
    county_weights: {
      48095: 19.61,
      48451: 80.39,
    },
    county_names_all: "Tom Green|Concho",
    county_fips_all: "48451|48095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76939,
    lat: 31.26855,
    lng: -100.59028,
    city: "Knickerbocker",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 48451,
    county_name: "Tom Green",
    county_weights: {
      48451: 100,
    },
    county_names_all: "Tom Green",
    county_fips_all: 48451,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76940,
    lat: 31.43681,
    lng: -100.12694,
    city: "Mereta",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 107,
    density: 4.7,
    county_fips: 48451,
    county_name: "Tom Green",
    county_weights: {
      48451: 100,
    },
    county_names_all: "Tom Green",
    county_fips_all: 48451,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76941,
    lat: 31.24731,
    lng: -100.89845,
    city: "Mertzon",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1421,
    density: 1.4,
    county_fips: 48235,
    county_name: "Irion",
    county_weights: {
      48235: 100,
    },
    county_names_all: "Irion",
    county_fips_all: 48235,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76943,
    lat: 30.48057,
    lng: -101.32623,
    city: "Ozona",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3206,
    density: 0.6,
    county_fips: 48105,
    county_name: "Crockett",
    county_weights: {
      48105: 74.39,
      48465: 25.61,
    },
    county_names_all: "Crockett|Val Verde",
    county_fips_all: "48105|48465",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76945,
    lat: 31.87297,
    lng: -100.60292,
    city: "Robert Lee",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1762,
    density: 1.1,
    county_fips: 48081,
    county_name: "Coke",
    county_weights: {
      48081: 94.88,
      48431: 1.06,
      48451: 4.06,
    },
    county_names_all: "Coke|Tom Green|Sterling",
    county_fips_all: "48081|48451|48431",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76950,
    lat: 30.43439,
    lng: -100.56564,
    city: "Sonora",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3824,
    density: 0.8,
    county_fips: 48435,
    county_name: "Sutton",
    county_weights: {
      48137: 13.26,
      48435: 79.31,
      48465: 7.43,
    },
    county_names_all: "Sutton|Edwards|Val Verde",
    county_fips_all: "48435|48137|48465",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76951,
    lat: 31.81255,
    lng: -101.04709,
    city: "Sterling City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1274,
    density: 0.6,
    county_fips: 48431,
    county_name: "Sterling",
    county_weights: {
      48431: 100,
    },
    county_names_all: "Sterling",
    county_fips_all: 48431,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76953,
    lat: 31.72871,
    lng: -100.32078,
    city: "Tennyson",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 83,
    density: 0.7,
    county_fips: 48081,
    county_name: "Coke",
    county_weights: {
      48081: 99.8,
      48451: 0.2,
    },
    county_names_all: "Coke|Tom Green",
    county_fips_all: "48081|48451",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76955,
    lat: 31.29919,
    lng: -100.1389,
    city: "Vancourt",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 141,
    density: 0.8,
    county_fips: 48451,
    county_name: "Tom Green",
    county_weights: {
      48095: 25.94,
      48451: 74.06,
    },
    county_names_all: "Tom Green|Concho",
    county_fips_all: "48451|48095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76957,
    lat: 31.37232,
    lng: -100.30514,
    city: "Wall",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 158,
    density: 237.2,
    county_fips: 48451,
    county_name: "Tom Green",
    county_weights: {
      48451: 100,
    },
    county_names_all: "Tom Green",
    county_fips_all: 48451,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 76958,
    lat: 31.64467,
    lng: -100.75515,
    city: "Water Valley",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 134,
    density: 1.1,
    county_fips: 48451,
    county_name: "Tom Green",
    county_weights: {
      48451: 100,
    },
    county_names_all: "Tom Green",
    county_fips_all: 48451,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77002,
    lat: 29.75635,
    lng: -95.36538,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17026,
    density: 3337.5,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77003,
    lat: 29.74961,
    lng: -95.34521,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9612,
    density: 1357.6,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77004,
    lat: 29.72477,
    lng: -95.36498,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38721,
    density: 2852.6,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77005,
    lat: 29.71824,
    lng: -95.42413,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29022,
    density: 2927.1,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77006,
    lat: 29.74086,
    lng: -95.39126,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21938,
    density: 3698,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77007,
    lat: 29.77152,
    lng: -95.40919,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40112,
    density: 2063,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77008,
    lat: 29.79856,
    lng: -95.41766,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36248,
    density: 2159.6,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77009,
    lat: 29.79499,
    lng: -95.36758,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37149,
    density: 2315.1,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77010,
    lat: 29.75368,
    lng: -95.35987,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 911,
    density: 2945,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77011,
    lat: 29.743,
    lng: -95.30785,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18296,
    density: 2071.4,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77012,
    lat: 29.71904,
    lng: -95.27449,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18640,
    density: 1830.3,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77013,
    lat: 29.79516,
    lng: -95.23895,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19548,
    density: 795.8,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77014,
    lat: 29.98025,
    lng: -95.46363,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36560,
    density: 1967.4,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77015,
    lat: 29.76485,
    lng: -95.17216,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57553,
    density: 1076,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77016,
    lat: 29.86147,
    lng: -95.29951,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30462,
    density: 1186.9,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77017,
    lat: 29.69153,
    lng: -95.25093,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34010,
    density: 1371.8,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77018,
    lat: 29.82703,
    lng: -95.42571,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28049,
    density: 1600.3,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77019,
    lat: 29.75318,
    lng: -95.41212,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22164,
    density: 2309.6,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77020,
    lat: 29.76842,
    lng: -95.30878,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26093,
    density: 1290.1,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77021,
    lat: 29.69713,
    lng: -95.35751,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25769,
    density: 1637.3,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77022,
    lat: 29.8306,
    lng: -95.3768,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27200,
    density: 1797.9,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77023,
    lat: 29.7216,
    lng: -95.31827,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28122,
    density: 1986.1,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77024,
    lat: 29.77073,
    lng: -95.50869,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38723,
    density: 1152.7,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77025,
    lat: 29.68584,
    lng: -95.43512,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29298,
    density: 2535,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77026,
    lat: 29.80013,
    lng: -95.32934,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21269,
    density: 1251.7,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77027,
    lat: 29.73919,
    lng: -95.44609,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19171,
    density: 2778.6,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77028,
    lat: 29.82471,
    lng: -95.28668,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18620,
    density: 789.2,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77029,
    lat: 29.76382,
    lng: -95.26326,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17478,
    density: 635.7,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77030,
    lat: 29.70597,
    lng: -95.40253,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11362,
    density: 1699.7,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77031,
    lat: 29.65434,
    lng: -95.54622,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17079,
    density: 2089,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48157: 0.86,
      48201: 99.14,
    },
    county_names_all: "Harris|Fort Bend",
    county_fips_all: "48201|48157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77032,
    lat: 29.96523,
    lng: -95.34004,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14351,
    density: 239.9,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77033,
    lat: 29.66801,
    lng: -95.33801,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29267,
    density: 1979.4,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77034,
    lat: 29.61522,
    lng: -95.19237,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36778,
    density: 1000.6,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77035,
    lat: 29.65269,
    lng: -95.47688,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36392,
    density: 2490.7,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77036,
    lat: 29.70119,
    lng: -95.53659,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69154,
    density: 3670.3,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77037,
    lat: 29.8918,
    lng: -95.39438,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18030,
    density: 1130.8,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77038,
    lat: 29.91906,
    lng: -95.44121,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30428,
    density: 1211.1,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77039,
    lat: 29.90923,
    lng: -95.34137,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27987,
    density: 1070.5,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77040,
    lat: 29.87539,
    lng: -95.52861,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50343,
    density: 1404,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77041,
    lat: 29.86203,
    lng: -95.58187,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33762,
    density: 690.6,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77042,
    lat: 29.74125,
    lng: -95.56015,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40659,
    density: 2545.4,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77043,
    lat: 29.8112,
    lng: -95.57981,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24957,
    density: 680.4,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77044,
    lat: 29.89808,
    lng: -95.17685,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51978,
    density: 513.3,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77045,
    lat: 29.63634,
    lng: -95.43279,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35010,
    density: 1212.2,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77046,
    lat: 29.73438,
    lng: -95.43301,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1344,
    density: 4844.8,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77047,
    lat: 29.60843,
    lng: -95.38662,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32747,
    density: 916.1,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77048,
    lat: 29.62154,
    lng: -95.32986,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18520,
    density: 620.4,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77049,
    lat: 29.83417,
    lng: -95.14827,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38915,
    density: 620.9,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77050,
    lat: 29.90286,
    lng: -95.27013,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6052,
    density: 340.2,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77051,
    lat: 29.65586,
    lng: -95.38023,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17547,
    density: 917.8,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77053,
    lat: 29.58549,
    lng: -95.45991,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31521,
    density: 1069.6,
    county_fips: 48157,
    county_name: "Fort Bend",
    county_weights: {
      48157: 68.9,
      48201: 31.1,
    },
    county_names_all: "Fort Bend|Harris",
    county_fips_all: "48157|48201",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77054,
    lat: 29.68102,
    lng: -95.40424,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24780,
    density: 1789.3,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77055,
    lat: 29.79757,
    lng: -95.4928,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45201,
    density: 2081.1,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77056,
    lat: 29.74849,
    lng: -95.46806,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22155,
    density: 2474.6,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77057,
    lat: 29.74522,
    lng: -95.48885,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42897,
    density: 3866.5,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77058,
    lat: 29.56297,
    lng: -95.09303,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15930,
    density: 735.4,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77059,
    lat: 29.60929,
    lng: -95.12417,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17483,
    density: 731,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77060,
    lat: 29.93567,
    lng: -95.39697,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45376,
    density: 2150,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77061,
    lat: 29.65436,
    lng: -95.28481,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26488,
    density: 1370.5,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77062,
    lat: 29.57584,
    lng: -95.13406,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25568,
    density: 1698.2,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77063,
    lat: 29.7356,
    lng: -95.52157,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41829,
    density: 3611.8,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77064,
    lat: 29.92279,
    lng: -95.5467,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49042,
    density: 1287.6,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77065,
    lat: 29.92673,
    lng: -95.60324,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39951,
    density: 1877.2,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77066,
    lat: 29.95714,
    lng: -95.50277,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38753,
    density: 1732.5,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77067,
    lat: 29.95283,
    lng: -95.44719,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34582,
    density: 2350.5,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77068,
    lat: 30.00628,
    lng: -95.48694,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10837,
    density: 1102.9,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77069,
    lat: 29.98631,
    lng: -95.52398,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18968,
    density: 1558.6,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77070,
    lat: 29.97783,
    lng: -95.57377,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56260,
    density: 1665.2,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77071,
    lat: 29.65265,
    lng: -95.52046,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27650,
    density: 2374.8,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77072,
    lat: 29.70006,
    lng: -95.58539,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65015,
    density: 3383.8,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77073,
    lat: 29.99849,
    lng: -95.39804,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40979,
    density: 1086.7,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77074,
    lat: 29.68821,
    lng: -95.51633,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40891,
    density: 2870.4,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77075,
    lat: 29.62119,
    lng: -95.26749,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46588,
    density: 1604.2,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77076,
    lat: 29.86002,
    lng: -95.38328,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34668,
    density: 2819.1,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77077,
    lat: 29.75375,
    lng: -95.64189,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61908,
    density: 1445.1,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77078,
    lat: 29.8529,
    lng: -95.25089,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14267,
    density: 535.4,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77079,
    lat: 29.77632,
    lng: -95.6037,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32826,
    density: 1638.4,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77080,
    lat: 29.81662,
    lng: -95.52375,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45254,
    density: 2728.5,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77081,
    lat: 29.71219,
    lng: -95.48026,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51781,
    density: 6150,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77082,
    lat: 29.72383,
    lng: -95.6414,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52830,
    density: 1620.7,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48157: 0.21,
      48201: 99.79,
    },
    county_names_all: "Harris|Fort Bend",
    county_fips_all: "48201|48157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77083,
    lat: 29.69316,
    lng: -95.64858,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 78240,
    density: 2914.4,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48157: 40.19,
      48201: 59.81,
    },
    county_names_all: "Harris|Fort Bend",
    county_fips_all: "48201|48157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77084,
    lat: 29.82698,
    lng: -95.6612,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 108161,
    density: 1315.9,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77085,
    lat: 29.62465,
    lng: -95.48411,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18155,
    density: 1278.7,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48157: 3.07,
      48201: 96.93,
    },
    county_names_all: "Harris|Fort Bend",
    county_fips_all: "48201|48157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77086,
    lat: 29.9186,
    lng: -95.49064,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30347,
    density: 1714.8,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77087,
    lat: 29.68631,
    lng: -95.3034,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37703,
    density: 2220.5,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77088,
    lat: 29.88148,
    lng: -95.45316,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57177,
    density: 1989,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77089,
    lat: 29.58698,
    lng: -95.2257,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55410,
    density: 1641.4,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77090,
    lat: 30.00845,
    lng: -95.44317,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39289,
    density: 1772.2,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77091,
    lat: 29.85382,
    lng: -95.43969,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28351,
    density: 1537.2,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77092,
    lat: 29.83153,
    lng: -95.47521,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39841,
    density: 1899.2,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77093,
    lat: 29.8623,
    lng: -95.34097,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46985,
    density: 1510.5,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77094,
    lat: 29.7738,
    lng: -95.69955,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11022,
    density: 1240.9,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77095,
    lat: 29.90834,
    lng: -95.65492,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 73956,
    density: 1937,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77096,
    lat: 29.67464,
    lng: -95.47965,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33299,
    density: 2134.8,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77098,
    lat: 29.73482,
    lng: -95.41526,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15487,
    density: 3392.2,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77099,
    lat: 29.67067,
    lng: -95.58485,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50326,
    density: 3170.2,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48157: 4.93,
      48201: 95.07,
    },
    county_names_all: "Harris|Fort Bend",
    county_fips_all: "48201|48157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77204,
    lat: 29.72168,
    lng: -95.34356,
    city: "Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77301,
    lat: 30.30897,
    lng: -95.43281,
    city: "Conroe",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34512,
    density: 660.6,
    county_fips: 48339,
    county_name: "Montgomery",
    county_weights: {
      48339: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 48339,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77302,
    lat: 30.22626,
    lng: -95.36014,
    city: "Conroe",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18845,
    density: 137.5,
    county_fips: 48339,
    county_name: "Montgomery",
    county_weights: {
      48339: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 48339,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77303,
    lat: 30.37569,
    lng: -95.37937,
    city: "Conroe",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22040,
    density: 139.7,
    county_fips: 48339,
    county_name: "Montgomery",
    county_weights: {
      48339: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 48339,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77304,
    lat: 30.33097,
    lng: -95.51538,
    city: "Conroe",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35893,
    density: 346.1,
    county_fips: 48339,
    county_name: "Montgomery",
    county_weights: {
      48339: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 48339,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77306,
    lat: 30.2799,
    lng: -95.31337,
    city: "Conroe",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16203,
    density: 152.3,
    county_fips: 48339,
    county_name: "Montgomery",
    county_weights: {
      48339: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 48339,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77316,
    lat: 30.30974,
    lng: -95.68528,
    city: "Montgomery",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27475,
    density: 82.2,
    county_fips: 48339,
    county_name: "Montgomery",
    county_weights: {
      48185: 3.84,
      48339: 96.16,
    },
    county_names_all: "Montgomery|Grimes",
    county_fips_all: "48339|48185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77318,
    lat: 30.44709,
    lng: -95.54364,
    city: "Willis",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18553,
    density: 193.4,
    county_fips: 48339,
    county_name: "Montgomery",
    county_weights: {
      48339: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 48339,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77320,
    lat: 30.80672,
    lng: -95.55687,
    city: "Huntsville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36091,
    density: 40.6,
    county_fips: 48471,
    county_name: "Walker",
    county_weights: {
      48407: 8.6,
      48471: 91.4,
    },
    county_names_all: "Walker|San Jacinto",
    county_fips_all: "48471|48407",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77326,
    lat: 30.50445,
    lng: -94.81661,
    city: "Ace",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59,
    density: 8.8,
    county_fips: 48373,
    county_name: "Polk",
    county_weights: {
      48373: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 48373,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77327,
    lat: 30.3262,
    lng: -94.91826,
    city: "Cleveland",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26206,
    density: 29.8,
    county_fips: 48291,
    county_name: "Liberty",
    county_weights: {
      48291: 100,
    },
    county_names_all: "Liberty",
    county_fips_all: 48291,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77328,
    lat: 30.40767,
    lng: -95.18888,
    city: "Cleveland",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16832,
    density: 36,
    county_fips: 48407,
    county_name: "San Jacinto",
    county_weights: {
      48291: 8.36,
      48339: 21.59,
      48407: 70.05,
    },
    county_names_all: "San Jacinto|Montgomery|Liberty",
    county_fips_all: "48407|48339|48291",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77331,
    lat: 30.61928,
    lng: -95.17706,
    city: "Coldspring",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8064,
    density: 18.2,
    county_fips: 48407,
    county_name: "San Jacinto",
    county_weights: {
      48407: 100,
    },
    county_names_all: "San Jacinto",
    county_fips_all: 48407,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77334,
    lat: 30.77996,
    lng: -95.36465,
    city: "Dodge",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 352,
    density: 9.5,
    county_fips: 48471,
    county_name: "Walker",
    county_weights: {
      48471: 100,
    },
    county_names_all: "Walker",
    county_fips_all: 48471,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77335,
    lat: 30.58901,
    lng: -94.92353,
    city: "Goodrich",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3468,
    density: 35.1,
    county_fips: 48373,
    county_name: "Polk",
    county_weights: {
      48373: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 48373,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77336,
    lat: 30.06842,
    lng: -95.10306,
    city: "Huffman",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12398,
    density: 134.2,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77338,
    lat: 30.00858,
    lng: -95.28351,
    city: "Humble",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45092,
    density: 668.6,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77339,
    lat: 30.04788,
    lng: -95.22139,
    city: "Kingwood",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42193,
    density: 1014.4,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 77.11,
      48339: 22.89,
    },
    county_names_all: "Harris|Montgomery",
    county_fips_all: "48201|48339",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77340,
    lat: 30.64601,
    lng: -95.53441,
    city: "Huntsville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31404,
    density: 56.9,
    county_fips: 48471,
    county_name: "Walker",
    county_weights: {
      48471: 100,
    },
    county_names_all: "Walker",
    county_fips_all: 48471,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77341,
    lat: 30.69818,
    lng: -95.55886,
    city: "Huntsville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48471,
    county_name: "Walker",
    county_weights: {
      48471: 100,
    },
    county_names_all: "Walker",
    county_fips_all: 48471,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77342,
    lat: 30.73877,
    lng: -95.55911,
    city: "Huntsville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 48471,
    county_name: "Walker",
    county_weights: {
      48471: 100,
    },
    county_names_all: "Walker",
    county_fips_all: 48471,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77345,
    lat: 30.05392,
    lng: -95.15884,
    city: "Kingwood",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28593,
    density: 1316.9,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77346,
    lat: 29.99027,
    lng: -95.17777,
    city: "Humble",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63772,
    density: 1373.6,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77350,
    lat: 30.81432,
    lng: -94.90086,
    city: "Leggett",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48373,
    county_name: "Polk",
    county_weights: {
      48373: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 48373,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77351,
    lat: 30.70411,
    lng: -94.81682,
    city: "Livingston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34367,
    density: 20.8,
    county_fips: 48373,
    county_name: "Polk",
    county_weights: {
      48373: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 48373,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77354,
    lat: 30.21113,
    lng: -95.65003,
    city: "Magnolia",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39843,
    density: 207.2,
    county_fips: 48339,
    county_name: "Montgomery",
    county_weights: {
      48339: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 48339,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77355,
    lat: 30.1579,
    lng: -95.75014,
    city: "Magnolia",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31201,
    density: 216.8,
    county_fips: 48339,
    county_name: "Montgomery",
    county_weights: {
      48339: 90.13,
      48473: 9.87,
    },
    county_names_all: "Montgomery|Waller",
    county_fips_all: "48339|48473",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77356,
    lat: 30.44807,
    lng: -95.70358,
    city: "Montgomery",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28144,
    density: 85.5,
    county_fips: 48339,
    county_name: "Montgomery",
    county_weights: {
      48185: 2.06,
      48339: 97.94,
    },
    county_names_all: "Montgomery|Grimes",
    county_fips_all: "48339|48185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77357,
    lat: 30.15694,
    lng: -95.18173,
    city: "New Caney",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29890,
    density: 172,
    county_fips: 48339,
    county_name: "Montgomery",
    county_weights: {
      48201: 10.54,
      48291: 7.62,
      48339: 81.84,
    },
    county_names_all: "Montgomery|Harris|Liberty",
    county_fips_all: "48339|48201|48291",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77358,
    lat: 30.55061,
    lng: -95.45419,
    city: "New Waverly",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5345,
    density: 18.6,
    county_fips: 48471,
    county_name: "Walker",
    county_weights: {
      48339: 6.29,
      48407: 20.95,
      48471: 72.76,
    },
    county_names_all: "Walker|San Jacinto|Montgomery",
    county_fips_all: "48471|48407|48339",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77359,
    lat: 30.76262,
    lng: -95.30441,
    city: "Oakhurst",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 292,
    density: 2.7,
    county_fips: 48407,
    county_name: "San Jacinto",
    county_weights: {
      48407: 100,
    },
    county_names_all: "San Jacinto",
    county_fips_all: 48407,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77360,
    lat: 30.8471,
    lng: -95.11394,
    city: "Onalaska",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5415,
    density: 63.4,
    county_fips: 48373,
    county_name: "Polk",
    county_weights: {
      48373: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 48373,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77362,
    lat: 30.16003,
    lng: -95.67237,
    city: "Pinehurst",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4992,
    density: 180.2,
    county_fips: 48339,
    county_name: "Montgomery",
    county_weights: {
      48201: 0.11,
      48339: 99.89,
    },
    county_names_all: "Montgomery|Harris",
    county_fips_all: "48339|48201",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77363,
    lat: 30.3267,
    lng: -95.85732,
    city: "Plantersville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2961,
    density: 19.5,
    county_fips: 48185,
    county_name: "Grimes",
    county_weights: {
      48185: 98.13,
      48473: 1.87,
    },
    county_names_all: "Grimes|Waller",
    county_fips_all: "48185|48473",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77364,
    lat: 30.76592,
    lng: -95.22168,
    city: "Pointblank",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2130,
    density: 26.7,
    county_fips: 48407,
    county_name: "San Jacinto",
    county_weights: {
      48407: 100,
    },
    county_names_all: "San Jacinto",
    county_fips_all: 48407,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77365,
    lat: 30.11638,
    lng: -95.2747,
    city: "Porter",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34286,
    density: 320,
    county_fips: 48339,
    county_name: "Montgomery",
    county_weights: {
      48201: 3.78,
      48339: 96.22,
    },
    county_names_all: "Montgomery|Harris",
    county_fips_all: "48339|48201",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77367,
    lat: 30.8504,
    lng: -95.39147,
    city: "Riverside",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42,
    density: 19,
    county_fips: 48471,
    county_name: "Walker",
    county_weights: {
      48471: 100,
    },
    county_names_all: "Walker",
    county_fips_all: 48471,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77368,
    lat: 30.45114,
    lng: -94.8407,
    city: "Romayor",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 102,
    density: 341.4,
    county_fips: 48291,
    county_name: "Liberty",
    county_weights: {
      48291: 100,
    },
    county_names_all: "Liberty",
    county_fips_all: 48291,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77369,
    lat: 30.44296,
    lng: -94.75084,
    city: "Rye",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 612,
    density: 9.6,
    county_fips: 48291,
    county_name: "Liberty",
    county_weights: {
      48199: 2.63,
      48291: 97.37,
    },
    county_names_all: "Liberty|Hardin",
    county_fips_all: "48291|48199",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77371,
    lat: 30.49376,
    lng: -94.98146,
    city: "Shepherd",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7326,
    density: 24,
    county_fips: 48407,
    county_name: "San Jacinto",
    county_weights: {
      48407: 100,
    },
    county_names_all: "San Jacinto",
    county_fips_all: 48407,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77372,
    lat: 30.24472,
    lng: -95.18281,
    city: "Splendora",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15484,
    density: 116,
    county_fips: 48339,
    county_name: "Montgomery",
    county_weights: {
      48291: 12.49,
      48339: 87.51,
    },
    county_names_all: "Montgomery|Liberty",
    county_fips_all: "48339|48291",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77373,
    lat: 30.06143,
    lng: -95.38423,
    city: "Spring",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62350,
    density: 1013.2,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77374,
    lat: 30.38226,
    lng: -94.63069,
    city: "Thicket",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 507,
    density: 5,
    county_fips: 48199,
    county_name: "Hardin",
    county_weights: {
      48199: 100,
    },
    county_names_all: "Hardin",
    county_fips_all: 48199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77375,
    lat: 30.09393,
    lng: -95.59095,
    city: "Tomball",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60115,
    density: 658.8,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77376,
    lat: 30.44422,
    lng: -94.6779,
    city: "Votaw",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 508,
    density: 6.9,
    county_fips: 48199,
    county_name: "Hardin",
    county_weights: {
      48199: 100,
    },
    county_names_all: "Hardin",
    county_fips_all: 48199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77377,
    lat: 30.06141,
    lng: -95.67608,
    city: "Tomball",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38233,
    density: 418.9,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77378,
    lat: 30.45873,
    lng: -95.37454,
    city: "Willis",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16134,
    density: 69.9,
    county_fips: 48339,
    county_name: "Montgomery",
    county_weights: {
      48339: 60.6,
      48407: 39.4,
    },
    county_names_all: "Montgomery|San Jacinto",
    county_fips_all: "48339|48407",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77379,
    lat: 30.03966,
    lng: -95.53305,
    city: "Spring",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 82493,
    density: 1233.5,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77380,
    lat: 30.1365,
    lng: -95.46863,
    city: "Spring",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28014,
    density: 870.2,
    county_fips: 48339,
    county_name: "Montgomery",
    county_weights: {
      48339: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 48339,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77381,
    lat: 30.17791,
    lng: -95.50266,
    city: "Spring",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35487,
    density: 1081.1,
    county_fips: 48339,
    county_name: "Montgomery",
    county_weights: {
      48339: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 48339,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77382,
    lat: 30.19961,
    lng: -95.5455,
    city: "Spring",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40026,
    density: 1287.5,
    county_fips: 48339,
    county_name: "Montgomery",
    county_weights: {
      48339: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 48339,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77384,
    lat: 30.23453,
    lng: -95.49675,
    city: "Conroe",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19171,
    density: 401.3,
    county_fips: 48339,
    county_name: "Montgomery",
    county_weights: {
      48339: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 48339,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77385,
    lat: 30.1894,
    lng: -95.42264,
    city: "Conroe",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24619,
    density: 438,
    county_fips: 48339,
    county_name: "Montgomery",
    county_weights: {
      48339: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 48339,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77386,
    lat: 30.10153,
    lng: -95.3561,
    city: "Spring",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60252,
    density: 570.8,
    county_fips: 48339,
    county_name: "Montgomery",
    county_weights: {
      48339: 100,
    },
    county_names_all: "Montgomery",
    county_fips_all: 48339,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77388,
    lat: 30.05957,
    lng: -95.46764,
    city: "Spring",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50972,
    density: 1470.1,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77389,
    lat: 30.11509,
    lng: -95.50752,
    city: "Spring",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39907,
    density: 724.5,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77396,
    lat: 29.94778,
    lng: -95.26129,
    city: "Humble",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62309,
    density: 967,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77401,
    lat: 29.70398,
    lng: -95.46192,
    city: "Bellaire",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19428,
    density: 2060.1,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77406,
    lat: 29.64571,
    lng: -95.79184,
    city: "Richmond",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57622,
    density: 386.3,
    county_fips: 48157,
    county_name: "Fort Bend",
    county_weights: {
      48157: 100,
    },
    county_names_all: "Fort Bend",
    county_fips_all: 48157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77407,
    lat: 29.67658,
    lng: -95.71455,
    city: "Richmond",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61382,
    density: 1185.4,
    county_fips: 48157,
    county_name: "Fort Bend",
    county_weights: {
      48157: 100,
    },
    county_names_all: "Fort Bend",
    county_fips_all: 48157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77412,
    lat: 29.56693,
    lng: -96.46031,
    city: "Altair",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 48089,
    county_name: "Colorado",
    county_weights: {
      48089: 100,
    },
    county_names_all: "Colorado",
    county_fips_all: 48089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77414,
    lat: 28.90601,
    lng: -95.8935,
    city: "Bay City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24254,
    density: 16.9,
    county_fips: 48321,
    county_name: "Matagorda",
    county_weights: {
      48321: 100,
    },
    county_names_all: "Matagorda",
    county_fips_all: 48321,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77415,
    lat: 28.93425,
    lng: -95.72035,
    city: "Cedar Lane",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 48321,
    county_name: "Matagorda",
    county_weights: {
      48321: 100,
    },
    county_names_all: "Matagorda",
    county_fips_all: 48321,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77417,
    lat: 29.46633,
    lng: -95.9621,
    city: "Beasley",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3683,
    density: 26.1,
    county_fips: 48157,
    county_name: "Fort Bend",
    county_weights: {
      48157: 100,
    },
    county_names_all: "Fort Bend",
    county_fips_all: 48157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77418,
    lat: 29.97922,
    lng: -96.25063,
    city: "Bellville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10250,
    density: 21.3,
    county_fips: 48015,
    county_name: "Austin",
    county_weights: {
      48015: 100,
    },
    county_names_all: "Austin",
    county_fips_all: 48015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77419,
    lat: 28.8692,
    lng: -96.25603,
    city: "Blessing",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1148,
    density: 8.4,
    county_fips: 48321,
    county_name: "Matagorda",
    county_weights: {
      48321: 100,
    },
    county_names_all: "Matagorda",
    county_fips_all: 48321,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77420,
    lat: 29.23404,
    lng: -95.91908,
    city: "Boling",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2331,
    density: 10.2,
    county_fips: 48481,
    county_name: "Wharton",
    county_weights: {
      48157: 11.79,
      48321: 26.09,
      48481: 62.12,
    },
    county_names_all: "Wharton|Matagorda|Fort Bend",
    county_fips_all: "48481|48321|48157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77422,
    lat: 28.96492,
    lng: -95.57268,
    city: "Brazoria",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13965,
    density: 31.5,
    county_fips: 48039,
    county_name: "Brazoria",
    county_weights: {
      48039: 100,
    },
    county_names_all: "Brazoria",
    county_fips_all: 48039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77423,
    lat: 29.83386,
    lng: -95.98219,
    city: "Brookshire",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13210,
    density: 34.3,
    county_fips: 48473,
    county_name: "Waller",
    county_weights: {
      48157: 8.07,
      48473: 91.93,
    },
    county_names_all: "Waller|Fort Bend",
    county_fips_all: "48473|48157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77426,
    lat: 30.11633,
    lng: -96.24721,
    city: "Chappell Hill",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2415,
    density: 10.3,
    county_fips: 48477,
    county_name: "Washington",
    county_weights: {
      48015: 21.26,
      48477: 78.74,
    },
    county_names_all: "Washington|Austin",
    county_fips_all: "48477|48015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77428,
    lat: 28.67447,
    lng: -96.15682,
    city: "Collegeport",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 48321,
    county_name: "Matagorda",
    county_weights: {
      48321: 100,
    },
    county_names_all: "Matagorda",
    county_fips_all: 48321,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77429,
    lat: 29.99068,
    lng: -95.65808,
    city: "Cypress",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 90506,
    density: 924.7,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77430,
    lat: 29.26487,
    lng: -95.65616,
    city: "Damon",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1867,
    density: 6.2,
    county_fips: 48039,
    county_name: "Brazoria",
    county_weights: {
      48039: 79.58,
      48157: 20.42,
    },
    county_names_all: "Brazoria|Fort Bend",
    county_fips_all: "48039|48157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77431,
    lat: 29.13239,
    lng: -95.82309,
    city: "Danciger",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48039,
    county_name: "Brazoria",
    county_weights: {
      48039: 100,
    },
    county_names_all: "Brazoria",
    county_fips_all: 48039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77432,
    lat: 29.05808,
    lng: -96.21608,
    city: "Danevang",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39,
    density: 1.1,
    county_fips: 48481,
    county_name: "Wharton",
    county_weights: {
      48481: 100,
    },
    county_names_all: "Wharton",
    county_fips_all: 48481,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77433,
    lat: 29.9492,
    lng: -95.73979,
    city: "Cypress",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 94345,
    density: 617.8,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77434,
    lat: 29.52577,
    lng: -96.31983,
    city: "Eagle Lake",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4562,
    density: 12.1,
    county_fips: 48089,
    county_name: "Colorado",
    county_weights: {
      48089: 66.22,
      48481: 33.78,
    },
    county_names_all: "Colorado|Wharton",
    county_fips_all: "48089|48481",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77435,
    lat: 29.51111,
    lng: -96.12395,
    city: "East Bernard",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3857,
    density: 8.4,
    county_fips: 48481,
    county_name: "Wharton",
    county_weights: {
      48089: 3.04,
      48157: 7.29,
      48481: 89.67,
    },
    county_names_all: "Wharton|Fort Bend|Colorado",
    county_fips_all: "48481|48157|48089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77436,
    lat: 29.38874,
    lng: -96.23832,
    city: "Egypt",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 66,
    density: 1.1,
    county_fips: 48481,
    county_name: "Wharton",
    county_weights: {
      48481: 100,
    },
    county_names_all: "Wharton",
    county_fips_all: 48481,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77437,
    lat: 29.20452,
    lng: -96.27328,
    city: "El Campo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17177,
    density: 18.8,
    county_fips: 48481,
    county_name: "Wharton",
    county_weights: {
      48481: 100,
    },
    county_names_all: "Wharton",
    county_fips_all: 48481,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77440,
    lat: 28.88819,
    lng: -96.14603,
    city: "Elmaton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28,
    density: 2.8,
    county_fips: 48321,
    county_name: "Matagorda",
    county_weights: {
      48321: 100,
    },
    county_names_all: "Matagorda",
    county_fips_all: 48321,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77441,
    lat: 29.6955,
    lng: -95.90896,
    city: "Fulshear",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11248,
    density: 169.8,
    county_fips: 48157,
    county_name: "Fort Bend",
    county_weights: {
      48157: 100,
    },
    county_names_all: "Fort Bend",
    county_fips_all: 48157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77442,
    lat: 29.43708,
    lng: -96.49757,
    city: "Garwood",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1286,
    density: 2.6,
    county_fips: 48089,
    county_name: "Colorado",
    county_weights: {
      48089: 100,
    },
    county_names_all: "Colorado",
    county_fips_all: 48089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77443,
    lat: 29.35835,
    lng: -96.18255,
    city: "Glen Flora",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 390,
    density: 68.7,
    county_fips: 48481,
    county_name: "Wharton",
    county_weights: {
      48481: 100,
    },
    county_names_all: "Wharton",
    county_fips_all: 48481,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77444,
    lat: 29.29641,
    lng: -95.77794,
    city: "Guy",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 582,
    density: 5.7,
    county_fips: 48157,
    county_name: "Fort Bend",
    county_weights: {
      48039: 49.76,
      48157: 50.24,
    },
    county_names_all: "Fort Bend|Brazoria",
    county_fips_all: "48157|48039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77445,
    lat: 30.09562,
    lng: -96.06247,
    city: "Hempstead",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14629,
    density: 30.4,
    county_fips: 48473,
    county_name: "Waller",
    county_weights: {
      48473: 100,
    },
    county_names_all: "Waller",
    county_fips_all: 48473,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77446,
    lat: 30.0871,
    lng: -95.9895,
    city: "Prairie View",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6781,
    density: 986.7,
    county_fips: 48473,
    county_name: "Waller",
    county_weights: {
      48473: 100,
    },
    county_names_all: "Waller",
    county_fips_all: 48473,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77447,
    lat: 30.05178,
    lng: -95.82868,
    city: "Hockley",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16309,
    density: 60.9,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 66.99,
      48339: 4.84,
      48473: 28.17,
    },
    county_names_all: "Harris|Waller|Montgomery",
    county_fips_all: "48201|48473|48339",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77448,
    lat: 29.4147,
    lng: -96.08746,
    city: "Hungerford",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 129,
    density: 7.4,
    county_fips: 48481,
    county_name: "Wharton",
    county_weights: {
      48481: 100,
    },
    county_names_all: "Wharton",
    county_fips_all: 48481,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77449,
    lat: 29.83674,
    lng: -95.73547,
    city: "Katy",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 123157,
    density: 1758.6,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77450,
    lat: 29.74753,
    lng: -95.73696,
    city: "Katy",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75752,
    density: 1486.4,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48157: 35.45,
      48201: 64.55,
    },
    county_names_all: "Harris|Fort Bend",
    county_fips_all: "48201|48157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77451,
    lat: 29.46173,
    lng: -96.02688,
    city: "Kendleton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36,
    density: 2,
    county_fips: 48157,
    county_name: "Fort Bend",
    county_weights: {
      48157: 99.9,
      48481: 0.1,
    },
    county_names_all: "Fort Bend|Wharton",
    county_fips_all: "48157|48481",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77453,
    lat: 29.23303,
    lng: -96.01802,
    city: "Lane City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 469,
    density: 51.6,
    county_fips: 48481,
    county_name: "Wharton",
    county_weights: {
      48481: 100,
    },
    county_names_all: "Wharton",
    county_fips_all: 48481,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77454,
    lat: 29.54304,
    lng: -96.23044,
    city: "Lissie",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 48481,
    county_name: "Wharton",
    county_weights: {
      48481: 100,
    },
    county_names_all: "Wharton",
    county_fips_all: 48481,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77455,
    lat: 29.14017,
    lng: -96.43782,
    city: "Louise",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2121,
    density: 3.9,
    county_fips: 48481,
    county_name: "Wharton",
    county_weights: {
      48089: 5.49,
      48239: 5.42,
      48481: 89.09,
    },
    county_names_all: "Wharton|Colorado|Jackson",
    county_fips_all: "48481|48089|48239",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77456,
    lat: 28.9511,
    lng: -96.1136,
    city: "Markham",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1116,
    density: 10.9,
    county_fips: 48321,
    county_name: "Matagorda",
    county_weights: {
      48321: 100,
    },
    county_names_all: "Matagorda",
    county_fips_all: 48321,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77457,
    lat: 28.70119,
    lng: -95.94076,
    city: "Matagorda",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 560,
    density: 9.2,
    county_fips: 48321,
    county_name: "Matagorda",
    county_weights: {
      48321: 100,
    },
    county_names_all: "Matagorda",
    county_fips_all: 48321,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77458,
    lat: 28.95409,
    lng: -96.25489,
    city: "Midfield",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 269,
    density: 4.7,
    county_fips: 48321,
    county_name: "Matagorda",
    county_weights: {
      48321: 100,
    },
    county_names_all: "Matagorda",
    county_fips_all: 48321,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77459,
    lat: 29.52691,
    lng: -95.53407,
    city: "Missouri City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 76662,
    density: 946.8,
    county_fips: 48157,
    county_name: "Fort Bend",
    county_weights: {
      48157: 100,
    },
    county_names_all: "Fort Bend",
    county_fips_all: 48157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77460,
    lat: 29.39744,
    lng: -96.38451,
    city: "Nada",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43,
    density: 23.9,
    county_fips: 48089,
    county_name: "Colorado",
    county_weights: {
      48089: 100,
    },
    county_names_all: "Colorado",
    county_fips_all: 48089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77461,
    lat: 29.39159,
    lng: -95.77345,
    city: "Needville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12133,
    density: 31.1,
    county_fips: 48157,
    county_name: "Fort Bend",
    county_weights: {
      48157: 100,
    },
    county_names_all: "Fort Bend",
    county_fips_all: 48157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77464,
    lat: 29.61807,
    lng: -95.94148,
    city: "Orchard",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 70,
    density: 1.8,
    county_fips: 48157,
    county_name: "Fort Bend",
    county_weights: {
      48157: 100,
    },
    county_names_all: "Fort Bend",
    county_fips_all: 48157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77465,
    lat: 28.71152,
    lng: -96.22545,
    city: "Palacios",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7331,
    density: 12.2,
    county_fips: 48321,
    county_name: "Matagorda",
    county_weights: {
      48057: 2,
      48239: 15.11,
      48321: 82.89,
    },
    county_names_all: "Matagorda|Jackson|Calhoun",
    county_fips_all: "48321|48239|48057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77466,
    lat: 29.80003,
    lng: -96.01085,
    city: "Pattison",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 539,
    density: 22.8,
    county_fips: 48473,
    county_name: "Waller",
    county_weights: {
      48473: 100,
    },
    county_names_all: "Waller",
    county_fips_all: 48473,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77467,
    lat: 29.23345,
    lng: -96.18563,
    city: "Pierce",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16,
    density: 3.2,
    county_fips: 48481,
    county_name: "Wharton",
    county_weights: {
      48481: 100,
    },
    county_names_all: "Wharton",
    county_fips_all: 48481,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77468,
    lat: 29.14681,
    lng: -95.85173,
    city: "Pledger",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48321,
    county_name: "Matagorda",
    county_weights: {
      48039: 0.58,
      48321: 99.42,
    },
    county_names_all: "Matagorda|Brazoria",
    county_fips_all: "48321|48039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77469,
    lat: 29.49229,
    lng: -95.70571,
    city: "Richmond",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57011,
    density: 206.2,
    county_fips: 48157,
    county_name: "Fort Bend",
    county_weights: {
      48157: 100,
    },
    county_names_all: "Fort Bend",
    county_fips_all: 48157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77470,
    lat: 29.52775,
    lng: -96.55305,
    city: "Rock Island",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 456,
    density: 6.2,
    county_fips: 48089,
    county_name: "Colorado",
    county_weights: {
      48089: 100,
    },
    county_names_all: "Colorado",
    county_fips_all: 48089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77471,
    lat: 29.55159,
    lng: -95.86785,
    city: "Rosenberg",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38430,
    density: 151,
    county_fips: 48157,
    county_name: "Fort Bend",
    county_weights: {
      48157: 100,
    },
    county_names_all: "Fort Bend",
    county_fips_all: 48157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77473,
    lat: 29.79459,
    lng: -96.1038,
    city: "San Felipe",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38,
    density: 146.1,
    county_fips: 48015,
    county_name: "Austin",
    county_weights: {
      48015: 100,
    },
    county_names_all: "Austin",
    county_fips_all: 48015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77474,
    lat: 29.77583,
    lng: -96.18518,
    city: "Sealy",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13347,
    density: 24.9,
    county_fips: 48015,
    county_name: "Austin",
    county_weights: {
      48015: 98.11,
      48089: 1.89,
    },
    county_names_all: "Austin|Colorado",
    county_fips_all: "48015|48089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77475,
    lat: 29.50419,
    lng: -96.66026,
    city: "Sheridan",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 868,
    density: 11.3,
    county_fips: 48089,
    county_name: "Colorado",
    county_weights: {
      48089: 100,
    },
    county_names_all: "Colorado",
    county_fips_all: 48089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77476,
    lat: 29.67551,
    lng: -95.97105,
    city: "Simonton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 402,
    density: 15,
    county_fips: 48157,
    county_name: "Fort Bend",
    county_weights: {
      48157: 100,
    },
    county_names_all: "Fort Bend",
    county_fips_all: 48157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77477,
    lat: 29.62625,
    lng: -95.56718,
    city: "Stafford",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35496,
    density: 1342.9,
    county_fips: 48157,
    county_name: "Fort Bend",
    county_weights: {
      48157: 94.77,
      48201: 5.23,
    },
    county_names_all: "Fort Bend|Harris",
    county_fips_all: "48157|48201",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77478,
    lat: 29.61896,
    lng: -95.6077,
    city: "Sugar Land",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24673,
    density: 950.7,
    county_fips: 48157,
    county_name: "Fort Bend",
    county_weights: {
      48157: 100,
    },
    county_names_all: "Fort Bend",
    county_fips_all: 48157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77479,
    lat: 29.56503,
    lng: -95.6346,
    city: "Sugar Land",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 95615,
    density: 1129.9,
    county_fips: 48157,
    county_name: "Fort Bend",
    county_weights: {
      48157: 100,
    },
    county_names_all: "Fort Bend",
    county_fips_all: 48157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77480,
    lat: 29.09388,
    lng: -95.76692,
    city: "Sweeny",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8344,
    density: 25.8,
    county_fips: 48039,
    county_name: "Brazoria",
    county_weights: {
      48039: 81.91,
      48321: 18.09,
    },
    county_names_all: "Brazoria|Matagorda",
    county_fips_all: "48039|48321",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77481,
    lat: 29.47053,
    lng: -95.56975,
    city: "Thompsons",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 66,
    density: 2.2,
    county_fips: 48157,
    county_name: "Fort Bend",
    county_weights: {
      48157: 100,
    },
    county_names_all: "Fort Bend",
    county_fips_all: 48157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77482,
    lat: 29.09351,
    lng: -95.88411,
    city: "Van Vleck",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1676,
    density: 14.7,
    county_fips: 48321,
    county_name: "Matagorda",
    county_weights: {
      48321: 100,
    },
    county_names_all: "Matagorda",
    county_fips_all: 48321,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77483,
    lat: 28.77467,
    lng: -95.86638,
    city: "Wadsworth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 360,
    density: 4.1,
    county_fips: 48321,
    county_name: "Matagorda",
    county_weights: {
      48321: 100,
    },
    county_names_all: "Matagorda",
    county_fips_all: 48321,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77484,
    lat: 30.07924,
    lng: -95.92812,
    city: "Waller",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11972,
    density: 30.6,
    county_fips: 48473,
    county_name: "Waller",
    county_weights: {
      48185: 1.1,
      48201: 20.93,
      48473: 77.97,
    },
    county_names_all: "Waller|Harris|Grimes",
    county_fips_all: "48473|48201|48185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77485,
    lat: 29.64118,
    lng: -96.06236,
    city: "Wallis",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4209,
    density: 21.1,
    county_fips: 48015,
    county_name: "Austin",
    county_weights: {
      48015: 59.12,
      48157: 40.88,
    },
    county_names_all: "Austin|Fort Bend",
    county_fips_all: "48015|48157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77486,
    lat: 29.15495,
    lng: -95.6805,
    city: "West Columbia",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7509,
    density: 60.1,
    county_fips: 48039,
    county_name: "Brazoria",
    county_weights: {
      48039: 100,
    },
    county_names_all: "Brazoria",
    county_fips_all: 48039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77488,
    lat: 29.29833,
    lng: -96.09821,
    city: "Wharton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14832,
    density: 25.5,
    county_fips: 48481,
    county_name: "Wharton",
    county_weights: {
      48481: 100,
    },
    county_names_all: "Wharton",
    county_fips_all: 48481,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77489,
    lat: 29.60068,
    lng: -95.51605,
    city: "Missouri City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39444,
    density: 1348,
    county_fips: 48157,
    county_name: "Fort Bend",
    county_weights: {
      48157: 96.33,
      48201: 3.67,
    },
    county_names_all: "Fort Bend|Harris",
    county_fips_all: "48157|48201",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77493,
    lat: 29.85193,
    lng: -95.83025,
    city: "Katy",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40547,
    density: 253.4,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48157: 0.1,
      48201: 68.29,
      48473: 31.61,
    },
    county_names_all: "Harris|Waller|Fort Bend",
    county_fips_all: "48201|48473|48157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77494,
    lat: 29.74566,
    lng: -95.82302,
    city: "Katy",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 126310,
    density: 1287.3,
    county_fips: 48157,
    county_name: "Fort Bend",
    county_weights: {
      48157: 85.06,
      48201: 6.99,
      48473: 7.95,
    },
    county_names_all: "Fort Bend|Waller|Harris",
    county_fips_all: "48157|48473|48201",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77498,
    lat: 29.64224,
    lng: -95.65244,
    city: "Sugar Land",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52950,
    density: 1269.3,
    county_fips: 48157,
    county_name: "Fort Bend",
    county_weights: {
      48157: 100,
    },
    county_names_all: "Fort Bend",
    county_fips_all: 48157,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77502,
    lat: 29.67984,
    lng: -95.19953,
    city: "Pasadena",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38117,
    density: 2692.8,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77503,
    lat: 29.69078,
    lng: -95.15781,
    city: "Pasadena",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24102,
    density: 1467.6,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77504,
    lat: 29.64766,
    lng: -95.19007,
    city: "Pasadena",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25044,
    density: 1730.2,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77505,
    lat: 29.64895,
    lng: -95.14284,
    city: "Pasadena",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22967,
    density: 1057.2,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77506,
    lat: 29.71786,
    lng: -95.19018,
    city: "Pasadena",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37968,
    density: 1295.8,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77507,
    lat: 29.62332,
    lng: -95.06582,
    city: "Pasadena",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 326,
    density: 7.7,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77510,
    lat: 29.34788,
    lng: -95.09089,
    city: "Santa Fe",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15223,
    density: 193.2,
    county_fips: 48167,
    county_name: "Galveston",
    county_weights: {
      48039: 6.46,
      48167: 93.54,
    },
    county_names_all: "Galveston|Brazoria",
    county_fips_all: "48167|48039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77511,
    lat: 29.38638,
    lng: -95.23769,
    city: "Alvin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50140,
    density: 129,
    county_fips: 48039,
    county_name: "Brazoria",
    county_weights: {
      48039: 86.65,
      48167: 13.35,
    },
    county_names_all: "Brazoria|Galveston",
    county_fips_all: "48039|48167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77514,
    lat: 29.69096,
    lng: -94.62598,
    city: "Anahuac",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5461,
    density: 11.6,
    county_fips: 48071,
    county_name: "Chambers",
    county_weights: {
      48071: 100,
    },
    county_names_all: "Chambers",
    county_fips_all: 48071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77515,
    lat: 29.17604,
    lng: -95.44955,
    city: "Angleton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33634,
    density: 63.5,
    county_fips: 48039,
    county_name: "Brazoria",
    county_weights: {
      48039: 100,
    },
    county_names_all: "Brazoria",
    county_fips_all: 48039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77517,
    lat: 29.36253,
    lng: -95.1369,
    city: "Santa Fe",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6515,
    density: 96,
    county_fips: 48167,
    county_name: "Galveston",
    county_weights: {
      48039: 24.82,
      48167: 75.18,
    },
    county_names_all: "Galveston|Brazoria",
    county_fips_all: "48167|48039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77518,
    lat: 29.50544,
    lng: -94.98664,
    city: "Bacliff",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11513,
    density: 1371.6,
    county_fips: 48167,
    county_name: "Galveston",
    county_weights: {
      48167: 100,
    },
    county_names_all: "Galveston",
    county_fips_all: 48167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77519,
    lat: 30.21124,
    lng: -94.58596,
    city: "Batson",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 781,
    density: 10.8,
    county_fips: 48199,
    county_name: "Hardin",
    county_weights: {
      48199: 100,
    },
    county_names_all: "Hardin",
    county_fips_all: 48199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77520,
    lat: 29.74599,
    lng: -95.00388,
    city: "Baytown",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33837,
    density: 621.2,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48071: 3.4,
      48201: 96.6,
    },
    county_names_all: "Harris|Chambers",
    county_fips_all: "48201|48071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77521,
    lat: 29.81298,
    lng: -94.96233,
    city: "Baytown",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60703,
    density: 475.7,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48071: 23.31,
      48201: 76.69,
    },
    county_names_all: "Harris|Chambers",
    county_fips_all: "48201|48071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77523,
    lat: 29.77598,
    lng: -94.8632,
    city: "Baytown",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23431,
    density: 106.2,
    county_fips: 48071,
    county_name: "Chambers",
    county_weights: {
      48071: 95.23,
      48201: 4.77,
    },
    county_names_all: "Chambers|Harris",
    county_fips_all: "48071|48201",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77530,
    lat: 29.78948,
    lng: -95.11159,
    city: "Channelview",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32070,
    density: 896.8,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77531,
    lat: 29.03895,
    lng: -95.40071,
    city: "Clute",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16352,
    density: 537.4,
    county_fips: 48039,
    county_name: "Brazoria",
    county_weights: {
      48039: 100,
    },
    county_names_all: "Brazoria",
    county_fips_all: 48039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77532,
    lat: 29.93177,
    lng: -95.05602,
    city: "Crosby",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30042,
    density: 140.5,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77533,
    lat: 30.09139,
    lng: -94.59488,
    city: "Daisetta",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1045,
    density: 15.9,
    county_fips: 48291,
    county_name: "Liberty",
    county_weights: {
      48291: 100,
    },
    county_names_all: "Liberty",
    county_fips_all: 48291,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77534,
    lat: 29.21335,
    lng: -95.30387,
    city: "Danbury",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2905,
    density: 26.8,
    county_fips: 48039,
    county_name: "Brazoria",
    county_weights: {
      48039: 100,
    },
    county_names_all: "Brazoria",
    county_fips_all: 48039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77535,
    lat: 30.05129,
    lng: -94.91569,
    city: "Dayton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34603,
    density: 43.3,
    county_fips: 48291,
    county_name: "Liberty",
    county_weights: {
      48071: 3.13,
      48201: 0.24,
      48291: 96.63,
    },
    county_names_all: "Liberty|Chambers|Harris",
    county_fips_all: "48291|48071|48201",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77536,
    lat: 29.69021,
    lng: -95.11891,
    city: "Deer Park",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32745,
    density: 1287.2,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77538,
    lat: 29.99217,
    lng: -94.53976,
    city: "Devers",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 808,
    density: 2.4,
    county_fips: 48291,
    county_name: "Liberty",
    county_weights: {
      48291: 100,
    },
    county_names_all: "Liberty",
    county_fips_all: 48291,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77539,
    lat: 29.45578,
    lng: -95.02723,
    city: "Dickinson",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44228,
    density: 352.7,
    county_fips: 48167,
    county_name: "Galveston",
    county_weights: {
      48167: 100,
    },
    county_names_all: "Galveston",
    county_fips_all: 48167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77541,
    lat: 29.01496,
    lng: -95.32667,
    city: "Freeport",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19072,
    density: 52,
    county_fips: 48039,
    county_name: "Brazoria",
    county_weights: {
      48039: 100,
    },
    county_names_all: "Brazoria",
    county_fips_all: 48039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77545,
    lat: 29.53729,
    lng: -95.47242,
    city: "Fresno",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23051,
    density: 606.1,
    county_fips: 48157,
    county_name: "Fort Bend",
    county_weights: {
      48039: 0.74,
      48157: 99.26,
    },
    county_names_all: "Fort Bend|Brazoria",
    county_fips_all: "48157|48039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77546,
    lat: 29.5132,
    lng: -95.19352,
    city: "Friendswood",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53148,
    density: 754.8,
    county_fips: 48167,
    county_name: "Galveston",
    county_weights: {
      48039: 1.92,
      48167: 66.97,
      48201: 31.11,
    },
    county_names_all: "Galveston|Harris|Brazoria",
    county_fips_all: "48167|48201|48039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77547,
    lat: 29.74018,
    lng: -95.23836,
    city: "Galena Park",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9895,
    density: 991.5,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77550,
    lat: 29.31021,
    lng: -94.77706,
    city: "Galveston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21710,
    density: 1108.6,
    county_fips: 48167,
    county_name: "Galveston",
    county_weights: {
      48167: 100,
    },
    county_names_all: "Galveston",
    county_fips_all: 48167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77551,
    lat: 29.27903,
    lng: -94.83502,
    city: "Galveston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22198,
    density: 2167.8,
    county_fips: 48167,
    county_name: "Galveston",
    county_weights: {
      48167: 100,
    },
    county_names_all: "Galveston",
    county_fips_all: 48167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77554,
    lat: 29.23187,
    lng: -94.92544,
    city: "Galveston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8730,
    density: 108.4,
    county_fips: 48167,
    county_name: "Galveston",
    county_weights: {
      48167: 100,
    },
    county_names_all: "Galveston",
    county_fips_all: 48167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77555,
    lat: 29.31082,
    lng: -94.77641,
    city: "Galveston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48167,
    county_name: "Galveston",
    county_weights: {
      48167: 100,
    },
    county_names_all: "Galveston",
    county_fips_all: 48167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77560,
    lat: 29.86399,
    lng: -94.59643,
    city: "Hankamer",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 510,
    density: 7.3,
    county_fips: 48071,
    county_name: "Chambers",
    county_weights: {
      48071: 100,
    },
    county_names_all: "Chambers",
    county_fips_all: 48071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77561,
    lat: 30.13459,
    lng: -94.73551,
    city: "Hardin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48291,
    county_name: "Liberty",
    county_weights: {
      48291: 100,
    },
    county_names_all: "Liberty",
    county_fips_all: 48291,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77562,
    lat: 29.82917,
    lng: -95.05473,
    city: "Highlands",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10064,
    density: 288.4,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77563,
    lat: 29.31123,
    lng: -95.01822,
    city: "Hitchcock",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11129,
    density: 97.3,
    county_fips: 48167,
    county_name: "Galveston",
    county_weights: {
      48167: 100,
    },
    county_names_all: "Galveston",
    county_fips_all: 48167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77564,
    lat: 30.21811,
    lng: -94.65989,
    city: "Hull",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1532,
    density: 9.9,
    county_fips: 48291,
    county_name: "Liberty",
    county_weights: {
      48199: 23.71,
      48291: 76.29,
    },
    county_names_all: "Liberty|Hardin",
    county_fips_all: "48291|48199",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77565,
    lat: 29.53925,
    lng: -95.03229,
    city: "Kemah",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6953,
    density: 755,
    county_fips: 48167,
    county_name: "Galveston",
    county_weights: {
      48167: 100,
    },
    county_names_all: "Galveston",
    county_fips_all: 48167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77566,
    lat: 29.04971,
    lng: -95.47511,
    city: "Lake Jackson",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29362,
    density: 478.9,
    county_fips: 48039,
    county_name: "Brazoria",
    county_weights: {
      48039: 100,
    },
    county_names_all: "Brazoria",
    county_fips_all: 48039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77568,
    lat: 29.36653,
    lng: -94.98773,
    city: "La Marque",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16676,
    density: 439.6,
    county_fips: 48167,
    county_name: "Galveston",
    county_weights: {
      48167: 100,
    },
    county_names_all: "Galveston",
    county_fips_all: 48167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77571,
    lat: 29.69287,
    lng: -95.06012,
    city: "La Porte",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37699,
    density: 392.6,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77573,
    lat: 29.50213,
    lng: -95.08636,
    city: "League City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 91454,
    density: 1185.5,
    county_fips: 48167,
    county_name: "Galveston",
    county_weights: {
      48167: 100,
    },
    county_names_all: "Galveston",
    county_fips_all: 48167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77575,
    lat: 30.07738,
    lng: -94.73666,
    city: "Liberty",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16209,
    density: 26.3,
    county_fips: 48291,
    county_name: "Liberty",
    county_weights: {
      48071: 3.33,
      48291: 96.67,
    },
    county_names_all: "Liberty|Chambers",
    county_fips_all: "48291|48071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77577,
    lat: 29.25966,
    lng: -95.26731,
    city: "Liverpool",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1497,
    density: 20.8,
    county_fips: 48039,
    county_name: "Brazoria",
    county_weights: {
      48039: 100,
    },
    county_names_all: "Brazoria",
    county_fips_all: 48039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77578,
    lat: 29.47794,
    lng: -95.36757,
    city: "Manvel",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22822,
    density: 229.5,
    county_fips: 48039,
    county_name: "Brazoria",
    county_weights: {
      48039: 100,
    },
    county_names_all: "Brazoria",
    county_fips_all: 48039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77580,
    lat: 29.85706,
    lng: -94.88081,
    city: "Mont Belvieu",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 999,
    density: 258.8,
    county_fips: 48071,
    county_name: "Chambers",
    county_weights: {
      48071: 100,
    },
    county_names_all: "Chambers",
    county_fips_all: 48071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77581,
    lat: 29.5624,
    lng: -95.27982,
    city: "Pearland",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50737,
    density: 795.7,
    county_fips: 48039,
    county_name: "Brazoria",
    county_weights: {
      48039: 94.23,
      48201: 5.77,
    },
    county_names_all: "Brazoria|Harris",
    county_fips_all: "48039|48201",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77582,
    lat: 30.01371,
    lng: -94.65497,
    city: "Raywood",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48291,
    county_name: "Liberty",
    county_weights: {
      48291: 100,
    },
    county_names_all: "Liberty",
    county_fips_all: 48291,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77583,
    lat: 29.37763,
    lng: -95.4585,
    city: "Rosharon",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41305,
    density: 91.5,
    county_fips: 48039,
    county_name: "Brazoria",
    county_weights: {
      48039: 91.49,
      48157: 8.51,
    },
    county_names_all: "Brazoria|Fort Bend",
    county_fips_all: "48039|48157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77584,
    lat: 29.54577,
    lng: -95.35013,
    city: "Pearland",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 91993,
    density: 1110.1,
    county_fips: 48039,
    county_name: "Brazoria",
    county_weights: {
      48039: 95.86,
      48157: 4.14,
    },
    county_names_all: "Brazoria|Fort Bend",
    county_fips_all: "48039|48157",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77585,
    lat: 30.29949,
    lng: -94.5294,
    city: "Saratoga",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1226,
    density: 4.6,
    county_fips: 48199,
    county_name: "Hardin",
    county_weights: {
      48199: 100,
    },
    county_names_all: "Hardin",
    county_fips_all: 48199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77586,
    lat: 29.58267,
    lng: -95.03391,
    city: "Seabrook",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23003,
    density: 761.8,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48167: 0.1,
      48201: 99.9,
    },
    county_names_all: "Harris|Galveston",
    county_fips_all: "48201|48167",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77587,
    lat: 29.66117,
    lng: -95.22865,
    city: "South Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17162,
    density: 2158.8,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77590,
    lat: 29.3804,
    lng: -94.91759,
    city: "Texas City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31045,
    density: 476,
    county_fips: 48167,
    county_name: "Galveston",
    county_weights: {
      48167: 100,
    },
    county_names_all: "Galveston",
    county_fips_all: 48167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77591,
    lat: 29.39971,
    lng: -95.00074,
    city: "Texas City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14926,
    density: 558.4,
    county_fips: 48167,
    county_name: "Galveston",
    county_weights: {
      48167: 100,
    },
    county_names_all: "Galveston",
    county_fips_all: 48167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77597,
    lat: 29.82811,
    lng: -94.69521,
    city: "Wallisville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1026,
    density: 24.2,
    county_fips: 48071,
    county_name: "Chambers",
    county_weights: {
      48071: 100,
    },
    county_names_all: "Chambers",
    county_fips_all: 48071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77598,
    lat: 29.53766,
    lng: -95.13714,
    city: "Webster",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26513,
    density: 836.4,
    county_fips: 48201,
    county_name: "Harris",
    county_weights: {
      48201: 100,
    },
    county_names_all: "Harris",
    county_fips_all: 48201,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77611,
    lat: 30.01259,
    lng: -93.8222,
    city: "Bridge City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8608,
    density: 171.5,
    county_fips: 48361,
    county_name: "Orange",
    county_weights: {
      48361: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 48361,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77612,
    lat: 30.39851,
    lng: -93.93276,
    city: "Buna",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9619,
    density: 10.6,
    county_fips: 48241,
    county_name: "Jasper",
    county_weights: {
      48241: 65.28,
      48351: 34.72,
    },
    county_names_all: "Jasper|Newton",
    county_fips_all: "48241|48351",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77613,
    lat: 30.02493,
    lng: -94.35393,
    city: "China",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1045,
    density: 9.3,
    county_fips: 48245,
    county_name: "Jefferson",
    county_weights: {
      48245: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 48245,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77614,
    lat: 30.3055,
    lng: -93.76033,
    city: "Deweyville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 408,
    density: 15.5,
    county_fips: 48351,
    county_name: "Newton",
    county_weights: {
      48351: 100,
    },
    county_names_all: "Newton",
    county_fips_all: 48351,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77615,
    lat: 30.35713,
    lng: -94.06563,
    city: "Evadale",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 923,
    density: 286.3,
    county_fips: 48241,
    county_name: "Jasper",
    county_weights: {
      48241: 100,
    },
    county_names_all: "Jasper",
    county_fips_all: 48241,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77616,
    lat: 30.56804,
    lng: -94.2117,
    city: "Fred",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 157,
    density: 2.3,
    county_fips: 48457,
    county_name: "Tyler",
    county_weights: {
      48457: 100,
    },
    county_names_all: "Tyler",
    county_fips_all: 48457,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77617,
    lat: 29.51128,
    lng: -94.51052,
    city: "Gilchrist",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47,
    density: 3.5,
    county_fips: 48167,
    county_name: "Galveston",
    county_weights: {
      48167: 100,
    },
    county_names_all: "Galveston",
    county_fips_all: 48167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77619,
    lat: 29.94549,
    lng: -93.9165,
    city: "Groves",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15531,
    density: 1102.1,
    county_fips: 48245,
    county_name: "Jefferson",
    county_weights: {
      48245: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 48245,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77622,
    lat: 29.85741,
    lng: -94.29467,
    city: "Hamshire",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1396,
    density: 26.6,
    county_fips: 48245,
    county_name: "Jefferson",
    county_weights: {
      48245: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 48245,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77623,
    lat: 29.55957,
    lng: -94.41621,
    city: "High Island",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 634,
    density: 16.7,
    county_fips: 48167,
    county_name: "Galveston",
    county_weights: {
      48167: 100,
    },
    county_names_all: "Galveston",
    county_fips_all: 48167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77624,
    lat: 30.68674,
    lng: -94.2822,
    city: "Hillister",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 793,
    density: 5.8,
    county_fips: 48457,
    county_name: "Tyler",
    county_weights: {
      48457: 100,
    },
    county_names_all: "Tyler",
    county_fips_all: 48457,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77625,
    lat: 30.37032,
    lng: -94.3923,
    city: "Kountze",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9997,
    density: 12.2,
    county_fips: 48199,
    county_name: "Hardin",
    county_weights: {
      48199: 100,
    },
    county_names_all: "Hardin",
    county_fips_all: 48199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77627,
    lat: 29.99095,
    lng: -94.00772,
    city: "Nederland",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20969,
    density: 615.3,
    county_fips: 48245,
    county_name: "Jefferson",
    county_weights: {
      48245: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 48245,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77629,
    lat: 29.97476,
    lng: -94.42727,
    city: "Nome",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 810,
    density: 4.9,
    county_fips: 48245,
    county_name: "Jefferson",
    county_weights: {
      48245: 72.96,
      48291: 27.04,
    },
    county_names_all: "Jefferson|Liberty",
    county_fips_all: "48245|48291",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77630,
    lat: 30.06534,
    lng: -93.86844,
    city: "Orange",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27279,
    density: 110,
    county_fips: 48361,
    county_name: "Orange",
    county_weights: {
      48361: 100,
    },
    county_names_all: "Orange",
    county_fips_all: 48361,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77632,
    lat: 30.2014,
    lng: -93.80477,
    city: "Orange",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22200,
    density: 65.7,
    county_fips: 48361,
    county_name: "Orange",
    county_weights: {
      48351: 23.61,
      48361: 76.39,
    },
    county_names_all: "Orange|Newton",
    county_fips_all: "48361|48351",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77640,
    lat: 29.88021,
    lng: -93.94152,
    city: "Port Arthur",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16549,
    density: 171.4,
    county_fips: 48245,
    county_name: "Jefferson",
    county_weights: {
      48245: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 48245,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77642,
    lat: 29.93917,
    lng: -93.91606,
    city: "Port Arthur",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37902,
    density: 742,
    county_fips: 48245,
    county_name: "Jefferson",
    county_weights: {
      48245: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 48245,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77650,
    lat: 29.42995,
    lng: -94.68096,
    city: "Port Bolivar",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1930,
    density: 33.9,
    county_fips: 48167,
    county_name: "Galveston",
    county_weights: {
      48167: 100,
    },
    county_names_all: "Galveston",
    county_fips_all: 48167,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77651,
    lat: 29.98036,
    lng: -93.94821,
    city: "Port Neches",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12729,
    density: 447.3,
    county_fips: 48245,
    county_name: "Jefferson",
    county_weights: {
      48245: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 48245,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77655,
    lat: 29.71338,
    lng: -93.95306,
    city: "Sabine Pass",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 264,
    density: 2.2,
    county_fips: 48245,
    county_name: "Jefferson",
    county_weights: {
      48245: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 48245,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77656,
    lat: 30.42866,
    lng: -94.16887,
    city: "Silsbee",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16744,
    density: 36.9,
    county_fips: 48199,
    county_name: "Hardin",
    county_weights: {
      48199: 86.35,
      48457: 13.65,
    },
    county_names_all: "Hardin|Tyler",
    county_fips_all: "48199|48457",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77657,
    lat: 30.22549,
    lng: -94.18862,
    city: "Lumberton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21323,
    density: 142.6,
    county_fips: 48199,
    county_name: "Hardin",
    county_weights: {
      48199: 100,
    },
    county_names_all: "Hardin",
    county_fips_all: 48199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77659,
    lat: 30.15775,
    lng: -94.43279,
    city: "Sour Lake",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5649,
    density: 18.4,
    county_fips: 48199,
    county_name: "Hardin",
    county_weights: {
      48199: 100,
    },
    county_names_all: "Hardin",
    county_fips_all: 48199,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77660,
    lat: 30.63993,
    lng: -94.14105,
    city: "Spurger",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1589,
    density: 10.8,
    county_fips: 48457,
    county_name: "Tyler",
    county_weights: {
      48457: 100,
    },
    county_names_all: "Tyler",
    county_fips_all: 48457,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77661,
    lat: 29.78021,
    lng: -94.36861,
    city: "Stowell",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1292,
    density: 259.4,
    county_fips: 48071,
    county_name: "Chambers",
    county_weights: {
      48071: 100,
    },
    county_names_all: "Chambers",
    county_fips_all: 48071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77662,
    lat: 30.1793,
    lng: -94.01876,
    city: "Vidor",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27587,
    density: 76.2,
    county_fips: 48361,
    county_name: "Orange",
    county_weights: {
      48241: 14.88,
      48361: 85.12,
    },
    county_names_all: "Orange|Jasper",
    county_fips_all: "48361|48241",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77663,
    lat: 30.51033,
    lng: -94.4052,
    city: "Village Mills",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 720,
    density: 15.5,
    county_fips: 48199,
    county_name: "Hardin",
    county_weights: {
      48199: 83.42,
      48457: 16.58,
    },
    county_names_all: "Hardin|Tyler",
    county_fips_all: "48199|48457",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77664,
    lat: 30.58901,
    lng: -94.39529,
    city: "Warren",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2872,
    density: 6,
    county_fips: 48457,
    county_name: "Tyler",
    county_weights: {
      48199: 9.56,
      48457: 90.44,
    },
    county_names_all: "Tyler|Hardin",
    county_fips_all: "48457|48199",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77665,
    lat: 29.78697,
    lng: -94.40969,
    city: "Winnie",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5857,
    density: 13.2,
    county_fips: 48071,
    county_name: "Chambers",
    county_weights: {
      48071: 75.33,
      48245: 24.67,
    },
    county_names_all: "Chambers|Jefferson",
    county_fips_all: "48071|48245",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77701,
    lat: 30.07321,
    lng: -94.10579,
    city: "Beaumont",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14005,
    density: 788.4,
    county_fips: 48245,
    county_name: "Jefferson",
    county_weights: {
      48245: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 48245,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77702,
    lat: 30.08624,
    lng: -94.12825,
    city: "Beaumont",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3334,
    density: 1036.1,
    county_fips: 48245,
    county_name: "Jefferson",
    county_weights: {
      48245: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 48245,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77703,
    lat: 30.11522,
    lng: -94.10906,
    city: "Beaumont",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13134,
    density: 583.3,
    county_fips: 48245,
    county_name: "Jefferson",
    county_weights: {
      48245: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 48245,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77705,
    lat: 29.90652,
    lng: -94.16961,
    city: "Beaumont",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40224,
    density: 64,
    county_fips: 48245,
    county_name: "Jefferson",
    county_weights: {
      48245: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 48245,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77706,
    lat: 30.10049,
    lng: -94.16717,
    city: "Beaumont",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29707,
    density: 1138.1,
    county_fips: 48245,
    county_name: "Jefferson",
    county_weights: {
      48245: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 48245,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77707,
    lat: 30.05323,
    lng: -94.1748,
    city: "Beaumont",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18867,
    density: 513.4,
    county_fips: 48245,
    county_name: "Jefferson",
    county_weights: {
      48245: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 48245,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77708,
    lat: 30.14747,
    lng: -94.15128,
    city: "Beaumont",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11385,
    density: 377.7,
    county_fips: 48245,
    county_name: "Jefferson",
    county_weights: {
      48245: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 48245,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77713,
    lat: 30.06777,
    lng: -94.25716,
    city: "Beaumont",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13867,
    density: 52,
    county_fips: 48245,
    county_name: "Jefferson",
    county_weights: {
      48245: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 48245,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77801,
    lat: 30.63968,
    lng: -96.36451,
    city: "Bryan",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14853,
    density: 1869.4,
    county_fips: 48041,
    county_name: "Brazos",
    county_weights: {
      48041: 100,
    },
    county_names_all: "Brazos",
    county_fips_all: 48041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77802,
    lat: 30.6609,
    lng: -96.32233,
    city: "Bryan",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25257,
    density: 850.4,
    county_fips: 48041,
    county_name: "Brazos",
    county_weights: {
      48041: 100,
    },
    county_names_all: "Brazos",
    county_fips_all: 48041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77803,
    lat: 30.67835,
    lng: -96.3867,
    city: "Bryan",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34026,
    density: 968,
    county_fips: 48041,
    county_name: "Brazos",
    county_weights: {
      48041: 100,
    },
    county_names_all: "Brazos",
    county_fips_all: 48041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77807,
    lat: 30.6783,
    lng: -96.47982,
    city: "Bryan",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11052,
    density: 43.4,
    county_fips: 48041,
    county_name: "Brazos",
    county_weights: {
      48041: 85.19,
      48395: 14.81,
    },
    county_names_all: "Brazos|Robertson",
    county_fips_all: "48041|48395",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77808,
    lat: 30.78965,
    lng: -96.31362,
    city: "Bryan",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12248,
    density: 18.6,
    county_fips: 48041,
    county_name: "Brazos",
    county_weights: {
      48041: 84.27,
      48395: 15.73,
    },
    county_names_all: "Brazos|Robertson",
    county_fips_all: "48041|48395",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77830,
    lat: 30.52648,
    lng: -96.00849,
    city: "Anderson",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3007,
    density: 6,
    county_fips: 48185,
    county_name: "Grimes",
    county_weights: {
      48185: 100,
    },
    county_names_all: "Grimes",
    county_fips_all: 48185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77831,
    lat: 30.73144,
    lng: -95.90933,
    city: "Bedias",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2847,
    density: 4.8,
    county_fips: 48185,
    county_name: "Grimes",
    county_weights: {
      48185: 76.53,
      48313: 1.24,
      48471: 22.23,
    },
    county_names_all: "Grimes|Walker|Madison",
    county_fips_all: "48185|48471|48313",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77833,
    lat: 30.20842,
    lng: -96.40797,
    city: "Brenham",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28507,
    density: 35.1,
    county_fips: 48477,
    county_name: "Washington",
    county_weights: {
      48015: 8.38,
      48477: 91.62,
    },
    county_names_all: "Washington|Austin",
    county_fips_all: "48477|48015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77835,
    lat: 30.19439,
    lng: -96.59257,
    city: "Burton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3121,
    density: 10.9,
    county_fips: 48477,
    county_name: "Washington",
    county_weights: {
      48015: 1.02,
      48477: 98.98,
    },
    county_names_all: "Washington|Austin",
    county_fips_all: "48477|48015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77836,
    lat: 30.53798,
    lng: -96.67813,
    city: "Caldwell",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12516,
    density: 11.2,
    county_fips: 48051,
    county_name: "Burleson",
    county_weights: {
      48051: 97.94,
      48331: 2.06,
    },
    county_names_all: "Burleson|Milam",
    county_fips_all: "48051|48331",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77837,
    lat: 31.00704,
    lng: -96.67718,
    city: "Calvert",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1873,
    density: 6.1,
    county_fips: 48395,
    county_name: "Robertson",
    county_weights: {
      48395: 100,
    },
    county_names_all: "Robertson",
    county_fips_all: 48395,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77840,
    lat: 30.6115,
    lng: -96.32332,
    city: "College Station",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59700,
    density: 2313.1,
    county_fips: 48041,
    county_name: "Brazos",
    county_weights: {
      48041: 100,
    },
    county_names_all: "Brazos",
    county_fips_all: 48041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77843,
    lat: 30.61527,
    lng: -96.34027,
    city: "College Station",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48041,
    county_name: "Brazos",
    county_weights: {
      48041: 100,
    },
    county_names_all: "Brazos",
    county_fips_all: 48041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77845,
    lat: 30.56212,
    lng: -96.27607,
    city: "College Station",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68757,
    density: 186.2,
    county_fips: 48041,
    county_name: "Brazos",
    county_weights: {
      48041: 100,
    },
    county_names_all: "Brazos",
    county_fips_all: 48041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77852,
    lat: 30.42833,
    lng: -96.7573,
    city: "Deanville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48051,
    county_name: "Burleson",
    county_weights: {
      48051: 100,
    },
    county_names_all: "Burleson",
    county_fips_all: 48051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77853,
    lat: 30.3623,
    lng: -96.84035,
    city: "Dime Box",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1189,
    density: 7.9,
    county_fips: 48287,
    county_name: "Lee",
    county_weights: {
      48287: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 48287,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77855,
    lat: 31.14741,
    lng: -96.11217,
    city: "Flynn",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 218,
    density: 6.2,
    county_fips: 48289,
    county_name: "Leon",
    county_weights: {
      48289: 100,
    },
    county_names_all: "Leon",
    county_fips_all: 48289,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77856,
    lat: 31.07714,
    lng: -96.41499,
    city: "Franklin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5492,
    density: 5.7,
    county_fips: 48395,
    county_name: "Robertson",
    county_weights: {
      48395: 100,
    },
    county_names_all: "Robertson",
    county_fips_all: 48395,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77857,
    lat: 30.78246,
    lng: -96.73927,
    city: "Gause",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 767,
    density: 3,
    county_fips: 48331,
    county_name: "Milam",
    county_weights: {
      48331: 100,
    },
    county_names_all: "Milam",
    county_fips_all: 48331,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77859,
    lat: 30.88012,
    lng: -96.51707,
    city: "Hearne",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6340,
    density: 15.6,
    county_fips: 48395,
    county_name: "Robertson",
    county_weights: {
      48041: 16.52,
      48395: 83.48,
    },
    county_names_all: "Robertson|Brazos",
    county_fips_all: "48395|48041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77861,
    lat: 30.72477,
    lng: -96.09908,
    city: "Iola",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2135,
    density: 7.2,
    county_fips: 48185,
    county_name: "Grimes",
    county_weights: {
      48185: 100,
    },
    county_names_all: "Grimes",
    county_fips_all: 48185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77863,
    lat: 30.39306,
    lng: -96.55946,
    city: "Lyons",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48051,
    county_name: "Burleson",
    county_weights: {
      48051: 100,
    },
    county_names_all: "Burleson",
    county_fips_all: 48051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77864,
    lat: 30.96087,
    lng: -95.89297,
    city: "Madisonville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7824,
    density: 16.9,
    county_fips: 48313,
    county_name: "Madison",
    county_weights: {
      48313: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 48313,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77865,
    lat: 31.22275,
    lng: -96.22553,
    city: "Marquez",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2154,
    density: 5.3,
    county_fips: 48289,
    county_name: "Leon",
    county_weights: {
      48289: 100,
    },
    county_names_all: "Leon",
    county_fips_all: 48289,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77866,
    lat: 30.49356,
    lng: -96.21034,
    city: "Millican",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48041,
    county_name: "Brazos",
    county_weights: {
      48041: 100,
    },
    county_names_all: "Brazos",
    county_fips_all: 48041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77867,
    lat: 30.74163,
    lng: -96.56992,
    city: "Mumford",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 315,
    density: 5,
    county_fips: 48395,
    county_name: "Robertson",
    county_weights: {
      48395: 100,
    },
    county_names_all: "Robertson",
    county_fips_all: 48395,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77868,
    lat: 30.36954,
    lng: -96.05815,
    city: "Navasota",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18344,
    density: 25.5,
    county_fips: 48185,
    county_name: "Grimes",
    county_weights: {
      48041: 28.41,
      48185: 70.12,
      48473: 0.69,
      48477: 0.78,
    },
    county_names_all: "Grimes|Brazos|Washington|Waller",
    county_fips_all: "48185|48041|48477|48473",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77871,
    lat: 31.05129,
    lng: -96.10903,
    city: "Normangee",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3009,
    density: 5.7,
    county_fips: 48289,
    county_name: "Leon",
    county_weights: {
      48289: 61.07,
      48313: 38.93,
    },
    county_names_all: "Leon|Madison",
    county_fips_all: "48289|48313",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77872,
    lat: 30.88539,
    lng: -96.0971,
    city: "North Zulch",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2178,
    density: 8.9,
    county_fips: 48313,
    county_name: "Madison",
    county_weights: {
      48185: 4.08,
      48313: 95.92,
    },
    county_names_all: "Madison|Grimes",
    county_fips_all: "48313|48185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77873,
    lat: 30.57489,
    lng: -95.79934,
    city: "Richards",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1272,
    density: 5.4,
    county_fips: 48339,
    county_name: "Montgomery",
    county_weights: {
      48185: 35.37,
      48339: 43.48,
      48471: 21.15,
    },
    county_names_all: "Montgomery|Grimes|Walker",
    county_fips_all: "48339|48185|48471",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77875,
    lat: 30.58119,
    lng: -95.94675,
    city: "Roans Prairie",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48185,
    county_name: "Grimes",
    county_weights: {
      48185: 100,
    },
    county_names_all: "Grimes",
    county_fips_all: 48185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77876,
    lat: 30.60369,
    lng: -95.85656,
    city: "Shiro",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 246,
    density: 19.5,
    county_fips: 48185,
    county_name: "Grimes",
    county_weights: {
      48185: 100,
    },
    county_names_all: "Grimes",
    county_fips_all: 48185,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77878,
    lat: 30.47222,
    lng: -96.45089,
    city: "Snook",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 312,
    density: 5.3,
    county_fips: 48051,
    county_name: "Burleson",
    county_weights: {
      48051: 100,
    },
    county_names_all: "Burleson",
    county_fips_all: 48051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77879,
    lat: 30.40078,
    lng: -96.49378,
    city: "Somerville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5357,
    density: 10.8,
    county_fips: 48051,
    county_name: "Burleson",
    county_weights: {
      48051: 100,
    },
    county_names_all: "Burleson",
    county_fips_all: 48051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77880,
    lat: 30.28283,
    lng: -96.1863,
    city: "Washington",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1800,
    density: 7.2,
    county_fips: 48477,
    county_name: "Washington",
    county_weights: {
      48477: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 48477,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77882,
    lat: 30.91139,
    lng: -96.37909,
    city: "Wheelock",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48395,
    county_name: "Robertson",
    county_weights: {
      48395: 100,
    },
    county_names_all: "Robertson",
    county_fips_all: 48395,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77901,
    lat: 28.80629,
    lng: -96.98553,
    city: "Victoria",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42620,
    density: 909,
    county_fips: 48469,
    county_name: "Victoria",
    county_weights: {
      48469: 100,
    },
    county_names_all: "Victoria",
    county_fips_all: 48469,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77904,
    lat: 28.91788,
    lng: -97.0311,
    city: "Victoria",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28838,
    density: 101.3,
    county_fips: 48469,
    county_name: "Victoria",
    county_weights: {
      48469: 100,
    },
    county_names_all: "Victoria",
    county_fips_all: 48469,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77905,
    lat: 28.72789,
    lng: -97.0508,
    city: "Victoria",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15279,
    density: 13.8,
    county_fips: 48469,
    county_name: "Victoria",
    county_weights: {
      48175: 9.9,
      48469: 90.1,
    },
    county_names_all: "Victoria|Goliad",
    county_fips_all: "48469|48175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77950,
    lat: 28.26427,
    lng: -96.89666,
    city: "Austwell",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 157,
    density: 0.4,
    county_fips: 48007,
    county_name: "Aransas",
    county_weights: {
      48007: 74.74,
      48391: 25.26,
    },
    county_names_all: "Aransas|Refugio",
    county_fips_all: "48007|48391",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77951,
    lat: 28.63476,
    lng: -96.91183,
    city: "Bloomington",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1534,
    density: 24.8,
    county_fips: 48469,
    county_name: "Victoria",
    county_weights: {
      48469: 100,
    },
    county_names_all: "Victoria",
    county_fips_all: 48469,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77954,
    lat: 29.0966,
    lng: -97.29533,
    city: "Cuero",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11047,
    density: 11.3,
    county_fips: 48123,
    county_name: "DeWitt",
    county_weights: {
      48123: 95.03,
      48177: 4.97,
    },
    county_names_all: "DeWitt|Gonzales",
    county_fips_all: "48123|48177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77957,
    lat: 29.03022,
    lng: -96.70606,
    city: "Edna",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8454,
    density: 9.1,
    county_fips: 48239,
    county_name: "Jackson",
    county_weights: {
      48239: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 48239,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77960,
    lat: 28.65306,
    lng: -97.2461,
    city: "Fannin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62,
    density: 1.2,
    county_fips: 48175,
    county_name: "Goliad",
    county_weights: {
      48175: 100,
    },
    county_names_all: "Goliad",
    county_fips_all: 48175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77961,
    lat: 28.85684,
    lng: -96.35947,
    city: "Francitas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 138,
    density: 1.4,
    county_fips: 48239,
    county_name: "Jackson",
    county_weights: {
      48239: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 48239,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77962,
    lat: 29.03253,
    lng: -96.5023,
    city: "Ganado",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3309,
    density: 6.7,
    county_fips: 48239,
    county_name: "Jackson",
    county_weights: {
      48239: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 48239,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77963,
    lat: 28.65589,
    lng: -97.40093,
    city: "Goliad",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5733,
    density: 3.8,
    county_fips: 48175,
    county_name: "Goliad",
    county_weights: {
      48175: 100,
    },
    county_names_all: "Goliad",
    county_fips_all: 48175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77964,
    lat: 29.38023,
    lng: -96.84301,
    city: "Hallettsville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7874,
    density: 5.1,
    county_fips: 48285,
    county_name: "Lavaca",
    county_weights: {
      48089: 2.26,
      48285: 97.74,
    },
    county_names_all: "Lavaca|Colorado",
    county_fips_all: "48285|48089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77968,
    lat: 28.90619,
    lng: -96.84952,
    city: "Inez",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3142,
    density: 6.2,
    county_fips: 48469,
    county_name: "Victoria",
    county_weights: {
      48469: 100,
    },
    county_names_all: "Victoria",
    county_fips_all: 48469,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77969,
    lat: 28.77579,
    lng: -96.64719,
    city: "La Salle",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 177,
    density: 1.9,
    county_fips: 48239,
    county_name: "Jackson",
    county_weights: {
      48239: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 48239,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77970,
    lat: 28.84533,
    lng: -96.43153,
    city: "La Ward",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 337,
    density: 2.8,
    county_fips: 48239,
    county_name: "Jackson",
    county_weights: {
      48239: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 48239,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77971,
    lat: 28.83063,
    lng: -96.52176,
    city: "Lolita",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1227,
    density: 7.6,
    county_fips: 48239,
    county_name: "Jackson",
    county_weights: {
      48239: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 48239,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77973,
    lat: 28.54094,
    lng: -96.95512,
    city: "Mcfaddin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25,
    density: 0.3,
    county_fips: 48469,
    county_name: "Victoria",
    county_weights: {
      48469: 100,
    },
    county_names_all: "Victoria",
    county_fips_all: 48469,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77974,
    lat: 28.89295,
    lng: -97.29275,
    city: "Meyersville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 448,
    density: 6.1,
    county_fips: 48123,
    county_name: "DeWitt",
    county_weights: {
      48123: 63.49,
      48469: 36.51,
    },
    county_names_all: "DeWitt|Victoria",
    county_fips_all: "48123|48469",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77975,
    lat: 29.56843,
    lng: -97.08818,
    city: "Moulton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1722,
    density: 9.3,
    county_fips: 48285,
    county_name: "Lavaca",
    county_weights: {
      48285: 100,
    },
    county_names_all: "Lavaca",
    county_fips_all: 48285,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77976,
    lat: 28.94057,
    lng: -97.1342,
    city: "Nursery",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38,
    density: 1.2,
    county_fips: 48469,
    county_name: "Victoria",
    county_weights: {
      48469: 100,
    },
    county_names_all: "Victoria",
    county_fips_all: 48469,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77977,
    lat: 28.68082,
    lng: -96.80183,
    city: "Placedo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 513,
    density: 14.3,
    county_fips: 48469,
    county_name: "Victoria",
    county_weights: {
      48469: 100,
    },
    county_names_all: "Victoria",
    county_fips_all: 48469,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77978,
    lat: 28.69152,
    lng: -96.5991,
    city: "Point Comfort",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 576,
    density: 131,
    county_fips: 48057,
    county_name: "Calhoun",
    county_weights: {
      48057: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 48057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77979,
    lat: 28.60248,
    lng: -96.6017,
    city: "Port Lavaca",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17295,
    density: 19.6,
    county_fips: 48057,
    county_name: "Calhoun",
    county_weights: {
      48057: 85.64,
      48239: 6.71,
      48469: 7.65,
    },
    county_names_all: "Calhoun|Victoria|Jackson",
    county_fips_all: "48057|48469|48239",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77982,
    lat: 28.44903,
    lng: -96.48657,
    city: "Port O'Connor",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1139,
    density: 10.3,
    county_fips: 48057,
    county_name: "Calhoun",
    county_weights: {
      48057: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 48057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77983,
    lat: 28.39874,
    lng: -96.64049,
    city: "Seadrift",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2414,
    density: 10.8,
    county_fips: 48057,
    county_name: "Calhoun",
    county_weights: {
      48057: 100,
    },
    county_names_all: "Calhoun",
    county_fips_all: 48057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77984,
    lat: 29.45373,
    lng: -97.18849,
    city: "Shiner",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4129,
    density: 10,
    county_fips: 48285,
    county_name: "Lavaca",
    county_weights: {
      48123: 1.46,
      48177: 33.9,
      48285: 64.64,
    },
    county_names_all: "Lavaca|Gonzales|DeWitt",
    county_fips_all: "48285|48177|48123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77986,
    lat: 29.47661,
    lng: -96.79607,
    city: "Sublime",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48285,
    county_name: "Lavaca",
    county_weights: {
      48285: 100,
    },
    county_names_all: "Lavaca",
    county_fips_all: 48285,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77987,
    lat: 29.34569,
    lng: -97.08019,
    city: "Sweet Home",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 218,
    density: 23,
    county_fips: 48285,
    county_name: "Lavaca",
    county_weights: {
      48285: 100,
    },
    county_names_all: "Lavaca",
    county_fips_all: 48285,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77988,
    lat: 28.84701,
    lng: -96.87547,
    city: "Telferner",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 356,
    density: 51.6,
    county_fips: 48469,
    county_name: "Victoria",
    county_weights: {
      48469: 100,
    },
    county_names_all: "Victoria",
    county_fips_all: 48469,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77990,
    lat: 28.48098,
    lng: -96.93438,
    city: "Tivoli",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 788,
    density: 2.3,
    county_fips: 48391,
    county_name: "Refugio",
    county_weights: {
      48057: 27.84,
      48391: 72.16,
    },
    county_names_all: "Refugio|Calhoun",
    county_fips_all: "48391|48057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77991,
    lat: 28.7866,
    lng: -96.59467,
    city: "Vanderbilt",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 631,
    density: 22.9,
    county_fips: 48239,
    county_name: "Jackson",
    county_weights: {
      48239: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 48239,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77993,
    lat: 28.85158,
    lng: -97.433,
    city: "Weesatche",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 87,
    density: 1.8,
    county_fips: 48175,
    county_name: "Goliad",
    county_weights: {
      48123: 0.1,
      48175: 99.9,
    },
    county_names_all: "Goliad|DeWitt",
    county_fips_all: "48175|48123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77994,
    lat: 29.17977,
    lng: -97.46563,
    city: "Westhoff",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 424,
    density: 2.8,
    county_fips: 48123,
    county_name: "DeWitt",
    county_weights: {
      48123: 92.42,
      48177: 7.58,
    },
    county_names_all: "DeWitt|Gonzales",
    county_fips_all: "48123|48177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 77995,
    lat: 29.20384,
    lng: -97.08814,
    city: "Yoakum",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10731,
    density: 11,
    county_fips: 48123,
    county_name: "DeWitt",
    county_weights: {
      48123: 48.16,
      48285: 43.01,
      48469: 8.83,
    },
    county_names_all: "DeWitt|Lavaca|Victoria",
    county_fips_all: "48123|48285|48469",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78001,
    lat: 28.25327,
    lng: -99.22731,
    city: "Artesia Wells",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 48283,
    county_name: "La Salle",
    county_weights: {
      48283: 100,
    },
    county_names_all: "La Salle",
    county_fips_all: 48283,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78002,
    lat: 29.28305,
    lng: -98.73652,
    city: "Atascosa",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5758,
    density: 55.6,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78003,
    lat: 29.71092,
    lng: -99.09823,
    city: "Bandera",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10129,
    density: 17.3,
    county_fips: 48019,
    county_name: "Bandera",
    county_weights: {
      48019: 85.28,
      48325: 14.72,
    },
    county_names_all: "Bandera|Medina",
    county_fips_all: "48019|48325",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78004,
    lat: 29.85767,
    lng: -98.53773,
    city: "Bergheim",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1328,
    density: 45.1,
    county_fips: 48259,
    county_name: "Kendall",
    county_weights: {
      48259: 100,
    },
    county_names_all: "Kendall",
    county_fips_all: 48259,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78005,
    lat: 28.92848,
    lng: -98.84668,
    city: "Bigfoot",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1176,
    density: 3,
    county_fips: 48163,
    county_name: "Frio",
    county_weights: {
      48013: 11.46,
      48163: 88.54,
    },
    county_names_all: "Frio|Atascosa",
    county_fips_all: "48163|48013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78006,
    lat: 29.86869,
    lng: -98.71368,
    city: "Boerne",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37568,
    density: 41.9,
    county_fips: 48259,
    county_name: "Kendall",
    county_weights: {
      48029: 6.83,
      48091: 1,
      48259: 92.17,
    },
    county_names_all: "Kendall|Bexar|Comal",
    county_fips_all: "48259|48029|48091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78007,
    lat: 28.48212,
    lng: -98.40373,
    city: "Calliham",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 198,
    density: 2.7,
    county_fips: 48311,
    county_name: "McMullen",
    county_weights: {
      48311: 100,
    },
    county_names_all: "McMullen",
    county_fips_all: 48311,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78008,
    lat: 28.72478,
    lng: -98.25911,
    city: "Campbellton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 351,
    density: 1.3,
    county_fips: 48013,
    county_name: "Atascosa",
    county_weights: {
      48013: 92.54,
      48297: 7.46,
    },
    county_names_all: "Atascosa|Live Oak",
    county_fips_all: "48013|48297",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78009,
    lat: 29.36251,
    lng: -98.88442,
    city: "Castroville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7632,
    density: 41.8,
    county_fips: 48325,
    county_name: "Medina",
    county_weights: {
      48325: 100,
    },
    county_names_all: "Medina",
    county_fips_all: 48325,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78010,
    lat: 29.91122,
    lng: -99.04698,
    city: "Center Point",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4224,
    density: 22.6,
    county_fips: 48265,
    county_name: "Kerr",
    county_weights: {
      48265: 100,
    },
    county_names_all: "Kerr",
    county_fips_all: 48265,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78011,
    lat: 28.80267,
    lng: -98.73441,
    city: "Charlotte",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1574,
    density: 3.3,
    county_fips: 48013,
    county_name: "Atascosa",
    county_weights: {
      48013: 100,
    },
    county_names_all: "Atascosa",
    county_fips_all: 48013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78012,
    lat: 28.75792,
    lng: -98.45578,
    city: "Christine",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 227,
    density: 3.5,
    county_fips: 48013,
    county_name: "Atascosa",
    county_weights: {
      48013: 100,
    },
    county_names_all: "Atascosa",
    county_fips_all: 48013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78013,
    lat: 29.97798,
    lng: -98.90647,
    city: "Comfort",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6210,
    density: 10.6,
    county_fips: 48259,
    county_name: "Kendall",
    county_weights: {
      48259: 50.18,
      48265: 49.82,
    },
    county_names_all: "Kendall|Kerr",
    county_fips_all: "48259|48265",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78014,
    lat: 28.39837,
    lng: -99.10946,
    city: "Cotulla",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5510,
    density: 2.4,
    county_fips: 48283,
    county_name: "La Salle",
    county_weights: {
      48127: 2.32,
      48283: 97.68,
    },
    county_names_all: "La Salle|Dimmit",
    county_fips_all: "48283|48127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78015,
    lat: 29.7439,
    lng: -98.64785,
    city: "Boerne",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17187,
    density: 256.1,
    county_fips: 48259,
    county_name: "Kendall",
    county_weights: {
      48029: 42.81,
      48091: 10.38,
      48259: 46.81,
    },
    county_names_all: "Kendall|Bexar|Comal",
    county_fips_all: "48259|48029|48091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78016,
    lat: 29.18499,
    lng: -98.95692,
    city: "Devine",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10940,
    density: 26.7,
    county_fips: 48325,
    county_name: "Medina",
    county_weights: {
      48163: 4.26,
      48325: 95.74,
    },
    county_names_all: "Medina|Frio",
    county_fips_all: "48325|48163",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78017,
    lat: 28.72456,
    lng: -99.20455,
    city: "Dilley",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6120,
    density: 5.9,
    county_fips: 48163,
    county_name: "Frio",
    county_weights: {
      48163: 87.6,
      48283: 12.4,
    },
    county_names_all: "Frio|La Salle",
    county_fips_all: "48163|48283",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78019,
    lat: 28.02401,
    lng: -99.28461,
    city: "Encinal",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2111,
    density: 1.1,
    county_fips: 48479,
    county_name: "Webb",
    county_weights: {
      48283: 15.84,
      48479: 84.16,
    },
    county_names_all: "Webb|La Salle",
    county_fips_all: "48479|48283",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78021,
    lat: 28.4318,
    lng: -98.83489,
    city: "Fowlerton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 158,
    density: 0.2,
    county_fips: 48283,
    county_name: "La Salle",
    county_weights: {
      48283: 64.26,
      48311: 35.74,
    },
    county_names_all: "La Salle|McMullen",
    county_fips_all: "48283|48311",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78022,
    lat: 28.24222,
    lng: -98.16421,
    city: "George West",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4082,
    density: 3.3,
    county_fips: 48297,
    county_name: "Live Oak",
    county_weights: {
      48297: 88.64,
      48311: 11.36,
    },
    county_names_all: "Live Oak|McMullen",
    county_fips_all: "48297|48311",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78023,
    lat: 29.61549,
    lng: -98.75443,
    city: "Helotes",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29847,
    density: 128.3,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48019: 1.51,
      48029: 84.86,
      48325: 13.63,
    },
    county_names_all: "Bexar|Medina|Bandera",
    county_fips_all: "48029|48325|48019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78024,
    lat: 29.9964,
    lng: -99.48622,
    city: "Hunt",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1466,
    density: 2.2,
    county_fips: 48265,
    county_name: "Kerr",
    county_weights: {
      48265: 95.37,
      48385: 4.63,
    },
    county_names_all: "Kerr|Real",
    county_fips_all: "48265|48385",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78025,
    lat: 30.07971,
    lng: -99.28562,
    city: "Ingram",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4860,
    density: 34.7,
    county_fips: 48265,
    county_name: "Kerr",
    county_weights: {
      48265: 100,
    },
    county_names_all: "Kerr",
    county_fips_all: 48265,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78026,
    lat: 28.75573,
    lng: -98.54754,
    city: "Jourdanton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7158,
    density: 7.8,
    county_fips: 48013,
    county_name: "Atascosa",
    county_weights: {
      48013: 72.31,
      48311: 27.69,
    },
    county_names_all: "Atascosa|McMullen",
    county_fips_all: "48013|48311",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78027,
    lat: 29.98193,
    lng: -98.53868,
    city: "Kendalia",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 990,
    density: 5.3,
    county_fips: 48259,
    county_name: "Kendall",
    county_weights: {
      48259: 100,
    },
    county_names_all: "Kendall",
    county_fips_all: 48259,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78028,
    lat: 30.04115,
    lng: -99.16276,
    city: "Kerrville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40058,
    density: 58.7,
    county_fips: 48265,
    county_name: "Kerr",
    county_weights: {
      48171: 16.17,
      48265: 83.83,
    },
    county_names_all: "Kerr|Gillespie",
    county_fips_all: "48265|48171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78029,
    lat: 29.90078,
    lng: -99.1898,
    city: "Kerrville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48265,
    county_name: "Kerr",
    county_weights: {
      48265: 100,
    },
    county_names_all: "Kerr",
    county_fips_all: 48265,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78039,
    lat: 29.31324,
    lng: -98.82528,
    city: "La Coste",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2309,
    density: 43,
    county_fips: 48325,
    county_name: "Medina",
    county_weights: {
      48029: 29.09,
      48325: 70.91,
    },
    county_names_all: "Medina|Bexar",
    county_fips_all: "48325|48029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78040,
    lat: 27.51349,
    lng: -99.50232,
    city: "Laredo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39997,
    density: 2449.3,
    county_fips: 48479,
    county_name: "Webb",
    county_weights: {
      48479: 100,
    },
    county_names_all: "Webb",
    county_fips_all: 48479,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78041,
    lat: 27.55489,
    lng: -99.46889,
    city: "Laredo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47207,
    density: 1046.4,
    county_fips: 48479,
    county_name: "Webb",
    county_weights: {
      48479: 100,
    },
    county_names_all: "Webb",
    county_fips_all: 48479,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78043,
    lat: 27.54037,
    lng: -99.27447,
    city: "Laredo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46141,
    density: 100.6,
    county_fips: 48479,
    county_name: "Webb",
    county_weights: {
      48479: 100,
    },
    county_names_all: "Webb",
    county_fips_all: 48479,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78044,
    lat: 27.75613,
    lng: -99.22748,
    city: "Laredo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 600,
    density: 3.1,
    county_fips: 48479,
    county_name: "Webb",
    county_weights: {
      48479: 100,
    },
    county_names_all: "Webb",
    county_fips_all: 48479,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78045,
    lat: 27.83197,
    lng: -99.65963,
    city: "Laredo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67981,
    density: 39.6,
    county_fips: 48479,
    county_name: "Webb",
    county_weights: {
      48479: 100,
    },
    county_names_all: "Webb",
    county_fips_all: 48479,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78046,
    lat: 27.38371,
    lng: -99.36803,
    city: "Laredo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 71726,
    density: 151.1,
    county_fips: 48479,
    county_name: "Webb",
    county_weights: {
      48479: 100,
    },
    county_names_all: "Webb",
    county_fips_all: 48479,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78050,
    lat: 29.08924,
    lng: -98.50258,
    city: "Leming",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 682,
    density: 46.6,
    county_fips: 48013,
    county_name: "Atascosa",
    county_weights: {
      48013: 100,
    },
    county_names_all: "Atascosa",
    county_fips_all: 48013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78052,
    lat: 29.20582,
    lng: -98.77427,
    city: "Lytle",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6128,
    density: 61.6,
    county_fips: 48013,
    county_name: "Atascosa",
    county_weights: {
      48013: 76.37,
      48029: 7.57,
      48325: 16.06,
    },
    county_names_all: "Atascosa|Medina|Bexar",
    county_fips_all: "48013|48325|48029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78055,
    lat: 29.8184,
    lng: -99.31923,
    city: "Medina",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2120,
    density: 3.5,
    county_fips: 48019,
    county_name: "Bandera",
    county_weights: {
      48019: 97.58,
      48265: 2.42,
    },
    county_names_all: "Bandera|Kerr",
    county_fips_all: "48019|48265",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78056,
    lat: 29.53896,
    lng: -98.94184,
    city: "Mico",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2024,
    density: 7.6,
    county_fips: 48325,
    county_name: "Medina",
    county_weights: {
      48325: 100,
    },
    county_names_all: "Medina",
    county_fips_all: 48325,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78057,
    lat: 29.03924,
    lng: -99.02185,
    city: "Moore",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 520,
    density: 1.3,
    county_fips: 48163,
    county_name: "Frio",
    county_weights: {
      48163: 83.55,
      48325: 16.45,
    },
    county_names_all: "Frio|Medina",
    county_fips_all: "48163|48325",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78058,
    lat: 30.13188,
    lng: -99.59042,
    city: "Mountain Home",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 763,
    density: 0.7,
    county_fips: 48265,
    county_name: "Kerr",
    county_weights: {
      48171: 3.53,
      48265: 78.53,
      48385: 17.94,
    },
    county_names_all: "Kerr|Real|Gillespie",
    county_fips_all: "48265|48385|48171",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78059,
    lat: 29.19236,
    lng: -98.84143,
    city: "Natalia",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5327,
    density: 50.7,
    county_fips: 48325,
    county_name: "Medina",
    county_weights: {
      48325: 100,
    },
    county_names_all: "Medina",
    county_fips_all: 48325,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78061,
    lat: 28.90162,
    lng: -99.13104,
    city: "Pearsall",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12566,
    density: 9.5,
    county_fips: 48163,
    county_name: "Frio",
    county_weights: {
      48163: 100,
    },
    county_names_all: "Frio",
    county_fips_all: 48163,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78062,
    lat: 28.74599,
    lng: -98.19711,
    city: "Peggy",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48013,
    county_name: "Atascosa",
    county_weights: {
      48013: 100,
    },
    county_names_all: "Atascosa",
    county_fips_all: 48013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78063,
    lat: 29.68793,
    lng: -98.91424,
    city: "Pipe Creek",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9462,
    density: 30.6,
    county_fips: 48019,
    county_name: "Bandera",
    county_weights: {
      48019: 100,
    },
    county_names_all: "Bandera",
    county_fips_all: 48019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78064,
    lat: 28.9206,
    lng: -98.4249,
    city: "Pleasanton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16722,
    density: 22.9,
    county_fips: 48013,
    county_name: "Atascosa",
    county_weights: {
      48013: 95.91,
      48493: 4.09,
    },
    county_names_all: "Atascosa|Wilson",
    county_fips_all: "48013|48493",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78065,
    lat: 29.08152,
    lng: -98.64437,
    city: "Poteet",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11134,
    density: 24.7,
    county_fips: 48013,
    county_name: "Atascosa",
    county_weights: {
      48013: 100,
    },
    county_names_all: "Atascosa",
    county_fips_all: 48013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78066,
    lat: 29.49065,
    lng: -98.89042,
    city: "Rio Medina",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 937,
    density: 16.3,
    county_fips: 48325,
    county_name: "Medina",
    county_weights: {
      48325: 100,
    },
    county_names_all: "Medina",
    county_fips_all: 48325,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78067,
    lat: 27.11312,
    lng: -99.32793,
    city: "San Ygnacio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 615,
    density: 1.3,
    county_fips: 48505,
    county_name: "Zapata",
    county_weights: {
      48505: 100,
    },
    county_names_all: "Zapata",
    county_fips_all: 48505,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78069,
    lat: 29.18973,
    lng: -98.68045,
    city: "Somerset",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6187,
    density: 83.8,
    county_fips: 48013,
    county_name: "Atascosa",
    county_weights: {
      48013: 72.15,
      48029: 27.85,
    },
    county_names_all: "Atascosa|Bexar",
    county_fips_all: "48013|48029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78070,
    lat: 29.89291,
    lng: -98.40732,
    city: "Spring Branch",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15537,
    density: 45,
    county_fips: 48091,
    county_name: "Comal",
    county_weights: {
      48031: 7.75,
      48091: 82.36,
      48259: 9.89,
    },
    county_names_all: "Comal|Kendall|Blanco",
    county_fips_all: "48091|48259|48031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78071,
    lat: 28.47756,
    lng: -98.19733,
    city: "Three Rivers",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4394,
    density: 5.4,
    county_fips: 48297,
    county_name: "Live Oak",
    county_weights: {
      48297: 89.55,
      48311: 10.45,
    },
    county_names_all: "Live Oak|McMullen",
    county_fips_all: "48297|48311",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78072,
    lat: 28.32631,
    lng: -98.58357,
    city: "Tilden",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 508,
    density: 0.3,
    county_fips: 48311,
    county_name: "McMullen",
    county_weights: {
      48311: 100,
    },
    county_names_all: "McMullen",
    county_fips_all: 48311,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78073,
    lat: 29.24569,
    lng: -98.6213,
    city: "Von Ormy",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8897,
    density: 64.3,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48013: 10.43,
      48029: 89.57,
    },
    county_names_all: "Bexar|Atascosa",
    county_fips_all: "48029|48013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78074,
    lat: 29.94234,
    lng: -98.79214,
    city: "Waring",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48259,
    county_name: "Kendall",
    county_weights: {
      48259: 100,
    },
    county_names_all: "Kendall",
    county_fips_all: 48259,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78075,
    lat: 28.58862,
    lng: -98.26823,
    city: "Whitsett",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 249,
    density: 1.4,
    county_fips: 48297,
    county_name: "Live Oak",
    county_weights: {
      48297: 94.81,
      48311: 5.19,
    },
    county_names_all: "Live Oak|McMullen",
    county_fips_all: "48297|48311",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78076,
    lat: 26.93149,
    lng: -99.13382,
    city: "Zapata",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13279,
    density: 9.3,
    county_fips: 48505,
    county_name: "Zapata",
    county_weights: {
      48505: 100,
    },
    county_names_all: "Zapata",
    county_fips_all: 48505,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78101,
    lat: 29.34444,
    lng: -98.23316,
    city: "Adkins",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7434,
    density: 54.3,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 52.36,
      48493: 47.64,
    },
    county_names_all: "Bexar|Wilson",
    county_fips_all: "48029|48493",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78102,
    lat: 28.4094,
    lng: -97.71733,
    city: "Beeville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28253,
    density: 20.7,
    county_fips: 48025,
    county_name: "Bee",
    county_weights: {
      48025: 94.24,
      48297: 5.76,
    },
    county_names_all: "Bee|Live Oak",
    county_fips_all: "48025|48297",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78104,
    lat: 28.52361,
    lng: -97.76197,
    city: "Beeville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 176,
    density: 19.7,
    county_fips: 48025,
    county_name: "Bee",
    county_weights: {
      48025: 100,
    },
    county_names_all: "Bee",
    county_fips_all: 48025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78107,
    lat: 28.57827,
    lng: -97.59484,
    city: "Berclair",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 316,
    density: 0.7,
    county_fips: 48175,
    county_name: "Goliad",
    county_weights: {
      48175: 100,
    },
    county_names_all: "Goliad",
    county_fips_all: 48175,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78108,
    lat: 29.57354,
    lng: -98.22068,
    city: "Cibolo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43579,
    density: 595.9,
    county_fips: 48187,
    county_name: "Guadalupe",
    county_weights: {
      48029: 10.15,
      48091: 2.77,
      48187: 87.08,
    },
    county_names_all: "Guadalupe|Bexar|Comal",
    county_fips_all: "48187|48029|48091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78109,
    lat: 29.47977,
    lng: -98.29295,
    city: "Converse",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39424,
    density: 546.9,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78111,
    lat: 29.03696,
    lng: -97.74074,
    city: "Ecleto",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48255,
    county_name: "Karnes",
    county_weights: {
      48255: 100,
    },
    county_names_all: "Karnes",
    county_fips_all: 48255,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78112,
    lat: 29.21353,
    lng: -98.37266,
    city: "Elmendorf",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8725,
    density: 65.5,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 98.83,
      48493: 1.17,
    },
    county_names_all: "Bexar|Wilson",
    county_fips_all: "48029|48493",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78113,
    lat: 28.94563,
    lng: -98.13611,
    city: "Falls City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3253,
    density: 4.2,
    county_fips: 48493,
    county_name: "Wilson",
    county_weights: {
      48013: 31.77,
      48255: 28.11,
      48493: 40.11,
    },
    county_names_all: "Wilson|Atascosa|Karnes",
    county_fips_all: "48493|48013|48255",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78114,
    lat: 29.12124,
    lng: -98.19708,
    city: "Floresville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24463,
    density: 27.1,
    county_fips: 48493,
    county_name: "Wilson",
    county_weights: {
      48013: 7.36,
      48493: 92.64,
    },
    county_names_all: "Wilson|Atascosa",
    county_fips_all: "48493|48013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78116,
    lat: 29.11275,
    lng: -97.75677,
    city: "Gillett",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 331,
    density: 1.1,
    county_fips: 48255,
    county_name: "Karnes",
    county_weights: {
      48255: 100,
    },
    county_names_all: "Karnes",
    county_fips_all: 48255,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78117,
    lat: 28.95092,
    lng: -97.95736,
    city: "Hobson",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 512,
    density: 2.8,
    county_fips: 48255,
    county_name: "Karnes",
    county_weights: {
      48255: 100,
    },
    county_names_all: "Karnes",
    county_fips_all: 48255,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78118,
    lat: 28.87574,
    lng: -97.94729,
    city: "Karnes City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4418,
    density: 8.9,
    county_fips: 48255,
    county_name: "Karnes",
    county_weights: {
      48013: 3.42,
      48255: 89.2,
      48297: 7.38,
    },
    county_names_all: "Karnes|Live Oak|Atascosa",
    county_fips_all: "48255|48297|48013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78119,
    lat: 28.71739,
    lng: -97.91187,
    city: "Kenedy",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6960,
    density: 8.2,
    county_fips: 48255,
    county_name: "Karnes",
    county_weights: {
      48025: 33.5,
      48255: 54.89,
      48297: 11.61,
    },
    county_names_all: "Karnes|Bee|Live Oak",
    county_fips_all: "48255|48025|48297",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78121,
    lat: 29.35118,
    lng: -98.10241,
    city: "La Vernia",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12901,
    density: 48.5,
    county_fips: 48493,
    county_name: "Wilson",
    county_weights: {
      48187: 24.76,
      48493: 75.24,
    },
    county_names_all: "Wilson|Guadalupe",
    county_fips_all: "48493|48187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78122,
    lat: 29.44512,
    lng: -97.72212,
    city: "Leesville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 427,
    density: 4.3,
    county_fips: 48177,
    county_name: "Gonzales",
    county_weights: {
      48177: 100,
    },
    county_names_all: "Gonzales",
    county_fips_all: 48177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78123,
    lat: 29.60056,
    lng: -98.04236,
    city: "McQueeney",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2801,
    density: 289.5,
    county_fips: 48187,
    county_name: "Guadalupe",
    county_weights: {
      48187: 100,
    },
    county_names_all: "Guadalupe",
    county_fips_all: 48187,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78124,
    lat: 29.5585,
    lng: -98.15176,
    city: "Marion",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6553,
    density: 44.4,
    county_fips: 48187,
    county_name: "Guadalupe",
    county_weights: {
      48029: 12.52,
      48187: 87.48,
    },
    county_names_all: "Guadalupe|Bexar",
    county_fips_all: "48187|48029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78125,
    lat: 28.53184,
    lng: -97.96656,
    city: "Mineral",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39,
    density: 0.6,
    county_fips: 48025,
    county_name: "Bee",
    county_weights: {
      48025: 100,
    },
    county_names_all: "Bee",
    county_fips_all: 48025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78130,
    lat: 29.69224,
    lng: -98.06877,
    city: "New Braunfels",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 79786,
    density: 338.4,
    county_fips: 48187,
    county_name: "Guadalupe",
    county_weights: {
      48091: 43.52,
      48187: 55.98,
      48209: 0.5,
    },
    county_names_all: "Guadalupe|Comal|Hays",
    county_fips_all: "48187|48091|48209",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78132,
    lat: 29.76299,
    lng: -98.19,
    city: "New Braunfels",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33368,
    density: 71.8,
    county_fips: 48091,
    county_name: "Comal",
    county_weights: {
      48091: 99.47,
      48187: 0.53,
    },
    county_names_all: "Comal|Guadalupe",
    county_fips_all: "48091|48187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78133,
    lat: 29.88119,
    lng: -98.24624,
    city: "Canyon Lake",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19405,
    density: 99.2,
    county_fips: 48091,
    county_name: "Comal",
    county_weights: {
      48091: 100,
    },
    county_names_all: "Comal",
    county_fips_all: 48091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78140,
    lat: 29.30758,
    lng: -97.7619,
    city: "Nixon",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3457,
    density: 7.6,
    county_fips: 48177,
    county_name: "Gonzales",
    county_weights: {
      48177: 67.47,
      48187: 3.26,
      48255: 1.95,
      48493: 27.32,
    },
    county_names_all: "Gonzales|Wilson|Guadalupe|Karnes",
    county_fips_all: "48177|48493|48187|48255",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78141,
    lat: 28.90484,
    lng: -97.62365,
    city: "Nordheim",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 767,
    density: 3.8,
    county_fips: 48123,
    county_name: "DeWitt",
    county_weights: {
      48123: 78.31,
      48255: 21.69,
    },
    county_names_all: "DeWitt|Karnes",
    county_fips_all: "48123|48255",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78142,
    lat: 28.53632,
    lng: -97.81297,
    city: "Normanna",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 106,
    density: 6.8,
    county_fips: 48025,
    county_name: "Bee",
    county_weights: {
      48025: 100,
    },
    county_names_all: "Bee",
    county_fips_all: 48025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78143,
    lat: 29.26267,
    lng: -97.86085,
    city: "Pandora",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 199,
    density: 44.5,
    county_fips: 48493,
    county_name: "Wilson",
    county_weights: {
      48493: 100,
    },
    county_names_all: "Wilson",
    county_fips_all: 48493,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78144,
    lat: 28.95506,
    lng: -97.88795,
    city: "Panna Maria",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14,
    density: 2.4,
    county_fips: 48255,
    county_name: "Karnes",
    county_weights: {
      48255: 100,
    },
    county_names_all: "Karnes",
    county_fips_all: 48255,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78145,
    lat: 28.64539,
    lng: -97.99248,
    city: "Pawnee",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 85,
    density: 10.1,
    county_fips: 48025,
    county_name: "Bee",
    county_weights: {
      48025: 100,
    },
    county_names_all: "Bee",
    county_fips_all: 48025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78146,
    lat: 28.6038,
    lng: -97.83989,
    city: "Pettus",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 834,
    density: 8,
    county_fips: 48025,
    county_name: "Bee",
    county_weights: {
      48025: 100,
    },
    county_names_all: "Bee",
    county_fips_all: 48025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78147,
    lat: 29.07375,
    lng: -98.08017,
    city: "Poth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1805,
    density: 200.5,
    county_fips: 48493,
    county_name: "Wilson",
    county_weights: {
      48493: 100,
    },
    county_names_all: "Wilson",
    county_fips_all: 48493,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78148,
    lat: 29.54331,
    lng: -98.29609,
    city: "Universal City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22955,
    density: 919.3,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78150,
    lat: 29.5381,
    lng: -98.2815,
    city: "Jbsa Randolph",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41,
    density: 261.4,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78151,
    lat: 28.86788,
    lng: -97.70986,
    city: "Runge",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1705,
    density: 6.1,
    county_fips: 48255,
    county_name: "Karnes",
    county_weights: {
      48123: 4.82,
      48255: 95.18,
    },
    county_names_all: "Karnes|DeWitt",
    county_fips_all: "48255|48123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78152,
    lat: 29.43046,
    lng: -98.20171,
    city: "Saint Hedwig",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2569,
    density: 27.5,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78154,
    lat: 29.54774,
    lng: -98.26574,
    city: "Schertz",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41171,
    density: 483.8,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 56.51,
      48091: 11.66,
      48187: 31.83,
    },
    county_names_all: "Bexar|Guadalupe|Comal",
    county_fips_all: "48029|48187|48091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78155,
    lat: 29.53305,
    lng: -97.93832,
    city: "Seguin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50832,
    density: 55.2,
    county_fips: 48187,
    county_name: "Guadalupe",
    county_weights: {
      48187: 100,
    },
    county_names_all: "Guadalupe",
    county_fips_all: 48187,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78159,
    lat: 29.23031,
    lng: -97.58247,
    city: "Smiley",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1033,
    density: 3,
    county_fips: 48177,
    county_name: "Gonzales",
    county_weights: {
      48177: 100,
    },
    county_names_all: "Gonzales",
    county_fips_all: 48177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78160,
    lat: 29.24182,
    lng: -97.9285,
    city: "Stockdale",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5776,
    density: 12.4,
    county_fips: 48493,
    county_name: "Wilson",
    county_weights: {
      48493: 100,
    },
    county_names_all: "Wilson",
    county_fips_all: 48493,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78161,
    lat: 29.28741,
    lng: -98.05012,
    city: "Sutherland Springs",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 550,
    density: 19.7,
    county_fips: 48493,
    county_name: "Wilson",
    county_weights: {
      48493: 100,
    },
    county_names_all: "Wilson",
    county_fips_all: 48493,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78162,
    lat: 28.57816,
    lng: -97.79447,
    city: "Tuleta",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 393,
    density: 9.5,
    county_fips: 48025,
    county_name: "Bee",
    county_weights: {
      48025: 100,
    },
    county_names_all: "Bee",
    county_fips_all: 48025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78163,
    lat: 29.7663,
    lng: -98.44514,
    city: "Bulverde",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13937,
    density: 72,
    county_fips: 48091,
    county_name: "Comal",
    county_weights: {
      48091: 100,
    },
    county_names_all: "Comal",
    county_fips_all: 48091,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78164,
    lat: 28.9792,
    lng: -97.5188,
    city: "Yorktown",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3990,
    density: 6.1,
    county_fips: 48123,
    county_name: "DeWitt",
    county_weights: {
      48123: 87.3,
      48175: 12.7,
    },
    county_names_all: "DeWitt|Goliad",
    county_fips_all: "48123|48175",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78201,
    lat: 29.46901,
    lng: -98.52861,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50336,
    density: 2726.1,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78202,
    lat: 29.42821,
    lng: -98.46078,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11675,
    density: 1954.3,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78203,
    lat: 29.41513,
    lng: -98.4593,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6162,
    density: 1740.9,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78204,
    lat: 29.40327,
    lng: -98.50368,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12850,
    density: 1830.1,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78205,
    lat: 29.42364,
    lng: -98.48647,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1503,
    density: 494.7,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78207,
    lat: 29.42223,
    lng: -98.52545,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57700,
    density: 3051.6,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78208,
    lat: 29.4399,
    lng: -98.45823,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4549,
    density: 1797.7,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78209,
    lat: 29.48899,
    lng: -98.45675,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44706,
    density: 1697.1,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78210,
    lat: 29.39597,
    lng: -98.46433,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37061,
    density: 1952.2,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78211,
    lat: 29.34644,
    lng: -98.56327,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34539,
    density: 1305.3,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78212,
    lat: 29.46447,
    lng: -98.49222,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27940,
    density: 1557.8,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78213,
    lat: 29.51745,
    lng: -98.52358,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45124,
    density: 2168.8,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78214,
    lat: 29.34944,
    lng: -98.47971,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26805,
    density: 1243,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78215,
    lat: 29.4404,
    lng: -98.48031,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2925,
    density: 1062.9,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78216,
    lat: 29.53641,
    lng: -98.48999,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45325,
    density: 1243.8,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78217,
    lat: 29.54073,
    lng: -98.42097,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35257,
    density: 1341.4,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78218,
    lat: 29.49354,
    lng: -98.39948,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38749,
    density: 1338.7,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78219,
    lat: 29.44137,
    lng: -98.38459,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17705,
    density: 434.8,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78220,
    lat: 29.41308,
    lng: -98.40152,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17095,
    density: 854.9,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78221,
    lat: 29.28097,
    lng: -98.47529,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42535,
    density: 452.3,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78222,
    lat: 29.3679,
    lng: -98.38334,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25935,
    density: 525.4,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78223,
    lat: 29.31102,
    lng: -98.38675,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56484,
    density: 533.1,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 91.62,
      48493: 8.38,
    },
    county_names_all: "Bexar|Wilson",
    county_fips_all: "48029|48493",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78224,
    lat: 29.30831,
    lng: -98.53751,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22569,
    density: 571.4,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78225,
    lat: 29.38795,
    lng: -98.52586,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15147,
    density: 3032.8,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78226,
    lat: 29.38442,
    lng: -98.56885,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8012,
    density: 435.7,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78227,
    lat: 29.39654,
    lng: -98.64019,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49326,
    density: 998,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78228,
    lat: 29.46072,
    lng: -98.57201,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61441,
    density: 2175.4,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78229,
    lat: 29.5056,
    lng: -98.57261,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35589,
    density: 2376.7,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78230,
    lat: 29.5455,
    lng: -98.55571,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45661,
    density: 1680.1,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78231,
    lat: 29.57978,
    lng: -98.54504,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10132,
    density: 956.8,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78232,
    lat: 29.58792,
    lng: -98.47503,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39638,
    density: 1287.4,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78233,
    lat: 29.55483,
    lng: -98.36323,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48060,
    density: 1357.4,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78234,
    lat: 29.46108,
    lng: -98.43715,
    city: "Jbsa Ft Sam Houston",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4917,
    density: 373.2,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78235,
    lat: 29.34244,
    lng: -98.43934,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1471,
    density: 298.1,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78236,
    lat: 29.3859,
    lng: -98.62256,
    city: "Jbsa Lackland",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6760,
    density: 530.9,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78237,
    lat: 29.42079,
    lng: -98.56832,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41247,
    density: 2235.3,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78238,
    lat: 29.47088,
    lng: -98.61925,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27027,
    density: 1027.4,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78239,
    lat: 29.51664,
    lng: -98.3625,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26966,
    density: 1629.8,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78240,
    lat: 29.5244,
    lng: -98.60813,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61937,
    density: 2140.5,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78242,
    lat: 29.35067,
    lng: -98.60751,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35159,
    density: 1715.1,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78243,
    lat: 29.37213,
    lng: -98.59349,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 419,
    density: 251.8,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78244,
    lat: 29.47702,
    lng: -98.35075,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33988,
    density: 1738.8,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78245,
    lat: 29.40106,
    lng: -98.73549,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 76392,
    density: 836.8,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78247,
    lat: 29.58005,
    lng: -98.41196,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53597,
    density: 1420.9,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78248,
    lat: 29.59022,
    lng: -98.52553,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13822,
    density: 1384.8,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78249,
    lat: 29.56752,
    lng: -98.614,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61712,
    density: 1645.2,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78250,
    lat: 29.50341,
    lng: -98.66668,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62951,
    density: 2580.6,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78251,
    lat: 29.46292,
    lng: -98.67763,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65885,
    density: 1697.8,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78252,
    lat: 29.34167,
    lng: -98.69682,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11479,
    density: 157.6,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78253,
    lat: 29.46899,
    lng: -98.78885,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41900,
    density: 301.7,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 62.69,
      48325: 37.31,
    },
    county_names_all: "Bexar|Medina",
    county_fips_all: "48029|48325",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78254,
    lat: 29.53011,
    lng: -98.72805,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61141,
    density: 1167.3,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78255,
    lat: 29.64814,
    lng: -98.66405,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15064,
    density: 324.1,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78256,
    lat: 29.62272,
    lng: -98.6262,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11435,
    density: 552.6,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78257,
    lat: 29.64373,
    lng: -98.57713,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8113,
    density: 109.9,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78258,
    lat: 29.63574,
    lng: -98.49282,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47146,
    density: 1045.8,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78259,
    lat: 29.62512,
    lng: -98.42031,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26591,
    density: 661.4,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78260,
    lat: 29.69737,
    lng: -98.49212,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26164,
    density: 404.7,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78261,
    lat: 29.69189,
    lng: -98.40072,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16518,
    density: 219,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78263,
    lat: 29.35084,
    lng: -98.31219,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3561,
    density: 36,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48029: 100,
    },
    county_names_all: "Bexar",
    county_fips_all: 48029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78264,
    lat: 29.19868,
    lng: -98.50534,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10603,
    density: 57.9,
    county_fips: 48029,
    county_name: "Bexar",
    county_weights: {
      48013: 6.41,
      48029: 93.59,
    },
    county_names_all: "Bexar|Atascosa",
    county_fips_all: "48029|48013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78266,
    lat: 29.65611,
    lng: -98.3295,
    city: "San Antonio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6592,
    density: 64.1,
    county_fips: 48091,
    county_name: "Comal",
    county_weights: {
      48029: 19.67,
      48091: 80.33,
    },
    county_names_all: "Comal|Bexar",
    county_fips_all: "48091|48029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78330,
    lat: 27.7656,
    lng: -97.91378,
    city: "Agua Dulce",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 633,
    density: 11.3,
    county_fips: 48355,
    county_name: "Nueces",
    county_weights: {
      48355: 100,
    },
    county_names_all: "Nueces",
    county_fips_all: 48355,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78332,
    lat: 27.71671,
    lng: -98.13208,
    city: "Alice",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28301,
    density: 22.4,
    county_fips: 48249,
    county_name: "Jim Wells",
    county_weights: {
      48131: 15.25,
      48249: 84.75,
    },
    county_names_all: "Jim Wells|Duval",
    county_fips_all: "48249|48131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78336,
    lat: 27.94356,
    lng: -97.1862,
    city: "Aransas Pass",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12533,
    density: 80.7,
    county_fips: 48409,
    county_name: "San Patricio",
    county_weights: {
      48007: 29.97,
      48355: 6.14,
      48409: 63.89,
    },
    county_names_all: "San Patricio|Aransas|Nueces",
    county_fips_all: "48409|48007|48355",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78338,
    lat: 26.86821,
    lng: -97.73585,
    city: "Armstrong",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 48261,
    county_name: "Kenedy",
    county_weights: {
      48261: 100,
    },
    county_names_all: "Kenedy",
    county_fips_all: 48261,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78339,
    lat: 27.80036,
    lng: -97.7912,
    city: "Banquete",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 476,
    density: 128.3,
    county_fips: 48355,
    county_name: "Nueces",
    county_weights: {
      48355: 100,
    },
    county_names_all: "Nueces",
    county_fips_all: 48355,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78340,
    lat: 28.12472,
    lng: -97.20982,
    city: "Bayside",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 437,
    density: 8.2,
    county_fips: 48391,
    county_name: "Refugio",
    county_weights: {
      48391: 100,
    },
    county_names_all: "Refugio",
    county_fips_all: 48391,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78341,
    lat: 27.57551,
    lng: -98.46636,
    city: "Benavides",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2318,
    density: 3.7,
    county_fips: 48131,
    county_name: "Duval",
    county_weights: {
      48131: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 48131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78342,
    lat: 27.66012,
    lng: -98.07572,
    city: "Ben Bolt",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 342,
    density: 75.1,
    county_fips: 48249,
    county_name: "Jim Wells",
    county_weights: {
      48249: 100,
    },
    county_names_all: "Jim Wells",
    county_fips_all: 48249,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78343,
    lat: 27.62163,
    lng: -97.77216,
    city: "Bishop",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4627,
    density: 12.5,
    county_fips: 48355,
    county_name: "Nueces",
    county_weights: {
      48355: 100,
    },
    county_names_all: "Nueces",
    county_fips_all: 48355,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78344,
    lat: 27.56303,
    lng: -98.85966,
    city: "Bruni",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 419,
    density: 1.1,
    county_fips: 48479,
    county_name: "Webb",
    county_weights: {
      48479: 100,
    },
    county_names_all: "Webb",
    county_fips_all: 48479,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78347,
    lat: 27.57337,
    lng: -97.48642,
    city: "Chapman Ranch",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48355,
    county_name: "Nueces",
    county_weights: {
      48273: 0.35,
      48355: 99.65,
    },
    county_names_all: "Nueces|Kleberg",
    county_fips_all: "48355|48273",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78349,
    lat: 27.37501,
    lng: -98.29983,
    city: "Concepcion",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 598,
    density: 1.9,
    county_fips: 48131,
    county_name: "Duval",
    county_weights: {
      48131: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 48131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78351,
    lat: 27.66779,
    lng: -97.75258,
    city: "Driscoll",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 519,
    density: 212.5,
    county_fips: 48355,
    county_name: "Nueces",
    county_weights: {
      48355: 100,
    },
    county_names_all: "Nueces",
    county_fips_all: 48355,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78352,
    lat: 27.98154,
    lng: -97.68978,
    city: "Edroy",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 256,
    density: 23.9,
    county_fips: 48409,
    county_name: "San Patricio",
    county_weights: {
      48409: 100,
    },
    county_names_all: "San Patricio",
    county_fips_all: 48409,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78353,
    lat: 26.88621,
    lng: -98.23927,
    city: "Encino",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 320,
    density: 0.5,
    county_fips: 48047,
    county_name: "Brooks",
    county_weights: {
      48047: 100,
    },
    county_names_all: "Brooks",
    county_fips_all: 48047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78355,
    lat: 27.18855,
    lng: -98.20304,
    city: "Falfurrias",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7222,
    density: 7.9,
    county_fips: 48047,
    county_name: "Brooks",
    county_weights: {
      48047: 84.63,
      48249: 11.3,
      48273: 4.07,
    },
    county_names_all: "Brooks|Jim Wells|Kleberg",
    county_fips_all: "48047|48249|48273",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78357,
    lat: 27.93286,
    lng: -98.5629,
    city: "Freer",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2695,
    density: 3.9,
    county_fips: 48131,
    county_name: "Duval",
    county_weights: {
      48131: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 48131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78358,
    lat: 28.06841,
    lng: -97.04325,
    city: "Fulton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 599,
    density: 279.7,
    county_fips: 48007,
    county_name: "Aransas",
    county_weights: {
      48007: 100,
    },
    county_names_all: "Aransas",
    county_fips_all: 48007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78359,
    lat: 27.93021,
    lng: -97.30056,
    city: "Gregory",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2218,
    density: 89.4,
    county_fips: 48409,
    county_name: "San Patricio",
    county_weights: {
      48409: 100,
    },
    county_names_all: "San Patricio",
    county_fips_all: 48409,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78360,
    lat: 26.8605,
    lng: -98.83204,
    city: "Guerra",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48247,
    county_name: "Jim Hogg",
    county_weights: {
      48247: 100,
    },
    county_names_all: "Jim Hogg",
    county_fips_all: 48247,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78361,
    lat: 27.08457,
    lng: -98.73973,
    city: "Hebbronville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5273,
    density: 2.2,
    county_fips: 48247,
    county_name: "Jim Hogg",
    county_weights: {
      48131: 2.88,
      48247: 87.68,
      48505: 9.44,
    },
    county_names_all: "Jim Hogg|Zapata|Duval",
    county_fips_all: "48247|48505|48131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78362,
    lat: 27.86668,
    lng: -97.20167,
    city: "Ingleside",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11025,
    density: 232.9,
    county_fips: 48409,
    county_name: "San Patricio",
    county_weights: {
      48355: 0.1,
      48409: 99.9,
    },
    county_names_all: "San Patricio|Nueces",
    county_fips_all: "48409|48355",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78363,
    lat: 27.43836,
    lng: -97.85532,
    city: "Kingsville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29400,
    density: 74.6,
    county_fips: 48273,
    county_name: "Kleberg",
    county_weights: {
      48273: 100,
    },
    county_names_all: "Kleberg",
    county_fips_all: 48273,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78368,
    lat: 28.11299,
    lng: -97.81201,
    city: "Mathis",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9305,
    density: 17.4,
    county_fips: 48409,
    county_name: "San Patricio",
    county_weights: {
      48297: 31.28,
      48409: 68.72,
    },
    county_names_all: "San Patricio|Live Oak",
    county_fips_all: "48409|48297",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78369,
    lat: 27.42418,
    lng: -99.08229,
    city: "Mirando City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 378,
    density: 2.2,
    county_fips: 48479,
    county_name: "Webb",
    county_weights: {
      48479: 100,
    },
    county_names_all: "Webb",
    county_fips_all: 48479,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78370,
    lat: 27.94238,
    lng: -97.6033,
    city: "Odem",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4458,
    density: 15.6,
    county_fips: 48409,
    county_name: "San Patricio",
    county_weights: {
      48409: 100,
    },
    county_names_all: "San Patricio",
    county_fips_all: 48409,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78371,
    lat: 27.5493,
    lng: -99.04716,
    city: "Oilton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 170,
    density: 0.7,
    county_fips: 48479,
    county_name: "Webb",
    county_weights: {
      48479: 100,
    },
    county_names_all: "Webb",
    county_fips_all: 48479,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78372,
    lat: 27.9979,
    lng: -98.09669,
    city: "Orange Grove",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4967,
    density: 7.8,
    county_fips: 48249,
    county_name: "Jim Wells",
    county_weights: {
      48131: 9.78,
      48249: 77.28,
      48297: 12.94,
    },
    county_names_all: "Jim Wells|Live Oak|Duval",
    county_fips_all: "48249|48297|48131",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78373,
    lat: 27.78075,
    lng: -97.11737,
    city: "Port Aransas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4407,
    density: 90.3,
    county_fips: 48355,
    county_name: "Nueces",
    county_weights: {
      48355: 100,
    },
    county_names_all: "Nueces",
    county_fips_all: 48355,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78374,
    lat: 27.88849,
    lng: -97.29366,
    city: "Portland",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17972,
    density: 373.9,
    county_fips: 48409,
    county_name: "San Patricio",
    county_weights: {
      48409: 100,
    },
    county_names_all: "San Patricio",
    county_fips_all: 48409,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78375,
    lat: 27.38282,
    lng: -98.16351,
    city: "Premont",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2982,
    density: 13,
    county_fips: 48249,
    county_name: "Jim Wells",
    county_weights: {
      48249: 100,
    },
    county_names_all: "Jim Wells",
    county_fips_all: 48249,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78376,
    lat: 27.37163,
    lng: -98.47721,
    city: "Realitos",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 447,
    density: 1.1,
    county_fips: 48131,
    county_name: "Duval",
    county_weights: {
      48131: 100,
    },
    county_names_all: "Duval",
    county_fips_all: 48131,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78377,
    lat: 28.3418,
    lng: -97.18051,
    city: "Refugio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3510,
    density: 2.8,
    county_fips: 48391,
    county_name: "Refugio",
    county_weights: {
      48391: 100,
    },
    county_names_all: "Refugio",
    county_fips_all: 48391,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78379,
    lat: 27.30211,
    lng: -97.79361,
    city: "Riviera",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1285,
    density: 6.5,
    county_fips: 48273,
    county_name: "Kleberg",
    county_weights: {
      48273: 100,
    },
    county_names_all: "Kleberg",
    county_fips_all: 48273,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78380,
    lat: 27.77872,
    lng: -97.7363,
    city: "Robstown",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23610,
    density: 26.6,
    county_fips: 48355,
    county_name: "Nueces",
    county_weights: {
      48249: 0.28,
      48355: 99.72,
    },
    county_names_all: "Nueces|Jim Wells",
    county_fips_all: "48355|48249",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78382,
    lat: 28.11489,
    lng: -97.06342,
    city: "Rockport",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19313,
    density: 93.3,
    county_fips: 48007,
    county_name: "Aransas",
    county_weights: {
      48007: 100,
    },
    county_names_all: "Aransas",
    county_fips_all: 48007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78383,
    lat: 28.07713,
    lng: -97.94425,
    city: "Sandia",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6079,
    density: 16.6,
    county_fips: 48297,
    county_name: "Live Oak",
    county_weights: {
      48249: 29.04,
      48297: 63.82,
      48355: 7.14,
    },
    county_names_all: "Live Oak|Jim Wells|Nueces",
    county_fips_all: "48297|48249|48355",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78384,
    lat: 27.73068,
    lng: -98.4707,
    city: "San Diego",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5621,
    density: 3.7,
    county_fips: 48131,
    county_name: "Duval",
    county_weights: {
      48131: 98.61,
      48249: 1.39,
    },
    county_names_all: "Duval|Jim Wells",
    county_fips_all: "48131|48249",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78385,
    lat: 27.1276,
    lng: -97.8369,
    city: "Sarita",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 391,
    density: 0.5,
    county_fips: 48261,
    county_name: "Kenedy",
    county_weights: {
      48261: 100,
    },
    county_names_all: "Kenedy",
    county_fips_all: 48261,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78387,
    lat: 28.08224,
    lng: -97.55255,
    city: "Sinton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9874,
    density: 22.1,
    county_fips: 48409,
    county_name: "San Patricio",
    county_weights: {
      48025: 20.86,
      48409: 79.14,
    },
    county_names_all: "San Patricio|Bee",
    county_fips_all: "48409|48025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78389,
    lat: 28.244,
    lng: -97.66619,
    city: "Skidmore",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1984,
    density: 6.2,
    county_fips: 48025,
    county_name: "Bee",
    county_weights: {
      48025: 100,
    },
    county_names_all: "Bee",
    county_fips_all: 48025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78390,
    lat: 28.00198,
    lng: -97.35631,
    city: "Taft",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5299,
    density: 10.1,
    county_fips: 48409,
    county_name: "San Patricio",
    county_weights: {
      48007: 8.3,
      48409: 91.7,
    },
    county_names_all: "San Patricio|Aransas",
    county_fips_all: "48409|48007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78391,
    lat: 28.18297,
    lng: -97.72743,
    city: "Tynan",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 223,
    density: 4,
    county_fips: 48025,
    county_name: "Bee",
    county_weights: {
      48025: 100,
    },
    county_names_all: "Bee",
    county_fips_all: 48025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78393,
    lat: 28.18097,
    lng: -97.35427,
    city: "Woodsboro",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2182,
    density: 6.6,
    county_fips: 48391,
    county_name: "Refugio",
    county_weights: {
      48391: 100,
    },
    county_names_all: "Refugio",
    county_fips_all: 48391,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78401,
    lat: 27.79734,
    lng: -97.40118,
    city: "Corpus Christi",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4823,
    density: 865.5,
    county_fips: 48355,
    county_name: "Nueces",
    county_weights: {
      48355: 100,
    },
    county_names_all: "Nueces",
    county_fips_all: 48355,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78402,
    lat: 27.82413,
    lng: -97.4091,
    city: "Corpus Christi",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 159,
    density: 14.5,
    county_fips: 48355,
    county_name: "Nueces",
    county_weights: {
      48355: 100,
    },
    county_names_all: "Nueces",
    county_fips_all: 48355,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78404,
    lat: 27.76798,
    lng: -97.39946,
    city: "Corpus Christi",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16852,
    density: 2022.8,
    county_fips: 48355,
    county_name: "Nueces",
    county_weights: {
      48355: 100,
    },
    county_names_all: "Nueces",
    county_fips_all: 48355,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78405,
    lat: 27.77404,
    lng: -97.43872,
    city: "Corpus Christi",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14224,
    density: 1078.3,
    county_fips: 48355,
    county_name: "Nueces",
    county_weights: {
      48355: 100,
    },
    county_names_all: "Nueces",
    county_fips_all: 48355,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78406,
    lat: 27.77197,
    lng: -97.51543,
    city: "Corpus Christi",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2051,
    density: 70.3,
    county_fips: 48355,
    county_name: "Nueces",
    county_weights: {
      48355: 100,
    },
    county_names_all: "Nueces",
    county_fips_all: 48355,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78407,
    lat: 27.80762,
    lng: -97.44772,
    city: "Corpus Christi",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2292,
    density: 369.1,
    county_fips: 48355,
    county_name: "Nueces",
    county_weights: {
      48355: 100,
    },
    county_names_all: "Nueces",
    county_fips_all: 48355,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78408,
    lat: 27.80081,
    lng: -97.44339,
    city: "Corpus Christi",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11299,
    density: 744.4,
    county_fips: 48355,
    county_name: "Nueces",
    county_weights: {
      48355: 100,
    },
    county_names_all: "Nueces",
    county_fips_all: 48355,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78409,
    lat: 27.81729,
    lng: -97.51458,
    city: "Corpus Christi",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2448,
    density: 51.3,
    county_fips: 48355,
    county_name: "Nueces",
    county_weights: {
      48355: 100,
    },
    county_names_all: "Nueces",
    county_fips_all: 48355,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78410,
    lat: 27.83798,
    lng: -97.59388,
    city: "Corpus Christi",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28210,
    density: 484.4,
    county_fips: 48355,
    county_name: "Nueces",
    county_weights: {
      48355: 100,
    },
    county_names_all: "Nueces",
    county_fips_all: 48355,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78411,
    lat: 27.7293,
    lng: -97.38504,
    city: "Corpus Christi",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25548,
    density: 1608.1,
    county_fips: 48355,
    county_name: "Nueces",
    county_weights: {
      48355: 100,
    },
    county_names_all: "Nueces",
    county_fips_all: 48355,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78412,
    lat: 27.70364,
    lng: -97.34264,
    city: "Corpus Christi",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42385,
    density: 1894.8,
    county_fips: 48355,
    county_name: "Nueces",
    county_weights: {
      48355: 100,
    },
    county_names_all: "Nueces",
    county_fips_all: 48355,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78413,
    lat: 27.68345,
    lng: -97.40409,
    city: "Corpus Christi",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39782,
    density: 1949.2,
    county_fips: 48355,
    county_name: "Nueces",
    county_weights: {
      48355: 100,
    },
    county_names_all: "Nueces",
    county_fips_all: 48355,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78414,
    lat: 27.65992,
    lng: -97.369,
    city: "Corpus Christi",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44014,
    density: 1193.9,
    county_fips: 48355,
    county_name: "Nueces",
    county_weights: {
      48355: 100,
    },
    county_names_all: "Nueces",
    county_fips_all: 48355,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78415,
    lat: 27.65437,
    lng: -97.48712,
    city: "Corpus Christi",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41976,
    density: 148.5,
    county_fips: 48355,
    county_name: "Nueces",
    county_weights: {
      48355: 100,
    },
    county_names_all: "Nueces",
    county_fips_all: 48355,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78416,
    lat: 27.74933,
    lng: -97.43759,
    city: "Corpus Christi",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15804,
    density: 1838.1,
    county_fips: 48355,
    county_name: "Nueces",
    county_weights: {
      48355: 100,
    },
    county_names_all: "Nueces",
    county_fips_all: 48355,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78417,
    lat: 27.73753,
    lng: -97.46771,
    city: "Corpus Christi",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4572,
    density: 189.4,
    county_fips: 48355,
    county_name: "Nueces",
    county_weights: {
      48355: 100,
    },
    county_names_all: "Nueces",
    county_fips_all: 48355,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78418,
    lat: 27.52732,
    lng: -97.29313,
    city: "Corpus Christi",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29789,
    density: 156.8,
    county_fips: 48273,
    county_name: "Kleberg",
    county_weights: {
      48273: 53.26,
      48355: 46.74,
    },
    county_names_all: "Kleberg|Nueces",
    county_fips_all: "48273|48355",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78419,
    lat: 27.69689,
    lng: -97.26881,
    city: "Corpus Christi",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 861,
    density: 457.5,
    county_fips: 48355,
    county_name: "Nueces",
    county_weights: {
      48355: 100,
    },
    county_names_all: "Nueces",
    county_fips_all: 48355,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78501,
    lat: 26.21599,
    lng: -98.2391,
    city: "Mcallen",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60299,
    density: 1498.2,
    county_fips: 48215,
    county_name: "Hidalgo",
    county_weights: {
      48215: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 48215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78503,
    lat: 26.16229,
    lng: -98.25132,
    city: "Mcallen",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20703,
    density: 416.1,
    county_fips: 48215,
    county_name: "Hidalgo",
    county_weights: {
      48215: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 48215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78504,
    lat: 26.27758,
    lng: -98.23728,
    city: "Mcallen",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61182,
    density: 1205.7,
    county_fips: 48215,
    county_name: "Hidalgo",
    county_weights: {
      48215: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 48215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78516,
    lat: 26.14256,
    lng: -98.11977,
    city: "Alamo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36248,
    density: 370,
    county_fips: 48215,
    county_name: "Hidalgo",
    county_weights: {
      48215: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 48215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78520,
    lat: 25.96564,
    lng: -97.55103,
    city: "Brownsville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59388,
    density: 577.1,
    county_fips: 48061,
    county_name: "Cameron",
    county_weights: {
      48061: 100,
    },
    county_names_all: "Cameron",
    county_fips_all: 48061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78521,
    lat: 25.95109,
    lng: -97.32078,
    city: "Brownsville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 89629,
    density: 369.2,
    county_fips: 48061,
    county_name: "Cameron",
    county_weights: {
      48061: 100,
    },
    county_names_all: "Cameron",
    county_fips_all: 48061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78526,
    lat: 25.99587,
    lng: -97.44991,
    city: "Brownsville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50057,
    density: 407.7,
    county_fips: 48061,
    county_name: "Cameron",
    county_weights: {
      48061: 100,
    },
    county_names_all: "Cameron",
    county_fips_all: 48061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78535,
    lat: 26.24948,
    lng: -97.73124,
    city: "Combes",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 732,
    density: 677.4,
    county_fips: 48061,
    county_name: "Cameron",
    county_weights: {
      48061: 100,
    },
    county_names_all: "Cameron",
    county_fips_all: 48061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78536,
    lat: 26.6432,
    lng: -98.44369,
    city: "Delmita",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 340,
    density: 3,
    county_fips: 48427,
    county_name: "Starr",
    county_weights: {
      48215: 1.77,
      48427: 98.23,
    },
    county_names_all: "Starr|Hidalgo",
    county_fips_all: "48427|48215",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78537,
    lat: 26.17322,
    lng: -98.05744,
    city: "Donna",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45120,
    density: 302.5,
    county_fips: 48215,
    county_name: "Hidalgo",
    county_weights: {
      48215: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 48215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78538,
    lat: 26.36812,
    lng: -97.97152,
    city: "Edcouch",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10698,
    density: 61.6,
    county_fips: 48215,
    county_name: "Hidalgo",
    county_weights: {
      48215: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 48215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78539,
    lat: 26.28,
    lng: -98.18311,
    city: "Edinburg",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37411,
    density: 1180.2,
    county_fips: 48215,
    county_name: "Hidalgo",
    county_weights: {
      48215: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 48215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78540,
    lat: 26.54911,
    lng: -97.99164,
    city: "Edinburg",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48215,
    county_name: "Hidalgo",
    county_weights: {
      48215: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 48215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78541,
    lat: 26.4528,
    lng: -98.28632,
    city: "Edinburg",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44740,
    density: 59.5,
    county_fips: 48215,
    county_name: "Hidalgo",
    county_weights: {
      48215: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 48215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78542,
    lat: 26.44412,
    lng: -98.09163,
    city: "Edinburg",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 80837,
    density: 177.4,
    county_fips: 48215,
    county_name: "Hidalgo",
    county_weights: {
      48215: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 48215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78543,
    lat: 26.30117,
    lng: -98.00508,
    city: "Elsa",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10188,
    density: 618.8,
    county_fips: 48215,
    county_name: "Hidalgo",
    county_weights: {
      48215: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 48215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78545,
    lat: 26.591,
    lng: -99.13889,
    city: "Falcon Heights",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 202,
    density: 3.6,
    county_fips: 48505,
    county_name: "Zapata",
    county_weights: {
      48427: 45.84,
      48505: 54.16,
    },
    county_names_all: "Zapata|Starr",
    county_fips_all: "48505|48427",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78547,
    lat: 26.30868,
    lng: -98.69723,
    city: "Garciasville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48427,
    county_name: "Starr",
    county_weights: {
      48427: 100,
    },
    county_names_all: "Starr",
    county_fips_all: 48427,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78548,
    lat: 26.27654,
    lng: -98.65527,
    city: "Grulla",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 583,
    density: 30.1,
    county_fips: 48427,
    county_name: "Starr",
    county_weights: {
      48427: 100,
    },
    county_names_all: "Starr",
    county_fips_all: 48427,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78549,
    lat: 26.48528,
    lng: -98.02329,
    city: "Hargill",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1095,
    density: 16.3,
    county_fips: 48215,
    county_name: "Hidalgo",
    county_weights: {
      48215: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 48215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78550,
    lat: 26.25469,
    lng: -97.66406,
    city: "Harlingen",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52022,
    density: 213.3,
    county_fips: 48061,
    county_name: "Cameron",
    county_weights: {
      48061: 100,
    },
    county_names_all: "Cameron",
    county_fips_all: 48061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78552,
    lat: 26.19664,
    lng: -97.75083,
    city: "Harlingen",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38982,
    density: 313.3,
    county_fips: 48061,
    county_name: "Cameron",
    county_weights: {
      48061: 100,
    },
    county_names_all: "Cameron",
    county_fips_all: 48061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78557,
    lat: 26.10844,
    lng: -98.25118,
    city: "Hidalgo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13984,
    density: 325.4,
    county_fips: 48215,
    county_name: "Hidalgo",
    county_weights: {
      48215: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 48215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78558,
    lat: 26.29276,
    lng: -98.02366,
    city: "La Blanca",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 979,
    density: 490.3,
    county_fips: 48215,
    county_name: "Hidalgo",
    county_weights: {
      48215: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 48215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78559,
    lat: 26.14549,
    lng: -97.82765,
    city: "La Feria",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13733,
    density: 146,
    county_fips: 48061,
    county_name: "Cameron",
    county_weights: {
      48061: 100,
    },
    county_names_all: "Cameron",
    county_fips_all: 48061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78560,
    lat: 26.25545,
    lng: -98.49515,
    city: "La Joya",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4743,
    density: 128.7,
    county_fips: 48215,
    county_name: "Hidalgo",
    county_weights: {
      48215: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 48215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78561,
    lat: 26.4687,
    lng: -97.91595,
    city: "Lasara",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 482,
    density: 176,
    county_fips: 48489,
    county_name: "Willacy",
    county_weights: {
      48489: 100,
    },
    county_names_all: "Willacy",
    county_fips_all: 48489,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78562,
    lat: 26.28809,
    lng: -97.89293,
    city: "La Villa",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3198,
    density: 57.5,
    county_fips: 48215,
    county_name: "Hidalgo",
    county_weights: {
      48215: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 48215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78563,
    lat: 26.66557,
    lng: -98.2517,
    city: "Linn",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 293,
    density: 0.5,
    county_fips: 48215,
    county_name: "Hidalgo",
    county_weights: {
      48215: 99.25,
      48427: 0.75,
    },
    county_names_all: "Hidalgo|Starr",
    county_fips_all: "48215|48427",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78564,
    lat: 26.67801,
    lng: -99.13171,
    city: "Lopeno",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 205,
    density: 4,
    county_fips: 48505,
    county_name: "Zapata",
    county_weights: {
      48505: 100,
    },
    county_names_all: "Zapata",
    county_fips_all: 48505,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78565,
    lat: 26.24453,
    lng: -98.561,
    city: "Los Ebanos",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42,
    density: 5.1,
    county_fips: 48215,
    county_name: "Hidalgo",
    county_weights: {
      48215: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 48215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78566,
    lat: 26.13543,
    lng: -97.42184,
    city: "Los Fresnos",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17999,
    density: 50,
    county_fips: 48061,
    county_name: "Cameron",
    county_weights: {
      48061: 100,
    },
    county_names_all: "Cameron",
    county_fips_all: 48061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78567,
    lat: 26.04607,
    lng: -97.73866,
    city: "Los Indios",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 269,
    density: 74.6,
    county_fips: 48061,
    county_name: "Cameron",
    county_weights: {
      48061: 100,
    },
    county_names_all: "Cameron",
    county_fips_all: 48061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78569,
    lat: 26.37417,
    lng: -97.73851,
    city: "Lyford",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4541,
    density: 11.5,
    county_fips: 48489,
    county_name: "Willacy",
    county_weights: {
      48061: 5.64,
      48215: 14.69,
      48489: 79.67,
    },
    county_names_all: "Willacy|Hidalgo|Cameron",
    county_fips_all: "48489|48215|48061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78570,
    lat: 26.17149,
    lng: -97.9112,
    city: "Mercedes",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32841,
    density: 168.6,
    county_fips: 48215,
    county_name: "Hidalgo",
    county_weights: {
      48215: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 48215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78572,
    lat: 26.19848,
    lng: -98.35633,
    city: "Mission",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 80135,
    density: 576.5,
    county_fips: 48215,
    county_name: "Hidalgo",
    county_weights: {
      48215: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 48215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78573,
    lat: 26.29745,
    lng: -98.30242,
    city: "Mission",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41336,
    density: 435.1,
    county_fips: 48215,
    county_name: "Hidalgo",
    county_weights: {
      48215: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 48215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78574,
    lat: 26.31118,
    lng: -98.37293,
    city: "Mission",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62972,
    density: 468.8,
    county_fips: 48215,
    county_name: "Hidalgo",
    county_weights: {
      48215: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 48215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78575,
    lat: 26.03234,
    lng: -97.55083,
    city: "Olmito",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12249,
    density: 567.9,
    county_fips: 48061,
    county_name: "Cameron",
    county_weights: {
      48061: 100,
    },
    county_names_all: "Cameron",
    county_fips_all: 48061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78576,
    lat: 26.32584,
    lng: -98.46799,
    city: "Penitas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10262,
    density: 68.1,
    county_fips: 48215,
    county_name: "Hidalgo",
    county_weights: {
      48215: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 48215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78577,
    lat: 26.1665,
    lng: -98.19082,
    city: "Pharr",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 78731,
    density: 1169.1,
    county_fips: 48215,
    county_name: "Hidalgo",
    county_weights: {
      48215: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 48215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78578,
    lat: 26.05336,
    lng: -97.31004,
    city: "Port Isabel",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11509,
    density: 78,
    county_fips: 48061,
    county_name: "Cameron",
    county_weights: {
      48061: 100,
    },
    county_names_all: "Cameron",
    county_fips_all: 48061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78579,
    lat: 26.0892,
    lng: -97.94627,
    city: "Progreso",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5562,
    density: 377.1,
    county_fips: 48215,
    county_name: "Hidalgo",
    county_weights: {
      48215: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 48215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78580,
    lat: 26.50065,
    lng: -97.75087,
    city: "Raymondville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14734,
    density: 22.1,
    county_fips: 48489,
    county_name: "Willacy",
    county_weights: {
      48261: 7.95,
      48489: 92.05,
    },
    county_names_all: "Willacy|Kenedy",
    county_fips_all: "48489|48261",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78582,
    lat: 26.53937,
    lng: -98.73985,
    city: "Rio Grande City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44047,
    density: 30.1,
    county_fips: 48427,
    county_name: "Starr",
    county_weights: {
      48427: 100,
    },
    county_names_all: "Starr",
    county_fips_all: 48427,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78583,
    lat: 26.28166,
    lng: -97.4686,
    city: "Rio Hondo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6915,
    density: 28.7,
    county_fips: 48061,
    county_name: "Cameron",
    county_weights: {
      48061: 100,
    },
    county_names_all: "Cameron",
    county_fips_all: 48061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78584,
    lat: 26.56226,
    lng: -98.98471,
    city: "Roma",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18286,
    density: 33.2,
    county_fips: 48427,
    county_name: "Starr",
    county_weights: {
      48427: 100,
    },
    county_names_all: "Starr",
    county_fips_all: 48427,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78585,
    lat: 26.4856,
    lng: -99.07737,
    city: "Salineno",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48427,
    county_name: "Starr",
    county_weights: {
      48427: 100,
    },
    county_names_all: "Starr",
    county_fips_all: 48427,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78586,
    lat: 26.10715,
    lng: -97.64576,
    city: "San Benito",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59360,
    density: 150.3,
    county_fips: 48061,
    county_name: "Cameron",
    county_weights: {
      48061: 100,
    },
    county_names_all: "Cameron",
    county_fips_all: 48061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78588,
    lat: 26.73966,
    lng: -98.39852,
    city: "San Isidro",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 135,
    density: 1.4,
    county_fips: 48427,
    county_name: "Starr",
    county_weights: {
      48215: 0.37,
      48427: 99.63,
    },
    county_names_all: "Starr|Hidalgo",
    county_fips_all: "48427|48215",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78589,
    lat: 26.15349,
    lng: -98.15979,
    city: "San Juan",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41112,
    density: 622.7,
    county_fips: 48215,
    county_name: "Hidalgo",
    county_weights: {
      48215: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 48215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78590,
    lat: 26.50401,
    lng: -97.63486,
    city: "San Perlita",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 298,
    density: 114.9,
    county_fips: 48489,
    county_name: "Willacy",
    county_weights: {
      48489: 100,
    },
    county_names_all: "Willacy",
    county_fips_all: 48489,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78591,
    lat: 26.65351,
    lng: -98.53408,
    city: "Santa Elena",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 260,
    density: 0.6,
    county_fips: 48427,
    county_name: "Starr",
    county_weights: {
      48427: 100,
    },
    county_names_all: "Starr",
    county_fips_all: 48427,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78592,
    lat: 26.06516,
    lng: -97.8461,
    city: "Santa Maria",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 752,
    density: 84,
    county_fips: 48061,
    county_name: "Cameron",
    county_weights: {
      48061: 100,
    },
    county_names_all: "Cameron",
    county_fips_all: 48061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78593,
    lat: 26.26999,
    lng: -97.82187,
    city: "Santa Rosa",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5432,
    density: 54.7,
    county_fips: 48061,
    county_name: "Cameron",
    county_weights: {
      48061: 100,
    },
    county_names_all: "Cameron",
    county_fips_all: 48061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78594,
    lat: 26.34704,
    lng: -97.8037,
    city: "Sebastian",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1538,
    density: 187.4,
    county_fips: 48489,
    county_name: "Willacy",
    county_weights: {
      48489: 100,
    },
    county_names_all: "Willacy",
    county_fips_all: 48489,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78595,
    lat: 26.31457,
    lng: -98.54038,
    city: "Sullivan City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7442,
    density: 94.1,
    county_fips: 48215,
    county_name: "Hidalgo",
    county_weights: {
      48215: 78.38,
      48427: 21.62,
    },
    county_names_all: "Hidalgo|Starr",
    county_fips_all: "48215|48427",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78596,
    lat: 26.10668,
    lng: -97.99856,
    city: "Weslaco",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68984,
    density: 664.1,
    county_fips: 48215,
    county_name: "Hidalgo",
    county_weights: {
      48215: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 48215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78597,
    lat: 26.2474,
    lng: -97.19688,
    city: "South Padre Island",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2798,
    density: 122.3,
    county_fips: 48061,
    county_name: "Cameron",
    county_weights: {
      48061: 100,
    },
    county_names_all: "Cameron",
    county_fips_all: 48061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78598,
    lat: 26.52363,
    lng: -97.42327,
    city: "Port Mansfield",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 127,
    density: 7.7,
    county_fips: 48489,
    county_name: "Willacy",
    county_weights: {
      48489: 100,
    },
    county_names_all: "Willacy",
    county_fips_all: 48489,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78599,
    lat: 26.2181,
    lng: -97.99087,
    city: "Weslaco",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48215,
    county_name: "Hidalgo",
    county_weights: {
      48215: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 48215,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78602,
    lat: 30.12735,
    lng: -97.32801,
    city: "Bastrop",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28536,
    density: 56.4,
    county_fips: 48021,
    county_name: "Bastrop",
    county_weights: {
      48021: 100,
    },
    county_names_all: "Bastrop",
    county_fips_all: 48021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78605,
    lat: 30.77366,
    lng: -98.04663,
    city: "Bertram",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6035,
    density: 13.5,
    county_fips: 48053,
    county_name: "Burnet",
    county_weights: {
      48053: 100,
    },
    county_names_all: "Burnet",
    county_fips_all: 48053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78606,
    lat: 30.09213,
    lng: -98.45789,
    city: "Blanco",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6315,
    density: 10.1,
    county_fips: 48031,
    county_name: "Blanco",
    county_weights: {
      48031: 75.21,
      48091: 3.5,
      48259: 21.29,
    },
    county_names_all: "Blanco|Kendall|Comal",
    county_fips_all: "48031|48259|48091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78607,
    lat: 30.81961,
    lng: -98.488,
    city: "Bluffton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 139,
    density: 2.4,
    county_fips: 48299,
    county_name: "Llano",
    county_weights: {
      48299: 100,
    },
    county_names_all: "Llano",
    county_fips_all: 48299,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78608,
    lat: 30.9341,
    lng: -97.93255,
    city: "Briggs",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 367,
    density: 3.1,
    county_fips: 48053,
    county_name: "Burnet",
    county_weights: {
      48053: 100,
    },
    county_names_all: "Burnet",
    county_fips_all: 48053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78609,
    lat: 30.75975,
    lng: -98.45271,
    city: "Buchanan Dam",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1999,
    density: 48.6,
    county_fips: 48299,
    county_name: "Llano",
    county_weights: {
      48299: 100,
    },
    county_names_all: "Llano",
    county_fips_all: 48299,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78610,
    lat: 30.07962,
    lng: -97.84047,
    city: "Buda",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39498,
    density: 157.4,
    county_fips: 48209,
    county_name: "Hays",
    county_weights: {
      48055: 2.36,
      48209: 71.54,
      48453: 26.1,
    },
    county_names_all: "Hays|Travis|Caldwell",
    county_fips_all: "48209|48453|48055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78611,
    lat: 30.79188,
    lng: -98.26663,
    city: "Burnet",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12454,
    density: 17.5,
    county_fips: 48053,
    county_name: "Burnet",
    county_weights: {
      48053: 97.94,
      48299: 2.06,
    },
    county_names_all: "Burnet|Llano",
    county_fips_all: "48053|48299",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78612,
    lat: 30.09301,
    lng: -97.49017,
    city: "Cedar Creek",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16234,
    density: 63.3,
    county_fips: 48021,
    county_name: "Bastrop",
    county_weights: {
      48021: 98.79,
      48453: 1.21,
    },
    county_names_all: "Bastrop|Travis",
    county_fips_all: "48021|48453",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78613,
    lat: 30.50683,
    lng: -97.81939,
    city: "Cedar Park",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 83876,
    density: 1169.4,
    county_fips: 48491,
    county_name: "Williamson",
    county_weights: {
      48453: 11.33,
      48491: 88.67,
    },
    county_names_all: "Williamson|Travis",
    county_fips_all: "48491|48453",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78614,
    lat: 29.41314,
    lng: -97.59429,
    city: "Cost",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 547,
    density: 3.8,
    county_fips: 48177,
    county_name: "Gonzales",
    county_weights: {
      48177: 100,
    },
    county_names_all: "Gonzales",
    county_fips_all: 48177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78615,
    lat: 30.46426,
    lng: -97.39061,
    city: "Coupland",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1363,
    density: 9.7,
    county_fips: 48491,
    county_name: "Williamson",
    county_weights: {
      48453: 35.78,
      48491: 64.22,
    },
    county_names_all: "Williamson|Travis",
    county_fips_all: "48491|48453",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78616,
    lat: 29.92687,
    lng: -97.55655,
    city: "Dale",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8472,
    density: 27.7,
    county_fips: 48055,
    county_name: "Caldwell",
    county_weights: {
      48021: 17.9,
      48055: 82.1,
    },
    county_names_all: "Caldwell|Bastrop",
    county_fips_all: "48055|48021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78617,
    lat: 30.1508,
    lng: -97.59928,
    city: "Del Valle",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28376,
    density: 171.1,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48021: 21.49,
      48453: 78.51,
    },
    county_names_all: "Travis|Bastrop",
    county_fips_all: "48453|48021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78618,
    lat: 30.48624,
    lng: -99.16794,
    city: "Doss",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 348,
    density: 0.8,
    county_fips: 48171,
    county_name: "Gillespie",
    county_weights: {
      48171: 61.8,
      48319: 38.2,
    },
    county_names_all: "Gillespie|Mason",
    county_fips_all: "48171|48319",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78619,
    lat: 30.11215,
    lng: -98.03101,
    city: "Driftwood",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5840,
    density: 56.5,
    county_fips: 48209,
    county_name: "Hays",
    county_weights: {
      48209: 100,
    },
    county_names_all: "Hays",
    county_fips_all: 48209,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78620,
    lat: 30.22214,
    lng: -98.13491,
    city: "Dripping Springs",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18420,
    density: 40.5,
    county_fips: 48209,
    county_name: "Hays",
    county_weights: {
      48031: 4.99,
      48209: 85.37,
      48453: 9.64,
    },
    county_names_all: "Hays|Travis|Blanco",
    county_fips_all: "48209|48453|48031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78621,
    lat: 30.33737,
    lng: -97.36053,
    city: "Elgin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24590,
    density: 53.4,
    county_fips: 48021,
    county_name: "Bastrop",
    county_weights: {
      48021: 62.57,
      48287: 8.58,
      48453: 14.51,
      48491: 14.34,
    },
    county_names_all: "Bastrop|Travis|Williamson|Lee",
    county_fips_all: "48021|48453|48491|48287",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78622,
    lat: 29.77225,
    lng: -97.78229,
    city: "Fentress",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 238,
    density: 22.6,
    county_fips: 48055,
    county_name: "Caldwell",
    county_weights: {
      48055: 100,
    },
    county_names_all: "Caldwell",
    county_fips_all: 48055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78623,
    lat: 29.95973,
    lng: -98.21933,
    city: "Fischer",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1044,
    density: 18,
    county_fips: 48091,
    county_name: "Comal",
    county_weights: {
      48091: 92.25,
      48209: 7.75,
    },
    county_names_all: "Comal|Hays",
    county_fips_all: "48091|48209",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78624,
    lat: 30.29227,
    lng: -98.87141,
    city: "Fredericksburg",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22751,
    density: 11.8,
    county_fips: 48171,
    county_name: "Gillespie",
    county_weights: {
      48171: 91.34,
      48259: 8.66,
    },
    county_names_all: "Gillespie|Kendall",
    county_fips_all: "48171|48259",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78626,
    lat: 30.66664,
    lng: -97.59878,
    city: "Georgetown",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38537,
    density: 168,
    county_fips: 48491,
    county_name: "Williamson",
    county_weights: {
      48491: 100,
    },
    county_names_all: "Williamson",
    county_fips_all: 48491,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78628,
    lat: 30.63981,
    lng: -97.74636,
    city: "Georgetown",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39529,
    density: 235.9,
    county_fips: 48491,
    county_name: "Williamson",
    county_weights: {
      48491: 100,
    },
    county_names_all: "Williamson",
    county_fips_all: 48491,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78629,
    lat: 29.47762,
    lng: -97.45093,
    city: "Gonzales",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12612,
    density: 11.6,
    county_fips: 48177,
    county_name: "Gonzales",
    county_weights: {
      48123: 1.86,
      48177: 98.14,
    },
    county_names_all: "Gonzales|DeWitt",
    county_fips_all: "48177|48123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78631,
    lat: 30.34576,
    lng: -99.31161,
    city: "Harper",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3157,
    density: 4.1,
    county_fips: 48267,
    county_name: "Kimble",
    county_weights: {
      48171: 44.33,
      48265: 6.9,
      48267: 48.77,
    },
    county_names_all: "Kimble|Gillespie|Kerr",
    county_fips_all: "48267|48171|48265",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78632,
    lat: 29.68866,
    lng: -97.46858,
    city: "Harwood",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1268,
    density: 5.3,
    county_fips: 48177,
    county_name: "Gonzales",
    county_weights: {
      48055: 40.99,
      48177: 59.01,
    },
    county_names_all: "Gonzales|Caldwell",
    county_fips_all: "48177|48055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78633,
    lat: 30.73803,
    lng: -97.75465,
    city: "Georgetown",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26632,
    density: 131,
    county_fips: 48491,
    county_name: "Williamson",
    county_weights: {
      48491: 100,
    },
    county_names_all: "Williamson",
    county_fips_all: 48491,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78634,
    lat: 30.56,
    lng: -97.54404,
    city: "Hutto",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37298,
    density: 255.4,
    county_fips: 48491,
    county_name: "Williamson",
    county_weights: {
      48453: 0.44,
      48491: 99.56,
    },
    county_names_all: "Williamson|Travis",
    county_fips_all: "48491|48453",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78635,
    lat: 30.20824,
    lng: -98.5485,
    city: "Hye",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 609,
    density: 12.1,
    county_fips: 48031,
    county_name: "Blanco",
    county_weights: {
      48031: 100,
    },
    county_names_all: "Blanco",
    county_fips_all: 48031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78636,
    lat: 30.31649,
    lng: -98.42376,
    city: "Johnson City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3307,
    density: 3.6,
    county_fips: 48031,
    county_name: "Blanco",
    county_weights: {
      48031: 100,
    },
    county_names_all: "Blanco",
    county_fips_all: 48031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78638,
    lat: 29.65821,
    lng: -97.79595,
    city: "Kingsbury",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2112,
    density: 6.9,
    county_fips: 48187,
    county_name: "Guadalupe",
    county_weights: {
      48177: 1.66,
      48187: 98.34,
    },
    county_names_all: "Guadalupe|Gonzales",
    county_fips_all: "48187|48177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78639,
    lat: 30.65823,
    lng: -98.45506,
    city: "Kingsland",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8869,
    density: 78,
    county_fips: 48299,
    county_name: "Llano",
    county_weights: {
      48053: 18.18,
      48299: 81.82,
    },
    county_names_all: "Llano|Burnet",
    county_fips_all: "48299|48053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78640,
    lat: 29.99619,
    lng: -97.82355,
    city: "Kyle",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61991,
    density: 267.2,
    county_fips: 48209,
    county_name: "Hays",
    county_weights: {
      48055: 15,
      48209: 83.6,
      48453: 1.4,
    },
    county_names_all: "Hays|Caldwell|Travis",
    county_fips_all: "48209|48055|48453",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78641,
    lat: 30.55851,
    lng: -97.91473,
    city: "Leander",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 78568,
    density: 243.9,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 63.18,
      48491: 36.82,
    },
    county_names_all: "Travis|Williamson",
    county_fips_all: "48453|48491",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78642,
    lat: 30.6946,
    lng: -97.94087,
    city: "Liberty Hill",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13408,
    density: 46.6,
    county_fips: 48491,
    county_name: "Williamson",
    county_weights: {
      48053: 8,
      48491: 92,
    },
    county_names_all: "Williamson|Burnet",
    county_fips_all: "48491|48053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78643,
    lat: 30.68161,
    lng: -98.71281,
    city: "Llano",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6938,
    density: 3.8,
    county_fips: 48299,
    county_name: "Llano",
    county_weights: {
      48299: 100,
    },
    county_names_all: "Llano",
    county_fips_all: 48299,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78644,
    lat: 29.87111,
    lng: -97.67292,
    city: "Lockhart",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17675,
    density: 37.9,
    county_fips: 48055,
    county_name: "Caldwell",
    county_weights: {
      48055: 100,
    },
    county_names_all: "Caldwell",
    county_fips_all: 48055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78645,
    lat: 30.4502,
    lng: -97.96934,
    city: "Leander",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11873,
    density: 141.1,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78648,
    lat: 29.69594,
    lng: -97.63827,
    city: "Luling",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8264,
    density: 24,
    county_fips: 48055,
    county_name: "Caldwell",
    county_weights: {
      48055: 75.57,
      48177: 8.95,
      48187: 15.48,
    },
    county_names_all: "Caldwell|Guadalupe|Gonzales",
    county_fips_all: "48055|48187|48177",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78650,
    lat: 30.30536,
    lng: -97.21574,
    city: "McDade",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2366,
    density: 14.4,
    county_fips: 48021,
    county_name: "Bastrop",
    county_weights: {
      48021: 71.02,
      48287: 28.98,
    },
    county_names_all: "Bastrop|Lee",
    county_fips_all: "48021|48287",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78652,
    lat: 30.13462,
    lng: -97.8606,
    city: "Manchaca",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5763,
    density: 198.7,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48209: 43.53,
      48453: 56.47,
    },
    county_names_all: "Travis|Hays",
    county_fips_all: "48453|48209",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78653,
    lat: 30.33783,
    lng: -97.52006,
    city: "Manor",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29622,
    density: 108.7,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48021: 1.14,
      48453: 98.86,
    },
    county_names_all: "Travis|Bastrop",
    county_fips_all: "48453|48021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78654,
    lat: 30.57112,
    lng: -98.20982,
    city: "Marble Falls",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18524,
    density: 35.5,
    county_fips: 48053,
    county_name: "Burnet",
    county_weights: {
      48053: 80.41,
      48453: 19.59,
    },
    county_names_all: "Burnet|Travis",
    county_fips_all: "48053|48453",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78655,
    lat: 29.82346,
    lng: -97.83517,
    city: "Martindale",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3892,
    density: 52.4,
    county_fips: 48055,
    county_name: "Caldwell",
    county_weights: {
      48055: 59.99,
      48187: 40.01,
    },
    county_names_all: "Caldwell|Guadalupe",
    county_fips_all: "48055|48187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78656,
    lat: 29.90275,
    lng: -97.8089,
    city: "Maxwell",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2590,
    density: 35.2,
    county_fips: 48055,
    county_name: "Caldwell",
    county_weights: {
      48055: 97.04,
      48209: 2.96,
    },
    county_names_all: "Caldwell|Hays",
    county_fips_all: "48055|48209",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78657,
    lat: 30.53328,
    lng: -98.37906,
    city: "Horseshoe Bay",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6509,
    density: 64.8,
    county_fips: 48299,
    county_name: "Llano",
    county_weights: {
      48053: 30.01,
      48299: 69.99,
    },
    county_names_all: "Llano|Burnet",
    county_fips_all: "48299|48053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78658,
    lat: 29.59339,
    lng: -97.62661,
    city: "Ottine",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48177,
    county_name: "Gonzales",
    county_weights: {
      48177: 100,
    },
    county_names_all: "Gonzales",
    county_fips_all: 48177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78659,
    lat: 30.20667,
    lng: -97.12624,
    city: "Paige",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2983,
    density: 9.9,
    county_fips: 48021,
    county_name: "Bastrop",
    county_weights: {
      48021: 79.12,
      48287: 20.88,
    },
    county_names_all: "Bastrop|Lee",
    county_fips_all: "48021|48287",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78660,
    lat: 30.44361,
    lng: -97.59558,
    city: "Pflugerville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 101937,
    density: 882.3,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78661,
    lat: 29.72925,
    lng: -97.74212,
    city: "Prairie Lea",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 272,
    density: 25.5,
    county_fips: 48055,
    county_name: "Caldwell",
    county_weights: {
      48055: 99.54,
      48187: 0.46,
    },
    county_names_all: "Caldwell|Guadalupe",
    county_fips_all: "48055|48187",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78662,
    lat: 29.94316,
    lng: -97.44231,
    city: "Red Rock",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2697,
    density: 15.5,
    county_fips: 48021,
    county_name: "Bastrop",
    county_weights: {
      48021: 81.26,
      48055: 18.74,
    },
    county_names_all: "Bastrop|Caldwell",
    county_fips_all: "48021|48055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78663,
    lat: 30.41582,
    lng: -98.31144,
    city: "Round Mountain",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 782,
    density: 2.8,
    county_fips: 48031,
    county_name: "Blanco",
    county_weights: {
      48031: 93.34,
      48053: 0.94,
      48209: 1.97,
      48453: 3.75,
    },
    county_names_all: "Blanco|Travis|Hays|Burnet",
    county_fips_all: "48031|48453|48209|48053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78664,
    lat: 30.50461,
    lng: -97.64583,
    city: "Round Rock",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63661,
    density: 1479.6,
    county_fips: 48491,
    county_name: "Williamson",
    county_weights: {
      48453: 14.36,
      48491: 85.64,
    },
    county_names_all: "Williamson|Travis",
    county_fips_all: "48491|48453",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78665,
    lat: 30.55038,
    lng: -97.63681,
    city: "Round Rock",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51925,
    density: 832.7,
    county_fips: 48491,
    county_name: "Williamson",
    county_weights: {
      48491: 100,
    },
    county_names_all: "Williamson",
    county_fips_all: 48491,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78666,
    lat: 29.8826,
    lng: -97.97974,
    city: "San Marcos",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 81844,
    density: 164.2,
    county_fips: 48209,
    county_name: "Hays",
    county_weights: {
      48055: 2.02,
      48091: 4.34,
      48187: 15.76,
      48209: 77.88,
    },
    county_names_all: "Hays|Guadalupe|Comal|Caldwell",
    county_fips_all: "48209|48187|48091|48055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78669,
    lat: 30.4347,
    lng: -98.13066,
    city: "Spicewood",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14038,
    density: 44.7,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48031: 17.92,
      48053: 36.18,
      48453: 45.91,
    },
    county_names_all: "Travis|Burnet|Blanco",
    county_fips_all: "48453|48053|48031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78670,
    lat: 29.76267,
    lng: -97.84608,
    city: "Staples",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48187,
    county_name: "Guadalupe",
    county_weights: {
      48187: 100,
    },
    county_names_all: "Guadalupe",
    county_fips_all: 48187,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78671,
    lat: 30.20409,
    lng: -98.63275,
    city: "Stonewall",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 659,
    density: 5.3,
    county_fips: 48171,
    county_name: "Gillespie",
    county_weights: {
      48171: 100,
    },
    county_names_all: "Gillespie",
    county_fips_all: 48171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78672,
    lat: 30.88151,
    lng: -98.49128,
    city: "Tow",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 960,
    density: 12.4,
    county_fips: 48299,
    county_name: "Llano",
    county_weights: {
      48299: 100,
    },
    county_names_all: "Llano",
    county_fips_all: 48299,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78674,
    lat: 30.67213,
    lng: -97.59653,
    city: "Weir",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48491,
    county_name: "Williamson",
    county_weights: {
      48491: 100,
    },
    county_names_all: "Williamson",
    county_fips_all: 48491,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78675,
    lat: 30.4585,
    lng: -98.70534,
    city: "Willow City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 304,
    density: 2.7,
    county_fips: 48171,
    county_name: "Gillespie",
    county_weights: {
      48171: 100,
    },
    county_names_all: "Gillespie",
    county_fips_all: 48171,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78676,
    lat: 30.04141,
    lng: -98.15051,
    city: "Wimberley",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13981,
    density: 32.2,
    county_fips: 48209,
    county_name: "Hays",
    county_weights: {
      48031: 6.6,
      48091: 0.94,
      48209: 92.46,
    },
    county_names_all: "Hays|Blanco|Comal",
    county_fips_all: "48209|48031|48091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78677,
    lat: 29.34174,
    lng: -97.59335,
    city: "Wrightsboro",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19,
    density: 0.4,
    county_fips: 48177,
    county_name: "Gonzales",
    county_weights: {
      48177: 100,
    },
    county_names_all: "Gonzales",
    county_fips_all: 48177,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78681,
    lat: 30.5355,
    lng: -97.71981,
    city: "Round Rock",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58983,
    density: 982.1,
    county_fips: 48491,
    county_name: "Williamson",
    county_weights: {
      48491: 100,
    },
    county_names_all: "Williamson",
    county_fips_all: 48491,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78701,
    lat: 30.27022,
    lng: -97.74248,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11903,
    density: 3047.1,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78702,
    lat: 30.26339,
    lng: -97.7144,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25393,
    density: 1958.5,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78703,
    lat: 30.29385,
    lng: -97.76554,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20297,
    density: 1393.8,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78704,
    lat: 30.24298,
    lng: -97.76537,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51422,
    density: 2265.3,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78705,
    lat: 30.2947,
    lng: -97.739,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33262,
    density: 6204,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78712,
    lat: 30.28393,
    lng: -97.73294,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 887,
    density: 601.2,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78717,
    lat: 30.48988,
    lng: -97.75393,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29463,
    density: 872.1,
    county_fips: 48491,
    county_name: "Williamson",
    county_weights: {
      48491: 100,
    },
    county_names_all: "Williamson",
    county_fips_all: 48491,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78719,
    lat: 30.14465,
    lng: -97.67148,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1803,
    density: 35.2,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78721,
    lat: 30.27127,
    lng: -97.68345,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11054,
    density: 1196.3,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78722,
    lat: 30.29005,
    lng: -97.71458,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6713,
    density: 1912.4,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78723,
    lat: 30.30423,
    lng: -97.68578,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37552,
    density: 2054.1,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78724,
    lat: 30.29474,
    lng: -97.61439,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25328,
    density: 392.1,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78725,
    lat: 30.23554,
    lng: -97.60859,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8303,
    density: 181.4,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78726,
    lat: 30.42898,
    lng: -97.84254,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13304,
    density: 443.4,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78727,
    lat: 30.42894,
    lng: -97.71736,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31856,
    density: 1583.2,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 98.18,
      48491: 1.82,
    },
    county_names_all: "Travis|Williamson",
    county_fips_all: "48453|48491",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78728,
    lat: 30.45537,
    lng: -97.68948,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21857,
    density: 1089.1,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 78.14,
      48491: 21.86,
    },
    county_names_all: "Travis|Williamson",
    county_fips_all: "48453|48491",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78729,
    lat: 30.45738,
    lng: -97.75516,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27707,
    density: 1090.2,
    county_fips: 48491,
    county_name: "Williamson",
    county_weights: {
      48453: 11.67,
      48491: 88.33,
    },
    county_names_all: "Williamson|Travis",
    county_fips_all: "48491|48453",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78730,
    lat: 30.36322,
    lng: -97.83847,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10527,
    density: 269.8,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78731,
    lat: 30.34766,
    lng: -97.7687,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27664,
    density: 1221.3,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78732,
    lat: 30.3802,
    lng: -97.89291,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18535,
    density: 557.4,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78733,
    lat: 30.32338,
    lng: -97.87762,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8711,
    density: 300.3,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78734,
    lat: 30.38079,
    lng: -97.94676,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19711,
    density: 401.9,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78735,
    lat: 30.26634,
    lng: -97.86775,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18211,
    density: 348.2,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78736,
    lat: 30.24833,
    lng: -97.94965,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10010,
    density: 173.4,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48209: 3.28,
      48453: 96.72,
    },
    county_names_all: "Travis|Hays",
    county_fips_all: "48453|48209",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78737,
    lat: 30.18935,
    lng: -97.96059,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20609,
    density: 218.4,
    county_fips: 48209,
    county_name: "Hays",
    county_weights: {
      48209: 71.17,
      48453: 28.83,
    },
    county_names_all: "Hays|Travis",
    county_fips_all: "48209|48453",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78738,
    lat: 30.30668,
    lng: -97.99002,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15090,
    density: 138.4,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78739,
    lat: 30.17596,
    lng: -97.89087,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20631,
    density: 687.4,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48209: 7.73,
      48453: 92.27,
    },
    county_names_all: "Travis|Hays",
    county_fips_all: "48453|48209",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78741,
    lat: 30.23007,
    lng: -97.71389,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47529,
    density: 2356,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78742,
    lat: 30.24375,
    lng: -97.65869,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 888,
    density: 58,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78744,
    lat: 30.18024,
    lng: -97.72888,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48551,
    density: 829.3,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78745,
    lat: 30.20743,
    lng: -97.79822,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63287,
    density: 1778.9,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78746,
    lat: 30.29759,
    lng: -97.81136,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27671,
    density: 466.1,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78747,
    lat: 30.12521,
    lng: -97.74117,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20137,
    density: 349.8,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78748,
    lat: 30.16144,
    lng: -97.8227,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52076,
    density: 1422.6,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78749,
    lat: 30.21329,
    lng: -97.85732,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38503,
    density: 1535.3,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78750,
    lat: 30.41685,
    lng: -97.80223,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33860,
    density: 1108.1,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 78.12,
      48491: 21.88,
    },
    county_names_all: "Travis|Williamson",
    county_fips_all: "48453|48491",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78751,
    lat: 30.3108,
    lng: -97.72278,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16138,
    density: 2579.7,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78752,
    lat: 30.33141,
    lng: -97.70364,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20779,
    density: 2404.3,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78753,
    lat: 30.38353,
    lng: -97.67335,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60035,
    density: 2042.7,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78754,
    lat: 30.35633,
    lng: -97.63925,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26508,
    density: 676.1,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78756,
    lat: 30.32219,
    lng: -97.7402,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9450,
    density: 2184.1,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78757,
    lat: 30.35164,
    lng: -97.73267,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26485,
    density: 2065.3,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78758,
    lat: 30.38768,
    lng: -97.70665,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50575,
    density: 2149,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 100,
    },
    county_names_all: "Travis",
    county_fips_all: 48453,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78759,
    lat: 30.4027,
    lng: -97.76093,
    city: "Austin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45901,
    density: 1243.6,
    county_fips: 48453,
    county_name: "Travis",
    county_weights: {
      48453: 98.83,
      48491: 1.17,
    },
    county_names_all: "Travis|Williamson",
    county_fips_all: "48453|48491",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78801,
    lat: 29.36407,
    lng: -99.88476,
    city: "Uvalde",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22707,
    density: 10.3,
    county_fips: 48463,
    county_name: "Uvalde",
    county_weights: {
      48385: 2.39,
      48463: 97.61,
    },
    county_names_all: "Uvalde|Real",
    county_fips_all: "48463|48385",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78802,
    lat: 29.14481,
    lng: -99.91983,
    city: "Uvalde",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 226,
    density: 13.8,
    county_fips: 48463,
    county_name: "Uvalde",
    county_weights: {
      48463: 100,
    },
    county_names_all: "Uvalde",
    county_fips_all: 48463,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78827,
    lat: 28.42865,
    lng: -99.72393,
    city: "Asherton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1030,
    density: 6.2,
    county_fips: 48127,
    county_name: "Dimmit",
    county_weights: {
      48127: 100,
    },
    county_names_all: "Dimmit",
    county_fips_all: 48127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78828,
    lat: 29.84372,
    lng: -99.99375,
    city: "Barksdale",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 94,
    density: 0.2,
    county_fips: 48385,
    county_name: "Real",
    county_weights: {
      48137: 34.86,
      48385: 65.14,
    },
    county_names_all: "Real|Edwards",
    county_fips_all: "48385|48137",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78829,
    lat: 28.89351,
    lng: -99.57401,
    city: "Batesville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1764,
    density: 1.3,
    county_fips: 48507,
    county_name: "Zavala",
    county_weights: {
      48507: 100,
    },
    county_names_all: "Zavala",
    county_fips_all: 48507,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78830,
    lat: 28.53226,
    lng: -99.48219,
    city: "Big Wells",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 877,
    density: 2.1,
    county_fips: 48127,
    county_name: "Dimmit",
    county_weights: {
      48127: 100,
    },
    county_names_all: "Dimmit",
    county_fips_all: 48127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78832,
    lat: 29.39512,
    lng: -100.4069,
    city: "Brackettville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3674,
    density: 1.3,
    county_fips: 48271,
    county_name: "Kinney",
    county_weights: {
      48271: 100,
    },
    county_names_all: "Kinney",
    county_fips_all: 48271,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78833,
    lat: 29.69785,
    lng: -99.97248,
    city: "Camp Wood",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1526,
    density: 4.3,
    county_fips: 48385,
    county_name: "Real",
    county_weights: {
      48137: 23.87,
      48385: 75.99,
      48463: 0.14,
    },
    county_names_all: "Real|Edwards|Uvalde",
    county_fips_all: "48385|48137|48463",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78834,
    lat: 28.54776,
    lng: -99.87286,
    city: "Carrizo Springs",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8245,
    density: 6.2,
    county_fips: 48127,
    county_name: "Dimmit",
    county_weights: {
      48127: 89.11,
      48507: 10.89,
    },
    county_names_all: "Dimmit|Zavala",
    county_fips_all: "48127|48507",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78836,
    lat: 28.32336,
    lng: -99.64569,
    city: "Catarina",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 80,
    density: 0.4,
    county_fips: 48127,
    county_name: "Dimmit",
    county_weights: {
      48127: 100,
    },
    county_names_all: "Dimmit",
    county_fips_all: 48127,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78837,
    lat: 29.92708,
    lng: -101.28057,
    city: "Comstock",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 212,
    density: 0.1,
    county_fips: 48465,
    county_name: "Val Verde",
    county_weights: {
      48465: 100,
    },
    county_names_all: "Val Verde",
    county_fips_all: 48465,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78838,
    lat: 29.53476,
    lng: -99.70757,
    city: "Concan",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 141,
    density: 0.7,
    county_fips: 48463,
    county_name: "Uvalde",
    county_weights: {
      48463: 100,
    },
    county_names_all: "Uvalde",
    county_fips_all: 48463,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78839,
    lat: 28.71282,
    lng: -99.75516,
    city: "Crystal City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8790,
    density: 13.9,
    county_fips: 48507,
    county_name: "Zavala",
    county_weights: {
      48127: 2.19,
      48507: 97.81,
    },
    county_names_all: "Zavala|Dimmit",
    county_fips_all: "48507|48127",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78840,
    lat: 29.74499,
    lng: -100.92362,
    city: "Del Rio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47993,
    density: 17.7,
    county_fips: 48465,
    county_name: "Val Verde",
    county_weights: {
      48465: 100,
    },
    county_names_all: "Val Verde",
    county_fips_all: 48465,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78841,
    lat: 29.8459,
    lng: -101.4653,
    city: "Del Rio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48465,
    county_name: "Val Verde",
    county_weights: {
      48465: 100,
    },
    county_names_all: "Val Verde",
    county_fips_all: 48465,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78842,
    lat: 29.63677,
    lng: -101.01044,
    city: "Del Rio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48465,
    county_name: "Val Verde",
    county_weights: {
      48465: 100,
    },
    county_names_all: "Val Verde",
    county_fips_all: 48465,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78843,
    lat: 29.34904,
    lng: -100.79188,
    city: "Laughlin Afb",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 713,
    density: 156.2,
    county_fips: 48465,
    county_name: "Val Verde",
    county_weights: {
      48465: 100,
    },
    county_names_all: "Val Verde",
    county_fips_all: 48465,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78850,
    lat: 29.27937,
    lng: -99.33581,
    city: "D Hanis",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1056,
    density: 1.7,
    county_fips: 48325,
    county_name: "Medina",
    county_weights: {
      48325: 100,
    },
    county_names_all: "Medina",
    county_fips_all: 48325,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78851,
    lat: 30.22441,
    lng: -101.91733,
    city: "Dryden",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11,
    density: 0,
    county_fips: 48443,
    county_name: "Terrell",
    county_weights: {
      48443: 100,
    },
    county_names_all: "Terrell",
    county_fips_all: 48443,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78852,
    lat: 28.82698,
    lng: -100.31543,
    city: "Eagle Pass",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57160,
    density: 45.7,
    county_fips: 48323,
    county_name: "Maverick",
    county_weights: {
      48323: 100,
    },
    county_names_all: "Maverick",
    county_fips_all: 48323,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78860,
    lat: 28.38168,
    lng: -100.22962,
    city: "El Indio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 48323,
    county_name: "Maverick",
    county_weights: {
      48323: 100,
    },
    county_names_all: "Maverick",
    county_fips_all: 48323,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78861,
    lat: 29.41778,
    lng: -99.15663,
    city: "Hondo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14318,
    density: 11.3,
    county_fips: 48325,
    county_name: "Medina",
    county_weights: {
      48325: 100,
    },
    county_names_all: "Medina",
    county_fips_all: 48325,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78870,
    lat: 29.29829,
    lng: -99.61255,
    city: "Knippa",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1092,
    density: 3.2,
    county_fips: 48463,
    county_name: "Uvalde",
    county_weights: {
      48463: 100,
    },
    county_names_all: "Uvalde",
    county_fips_all: 48463,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78871,
    lat: 29.90185,
    lng: -101.62018,
    city: "Langtry",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31,
    density: 0.1,
    county_fips: 48465,
    county_name: "Val Verde",
    county_weights: {
      48465: 100,
    },
    county_names_all: "Val Verde",
    county_fips_all: 48465,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78872,
    lat: 28.90751,
    lng: -99.88039,
    city: "La Pryor",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1376,
    density: 3.2,
    county_fips: 48507,
    county_name: "Zavala",
    county_weights: {
      48507: 100,
    },
    county_names_all: "Zavala",
    county_fips_all: 48507,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78873,
    lat: 29.80966,
    lng: -99.73953,
    city: "Leakey",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1839,
    density: 2.3,
    county_fips: 48385,
    county_name: "Real",
    county_weights: {
      48385: 100,
    },
    county_names_all: "Real",
    county_fips_all: 48385,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78877,
    lat: 28.9533,
    lng: -100.60429,
    city: "Quemado",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 938,
    density: 7.6,
    county_fips: 48323,
    county_name: "Maverick",
    county_weights: {
      48323: 100,
    },
    county_names_all: "Maverick",
    county_fips_all: 48323,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78879,
    lat: 29.6435,
    lng: -99.71733,
    city: "Rio Frio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 145,
    density: 2.6,
    county_fips: 48385,
    county_name: "Real",
    county_weights: {
      48385: 76.73,
      48463: 23.27,
    },
    county_names_all: "Real|Uvalde",
    county_fips_all: "48385|48463",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78880,
    lat: 29.96486,
    lng: -100.27779,
    city: "Rocksprings",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1736,
    density: 0.4,
    county_fips: 48137,
    county_name: "Edwards",
    county_weights: {
      48137: 97.17,
      48385: 2.83,
    },
    county_names_all: "Edwards|Real",
    county_fips_all: "48137|48385",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78881,
    lat: 29.39333,
    lng: -99.50972,
    city: "Sabinal",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1601,
    density: 2.4,
    county_fips: 48463,
    county_name: "Uvalde",
    county_weights: {
      48463: 100,
    },
    county_names_all: "Uvalde",
    county_fips_all: 48463,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78883,
    lat: 29.67707,
    lng: -99.31851,
    city: "Tarpley",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 314,
    density: 1.8,
    county_fips: 48019,
    county_name: "Bandera",
    county_weights: {
      48019: 100,
    },
    county_names_all: "Bandera",
    county_fips_all: 48019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78884,
    lat: 29.63823,
    lng: -99.49308,
    city: "Utopia",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1645,
    density: 3.2,
    county_fips: 48019,
    county_name: "Bandera",
    county_weights: {
      48019: 52.68,
      48325: 10.28,
      48463: 37.04,
    },
    county_names_all: "Bandera|Uvalde|Medina",
    county_fips_all: "48019|48463|48325",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78885,
    lat: 29.82682,
    lng: -99.54502,
    city: "Vanderpool",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 124,
    density: 0.6,
    county_fips: 48019,
    county_name: "Bandera",
    county_weights: {
      48019: 100,
    },
    county_names_all: "Bandera",
    county_fips_all: 48019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78886,
    lat: 29.15453,
    lng: -99.18749,
    city: "Yancey",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 490,
    density: 2.6,
    county_fips: 48325,
    county_name: "Medina",
    county_weights: {
      48325: 100,
    },
    county_names_all: "Medina",
    county_fips_all: 48325,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78931,
    lat: 30.03117,
    lng: -96.44291,
    city: "Bleiblerville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 326,
    density: 9.2,
    county_fips: 48015,
    county_name: "Austin",
    county_weights: {
      48015: 100,
    },
    county_names_all: "Austin",
    county_fips_all: 48015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78932,
    lat: 30.1656,
    lng: -96.70793,
    city: "Carmine",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 470,
    density: 3.2,
    county_fips: 48477,
    county_name: "Washington",
    county_weights: {
      48149: 41.37,
      48477: 58.63,
    },
    county_names_all: "Washington|Fayette",
    county_fips_all: "48477|48149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78933,
    lat: 29.77209,
    lng: -96.33829,
    city: "Cat Spring",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1194,
    density: 3.5,
    county_fips: 48089,
    county_name: "Colorado",
    county_weights: {
      48015: 30.67,
      48089: 69.33,
    },
    county_names_all: "Colorado|Austin",
    county_fips_all: "48089|48015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78934,
    lat: 29.7023,
    lng: -96.56741,
    city: "Columbus",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6698,
    density: 11.7,
    county_fips: 48089,
    county_name: "Colorado",
    county_weights: {
      48089: 100,
    },
    county_names_all: "Colorado",
    county_fips_all: 48089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78935,
    lat: 29.68797,
    lng: -96.43006,
    city: "Alleyton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 926,
    density: 5.7,
    county_fips: 48089,
    county_name: "Colorado",
    county_weights: {
      48089: 100,
    },
    county_names_all: "Colorado",
    county_fips_all: 48089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78938,
    lat: 29.82757,
    lng: -96.7041,
    city: "Ellinger",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 314,
    density: 15.5,
    county_fips: 48149,
    county_name: "Fayette",
    county_weights: {
      48149: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 48149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78940,
    lat: 29.93139,
    lng: -96.66701,
    city: "Fayetteville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2370,
    density: 7,
    county_fips: 48149,
    county_name: "Fayette",
    county_weights: {
      48015: 7.73,
      48089: 16.04,
      48149: 76.23,
    },
    county_names_all: "Fayette|Colorado|Austin",
    county_fips_all: "48149|48089|48015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78941,
    lat: 29.74201,
    lng: -97.1561,
    city: "Flatonia",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3046,
    density: 7.3,
    county_fips: 48149,
    county_name: "Fayette",
    county_weights: {
      48021: 5.9,
      48149: 80.77,
      48177: 12.85,
      48285: 0.48,
    },
    county_names_all: "Fayette|Gonzales|Bastrop|Lavaca",
    county_fips_all: "48149|48177|48021|48285",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78942,
    lat: 30.16803,
    lng: -96.93153,
    city: "Giddings",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9565,
    density: 18.2,
    county_fips: 48287,
    county_name: "Lee",
    county_weights: {
      48021: 5.06,
      48149: 7.76,
      48287: 87.18,
    },
    county_names_all: "Lee|Fayette|Bastrop",
    county_fips_all: "48287|48149|48021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78943,
    lat: 29.69721,
    lng: -96.59538,
    city: "Glidden",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 269,
    density: 148.1,
    county_fips: 48089,
    county_name: "Colorado",
    county_weights: {
      48089: 100,
    },
    county_names_all: "Colorado",
    county_fips_all: 48089,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78944,
    lat: 30.00401,
    lng: -96.48945,
    city: "Industry",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 614,
    density: 15.6,
    county_fips: 48015,
    county_name: "Austin",
    county_weights: {
      48015: 100,
    },
    county_names_all: "Austin",
    county_fips_all: 48015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78945,
    lat: 29.91594,
    lng: -96.89031,
    city: "La Grange",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10388,
    density: 16.2,
    county_fips: 48149,
    county_name: "Fayette",
    county_weights: {
      48021: 0.74,
      48149: 99.14,
      48287: 0.12,
    },
    county_names_all: "Fayette|Bastrop|Lee",
    county_fips_all: "48149|48021|48287",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78946,
    lat: 30.18947,
    lng: -96.77412,
    city: "Ledbetter",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1298,
    density: 4.8,
    county_fips: 48287,
    county_name: "Lee",
    county_weights: {
      48149: 33.78,
      48287: 61.91,
      48477: 4.31,
    },
    county_names_all: "Lee|Fayette|Washington",
    county_fips_all: "48287|48149|48477",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78947,
    lat: 30.42378,
    lng: -97.04183,
    city: "Lexington",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4679,
    density: 8.7,
    county_fips: 48287,
    county_name: "Lee",
    county_weights: {
      48287: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 48287,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78948,
    lat: 30.30748,
    lng: -96.97022,
    city: "Lincoln",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 320,
    density: 1.9,
    county_fips: 48287,
    county_name: "Lee",
    county_weights: {
      48287: 100,
    },
    county_names_all: "Lee",
    county_fips_all: 48287,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78949,
    lat: 29.83681,
    lng: -97.08062,
    city: "Muldoon",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 822,
    density: 3.9,
    county_fips: 48149,
    county_name: "Fayette",
    county_weights: {
      48149: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 48149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78950,
    lat: 29.90735,
    lng: -96.48518,
    city: "New Ulm",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1863,
    density: 6.3,
    county_fips: 48015,
    county_name: "Austin",
    county_weights: {
      48015: 69.2,
      48089: 28.26,
      48149: 2.54,
    },
    county_names_all: "Austin|Colorado|Fayette",
    county_fips_all: "48015|48089|48149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78951,
    lat: 29.61361,
    lng: -96.83746,
    city: "Oakland",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 48089,
    county_name: "Colorado",
    county_weights: {
      48089: 99.9,
      48285: 0.1,
    },
    county_names_all: "Colorado|Lavaca",
    county_fips_all: "48089|48285",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78953,
    lat: 29.85552,
    lng: -97.35214,
    city: "Rosanky",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 775,
    density: 2.6,
    county_fips: 48021,
    county_name: "Bastrop",
    county_weights: {
      48021: 65.24,
      48055: 34.76,
    },
    county_names_all: "Bastrop|Caldwell",
    county_fips_all: "48021|48055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78954,
    lat: 30.04507,
    lng: -96.69774,
    city: "Round Top",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1207,
    density: 6.3,
    county_fips: 48149,
    county_name: "Fayette",
    county_weights: {
      48015: 8.21,
      48149: 91.79,
    },
    county_names_all: "Fayette|Austin",
    county_fips_all: "48149|48015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78956,
    lat: 29.68322,
    lng: -96.93454,
    city: "Schulenburg",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5977,
    density: 13.6,
    county_fips: 48149,
    county_name: "Fayette",
    county_weights: {
      48149: 75.02,
      48285: 24.98,
    },
    county_names_all: "Fayette|Lavaca",
    county_fips_all: "48149|48285",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78957,
    lat: 30.01279,
    lng: -97.17481,
    city: "Smithville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9218,
    density: 20.1,
    county_fips: 48021,
    county_name: "Bastrop",
    county_weights: {
      48021: 88.84,
      48149: 11.16,
    },
    county_names_all: "Bastrop|Fayette",
    county_fips_all: "48021|48149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78959,
    lat: 29.69877,
    lng: -97.30153,
    city: "Waelder",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1742,
    density: 4.6,
    county_fips: 48177,
    county_name: "Gonzales",
    county_weights: {
      48021: 1.08,
      48055: 2.66,
      48149: 16.44,
      48177: 79.82,
    },
    county_names_all: "Gonzales|Fayette|Caldwell|Bastrop",
    county_fips_all: "48177|48149|48055|48021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78962,
    lat: 29.66951,
    lng: -96.73815,
    city: "Weimar",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5290,
    density: 11.8,
    county_fips: 48089,
    county_name: "Colorado",
    county_weights: {
      48089: 84.64,
      48149: 15.36,
    },
    county_names_all: "Colorado|Fayette",
    county_fips_all: "48089|48149",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 78963,
    lat: 29.92586,
    lng: -97.02767,
    city: "West Point",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 868,
    density: 7.9,
    county_fips: 48149,
    county_name: "Fayette",
    county_weights: {
      48149: 100,
    },
    county_names_all: "Fayette",
    county_fips_all: 48149,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79001,
    lat: 35.2824,
    lng: -102.8023,
    city: "Adrian",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 174,
    density: 0.1,
    county_fips: 48359,
    county_name: "Oldham",
    county_weights: {
      48117: 34.68,
      48359: 65.32,
    },
    county_names_all: "Oldham|Deaf Smith",
    county_fips_all: "48359|48117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79002,
    lat: 35.19819,
    lng: -100.76956,
    city: "Alanreed",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48179,
    county_name: "Gray",
    county_weights: {
      48129: 0.12,
      48179: 99.88,
    },
    county_names_all: "Gray|Donley",
    county_fips_all: "48179|48129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79003,
    lat: 35.63873,
    lng: -100.0881,
    city: "Allison",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 202,
    density: 1.6,
    county_fips: 48211,
    county_name: "Hemphill",
    county_weights: {
      48211: 74.6,
      48483: 25.4,
    },
    county_names_all: "Hemphill|Wheeler",
    county_fips_all: "48211|48483",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79005,
    lat: 36.3874,
    lng: -100.50627,
    city: "Booker",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1610,
    density: 3.1,
    county_fips: 48295,
    county_name: "Lipscomb",
    county_weights: {
      48295: 73.95,
      48357: 26.05,
    },
    county_names_all: "Lipscomb|Ochiltree",
    county_fips_all: "48295|48357",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79007,
    lat: 35.66635,
    lng: -101.41444,
    city: "Borger",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13936,
    density: 121.1,
    county_fips: 48233,
    county_name: "Hutchinson",
    county_weights: {
      48233: 100,
    },
    county_names_all: "Hutchinson",
    county_fips_all: 48233,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79008,
    lat: 35.69845,
    lng: -101.42383,
    city: "Borger",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48233,
    county_name: "Hutchinson",
    county_weights: {
      48233: 100,
    },
    county_names_all: "Hutchinson",
    county_fips_all: 48233,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79009,
    lat: 34.53016,
    lng: -102.88533,
    city: "Bovina",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1734,
    density: 5.5,
    county_fips: 48369,
    county_name: "Parmer",
    county_weights: {
      48369: 100,
    },
    county_names_all: "Parmer",
    county_fips_all: 48369,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79010,
    lat: 35.45283,
    lng: -102.12013,
    city: "Boys Ranch",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 833,
    density: 2.1,
    county_fips: 48375,
    county_name: "Potter",
    county_weights: {
      48359: 28.7,
      48375: 71.3,
    },
    county_names_all: "Potter|Oldham",
    county_fips_all: "48375|48359",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79011,
    lat: 35.63111,
    lng: -100.20866,
    city: "Briscoe",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 202,
    density: 0.6,
    county_fips: 48483,
    county_name: "Wheeler",
    county_weights: {
      48211: 49.47,
      48483: 50.53,
    },
    county_names_all: "Wheeler|Hemphill",
    county_fips_all: "48483|48211",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79012,
    lat: 35.11701,
    lng: -102.1072,
    city: "Bushland",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48381,
    county_name: "Randall",
    county_weights: {
      48381: 100,
    },
    county_names_all: "Randall",
    county_fips_all: 48381,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79013,
    lat: 36.04183,
    lng: -101.99335,
    city: "Cactus",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3447,
    density: 283.3,
    county_fips: 48341,
    county_name: "Moore",
    county_weights: {
      48341: 100,
    },
    county_names_all: "Moore",
    county_fips_all: 48341,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79014,
    lat: 35.91912,
    lng: -100.32123,
    city: "Canadian",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3844,
    density: 1.6,
    county_fips: 48211,
    county_name: "Hemphill",
    county_weights: {
      48211: 78.21,
      48295: 18.73,
      48393: 3.06,
    },
    county_names_all: "Hemphill|Lipscomb|Roberts",
    county_fips_all: "48211|48295|48393",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79015,
    lat: 34.95259,
    lng: -101.89925,
    city: "Canyon",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22914,
    density: 26.9,
    county_fips: 48381,
    county_name: "Randall",
    county_weights: {
      48381: 100,
    },
    county_names_all: "Randall",
    county_fips_all: 48381,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79016,
    lat: 34.98338,
    lng: -101.9148,
    city: "Canyon",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48381,
    county_name: "Randall",
    county_weights: {
      48381: 100,
    },
    county_names_all: "Randall",
    county_fips_all: 48381,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79018,
    lat: 35.69322,
    lng: -102.33767,
    city: "Channing",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 330,
    density: 0.3,
    county_fips: 48205,
    county_name: "Hartley",
    county_weights: {
      48205: 65.32,
      48341: 19.07,
      48359: 15.61,
    },
    county_names_all: "Hartley|Moore|Oldham",
    county_fips_all: "48205|48341|48359",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79019,
    lat: 34.98099,
    lng: -101.39288,
    city: "Claude",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1890,
    density: 1.3,
    county_fips: 48011,
    county_name: "Armstrong",
    county_weights: {
      48011: 97.05,
      48381: 2.95,
    },
    county_names_all: "Armstrong|Randall",
    county_fips_all: "48011|48381",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79021,
    lat: 33.98366,
    lng: -101.99302,
    city: "Cotton Center",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 147,
    density: 7.7,
    county_fips: 48189,
    county_name: "Hale",
    county_weights: {
      48189: 100,
    },
    county_names_all: "Hale",
    county_fips_all: 48189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79022,
    lat: 36.10004,
    lng: -102.61443,
    city: "Dalhart",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11210,
    density: 2.2,
    county_fips: 48111,
    county_name: "Dallam",
    county_weights: {
      48111: 57.8,
      48205: 42.2,
    },
    county_names_all: "Dallam|Hartley",
    county_fips_all: "48111|48205",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79024,
    lat: 36.43877,
    lng: -100.35188,
    city: "Darrouzett",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 393,
    density: 2.9,
    county_fips: 48295,
    county_name: "Lipscomb",
    county_weights: {
      48295: 100,
    },
    county_names_all: "Lipscomb",
    county_fips_all: 48295,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79025,
    lat: 34.94943,
    lng: -102.20117,
    city: "Dawn",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26,
    density: 0.6,
    county_fips: 48117,
    county_name: "Deaf Smith",
    county_weights: {
      48117: 99.29,
      48381: 0.71,
    },
    county_names_all: "Deaf Smith|Randall",
    county_fips_all: "48117|48381",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79027,
    lat: 34.49238,
    lng: -102.3378,
    city: "Dimmitt",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4873,
    density: 5.4,
    county_fips: 48069,
    county_name: "Castro",
    county_weights: {
      48069: 99.26,
      48279: 0.74,
    },
    county_names_all: "Castro|Lamb",
    county_fips_all: "48069|48279",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79029,
    lat: 35.89513,
    lng: -102.02756,
    city: "Dumas",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15349,
    density: 19.6,
    county_fips: 48341,
    county_name: "Moore",
    county_weights: {
      48205: 2.27,
      48341: 97.73,
    },
    county_names_all: "Moore|Hartley",
    county_fips_all: "48341|48205",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79031,
    lat: 34.24501,
    lng: -102.45225,
    city: "Earth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1360,
    density: 5.1,
    county_fips: 48279,
    county_name: "Lamb",
    county_weights: {
      48069: 6.84,
      48279: 93.16,
    },
    county_names_all: "Lamb|Castro",
    county_fips_all: "48279|48069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79032,
    lat: 34.2878,
    lng: -101.89492,
    city: "Edmonson",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 85,
    density: 4.6,
    county_fips: 48189,
    county_name: "Hale",
    county_weights: {
      48189: 100,
    },
    county_names_all: "Hale",
    county_fips_all: 48189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79033,
    lat: 36.30684,
    lng: -100.97661,
    city: "Farnsworth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49,
    density: 5.7,
    county_fips: 48357,
    county_name: "Ochiltree",
    county_weights: {
      48357: 100,
    },
    county_names_all: "Ochiltree",
    county_fips_all: 48357,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79034,
    lat: 36.37524,
    lng: -100.16581,
    city: "Follett",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 501,
    density: 0.7,
    county_fips: 48295,
    county_name: "Lipscomb",
    county_weights: {
      48295: 100,
    },
    county_names_all: "Lipscomb",
    county_fips_all: 48295,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79035,
    lat: 34.68301,
    lng: -102.78573,
    city: "Friona",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5166,
    density: 3,
    county_fips: 48369,
    county_name: "Parmer",
    county_weights: {
      48117: 30.08,
      48369: 69.92,
    },
    county_names_all: "Parmer|Deaf Smith",
    county_fips_all: "48369|48117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79036,
    lat: 35.59727,
    lng: -101.54826,
    city: "Fritch",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5245,
    density: 25.5,
    county_fips: 48065,
    county_name: "Carson",
    county_weights: {
      48065: 64.26,
      48233: 28.01,
      48341: 3.24,
      48375: 4.49,
    },
    county_names_all: "Carson|Hutchinson|Potter|Moore",
    county_fips_all: "48065|48233|48375|48341",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79039,
    lat: 35.25237,
    lng: -101.12206,
    city: "Groom",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 844,
    density: 1.4,
    county_fips: 48065,
    county_name: "Carson",
    county_weights: {
      48011: 7.36,
      48065: 52.36,
      48129: 5.08,
      48179: 35.2,
    },
    county_names_all: "Carson|Gray|Armstrong|Donley",
    county_fips_all: "48065|48179|48011|48129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79040,
    lat: 36.30113,
    lng: -101.57841,
    city: "Gruver",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2085,
    density: 1.3,
    county_fips: 48195,
    county_name: "Hansford",
    county_weights: {
      48195: 62.99,
      48421: 37.01,
    },
    county_names_all: "Hansford|Sherman",
    county_fips_all: "48195|48421",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79041,
    lat: 34.0376,
    lng: -101.93466,
    city: "Hale Center",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2711,
    density: 3.7,
    county_fips: 48189,
    county_name: "Hale",
    county_weights: {
      48189: 96.14,
      48279: 3.86,
    },
    county_names_all: "Hale|Lamb",
    county_fips_all: "48189|48279",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79042,
    lat: 34.74802,
    lng: -101.89449,
    city: "Happy",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1051,
    density: 0.9,
    county_fips: 48381,
    county_name: "Randall",
    county_weights: {
      48011: 6.68,
      48069: 23.39,
      48381: 47.79,
      48437: 22.14,
    },
    county_names_all: "Randall|Castro|Swisher|Armstrong",
    county_fips_all: "48381|48069|48437|48011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79043,
    lat: 34.36761,
    lng: -102.1374,
    city: "Hart",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1480,
    density: 3.4,
    county_fips: 48069,
    county_name: "Castro",
    county_weights: {
      48069: 81.86,
      48189: 5.5,
      48279: 12.64,
    },
    county_names_all: "Castro|Lamb|Hale",
    county_fips_all: "48069|48279|48189",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79044,
    lat: 35.87456,
    lng: -102.37903,
    city: "Hartley",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 694,
    density: 1.4,
    county_fips: 48205,
    county_name: "Hartley",
    county_weights: {
      48205: 100,
    },
    county_names_all: "Hartley",
    county_fips_all: 48205,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79045,
    lat: 34.89831,
    lng: -102.51228,
    city: "Hereford",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18706,
    density: 6.4,
    county_fips: 48117,
    county_name: "Deaf Smith",
    county_weights: {
      48069: 16.25,
      48117: 83.75,
    },
    county_names_all: "Deaf Smith|Castro",
    county_fips_all: "48117|48069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79046,
    lat: 36.14237,
    lng: -100.10709,
    city: "Higgins",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 757,
    density: 1.6,
    county_fips: 48295,
    county_name: "Lipscomb",
    county_weights: {
      48211: 12.83,
      48295: 87.17,
    },
    county_names_all: "Lipscomb|Hemphill",
    county_fips_all: "48295|48211",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79051,
    lat: 36.45421,
    lng: -102.23423,
    city: "Kerrick",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 48111,
    county_name: "Dallam",
    county_weights: {
      48111: 100,
    },
    county_names_all: "Dallam",
    county_fips_all: 48111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79052,
    lat: 34.35869,
    lng: -101.76276,
    city: "Kress",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1322,
    density: 2.2,
    county_fips: 48437,
    county_name: "Swisher",
    county_weights: {
      48069: 3,
      48189: 8.97,
      48437: 88.03,
    },
    county_names_all: "Swisher|Hale|Castro",
    county_fips_all: "48437|48189|48069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79053,
    lat: 34.40284,
    lng: -102.59106,
    city: "Lazbuddie",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 73,
    density: 1.9,
    county_fips: 48369,
    county_name: "Parmer",
    county_weights: {
      48369: 100,
    },
    county_names_all: "Parmer",
    county_fips_all: 48369,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79054,
    lat: 35.42894,
    lng: -100.78086,
    city: "Lefors",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 584,
    density: 4,
    county_fips: 48179,
    county_name: "Gray",
    county_weights: {
      48179: 100,
    },
    county_names_all: "Gray",
    county_fips_all: 48179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79056,
    lat: 36.21724,
    lng: -100.22139,
    city: "Lipscomb",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60,
    density: 0.6,
    county_fips: 48295,
    county_name: "Lipscomb",
    county_weights: {
      48295: 100,
    },
    county_names_all: "Lipscomb",
    county_fips_all: 48295,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79057,
    lat: 35.20638,
    lng: -100.62157,
    city: "Mclean",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1320,
    density: 1.3,
    county_fips: 48179,
    county_name: "Gray",
    county_weights: {
      48087: 6.25,
      48129: 35.62,
      48179: 44.27,
      48483: 13.86,
    },
    county_names_all: "Gray|Donley|Wheeler|Collingsworth",
    county_fips_all: "48179|48129|48483|48087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79058,
    lat: 35.59509,
    lng: -101.94925,
    city: "Masterson",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 48375,
    county_name: "Potter",
    county_weights: {
      48341: 30.82,
      48375: 69.18,
    },
    county_names_all: "Potter|Moore",
    county_fips_all: "48375|48341",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79059,
    lat: 35.79825,
    lng: -100.73531,
    city: "Miami",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 652,
    density: 0.6,
    county_fips: 48393,
    county_name: "Roberts",
    county_weights: {
      48179: 10.94,
      48393: 89.06,
    },
    county_names_all: "Roberts|Gray",
    county_fips_all: "48393|48179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79061,
    lat: 35.51987,
    lng: -100.45706,
    city: "Mobeetie",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 182,
    density: 0.4,
    county_fips: 48483,
    county_name: "Wheeler",
    county_weights: {
      48179: 9.05,
      48483: 90.95,
    },
    county_names_all: "Wheeler|Gray",
    county_fips_all: "48483|48179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79062,
    lat: 35.99616,
    lng: -101.52733,
    city: "Morse",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 267,
    density: 1,
    county_fips: 48233,
    county_name: "Hutchinson",
    county_weights: {
      48195: 17.34,
      48233: 82.66,
    },
    county_names_all: "Hutchinson|Hansford",
    county_fips_all: "48233|48195",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79063,
    lat: 34.51063,
    lng: -102.115,
    city: "Nazareth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 754,
    density: 3.5,
    county_fips: 48069,
    county_name: "Castro",
    county_weights: {
      48069: 100,
    },
    county_names_all: "Castro",
    county_fips_all: 48069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79064,
    lat: 34.17738,
    lng: -102.12699,
    city: "Olton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2436,
    density: 6.5,
    county_fips: 48279,
    county_name: "Lamb",
    county_weights: {
      48189: 26.43,
      48279: 73.57,
    },
    county_names_all: "Lamb|Hale",
    county_fips_all: "48279|48189",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79065,
    lat: 35.52363,
    lng: -100.90378,
    city: "Pampa",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20148,
    density: 15.4,
    county_fips: 48179,
    county_name: "Gray",
    county_weights: {
      48179: 77.71,
      48393: 22.29,
    },
    county_names_all: "Gray|Roberts",
    county_fips_all: "48179|48393",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79066,
    lat: 35.49929,
    lng: -101.03423,
    city: "Pampa",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48179,
    county_name: "Gray",
    county_weights: {
      48179: 100,
    },
    county_names_all: "Gray",
    county_fips_all: 48179,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79068,
    lat: 35.33633,
    lng: -101.45226,
    city: "Panhandle",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3506,
    density: 3.4,
    county_fips: 48065,
    county_name: "Carson",
    county_weights: {
      48065: 99.09,
      48375: 0.91,
    },
    county_names_all: "Carson|Potter",
    county_fips_all: "48065|48375",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79070,
    lat: 36.25346,
    lng: -100.80731,
    city: "Perryton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9652,
    density: 4.3,
    county_fips: 48357,
    county_name: "Ochiltree",
    county_weights: {
      48295: 1.31,
      48357: 90.18,
      48393: 8.51,
    },
    county_names_all: "Ochiltree|Roberts|Lipscomb",
    county_fips_all: "48357|48393|48295",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79072,
    lat: 34.1719,
    lng: -101.745,
    city: "Plainview",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26404,
    density: 25.8,
    county_fips: 48189,
    county_name: "Hale",
    county_weights: {
      48189: 100,
    },
    county_names_all: "Hale",
    county_fips_all: 48189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79073,
    lat: 33.95608,
    lng: -101.94924,
    city: "Plainview",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48189,
    county_name: "Hale",
    county_weights: {
      48189: 100,
    },
    county_names_all: "Hale",
    county_fips_all: 48189,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79078,
    lat: 35.69856,
    lng: -101.55,
    city: "Sanford",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 175,
    density: 3.1,
    county_fips: 48233,
    county_name: "Hutchinson",
    county_weights: {
      48233: 100,
    },
    county_names_all: "Hutchinson",
    county_fips_all: 48233,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79079,
    lat: 35.20719,
    lng: -100.24884,
    city: "Shamrock",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2570,
    density: 1.7,
    county_fips: 48483,
    county_name: "Wheeler",
    county_weights: {
      48087: 41.22,
      48483: 58.78,
    },
    county_names_all: "Wheeler|Collingsworth",
    county_fips_all: "48483|48087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79080,
    lat: 35.70341,
    lng: -101.21116,
    city: "Skellytown",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 453,
    density: 0.9,
    county_fips: 48233,
    county_name: "Hutchinson",
    county_weights: {
      48065: 13.94,
      48233: 86.06,
    },
    county_names_all: "Hutchinson|Carson",
    county_fips_all: "48233|48065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79081,
    lat: 36.21559,
    lng: -101.21054,
    city: "Spearman",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3546,
    density: 2,
    county_fips: 48195,
    county_name: "Hansford",
    county_weights: {
      48195: 75.03,
      48233: 11.97,
      48357: 8.58,
      48393: 4.42,
    },
    county_names_all: "Hansford|Hutchinson|Ochiltree|Roberts",
    county_fips_all: "48195|48233|48357|48393",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79082,
    lat: 34.21881,
    lng: -102.2862,
    city: "Springlake",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 165,
    density: 0.7,
    county_fips: 48279,
    county_name: "Lamb",
    county_weights: {
      48279: 100,
    },
    county_names_all: "Lamb",
    county_fips_all: 48279,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79083,
    lat: 35.87359,
    lng: -101.51422,
    city: "Stinnett",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2108,
    density: 2.4,
    county_fips: 48233,
    county_name: "Hutchinson",
    county_weights: {
      48233: 71.62,
      48341: 28.38,
    },
    county_names_all: "Hutchinson|Moore",
    county_fips_all: "48233|48341",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79084,
    lat: 36.25502,
    lng: -102.01825,
    city: "Stratford",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2021,
    density: 1.8,
    county_fips: 48421,
    county_name: "Sherman",
    county_weights: {
      48111: 2.71,
      48421: 97.29,
    },
    county_names_all: "Sherman|Dallam",
    county_fips_all: "48421|48111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79085,
    lat: 34.73977,
    lng: -102.50956,
    city: "Summerfield",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26,
    density: 65.1,
    county_fips: 48069,
    county_name: "Castro",
    county_weights: {
      48069: 100,
    },
    county_names_all: "Castro",
    county_fips_all: 48069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79086,
    lat: 36.13538,
    lng: -101.79255,
    city: "Sunray",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2476,
    density: 3,
    county_fips: 48421,
    county_name: "Sherman",
    county_weights: {
      48341: 41.42,
      48421: 58.58,
    },
    county_names_all: "Sherman|Moore",
    county_fips_all: "48421|48341",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79087,
    lat: 36.32788,
    lng: -102.93667,
    city: "Texline",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 637,
    density: 1,
    county_fips: 48111,
    county_name: "Dallam",
    county_weights: {
      48111: 100,
    },
    county_names_all: "Dallam",
    county_fips_all: 48111,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79088,
    lat: 34.57463,
    lng: -101.69315,
    city: "Tulia",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5401,
    density: 3.4,
    county_fips: 48437,
    county_name: "Swisher",
    county_weights: {
      48045: 12.82,
      48069: 1.65,
      48437: 85.53,
    },
    county_names_all: "Swisher|Briscoe|Castro",
    county_fips_all: "48437|48045|48069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79091,
    lat: 34.87053,
    lng: -102.11431,
    city: "Umbarger",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69,
    density: 0.5,
    county_fips: 48381,
    county_name: "Randall",
    county_weights: {
      48381: 100,
    },
    county_names_all: "Randall",
    county_fips_all: 48381,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79092,
    lat: 35.28133,
    lng: -102.48784,
    city: "Vega",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1124,
    density: 1.4,
    county_fips: 48359,
    county_name: "Oldham",
    county_weights: {
      48117: 16.05,
      48359: 83.95,
    },
    county_names_all: "Oldham|Deaf Smith",
    county_fips_all: "48359|48117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79093,
    lat: 36.26637,
    lng: -101.02997,
    city: "Waka",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 101,
    density: 1.8,
    county_fips: 48357,
    county_name: "Ochiltree",
    county_weights: {
      48357: 100,
    },
    county_names_all: "Ochiltree",
    county_fips_all: 48357,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79094,
    lat: 34.84546,
    lng: -101.52493,
    city: "Wayside",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12,
    density: 0,
    county_fips: 48011,
    county_name: "Armstrong",
    county_weights: {
      48011: 100,
    },
    county_names_all: "Armstrong",
    county_fips_all: 48011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79095,
    lat: 34.88485,
    lng: -100.19561,
    city: "Wellington",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2677,
    density: 2.6,
    county_fips: 48087,
    county_name: "Collingsworth",
    county_weights: {
      48075: 3.46,
      48087: 96.54,
    },
    county_names_all: "Collingsworth|Childress",
    county_fips_all: "48087|48075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79096,
    lat: 35.45133,
    lng: -100.1984,
    city: "Wheeler",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2175,
    density: 3.2,
    county_fips: 48483,
    county_name: "Wheeler",
    county_weights: {
      48483: 100,
    },
    county_names_all: "Wheeler",
    county_fips_all: 48483,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79097,
    lat: 35.43104,
    lng: -101.17405,
    city: "White Deer",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1001,
    density: 3,
    county_fips: 48065,
    county_name: "Carson",
    county_weights: {
      48065: 94.85,
      48179: 5.15,
    },
    county_names_all: "Carson|Gray",
    county_fips_all: "48065|48179",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79098,
    lat: 35.15671,
    lng: -102.21646,
    city: "Wildorado",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 365,
    density: 0.8,
    county_fips: 48117,
    county_name: "Deaf Smith",
    county_weights: {
      48117: 46.37,
      48359: 36.42,
      48375: 2.2,
      48381: 15.02,
    },
    county_names_all: "Deaf Smith|Oldham|Randall|Potter",
    county_fips_all: "48117|48359|48381|48375",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79101,
    lat: 35.20605,
    lng: -101.83946,
    city: "Amarillo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2271,
    density: 548.9,
    county_fips: 48375,
    county_name: "Potter",
    county_weights: {
      48375: 100,
    },
    county_names_all: "Potter",
    county_fips_all: 48375,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79102,
    lat: 35.19948,
    lng: -101.84661,
    city: "Amarillo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10245,
    density: 1451.6,
    county_fips: 48375,
    county_name: "Potter",
    county_weights: {
      48375: 100,
    },
    county_names_all: "Potter",
    county_fips_all: 48375,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79103,
    lat: 35.18297,
    lng: -101.7999,
    city: "Amarillo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10529,
    density: 951.2,
    county_fips: 48375,
    county_name: "Potter",
    county_weights: {
      48375: 50.04,
      48381: 49.96,
    },
    county_names_all: "Potter|Randall",
    county_fips_all: "48375|48381",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79104,
    lat: 35.2011,
    lng: -101.79017,
    city: "Amarillo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6861,
    density: 872.6,
    county_fips: 48375,
    county_name: "Potter",
    county_weights: {
      48375: 100,
    },
    county_names_all: "Potter",
    county_fips_all: 48375,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79106,
    lat: 35.20369,
    lng: -101.89178,
    city: "Amarillo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28289,
    density: 1271.5,
    county_fips: 48375,
    county_name: "Potter",
    county_weights: {
      48375: 90.3,
      48381: 9.7,
    },
    county_names_all: "Potter|Randall",
    county_fips_all: "48375|48381",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79107,
    lat: 35.23119,
    lng: -101.7946,
    city: "Amarillo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34204,
    density: 672.8,
    county_fips: 48375,
    county_name: "Potter",
    county_weights: {
      48375: 100,
    },
    county_names_all: "Potter",
    county_fips_all: 48375,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79108,
    lat: 35.37511,
    lng: -101.80307,
    city: "Amarillo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14580,
    density: 30.7,
    county_fips: 48375,
    county_name: "Potter",
    county_weights: {
      48065: 1.25,
      48375: 98.75,
    },
    county_names_all: "Potter|Carson",
    county_fips_all: "48375|48065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79109,
    lat: 35.1665,
    lng: -101.88633,
    city: "Amarillo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43652,
    density: 1634.4,
    county_fips: 48381,
    county_name: "Randall",
    county_weights: {
      48375: 20.95,
      48381: 79.05,
    },
    county_names_all: "Randall|Potter",
    county_fips_all: "48381|48375",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79110,
    lat: 35.14946,
    lng: -101.87109,
    city: "Amarillo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19729,
    density: 1401,
    county_fips: 48381,
    county_name: "Randall",
    county_weights: {
      48381: 100,
    },
    county_names_all: "Randall",
    county_fips_all: 48381,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79111,
    lat: 35.21934,
    lng: -101.68957,
    city: "Amarillo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2140,
    density: 73.8,
    county_fips: 48375,
    county_name: "Potter",
    county_weights: {
      48375: 100,
    },
    county_names_all: "Potter",
    county_fips_all: 48375,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79118,
    lat: 35.10103,
    lng: -101.74863,
    city: "Amarillo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23668,
    density: 57.3,
    county_fips: 48381,
    county_name: "Randall",
    county_weights: {
      48011: 0.47,
      48375: 6.58,
      48381: 92.95,
    },
    county_names_all: "Randall|Potter|Armstrong",
    county_fips_all: "48381|48375|48011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79119,
    lat: 35.10876,
    lng: -102.01968,
    city: "Amarillo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18510,
    density: 71.8,
    county_fips: 48381,
    county_name: "Randall",
    county_weights: {
      48381: 100,
    },
    county_names_all: "Randall",
    county_fips_all: 48381,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79121,
    lat: 35.17447,
    lng: -101.92922,
    city: "Amarillo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5684,
    density: 1251.9,
    county_fips: 48381,
    county_name: "Randall",
    county_weights: {
      48375: 16.1,
      48381: 83.9,
    },
    county_names_all: "Randall|Potter",
    county_fips_all: "48381|48375",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79124,
    lat: 35.26891,
    lng: -102.02705,
    city: "Amarillo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8159,
    density: 17.4,
    county_fips: 48375,
    county_name: "Potter",
    county_weights: {
      48375: 97.45,
      48381: 2.55,
    },
    county_names_all: "Potter|Randall",
    county_fips_all: "48375|48381",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79201,
    lat: 34.4101,
    lng: -100.33521,
    city: "Childress",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7227,
    density: 3.2,
    county_fips: 48075,
    county_name: "Childress",
    county_weights: {
      48075: 54.67,
      48101: 18.37,
      48191: 16.4,
      48345: 10.56,
    },
    county_names_all: "Childress|Cottle|Hall|Motley",
    county_fips_all: "48075|48101|48191|48345",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79220,
    lat: 33.7658,
    lng: -100.76614,
    city: "Afton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 271,
    density: 0.9,
    county_fips: 48125,
    county_name: "Dickens",
    county_weights: {
      48125: 100,
    },
    county_names_all: "Dickens",
    county_fips_all: 48125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79223,
    lat: 34.2317,
    lng: -100.48085,
    city: "Cee Vee",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48101,
    county_name: "Cottle",
    county_weights: {
      48101: 100,
    },
    county_names_all: "Cottle",
    county_fips_all: 48101,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79225,
    lat: 34.25058,
    lng: -99.50831,
    city: "Chillicothe",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1002,
    density: 2.2,
    county_fips: 48197,
    county_name: "Hardeman",
    county_weights: {
      48197: 77.02,
      48487: 22.98,
    },
    county_names_all: "Hardeman|Wilbarger",
    county_fips_all: "48197|48487",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79226,
    lat: 34.91965,
    lng: -100.99229,
    city: "Clarendon",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2767,
    density: 1.3,
    county_fips: 48129,
    county_name: "Donley",
    county_weights: {
      48011: 23.91,
      48045: 13.71,
      48129: 60.37,
      48191: 2.01,
    },
    county_names_all: "Donley|Armstrong|Briscoe|Hall",
    county_fips_all: "48129|48011|48045|48191",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79227,
    lat: 33.87702,
    lng: -99.74893,
    city: "Crowell",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1260,
    density: 0.6,
    county_fips: 48155,
    county_name: "Foard",
    county_weights: {
      48155: 66.13,
      48275: 33.87,
    },
    county_names_all: "Foard|Knox",
    county_fips_all: "48155|48275",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79229,
    lat: 33.67379,
    lng: -100.744,
    city: "Dickens",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 451,
    density: 0.8,
    county_fips: 48125,
    county_name: "Dickens",
    county_weights: {
      48125: 100,
    },
    county_names_all: "Dickens",
    county_fips_all: 48125,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79230,
    lat: 34.71353,
    lng: -100.04878,
    city: "Dodson",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 156,
    density: 0.8,
    county_fips: 48075,
    county_name: "Childress",
    county_weights: {
      48075: 66.8,
      48087: 33.2,
    },
    county_names_all: "Childress|Collingsworth",
    county_fips_all: "48075|48087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79231,
    lat: 33.94164,
    lng: -101.06579,
    city: "Dougherty",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 112,
    density: 4,
    county_fips: 48153,
    county_name: "Floyd",
    county_weights: {
      48153: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 48153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79233,
    lat: 34.50195,
    lng: -100.49165,
    city: "Estelline",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 130,
    density: 0.7,
    county_fips: 48191,
    county_name: "Hall",
    county_weights: {
      48191: 100,
    },
    county_names_all: "Hall",
    county_fips_all: 48191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79234,
    lat: 34.22108,
    lng: -100.95509,
    city: "Flomot",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42,
    density: 0.1,
    county_fips: 48345,
    county_name: "Motley",
    county_weights: {
      48153: 18.48,
      48345: 81.52,
    },
    county_names_all: "Motley|Floyd",
    county_fips_all: "48345|48153",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79235,
    lat: 33.94794,
    lng: -101.26088,
    city: "Floydada",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3335,
    density: 2.6,
    county_fips: 48153,
    county_name: "Floyd",
    county_weights: {
      48107: 8.4,
      48153: 88.1,
      48345: 3.5,
    },
    county_names_all: "Floyd|Crosby|Motley",
    county_fips_all: "48153|48107|48345",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79236,
    lat: 33.5992,
    lng: -100.28095,
    city: "Guthrie",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 265,
    density: 0.4,
    county_fips: 48269,
    county_name: "King",
    county_weights: {
      48125: 0.22,
      48269: 99.78,
    },
    county_names_all: "King|Dickens",
    county_fips_all: "48269|48125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79237,
    lat: 34.85566,
    lng: -100.66588,
    city: "Hedley",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 454,
    density: 0.9,
    county_fips: 48129,
    county_name: "Donley",
    county_weights: {
      48129: 100,
    },
    county_names_all: "Donley",
    county_fips_all: 48129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79239,
    lat: 34.64837,
    lng: -100.77015,
    city: "Lakeview",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 161,
    density: 0.3,
    county_fips: 48191,
    county_name: "Hall",
    county_weights: {
      48191: 100,
    },
    county_names_all: "Hall",
    county_fips_all: 48191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79240,
    lat: 34.8836,
    lng: -100.76797,
    city: "Lelia Lake",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 97,
    density: 4.4,
    county_fips: 48129,
    county_name: "Donley",
    county_weights: {
      48129: 100,
    },
    county_names_all: "Donley",
    county_fips_all: 48129,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79241,
    lat: 34.18069,
    lng: -101.38507,
    city: "Lockney",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2166,
    density: 2.2,
    county_fips: 48153,
    county_name: "Floyd",
    county_weights: {
      48153: 99.3,
      48437: 0.7,
    },
    county_names_all: "Floyd|Swisher",
    county_fips_all: "48153|48437",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79243,
    lat: 33.76426,
    lng: -101.02557,
    city: "Mcadoo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58,
    density: 0.3,
    county_fips: 48125,
    county_name: "Dickens",
    county_weights: {
      48107: 34.36,
      48125: 65.64,
    },
    county_names_all: "Dickens|Crosby",
    county_fips_all: "48125|48107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79244,
    lat: 34.0383,
    lng: -100.8059,
    city: "Matador",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 894,
    density: 1.5,
    county_fips: 48345,
    county_name: "Motley",
    county_weights: {
      48345: 100,
    },
    county_names_all: "Motley",
    county_fips_all: 48345,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79245,
    lat: 34.68001,
    lng: -100.47552,
    city: "Memphis",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2339,
    density: 3.2,
    county_fips: 48191,
    county_name: "Hall",
    county_weights: {
      48075: 32.79,
      48087: 12.59,
      48129: 4.2,
      48191: 50.42,
    },
    county_names_all: "Hall|Childress|Collingsworth|Donley",
    county_fips_all: "48191|48075|48087|48129",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79247,
    lat: 34.39704,
    lng: -99.3807,
    city: "Odell",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48487,
    county_name: "Wilbarger",
    county_weights: {
      48487: 100,
    },
    county_names_all: "Wilbarger",
    county_fips_all: 48487,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79248,
    lat: 33.94146,
    lng: -100.22159,
    city: "Paducah",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1595,
    density: 0.7,
    county_fips: 48101,
    county_name: "Cottle",
    county_weights: {
      48101: 65.42,
      48125: 2.72,
      48155: 10.69,
      48269: 21.16,
    },
    county_names_all: "Cottle|King|Foard|Dickens",
    county_fips_all: "48101|48269|48155|48125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79250,
    lat: 33.88134,
    lng: -101.59881,
    city: "Petersburg",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1438,
    density: 3.4,
    county_fips: 48189,
    county_name: "Hale",
    county_weights: {
      48107: 11.36,
      48153: 19,
      48189: 58.05,
      48303: 11.59,
    },
    county_names_all: "Hale|Floyd|Lubbock|Crosby",
    county_fips_all: "48189|48153|48303|48107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79251,
    lat: 34.96174,
    lng: -100.45441,
    city: "Quail",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29,
    density: 0.2,
    county_fips: 48087,
    county_name: "Collingsworth",
    county_weights: {
      48087: 100,
    },
    county_names_all: "Collingsworth",
    county_fips_all: 48087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79252,
    lat: 34.31001,
    lng: -99.80874,
    city: "Quanah",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3017,
    density: 2.2,
    county_fips: 48197,
    county_name: "Hardeman",
    county_weights: {
      48101: 3.23,
      48197: 96.77,
    },
    county_names_all: "Hardeman|Cottle",
    county_fips_all: "48197|48101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79255,
    lat: 34.36113,
    lng: -101.04924,
    city: "Quitaque",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 480,
    density: 1.1,
    county_fips: 48045,
    county_name: "Briscoe",
    county_weights: {
      48045: 72.06,
      48153: 22.54,
      48345: 5.4,
    },
    county_names_all: "Briscoe|Floyd|Motley",
    county_fips_all: "48045|48153|48345",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79256,
    lat: 33.87463,
    lng: -100.82078,
    city: "Roaring Springs",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 359,
    density: 0.6,
    county_fips: 48345,
    county_name: "Motley",
    county_weights: {
      48125: 16.09,
      48345: 83.91,
    },
    county_names_all: "Motley|Dickens",
    county_fips_all: "48345|48125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79257,
    lat: 34.44868,
    lng: -101.2995,
    city: "Silverton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 903,
    density: 0.9,
    county_fips: 48045,
    county_name: "Briscoe",
    county_weights: {
      48045: 97.38,
      48437: 2.62,
    },
    county_names_all: "Briscoe|Swisher",
    county_fips_all: "48045|48437",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79258,
    lat: 34.24344,
    lng: -101.29647,
    city: "South Plains",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60,
    density: 1.2,
    county_fips: 48153,
    county_name: "Floyd",
    county_weights: {
      48153: 100,
    },
    county_names_all: "Floyd",
    county_fips_all: 48153,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79259,
    lat: 34.36243,
    lng: -100.45594,
    city: "Tell",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46,
    density: 0.3,
    county_fips: 48191,
    county_name: "Hall",
    county_weights: {
      48075: 22.59,
      48191: 77.41,
    },
    county_names_all: "Hall|Childress",
    county_fips_all: "48191|48075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79261,
    lat: 34.45525,
    lng: -100.86876,
    city: "Turkey",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 370,
    density: 0.8,
    county_fips: 48191,
    county_name: "Hall",
    county_weights: {
      48191: 100,
    },
    county_names_all: "Hall",
    county_fips_all: 48191,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79311,
    lat: 33.85781,
    lng: -101.88228,
    city: "Abernathy",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3777,
    density: 7.6,
    county_fips: 48189,
    county_name: "Hale",
    county_weights: {
      48189: 73.94,
      48303: 26.06,
    },
    county_names_all: "Hale|Lubbock",
    county_fips_all: "48189|48303",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79312,
    lat: 34.06218,
    lng: -102.36794,
    city: "Amherst",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1127,
    density: 4.1,
    county_fips: 48279,
    county_name: "Lamb",
    county_weights: {
      48279: 100,
    },
    county_names_all: "Lamb",
    county_fips_all: 48279,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79313,
    lat: 33.8126,
    lng: -102.16093,
    city: "Anton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1505,
    density: 4,
    county_fips: 48219,
    county_name: "Hockley",
    county_weights: {
      48219: 56.23,
      48279: 42.89,
      48303: 0.88,
    },
    county_names_all: "Hockley|Lamb|Lubbock",
    county_fips_all: "48219|48279|48303",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79314,
    lat: 33.63016,
    lng: -103.03051,
    city: "Bledsoe",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 109,
    density: 2.9,
    county_fips: 48079,
    county_name: "Cochran",
    county_weights: {
      48079: 100,
    },
    county_names_all: "Cochran",
    county_fips_all: 48079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79316,
    lat: 33.13478,
    lng: -102.3058,
    city: "Brownfield",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10772,
    density: 8.8,
    county_fips: 48445,
    county_name: "Terry",
    county_weights: {
      48445: 100,
    },
    county_names_all: "Terry",
    county_fips_all: 48445,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79322,
    lat: 33.65887,
    lng: -101.19814,
    city: "Crosbyton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2032,
    density: 3,
    county_fips: 48107,
    county_name: "Crosby",
    county_weights: {
      48107: 100,
    },
    county_names_all: "Crosby",
    county_fips_all: 48107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79323,
    lat: 32.94678,
    lng: -102.89674,
    city: "Denver City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7347,
    density: 14.8,
    county_fips: 48165,
    county_name: "Gaines",
    county_weights: {
      48165: 57.86,
      48501: 42.14,
    },
    county_names_all: "Gaines|Yoakum",
    county_fips_all: "48165|48501",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79324,
    lat: 33.88759,
    lng: -102.73534,
    city: "Enochs",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58,
    density: 0.4,
    county_fips: 48017,
    county_name: "Bailey",
    county_weights: {
      48017: 99.43,
      48279: 0.57,
    },
    county_names_all: "Bailey|Lamb",
    county_fips_all: "48017|48279",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79325,
    lat: 34.40798,
    lng: -102.93821,
    city: "Farwell",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2327,
    density: 5,
    county_fips: 48369,
    county_name: "Parmer",
    county_weights: {
      48017: 4.42,
      48369: 95.58,
    },
    county_names_all: "Parmer|Bailey",
    county_fips_all: "48369|48017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79326,
    lat: 34.09913,
    lng: -102.21433,
    city: "Fieldton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63,
    density: 1.2,
    county_fips: 48279,
    county_name: "Lamb",
    county_weights: {
      48279: 100,
    },
    county_names_all: "Lamb",
    county_fips_all: 48279,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79329,
    lat: 33.72503,
    lng: -101.68807,
    city: "Idalou",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2891,
    density: 13.4,
    county_fips: 48303,
    county_name: "Lubbock",
    county_weights: {
      48303: 100,
    },
    county_names_all: "Lubbock",
    county_fips_all: 48303,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79330,
    lat: 33.03072,
    lng: -101.21727,
    city: "Justiceburg",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 70,
    density: 0.2,
    county_fips: 48169,
    county_name: "Garza",
    county_weights: {
      48169: 100,
    },
    county_names_all: "Garza",
    county_fips_all: 48169,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79331,
    lat: 32.66775,
    lng: -101.97488,
    city: "Lamesa",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12309,
    density: 6,
    county_fips: 48115,
    county_name: "Dawson",
    county_weights: {
      48033: 4.1,
      48115: 77.58,
      48165: 3,
      48317: 15.32,
    },
    county_names_all: "Dawson|Martin|Borden|Gaines",
    county_fips_all: "48115|48317|48033|48165",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79336,
    lat: 33.59962,
    lng: -102.40214,
    city: "Levelland",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16827,
    density: 13.5,
    county_fips: 48219,
    county_name: "Hockley",
    county_weights: {
      48079: 2.44,
      48219: 97.56,
    },
    county_names_all: "Hockley|Cochran",
    county_fips_all: "48219|48079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79339,
    lat: 33.87938,
    lng: -102.34682,
    city: "Littlefield",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6591,
    density: 7.6,
    county_fips: 48279,
    county_name: "Lamb",
    county_weights: {
      48219: 28.98,
      48279: 71.02,
    },
    county_names_all: "Lamb|Hockley",
    county_fips_all: "48279|48219",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79342,
    lat: 32.90313,
    lng: -102.33188,
    city: "Loop",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 479,
    density: 1.8,
    county_fips: 48165,
    county_name: "Gaines",
    county_weights: {
      48165: 100,
    },
    county_names_all: "Gaines",
    county_fips_all: 48165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79343,
    lat: 33.65096,
    lng: -101.54459,
    city: "Lorenzo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1695,
    density: 5.1,
    county_fips: 48107,
    county_name: "Crosby",
    county_weights: {
      48107: 63.82,
      48303: 36.18,
    },
    county_names_all: "Crosby|Lubbock",
    county_fips_all: "48107|48303",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79344,
    lat: 33.85677,
    lng: -103.0143,
    city: "Maple",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48017,
    county_name: "Bailey",
    county_weights: {
      48017: 100,
    },
    county_names_all: "Bailey",
    county_fips_all: 48017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79345,
    lat: 33.33611,
    lng: -102.32789,
    city: "Meadow",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1248,
    density: 2.6,
    county_fips: 48445,
    county_name: "Terry",
    county_weights: {
      48305: 5.68,
      48445: 94.32,
    },
    county_names_all: "Terry|Lynn",
    county_fips_all: "48445|48305",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79346,
    lat: 33.64805,
    lng: -102.82309,
    city: "Morton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2198,
    density: 1.8,
    county_fips: 48079,
    county_name: "Cochran",
    county_weights: {
      48017: 6.41,
      48079: 93.59,
    },
    county_names_all: "Cochran|Bailey",
    county_fips_all: "48079|48017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79347,
    lat: 34.18804,
    lng: -102.79682,
    city: "Muleshoe",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6954,
    density: 3.9,
    county_fips: 48017,
    county_name: "Bailey",
    county_weights: {
      48017: 77.81,
      48069: 2.81,
      48279: 4.11,
      48369: 15.27,
    },
    county_names_all: "Bailey|Parmer|Lamb|Castro",
    county_fips_all: "48017|48369|48279|48069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79350,
    lat: 33.73115,
    lng: -101.82296,
    city: "New Deal",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 428,
    density: 68.8,
    county_fips: 48303,
    county_name: "Lubbock",
    county_weights: {
      48303: 100,
    },
    county_names_all: "Lubbock",
    county_fips_all: 48303,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79351,
    lat: 32.93191,
    lng: -101.78581,
    city: "Odonnell",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1478,
    density: 1.9,
    county_fips: 48115,
    county_name: "Dawson",
    county_weights: {
      48033: 31.07,
      48115: 37.04,
      48305: 31.89,
    },
    county_names_all: "Dawson|Lynn|Borden",
    county_fips_all: "48115|48305|48033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79353,
    lat: 33.78723,
    lng: -102.58723,
    city: "Pep",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11,
    density: 0.3,
    county_fips: 48219,
    county_name: "Hockley",
    county_weights: {
      48219: 100,
    },
    county_names_all: "Hockley",
    county_fips_all: 48219,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79355,
    lat: 33.16605,
    lng: -102.89485,
    city: "Plains",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1926,
    density: 1.8,
    county_fips: 48501,
    county_name: "Yoakum",
    county_weights: {
      48501: 100,
    },
    county_names_all: "Yoakum",
    county_fips_all: 48501,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79356,
    lat: 33.2562,
    lng: -101.33245,
    city: "Post",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5931,
    density: 2.8,
    county_fips: 48169,
    county_name: "Garza",
    county_weights: {
      48107: 15.42,
      48169: 75.82,
      48305: 8.76,
    },
    county_names_all: "Garza|Crosby|Lynn",
    county_fips_all: "48169|48107|48305",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79357,
    lat: 33.64659,
    lng: -101.40577,
    city: "Ralls",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2071,
    density: 3.3,
    county_fips: 48107,
    county_name: "Crosby",
    county_weights: {
      48107: 100,
    },
    county_names_all: "Crosby",
    county_fips_all: 48107,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79358,
    lat: 33.4321,
    lng: -102.20017,
    city: "Ropesville",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1306,
    density: 4,
    county_fips: 48219,
    county_name: "Hockley",
    county_weights: {
      48219: 86.46,
      48303: 8.49,
      48445: 5.05,
    },
    county_names_all: "Hockley|Lubbock|Terry",
    county_fips_all: "48219|48303|48445",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79359,
    lat: 32.92872,
    lng: -102.54718,
    city: "Seagraves",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3129,
    density: 3.6,
    county_fips: 48165,
    county_name: "Gaines",
    county_weights: {
      48165: 60.91,
      48445: 13.76,
      48501: 25.33,
    },
    county_names_all: "Gaines|Yoakum|Terry",
    county_fips_all: "48165|48501|48445",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79360,
    lat: 32.69018,
    lng: -102.72482,
    city: "Seminole",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16760,
    density: 7,
    county_fips: 48165,
    county_name: "Gaines",
    county_weights: {
      48165: 100,
    },
    county_names_all: "Gaines",
    county_fips_all: 48165,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79363,
    lat: 33.70769,
    lng: -102.03804,
    city: "Shallowater",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5374,
    density: 19.2,
    county_fips: 48303,
    county_name: "Lubbock",
    county_weights: {
      48219: 16.18,
      48303: 83.82,
    },
    county_names_all: "Lubbock|Hockley",
    county_fips_all: "48303|48219",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79364,
    lat: 33.44681,
    lng: -101.6355,
    city: "Slaton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7161,
    density: 13.1,
    county_fips: 48303,
    county_name: "Lubbock",
    county_weights: {
      48107: 5.3,
      48169: 8.92,
      48303: 68.79,
      48305: 16.99,
    },
    county_names_all: "Lubbock|Lynn|Garza|Crosby",
    county_fips_all: "48303|48305|48169|48107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79366,
    lat: 33.53016,
    lng: -101.68367,
    city: "Ransom Canyon",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 903,
    density: 429.5,
    county_fips: 48303,
    county_name: "Lubbock",
    county_weights: {
      48303: 100,
    },
    county_names_all: "Lubbock",
    county_fips_all: 48303,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79367,
    lat: 33.58938,
    lng: -102.16805,
    city: "Smyer",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 667,
    density: 33,
    county_fips: 48219,
    county_name: "Hockley",
    county_weights: {
      48219: 100,
    },
    county_names_all: "Hockley",
    county_fips_all: 48219,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79369,
    lat: 33.94322,
    lng: -102.15916,
    city: "Spade",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69,
    density: 4.2,
    county_fips: 48279,
    county_name: "Lamb",
    county_weights: {
      48279: 100,
    },
    county_names_all: "Lamb",
    county_fips_all: 48279,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79370,
    lat: 33.4638,
    lng: -100.92328,
    city: "Spur",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1483,
    density: 1.1,
    county_fips: 48125,
    county_name: "Dickens",
    county_weights: {
      48107: 14.16,
      48125: 61.94,
      48169: 4.54,
      48263: 19.36,
    },
    county_names_all: "Dickens|Kent|Crosby|Garza",
    county_fips_all: "48125|48263|48107|48169",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79371,
    lat: 33.97942,
    lng: -102.69414,
    city: "Sudan",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1415,
    density: 1.6,
    county_fips: 48017,
    county_name: "Bailey",
    county_weights: {
      48017: 57.82,
      48279: 42.18,
    },
    county_names_all: "Bailey|Lamb",
    county_fips_all: "48017|48279",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79372,
    lat: 33.42482,
    lng: -102.50108,
    city: "Sundown",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1488,
    density: 36.8,
    county_fips: 48219,
    county_name: "Hockley",
    county_weights: {
      48219: 100,
    },
    county_names_all: "Hockley",
    county_fips_all: 48219,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79373,
    lat: 33.15905,
    lng: -101.83628,
    city: "Tahoka",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2985,
    density: 2.3,
    county_fips: 48305,
    county_name: "Lynn",
    county_weights: {
      48305: 100,
    },
    county_names_all: "Lynn",
    county_fips_all: 48305,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79376,
    lat: 33.25506,
    lng: -102.64143,
    city: "Tokio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15,
    density: 0,
    county_fips: 48501,
    county_name: "Yoakum",
    county_weights: {
      48445: 25.44,
      48501: 74.56,
    },
    county_names_all: "Yoakum|Terry",
    county_fips_all: "48501|48445",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79377,
    lat: 32.9309,
    lng: -102.13653,
    city: "Welch",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 246,
    density: 3.2,
    county_fips: 48115,
    county_name: "Dawson",
    county_weights: {
      48115: 100,
    },
    county_names_all: "Dawson",
    county_fips_all: 48115,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79378,
    lat: 33.03075,
    lng: -102.44482,
    city: "Wellman",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 312,
    density: 12.3,
    county_fips: 48445,
    county_name: "Terry",
    county_weights: {
      48445: 100,
    },
    county_names_all: "Terry",
    county_fips_all: 48445,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79379,
    lat: 33.49523,
    lng: -102.65345,
    city: "Whiteface",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 551,
    density: 2.9,
    county_fips: 48079,
    county_name: "Cochran",
    county_weights: {
      48079: 100,
    },
    county_names_all: "Cochran",
    county_fips_all: 48079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79380,
    lat: 33.73913,
    lng: -102.32784,
    city: "Whitharral",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 94,
    density: 32.7,
    county_fips: 48219,
    county_name: "Hockley",
    county_weights: {
      48219: 100,
    },
    county_names_all: "Hockley",
    county_fips_all: 48219,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79381,
    lat: 33.32312,
    lng: -101.76982,
    city: "Wilson",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1590,
    density: 5.2,
    county_fips: 48305,
    county_name: "Lynn",
    county_weights: {
      48305: 100,
    },
    county_names_all: "Lynn",
    county_fips_all: 48305,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79382,
    lat: 33.46578,
    lng: -102.02282,
    city: "Wolfforth",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8515,
    density: 64.3,
    county_fips: 48303,
    county_name: "Lubbock",
    county_weights: {
      48219: 5.61,
      48303: 94.39,
    },
    county_names_all: "Lubbock|Hockley",
    county_fips_all: "48303|48219",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79383,
    lat: 33.32429,
    lng: -101.90801,
    city: "New Home",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48305,
    county_name: "Lynn",
    county_weights: {
      48305: 100,
    },
    county_names_all: "Lynn",
    county_fips_all: 48305,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79401,
    lat: 33.58683,
    lng: -101.85179,
    city: "Lubbock",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9084,
    density: 1393.3,
    county_fips: 48303,
    county_name: "Lubbock",
    county_weights: {
      48303: 100,
    },
    county_names_all: "Lubbock",
    county_fips_all: 48303,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79402,
    lat: 33.58124,
    lng: -101.84201,
    city: "Lubbock",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48303,
    county_name: "Lubbock",
    county_weights: {
      48303: 100,
    },
    county_names_all: "Lubbock",
    county_fips_all: 48303,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79403,
    lat: 33.6433,
    lng: -101.76595,
    city: "Lubbock",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16348,
    density: 48.1,
    county_fips: 48303,
    county_name: "Lubbock",
    county_weights: {
      48303: 100,
    },
    county_names_all: "Lubbock",
    county_fips_all: 48303,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79404,
    lat: 33.52651,
    lng: -101.79856,
    city: "Lubbock",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9630,
    density: 130.3,
    county_fips: 48303,
    county_name: "Lubbock",
    county_weights: {
      48303: 100,
    },
    county_names_all: "Lubbock",
    county_fips_all: 48303,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79406,
    lat: 33.58336,
    lng: -101.88082,
    city: "Lubbock",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7288,
    density: 2950.9,
    county_fips: 48303,
    county_name: "Lubbock",
    county_weights: {
      48303: 100,
    },
    county_names_all: "Lubbock",
    county_fips_all: 48303,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79407,
    lat: 33.56566,
    lng: -102.08895,
    city: "Lubbock",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22157,
    density: 112.7,
    county_fips: 48219,
    county_name: "Hockley",
    county_weights: {
      48219: 62.38,
      48303: 37.62,
    },
    county_names_all: "Hockley|Lubbock",
    county_fips_all: "48219|48303",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79410,
    lat: 33.56962,
    lng: -101.89124,
    city: "Lubbock",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10588,
    density: 1692.3,
    county_fips: 48303,
    county_name: "Lubbock",
    county_weights: {
      48303: 100,
    },
    county_names_all: "Lubbock",
    county_fips_all: 48303,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79411,
    lat: 33.57012,
    lng: -101.85773,
    city: "Lubbock",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6661,
    density: 1733,
    county_fips: 48303,
    county_name: "Lubbock",
    county_weights: {
      48303: 100,
    },
    county_names_all: "Lubbock",
    county_fips_all: 48303,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79412,
    lat: 33.5464,
    lng: -101.85765,
    city: "Lubbock",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15597,
    density: 1876,
    county_fips: 48303,
    county_name: "Lubbock",
    county_weights: {
      48303: 100,
    },
    county_names_all: "Lubbock",
    county_fips_all: 48303,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79413,
    lat: 33.54576,
    lng: -101.88775,
    city: "Lubbock",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23820,
    density: 1963.9,
    county_fips: 48303,
    county_name: "Lubbock",
    county_weights: {
      48303: 100,
    },
    county_names_all: "Lubbock",
    county_fips_all: 48303,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79414,
    lat: 33.54862,
    lng: -101.91943,
    city: "Lubbock",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17806,
    density: 2167.9,
    county_fips: 48303,
    county_name: "Lubbock",
    county_weights: {
      48303: 100,
    },
    county_names_all: "Lubbock",
    county_fips_all: 48303,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79415,
    lat: 33.69863,
    lng: -101.90497,
    city: "Lubbock",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17894,
    density: 101.9,
    county_fips: 48303,
    county_name: "Lubbock",
    county_weights: {
      48303: 100,
    },
    county_names_all: "Lubbock",
    county_fips_all: 48303,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79416,
    lat: 33.60473,
    lng: -101.97658,
    city: "Lubbock",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34628,
    density: 415.9,
    county_fips: 48303,
    county_name: "Lubbock",
    county_weights: {
      48303: 100,
    },
    county_names_all: "Lubbock",
    county_fips_all: 48303,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79423,
    lat: 33.43376,
    lng: -101.84751,
    city: "Lubbock",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42354,
    density: 254.6,
    county_fips: 48303,
    county_name: "Lubbock",
    county_weights: {
      48303: 78.95,
      48305: 21.05,
    },
    county_names_all: "Lubbock|Lynn",
    county_fips_all: "48303|48305",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79424,
    lat: 33.46865,
    lng: -101.93881,
    city: "Lubbock",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49191,
    density: 456.6,
    county_fips: 48303,
    county_name: "Lubbock",
    county_weights: {
      48303: 100,
    },
    county_names_all: "Lubbock",
    county_fips_all: 48303,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79501,
    lat: 32.74332,
    lng: -99.89332,
    city: "Anson",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2535,
    density: 4.8,
    county_fips: 48253,
    county_name: "Jones",
    county_weights: {
      48253: 100,
    },
    county_names_all: "Jones",
    county_fips_all: 48253,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79502,
    lat: 33.18305,
    lng: -100.26499,
    city: "Aspermont",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1297,
    density: 1,
    county_fips: 48433,
    county_name: "Stonewall",
    county_weights: {
      48433: 100,
    },
    county_names_all: "Stonewall",
    county_fips_all: 48433,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79503,
    lat: 32.89003,
    lng: -99.69033,
    city: "Avoca",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 137,
    density: 0.7,
    county_fips: 48253,
    county_name: "Jones",
    county_weights: {
      48207: 13.01,
      48253: 86.99,
    },
    county_names_all: "Jones|Haskell",
    county_fips_all: "48253|48207",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79504,
    lat: 32.31336,
    lng: -99.35271,
    city: "Baird",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3375,
    density: 3.5,
    county_fips: 48059,
    county_name: "Callahan",
    county_weights: {
      48059: 94.35,
      48417: 5.65,
    },
    county_names_all: "Callahan|Shackelford",
    county_fips_all: "48059|48417",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79505,
    lat: 33.56323,
    lng: -99.84003,
    city: "Benjamin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 307,
    density: 0.7,
    county_fips: 48275,
    county_name: "Knox",
    county_weights: {
      48275: 100,
    },
    county_names_all: "Knox",
    county_fips_all: 48275,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79506,
    lat: 32.11366,
    lng: -100.32613,
    city: "Blackwell",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 555,
    density: 1.3,
    county_fips: 48353,
    county_name: "Nolan",
    county_weights: {
      48081: 27.39,
      48353: 72.61,
    },
    county_names_all: "Nolan|Coke",
    county_fips_all: "48353|48081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79508,
    lat: 32.26999,
    lng: -99.83032,
    city: "Buffalo Gap",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1060,
    density: 42.5,
    county_fips: 48441,
    county_name: "Taylor",
    county_weights: {
      48441: 100,
    },
    county_names_all: "Taylor",
    county_fips_all: 48441,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79510,
    lat: 32.26006,
    lng: -99.52872,
    city: "Clyde",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7801,
    density: 11.8,
    county_fips: 48059,
    county_name: "Callahan",
    county_weights: {
      48059: 88.61,
      48083: 11.39,
    },
    county_names_all: "Callahan|Coleman",
    county_fips_all: "48059|48083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79511,
    lat: 32.42982,
    lng: -101.26699,
    city: "Coahoma",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1417,
    density: 2.1,
    county_fips: 48227,
    county_name: "Howard",
    county_weights: {
      48033: 26.82,
      48227: 73.18,
    },
    county_names_all: "Howard|Borden",
    county_fips_all: "48227|48033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79512,
    lat: 32.32614,
    lng: -100.92807,
    city: "Colorado City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7451,
    density: 4.8,
    county_fips: 48335,
    county_name: "Mitchell",
    county_weights: {
      48335: 96.57,
      48415: 3.43,
    },
    county_names_all: "Mitchell|Scurry",
    county_fips_all: "48335|48415",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79517,
    lat: 32.87754,
    lng: -101.24144,
    city: "Fluvanna",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 226,
    density: 0.4,
    county_fips: 48033,
    county_name: "Borden",
    county_weights: {
      48033: 73.06,
      48415: 26.94,
    },
    county_names_all: "Borden|Scurry",
    county_fips_all: "48033|48415",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79518,
    lat: 33.31644,
    lng: -100.74382,
    city: "Girard",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67,
    density: 0.1,
    county_fips: 48263,
    county_name: "Kent",
    county_weights: {
      48125: 0.14,
      48263: 99.86,
    },
    county_names_all: "Kent|Dickens",
    county_fips_all: "48263|48125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79519,
    lat: 32.04926,
    lng: -99.69857,
    city: "Goldsboro",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61,
    density: 0.8,
    county_fips: 48083,
    county_name: "Coleman",
    county_weights: {
      48083: 63.72,
      48399: 30.67,
      48441: 5.61,
    },
    county_names_all: "Coleman|Runnels|Taylor",
    county_fips_all: "48083|48399|48441",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79520,
    lat: 32.87581,
    lng: -100.13012,
    city: "Hamlin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2286,
    density: 3.9,
    county_fips: 48253,
    county_name: "Jones",
    county_weights: {
      48151: 38.64,
      48253: 53.48,
      48433: 7.88,
    },
    county_names_all: "Jones|Fisher|Stonewall",
    county_fips_all: "48253|48151|48433",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79521,
    lat: 33.12478,
    lng: -99.64061,
    city: "Haskell",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3563,
    density: 4.2,
    county_fips: 48207,
    county_name: "Haskell",
    county_weights: {
      48207: 93.64,
      48447: 6.36,
    },
    county_names_all: "Haskell|Throckmorton",
    county_fips_all: "48207|48447",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79525,
    lat: 32.62745,
    lng: -99.82711,
    city: "Hawley",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2561,
    density: 10.1,
    county_fips: 48253,
    county_name: "Jones",
    county_weights: {
      48253: 100,
    },
    county_names_all: "Jones",
    county_fips_all: 48253,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79526,
    lat: 32.6443,
    lng: -100.75192,
    city: "Hermleigh",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 873,
    density: 1.8,
    county_fips: 48415,
    county_name: "Scurry",
    county_weights: {
      48151: 7.94,
      48415: 92.06,
    },
    county_names_all: "Scurry|Fisher",
    county_fips_all: "48415|48151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79527,
    lat: 32.59637,
    lng: -101.09939,
    city: "Ira",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 225,
    density: 1.4,
    county_fips: 48415,
    county_name: "Scurry",
    county_weights: {
      48033: 16.69,
      48415: 83.31,
    },
    county_names_all: "Scurry|Borden",
    county_fips_all: "48415|48033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79528,
    lat: 33.15936,
    lng: -100.57982,
    city: "Jayton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 625,
    density: 0.7,
    county_fips: 48263,
    county_name: "Kent",
    county_weights: {
      48263: 75.75,
      48433: 24.25,
    },
    county_names_all: "Kent|Stonewall",
    county_fips_all: "48263|48433",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79529,
    lat: 33.42911,
    lng: -99.82915,
    city: "Knox City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1339,
    density: 5.5,
    county_fips: 48275,
    county_name: "Knox",
    county_weights: {
      48207: 15.27,
      48275: 84.73,
    },
    county_names_all: "Knox|Haskell",
    county_fips_all: "48275|48207",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79530,
    lat: 32.09981,
    lng: -99.78178,
    city: "Lawn",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 450,
    density: 3,
    county_fips: 48441,
    county_name: "Taylor",
    county_weights: {
      48399: 32.76,
      48441: 67.24,
    },
    county_names_all: "Taylor|Runnels",
    county_fips_all: "48441|48399",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79532,
    lat: 32.40804,
    lng: -100.71357,
    city: "Loraine",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 671,
    density: 2.1,
    county_fips: 48335,
    county_name: "Mitchell",
    county_weights: {
      48335: 91.92,
      48353: 4.88,
      48415: 3.2,
    },
    county_names_all: "Mitchell|Nolan|Scurry",
    county_fips_all: "48335|48353|48415",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79533,
    lat: 32.84898,
    lng: -99.54739,
    city: "Lueders",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 392,
    density: 0.8,
    county_fips: 48417,
    county_name: "Shackelford",
    county_weights: {
      48207: 13.53,
      48253: 18.02,
      48417: 63.09,
      48447: 5.36,
    },
    county_names_all: "Shackelford|Jones|Haskell|Throckmorton",
    county_fips_all: "48417|48253|48207|48447",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79534,
    lat: 32.75559,
    lng: -100.22273,
    city: "McCaulley",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 165,
    density: 0.9,
    county_fips: 48151,
    county_name: "Fisher",
    county_weights: {
      48151: 100,
    },
    county_names_all: "Fisher",
    county_fips_all: 48151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79535,
    lat: 32.2219,
    lng: -100.48421,
    city: "Maryneal",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 188,
    density: 0.5,
    county_fips: 48353,
    county_name: "Nolan",
    county_weights: {
      48335: 0.11,
      48353: 99.89,
    },
    county_names_all: "Nolan|Mitchell",
    county_fips_all: "48353|48335",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79536,
    lat: 32.47333,
    lng: -100.02859,
    city: "Merkel",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5230,
    density: 6.8,
    county_fips: 48441,
    county_name: "Taylor",
    county_weights: {
      48253: 37.43,
      48353: 1.77,
      48441: 60.8,
    },
    county_names_all: "Taylor|Jones|Nolan",
    county_fips_all: "48441|48253|48353",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79537,
    lat: 32.28033,
    lng: -100.21402,
    city: "Nolan",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24,
    density: 0.1,
    county_fips: 48353,
    county_name: "Nolan",
    county_weights: {
      48353: 100,
    },
    county_names_all: "Nolan",
    county_fips_all: 48353,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79538,
    lat: 31.97891,
    lng: -99.69177,
    city: "Novice",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 264,
    density: 1.8,
    county_fips: 48083,
    county_name: "Coleman",
    county_weights: {
      48083: 65.89,
      48399: 34.11,
    },
    county_names_all: "Coleman|Runnels",
    county_fips_all: "48083|48399",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79539,
    lat: 33.36965,
    lng: -99.89207,
    city: "O'Brien",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 221,
    density: 1.8,
    county_fips: 48207,
    county_name: "Haskell",
    county_weights: {
      48207: 100,
    },
    county_names_all: "Haskell",
    county_fips_all: 48207,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79540,
    lat: 33.15173,
    lng: -100.06289,
    city: "Old Glory",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51,
    density: 0.2,
    county_fips: 48433,
    county_name: "Stonewall",
    county_weights: {
      48433: 100,
    },
    county_names_all: "Stonewall",
    county_fips_all: 48433,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79541,
    lat: 32.15018,
    lng: -99.81617,
    city: "Ovalo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1172,
    density: 3.1,
    county_fips: 48441,
    county_name: "Taylor",
    county_weights: {
      48059: 7.07,
      48441: 92.93,
    },
    county_names_all: "Taylor|Callahan",
    county_fips_all: "48441|48059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79543,
    lat: 32.71864,
    lng: -100.38724,
    city: "Roby",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1319,
    density: 4,
    county_fips: 48151,
    county_name: "Fisher",
    county_weights: {
      48151: 100,
    },
    county_names_all: "Fisher",
    county_fips_all: 48151,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79544,
    lat: 33.30557,
    lng: -99.86565,
    city: "Rochester",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 475,
    density: 2.2,
    county_fips: 48207,
    county_name: "Haskell",
    county_weights: {
      48207: 92.28,
      48433: 7.72,
    },
    county_names_all: "Haskell|Stonewall",
    county_fips_all: "48207|48433",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79545,
    lat: 32.41806,
    lng: -100.57753,
    city: "Roscoe",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1950,
    density: 3.3,
    county_fips: 48353,
    county_name: "Nolan",
    county_weights: {
      48151: 15.34,
      48353: 81.51,
      48415: 3.15,
    },
    county_names_all: "Nolan|Fisher|Scurry",
    county_fips_all: "48353|48151|48415",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79546,
    lat: 32.8792,
    lng: -100.49136,
    city: "Rotan",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1734,
    density: 1.7,
    county_fips: 48151,
    county_name: "Fisher",
    county_weights: {
      48151: 77.08,
      48415: 3.82,
      48433: 19.1,
    },
    county_names_all: "Fisher|Stonewall|Scurry",
    county_fips_all: "48151|48433|48415",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79547,
    lat: 33.20478,
    lng: -99.91023,
    city: "Rule",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 932,
    density: 4.5,
    county_fips: 48207,
    county_name: "Haskell",
    county_weights: {
      48207: 99.53,
      48433: 0.47,
    },
    county_names_all: "Haskell|Stonewall",
    county_fips_all: "48207|48433",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79548,
    lat: 33.06989,
    lng: -99.93005,
    city: "Rule",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 197,
    density: 0.9,
    county_fips: 48207,
    county_name: "Haskell",
    county_weights: {
      48207: 100,
    },
    county_names_all: "Haskell",
    county_fips_all: 48207,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79549,
    lat: 32.90152,
    lng: -100.90407,
    city: "Snyder",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15708,
    density: 7,
    county_fips: 48415,
    county_name: "Scurry",
    county_weights: {
      48033: 1,
      48263: 38.67,
      48415: 60.33,
    },
    county_names_all: "Scurry|Kent|Borden",
    county_fips_all: "48415|48263|48033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79553,
    lat: 32.93785,
    lng: -99.84022,
    city: "Stamford",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3127,
    density: 6.5,
    county_fips: 48253,
    county_name: "Jones",
    county_weights: {
      48207: 37.65,
      48253: 62.35,
    },
    county_names_all: "Jones|Haskell",
    county_fips_all: "48253|48207",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79556,
    lat: 32.48451,
    lng: -100.39263,
    city: "Sweetwater",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12683,
    density: 12.9,
    county_fips: 48353,
    county_name: "Nolan",
    county_weights: {
      48151: 41.6,
      48353: 58.4,
    },
    county_names_all: "Nolan|Fisher",
    county_fips_all: "48353|48151",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79560,
    lat: 32.67514,
    lng: -100.2094,
    city: "Sylvester",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 160,
    density: 0.9,
    county_fips: 48151,
    county_name: "Fisher",
    county_weights: {
      48151: 75.19,
      48253: 24.81,
    },
    county_names_all: "Fisher|Jones",
    county_fips_all: "48151|48253",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79561,
    lat: 32.51974,
    lng: -100.18369,
    city: "Trent",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 440,
    density: 1.2,
    county_fips: 48353,
    county_name: "Nolan",
    county_weights: {
      48151: 36.24,
      48253: 11.4,
      48353: 36.31,
      48441: 16.05,
    },
    county_names_all: "Nolan|Fisher|Taylor|Jones",
    county_fips_all: "48353|48151|48441|48253",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79562,
    lat: 32.24168,
    lng: -99.86766,
    city: "Tuscola",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3795,
    density: 12.8,
    county_fips: 48441,
    county_name: "Taylor",
    county_weights: {
      48441: 100,
    },
    county_names_all: "Taylor",
    county_fips_all: 48441,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79563,
    lat: 32.42222,
    lng: -99.90929,
    city: "Tye",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1013,
    density: 22.1,
    county_fips: 48441,
    county_name: "Taylor",
    county_weights: {
      48441: 100,
    },
    county_names_all: "Taylor",
    county_fips_all: 48441,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79565,
    lat: 32.37637,
    lng: -101.08415,
    city: "Westbrook",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 195,
    density: 1.3,
    county_fips: 48335,
    county_name: "Mitchell",
    county_weights: {
      48335: 100,
    },
    county_names_all: "Mitchell",
    county_fips_all: 48335,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79566,
    lat: 32.15454,
    lng: -100.1098,
    city: "Wingate",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 218,
    density: 0.7,
    county_fips: 48441,
    county_name: "Taylor",
    county_weights: {
      48353: 15.04,
      48399: 16.9,
      48441: 68.06,
    },
    county_names_all: "Taylor|Runnels|Nolan",
    county_fips_all: "48441|48399|48353",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79567,
    lat: 31.97678,
    lng: -99.97787,
    city: "Winters",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3149,
    density: 3.8,
    county_fips: 48399,
    county_name: "Runnels",
    county_weights: {
      48399: 94.1,
      48441: 5.9,
    },
    county_names_all: "Runnels|Taylor",
    county_fips_all: "48399|48441",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79601,
    lat: 32.57226,
    lng: -99.64921,
    city: "Abilene",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27385,
    density: 40.2,
    county_fips: 48253,
    county_name: "Jones",
    county_weights: {
      48059: 11.89,
      48253: 47.64,
      48417: 23.16,
      48441: 17.31,
    },
    county_names_all: "Jones|Shackelford|Taylor|Callahan",
    county_fips_all: "48253|48417|48441|48059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79602,
    lat: 32.33568,
    lng: -99.6699,
    city: "Abilene",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26033,
    density: 82.6,
    county_fips: 48441,
    county_name: "Taylor",
    county_weights: {
      48059: 22.53,
      48441: 77.47,
    },
    county_names_all: "Taylor|Callahan",
    county_fips_all: "48441|48059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79603,
    lat: 32.39904,
    lng: -99.89222,
    city: "Abilene",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23602,
    density: 153.9,
    county_fips: 48441,
    county_name: "Taylor",
    county_weights: {
      48441: 100,
    },
    county_names_all: "Taylor",
    county_fips_all: 48441,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79605,
    lat: 32.43394,
    lng: -99.78182,
    city: "Abilene",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28259,
    density: 993.5,
    county_fips: 48441,
    county_name: "Taylor",
    county_weights: {
      48441: 100,
    },
    county_names_all: "Taylor",
    county_fips_all: 48441,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79606,
    lat: 32.35477,
    lng: -99.83139,
    city: "Abilene",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25568,
    density: 141.9,
    county_fips: 48441,
    county_name: "Taylor",
    county_weights: {
      48441: 100,
    },
    county_names_all: "Taylor",
    county_fips_all: 48441,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79607,
    lat: 32.42289,
    lng: -99.83904,
    city: "Dyess Afb",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3714,
    density: 171.1,
    county_fips: 48441,
    county_name: "Taylor",
    county_weights: {
      48441: 100,
    },
    county_names_all: "Taylor",
    county_fips_all: 48441,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79699,
    lat: 32.46221,
    lng: -99.71502,
    city: "Abilene",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 118,
    density: 758,
    county_fips: 48441,
    county_name: "Taylor",
    county_weights: {
      48441: 100,
    },
    county_names_all: "Taylor",
    county_fips_all: 48441,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79701,
    lat: 31.99239,
    lng: -102.08105,
    city: "Midland",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32692,
    density: 1045.7,
    county_fips: 48329,
    county_name: "Midland",
    county_weights: {
      48329: 100,
    },
    county_names_all: "Midland",
    county_fips_all: 48329,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79703,
    lat: 31.97998,
    lng: -102.13158,
    city: "Midland",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24683,
    density: 1465.8,
    county_fips: 48329,
    county_name: "Midland",
    county_weights: {
      48329: 100,
    },
    county_names_all: "Midland",
    county_fips_all: 48329,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79705,
    lat: 32.09619,
    lng: -102.0508,
    city: "Midland",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43119,
    density: 209.6,
    county_fips: 48317,
    county_name: "Martin",
    county_weights: {
      48317: 51.5,
      48329: 48.5,
    },
    county_names_all: "Martin|Midland",
    county_fips_all: "48317|48329",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79706,
    lat: 31.83622,
    lng: -101.97025,
    city: "Midland",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27354,
    density: 15.3,
    county_fips: 48329,
    county_name: "Midland",
    county_weights: {
      48173: 5.75,
      48329: 93.04,
      48461: 1.21,
    },
    county_names_all: "Midland|Glasscock|Upton",
    county_fips_all: "48329|48173|48461",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79707,
    lat: 32.03304,
    lng: -102.21189,
    city: "Midland",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38644,
    density: 210.3,
    county_fips: 48329,
    county_name: "Midland",
    county_weights: {
      48329: 100,
    },
    county_names_all: "Midland",
    county_fips_all: 48329,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79713,
    lat: 32.49861,
    lng: -101.74554,
    city: "Ackerly",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 725,
    density: 1.5,
    county_fips: 48317,
    county_name: "Martin",
    county_weights: {
      48033: 10.11,
      48115: 22.01,
      48227: 21.76,
      48317: 46.11,
    },
    county_names_all: "Martin|Dawson|Howard|Borden",
    county_fips_all: "48317|48115|48227|48033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79714,
    lat: 32.32947,
    lng: -102.71323,
    city: "Andrews",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18227,
    density: 9.2,
    county_fips: 48003,
    county_name: "Andrews",
    county_weights: {
      48003: 100,
    },
    county_names_all: "Andrews",
    county_fips_all: 48003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79718,
    lat: 30.99474,
    lng: -103.73293,
    city: "Balmorhea",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1029,
    density: 1.1,
    county_fips: 48389,
    county_name: "Reeves",
    county_weights: {
      48389: 100,
    },
    county_names_all: "Reeves",
    county_fips_all: 48389,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79719,
    lat: 31.46042,
    lng: -103.4051,
    city: "Barstow",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 465,
    density: 9.3,
    county_fips: 48475,
    county_name: "Ward",
    county_weights: {
      48475: 100,
    },
    county_names_all: "Ward",
    county_fips_all: 48475,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79720,
    lat: 32.20171,
    lng: -101.51395,
    city: "Big Spring",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34454,
    density: 13.5,
    county_fips: 48227,
    county_name: "Howard",
    county_weights: {
      48033: 5.72,
      48173: 35.03,
      48227: 55.13,
      48317: 4.12,
    },
    county_names_all: "Howard|Glasscock|Borden|Martin",
    county_fips_all: "48227|48173|48033|48317",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79721,
    lat: 32.22491,
    lng: -101.52737,
    city: "Big Spring",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48227,
    county_name: "Howard",
    county_weights: {
      48227: 100,
    },
    county_names_all: "Howard",
    county_fips_all: 48227,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79730,
    lat: 31.19335,
    lng: -103.06396,
    city: "Coyanosa",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 229,
    density: 0.4,
    county_fips: 48371,
    county_name: "Pecos",
    county_weights: {
      48371: 100,
    },
    county_names_all: "Pecos",
    county_fips_all: 48371,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79731,
    lat: 31.4477,
    lng: -102.56095,
    city: "Crane",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4619,
    density: 4,
    county_fips: 48103,
    county_name: "Crane",
    county_weights: {
      48103: 100,
    },
    county_names_all: "Crane",
    county_fips_all: 48103,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79733,
    lat: 32.11036,
    lng: -101.36683,
    city: "Forsan",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 449,
    density: 595.4,
    county_fips: 48227,
    county_name: "Howard",
    county_weights: {
      48227: 100,
    },
    county_names_all: "Howard",
    county_fips_all: 48227,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79734,
    lat: 30.68526,
    lng: -103.97911,
    city: "Fort Davis",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2044,
    density: 0.6,
    county_fips: 48243,
    county_name: "Jeff Davis",
    county_weights: {
      48243: 100,
    },
    county_names_all: "Jeff Davis",
    county_fips_all: 48243,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79735,
    lat: 30.74837,
    lng: -102.85518,
    city: "Fort Stockton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13636,
    density: 4.3,
    county_fips: 48371,
    county_name: "Pecos",
    county_weights: {
      48371: 100,
    },
    county_names_all: "Pecos",
    county_fips_all: 48371,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79738,
    lat: 32.73625,
    lng: -101.48269,
    city: "Gail",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 187,
    density: 0.2,
    county_fips: 48033,
    county_name: "Borden",
    county_weights: {
      48033: 100,
    },
    county_names_all: "Borden",
    county_fips_all: 48033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79739,
    lat: 31.75515,
    lng: -101.50668,
    city: "Garden City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1278,
    density: 1.1,
    county_fips: 48173,
    county_name: "Glasscock",
    county_weights: {
      48173: 91.41,
      48383: 8.59,
    },
    county_names_all: "Glasscock|Reagan",
    county_fips_all: "48173|48383",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79741,
    lat: 32.00833,
    lng: -102.65675,
    city: "Goldsmith",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 197,
    density: 0.8,
    county_fips: 48135,
    county_name: "Ector",
    county_weights: {
      48135: 100,
    },
    county_names_all: "Ector",
    county_fips_all: 48135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79742,
    lat: 31.3605,
    lng: -102.86027,
    city: "Grandfalls",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 617,
    density: 2.8,
    county_fips: 48475,
    county_name: "Ward",
    county_weights: {
      48475: 100,
    },
    county_names_all: "Ward",
    county_fips_all: 48475,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79743,
    lat: 31.24911,
    lng: -102.76766,
    city: "Imperial",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 339,
    density: 1.4,
    county_fips: 48371,
    county_name: "Pecos",
    county_weights: {
      48371: 100,
    },
    county_names_all: "Pecos",
    county_fips_all: 48371,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79744,
    lat: 30.89083,
    lng: -101.91305,
    city: "Iraan",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1362,
    density: 1.1,
    county_fips: 48105,
    county_name: "Crockett",
    county_weights: {
      48105: 51.31,
      48371: 48.69,
    },
    county_names_all: "Crockett|Pecos",
    county_fips_all: "48105|48371",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79745,
    lat: 31.85302,
    lng: -103.03325,
    city: "Kermit",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6783,
    density: 4.7,
    county_fips: 48495,
    county_name: "Winkler",
    county_weights: {
      48495: 100,
    },
    county_names_all: "Winkler",
    county_fips_all: 48495,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79748,
    lat: 32.38784,
    lng: -101.66889,
    city: "Knott",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 277,
    density: 2.2,
    county_fips: 48227,
    county_name: "Howard",
    county_weights: {
      48227: 62.52,
      48317: 37.48,
    },
    county_names_all: "Howard|Martin",
    county_fips_all: "48227|48317",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79749,
    lat: 32.25551,
    lng: -101.83419,
    city: "Lenorah",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 492,
    density: 3.4,
    county_fips: 48317,
    county_name: "Martin",
    county_weights: {
      48317: 100,
    },
    county_names_all: "Martin",
    county_fips_all: 48317,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79752,
    lat: 31.10993,
    lng: -102.19225,
    city: "McCamey",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2415,
    density: 3.4,
    county_fips: 48461,
    county_name: "Upton",
    county_weights: {
      48105: 19.41,
      48371: 21.63,
      48461: 58.96,
    },
    county_names_all: "Upton|Pecos|Crockett",
    county_fips_all: "48461|48371|48105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79754,
    lat: 31.81735,
    lng: -103.49163,
    city: "Mentone",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 117,
    density: 0.1,
    county_fips: 48301,
    county_name: "Loving",
    county_weights: {
      48301: 100,
    },
    county_names_all: "Loving",
    county_fips_all: 48301,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79755,
    lat: 31.51298,
    lng: -101.96934,
    city: "Midkiff",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 103,
    density: 0.1,
    county_fips: 48461,
    county_name: "Upton",
    county_weights: {
      48329: 1.93,
      48461: 98.07,
    },
    county_names_all: "Upton|Midland",
    county_fips_all: "48461|48329",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79756,
    lat: 31.54626,
    lng: -102.88338,
    city: "Monahans",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9576,
    density: 23.3,
    county_fips: 48475,
    county_name: "Ward",
    county_weights: {
      48475: 100,
    },
    county_names_all: "Ward",
    county_fips_all: 48475,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79758,
    lat: 32.0112,
    lng: -102.33569,
    city: "Gardendale",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3425,
    density: 26.1,
    county_fips: 48135,
    county_name: "Ector",
    county_weights: {
      48135: 100,
    },
    county_names_all: "Ector",
    county_fips_all: 48135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79759,
    lat: 31.80913,
    lng: -102.69819,
    city: "Notrees",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 48135,
    county_name: "Ector",
    county_weights: {
      48135: 100,
    },
    county_names_all: "Ector",
    county_fips_all: 48135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79761,
    lat: 31.85603,
    lng: -102.3485,
    city: "Odessa",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33955,
    density: 1256,
    county_fips: 48135,
    county_name: "Ector",
    county_weights: {
      48135: 100,
    },
    county_names_all: "Ector",
    county_fips_all: 48135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79762,
    lat: 31.92573,
    lng: -102.35502,
    city: "Odessa",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45474,
    density: 576.4,
    county_fips: 48135,
    county_name: "Ector",
    county_weights: {
      48135: 100,
    },
    county_names_all: "Ector",
    county_fips_all: 48135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79763,
    lat: 31.80766,
    lng: -102.46744,
    city: "Odessa",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36688,
    density: 280.9,
    county_fips: 48135,
    county_name: "Ector",
    county_weights: {
      48135: 100,
    },
    county_names_all: "Ector",
    county_fips_all: 48135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79764,
    lat: 31.88546,
    lng: -102.47378,
    city: "Odessa",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22519,
    density: 159.5,
    county_fips: 48135,
    county_name: "Ector",
    county_weights: {
      48135: 100,
    },
    county_names_all: "Ector",
    county_fips_all: 48135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79765,
    lat: 31.92205,
    lng: -102.29878,
    city: "Odessa",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17017,
    density: 280.4,
    county_fips: 48329,
    county_name: "Midland",
    county_weights: {
      48135: 45.15,
      48329: 54.85,
    },
    county_names_all: "Midland|Ector",
    county_fips_all: "48329|48135",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79766,
    lat: 31.71014,
    lng: -102.36185,
    city: "Odessa",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7676,
    density: 9.7,
    county_fips: 48135,
    county_name: "Ector",
    county_weights: {
      48103: 18.93,
      48135: 53.82,
      48329: 27.25,
    },
    county_names_all: "Ector|Midland|Crane",
    county_fips_all: "48135|48329|48103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79769,
    lat: 31.68212,
    lng: -102.61973,
    city: "Odessa",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48135,
    county_name: "Ector",
    county_weights: {
      48103: 0.54,
      48135: 99.46,
    },
    county_names_all: "Ector|Crane",
    county_fips_all: "48135|48103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79770,
    lat: 31.85389,
    lng: -103.90585,
    city: "Orla",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 48389,
    county_name: "Reeves",
    county_weights: {
      48389: 100,
    },
    county_names_all: "Reeves",
    county_fips_all: 48389,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79772,
    lat: 31.39852,
    lng: -103.5867,
    city: "Pecos",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14265,
    density: 5.3,
    county_fips: 48389,
    county_name: "Reeves",
    county_weights: {
      48389: 98.64,
      48475: 1.36,
    },
    county_names_all: "Reeves|Ward",
    county_fips_all: "48389|48475",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79776,
    lat: 31.77513,
    lng: -102.55573,
    city: "Penwell",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48135,
    county_name: "Ector",
    county_weights: {
      48135: 100,
    },
    county_names_all: "Ector",
    county_fips_all: 48135,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79777,
    lat: 31.47772,
    lng: -103.16337,
    city: "Pyote",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 174,
    density: 0.4,
    county_fips: 48475,
    county_name: "Ward",
    county_weights: {
      48475: 100,
    },
    county_names_all: "Ward",
    county_fips_all: 48475,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79778,
    lat: 31.25857,
    lng: -101.97359,
    city: "Rankin",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1115,
    density: 2,
    county_fips: 48461,
    county_name: "Upton",
    county_weights: {
      48461: 100,
    },
    county_names_all: "Upton",
    county_fips_all: 48461,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79780,
    lat: 31.03937,
    lng: -103.65754,
    city: "Saragosa",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 127,
    density: 2.9,
    county_fips: 48389,
    county_name: "Reeves",
    county_weights: {
      48389: 100,
    },
    county_names_all: "Reeves",
    county_fips_all: 48389,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79781,
    lat: 30.60111,
    lng: -101.75348,
    city: "Sheffield",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 267,
    density: 0.2,
    county_fips: 48443,
    county_name: "Terrell",
    county_weights: {
      48105: 42,
      48371: 13.65,
      48443: 44.35,
    },
    county_names_all: "Terrell|Crockett|Pecos",
    county_fips_all: "48443|48105|48371",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79782,
    lat: 32.18599,
    lng: -101.88823,
    city: "Stanton",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4304,
    density: 4.4,
    county_fips: 48317,
    county_name: "Martin",
    county_weights: {
      48173: 8.92,
      48317: 84.03,
      48329: 7.05,
    },
    county_names_all: "Martin|Glasscock|Midland",
    county_fips_all: "48317|48173|48329",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79783,
    lat: 32.3321,
    lng: -102.05007,
    city: "Tarzan",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 279,
    density: 0.7,
    county_fips: 48317,
    county_name: "Martin",
    county_weights: {
      48317: 100,
    },
    county_names_all: "Martin",
    county_fips_all: 48317,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79785,
    lat: 31.32135,
    lng: -103.94006,
    city: "Toyah",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 125,
    density: 0.5,
    county_fips: 48389,
    county_name: "Reeves",
    county_weights: {
      48389: 100,
    },
    county_names_all: "Reeves",
    county_fips_all: 48389,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79788,
    lat: 31.60544,
    lng: -102.98261,
    city: "Wickett",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 913,
    density: 23.7,
    county_fips: 48475,
    county_name: "Ward",
    county_weights: {
      48475: 100,
    },
    county_names_all: "Ward",
    county_fips_all: 48475,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79789,
    lat: 31.75047,
    lng: -103.1948,
    city: "Wink",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1023,
    density: 11.6,
    county_fips: 48495,
    county_name: "Winkler",
    county_weights: {
      48495: 100,
    },
    county_names_all: "Winkler",
    county_fips_all: 48495,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79821,
    lat: 31.97677,
    lng: -106.59822,
    city: "Anthony",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7044,
    density: 242.2,
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      48141: 100,
    },
    county_names_all: "El Paso",
    county_fips_all: 48141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79830,
    lat: 29.89491,
    lng: -103.49925,
    city: "Alpine",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7956,
    density: 2.6,
    county_fips: 48043,
    county_name: "Brewster",
    county_weights: {
      48043: 100,
    },
    county_names_all: "Brewster",
    county_fips_all: 48043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79832,
    lat: 30.36316,
    lng: -103.64934,
    city: "Alpine",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48043,
    county_name: "Brewster",
    county_weights: {
      48043: 100,
    },
    county_names_all: "Brewster",
    county_fips_all: 48043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79834,
    lat: 29.17102,
    lng: -103.28736,
    city: "Big Bend National Park",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 202,
    density: 0.1,
    county_fips: 48043,
    county_name: "Brewster",
    county_weights: {
      48043: 100,
    },
    county_names_all: "Brewster",
    county_fips_all: 48043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79835,
    lat: 31.93555,
    lng: -106.59491,
    city: "Canutillo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11171,
    density: 487,
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      35013: 1.55,
      48141: 98.45,
    },
    county_names_all: "El Paso|Doña Ana",
    county_fips_all: "48141|35013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79836,
    lat: 31.56975,
    lng: -106.2112,
    city: "Clint",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5804,
    density: 116.2,
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      48141: 100,
    },
    county_names_all: "El Paso",
    county_fips_all: 48141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79837,
    lat: 32.11472,
    lng: -105.22792,
    city: "Dell City",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 249,
    density: 0.1,
    county_fips: 35035,
    county_name: "Otero",
    county_weights: {
      35035: 81.78,
      48229: 18.22,
    },
    county_names_all: "Otero|Hudspeth",
    county_fips_all: "35035|48229",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79838,
    lat: 31.49362,
    lng: -106.17024,
    city: "Fabens",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4872,
    density: 61,
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      48141: 100,
    },
    county_names_all: "El Paso",
    county_fips_all: 48141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79839,
    lat: 31.36476,
    lng: -105.68693,
    city: "Fort Hancock",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2182,
    density: 2.6,
    county_fips: 48229,
    county_name: "Hudspeth",
    county_weights: {
      48229: 100,
    },
    county_names_all: "Hudspeth",
    county_fips_all: 48229,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79842,
    lat: 30.0151,
    lng: -103.02301,
    city: "Marathon",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 397,
    density: 0.2,
    county_fips: 48043,
    county_name: "Brewster",
    county_weights: {
      48043: 100,
    },
    county_names_all: "Brewster",
    county_fips_all: 48043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79843,
    lat: 30.11987,
    lng: -104.30359,
    city: "Marfa",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2457,
    density: 0.6,
    county_fips: 48377,
    county_name: "Presidio",
    county_weights: {
      48377: 100,
    },
    county_names_all: "Presidio",
    county_fips_all: 48377,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79845,
    lat: 29.65332,
    lng: -104.39724,
    city: "Presidio",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4317,
    density: 9.4,
    county_fips: 48377,
    county_name: "Presidio",
    county_weights: {
      48377: 100,
    },
    county_names_all: "Presidio",
    county_fips_all: 48377,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79846,
    lat: 29.41684,
    lng: -103.98559,
    city: "Redford",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23,
    density: 0,
    county_fips: 48377,
    county_name: "Presidio",
    county_weights: {
      48377: 100,
    },
    county_names_all: "Presidio",
    county_fips_all: 48377,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79847,
    lat: 31.78975,
    lng: -104.99032,
    city: "Salt Flat",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 90,
    density: 0,
    county_fips: 48109,
    county_name: "Culberson",
    county_weights: {
      48109: 54.4,
      48229: 45.6,
    },
    county_names_all: "Culberson|Hudspeth",
    county_fips_all: "48109|48229",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79848,
    lat: 30.27747,
    lng: -102.26187,
    city: "Sanderson",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 835,
    density: 0.4,
    county_fips: 48443,
    county_name: "Terrell",
    county_weights: {
      48443: 100,
    },
    county_names_all: "Terrell",
    county_fips_all: 48443,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79849,
    lat: 31.56449,
    lng: -106.25275,
    city: "San Elizario",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11605,
    density: 328.8,
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      48141: 100,
    },
    county_names_all: "El Paso",
    county_fips_all: 48141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79851,
    lat: 31.2687,
    lng: -105.26255,
    city: "Sierra Blanca",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1689,
    density: 1.5,
    county_fips: 48229,
    county_name: "Hudspeth",
    county_weights: {
      48229: 100,
    },
    county_names_all: "Hudspeth",
    county_fips_all: 48229,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79852,
    lat: 29.36484,
    lng: -103.6029,
    city: "Terlingua",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 676,
    density: 0.6,
    county_fips: 48043,
    county_name: "Brewster",
    county_weights: {
      48043: 100,
    },
    county_names_all: "Brewster",
    county_fips_all: 48043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79853,
    lat: 31.43559,
    lng: -106.06493,
    city: "Tornillo",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2282,
    density: 25.3,
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      48141: 100,
    },
    county_names_all: "El Paso",
    county_fips_all: 48141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79854,
    lat: 30.6109,
    lng: -104.62469,
    city: "Valentine",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 175,
    density: 0.1,
    county_fips: 48243,
    county_name: "Jeff Davis",
    county_weights: {
      48243: 68.65,
      48377: 31.35,
    },
    county_names_all: "Jeff Davis|Presidio",
    county_fips_all: "48243|48377",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79855,
    lat: 30.92331,
    lng: -104.85583,
    city: "Van Horn",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2108,
    density: 1.8,
    county_fips: 48109,
    county_name: "Culberson",
    county_weights: {
      48109: 72.37,
      48229: 27.63,
    },
    county_names_all: "Culberson|Hudspeth",
    county_fips_all: "48109|48229",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Chicago",
  },
  {
    zip: 79901,
    lat: 31.7597,
    lng: -106.48049,
    city: "El Paso",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8821,
    density: 1548,
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      48141: 100,
    },
    county_names_all: "El Paso",
    county_fips_all: 48141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79902,
    lat: 31.78431,
    lng: -106.49768,
    city: "El Paso",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20752,
    density: 1226.8,
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      48141: 100,
    },
    county_names_all: "El Paso",
    county_fips_all: 48141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79903,
    lat: 31.78622,
    lng: -106.44194,
    city: "El Paso",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15422,
    density: 1952.6,
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      48141: 100,
    },
    county_names_all: "El Paso",
    county_fips_all: 48141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79904,
    lat: 31.85005,
    lng: -106.45417,
    city: "El Paso",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33084,
    density: 1068.8,
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      48141: 100,
    },
    county_names_all: "El Paso",
    county_fips_all: 48141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79905,
    lat: 31.76665,
    lng: -106.42523,
    city: "El Paso",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22767,
    density: 1338.5,
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      48141: 100,
    },
    county_names_all: "El Paso",
    county_fips_all: 48141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79906,
    lat: 31.80906,
    lng: -106.41954,
    city: "El Paso",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3452,
    density: 295.5,
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      48141: 100,
    },
    county_names_all: "El Paso",
    county_fips_all: 48141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79907,
    lat: 31.7074,
    lng: -106.32681,
    city: "El Paso",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51208,
    density: 1441.8,
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      48141: 100,
    },
    county_names_all: "El Paso",
    county_fips_all: 48141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79908,
    lat: 31.82974,
    lng: -106.37763,
    city: "El Paso",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6351,
    density: 1381.7,
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      48141: 100,
    },
    county_names_all: "El Paso",
    county_fips_all: 48141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79911,
    lat: 31.9361,
    lng: -106.53569,
    city: "El Paso",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5905,
    density: 66.1,
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      48141: 100,
    },
    county_names_all: "El Paso",
    county_fips_all: 48141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79912,
    lat: 31.84839,
    lng: -106.53272,
    city: "El Paso",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 79861,
    density: 1303.8,
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      48141: 100,
    },
    county_names_all: "El Paso",
    county_fips_all: 48141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79915,
    lat: 31.74593,
    lng: -106.37245,
    city: "El Paso",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36797,
    density: 1597,
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      48141: 100,
    },
    county_names_all: "El Paso",
    county_fips_all: 48141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79916,
    lat: 31.86268,
    lng: -106.38912,
    city: "Fort Bliss",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4238,
    density: 135.7,
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      48141: 100,
    },
    county_names_all: "El Paso",
    county_fips_all: 48141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79918,
    lat: 31.84691,
    lng: -106.36936,
    city: "Fort Bliss",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      48141: 100,
    },
    county_names_all: "El Paso",
    county_fips_all: 48141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79920,
    lat: 31.82261,
    lng: -106.46037,
    city: "El Paso",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      48141: 100,
    },
    county_names_all: "El Paso",
    county_fips_all: 48141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79922,
    lat: 31.81126,
    lng: -106.55823,
    city: "El Paso",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7890,
    density: 378.1,
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      35013: 16.69,
      48141: 83.31,
    },
    county_names_all: "El Paso|Doña Ana",
    county_fips_all: "48141|35013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79924,
    lat: 31.90224,
    lng: -106.41355,
    city: "El Paso",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59816,
    density: 1865.3,
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      48141: 100,
    },
    county_names_all: "El Paso",
    county_fips_all: 48141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79925,
    lat: 31.79851,
    lng: -106.36327,
    city: "El Paso",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39868,
    density: 881.6,
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      48141: 100,
    },
    county_names_all: "El Paso",
    county_fips_all: 48141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79927,
    lat: 31.64566,
    lng: -106.27359,
    city: "El Paso",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42221,
    density: 593.9,
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      48141: 100,
    },
    county_names_all: "El Paso",
    county_fips_all: 48141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79928,
    lat: 31.67896,
    lng: -106.11511,
    city: "El Paso",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62344,
    density: 114.7,
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      48141: 100,
    },
    county_names_all: "El Paso",
    county_fips_all: 48141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79930,
    lat: 31.81078,
    lng: -106.46846,
    city: "El Paso",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28091,
    density: 1448.5,
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      48141: 100,
    },
    county_names_all: "El Paso",
    county_fips_all: 48141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79932,
    lat: 31.87753,
    lng: -106.6068,
    city: "El Paso",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28893,
    density: 813,
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      48141: 100,
    },
    county_names_all: "El Paso",
    county_fips_all: 48141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79934,
    lat: 31.95206,
    lng: -106.434,
    city: "El Paso",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26360,
    density: 172.2,
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      48141: 100,
    },
    county_names_all: "El Paso",
    county_fips_all: 48141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79935,
    lat: 31.76804,
    lng: -106.33029,
    city: "El Paso",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18546,
    density: 2066.1,
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      48141: 100,
    },
    county_names_all: "El Paso",
    county_fips_all: 48141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79936,
    lat: 31.77373,
    lng: -106.29631,
    city: "El Paso",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 108668,
    density: 1620,
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      48141: 100,
    },
    county_names_all: "El Paso",
    county_fips_all: 48141,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 79938,
    lat: 31.85764,
    lng: -106.03895,
    city: "El Paso",
    state_id: "TX",
    state_name: "Texas",
    zcta: "TRUE",
    parent_zcta: "",
    population: 83326,
    density: 82.4,
    county_fips: 48141,
    county_name: "El Paso",
    county_weights: {
      48141: 54.48,
      48229: 45.52,
    },
    county_names_all: "El Paso|Hudspeth",
    county_fips_all: "48141|48229",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80002,
    lat: 39.79405,
    lng: -105.10845,
    city: "Arvada",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19319,
    density: 1148.2,
    county_fips: "08059",
    county_name: "Jefferson",
    county_weights: {
      "08059": 94.86,
      "08001": 5.14,
    },
    county_names_all: "Jefferson|Adams",
    county_fips_all: "08059|08001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80003,
    lat: 39.827,
    lng: -105.06412,
    city: "Arvada",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36914,
    density: 2165.9,
    county_fips: "08059",
    county_name: "Jefferson",
    county_weights: {
      "08059": 85.1,
      "08001": 14.9,
    },
    county_names_all: "Jefferson|Adams",
    county_fips_all: "08059|08001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80004,
    lat: 39.81443,
    lng: -105.12293,
    city: "Arvada",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36118,
    density: 1950.5,
    county_fips: "08059",
    county_name: "Jefferson",
    county_weights: {
      "08059": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "08059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80005,
    lat: 39.85053,
    lng: -105.13031,
    city: "Arvada",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28287,
    density: 933,
    county_fips: "08059",
    county_name: "Jefferson",
    county_weights: {
      "08059": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "08059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80007,
    lat: 39.8665,
    lng: -105.19875,
    city: "Arvada",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16048,
    density: 247.6,
    county_fips: "08059",
    county_name: "Jefferson",
    county_weights: {
      "08059": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "08059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80010,
    lat: 39.73979,
    lng: -104.86193,
    city: "Aurora",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43653,
    density: 3279.5,
    county_fips: "08005",
    county_name: "Arapahoe",
    county_weights: {
      "08005": 51.06,
      "08001": 48.94,
    },
    county_names_all: "Arapahoe|Adams",
    county_fips_all: "08005|08001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80011,
    lat: 39.74393,
    lng: -104.78994,
    city: "Aurora",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51806,
    density: 979.2,
    county_fips: "08001",
    county_name: "Adams",
    county_weights: {
      "08001": 55.36,
      "08005": 44.64,
    },
    county_names_all: "Adams|Arapahoe",
    county_fips_all: "08001|08005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80012,
    lat: 39.69976,
    lng: -104.83784,
    city: "Aurora",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53862,
    density: 2736.5,
    county_fips: "08005",
    county_name: "Arapahoe",
    county_weights: {
      "08005": 99.64,
      "08031": 0.36,
    },
    county_names_all: "Arapahoe|Denver",
    county_fips_all: "08005|08031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80013,
    lat: 39.66145,
    lng: -104.76577,
    city: "Aurora",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74293,
    density: 2056.6,
    county_fips: "08005",
    county_name: "Arapahoe",
    county_weights: {
      "08005": 100,
    },
    county_names_all: "Arapahoe",
    county_fips_all: "08005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80014,
    lat: 39.66353,
    lng: -104.83781,
    city: "Aurora",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39540,
    density: 2130.9,
    county_fips: "08005",
    county_name: "Arapahoe",
    county_weights: {
      "08005": 90.05,
      "08031": 9.95,
    },
    county_names_all: "Arapahoe|Denver",
    county_fips_all: "08005|08031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80015,
    lat: 39.62737,
    lng: -104.79497,
    city: "Aurora",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 70215,
    density: 1666.8,
    county_fips: "08005",
    county_name: "Arapahoe",
    county_weights: {
      "08005": 100,
    },
    county_names_all: "Arapahoe",
    county_fips_all: "08005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80016,
    lat: 39.59391,
    lng: -104.72311,
    city: "Aurora",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58948,
    density: 705.1,
    county_fips: "08005",
    county_name: "Arapahoe",
    county_weights: {
      "08005": 95.38,
      "08035": 4.62,
    },
    county_names_all: "Arapahoe|Douglas",
    county_fips_all: "08005|08035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80017,
    lat: 39.69914,
    lng: -104.7735,
    city: "Aurora",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39182,
    density: 1650.2,
    county_fips: "08005",
    county_name: "Arapahoe",
    county_weights: {
      "08005": 100,
    },
    county_names_all: "Arapahoe",
    county_fips_all: "08005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80018,
    lat: 39.69071,
    lng: -104.68096,
    city: "Aurora",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13847,
    density: 151.1,
    county_fips: "08005",
    county_name: "Arapahoe",
    county_weights: {
      "08005": 100,
    },
    county_names_all: "Arapahoe",
    county_fips_all: "08005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80019,
    lat: 39.78653,
    lng: -104.6972,
    city: "Aurora",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3696,
    density: 50.9,
    county_fips: "08001",
    county_name: "Adams",
    county_weights: {
      "08001": 100,
    },
    county_names_all: "Adams",
    county_fips_all: "08001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80020,
    lat: 39.93121,
    lng: -105.07407,
    city: "Broomfield",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51801,
    density: 1011.9,
    county_fips: "08014",
    county_name: "Broomfield",
    county_weights: {
      "08014": 59.95,
      "08013": 24.9,
      "08059": 12.9,
      "08001": 2.25,
    },
    county_names_all: "Broomfield|Boulder|Jefferson|Adams",
    county_fips_all: "08014|08013|08059|08001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80021,
    lat: 39.89105,
    lng: -105.11448,
    city: "Broomfield",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34277,
    density: 800.4,
    county_fips: "08059",
    county_name: "Jefferson",
    county_weights: {
      "08059": 69.25,
      "08014": 30.75,
    },
    county_names_all: "Jefferson|Broomfield",
    county_fips_all: "08059|08014",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80022,
    lat: 39.86448,
    lng: -104.78868,
    city: "Commerce City",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51752,
    density: 251.1,
    county_fips: "08001",
    county_name: "Adams",
    county_weights: {
      "08001": 100,
    },
    county_names_all: "Adams",
    county_fips_all: "08001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80023,
    lat: 39.97407,
    lng: -105.01011,
    city: "Broomfield",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22290,
    density: 466.3,
    county_fips: "08014",
    county_name: "Broomfield",
    county_weights: {
      "08014": 62.91,
      "08001": 37.09,
    },
    county_names_all: "Broomfield|Adams",
    county_fips_all: "08014|08001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80024,
    lat: 39.84403,
    lng: -104.91842,
    city: "Dupont",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 209,
    density: 3650.8,
    county_fips: "08001",
    county_name: "Adams",
    county_weights: {
      "08001": 100,
    },
    county_names_all: "Adams",
    county_fips_all: "08001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80025,
    lat: 39.92444,
    lng: -105.29226,
    city: "Eldorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47,
    density: 4.5,
    county_fips: "08013",
    county_name: "Boulder",
    county_weights: {
      "08013": 99.6,
      "08059": 0.4,
    },
    county_names_all: "Boulder|Jefferson",
    county_fips_all: "08013|08059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80026,
    lat: 40.01188,
    lng: -105.0985,
    city: "Lafayette",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30817,
    density: 528.6,
    county_fips: "08013",
    county_name: "Boulder",
    county_weights: {
      "08013": 99.56,
      "08014": 0.44,
    },
    county_names_all: "Boulder|Broomfield",
    county_fips_all: "08013|08014",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80027,
    lat: 39.9508,
    lng: -105.16354,
    city: "Louisville",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32755,
    density: 678.9,
    county_fips: "08013",
    county_name: "Boulder",
    county_weights: {
      "08013": 100,
    },
    county_names_all: "Boulder",
    county_fips_all: "08013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80030,
    lat: 39.83006,
    lng: -105.03695,
    city: "Westminster",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16386,
    density: 2401.1,
    county_fips: "08001",
    county_name: "Adams",
    county_weights: {
      "08001": 100,
    },
    county_names_all: "Adams",
    county_fips_all: "08001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80031,
    lat: 39.87522,
    lng: -105.04039,
    city: "Westminster",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35753,
    density: 1635.6,
    county_fips: "08001",
    county_name: "Adams",
    county_weights: {
      "08001": 89.92,
      "08059": 10.08,
    },
    county_names_all: "Adams|Jefferson",
    county_fips_all: "08001|08059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80033,
    lat: 39.77315,
    lng: -105.10222,
    city: "Wheat Ridge",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26742,
    density: 1238.2,
    county_fips: "08059",
    county_name: "Jefferson",
    county_weights: {
      "08059": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "08059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80045,
    lat: 39.74702,
    lng: -104.83843,
    city: "Aurora",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 901,
    density: 389.2,
    county_fips: "08001",
    county_name: "Adams",
    county_weights: {
      "08001": 100,
    },
    county_names_all: "Adams",
    county_fips_all: "08001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80101,
    lat: 39.42503,
    lng: -103.95395,
    city: "Agate",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 564,
    density: 0.6,
    county_fips: "08039",
    county_name: "Elbert",
    county_weights: {
      "08039": 100,
    },
    county_names_all: "Elbert",
    county_fips_all: "08039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80102,
    lat: 39.73237,
    lng: -104.43874,
    city: "Bennett",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5960,
    density: 7.8,
    county_fips: "08001",
    county_name: "Adams",
    county_weights: {
      "08001": 48.72,
      "08005": 36.4,
      "08039": 14.88,
    },
    county_names_all: "Adams|Arapahoe|Elbert",
    county_fips_all: "08001|08005|08039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80103,
    lat: 39.78035,
    lng: -104.09576,
    city: "Byers",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2928,
    density: 3.1,
    county_fips: "08001",
    county_name: "Adams",
    county_weights: {
      "08001": 66.6,
      "08005": 33.4,
    },
    county_names_all: "Adams|Arapahoe",
    county_fips_all: "08001|08005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80104,
    lat: 39.30213,
    lng: -104.81967,
    city: "Castle Rock",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32427,
    density: 177.2,
    county_fips: "08035",
    county_name: "Douglas",
    county_weights: {
      "08035": 100,
    },
    county_names_all: "Douglas",
    county_fips_all: "08035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80105,
    lat: 39.62679,
    lng: -103.96078,
    city: "Deer Trail",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1349,
    density: 1.3,
    county_fips: "08005",
    county_name: "Arapahoe",
    county_weights: {
      "08005": 59.35,
      "08039": 27.9,
      "08001": 12.75,
    },
    county_names_all: "Arapahoe|Elbert|Adams",
    county_fips_all: "08005|08039|08001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80106,
    lat: 39.17646,
    lng: -104.52975,
    city: "Elbert",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6120,
    density: 13.7,
    county_fips: "08039",
    county_name: "Elbert",
    county_weights: {
      "08039": 79.72,
      "08041": 16.66,
      "08035": 3.62,
    },
    county_names_all: "Elbert|El Paso|Douglas",
    county_fips_all: "08039|08041|08035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80107,
    lat: 39.41195,
    lng: -104.57226,
    city: "Elizabeth",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14484,
    density: 36.2,
    county_fips: "08039",
    county_name: "Elbert",
    county_weights: {
      "08039": 100,
    },
    county_names_all: "Elbert",
    county_fips_all: "08039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80108,
    lat: 39.44441,
    lng: -104.85321,
    city: "Castle Rock",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28952,
    density: 316.8,
    county_fips: "08035",
    county_name: "Douglas",
    county_weights: {
      "08035": 100,
    },
    county_names_all: "Douglas",
    county_fips_all: "08035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80109,
    lat: 39.36473,
    lng: -104.90056,
    city: "Castle Rock",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24554,
    density: 364.8,
    county_fips: "08035",
    county_name: "Douglas",
    county_weights: {
      "08035": 100,
    },
    county_names_all: "Douglas",
    county_fips_all: "08035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80110,
    lat: 39.64612,
    lng: -105.00928,
    city: "Englewood",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23295,
    density: 1410.2,
    county_fips: "08005",
    county_name: "Arapahoe",
    county_weights: {
      "08005": 97.45,
      "08031": 2.55,
    },
    county_names_all: "Arapahoe|Denver",
    county_fips_all: "08005|08031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80111,
    lat: 39.6124,
    lng: -104.88025,
    city: "Englewood",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32495,
    density: 1151.7,
    county_fips: "08005",
    county_name: "Arapahoe",
    county_weights: {
      "08005": 100,
    },
    county_names_all: "Arapahoe",
    county_fips_all: "08005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80112,
    lat: 39.57288,
    lng: -104.85854,
    city: "Englewood",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34714,
    density: 750.9,
    county_fips: "08005",
    county_name: "Arapahoe",
    county_weights: {
      "08005": 73.14,
      "08035": 26.86,
    },
    county_names_all: "Arapahoe|Douglas",
    county_fips_all: "08005|08035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80113,
    lat: 39.64224,
    lng: -104.96189,
    city: "Englewood",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23715,
    density: 1193.6,
    county_fips: "08005",
    county_name: "Arapahoe",
    county_weights: {
      "08005": 100,
    },
    county_names_all: "Arapahoe",
    county_fips_all: "08005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80116,
    lat: 39.30711,
    lng: -104.71947,
    city: "Franktown",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4263,
    density: 17.9,
    county_fips: "08035",
    county_name: "Douglas",
    county_weights: {
      "08035": 100,
    },
    county_names_all: "Douglas",
    county_fips_all: "08035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80117,
    lat: 39.37203,
    lng: -104.39978,
    city: "Kiowa",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2413,
    density: 5,
    county_fips: "08039",
    county_name: "Elbert",
    county_weights: {
      "08039": 100,
    },
    county_names_all: "Elbert",
    county_fips_all: "08039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80118,
    lat: 39.19132,
    lng: -104.8848,
    city: "Larkspur",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5998,
    density: 17.7,
    county_fips: "08035",
    county_name: "Douglas",
    county_weights: {
      "08035": 100,
    },
    county_names_all: "Douglas",
    county_fips_all: "08035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80120,
    lat: 39.5929,
    lng: -105.00949,
    city: "Littleton",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30632,
    density: 1413.8,
    county_fips: "08005",
    county_name: "Arapahoe",
    county_weights: {
      "08005": 98.63,
      "08035": 1.37,
    },
    county_names_all: "Arapahoe|Douglas",
    county_fips_all: "08005|08035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80121,
    lat: 39.61045,
    lng: -104.95421,
    city: "Littleton",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18567,
    density: 994,
    county_fips: "08005",
    county_name: "Arapahoe",
    county_weights: {
      "08005": 100,
    },
    county_names_all: "Arapahoe",
    county_fips_all: "08005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80122,
    lat: 39.5806,
    lng: -104.95573,
    city: "Littleton",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33120,
    density: 1797.5,
    county_fips: "08005",
    county_name: "Arapahoe",
    county_weights: {
      "08005": 100,
    },
    county_names_all: "Arapahoe",
    county_fips_all: "08005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80123,
    lat: 39.61578,
    lng: -105.0692,
    city: "Littleton",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46575,
    density: 1495.7,
    county_fips: "08059",
    county_name: "Jefferson",
    county_weights: {
      "08059": 46.53,
      "08005": 29.28,
      "08031": 24.19,
    },
    county_names_all: "Jefferson|Arapahoe|Denver",
    county_fips_all: "08059|08005|08031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80124,
    lat: 39.53197,
    lng: -104.89173,
    city: "Lone Tree",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21646,
    density: 890.6,
    county_fips: "08035",
    county_name: "Douglas",
    county_weights: {
      "08035": 100,
    },
    county_names_all: "Douglas",
    county_fips_all: "08035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80125,
    lat: 39.48546,
    lng: -105.05737,
    city: "Littleton",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10832,
    density: 106.7,
    county_fips: "08035",
    county_name: "Douglas",
    county_weights: {
      "08035": 99.63,
      "08059": 0.37,
    },
    county_names_all: "Douglas|Jefferson",
    county_fips_all: "08035|08059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80126,
    lat: 39.54127,
    lng: -104.96251,
    city: "Littleton",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44574,
    density: 1591,
    county_fips: "08035",
    county_name: "Douglas",
    county_weights: {
      "08035": 100,
    },
    county_names_all: "Douglas",
    county_fips_all: "08035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80127,
    lat: 39.52249,
    lng: -105.15773,
    city: "Littleton",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44866,
    density: 260.9,
    county_fips: "08059",
    county_name: "Jefferson",
    county_weights: {
      "08059": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "08059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80128,
    lat: 39.56167,
    lng: -105.07914,
    city: "Littleton",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37181,
    density: 1143,
    county_fips: "08059",
    county_name: "Jefferson",
    county_weights: {
      "08059": 87.27,
      "08005": 12.73,
    },
    county_names_all: "Jefferson|Arapahoe",
    county_fips_all: "08059|08005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80129,
    lat: 39.54521,
    lng: -105.01203,
    city: "Littleton",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32286,
    density: 1770.6,
    county_fips: "08035",
    county_name: "Douglas",
    county_weights: {
      "08035": 99.49,
      "08005": 0.51,
    },
    county_names_all: "Douglas|Arapahoe",
    county_fips_all: "08035|08005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80130,
    lat: 39.52918,
    lng: -104.92448,
    city: "Littleton",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27892,
    density: 1566.4,
    county_fips: "08035",
    county_name: "Douglas",
    county_weights: {
      "08035": 100,
    },
    county_names_all: "Douglas",
    county_fips_all: "08035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80131,
    lat: 39.47627,
    lng: -105.00899,
    city: "Louviers",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 381,
    density: 265.2,
    county_fips: "08035",
    county_name: "Douglas",
    county_weights: {
      "08035": 100,
    },
    county_names_all: "Douglas",
    county_fips_all: "08035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80132,
    lat: 39.09183,
    lng: -104.8576,
    city: "Monument",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21422,
    density: 207.4,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80133,
    lat: 39.1155,
    lng: -104.90443,
    city: "Palmer Lake",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2712,
    density: 352.7,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80134,
    lat: 39.48282,
    lng: -104.77957,
    city: "Parker",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 71112,
    density: 478.8,
    county_fips: "08035",
    county_name: "Douglas",
    county_weights: {
      "08035": 100,
    },
    county_names_all: "Douglas",
    county_fips_all: "08035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80135,
    lat: 39.27763,
    lng: -105.13494,
    city: "Sedalia",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4212,
    density: 4.4,
    county_fips: "08035",
    county_name: "Douglas",
    county_weights: {
      "08035": 82.31,
      "08059": 17.69,
    },
    county_names_all: "Douglas|Jefferson",
    county_fips_all: "08035|08059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80136,
    lat: 39.80729,
    lng: -104.29613,
    city: "Strasburg",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5369,
    density: 9.8,
    county_fips: "08001",
    county_name: "Adams",
    county_weights: {
      "08001": 68.68,
      "08005": 31.32,
    },
    county_names_all: "Adams|Arapahoe",
    county_fips_all: "08001|08005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80137,
    lat: 39.70901,
    lng: -104.59235,
    city: "Watkins",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2157,
    density: 7.7,
    county_fips: "08005",
    county_name: "Arapahoe",
    county_weights: {
      "08005": 59.33,
      "08001": 40.67,
    },
    county_names_all: "Arapahoe|Adams",
    county_fips_all: "08005|08001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80138,
    lat: 39.51649,
    lng: -104.67114,
    city: "Parker",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34692,
    density: 216.3,
    county_fips: "08035",
    county_name: "Douglas",
    county_weights: {
      "08035": 55.41,
      "08039": 44.59,
    },
    county_names_all: "Douglas|Elbert",
    county_fips_all: "08035|08039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80202,
    lat: 39.75156,
    lng: -104.99768,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15813,
    density: 5280.2,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 100,
    },
    county_names_all: "Denver",
    county_fips_all: "08031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80203,
    lat: 39.73142,
    lng: -104.98274,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21368,
    density: 7549.9,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 100,
    },
    county_names_all: "Denver",
    county_fips_all: "08031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80204,
    lat: 39.73476,
    lng: -105.0207,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34860,
    density: 2455.7,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 100,
    },
    county_names_all: "Denver",
    county_fips_all: "08031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80205,
    lat: 39.75891,
    lng: -104.96353,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34884,
    density: 2899.3,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 100,
    },
    county_names_all: "Denver",
    county_fips_all: "08031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80206,
    lat: 39.73041,
    lng: -104.95258,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24913,
    density: 3882.5,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 100,
    },
    county_names_all: "Denver",
    county_fips_all: "08031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80207,
    lat: 39.76137,
    lng: -104.91674,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27326,
    density: 2691.7,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 100,
    },
    county_names_all: "Denver",
    county_fips_all: "08031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80209,
    lat: 39.70608,
    lng: -104.9656,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25032,
    density: 2759.2,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 100,
    },
    county_names_all: "Denver",
    county_fips_all: "08031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80210,
    lat: 39.6781,
    lng: -104.96275,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37786,
    density: 2396.1,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 100,
    },
    county_names_all: "Denver",
    county_fips_all: "08031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80211,
    lat: 39.76715,
    lng: -105.02006,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36061,
    density: 3084.4,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 100,
    },
    county_names_all: "Denver",
    county_fips_all: "08031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80212,
    lat: 39.77174,
    lng: -105.04819,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20240,
    density: 2193.2,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 74.66,
      "08059": 18.07,
      "08001": 7.27,
    },
    county_names_all: "Denver|Jefferson|Adams",
    county_fips_all: "08031|08059|08001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80214,
    lat: 39.74205,
    lng: -105.07123,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26021,
    density: 2152,
    county_fips: "08059",
    county_name: "Jefferson",
    county_weights: {
      "08059": 99.16,
      "08031": 0.84,
    },
    county_names_all: "Jefferson|Denver",
    county_fips_all: "08059|08031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80215,
    lat: 39.74412,
    lng: -105.1158,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20061,
    density: 1419,
    county_fips: "08059",
    county_name: "Jefferson",
    county_weights: {
      "08059": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "08059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80216,
    lat: 39.78659,
    lng: -104.96187,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14687,
    density: 559.7,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 71.56,
      "08001": 28.44,
    },
    county_names_all: "Denver|Adams",
    county_fips_all: "08031|08001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80218,
    lat: 39.73119,
    lng: -104.97073,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18915,
    density: 4614.2,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 100,
    },
    county_names_all: "Denver",
    county_fips_all: "08031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80219,
    lat: 39.69496,
    lng: -105.03432,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 71795,
    density: 3755.4,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 100,
    },
    county_names_all: "Denver",
    county_fips_all: "08031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80220,
    lat: 39.73375,
    lng: -104.91648,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36790,
    density: 2747.1,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 99.52,
      "08001": 0.31,
      "08005": 0.17,
    },
    county_names_all: "Denver|Adams|Arapahoe",
    county_fips_all: "08031|08001|08005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80221,
    lat: 39.81555,
    lng: -105.0103,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40266,
    density: 1711.3,
    county_fips: "08001",
    county_name: "Adams",
    county_weights: {
      "08001": 88.51,
      "08031": 11.49,
    },
    county_names_all: "Adams|Denver",
    county_fips_all: "08001|08031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80222,
    lat: 39.6713,
    lng: -104.92828,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24682,
    density: 2491.6,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 84.99,
      "08005": 15.01,
    },
    county_names_all: "Denver|Arapahoe",
    county_fips_all: "08031|08005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80223,
    lat: 39.69646,
    lng: -105.00216,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20888,
    density: 1519.8,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 100,
    },
    county_names_all: "Denver",
    county_fips_all: "08031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80224,
    lat: 39.68803,
    lng: -104.91161,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19450,
    density: 2290.5,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 97.44,
      "08005": 2.56,
    },
    county_names_all: "Denver|Arapahoe",
    county_fips_all: "08031|08005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80226,
    lat: 39.71081,
    lng: -105.09155,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33022,
    density: 1571.5,
    county_fips: "08059",
    county_name: "Jefferson",
    county_weights: {
      "08059": 99.4,
      "08031": 0.6,
    },
    county_names_all: "Jefferson|Denver",
    county_fips_all: "08059|08031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80227,
    lat: 39.66331,
    lng: -105.10536,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34850,
    density: 1244.4,
    county_fips: "08059",
    county_name: "Jefferson",
    county_weights: {
      "08059": 86.15,
      "08031": 13.85,
    },
    county_names_all: "Jefferson|Denver",
    county_fips_all: "08059|08031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80228,
    lat: 39.69186,
    lng: -105.15726,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34518,
    density: 1162.7,
    county_fips: "08059",
    county_name: "Jefferson",
    county_weights: {
      "08059": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "08059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80229,
    lat: 39.85472,
    lng: -104.95867,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56721,
    density: 1750.5,
    county_fips: "08001",
    county_name: "Adams",
    county_weights: {
      "08001": 100,
    },
    county_names_all: "Adams",
    county_fips_all: "08001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80230,
    lat: 39.72032,
    lng: -104.88933,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10077,
    density: 1412.4,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 90.54,
      "08005": 9.46,
    },
    county_names_all: "Denver|Arapahoe",
    county_fips_all: "08031|08005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80231,
    lat: 39.67123,
    lng: -104.88787,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36103,
    density: 2855.4,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 58.05,
      "08005": 41.95,
    },
    county_names_all: "Denver|Arapahoe",
    county_fips_all: "08031|08005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80232,
    lat: 39.68892,
    lng: -105.08983,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23102,
    density: 2296.8,
    county_fips: "08059",
    county_name: "Jefferson",
    county_weights: {
      "08059": 99.29,
      "08031": 0.71,
    },
    county_names_all: "Jefferson|Denver",
    county_fips_all: "08059|08031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80233,
    lat: 39.89937,
    lng: -104.94697,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50321,
    density: 2125.7,
    county_fips: "08001",
    county_name: "Adams",
    county_weights: {
      "08001": 100,
    },
    county_names_all: "Adams",
    county_fips_all: "08001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80234,
    lat: 39.91208,
    lng: -105.00526,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29310,
    density: 1606.9,
    county_fips: "08001",
    county_name: "Adams",
    county_weights: {
      "08001": 97.9,
      "08014": 2.1,
    },
    county_names_all: "Adams|Broomfield",
    county_fips_all: "08001|08014",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80235,
    lat: 39.64615,
    lng: -105.08909,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8565,
    density: 973.8,
    county_fips: "08059",
    county_name: "Jefferson",
    county_weights: {
      "08059": 74.92,
      "08031": 25.08,
    },
    county_names_all: "Jefferson|Denver",
    county_fips_all: "08059|08031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80236,
    lat: 39.65169,
    lng: -105.03966,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18580,
    density: 2233.4,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 96.4,
      "08005": 3.6,
    },
    county_names_all: "Denver|Arapahoe",
    county_fips_all: "08031|08005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80237,
    lat: 39.63996,
    lng: -104.90178,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21771,
    density: 2319.8,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 99.75,
      "08005": 0.25,
    },
    county_names_all: "Denver|Arapahoe",
    county_fips_all: "08031|08005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80238,
    lat: 39.77722,
    lng: -104.8808,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21355,
    density: 1213.9,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 100,
    },
    county_names_all: "Denver",
    county_fips_all: "08031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80239,
    lat: 39.78801,
    lng: -104.8333,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48835,
    density: 1824.9,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 79.67,
      "08001": 20.33,
    },
    county_names_all: "Denver|Adams",
    county_fips_all: "08031|08001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80241,
    lat: 39.92876,
    lng: -104.95492,
    city: "Thornton",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34856,
    density: 2046.9,
    county_fips: "08001",
    county_name: "Adams",
    county_weights: {
      "08001": 100,
    },
    county_names_all: "Adams",
    county_fips_all: "08001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80246,
    lat: 39.70461,
    lng: -104.9314,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13277,
    density: 3067.3,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 65.59,
      "08005": 34.41,
    },
    county_names_all: "Denver|Arapahoe",
    county_fips_all: "08031|08005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80247,
    lat: 39.69684,
    lng: -104.88127,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30161,
    density: 3998.3,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 54.07,
      "08005": 45.93,
    },
    county_names_all: "Denver|Arapahoe",
    county_fips_all: "08031|08005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80249,
    lat: 39.84964,
    lng: -104.69496,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35104,
    density: 284.4,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 100,
    },
    county_names_all: "Denver",
    county_fips_all: "08031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80260,
    lat: 39.86705,
    lng: -105.00569,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36938,
    density: 2993.9,
    county_fips: "08001",
    county_name: "Adams",
    county_weights: {
      "08001": 100,
    },
    county_names_all: "Adams",
    county_fips_all: "08001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80264,
    lat: 39.74248,
    lng: -104.98548,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 100,
    },
    county_names_all: "Denver",
    county_fips_all: "08031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80266,
    lat: 39.79002,
    lng: -104.90021,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 100,
    },
    county_names_all: "Denver",
    county_fips_all: "08031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80290,
    lat: 39.74411,
    lng: -104.98675,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 96,
    density: 4925.9,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 100,
    },
    county_names_all: "Denver",
    county_fips_all: "08031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80293,
    lat: 39.74608,
    lng: -104.98972,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 100,
    },
    county_names_all: "Denver",
    county_fips_all: "08031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80294,
    lat: 39.74979,
    lng: -104.98971,
    city: "Denver",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "08031",
    county_name: "Denver",
    county_weights: {
      "08031": 100,
    },
    county_names_all: "Denver",
    county_fips_all: "08031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80301,
    lat: 40.04795,
    lng: -105.19876,
    city: "Boulder",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26010,
    density: 350.6,
    county_fips: "08013",
    county_name: "Boulder",
    county_weights: {
      "08013": 100,
    },
    county_names_all: "Boulder",
    county_fips_all: "08013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80302,
    lat: 40.0306,
    lng: -105.35542,
    city: "Boulder",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29422,
    density: 121,
    county_fips: "08013",
    county_name: "Boulder",
    county_weights: {
      "08013": 100,
    },
    county_names_all: "Boulder",
    county_fips_all: "08013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80303,
    lat: 39.97422,
    lng: -105.21206,
    city: "Boulder",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25709,
    density: 453.6,
    county_fips: "08013",
    county_name: "Boulder",
    county_weights: {
      "08013": 100,
    },
    county_names_all: "Boulder",
    county_fips_all: "08013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80304,
    lat: 40.04557,
    lng: -105.29006,
    city: "Boulder",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26501,
    density: 1133.6,
    county_fips: "08013",
    county_name: "Boulder",
    county_weights: {
      "08013": 100,
    },
    county_names_all: "Boulder",
    county_fips_all: "08013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80305,
    lat: 39.97733,
    lng: -105.24877,
    city: "Boulder",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17305,
    density: 1148,
    county_fips: "08013",
    county_name: "Boulder",
    county_weights: {
      "08013": 100,
    },
    county_names_all: "Boulder",
    county_fips_all: "08013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80310,
    lat: 40.00465,
    lng: -105.26254,
    city: "Boulder",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7296,
    density: 5166.6,
    county_fips: "08013",
    county_name: "Boulder",
    county_weights: {
      "08013": 100,
    },
    county_names_all: "Boulder",
    county_fips_all: "08013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80401,
    lat: 39.71672,
    lng: -105.23286,
    city: "Golden",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42907,
    density: 337.6,
    county_fips: "08059",
    county_name: "Jefferson",
    county_weights: {
      "08059": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "08059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80403,
    lat: 39.83229,
    lng: -105.32013,
    city: "Golden",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20302,
    density: 55.2,
    county_fips: "08059",
    county_name: "Jefferson",
    county_weights: {
      "08059": 82.13,
      "08047": 12.44,
      "08013": 5.43,
    },
    county_names_all: "Jefferson|Gilpin|Boulder",
    county_fips_all: "08059|08047|08013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80419,
    lat: 39.7284,
    lng: -105.20239,
    city: "Golden",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "08059",
    county_name: "Jefferson",
    county_weights: {
      "08059": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "08059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80420,
    lat: 39.31451,
    lng: -106.10553,
    city: "Alma",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 679,
    density: 6.2,
    county_fips: "08093",
    county_name: "Park",
    county_weights: {
      "08093": 100,
    },
    county_names_all: "Park",
    county_fips_all: "08093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80421,
    lat: 39.48166,
    lng: -105.50462,
    city: "Bailey",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9683,
    density: 35.8,
    county_fips: "08093",
    county_name: "Park",
    county_weights: {
      "08093": 97.9,
      "08059": 2.1,
    },
    county_names_all: "Park|Jefferson",
    county_fips_all: "08093|08059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80422,
    lat: 39.8635,
    lng: -105.53846,
    city: "Black Hawk",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4992,
    density: 18,
    county_fips: "08047",
    county_name: "Gilpin",
    county_weights: {
      "08047": 100,
    },
    county_names_all: "Gilpin",
    county_fips_all: "08047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80423,
    lat: 39.84776,
    lng: -106.55359,
    city: "Bond",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 214,
    density: 0.3,
    county_fips: "08037",
    county_name: "Eagle",
    county_weights: {
      "08037": 84.94,
      "08049": 15.06,
    },
    county_names_all: "Eagle|Grand",
    county_fips_all: "08037|08049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80424,
    lat: 39.47089,
    lng: -106.01685,
    city: "Breckenridge",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10769,
    density: 33,
    county_fips: "08117",
    county_name: "Summit",
    county_weights: {
      "08117": 100,
    },
    county_names_all: "Summit",
    county_fips_all: "08117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80425,
    lat: 39.34714,
    lng: -105.23162,
    city: "Buffalo Creek",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 130,
    density: 0.9,
    county_fips: "08059",
    county_name: "Jefferson",
    county_weights: {
      "08059": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "08059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80426,
    lat: 39.87393,
    lng: -106.98452,
    city: "Burns",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48,
    density: 0.2,
    county_fips: "08037",
    county_name: "Eagle",
    county_weights: {
      "08037": 100,
    },
    county_names_all: "Eagle",
    county_fips_all: "08037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80427,
    lat: 39.79366,
    lng: -105.52413,
    city: "Central City",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 531,
    density: 14.2,
    county_fips: "08047",
    county_name: "Gilpin",
    county_weights: {
      "08047": 99.9,
      "08019": 0.1,
    },
    county_names_all: "Gilpin|Clear Creek",
    county_fips_all: "08047|08019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80428,
    lat: 40.85326,
    lng: -106.91373,
    city: "Clark",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 627,
    density: 1.2,
    county_fips: "08107",
    county_name: "Routt",
    county_weights: {
      "08107": 100,
    },
    county_names_all: "Routt",
    county_fips_all: "08107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80430,
    lat: 40.50925,
    lng: -106.44688,
    city: "Coalmont",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "08057",
    county_name: "Jackson",
    county_weights: {
      "08057": 100,
    },
    county_names_all: "Jackson",
    county_fips_all: "08057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80432,
    lat: 39.22256,
    lng: -105.82969,
    city: "Como",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 215,
    density: 0.4,
    county_fips: "08093",
    county_name: "Park",
    county_weights: {
      "08093": 100,
    },
    county_names_all: "Park",
    county_fips_all: "08093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80433,
    lat: 39.49636,
    lng: -105.29586,
    city: "Conifer",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8605,
    density: 50,
    county_fips: "08059",
    county_name: "Jefferson",
    county_weights: {
      "08059": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "08059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80434,
    lat: 40.91209,
    lng: -106.28228,
    city: "Cowdrey",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29,
    density: 0.1,
    county_fips: "08057",
    county_name: "Jackson",
    county_weights: {
      "08057": 100,
    },
    county_names_all: "Jackson",
    county_fips_all: "08057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80435,
    lat: 39.60161,
    lng: -105.92452,
    city: "Dillon",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8176,
    density: 30.3,
    county_fips: "08117",
    county_name: "Summit",
    county_weights: {
      "08117": 100,
    },
    county_names_all: "Summit",
    county_fips_all: "08117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80436,
    lat: 39.78203,
    lng: -105.64349,
    city: "Dumont",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 547,
    density: 12,
    county_fips: "08019",
    county_name: "Clear Creek",
    county_weights: {
      "08019": 100,
    },
    county_names_all: "Clear Creek",
    county_fips_all: "08019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80438,
    lat: 39.7602,
    lng: -105.78356,
    city: "Empire",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 613,
    density: 4.3,
    county_fips: "08019",
    county_name: "Clear Creek",
    county_weights: {
      "08019": 100,
    },
    county_names_all: "Clear Creek",
    county_fips_all: "08019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80439,
    lat: 39.6343,
    lng: -105.42994,
    city: "Evergreen",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25374,
    density: 58,
    county_fips: "08019",
    county_name: "Clear Creek",
    county_weights: {
      "08019": 58.27,
      "08059": 41.73,
    },
    county_names_all: "Clear Creek|Jefferson",
    county_fips_all: "08019|08059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80440,
    lat: 39.13412,
    lng: -106.04137,
    city: "Fairplay",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2568,
    density: 3.1,
    county_fips: "08093",
    county_name: "Park",
    county_weights: {
      "08093": 100,
    },
    county_names_all: "Park",
    county_fips_all: "08093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80442,
    lat: 39.91633,
    lng: -105.89813,
    city: "Fraser",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2140,
    density: 15,
    county_fips: "08049",
    county_name: "Grand",
    county_weights: {
      "08049": 100,
    },
    county_names_all: "Grand",
    county_fips_all: "08049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80443,
    lat: 39.50165,
    lng: -106.16673,
    city: "Frisco",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4056,
    density: 15.3,
    county_fips: "08117",
    county_name: "Summit",
    county_weights: {
      "08117": 100,
    },
    county_names_all: "Summit",
    county_fips_all: "08117",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80444,
    lat: 39.63138,
    lng: -105.73078,
    city: "Georgetown",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1222,
    density: 12.4,
    county_fips: "08019",
    county_name: "Clear Creek",
    county_weights: {
      "08019": 100,
    },
    county_names_all: "Clear Creek",
    county_fips_all: "08019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80446,
    lat: 40.16335,
    lng: -105.937,
    city: "Granby",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4041,
    density: 4.2,
    county_fips: "08049",
    county_name: "Grand",
    county_weights: {
      "08049": 100,
    },
    county_names_all: "Grand",
    county_fips_all: "08049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80447,
    lat: 40.30116,
    lng: -105.81712,
    city: "Grand Lake",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2067,
    density: 3.9,
    county_fips: "08049",
    county_name: "Grand",
    county_weights: {
      "08049": 100,
    },
    county_names_all: "Grand",
    county_fips_all: "08049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80448,
    lat: 39.41769,
    lng: -105.63747,
    city: "Grant",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "08093",
    county_name: "Park",
    county_weights: {
      "08093": 100,
    },
    county_names_all: "Park",
    county_fips_all: "08093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80449,
    lat: 38.93059,
    lng: -105.79169,
    city: "Hartsel",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1237,
    density: 1.1,
    county_fips: "08093",
    county_name: "Park",
    county_weights: {
      "08093": 97.52,
      "08015": 2.48,
    },
    county_names_all: "Park|Chaffee",
    county_fips_all: "08093|08015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80451,
    lat: 40.04007,
    lng: -106.04456,
    city: "Hot Sulphur Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1094,
    density: 11.4,
    county_fips: "08049",
    county_name: "Grand",
    county_weights: {
      "08049": 100,
    },
    county_names_all: "Grand",
    county_fips_all: "08049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80452,
    lat: 39.70969,
    lng: -105.59515,
    city: "Idaho Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3151,
    density: 9.4,
    county_fips: "08019",
    county_name: "Clear Creek",
    county_weights: {
      "08019": 98.1,
      "08047": 1.9,
    },
    county_names_all: "Clear Creek|Gilpin",
    county_fips_all: "08019|08047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80453,
    lat: 39.66477,
    lng: -105.24285,
    city: "Idledale",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 229,
    density: 167.7,
    county_fips: "08059",
    county_name: "Jefferson",
    county_weights: {
      "08059": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "08059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80454,
    lat: 39.63109,
    lng: -105.25204,
    city: "Indian Hills",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1343,
    density: 103,
    county_fips: "08059",
    county_name: "Jefferson",
    county_weights: {
      "08059": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "08059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80455,
    lat: 40.11071,
    lng: -105.39071,
    city: "Jamestown",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 474,
    density: 5.7,
    county_fips: "08013",
    county_name: "Boulder",
    county_weights: {
      "08013": 100,
    },
    county_names_all: "Boulder",
    county_fips_all: "08013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80456,
    lat: 39.30643,
    lng: -105.69211,
    city: "Jefferson",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 302,
    density: 0.5,
    county_fips: "08093",
    county_name: "Park",
    county_weights: {
      "08093": 100,
    },
    county_names_all: "Park",
    county_fips_all: "08093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80457,
    lat: 39.65091,
    lng: -105.29972,
    city: "Kittredge",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 171,
    density: 107.4,
    county_fips: "08059",
    county_name: "Jefferson",
    county_weights: {
      "08059": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "08059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80459,
    lat: 40.1843,
    lng: -106.41877,
    city: "Kremmling",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2997,
    density: 1.9,
    county_fips: "08049",
    county_name: "Grand",
    county_weights: {
      "08049": 100,
    },
    county_names_all: "Grand",
    county_fips_all: "08049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80461,
    lat: 39.24244,
    lng: -106.29016,
    city: "Leadville",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7682,
    density: 12.5,
    county_fips: "08065",
    county_name: "Lake",
    county_weights: {
      "08065": 100,
    },
    county_names_all: "Lake",
    county_fips_all: "08065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80463,
    lat: 39.95523,
    lng: -106.73888,
    city: "McCoy",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 185,
    density: 0.6,
    county_fips: "08107",
    county_name: "Routt",
    county_weights: {
      "08107": 75.62,
      "08037": 24.38,
    },
    county_names_all: "Routt|Eagle",
    county_fips_all: "08107|08037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80465,
    lat: 39.60437,
    lng: -105.21521,
    city: "Morrison",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16030,
    density: 142.6,
    county_fips: "08059",
    county_name: "Jefferson",
    county_weights: {
      "08059": 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: "08059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80466,
    lat: 39.99008,
    lng: -105.546,
    city: "Nederland",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3723,
    density: 12.4,
    county_fips: "08013",
    county_name: "Boulder",
    county_weights: {
      "08013": 100,
    },
    county_names_all: "Boulder",
    county_fips_all: "08013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80467,
    lat: 40.25692,
    lng: -106.87326,
    city: "Oak Creek",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2193,
    density: 3.1,
    county_fips: "08107",
    county_name: "Routt",
    county_weights: {
      "08107": 93.58,
      "08103": 6.42,
    },
    county_names_all: "Routt|Rio Blanco",
    county_fips_all: "08107|08103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80468,
    lat: 39.91447,
    lng: -106.10979,
    city: "Parshall",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 322,
    density: 0.4,
    county_fips: "08049",
    county_name: "Grand",
    county_weights: {
      "08049": 100,
    },
    county_names_all: "Grand",
    county_fips_all: "08049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80469,
    lat: 40.21448,
    lng: -106.96797,
    city: "Phippsburg",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 365,
    density: 3.8,
    county_fips: "08107",
    county_name: "Routt",
    county_weights: {
      "08107": 100,
    },
    county_names_all: "Routt",
    county_fips_all: "08107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80470,
    lat: 39.40104,
    lng: -105.34527,
    city: "Pine",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4253,
    density: 16.1,
    county_fips: "08059",
    county_name: "Jefferson",
    county_weights: {
      "08059": 81.35,
      "08093": 18.65,
    },
    county_names_all: "Jefferson|Park",
    county_fips_all: "08059|08093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80471,
    lat: 39.93507,
    lng: -105.42048,
    city: "Pinecliffe",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "08013",
    county_name: "Boulder",
    county_weights: {
      "08013": 99.74,
      "08047": 0.26,
    },
    county_names_all: "Boulder|Gilpin",
    county_fips_all: "08013|08047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80473,
    lat: 40.45096,
    lng: -106.1555,
    city: "Rand",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50,
    density: 0.5,
    county_fips: "08057",
    county_name: "Jackson",
    county_weights: {
      "08057": 100,
    },
    county_names_all: "Jackson",
    county_fips_all: "08057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80474,
    lat: 39.92353,
    lng: -105.56404,
    city: "Rollinsville",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "08047",
    county_name: "Gilpin",
    county_weights: {
      "08047": 100,
    },
    county_names_all: "Gilpin",
    county_fips_all: "08047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80475,
    lat: 39.43012,
    lng: -105.59234,
    city: "Shawnee",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10,
    density: 0.1,
    county_fips: "08093",
    county_name: "Park",
    county_weights: {
      "08093": 100,
    },
    county_names_all: "Park",
    county_fips_all: "08093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80476,
    lat: 39.68522,
    lng: -105.80972,
    city: "Silver Plume",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 175,
    density: 1.2,
    county_fips: "08019",
    county_name: "Clear Creek",
    county_weights: {
      "08019": 100,
    },
    county_names_all: "Clear Creek",
    county_fips_all: "08019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80478,
    lat: 40.02218,
    lng: -105.85693,
    city: "Tabernash",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1491,
    density: 15.7,
    county_fips: "08049",
    county_name: "Grand",
    county_weights: {
      "08049": 100,
    },
    county_names_all: "Grand",
    county_fips_all: "08049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80479,
    lat: 40.02078,
    lng: -106.86356,
    city: "Toponas",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "08107",
    county_name: "Routt",
    county_weights: {
      "08107": 100,
    },
    county_names_all: "Routt",
    county_fips_all: "08107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80480,
    lat: 40.67188,
    lng: -106.34175,
    city: "Walden",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1237,
    density: 0.4,
    county_fips: "08057",
    county_name: "Jackson",
    county_weights: {
      "08057": 100,
    },
    county_names_all: "Jackson",
    county_fips_all: "08057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80481,
    lat: 40.10351,
    lng: -105.52253,
    city: "Ward",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 617,
    density: 5.5,
    county_fips: "08013",
    county_name: "Boulder",
    county_weights: {
      "08013": 100,
    },
    county_names_all: "Boulder",
    county_fips_all: "08013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80482,
    lat: 39.90429,
    lng: -105.78404,
    city: "Winter Park",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1308,
    density: 3.6,
    county_fips: "08049",
    county_name: "Grand",
    county_weights: {
      "08049": 100,
    },
    county_names_all: "Grand",
    county_fips_all: "08049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80483,
    lat: 40.12482,
    lng: -106.92124,
    city: "Yampa",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 661,
    density: 2.6,
    county_fips: "08107",
    county_name: "Routt",
    county_weights: {
      "08107": 100,
    },
    county_names_all: "Routt",
    county_fips_all: "08107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80487,
    lat: 40.58803,
    lng: -106.89321,
    city: "Steamboat Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18150,
    density: 8.8,
    county_fips: "08107",
    county_name: "Routt",
    county_weights: {
      "08107": 100,
    },
    county_names_all: "Routt",
    county_fips_all: "08107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80498,
    lat: 39.7794,
    lng: -106.22338,
    city: "Silverthorne",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7473,
    density: 9.8,
    county_fips: "08117",
    county_name: "Summit",
    county_weights: {
      "08117": 93.82,
      "08049": 6.18,
    },
    county_names_all: "Summit|Grand",
    county_fips_all: "08117|08049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80501,
    lat: 40.16479,
    lng: -105.10208,
    city: "Longmont",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43773,
    density: 1339.4,
    county_fips: "08013",
    county_name: "Boulder",
    county_weights: {
      "08013": 100,
    },
    county_names_all: "Boulder",
    county_fips_all: "08013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80503,
    lat: 40.16922,
    lng: -105.20725,
    city: "Longmont",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36056,
    density: 151.7,
    county_fips: "08013",
    county_name: "Boulder",
    county_weights: {
      "08013": 98.01,
      "08069": 1.99,
    },
    county_names_all: "Boulder|Larimer",
    county_fips_all: "08013|08069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80504,
    lat: 40.16523,
    lng: -105.03029,
    city: "Longmont",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53743,
    density: 219.4,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 58.58,
      "08013": 40.8,
      "08069": 0.62,
    },
    county_names_all: "Weld|Boulder|Larimer",
    county_fips_all: "08123|08013|08069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80510,
    lat: 40.20964,
    lng: -105.57878,
    city: "Allenspark",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 363,
    density: 2.1,
    county_fips: "08013",
    county_name: "Boulder",
    county_weights: {
      "08013": 100,
    },
    county_names_all: "Boulder",
    county_fips_all: "08013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80512,
    lat: 40.62989,
    lng: -105.56828,
    city: "Bellvue",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1602,
    density: 1.3,
    county_fips: "08069",
    county_name: "Larimer",
    county_weights: {
      "08069": 100,
    },
    county_names_all: "Larimer",
    county_fips_all: "08069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80513,
    lat: 40.29789,
    lng: -105.10913,
    city: "Berthoud",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13650,
    density: 73.8,
    county_fips: "08069",
    county_name: "Larimer",
    county_weights: {
      "08069": 65.52,
      "08123": 29.5,
      "08013": 4.98,
    },
    county_names_all: "Larimer|Weld|Boulder",
    county_fips_all: "08069|08123|08013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80514,
    lat: 40.07152,
    lng: -104.95401,
    city: "Dacono",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5947,
    density: 249.1,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 100,
    },
    county_names_all: "Weld",
    county_fips_all: "08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80515,
    lat: 40.45659,
    lng: -105.37726,
    city: "Drake",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 896,
    density: 7.1,
    county_fips: "08069",
    county_name: "Larimer",
    county_weights: {
      "08069": 100,
    },
    county_names_all: "Larimer",
    county_fips_all: "08069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80516,
    lat: 40.05333,
    lng: -105.01869,
    city: "Erie",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31063,
    density: 296.5,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 76.29,
      "08013": 14.46,
      "08014": 9.25,
    },
    county_names_all: "Weld|Boulder|Broomfield",
    county_fips_all: "08123|08013|08014",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80517,
    lat: 40.39731,
    lng: -105.61165,
    city: "Estes Park",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11416,
    density: 14.8,
    county_fips: "08069",
    county_name: "Larimer",
    county_weights: {
      "08069": 100,
    },
    county_names_all: "Larimer",
    county_fips_all: "08069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80520,
    lat: 40.11387,
    lng: -104.93347,
    city: "Firestone",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1416,
    density: 928.3,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 100,
    },
    county_names_all: "Weld",
    county_fips_all: "08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80521,
    lat: 40.59372,
    lng: -105.1268,
    city: "Fort Collins",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37796,
    density: 1040.9,
    county_fips: "08069",
    county_name: "Larimer",
    county_weights: {
      "08069": 100,
    },
    county_names_all: "Larimer",
    county_fips_all: "08069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80524,
    lat: 40.64814,
    lng: -105.02155,
    city: "Fort Collins",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37656,
    density: 118.5,
    county_fips: "08069",
    county_name: "Larimer",
    county_weights: {
      "08069": 77.17,
      "08123": 22.83,
    },
    county_names_all: "Larimer|Weld",
    county_fips_all: "08069|08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80525,
    lat: 40.52795,
    lng: -105.04249,
    city: "Fort Collins",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56233,
    density: 929.5,
    county_fips: "08069",
    county_name: "Larimer",
    county_weights: {
      "08069": 100,
    },
    county_names_all: "Larimer",
    county_fips_all: "08069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80526,
    lat: 40.5174,
    lng: -105.13262,
    city: "Fort Collins",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45220,
    density: 546.1,
    county_fips: "08069",
    county_name: "Larimer",
    county_weights: {
      "08069": 100,
    },
    county_names_all: "Larimer",
    county_fips_all: "08069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80528,
    lat: 40.49343,
    lng: -105.00075,
    city: "Fort Collins",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21387,
    density: 447.1,
    county_fips: "08069",
    county_name: "Larimer",
    county_weights: {
      "08069": 100,
    },
    county_names_all: "Larimer",
    county_fips_all: "08069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80530,
    lat: 40.10153,
    lng: -104.92302,
    city: "Frederick",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3996,
    density: 495.2,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 100,
    },
    county_names_all: "Weld",
    county_fips_all: "08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80532,
    lat: 40.4775,
    lng: -105.46048,
    city: "Glen Haven",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25,
    density: 0.3,
    county_fips: "08069",
    county_name: "Larimer",
    county_weights: {
      "08069": 100,
    },
    county_names_all: "Larimer",
    county_fips_all: "08069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80534,
    lat: 40.33192,
    lng: -104.93522,
    city: "Johnstown",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15635,
    density: 125.6,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 80.58,
      "08069": 19.42,
    },
    county_names_all: "Weld|Larimer",
    county_fips_all: "08123|08069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80535,
    lat: 40.73718,
    lng: -105.19292,
    city: "Laporte",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2507,
    density: 17.1,
    county_fips: "08069",
    county_name: "Larimer",
    county_weights: {
      "08069": 100,
    },
    county_names_all: "Larimer",
    county_fips_all: "08069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80536,
    lat: 40.87458,
    lng: -105.38842,
    city: "Livermore",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2031,
    density: 2.1,
    county_fips: "08069",
    county_name: "Larimer",
    county_weights: {
      "08069": 100,
    },
    county_names_all: "Larimer",
    county_fips_all: "08069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80537,
    lat: 40.38304,
    lng: -105.20277,
    city: "Loveland",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46154,
    density: 145.6,
    county_fips: "08069",
    county_name: "Larimer",
    county_weights: {
      "08069": 97.28,
      "08123": 2.72,
    },
    county_names_all: "Larimer|Weld",
    county_fips_all: "08069|08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80538,
    lat: 40.48174,
    lng: -105.16825,
    city: "Loveland",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52708,
    density: 199.2,
    county_fips: "08069",
    county_name: "Larimer",
    county_weights: {
      "08069": 100,
    },
    county_names_all: "Larimer",
    county_fips_all: "08069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80540,
    lat: 40.23186,
    lng: -105.39341,
    city: "Lyons",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4733,
    density: 12,
    county_fips: "08013",
    county_name: "Boulder",
    county_weights: {
      "08013": 65.41,
      "08069": 34.59,
    },
    county_names_all: "Boulder|Larimer",
    county_fips_all: "08013|08069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80542,
    lat: 40.23431,
    lng: -104.99882,
    city: "Mead",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5054,
    density: 212.1,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 100,
    },
    county_names_all: "Weld",
    county_fips_all: "08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80543,
    lat: 40.34645,
    lng: -104.8532,
    city: "Milliken",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8048,
    density: 100.5,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 100,
    },
    county_names_all: "Weld",
    county_fips_all: "08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80544,
    lat: 40.10305,
    lng: -105.17178,
    city: "Niwot",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 81,
    density: 561.4,
    county_fips: "08013",
    county_name: "Boulder",
    county_weights: {
      "08013": 100,
    },
    county_names_all: "Boulder",
    county_fips_all: "08013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80545,
    lat: 40.85911,
    lng: -105.69644,
    city: "Red Feather Lakes",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1190,
    density: 1.6,
    county_fips: "08069",
    county_name: "Larimer",
    county_weights: {
      "08069": 100,
    },
    county_names_all: "Larimer",
    county_fips_all: "08069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80546,
    lat: 40.52415,
    lng: -104.84986,
    city: "Severance",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 205,
    density: 707.9,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 100,
    },
    county_names_all: "Weld",
    county_fips_all: "08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80547,
    lat: 40.52948,
    lng: -104.96347,
    city: "Timnath",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1234,
    density: 84.1,
    county_fips: "08069",
    county_name: "Larimer",
    county_weights: {
      "08069": 100,
    },
    county_names_all: "Larimer",
    county_fips_all: "08069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80549,
    lat: 40.84341,
    lng: -105.05499,
    city: "Wellington",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11785,
    density: 24.3,
    county_fips: "08069",
    county_name: "Larimer",
    county_weights: {
      "08069": 94.93,
      "08123": 5.07,
    },
    county_names_all: "Larimer|Weld",
    county_fips_all: "08069|08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80550,
    lat: 40.48213,
    lng: -104.90223,
    city: "Windsor",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28935,
    density: 213.1,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 91.04,
      "08069": 8.96,
    },
    county_names_all: "Weld|Larimer",
    county_fips_all: "08123|08069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80601,
    lat: 39.96288,
    lng: -104.80777,
    city: "Brighton",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39385,
    density: 580.5,
    county_fips: "08001",
    county_name: "Adams",
    county_weights: {
      "08001": 100,
    },
    county_names_all: "Adams",
    county_fips_all: "08001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80602,
    lat: 39.96369,
    lng: -104.90661,
    city: "Brighton",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38191,
    density: 479.7,
    county_fips: "08001",
    county_name: "Adams",
    county_weights: {
      "08001": 100,
    },
    county_names_all: "Adams",
    county_fips_all: "08001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80603,
    lat: 39.9845,
    lng: -104.74539,
    city: "Brighton",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14076,
    density: 73.4,
    county_fips: "08001",
    county_name: "Adams",
    county_weights: {
      "08001": 56.13,
      "08123": 43.87,
    },
    county_names_all: "Adams|Weld",
    county_fips_all: "08001|08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80610,
    lat: 40.66996,
    lng: -104.58269,
    city: "Ault",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3719,
    density: 8,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 100,
    },
    county_names_all: "Weld",
    county_fips_all: "08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80611,
    lat: 40.62015,
    lng: -104.24964,
    city: "Briggsdale",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1173,
    density: 1.1,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 100,
    },
    county_names_all: "Weld",
    county_fips_all: "08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80612,
    lat: 40.89924,
    lng: -104.82287,
    city: "Carr",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 242,
    density: 0.3,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 84.85,
      "08069": 15.15,
    },
    county_names_all: "Weld|Larimer",
    county_fips_all: "08123|08069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80615,
    lat: 40.5444,
    lng: -104.64236,
    city: "Eaton",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9210,
    density: 33.6,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 100,
    },
    county_names_all: "Weld",
    county_fips_all: "08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80620,
    lat: 40.37425,
    lng: -104.71337,
    city: "Evans",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21331,
    density: 1391.3,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 100,
    },
    county_names_all: "Weld",
    county_fips_all: "08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80621,
    lat: 40.10732,
    lng: -104.79841,
    city: "Fort Lupton",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15100,
    density: 46.1,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 100,
    },
    county_names_all: "Weld",
    county_fips_all: "08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80622,
    lat: 40.54235,
    lng: -104.44732,
    city: "Galeton",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 83,
    density: 2.9,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 100,
    },
    county_names_all: "Weld",
    county_fips_all: "08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80623,
    lat: 40.28531,
    lng: -104.78253,
    city: "Gilcrest",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1381,
    density: 796.1,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 100,
    },
    county_names_all: "Weld",
    county_fips_all: "08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80624,
    lat: 40.45683,
    lng: -104.45635,
    city: "Gill",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1014,
    density: 5.3,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 100,
    },
    county_names_all: "Weld",
    county_fips_all: "08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80631,
    lat: 40.44216,
    lng: -104.67809,
    city: "Greeley",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55748,
    density: 207.8,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 100,
    },
    county_names_all: "Weld",
    county_fips_all: "08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80634,
    lat: 40.40075,
    lng: -104.79222,
    city: "Greeley",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61810,
    density: 622.8,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 100,
    },
    county_names_all: "Weld",
    county_fips_all: "08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80640,
    lat: 39.88536,
    lng: -104.88202,
    city: "Henderson",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12850,
    density: 381.4,
    county_fips: "08001",
    county_name: "Adams",
    county_weights: {
      "08001": 100,
    },
    county_names_all: "Adams",
    county_fips_all: "08001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80642,
    lat: 40.05353,
    lng: -104.61565,
    city: "Hudson",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5694,
    density: 22.1,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 70.39,
      "08001": 29.61,
    },
    county_names_all: "Weld|Adams",
    county_fips_all: "08123|08001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80643,
    lat: 40.11186,
    lng: -104.47164,
    city: "Keenesburg",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4471,
    density: 8,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 88.68,
      "08001": 11.32,
    },
    county_names_all: "Weld|Adams",
    county_fips_all: "08123|08001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80644,
    lat: 40.3371,
    lng: -104.43866,
    city: "Kersey",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3375,
    density: 8.1,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 100,
    },
    county_names_all: "Weld",
    county_fips_all: "08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80645,
    lat: 40.28409,
    lng: -104.64731,
    city: "La Salle",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6395,
    density: 26.6,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 100,
    },
    county_names_all: "Weld",
    county_fips_all: "08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80646,
    lat: 40.47537,
    lng: -104.69761,
    city: "Lucerne",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 100,
    },
    county_names_all: "Weld",
    county_fips_all: "08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80648,
    lat: 40.76559,
    lng: -104.72816,
    city: "Nunn",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1718,
    density: 4.3,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 100,
    },
    county_names_all: "Weld",
    county_fips_all: "08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80649,
    lat: 40.37924,
    lng: -104.17595,
    city: "Orchard",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 449,
    density: 1,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 65.66,
      "08087": 34.34,
    },
    county_names_all: "Weld|Morgan",
    county_fips_all: "08123|08087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80650,
    lat: 40.6484,
    lng: -104.77666,
    city: "Pierce",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2270,
    density: 15.5,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 100,
    },
    county_names_all: "Weld",
    county_fips_all: "08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80651,
    lat: 40.23717,
    lng: -104.81409,
    city: "Platteville",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4352,
    density: 17.7,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 100,
    },
    county_names_all: "Weld",
    county_fips_all: "08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80652,
    lat: 40.11048,
    lng: -104.2751,
    city: "Roggen",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 370,
    density: 0.8,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 100,
    },
    county_names_all: "Weld",
    county_fips_all: "08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80653,
    lat: 40.3931,
    lng: -103.97685,
    city: "Weldona",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 809,
    density: 2.3,
    county_fips: "08087",
    county_name: "Morgan",
    county_weights: {
      "08087": 100,
    },
    county_names_all: "Morgan",
    county_fips_all: "08087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80654,
    lat: 40.13501,
    lng: -104.07642,
    city: "Wiggins",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2572,
    density: 4.2,
    county_fips: "08087",
    county_name: "Morgan",
    county_weights: {
      "08087": 83.16,
      "08001": 9.11,
      "08123": 7.73,
    },
    county_names_all: "Morgan|Adams|Weld",
    county_fips_all: "08087|08001|08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80701,
    lat: 40.13494,
    lng: -103.81102,
    city: "Fort Morgan",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16248,
    density: 10.2,
    county_fips: "08087",
    county_name: "Morgan",
    county_weights: {
      "08087": 74.23,
      "08001": 25.77,
    },
    county_names_all: "Morgan|Adams",
    county_fips_all: "08087|08001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80705,
    lat: 40.27116,
    lng: -103.83428,
    city: "Log Lane Village",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1078,
    density: 1255.3,
    county_fips: "08087",
    county_name: "Morgan",
    county_weights: {
      "08087": 100,
    },
    county_names_all: "Morgan",
    county_fips_all: "08087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80720,
    lat: 40.07457,
    lng: -103.18878,
    city: "Akron",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2711,
    density: 1.1,
    county_fips: "08121",
    county_name: "Washington",
    county_weights: {
      "08121": 100,
    },
    county_names_all: "Washington",
    county_fips_all: "08121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80721,
    lat: 40.68821,
    lng: -102.15297,
    city: "Amherst",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 296,
    density: 1.3,
    county_fips: "08095",
    county_name: "Phillips",
    county_weights: {
      "08095": 100,
    },
    county_names_all: "Phillips",
    county_fips_all: "08095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80722,
    lat: 40.49515,
    lng: -103.23833,
    city: "Atwood",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 486,
    density: 2.8,
    county_fips: "08075",
    county_name: "Logan",
    county_weights: {
      "08075": 100,
    },
    county_names_all: "Logan",
    county_fips_all: "08075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80723,
    lat: 40.15981,
    lng: -103.55046,
    city: "Brush",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7080,
    density: 10.3,
    county_fips: "08087",
    county_name: "Morgan",
    county_weights: {
      "08087": 83.51,
      "08121": 16.49,
    },
    county_names_all: "Morgan|Washington",
    county_fips_all: "08087|08121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80726,
    lat: 40.91044,
    lng: -102.7773,
    city: "Crook",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 471,
    density: 1.2,
    county_fips: "08075",
    county_name: "Logan",
    county_weights: {
      "08075": 100,
    },
    county_names_all: "Logan",
    county_fips_all: "08075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80727,
    lat: 40.02185,
    lng: -102.51484,
    city: "Eckley",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 590,
    density: 0.9,
    county_fips: "08125",
    county_name: "Yuma",
    county_weights: {
      "08125": 100,
    },
    county_names_all: "Yuma",
    county_fips_all: "08125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80728,
    lat: 40.64,
    lng: -102.87285,
    city: "Fleming",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1086,
    density: 1.2,
    county_fips: "08075",
    county_name: "Logan",
    county_weights: {
      "08075": 100,
    },
    county_names_all: "Logan",
    county_fips_all: "08075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80729,
    lat: 40.87439,
    lng: -104.22632,
    city: "Grover",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 737,
    density: 0.5,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 100,
    },
    county_names_all: "Weld",
    county_fips_all: "08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80731,
    lat: 40.58734,
    lng: -102.60558,
    city: "Haxtun",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1180,
    density: 1.2,
    county_fips: "08095",
    county_name: "Phillips",
    county_weights: {
      "08095": 59.86,
      "08075": 28.3,
      "08125": 9.47,
      "08115": 2.37,
    },
    county_names_all: "Phillips|Logan|Yuma|Sedgwick",
    county_fips_all: "08095|08075|08125|08115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80732,
    lat: 40.9884,
    lng: -104.30525,
    city: "Hereford",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 100,
    },
    county_names_all: "Weld",
    county_fips_all: "08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80733,
    lat: 40.35695,
    lng: -103.47989,
    city: "Hillrose",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 529,
    density: 8.7,
    county_fips: "08087",
    county_name: "Morgan",
    county_weights: {
      "08087": 60.28,
      "08121": 39.72,
    },
    county_names_all: "Morgan|Washington",
    county_fips_all: "08087|08121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80734,
    lat: 40.52472,
    lng: -102.29259,
    city: "Holyoke",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3100,
    density: 2.5,
    county_fips: "08095",
    county_name: "Phillips",
    county_weights: {
      "08095": 77.06,
      "08125": 22.94,
    },
    county_names_all: "Phillips|Yuma",
    county_fips_all: "08095|08125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80735,
    lat: 39.71549,
    lng: -102.25029,
    city: "Idalia",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 395,
    density: 0.5,
    county_fips: "08125",
    county_name: "Yuma",
    county_weights: {
      "08125": 100,
    },
    county_names_all: "Yuma",
    county_fips_all: "08125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80736,
    lat: 40.81635,
    lng: -103.01907,
    city: "Iliff",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 484,
    density: 1.4,
    county_fips: "08075",
    county_name: "Logan",
    county_weights: {
      "08075": 100,
    },
    county_names_all: "Logan",
    county_fips_all: "08075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80737,
    lat: 40.88974,
    lng: -102.19267,
    city: "Julesburg",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1631,
    density: 2.5,
    county_fips: "08115",
    county_name: "Sedgwick",
    county_weights: {
      31049: 3.84,
      "08115": 96.16,
    },
    county_names_all: "Sedgwick|Deuel",
    county_fips_all: "08115|31049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80740,
    lat: 39.74256,
    lng: -103.38744,
    city: "Lindon",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 92,
    density: 0.2,
    county_fips: "08121",
    county_name: "Washington",
    county_weights: {
      "08121": 100,
    },
    county_names_all: "Washington",
    county_fips_all: "08121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80741,
    lat: 40.5598,
    lng: -103.47339,
    city: "Merino",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1101,
    density: 1.9,
    county_fips: "08075",
    county_name: "Logan",
    county_weights: {
      "08075": 76.99,
      "08087": 14.37,
      "08121": 8.64,
    },
    county_names_all: "Logan|Morgan|Washington",
    county_fips_all: "08075|08087|08121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80742,
    lat: 40.74855,
    lng: -103.81371,
    city: "New Raymer",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 218,
    density: 0.2,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 92.74,
      "08087": 7.26,
    },
    county_names_all: "Weld|Morgan",
    county_fips_all: "08123|08087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80743,
    lat: 40.21588,
    lng: -102.95679,
    city: "Otis",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1115,
    density: 1,
    county_fips: "08121",
    county_name: "Washington",
    county_weights: {
      "08121": 100,
    },
    county_names_all: "Washington",
    county_fips_all: "08121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80744,
    lat: 40.87471,
    lng: -102.38355,
    city: "Ovid",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 430,
    density: 1.4,
    county_fips: "08115",
    county_name: "Sedgwick",
    county_weights: {
      "08115": 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: "08115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80745,
    lat: 40.88801,
    lng: -103.40077,
    city: "Padroni",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 209,
    density: 0.5,
    county_fips: "08075",
    county_name: "Logan",
    county_weights: {
      "08075": 100,
    },
    county_names_all: "Logan",
    county_fips_all: "08075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80746,
    lat: 40.60706,
    lng: -102.45695,
    city: "Paoli",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 73,
    density: 18,
    county_fips: "08095",
    county_name: "Phillips",
    county_weights: {
      "08095": 100,
    },
    county_names_all: "Phillips",
    county_fips_all: "08095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80747,
    lat: 40.94709,
    lng: -103.16392,
    city: "Peetz",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 458,
    density: 0.8,
    county_fips: "08075",
    county_name: "Logan",
    county_weights: {
      "08075": 100,
    },
    county_names_all: "Logan",
    county_fips_all: "08075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80749,
    lat: 40.87574,
    lng: -102.55354,
    city: "Sedgwick",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 245,
    density: 0.5,
    county_fips: "08115",
    county_name: "Sedgwick",
    county_weights: {
      "08115": 100,
    },
    county_names_all: "Sedgwick",
    county_fips_all: "08115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80750,
    lat: 40.41144,
    lng: -103.60681,
    city: "Snyder",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 325,
    density: 1,
    county_fips: "08087",
    county_name: "Morgan",
    county_weights: {
      "08087": 100,
    },
    county_names_all: "Morgan",
    county_fips_all: "08087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80751,
    lat: 40.65263,
    lng: -103.24504,
    city: "Sterling",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18005,
    density: 14.6,
    county_fips: "08075",
    county_name: "Logan",
    county_weights: {
      "08075": 100,
    },
    county_names_all: "Logan",
    county_fips_all: "08075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80754,
    lat: 40.69052,
    lng: -103.64694,
    city: "Stoneham",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 211,
    density: 0.5,
    county_fips: "08123",
    county_name: "Weld",
    county_weights: {
      "08123": 100,
    },
    county_names_all: "Weld",
    county_fips_all: "08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80755,
    lat: 39.89966,
    lng: -102.35155,
    city: "Vernon",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75,
    density: 0.3,
    county_fips: "08125",
    county_name: "Yuma",
    county_weights: {
      "08125": 100,
    },
    county_names_all: "Yuma",
    county_fips_all: "08125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80757,
    lat: 39.79244,
    lng: -103.58588,
    city: "Woodrow",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 226,
    density: 0.2,
    county_fips: "08121",
    county_name: "Washington",
    county_weights: {
      "08121": 100,
    },
    county_names_all: "Washington",
    county_fips_all: "08121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80758,
    lat: 40.11998,
    lng: -102.2122,
    city: "Wray",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3401,
    density: 1.9,
    county_fips: "08125",
    county_name: "Yuma",
    county_weights: {
      "08125": 100,
    },
    county_names_all: "Yuma",
    county_fips_all: "08125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80759,
    lat: 40.10892,
    lng: -102.68759,
    city: "Yuma",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4806,
    density: 2.9,
    county_fips: "08125",
    county_name: "Yuma",
    county_weights: {
      "08125": 92.07,
      "08121": 7.93,
    },
    county_names_all: "Yuma|Washington",
    county_fips_all: "08125|08121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80801,
    lat: 39.73943,
    lng: -103.11354,
    city: "Anton",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 120,
    density: 0.3,
    county_fips: "08121",
    county_name: "Washington",
    county_weights: {
      "08121": 100,
    },
    county_names_all: "Washington",
    county_fips_all: "08121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80802,
    lat: 38.84317,
    lng: -102.16393,
    city: "Arapahoe",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 238,
    density: 0.3,
    county_fips: "08017",
    county_name: "Cheyenne",
    county_weights: {
      "08017": 100,
    },
    county_names_all: "Cheyenne",
    county_fips_all: "08017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80804,
    lat: 39.35644,
    lng: -103.26331,
    city: "Arriba",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 267,
    density: 0.3,
    county_fips: "08073",
    county_name: "Lincoln",
    county_weights: {
      "08073": 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: "08073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80805,
    lat: 39.29378,
    lng: -102.44923,
    city: "Bethune",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 389,
    density: 1.1,
    county_fips: "08063",
    county_name: "Kit Carson",
    county_weights: {
      "08063": 100,
    },
    county_names_all: "Kit Carson",
    county_fips_all: "08063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80807,
    lat: 39.31575,
    lng: -102.23303,
    city: "Burlington",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4460,
    density: 2.3,
    county_fips: "08063",
    county_name: "Kit Carson",
    county_weights: {
      "08063": 94.53,
      "08125": 5.47,
    },
    county_names_all: "Kit Carson|Yuma",
    county_fips_all: "08063|08125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80808,
    lat: 39.00043,
    lng: -104.30638,
    city: "Calhan",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5963,
    density: 5.9,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 83.69,
      "08039": 16.31,
    },
    county_names_all: "El Paso|Elbert",
    county_fips_all: "08041|08039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80809,
    lat: 38.86503,
    lng: -104.99733,
    city: "Cascade",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 818,
    density: 6.4,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80810,
    lat: 38.82589,
    lng: -102.4454,
    city: "Cheyenne Wells",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1171,
    density: 0.8,
    county_fips: "08017",
    county_name: "Cheyenne",
    county_weights: {
      "08017": 100,
    },
    county_names_all: "Cheyenne",
    county_fips_all: "08017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80812,
    lat: 39.67901,
    lng: -102.89161,
    city: "Cope",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 246,
    density: 0.6,
    county_fips: "08121",
    county_name: "Washington",
    county_weights: {
      "08121": 95.54,
      "08125": 4.46,
    },
    county_names_all: "Washington|Yuma",
    county_fips_all: "08121|08125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80813,
    lat: 38.76307,
    lng: -105.09278,
    city: "Cripple Creek",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1621,
    density: 5.6,
    county_fips: "08119",
    county_name: "Teller",
    county_weights: {
      "08119": 100,
    },
    county_names_all: "Teller",
    county_fips_all: "08119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80814,
    lat: 38.94731,
    lng: -105.17604,
    city: "Divide",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4125,
    density: 15.7,
    county_fips: "08119",
    county_name: "Teller",
    county_weights: {
      "08119": 100,
    },
    county_names_all: "Teller",
    county_fips_all: "08119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80815,
    lat: 39.40174,
    lng: -103.08191,
    city: "Flagler",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 775,
    density: 0.6,
    county_fips: "08063",
    county_name: "Kit Carson",
    county_weights: {
      "08063": 73.08,
      "08121": 26.92,
    },
    county_names_all: "Kit Carson|Washington",
    county_fips_all: "08063|08121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80816,
    lat: 38.85162,
    lng: -105.31591,
    city: "Florissant",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5932,
    density: 12.6,
    county_fips: "08119",
    county_name: "Teller",
    county_weights: {
      "08119": 62.65,
      "08093": 37.35,
    },
    county_names_all: "Teller|Park",
    county_fips_all: "08119|08093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80817,
    lat: 38.58347,
    lng: -104.67412,
    city: "Fountain",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31426,
    density: 105.4,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 76.51,
      "08101": 23.49,
    },
    county_names_all: "El Paso|Pueblo",
    county_fips_all: "08041|08101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80818,
    lat: 39.41539,
    lng: -103.48119,
    city: "Genoa",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 462,
    density: 0.5,
    county_fips: "08073",
    county_name: "Lincoln",
    county_weights: {
      "08073": 87.22,
      "08121": 12.78,
    },
    county_names_all: "Lincoln|Washington",
    county_fips_all: "08073|08121",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80819,
    lat: 38.94076,
    lng: -105.00249,
    city: "Green Mountain Falls",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 891,
    density: 58.1,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 93.68,
      "08119": 6.32,
    },
    county_names_all: "El Paso|Teller",
    county_fips_all: "08041|08119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80820,
    lat: 38.77781,
    lng: -105.56613,
    city: "Guffey",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1074,
    density: 1.6,
    county_fips: "08093",
    county_name: "Park",
    county_weights: {
      "08093": 100,
    },
    county_names_all: "Park",
    county_fips_all: "08093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80821,
    lat: 38.97366,
    lng: -103.43248,
    city: "Hugo",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1102,
    density: 0.6,
    county_fips: "08073",
    county_name: "Lincoln",
    county_weights: {
      "08073": 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: "08073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80822,
    lat: 39.67088,
    lng: -102.67815,
    city: "Joes",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 230,
    density: 0.8,
    county_fips: "08125",
    county_name: "Yuma",
    county_weights: {
      "08125": 100,
    },
    county_names_all: "Yuma",
    county_fips_all: "08125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80823,
    lat: 38.69026,
    lng: -103.46738,
    city: "Karval",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 222,
    density: 0.3,
    county_fips: "08073",
    county_name: "Lincoln",
    county_weights: {
      "08073": 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: "08073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80824,
    lat: 39.66302,
    lng: -102.49943,
    city: "Kirk",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 350,
    density: 1,
    county_fips: "08125",
    county_name: "Yuma",
    county_weights: {
      "08125": 100,
    },
    county_names_all: "Yuma",
    county_fips_all: "08125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80825,
    lat: 38.81864,
    lng: -102.80624,
    city: "Kit Carson",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 543,
    density: 0.4,
    county_fips: "08017",
    county_name: "Cheyenne",
    county_weights: {
      "08017": 100,
    },
    county_names_all: "Cheyenne",
    county_fips_all: "08017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80826,
    lat: 39.21874,
    lng: -103.69129,
    city: "Limon",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "08073",
    county_name: "Lincoln",
    county_weights: {
      "08073": 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: "08073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80827,
    lat: 39.05821,
    lng: -105.46272,
    city: "Lake George",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 609,
    density: 0.8,
    county_fips: "08093",
    county_name: "Park",
    county_weights: {
      "08093": 87.73,
      "08119": 12.27,
    },
    county_names_all: "Park|Teller",
    county_fips_all: "08093|08119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80828,
    lat: 39.26643,
    lng: -103.70983,
    city: "Limon",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3711,
    density: 3.3,
    county_fips: "08073",
    county_name: "Lincoln",
    county_weights: {
      "08073": 53.55,
      "08039": 46.45,
    },
    county_names_all: "Lincoln|Elbert",
    county_fips_all: "08073|08039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80829,
    lat: 38.82922,
    lng: -104.93289,
    city: "Manitou Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6387,
    density: 122.6,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80830,
    lat: 39.11313,
    lng: -103.91139,
    city: "Matheson",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 170,
    density: 0.4,
    county_fips: "08039",
    county_name: "Elbert",
    county_weights: {
      "08039": 100,
    },
    county_names_all: "Elbert",
    county_fips_all: "08039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80831,
    lat: 38.98867,
    lng: -104.51172,
    city: "Peyton",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27786,
    density: 56.9,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 94.85,
      "08039": 5.15,
    },
    county_names_all: "El Paso|Elbert",
    county_fips_all: "08041|08039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80832,
    lat: 39.06344,
    lng: -104.02769,
    city: "Ramah",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 775,
    density: 1,
    county_fips: "08039",
    county_name: "Elbert",
    county_weights: {
      "08039": 80.88,
      "08041": 14.45,
      "08073": 4.67,
    },
    county_names_all: "Elbert|El Paso|Lincoln",
    county_fips_all: "08039|08041|08073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80833,
    lat: 38.73874,
    lng: -103.93699,
    city: "Rush",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1042,
    density: 0.8,
    county_fips: "08073",
    county_name: "Lincoln",
    county_weights: {
      "08073": 77.5,
      "08041": 19.95,
      "08039": 2.55,
    },
    county_names_all: "Lincoln|El Paso|Elbert",
    county_fips_all: "08073|08041|08039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80834,
    lat: 39.29735,
    lng: -102.88617,
    city: "Seibert",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 272,
    density: 0.4,
    county_fips: "08063",
    county_name: "Kit Carson",
    county_weights: {
      "08063": 100,
    },
    county_names_all: "Kit Carson",
    county_fips_all: "08063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80835,
    lat: 39.20933,
    lng: -104.07223,
    city: "Simla",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 821,
    density: 2.3,
    county_fips: "08039",
    county_name: "Elbert",
    county_weights: {
      "08039": 94.15,
      "08041": 5.85,
    },
    county_names_all: "Elbert|El Paso",
    county_fips_all: "08039|08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80836,
    lat: 39.30518,
    lng: -102.58239,
    city: "Stratton",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1168,
    density: 1.1,
    county_fips: "08063",
    county_name: "Kit Carson",
    county_weights: {
      "08063": 99.24,
      "08125": 0.76,
    },
    county_names_all: "Kit Carson|Yuma",
    county_fips_all: "08063|08125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80840,
    lat: 39.00041,
    lng: -104.85446,
    city: "Usaf Academy",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6368,
    density: 104.4,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80860,
    lat: 38.69307,
    lng: -105.09876,
    city: "Victor",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 597,
    density: 3.3,
    county_fips: "08119",
    county_name: "Teller",
    county_weights: {
      "08119": 100,
    },
    county_names_all: "Teller",
    county_fips_all: "08119",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80861,
    lat: 39.32645,
    lng: -102.74844,
    city: "Vona",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 253,
    density: 0.4,
    county_fips: "08063",
    county_name: "Kit Carson",
    county_weights: {
      "08063": 99.17,
      "08125": 0.83,
    },
    county_names_all: "Kit Carson|Yuma",
    county_fips_all: "08063|08125",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80862,
    lat: 38.90926,
    lng: -103.06782,
    city: "Wild Horse",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37,
    density: 0.1,
    county_fips: "08017",
    county_name: "Cheyenne",
    county_weights: {
      "08017": 100,
    },
    county_names_all: "Cheyenne",
    county_fips_all: "08017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80863,
    lat: 39.03004,
    lng: -105.07132,
    city: "Woodland Park",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13119,
    density: 29.2,
    county_fips: "08119",
    county_name: "Teller",
    county_weights: {
      "08119": 71.15,
      "08041": 28.85,
    },
    county_names_all: "Teller|El Paso",
    county_fips_all: "08119|08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80864,
    lat: 38.69923,
    lng: -104.18757,
    city: "Yoder",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1412,
    density: 2.2,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80902,
    lat: 38.68683,
    lng: -104.8127,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12797,
    density: 272.5,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80903,
    lat: 38.83249,
    lng: -104.81342,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16399,
    density: 1177.5,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80904,
    lat: 38.86321,
    lng: -104.87197,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20882,
    density: 722,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80905,
    lat: 38.81855,
    lng: -104.83649,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16588,
    density: 1252.1,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80906,
    lat: 38.76744,
    lng: -104.87023,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37610,
    density: 318.6,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80907,
    lat: 38.87912,
    lng: -104.82137,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29173,
    density: 1144.3,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80908,
    lat: 39.0463,
    lng: -104.69094,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19628,
    density: 80,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80909,
    lat: 38.85255,
    lng: -104.77434,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38826,
    density: 1890.5,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80910,
    lat: 38.81178,
    lng: -104.7743,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31619,
    density: 1998.1,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80911,
    lat: 38.75325,
    lng: -104.71955,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35597,
    density: 1237.1,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80913,
    lat: 38.70005,
    lng: -104.76268,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4165,
    density: 67.3,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80914,
    lat: 38.82401,
    lng: -104.70546,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 323,
    density: 188.5,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80915,
    lat: 38.85271,
    lng: -104.71652,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22474,
    density: 1104.4,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80916,
    lat: 38.80327,
    lng: -104.71208,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41173,
    density: 864.5,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80917,
    lat: 38.88684,
    lng: -104.74049,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31648,
    density: 2176.7,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80918,
    lat: 38.91156,
    lng: -104.78032,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48905,
    density: 1575.7,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80919,
    lat: 38.92797,
    lng: -104.88025,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27922,
    density: 393.9,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80920,
    lat: 38.95579,
    lng: -104.77191,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38558,
    density: 1199,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80921,
    lat: 39.02648,
    lng: -104.88156,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24725,
    density: 194.8,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80922,
    lat: 38.88996,
    lng: -104.70084,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29598,
    density: 1960.9,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80923,
    lat: 38.92673,
    lng: -104.71433,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30932,
    density: 1709.8,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80924,
    lat: 38.96727,
    lng: -104.72199,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11873,
    density: 783.4,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80925,
    lat: 38.76156,
    lng: -104.64441,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13752,
    density: 184.9,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80926,
    lat: 38.64318,
    lng: -104.92439,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1595,
    density: 7.9,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 63.47,
      "08043": 36.53,
    },
    county_names_all: "El Paso|Fremont",
    county_fips_all: "08041|08043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80927,
    lat: 38.92833,
    lng: -104.65878,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4491,
    density: 385.8,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80928,
    lat: 38.64517,
    lng: -104.44268,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1165,
    density: 1.5,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80929,
    lat: 38.82453,
    lng: -104.60833,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58,
    density: 0.9,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80930,
    lat: 38.80507,
    lng: -104.50644,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1794,
    density: 20.2,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80938,
    lat: 38.90157,
    lng: -104.65926,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 462,
    density: 33.5,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80939,
    lat: 38.87772,
    lng: -104.67742,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 80951,
    lat: 38.88396,
    lng: -104.6558,
    city: "Colorado Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4574,
    density: 603.6,
    county_fips: "08041",
    county_name: "El Paso",
    county_weights: {
      "08041": 100,
    },
    county_names_all: "El Paso",
    county_fips_all: "08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81001,
    lat: 38.29525,
    lng: -104.5378,
    city: "Pueblo",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29997,
    density: 361.4,
    county_fips: "08101",
    county_name: "Pueblo",
    county_weights: {
      "08101": 100,
    },
    county_names_all: "Pueblo",
    county_fips_all: "08101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81003,
    lat: 38.27782,
    lng: -104.65668,
    city: "Pueblo",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14824,
    density: 468.6,
    county_fips: "08101",
    county_name: "Pueblo",
    county_weights: {
      "08101": 100,
    },
    county_names_all: "Pueblo",
    county_fips_all: "08101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81004,
    lat: 38.05121,
    lng: -104.71595,
    city: "Pueblo",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27159,
    density: 65.2,
    county_fips: "08101",
    county_name: "Pueblo",
    county_weights: {
      "08101": 100,
    },
    county_names_all: "Pueblo",
    county_fips_all: "08101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81005,
    lat: 38.21054,
    lng: -104.84608,
    city: "Pueblo",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32062,
    density: 62.3,
    county_fips: "08101",
    county_name: "Pueblo",
    county_weights: {
      "08101": 100,
    },
    county_names_all: "Pueblo",
    county_fips_all: "08101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81006,
    lat: 38.24059,
    lng: -104.47413,
    city: "Pueblo",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12120,
    density: 41.6,
    county_fips: "08101",
    county_name: "Pueblo",
    county_weights: {
      "08101": 100,
    },
    county_names_all: "Pueblo",
    county_fips_all: "08101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81007,
    lat: 38.35858,
    lng: -104.78472,
    city: "Pueblo",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32842,
    density: 92.9,
    county_fips: "08101",
    county_name: "Pueblo",
    county_weights: {
      "08101": 100,
    },
    county_names_all: "Pueblo",
    county_fips_all: "08101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81008,
    lat: 38.40765,
    lng: -104.59354,
    city: "Pueblo",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11659,
    density: 44,
    county_fips: "08101",
    county_name: "Pueblo",
    county_weights: {
      "08101": 98.14,
      "08041": 1.86,
    },
    county_names_all: "Pueblo|El Paso",
    county_fips_all: "08101|08041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81019,
    lat: 37.94152,
    lng: -104.83714,
    city: "Colorado City",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1748,
    density: 51.6,
    county_fips: "08101",
    county_name: "Pueblo",
    county_weights: {
      "08101": 100,
    },
    county_names_all: "Pueblo",
    county_fips_all: "08101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81020,
    lat: 37.43821,
    lng: -104.6253,
    city: "Aguilar",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 929,
    density: 0.9,
    county_fips: "08071",
    county_name: "Las Animas",
    county_weights: {
      "08071": 100,
    },
    county_names_all: "Las Animas",
    county_fips_all: "08071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81021,
    lat: 38.43332,
    lng: -103.36732,
    city: "Arlington",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19,
    density: 0,
    county_fips: "08061",
    county_name: "Kiowa",
    county_weights: {
      "08061": 68,
      "08073": 32,
    },
    county_names_all: "Kiowa|Lincoln",
    county_fips_all: "08061|08073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81022,
    lat: 38.03279,
    lng: -104.43768,
    city: "Avondale",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1545,
    density: 1.6,
    county_fips: "08101",
    county_name: "Pueblo",
    county_weights: {
      "08101": 100,
    },
    county_names_all: "Pueblo",
    county_fips_all: "08101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81023,
    lat: 38.06352,
    lng: -104.92966,
    city: "Beulah",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1268,
    density: 3.2,
    county_fips: "08101",
    county_name: "Pueblo",
    county_weights: {
      "08101": 100,
    },
    county_names_all: "Pueblo",
    county_fips_all: "08101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81024,
    lat: 37.2293,
    lng: -104.71162,
    city: "Boncarbo",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 170,
    density: 1.3,
    county_fips: "08071",
    county_name: "Las Animas",
    county_weights: {
      "08071": 100,
    },
    county_names_all: "Las Animas",
    county_fips_all: "08071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81025,
    lat: 38.34567,
    lng: -104.26422,
    city: "Boone",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 685,
    density: 0.5,
    county_fips: "08101",
    county_name: "Pueblo",
    county_weights: {
      "08101": 100,
    },
    county_names_all: "Pueblo",
    county_fips_all: "08101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81027,
    lat: 37.24687,
    lng: -103.72308,
    city: "Branson",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 163,
    density: 0.1,
    county_fips: "08071",
    county_name: "Las Animas",
    county_weights: {
      "08071": 100,
    },
    county_names_all: "Las Animas",
    county_fips_all: "08071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81029,
    lat: 37.08921,
    lng: -102.48274,
    city: "Campo",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 253,
    density: 0.2,
    county_fips: "08009",
    county_name: "Baca",
    county_weights: {
      "08009": 100,
    },
    county_names_all: "Baca",
    county_fips_all: "08009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81030,
    lat: 38.10322,
    lng: -103.51876,
    city: "Cheraw",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 131,
    density: 137.7,
    county_fips: "08089",
    county_name: "Otero",
    county_weights: {
      "08089": 100,
    },
    county_names_all: "Otero",
    county_fips_all: "08089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81033,
    lat: 38.19575,
    lng: -103.85557,
    city: "Crowley",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 153,
    density: 95.9,
    county_fips: "08025",
    county_name: "Crowley",
    county_weights: {
      "08025": 100,
    },
    county_names_all: "Crowley",
    county_fips_all: "08025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81036,
    lat: 38.42984,
    lng: -102.79292,
    city: "Eads",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1082,
    density: 0.6,
    county_fips: "08061",
    county_name: "Kiowa",
    county_weights: {
      "08061": 100,
    },
    county_names_all: "Kiowa",
    county_fips_all: "08061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81039,
    lat: 37.94079,
    lng: -104.08615,
    city: "Fowler",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1531,
    density: 1,
    county_fips: "08101",
    county_name: "Pueblo",
    county_weights: {
      "08101": 57.12,
      "08089": 42.28,
      "08025": 0.6,
    },
    county_names_all: "Pueblo|Otero|Crowley",
    county_fips_all: "08101|08089|08025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81040,
    lat: 37.79283,
    lng: -105.2493,
    city: "Gardner",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 258,
    density: 0.2,
    county_fips: "08055",
    county_name: "Huerfano",
    county_weights: {
      "08055": 100,
    },
    county_names_all: "Huerfano",
    county_fips_all: "08055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81041,
    lat: 37.844,
    lng: -102.3839,
    city: "Granada",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 696,
    density: 0.5,
    county_fips: "08099",
    county_name: "Prowers",
    county_weights: {
      "08099": 96.27,
      "08009": 3.73,
    },
    county_names_all: "Prowers|Baca",
    county_fips_all: "08099|08009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81043,
    lat: 38.11982,
    lng: -102.22312,
    city: "Hartman",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50,
    density: 55,
    county_fips: "08099",
    county_name: "Prowers",
    county_weights: {
      "08099": 100,
    },
    county_names_all: "Prowers",
    county_fips_all: "08099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81044,
    lat: 37.90328,
    lng: -102.93628,
    city: "Hasty",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 193,
    density: 0.2,
    county_fips: "08011",
    county_name: "Bent",
    county_weights: {
      "08011": 100,
    },
    county_names_all: "Bent",
    county_fips_all: "08011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81045,
    lat: 38.55956,
    lng: -103.16093,
    city: "Haswell",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74,
    density: 0.1,
    county_fips: "08061",
    county_name: "Kiowa",
    county_weights: {
      "08061": 58.38,
      "08017": 24.99,
      "08073": 16.63,
    },
    county_names_all: "Kiowa|Cheyenne|Lincoln",
    county_fips_all: "08061|08017|08073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81046,
    lat: 37.29597,
    lng: -104.36867,
    city: "Hoehne",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "08071",
    county_name: "Las Animas",
    county_weights: {
      "08071": 100,
    },
    county_names_all: "Las Animas",
    county_fips_all: "08071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81047,
    lat: 38.03226,
    lng: -102.19206,
    city: "Holly",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1535,
    density: 1,
    county_fips: "08099",
    county_name: "Prowers",
    county_weights: {
      "08099": 96.36,
      "08061": 3.64,
    },
    county_names_all: "Prowers|Kiowa",
    county_fips_all: "08099|08061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81049,
    lat: 37.31338,
    lng: -103.36308,
    city: "Kim",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 233,
    density: 0.1,
    county_fips: "08071",
    county_name: "Las Animas",
    county_weights: {
      "08071": 100,
    },
    county_names_all: "Las Animas",
    county_fips_all: "08071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81050,
    lat: 37.92266,
    lng: -103.51528,
    city: "La Junta",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9511,
    density: 7.2,
    county_fips: "08089",
    county_name: "Otero",
    county_weights: {
      "08089": 96.64,
      "08011": 3.36,
    },
    county_names_all: "Otero|Bent",
    county_fips_all: "08089|08011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81052,
    lat: 37.94242,
    lng: -102.65625,
    city: "Lamar",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9140,
    density: 5.2,
    county_fips: "08099",
    county_name: "Prowers",
    county_weights: {
      "08099": 75.83,
      "08011": 24.17,
    },
    county_names_all: "Prowers|Bent",
    county_fips_all: "08099|08011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81054,
    lat: 37.88583,
    lng: -103.19493,
    city: "Las Animas",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4963,
    density: 2,
    county_fips: "08011",
    county_name: "Bent",
    county_weights: {
      "08011": 84.82,
      "08071": 7.85,
      "08009": 7.33,
    },
    county_names_all: "Bent|Las Animas|Baca",
    county_fips_all: "08011|08071|08009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81055,
    lat: 37.47727,
    lng: -105.06635,
    city: "La Veta",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1657,
    density: 2.6,
    county_fips: "08055",
    county_name: "Huerfano",
    county_weights: {
      "08055": 98.79,
      "08023": 1.21,
    },
    county_names_all: "Huerfano|Costilla",
    county_fips_all: "08055|08023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81057,
    lat: 38.12525,
    lng: -102.89675,
    city: "McClave",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 323,
    density: 2.6,
    county_fips: "08011",
    county_name: "Bent",
    county_weights: {
      "08011": 100,
    },
    county_names_all: "Bent",
    county_fips_all: "08011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81058,
    lat: 38.10727,
    lng: -103.88161,
    city: "Manzanola",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1261,
    density: 9.9,
    county_fips: "08089",
    county_name: "Otero",
    county_weights: {
      "08089": 70.12,
      "08025": 29.88,
    },
    county_names_all: "Otero|Crowley",
    county_fips_all: "08089|08025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81059,
    lat: 37.56259,
    lng: -103.99322,
    city: "Model",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 463,
    density: 0.2,
    county_fips: "08071",
    county_name: "Las Animas",
    county_weights: {
      "08071": 73.77,
      "08089": 26.23,
    },
    county_names_all: "Las Animas|Otero",
    county_fips_all: "08071|08089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81062,
    lat: 38.29345,
    lng: -103.94995,
    city: "Olney Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1750,
    density: 2.9,
    county_fips: "08025",
    county_name: "Crowley",
    county_weights: {
      "08025": 100,
    },
    county_names_all: "Crowley",
    county_fips_all: "08025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81063,
    lat: 38.45232,
    lng: -103.78494,
    city: "Ordway",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3186,
    density: 3.1,
    county_fips: "08025",
    county_name: "Crowley",
    county_weights: {
      "08025": 63.14,
      "08073": 36.86,
    },
    county_names_all: "Crowley|Lincoln",
    county_fips_all: "08025|08073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81064,
    lat: 37.24593,
    lng: -102.99753,
    city: "Pritchett",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 290,
    density: 0.2,
    county_fips: "08009",
    county_name: "Baca",
    county_weights: {
      "08009": 80.62,
      "08071": 19.38,
    },
    county_names_all: "Baca|Las Animas",
    county_fips_all: "08009|08071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81067,
    lat: 38.01674,
    lng: -103.72326,
    city: "Rocky Ford",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5436,
    density: 9.7,
    county_fips: "08089",
    county_name: "Otero",
    county_weights: {
      "08089": 100,
    },
    county_names_all: "Otero",
    county_fips_all: "08089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81069,
    lat: 37.88998,
    lng: -104.88951,
    city: "Rye",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2170,
    density: 2.9,
    county_fips: "08055",
    county_name: "Huerfano",
    county_weights: {
      "08055": 48.37,
      "08101": 36.28,
      "08027": 15.35,
    },
    county_names_all: "Huerfano|Pueblo|Custer",
    county_fips_all: "08055|08101|08027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81071,
    lat: 38.44838,
    lng: -102.2816,
    city: "Sheridan Lake",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 288,
    density: 0.2,
    county_fips: "08061",
    county_name: "Kiowa",
    county_weights: {
      "08061": 100,
    },
    county_names_all: "Kiowa",
    county_fips_all: "08061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81073,
    lat: 37.42414,
    lng: -102.71496,
    city: "Springfield",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1885,
    density: 1.1,
    county_fips: "08009",
    county_name: "Baca",
    county_weights: {
      "08009": 100,
    },
    county_names_all: "Baca",
    county_fips_all: "08009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81076,
    lat: 38.32338,
    lng: -103.6167,
    city: "Sugar City",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 570,
    density: 0.8,
    county_fips: "08025",
    county_name: "Crowley",
    county_weights: {
      "08025": 100,
    },
    county_names_all: "Crowley",
    county_fips_all: "08025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81077,
    lat: 38.01374,
    lng: -103.60985,
    city: "Swink",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "08089",
    county_name: "Otero",
    county_weights: {
      "08089": 100,
    },
    county_names_all: "Otero",
    county_fips_all: "08089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81081,
    lat: 37.07295,
    lng: -104.14954,
    city: "Trinchera",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 91,
    density: 0.1,
    county_fips: "08071",
    county_name: "Las Animas",
    county_weights: {
      "08071": 100,
    },
    county_names_all: "Las Animas",
    county_fips_all: "08071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81082,
    lat: 37.20343,
    lng: -104.41717,
    city: "Trinidad",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11540,
    density: 5.8,
    county_fips: "08071",
    county_name: "Las Animas",
    county_weights: {
      "08071": 100,
    },
    county_names_all: "Las Animas",
    county_fips_all: "08071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81084,
    lat: 37.57031,
    lng: -102.41929,
    city: "Two Buttes",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 106,
    density: 0.2,
    county_fips: "08009",
    county_name: "Baca",
    county_weights: {
      "08009": 83.65,
      "08099": 16.35,
    },
    county_names_all: "Baca|Prowers",
    county_fips_all: "08009|08099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81087,
    lat: 37.39168,
    lng: -102.41277,
    city: "Vilas",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 130,
    density: 1.7,
    county_fips: "08009",
    county_name: "Baca",
    county_weights: {
      "08009": 100,
    },
    county_names_all: "Baca",
    county_fips_all: "08009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81089,
    lat: 37.6642,
    lng: -104.66427,
    city: "Walsenburg",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4628,
    density: 1.9,
    county_fips: "08055",
    county_name: "Huerfano",
    county_weights: {
      "08055": 77.99,
      "08071": 22.01,
    },
    county_names_all: "Huerfano|Las Animas",
    county_fips_all: "08055|08071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81090,
    lat: 37.36311,
    lng: -102.22434,
    city: "Walsh",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 918,
    density: 0.5,
    county_fips: "08009",
    county_name: "Baca",
    county_weights: {
      "08009": 100,
    },
    county_names_all: "Baca",
    county_fips_all: "08009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81091,
    lat: 37.14869,
    lng: -104.97774,
    city: "Weston",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 727,
    density: 0.7,
    county_fips: "08071",
    county_name: "Las Animas",
    county_weights: {
      "08071": 100,
    },
    county_names_all: "Las Animas",
    county_fips_all: "08071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81092,
    lat: 38.20283,
    lng: -102.86779,
    city: "Wiley",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 807,
    density: 1.6,
    county_fips: "08011",
    county_name: "Bent",
    county_weights: {
      "08011": 79.24,
      "08099": 19.18,
      "08061": 1.58,
    },
    county_names_all: "Bent|Prowers|Kiowa",
    county_fips_all: "08011|08099|08061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81101,
    lat: 37.47197,
    lng: -105.85243,
    city: "Alamosa",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15014,
    density: 15.7,
    county_fips: "08003",
    county_name: "Alamosa",
    county_weights: {
      "08003": 94.45,
      "08021": 5.55,
    },
    county_names_all: "Alamosa|Conejos",
    county_fips_all: "08003|08021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81120,
    lat: 37.14248,
    lng: -106.26715,
    city: "Antonito",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2305,
    density: 1,
    county_fips: "08021",
    county_name: "Conejos",
    county_weights: {
      35039: 7.89,
      "08021": 92.11,
    },
    county_names_all: "Conejos|Rio Arriba",
    county_fips_all: "08021|35039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81121,
    lat: 37.01861,
    lng: -107.42041,
    city: "Arboles",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 449,
    density: 38.7,
    county_fips: "08007",
    county_name: "Archuleta",
    county_weights: {
      "08007": 100,
    },
    county_names_all: "Archuleta",
    county_fips_all: "08007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81122,
    lat: 37.31839,
    lng: -107.50574,
    city: "Bayfield",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8306,
    density: 6.7,
    county_fips: "08067",
    county_name: "La Plata",
    county_weights: {
      "08067": 60.76,
      "08007": 39.24,
    },
    county_names_all: "La Plata|Archuleta",
    county_fips_all: "08067|08007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81123,
    lat: 37.40469,
    lng: -105.5659,
    city: "Blanca",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 880,
    density: 2.3,
    county_fips: "08023",
    county_name: "Costilla",
    county_weights: {
      "08023": 100,
    },
    county_names_all: "Costilla",
    county_fips_all: "08023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81124,
    lat: 37.28543,
    lng: -106.10688,
    city: "Capulin",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 125,
    density: 16.6,
    county_fips: "08021",
    county_name: "Conejos",
    county_weights: {
      "08021": 100,
    },
    county_names_all: "Conejos",
    county_fips_all: "08021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81125,
    lat: 37.81745,
    lng: -106.06678,
    city: "Center",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3669,
    density: 5.4,
    county_fips: "08109",
    county_name: "Saguache",
    county_weights: {
      "08109": 82,
      "08105": 16.45,
      "08003": 1.55,
    },
    county_names_all: "Saguache|Rio Grande|Alamosa",
    county_fips_all: "08109|08105|08003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81126,
    lat: 37.16146,
    lng: -105.34724,
    city: "Chama",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 346,
    density: 13.4,
    county_fips: "08023",
    county_name: "Costilla",
    county_weights: {
      "08023": 100,
    },
    county_names_all: "Costilla",
    county_fips_all: "08023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81128,
    lat: 37.06529,
    lng: -106.65223,
    city: "Chromo",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 91,
    density: 0.2,
    county_fips: "08007",
    county_name: "Archuleta",
    county_weights: {
      "08007": 100,
    },
    county_names_all: "Archuleta",
    county_fips_all: "08007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81129,
    lat: 37.10495,
    lng: -106.02167,
    city: "Conejos",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58,
    density: 8.6,
    county_fips: "08021",
    county_name: "Conejos",
    county_weights: {
      "08021": 100,
    },
    county_names_all: "Conejos",
    county_fips_all: "08021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81130,
    lat: 37.7179,
    lng: -107.04471,
    city: "Creede",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 807,
    density: 0.3,
    county_fips: "08079",
    county_name: "Mineral",
    county_weights: {
      "08079": 70.47,
      "08053": 29.53,
    },
    county_names_all: "Mineral|Hinsdale",
    county_fips_all: "08079|08053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81131,
    lat: 37.87706,
    lng: -105.66651,
    city: "Crestone",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1290,
    density: 1.3,
    county_fips: "08109",
    county_name: "Saguache",
    county_weights: {
      "08109": 100,
    },
    county_names_all: "Saguache",
    county_fips_all: "08109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81132,
    lat: 37.71656,
    lng: -106.41009,
    city: "Del Norte",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3231,
    density: 1.8,
    county_fips: "08105",
    county_name: "Rio Grande",
    county_weights: {
      "08105": 51.26,
      "08109": 48.74,
    },
    county_names_all: "Rio Grande|Saguache",
    county_fips_all: "08105|08109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81133,
    lat: 37.44964,
    lng: -105.32747,
    city: "Fort Garland",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1276,
    density: 1.2,
    county_fips: "08023",
    county_name: "Costilla",
    county_weights: {
      "08023": 100,
    },
    county_names_all: "Costilla",
    county_fips_all: "08023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81136,
    lat: 37.72672,
    lng: -105.85355,
    city: "Hooper",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 265,
    density: 1.2,
    county_fips: "08003",
    county_name: "Alamosa",
    county_weights: {
      "08003": 80.39,
      "08109": 19.61,
    },
    county_names_all: "Alamosa|Saguache",
    county_fips_all: "08003|08109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81137,
    lat: 37.05555,
    lng: -107.61596,
    city: "Ignacio",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5830,
    density: 8.7,
    county_fips: "08067",
    county_name: "La Plata",
    county_weights: {
      35045: 19.2,
      "08067": 77.76,
      "08007": 3.04,
    },
    county_names_all: "La Plata|San Juan|Archuleta",
    county_fips_all: "08067|35045|08007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81138,
    lat: 37.02302,
    lng: -105.62737,
    city: "Jaroso",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38,
    density: 0.7,
    county_fips: "08023",
    county_name: "Costilla",
    county_weights: {
      "08023": 100,
    },
    county_names_all: "Costilla",
    county_fips_all: "08023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81140,
    lat: 37.28692,
    lng: -106.1543,
    city: "La Jara",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2150,
    density: 2.9,
    county_fips: "08021",
    county_name: "Conejos",
    county_weights: {
      "08021": 100,
    },
    county_names_all: "Conejos",
    county_fips_all: "08021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81141,
    lat: 37.16256,
    lng: -105.89507,
    city: "Manassa",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1315,
    density: 19.7,
    county_fips: "08021",
    county_name: "Conejos",
    county_weights: {
      "08021": 100,
    },
    county_names_all: "Conejos",
    county_fips_all: "08021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81143,
    lat: 38.14477,
    lng: -105.87112,
    city: "Moffat",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 719,
    density: 0.7,
    county_fips: "08109",
    county_name: "Saguache",
    county_weights: {
      "08109": 100,
    },
    county_names_all: "Saguache",
    county_fips_all: "08109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81144,
    lat: 37.5516,
    lng: -106.14851,
    city: "Monte Vista",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6837,
    density: 9.2,
    county_fips: "08105",
    county_name: "Rio Grande",
    county_weights: {
      "08105": 91.56,
      "08003": 8.44,
    },
    county_names_all: "Rio Grande|Alamosa",
    county_fips_all: "08105|08003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81146,
    lat: 37.64616,
    lng: -105.6776,
    city: "Mosca",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1036,
    density: 1.4,
    county_fips: "08003",
    county_name: "Alamosa",
    county_weights: {
      "08003": 100,
    },
    county_names_all: "Alamosa",
    county_fips_all: "08003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81147,
    lat: 37.28675,
    lng: -107.08333,
    city: "Pagosa Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12794,
    density: 3.6,
    county_fips: "08007",
    county_name: "Archuleta",
    county_weights: {
      "08007": 73.81,
      "08053": 21.98,
      "08079": 4.21,
    },
    county_names_all: "Archuleta|Hinsdale|Mineral",
    county_fips_all: "08007|08053|08079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81148,
    lat: 37.17183,
    lng: -105.98542,
    city: "Romeo",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 306,
    density: 506.2,
    county_fips: "08021",
    county_name: "Conejos",
    county_weights: {
      "08021": 100,
    },
    county_names_all: "Conejos",
    county_fips_all: "08021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81149,
    lat: 38.1035,
    lng: -106.33858,
    city: "Saguache",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 974,
    density: 0.6,
    county_fips: "08109",
    county_name: "Saguache",
    county_weights: {
      "08109": 100,
    },
    county_names_all: "Saguache",
    county_fips_all: "08109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81151,
    lat: 37.23376,
    lng: -105.71506,
    city: "Sanford",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1864,
    density: 2.5,
    county_fips: "08023",
    county_name: "Costilla",
    county_weights: {
      "08023": 56.74,
      "08021": 43.26,
    },
    county_names_all: "Costilla|Conejos",
    county_fips_all: "08023|08021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81152,
    lat: 37.12609,
    lng: -105.39411,
    city: "San Luis",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1126,
    density: 0.9,
    county_fips: "08023",
    county_name: "Costilla",
    county_weights: {
      "08023": 100,
    },
    county_names_all: "Costilla",
    county_fips_all: "08023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81154,
    lat: 37.63473,
    lng: -106.67179,
    city: "South Fork",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1017,
    density: 1,
    county_fips: "08105",
    county_name: "Rio Grande",
    county_weights: {
      "08105": 65.39,
      "08079": 34.61,
    },
    county_names_all: "Rio Grande|Mineral",
    county_fips_all: "08105|08079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81155,
    lat: 38.26671,
    lng: -106.09603,
    city: "Villa Grove",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 216,
    density: 0.3,
    county_fips: "08109",
    county_name: "Saguache",
    county_weights: {
      "08109": 100,
    },
    county_names_all: "Saguache",
    county_fips_all: "08109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81201,
    lat: 38.55129,
    lng: -106.08157,
    city: "Salida",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8955,
    density: 8.6,
    county_fips: "08015",
    county_name: "Chaffee",
    county_weights: {
      "08015": 84.46,
      "08043": 15.54,
    },
    county_names_all: "Chaffee|Fremont",
    county_fips_all: "08015|08043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81210,
    lat: 38.81898,
    lng: -106.62219,
    city: "Almont",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 313,
    density: 0.3,
    county_fips: "08051",
    county_name: "Gunnison",
    county_weights: {
      "08051": 100,
    },
    county_names_all: "Gunnison",
    county_fips_all: "08051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81211,
    lat: 38.89548,
    lng: -106.24128,
    city: "Buena Vista",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9017,
    density: 7.3,
    county_fips: "08015",
    county_name: "Chaffee",
    county_weights: {
      "08015": 100,
    },
    county_names_all: "Chaffee",
    county_fips_all: "08015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81212,
    lat: 38.54409,
    lng: -105.42498,
    city: "Canon City",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31129,
    density: 17.9,
    county_fips: "08043",
    county_name: "Fremont",
    county_weights: {
      "08043": 100,
    },
    county_names_all: "Fremont",
    county_fips_all: "08043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81220,
    lat: 38.29861,
    lng: -107.48414,
    city: "Cimarron",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 118,
    density: 0.2,
    county_fips: "08051",
    county_name: "Gunnison",
    county_weights: {
      "08051": 74.43,
      "08085": 25.57,
    },
    county_names_all: "Gunnison|Montrose",
    county_fips_all: "08051|08085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81221,
    lat: 38.36243,
    lng: -105.14238,
    city: "Coal Creek",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 304,
    density: 102.4,
    county_fips: "08043",
    county_name: "Fremont",
    county_weights: {
      "08043": 100,
    },
    county_names_all: "Fremont",
    county_fips_all: "08043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81222,
    lat: 38.35492,
    lng: -105.81612,
    city: "Coaldale",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 240,
    density: 2.9,
    county_fips: "08043",
    county_name: "Fremont",
    county_weights: {
      "08043": 100,
    },
    county_names_all: "Fremont",
    county_fips_all: "08043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81223,
    lat: 38.39372,
    lng: -105.6031,
    city: "Cotopaxi",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1760,
    density: 1.7,
    county_fips: "08043",
    county_name: "Fremont",
    county_weights: {
      "08043": 100,
    },
    county_names_all: "Fremont",
    county_fips_all: "08043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81224,
    lat: 38.87985,
    lng: -106.90957,
    city: "Crested Butte",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3291,
    density: 4.8,
    county_fips: "08051",
    county_name: "Gunnison",
    county_weights: {
      "08051": 100,
    },
    county_names_all: "Gunnison",
    county_fips_all: "08051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81225,
    lat: 38.94115,
    lng: -107.00664,
    city: "Crested Butte",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1328,
    density: 17.8,
    county_fips: "08051",
    county_name: "Gunnison",
    county_weights: {
      "08051": 100,
    },
    county_names_all: "Gunnison",
    county_fips_all: "08051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81226,
    lat: 38.32213,
    lng: -105.10193,
    city: "Florence",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9110,
    density: 27.1,
    county_fips: "08043",
    county_name: "Fremont",
    county_weights: {
      "08043": 88.43,
      "08027": 11.57,
    },
    county_names_all: "Fremont|Custer",
    county_fips_all: "08043|08027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81227,
    lat: 38.54934,
    lng: -106.29009,
    city: "Monarch",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "08015",
    county_name: "Chaffee",
    county_weights: {
      "08015": 100,
    },
    county_names_all: "Chaffee",
    county_fips_all: "08015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81228,
    lat: 39.03402,
    lng: -106.27723,
    city: "Granite",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "08015",
    county_name: "Chaffee",
    county_weights: {
      "08015": 100,
    },
    county_names_all: "Chaffee",
    county_fips_all: "08015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81230,
    lat: 38.40752,
    lng: -106.98372,
    city: "Gunnison",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10110,
    density: 2.3,
    county_fips: "08051",
    county_name: "Gunnison",
    county_weights: {
      "08051": 61.48,
      "08109": 38.52,
    },
    county_names_all: "Gunnison|Saguache",
    county_fips_all: "08051|08109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81232,
    lat: 38.27535,
    lng: -105.60895,
    city: "Hillside",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 122,
    density: 57.8,
    county_fips: "08043",
    county_name: "Fremont",
    county_weights: {
      "08043": 100,
    },
    county_names_all: "Fremont",
    county_fips_all: "08043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81233,
    lat: 38.49244,
    lng: -105.81369,
    city: "Howard",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 882,
    density: 5.9,
    county_fips: "08043",
    county_name: "Fremont",
    county_weights: {
      "08043": 100,
    },
    county_names_all: "Fremont",
    county_fips_all: "08043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81235,
    lat: 37.99363,
    lng: -107.33098,
    city: "Lake City",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 740,
    density: 0.5,
    county_fips: "08053",
    county_name: "Hinsdale",
    county_weights: {
      "08053": 100,
    },
    county_names_all: "Hinsdale",
    county_fips_all: "08053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81236,
    lat: 38.6955,
    lng: -106.25424,
    city: "Nathrop",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1207,
    density: 2.9,
    county_fips: "08015",
    county_name: "Chaffee",
    county_weights: {
      "08015": 100,
    },
    county_names_all: "Chaffee",
    county_fips_all: "08015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81237,
    lat: 38.62842,
    lng: -106.59108,
    city: "Ohio City",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49,
    density: 0.4,
    county_fips: "08051",
    county_name: "Gunnison",
    county_weights: {
      "08051": 100,
    },
    county_names_all: "Gunnison",
    county_fips_all: "08051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81239,
    lat: 38.53667,
    lng: -106.60825,
    city: "Parlin",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 164,
    density: 1.5,
    county_fips: "08051",
    county_name: "Gunnison",
    county_weights: {
      "08051": 100,
    },
    county_names_all: "Gunnison",
    county_fips_all: "08051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81240,
    lat: 38.4995,
    lng: -105.03076,
    city: "Penrose",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3659,
    density: 10.2,
    county_fips: "08043",
    county_name: "Fremont",
    county_weights: {
      "08043": 100,
    },
    county_names_all: "Fremont",
    county_fips_all: "08043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81241,
    lat: 38.62675,
    lng: -106.48848,
    city: "Pitkin",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 208,
    density: 2,
    county_fips: "08051",
    county_name: "Gunnison",
    county_weights: {
      "08051": 100,
    },
    county_names_all: "Gunnison",
    county_fips_all: "08051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81242,
    lat: 38.47181,
    lng: -106.07288,
    city: "Poncha Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "08015",
    county_name: "Chaffee",
    county_weights: {
      "08015": 99.85,
      "08109": 0.15,
    },
    county_names_all: "Chaffee|Saguache",
    county_fips_all: "08015|08109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81243,
    lat: 38.26041,
    lng: -107.17654,
    city: "Powderhorn",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65,
    density: 0.1,
    county_fips: "08051",
    county_name: "Gunnison",
    county_weights: {
      "08051": 100,
    },
    county_names_all: "Gunnison",
    county_fips_all: "08051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81244,
    lat: 38.36393,
    lng: -105.16495,
    city: "Rockvale",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 407,
    density: 81.8,
    county_fips: "08043",
    county_name: "Fremont",
    county_weights: {
      "08043": 100,
    },
    county_names_all: "Fremont",
    county_fips_all: "08043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81248,
    lat: 38.3991,
    lng: -106.47763,
    city: "Sargents",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 161,
    density: 0.2,
    county_fips: "08109",
    county_name: "Saguache",
    county_weights: {
      "08109": 65.65,
      "08051": 34.35,
    },
    county_names_all: "Saguache|Gunnison",
    county_fips_all: "08109|08051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81251,
    lat: 39.13482,
    lng: -106.43723,
    city: "Twin Lakes",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 163,
    density: 0.5,
    county_fips: "08065",
    county_name: "Lake",
    county_weights: {
      "08065": 100,
    },
    county_names_all: "Lake",
    county_fips_all: "08065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81252,
    lat: 38.10891,
    lng: -105.42143,
    city: "Westcliffe",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4023,
    density: 2.5,
    county_fips: "08027",
    county_name: "Custer",
    county_weights: {
      "08027": 100,
    },
    county_names_all: "Custer",
    county_fips_all: "08027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81253,
    lat: 38.18763,
    lng: -105.07497,
    city: "Wetmore",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 698,
    density: 2.9,
    county_fips: "08027",
    county_name: "Custer",
    county_weights: {
      "08027": 70.02,
      "08043": 23.75,
      "08101": 6.23,
    },
    county_names_all: "Custer|Fremont|Pueblo",
    county_fips_all: "08027|08043|08101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81301,
    lat: 37.51095,
    lng: -107.82066,
    city: "Durango",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30307,
    density: 15.5,
    county_fips: "08067",
    county_name: "La Plata",
    county_weights: {
      "08067": 78.31,
      "08111": 21.69,
    },
    county_names_all: "La Plata|San Juan",
    county_fips_all: "08067|08111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81303,
    lat: 37.12903,
    lng: -107.85677,
    city: "Durango",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9453,
    density: 25.1,
    county_fips: "08067",
    county_name: "La Plata",
    county_weights: {
      "08067": 100,
    },
    county_names_all: "La Plata",
    county_fips_all: "08067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81320,
    lat: 37.70115,
    lng: -108.72654,
    city: "Cahone",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 376,
    density: 1,
    county_fips: "08033",
    county_name: "Dolores",
    county_weights: {
      "08033": 100,
    },
    county_names_all: "Dolores",
    county_fips_all: "08033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81321,
    lat: 37.31826,
    lng: -108.76267,
    city: "Cortez",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15389,
    density: 14.2,
    county_fips: "08083",
    county_name: "Montezuma",
    county_weights: {
      "08083": 100,
    },
    county_names_all: "Montezuma",
    county_fips_all: "08083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81323,
    lat: 37.64874,
    lng: -108.27823,
    city: "Dolores",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4758,
    density: 2.4,
    county_fips: "08033",
    county_name: "Dolores",
    county_weights: {
      "08033": 51.67,
      "08083": 48.33,
    },
    county_names_all: "Dolores|Montezuma",
    county_fips_all: "08033|08083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81324,
    lat: 37.63734,
    lng: -109.02911,
    city: "Dove Creek",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1374,
    density: 1.2,
    county_fips: "08033",
    county_name: "Dolores",
    county_weights: {
      49037: 47.01,
      "08033": 52.99,
    },
    county_names_all: "Dolores|San Juan",
    county_fips_all: "08033|49037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81325,
    lat: 37.89605,
    lng: -108.72011,
    city: "Egnar",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 140,
    density: 0.1,
    county_fips: "08033",
    county_name: "Dolores",
    county_weights: {
      "08033": 51.12,
      "08113": 48.88,
    },
    county_names_all: "Dolores|San Miguel",
    county_fips_all: "08033|08113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81326,
    lat: 37.14635,
    lng: -108.11525,
    city: "Hesperus",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2663,
    density: 2.5,
    county_fips: "08067",
    county_name: "La Plata",
    county_weights: {
      "08067": 100,
    },
    county_names_all: "La Plata",
    county_fips_all: "08067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81327,
    lat: 37.5155,
    lng: -108.66488,
    city: "Lewis",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 384,
    density: 4.9,
    county_fips: "08083",
    county_name: "Montezuma",
    county_weights: {
      "08083": 100,
    },
    county_names_all: "Montezuma",
    county_fips_all: "08083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81328,
    lat: 37.30054,
    lng: -108.3101,
    city: "Mancos",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3882,
    density: 3,
    county_fips: "08083",
    county_name: "Montezuma",
    county_weights: {
      "08083": 90.91,
      "08067": 9.09,
    },
    county_names_all: "Montezuma|La Plata",
    county_fips_all: "08083|08067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81330,
    lat: 37.23484,
    lng: -108.47828,
    city: "Mesa Verde National Park",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 154,
    density: 0.9,
    county_fips: "08083",
    county_name: "Montezuma",
    county_weights: {
      "08083": 100,
    },
    county_names_all: "Montezuma",
    county_fips_all: "08083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81331,
    lat: 37.51387,
    lng: -108.86252,
    city: "Pleasant View",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 270,
    density: 0.4,
    county_fips: "08083",
    county_name: "Montezuma",
    county_weights: {
      "08083": 100,
    },
    county_names_all: "Montezuma",
    county_fips_all: "08083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81332,
    lat: 37.69857,
    lng: -107.99292,
    city: "Rico",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 201,
    density: 2.4,
    county_fips: "08033",
    county_name: "Dolores",
    county_weights: {
      "08033": 100,
    },
    county_names_all: "Dolores",
    county_fips_all: "08033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81334,
    lat: 37.11594,
    lng: -108.63674,
    city: "Towaoc",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1476,
    density: 2.7,
    county_fips: "08083",
    county_name: "Montezuma",
    county_weights: {
      "08083": 100,
    },
    county_names_all: "Montezuma",
    county_fips_all: "08083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81335,
    lat: 37.54381,
    lng: -108.71978,
    city: "Yellow Jacket",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21,
    density: 1.8,
    county_fips: "08083",
    county_name: "Montezuma",
    county_weights: {
      "08083": 100,
    },
    county_names_all: "Montezuma",
    county_fips_all: "08083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81401,
    lat: 38.51559,
    lng: -107.78472,
    city: "Montrose",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22715,
    density: 43.8,
    county_fips: "08085",
    county_name: "Montrose",
    county_weights: {
      "08085": 100,
    },
    county_names_all: "Montrose",
    county_fips_all: "08085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81403,
    lat: 38.32308,
    lng: -107.92816,
    city: "Montrose",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11501,
    density: 8.8,
    county_fips: "08085",
    county_name: "Montrose",
    county_weights: {
      "08085": 66.88,
      "08091": 33.12,
    },
    county_names_all: "Montrose|Ouray",
    county_fips_all: "08085|08091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81410,
    lat: 38.81261,
    lng: -107.97595,
    city: "Austin",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1510,
    density: 17.1,
    county_fips: "08029",
    county_name: "Delta",
    county_weights: {
      "08029": 100,
    },
    county_names_all: "Delta",
    county_fips_all: "08029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81411,
    lat: 38.25188,
    lng: -108.97862,
    city: "Bedrock",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46,
    density: 0.2,
    county_fips: "08085",
    county_name: "Montrose",
    county_weights: {
      "08085": 100,
    },
    county_names_all: "Montrose",
    county_fips_all: "08085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81413,
    lat: 38.97171,
    lng: -107.90845,
    city: "Cedaredge",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5633,
    density: 14.2,
    county_fips: "08029",
    county_name: "Delta",
    county_weights: {
      "08029": 100,
    },
    county_names_all: "Delta",
    county_fips_all: "08029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81415,
    lat: 38.64027,
    lng: -107.6368,
    city: "Crawford",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1732,
    density: 2.4,
    county_fips: "08085",
    county_name: "Montrose",
    county_weights: {
      "08085": 60.44,
      "08029": 39.56,
    },
    county_names_all: "Montrose|Delta",
    county_fips_all: "08085|08029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81416,
    lat: 38.66482,
    lng: -108.20403,
    city: "Delta",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13793,
    density: 9.3,
    county_fips: "08029",
    county_name: "Delta",
    county_weights: {
      "08029": 56.93,
      "08085": 43.07,
    },
    county_names_all: "Delta|Montrose",
    county_fips_all: "08029|08085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81418,
    lat: 38.90479,
    lng: -108.05687,
    city: "Eckert",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1787,
    density: 9.7,
    county_fips: "08029",
    county_name: "Delta",
    county_weights: {
      "08029": 100,
    },
    county_names_all: "Delta",
    county_fips_all: "08029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81419,
    lat: 38.86332,
    lng: -107.74872,
    city: "Hotchkiss",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3235,
    density: 6,
    county_fips: "08029",
    county_name: "Delta",
    county_weights: {
      "08029": 100,
    },
    county_names_all: "Delta",
    county_fips_all: "08029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81422,
    lat: 38.32039,
    lng: -108.70843,
    city: "Naturita",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 583,
    density: 0.9,
    county_fips: "08085",
    county_name: "Montrose",
    county_weights: {
      "08085": 100,
    },
    county_names_all: "Montrose",
    county_fips_all: "08085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81423,
    lat: 38.03835,
    lng: -108.45816,
    city: "Norwood",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1782,
    density: 1.2,
    county_fips: "08113",
    county_name: "San Miguel",
    county_weights: {
      "08113": 89.97,
      "08085": 10.03,
    },
    county_names_all: "San Miguel|Montrose",
    county_fips_all: "08113|08085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81424,
    lat: 38.34098,
    lng: -108.47346,
    city: "Nucla",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1080,
    density: 1.2,
    county_fips: "08085",
    county_name: "Montrose",
    county_weights: {
      "08085": 100,
    },
    county_names_all: "Montrose",
    county_fips_all: "08085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81425,
    lat: 38.49363,
    lng: -108.10469,
    city: "Olathe",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5664,
    density: 10,
    county_fips: "08085",
    county_name: "Montrose",
    county_weights: {
      "08085": 100,
    },
    county_names_all: "Montrose",
    county_fips_all: "08085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81426,
    lat: 37.87339,
    lng: -107.83191,
    city: "Ophir",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 194,
    density: 7.7,
    county_fips: "08113",
    county_name: "San Miguel",
    county_weights: {
      "08113": 100,
    },
    county_names_all: "San Miguel",
    county_fips_all: "08113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81427,
    lat: 37.99301,
    lng: -107.64387,
    city: "Ouray",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1233,
    density: 6.4,
    county_fips: "08091",
    county_name: "Ouray",
    county_weights: {
      "08091": 100,
    },
    county_names_all: "Ouray",
    county_fips_all: "08091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81428,
    lat: 38.95928,
    lng: -107.59899,
    city: "Paonia",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3666,
    density: 7.5,
    county_fips: "08029",
    county_name: "Delta",
    county_weights: {
      "08029": 100,
    },
    county_names_all: "Delta",
    county_fips_all: "08029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81429,
    lat: 38.34121,
    lng: -108.90732,
    city: "Paradox",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 130,
    density: 0.2,
    county_fips: "08085",
    county_name: "Montrose",
    county_weights: {
      "08085": 100,
    },
    county_names_all: "Montrose",
    county_fips_all: "08085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81430,
    lat: 38.04013,
    lng: -108.05764,
    city: "Placerville",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 841,
    density: 1.5,
    county_fips: "08113",
    county_name: "San Miguel",
    county_weights: {
      "08113": 100,
    },
    county_names_all: "San Miguel",
    county_fips_all: "08113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81431,
    lat: 38.13808,
    lng: -108.51429,
    city: "Redvale",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 409,
    density: 1.2,
    county_fips: "08113",
    county_name: "San Miguel",
    county_weights: {
      "08113": 65.09,
      "08085": 34.91,
    },
    county_names_all: "San Miguel|Montrose",
    county_fips_all: "08113|08085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81432,
    lat: 38.12494,
    lng: -107.74273,
    city: "Ridgway",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3130,
    density: 4,
    county_fips: "08091",
    county_name: "Ouray",
    county_weights: {
      "08091": 99.31,
      "08113": 0.69,
    },
    county_names_all: "Ouray|San Miguel",
    county_fips_all: "08091|08113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81433,
    lat: 37.79346,
    lng: -107.59448,
    city: "Silverton",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 621,
    density: 1.1,
    county_fips: "08111",
    county_name: "San Juan",
    county_weights: {
      "08111": 100,
    },
    county_names_all: "San Juan",
    county_fips_all: "08111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81434,
    lat: 38.95384,
    lng: -107.35954,
    city: "Somerset",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 271,
    density: 0.2,
    county_fips: "08051",
    county_name: "Gunnison",
    county_weights: {
      "08051": 91.77,
      "08029": 8.23,
    },
    county_names_all: "Gunnison|Delta",
    county_fips_all: "08051|08029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81435,
    lat: 37.90014,
    lng: -107.92397,
    city: "Telluride",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5243,
    density: 10.6,
    county_fips: "08113",
    county_name: "San Miguel",
    county_weights: {
      "08113": 100,
    },
    county_names_all: "San Miguel",
    county_fips_all: "08113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81501,
    lat: 39.07174,
    lng: -108.54569,
    city: "Grand Junction",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23717,
    density: 1055.7,
    county_fips: "08077",
    county_name: "Mesa",
    county_weights: {
      "08077": 100,
    },
    county_names_all: "Mesa",
    county_fips_all: "08077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81503,
    lat: 39.03094,
    lng: -108.48682,
    city: "Grand Junction",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15533,
    density: 272.5,
    county_fips: "08077",
    county_name: "Mesa",
    county_weights: {
      "08077": 100,
    },
    county_names_all: "Mesa",
    county_fips_all: "08077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81504,
    lat: 39.1198,
    lng: -108.49542,
    city: "Grand Junction",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30192,
    density: 433.1,
    county_fips: "08077",
    county_name: "Mesa",
    county_weights: {
      "08077": 100,
    },
    county_names_all: "Mesa",
    county_fips_all: "08077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81505,
    lat: 39.18593,
    lng: -108.59997,
    city: "Grand Junction",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10599,
    density: 56.8,
    county_fips: "08077",
    county_name: "Mesa",
    county_weights: {
      "08077": 100,
    },
    county_names_all: "Mesa",
    county_fips_all: "08077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81506,
    lat: 39.15785,
    lng: -108.53454,
    city: "Grand Junction",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11895,
    density: 191.9,
    county_fips: "08077",
    county_name: "Mesa",
    county_weights: {
      "08077": 100,
    },
    county_names_all: "Mesa",
    county_fips_all: "08077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81507,
    lat: 39.0079,
    lng: -108.62644,
    city: "Grand Junction",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15068,
    density: 51.9,
    county_fips: "08077",
    county_name: "Mesa",
    county_weights: {
      "08077": 100,
    },
    county_names_all: "Mesa",
    county_fips_all: "08077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81520,
    lat: 39.10962,
    lng: -108.43561,
    city: "Clifton",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14337,
    density: 269.4,
    county_fips: "08077",
    county_name: "Mesa",
    county_weights: {
      "08077": 100,
    },
    county_names_all: "Mesa",
    county_fips_all: "08077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81521,
    lat: 39.12529,
    lng: -108.85049,
    city: "Fruita",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16178,
    density: 34.4,
    county_fips: "08077",
    county_name: "Mesa",
    county_weights: {
      "08077": 100,
    },
    county_names_all: "Mesa",
    county_fips_all: "08077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81522,
    lat: 38.66026,
    lng: -108.93025,
    city: "Gateway",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 107,
    density: 0.1,
    county_fips: "08077",
    county_name: "Mesa",
    county_weights: {
      "08077": 100,
    },
    county_names_all: "Mesa",
    county_fips_all: "08077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81523,
    lat: 38.93803,
    lng: -108.87362,
    city: "Glade Park",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 749,
    density: 1,
    county_fips: "08077",
    county_name: "Mesa",
    county_weights: {
      "08077": 100,
    },
    county_names_all: "Mesa",
    county_fips_all: "08077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81524,
    lat: 39.2842,
    lng: -108.73257,
    city: "Loma",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2519,
    density: 7,
    county_fips: "08077",
    county_name: "Mesa",
    county_weights: {
      "08077": 100,
    },
    county_names_all: "Mesa",
    county_fips_all: "08077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81525,
    lat: 39.26984,
    lng: -108.95075,
    city: "Mack",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1522,
    density: 3.8,
    county_fips: "08077",
    county_name: "Mesa",
    county_weights: {
      "08077": 100,
    },
    county_names_all: "Mesa",
    county_fips_all: "08077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81526,
    lat: 39.07741,
    lng: -108.33056,
    city: "Palisade",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5789,
    density: 30.9,
    county_fips: "08077",
    county_name: "Mesa",
    county_weights: {
      "08077": 100,
    },
    county_names_all: "Mesa",
    county_fips_all: "08077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81527,
    lat: 38.75758,
    lng: -108.52466,
    city: "Whitewater",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1674,
    density: 0.8,
    county_fips: "08077",
    county_name: "Mesa",
    county_weights: {
      "08077": 100,
    },
    county_names_all: "Mesa",
    county_fips_all: "08077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81601,
    lat: 39.59357,
    lng: -107.32815,
    city: "Glenwood Springs",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16359,
    density: 17.2,
    county_fips: "08045",
    county_name: "Garfield",
    county_weights: {
      "08045": 100,
    },
    county_names_all: "Garfield",
    county_fips_all: "08045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81610,
    lat: 40.29418,
    lng: -108.82468,
    city: "Dinosaur",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 294,
    density: 0.5,
    county_fips: "08081",
    county_name: "Moffat",
    county_weights: {
      "08081": 100,
    },
    county_names_all: "Moffat",
    county_fips_all: "08081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81611,
    lat: 39.14561,
    lng: -106.74885,
    city: "Aspen",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10814,
    density: 13.7,
    county_fips: "08097",
    county_name: "Pitkin",
    county_weights: {
      "08097": 100,
    },
    county_names_all: "Pitkin",
    county_fips_all: "08097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81612,
    lat: 39.05048,
    lng: -106.82335,
    city: "Aspen",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "08097",
    county_name: "Pitkin",
    county_weights: {
      "08097": 100,
    },
    county_names_all: "Pitkin",
    county_fips_all: "08097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81615,
    lat: 39.21437,
    lng: -106.94172,
    city: "Snowmass Village",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2786,
    density: 42.5,
    county_fips: "08097",
    county_name: "Pitkin",
    county_weights: {
      "08097": 100,
    },
    county_names_all: "Pitkin",
    county_fips_all: "08097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81620,
    lat: 39.61485,
    lng: -106.50555,
    city: "Avon",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11912,
    density: 85.1,
    county_fips: "08037",
    county_name: "Eagle",
    county_weights: {
      "08037": 100,
    },
    county_names_all: "Eagle",
    county_fips_all: "08037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81621,
    lat: 39.37803,
    lng: -106.8772,
    city: "Basalt",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6344,
    density: 9.5,
    county_fips: "08037",
    county_name: "Eagle",
    county_weights: {
      "08037": 64.85,
      "08097": 35.15,
    },
    county_names_all: "Eagle|Pitkin",
    county_fips_all: "08037|08097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81623,
    lat: 39.2451,
    lng: -107.20921,
    city: "Carbondale",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16166,
    density: 14.4,
    county_fips: "08097",
    county_name: "Pitkin",
    county_weights: {
      "08097": 53.89,
      "08051": 23.92,
      "08045": 16.55,
      "08037": 5.64,
    },
    county_names_all: "Pitkin|Gunnison|Garfield|Eagle",
    county_fips_all: "08097|08051|08045|08037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81624,
    lat: 39.24611,
    lng: -107.77259,
    city: "Collbran",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1470,
    density: 1,
    county_fips: "08077",
    county_name: "Mesa",
    county_weights: {
      "08077": 100,
    },
    county_names_all: "Mesa",
    county_fips_all: "08077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81625,
    lat: 40.70295,
    lng: -107.74652,
    city: "Craig",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12670,
    density: 3.2,
    county_fips: "08081",
    county_name: "Moffat",
    county_weights: {
      "08081": 100,
    },
    county_names_all: "Moffat",
    county_fips_all: "08081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81630,
    lat: 39.45769,
    lng: -108.54627,
    city: "De Beque",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1151,
    density: 0.4,
    county_fips: "08045",
    county_name: "Garfield",
    county_weights: {
      "08045": 76.6,
      "08077": 23.4,
    },
    county_names_all: "Garfield|Mesa",
    county_fips_all: "08045|08077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81631,
    lat: 39.63116,
    lng: -106.77136,
    city: "Eagle",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8475,
    density: 14.8,
    county_fips: "08037",
    county_name: "Eagle",
    county_weights: {
      "08037": 100,
    },
    county_names_all: "Eagle",
    county_fips_all: "08037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81632,
    lat: 39.62015,
    lng: -106.61132,
    city: "Edwards",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9294,
    density: 31,
    county_fips: "08037",
    county_name: "Eagle",
    county_weights: {
      "08037": 100,
    },
    county_names_all: "Eagle",
    county_fips_all: "08037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81633,
    lat: 40.37644,
    lng: -108.50983,
    city: "Dinosaur",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "08081",
    county_name: "Moffat",
    county_weights: {
      "08081": 100,
    },
    county_names_all: "Moffat",
    county_fips_all: "08081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81635,
    lat: 39.53722,
    lng: -108.06022,
    city: "Parachute",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6862,
    density: 8,
    county_fips: "08045",
    county_name: "Garfield",
    county_weights: {
      "08045": 97.09,
      "08077": 2.91,
    },
    county_names_all: "Garfield|Mesa",
    county_fips_all: "08045|08077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81637,
    lat: 39.77162,
    lng: -107.10065,
    city: "Gypsum",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8277,
    density: 4.1,
    county_fips: "08045",
    county_name: "Garfield",
    county_weights: {
      "08045": 53.97,
      "08037": 46.03,
    },
    county_names_all: "Garfield|Eagle",
    county_fips_all: "08045|08037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81638,
    lat: 40.30589,
    lng: -107.64205,
    city: "Hamilton",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19,
    density: 0,
    county_fips: "08081",
    county_name: "Moffat",
    county_weights: {
      "08081": 77.29,
      "08107": 22.71,
    },
    county_names_all: "Moffat|Routt",
    county_fips_all: "08081|08107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81639,
    lat: 40.52636,
    lng: -107.24457,
    city: "Hayden",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2932,
    density: 2.4,
    county_fips: "08107",
    county_name: "Routt",
    county_weights: {
      "08107": 100,
    },
    county_names_all: "Routt",
    county_fips_all: "08107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81640,
    lat: 40.69357,
    lng: -108.51791,
    city: "Maybell",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 112,
    density: 0,
    county_fips: "08081",
    county_name: "Moffat",
    county_weights: {
      "08081": 100,
    },
    county_names_all: "Moffat",
    county_fips_all: "08081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81641,
    lat: 40.09112,
    lng: -107.84699,
    city: "Meeker",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3862,
    density: 0.8,
    county_fips: "08103",
    county_name: "Rio Blanco",
    county_weights: {
      "08103": 83,
      "08081": 17,
    },
    county_names_all: "Rio Blanco|Moffat",
    county_fips_all: "08103|08081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81642,
    lat: 39.31202,
    lng: -106.58448,
    city: "Meredith",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9,
    density: 0,
    county_fips: "08097",
    county_name: "Pitkin",
    county_weights: {
      "08097": 100,
    },
    county_names_all: "Pitkin",
    county_fips_all: "08097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81643,
    lat: 39.11968,
    lng: -108.15001,
    city: "Mesa",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 430,
    density: 1.1,
    county_fips: "08077",
    county_name: "Mesa",
    county_weights: {
      "08077": 100,
    },
    county_names_all: "Mesa",
    county_fips_all: "08077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81645,
    lat: 39.47634,
    lng: -106.46779,
    city: "Minturn",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1149,
    density: 4.3,
    county_fips: "08037",
    county_name: "Eagle",
    county_weights: {
      "08037": 100,
    },
    county_names_all: "Eagle",
    county_fips_all: "08037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81646,
    lat: 39.10875,
    lng: -107.99199,
    city: "Molina",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 182,
    density: 1,
    county_fips: "08077",
    county_name: "Mesa",
    county_weights: {
      "08077": 100,
    },
    county_names_all: "Mesa",
    county_fips_all: "08077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81647,
    lat: 39.57972,
    lng: -107.5364,
    city: "New Castle",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6961,
    density: 9.4,
    county_fips: "08045",
    county_name: "Garfield",
    county_weights: {
      "08045": 100,
    },
    county_names_all: "Garfield",
    county_fips_all: "08045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81648,
    lat: 39.95096,
    lng: -108.78498,
    city: "Rangely",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2476,
    density: 0.9,
    county_fips: "08103",
    county_name: "Rio Blanco",
    county_weights: {
      "08103": 100,
    },
    county_names_all: "Rio Blanco",
    county_fips_all: "08103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81649,
    lat: 39.46433,
    lng: -106.31954,
    city: "Red Cliff",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 318,
    density: 0.9,
    county_fips: "08037",
    county_name: "Eagle",
    county_weights: {
      "08037": 100,
    },
    county_names_all: "Eagle",
    county_fips_all: "08037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81650,
    lat: 39.75926,
    lng: -108.11201,
    city: "Rifle",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13758,
    density: 5.2,
    county_fips: "08103",
    county_name: "Rio Blanco",
    county_weights: {
      "08103": 59.93,
      "08045": 40.07,
    },
    county_names_all: "Rio Blanco|Garfield",
    county_fips_all: "08103|08045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81652,
    lat: 39.472,
    lng: -107.67082,
    city: "Silt",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5164,
    density: 18.9,
    county_fips: "08045",
    county_name: "Garfield",
    county_weights: {
      "08045": 100,
    },
    county_names_all: "Garfield",
    county_fips_all: "08045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81653,
    lat: 40.9144,
    lng: -107.2242,
    city: "Slater",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8,
    density: 0,
    county_fips: "08107",
    county_name: "Routt",
    county_weights: {
      "08107": 87.48,
      "08081": 12.52,
    },
    county_names_all: "Routt|Moffat",
    county_fips_all: "08107|08081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81654,
    lat: 39.21462,
    lng: -107.02597,
    city: "Snowmass",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1729,
    density: 6.5,
    county_fips: "08097",
    county_name: "Pitkin",
    county_weights: {
      "08097": 100,
    },
    county_names_all: "Pitkin",
    county_fips_all: "08097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81655,
    lat: 39.7477,
    lng: -106.67821,
    city: "Wolcott",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 112,
    density: 0.7,
    county_fips: "08037",
    county_name: "Eagle",
    county_weights: {
      "08037": 100,
    },
    county_names_all: "Eagle",
    county_fips_all: "08037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81656,
    lat: 39.27948,
    lng: -106.78711,
    city: "Woody Creek",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "08097",
    county_name: "Pitkin",
    county_weights: {
      "08097": 100,
    },
    county_names_all: "Pitkin",
    county_fips_all: "08097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 81657,
    lat: 39.64864,
    lng: -106.32608,
    city: "Vail",
    state_id: "CO",
    state_name: "Colorado",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5903,
    density: 19.6,
    county_fips: "08037",
    county_name: "Eagle",
    county_weights: {
      "08037": 100,
    },
    county_names_all: "Eagle",
    county_fips_all: "08037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82001,
    lat: 41.095,
    lng: -104.93265,
    city: "Cheyenne",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36944,
    density: 258.8,
    county_fips: 56021,
    county_name: "Laramie",
    county_weights: {
      56021: 100,
    },
    county_names_all: "Laramie",
    county_fips_all: 56021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82005,
    lat: 41.14631,
    lng: -104.86787,
    city: "Fe Warren Afb",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 646,
    density: 96.3,
    county_fips: 56021,
    county_name: "Laramie",
    county_weights: {
      56021: 100,
    },
    county_names_all: "Laramie",
    county_fips_all: 56021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82007,
    lat: 41.06231,
    lng: -104.75591,
    city: "Cheyenne",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21642,
    density: 43.1,
    county_fips: 56021,
    county_name: "Laramie",
    county_weights: {
      56021: 100,
    },
    county_names_all: "Laramie",
    county_fips_all: 56021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82009,
    lat: 41.38431,
    lng: -104.85415,
    city: "Cheyenne",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34666,
    density: 10.5,
    county_fips: 56021,
    county_name: "Laramie",
    county_weights: {
      56021: 100,
    },
    county_names_all: "Laramie",
    county_fips_all: 56021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82050,
    lat: 41.43517,
    lng: -104.21477,
    city: "Albin",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 323,
    density: 0.9,
    county_fips: 56021,
    county_name: "Laramie",
    county_weights: {
      56021: 100,
    },
    county_names_all: "Laramie",
    county_fips_all: 56021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82051,
    lat: 41.60053,
    lng: -105.64743,
    city: "Bosler",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24,
    density: 0,
    county_fips: 56001,
    county_name: "Albany",
    county_weights: {
      56001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 56001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82052,
    lat: 41.12399,
    lng: -105.34802,
    city: "Buford",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 56001,
    county_name: "Albany",
    county_weights: {
      56001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 56001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82053,
    lat: 41.24392,
    lng: -104.348,
    city: "Burns",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1268,
    density: 2.3,
    county_fips: 56021,
    county_name: "Laramie",
    county_weights: {
      56021: 100,
    },
    county_names_all: "Laramie",
    county_fips_all: 56021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82054,
    lat: 41.0647,
    lng: -104.35899,
    city: "Carpenter",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1243,
    density: 2.6,
    county_fips: 56021,
    county_name: "Laramie",
    county_weights: {
      56021: 100,
    },
    county_names_all: "Laramie",
    county_fips_all: 56021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82055,
    lat: 41.3483,
    lng: -106.18191,
    city: "Centennial",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 292,
    density: 1.9,
    county_fips: 56001,
    county_name: "Albany",
    county_weights: {
      56001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 56001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82058,
    lat: 42.13817,
    lng: -105.63358,
    city: "Garrett",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6,
    density: 0,
    county_fips: 56001,
    county_name: "Albany",
    county_weights: {
      56001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 56001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82059,
    lat: 41.05681,
    lng: -105.17714,
    city: "Granite Canon",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 186,
    density: 0.8,
    county_fips: 56021,
    county_name: "Laramie",
    county_weights: {
      56021: 100,
    },
    county_names_all: "Laramie",
    county_fips_all: 56021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82060,
    lat: 41.22526,
    lng: -104.51505,
    city: "Hillsdale",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 281,
    density: 2.6,
    county_fips: 56021,
    county_name: "Laramie",
    county_weights: {
      56021: 100,
    },
    county_names_all: "Laramie",
    county_fips_all: 56021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82061,
    lat: 41.43791,
    lng: -105.15495,
    city: "Horse Creek",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 56021,
    county_name: "Laramie",
    county_weights: {
      56021: 100,
    },
    county_names_all: "Laramie",
    county_fips_all: 56021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82063,
    lat: 40.87554,
    lng: -105.9889,
    city: "Jelm",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 109,
    density: 0.1,
    county_fips: "08069",
    county_name: "Larimer",
    county_weights: {
      56001: 20.3,
      "08069": 79.7,
    },
    county_names_all: "Larimer|Albany",
    county_fips_all: "08069|56001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82070,
    lat: 41.21404,
    lng: -105.85037,
    city: "Laramie",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20489,
    density: 7.8,
    county_fips: 56001,
    county_name: "Albany",
    county_weights: {
      56001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 56001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82072,
    lat: 41.42557,
    lng: -105.55849,
    city: "Laramie",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17318,
    density: 35.4,
    county_fips: 56001,
    county_name: "Albany",
    county_weights: {
      56001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 56001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82073,
    lat: 41.16408,
    lng: -105.43228,
    city: "Laramie",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 56001,
    county_name: "Albany",
    county_weights: {
      56001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 56001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82081,
    lat: 41.52319,
    lng: -104.40653,
    city: "Meriden",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 70,
    density: 0.3,
    county_fips: 56021,
    county_name: "Laramie",
    county_weights: {
      56021: 100,
    },
    county_names_all: "Laramie",
    county_fips_all: 56021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82082,
    lat: 41.2632,
    lng: -104.09359,
    city: "Pine Bluffs",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2017,
    density: 2.4,
    county_fips: 56021,
    county_name: "Laramie",
    county_weights: {
      31007: 16.91,
      31105: 10.66,
      56021: 70.63,
      "08123": 1.8,
    },
    county_names_all: "Laramie|Banner|Kimball|Weld",
    county_fips_all: "56021|31007|31105|08123",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82083,
    lat: 41.72291,
    lng: -105.99118,
    city: "Rock River",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 338,
    density: 0.5,
    county_fips: 56001,
    county_name: "Albany",
    county_weights: {
      56001: 65.36,
      56007: 34.64,
    },
    county_names_all: "Albany|Carbon",
    county_fips_all: "56001|56007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82084,
    lat: 41.04764,
    lng: -105.52494,
    city: "Tie Siding",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6,
    density: 0,
    county_fips: 56001,
    county_name: "Albany",
    county_weights: {
      56001: 100,
    },
    county_names_all: "Albany",
    county_fips_all: 56001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82190,
    lat: 44.57439,
    lng: -110.51807,
    city: "Yellowstone National Park",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1183,
    density: 0.2,
    county_fips: 56029,
    county_name: "Park",
    county_weights: {
      56029: 55.76,
      56039: 44.24,
    },
    county_names_all: "Park|Teton",
    county_fips_all: "56029|56039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82201,
    lat: 42.01049,
    lng: -105.11328,
    city: "Wheatland",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6830,
    density: 1.6,
    county_fips: 56031,
    county_name: "Platte",
    county_weights: {
      56001: 28.3,
      56031: 71.7,
    },
    county_names_all: "Platte|Albany",
    county_fips_all: "56031|56001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82210,
    lat: 41.73214,
    lng: -104.77981,
    city: "Chugwater",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 243,
    density: 0.3,
    county_fips: 56031,
    county_name: "Platte",
    county_weights: {
      56015: 25.69,
      56031: 74.31,
    },
    county_names_all: "Platte|Goshen",
    county_fips_all: "56031|56015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82212,
    lat: 42.26126,
    lng: -104.51995,
    city: "Fort Laramie",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 577,
    density: 0.6,
    county_fips: 56015,
    county_name: "Goshen",
    county_weights: {
      56015: 100,
    },
    county_names_all: "Goshen",
    county_fips_all: 56015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82213,
    lat: 42.50216,
    lng: -105.00672,
    city: "Glendo",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 349,
    density: 0.3,
    county_fips: 56031,
    county_name: "Platte",
    county_weights: {
      56031: 100,
    },
    county_names_all: "Platte",
    county_fips_all: 56031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82214,
    lat: 42.26421,
    lng: -104.75104,
    city: "Guernsey",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1179,
    density: 6.1,
    county_fips: 56031,
    county_name: "Platte",
    county_weights: {
      56031: 100,
    },
    county_names_all: "Platte",
    county_fips_all: 56031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82215,
    lat: 42.39738,
    lng: -104.71507,
    city: "Hartville",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 119,
    density: 0.8,
    county_fips: 56031,
    county_name: "Platte",
    county_weights: {
      56031: 100,
    },
    county_names_all: "Platte",
    county_fips_all: 56031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82217,
    lat: 41.76223,
    lng: -104.17504,
    city: "Hawk Springs",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27,
    density: 0.1,
    county_fips: 56015,
    county_name: "Goshen",
    county_weights: {
      56015: 100,
    },
    county_names_all: "Goshen",
    county_fips_all: 56015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82218,
    lat: 41.93623,
    lng: -104.14004,
    city: "Huntley",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 56015,
    county_name: "Goshen",
    county_weights: {
      56015: 100,
    },
    county_names_all: "Goshen",
    county_fips_all: 56015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82219,
    lat: 42.4973,
    lng: -104.50627,
    city: "Jay Em",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28,
    density: 0.1,
    county_fips: 56015,
    county_name: "Goshen",
    county_weights: {
      56015: 100,
    },
    county_names_all: "Goshen",
    county_fips_all: 56015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82221,
    lat: 41.63816,
    lng: -104.34264,
    city: "Lagrange",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 502,
    density: 0.6,
    county_fips: 56015,
    county_name: "Goshen",
    county_weights: {
      56015: 97.92,
      56021: 2.08,
    },
    county_names_all: "Goshen|Laramie",
    county_fips_all: "56015|56021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82222,
    lat: 43.16311,
    lng: -104.64988,
    city: "Lance Creek",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 129,
    density: 0.2,
    county_fips: 56027,
    county_name: "Niobrara",
    county_weights: {
      56027: 100,
    },
    county_names_all: "Niobrara",
    county_fips_all: 56027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82223,
    lat: 42.12035,
    lng: -104.38503,
    city: "Lingle",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 850,
    density: 2.7,
    county_fips: 56015,
    county_name: "Goshen",
    county_weights: {
      56015: 100,
    },
    county_names_all: "Goshen",
    county_fips_all: 56015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82224,
    lat: 42.93677,
    lng: -104.88811,
    city: "Lost Springs",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10,
    density: 0,
    county_fips: 56009,
    county_name: "Converse",
    county_weights: {
      56009: 51.8,
      56027: 48.2,
    },
    county_names_all: "Converse|Niobrara",
    county_fips_all: "56009|56027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82225,
    lat: 42.95428,
    lng: -104.31385,
    city: "Lusk",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1887,
    density: 0.7,
    county_fips: 56027,
    county_name: "Niobrara",
    county_weights: {
      56015: 5.64,
      56027: 94.36,
    },
    county_names_all: "Niobrara|Goshen",
    county_fips_all: "56027|56015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82227,
    lat: 42.72083,
    lng: -104.72875,
    city: "Manville",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 211,
    density: 0.3,
    county_fips: 56027,
    county_name: "Niobrara",
    county_weights: {
      56027: 100,
    },
    county_names_all: "Niobrara",
    county_fips_all: 56027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82229,
    lat: 42.85613,
    lng: -104.9863,
    city: "Shawnee",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1,
    density: 0,
    county_fips: 56009,
    county_name: "Converse",
    county_weights: {
      56009: 99.9,
      56027: 0.1,
    },
    county_names_all: "Converse|Niobrara",
    county_fips_all: "56009|56027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82240,
    lat: 42.23064,
    lng: -104.17824,
    city: "Torrington",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10680,
    density: 6.2,
    county_fips: 56015,
    county_name: "Goshen",
    county_weights: {
      56015: 100,
    },
    county_names_all: "Goshen",
    county_fips_all: 56015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82242,
    lat: 42.67694,
    lng: -104.13886,
    city: "Van Tassell",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23,
    density: 0.1,
    county_fips: 56027,
    county_name: "Niobrara",
    county_weights: {
      56015: 12.59,
      56027: 87.41,
    },
    county_names_all: "Niobrara|Goshen",
    county_fips_all: "56027|56015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82243,
    lat: 41.99442,
    lng: -104.41451,
    city: "Veteran",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44,
    density: 0.3,
    county_fips: 56015,
    county_name: "Goshen",
    county_weights: {
      56015: 100,
    },
    county_names_all: "Goshen",
    county_fips_all: 56015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82244,
    lat: 41.87602,
    lng: -104.44228,
    city: "Yoder",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 540,
    density: 0.7,
    county_fips: 56015,
    county_name: "Goshen",
    county_weights: {
      56015: 100,
    },
    county_names_all: "Goshen",
    county_fips_all: 56015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82301,
    lat: 41.98163,
    lng: -107.47745,
    city: "Rawlins",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8815,
    density: 3.6,
    county_fips: 56007,
    county_name: "Carbon",
    county_weights: {
      56007: 64.34,
      56037: 35.66,
    },
    county_names_all: "Carbon|Sweetwater",
    county_fips_all: "56007|56037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82310,
    lat: 42.44566,
    lng: -107.8775,
    city: "Jeffrey City",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 56013,
    county_name: "Fremont",
    county_weights: {
      56013: 100,
    },
    county_names_all: "Fremont",
    county_fips_all: 56013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82321,
    lat: 41.15921,
    lng: -107.69697,
    city: "Baggs",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 684,
    density: 1.6,
    county_fips: 56007,
    county_name: "Carbon",
    county_weights: {
      56007: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 56007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82322,
    lat: 42.24643,
    lng: -107.54816,
    city: "Bairoil",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 209,
    density: 15.3,
    county_fips: 56037,
    county_name: "Sweetwater",
    county_weights: {
      56013: 0.21,
      56037: 99.79,
    },
    county_names_all: "Sweetwater|Fremont",
    county_fips_all: "56037|56013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82323,
    lat: 41.0308,
    lng: -107.52201,
    city: "Dixon",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 267,
    density: 6.7,
    county_fips: 56007,
    county_name: "Carbon",
    county_weights: {
      56007: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 56007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82324,
    lat: 41.64509,
    lng: -106.43721,
    city: "Elk Mountain",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 236,
    density: 0.6,
    county_fips: 56007,
    county_name: "Carbon",
    county_weights: {
      56007: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 56007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82325,
    lat: 41.1628,
    lng: -106.7919,
    city: "Encampment",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 883,
    density: 0.8,
    county_fips: 56007,
    county_name: "Carbon",
    county_weights: {
      56007: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 56007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82327,
    lat: 42.17354,
    lng: -106.69289,
    city: "Hanna",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 989,
    density: 1.2,
    county_fips: 56007,
    county_name: "Carbon",
    county_weights: {
      56007: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 56007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82329,
    lat: 42.09073,
    lng: -106.09959,
    city: "Medicine Bow",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 313,
    density: 0.4,
    county_fips: 56007,
    county_name: "Carbon",
    county_weights: {
      56001: 42.16,
      56007: 57.84,
    },
    county_names_all: "Carbon|Albany",
    county_fips_all: "56007|56001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82331,
    lat: 41.38607,
    lng: -106.82252,
    city: "Saratoga",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2173,
    density: 1.6,
    county_fips: 56007,
    county_name: "Carbon",
    county_weights: {
      56007: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 56007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82332,
    lat: 41.06314,
    lng: -107.3016,
    city: "Savery",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 94,
    density: 0.2,
    county_fips: 56007,
    county_name: "Carbon",
    county_weights: {
      56007: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 56007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82334,
    lat: 41.92837,
    lng: -106.9679,
    city: "Sinclair",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 491,
    density: 1.2,
    county_fips: 56007,
    county_name: "Carbon",
    county_weights: {
      56007: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 56007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82335,
    lat: 41.76174,
    lng: -106.82553,
    city: "Walcott",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45,
    density: 1.4,
    county_fips: 56007,
    county_name: "Carbon",
    county_weights: {
      56007: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 56007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82336,
    lat: 41.71046,
    lng: -108.16368,
    city: "Wamsutter",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 214,
    density: 0.2,
    county_fips: 56037,
    county_name: "Sweetwater",
    county_weights: {
      56037: 100,
    },
    county_names_all: "Sweetwater",
    county_fips_all: 56037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82401,
    lat: 44.00089,
    lng: -108.1677,
    city: "Worland",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7268,
    density: 5,
    county_fips: 56043,
    county_name: "Washakie",
    county_weights: {
      56003: 2.57,
      56017: 14.14,
      56043: 83.29,
    },
    county_names_all: "Washakie|Hot Springs|Big Horn",
    county_fips_all: "56043|56017|56003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82410,
    lat: 44.37297,
    lng: -108.15093,
    city: "Basin",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2181,
    density: 5.4,
    county_fips: 56003,
    county_name: "Big Horn",
    county_weights: {
      56003: 100,
    },
    county_names_all: "Big Horn",
    county_fips_all: 56003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82411,
    lat: 44.44995,
    lng: -108.47663,
    city: "Burlington",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 569,
    density: 1.6,
    county_fips: 56003,
    county_name: "Big Horn",
    county_weights: {
      56003: 100,
    },
    county_names_all: "Big Horn",
    county_fips_all: 56003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82412,
    lat: 44.79014,
    lng: -108.55286,
    city: "Byron",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 515,
    density: 14.9,
    county_fips: 56003,
    county_name: "Big Horn",
    county_weights: {
      56003: 99.86,
      56029: 0.14,
    },
    county_names_all: "Big Horn|Park",
    county_fips_all: "56003|56029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82414,
    lat: 44.45727,
    lng: -109.59671,
    city: "Cody",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15383,
    density: 2.2,
    county_fips: 56029,
    county_name: "Park",
    county_weights: {
      56029: 100,
    },
    county_names_all: "Park",
    county_fips_all: 56029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82420,
    lat: 44.92254,
    lng: -108.46149,
    city: "Cowley",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 733,
    density: 5.3,
    county_fips: 56003,
    county_name: "Big Horn",
    county_weights: {
      56003: 100,
    },
    county_names_all: "Big Horn",
    county_fips_all: 56003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82421,
    lat: 44.88399,
    lng: -108.60497,
    city: "Deaver",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 221,
    density: 1.1,
    county_fips: 56029,
    county_name: "Park",
    county_weights: {
      56003: 49.98,
      56029: 50.02,
    },
    county_names_all: "Park|Big Horn",
    county_fips_all: "56029|56003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82422,
    lat: 44.49768,
    lng: -108.37943,
    city: "Emblem",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23,
    density: 0.8,
    county_fips: 56003,
    county_name: "Big Horn",
    county_weights: {
      56003: 100,
    },
    county_names_all: "Big Horn",
    county_fips_all: 56003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82423,
    lat: 44.98029,
    lng: -108.58432,
    city: "Frannie",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 256,
    density: 8,
    county_fips: 56003,
    county_name: "Big Horn",
    county_weights: {
      56003: 90.11,
      56029: 9.89,
    },
    county_names_all: "Big Horn|Park",
    county_fips_all: "56003|56029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82426,
    lat: 44.51595,
    lng: -108.02938,
    city: "Greybull",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3161,
    density: 4.4,
    county_fips: 56003,
    county_name: "Big Horn",
    county_weights: {
      56003: 100,
    },
    county_names_all: "Big Horn",
    county_fips_all: 56003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82428,
    lat: 44.29866,
    lng: -107.59032,
    city: "Hyattville",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 166,
    density: 0.6,
    county_fips: 56003,
    county_name: "Big Horn",
    county_weights: {
      56003: 100,
    },
    county_names_all: "Big Horn",
    county_fips_all: 56003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82430,
    lat: 43.80433,
    lng: -108.17898,
    city: "Kirby",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 77,
    density: 7.9,
    county_fips: 56017,
    county_name: "Hot Springs",
    county_weights: {
      56017: 100,
    },
    county_names_all: "Hot Springs",
    county_fips_all: 56017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82431,
    lat: 44.87059,
    lng: -108.16218,
    city: "Lovell",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3339,
    density: 2.7,
    county_fips: 56003,
    county_name: "Big Horn",
    county_weights: {
      56003: 100,
    },
    county_names_all: "Big Horn",
    county_fips_all: 56003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82432,
    lat: 44.23641,
    lng: -107.88175,
    city: "Manderson",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 246,
    density: 0.7,
    county_fips: 56003,
    county_name: "Big Horn",
    county_weights: {
      56003: 100,
    },
    county_names_all: "Big Horn",
    county_fips_all: 56003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82433,
    lat: 44.0616,
    lng: -109.12558,
    city: "Meeteetse",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1248,
    density: 0.6,
    county_fips: 56029,
    county_name: "Park",
    county_weights: {
      56029: 100,
    },
    county_names_all: "Park",
    county_fips_all: 56029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82434,
    lat: 44.34726,
    lng: -108.30767,
    city: "Otto",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 101,
    density: 0.8,
    county_fips: 56003,
    county_name: "Big Horn",
    county_weights: {
      56003: 100,
    },
    county_names_all: "Big Horn",
    county_fips_all: 56003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82435,
    lat: 44.82409,
    lng: -109.0348,
    city: "Powell",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11971,
    density: 6,
    county_fips: 56029,
    county_name: "Park",
    county_weights: {
      56003: 4.47,
      56029: 95.53,
    },
    county_names_all: "Park|Big Horn",
    county_fips_all: "56029|56003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82440,
    lat: 44.71743,
    lng: -108.86781,
    city: "Ralston",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 220,
    density: 133.6,
    county_fips: 56029,
    county_name: "Park",
    county_weights: {
      56029: 100,
    },
    county_names_all: "Park",
    county_fips_all: 56029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82441,
    lat: 44.58025,
    lng: -107.60799,
    city: "Shell",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 184,
    density: 0.2,
    county_fips: 56003,
    county_name: "Big Horn",
    county_weights: {
      56003: 100,
    },
    county_names_all: "Big Horn",
    county_fips_all: 56003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82442,
    lat: 43.92096,
    lng: -107.31087,
    city: "Ten Sleep",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 776,
    density: 0.5,
    county_fips: 56043,
    county_name: "Washakie",
    county_weights: {
      56043: 100,
    },
    county_names_all: "Washakie",
    county_fips_all: 56043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82443,
    lat: 43.71794,
    lng: -108.48023,
    city: "Thermopolis",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4473,
    density: 1.6,
    county_fips: 56017,
    county_name: "Hot Springs",
    county_weights: {
      56017: 100,
    },
    county_names_all: "Hot Springs",
    county_fips_all: 56017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82450,
    lat: 44.50398,
    lng: -109.43379,
    city: "Wapiti",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 150,
    density: 1.7,
    county_fips: 56029,
    county_name: "Park",
    county_weights: {
      56029: 100,
    },
    county_names_all: "Park",
    county_fips_all: 56029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82501,
    lat: 43.03325,
    lng: -108.24936,
    city: "Riverton",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19660,
    density: 10.9,
    county_fips: 56013,
    county_name: "Fremont",
    county_weights: {
      56013: 100,
    },
    county_names_all: "Fremont",
    county_fips_all: 56013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82510,
    lat: 42.99294,
    lng: -108.6055,
    city: "Arapahoe",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 349,
    density: 2.1,
    county_fips: 56013,
    county_name: "Fremont",
    county_weights: {
      56013: 100,
    },
    county_names_all: "Fremont",
    county_fips_all: 56013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82512,
    lat: 43.1639,
    lng: -109.24974,
    city: "Crowheart",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 179,
    density: 0.1,
    county_fips: 56013,
    county_name: "Fremont",
    county_weights: {
      56013: 100,
    },
    county_names_all: "Fremont",
    county_fips_all: 56013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82513,
    lat: 43.59737,
    lng: -109.61913,
    city: "Dubois",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1549,
    density: 0.4,
    county_fips: 56013,
    county_name: "Fremont",
    county_weights: {
      56013: 100,
    },
    county_names_all: "Fremont",
    county_fips_all: 56013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82514,
    lat: 43.01997,
    lng: -109.01,
    city: "Fort Washakie",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1674,
    density: 4,
    county_fips: 56013,
    county_name: "Fremont",
    county_weights: {
      56013: 100,
    },
    county_names_all: "Fremont",
    county_fips_all: 56013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82515,
    lat: 42.89717,
    lng: -108.56688,
    city: "Hudson",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 446,
    density: 19.6,
    county_fips: 56013,
    county_name: "Fremont",
    county_weights: {
      56013: 100,
    },
    county_names_all: "Fremont",
    county_fips_all: 56013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82516,
    lat: 43.21485,
    lng: -108.83195,
    city: "Kinnear",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 434,
    density: 0.6,
    county_fips: 56013,
    county_name: "Fremont",
    county_weights: {
      56013: 100,
    },
    county_names_all: "Fremont",
    county_fips_all: 56013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82520,
    lat: 42.65919,
    lng: -108.63282,
    city: "Lander",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13250,
    density: 3.4,
    county_fips: 56013,
    county_name: "Fremont",
    county_weights: {
      56013: 100,
    },
    county_names_all: "Fremont",
    county_fips_all: 56013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82523,
    lat: 43.41253,
    lng: -108.85636,
    city: "Pavillion",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1048,
    density: 0.8,
    county_fips: 56013,
    county_name: "Fremont",
    county_weights: {
      56013: 100,
    },
    county_names_all: "Fremont",
    county_fips_all: 56013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82601,
    lat: 43.0655,
    lng: -106.34618,
    city: "Casper",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26854,
    density: 21.7,
    county_fips: 56025,
    county_name: "Natrona",
    county_weights: {
      56025: 100,
    },
    county_names_all: "Natrona",
    county_fips_all: 56025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82604,
    lat: 42.91751,
    lng: -106.7084,
    city: "Casper",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28470,
    density: 10.5,
    county_fips: 56025,
    county_name: "Natrona",
    county_weights: {
      56025: 100,
    },
    county_names_all: "Natrona",
    county_fips_all: 56025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82609,
    lat: 42.77773,
    lng: -106.18937,
    city: "Casper",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18664,
    density: 110.5,
    county_fips: 56025,
    county_name: "Natrona",
    county_weights: {
      56025: 100,
    },
    county_names_all: "Natrona",
    county_fips_all: 56025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82620,
    lat: 42.52434,
    lng: -107.08132,
    city: "Alcova",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 218,
    density: 0.2,
    county_fips: 56025,
    county_name: "Natrona",
    county_weights: {
      56007: 7.66,
      56025: 92.34,
    },
    county_names_all: "Natrona|Carbon",
    county_fips_all: "56025|56007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82630,
    lat: 43.33432,
    lng: -107.25595,
    city: "Arminto",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 56025,
    county_name: "Natrona",
    county_weights: {
      56025: 100,
    },
    county_names_all: "Natrona",
    county_fips_all: 56025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82633,
    lat: 42.99525,
    lng: -105.39874,
    city: "Douglas",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9705,
    density: 1.5,
    county_fips: 56009,
    county_name: "Converse",
    county_weights: {
      56009: 98.96,
      56027: 1.04,
    },
    county_names_all: "Converse|Niobrara",
    county_fips_all: "56009|56027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82635,
    lat: 43.4218,
    lng: -106.21834,
    city: "Edgerton",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 118,
    density: 6.5,
    county_fips: 56025,
    county_name: "Natrona",
    county_weights: {
      56025: 100,
    },
    county_names_all: "Natrona",
    county_fips_all: 56025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82636,
    lat: 42.83473,
    lng: -106.14286,
    city: "Evansville",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3701,
    density: 10.7,
    county_fips: 56025,
    county_name: "Natrona",
    county_weights: {
      56009: 2.4,
      56025: 97.6,
    },
    county_names_all: "Natrona|Converse",
    county_fips_all: "56025|56009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82637,
    lat: 42.76679,
    lng: -105.88228,
    city: "Glenrock",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4143,
    density: 2.5,
    county_fips: 56009,
    county_name: "Converse",
    county_weights: {
      56009: 100,
    },
    county_names_all: "Converse",
    county_fips_all: 56009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82638,
    lat: 43.0667,
    lng: -107.25585,
    city: "Hiland",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 113,
    density: 0.6,
    county_fips: 56025,
    county_name: "Natrona",
    county_weights: {
      56025: 100,
    },
    county_names_all: "Natrona",
    county_fips_all: 56025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82639,
    lat: 43.73555,
    lng: -106.6978,
    city: "Kaycee",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 762,
    density: 0.3,
    county_fips: 56019,
    county_name: "Johnson",
    county_weights: {
      56019: 94.32,
      56025: 5.68,
    },
    county_names_all: "Johnson|Natrona",
    county_fips_all: "56019|56025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82640,
    lat: 43.55214,
    lng: -106.11811,
    city: "Linch",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 208,
    density: 3.1,
    county_fips: 56019,
    county_name: "Johnson",
    county_weights: {
      56005: 0.2,
      56019: 99.8,
    },
    county_names_all: "Johnson|Campbell",
    county_fips_all: "56019|56005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82642,
    lat: 43.2799,
    lng: -107.65797,
    city: "Lysite",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48,
    density: 0.1,
    county_fips: 56013,
    county_name: "Fremont",
    county_weights: {
      56013: 86.66,
      56025: 13.34,
    },
    county_names_all: "Fremont|Natrona",
    county_fips_all: "56013|56025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82643,
    lat: 43.43973,
    lng: -106.27359,
    city: "Midwest",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 250,
    density: 6.7,
    county_fips: 56025,
    county_name: "Natrona",
    county_weights: {
      56025: 100,
    },
    county_names_all: "Natrona",
    county_fips_all: 56025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82644,
    lat: 42.84303,
    lng: -106.37437,
    city: "Mills",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1626,
    density: 772.6,
    county_fips: 56025,
    county_name: "Natrona",
    county_weights: {
      56025: 100,
    },
    county_names_all: "Natrona",
    county_fips_all: 56025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82646,
    lat: 42.96297,
    lng: -106.79617,
    city: "Natrona",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 56025,
    county_name: "Natrona",
    county_weights: {
      56025: 100,
    },
    county_names_all: "Natrona",
    county_fips_all: 56025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82648,
    lat: 43.14749,
    lng: -107.04194,
    city: "Powder River",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 91,
    density: 0.2,
    county_fips: 56025,
    county_name: "Natrona",
    county_weights: {
      56025: 100,
    },
    county_names_all: "Natrona",
    county_fips_all: 56025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82649,
    lat: 43.27229,
    lng: -108.04155,
    city: "Shoshoni",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1074,
    density: 0.7,
    county_fips: 56013,
    county_name: "Fremont",
    county_weights: {
      56013: 100,
    },
    county_names_all: "Fremont",
    county_fips_all: 56013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82701,
    lat: 43.71185,
    lng: -104.4451,
    city: "Newcastle",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5164,
    density: 1.1,
    county_fips: 56045,
    county_name: "Weston",
    county_weights: {
      46033: 4.38,
      46103: 3.5,
      56005: 6.18,
      56027: 9.34,
      56045: 76.6,
    },
    county_names_all: "Weston|Niobrara|Campbell|Custer|Pennington",
    county_fips_all: "56045|56027|56005|46033|46103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82710,
    lat: 44.71488,
    lng: -104.28465,
    city: "Aladdin",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 127,
    density: 0.2,
    county_fips: 56011,
    county_name: "Crook",
    county_weights: {
      56011: 100,
    },
    county_names_all: "Crook",
    county_fips_all: 56011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82711,
    lat: 44.71157,
    lng: -104.48062,
    city: "Alva",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 80,
    density: 0.3,
    county_fips: 56011,
    county_name: "Crook",
    county_weights: {
      56011: 100,
    },
    county_names_all: "Crook",
    county_fips_all: 56011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82712,
    lat: 44.52594,
    lng: -104.12372,
    city: "Beulah",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 337,
    density: 1.7,
    county_fips: 56011,
    county_name: "Crook",
    county_weights: {
      56011: 100,
    },
    county_names_all: "Crook",
    county_fips_all: 56011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82714,
    lat: 44.5519,
    lng: -104.68009,
    city: "Devils Tower",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 66,
    density: 1.1,
    county_fips: 56011,
    county_name: "Crook",
    county_weights: {
      56011: 100,
    },
    county_names_all: "Crook",
    county_fips_all: 56011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82716,
    lat: 44.54033,
    lng: -105.64601,
    city: "Gillette",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17526,
    density: 5.7,
    county_fips: 56005,
    county_name: "Campbell",
    county_weights: {
      56005: 100,
    },
    county_names_all: "Campbell",
    county_fips_all: 56005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82718,
    lat: 43.91777,
    lng: -105.61603,
    city: "Gillette",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25380,
    density: 6.1,
    county_fips: 56005,
    county_name: "Campbell",
    county_weights: {
      56005: 100,
    },
    county_names_all: "Campbell",
    county_fips_all: 56005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82720,
    lat: 44.79324,
    lng: -104.67241,
    city: "Hulett",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 643,
    density: 0.4,
    county_fips: 56011,
    county_name: "Crook",
    county_weights: {
      56011: 100,
    },
    county_names_all: "Crook",
    county_fips_all: 56011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82721,
    lat: 44.46199,
    lng: -104.89808,
    city: "Moorcroft",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3433,
    density: 1.9,
    county_fips: 56011,
    county_name: "Crook",
    county_weights: {
      56011: 100,
    },
    county_names_all: "Crook",
    county_fips_all: 56011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82723,
    lat: 43.98898,
    lng: -104.42397,
    city: "Osage",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 111,
    density: 0.3,
    county_fips: 56045,
    county_name: "Weston",
    county_weights: {
      56045: 100,
    },
    county_names_all: "Weston",
    county_fips_all: 56045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82725,
    lat: 44.87752,
    lng: -105.70974,
    city: "Recluse",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 170,
    density: 0.3,
    county_fips: 56005,
    county_name: "Campbell",
    county_weights: {
      56005: 100,
    },
    county_names_all: "Campbell",
    county_fips_all: 56005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82727,
    lat: 44.33595,
    lng: -105.19426,
    city: "Rozet",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1568,
    density: 1.4,
    county_fips: 56005,
    county_name: "Campbell",
    county_weights: {
      56005: 94.97,
      56011: 5.03,
    },
    county_names_all: "Campbell|Crook",
    county_fips_all: "56005|56011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82729,
    lat: 44.36384,
    lng: -104.38734,
    city: "Sundance",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2734,
    density: 2,
    county_fips: 56011,
    county_name: "Crook",
    county_weights: {
      56011: 93.81,
      56045: 6.19,
    },
    county_names_all: "Crook|Weston",
    county_fips_all: "56011|56045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82730,
    lat: 44.04378,
    lng: -104.70031,
    city: "Upton",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1846,
    density: 1.2,
    county_fips: 56045,
    county_name: "Weston",
    county_weights: {
      56011: 10.08,
      56045: 89.92,
    },
    county_names_all: "Weston|Crook",
    county_fips_all: "56045|56011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82731,
    lat: 44.80203,
    lng: -105.23982,
    city: "Weston",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 175,
    density: 0.2,
    county_fips: 56005,
    county_name: "Campbell",
    county_weights: {
      56005: 100,
    },
    county_names_all: "Campbell",
    county_fips_all: 56005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82732,
    lat: 43.725,
    lng: -105.57871,
    city: "Wright",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1947,
    density: 9.8,
    county_fips: 56005,
    county_name: "Campbell",
    county_weights: {
      56005: 100,
    },
    county_names_all: "Campbell",
    county_fips_all: 56005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82801,
    lat: 44.83618,
    lng: -106.89258,
    city: "Sheridan",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25124,
    density: 18.4,
    county_fips: 56033,
    county_name: "Sheridan",
    county_weights: {
      30003: 2.56,
      56033: 97.44,
    },
    county_names_all: "Sheridan|Big Horn",
    county_fips_all: "56033|30003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82831,
    lat: 44.66424,
    lng: -106.0669,
    city: "Arvada",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 427,
    density: 0.3,
    county_fips: 56005,
    county_name: "Campbell",
    county_weights: {
      56005: 34.46,
      56019: 31.95,
      56033: 33.59,
    },
    county_names_all: "Campbell|Sheridan|Johnson",
    county_fips_all: "56005|56033|56019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82832,
    lat: 44.59442,
    lng: -106.75233,
    city: "Banner",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 970,
    density: 2.8,
    county_fips: 56033,
    county_name: "Sheridan",
    county_weights: {
      56019: 20.6,
      56033: 79.4,
    },
    county_names_all: "Sheridan|Johnson",
    county_fips_all: "56033|56019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82833,
    lat: 44.61601,
    lng: -107.12966,
    city: "Big Horn",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 112,
    density: 0.4,
    county_fips: 56033,
    county_name: "Sheridan",
    county_weights: {
      56033: 100,
    },
    county_names_all: "Sheridan",
    county_fips_all: 56033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82834,
    lat: 44.25386,
    lng: -106.74481,
    city: "Buffalo",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7344,
    density: 1.7,
    county_fips: 56019,
    county_name: "Johnson",
    county_weights: {
      56019: 100,
    },
    county_names_all: "Johnson",
    county_fips_all: 56019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82835,
    lat: 44.75856,
    lng: -106.36918,
    city: "Clearmont",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 410,
    density: 0.3,
    county_fips: 56033,
    county_name: "Sheridan",
    county_weights: {
      56033: 100,
    },
    county_names_all: "Sheridan",
    county_fips_all: 56033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82836,
    lat: 44.83701,
    lng: -107.57589,
    city: "Dayton",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1073,
    density: 1.1,
    county_fips: 56033,
    county_name: "Sheridan",
    county_weights: {
      56033: 100,
    },
    county_names_all: "Sheridan",
    county_fips_all: 56033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82837,
    lat: 44.72549,
    lng: -106.28169,
    city: "Leiter",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33,
    density: 0.9,
    county_fips: 56033,
    county_name: "Sheridan",
    county_weights: {
      56033: 100,
    },
    county_names_all: "Sheridan",
    county_fips_all: 56033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82838,
    lat: 44.93793,
    lng: -107.4839,
    city: "Parkman",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 526,
    density: 1.4,
    county_fips: 56033,
    county_name: "Sheridan",
    county_weights: {
      56033: 100,
    },
    county_names_all: "Sheridan",
    county_fips_all: 56033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82839,
    lat: 44.92887,
    lng: -107.15762,
    city: "Ranchester",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1293,
    density: 4.5,
    county_fips: 56033,
    county_name: "Sheridan",
    county_weights: {
      56033: 100,
    },
    county_names_all: "Sheridan",
    county_fips_all: 56033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82842,
    lat: 44.57143,
    lng: -106.93956,
    city: "Story",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 805,
    density: 34.5,
    county_fips: 56033,
    county_name: "Sheridan",
    county_weights: {
      56033: 100,
    },
    county_names_all: "Sheridan",
    county_fips_all: 56033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82844,
    lat: 44.80405,
    lng: -107.19965,
    city: "Wolf",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20,
    density: 0.3,
    county_fips: 56033,
    county_name: "Sheridan",
    county_weights: {
      56033: 100,
    },
    county_names_all: "Sheridan",
    county_fips_all: 56033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82845,
    lat: 44.76416,
    lng: -106.70382,
    city: "Wyarno",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 56033,
    county_name: "Sheridan",
    county_weights: {
      56033: 100,
    },
    county_names_all: "Sheridan",
    county_fips_all: 56033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82901,
    lat: 41.38121,
    lng: -109.02469,
    city: "Rock Springs",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28794,
    density: 10.3,
    county_fips: 56037,
    county_name: "Sweetwater",
    county_weights: {
      56037: 100,
    },
    county_names_all: "Sweetwater",
    county_fips_all: 56037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82922,
    lat: 43.13507,
    lng: -110.43426,
    city: "Bondurant",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 302,
    density: 0.4,
    county_fips: 56035,
    county_name: "Sublette",
    county_weights: {
      56035: 100,
    },
    county_names_all: "Sublette",
    county_fips_all: 56035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82923,
    lat: 42.61609,
    lng: -109.40099,
    city: "Boulder",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 671,
    density: 0.3,
    county_fips: 56035,
    county_name: "Sublette",
    county_weights: {
      56035: 100,
    },
    county_names_all: "Sublette",
    county_fips_all: 56035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82925,
    lat: 43.23123,
    lng: -109.89386,
    city: "Cora",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 438,
    density: 0.2,
    county_fips: 56035,
    county_name: "Sublette",
    county_weights: {
      56035: 94.89,
      56039: 5.11,
    },
    county_names_all: "Sublette|Teton",
    county_fips_all: "56035|56039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82929,
    lat: 41.54765,
    lng: -109.87134,
    city: "Little America",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74,
    density: 9.1,
    county_fips: 56037,
    county_name: "Sweetwater",
    county_weights: {
      56037: 100,
    },
    county_names_all: "Sweetwater",
    county_fips_all: 56037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82930,
    lat: 40.98028,
    lng: -110.5964,
    city: "Evanston",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14872,
    density: 6,
    county_fips: 49043,
    county_name: "Summit",
    county_weights: {
      49043: 70.29,
      56041: 29.71,
    },
    county_names_all: "Summit|Uinta",
    county_fips_all: "49043|56041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82932,
    lat: 42.1219,
    lng: -109.38993,
    city: "Farson",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 343,
    density: 0.8,
    county_fips: 56037,
    county_name: "Sweetwater",
    county_weights: {
      56037: 100,
    },
    county_names_all: "Sweetwater",
    county_fips_all: 56037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82933,
    lat: 41.2686,
    lng: -110.45446,
    city: "Fort Bridger",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 428,
    density: 2.1,
    county_fips: 56041,
    county_name: "Uinta",
    county_weights: {
      56041: 100,
    },
    county_names_all: "Uinta",
    county_fips_all: 56041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82934,
    lat: 41.61247,
    lng: -109.99564,
    city: "Granger",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 142,
    density: 7.7,
    county_fips: 56037,
    county_name: "Sweetwater",
    county_weights: {
      56037: 100,
    },
    county_names_all: "Sweetwater",
    county_fips_all: 56037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82935,
    lat: 41.67746,
    lng: -109.66001,
    city: "Green River",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12703,
    density: 36.5,
    county_fips: 56037,
    county_name: "Sweetwater",
    county_weights: {
      56037: 100,
    },
    county_names_all: "Sweetwater",
    county_fips_all: 56037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82936,
    lat: 41.05725,
    lng: -110.18239,
    city: "Lonetree",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10,
    density: 0,
    county_fips: 56041,
    county_name: "Uinta",
    county_weights: {
      56041: 100,
    },
    county_names_all: "Uinta",
    county_fips_all: 56041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82937,
    lat: 41.3491,
    lng: -110.2634,
    city: "Lyman",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3198,
    density: 13.9,
    county_fips: 56041,
    county_name: "Uinta",
    county_weights: {
      56041: 100,
    },
    county_names_all: "Uinta",
    county_fips_all: 56041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82938,
    lat: 41.09622,
    lng: -109.73764,
    city: "McKinnon",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 380,
    density: 1,
    county_fips: 56037,
    county_name: "Sweetwater",
    county_weights: {
      56037: 100,
    },
    county_names_all: "Sweetwater",
    county_fips_all: 56037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82939,
    lat: 41.22068,
    lng: -110.32357,
    city: "Mountain View",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1342,
    density: 6.6,
    county_fips: 56041,
    county_name: "Uinta",
    county_weights: {
      56041: 100,
    },
    county_names_all: "Uinta",
    county_fips_all: 56041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82941,
    lat: 42.99919,
    lng: -109.90869,
    city: "Pinedale",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4981,
    density: 2.9,
    county_fips: 56035,
    county_name: "Sublette",
    county_weights: {
      56035: 100,
    },
    county_names_all: "Sublette",
    county_fips_all: 56035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82942,
    lat: 41.70234,
    lng: -108.77539,
    city: "Point Of Rocks",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58,
    density: 2.3,
    county_fips: 56037,
    county_name: "Sweetwater",
    county_weights: {
      56037: 100,
    },
    county_names_all: "Sweetwater",
    county_fips_all: 56037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82943,
    lat: 41.70197,
    lng: -109.18399,
    city: "Reliance",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 166,
    density: 1.6,
    county_fips: 56037,
    county_name: "Sweetwater",
    county_weights: {
      56037: 100,
    },
    county_names_all: "Sweetwater",
    county_fips_all: 56037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82944,
    lat: 41.12199,
    lng: -110.49746,
    city: "Robertson",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 627,
    density: 2,
    county_fips: 56041,
    county_name: "Uinta",
    county_weights: {
      56041: 100,
    },
    county_names_all: "Uinta",
    county_fips_all: 56041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 82945,
    lat: 41.72007,
    lng: -108.9389,
    city: "Superior",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 194,
    density: 1.1,
    county_fips: 56037,
    county_name: "Sweetwater",
    county_weights: {
      56037: 100,
    },
    county_names_all: "Sweetwater",
    county_fips_all: 56037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 83001,
    lat: 43.4094,
    lng: -110.60884,
    city: "Jackson",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17867,
    density: 14.3,
    county_fips: 56039,
    county_name: "Teton",
    county_weights: {
      56039: 100,
    },
    county_names_all: "Teton",
    county_fips_all: 56039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 83011,
    lat: 43.58837,
    lng: -110.43192,
    city: "Kelly",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 194,
    density: 0.2,
    county_fips: 56039,
    county_name: "Teton",
    county_weights: {
      56039: 100,
    },
    county_names_all: "Teton",
    county_fips_all: 56039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 83012,
    lat: 43.7073,
    lng: -110.75036,
    city: "Moose",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31,
    density: 0.1,
    county_fips: 56039,
    county_name: "Teton",
    county_weights: {
      56039: 100,
    },
    county_names_all: "Teton",
    county_fips_all: 56039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 83013,
    lat: 43.95666,
    lng: -110.45191,
    city: "Moran",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 187,
    density: 0.1,
    county_fips: 56039,
    county_name: "Teton",
    county_weights: {
      56039: 100,
    },
    county_names_all: "Teton",
    county_fips_all: 56039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 83014,
    lat: 43.458,
    lng: -110.93746,
    city: "Wilson",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2885,
    density: 5.2,
    county_fips: 56039,
    county_name: "Teton",
    county_weights: {
      56039: 100,
    },
    county_names_all: "Teton",
    county_fips_all: 56039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 83025,
    lat: 43.59371,
    lng: -110.82814,
    city: "Teton Village",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 946,
    density: 26.3,
    county_fips: 56039,
    county_name: "Teton",
    county_weights: {
      56039: 100,
    },
    county_names_all: "Teton",
    county_fips_all: 56039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 83101,
    lat: 41.97455,
    lng: -110.5468,
    city: "Kemmerer",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3043,
    density: 2.2,
    county_fips: 56023,
    county_name: "Lincoln",
    county_weights: {
      56023: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 56023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 83110,
    lat: 42.72421,
    lng: -110.90108,
    city: "Afton",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5325,
    density: 13.6,
    county_fips: 56023,
    county_name: "Lincoln",
    county_weights: {
      56023: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 56023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 83111,
    lat: 42.819,
    lng: -111.01143,
    city: "Auburn",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 807,
    density: 20.7,
    county_fips: 56023,
    county_name: "Lincoln",
    county_weights: {
      56023: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 56023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 83112,
    lat: 42.88191,
    lng: -110.8833,
    city: "Bedford",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 642,
    density: 4.3,
    county_fips: 56023,
    county_name: "Lincoln",
    county_weights: {
      56023: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 56023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 83113,
    lat: 42.55189,
    lng: -110.25204,
    city: "Big Piney",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2556,
    density: 1,
    county_fips: 56035,
    county_name: "Sublette",
    county_weights: {
      56035: 100,
    },
    county_names_all: "Sublette",
    county_fips_all: 56035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 83114,
    lat: 42.09736,
    lng: -110.956,
    city: "Cokeville",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 796,
    density: 0.9,
    county_fips: 56023,
    county_name: "Lincoln",
    county_weights: {
      56023: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 56023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 83115,
    lat: 42.92003,
    lng: -110.24036,
    city: "Daniel",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 917,
    density: 1,
    county_fips: 56035,
    county_name: "Sublette",
    county_weights: {
      56035: 100,
    },
    county_names_all: "Sublette",
    county_fips_all: 56035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 83116,
    lat: 41.76333,
    lng: -110.54415,
    city: "Diamondville",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 723,
    density: 97.1,
    county_fips: 56023,
    county_name: "Lincoln",
    county_weights: {
      56023: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 56023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 83118,
    lat: 43.06638,
    lng: -110.9246,
    city: "Etna",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 622,
    density: 2.6,
    county_fips: 56023,
    county_name: "Lincoln",
    county_weights: {
      56023: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 56023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 83119,
    lat: 42.64394,
    lng: -110.98828,
    city: "Fairview",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 188,
    density: 5.5,
    county_fips: 56023,
    county_name: "Lincoln",
    county_weights: {
      56023: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 56023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 83120,
    lat: 43.06595,
    lng: -111.13529,
    city: "Freedom",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 356,
    density: 1,
    county_fips: 16019,
    county_name: "Bonneville",
    county_weights: {
      16019: 71.13,
      16029: 18.82,
      56023: 10.05,
    },
    county_names_all: "Bonneville|Caribou|Lincoln",
    county_fips_all: "16019|16029|56023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83121,
    lat: 41.84982,
    lng: -110.54023,
    city: "Frontier",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 56023,
    county_name: "Lincoln",
    county_weights: {
      56023: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 56023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 83122,
    lat: 42.82175,
    lng: -110.95843,
    city: "Grover",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 875,
    density: 45.5,
    county_fips: 56023,
    county_name: "Lincoln",
    county_weights: {
      56023: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 56023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 83123,
    lat: 42.23985,
    lng: -110.25947,
    city: "La Barge",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 699,
    density: 5.9,
    county_fips: 56023,
    county_name: "Lincoln",
    county_weights: {
      56023: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 56023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 83124,
    lat: 41.75002,
    lng: -110.20865,
    city: "Opal",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 142,
    density: 1.7,
    county_fips: 56023,
    county_name: "Lincoln",
    county_weights: {
      56023: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 56023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 83126,
    lat: 42.58697,
    lng: -110.90916,
    city: "Smoot",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 417,
    density: 14,
    county_fips: 56023,
    county_name: "Lincoln",
    county_weights: {
      56023: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 56023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 83127,
    lat: 42.91815,
    lng: -110.99756,
    city: "Thayne",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4060,
    density: 6.8,
    county_fips: 56023,
    county_name: "Lincoln",
    county_weights: {
      16029: 47.79,
      56023: 52.21,
    },
    county_names_all: "Lincoln|Caribou",
    county_fips_all: "56023|16029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 83128,
    lat: 43.14762,
    lng: -110.7918,
    city: "Alpine",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1081,
    density: 1.1,
    county_fips: 56023,
    county_name: "Lincoln",
    county_weights: {
      56023: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 56023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 83201,
    lat: 42.88949,
    lng: -112.38324,
    city: "Pocatello",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36546,
    density: 412.5,
    county_fips: 16005,
    county_name: "Bannock",
    county_weights: {
      16005: 100,
    },
    county_names_all: "Bannock",
    county_fips_all: 16005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83202,
    lat: 42.97057,
    lng: -112.34734,
    city: "Pocatello",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22413,
    density: 51.9,
    county_fips: 16005,
    county_name: "Bannock",
    county_weights: {
      16005: 90.38,
      16011: 9.62,
    },
    county_names_all: "Bannock|Bingham",
    county_fips_all: "16005|16011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83203,
    lat: 43.0252,
    lng: -112.42813,
    city: "Fort Hall",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 16011,
    county_name: "Bingham",
    county_weights: {
      16011: 100,
    },
    county_names_all: "Bingham",
    county_fips_all: 16011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83204,
    lat: 42.79219,
    lng: -112.51877,
    city: "Pocatello",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20699,
    density: 28.5,
    county_fips: 16077,
    county_name: "Power",
    county_weights: {
      16005: 40.76,
      16077: 59.24,
    },
    county_names_all: "Power|Bannock",
    county_fips_all: "16077|16005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83209,
    lat: 42.85782,
    lng: -112.42619,
    city: "Pocatello",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1237,
    density: 713,
    county_fips: 16005,
    county_name: "Bannock",
    county_weights: {
      16005: 100,
    },
    county_names_all: "Bannock",
    county_fips_all: 16005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83210,
    lat: 43.02069,
    lng: -112.86048,
    city: "Aberdeen",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3874,
    density: 5.6,
    county_fips: 16011,
    county_name: "Bingham",
    county_weights: {
      16011: 100,
    },
    county_names_all: "Bingham",
    county_fips_all: 16011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83211,
    lat: 42.66257,
    lng: -113.06186,
    city: "American Falls",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5766,
    density: 3,
    county_fips: 16077,
    county_name: "Power",
    county_weights: {
      16011: 0.26,
      16031: 34.41,
      16077: 65.33,
    },
    county_names_all: "Power|Cassia|Bingham",
    county_fips_all: "16077|16031|16011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83212,
    lat: 42.50847,
    lng: -112.54828,
    city: "Arbon",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 423,
    density: 0.7,
    county_fips: 16077,
    county_name: "Power",
    county_weights: {
      16071: 13.99,
      16077: 86.01,
    },
    county_names_all: "Power|Oneida",
    county_fips_all: "16077|16071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83213,
    lat: 43.55171,
    lng: -113.35809,
    city: "Arco",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1312,
    density: 0.7,
    county_fips: 16023,
    county_name: "Butte",
    county_weights: {
      16023: 100,
    },
    county_names_all: "Butte",
    county_fips_all: 16023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83214,
    lat: 42.54495,
    lng: -112.29362,
    city: "Arimo",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 660,
    density: 2.3,
    county_fips: 16005,
    county_name: "Bannock",
    county_weights: {
      16005: 100,
    },
    county_names_all: "Bannock",
    county_fips_all: 16005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83215,
    lat: 43.44314,
    lng: -112.81239,
    city: "Atomic City",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46,
    density: 223.7,
    county_fips: 16011,
    county_name: "Bingham",
    county_weights: {
      16011: 100,
    },
    county_names_all: "Bingham",
    county_fips_all: 16011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83217,
    lat: 42.77525,
    lng: -111.93559,
    city: "Bancroft",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 895,
    density: 1.2,
    county_fips: 16029,
    county_name: "Caribou",
    county_weights: {
      16029: 100,
    },
    county_names_all: "Caribou",
    county_fips_all: 16029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83218,
    lat: 43.31803,
    lng: -112.16453,
    city: "Basalt",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 358,
    density: 305.9,
    county_fips: 16011,
    county_name: "Bingham",
    county_weights: {
      16011: 100,
    },
    county_names_all: "Bingham",
    county_fips_all: 16011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83220,
    lat: 42.34465,
    lng: -111.38008,
    city: "Bern",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 98,
    density: 3.2,
    county_fips: 16007,
    county_name: "Bear Lake",
    county_weights: {
      16007: 100,
    },
    county_names_all: "Bear Lake",
    county_fips_all: 16007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83221,
    lat: 43.30874,
    lng: -112.53217,
    city: "Blackfoot",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27651,
    density: 14.7,
    county_fips: 16011,
    county_name: "Bingham",
    county_weights: {
      16011: 100,
    },
    county_names_all: "Bingham",
    county_fips_all: 16011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83223,
    lat: 42.18249,
    lng: -111.40327,
    city: "Bloomington",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 144,
    density: 17.9,
    county_fips: 16007,
    county_name: "Bear Lake",
    county_weights: {
      16007: 100,
    },
    county_names_all: "Bear Lake",
    county_fips_all: 16007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83226,
    lat: 44.40775,
    lng: -114.06951,
    city: "Challis",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1858,
    density: 0.4,
    county_fips: 16037,
    county_name: "Custer",
    county_weights: {
      16037: 87.32,
      16059: 12.68,
    },
    county_names_all: "Custer|Lemhi",
    county_fips_all: "16037|16059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83227,
    lat: 44.16563,
    lng: -114.49424,
    city: "Clayton",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17,
    density: 0,
    county_fips: 16037,
    county_name: "Custer",
    county_weights: {
      16037: 100,
    },
    county_names_all: "Custer",
    county_fips_all: 16037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83228,
    lat: 42.19496,
    lng: -112.03658,
    city: "Clifton",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 929,
    density: 5.2,
    county_fips: 16041,
    county_name: "Franklin",
    county_weights: {
      16041: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 16041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83232,
    lat: 42.13341,
    lng: -111.97245,
    city: "Dayton",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 575,
    density: 26.9,
    county_fips: 16041,
    county_name: "Franklin",
    county_weights: {
      16041: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 16041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83233,
    lat: 42.15664,
    lng: -111.25256,
    city: "Dingle",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 277,
    density: 3.5,
    county_fips: 16007,
    county_name: "Bear Lake",
    county_weights: {
      16007: 100,
    },
    county_names_all: "Bear Lake",
    county_fips_all: 16007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83234,
    lat: 42.41661,
    lng: -112.09482,
    city: "Downey",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1443,
    density: 2.1,
    county_fips: 16005,
    county_name: "Bannock",
    county_weights: {
      16005: 100,
    },
    county_names_all: "Bannock",
    county_fips_all: 16005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83235,
    lat: 44.60163,
    lng: -114.03404,
    city: "Ellis",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 333,
    density: 2.3,
    county_fips: 16037,
    county_name: "Custer",
    county_weights: {
      16037: 93.74,
      16059: 6.26,
    },
    county_names_all: "Custer|Lemhi",
    county_fips_all: "16037|16059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83236,
    lat: 43.22819,
    lng: -111.94894,
    city: "Firth",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2398,
    density: 4.3,
    county_fips: 16011,
    county_name: "Bingham",
    county_weights: {
      16011: 100,
    },
    county_names_all: "Bingham",
    county_fips_all: 16011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83237,
    lat: 42.02737,
    lng: -111.77626,
    city: "Franklin",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 846,
    density: 14.1,
    county_fips: 16041,
    county_name: "Franklin",
    county_weights: {
      16041: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 16041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83238,
    lat: 42.37942,
    lng: -111.10593,
    city: "Geneva",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58,
    density: 0.2,
    county_fips: 16007,
    county_name: "Bear Lake",
    county_weights: {
      16007: 100,
    },
    county_names_all: "Bear Lake",
    county_fips_all: 16007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83239,
    lat: 42.53167,
    lng: -111.36528,
    city: "Georgetown",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 642,
    density: 3.5,
    county_fips: 16007,
    county_name: "Bear Lake",
    county_weights: {
      16007: 100,
    },
    county_names_all: "Bear Lake",
    county_fips_all: 16007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83241,
    lat: 42.51527,
    lng: -111.76214,
    city: "Grace",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2402,
    density: 4.7,
    county_fips: 16029,
    county_name: "Caribou",
    county_weights: {
      16029: 99.9,
      16041: 0.1,
    },
    county_names_all: "Caribou|Franklin",
    county_fips_all: "16029|16041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83243,
    lat: 42.24444,
    lng: -112.67292,
    city: "Holbrook",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 16071,
    county_name: "Oneida",
    county_weights: {
      16071: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 16071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83244,
    lat: 43.94076,
    lng: -113.11287,
    city: "Howe",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 392,
    density: 0.2,
    county_fips: 16023,
    county_name: "Butte",
    county_weights: {
      16023: 100,
    },
    county_names_all: "Butte",
    county_fips_all: 16023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83245,
    lat: 42.82286,
    lng: -112.21713,
    city: "Inkom",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2369,
    density: 9.3,
    county_fips: 16005,
    county_name: "Bannock",
    county_weights: {
      16005: 100,
    },
    county_names_all: "Bannock",
    county_fips_all: 16005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83246,
    lat: 42.60616,
    lng: -112.03051,
    city: "Lava Hot Springs",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1149,
    density: 3.3,
    county_fips: 16005,
    county_name: "Bannock",
    county_weights: {
      16005: 100,
    },
    county_names_all: "Bannock",
    county_fips_all: 16005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83250,
    lat: 42.67228,
    lng: -112.20865,
    city: "Mccammon",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2046,
    density: 9.3,
    county_fips: 16005,
    county_name: "Bannock",
    county_weights: {
      16005: 100,
    },
    county_names_all: "Bannock",
    county_fips_all: 16005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83251,
    lat: 43.90738,
    lng: -113.86425,
    city: "Mackay",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1264,
    density: 0.4,
    county_fips: 16037,
    county_name: "Custer",
    county_weights: {
      16037: 100,
    },
    county_names_all: "Custer",
    county_fips_all: 16037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83252,
    lat: 42.18979,
    lng: -112.38411,
    city: "Malad City",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4429,
    density: 2.3,
    county_fips: 16071,
    county_name: "Oneida",
    county_weights: {
      16071: 100,
    },
    county_names_all: "Oneida",
    county_fips_all: 16071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83253,
    lat: 44.54647,
    lng: -113.77167,
    city: "May",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59,
    density: 0.1,
    county_fips: 16059,
    county_name: "Lemhi",
    county_weights: {
      16037: 28.06,
      16059: 71.94,
    },
    county_names_all: "Lemhi|Custer",
    county_fips_all: "16059|16037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83254,
    lat: 42.36403,
    lng: -111.2655,
    city: "Montpelier",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3551,
    density: 2.5,
    county_fips: 16007,
    county_name: "Bear Lake",
    county_weights: {
      16007: 82.59,
      16029: 17.41,
    },
    county_names_all: "Bear Lake|Caribou",
    county_fips_all: "16007|16029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83255,
    lat: 43.72829,
    lng: -113.45702,
    city: "Moore",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1248,
    density: 2.3,
    county_fips: 16023,
    county_name: "Butte",
    county_weights: {
      16023: 89.68,
      16037: 10.32,
    },
    county_names_all: "Butte|Custer",
    county_fips_all: "16023|16037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83261,
    lat: 42.22112,
    lng: -111.40661,
    city: "Paris",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 682,
    density: 11.1,
    county_fips: 16007,
    county_name: "Bear Lake",
    county_weights: {
      16007: 100,
    },
    county_names_all: "Bear Lake",
    county_fips_all: 16007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83262,
    lat: 43.18419,
    lng: -112.7658,
    city: "Pingree",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 896,
    density: 1.6,
    county_fips: 16011,
    county_name: "Bingham",
    county_weights: {
      16011: 100,
    },
    county_names_all: "Bingham",
    county_fips_all: 16011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83263,
    lat: 42.17757,
    lng: -111.76101,
    city: "Preston",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9844,
    density: 9.2,
    county_fips: 16041,
    county_name: "Franklin",
    county_weights: {
      16041: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 16041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83271,
    lat: 42.4574,
    lng: -112.84551,
    city: "Rockland",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 381,
    density: 0.6,
    county_fips: 16077,
    county_name: "Power",
    county_weights: {
      16077: 100,
    },
    county_names_all: "Power",
    county_fips_all: 16077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83272,
    lat: 42.09156,
    lng: -111.36835,
    city: "Saint Charles",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 277,
    density: 0.8,
    county_fips: 16007,
    county_name: "Bear Lake",
    county_weights: {
      16007: 100,
    },
    county_names_all: "Bear Lake",
    county_fips_all: 16007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83274,
    lat: 43.35049,
    lng: -112.09904,
    city: "Shelley",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9307,
    density: 36.4,
    county_fips: 16011,
    county_name: "Bingham",
    county_weights: {
      16011: 99.54,
      16019: 0.46,
    },
    county_names_all: "Bingham|Bonneville",
    county_fips_all: "16011|16019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83276,
    lat: 42.75942,
    lng: -111.44451,
    city: "Soda Springs",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3699,
    density: 2.1,
    county_fips: 16029,
    county_name: "Caribou",
    county_weights: {
      16007: 4.33,
      16029: 95.67,
    },
    county_names_all: "Caribou|Bear Lake",
    county_fips_all: "16029|16007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83277,
    lat: 43.07429,
    lng: -112.68127,
    city: "Springfield",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 152,
    density: 7,
    county_fips: 16011,
    county_name: "Bingham",
    county_weights: {
      16011: 100,
    },
    county_names_all: "Bingham",
    county_fips_all: 16011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83278,
    lat: 44.36917,
    lng: -114.85619,
    city: "Stanley",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 458,
    density: 0.1,
    county_fips: 16037,
    county_name: "Custer",
    county_weights: {
      16037: 100,
    },
    county_names_all: "Custer",
    county_fips_all: 16037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83281,
    lat: 42.31044,
    lng: -111.95953,
    city: "Swanlake",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 150,
    density: 1.4,
    county_fips: 16005,
    county_name: "Bannock",
    county_weights: {
      16005: 100,
    },
    county_names_all: "Bannock",
    county_fips_all: 16005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83283,
    lat: 42.35709,
    lng: -111.66445,
    city: "Thatcher",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 236,
    density: 1.6,
    county_fips: 16041,
    county_name: "Franklin",
    county_weights: {
      16041: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 16041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83285,
    lat: 43.061,
    lng: -111.37199,
    city: "Wayan",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 132,
    density: 0.2,
    county_fips: 16019,
    county_name: "Bonneville",
    county_weights: {
      16019: 68.44,
      16029: 31.56,
    },
    county_names_all: "Bonneville|Caribou",
    county_fips_all: "16019|16029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83286,
    lat: 42.0533,
    lng: -112.0148,
    city: "Weston",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1306,
    density: 6.9,
    county_fips: 16041,
    county_name: "Franklin",
    county_weights: {
      16041: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 16041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83287,
    lat: 42.03671,
    lng: -111.45894,
    city: "Fish Haven",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 185,
    density: 2.6,
    county_fips: 16007,
    county_name: "Bear Lake",
    county_weights: {
      16007: 100,
    },
    county_names_all: "Bear Lake",
    county_fips_all: 16007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83301,
    lat: 42.39472,
    lng: -114.52203,
    city: "Twin Falls",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58230,
    density: 76,
    county_fips: 16083,
    county_name: "Twin Falls",
    county_weights: {
      16053: 0.74,
      16083: 99.26,
    },
    county_names_all: "Twin Falls|Jerome",
    county_fips_all: "16083|16053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83302,
    lat: 42.10012,
    lng: -114.82857,
    city: "Rogerson",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 243,
    density: 0.3,
    county_fips: 16083,
    county_name: "Twin Falls",
    county_weights: {
      16073: 25.72,
      16083: 74.28,
    },
    county_names_all: "Twin Falls|Owyhee",
    county_fips_all: "16083|16073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83311,
    lat: 42.40396,
    lng: -113.55864,
    city: "Albion",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 870,
    density: 3.6,
    county_fips: 16031,
    county_name: "Cassia",
    county_weights: {
      16031: 100,
    },
    county_names_all: "Cassia",
    county_fips_all: 16031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83312,
    lat: 42.10296,
    lng: -113.6319,
    city: "Almo",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74,
    density: 0.3,
    county_fips: 16031,
    county_name: "Cassia",
    county_weights: {
      16031: 100,
    },
    county_names_all: "Cassia",
    county_fips_all: 16031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83313,
    lat: 43.3586,
    lng: -114.20511,
    city: "Bellevue",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3977,
    density: 6,
    county_fips: 16013,
    county_name: "Blaine",
    county_weights: {
      16013: 100,
    },
    county_names_all: "Blaine",
    county_fips_all: 16013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83314,
    lat: 42.97376,
    lng: -114.95228,
    city: "Bliss",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1006,
    density: 3,
    county_fips: 16047,
    county_name: "Gooding",
    county_weights: {
      16047: 99.13,
      16083: 0.87,
    },
    county_names_all: "Gooding|Twin Falls",
    county_fips_all: "16047|16083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83316,
    lat: 42.60622,
    lng: -114.88507,
    city: "Buhl",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10057,
    density: 13.2,
    county_fips: 16083,
    county_name: "Twin Falls",
    county_weights: {
      16047: 0.75,
      16073: 14.32,
      16083: 84.93,
    },
    county_names_all: "Twin Falls|Owyhee|Gooding",
    county_fips_all: "16083|16073|16047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83318,
    lat: 42.43434,
    lng: -113.82007,
    city: "Burley",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17737,
    density: 26.9,
    county_fips: 16031,
    county_name: "Cassia",
    county_weights: {
      16031: 99.82,
      16067: 0.18,
    },
    county_names_all: "Cassia|Minidoka",
    county_fips_all: "16031|16067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83320,
    lat: 43.40515,
    lng: -113.88309,
    city: "Carey",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1449,
    density: 1.3,
    county_fips: 16013,
    county_name: "Blaine",
    county_weights: {
      16013: 100,
    },
    county_names_all: "Blaine",
    county_fips_all: 16013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83321,
    lat: 42.35955,
    lng: -114.86312,
    city: "Castleford",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 499,
    density: 1.1,
    county_fips: 16083,
    county_name: "Twin Falls",
    county_weights: {
      16083: 100,
    },
    county_names_all: "Twin Falls",
    county_fips_all: 16083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83322,
    lat: 43.31475,
    lng: -114.96811,
    city: "Corral",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17,
    density: 0.1,
    county_fips: 16025,
    county_name: "Camas",
    county_weights: {
      16025: 100,
    },
    county_names_all: "Camas",
    county_fips_all: 16025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83323,
    lat: 42.46902,
    lng: -113.4081,
    city: "Declo",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1697,
    density: 3.2,
    county_fips: 16031,
    county_name: "Cassia",
    county_weights: {
      16031: 100,
    },
    county_names_all: "Cassia",
    county_fips_all: 16031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83324,
    lat: 42.87725,
    lng: -114.2615,
    city: "Dietrich",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 758,
    density: 3.5,
    county_fips: 16063,
    county_name: "Lincoln",
    county_weights: {
      16063: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 16063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83325,
    lat: 42.58675,
    lng: -114.24282,
    city: "Eden",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 760,
    density: 8,
    county_fips: 16053,
    county_name: "Jerome",
    county_weights: {
      16053: 100,
    },
    county_names_all: "Jerome",
    county_fips_all: 16053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83327,
    lat: 43.51145,
    lng: -114.7961,
    city: "Fairfield",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1003,
    density: 0.5,
    county_fips: 16025,
    county_name: "Camas",
    county_weights: {
      16025: 100,
    },
    county_names_all: "Camas",
    county_fips_all: 16025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83328,
    lat: 42.56962,
    lng: -114.61665,
    city: "Filer",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5956,
    density: 34.2,
    county_fips: 16083,
    county_name: "Twin Falls",
    county_weights: {
      16083: 100,
    },
    county_names_all: "Twin Falls",
    county_fips_all: 16083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83330,
    lat: 42.94207,
    lng: -114.69291,
    city: "Gooding",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6421,
    density: 16.7,
    county_fips: 16047,
    county_name: "Gooding",
    county_weights: {
      16047: 99.05,
      16063: 0.95,
    },
    county_names_all: "Gooding|Lincoln",
    county_fips_all: "16047|16063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83332,
    lat: 42.79758,
    lng: -114.92962,
    city: "Hagerman",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2609,
    density: 11.4,
    county_fips: 16083,
    county_name: "Twin Falls",
    county_weights: {
      16047: 39.84,
      16083: 60.16,
    },
    county_names_all: "Twin Falls|Gooding",
    county_fips_all: "16083|16047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83333,
    lat: 43.57589,
    lng: -114.2214,
    city: "Hailey",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10561,
    density: 7.8,
    county_fips: 16013,
    county_name: "Blaine",
    county_weights: {
      16013: 100,
    },
    county_names_all: "Blaine",
    county_fips_all: 16013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83334,
    lat: 42.4243,
    lng: -114.29126,
    city: "Hansen",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2304,
    density: 10.1,
    county_fips: 16083,
    county_name: "Twin Falls",
    county_weights: {
      16083: 100,
    },
    county_names_all: "Twin Falls",
    county_fips_all: 16083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83335,
    lat: 42.58726,
    lng: -114.07347,
    city: "Hazelton",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1687,
    density: 5.7,
    county_fips: 16053,
    county_name: "Jerome",
    county_weights: {
      16053: 99.3,
      16067: 0.7,
    },
    county_names_all: "Jerome|Minidoka",
    county_fips_all: "16053|16067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83336,
    lat: 42.5626,
    lng: -113.81699,
    city: "Heyburn",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5700,
    density: 62.5,
    county_fips: 16067,
    county_name: "Minidoka",
    county_weights: {
      16067: 100,
    },
    county_names_all: "Minidoka",
    county_fips_all: 16067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83337,
    lat: 43.21807,
    lng: -115.1575,
    city: "Hill City",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23,
    density: 0,
    county_fips: 16039,
    county_name: "Elmore",
    county_weights: {
      16025: 17.56,
      16039: 82.44,
    },
    county_names_all: "Elmore|Camas",
    county_fips_all: "16039|16025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83338,
    lat: 42.72501,
    lng: -114.43273,
    city: "Jerome",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21733,
    density: 30.4,
    county_fips: 16053,
    county_name: "Jerome",
    county_weights: {
      16047: 3.43,
      16053: 95.36,
      16063: 1.21,
    },
    county_names_all: "Jerome|Gooding|Lincoln",
    county_fips_all: "16053|16047|16063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83340,
    lat: 43.77178,
    lng: -114.58138,
    city: "Ketchum",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4800,
    density: 3.3,
    county_fips: 16013,
    county_name: "Blaine",
    county_weights: {
      16013: 100,
    },
    county_names_all: "Blaine",
    county_fips_all: 16013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83341,
    lat: 42.42875,
    lng: -114.37052,
    city: "Kimberly",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8084,
    density: 36.6,
    county_fips: 16083,
    county_name: "Twin Falls",
    county_weights: {
      16083: 100,
    },
    county_names_all: "Twin Falls",
    county_fips_all: 16083,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83342,
    lat: 42.15014,
    lng: -113.22915,
    city: "Malta",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1252,
    density: 0.4,
    county_fips: 16031,
    county_name: "Cassia",
    county_weights: {
      16031: 65.43,
      16071: 21.35,
      49003: 13.22,
    },
    county_names_all: "Cassia|Oneida|Box Elder",
    county_fips_all: "16031|16071|49003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83344,
    lat: 42.40437,
    lng: -114.11768,
    city: "Murtaugh",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1159,
    density: 2.5,
    county_fips: 16031,
    county_name: "Cassia",
    county_weights: {
      16031: 68.55,
      16083: 31.45,
    },
    county_names_all: "Cassia|Twin Falls",
    county_fips_all: "16031|16083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83346,
    lat: 42.19491,
    lng: -113.9046,
    city: "Oakley",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1981,
    density: 2.5,
    county_fips: 16031,
    county_name: "Cassia",
    county_weights: {
      16031: 100,
    },
    county_names_all: "Cassia",
    county_fips_all: 16031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83347,
    lat: 42.73812,
    lng: -113.87705,
    city: "Paul",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3287,
    density: 5.6,
    county_fips: 16067,
    county_name: "Minidoka",
    county_weights: {
      16053: 17.87,
      16063: 37.17,
      16067: 44.96,
    },
    county_names_all: "Minidoka|Lincoln|Jerome",
    county_fips_all: "16067|16063|16053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83348,
    lat: 43.28489,
    lng: -114.10592,
    city: "Picabo",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 357,
    density: 5.1,
    county_fips: 16013,
    county_name: "Blaine",
    county_weights: {
      16013: 100,
    },
    county_names_all: "Blaine",
    county_fips_all: 16013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83349,
    lat: 43.10148,
    lng: -114.17784,
    city: "Richfield",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1203,
    density: 5.4,
    county_fips: 16063,
    county_name: "Lincoln",
    county_weights: {
      16063: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 16063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83350,
    lat: 42.70996,
    lng: -113.59812,
    city: "Rupert",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12223,
    density: 17.9,
    county_fips: 16067,
    county_name: "Minidoka",
    county_weights: {
      16013: 10.93,
      16031: 7.17,
      16067: 81.9,
    },
    county_names_all: "Minidoka|Blaine|Cassia",
    county_fips_all: "16067|16013|16031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83352,
    lat: 43.05133,
    lng: -114.40584,
    city: "Shoshone",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3366,
    density: 6,
    county_fips: 16063,
    county_name: "Lincoln",
    county_weights: {
      16013: 2.05,
      16025: 10.91,
      16063: 87.04,
    },
    county_names_all: "Lincoln|Camas|Blaine",
    county_fips_all: "16063|16025|16013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83353,
    lat: 43.68625,
    lng: -114.33354,
    city: "Sun Valley",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1508,
    density: 65.4,
    county_fips: 16013,
    county_name: "Blaine",
    county_weights: {
      16013: 100,
    },
    county_names_all: "Blaine",
    county_fips_all: 16013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83354,
    lat: 43.67012,
    lng: -114.32235,
    city: "Sun Valley",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13,
    density: 254.6,
    county_fips: 16013,
    county_name: "Blaine",
    county_weights: {
      16013: 100,
    },
    county_names_all: "Blaine",
    county_fips_all: 16013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83355,
    lat: 42.75515,
    lng: -114.72676,
    city: "Wendell",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5002,
    density: 16.6,
    county_fips: 16047,
    county_name: "Gooding",
    county_weights: {
      16047: 100,
    },
    county_names_all: "Gooding",
    county_fips_all: 16047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83401,
    lat: 43.53222,
    lng: -111.86516,
    city: "Idaho Falls",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43921,
    density: 85.9,
    county_fips: 16019,
    county_name: "Bonneville",
    county_weights: {
      16019: 99.79,
      16051: 0.21,
    },
    county_names_all: "Bonneville|Jefferson",
    county_fips_all: "16019|16051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83402,
    lat: 43.53011,
    lng: -112.16786,
    city: "Idaho Falls",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25947,
    density: 58.6,
    county_fips: 16019,
    county_name: "Bonneville",
    county_weights: {
      16011: 0.37,
      16019: 97.02,
      16051: 2.61,
    },
    county_names_all: "Bonneville|Jefferson|Bingham",
    county_fips_all: "16019|16051|16011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83404,
    lat: 43.42818,
    lng: -112.01432,
    city: "Idaho Falls",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24452,
    density: 377.9,
    county_fips: 16019,
    county_name: "Bonneville",
    county_weights: {
      16019: 100,
    },
    county_names_all: "Bonneville",
    county_fips_all: 16019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83406,
    lat: 43.43768,
    lng: -111.93382,
    city: "Idaho Falls",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19204,
    density: 231.5,
    county_fips: 16019,
    county_name: "Bonneville",
    county_weights: {
      16019: 100,
    },
    county_names_all: "Bonneville",
    county_fips_all: 16019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83414,
    lat: 43.88847,
    lng: -110.94924,
    city: "Alta",
    state_id: "WY",
    state_name: "Wyoming",
    zcta: "TRUE",
    parent_zcta: "",
    population: 367,
    density: 0.4,
    county_fips: 56039,
    county_name: "Teton",
    county_weights: {
      56039: 100,
    },
    county_names_all: "Teton",
    county_fips_all: 56039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 83420,
    lat: 44.06001,
    lng: -111.32243,
    city: "Ashton",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2435,
    density: 2.3,
    county_fips: 16043,
    county_name: "Fremont",
    county_weights: {
      16043: 100,
    },
    county_names_all: "Fremont",
    county_fips_all: 16043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83421,
    lat: 44.00349,
    lng: -111.54057,
    city: "Chester",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 293,
    density: 9.7,
    county_fips: 16043,
    county_name: "Fremont",
    county_weights: {
      16043: 100,
    },
    county_names_all: "Fremont",
    county_fips_all: 16043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83422,
    lat: 43.70463,
    lng: -111.23914,
    city: "Driggs",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4121,
    density: 12.7,
    county_fips: 16081,
    county_name: "Teton",
    county_weights: {
      16081: 100,
    },
    county_names_all: "Teton",
    county_fips_all: 16081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83423,
    lat: 44.33967,
    lng: -112.33199,
    city: "Dubois",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 810,
    density: 0.6,
    county_fips: 16033,
    county_name: "Clark",
    county_weights: {
      16033: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 16033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83424,
    lat: 43.90488,
    lng: -111.19136,
    city: "Felt",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 157,
    density: 1.5,
    county_fips: 16081,
    county_name: "Teton",
    county_weights: {
      16081: 100,
    },
    county_names_all: "Teton",
    county_fips_all: 16081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83425,
    lat: 43.93106,
    lng: -112.21677,
    city: "Hamer",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 697,
    density: 2.2,
    county_fips: 16051,
    county_name: "Jefferson",
    county_weights: {
      16043: 6.58,
      16051: 93.42,
    },
    county_names_all: "Jefferson|Fremont",
    county_fips_all: "16051|16043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83427,
    lat: 43.35936,
    lng: -111.75064,
    city: "Iona",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 16019,
    county_name: "Bonneville",
    county_weights: {
      16019: 100,
    },
    county_names_all: "Bonneville",
    county_fips_all: 16019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83428,
    lat: 43.3833,
    lng: -111.16093,
    city: "Irwin",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 625,
    density: 1,
    county_fips: 16019,
    county_name: "Bonneville",
    county_weights: {
      16019: 100,
    },
    county_names_all: "Bonneville",
    county_fips_all: 16019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83429,
    lat: 44.48674,
    lng: -111.37366,
    city: "Island Park",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 721,
    density: 0.6,
    county_fips: 16043,
    county_name: "Fremont",
    county_weights: {
      16043: 100,
    },
    county_names_all: "Fremont",
    county_fips_all: 16043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83431,
    lat: 43.68808,
    lng: -112.03012,
    city: "Lewisville",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 859,
    density: 26.5,
    county_fips: 16051,
    county_name: "Jefferson",
    county_weights: {
      16051: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 16051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83433,
    lat: 44.49284,
    lng: -111.31788,
    city: "Macks Inn",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4,
    density: 1,
    county_fips: 16043,
    county_name: "Fremont",
    county_weights: {
      16043: 100,
    },
    county_names_all: "Fremont",
    county_fips_all: 16043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83434,
    lat: 43.75636,
    lng: -112.00758,
    city: "Menan",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1634,
    density: 14.6,
    county_fips: 16051,
    county_name: "Jefferson",
    county_weights: {
      16051: 72.29,
      16065: 27.71,
    },
    county_names_all: "Jefferson|Madison",
    county_fips_all: "16051|16065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83435,
    lat: 43.98469,
    lng: -112.58043,
    city: "Monteview",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 726,
    density: 1.6,
    county_fips: 16051,
    county_name: "Jefferson",
    county_weights: {
      16033: 18.63,
      16051: 81.37,
    },
    county_names_all: "Jefferson|Clark",
    county_fips_all: "16051|16033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83436,
    lat: 43.8588,
    lng: -111.46665,
    city: "Newdale",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 717,
    density: 2.8,
    county_fips: 16065,
    county_name: "Madison",
    county_weights: {
      16043: 6.53,
      16065: 75.94,
      16081: 17.53,
    },
    county_names_all: "Madison|Teton|Fremont",
    county_fips_all: "16065|16081|16043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83438,
    lat: 43.9597,
    lng: -111.75932,
    city: "Parker",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 16043,
    county_name: "Fremont",
    county_weights: {
      16043: 100,
    },
    county_names_all: "Fremont",
    county_fips_all: 16043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83440,
    lat: 43.81092,
    lng: -111.80779,
    city: "Rexburg",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37231,
    density: 79.1,
    county_fips: 16065,
    county_name: "Madison",
    county_weights: {
      16043: 3.87,
      16065: 96.13,
    },
    county_names_all: "Madison|Fremont",
    county_fips_all: "16065|16043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83442,
    lat: 43.62931,
    lng: -111.82507,
    city: "Rigby",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22415,
    density: 66.9,
    county_fips: 16051,
    county_name: "Jefferson",
    county_weights: {
      16019: 28.41,
      16051: 71.59,
    },
    county_names_all: "Jefferson|Bonneville",
    county_fips_all: "16051|16019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83443,
    lat: 43.50942,
    lng: -111.56155,
    city: "Ririe",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1089,
    density: 2.1,
    county_fips: 16019,
    county_name: "Bonneville",
    county_weights: {
      16019: 95.1,
      16051: 3.69,
      16065: 1.21,
    },
    county_names_all: "Bonneville|Jefferson|Madison",
    county_fips_all: "16019|16051|16065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83444,
    lat: 43.69748,
    lng: -112.24406,
    city: "Roberts",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1148,
    density: 2.8,
    county_fips: 16051,
    county_name: "Jefferson",
    county_weights: {
      16019: 0.77,
      16051: 99.23,
    },
    county_names_all: "Jefferson|Bonneville",
    county_fips_all: "16051|16019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83445,
    lat: 44.07014,
    lng: -111.73075,
    city: "Saint Anthony",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7799,
    density: 10,
    county_fips: 16043,
    county_name: "Fremont",
    county_weights: {
      16043: 99.73,
      16065: 0.27,
    },
    county_names_all: "Fremont|Madison",
    county_fips_all: "16043|16065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83446,
    lat: 44.37841,
    lng: -112.21887,
    city: "Spencer",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17,
    density: 0.2,
    county_fips: 16033,
    county_name: "Clark",
    county_weights: {
      16033: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 16033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83448,
    lat: 43.85082,
    lng: -111.70529,
    city: "Sugar City",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2814,
    density: 37.7,
    county_fips: 16065,
    county_name: "Madison",
    county_weights: {
      16043: 1.97,
      16065: 98.03,
    },
    county_names_all: "Madison|Fremont",
    county_fips_all: "16065|16043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83449,
    lat: 43.42487,
    lng: -111.35966,
    city: "Swan Valley",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 168,
    density: 0.3,
    county_fips: 16019,
    county_name: "Bonneville",
    county_weights: {
      16019: 100,
    },
    county_names_all: "Bonneville",
    county_fips_all: 16019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83450,
    lat: 43.8463,
    lng: -112.41356,
    city: "Terreton",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 960,
    density: 2.9,
    county_fips: 16051,
    county_name: "Jefferson",
    county_weights: {
      16051: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 16051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83451,
    lat: 43.86595,
    lng: -111.63489,
    city: "Teton",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 610,
    density: 14.2,
    county_fips: 16065,
    county_name: "Madison",
    county_weights: {
      16043: 33.53,
      16065: 66.47,
    },
    county_names_all: "Madison|Fremont",
    county_fips_all: "16065|16043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83452,
    lat: 43.83619,
    lng: -111.21239,
    city: "Tetonia",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2075,
    density: 4.6,
    county_fips: 16081,
    county_name: "Teton",
    county_weights: {
      16081: 100,
    },
    county_names_all: "Teton",
    county_fips_all: 16081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83454,
    lat: 43.5946,
    lng: -111.95698,
    city: "Ucon",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 558,
    density: 1330.3,
    county_fips: 16019,
    county_name: "Bonneville",
    county_weights: {
      16019: 100,
    },
    county_names_all: "Bonneville",
    county_fips_all: 16019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83455,
    lat: 43.60638,
    lng: -111.14077,
    city: "Victor",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5423,
    density: 22.6,
    county_fips: 16081,
    county_name: "Teton",
    county_weights: {
      16081: 100,
    },
    county_names_all: "Teton",
    county_fips_all: 16081,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83460,
    lat: 43.81639,
    lng: -111.7826,
    city: "Rexburg",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 111,
    density: 149.1,
    county_fips: 16065,
    county_name: "Madison",
    county_weights: {
      16065: 100,
    },
    county_names_all: "Madison",
    county_fips_all: 16065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83462,
    lat: 45.30698,
    lng: -113.81069,
    city: "Carmen",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 583,
    density: 2.1,
    county_fips: 16059,
    county_name: "Lemhi",
    county_weights: {
      16059: 100,
    },
    county_names_all: "Lemhi",
    county_fips_all: 16059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83463,
    lat: 45.5706,
    lng: -113.97716,
    city: "Gibbonsville",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54,
    density: 0.1,
    county_fips: 16059,
    county_name: "Lemhi",
    county_weights: {
      16059: 100,
    },
    county_names_all: "Lemhi",
    county_fips_all: 16059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83464,
    lat: 44.48105,
    lng: -113.20271,
    city: "Leadore",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 291,
    density: 0.1,
    county_fips: 16059,
    county_name: "Lemhi",
    county_weights: {
      16033: 10.5,
      16059: 89.5,
    },
    county_names_all: "Lemhi|Clark",
    county_fips_all: "16059|16033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83465,
    lat: 44.77581,
    lng: -113.69949,
    city: "Lemhi",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 123,
    density: 0.3,
    county_fips: 16059,
    county_name: "Lemhi",
    county_weights: {
      16059: 100,
    },
    county_names_all: "Lemhi",
    county_fips_all: 16059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83466,
    lat: 45.44184,
    lng: -114.05549,
    city: "North Fork",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 168,
    density: 0.3,
    county_fips: 16059,
    county_name: "Lemhi",
    county_weights: {
      16059: 100,
    },
    county_names_all: "Lemhi",
    county_fips_all: 16059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83467,
    lat: 45.02006,
    lng: -113.89828,
    city: "Salmon",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6377,
    density: 2.9,
    county_fips: 16059,
    county_name: "Lemhi",
    county_weights: {
      16059: 100,
    },
    county_names_all: "Lemhi",
    county_fips_all: 16059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83468,
    lat: 44.92444,
    lng: -113.61293,
    city: "Tendoy",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 167,
    density: 0.5,
    county_fips: 16059,
    county_name: "Lemhi",
    county_weights: {
      16059: 100,
    },
    county_names_all: "Lemhi",
    county_fips_all: 16059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83469,
    lat: 45.1127,
    lng: -114.47772,
    city: "Shoup",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27,
    density: 0,
    county_fips: 16059,
    county_name: "Lemhi",
    county_weights: {
      16059: 100,
    },
    county_names_all: "Lemhi",
    county_fips_all: 16059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83501,
    lat: 46.2283,
    lng: -116.90608,
    city: "Lewiston",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35183,
    density: 55.6,
    county_fips: 16069,
    county_name: "Nez Perce",
    county_weights: {
      16069: 100,
    },
    county_names_all: "Nez Perce",
    county_fips_all: 16069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83520,
    lat: 46.53936,
    lng: -116.32366,
    city: "Ahsahka",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 272,
    density: 9.5,
    county_fips: 16035,
    county_name: "Clearwater",
    county_weights: {
      16035: 100,
    },
    county_names_all: "Clearwater",
    county_fips_all: 16035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83522,
    lat: 45.91273,
    lng: -116.50102,
    city: "Cottonwood",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2362,
    density: 2.1,
    county_fips: 16049,
    county_name: "Idaho",
    county_weights: {
      16049: 100,
    },
    county_names_all: "Idaho",
    county_fips_all: 16049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83523,
    lat: 46.22939,
    lng: -116.47224,
    city: "Craigmont",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 804,
    density: 1.4,
    county_fips: 16061,
    county_name: "Lewis",
    county_weights: {
      16061: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 16061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83524,
    lat: 46.3586,
    lng: -116.65439,
    city: "Culdesac",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 947,
    density: 3.1,
    county_fips: 16069,
    county_name: "Nez Perce",
    county_weights: {
      16061: 19.77,
      16069: 80.23,
    },
    county_names_all: "Nez Perce|Lewis",
    county_fips_all: "16069|16061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83525,
    lat: 45.73798,
    lng: -115.39367,
    city: "Elk City",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 276,
    density: 0.2,
    county_fips: 16049,
    county_name: "Idaho",
    county_weights: {
      16049: 100,
    },
    county_names_all: "Idaho",
    county_fips_all: 16049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83526,
    lat: 46.14759,
    lng: -116.4169,
    city: "Ferdinand",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 318,
    density: 3.1,
    county_fips: 16049,
    county_name: "Idaho",
    county_weights: {
      16049: 100,
    },
    county_names_all: "Idaho",
    county_fips_all: 16049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83530,
    lat: 45.91516,
    lng: -116.02117,
    city: "Grangeville",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5727,
    density: 5.7,
    county_fips: 16049,
    county_name: "Idaho",
    county_weights: {
      16049: 100,
    },
    county_names_all: "Idaho",
    county_fips_all: 16049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83533,
    lat: 46.11707,
    lng: -116.24063,
    city: "Greencreek",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 217,
    density: 2.5,
    county_fips: 16049,
    county_name: "Idaho",
    county_weights: {
      16049: 100,
    },
    county_names_all: "Idaho",
    county_fips_all: 16049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83535,
    lat: 46.54011,
    lng: -116.72599,
    city: "Juliaetta",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1056,
    density: 7.7,
    county_fips: 16069,
    county_name: "Nez Perce",
    county_weights: {
      16057: 29.73,
      16069: 70.27,
    },
    county_names_all: "Nez Perce|Latah",
    county_fips_all: "16069|16057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83536,
    lat: 46.21794,
    lng: -116.02665,
    city: "Kamiah",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4533,
    density: 8.6,
    county_fips: 16049,
    county_name: "Idaho",
    county_weights: {
      16049: 91.41,
      16061: 8.59,
    },
    county_names_all: "Idaho|Lewis",
    county_fips_all: "16049|16061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83537,
    lat: 46.62877,
    lng: -116.52348,
    city: "Kendrick",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1033,
    density: 2.3,
    county_fips: 16057,
    county_name: "Latah",
    county_weights: {
      16035: 19.73,
      16057: 52.28,
      16069: 27.99,
    },
    county_names_all: "Latah|Nez Perce|Clearwater",
    county_fips_all: "16057|16069|16035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83539,
    lat: 46.20361,
    lng: -114.93684,
    city: "Kooskia",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2297,
    density: 0.4,
    county_fips: 16049,
    county_name: "Idaho",
    county_weights: {
      16049: 100,
    },
    county_names_all: "Idaho",
    county_fips_all: 16049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83540,
    lat: 46.34649,
    lng: -116.78273,
    city: "Lapwai",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2452,
    density: 9,
    county_fips: 16069,
    county_name: "Nez Perce",
    county_weights: {
      16069: 100,
    },
    county_names_all: "Nez Perce",
    county_fips_all: 16069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83541,
    lat: 46.49297,
    lng: -116.50156,
    city: "Lenore",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 986,
    density: 3.7,
    county_fips: 16069,
    county_name: "Nez Perce",
    county_weights: {
      16035: 25.27,
      16069: 74.73,
    },
    county_names_all: "Nez Perce|Clearwater",
    county_fips_all: "16069|16035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83542,
    lat: 45.55291,
    lng: -116.3115,
    city: "Lucile",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 123,
    density: 0.6,
    county_fips: 16049,
    county_name: "Idaho",
    county_weights: {
      16049: 100,
    },
    county_names_all: "Idaho",
    county_fips_all: 16049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83543,
    lat: 46.27358,
    lng: -116.23815,
    city: "Nezperce",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 821,
    density: 2.4,
    county_fips: 16061,
    county_name: "Lewis",
    county_weights: {
      16061: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 16061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83544,
    lat: 46.49365,
    lng: -116.1525,
    city: "Orofino",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6754,
    density: 10.8,
    county_fips: 16035,
    county_name: "Clearwater",
    county_weights: {
      16035: 97.36,
      16061: 2.64,
    },
    county_names_all: "Clearwater|Lewis",
    county_fips_all: "16035|16061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83545,
    lat: 46.42664,
    lng: -116.4213,
    city: "Peck",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 333,
    density: 3,
    county_fips: 16069,
    county_name: "Nez Perce",
    county_weights: {
      16069: 100,
    },
    county_names_all: "Nez Perce",
    county_fips_all: 16069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83546,
    lat: 46.57326,
    lng: -115.81115,
    city: "Pierce",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 384,
    density: 3.6,
    county_fips: 16035,
    county_name: "Clearwater",
    county_weights: {
      16035: 100,
    },
    county_names_all: "Clearwater",
    county_fips_all: 16035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83547,
    lat: 45.31165,
    lng: -116.33062,
    city: "Pollock",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 353,
    density: 4.1,
    county_fips: 16049,
    county_name: "Idaho",
    county_weights: {
      16049: 100,
    },
    county_names_all: "Idaho",
    county_fips_all: 16049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83548,
    lat: 46.34878,
    lng: -116.50843,
    city: "Reubens",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 125,
    density: 1.9,
    county_fips: 16069,
    county_name: "Nez Perce",
    county_weights: {
      16061: 14.08,
      16069: 85.92,
    },
    county_names_all: "Nez Perce|Lewis",
    county_fips_all: "16069|16061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83549,
    lat: 45.36641,
    lng: -116.2549,
    city: "Riggins",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 622,
    density: 0.4,
    county_fips: 16049,
    county_name: "Idaho",
    county_weights: {
      16049: 100,
    },
    county_names_all: "Idaho",
    county_fips_all: 16049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83552,
    lat: 45.9777,
    lng: -115.93948,
    city: "Stites",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 837,
    density: 2.8,
    county_fips: 16049,
    county_name: "Idaho",
    county_weights: {
      16049: 100,
    },
    county_names_all: "Idaho",
    county_fips_all: 16049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83553,
    lat: 46.38365,
    lng: -115.9038,
    city: "Weippe",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 781,
    density: 2.8,
    county_fips: 16035,
    county_name: "Clearwater",
    county_weights: {
      16035: 100,
    },
    county_names_all: "Clearwater",
    county_fips_all: 16035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83554,
    lat: 45.68522,
    lng: -116.29936,
    city: "White Bird",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 347,
    density: 0.6,
    county_fips: 16049,
    county_name: "Idaho",
    county_weights: {
      16049: 100,
    },
    county_names_all: "Idaho",
    county_fips_all: 16049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83555,
    lat: 46.08662,
    lng: -116.72221,
    city: "Winchester",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 471,
    density: 1,
    county_fips: 16069,
    county_name: "Nez Perce",
    county_weights: {
      16061: 41.37,
      16069: 58.63,
    },
    county_names_all: "Nez Perce|Lewis",
    county_fips_all: "16069|16061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83602,
    lat: 44.09676,
    lng: -116.15049,
    city: "Banks",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6,
    density: 0.1,
    county_fips: 16015,
    county_name: "Boise",
    county_weights: {
      16015: 100,
    },
    county_names_all: "Boise",
    county_fips_all: 16015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83604,
    lat: 42.52727,
    lng: -115.84966,
    city: "Bruneau",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 554,
    density: 0.3,
    county_fips: 16073,
    county_name: "Owyhee",
    county_weights: {
      16073: 100,
    },
    county_names_all: "Owyhee",
    county_fips_all: 16073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83605,
    lat: 43.66442,
    lng: -116.65171,
    city: "Caldwell",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46961,
    density: 736.2,
    county_fips: 16027,
    county_name: "Canyon",
    county_weights: {
      16027: 100,
    },
    county_names_all: "Canyon",
    county_fips_all: 16027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83607,
    lat: 43.7116,
    lng: -116.74362,
    city: "Caldwell",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24922,
    density: 41.8,
    county_fips: 16027,
    county_name: "Canyon",
    county_weights: {
      16027: 70.79,
      16045: 9.58,
      16075: 19.63,
    },
    county_names_all: "Canyon|Payette|Gem",
    county_fips_all: "16027|16075|16045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83610,
    lat: 44.70231,
    lng: -116.78239,
    city: "Cambridge",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 928,
    density: 0.7,
    county_fips: 16087,
    county_name: "Washington",
    county_weights: {
      16003: 12.64,
      16087: 87.36,
    },
    county_names_all: "Washington|Adams",
    county_fips_all: "16087|16003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83611,
    lat: 45.03935,
    lng: -115.24709,
    city: "Cascade",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2159,
    density: 0.3,
    county_fips: 16085,
    county_name: "Valley",
    county_weights: {
      16049: 39.74,
      16085: 60.26,
    },
    county_names_all: "Valley|Idaho",
    county_fips_all: "16085|16049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83612,
    lat: 44.8438,
    lng: -116.53296,
    city: "Council",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2020,
    density: 1.6,
    county_fips: 16003,
    county_name: "Adams",
    county_weights: {
      16003: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 16003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83615,
    lat: 44.70288,
    lng: -116.0484,
    city: "Donnelly",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1552,
    density: 8.2,
    county_fips: 16085,
    county_name: "Valley",
    county_weights: {
      16085: 100,
    },
    county_names_all: "Valley",
    county_fips_all: 16085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83616,
    lat: 43.77667,
    lng: -116.38977,
    city: "Eagle",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29630,
    density: 102.7,
    county_fips: 16001,
    county_name: "Ada",
    county_weights: {
      16001: 64.61,
      16045: 35.39,
    },
    county_names_all: "Ada|Gem",
    county_fips_all: "16001|16045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83617,
    lat: 43.93303,
    lng: -116.50368,
    city: "Emmett",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15586,
    density: 26.9,
    county_fips: 16045,
    county_name: "Gem",
    county_weights: {
      16045: 99.89,
      16075: 0.11,
    },
    county_names_all: "Gem|Payette",
    county_fips_all: "16045|16075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83619,
    lat: 43.96982,
    lng: -116.91204,
    city: "Fruitland",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7544,
    density: 92,
    county_fips: 16075,
    county_name: "Payette",
    county_weights: {
      16075: 100,
    },
    county_names_all: "Payette",
    county_fips_all: 16075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83622,
    lat: 44.1065,
    lng: -115.88953,
    city: "Garden Valley",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2268,
    density: 3.1,
    county_fips: 16015,
    county_name: "Boise",
    county_weights: {
      16015: 100,
    },
    county_names_all: "Boise",
    county_fips_all: 16015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83623,
    lat: 43.04932,
    lng: -115.39485,
    city: "Glenns Ferry",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1493,
    density: 2.3,
    county_fips: 16039,
    county_name: "Elmore",
    county_weights: {
      16039: 100,
    },
    county_names_all: "Elmore",
    county_fips_all: 16039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83624,
    lat: 42.92441,
    lng: -116.14266,
    city: "Grand View",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1528,
    density: 2.2,
    county_fips: 16073,
    county_name: "Owyhee",
    county_weights: {
      16039: 22.69,
      16073: 77.31,
    },
    county_names_all: "Owyhee|Elmore",
    county_fips_all: "16073|16039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83626,
    lat: 43.66876,
    lng: -116.82815,
    city: "Greenleaf",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1244,
    density: 72.8,
    county_fips: 16027,
    county_name: "Canyon",
    county_weights: {
      16027: 100,
    },
    county_names_all: "Canyon",
    county_fips_all: 16027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83627,
    lat: 42.91336,
    lng: -115.53238,
    city: "Hammett",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 466,
    density: 2.1,
    county_fips: 16073,
    county_name: "Owyhee",
    county_weights: {
      16039: 27.63,
      16073: 72.37,
    },
    county_names_all: "Owyhee|Elmore",
    county_fips_all: "16073|16039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83628,
    lat: 43.57934,
    lng: -116.96975,
    city: "Homedale",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4460,
    density: 27.3,
    county_fips: 16073,
    county_name: "Owyhee",
    county_weights: {
      16073: 100,
    },
    county_names_all: "Owyhee",
    county_fips_all: 16073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83629,
    lat: 43.91115,
    lng: -116.16947,
    city: "Horseshoe Bend",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2125,
    density: 4.2,
    county_fips: 16015,
    county_name: "Boise",
    county_weights: {
      16015: 95.33,
      16045: 4.67,
    },
    county_names_all: "Boise|Gem",
    county_fips_all: "16015|16045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83631,
    lat: 43.88543,
    lng: -115.77369,
    city: "Idaho City",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 979,
    density: 2.2,
    county_fips: 16015,
    county_name: "Boise",
    county_weights: {
      16015: 100,
    },
    county_names_all: "Boise",
    county_fips_all: 16015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83632,
    lat: 44.53228,
    lng: -116.40994,
    city: "Indian Valley",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 409,
    density: 1.2,
    county_fips: 16003,
    county_name: "Adams",
    county_weights: {
      16003: 96.18,
      16087: 3.82,
    },
    county_names_all: "Adams|Washington",
    county_fips_all: "16003|16087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83633,
    lat: 43.0297,
    lng: -115.21253,
    city: "King Hill",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 720,
    density: 1.9,
    county_fips: 16039,
    county_name: "Elmore",
    county_weights: {
      16039: 100,
    },
    county_names_all: "Elmore",
    county_fips_all: 16039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83634,
    lat: 43.44824,
    lng: -116.33287,
    city: "Kuna",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28443,
    density: 70.3,
    county_fips: 16001,
    county_name: "Ada",
    county_weights: {
      16001: 95.16,
      16027: 4.84,
    },
    county_names_all: "Ada|Canyon",
    county_fips_all: "16001|16027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83636,
    lat: 43.90832,
    lng: -116.66097,
    city: "Letha",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 458,
    density: 71,
    county_fips: 16045,
    county_name: "Gem",
    county_weights: {
      16045: 100,
    },
    county_names_all: "Gem",
    county_fips_all: 16045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83637,
    lat: 44.13249,
    lng: -115.29625,
    city: "Lowman",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 280,
    density: 0.2,
    county_fips: 16015,
    county_name: "Boise",
    county_weights: {
      16015: 100,
    },
    county_names_all: "Boise",
    county_fips_all: 16015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83638,
    lat: 45.1504,
    lng: -115.82001,
    city: "Mccall",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7259,
    density: 4.2,
    county_fips: 16085,
    county_name: "Valley",
    county_weights: {
      16003: 0.58,
      16049: 46.69,
      16085: 52.73,
    },
    county_names_all: "Valley|Idaho|Adams",
    county_fips_all: "16085|16049|16003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83639,
    lat: 43.36878,
    lng: -116.92472,
    city: "Marsing",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3519,
    density: 5.5,
    county_fips: 16073,
    county_name: "Owyhee",
    county_weights: {
      16073: 100,
    },
    county_names_all: "Owyhee",
    county_fips_all: 16073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83641,
    lat: 43.35079,
    lng: -116.6357,
    city: "Melba",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3720,
    density: 6.3,
    county_fips: 16073,
    county_name: "Owyhee",
    county_weights: {
      16001: 14.23,
      16027: 24.77,
      16073: 61,
    },
    county_names_all: "Owyhee|Canyon|Ada",
    county_fips_all: "16073|16027|16001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83642,
    lat: 43.57334,
    lng: -116.40116,
    city: "Meridian",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47808,
    density: 445.1,
    county_fips: 16001,
    county_name: "Ada",
    county_weights: {
      16001: 100,
    },
    county_names_all: "Ada",
    county_fips_all: 16001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83643,
    lat: 44.62983,
    lng: -116.45439,
    city: "Mesa",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 106,
    density: 11.7,
    county_fips: 16003,
    county_name: "Adams",
    county_weights: {
      16003: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 16003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83644,
    lat: 43.74823,
    lng: -116.58455,
    city: "Middleton",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14237,
    density: 119.9,
    county_fips: 16027,
    county_name: "Canyon",
    county_weights: {
      16027: 100,
    },
    county_names_all: "Canyon",
    county_fips_all: 16027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83645,
    lat: 44.36016,
    lng: -116.56454,
    city: "Midvale",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 787,
    density: 0.7,
    county_fips: 16087,
    county_name: "Washington",
    county_weights: {
      16087: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 16087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83646,
    lat: 43.65,
    lng: -116.43247,
    city: "Meridian",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68189,
    density: 965.2,
    county_fips: 16001,
    county_name: "Ada",
    county_weights: {
      16001: 100,
    },
    county_names_all: "Ada",
    county_fips_all: 16001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83647,
    lat: 43.39487,
    lng: -115.51159,
    city: "Mountain Home",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20868,
    density: 5.4,
    county_fips: 16039,
    county_name: "Elmore",
    county_weights: {
      16039: 97.7,
      16073: 2.3,
    },
    county_names_all: "Elmore|Owyhee",
    county_fips_all: "16039|16073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83648,
    lat: 43.04962,
    lng: -115.86554,
    city: "Mountain Home Afb",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3151,
    density: 122,
    county_fips: 16039,
    county_name: "Elmore",
    county_weights: {
      16039: 100,
    },
    county_names_all: "Elmore",
    county_fips_all: 16039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83650,
    lat: 42.87041,
    lng: -116.65518,
    city: "Murphy",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 558,
    density: 0.1,
    county_fips: 16073,
    county_name: "Owyhee",
    county_weights: {
      16073: 100,
    },
    county_names_all: "Owyhee",
    county_fips_all: 16073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83651,
    lat: 43.58438,
    lng: -116.62884,
    city: "Nampa",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36313,
    density: 879.5,
    county_fips: 16027,
    county_name: "Canyon",
    county_weights: {
      16027: 100,
    },
    county_names_all: "Canyon",
    county_fips_all: 16027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83654,
    lat: 45.13647,
    lng: -116.39626,
    city: "New Meadows",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1622,
    density: 1.7,
    county_fips: 16003,
    county_name: "Adams",
    county_weights: {
      16003: 78.91,
      16049: 21.09,
    },
    county_names_all: "Adams|Idaho",
    county_fips_all: "16003|16049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83655,
    lat: 43.95135,
    lng: -116.79171,
    city: "New Plymouth",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5375,
    density: 35.5,
    county_fips: 16075,
    county_name: "Payette",
    county_weights: {
      16075: 100,
    },
    county_names_all: "Payette",
    county_fips_all: 16075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83656,
    lat: 43.7255,
    lng: -116.79852,
    city: "Notus",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 588,
    density: 883.6,
    county_fips: 16027,
    county_name: "Canyon",
    county_weights: {
      16027: 100,
    },
    county_names_all: "Canyon",
    county_fips_all: 16027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83657,
    lat: 44.23554,
    lng: -116.30057,
    city: "Ola",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 338,
    density: 0.8,
    county_fips: 16045,
    county_name: "Gem",
    county_weights: {
      16045: 97.47,
      16085: 2.53,
    },
    county_names_all: "Gem|Valley",
    county_fips_all: "16045|16085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83660,
    lat: 43.80016,
    lng: -116.9301,
    city: "Parma",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6126,
    density: 19,
    county_fips: 16027,
    county_name: "Canyon",
    county_weights: {
      16027: 71.94,
      16075: 28.06,
    },
    county_names_all: "Canyon|Payette",
    county_fips_all: "16027|16075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83661,
    lat: 44.10617,
    lng: -116.69337,
    city: "Payette",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9650,
    density: 12.6,
    county_fips: 16075,
    county_name: "Payette",
    county_weights: {
      16075: 78.77,
      16087: 21.23,
    },
    county_names_all: "Payette|Washington",
    county_fips_all: "16075|16087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83666,
    lat: 43.96157,
    lng: -115.97398,
    city: "Placerville",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48,
    density: 1.8,
    county_fips: 16015,
    county_name: "Boise",
    county_weights: {
      16015: 100,
    },
    county_names_all: "Boise",
    county_fips_all: 16015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83669,
    lat: 43.71899,
    lng: -116.50147,
    city: "Star",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11281,
    density: 197.9,
    county_fips: 16001,
    county_name: "Ada",
    county_weights: {
      16001: 65.87,
      16027: 34.13,
    },
    county_names_all: "Ada|Canyon",
    county_fips_all: "16001|16027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83670,
    lat: 44.0189,
    lng: -116.30793,
    city: "Sweet",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 711,
    density: 4.1,
    county_fips: 16045,
    county_name: "Gem",
    county_weights: {
      16015: 31.02,
      16045: 68.98,
    },
    county_names_all: "Gem|Boise",
    county_fips_all: "16045|16015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83672,
    lat: 44.38095,
    lng: -116.97188,
    city: "Weiser",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8381,
    density: 5.9,
    county_fips: 16087,
    county_name: "Washington",
    county_weights: {
      16087: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 16087,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83676,
    lat: 43.65743,
    lng: -116.91156,
    city: "Wilder",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5504,
    density: 52.1,
    county_fips: 16027,
    county_name: "Canyon",
    county_weights: {
      16027: 100,
    },
    county_names_all: "Canyon",
    county_fips_all: 16027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83677,
    lat: 45.03763,
    lng: -115.38691,
    city: "Yellow Pine",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 235,
    density: 0.2,
    county_fips: 16085,
    county_name: "Valley",
    county_weights: {
      16085: 100,
    },
    county_names_all: "Valley",
    county_fips_all: 16085,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83686,
    lat: 43.49643,
    lng: -116.61207,
    city: "Nampa",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52879,
    density: 232.8,
    county_fips: 16027,
    county_name: "Canyon",
    county_weights: {
      16027: 100,
    },
    county_names_all: "Canyon",
    county_fips_all: 16027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83687,
    lat: 43.60998,
    lng: -116.52997,
    city: "Nampa",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34377,
    density: 268.6,
    county_fips: 16027,
    county_name: "Canyon",
    county_weights: {
      16001: 10.33,
      16027: 89.67,
    },
    county_names_all: "Canyon|Ada",
    county_fips_all: "16027|16001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83702,
    lat: 43.66821,
    lng: -116.16493,
    city: "Boise",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22665,
    density: 279.1,
    county_fips: 16001,
    county_name: "Ada",
    county_weights: {
      16001: 97.26,
      16015: 2.74,
    },
    county_names_all: "Ada|Boise",
    county_fips_all: "16001|16015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83703,
    lat: 43.66189,
    lng: -116.23906,
    city: "Boise",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17450,
    density: 828.4,
    county_fips: 16001,
    county_name: "Ada",
    county_weights: {
      16001: 100,
    },
    county_names_all: "Ada",
    county_fips_all: 16001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83704,
    lat: 43.62765,
    lng: -116.28716,
    city: "Boise",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40071,
    density: 1767.8,
    county_fips: 16001,
    county_name: "Ada",
    county_weights: {
      16001: 100,
    },
    county_names_all: "Ada",
    county_fips_all: 16001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83705,
    lat: 43.55609,
    lng: -116.22002,
    city: "Boise",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29157,
    density: 694.4,
    county_fips: 16001,
    county_name: "Ada",
    county_weights: {
      16001: 100,
    },
    county_names_all: "Ada",
    county_fips_all: 16001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83706,
    lat: 43.59108,
    lng: -116.19427,
    city: "Boise",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34814,
    density: 1809.2,
    county_fips: 16001,
    county_name: "Ada",
    county_weights: {
      16001: 100,
    },
    county_names_all: "Ada",
    county_fips_all: 16001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83709,
    lat: 43.55212,
    lng: -116.28847,
    city: "Boise",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60449,
    density: 692.6,
    county_fips: 16001,
    county_name: "Ada",
    county_weights: {
      16001: 100,
    },
    county_names_all: "Ada",
    county_fips_all: 16001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83712,
    lat: 43.61663,
    lng: -116.11766,
    city: "Boise",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10020,
    density: 168.6,
    county_fips: 16001,
    county_name: "Ada",
    county_weights: {
      16001: 100,
    },
    county_names_all: "Ada",
    county_fips_all: 16001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83713,
    lat: 43.63897,
    lng: -116.33464,
    city: "Boise",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28806,
    density: 1684.4,
    county_fips: 16001,
    county_name: "Ada",
    county_weights: {
      16001: 100,
    },
    county_names_all: "Ada",
    county_fips_all: 16001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83714,
    lat: 43.72444,
    lng: -116.27017,
    city: "Garden City",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24351,
    density: 173.5,
    county_fips: 16001,
    county_name: "Ada",
    county_weights: {
      16001: 100,
    },
    county_names_all: "Ada",
    county_fips_all: 16001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83716,
    lat: 43.67271,
    lng: -115.6548,
    city: "Boise",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18283,
    density: 6.8,
    county_fips: 16039,
    county_name: "Elmore",
    county_weights: {
      16001: 15.84,
      16015: 23.82,
      16039: 60.34,
    },
    county_names_all: "Elmore|Boise|Ada",
    county_fips_all: "16039|16015|16001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83720,
    lat: 43.61771,
    lng: -116.19973,
    city: "Boise",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 16001,
    county_name: "Ada",
    county_weights: {
      16001: 100,
    },
    county_names_all: "Ada",
    county_fips_all: 16001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83725,
    lat: 43.60484,
    lng: -116.20569,
    city: "Boise",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 16001,
    county_name: "Ada",
    county_weights: {
      16001: 100,
    },
    county_names_all: "Ada",
    county_fips_all: 16001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 83801,
    lat: 47.95631,
    lng: -116.6434,
    city: "Athol",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6872,
    density: 15.2,
    county_fips: 16055,
    county_name: "Kootenai",
    county_weights: {
      16017: 39.99,
      16055: 60.01,
    },
    county_names_all: "Kootenai|Bonner",
    county_fips_all: "16055|16017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83802,
    lat: 47.26665,
    lng: -115.72815,
    city: "Avery",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 170,
    density: 0.3,
    county_fips: 16079,
    county_name: "Shoshone",
    county_weights: {
      16079: 100,
    },
    county_names_all: "Shoshone",
    county_fips_all: 16079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83803,
    lat: 48.02261,
    lng: -116.39878,
    city: "Bayview",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1015,
    density: 3.1,
    county_fips: 16017,
    county_name: "Bonner",
    county_weights: {
      16017: 92.82,
      16055: 7.18,
    },
    county_names_all: "Bonner|Kootenai",
    county_fips_all: "16017|16055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83804,
    lat: 48.03714,
    lng: -116.97315,
    city: "Blanchard",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1497,
    density: 10.9,
    county_fips: 16017,
    county_name: "Bonner",
    county_weights: {
      16017: 100,
    },
    county_names_all: "Bonner",
    county_fips_all: 16017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83805,
    lat: 48.83203,
    lng: -116.49248,
    city: "Bonners Ferry",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8856,
    density: 3.9,
    county_fips: 16021,
    county_name: "Boundary",
    county_weights: {
      16021: 100,
    },
    county_names_all: "Boundary",
    county_fips_all: 16021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83806,
    lat: 46.88243,
    lng: -116.37038,
    city: "Bovill",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 224,
    density: 3.5,
    county_fips: 16057,
    county_name: "Latah",
    county_weights: {
      16057: 100,
    },
    county_names_all: "Latah",
    county_fips_all: 16057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83808,
    lat: 47.31276,
    lng: -116.07659,
    city: "Calder",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 168,
    density: 0.3,
    county_fips: 16079,
    county_name: "Shoshone",
    county_weights: {
      16079: 100,
    },
    county_names_all: "Shoshone",
    county_fips_all: 16079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83809,
    lat: 48.06234,
    lng: -116.58116,
    city: "Careywood",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 245,
    density: 5.6,
    county_fips: 16017,
    county_name: "Bonner",
    county_weights: {
      16017: 100,
    },
    county_names_all: "Bonner",
    county_fips_all: 16017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83810,
    lat: 47.54326,
    lng: -116.45525,
    city: "Cataldo",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1519,
    density: 3.8,
    county_fips: 16055,
    county_name: "Kootenai",
    county_weights: {
      16055: 97.47,
      16079: 2.53,
    },
    county_names_all: "Kootenai|Shoshone",
    county_fips_all: "16055|16079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83811,
    lat: 48.11296,
    lng: -116.15574,
    city: "Clark Fork",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1451,
    density: 5.3,
    county_fips: 16017,
    county_name: "Bonner",
    county_weights: {
      16017: 100,
    },
    county_names_all: "Bonner",
    county_fips_all: 16017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83812,
    lat: 47.00311,
    lng: -116.28295,
    city: "Clarkia",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32,
    density: 0.5,
    county_fips: 16079,
    county_name: "Shoshone",
    county_weights: {
      16079: 100,
    },
    county_names_all: "Shoshone",
    county_fips_all: 16079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83813,
    lat: 48.10462,
    lng: -116.63734,
    city: "Cocolalla",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 905,
    density: 8.4,
    county_fips: 16017,
    county_name: "Bonner",
    county_weights: {
      16017: 100,
    },
    county_names_all: "Bonner",
    county_fips_all: 16017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83814,
    lat: 47.63717,
    lng: -116.75811,
    city: "Coeur D Alene",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26174,
    density: 52.1,
    county_fips: 16055,
    county_name: "Kootenai",
    county_weights: {
      16055: 100,
    },
    county_names_all: "Kootenai",
    county_fips_all: 16055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83815,
    lat: 47.72498,
    lng: -116.78732,
    city: "Coeur D Alene",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35832,
    density: 885.9,
    county_fips: 16055,
    county_name: "Kootenai",
    county_weights: {
      16055: 100,
    },
    county_names_all: "Kootenai",
    county_fips_all: 16055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83821,
    lat: 48.59365,
    lng: -116.8367,
    city: "Coolin",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 216,
    density: 1.7,
    county_fips: 16017,
    county_name: "Bonner",
    county_weights: {
      16017: 100,
    },
    county_names_all: "Bonner",
    county_fips_all: 16017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83822,
    lat: 48.16785,
    lng: -117.0014,
    city: "Oldtown",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1961,
    density: 22,
    county_fips: 16017,
    county_name: "Bonner",
    county_weights: {
      16017: 100,
    },
    county_names_all: "Bonner",
    county_fips_all: 16017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83823,
    lat: 46.80554,
    lng: -116.51934,
    city: "Deary",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1663,
    density: 4.2,
    county_fips: 16057,
    county_name: "Latah",
    county_weights: {
      16057: 100,
    },
    county_names_all: "Latah",
    county_fips_all: 16057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83824,
    lat: 47.10638,
    lng: -116.93901,
    city: "Desmet",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 337,
    density: 1.8,
    county_fips: 16009,
    county_name: "Benewah",
    county_weights: {
      16009: 73.93,
      16057: 26.07,
    },
    county_names_all: "Benewah|Latah",
    county_fips_all: "16009|16057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83825,
    lat: 48.24694,
    lng: -116.6076,
    city: "Dover",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 209,
    density: 148.8,
    county_fips: 16017,
    county_name: "Bonner",
    county_weights: {
      16017: 100,
    },
    county_names_all: "Bonner",
    county_fips_all: 16017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83826,
    lat: 48.98382,
    lng: -116.15188,
    city: "Eastport",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 16021,
    county_name: "Boundary",
    county_weights: {
      16021: 100,
    },
    county_names_all: "Boundary",
    county_fips_all: 16021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83827,
    lat: 46.78035,
    lng: -116.17469,
    city: "Elk River",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 132,
    density: 5.4,
    county_fips: 16035,
    county_name: "Clearwater",
    county_weights: {
      16035: 100,
    },
    county_names_all: "Clearwater",
    county_fips_all: 16035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83830,
    lat: 47.07651,
    lng: -116.35272,
    city: "Fernwood",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 359,
    density: 2.3,
    county_fips: 16009,
    county_name: "Benewah",
    county_weights: {
      16009: 70.97,
      16079: 29.03,
    },
    county_names_all: "Benewah|Shoshone",
    county_fips_all: "16009|16079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83832,
    lat: 46.55223,
    lng: -116.90666,
    city: "Genesee",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1804,
    density: 4.6,
    county_fips: 16057,
    county_name: "Latah",
    county_weights: {
      16057: 55.17,
      16069: 44.83,
    },
    county_names_all: "Latah|Nez Perce",
    county_fips_all: "16057|16069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83833,
    lat: 47.51484,
    lng: -116.73284,
    city: "Harrison",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1608,
    density: 5.9,
    county_fips: 16055,
    county_name: "Kootenai",
    county_weights: {
      16009: 0.1,
      16055: 99.9,
    },
    county_names_all: "Kootenai|Benewah",
    county_fips_all: "16055|16009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83834,
    lat: 46.97566,
    lng: -116.67484,
    city: "Harvard",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 172,
    density: 0.7,
    county_fips: 16057,
    county_name: "Latah",
    county_weights: {
      16057: 100,
    },
    county_names_all: "Latah",
    county_fips_all: 16057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83835,
    lat: 47.79557,
    lng: -116.66843,
    city: "Hayden",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22037,
    density: 85.6,
    county_fips: 16055,
    county_name: "Kootenai",
    county_weights: {
      16055: 100,
    },
    county_names_all: "Kootenai",
    county_fips_all: 16055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83836,
    lat: 48.27046,
    lng: -116.24804,
    city: "Hope",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 887,
    density: 3.7,
    county_fips: 16017,
    county_name: "Bonner",
    county_weights: {
      16017: 100,
    },
    county_names_all: "Bonner",
    county_fips_all: 16017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83837,
    lat: 47.52835,
    lng: -116.09103,
    city: "Kellogg",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3149,
    density: 20.2,
    county_fips: 16079,
    county_name: "Shoshone",
    county_weights: {
      16079: 100,
    },
    county_names_all: "Shoshone",
    county_fips_all: 16079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83839,
    lat: 47.61647,
    lng: -116.17949,
    city: "Kingston",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1281,
    density: 5.3,
    county_fips: 16079,
    county_name: "Shoshone",
    county_weights: {
      16079: 100,
    },
    county_names_all: "Shoshone",
    county_fips_all: 16079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83840,
    lat: 48.31263,
    lng: -116.51506,
    city: "Kootenai",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 283,
    density: 369.3,
    county_fips: 16017,
    county_name: "Bonner",
    county_weights: {
      16017: 100,
    },
    county_names_all: "Bonner",
    county_fips_all: 16017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83841,
    lat: 48.19911,
    lng: -116.77851,
    city: "Laclede",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 449,
    density: 7.3,
    county_fips: 16017,
    county_name: "Bonner",
    county_weights: {
      16017: 100,
    },
    county_names_all: "Bonner",
    county_fips_all: 16017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83842,
    lat: 47.44046,
    lng: -116.55056,
    city: "Medimont",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 101,
    density: 2,
    county_fips: 16055,
    county_name: "Kootenai",
    county_weights: {
      16055: 100,
    },
    county_names_all: "Kootenai",
    county_fips_all: 16055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83843,
    lat: 46.72257,
    lng: -116.94132,
    city: "Moscow",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27480,
    density: 89.2,
    county_fips: 16057,
    county_name: "Latah",
    county_weights: {
      16057: 100,
    },
    county_names_all: "Latah",
    county_fips_all: 16057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83844,
    lat: 46.72823,
    lng: -117.01946,
    city: "Moscow",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 16057,
    county_name: "Latah",
    county_weights: {
      16057: 100,
    },
    county_names_all: "Latah",
    county_fips_all: 16057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83845,
    lat: 48.74854,
    lng: -116.11302,
    city: "Moyie Springs",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2067,
    density: 12.1,
    county_fips: 16021,
    county_name: "Boundary",
    county_weights: {
      16021: 100,
    },
    county_names_all: "Boundary",
    county_fips_all: 16021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83846,
    lat: 47.47308,
    lng: -115.75009,
    city: "Mullan",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 838,
    density: 9.1,
    county_fips: 16079,
    county_name: "Shoshone",
    county_weights: {
      16079: 100,
    },
    county_names_all: "Shoshone",
    county_fips_all: 16079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83847,
    lat: 48.57699,
    lng: -116.43207,
    city: "Naples",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1233,
    density: 4,
    county_fips: 16021,
    county_name: "Boundary",
    county_weights: {
      16021: 100,
    },
    county_names_all: "Boundary",
    county_fips_all: 16021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83848,
    lat: 48.7067,
    lng: -116.92766,
    city: "Nordman",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 140,
    density: 1,
    county_fips: 16017,
    county_name: "Bonner",
    county_weights: {
      16017: 100,
    },
    county_names_all: "Bonner",
    county_fips_all: 16017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83849,
    lat: 47.51723,
    lng: -115.99531,
    city: "Osburn",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2249,
    density: 49.1,
    county_fips: 16079,
    county_name: "Shoshone",
    county_weights: {
      16079: 100,
    },
    county_names_all: "Shoshone",
    county_fips_all: 16079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83850,
    lat: 47.4421,
    lng: -116.20674,
    city: "Pinehurst",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2061,
    density: 8.4,
    county_fips: 16079,
    county_name: "Shoshone",
    county_weights: {
      16079: 100,
    },
    county_names_all: "Shoshone",
    county_fips_all: 16079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83851,
    lat: 47.29899,
    lng: -116.90513,
    city: "Plummer",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1832,
    density: 5.6,
    county_fips: 16009,
    county_name: "Benewah",
    county_weights: {
      16009: 100,
    },
    county_names_all: "Benewah",
    county_fips_all: 16009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83852,
    lat: 48.31105,
    lng: -116.53933,
    city: "Ponderay",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 937,
    density: 145,
    county_fips: 16017,
    county_name: "Bonner",
    county_weights: {
      16017: 100,
    },
    county_names_all: "Bonner",
    county_fips_all: 16017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83854,
    lat: 47.7267,
    lng: -116.97511,
    city: "Post Falls",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44206,
    density: 220,
    county_fips: 16055,
    county_name: "Kootenai",
    county_weights: {
      16055: 100,
    },
    county_names_all: "Kootenai",
    county_fips_all: 16055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83855,
    lat: 46.97188,
    lng: -116.92464,
    city: "Potlatch",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1990,
    density: 6.9,
    county_fips: 16057,
    county_name: "Latah",
    county_weights: {
      16057: 100,
    },
    county_names_all: "Latah",
    county_fips_all: 16057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83856,
    lat: 48.34228,
    lng: -116.91058,
    city: "Priest River",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6757,
    density: 6.6,
    county_fips: 16017,
    county_name: "Bonner",
    county_weights: {
      16017: 91.97,
      53051: 8.03,
    },
    county_names_all: "Bonner|Pend Oreille",
    county_fips_all: "16017|53051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83857,
    lat: 46.8895,
    lng: -116.79776,
    city: "Princeton",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1393,
    density: 8,
    county_fips: 16057,
    county_name: "Latah",
    county_weights: {
      16057: 100,
    },
    county_names_all: "Latah",
    county_fips_all: 16057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83858,
    lat: 47.85245,
    lng: -116.90173,
    city: "Rathdrum",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17592,
    density: 60.6,
    county_fips: 16055,
    county_name: "Kootenai",
    county_weights: {
      16055: 100,
    },
    county_names_all: "Kootenai",
    county_fips_all: 16055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83860,
    lat: 48.19234,
    lng: -116.52918,
    city: "Sagle",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6788,
    density: 22.5,
    county_fips: 16017,
    county_name: "Bonner",
    county_weights: {
      16017: 100,
    },
    county_names_all: "Bonner",
    county_fips_all: 16017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83861,
    lat: 47.2488,
    lng: -116.57821,
    city: "Saint Maries",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6563,
    density: 5.6,
    county_fips: 16009,
    county_name: "Benewah",
    county_weights: {
      16009: 89.23,
      16055: 4.77,
      16079: 6,
    },
    county_names_all: "Benewah|Shoshone|Kootenai",
    county_fips_all: "16009|16079|16055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83864,
    lat: 48.43432,
    lng: -116.50559,
    city: "Sandpoint",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19201,
    density: 18.4,
    county_fips: 16017,
    county_name: "Bonner",
    county_weights: {
      16017: 73.82,
      16021: 26.18,
    },
    county_names_all: "Bonner|Boundary",
    county_fips_all: "16017|16021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83866,
    lat: 47.14286,
    lng: -116.43995,
    city: "Santa",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 197,
    density: 1.2,
    county_fips: 16009,
    county_name: "Benewah",
    county_weights: {
      16009: 100,
    },
    county_names_all: "Benewah",
    county_fips_all: 16009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83867,
    lat: 47.50624,
    lng: -115.94696,
    city: "Silverton",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 309,
    density: 28.4,
    county_fips: 16079,
    county_name: "Shoshone",
    county_weights: {
      16079: 100,
    },
    county_names_all: "Shoshone",
    county_fips_all: 16079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83868,
    lat: 47.52441,
    lng: -116.18439,
    city: "Smelterville",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 635,
    density: 36.7,
    county_fips: 16079,
    county_name: "Shoshone",
    county_weights: {
      16079: 100,
    },
    county_names_all: "Shoshone",
    county_fips_all: 16079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83869,
    lat: 47.98095,
    lng: -116.89239,
    city: "Spirit Lake",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5407,
    density: 31.7,
    county_fips: 16055,
    county_name: "Kootenai",
    county_weights: {
      16017: 41.9,
      16055: 58.1,
    },
    county_names_all: "Kootenai|Bonner",
    county_fips_all: "16055|16017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83870,
    lat: 47.13862,
    lng: -116.85372,
    city: "Tensed",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 383,
    density: 2.3,
    county_fips: 16009,
    county_name: "Benewah",
    county_weights: {
      16009: 100,
    },
    county_names_all: "Benewah",
    county_fips_all: 16009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83871,
    lat: 46.74589,
    lng: -116.73865,
    city: "Troy",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2175,
    density: 7.5,
    county_fips: 16057,
    county_name: "Latah",
    county_weights: {
      16057: 100,
    },
    county_names_all: "Latah",
    county_fips_all: 16057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83872,
    lat: 46.85772,
    lng: -116.97251,
    city: "Viola",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 590,
    density: 5.9,
    county_fips: 16057,
    county_name: "Latah",
    county_weights: {
      16057: 100,
    },
    county_names_all: "Latah",
    county_fips_all: 16057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83873,
    lat: 47.5982,
    lng: -115.90899,
    city: "Wallace",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1697,
    density: 2.6,
    county_fips: 16079,
    county_name: "Shoshone",
    county_weights: {
      16079: 100,
    },
    county_names_all: "Shoshone",
    county_fips_all: 16079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83874,
    lat: 47.63563,
    lng: -115.78882,
    city: "Murray",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32,
    density: 0.3,
    county_fips: 16079,
    county_name: "Shoshone",
    county_weights: {
      16079: 100,
    },
    county_names_all: "Shoshone",
    county_fips_all: 16079,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 83876,
    lat: 47.44842,
    lng: -116.93161,
    city: "Worley",
    state_id: "ID",
    state_name: "Idaho",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1714,
    density: 5.5,
    county_fips: 16055,
    county_name: "Kootenai",
    county_weights: {
      16055: 100,
    },
    county_names_all: "Kootenai",
    county_fips_all: 16055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 84001,
    lat: 40.34525,
    lng: -110.27241,
    city: "Altamont",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 688,
    density: 12.7,
    county_fips: 49013,
    county_name: "Duchesne",
    county_weights: {
      49013: 100,
    },
    county_names_all: "Duchesne",
    county_fips_all: 49013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84002,
    lat: 40.42467,
    lng: -110.27784,
    city: "Altonah",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 314,
    density: 3.2,
    county_fips: 49013,
    county_name: "Duchesne",
    county_weights: {
      49013: 100,
    },
    county_names_all: "Duchesne",
    county_fips_all: 49013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84003,
    lat: 40.46629,
    lng: -111.69334,
    city: "American Fork",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51917,
    density: 272.4,
    county_fips: 49049,
    county_name: "Utah",
    county_weights: {
      49049: 100,
    },
    county_names_all: "Utah",
    county_fips_all: 49049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84004,
    lat: 40.48444,
    lng: -111.74447,
    city: "Alpine",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10573,
    density: 131.8,
    county_fips: 49049,
    county_name: "Utah",
    county_weights: {
      49049: 100,
    },
    county_names_all: "Utah",
    county_fips_all: 49049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84005,
    lat: 40.32277,
    lng: -111.99942,
    city: "Eagle Mountain",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34422,
    density: 364,
    county_fips: 49049,
    county_name: "Utah",
    county_weights: {
      49049: 100,
    },
    county_names_all: "Utah",
    county_fips_all: 49049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84006,
    lat: 40.59682,
    lng: -112.12373,
    city: "Bingham Canyon",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 839,
    density: 12.5,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84007,
    lat: 40.34115,
    lng: -110.21717,
    city: "Bluebell",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 722,
    density: 13.5,
    county_fips: 49013,
    county_name: "Duchesne",
    county_weights: {
      49013: 100,
    },
    county_names_all: "Duchesne",
    county_fips_all: 49013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84008,
    lat: 40.03341,
    lng: -109.19376,
    city: "Bonanza",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 49047,
    county_name: "Uintah",
    county_weights: {
      49047: 100,
    },
    county_names_all: "Uintah",
    county_fips_all: 49047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84009,
    lat: 40.55221,
    lng: -112.05362,
    city: "South Jordan",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84010,
    lat: 40.87433,
    lng: -111.83042,
    city: "Bountiful",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46326,
    density: 470.5,
    county_fips: 49011,
    county_name: "Davis",
    county_weights: {
      49011: 100,
    },
    county_names_all: "Davis",
    county_fips_all: 49011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84013,
    lat: 40.2958,
    lng: -112.0913,
    city: "Cedar Valley",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 910,
    density: 7.9,
    county_fips: 49049,
    county_name: "Utah",
    county_weights: {
      49049: 100,
    },
    county_names_all: "Utah",
    county_fips_all: 49049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84014,
    lat: 40.93311,
    lng: -111.85308,
    city: "Centerville",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17527,
    density: 526.3,
    county_fips: 49011,
    county_name: "Davis",
    county_weights: {
      49011: 100,
    },
    county_names_all: "Davis",
    county_fips_all: 49011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84015,
    lat: 41.12073,
    lng: -112.06129,
    city: "Clearfield",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67245,
    density: 1246.7,
    county_fips: 49011,
    county_name: "Davis",
    county_weights: {
      49011: 100,
    },
    county_names_all: "Davis",
    county_fips_all: 49011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84017,
    lat: 40.9549,
    lng: -111.20582,
    city: "Coalville",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4569,
    density: 3.4,
    county_fips: 49043,
    county_name: "Summit",
    county_weights: {
      49043: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 49043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84018,
    lat: 41.20535,
    lng: -111.42716,
    city: "Croydon",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 284,
    density: 0.6,
    county_fips: 49029,
    county_name: "Morgan",
    county_weights: {
      49029: 100,
    },
    county_names_all: "Morgan",
    county_fips_all: 49029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84020,
    lat: 40.49885,
    lng: -111.8635,
    city: "Draper",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48594,
    density: 690.7,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 80.13,
      49049: 19.87,
    },
    county_names_all: "Salt Lake|Utah",
    county_fips_all: "49035|49049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84021,
    lat: 40.10998,
    lng: -110.51593,
    city: "Duchesne",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3793,
    density: 2.4,
    county_fips: 49013,
    county_name: "Duchesne",
    county_weights: {
      49013: 100,
    },
    county_names_all: "Duchesne",
    county_fips_all: 49013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84022,
    lat: 40.17921,
    lng: -112.81371,
    city: "Dugway",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 672,
    density: 1.8,
    county_fips: 49045,
    county_name: "Tooele",
    county_weights: {
      49023: 24.41,
      49045: 75.59,
    },
    county_names_all: "Tooele|Juab",
    county_fips_all: "49045|49023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84023,
    lat: 40.83781,
    lng: -109.20665,
    city: "Dutch John",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 167,
    density: 0.4,
    county_fips: 49009,
    county_name: "Daggett",
    county_weights: {
      49009: 100,
    },
    county_names_all: "Daggett",
    county_fips_all: 49009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84024,
    lat: 41.00765,
    lng: -111.44721,
    city: "Echo",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44,
    density: 2.2,
    county_fips: 49043,
    county_name: "Summit",
    county_weights: {
      49043: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 49043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84025,
    lat: 40.97667,
    lng: -111.89874,
    city: "Farmington",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24497,
    density: 664.8,
    county_fips: 49011,
    county_name: "Davis",
    county_weights: {
      49011: 100,
    },
    county_names_all: "Davis",
    county_fips_all: 49011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84026,
    lat: 40.29122,
    lng: -109.83882,
    city: "Fort Duchesne",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1306,
    density: 13.6,
    county_fips: 49047,
    county_name: "Uintah",
    county_weights: {
      49047: 100,
    },
    county_names_all: "Uintah",
    county_fips_all: 49047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84027,
    lat: 40.15643,
    lng: -110.79453,
    city: "Fruitland",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 587,
    density: 1,
    county_fips: 49013,
    county_name: "Duchesne",
    county_weights: {
      49013: 100,
    },
    county_names_all: "Duchesne",
    county_fips_all: 49013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84028,
    lat: 41.93107,
    lng: -111.38267,
    city: "Garden City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 573,
    density: 4.5,
    county_fips: 49033,
    county_name: "Rich",
    county_weights: {
      49033: 100,
    },
    county_names_all: "Rich",
    county_fips_all: 49033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84029,
    lat: 40.6483,
    lng: -112.98298,
    city: "Grantsville",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11844,
    density: 3.5,
    county_fips: 49045,
    county_name: "Tooele",
    county_weights: {
      49003: 0.36,
      49045: 99.64,
    },
    county_names_all: "Tooele|Box Elder",
    county_fips_all: "49045|49003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84031,
    lat: 40.60493,
    lng: -110.63735,
    city: "Hanna",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 210,
    density: 0.1,
    county_fips: 49013,
    county_name: "Duchesne",
    county_weights: {
      49013: 100,
    },
    county_names_all: "Duchesne",
    county_fips_all: 49013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84032,
    lat: 40.35839,
    lng: -111.188,
    city: "Heber City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24229,
    density: 28.5,
    county_fips: 49051,
    county_name: "Wasatch",
    county_weights: {
      49051: 100,
    },
    county_names_all: "Wasatch",
    county_fips_all: 49051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84033,
    lat: 40.98002,
    lng: -111.49148,
    city: "Henefer",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1156,
    density: 6.2,
    county_fips: 49043,
    county_name: "Summit",
    county_weights: {
      49043: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 49043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84034,
    lat: 39.99427,
    lng: -113.9575,
    city: "Ibapah",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 206,
    density: 0.2,
    county_fips: 49045,
    county_name: "Tooele",
    county_weights: {
      32033: 9.2,
      49023: 21.01,
      49045: 69.79,
    },
    county_names_all: "Tooele|Juab|White Pine",
    county_fips_all: "49045|49023|32033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84035,
    lat: 40.39024,
    lng: -109.28208,
    city: "Jensen",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 343,
    density: 0.6,
    county_fips: 49047,
    county_name: "Uintah",
    county_weights: {
      49047: 100,
    },
    county_names_all: "Uintah",
    county_fips_all: 49047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84036,
    lat: 40.66022,
    lng: -111.1093,
    city: "Kamas",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7754,
    density: 9,
    county_fips: 49043,
    county_name: "Summit",
    county_weights: {
      49043: 71.82,
      49051: 28.18,
    },
    county_names_all: "Summit|Wasatch",
    county_fips_all: "49043|49051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84037,
    lat: 40.99281,
    lng: -111.91444,
    city: "Kaysville",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39119,
    density: 310.8,
    county_fips: 49011,
    county_name: "Davis",
    county_weights: {
      49011: 100,
    },
    county_names_all: "Davis",
    county_fips_all: 49011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84038,
    lat: 41.87926,
    lng: -111.29692,
    city: "Laketown",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 407,
    density: 2.4,
    county_fips: 49033,
    county_name: "Rich",
    county_weights: {
      49033: 100,
    },
    county_names_all: "Rich",
    county_fips_all: 49033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84039,
    lat: 40.44602,
    lng: -109.80972,
    city: "Lapoint",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 664,
    density: 2.9,
    county_fips: 49047,
    county_name: "Uintah",
    county_weights: {
      49047: 100,
    },
    county_names_all: "Uintah",
    county_fips_all: 49047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84040,
    lat: 41.09121,
    lng: -111.89674,
    city: "Layton",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25376,
    density: 404.1,
    county_fips: 49011,
    county_name: "Davis",
    county_weights: {
      49011: 100,
    },
    county_names_all: "Davis",
    county_fips_all: 49011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84041,
    lat: 41.07137,
    lng: -111.98416,
    city: "Layton",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51512,
    density: 1332.2,
    county_fips: 49011,
    county_name: "Davis",
    county_weights: {
      49011: 100,
    },
    county_names_all: "Davis",
    county_fips_all: 49011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84042,
    lat: 40.34113,
    lng: -111.72466,
    city: "Lindon",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11135,
    density: 542.2,
    county_fips: 49049,
    county_name: "Utah",
    county_weights: {
      49049: 100,
    },
    county_names_all: "Utah",
    county_fips_all: 49049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84043,
    lat: 40.41209,
    lng: -111.87377,
    city: "Lehi",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67436,
    density: 836.2,
    county_fips: 49049,
    county_name: "Utah",
    county_weights: {
      49049: 100,
    },
    county_names_all: "Utah",
    county_fips_all: 49049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84044,
    lat: 40.73,
    lng: -112.1474,
    city: "Magna",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27029,
    density: 142.4,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84045,
    lat: 40.28574,
    lng: -111.91384,
    city: "Saratoga Springs",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31199,
    density: 231.9,
    county_fips: 49049,
    county_name: "Utah",
    county_weights: {
      49049: 100,
    },
    county_names_all: "Utah",
    county_fips_all: 49049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84046,
    lat: 40.95339,
    lng: -109.82786,
    city: "Manila",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 412,
    density: 1.4,
    county_fips: 49009,
    county_name: "Daggett",
    county_weights: {
      49009: 100,
    },
    county_names_all: "Daggett",
    county_fips_all: 49009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84047,
    lat: 40.61533,
    lng: -111.89176,
    city: "Midvale",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33454,
    density: 2023.6,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84049,
    lat: 40.5136,
    lng: -111.51657,
    city: "Midway",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5883,
    density: 30.4,
    county_fips: 49051,
    county_name: "Wasatch",
    county_weights: {
      49051: 100,
    },
    county_names_all: "Wasatch",
    county_fips_all: 49051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84050,
    lat: 41.02244,
    lng: -111.67229,
    city: "Morgan",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11666,
    density: 11.6,
    county_fips: 49029,
    county_name: "Morgan",
    county_weights: {
      49029: 100,
    },
    county_names_all: "Morgan",
    county_fips_all: 49029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84051,
    lat: 40.39552,
    lng: -110.43131,
    city: "Mountain Home",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 547,
    density: 4.2,
    county_fips: 49013,
    county_name: "Duchesne",
    county_weights: {
      49013: 100,
    },
    county_names_all: "Duchesne",
    county_fips_all: 49013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84052,
    lat: 40.16829,
    lng: -109.99089,
    city: "Myton",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1457,
    density: 3.9,
    county_fips: 49013,
    county_name: "Duchesne",
    county_weights: {
      49013: 53.72,
      49047: 46.28,
    },
    county_names_all: "Duchesne|Uintah",
    county_fips_all: "49013|49047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84053,
    lat: 40.43325,
    lng: -109.98941,
    city: "Neola",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1133,
    density: 14,
    county_fips: 49013,
    county_name: "Duchesne",
    county_weights: {
      49013: 67.27,
      49047: 32.73,
    },
    county_names_all: "Duchesne|Uintah",
    county_fips_all: "49013|49047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84054,
    lat: 40.84078,
    lng: -111.91754,
    city: "North Salt Lake",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20516,
    density: 924.2,
    county_fips: 49011,
    county_name: "Davis",
    county_weights: {
      49011: 100,
    },
    county_names_all: "Davis",
    county_fips_all: 49011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84055,
    lat: 40.71889,
    lng: -111.16106,
    city: "Oakley",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1503,
    density: 4.6,
    county_fips: 49043,
    county_name: "Summit",
    county_weights: {
      49043: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 49043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84056,
    lat: 41.12679,
    lng: -111.99084,
    city: "Hill Afb",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3568,
    density: 142.9,
    county_fips: 49011,
    county_name: "Davis",
    county_weights: {
      49011: 100,
    },
    county_names_all: "Davis",
    county_fips_all: 49011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84057,
    lat: 40.31427,
    lng: -111.70948,
    city: "Orem",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40565,
    density: 2542.3,
    county_fips: 49049,
    county_name: "Utah",
    county_weights: {
      49049: 100,
    },
    county_names_all: "Utah",
    county_fips_all: 49049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84058,
    lat: 40.27474,
    lng: -111.71468,
    city: "Orem",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42952,
    density: 2065.8,
    county_fips: 49049,
    county_name: "Utah",
    county_weights: {
      49049: 100,
    },
    county_names_all: "Utah",
    county_fips_all: 49049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84059,
    lat: 40.30353,
    lng: -111.74853,
    city: "Vineyard",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 49049,
    county_name: "Utah",
    county_weights: {
      49049: 100,
    },
    county_names_all: "Utah",
    county_fips_all: 49049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84060,
    lat: 40.6418,
    lng: -111.50332,
    city: "Park City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8684,
    density: 76.5,
    county_fips: 49043,
    county_name: "Summit",
    county_weights: {
      49043: 75.57,
      49051: 24.43,
    },
    county_names_all: "Summit|Wasatch",
    county_fips_all: "49043|49051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84061,
    lat: 40.74721,
    lng: -111.3417,
    city: "Peoa",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 292,
    density: 2.1,
    county_fips: 49043,
    county_name: "Summit",
    county_weights: {
      49043: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 49043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84062,
    lat: 40.38586,
    lng: -111.68421,
    city: "Pleasant Grove",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47591,
    density: 362.4,
    county_fips: 49049,
    county_name: "Utah",
    county_weights: {
      49049: 100,
    },
    county_names_all: "Utah",
    county_fips_all: 49049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84063,
    lat: 40.21007,
    lng: -109.69285,
    city: "Randlett",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 152,
    density: 0.7,
    county_fips: 49047,
    county_name: "Uintah",
    county_weights: {
      49047: 100,
    },
    county_names_all: "Uintah",
    county_fips_all: 49047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84064,
    lat: 41.67086,
    lng: -111.12293,
    city: "Randolph",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1007,
    density: 2.2,
    county_fips: 49033,
    county_name: "Rich",
    county_weights: {
      49033: 100,
    },
    county_names_all: "Rich",
    county_fips_all: 49033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84065,
    lat: 40.495,
    lng: -111.9444,
    city: "Riverton",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46338,
    density: 866.7,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84066,
    lat: 40.34671,
    lng: -110.05171,
    city: "Roosevelt",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12573,
    density: 20.2,
    county_fips: 49013,
    county_name: "Duchesne",
    county_weights: {
      49013: 78.95,
      49047: 21.05,
    },
    county_names_all: "Duchesne|Uintah",
    county_fips_all: "49013|49047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84067,
    lat: 41.17189,
    lng: -112.04803,
    city: "Roy",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40009,
    density: 1883.8,
    county_fips: 49057,
    county_name: "Weber",
    county_weights: {
      49057: 100,
    },
    county_names_all: "Weber",
    county_fips_all: 49057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84069,
    lat: 40.36521,
    lng: -112.48548,
    city: "Rush Valley",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 479,
    density: 3.3,
    county_fips: 49045,
    county_name: "Tooele",
    county_weights: {
      49045: 100,
    },
    county_names_all: "Tooele",
    county_fips_all: 49045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84070,
    lat: 40.57707,
    lng: -111.88916,
    city: "Sandy",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30595,
    density: 1609.9,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84071,
    lat: 40.4191,
    lng: -112.32475,
    city: "Stockton",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1806,
    density: 5.7,
    county_fips: 49045,
    county_name: "Tooele",
    county_weights: {
      49045: 100,
    },
    county_names_all: "Tooele",
    county_fips_all: 49045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84072,
    lat: 40.3641,
    lng: -110.633,
    city: "Tabiona",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 340,
    density: 0.8,
    county_fips: 49013,
    county_name: "Duchesne",
    county_weights: {
      49013: 100,
    },
    county_names_all: "Duchesne",
    county_fips_all: 49013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84073,
    lat: 40.3456,
    lng: -110.41394,
    city: "Talmage",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 271,
    density: 3.8,
    county_fips: 49013,
    county_name: "Duchesne",
    county_weights: {
      49013: 100,
    },
    county_names_all: "Duchesne",
    county_fips_all: 49013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84074,
    lat: 40.57379,
    lng: -112.29914,
    city: "Tooele",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53254,
    density: 118,
    county_fips: 49045,
    county_name: "Tooele",
    county_weights: {
      49045: 100,
    },
    county_names_all: "Tooele",
    county_fips_all: 49045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84075,
    lat: 41.05975,
    lng: -112.06933,
    city: "Syracuse",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30427,
    density: 336.2,
    county_fips: 49011,
    county_name: "Davis",
    county_weights: {
      49011: 100,
    },
    county_names_all: "Davis",
    county_fips_all: 49011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84076,
    lat: 40.44718,
    lng: -109.84017,
    city: "Tridell",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 451,
    density: 22.2,
    county_fips: 49047,
    county_name: "Uintah",
    county_weights: {
      49047: 100,
    },
    county_names_all: "Uintah",
    county_fips_all: 49047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84078,
    lat: 40.46403,
    lng: -109.5084,
    city: "Vernal",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29654,
    density: 8.6,
    county_fips: 49047,
    county_name: "Uintah",
    county_weights: {
      49047: 100,
    },
    county_names_all: "Uintah",
    county_fips_all: 49047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84080,
    lat: 40.02168,
    lng: -112.44818,
    city: "Vernon",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 349,
    density: 0.5,
    county_fips: 49045,
    county_name: "Tooele",
    county_weights: {
      49045: 100,
    },
    county_names_all: "Tooele",
    county_fips_all: 49045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84081,
    lat: 40.60275,
    lng: -112.03821,
    city: "West Jordan",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50158,
    density: 1251.8,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84082,
    lat: 40.3404,
    lng: -111.36184,
    city: "Wallsburg",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1079,
    density: 2.8,
    county_fips: 49051,
    county_name: "Wasatch",
    county_weights: {
      49051: 100,
    },
    county_names_all: "Wasatch",
    county_fips_all: 49051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84083,
    lat: 40.84354,
    lng: -113.6944,
    city: "Wendover",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1384,
    density: 0.9,
    county_fips: 49045,
    county_name: "Tooele",
    county_weights: {
      49045: 100,
    },
    county_names_all: "Tooele",
    county_fips_all: 49045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84084,
    lat: 40.62139,
    lng: -111.96603,
    city: "West Jordan",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38463,
    density: 2236.7,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84085,
    lat: 40.58609,
    lng: -109.92642,
    city: "Whiterocks",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 473,
    density: 1.9,
    county_fips: 49047,
    county_name: "Uintah",
    county_weights: {
      49047: 100,
    },
    county_names_all: "Uintah",
    county_fips_all: 49047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84086,
    lat: 41.41644,
    lng: -111.20858,
    city: "Woodruff",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 428,
    density: 1.4,
    county_fips: 49033,
    county_name: "Rich",
    county_weights: {
      49033: 100,
    },
    county_names_all: "Rich",
    county_fips_all: 49033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84087,
    lat: 40.8891,
    lng: -111.92898,
    city: "Woods Cross",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15976,
    density: 445.1,
    county_fips: 49011,
    county_name: "Davis",
    county_weights: {
      49011: 100,
    },
    county_names_all: "Davis",
    county_fips_all: 49011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84088,
    lat: 40.59507,
    lng: -111.96077,
    city: "West Jordan",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38761,
    density: 1597.4,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84092,
    lat: 40.55803,
    lng: -111.74205,
    city: "Sandy",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28699,
    density: 204.1,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84093,
    lat: 40.59473,
    lng: -111.82863,
    city: "Sandy",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24140,
    density: 1691.1,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84094,
    lat: 40.57177,
    lng: -111.86201,
    city: "Sandy",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29586,
    density: 2247.1,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84095,
    lat: 40.55856,
    lng: -111.94165,
    city: "South Jordan",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 73808,
    density: 2469.1,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84096,
    lat: 40.50539,
    lng: -112.08546,
    city: "Herriman",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53693,
    density: 291.7,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84097,
    lat: 40.3048,
    lng: -111.67318,
    city: "Orem",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22994,
    density: 1471.7,
    county_fips: 49049,
    county_name: "Utah",
    county_weights: {
      49049: 100,
    },
    county_names_all: "Utah",
    county_fips_all: 49049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84098,
    lat: 40.73988,
    lng: -111.53504,
    city: "Park City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19395,
    density: 104.3,
    county_fips: 49043,
    county_name: "Summit",
    county_weights: {
      49043: 100,
    },
    county_names_all: "Summit",
    county_fips_all: 49043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84101,
    lat: 40.75628,
    lng: -111.89996,
    city: "Salt Lake City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5202,
    density: 1088.9,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84102,
    lat: 40.75992,
    lng: -111.86367,
    city: "Salt Lake City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19016,
    density: 3801.4,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84103,
    lat: 40.8034,
    lng: -111.84708,
    city: "Salt Lake City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22881,
    density: 430.6,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84104,
    lat: 40.74846,
    lng: -111.98286,
    city: "Salt Lake City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26761,
    density: 478.8,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84105,
    lat: 40.73841,
    lng: -111.85982,
    city: "Salt Lake City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22812,
    density: 2863.4,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84106,
    lat: 40.70678,
    lng: -111.85571,
    city: "Salt Lake City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35166,
    density: 2248.7,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84107,
    lat: 40.65799,
    lng: -111.88447,
    city: "Salt Lake City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34914,
    density: 1787.8,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84108,
    lat: 40.78811,
    lng: -111.7365,
    city: "Salt Lake City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21864,
    density: 116.8,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84109,
    lat: 40.70196,
    lng: -111.7051,
    city: "Salt Lake City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25217,
    density: 170.8,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84111,
    lat: 40.75575,
    lng: -111.88431,
    city: "Salt Lake City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13030,
    density: 3697.9,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84112,
    lat: 40.7652,
    lng: -111.84123,
    city: "Salt Lake City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2402,
    density: 1047.4,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84113,
    lat: 40.76248,
    lng: -111.83291,
    city: "Salt Lake City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 190,
    density: 380.8,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84114,
    lat: 40.77794,
    lng: -111.88831,
    city: "Salt Lake City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84115,
    lat: 40.71467,
    lng: -111.89266,
    city: "Salt Lake City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27627,
    density: 1756.4,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84116,
    lat: 40.83258,
    lng: -112.01691,
    city: "Salt Lake City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34588,
    density: 265.3,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84117,
    lat: 40.66167,
    lng: -111.83561,
    city: "Salt Lake City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23799,
    density: 1636.1,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84118,
    lat: 40.65598,
    lng: -112.03812,
    city: "Salt Lake City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 71133,
    density: 2115.3,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84119,
    lat: 40.70289,
    lng: -111.94591,
    city: "West Valley City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53536,
    density: 1795.4,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84120,
    lat: 40.69686,
    lng: -112.00178,
    city: "West Valley City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51130,
    density: 1954.9,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84121,
    lat: 40.62557,
    lng: -111.69864,
    city: "Salt Lake City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39895,
    density: 239,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84123,
    lat: 40.65837,
    lng: -111.92177,
    city: "Salt Lake City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38082,
    density: 1777.3,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84124,
    lat: 40.67113,
    lng: -111.80705,
    city: "Salt Lake City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22884,
    density: 1145.2,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84128,
    lat: 40.70518,
    lng: -112.04259,
    city: "West Valley City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27921,
    density: 1286.4,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84129,
    lat: 40.6536,
    lng: -111.96209,
    city: "Salt Lake City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84138,
    lat: 40.76675,
    lng: -111.88724,
    city: "Salt Lake City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84150,
    lat: 40.77151,
    lng: -111.89107,
    city: "Salt Lake City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84180,
    lat: 40.77044,
    lng: -111.9011,
    city: "Salt Lake City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 49035,
    county_name: "Salt Lake",
    county_weights: {
      49035: 100,
    },
    county_names_all: "Salt Lake",
    county_fips_all: 49035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84301,
    lat: 41.61368,
    lng: -112.12723,
    city: "Bear River City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 721,
    density: 98.8,
    county_fips: 49003,
    county_name: "Box Elder",
    county_weights: {
      49003: 100,
    },
    county_names_all: "Box Elder",
    county_fips_all: 49003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84302,
    lat: 41.57956,
    lng: -112.04769,
    city: "Brigham City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26259,
    density: 127.5,
    county_fips: 49003,
    county_name: "Box Elder",
    county_weights: {
      49003: 100,
    },
    county_names_all: "Box Elder",
    county_fips_all: 49003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84304,
    lat: 41.82722,
    lng: -111.99867,
    city: "Cache Junction",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 120,
    density: 10.6,
    county_fips: 49005,
    county_name: "Cache",
    county_weights: {
      49003: 0.14,
      49005: 99.86,
    },
    county_names_all: "Cache|Box Elder",
    county_fips_all: "49005|49003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84305,
    lat: 41.94388,
    lng: -112.05804,
    city: "Clarkston",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 691,
    density: 4.8,
    county_fips: 49005,
    county_name: "Cache",
    county_weights: {
      49005: 100,
    },
    county_names_all: "Cache",
    county_fips_all: 49005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84306,
    lat: 41.78272,
    lng: -112.06323,
    city: "Collinston",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 269,
    density: 4.5,
    county_fips: 49003,
    county_name: "Box Elder",
    county_weights: {
      49003: 100,
    },
    county_names_all: "Box Elder",
    county_fips_all: 49003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84307,
    lat: 41.5535,
    lng: -112.49192,
    city: "Corinne",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 969,
    density: 0.6,
    county_fips: 49003,
    county_name: "Box Elder",
    county_weights: {
      49003: 100,
    },
    county_names_all: "Box Elder",
    county_fips_all: 49003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84308,
    lat: 41.9656,
    lng: -111.96681,
    city: "Cornish",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 253,
    density: 7,
    county_fips: 49005,
    county_name: "Cache",
    county_weights: {
      49005: 100,
    },
    county_names_all: "Cache",
    county_fips_all: 49005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84309,
    lat: 41.71375,
    lng: -112.09908,
    city: "Deweyville",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 396,
    density: 17.8,
    county_fips: 49003,
    county_name: "Box Elder",
    county_weights: {
      49003: 100,
    },
    county_names_all: "Box Elder",
    county_fips_all: 49003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84310,
    lat: 41.3371,
    lng: -111.84598,
    city: "Eden",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4653,
    density: 17,
    county_fips: 49057,
    county_name: "Weber",
    county_weights: {
      49057: 100,
    },
    county_names_all: "Weber",
    county_fips_all: 49057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84311,
    lat: 41.82012,
    lng: -112.1106,
    city: "Fielding",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 724,
    density: 31.3,
    county_fips: 49003,
    county_name: "Box Elder",
    county_weights: {
      49003: 100,
    },
    county_names_all: "Box Elder",
    county_fips_all: 49003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84312,
    lat: 41.77976,
    lng: -112.15681,
    city: "Garland",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4766,
    density: 74.1,
    county_fips: 49003,
    county_name: "Box Elder",
    county_weights: {
      49003: 100,
    },
    county_names_all: "Box Elder",
    county_fips_all: 49003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84313,
    lat: 41.34615,
    lng: -113.71268,
    city: "Grouse Creek",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62,
    density: 0,
    county_fips: 49003,
    county_name: "Box Elder",
    county_weights: {
      49003: 100,
    },
    county_names_all: "Box Elder",
    county_fips_all: 49003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84314,
    lat: 41.64929,
    lng: -112.09292,
    city: "Honeyville",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1211,
    density: 60.2,
    county_fips: 49003,
    county_name: "Box Elder",
    county_weights: {
      49003: 100,
    },
    county_names_all: "Box Elder",
    county_fips_all: 49003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84315,
    lat: 41.16681,
    lng: -112.13672,
    city: "Hooper",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9218,
    density: 199.4,
    county_fips: 49057,
    county_name: "Weber",
    county_weights: {
      49011: 22.13,
      49057: 77.87,
    },
    county_names_all: "Weber|Davis",
    county_fips_all: "49057|49011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84316,
    lat: 41.77328,
    lng: -112.44504,
    city: "Howell",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 347,
    density: 3.8,
    county_fips: 49003,
    county_name: "Box Elder",
    county_weights: {
      49003: 100,
    },
    county_names_all: "Box Elder",
    county_fips_all: 49003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84317,
    lat: 41.30359,
    lng: -111.62178,
    city: "Huntsville",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2536,
    density: 4.5,
    county_fips: 49057,
    county_name: "Weber",
    county_weights: {
      49057: 100,
    },
    county_names_all: "Weber",
    county_fips_all: 49057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84318,
    lat: 41.80167,
    lng: -111.80422,
    city: "Hyde Park",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4883,
    density: 338,
    county_fips: 49005,
    county_name: "Cache",
    county_weights: {
      49005: 100,
    },
    county_names_all: "Cache",
    county_fips_all: 49005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84319,
    lat: 41.59401,
    lng: -111.659,
    city: "Hyrum",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8961,
    density: 34.1,
    county_fips: 49005,
    county_name: "Cache",
    county_weights: {
      49005: 100,
    },
    county_names_all: "Cache",
    county_fips_all: 49005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84320,
    lat: 41.96011,
    lng: -111.85252,
    city: "Lewiston",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2609,
    density: 21.3,
    county_fips: 49005,
    county_name: "Cache",
    county_weights: {
      49005: 100,
    },
    county_names_all: "Cache",
    county_fips_all: 49005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84321,
    lat: 41.77938,
    lng: -111.68316,
    city: "Logan",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46634,
    density: 81.8,
    county_fips: 49005,
    county_name: "Cache",
    county_weights: {
      49005: 100,
    },
    county_names_all: "Cache",
    county_fips_all: 49005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84322,
    lat: 41.75822,
    lng: -111.81256,
    city: "Logan",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 49005,
    county_name: "Cache",
    county_weights: {
      49005: 100,
    },
    county_names_all: "Cache",
    county_fips_all: 49005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84324,
    lat: 41.49253,
    lng: -111.93868,
    city: "Mantua",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1017,
    density: 17.8,
    county_fips: 49003,
    county_name: "Box Elder",
    county_weights: {
      49003: 100,
    },
    county_names_all: "Box Elder",
    county_fips_all: 49003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84325,
    lat: 41.73869,
    lng: -111.99303,
    city: "Mendon",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2174,
    density: 19.6,
    county_fips: 49005,
    county_name: "Cache",
    county_weights: {
      49005: 100,
    },
    county_names_all: "Cache",
    county_fips_all: 49005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84326,
    lat: 41.67228,
    lng: -111.81772,
    city: "Millville",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1892,
    density: 204.2,
    county_fips: 49005,
    county_name: "Cache",
    county_weights: {
      49005: 100,
    },
    county_names_all: "Cache",
    county_fips_all: 49005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84327,
    lat: 41.86555,
    lng: -111.99512,
    city: "Newton",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 800,
    density: 18.4,
    county_fips: 49005,
    county_name: "Cache",
    county_weights: {
      49005: 100,
    },
    county_names_all: "Cache",
    county_fips_all: 49005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84328,
    lat: 41.53937,
    lng: -111.8444,
    city: "Paradise",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1440,
    density: 11.7,
    county_fips: 49005,
    county_name: "Cache",
    county_weights: {
      49005: 100,
    },
    county_names_all: "Cache",
    county_fips_all: 49005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84329,
    lat: 41.79229,
    lng: -113.47079,
    city: "Park Valley",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 127,
    density: 0.1,
    county_fips: 49003,
    county_name: "Box Elder",
    county_weights: {
      49003: 100,
    },
    county_names_all: "Box Elder",
    county_fips_all: 49003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84330,
    lat: 41.9063,
    lng: -112.17019,
    city: "Plymouth",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 380,
    density: 4.1,
    county_fips: 49003,
    county_name: "Box Elder",
    county_weights: {
      49003: 100,
    },
    county_names_all: "Box Elder",
    county_fips_all: 49003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84331,
    lat: 41.94354,
    lng: -112.35869,
    city: "Portage",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 262,
    density: 0.7,
    county_fips: 49003,
    county_name: "Box Elder",
    county_weights: {
      49003: 100,
    },
    county_names_all: "Box Elder",
    county_fips_all: 49003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84332,
    lat: 41.70313,
    lng: -111.81205,
    city: "Providence",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7945,
    density: 768,
    county_fips: 49005,
    county_name: "Cache",
    county_weights: {
      49005: 100,
    },
    county_names_all: "Cache",
    county_fips_all: 49005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84333,
    lat: 41.91008,
    lng: -111.79882,
    city: "Richmond",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2896,
    density: 48.4,
    county_fips: 49005,
    county_name: "Cache",
    county_weights: {
      49005: 100,
    },
    county_names_all: "Cache",
    county_fips_all: 49005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84334,
    lat: 41.78955,
    lng: -112.15189,
    city: "Riverside",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 212,
    density: 181.9,
    county_fips: 49003,
    county_name: "Box Elder",
    county_weights: {
      49003: 100,
    },
    county_names_all: "Box Elder",
    county_fips_all: 49003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84335,
    lat: 41.82907,
    lng: -111.88074,
    city: "Smithfield",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13713,
    density: 80.8,
    county_fips: 49005,
    county_name: "Cache",
    county_weights: {
      49005: 100,
    },
    county_names_all: "Cache",
    county_fips_all: 49005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84336,
    lat: 41.87159,
    lng: -112.74697,
    city: "Snowville",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 317,
    density: 0.3,
    county_fips: 49003,
    county_name: "Box Elder",
    county_weights: {
      49003: 100,
    },
    county_names_all: "Box Elder",
    county_fips_all: 49003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84337,
    lat: 41.69223,
    lng: -112.28486,
    city: "Tremonton",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13390,
    density: 30.8,
    county_fips: 49003,
    county_name: "Box Elder",
    county_weights: {
      49003: 100,
    },
    county_names_all: "Box Elder",
    county_fips_all: 49003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84338,
    lat: 41.91133,
    lng: -111.93527,
    city: "Trenton",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 546,
    density: 22.2,
    county_fips: 49005,
    county_name: "Cache",
    county_weights: {
      49005: 100,
    },
    county_names_all: "Cache",
    county_fips_all: 49005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84339,
    lat: 41.62546,
    lng: -111.939,
    city: "Wellsville",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5830,
    density: 36.3,
    county_fips: 49005,
    county_name: "Cache",
    county_weights: {
      49005: 100,
    },
    county_names_all: "Cache",
    county_fips_all: 49005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84340,
    lat: 41.39312,
    lng: -112.15705,
    city: "Willard",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3207,
    density: 38.5,
    county_fips: 49003,
    county_name: "Box Elder",
    county_weights: {
      49003: 100,
    },
    county_names_all: "Box Elder",
    county_fips_all: 49003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84341,
    lat: 41.77197,
    lng: -111.81128,
    city: "Logan",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24949,
    density: 901.2,
    county_fips: 49005,
    county_name: "Cache",
    county_weights: {
      49005: 100,
    },
    county_names_all: "Cache",
    county_fips_all: 49005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84401,
    lat: 41.21962,
    lng: -112.03352,
    city: "Ogden",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41324,
    density: 520.2,
    county_fips: 49057,
    county_name: "Weber",
    county_weights: {
      49057: 100,
    },
    county_names_all: "Weber",
    county_fips_all: 49057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84403,
    lat: 41.19379,
    lng: -111.9038,
    city: "Ogden",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36762,
    density: 417.3,
    county_fips: 49057,
    county_name: "Weber",
    county_weights: {
      49057: 100,
    },
    county_names_all: "Weber",
    county_fips_all: 49057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84404,
    lat: 41.27198,
    lng: -112.11705,
    city: "Ogden",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64249,
    density: 257.7,
    county_fips: 49057,
    county_name: "Weber",
    county_weights: {
      49057: 100,
    },
    county_names_all: "Weber",
    county_fips_all: 49057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84405,
    lat: 41.15747,
    lng: -111.96499,
    city: "Ogden",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33402,
    density: 697,
    county_fips: 49057,
    county_name: "Weber",
    county_weights: {
      49011: 33.79,
      49057: 66.21,
    },
    county_names_all: "Weber|Davis",
    county_fips_all: "49057|49011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84408,
    lat: 41.19252,
    lng: -111.93966,
    city: "Ogden",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 49057,
    county_name: "Weber",
    county_weights: {
      49057: 100,
    },
    county_names_all: "Weber",
    county_fips_all: 49057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84414,
    lat: 41.32578,
    lng: -111.96547,
    city: "Ogden",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31210,
    density: 554.9,
    county_fips: 49057,
    county_name: "Weber",
    county_weights: {
      49057: 100,
    },
    county_names_all: "Weber",
    county_fips_all: 49057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84501,
    lat: 39.53214,
    lng: -110.80393,
    city: "Price",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12983,
    density: 23.3,
    county_fips: 49007,
    county_name: "Carbon",
    county_weights: {
      49007: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 49007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84511,
    lat: 37.52687,
    lng: -109.42054,
    city: "Blanding",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4695,
    density: 9.9,
    county_fips: 49037,
    county_name: "San Juan",
    county_weights: {
      49037: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 49037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84512,
    lat: 37.16255,
    lng: -109.55921,
    city: "Bluff",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 822,
    density: 1.1,
    county_fips: 49037,
    county_name: "San Juan",
    county_weights: {
      49037: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 49037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84513,
    lat: 39.24932,
    lng: -111.00912,
    city: "Castle Dale",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1426,
    density: 33.2,
    county_fips: 49015,
    county_name: "Emery",
    county_weights: {
      49015: 100,
    },
    county_names_all: "Emery",
    county_fips_all: 49015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84515,
    lat: 38.96824,
    lng: -109.23876,
    city: "Cisco",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 49019,
    county_name: "Grand",
    county_weights: {
      49019: 100,
    },
    county_names_all: "Grand",
    county_fips_all: 49019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84516,
    lat: 39.12842,
    lng: -111.06703,
    city: "Clawson",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 84,
    density: 2.1,
    county_fips: 49015,
    county_name: "Emery",
    county_weights: {
      49015: 100,
    },
    county_names_all: "Emery",
    county_fips_all: 49015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84518,
    lat: 39.3917,
    lng: -110.88478,
    city: "Cleveland",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 831,
    density: 4.9,
    county_fips: 49015,
    county_name: "Emery",
    county_weights: {
      49015: 100,
    },
    county_names_all: "Emery",
    county_fips_all: 49015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84520,
    lat: 39.53392,
    lng: -110.41949,
    city: "East Carbon",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1261,
    density: 74.3,
    county_fips: 49007,
    county_name: "Carbon",
    county_weights: {
      49007: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 49007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84521,
    lat: 39.4213,
    lng: -110.78709,
    city: "Elmo",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 761,
    density: 5.9,
    county_fips: 49015,
    county_name: "Emery",
    county_weights: {
      49015: 100,
    },
    county_names_all: "Emery",
    county_fips_all: 49015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84522,
    lat: 38.90991,
    lng: -111.20987,
    city: "Emery",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 344,
    density: 1.9,
    county_fips: 49015,
    county_name: "Emery",
    county_weights: {
      49015: 100,
    },
    county_names_all: "Emery",
    county_fips_all: 49015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84523,
    lat: 39.0946,
    lng: -111.2014,
    city: "Ferron",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1719,
    density: 5.8,
    county_fips: 49015,
    county_name: "Emery",
    county_weights: {
      49015: 100,
    },
    county_names_all: "Emery",
    county_fips_all: 49015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84525,
    lat: 38.87947,
    lng: -110.33217,
    city: "Green River",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 814,
    density: 0.6,
    county_fips: 49015,
    county_name: "Emery",
    county_weights: {
      49015: 79.72,
      49019: 20.28,
    },
    county_names_all: "Emery|Grand",
    county_fips_all: "49015|49019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84526,
    lat: 39.72395,
    lng: -111.04571,
    city: "Helper",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4114,
    density: 8.2,
    county_fips: 49007,
    county_name: "Carbon",
    county_weights: {
      49007: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 49007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84528,
    lat: 39.43404,
    lng: -111.08778,
    city: "Huntington",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2867,
    density: 4.5,
    county_fips: 49015,
    county_name: "Emery",
    county_weights: {
      49015: 100,
    },
    county_names_all: "Emery",
    county_fips_all: 49015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84529,
    lat: 39.71151,
    lng: -110.7733,
    city: "Kenilworth",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 49007,
    county_name: "Carbon",
    county_weights: {
      49007: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 49007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84530,
    lat: 38.23736,
    lng: -109.40846,
    city: "La Sal",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 255,
    density: 0.1,
    county_fips: 49037,
    county_name: "San Juan",
    county_weights: {
      49037: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 49037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84531,
    lat: 37.0683,
    lng: -109.86371,
    city: "Mexican Hat",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 776,
    density: 1.1,
    county_fips: 49037,
    county_name: "San Juan",
    county_weights: {
      49037: 78.79,
      "04001": 21.21,
    },
    county_names_all: "San Juan|Apache",
    county_fips_all: "49037|04001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84532,
    lat: 38.53898,
    lng: -109.45916,
    city: "Moab",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10103,
    density: 2.5,
    county_fips: 49019,
    county_name: "Grand",
    county_weights: {
      49019: 55.97,
      49037: 44.03,
    },
    county_names_all: "Grand|San Juan",
    county_fips_all: "49019|49037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84533,
    lat: 37.40827,
    lng: -110.56844,
    city: "Lake Powell",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 105,
    density: 0,
    county_fips: 49037,
    county_name: "San Juan",
    county_weights: {
      49025: 31.45,
      49037: 68.55,
    },
    county_names_all: "San Juan|Kane",
    county_fips_all: "49037|49025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84534,
    lat: 37.21283,
    lng: -109.26826,
    city: "Montezuma Creek",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2714,
    density: 2.2,
    county_fips: 49037,
    county_name: "San Juan",
    county_weights: {
      49037: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 49037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84535,
    lat: 37.84244,
    lng: -109.28673,
    city: "Monticello",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3354,
    density: 1.4,
    county_fips: 49037,
    county_name: "San Juan",
    county_weights: {
      49037: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 49037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84536,
    lat: 37.14017,
    lng: -110.23104,
    city: "Monument Valley",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1239,
    density: 0.8,
    county_fips: 49037,
    county_name: "San Juan",
    county_weights: {
      49037: 97.26,
      "04017": 2.74,
    },
    county_names_all: "San Juan|Navajo",
    county_fips_all: "49037|04017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84537,
    lat: 39.29966,
    lng: -111.17345,
    city: "Orangeville",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1253,
    density: 3.9,
    county_fips: 49015,
    county_name: "Emery",
    county_weights: {
      49015: 100,
    },
    county_names_all: "Emery",
    county_fips_all: 49015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84539,
    lat: 39.5761,
    lng: -110.4007,
    city: "Sunnyside",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 328,
    density: 13,
    county_fips: 49007,
    county_name: "Carbon",
    county_weights: {
      49007: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 49007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84540,
    lat: 39.20039,
    lng: -109.55281,
    city: "Thompson",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 99,
    density: 0,
    county_fips: 49019,
    county_name: "Grand",
    county_weights: {
      49019: 100,
    },
    county_names_all: "Grand",
    county_fips_all: 49019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84542,
    lat: 39.64433,
    lng: -110.59916,
    city: "Wellington",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1596,
    density: 37.5,
    county_fips: 49007,
    county_name: "Carbon",
    county_weights: {
      49007: 100,
    },
    county_names_all: "Carbon",
    county_fips_all: 49007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84601,
    lat: 40.22593,
    lng: -111.6955,
    city: "Provo",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33771,
    density: 979.9,
    county_fips: 49049,
    county_name: "Utah",
    county_weights: {
      49049: 100,
    },
    county_names_all: "Utah",
    county_fips_all: 49049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84602,
    lat: 40.25412,
    lng: -111.65009,
    city: "Provo",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 49049,
    county_name: "Utah",
    county_weights: {
      49049: 100,
    },
    county_names_all: "Utah",
    county_fips_all: 49049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84604,
    lat: 40.3313,
    lng: -111.57284,
    city: "Provo",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46099,
    density: 187.7,
    county_fips: 49049,
    county_name: "Utah",
    county_weights: {
      49049: 88.33,
      49051: 11.67,
    },
    county_names_all: "Utah|Wasatch",
    county_fips_all: "49049|49051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84606,
    lat: 40.2149,
    lng: -111.62619,
    city: "Provo",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37351,
    density: 1245.7,
    county_fips: 49049,
    county_name: "Utah",
    county_weights: {
      49049: 100,
    },
    county_names_all: "Utah",
    county_fips_all: 49049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84620,
    lat: 38.92244,
    lng: -111.92427,
    city: "Aurora",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 916,
    density: 17.8,
    county_fips: 49041,
    county_name: "Sevier",
    county_weights: {
      49041: 100,
    },
    county_names_all: "Sevier",
    county_fips_all: 49041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84621,
    lat: 39.05109,
    lng: -111.82959,
    city: "Axtell",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 111,
    density: 7.4,
    county_fips: 49039,
    county_name: "Sanpete",
    county_weights: {
      49039: 99.7,
      49041: 0.3,
    },
    county_names_all: "Sanpete|Sevier",
    county_fips_all: "49039|49041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84622,
    lat: 39.09816,
    lng: -111.81353,
    city: "Centerfield",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1604,
    density: 33.4,
    county_fips: 49039,
    county_name: "Sanpete",
    county_weights: {
      49039: 100,
    },
    county_names_all: "Sanpete",
    county_fips_all: 49039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84623,
    lat: 39.45608,
    lng: -111.59063,
    city: "Chester",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 454,
    density: 10.5,
    county_fips: 49039,
    county_name: "Sanpete",
    county_weights: {
      49039: 100,
    },
    county_names_all: "Sanpete",
    county_fips_all: 49039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84624,
    lat: 39.38429,
    lng: -112.58756,
    city: "Delta",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5641,
    density: 7.3,
    county_fips: 49027,
    county_name: "Millard",
    county_weights: {
      49027: 100,
    },
    county_names_all: "Millard",
    county_fips_all: 49027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84626,
    lat: 39.93359,
    lng: -111.98545,
    city: "Elberta",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 466,
    density: 1.7,
    county_fips: 49049,
    county_name: "Utah",
    county_weights: {
      49049: 100,
    },
    county_names_all: "Utah",
    county_fips_all: 49049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84627,
    lat: 39.35515,
    lng: -111.58457,
    city: "Ephraim",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7563,
    density: 67.1,
    county_fips: 49039,
    county_name: "Sanpete",
    county_weights: {
      49039: 100,
    },
    county_names_all: "Sanpete",
    county_fips_all: 49039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84628,
    lat: 39.93583,
    lng: -112.13419,
    city: "Eureka",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 669,
    density: 24.9,
    county_fips: 49023,
    county_name: "Juab",
    county_weights: {
      49023: 100,
    },
    county_names_all: "Juab",
    county_fips_all: 49023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84629,
    lat: 39.76574,
    lng: -111.44752,
    city: "Fairview",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3309,
    density: 5.3,
    county_fips: 49039,
    county_name: "Sanpete",
    county_weights: {
      49039: 67.22,
      49049: 32.78,
    },
    county_names_all: "Sanpete|Utah",
    county_fips_all: "49039|49049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84630,
    lat: 39.31069,
    lng: -111.8342,
    city: "Fayette",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 522,
    density: 3.8,
    county_fips: 49039,
    county_name: "Sanpete",
    county_weights: {
      49039: 100,
    },
    county_names_all: "Sanpete",
    county_fips_all: 49039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84631,
    lat: 38.99771,
    lng: -112.39675,
    city: "Fillmore",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2912,
    density: 8.9,
    county_fips: 49027,
    county_name: "Millard",
    county_weights: {
      49027: 100,
    },
    county_names_all: "Millard",
    county_fips_all: 49027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84632,
    lat: 39.64498,
    lng: -111.64649,
    city: "Fountain Green",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1158,
    density: 11.7,
    county_fips: 49039,
    county_name: "Sanpete",
    county_weights: {
      49039: 100,
    },
    county_names_all: "Sanpete",
    county_fips_all: 49039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84633,
    lat: 39.94026,
    lng: -111.89281,
    city: "Goshen",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1032,
    density: 16,
    county_fips: 49049,
    county_name: "Utah",
    county_weights: {
      49049: 100,
    },
    county_names_all: "Utah",
    county_fips_all: 49049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84634,
    lat: 39.18028,
    lng: -111.83561,
    city: "Gunnison",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3657,
    density: 20.4,
    county_fips: 49039,
    county_name: "Sanpete",
    county_weights: {
      49039: 100,
    },
    county_names_all: "Sanpete",
    county_fips_all: 49039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84635,
    lat: 39.39181,
    lng: -112.72132,
    city: "Hinckley",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 927,
    density: 11.4,
    county_fips: 49027,
    county_name: "Millard",
    county_weights: {
      49027: 100,
    },
    county_names_all: "Millard",
    county_fips_all: 49027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84636,
    lat: 39.13961,
    lng: -112.3389,
    city: "Holden",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 578,
    density: 3.4,
    county_fips: 49027,
    county_name: "Millard",
    county_weights: {
      49027: 100,
    },
    county_names_all: "Millard",
    county_fips_all: 49027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84637,
    lat: 38.72183,
    lng: -112.48706,
    city: "Kanosh",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 796,
    density: 2.4,
    county_fips: 49027,
    county_name: "Millard",
    county_weights: {
      49027: 100,
    },
    county_names_all: "Millard",
    county_fips_all: 49027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84638,
    lat: 39.50192,
    lng: -112.25773,
    city: "Leamington",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 362,
    density: 3.1,
    county_fips: 49027,
    county_name: "Millard",
    county_weights: {
      49027: 100,
    },
    county_names_all: "Millard",
    county_fips_all: 49027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84639,
    lat: 39.51071,
    lng: -111.90225,
    city: "Levan",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 908,
    density: 1.6,
    county_fips: 49023,
    county_name: "Juab",
    county_weights: {
      49023: 100,
    },
    county_names_all: "Juab",
    county_fips_all: 49023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84640,
    lat: 39.47622,
    lng: -112.39942,
    city: "Lynndyl",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 127,
    density: 0.7,
    county_fips: 49027,
    county_name: "Millard",
    county_weights: {
      49027: 100,
    },
    county_names_all: "Millard",
    county_fips_all: 49027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84642,
    lat: 39.20135,
    lng: -111.60893,
    city: "Manti",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3790,
    density: 11.7,
    county_fips: 49039,
    county_name: "Sanpete",
    county_weights: {
      49039: 100,
    },
    county_names_all: "Sanpete",
    county_fips_all: 49039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84643,
    lat: 39.12873,
    lng: -111.68485,
    city: "Mayfield",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 507,
    density: 4.1,
    county_fips: 49039,
    county_name: "Sanpete",
    county_weights: {
      49039: 100,
    },
    county_names_all: "Sanpete",
    county_fips_all: 49039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84644,
    lat: 38.87008,
    lng: -112.37511,
    city: "Meadow",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 49027,
    county_name: "Millard",
    county_weights: {
      49027: 100,
    },
    county_names_all: "Millard",
    county_fips_all: 49027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84645,
    lat: 39.85159,
    lng: -111.83946,
    city: "Mona",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3204,
    density: 15.8,
    county_fips: 49023,
    county_name: "Juab",
    county_weights: {
      49023: 100,
    },
    county_names_all: "Juab",
    county_fips_all: 49023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84646,
    lat: 39.54565,
    lng: -111.61121,
    city: "Moroni",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1592,
    density: 13.9,
    county_fips: 49039,
    county_name: "Sanpete",
    county_weights: {
      49039: 100,
    },
    county_names_all: "Sanpete",
    county_fips_all: 49039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84647,
    lat: 39.52708,
    lng: -111.40658,
    city: "Mount Pleasant",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4063,
    density: 15.2,
    county_fips: 49039,
    county_name: "Sanpete",
    county_weights: {
      49039: 100,
    },
    county_names_all: "Sanpete",
    county_fips_all: 49039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84648,
    lat: 39.68659,
    lng: -111.86819,
    city: "Nephi",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6659,
    density: 15.3,
    county_fips: 49023,
    county_name: "Juab",
    county_weights: {
      49023: 100,
    },
    county_names_all: "Juab",
    county_fips_all: 49023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84649,
    lat: 39.34661,
    lng: -112.32992,
    city: "Oak City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1047,
    density: 2.7,
    county_fips: 49027,
    county_name: "Millard",
    county_weights: {
      49027: 100,
    },
    county_names_all: "Millard",
    county_fips_all: 49027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84651,
    lat: 39.95633,
    lng: -111.69342,
    city: "Payson",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27142,
    density: 82.7,
    county_fips: 49049,
    county_name: "Utah",
    county_weights: {
      49049: 100,
    },
    county_names_all: "Utah",
    county_fips_all: 49049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84652,
    lat: 39.01706,
    lng: -111.8785,
    city: "Redmond",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 770,
    density: 20,
    county_fips: 49041,
    county_name: "Sevier",
    county_weights: {
      49041: 100,
    },
    county_names_all: "Sevier",
    county_fips_all: 49041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84653,
    lat: 40.04803,
    lng: -111.66804,
    city: "Salem",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9481,
    density: 228,
    county_fips: 49049,
    county_name: "Utah",
    county_weights: {
      49049: 100,
    },
    county_names_all: "Utah",
    county_fips_all: 49049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84654,
    lat: 38.89144,
    lng: -111.64442,
    city: "Salina",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2886,
    density: 4.3,
    county_fips: 49041,
    county_name: "Sevier",
    county_weights: {
      49041: 100,
    },
    county_names_all: "Sevier",
    county_fips_all: 49041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84655,
    lat: 39.97427,
    lng: -111.80716,
    city: "Santaquin",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13877,
    density: 115.8,
    county_fips: 49049,
    county_name: "Utah",
    county_weights: {
      49049: 100,
    },
    county_names_all: "Utah",
    county_fips_all: 49049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84656,
    lat: 39.23513,
    lng: -112.1088,
    city: "Scipio",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 367,
    density: 37.3,
    county_fips: 49027,
    county_name: "Millard",
    county_weights: {
      49027: 100,
    },
    county_names_all: "Millard",
    county_fips_all: 49027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84657,
    lat: 38.81817,
    lng: -111.94022,
    city: "Sigurd",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 430,
    density: 6.9,
    county_fips: 49041,
    county_name: "Sevier",
    county_weights: {
      49041: 100,
    },
    county_names_all: "Sevier",
    county_fips_all: 49041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84660,
    lat: 40.00724,
    lng: -111.4268,
    city: "Spanish Fork",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42535,
    density: 45.3,
    county_fips: 49049,
    county_name: "Utah",
    county_weights: {
      49049: 100,
    },
    county_names_all: "Utah",
    county_fips_all: 49049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84662,
    lat: 39.43978,
    lng: -111.48573,
    city: "Spring City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1477,
    density: 8.4,
    county_fips: 49039,
    county_name: "Sanpete",
    county_weights: {
      49039: 100,
    },
    county_names_all: "Sanpete",
    county_fips_all: 49039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84663,
    lat: 40.19266,
    lng: -111.48917,
    city: "Springville",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34642,
    density: 122,
    county_fips: 49049,
    county_name: "Utah",
    county_weights: {
      49049: 100,
    },
    county_names_all: "Utah",
    county_fips_all: 49049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84664,
    lat: 40.12627,
    lng: -111.57712,
    city: "Mapleton",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9994,
    density: 385.7,
    county_fips: 49049,
    county_name: "Utah",
    county_weights: {
      49049: 100,
    },
    county_names_all: "Utah",
    county_fips_all: 49049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84665,
    lat: 39.19527,
    lng: -111.66109,
    city: "Sterling",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 683,
    density: 12.2,
    county_fips: 49039,
    county_name: "Sanpete",
    county_weights: {
      49039: 100,
    },
    county_names_all: "Sanpete",
    county_fips_all: 49039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84667,
    lat: 39.48926,
    lng: -111.65115,
    city: "Wales",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 418,
    density: 8.5,
    county_fips: 49039,
    county_name: "Sanpete",
    county_weights: {
      49039: 100,
    },
    county_names_all: "Sanpete",
    county_fips_all: 49039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84701,
    lat: 38.69586,
    lng: -111.90474,
    city: "Richfield",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8877,
    density: 15,
    county_fips: 49041,
    county_name: "Sevier",
    county_weights: {
      49041: 100,
    },
    county_names_all: "Sevier",
    county_fips_all: 49041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84710,
    lat: 37.46925,
    lng: -112.51251,
    city: "Alton",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 363,
    density: 1.8,
    county_fips: 49025,
    county_name: "Kane",
    county_weights: {
      49025: 100,
    },
    county_names_all: "Kane",
    county_fips_all: 49025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84711,
    lat: 38.71294,
    lng: -112.0606,
    city: "Annabella",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 826,
    density: 63.1,
    county_fips: 49041,
    county_name: "Sevier",
    county_weights: {
      49041: 100,
    },
    county_names_all: "Sevier",
    county_fips_all: 49041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84712,
    lat: 38.14076,
    lng: -111.97783,
    city: "Antimony",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 111,
    density: 0.3,
    county_fips: 49031,
    county_name: "Piute",
    county_weights: {
      49017: 37.58,
      49031: 62.42,
    },
    county_names_all: "Piute|Garfield",
    county_fips_all: "49031|49017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84713,
    lat: 38.3292,
    lng: -112.54441,
    city: "Beaver",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3480,
    density: 8.6,
    county_fips: 49001,
    county_name: "Beaver",
    county_weights: {
      49001: 100,
    },
    county_names_all: "Beaver",
    county_fips_all: 49001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84714,
    lat: 37.84815,
    lng: -113.75547,
    city: "Beryl",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 631,
    density: 0.6,
    county_fips: 49021,
    county_name: "Iron",
    county_weights: {
      49021: 100,
    },
    county_names_all: "Iron",
    county_fips_all: 49021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84715,
    lat: 38.33221,
    lng: -111.60317,
    city: "Bicknell",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 316,
    density: 4,
    county_fips: 49055,
    county_name: "Wayne",
    county_weights: {
      49055: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 49055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84716,
    lat: 37.97152,
    lng: -111.4493,
    city: "Boulder",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 471,
    density: 0.7,
    county_fips: 49017,
    county_name: "Garfield",
    county_weights: {
      49017: 100,
    },
    county_names_all: "Garfield",
    county_fips_all: 49017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84718,
    lat: 37.57954,
    lng: -112.08306,
    city: "Cannonville",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 350,
    density: 8.4,
    county_fips: 49017,
    county_name: "Garfield",
    county_weights: {
      49017: 100,
    },
    county_names_all: "Garfield",
    county_fips_all: 49017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84719,
    lat: 37.65532,
    lng: -112.76974,
    city: "Brian Head",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43,
    density: 0.2,
    county_fips: 49021,
    county_name: "Iron",
    county_weights: {
      49021: 100,
    },
    county_names_all: "Iron",
    county_fips_all: 49021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84720,
    lat: 37.55477,
    lng: -113.25665,
    city: "Cedar City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22132,
    density: 25,
    county_fips: 49021,
    county_name: "Iron",
    county_weights: {
      49021: 69.02,
      49053: 30.98,
    },
    county_names_all: "Iron|Washington",
    county_fips_all: "49021|49053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84721,
    lat: 37.77021,
    lng: -113.13308,
    city: "Cedar City",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25286,
    density: 52.2,
    county_fips: 49021,
    county_name: "Iron",
    county_weights: {
      49021: 100,
    },
    county_names_all: "Iron",
    county_fips_all: 49021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84722,
    lat: 37.48553,
    lng: -113.57582,
    city: "Central",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 940,
    density: 3.6,
    county_fips: 49053,
    county_name: "Washington",
    county_weights: {
      49053: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 49053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84723,
    lat: 38.17611,
    lng: -112.2519,
    city: "Circleville",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 880,
    density: 24.1,
    county_fips: 49031,
    county_name: "Piute",
    county_weights: {
      49031: 100,
    },
    county_names_all: "Piute",
    county_fips_all: 49031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84724,
    lat: 38.67417,
    lng: -112.15015,
    city: "Elsinore",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1110,
    density: 105.2,
    county_fips: 49041,
    county_name: "Sevier",
    county_weights: {
      49041: 100,
    },
    county_names_all: "Sevier",
    county_fips_all: 49041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84725,
    lat: 37.53928,
    lng: -113.78042,
    city: "Enterprise",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1602,
    density: 4.1,
    county_fips: 49053,
    county_name: "Washington",
    county_weights: {
      49053: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 49053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84726,
    lat: 37.7514,
    lng: -111.57911,
    city: "Escalante",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 764,
    density: 0.9,
    county_fips: 49017,
    county_name: "Garfield",
    county_weights: {
      49017: 100,
    },
    county_names_all: "Garfield",
    county_fips_all: 49017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84728,
    lat: 39.23887,
    lng: -113.95719,
    city: "Garrison",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46,
    density: 0.1,
    county_fips: 49027,
    county_name: "Millard",
    county_weights: {
      49027: 100,
    },
    county_names_all: "Millard",
    county_fips_all: 49027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84729,
    lat: 37.35858,
    lng: -112.61527,
    city: "Glendale",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 427,
    density: 2.1,
    county_fips: 49025,
    county_name: "Kane",
    county_weights: {
      49025: 100,
    },
    county_names_all: "Kane",
    county_fips_all: 49025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84730,
    lat: 38.74504,
    lng: -112.00084,
    city: "Glenwood",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 435,
    density: 12.9,
    county_fips: 49041,
    county_name: "Sevier",
    county_weights: {
      49041: 100,
    },
    county_names_all: "Sevier",
    county_fips_all: 49041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84731,
    lat: 38.19714,
    lng: -112.76195,
    city: "Greenville",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 78,
    density: 0.3,
    county_fips: 49001,
    county_name: "Beaver",
    county_weights: {
      49001: 100,
    },
    county_names_all: "Beaver",
    county_fips_all: 49001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84732,
    lat: 38.4453,
    lng: -111.90408,
    city: "Greenwich",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45,
    density: 1.7,
    county_fips: 49031,
    county_name: "Piute",
    county_weights: {
      49031: 100,
    },
    county_names_all: "Piute",
    county_fips_all: 49031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84733,
    lat: 37.29597,
    lng: -113.79775,
    city: "Gunlock",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 160,
    density: 1,
    county_fips: 49053,
    county_name: "Washington",
    county_weights: {
      49053: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 49053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84734,
    lat: 38.36353,
    lng: -110.5658,
    city: "Hanksville",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 315,
    density: 0.3,
    county_fips: 49055,
    county_name: "Wayne",
    county_weights: {
      49055: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 49055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84735,
    lat: 37.64627,
    lng: -112.44997,
    city: "Hatch",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 171,
    density: 0.5,
    county_fips: 49017,
    county_name: "Garfield",
    county_weights: {
      49017: 100,
    },
    county_names_all: "Garfield",
    county_fips_all: 49017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84736,
    lat: 37.63732,
    lng: -111.7938,
    city: "Henrieville",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 49017,
    county_name: "Garfield",
    county_weights: {
      49017: 100,
    },
    county_names_all: "Garfield",
    county_fips_all: 49017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84737,
    lat: 37.08321,
    lng: -113.26032,
    city: "Hurricane",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19316,
    density: 29.8,
    county_fips: 49053,
    county_name: "Washington",
    county_weights: {
      49053: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 49053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84738,
    lat: 37.20987,
    lng: -113.70888,
    city: "Ivins",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9493,
    density: 77.2,
    county_fips: 49053,
    county_name: "Washington",
    county_weights: {
      49053: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 49053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84739,
    lat: 38.64204,
    lng: -112.22299,
    city: "Joseph",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 634,
    density: 9,
    county_fips: 49041,
    county_name: "Sevier",
    county_weights: {
      49041: 100,
    },
    county_names_all: "Sevier",
    county_fips_all: 49041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84740,
    lat: 38.27504,
    lng: -112.26689,
    city: "Junction",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 271,
    density: 1.9,
    county_fips: 49031,
    county_name: "Piute",
    county_weights: {
      49031: 100,
    },
    county_names_all: "Piute",
    county_fips_all: 49031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84741,
    lat: 37.19749,
    lng: -112.25533,
    city: "Kanab",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6180,
    density: 1.8,
    county_fips: 49025,
    county_name: "Kane",
    county_weights: {
      49025: 100,
    },
    county_names_all: "Kane",
    county_fips_all: 49025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84742,
    lat: 37.52102,
    lng: -113.14592,
    city: "Kanarraville",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 308,
    density: 2.1,
    county_fips: 49021,
    county_name: "Iron",
    county_weights: {
      49021: 100,
    },
    county_names_all: "Iron",
    county_fips_all: 49021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84743,
    lat: 38.20827,
    lng: -112.18572,
    city: "Kingston",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17,
    density: 1,
    county_fips: 49031,
    county_name: "Piute",
    county_weights: {
      49031: 100,
    },
    county_names_all: "Piute",
    county_fips_all: 49031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84744,
    lat: 38.64207,
    lng: -111.93627,
    city: "Koosharem",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 316,
    density: 1.1,
    county_fips: 49041,
    county_name: "Sevier",
    county_weights: {
      49031: 4.03,
      49041: 95.97,
    },
    county_names_all: "Sevier|Piute",
    county_fips_all: "49041|49031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84745,
    lat: 37.20838,
    lng: -113.26266,
    city: "La Verkin",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4413,
    density: 340.7,
    county_fips: 49053,
    county_name: "Washington",
    county_weights: {
      49053: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 49053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84746,
    lat: 37.23867,
    lng: -113.35055,
    city: "Leeds",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 961,
    density: 19.3,
    county_fips: 49053,
    county_name: "Washington",
    county_weights: {
      49053: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 49053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84747,
    lat: 38.44628,
    lng: -111.63773,
    city: "Loa",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1224,
    density: 8.2,
    county_fips: 49055,
    county_name: "Wayne",
    county_weights: {
      49055: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 49055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84749,
    lat: 38.36687,
    lng: -111.47667,
    city: "Lyman",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 141,
    density: 0.6,
    county_fips: 49055,
    county_name: "Wayne",
    county_weights: {
      49055: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 49055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84750,
    lat: 38.44205,
    lng: -112.1947,
    city: "Marysvale",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 590,
    density: 1.7,
    county_fips: 49031,
    county_name: "Piute",
    county_weights: {
      49031: 99.79,
      49041: 0.21,
    },
    county_names_all: "Piute|Sevier",
    county_fips_all: "49031|49041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84751,
    lat: 38.44392,
    lng: -113.0618,
    city: "Milford",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2370,
    density: 3,
    county_fips: 49001,
    county_name: "Beaver",
    county_weights: {
      49001: 90.57,
      49027: 9.43,
    },
    county_names_all: "Beaver|Millard",
    county_fips_all: "49001|49027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84752,
    lat: 38.24975,
    lng: -112.88434,
    city: "Minersville",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 826,
    density: 6.4,
    county_fips: 49001,
    county_name: "Beaver",
    county_weights: {
      49001: 100,
    },
    county_names_all: "Beaver",
    county_fips_all: 49001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84753,
    lat: 37.95019,
    lng: -113.87967,
    city: "Modena",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5,
    density: 0,
    county_fips: 49021,
    county_name: "Iron",
    county_weights: {
      49021: 100,
    },
    county_names_all: "Iron",
    county_fips_all: 49021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84754,
    lat: 38.60521,
    lng: -112.11747,
    city: "Monroe",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4033,
    density: 19.5,
    county_fips: 49041,
    county_name: "Sevier",
    county_weights: {
      49041: 100,
    },
    county_names_all: "Sevier",
    county_fips_all: 49041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84755,
    lat: 37.22652,
    lng: -112.78532,
    city: "Mount Carmel",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47,
    density: 0.3,
    county_fips: 49025,
    county_name: "Kane",
    county_weights: {
      49025: 100,
    },
    county_names_all: "Kane",
    county_fips_all: 49025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84756,
    lat: 37.74249,
    lng: -113.54772,
    city: "Newcastle",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 326,
    density: 1.8,
    county_fips: 49021,
    county_name: "Iron",
    county_weights: {
      49021: 100,
    },
    county_names_all: "Iron",
    county_fips_all: 49021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84757,
    lat: 37.45227,
    lng: -113.25166,
    city: "New Harmony",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1373,
    density: 9.9,
    county_fips: 49053,
    county_name: "Washington",
    county_weights: {
      49021: 3.35,
      49053: 96.65,
    },
    county_names_all: "Washington|Iron",
    county_fips_all: "49053|49021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84758,
    lat: 37.27041,
    lng: -112.68529,
    city: "Orderville",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 461,
    density: 1.3,
    county_fips: 49025,
    county_name: "Kane",
    county_weights: {
      49025: 100,
    },
    county_names_all: "Kane",
    county_fips_all: 49025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84759,
    lat: 37.92238,
    lng: -112.38423,
    city: "Panguitch",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2175,
    density: 1.8,
    county_fips: 49017,
    county_name: "Garfield",
    county_weights: {
      49017: 100,
    },
    county_names_all: "Garfield",
    county_fips_all: 49017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84760,
    lat: 37.96299,
    lng: -112.68551,
    city: "Paragonah",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 525,
    density: 0.6,
    county_fips: 49021,
    county_name: "Iron",
    county_weights: {
      49021: 100,
    },
    county_names_all: "Iron",
    county_fips_all: 49021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84761,
    lat: 37.84603,
    lng: -112.87124,
    city: "Parowan",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3556,
    density: 10.8,
    county_fips: 49021,
    county_name: "Iron",
    county_weights: {
      49021: 100,
    },
    county_names_all: "Iron",
    county_fips_all: 49021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84762,
    lat: 37.46882,
    lng: -112.72644,
    city: "Duck Creek Village",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75,
    density: 0.2,
    county_fips: 49025,
    county_name: "Kane",
    county_weights: {
      49017: 9.27,
      49025: 90.73,
    },
    county_names_all: "Kane|Garfield",
    county_fips_all: "49025|49017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84763,
    lat: 37.14667,
    lng: -113.06947,
    city: "Rockville",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 221,
    density: 5.9,
    county_fips: 49053,
    county_name: "Washington",
    county_weights: {
      49053: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 49053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84764,
    lat: 37.72035,
    lng: -112.06689,
    city: "Bryce",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 250,
    density: 0.6,
    county_fips: 49017,
    county_name: "Garfield",
    county_weights: {
      49017: 100,
    },
    county_names_all: "Garfield",
    county_fips_all: 49017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84765,
    lat: 37.31012,
    lng: -113.92535,
    city: "Santa Clara",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7234,
    density: 58.1,
    county_fips: 49053,
    county_name: "Washington",
    county_weights: {
      49053: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 49053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84766,
    lat: 38.59762,
    lng: -112.33567,
    city: "Sevier",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 287,
    density: 0.9,
    county_fips: 49041,
    county_name: "Sevier",
    county_weights: {
      49041: 100,
    },
    county_names_all: "Sevier",
    county_fips_all: 49041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84767,
    lat: 37.20152,
    lng: -112.9858,
    city: "Springdale",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 647,
    density: 1.1,
    county_fips: 49053,
    county_name: "Washington",
    county_weights: {
      49053: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 49053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84770,
    lat: 37.13818,
    lng: -113.6294,
    city: "Saint George",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43594,
    density: 233.6,
    county_fips: 49053,
    county_name: "Washington",
    county_weights: {
      49053: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 49053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84772,
    lat: 37.79706,
    lng: -112.94168,
    city: "Summit",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 252,
    density: 66.5,
    county_fips: 49021,
    county_name: "Iron",
    county_weights: {
      49021: 100,
    },
    county_names_all: "Iron",
    county_fips_all: 49021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84773,
    lat: 38.24958,
    lng: -111.47045,
    city: "Teasdale",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 242,
    density: 1.6,
    county_fips: 49055,
    county_name: "Wayne",
    county_weights: {
      49055: 100,
    },
    county_names_all: "Wayne",
    county_fips_all: 49055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84774,
    lat: 37.24324,
    lng: -113.28089,
    city: "Toquerville",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1681,
    density: 25.6,
    county_fips: 49053,
    county_name: "Washington",
    county_weights: {
      49053: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 49053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84775,
    lat: 38.28881,
    lng: -111.04073,
    city: "Torrey",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 460,
    density: 0.4,
    county_fips: 49055,
    county_name: "Wayne",
    county_weights: {
      49017: 7.62,
      49055: 92.38,
    },
    county_names_all: "Wayne|Garfield",
    county_fips_all: "49055|49017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84776,
    lat: 37.62956,
    lng: -112.08217,
    city: "Tropic",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 481,
    density: 18.4,
    county_fips: 49017,
    county_name: "Garfield",
    county_weights: {
      49017: 100,
    },
    county_names_all: "Garfield",
    county_fips_all: 49017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84779,
    lat: 37.33381,
    lng: -113.11869,
    city: "Virgin",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 760,
    density: 1.3,
    county_fips: 49053,
    county_name: "Washington",
    county_weights: {
      49053: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 49053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84780,
    lat: 37.12798,
    lng: -113.48108,
    city: "Washington",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27518,
    density: 172,
    county_fips: 49053,
    county_name: "Washington",
    county_weights: {
      49053: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 49053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84781,
    lat: 37.41197,
    lng: -113.47217,
    city: "Pine Valley",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 122,
    density: 0.6,
    county_fips: 49053,
    county_name: "Washington",
    county_weights: {
      49053: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 49053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84782,
    lat: 37.35939,
    lng: -113.67522,
    city: "Veyo",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 638,
    density: 11.8,
    county_fips: 49053,
    county_name: "Washington",
    county_weights: {
      49053: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 49053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84783,
    lat: 37.28556,
    lng: -113.65639,
    city: "Dammeron Valley",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 738,
    density: 8.3,
    county_fips: 49053,
    county_name: "Washington",
    county_weights: {
      49053: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 49053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84784,
    lat: 37.01858,
    lng: -112.96941,
    city: "Hildale",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2921,
    density: 266.5,
    county_fips: 49053,
    county_name: "Washington",
    county_weights: {
      49053: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 49053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 84790,
    lat: 37.04615,
    lng: -113.55738,
    city: "Saint George",
    state_id: "UT",
    state_name: "Utah",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47849,
    density: 382.2,
    county_fips: 49053,
    county_name: "Washington",
    county_weights: {
      49053: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 49053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 85003,
    lat: 33.45059,
    lng: -112.07833,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8465,
    density: 1757.1,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85004,
    lat: 33.45159,
    lng: -112.06988,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8223,
    density: 1546.9,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85006,
    lat: 33.46511,
    lng: -112.04778,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26682,
    density: 2597.1,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85007,
    lat: 33.44682,
    lng: -112.09073,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14820,
    density: 1242.9,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85008,
    lat: 33.46355,
    lng: -111.98746,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62995,
    density: 2377.3,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85009,
    lat: 33.44457,
    lng: -112.12661,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54000,
    density: 1423,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85012,
    lat: 33.50719,
    lng: -112.07024,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7595,
    density: 1300.8,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85013,
    lat: 33.51001,
    lng: -112.08294,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20912,
    density: 2191.2,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85014,
    lat: 33.50903,
    lng: -112.05665,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27888,
    density: 2665.5,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85015,
    lat: 33.50908,
    lng: -112.10184,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44010,
    density: 3464,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85016,
    lat: 33.50953,
    lng: -112.03041,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35627,
    density: 1678.3,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85017,
    lat: 33.50898,
    lng: -112.12381,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43396,
    density: 3183.8,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85018,
    lat: 33.5194,
    lng: -111.99309,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38891,
    density: 995.5,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85019,
    lat: 33.50952,
    lng: -112.14307,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30369,
    density: 3142.7,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85020,
    lat: 33.56766,
    lng: -112.05485,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35742,
    density: 1571.4,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85021,
    lat: 33.56046,
    lng: -112.09442,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42114,
    density: 2342.4,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85022,
    lat: 33.62685,
    lng: -112.05113,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52146,
    density: 2141.7,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85023,
    lat: 33.63156,
    lng: -112.09452,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35196,
    density: 1833.1,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85024,
    lat: 33.69042,
    lng: -112.04632,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26724,
    density: 880.3,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85026,
    lat: 33.44891,
    lng: -111.97356,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85027,
    lat: 33.6771,
    lng: -112.10206,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39488,
    density: 1301.4,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85028,
    lat: 33.5816,
    lng: -112.00811,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19120,
    density: 1077.5,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85029,
    lat: 33.59546,
    lng: -112.11002,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47541,
    density: 1961.8,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85031,
    lat: 33.49491,
    lng: -112.16835,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36409,
    density: 3461.1,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85032,
    lat: 33.62624,
    lng: -112.00368,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 73212,
    density: 2286.5,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85033,
    lat: 33.49443,
    lng: -112.21193,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64388,
    density: 4063.6,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85034,
    lat: 33.43465,
    lng: -112.01989,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5438,
    density: 181.5,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85035,
    lat: 33.47167,
    lng: -112.19538,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57599,
    density: 3973.9,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85037,
    lat: 33.49038,
    lng: -112.26487,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55083,
    density: 2600.8,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85040,
    lat: 33.40585,
    lng: -112.02658,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35399,
    density: 1352,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85041,
    lat: 33.38643,
    lng: -112.10928,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64657,
    density: 1561.3,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85042,
    lat: 33.35911,
    lng: -112.04949,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49374,
    density: 980.5,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85043,
    lat: 33.4323,
    lng: -112.19744,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37779,
    density: 718.3,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85044,
    lat: 33.33997,
    lng: -112.00617,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43187,
    density: 1010.8,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85045,
    lat: 33.29976,
    lng: -112.1062,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6737,
    density: 654.9,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85048,
    lat: 33.30362,
    lng: -112.03192,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36867,
    density: 1406.6,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85050,
    lat: 33.68739,
    lng: -111.99854,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31864,
    density: 826,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85051,
    lat: 33.55914,
    lng: -112.13324,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46041,
    density: 2796.9,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85053,
    lat: 33.6296,
    lng: -112.13184,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31381,
    density: 2345.1,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85054,
    lat: 33.67515,
    lng: -111.94763,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8836,
    density: 398.4,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85083,
    lat: 33.74032,
    lng: -112.16308,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20343,
    density: 394.2,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85085,
    lat: 33.75637,
    lng: -112.07426,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24608,
    density: 249.3,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85086,
    lat: 33.82639,
    lng: -112.12876,
    city: "Phoenix",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43447,
    density: 273.5,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85087,
    lat: 33.92635,
    lng: -112.14908,
    city: "New River",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8124,
    density: 36,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85118,
    lat: 33.3737,
    lng: -111.36545,
    city: "Gold Canyon",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12888,
    density: 33.5,
    county_fips: "04021",
    county_name: "Pinal",
    county_weights: {
      "04021": 100,
    },
    county_names_all: "Pinal",
    county_fips_all: "04021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85119,
    lat: 33.38682,
    lng: -111.50824,
    city: "Apache Junction",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26216,
    density: 221.2,
    county_fips: "04021",
    county_name: "Pinal",
    county_weights: {
      "04021": 100,
    },
    county_names_all: "Pinal",
    county_fips_all: "04021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85120,
    lat: 33.38706,
    lng: -111.56311,
    city: "Apache Junction",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31042,
    density: 519.1,
    county_fips: "04021",
    county_name: "Pinal",
    county_weights: {
      "04021": 93.89,
      "04013": 6.11,
    },
    county_names_all: "Pinal|Maricopa",
    county_fips_all: "04021|04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85121,
    lat: 33.13751,
    lng: -111.91316,
    city: "Bapchule",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1782,
    density: 9.1,
    county_fips: "04021",
    county_name: "Pinal",
    county_weights: {
      "04021": 100,
    },
    county_names_all: "Pinal",
    county_fips_all: "04021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85122,
    lat: 32.91672,
    lng: -111.74798,
    city: "Casa Grande",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60061,
    density: 411.2,
    county_fips: "04021",
    county_name: "Pinal",
    county_weights: {
      "04021": 100,
    },
    county_names_all: "Pinal",
    county_fips_all: "04021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85123,
    lat: 32.70917,
    lng: -111.6802,
    city: "Arizona City",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10484,
    density: 120.2,
    county_fips: "04021",
    county_name: "Pinal",
    county_weights: {
      "04021": 100,
    },
    county_names_all: "Pinal",
    county_fips_all: "04021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85128,
    lat: 32.96468,
    lng: -111.51028,
    city: "Coolidge",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17427,
    density: 40.4,
    county_fips: "04021",
    county_name: "Pinal",
    county_weights: {
      "04021": 100,
    },
    county_names_all: "Pinal",
    county_fips_all: "04021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85131,
    lat: 32.65542,
    lng: -111.57649,
    city: "Eloy",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20455,
    density: 25.8,
    county_fips: "04021",
    county_name: "Pinal",
    county_weights: {
      "04021": 100,
    },
    county_names_all: "Pinal",
    county_fips_all: "04021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85132,
    lat: 32.92358,
    lng: -111.19119,
    city: "Florence",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40171,
    density: 25.8,
    county_fips: "04021",
    county_name: "Pinal",
    county_weights: {
      "04021": 100,
    },
    county_names_all: "Pinal",
    county_fips_all: "04021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85135,
    lat: 32.9987,
    lng: -110.78242,
    city: "Hayden",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 444,
    density: 118.4,
    county_fips: "04007",
    county_name: "Gila",
    county_weights: {
      "04007": 100,
    },
    county_names_all: "Gila",
    county_fips_all: "04007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85137,
    lat: 33.11275,
    lng: -110.98353,
    city: "Kearny",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2772,
    density: 4.6,
    county_fips: "04021",
    county_name: "Pinal",
    county_weights: {
      "04021": 100,
    },
    county_names_all: "Pinal",
    county_fips_all: "04021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85138,
    lat: 33.0151,
    lng: -111.98681,
    city: "Maricopa",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41266,
    density: 188,
    county_fips: "04021",
    county_name: "Pinal",
    county_weights: {
      "04021": 100,
    },
    county_names_all: "Pinal",
    county_fips_all: "04021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85139,
    lat: 32.92096,
    lng: -112.21117,
    city: "Maricopa",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17708,
    density: 13.6,
    county_fips: "04021",
    county_name: "Pinal",
    county_weights: {
      "04021": 52.77,
      "04013": 47.23,
    },
    county_names_all: "Pinal|Maricopa",
    county_fips_all: "04021|04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85140,
    lat: 33.24805,
    lng: -111.48921,
    city: "San Tan Valley",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51520,
    density: 241.4,
    county_fips: "04021",
    county_name: "Pinal",
    county_weights: {
      "04021": 100,
    },
    county_names_all: "Pinal",
    county_fips_all: "04021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85141,
    lat: 32.64707,
    lng: -111.42792,
    city: "Picacho",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 534,
    density: 3.4,
    county_fips: "04021",
    county_name: "Pinal",
    county_weights: {
      "04021": 100,
    },
    county_names_all: "Pinal",
    county_fips_all: "04021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85142,
    lat: 33.19302,
    lng: -111.66645,
    city: "Queen Creek",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 77101,
    density: 293.8,
    county_fips: "04021",
    county_name: "Pinal",
    county_weights: {
      "04021": 67.52,
      "04013": 32.48,
    },
    county_names_all: "Pinal|Maricopa",
    county_fips_all: "04021|04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85143,
    lat: 33.15602,
    lng: -111.51974,
    city: "San Tan Valley",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41329,
    density: 510.2,
    county_fips: "04021",
    county_name: "Pinal",
    county_weights: {
      "04021": 100,
    },
    county_names_all: "Pinal",
    county_fips_all: "04021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85145,
    lat: 32.54322,
    lng: -111.39415,
    city: "Red Rock",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3893,
    density: 39,
    county_fips: "04021",
    county_name: "Pinal",
    county_weights: {
      "04021": 100,
    },
    county_names_all: "Pinal",
    county_fips_all: "04021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85147,
    lat: 33.09454,
    lng: -111.7209,
    city: "Sacaton",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4188,
    density: 22.9,
    county_fips: "04021",
    county_name: "Pinal",
    county_weights: {
      "04021": 100,
    },
    county_names_all: "Pinal",
    county_fips_all: "04021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85172,
    lat: 32.89974,
    lng: -111.95205,
    city: "Stanfield",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1497,
    density: 7.8,
    county_fips: "04021",
    county_name: "Pinal",
    county_weights: {
      "04021": 100,
    },
    county_names_all: "Pinal",
    county_fips_all: "04021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85173,
    lat: 33.26827,
    lng: -111.13651,
    city: "Superior",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3155,
    density: 25.5,
    county_fips: "04021",
    county_name: "Pinal",
    county_weights: {
      "04021": 100,
    },
    county_names_all: "Pinal",
    county_fips_all: "04021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85191,
    lat: 32.98498,
    lng: -111.44686,
    city: "Valley Farms",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "04021",
    county_name: "Pinal",
    county_weights: {
      "04021": 100,
    },
    county_names_all: "Pinal",
    county_fips_all: "04021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85192,
    lat: 32.96134,
    lng: -110.66501,
    city: "Winkelman",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2669,
    density: 3.2,
    county_fips: "04021",
    county_name: "Pinal",
    county_weights: {
      "04021": 67.65,
      "04007": 32.35,
    },
    county_names_all: "Pinal|Gila",
    county_fips_all: "04021|04007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85193,
    lat: 32.79822,
    lng: -111.82809,
    city: "Casa Grande",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5946,
    density: 10.8,
    county_fips: "04021",
    county_name: "Pinal",
    county_weights: {
      "04021": 100,
    },
    county_names_all: "Pinal",
    county_fips_all: "04021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85194,
    lat: 32.89675,
    lng: -111.62439,
    city: "Casa Grande",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8283,
    density: 39.6,
    county_fips: "04021",
    county_name: "Pinal",
    county_weights: {
      "04021": 100,
    },
    county_names_all: "Pinal",
    county_fips_all: "04021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85201,
    lat: 33.4336,
    lng: -111.84929,
    city: "Mesa",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55159,
    density: 2271.2,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85202,
    lat: 33.38252,
    lng: -111.87482,
    city: "Mesa",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40037,
    density: 2478.9,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85203,
    lat: 33.44997,
    lng: -111.80403,
    city: "Mesa",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40112,
    density: 1672.7,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85204,
    lat: 33.39666,
    lng: -111.78786,
    city: "Mesa",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69792,
    density: 2719.6,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85205,
    lat: 33.43227,
    lng: -111.71804,
    city: "Mesa",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44079,
    density: 1680.2,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85206,
    lat: 33.39685,
    lng: -111.71758,
    city: "Mesa",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36506,
    density: 1501.6,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85207,
    lat: 33.45362,
    lng: -111.63631,
    city: "Mesa",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51867,
    density: 681.6,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85208,
    lat: 33.40301,
    lng: -111.63194,
    city: "Mesa",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38474,
    density: 1824.6,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85209,
    lat: 33.37877,
    lng: -111.63476,
    city: "Mesa",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40294,
    density: 1319.8,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85210,
    lat: 33.38955,
    lng: -111.84337,
    city: "Mesa",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41359,
    density: 2389.8,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85212,
    lat: 33.32064,
    lng: -111.63088,
    city: "Mesa",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40326,
    density: 403.6,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 92.4,
      "04021": 7.6,
    },
    county_names_all: "Maricopa|Pinal",
    county_fips_all: "04013|04021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85213,
    lat: 33.44764,
    lng: -111.76962,
    city: "Mesa",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38412,
    density: 1608.8,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85215,
    lat: 33.51101,
    lng: -111.58027,
    city: "Mesa",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16255,
    density: 75.8,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85224,
    lat: 33.32351,
    lng: -111.87616,
    city: "Chandler",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45154,
    density: 1849.6,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85225,
    lat: 33.31748,
    lng: -111.83167,
    city: "Chandler",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69790,
    density: 2123,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85226,
    lat: 33.26519,
    lng: -111.94641,
    city: "Chandler",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39614,
    density: 397.8,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85233,
    lat: 33.35242,
    lng: -111.8115,
    city: "Gilbert",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36229,
    density: 1449.8,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85234,
    lat: 33.36479,
    lng: -111.73924,
    city: "Gilbert",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49266,
    density: 1592.6,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85236,
    lat: 33.32301,
    lng: -111.71951,
    city: "Higley",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85248,
    lat: 33.2145,
    lng: -111.86667,
    city: "Chandler",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36396,
    density: 460,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 63.38,
      "04021": 36.62,
    },
    county_names_all: "Maricopa|Pinal",
    county_fips_all: "04013|04021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85249,
    lat: 33.22652,
    lng: -111.79918,
    city: "Chandler",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40711,
    density: 1095.5,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85250,
    lat: 33.52986,
    lng: -111.88991,
    city: "Scottsdale",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17860,
    density: 820.1,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85251,
    lat: 33.49406,
    lng: -111.92025,
    city: "Scottsdale",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41592,
    density: 2223,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85253,
    lat: 33.54479,
    lng: -111.95873,
    city: "Paradise Valley",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18873,
    density: 402.5,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85254,
    lat: 33.61474,
    lng: -111.95176,
    city: "Scottsdale",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47518,
    density: 1337.4,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85255,
    lat: 33.6824,
    lng: -111.8177,
    city: "Scottsdale",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43246,
    density: 189.3,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85256,
    lat: 33.50053,
    lng: -111.83524,
    city: "Scottsdale",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6329,
    density: 71.4,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85257,
    lat: 33.46354,
    lng: -111.91486,
    city: "Scottsdale",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33594,
    density: 1889.3,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85258,
    lat: 33.56337,
    lng: -111.89268,
    city: "Scottsdale",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27133,
    density: 1016.4,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85259,
    lat: 33.60105,
    lng: -111.80952,
    city: "Scottsdale",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24119,
    density: 449.2,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85260,
    lat: 33.60943,
    lng: -111.89113,
    city: "Scottsdale",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41192,
    density: 1116.7,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85262,
    lat: 33.85834,
    lng: -111.80169,
    city: "Scottsdale",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12675,
    density: 31.5,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85263,
    lat: 33.90026,
    lng: -111.62412,
    city: "Rio Verde",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3040,
    density: 6.2,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85264,
    lat: 33.69996,
    lng: -111.50123,
    city: "Fort Mcdowell",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1511,
    density: 1.4,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85266,
    lat: 33.76034,
    lng: -111.92503,
    city: "Scottsdale",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13596,
    density: 267.6,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85268,
    lat: 33.60717,
    lng: -111.73999,
    city: "Fountain Hills",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25368,
    density: 478.3,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85281,
    lat: 33.42805,
    lng: -111.93157,
    city: "Tempe",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69197,
    density: 2011.3,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85282,
    lat: 33.3943,
    lng: -111.93242,
    city: "Tempe",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56435,
    density: 1963.6,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85283,
    lat: 33.36461,
    lng: -111.93196,
    city: "Tempe",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51800,
    density: 2265.1,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85284,
    lat: 33.33719,
    lng: -111.93443,
    city: "Tempe",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20782,
    density: 1025.8,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85286,
    lat: 33.27146,
    lng: -111.83156,
    city: "Chandler",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45444,
    density: 1102.8,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85295,
    lat: 33.30639,
    lng: -111.73804,
    city: "Gilbert",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48814,
    density: 1562.9,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85296,
    lat: 33.33554,
    lng: -111.74006,
    city: "Gilbert",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46934,
    density: 1553,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85297,
    lat: 33.27843,
    lng: -111.73638,
    city: "Gilbert",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32706,
    density: 1177,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85298,
    lat: 33.23983,
    lng: -111.72819,
    city: "Gilbert",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32742,
    density: 806.7,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85301,
    lat: 33.53219,
    lng: -112.17817,
    city: "Glendale",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69181,
    density: 2868.4,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85302,
    lat: 33.56777,
    lng: -112.17819,
    city: "Glendale",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41547,
    density: 2668.8,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85303,
    lat: 33.53398,
    lng: -112.22084,
    city: "Glendale",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35403,
    density: 2023,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85304,
    lat: 33.59566,
    lng: -112.17815,
    city: "Glendale",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29801,
    density: 2105.9,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85305,
    lat: 33.52996,
    lng: -112.25563,
    city: "Glendale",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14452,
    density: 910.2,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85306,
    lat: 33.62333,
    lng: -112.17569,
    city: "Glendale",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23923,
    density: 1577.3,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85307,
    lat: 33.53396,
    lng: -112.30867,
    city: "Glendale",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12118,
    density: 449.9,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85308,
    lat: 33.66029,
    lng: -112.18486,
    city: "Glendale",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65799,
    density: 1503.2,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85309,
    lat: 33.53556,
    lng: -112.37637,
    city: "Luke Air Force Base",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 836,
    density: 90.3,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85310,
    lat: 33.69532,
    lng: -112.17162,
    city: "Glendale",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20492,
    density: 862,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85320,
    lat: 33.83563,
    lng: -113.23214,
    city: "Aguila",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 956,
    density: 1.4,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 99.84,
      "04012": 0.16,
    },
    county_names_all: "Maricopa|La Paz",
    county_fips_all: "04013|04012",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85321,
    lat: 32.30062,
    lng: -112.63169,
    city: "Ajo",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3768,
    density: 1.1,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 88.95,
      "04013": 11.05,
    },
    county_names_all: "Pima|Maricopa",
    county_fips_all: "04019|04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85322,
    lat: 33.1766,
    lng: -112.85207,
    city: "Arlington",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 579,
    density: 0.6,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85323,
    lat: 33.41888,
    lng: -112.32615,
    city: "Avondale",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45361,
    density: 987.3,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85324,
    lat: 34.10456,
    lng: -112.07094,
    city: "Black Canyon City",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2685,
    density: 3.2,
    county_fips: "04025",
    county_name: "Yavapai",
    county_weights: {
      "04025": 100,
    },
    county_names_all: "Yavapai",
    county_fips_all: "04025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85325,
    lat: 33.98328,
    lng: -113.84323,
    city: "Bouse",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1281,
    density: 0.7,
    county_fips: "04012",
    county_name: "La Paz",
    county_weights: {
      "04012": 100,
    },
    county_names_all: "La Paz",
    county_fips_all: "04012",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85326,
    lat: 33.23735,
    lng: -112.58538,
    city: "Buckeye",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63438,
    density: 50.7,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85328,
    lat: 33.22795,
    lng: -114.63413,
    city: "Cibola",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 286,
    density: 0.6,
    county_fips: "04012",
    county_name: "La Paz",
    county_weights: {
      "04012": 100,
    },
    county_names_all: "La Paz",
    county_fips_all: "04012",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85329,
    lat: 33.43171,
    lng: -112.2965,
    city: "Cashion",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85331,
    lat: 33.88685,
    lng: -111.94276,
    city: "Cave Creek",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31947,
    density: 94.1,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85332,
    lat: 34.19209,
    lng: -112.89444,
    city: "Congress",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1960,
    density: 1.8,
    county_fips: "04025",
    county_name: "Yavapai",
    county_weights: {
      "04025": 100,
    },
    county_names_all: "Yavapai",
    county_fips_all: "04025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85333,
    lat: 32.97896,
    lng: -113.30714,
    city: "Dateland",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 607,
    density: 0.4,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 55.51,
      "04027": 44.49,
    },
    county_names_all: "Maricopa|Yuma",
    county_fips_all: "04013|04027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85334,
    lat: 33.60535,
    lng: -114.4075,
    city: "Ehrenberg",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1005,
    density: 6.7,
    county_fips: "04012",
    county_name: "La Paz",
    county_weights: {
      "04012": 100,
    },
    county_names_all: "La Paz",
    county_fips_all: "04012",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85335,
    lat: 33.58721,
    lng: -112.32836,
    city: "El Mirage",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35702,
    density: 1151.4,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85336,
    lat: 32.51904,
    lng: -114.77977,
    city: "San Luis",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 873,
    density: 34.5,
    county_fips: "04027",
    county_name: "Yuma",
    county_weights: {
      "04027": 100,
    },
    county_names_all: "Yuma",
    county_fips_all: "04027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85337,
    lat: 32.97553,
    lng: -112.866,
    city: "Gila Bend",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2676,
    density: 2.9,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85338,
    lat: 33.37252,
    lng: -112.40826,
    city: "Goodyear",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51691,
    density: 262.5,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85339,
    lat: 33.23985,
    lng: -112.14322,
    city: "Laveen",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49398,
    density: 73.9,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 56.1,
      "04021": 43.9,
    },
    county_names_all: "Maricopa|Pinal",
    county_fips_all: "04013|04021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85340,
    lat: 33.5179,
    lng: -112.42361,
    city: "Litchfield Park",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39394,
    density: 486,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85341,
    lat: 31.9726,
    lng: -112.71943,
    city: "Lukeville",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85342,
    lat: 33.95308,
    lng: -112.48358,
    city: "Morristown",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1795,
    density: 1.8,
    county_fips: "04025",
    county_name: "Yavapai",
    county_weights: {
      "04025": 56.23,
      "04013": 43.77,
    },
    county_names_all: "Yavapai|Maricopa",
    county_fips_all: "04025|04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85343,
    lat: 33.33774,
    lng: -112.69087,
    city: "Palo Verde",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 87,
    density: 5.3,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85344,
    lat: 33.98527,
    lng: -114.23267,
    city: "Parker",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10608,
    density: 4.7,
    county_fips: "04012",
    county_name: "La Paz",
    county_weights: {
      "04012": 100,
    },
    county_names_all: "La Paz",
    county_fips_all: "04012",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85345,
    lat: 33.57215,
    lng: -112.24838,
    city: "Peoria",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57095,
    density: 1737.3,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85346,
    lat: 33.60992,
    lng: -114.15835,
    city: "Quartzsite",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4275,
    density: 4.5,
    county_fips: "04012",
    county_name: "La Paz",
    county_weights: {
      "04012": 100,
    },
    county_names_all: "La Paz",
    county_fips_all: "04012",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85347,
    lat: 32.78612,
    lng: -113.80633,
    city: "Roll",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 498,
    density: 0.9,
    county_fips: "04027",
    county_name: "Yuma",
    county_weights: {
      "04027": 100,
    },
    county_names_all: "Yuma",
    county_fips_all: "04027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85348,
    lat: 33.69914,
    lng: -113.66372,
    city: "Salome",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2836,
    density: 1.6,
    county_fips: "04012",
    county_name: "La Paz",
    county_weights: {
      "04012": 100,
    },
    county_names_all: "La Paz",
    county_fips_all: "04012",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85349,
    lat: 32.47983,
    lng: -114.69647,
    city: "San Luis",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31340,
    density: 536.1,
    county_fips: "04027",
    county_name: "Yuma",
    county_weights: {
      "04027": 100,
    },
    county_names_all: "Yuma",
    county_fips_all: "04027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85350,
    lat: 32.56651,
    lng: -114.70896,
    city: "Somerton",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24044,
    density: 114.1,
    county_fips: "04027",
    county_name: "Yuma",
    county_weights: {
      "04027": 100,
    },
    county_names_all: "Yuma",
    county_fips_all: "04027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85351,
    lat: 33.60638,
    lng: -112.28213,
    city: "Sun City",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28824,
    density: 1022.9,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85352,
    lat: 32.69118,
    lng: -113.8963,
    city: "Tacna",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 495,
    density: 4.5,
    county_fips: "04027",
    county_name: "Yuma",
    county_weights: {
      "04027": 100,
    },
    county_names_all: "Yuma",
    county_fips_all: "04027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85353,
    lat: 33.41721,
    lng: -112.27283,
    city: "Tolleson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42230,
    density: 760.1,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85354,
    lat: 33.40735,
    lng: -113.06637,
    city: "Tonopah",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7673,
    density: 4.1,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85355,
    lat: 33.57519,
    lng: -112.45374,
    city: "Waddell",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12756,
    density: 142.3,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85356,
    lat: 32.68933,
    lng: -114.1852,
    city: "Wellton",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5009,
    density: 10.7,
    county_fips: "04027",
    county_name: "Yuma",
    county_weights: {
      "04027": 100,
    },
    county_names_all: "Yuma",
    county_fips_all: "04027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85357,
    lat: 34.02498,
    lng: -113.49055,
    city: "Wenden",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 434,
    density: 0.4,
    county_fips: "04012",
    county_name: "La Paz",
    county_weights: {
      "04012": 100,
    },
    county_names_all: "La Paz",
    county_fips_all: "04012",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85360,
    lat: 34.54833,
    lng: -113.57275,
    city: "Wikieup",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 99,
    density: 0,
    county_fips: "04015",
    county_name: "Mohave",
    county_weights: {
      "04015": 100,
    },
    county_names_all: "Mohave",
    county_fips_all: "04015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85361,
    lat: 33.76617,
    lng: -112.63093,
    city: "Wittmann",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7082,
    density: 23.3,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85362,
    lat: 34.28558,
    lng: -112.84337,
    city: "Yarnell",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 667,
    density: 4.1,
    county_fips: "04025",
    county_name: "Yavapai",
    county_weights: {
      "04025": 100,
    },
    county_names_all: "Yavapai",
    county_fips_all: "04025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85363,
    lat: 33.58458,
    lng: -112.30489,
    city: "Youngtown",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6837,
    density: 1728.3,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85364,
    lat: 32.70469,
    lng: -114.65664,
    city: "Yuma",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 73674,
    density: 741.1,
    county_fips: "04027",
    county_name: "Yuma",
    county_weights: {
      "04027": 100,
    },
    county_names_all: "Yuma",
    county_fips_all: "04027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85365,
    lat: 33.07067,
    lng: -114.13801,
    city: "Yuma",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53355,
    density: 15.3,
    county_fips: "04027",
    county_name: "Yuma",
    county_weights: {
      "04027": 100,
    },
    county_names_all: "Yuma",
    county_fips_all: "04027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85367,
    lat: 32.66082,
    lng: -114.39361,
    city: "Yuma",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22067,
    density: 226.7,
    county_fips: "04027",
    county_name: "Yuma",
    county_weights: {
      "04027": 100,
    },
    county_names_all: "Yuma",
    county_fips_all: "04027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85371,
    lat: 33.96732,
    lng: -114.39005,
    city: "Poston",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 310,
    density: 12.9,
    county_fips: "04012",
    county_name: "La Paz",
    county_weights: {
      "04012": 100,
    },
    county_names_all: "La Paz",
    county_fips_all: "04012",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85373,
    lat: 33.67257,
    lng: -112.29983,
    city: "Sun City",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20738,
    density: 711.1,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85374,
    lat: 33.64449,
    lng: -112.395,
    city: "Surprise",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49284,
    density: 1488.3,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85375,
    lat: 33.6716,
    lng: -112.3565,
    city: "Sun City West",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30285,
    density: 943.7,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85377,
    lat: 33.82376,
    lng: -111.91515,
    city: "Carefree",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3589,
    density: 161.2,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85378,
    lat: 33.64162,
    lng: -112.32012,
    city: "Surprise",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85379,
    lat: 33.60207,
    lng: -112.3736,
    city: "Surprise",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47061,
    density: 1691.6,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85381,
    lat: 33.60957,
    lng: -112.23175,
    city: "Peoria",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25050,
    density: 1449.8,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85382,
    lat: 33.65548,
    lng: -112.24771,
    city: "Peoria",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38815,
    density: 1511,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85383,
    lat: 33.80297,
    lng: -112.31734,
    city: "Peoria",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58375,
    density: 143.7,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85387,
    lat: 33.71025,
    lng: -112.44869,
    city: "Surprise",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11141,
    density: 71.7,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85388,
    lat: 33.60743,
    lng: -112.43413,
    city: "Surprise",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33455,
    density: 1005.6,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85390,
    lat: 33.92391,
    lng: -112.86739,
    city: "Wickenburg",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9443,
    density: 7.7,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 76.23,
      "04025": 23.77,
    },
    county_names_all: "Maricopa|Yavapai",
    county_fips_all: "04013|04025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85392,
    lat: 33.47713,
    lng: -112.30981,
    city: "Avondale",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38795,
    density: 1542.1,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85395,
    lat: 33.48208,
    lng: -112.40518,
    city: "Goodyear",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30013,
    density: 623.4,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85396,
    lat: 33.5376,
    lng: -112.64635,
    city: "Buckeye",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25272,
    density: 97.9,
    county_fips: "04013",
    county_name: "Maricopa",
    county_weights: {
      "04013": 100,
    },
    county_names_all: "Maricopa",
    county_fips_all: "04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85501,
    lat: 33.54569,
    lng: -110.74788,
    city: "Globe",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13073,
    density: 9.2,
    county_fips: "04007",
    county_name: "Gila",
    county_weights: {
      "04007": 100,
    },
    county_names_all: "Gila",
    county_fips_all: "04007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85530,
    lat: 33.09361,
    lng: -110.23109,
    city: "Bylas",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1508,
    density: 1.5,
    county_fips: "04009",
    county_name: "Graham",
    county_weights: {
      "04009": 100,
    },
    county_names_all: "Graham",
    county_fips_all: "04009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85531,
    lat: 32.87392,
    lng: -109.7849,
    city: "Central",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 366,
    density: 31.6,
    county_fips: "04009",
    county_name: "Graham",
    county_weights: {
      "04009": 100,
    },
    county_names_all: "Graham",
    county_fips_all: "04009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85532,
    lat: 33.40779,
    lng: -110.8454,
    city: "Claypool",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "04007",
    county_name: "Gila",
    county_weights: {
      "04007": 100,
    },
    county_names_all: "Gila",
    county_fips_all: "04007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85533,
    lat: 33.29208,
    lng: -109.40219,
    city: "Clifton",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3412,
    density: 1.4,
    county_fips: "04011",
    county_name: "Greenlee",
    county_weights: {
      "04011": 69.87,
      "04009": 30.13,
    },
    county_names_all: "Greenlee|Graham",
    county_fips_all: "04011|04009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85534,
    lat: 32.72939,
    lng: -109.14475,
    city: "Duncan",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2708,
    density: 2.6,
    county_fips: "04011",
    county_name: "Greenlee",
    county_weights: {
      "04011": 100,
    },
    county_names_all: "Greenlee",
    county_fips_all: "04011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85535,
    lat: 32.98583,
    lng: -109.91284,
    city: "Eden",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "04009",
    county_name: "Graham",
    county_weights: {
      "04009": 100,
    },
    county_names_all: "Graham",
    county_fips_all: "04009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85536,
    lat: 33.14063,
    lng: -110.00331,
    city: "Fort Thomas",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 445,
    density: 1.2,
    county_fips: "04009",
    county_name: "Graham",
    county_weights: {
      "04009": 100,
    },
    county_names_all: "Graham",
    county_fips_all: "04009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85539,
    lat: 33.33282,
    lng: -110.92883,
    city: "Miami",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4146,
    density: 20.7,
    county_fips: "04007",
    county_name: "Gila",
    county_weights: {
      "04007": 75.19,
      "04021": 24.81,
    },
    county_names_all: "Gila|Pinal",
    county_fips_all: "04007|04021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85540,
    lat: 32.9781,
    lng: -109.35704,
    city: "Morenci",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3294,
    density: 12.6,
    county_fips: "04011",
    county_name: "Greenlee",
    county_weights: {
      "04011": 100,
    },
    county_names_all: "Greenlee",
    county_fips_all: "04011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85541,
    lat: 34.21921,
    lng: -111.34387,
    city: "Payson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21809,
    density: 10.4,
    county_fips: "04007",
    county_name: "Gila",
    county_weights: {
      "04007": 100,
    },
    county_names_all: "Gila",
    county_fips_all: "04007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85542,
    lat: 33.28633,
    lng: -110.30145,
    city: "Peridot",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3538,
    density: 5.4,
    county_fips: "04009",
    county_name: "Graham",
    county_weights: {
      "04009": 83.74,
      "04007": 16.26,
    },
    county_names_all: "Graham|Gila",
    county_fips_all: "04009|04007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85543,
    lat: 32.9593,
    lng: -109.90123,
    city: "Pima",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4058,
    density: 4.1,
    county_fips: "04009",
    county_name: "Graham",
    county_weights: {
      "04009": 100,
    },
    county_names_all: "Graham",
    county_fips_all: "04009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85544,
    lat: 34.38609,
    lng: -111.4732,
    city: "Pine",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2800,
    density: 14.7,
    county_fips: "04007",
    county_name: "Gila",
    county_weights: {
      "04007": 100,
    },
    county_names_all: "Gila",
    county_fips_all: "04007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85545,
    lat: 33.53759,
    lng: -111.11955,
    city: "Roosevelt",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 607,
    density: 0.6,
    county_fips: "04007",
    county_name: "Gila",
    county_weights: {
      "04007": 50.82,
      "04013": 49.18,
    },
    county_names_all: "Gila|Maricopa",
    county_fips_all: "04007|04013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85546,
    lat: 32.71743,
    lng: -109.58175,
    city: "Safford",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20383,
    density: 11.3,
    county_fips: "04009",
    county_name: "Graham",
    county_weights: {
      "04009": 100,
    },
    county_names_all: "Graham",
    county_fips_all: "04009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85550,
    lat: 33.54833,
    lng: -110.51244,
    city: "San Carlos",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5525,
    density: 5,
    county_fips: "04007",
    county_name: "Gila",
    county_weights: {
      "04007": 100,
    },
    county_names_all: "Gila",
    county_fips_all: "04007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85551,
    lat: 32.73048,
    lng: -109.56252,
    city: "Solomon",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 555,
    density: 8.5,
    county_fips: "04009",
    county_name: "Graham",
    county_weights: {
      "04009": 100,
    },
    county_names_all: "Graham",
    county_fips_all: "04009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85552,
    lat: 32.81399,
    lng: -109.78953,
    city: "Thatcher",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6653,
    density: 88,
    county_fips: "04009",
    county_name: "Graham",
    county_weights: {
      "04009": 100,
    },
    county_names_all: "Graham",
    county_fips_all: "04009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85553,
    lat: 33.79932,
    lng: -111.22438,
    city: "Tonto Basin",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1850,
    density: 2.4,
    county_fips: "04007",
    county_name: "Gila",
    county_weights: {
      "04007": 100,
    },
    county_names_all: "Gila",
    county_fips_all: "04007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85554,
    lat: 33.99679,
    lng: -110.97834,
    city: "Young",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 456,
    density: 0.2,
    county_fips: "04007",
    county_name: "Gila",
    county_weights: {
      "04007": 100,
    },
    county_names_all: "Gila",
    county_fips_all: "04007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85601,
    lat: 31.58453,
    lng: -111.33359,
    city: "Arivaca",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 692,
    density: 1.6,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85602,
    lat: 32.17296,
    lng: -110.3865,
    city: "Benson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9007,
    density: 4.1,
    county_fips: "04003",
    county_name: "Cochise",
    county_weights: {
      "04003": 69.45,
      "04019": 30.55,
    },
    county_names_all: "Cochise|Pima",
    county_fips_all: "04003|04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85603,
    lat: 31.43525,
    lng: -109.91127,
    city: "Bisbee",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7137,
    density: 12.1,
    county_fips: "04003",
    county_name: "Cochise",
    county_weights: {
      "04003": 100,
    },
    county_names_all: "Cochise",
    county_fips_all: "04003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85605,
    lat: 32.29784,
    lng: -109.47644,
    city: "Bowie",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 666,
    density: 0.8,
    county_fips: "04003",
    county_name: "Cochise",
    county_weights: {
      "04003": 100,
    },
    county_names_all: "Cochise",
    county_fips_all: "04003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85606,
    lat: 32.01521,
    lng: -109.93326,
    city: "Cochise",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1002,
    density: 2.2,
    county_fips: "04003",
    county_name: "Cochise",
    county_weights: {
      "04003": 100,
    },
    county_names_all: "Cochise",
    county_fips_all: "04003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85607,
    lat: 31.49008,
    lng: -109.34052,
    city: "Douglas",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17415,
    density: 8.6,
    county_fips: "04003",
    county_name: "Cochise",
    county_weights: {
      "04003": 100,
    },
    county_names_all: "Cochise",
    county_fips_all: "04003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85608,
    lat: 31.45624,
    lng: -109.58635,
    city: "Douglas",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3421,
    density: 690.2,
    county_fips: "04003",
    county_name: "Cochise",
    county_weights: {
      "04003": 100,
    },
    county_names_all: "Cochise",
    county_fips_all: "04003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85609,
    lat: 32.06867,
    lng: -110.09714,
    city: "Dragoon",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 401,
    density: 1.3,
    county_fips: "04003",
    county_name: "Cochise",
    county_weights: {
      "04003": 100,
    },
    county_names_all: "Cochise",
    county_fips_all: "04003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85610,
    lat: 31.73144,
    lng: -109.65957,
    city: "Elfrida",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 854,
    density: 0.7,
    county_fips: "04003",
    county_name: "Cochise",
    county_weights: {
      "04003": 100,
    },
    county_names_all: "Cochise",
    county_fips_all: "04003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85611,
    lat: 31.64266,
    lng: -110.51334,
    city: "Elgin",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1246,
    density: 1.3,
    county_fips: "04023",
    county_name: "Santa Cruz",
    county_weights: {
      "04023": 49.66,
      "04019": 36,
      "04003": 14.34,
    },
    county_names_all: "Santa Cruz|Pima|Cochise",
    county_fips_all: "04023|04019|04003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85613,
    lat: 31.55393,
    lng: -110.38305,
    city: "Fort Huachuca",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5563,
    density: 37.7,
    county_fips: "04003",
    county_name: "Cochise",
    county_weights: {
      "04003": 100,
    },
    county_names_all: "Cochise",
    county_fips_all: "04003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85614,
    lat: 31.81241,
    lng: -110.92972,
    city: "Green Valley",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24890,
    density: 72.9,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 93.09,
      "04023": 6.91,
    },
    county_names_all: "Pima|Santa Cruz",
    county_fips_all: "04019|04023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85615,
    lat: 31.39678,
    lng: -110.2108,
    city: "Hereford",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9133,
    density: 19,
    county_fips: "04003",
    county_name: "Cochise",
    county_weights: {
      "04003": 100,
    },
    county_names_all: "Cochise",
    county_fips_all: "04003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85616,
    lat: 31.70768,
    lng: -110.32184,
    city: "Huachuca City",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5483,
    density: 14.1,
    county_fips: "04003",
    county_name: "Cochise",
    county_weights: {
      "04003": 100,
    },
    county_names_all: "Cochise",
    county_fips_all: "04003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85617,
    lat: 31.55767,
    lng: -109.71548,
    city: "McNeal",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1254,
    density: 2.2,
    county_fips: "04003",
    county_name: "Cochise",
    county_weights: {
      "04003": 100,
    },
    county_names_all: "Cochise",
    county_fips_all: "04003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85618,
    lat: 32.77631,
    lng: -110.69433,
    city: "Mammoth",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1796,
    density: 2.7,
    county_fips: "04021",
    county_name: "Pinal",
    county_weights: {
      "04021": 100,
    },
    county_names_all: "Pinal",
    county_fips_all: "04021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85619,
    lat: 32.39574,
    lng: -110.73663,
    city: "Mount Lemmon",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35,
    density: 0.1,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85620,
    lat: 31.33835,
    lng: -109.9431,
    city: "Naco",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 985,
    density: 329.6,
    county_fips: "04003",
    county_name: "Cochise",
    county_weights: {
      "04003": 100,
    },
    county_names_all: "Cochise",
    county_fips_all: "04003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85621,
    lat: 31.42345,
    lng: -111.03764,
    city: "Nogales",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21988,
    density: 29.8,
    county_fips: "04023",
    county_name: "Santa Cruz",
    county_weights: {
      "04023": 100,
    },
    county_names_all: "Santa Cruz",
    county_fips_all: "04023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85622,
    lat: 31.80301,
    lng: -111.09104,
    city: "Green Valley",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5785,
    density: 29,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85623,
    lat: 32.65407,
    lng: -110.78447,
    city: "Oracle",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5526,
    density: 11.3,
    county_fips: "04021",
    county_name: "Pinal",
    county_weights: {
      "04021": 100,
    },
    county_names_all: "Pinal",
    county_fips_all: "04021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85624,
    lat: 31.51768,
    lng: -110.71039,
    city: "Patagonia",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1334,
    density: 1.5,
    county_fips: "04023",
    county_name: "Santa Cruz",
    county_weights: {
      "04023": 100,
    },
    county_names_all: "Santa Cruz",
    county_fips_all: "04023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85625,
    lat: 31.88021,
    lng: -109.66692,
    city: "Pearce",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1975,
    density: 2.3,
    county_fips: "04003",
    county_name: "Cochise",
    county_weights: {
      "04003": 100,
    },
    county_names_all: "Cochise",
    county_fips_all: "04003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85626,
    lat: 31.35932,
    lng: -109.56827,
    city: "Pirtleville",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 817,
    density: 323.5,
    county_fips: "04003",
    county_name: "Cochise",
    county_weights: {
      "04003": 100,
    },
    county_names_all: "Cochise",
    county_fips_all: "04003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85627,
    lat: 32.00707,
    lng: -110.24695,
    city: "Pomerene",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1183,
    density: 41.2,
    county_fips: "04003",
    county_name: "Cochise",
    county_weights: {
      "04003": 100,
    },
    county_names_all: "Cochise",
    county_fips_all: "04003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85629,
    lat: 31.91413,
    lng: -111.01334,
    city: "Sahuarita",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25097,
    density: 41,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85630,
    lat: 31.88335,
    lng: -110.19447,
    city: "Saint David",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1889,
    density: 4.7,
    county_fips: "04003",
    county_name: "Cochise",
    county_weights: {
      "04003": 100,
    },
    county_names_all: "Cochise",
    county_fips_all: "04003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85631,
    lat: 32.58133,
    lng: -110.5627,
    city: "San Manuel",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3750,
    density: 12.2,
    county_fips: "04021",
    county_name: "Pinal",
    county_weights: {
      "04021": 100,
    },
    county_names_all: "Pinal",
    county_fips_all: "04021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85632,
    lat: 32.05855,
    lng: -109.18305,
    city: "San Simon",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 757,
    density: 0.4,
    county_fips: "04003",
    county_name: "Cochise",
    county_weights: {
      "04003": 100,
    },
    county_names_all: "Cochise",
    county_fips_all: "04003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85633,
    lat: 31.60632,
    lng: -111.52827,
    city: "Sasabe",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34,
    density: 0.1,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85634,
    lat: 32.02817,
    lng: -112.03296,
    city: "Sells",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6578,
    density: 0.9,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 98.43,
      "04021": 1.57,
    },
    county_names_all: "Pima|Pinal",
    county_fips_all: "04019|04021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85635,
    lat: 31.55322,
    lng: -110.17304,
    city: "Sierra Vista",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33427,
    density: 189.6,
    county_fips: "04003",
    county_name: "Cochise",
    county_weights: {
      "04003": 100,
    },
    county_names_all: "Cochise",
    county_fips_all: "04003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85637,
    lat: 31.72108,
    lng: -110.69258,
    city: "Sonoita",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1129,
    density: 3.5,
    county_fips: "04023",
    county_name: "Santa Cruz",
    county_weights: {
      "04023": 52.53,
      "04019": 47.47,
    },
    county_names_all: "Santa Cruz|Pima",
    county_fips_all: "04023|04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85638,
    lat: 31.68588,
    lng: -110.05887,
    city: "Tombstone",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1688,
    density: 2.4,
    county_fips: "04003",
    county_name: "Cochise",
    county_weights: {
      "04003": 100,
    },
    county_names_all: "Cochise",
    county_fips_all: "04003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85639,
    lat: 31.77175,
    lng: -111.68228,
    city: "Topawa",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85640,
    lat: 31.56755,
    lng: -111.04473,
    city: "Tumacacori",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 140,
    density: 19,
    county_fips: "04023",
    county_name: "Santa Cruz",
    county_weights: {
      "04023": 100,
    },
    county_names_all: "Santa Cruz",
    county_fips_all: "04023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85641,
    lat: 32.02125,
    lng: -110.64617,
    city: "Vail",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28966,
    density: 32.6,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85643,
    lat: 32.43757,
    lng: -109.98521,
    city: "Willcox",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8771,
    density: 1.5,
    county_fips: "04009",
    county_name: "Graham",
    county_weights: {
      "04009": 51.49,
      "04003": 48.51,
    },
    county_names_all: "Graham|Cochise",
    county_fips_all: "04009|04003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85645,
    lat: 31.69497,
    lng: -111.14655,
    city: "Amado",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2028,
    density: 4.9,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 61.99,
      "04023": 38.01,
    },
    county_names_all: "Pima|Santa Cruz",
    county_fips_all: "04019|04023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85646,
    lat: 31.62009,
    lng: -111.05192,
    city: "Tubac",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1210,
    density: 6.8,
    county_fips: "04023",
    county_name: "Santa Cruz",
    county_weights: {
      "04023": 100,
    },
    county_names_all: "Santa Cruz",
    county_fips_all: "04023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85648,
    lat: 31.51262,
    lng: -111.00807,
    city: "Rio Rico",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20064,
    density: 36,
    county_fips: "04023",
    county_name: "Santa Cruz",
    county_weights: {
      "04023": 100,
    },
    county_names_all: "Santa Cruz",
    county_fips_all: "04023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85650,
    lat: 31.49759,
    lng: -110.19906,
    city: "Sierra Vista",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15799,
    density: 147.7,
    county_fips: "04003",
    county_name: "Cochise",
    county_weights: {
      "04003": 100,
    },
    county_names_all: "Cochise",
    county_fips_all: "04003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85653,
    lat: 32.38979,
    lng: -111.37908,
    city: "Marana",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21629,
    density: 24.3,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 94.9,
      "04021": 5.1,
    },
    county_names_all: "Pima|Pinal",
    county_fips_all: "04019|04021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85654,
    lat: 32.41529,
    lng: -111.15467,
    city: "Rillito",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85658,
    lat: 32.52455,
    lng: -111.13603,
    city: "Marana",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10797,
    density: 21.4,
    county_fips: "04021",
    county_name: "Pinal",
    county_weights: {
      "04021": 64.58,
      "04019": 35.42,
    },
    county_names_all: "Pinal|Pima",
    county_fips_all: "04021|04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85701,
    lat: 32.21702,
    lng: -110.97138,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5279,
    density: 1380.2,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85704,
    lat: 32.33885,
    lng: -110.98483,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34413,
    density: 729.9,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85705,
    lat: 32.27119,
    lng: -110.99172,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57449,
    density: 1627.9,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85706,
    lat: 32.14783,
    lng: -110.93541,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57712,
    density: 1699.1,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85707,
    lat: 32.18022,
    lng: -110.88966,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 717,
    density: 67.2,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85708,
    lat: 32.17575,
    lng: -110.86019,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4009,
    density: 535.9,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85709,
    lat: 32.14136,
    lng: -110.99008,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85710,
    lat: 32.21439,
    lng: -110.82365,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53002,
    density: 1711,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85711,
    lat: 32.21504,
    lng: -110.88348,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41266,
    density: 1849.2,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85712,
    lat: 32.25229,
    lng: -110.88636,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32494,
    density: 1832.4,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85713,
    lat: 32.19525,
    lng: -111.0151,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47477,
    density: 769.1,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85714,
    lat: 32.16997,
    lng: -110.94653,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14449,
    density: 989.9,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85715,
    lat: 32.24898,
    lng: -110.83118,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19532,
    density: 1151,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85716,
    lat: 32.24222,
    lng: -110.92351,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30850,
    density: 1654.6,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85718,
    lat: 32.31078,
    lng: -110.91819,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26364,
    density: 430.6,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85719,
    lat: 32.2462,
    lng: -110.94876,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48196,
    density: 2336.3,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85721,
    lat: 32.23107,
    lng: -110.94957,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85723,
    lat: 32.18189,
    lng: -110.96496,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85724,
    lat: 32.24072,
    lng: -110.94555,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85726,
    lat: 32.20437,
    lng: -110.94529,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85730,
    lat: 32.19064,
    lng: -110.72976,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38755,
    density: 398.8,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85734,
    lat: 32.06761,
    lng: -110.86717,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85735,
    lat: 32.10389,
    lng: -111.33437,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10457,
    density: 23.1,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85736,
    lat: 31.87623,
    lng: -111.37472,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4404,
    density: 4,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85737,
    lat: 32.41425,
    lng: -110.94683,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22398,
    density: 364.8,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85739,
    lat: 32.6137,
    lng: -111.00758,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18952,
    density: 28.6,
    county_fips: "04021",
    county_name: "Pinal",
    county_weights: {
      "04021": 86.99,
      "04019": 13.01,
    },
    county_names_all: "Pinal|Pima",
    county_fips_all: "04021|04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85741,
    lat: 32.3364,
    lng: -111.04077,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34079,
    density: 1384,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85742,
    lat: 32.3898,
    lng: -111.05113,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28812,
    density: 498.9,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85743,
    lat: 32.30501,
    lng: -111.18548,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30443,
    density: 99.4,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85745,
    lat: 32.25014,
    lng: -111.06253,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39211,
    density: 322.3,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85746,
    lat: 32.06964,
    lng: -111.09047,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48383,
    density: 161.2,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85747,
    lat: 32.09318,
    lng: -110.7723,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26113,
    density: 150.5,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85748,
    lat: 32.21904,
    lng: -110.75205,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19646,
    density: 634.1,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85749,
    lat: 32.28129,
    lng: -110.72604,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19055,
    density: 152.2,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85750,
    lat: 32.29952,
    lng: -110.84288,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24814,
    density: 527.2,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85755,
    lat: 32.46836,
    lng: -110.98152,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17100,
    density: 195.1,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85756,
    lat: 32.07034,
    lng: -110.90625,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43677,
    density: 180.1,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85757,
    lat: 32.12835,
    lng: -111.12228,
    city: "Tucson",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20100,
    density: 303.3,
    county_fips: "04019",
    county_name: "Pima",
    county_weights: {
      "04019": 100,
    },
    county_names_all: "Pima",
    county_fips_all: "04019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85901,
    lat: 34.29348,
    lng: -109.99878,
    city: "Show Low",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18416,
    density: 27,
    county_fips: "04017",
    county_name: "Navajo",
    county_weights: {
      "04017": 89.55,
      "04001": 10.45,
    },
    county_names_all: "Navajo|Apache",
    county_fips_all: "04017|04001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85902,
    lat: 34.11509,
    lng: -110.16233,
    city: "Show Low",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "04017",
    county_name: "Navajo",
    county_weights: {
      "04017": 100,
    },
    county_names_all: "Navajo",
    county_fips_all: "04017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85911,
    lat: 34.14844,
    lng: -110.4588,
    city: "Cibecue",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1864,
    density: 2.1,
    county_fips: "04017",
    county_name: "Navajo",
    county_weights: {
      "04017": 100,
    },
    county_names_all: "Navajo",
    county_fips_all: "04017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85912,
    lat: 34.41962,
    lng: -109.91624,
    city: "White Mountain Lake",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 344,
    density: 3.3,
    county_fips: "04017",
    county_name: "Navajo",
    county_weights: {
      "04017": 100,
    },
    county_names_all: "Navajo",
    county_fips_all: "04017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85920,
    lat: 33.85995,
    lng: -109.1753,
    city: "Alpine",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 554,
    density: 2,
    county_fips: "04001",
    county_name: "Apache",
    county_weights: {
      "04001": 100,
    },
    county_names_all: "Apache",
    county_fips_all: "04001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85922,
    lat: 33.49535,
    lng: -109.18864,
    city: "Blue",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51,
    density: 0,
    county_fips: "04011",
    county_name: "Greenlee",
    county_weights: {
      "04011": 100,
    },
    county_names_all: "Greenlee",
    county_fips_all: "04011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85923,
    lat: 34.32313,
    lng: -110.34036,
    city: "Clay Springs",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 568,
    density: 3.6,
    county_fips: "04017",
    county_name: "Navajo",
    county_weights: {
      "04017": 100,
    },
    county_names_all: "Navajo",
    county_fips_all: "04017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85924,
    lat: 34.5635,
    lng: -109.67553,
    city: "Concho",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2502,
    density: 1.4,
    county_fips: "04001",
    county_name: "Apache",
    county_weights: {
      "04001": 100,
    },
    county_names_all: "Apache",
    county_fips_all: "04001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85925,
    lat: 34.0162,
    lng: -109.3557,
    city: "Eagar",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5049,
    density: 23.6,
    county_fips: "04001",
    county_name: "Apache",
    county_weights: {
      "04001": 100,
    },
    county_names_all: "Apache",
    county_fips_all: "04001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85926,
    lat: 33.77507,
    lng: -109.9788,
    city: "Fort Apache",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 684,
    density: 36.8,
    county_fips: "04017",
    county_name: "Navajo",
    county_weights: {
      "04017": 100,
    },
    county_names_all: "Navajo",
    county_fips_all: "04017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85927,
    lat: 33.99572,
    lng: -109.48079,
    city: "Greer",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 129,
    density: 0.4,
    county_fips: "04001",
    county_name: "Apache",
    county_weights: {
      "04001": 100,
    },
    county_names_all: "Apache",
    county_fips_all: "04001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85928,
    lat: 34.52276,
    lng: -110.5506,
    city: "Heber",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1258,
    density: 1.6,
    county_fips: "04017",
    county_name: "Navajo",
    county_weights: {
      "04017": 100,
    },
    county_names_all: "Navajo",
    county_fips_all: "04017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85929,
    lat: 34.16512,
    lng: -109.95948,
    city: "Lakeside",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7173,
    density: 81.2,
    county_fips: "04017",
    county_name: "Navajo",
    county_weights: {
      "04017": 100,
    },
    county_names_all: "Navajo",
    county_fips_all: "04017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85930,
    lat: 34.02744,
    lng: -109.77141,
    city: "Mcnary",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1444,
    density: 4.2,
    county_fips: "04001",
    county_name: "Apache",
    county_weights: {
      "04001": 88.57,
      "04017": 11.43,
    },
    county_names_all: "Apache|Navajo",
    county_fips_all: "04001|04017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85931,
    lat: 34.45238,
    lng: -110.87003,
    city: "Forest Lakes",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 197,
    density: 0.2,
    county_fips: "04005",
    county_name: "Coconino",
    county_weights: {
      "04005": 100,
    },
    county_names_all: "Coconino",
    county_fips_all: "04005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85932,
    lat: 33.95958,
    lng: -109.1943,
    city: "Nutrioso",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 664,
    density: 2.1,
    county_fips: "04001",
    county_name: "Apache",
    county_weights: {
      "04001": 100,
    },
    county_names_all: "Apache",
    county_fips_all: "04001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85933,
    lat: 34.36089,
    lng: -110.50955,
    city: "Overgaard",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2548,
    density: 10.3,
    county_fips: "04017",
    county_name: "Navajo",
    county_weights: {
      "04017": 100,
    },
    county_names_all: "Navajo",
    county_fips_all: "04017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85934,
    lat: 34.30251,
    lng: -110.24432,
    city: "Pinedale",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 405,
    density: 2.6,
    county_fips: "04017",
    county_name: "Navajo",
    county_weights: {
      "04017": 100,
    },
    county_names_all: "Navajo",
    county_fips_all: "04017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85935,
    lat: 34.14166,
    lng: -109.90453,
    city: "Pinetop",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5021,
    density: 42.9,
    county_fips: "04017",
    county_name: "Navajo",
    county_weights: {
      "04017": 100,
    },
    county_names_all: "Navajo",
    county_fips_all: "04017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85936,
    lat: 34.60662,
    lng: -109.29134,
    city: "Saint Johns",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4283,
    density: 1.5,
    county_fips: "04001",
    county_name: "Apache",
    county_weights: {
      "04001": 100,
    },
    county_names_all: "Apache",
    county_fips_all: "04001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85937,
    lat: 34.56927,
    lng: -110.01285,
    city: "Snowflake",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8734,
    density: 11.6,
    county_fips: "04017",
    county_name: "Navajo",
    county_weights: {
      "04017": 100,
    },
    county_names_all: "Navajo",
    county_fips_all: "04017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85938,
    lat: 34.17814,
    lng: -109.40089,
    city: "Springerville",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2391,
    density: 3.8,
    county_fips: "04001",
    county_name: "Apache",
    county_weights: {
      "04001": 100,
    },
    county_names_all: "Apache",
    county_fips_all: "04001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85939,
    lat: 34.43729,
    lng: -110.08754,
    city: "Taylor",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4380,
    density: 31.4,
    county_fips: "04017",
    county_name: "Navajo",
    county_weights: {
      "04017": 100,
    },
    county_names_all: "Navajo",
    county_fips_all: "04017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85940,
    lat: 34.25265,
    lng: -109.69729,
    city: "Vernon",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1341,
    density: 5.3,
    county_fips: "04001",
    county_name: "Apache",
    county_weights: {
      "04001": 100,
    },
    county_names_all: "Apache",
    county_fips_all: "04001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85941,
    lat: 33.88756,
    lng: -110.0648,
    city: "Whiteriver",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11320,
    density: 9.2,
    county_fips: "04007",
    county_name: "Gila",
    county_weights: {
      "04007": 60.25,
      "04017": 39.75,
    },
    county_names_all: "Gila|Navajo",
    county_fips_all: "04007|04017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 85942,
    lat: 34.77442,
    lng: -110.03549,
    city: "Woodruff",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21,
    density: 1.4,
    county_fips: "04017",
    county_name: "Navajo",
    county_weights: {
      "04017": 100,
    },
    county_names_all: "Navajo",
    county_fips_all: "04017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86001,
    lat: 35.35119,
    lng: -111.75607,
    city: "Flagstaff",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45396,
    density: 60.3,
    county_fips: "04005",
    county_name: "Coconino",
    county_weights: {
      "04005": 100,
    },
    county_names_all: "Coconino",
    county_fips_all: "04005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86003,
    lat: 35.24259,
    lng: -111.20202,
    city: "Flagstaff",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21,
    density: 0.2,
    county_fips: "04005",
    county_name: "Coconino",
    county_weights: {
      "04005": 100,
    },
    county_names_all: "Coconino",
    county_fips_all: "04005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86004,
    lat: 35.37546,
    lng: -111.37515,
    city: "Flagstaff",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35703,
    density: 15.1,
    county_fips: "04005",
    county_name: "Coconino",
    county_weights: {
      "04005": 100,
    },
    county_names_all: "Coconino",
    county_fips_all: "04005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86005,
    lat: 35.08125,
    lng: -111.62832,
    city: "Flagstaff",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "04005",
    county_name: "Coconino",
    county_weights: {
      "04005": 100,
    },
    county_names_all: "Coconino",
    county_fips_all: "04005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86011,
    lat: 35.18953,
    lng: -111.65469,
    city: "Flagstaff",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10836,
    density: 32998.2,
    county_fips: "04005",
    county_name: "Coconino",
    county_weights: {
      "04005": 100,
    },
    county_names_all: "Coconino",
    county_fips_all: "04005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86015,
    lat: 35.22408,
    lng: -111.80972,
    city: "Bellemont",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 364,
    density: 8.1,
    county_fips: "04005",
    county_name: "Coconino",
    county_weights: {
      "04005": 100,
    },
    county_names_all: "Coconino",
    county_fips_all: "04005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86016,
    lat: 35.74486,
    lng: -111.6373,
    city: "Gray Mountain",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33,
    density: 0.2,
    county_fips: "04005",
    county_name: "Coconino",
    county_weights: {
      "04005": 100,
    },
    county_names_all: "Coconino",
    county_fips_all: "04005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86017,
    lat: 34.91938,
    lng: -111.66077,
    city: "Munds Park",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 755,
    density: 2.8,
    county_fips: "04005",
    county_name: "Coconino",
    county_weights: {
      "04005": 100,
    },
    county_names_all: "Coconino",
    county_fips_all: "04005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86018,
    lat: 35.24716,
    lng: -111.96204,
    city: "Parks",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 619,
    density: 1.3,
    county_fips: "04005",
    county_name: "Coconino",
    county_weights: {
      "04005": 100,
    },
    county_names_all: "Coconino",
    county_fips_all: "04005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86020,
    lat: 36.00133,
    lng: -111.51263,
    city: "Cameron",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1884,
    density: 0.6,
    county_fips: "04005",
    county_name: "Coconino",
    county_weights: {
      "04005": 100,
    },
    county_names_all: "Coconino",
    county_fips_all: "04005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86021,
    lat: 36.92707,
    lng: -113.10205,
    city: "Colorado City",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5959,
    density: 13.3,
    county_fips: "04015",
    county_name: "Mohave",
    county_weights: {
      "04015": 100,
    },
    county_names_all: "Mohave",
    county_fips_all: "04015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86022,
    lat: 36.7702,
    lng: -112.5449,
    city: "Fredonia",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1885,
    density: 0.9,
    county_fips: "04005",
    county_name: "Coconino",
    county_weights: {
      "04005": 67.58,
      "04015": 32.42,
    },
    county_names_all: "Coconino|Mohave",
    county_fips_all: "04005|04015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86023,
    lat: 36.13498,
    lng: -112.23438,
    city: "Grand Canyon",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2316,
    density: 2.1,
    county_fips: "04005",
    county_name: "Coconino",
    county_weights: {
      "04005": 100,
    },
    county_names_all: "Coconino",
    county_fips_all: "04005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86024,
    lat: 34.68509,
    lng: -111.20244,
    city: "Happy Jack",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 908,
    density: 0.5,
    county_fips: "04005",
    county_name: "Coconino",
    county_weights: {
      "04005": 100,
    },
    county_names_all: "Coconino",
    county_fips_all: "04005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86025,
    lat: 34.90484,
    lng: -110.08557,
    city: "Holbrook",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5607,
    density: 2.9,
    county_fips: "04017",
    county_name: "Navajo",
    county_weights: {
      "04017": 100,
    },
    county_names_all: "Navajo",
    county_fips_all: "04017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86028,
    lat: 35.02873,
    lng: -109.81056,
    city: "Petrified Forest Natl Pk",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67,
    density: 1.8,
    county_fips: "04001",
    county_name: "Apache",
    county_weights: {
      "04001": 100,
    },
    county_names_all: "Apache",
    county_fips_all: "04001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86029,
    lat: 34.96834,
    lng: -110.01175,
    city: "Sun Valley",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 93,
    density: 1.3,
    county_fips: "04017",
    county_name: "Navajo",
    county_weights: {
      "04017": 100,
    },
    county_names_all: "Navajo",
    county_fips_all: "04017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86030,
    lat: 35.87005,
    lng: -110.80709,
    city: "Hotevilla",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1734,
    density: 3.2,
    county_fips: "04005",
    county_name: "Coconino",
    county_weights: {
      "04005": 73.23,
      "04017": 26.77,
    },
    county_names_all: "Coconino|Navajo",
    county_fips_all: "04005|04017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86031,
    lat: 35.3534,
    lng: -110.0647,
    city: "Indian Wells",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1749,
    density: 1.4,
    county_fips: "04017",
    county_name: "Navajo",
    county_weights: {
      "04017": 100,
    },
    county_names_all: "Navajo",
    county_fips_all: "04017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86032,
    lat: 35.04288,
    lng: -110.32234,
    city: "Joseph City",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2034,
    density: 3.8,
    county_fips: "04017",
    county_name: "Navajo",
    county_weights: {
      "04017": 100,
    },
    county_names_all: "Navajo",
    county_fips_all: "04017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86033,
    lat: 36.67692,
    lng: -110.25536,
    city: "Kayenta",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8080,
    density: 2.6,
    county_fips: "04017",
    county_name: "Navajo",
    county_weights: {
      "04017": 95.09,
      "04001": 4.91,
    },
    county_names_all: "Navajo|Apache",
    county_fips_all: "04017|04001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86034,
    lat: 35.77145,
    lng: -110.138,
    city: "Keams Canyon",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1842,
    density: 1.5,
    county_fips: "04017",
    county_name: "Navajo",
    county_weights: {
      "04017": 92.61,
      "04001": 7.39,
    },
    county_names_all: "Navajo|Apache",
    county_fips_all: "04017|04001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86035,
    lat: 35.39631,
    lng: -111.02806,
    city: "Leupp",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1980,
    density: 1.6,
    county_fips: "04005",
    county_name: "Coconino",
    county_weights: {
      "04005": 100,
    },
    county_names_all: "Coconino",
    county_fips_all: "04005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86036,
    lat: 36.72434,
    lng: -111.82083,
    city: "Marble Canyon",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 537,
    density: 0.2,
    county_fips: "04005",
    county_name: "Coconino",
    county_weights: {
      "04005": 100,
    },
    county_names_all: "Coconino",
    county_fips_all: "04005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86038,
    lat: 34.9018,
    lng: -111.49161,
    city: "Mormon Lake",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55,
    density: 0.2,
    county_fips: "04005",
    county_name: "Coconino",
    county_weights: {
      "04005": 100,
    },
    county_names_all: "Coconino",
    county_fips_all: "04005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86039,
    lat: 35.98813,
    lng: -110.56688,
    city: "Kykotsmovi Village",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1296,
    density: 2,
    county_fips: "04017",
    county_name: "Navajo",
    county_weights: {
      "04017": 100,
    },
    county_names_all: "Navajo",
    county_fips_all: "04017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86040,
    lat: 36.66294,
    lng: -111.3852,
    city: "Page",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10599,
    density: 4.6,
    county_fips: "04005",
    county_name: "Coconino",
    county_weights: {
      "04005": 100,
    },
    county_names_all: "Coconino",
    county_fips_all: "04005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86042,
    lat: 35.86498,
    lng: -110.38447,
    city: "Polacca",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2419,
    density: 15.2,
    county_fips: "04017",
    county_name: "Navajo",
    county_weights: {
      "04017": 100,
    },
    county_names_all: "Navajo",
    county_fips_all: "04017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86043,
    lat: 35.81049,
    lng: -110.52904,
    city: "Second Mesa",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3036,
    density: 10.2,
    county_fips: "04017",
    county_name: "Navajo",
    county_weights: {
      "04017": 100,
    },
    county_names_all: "Navajo",
    county_fips_all: "04017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86044,
    lat: 36.75137,
    lng: -110.82626,
    city: "Tonalea",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3301,
    density: 1.1,
    county_fips: "04005",
    county_name: "Coconino",
    county_weights: {
      49037: 31.59,
      "04005": 55.31,
      "04017": 13.1,
    },
    county_names_all: "Coconino|San Juan|Navajo",
    county_fips_all: "04005|49037|04017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86045,
    lat: 36.14775,
    lng: -111.13344,
    city: "Tuba City",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12149,
    density: 6.5,
    county_fips: "04005",
    county_name: "Coconino",
    county_weights: {
      "04005": 100,
    },
    county_names_all: "Coconino",
    county_fips_all: "04005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86046,
    lat: 35.43882,
    lng: -112.17428,
    city: "Williams",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6053,
    density: 2.5,
    county_fips: "04005",
    county_name: "Coconino",
    county_weights: {
      "04005": 100,
    },
    county_names_all: "Coconino",
    county_fips_all: "04005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86047,
    lat: 35.18181,
    lng: -110.63785,
    city: "Winslow",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15403,
    density: 3.5,
    county_fips: "04017",
    county_name: "Navajo",
    county_weights: {
      "04017": 71.59,
      "04005": 28.41,
    },
    county_names_all: "Navajo|Coconino",
    county_fips_all: "04017|04005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86052,
    lat: 36.29112,
    lng: -112.12543,
    city: "North Rim",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 316,
    density: 0.1,
    county_fips: "04005",
    county_name: "Coconino",
    county_weights: {
      "04005": 100,
    },
    county_names_all: "Coconino",
    county_fips_all: "04005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86053,
    lat: 36.75699,
    lng: -111.05597,
    city: "Kaibeto",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2865,
    density: 1.8,
    county_fips: "04005",
    county_name: "Coconino",
    county_weights: {
      "04005": 100,
    },
    county_names_all: "Coconino",
    county_fips_all: "04005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86054,
    lat: 36.67546,
    lng: -110.61259,
    city: "Shonto",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1422,
    density: 1.3,
    county_fips: "04017",
    county_name: "Navajo",
    county_weights: {
      "04017": 94.09,
      "04005": 5.91,
    },
    county_names_all: "Navajo|Coconino",
    county_fips_all: "04017|04005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86301,
    lat: 34.59452,
    lng: -112.42454,
    city: "Prescott",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23882,
    density: 276.1,
    county_fips: "04025",
    county_name: "Yavapai",
    county_weights: {
      "04025": 100,
    },
    county_names_all: "Yavapai",
    county_fips_all: "04025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86303,
    lat: 34.4894,
    lng: -112.42897,
    city: "Prescott",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17955,
    density: 64.7,
    county_fips: "04025",
    county_name: "Yavapai",
    county_weights: {
      "04025": 100,
    },
    county_names_all: "Yavapai",
    county_fips_all: "04025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86305,
    lat: 34.7906,
    lng: -112.75229,
    city: "Prescott",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19022,
    density: 12.5,
    county_fips: "04025",
    county_name: "Yavapai",
    county_weights: {
      "04025": 100,
    },
    county_names_all: "Yavapai",
    county_fips_all: "04025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86313,
    lat: 34.55416,
    lng: -112.45288,
    city: "Prescott",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 322,
    density: 506.2,
    county_fips: "04025",
    county_name: "Yavapai",
    county_weights: {
      "04025": 100,
    },
    county_names_all: "Yavapai",
    county_fips_all: "04025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86314,
    lat: 34.59823,
    lng: -112.33079,
    city: "Prescott Valley",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39335,
    density: 571.3,
    county_fips: "04025",
    county_name: "Yavapai",
    county_weights: {
      "04025": 100,
    },
    county_names_all: "Yavapai",
    county_fips_all: "04025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86315,
    lat: 34.67403,
    lng: -112.2891,
    city: "Prescott Valley",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8001,
    density: 34.9,
    county_fips: "04025",
    county_name: "Yavapai",
    county_weights: {
      "04025": 100,
    },
    county_names_all: "Yavapai",
    county_fips_all: "04025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86320,
    lat: 35.36745,
    lng: -112.63995,
    city: "Ash Fork",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2437,
    density: 1.2,
    county_fips: "04005",
    county_name: "Coconino",
    county_weights: {
      "04005": 70.43,
      "04025": 29.57,
    },
    county_names_all: "Coconino|Yavapai",
    county_fips_all: "04005|04025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86321,
    lat: 34.55367,
    lng: -113.08895,
    city: "Bagdad",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2509,
    density: 2.4,
    county_fips: "04025",
    county_name: "Yavapai",
    county_weights: {
      "04025": 100,
    },
    county_names_all: "Yavapai",
    county_fips_all: "04025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86322,
    lat: 34.47486,
    lng: -111.80587,
    city: "Camp Verde",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11868,
    density: 14.3,
    county_fips: "04025",
    county_name: "Yavapai",
    county_weights: {
      "04025": 100,
    },
    county_names_all: "Yavapai",
    county_fips_all: "04025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86323,
    lat: 34.76606,
    lng: -112.40424,
    city: "Chino Valley",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17032,
    density: 57.3,
    county_fips: "04025",
    county_name: "Yavapai",
    county_weights: {
      "04025": 100,
    },
    county_names_all: "Yavapai",
    county_fips_all: "04025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86324,
    lat: 34.836,
    lng: -112.1304,
    city: "Clarkdale",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4367,
    density: 6.5,
    county_fips: "04025",
    county_name: "Yavapai",
    county_weights: {
      "04025": 100,
    },
    county_names_all: "Yavapai",
    county_fips_all: "04025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86325,
    lat: 34.73347,
    lng: -111.89884,
    city: "Cornville",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5608,
    density: 35.3,
    county_fips: "04025",
    county_name: "Yavapai",
    county_weights: {
      "04025": 100,
    },
    county_names_all: "Yavapai",
    county_fips_all: "04025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86326,
    lat: 34.69857,
    lng: -112.01383,
    city: "Cottonwood",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25300,
    density: 214.9,
    county_fips: "04025",
    county_name: "Yavapai",
    county_weights: {
      "04025": 100,
    },
    county_names_all: "Yavapai",
    county_fips_all: "04025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86327,
    lat: 34.55682,
    lng: -112.11089,
    city: "Dewey",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10593,
    density: 15.9,
    county_fips: "04025",
    county_name: "Yavapai",
    county_weights: {
      "04025": 100,
    },
    county_names_all: "Yavapai",
    county_fips_all: "04025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86329,
    lat: 34.48589,
    lng: -112.27666,
    city: "Humboldt",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1416,
    density: 32.9,
    county_fips: "04025",
    county_name: "Yavapai",
    county_weights: {
      "04025": 100,
    },
    county_names_all: "Yavapai",
    county_fips_all: "04025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86331,
    lat: 34.76009,
    lng: -112.11704,
    city: "Jerome",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 416,
    density: 24.2,
    county_fips: "04025",
    county_name: "Yavapai",
    county_weights: {
      "04025": 100,
    },
    county_names_all: "Yavapai",
    county_fips_all: "04025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86332,
    lat: 34.30403,
    lng: -112.61809,
    city: "Kirkland",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2191,
    density: 1.6,
    county_fips: "04025",
    county_name: "Yavapai",
    county_weights: {
      "04025": 100,
    },
    county_names_all: "Yavapai",
    county_fips_all: "04025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86333,
    lat: 34.32195,
    lng: -112.08352,
    city: "Mayer",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7960,
    density: 6.2,
    county_fips: "04025",
    county_name: "Yavapai",
    county_weights: {
      "04025": 100,
    },
    county_names_all: "Yavapai",
    county_fips_all: "04025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86334,
    lat: 34.94847,
    lng: -112.53946,
    city: "Paulden",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4778,
    density: 7.2,
    county_fips: "04025",
    county_name: "Yavapai",
    county_weights: {
      "04025": 100,
    },
    county_names_all: "Yavapai",
    county_fips_all: "04025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86335,
    lat: 34.65216,
    lng: -111.68044,
    city: "Rimrock",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4868,
    density: 6.9,
    county_fips: "04025",
    county_name: "Yavapai",
    county_weights: {
      "04025": 100,
    },
    county_names_all: "Yavapai",
    county_fips_all: "04025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86336,
    lat: 34.8902,
    lng: -111.85157,
    city: "Sedona",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11621,
    density: 22,
    county_fips: "04025",
    county_name: "Yavapai",
    county_weights: {
      "04025": 72.91,
      "04005": 27.09,
    },
    county_names_all: "Yavapai|Coconino",
    county_fips_all: "04025|04005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86337,
    lat: 35.24422,
    lng: -113.0505,
    city: "Seligman",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1523,
    density: 0.3,
    county_fips: "04025",
    county_name: "Yavapai",
    county_weights: {
      "04025": 75.22,
      "04005": 24.78,
    },
    county_names_all: "Yavapai|Coconino",
    county_fips_all: "04025|04005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86338,
    lat: 34.57306,
    lng: -112.75756,
    city: "Skull Valley",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 408,
    density: 0.5,
    county_fips: "04025",
    county_name: "Yavapai",
    county_weights: {
      "04025": 100,
    },
    county_names_all: "Yavapai",
    county_fips_all: "04025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86343,
    lat: 34.17937,
    lng: -112.31236,
    city: "Crown King",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 83,
    density: 0.4,
    county_fips: "04025",
    county_name: "Yavapai",
    county_weights: {
      "04025": 100,
    },
    county_names_all: "Yavapai",
    county_fips_all: "04025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86351,
    lat: 34.77846,
    lng: -111.78514,
    city: "Sedona",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6494,
    density: 62.7,
    county_fips: "04025",
    county_name: "Yavapai",
    county_weights: {
      "04025": 100,
    },
    county_names_all: "Yavapai",
    county_fips_all: "04025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86401,
    lat: 35.11024,
    lng: -113.70423,
    city: "Kingman",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27059,
    density: 8.5,
    county_fips: "04015",
    county_name: "Mohave",
    county_weights: {
      "04015": 100,
    },
    county_names_all: "Mohave",
    county_fips_all: "04015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86403,
    lat: 34.47703,
    lng: -114.34423,
    city: "Lake Havasu City",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19123,
    density: 669.9,
    county_fips: "04015",
    county_name: "Mohave",
    county_weights: {
      "04015": 100,
    },
    county_names_all: "Mohave",
    county_fips_all: "04015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 86404,
    lat: 34.61156,
    lng: -114.29452,
    city: "Lake Havasu City",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16451,
    density: 39.3,
    county_fips: "04015",
    county_name: "Mohave",
    county_weights: {
      "04015": 100,
    },
    county_names_all: "Mohave",
    county_fips_all: "04015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86406,
    lat: 34.42269,
    lng: -114.12418,
    city: "Lake Havasu City",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23069,
    density: 36.4,
    county_fips: "04015",
    county_name: "Mohave",
    county_weights: {
      "04015": 100,
    },
    county_names_all: "Mohave",
    county_fips_all: "04015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86409,
    lat: 35.46429,
    lng: -114.03245,
    city: "Kingman",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29045,
    density: 30.7,
    county_fips: "04015",
    county_name: "Mohave",
    county_weights: {
      "04015": 100,
    },
    county_names_all: "Mohave",
    county_fips_all: "04015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86411,
    lat: 35.44761,
    lng: -113.74381,
    city: "Hackberry",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 181,
    density: 0.2,
    county_fips: "04015",
    county_name: "Mohave",
    county_weights: {
      "04015": 100,
    },
    county_names_all: "Mohave",
    county_fips_all: "04015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86413,
    lat: 35.16995,
    lng: -114.25695,
    city: "Golden Valley",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12033,
    density: 10.9,
    county_fips: "04015",
    county_name: "Mohave",
    county_weights: {
      "04015": 100,
    },
    county_names_all: "Mohave",
    county_fips_all: "04015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86426,
    lat: 35.0134,
    lng: -114.54968,
    city: "Fort Mohave",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15326,
    density: 169.6,
    county_fips: "04015",
    county_name: "Mohave",
    county_weights: {
      "04015": 100,
    },
    county_names_all: "Mohave",
    county_fips_all: "04015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86429,
    lat: 35.28769,
    lng: -114.51261,
    city: "Bullhead City",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8415,
    density: 11.8,
    county_fips: "04015",
    county_name: "Mohave",
    county_weights: {
      "04015": 100,
    },
    county_names_all: "Mohave",
    county_fips_all: "04015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86431,
    lat: 35.42521,
    lng: -114.24738,
    city: "Chloride",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 419,
    density: 2.2,
    county_fips: "04015",
    county_name: "Mohave",
    county_weights: {
      "04015": 100,
    },
    county_names_all: "Mohave",
    county_fips_all: "04015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86432,
    lat: 36.79085,
    lng: -113.73783,
    city: "Littlefield",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3815,
    density: 1.4,
    county_fips: "04015",
    county_name: "Mohave",
    county_weights: {
      "04015": 100,
    },
    county_names_all: "Mohave",
    county_fips_all: "04015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86433,
    lat: 34.92862,
    lng: -114.35853,
    city: "Oatman",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43,
    density: 0.1,
    county_fips: "04015",
    county_name: "Mohave",
    county_weights: {
      "04015": 100,
    },
    county_names_all: "Mohave",
    county_fips_all: "04015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86434,
    lat: 35.65959,
    lng: -113.58538,
    city: "Peach Springs",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1764,
    density: 0.8,
    county_fips: "04015",
    county_name: "Mohave",
    county_weights: {
      "04015": 95.14,
      "04025": 3.92,
      "04005": 0.94,
    },
    county_names_all: "Mohave|Yavapai|Coconino",
    county_fips_all: "04015|04025|04005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86435,
    lat: 36.00915,
    lng: -112.94567,
    city: "Supai",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "04005",
    county_name: "Coconino",
    county_weights: {
      "04005": 100,
    },
    county_names_all: "Coconino",
    county_fips_all: "04005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86436,
    lat: 34.73914,
    lng: -114.42273,
    city: "Topock",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1282,
    density: 5.7,
    county_fips: "04015",
    county_name: "Mohave",
    county_weights: {
      "04015": 100,
    },
    county_names_all: "Mohave",
    county_fips_all: "04015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86437,
    lat: 35.39511,
    lng: -113.59784,
    city: "Valentine",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 129,
    density: 0.5,
    county_fips: "04015",
    county_name: "Mohave",
    county_weights: {
      "04015": 100,
    },
    county_names_all: "Mohave",
    county_fips_all: "04015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86438,
    lat: 34.68595,
    lng: -113.98175,
    city: "Yucca",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 794,
    density: 0.3,
    county_fips: "04015",
    county_name: "Mohave",
    county_weights: {
      "04015": 100,
    },
    county_names_all: "Mohave",
    county_fips_all: "04015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86440,
    lat: 34.88855,
    lng: -114.54071,
    city: "Mohave Valley",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7773,
    density: 24.3,
    county_fips: "04015",
    county_name: "Mohave",
    county_weights: {
      "04015": 100,
    },
    county_names_all: "Mohave",
    county_fips_all: "04015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86441,
    lat: 35.56205,
    lng: -114.30384,
    city: "Dolan Springs",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2066,
    density: 2.1,
    county_fips: "04015",
    county_name: "Mohave",
    county_weights: {
      "04015": 100,
    },
    county_names_all: "Mohave",
    county_fips_all: "04015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86442,
    lat: 35.09139,
    lng: -114.57731,
    city: "Bullhead City",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33686,
    density: 461.8,
    county_fips: "04015",
    county_name: "Mohave",
    county_weights: {
      "04015": 100,
    },
    county_names_all: "Mohave",
    county_fips_all: "04015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86443,
    lat: 35.97186,
    lng: -114.46386,
    city: "Temple Bar Marina",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "04015",
    county_name: "Mohave",
    county_weights: {
      "04015": 100,
    },
    county_names_all: "Mohave",
    county_fips_all: "04015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86444,
    lat: 35.90199,
    lng: -114.05969,
    city: "Meadview",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1520,
    density: 1.1,
    county_fips: "04015",
    county_name: "Mohave",
    county_weights: {
      "04015": 100,
    },
    county_names_all: "Mohave",
    county_fips_all: "04015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86445,
    lat: 35.70747,
    lng: -114.53764,
    city: "Willow Beach",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 210,
    density: 0.2,
    county_fips: "04015",
    county_name: "Mohave",
    county_weights: {
      "04015": 100,
    },
    county_names_all: "Mohave",
    county_fips_all: "04015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86502,
    lat: 35.1212,
    lng: -109.61705,
    city: "Chambers",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 980,
    density: 0.4,
    county_fips: "04001",
    county_name: "Apache",
    county_weights: {
      "04001": 100,
    },
    county_names_all: "Apache",
    county_fips_all: "04001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86503,
    lat: 36.20258,
    lng: -109.68224,
    city: "Chinle",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10578,
    density: 4.1,
    county_fips: "04001",
    county_name: "Apache",
    county_weights: {
      "04001": 95.28,
      "04017": 4.72,
    },
    county_names_all: "Apache|Navajo",
    county_fips_all: "04001|04017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86504,
    lat: 35.86087,
    lng: -109.13995,
    city: "Fort Defiance",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7296,
    density: 14,
    county_fips: "04001",
    county_name: "Apache",
    county_weights: {
      35031: 1.18,
      "04001": 98.82,
    },
    county_names_all: "Apache|McKinley",
    county_fips_all: "04001|35031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86505,
    lat: 35.61872,
    lng: -109.71274,
    city: "Ganado",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7920,
    density: 2.8,
    county_fips: "04001",
    county_name: "Apache",
    county_weights: {
      "04001": 84.25,
      "04017": 15.75,
    },
    county_names_all: "Apache|Navajo",
    county_fips_all: "04001|04017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86506,
    lat: 35.35206,
    lng: -109.25868,
    city: "Houck",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1273,
    density: 1.7,
    county_fips: "04001",
    county_name: "Apache",
    county_weights: {
      "04001": 100,
    },
    county_names_all: "Apache",
    county_fips_all: "04001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86507,
    lat: 36.41985,
    lng: -109.28019,
    city: "Lukachukai",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2429,
    density: 4.3,
    county_fips: "04001",
    county_name: "Apache",
    county_weights: {
      "04001": 100,
    },
    county_names_all: "Apache",
    county_fips_all: "04001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86508,
    lat: 35.35086,
    lng: -109.08737,
    city: "Lupton",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 599,
    density: 2.8,
    county_fips: "04001",
    county_name: "Apache",
    county_weights: {
      "04001": 100,
    },
    county_names_all: "Apache",
    county_fips_all: "04001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86510,
    lat: 36.23061,
    lng: -110.27182,
    city: "Pinon",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4126,
    density: 2.3,
    county_fips: "04017",
    county_name: "Navajo",
    county_weights: {
      "04017": 100,
    },
    county_names_all: "Navajo",
    county_fips_all: "04017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86511,
    lat: 35.66536,
    lng: -109.26397,
    city: "Saint Michaels",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3988,
    density: 4.5,
    county_fips: "04001",
    county_name: "Apache",
    county_weights: {
      "04001": 100,
    },
    county_names_all: "Apache",
    county_fips_all: "04001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86512,
    lat: 35.079,
    lng: -109.24737,
    city: "Sanders",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2867,
    density: 2.4,
    county_fips: "04001",
    county_name: "Apache",
    county_weights: {
      "04001": 100,
    },
    county_names_all: "Apache",
    county_fips_all: "04001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 86514,
    lat: 36.90487,
    lng: -109.32028,
    city: "Teec Nos Pos",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3384,
    density: 1.9,
    county_fips: "04001",
    county_name: "Apache",
    county_weights: {
      35045: 0.99,
      49037: 15.12,
      "04001": 83.89,
    },
    county_names_all: "Apache|San Juan|San Juan",
    county_fips_all: "04001|49037|35045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86515,
    lat: 35.70301,
    lng: -108.99057,
    city: "Window Rock",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3660,
    density: 12.2,
    county_fips: 35031,
    county_name: "McKinley",
    county_weights: {
      35031: 88.14,
      "04001": 11.86,
    },
    county_names_all: "McKinley|Apache",
    county_fips_all: "35031|04001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86520,
    lat: 36.05891,
    lng: -109.95208,
    city: "Blue Gap",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1556,
    density: 2.1,
    county_fips: "04001",
    county_name: "Apache",
    county_weights: {
      "04001": 78.06,
      "04017": 21.94,
    },
    county_names_all: "Apache|Navajo",
    county_fips_all: "04001|04017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86535,
    lat: 36.82372,
    lng: -109.86199,
    city: "Dennehotso",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1459,
    density: 2.6,
    county_fips: "04001",
    county_name: "Apache",
    county_weights: {
      "04001": 100,
    },
    county_names_all: "Apache",
    county_fips_all: "04001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86538,
    lat: 36.43323,
    lng: -109.63752,
    city: "Many Farms",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1649,
    density: 4.5,
    county_fips: "04001",
    county_name: "Apache",
    county_weights: {
      "04001": 100,
    },
    county_names_all: "Apache",
    county_fips_all: "04001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86540,
    lat: 35.93953,
    lng: -109.44886,
    city: "Nazlini",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1084,
    density: 1.7,
    county_fips: "04001",
    county_name: "Apache",
    county_weights: {
      "04001": 100,
    },
    county_names_all: "Apache",
    county_fips_all: "04001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86544,
    lat: 36.58162,
    lng: -109.13818,
    city: "Red Valley",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1452,
    density: 2.1,
    county_fips: "04001",
    county_name: "Apache",
    county_weights: {
      "04001": 100,
    },
    county_names_all: "Apache",
    county_fips_all: "04001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86545,
    lat: 36.71125,
    lng: -109.58943,
    city: "Rock Point",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1264,
    density: 1.2,
    county_fips: "04001",
    county_name: "Apache",
    county_weights: {
      "04001": 100,
    },
    county_names_all: "Apache",
    county_fips_all: "04001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86547,
    lat: 36.52759,
    lng: -109.46019,
    city: "Round Rock",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1242,
    density: 2.6,
    county_fips: "04001",
    county_name: "Apache",
    county_weights: {
      "04001": 100,
    },
    county_names_all: "Apache",
    county_fips_all: "04001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 86556,
    lat: 36.24093,
    lng: -109.21631,
    city: "Tsaile",
    state_id: "AZ",
    state_name: "Arizona",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2358,
    density: 4.2,
    county_fips: "04001",
    county_name: "Apache",
    county_weights: {
      "04001": 100,
    },
    county_names_all: "Apache",
    county_fips_all: "04001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87001,
    lat: 35.41231,
    lng: -106.37944,
    city: "Algodones",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3675,
    density: 14.2,
    county_fips: 35043,
    county_name: "Sandoval",
    county_weights: {
      35043: 100,
    },
    county_names_all: "Sandoval",
    county_fips_all: 35043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87002,
    lat: 34.63619,
    lng: -106.82517,
    city: "Belen",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21804,
    density: 14.1,
    county_fips: 35061,
    county_name: "Valencia",
    county_weights: {
      35053: 0.21,
      35061: 99.79,
    },
    county_names_all: "Valencia|Socorro",
    county_fips_all: "35061|35053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87004,
    lat: 35.38555,
    lng: -106.58493,
    city: "Bernalillo",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12623,
    density: 53.8,
    county_fips: 35043,
    county_name: "Sandoval",
    county_weights: {
      35043: 100,
    },
    county_names_all: "Sandoval",
    county_fips_all: 35043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87005,
    lat: 35.25669,
    lng: -107.98867,
    city: "Bluewater",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 112,
    density: 1.9,
    county_fips: 35006,
    county_name: "Cibola",
    county_weights: {
      35006: 100,
    },
    county_names_all: "Cibola",
    county_fips_all: 35006,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87006,
    lat: 34.48616,
    lng: -106.84202,
    city: "Bosque",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1171,
    density: 7.3,
    county_fips: 35053,
    county_name: "Socorro",
    county_weights: {
      35053: 95.81,
      35061: 4.19,
    },
    county_names_all: "Socorro|Valencia",
    county_fips_all: "35053|35061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87007,
    lat: 34.96582,
    lng: -107.46717,
    city: "Casa Blanca",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 869,
    density: 2.7,
    county_fips: 35006,
    county_name: "Cibola",
    county_weights: {
      35006: 100,
    },
    county_names_all: "Cibola",
    county_fips_all: 35006,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87008,
    lat: 35.14779,
    lng: -106.39133,
    city: "Cedar Crest",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2541,
    density: 36.8,
    county_fips: 35001,
    county_name: "Bernalillo",
    county_weights: {
      35001: 100,
    },
    county_names_all: "Bernalillo",
    county_fips_all: 35001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87010,
    lat: 35.40517,
    lng: -106.13493,
    city: "Cerrillos",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1017,
    density: 2.4,
    county_fips: 35049,
    county_name: "Santa Fe",
    county_weights: {
      35049: 100,
    },
    county_names_all: "Santa Fe",
    county_fips_all: 35049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87011,
    lat: 34.08236,
    lng: -105.97225,
    city: "Claunch",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35,
    density: 0.1,
    county_fips: 35053,
    county_name: "Socorro",
    county_weights: {
      35027: 27.71,
      35053: 72.29,
    },
    county_names_all: "Socorro|Lincoln",
    county_fips_all: "35053|35027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87012,
    lat: 36.13341,
    lng: -106.67312,
    city: "Coyote",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 371,
    density: 1.9,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 100,
    },
    county_names_all: "Rio Arriba",
    county_fips_all: 35039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87013,
    lat: 35.90014,
    lng: -107.33509,
    city: "Cuba",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6395,
    density: 2.2,
    county_fips: 35043,
    county_name: "Sandoval",
    county_weights: {
      35031: 44.35,
      35039: 0.48,
      35043: 55.17,
    },
    county_names_all: "Sandoval|McKinley|Rio Arriba",
    county_fips_all: "35043|35031|35039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87014,
    lat: 35.1372,
    lng: -107.45315,
    city: "Cubero",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 469,
    density: 8.6,
    county_fips: 35006,
    county_name: "Cibola",
    county_weights: {
      35006: 100,
    },
    county_names_all: "Cibola",
    county_fips_all: 35006,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87015,
    lat: 35.07535,
    lng: -106.19123,
    city: "Edgewood",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15012,
    density: 44.1,
    county_fips: 35049,
    county_name: "Santa Fe",
    county_weights: {
      35001: 17.46,
      35049: 62.06,
      35057: 20.48,
    },
    county_names_all: "Santa Fe|Torrance|Bernalillo",
    county_fips_all: "35049|35057|35001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87016,
    lat: 34.75117,
    lng: -106.01074,
    city: "Estancia",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3502,
    density: 2.3,
    county_fips: 35057,
    county_name: "Torrance",
    county_weights: {
      35057: 100,
    },
    county_names_all: "Torrance",
    county_fips_all: 35057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87017,
    lat: 36.30624,
    lng: -106.73759,
    city: "Gallina",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 500,
    density: 0.9,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 100,
    },
    county_names_all: "Rio Arriba",
    county_fips_all: 35039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87018,
    lat: 36.11644,
    lng: -107.51745,
    city: "Counselor",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 499,
    density: 1.1,
    county_fips: 35043,
    county_name: "Sandoval",
    county_weights: {
      35039: 2.36,
      35043: 97.64,
    },
    county_names_all: "Sandoval|Rio Arriba",
    county_fips_all: "35043|35039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87020,
    lat: 35.0589,
    lng: -107.92797,
    city: "Grants",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11058,
    density: 4.7,
    county_fips: 35006,
    county_name: "Cibola",
    county_weights: {
      35006: 86.5,
      35031: 13.5,
    },
    county_names_all: "Cibola|McKinley",
    county_fips_all: "35006|35031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87021,
    lat: 35.19673,
    lng: -107.88621,
    city: "Milan",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3391,
    density: 130.5,
    county_fips: 35006,
    county_name: "Cibola",
    county_weights: {
      35006: 100,
    },
    county_names_all: "Cibola",
    county_fips_all: 35006,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87022,
    lat: 34.90986,
    lng: -106.69501,
    city: "Isleta",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 773,
    density: 324.6,
    county_fips: 35001,
    county_name: "Bernalillo",
    county_weights: {
      35001: 100,
    },
    county_names_all: "Bernalillo",
    county_fips_all: 35001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87023,
    lat: 34.59583,
    lng: -106.7633,
    city: "Jarales",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 577,
    density: 85.8,
    county_fips: 35061,
    county_name: "Valencia",
    county_weights: {
      35061: 100,
    },
    county_names_all: "Valencia",
    county_fips_all: 35061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87024,
    lat: 35.6765,
    lng: -106.75031,
    city: "Jemez Pueblo",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2257,
    density: 6.6,
    county_fips: 35043,
    county_name: "Sandoval",
    county_weights: {
      35043: 100,
    },
    county_names_all: "Sandoval",
    county_fips_all: 35043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87025,
    lat: 35.84308,
    lng: -106.61862,
    city: "Jemez Springs",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1512,
    density: 1.9,
    county_fips: 35043,
    county_name: "Sandoval",
    county_weights: {
      35043: 100,
    },
    county_names_all: "Sandoval",
    county_fips_all: 35043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87026,
    lat: 34.97119,
    lng: -107.17556,
    city: "Laguna",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4077,
    density: 4,
    county_fips: 35006,
    county_name: "Cibola",
    county_weights: {
      35001: 22.08,
      35006: 49.49,
      35061: 28.43,
    },
    county_names_all: "Cibola|Valencia|Bernalillo",
    county_fips_all: "35006|35061|35001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87027,
    lat: 36.12734,
    lng: -106.94737,
    city: "La Jara",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 289,
    density: 3.2,
    county_fips: 35043,
    county_name: "Sandoval",
    county_weights: {
      35043: 100,
    },
    county_names_all: "Sandoval",
    county_fips_all: 35043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87028,
    lat: 34.35076,
    lng: -106.78789,
    city: "La Joya",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 493,
    density: 2.3,
    county_fips: 35053,
    county_name: "Socorro",
    county_weights: {
      35053: 100,
    },
    county_names_all: "Socorro",
    county_fips_all: 35053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87029,
    lat: 36.39394,
    lng: -107.03949,
    city: "Lindrith",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 229,
    density: 0.3,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 100,
    },
    county_names_all: "Rio Arriba",
    county_fips_all: 35039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87031,
    lat: 34.78007,
    lng: -106.72649,
    city: "Los Lunas",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44542,
    density: 67.3,
    county_fips: 35061,
    county_name: "Valencia",
    county_weights: {
      35061: 100,
    },
    county_names_all: "Valencia",
    county_fips_all: 35061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87032,
    lat: 34.86786,
    lng: -106.04201,
    city: "Mcintosh",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 251,
    density: 3.7,
    county_fips: 35057,
    county_name: "Torrance",
    county_weights: {
      35057: 100,
    },
    county_names_all: "Torrance",
    county_fips_all: 35057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87034,
    lat: 34.91939,
    lng: -107.6559,
    city: "Pueblo Of Acoma",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1858,
    density: 2.6,
    county_fips: 35006,
    county_name: "Cibola",
    county_weights: {
      35006: 100,
    },
    county_names_all: "Cibola",
    county_fips_all: 35006,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87035,
    lat: 34.95116,
    lng: -105.90273,
    city: "Moriarty",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6903,
    density: 7.8,
    county_fips: 35057,
    county_name: "Torrance",
    county_weights: {
      35049: 3.07,
      35057: 96.93,
    },
    county_names_all: "Torrance|Santa Fe",
    county_fips_all: "35057|35049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87036,
    lat: 34.35591,
    lng: -106.24227,
    city: "Mountainair",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1585,
    density: 0.6,
    county_fips: 35057,
    county_name: "Torrance",
    county_weights: {
      35053: 37.48,
      35057: 62.52,
    },
    county_names_all: "Torrance|Socorro",
    county_fips_all: "35057|35053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87037,
    lat: 36.18392,
    lng: -107.78087,
    city: "Nageezi",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 808,
    density: 0.8,
    county_fips: 35045,
    county_name: "San Juan",
    county_weights: {
      35039: 3.28,
      35045: 96.72,
    },
    county_names_all: "San Juan|Rio Arriba",
    county_fips_all: "35045|35039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87038,
    lat: 35.0944,
    lng: -107.43259,
    city: "New Laguna",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 642,
    density: 10.4,
    county_fips: 35006,
    county_name: "Cibola",
    county_weights: {
      35006: 100,
    },
    county_names_all: "Cibola",
    county_fips_all: 35006,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87040,
    lat: 35.14192,
    lng: -107.39887,
    city: "Paguate",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 560,
    density: 20.4,
    county_fips: 35006,
    county_name: "Cibola",
    county_weights: {
      35006: 100,
    },
    county_names_all: "Cibola",
    county_fips_all: 35006,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87041,
    lat: 35.60202,
    lng: -106.31054,
    city: "Pena Blanca",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 927,
    density: 6.6,
    county_fips: 35043,
    county_name: "Sandoval",
    county_weights: {
      35043: 100,
    },
    county_names_all: "Sandoval",
    county_fips_all: 35043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87042,
    lat: 34.82827,
    lng: -106.68619,
    city: "Peralta",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3599,
    density: 308.9,
    county_fips: 35061,
    county_name: "Valencia",
    county_weights: {
      35061: 100,
    },
    county_names_all: "Valencia",
    county_fips_all: 35061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87043,
    lat: 35.28978,
    lng: -106.44418,
    city: "Placitas",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4506,
    density: 16.2,
    county_fips: 35043,
    county_name: "Sandoval",
    county_weights: {
      35043: 100,
    },
    county_names_all: "Sandoval",
    county_fips_all: 35043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87044,
    lat: 35.71254,
    lng: -106.65652,
    city: "Ponderosa",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 184,
    density: 1.7,
    county_fips: 35043,
    county_name: "Sandoval",
    county_weights: {
      35043: 100,
    },
    county_names_all: "Sandoval",
    county_fips_all: 35043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87045,
    lat: 35.40018,
    lng: -108.00182,
    city: "Prewitt",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1692,
    density: 4.1,
    county_fips: 35031,
    county_name: "McKinley",
    county_weights: {
      35006: 1.68,
      35031: 98.32,
    },
    county_names_all: "McKinley|Cibola",
    county_fips_all: "35031|35006",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87046,
    lat: 36.27773,
    lng: -106.91643,
    city: "Regina",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 256,
    density: 1.1,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 78.49,
      35043: 21.51,
    },
    county_names_all: "Rio Arriba|Sandoval",
    county_fips_all: "35039|35043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87047,
    lat: 35.24866,
    lng: -106.27629,
    city: "Sandia Park",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4554,
    density: 12.6,
    county_fips: 35043,
    county_name: "Sandoval",
    county_weights: {
      35001: 28.63,
      35043: 41.52,
      35049: 29.85,
    },
    county_names_all: "Sandoval|Santa Fe|Bernalillo",
    county_fips_all: "35043|35049|35001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87048,
    lat: 35.23624,
    lng: -106.61977,
    city: "Corrales",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8983,
    density: 315.6,
    county_fips: 35043,
    county_name: "Sandoval",
    county_weights: {
      35001: 1.87,
      35043: 98.13,
    },
    county_names_all: "Sandoval|Bernalillo",
    county_fips_all: "35043|35001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87049,
    lat: 35.11699,
    lng: -107.61026,
    city: "San Fidel",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1761,
    density: 22,
    county_fips: 35006,
    county_name: "Cibola",
    county_weights: {
      35006: 100,
    },
    county_names_all: "Cibola",
    county_fips_all: 35006,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87051,
    lat: 35.06188,
    lng: -107.85426,
    city: "San Rafael",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1429,
    density: 10.6,
    county_fips: 35006,
    county_name: "Cibola",
    county_weights: {
      35006: 100,
    },
    county_names_all: "Cibola",
    county_fips_all: 35006,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87052,
    lat: 35.52867,
    lng: -106.36935,
    city: "Santo Domingo Pueblo",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2884,
    density: 14.3,
    county_fips: 35043,
    county_name: "Sandoval",
    county_weights: {
      35043: 100,
    },
    county_names_all: "Sandoval",
    county_fips_all: 35043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87053,
    lat: 35.57537,
    lng: -106.87832,
    city: "San Ysidro",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1268,
    density: 2.8,
    county_fips: 35043,
    county_name: "Sandoval",
    county_weights: {
      35043: 100,
    },
    county_names_all: "Sandoval",
    county_fips_all: 35043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87056,
    lat: 35.16197,
    lng: -105.89566,
    city: "Stanley",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 987,
    density: 0.9,
    county_fips: 35049,
    county_name: "Santa Fe",
    county_weights: {
      35047: 13.6,
      35049: 86.4,
    },
    county_names_all: "Santa Fe|San Miguel",
    county_fips_all: "35049|35047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87059,
    lat: 34.99647,
    lng: -106.29764,
    city: "Tijeras",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9646,
    density: 26.3,
    county_fips: 35001,
    county_name: "Bernalillo",
    county_weights: {
      35001: 100,
    },
    county_names_all: "Bernalillo",
    county_fips_all: 35001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87060,
    lat: 34.74292,
    lng: -106.73571,
    city: "Tome",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 35061,
    county_name: "Valencia",
    county_weights: {
      35061: 100,
    },
    county_names_all: "Valencia",
    county_fips_all: 35061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87061,
    lat: 34.705,
    lng: -106.38145,
    city: "Torreon",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 293,
    density: 1.2,
    county_fips: 35057,
    county_name: "Torrance",
    county_weights: {
      35057: 100,
    },
    county_names_all: "Torrance",
    county_fips_all: 35057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87062,
    lat: 34.46187,
    lng: -106.69719,
    city: "Veguita",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1792,
    density: 8.1,
    county_fips: 35053,
    county_name: "Socorro",
    county_weights: {
      35053: 99.32,
      35061: 0.68,
    },
    county_names_all: "Socorro|Valencia",
    county_fips_all: "35053|35061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87063,
    lat: 34.49265,
    lng: -105.85432,
    city: "Willard",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 358,
    density: 0.3,
    county_fips: 35057,
    county_name: "Torrance",
    county_weights: {
      35057: 100,
    },
    county_names_all: "Torrance",
    county_fips_all: 35057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87064,
    lat: 36.1849,
    lng: -106.53923,
    city: "Youngsville",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 106,
    density: 0.6,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 100,
    },
    county_names_all: "Rio Arriba",
    county_fips_all: 35039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87068,
    lat: 34.90354,
    lng: -106.64321,
    city: "Bosque Farms",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5386,
    density: 55.9,
    county_fips: 35001,
    county_name: "Bernalillo",
    county_weights: {
      35001: 53.54,
      35061: 46.46,
    },
    county_names_all: "Bernalillo|Valencia",
    county_fips_all: "35001|35061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87070,
    lat: 35.02255,
    lng: -105.74037,
    city: "Clines Corners",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 170,
    density: 3.7,
    county_fips: 35057,
    county_name: "Torrance",
    county_weights: {
      35057: 100,
    },
    county_names_all: "Torrance",
    county_fips_all: 35057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87072,
    lat: 35.60828,
    lng: -106.3955,
    city: "Cochiti Pueblo",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 652,
    density: 14.2,
    county_fips: 35043,
    county_name: "Sandoval",
    county_weights: {
      35043: 100,
    },
    county_names_all: "Sandoval",
    county_fips_all: 35043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87083,
    lat: 35.64496,
    lng: -106.36366,
    city: "Cochiti Lake",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 444,
    density: 15.8,
    county_fips: 35043,
    county_name: "Sandoval",
    county_weights: {
      35043: 100,
    },
    county_names_all: "Sandoval",
    county_fips_all: 35043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87101,
    lat: 35.09669,
    lng: -106.64339,
    city: "Albuquerque",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 35001,
    county_name: "Bernalillo",
    county_weights: {
      35001: 100,
    },
    county_names_all: "Bernalillo",
    county_fips_all: 35001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87102,
    lat: 35.08116,
    lng: -106.64636,
    city: "Albuquerque",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19486,
    density: 1152.9,
    county_fips: 35001,
    county_name: "Bernalillo",
    county_weights: {
      35001: 100,
    },
    county_names_all: "Bernalillo",
    county_fips_all: 35001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87104,
    lat: 35.10278,
    lng: -106.67492,
    city: "Albuquerque",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13679,
    density: 1256.9,
    county_fips: 35001,
    county_name: "Bernalillo",
    county_weights: {
      35001: 100,
    },
    county_names_all: "Bernalillo",
    county_fips_all: 35001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87105,
    lat: 34.99512,
    lng: -106.68644,
    city: "Albuquerque",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57365,
    density: 551.4,
    county_fips: 35001,
    county_name: "Bernalillo",
    county_weights: {
      35001: 100,
    },
    county_names_all: "Bernalillo",
    county_fips_all: 35001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87106,
    lat: 35.00818,
    lng: -106.61185,
    city: "Albuquerque",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25299,
    density: 272.7,
    county_fips: 35001,
    county_name: "Bernalillo",
    county_weights: {
      35001: 100,
    },
    county_names_all: "Bernalillo",
    county_fips_all: 35001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87107,
    lat: 35.13747,
    lng: -106.64363,
    city: "Albuquerque",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29735,
    density: 783.8,
    county_fips: 35001,
    county_name: "Bernalillo",
    county_weights: {
      35001: 100,
    },
    county_names_all: "Bernalillo",
    county_fips_all: 35001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87108,
    lat: 35.07235,
    lng: -106.57835,
    city: "Albuquerque",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37572,
    density: 2468,
    county_fips: 35001,
    county_name: "Bernalillo",
    county_weights: {
      35001: 100,
    },
    county_names_all: "Bernalillo",
    county_fips_all: 35001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87109,
    lat: 35.15285,
    lng: -106.57543,
    city: "Albuquerque",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39961,
    density: 1545.5,
    county_fips: 35001,
    county_name: "Bernalillo",
    county_weights: {
      35001: 100,
    },
    county_names_all: "Bernalillo",
    county_fips_all: 35001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87110,
    lat: 35.10812,
    lng: -106.57816,
    city: "Albuquerque",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39581,
    density: 1742.2,
    county_fips: 35001,
    county_name: "Bernalillo",
    county_weights: {
      35001: 100,
    },
    county_names_all: "Bernalillo",
    county_fips_all: 35001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87111,
    lat: 35.13824,
    lng: -106.51589,
    city: "Albuquerque",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57389,
    density: 1744.7,
    county_fips: 35001,
    county_name: "Bernalillo",
    county_weights: {
      35001: 100,
    },
    county_names_all: "Bernalillo",
    county_fips_all: 35001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87112,
    lat: 35.10093,
    lng: -106.51622,
    city: "Albuquerque",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41406,
    density: 1966.5,
    county_fips: 35001,
    county_name: "Bernalillo",
    county_weights: {
      35001: 100,
    },
    county_names_all: "Bernalillo",
    county_fips_all: 35001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87113,
    lat: 35.19249,
    lng: -106.5708,
    city: "Albuquerque",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16098,
    density: 417.6,
    county_fips: 35001,
    county_name: "Bernalillo",
    county_weights: {
      35001: 100,
    },
    county_names_all: "Bernalillo",
    county_fips_all: 35001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87114,
    lat: 35.19718,
    lng: -106.68216,
    city: "Albuquerque",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69752,
    density: 1286.4,
    county_fips: 35001,
    county_name: "Bernalillo",
    county_weights: {
      35001: 100,
    },
    county_names_all: "Bernalillo",
    county_fips_all: 35001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87116,
    lat: 35.05056,
    lng: -106.56028,
    city: "Albuquerque",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4308,
    density: 283.3,
    county_fips: 35001,
    county_name: "Bernalillo",
    county_weights: {
      35001: 100,
    },
    county_names_all: "Bernalillo",
    county_fips_all: 35001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87117,
    lat: 34.99486,
    lng: -106.51697,
    city: "Kirtland Afb",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 335,
    density: 3.3,
    county_fips: 35001,
    county_name: "Bernalillo",
    county_weights: {
      35001: 100,
    },
    county_names_all: "Bernalillo",
    county_fips_all: 35001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87120,
    lat: 35.14097,
    lng: -106.76522,
    city: "Albuquerque",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64398,
    density: 431.4,
    county_fips: 35001,
    county_name: "Bernalillo",
    county_weights: {
      35001: 100,
    },
    county_names_all: "Bernalillo",
    county_fips_all: 35001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87121,
    lat: 35.01031,
    lng: -106.87816,
    city: "Albuquerque",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 77671,
    density: 89,
    county_fips: 35001,
    county_name: "Bernalillo",
    county_weights: {
      35001: 100,
    },
    county_names_all: "Bernalillo",
    county_fips_all: 35001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87122,
    lat: 35.18685,
    lng: -106.48827,
    city: "Albuquerque",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18870,
    density: 335.9,
    county_fips: 35001,
    county_name: "Bernalillo",
    county_weights: {
      35001: 97.29,
      35043: 2.71,
    },
    county_names_all: "Bernalillo|Sandoval",
    county_fips_all: "35001|35043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87123,
    lat: 35.06206,
    lng: -106.46991,
    city: "Albuquerque",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44103,
    density: 590.1,
    county_fips: 35001,
    county_name: "Bernalillo",
    county_weights: {
      35001: 100,
    },
    county_names_all: "Bernalillo",
    county_fips_all: 35001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87124,
    lat: 35.27144,
    lng: -106.79627,
    city: "Rio Rancho",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55409,
    density: 274.5,
    county_fips: 35043,
    county_name: "Sandoval",
    county_weights: {
      35043: 100,
    },
    county_names_all: "Sandoval",
    county_fips_all: 35043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87144,
    lat: 35.33074,
    lng: -106.71248,
    city: "Rio Rancho",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44388,
    density: 170.7,
    county_fips: 35043,
    county_name: "Sandoval",
    county_weights: {
      35043: 100,
    },
    county_names_all: "Sandoval",
    county_fips_all: 35043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87151,
    lat: 35.00772,
    lng: -106.86035,
    city: "Albuquerque",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 35001,
    county_name: "Bernalillo",
    county_weights: {
      35001: 100,
    },
    county_names_all: "Bernalillo",
    county_fips_all: 35001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87301,
    lat: 35.52153,
    lng: -108.76524,
    city: "Gallup",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24684,
    density: 241.4,
    county_fips: 35031,
    county_name: "McKinley",
    county_weights: {
      35031: 100,
    },
    county_names_all: "McKinley",
    county_fips_all: 35031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87305,
    lat: 35.40327,
    lng: -108.73151,
    city: "Gallup",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2907,
    density: 9.4,
    county_fips: 35031,
    county_name: "McKinley",
    county_weights: {
      35031: 100,
    },
    county_names_all: "McKinley",
    county_fips_all: 35031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87310,
    lat: 35.75365,
    lng: -108.60267,
    city: "Brimhall",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1058,
    density: 4.4,
    county_fips: 35031,
    county_name: "McKinley",
    county_weights: {
      35031: 100,
    },
    county_names_all: "McKinley",
    county_fips_all: 35031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87311,
    lat: 35.60501,
    lng: -108.50061,
    city: "Church Rock",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4101,
    density: 7.5,
    county_fips: 35031,
    county_name: "McKinley",
    county_weights: {
      35031: 100,
    },
    county_names_all: "McKinley",
    county_fips_all: 35031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87312,
    lat: 35.4291,
    lng: -108.34543,
    city: "Continental Divide",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 398,
    density: 1.9,
    county_fips: 35031,
    county_name: "McKinley",
    county_weights: {
      35031: 100,
    },
    county_names_all: "McKinley",
    county_fips_all: 35031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87313,
    lat: 35.79538,
    lng: -108.22129,
    city: "Crownpoint",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5914,
    density: 3.3,
    county_fips: 35031,
    county_name: "McKinley",
    county_weights: {
      35031: 88.9,
      35045: 11.1,
    },
    county_names_all: "McKinley|San Juan",
    county_fips_all: "35031|35045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87315,
    lat: 34.66247,
    lng: -108.55075,
    city: "Fence Lake",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 116,
    density: 0.1,
    county_fips: 35006,
    county_name: "Cibola",
    county_weights: {
      35006: 100,
    },
    county_names_all: "Cibola",
    county_fips_all: 35006,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87316,
    lat: 35.48684,
    lng: -108.53328,
    city: "Fort Wingate",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1228,
    density: 6.3,
    county_fips: 35031,
    county_name: "McKinley",
    county_weights: {
      35031: 100,
    },
    county_names_all: "McKinley",
    county_fips_all: 35031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87317,
    lat: 35.58024,
    lng: -108.75244,
    city: "Gamerco",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2129,
    density: 63.2,
    county_fips: 35031,
    county_name: "McKinley",
    county_weights: {
      35031: 100,
    },
    county_names_all: "McKinley",
    county_fips_all: 35031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87319,
    lat: 35.4769,
    lng: -108.94232,
    city: "Mentmore",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1849,
    density: 4,
    county_fips: 35031,
    county_name: "McKinley",
    county_weights: {
      35031: 100,
    },
    county_names_all: "McKinley",
    county_fips_all: 35031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87320,
    lat: 35.80762,
    lng: -108.87136,
    city: "Mexican Springs",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 377,
    density: 1.6,
    county_fips: 35031,
    county_name: "McKinley",
    county_weights: {
      35031: 100,
    },
    county_names_all: "McKinley",
    county_fips_all: 35031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87321,
    lat: 35.06791,
    lng: -108.40638,
    city: "Ramah",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2419,
    density: 2,
    county_fips: 35006,
    county_name: "Cibola",
    county_weights: {
      35006: 70.2,
      35031: 29.8,
    },
    county_names_all: "Cibola|McKinley",
    county_fips_all: "35006|35031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87322,
    lat: 35.48531,
    lng: -108.66253,
    city: "Rehoboth",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 35031,
    county_name: "McKinley",
    county_weights: {
      35031: 100,
    },
    county_names_all: "McKinley",
    county_fips_all: 35031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87323,
    lat: 35.45214,
    lng: -108.17531,
    city: "Thoreau",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4418,
    density: 5.8,
    county_fips: 35031,
    county_name: "McKinley",
    county_weights: {
      35006: 14.53,
      35031: 85.47,
    },
    county_names_all: "McKinley|Cibola",
    county_fips_all: "35031|35006",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87325,
    lat: 35.97495,
    lng: -108.58746,
    city: "Tohatchi",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3443,
    density: 2.6,
    county_fips: 35031,
    county_name: "McKinley",
    county_weights: {
      35031: 61.44,
      35045: 38.56,
    },
    county_names_all: "McKinley|San Juan",
    county_fips_all: "35031|35045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87326,
    lat: 35.27223,
    lng: -108.88765,
    city: "Vanderwagen",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1624,
    density: 2.7,
    county_fips: 35031,
    county_name: "McKinley",
    county_weights: {
      35031: 100,
    },
    county_names_all: "McKinley",
    county_fips_all: 35031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87327,
    lat: 35.06529,
    lng: -108.77813,
    city: "Zuni",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8187,
    density: 8.4,
    county_fips: 35031,
    county_name: "McKinley",
    county_weights: {
      35006: 13.99,
      35031: 86.01,
    },
    county_names_all: "McKinley|Cibola",
    county_fips_all: "35031|35006",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87328,
    lat: 36.02541,
    lng: -109.03638,
    city: "Navajo",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2709,
    density: 3,
    county_fips: "04001",
    county_name: "Apache",
    county_weights: {
      35031: 31.58,
      35045: 29.72,
      "04001": 38.7,
    },
    county_names_all: "Apache|McKinley|San Juan",
    county_fips_all: "04001|35031|35045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87347,
    lat: 35.38502,
    lng: -108.47052,
    city: "Jamestown",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 129,
    density: 0.5,
    county_fips: 35031,
    county_name: "McKinley",
    county_weights: {
      35031: 100,
    },
    county_names_all: "McKinley",
    county_fips_all: 35031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87357,
    lat: 34.82644,
    lng: -108.41435,
    city: "Pinehill",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 672,
    density: 0.9,
    county_fips: 35006,
    county_name: "Cibola",
    county_weights: {
      35006: 100,
    },
    county_names_all: "Cibola",
    county_fips_all: 35006,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87364,
    lat: 36.13538,
    lng: -108.70875,
    city: "Sheep Springs",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1090,
    density: 2.2,
    county_fips: 35045,
    county_name: "San Juan",
    county_weights: {
      35045: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 35045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87365,
    lat: 35.53585,
    lng: -108.13796,
    city: "Smith Lake",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 35031,
    county_name: "McKinley",
    county_weights: {
      35031: 100,
    },
    county_names_all: "McKinley",
    county_fips_all: 35031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87375,
    lat: 35.66114,
    lng: -108.79477,
    city: "Yatahey",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3607,
    density: 8.3,
    county_fips: 35031,
    county_name: "McKinley",
    county_weights: {
      35031: 100,
    },
    county_names_all: "McKinley",
    county_fips_all: 35031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87401,
    lat: 36.73824,
    lng: -108.18377,
    city: "Farmington",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46151,
    density: 134.2,
    county_fips: 35045,
    county_name: "San Juan",
    county_weights: {
      35045: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 35045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87402,
    lat: 36.79174,
    lng: -108.14831,
    city: "Farmington",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9620,
    density: 239.3,
    county_fips: 35045,
    county_name: "San Juan",
    county_weights: {
      35045: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 35045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87410,
    lat: 36.86708,
    lng: -107.89433,
    city: "Aztec",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16716,
    density: 24.3,
    county_fips: 35045,
    county_name: "San Juan",
    county_weights: {
      35045: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 35045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87412,
    lat: 36.6569,
    lng: -107.51956,
    city: "Blanco",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1683,
    density: 1.4,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 72.13,
      35045: 27.87,
    },
    county_names_all: "Rio Arriba|San Juan",
    county_fips_all: "35039|35045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87413,
    lat: 36.45914,
    lng: -107.96408,
    city: "Bloomfield",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16177,
    density: 10.4,
    county_fips: 35045,
    county_name: "San Juan",
    county_weights: {
      35045: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 35045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87415,
    lat: 36.82823,
    lng: -108.10125,
    city: "Flora Vista",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2189,
    density: 49.7,
    county_fips: 35045,
    county_name: "San Juan",
    county_weights: {
      35045: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 35045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87416,
    lat: 36.58687,
    lng: -108.43897,
    city: "Fruitland",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4786,
    density: 4.4,
    county_fips: 35045,
    county_name: "San Juan",
    county_weights: {
      35045: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 35045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87417,
    lat: 36.74456,
    lng: -108.34551,
    city: "Kirtland",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5650,
    density: 196.3,
    county_fips: 35045,
    county_name: "San Juan",
    county_weights: {
      35045: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 35045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87418,
    lat: 36.94938,
    lng: -108.14728,
    city: "La Plata",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 849,
    density: 4.9,
    county_fips: 35045,
    county_name: "San Juan",
    county_weights: {
      35045: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 35045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87419,
    lat: 36.88767,
    lng: -107.55195,
    city: "Navajo Dam",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 475,
    density: 0.7,
    county_fips: 35045,
    county_name: "San Juan",
    county_weights: {
      35039: 47.14,
      35045: 52.86,
    },
    county_names_all: "San Juan|Rio Arriba",
    county_fips_all: "35045|35039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87420,
    lat: 36.72142,
    lng: -108.84406,
    city: "Shiprock",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11933,
    density: 8.3,
    county_fips: 35045,
    county_name: "San Juan",
    county_weights: {
      35045: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 35045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87421,
    lat: 36.7772,
    lng: -108.53676,
    city: "Waterflow",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1637,
    density: 19.3,
    county_fips: 35045,
    county_name: "San Juan",
    county_weights: {
      35045: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 35045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87455,
    lat: 36.27109,
    lng: -108.71936,
    city: "Newcomb",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1638,
    density: 1.5,
    county_fips: 35045,
    county_name: "San Juan",
    county_weights: {
      35045: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 35045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87461,
    lat: 36.43717,
    lng: -108.91099,
    city: "Sanostee",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1395,
    density: 2.2,
    county_fips: 35045,
    county_name: "San Juan",
    county_weights: {
      35045: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 35045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87499,
    lat: 36.32165,
    lng: -108.24657,
    city: "Farmington",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 657,
    density: 0.6,
    county_fips: 35045,
    county_name: "San Juan",
    county_weights: {
      35045: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 35045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87501,
    lat: 35.71273,
    lng: -105.86523,
    city: "Santa Fe",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15539,
    density: 118.6,
    county_fips: 35049,
    county_name: "Santa Fe",
    county_weights: {
      35049: 100,
    },
    county_names_all: "Santa Fe",
    county_fips_all: 35049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87505,
    lat: 35.62307,
    lng: -105.86891,
    city: "Santa Fe",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30615,
    density: 181.5,
    county_fips: 35049,
    county_name: "Santa Fe",
    county_weights: {
      35049: 100,
    },
    county_names_all: "Santa Fe",
    county_fips_all: 35049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87506,
    lat: 35.82119,
    lng: -105.96802,
    city: "Santa Fe",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13820,
    density: 17.3,
    county_fips: 35049,
    county_name: "Santa Fe",
    county_weights: {
      35049: 100,
    },
    county_names_all: "Santa Fe",
    county_fips_all: 35049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87507,
    lat: 35.621,
    lng: -106.11061,
    city: "Santa Fe",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50489,
    density: 202.9,
    county_fips: 35049,
    county_name: "Santa Fe",
    county_weights: {
      35049: 100,
    },
    county_names_all: "Santa Fe",
    county_fips_all: 35049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87508,
    lat: 35.52064,
    lng: -105.94593,
    city: "Santa Fe",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18444,
    density: 42.1,
    county_fips: 35049,
    county_name: "Santa Fe",
    county_weights: {
      35049: 100,
    },
    county_names_all: "Santa Fe",
    county_fips_all: 35049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87510,
    lat: 36.35906,
    lng: -106.48312,
    city: "Abiquiu",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 843,
    density: 1,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 100,
    },
    county_names_all: "Rio Arriba",
    county_fips_all: 35039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87511,
    lat: 36.08905,
    lng: -105.96448,
    city: "Alcalde",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1837,
    density: 13.8,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 100,
    },
    county_names_all: "Rio Arriba",
    county_fips_all: 35039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87512,
    lat: 36.90885,
    lng: -105.36515,
    city: "Amalia",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68,
    density: 0.1,
    county_fips: 35055,
    county_name: "Taos",
    county_weights: {
      35055: 100,
    },
    county_names_all: "Taos",
    county_fips_all: 35055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87513,
    lat: 36.58367,
    lng: -105.70121,
    city: "Arroyo Hondo",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1004,
    density: 9.9,
    county_fips: 35055,
    county_name: "Taos",
    county_weights: {
      35055: 100,
    },
    county_names_all: "Taos",
    county_fips_all: 35055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87514,
    lat: 36.52957,
    lng: -105.60055,
    city: "Arroyo Seco",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1282,
    density: 57.9,
    county_fips: 35055,
    county_name: "Taos",
    county_weights: {
      35055: 100,
    },
    county_names_all: "Taos",
    county_fips_all: 35055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87515,
    lat: 36.56257,
    lng: -106.3696,
    city: "Canjilon",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 254,
    density: 0.5,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 100,
    },
    county_names_all: "Rio Arriba",
    county_fips_all: 35039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87516,
    lat: 36.18116,
    lng: -106.46149,
    city: "Canones",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 94,
    density: 0.9,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 100,
    },
    county_names_all: "Rio Arriba",
    county_fips_all: 35039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87517,
    lat: 36.39035,
    lng: -105.79269,
    city: "Carson",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 253,
    density: 1.2,
    county_fips: 35055,
    county_name: "Taos",
    county_weights: {
      35055: 100,
    },
    county_names_all: "Taos",
    county_fips_all: 35055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87518,
    lat: 36.51197,
    lng: -106.54235,
    city: "Cebolla",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 100,
    },
    county_names_all: "Rio Arriba",
    county_fips_all: 35039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87519,
    lat: 36.76472,
    lng: -105.63502,
    city: "Cerro",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 519,
    density: 7,
    county_fips: 35055,
    county_name: "Taos",
    county_weights: {
      35055: 100,
    },
    county_names_all: "Taos",
    county_fips_all: 35055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87520,
    lat: 36.88419,
    lng: -106.63552,
    city: "Chama",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1201,
    density: 1.8,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 100,
    },
    county_names_all: "Rio Arriba",
    county_fips_all: 35039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87521,
    lat: 36.08506,
    lng: -105.70477,
    city: "Chamisal",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 769,
    density: 2.9,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 66.48,
      35055: 33.52,
    },
    county_names_all: "Rio Arriba|Taos",
    county_fips_all: "35039|35055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87522,
    lat: 35.96889,
    lng: -105.84639,
    city: "Chimayo",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2907,
    density: 10.5,
    county_fips: 35049,
    county_name: "Santa Fe",
    county_weights: {
      35039: 21.06,
      35049: 78.94,
    },
    county_names_all: "Santa Fe|Rio Arriba",
    county_fips_all: "35049|35039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87523,
    lat: 36.01115,
    lng: -105.86273,
    city: "Cordova",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 553,
    density: 102,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 100,
    },
    county_names_all: "Rio Arriba",
    county_fips_all: 35039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87524,
    lat: 36.96986,
    lng: -105.5375,
    city: "Costilla",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 89,
    density: 8,
    county_fips: 35055,
    county_name: "Taos",
    county_weights: {
      35055: 100,
    },
    county_names_all: "Taos",
    county_fips_all: 35055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87525,
    lat: 36.5985,
    lng: -105.49812,
    city: "Taos Ski Valley",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46,
    density: 1,
    county_fips: 35055,
    county_name: "Taos",
    county_weights: {
      35055: 100,
    },
    county_names_all: "Taos",
    county_fips_all: 35055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87527,
    lat: 36.16875,
    lng: -105.86352,
    city: "Dixon",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 444,
    density: 4.3,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 100,
    },
    county_names_all: "Rio Arriba",
    county_fips_all: 35039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87528,
    lat: 36.79432,
    lng: -106.87989,
    city: "Dulce",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3291,
    density: 2.9,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 100,
    },
    county_names_all: "Rio Arriba",
    county_fips_all: 35039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87529,
    lat: 36.45001,
    lng: -105.66147,
    city: "El Prado",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5203,
    density: 30.9,
    county_fips: 35055,
    county_name: "Taos",
    county_weights: {
      35055: 100,
    },
    county_names_all: "Taos",
    county_fips_all: 35055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87530,
    lat: 36.34088,
    lng: -106.20198,
    city: "El Rito",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 682,
    density: 1.6,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 100,
    },
    county_names_all: "Rio Arriba",
    county_fips_all: 35039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87531,
    lat: 36.25326,
    lng: -105.84584,
    city: "Embudo",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 396,
    density: 4.6,
    county_fips: 35055,
    county_name: "Taos",
    county_weights: {
      35039: 41.23,
      35055: 58.77,
    },
    county_names_all: "Taos|Rio Arriba",
    county_fips_all: "35055|35039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87532,
    lat: 35.97965,
    lng: -106.1048,
    city: "Espanola",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19073,
    density: 67.3,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 75.12,
      35049: 24.88,
    },
    county_names_all: "Rio Arriba|Santa Fe",
    county_fips_all: "35039|35049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87535,
    lat: 35.56675,
    lng: -105.74719,
    city: "Glorieta",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1607,
    density: 11.9,
    county_fips: 35049,
    county_name: "Santa Fe",
    county_weights: {
      35047: 7.28,
      35049: 92.72,
    },
    county_names_all: "Santa Fe|San Miguel",
    county_fips_all: "35049|35047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87537,
    lat: 36.1043,
    lng: -106.2454,
    city: "Hernandez",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2850,
    density: 7.8,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 100,
    },
    county_names_all: "Rio Arriba",
    county_fips_all: 35039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87538,
    lat: 35.49323,
    lng: -105.53767,
    city: "Ilfeld",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 355,
    density: 2.5,
    county_fips: 35047,
    county_name: "San Miguel",
    county_weights: {
      35047: 100,
    },
    county_names_all: "San Miguel",
    county_fips_all: 35047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87539,
    lat: 36.41192,
    lng: -106.02393,
    city: "La Madera",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21,
    density: 0.1,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 100,
    },
    county_names_all: "Rio Arriba",
    county_fips_all: 35039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87540,
    lat: 35.39987,
    lng: -105.8759,
    city: "Lamy",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 904,
    density: 2.1,
    county_fips: 35049,
    county_name: "Santa Fe",
    county_weights: {
      35049: 100,
    },
    county_names_all: "Santa Fe",
    county_fips_all: 35049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87543,
    lat: 36.10399,
    lng: -105.65781,
    city: "Llano",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44,
    density: 0.9,
    county_fips: 35055,
    county_name: "Taos",
    county_weights: {
      35055: 100,
    },
    county_names_all: "Taos",
    county_fips_all: 35055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87544,
    lat: 35.7869,
    lng: -106.31914,
    city: "Los Alamos",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18976,
    density: 55.1,
    county_fips: 35043,
    county_name: "Sandoval",
    county_weights: {
      35028: 42.27,
      35043: 57.73,
    },
    county_names_all: "Sandoval|Los Alamos",
    county_fips_all: "35043|35028",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87547,
    lat: 35.81046,
    lng: -106.20579,
    city: "White Rock",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 35028,
    county_name: "Los Alamos",
    county_weights: {
      35028: 100,
    },
    county_names_all: "Los Alamos",
    county_fips_all: 35028,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87548,
    lat: 36.1756,
    lng: -106.18491,
    city: "Medanales",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1036,
    density: 85.6,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 100,
    },
    county_names_all: "Rio Arriba",
    county_fips_all: 35039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87549,
    lat: 36.23237,
    lng: -106.0568,
    city: "Ojo Caliente",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 950,
    density: 2.9,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 85,
      35055: 15,
    },
    county_names_all: "Rio Arriba|Taos",
    county_fips_all: "35039|35055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87551,
    lat: 36.6925,
    lng: -106.66872,
    city: "Los Ojos",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 183,
    density: 2.4,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 100,
    },
    county_names_all: "Rio Arriba",
    county_fips_all: 35039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87552,
    lat: 35.67026,
    lng: -105.61382,
    city: "Pecos",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2721,
    density: 5.1,
    county_fips: 35047,
    county_name: "San Miguel",
    county_weights: {
      35047: 100,
    },
    county_names_all: "San Miguel",
    county_fips_all: 35047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87553,
    lat: 36.20389,
    lng: -105.72094,
    city: "Penasco",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1512,
    density: 48.9,
    county_fips: 35055,
    county_name: "Taos",
    county_weights: {
      35055: 100,
    },
    county_names_all: "Taos",
    county_fips_all: 35055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87554,
    lat: 36.54573,
    lng: -106.0633,
    city: "Petaca",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 100,
    },
    county_names_all: "Rio Arriba",
    county_fips_all: 35039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87556,
    lat: 36.81848,
    lng: -105.5575,
    city: "Questa",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2159,
    density: 2.9,
    county_fips: 35055,
    county_name: "Taos",
    county_weights: {
      35055: 100,
    },
    county_names_all: "Taos",
    county_fips_all: 35055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87557,
    lat: 36.28603,
    lng: -105.6331,
    city: "Ranchos De Taos",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5104,
    density: 14.2,
    county_fips: 35055,
    county_name: "Taos",
    county_weights: {
      35055: 100,
    },
    county_names_all: "Taos",
    county_fips_all: 35055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87558,
    lat: 36.67279,
    lng: -105.40523,
    city: "Red River",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 983,
    density: 3.6,
    county_fips: 35055,
    county_name: "Taos",
    county_weights: {
      35055: 100,
    },
    county_names_all: "Taos",
    county_fips_all: 35055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87560,
    lat: 35.22567,
    lng: -105.50185,
    city: "Ribera",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1303,
    density: 1.3,
    county_fips: 35047,
    county_name: "San Miguel",
    county_weights: {
      35047: 100,
    },
    county_names_all: "San Miguel",
    county_fips_all: 35047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87562,
    lat: 35.40668,
    lng: -105.65522,
    city: "Rowe",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 513,
    density: 2.1,
    county_fips: 35047,
    county_name: "San Miguel",
    county_weights: {
      35047: 100,
    },
    county_names_all: "San Miguel",
    county_fips_all: 35047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87564,
    lat: 36.61566,
    lng: -105.61797,
    city: "San Cristobal",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 156,
    density: 1.6,
    county_fips: 35055,
    county_name: "Taos",
    county_weights: {
      35055: 100,
    },
    county_names_all: "Taos",
    county_fips_all: 35055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87565,
    lat: 35.4442,
    lng: -105.49384,
    city: "San Jose",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 304,
    density: 2.9,
    county_fips: 35047,
    county_name: "San Miguel",
    county_weights: {
      35047: 100,
    },
    county_names_all: "San Miguel",
    county_fips_all: 35047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87566,
    lat: 36.07242,
    lng: -106.07185,
    city: "Ohkay Owingeh",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2932,
    density: 51.7,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 100,
    },
    county_names_all: "Rio Arriba",
    county_fips_all: 35039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87567,
    lat: 35.99401,
    lng: -106.01872,
    city: "Santa Cruz",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 886,
    density: 120.9,
    county_fips: 35049,
    county_name: "Santa Fe",
    county_weights: {
      35049: 100,
    },
    county_names_all: "Santa Fe",
    county_fips_all: 35049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87569,
    lat: 35.35026,
    lng: -105.30509,
    city: "Serafina",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 632,
    density: 3,
    county_fips: 35047,
    county_name: "San Miguel",
    county_weights: {
      35047: 100,
    },
    county_names_all: "San Miguel",
    county_fips_all: 35047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87571,
    lat: 36.42507,
    lng: -105.48523,
    city: "Taos",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12066,
    density: 29.5,
    county_fips: 35055,
    county_name: "Taos",
    county_weights: {
      35055: 100,
    },
    county_names_all: "Taos",
    county_fips_all: 35055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87573,
    lat: 35.77176,
    lng: -105.70715,
    city: "Tererro",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11,
    density: 0.1,
    county_fips: 35047,
    county_name: "San Miguel",
    county_weights: {
      35047: 59.03,
      35049: 40.97,
    },
    county_names_all: "San Miguel|Santa Fe",
    county_fips_all: "35047|35049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87575,
    lat: 36.64203,
    lng: -106.59341,
    city: "Tierra Amarilla",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1012,
    density: 1.9,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 100,
    },
    county_names_all: "Rio Arriba",
    county_fips_all: 35039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87577,
    lat: 36.63237,
    lng: -105.97755,
    city: "Tres Piedras",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 351,
    density: 0.4,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 51.28,
      35055: 48.72,
    },
    county_names_all: "Rio Arriba|Taos",
    county_fips_all: "35039|35055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87578,
    lat: 36.04392,
    lng: -105.78539,
    city: "Truchas",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 269,
    density: 1.6,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 100,
    },
    county_names_all: "Rio Arriba",
    county_fips_all: 35039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87579,
    lat: 36.12885,
    lng: -105.56729,
    city: "Vadito",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 946,
    density: 2.9,
    county_fips: 35055,
    county_name: "Taos",
    county_weights: {
      35055: 100,
    },
    county_names_all: "Taos",
    county_fips_all: 35055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87580,
    lat: 36.55956,
    lng: -105.57459,
    city: "Valdez",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 463,
    density: 12.1,
    county_fips: 35055,
    county_name: "Taos",
    county_weights: {
      35055: 100,
    },
    county_names_all: "Taos",
    county_fips_all: 35055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87581,
    lat: 36.51531,
    lng: -106.16017,
    city: "Vallecitos",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25,
    density: 0.1,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 100,
    },
    county_names_all: "Rio Arriba",
    county_fips_all: 35039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87582,
    lat: 36.15323,
    lng: -106.00246,
    city: "Velarde",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1038,
    density: 17.5,
    county_fips: 35039,
    county_name: "Rio Arriba",
    county_weights: {
      35039: 100,
    },
    county_names_all: "Rio Arriba",
    county_fips_all: 35039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87583,
    lat: 35.28221,
    lng: -105.35226,
    city: "Villanueva",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 312,
    density: 10,
    county_fips: 35047,
    county_name: "San Miguel",
    county_weights: {
      35047: 100,
    },
    county_names_all: "San Miguel",
    county_fips_all: 35047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87701,
    lat: 35.53091,
    lng: -104.94419,
    city: "Las Vegas",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18882,
    density: 4.6,
    county_fips: 35047,
    county_name: "San Miguel",
    county_weights: {
      35047: 100,
    },
    county_names_all: "San Miguel",
    county_fips_all: 35047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87710,
    lat: 36.3729,
    lng: -105.23873,
    city: "Angel Fire",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1450,
    density: 3.9,
    county_fips: 35007,
    county_name: "Colfax",
    county_weights: {
      35007: 100,
    },
    county_names_all: "Colfax",
    county_fips_all: 35007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87711,
    lat: 35.22458,
    lng: -105.14673,
    city: "Anton Chico",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 901,
    density: 1.9,
    county_fips: 35047,
    county_name: "San Miguel",
    county_weights: {
      35019: 24.68,
      35047: 75.32,
    },
    county_names_all: "San Miguel|Guadalupe",
    county_fips_all: "35047|35019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87712,
    lat: 35.88076,
    lng: -105.17612,
    city: "Buena Vista",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 434,
    density: 2.4,
    county_fips: 35033,
    county_name: "Mora",
    county_weights: {
      35033: 100,
    },
    county_names_all: "Mora",
    county_fips_all: 35033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87713,
    lat: 36.1708,
    lng: -105.36111,
    city: "Chacon",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 249,
    density: 1.3,
    county_fips: 35033,
    county_name: "Mora",
    county_weights: {
      35033: 100,
    },
    county_names_all: "Mora",
    county_fips_all: 35033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87714,
    lat: 36.4463,
    lng: -104.99079,
    city: "Cimarron",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1045,
    density: 1.3,
    county_fips: 35007,
    county_name: "Colfax",
    county_weights: {
      35007: 100,
    },
    county_names_all: "Colfax",
    county_fips_all: 35007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87715,
    lat: 36.01839,
    lng: -105.42535,
    city: "Cleveland",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 456,
    density: 4,
    county_fips: 35033,
    county_name: "Mora",
    county_weights: {
      35033: 100,
    },
    county_names_all: "Mora",
    county_fips_all: 35033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87718,
    lat: 36.59931,
    lng: -105.24097,
    city: "Eagle Nest",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 303,
    density: 0.7,
    county_fips: 35007,
    county_name: "Colfax",
    county_weights: {
      35007: 100,
    },
    county_names_all: "Colfax",
    county_fips_all: 35007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87722,
    lat: 36.12837,
    lng: -105.24424,
    city: "Guadalupita",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 586,
    density: 1.9,
    county_fips: 35033,
    county_name: "Mora",
    county_weights: {
      35033: 100,
    },
    county_names_all: "Mora",
    county_fips_all: 35033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87723,
    lat: 36.05883,
    lng: -105.37556,
    city: "Holman",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 206,
    density: 4,
    county_fips: 35033,
    county_name: "Mora",
    county_weights: {
      35033: 100,
    },
    county_names_all: "Mora",
    county_fips_all: 35033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87724,
    lat: 35.16044,
    lng: -104.97133,
    city: "La Loma",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 35019,
    county_name: "Guadalupe",
    county_weights: {
      35019: 100,
    },
    county_names_all: "Guadalupe",
    county_fips_all: 35019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87728,
    lat: 36.60334,
    lng: -104.59473,
    city: "Maxwell",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 560,
    density: 1.8,
    county_fips: 35007,
    county_name: "Colfax",
    county_weights: {
      35007: 100,
    },
    county_names_all: "Colfax",
    county_fips_all: 35007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87729,
    lat: 36.31405,
    lng: -104.80642,
    city: "Miami",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 88,
    density: 0.4,
    county_fips: 35007,
    county_name: "Colfax",
    county_weights: {
      35007: 100,
    },
    county_names_all: "Colfax",
    county_fips_all: 35007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87730,
    lat: 36.10704,
    lng: -104.23485,
    city: "Mills",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9,
    density: 0,
    county_fips: 35021,
    county_name: "Harding",
    county_weights: {
      35021: 100,
    },
    county_names_all: "Harding",
    county_fips_all: 35021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87731,
    lat: 35.70411,
    lng: -105.39881,
    city: "Montezuma",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 295,
    density: 1.5,
    county_fips: 35047,
    county_name: "San Miguel",
    county_weights: {
      35047: 100,
    },
    county_names_all: "San Miguel",
    county_fips_all: 35047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87732,
    lat: 35.942,
    lng: -105.47009,
    city: "Mora",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1483,
    density: 3.2,
    county_fips: 35033,
    county_name: "Mora",
    county_weights: {
      35033: 100,
    },
    county_names_all: "Mora",
    county_fips_all: 35033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87733,
    lat: 35.77075,
    lng: -103.82959,
    city: "Mosquero",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 84,
    density: 0.1,
    county_fips: 35021,
    county_name: "Harding",
    county_weights: {
      35021: 100,
    },
    county_names_all: "Harding",
    county_fips_all: 35021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87734,
    lat: 36.17323,
    lng: -105.09363,
    city: "Ocate",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 244,
    density: 0.7,
    county_fips: 35033,
    county_name: "Mora",
    county_weights: {
      35033: 100,
    },
    county_names_all: "Mora",
    county_fips_all: 35033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87735,
    lat: 36.04867,
    lng: -105.11978,
    city: "Ojo Feliz",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 77,
    density: 1.7,
    county_fips: 35033,
    county_name: "Mora",
    county_weights: {
      35033: 100,
    },
    county_names_all: "Mora",
    county_fips_all: 35033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87736,
    lat: 35.98431,
    lng: -105.19238,
    city: "Rainsville",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21,
    density: 0.4,
    county_fips: 35033,
    county_name: "Mora",
    county_weights: {
      35033: 100,
    },
    county_names_all: "Mora",
    county_fips_all: 35033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87740,
    lat: 36.76707,
    lng: -104.37953,
    city: "Raton",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6865,
    density: 2,
    county_fips: 35007,
    county_name: "Colfax",
    county_weights: {
      35007: 100,
    },
    county_names_all: "Colfax",
    county_fips_all: 35007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87742,
    lat: 35.87161,
    lng: -105.44427,
    city: "Rociada",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 326,
    density: 1.8,
    county_fips: 35047,
    county_name: "San Miguel",
    county_weights: {
      35033: 41.85,
      35047: 58.15,
    },
    county_names_all: "San Miguel|Mora",
    county_fips_all: "35047|35033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87743,
    lat: 35.96714,
    lng: -104.01174,
    city: "Roy",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 254,
    density: 0.2,
    county_fips: 35021,
    county_name: "Harding",
    county_weights: {
      35021: 100,
    },
    county_names_all: "Harding",
    county_fips_all: 35021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87745,
    lat: 35.7877,
    lng: -105.26635,
    city: "Sapello",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 845,
    density: 1.8,
    county_fips: 35047,
    county_name: "San Miguel",
    county_weights: {
      35033: 9.55,
      35047: 90.45,
    },
    county_names_all: "San Miguel|Mora",
    county_fips_all: "35047|35033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87746,
    lat: 35.66271,
    lng: -104.12715,
    city: "Solano",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49,
    density: 0,
    county_fips: 35047,
    county_name: "San Miguel",
    county_weights: {
      35021: 5.76,
      35047: 94.24,
    },
    county_names_all: "San Miguel|Harding",
    county_fips_all: "35047|35021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87747,
    lat: 36.35856,
    lng: -104.44472,
    city: "Springer",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1511,
    density: 0.8,
    county_fips: 35007,
    county_name: "Colfax",
    county_weights: {
      35007: 100,
    },
    county_names_all: "Colfax",
    county_fips_all: 35007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87749,
    lat: 36.57827,
    lng: -105.13028,
    city: "Ute Park",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 225,
    density: 5.4,
    county_fips: 35007,
    county_name: "Colfax",
    county_weights: {
      35007: 100,
    },
    county_names_all: "Colfax",
    county_fips_all: 35007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87750,
    lat: 35.82498,
    lng: -104.92704,
    city: "Valmora",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 35033,
    county_name: "Mora",
    county_weights: {
      35033: 100,
    },
    county_names_all: "Mora",
    county_fips_all: 35033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87752,
    lat: 36.01339,
    lng: -104.62763,
    city: "Wagon Mound",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 594,
    density: 0.3,
    county_fips: 35033,
    county_name: "Mora",
    county_weights: {
      35033: 100,
    },
    county_names_all: "Mora",
    county_fips_all: 35033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87753,
    lat: 35.85796,
    lng: -104.95477,
    city: "Watrous",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 98,
    density: 0.2,
    county_fips: 35033,
    county_name: "Mora",
    county_weights: {
      35033: 100,
    },
    county_names_all: "Mora",
    county_fips_all: 35033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87801,
    lat: 34.04824,
    lng: -106.96668,
    city: "Socorro",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9272,
    density: 20.2,
    county_fips: 35053,
    county_name: "Socorro",
    county_weights: {
      35053: 100,
    },
    county_names_all: "Socorro",
    county_fips_all: 35053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87820,
    lat: 33.90448,
    lng: -108.55837,
    city: "Aragon",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 98,
    density: 0.2,
    county_fips: 35003,
    county_name: "Catron",
    county_weights: {
      35003: 100,
    },
    county_names_all: "Catron",
    county_fips_all: 35003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87821,
    lat: 33.93515,
    lng: -108.0929,
    city: "Datil",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 711,
    density: 0.2,
    county_fips: 35003,
    county_name: "Catron",
    county_weights: {
      35003: 100,
    },
    county_names_all: "Catron",
    county_fips_all: 35003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87823,
    lat: 34.18348,
    lng: -106.95901,
    city: "Lemitar",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 656,
    density: 5.3,
    county_fips: 35053,
    county_name: "Socorro",
    county_weights: {
      35053: 100,
    },
    county_names_all: "Socorro",
    county_fips_all: 35053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87824,
    lat: 33.82708,
    lng: -108.97731,
    city: "Luna",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63,
    density: 0.2,
    county_fips: 35003,
    county_name: "Catron",
    county_weights: {
      35003: 100,
    },
    county_names_all: "Catron",
    county_fips_all: 35003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87825,
    lat: 33.94509,
    lng: -107.6603,
    city: "Magdalena",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2302,
    density: 0.4,
    county_fips: 35053,
    county_name: "Socorro",
    county_weights: {
      35003: 32.4,
      35053: 67.6,
    },
    county_names_all: "Socorro|Catron",
    county_fips_all: "35053|35003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87827,
    lat: 34.36366,
    lng: -108.12546,
    city: "Pie Town",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 185,
    density: 0.2,
    county_fips: 35003,
    county_name: "Catron",
    county_weights: {
      35003: 100,
    },
    county_names_all: "Catron",
    county_fips_all: 35003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87828,
    lat: 34.20567,
    lng: -106.92056,
    city: "Polvadera",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 777,
    density: 89.1,
    county_fips: 35053,
    county_name: "Socorro",
    county_weights: {
      35053: 100,
    },
    county_names_all: "Socorro",
    county_fips_all: 35053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87829,
    lat: 34.25215,
    lng: -108.64369,
    city: "Quemado",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 744,
    density: 0.2,
    county_fips: 35003,
    county_name: "Catron",
    county_weights: {
      35003: 100,
    },
    county_names_all: "Catron",
    county_fips_all: 35003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87830,
    lat: 33.70362,
    lng: -108.73884,
    city: "Reserve",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1062,
    density: 0.6,
    county_fips: 35003,
    county_name: "Catron",
    county_weights: {
      35003: 100,
    },
    county_names_all: "Catron",
    county_fips_all: 35003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87831,
    lat: 34.28303,
    lng: -106.88722,
    city: "San Acacia",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 223,
    density: 5.8,
    county_fips: 35053,
    county_name: "Socorro",
    county_weights: {
      35053: 100,
    },
    county_names_all: "Socorro",
    county_fips_all: 35053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87832,
    lat: 33.83949,
    lng: -106.83284,
    city: "San Antonio",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 176,
    density: 0.1,
    county_fips: 35053,
    county_name: "Socorro",
    county_weights: {
      35053: 100,
    },
    county_names_all: "Socorro",
    county_fips_all: 35053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87901,
    lat: 33.1753,
    lng: -107.01908,
    city: "Truth Or Consequences",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6263,
    density: 2.2,
    county_fips: 35051,
    county_name: "Sierra",
    county_weights: {
      35051: 100,
    },
    county_names_all: "Sierra",
    county_fips_all: 35051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87930,
    lat: 32.84962,
    lng: -107.33762,
    city: "Arrey",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 797,
    density: 8.7,
    county_fips: 35051,
    county_name: "Sierra",
    county_weights: {
      35051: 100,
    },
    county_names_all: "Sierra",
    county_fips_all: 35051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87931,
    lat: 32.93379,
    lng: -107.33657,
    city: "Caballo",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 914,
    density: 2.1,
    county_fips: 35051,
    county_name: "Sierra",
    county_weights: {
      35051: 100,
    },
    county_names_all: "Sierra",
    county_fips_all: 35051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87933,
    lat: 32.79115,
    lng: -107.27885,
    city: "Derry",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 153,
    density: 52.9,
    county_fips: 35051,
    county_name: "Sierra",
    county_weights: {
      35051: 100,
    },
    county_names_all: "Sierra",
    county_fips_all: 35051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87935,
    lat: 33.25423,
    lng: -107.22903,
    city: "Elephant Butte",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1457,
    density: 14.7,
    county_fips: 35051,
    county_name: "Sierra",
    county_weights: {
      35051: 100,
    },
    county_names_all: "Sierra",
    county_fips_all: 35051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87936,
    lat: 32.7544,
    lng: -107.26284,
    city: "Garfield",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 375,
    density: 10.6,
    county_fips: 35013,
    county_name: "Doña Ana",
    county_weights: {
      35013: 86.5,
      35051: 13.5,
    },
    county_names_all: "Doña Ana|Sierra",
    county_fips_all: "35013|35051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87937,
    lat: 32.60008,
    lng: -107.1972,
    city: "Hatch",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3622,
    density: 8,
    county_fips: 35013,
    county_name: "Doña Ana",
    county_weights: {
      35013: 100,
    },
    county_names_all: "Doña Ana",
    county_fips_all: 35013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87939,
    lat: 33.40339,
    lng: -107.36566,
    city: "Monticello",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 116,
    density: 0.2,
    county_fips: 35051,
    county_name: "Sierra",
    county_weights: {
      35051: 100,
    },
    county_names_all: "Sierra",
    county_fips_all: 35051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87940,
    lat: 32.60986,
    lng: -106.99465,
    city: "Rincon",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 730,
    density: 4.5,
    county_fips: 35013,
    county_name: "Doña Ana",
    county_weights: {
      35013: 100,
    },
    county_names_all: "Doña Ana",
    county_fips_all: 35013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87941,
    lat: 32.7055,
    lng: -107.21424,
    city: "Salem",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 680,
    density: 33.3,
    county_fips: 35013,
    county_name: "Doña Ana",
    county_weights: {
      35013: 100,
    },
    county_names_all: "Doña Ana",
    county_fips_all: 35013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87942,
    lat: 33.09447,
    lng: -107.42951,
    city: "Williamsburg",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 707,
    density: 1.9,
    county_fips: 35051,
    county_name: "Sierra",
    county_weights: {
      35051: 100,
    },
    county_names_all: "Sierra",
    county_fips_all: 35051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 87943,
    lat: 33.44312,
    lng: -107.6817,
    city: "Winston",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 150,
    density: 0,
    county_fips: 35051,
    county_name: "Sierra",
    county_weights: {
      35003: 17.64,
      35051: 45.18,
      35053: 37.19,
    },
    county_names_all: "Sierra|Socorro|Catron",
    county_fips_all: "35051|35053|35003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88001,
    lat: 32.29026,
    lng: -106.75318,
    city: "Las Cruces",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37957,
    density: 1321.4,
    county_fips: 35013,
    county_name: "Doña Ana",
    county_weights: {
      35013: 100,
    },
    county_names_all: "Doña Ana",
    county_fips_all: 35013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88002,
    lat: 32.38275,
    lng: -106.45804,
    city: "White Sands Missile Range",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1386,
    density: 10.5,
    county_fips: 35013,
    county_name: "Doña Ana",
    county_weights: {
      35013: 100,
    },
    county_names_all: "Doña Ana",
    county_fips_all: 35013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88003,
    lat: 32.27868,
    lng: -106.74566,
    city: "Las Cruces",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 618,
    density: 481.4,
    county_fips: 35013,
    county_name: "Doña Ana",
    county_weights: {
      35013: 100,
    },
    county_names_all: "Doña Ana",
    county_fips_all: 35013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88004,
    lat: 32.25022,
    lng: -106.94908,
    city: "Las Cruces",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1326,
    density: 2422.8,
    county_fips: 35013,
    county_name: "Doña Ana",
    county_weights: {
      35013: 100,
    },
    county_names_all: "Doña Ana",
    county_fips_all: 35013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88005,
    lat: 32.22757,
    lng: -106.99027,
    city: "Las Cruces",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27257,
    density: 69.7,
    county_fips: 35013,
    county_name: "Doña Ana",
    county_weights: {
      35013: 100,
    },
    county_names_all: "Doña Ana",
    county_fips_all: 35013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88007,
    lat: 32.37103,
    lng: -106.9984,
    city: "Las Cruces",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23505,
    density: 27.6,
    county_fips: 35013,
    county_name: "Doña Ana",
    county_weights: {
      35013: 100,
    },
    county_names_all: "Doña Ana",
    county_fips_all: 35013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88008,
    lat: 31.81867,
    lng: -106.74188,
    city: "Santa Teresa",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10734,
    density: 51.4,
    county_fips: 35013,
    county_name: "Doña Ana",
    county_weights: {
      35013: 100,
    },
    county_names_all: "Doña Ana",
    county_fips_all: 35013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88009,
    lat: 31.91248,
    lng: -108.53627,
    city: "Playas",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62,
    density: 12.8,
    county_fips: 35023,
    county_name: "Hidalgo",
    county_weights: {
      35023: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 35023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88011,
    lat: 32.39533,
    lng: -106.58519,
    city: "Las Cruces",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28594,
    density: 43.9,
    county_fips: 35013,
    county_name: "Doña Ana",
    county_weights: {
      35013: 100,
    },
    county_names_all: "Doña Ana",
    county_fips_all: 35013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88012,
    lat: 32.58898,
    lng: -106.77135,
    city: "Las Cruces",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30080,
    density: 33.3,
    county_fips: 35013,
    county_name: "Doña Ana",
    county_weights: {
      35013: 100,
    },
    county_names_all: "Doña Ana",
    county_fips_all: 35013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88020,
    lat: 31.78203,
    lng: -108.82192,
    city: "Animas",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 773,
    density: 0.2,
    county_fips: 35023,
    county_name: "Hidalgo",
    county_weights: {
      35023: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 35023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88021,
    lat: 31.97338,
    lng: -106.81639,
    city: "Anthony",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18813,
    density: 15.9,
    county_fips: 35013,
    county_name: "Doña Ana",
    county_weights: {
      35013: 100,
    },
    county_names_all: "Doña Ana",
    county_fips_all: 35013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88022,
    lat: 32.80238,
    lng: -108.18766,
    city: "Arenas Valley",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1080,
    density: 36.7,
    county_fips: 35017,
    county_name: "Grant",
    county_weights: {
      35017: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 35017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88023,
    lat: 32.71106,
    lng: -108.07749,
    city: "Bayard",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 35017,
    county_name: "Grant",
    county_weights: {
      35017: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 35017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88024,
    lat: 32.06539,
    lng: -106.61803,
    city: "Berino",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 35013,
    county_name: "Doña Ana",
    county_weights: {
      35013: 100,
    },
    county_names_all: "Doña Ana",
    county_fips_all: 35013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88025,
    lat: 33.10087,
    lng: -108.71984,
    city: "Buckhorn",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 169,
    density: 0.5,
    county_fips: 35017,
    county_name: "Grant",
    county_weights: {
      35017: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 35017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88026,
    lat: 32.75833,
    lng: -108.15741,
    city: "Santa Clara",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1443,
    density: 118.2,
    county_fips: 35017,
    county_name: "Grant",
    county_weights: {
      35017: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 35017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88027,
    lat: 32.03625,
    lng: -106.68143,
    city: "Chamberino",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 327,
    density: 62.2,
    county_fips: 35013,
    county_name: "Doña Ana",
    county_weights: {
      35013: 100,
    },
    county_names_all: "Doña Ana",
    county_fips_all: 35013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88028,
    lat: 32.95131,
    lng: -108.67807,
    city: "Cliff",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 370,
    density: 0.8,
    county_fips: 35017,
    county_name: "Grant",
    county_weights: {
      35017: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 35017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88029,
    lat: 31.84339,
    lng: -107.70225,
    city: "Columbus",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1116,
    density: 2.3,
    county_fips: 35029,
    county_name: "Luna",
    county_weights: {
      35029: 100,
    },
    county_names_all: "Luna",
    county_fips_all: 35029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88030,
    lat: 32.19039,
    lng: -107.72768,
    city: "Deming",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22906,
    density: 3.4,
    county_fips: 35029,
    county_name: "Luna",
    county_weights: {
      35029: 100,
    },
    county_names_all: "Luna",
    county_fips_all: 35029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88034,
    lat: 32.58114,
    lng: -107.96764,
    city: "Faywood",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18,
    density: 0.1,
    county_fips: 35017,
    county_name: "Grant",
    county_weights: {
      35017: 95.45,
      35029: 4.55,
    },
    county_names_all: "Grant|Luna",
    county_fips_all: "35017|35029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88038,
    lat: 33.0722,
    lng: -108.42625,
    city: "Gila",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 215,
    density: 0.2,
    county_fips: 35017,
    county_name: "Grant",
    county_weights: {
      35017: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 35017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88039,
    lat: 33.35081,
    lng: -108.71909,
    city: "Glenwood",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 670,
    density: 0.3,
    county_fips: 35003,
    county_name: "Catron",
    county_weights: {
      35003: 100,
    },
    county_names_all: "Catron",
    county_fips_all: 35003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88040,
    lat: 31.6197,
    lng: -108.44025,
    city: "Hachita",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62,
    density: 0,
    county_fips: 35023,
    county_name: "Hidalgo",
    county_weights: {
      35017: 13.72,
      35023: 86.28,
    },
    county_names_all: "Hidalgo|Grant",
    county_fips_all: "35023|35017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88041,
    lat: 32.78367,
    lng: -107.89654,
    city: "Hanover",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1201,
    density: 1.1,
    county_fips: 35017,
    county_name: "Grant",
    county_weights: {
      35017: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 35017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88042,
    lat: 32.80979,
    lng: -107.56385,
    city: "Hillsboro",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 367,
    density: 0.2,
    county_fips: 35051,
    county_name: "Sierra",
    county_weights: {
      35051: 100,
    },
    county_names_all: "Sierra",
    county_fips_all: 35051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88043,
    lat: 32.61358,
    lng: -108.11762,
    city: "Hurley",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1552,
    density: 8.4,
    county_fips: 35017,
    county_name: "Grant",
    county_weights: {
      35017: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 35017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88044,
    lat: 32.01977,
    lng: -107.08116,
    city: "La Mesa",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3333,
    density: 2.2,
    county_fips: 35013,
    county_name: "Doña Ana",
    county_weights: {
      35013: 100,
    },
    county_names_all: "Doña Ana",
    county_fips_all: 35013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88045,
    lat: 32.3298,
    lng: -108.71057,
    city: "Lordsburg",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3209,
    density: 0.9,
    county_fips: 35023,
    county_name: "Hidalgo",
    county_weights: {
      35017: 22.67,
      35023: 77.33,
    },
    county_names_all: "Hidalgo|Grant",
    county_fips_all: "35023|35017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88046,
    lat: 32.26797,
    lng: -106.79674,
    city: "Mesilla",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 867,
    density: 541.1,
    county_fips: 35013,
    county_name: "Doña Ana",
    county_weights: {
      35013: 100,
    },
    county_names_all: "Doña Ana",
    county_fips_all: 35013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88047,
    lat: 32.21444,
    lng: -106.71556,
    city: "Mesilla Park",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1683,
    density: 100.8,
    county_fips: 35013,
    county_name: "Doña Ana",
    county_weights: {
      35013: 100,
    },
    county_names_all: "Doña Ana",
    county_fips_all: 35013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88048,
    lat: 32.14966,
    lng: -106.6581,
    city: "Mesquite",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2471,
    density: 43.7,
    county_fips: 35013,
    county_name: "Doña Ana",
    county_weights: {
      35013: 100,
    },
    county_names_all: "Doña Ana",
    county_fips_all: 35013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88049,
    lat: 33.04814,
    lng: -108.06782,
    city: "Mimbres",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 304,
    density: 0.2,
    county_fips: 35017,
    county_name: "Grant",
    county_weights: {
      35017: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 35017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88051,
    lat: 33.01471,
    lng: -108.94299,
    city: "Mule Creek",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 118,
    density: 0.1,
    county_fips: 35017,
    county_name: "Grant",
    county_weights: {
      35017: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 35017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88052,
    lat: 32.45034,
    lng: -106.60186,
    city: "Organ",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 172,
    density: 10.9,
    county_fips: 35013,
    county_name: "Doña Ana",
    county_weights: {
      35013: 100,
    },
    county_names_all: "Doña Ana",
    county_fips_all: 35013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88053,
    lat: 32.89601,
    lng: -108.21378,
    city: "Pinos Altos",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61,
    density: 1.6,
    county_fips: 35017,
    county_name: "Grant",
    county_weights: {
      35017: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 35017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88055,
    lat: 32.7497,
    lng: -108.73985,
    city: "Redrock",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23,
    density: 0,
    county_fips: 35017,
    county_name: "Grant",
    county_weights: {
      35017: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 35017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88056,
    lat: 31.84062,
    lng: -109.00295,
    city: "Rodeo",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 182,
    density: 0.7,
    county_fips: 35023,
    county_name: "Hidalgo",
    county_weights: {
      35023: 100,
    },
    county_names_all: "Hidalgo",
    county_fips_all: 35023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88061,
    lat: 32.6211,
    lng: -108.40888,
    city: "Silver City",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17885,
    density: 7.7,
    county_fips: 35017,
    county_name: "Grant",
    county_weights: {
      35017: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 35017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88063,
    lat: 31.80715,
    lng: -106.58259,
    city: "Sunland Park",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13400,
    density: 829.6,
    county_fips: 35013,
    county_name: "Doña Ana",
    county_weights: {
      35013: 100,
    },
    county_names_all: "Doña Ana",
    county_fips_all: 35013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88065,
    lat: 32.71375,
    lng: -108.30231,
    city: "Tyrone",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 456,
    density: 276.4,
    county_fips: 35017,
    county_name: "Grant",
    county_weights: {
      35017: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 35017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88072,
    lat: 32.14242,
    lng: -106.61329,
    city: "Vado",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2685,
    density: 39.8,
    county_fips: 35013,
    county_name: "Doña Ana",
    county_weights: {
      35013: 100,
    },
    county_names_all: "Doña Ana",
    county_fips_all: 35013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88081,
    lat: 32.24958,
    lng: -106.28821,
    city: "Chaparral",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16136,
    density: 16.5,
    county_fips: 35035,
    county_name: "Otero",
    county_weights: {
      35013: 10.25,
      35035: 89.75,
    },
    county_names_all: "Otero|Doña Ana",
    county_fips_all: "35035|35013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88101,
    lat: 34.50114,
    lng: -103.26616,
    city: "Clovis",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46133,
    density: 33,
    county_fips: 35009,
    county_name: "Curry",
    county_weights: {
      35009: 98.89,
      35041: 1.11,
    },
    county_names_all: "Curry|Roosevelt",
    county_fips_all: "35009|35041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88103,
    lat: 34.38418,
    lng: -103.31551,
    city: "Cannon Afb",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 259,
    density: 22.3,
    county_fips: 35009,
    county_name: "Curry",
    county_weights: {
      35009: 100,
    },
    county_names_all: "Curry",
    county_fips_all: 35009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88112,
    lat: 34.91023,
    lng: -103.15863,
    city: "Broadview",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 337,
    density: 0.5,
    county_fips: 35009,
    county_name: "Curry",
    county_weights: {
      35009: 66.23,
      35037: 33.77,
    },
    county_names_all: "Curry|Quay",
    county_fips_all: "35009|35037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88113,
    lat: 33.81968,
    lng: -103.08894,
    city: "Causey",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 178,
    density: 2,
    county_fips: 35041,
    county_name: "Roosevelt",
    county_weights: {
      35041: 100,
    },
    county_names_all: "Roosevelt",
    county_fips_all: 35041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88114,
    lat: 33.51026,
    lng: -103.43052,
    city: "Crossroads",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43,
    density: 0.1,
    county_fips: 35025,
    county_name: "Lea",
    county_weights: {
      35025: 100,
    },
    county_names_all: "Lea",
    county_fips_all: 35025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88115,
    lat: 33.93185,
    lng: -103.34466,
    city: "Dora",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74,
    density: 27.7,
    county_fips: 35041,
    county_name: "Roosevelt",
    county_weights: {
      35041: 100,
    },
    county_names_all: "Roosevelt",
    county_fips_all: 35041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88116,
    lat: 33.89425,
    lng: -103.82335,
    city: "Elida",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 370,
    density: 0.1,
    county_fips: 35041,
    county_name: "Roosevelt",
    county_weights: {
      35005: 48.74,
      35041: 51.26,
    },
    county_names_all: "Roosevelt|Chaves",
    county_fips_all: "35041|35005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88118,
    lat: 34.23626,
    lng: -103.6645,
    city: "Floyd",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 264,
    density: 0.5,
    county_fips: 35041,
    county_name: "Roosevelt",
    county_weights: {
      35009: 17.5,
      35041: 82.5,
    },
    county_names_all: "Roosevelt|Curry",
    county_fips_all: "35041|35009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88119,
    lat: 34.34782,
    lng: -104.40041,
    city: "Fort Sumner",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1910,
    density: 0.5,
    county_fips: 35011,
    county_name: "De Baca",
    county_weights: {
      35011: 100,
    },
    county_names_all: "De Baca",
    county_fips_all: 35011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88120,
    lat: 34.90329,
    lng: -103.42523,
    city: "Grady",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 402,
    density: 0.5,
    county_fips: 35037,
    county_name: "Quay",
    county_weights: {
      35009: 28.45,
      35037: 71.55,
    },
    county_names_all: "Quay|Curry",
    county_fips_all: "35037|35009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88121,
    lat: 34.67979,
    lng: -103.97721,
    city: "House",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 163,
    density: 0.3,
    county_fips: 35037,
    county_name: "Quay",
    county_weights: {
      35037: 100,
    },
    county_names_all: "Quay",
    county_fips_all: 35037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88124,
    lat: 34.52771,
    lng: -103.6473,
    city: "Melrose",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1082,
    density: 0.6,
    county_fips: 35009,
    county_name: "Curry",
    county_weights: {
      35009: 58.24,
      35037: 14.04,
      35041: 27.72,
    },
    county_names_all: "Curry|Roosevelt|Quay",
    county_fips_all: "35009|35041|35037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88125,
    lat: 33.67137,
    lng: -103.24997,
    city: "Milnesand",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 77,
    density: 0.1,
    county_fips: 35041,
    county_name: "Roosevelt",
    county_weights: {
      35041: 100,
    },
    county_names_all: "Roosevelt",
    county_fips_all: 35041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88126,
    lat: 33.81642,
    lng: -103.35359,
    city: "Pep",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33,
    density: 0.2,
    county_fips: 35041,
    county_name: "Roosevelt",
    county_weights: {
      35041: 100,
    },
    county_names_all: "Roosevelt",
    county_fips_all: 35041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88130,
    lat: 34.1285,
    lng: -103.31825,
    city: "Portales",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17385,
    density: 10.6,
    county_fips: 35041,
    county_name: "Roosevelt",
    county_weights: {
      35041: 100,
    },
    county_names_all: "Roosevelt",
    county_fips_all: 35041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88132,
    lat: 33.92382,
    lng: -103.18855,
    city: "Rogers",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 228,
    density: 0.4,
    county_fips: 35041,
    county_name: "Roosevelt",
    county_weights: {
      35041: 100,
    },
    county_names_all: "Roosevelt",
    county_fips_all: 35041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88134,
    lat: 34.37413,
    lng: -104.00487,
    city: "Taiban",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57,
    density: 0.1,
    county_fips: 35011,
    county_name: "De Baca",
    county_weights: {
      35011: 83.72,
      35041: 16.28,
    },
    county_names_all: "De Baca|Roosevelt",
    county_fips_all: "35011|35041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88135,
    lat: 34.5623,
    lng: -103.08204,
    city: "Texico",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1426,
    density: 3.8,
    county_fips: 35009,
    county_name: "Curry",
    county_weights: {
      35009: 93.56,
      35041: 6.44,
    },
    county_names_all: "Curry|Roosevelt",
    county_fips_all: "35009|35041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88136,
    lat: 34.25356,
    lng: -104.83347,
    city: "Yeso",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28,
    density: 0,
    county_fips: 35011,
    county_name: "De Baca",
    county_weights: {
      35011: 67.01,
      35027: 32.99,
    },
    county_names_all: "De Baca|Lincoln",
    county_fips_all: "35011|35027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88201,
    lat: 33.66517,
    lng: -104.48932,
    city: "Roswell",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26551,
    density: 3.9,
    county_fips: 35005,
    county_name: "Chaves",
    county_weights: {
      35005: 86.58,
      35027: 13.42,
    },
    county_names_all: "Chaves|Lincoln",
    county_fips_all: "35005|35027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88203,
    lat: 33.22169,
    lng: -104.43904,
    city: "Roswell",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30234,
    density: 10.7,
    county_fips: 35005,
    county_name: "Chaves",
    county_weights: {
      35005: 100,
    },
    county_names_all: "Chaves",
    county_fips_all: 35005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88210,
    lat: 32.77272,
    lng: -104.22567,
    city: "Artesia",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18238,
    density: 5.5,
    county_fips: 35015,
    county_name: "Eddy",
    county_weights: {
      35015: 100,
    },
    county_names_all: "Eddy",
    county_fips_all: 35015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88220,
    lat: 32.31421,
    lng: -104.41732,
    city: "Carlsbad",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37269,
    density: 7.5,
    county_fips: 35015,
    county_name: "Eddy",
    county_weights: {
      35015: 100,
    },
    county_names_all: "Eddy",
    county_fips_all: 35015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88230,
    lat: 33.21396,
    lng: -104.39764,
    city: "Dexter",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4672,
    density: 6.3,
    county_fips: 35005,
    county_name: "Chaves",
    county_weights: {
      35005: 100,
    },
    county_names_all: "Chaves",
    county_fips_all: 35005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88231,
    lat: 32.42376,
    lng: -103.26873,
    city: "Eunice",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3498,
    density: 3.8,
    county_fips: 35025,
    county_name: "Lea",
    county_weights: {
      35025: 100,
    },
    county_names_all: "Lea",
    county_fips_all: 35025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88232,
    lat: 33.06398,
    lng: -104.1568,
    city: "Hagerman",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2452,
    density: 1.8,
    county_fips: 35005,
    county_name: "Chaves",
    county_weights: {
      35005: 100,
    },
    county_names_all: "Chaves",
    county_fips_all: 35005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88240,
    lat: 32.67285,
    lng: -103.43454,
    city: "Hobbs",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41574,
    density: 26.7,
    county_fips: 35025,
    county_name: "Lea",
    county_weights: {
      35025: 100,
    },
    county_names_all: "Lea",
    county_fips_all: 35025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88242,
    lat: 32.81654,
    lng: -103.16014,
    city: "Hobbs",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7076,
    density: 38.8,
    county_fips: 35025,
    county_name: "Lea",
    county_weights: {
      35025: 100,
    },
    county_names_all: "Lea",
    county_fips_all: 35025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88244,
    lat: 32.76412,
    lng: -103.22498,
    city: "Hobbs",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 35025,
    county_name: "Lea",
    county_weights: {
      35025: 100,
    },
    county_names_all: "Lea",
    county_fips_all: 35025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88250,
    lat: 32.72882,
    lng: -104.91851,
    city: "Hope",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 266,
    density: 0.1,
    county_fips: 35005,
    county_name: "Chaves",
    county_weights: {
      35005: 65.84,
      35015: 34.16,
    },
    county_names_all: "Chaves|Eddy",
    county_fips_all: "35005|35015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88252,
    lat: 32.16345,
    lng: -103.39452,
    city: "Jal",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1892,
    density: 0.9,
    county_fips: 35025,
    county_name: "Lea",
    county_weights: {
      35025: 100,
    },
    county_names_all: "Lea",
    county_fips_all: 35025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88253,
    lat: 32.98767,
    lng: -104.54852,
    city: "Lake Arthur",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 902,
    density: 1.6,
    county_fips: 35005,
    county_name: "Chaves",
    county_weights: {
      35005: 73.98,
      35015: 26.02,
    },
    county_names_all: "Chaves|Eddy",
    county_fips_all: "35005|35015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88254,
    lat: 32.62876,
    lng: -104.40779,
    city: "Lakewood",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48,
    density: 0.5,
    county_fips: 35015,
    county_name: "Eddy",
    county_weights: {
      35015: 100,
    },
    county_names_all: "Eddy",
    county_fips_all: 35015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88255,
    lat: 32.81091,
    lng: -103.99923,
    city: "Loco Hills",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22,
    density: 2.4,
    county_fips: 35015,
    county_name: "Eddy",
    county_weights: {
      35015: 100,
    },
    county_names_all: "Eddy",
    county_fips_all: 35015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88256,
    lat: 32.19543,
    lng: -103.88924,
    city: "Loving",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1843,
    density: 1.5,
    county_fips: 35015,
    county_name: "Eddy",
    county_weights: {
      35015: 100,
    },
    county_names_all: "Eddy",
    county_fips_all: 35015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88260,
    lat: 32.98698,
    lng: -103.39801,
    city: "Lovington",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14836,
    density: 7,
    county_fips: 35025,
    county_name: "Lea",
    county_weights: {
      35025: 100,
    },
    county_names_all: "Lea",
    county_fips_all: 35025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88262,
    lat: 33.12871,
    lng: -103.40694,
    city: "Mcdonald",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14,
    density: 0.1,
    county_fips: 35025,
    county_name: "Lea",
    county_weights: {
      35025: 100,
    },
    county_names_all: "Lea",
    county_fips_all: 35025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88263,
    lat: 32.09091,
    lng: -104.09006,
    city: "Malaga",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 134,
    density: 0.4,
    county_fips: 35015,
    county_name: "Eddy",
    county_weights: {
      35015: 100,
    },
    county_names_all: "Eddy",
    county_fips_all: 35015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88264,
    lat: 32.86351,
    lng: -103.70089,
    city: "Maljamar",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 35025,
    county_name: "Lea",
    county_weights: {
      35025: 100,
    },
    county_names_all: "Lea",
    county_fips_all: 35025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88265,
    lat: 32.58421,
    lng: -103.34642,
    city: "Monument",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 142,
    density: 0.7,
    county_fips: 35025,
    county_name: "Lea",
    county_weights: {
      35025: 100,
    },
    county_names_all: "Lea",
    county_fips_all: 35025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88267,
    lat: 33.30983,
    lng: -103.39329,
    city: "Tatum",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1284,
    density: 0.6,
    county_fips: 35025,
    county_name: "Lea",
    county_weights: {
      35025: 100,
    },
    county_names_all: "Lea",
    county_fips_all: 35025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88268,
    lat: 32.17632,
    lng: -104.37939,
    city: "Whites City",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 35015,
    county_name: "Eddy",
    county_weights: {
      35015: 100,
    },
    county_names_all: "Eddy",
    county_fips_all: 35015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88301,
    lat: 33.7494,
    lng: -105.85191,
    city: "Carrizozo",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1118,
    density: 0.5,
    county_fips: 35027,
    county_name: "Lincoln",
    county_weights: {
      35027: 97.69,
      35053: 2.31,
    },
    county_names_all: "Lincoln|Socorro",
    county_fips_all: "35027|35053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88310,
    lat: 32.71809,
    lng: -106.07231,
    city: "Alamogordo",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36585,
    density: 22.8,
    county_fips: 35035,
    county_name: "Otero",
    county_weights: {
      35035: 100,
    },
    county_names_all: "Otero",
    county_fips_all: 35035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88311,
    lat: 32.80689,
    lng: -105.98875,
    city: "Alamogordo",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1298,
    density: 210.4,
    county_fips: 35035,
    county_name: "Otero",
    county_weights: {
      35035: 100,
    },
    county_names_all: "Otero",
    county_fips_all: 35035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88312,
    lat: 33.43186,
    lng: -105.64397,
    city: "Alto",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2806,
    density: 15.2,
    county_fips: 35027,
    county_name: "Lincoln",
    county_weights: {
      35027: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 35027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88314,
    lat: 33.10061,
    lng: -105.86725,
    city: "Bent",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 151,
    density: 1.2,
    county_fips: 35035,
    county_name: "Otero",
    county_weights: {
      35035: 100,
    },
    county_names_all: "Otero",
    county_fips_all: 35035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88316,
    lat: 33.77306,
    lng: -105.36895,
    city: "Capitan",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2097,
    density: 0.9,
    county_fips: 35027,
    county_name: "Lincoln",
    county_weights: {
      35027: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 35027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88317,
    lat: 32.86081,
    lng: -105.67442,
    city: "Cloudcroft",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2118,
    density: 3,
    county_fips: 35035,
    county_name: "Otero",
    county_weights: {
      35035: 100,
    },
    county_names_all: "Otero",
    county_fips_all: 35035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88318,
    lat: 34.22491,
    lng: -105.44166,
    city: "Corona",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 291,
    density: 0.1,
    county_fips: 35027,
    county_name: "Lincoln",
    county_weights: {
      35027: 69.82,
      35057: 30.18,
    },
    county_names_all: "Lincoln|Torrance",
    county_fips_all: "35027|35057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88321,
    lat: 34.76815,
    lng: -105.45564,
    city: "Encino",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 107,
    density: 0,
    county_fips: 35057,
    county_name: "Torrance",
    county_weights: {
      35019: 9.48,
      35047: 2.6,
      35057: 87.92,
    },
    county_names_all: "Torrance|Guadalupe|San Miguel",
    county_fips_all: "35057|35019|35047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88323,
    lat: 33.48534,
    lng: -105.56488,
    city: "Fort Stanton",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 35027,
    county_name: "Lincoln",
    county_weights: {
      35027: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 35027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88324,
    lat: 33.38666,
    lng: -105.47268,
    city: "Glencoe",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 225,
    density: 2.2,
    county_fips: 35027,
    county_name: "Lincoln",
    county_weights: {
      35027: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 35027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88325,
    lat: 32.8529,
    lng: -105.86027,
    city: "High Rolls Mountain Park",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1413,
    density: 5.1,
    county_fips: 35035,
    county_name: "Otero",
    county_weights: {
      35035: 100,
    },
    county_names_all: "Otero",
    county_fips_all: 35035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88330,
    lat: 32.87046,
    lng: -106.09951,
    city: "Holloman Air Force Base",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 35035,
    county_name: "Otero",
    county_weights: {
      35035: 100,
    },
    county_names_all: "Otero",
    county_fips_all: 35035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88336,
    lat: 33.31883,
    lng: -105.28552,
    city: "Hondo",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 385,
    density: 1.1,
    county_fips: 35027,
    county_name: "Lincoln",
    county_weights: {
      35027: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 35027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88337,
    lat: 32.99141,
    lng: -105.89025,
    city: "La Luz",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1977,
    density: 18.9,
    county_fips: 35035,
    county_name: "Otero",
    county_weights: {
      35035: 100,
    },
    county_names_all: "Otero",
    county_fips_all: 35035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88338,
    lat: 33.53723,
    lng: -105.38468,
    city: "Lincoln",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 139,
    density: 0.3,
    county_fips: 35027,
    county_name: "Lincoln",
    county_weights: {
      35027: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 35027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88339,
    lat: 32.9561,
    lng: -105.32141,
    city: "Mayhill",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 748,
    density: 0.8,
    county_fips: 35005,
    county_name: "Chaves",
    county_weights: {
      35005: 59.4,
      35035: 40.6,
    },
    county_names_all: "Chaves|Otero",
    county_fips_all: "35005|35035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88340,
    lat: 33.17859,
    lng: -105.61211,
    city: "Mescalero",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4204,
    density: 2.3,
    county_fips: 35035,
    county_name: "Otero",
    county_weights: {
      35035: 100,
    },
    county_names_all: "Otero",
    county_fips_all: 35035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88341,
    lat: 33.50811,
    lng: -105.79161,
    city: "Nogal",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 681,
    density: 1.7,
    county_fips: 35027,
    county_name: "Lincoln",
    county_weights: {
      35027: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 35027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88342,
    lat: 32.38926,
    lng: -106.10469,
    city: "Orogrande",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5,
    density: 0.3,
    county_fips: 35035,
    county_name: "Otero",
    county_weights: {
      35035: 100,
    },
    county_names_all: "Otero",
    county_fips_all: 35035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88343,
    lat: 33.23504,
    lng: -105.06772,
    city: "Picacho",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13,
    density: 0,
    county_fips: 35027,
    county_name: "Lincoln",
    county_weights: {
      35027: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 35027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88344,
    lat: 32.5105,
    lng: -105.2235,
    city: "Pinon",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37,
    density: 0,
    county_fips: 35035,
    county_name: "Otero",
    county_weights: {
      35005: 30.13,
      35035: 69.87,
    },
    county_names_all: "Otero|Chaves",
    county_fips_all: "35035|35005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88345,
    lat: 33.35127,
    lng: -105.67092,
    city: "Ruidoso",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8610,
    density: 84.5,
    county_fips: 35027,
    county_name: "Lincoln",
    county_weights: {
      35027: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 35027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88346,
    lat: 33.34814,
    lng: -105.54073,
    city: "Ruidoso Downs",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2620,
    density: 19.4,
    county_fips: 35027,
    county_name: "Lincoln",
    county_weights: {
      35027: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 35027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88347,
    lat: 32.72757,
    lng: -105.64704,
    city: "Sacramento",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60,
    density: 0.2,
    county_fips: 35035,
    county_name: "Otero",
    county_weights: {
      35035: 100,
    },
    county_names_all: "Otero",
    county_fips_all: 35035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88348,
    lat: 33.41675,
    lng: -105.39858,
    city: "San Patricio",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 471,
    density: 5.9,
    county_fips: 35027,
    county_name: "Lincoln",
    county_weights: {
      35027: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 35027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88349,
    lat: 32.795,
    lng: -105.80313,
    city: "Sunspot",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 35035,
    county_name: "Otero",
    county_weights: {
      35035: 100,
    },
    county_names_all: "Otero",
    county_fips_all: 35035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88350,
    lat: 32.6031,
    lng: -105.67669,
    city: "Timberon",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 262,
    density: 2.2,
    county_fips: 35035,
    county_name: "Otero",
    county_weights: {
      35035: 100,
    },
    county_names_all: "Otero",
    county_fips_all: 35035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88351,
    lat: 33.47154,
    lng: -105.09777,
    city: "Tinnie",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 205,
    density: 0.2,
    county_fips: 35027,
    county_name: "Lincoln",
    county_weights: {
      35027: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 35027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88352,
    lat: 33.18745,
    lng: -106.00712,
    city: "Tularosa",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4766,
    density: 6.2,
    county_fips: 35035,
    county_name: "Otero",
    county_weights: {
      35035: 100,
    },
    county_names_all: "Otero",
    county_fips_all: 35035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88353,
    lat: 34.49912,
    lng: -105.1034,
    city: "Vaughn",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 302,
    density: 0.2,
    county_fips: 35019,
    county_name: "Guadalupe",
    county_weights: {
      35019: 100,
    },
    county_names_all: "Guadalupe",
    county_fips_all: 35019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88354,
    lat: 32.73771,
    lng: -105.49297,
    city: "Weed",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 98,
    density: 0.2,
    county_fips: 35035,
    county_name: "Otero",
    county_weights: {
      35035: 100,
    },
    county_names_all: "Otero",
    county_fips_all: 35035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88355,
    lat: 33.36288,
    lng: -105.6694,
    city: "Ruidoso",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 35027,
    county_name: "Lincoln",
    county_weights: {
      35027: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 35027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88401,
    lat: 35.08984,
    lng: -103.80942,
    city: "Tucumcari",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6392,
    density: 2.5,
    county_fips: 35037,
    county_name: "Quay",
    county_weights: {
      35037: 90.24,
      35047: 9.76,
    },
    county_names_all: "Quay|San Miguel",
    county_fips_all: "35037|35047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88410,
    lat: 35.90263,
    lng: -103.30767,
    city: "Amistad",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 138,
    density: 0.1,
    county_fips: 35059,
    county_name: "Union",
    county_weights: {
      35021: 38.47,
      35059: 61.53,
    },
    county_names_all: "Union|Harding",
    county_fips_all: "35059|35021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88411,
    lat: 35.23488,
    lng: -103.16248,
    city: "Bard",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 102,
    density: 0.1,
    county_fips: 35037,
    county_name: "Quay",
    county_weights: {
      35037: 100,
    },
    county_names_all: "Quay",
    county_fips_all: 35037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88414,
    lat: 36.77484,
    lng: -104.02073,
    city: "Capulin",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17,
    density: 0.4,
    county_fips: 35007,
    county_name: "Colfax",
    county_weights: {
      35007: 67.36,
      35059: 32.64,
    },
    county_names_all: "Colfax|Union",
    county_fips_all: "35007|35059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88415,
    lat: 36.35171,
    lng: -103.32643,
    city: "Clayton",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3345,
    density: 0.9,
    county_fips: 35059,
    county_name: "Union",
    county_weights: {
      35021: 15.66,
      35059: 84.34,
    },
    county_names_all: "Union|Harding",
    county_fips_all: "35059|35021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88416,
    lat: 35.44255,
    lng: -104.21511,
    city: "Conchas Dam",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 137,
    density: 0.6,
    county_fips: 35047,
    county_name: "San Miguel",
    county_weights: {
      35047: 100,
    },
    county_names_all: "San Miguel",
    county_fips_all: 35047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88417,
    lat: 34.93076,
    lng: -104.25309,
    city: "Cuervo",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 35019,
    county_name: "Guadalupe",
    county_weights: {
      35019: 81.46,
      35037: 18.54,
    },
    county_names_all: "Guadalupe|Quay",
    county_fips_all: "35019|35037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88418,
    lat: 36.74995,
    lng: -103.63874,
    city: "Des Moines",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 328,
    density: 0.2,
    county_fips: 35059,
    county_name: "Union",
    county_weights: {
      35059: 100,
    },
    county_names_all: "Union",
    county_fips_all: 35059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88419,
    lat: 36.91839,
    lng: -103.54734,
    city: "Folsom",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 168,
    density: 0.1,
    county_fips: 35059,
    county_name: "Union",
    county_weights: {
      35059: 100,
    },
    county_names_all: "Union",
    county_fips_all: 35059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88421,
    lat: 35.32691,
    lng: -104.49731,
    city: "Garita",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55,
    density: 0.1,
    county_fips: 35047,
    county_name: "San Miguel",
    county_weights: {
      35047: 100,
    },
    county_names_all: "San Miguel",
    county_fips_all: 35047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88422,
    lat: 36.33791,
    lng: -103.98655,
    city: "Gladstone",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 78,
    density: 0.1,
    county_fips: 35059,
    county_name: "Union",
    county_weights: {
      35007: 35.52,
      35059: 64.48,
    },
    county_names_all: "Union|Colfax",
    county_fips_all: "35059|35007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88424,
    lat: 36.43714,
    lng: -103.6554,
    city: "Grenville",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56,
    density: 0,
    county_fips: 35059,
    county_name: "Union",
    county_weights: {
      35059: 100,
    },
    county_names_all: "Union",
    county_fips_all: 35059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88426,
    lat: 35.52366,
    lng: -103.47607,
    city: "Logan",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1082,
    density: 0.5,
    county_fips: 35021,
    county_name: "Harding",
    county_weights: {
      35021: 65.38,
      35037: 31.51,
      35047: 3.11,
    },
    county_names_all: "Harding|Quay|San Miguel",
    county_fips_all: "35021|35037|35047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88427,
    lat: 34.78172,
    lng: -103.76417,
    city: "Mcalister",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 132,
    density: 0.2,
    county_fips: 35037,
    county_name: "Quay",
    county_weights: {
      35037: 100,
    },
    county_names_all: "Quay",
    county_fips_all: 35037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88430,
    lat: 35.65348,
    lng: -103.21357,
    city: "Nara Visa",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 86,
    density: 0.1,
    county_fips: 35037,
    county_name: "Quay",
    county_weights: {
      35037: 71.89,
      35059: 25.48,
      48359: 2.63,
    },
    county_names_all: "Quay|Union|Oldham",
    county_fips_all: "35037|35059|48359",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88431,
    lat: 35.21256,
    lng: -104.33677,
    city: "Newkirk",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48,
    density: 0.1,
    county_fips: 35019,
    county_name: "Guadalupe",
    county_weights: {
      35019: 57.52,
      35047: 42.48,
    },
    county_names_all: "Guadalupe|San Miguel",
    county_fips_all: "35019|35047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88434,
    lat: 35.12367,
    lng: -103.34013,
    city: "San Jon",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 342,
    density: 0.5,
    county_fips: 35037,
    county_name: "Quay",
    county_weights: {
      35037: 100,
    },
    county_names_all: "Quay",
    county_fips_all: 35037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88435,
    lat: 34.90262,
    lng: -104.8133,
    city: "Santa Rosa",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3681,
    density: 0.8,
    county_fips: 35019,
    county_name: "Guadalupe",
    county_weights: {
      35019: 100,
    },
    county_names_all: "Guadalupe",
    county_fips_all: 35019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88436,
    lat: 36.14965,
    lng: -103.13345,
    city: "Sedan",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48,
    density: 0.1,
    county_fips: 35059,
    county_name: "Union",
    county_weights: {
      35059: 100,
    },
    county_names_all: "Union",
    county_fips_all: 35059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 88439,
    lat: 35.48908,
    lng: -104.35627,
    city: "Trementina",
    state_id: "NM",
    state_name: "New Mexico",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 35047,
    county_name: "San Miguel",
    county_weights: {
      35047: 100,
    },
    county_names_all: "San Miguel",
    county_fips_all: 35047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Denver",
  },
  {
    zip: 89001,
    lat: 37.40035,
    lng: -115.39564,
    city: "Alamo",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1356,
    density: 1,
    county_fips: 32017,
    county_name: "Lincoln",
    county_weights: {
      32017: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 32017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89002,
    lat: 35.99846,
    lng: -114.96181,
    city: "Henderson",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36752,
    density: 1635.1,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89003,
    lat: 36.94925,
    lng: -116.7331,
    city: "Beatty",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 870,
    density: 1.4,
    county_fips: 32023,
    county_name: "Nye",
    county_weights: {
      32023: 100,
    },
    county_names_all: "Nye",
    county_fips_all: 32023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89004,
    lat: 36.04164,
    lng: -115.41261,
    city: "Blue Diamond",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 266,
    density: 15.6,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89005,
    lat: 36.00875,
    lng: -114.84805,
    city: "Boulder City",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16048,
    density: 67.1,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89007,
    lat: 36.68605,
    lng: -114.22915,
    city: "Bunkerville",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1430,
    density: 2.6,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89008,
    lat: 37.26441,
    lng: -114.50414,
    city: "Caliente",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1162,
    density: 0.2,
    county_fips: 32017,
    county_name: "Lincoln",
    county_weights: {
      32017: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 32017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89010,
    lat: 37.82511,
    lng: -118.08079,
    city: "Dyer",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 469,
    density: 0.5,
    county_fips: 32009,
    county_name: "Esmeralda",
    county_weights: {
      32009: 90.34,
      32021: 5.9,
      "06051": 3.76,
    },
    county_names_all: "Esmeralda|Mineral|Mono",
    county_fips_all: "32009|32021|06051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89011,
    lat: 36.0848,
    lng: -114.9651,
    city: "Henderson",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29556,
    density: 691.4,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89012,
    lat: 36.01192,
    lng: -115.04314,
    city: "Henderson",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37617,
    density: 1355.7,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89013,
    lat: 37.34574,
    lng: -117.34393,
    city: "Goldfield",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 242,
    density: 0.1,
    county_fips: 32009,
    county_name: "Esmeralda",
    county_weights: {
      32009: 100,
    },
    county_names_all: "Esmeralda",
    county_fips_all: 32009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89014,
    lat: 36.06153,
    lng: -115.0577,
    city: "Henderson",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41776,
    density: 2110.4,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89015,
    lat: 36.03887,
    lng: -114.9282,
    city: "Henderson",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42315,
    density: 438.2,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89017,
    lat: 37.70485,
    lng: -115.30344,
    city: "Hiko",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20,
    density: 0,
    county_fips: 32017,
    county_name: "Lincoln",
    county_weights: {
      32017: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 32017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89018,
    lat: 36.57063,
    lng: -115.66802,
    city: "Indian Springs",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4694,
    density: 1037.9,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89019,
    lat: 35.76949,
    lng: -115.51606,
    city: "Jean",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2068,
    density: 1.6,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 77.52,
      "06071": 21.56,
      "06027": 0.92,
    },
    county_names_all: "Clark|San Bernardino|Inyo",
    county_fips_all: "32003|06071|06027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89020,
    lat: 36.56232,
    lng: -116.42454,
    city: "Amargosa Valley",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1375,
    density: 2.5,
    county_fips: 32023,
    county_name: "Nye",
    county_weights: {
      32023: 100,
    },
    county_names_all: "Nye",
    county_fips_all: 32023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89021,
    lat: 36.6255,
    lng: -114.47863,
    city: "Logandale",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3136,
    density: 23.5,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89022,
    lat: 38.51839,
    lng: -117.01489,
    city: "Manhattan",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 32023,
    county_name: "Nye",
    county_weights: {
      32023: 100,
    },
    county_names_all: "Nye",
    county_fips_all: 32023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89025,
    lat: 36.71387,
    lng: -114.74777,
    city: "Moapa",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 998,
    density: 1.6,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89026,
    lat: 35.74922,
    lng: -115.28475,
    city: "Jean",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89027,
    lat: 36.81374,
    lng: -114.08857,
    city: "Mesquite",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19087,
    density: 589.9,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89029,
    lat: 35.12561,
    lng: -114.68607,
    city: "Laughlin",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8301,
    density: 34,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89030,
    lat: 36.21235,
    lng: -115.12313,
    city: "North Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50313,
    density: 2050.9,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89031,
    lat: 36.25846,
    lng: -115.17075,
    city: "North Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69016,
    density: 2694.1,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89032,
    lat: 36.22239,
    lng: -115.17358,
    city: "North Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46495,
    density: 1797.8,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89034,
    lat: 36.80924,
    lng: -114.14978,
    city: "Mesquite",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89039,
    lat: 35.26581,
    lng: -114.8725,
    city: "Cal Nev Ari",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 222,
    density: 1.4,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89040,
    lat: 36.35322,
    lng: -114.53541,
    city: "Overton",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3868,
    density: 3,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89042,
    lat: 37.79819,
    lng: -114.35862,
    city: "Panaca",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1146,
    density: 4.1,
    county_fips: 32017,
    county_name: "Lincoln",
    county_weights: {
      32017: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 32017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89043,
    lat: 38.30434,
    lng: -114.39018,
    city: "Pioche",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1493,
    density: 0.4,
    county_fips: 32017,
    county_name: "Lincoln",
    county_weights: {
      32017: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 32017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89044,
    lat: 35.93986,
    lng: -115.05632,
    city: "Henderson",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24386,
    density: 161.3,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89045,
    lat: 38.85618,
    lng: -117.06987,
    city: "Round Mountain",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2073,
    density: 0.5,
    county_fips: 32023,
    county_name: "Nye",
    county_weights: {
      32023: 100,
    },
    county_names_all: "Nye",
    county_fips_all: 32023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89046,
    lat: 35.51207,
    lng: -114.8338,
    city: "Searchlight",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 379,
    density: 0.2,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89047,
    lat: 37.75776,
    lng: -117.6386,
    city: "Silverpeak",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 216,
    density: 84.2,
    county_fips: 32009,
    county_name: "Esmeralda",
    county_weights: {
      32009: 100,
    },
    county_names_all: "Esmeralda",
    county_fips_all: 32009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89048,
    lat: 36.16452,
    lng: -115.98833,
    city: "Pahrump",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22242,
    density: 99.9,
    county_fips: 32023,
    county_name: "Nye",
    county_weights: {
      32023: 100,
    },
    county_names_all: "Nye",
    county_fips_all: 32023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89049,
    lat: 38.37741,
    lng: -116.41205,
    city: "Tonopah",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2449,
    density: 0.4,
    county_fips: 32023,
    county_name: "Nye",
    county_weights: {
      32009: 0.39,
      32023: 99.61,
    },
    county_names_all: "Nye|Esmeralda",
    county_fips_all: "32023|32009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89052,
    lat: 35.97988,
    lng: -115.10788,
    city: "Henderson",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56242,
    density: 1332.5,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89054,
    lat: 35.92093,
    lng: -115.19055,
    city: "Sloan",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52,
    density: 3.4,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89060,
    lat: 36.38854,
    lng: -116.05769,
    city: "Pahrump",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10692,
    density: 9.2,
    county_fips: 32023,
    county_name: "Nye",
    county_weights: {
      32023: 98.13,
      "06027": 1.87,
    },
    county_names_all: "Nye|Inyo",
    county_fips_all: "32023|06027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89061,
    lat: 36.07143,
    lng: -115.89957,
    city: "Pahrump",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5537,
    density: 33.4,
    county_fips: 32023,
    county_name: "Nye",
    county_weights: {
      32023: 95.56,
      "06027": 4.44,
    },
    county_names_all: "Nye|Inyo",
    county_fips_all: "32023|06027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89070,
    lat: 36.50083,
    lng: -115.63952,
    city: "Indian Springs",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89074,
    lat: 36.03639,
    lng: -115.08113,
    city: "Henderson",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51254,
    density: 2181.6,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89081,
    lat: 36.2586,
    lng: -115.10703,
    city: "North Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37599,
    density: 2014.8,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89084,
    lat: 36.29749,
    lng: -115.1569,
    city: "North Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29244,
    density: 767.8,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89085,
    lat: 36.30955,
    lng: -115.19817,
    city: "North Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4073,
    density: 3106.4,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89086,
    lat: 36.28361,
    lng: -115.10997,
    city: "North Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6170,
    density: 796,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89101,
    lat: 36.17279,
    lng: -115.12234,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43536,
    density: 3125,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89102,
    lat: 36.1453,
    lng: -115.18662,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39283,
    density: 2841.8,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89103,
    lat: 36.11236,
    lng: -115.21215,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54406,
    density: 3223.9,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89104,
    lat: 36.15118,
    lng: -115.10932,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40519,
    density: 2730.4,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89106,
    lat: 36.18207,
    lng: -115.16253,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25978,
    density: 1977.7,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89107,
    lat: 36.17049,
    lng: -115.209,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39287,
    density: 2694,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89108,
    lat: 36.20508,
    lng: -115.2237,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75201,
    density: 3259.6,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89109,
    lat: 36.12603,
    lng: -115.16327,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7854,
    density: 735.2,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89110,
    lat: 36.17367,
    lng: -115.05549,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 70865,
    density: 2861.9,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89113,
    lat: 36.06017,
    lng: -115.26236,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34229,
    density: 1226.9,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89115,
    lat: 36.25374,
    lng: -115.04285,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 66378,
    density: 1029.3,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89117,
    lat: 36.14267,
    lng: -115.28001,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56880,
    density: 2389.5,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89118,
    lat: 36.07778,
    lng: -115.21306,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22891,
    density: 834,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89119,
    lat: 36.08452,
    lng: -115.14606,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52120,
    density: 1559.6,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89120,
    lat: 36.08065,
    lng: -115.09585,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24102,
    density: 1318.9,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89121,
    lat: 36.12141,
    lng: -115.09135,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 66344,
    density: 2790.3,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89122,
    lat: 36.10399,
    lng: -115.03783,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51072,
    density: 2070,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89123,
    lat: 36.0352,
    lng: -115.14908,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62982,
    density: 2347.7,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89124,
    lat: 36.34074,
    lng: -115.60096,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1412,
    density: 0.6,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89128,
    lat: 36.19678,
    lng: -115.26439,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37159,
    density: 2396.4,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89129,
    lat: 36.23325,
    lng: -115.29025,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56770,
    density: 2195.8,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89130,
    lat: 36.25348,
    lng: -115.22671,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35263,
    density: 1767.1,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89131,
    lat: 36.3064,
    lng: -115.24256,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51862,
    density: 1238.9,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89134,
    lat: 36.20262,
    lng: -115.3078,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24280,
    density: 1404.7,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89135,
    lat: 36.09531,
    lng: -115.37163,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29104,
    density: 221.7,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89138,
    lat: 36.20212,
    lng: -115.36499,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18954,
    density: 402.2,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89139,
    lat: 36.03429,
    lng: -115.21117,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42030,
    density: 1512.2,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89141,
    lat: 35.98813,
    lng: -115.2074,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36188,
    density: 1328.2,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89142,
    lat: 36.14812,
    lng: -115.031,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32813,
    density: 2114,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89143,
    lat: 36.32168,
    lng: -115.29288,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13168,
    density: 1449.6,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89144,
    lat: 36.17746,
    lng: -115.31943,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20126,
    density: 1742.9,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89145,
    lat: 36.16748,
    lng: -115.27618,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25982,
    density: 2364.7,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89146,
    lat: 36.14323,
    lng: -115.22679,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18969,
    density: 1525.4,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89147,
    lat: 36.11289,
    lng: -115.27985,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56784,
    density: 2980.8,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89148,
    lat: 36.06337,
    lng: -115.29676,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57952,
    density: 2302.7,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89149,
    lat: 36.2708,
    lng: -115.29462,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42495,
    density: 1259.4,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89156,
    lat: 36.15906,
    lng: -114.98176,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30394,
    density: 262.8,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89158,
    lat: 36.10481,
    lng: -115.17665,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89161,
    lat: 36.03552,
    lng: -115.48284,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 165,
    density: 0.4,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89166,
    lat: 36.33733,
    lng: -115.4686,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25877,
    density: 57.1,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89169,
    lat: 36.12405,
    lng: -115.14184,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21350,
    density: 2390.6,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89178,
    lat: 35.98783,
    lng: -115.29541,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42301,
    density: 723.2,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89179,
    lat: 35.8916,
    lng: -115.32794,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7807,
    density: 25.8,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89183,
    lat: 35.99619,
    lng: -115.15799,
    city: "Las Vegas",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41974,
    density: 2314.5,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89191,
    lat: 36.2473,
    lng: -115.00407,
    city: "Nellis Afb",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 487,
    density: 20.4,
    county_fips: 32003,
    county_name: "Clark",
    county_weights: {
      32003: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 32003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89301,
    lat: 39.52872,
    lng: -114.76615,
    city: "Ely",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7962,
    density: 1.4,
    county_fips: 32033,
    county_name: "White Pine",
    county_weights: {
      32033: 100,
    },
    county_names_all: "White Pine",
    county_fips_all: 32033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89310,
    lat: 39.47836,
    lng: -117.13758,
    city: "Austin",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 225,
    density: 0,
    county_fips: 32015,
    county_name: "Lander",
    county_weights: {
      32015: 94.43,
      32023: 5.57,
    },
    county_names_all: "Lander|Nye",
    county_fips_all: "32015|32023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89311,
    lat: 39.16715,
    lng: -114.19288,
    city: "Baker",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 206,
    density: 0.1,
    county_fips: 32033,
    county_name: "White Pine",
    county_weights: {
      32033: 100,
    },
    county_names_all: "White Pine",
    county_fips_all: 32033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89314,
    lat: 38.86222,
    lng: -115.64186,
    city: "Duckwater",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 251,
    density: 3.1,
    county_fips: 32023,
    county_name: "Nye",
    county_weights: {
      32023: 100,
    },
    county_names_all: "Nye",
    county_fips_all: 32023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89315,
    lat: 39.1855,
    lng: -114.84489,
    city: "Ely",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 32033,
    county_name: "White Pine",
    county_weights: {
      32033: 100,
    },
    county_names_all: "White Pine",
    county_fips_all: 32033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89316,
    lat: 39.67956,
    lng: -116.01497,
    city: "Eureka",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1228,
    density: 0.3,
    county_fips: 32011,
    county_name: "Eureka",
    county_weights: {
      32011: 76.38,
      32033: 23.62,
    },
    county_names_all: "Eureka|White Pine",
    county_fips_all: "32011|32033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89317,
    lat: 38.87915,
    lng: -115.08418,
    city: "Lund",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 256,
    density: 1.6,
    county_fips: 32033,
    county_name: "White Pine",
    county_weights: {
      32033: 100,
    },
    county_names_all: "White Pine",
    county_fips_all: 32033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89318,
    lat: 39.43783,
    lng: -114.8188,
    city: "McGill",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 858,
    density: 9.1,
    county_fips: 32033,
    county_name: "White Pine",
    county_weights: {
      32033: 100,
    },
    county_names_all: "White Pine",
    county_fips_all: 32033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89319,
    lat: 39.27915,
    lng: -114.98724,
    city: "Ruth",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 235,
    density: 246.3,
    county_fips: 32033,
    county_name: "White Pine",
    county_weights: {
      32033: 100,
    },
    county_names_all: "White Pine",
    county_fips_all: 32033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89402,
    lat: 39.23075,
    lng: -120.00259,
    city: "Crystal Bay",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17,
    density: 24.7,
    county_fips: 32031,
    county_name: "Washoe",
    county_weights: {
      32031: 100,
    },
    county_names_all: "Washoe",
    county_fips_all: 32031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89403,
    lat: 39.25838,
    lng: -119.48633,
    city: "Dayton",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15885,
    density: 37.9,
    county_fips: 32019,
    county_name: "Lyon",
    county_weights: {
      32019: 80.41,
      32029: 19.59,
    },
    county_names_all: "Lyon|Storey",
    county_fips_all: "32019|32029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89404,
    lat: 41.80704,
    lng: -118.88807,
    city: "Denio",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 32013,
    county_name: "Humboldt",
    county_weights: {
      32013: 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: 32013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89405,
    lat: 40.45057,
    lng: -119.46926,
    city: "Empire",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 103,
    density: 0.1,
    county_fips: 32031,
    county_name: "Washoe",
    county_weights: {
      32031: 100,
    },
    county_names_all: "Washoe",
    county_fips_all: 32031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89406,
    lat: 39.46614,
    lng: -118.27364,
    city: "Fallon",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24475,
    density: 4.7,
    county_fips: 32001,
    county_name: "Churchill",
    county_weights: {
      32001: 98.65,
      32019: 1.35,
    },
    county_names_all: "Churchill|Lyon",
    county_fips_all: "32001|32019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89408,
    lat: 39.71675,
    lng: -119.02706,
    city: "Fernley",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20982,
    density: 17.5,
    county_fips: 32001,
    county_name: "Churchill",
    county_weights: {
      32001: 77.66,
      32019: 22.34,
    },
    county_names_all: "Churchill|Lyon",
    county_fips_all: "32001|32019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89409,
    lat: 38.83828,
    lng: -117.98088,
    city: "Gabbs",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 78,
    density: 0.2,
    county_fips: 32023,
    county_name: "Nye",
    county_weights: {
      32021: 31.91,
      32023: 68.09,
    },
    county_names_all: "Nye|Mineral",
    county_fips_all: "32023|32021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89410,
    lat: 38.78368,
    lng: -119.54802,
    city: "Gardnerville",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10992,
    density: 18.4,
    county_fips: 32005,
    county_name: "Douglas",
    county_weights: {
      32005: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 32005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89411,
    lat: 39.01837,
    lng: -119.85301,
    city: "Genoa",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 776,
    density: 14,
    county_fips: 32005,
    county_name: "Douglas",
    county_weights: {
      32005: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 32005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89412,
    lat: 41.13904,
    lng: -119.69501,
    city: "Gerlach",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75,
    density: 0,
    county_fips: 32031,
    county_name: "Washoe",
    county_weights: {
      32013: 8.22,
      32031: 91.78,
    },
    county_names_all: "Washoe|Humboldt",
    county_fips_all: "32031|32013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89413,
    lat: 39.07389,
    lng: -119.92095,
    city: "Glenbrook",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 723,
    density: 17.7,
    county_fips: 32005,
    county_name: "Douglas",
    county_weights: {
      32005: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 32005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89414,
    lat: 41.04934,
    lng: -117.22765,
    city: "Golconda",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 90,
    density: 0.1,
    county_fips: 32013,
    county_name: "Humboldt",
    county_weights: {
      32007: 26.23,
      32013: 73.77,
    },
    county_names_all: "Humboldt|Elko",
    county_fips_all: "32013|32007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89415,
    lat: 38.50993,
    lng: -118.77958,
    city: "Hawthorne",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3101,
    density: 3.2,
    county_fips: 32021,
    county_name: "Mineral",
    county_weights: {
      32021: 100,
    },
    county_names_all: "Mineral",
    county_fips_all: 32021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89418,
    lat: 40.5669,
    lng: -118.03851,
    city: "Imlay",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 244,
    density: 0.4,
    county_fips: 32027,
    county_name: "Pershing",
    county_weights: {
      32027: 100,
    },
    county_names_all: "Pershing",
    county_fips_all: 32027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89419,
    lat: 40.34309,
    lng: -118.29831,
    city: "Lovelock",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5380,
    density: 5,
    county_fips: 32027,
    county_name: "Pershing",
    county_weights: {
      32027: 100,
    },
    county_names_all: "Pershing",
    county_fips_all: 32027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89420,
    lat: 38.50802,
    lng: -118.18051,
    city: "Luning",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 77,
    density: 9.9,
    county_fips: 32021,
    county_name: "Mineral",
    county_weights: {
      32021: 100,
    },
    county_names_all: "Mineral",
    county_fips_all: 32021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89421,
    lat: 42.04485,
    lng: -117.94724,
    city: "McDermitt",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 423,
    density: 0.2,
    county_fips: 41045,
    county_name: "Malheur",
    county_weights: {
      32013: 38.78,
      41045: 61.22,
    },
    county_names_all: "Malheur|Humboldt",
    county_fips_all: "41045|32013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89422,
    lat: 38.42008,
    lng: -118.17911,
    city: "Mina",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 177,
    density: 0.3,
    county_fips: 32021,
    county_name: "Mineral",
    county_weights: {
      32021: 100,
    },
    county_names_all: "Mineral",
    county_fips_all: 32021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89423,
    lat: 39.01561,
    lng: -119.74636,
    city: "Minden",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10636,
    density: 54.9,
    county_fips: 32005,
    county_name: "Douglas",
    county_weights: {
      32005: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 32005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89424,
    lat: 40.10964,
    lng: -119.49396,
    city: "Nixon",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 241,
    density: 0.2,
    county_fips: 32031,
    county_name: "Washoe",
    county_weights: {
      32031: 100,
    },
    county_names_all: "Washoe",
    county_fips_all: 32031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89425,
    lat: 41.65695,
    lng: -117.88461,
    city: "Orovada",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 529,
    density: 0.3,
    county_fips: 32013,
    county_name: "Humboldt",
    county_weights: {
      32013: 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: 32013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89426,
    lat: 41.45402,
    lng: -117.59307,
    city: "Paradise Valley",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 268,
    density: 0.6,
    county_fips: 32013,
    county_name: "Humboldt",
    county_weights: {
      32013: 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: 32013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89427,
    lat: 38.94556,
    lng: -118.70553,
    city: "Schurz",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1115,
    density: 1.4,
    county_fips: 32021,
    county_name: "Mineral",
    county_weights: {
      32021: 100,
    },
    county_names_all: "Mineral",
    county_fips_all: 32021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89428,
    lat: 39.25691,
    lng: -119.63099,
    city: "Silver City",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 115,
    density: 28.9,
    county_fips: 32019,
    county_name: "Lyon",
    county_weights: {
      32019: 100,
    },
    county_names_all: "Lyon",
    county_fips_all: 32019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89429,
    lat: 39.36221,
    lng: -119.29063,
    city: "Silver Springs",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7720,
    density: 12.6,
    county_fips: 32019,
    county_name: "Lyon",
    county_weights: {
      32019: 100,
    },
    county_names_all: "Lyon",
    county_fips_all: 32019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89430,
    lat: 38.79567,
    lng: -119.31785,
    city: "Smith",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 118,
    density: 1.4,
    county_fips: 32019,
    county_name: "Lyon",
    county_weights: {
      32019: 100,
    },
    county_names_all: "Lyon",
    county_fips_all: 32019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89431,
    lat: 39.53865,
    lng: -119.75005,
    city: "Sparks",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39415,
    density: 1649.6,
    county_fips: 32031,
    county_name: "Washoe",
    county_weights: {
      32031: 100,
    },
    county_names_all: "Washoe",
    county_fips_all: 32031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89433,
    lat: 39.59758,
    lng: -119.77817,
    city: "Sun Valley",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21771,
    density: 754.4,
    county_fips: 32031,
    county_name: "Washoe",
    county_weights: {
      32031: 100,
    },
    county_names_all: "Washoe",
    county_fips_all: 32031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89434,
    lat: 39.54019,
    lng: -119.53318,
    city: "Sparks",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26564,
    density: 81.8,
    county_fips: 32029,
    county_name: "Storey",
    county_weights: {
      32029: 69.16,
      32031: 30.84,
    },
    county_names_all: "Storey|Washoe",
    county_fips_all: "32029|32031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89436,
    lat: 39.61086,
    lng: -119.69854,
    city: "Sparks",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44454,
    density: 403.9,
    county_fips: 32031,
    county_name: "Washoe",
    county_weights: {
      32031: 100,
    },
    county_names_all: "Washoe",
    county_fips_all: 32031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89437,
    lat: 39.50101,
    lng: -119.46864,
    city: "Sparks",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 32029,
    county_name: "Storey",
    county_weights: {
      32029: 100,
    },
    county_names_all: "Storey",
    county_fips_all: 32029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89438,
    lat: 40.79671,
    lng: -117.12004,
    city: "Valmy",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 85,
    density: 13.3,
    county_fips: 32013,
    county_name: "Humboldt",
    county_weights: {
      32013: 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: 32013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89439,
    lat: 39.52291,
    lng: -119.99008,
    city: "Verdi",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1244,
    density: 29.5,
    county_fips: 32031,
    county_name: "Washoe",
    county_weights: {
      32031: 74.74,
      "06091": 25.26,
    },
    county_names_all: "Washoe|Sierra",
    county_fips_all: "32031|06091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89440,
    lat: 39.29597,
    lng: -119.66212,
    city: "Virginia City",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 747,
    density: 23.1,
    county_fips: 32029,
    county_name: "Storey",
    county_weights: {
      32029: 100,
    },
    county_names_all: "Storey",
    county_fips_all: 32029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89441,
    lat: 39.68131,
    lng: -119.68755,
    city: "Sparks",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12479,
    density: 97,
    county_fips: 32031,
    county_name: "Washoe",
    county_weights: {
      32031: 100,
    },
    county_names_all: "Washoe",
    county_fips_all: 32031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89442,
    lat: 39.69511,
    lng: -119.35082,
    city: "Wadsworth",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1048,
    density: 1.9,
    county_fips: 32031,
    county_name: "Washoe",
    county_weights: {
      32031: 100,
    },
    county_names_all: "Washoe",
    county_fips_all: 32031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89444,
    lat: 38.72695,
    lng: -119.35101,
    city: "Wellington",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3219,
    density: 5.9,
    county_fips: 32019,
    county_name: "Lyon",
    county_weights: {
      32005: 20.92,
      32019: 79.08,
    },
    county_names_all: "Lyon|Douglas",
    county_fips_all: "32019|32005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89445,
    lat: 41.06767,
    lng: -118.02515,
    city: "Winnemucca",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16424,
    density: 2.3,
    county_fips: 32013,
    county_name: "Humboldt",
    county_weights: {
      32013: 73.98,
      32027: 26.02,
    },
    county_names_all: "Humboldt|Pershing",
    county_fips_all: "32013|32027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89446,
    lat: 40.87879,
    lng: -117.9532,
    city: "Winnemucca",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 32013,
    county_name: "Humboldt",
    county_weights: {
      32013: 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: 32013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89447,
    lat: 38.83148,
    lng: -119.11712,
    city: "Yerington",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8261,
    density: 3.7,
    county_fips: 32019,
    county_name: "Lyon",
    county_weights: {
      32019: 100,
    },
    county_names_all: "Lyon",
    county_fips_all: 32019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89448,
    lat: 39.00789,
    lng: -119.92412,
    city: "Zephyr Cove",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1776,
    density: 55.8,
    county_fips: 32005,
    county_name: "Douglas",
    county_weights: {
      32005: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 32005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89449,
    lat: 38.96433,
    lng: -119.90688,
    city: "Stateline",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2973,
    density: 114.4,
    county_fips: 32005,
    county_name: "Douglas",
    county_weights: {
      32005: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 32005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89450,
    lat: 39.24135,
    lng: -119.93832,
    city: "Incline Village",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18,
    density: 672.7,
    county_fips: 32031,
    county_name: "Washoe",
    county_weights: {
      32031: 100,
    },
    county_names_all: "Washoe",
    county_fips_all: 32031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89451,
    lat: 39.26775,
    lng: -119.94534,
    city: "Incline Village",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9304,
    density: 85.1,
    county_fips: 32031,
    county_name: "Washoe",
    county_weights: {
      32031: 100,
    },
    county_names_all: "Washoe",
    county_fips_all: 32031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89460,
    lat: 38.90136,
    lng: -119.79085,
    city: "Gardnerville",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13727,
    density: 96,
    county_fips: 32005,
    county_name: "Douglas",
    county_weights: {
      32005: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 32005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89496,
    lat: 39.19949,
    lng: -118.57103,
    city: "Fallon",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 32001,
    county_name: "Churchill",
    county_weights: {
      32001: 100,
    },
    county_names_all: "Churchill",
    county_fips_all: 32001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89501,
    lat: 39.52602,
    lng: -119.81262,
    city: "Reno",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4435,
    density: 2930.3,
    county_fips: 32031,
    county_name: "Washoe",
    county_weights: {
      32031: 100,
    },
    county_names_all: "Washoe",
    county_fips_all: 32031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89502,
    lat: 39.49383,
    lng: -119.74701,
    city: "Reno",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44881,
    density: 807.5,
    county_fips: 32031,
    county_name: "Washoe",
    county_weights: {
      32031: 100,
    },
    county_names_all: "Washoe",
    county_fips_all: 32031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89503,
    lat: 39.54112,
    lng: -119.83991,
    city: "Reno",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29993,
    density: 1875.4,
    county_fips: 32031,
    county_name: "Washoe",
    county_weights: {
      32031: 100,
    },
    county_names_all: "Washoe",
    county_fips_all: 32031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89506,
    lat: 39.70084,
    lng: -119.82646,
    city: "Reno",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42742,
    density: 181.1,
    county_fips: 32031,
    county_name: "Washoe",
    county_weights: {
      32031: 100,
    },
    county_names_all: "Washoe",
    county_fips_all: 32031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89508,
    lat: 39.78504,
    lng: -119.92728,
    city: "Reno",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14198,
    density: 36.5,
    county_fips: 32031,
    county_name: "Washoe",
    county_weights: {
      32031: 100,
    },
    county_names_all: "Washoe",
    county_fips_all: 32031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89509,
    lat: 39.49637,
    lng: -119.8273,
    city: "Reno",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35558,
    density: 1556,
    county_fips: 32031,
    county_name: "Washoe",
    county_weights: {
      32031: 100,
    },
    county_names_all: "Washoe",
    county_fips_all: 32031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89510,
    lat: 39.93619,
    lng: -119.73734,
    city: "Reno",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1671,
    density: 1.1,
    county_fips: 32031,
    county_name: "Washoe",
    county_weights: {
      32031: 100,
    },
    county_names_all: "Washoe",
    county_fips_all: 32031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89511,
    lat: 39.40747,
    lng: -119.88822,
    city: "Reno",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27874,
    density: 81.8,
    county_fips: 32031,
    county_name: "Washoe",
    county_weights: {
      32031: 100,
    },
    county_names_all: "Washoe",
    county_fips_all: 32031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89512,
    lat: 39.55322,
    lng: -119.80074,
    city: "Reno",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26690,
    density: 1661,
    county_fips: 32031,
    county_name: "Washoe",
    county_weights: {
      32031: 100,
    },
    county_names_all: "Washoe",
    county_fips_all: 32031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89519,
    lat: 39.48518,
    lng: -119.86003,
    city: "Reno",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8602,
    density: 511.2,
    county_fips: 32031,
    county_name: "Washoe",
    county_weights: {
      32031: 100,
    },
    county_names_all: "Washoe",
    county_fips_all: 32031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89521,
    lat: 39.37215,
    lng: -119.67611,
    city: "Reno",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34101,
    density: 141.6,
    county_fips: 32031,
    county_name: "Washoe",
    county_weights: {
      32029: 42.84,
      32031: 57.16,
    },
    county_names_all: "Washoe|Storey",
    county_fips_all: "32031|32029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89523,
    lat: 39.52387,
    lng: -119.91309,
    city: "Reno",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35065,
    density: 716.9,
    county_fips: 32031,
    county_name: "Washoe",
    county_weights: {
      32031: 100,
    },
    county_names_all: "Washoe",
    county_fips_all: 32031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89557,
    lat: 39.54247,
    lng: -119.81584,
    city: "Reno",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 32031,
    county_name: "Washoe",
    county_weights: {
      32031: 100,
    },
    county_names_all: "Washoe",
    county_fips_all: 32031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89701,
    lat: 39.13944,
    lng: -119.72087,
    city: "Carson City",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27328,
    density: 303,
    county_fips: 32510,
    county_name: "Carson City",
    county_weights: {
      32510: 100,
    },
    county_names_all: "Carson City",
    county_fips_all: 32510,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89703,
    lat: 39.15359,
    lng: -119.8486,
    city: "Carson City",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10062,
    density: 87.8,
    county_fips: 32510,
    county_name: "Carson City",
    county_weights: {
      32031: 1.67,
      32510: 98.33,
    },
    county_names_all: "Carson City|Washoe",
    county_fips_all: "32510|32031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89704,
    lat: 39.26789,
    lng: -119.81712,
    city: "Washoe Valley",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4411,
    density: 22.3,
    county_fips: 32031,
    county_name: "Washoe",
    county_weights: {
      32031: 100,
    },
    county_names_all: "Washoe",
    county_fips_all: 32031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89705,
    lat: 39.09003,
    lng: -119.83689,
    city: "Carson City",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5315,
    density: 88.4,
    county_fips: 32005,
    county_name: "Douglas",
    county_weights: {
      32005: 95.93,
      32510: 4.07,
    },
    county_names_all: "Douglas|Carson City",
    county_fips_all: "32005|32510",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89706,
    lat: 39.22002,
    lng: -119.69974,
    city: "Carson City",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19447,
    density: 217.6,
    county_fips: 32510,
    county_name: "Carson City",
    county_weights: {
      32019: 47.36,
      32510: 52.64,
    },
    county_names_all: "Carson City|Lyon",
    county_fips_all: "32510|32019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89801,
    lat: 41.18096,
    lng: -115.76076,
    city: "Elko",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26473,
    density: 8.4,
    county_fips: 32007,
    county_name: "Elko",
    county_weights: {
      32007: 100,
    },
    county_names_all: "Elko",
    county_fips_all: 32007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89815,
    lat: 40.56652,
    lng: -115.59504,
    city: "Spring Creek",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15292,
    density: 8.4,
    county_fips: 32007,
    county_name: "Elko",
    county_weights: {
      32007: 100,
    },
    county_names_all: "Elko",
    county_fips_all: 32007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89820,
    lat: 40.43192,
    lng: -116.97134,
    city: "Battle Mountain",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5403,
    density: 1,
    county_fips: 32015,
    county_name: "Lander",
    county_weights: {
      32011: 2.05,
      32015: 97.95,
    },
    county_names_all: "Lander|Eureka",
    county_fips_all: "32015|32011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89821,
    lat: 40.55585,
    lng: -116.41218,
    city: "Crescent Valley",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 483,
    density: 0.4,
    county_fips: 32011,
    county_name: "Eureka",
    county_weights: {
      32011: 100,
    },
    county_names_all: "Eureka",
    county_fips_all: 32011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89822,
    lat: 40.49237,
    lng: -116.189,
    city: "Carlin",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2013,
    density: 3.2,
    county_fips: 32011,
    county_name: "Eureka",
    county_weights: {
      32007: 6.88,
      32011: 93.12,
    },
    county_names_all: "Eureka|Elko",
    county_fips_all: "32011|32007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89823,
    lat: 40.96431,
    lng: -115.22821,
    city: "Deeth",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 363,
    density: 0.6,
    county_fips: 32007,
    county_name: "Elko",
    county_weights: {
      32007: 100,
    },
    county_names_all: "Elko",
    county_fips_all: 32007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89825,
    lat: 41.90422,
    lng: -114.71103,
    city: "Jackpot",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1101,
    density: 6.7,
    county_fips: 32007,
    county_name: "Elko",
    county_weights: {
      32007: 100,
    },
    county_names_all: "Elko",
    county_fips_all: 32007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89826,
    lat: 41.93262,
    lng: -115.41386,
    city: "Jarbidge",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 32007,
    county_name: "Elko",
    county_weights: {
      32007: 100,
    },
    county_names_all: "Elko",
    county_fips_all: 32007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89828,
    lat: 40.77384,
    lng: -115.36403,
    city: "Lamoille",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 175,
    density: 0.4,
    county_fips: 32007,
    county_name: "Elko",
    county_weights: {
      32007: 100,
    },
    county_names_all: "Elko",
    county_fips_all: 32007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89830,
    lat: 41.32794,
    lng: -114.22677,
    city: "Montello",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 99,
    density: 0.2,
    county_fips: 32007,
    county_name: "Elko",
    county_weights: {
      32007: 100,
    },
    county_names_all: "Elko",
    county_fips_all: 32007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89831,
    lat: 41.75992,
    lng: -116.03935,
    city: "Mountain City",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11,
    density: 0,
    county_fips: 32007,
    county_name: "Elko",
    county_weights: {
      32007: 100,
    },
    county_names_all: "Elko",
    county_fips_all: 32007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89832,
    lat: 41.98001,
    lng: -116.19537,
    city: "Owyhee",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1079,
    density: 2.4,
    county_fips: 32007,
    county_name: "Elko",
    county_weights: {
      16073: 33.08,
      32007: 66.92,
    },
    county_names_all: "Elko|Owyhee",
    county_fips_all: "32007|16073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89833,
    lat: 40.4692,
    lng: -115.34201,
    city: "Ruby Valley",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 143,
    density: 0.1,
    county_fips: 32007,
    county_name: "Elko",
    county_weights: {
      32007: 100,
    },
    county_names_all: "Elko",
    county_fips_all: 32007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89834,
    lat: 41.42358,
    lng: -116.24843,
    city: "Tuscarora",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 166,
    density: 0.1,
    county_fips: 32007,
    county_name: "Elko",
    county_weights: {
      32007: 100,
    },
    county_names_all: "Elko",
    county_fips_all: 32007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89835,
    lat: 41.2848,
    lng: -114.87765,
    city: "Wells",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1544,
    density: 0.3,
    county_fips: 32007,
    county_name: "Elko",
    county_weights: {
      32007: 100,
    },
    county_names_all: "Elko",
    county_fips_all: 32007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 89883,
    lat: 40.84711,
    lng: -114.18217,
    city: "West Wendover",
    state_id: "NV",
    state_name: "Nevada",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4373,
    density: 5.8,
    county_fips: 32007,
    county_name: "Elko",
    county_weights: {
      32007: 100,
    },
    county_names_all: "Elko",
    county_fips_all: 32007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90001,
    lat: 33.97365,
    lng: -118.24904,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58974,
    density: 6941.9,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90002,
    lat: 33.94906,
    lng: -118.24679,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53402,
    density: 6890,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90003,
    lat: 33.96409,
    lng: -118.27368,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74117,
    density: 7893.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90004,
    lat: 34.07624,
    lng: -118.31101,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61105,
    density: 7733.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90005,
    lat: 34.05939,
    lng: -118.30909,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38885,
    density: 12725.2,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90006,
    lat: 34.04807,
    lng: -118.29411,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58560,
    density: 11692.7,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90007,
    lat: 34.02819,
    lng: -118.28486,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42380,
    density: 6733.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90008,
    lat: 34.01037,
    lng: -118.3428,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31900,
    density: 4256.9,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90010,
    lat: 34.06209,
    lng: -118.31262,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4108,
    density: 4062,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90011,
    lat: 34.00689,
    lng: -118.25861,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 110750,
    density: 9969.9,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90012,
    lat: 34.06679,
    lng: -118.23878,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37268,
    density: 3955.3,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90013,
    lat: 34.04435,
    lng: -118.24,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13009,
    density: 7121.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90014,
    lat: 34.04302,
    lng: -118.25182,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9126,
    density: 11769.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90015,
    lat: 34.03932,
    lng: -118.26625,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23900,
    density: 5449.7,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90016,
    lat: 34.02881,
    lng: -118.35436,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46340,
    density: 4974.1,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90017,
    lat: 34.05306,
    lng: -118.26447,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27832,
    density: 15199.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90018,
    lat: 34.0286,
    lng: -118.31737,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52444,
    density: 6747.9,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90019,
    lat: 34.04861,
    lng: -118.33874,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62816,
    density: 6266,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90020,
    lat: 34.06638,
    lng: -118.30986,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39366,
    density: 13669.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90021,
    lat: 34.02909,
    lng: -118.23889,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3285,
    density: 641.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90022,
    lat: 34.02455,
    lng: -118.15608,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 66168,
    density: 5776.9,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90023,
    lat: 34.02264,
    lng: -118.19986,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46517,
    density: 4160,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90024,
    lat: 34.06565,
    lng: -118.43521,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52069,
    density: 6760.2,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90025,
    lat: 34.04551,
    lng: -118.44583,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47438,
    density: 7180.2,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90026,
    lat: 34.07883,
    lng: -118.2637,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67657,
    density: 6482.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90027,
    lat: 34.12515,
    lng: -118.29049,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45996,
    density: 2185.8,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90028,
    lat: 34.09982,
    lng: -118.3268,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31385,
    density: 8021.9,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90029,
    lat: 34.08983,
    lng: -118.29467,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36126,
    density: 10136,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90031,
    lat: 34.08122,
    lng: -118.21081,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39497,
    density: 4357.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90032,
    lat: 34.0793,
    lng: -118.17835,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47857,
    density: 3837.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90033,
    lat: 34.05117,
    lng: -118.21165,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49695,
    density: 5856.8,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90034,
    lat: 34.03059,
    lng: -118.39936,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56416,
    density: 7023.9,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90035,
    lat: 34.05139,
    lng: -118.38577,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27725,
    density: 4703.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90036,
    lat: 34.07013,
    lng: -118.34978,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38111,
    density: 5992,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90037,
    lat: 34.00271,
    lng: -118.28747,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67377,
    density: 9009,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90038,
    lat: 34.08882,
    lng: -118.32671,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28592,
    density: 7131.9,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90039,
    lat: 34.11242,
    lng: -118.26153,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29966,
    density: 3178.8,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90040,
    lat: 33.99318,
    lng: -118.1489,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12363,
    density: 857.3,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90041,
    lat: 34.13749,
    lng: -118.20746,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29888,
    density: 3210.9,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90042,
    lat: 34.11475,
    lng: -118.192,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60509,
    density: 5169.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90043,
    lat: 33.98876,
    lng: -118.33519,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46358,
    density: 4363.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90044,
    lat: 33.95253,
    lng: -118.29194,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 99980,
    density: 7565.9,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90045,
    lat: 33.95302,
    lng: -118.40028,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39795,
    density: 1428.1,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90046,
    lat: 34.10752,
    lng: -118.36575,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49828,
    density: 3395.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90047,
    lat: 33.95456,
    lng: -118.30899,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51057,
    density: 4188.3,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90048,
    lat: 34.07293,
    lng: -118.3727,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21766,
    density: 4437.8,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90049,
    lat: 34.08749,
    lng: -118.48976,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36610,
    density: 944.1,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90052,
    lat: 33.9783,
    lng: -118.25891,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90056,
    lat: 33.99361,
    lng: -118.36884,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8058,
    density: 1378.1,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90057,
    lat: 34.06205,
    lng: -118.27704,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49771,
    density: 21837.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90058,
    lat: 34.00264,
    lng: -118.21452,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3003,
    density: 200.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90059,
    lat: 33.92709,
    lng: -118.2491,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42311,
    density: 5167,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90061,
    lat: 33.92037,
    lng: -118.27383,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28755,
    density: 4091.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90062,
    lat: 34.0035,
    lng: -118.30904,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35908,
    density: 7265.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90063,
    lat: 34.0452,
    lng: -118.18583,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53846,
    density: 6329.1,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90064,
    lat: 34.0358,
    lng: -118.42653,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25988,
    density: 2694.1,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90065,
    lat: 34.10867,
    lng: -118.22813,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47389,
    density: 3332.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90066,
    lat: 34.00166,
    lng: -118.43104,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58851,
    density: 4725.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90067,
    lat: 34.0565,
    lng: -118.41373,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2560,
    density: 2297.8,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90068,
    lat: 34.12794,
    lng: -118.32914,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21590,
    density: 1041.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90069,
    lat: 34.09401,
    lng: -118.38154,
    city: "West Hollywood",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20035,
    density: 3594.9,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90071,
    lat: 34.05239,
    lng: -118.25518,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 152,
    density: 435.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90073,
    lat: 34.05738,
    lng: -118.45956,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 962,
    density: 692.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90077,
    lat: 34.10536,
    lng: -118.45591,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8328,
    density: 442.8,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90079,
    lat: 34.04058,
    lng: -118.25541,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90089,
    lat: 34.02158,
    lng: -118.2856,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3740,
    density: 4429.1,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90094,
    lat: 33.97523,
    lng: -118.41837,
    city: "Playa Vista",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9065,
    density: 4898.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90095,
    lat: 34.07121,
    lng: -118.44334,
    city: "Los Angeles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90201,
    lat: 33.97113,
    lng: -118.1709,
    city: "Bell Gardens",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 100512,
    density: 6481,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90210,
    lat: 34.10251,
    lng: -118.41505,
    city: "Beverly Hills",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19229,
    density: 691.1,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90211,
    lat: 34.06498,
    lng: -118.38293,
    city: "Beverly Hills",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9211,
    density: 5079.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90212,
    lat: 34.06208,
    lng: -118.40173,
    city: "Beverly Hills",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11878,
    density: 4844.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90220,
    lat: 33.88058,
    lng: -118.23591,
    city: "Compton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51042,
    density: 2848.9,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90221,
    lat: 33.88542,
    lng: -118.20614,
    city: "Compton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50928,
    density: 3653.7,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90222,
    lat: 33.91213,
    lng: -118.23721,
    city: "Compton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34547,
    density: 4928.3,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90230,
    lat: 33.99691,
    lng: -118.39487,
    city: "Culver City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33135,
    density: 2818,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90232,
    lat: 34.01859,
    lng: -118.39157,
    city: "Culver City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14921,
    density: 2664,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90240,
    lat: 33.9564,
    lng: -118.11803,
    city: "Downey",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26801,
    density: 3438.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90241,
    lat: 33.94076,
    lng: -118.1295,
    city: "Downey",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42759,
    density: 3385.8,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90242,
    lat: 33.92216,
    lng: -118.14167,
    city: "Downey",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41703,
    density: 3565.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90245,
    lat: 33.91709,
    lng: -118.40161,
    city: "El Segundo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16575,
    density: 1196.7,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90247,
    lat: 33.89159,
    lng: -118.29735,
    city: "Gardena",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47507,
    density: 4882.9,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90248,
    lat: 33.87689,
    lng: -118.28362,
    city: "Gardena",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11425,
    density: 928.2,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90249,
    lat: 33.90152,
    lng: -118.31707,
    city: "Gardena",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26192,
    density: 3403.1,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90250,
    lat: 33.91383,
    lng: -118.34996,
    city: "Hawthorne",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 95115,
    density: 5426.1,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90254,
    lat: 33.86532,
    lng: -118.39616,
    city: "Hermosa Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19147,
    density: 5171.8,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90255,
    lat: 33.97697,
    lng: -118.21725,
    city: "Huntington Park",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74390,
    density: 7707.8,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90260,
    lat: 33.88768,
    lng: -118.34952,
    city: "Lawndale",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34540,
    density: 5398.2,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90262,
    lat: 33.92384,
    lng: -118.20133,
    city: "Lynwood",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69369,
    density: 5612.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90263,
    lat: 34.03919,
    lng: -118.70809,
    city: "Malibu",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1813,
    density: 2993.3,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90265,
    lat: 34.07282,
    lng: -118.84995,
    city: "Malibu",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18028,
    density: 62.7,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 68.4,
      "06111": 31.6,
    },
    county_names_all: "Los Angeles|Ventura",
    county_fips_all: "06037|06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90266,
    lat: 33.88968,
    lng: -118.39705,
    city: "Manhattan Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35064,
    density: 3344.2,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90270,
    lat: 33.98856,
    lng: -118.18774,
    city: "Maywood",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27127,
    density: 8807.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90272,
    lat: 34.08066,
    lng: -118.54459,
    city: "Pacific Palisades",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21848,
    density: 354.3,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90274,
    lat: 33.77732,
    lng: -118.3684,
    city: "Palos Verdes Peninsula",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24541,
    density: 791.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90275,
    lat: 33.7555,
    lng: -118.36338,
    city: "Rancho Palos Verdes",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41731,
    density: 1190.7,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90277,
    lat: 33.83099,
    lng: -118.38441,
    city: "Redondo Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34494,
    density: 3721,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90278,
    lat: 33.87362,
    lng: -118.37028,
    city: "Redondo Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40090,
    density: 4216.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90280,
    lat: 33.94453,
    lng: -118.19256,
    city: "South Gate",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 94905,
    density: 4965.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90290,
    lat: 34.09725,
    lng: -118.6125,
    city: "Topanga",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5200,
    density: 107.2,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90291,
    lat: 33.99447,
    lng: -118.46315,
    city: "Venice",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27556,
    density: 4318.7,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90292,
    lat: 33.97865,
    lng: -118.44707,
    city: "Marina Del Rey",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23931,
    density: 4408.2,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90293,
    lat: 33.95071,
    lng: -118.43745,
    city: "Playa Del Rey",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12915,
    density: 1819.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90301,
    lat: 33.95647,
    lng: -118.35863,
    city: "Inglewood",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39320,
    density: 6118.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90302,
    lat: 33.97472,
    lng: -118.35565,
    city: "Inglewood",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29367,
    density: 5926.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90303,
    lat: 33.93601,
    lng: -118.33112,
    city: "Inglewood",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23961,
    density: 4767,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90304,
    lat: 33.93736,
    lng: -118.35879,
    city: "Inglewood",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26584,
    density: 6260.2,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90305,
    lat: 33.9583,
    lng: -118.33113,
    city: "Inglewood",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15373,
    density: 2270.9,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90401,
    lat: 34.01584,
    lng: -118.49251,
    city: "Santa Monica",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7079,
    density: 3622.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90402,
    lat: 34.03598,
    lng: -118.50391,
    city: "Santa Monica",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11637,
    density: 2200.1,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90403,
    lat: 34.03164,
    lng: -118.48975,
    city: "Santa Monica",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24359,
    density: 6662.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90404,
    lat: 34.02665,
    lng: -118.47381,
    city: "Santa Monica",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23107,
    density: 4526.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90405,
    lat: 34.01208,
    lng: -118.4679,
    city: "Santa Monica",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27509,
    density: 3818,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90501,
    lat: 33.8336,
    lng: -118.31419,
    city: "Torrance",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42298,
    density: 2872.7,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90502,
    lat: 33.83497,
    lng: -118.29291,
    city: "Torrance",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18527,
    density: 3194.8,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90503,
    lat: 33.84089,
    lng: -118.3538,
    city: "Torrance",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44354,
    density: 3251.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90504,
    lat: 33.86693,
    lng: -118.33135,
    city: "Torrance",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32703,
    density: 2863,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90505,
    lat: 33.80904,
    lng: -118.34775,
    city: "Torrance",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36820,
    density: 2429.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90506,
    lat: 33.88493,
    lng: -118.33044,
    city: "Torrance",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90601,
    lat: 34.0078,
    lng: -118.03287,
    city: "Whittier",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30623,
    density: 1115.2,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90602,
    lat: 33.97317,
    lng: -118.02341,
    city: "Whittier",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25426,
    density: 2616.9,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90603,
    lat: 33.94487,
    lng: -117.99239,
    city: "Whittier",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20780,
    density: 2536.3,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90604,
    lat: 33.93012,
    lng: -118.01226,
    city: "Whittier",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40545,
    density: 3719.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90605,
    lat: 33.95209,
    lng: -118.02085,
    city: "Whittier",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41162,
    density: 2488.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90606,
    lat: 33.97742,
    lng: -118.0661,
    city: "Whittier",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32631,
    density: 3321.1,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90620,
    lat: 33.84616,
    lng: -118.01176,
    city: "Buena Park",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46228,
    density: 2802.1,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90621,
    lat: 33.87396,
    lng: -117.99346,
    city: "Buena Park",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35448,
    density: 3265.5,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90623,
    lat: 33.85038,
    lng: -118.04088,
    city: "La Palma",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15624,
    density: 3325.3,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 97.92,
      "06037": 2.08,
    },
    county_names_all: "Orange|Los Angeles",
    county_fips_all: "06059|06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90630,
    lat: 33.81814,
    lng: -118.03814,
    city: "Cypress",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49378,
    density: 3099.9,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 99.23,
      "06037": 0.77,
    },
    county_names_all: "Orange|Los Angeles",
    county_fips_all: "06059|06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90631,
    lat: 33.94266,
    lng: -117.95126,
    city: "La Habra",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68748,
    density: 1899.5,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 54.32,
      "06037": 45.68,
    },
    county_names_all: "Orange|Los Angeles",
    county_fips_all: "06059|06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90638,
    lat: 33.90236,
    lng: -118.00907,
    city: "La Mirada",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48704,
    density: 2426.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 99.1,
      "06059": 0.9,
    },
    county_names_all: "Los Angeles|Orange",
    county_fips_all: "06037|06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90639,
    lat: 33.90565,
    lng: -118.01499,
    city: "La Mirada",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90640,
    lat: 34.01506,
    lng: -118.111,
    city: "Montebello",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62873,
    density: 2916.8,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90650,
    lat: 33.90703,
    lng: -118.08249,
    city: "Norwalk",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 104524,
    density: 4075.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90660,
    lat: 33.98868,
    lng: -118.09111,
    city: "Pico Rivera",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62507,
    density: 3113.9,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90670,
    lat: 33.93279,
    lng: -118.0626,
    city: "Santa Fe Springs",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16410,
    density: 761.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90680,
    lat: 33.80115,
    lng: -117.99532,
    city: "Stanton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30807,
    density: 4660.6,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90701,
    lat: 33.8676,
    lng: -118.08055,
    city: "Artesia",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16500,
    density: 3912.1,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90703,
    lat: 33.86797,
    lng: -118.06874,
    city: "Cerritos",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49633,
    density: 2190.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90704,
    lat: 33.3765,
    lng: -118.43678,
    city: "Avalon",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4201,
    density: 21.3,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90706,
    lat: 33.88802,
    lng: -118.12709,
    city: "Bellflower",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 76339,
    density: 4827.8,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90710,
    lat: 33.79806,
    lng: -118.29918,
    city: "Harbor City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28566,
    density: 4724.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90712,
    lat: 33.849,
    lng: -118.14677,
    city: "Lakewood",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30773,
    density: 2818.1,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90713,
    lat: 33.84797,
    lng: -118.11268,
    city: "Lakewood",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27905,
    density: 3106.9,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90715,
    lat: 33.84037,
    lng: -118.07887,
    city: "Lakewood",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20505,
    density: 4671.8,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90716,
    lat: 33.8305,
    lng: -118.07295,
    city: "Hawaiian Gardens",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14170,
    density: 5938.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 99.79,
      "06059": 0.21,
    },
    county_names_all: "Los Angeles|Orange",
    county_fips_all: "06037|06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90717,
    lat: 33.79345,
    lng: -118.31706,
    city: "Lomita",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20919,
    density: 4032.3,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90720,
    lat: 33.79573,
    lng: -118.06342,
    city: "Los Alamitos",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22998,
    density: 1460.7,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90723,
    lat: 33.89768,
    lng: -118.16508,
    city: "Paramount",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53949,
    density: 4387.3,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90731,
    lat: 33.7334,
    lng: -118.27398,
    city: "San Pedro",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60813,
    density: 2537.7,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90732,
    lat: 33.74319,
    lng: -118.31048,
    city: "San Pedro",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22561,
    density: 2435.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90740,
    lat: 33.75461,
    lng: -118.07129,
    city: "Seal Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24288,
    density: 848,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 99.88,
      "06037": 0.12,
    },
    county_names_all: "Orange|Los Angeles",
    county_fips_all: "06059|06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90742,
    lat: 33.71834,
    lng: -118.07174,
    city: "Sunset Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 617,
    density: 1265,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90743,
    lat: 33.72963,
    lng: -118.08594,
    city: "Surfside",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 256,
    density: 740.4,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90744,
    lat: 33.77821,
    lng: -118.26087,
    city: "Wilmington",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56450,
    density: 2452.7,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90745,
    lat: 33.82117,
    lng: -118.26458,
    city: "Carson",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55567,
    density: 2607.8,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90746,
    lat: 33.85855,
    lng: -118.25518,
    city: "Carson",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27458,
    density: 1832.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90747,
    lat: 33.86372,
    lng: -118.25142,
    city: "Carson",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90755,
    lat: 33.80274,
    lng: -118.16747,
    city: "Signal Hill",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11458,
    density: 2036.1,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90802,
    lat: 33.75035,
    lng: -118.21143,
    city: "Long Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39165,
    density: 2315.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90803,
    lat: 33.76162,
    lng: -118.12178,
    city: "Long Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32241,
    density: 3062.7,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 99.9,
      "06059": 0.1,
    },
    county_names_all: "Los Angeles|Orange",
    county_fips_all: "06037|06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90804,
    lat: 33.78223,
    lng: -118.14917,
    city: "Long Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38151,
    density: 6822.8,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90805,
    lat: 33.86494,
    lng: -118.18051,
    city: "Long Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 95094,
    density: 4949,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90806,
    lat: 33.80819,
    lng: -118.17797,
    city: "Long Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41280,
    density: 3261.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90807,
    lat: 33.83098,
    lng: -118.18113,
    city: "Long Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32699,
    density: 2855.8,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90808,
    lat: 33.82406,
    lng: -118.11236,
    city: "Long Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39602,
    density: 2226.8,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90810,
    lat: 33.81912,
    lng: -118.22096,
    city: "Long Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36657,
    density: 2164.2,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90813,
    lat: 33.78237,
    lng: -118.19656,
    city: "Long Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56726,
    density: 7112.2,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90814,
    lat: 33.7716,
    lng: -118.14351,
    city: "Long Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18714,
    density: 5421.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90815,
    lat: 33.79572,
    lng: -118.11592,
    city: "Long Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41854,
    density: 2290.9,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90822,
    lat: 33.77825,
    lng: -118.11871,
    city: "Long Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 133,
    density: 316,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90831,
    lat: 33.76824,
    lng: -118.20055,
    city: "Long Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 90840,
    lat: 33.78449,
    lng: -118.12133,
    city: "Long Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91001,
    lat: 34.19522,
    lng: -118.13866,
    city: "Altadena",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36697,
    density: 1715.3,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91006,
    lat: 34.1352,
    lng: -118.02667,
    city: "Arcadia",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32526,
    density: 1953.2,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91007,
    lat: 34.12842,
    lng: -118.04818,
    city: "Arcadia",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33827,
    density: 2372.3,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91008,
    lat: 34.15363,
    lng: -117.96862,
    city: "Duarte",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1079,
    density: 216.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91010,
    lat: 34.14114,
    lng: -117.95918,
    city: "Duarte",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26516,
    density: 1591.9,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91011,
    lat: 34.21757,
    lng: -118.20346,
    city: "La Canada Flintridge",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20174,
    density: 691.7,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91016,
    lat: 34.15246,
    lng: -118.00065,
    city: "Monrovia",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41582,
    density: 1893.7,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91020,
    lat: 34.21144,
    lng: -118.23065,
    city: "Montrose",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8785,
    density: 4720.9,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91024,
    lat: 34.17177,
    lng: -118.04654,
    city: "Sierra Madre",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10829,
    density: 1196.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91030,
    lat: 34.11029,
    lng: -118.15748,
    city: "South Pasadena",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25478,
    density: 2866.7,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91040,
    lat: 34.25861,
    lng: -118.33468,
    city: "Sunland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20606,
    density: 956.2,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91042,
    lat: 34.30687,
    lng: -118.25701,
    city: "Tujunga",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26617,
    density: 206.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91046,
    lat: 34.2117,
    lng: -118.24092,
    city: "Verdugo City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 191,
    density: 14534.7,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91101,
    lat: 34.14671,
    lng: -118.13895,
    city: "Pasadena",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21920,
    density: 6662.7,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91103,
    lat: 34.16738,
    lng: -118.16446,
    city: "Pasadena",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26837,
    density: 2257.8,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91104,
    lat: 34.16766,
    lng: -118.12341,
    city: "Pasadena",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37784,
    density: 3868.8,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91105,
    lat: 34.14045,
    lng: -118.16716,
    city: "Pasadena",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12648,
    density: 1163.9,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91106,
    lat: 34.13861,
    lng: -118.12825,
    city: "Pasadena",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25205,
    density: 3582.1,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91107,
    lat: 34.15919,
    lng: -118.08688,
    city: "Pasadena",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33481,
    density: 1528.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91108,
    lat: 34.12232,
    lng: -118.11363,
    city: "San Marino",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13175,
    density: 1342.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91125,
    lat: 34.13772,
    lng: -118.12492,
    city: "Pasadena",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91201,
    lat: 34.17041,
    lng: -118.28902,
    city: "Glendale",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22786,
    density: 3691.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91202,
    lat: 34.18221,
    lng: -118.26761,
    city: "Glendale",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23399,
    density: 1835.7,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91203,
    lat: 34.15287,
    lng: -118.26355,
    city: "Glendale",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15794,
    density: 6946.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91204,
    lat: 34.13554,
    lng: -118.26093,
    city: "Glendale",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18950,
    density: 7006.9,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91205,
    lat: 34.13679,
    lng: -118.24339,
    city: "Glendale",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37549,
    density: 7649.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91206,
    lat: 34.16076,
    lng: -118.21311,
    city: "Glendale",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33781,
    density: 2263,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91207,
    lat: 34.16872,
    lng: -118.24477,
    city: "Glendale",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11318,
    density: 2747.1,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91208,
    lat: 34.19333,
    lng: -118.23839,
    city: "Glendale",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15146,
    density: 791.2,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91210,
    lat: 34.14468,
    lng: -118.25809,
    city: "Glendale",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 352,
    density: 1423.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91214,
    lat: 34.23759,
    lng: -118.24778,
    city: "La Crescenta",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31668,
    density: 1680,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91301,
    lat: 34.12314,
    lng: -118.75685,
    city: "Agoura Hills",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26021,
    density: 303.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91302,
    lat: 34.12295,
    lng: -118.67193,
    city: "Calabasas",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26961,
    density: 379.2,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91303,
    lat: 34.19784,
    lng: -118.6017,
    city: "Canoga Park",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31024,
    density: 5662.3,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91304,
    lat: 34.22472,
    lng: -118.63261,
    city: "Canoga Park",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53637,
    density: 2130,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 86,
      "06111": 14,
    },
    county_names_all: "Los Angeles|Ventura",
    county_fips_all: "06037|06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91306,
    lat: 34.20926,
    lng: -118.5755,
    city: "Winnetka",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50319,
    density: 4673.1,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91307,
    lat: 34.20177,
    lng: -118.66226,
    city: "West Hills",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25794,
    density: 1223.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 55.18,
      "06111": 44.82,
    },
    county_names_all: "Los Angeles|Ventura",
    county_fips_all: "06037|06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91311,
    lat: 34.29011,
    lng: -118.60776,
    city: "Chatsworth",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41811,
    density: 495.7,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 96.78,
      "06111": 3.22,
    },
    county_names_all: "Los Angeles|Ventura",
    county_fips_all: "06037|06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91316,
    lat: 34.15836,
    lng: -118.51658,
    city: "Encino",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30412,
    density: 2151.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91320,
    lat: 34.17339,
    lng: -118.94795,
    city: "Newbury Park",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44667,
    density: 854.8,
    county_fips: "06111",
    county_name: "Ventura",
    county_weights: {
      "06111": 100,
    },
    county_names_all: "Ventura",
    county_fips_all: "06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91321,
    lat: 34.36479,
    lng: -118.4922,
    city: "Newhall",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34340,
    density: 497.3,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91324,
    lat: 34.23855,
    lng: -118.55015,
    city: "Northridge",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30995,
    density: 2810.8,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91325,
    lat: 34.23636,
    lng: -118.51777,
    city: "Northridge",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34637,
    density: 2777,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91326,
    lat: 34.28022,
    lng: -118.5566,
    city: "Porter Ranch",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36126,
    density: 1722.1,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91330,
    lat: 34.2446,
    lng: -118.52669,
    city: "Northridge",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3136,
    density: 2425.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91331,
    lat: 34.25602,
    lng: -118.41939,
    city: "Pacoima",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 103683,
    density: 4284,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91335,
    lat: 34.20107,
    lng: -118.5407,
    city: "Reseda",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 80937,
    density: 4759.1,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91340,
    lat: 34.28668,
    lng: -118.43479,
    city: "San Fernando",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37221,
    density: 4188.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91342,
    lat: 34.31778,
    lng: -118.39207,
    city: "Sylmar",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 94432,
    density: 802.3,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91343,
    lat: 34.23837,
    lng: -118.48076,
    city: "North Hills",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65344,
    density: 4259.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91344,
    lat: 34.28991,
    lng: -118.5047,
    city: "Granada Hills",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55694,
    density: 1486.9,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91345,
    lat: 34.26591,
    lng: -118.45948,
    city: "Mission Hills",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18825,
    density: 2240.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91350,
    lat: 34.43028,
    lng: -118.50283,
    city: "Santa Clarita",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38611,
    density: 939.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91351,
    lat: 34.43269,
    lng: -118.46276,
    city: "Canyon Country",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30746,
    density: 1366.7,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91352,
    lat: 34.23183,
    lng: -118.36596,
    city: "Sun Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46027,
    density: 1532,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91354,
    lat: 34.46039,
    lng: -118.5528,
    city: "Valencia",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33039,
    density: 1741,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91355,
    lat: 34.42379,
    lng: -118.58437,
    city: "Valencia",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29371,
    density: 862.1,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91356,
    lat: 34.15504,
    lng: -118.54757,
    city: "Tarzana",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30700,
    density: 1616.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91360,
    lat: 34.21475,
    lng: -118.87735,
    city: "Thousand Oaks",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42663,
    density: 1072.2,
    county_fips: "06111",
    county_name: "Ventura",
    county_weights: {
      "06111": 100,
    },
    county_names_all: "Ventura",
    county_fips_all: "06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91361,
    lat: 34.14016,
    lng: -118.88398,
    city: "Westlake Village",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19953,
    density: 266.9,
    county_fips: "06111",
    county_name: "Ventura",
    county_weights: {
      "06111": 81.98,
      "06037": 18.02,
    },
    county_names_all: "Ventura|Los Angeles",
    county_fips_all: "06111|06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91362,
    lat: 34.19244,
    lng: -118.81949,
    city: "Thousand Oaks",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37085,
    density: 754,
    county_fips: "06111",
    county_name: "Ventura",
    county_weights: {
      "06111": 94.55,
      "06037": 5.45,
    },
    county_names_all: "Ventura|Los Angeles",
    county_fips_all: "06111|06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91364,
    lat: 34.1548,
    lng: -118.59492,
    city: "Woodland Hills",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28395,
    density: 1454.1,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91367,
    lat: 34.17708,
    lng: -118.61518,
    city: "Woodland Hills",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45074,
    density: 2324.3,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91371,
    lat: 34.18505,
    lng: -118.57605,
    city: "Woodland Hills",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91377,
    lat: 34.1847,
    lng: -118.76652,
    city: "Oak Park",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13987,
    density: 1001.1,
    county_fips: "06111",
    county_name: "Ventura",
    county_weights: {
      "06111": 100,
    },
    county_names_all: "Ventura",
    county_fips_all: "06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91381,
    lat: 34.3753,
    lng: -118.60744,
    city: "Stevenson Ranch",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19675,
    density: 192.2,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91384,
    lat: 34.51604,
    lng: -118.67289,
    city: "Castaic",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28833,
    density: 107.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91387,
    lat: 34.39708,
    lng: -118.3707,
    city: "Canyon Country",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41145,
    density: 297.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91390,
    lat: 34.53159,
    lng: -118.40668,
    city: "Santa Clarita",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19093,
    density: 46.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91401,
    lat: 34.17801,
    lng: -118.43183,
    city: "Van Nuys",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40405,
    density: 4408.3,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91402,
    lat: 34.22413,
    lng: -118.4448,
    city: "Panorama City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 70702,
    density: 7326.2,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91403,
    lat: 34.14716,
    lng: -118.46311,
    city: "Sherman Oaks",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25837,
    density: 2781,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91405,
    lat: 34.20153,
    lng: -118.44863,
    city: "Van Nuys",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56821,
    density: 6455.7,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91406,
    lat: 34.19791,
    lng: -118.48987,
    city: "Van Nuys",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54309,
    density: 2602,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91411,
    lat: 34.17853,
    lng: -118.45956,
    city: "Van Nuys",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24893,
    density: 4924.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91423,
    lat: 34.14924,
    lng: -118.43239,
    city: "Sherman Oaks",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32968,
    density: 3133.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91436,
    lat: 34.15219,
    lng: -118.49053,
    city: "Encino",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16737,
    density: 1237.8,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91501,
    lat: 34.19469,
    lng: -118.29431,
    city: "Burbank",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19459,
    density: 2754,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91502,
    lat: 34.17684,
    lng: -118.30936,
    city: "Burbank",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11218,
    density: 3224.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91504,
    lat: 34.21349,
    lng: -118.31478,
    city: "Burbank",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27975,
    density: 1159,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91505,
    lat: 34.17583,
    lng: -118.34692,
    city: "Burbank",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31139,
    density: 2245.7,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91506,
    lat: 34.17134,
    lng: -118.32384,
    city: "Burbank",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17864,
    density: 2846.3,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91601,
    lat: 34.16827,
    lng: -118.37222,
    city: "North Hollywood",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35312,
    density: 5171.1,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91602,
    lat: 34.15078,
    lng: -118.36633,
    city: "North Hollywood",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20339,
    density: 3849,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91604,
    lat: 34.13985,
    lng: -118.39435,
    city: "Studio City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34021,
    density: 2771,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91605,
    lat: 34.20699,
    lng: -118.40067,
    city: "North Hollywood",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52345,
    density: 3763.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91606,
    lat: 34.18655,
    lng: -118.38867,
    city: "North Hollywood",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45003,
    density: 5219.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91607,
    lat: 34.16633,
    lng: -118.39982,
    city: "Valley Village",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31039,
    density: 4856.1,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91608,
    lat: 34.13839,
    lng: -118.35272,
    city: "Universal City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18,
    density: 11.8,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91701,
    lat: 34.13784,
    lng: -117.60028,
    city: "Rancho Cucamonga",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39954,
    density: 2087,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91702,
    lat: 34.24129,
    lng: -117.82614,
    city: "Azusa",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61464,
    density: 364.9,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91706,
    lat: 34.09627,
    lng: -117.96855,
    city: "Baldwin Park",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 76581,
    density: 2185.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91708,
    lat: 33.95141,
    lng: -117.64506,
    city: "Chino",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4880,
    density: 233,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91709,
    lat: 33.95105,
    lng: -117.72549,
    city: "Chino Hills",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 82800,
    density: 713.4,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 99.65,
      "06037": 0.35,
    },
    county_names_all: "San Bernardino|Los Angeles",
    county_fips_all: "06071|06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91710,
    lat: 34.00507,
    lng: -117.68249,
    city: "Chino",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 90481,
    density: 1585.7,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91711,
    lat: 34.12836,
    lng: -117.71523,
    city: "Claremont",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36217,
    density: 936.2,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91722,
    lat: 34.09731,
    lng: -117.90612,
    city: "Covina",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34951,
    density: 3271.7,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91723,
    lat: 34.08495,
    lng: -117.88652,
    city: "Covina",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17664,
    density: 2923.3,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91724,
    lat: 34.0805,
    lng: -117.85515,
    city: "Covina",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27510,
    density: 1703.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91730,
    lat: 34.10023,
    lng: -117.5811,
    city: "Rancho Cucamonga",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74843,
    density: 2104.8,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91731,
    lat: 34.07914,
    lng: -118.04047,
    city: "El Monte",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30313,
    density: 3083.7,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91732,
    lat: 34.07239,
    lng: -118.01455,
    city: "El Monte",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61075,
    density: 5194.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91733,
    lat: 34.0454,
    lng: -118.05314,
    city: "South El Monte",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44908,
    density: 2570,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91737,
    lat: 34.15523,
    lng: -117.57808,
    city: "Rancho Cucamonga",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24064,
    density: 921.1,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91739,
    lat: 34.1622,
    lng: -117.51558,
    city: "Rancho Cucamonga",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39355,
    density: 534.6,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91740,
    lat: 34.11884,
    lng: -117.8534,
    city: "Glendora",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26099,
    density: 2011.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91741,
    lat: 34.1647,
    lng: -117.83197,
    city: "Glendora",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26071,
    density: 494.2,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91744,
    lat: 34.02914,
    lng: -117.93735,
    city: "La Puente",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 83396,
    density: 3704.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91745,
    lat: 33.99926,
    lng: -117.97225,
    city: "Hacienda Heights",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55394,
    density: 1651.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91746,
    lat: 34.04397,
    lng: -117.98785,
    city: "La Puente",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29876,
    density: 1985.7,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91748,
    lat: 33.9769,
    lng: -117.89924,
    city: "Rowland Heights",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46634,
    density: 1270.2,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91750,
    lat: 34.14927,
    lng: -117.76647,
    city: "La Verne",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34468,
    density: 717.9,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91752,
    lat: 33.99575,
    lng: -117.53399,
    city: "Mira Loma",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36087,
    density: 923.8,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91754,
    lat: 34.051,
    lng: -118.14451,
    city: "Monterey Park",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33343,
    density: 2848.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91755,
    lat: 34.04832,
    lng: -118.11496,
    city: "Monterey Park",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27254,
    density: 3340.1,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91759,
    lat: 34.2541,
    lng: -117.69194,
    city: "Mt Baldy",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 351,
    density: 1.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 79.33,
      "06071": 20.67,
    },
    county_names_all: "Los Angeles|San Bernardino",
    county_fips_all: "06037|06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91761,
    lat: 34.03541,
    lng: -117.5915,
    city: "Ontario",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60827,
    density: 824.3,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91762,
    lat: 34.02764,
    lng: -117.64308,
    city: "Ontario",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63819,
    density: 1724.4,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91763,
    lat: 34.07208,
    lng: -117.69828,
    city: "Montclair",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39557,
    density: 2881.6,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91764,
    lat: 34.07533,
    lng: -117.60164,
    city: "Ontario",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57265,
    density: 2796.4,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91765,
    lat: 33.98725,
    lng: -117.81473,
    city: "Diamond Bar",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46248,
    density: 961.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91766,
    lat: 34.04192,
    lng: -117.75698,
    city: "Pomona",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 71189,
    density: 2721.8,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 95.85,
      "06071": 4.15,
    },
    county_names_all: "Los Angeles|San Bernardino",
    county_fips_all: "06037|06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91767,
    lat: 34.08143,
    lng: -117.73868,
    city: "Pomona",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50493,
    density: 3429.4,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91768,
    lat: 34.06358,
    lng: -117.78941,
    city: "Pomona",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35634,
    density: 1677.8,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91770,
    lat: 34.06395,
    lng: -118.08361,
    city: "Rosemead",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63177,
    density: 3738.8,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91773,
    lat: 34.1072,
    lng: -117.80928,
    city: "San Dimas",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33703,
    density: 868.9,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91775,
    lat: 34.11454,
    lng: -118.08946,
    city: "San Gabriel",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24517,
    density: 3054.2,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91776,
    lat: 34.08987,
    lng: -118.09519,
    city: "San Gabriel",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38675,
    density: 4469.7,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91780,
    lat: 34.10152,
    lng: -118.05584,
    city: "Temple City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34854,
    density: 3499.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91784,
    lat: 34.14103,
    lng: -117.65831,
    city: "Upland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26296,
    density: 1110.8,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91786,
    lat: 34.10525,
    lng: -117.66206,
    city: "Upland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54165,
    density: 2338.4,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91789,
    lat: 34.01858,
    lng: -117.85408,
    city: "Walnut",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43531,
    density: 1059.3,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91790,
    lat: 34.06722,
    lng: -117.93788,
    city: "West Covina",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44601,
    density: 2992,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91791,
    lat: 34.06134,
    lng: -117.89425,
    city: "West Covina",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33314,
    density: 1936.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91792,
    lat: 34.02586,
    lng: -117.89989,
    city: "West Covina",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29806,
    density: 2995.7,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91801,
    lat: 34.09093,
    lng: -118.12776,
    city: "Alhambra",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54161,
    density: 4836.2,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91803,
    lat: 34.0749,
    lng: -118.14624,
    city: "Alhambra",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30093,
    density: 3564.2,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91901,
    lat: 32.81467,
    lng: -116.71929,
    city: "Alpine",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17896,
    density: 88.7,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91902,
    lat: 32.67479,
    lng: -117.00475,
    city: "Bonita",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17760,
    density: 611.3,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91905,
    lat: 32.67773,
    lng: -116.30734,
    city: "Boulevard",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1665,
    density: 7.7,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91906,
    lat: 32.66241,
    lng: -116.47255,
    city: "Campo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4327,
    density: 15.9,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91910,
    lat: 32.63653,
    lng: -117.06301,
    city: "Chula Vista",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74233,
    density: 2277.1,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91911,
    lat: 32.60686,
    lng: -117.04984,
    city: "Chula Vista",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 88593,
    density: 2687.5,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91913,
    lat: 32.62174,
    lng: -116.98609,
    city: "Chula Vista",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51054,
    density: 2167.2,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91914,
    lat: 32.66604,
    lng: -116.95426,
    city: "Chula Vista",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16889,
    density: 981.5,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91915,
    lat: 32.62266,
    lng: -116.95013,
    city: "Chula Vista",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33991,
    density: 1698,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91916,
    lat: 32.91103,
    lng: -116.63201,
    city: "Descanso",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1775,
    density: 11.1,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91917,
    lat: 32.6267,
    lng: -116.71894,
    city: "Dulzura",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1048,
    density: 7.8,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91931,
    lat: 32.83758,
    lng: -116.58029,
    city: "Guatay",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 530,
    density: 24.9,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91932,
    lat: 32.56923,
    lng: -117.11798,
    city: "Imperial Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26323,
    density: 2376.4,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91934,
    lat: 32.66488,
    lng: -116.16828,
    city: "Jacumba",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 785,
    density: 5.9,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91935,
    lat: 32.70214,
    lng: -116.78721,
    city: "Jamul",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9270,
    density: 33.9,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91941,
    lat: 32.75964,
    lng: -116.99253,
    city: "La Mesa",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33126,
    density: 1555.3,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91942,
    lat: 32.77728,
    lng: -117.02129,
    city: "La Mesa",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40714,
    density: 2724.3,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91945,
    lat: 32.73315,
    lng: -117.03402,
    city: "Lemon Grove",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26923,
    density: 2629.7,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91948,
    lat: 32.87509,
    lng: -116.47076,
    city: "Mount Laguna",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 115,
    density: 1.3,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91950,
    lat: 32.66952,
    lng: -117.09313,
    city: "National City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62783,
    density: 3303.7,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91962,
    lat: 32.79248,
    lng: -116.48044,
    city: "Pine Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2652,
    density: 17.5,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91963,
    lat: 32.64798,
    lng: -116.5964,
    city: "Potrero",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 479,
    density: 4.5,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91977,
    lat: 32.72387,
    lng: -116.99631,
    city: "Spring Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63267,
    density: 2463,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91978,
    lat: 32.71209,
    lng: -116.94103,
    city: "Spring Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10949,
    density: 354.1,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 91980,
    lat: 32.58685,
    lng: -116.61969,
    city: "Tecate",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92003,
    lat: 33.28701,
    lng: -117.19977,
    city: "Bonsall",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5123,
    density: 131.7,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92004,
    lat: 33.18481,
    lng: -116.15688,
    city: "Borrego Springs",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2284,
    density: 1,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 58.05,
      "06025": 41.95,
    },
    county_names_all: "San Diego|Imperial",
    county_fips_all: "06073|06025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92007,
    lat: 33.02216,
    lng: -117.27389,
    city: "Cardiff By The Sea",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11973,
    density: 1998.9,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92008,
    lat: 33.14564,
    lng: -117.31691,
    city: "Carlsbad",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27119,
    density: 1006.7,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92009,
    lat: 33.09535,
    lng: -117.24574,
    city: "Carlsbad",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46849,
    density: 1484.5,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92010,
    lat: 33.15676,
    lng: -117.28423,
    city: "Carlsbad",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15600,
    density: 730.8,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92011,
    lat: 33.10698,
    lng: -117.29507,
    city: "Carlsbad",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24843,
    density: 1467.3,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92014,
    lat: 32.96797,
    lng: -117.24879,
    city: "Del Mar",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13133,
    density: 804.2,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92019,
    lat: 32.77886,
    lng: -116.87142,
    city: "El Cajon",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44397,
    density: 540.2,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92020,
    lat: 32.79557,
    lng: -116.9697,
    city: "El Cajon",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57796,
    density: 2007.5,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92021,
    lat: 32.83514,
    lng: -116.87462,
    city: "El Cajon",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 71183,
    density: 980.2,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92024,
    lat: 33.05716,
    lng: -117.25651,
    city: "Encinitas",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50994,
    density: 1092.3,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92025,
    lat: 33.08492,
    lng: -117.02967,
    city: "Escondido",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52276,
    density: 902.2,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92026,
    lat: 33.2111,
    lng: -117.11157,
    city: "Escondido",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50461,
    density: 540.3,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92027,
    lat: 33.13263,
    lng: -116.98335,
    city: "Escondido",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57225,
    density: 370.3,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92028,
    lat: 33.38613,
    lng: -117.22658,
    city: "Fallbrook",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48736,
    density: 161.3,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 99.3,
      "06065": 0.7,
    },
    county_names_all: "San Diego|Riverside",
    county_fips_all: "06073|06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92029,
    lat: 33.08555,
    lng: -117.12885,
    city: "Escondido",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19361,
    density: 331.4,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92036,
    lat: 33.01137,
    lng: -116.37672,
    city: "Julian",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2619,
    density: 2,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92037,
    lat: 32.85257,
    lng: -117.25104,
    city: "La Jolla",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38261,
    density: 1226.3,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92040,
    lat: 32.90665,
    lng: -116.88875,
    city: "Lakeside",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45392,
    density: 260.8,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92054,
    lat: 33.19377,
    lng: -117.35508,
    city: "Oceanside",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40709,
    density: 2103.6,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92055,
    lat: 33.38123,
    lng: -117.42874,
    city: "Camp Pendleton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12783,
    density: 38,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92056,
    lat: 33.20197,
    lng: -117.28939,
    city: "Oceanside",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53124,
    density: 1666.3,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92057,
    lat: 33.25326,
    lng: -117.28704,
    city: "Oceanside",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59190,
    density: 1527.3,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92058,
    lat: 33.28379,
    lng: -117.34182,
    city: "Oceanside",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47011,
    density: 410.1,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92059,
    lat: 33.38277,
    lng: -117.05193,
    city: "Pala",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1578,
    density: 22.1,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92060,
    lat: 33.35043,
    lng: -116.86451,
    city: "Palomar Mountain",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 457,
    density: 2.6,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92061,
    lat: 33.30036,
    lng: -116.93048,
    city: "Pauma Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2273,
    density: 25.2,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92064,
    lat: 32.98038,
    lng: -117.01746,
    city: "Poway",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49768,
    density: 453.9,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92065,
    lat: 33.04736,
    lng: -116.84386,
    city: "Ramona",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36460,
    density: 83.1,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92066,
    lat: 33.21541,
    lng: -116.53583,
    city: "Ranchita",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 350,
    density: 6.1,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92067,
    lat: 33.02087,
    lng: -117.19209,
    city: "Rancho Santa Fe",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8968,
    density: 154.6,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92069,
    lat: 33.17536,
    lng: -117.15761,
    city: "San Marcos",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48048,
    density: 1004.4,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92070,
    lat: 33.18513,
    lng: -116.74071,
    city: "Santa Ysabel",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 892,
    density: 2.7,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92071,
    lat: 32.85045,
    lng: -116.99479,
    city: "Santee",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57207,
    density: 1171.8,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92075,
    lat: 32.99735,
    lng: -117.25875,
    city: "Solana Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12691,
    density: 1433.4,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92078,
    lat: 33.11834,
    lng: -117.18554,
    city: "San Marcos",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52810,
    density: 1220.9,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92081,
    lat: 33.16451,
    lng: -117.24056,
    city: "Vista",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30434,
    density: 1315,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92082,
    lat: 33.2518,
    lng: -117.00284,
    city: "Valley Center",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19636,
    density: 60.3,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92083,
    lat: 33.19808,
    lng: -117.24844,
    city: "Vista",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39276,
    density: 2733.8,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92084,
    lat: 33.22454,
    lng: -117.20334,
    city: "Vista",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50306,
    density: 685.3,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92086,
    lat: 33.29718,
    lng: -116.64176,
    city: "Warner Springs",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1259,
    density: 2.2,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92091,
    lat: 33.03432,
    lng: -117.19704,
    city: "Rancho Santa Fe",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1311,
    density: 392.3,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92092,
    lat: 32.87544,
    lng: -117.23621,
    city: "La Jolla",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92093,
    lat: 32.88219,
    lng: -117.23706,
    city: "La Jolla",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92096,
    lat: 33.12819,
    lng: -117.15631,
    city: "San Marcos",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92101,
    lat: 32.7162,
    lng: -117.18589,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42423,
    density: 3042.5,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92102,
    lat: 32.71595,
    lng: -117.11749,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42413,
    density: 3646.6,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92103,
    lat: 32.74782,
    lng: -117.16738,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34246,
    density: 3588.4,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92104,
    lat: 32.74191,
    lng: -117.12781,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45601,
    density: 4765.6,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92105,
    lat: 32.73756,
    lng: -117.09193,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75990,
    density: 5097.7,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92106,
    lat: 32.71334,
    lng: -117.23617,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20592,
    density: 1403.7,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92107,
    lat: 32.7402,
    lng: -117.24357,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31667,
    density: 4042.8,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92108,
    lat: 32.77423,
    lng: -117.14097,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21013,
    density: 1840.5,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92109,
    lat: 32.78699,
    lng: -117.23273,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46777,
    density: 2373.6,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92110,
    lat: 32.76533,
    lng: -117.19965,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30047,
    density: 2317.1,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92111,
    lat: 32.8065,
    lng: -117.16897,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49874,
    density: 2271.2,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92113,
    lat: 32.69591,
    lng: -117.12012,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58231,
    density: 4984.6,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92114,
    lat: 32.70778,
    lng: -117.05529,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69858,
    density: 3254.3,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92115,
    lat: 32.76154,
    lng: -117.07187,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63755,
    density: 3990,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92116,
    lat: 32.76484,
    lng: -117.12303,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32361,
    density: 3696.8,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92117,
    lat: 32.82493,
    lng: -117.19972,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58651,
    density: 2602,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92118,
    lat: 32.67466,
    lng: -117.16915,
    city: "Coronado",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23426,
    density: 1176.2,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92119,
    lat: 32.80896,
    lng: -117.03232,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24915,
    density: 1465.4,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92120,
    lat: 32.79526,
    lng: -117.07317,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29764,
    density: 1496.2,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92121,
    lat: 32.8973,
    lng: -117.20231,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4668,
    density: 143.7,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92122,
    lat: 32.85681,
    lng: -117.21017,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47842,
    density: 3434.6,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92123,
    lat: 32.80958,
    lng: -117.13419,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34103,
    density: 1529.1,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92124,
    lat: 32.82823,
    lng: -117.08528,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32754,
    density: 1292.6,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92126,
    lat: 32.912,
    lng: -117.14344,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 83257,
    density: 2774.4,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92127,
    lat: 33.01913,
    lng: -117.12339,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50092,
    density: 853,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92128,
    lat: 32.99687,
    lng: -117.07308,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52225,
    density: 1722.6,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92129,
    lat: 32.96354,
    lng: -117.12622,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56608,
    density: 1670.5,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92130,
    lat: 32.94763,
    lng: -117.20586,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56741,
    density: 1180.1,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92131,
    lat: 32.89604,
    lng: -117.05737,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34922,
    density: 348.9,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92132,
    lat: 32.71368,
    lng: -117.17201,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92134,
    lat: 32.72512,
    lng: -117.14541,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 297,
    density: 1527.4,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92135,
    lat: 32.69487,
    lng: -117.19461,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 637,
    density: 584.7,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92136,
    lat: 32.68254,
    lng: -117.12307,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92139,
    lat: 32.68006,
    lng: -117.04889,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36172,
    density: 3903.6,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92140,
    lat: 32.74041,
    lng: -117.1984,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3443,
    density: 2484.1,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92145,
    lat: 32.86292,
    lng: -117.14579,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92147,
    lat: 32.72478,
    lng: -117.21895,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 396,
    density: 1756.6,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92154,
    lat: 32.578,
    lng: -116.96621,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 89886,
    density: 676.5,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92155,
    lat: 32.67148,
    lng: -117.16714,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92161,
    lat: 32.8742,
    lng: -117.23159,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92173,
    lat: 32.55552,
    lng: -117.05114,
    city: "San Ysidro",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31248,
    density: 4193,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92179,
    lat: 32.58409,
    lng: -116.93349,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92182,
    lat: 32.77498,
    lng: -117.07424,
    city: "San Diego",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 100,
    },
    county_names_all: "San Diego",
    county_fips_all: "06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92201,
    lat: 33.70804,
    lng: -116.23502,
    city: "Indio",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64967,
    density: 1547.2,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92203,
    lat: 33.75159,
    lng: -116.24139,
    city: "Indio",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32360,
    density: 677,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92210,
    lat: 33.70357,
    lng: -116.33953,
    city: "Indian Wells",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5137,
    density: 138.4,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92211,
    lat: 33.76593,
    lng: -116.33241,
    city: "Palm Desert",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25530,
    density: 664.9,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92220,
    lat: 33.93992,
    lng: -116.83935,
    city: "Banning",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33360,
    density: 91.1,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92222,
    lat: 32.78346,
    lng: -114.54965,
    city: "Bard",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "06025",
    county_name: "Imperial",
    county_weights: {
      "06025": 100,
    },
    county_names_all: "Imperial",
    county_fips_all: "06025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Phoenix",
  },
  {
    zip: 92223,
    lat: 33.9382,
    lng: -116.98137,
    city: "Beaumont",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56925,
    density: 488.5,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92225,
    lat: 33.71642,
    lng: -114.65606,
    city: "Blythe",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22520,
    density: 15,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 99.52,
      "06025": 0.48,
    },
    county_names_all: "Riverside|Imperial",
    county_fips_all: "06065|06025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92227,
    lat: 32.98677,
    lng: -115.3341,
    city: "Brawley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27165,
    density: 17.7,
    county_fips: "06025",
    county_name: "Imperial",
    county_weights: {
      "06025": 100,
    },
    county_names_all: "Imperial",
    county_fips_all: "06025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92230,
    lat: 33.9088,
    lng: -116.76879,
    city: "Cabazon",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2363,
    density: 78.1,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92231,
    lat: 32.68751,
    lng: -115.56433,
    city: "Calexico",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39884,
    density: 224.6,
    county_fips: "06025",
    county_name: "Imperial",
    county_weights: {
      "06025": 100,
    },
    county_names_all: "Imperial",
    county_fips_all: "06025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92233,
    lat: 33.14736,
    lng: -115.50686,
    city: "Calipatria",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7520,
    density: 19.1,
    county_fips: "06025",
    county_name: "Imperial",
    county_weights: {
      "06025": 100,
    },
    county_names_all: "Imperial",
    county_fips_all: "06025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92234,
    lat: 33.81386,
    lng: -116.46663,
    city: "Cathedral City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54812,
    density: 1433.5,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92236,
    lat: 33.70276,
    lng: -116.07254,
    city: "Coachella",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45975,
    density: 287,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92239,
    lat: 33.87424,
    lng: -115.24396,
    city: "Desert Center",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 295,
    density: 0.2,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92240,
    lat: 33.95291,
    lng: -116.5194,
    city: "Desert Hot Springs",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36214,
    density: 391.6,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92241,
    lat: 33.84634,
    lng: -116.28342,
    city: "Desert Hot Springs",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7695,
    density: 22.4,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92242,
    lat: 34.19019,
    lng: -114.30755,
    city: "Earp",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1300,
    density: 11.1,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92243,
    lat: 32.77285,
    lng: -115.60065,
    city: "El Centro",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50112,
    density: 170.8,
    county_fips: "06025",
    county_name: "Imperial",
    county_weights: {
      "06025": 100,
    },
    county_names_all: "Imperial",
    county_fips_all: "06025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92249,
    lat: 32.72606,
    lng: -115.48218,
    city: "Heber",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8459,
    density: 164.4,
    county_fips: "06025",
    county_name: "Imperial",
    county_weights: {
      "06025": 100,
    },
    county_names_all: "Imperial",
    county_fips_all: "06025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92250,
    lat: 32.79188,
    lng: -115.23454,
    city: "Holtville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8255,
    density: 9,
    county_fips: "06025",
    county_name: "Imperial",
    county_weights: {
      "06025": 100,
    },
    county_names_all: "Imperial",
    county_fips_all: "06025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92251,
    lat: 32.87129,
    lng: -115.71804,
    city: "Imperial",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24321,
    density: 38,
    county_fips: "06025",
    county_name: "Imperial",
    county_weights: {
      "06025": 100,
    },
    county_names_all: "Imperial",
    county_fips_all: "06025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92252,
    lat: 34.14801,
    lng: -116.28422,
    city: "Joshua Tree",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9500,
    density: 32.7,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92253,
    lat: 33.65562,
    lng: -116.28785,
    city: "La Quinta",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41573,
    density: 396.9,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92254,
    lat: 33.54371,
    lng: -115.99995,
    city: "Mecca",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8336,
    density: 67.2,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92256,
    lat: 34.07207,
    lng: -116.61761,
    city: "Morongo Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3176,
    density: 19.4,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92257,
    lat: 33.33976,
    lng: -115.52814,
    city: "Niland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1217,
    density: 1.7,
    county_fips: "06025",
    county_name: "Imperial",
    county_weights: {
      "06025": 100,
    },
    county_names_all: "Imperial",
    county_fips_all: "06025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92258,
    lat: 33.91791,
    lng: -116.56002,
    city: "North Palm Springs",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 517,
    density: 19.2,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92259,
    lat: 32.73478,
    lng: -115.94632,
    city: "Ocotillo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 89,
    density: 0.1,
    county_fips: "06025",
    county_name: "Imperial",
    county_weights: {
      "06025": 100,
    },
    county_names_all: "Imperial",
    county_fips_all: "06025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92260,
    lat: 33.69841,
    lng: -116.40519,
    city: "Palm Desert",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34553,
    density: 425.8,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92262,
    lat: 33.86287,
    lng: -116.55736,
    city: "Palm Springs",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28463,
    density: 313,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92264,
    lat: 33.73575,
    lng: -116.50544,
    city: "Palm Springs",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20881,
    density: 158.4,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92266,
    lat: 33.17507,
    lng: -114.92594,
    city: "Palo Verde",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 119,
    density: 0,
    county_fips: "06025",
    county_name: "Imperial",
    county_weights: {
      "06025": 100,
    },
    county_names_all: "Imperial",
    county_fips_all: "06025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92267,
    lat: 34.29765,
    lng: -114.20138,
    city: "Parker Dam",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26,
    density: 0.2,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92268,
    lat: 34.16146,
    lng: -116.55002,
    city: "Pioneertown",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 360,
    density: 2,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92270,
    lat: 33.76399,
    lng: -116.42705,
    city: "Rancho Mirage",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18537,
    density: 279.3,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92273,
    lat: 32.80798,
    lng: -115.69592,
    city: "Seeley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1847,
    density: 220.7,
    county_fips: "06025",
    county_name: "Imperial",
    county_weights: {
      "06025": 100,
    },
    county_names_all: "Imperial",
    county_fips_all: "06025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92274,
    lat: 33.47031,
    lng: -116.11387,
    city: "Thermal",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14105,
    density: 25.2,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 66.1,
      "06025": 33.9,
    },
    county_names_all: "Riverside|Imperial",
    county_fips_all: "06065|06025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92275,
    lat: 33.20783,
    lng: -115.88084,
    city: "Salton City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2531,
    density: 24.1,
    county_fips: "06025",
    county_name: "Imperial",
    county_weights: {
      "06025": 100,
    },
    county_names_all: "Imperial",
    county_fips_all: "06025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92276,
    lat: 33.83234,
    lng: -116.38648,
    city: "Thousand Palms",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8158,
    density: 85,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92277,
    lat: 34.11248,
    lng: -115.68752,
    city: "Twentynine Palms",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24464,
    density: 5.9,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 78.08,
      "06065": 21.92,
    },
    county_names_all: "San Bernardino|Riverside",
    county_fips_all: "06071|06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92278,
    lat: 34.23505,
    lng: -116.05825,
    city: "Twentynine Palms",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5001,
    density: 4919.6,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92280,
    lat: 34.13963,
    lng: -114.84652,
    city: "Vidal",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92281,
    lat: 33.05033,
    lng: -115.61264,
    city: "Westmorland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2865,
    density: 83.8,
    county_fips: "06025",
    county_name: "Imperial",
    county_weights: {
      "06025": 100,
    },
    county_names_all: "Imperial",
    county_fips_all: "06025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92282,
    lat: 33.96253,
    lng: -116.65829,
    city: "Whitewater",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1440,
    density: 7.4,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92283,
    lat: 32.83741,
    lng: -114.79462,
    city: "Winterhaven",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1730,
    density: 2,
    county_fips: "06025",
    county_name: "Imperial",
    county_weights: {
      "06025": 100,
    },
    county_names_all: "Imperial",
    county_fips_all: "06025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92284,
    lat: 34.16013,
    lng: -116.42474,
    city: "Yucca Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25791,
    density: 78.1,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92285,
    lat: 34.33762,
    lng: -116.51364,
    city: "Landers",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2440,
    density: 3.5,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92301,
    lat: 34.65183,
    lng: -117.52617,
    city: "Adelanto",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34791,
    density: 59.8,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92304,
    lat: 34.53062,
    lng: -115.65933,
    city: "Amboy",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7,
    density: 0.1,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92305,
    lat: 34.17018,
    lng: -116.83231,
    city: "Angelus Oaks",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 613,
    density: 2,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92307,
    lat: 34.59078,
    lng: -117.14127,
    city: "Apple Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38848,
    density: 80,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92308,
    lat: 34.42005,
    lng: -117.15558,
    city: "Apple Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42375,
    density: 158.5,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92309,
    lat: 35.24942,
    lng: -116.15578,
    city: "Baker",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 634,
    density: 0.7,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92310,
    lat: 35.33443,
    lng: -116.76306,
    city: "Fort Irwin",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92311,
    lat: 34.97204,
    lng: -117.0101,
    city: "Barstow",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32619,
    density: 29.7,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92313,
    lat: 34.03142,
    lng: -117.31373,
    city: "Grand Terrace",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12559,
    density: 1341.5,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92314,
    lat: 34.2576,
    lng: -116.80075,
    city: "Big Bear City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10684,
    density: 112.7,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92315,
    lat: 34.22011,
    lng: -116.95301,
    city: "Big Bear Lake",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5307,
    density: 69.8,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92316,
    lat: 34.0576,
    lng: -117.39076,
    city: "Bloomington",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29176,
    density: 978.3,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92317,
    lat: 34.24507,
    lng: -117.20874,
    city: "Blue Jay",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92320,
    lat: 33.9874,
    lng: -117.05024,
    city: "Calimesa",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9022,
    density: 249.7,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92321,
    lat: 34.24748,
    lng: -117.14694,
    city: "Cedar Glen",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 907,
    density: 49.2,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92322,
    lat: 34.25419,
    lng: -117.32259,
    city: "Cedarpines Park",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 558,
    density: 65.5,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92324,
    lat: 34.03398,
    lng: -117.29008,
    city: "Colton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59628,
    density: 828.9,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 68.36,
      "06065": 31.64,
    },
    county_names_all: "San Bernardino|Riverside",
    county_fips_all: "06071|06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92325,
    lat: 34.24554,
    lng: -117.27506,
    city: "Crestline",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8647,
    density: 382,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92327,
    lat: 34.86632,
    lng: -116.84347,
    city: "Daggett",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 835,
    density: 13.2,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92328,
    lat: 36.39482,
    lng: -117.02718,
    city: "Death Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 578,
    density: 0.1,
    county_fips: "06027",
    county_name: "Inyo",
    county_weights: {
      "06027": 100,
    },
    county_names_all: "Inyo",
    county_fips_all: "06027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92332,
    lat: 34.90728,
    lng: -115.36409,
    city: "Essex",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 94,
    density: 0,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92333,
    lat: 34.26951,
    lng: -116.96277,
    city: "Fawnskin",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 409,
    density: 15.7,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92335,
    lat: 34.08733,
    lng: -117.46519,
    city: "Fontana",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 99242,
    density: 2194.9,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92336,
    lat: 34.13686,
    lng: -117.46033,
    city: "Fontana",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 98731,
    density: 1917,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92337,
    lat: 34.04967,
    lng: -117.47145,
    city: "Fontana",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39600,
    density: 1116.1,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92338,
    lat: 34.78773,
    lng: -116.25117,
    city: "Ludlow",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92339,
    lat: 34.08189,
    lng: -116.83838,
    city: "Forest Falls",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1382,
    density: 6.8,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92341,
    lat: 34.24009,
    lng: -117.06798,
    city: "Green Valley Lake",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 248,
    density: 9.6,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92342,
    lat: 34.76078,
    lng: -117.33795,
    city: "Helendale",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6725,
    density: 26.4,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92344,
    lat: 34.39176,
    lng: -117.40657,
    city: "Hesperia",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22415,
    density: 230.3,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92345,
    lat: 34.36415,
    lng: -117.30984,
    city: "Hesperia",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 83731,
    density: 327,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92346,
    lat: 34.12629,
    lng: -117.1792,
    city: "Highland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63395,
    density: 902.7,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92347,
    lat: 34.95003,
    lng: -117.25802,
    city: "Hinkley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 683,
    density: 1.5,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92350,
    lat: 34.05296,
    lng: -117.2617,
    city: "Loma Linda",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92352,
    lat: 34.26824,
    lng: -117.18486,
    city: "Lake Arrowhead",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6319,
    density: 211.5,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92354,
    lat: 34.04933,
    lng: -117.25119,
    city: "Loma Linda",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22991,
    density: 1782.7,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92356,
    lat: 34.49633,
    lng: -116.89265,
    city: "Lucerne Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6199,
    density: 6.5,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92358,
    lat: 34.24624,
    lng: -117.56762,
    city: "Lytle Creek",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 701,
    density: 3.7,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92359,
    lat: 34.08296,
    lng: -117.07026,
    city: "Mentone",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9779,
    density: 196.7,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92363,
    lat: 34.70863,
    lng: -114.57562,
    city: "Needles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5374,
    density: 5.6,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92364,
    lat: 35.35678,
    lng: -115.43741,
    city: "Nipton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5,
    density: 0,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92365,
    lat: 34.88843,
    lng: -116.54129,
    city: "Newberry Springs",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2527,
    density: 2,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92368,
    lat: 34.65508,
    lng: -117.30893,
    city: "Oro Grande",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1058,
    density: 8.2,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92369,
    lat: 34.13941,
    lng: -117.21966,
    city: "Patton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92371,
    lat: 34.43837,
    lng: -117.54266,
    city: "Phelan",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20881,
    density: 61,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92372,
    lat: 34.45097,
    lng: -117.62859,
    city: "Pinon Hills",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5796,
    density: 87,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92373,
    lat: 34.00648,
    lng: -117.15351,
    city: "Redlands",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32433,
    density: 314.3,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 58.05,
      "06065": 41.95,
    },
    county_names_all: "San Bernardino|Riverside",
    county_fips_all: "06071|06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92374,
    lat: 34.06738,
    lng: -117.17482,
    city: "Redlands",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44131,
    density: 949.4,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92376,
    lat: 34.11053,
    lng: -117.37997,
    city: "Rialto",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 86719,
    density: 2512.9,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92377,
    lat: 34.15234,
    lng: -117.40412,
    city: "Rialto",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20606,
    density: 1105.9,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92378,
    lat: 34.23206,
    lng: -117.22483,
    city: "Rimforest",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 163,
    density: 78.5,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92382,
    lat: 34.20604,
    lng: -117.11276,
    city: "Running Springs",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4816,
    density: 91.1,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92384,
    lat: 35.98255,
    lng: -116.1505,
    city: "Shoshone",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18,
    density: 0,
    county_fips: "06027",
    county_name: "Inyo",
    county_weights: {
      "06027": 100,
    },
    county_names_all: "Inyo",
    county_fips_all: "06027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92385,
    lat: 34.21345,
    lng: -117.23057,
    city: "Skyforest",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 235,
    density: 9.9,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92386,
    lat: 34.23702,
    lng: -116.82523,
    city: "Sugarloaf",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2038,
    density: 342.6,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92389,
    lat: 35.82902,
    lng: -116.24813,
    city: "Tecopa",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 212,
    density: 1.8,
    county_fips: "06027",
    county_name: "Inyo",
    county_weights: {
      "06027": 100,
    },
    county_names_all: "Inyo",
    county_fips_all: "06027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92391,
    lat: 34.23958,
    lng: -117.23665,
    city: "Twin Peaks",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2263,
    density: 441.6,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92392,
    lat: 34.479,
    lng: -117.40884,
    city: "Victorville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56938,
    density: 589.5,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92394,
    lat: 34.563,
    lng: -117.3542,
    city: "Victorville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34836,
    density: 419.8,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92395,
    lat: 34.50032,
    lng: -117.29479,
    city: "Victorville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45692,
    density: 1044.4,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92397,
    lat: 34.36212,
    lng: -117.69136,
    city: "Wrightwood",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4638,
    density: 37.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 66.3,
      "06071": 33.7,
    },
    county_names_all: "Los Angeles|San Bernardino",
    county_fips_all: "06037|06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92398,
    lat: 34.97178,
    lng: -116.83808,
    city: "Yermo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1643,
    density: 6.3,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92399,
    lat: 34.04469,
    lng: -117.004,
    city: "Yucaipa",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55070,
    density: 396.4,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 99.02,
      "06065": 0.98,
    },
    county_names_all: "San Bernardino|Riverside",
    county_fips_all: "06071|06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92401,
    lat: 34.10586,
    lng: -117.29188,
    city: "San Bernardino",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1971,
    density: 1118.9,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92404,
    lat: 34.17862,
    lng: -117.23891,
    city: "San Bernardino",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63261,
    density: 773.2,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92405,
    lat: 34.14578,
    lng: -117.30225,
    city: "San Bernardino",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30782,
    density: 2372.1,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92407,
    lat: 34.22394,
    lng: -117.38839,
    city: "San Bernardino",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67866,
    density: 320.9,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92408,
    lat: 34.0845,
    lng: -117.2653,
    city: "San Bernardino",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14312,
    density: 527.2,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92410,
    lat: 34.10655,
    lng: -117.29574,
    city: "San Bernardino",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44685,
    density: 2095.1,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92411,
    lat: 34.12214,
    lng: -117.32291,
    city: "San Bernardino",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26361,
    density: 2163,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92415,
    lat: 34.10506,
    lng: -117.28685,
    city: "San Bernardino",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92501,
    lat: 33.99496,
    lng: -117.37367,
    city: "Riverside",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21967,
    density: 1504.2,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92503,
    lat: 33.88308,
    lng: -117.45222,
    city: "Riverside",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 93032,
    density: 1046.4,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92504,
    lat: 33.90607,
    lng: -117.39854,
    city: "Riverside",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62423,
    density: 1062.7,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92505,
    lat: 33.92663,
    lng: -117.4928,
    city: "Riverside",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54706,
    density: 2075.6,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92506,
    lat: 33.93478,
    lng: -117.36689,
    city: "Riverside",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45699,
    density: 1088.6,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92507,
    lat: 33.97464,
    lng: -117.32234,
    city: "Riverside",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59612,
    density: 1075,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92508,
    lat: 33.89039,
    lng: -117.3282,
    city: "Riverside",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38518,
    density: 1353.4,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92509,
    lat: 34.00293,
    lng: -117.44547,
    city: "Jurupa Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 82377,
    density: 1035.4,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 99.44,
      "06071": 0.56,
    },
    county_names_all: "Riverside|San Bernardino",
    county_fips_all: "06065|06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92518,
    lat: 33.89602,
    lng: -117.27705,
    city: "March Air Reserve Base",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1266,
    density: 62.3,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92521,
    lat: 33.96794,
    lng: -117.32731,
    city: "Riverside",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92530,
    lat: 33.63386,
    lng: -117.37949,
    city: "Lake Elsinore",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56442,
    density: 282.6,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 94.77,
      "06059": 5.23,
    },
    county_names_all: "Riverside|Orange",
    county_fips_all: "06065|06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92532,
    lat: 33.69052,
    lng: -117.30241,
    city: "Lake Elsinore",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25333,
    density: 641.7,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92536,
    lat: 33.48791,
    lng: -116.81528,
    city: "Aguanga",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2639,
    density: 9.5,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92539,
    lat: 33.51579,
    lng: -116.64432,
    city: "Anza",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4433,
    density: 13.1,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92543,
    lat: 33.69867,
    lng: -116.97916,
    city: "Hemet",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37492,
    density: 756.2,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92544,
    lat: 33.64581,
    lng: -116.86033,
    city: "Hemet",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50392,
    density: 113.9,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92545,
    lat: 33.7311,
    lng: -117.0359,
    city: "Hemet",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44278,
    density: 574.9,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92548,
    lat: 33.76392,
    lng: -117.10907,
    city: "Homeland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8502,
    density: 250.9,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92549,
    lat: 33.80886,
    lng: -116.71212,
    city: "Idyllwild",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2988,
    density: 10.9,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92551,
    lat: 33.88148,
    lng: -117.22521,
    city: "Moreno Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34441,
    density: 2161.7,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92553,
    lat: 33.92335,
    lng: -117.24532,
    city: "Moreno Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74107,
    density: 2789.3,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92555,
    lat: 33.9133,
    lng: -117.10867,
    city: "Moreno Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46566,
    density: 273.4,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92557,
    lat: 33.96855,
    lng: -117.25704,
    city: "Moreno Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54275,
    density: 1179.3,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92561,
    lat: 33.63704,
    lng: -116.57441,
    city: "Mountain Center",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1471,
    density: 3.5,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92562,
    lat: 33.53579,
    lng: -117.35098,
    city: "Murrieta",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65159,
    density: 228,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 81.48,
      "06073": 18.52,
    },
    county_names_all: "Riverside|San Diego",
    county_fips_all: "06065|06073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92563,
    lat: 33.58435,
    lng: -117.14458,
    city: "Murrieta",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 71394,
    density: 1218.1,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92567,
    lat: 33.82378,
    lng: -117.10305,
    city: "Nuevo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10012,
    density: 116.7,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92570,
    lat: 33.78377,
    lng: -117.31737,
    city: "Perris",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60370,
    density: 219.3,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92571,
    lat: 33.84182,
    lng: -117.19522,
    city: "Perris",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59417,
    density: 586.6,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92582,
    lat: 33.80489,
    lng: -117.01873,
    city: "San Jacinto",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18243,
    density: 382.5,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92583,
    lat: 33.79662,
    lng: -116.93188,
    city: "San Jacinto",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32077,
    density: 425,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92584,
    lat: 33.66167,
    lng: -117.18079,
    city: "Menifee",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54130,
    density: 718.1,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92585,
    lat: 33.74217,
    lng: -117.16723,
    city: "Menifee",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23868,
    density: 538.8,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92586,
    lat: 33.70773,
    lng: -117.20045,
    city: "Menifee",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18615,
    density: 1114.4,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92587,
    lat: 33.69466,
    lng: -117.25196,
    city: "Menifee",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18017,
    density: 972.4,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92590,
    lat: 33.48391,
    lng: -117.22075,
    city: "Temecula",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5215,
    density: 37,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92591,
    lat: 33.53432,
    lng: -117.1092,
    city: "Temecula",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41588,
    density: 932.2,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92592,
    lat: 33.511,
    lng: -117.0242,
    city: "Temecula",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 86115,
    density: 301.8,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92595,
    lat: 33.61638,
    lng: -117.26028,
    city: "Wildomar",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34034,
    density: 610.4,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92596,
    lat: 33.64739,
    lng: -117.07641,
    city: "Winchester",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34743,
    density: 231.5,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92602,
    lat: 33.72645,
    lng: -117.7287,
    city: "Irvine",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21666,
    density: 553.7,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92603,
    lat: 33.62927,
    lng: -117.79408,
    city: "Irvine",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20183,
    density: 780.3,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92604,
    lat: 33.6879,
    lng: -117.7889,
    city: "Irvine",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28330,
    density: 3267.5,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92606,
    lat: 33.69849,
    lng: -117.8123,
    city: "Irvine",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27410,
    density: 3066.5,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92610,
    lat: 33.68336,
    lng: -117.65404,
    city: "Foothill Ranch",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17002,
    density: 1624.7,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92612,
    lat: 33.65984,
    lng: -117.82457,
    city: "Irvine",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32069,
    density: 1936.1,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92614,
    lat: 33.68173,
    lng: -117.83316,
    city: "Irvine",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27471,
    density: 2391.8,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92617,
    lat: 33.64197,
    lng: -117.84103,
    city: "Irvine",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17213,
    density: 2975.3,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92618,
    lat: 33.66729,
    lng: -117.73362,
    city: "Irvine",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54509,
    density: 1017.1,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92620,
    lat: 33.70661,
    lng: -117.75695,
    city: "Irvine",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48360,
    density: 3159.3,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92624,
    lat: 33.46082,
    lng: -117.66656,
    city: "Capistrano Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6376,
    density: 1638.4,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92625,
    lat: 33.60229,
    lng: -117.86551,
    city: "Corona Del Mar",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13149,
    density: 1983.3,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92626,
    lat: 33.67896,
    lng: -117.90844,
    city: "Costa Mesa",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50978,
    density: 2028.4,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92627,
    lat: 33.64786,
    lng: -117.9205,
    city: "Costa Mesa",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62437,
    density: 3767.8,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92629,
    lat: 33.47678,
    lng: -117.70459,
    city: "Dana Point",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27023,
    density: 2061.3,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92630,
    lat: 33.64709,
    lng: -117.68428,
    city: "Lake Forest",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 60804,
    density: 2227.9,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92637,
    lat: 33.60796,
    lng: -117.72799,
    city: "Laguna Woods",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16034,
    density: 2088.1,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92646,
    lat: 33.66525,
    lng: -117.96755,
    city: "Huntington Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56568,
    density: 2713,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92647,
    lat: 33.72395,
    lng: -118.00685,
    city: "Huntington Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61476,
    density: 3149.5,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92648,
    lat: 33.68212,
    lng: -118.0101,
    city: "Huntington Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45328,
    density: 2174.9,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92649,
    lat: 33.72037,
    lng: -118.04423,
    city: "Huntington Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35856,
    density: 2454.2,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92651,
    lat: 33.56535,
    lng: -117.77399,
    city: "Laguna Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23732,
    density: 415.5,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92653,
    lat: 33.59276,
    lng: -117.69994,
    city: "Laguna Hills",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30080,
    density: 1676.6,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92655,
    lat: 33.74606,
    lng: -117.98765,
    city: "Midway City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8730,
    density: 3732.4,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92656,
    lat: 33.57518,
    lng: -117.73036,
    city: "Aliso Viejo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51940,
    density: 2507.3,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92657,
    lat: 33.59571,
    lng: -117.83069,
    city: "Newport Coast",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8988,
    density: 418.1,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92660,
    lat: 33.63375,
    lng: -117.87504,
    city: "Newport Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35409,
    density: 1423.2,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92661,
    lat: 33.60231,
    lng: -117.89872,
    city: "Newport Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3825,
    density: 2268.5,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92662,
    lat: 33.60547,
    lng: -117.89218,
    city: "Newport Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2710,
    density: 5024.1,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92663,
    lat: 33.62328,
    lng: -117.93022,
    city: "Newport Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22721,
    density: 2665.7,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92672,
    lat: 33.3825,
    lng: -117.5403,
    city: "San Clemente",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34659,
    density: 376.3,
    county_fips: "06073",
    county_name: "San Diego",
    county_weights: {
      "06073": 76.36,
      "06059": 23.64,
    },
    county_names_all: "San Diego|Orange",
    county_fips_all: "06073|06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92673,
    lat: 33.46611,
    lng: -117.61204,
    city: "San Clemente",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30634,
    density: 1147.8,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92675,
    lat: 33.49977,
    lng: -117.65366,
    city: "San Juan Capistrano",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39827,
    density: 1148.7,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92676,
    lat: 33.75306,
    lng: -117.63534,
    city: "Silverado",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2033,
    density: 11.3,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92677,
    lat: 33.52777,
    lng: -117.70523,
    city: "Laguna Niguel",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65508,
    density: 1537.9,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92678,
    lat: 33.64627,
    lng: -117.50662,
    city: "Trabuco Canyon",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 555,
    density: 5.6,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92679,
    lat: 33.65274,
    lng: -117.56048,
    city: "Trabuco Canyon",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32784,
    density: 502.8,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92683,
    lat: 33.75242,
    lng: -117.99383,
    city: "Westminster",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 90833,
    density: 3608.1,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92688,
    lat: 33.61737,
    lng: -117.61131,
    city: "Rancho Santa Margarita",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44586,
    density: 1302.2,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92691,
    lat: 33.61051,
    lng: -117.66627,
    city: "Mission Viejo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50033,
    density: 2200.9,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92692,
    lat: 33.60948,
    lng: -117.64396,
    city: "Mission Viejo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47548,
    density: 2136.2,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92694,
    lat: 33.51502,
    lng: -117.58065,
    city: "Ladera Ranch",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26679,
    density: 256.5,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92697,
    lat: 33.65061,
    lng: -117.85091,
    city: "Irvine",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92701,
    lat: 33.7486,
    lng: -117.85877,
    city: "Santa Ana",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54796,
    density: 6561.1,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92703,
    lat: 33.74853,
    lng: -117.90621,
    city: "Santa Ana",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 66428,
    density: 6046.3,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92704,
    lat: 33.72038,
    lng: -117.90807,
    city: "Santa Ana",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 85935,
    density: 4479.4,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92705,
    lat: 33.755,
    lng: -117.81488,
    city: "Santa Ana",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47044,
    density: 1541.1,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92706,
    lat: 33.76602,
    lng: -117.88174,
    city: "Santa Ana",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39080,
    density: 4262.5,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92707,
    lat: 33.70991,
    lng: -117.87045,
    city: "Santa Ana",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62698,
    density: 4633.1,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92708,
    lat: 33.71046,
    lng: -117.95132,
    city: "Fountain Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56811,
    density: 2409.7,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92780,
    lat: 33.73685,
    lng: -117.81968,
    city: "Tustin",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58654,
    density: 3609.4,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92782,
    lat: 33.72833,
    lng: -117.79753,
    city: "Tustin",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23166,
    density: 1730.1,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92801,
    lat: 33.84441,
    lng: -117.95175,
    city: "Anaheim",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65757,
    density: 4036.6,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92802,
    lat: 33.80831,
    lng: -117.9237,
    city: "Anaheim",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44013,
    density: 3732.5,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92804,
    lat: 33.81801,
    lng: -117.97517,
    city: "Anaheim",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 88173,
    density: 4778.1,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92805,
    lat: 33.83003,
    lng: -117.90568,
    city: "Anaheim",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74557,
    density: 4624.2,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92806,
    lat: 33.83884,
    lng: -117.87054,
    city: "Anaheim",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40216,
    density: 2021,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92807,
    lat: 33.85001,
    lng: -117.78946,
    city: "Anaheim",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36057,
    density: 1271.4,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92808,
    lat: 33.85623,
    lng: -117.74018,
    city: "Anaheim",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21787,
    density: 1682.4,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92821,
    lat: 33.92997,
    lng: -117.86986,
    city: "Brea",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39140,
    density: 1069.4,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92823,
    lat: 33.92536,
    lng: -117.80024,
    city: "Brea",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4996,
    density: 258.7,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92831,
    lat: 33.8795,
    lng: -117.89607,
    city: "Fullerton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36211,
    density: 2350.2,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92832,
    lat: 33.86871,
    lng: -117.92914,
    city: "Fullerton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25887,
    density: 3452.3,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92833,
    lat: 33.88051,
    lng: -117.96112,
    city: "Fullerton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52537,
    density: 2645.7,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92835,
    lat: 33.90171,
    lng: -117.91529,
    city: "Fullerton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26115,
    density: 1762.4,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92840,
    lat: 33.78584,
    lng: -117.93202,
    city: "Garden Grove",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54315,
    density: 4072.9,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92841,
    lat: 33.7868,
    lng: -117.98207,
    city: "Garden Grove",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33990,
    density: 2878.5,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92843,
    lat: 33.76399,
    lng: -117.93153,
    city: "Garden Grove",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47823,
    density: 4662.7,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92844,
    lat: 33.76561,
    lng: -117.96952,
    city: "Garden Grove",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22686,
    density: 4171.5,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92845,
    lat: 33.78292,
    lng: -118.0264,
    city: "Garden Grove",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15490,
    density: 2684.4,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92860,
    lat: 33.9262,
    lng: -117.54913,
    city: "Norco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27219,
    density: 744.4,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92861,
    lat: 33.81801,
    lng: -117.81031,
    city: "Villa Park",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5886,
    density: 1087,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92865,
    lat: 33.82887,
    lng: -117.84925,
    city: "Orange",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21003,
    density: 2118.1,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92866,
    lat: 33.78453,
    lng: -117.84479,
    city: "Orange",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15428,
    density: 3124.8,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92867,
    lat: 33.81443,
    lng: -117.79617,
    city: "Orange",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44437,
    density: 1429.5,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92868,
    lat: 33.78799,
    lng: -117.87637,
    city: "Orange",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26549,
    density: 2980.4,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92869,
    lat: 33.79479,
    lng: -117.7621,
    city: "Orange",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36259,
    density: 1039.2,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92870,
    lat: 33.88087,
    lng: -117.85522,
    city: "Placentia",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53194,
    density: 3052.6,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92879,
    lat: 33.87979,
    lng: -117.5357,
    city: "Corona",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49481,
    density: 1944,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92880,
    lat: 33.92096,
    lng: -117.61052,
    city: "Corona",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 72614,
    density: 1071.5,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 92.82,
      "06071": 7.18,
    },
    county_names_all: "Riverside|San Bernardino",
    county_fips_all: "06065|06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92881,
    lat: 33.82163,
    lng: -117.56763,
    city: "Corona",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32694,
    density: 389.1,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92882,
    lat: 33.86367,
    lng: -117.59989,
    city: "Corona",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74742,
    density: 2455.6,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92883,
    lat: 33.75994,
    lng: -117.47827,
    city: "Corona",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36608,
    density: 250.4,
    county_fips: "06065",
    county_name: "Riverside",
    county_weights: {
      "06065": 100,
    },
    county_names_all: "Riverside",
    county_fips_all: "06065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92886,
    lat: 33.89517,
    lng: -117.80154,
    city: "Yorba Linda",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51312,
    density: 1528.3,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 92887,
    lat: 33.88727,
    lng: -117.73389,
    city: "Yorba Linda",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19362,
    density: 662.4,
    county_fips: "06059",
    county_name: "Orange",
    county_weights: {
      "06059": 100,
    },
    county_names_all: "Orange",
    county_fips_all: "06059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93001,
    lat: 34.35321,
    lng: -119.31868,
    city: "Ventura",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31729,
    density: 126.8,
    county_fips: "06111",
    county_name: "Ventura",
    county_weights: {
      "06111": 100,
    },
    county_names_all: "Ventura",
    county_fips_all: "06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93003,
    lat: 34.28434,
    lng: -119.22256,
    city: "Ventura",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51461,
    density: 955.9,
    county_fips: "06111",
    county_name: "Ventura",
    county_weights: {
      "06111": 100,
    },
    county_names_all: "Ventura",
    county_fips_all: "06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93004,
    lat: 34.27901,
    lng: -119.16537,
    city: "Ventura",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31283,
    density: 1718.3,
    county_fips: "06111",
    county_name: "Ventura",
    county_weights: {
      "06111": 100,
    },
    county_names_all: "Ventura",
    county_fips_all: "06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93010,
    lat: 34.23007,
    lng: -119.07437,
    city: "Camarillo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46434,
    density: 815.9,
    county_fips: "06111",
    county_name: "Ventura",
    county_weights: {
      "06111": 100,
    },
    county_names_all: "Ventura",
    county_fips_all: "06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93012,
    lat: 34.20518,
    lng: -118.99309,
    city: "Camarillo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35726,
    density: 275.1,
    county_fips: "06111",
    county_name: "Ventura",
    county_weights: {
      "06111": 100,
    },
    county_names_all: "Ventura",
    county_fips_all: "06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93013,
    lat: 34.42697,
    lng: -119.48032,
    city: "Carpinteria",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17021,
    density: 158.8,
    county_fips: "06083",
    county_name: "Santa Barbara",
    county_weights: {
      "06083": 74.7,
      "06111": 25.3,
    },
    county_names_all: "Santa Barbara|Ventura",
    county_fips_all: "06083|06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93015,
    lat: 34.40969,
    lng: -118.87807,
    city: "Fillmore",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18182,
    density: 75.7,
    county_fips: "06111",
    county_name: "Ventura",
    county_weights: {
      "06111": 100,
    },
    county_names_all: "Ventura",
    county_fips_all: "06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93021,
    lat: 34.30417,
    lng: -118.88274,
    city: "Moorpark",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38235,
    density: 308.9,
    county_fips: "06111",
    county_name: "Ventura",
    county_weights: {
      "06111": 100,
    },
    county_names_all: "Ventura",
    county_fips_all: "06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93022,
    lat: 34.40324,
    lng: -119.29836,
    city: "Oak View",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6607,
    density: 812.6,
    county_fips: "06111",
    county_name: "Ventura",
    county_weights: {
      "06111": 100,
    },
    county_names_all: "Ventura",
    county_fips_all: "06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93023,
    lat: 34.50372,
    lng: -119.24856,
    city: "Ojai",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21011,
    density: 30.4,
    county_fips: "06111",
    county_name: "Ventura",
    county_weights: {
      "06111": 100,
    },
    county_names_all: "Ventura",
    county_fips_all: "06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93030,
    lat: 34.2051,
    lng: -119.1753,
    city: "Oxnard",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59844,
    density: 1637.2,
    county_fips: "06111",
    county_name: "Ventura",
    county_weights: {
      "06111": 100,
    },
    county_names_all: "Ventura",
    county_fips_all: "06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93033,
    lat: 34.15401,
    lng: -119.12296,
    city: "Oxnard",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 84902,
    density: 1018.2,
    county_fips: "06111",
    county_name: "Ventura",
    county_weights: {
      "06111": 100,
    },
    county_names_all: "Ventura",
    county_fips_all: "06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93035,
    lat: 34.19034,
    lng: -119.22879,
    city: "Oxnard",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28426,
    density: 2182.5,
    county_fips: "06111",
    county_name: "Ventura",
    county_weights: {
      "06111": 100,
    },
    county_names_all: "Ventura",
    county_fips_all: "06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93036,
    lat: 34.24911,
    lng: -119.15977,
    city: "Oxnard",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47126,
    density: 1022.3,
    county_fips: "06111",
    county_name: "Ventura",
    county_weights: {
      "06111": 100,
    },
    county_names_all: "Ventura",
    county_fips_all: "06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93040,
    lat: 34.59337,
    lng: -118.93657,
    city: "Piru",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1822,
    density: 1.9,
    county_fips: "06111",
    county_name: "Ventura",
    county_weights: {
      "06111": 100,
    },
    county_names_all: "Ventura",
    county_fips_all: "06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93041,
    lat: 34.14956,
    lng: -119.17458,
    city: "Port Hueneme",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24102,
    density: 1582.9,
    county_fips: "06111",
    county_name: "Ventura",
    county_weights: {
      "06111": 100,
    },
    county_names_all: "Ventura",
    county_fips_all: "06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93042,
    lat: 33.4077,
    lng: -119.43365,
    city: "Point Mugu Nawc",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 124,
    density: 1.7,
    county_fips: "06111",
    county_name: "Ventura",
    county_weights: {
      "06111": 100,
    },
    county_names_all: "Ventura",
    county_fips_all: "06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93043,
    lat: 34.17001,
    lng: -119.2026,
    city: "Port Hueneme Cbc Base",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 82,
    density: 63.9,
    county_fips: "06111",
    county_name: "Ventura",
    county_weights: {
      "06111": 100,
    },
    county_names_all: "Ventura",
    county_fips_all: "06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93060,
    lat: 34.36543,
    lng: -119.09563,
    city: "Santa Paula",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33799,
    density: 141.2,
    county_fips: "06111",
    county_name: "Ventura",
    county_weights: {
      "06111": 100,
    },
    county_names_all: "Ventura",
    county_fips_all: "06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93063,
    lat: 34.30922,
    lng: -118.69041,
    city: "Simi Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56259,
    density: 600.6,
    county_fips: "06111",
    county_name: "Ventura",
    county_weights: {
      "06111": 100,
    },
    county_names_all: "Ventura",
    county_fips_all: "06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93064,
    lat: 34.24527,
    lng: -118.69984,
    city: "Brandeis",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "06111",
    county_name: "Ventura",
    county_weights: {
      "06111": 100,
    },
    county_names_all: "Ventura",
    county_fips_all: "06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93065,
    lat: 34.26206,
    lng: -118.77151,
    city: "Simi Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 71906,
    density: 931.6,
    county_fips: "06111",
    county_name: "Ventura",
    county_weights: {
      "06111": 100,
    },
    county_names_all: "Ventura",
    county_fips_all: "06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93066,
    lat: 34.28851,
    lng: -119.02848,
    city: "Somis",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2925,
    density: 26.8,
    county_fips: "06111",
    county_name: "Ventura",
    county_weights: {
      "06111": 100,
    },
    county_names_all: "Ventura",
    county_fips_all: "06111",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93067,
    lat: 34.42162,
    lng: -119.59277,
    city: "Summerland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 369,
    density: 245.3,
    county_fips: "06083",
    county_name: "Santa Barbara",
    county_weights: {
      "06083": 100,
    },
    county_names_all: "Santa Barbara",
    county_fips_all: "06083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93101,
    lat: 34.41925,
    lng: -119.70808,
    city: "Santa Barbara",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32650,
    density: 3936.5,
    county_fips: "06083",
    county_name: "Santa Barbara",
    county_weights: {
      "06083": 100,
    },
    county_names_all: "Santa Barbara",
    county_fips_all: "06083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93103,
    lat: 34.43888,
    lng: -119.68173,
    city: "Santa Barbara",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20542,
    density: 1444.8,
    county_fips: "06083",
    county_name: "Santa Barbara",
    county_weights: {
      "06083": 100,
    },
    county_names_all: "Santa Barbara",
    county_fips_all: "06083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93105,
    lat: 34.52702,
    lng: -119.76082,
    city: "Santa Barbara",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26933,
    density: 74.4,
    county_fips: "06083",
    county_name: "Santa Barbara",
    county_weights: {
      "06083": 100,
    },
    county_names_all: "Santa Barbara",
    county_fips_all: "06083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93106,
    lat: 34.41719,
    lng: -119.85111,
    city: "Santa Barbara",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06083",
    county_name: "Santa Barbara",
    county_weights: {
      "06083": 100,
    },
    county_names_all: "Santa Barbara",
    county_fips_all: "06083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93108,
    lat: 34.44934,
    lng: -119.60397,
    city: "Santa Barbara",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10451,
    density: 144.8,
    county_fips: "06083",
    county_name: "Santa Barbara",
    county_weights: {
      "06083": 100,
    },
    county_names_all: "Santa Barbara",
    county_fips_all: "06083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93109,
    lat: 34.40662,
    lng: -119.72682,
    city: "Santa Barbara",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11289,
    density: 1269.6,
    county_fips: "06083",
    county_name: "Santa Barbara",
    county_weights: {
      "06083": 100,
    },
    county_names_all: "Santa Barbara",
    county_fips_all: "06083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93110,
    lat: 34.43913,
    lng: -119.7666,
    city: "Santa Barbara",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15777,
    density: 753.4,
    county_fips: "06083",
    county_name: "Santa Barbara",
    county_weights: {
      "06083": 100,
    },
    county_names_all: "Santa Barbara",
    county_fips_all: "06083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93111,
    lat: 34.44932,
    lng: -119.80223,
    city: "Santa Barbara",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18468,
    density: 876.5,
    county_fips: "06083",
    county_name: "Santa Barbara",
    county_weights: {
      "06083": 100,
    },
    county_names_all: "Santa Barbara",
    county_fips_all: "06083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93117,
    lat: 34.49102,
    lng: -120.08201,
    city: "Goleta",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59298,
    density: 136.2,
    county_fips: "06083",
    county_name: "Santa Barbara",
    county_weights: {
      "06083": 100,
    },
    county_names_all: "Santa Barbara",
    county_fips_all: "06083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93201,
    lat: 35.8555,
    lng: -119.48338,
    city: "Alpaugh",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1251,
    density: 6.7,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 85.8,
      "06031": 14.2,
    },
    county_names_all: "Tulare|Kings",
    county_fips_all: "06107|06031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93202,
    lat: 36.3187,
    lng: -119.7076,
    city: "Armona",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4236,
    density: 1064.4,
    county_fips: "06031",
    county_name: "Kings",
    county_weights: {
      "06031": 100,
    },
    county_names_all: "Kings",
    county_fips_all: "06031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93203,
    lat: 35.12158,
    lng: -118.8468,
    city: "Arvin",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22546,
    density: 50.6,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93204,
    lat: 35.90819,
    lng: -120.06776,
    city: "Avenal",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13033,
    density: 71.3,
    county_fips: "06031",
    county_name: "Kings",
    county_weights: {
      "06031": 100,
    },
    county_names_all: "Kings",
    county_fips_all: "06031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93205,
    lat: 35.5387,
    lng: -118.45463,
    city: "Bodfish",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2164,
    density: 36,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93206,
    lat: 35.44402,
    lng: -119.47578,
    city: "Buttonwillow",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1741,
    density: 4.1,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93207,
    lat: 35.88721,
    lng: -118.63153,
    city: "California Hot Springs",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 216,
    density: 1.6,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93208,
    lat: 36.1298,
    lng: -118.63982,
    city: "Camp Nelson",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 110,
    density: 5.5,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93210,
    lat: 36.19519,
    lng: -120.43245,
    city: "Coalinga",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18339,
    density: 9.1,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 90.26,
      "06053": 6.38,
      "06069": 3.36,
    },
    county_names_all: "Fresno|Monterey|San Benito",
    county_fips_all: "06019|06053|06069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93212,
    lat: 36.01649,
    lng: -119.56937,
    city: "Corcoran",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22596,
    density: 73.6,
    county_fips: "06031",
    county_name: "Kings",
    county_weights: {
      "06031": 60.72,
      "06107": 39.28,
    },
    county_names_all: "Kings|Tulare",
    county_fips_all: "06031|06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93215,
    lat: 35.7764,
    lng: -119.18835,
    city: "Delano",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55648,
    density: 147.7,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 59.64,
      "06107": 40.36,
    },
    county_names_all: "Kern|Tulare",
    county_fips_all: "06029|06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93218,
    lat: 35.86194,
    lng: -119.03822,
    city: "Ducor",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 827,
    density: 4.9,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93219,
    lat: 35.87908,
    lng: -119.28818,
    city: "Earlimart",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10998,
    density: 41.3,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93220,
    lat: 35.3705,
    lng: -118.78369,
    city: "Edison",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45,
    density: 0.6,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93221,
    lat: 36.29637,
    lng: -119.02992,
    city: "Exeter",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14596,
    density: 42.7,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93222,
    lat: 34.89835,
    lng: -119.25983,
    city: "Pine Mountain Club",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1812,
    density: 6.4,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93223,
    lat: 36.30117,
    lng: -119.20789,
    city: "Farmersville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10842,
    density: 1349.1,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93224,
    lat: 35.21687,
    lng: -119.58087,
    city: "Fellows",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 364,
    density: 3.9,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93225,
    lat: 34.78532,
    lng: -119.04196,
    city: "Frazier Park",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5538,
    density: 19.1,
    county_fips: "06111",
    county_name: "Ventura",
    county_weights: {
      "06111": 64.02,
      "06029": 35.98,
    },
    county_names_all: "Ventura|Kern",
    county_fips_all: "06111|06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93226,
    lat: 35.7476,
    lng: -118.73462,
    city: "Glennville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 82,
    density: 0.4,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93227,
    lat: 36.34441,
    lng: -119.41856,
    city: "Goshen",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93230,
    lat: 36.28967,
    lng: -119.62514,
    city: "Hanford",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68896,
    density: 103.1,
    county_fips: "06031",
    county_name: "Kings",
    county_weights: {
      "06031": 99.6,
      "06107": 0.4,
    },
    county_names_all: "Kings|Tulare",
    county_fips_all: "06031|06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93234,
    lat: 36.19608,
    lng: -120.08477,
    city: "Huron",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7258,
    density: 20.8,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93235,
    lat: 36.38507,
    lng: -119.22314,
    city: "Ivanhoe",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4561,
    density: 424.5,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93237,
    lat: 36.47452,
    lng: -118.90426,
    city: "Kaweah",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93238,
    lat: 35.82799,
    lng: -118.47137,
    city: "Kernville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 810,
    density: 2.9,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 62.55,
      "06029": 37.45,
    },
    county_names_all: "Tulare|Kern",
    county_fips_all: "06107|06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93239,
    lat: 36.03293,
    lng: -119.98645,
    city: "Kettleman City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1785,
    density: 11.8,
    county_fips: "06031",
    county_name: "Kings",
    county_weights: {
      "06031": 100,
    },
    county_names_all: "Kings",
    county_fips_all: "06031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93240,
    lat: 35.62425,
    lng: -118.4645,
    city: "Lake Isabella",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6096,
    density: 40.6,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93241,
    lat: 35.24922,
    lng: -118.91224,
    city: "Lamont",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16988,
    density: 1299.3,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93242,
    lat: 36.44115,
    lng: -119.73024,
    city: "Laton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3455,
    density: 32.8,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 83.05,
      "06031": 16.95,
    },
    county_names_all: "Fresno|Kings",
    county_fips_all: "06019|06031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93243,
    lat: 34.84057,
    lng: -118.81769,
    city: "Lebec",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1513,
    density: 3.6,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 63.73,
      "06037": 36.27,
    },
    county_names_all: "Kern|Los Angeles",
    county_fips_all: "06029|06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93244,
    lat: 36.3908,
    lng: -118.99733,
    city: "Lemon Cove",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 326,
    density: 16,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93245,
    lat: 36.28614,
    lng: -119.83405,
    city: "Lemoore",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38275,
    density: 124.3,
    county_fips: "06031",
    county_name: "Kings",
    county_weights: {
      "06031": 100,
    },
    county_names_all: "Kings",
    county_fips_all: "06031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93246,
    lat: 36.31921,
    lng: -119.93135,
    city: "Lemoore",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06031",
    county_name: "Kings",
    county_weights: {
      "06031": 100,
    },
    county_names_all: "Kings",
    county_fips_all: "06031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93247,
    lat: 36.20234,
    lng: -119.08277,
    city: "Lindsay",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17334,
    density: 101.7,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93249,
    lat: 35.67033,
    lng: -119.85814,
    city: "Lost Hills",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1959,
    density: 3.7,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93250,
    lat: 35.66456,
    lng: -119.20278,
    city: "McFarland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14689,
    density: 63.3,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93251,
    lat: 35.37059,
    lng: -119.69735,
    city: "McKittrick",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 237,
    density: 0.9,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93252,
    lat: 34.80685,
    lng: -119.34664,
    city: "Maricopa",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3180,
    density: 2.7,
    county_fips: "06111",
    county_name: "Ventura",
    county_weights: {
      "06111": 66.05,
      "06029": 18.03,
      "06083": 9.82,
      "06079": 6.1,
    },
    county_names_all: "Ventura|Kern|Santa Barbara|San Luis Obispo",
    county_fips_all: "06111|06029|06083|06079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93254,
    lat: 34.92498,
    lng: -119.74834,
    city: "New Cuyama",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 757,
    density: 1.5,
    county_fips: "06083",
    county_name: "Santa Barbara",
    county_weights: {
      "06083": 91.24,
      "06079": 8.76,
    },
    county_names_all: "Santa Barbara|San Luis Obispo",
    county_fips_all: "06083|06079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93255,
    lat: 35.68292,
    lng: -118.0798,
    city: "Onyx",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 854,
    density: 1.4,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93256,
    lat: 35.96805,
    lng: -119.31251,
    city: "Pixley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5811,
    density: 30.1,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93257,
    lat: 35.98708,
    lng: -118.89493,
    city: "Porterville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75483,
    density: 76.9,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93258,
    lat: 36.05833,
    lng: -119.15209,
    city: "Porterville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1366,
    density: 540.8,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93260,
    lat: 35.81909,
    lng: -118.66116,
    city: "Posey",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 244,
    density: 2.5,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93261,
    lat: 35.81147,
    lng: -119.11673,
    city: "Richgrove",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2179,
    density: 145.7,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93262,
    lat: 36.50256,
    lng: -118.68109,
    city: "Sequoia National Park",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45,
    density: 0.1,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93263,
    lat: 35.48722,
    lng: -119.27835,
    city: "Shafter",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21854,
    density: 91.5,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93265,
    lat: 36.20713,
    lng: -118.70876,
    city: "Springville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3230,
    density: 3.2,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93266,
    lat: 36.17176,
    lng: -119.85628,
    city: "Stratford",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1086,
    density: 7.1,
    county_fips: "06031",
    county_name: "Kings",
    county_weights: {
      "06031": 100,
    },
    county_names_all: "Kings",
    county_fips_all: "06031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93267,
    lat: 36.14279,
    lng: -119.0742,
    city: "Strathmore",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6325,
    density: 39.6,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93268,
    lat: 35.16725,
    lng: -119.40785,
    city: "Taft",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18389,
    density: 104.2,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93270,
    lat: 35.94703,
    lng: -119.05669,
    city: "Terra Bella",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5538,
    density: 31.7,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93271,
    lat: 36.43661,
    lng: -118.86903,
    city: "Three Rivers",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2699,
    density: 6.8,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93272,
    lat: 36.04818,
    lng: -119.34535,
    city: "Tipton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4925,
    density: 22.6,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93274,
    lat: 36.17978,
    lng: -119.37949,
    city: "Tulare",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75068,
    density: 132.2,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 95.45,
      "06031": 4.55,
    },
    county_names_all: "Tulare|Kings",
    county_fips_all: "06107|06031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93276,
    lat: 35.31756,
    lng: -119.4092,
    city: "Tupman",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 134,
    density: 12.1,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93277,
    lat: 36.29963,
    lng: -119.38139,
    city: "Visalia",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53114,
    density: 520.1,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93280,
    lat: 35.65204,
    lng: -119.44716,
    city: "Wasco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28394,
    density: 34.7,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93283,
    lat: 35.58478,
    lng: -118.28854,
    city: "Weldon",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2216,
    density: 3.3,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93285,
    lat: 35.72233,
    lng: -118.50871,
    city: "Wofford Heights",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2009,
    density: 14.3,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93286,
    lat: 36.45149,
    lng: -119.1079,
    city: "Woodlake",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10466,
    density: 55.7,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93287,
    lat: 35.72387,
    lng: -118.91958,
    city: "Woody",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75,
    density: 0.4,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93291,
    lat: 36.38931,
    lng: -119.36838,
    city: "Visalia",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58394,
    density: 267.8,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93292,
    lat: 36.3763,
    lng: -119.22183,
    city: "Visalia",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42769,
    density: 143.9,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93301,
    lat: 35.38428,
    lng: -119.02057,
    city: "Bakersfield",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12624,
    density: 1137.4,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93304,
    lat: 35.33938,
    lng: -119.02368,
    city: "Bakersfield",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46922,
    density: 2424,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93305,
    lat: 35.38989,
    lng: -118.98515,
    city: "Bakersfield",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38682,
    density: 2581.4,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93306,
    lat: 35.46595,
    lng: -118.78445,
    city: "Bakersfield",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74296,
    density: 294.7,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93307,
    lat: 35.2487,
    lng: -118.93253,
    city: "Bakersfield",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 86273,
    density: 235.9,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93308,
    lat: 35.5498,
    lng: -118.93389,
    city: "Bakersfield",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55211,
    density: 61.9,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93309,
    lat: 35.34266,
    lng: -119.06461,
    city: "Bakersfield",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58709,
    density: 2168.8,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93311,
    lat: 35.15378,
    lng: -119.16567,
    city: "Bakersfield",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46618,
    density: 84.5,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93312,
    lat: 35.39186,
    lng: -119.11954,
    city: "Bakersfield",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59200,
    density: 1612.9,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93313,
    lat: 35.16363,
    lng: -119.04715,
    city: "Bakersfield",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57200,
    density: 219.6,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93314,
    lat: 35.385,
    lng: -119.23741,
    city: "Bakersfield",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30805,
    density: 133.7,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93401,
    lat: 35.23539,
    lng: -120.61834,
    city: "San Luis Obispo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28751,
    density: 173,
    county_fips: "06079",
    county_name: "San Luis Obispo",
    county_weights: {
      "06079": 100,
    },
    county_names_all: "San Luis Obispo",
    county_fips_all: "06079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93402,
    lat: 35.29082,
    lng: -120.8392,
    city: "Los Osos",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16198,
    density: 225.4,
    county_fips: "06079",
    county_name: "San Luis Obispo",
    county_weights: {
      "06079": 100,
    },
    county_names_all: "San Luis Obispo",
    county_fips_all: "06079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93405,
    lat: 35.29672,
    lng: -120.72618,
    city: "San Luis Obispo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36285,
    density: 156.2,
    county_fips: "06079",
    county_name: "San Luis Obispo",
    county_weights: {
      "06079": 100,
    },
    county_names_all: "San Luis Obispo",
    county_fips_all: "06079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93407,
    lat: 35.30747,
    lng: -120.66986,
    city: "San Luis Obispo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06079",
    county_name: "San Luis Obispo",
    county_weights: {
      "06079": 100,
    },
    county_names_all: "San Luis Obispo",
    county_fips_all: "06079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93408,
    lat: 35.32117,
    lng: -120.71889,
    city: "San Luis Obispo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06079",
    county_name: "San Luis Obispo",
    county_weights: {
      "06079": 100,
    },
    county_names_all: "San Luis Obispo",
    county_fips_all: "06079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93409,
    lat: 35.32352,
    lng: -120.69743,
    city: "San Luis Obispo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06079",
    county_name: "San Luis Obispo",
    county_weights: {
      "06079": 100,
    },
    county_names_all: "San Luis Obispo",
    county_fips_all: "06079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93410,
    lat: 35.30428,
    lng: -120.65683,
    city: "San Luis Obispo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06079",
    county_name: "San Luis Obispo",
    county_weights: {
      "06079": 100,
    },
    county_names_all: "San Luis Obispo",
    county_fips_all: "06079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93420,
    lat: 35.16682,
    lng: -120.46617,
    city: "Arroyo Grande",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29915,
    density: 58.5,
    county_fips: "06079",
    county_name: "San Luis Obispo",
    county_weights: {
      "06079": 100,
    },
    county_names_all: "San Luis Obispo",
    county_fips_all: "06079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93422,
    lat: 35.4638,
    lng: -120.69007,
    city: "Atascadero",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34005,
    density: 190.9,
    county_fips: "06079",
    county_name: "San Luis Obispo",
    county_weights: {
      "06079": 100,
    },
    county_names_all: "San Luis Obispo",
    county_fips_all: "06079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93424,
    lat: 35.20141,
    lng: -120.78394,
    city: "Avila Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 955,
    density: 18.3,
    county_fips: "06079",
    county_name: "San Luis Obispo",
    county_weights: {
      "06079": 100,
    },
    county_names_all: "San Luis Obispo",
    county_fips_all: "06079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93426,
    lat: 35.84682,
    lng: -120.97233,
    city: "Bradley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1717,
    density: 3.1,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 81.29,
      "06079": 18.71,
    },
    county_names_all: "Monterey|San Luis Obispo",
    county_fips_all: "06053|06079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93427,
    lat: 34.62724,
    lng: -120.22465,
    city: "Buellton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6195,
    density: 34.4,
    county_fips: "06083",
    county_name: "Santa Barbara",
    county_weights: {
      "06083": 100,
    },
    county_names_all: "Santa Barbara",
    county_fips_all: "06083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93428,
    lat: 35.58995,
    lng: -121.02943,
    city: "Cambria",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5758,
    density: 28.8,
    county_fips: "06079",
    county_name: "San Luis Obispo",
    county_weights: {
      "06079": 100,
    },
    county_names_all: "San Luis Obispo",
    county_fips_all: "06079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93429,
    lat: 34.86682,
    lng: -120.53582,
    city: "Casmalia",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 88,
    density: 4.9,
    county_fips: "06083",
    county_name: "Santa Barbara",
    county_weights: {
      "06083": 100,
    },
    county_names_all: "Santa Barbara",
    county_fips_all: "06083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93430,
    lat: 35.49214,
    lng: -120.92422,
    city: "Cayucos",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2681,
    density: 14.4,
    county_fips: "06079",
    county_name: "San Luis Obispo",
    county_weights: {
      "06079": 100,
    },
    county_names_all: "San Luis Obispo",
    county_fips_all: "06079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93432,
    lat: 35.47686,
    lng: -120.47228,
    city: "Creston",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1112,
    density: 5.1,
    county_fips: "06079",
    county_name: "San Luis Obispo",
    county_weights: {
      "06079": 100,
    },
    county_names_all: "San Luis Obispo",
    county_fips_all: "06079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93433,
    lat: 35.12045,
    lng: -120.61894,
    city: "Grover Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13481,
    density: 2405,
    county_fips: "06079",
    county_name: "San Luis Obispo",
    county_weights: {
      "06079": 100,
    },
    county_names_all: "San Luis Obispo",
    county_fips_all: "06079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93434,
    lat: 34.94086,
    lng: -120.6113,
    city: "Guadalupe",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7654,
    density: 129.6,
    county_fips: "06083",
    county_name: "Santa Barbara",
    county_weights: {
      "06083": 98.79,
      "06079": 1.21,
    },
    county_names_all: "Santa Barbara|San Luis Obispo",
    county_fips_all: "06083|06079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93436,
    lat: 34.60888,
    lng: -120.4002,
    city: "Lompoc",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55727,
    density: 94.4,
    county_fips: "06083",
    county_name: "Santa Barbara",
    county_weights: {
      "06083": 100,
    },
    county_names_all: "Santa Barbara",
    county_fips_all: "06083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93437,
    lat: 34.76049,
    lng: -120.51102,
    city: "Lompoc",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3646,
    density: 28.4,
    county_fips: "06083",
    county_name: "Santa Barbara",
    county_weights: {
      "06083": 100,
    },
    county_names_all: "Santa Barbara",
    county_fips_all: "06083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93440,
    lat: 34.74606,
    lng: -120.25292,
    city: "Los Alamos",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1355,
    density: 11.9,
    county_fips: "06083",
    county_name: "Santa Barbara",
    county_weights: {
      "06083": 100,
    },
    county_names_all: "Santa Barbara",
    county_fips_all: "06083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93441,
    lat: 34.73296,
    lng: -120.09721,
    city: "Los Olivos",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 861,
    density: 8.6,
    county_fips: "06083",
    county_name: "Santa Barbara",
    county_weights: {
      "06083": 100,
    },
    county_names_all: "Santa Barbara",
    county_fips_all: "06083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93442,
    lat: 35.4,
    lng: -120.80495,
    city: "Morro Bay",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10955,
    density: 95,
    county_fips: "06079",
    county_name: "San Luis Obispo",
    county_weights: {
      "06079": 100,
    },
    county_names_all: "San Luis Obispo",
    county_fips_all: "06079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93444,
    lat: 35.03553,
    lng: -120.50293,
    city: "Nipomo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22383,
    density: 132.1,
    county_fips: "06079",
    county_name: "San Luis Obispo",
    county_weights: {
      "06079": 100,
    },
    county_names_all: "San Luis Obispo",
    county_fips_all: "06079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93445,
    lat: 35.03319,
    lng: -120.62002,
    city: "Oceano",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7327,
    density: 166.2,
    county_fips: "06079",
    county_name: "San Luis Obispo",
    county_weights: {
      "06079": 100,
    },
    county_names_all: "San Luis Obispo",
    county_fips_all: "06079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93446,
    lat: 35.65861,
    lng: -120.71888,
    city: "Paso Robles",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44960,
    density: 40.5,
    county_fips: "06079",
    county_name: "San Luis Obispo",
    county_weights: {
      "06079": 100,
    },
    county_names_all: "San Luis Obispo",
    county_fips_all: "06079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93449,
    lat: 35.15803,
    lng: -120.6504,
    city: "Pismo Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8042,
    density: 313.4,
    county_fips: "06079",
    county_name: "San Luis Obispo",
    county_weights: {
      "06079": 100,
    },
    county_names_all: "San Luis Obispo",
    county_fips_all: "06079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93450,
    lat: 36.05791,
    lng: -120.82894,
    city: "San Ardo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 856,
    density: 1.8,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 100,
    },
    county_names_all: "Monterey",
    county_fips_all: "06053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93451,
    lat: 35.89398,
    lng: -120.56733,
    city: "San Miguel",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4233,
    density: 3.7,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 84.85,
      "06079": 15.15,
    },
    county_names_all: "Monterey|San Luis Obispo",
    county_fips_all: "06053|06079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93452,
    lat: 35.71078,
    lng: -121.20396,
    city: "San Simeon",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 550,
    density: 1.9,
    county_fips: "06079",
    county_name: "San Luis Obispo",
    county_weights: {
      "06079": 100,
    },
    county_names_all: "San Luis Obispo",
    county_fips_all: "06079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93453,
    lat: 35.31339,
    lng: -120.1655,
    city: "Santa Margarita",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2414,
    density: 1.3,
    county_fips: "06079",
    county_name: "San Luis Obispo",
    county_weights: {
      "06079": 100,
    },
    county_names_all: "San Luis Obispo",
    county_fips_all: "06079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93454,
    lat: 34.94834,
    lng: -120.23425,
    city: "Santa Maria",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40600,
    density: 37.5,
    county_fips: "06083",
    county_name: "Santa Barbara",
    county_weights: {
      "06083": 71.83,
      "06079": 28.17,
    },
    county_names_all: "Santa Barbara|San Luis Obispo",
    county_fips_all: "06083|06079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93455,
    lat: 34.84195,
    lng: -120.45522,
    city: "Santa Maria",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45246,
    density: 147.6,
    county_fips: "06083",
    county_name: "Santa Barbara",
    county_weights: {
      "06083": 100,
    },
    county_names_all: "Santa Barbara",
    county_fips_all: "06083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93458,
    lat: 34.95477,
    lng: -120.49042,
    city: "Santa Maria",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56572,
    density: 768.7,
    county_fips: "06083",
    county_name: "Santa Barbara",
    county_weights: {
      "06083": 99.84,
      "06079": 0.16,
    },
    county_names_all: "Santa Barbara|San Luis Obispo",
    county_fips_all: "06083|06079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93460,
    lat: 34.66214,
    lng: -119.90091,
    city: "Santa Ynez",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6023,
    density: 10.6,
    county_fips: "06083",
    county_name: "Santa Barbara",
    county_weights: {
      "06083": 100,
    },
    county_names_all: "Santa Barbara",
    county_fips_all: "06083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93461,
    lat: 35.63519,
    lng: -120.26951,
    city: "Shandon",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1437,
    density: 1.9,
    county_fips: "06079",
    county_name: "San Luis Obispo",
    county_weights: {
      "06079": 90.85,
      "06029": 9.15,
    },
    county_names_all: "San Luis Obispo|Kern",
    county_fips_all: "06079|06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93463,
    lat: 34.60688,
    lng: -120.13495,
    city: "Solvang",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7846,
    density: 89.4,
    county_fips: "06083",
    county_name: "Santa Barbara",
    county_weights: {
      "06083": 100,
    },
    county_names_all: "Santa Barbara",
    county_fips_all: "06083",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93465,
    lat: 35.54267,
    lng: -120.73417,
    city: "Templeton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9465,
    density: 43.2,
    county_fips: "06079",
    county_name: "San Luis Obispo",
    county_weights: {
      "06079": 100,
    },
    county_names_all: "San Luis Obispo",
    county_fips_all: "06079",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93501,
    lat: 35.0411,
    lng: -118.22922,
    city: "Mojave",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4798,
    density: 8.3,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93505,
    lat: 35.15708,
    lng: -117.90934,
    city: "California City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13993,
    density: 83.1,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93510,
    lat: 34.45627,
    lng: -118.2109,
    city: "Acton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7433,
    density: 35.8,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93512,
    lat: 37.87379,
    lng: -118.53455,
    city: "Benton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 244,
    density: 0.9,
    county_fips: "06051",
    county_name: "Mono",
    county_weights: {
      "06051": 100,
    },
    county_names_all: "Mono",
    county_fips_all: "06051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93513,
    lat: 37.18401,
    lng: -118.17129,
    city: "Big Pine",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1461,
    density: 1.4,
    county_fips: "06027",
    county_name: "Inyo",
    county_weights: {
      "06027": 100,
    },
    county_names_all: "Inyo",
    county_fips_all: "06027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93514,
    lat: 37.4947,
    lng: -118.38514,
    city: "Bishop",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14423,
    density: 5.5,
    county_fips: "06051",
    county_name: "Mono",
    county_weights: {
      "06051": 56.23,
      "06027": 43.77,
    },
    county_names_all: "Mono|Inyo",
    county_fips_all: "06051|06027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93516,
    lat: 35.0081,
    lng: -117.64268,
    city: "Boron",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2406,
    density: 32.5,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 52.03,
      "06071": 47.97,
    },
    county_names_all: "Kern|San Bernardino",
    county_fips_all: "06029|06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93517,
    lat: 38.27091,
    lng: -119.27372,
    city: "Bridgeport",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 627,
    density: 0.7,
    county_fips: "06051",
    county_name: "Mono",
    county_weights: {
      "06051": 100,
    },
    county_names_all: "Mono",
    county_fips_all: "06051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93518,
    lat: 35.37675,
    lng: -118.47314,
    city: "Caliente",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 833,
    density: 1,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93519,
    lat: 35.3171,
    lng: -117.95596,
    city: "Cantil",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93522,
    lat: 36.29836,
    lng: -117.59681,
    city: "Darwin",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 90,
    density: 0.7,
    county_fips: "06027",
    county_name: "Inyo",
    county_weights: {
      "06027": 100,
    },
    county_names_all: "Inyo",
    county_fips_all: "06027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93523,
    lat: 34.99788,
    lng: -117.88308,
    city: "Edwards",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3681,
    density: 37.5,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93524,
    lat: 34.90993,
    lng: -117.85007,
    city: "Edwards",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93526,
    lat: 36.85941,
    lng: -118.25378,
    city: "Independence",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 767,
    density: 5.5,
    county_fips: "06027",
    county_name: "Inyo",
    county_weights: {
      "06027": 100,
    },
    county_names_all: "Inyo",
    county_fips_all: "06027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93527,
    lat: 35.80294,
    lng: -117.98504,
    city: "Inyokern",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1690,
    density: 1.9,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 50.78,
      "06029": 34.7,
      "06027": 14.52,
    },
    county_names_all: "Tulare|Kern|Inyo",
    county_fips_all: "06107|06029|06027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93528,
    lat: 35.37194,
    lng: -117.64193,
    city: "Johannesburg",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48,
    density: 7.6,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93529,
    lat: 37.7832,
    lng: -119.1375,
    city: "June Lake",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 413,
    density: 2.1,
    county_fips: "06051",
    county_name: "Mono",
    county_weights: {
      "06051": 100,
    },
    county_names_all: "Mono",
    county_fips_all: "06051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93530,
    lat: 36.48458,
    lng: -117.87201,
    city: "Keeler",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6,
    density: 2,
    county_fips: "06027",
    county_name: "Inyo",
    county_weights: {
      "06027": 100,
    },
    county_names_all: "Inyo",
    county_fips_all: "06027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93531,
    lat: 35.22937,
    lng: -118.60781,
    city: "Keene",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 371,
    density: 7.3,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93532,
    lat: 34.68571,
    lng: -118.55914,
    city: "Lake Hughes",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2637,
    density: 8.3,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93534,
    lat: 34.71759,
    lng: -118.15079,
    city: "Lancaster",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39798,
    density: 810.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93535,
    lat: 34.69908,
    lng: -117.89613,
    city: "Lancaster",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74944,
    density: 121.1,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93536,
    lat: 34.75267,
    lng: -118.3889,
    city: "Lancaster",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68575,
    density: 104.1,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 94.84,
      "06029": 5.16,
    },
    county_names_all: "Los Angeles|Kern",
    county_fips_all: "06037|06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93541,
    lat: 37.99678,
    lng: -119.01847,
    city: "Lee Vining",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 266,
    density: 0.3,
    county_fips: "06051",
    county_name: "Mono",
    county_weights: {
      "06051": 100,
    },
    county_names_all: "Mono",
    county_fips_all: "06051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93543,
    lat: 34.47916,
    lng: -117.97357,
    city: "Littlerock",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14605,
    density: 83.3,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93544,
    lat: 34.49063,
    lng: -117.75505,
    city: "Llano",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1086,
    density: 3.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93545,
    lat: 36.6046,
    lng: -118.02721,
    city: "Lone Pine",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1522,
    density: 1.5,
    county_fips: "06027",
    county_name: "Inyo",
    county_weights: {
      "06027": 100,
    },
    county_names_all: "Inyo",
    county_fips_all: "06027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93546,
    lat: 37.60573,
    lng: -118.85219,
    city: "Mammoth Lakes",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9750,
    density: 16,
    county_fips: "06051",
    county_name: "Mono",
    county_weights: {
      "06051": 100,
    },
    county_names_all: "Mono",
    county_fips_all: "06051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93549,
    lat: 36.27728,
    lng: -117.96016,
    city: "Olancha",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 273,
    density: 0.2,
    county_fips: "06027",
    county_name: "Inyo",
    county_weights: {
      "06027": 100,
    },
    county_names_all: "Inyo",
    county_fips_all: "06027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93550,
    lat: 34.38305,
    lng: -118.04926,
    city: "Palmdale",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75617,
    density: 112.6,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93551,
    lat: 34.59404,
    lng: -118.22634,
    city: "Palmdale",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50978,
    density: 232.2,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93552,
    lat: 34.58412,
    lng: -118.02386,
    city: "Palmdale",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39776,
    density: 399.5,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93553,
    lat: 34.44515,
    lng: -117.89611,
    city: "Pearblossom",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1513,
    density: 10.2,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93554,
    lat: 35.36914,
    lng: -117.75876,
    city: "Randsburg",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 99,
    density: 0.3,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93555,
    lat: 35.58596,
    lng: -117.68446,
    city: "Ridgecrest",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33925,
    density: 167.7,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 92.01,
      "06071": 7.99,
    },
    county_names_all: "Kern|San Bernardino",
    county_fips_all: "06029|06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93558,
    lat: 35.33945,
    lng: -117.58517,
    city: "Red Mountain",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93560,
    lat: 34.87116,
    lng: -118.32594,
    city: "Rosamond",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20988,
    density: 48.3,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 95.18,
      "06037": 4.82,
    },
    county_names_all: "Kern|Los Angeles",
    county_fips_all: "06029|06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93561,
    lat: 35.10904,
    lng: -118.52016,
    city: "Tehachapi",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35133,
    density: 44.9,
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93562,
    lat: 35.70667,
    lng: -117.34263,
    city: "Trona",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1757,
    density: 7.6,
    county_fips: "06071",
    county_name: "San Bernardino",
    county_weights: {
      "06071": 100,
    },
    county_names_all: "San Bernardino",
    county_fips_all: "06071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93563,
    lat: 34.38662,
    lng: -117.83646,
    city: "Valyermo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 419,
    density: 4.3,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93581,
    lat: 35.11288,
    lng: -118.57035,
    city: "Tehachapi",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06029",
    county_name: "Kern",
    county_weights: {
      "06029": 100,
    },
    county_names_all: "Kern",
    county_fips_all: "06029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93591,
    lat: 34.59656,
    lng: -117.80955,
    city: "Palmdale",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6557,
    density: 34.1,
    county_fips: "06037",
    county_name: "Los Angeles",
    county_weights: {
      "06037": 100,
    },
    county_names_all: "Los Angeles",
    county_fips_all: "06037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93601,
    lat: 37.39395,
    lng: -119.73702,
    city: "Ahwahnee",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1418,
    density: 13.8,
    county_fips: "06039",
    county_name: "Madera",
    county_weights: {
      "06039": 63.75,
      "06043": 36.25,
    },
    county_names_all: "Madera|Mariposa",
    county_fips_all: "06039|06043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93602,
    lat: 37.0644,
    lng: -119.37484,
    city: "Auberry",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3330,
    density: 11.6,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 95.46,
      "06039": 4.54,
    },
    county_names_all: "Fresno|Madera",
    county_fips_all: "06019|06039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93603,
    lat: 36.55118,
    lng: -118.99607,
    city: "Badger",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 141,
    density: 0.5,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93604,
    lat: 37.3717,
    lng: -119.52215,
    city: "Bass Lake",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 366,
    density: 3.2,
    county_fips: "06039",
    county_name: "Madera",
    county_weights: {
      "06039": 100,
    },
    county_names_all: "Madera",
    county_fips_all: "06039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93605,
    lat: 37.17622,
    lng: -119.24953,
    city: "Big Creek",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93606,
    lat: 36.79871,
    lng: -120.01625,
    city: "Biola",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 776,
    density: 432.9,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93608,
    lat: 36.5055,
    lng: -120.3418,
    city: "Cantua Creek",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1057,
    density: 3.4,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93609,
    lat: 36.52616,
    lng: -119.86388,
    city: "Caruthers",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5328,
    density: 33.7,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93610,
    lat: 37.09047,
    lng: -120.29036,
    city: "Chowchilla",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23279,
    density: 34.2,
    county_fips: "06039",
    county_name: "Madera",
    county_weights: {
      "06039": 85.12,
      "06047": 14.88,
    },
    county_names_all: "Madera|Merced",
    county_fips_all: "06039|06047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93611,
    lat: 36.82552,
    lng: -119.68115,
    city: "Clovis",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48619,
    density: 1821.9,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93612,
    lat: 36.81548,
    lng: -119.71076,
    city: "Clovis",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35475,
    density: 2029.6,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93614,
    lat: 37.21282,
    lng: -119.72659,
    city: "Coarsegold",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12132,
    density: 36.5,
    county_fips: "06039",
    county_name: "Madera",
    county_weights: {
      "06039": 100,
    },
    county_names_all: "Madera",
    county_fips_all: "06039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93615,
    lat: 36.50374,
    lng: -119.28385,
    city: "Cutler",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6335,
    density: 152,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93616,
    lat: 36.65468,
    lng: -119.59437,
    city: "Del Rey",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2370,
    density: 66.4,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93618,
    lat: 36.52213,
    lng: -119.38661,
    city: "Dinuba",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31971,
    density: 184.5,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 88.96,
      "06019": 11.04,
    },
    county_names_all: "Tulare|Fresno",
    county_fips_all: "06107|06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93619,
    lat: 36.91656,
    lng: -119.57372,
    city: "Clovis",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43026,
    density: 89.1,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93620,
    lat: 37.0448,
    lng: -120.6223,
    city: "Dos Palos",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8452,
    density: 20.2,
    county_fips: "06047",
    county_name: "Merced",
    county_weights: {
      "06047": 75.66,
      "06019": 24.09,
      "06039": 0.25,
    },
    county_names_all: "Merced|Fresno|Madera",
    county_fips_all: "06047|06019|06039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93621,
    lat: 36.8067,
    lng: -119.13602,
    city: "Dunlap",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 118,
    density: 0.6,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93622,
    lat: 36.79283,
    lng: -120.62434,
    city: "Firebaugh",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9417,
    density: 8,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 83.43,
      "06039": 10.33,
      "06047": 6.24,
    },
    county_names_all: "Fresno|Madera|Merced",
    county_fips_all: "06019|06039|06047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93623,
    lat: 37.47478,
    lng: -119.66071,
    city: "Fish Camp",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59,
    density: 1.2,
    county_fips: "06043",
    county_name: "Mariposa",
    county_weights: {
      "06043": 96,
      "06039": 4,
    },
    county_names_all: "Mariposa|Madera",
    county_fips_all: "06043|06039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93624,
    lat: 36.37258,
    lng: -120.12125,
    city: "Five Points",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 935,
    density: 2.5,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93625,
    lat: 36.62423,
    lng: -119.67173,
    city: "Fowler",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7695,
    density: 123.9,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93626,
    lat: 37.03278,
    lng: -119.68601,
    city: "Friant",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2464,
    density: 9.6,
    county_fips: "06039",
    county_name: "Madera",
    county_weights: {
      "06039": 72.18,
      "06019": 27.82,
    },
    county_names_all: "Madera|Fresno",
    county_fips_all: "06039|06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93627,
    lat: 36.51568,
    lng: -120.10635,
    city: "Helm",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 134,
    density: 0.8,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93628,
    lat: 36.78149,
    lng: -118.83839,
    city: "Hume",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 289,
    density: 1.8,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93630,
    lat: 36.71831,
    lng: -120.12912,
    city: "Kerman",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20727,
    density: 49.3,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93631,
    lat: 36.47653,
    lng: -119.52131,
    city: "Kingsburg",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16163,
    density: 75.6,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 53.33,
      "06019": 25.96,
      "06031": 20.71,
    },
    county_names_all: "Tulare|Fresno|Kings",
    county_fips_all: "06107|06019|06031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93633,
    lat: 36.72912,
    lng: -118.95627,
    city: "Kings Canyon National Pk",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93634,
    lat: 37.20583,
    lng: -118.93652,
    city: "Lakeshore",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27,
    density: 0,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93635,
    lat: 37.016,
    lng: -120.88294,
    city: "Los Banos",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41563,
    density: 41.1,
    county_fips: "06047",
    county_name: "Merced",
    county_weights: {
      "06047": 100,
    },
    county_names_all: "Merced",
    county_fips_all: "06047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93636,
    lat: 36.98171,
    lng: -119.87706,
    city: "Madera",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12527,
    density: 24.5,
    county_fips: "06039",
    county_name: "Madera",
    county_weights: {
      "06039": 100,
    },
    county_names_all: "Madera",
    county_fips_all: "06039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93637,
    lat: 36.91099,
    lng: -120.1922,
    city: "Madera",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41100,
    density: 56.6,
    county_fips: "06039",
    county_name: "Madera",
    county_weights: {
      "06039": 100,
    },
    county_names_all: "Madera",
    county_fips_all: "06039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93638,
    lat: 37.0424,
    lng: -120.03816,
    city: "Madera",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51353,
    density: 219.7,
    county_fips: "06039",
    county_name: "Madera",
    county_weights: {
      "06039": 100,
    },
    county_names_all: "Madera",
    county_fips_all: "06039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93640,
    lat: 36.67215,
    lng: -120.43778,
    city: "Mendota",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13578,
    density: 33.2,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93641,
    lat: 36.70481,
    lng: -119.02167,
    city: "Miramonte",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 261,
    density: 1.6,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 71.55,
      "06107": 28.45,
    },
    county_names_all: "Fresno|Tulare",
    county_fips_all: "06019|06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93643,
    lat: 37.27155,
    lng: -119.45004,
    city: "North Fork",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3059,
    density: 7.7,
    county_fips: "06039",
    county_name: "Madera",
    county_weights: {
      "06039": 100,
    },
    county_names_all: "Madera",
    county_fips_all: "06039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93644,
    lat: 37.41245,
    lng: -119.59431,
    city: "Oakhurst",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8272,
    density: 27.3,
    county_fips: "06039",
    county_name: "Madera",
    county_weights: {
      "06039": 100,
    },
    county_names_all: "Madera",
    county_fips_all: "06039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93645,
    lat: 37.1641,
    lng: -119.61824,
    city: "O'Neals",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 222,
    density: 1.4,
    county_fips: "06039",
    county_name: "Madera",
    county_weights: {
      "06039": 100,
    },
    county_names_all: "Madera",
    county_fips_all: "06039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93646,
    lat: 36.63218,
    lng: -119.28938,
    city: "Orange Cove",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11240,
    density: 126.6,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 58.27,
      "06019": 41.73,
    },
    county_names_all: "Tulare|Fresno",
    county_fips_all: "06107|06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93647,
    lat: 36.58449,
    lng: -119.17773,
    city: "Orosi",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11485,
    density: 47.6,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93648,
    lat: 36.6206,
    lng: -119.52062,
    city: "Parlier",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16543,
    density: 288.8,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93650,
    lat: 36.84026,
    lng: -119.80038,
    city: "Fresno",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2885,
    density: 1782.5,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93651,
    lat: 37.00296,
    lng: -119.521,
    city: "Prather",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2289,
    density: 54.3,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93652,
    lat: 36.59502,
    lng: -119.90458,
    city: "Raisin City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 563,
    density: 105.3,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93653,
    lat: 37.24769,
    lng: -119.91882,
    city: "Raymond",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1304,
    density: 2.4,
    county_fips: "06039",
    county_name: "Madera",
    county_weights: {
      "06039": 69.45,
      "06043": 30.55,
    },
    county_names_all: "Madera|Mariposa",
    county_fips_all: "06039|06043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93654,
    lat: 36.65747,
    lng: -119.402,
    city: "Reedley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30798,
    density: 118.3,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 90.88,
      "06107": 9.12,
    },
    county_names_all: "Fresno|Tulare",
    county_fips_all: "06019|06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93656,
    lat: 36.45173,
    lng: -119.93615,
    city: "Riverdale",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5806,
    density: 19.8,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 90.74,
      "06031": 9.26,
    },
    county_names_all: "Fresno|Kings",
    county_fips_all: "06019|06031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93657,
    lat: 36.78853,
    lng: -119.4378,
    city: "Sanger",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36557,
    density: 62.5,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93660,
    lat: 36.60932,
    lng: -120.16514,
    city: "San Joaquin",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4082,
    density: 32.3,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93662,
    lat: 36.53963,
    lng: -119.64287,
    city: "Selma",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30453,
    density: 151,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93664,
    lat: 37.05671,
    lng: -119.17981,
    city: "Shaver Lake",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 370,
    density: 0.8,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93665,
    lat: 36.96334,
    lng: -120.65034,
    city: "South Dos Palos",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 492,
    density: 363,
    county_fips: "06047",
    county_name: "Merced",
    county_weights: {
      "06047": 100,
    },
    county_names_all: "Merced",
    county_fips_all: "06047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93666,
    lat: 36.54623,
    lng: -119.33629,
    city: "Sultana",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1029,
    density: 1877,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93667,
    lat: 36.96585,
    lng: -119.31511,
    city: "Tollhouse",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2112,
    density: 6.9,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93668,
    lat: 36.65663,
    lng: -120.28997,
    city: "Tranquillity",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1200,
    density: 9.7,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93669,
    lat: 37.28334,
    lng: -119.54297,
    city: "Wishon",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 320,
    density: 17.5,
    county_fips: "06039",
    county_name: "Madera",
    county_weights: {
      "06039": 100,
    },
    county_names_all: "Madera",
    county_fips_all: "06039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93670,
    lat: 36.48564,
    lng: -119.25442,
    city: "Yettem",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93673,
    lat: 36.45229,
    lng: -119.48232,
    city: "Traver",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 702,
    density: 348,
    county_fips: "06107",
    county_name: "Tulare",
    county_weights: {
      "06107": 100,
    },
    county_names_all: "Tulare",
    county_fips_all: "06107",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93675,
    lat: 36.73251,
    lng: -119.19285,
    city: "Squaw Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3775,
    density: 14.7,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93701,
    lat: 36.74955,
    lng: -119.78772,
    city: "Fresno",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10398,
    density: 2639.7,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93702,
    lat: 36.73942,
    lng: -119.75422,
    city: "Fresno",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43697,
    density: 3263.1,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93703,
    lat: 36.76884,
    lng: -119.76249,
    city: "Fresno",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32102,
    density: 2603.4,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93704,
    lat: 36.80012,
    lng: -119.80202,
    city: "Fresno",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29205,
    density: 2089.5,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93705,
    lat: 36.78667,
    lng: -119.82851,
    city: "Fresno",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36370,
    density: 2886.5,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93706,
    lat: 36.65344,
    lng: -119.90216,
    city: "Fresno",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41534,
    density: 101.2,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93710,
    lat: 36.82335,
    lng: -119.76251,
    city: "Fresno",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34123,
    density: 2134.4,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93711,
    lat: 36.83508,
    lng: -119.83309,
    city: "Fresno",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38680,
    density: 1331.5,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93720,
    lat: 36.8606,
    lng: -119.76228,
    city: "Fresno",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46725,
    density: 1727.8,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 97.77,
      "06039": 2.23,
    },
    county_names_all: "Fresno|Madera",
    county_fips_all: "06019|06039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93721,
    lat: 36.73282,
    lng: -119.78383,
    city: "Fresno",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8475,
    density: 1603.3,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93722,
    lat: 36.80003,
    lng: -119.87791,
    city: "Fresno",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 85811,
    density: 1716.7,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93723,
    lat: 36.78693,
    lng: -119.95271,
    city: "Fresno",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13793,
    density: 129.7,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93725,
    lat: 36.62667,
    lng: -119.73501,
    city: "Fresno",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27167,
    density: 156.6,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93726,
    lat: 36.79374,
    lng: -119.76161,
    city: "Fresno",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42945,
    density: 2598.4,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93727,
    lat: 36.75119,
    lng: -119.69736,
    city: "Fresno",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 84656,
    density: 1487.3,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93728,
    lat: 36.75729,
    lng: -119.81816,
    city: "Fresno",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16738,
    density: 2124.3,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93730,
    lat: 36.90354,
    lng: -119.75512,
    city: "Fresno",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12571,
    density: 616.8,
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93737,
    lat: 36.75358,
    lng: -119.6456,
    city: "Fresno",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93740,
    lat: 36.81638,
    lng: -119.74613,
    city: "Fresno",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93741,
    lat: 36.76742,
    lng: -119.79602,
    city: "Fresno",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06019",
    county_name: "Fresno",
    county_weights: {
      "06019": 100,
    },
    county_names_all: "Fresno",
    county_fips_all: "06019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93901,
    lat: 36.64794,
    lng: -121.63044,
    city: "Salinas",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28089,
    density: 1131.4,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 100,
    },
    county_names_all: "Monterey",
    county_fips_all: "06053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93905,
    lat: 36.6849,
    lng: -121.60562,
    city: "Salinas",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61633,
    density: 2575.4,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 100,
    },
    county_names_all: "Monterey",
    county_fips_all: "06053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93906,
    lat: 36.72258,
    lng: -121.63218,
    city: "Salinas",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63733,
    density: 1855.7,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 100,
    },
    county_names_all: "Monterey",
    county_fips_all: "06053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93907,
    lat: 36.76643,
    lng: -121.66816,
    city: "Salinas",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24337,
    density: 172.3,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 100,
    },
    county_names_all: "Monterey",
    county_fips_all: "06053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93908,
    lat: 36.62153,
    lng: -121.60048,
    city: "Salinas",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12195,
    density: 19.5,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 100,
    },
    county_names_all: "Monterey",
    county_fips_all: "06053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93920,
    lat: 36.03164,
    lng: -121.52592,
    city: "Big Sur",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1430,
    density: 3.5,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 100,
    },
    county_names_all: "Monterey",
    county_fips_all: "06053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93921,
    lat: 36.55359,
    lng: -121.92259,
    city: "Carmel By The Sea",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2951,
    density: 1196.8,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 100,
    },
    county_names_all: "Monterey",
    county_fips_all: "06053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93923,
    lat: 36.40394,
    lng: -121.79867,
    city: "Carmel",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12922,
    density: 24.6,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 100,
    },
    county_names_all: "Monterey",
    county_fips_all: "06053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93924,
    lat: 36.39489,
    lng: -121.63406,
    city: "Carmel Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6421,
    density: 13.3,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 100,
    },
    county_names_all: "Monterey",
    county_fips_all: "06053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93925,
    lat: 36.60209,
    lng: -121.42526,
    city: "Chualar",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1794,
    density: 13.9,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 100,
    },
    county_names_all: "Monterey",
    county_fips_all: "06053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93926,
    lat: 36.52567,
    lng: -121.3991,
    city: "Gonzales",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8893,
    density: 51.1,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 100,
    },
    county_names_all: "Monterey",
    county_fips_all: "06053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93927,
    lat: 36.26978,
    lng: -121.38018,
    city: "Greenfield",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18344,
    density: 33.7,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 100,
    },
    county_names_all: "Monterey",
    county_fips_all: "06053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93928,
    lat: 36.06484,
    lng: -121.38102,
    city: "Jolon",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1019,
    density: 10.2,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 100,
    },
    county_names_all: "Monterey",
    county_fips_all: "06053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93930,
    lat: 36.19924,
    lng: -121.07282,
    city: "King City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17599,
    density: 19.8,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 81.1,
      "06069": 18.9,
    },
    county_names_all: "Monterey|San Benito",
    county_fips_all: "06053|06069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93932,
    lat: 36.00143,
    lng: -121.05757,
    city: "Lockwood",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 502,
    density: 2.6,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 100,
    },
    county_names_all: "Monterey",
    county_fips_all: "06053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93933,
    lat: 36.67566,
    lng: -121.78237,
    city: "Marina",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25056,
    density: 906.3,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 100,
    },
    county_names_all: "Monterey",
    county_fips_all: "06053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93940,
    lat: 36.45294,
    lng: -121.8498,
    city: "Monterey",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32699,
    density: 359.3,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 100,
    },
    county_names_all: "Monterey",
    county_fips_all: "06053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93943,
    lat: 36.59736,
    lng: -121.87332,
    city: "Monterey",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 100,
    },
    county_names_all: "Monterey",
    county_fips_all: "06053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93944,
    lat: 36.60058,
    lng: -121.91858,
    city: "Monterey",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 100,
    },
    county_names_all: "Monterey",
    county_fips_all: "06053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93950,
    lat: 36.61899,
    lng: -121.92575,
    city: "Pacific Grove",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15471,
    density: 2127.3,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 100,
    },
    county_names_all: "Monterey",
    county_fips_all: "06053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93953,
    lat: 36.58566,
    lng: -121.94329,
    city: "Pebble Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3783,
    density: 180.4,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 100,
    },
    county_names_all: "Monterey",
    county_fips_all: "06053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93954,
    lat: 36.16434,
    lng: -120.92441,
    city: "San Lucas",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 438,
    density: 2.8,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 100,
    },
    county_names_all: "Monterey",
    county_fips_all: "06053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93955,
    lat: 36.62153,
    lng: -121.79562,
    city: "Seaside",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34757,
    density: 510.2,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 100,
    },
    county_names_all: "Monterey",
    county_fips_all: "06053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93960,
    lat: 36.40489,
    lng: -121.32121,
    city: "Soledad",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27009,
    density: 59.9,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 100,
    },
    county_names_all: "Monterey",
    county_fips_all: "06053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 93962,
    lat: 36.62472,
    lng: -121.64649,
    city: "Spreckels",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 373,
    density: 1179,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 100,
    },
    county_names_all: "Monterey",
    county_fips_all: "06053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94002,
    lat: 37.51366,
    lng: -122.29853,
    city: "Belmont",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27001,
    density: 1853.6,
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 100,
    },
    county_names_all: "San Mateo",
    county_fips_all: "06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94005,
    lat: 37.6882,
    lng: -122.40873,
    city: "Brisbane",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4645,
    density: 391.6,
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 100,
    },
    county_names_all: "San Mateo",
    county_fips_all: "06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94010,
    lat: 37.57306,
    lng: -122.37828,
    city: "Burlingame",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42466,
    density: 1084.6,
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 100,
    },
    county_names_all: "San Mateo",
    county_fips_all: "06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94014,
    lat: 37.6907,
    lng: -122.44769,
    city: "Daly City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49565,
    density: 2994.2,
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 100,
    },
    county_names_all: "San Mateo",
    county_fips_all: "06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94015,
    lat: 37.68121,
    lng: -122.48074,
    city: "Daly City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65199,
    density: 4451.1,
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 100,
    },
    county_names_all: "San Mateo",
    county_fips_all: "06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94018,
    lat: 37.50603,
    lng: -122.47321,
    city: "El Granada",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 100,
    },
    county_names_all: "San Mateo",
    county_fips_all: "06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94019,
    lat: 37.44826,
    lng: -122.4023,
    city: "Half Moon Bay",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20207,
    density: 130.6,
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 100,
    },
    county_names_all: "San Mateo",
    county_fips_all: "06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94020,
    lat: 37.28473,
    lng: -122.21969,
    city: "La Honda",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1979,
    density: 18.2,
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 100,
    },
    county_names_all: "San Mateo",
    county_fips_all: "06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94021,
    lat: 37.25028,
    lng: -122.24958,
    city: "Loma Mar",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 574,
    density: 20.2,
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 100,
    },
    county_names_all: "San Mateo",
    county_fips_all: "06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94022,
    lat: 37.35534,
    lng: -122.14494,
    city: "Los Altos",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19701,
    density: 429.3,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94024,
    lat: 37.35037,
    lng: -122.09863,
    city: "Los Altos",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23704,
    density: 1106.3,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94025,
    lat: 37.45087,
    lng: -122.1829,
    city: "Menlo Park",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43996,
    density: 2030.6,
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 100,
    },
    county_names_all: "San Mateo",
    county_fips_all: "06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94027,
    lat: 37.45399,
    lng: -122.20313,
    city: "Atherton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7193,
    density: 552.5,
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 100,
    },
    county_names_all: "San Mateo",
    county_fips_all: "06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94028,
    lat: 37.37492,
    lng: -122.21136,
    city: "Portola Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6718,
    density: 149.8,
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 80.67,
      "06085": 19.33,
    },
    county_names_all: "San Mateo|Santa Clara",
    county_fips_all: "06081|06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94030,
    lat: 37.59969,
    lng: -122.40343,
    city: "Millbrae",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22998,
    density: 2631.5,
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 100,
    },
    county_names_all: "San Mateo",
    county_fips_all: "06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94037,
    lat: 37.55327,
    lng: -122.49584,
    city: "Montara",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2833,
    density: 198.8,
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 100,
    },
    county_names_all: "San Mateo",
    county_fips_all: "06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94038,
    lat: 37.52946,
    lng: -122.4849,
    city: "Moss Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3350,
    density: 217.5,
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 100,
    },
    county_names_all: "San Mateo",
    county_fips_all: "06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94040,
    lat: 37.38034,
    lng: -122.08531,
    city: "Mountain View",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34804,
    density: 3671.6,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94041,
    lat: 37.38822,
    lng: -122.07529,
    city: "Mountain View",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13996,
    density: 3396.5,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94043,
    lat: 37.41188,
    lng: -122.06892,
    city: "Mountain View",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31999,
    density: 1460.7,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94044,
    lat: 37.60544,
    lng: -122.47993,
    city: "Pacifica",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38677,
    density: 989.8,
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 100,
    },
    county_names_all: "San Mateo",
    county_fips_all: "06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94060,
    lat: 37.22297,
    lng: -122.33572,
    city: "Pescadero",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1098,
    density: 5.8,
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 100,
    },
    county_names_all: "San Mateo",
    county_fips_all: "06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94061,
    lat: 37.46136,
    lng: -122.23731,
    city: "Redwood City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38158,
    density: 3815.8,
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 100,
    },
    county_names_all: "San Mateo",
    county_fips_all: "06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94062,
    lat: 37.42562,
    lng: -122.29653,
    city: "Redwood City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27871,
    density: 166.4,
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 100,
    },
    county_names_all: "San Mateo",
    county_fips_all: "06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94063,
    lat: 37.49367,
    lng: -122.20823,
    city: "Redwood City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36110,
    density: 2144.2,
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 100,
    },
    county_names_all: "San Mateo",
    county_fips_all: "06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94065,
    lat: 37.53504,
    lng: -122.24683,
    city: "Redwood City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11603,
    density: 1953.2,
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 100,
    },
    county_names_all: "San Mateo",
    county_fips_all: "06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94066,
    lat: 37.62539,
    lng: -122.43229,
    city: "San Bruno",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44538,
    density: 2837.5,
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 100,
    },
    county_names_all: "San Mateo",
    county_fips_all: "06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94070,
    lat: 37.49739,
    lng: -122.27021,
    city: "San Carlos",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30420,
    density: 1918.8,
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 100,
    },
    county_names_all: "San Mateo",
    county_fips_all: "06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94074,
    lat: 37.32817,
    lng: -122.34164,
    city: "San Gregorio",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 177,
    density: 3,
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 100,
    },
    county_names_all: "San Mateo",
    county_fips_all: "06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94080,
    lat: 37.65541,
    lng: -122.42083,
    city: "South San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67263,
    density: 2551.8,
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 100,
    },
    county_names_all: "San Mateo",
    county_fips_all: "06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94085,
    lat: 37.38862,
    lng: -122.01793,
    city: "Sunnyvale",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23592,
    density: 2593.2,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94086,
    lat: 37.37164,
    lng: -122.02316,
    city: "Sunnyvale",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49190,
    density: 4349.4,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94087,
    lat: 37.35164,
    lng: -122.03669,
    city: "Sunnyvale",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57015,
    density: 3340,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94089,
    lat: 37.41192,
    lng: -122.01441,
    city: "Sunnyvale",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23049,
    density: 1462.5,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94102,
    lat: 37.77956,
    lng: -122.41931,
    city: "San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33264,
    density: 19415.4,
    county_fips: "06075",
    county_name: "San Francisco",
    county_weights: {
      "06075": 100,
    },
    county_names_all: "San Francisco",
    county_fips_all: "06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94103,
    lat: 37.77299,
    lng: -122.41136,
    city: "San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31585,
    density: 8876.4,
    county_fips: "06075",
    county_name: "San Francisco",
    county_weights: {
      "06075": 100,
    },
    county_names_all: "San Francisco",
    county_fips_all: "06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94104,
    lat: 37.79144,
    lng: -122.40211,
    city: "San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 438,
    density: 2180.7,
    county_fips: "06075",
    county_name: "San Francisco",
    county_weights: {
      "06075": 100,
    },
    county_names_all: "San Francisco",
    county_fips_all: "06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94105,
    lat: 37.79239,
    lng: -122.39707,
    city: "San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12944,
    density: 9905.8,
    county_fips: "06075",
    county_name: "San Francisco",
    county_weights: {
      "06075": 100,
    },
    county_names_all: "San Francisco",
    county_fips_all: "06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94107,
    lat: 37.76473,
    lng: -122.39508,
    city: "San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29708,
    density: 6180.9,
    county_fips: "06075",
    county_name: "San Francisco",
    county_weights: {
      "06075": 100,
    },
    county_names_all: "San Francisco",
    county_fips_all: "06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94108,
    lat: 37.79189,
    lng: -122.40854,
    city: "San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13535,
    density: 20257.4,
    county_fips: "06075",
    county_name: "San Francisco",
    county_weights: {
      "06075": 100,
    },
    county_names_all: "San Francisco",
    county_fips_all: "06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94109,
    lat: 37.79334,
    lng: -122.42138,
    city: "San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55797,
    density: 19972,
    county_fips: "06075",
    county_name: "San Francisco",
    county_weights: {
      "06075": 100,
    },
    county_names_all: "San Francisco",
    county_fips_all: "06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94110,
    lat: 37.74975,
    lng: -122.41528,
    city: "San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 72765,
    density: 11755.9,
    county_fips: "06075",
    county_name: "San Francisco",
    county_weights: {
      "06075": 100,
    },
    county_names_all: "San Francisco",
    county_fips_all: "06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94111,
    lat: 37.79847,
    lng: -122.3998,
    city: "San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4023,
    density: 4656,
    county_fips: "06075",
    county_name: "San Francisco",
    county_weights: {
      "06075": 100,
    },
    county_names_all: "San Francisco",
    county_fips_all: "06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94112,
    lat: 37.7206,
    lng: -122.44311,
    city: "San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 85053,
    density: 9845.7,
    county_fips: "06075",
    county_name: "San Francisco",
    county_weights: {
      "06075": 100,
    },
    county_names_all: "San Francisco",
    county_fips_all: "06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94114,
    lat: 37.75814,
    lng: -122.43547,
    city: "San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35077,
    density: 9781,
    county_fips: "06075",
    county_name: "San Francisco",
    county_weights: {
      "06075": 100,
    },
    county_names_all: "San Francisco",
    county_fips_all: "06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94115,
    lat: 37.78608,
    lng: -122.43742,
    city: "San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33841,
    density: 11498,
    county_fips: "06075",
    county_name: "San Francisco",
    county_weights: {
      "06075": 100,
    },
    county_names_all: "San Francisco",
    county_fips_all: "06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94116,
    lat: 37.74457,
    lng: -122.48611,
    city: "San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46594,
    density: 7121.7,
    county_fips: "06075",
    county_name: "San Francisco",
    county_weights: {
      "06075": 100,
    },
    county_names_all: "San Francisco",
    county_fips_all: "06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94117,
    lat: 37.77002,
    lng: -122.44425,
    city: "San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43526,
    density: 13185.5,
    county_fips: "06075",
    county_name: "San Francisco",
    county_weights: {
      "06075": 100,
    },
    county_names_all: "San Francisco",
    county_fips_all: "06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94118,
    lat: 37.7801,
    lng: -122.46185,
    city: "San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41241,
    density: 7940.7,
    county_fips: "06075",
    county_name: "San Francisco",
    county_weights: {
      "06075": 100,
    },
    county_names_all: "San Francisco",
    county_fips_all: "06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94121,
    lat: 37.77849,
    lng: -122.49548,
    city: "San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43843,
    density: 6678.8,
    county_fips: "06075",
    county_name: "San Francisco",
    county_weights: {
      "06075": 100,
    },
    county_names_all: "San Francisco",
    county_fips_all: "06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94122,
    lat: 37.76113,
    lng: -122.48433,
    city: "San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61248,
    density: 7260.2,
    county_fips: "06075",
    county_name: "San Francisco",
    county_weights: {
      "06075": 100,
    },
    county_names_all: "San Francisco",
    county_fips_all: "06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94123,
    lat: 37.80112,
    lng: -122.43645,
    city: "San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26074,
    density: 9298.2,
    county_fips: "06075",
    county_name: "San Francisco",
    county_weights: {
      "06075": 100,
    },
    county_names_all: "San Francisco",
    county_fips_all: "06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94124,
    lat: 37.73204,
    lng: -122.3858,
    city: "San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36278,
    density: 2934.7,
    county_fips: "06075",
    county_name: "San Francisco",
    county_weights: {
      "06075": 100,
    },
    county_names_all: "San Francisco",
    county_fips_all: "06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94127,
    lat: 37.73642,
    lng: -122.45961,
    city: "San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20413,
    density: 4226.1,
    county_fips: "06075",
    county_name: "San Francisco",
    county_weights: {
      "06075": 100,
    },
    county_names_all: "San Francisco",
    county_fips_all: "06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94128,
    lat: 37.62197,
    lng: -122.38388,
    city: "San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 173,
    density: 19.9,
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 100,
    },
    county_names_all: "San Mateo",
    county_fips_all: "06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94129,
    lat: 37.79743,
    lng: -122.46662,
    city: "San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4011,
    density: 659.2,
    county_fips: "06075",
    county_name: "San Francisco",
    county_weights: {
      "06075": 100,
    },
    county_names_all: "San Francisco",
    county_fips_all: "06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94130,
    lat: 37.81975,
    lng: -122.36898,
    city: "San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3184,
    density: 1395.7,
    county_fips: "06075",
    county_name: "San Francisco",
    county_weights: {
      "06075": 100,
    },
    county_names_all: "San Francisco",
    county_fips_all: "06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94131,
    lat: 37.74569,
    lng: -122.44243,
    city: "San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30458,
    density: 5815.8,
    county_fips: "06075",
    county_name: "San Francisco",
    county_weights: {
      "06075": 100,
    },
    county_names_all: "San Francisco",
    county_fips_all: "06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94132,
    lat: 37.72219,
    lng: -122.48475,
    city: "San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30437,
    density: 3752.2,
    county_fips: "06075",
    county_name: "San Francisco",
    county_weights: {
      "06075": 100,
    },
    county_names_all: "San Francisco",
    county_fips_all: "06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94133,
    lat: 37.80193,
    lng: -122.41092,
    city: "San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26930,
    density: 15812.2,
    county_fips: "06075",
    county_name: "San Francisco",
    county_weights: {
      "06075": 100,
    },
    county_names_all: "San Francisco",
    county_fips_all: "06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94134,
    lat: 37.71887,
    lng: -122.41124,
    city: "San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43286,
    density: 6531.3,
    county_fips: "06075",
    county_name: "San Francisco",
    county_weights: {
      "06075": 100,
    },
    county_names_all: "San Francisco",
    county_fips_all: "06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94158,
    lat: 37.77116,
    lng: -122.39153,
    city: "San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9231,
    density: 5834.4,
    county_fips: "06075",
    county_name: "San Francisco",
    county_weights: {
      "06075": 100,
    },
    county_names_all: "San Francisco",
    county_fips_all: "06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94188,
    lat: 37.7407,
    lng: -122.38091,
    city: "San Francisco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06075",
    county_name: "San Francisco",
    county_weights: {
      "06075": 100,
    },
    county_names_all: "San Francisco",
    county_fips_all: "06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94301,
    lat: 37.44424,
    lng: -122.14992,
    city: "Palo Alto",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17470,
    density: 2845.8,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 99.51,
      "06081": 0.49,
    },
    county_names_all: "Santa Clara|San Mateo",
    county_fips_all: "06085|06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94303,
    lat: 37.45064,
    lng: -122.11928,
    city: "Palo Alto",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47828,
    density: 2188.2,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 67.45,
      "06081": 32.55,
    },
    county_names_all: "Santa Clara|San Mateo",
    county_fips_all: "06085|06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94304,
    lat: 37.39744,
    lng: -122.16699,
    city: "Palo Alto",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4391,
    density: 352.7,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94305,
    lat: 37.41623,
    lng: -122.17069,
    city: "Stanford",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16283,
    density: 1315.4,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94306,
    lat: 37.41627,
    lng: -122.13088,
    city: "Palo Alto",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27650,
    density: 2613.1,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94401,
    lat: 37.57445,
    lng: -122.31942,
    city: "San Mateo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35013,
    density: 4345.9,
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 100,
    },
    county_names_all: "San Mateo",
    county_fips_all: "06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94402,
    lat: 37.54035,
    lng: -122.33388,
    city: "San Mateo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25966,
    density: 1984,
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 100,
    },
    county_names_all: "San Mateo",
    county_fips_all: "06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94403,
    lat: 37.53844,
    lng: -122.30454,
    city: "San Mateo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44361,
    density: 3040.8,
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 100,
    },
    county_names_all: "San Mateo",
    county_fips_all: "06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94404,
    lat: 37.5562,
    lng: -122.26905,
    city: "San Mateo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36086,
    density: 3203,
    county_fips: "06081",
    county_name: "San Mateo",
    county_weights: {
      "06081": 100,
    },
    county_names_all: "San Mateo",
    county_fips_all: "06081",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94501,
    lat: 37.77525,
    lng: -122.27493,
    city: "Alameda",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64487,
    density: 3122.7,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 99.46,
      "06075": 0.54,
    },
    county_names_all: "Alameda|San Francisco",
    county_fips_all: "06001|06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94502,
    lat: 37.73686,
    lng: -122.24114,
    city: "Alameda",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15340,
    density: 2348.3,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94503,
    lat: 38.19454,
    lng: -122.23042,
    city: "American Canyon",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20295,
    density: 289.9,
    county_fips: "06055",
    county_name: "Napa",
    county_weights: {
      "06055": 68.05,
      "06095": 31.95,
    },
    county_names_all: "Napa|Solano",
    county_fips_all: "06055|06095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94505,
    lat: 37.86638,
    lng: -121.5868,
    city: "Discovery Bay",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15974,
    density: 369.9,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 96.44,
      "06001": 3,
      "06077": 0.56,
    },
    county_names_all: "Contra Costa|Alameda|San Joaquin",
    county_fips_all: "06013|06001|06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94506,
    lat: 37.80862,
    lng: -121.90498,
    city: "Danville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27143,
    density: 561.8,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94507,
    lat: 37.85429,
    lng: -122.00664,
    city: "Alamo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14059,
    density: 484.7,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94508,
    lat: 38.57909,
    lng: -122.44451,
    city: "Angwin",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4083,
    density: 98.4,
    county_fips: "06055",
    county_name: "Napa",
    county_weights: {
      "06055": 100,
    },
    county_names_all: "Napa",
    county_fips_all: "06055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94509,
    lat: 37.99214,
    lng: -121.8142,
    city: "Antioch",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69295,
    density: 1533.8,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94510,
    lat: 38.09756,
    lng: -122.13189,
    city: "Benicia",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28297,
    density: 374.5,
    county_fips: "06095",
    county_name: "Solano",
    county_weights: {
      "06095": 100,
    },
    county_names_all: "Solano",
    county_fips_all: "06095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94511,
    lat: 38.02883,
    lng: -121.64039,
    city: "Bethel Island",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2015,
    density: 148.1,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94512,
    lat: 38.1263,
    lng: -121.83793,
    city: "Birds Landing",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18,
    density: 0.3,
    county_fips: "06095",
    county_name: "Solano",
    county_weights: {
      "06095": 100,
    },
    county_names_all: "Solano",
    county_fips_all: "06095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94513,
    lat: 37.92541,
    lng: -121.68452,
    city: "Brentwood",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65454,
    density: 320.5,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94514,
    lat: 37.83071,
    lng: -121.63392,
    city: "Byron",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2081,
    density: 26.8,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 82.38,
      "06001": 17.62,
    },
    county_names_all: "Contra Costa|Alameda",
    county_fips_all: "06013|06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94515,
    lat: 38.62449,
    lng: -122.62503,
    city: "Calistoga",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7525,
    density: 25.1,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 50.63,
      "06055": 49.37,
    },
    county_names_all: "Sonoma|Napa",
    county_fips_all: "06097|06055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94516,
    lat: 37.82748,
    lng: -122.16629,
    city: "Canyon",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 233,
    density: 24.9,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94517,
    lat: 37.8926,
    lng: -121.88252,
    city: "Clayton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12970,
    density: 104.9,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94518,
    lat: 37.95052,
    lng: -122.02209,
    city: "Concord",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28846,
    density: 2010.1,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94519,
    lat: 37.98881,
    lng: -122.01275,
    city: "Concord",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20317,
    density: 1729.4,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94520,
    lat: 37.99344,
    lng: -122.03532,
    city: "Concord",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38709,
    density: 1514,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94521,
    lat: 37.95293,
    lng: -121.96971,
    city: "Concord",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42891,
    density: 1710.3,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94523,
    lat: 37.95403,
    lng: -122.07608,
    city: "Pleasant Hill",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34929,
    density: 1871.6,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94525,
    lat: 38.04811,
    lng: -122.2292,
    city: "Crockett",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3231,
    density: 508.7,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94526,
    lat: 37.81472,
    lng: -121.98451,
    city: "Danville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33738,
    density: 989.1,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94528,
    lat: 37.84149,
    lng: -121.95819,
    city: "Diablo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 804,
    density: 269,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94530,
    lat: 37.92076,
    lng: -122.30068,
    city: "El Cerrito",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25925,
    density: 2311.5,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94531,
    lat: 37.95665,
    lng: -121.77777,
    city: "Antioch",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42163,
    density: 1160.5,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94533,
    lat: 38.28132,
    lng: -122.00693,
    city: "Fairfield",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 78695,
    density: 1348.9,
    county_fips: "06095",
    county_name: "Solano",
    county_weights: {
      "06095": 100,
    },
    county_names_all: "Solano",
    county_fips_all: "06095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94534,
    lat: 38.24112,
    lng: -122.12142,
    city: "Fairfield",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38471,
    density: 191.5,
    county_fips: "06095",
    county_name: "Solano",
    county_weights: {
      "06095": 100,
    },
    county_names_all: "Solano",
    county_fips_all: "06095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94535,
    lat: 38.27048,
    lng: -121.93851,
    city: "Travis Afb",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3407,
    density: 137,
    county_fips: "06095",
    county_name: "Solano",
    county_weights: {
      "06095": 100,
    },
    county_names_all: "Solano",
    county_fips_all: "06095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94536,
    lat: 37.57072,
    lng: -121.98555,
    city: "Fremont",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74544,
    density: 2044.6,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94538,
    lat: 37.50653,
    lng: -121.96361,
    city: "Fremont",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67283,
    density: 1570.8,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94539,
    lat: 37.51635,
    lng: -121.9119,
    city: "Fremont",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55006,
    density: 847,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94541,
    lat: 37.67376,
    lng: -122.08707,
    city: "Hayward",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 66182,
    density: 3427.9,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94542,
    lat: 37.6553,
    lng: -122.02584,
    city: "Hayward",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15149,
    density: 675.9,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94544,
    lat: 37.63352,
    lng: -122.05678,
    city: "Hayward",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 78333,
    density: 2761.6,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94545,
    lat: 37.62957,
    lng: -122.12048,
    city: "Hayward",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32552,
    density: 868,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94546,
    lat: 37.73441,
    lng: -122.09056,
    city: "Castro Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45085,
    density: 1090.9,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94547,
    lat: 38.00637,
    lng: -122.26117,
    city: "Hercules",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26090,
    density: 1776.5,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94548,
    lat: 37.97481,
    lng: -121.65265,
    city: "Knightsen",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 248,
    density: 41.4,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94549,
    lat: 37.90133,
    lng: -122.11933,
    city: "Lafayette",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29344,
    density: 570.9,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94550,
    lat: 37.51746,
    lng: -121.59406,
    city: "Livermore",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52617,
    density: 74.7,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 61.55,
      "06085": 38.45,
    },
    county_names_all: "Alameda|Santa Clara",
    county_fips_all: "06001|06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94551,
    lat: 37.75902,
    lng: -121.76026,
    city: "Livermore",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48151,
    density: 224.7,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 63.13,
      "06013": 36.87,
    },
    county_names_all: "Alameda|Contra Costa",
    county_fips_all: "06001|06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94552,
    lat: 37.70456,
    lng: -122.01359,
    city: "Castro Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15220,
    density: 113.4,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94553,
    lat: 37.97999,
    lng: -122.15368,
    city: "Martinez",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49801,
    density: 312,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94555,
    lat: 37.55083,
    lng: -122.08043,
    city: "Fremont",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38017,
    density: 1059.4,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94556,
    lat: 37.83102,
    lng: -122.10425,
    city: "Moraga",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15776,
    density: 315.9,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 99.9,
      "06001": 0.1,
    },
    county_names_all: "Contra Costa|Alameda",
    county_fips_all: "06013|06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94558,
    lat: 38.50846,
    lng: -122.26497,
    city: "Napa",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 66854,
    density: 64.6,
    county_fips: "06055",
    county_name: "Napa",
    county_weights: {
      "06055": 100,
    },
    county_names_all: "Napa",
    county_fips_all: "06055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94559,
    lat: 38.25238,
    lng: -122.29382,
    city: "Napa",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27564,
    density: 257.3,
    county_fips: "06055",
    county_name: "Napa",
    county_weights: {
      "06055": 100,
    },
    county_names_all: "Napa",
    county_fips_all: "06055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94560,
    lat: 37.50771,
    lng: -122.02523,
    city: "Newark",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48148,
    density: 926,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94561,
    lat: 37.99311,
    lng: -121.69172,
    city: "Oakley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43031,
    density: 958.2,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94562,
    lat: 38.43071,
    lng: -122.40874,
    city: "Oakville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06055",
    county_name: "Napa",
    county_weights: {
      "06055": 100,
    },
    county_names_all: "Napa",
    county_fips_all: "06055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94563,
    lat: 37.88196,
    lng: -122.19419,
    city: "Orinda",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19351,
    density: 364.1,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94564,
    lat: 37.98896,
    lng: -122.27018,
    city: "Pinole",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19201,
    density: 1085.5,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94565,
    lat: 38.00926,
    lng: -121.92886,
    city: "Pittsburg",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 97249,
    density: 829,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94566,
    lat: 37.65032,
    lng: -121.85881,
    city: "Pleasanton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45050,
    density: 856,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94567,
    lat: 38.66342,
    lng: -122.4349,
    city: "Pope Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 869,
    density: 4.6,
    county_fips: "06055",
    county_name: "Napa",
    county_weights: {
      "06055": 100,
    },
    county_names_all: "Napa",
    county_fips_all: "06055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94568,
    lat: 37.71596,
    lng: -121.90113,
    city: "Dublin",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57395,
    density: 1343.5,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94569,
    lat: 38.04411,
    lng: -122.19201,
    city: "Port Costa",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 242,
    density: 72.7,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94571,
    lat: 38.1566,
    lng: -121.7482,
    city: "Rio Vista",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10330,
    density: 36.6,
    county_fips: "06095",
    county_name: "Solano",
    county_weights: {
      "06095": 78.06,
      "06067": 21.94,
    },
    county_names_all: "Solano|Sacramento",
    county_fips_all: "06095|06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94572,
    lat: 38.02392,
    lng: -122.23285,
    city: "Rodeo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9997,
    density: 420,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94573,
    lat: 38.45726,
    lng: -122.42348,
    city: "Rutherford",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 70,
    density: 17.6,
    county_fips: "06055",
    county_name: "Napa",
    county_weights: {
      "06055": 100,
    },
    county_names_all: "Napa",
    county_fips_all: "06055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94574,
    lat: 38.52742,
    lng: -122.39261,
    city: "Saint Helena",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8527,
    density: 26.5,
    county_fips: "06055",
    county_name: "Napa",
    county_weights: {
      "06055": 98.73,
      "06097": 1.27,
    },
    county_names_all: "Napa|Sonoma",
    county_fips_all: "06055|06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94575,
    lat: 37.84235,
    lng: -122.11012,
    city: "Moraga",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1176,
    density: 2820.8,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94576,
    lat: 38.54932,
    lng: -122.47581,
    city: "Deer Park",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 123,
    density: 167.2,
    county_fips: "06055",
    county_name: "Napa",
    county_weights: {
      "06055": 100,
    },
    county_names_all: "Napa",
    county_fips_all: "06055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94577,
    lat: 37.71595,
    lng: -122.16615,
    city: "San Leandro",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48520,
    density: 2308.6,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94578,
    lat: 37.70675,
    lng: -122.1256,
    city: "San Leandro",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42468,
    density: 3596.9,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94579,
    lat: 37.68656,
    lng: -122.15709,
    city: "San Leandro",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21541,
    density: 2659.2,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94580,
    lat: 37.67803,
    lng: -122.13334,
    city: "San Lorenzo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29661,
    density: 3447,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94582,
    lat: 37.76357,
    lng: -121.91469,
    city: "San Ramon",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44721,
    density: 1287.5,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94583,
    lat: 37.77245,
    lng: -121.99157,
    city: "San Ramon",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38527,
    density: 700.5,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94585,
    lat: 38.19061,
    lng: -121.94216,
    city: "Suisun City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29351,
    density: 106.7,
    county_fips: "06095",
    county_name: "Solano",
    county_weights: {
      "06095": 100,
    },
    county_names_all: "Solano",
    county_fips_all: "06095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94586,
    lat: 37.57327,
    lng: -121.85472,
    city: "Sunol",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 817,
    density: 5.7,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94587,
    lat: 37.59142,
    lng: -122.06993,
    city: "Union City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75067,
    density: 1476.4,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94588,
    lat: 37.73801,
    lng: -121.88178,
    city: "Pleasanton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36324,
    density: 428.4,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 51.42,
      "06013": 48.58,
    },
    county_names_all: "Alameda|Contra Costa",
    county_fips_all: "06001|06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94589,
    lat: 38.14162,
    lng: -122.24596,
    city: "Vallejo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30206,
    density: 2058.8,
    county_fips: "06095",
    county_name: "Solano",
    county_weights: {
      "06095": 100,
    },
    county_names_all: "Solano",
    county_fips_all: "06095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94590,
    lat: 38.09546,
    lng: -122.24986,
    city: "Vallejo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37378,
    density: 2199.1,
    county_fips: "06095",
    county_name: "Solano",
    county_weights: {
      "06095": 100,
    },
    county_names_all: "Solano",
    county_fips_all: "06095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94591,
    lat: 38.12702,
    lng: -122.19635,
    city: "Vallejo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56333,
    density: 1031,
    county_fips: "06095",
    county_name: "Solano",
    county_weights: {
      "06095": 97.02,
      "06055": 2.98,
    },
    county_names_all: "Solano|Napa",
    county_fips_all: "06095|06055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94592,
    lat: 38.12009,
    lng: -122.3117,
    city: "Vallejo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1038,
    density: 50,
    county_fips: "06095",
    county_name: "Solano",
    county_weights: {
      "06095": 100,
    },
    county_names_all: "Solano",
    county_fips_all: "06095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94595,
    lat: 37.87206,
    lng: -122.06892,
    city: "Walnut Creek",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17730,
    density: 1311.8,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94596,
    lat: 37.88902,
    lng: -122.03676,
    city: "Walnut Creek",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22247,
    density: 1416.9,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94597,
    lat: 37.91768,
    lng: -122.0718,
    city: "Walnut Creek",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23263,
    density: 2216.2,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94598,
    lat: 37.89238,
    lng: -121.98283,
    city: "Walnut Creek",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26666,
    density: 499.5,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94599,
    lat: 38.41012,
    lng: -122.37365,
    city: "Yountville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3070,
    density: 149.2,
    county_fips: "06055",
    county_name: "Napa",
    county_weights: {
      "06055": 100,
    },
    county_names_all: "Napa",
    county_fips_all: "06055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94601,
    lat: 37.77684,
    lng: -122.21822,
    city: "Oakland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53104,
    density: 6408.9,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94602,
    lat: 37.80517,
    lng: -122.20422,
    city: "Oakland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29593,
    density: 3141.1,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94603,
    lat: 37.73923,
    lng: -122.17554,
    city: "Oakland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35486,
    density: 5078.1,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94605,
    lat: 37.76062,
    lng: -122.14903,
    city: "Oakland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43167,
    density: 1887.6,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94606,
    lat: 37.79179,
    lng: -122.24455,
    city: "Oakland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37640,
    density: 6247.8,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94607,
    lat: 37.80721,
    lng: -122.30024,
    city: "Oakland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25723,
    density: 1685.8,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94608,
    lat: 37.83611,
    lng: -122.28621,
    city: "Emeryville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31572,
    density: 4430,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94609,
    lat: 37.83476,
    lng: -122.2642,
    city: "Oakland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23729,
    density: 5501.5,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94610,
    lat: 37.81229,
    lng: -122.24048,
    city: "Oakland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31553,
    density: 5825.3,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94611,
    lat: 37.83191,
    lng: -122.21592,
    city: "Oakland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39042,
    density: 2065,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 94.86,
      "06013": 5.14,
    },
    county_names_all: "Alameda|Contra Costa",
    county_fips_all: "06001|06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94612,
    lat: 37.80789,
    lng: -122.2662,
    city: "Oakland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16203,
    density: 6528.7,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94613,
    lat: 37.78075,
    lng: -122.18308,
    city: "Oakland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 868,
    density: 1367.6,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94618,
    lat: 37.8442,
    lng: -122.23868,
    city: "Oakland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17110,
    density: 2726.4,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94619,
    lat: 37.79262,
    lng: -122.16001,
    city: "Oakland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24833,
    density: 1148.9,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94621,
    lat: 37.7379,
    lng: -122.20794,
    city: "Oakland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33820,
    density: 1533.8,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94702,
    lat: 37.86619,
    lng: -122.28634,
    city: "Berkeley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17000,
    density: 5120,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94703,
    lat: 37.86397,
    lng: -122.27573,
    city: "Berkeley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21942,
    density: 6579.2,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94704,
    lat: 37.8664,
    lng: -122.26088,
    city: "Berkeley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29509,
    density: 13387.4,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94705,
    lat: 37.86523,
    lng: -122.2384,
    city: "Berkeley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13612,
    density: 1554.6,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94706,
    lat: 37.88969,
    lng: -122.29581,
    city: "Albany",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21404,
    density: 5643.6,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 99.54,
      "06013": 0.46,
    },
    county_names_all: "Alameda|Contra Costa",
    county_fips_all: "06001|06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94707,
    lat: 37.89843,
    lng: -122.27917,
    city: "Berkeley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11887,
    density: 2604.7,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 64.47,
      "06013": 35.53,
    },
    county_names_all: "Alameda|Contra Costa",
    county_fips_all: "06001|06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94708,
    lat: 37.90276,
    lng: -122.26202,
    city: "Berkeley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11899,
    density: 1379.6,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 58.54,
      "06001": 41.46,
    },
    county_names_all: "Contra Costa|Alameda",
    county_fips_all: "06013|06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94709,
    lat: 37.87835,
    lng: -122.26613,
    city: "Berkeley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12411,
    density: 7092.9,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94710,
    lat: 37.86705,
    lng: -122.303,
    city: "Berkeley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8123,
    density: 1452,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94720,
    lat: 37.87185,
    lng: -122.25226,
    city: "Berkeley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2829,
    density: 1551.4,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 100,
    },
    county_names_all: "Alameda",
    county_fips_all: "06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94801,
    lat: 37.95217,
    lng: -122.38025,
    city: "Richmond",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31443,
    density: 1053.1,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94803,
    lat: 37.95683,
    lng: -122.28235,
    city: "El Sobrante",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26062,
    density: 785,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94804,
    lat: 37.92074,
    lng: -122.34204,
    city: "Richmond",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41440,
    density: 2469,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94805,
    lat: 37.94215,
    lng: -122.32364,
    city: "Richmond",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14292,
    density: 2958.4,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94806,
    lat: 37.97811,
    lng: -122.33618,
    city: "San Pablo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63603,
    density: 3127.6,
    county_fips: "06013",
    county_name: "Contra Costa",
    county_weights: {
      "06013": 100,
    },
    county_names_all: "Contra Costa",
    county_fips_all: "06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94901,
    lat: 37.98053,
    lng: -122.50249,
    city: "San Rafael",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41235,
    density: 1215.1,
    county_fips: "06041",
    county_name: "Marin",
    county_weights: {
      "06041": 100,
    },
    county_names_all: "Marin",
    county_fips_all: "06041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94903,
    lat: 38.02485,
    lng: -122.5522,
    city: "San Rafael",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30198,
    density: 586.4,
    county_fips: "06041",
    county_name: "Marin",
    county_weights: {
      "06041": 100,
    },
    county_names_all: "Marin",
    county_fips_all: "06041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94904,
    lat: 37.94841,
    lng: -122.55288,
    city: "Greenbrae",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13319,
    density: 1039.6,
    county_fips: "06041",
    county_name: "Marin",
    county_weights: {
      "06041": 100,
    },
    county_names_all: "Marin",
    county_fips_all: "06041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94920,
    lat: 37.88732,
    lng: -122.46549,
    city: "Belvedere Tiburon",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12592,
    density: 746.8,
    county_fips: "06041",
    county_name: "Marin",
    county_weights: {
      "06041": 99.82,
      "06075": 0.18,
    },
    county_names_all: "Marin|San Francisco",
    county_fips_all: "06041|06075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94922,
    lat: 38.35683,
    lng: -122.95098,
    city: "Bodega",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 726,
    density: 64.3,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94923,
    lat: 38.33588,
    lng: -123.02647,
    city: "Bodega Bay",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1185,
    density: 23.7,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94924,
    lat: 37.95411,
    lng: -122.73171,
    city: "Bolinas",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1273,
    density: 17.9,
    county_fips: "06041",
    county_name: "Marin",
    county_weights: {
      "06041": 100,
    },
    county_names_all: "Marin",
    county_fips_all: "06041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94925,
    lat: 37.92386,
    lng: -122.5132,
    city: "Corte Madera",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9793,
    density: 1177.4,
    county_fips: "06041",
    county_name: "Marin",
    county_weights: {
      "06041": 100,
    },
    county_names_all: "Marin",
    county_fips_all: "06041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94928,
    lat: 38.3459,
    lng: -122.6935,
    city: "Rohnert Park",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43908,
    density: 2188.6,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94929,
    lat: 38.25444,
    lng: -122.96243,
    city: "Dillon Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 309,
    density: 126.2,
    county_fips: "06041",
    county_name: "Marin",
    county_weights: {
      "06041": 100,
    },
    county_names_all: "Marin",
    county_fips_all: "06041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94930,
    lat: 37.97048,
    lng: -122.61108,
    city: "Fairfax",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8794,
    density: 238.5,
    county_fips: "06041",
    county_name: "Marin",
    county_weights: {
      "06041": 100,
    },
    county_names_all: "Marin",
    county_fips_all: "06041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94931,
    lat: 38.32229,
    lng: -122.71497,
    city: "Cotati",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9097,
    density: 454.1,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94933,
    lat: 38.01753,
    lng: -122.68814,
    city: "Forest Knolls",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 880,
    density: 105.8,
    county_fips: "06041",
    county_name: "Marin",
    county_weights: {
      "06041": 100,
    },
    county_names_all: "Marin",
    county_fips_all: "06041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94937,
    lat: 38.09466,
    lng: -122.92719,
    city: "Inverness",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 920,
    density: 6.3,
    county_fips: "06041",
    county_name: "Marin",
    county_weights: {
      "06041": 100,
    },
    county_names_all: "Marin",
    county_fips_all: "06041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94938,
    lat: 38.03024,
    lng: -122.72953,
    city: "Lagunitas",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 967,
    density: 39.4,
    county_fips: "06041",
    county_name: "Marin",
    county_weights: {
      "06041": 100,
    },
    county_names_all: "Marin",
    county_fips_all: "06041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94939,
    lat: 37.93725,
    lng: -122.53518,
    city: "Larkspur",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6910,
    density: 1130.5,
    county_fips: "06041",
    county_name: "Marin",
    county_weights: {
      "06041": 100,
    },
    county_names_all: "Marin",
    county_fips_all: "06041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94940,
    lat: 38.15754,
    lng: -122.86376,
    city: "Marshall",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 244,
    density: 3.6,
    county_fips: "06041",
    county_name: "Marin",
    county_weights: {
      "06041": 100,
    },
    county_names_all: "Marin",
    county_fips_all: "06041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94941,
    lat: 37.92562,
    lng: -122.60083,
    city: "Mill Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32707,
    density: 334.9,
    county_fips: "06041",
    county_name: "Marin",
    county_weights: {
      "06041": 100,
    },
    county_names_all: "Marin",
    county_fips_all: "06041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94945,
    lat: 38.1258,
    lng: -122.55443,
    city: "Novato",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18084,
    density: 299.6,
    county_fips: "06041",
    county_name: "Marin",
    county_weights: {
      "06041": 100,
    },
    county_names_all: "Marin",
    county_fips_all: "06041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94946,
    lat: 38.07176,
    lng: -122.68785,
    city: "Nicasio",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 723,
    density: 7.5,
    county_fips: "06041",
    county_name: "Marin",
    county_weights: {
      "06041": 100,
    },
    county_names_all: "Marin",
    county_fips_all: "06041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94947,
    lat: 38.10705,
    lng: -122.62813,
    city: "Novato",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25809,
    density: 454.3,
    county_fips: "06041",
    county_name: "Marin",
    county_weights: {
      "06041": 100,
    },
    county_names_all: "Marin",
    county_fips_all: "06041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94949,
    lat: 38.06576,
    lng: -122.53172,
    city: "Novato",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17942,
    density: 516.1,
    county_fips: "06041",
    county_name: "Marin",
    county_weights: {
      "06041": 100,
    },
    county_names_all: "Marin",
    county_fips_all: "06041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94950,
    lat: 38.02122,
    lng: -122.76187,
    city: "Olema",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 118,
    density: 9.4,
    county_fips: "06041",
    county_name: "Marin",
    county_weights: {
      "06041": 100,
    },
    county_names_all: "Marin",
    county_fips_all: "06041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94951,
    lat: 38.32252,
    lng: -122.64492,
    city: "Penngrove",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3672,
    density: 110.3,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94952,
    lat: 38.23007,
    lng: -122.76338,
    city: "Petaluma",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35198,
    density: 68.5,
    county_fips: "06041",
    county_name: "Marin",
    county_weights: {
      "06041": 51.34,
      "06097": 48.66,
    },
    county_names_all: "Marin|Sonoma",
    county_fips_all: "06041|06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94954,
    lat: 38.24624,
    lng: -122.56627,
    city: "Petaluma",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39018,
    density: 242.3,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94956,
    lat: 38.0476,
    lng: -122.81046,
    city: "Point Reyes Station",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1181,
    density: 13.1,
    county_fips: "06041",
    county_name: "Marin",
    county_weights: {
      "06041": 100,
    },
    county_names_all: "Marin",
    county_fips_all: "06041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94957,
    lat: 37.96343,
    lng: -122.56174,
    city: "Ross",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1185,
    density: 322.1,
    county_fips: "06041",
    county_name: "Marin",
    county_weights: {
      "06041": 100,
    },
    county_names_all: "Marin",
    county_fips_all: "06041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94960,
    lat: 37.99707,
    lng: -122.57838,
    city: "San Anselmo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16199,
    density: 1063.8,
    county_fips: "06041",
    county_name: "Marin",
    county_weights: {
      "06041": 100,
    },
    county_names_all: "Marin",
    county_fips_all: "06041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94963,
    lat: 38.00765,
    lng: -122.66484,
    city: "San Geronimo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 195,
    density: 47.2,
    county_fips: "06041",
    county_name: "Marin",
    county_weights: {
      "06041": 100,
    },
    county_names_all: "Marin",
    county_fips_all: "06041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94964,
    lat: 37.94235,
    lng: -122.49244,
    city: "San Quentin",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2959,
    density: 2502.9,
    county_fips: "06041",
    county_name: "Marin",
    county_weights: {
      "06041": 100,
    },
    county_names_all: "Marin",
    county_fips_all: "06041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94965,
    lat: 37.85263,
    lng: -122.52699,
    city: "Sausalito",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11438,
    density: 302.9,
    county_fips: "06041",
    county_name: "Marin",
    county_weights: {
      "06041": 100,
    },
    county_names_all: "Marin",
    county_fips_all: "06041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94970,
    lat: 37.91694,
    lng: -122.65553,
    city: "Stinson Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 653,
    density: 34.9,
    county_fips: "06041",
    county_name: "Marin",
    county_weights: {
      "06041": 100,
    },
    county_names_all: "Marin",
    county_fips_all: "06041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94971,
    lat: 38.23724,
    lng: -122.89006,
    city: "Tomales",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 197,
    density: 3.4,
    county_fips: "06041",
    county_name: "Marin",
    county_weights: {
      "06041": 100,
    },
    county_names_all: "Marin",
    county_fips_all: "06041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94972,
    lat: 38.33665,
    lng: -122.93934,
    city: "Valley Ford",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 94973,
    lat: 38.01259,
    lng: -122.63947,
    city: "Woodacre",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1515,
    density: 148.1,
    county_fips: "06041",
    county_name: "Marin",
    county_weights: {
      "06041": 100,
    },
    county_names_all: "Marin",
    county_fips_all: "06041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95002,
    lat: 37.44075,
    lng: -122.00047,
    city: "Alviso",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2251,
    density: 90.7,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95003,
    lat: 37.0089,
    lng: -121.87775,
    city: "Aptos",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25230,
    density: 300.4,
    county_fips: "06087",
    county_name: "Santa Cruz",
    county_weights: {
      "06087": 100,
    },
    county_names_all: "Santa Cruz",
    county_fips_all: "06087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95004,
    lat: 36.86818,
    lng: -121.63237,
    city: "Aromas",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4295,
    density: 75.5,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 56.39,
      "06069": 43.61,
    },
    county_names_all: "Monterey|San Benito",
    county_fips_all: "06053|06069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95005,
    lat: 37.09835,
    lng: -122.08931,
    city: "Ben Lomond",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7731,
    density: 252.7,
    county_fips: "06087",
    county_name: "Santa Cruz",
    county_weights: {
      "06087": 100,
    },
    county_names_all: "Santa Cruz",
    county_fips_all: "06087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95006,
    lat: 37.17129,
    lng: -122.151,
    city: "Boulder Creek",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9457,
    density: 66.2,
    county_fips: "06087",
    county_name: "Santa Cruz",
    county_weights: {
      "06087": 100,
    },
    county_names_all: "Santa Cruz",
    county_fips_all: "06087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95007,
    lat: 37.11019,
    lng: -122.11434,
    city: "Brookdale",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 395,
    density: 96.2,
    county_fips: "06087",
    county_name: "Santa Cruz",
    county_weights: {
      "06087": 100,
    },
    county_names_all: "Santa Cruz",
    county_fips_all: "06087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95008,
    lat: 37.27977,
    lng: -121.95481,
    city: "Campbell",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47886,
    density: 2860.6,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95010,
    lat: 36.97721,
    lng: -121.95466,
    city: "Capitola",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8908,
    density: 2487.3,
    county_fips: "06087",
    county_name: "Santa Cruz",
    county_weights: {
      "06087": 100,
    },
    county_names_all: "Santa Cruz",
    county_fips_all: "06087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95012,
    lat: 36.78373,
    lng: -121.74164,
    city: "Castroville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10083,
    density: 301.5,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 100,
    },
    county_names_all: "Monterey",
    county_fips_all: "06053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95013,
    lat: 37.21531,
    lng: -121.73962,
    city: "Coyote",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34,
    density: 7.4,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95014,
    lat: 37.30827,
    lng: -122.07981,
    city: "Cupertino",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61480,
    density: 954.8,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95017,
    lat: 37.10529,
    lng: -122.22913,
    city: "Davenport",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 831,
    density: 5.1,
    county_fips: "06087",
    county_name: "Santa Cruz",
    county_weights: {
      "06087": 100,
    },
    county_names_all: "Santa Cruz",
    county_fips_all: "06087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95018,
    lat: 37.08027,
    lng: -122.05824,
    city: "Felton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6348,
    density: 140.5,
    county_fips: "06087",
    county_name: "Santa Cruz",
    county_weights: {
      "06087": 100,
    },
    county_names_all: "Santa Cruz",
    county_fips_all: "06087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95019,
    lat: 36.93575,
    lng: -121.78458,
    city: "Freedom",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8743,
    density: 3085.3,
    county_fips: "06087",
    county_name: "Santa Cruz",
    county_weights: {
      "06087": 100,
    },
    county_names_all: "Santa Cruz",
    county_fips_all: "06087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95020,
    lat: 37.01461,
    lng: -121.55718,
    city: "Gilroy",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63522,
    density: 161.6,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95023,
    lat: 36.92113,
    lng: -121.36117,
    city: "Hollister",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54197,
    density: 53,
    county_fips: "06069",
    county_name: "San Benito",
    county_weights: {
      "06069": 63.42,
      "06085": 36.58,
    },
    county_names_all: "San Benito|Santa Clara",
    county_fips_all: "06069|06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95030,
    lat: 37.22168,
    lng: -121.98326,
    city: "Los Gatos",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13631,
    density: 499.1,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95032,
    lat: 37.20859,
    lng: -121.92359,
    city: "Los Gatos",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25865,
    density: 535,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95033,
    lat: 37.15701,
    lng: -121.97771,
    city: "Los Gatos",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9910,
    density: 42.8,
    county_fips: "06087",
    county_name: "Santa Cruz",
    county_weights: {
      "06087": 52.17,
      "06085": 47.83,
    },
    county_names_all: "Santa Cruz|Santa Clara",
    county_fips_all: "06087|06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95035,
    lat: 37.44319,
    lng: -121.87632,
    city: "Milpitas",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75367,
    density: 1297.2,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95037,
    lat: 37.13213,
    lng: -121.67886,
    city: "Morgan Hill",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51968,
    density: 167.1,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95039,
    lat: 36.81515,
    lng: -121.7779,
    city: "Moss Landing",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1209,
    density: 26.9,
    county_fips: "06053",
    county_name: "Monterey",
    county_weights: {
      "06053": 100,
    },
    county_names_all: "Monterey",
    county_fips_all: "06053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95041,
    lat: 37.05052,
    lng: -122.05828,
    city: "Mount Hermon",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 349,
    density: 696.3,
    county_fips: "06087",
    county_name: "Santa Cruz",
    county_weights: {
      "06087": 100,
    },
    county_names_all: "Santa Cruz",
    county_fips_all: "06087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95043,
    lat: 36.51652,
    lng: -120.97677,
    city: "Paicines",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 727,
    density: 0.4,
    county_fips: "06069",
    county_name: "San Benito",
    county_weights: {
      "06069": 100,
    },
    county_names_all: "San Benito",
    county_fips_all: "06069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95045,
    lat: 36.83281,
    lng: -121.52576,
    city: "San Juan Bautista",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4340,
    density: 35.4,
    county_fips: "06069",
    county_name: "San Benito",
    county_weights: {
      "06069": 100,
    },
    county_names_all: "San Benito",
    county_fips_all: "06069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95046,
    lat: 37.09576,
    lng: -121.59649,
    city: "San Martin",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5905,
    density: 121.2,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95050,
    lat: 37.3504,
    lng: -121.95238,
    city: "Santa Clara",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38884,
    density: 2752,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95051,
    lat: 37.3483,
    lng: -121.98444,
    city: "Santa Clara",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59209,
    density: 3468.4,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95053,
    lat: 37.34848,
    lng: -121.93737,
    city: "Santa Clara",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3835,
    density: 10093.6,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95054,
    lat: 37.39308,
    lng: -121.96483,
    city: "Santa Clara",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23959,
    density: 1440.2,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95060,
    lat: 37.01352,
    lng: -122.10176,
    city: "Santa Cruz",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48910,
    density: 346.2,
    county_fips: "06087",
    county_name: "Santa Cruz",
    county_weights: {
      "06087": 100,
    },
    county_names_all: "Santa Cruz",
    county_fips_all: "06087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95062,
    lat: 36.97279,
    lng: -121.99008,
    city: "Santa Cruz",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36413,
    density: 2782.5,
    county_fips: "06087",
    county_name: "Santa Cruz",
    county_weights: {
      "06087": 100,
    },
    county_names_all: "Santa Cruz",
    county_fips_all: "06087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95064,
    lat: 36.99158,
    lng: -122.05886,
    city: "Santa Cruz",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10622,
    density: 2409.8,
    county_fips: "06087",
    county_name: "Santa Cruz",
    county_weights: {
      "06087": 100,
    },
    county_names_all: "Santa Cruz",
    county_fips_all: "06087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95065,
    lat: 37.03229,
    lng: -121.98444,
    city: "Santa Cruz",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8164,
    density: 288,
    county_fips: "06087",
    county_name: "Santa Cruz",
    county_weights: {
      "06087": 100,
    },
    county_names_all: "Santa Cruz",
    county_fips_all: "06087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95066,
    lat: 37.0672,
    lng: -122.01453,
    city: "Scotts Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15275,
    density: 315,
    county_fips: "06087",
    county_name: "Santa Cruz",
    county_weights: {
      "06087": 100,
    },
    county_names_all: "Santa Cruz",
    county_fips_all: "06087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95070,
    lat: 37.25624,
    lng: -122.05151,
    city: "Saratoga",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31442,
    density: 428.6,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95073,
    lat: 37.04068,
    lng: -121.93174,
    city: "Soquel",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11289,
    density: 190.3,
    county_fips: "06087",
    county_name: "Santa Cruz",
    county_weights: {
      "06087": 100,
    },
    county_names_all: "Santa Cruz",
    county_fips_all: "06087",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95075,
    lat: 36.80112,
    lng: -121.19258,
    city: "Tres Pinos",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 429,
    density: 1.8,
    county_fips: "06069",
    county_name: "San Benito",
    county_weights: {
      "06069": 100,
    },
    county_names_all: "San Benito",
    county_fips_all: "06069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95076,
    lat: 36.94029,
    lng: -121.75089,
    city: "Watsonville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 84281,
    density: 240.9,
    county_fips: "06087",
    county_name: "Santa Cruz",
    county_weights: {
      "06087": 74.54,
      "06053": 22.64,
      "06085": 2.82,
    },
    county_names_all: "Santa Cruz|Monterey|Santa Clara",
    county_fips_all: "06087|06053|06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95110,
    lat: 37.34656,
    lng: -121.9097,
    city: "San Jose",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20004,
    density: 1695.9,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95111,
    lat: 37.28401,
    lng: -121.82731,
    city: "San Jose",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61183,
    density: 4069.1,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95112,
    lat: 37.34461,
    lng: -121.88346,
    city: "San Jose",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59959,
    density: 3184.4,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95113,
    lat: 37.3339,
    lng: -121.8905,
    city: "San Jose",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2550,
    density: 2826.9,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95116,
    lat: 37.35043,
    lng: -121.85255,
    city: "San Jose",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54758,
    density: 5932.7,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95117,
    lat: 37.31008,
    lng: -121.96225,
    city: "San Jose",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31702,
    density: 5275.3,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95118,
    lat: 37.25589,
    lng: -121.88991,
    city: "San Jose",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32768,
    density: 3111.7,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95119,
    lat: 37.22756,
    lng: -121.79077,
    city: "San Jose",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10450,
    density: 948.9,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95120,
    lat: 37.18428,
    lng: -121.83658,
    city: "San Jose",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38177,
    density: 375.1,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95121,
    lat: 37.30463,
    lng: -121.80981,
    city: "San Jose",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38258,
    density: 3323,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95122,
    lat: 37.32925,
    lng: -121.83481,
    city: "San Jose",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55619,
    density: 4490.7,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95123,
    lat: 37.24479,
    lng: -121.83306,
    city: "San Jose",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 70005,
    density: 3455.5,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95124,
    lat: 37.25684,
    lng: -121.92286,
    city: "San Jose",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52049,
    density: 3050.2,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95125,
    lat: 37.29554,
    lng: -121.89408,
    city: "San Jose",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54076,
    density: 2866.1,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95126,
    lat: 37.32687,
    lng: -121.91677,
    city: "San Jose",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37063,
    density: 4313.5,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95127,
    lat: 37.37453,
    lng: -121.78733,
    city: "San Jose",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63220,
    density: 1282.6,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95128,
    lat: 37.31579,
    lng: -121.93647,
    city: "San Jose",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35986,
    density: 3534.7,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95129,
    lat: 37.30597,
    lng: -122.00072,
    city: "San Jose",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40277,
    density: 3408,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95130,
    lat: 37.28803,
    lng: -121.98146,
    city: "San Jose",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14051,
    density: 3770.1,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95131,
    lat: 37.38729,
    lng: -121.89793,
    city: "San Jose",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32096,
    density: 2145.7,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95132,
    lat: 37.41994,
    lng: -121.79059,
    city: "San Jose",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42726,
    density: 603.1,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95133,
    lat: 37.37171,
    lng: -121.86057,
    city: "San Jose",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28158,
    density: 3333.5,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95134,
    lat: 37.43003,
    lng: -121.94528,
    city: "San Jose",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30499,
    density: 1089.5,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95135,
    lat: 37.22285,
    lng: -121.55913,
    city: "San Jose",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22509,
    density: 67.1,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95136,
    lat: 37.27192,
    lng: -121.85237,
    city: "San Jose",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48492,
    density: 3598.3,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95138,
    lat: 37.2462,
    lng: -121.73287,
    city: "San Jose",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20597,
    density: 305.4,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95139,
    lat: 37.22489,
    lng: -121.76393,
    city: "San Jose",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7262,
    density: 2326.6,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95140,
    lat: 37.3483,
    lng: -121.64085,
    city: "Mount Hamilton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56,
    density: 0.3,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95148,
    lat: 37.33252,
    lng: -121.78142,
    city: "San Jose",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48629,
    density: 2381.9,
    county_fips: "06085",
    county_name: "Santa Clara",
    county_weights: {
      "06085": 100,
    },
    county_names_all: "Santa Clara",
    county_fips_all: "06085",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95202,
    lat: 37.95968,
    lng: -121.28772,
    city: "Stockton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6607,
    density: 2406.2,
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 100,
    },
    county_names_all: "San Joaquin",
    county_fips_all: "06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95203,
    lat: 37.95237,
    lng: -121.33098,
    city: "Stockton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15561,
    density: 974.5,
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 100,
    },
    county_names_all: "San Joaquin",
    county_fips_all: "06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95204,
    lat: 37.97403,
    lng: -121.31906,
    city: "Stockton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28860,
    density: 2101.7,
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 100,
    },
    county_names_all: "San Joaquin",
    county_fips_all: "06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95205,
    lat: 37.96425,
    lng: -121.25955,
    city: "Stockton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37133,
    density: 1594.6,
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 100,
    },
    county_names_all: "San Joaquin",
    county_fips_all: "06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95206,
    lat: 37.8961,
    lng: -121.41051,
    city: "Stockton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65643,
    density: 190.2,
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 100,
    },
    county_names_all: "San Joaquin",
    county_fips_all: "06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95207,
    lat: 38.00242,
    lng: -121.325,
    city: "Stockton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51652,
    density: 2752.3,
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 100,
    },
    county_names_all: "San Joaquin",
    county_fips_all: "06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95209,
    lat: 38.04717,
    lng: -121.35121,
    city: "Stockton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44325,
    density: 2077.4,
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 100,
    },
    county_names_all: "San Joaquin",
    county_fips_all: "06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95210,
    lat: 38.03215,
    lng: -121.29782,
    city: "Stockton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41641,
    density: 2114.3,
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 100,
    },
    county_names_all: "San Joaquin",
    county_fips_all: "06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95211,
    lat: 37.98078,
    lng: -121.31198,
    city: "Stockton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2343,
    density: 9169,
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 100,
    },
    county_names_all: "San Joaquin",
    county_fips_all: "06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95212,
    lat: 38.04897,
    lng: -121.22684,
    city: "Stockton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28281,
    density: 515.5,
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 100,
    },
    county_names_all: "San Joaquin",
    county_fips_all: "06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95215,
    lat: 37.9444,
    lng: -121.15276,
    city: "Stockton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25473,
    density: 106,
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 100,
    },
    county_names_all: "San Joaquin",
    county_fips_all: "06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95219,
    lat: 38.0207,
    lng: -121.51584,
    city: "Stockton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29117,
    density: 96.2,
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 80.4,
      "06013": 19.6,
    },
    county_names_all: "San Joaquin|Contra Costa",
    county_fips_all: "06077|06013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95220,
    lat: 38.19779,
    lng: -121.23603,
    city: "Acampo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8228,
    density: 54.7,
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 100,
    },
    county_names_all: "San Joaquin",
    county_fips_all: "06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95221,
    lat: 38.0724,
    lng: -120.54852,
    city: "Altaville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06009",
    county_name: "Calaveras",
    county_weights: {
      "06009": 100,
    },
    county_names_all: "Calaveras",
    county_fips_all: "06009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95222,
    lat: 38.06127,
    lng: -120.61791,
    city: "Angels Camp",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5418,
    density: 13.8,
    county_fips: "06009",
    county_name: "Calaveras",
    county_weights: {
      "06009": 100,
    },
    county_names_all: "Calaveras",
    county_fips_all: "06009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95223,
    lat: 38.4644,
    lng: -119.85939,
    city: "Arnold",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2602,
    density: 2.4,
    county_fips: "06003",
    county_name: "Alpine",
    county_weights: {
      "06003": 80.95,
      "06009": 17.26,
      "06109": 1.79,
    },
    county_names_all: "Alpine|Calaveras|Tuolumne",
    county_fips_all: "06003|06009|06109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95224,
    lat: 38.22706,
    lng: -120.32562,
    city: "Avery",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 195,
    density: 6.5,
    county_fips: "06009",
    county_name: "Calaveras",
    county_weights: {
      "06009": 100,
    },
    county_names_all: "Calaveras",
    county_fips_all: "06009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95225,
    lat: 38.20399,
    lng: -120.86488,
    city: "Burson",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 618,
    density: 24.6,
    county_fips: "06009",
    county_name: "Calaveras",
    county_weights: {
      "06009": 100,
    },
    county_names_all: "Calaveras",
    county_fips_all: "06009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95226,
    lat: 38.23377,
    lng: -120.86232,
    city: "Campo Seco",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "06009",
    county_name: "Calaveras",
    county_weights: {
      "06009": 100,
    },
    county_names_all: "Calaveras",
    county_fips_all: "06009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95227,
    lat: 38.20678,
    lng: -121.04615,
    city: "Clements",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 734,
    density: 7.4,
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 100,
    },
    county_names_all: "San Joaquin",
    county_fips_all: "06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95228,
    lat: 37.94669,
    lng: -120.68067,
    city: "Copperopolis",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4486,
    density: 18.9,
    county_fips: "06009",
    county_name: "Calaveras",
    county_weights: {
      "06009": 100,
    },
    county_names_all: "Calaveras",
    county_fips_all: "06009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95230,
    lat: 37.97361,
    lng: -120.86492,
    city: "Farmington",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 661,
    density: 1.9,
    county_fips: "06099",
    county_name: "Stanislaus",
    county_weights: {
      "06099": 48.49,
      "06009": 30.08,
      "06077": 21.42,
    },
    county_names_all: "Stanislaus|Calaveras|San Joaquin",
    county_fips_all: "06099|06009|06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95231,
    lat: 37.87331,
    lng: -121.29272,
    city: "French Camp",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5520,
    density: 198,
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 100,
    },
    county_names_all: "San Joaquin",
    county_fips_all: "06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95232,
    lat: 38.36051,
    lng: -120.57722,
    city: "Glencoe",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 203,
    density: 15.8,
    county_fips: "06009",
    county_name: "Calaveras",
    county_weights: {
      "06009": 100,
    },
    county_names_all: "Calaveras",
    county_fips_all: "06009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95233,
    lat: 38.18622,
    lng: -120.36859,
    city: "Hathaway Pines",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 381,
    density: 91.3,
    county_fips: "06009",
    county_name: "Calaveras",
    county_weights: {
      "06009": 100,
    },
    county_names_all: "Calaveras",
    county_fips_all: "06009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95236,
    lat: 38.04218,
    lng: -121.03176,
    city: "Linden",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4458,
    density: 13.5,
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 98.09,
      "06009": 1.91,
    },
    county_names_all: "San Joaquin|Calaveras",
    county_fips_all: "06077|06009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95237,
    lat: 38.15953,
    lng: -121.14845,
    city: "Lockeford",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3655,
    density: 190.3,
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 100,
    },
    county_names_all: "San Joaquin",
    county_fips_all: "06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95240,
    lat: 38.1177,
    lng: -121.1627,
    city: "Lodi",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49439,
    density: 279.9,
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 100,
    },
    county_names_all: "San Joaquin",
    county_fips_all: "06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95242,
    lat: 38.13204,
    lng: -121.38875,
    city: "Lodi",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27340,
    density: 116.2,
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 100,
    },
    county_names_all: "San Joaquin",
    county_fips_all: "06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95245,
    lat: 38.30189,
    lng: -120.61975,
    city: "Mokelumne Hill",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1650,
    density: 9.1,
    county_fips: "06009",
    county_name: "Calaveras",
    county_weights: {
      "06009": 100,
    },
    county_names_all: "Calaveras",
    county_fips_all: "06009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95246,
    lat: 38.23662,
    lng: -120.49589,
    city: "Mountain Ranch",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1234,
    density: 6.9,
    county_fips: "06009",
    county_name: "Calaveras",
    county_weights: {
      "06009": 100,
    },
    county_names_all: "Calaveras",
    county_fips_all: "06009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95247,
    lat: 38.14264,
    lng: -120.44359,
    city: "Murphys",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3853,
    density: 31.6,
    county_fips: "06009",
    county_name: "Calaveras",
    county_weights: {
      "06009": 100,
    },
    county_names_all: "Calaveras",
    county_fips_all: "06009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95248,
    lat: 38.32433,
    lng: -120.46051,
    city: "Rail Road Flat",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 108,
    density: 1.3,
    county_fips: "06009",
    county_name: "Calaveras",
    county_weights: {
      "06009": 100,
    },
    county_names_all: "Calaveras",
    county_fips_all: "06009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95249,
    lat: 38.18986,
    lng: -120.61784,
    city: "San Andreas",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5988,
    density: 28.5,
    county_fips: "06009",
    county_name: "Calaveras",
    county_weights: {
      "06009": 100,
    },
    county_names_all: "Calaveras",
    county_fips_all: "06009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95251,
    lat: 38.08024,
    lng: -120.45769,
    city: "Vallecito",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 496,
    density: 15.7,
    county_fips: "06009",
    county_name: "Calaveras",
    county_weights: {
      "06009": 100,
    },
    county_names_all: "Calaveras",
    county_fips_all: "06009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95252,
    lat: 38.15871,
    lng: -120.84214,
    city: "Valley Springs",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15779,
    density: 53.4,
    county_fips: "06009",
    county_name: "Calaveras",
    county_weights: {
      "06009": 100,
    },
    county_names_all: "Calaveras",
    county_fips_all: "06009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95253,
    lat: 38.14725,
    lng: -121.19525,
    city: "Victor",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 100,
    },
    county_names_all: "San Joaquin",
    county_fips_all: "06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95254,
    lat: 38.20323,
    lng: -120.95857,
    city: "Wallace",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 721,
    density: 57.1,
    county_fips: "06009",
    county_name: "Calaveras",
    county_weights: {
      "06009": 100,
    },
    county_names_all: "Calaveras",
    county_fips_all: "06009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95255,
    lat: 38.42055,
    lng: -120.47506,
    city: "West Point",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1591,
    density: 13.9,
    county_fips: "06009",
    county_name: "Calaveras",
    county_weights: {
      "06009": 100,
    },
    county_names_all: "Calaveras",
    county_fips_all: "06009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95257,
    lat: 38.38068,
    lng: -120.45255,
    city: "Wilseyville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 386,
    density: 12.7,
    county_fips: "06009",
    county_name: "Calaveras",
    county_weights: {
      "06009": 100,
    },
    county_names_all: "Calaveras",
    county_fips_all: "06009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95258,
    lat: 38.16811,
    lng: -121.31011,
    city: "Woodbridge",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3820,
    density: 458.2,
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 100,
    },
    county_names_all: "San Joaquin",
    county_fips_all: "06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95301,
    lat: 37.30634,
    lng: -120.65119,
    city: "Atwater",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39922,
    density: 202.6,
    county_fips: "06047",
    county_name: "Merced",
    county_weights: {
      "06047": 100,
    },
    county_names_all: "Merced",
    county_fips_all: "06047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95303,
    lat: 37.4714,
    lng: -120.67744,
    city: "Ballico",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1019,
    density: 13.6,
    county_fips: "06047",
    county_name: "Merced",
    county_weights: {
      "06047": 100,
    },
    county_names_all: "Merced",
    county_fips_all: "06047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95304,
    lat: 37.6773,
    lng: -121.3948,
    city: "Tracy",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15533,
    density: 39.1,
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 100,
    },
    county_names_all: "San Joaquin",
    county_fips_all: "06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95305,
    lat: 37.8306,
    lng: -120.34821,
    city: "Big Oak Flat",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "06109",
    county_name: "Tuolumne",
    county_weights: {
      "06109": 100,
    },
    county_names_all: "Tuolumne",
    county_fips_all: "06109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95306,
    lat: 37.36015,
    lng: -120.11581,
    city: "Catheys Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 841,
    density: 2,
    county_fips: "06043",
    county_name: "Mariposa",
    county_weights: {
      "06043": 100,
    },
    county_names_all: "Mariposa",
    county_fips_all: "06043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95307,
    lat: 37.55582,
    lng: -120.95385,
    city: "Ceres",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47130,
    density: 554.2,
    county_fips: "06099",
    county_name: "Stanislaus",
    county_weights: {
      "06099": 100,
    },
    county_names_all: "Stanislaus",
    county_fips_all: "06099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95309,
    lat: 37.87154,
    lng: -120.43299,
    city: "Chinese Camp",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06109",
    county_name: "Tuolumne",
    county_weights: {
      "06109": 100,
    },
    county_names_all: "Tuolumne",
    county_fips_all: "06109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95310,
    lat: 38.09944,
    lng: -120.36171,
    city: "Columbia",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1654,
    density: 14.3,
    county_fips: "06109",
    county_name: "Tuolumne",
    county_weights: {
      "06109": 100,
    },
    county_names_all: "Tuolumne",
    county_fips_all: "06109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95311,
    lat: 37.70443,
    lng: -120.08344,
    city: "Coulterville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1976,
    density: 3.2,
    county_fips: "06043",
    county_name: "Mariposa",
    county_weights: {
      "06043": 97.87,
      "06109": 2.13,
    },
    county_names_all: "Mariposa|Tuolumne",
    county_fips_all: "06043|06109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95312,
    lat: 37.42107,
    lng: -120.65295,
    city: "Cressey",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 206,
    density: 81.1,
    county_fips: "06047",
    county_name: "Merced",
    county_weights: {
      "06047": 100,
    },
    county_names_all: "Merced",
    county_fips_all: "06047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95313,
    lat: 37.43511,
    lng: -121.03769,
    city: "Crows Landing",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1166,
    density: 9.8,
    county_fips: "06099",
    county_name: "Stanislaus",
    county_weights: {
      "06099": 100,
    },
    county_names_all: "Stanislaus",
    county_fips_all: "06099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95315,
    lat: 37.42243,
    lng: -120.7733,
    city: "Delhi",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14434,
    density: 294.2,
    county_fips: "06047",
    county_name: "Merced",
    county_weights: {
      "06047": 100,
    },
    county_names_all: "Merced",
    county_fips_all: "06047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95316,
    lat: 37.54613,
    lng: -120.69212,
    city: "Denair",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8090,
    density: 38.2,
    county_fips: "06099",
    county_name: "Stanislaus",
    county_weights: {
      "06099": 76.76,
      "06047": 23.24,
    },
    county_names_all: "Stanislaus|Merced",
    county_fips_all: "06099|06047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95317,
    lat: 37.12947,
    lng: -120.5074,
    city: "El Nido",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1085,
    density: 9.1,
    county_fips: "06047",
    county_name: "Merced",
    county_weights: {
      "06047": 100,
    },
    county_names_all: "Merced",
    county_fips_all: "06047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95318,
    lat: 37.66618,
    lng: -119.8064,
    city: "El Portal",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 271,
    density: 1.8,
    county_fips: "06043",
    county_name: "Mariposa",
    county_weights: {
      "06043": 100,
    },
    county_names_all: "Mariposa",
    county_fips_all: "06043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95319,
    lat: 37.6309,
    lng: -120.87728,
    city: "Empire",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1548,
    density: 236.7,
    county_fips: "06099",
    county_name: "Stanislaus",
    county_weights: {
      "06099": 100,
    },
    county_names_all: "Stanislaus",
    county_fips_all: "06099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95320,
    lat: 37.82453,
    lng: -121.01545,
    city: "Escalon",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12990,
    density: 56.5,
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 100,
    },
    county_names_all: "San Joaquin",
    county_fips_all: "06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95321,
    lat: 37.97719,
    lng: -119.75012,
    city: "Groveland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3544,
    density: 3,
    county_fips: "06109",
    county_name: "Tuolumne",
    county_weights: {
      "06109": 98.06,
      "06043": 1.94,
    },
    county_names_all: "Tuolumne|Mariposa",
    county_fips_all: "06109|06043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95322,
    lat: 37.17622,
    lng: -121.01861,
    city: "Gustine",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10016,
    density: 22.8,
    county_fips: "06047",
    county_name: "Merced",
    county_weights: {
      "06047": 97.68,
      "06099": 2.32,
    },
    county_names_all: "Merced|Stanislaus",
    county_fips_all: "06047|06099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95323,
    lat: 37.60881,
    lng: -120.68464,
    city: "Hickman",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1484,
    density: 18.3,
    county_fips: "06099",
    county_name: "Stanislaus",
    county_weights: {
      "06099": 100,
    },
    county_names_all: "Stanislaus",
    county_fips_all: "06099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95324,
    lat: 37.39452,
    lng: -120.89605,
    city: "Hilmar",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8738,
    density: 84,
    county_fips: "06047",
    county_name: "Merced",
    county_weights: {
      "06047": 100,
    },
    county_names_all: "Merced",
    county_fips_all: "06047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95325,
    lat: 37.48058,
    lng: -120.24208,
    city: "Hornitos",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65,
    density: 0.8,
    county_fips: "06043",
    county_name: "Mariposa",
    county_weights: {
      "06043": 100,
    },
    county_names_all: "Mariposa",
    county_fips_all: "06043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95326,
    lat: 37.58998,
    lng: -120.8531,
    city: "Hughson",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10669,
    density: 155.4,
    county_fips: "06099",
    county_name: "Stanislaus",
    county_weights: {
      "06099": 100,
    },
    county_names_all: "Stanislaus",
    county_fips_all: "06099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95327,
    lat: 37.84912,
    lng: -120.4858,
    city: "Jamestown",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8542,
    density: 20.8,
    county_fips: "06109",
    county_name: "Tuolumne",
    county_weights: {
      "06109": 100,
    },
    county_names_all: "Tuolumne",
    county_fips_all: "06109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95328,
    lat: 37.55797,
    lng: -120.90932,
    city: "Keyes",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3680,
    density: 1575.2,
    county_fips: "06099",
    county_name: "Stanislaus",
    county_weights: {
      "06099": 100,
    },
    county_names_all: "Stanislaus",
    county_fips_all: "06099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95329,
    lat: 37.67726,
    lng: -120.41363,
    city: "La Grange",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2318,
    density: 7.7,
    county_fips: "06109",
    county_name: "Tuolumne",
    county_weights: {
      "06109": 48.33,
      "06099": 36,
      "06043": 15.67,
    },
    county_names_all: "Tuolumne|Stanislaus|Mariposa",
    county_fips_all: "06109|06099|06043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95330,
    lat: 37.8117,
    lng: -121.31331,
    city: "Lathrop",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24096,
    density: 432.2,
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 100,
    },
    county_names_all: "San Joaquin",
    county_fips_all: "06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95333,
    lat: 37.2447,
    lng: -120.24277,
    city: "Le Grand",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3012,
    density: 9.5,
    county_fips: "06047",
    county_name: "Merced",
    county_weights: {
      "06047": 100,
    },
    county_names_all: "Merced",
    county_fips_all: "06047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95334,
    lat: 37.34756,
    lng: -120.74624,
    city: "Livingston",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17624,
    density: 120.5,
    county_fips: "06047",
    county_name: "Merced",
    county_weights: {
      "06047": 100,
    },
    county_names_all: "Merced",
    county_fips_all: "06047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95335,
    lat: 38.11894,
    lng: -120.09239,
    city: "Long Barn",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 88,
    density: 0.8,
    county_fips: "06109",
    county_name: "Tuolumne",
    county_weights: {
      "06109": 100,
    },
    county_names_all: "Tuolumne",
    county_fips_all: "06109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95336,
    lat: 37.83351,
    lng: -121.1988,
    city: "Manteca",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47243,
    density: 475.8,
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 100,
    },
    county_names_all: "San Joaquin",
    county_fips_all: "06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95337,
    lat: 37.74171,
    lng: -121.23834,
    city: "Manteca",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40657,
    density: 345.6,
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 100,
    },
    county_names_all: "San Joaquin",
    county_fips_all: "06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95338,
    lat: 37.50911,
    lng: -119.98659,
    city: "Mariposa",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10633,
    density: 12.1,
    county_fips: "06043",
    county_name: "Mariposa",
    county_weights: {
      "06043": 100,
    },
    county_names_all: "Mariposa",
    county_fips_all: "06043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95340,
    lat: 37.34128,
    lng: -120.40658,
    city: "Merced",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36402,
    density: 270.5,
    county_fips: "06047",
    county_name: "Merced",
    county_weights: {
      "06047": 100,
    },
    county_names_all: "Merced",
    county_fips_all: "06047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95341,
    lat: 37.23037,
    lng: -120.50715,
    city: "Merced",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34047,
    density: 89.5,
    county_fips: "06047",
    county_name: "Merced",
    county_weights: {
      "06047": 100,
    },
    county_names_all: "Merced",
    county_fips_all: "06047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95345,
    lat: 37.58784,
    lng: -119.96408,
    city: "Midpines",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 715,
    density: 7.3,
    county_fips: "06043",
    county_name: "Mariposa",
    county_weights: {
      "06043": 100,
    },
    county_names_all: "Mariposa",
    county_fips_all: "06043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95346,
    lat: 38.07045,
    lng: -120.17291,
    city: "Mi Wuk Village",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1159,
    density: 87.6,
    county_fips: "06109",
    county_name: "Tuolumne",
    county_weights: {
      "06109": 100,
    },
    county_names_all: "Tuolumne",
    county_fips_all: "06109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95348,
    lat: 37.41525,
    lng: -120.4979,
    city: "Merced",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34302,
    density: 224.5,
    county_fips: "06047",
    county_name: "Merced",
    county_weights: {
      "06047": 100,
    },
    county_names_all: "Merced",
    county_fips_all: "06047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95350,
    lat: 37.67175,
    lng: -121.00732,
    city: "Modesto",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54044,
    density: 2361.6,
    county_fips: "06099",
    county_name: "Stanislaus",
    county_weights: {
      "06099": 100,
    },
    county_names_all: "Stanislaus",
    county_fips_all: "06099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95351,
    lat: 37.6236,
    lng: -120.99828,
    city: "Modesto",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48844,
    density: 2120.8,
    county_fips: "06099",
    county_name: "Stanislaus",
    county_weights: {
      "06099": 100,
    },
    county_names_all: "Stanislaus",
    county_fips_all: "06099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95354,
    lat: 37.63849,
    lng: -120.96428,
    city: "Modesto",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24481,
    density: 1234.9,
    county_fips: "06099",
    county_name: "Stanislaus",
    county_weights: {
      "06099": 100,
    },
    county_names_all: "Stanislaus",
    county_fips_all: "06099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95355,
    lat: 37.6727,
    lng: -120.94717,
    city: "Modesto",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59272,
    density: 2448.6,
    county_fips: "06099",
    county_name: "Stanislaus",
    county_weights: {
      "06099": 100,
    },
    county_names_all: "Stanislaus",
    county_fips_all: "06099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95356,
    lat: 37.71945,
    lng: -121.02786,
    city: "Modesto",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32387,
    density: 563,
    county_fips: "06099",
    county_name: "Stanislaus",
    county_weights: {
      "06099": 100,
    },
    county_names_all: "Stanislaus",
    county_fips_all: "06099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95357,
    lat: 37.66985,
    lng: -120.87924,
    city: "Modesto",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13011,
    density: 127.7,
    county_fips: "06099",
    county_name: "Stanislaus",
    county_weights: {
      "06099": 100,
    },
    county_names_all: "Stanislaus",
    county_fips_all: "06099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95358,
    lat: 37.61578,
    lng: -121.10059,
    city: "Modesto",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32583,
    density: 108.2,
    county_fips: "06099",
    county_name: "Stanislaus",
    county_weights: {
      "06099": 100,
    },
    county_names_all: "Stanislaus",
    county_fips_all: "06099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95360,
    lat: 37.32918,
    lng: -121.03827,
    city: "Newman",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13571,
    density: 84.8,
    county_fips: "06099",
    county_name: "Stanislaus",
    county_weights: {
      "06099": 74.95,
      "06047": 25.05,
    },
    county_names_all: "Stanislaus|Merced",
    county_fips_all: "06099|06047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95361,
    lat: 37.79342,
    lng: -120.77654,
    city: "Oakdale",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34624,
    density: 61.5,
    county_fips: "06099",
    county_name: "Stanislaus",
    county_weights: {
      "06099": 97.73,
      "06077": 2.27,
    },
    county_names_all: "Stanislaus|San Joaquin",
    county_fips_all: "06099|06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95363,
    lat: 37.37251,
    lng: -121.27192,
    city: "Patterson",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28333,
    density: 22.9,
    county_fips: "06099",
    county_name: "Stanislaus",
    county_weights: {
      "06099": 100,
    },
    county_names_all: "Stanislaus",
    county_fips_all: "06099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95364,
    lat: 38.22908,
    lng: -119.79174,
    city: "Pinecrest",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "06109",
    county_name: "Tuolumne",
    county_weights: {
      "06109": 100,
    },
    county_names_all: "Tuolumne",
    county_fips_all: "06109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95365,
    lat: 37.3012,
    lng: -120.33152,
    city: "Planada",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4292,
    density: 452.1,
    county_fips: "06047",
    county_name: "Merced",
    county_weights: {
      "06047": 100,
    },
    county_names_all: "Merced",
    county_fips_all: "06047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95366,
    lat: 37.76223,
    lng: -121.12574,
    city: "Ripon",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18728,
    density: 210.7,
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 100,
    },
    county_names_all: "San Joaquin",
    county_fips_all: "06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95367,
    lat: 37.73089,
    lng: -120.94669,
    city: "Riverbank",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24976,
    density: 1836.1,
    county_fips: "06099",
    county_name: "Stanislaus",
    county_weights: {
      "06099": 100,
    },
    county_names_all: "Stanislaus",
    county_fips_all: "06099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95368,
    lat: 37.71544,
    lng: -121.09047,
    city: "Salida",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15251,
    density: 1923.9,
    county_fips: "06099",
    county_name: "Stanislaus",
    county_weights: {
      "06099": 100,
    },
    county_names_all: "Stanislaus",
    county_fips_all: "06099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95369,
    lat: 37.52435,
    lng: -120.41301,
    city: "Snelling",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 978,
    density: 2.4,
    county_fips: "06047",
    county_name: "Merced",
    county_weights: {
      "06047": 85.76,
      "06043": 14.24,
    },
    county_names_all: "Merced|Mariposa",
    county_fips_all: "06047|06043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95370,
    lat: 37.98484,
    lng: -120.34515,
    city: "Sonora",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28301,
    density: 106,
    county_fips: "06109",
    county_name: "Tuolumne",
    county_weights: {
      "06109": 100,
    },
    county_names_all: "Tuolumne",
    county_fips_all: "06109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95372,
    lat: 37.98927,
    lng: -120.26272,
    city: "Soulsbyville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1761,
    density: 280.9,
    county_fips: "06109",
    county_name: "Tuolumne",
    county_weights: {
      "06109": 100,
    },
    county_names_all: "Tuolumne",
    county_fips_all: "06109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95374,
    lat: 37.31636,
    lng: -120.85683,
    city: "Stevinson",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1714,
    density: 14.9,
    county_fips: "06047",
    county_name: "Merced",
    county_weights: {
      "06047": 100,
    },
    county_names_all: "Merced",
    county_fips_all: "06047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95375,
    lat: 38.21493,
    lng: -119.97031,
    city: "Strawberry",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5,
    density: 0.1,
    county_fips: "06109",
    county_name: "Tuolumne",
    county_weights: {
      "06109": 100,
    },
    county_names_all: "Tuolumne",
    county_fips_all: "06109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95376,
    lat: 37.73678,
    lng: -121.43404,
    city: "Tracy",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55296,
    density: 2803.1,
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 100,
    },
    county_names_all: "San Joaquin",
    county_fips_all: "06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95377,
    lat: 37.65293,
    lng: -121.49598,
    city: "Tracy",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32599,
    density: 114.5,
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 89.32,
      "06001": 10.68,
    },
    county_names_all: "San Joaquin|Alameda",
    county_fips_all: "06077|06001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95379,
    lat: 37.96174,
    lng: -120.21635,
    city: "Tuolumne",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3856,
    density: 57.5,
    county_fips: "06109",
    county_name: "Tuolumne",
    county_weights: {
      "06109": 100,
    },
    county_names_all: "Tuolumne",
    county_fips_all: "06109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95380,
    lat: 37.47226,
    lng: -120.86978,
    city: "Turlock",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43973,
    density: 220.1,
    county_fips: "06099",
    county_name: "Stanislaus",
    county_weights: {
      "06099": 75.35,
      "06047": 24.65,
    },
    county_names_all: "Stanislaus|Merced",
    county_fips_all: "06099|06047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95382,
    lat: 37.52831,
    lng: -120.85214,
    city: "Turlock",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38029,
    density: 1341.5,
    county_fips: "06099",
    county_name: "Stanislaus",
    county_weights: {
      "06099": 100,
    },
    county_names_all: "Stanislaus",
    county_fips_all: "06099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95383,
    lat: 38.09534,
    lng: -120.22602,
    city: "Twain Harte",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3816,
    density: 22.2,
    county_fips: "06109",
    county_name: "Tuolumne",
    county_weights: {
      "06109": 100,
    },
    county_names_all: "Tuolumne",
    county_fips_all: "06109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95385,
    lat: 37.612,
    lng: -121.24773,
    city: "Vernalis",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 430,
    density: 6.2,
    county_fips: "06099",
    county_name: "Stanislaus",
    county_weights: {
      "06099": 98,
      "06077": 2,
    },
    county_names_all: "Stanislaus|San Joaquin",
    county_fips_all: "06099|06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95386,
    lat: 37.67391,
    lng: -120.63045,
    city: "Waterford",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10493,
    density: 42.8,
    county_fips: "06099",
    county_name: "Stanislaus",
    county_weights: {
      "06099": 100,
    },
    county_names_all: "Stanislaus",
    county_fips_all: "06099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95387,
    lat: 37.55429,
    lng: -121.2451,
    city: "Westley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 600,
    density: 10.8,
    county_fips: "06099",
    county_name: "Stanislaus",
    county_weights: {
      "06099": 100,
    },
    county_names_all: "Stanislaus",
    county_fips_all: "06099",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95388,
    lat: 37.42171,
    lng: -120.59715,
    city: "Winton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13805,
    density: 141.4,
    county_fips: "06047",
    county_name: "Merced",
    county_weights: {
      "06047": 100,
    },
    county_names_all: "Merced",
    county_fips_all: "06047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95389,
    lat: 37.73784,
    lng: -119.52556,
    city: "Yosemite National Park",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1464,
    density: 1.9,
    county_fips: "06043",
    county_name: "Mariposa",
    county_weights: {
      "06043": 81.66,
      "06109": 18.34,
    },
    county_names_all: "Mariposa|Tuolumne",
    county_fips_all: "06043|06109",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95391,
    lat: 37.76952,
    lng: -121.5912,
    city: "Tracy",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21488,
    density: 308.9,
    county_fips: "06001",
    county_name: "Alameda",
    county_weights: {
      "06001": 69.64,
      "06077": 30.36,
    },
    county_names_all: "Alameda|San Joaquin",
    county_fips_all: "06001|06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95401,
    lat: 38.44922,
    lng: -122.79307,
    city: "Santa Rosa",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38872,
    density: 718,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95403,
    lat: 38.50326,
    lng: -122.75358,
    city: "Santa Rosa",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44716,
    density: 801.5,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95404,
    lat: 38.46488,
    lng: -122.65709,
    city: "Santa Rosa",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38462,
    density: 197,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95405,
    lat: 38.43926,
    lng: -122.66908,
    city: "Santa Rosa",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22875,
    density: 1760.7,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95407,
    lat: 38.39465,
    lng: -122.74591,
    city: "Santa Rosa",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42815,
    density: 764.9,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95409,
    lat: 38.46116,
    lng: -122.60425,
    city: "Santa Rosa",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26739,
    density: 295.2,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95410,
    lat: 39.21616,
    lng: -123.70012,
    city: "Albion",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 970,
    density: 12.5,
    county_fips: "06045",
    county_name: "Mendocino",
    county_weights: {
      "06045": 100,
    },
    county_names_all: "Mendocino",
    county_fips_all: "06045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95412,
    lat: 38.71168,
    lng: -123.31967,
    city: "Annapolis",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 485,
    density: 2.1,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95415,
    lat: 39.0205,
    lng: -123.36751,
    city: "Boonville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1273,
    density: 8.9,
    county_fips: "06045",
    county_name: "Mendocino",
    county_weights: {
      "06045": 100,
    },
    county_names_all: "Mendocino",
    county_fips_all: "06045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95417,
    lat: 39.68791,
    lng: -123.65075,
    city: "Branscomb",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 257,
    density: 4.1,
    county_fips: "06045",
    county_name: "Mendocino",
    county_weights: {
      "06045": 100,
    },
    county_names_all: "Mendocino",
    county_fips_all: "06045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95419,
    lat: 38.42336,
    lng: -122.9582,
    city: "Camp Meeker",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95420,
    lat: 39.35638,
    lng: -123.76832,
    city: "Caspar",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 235,
    density: 12.5,
    county_fips: "06045",
    county_name: "Mendocino",
    county_weights: {
      "06045": 100,
    },
    county_names_all: "Mendocino",
    county_fips_all: "06045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95421,
    lat: 38.58276,
    lng: -123.18037,
    city: "Cazadero",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1662,
    density: 4.5,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95422,
    lat: 38.97829,
    lng: -122.6423,
    city: "Clearlake",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15644,
    density: 224.7,
    county_fips: "06033",
    county_name: "Lake",
    county_weights: {
      "06033": 100,
    },
    county_names_all: "Lake",
    county_fips_all: "06033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95423,
    lat: 39.06749,
    lng: -122.62753,
    city: "Clearlake Oaks",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3597,
    density: 11.3,
    county_fips: "06033",
    county_name: "Lake",
    county_weights: {
      "06033": 100,
    },
    county_names_all: "Lake",
    county_fips_all: "06033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95425,
    lat: 38.81792,
    lng: -123.02566,
    city: "Cloverdale",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11144,
    density: 22.4,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 68.16,
      "06045": 31.84,
    },
    county_names_all: "Sonoma|Mendocino",
    county_fips_all: "06097|06045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95426,
    lat: 38.83449,
    lng: -122.7361,
    city: "Cobb",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1124,
    density: 15.1,
    county_fips: "06033",
    county_name: "Lake",
    county_weights: {
      "06033": 100,
    },
    county_names_all: "Lake",
    county_fips_all: "06033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95427,
    lat: 39.25326,
    lng: -123.56932,
    city: "Comptche",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 548,
    density: 3.8,
    county_fips: "06045",
    county_name: "Mendocino",
    county_weights: {
      "06045": 100,
    },
    county_names_all: "Mendocino",
    county_fips_all: "06045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95428,
    lat: 39.82489,
    lng: -123.18126,
    city: "Covelo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2821,
    density: 4,
    county_fips: "06045",
    county_name: "Mendocino",
    county_weights: {
      "06045": 100,
    },
    county_names_all: "Mendocino",
    county_fips_all: "06045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95429,
    lat: 39.73292,
    lng: -123.34841,
    city: "Dos Rios",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 84,
    density: 1.3,
    county_fips: "06045",
    county_name: "Mendocino",
    county_weights: {
      "06045": 100,
    },
    county_names_all: "Mendocino",
    county_fips_all: "06045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95430,
    lat: 38.46279,
    lng: -123.04476,
    city: "Duncans Mills",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13,
    density: 21.1,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95431,
    lat: 38.34897,
    lng: -122.51625,
    city: "Eldridge",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 121,
    density: 387.9,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95432,
    lat: 39.1083,
    lng: -123.63829,
    city: "Elk",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 596,
    density: 3.2,
    county_fips: "06045",
    county_name: "Mendocino",
    county_weights: {
      "06045": 100,
    },
    county_names_all: "Mendocino",
    county_fips_all: "06045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95435,
    lat: 39.00315,
    lng: -122.8748,
    city: "Finley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 313,
    density: 8455.1,
    county_fips: "06033",
    county_name: "Lake",
    county_weights: {
      "06033": 100,
    },
    county_names_all: "Lake",
    county_fips_all: "06033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95436,
    lat: 38.49108,
    lng: -122.91425,
    city: "Forestville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6602,
    density: 119.9,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95437,
    lat: 39.44535,
    lng: -123.69402,
    city: "Fort Bragg",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15098,
    density: 32.9,
    county_fips: "06045",
    county_name: "Mendocino",
    county_weights: {
      "06045": 100,
    },
    county_names_all: "Mendocino",
    county_fips_all: "06045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95439,
    lat: 38.49055,
    lng: -122.77591,
    city: "Fulton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 444,
    density: 64.3,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95441,
    lat: 38.73775,
    lng: -123.0354,
    city: "Geyserville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1696,
    density: 4.2,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95442,
    lat: 38.3785,
    lng: -122.51549,
    city: "Glen Ellen",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3143,
    density: 48.6,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95443,
    lat: 39.05013,
    lng: -122.73962,
    city: "Glenhaven",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 183,
    density: 16.9,
    county_fips: "06033",
    county_name: "Lake",
    county_weights: {
      "06033": 100,
    },
    county_names_all: "Lake",
    county_fips_all: "06033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95444,
    lat: 38.43261,
    lng: -122.86922,
    city: "Graton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 357,
    density: 439.7,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95445,
    lat: 38.83762,
    lng: -123.49404,
    city: "Gualala",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1989,
    density: 8.6,
    county_fips: "06045",
    county_name: "Mendocino",
    county_weights: {
      "06045": 100,
    },
    county_names_all: "Mendocino",
    county_fips_all: "06045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95446,
    lat: 38.52525,
    lng: -123.00423,
    city: "Guerneville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4951,
    density: 61.6,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95448,
    lat: 38.62309,
    lng: -122.89089,
    city: "Healdsburg",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17353,
    density: 36.2,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95449,
    lat: 38.94331,
    lng: -123.09653,
    city: "Hopland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1393,
    density: 3.9,
    county_fips: "06045",
    county_name: "Mendocino",
    county_weights: {
      "06045": 100,
    },
    county_names_all: "Mendocino",
    county_fips_all: "06045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95450,
    lat: 38.5229,
    lng: -123.21508,
    city: "Jenner",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 223,
    density: 2.3,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95451,
    lat: 38.9388,
    lng: -122.80484,
    city: "Kelseyville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12031,
    density: 50,
    county_fips: "06033",
    county_name: "Lake",
    county_weights: {
      "06033": 100,
    },
    county_names_all: "Lake",
    county_fips_all: "06033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95452,
    lat: 38.42969,
    lng: -122.5362,
    city: "Kenwood",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 740,
    density: 17.3,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95453,
    lat: 39.04346,
    lng: -122.93918,
    city: "Lakeport",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11209,
    density: 49.7,
    county_fips: "06033",
    county_name: "Lake",
    county_weights: {
      "06033": 100,
    },
    county_names_all: "Lake",
    county_fips_all: "06033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95454,
    lat: 39.78063,
    lng: -123.51631,
    city: "Laytonville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2165,
    density: 2.7,
    county_fips: "06045",
    county_name: "Mendocino",
    county_weights: {
      "06045": 100,
    },
    county_names_all: "Mendocino",
    county_fips_all: "06045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95456,
    lat: 39.25851,
    lng: -123.74585,
    city: "Little River",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 682,
    density: 23.2,
    county_fips: "06045",
    county_name: "Mendocino",
    county_weights: {
      "06045": 100,
    },
    county_names_all: "Mendocino",
    county_fips_all: "06045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95457,
    lat: 38.87967,
    lng: -122.52753,
    city: "Lower Lake",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3061,
    density: 8,
    county_fips: "06033",
    county_name: "Lake",
    county_weights: {
      "06033": 100,
    },
    county_names_all: "Lake",
    county_fips_all: "06033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95458,
    lat: 39.11667,
    lng: -122.78204,
    city: "Lucerne",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2825,
    density: 31.3,
    county_fips: "06033",
    county_name: "Lake",
    county_weights: {
      "06033": 100,
    },
    county_names_all: "Lake",
    county_fips_all: "06033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95459,
    lat: 38.99068,
    lng: -123.62627,
    city: "Manchester",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 838,
    density: 5.5,
    county_fips: "06045",
    county_name: "Mendocino",
    county_weights: {
      "06045": 100,
    },
    county_names_all: "Mendocino",
    county_fips_all: "06045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95460,
    lat: 39.30386,
    lng: -123.73737,
    city: "Mendocino",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2106,
    density: 23.5,
    county_fips: "06045",
    county_name: "Mendocino",
    county_weights: {
      "06045": 100,
    },
    county_names_all: "Mendocino",
    county_fips_all: "06045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95461,
    lat: 38.762,
    lng: -122.59314,
    city: "Middletown",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2714,
    density: 8.5,
    county_fips: "06033",
    county_name: "Lake",
    county_weights: {
      "06033": 100,
    },
    county_names_all: "Lake",
    county_fips_all: "06033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95462,
    lat: 38.47263,
    lng: -123.02064,
    city: "Monte Rio",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1224,
    density: 130.7,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95463,
    lat: 39.18957,
    lng: -123.58059,
    city: "Navarro",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 109,
    density: 5.8,
    county_fips: "06045",
    county_name: "Mendocino",
    county_weights: {
      "06045": 100,
    },
    county_names_all: "Mendocino",
    county_fips_all: "06045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95464,
    lat: 39.12736,
    lng: -122.84733,
    city: "Nice",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2715,
    density: 413.2,
    county_fips: "06033",
    county_name: "Lake",
    county_weights: {
      "06033": 100,
    },
    county_names_all: "Lake",
    county_fips_all: "06033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95465,
    lat: 38.40556,
    lng: -123.01963,
    city: "Occidental",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1908,
    density: 15.3,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95466,
    lat: 39.08868,
    lng: -123.51058,
    city: "Philo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 943,
    density: 3.5,
    county_fips: "06045",
    county_name: "Mendocino",
    county_weights: {
      "06045": 100,
    },
    county_names_all: "Mendocino",
    county_fips_all: "06045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95467,
    lat: 38.80453,
    lng: -122.54948,
    city: "Hidden Valley Lake",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5909,
    density: 310.2,
    county_fips: "06033",
    county_name: "Lake",
    county_weights: {
      "06033": 100,
    },
    county_names_all: "Lake",
    county_fips_all: "06033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95468,
    lat: 38.9094,
    lng: -123.60372,
    city: "Point Arena",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1369,
    density: 8.7,
    county_fips: "06045",
    county_name: "Mendocino",
    county_weights: {
      "06045": 100,
    },
    county_names_all: "Mendocino",
    county_fips_all: "06045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95469,
    lat: 39.38853,
    lng: -123.05972,
    city: "Potter Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1499,
    density: 3.1,
    county_fips: "06045",
    county_name: "Mendocino",
    county_weights: {
      "06045": 62.1,
      "06033": 37.9,
    },
    county_names_all: "Mendocino|Lake",
    county_fips_all: "06045|06033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95470,
    lat: 39.30019,
    lng: -123.22984,
    city: "Redwood Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5359,
    density: 29.7,
    county_fips: "06045",
    county_name: "Mendocino",
    county_weights: {
      "06045": 100,
    },
    county_names_all: "Mendocino",
    county_fips_all: "06045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95471,
    lat: 38.53218,
    lng: -122.97362,
    city: "Rio Nido",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 569,
    density: 61.9,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95472,
    lat: 38.39738,
    lng: -122.86668,
    city: "Sebastopol",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29690,
    density: 163.1,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95476,
    lat: 38.25531,
    lng: -122.46055,
    city: "Sonoma",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37150,
    density: 133,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 97.81,
      "06055": 2.19,
    },
    county_names_all: "Sonoma|Napa",
    county_fips_all: "06097|06055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95480,
    lat: 38.68463,
    lng: -123.36802,
    city: "Stewarts Point",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95482,
    lat: 39.1618,
    lng: -123.23925,
    city: "Ukiah",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31714,
    density: 41.6,
    county_fips: "06045",
    county_name: "Mendocino",
    county_weights: {
      "06045": 100,
    },
    county_names_all: "Mendocino",
    county_fips_all: "06045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95485,
    lat: 39.20828,
    lng: -122.9259,
    city: "Upper Lake",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2804,
    density: 12.4,
    county_fips: "06033",
    county_name: "Lake",
    county_weights: {
      "06033": 100,
    },
    county_names_all: "Lake",
    county_fips_all: "06033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95486,
    lat: 38.4741,
    lng: -123.02403,
    city: "Villa Grande",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44,
    density: 877.1,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95488,
    lat: 39.73679,
    lng: -123.77199,
    city: "Westport",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 192,
    density: 1.2,
    county_fips: "06045",
    county_name: "Mendocino",
    county_weights: {
      "06045": 100,
    },
    county_names_all: "Mendocino",
    county_fips_all: "06045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95490,
    lat: 39.4883,
    lng: -123.34725,
    city: "Willits",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13731,
    density: 12.3,
    county_fips: "06045",
    county_name: "Mendocino",
    county_weights: {
      "06045": 100,
    },
    county_names_all: "Mendocino",
    county_fips_all: "06045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95492,
    lat: 38.53052,
    lng: -122.81254,
    city: "Windsor",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29502,
    density: 575.7,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95493,
    lat: 39.20241,
    lng: -122.97948,
    city: "Witter Springs",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 99,
    density: 4.9,
    county_fips: "06033",
    county_name: "Lake",
    county_weights: {
      "06033": 100,
    },
    county_names_all: "Lake",
    county_fips_all: "06033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95494,
    lat: 38.89646,
    lng: -123.34324,
    city: "Yorkville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 181,
    density: 0.6,
    county_fips: "06045",
    county_name: "Mendocino",
    county_weights: {
      "06045": 100,
    },
    county_names_all: "Mendocino",
    county_fips_all: "06045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95497,
    lat: 38.71976,
    lng: -123.45601,
    city: "The Sea Ranch",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1156,
    density: 29.3,
    county_fips: "06097",
    county_name: "Sonoma",
    county_weights: {
      "06097": 100,
    },
    county_names_all: "Sonoma",
    county_fips_all: "06097",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95501,
    lat: 40.80435,
    lng: -124.14034,
    city: "Eureka",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23948,
    density: 1260.4,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95503,
    lat: 40.72406,
    lng: -124.09178,
    city: "Eureka",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24631,
    density: 113.6,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95511,
    lat: 40.16975,
    lng: -123.59539,
    city: "Alderpoint",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 138,
    density: 1.3,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95514,
    lat: 40.29151,
    lng: -123.67119,
    city: "Blocksburg",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 109,
    density: 0.4,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95519,
    lat: 40.95833,
    lng: -124.04983,
    city: "Mckinleyville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18831,
    density: 135.2,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95521,
    lat: 40.84586,
    lng: -124.04745,
    city: "Arcata",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21193,
    density: 135.5,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95524,
    lat: 40.82346,
    lng: -124.05271,
    city: "Bayside",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1764,
    density: 83.8,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95525,
    lat: 40.94845,
    lng: -123.82629,
    city: "Blue Lake",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1403,
    density: 5.8,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95526,
    lat: 40.44705,
    lng: -123.6628,
    city: "Bridgeville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 210,
    density: 0.6,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 86.09,
      "06105": 13.91,
    },
    county_names_all: "Humboldt|Trinity",
    county_fips_all: "06023|06105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95527,
    lat: 40.93593,
    lng: -123.41966,
    city: "Burnt Ranch",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 437,
    density: 1.2,
    county_fips: "06105",
    county_name: "Trinity",
    county_weights: {
      "06105": 100,
    },
    county_names_all: "Trinity",
    county_fips_all: "06105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95528,
    lat: 40.4936,
    lng: -123.92393,
    city: "Carlotta",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1745,
    density: 7.7,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95531,
    lat: 41.79288,
    lng: -124.00473,
    city: "Crescent City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24052,
    density: 49,
    county_fips: "06015",
    county_name: "Del Norte",
    county_weights: {
      "06015": 100,
    },
    county_names_all: "Del Norte",
    county_fips_all: "06015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95536,
    lat: 40.51069,
    lng: -124.26547,
    city: "Ferndale",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3081,
    density: 7.3,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95537,
    lat: 40.745,
    lng: -124.21472,
    city: "Fields Landing",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95538,
    lat: 41.86833,
    lng: -124.15433,
    city: "Fort Dick",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06015",
    county_name: "Del Norte",
    county_weights: {
      "06015": 100,
    },
    county_names_all: "Del Norte",
    county_fips_all: "06015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95540,
    lat: 40.56671,
    lng: -124.12651,
    city: "Fortuna",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14316,
    density: 162.2,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95542,
    lat: 40.08074,
    lng: -123.77369,
    city: "Garberville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2262,
    density: 4,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 97.21,
      "06045": 2.79,
    },
    county_names_all: "Humboldt|Mendocino",
    county_fips_all: "06023|06045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95543,
    lat: 41.88847,
    lng: -123.80238,
    city: "Gasquet",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 629,
    density: 1.7,
    county_fips: "06015",
    county_name: "Del Norte",
    county_weights: {
      "06015": 100,
    },
    county_names_all: "Del Norte",
    county_fips_all: "06015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95545,
    lat: 40.26159,
    lng: -124.08599,
    city: "Honeydew",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 110,
    density: 0.3,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95546,
    lat: 41.18777,
    lng: -123.74535,
    city: "Hoopa",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3507,
    density: 15.5,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95547,
    lat: 40.56952,
    lng: -124.07751,
    city: "Hydesville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1051,
    density: 39,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95548,
    lat: 41.58633,
    lng: -124.05859,
    city: "Klamath",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1123,
    density: 7.8,
    county_fips: "06015",
    county_name: "Del Norte",
    county_weights: {
      "06015": 100,
    },
    county_names_all: "Del Norte",
    county_fips_all: "06015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95549,
    lat: 40.65838,
    lng: -123.89485,
    city: "Kneeland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1088,
    density: 3,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95550,
    lat: 40.77695,
    lng: -123.82951,
    city: "Korbel",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 172,
    density: 0.5,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95551,
    lat: 40.66977,
    lng: -124.21961,
    city: "Loleta",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1601,
    density: 14.6,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95552,
    lat: 40.34899,
    lng: -123.42248,
    city: "Mad River",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 699,
    density: 2,
    county_fips: "06105",
    county_name: "Trinity",
    county_weights: {
      "06105": 93.27,
      "06023": 6.73,
    },
    county_names_all: "Trinity|Humboldt",
    county_fips_all: "06105|06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95553,
    lat: 40.22981,
    lng: -123.87133,
    city: "Miranda",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 783,
    density: 4.3,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95554,
    lat: 40.27573,
    lng: -123.78414,
    city: "Myers Flat",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 419,
    density: 5,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95555,
    lat: 41.29519,
    lng: -123.97774,
    city: "Orick",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 390,
    density: 1.4,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95556,
    lat: 41.31444,
    lng: -123.59043,
    city: "Orleans",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 910,
    density: 2.1,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 89.02,
      "06093": 10.98,
    },
    county_names_all: "Humboldt|Siskiyou",
    county_fips_all: "06023|06093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95558,
    lat: 40.32673,
    lng: -124.24017,
    city: "Petrolia",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 409,
    density: 0.9,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95559,
    lat: 40.18977,
    lng: -123.7512,
    city: "Phillipsville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 102,
    density: 2.1,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95560,
    lat: 40.14606,
    lng: -123.83816,
    city: "Redway",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1534,
    density: 35.5,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95562,
    lat: 40.45808,
    lng: -124.1072,
    city: "Rio Dell",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3412,
    density: 79.4,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95563,
    lat: 40.84248,
    lng: -123.51225,
    city: "Salyer",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 591,
    density: 3.5,
    county_fips: "06105",
    county_name: "Trinity",
    county_weights: {
      "06105": 100,
    },
    county_names_all: "Trinity",
    county_fips_all: "06105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95564,
    lat: 40.79023,
    lng: -124.20312,
    city: "Samoa",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 465,
    density: 53.5,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95565,
    lat: 40.45723,
    lng: -124.01099,
    city: "Scotia",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 662,
    density: 7.6,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95567,
    lat: 41.9498,
    lng: -124.1118,
    city: "Smith River",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1888,
    density: 11.7,
    county_fips: "06015",
    county_name: "Del Norte",
    county_weights: {
      "06015": 100,
    },
    county_names_all: "Del Norte",
    county_fips_all: "06015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95568,
    lat: 41.48454,
    lng: -123.48543,
    city: "Somes Bar",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 211,
    density: 0.8,
    county_fips: "06093",
    county_name: "Siskiyou",
    county_weights: {
      "06093": 100,
    },
    county_names_all: "Siskiyou",
    county_fips_all: "06093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95569,
    lat: 40.36078,
    lng: -123.85818,
    city: "Redcrest",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 244,
    density: 1.7,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95570,
    lat: 41.11375,
    lng: -124.08037,
    city: "Trinidad",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2599,
    density: 19.2,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95571,
    lat: 40.36495,
    lng: -123.94157,
    city: "Weott",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95573,
    lat: 40.89567,
    lng: -123.65873,
    city: "Willow Creek",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1285,
    density: 4.1,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 100,
    },
    county_names_all: "Humboldt",
    county_fips_all: "06023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95585,
    lat: 39.85872,
    lng: -123.66619,
    city: "Leggett",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 420,
    density: 2.8,
    county_fips: "06045",
    county_name: "Mendocino",
    county_weights: {
      "06045": 100,
    },
    county_names_all: "Mendocino",
    county_fips_all: "06045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95587,
    lat: 39.96969,
    lng: -123.75537,
    city: "Piercy",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62,
    density: 1.3,
    county_fips: "06045",
    county_name: "Mendocino",
    county_weights: {
      "06045": 100,
    },
    county_names_all: "Mendocino",
    county_fips_all: "06045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95589,
    lat: 40.07927,
    lng: -123.98596,
    city: "Whitethorn",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1140,
    density: 2.9,
    county_fips: "06023",
    county_name: "Humboldt",
    county_weights: {
      "06023": 78.68,
      "06045": 21.32,
    },
    county_names_all: "Humboldt|Mendocino",
    county_fips_all: "06023|06045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95595,
    lat: 40.11074,
    lng: -123.26642,
    city: "Zenia",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 160,
    density: 0.1,
    county_fips: "06105",
    county_name: "Trinity",
    county_weights: {
      "06105": 100,
    },
    county_names_all: "Trinity",
    county_fips_all: "06105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95601,
    lat: 38.42713,
    lng: -120.82997,
    city: "Amador City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 136,
    density: 25.5,
    county_fips: "06005",
    county_name: "Amador",
    county_weights: {
      "06005": 100,
    },
    county_names_all: "Amador",
    county_fips_all: "06005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95602,
    lat: 38.99039,
    lng: -121.10991,
    city: "Auburn",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18588,
    density: 144.5,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 78.02,
      "06057": 21.98,
    },
    county_names_all: "Placer|Nevada",
    county_fips_all: "06061|06057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95603,
    lat: 38.91167,
    lng: -121.08559,
    city: "Auburn",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29930,
    density: 323.1,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 99.61,
      "06017": 0.39,
    },
    county_names_all: "Placer|El Dorado",
    county_fips_all: "06061|06017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95604,
    lat: 38.9112,
    lng: -121.0982,
    city: "Auburn",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62,
    density: 479.6,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 100,
    },
    county_names_all: "Placer",
    county_fips_all: "06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95605,
    lat: 38.59289,
    lng: -121.53929,
    city: "West Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14468,
    density: 1432.6,
    county_fips: "06113",
    county_name: "Yolo",
    county_weights: {
      "06113": 100,
    },
    county_names_all: "Yolo",
    county_fips_all: "06113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95606,
    lat: 38.75604,
    lng: -122.19387,
    city: "Brooks",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 303,
    density: 3.1,
    county_fips: "06113",
    county_name: "Yolo",
    county_weights: {
      "06113": 100,
    },
    county_names_all: "Yolo",
    county_fips_all: "06113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95607,
    lat: 38.7899,
    lng: -122.12585,
    city: "Capay",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 303,
    density: 0.9,
    county_fips: "06113",
    county_name: "Yolo",
    county_weights: {
      "06113": 100,
    },
    county_names_all: "Yolo",
    county_fips_all: "06113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95608,
    lat: 38.62611,
    lng: -121.32886,
    city: "Carmichael",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62330,
    density: 1819.3,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95610,
    lat: 38.69494,
    lng: -121.27219,
    city: "Citrus Heights",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46924,
    density: 2285.2,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95612,
    lat: 38.38644,
    lng: -121.58118,
    city: "Clarksburg",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1465,
    density: 8.9,
    county_fips: "06113",
    county_name: "Yolo",
    county_weights: {
      "06113": 88.11,
      "06095": 11.89,
    },
    county_names_all: "Yolo|Solano",
    county_fips_all: "06113|06095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95613,
    lat: 38.81272,
    lng: -120.89173,
    city: "Coloma",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06017",
    county_name: "El Dorado",
    county_weights: {
      "06017": 100,
    },
    county_names_all: "El Dorado",
    county_fips_all: "06017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95614,
    lat: 38.88649,
    lng: -120.98896,
    city: "Cool",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4446,
    density: 54.1,
    county_fips: "06017",
    county_name: "El Dorado",
    county_weights: {
      "06017": 100,
    },
    county_names_all: "El Dorado",
    county_fips_all: "06017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95615,
    lat: 38.31113,
    lng: -121.54595,
    city: "Courtland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 877,
    density: 16,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95616,
    lat: 38.55819,
    lng: -121.80044,
    city: "Davis",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53805,
    density: 695.8,
    county_fips: "06113",
    county_name: "Yolo",
    county_weights: {
      "06113": 96.75,
      "06095": 3.25,
    },
    county_names_all: "Yolo|Solano",
    county_fips_all: "06113|06095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95618,
    lat: 38.54348,
    lng: -121.6917,
    city: "Davis",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27238,
    density: 327.3,
    county_fips: "06113",
    county_name: "Yolo",
    county_weights: {
      "06113": 77.29,
      "06095": 22.71,
    },
    county_names_all: "Yolo|Solano",
    county_fips_all: "06113|06095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95619,
    lat: 38.68218,
    lng: -120.81401,
    city: "Diamond Springs",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6504,
    density: 423,
    county_fips: "06017",
    county_name: "El Dorado",
    county_weights: {
      "06017": 100,
    },
    county_names_all: "El Dorado",
    county_fips_all: "06017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95620,
    lat: 38.40599,
    lng: -121.75689,
    city: "Dixon",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22312,
    density: 35.7,
    county_fips: "06095",
    county_name: "Solano",
    county_weights: {
      "06095": 75.99,
      "06113": 24.01,
    },
    county_names_all: "Solano|Yolo",
    county_fips_all: "06095|06113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95621,
    lat: 38.69551,
    lng: -121.30862,
    city: "Citrus Heights",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41755,
    density: 2415.1,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95623,
    lat: 38.6075,
    lng: -120.84873,
    city: "El Dorado",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3949,
    density: 34.1,
    county_fips: "06017",
    county_name: "El Dorado",
    county_weights: {
      "06017": 100,
    },
    county_names_all: "El Dorado",
    county_fips_all: "06017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95624,
    lat: 38.43203,
    lng: -121.30506,
    city: "Elk Grove",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67017,
    density: 568,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95625,
    lat: 38.35728,
    lng: -121.90861,
    city: "Elmira",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 175,
    density: 73.4,
    county_fips: "06095",
    county_name: "Solano",
    county_weights: {
      "06095": 100,
    },
    county_names_all: "Solano",
    county_fips_all: "06095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95626,
    lat: 38.73378,
    lng: -121.48898,
    city: "Elverta",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5879,
    density: 60.2,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 57.51,
      "06061": 25.62,
      "06101": 16.87,
    },
    county_names_all: "Sacramento|Placer|Sutter",
    county_fips_all: "06067|06061|06101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95627,
    lat: 38.72936,
    lng: -122.00959,
    city: "Esparto",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4516,
    density: 33.3,
    county_fips: "06113",
    county_name: "Yolo",
    county_weights: {
      "06113": 100,
    },
    county_names_all: "Yolo",
    county_fips_all: "06113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95628,
    lat: 38.65212,
    lng: -121.2543,
    city: "Fair Oaks",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40922,
    density: 1225.6,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95629,
    lat: 38.51277,
    lng: -120.6875,
    city: "Fiddletown",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 511,
    density: 3.5,
    county_fips: "06005",
    county_name: "Amador",
    county_weights: {
      "06005": 60.81,
      "06017": 39.19,
    },
    county_names_all: "Amador|El Dorado",
    county_fips_all: "06005|06017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95630,
    lat: 38.66558,
    lng: -121.141,
    city: "Folsom",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 79584,
    density: 1173.2,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95631,
    lat: 39.05453,
    lng: -120.75365,
    city: "Foresthill",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6604,
    density: 14.7,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 100,
    },
    county_names_all: "Placer",
    county_fips_all: "06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95632,
    lat: 38.27705,
    lng: -121.26128,
    city: "Galt",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32039,
    density: 109.2,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 69.5,
      "06077": 30.5,
    },
    county_names_all: "Sacramento|San Joaquin",
    county_fips_all: "06067|06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95633,
    lat: 38.84919,
    lng: -120.82328,
    city: "Garden Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4482,
    density: 43.9,
    county_fips: "06017",
    county_name: "El Dorado",
    county_weights: {
      "06017": 100,
    },
    county_names_all: "El Dorado",
    county_fips_all: "06017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95634,
    lat: 38.9123,
    lng: -120.69443,
    city: "Georgetown",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3921,
    density: 12.8,
    county_fips: "06017",
    county_name: "El Dorado",
    county_weights: {
      "06017": 100,
    },
    county_names_all: "El Dorado",
    county_fips_all: "06017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95635,
    lat: 38.91111,
    lng: -120.90043,
    city: "Greenwood",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 801,
    density: 10.5,
    county_fips: "06017",
    county_name: "El Dorado",
    county_weights: {
      "06017": 100,
    },
    county_names_all: "El Dorado",
    county_fips_all: "06017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95636,
    lat: 38.6274,
    lng: -120.51852,
    city: "Grizzly Flats",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1382,
    density: 46.5,
    county_fips: "06017",
    county_name: "El Dorado",
    county_weights: {
      "06017": 100,
    },
    county_names_all: "El Dorado",
    county_fips_all: "06017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95637,
    lat: 38.85283,
    lng: -122.2729,
    city: "Guinda",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 140,
    density: 1.3,
    county_fips: "06113",
    county_name: "Yolo",
    county_weights: {
      "06113": 100,
    },
    county_names_all: "Yolo",
    county_fips_all: "06113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95638,
    lat: 38.33969,
    lng: -121.11481,
    city: "Herald",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2142,
    density: 10.3,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95639,
    lat: 38.39202,
    lng: -121.49599,
    city: "Hood",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 309,
    density: 25.7,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95640,
    lat: 38.33922,
    lng: -120.94024,
    city: "Ione",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11872,
    density: 34.9,
    county_fips: "06005",
    county_name: "Amador",
    county_weights: {
      "06005": 99.69,
      "06067": 0.31,
    },
    county_names_all: "Amador|Sacramento",
    county_fips_all: "06005|06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95641,
    lat: 38.15046,
    lng: -121.60271,
    city: "Isleton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1459,
    density: 13.4,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 95.81,
      "06077": 4.19,
    },
    county_names_all: "Sacramento|San Joaquin",
    county_fips_all: "06067|06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95642,
    lat: 38.3434,
    lng: -120.76398,
    city: "Jackson",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6547,
    density: 38,
    county_fips: "06005",
    county_name: "Amador",
    county_weights: {
      "06005": 100,
    },
    county_names_all: "Amador",
    county_fips_all: "06005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95645,
    lat: 38.89025,
    lng: -121.79992,
    city: "Knights Landing",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1704,
    density: 5.3,
    county_fips: "06113",
    county_name: "Yolo",
    county_weights: {
      "06113": 39.21,
      "06101": 35.98,
      "06011": 24.82,
    },
    county_names_all: "Yolo|Sutter|Colusa",
    county_fips_all: "06113|06101|06011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95646,
    lat: 38.63828,
    lng: -120.01813,
    city: "Kirkwood",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06003",
    county_name: "Alpine",
    county_weights: {
      "06003": 97.45,
      "06005": 2.55,
    },
    county_names_all: "Alpine|Amador",
    county_fips_all: "06003|06005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95648,
    lat: 38.92643,
    lng: -121.31101,
    city: "Lincoln",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52777,
    density: 141.2,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 100,
    },
    county_names_all: "Placer",
    county_fips_all: "06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95650,
    lat: 38.81339,
    lng: -121.16831,
    city: "Loomis",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15172,
    density: 256.1,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 100,
    },
    county_names_all: "Placer",
    county_fips_all: "06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95651,
    lat: 38.82088,
    lng: -120.93515,
    city: "Lotus",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 480,
    density: 13.9,
    county_fips: "06017",
    county_name: "El Dorado",
    county_weights: {
      "06017": 100,
    },
    county_names_all: "El Dorado",
    county_fips_all: "06017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95652,
    lat: 38.66265,
    lng: -121.40079,
    city: "Mcclellan",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 635,
    density: 65.6,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95653,
    lat: 38.69151,
    lng: -121.97723,
    city: "Madison",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 502,
    density: 35.3,
    county_fips: "06113",
    county_name: "Yolo",
    county_weights: {
      "06113": 100,
    },
    county_names_all: "Yolo",
    county_fips_all: "06113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95655,
    lat: 38.54976,
    lng: -121.27898,
    city: "Mather",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4334,
    density: 175.6,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95658,
    lat: 38.87938,
    lng: -121.15173,
    city: "Newcastle",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6491,
    density: 107.5,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 100,
    },
    county_names_all: "Placer",
    county_fips_all: "06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95659,
    lat: 38.84594,
    lng: -121.57679,
    city: "Nicolaus",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 748,
    density: 6.3,
    county_fips: "06101",
    county_name: "Sutter",
    county_weights: {
      "06101": 100,
    },
    county_names_all: "Sutter",
    county_fips_all: "06101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95660,
    lat: 38.67883,
    lng: -121.3805,
    city: "North Highlands",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36820,
    density: 2237.1,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95661,
    lat: 38.74129,
    lng: -121.24925,
    city: "Roseville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31851,
    density: 1373.4,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 100,
    },
    county_names_all: "Placer",
    county_fips_all: "06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95662,
    lat: 38.68917,
    lng: -121.21988,
    city: "Orangevale",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32363,
    density: 1156.3,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95663,
    lat: 38.85739,
    lng: -121.18251,
    city: "Penryn",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2787,
    density: 123.7,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 100,
    },
    county_names_all: "Placer",
    county_fips_all: "06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95664,
    lat: 38.79755,
    lng: -121.05136,
    city: "Pilot Hill",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1280,
    density: 13.5,
    county_fips: "06017",
    county_name: "El Dorado",
    county_weights: {
      "06017": 100,
    },
    county_names_all: "El Dorado",
    county_fips_all: "06017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95665,
    lat: 38.39587,
    lng: -120.65238,
    city: "Pine Grove",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3729,
    density: 71.1,
    county_fips: "06005",
    county_name: "Amador",
    county_weights: {
      "06005": 100,
    },
    county_names_all: "Amador",
    county_fips_all: "06005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95666,
    lat: 38.54113,
    lng: -120.33076,
    city: "Pioneer",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4692,
    density: 21.6,
    county_fips: "06005",
    county_name: "Amador",
    county_weights: {
      "06005": 100,
    },
    county_names_all: "Amador",
    county_fips_all: "06005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95667,
    lat: 38.73407,
    lng: -120.79216,
    city: "Placerville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35452,
    density: 81,
    county_fips: "06017",
    county_name: "El Dorado",
    county_weights: {
      "06017": 100,
    },
    county_names_all: "El Dorado",
    county_fips_all: "06017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95668,
    lat: 38.82708,
    lng: -121.49378,
    city: "Pleasant Grove",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 588,
    density: 3.5,
    county_fips: "06101",
    county_name: "Sutter",
    county_weights: {
      "06101": 69.73,
      "06061": 30.27,
    },
    county_names_all: "Sutter|Placer",
    county_fips_all: "06101|06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95669,
    lat: 38.49522,
    lng: -120.89157,
    city: "Plymouth",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4899,
    density: 25,
    county_fips: "06005",
    county_name: "Amador",
    county_weights: {
      "06005": 100,
    },
    county_names_all: "Amador",
    county_fips_all: "06005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95670,
    lat: 38.60461,
    lng: -121.27963,
    city: "Rancho Cordova",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57222,
    density: 1710.4,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95671,
    lat: 38.69529,
    lng: -121.15671,
    city: "Represa",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95672,
    lat: 38.72664,
    lng: -120.99638,
    city: "Rescue",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6543,
    density: 116.2,
    county_fips: "06017",
    county_name: "El Dorado",
    county_weights: {
      "06017": 100,
    },
    county_names_all: "El Dorado",
    county_fips_all: "06017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95673,
    lat: 38.69029,
    lng: -121.46603,
    city: "Rio Linda",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16337,
    density: 388.1,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95674,
    lat: 38.95396,
    lng: -121.48187,
    city: "Rio Oso",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 910,
    density: 11,
    county_fips: "06101",
    county_name: "Sutter",
    county_weights: {
      "06101": 100,
    },
    county_names_all: "Sutter",
    county_fips_all: "06101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95675,
    lat: 38.54548,
    lng: -120.74277,
    city: "River Pines",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 420,
    density: 800.9,
    county_fips: "06005",
    county_name: "Amador",
    county_weights: {
      "06005": 96.96,
      "06017": 3.04,
    },
    county_names_all: "Amador|El Dorado",
    county_fips_all: "06005|06017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95676,
    lat: 38.87224,
    lng: -121.71664,
    city: "Robbins",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06101",
    county_name: "Sutter",
    county_weights: {
      "06101": 100,
    },
    county_names_all: "Sutter",
    county_fips_all: "06101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95677,
    lat: 38.79298,
    lng: -121.23133,
    city: "Rocklin",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26872,
    density: 1067,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 100,
    },
    county_names_all: "Placer",
    county_fips_all: "06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95678,
    lat: 38.76536,
    lng: -121.28847,
    city: "Roseville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43078,
    density: 1455.8,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 100,
    },
    county_names_all: "Placer",
    county_fips_all: "06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95679,
    lat: 38.90524,
    lng: -122.26727,
    city: "Rumsey",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63,
    density: 4.1,
    county_fips: "06113",
    county_name: "Yolo",
    county_weights: {
      "06113": 100,
    },
    county_names_all: "Yolo",
    county_fips_all: "06113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95680,
    lat: 38.24142,
    lng: -121.57816,
    city: "Ryde",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95681,
    lat: 38.99809,
    lng: -121.35422,
    city: "Sheridan",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1023,
    density: 25.3,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 100,
    },
    county_names_all: "Placer",
    county_fips_all: "06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95682,
    lat: 38.60537,
    lng: -120.96175,
    city: "Shingle Springs",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29556,
    density: 127,
    county_fips: "06017",
    county_name: "El Dorado",
    county_weights: {
      "06017": 100,
    },
    county_names_all: "El Dorado",
    county_fips_all: "06017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95683,
    lat: 38.51018,
    lng: -121.09894,
    city: "Sloughhouse",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6084,
    density: 27.2,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95684,
    lat: 38.59098,
    lng: -120.55066,
    city: "Somerset",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2857,
    density: 6.9,
    county_fips: "06017",
    county_name: "El Dorado",
    county_weights: {
      "06017": 100,
    },
    county_names_all: "El Dorado",
    county_fips_all: "06017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95685,
    lat: 38.42716,
    lng: -120.76698,
    city: "Sutter Creek",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4796,
    density: 46.3,
    county_fips: "06005",
    county_name: "Amador",
    county_weights: {
      "06005": 100,
    },
    county_names_all: "Amador",
    county_fips_all: "06005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95686,
    lat: 38.19039,
    lng: -121.48543,
    city: "Thornton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1133,
    density: 13.5,
    county_fips: "06077",
    county_name: "San Joaquin",
    county_weights: {
      "06077": 100,
    },
    county_names_all: "San Joaquin",
    county_fips_all: "06077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95687,
    lat: 38.3344,
    lng: -121.91765,
    city: "Vacaville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69073,
    density: 598.5,
    county_fips: "06095",
    county_name: "Solano",
    county_weights: {
      "06095": 100,
    },
    county_names_all: "Solano",
    county_fips_all: "06095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95688,
    lat: 38.41901,
    lng: -122.02571,
    city: "Vacaville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38114,
    density: 160,
    county_fips: "06095",
    county_name: "Solano",
    county_weights: {
      "06095": 100,
    },
    county_names_all: "Solano",
    county_fips_all: "06095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95689,
    lat: 38.47088,
    lng: -120.61566,
    city: "Volcano",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1454,
    density: 22.2,
    county_fips: "06005",
    county_name: "Amador",
    county_weights: {
      "06005": 100,
    },
    county_names_all: "Amador",
    county_fips_all: "06005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95690,
    lat: 38.23429,
    lng: -121.58672,
    city: "Walnut Grove",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2060,
    density: 15.4,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 64.08,
      "06095": 35.92,
    },
    county_names_all: "Sacramento|Solano",
    county_fips_all: "06067|06095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95691,
    lat: 38.62394,
    lng: -121.58272,
    city: "West Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39198,
    density: 387.8,
    county_fips: "06113",
    county_name: "Yolo",
    county_weights: {
      "06113": 100,
    },
    county_names_all: "Yolo",
    county_fips_all: "06113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95692,
    lat: 39.04699,
    lng: -121.40471,
    city: "Wheatland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4924,
    density: 33.2,
    county_fips: "06115",
    county_name: "Yuba",
    county_weights: {
      "06115": 97.73,
      "06101": 2.27,
    },
    county_names_all: "Yuba|Sutter",
    county_fips_all: "06115|06101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95693,
    lat: 38.39851,
    lng: -121.21956,
    city: "Wilton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6404,
    density: 42.2,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95694,
    lat: 38.56163,
    lng: -122.00609,
    city: "Winters",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10549,
    density: 30.6,
    county_fips: "06113",
    county_name: "Yolo",
    county_weights: {
      "06113": 80.03,
      "06095": 19.97,
    },
    county_names_all: "Yolo|Solano",
    county_fips_all: "06113|06095",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95695,
    lat: 38.68847,
    lng: -121.85666,
    city: "Woodland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40340,
    density: 107,
    county_fips: "06113",
    county_name: "Yolo",
    county_weights: {
      "06113": 100,
    },
    county_names_all: "Yolo",
    county_fips_all: "06113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95697,
    lat: 38.73284,
    lng: -121.80701,
    city: "Yolo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 188,
    density: 264.9,
    county_fips: "06113",
    county_name: "Yolo",
    county_weights: {
      "06113": 100,
    },
    county_names_all: "Yolo",
    county_fips_all: "06113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95698,
    lat: 38.8187,
    lng: -121.91012,
    city: "Zamora",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 193,
    density: 1.9,
    county_fips: "06113",
    county_name: "Yolo",
    county_weights: {
      "06113": 100,
    },
    county_names_all: "Yolo",
    county_fips_all: "06113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95699,
    lat: 38.44074,
    lng: -120.85702,
    city: "Drytown",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13,
    density: 1.4,
    county_fips: "06005",
    county_name: "Amador",
    county_weights: {
      "06005": 100,
    },
    county_names_all: "Amador",
    county_fips_all: "06005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95701,
    lat: 39.22633,
    lng: -120.76741,
    city: "Alta",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1064,
    density: 12.9,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 100,
    },
    county_names_all: "Placer",
    county_fips_all: "06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95703,
    lat: 38.99156,
    lng: -120.9864,
    city: "Applegate",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 910,
    density: 39.6,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 100,
    },
    county_names_all: "Placer",
    county_fips_all: "06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95709,
    lat: 38.74886,
    lng: -120.68134,
    city: "Camino",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5634,
    density: 91.4,
    county_fips: "06017",
    county_name: "El Dorado",
    county_weights: {
      "06017": 100,
    },
    county_names_all: "El Dorado",
    county_fips_all: "06017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95713,
    lat: 39.08477,
    lng: -120.92788,
    city: "Colfax",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10545,
    density: 67,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 100,
    },
    county_names_all: "Placer",
    county_fips_all: "06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95714,
    lat: 39.2013,
    lng: -120.83677,
    city: "Dutch Flat",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 445,
    density: 47.8,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 100,
    },
    county_names_all: "Placer",
    county_fips_all: "06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95715,
    lat: 39.27495,
    lng: -120.64388,
    city: "Emigrant Gap",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 101,
    density: 1.2,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 100,
    },
    county_names_all: "Placer",
    county_fips_all: "06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95717,
    lat: 39.14258,
    lng: -120.84268,
    city: "Gold Run",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 150,
    density: 3,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 100,
    },
    county_names_all: "Placer",
    county_fips_all: "06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95720,
    lat: 38.84536,
    lng: -120.26021,
    city: "Kyburz",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 108,
    density: 0.3,
    county_fips: "06017",
    county_name: "El Dorado",
    county_weights: {
      "06017": 100,
    },
    county_names_all: "El Dorado",
    county_fips_all: "06017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95721,
    lat: 38.82341,
    lng: -120.09379,
    city: "Echo Lake",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "06017",
    county_name: "El Dorado",
    county_weights: {
      "06017": 100,
    },
    county_names_all: "El Dorado",
    county_fips_all: "06017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95722,
    lat: 39.00467,
    lng: -121.02891,
    city: "Meadow Vista",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4969,
    density: 183.7,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 100,
    },
    county_names_all: "Placer",
    county_fips_all: "06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95726,
    lat: 38.75418,
    lng: -120.41989,
    city: "Pollock Pines",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8207,
    density: 22.2,
    county_fips: "06017",
    county_name: "El Dorado",
    county_weights: {
      "06017": 100,
    },
    county_names_all: "El Dorado",
    county_fips_all: "06017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95728,
    lat: 39.29673,
    lng: -120.40358,
    city: "Soda Springs",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 328,
    density: 4.5,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 76.85,
      "06057": 23.15,
    },
    county_names_all: "Placer|Nevada",
    county_fips_all: "06061|06057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95735,
    lat: 38.82986,
    lng: -120.17936,
    city: "Twin Bridges",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33,
    density: 0.3,
    county_fips: "06017",
    county_name: "El Dorado",
    county_weights: {
      "06017": 100,
    },
    county_names_all: "El Dorado",
    county_fips_all: "06017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95736,
    lat: 39.03905,
    lng: -120.97738,
    city: "Weimar",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 277,
    density: 462.5,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 100,
    },
    county_names_all: "Placer",
    county_fips_all: "06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95742,
    lat: 38.5735,
    lng: -121.19854,
    city: "Rancho Cordova",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12643,
    density: 96.8,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95746,
    lat: 38.75009,
    lng: -121.16712,
    city: "Granite Bay",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23208,
    density: 487,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 100,
    },
    county_names_all: "Placer",
    county_fips_all: "06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95747,
    lat: 38.77963,
    lng: -121.36798,
    city: "Roseville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68541,
    density: 628.4,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 100,
    },
    county_names_all: "Placer",
    county_fips_all: "06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95757,
    lat: 38.33886,
    lng: -121.43643,
    city: "Elk Grove",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51676,
    density: 309.4,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95758,
    lat: 38.42932,
    lng: -121.44603,
    city: "Elk Grove",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65952,
    density: 1869.1,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95762,
    lat: 38.67694,
    lng: -121.05755,
    city: "El Dorado Hills",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43396,
    density: 402.9,
    county_fips: "06017",
    county_name: "El Dorado",
    county_weights: {
      "06017": 100,
    },
    county_names_all: "El Dorado",
    county_fips_all: "06017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95765,
    lat: 38.81982,
    lng: -121.27772,
    city: "Rocklin",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39992,
    density: 1233.1,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 100,
    },
    county_names_all: "Placer",
    county_fips_all: "06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95776,
    lat: 38.68889,
    lng: -121.70776,
    city: "Woodland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24311,
    density: 106.4,
    county_fips: "06113",
    county_name: "Yolo",
    county_weights: {
      "06113": 100,
    },
    county_names_all: "Yolo",
    county_fips_all: "06113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95811,
    lat: 38.58761,
    lng: -121.49077,
    city: "Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6878,
    density: 1146.5,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95814,
    lat: 38.58064,
    lng: -121.49488,
    city: "Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12551,
    density: 3470.5,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95815,
    lat: 38.60544,
    lng: -121.44497,
    city: "Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25966,
    density: 1310,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95816,
    lat: 38.57555,
    lng: -121.46543,
    city: "Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16913,
    density: 2393.3,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95817,
    lat: 38.55057,
    lng: -121.45713,
    city: "Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13966,
    density: 2380.8,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95818,
    lat: 38.55579,
    lng: -121.49669,
    city: "Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21437,
    density: 2144.6,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95819,
    lat: 38.56816,
    lng: -121.43772,
    city: "Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20379,
    density: 2181.9,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95820,
    lat: 38.53491,
    lng: -121.4442,
    city: "Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35145,
    density: 2576.2,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95821,
    lat: 38.62541,
    lng: -121.38479,
    city: "Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36434,
    density: 1992,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95822,
    lat: 38.51273,
    lng: -121.49556,
    city: "Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45123,
    density: 2074.7,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95823,
    lat: 38.47473,
    lng: -121.44266,
    city: "Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 80842,
    density: 2719.2,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95824,
    lat: 38.51746,
    lng: -121.44147,
    city: "Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30213,
    density: 2925.2,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95825,
    lat: 38.5901,
    lng: -121.40644,
    city: "Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37268,
    density: 3090.7,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95826,
    lat: 38.54554,
    lng: -121.37885,
    city: "Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39210,
    density: 1436.6,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95827,
    lat: 38.55151,
    lng: -121.3253,
    city: "Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21325,
    density: 920.5,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95828,
    lat: 38.48943,
    lng: -121.39598,
    city: "Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59139,
    density: 1841,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95829,
    lat: 38.48759,
    lng: -121.33326,
    city: "Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29014,
    density: 551.6,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95830,
    lat: 38.49415,
    lng: -121.27229,
    city: "Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 670,
    density: 19.9,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95831,
    lat: 38.49599,
    lng: -121.52948,
    city: "Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43141,
    density: 2381.2,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95832,
    lat: 38.43979,
    lng: -121.49888,
    city: "Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12695,
    density: 589.8,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95833,
    lat: 38.61529,
    lng: -121.51558,
    city: "Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40380,
    density: 1927.5,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95834,
    lat: 38.64207,
    lng: -121.51967,
    city: "Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31077,
    density: 1204.2,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95835,
    lat: 38.67088,
    lng: -121.52464,
    city: "Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39444,
    density: 1715.1,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95837,
    lat: 38.68925,
    lng: -121.59537,
    city: "Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 265,
    density: 7.1,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 91.86,
      "06101": 8.14,
    },
    county_names_all: "Sacramento|Sutter",
    county_fips_all: "06067|06101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95838,
    lat: 38.64708,
    lng: -121.44312,
    city: "Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40068,
    density: 1680.6,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95841,
    lat: 38.66031,
    lng: -121.34812,
    city: "Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20063,
    density: 1987.4,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95842,
    lat: 38.687,
    lng: -121.34889,
    city: "Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33287,
    density: 3235.9,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95843,
    lat: 38.71532,
    lng: -121.36366,
    city: "Antelope",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47928,
    density: 2839.6,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95864,
    lat: 38.58512,
    lng: -121.37655,
    city: "Sacramento",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25001,
    density: 1537.1,
    county_fips: "06067",
    county_name: "Sacramento",
    county_weights: {
      "06067": 100,
    },
    county_names_all: "Sacramento",
    county_fips_all: "06067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95901,
    lat: 39.2225,
    lng: -121.48855,
    city: "Marysville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35181,
    density: 67.8,
    county_fips: "06115",
    county_name: "Yuba",
    county_weights: {
      "06115": 96.97,
      "06007": 3.03,
    },
    county_names_all: "Yuba|Butte",
    county_fips_all: "06115|06007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95903,
    lat: 39.11337,
    lng: -121.37192,
    city: "Beale Afb",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1601,
    density: 30.2,
    county_fips: "06115",
    county_name: "Yuba",
    county_weights: {
      "06115": 100,
    },
    county_names_all: "Yuba",
    county_fips_all: "06115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95910,
    lat: 39.46742,
    lng: -120.83158,
    city: "Alleghany",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 157,
    density: 1.8,
    county_fips: "06091",
    county_name: "Sierra",
    county_weights: {
      "06091": 100,
    },
    county_names_all: "Sierra",
    county_fips_all: "06091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95912,
    lat: 39.0016,
    lng: -122.07462,
    city: "Arbuckle",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5112,
    density: 13,
    county_fips: "06011",
    county_name: "Colusa",
    county_weights: {
      "06011": 100,
    },
    county_names_all: "Colusa",
    county_fips_all: "06011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95913,
    lat: 39.62899,
    lng: -122.19215,
    city: "Artois",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06021",
    county_name: "Glenn",
    county_weights: {
      "06021": 100,
    },
    county_names_all: "Glenn",
    county_fips_all: "06021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95914,
    lat: 39.40756,
    lng: -121.37878,
    city: "Bangor",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 660,
    density: 11.6,
    county_fips: "06007",
    county_name: "Butte",
    county_weights: {
      "06007": 88.11,
      "06115": 11.89,
    },
    county_names_all: "Butte|Yuba",
    county_fips_all: "06007|06115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95915,
    lat: 39.97926,
    lng: -121.21492,
    city: "Belden",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "06063",
    county_name: "Plumas",
    county_weights: {
      "06063": 100,
    },
    county_names_all: "Plumas",
    county_fips_all: "06063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95916,
    lat: 39.65945,
    lng: -121.37375,
    city: "Berry Creek",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1206,
    density: 5.5,
    county_fips: "06007",
    county_name: "Butte",
    county_weights: {
      "06007": 100,
    },
    county_names_all: "Butte",
    county_fips_all: "06007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95917,
    lat: 39.42392,
    lng: -121.77178,
    city: "Biggs",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3881,
    density: 18.6,
    county_fips: "06007",
    county_name: "Butte",
    county_weights: {
      "06007": 100,
    },
    county_names_all: "Butte",
    county_fips_all: "06007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95918,
    lat: 39.301,
    lng: -121.34547,
    city: "Browns Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2613,
    density: 18.1,
    county_fips: "06115",
    county_name: "Yuba",
    county_weights: {
      "06115": 100,
    },
    county_names_all: "Yuba",
    county_fips_all: "06115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95919,
    lat: 39.43445,
    lng: -121.26554,
    city: "Brownsville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1306,
    density: 18.8,
    county_fips: "06115",
    county_name: "Yuba",
    county_weights: {
      "06115": 100,
    },
    county_names_all: "Yuba",
    county_fips_all: "06115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95920,
    lat: 39.46071,
    lng: -121.93702,
    city: "Butte City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 304,
    density: 1.7,
    county_fips: "06021",
    county_name: "Glenn",
    county_weights: {
      "06021": 100,
    },
    county_names_all: "Glenn",
    county_fips_all: "06021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95922,
    lat: 39.47033,
    lng: -121.07736,
    city: "Camptonville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 512,
    density: 3.8,
    county_fips: "06115",
    county_name: "Yuba",
    county_weights: {
      "06115": 83.15,
      "06091": 16.85,
    },
    county_names_all: "Yuba|Sierra",
    county_fips_all: "06115|06091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95923,
    lat: 40.18385,
    lng: -121.13672,
    city: "Canyon Dam",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27,
    density: 1,
    county_fips: "06063",
    county_name: "Plumas",
    county_weights: {
      "06063": 100,
    },
    county_names_all: "Plumas",
    county_fips_all: "06063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95925,
    lat: 39.46798,
    lng: -121.18006,
    city: "Challenge",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 261,
    density: 2.9,
    county_fips: "06115",
    county_name: "Yuba",
    county_weights: {
      "06115": 100,
    },
    county_names_all: "Yuba",
    county_fips_all: "06115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95926,
    lat: 39.74573,
    lng: -121.84396,
    city: "Chico",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41390,
    density: 2054.5,
    county_fips: "06007",
    county_name: "Butte",
    county_weights: {
      "06007": 100,
    },
    county_names_all: "Butte",
    county_fips_all: "06007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95928,
    lat: 39.68317,
    lng: -121.83528,
    city: "Chico",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38655,
    density: 102.7,
    county_fips: "06007",
    county_name: "Butte",
    county_weights: {
      "06007": 100,
    },
    county_names_all: "Butte",
    county_fips_all: "06007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95929,
    lat: 39.72578,
    lng: -121.85022,
    city: "Chico",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06007",
    county_name: "Butte",
    county_weights: {
      "06007": 100,
    },
    county_names_all: "Butte",
    county_fips_all: "06007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95930,
    lat: 39.54679,
    lng: -121.1606,
    city: "Clipper Mills",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 115,
    density: 5.9,
    county_fips: "06007",
    county_name: "Butte",
    county_weights: {
      "06007": 85.11,
      "06115": 14.89,
    },
    county_names_all: "Butte|Yuba",
    county_fips_all: "06007|06115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95932,
    lat: 39.26839,
    lng: -122.00426,
    city: "Colusa",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7573,
    density: 20.5,
    county_fips: "06011",
    county_name: "Colusa",
    county_weights: {
      "06011": 100,
    },
    county_names_all: "Colusa",
    county_fips_all: "06011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95934,
    lat: 40.07463,
    lng: -120.93108,
    city: "Crescent Mills",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 80,
    density: 1.4,
    county_fips: "06063",
    county_name: "Plumas",
    county_weights: {
      "06063": 100,
    },
    county_names_all: "Plumas",
    county_fips_all: "06063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95935,
    lat: 39.37369,
    lng: -121.19615,
    city: "Dobbins",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 113,
    density: 1.7,
    county_fips: "06115",
    county_name: "Yuba",
    county_weights: {
      "06115": 100,
    },
    county_names_all: "Yuba",
    county_fips_all: "06115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95936,
    lat: 39.56336,
    lng: -120.79279,
    city: "Downieville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 99,
    density: 0.9,
    county_fips: "06091",
    county_name: "Sierra",
    county_weights: {
      "06091": 100,
    },
    county_names_all: "Sierra",
    county_fips_all: "06091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95937,
    lat: 38.88403,
    lng: -121.99847,
    city: "Dunnigan",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1542,
    density: 11.2,
    county_fips: "06113",
    county_name: "Yolo",
    county_weights: {
      "06113": 100,
    },
    county_names_all: "Yolo",
    county_fips_all: "06113",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95938,
    lat: 39.60504,
    lng: -121.79708,
    city: "Durham",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4202,
    density: 23.8,
    county_fips: "06007",
    county_name: "Butte",
    county_weights: {
      "06007": 100,
    },
    county_names_all: "Butte",
    county_fips_all: "06007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95939,
    lat: 39.56755,
    lng: -122.60224,
    city: "Elk Creek",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 592,
    density: 0.9,
    county_fips: "06021",
    county_name: "Glenn",
    county_weights: {
      "06021": 100,
    },
    county_names_all: "Glenn",
    county_fips_all: "06021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95941,
    lat: 39.5588,
    lng: -121.24157,
    city: "Forbestown",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 848,
    density: 9.2,
    county_fips: "06007",
    county_name: "Butte",
    county_weights: {
      "06007": 85.28,
      "06115": 14.72,
    },
    county_names_all: "Butte|Yuba",
    county_fips_all: "06007|06115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95942,
    lat: 39.98954,
    lng: -121.58872,
    city: "Forest Ranch",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1605,
    density: 9,
    county_fips: "06007",
    county_name: "Butte",
    county_weights: {
      "06007": 100,
    },
    county_names_all: "Butte",
    county_fips_all: "06007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95943,
    lat: 39.57692,
    lng: -122.0367,
    city: "Glenn",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 731,
    density: 4.4,
    county_fips: "06021",
    county_name: "Glenn",
    county_weights: {
      "06021": 100,
    },
    county_names_all: "Glenn",
    county_fips_all: "06021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95944,
    lat: 39.53482,
    lng: -120.86159,
    city: "Goodyears Bar",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 80,
    density: 3.3,
    county_fips: "06091",
    county_name: "Sierra",
    county_weights: {
      "06091": 100,
    },
    county_names_all: "Sierra",
    county_fips_all: "06091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95945,
    lat: 39.19426,
    lng: -120.98199,
    city: "Grass Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26281,
    density: 166,
    county_fips: "06057",
    county_name: "Nevada",
    county_weights: {
      "06057": 100,
    },
    county_names_all: "Nevada",
    county_fips_all: "06057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95946,
    lat: 39.21052,
    lng: -121.20467,
    city: "Penn Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8335,
    density: 72,
    county_fips: "06057",
    county_name: "Nevada",
    county_weights: {
      "06057": 100,
    },
    county_names_all: "Nevada",
    county_fips_all: "06057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95947,
    lat: 40.15942,
    lng: -120.84409,
    city: "Greenville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1676,
    density: 7.6,
    county_fips: "06063",
    county_name: "Plumas",
    county_weights: {
      "06063": 100,
    },
    county_names_all: "Plumas",
    county_fips_all: "06063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95948,
    lat: 39.34289,
    lng: -121.75818,
    city: "Gridley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12122,
    density: 61.9,
    county_fips: "06007",
    county_name: "Butte",
    county_weights: {
      "06007": 99.79,
      "06101": 0.21,
    },
    county_names_all: "Butte|Sutter",
    county_fips_all: "06007|06101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95949,
    lat: 39.102,
    lng: -121.13343,
    city: "Grass Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20763,
    density: 58.5,
    county_fips: "06057",
    county_name: "Nevada",
    county_weights: {
      "06057": 100,
    },
    county_names_all: "Nevada",
    county_fips_all: "06057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95950,
    lat: 39.05144,
    lng: -121.92196,
    city: "Grimes",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 494,
    density: 3.6,
    county_fips: "06011",
    county_name: "Colusa",
    county_weights: {
      "06011": 100,
    },
    county_names_all: "Colusa",
    county_fips_all: "06011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95951,
    lat: 39.71473,
    lng: -122.00197,
    city: "Hamilton City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2603,
    density: 51.4,
    county_fips: "06021",
    county_name: "Glenn",
    county_weights: {
      "06021": 100,
    },
    county_names_all: "Glenn",
    county_fips_all: "06021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95953,
    lat: 39.25018,
    lng: -121.77309,
    city: "Live Oak",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11073,
    density: 36.8,
    county_fips: "06101",
    county_name: "Sutter",
    county_weights: {
      "06101": 100,
    },
    county_names_all: "Sutter",
    county_fips_all: "06101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95954,
    lat: 39.94916,
    lng: -121.54088,
    city: "Magalia",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12221,
    density: 37.2,
    county_fips: "06007",
    county_name: "Butte",
    county_weights: {
      "06007": 100,
    },
    county_names_all: "Butte",
    county_fips_all: "06007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95955,
    lat: 39.29657,
    lng: -122.20454,
    city: "Maxwell",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1513,
    density: 4.5,
    county_fips: "06011",
    county_name: "Colusa",
    county_weights: {
      "06011": 100,
    },
    county_names_all: "Colusa",
    county_fips_all: "06011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95956,
    lat: 39.8751,
    lng: -121.12209,
    city: "Meadow Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 399,
    density: 2.6,
    county_fips: "06063",
    county_name: "Plumas",
    county_weights: {
      "06063": 100,
    },
    county_names_all: "Plumas",
    county_fips_all: "06063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95957,
    lat: 39.05366,
    lng: -121.82379,
    city: "Meridian",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 723,
    density: 3,
    county_fips: "06101",
    county_name: "Sutter",
    county_weights: {
      "06101": 95.59,
      "06011": 4.41,
    },
    county_names_all: "Sutter|Colusa",
    county_fips_all: "06101|06011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95958,
    lat: 39.56417,
    lng: -121.79804,
    city: "Nelson",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06007",
    county_name: "Butte",
    county_weights: {
      "06007": 100,
    },
    county_names_all: "Butte",
    county_fips_all: "06007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95959,
    lat: 39.34509,
    lng: -120.86797,
    city: "Nevada City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17838,
    density: 22.1,
    county_fips: "06057",
    county_name: "Nevada",
    county_weights: {
      "06057": 100,
    },
    county_names_all: "Nevada",
    county_fips_all: "06057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95960,
    lat: 39.39121,
    lng: -121.0583,
    city: "North San Juan",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 592,
    density: 5.5,
    county_fips: "06091",
    county_name: "Sierra",
    county_weights: {
      "06091": 39.04,
      "06057": 37.19,
      "06115": 23.77,
    },
    county_names_all: "Sierra|Nevada|Yuba",
    county_fips_all: "06091|06057|06115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95961,
    lat: 39.03343,
    lng: -121.55754,
    city: "Olivehurst",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28929,
    density: 243.6,
    county_fips: "06115",
    county_name: "Yuba",
    county_weights: {
      "06115": 100,
    },
    county_names_all: "Yuba",
    county_fips_all: "06115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95962,
    lat: 39.32669,
    lng: -121.26876,
    city: "Oregon House",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1053,
    density: 10.7,
    county_fips: "06115",
    county_name: "Yuba",
    county_weights: {
      "06115": 100,
    },
    county_names_all: "Yuba",
    county_fips_all: "06115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95963,
    lat: 39.73682,
    lng: -122.30329,
    city: "Orland",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15904,
    density: 18.9,
    county_fips: "06021",
    county_name: "Glenn",
    county_weights: {
      "06021": 87.65,
      "06103": 12.35,
    },
    county_names_all: "Glenn|Tehama",
    county_fips_all: "06021|06103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95965,
    lat: 39.59169,
    lng: -121.59034,
    city: "Oroville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20681,
    density: 25.6,
    county_fips: "06007",
    county_name: "Butte",
    county_weights: {
      "06007": 100,
    },
    county_names_all: "Butte",
    county_fips_all: "06007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95966,
    lat: 39.47332,
    lng: -121.43284,
    city: "Oroville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29444,
    density: 66.8,
    county_fips: "06007",
    county_name: "Butte",
    county_weights: {
      "06007": 96.97,
      "06115": 3.03,
    },
    county_names_all: "Butte|Yuba",
    county_fips_all: "06007|06115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95968,
    lat: 39.43514,
    lng: -121.55179,
    city: "Palermo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1172,
    density: 251.6,
    county_fips: "06007",
    county_name: "Butte",
    county_weights: {
      "06007": 100,
    },
    county_names_all: "Butte",
    county_fips_all: "06007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95969,
    lat: 39.72178,
    lng: -121.63388,
    city: "Paradise",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19112,
    density: 145.5,
    county_fips: "06007",
    county_name: "Butte",
    county_weights: {
      "06007": 100,
    },
    county_names_all: "Butte",
    county_fips_all: "06007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95970,
    lat: 39.41159,
    lng: -122.05176,
    city: "Princeton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 533,
    density: 6.4,
    county_fips: "06021",
    county_name: "Glenn",
    county_weights: {
      "06021": 50.06,
      "06011": 49.94,
    },
    county_names_all: "Glenn|Colusa",
    county_fips_all: "06021|06011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95971,
    lat: 39.92895,
    lng: -120.91608,
    city: "Quincy",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5948,
    density: 15.2,
    county_fips: "06063",
    county_name: "Plumas",
    county_weights: {
      "06063": 100,
    },
    county_names_all: "Plumas",
    county_fips_all: "06063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95972,
    lat: 39.42955,
    lng: -121.33624,
    city: "Rackerby",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06115",
    county_name: "Yuba",
    county_weights: {
      "06115": 100,
    },
    county_names_all: "Yuba",
    county_fips_all: "06115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95973,
    lat: 39.88099,
    lng: -121.8516,
    city: "Chico",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36223,
    density: 46.6,
    county_fips: "06007",
    county_name: "Butte",
    county_weights: {
      "06007": 61.67,
      "06103": 38.33,
    },
    county_names_all: "Butte|Tehama",
    county_fips_all: "06007|06103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95974,
    lat: 39.4973,
    lng: -121.75569,
    city: "Richvale",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06007",
    county_name: "Butte",
    county_weights: {
      "06007": 100,
    },
    county_names_all: "Butte",
    county_fips_all: "06007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95975,
    lat: 39.22436,
    lng: -121.15367,
    city: "Rough And Ready",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1736,
    density: 71,
    county_fips: "06057",
    county_name: "Nevada",
    county_weights: {
      "06057": 100,
    },
    county_names_all: "Nevada",
    county_fips_all: "06057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95977,
    lat: 39.17967,
    lng: -121.29007,
    city: "Smartsville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1586,
    density: 16.3,
    county_fips: "06115",
    county_name: "Yuba",
    county_weights: {
      "06115": 61.21,
      "06057": 38.79,
    },
    county_names_all: "Yuba|Nevada",
    county_fips_all: "06115|06057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95978,
    lat: 39.90826,
    lng: -121.52941,
    city: "Stirling City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 153,
    density: 1589.4,
    county_fips: "06007",
    county_name: "Butte",
    county_weights: {
      "06007": 100,
    },
    county_names_all: "Butte",
    county_fips_all: "06007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95979,
    lat: 39.29771,
    lng: -122.47913,
    city: "Stonyford",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 397,
    density: 0.7,
    county_fips: "06011",
    county_name: "Colusa",
    county_weights: {
      "06011": 100,
    },
    county_names_all: "Colusa",
    county_fips_all: "06011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95981,
    lat: 39.65237,
    lng: -121.03447,
    city: "Strawberry Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35,
    density: 0.3,
    county_fips: "06063",
    county_name: "Plumas",
    county_weights: {
      "06063": 76.17,
      "06115": 23.83,
    },
    county_names_all: "Plumas|Yuba",
    county_fips_all: "06063|06115",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95982,
    lat: 39.18051,
    lng: -121.80746,
    city: "Sutter",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3097,
    density: 28.1,
    county_fips: "06101",
    county_name: "Sutter",
    county_weights: {
      "06101": 100,
    },
    county_names_all: "Sutter",
    county_fips_all: "06101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95983,
    lat: 40.05827,
    lng: -120.73897,
    city: "Taylorsville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 306,
    density: 1.4,
    county_fips: "06063",
    county_name: "Plumas",
    county_weights: {
      "06063": 100,
    },
    county_names_all: "Plumas",
    county_fips_all: "06063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95984,
    lat: 39.99654,
    lng: -121.11951,
    city: "Twain",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 303,
    density: 1.5,
    county_fips: "06063",
    county_name: "Plumas",
    county_weights: {
      "06063": 100,
    },
    county_names_all: "Plumas",
    county_fips_all: "06063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95986,
    lat: 39.36149,
    lng: -120.7652,
    city: "Washington",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 123,
    density: 4.4,
    county_fips: "06057",
    county_name: "Nevada",
    county_weights: {
      "06057": 100,
    },
    county_names_all: "Nevada",
    county_fips_all: "06057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95987,
    lat: 39.10299,
    lng: -122.2726,
    city: "Williams",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6040,
    density: 7.4,
    county_fips: "06011",
    county_name: "Colusa",
    county_weights: {
      "06011": 100,
    },
    county_names_all: "Colusa",
    county_fips_all: "06011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95988,
    lat: 39.49825,
    lng: -122.28698,
    city: "Willows",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8460,
    density: 9.9,
    county_fips: "06021",
    county_name: "Glenn",
    county_weights: {
      "06021": 100,
    },
    county_names_all: "Glenn",
    county_fips_all: "06021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95991,
    lat: 39.02205,
    lng: -121.61317,
    city: "Yuba City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40749,
    density: 382.6,
    county_fips: "06101",
    county_name: "Sutter",
    county_weights: {
      "06101": 100,
    },
    county_names_all: "Sutter",
    county_fips_all: "06101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 95993,
    lat: 39.08171,
    lng: -121.68798,
    city: "Yuba City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37713,
    density: 172.8,
    county_fips: "06101",
    county_name: "Sutter",
    county_weights: {
      "06101": 100,
    },
    county_names_all: "Sutter",
    county_fips_all: "06101",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96001,
    lat: 40.57731,
    lng: -122.45443,
    city: "Redding",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34008,
    density: 181.3,
    county_fips: "06089",
    county_name: "Shasta",
    county_weights: {
      "06089": 100,
    },
    county_names_all: "Shasta",
    county_fips_all: "06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96002,
    lat: 40.5299,
    lng: -122.31679,
    city: "Redding",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33943,
    density: 428.7,
    county_fips: "06089",
    county_name: "Shasta",
    county_weights: {
      "06089": 100,
    },
    county_names_all: "Shasta",
    county_fips_all: "06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96003,
    lat: 40.66664,
    lng: -122.31564,
    city: "Redding",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44171,
    density: 153.4,
    county_fips: "06089",
    county_name: "Shasta",
    county_weights: {
      "06089": 100,
    },
    county_names_all: "Shasta",
    county_fips_all: "06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96006,
    lat: 41.15575,
    lng: -120.83952,
    city: "Adin",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 615,
    density: 1.2,
    county_fips: "06035",
    county_name: "Lassen",
    county_weights: {
      "06035": 63.88,
      "06049": 36.12,
    },
    county_names_all: "Lassen|Modoc",
    county_fips_all: "06035|06049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96007,
    lat: 40.45507,
    lng: -122.30468,
    city: "Anderson",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23670,
    density: 74.6,
    county_fips: "06089",
    county_name: "Shasta",
    county_weights: {
      "06089": 100,
    },
    county_names_all: "Shasta",
    county_fips_all: "06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96008,
    lat: 40.73559,
    lng: -122.11091,
    city: "Bella Vista",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1343,
    density: 8.4,
    county_fips: "06089",
    county_name: "Shasta",
    county_weights: {
      "06089": 100,
    },
    county_names_all: "Shasta",
    county_fips_all: "06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96009,
    lat: 41.06183,
    lng: -121.04434,
    city: "Bieber",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 291,
    density: 0.6,
    county_fips: "06035",
    county_name: "Lassen",
    county_weights: {
      "06035": 100,
    },
    county_names_all: "Lassen",
    county_fips_all: "06035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96010,
    lat: 40.89735,
    lng: -123.24365,
    city: "Big Bar",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 96,
    density: 0.1,
    county_fips: "06105",
    county_name: "Trinity",
    county_weights: {
      "06105": 100,
    },
    county_names_all: "Trinity",
    county_fips_all: "06105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96011,
    lat: 41.05762,
    lng: -121.89157,
    city: "Big Bend",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 260,
    density: 0.9,
    county_fips: "06089",
    county_name: "Shasta",
    county_weights: {
      "06089": 100,
    },
    county_names_all: "Shasta",
    county_fips_all: "06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96013,
    lat: 40.97495,
    lng: -121.68316,
    city: "Burney",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4883,
    density: 12.3,
    county_fips: "06089",
    county_name: "Shasta",
    county_weights: {
      "06089": 100,
    },
    county_names_all: "Shasta",
    county_fips_all: "06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96014,
    lat: 41.3579,
    lng: -122.77305,
    city: "Callahan",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 160,
    density: 0.4,
    county_fips: "06093",
    county_name: "Siskiyou",
    county_weights: {
      "06093": 100,
    },
    county_names_all: "Siskiyou",
    county_fips_all: "06093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96015,
    lat: 41.49672,
    lng: -120.87162,
    city: "Canby",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 334,
    density: 0.6,
    county_fips: "06049",
    county_name: "Modoc",
    county_weights: {
      "06049": 100,
    },
    county_names_all: "Modoc",
    county_fips_all: "06049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96016,
    lat: 40.90675,
    lng: -121.52032,
    city: "Cassel",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 366,
    density: 3.3,
    county_fips: "06089",
    county_name: "Shasta",
    county_weights: {
      "06089": 100,
    },
    county_names_all: "Shasta",
    county_fips_all: "06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96017,
    lat: 41.10776,
    lng: -122.30751,
    city: "Castella",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 202,
    density: 0.8,
    county_fips: "06089",
    county_name: "Shasta",
    county_weights: {
      "06089": 100,
    },
    county_names_all: "Shasta",
    county_fips_all: "06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96019,
    lat: 40.68729,
    lng: -122.39927,
    city: "Shasta Lake",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10216,
    density: 204.2,
    county_fips: "06089",
    county_name: "Shasta",
    county_weights: {
      "06089": 100,
    },
    county_names_all: "Shasta",
    county_fips_all: "06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96020,
    lat: 40.30089,
    lng: -121.26286,
    city: "Chester",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2417,
    density: 16.6,
    county_fips: "06063",
    county_name: "Plumas",
    county_weights: {
      "06063": 99.85,
      "06089": 0.15,
    },
    county_names_all: "Plumas|Shasta",
    county_fips_all: "06063|06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96021,
    lat: 39.91871,
    lng: -122.26813,
    city: "Corning",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14970,
    density: 23.2,
    county_fips: "06103",
    county_name: "Tehama",
    county_weights: {
      "06103": 100,
    },
    county_names_all: "Tehama",
    county_fips_all: "06103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96022,
    lat: 40.34232,
    lng: -122.44814,
    city: "Cottonwood",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14624,
    density: 22.7,
    county_fips: "06103",
    county_name: "Tehama",
    county_weights: {
      "06103": 68.77,
      "06089": 31.23,
    },
    county_names_all: "Tehama|Shasta",
    county_fips_all: "06103|06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96023,
    lat: 41.92108,
    lng: -121.97592,
    city: "Dorris",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1188,
    density: 2.1,
    county_fips: "06093",
    county_name: "Siskiyou",
    county_weights: {
      "06093": 100,
    },
    county_names_all: "Siskiyou",
    county_fips_all: "06093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96024,
    lat: 40.58767,
    lng: -122.90143,
    city: "Douglas City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 825,
    density: 3,
    county_fips: "06105",
    county_name: "Trinity",
    county_weights: {
      "06105": 100,
    },
    county_names_all: "Trinity",
    county_fips_all: "06105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96025,
    lat: 41.20409,
    lng: -122.32523,
    city: "Dunsmuir",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2232,
    density: 8.3,
    county_fips: "06093",
    county_name: "Siskiyou",
    county_weights: {
      "06093": 72.25,
      "06089": 27.75,
    },
    county_names_all: "Siskiyou|Shasta",
    county_fips_all: "06093|06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96027,
    lat: 41.36558,
    lng: -123.07799,
    city: "Etna",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2273,
    density: 2.1,
    county_fips: "06093",
    county_name: "Siskiyou",
    county_weights: {
      "06093": 100,
    },
    county_names_all: "Siskiyou",
    county_fips_all: "06093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96028,
    lat: 41.00761,
    lng: -121.45731,
    city: "Fall River Mills",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1000,
    density: 2.3,
    county_fips: "06089",
    county_name: "Shasta",
    county_weights: {
      "06089": 100,
    },
    county_names_all: "Shasta",
    county_fips_all: "06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96029,
    lat: 39.94003,
    lng: -122.48743,
    city: "Flournoy",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 190,
    density: 3,
    county_fips: "06103",
    county_name: "Tehama",
    county_weights: {
      "06103": 100,
    },
    county_names_all: "Tehama",
    county_fips_all: "06103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96031,
    lat: 41.17262,
    lng: -123.18029,
    city: "Forks Of Salmon",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 96,
    density: 0.1,
    county_fips: "06093",
    county_name: "Siskiyou",
    county_weights: {
      "06093": 100,
    },
    county_names_all: "Siskiyou",
    county_fips_all: "06093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96032,
    lat: 41.58503,
    lng: -122.98291,
    city: "Fort Jones",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2732,
    density: 2,
    county_fips: "06093",
    county_name: "Siskiyou",
    county_weights: {
      "06093": 100,
    },
    county_names_all: "Siskiyou",
    county_fips_all: "06093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96033,
    lat: 40.75076,
    lng: -122.60004,
    city: "French Gulch",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 484,
    density: 1.3,
    county_fips: "06089",
    county_name: "Shasta",
    county_weights: {
      "06089": 100,
    },
    county_names_all: "Shasta",
    county_fips_all: "06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96034,
    lat: 41.44177,
    lng: -122.60772,
    city: "Gazelle",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 328,
    density: 1.1,
    county_fips: "06093",
    county_name: "Siskiyou",
    county_weights: {
      "06093": 100,
    },
    county_names_all: "Siskiyou",
    county_fips_all: "06093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96035,
    lat: 40.04168,
    lng: -122.18254,
    city: "Gerber",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3341,
    density: 30.3,
    county_fips: "06103",
    county_name: "Tehama",
    county_weights: {
      "06103": 100,
    },
    county_names_all: "Tehama",
    county_fips_all: "06103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96037,
    lat: 41.54368,
    lng: -122.93177,
    city: "Greenview",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 188,
    density: 26.5,
    county_fips: "06093",
    county_name: "Siskiyou",
    county_weights: {
      "06093": 100,
    },
    county_names_all: "Siskiyou",
    county_fips_all: "06093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96038,
    lat: 41.60827,
    lng: -122.54576,
    city: "Grenada",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 717,
    density: 15.2,
    county_fips: "06093",
    county_name: "Siskiyou",
    county_weights: {
      "06093": 100,
    },
    county_names_all: "Siskiyou",
    county_fips_all: "06093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96039,
    lat: 41.66376,
    lng: -123.37711,
    city: "Happy Camp",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 896,
    density: 1.3,
    county_fips: "06093",
    county_name: "Siskiyou",
    county_weights: {
      "06093": 100,
    },
    county_names_all: "Siskiyou",
    county_fips_all: "06093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96040,
    lat: 40.79393,
    lng: -121.47397,
    city: "Hat Creek",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68,
    density: 0.5,
    county_fips: "06089",
    county_name: "Shasta",
    county_weights: {
      "06089": 100,
    },
    county_names_all: "Shasta",
    county_fips_all: "06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96041,
    lat: 40.52059,
    lng: -123.19991,
    city: "Hayfork",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2871,
    density: 3.3,
    county_fips: "06105",
    county_name: "Trinity",
    county_weights: {
      "06105": 100,
    },
    county_names_all: "Trinity",
    county_fips_all: "06105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96044,
    lat: 41.95384,
    lng: -122.64853,
    city: "Hornbrook",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1125,
    density: 2,
    county_fips: "06093",
    county_name: "Siskiyou",
    county_weights: {
      "06093": 100,
    },
    county_names_all: "Siskiyou",
    county_fips_all: "06093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96046,
    lat: 40.61118,
    lng: -123.43151,
    city: "Hyampom",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 124,
    density: 0.3,
    county_fips: "06105",
    county_name: "Trinity",
    county_weights: {
      "06105": 100,
    },
    county_names_all: "Trinity",
    county_fips_all: "06105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96047,
    lat: 40.47695,
    lng: -122.69889,
    city: "Igo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 939,
    density: 1.5,
    county_fips: "06089",
    county_name: "Shasta",
    county_weights: {
      "06089": 100,
    },
    county_names_all: "Shasta",
    county_fips_all: "06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96048,
    lat: 40.82613,
    lng: -123.05594,
    city: "Junction City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 795,
    density: 2,
    county_fips: "06105",
    county_name: "Trinity",
    county_weights: {
      "06105": 100,
    },
    county_names_all: "Trinity",
    county_fips_all: "06105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96050,
    lat: 41.85389,
    lng: -122.95689,
    city: "Klamath River",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 414,
    density: 0.6,
    county_fips: "06093",
    county_name: "Siskiyou",
    county_weights: {
      "06093": 100,
    },
    county_names_all: "Siskiyou",
    county_fips_all: "06093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96051,
    lat: 40.90112,
    lng: -122.35664,
    city: "Lakehead",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1193,
    density: 1.3,
    county_fips: "06089",
    county_name: "Shasta",
    county_weights: {
      "06089": 100,
    },
    county_names_all: "Shasta",
    county_fips_all: "06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96052,
    lat: 40.68515,
    lng: -122.80342,
    city: "Lewiston",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1724,
    density: 6,
    county_fips: "06105",
    county_name: "Trinity",
    county_weights: {
      "06105": 100,
    },
    county_names_all: "Trinity",
    county_fips_all: "06105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96054,
    lat: 41.26665,
    lng: -121.10633,
    city: "Lookout",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 265,
    density: 0.9,
    county_fips: "06049",
    county_name: "Modoc",
    county_weights: {
      "06049": 100,
    },
    county_names_all: "Modoc",
    county_fips_all: "06049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96055,
    lat: 40.10249,
    lng: -122.03213,
    city: "Los Molinos",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4194,
    density: 17,
    county_fips: "06103",
    county_name: "Tehama",
    county_weights: {
      "06103": 100,
    },
    county_names_all: "Tehama",
    county_fips_all: "06103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96056,
    lat: 41.07178,
    lng: -121.32607,
    city: "Mcarthur",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1730,
    density: 3.1,
    county_fips: "06035",
    county_name: "Lassen",
    county_weights: {
      "06035": 53.13,
      "06089": 33.18,
      "06049": 13.69,
    },
    county_names_all: "Lassen|Shasta|Modoc",
    county_fips_all: "06035|06089|06049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96057,
    lat: 41.26144,
    lng: -122.0118,
    city: "Mccloud",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1089,
    density: 3.9,
    county_fips: "06093",
    county_name: "Siskiyou",
    county_weights: {
      "06093": 100,
    },
    county_names_all: "Siskiyou",
    county_fips_all: "06093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96058,
    lat: 41.74536,
    lng: -121.9337,
    city: "Macdoel",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 507,
    density: 0.5,
    county_fips: "06093",
    county_name: "Siskiyou",
    county_weights: {
      "06093": 100,
    },
    county_names_all: "Siskiyou",
    county_fips_all: "06093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96059,
    lat: 40.42947,
    lng: -121.83465,
    city: "Manton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 478,
    density: 2.9,
    county_fips: "06103",
    county_name: "Tehama",
    county_weights: {
      "06103": 51.79,
      "06089": 48.21,
    },
    county_names_all: "Tehama|Shasta",
    county_fips_all: "06103|06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96061,
    lat: 40.34407,
    lng: -121.48767,
    city: "Mill Creek",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "06103",
    county_name: "Tehama",
    county_weights: {
      "06103": 100,
    },
    county_names_all: "Tehama",
    county_fips_all: "06103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96062,
    lat: 40.56373,
    lng: -122.06646,
    city: "Millville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1217,
    density: 7,
    county_fips: "06089",
    county_name: "Shasta",
    county_weights: {
      "06089": 100,
    },
    county_names_all: "Shasta",
    county_fips_all: "06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96063,
    lat: 40.35708,
    lng: -121.60236,
    city: "Mineral",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 250,
    density: 7.4,
    county_fips: "06103",
    county_name: "Tehama",
    county_weights: {
      "06103": 100,
    },
    county_names_all: "Tehama",
    county_fips_all: "06103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96064,
    lat: 41.76371,
    lng: -122.36433,
    city: "Montague",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4368,
    density: 3.5,
    county_fips: "06093",
    county_name: "Siskiyou",
    county_weights: {
      "06093": 100,
    },
    county_names_all: "Siskiyou",
    county_fips_all: "06093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96065,
    lat: 40.88056,
    lng: -121.95433,
    city: "Montgomery Creek",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 286,
    density: 0.8,
    county_fips: "06089",
    county_name: "Shasta",
    county_weights: {
      "06089": 100,
    },
    county_names_all: "Shasta",
    county_fips_all: "06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96067,
    lat: 41.31664,
    lng: -122.31736,
    city: "Mount Shasta",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7050,
    density: 35.6,
    county_fips: "06093",
    county_name: "Siskiyou",
    county_weights: {
      "06093": 100,
    },
    county_names_all: "Siskiyou",
    county_fips_all: "06093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96068,
    lat: 41.10525,
    lng: -121.20455,
    city: "Nubieber",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 200,
    density: 2.7,
    county_fips: "06035",
    county_name: "Lassen",
    county_weights: {
      "06035": 100,
    },
    county_names_all: "Lassen",
    county_fips_all: "06035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96069,
    lat: 40.68226,
    lng: -122.02341,
    city: "Oak Run",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1167,
    density: 4.9,
    county_fips: "06089",
    county_name: "Shasta",
    county_weights: {
      "06089": 100,
    },
    county_names_all: "Shasta",
    county_fips_all: "06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96071,
    lat: 40.68134,
    lng: -121.45275,
    city: "Old Station",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21,
    density: 0.3,
    county_fips: "06089",
    county_name: "Shasta",
    county_weights: {
      "06089": 100,
    },
    county_names_all: "Shasta",
    county_fips_all: "06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96073,
    lat: 40.59047,
    lng: -122.20537,
    city: "Palo Cedro",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4538,
    density: 38.7,
    county_fips: "06089",
    county_name: "Shasta",
    county_weights: {
      "06089": 100,
    },
    county_names_all: "Shasta",
    county_fips_all: "06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96074,
    lat: 39.87196,
    lng: -122.58599,
    city: "Paskenta",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 109,
    density: 0.5,
    county_fips: "06103",
    county_name: "Tehama",
    county_weights: {
      "06103": 100,
    },
    county_names_all: "Tehama",
    county_fips_all: "06103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96075,
    lat: 40.35582,
    lng: -121.87196,
    city: "Paynes Creek",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 353,
    density: 1.5,
    county_fips: "06103",
    county_name: "Tehama",
    county_weights: {
      "06103": 91.09,
      "06089": 8.91,
    },
    county_names_all: "Tehama|Shasta",
    county_fips_all: "06103|06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96076,
    lat: 40.37547,
    lng: -122.92996,
    city: "Platina",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 201,
    density: 0.4,
    county_fips: "06105",
    county_name: "Trinity",
    county_weights: {
      "06105": 38.75,
      "06103": 33.63,
      "06089": 27.62,
    },
    county_names_all: "Trinity|Tehama|Shasta",
    county_fips_all: "06105|06103|06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96078,
    lat: 40.08245,
    lng: -122.17607,
    city: "Proberta",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "06103",
    county_name: "Tehama",
    county_weights: {
      "06103": 100,
    },
    county_names_all: "Tehama",
    county_fips_all: "06103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96080,
    lat: 40.16386,
    lng: -122.39171,
    city: "Red Bluff",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31009,
    density: 18.5,
    county_fips: "06103",
    county_name: "Tehama",
    county_weights: {
      "06103": 100,
    },
    county_names_all: "Tehama",
    county_fips_all: "06103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96084,
    lat: 40.79395,
    lng: -121.91519,
    city: "Round Mountain",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 514,
    density: 3.7,
    county_fips: "06089",
    county_name: "Shasta",
    county_weights: {
      "06089": 100,
    },
    county_names_all: "Shasta",
    county_fips_all: "06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96085,
    lat: 41.73245,
    lng: -123.05145,
    city: "Scott Bar",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 66,
    density: 0.5,
    county_fips: "06093",
    county_name: "Siskiyou",
    county_weights: {
      "06093": 100,
    },
    county_names_all: "Siskiyou",
    county_fips_all: "06093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96086,
    lat: 41.87407,
    lng: -123.23012,
    city: "Seiad Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 239,
    density: 0.5,
    county_fips: "06093",
    county_name: "Siskiyou",
    county_weights: {
      "06093": 100,
    },
    county_names_all: "Siskiyou",
    county_fips_all: "06093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96087,
    lat: 40.63296,
    lng: -122.58067,
    city: "Shasta",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 699,
    density: 6.3,
    county_fips: "06089",
    county_name: "Shasta",
    county_weights: {
      "06089": 100,
    },
    county_names_all: "Shasta",
    county_fips_all: "06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96088,
    lat: 40.50983,
    lng: -121.88848,
    city: "Shingletown",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5022,
    density: 11.2,
    county_fips: "06089",
    county_name: "Shasta",
    county_weights: {
      "06089": 100,
    },
    county_names_all: "Shasta",
    county_fips_all: "06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96090,
    lat: 40.00681,
    lng: -122.12142,
    city: "Tehama",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 503,
    density: 63.5,
    county_fips: "06103",
    county_name: "Tehama",
    county_weights: {
      "06103": 100,
    },
    county_names_all: "Tehama",
    county_fips_all: "06103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96091,
    lat: 41.04567,
    lng: -122.78053,
    city: "Trinity Center",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 678,
    density: 0.6,
    county_fips: "06105",
    county_name: "Trinity",
    county_weights: {
      "06105": 100,
    },
    county_names_all: "Trinity",
    county_fips_all: "06105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96092,
    lat: 39.97344,
    lng: -121.97342,
    city: "Vina",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 320,
    density: 1.9,
    county_fips: "06103",
    county_name: "Tehama",
    county_weights: {
      "06103": 100,
    },
    county_names_all: "Tehama",
    county_fips_all: "06103",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96093,
    lat: 40.77237,
    lng: -122.94329,
    city: "Weaverville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3469,
    density: 13.4,
    county_fips: "06105",
    county_name: "Trinity",
    county_weights: {
      "06105": 100,
    },
    county_names_all: "Trinity",
    county_fips_all: "06105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96094,
    lat: 41.51214,
    lng: -122.36253,
    city: "Weed",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7104,
    density: 13.7,
    county_fips: "06093",
    county_name: "Siskiyou",
    county_weights: {
      "06093": 100,
    },
    county_names_all: "Siskiyou",
    county_fips_all: "06093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96096,
    lat: 40.63738,
    lng: -121.87552,
    city: "Whitmore",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 718,
    density: 2.7,
    county_fips: "06089",
    county_name: "Shasta",
    county_weights: {
      "06089": 100,
    },
    county_names_all: "Shasta",
    county_fips_all: "06089",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96097,
    lat: 41.76234,
    lng: -122.65921,
    city: "Yreka",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9468,
    density: 20.1,
    county_fips: "06093",
    county_name: "Siskiyou",
    county_weights: {
      "06093": 100,
    },
    county_names_all: "Siskiyou",
    county_fips_all: "06093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96101,
    lat: 41.45803,
    lng: -120.5043,
    city: "Alturas",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5152,
    density: 3.3,
    county_fips: "06049",
    county_name: "Modoc",
    county_weights: {
      "06049": 100,
    },
    county_names_all: "Modoc",
    county_fips_all: "06049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96103,
    lat: 39.78446,
    lng: -120.66969,
    city: "Blairsden Graeagle",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1343,
    density: 5.3,
    county_fips: "06063",
    county_name: "Plumas",
    county_weights: {
      "06063": 100,
    },
    county_names_all: "Plumas",
    county_fips_all: "06063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96104,
    lat: 41.48248,
    lng: -120.12725,
    city: "Cedarville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 920,
    density: 1.5,
    county_fips: "06049",
    county_name: "Modoc",
    county_weights: {
      "06049": 100,
    },
    county_names_all: "Modoc",
    county_fips_all: "06049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96105,
    lat: 39.82478,
    lng: -120.1821,
    city: "Chilcoot",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 351,
    density: 0.5,
    county_fips: "06063",
    county_name: "Plumas",
    county_weights: {
      "06063": 59.92,
      "06091": 26.19,
      "06035": 13.89,
    },
    county_names_all: "Plumas|Sierra|Lassen",
    county_fips_all: "06063|06091|06035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96106,
    lat: 39.73552,
    lng: -120.54388,
    city: "Clio",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 465,
    density: 8.1,
    county_fips: "06063",
    county_name: "Plumas",
    county_weights: {
      "06063": 100,
    },
    county_names_all: "Plumas",
    county_fips_all: "06063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96107,
    lat: 38.45215,
    lng: -119.51421,
    city: "Coleville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1057,
    density: 4.3,
    county_fips: "06051",
    county_name: "Mono",
    county_weights: {
      "06051": 100,
    },
    county_names_all: "Mono",
    county_fips_all: "06051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96108,
    lat: 41.77687,
    lng: -120.42351,
    city: "Davis Creek",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 158,
    density: 0.3,
    county_fips: "06049",
    county_name: "Modoc",
    county_weights: {
      "06049": 100,
    },
    county_names_all: "Modoc",
    county_fips_all: "06049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96109,
    lat: 39.99747,
    lng: -120.09521,
    city: "Doyle",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 914,
    density: 1.6,
    county_fips: "06035",
    county_name: "Lassen",
    county_weights: {
      "06035": 100,
    },
    county_names_all: "Lassen",
    county_fips_all: "06035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96110,
    lat: 41.26637,
    lng: -120.10763,
    city: "Eagleville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 87,
    density: 0.3,
    county_fips: "06049",
    county_name: "Modoc",
    county_weights: {
      "06049": 96.22,
      "06035": 3.78,
    },
    county_names_all: "Modoc|Lassen",
    county_fips_all: "06049|06035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96111,
    lat: 39.41571,
    lng: -120.01648,
    city: "Floriston",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 111,
    density: 9,
    county_fips: "06057",
    county_name: "Nevada",
    county_weights: {
      "06057": 100,
    },
    county_names_all: "Nevada",
    county_fips_all: "06057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96112,
    lat: 41.8372,
    lng: -120.09403,
    city: "Fort Bidwell",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 210,
    density: 0.6,
    county_fips: "06049",
    county_name: "Modoc",
    county_weights: {
      "06049": 100,
    },
    county_names_all: "Modoc",
    county_fips_all: "06049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96113,
    lat: 40.18577,
    lng: -120.14609,
    city: "Herlong",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1916,
    density: 33.9,
    county_fips: "06035",
    county_name: "Lassen",
    county_weights: {
      "06035": 100,
    },
    county_names_all: "Lassen",
    county_fips_all: "06035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96114,
    lat: 40.2945,
    lng: -120.49359,
    city: "Janesville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3129,
    density: 18.4,
    county_fips: "06035",
    county_name: "Lassen",
    county_weights: {
      "06035": 100,
    },
    county_names_all: "Lassen",
    county_fips_all: "06035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96115,
    lat: 41.70753,
    lng: -120.14047,
    city: "Lake City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 167,
    density: 0.6,
    county_fips: "06049",
    county_name: "Modoc",
    county_weights: {
      "06049": 100,
    },
    county_names_all: "Modoc",
    county_fips_all: "06049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96116,
    lat: 41.2603,
    lng: -120.44841,
    city: "Likely",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 149,
    density: 0.3,
    county_fips: "06049",
    county_name: "Modoc",
    county_weights: {
      "06049": 100,
    },
    county_names_all: "Modoc",
    county_fips_all: "06049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96117,
    lat: 40.54556,
    lng: -120.23978,
    city: "Litchfield",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 304,
    density: 0.4,
    county_fips: "06035",
    county_name: "Lassen",
    county_weights: {
      "06035": 100,
    },
    county_names_all: "Lassen",
    county_fips_all: "06035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96118,
    lat: 39.64823,
    lng: -120.25392,
    city: "Loyalton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1671,
    density: 3.8,
    county_fips: "06091",
    county_name: "Sierra",
    county_weights: {
      "06091": 82.59,
      "06063": 17.41,
    },
    county_names_all: "Sierra|Plumas",
    county_fips_all: "06091|06063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96119,
    lat: 41.03353,
    lng: -120.55264,
    city: "Madeline",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11,
    density: 0,
    county_fips: "06035",
    county_name: "Lassen",
    county_weights: {
      "06035": 100,
    },
    county_names_all: "Lassen",
    county_fips_all: "06035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96120,
    lat: 38.745,
    lng: -119.82485,
    city: "Markleeville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 927,
    density: 1.6,
    county_fips: "06003",
    county_name: "Alpine",
    county_weights: {
      "06003": 100,
    },
    county_names_all: "Alpine",
    county_fips_all: "06003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96121,
    lat: 40.16938,
    lng: -120.37659,
    city: "Milford",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 298,
    density: 3.5,
    county_fips: "06035",
    county_name: "Lassen",
    county_weights: {
      "06035": 100,
    },
    county_names_all: "Lassen",
    county_fips_all: "06035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96122,
    lat: 39.82082,
    lng: -120.47652,
    city: "Portola",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3594,
    density: 21.7,
    county_fips: "06063",
    county_name: "Plumas",
    county_weights: {
      "06063": 100,
    },
    county_names_all: "Plumas",
    county_fips_all: "06063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96123,
    lat: 40.80392,
    lng: -120.30799,
    city: "Ravendale",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45,
    density: 0.1,
    county_fips: "06035",
    county_name: "Lassen",
    county_weights: {
      "06035": 100,
    },
    county_names_all: "Lassen",
    county_fips_all: "06035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96124,
    lat: 39.63918,
    lng: -120.46194,
    city: "Calpine",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 367,
    density: 2.7,
    county_fips: "06091",
    county_name: "Sierra",
    county_weights: {
      "06091": 100,
    },
    county_names_all: "Sierra",
    county_fips_all: "06091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96125,
    lat: 39.61526,
    lng: -120.60493,
    city: "Sierra City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 84,
    density: 0.3,
    county_fips: "06091",
    county_name: "Sierra",
    county_weights: {
      "06091": 100,
    },
    county_names_all: "Sierra",
    county_fips_all: "06091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96126,
    lat: 39.54764,
    lng: -120.38999,
    city: "Sierraville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 166,
    density: 2.2,
    county_fips: "06091",
    county_name: "Sierra",
    county_weights: {
      "06091": 100,
    },
    county_names_all: "Sierra",
    county_fips_all: "06091",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96128,
    lat: 40.34948,
    lng: -120.40198,
    city: "Standish",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 823,
    density: 14,
    county_fips: "06035",
    county_name: "Lassen",
    county_weights: {
      "06035": 100,
    },
    county_names_all: "Lassen",
    county_fips_all: "06035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96129,
    lat: 39.81848,
    lng: -120.35346,
    city: "Beckwourth",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 301,
    density: 1,
    county_fips: "06063",
    county_name: "Plumas",
    county_weights: {
      "06063": 100,
    },
    county_names_all: "Plumas",
    county_fips_all: "06063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96130,
    lat: 40.54992,
    lng: -120.63064,
    city: "Susanville",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19859,
    density: 15.3,
    county_fips: "06035",
    county_name: "Lassen",
    county_weights: {
      "06035": 100,
    },
    county_names_all: "Lassen",
    county_fips_all: "06035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96132,
    lat: 40.89371,
    lng: -120.5389,
    city: "Termo",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54,
    density: 0.2,
    county_fips: "06035",
    county_name: "Lassen",
    county_weights: {
      "06035": 100,
    },
    county_names_all: "Lassen",
    county_fips_all: "06035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96133,
    lat: 38.63181,
    lng: -119.50423,
    city: "Topaz",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 136,
    density: 4,
    county_fips: "06051",
    county_name: "Mono",
    county_weights: {
      "06051": 100,
    },
    county_names_all: "Mono",
    county_fips_all: "06051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96134,
    lat: 41.8444,
    lng: -121.41231,
    city: "Tulelake",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2075,
    density: 2.4,
    county_fips: "06049",
    county_name: "Modoc",
    county_weights: {
      "06049": 62.93,
      "06093": 37.07,
    },
    county_names_all: "Modoc|Siskiyou",
    county_fips_all: "06049|06093",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96135,
    lat: 39.81303,
    lng: -120.20927,
    city: "Vinton",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 280,
    density: 3.1,
    county_fips: "06063",
    county_name: "Plumas",
    county_weights: {
      "06063": 100,
    },
    county_names_all: "Plumas",
    county_fips_all: "06063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96136,
    lat: 40.31263,
    lng: -120.12425,
    city: "Wendel",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24,
    density: 0.1,
    county_fips: "06035",
    county_name: "Lassen",
    county_weights: {
      "06035": 100,
    },
    county_names_all: "Lassen",
    county_fips_all: "06035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96137,
    lat: 40.38554,
    lng: -121.12478,
    city: "Westwood",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3076,
    density: 8.4,
    county_fips: "06035",
    county_name: "Lassen",
    county_weights: {
      "06035": 59.78,
      "06063": 40.22,
    },
    county_names_all: "Lassen|Plumas",
    county_fips_all: "06035|06063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96140,
    lat: 39.23244,
    lng: -120.10364,
    city: "Carnelian Bay",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1345,
    density: 50.2,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 100,
    },
    county_names_all: "Placer",
    county_fips_all: "06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96141,
    lat: 39.10297,
    lng: -120.19872,
    city: "Homewood",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 463,
    density: 6.2,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 100,
    },
    county_names_all: "Placer",
    county_fips_all: "06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96142,
    lat: 39.0138,
    lng: -120.09592,
    city: "Tahoma",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 934,
    density: 22.6,
    county_fips: "06017",
    county_name: "El Dorado",
    county_weights: {
      "06017": 99.15,
      "06061": 0.85,
    },
    county_names_all: "El Dorado|Placer",
    county_fips_all: "06017|06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96143,
    lat: 39.26174,
    lng: -120.02817,
    city: "Kings Beach",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3356,
    density: 140.4,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 100,
    },
    county_names_all: "Placer",
    county_fips_all: "06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96145,
    lat: 39.18203,
    lng: -120.15143,
    city: "Tahoe City",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2664,
    density: 58.1,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 100,
    },
    county_names_all: "Placer",
    county_fips_all: "06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96146,
    lat: 39.22556,
    lng: -120.23681,
    city: "Olympic Valley",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1096,
    density: 10.5,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 100,
    },
    county_names_all: "Placer",
    county_fips_all: "06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96148,
    lat: 39.24978,
    lng: -120.05767,
    city: "Tahoe Vista",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 679,
    density: 125.5,
    county_fips: "06061",
    county_name: "Placer",
    county_weights: {
      "06061": 100,
    },
    county_names_all: "Placer",
    county_fips_all: "06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96150,
    lat: 38.88971,
    lng: -120.04409,
    city: "South Lake Tahoe",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30369,
    density: 71.9,
    county_fips: "06017",
    county_name: "El Dorado",
    county_weights: {
      "06017": 100,
    },
    county_names_all: "El Dorado",
    county_fips_all: "06017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96155,
    lat: 38.75294,
    lng: -120.09222,
    city: "South Lake Tahoe",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "06017",
    county_name: "El Dorado",
    county_weights: {
      "06017": 100,
    },
    county_names_all: "El Dorado",
    county_fips_all: "06017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96161,
    lat: 39.34848,
    lng: -120.22603,
    city: "Truckee",
    state_id: "CA",
    state_name: "California",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18782,
    density: 27.6,
    county_fips: "06057",
    county_name: "Nevada",
    county_weights: {
      "06057": 70.01,
      "06061": 29.99,
    },
    county_names_all: "Nevada|Placer",
    county_fips_all: "06057|06061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 96701,
    lat: 21.40368,
    lng: -157.89875,
    city: "Aiea",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40279,
    density: 615.4,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96703,
    lat: 22.1349,
    lng: -159.37152,
    city: "Anahola",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2356,
    density: 28,
    county_fips: 15007,
    county_name: "Kauai",
    county_weights: {
      15007: 100,
    },
    county_names_all: "Kauai",
    county_fips_all: 15007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96704,
    lat: 19.30612,
    lng: -155.83884,
    city: "Captain Cook",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8462,
    density: 13.3,
    county_fips: 15001,
    county_name: "Hawaii",
    county_weights: {
      15001: 100,
    },
    county_names_all: "Hawaii",
    county_fips_all: 15001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96705,
    lat: 21.89973,
    lng: -159.56252,
    city: "Eleele",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2662,
    density: 305.3,
    county_fips: 15007,
    county_name: "Kauai",
    county_weights: {
      15007: 100,
    },
    county_names_all: "Kauai",
    county_fips_all: 15007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96706,
    lat: 21.34033,
    lng: -158.01704,
    city: "Ewa Beach",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 76081,
    density: 1721.3,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96707,
    lat: 21.36455,
    lng: -158.08141,
    city: "Kapolei",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46529,
    density: 413.8,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96708,
    lat: 20.88083,
    lng: -156.23763,
    city: "Haiku",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10889,
    density: 70.6,
    county_fips: 15009,
    county_name: "Maui",
    county_weights: {
      15009: 100,
    },
    county_names_all: "Maui",
    county_fips_all: 15009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96710,
    lat: 19.85516,
    lng: -155.21784,
    city: "Hakalau",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 181,
    density: 1.7,
    county_fips: 15001,
    county_name: "Hawaii",
    county_weights: {
      15001: 100,
    },
    county_names_all: "Hawaii",
    county_fips_all: 15001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96712,
    lat: 21.626,
    lng: -158.03534,
    city: "Haleiwa",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6754,
    density: 61.7,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96713,
    lat: 20.73684,
    lng: -156.1159,
    city: "Hana",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1079,
    density: 2.5,
    county_fips: 15009,
    county_name: "Maui",
    county_weights: {
      15009: 100,
    },
    county_names_all: "Maui",
    county_fips_all: 15009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96714,
    lat: 22.15734,
    lng: -159.54472,
    city: "Hanalei",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1222,
    density: 6,
    county_fips: 15007,
    county_name: "Kauai",
    county_weights: {
      15007: 100,
    },
    county_names_all: "Kauai",
    county_fips_all: 15007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96716,
    lat: 21.91167,
    lng: -159.60134,
    city: "Hanapepe",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2893,
    density: 287.9,
    county_fips: 15007,
    county_name: "Kauai",
    county_weights: {
      15007: 100,
    },
    county_names_all: "Kauai",
    county_fips_all: 15007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96717,
    lat: 21.55556,
    lng: -157.89605,
    city: "Hauula",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4860,
    density: 75.9,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96719,
    lat: 20.24005,
    lng: -155.83344,
    city: "Hawi",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1378,
    density: 91.2,
    county_fips: 15001,
    county_name: "Hawaii",
    county_weights: {
      15001: 100,
    },
    county_names_all: "Hawaii",
    county_fips_all: 15001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96720,
    lat: 19.67022,
    lng: -155.21718,
    city: "Hilo",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48647,
    density: 65.3,
    county_fips: 15001,
    county_name: "Hawaii",
    county_weights: {
      15001: 100,
    },
    county_names_all: "Hawaii",
    county_fips_all: 15001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96722,
    lat: 22.16689,
    lng: -159.45826,
    city: "Princeville",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1874,
    density: 44.6,
    county_fips: 15007,
    county_name: "Kauai",
    county_weights: {
      15007: 100,
    },
    county_names_all: "Kauai",
    county_fips_all: 15007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96725,
    lat: 19.61243,
    lng: -155.8824,
    city: "Holualoa",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3448,
    density: 13.8,
    county_fips: 15001,
    county_name: "Hawaii",
    county_weights: {
      15001: 100,
    },
    county_names_all: "Hawaii",
    county_fips_all: 15001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96726,
    lat: 19.42147,
    lng: -155.81094,
    city: "Honaunau",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 332,
    density: 6.3,
    county_fips: 15001,
    county_name: "Hawaii",
    county_weights: {
      15001: 100,
    },
    county_names_all: "Hawaii",
    county_fips_all: 15001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96727,
    lat: 20.00803,
    lng: -155.54842,
    city: "Honokaa",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4636,
    density: 9.4,
    county_fips: 15001,
    county_name: "Hawaii",
    county_weights: {
      15001: 100,
    },
    county_names_all: "Hawaii",
    county_fips_all: 15001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96728,
    lat: 19.85991,
    lng: -155.13339,
    city: "Honomu",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 458,
    density: 42.5,
    county_fips: 15001,
    county_name: "Hawaii",
    county_weights: {
      15001: 100,
    },
    county_names_all: "Hawaii",
    county_fips_all: 15001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96729,
    lat: 21.17214,
    lng: -157.11722,
    city: "Hoolehua",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1321,
    density: 13.5,
    county_fips: 15009,
    county_name: "Maui",
    county_weights: {
      15009: 100,
    },
    county_names_all: "Maui",
    county_fips_all: 15009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96730,
    lat: 21.54615,
    lng: -157.85112,
    city: "Kaaawa",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1401,
    density: 509.8,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96731,
    lat: 21.68488,
    lng: -157.96999,
    city: "Kahuku",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2956,
    density: 117.5,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96732,
    lat: 20.87593,
    lng: -156.46092,
    city: "Kahului",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28240,
    density: 918.5,
    county_fips: 15009,
    county_name: "Maui",
    county_weights: {
      15009: 100,
    },
    county_names_all: "Maui",
    county_fips_all: 15009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96734,
    lat: 21.39002,
    lng: -157.75387,
    city: "Kailua",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51715,
    density: 918.9,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96737,
    lat: 19.10735,
    lng: -155.78062,
    city: "Ocean View",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4803,
    density: 40.4,
    county_fips: 15001,
    county_name: "Hawaii",
    county_weights: {
      15001: 100,
    },
    county_names_all: "Hawaii",
    county_fips_all: 15001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96738,
    lat: 19.90341,
    lng: -155.79392,
    city: "Waikoloa",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7793,
    density: 37.7,
    county_fips: 15001,
    county_name: "Hawaii",
    county_weights: {
      15001: 100,
    },
    county_names_all: "Hawaii",
    county_fips_all: 15001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96740,
    lat: 19.74422,
    lng: -155.89951,
    city: "Kailua Kona",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43045,
    density: 68.6,
    county_fips: 15001,
    county_name: "Hawaii",
    county_weights: {
      15001: 100,
    },
    county_names_all: "Hawaii",
    county_fips_all: 15001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96741,
    lat: 21.94986,
    lng: -159.51847,
    city: "Kalaheo",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6603,
    density: 80,
    county_fips: 15007,
    county_name: "Kauai",
    county_weights: {
      15007: 100,
    },
    county_names_all: "Kauai",
    county_fips_all: 15007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96742,
    lat: 21.17089,
    lng: -156.94753,
    city: "Kalaupapa",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 436,
    density: 14,
    county_fips: 15005,
    county_name: "Kalawao",
    county_weights: {
      15005: 100,
    },
    county_names_all: "Kalawao",
    county_fips_all: 15005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96743,
    lat: 20.02619,
    lng: -155.72266,
    city: "Kamuela",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13517,
    density: 17.9,
    county_fips: 15001,
    county_name: "Hawaii",
    county_weights: {
      15001: 100,
    },
    county_names_all: "Hawaii",
    county_fips_all: 15001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96744,
    lat: 21.4427,
    lng: -157.83328,
    city: "Kaneohe",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51830,
    density: 592.6,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96746,
    lat: 22.09167,
    lng: -159.34951,
    city: "Kapaa",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18863,
    density: 244.1,
    county_fips: 15007,
    county_name: "Kauai",
    county_weights: {
      15007: 100,
    },
    county_names_all: "Kauai",
    county_fips_all: 15007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96747,
    lat: 21.9169,
    lng: -159.62788,
    city: "Kaumakani",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1148,
    density: 803.3,
    county_fips: 15007,
    county_name: "Kauai",
    county_weights: {
      15007: 100,
    },
    county_names_all: "Kauai",
    county_fips_all: 15007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96748,
    lat: 21.1138,
    lng: -156.8794,
    city: "Kaunakakai",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4117,
    density: 12.9,
    county_fips: 15009,
    county_name: "Maui",
    county_weights: {
      15009: 100,
    },
    county_names_all: "Maui",
    county_fips_all: 15009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96749,
    lat: 19.61031,
    lng: -155.00281,
    city: "Keaau",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17325,
    density: 111.9,
    county_fips: 15001,
    county_name: "Hawaii",
    county_weights: {
      15001: 100,
    },
    county_names_all: "Hawaii",
    county_fips_all: 15001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96750,
    lat: 19.52404,
    lng: -155.91463,
    city: "Kealakekua",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3386,
    density: 66.1,
    county_fips: 15001,
    county_name: "Hawaii",
    county_weights: {
      15001: 100,
    },
    county_names_all: "Hawaii",
    county_fips_all: 15001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96751,
    lat: 22.10668,
    lng: -159.30516,
    city: "Kealia",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 153,
    density: 108.5,
    county_fips: 15007,
    county_name: "Kauai",
    county_weights: {
      15007: 100,
    },
    county_names_all: "Kauai",
    county_fips_all: 15007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96752,
    lat: 22.07823,
    lng: -159.72077,
    city: "Kekaha",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 15007,
    county_name: "Kauai",
    county_weights: {
      15007: 100,
    },
    county_names_all: "Kauai",
    county_fips_all: 15007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96753,
    lat: 20.7317,
    lng: -156.43606,
    city: "Kihei",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29146,
    density: 309.4,
    county_fips: 15009,
    county_name: "Maui",
    county_weights: {
      15009: 100,
    },
    county_names_all: "Maui",
    county_fips_all: 15009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96754,
    lat: 22.18537,
    lng: -159.40246,
    city: "Kilauea",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3500,
    density: 45.5,
    county_fips: 15007,
    county_name: "Kauai",
    county_weights: {
      15007: 100,
    },
    county_names_all: "Kauai",
    county_fips_all: 15007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96755,
    lat: 20.19602,
    lng: -155.78158,
    city: "Kapaau",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3206,
    density: 21.8,
    county_fips: 15001,
    county_name: "Hawaii",
    county_weights: {
      15001: 100,
    },
    county_names_all: "Hawaii",
    county_fips_all: 15001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96756,
    lat: 21.9085,
    lng: -159.45368,
    city: "Koloa",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6245,
    density: 99,
    county_fips: 15007,
    county_name: "Kauai",
    county_weights: {
      15007: 100,
    },
    county_names_all: "Kauai",
    county_fips_all: 15007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96757,
    lat: 21.15536,
    lng: -156.99513,
    city: "Kualapuu",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 566,
    density: 14.2,
    county_fips: 15009,
    county_name: "Maui",
    county_weights: {
      15009: 100,
    },
    county_names_all: "Maui",
    county_fips_all: 15009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96759,
    lat: 21.46015,
    lng: -158.05995,
    city: "Kunia",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1345,
    density: 3302.8,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96760,
    lat: 19.55234,
    lng: -155.05483,
    city: "Kurtistown",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3038,
    density: 58.7,
    county_fips: 15001,
    county_name: "Hawaii",
    county_weights: {
      15001: 100,
    },
    county_names_all: "Hawaii",
    county_fips_all: 15001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96761,
    lat: 20.90961,
    lng: -156.62226,
    city: "Lahaina",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23117,
    density: 93.7,
    county_fips: 15009,
    county_name: "Maui",
    county_weights: {
      15009: 100,
    },
    county_names_all: "Maui",
    county_fips_all: 15009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96762,
    lat: 21.62468,
    lng: -157.94201,
    city: "Laie",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6504,
    density: 202.7,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96763,
    lat: 20.83512,
    lng: -156.92717,
    city: "Lanai City",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2888,
    density: 7.9,
    county_fips: 15009,
    county_name: "Maui",
    county_weights: {
      15009: 100,
    },
    county_names_all: "Maui",
    county_fips_all: 15009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96764,
    lat: 19.97766,
    lng: -155.23985,
    city: "Laupahoehoe",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 684,
    density: 108.8,
    county_fips: 15001,
    county_name: "Hawaii",
    county_weights: {
      15001: 100,
    },
    county_names_all: "Hawaii",
    county_fips_all: 15001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96765,
    lat: 21.92608,
    lng: -159.49831,
    city: "Lawai",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 240,
    density: 145.7,
    county_fips: 15007,
    county_name: "Kauai",
    county_weights: {
      15007: 100,
    },
    county_names_all: "Kauai",
    county_fips_all: 15007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96766,
    lat: 22.00556,
    lng: -159.41931,
    city: "Lihue",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18584,
    density: 76.6,
    county_fips: 15007,
    county_name: "Kauai",
    county_weights: {
      15007: 100,
    },
    county_names_all: "Kauai",
    county_fips_all: 15007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96768,
    lat: 20.83231,
    lng: -156.29787,
    city: "Makawao",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18592,
    density: 165.8,
    county_fips: 15009,
    county_name: "Maui",
    county_weights: {
      15009: 100,
    },
    county_names_all: "Maui",
    county_fips_all: 15009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96769,
    lat: 21.95501,
    lng: -159.61655,
    city: "Makaweli",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 454,
    density: 9.7,
    county_fips: 15007,
    county_name: "Kauai",
    county_weights: {
      15007: 100,
    },
    county_names_all: "Kauai",
    county_fips_all: 15007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96770,
    lat: 21.13465,
    lng: -157.20354,
    city: "Maunaloa",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 493,
    density: 2.6,
    county_fips: 15009,
    county_name: "Maui",
    county_weights: {
      15009: 100,
    },
    county_names_all: "Maui",
    county_fips_all: 15009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96771,
    lat: 19.53348,
    lng: -155.13573,
    city: "Mountain View",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7736,
    density: 38.9,
    county_fips: 15001,
    county_name: "Hawaii",
    county_weights: {
      15001: 100,
    },
    county_names_all: "Hawaii",
    county_fips_all: 15001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96772,
    lat: 19.0683,
    lng: -155.66077,
    city: "Naalehu",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2693,
    density: 5,
    county_fips: 15001,
    county_name: "Hawaii",
    county_weights: {
      15001: 100,
    },
    county_names_all: "Hawaii",
    county_fips_all: 15001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96773,
    lat: 19.90677,
    lng: -155.25218,
    city: "Ninole",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 102,
    density: 0.6,
    county_fips: 15001,
    county_name: "Hawaii",
    county_weights: {
      15001: 100,
    },
    county_names_all: "Hawaii",
    county_fips_all: 15001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96774,
    lat: 19.96871,
    lng: -155.31503,
    city: "Ookala",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 221,
    density: 2.6,
    county_fips: 15001,
    county_name: "Hawaii",
    county_weights: {
      15001: 100,
    },
    county_names_all: "Hawaii",
    county_fips_all: 15001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96776,
    lat: 20.00156,
    lng: -155.38777,
    city: "Paauilo",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1315,
    density: 9,
    county_fips: 15001,
    county_name: "Hawaii",
    county_weights: {
      15001: 100,
    },
    county_names_all: "Hawaii",
    county_fips_all: 15001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96777,
    lat: 19.23137,
    lng: -155.4705,
    city: "Pahala",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2265,
    density: 9.4,
    county_fips: 15001,
    county_name: "Hawaii",
    county_weights: {
      15001: 100,
    },
    county_names_all: "Hawaii",
    county_fips_all: 15001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96778,
    lat: 19.45221,
    lng: -154.98624,
    city: "Pahoa",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15198,
    density: 27.7,
    county_fips: 15001,
    county_name: "Hawaii",
    county_weights: {
      15001: 100,
    },
    county_names_all: "Hawaii",
    county_fips_all: 15001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96779,
    lat: 20.90534,
    lng: -156.38208,
    city: "Paia",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2514,
    density: 83.4,
    county_fips: 15009,
    county_name: "Maui",
    county_weights: {
      15009: 100,
    },
    county_names_all: "Maui",
    county_fips_all: 15009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96780,
    lat: 19.96592,
    lng: -155.225,
    city: "Papaaloa",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 659,
    density: 143.6,
    county_fips: 15001,
    county_name: "Hawaii",
    county_weights: {
      15001: 100,
    },
    county_names_all: "Hawaii",
    county_fips_all: 15001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96781,
    lat: 19.80066,
    lng: -155.18194,
    city: "Papaikou",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1086,
    density: 8.1,
    county_fips: 15001,
    county_name: "Hawaii",
    county_weights: {
      15001: 100,
    },
    county_names_all: "Hawaii",
    county_fips_all: 15001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96782,
    lat: 21.43471,
    lng: -157.94694,
    city: "Pearl City",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37843,
    density: 496.3,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96783,
    lat: 19.84293,
    lng: -155.1074,
    city: "Pepeekeo",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1810,
    density: 84.2,
    county_fips: 15001,
    county_name: "Hawaii",
    county_weights: {
      15001: 100,
    },
    county_names_all: "Hawaii",
    county_fips_all: 15001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96785,
    lat: 19.47818,
    lng: -155.23017,
    city: "Volcano",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3926,
    density: 20.7,
    county_fips: 15001,
    county_name: "Hawaii",
    county_weights: {
      15001: 100,
    },
    county_names_all: "Hawaii",
    county_fips_all: 15001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96786,
    lat: 21.53733,
    lng: -158.02331,
    city: "Wahiawa",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41157,
    density: 178.2,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96789,
    lat: 21.47823,
    lng: -157.97264,
    city: "Mililani",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 53233,
    density: 779.5,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96790,
    lat: 20.6975,
    lng: -156.31121,
    city: "Kula",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9076,
    density: 17.3,
    county_fips: 15009,
    county_name: "Maui",
    county_weights: {
      15009: 100,
    },
    county_names_all: "Maui",
    county_fips_all: 15009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96791,
    lat: 21.55072,
    lng: -158.15857,
    city: "Waialua",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7303,
    density: 77.2,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96792,
    lat: 21.46311,
    lng: -158.16418,
    city: "Waianae",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50440,
    density: 319,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96793,
    lat: 20.88998,
    lng: -156.53215,
    city: "Wailuku",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34619,
    density: 175.6,
    county_fips: 15009,
    county_name: "Maui",
    county_weights: {
      15009: 100,
    },
    county_names_all: "Maui",
    county_fips_all: 15009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96795,
    lat: 21.33934,
    lng: -157.71643,
    city: "Waimanalo",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9909,
    density: 333.6,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96796,
    lat: 21.96512,
    lng: -159.66793,
    city: "Waimea",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1682,
    density: 347.5,
    county_fips: 15007,
    county_name: "Kauai",
    county_weights: {
      15007: 100,
    },
    county_names_all: "Kauai",
    county_fips_all: 15007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96797,
    lat: 21.40734,
    lng: -158.01658,
    city: "Waipahu",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 70684,
    density: 1416.9,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96799,
    lat: -14.21984,
    lng: -170.37005,
    city: "Pago Pago",
    state_id: "AS",
    state_name: "American Samoa",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 60050,
    county_name: "Western",
    county_weights: {
      60010: 32.58,
      60020: 29.15,
      60040: 1.78,
      60050: 36.49,
    },
    county_names_all: "Western|Eastern|Manu'a|Swains Island",
    county_fips_all: "60050|60010|60020|60040",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Pago_Pago",
  },
  {
    zip: 96813,
    lat: 21.31628,
    lng: -157.84359,
    city: "Honolulu",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25833,
    density: 2807.3,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96814,
    lat: 21.29405,
    lng: -157.84637,
    city: "Honolulu",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20348,
    density: 6446.6,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96815,
    lat: 21.27375,
    lng: -157.82108,
    city: "Honolulu",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25940,
    density: 4557.4,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96816,
    lat: 21.29379,
    lng: -157.79009,
    city: "Honolulu",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50300,
    density: 2030,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96817,
    lat: 21.34016,
    lng: -157.83749,
    city: "Honolulu",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54378,
    density: 2257.3,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96818,
    lat: 21.34637,
    lng: -157.93704,
    city: "Honolulu",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 59923,
    density: 2143.7,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96819,
    lat: 21.34968,
    lng: -157.87527,
    city: "Honolulu",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51179,
    density: 904.5,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96820,
    lat: 21.33633,
    lng: -157.92071,
    city: "Honolulu",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96821,
    lat: 21.29952,
    lng: -157.75004,
    city: "Honolulu",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18700,
    density: 624,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96822,
    lat: 21.32046,
    lng: -157.81037,
    city: "Honolulu",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46865,
    density: 2252.6,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96825,
    lat: 21.29575,
    lng: -157.69234,
    city: "Honolulu",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28398,
    density: 1007,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96826,
    lat: 21.29171,
    lng: -157.82698,
    city: "Honolulu",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31653,
    density: 11393.5,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96848,
    lat: 21.30131,
    lng: -157.81419,
    city: "Honolulu",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96850,
    lat: 21.30385,
    lng: -157.86258,
    city: "Honolulu",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96853,
    lat: 21.335,
    lng: -157.94032,
    city: "Jbphh",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 475,
    density: 1162.8,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96857,
    lat: 21.48798,
    lng: -158.05293,
    city: "Schofield Barracks",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2918,
    density: 2129.4,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96858,
    lat: 21.34459,
    lng: -157.88342,
    city: "Fort Shafter",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96859,
    lat: 21.35987,
    lng: -157.88985,
    city: "Tripler Army Medical Center",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96860,
    lat: 21.35687,
    lng: -157.94829,
    city: "Jbphh",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1898,
    density: 784.8,
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96863,
    lat: 21.4351,
    lng: -157.75002,
    city: "Mcbh Kaneohe Bay",
    state_id: "HI",
    state_name: "Hawaii",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 15003,
    county_name: "Honolulu",
    county_weights: {
      15003: 100,
    },
    county_names_all: "Honolulu",
    county_fips_all: 15003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Honolulu",
  },
  {
    zip: 96910,
    lat: 13.45472,
    lng: 144.75128,
    city: "Hagatna",
    state_id: "GU",
    state_name: "Guam",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 66010,
    county_name: "Guam",
    county_weights: {
      66010: 100,
    },
    county_names_all: "Guam",
    county_fips_all: 66010,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Guam",
  },
  {
    zip: 96913,
    lat: 13.47825,
    lng: 144.81519,
    city: "Barrigada",
    state_id: "GU",
    state_name: "Guam",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 66010,
    county_name: "Guam",
    county_weights: {
      66010: 100,
    },
    county_names_all: "Guam",
    county_fips_all: 66010,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Guam",
  },
  {
    zip: 96915,
    lat: 13.37526,
    lng: 144.70714,
    city: "Santa Rita",
    state_id: "GU",
    state_name: "Guam",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 66010,
    county_name: "Guam",
    county_weights: {
      66010: 100,
    },
    county_names_all: "Guam",
    county_fips_all: 66010,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Guam",
  },
  {
    zip: 96916,
    lat: 13.26593,
    lng: 144.68915,
    city: "Merizo",
    state_id: "GU",
    state_name: "Guam",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 66010,
    county_name: "Guam",
    county_weights: {
      66010: 100,
    },
    county_names_all: "Guam",
    county_fips_all: 66010,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Guam",
  },
  {
    zip: 96917,
    lat: 13.28469,
    lng: 144.73991,
    city: "Inarajan",
    state_id: "GU",
    state_name: "Guam",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 66010,
    county_name: "Guam",
    county_weights: {
      66010: 100,
    },
    county_names_all: "Guam",
    county_fips_all: 66010,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Guam",
  },
  {
    zip: 96928,
    lat: 13.35626,
    lng: 144.65731,
    city: "Agat",
    state_id: "GU",
    state_name: "Guam",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 66010,
    county_name: "Guam",
    county_weights: {
      66010: 100,
    },
    county_names_all: "Guam",
    county_fips_all: 66010,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Guam",
  },
  {
    zip: 96929,
    lat: 13.56521,
    lng: 144.87637,
    city: "Yigo",
    state_id: "GU",
    state_name: "Guam",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 66010,
    county_name: "Guam",
    county_weights: {
      66010: 100,
    },
    county_names_all: "Guam",
    county_fips_all: 66010,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Guam",
  },
  {
    zip: 96950,
    lat: 15.18888,
    lng: 145.75349,
    city: "Saipan",
    state_id: "MP",
    state_name: "Northern Mariana Islands",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 69110,
    county_name: "Saipan",
    county_weights: {
      69110: 100,
    },
    county_names_all: "Saipan",
    county_fips_all: 69110,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Saipan",
  },
  {
    zip: 96951,
    lat: 14.15733,
    lng: 145.2145,
    city: "Rota",
    state_id: "MP",
    state_name: "Northern Mariana Islands",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 69100,
    county_name: "Rota",
    county_weights: {
      69100: 100,
    },
    county_names_all: "Rota",
    county_fips_all: 69100,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Saipan",
  },
  {
    zip: 96952,
    lat: 15.01311,
    lng: 145.63149,
    city: "Tinian",
    state_id: "MP",
    state_name: "Northern Mariana Islands",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 69120,
    county_name: "Tinian",
    county_weights: {
      69120: 100,
    },
    county_names_all: "Tinian",
    county_fips_all: 69120,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "Pacific/Saipan",
  },
  {
    zip: 97001,
    lat: 44.93328,
    lng: -120.64169,
    city: "Antelope",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 385,
    density: 0.5,
    county_fips: 41065,
    county_name: "Wasco",
    county_weights: {
      41065: 100,
    },
    county_names_all: "Wasco",
    county_fips_all: 41065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97002,
    lat: 45.23774,
    lng: -122.8003,
    city: "Aurora",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6418,
    density: 59.7,
    county_fips: 41047,
    county_name: "Marion",
    county_weights: {
      41005: 29.23,
      41047: 70.77,
    },
    county_names_all: "Marion|Clackamas",
    county_fips_all: "41047|41005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97003,
    lat: 45.50372,
    lng: -122.86482,
    city: "Beaverton",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 41067,
    county_name: "Washington",
    county_weights: {
      41067: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 41067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97004,
    lat: 45.25068,
    lng: -122.45399,
    city: "Beavercreek",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3964,
    density: 35.4,
    county_fips: 41005,
    county_name: "Clackamas",
    county_weights: {
      41005: 100,
    },
    county_names_all: "Clackamas",
    county_fips_all: 41005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97005,
    lat: 45.49144,
    lng: -122.80397,
    city: "Beaverton",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27393,
    density: 2063.6,
    county_fips: 41067,
    county_name: "Washington",
    county_weights: {
      41067: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 41067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97006,
    lat: 45.52598,
    lng: -122.85591,
    city: "Beaverton",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74152,
    density: 3957.4,
    county_fips: 41067,
    county_name: "Washington",
    county_weights: {
      41067: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 41067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97007,
    lat: 45.44282,
    lng: -122.87112,
    city: "Beaverton",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 71896,
    density: 1486.6,
    county_fips: 41067,
    county_name: "Washington",
    county_weights: {
      41067: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 41067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97008,
    lat: 45.46044,
    lng: -122.80252,
    city: "Beaverton",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30485,
    density: 2221.5,
    county_fips: 41067,
    county_name: "Washington",
    county_weights: {
      41067: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 41067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97009,
    lat: 45.42409,
    lng: -122.33962,
    city: "Boring",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8198,
    density: 103.1,
    county_fips: 41005,
    county_name: "Clackamas",
    county_weights: {
      41005: 97.14,
      41051: 2.86,
    },
    county_names_all: "Clackamas|Multnomah",
    county_fips_all: "41005|41051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97011,
    lat: 45.38738,
    lng: -122.03671,
    city: "Brightwood",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 813,
    density: 68.6,
    county_fips: 41005,
    county_name: "Clackamas",
    county_weights: {
      41005: 100,
    },
    county_names_all: "Clackamas",
    county_fips_all: 41005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97013,
    lat: 45.21799,
    lng: -122.67277,
    city: "Canby",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24396,
    density: 159.8,
    county_fips: 41005,
    county_name: "Clackamas",
    county_weights: {
      41005: 100,
    },
    county_names_all: "Clackamas",
    county_fips_all: 41005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97014,
    lat: 45.61354,
    lng: -121.87405,
    city: "Cascade Locks",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1589,
    density: 4.2,
    county_fips: 41027,
    county_name: "Hood River",
    county_weights: {
      41027: 66.18,
      41051: 33.82,
    },
    county_names_all: "Hood River|Multnomah",
    county_fips_all: "41027|41051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97015,
    lat: 45.41477,
    lng: -122.53767,
    city: "Clackamas",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24332,
    density: 1063.7,
    county_fips: 41005,
    county_name: "Clackamas",
    county_weights: {
      41005: 100,
    },
    county_names_all: "Clackamas",
    county_fips_all: 41005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97016,
    lat: 46.05573,
    lng: -123.27032,
    city: "Clatskanie",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6329,
    density: 10.6,
    county_fips: 41009,
    county_name: "Columbia",
    county_weights: {
      41007: 24,
      41009: 76,
    },
    county_names_all: "Columbia|Clatsop",
    county_fips_all: "41009|41007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97017,
    lat: 45.17017,
    lng: -122.37676,
    city: "Colton",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3787,
    density: 32.3,
    county_fips: 41005,
    county_name: "Clackamas",
    county_weights: {
      41005: 100,
    },
    county_names_all: "Clackamas",
    county_fips_all: 41005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97018,
    lat: 45.8957,
    lng: -122.81165,
    city: "Columbia City",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1696,
    density: 794.8,
    county_fips: 41009,
    county_name: "Columbia",
    county_weights: {
      41009: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 41009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97019,
    lat: 45.494,
    lng: -122.18885,
    city: "Corbett",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3304,
    density: 16.2,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41005: 27.67,
      41051: 72.33,
    },
    county_names_all: "Multnomah|Clackamas",
    county_fips_all: "41051|41005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97020,
    lat: 45.22267,
    lng: -122.83887,
    city: "Donald",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1197,
    density: 1641.5,
    county_fips: 41047,
    county_name: "Marion",
    county_weights: {
      41047: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 41047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97021,
    lat: 45.39048,
    lng: -121.13425,
    city: "Dufur",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1283,
    density: 1.9,
    county_fips: 41065,
    county_name: "Wasco",
    county_weights: {
      41065: 100,
    },
    county_names_all: "Wasco",
    county_fips_all: 41065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97022,
    lat: 45.34562,
    lng: -122.3306,
    city: "Eagle Creek",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3918,
    density: 65,
    county_fips: 41005,
    county_name: "Clackamas",
    county_weights: {
      41005: 100,
    },
    county_names_all: "Clackamas",
    county_fips_all: 41005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97023,
    lat: 45.19147,
    lng: -122.20501,
    city: "Estacada",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10481,
    density: 20.6,
    county_fips: 41005,
    county_name: "Clackamas",
    county_weights: {
      41005: 100,
    },
    county_names_all: "Clackamas",
    county_fips_all: 41005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97024,
    lat: 45.54576,
    lng: -122.44142,
    city: "Fairview",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10014,
    density: 1121.6,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41051: 100,
    },
    county_names_all: "Multnomah",
    county_fips_all: 41051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97026,
    lat: 45.10409,
    lng: -122.94251,
    city: "Gervais",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3926,
    density: 44.9,
    county_fips: 41047,
    county_name: "Marion",
    county_weights: {
      41047: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 41047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97027,
    lat: 45.38697,
    lng: -122.59271,
    city: "Gladstone",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12984,
    density: 1998.3,
    county_fips: 41005,
    county_name: "Clackamas",
    county_weights: {
      41005: 100,
    },
    county_names_all: "Clackamas",
    county_fips_all: 41005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97028,
    lat: 45.28225,
    lng: -121.75274,
    city: "Government Camp",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 162,
    density: 1.6,
    county_fips: 41005,
    county_name: "Clackamas",
    county_weights: {
      41005: 100,
    },
    county_names_all: "Clackamas",
    county_fips_all: 41005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97029,
    lat: 45.29901,
    lng: -120.81003,
    city: "Grass Valley",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 313,
    density: 0.4,
    county_fips: 41055,
    county_name: "Sherman",
    county_weights: {
      41055: 100,
    },
    county_names_all: "Sherman",
    county_fips_all: 41055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97030,
    lat: 45.50896,
    lng: -122.43135,
    city: "Gresham",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38980,
    density: 2008.9,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41051: 100,
    },
    county_names_all: "Multnomah",
    county_fips_all: 41051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97031,
    lat: 45.61193,
    lng: -121.61094,
    city: "Hood River",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18643,
    density: 48.1,
    county_fips: 41027,
    county_name: "Hood River",
    county_weights: {
      41027: 100,
    },
    county_names_all: "Hood River",
    county_fips_all: 41027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97032,
    lat: 45.17949,
    lng: -122.78559,
    city: "Hubbard",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5210,
    density: 112.5,
    county_fips: 41047,
    county_name: "Marion",
    county_weights: {
      41005: 34.79,
      41047: 65.21,
    },
    county_names_all: "Marion|Clackamas",
    county_fips_all: "41047|41005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97033,
    lat: 45.23361,
    lng: -120.5876,
    city: "Kent",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42,
    density: 0.1,
    county_fips: 41055,
    county_name: "Sherman",
    county_weights: {
      41055: 100,
    },
    county_names_all: "Sherman",
    county_fips_all: 41055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97034,
    lat: 45.4095,
    lng: -122.68467,
    city: "Lake Oswego",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20108,
    density: 1002.8,
    county_fips: 41005,
    county_name: "Clackamas",
    county_weights: {
      41005: 96.63,
      41051: 3.37,
    },
    county_names_all: "Clackamas|Multnomah",
    county_fips_all: "41005|41051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97035,
    lat: 45.41291,
    lng: -122.72616,
    city: "Lake Oswego",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26721,
    density: 1773.8,
    county_fips: 41005,
    county_name: "Clackamas",
    county_weights: {
      41005: 88.03,
      41051: 9.91,
      41067: 2.06,
    },
    county_names_all: "Clackamas|Multnomah|Washington",
    county_fips_all: "41005|41051|41067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97037,
    lat: 45.06567,
    lng: -121.03141,
    city: "Maupin",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 805,
    density: 0.6,
    county_fips: 41065,
    county_name: "Wasco",
    county_weights: {
      41065: 100,
    },
    county_names_all: "Wasco",
    county_fips_all: 41065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97038,
    lat: 45.08575,
    lng: -122.55288,
    city: "Molalla",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15504,
    density: 45.7,
    county_fips: 41005,
    county_name: "Clackamas",
    county_weights: {
      41005: 100,
    },
    county_names_all: "Clackamas",
    county_fips_all: 41005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97039,
    lat: 45.47226,
    lng: -120.62428,
    city: "Moro",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 494,
    density: 1.7,
    county_fips: 41055,
    county_name: "Sherman",
    county_weights: {
      41055: 100,
    },
    county_names_all: "Sherman",
    county_fips_all: 41055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97040,
    lat: 45.62648,
    lng: -121.38476,
    city: "Mosier",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1725,
    density: 12.6,
    county_fips: 41065,
    county_name: "Wasco",
    county_weights: {
      41065: 100,
    },
    county_names_all: "Wasco",
    county_fips_all: 41065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97041,
    lat: 45.41655,
    lng: -121.59617,
    city: "Mount Hood Parkdale",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3084,
    density: 7.5,
    county_fips: 41027,
    county_name: "Hood River",
    county_weights: {
      41027: 100,
    },
    county_names_all: "Hood River",
    county_fips_all: 41027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97042,
    lat: 45.20679,
    lng: -122.53247,
    city: "Mulino",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2877,
    density: 46.7,
    county_fips: 41005,
    county_name: "Clackamas",
    county_weights: {
      41005: 100,
    },
    county_names_all: "Clackamas",
    county_fips_all: 41005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97045,
    lat: 45.32834,
    lng: -122.53058,
    city: "Oregon City",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56558,
    density: 251.6,
    county_fips: 41005,
    county_name: "Clackamas",
    county_weights: {
      41005: 100,
    },
    county_names_all: "Clackamas",
    county_fips_all: 41005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97048,
    lat: 46.03905,
    lng: -122.99483,
    city: "Rainier",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7591,
    density: 30,
    county_fips: 41009,
    county_name: "Columbia",
    county_weights: {
      41009: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 41009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97049,
    lat: 45.35931,
    lng: -121.86829,
    city: "Rhododendron",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1725,
    density: 4.2,
    county_fips: 41005,
    county_name: "Clackamas",
    county_weights: {
      41005: 100,
    },
    county_names_all: "Clackamas",
    county_fips_all: 41005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97050,
    lat: 45.68256,
    lng: -120.7727,
    city: "Rufus",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 211,
    density: 9.9,
    county_fips: 41055,
    county_name: "Sherman",
    county_weights: {
      41055: 100,
    },
    county_names_all: "Sherman",
    county_fips_all: 41055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97051,
    lat: 45.88902,
    lng: -122.92011,
    city: "Saint Helens",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17126,
    density: 114.9,
    county_fips: 41009,
    county_name: "Columbia",
    county_weights: {
      41009: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 41009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97053,
    lat: 45.82695,
    lng: -122.88401,
    city: "Warren",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3633,
    density: 109.5,
    county_fips: 41009,
    county_name: "Columbia",
    county_weights: {
      41009: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 41009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97054,
    lat: 45.95406,
    lng: -122.92995,
    city: "Deer Island",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1368,
    density: 13.3,
    county_fips: 41009,
    county_name: "Columbia",
    county_weights: {
      41009: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 41009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97055,
    lat: 45.35975,
    lng: -122.15396,
    city: "Sandy",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18600,
    density: 63.8,
    county_fips: 41005,
    county_name: "Clackamas",
    county_weights: {
      41005: 100,
    },
    county_names_all: "Clackamas",
    county_fips_all: 41005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97056,
    lat: 45.78935,
    lng: -122.96941,
    city: "Scappoose",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12161,
    density: 42.4,
    county_fips: 41009,
    county_name: "Columbia",
    county_weights: {
      41009: 85.2,
      41051: 4.2,
      41067: 10.6,
    },
    county_names_all: "Columbia|Washington|Multnomah",
    county_fips_all: "41009|41067|41051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97057,
    lat: 45.00422,
    lng: -120.7516,
    city: "Shaniko",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12,
    density: 10.7,
    county_fips: 41065,
    county_name: "Wasco",
    county_weights: {
      41065: 100,
    },
    county_names_all: "Wasco",
    county_fips_all: 41065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97058,
    lat: 45.54239,
    lng: -121.15447,
    city: "The Dalles",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20627,
    density: 24.5,
    county_fips: 41065,
    county_name: "Wasco",
    county_weights: {
      41065: 100,
    },
    county_names_all: "Wasco",
    county_fips_all: 41065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97060,
    lat: 45.5342,
    lng: -122.36989,
    city: "Troutdale",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22133,
    density: 488.6,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41051: 100,
    },
    county_names_all: "Multnomah",
    county_fips_all: 41051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97062,
    lat: 45.36821,
    lng: -122.76169,
    city: "Tualatin",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28740,
    density: 781.2,
    county_fips: 41067,
    county_name: "Washington",
    county_weights: {
      41005: 27.38,
      41067: 72.62,
    },
    county_names_all: "Washington|Clackamas",
    county_fips_all: "41067|41005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97063,
    lat: 45.22319,
    lng: -121.28306,
    city: "Tygh Valley",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 727,
    density: 2,
    county_fips: 41065,
    county_name: "Wasco",
    county_weights: {
      41065: 100,
    },
    county_names_all: "Wasco",
    county_fips_all: 41065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97064,
    lat: 45.87276,
    lng: -123.2309,
    city: "Vernonia",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3244,
    density: 12.8,
    county_fips: 41009,
    county_name: "Columbia",
    county_weights: {
      41009: 93.11,
      41067: 6.89,
    },
    county_names_all: "Columbia|Washington",
    county_fips_all: "41009|41067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97065,
    lat: 45.59803,
    lng: -120.65696,
    city: "Wasco",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 626,
    density: 1,
    county_fips: 41055,
    county_name: "Sherman",
    county_weights: {
      41055: 100,
    },
    county_names_all: "Sherman",
    county_fips_all: 41055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97067,
    lat: 45.31302,
    lng: -121.97733,
    city: "Welches",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2004,
    density: 34,
    county_fips: 41005,
    county_name: "Clackamas",
    county_weights: {
      41005: 100,
    },
    county_names_all: "Clackamas",
    county_fips_all: 41005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97068,
    lat: 45.35195,
    lng: -122.66876,
    city: "West Linn",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30085,
    density: 518.8,
    county_fips: 41005,
    county_name: "Clackamas",
    county_weights: {
      41005: 100,
    },
    county_names_all: "Clackamas",
    county_fips_all: 41005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97070,
    lat: 45.308,
    lng: -122.77059,
    city: "Wilsonville",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25163,
    density: 547,
    county_fips: 41005,
    county_name: "Clackamas",
    county_weights: {
      41005: 96.58,
      41067: 3.42,
    },
    county_names_all: "Clackamas|Washington",
    county_fips_all: "41005|41067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97071,
    lat: 45.13588,
    lng: -122.82344,
    city: "Woodburn",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31034,
    density: 231.9,
    county_fips: 41047,
    county_name: "Marion",
    county_weights: {
      41005: 25.97,
      41047: 74.03,
    },
    county_names_all: "Marion|Clackamas",
    county_fips_all: "41047|41005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97078,
    lat: 45.47628,
    lng: -122.89088,
    city: "Beaverton",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 41067,
    county_name: "Washington",
    county_weights: {
      41067: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 41067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97080,
    lat: 45.47848,
    lng: -122.39001,
    city: "Gresham",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44907,
    density: 801.3,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41051: 100,
    },
    county_names_all: "Multnomah",
    county_fips_all: 41051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97086,
    lat: 45.44531,
    lng: -122.52793,
    city: "Happy Valley",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31609,
    density: 1164.9,
    county_fips: 41005,
    county_name: "Clackamas",
    county_weights: {
      41005: 100,
    },
    county_names_all: "Clackamas",
    county_fips_all: 41005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97089,
    lat: 45.4256,
    lng: -122.44342,
    city: "Damascus",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13777,
    density: 246.1,
    county_fips: 41005,
    county_name: "Clackamas",
    county_weights: {
      41005: 100,
    },
    county_names_all: "Clackamas",
    county_fips_all: 41005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97101,
    lat: 45.09225,
    lng: -123.21557,
    city: "Amity",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4141,
    density: 31.9,
    county_fips: 41071,
    county_name: "Yamhill",
    county_weights: {
      41053: 35.68,
      41071: 64.32,
    },
    county_names_all: "Yamhill|Polk",
    county_fips_all: "41071|41053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97102,
    lat: 45.7934,
    lng: -123.94793,
    city: "Arch Cape",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 328,
    density: 15.2,
    county_fips: 41007,
    county_name: "Clatsop",
    county_weights: {
      41007: 61.78,
      41057: 38.22,
    },
    county_names_all: "Clatsop|Tillamook",
    county_fips_all: "41007|41057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97103,
    lat: 46.13327,
    lng: -123.69648,
    city: "Astoria",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17892,
    density: 42.3,
    county_fips: 41007,
    county_name: "Clatsop",
    county_weights: {
      41007: 100,
    },
    county_names_all: "Clatsop",
    county_fips_all: 41007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97106,
    lat: 45.65419,
    lng: -123.13417,
    city: "Banks",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4942,
    density: 43.3,
    county_fips: 41067,
    county_name: "Washington",
    county_weights: {
      41067: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 41067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97107,
    lat: 45.56172,
    lng: -123.88291,
    city: "Bay City",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2302,
    density: 50.3,
    county_fips: 41057,
    county_name: "Tillamook",
    county_weights: {
      41057: 100,
    },
    county_names_all: "Tillamook",
    county_fips_all: 41057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97108,
    lat: 45.27423,
    lng: -123.67544,
    city: "Beaver",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 518,
    density: 2,
    county_fips: 41057,
    county_name: "Tillamook",
    county_weights: {
      41057: 100,
    },
    county_names_all: "Tillamook",
    county_fips_all: 41057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97109,
    lat: 45.73777,
    lng: -123.1946,
    city: "Buxton",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 736,
    density: 10.5,
    county_fips: 41067,
    county_name: "Washington",
    county_weights: {
      41067: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 41067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97110,
    lat: 45.89186,
    lng: -123.95128,
    city: "Cannon Beach",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1286,
    density: 81,
    county_fips: 41007,
    county_name: "Clatsop",
    county_weights: {
      41007: 100,
    },
    county_names_all: "Clatsop",
    county_fips_all: 41007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97111,
    lat: 45.29012,
    lng: -123.19855,
    city: "Carlton",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3441,
    density: 34.9,
    county_fips: 41071,
    county_name: "Yamhill",
    county_weights: {
      41071: 100,
    },
    county_names_all: "Yamhill",
    county_fips_all: 41071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97112,
    lat: 45.26218,
    lng: -123.86629,
    city: "Cloverdale",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1688,
    density: 5.7,
    county_fips: 41057,
    county_name: "Tillamook",
    county_weights: {
      41057: 100,
    },
    county_names_all: "Tillamook",
    county_fips_all: 41057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97113,
    lat: 45.50746,
    lng: -123.04544,
    city: "Cornelius",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14689,
    density: 162.3,
    county_fips: 41067,
    county_name: "Washington",
    county_weights: {
      41067: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 41067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97114,
    lat: 45.18381,
    lng: -123.07172,
    city: "Dayton",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4675,
    density: 30.3,
    county_fips: 41071,
    county_name: "Yamhill",
    county_weights: {
      41071: 100,
    },
    county_names_all: "Yamhill",
    county_fips_all: 41071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97115,
    lat: 45.27573,
    lng: -123.02682,
    city: "Dundee",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4021,
    density: 143.3,
    county_fips: 41071,
    county_name: "Yamhill",
    county_weights: {
      41071: 100,
    },
    county_names_all: "Yamhill",
    county_fips_all: 41071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97116,
    lat: 45.59054,
    lng: -123.18876,
    city: "Forest Grove",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27349,
    density: 128.7,
    county_fips: 41067,
    county_name: "Washington",
    county_weights: {
      41067: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 41067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97117,
    lat: 45.62189,
    lng: -123.31132,
    city: "Gales Creek",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 727,
    density: 7.1,
    county_fips: 41067,
    county_name: "Washington",
    county_weights: {
      41067: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 41067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97118,
    lat: 45.55697,
    lng: -123.91619,
    city: "Garibaldi",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 672,
    density: 279.5,
    county_fips: 41057,
    county_name: "Tillamook",
    county_weights: {
      41057: 100,
    },
    county_names_all: "Tillamook",
    county_fips_all: 41057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97119,
    lat: 45.4717,
    lng: -123.20781,
    city: "Gaston",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5309,
    density: 21.7,
    county_fips: 41067,
    county_name: "Washington",
    county_weights: {
      41067: 79.2,
      41071: 20.8,
    },
    county_names_all: "Washington|Yamhill",
    county_fips_all: "41067|41071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97121,
    lat: 46.19347,
    lng: -123.97141,
    city: "Hammond",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1352,
    density: 69.1,
    county_fips: 41007,
    county_name: "Clatsop",
    county_weights: {
      41007: 100,
    },
    county_names_all: "Clatsop",
    county_fips_all: 41007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97122,
    lat: 45.17331,
    lng: -123.8164,
    city: "Hebo",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 526,
    density: 7.3,
    county_fips: 41057,
    county_name: "Tillamook",
    county_weights: {
      41057: 100,
    },
    county_names_all: "Tillamook",
    county_fips_all: 41057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97123,
    lat: 45.44353,
    lng: -122.98048,
    city: "Hillsboro",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49522,
    density: 343.5,
    county_fips: 41067,
    county_name: "Washington",
    county_weights: {
      41067: 89.49,
      41071: 10.51,
    },
    county_names_all: "Washington|Yamhill",
    county_fips_all: "41067|41071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97124,
    lat: 45.57088,
    lng: -122.94584,
    city: "Hillsboro",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56101,
    density: 479.8,
    county_fips: 41067,
    county_name: "Washington",
    county_weights: {
      41051: 2.13,
      41067: 97.87,
    },
    county_names_all: "Washington|Multnomah",
    county_fips_all: "41067|41051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97125,
    lat: 45.66243,
    lng: -123.21117,
    city: "Manning",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 141,
    density: 10.6,
    county_fips: 41067,
    county_name: "Washington",
    county_weights: {
      41067: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 41067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97127,
    lat: 45.24629,
    lng: -123.11159,
    city: "Lafayette",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4222,
    density: 1886.2,
    county_fips: 41071,
    county_name: "Yamhill",
    county_weights: {
      41071: 100,
    },
    county_names_all: "Yamhill",
    county_fips_all: 41071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97128,
    lat: 45.19814,
    lng: -123.25812,
    city: "Mcminnville",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38246,
    density: 131.6,
    county_fips: 41071,
    county_name: "Yamhill",
    county_weights: {
      41071: 100,
    },
    county_names_all: "Yamhill",
    county_fips_all: 41071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97130,
    lat: 45.71592,
    lng: -123.93318,
    city: "Manzanita",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 528,
    density: 183.6,
    county_fips: 41057,
    county_name: "Tillamook",
    county_weights: {
      41057: 100,
    },
    county_names_all: "Tillamook",
    county_fips_all: 41057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97131,
    lat: 45.71495,
    lng: -123.8107,
    city: "Nehalem",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3065,
    density: 8.5,
    county_fips: 41057,
    county_name: "Tillamook",
    county_weights: {
      41007: 13.44,
      41057: 86.56,
    },
    county_names_all: "Tillamook|Clatsop",
    county_fips_all: "41057|41007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97132,
    lat: 45.32272,
    lng: -122.98854,
    city: "Newberg",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29851,
    density: 184,
    county_fips: 41071,
    county_name: "Yamhill",
    county_weights: {
      41005: 1.23,
      41067: 6.4,
      41071: 92.37,
    },
    county_names_all: "Yamhill|Washington|Clackamas",
    county_fips_all: "41071|41067|41005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97133,
    lat: 45.68719,
    lng: -123.02861,
    city: "North Plains",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4948,
    density: 24.9,
    county_fips: 41067,
    county_name: "Washington",
    county_weights: {
      41051: 3.58,
      41067: 96.42,
    },
    county_names_all: "Washington|Multnomah",
    county_fips_all: "41067|41051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97134,
    lat: 45.45587,
    lng: -123.96513,
    city: "Oceanside",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 108,
    density: 93.7,
    county_fips: 41057,
    county_name: "Tillamook",
    county_weights: {
      41057: 100,
    },
    county_names_all: "Tillamook",
    county_fips_all: 41057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97135,
    lat: 45.18749,
    lng: -123.95494,
    city: "Pacific City",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1016,
    density: 114.2,
    county_fips: 41057,
    county_name: "Tillamook",
    county_weights: {
      41057: 100,
    },
    county_names_all: "Tillamook",
    county_fips_all: 41057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97136,
    lat: 45.6341,
    lng: -123.91353,
    city: "Rockaway Beach",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1909,
    density: 37.7,
    county_fips: 41057,
    county_name: "Tillamook",
    county_weights: {
      41057: 100,
    },
    county_names_all: "Tillamook",
    county_fips_all: 41057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97137,
    lat: 45.21028,
    lng: -122.9635,
    city: "Saint Paul",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1087,
    density: 9.3,
    county_fips: 41047,
    county_name: "Marion",
    county_weights: {
      41047: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 41047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97138,
    lat: 45.90946,
    lng: -123.70036,
    city: "Seaside",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10799,
    density: 28.6,
    county_fips: 41007,
    county_name: "Clatsop",
    county_weights: {
      41007: 100,
    },
    county_names_all: "Clatsop",
    county_fips_all: 41007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97140,
    lat: 45.35359,
    lng: -122.86339,
    city: "Sherwood",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25778,
    density: 223.3,
    county_fips: 41067,
    county_name: "Washington",
    county_weights: {
      41005: 22.7,
      41067: 74.92,
      41071: 2.38,
    },
    county_names_all: "Washington|Clackamas|Yamhill",
    county_fips_all: "41067|41005|41071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97141,
    lat: 45.47142,
    lng: -123.73791,
    city: "Tillamook",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13557,
    density: 20.2,
    county_fips: 41057,
    county_name: "Tillamook",
    county_weights: {
      41057: 100,
    },
    county_names_all: "Tillamook",
    county_fips_all: 41057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97144,
    lat: 45.74349,
    lng: -123.30305,
    city: "Timber",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 138,
    density: 3.3,
    county_fips: 41067,
    county_name: "Washington",
    county_weights: {
      41067: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 41067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97145,
    lat: 45.84357,
    lng: -123.9516,
    city: "Tolovana Park",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 298,
    density: 45.1,
    county_fips: 41007,
    county_name: "Clatsop",
    county_weights: {
      41007: 100,
    },
    county_names_all: "Clatsop",
    county_fips_all: 41007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97146,
    lat: 46.11849,
    lng: -123.91399,
    city: "Warrenton",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6980,
    density: 105.1,
    county_fips: 41007,
    county_name: "Clatsop",
    county_weights: {
      41007: 100,
    },
    county_names_all: "Clatsop",
    county_fips_all: 41007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97147,
    lat: 45.6871,
    lng: -123.8873,
    city: "Wheeler",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 376,
    density: 282.9,
    county_fips: 41057,
    county_name: "Tillamook",
    county_weights: {
      41057: 100,
    },
    county_names_all: "Tillamook",
    county_fips_all: 41057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97148,
    lat: 45.35988,
    lng: -123.26553,
    city: "Yamhill",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3553,
    density: 15,
    county_fips: 41071,
    county_name: "Yamhill",
    county_weights: {
      41071: 100,
    },
    county_names_all: "Yamhill",
    county_fips_all: 41071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97149,
    lat: 45.09957,
    lng: -123.94455,
    city: "Neskowin",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 458,
    density: 7.1,
    county_fips: 41057,
    county_name: "Tillamook",
    county_weights: {
      41057: 100,
    },
    county_names_all: "Tillamook",
    county_fips_all: 41057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97201,
    lat: 45.50796,
    lng: -122.68959,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17558,
    density: 3543.7,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41051: 100,
    },
    county_names_all: "Multnomah",
    county_fips_all: 41051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97202,
    lat: 45.48232,
    lng: -122.64365,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43744,
    density: 2692.1,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41005: 0.99,
      41051: 99.01,
    },
    county_names_all: "Multnomah|Clackamas",
    county_fips_all: "41051|41005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97203,
    lat: 45.60764,
    lng: -122.74923,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34759,
    density: 1245.4,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41051: 100,
    },
    county_names_all: "Multnomah",
    county_fips_all: 41051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97204,
    lat: 45.5183,
    lng: -122.67378,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1162,
    density: 1819.9,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41051: 100,
    },
    county_names_all: "Multnomah",
    county_fips_all: 41051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97205,
    lat: 45.51924,
    lng: -122.70127,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7679,
    density: 3147.6,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41051: 100,
    },
    county_names_all: "Multnomah",
    county_fips_all: 41051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97206,
    lat: 45.48173,
    lng: -122.5988,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54248,
    density: 3246.4,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41005: 8.13,
      41051: 91.87,
    },
    county_names_all: "Multnomah|Clackamas",
    county_fips_all: "41051|41005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97208,
    lat: 45.52866,
    lng: -122.67898,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41051: 100,
    },
    county_names_all: "Multnomah",
    county_fips_all: 41051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97209,
    lat: 45.53093,
    lng: -122.68429,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19824,
    density: 7430.7,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41051: 100,
    },
    county_names_all: "Multnomah",
    county_fips_all: 41051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97210,
    lat: 45.54954,
    lng: -122.73549,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11395,
    density: 494.6,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41051: 99.81,
      41067: 0.19,
    },
    county_names_all: "Multnomah|Washington",
    county_fips_all: "41051|41067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97211,
    lat: 45.58174,
    lng: -122.63548,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35738,
    density: 1933.5,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41051: 100,
    },
    county_names_all: "Multnomah",
    county_fips_all: 41051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97212,
    lat: 45.54428,
    lng: -122.64322,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28770,
    density: 4070.2,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41051: 100,
    },
    county_names_all: "Multnomah",
    county_fips_all: 41051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97213,
    lat: 45.53776,
    lng: -122.59957,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32815,
    density: 3142.5,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41051: 100,
    },
    county_names_all: "Multnomah",
    county_fips_all: 41051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97214,
    lat: 45.51395,
    lng: -122.64424,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28348,
    density: 3765.3,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41051: 100,
    },
    county_names_all: "Multnomah",
    county_fips_all: 41051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97215,
    lat: 45.51436,
    lng: -122.59923,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17354,
    density: 2869.3,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41051: 100,
    },
    county_names_all: "Multnomah",
    county_fips_all: 41051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97216,
    lat: 45.51393,
    lng: -122.5585,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17757,
    density: 2725.1,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41051: 100,
    },
    county_names_all: "Multnomah",
    county_fips_all: 41051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97217,
    lat: 45.59686,
    lng: -122.69717,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34881,
    density: 1208.6,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41051: 100,
    },
    county_names_all: "Multnomah",
    county_fips_all: 41051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97218,
    lat: 45.5759,
    lng: -122.60023,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14666,
    density: 850.6,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41051: 100,
    },
    county_names_all: "Multnomah",
    county_fips_all: 41051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97219,
    lat: 45.45413,
    lng: -122.69972,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43274,
    density: 1428.1,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41005: 3.44,
      41051: 96.56,
    },
    county_names_all: "Multnomah|Clackamas",
    county_fips_all: "41051|41005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97220,
    lat: 45.55107,
    lng: -122.55915,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29318,
    density: 1507.1,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41051: 100,
    },
    county_names_all: "Multnomah",
    county_fips_all: 41051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97221,
    lat: 45.49799,
    lng: -122.72749,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12104,
    density: 1060.8,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41051: 99.76,
      41067: 0.24,
    },
    county_names_all: "Multnomah|Washington",
    county_fips_all: "41051|41067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97222,
    lat: 45.44114,
    lng: -122.61682,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36904,
    density: 1647.5,
    county_fips: 41005,
    county_name: "Clackamas",
    county_weights: {
      41005: 99.01,
      41051: 0.99,
    },
    county_names_all: "Clackamas|Multnomah",
    county_fips_all: "41005|41051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97223,
    lat: 45.44023,
    lng: -122.77838,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51513,
    density: 1797.7,
    county_fips: 41067,
    county_name: "Washington",
    county_weights: {
      41067: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 41067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97224,
    lat: 45.40568,
    lng: -122.7958,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35949,
    density: 1534,
    county_fips: 41067,
    county_name: "Washington",
    county_weights: {
      41067: 100,
    },
    county_names_all: "Washington",
    county_fips_all: 41067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97225,
    lat: 45.502,
    lng: -122.76994,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25965,
    density: 1505.5,
    county_fips: 41067,
    county_name: "Washington",
    county_weights: {
      41051: 0.74,
      41067: 99.26,
    },
    county_names_all: "Washington|Multnomah",
    county_fips_all: "41067|41051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97227,
    lat: 45.54432,
    lng: -122.67721,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5911,
    density: 1598.9,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41051: 100,
    },
    county_names_all: "Multnomah",
    county_fips_all: 41051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97229,
    lat: 45.55032,
    lng: -122.81026,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 71529,
    density: 1405.4,
    county_fips: 41067,
    county_name: "Washington",
    county_weights: {
      41051: 37.82,
      41067: 62.18,
    },
    county_names_all: "Washington|Multnomah",
    county_fips_all: "41067|41051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97230,
    lat: 45.5582,
    lng: -122.506,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39900,
    density: 1106.6,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41051: 100,
    },
    county_names_all: "Multnomah",
    county_fips_all: 41051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97231,
    lat: 45.68197,
    lng: -122.82687,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3975,
    density: 24.5,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41009: 25.36,
      41051: 72.53,
      41067: 2.11,
    },
    county_names_all: "Multnomah|Columbia|Washington",
    county_fips_all: "41051|41009|41067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97232,
    lat: 45.5292,
    lng: -122.64376,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14140,
    density: 2919.9,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41051: 100,
    },
    county_names_all: "Multnomah",
    county_fips_all: 41051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97233,
    lat: 45.51391,
    lng: -122.49887,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38779,
    density: 3224.4,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41051: 100,
    },
    county_names_all: "Multnomah",
    county_fips_all: 41051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97236,
    lat: 45.48474,
    lng: -122.51055,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39669,
    density: 1984.3,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41051: 100,
    },
    county_names_all: "Multnomah",
    county_fips_all: 41051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97239,
    lat: 45.48893,
    lng: -122.69053,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18637,
    density: 2008.4,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41051: 100,
    },
    county_names_all: "Multnomah",
    county_fips_all: 41051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97266,
    lat: 45.48268,
    lng: -122.55838,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36818,
    density: 2346.6,
    county_fips: 41051,
    county_name: "Multnomah",
    county_weights: {
      41051: 100,
    },
    county_names_all: "Multnomah",
    county_fips_all: 41051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97267,
    lat: 45.40744,
    lng: -122.61472,
    city: "Portland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33250,
    density: 1776,
    county_fips: 41005,
    county_name: "Clackamas",
    county_weights: {
      41005: 100,
    },
    county_names_all: "Clackamas",
    county_fips_all: 41005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97301,
    lat: 44.94948,
    lng: -123.00439,
    city: "Salem",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57194,
    density: 1953.3,
    county_fips: 41047,
    county_name: "Marion",
    county_weights: {
      41047: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 41047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97302,
    lat: 44.90191,
    lng: -123.06719,
    city: "Salem",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40113,
    density: 660.4,
    county_fips: 41047,
    county_name: "Marion",
    county_weights: {
      41047: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 41047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97303,
    lat: 45.03036,
    lng: -123.02449,
    city: "Salem",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41596,
    density: 644.4,
    county_fips: 41047,
    county_name: "Marion",
    county_weights: {
      41047: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 41047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97304,
    lat: 45.0078,
    lng: -123.1078,
    city: "Salem",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32435,
    density: 220.4,
    county_fips: 41053,
    county_name: "Polk",
    county_weights: {
      41053: 86.91,
      41071: 13.09,
    },
    county_names_all: "Polk|Yamhill",
    county_fips_all: "41053|41071",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97305,
    lat: 45.01573,
    lng: -122.92909,
    city: "Salem",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44536,
    density: 364.2,
    county_fips: 41047,
    county_name: "Marion",
    county_weights: {
      41047: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 41047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97306,
    lat: 44.84585,
    lng: -123.07972,
    city: "Salem",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32741,
    density: 390.1,
    county_fips: 41047,
    county_name: "Marion",
    county_weights: {
      41047: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 41047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97310,
    lat: 44.90048,
    lng: -122.97436,
    city: "Salem",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 41047,
    county_name: "Marion",
    county_weights: {
      41047: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 41047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97317,
    lat: 44.90242,
    lng: -122.90628,
    city: "Salem",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26408,
    density: 184.6,
    county_fips: 41047,
    county_name: "Marion",
    county_weights: {
      41047: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 41047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97321,
    lat: 44.64994,
    lng: -123.13474,
    city: "Albany",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27131,
    density: 151.5,
    county_fips: 41043,
    county_name: "Linn",
    county_weights: {
      41003: 31.26,
      41043: 68.74,
    },
    county_names_all: "Linn|Benton",
    county_fips_all: "41043|41003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97322,
    lat: 44.62524,
    lng: -123.01975,
    city: "Albany",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37343,
    density: 228,
    county_fips: 41043,
    county_name: "Linn",
    county_weights: {
      41043: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 41043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97324,
    lat: 44.34345,
    lng: -123.63042,
    city: "Alsea",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1495,
    density: 3,
    county_fips: 41003,
    county_name: "Benton",
    county_weights: {
      41003: 77.53,
      41039: 13.49,
      41041: 8.98,
    },
    county_names_all: "Benton|Lane|Lincoln",
    county_fips_all: "41003|41039|41041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97325,
    lat: 44.83141,
    lng: -122.85195,
    city: "Aumsville",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6837,
    density: 87.3,
    county_fips: 41047,
    county_name: "Marion",
    county_weights: {
      41047: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 41047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97326,
    lat: 44.62794,
    lng: -123.61573,
    city: "Blodgett",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1397,
    density: 4.6,
    county_fips: 41041,
    county_name: "Lincoln",
    county_weights: {
      41003: 38.97,
      41041: 61.03,
    },
    county_names_all: "Lincoln|Benton",
    county_fips_all: "41041|41003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97327,
    lat: 44.37567,
    lng: -122.94783,
    city: "Brownsville",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3511,
    density: 18.9,
    county_fips: 41043,
    county_name: "Linn",
    county_weights: {
      41043: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 41043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97329,
    lat: 44.3956,
    lng: -122.33698,
    city: "Cascadia",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 107,
    density: 0.7,
    county_fips: 41043,
    county_name: "Linn",
    county_weights: {
      41043: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 41043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97330,
    lat: 44.63796,
    lng: -123.27814,
    city: "Corvallis",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43155,
    density: 213.7,
    county_fips: 41003,
    county_name: "Benton",
    county_weights: {
      41003: 100,
    },
    county_names_all: "Benton",
    county_fips_all: 41003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97331,
    lat: 44.56343,
    lng: -123.28113,
    city: "Corvallis",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2868,
    density: 2033.2,
    county_fips: 41003,
    county_name: "Benton",
    county_weights: {
      41003: 100,
    },
    county_names_all: "Benton",
    county_fips_all: 41003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97333,
    lat: 44.4735,
    lng: -123.3067,
    city: "Corvallis",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23493,
    density: 81,
    county_fips: 41003,
    county_name: "Benton",
    county_weights: {
      41003: 89.04,
      41043: 10.96,
    },
    county_names_all: "Benton|Linn",
    county_fips_all: "41003|41043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97335,
    lat: 44.63776,
    lng: -122.88045,
    city: "Crabtree",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 41043,
    county_name: "Linn",
    county_weights: {
      41043: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 41043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97336,
    lat: 44.35669,
    lng: -122.85092,
    city: "Crawfordsville",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 41043,
    county_name: "Linn",
    county_weights: {
      41043: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 41043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97338,
    lat: 44.93654,
    lng: -123.33868,
    city: "Dallas",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22449,
    density: 69.4,
    county_fips: 41053,
    county_name: "Polk",
    county_weights: {
      41053: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 41053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97341,
    lat: 44.81525,
    lng: -124.04513,
    city: "Depoe Bay",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2628,
    density: 102.4,
    county_fips: 41041,
    county_name: "Lincoln",
    county_weights: {
      41041: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 41041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97342,
    lat: 44.73382,
    lng: -121.94524,
    city: "Detroit",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 80,
    density: 0.4,
    county_fips: 41047,
    county_name: "Marion",
    county_weights: {
      41047: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 41047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97343,
    lat: 44.56934,
    lng: -123.73091,
    city: "Eddyville",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 293,
    density: 0.8,
    county_fips: 41041,
    county_name: "Lincoln",
    county_weights: {
      41041: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 41041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97344,
    lat: 44.86887,
    lng: -123.46596,
    city: "Falls City",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1742,
    density: 58.4,
    county_fips: 41053,
    county_name: "Polk",
    county_weights: {
      41053: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 41053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97345,
    lat: 44.4126,
    lng: -122.57644,
    city: "Foster",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 549,
    density: 5,
    county_fips: 41043,
    county_name: "Linn",
    county_weights: {
      41043: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 41043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97346,
    lat: 44.76948,
    lng: -122.37857,
    city: "Gates",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1087,
    density: 9.6,
    county_fips: 41047,
    county_name: "Marion",
    county_weights: {
      41043: 26.82,
      41047: 73.18,
    },
    county_names_all: "Marion|Linn",
    county_fips_all: "41047|41043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97347,
    lat: 45.07836,
    lng: -123.65943,
    city: "Grand Ronde",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1584,
    density: 12.9,
    county_fips: 41071,
    county_name: "Yamhill",
    county_weights: {
      41053: 45.21,
      41057: 3.69,
      41071: 51.1,
    },
    county_names_all: "Yamhill|Polk|Tillamook",
    county_fips_all: "41071|41053|41057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97348,
    lat: 44.38768,
    lng: -123.12582,
    city: "Halsey",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1533,
    density: 8.8,
    county_fips: 41043,
    county_name: "Linn",
    county_weights: {
      41043: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 41043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97350,
    lat: 44.64786,
    lng: -121.96146,
    city: "Idanha",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 149,
    density: 0.5,
    county_fips: 41043,
    county_name: "Linn",
    county_weights: {
      41043: 92.83,
      41047: 7.17,
    },
    county_names_all: "Linn|Marion",
    county_fips_all: "41043|41047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97351,
    lat: 44.83857,
    lng: -123.17449,
    city: "Independence",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11551,
    density: 85.4,
    county_fips: 41053,
    county_name: "Polk",
    county_weights: {
      41053: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 41053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97352,
    lat: 44.75009,
    lng: -123.02419,
    city: "Jefferson",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6860,
    density: 54.4,
    county_fips: 41047,
    county_name: "Marion",
    county_weights: {
      41043: 18.14,
      41047: 81.86,
    },
    county_names_all: "Marion|Linn",
    county_fips_all: "41047|41043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97355,
    lat: 44.5315,
    lng: -122.81701,
    city: "Lebanon",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31118,
    density: 56.1,
    county_fips: 41043,
    county_name: "Linn",
    county_weights: {
      41043: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 41043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97357,
    lat: 44.73934,
    lng: -123.81592,
    city: "Logsden",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 194,
    density: 3.9,
    county_fips: 41041,
    county_name: "Lincoln",
    county_weights: {
      41041: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 41041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97358,
    lat: 44.80681,
    lng: -122.40702,
    city: "Lyons",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2610,
    density: 11.4,
    county_fips: 41047,
    county_name: "Marion",
    county_weights: {
      41043: 23.5,
      41047: 76.5,
    },
    county_names_all: "Marion|Linn",
    county_fips_all: "41047|41043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97360,
    lat: 44.7515,
    lng: -122.48529,
    city: "Mill City",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2415,
    density: 69,
    county_fips: 41043,
    county_name: "Linn",
    county_weights: {
      41043: 57.9,
      41047: 42.1,
    },
    county_names_all: "Linn|Marion",
    county_fips_all: "41043|41047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97361,
    lat: 44.77251,
    lng: -123.32999,
    city: "Monmouth",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12528,
    density: 36.4,
    county_fips: 41053,
    county_name: "Polk",
    county_weights: {
      41003: 10.8,
      41053: 89.2,
    },
    county_names_all: "Polk|Benton",
    county_fips_all: "41053|41003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97362,
    lat: 45.06903,
    lng: -122.7692,
    city: "Mount Angel",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4322,
    density: 71.4,
    county_fips: 41047,
    county_name: "Marion",
    county_weights: {
      41005: 10.81,
      41047: 89.19,
    },
    county_names_all: "Marion|Clackamas",
    county_fips_all: "41047|41005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97364,
    lat: 44.99889,
    lng: -123.98703,
    city: "Neotsu",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 501,
    density: 636.6,
    county_fips: 41041,
    county_name: "Lincoln",
    county_weights: {
      41041: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 41041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97365,
    lat: 44.67113,
    lng: -124.01825,
    city: "Newport",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11338,
    density: 105.6,
    county_fips: 41041,
    county_name: "Lincoln",
    county_weights: {
      41041: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 41041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97366,
    lat: 44.58288,
    lng: -124.04748,
    city: "South Beach",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1980,
    density: 71.6,
    county_fips: 41041,
    county_name: "Lincoln",
    county_weights: {
      41041: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 41041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97367,
    lat: 44.9122,
    lng: -123.96914,
    city: "Lincoln City",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10023,
    density: 84.6,
    county_fips: 41041,
    county_name: "Lincoln",
    county_weights: {
      41041: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 41041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97368,
    lat: 45.0073,
    lng: -123.89155,
    city: "Otis",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3326,
    density: 21.1,
    county_fips: 41041,
    county_name: "Lincoln",
    county_weights: {
      41041: 92.71,
      41057: 7.29,
    },
    county_names_all: "Lincoln|Tillamook",
    county_fips_all: "41041|41057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97369,
    lat: 44.76015,
    lng: -124.05676,
    city: "Otter Rock",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 139,
    density: 25.4,
    county_fips: 41041,
    county_name: "Lincoln",
    county_weights: {
      41041: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 41041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97370,
    lat: 44.57901,
    lng: -123.46907,
    city: "Philomath",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8861,
    density: 19.2,
    county_fips: 41003,
    county_name: "Benton",
    county_weights: {
      41003: 93.65,
      41053: 6.35,
    },
    county_names_all: "Benton|Polk",
    county_fips_all: "41003|41053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97371,
    lat: 44.98985,
    lng: -123.1994,
    city: "Rickreall",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 592,
    density: 7.2,
    county_fips: 41053,
    county_name: "Polk",
    county_weights: {
      41053: 100,
    },
    county_names_all: "Polk",
    county_fips_all: 41053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97373,
    lat: 45.05819,
    lng: -122.77677,
    city: "Saint Benedict",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 178,
    density: 1487.5,
    county_fips: 41047,
    county_name: "Marion",
    county_weights: {
      41047: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 41047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97374,
    lat: 44.69285,
    lng: -122.77379,
    city: "Scio",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4394,
    density: 13.1,
    county_fips: 41043,
    county_name: "Linn",
    county_weights: {
      41043: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 41043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97375,
    lat: 44.97922,
    lng: -122.6021,
    city: "Scotts Mills",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1241,
    density: 10,
    county_fips: 41047,
    county_name: "Marion",
    county_weights: {
      41005: 21.49,
      41047: 78.51,
    },
    county_names_all: "Marion|Clackamas",
    county_fips_all: "41047|41005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97376,
    lat: 44.50854,
    lng: -123.9768,
    city: "Seal Rock",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1046,
    density: 6.6,
    county_fips: 41041,
    county_name: "Lincoln",
    county_weights: {
      41041: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 41041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97377,
    lat: 44.46403,
    lng: -123.10156,
    city: "Shedd",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 827,
    density: 7.1,
    county_fips: 41043,
    county_name: "Linn",
    county_weights: {
      41043: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 41043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97378,
    lat: 45.08058,
    lng: -123.43127,
    city: "Sheridan",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10637,
    density: 35.2,
    county_fips: 41071,
    county_name: "Yamhill",
    county_weights: {
      41053: 48.53,
      41071: 51.47,
    },
    county_names_all: "Yamhill|Polk",
    county_fips_all: "41071|41053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97380,
    lat: 44.77268,
    lng: -123.94202,
    city: "Siletz",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2272,
    density: 14.6,
    county_fips: 41041,
    county_name: "Lincoln",
    county_weights: {
      41041: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 41041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97381,
    lat: 44.97014,
    lng: -122.74749,
    city: "Silverton",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16420,
    density: 57.6,
    county_fips: 41047,
    county_name: "Marion",
    county_weights: {
      41047: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 41047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97383,
    lat: 44.80014,
    lng: -122.71836,
    city: "Stayton",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10185,
    density: 82.5,
    county_fips: 41047,
    county_name: "Marion",
    county_weights: {
      41043: 30.12,
      41047: 69.88,
    },
    county_names_all: "Marion|Linn",
    county_fips_all: "41047|41043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97384,
    lat: 44.79109,
    lng: -122.62007,
    city: "Mehama",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67,
    density: 944,
    county_fips: 41047,
    county_name: "Marion",
    county_weights: {
      41047: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 41047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97385,
    lat: 44.86633,
    lng: -122.72924,
    city: "Sublimity",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3355,
    density: 36.5,
    county_fips: 41047,
    county_name: "Marion",
    county_weights: {
      41047: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 41047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97386,
    lat: 44.36062,
    lng: -122.75076,
    city: "Sweet Home",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15584,
    density: 47.8,
    county_fips: 41043,
    county_name: "Linn",
    county_weights: {
      41043: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 41043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97388,
    lat: 44.87418,
    lng: -124.01169,
    city: "Gleneden Beach",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1014,
    density: 61.1,
    county_fips: 41041,
    county_name: "Lincoln",
    county_weights: {
      41041: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 41041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97389,
    lat: 44.53269,
    lng: -123.09028,
    city: "Tangent",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1929,
    density: 20.9,
    county_fips: 41043,
    county_name: "Linn",
    county_weights: {
      41043: 100,
    },
    county_names_all: "Linn",
    county_fips_all: 41043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97390,
    lat: 44.33781,
    lng: -123.85717,
    city: "Tidewater",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 891,
    density: 2.8,
    county_fips: 41041,
    county_name: "Lincoln",
    county_weights: {
      41039: 32.75,
      41041: 67.25,
    },
    county_names_all: "Lincoln|Lane",
    county_fips_all: "41041|41039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97391,
    lat: 44.59593,
    lng: -123.8816,
    city: "Toledo",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6399,
    density: 21.4,
    county_fips: 41041,
    county_name: "Lincoln",
    county_weights: {
      41041: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 41041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97392,
    lat: 44.79096,
    lng: -122.9413,
    city: "Turner",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5695,
    density: 52,
    county_fips: 41047,
    county_name: "Marion",
    county_weights: {
      41047: 100,
    },
    county_names_all: "Marion",
    county_fips_all: 41047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97394,
    lat: 44.40607,
    lng: -124.00258,
    city: "Waldport",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5090,
    density: 38,
    county_fips: 41041,
    county_name: "Lincoln",
    county_weights: {
      41041: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 41041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97396,
    lat: 45.11528,
    lng: -123.5275,
    city: "Willamina",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3753,
    density: 26.5,
    county_fips: 41071,
    county_name: "Yamhill",
    county_weights: {
      41053: 24.5,
      41071: 75.5,
    },
    county_names_all: "Yamhill|Polk",
    county_fips_all: "41071|41053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97401,
    lat: 44.06803,
    lng: -123.08171,
    city: "Eugene",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47985,
    density: 1997.1,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97402,
    lat: 44.05193,
    lng: -123.23022,
    city: "Eugene",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52481,
    density: 295.3,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97403,
    lat: 44.03541,
    lng: -123.05247,
    city: "Eugene",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14024,
    density: 1281.5,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97404,
    lat: 44.10518,
    lng: -123.13315,
    city: "Eugene",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34126,
    density: 1370.1,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97405,
    lat: 43.95528,
    lng: -123.167,
    city: "Eugene",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45184,
    density: 135.1,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97406,
    lat: 42.62638,
    lng: -123.99867,
    city: "Agness",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 355,
    density: 0.8,
    county_fips: 41015,
    county_name: "Curry",
    county_weights: {
      41011: 4.88,
      41015: 95.12,
    },
    county_names_all: "Curry|Coos",
    county_fips_all: "41015|41011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97408,
    lat: 44.14435,
    lng: -123.05452,
    city: "Eugene",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13761,
    density: 106.8,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97410,
    lat: 42.80159,
    lng: -123.11931,
    city: "Azalea",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 566,
    density: 1.4,
    county_fips: 41019,
    county_name: "Douglas",
    county_weights: {
      41019: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 41019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97411,
    lat: 43.07557,
    lng: -124.3624,
    city: "Bandon",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7568,
    density: 22.7,
    county_fips: 41011,
    county_name: "Coos",
    county_weights: {
      41011: 100,
    },
    county_names_all: "Coos",
    county_fips_all: 41011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97412,
    lat: 44.19625,
    lng: -123.56106,
    city: "Blachly",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 681,
    density: 3.1,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97413,
    lat: 44.09633,
    lng: -122.01513,
    city: "Blue River",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 944,
    density: 0.8,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97414,
    lat: 42.96653,
    lng: -124.15026,
    city: "Broadbent",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 154,
    density: 1.3,
    county_fips: 41011,
    county_name: "Coos",
    county_weights: {
      41011: 100,
    },
    county_names_all: "Coos",
    county_fips_all: 41011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97415,
    lat: 42.13977,
    lng: -124.13506,
    city: "Brookings",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13857,
    density: 17.5,
    county_fips: 41015,
    county_name: "Curry",
    county_weights: {
      41015: 100,
    },
    county_names_all: "Curry",
    county_fips_all: 41015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97416,
    lat: 43.03524,
    lng: -123.69123,
    city: "Camas Valley",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1241,
    density: 7.9,
    county_fips: 41019,
    county_name: "Douglas",
    county_weights: {
      41019: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 41019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97417,
    lat: 42.94014,
    lng: -123.21802,
    city: "Canyonville",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2249,
    density: 30.4,
    county_fips: 41019,
    county_name: "Douglas",
    county_weights: {
      41019: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 41019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97419,
    lat: 44.1793,
    lng: -123.40719,
    city: "Cheshire",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 892,
    density: 10.5,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97420,
    lat: 43.34839,
    lng: -124.10825,
    city: "Coos Bay",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27906,
    density: 39.3,
    county_fips: 41011,
    county_name: "Coos",
    county_weights: {
      41011: 100,
    },
    county_names_all: "Coos",
    county_fips_all: 41011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97423,
    lat: 43.19137,
    lng: -124.17177,
    city: "Coquille",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6521,
    density: 19.9,
    county_fips: 41011,
    county_name: "Coos",
    county_weights: {
      41011: 100,
    },
    county_names_all: "Coos",
    county_fips_all: 41011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97424,
    lat: 43.74712,
    lng: -123.05496,
    city: "Cottage Grove",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18361,
    density: 28.8,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41019: 11.49,
      41039: 88.51,
    },
    county_names_all: "Lane|Douglas",
    county_fips_all: "41039|41019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97426,
    lat: 43.90313,
    lng: -123.02781,
    city: "Creswell",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9987,
    density: 51.4,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97429,
    lat: 42.96778,
    lng: -123.05442,
    city: "Days Creek",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 881,
    density: 3.5,
    county_fips: 41019,
    county_name: "Douglas",
    county_weights: {
      41019: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 41019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97430,
    lat: 44.15507,
    lng: -123.71175,
    city: "Deadwood",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 394,
    density: 1.9,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97431,
    lat: 43.87135,
    lng: -122.81576,
    city: "Dexter",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2289,
    density: 21,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97432,
    lat: 43.10445,
    lng: -123.4294,
    city: "Dillard",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 41019,
    county_name: "Douglas",
    county_weights: {
      41019: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 41019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97434,
    lat: 43.66553,
    lng: -122.78211,
    city: "Dorena",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 903,
    density: 3.3,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97435,
    lat: 43.7016,
    lng: -123.33839,
    city: "Drain",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2170,
    density: 8.5,
    county_fips: 41019,
    county_name: "Douglas",
    county_weights: {
      41019: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 41019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97436,
    lat: 43.63958,
    lng: -123.58256,
    city: "Elkton",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 740,
    density: 3,
    county_fips: 41019,
    county_name: "Douglas",
    county_weights: {
      41019: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 41019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97437,
    lat: 44.09734,
    lng: -123.38731,
    city: "Elmira",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2489,
    density: 42.7,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97438,
    lat: 43.96068,
    lng: -122.65546,
    city: "Fall Creek",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1127,
    density: 3.6,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97439,
    lat: 44.06573,
    lng: -124.03705,
    city: "Florence",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15101,
    density: 34.6,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97441,
    lat: 43.77659,
    lng: -124.14414,
    city: "Gardiner",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 466,
    density: 6.5,
    county_fips: 41019,
    county_name: "Douglas",
    county_weights: {
      41019: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 41019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97442,
    lat: 42.76982,
    lng: -123.40365,
    city: "Glendale",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2319,
    density: 10.6,
    county_fips: 41019,
    county_name: "Douglas",
    county_weights: {
      41019: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 41019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97443,
    lat: 43.25014,
    lng: -123.00255,
    city: "Glide",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2939,
    density: 13.2,
    county_fips: 41019,
    county_name: "Douglas",
    county_weights: {
      41019: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 41019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97444,
    lat: 42.44453,
    lng: -124.33223,
    city: "Gold Beach",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5974,
    density: 14.1,
    county_fips: 41015,
    county_name: "Curry",
    county_weights: {
      41015: 100,
    },
    county_names_all: "Curry",
    county_fips_all: 41015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97446,
    lat: 44.26804,
    lng: -123.05548,
    city: "Harrisburg",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5826,
    density: 18.3,
    county_fips: 41043,
    county_name: "Linn",
    county_weights: {
      41039: 0.93,
      41043: 99.07,
    },
    county_names_all: "Linn|Lane",
    county_fips_all: "41043|41039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97447,
    lat: 43.28409,
    lng: -122.49807,
    city: "Idleyld Park",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 485,
    density: 0.7,
    county_fips: 41019,
    county_name: "Douglas",
    county_weights: {
      41019: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 41019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97448,
    lat: 44.2105,
    lng: -123.27882,
    city: "Junction City",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13409,
    density: 37.5,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41003: 5.57,
      41039: 94.43,
    },
    county_names_all: "Lane|Benton",
    county_fips_all: "41039|41003",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97449,
    lat: 43.57571,
    lng: -124.08581,
    city: "Lakeside",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1955,
    density: 16.7,
    county_fips: 41011,
    county_name: "Coos",
    county_weights: {
      41011: 100,
    },
    county_names_all: "Coos",
    county_fips_all: 41011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97450,
    lat: 42.91026,
    lng: -124.37398,
    city: "Langlois",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 508,
    density: 2.5,
    county_fips: 41015,
    county_name: "Curry",
    county_weights: {
      41011: 8.12,
      41015: 91.88,
    },
    county_names_all: "Curry|Coos",
    county_fips_all: "41015|41011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97451,
    lat: 43.83998,
    lng: -123.31383,
    city: "Lorane",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 464,
    density: 2.4,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97452,
    lat: 43.88564,
    lng: -122.72259,
    city: "Lowell",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1518,
    density: 23.1,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97453,
    lat: 43.99422,
    lng: -123.86344,
    city: "Mapleton",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 882,
    density: 3,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97454,
    lat: 44.21806,
    lng: -122.8191,
    city: "Marcola",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1136,
    density: 7.3,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97455,
    lat: 43.96212,
    lng: -122.91493,
    city: "Pleasant Hill",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3184,
    density: 47.9,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97456,
    lat: 44.34036,
    lng: -123.35893,
    city: "Monroe",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3056,
    density: 12.8,
    county_fips: 41003,
    county_name: "Benton",
    county_weights: {
      41003: 96.9,
      41039: 3.1,
    },
    county_names_all: "Benton|Lane",
    county_fips_all: "41003|41039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97457,
    lat: 43.05484,
    lng: -123.2229,
    city: "Myrtle Creek",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10365,
    density: 24.4,
    county_fips: 41019,
    county_name: "Douglas",
    county_weights: {
      41019: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 41019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97458,
    lat: 43.06372,
    lng: -124.01287,
    city: "Myrtle Point",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4488,
    density: 4.8,
    county_fips: 41011,
    county_name: "Coos",
    county_weights: {
      41011: 100,
    },
    county_names_all: "Coos",
    county_fips_all: 41011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97459,
    lat: 43.47444,
    lng: -124.18216,
    city: "North Bend",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14434,
    density: 51,
    county_fips: 41011,
    county_name: "Coos",
    county_weights: {
      41011: 96.52,
      41019: 3.48,
    },
    county_names_all: "Coos|Douglas",
    county_fips_all: "41011|41019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97461,
    lat: 44.09789,
    lng: -123.48993,
    city: "Noti",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 823,
    density: 7.6,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97462,
    lat: 43.49047,
    lng: -123.38828,
    city: "Oakland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4014,
    density: 7.1,
    county_fips: 41019,
    county_name: "Douglas",
    county_weights: {
      41019: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 41019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97463,
    lat: 43.73951,
    lng: -122.40591,
    city: "Oakridge",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3801,
    density: 30.1,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97465,
    lat: 42.7376,
    lng: -124.3795,
    city: "Port Orford",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1838,
    density: 6.2,
    county_fips: 41015,
    county_name: "Curry",
    county_weights: {
      41015: 100,
    },
    county_names_all: "Curry",
    county_fips_all: 41015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97466,
    lat: 42.86459,
    lng: -124.08632,
    city: "Powers",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1197,
    density: 9.5,
    county_fips: 41011,
    county_name: "Coos",
    county_weights: {
      41011: 85.12,
      41015: 14.88,
    },
    county_names_all: "Coos|Curry",
    county_fips_all: "41011|41015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97467,
    lat: 43.73557,
    lng: -123.90442,
    city: "Reedsport",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5017,
    density: 5.9,
    county_fips: 41019,
    county_name: "Douglas",
    county_weights: {
      41019: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 41019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97469,
    lat: 42.91994,
    lng: -123.41459,
    city: "Riddle",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2789,
    density: 18.7,
    county_fips: 41019,
    county_name: "Douglas",
    county_weights: {
      41019: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 41019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97470,
    lat: 43.23288,
    lng: -123.23111,
    city: "Roseburg",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18659,
    density: 39.8,
    county_fips: 41019,
    county_name: "Douglas",
    county_weights: {
      41019: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 41019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97471,
    lat: 43.22215,
    lng: -123.47486,
    city: "Roseburg",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31762,
    density: 67.4,
    county_fips: 41019,
    county_name: "Douglas",
    county_weights: {
      41019: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 41019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97473,
    lat: 43.6773,
    lng: -123.8726,
    city: "Scottsburg",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 293,
    density: 2,
    county_fips: 41019,
    county_name: "Douglas",
    county_weights: {
      41019: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 41019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97476,
    lat: 42.84075,
    lng: -124.43806,
    city: "Sixes",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 357,
    density: 2.6,
    county_fips: 41015,
    county_name: "Curry",
    county_weights: {
      41015: 100,
    },
    county_names_all: "Curry",
    county_fips_all: 41015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97477,
    lat: 44.05861,
    lng: -123.01126,
    city: "Springfield",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38073,
    density: 1183.4,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97478,
    lat: 44.08781,
    lng: -122.84478,
    city: "Springfield",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40357,
    density: 92.5,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97479,
    lat: 43.40194,
    lng: -123.19426,
    city: "Sutherlin",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9876,
    density: 56.5,
    county_fips: 41019,
    county_name: "Douglas",
    county_weights: {
      41019: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 41019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97480,
    lat: 44.1303,
    lng: -123.83213,
    city: "Swisshome",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 291,
    density: 1.7,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97481,
    lat: 43.11376,
    lng: -123.55237,
    city: "Tenmile",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 875,
    density: 45,
    county_fips: 41019,
    county_name: "Douglas",
    county_weights: {
      41019: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 41019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97484,
    lat: 42.93373,
    lng: -122.84585,
    city: "Tiller",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 136,
    density: 0.4,
    county_fips: 41019,
    county_name: "Douglas",
    county_weights: {
      41019: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 41019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97486,
    lat: 43.37778,
    lng: -123.5351,
    city: "Umpqua",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 668,
    density: 3.8,
    county_fips: 41019,
    county_name: "Douglas",
    county_weights: {
      41019: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 41019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97487,
    lat: 43.99441,
    lng: -123.39303,
    city: "Veneta",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9047,
    density: 48,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97488,
    lat: 44.13077,
    lng: -122.41198,
    city: "Vida",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1165,
    density: 3,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97489,
    lat: 44.10986,
    lng: -122.61962,
    city: "Walterville",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 873,
    density: 11.3,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97490,
    lat: 44.00795,
    lng: -123.60522,
    city: "Walton",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 439,
    density: 1.8,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97492,
    lat: 43.77168,
    lng: -122.49868,
    city: "Westfir",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1071,
    density: 8.9,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 100,
    },
    county_names_all: "Lane",
    county_fips_all: 41039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97493,
    lat: 43.90256,
    lng: -124.01602,
    city: "Westlake",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 300,
    density: 2.2,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41019: 8.26,
      41039: 91.74,
    },
    county_names_all: "Lane|Douglas",
    county_fips_all: "41039|41019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97494,
    lat: 43.33059,
    lng: -123.32779,
    city: "Wilbur",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51,
    density: 21.5,
    county_fips: 41019,
    county_name: "Douglas",
    county_weights: {
      41019: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 41019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97495,
    lat: 43.28765,
    lng: -123.30463,
    city: "Winchester",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1568,
    density: 82.6,
    county_fips: 41019,
    county_name: "Douglas",
    county_weights: {
      41019: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 41019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97496,
    lat: 43.05261,
    lng: -123.49992,
    city: "Winston",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7663,
    density: 33.6,
    county_fips: 41019,
    county_name: "Douglas",
    county_weights: {
      41019: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 41019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97497,
    lat: 42.66015,
    lng: -123.40929,
    city: "Wolf Creek",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1502,
    density: 3.5,
    county_fips: 41033,
    county_name: "Josephine",
    county_weights: {
      41029: 5.94,
      41033: 94.06,
    },
    county_names_all: "Josephine|Jackson",
    county_fips_all: "41033|41029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97498,
    lat: 44.27728,
    lng: -124.01901,
    city: "Yachats",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1830,
    density: 6.5,
    county_fips: 41039,
    county_name: "Lane",
    county_weights: {
      41039: 50.63,
      41041: 49.37,
    },
    county_names_all: "Lane|Lincoln",
    county_fips_all: "41039|41041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97499,
    lat: 43.59495,
    lng: -123.23356,
    city: "Yoncalla",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1869,
    density: 5.8,
    county_fips: 41019,
    county_name: "Douglas",
    county_weights: {
      41019: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 41019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97501,
    lat: 42.2856,
    lng: -122.89459,
    city: "Medford",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 47160,
    density: 401.6,
    county_fips: 41029,
    county_name: "Jackson",
    county_weights: {
      41029: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 41029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97502,
    lat: 42.40927,
    lng: -122.94718,
    city: "Central Point",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28769,
    density: 135.4,
    county_fips: 41029,
    county_name: "Jackson",
    county_weights: {
      41029: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 41029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97503,
    lat: 42.5836,
    lng: -122.92721,
    city: "White City",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13008,
    density: 61.5,
    county_fips: 41029,
    county_name: "Jackson",
    county_weights: {
      41029: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 41029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97504,
    lat: 42.32757,
    lng: -122.80068,
    city: "Medford",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48053,
    density: 428.4,
    county_fips: 41029,
    county_name: "Jackson",
    county_weights: {
      41029: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 41029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97520,
    lat: 42.15472,
    lng: -122.53168,
    city: "Ashland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25345,
    density: 29.8,
    county_fips: 41029,
    county_name: "Jackson",
    county_weights: {
      41029: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 41029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97522,
    lat: 42.56594,
    lng: -122.46886,
    city: "Butte Falls",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 650,
    density: 5.4,
    county_fips: 41029,
    county_name: "Jackson",
    county_weights: {
      41029: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 41029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97523,
    lat: 42.11349,
    lng: -123.62961,
    city: "Cave Junction",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5885,
    density: 9.1,
    county_fips: 41033,
    county_name: "Josephine",
    county_weights: {
      41033: 100,
    },
    county_names_all: "Josephine",
    county_fips_all: 41033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97524,
    lat: 42.46271,
    lng: -122.66327,
    city: "Eagle Point",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15174,
    density: 16.3,
    county_fips: 41029,
    county_name: "Jackson",
    county_weights: {
      41029: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 41029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97525,
    lat: 42.43557,
    lng: -123.07606,
    city: "Gold Hill",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4293,
    density: 15.3,
    county_fips: 41029,
    county_name: "Jackson",
    county_weights: {
      41029: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 41029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97526,
    lat: 42.51275,
    lng: -123.33964,
    city: "Grants Pass",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35302,
    density: 96.9,
    county_fips: 41033,
    county_name: "Josephine",
    county_weights: {
      41029: 0.85,
      41033: 99.15,
    },
    county_names_all: "Josephine|Jackson",
    county_fips_all: "41033|41029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97527,
    lat: 42.37615,
    lng: -123.38288,
    city: "Grants Pass",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37120,
    density: 65.2,
    county_fips: 41033,
    county_name: "Josephine",
    county_weights: {
      41029: 13.15,
      41033: 86.85,
    },
    county_names_all: "Josephine|Jackson",
    county_fips_all: "41033|41029",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97530,
    lat: 42.13778,
    lng: -123.10507,
    city: "Jacksonville",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7806,
    density: 6.5,
    county_fips: 41029,
    county_name: "Jackson",
    county_weights: {
      41029: 80.45,
      41033: 19.55,
    },
    county_names_all: "Jackson|Josephine",
    county_fips_all: "41029|41033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97531,
    lat: 42.20739,
    lng: -123.64391,
    city: "Kerby",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 307,
    density: 31.9,
    county_fips: 41033,
    county_name: "Josephine",
    county_weights: {
      41033: 100,
    },
    county_names_all: "Josephine",
    county_fips_all: 41033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97532,
    lat: 42.56142,
    lng: -123.58586,
    city: "Merlin",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2621,
    density: 12,
    county_fips: 41033,
    county_name: "Josephine",
    county_weights: {
      41033: 100,
    },
    county_names_all: "Josephine",
    county_fips_all: 41033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97534,
    lat: 42.03616,
    lng: -123.71641,
    city: "O'Brien",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 719,
    density: 10.8,
    county_fips: 41033,
    county_name: "Josephine",
    county_weights: {
      41033: 100,
    },
    county_names_all: "Josephine",
    county_fips_all: 41033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97535,
    lat: 42.26799,
    lng: -122.81238,
    city: "Phoenix",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5454,
    density: 641.4,
    county_fips: 41029,
    county_name: "Jackson",
    county_weights: {
      41029: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 41029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97536,
    lat: 42.78455,
    lng: -122.50802,
    city: "Prospect",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1151,
    density: 6.3,
    county_fips: 41029,
    county_name: "Jackson",
    county_weights: {
      41029: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 41029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97537,
    lat: 42.55041,
    lng: -123.13357,
    city: "Rogue River",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7104,
    density: 22.1,
    county_fips: 41029,
    county_name: "Jackson",
    county_weights: {
      41029: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 41029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97538,
    lat: 42.29623,
    lng: -123.65723,
    city: "Selma",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1809,
    density: 3.7,
    county_fips: 41033,
    county_name: "Josephine",
    county_weights: {
      41033: 100,
    },
    county_names_all: "Josephine",
    county_fips_all: 41033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97539,
    lat: 42.59999,
    lng: -122.79024,
    city: "Shady Cove",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3296,
    density: 58.3,
    county_fips: 41029,
    county_name: "Jackson",
    county_weights: {
      41029: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 41029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97540,
    lat: 42.18615,
    lng: -122.80027,
    city: "Talent",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8554,
    density: 73.5,
    county_fips: 41029,
    county_name: "Jackson",
    county_weights: {
      41029: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 41029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97541,
    lat: 42.72983,
    lng: -122.75359,
    city: "Trail",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1720,
    density: 3.2,
    county_fips: 41029,
    county_name: "Jackson",
    county_weights: {
      41029: 100,
    },
    county_names_all: "Jackson",
    county_fips_all: 41029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97543,
    lat: 42.37724,
    lng: -123.56031,
    city: "Wilderville",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 482,
    density: 3.9,
    county_fips: 41033,
    county_name: "Josephine",
    county_weights: {
      41033: 100,
    },
    county_names_all: "Josephine",
    county_fips_all: 41033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97544,
    lat: 42.207,
    lng: -123.30006,
    city: "Williams",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2594,
    density: 13.1,
    county_fips: 41033,
    county_name: "Josephine",
    county_weights: {
      41033: 100,
    },
    county_names_all: "Josephine",
    county_fips_all: 41033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97601,
    lat: 42.44404,
    lng: -122.06741,
    city: "Klamath Falls",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23020,
    density: 15.4,
    county_fips: 41035,
    county_name: "Klamath",
    county_weights: {
      41035: 100,
    },
    county_names_all: "Klamath",
    county_fips_all: 41035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97603,
    lat: 42.13704,
    lng: -121.67766,
    city: "Klamath Falls",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29797,
    density: 33.8,
    county_fips: 41035,
    county_name: "Klamath",
    county_weights: {
      41035: 100,
    },
    county_names_all: "Klamath",
    county_fips_all: 41035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97604,
    lat: 42.97778,
    lng: -122.20674,
    city: "Crater Lake",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 137,
    density: 0.6,
    county_fips: 41035,
    county_name: "Klamath",
    county_weights: {
      41035: 100,
    },
    county_names_all: "Klamath",
    county_fips_all: 41035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97620,
    lat: 42.223,
    lng: -119.89677,
    city: "Adel",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 106,
    density: 0.1,
    county_fips: 41037,
    county_name: "Lake",
    county_weights: {
      41037: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 41037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97621,
    lat: 42.51504,
    lng: -121.2881,
    city: "Beatty",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 260,
    density: 0.6,
    county_fips: 41035,
    county_name: "Klamath",
    county_weights: {
      41035: 100,
    },
    county_names_all: "Klamath",
    county_fips_all: 41035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97622,
    lat: 42.39667,
    lng: -121.01032,
    city: "Bly",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 335,
    density: 0.7,
    county_fips: 41035,
    county_name: "Klamath",
    county_weights: {
      41035: 100,
    },
    county_names_all: "Klamath",
    county_fips_all: 41035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97623,
    lat: 42.19905,
    lng: -121.31016,
    city: "Bonanza",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2672,
    density: 2.9,
    county_fips: 41035,
    county_name: "Klamath",
    county_weights: {
      41035: 100,
    },
    county_names_all: "Klamath",
    county_fips_all: 41035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97624,
    lat: 42.72121,
    lng: -121.69415,
    city: "Chiloquin",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3519,
    density: 2.2,
    county_fips: 41035,
    county_name: "Klamath",
    county_weights: {
      41035: 100,
    },
    county_names_all: "Klamath",
    county_fips_all: 41035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97625,
    lat: 42.31507,
    lng: -121.58402,
    city: "Dairy",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 360,
    density: 2.8,
    county_fips: 41035,
    county_name: "Klamath",
    county_weights: {
      41035: 100,
    },
    county_names_all: "Klamath",
    county_fips_all: 41035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97626,
    lat: 42.72488,
    lng: -122.02011,
    city: "Fort Klamath",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58,
    density: 0.2,
    county_fips: 41035,
    county_name: "Klamath",
    county_weights: {
      41035: 100,
    },
    county_names_all: "Klamath",
    county_fips_all: 41035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97627,
    lat: 42.08036,
    lng: -122.05796,
    city: "Keno",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 558,
    density: 6.7,
    county_fips: 41035,
    county_name: "Klamath",
    county_weights: {
      41035: 100,
    },
    county_names_all: "Klamath",
    county_fips_all: 41035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97630,
    lat: 42.29832,
    lng: -120.39166,
    city: "Lakeview",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4797,
    density: 1.8,
    county_fips: 41037,
    county_name: "Lake",
    county_weights: {
      41037: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 41037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97632,
    lat: 42.04175,
    lng: -121.40597,
    city: "Malin",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1731,
    density: 10.5,
    county_fips: 41035,
    county_name: "Klamath",
    county_weights: {
      41035: 100,
    },
    county_names_all: "Klamath",
    county_fips_all: 41035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97633,
    lat: 42.03014,
    lng: -121.56328,
    city: "Merrill",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1263,
    density: 17.1,
    county_fips: 41035,
    county_name: "Klamath",
    county_weights: {
      41035: 100,
    },
    county_names_all: "Klamath",
    county_fips_all: 41035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97634,
    lat: 42.12747,
    lng: -121.80348,
    city: "Midland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 284,
    density: 33.6,
    county_fips: 41035,
    county_name: "Klamath",
    county_weights: {
      41035: 100,
    },
    county_names_all: "Klamath",
    county_fips_all: 41035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97635,
    lat: 41.93173,
    lng: -120.29974,
    city: "New Pine Creek",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 164,
    density: 1.2,
    county_fips: "06049",
    county_name: "Modoc",
    county_weights: {
      41037: 7.21,
      "06049": 92.79,
    },
    county_names_all: "Modoc|Lake",
    county_fips_all: "06049|41037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97636,
    lat: 42.68775,
    lng: -120.56746,
    city: "Paisley",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 508,
    density: 0.7,
    county_fips: 41037,
    county_name: "Lake",
    county_weights: {
      41037: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 41037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97637,
    lat: 42.46142,
    lng: -119.92486,
    city: "Plush",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 126,
    density: 0.4,
    county_fips: 41037,
    county_name: "Lake",
    county_weights: {
      41037: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 41037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97638,
    lat: 43.1458,
    lng: -121.01156,
    city: "Silver Lake",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 575,
    density: 0.6,
    county_fips: 41037,
    county_name: "Lake",
    county_weights: {
      41037: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 41037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97639,
    lat: 42.43435,
    lng: -121.49845,
    city: "Sprague River",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 479,
    density: 3.2,
    county_fips: 41035,
    county_name: "Klamath",
    county_weights: {
      41035: 100,
    },
    county_names_all: "Klamath",
    county_fips_all: 41035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97640,
    lat: 42.90742,
    lng: -120.65381,
    city: "Summer Lake",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 179,
    density: 0.2,
    county_fips: 41037,
    county_name: "Lake",
    county_weights: {
      41037: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 41037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97641,
    lat: 43.28742,
    lng: -120.53809,
    city: "Christmas Valley",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1440,
    density: 0.8,
    county_fips: 41037,
    county_name: "Lake",
    county_weights: {
      41037: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 41037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97701,
    lat: 44.00065,
    lng: -121.03289,
    city: "Bend",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74255,
    density: 92,
    county_fips: 41017,
    county_name: "Deschutes",
    county_weights: {
      41013: 7.56,
      41017: 92.44,
    },
    county_names_all: "Deschutes|Crook",
    county_fips_all: "41017|41013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97702,
    lat: 43.98336,
    lng: -121.21083,
    city: "Bend",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50395,
    density: 188,
    county_fips: 41017,
    county_name: "Deschutes",
    county_weights: {
      41017: 100,
    },
    county_names_all: "Deschutes",
    county_fips_all: 41017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97703,
    lat: 44.07281,
    lng: -121.51971,
    city: "Bend",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 41017,
    county_name: "Deschutes",
    county_weights: {
      41017: 100,
    },
    county_names_all: "Deschutes",
    county_fips_all: 41017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97707,
    lat: 43.83031,
    lng: -121.49365,
    city: "Bend",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5970,
    density: 36.8,
    county_fips: 41017,
    county_name: "Deschutes",
    county_weights: {
      41017: 100,
    },
    county_names_all: "Deschutes",
    county_fips_all: 41017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97709,
    lat: 43.89338,
    lng: -121.85627,
    city: "Bend",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 41017,
    county_name: "Deschutes",
    county_weights: {
      41017: 100,
    },
    county_names_all: "Deschutes",
    county_fips_all: 41017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97710,
    lat: 42.15095,
    lng: -118.53902,
    city: "Fields",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 102,
    density: 0,
    county_fips: 41025,
    county_name: "Harney",
    county_weights: {
      41025: 100,
    },
    county_names_all: "Harney",
    county_fips_all: 41025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97711,
    lat: 44.7239,
    lng: -120.63489,
    city: "Ashwood",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28,
    density: 0,
    county_fips: 41031,
    county_name: "Jefferson",
    county_weights: {
      41031: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 41031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97712,
    lat: 43.77825,
    lng: -120.42866,
    city: "Brothers",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 65,
    density: 0.2,
    county_fips: 41017,
    county_name: "Deschutes",
    county_weights: {
      41017: 100,
    },
    county_names_all: "Deschutes",
    county_fips_all: 41017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97720,
    lat: 43.58799,
    lng: -118.85806,
    city: "Burns",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4383,
    density: 1.4,
    county_fips: 41025,
    county_name: "Harney",
    county_weights: {
      41025: 100,
    },
    county_names_all: "Harney",
    county_fips_all: 41025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97721,
    lat: 42.88772,
    lng: -118.52635,
    city: "Princeton",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 199,
    density: 0,
    county_fips: 41025,
    county_name: "Harney",
    county_weights: {
      41025: 100,
    },
    county_names_all: "Harney",
    county_fips_all: 41025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97722,
    lat: 42.95733,
    lng: -118.69241,
    city: "Diamond",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54,
    density: 0,
    county_fips: 41025,
    county_name: "Harney",
    county_weights: {
      41025: 100,
    },
    county_names_all: "Harney",
    county_fips_all: 41025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97730,
    lat: 44.52265,
    lng: -121.64535,
    city: "Camp Sherman",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 327,
    density: 4.9,
    county_fips: 41031,
    county_name: "Jefferson",
    county_weights: {
      41031: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 41031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97731,
    lat: 43.1315,
    lng: -121.92089,
    city: "Chemult",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 458,
    density: 2.6,
    county_fips: 41035,
    county_name: "Klamath",
    county_weights: {
      41019: 33.87,
      41035: 66.13,
    },
    county_names_all: "Klamath|Douglas",
    county_fips_all: "41035|41019",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97732,
    lat: 43.41369,
    lng: -118.40265,
    city: "Crane",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 113,
    density: 0.3,
    county_fips: 41025,
    county_name: "Harney",
    county_weights: {
      41025: 100,
    },
    county_names_all: "Harney",
    county_fips_all: 41025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97733,
    lat: 43.38441,
    lng: -121.94778,
    city: "Crescent",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 462,
    density: 0.5,
    county_fips: 41035,
    county_name: "Klamath",
    county_weights: {
      41035: 100,
    },
    county_names_all: "Klamath",
    county_fips_all: 41035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97734,
    lat: 44.53502,
    lng: -121.33395,
    city: "Culver",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3606,
    density: 8,
    county_fips: 41031,
    county_name: "Jefferson",
    county_weights: {
      41031: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 41031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97735,
    lat: 43.39014,
    lng: -120.99224,
    city: "Fort Rock",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48,
    density: 0.1,
    county_fips: 41037,
    county_name: "Lake",
    county_weights: {
      41037: 100,
    },
    county_names_all: "Lake",
    county_fips_all: 41037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97736,
    lat: 42.66655,
    lng: -118.92058,
    city: "Frenchglen",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 88,
    density: 0,
    county_fips: 41025,
    county_name: "Harney",
    county_weights: {
      41025: 100,
    },
    county_names_all: "Harney",
    county_fips_all: 41025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97737,
    lat: 43.50897,
    lng: -121.71917,
    city: "Gilchrist",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 467,
    density: 7.9,
    county_fips: 41035,
    county_name: "Klamath",
    county_weights: {
      41035: 100,
    },
    county_names_all: "Klamath",
    county_fips_all: 41035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97738,
    lat: 43.51218,
    lng: -119.25078,
    city: "Hines",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2045,
    density: 3.1,
    county_fips: 41025,
    county_name: "Harney",
    county_weights: {
      41025: 100,
    },
    county_names_all: "Harney",
    county_fips_all: 41025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97739,
    lat: 43.67259,
    lng: -121.48693,
    city: "La Pine",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13158,
    density: 16.7,
    county_fips: 41017,
    county_name: "Deschutes",
    county_weights: {
      41017: 73.96,
      41035: 26.04,
    },
    county_names_all: "Deschutes|Klamath",
    county_fips_all: "41017|41035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97741,
    lat: 44.65771,
    lng: -121.04291,
    city: "Madras",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12791,
    density: 13.6,
    county_fips: 41031,
    county_name: "Jefferson",
    county_weights: {
      41031: 96.09,
      41065: 3.91,
    },
    county_names_all: "Jefferson|Wasco",
    county_fips_all: "41031|41065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97750,
    lat: 44.67037,
    lng: -120.12704,
    city: "Mitchell",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 340,
    density: 0.2,
    county_fips: 41069,
    county_name: "Wheeler",
    county_weights: {
      41069: 100,
    },
    county_names_all: "Wheeler",
    county_fips_all: 41069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97751,
    lat: 44.14856,
    lng: -119.81945,
    city: "Paulina",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62,
    density: 0.1,
    county_fips: 41013,
    county_name: "Crook",
    county_weights: {
      41013: 100,
    },
    county_names_all: "Crook",
    county_fips_all: 41013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97752,
    lat: 44.14094,
    lng: -120.20584,
    city: "Post",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 41013,
    county_name: "Crook",
    county_weights: {
      41013: 100,
    },
    county_names_all: "Crook",
    county_fips_all: 41013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97753,
    lat: 44.22625,
    lng: -120.99996,
    city: "Powell Butte",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2594,
    density: 9.2,
    county_fips: 41013,
    county_name: "Crook",
    county_weights: {
      41013: 100,
    },
    county_names_all: "Crook",
    county_fips_all: 41013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97754,
    lat: 44.13577,
    lng: -120.52848,
    city: "Prineville",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20985,
    density: 5.9,
    county_fips: 41013,
    county_name: "Crook",
    county_weights: {
      41013: 97.08,
      41025: 0.83,
      41031: 2.09,
    },
    county_names_all: "Crook|Jefferson|Harney",
    county_fips_all: "41013|41031|41025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97756,
    lat: 44.28079,
    lng: -121.19335,
    city: "Redmond",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39342,
    density: 120.2,
    county_fips: 41017,
    county_name: "Deschutes",
    county_weights: {
      41013: 16.1,
      41017: 83.9,
    },
    county_names_all: "Deschutes|Crook",
    county_fips_all: "41017|41013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97758,
    lat: 43.41449,
    lng: -119.74859,
    city: "Riley",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 76,
    density: 0,
    county_fips: 41025,
    county_name: "Harney",
    county_weights: {
      41025: 75.54,
      41037: 24.46,
    },
    county_names_all: "Harney|Lake",
    county_fips_all: "41025|41037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97759,
    lat: 44.44428,
    lng: -121.76823,
    city: "Sisters",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7530,
    density: 5.3,
    county_fips: 41043,
    county_name: "Linn",
    county_weights: {
      41017: 26.69,
      41031: 30.99,
      41043: 42.32,
    },
    county_names_all: "Linn|Jefferson|Deschutes",
    county_fips_all: "41043|41031|41017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97760,
    lat: 44.38662,
    lng: -121.23323,
    city: "Terrebonne",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7364,
    density: 31.2,
    county_fips: 41017,
    county_name: "Deschutes",
    county_weights: {
      41013: 16.82,
      41017: 46.08,
      41031: 37.1,
    },
    county_names_all: "Deschutes|Jefferson|Crook",
    county_fips_all: "41017|41031|41013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97761,
    lat: 44.8433,
    lng: -121.29807,
    city: "Warm Springs",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3631,
    density: 3.8,
    county_fips: 41065,
    county_name: "Wasco",
    county_weights: {
      41031: 38.6,
      41065: 61.4,
    },
    county_names_all: "Wasco|Jefferson",
    county_fips_all: "41065|41031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97801,
    lat: 45.67317,
    lng: -118.83362,
    city: "Pendleton",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20859,
    density: 16.2,
    county_fips: 41059,
    county_name: "Umatilla",
    county_weights: {
      41059: 100,
    },
    county_names_all: "Umatilla",
    county_fips_all: 41059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97810,
    lat: 45.6725,
    lng: -118.39642,
    city: "Adams",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1197,
    density: 1.8,
    county_fips: 41059,
    county_name: "Umatilla",
    county_weights: {
      41059: 100,
    },
    county_names_all: "Umatilla",
    county_fips_all: 41059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97812,
    lat: 45.58138,
    lng: -120.21907,
    city: "Arlington",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 832,
    density: 0.7,
    county_fips: 41021,
    county_name: "Gilliam",
    county_weights: {
      41021: 100,
    },
    county_names_all: "Gilliam",
    county_fips_all: 41021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97813,
    lat: 45.85305,
    lng: -118.52802,
    city: "Athena",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1435,
    density: 10.3,
    county_fips: 41059,
    county_name: "Umatilla",
    county_weights: {
      41059: 100,
    },
    county_names_all: "Umatilla",
    county_fips_all: 41059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97814,
    lat: 44.80075,
    lng: -117.77034,
    city: "Baker City",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12269,
    density: 5.7,
    county_fips: 41001,
    county_name: "Baker",
    county_weights: {
      41001: 94.87,
      41061: 5.13,
    },
    county_names_all: "Baker|Union",
    county_fips_all: "41001|41061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97817,
    lat: 44.6555,
    lng: -118.60816,
    city: "Bates",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55,
    density: 0.1,
    county_fips: 41023,
    county_name: "Grant",
    county_weights: {
      41023: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 41023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97818,
    lat: 45.7567,
    lng: -119.78444,
    city: "Boardman",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4352,
    density: 7.9,
    county_fips: 41049,
    county_name: "Morrow",
    county_weights: {
      41049: 100,
    },
    county_names_all: "Morrow",
    county_fips_all: 41049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97819,
    lat: 44.48603,
    lng: -117.76317,
    city: "Bridgeport",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19,
    density: 0.1,
    county_fips: 41001,
    county_name: "Baker",
    county_weights: {
      41001: 100,
    },
    county_names_all: "Baker",
    county_fips_all: 41001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97820,
    lat: 44.16327,
    lng: -119.21436,
    city: "Canyon City",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 985,
    density: 1,
    county_fips: 41023,
    county_name: "Grant",
    county_weights: {
      41023: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 41023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97823,
    lat: 45.24334,
    lng: -120.19097,
    city: "Condon",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1014,
    density: 0.6,
    county_fips: 41021,
    county_name: "Gilliam",
    county_weights: {
      41021: 98.22,
      41069: 1.78,
    },
    county_names_all: "Gilliam|Wheeler",
    county_fips_all: "41021|41069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97824,
    lat: 45.34992,
    lng: -117.75506,
    city: "Cove",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1853,
    density: 3,
    county_fips: 41061,
    county_name: "Union",
    county_weights: {
      41061: 100,
    },
    county_names_all: "Union",
    county_fips_all: 41061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97825,
    lat: 44.38804,
    lng: -119.51852,
    city: "Dayville",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 336,
    density: 0.5,
    county_fips: 41023,
    county_name: "Grant",
    county_weights: {
      41023: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 41023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97826,
    lat: 45.65508,
    lng: -119.22586,
    city: "Echo",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1274,
    density: 1.5,
    county_fips: 41059,
    county_name: "Umatilla",
    county_weights: {
      41049: 13.75,
      41059: 86.25,
    },
    county_names_all: "Umatilla|Morrow",
    county_fips_all: "41059|41049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97827,
    lat: 45.60854,
    lng: -117.85886,
    city: "Elgin",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2485,
    density: 4.6,
    county_fips: 41061,
    county_name: "Union",
    county_weights: {
      41061: 100,
    },
    county_names_all: "Union",
    county_fips_all: 41061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97828,
    lat: 45.71382,
    lng: -117.25971,
    city: "Enterprise",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3135,
    density: 1.8,
    county_fips: 41063,
    county_name: "Wallowa",
    county_weights: {
      41063: 100,
    },
    county_names_all: "Wallowa",
    county_fips_all: 41063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97830,
    lat: 44.9779,
    lng: -120.17165,
    city: "Fossil",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 660,
    density: 0.6,
    county_fips: 41069,
    county_name: "Wheeler",
    county_weights: {
      41021: 13.29,
      41069: 86.71,
    },
    county_names_all: "Wheeler|Gilliam",
    county_fips_all: "41069|41021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97833,
    lat: 44.93471,
    lng: -118.05951,
    city: "Haines",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 673,
    density: 2.1,
    county_fips: 41001,
    county_name: "Baker",
    county_weights: {
      41001: 100,
    },
    county_names_all: "Baker",
    county_fips_all: 41001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97834,
    lat: 44.97251,
    lng: -117.20509,
    city: "Halfway",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1116,
    density: 1.5,
    county_fips: 41001,
    county_name: "Baker",
    county_weights: {
      41001: 100,
    },
    county_names_all: "Baker",
    county_fips_all: 41001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97835,
    lat: 45.8992,
    lng: -118.772,
    city: "Helix",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 421,
    density: 1,
    county_fips: 41059,
    county_name: "Umatilla",
    county_weights: {
      41059: 100,
    },
    county_names_all: "Umatilla",
    county_fips_all: 41059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97836,
    lat: 45.29166,
    lng: -119.50144,
    city: "Heppner",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2148,
    density: 0.9,
    county_fips: 41049,
    county_name: "Morrow",
    county_weights: {
      41049: 100,
    },
    county_names_all: "Morrow",
    county_fips_all: 41049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97837,
    lat: 44.51127,
    lng: -118.0483,
    city: "Hereford",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 83,
    density: 0.2,
    county_fips: 41001,
    county_name: "Baker",
    county_weights: {
      41001: 100,
    },
    county_names_all: "Baker",
    county_fips_all: 41001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97838,
    lat: 45.85266,
    lng: -119.28878,
    city: "Hermiston",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26071,
    density: 49.7,
    county_fips: 41059,
    county_name: "Umatilla",
    county_weights: {
      41049: 24.48,
      41059: 75.52,
    },
    county_names_all: "Umatilla|Morrow",
    county_fips_all: "41059|41049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97839,
    lat: 45.58272,
    lng: -119.60005,
    city: "Lexington",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 291,
    density: 0.6,
    county_fips: 41049,
    county_name: "Morrow",
    county_weights: {
      41049: 100,
    },
    county_names_all: "Morrow",
    county_fips_all: 41049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97840,
    lat: 44.90218,
    lng: -116.93608,
    city: "Oxbow",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 168,
    density: 0.5,
    county_fips: 41001,
    county_name: "Baker",
    county_weights: {
      41001: 100,
    },
    county_names_all: "Baker",
    county_fips_all: 41001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 97841,
    lat: 45.46823,
    lng: -117.94035,
    city: "Imbler",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 540,
    density: 13.4,
    county_fips: 41061,
    county_name: "Union",
    county_weights: {
      41061: 100,
    },
    county_names_all: "Union",
    county_fips_all: 41061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97842,
    lat: 45.57223,
    lng: -116.82384,
    city: "Imnaha",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 91,
    density: 0,
    county_fips: 41063,
    county_name: "Wallowa",
    county_weights: {
      41063: 100,
    },
    county_names_all: "Wallowa",
    county_fips_all: 41063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97843,
    lat: 45.50479,
    lng: -119.88066,
    city: "Ione",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 747,
    density: 0.8,
    county_fips: 41049,
    county_name: "Morrow",
    county_weights: {
      41021: 5.29,
      41049: 94.71,
    },
    county_names_all: "Morrow|Gilliam",
    county_fips_all: "41049|41021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97844,
    lat: 45.87867,
    lng: -119.54676,
    city: "Irrigon",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3803,
    density: 44.5,
    county_fips: 41049,
    county_name: "Morrow",
    county_weights: {
      41049: 100,
    },
    county_names_all: "Morrow",
    county_fips_all: 41049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97845,
    lat: 44.41445,
    lng: -118.90372,
    city: "John Day",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2152,
    density: 7.3,
    county_fips: 41023,
    county_name: "Grant",
    county_weights: {
      41023: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 41023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97846,
    lat: 45.27465,
    lng: -117.10956,
    city: "Joseph",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1954,
    density: 1.7,
    county_fips: 41063,
    county_name: "Wallowa",
    county_weights: {
      41063: 100,
    },
    county_names_all: "Wallowa",
    county_fips_all: 41063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97848,
    lat: 44.69761,
    lng: -119.57336,
    city: "Kimberly",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 236,
    density: 0.4,
    county_fips: 41023,
    county_name: "Grant",
    county_weights: {
      41023: 99.17,
      41069: 0.83,
    },
    county_names_all: "Grant|Wheeler",
    county_fips_all: "41023|41069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97850,
    lat: 45.30689,
    lng: -118.13265,
    city: "La Grande",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17388,
    density: 21,
    county_fips: 41061,
    county_name: "Union",
    county_weights: {
      41061: 100,
    },
    county_names_all: "Union",
    county_fips_all: 41061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97856,
    lat: 44.78426,
    lng: -119.12976,
    city: "Long Creek",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 357,
    density: 0.3,
    county_fips: 41023,
    county_name: "Grant",
    county_weights: {
      41023: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 41023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97857,
    lat: 45.37273,
    lng: -117.50418,
    city: "Lostine",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 641,
    density: 1,
    county_fips: 41063,
    county_name: "Wallowa",
    county_weights: {
      41063: 100,
    },
    county_names_all: "Wallowa",
    county_fips_all: 41063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97859,
    lat: 45.5258,
    lng: -118.43209,
    city: "Meacham",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 230,
    density: 0.8,
    county_fips: 41059,
    county_name: "Umatilla",
    county_weights: {
      41059: 100,
    },
    county_names_all: "Umatilla",
    county_fips_all: 41059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97862,
    lat: 45.92712,
    lng: -118.31797,
    city: "Milton Freewater",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12014,
    density: 15.8,
    county_fips: 41059,
    county_name: "Umatilla",
    county_weights: {
      41059: 100,
    },
    county_names_all: "Umatilla",
    county_fips_all: 41059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97864,
    lat: 44.83842,
    lng: -119.45471,
    city: "Monument",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 260,
    density: 0.4,
    county_fips: 41023,
    county_name: "Grant",
    county_weights: {
      41023: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 41023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97865,
    lat: 44.42949,
    lng: -119.19192,
    city: "Mount Vernon",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1511,
    density: 1.6,
    county_fips: 41023,
    county_name: "Grant",
    county_weights: {
      41023: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 41023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97867,
    lat: 45.0627,
    lng: -117.997,
    city: "North Powder",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 975,
    density: 2.5,
    county_fips: 41061,
    county_name: "Union",
    county_weights: {
      41001: 25.74,
      41061: 74.26,
    },
    county_names_all: "Union|Baker",
    county_fips_all: "41061|41001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97868,
    lat: 45.40815,
    lng: -118.86964,
    city: "Pilot Rock",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1718,
    density: 1.6,
    county_fips: 41059,
    county_name: "Umatilla",
    county_weights: {
      41059: 100,
    },
    county_names_all: "Umatilla",
    county_fips_all: 41059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97869,
    lat: 44.37993,
    lng: -118.61425,
    city: "Prairie City",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 944,
    density: 1.3,
    county_fips: 41023,
    county_name: "Grant",
    county_weights: {
      41001: 7.85,
      41023: 92.15,
    },
    county_names_all: "Grant|Baker",
    county_fips_all: "41023|41001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97870,
    lat: 44.79434,
    lng: -117.19033,
    city: "Richland",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 644,
    density: 2.6,
    county_fips: 41001,
    county_name: "Baker",
    county_weights: {
      41001: 100,
    },
    county_names_all: "Baker",
    county_fips_all: 41001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97873,
    lat: 44.12837,
    lng: -118.99505,
    city: "Seneca",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 274,
    density: 1,
    county_fips: 41023,
    county_name: "Grant",
    county_weights: {
      41023: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 41023,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97874,
    lat: 44.75783,
    lng: -119.84828,
    city: "Spray",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 431,
    density: 0.6,
    county_fips: 41069,
    county_name: "Wheeler",
    county_weights: {
      41069: 100,
    },
    county_names_all: "Wheeler",
    county_fips_all: 41069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97875,
    lat: 45.81481,
    lng: -119.14898,
    city: "Stanfield",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2885,
    density: 19.1,
    county_fips: 41059,
    county_name: "Umatilla",
    county_weights: {
      41059: 100,
    },
    county_names_all: "Umatilla",
    county_fips_all: 41059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97876,
    lat: 45.52237,
    lng: -118.02811,
    city: "Summerville",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1034,
    density: 6.9,
    county_fips: 41061,
    county_name: "Union",
    county_weights: {
      41061: 100,
    },
    county_names_all: "Union",
    county_fips_all: 41061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97877,
    lat: 44.80662,
    lng: -118.38766,
    city: "Sumpter",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 334,
    density: 0.6,
    county_fips: 41023,
    county_name: "Grant",
    county_weights: {
      41001: 34.15,
      41023: 65.85,
    },
    county_names_all: "Grant|Baker",
    county_fips_all: "41023|41001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97880,
    lat: 45.08631,
    lng: -118.89269,
    city: "Ukiah",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 367,
    density: 0.5,
    county_fips: 41059,
    county_name: "Umatilla",
    county_weights: {
      41023: 15.29,
      41059: 84.71,
    },
    county_names_all: "Umatilla|Grant",
    county_fips_all: "41059|41023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97882,
    lat: 45.90741,
    lng: -119.34944,
    city: "Umatilla",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7958,
    density: 163.1,
    county_fips: 41059,
    county_name: "Umatilla",
    county_weights: {
      41059: 100,
    },
    county_names_all: "Umatilla",
    county_fips_all: 41059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97883,
    lat: 45.14264,
    lng: -117.64047,
    city: "Union",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2256,
    density: 2.7,
    county_fips: 41061,
    county_name: "Union",
    county_weights: {
      41061: 100,
    },
    county_names_all: "Union",
    county_fips_all: 41061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97884,
    lat: 44.44975,
    lng: -118.21895,
    city: "Unity",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 103,
    density: 0.4,
    county_fips: 41001,
    county_name: "Baker",
    county_weights: {
      41001: 100,
    },
    county_names_all: "Baker",
    county_fips_all: 41001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97885,
    lat: 45.65073,
    lng: -117.50972,
    city: "Wallowa",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1244,
    density: 1.5,
    county_fips: 41063,
    county_name: "Wallowa",
    county_weights: {
      41063: 100,
    },
    county_names_all: "Wallowa",
    county_fips_all: 41063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97886,
    lat: 45.79604,
    lng: -118.24924,
    city: "Weston",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 990,
    density: 2.6,
    county_fips: 41059,
    county_name: "Umatilla",
    county_weights: {
      41059: 100,
    },
    county_names_all: "Umatilla",
    county_fips_all: 41059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97901,
    lat: 43.5996,
    lng: -117.09602,
    city: "Adrian",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 710,
    density: 2,
    county_fips: 41045,
    county_name: "Malheur",
    county_weights: {
      41045: 100,
    },
    county_names_all: "Malheur",
    county_fips_all: 41045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 97902,
    lat: 42.91332,
    lng: -117.49412,
    city: "Arock",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 41045,
    county_name: "Malheur",
    county_weights: {
      41045: 100,
    },
    county_names_all: "Malheur",
    county_fips_all: 41045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 97903,
    lat: 44.27772,
    lng: -117.59775,
    city: "Brogan",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21,
    density: 0.1,
    county_fips: 41045,
    county_name: "Malheur",
    county_weights: {
      41045: 100,
    },
    county_names_all: "Malheur",
    county_fips_all: 41045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 97904,
    lat: 43.89136,
    lng: -118.50581,
    city: "Drewsey",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 249,
    density: 0.2,
    county_fips: 41025,
    county_name: "Harney",
    county_weights: {
      41025: 100,
    },
    county_names_all: "Harney",
    county_fips_all: 41025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97905,
    lat: 44.58183,
    lng: -117.4654,
    city: "Durkee",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 91,
    density: 0.2,
    county_fips: 41001,
    county_name: "Baker",
    county_weights: {
      41001: 100,
    },
    county_names_all: "Baker",
    county_fips_all: 41001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97906,
    lat: 43.46049,
    lng: -117.81783,
    city: "Harper",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 262,
    density: 0.1,
    county_fips: 41045,
    county_name: "Malheur",
    county_weights: {
      41045: 100,
    },
    county_names_all: "Malheur",
    county_fips_all: 41045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 97907,
    lat: 44.41893,
    lng: -117.35568,
    city: "Huntington",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 546,
    density: 0.6,
    county_fips: 41001,
    county_name: "Baker",
    county_weights: {
      41001: 73.77,
      41045: 26.23,
    },
    county_names_all: "Baker|Malheur",
    county_fips_all: "41001|41045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 97908,
    lat: 44.25679,
    lng: -117.94828,
    city: "Ironside",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31,
    density: 0,
    county_fips: 41045,
    county_name: "Malheur",
    county_weights: {
      41045: 100,
    },
    county_names_all: "Malheur",
    county_fips_all: 41045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 97909,
    lat: 44.21096,
    lng: -117.37909,
    city: "Jamieson",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 41045,
    county_name: "Malheur",
    county_weights: {
      41045: 100,
    },
    county_names_all: "Malheur",
    county_fips_all: 41045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 97910,
    lat: 42.85733,
    lng: -117.50909,
    city: "Jordan Valley",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 626,
    density: 0.1,
    county_fips: 41045,
    county_name: "Malheur",
    county_weights: {
      16073: 7.61,
      41045: 92.39,
    },
    county_names_all: "Malheur|Owyhee",
    county_fips_all: "41045|16073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 97911,
    lat: 43.85547,
    lng: -118.02605,
    city: "Juntura",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 106,
    density: 0.1,
    county_fips: 41045,
    county_name: "Malheur",
    county_weights: {
      41045: 100,
    },
    county_names_all: "Malheur",
    county_fips_all: 41045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 97913,
    lat: 43.64688,
    lng: -117.28131,
    city: "Nyssa",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5007,
    density: 4.9,
    county_fips: 41045,
    county_name: "Malheur",
    county_weights: {
      16075: 0.14,
      41045: 99.86,
    },
    county_names_all: "Malheur|Payette",
    county_fips_all: "41045|16075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 97914,
    lat: 44.11085,
    lng: -117.07383,
    city: "Ontario",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19281,
    density: 28.6,
    county_fips: 41045,
    county_name: "Malheur",
    county_weights: {
      41045: 100,
    },
    county_names_all: "Malheur",
    county_fips_all: 41045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 97917,
    lat: 43.5415,
    lng: -118.11651,
    city: "Riverside",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 41045,
    county_name: "Malheur",
    county_weights: {
      41045: 100,
    },
    county_names_all: "Malheur",
    county_fips_all: 41045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 97918,
    lat: 43.96255,
    lng: -117.38073,
    city: "Vale",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4533,
    density: 3,
    county_fips: 41045,
    county_name: "Malheur",
    county_weights: {
      41045: 100,
    },
    county_names_all: "Malheur",
    county_fips_all: 41045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 97920,
    lat: 44.06595,
    lng: -117.75997,
    city: "Westfall",
    state_id: "OR",
    state_name: "Oregon",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36,
    density: 0.1,
    county_fips: 41045,
    county_name: "Malheur",
    county_weights: {
      41045: 100,
    },
    county_names_all: "Malheur",
    county_fips_all: 41045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Boise",
  },
  {
    zip: 98001,
    lat: 47.30919,
    lng: -122.26426,
    city: "Auburn",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34455,
    density: 713.9,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98002,
    lat: 47.3082,
    lng: -122.21567,
    city: "Auburn",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33947,
    density: 1829.6,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98003,
    lat: 47.30596,
    lng: -122.31465,
    city: "Federal Way",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49445,
    density: 1659.9,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98004,
    lat: 47.61865,
    lng: -122.20548,
    city: "Bellevue",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37265,
    density: 1979.1,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98005,
    lat: 47.61494,
    lng: -122.16814,
    city: "Bellevue",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21414,
    density: 1126.7,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98006,
    lat: 47.55772,
    lng: -122.14957,
    city: "Bellevue",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37473,
    density: 1287.3,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98007,
    lat: 47.61392,
    lng: -122.14378,
    city: "Bellevue",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28147,
    density: 2515.6,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98008,
    lat: 47.60551,
    lng: -122.11219,
    city: "Bellevue",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25650,
    density: 1781.6,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98010,
    lat: 47.31173,
    lng: -122.00326,
    city: "Black Diamond",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5882,
    density: 152.8,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98011,
    lat: 47.75736,
    lng: -122.19871,
    city: "Bothell",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34201,
    density: 1871.8,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98012,
    lat: 47.84205,
    lng: -122.19813,
    city: "Bothell",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 70009,
    density: 1726.2,
    county_fips: 53061,
    county_name: "Snohomish",
    county_weights: {
      53061: 100,
    },
    county_names_all: "Snohomish",
    county_fips_all: 53061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98014,
    lat: 47.69664,
    lng: -121.84024,
    city: "Carnation",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7200,
    density: 31.9,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98019,
    lat: 47.74083,
    lng: -121.93494,
    city: "Duvall",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11841,
    density: 128.2,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98020,
    lat: 47.80015,
    lng: -122.37267,
    city: "Edmonds",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 19010,
    density: 1418.3,
    county_fips: 53061,
    county_name: "Snohomish",
    county_weights: {
      53061: 100,
    },
    county_names_all: "Snohomish",
    county_fips_all: 53061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98021,
    lat: 47.79257,
    lng: -122.20846,
    city: "Bothell",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33382,
    density: 1270.4,
    county_fips: 53061,
    county_name: "Snohomish",
    county_weights: {
      53061: 100,
    },
    county_names_all: "Snohomish",
    county_fips_all: 53061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98022,
    lat: 47.1714,
    lng: -121.67958,
    city: "Enumclaw",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21296,
    density: 11.3,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 61.65,
      53053: 38.35,
    },
    county_names_all: "King|Pierce",
    county_fips_all: "53033|53053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98023,
    lat: 47.30881,
    lng: -122.36198,
    city: "Federal Way",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 50176,
    density: 1887.3,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98024,
    lat: 47.57301,
    lng: -121.90219,
    city: "Fall City",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6635,
    density: 116,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98025,
    lat: 47.43441,
    lng: -121.9524,
    city: "Hobart",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98026,
    lat: 47.83555,
    lng: -122.3316,
    city: "Edmonds",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38292,
    density: 1575.8,
    county_fips: 53061,
    county_name: "Snohomish",
    county_weights: {
      53061: 100,
    },
    county_names_all: "Snohomish",
    county_fips_all: 53061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98027,
    lat: 47.50387,
    lng: -122.00176,
    city: "Issaquah",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30240,
    density: 204.2,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98028,
    lat: 47.75162,
    lng: -122.24892,
    city: "Kenmore",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22953,
    density: 1441.6,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98029,
    lat: 47.5576,
    lng: -122.0091,
    city: "Issaquah",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29956,
    density: 1136.9,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98030,
    lat: 47.36817,
    lng: -122.19749,
    city: "Kent",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37411,
    density: 2009.1,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98031,
    lat: 47.4055,
    lng: -122.1943,
    city: "Kent",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38163,
    density: 1905.4,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98032,
    lat: 47.3922,
    lng: -122.25819,
    city: "Kent",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38478,
    density: 875.9,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98033,
    lat: 47.67616,
    lng: -122.19267,
    city: "Kirkland",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 39802,
    density: 1669.8,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98034,
    lat: 47.71612,
    lng: -122.21332,
    city: "Kirkland",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45009,
    density: 1771,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98036,
    lat: 47.81094,
    lng: -122.28155,
    city: "Lynnwood",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40784,
    density: 1641.9,
    county_fips: 53061,
    county_name: "Snohomish",
    county_weights: {
      53061: 100,
    },
    county_names_all: "Snohomish",
    county_fips_all: 53061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98037,
    lat: 47.83873,
    lng: -122.28463,
    city: "Lynnwood",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29977,
    density: 2001.8,
    county_fips: 53061,
    county_name: "Snohomish",
    county_weights: {
      53061: 100,
    },
    county_names_all: "Snohomish",
    county_fips_all: 53061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98038,
    lat: 47.41861,
    lng: -121.95589,
    city: "Maple Valley",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36157,
    density: 212.1,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98039,
    lat: 47.63308,
    lng: -122.23963,
    city: "Medina",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3283,
    density: 883.1,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98040,
    lat: 47.56611,
    lng: -122.232,
    city: "Mercer Island",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25820,
    density: 1561.9,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98042,
    lat: 47.36508,
    lng: -122.11623,
    city: "Kent",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49118,
    density: 682.5,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98043,
    lat: 47.7921,
    lng: -122.30758,
    city: "Mountlake Terrace",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21328,
    density: 2033,
    county_fips: 53061,
    county_name: "Snohomish",
    county_weights: {
      53061: 100,
    },
    county_names_all: "Snohomish",
    county_fips_all: 53061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98045,
    lat: 47.48276,
    lng: -121.65678,
    city: "North Bend",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15174,
    density: 34,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98047,
    lat: 47.26079,
    lng: -122.24822,
    city: "Pacific",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7012,
    density: 1265.1,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 70.68,
      53053: 29.32,
    },
    county_names_all: "King|Pierce",
    county_fips_all: "53033|53053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98050,
    lat: 47.54764,
    lng: -121.93663,
    city: "Preston",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 523,
    density: 108.4,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98051,
    lat: 47.3396,
    lng: -121.89049,
    city: "Ravensdale",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4386,
    density: 31.4,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98052,
    lat: 47.68148,
    lng: -122.1203,
    city: "Redmond",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 71940,
    density: 1371,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98053,
    lat: 47.66491,
    lng: -122.02071,
    city: "Redmond",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22911,
    density: 319.9,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98055,
    lat: 47.44775,
    lng: -122.20205,
    city: "Renton",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24077,
    density: 2084.1,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98056,
    lat: 47.51281,
    lng: -122.18923,
    city: "Renton",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36625,
    density: 1866.8,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98057,
    lat: 47.47188,
    lng: -122.21961,
    city: "Renton",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11534,
    density: 723,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98058,
    lat: 47.44082,
    lng: -122.12503,
    city: "Renton",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43482,
    density: 892,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98059,
    lat: 47.49563,
    lng: -122.12474,
    city: "Renton",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40693,
    density: 971.8,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98065,
    lat: 47.59234,
    lng: -121.78931,
    city: "Snoqualmie",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15896,
    density: 87.2,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98068,
    lat: 47.45154,
    lng: -121.35795,
    city: "Snoqualmie Pass",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 497,
    density: 0.8,
    county_fips: 53037,
    county_name: "Kittitas",
    county_weights: {
      53033: 45.06,
      53037: 54.94,
    },
    county_names_all: "Kittitas|King",
    county_fips_all: "53037|53033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98070,
    lat: 47.41219,
    lng: -122.4726,
    city: "Vashon",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10400,
    density: 108.7,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98072,
    lat: 47.76151,
    lng: -122.13153,
    city: "Woodinville",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24865,
    density: 533.7,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 72.29,
      53061: 27.71,
    },
    county_names_all: "King|Snohomish",
    county_fips_all: "53033|53061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98074,
    lat: 47.62206,
    lng: -122.04437,
    city: "Sammamish",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29349,
    density: 1080.4,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98075,
    lat: 47.58683,
    lng: -122.03796,
    city: "Sammamish",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24435,
    density: 979.2,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98077,
    lat: 47.75263,
    lng: -122.05754,
    city: "Woodinville",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14407,
    density: 321.8,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 85.05,
      53061: 14.95,
    },
    county_names_all: "King|Snohomish",
    county_fips_all: "53033|53061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98087,
    lat: 47.8624,
    lng: -122.2664,
    city: "Lynnwood",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41594,
    density: 2794.1,
    county_fips: 53061,
    county_name: "Snohomish",
    county_weights: {
      53061: 100,
    },
    county_names_all: "Snohomish",
    county_fips_all: 53061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98092,
    lat: 47.28851,
    lng: -122.13123,
    city: "Auburn",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48962,
    density: 440.7,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 96.62,
      53053: 3.38,
    },
    county_names_all: "King|Pierce",
    county_fips_all: "53033|53053",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98101,
    lat: 47.61119,
    lng: -122.33454,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14380,
    density: 10509,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98102,
    lat: 47.63627,
    lng: -122.32337,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25887,
    density: 7851.8,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98103,
    lat: 47.6732,
    lng: -122.34258,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54194,
    density: 4564.1,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98104,
    lat: 47.60044,
    lng: -122.33004,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15155,
    density: 6189.8,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98105,
    lat: 47.66094,
    lng: -122.28321,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52290,
    density: 5261.5,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98106,
    lat: 47.54339,
    lng: -122.35366,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27997,
    density: 1968.1,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98107,
    lat: 47.66757,
    lng: -122.37789,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28025,
    density: 4980.3,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98108,
    lat: 47.54113,
    lng: -122.3126,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24034,
    density: 1257.8,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98109,
    lat: 47.63128,
    lng: -122.34486,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31011,
    density: 6189,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98110,
    lat: 47.64389,
    lng: -122.54335,
    city: "Bainbridge Island",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24859,
    density: 347.6,
    county_fips: 53035,
    county_name: "Kitsap",
    county_weights: {
      53035: 100,
    },
    county_names_all: "Kitsap",
    county_fips_all: 53035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98112,
    lat: 47.63242,
    lng: -122.28732,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25694,
    density: 3096.2,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98115,
    lat: 47.68547,
    lng: -122.28234,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55519,
    density: 3269.7,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98116,
    lat: 47.57399,
    lng: -122.39503,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28705,
    density: 3692.2,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98117,
    lat: 47.6882,
    lng: -122.38157,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36647,
    density: 3653.4,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98118,
    lat: 47.54235,
    lng: -122.26872,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49702,
    density: 3074.9,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98119,
    lat: 47.63943,
    lng: -122.36932,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26898,
    density: 4315.5,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98121,
    lat: 47.61548,
    lng: -122.34668,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20534,
    density: 17876.5,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98122,
    lat: 47.60985,
    lng: -122.29569,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41152,
    density: 6801.5,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98125,
    lat: 47.71706,
    lng: -122.29969,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44030,
    density: 3133.5,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98126,
    lat: 47.54732,
    lng: -122.37454,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22681,
    density: 2827,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98133,
    lat: 47.7399,
    lng: -122.34432,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49476,
    density: 2680,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98134,
    lat: 47.57691,
    lng: -122.33686,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 779,
    density: 90.7,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98136,
    lat: 47.53686,
    lng: -122.38992,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17083,
    density: 2874.5,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98144,
    lat: 47.58582,
    lng: -122.29205,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33175,
    density: 3799,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98146,
    lat: 47.50008,
    lng: -122.35768,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27622,
    density: 2307.8,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98148,
    lat: 47.44494,
    lng: -122.32587,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11514,
    density: 1639.9,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98154,
    lat: 47.60621,
    lng: -122.33379,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98155,
    lat: 47.75609,
    lng: -122.30039,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35420,
    density: 1812.8,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98158,
    lat: 47.45043,
    lng: -122.30805,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98164,
    lat: 47.60596,
    lng: -122.33203,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 200,
    density: 21822.1,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98166,
    lat: 47.45256,
    lng: -122.34978,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21772,
    density: 1455.3,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98168,
    lat: 47.48898,
    lng: -122.30175,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33217,
    density: 1464.8,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98174,
    lat: 47.60477,
    lng: -122.33528,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98177,
    lat: 47.74237,
    lng: -122.37085,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20422,
    density: 1398.3,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98178,
    lat: 47.49921,
    lng: -122.24735,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26507,
    density: 2088.1,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98188,
    lat: 47.44754,
    lng: -122.27398,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25292,
    density: 1210.6,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98195,
    lat: 47.65466,
    lng: -122.30752,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51,
    density: 49.9,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98198,
    lat: 47.39469,
    lng: -122.31111,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38699,
    density: 1934.2,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98199,
    lat: 47.65139,
    lng: -122.40223,
    city: "Seattle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23444,
    density: 2137.3,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98201,
    lat: 47.99373,
    lng: -122.18563,
    city: "Everett",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30645,
    density: 631,
    county_fips: 53061,
    county_name: "Snohomish",
    county_weights: {
      53061: 100,
    },
    county_names_all: "Snohomish",
    county_fips_all: 53061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98203,
    lat: 47.94236,
    lng: -122.23651,
    city: "Everett",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35901,
    density: 1172.2,
    county_fips: 53061,
    county_name: "Snohomish",
    county_weights: {
      53061: 100,
    },
    county_names_all: "Snohomish",
    county_fips_all: 53061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98204,
    lat: 47.90105,
    lng: -122.2586,
    city: "Everett",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44152,
    density: 2373.2,
    county_fips: 53061,
    county_name: "Snohomish",
    county_weights: {
      53061: 100,
    },
    county_names_all: "Snohomish",
    county_fips_all: 53061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98207,
    lat: 47.98793,
    lng: -122.2229,
    city: "Everett",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1435,
    density: 2197.3,
    county_fips: 53061,
    county_name: "Snohomish",
    county_weights: {
      53061: 100,
    },
    county_names_all: "Snohomish",
    county_fips_all: 53061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98208,
    lat: 47.90072,
    lng: -122.18852,
    city: "Everett",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 58211,
    density: 1475.1,
    county_fips: 53061,
    county_name: "Snohomish",
    county_weights: {
      53061: 100,
    },
    county_names_all: "Snohomish",
    county_fips_all: 53061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98220,
    lat: 48.68526,
    lng: -122.19678,
    city: "Acme",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 839,
    density: 16,
    county_fips: 53073,
    county_name: "Whatcom",
    county_weights: {
      53073: 100,
    },
    county_names_all: "Whatcom",
    county_fips_all: 53073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98221,
    lat: 48.50401,
    lng: -122.65435,
    city: "Anacortes",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22290,
    density: 165.7,
    county_fips: 53057,
    county_name: "Skagit",
    county_weights: {
      53055: 10.68,
      53057: 89.32,
    },
    county_names_all: "Skagit|San Juan",
    county_fips_all: "53057|53055",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98222,
    lat: 48.56085,
    lng: -122.80263,
    city: "Blakely Island",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 89,
    density: 5.2,
    county_fips: 53055,
    county_name: "San Juan",
    county_weights: {
      53055: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 53055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98223,
    lat: 48.20994,
    lng: -121.95081,
    city: "Arlington",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46027,
    density: 56.2,
    county_fips: 53061,
    county_name: "Snohomish",
    county_weights: {
      53061: 100,
    },
    county_names_all: "Snohomish",
    county_fips_all: 53061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98224,
    lat: 47.7357,
    lng: -121.56859,
    city: "Baring",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 243,
    density: 1.5,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98225,
    lat: 48.75461,
    lng: -122.50307,
    city: "Bellingham",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51606,
    density: 1585.1,
    county_fips: 53073,
    county_name: "Whatcom",
    county_weights: {
      53073: 100,
    },
    county_names_all: "Whatcom",
    county_fips_all: 53073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98226,
    lat: 48.80064,
    lng: -122.42299,
    city: "Bellingham",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 45380,
    density: 165.6,
    county_fips: 53073,
    county_name: "Whatcom",
    county_weights: {
      53073: 100,
    },
    county_names_all: "Whatcom",
    county_fips_all: 53073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98229,
    lat: 48.69615,
    lng: -122.40979,
    city: "Bellingham",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33548,
    density: 258.2,
    county_fips: 53073,
    county_name: "Whatcom",
    county_weights: {
      53057: 4.66,
      53073: 95.34,
    },
    county_names_all: "Whatcom|Skagit",
    county_fips_all: "53073|53057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98230,
    lat: 48.95688,
    lng: -122.7084,
    city: "Blaine",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17910,
    density: 162.6,
    county_fips: 53073,
    county_name: "Whatcom",
    county_weights: {
      53073: 100,
    },
    county_names_all: "Whatcom",
    county_fips_all: 53073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98232,
    lat: 48.56531,
    lng: -122.41498,
    city: "Bow",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4259,
    density: 30.5,
    county_fips: 53057,
    county_name: "Skagit",
    county_weights: {
      53057: 100,
    },
    county_names_all: "Skagit",
    county_fips_all: 53057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98233,
    lat: 48.50309,
    lng: -122.35102,
    city: "Burlington",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16324,
    density: 190.1,
    county_fips: 53057,
    county_name: "Skagit",
    county_weights: {
      53057: 100,
    },
    county_names_all: "Skagit",
    county_fips_all: 53057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98235,
    lat: 48.4602,
    lng: -122.22846,
    city: "Clearlake",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 53057,
    county_name: "Skagit",
    county_weights: {
      53057: 100,
    },
    county_names_all: "Skagit",
    county_fips_all: 53057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98236,
    lat: 47.95804,
    lng: -122.40468,
    city: "Clinton",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6140,
    density: 102.9,
    county_fips: 53029,
    county_name: "Island",
    county_weights: {
      53029: 100,
    },
    county_names_all: "Island",
    county_fips_all: 53029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98237,
    lat: 48.53272,
    lng: -121.69748,
    city: "Concrete",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4762,
    density: 4.4,
    county_fips: 53057,
    county_name: "Skagit",
    county_weights: {
      53057: 83.35,
      53073: 16.65,
    },
    county_names_all: "Skagit|Whatcom",
    county_fips_all: "53057|53073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98238,
    lat: 48.33563,
    lng: -122.34444,
    city: "Conway",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40,
    density: 68.6,
    county_fips: 53057,
    county_name: "Skagit",
    county_weights: {
      53057: 100,
    },
    county_names_all: "Skagit",
    county_fips_all: 53057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98239,
    lat: 48.18926,
    lng: -122.65756,
    city: "Coupeville",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7679,
    density: 95.6,
    county_fips: 53029,
    county_name: "Island",
    county_weights: {
      53029: 100,
    },
    county_names_all: "Island",
    county_fips_all: 53029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98240,
    lat: 48.94711,
    lng: -122.62061,
    city: "Custer",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2934,
    density: 50.9,
    county_fips: 53073,
    county_name: "Whatcom",
    county_weights: {
      53073: 100,
    },
    county_names_all: "Whatcom",
    county_fips_all: 53073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98241,
    lat: 48.21425,
    lng: -121.33219,
    city: "Darrington",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1941,
    density: 1.8,
    county_fips: 53061,
    county_name: "Snohomish",
    county_weights: {
      53057: 8.07,
      53061: 91.93,
    },
    county_names_all: "Snohomish|Skagit",
    county_fips_all: "53061|53057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98243,
    lat: 48.61512,
    lng: -122.99882,
    city: "Deer Harbor",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 548,
    density: 69.8,
    county_fips: 53055,
    county_name: "San Juan",
    county_weights: {
      53055: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 53055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98244,
    lat: 48.79423,
    lng: -121.93557,
    city: "Deming",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3483,
    density: 2.9,
    county_fips: 53073,
    county_name: "Whatcom",
    county_weights: {
      53073: 100,
    },
    county_names_all: "Whatcom",
    county_fips_all: 53073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98245,
    lat: 48.66241,
    lng: -122.91616,
    city: "Eastsound",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3767,
    density: 41,
    county_fips: 53055,
    county_name: "San Juan",
    county_weights: {
      53055: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 53055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98247,
    lat: 48.90459,
    lng: -122.31732,
    city: "Everson",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9105,
    density: 52.7,
    county_fips: 53073,
    county_name: "Whatcom",
    county_weights: {
      53073: 100,
    },
    county_names_all: "Whatcom",
    county_fips_all: 53073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98248,
    lat: 48.86494,
    lng: -122.62211,
    city: "Ferndale",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26552,
    density: 142.8,
    county_fips: 53073,
    county_name: "Whatcom",
    county_weights: {
      53073: 100,
    },
    county_names_all: "Whatcom",
    county_fips_all: 53073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98249,
    lat: 48.01888,
    lng: -122.53947,
    city: "Freeland",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4458,
    density: 108.1,
    county_fips: 53029,
    county_name: "Island",
    county_weights: {
      53029: 100,
    },
    county_names_all: "Island",
    county_fips_all: 53029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98250,
    lat: 48.55264,
    lng: -123.09631,
    city: "Friday Harbor",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8318,
    density: 52.5,
    county_fips: 53055,
    county_name: "San Juan",
    county_weights: {
      53055: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 53055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98251,
    lat: 47.89812,
    lng: -121.55752,
    city: "Gold Bar",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4084,
    density: 9.8,
    county_fips: 53061,
    county_name: "Snohomish",
    county_weights: {
      53061: 100,
    },
    county_names_all: "Snohomish",
    county_fips_all: 53061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98252,
    lat: 48.06173,
    lng: -121.70939,
    city: "Granite Falls",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9993,
    density: 16.2,
    county_fips: 53061,
    county_name: "Snohomish",
    county_weights: {
      53061: 100,
    },
    county_names_all: "Snohomish",
    county_fips_all: 53061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98253,
    lat: 48.079,
    lng: -122.57568,
    city: "Greenbank",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1726,
    density: 60.9,
    county_fips: 53029,
    county_name: "Island",
    county_weights: {
      53029: 100,
    },
    county_names_all: "Island",
    county_fips_all: 53029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98255,
    lat: 48.52353,
    lng: -121.99203,
    city: "Hamilton",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 182,
    density: 105.9,
    county_fips: 53057,
    county_name: "Skagit",
    county_weights: {
      53057: 100,
    },
    county_names_all: "Skagit",
    county_fips_all: 53057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98256,
    lat: 47.82883,
    lng: -121.41464,
    city: "Index",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 369,
    density: 1.9,
    county_fips: 53061,
    county_name: "Snohomish",
    county_weights: {
      53061: 100,
    },
    county_names_all: "Snohomish",
    county_fips_all: 53061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98257,
    lat: 48.415,
    lng: -122.50879,
    city: "La Conner",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4430,
    density: 92.5,
    county_fips: 53057,
    county_name: "Skagit",
    county_weights: {
      53057: 100,
    },
    county_names_all: "Skagit",
    county_fips_all: 53057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98258,
    lat: 48.03252,
    lng: -122.07762,
    city: "Lake Stevens",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33545,
    density: 349.5,
    county_fips: 53061,
    county_name: "Snohomish",
    county_weights: {
      53061: 100,
    },
    county_names_all: "Snohomish",
    county_fips_all: 53061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98260,
    lat: 48.03074,
    lng: -122.45106,
    city: "Langley",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6024,
    density: 88.6,
    county_fips: 53029,
    county_name: "Island",
    county_weights: {
      53029: 100,
    },
    county_names_all: "Island",
    county_fips_all: 53029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98261,
    lat: 48.48381,
    lng: -122.88302,
    city: "Lopez Island",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2808,
    density: 36.4,
    county_fips: 53055,
    county_name: "San Juan",
    county_weights: {
      53055: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 53055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98262,
    lat: 48.69317,
    lng: -122.66406,
    city: "Lummi Island",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 955,
    density: 39.9,
    county_fips: 53073,
    county_name: "Whatcom",
    county_weights: {
      53073: 100,
    },
    county_names_all: "Whatcom",
    county_fips_all: 53073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98263,
    lat: 48.52281,
    lng: -122.0657,
    city: "Lyman",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49,
    density: 77.4,
    county_fips: 53057,
    county_name: "Skagit",
    county_weights: {
      53057: 100,
    },
    county_names_all: "Skagit",
    county_fips_all: 53057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98264,
    lat: 48.94972,
    lng: -122.45672,
    city: "Lynden",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21337,
    density: 144.1,
    county_fips: 53073,
    county_name: "Whatcom",
    county_weights: {
      53073: 100,
    },
    county_names_all: "Whatcom",
    county_fips_all: 53073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98266,
    lat: 48.9576,
    lng: -122.06189,
    city: "Maple Falls",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4014,
    density: 30.7,
    county_fips: 53073,
    county_name: "Whatcom",
    county_weights: {
      53073: 100,
    },
    county_names_all: "Whatcom",
    county_fips_all: 53073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98267,
    lat: 48.43756,
    lng: -121.30841,
    city: "Marblemount",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 262,
    density: 0.3,
    county_fips: 53057,
    county_name: "Skagit",
    county_weights: {
      53057: 100,
    },
    county_names_all: "Skagit",
    county_fips_all: 53057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98270,
    lat: 48.05952,
    lng: -122.1443,
    city: "Marysville",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52307,
    density: 1416.2,
    county_fips: 53061,
    county_name: "Snohomish",
    county_weights: {
      53061: 100,
    },
    county_names_all: "Snohomish",
    county_fips_all: 53061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98271,
    lat: 48.09373,
    lng: -122.23559,
    city: "Marysville",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28473,
    density: 242.6,
    county_fips: 53061,
    county_name: "Snohomish",
    county_weights: {
      53061: 100,
    },
    county_names_all: "Snohomish",
    county_fips_all: 53061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98272,
    lat: 47.85834,
    lng: -121.88457,
    city: "Monroe",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30801,
    density: 111.9,
    county_fips: 53061,
    county_name: "Snohomish",
    county_weights: {
      53061: 100,
    },
    county_names_all: "Snohomish",
    county_fips_all: 53061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98273,
    lat: 48.40522,
    lng: -122.36841,
    city: "Mount Vernon",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31725,
    density: 145.9,
    county_fips: 53057,
    county_name: "Skagit",
    county_weights: {
      53057: 100,
    },
    county_names_all: "Skagit",
    county_fips_all: 53057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98274,
    lat: 48.36013,
    lng: -122.14346,
    city: "Mount Vernon",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18346,
    density: 49.5,
    county_fips: 53057,
    county_name: "Skagit",
    county_weights: {
      53057: 100,
    },
    county_names_all: "Skagit",
    county_fips_all: 53057,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98275,
    lat: 47.90994,
    lng: -122.30113,
    city: "Mukilteo",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21432,
    density: 1131.8,
    county_fips: 53061,
    county_name: "Snohomish",
    county_weights: {
      53061: 100,
    },
    county_names_all: "Snohomish",
    county_fips_all: 53061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98276,
    lat: 48.92765,
    lng: -122.32096,
    city: "Nooksack",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 713,
    density: 389.2,
    county_fips: 53073,
    county_name: "Whatcom",
    county_weights: {
      53073: 100,
    },
    county_names_all: "Whatcom",
    county_fips_all: 53073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98277,
    lat: 48.31688,
    lng: -122.63152,
    city: "Oak Harbor",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38844,
    density: 262,
    county_fips: 53029,
    county_name: "Island",
    county_weights: {
      53029: 100,
    },
    county_names_all: "Island",
    county_fips_all: 53029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98278,
    lat: 48.34388,
    lng: -122.66491,
    city: "Oak Harbor",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2243,
    density: 205.1,
    county_fips: 53029,
    county_name: "Island",
    county_weights: {
      53029: 100,
    },
    county_names_all: "Island",
    county_fips_all: 53029,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98279,
    lat: 48.64474,
    lng: -122.80602,
    city: "Olga",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 693,
    density: 19.6,
    county_fips: 53055,
    county_name: "San Juan",
    county_weights: {
      53055: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 53055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98280,
    lat: 48.60866,
    lng: -122.90554,
    city: "Orcas",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 384,
    density: 24,
    county_fips: 53055,
    county_name: "San Juan",
    county_weights: {
      53055: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 53055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98281,
    lat: 48.98817,
    lng: -123.05767,
    city: "Point Roberts",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1100,
    density: 86.9,
    county_fips: 53073,
    county_name: "Whatcom",
    county_weights: {
      53073: 100,
    },
    county_names_all: "Whatcom",
    county_fips_all: 53073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98282,
    lat: 48.18719,
    lng: -122.46966,
    city: "Camano Island",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17073,
    density: 163.3,
    county_fips: 53029,
    county_name: "Island",
    county_weights: {
      53029: 98.66,
      53061: 1.34,
    },
    county_names_all: "Island|Snohomish",
    county_fips_all: "53029|53061",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98283,
    lat: 48.80137,
    lng: -121.29997,
    city: "Rockport",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 350,
    density: 0.3,
    county_fips: 53073,
    county_name: "Whatcom",
    county_weights: {
      53057: 4.25,
      53073: 95.75,
    },
    county_names_all: "Whatcom|Skagit",
    county_fips_all: "53073|53057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98284,
    lat: 48.55211,
    lng: -122.11763,
    city: "Sedro Woolley",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26268,
    density: 36.1,
    county_fips: 53057,
    county_name: "Skagit",
    county_weights: {
      53057: 91.87,
      53073: 8.13,
    },
    county_names_all: "Skagit|Whatcom",
    county_fips_all: "53057|53073",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98286,
    lat: 48.57262,
    lng: -122.95712,
    city: "Shaw Island",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 181,
    density: 9.1,
    county_fips: 53055,
    county_name: "San Juan",
    county_weights: {
      53055: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 53055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98288,
    lat: 47.65204,
    lng: -121.3574,
    city: "Skykomish",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 225,
    density: 0.3,
    county_fips: 53033,
    county_name: "King",
    county_weights: {
      53033: 100,
    },
    county_names_all: "King",
    county_fips_all: 53033,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98290,
    lat: 47.95141,
    lng: -121.98421,
    city: "Snohomish",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37077,
    density: 121.8,
    county_fips: 53061,
    county_name: "Snohomish",
    county_weights: {
      53061: 100,
    },
    county_names_all: "Snohomish",
    county_fips_all: 53061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98292,
    lat: 48.22455,
    lng: -122.3032,
    city: "Stanwood",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23063,
    density: 115.9,
    county_fips: 53061,
    county_name: "Snohomish",
    county_weights: {
      53057: 1.03,
      53061: 98.97,
    },
    county_names_all: "Snohomish|Skagit",
    county_fips_all: "53061|53057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98294,
    lat: 47.84431,
    lng: -121.75822,
    city: "Sultan",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7310,
    density: 52.1,
    county_fips: 53061,
    county_name: "Snohomish",
    county_weights: {
      53061: 100,
    },
    county_names_all: "Snohomish",
    county_fips_all: 53061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98295,
    lat: 48.97163,
    lng: -122.2213,
    city: "Sumas",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2884,
    density: 35.6,
    county_fips: 53073,
    county_name: "Whatcom",
    county_weights: {
      53073: 100,
    },
    county_names_all: "Whatcom",
    county_fips_all: 53073,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98296,
    lat: 47.84266,
    lng: -122.10199,
    city: "Snohomish",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30781,
    density: 344.2,
    county_fips: 53061,
    county_name: "Snohomish",
    county_weights: {
      53061: 100,
    },
    county_names_all: "Snohomish",
    county_fips_all: 53061,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98297,
    lat: 48.7005,
    lng: -123.02834,
    city: "Waldron",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 66,
    density: 5.6,
    county_fips: 53055,
    county_name: "San Juan",
    county_weights: {
      53055: 100,
    },
    county_names_all: "San Juan",
    county_fips_all: 53055,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98303,
    lat: 47.15783,
    lng: -122.70387,
    city: "Anderson Island",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1571,
    density: 76.5,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98304,
    lat: 46.87036,
    lng: -121.73985,
    city: "Ashford",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1029,
    density: 1.2,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53041: 1.66,
      53053: 98.34,
    },
    county_names_all: "Pierce|Lewis",
    county_fips_all: "53053|53041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98305,
    lat: 48.03148,
    lng: -124.22934,
    city: "Beaver",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 349,
    density: 0.6,
    county_fips: 53009,
    county_name: "Clallam",
    county_weights: {
      53009: 100,
    },
    county_names_all: "Clallam",
    county_fips_all: 53009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98310,
    lat: 47.58939,
    lng: -122.6175,
    city: "Bremerton",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20431,
    density: 1433.4,
    county_fips: 53035,
    county_name: "Kitsap",
    county_weights: {
      53035: 100,
    },
    county_names_all: "Kitsap",
    county_fips_all: 53035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98311,
    lat: 47.62829,
    lng: -122.63793,
    city: "Bremerton",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28042,
    density: 967,
    county_fips: 53035,
    county_name: "Kitsap",
    county_weights: {
      53035: 100,
    },
    county_names_all: "Kitsap",
    county_fips_all: 53035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98312,
    lat: 47.56435,
    lng: -122.75706,
    city: "Bremerton",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30437,
    density: 178.8,
    county_fips: 53035,
    county_name: "Kitsap",
    county_weights: {
      53035: 99.84,
      53045: 0.16,
    },
    county_names_all: "Kitsap|Mason",
    county_fips_all: "53035|53045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98314,
    lat: 47.56243,
    lng: -122.63893,
    city: "Bremerton",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3270,
    density: 10817.4,
    county_fips: 53035,
    county_name: "Kitsap",
    county_weights: {
      53035: 100,
    },
    county_names_all: "Kitsap",
    county_fips_all: 53035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98315,
    lat: 47.72263,
    lng: -122.71444,
    city: "Silverdale",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6825,
    density: 237.7,
    county_fips: 53035,
    county_name: "Kitsap",
    county_weights: {
      53035: 100,
    },
    county_names_all: "Kitsap",
    county_fips_all: 53035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98320,
    lat: 47.69861,
    lng: -123.01742,
    city: "Brinnon",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1357,
    density: 3.8,
    county_fips: 53031,
    county_name: "Jefferson",
    county_weights: {
      53031: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 53031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98321,
    lat: 47.15564,
    lng: -122.06576,
    city: "Buckley",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15976,
    density: 173.7,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98323,
    lat: 46.98059,
    lng: -122.006,
    city: "Carbonado",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 757,
    density: 3,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98325,
    lat: 47.96093,
    lng: -122.77911,
    city: "Chimacum",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1321,
    density: 18.4,
    county_fips: 53031,
    county_name: "Jefferson",
    county_weights: {
      53031: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 53031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98326,
    lat: 48.17364,
    lng: -124.45278,
    city: "Clallam Bay",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 840,
    density: 1.1,
    county_fips: 53009,
    county_name: "Clallam",
    county_weights: {
      53009: 100,
    },
    county_names_all: "Clallam",
    county_fips_all: 53009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98327,
    lat: 47.10203,
    lng: -122.66061,
    city: "Dupont",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9514,
    density: 537.4,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98328,
    lat: 46.86055,
    lng: -122.17227,
    city: "Eatonville",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10763,
    density: 18.1,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98329,
    lat: 47.37731,
    lng: -122.72523,
    city: "Gig Harbor",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11063,
    density: 164.3,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53035: 0.98,
      53053: 99.02,
    },
    county_names_all: "Pierce|Kitsap",
    county_fips_all: "53053|53035",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98330,
    lat: 46.75874,
    lng: -122.15894,
    city: "Elbe",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 92,
    density: 26.6,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98331,
    lat: 47.77292,
    lng: -124.1273,
    city: "Forks",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6228,
    density: 2.6,
    county_fips: 53031,
    county_name: "Jefferson",
    county_weights: {
      53009: 20.66,
      53031: 79.34,
    },
    county_names_all: "Jefferson|Clallam",
    county_fips_all: "53031|53009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98332,
    lat: 47.36514,
    lng: -122.59858,
    city: "Gig Harbor",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18940,
    density: 353.9,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98333,
    lat: 47.24771,
    lng: -122.62561,
    city: "Fox Island",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3613,
    density: 268.6,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98335,
    lat: 47.29909,
    lng: -122.61911,
    city: "Gig Harbor",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27098,
    density: 472.5,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98336,
    lat: 46.56382,
    lng: -122.10939,
    city: "Glenoma",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 824,
    density: 4.8,
    county_fips: 53041,
    county_name: "Lewis",
    county_weights: {
      53041: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 53041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98337,
    lat: 47.56345,
    lng: -122.63405,
    city: "Bremerton",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7223,
    density: 1884.4,
    county_fips: 53035,
    county_name: "Kitsap",
    county_weights: {
      53035: 100,
    },
    county_names_all: "Kitsap",
    county_fips_all: 53035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98338,
    lat: 47.01927,
    lng: -122.28347,
    city: "Graham",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28999,
    density: 207.5,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98339,
    lat: 48.02991,
    lng: -122.74364,
    city: "Port Hadlock",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3277,
    density: 104.3,
    county_fips: 53031,
    county_name: "Jefferson",
    county_weights: {
      53031: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 53031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98340,
    lat: 47.90622,
    lng: -122.56406,
    city: "Hansville",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3421,
    density: 176.6,
    county_fips: 53035,
    county_name: "Kitsap",
    county_weights: {
      53035: 100,
    },
    county_names_all: "Kitsap",
    county_fips_all: 53035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98342,
    lat: 47.75475,
    lng: -122.51952,
    city: "Indianola",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1276,
    density: 181.5,
    county_fips: 53035,
    county_name: "Kitsap",
    county_weights: {
      53035: 100,
    },
    county_names_all: "Kitsap",
    county_fips_all: 53035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98345,
    lat: 47.69972,
    lng: -122.62366,
    city: "Keyport",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 339,
    density: 261.8,
    county_fips: 53035,
    county_name: "Kitsap",
    county_weights: {
      53035: 100,
    },
    county_names_all: "Kitsap",
    county_fips_all: 53035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98346,
    lat: 47.82005,
    lng: -122.53399,
    city: "Kingston",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9273,
    density: 123,
    county_fips: 53035,
    county_name: "Kitsap",
    county_weights: {
      53035: 100,
    },
    county_names_all: "Kitsap",
    county_fips_all: 53035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98349,
    lat: 47.26583,
    lng: -122.77366,
    city: "Lakebay",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5090,
    density: 95.1,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98350,
    lat: 47.90683,
    lng: -124.62509,
    city: "La Push",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 520,
    density: 132.3,
    county_fips: 53009,
    county_name: "Clallam",
    county_weights: {
      53009: 100,
    },
    county_names_all: "Clallam",
    county_fips_all: 53009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98351,
    lat: 47.20353,
    lng: -122.76773,
    city: "Longbranch",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1619,
    density: 69.1,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98353,
    lat: 47.53885,
    lng: -122.49294,
    city: "Manchester",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18,
    density: 8.7,
    county_fips: 53035,
    county_name: "Kitsap",
    county_weights: {
      53035: 100,
    },
    county_names_all: "Kitsap",
    county_fips_all: 53035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98354,
    lat: 47.25113,
    lng: -122.31557,
    city: "Milton",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7551,
    density: 1029,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53033: 19.98,
      53053: 80.02,
    },
    county_names_all: "Pierce|King",
    county_fips_all: "53053|53033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98355,
    lat: 46.69179,
    lng: -122.03978,
    city: "Mineral",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 846,
    density: 2,
    county_fips: 53041,
    county_name: "Lewis",
    county_weights: {
      53041: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 53041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98356,
    lat: 46.57943,
    lng: -122.26913,
    city: "Morton",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2016,
    density: 6.2,
    county_fips: 53041,
    county_name: "Lewis",
    county_weights: {
      53041: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 53041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98357,
    lat: 48.33188,
    lng: -124.62816,
    city: "Neah Bay",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1638,
    density: 14.9,
    county_fips: 53009,
    county_name: "Clallam",
    county_weights: {
      53009: 100,
    },
    county_names_all: "Clallam",
    county_fips_all: 53009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98358,
    lat: 48.05796,
    lng: -122.70008,
    city: "Nordland",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 943,
    density: 57.6,
    county_fips: 53031,
    county_name: "Jefferson",
    county_weights: {
      53031: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 53031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98359,
    lat: 47.43047,
    lng: -122.57631,
    city: "Olalla",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5065,
    density: 140.8,
    county_fips: 53035,
    county_name: "Kitsap",
    county_weights: {
      53035: 100,
    },
    county_names_all: "Kitsap",
    county_fips_all: 53035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98360,
    lat: 47.03246,
    lng: -122.1575,
    city: "Orting",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14084,
    density: 80.3,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98361,
    lat: 46.62786,
    lng: -121.56385,
    city: "Packwood",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 696,
    density: 0.8,
    county_fips: 53041,
    county_name: "Lewis",
    county_weights: {
      53041: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 53041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98362,
    lat: 48.01639,
    lng: -123.31951,
    city: "Port Angeles",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24997,
    density: 78.5,
    county_fips: 53009,
    county_name: "Clallam",
    county_weights: {
      53009: 100,
    },
    county_names_all: "Clallam",
    county_fips_all: 53009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98363,
    lat: 48.03477,
    lng: -123.76952,
    city: "Port Angeles",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14295,
    density: 11.5,
    county_fips: 53009,
    county_name: "Clallam",
    county_weights: {
      53009: 100,
    },
    county_names_all: "Clallam",
    county_fips_all: 53009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98364,
    lat: 47.85455,
    lng: -122.58638,
    city: "Port Gamble",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 82,
    density: 901.9,
    county_fips: 53035,
    county_name: "Kitsap",
    county_weights: {
      53035: 100,
    },
    county_names_all: "Kitsap",
    county_fips_all: 53035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98365,
    lat: 47.89545,
    lng: -122.70271,
    city: "Port Ludlow",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4816,
    density: 50,
    county_fips: 53031,
    county_name: "Jefferson",
    county_weights: {
      53031: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 53031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98366,
    lat: 47.53732,
    lng: -122.58647,
    city: "Port Orchard",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35523,
    density: 585.9,
    county_fips: 53035,
    county_name: "Kitsap",
    county_weights: {
      53035: 100,
    },
    county_names_all: "Kitsap",
    county_fips_all: 53035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98367,
    lat: 47.46141,
    lng: -122.67662,
    city: "Port Orchard",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30447,
    density: 159.9,
    county_fips: 53035,
    county_name: "Kitsap",
    county_weights: {
      53035: 100,
    },
    county_names_all: "Kitsap",
    county_fips_all: 53035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98368,
    lat: 48.03879,
    lng: -122.84406,
    city: "Port Townsend",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16070,
    density: 118.5,
    county_fips: 53031,
    county_name: "Jefferson",
    county_weights: {
      53031: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 53031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98370,
    lat: 47.75114,
    lng: -122.62373,
    city: "Poulsbo",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32044,
    density: 219.7,
    county_fips: 53035,
    county_name: "Kitsap",
    county_weights: {
      53035: 100,
    },
    county_names_all: "Kitsap",
    county_fips_all: 53035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98371,
    lat: 47.19957,
    lng: -122.32191,
    city: "Puyallup",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21764,
    density: 710,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98372,
    lat: 47.2064,
    lng: -122.26689,
    city: "Puyallup",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26823,
    density: 776.5,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98373,
    lat: 47.14761,
    lng: -122.32506,
    city: "Puyallup",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27196,
    density: 1119.1,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98374,
    lat: 47.12904,
    lng: -122.26156,
    city: "Puyallup",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 44293,
    density: 1044.1,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98375,
    lat: 47.10394,
    lng: -122.32383,
    city: "Puyallup",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32349,
    density: 1290.8,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98376,
    lat: 47.8455,
    lng: -122.85916,
    city: "Quilcene",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2176,
    density: 7.6,
    county_fips: 53031,
    county_name: "Jefferson",
    county_weights: {
      53031: 100,
    },
    county_names_all: "Jefferson",
    county_fips_all: 53031,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98377,
    lat: 46.50586,
    lng: -121.81912,
    city: "Randle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1845,
    density: 2.2,
    county_fips: 53041,
    county_name: "Lewis",
    county_weights: {
      53041: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 53041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98380,
    lat: 47.5743,
    lng: -122.90287,
    city: "Seabeck",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4296,
    density: 34.3,
    county_fips: 53035,
    county_name: "Kitsap",
    county_weights: {
      53035: 93.68,
      53045: 6.32,
    },
    county_names_all: "Kitsap|Mason",
    county_fips_all: "53035|53045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98381,
    lat: 48.28863,
    lng: -124.45681,
    city: "Sekiu",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 266,
    density: 2.5,
    county_fips: 53009,
    county_name: "Clallam",
    county_weights: {
      53009: 100,
    },
    county_names_all: "Clallam",
    county_fips_all: 53009,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98382,
    lat: 48.0131,
    lng: -123.07437,
    city: "Sequim",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29214,
    density: 54.6,
    county_fips: 53009,
    county_name: "Clallam",
    county_weights: {
      53009: 93.34,
      53031: 6.66,
    },
    county_names_all: "Clallam|Jefferson",
    county_fips_all: "53009|53031",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98383,
    lat: 47.66212,
    lng: -122.71652,
    city: "Silverdale",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22825,
    density: 507.9,
    county_fips: 53035,
    county_name: "Kitsap",
    county_weights: {
      53035: 100,
    },
    county_names_all: "Kitsap",
    county_fips_all: 53035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98385,
    lat: 47.13791,
    lng: -122.09469,
    city: "South Prairie",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 362,
    density: 189.4,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98387,
    lat: 47.0562,
    lng: -122.39111,
    city: "Spanaway",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51305,
    density: 744.5,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98388,
    lat: 47.19892,
    lng: -122.66268,
    city: "Steilacoom",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6682,
    density: 292,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98390,
    lat: 47.21195,
    lng: -122.22894,
    city: "Sumner",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11155,
    density: 468.5,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98391,
    lat: 47.17654,
    lng: -122.17362,
    city: "Bonney Lake",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52686,
    density: 530.2,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98392,
    lat: 47.73425,
    lng: -122.5631,
    city: "Suquamish",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3059,
    density: 661.4,
    county_fips: 53035,
    county_name: "Kitsap",
    county_weights: {
      53035: 100,
    },
    county_names_all: "Kitsap",
    county_fips_all: 53035,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98394,
    lat: 47.32011,
    lng: -122.77791,
    city: "Vaughn",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1331,
    density: 94.4,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98396,
    lat: 47.10669,
    lng: -122.01052,
    city: "Wilkeson",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 749,
    density: 27.3,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98402,
    lat: 47.25021,
    lng: -122.44056,
    city: "Tacoma",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6920,
    density: 2264.8,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98403,
    lat: 47.26581,
    lng: -122.45921,
    city: "Tacoma",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8169,
    density: 3153.2,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98404,
    lat: 47.20927,
    lng: -122.41139,
    city: "Tacoma",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36749,
    density: 2010.1,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98405,
    lat: 47.24599,
    lng: -122.47222,
    city: "Tacoma",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23671,
    density: 2229.8,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98406,
    lat: 47.26283,
    lng: -122.50857,
    city: "Tacoma",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23052,
    density: 2128.9,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98407,
    lat: 47.28889,
    lng: -122.5111,
    city: "Tacoma",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21316,
    density: 1526.9,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98408,
    lat: 47.19811,
    lng: -122.44638,
    city: "Tacoma",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20670,
    density: 2339.5,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98409,
    lat: 47.21084,
    lng: -122.48197,
    city: "Tacoma",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27918,
    density: 1509.5,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98416,
    lat: 47.26271,
    lng: -122.48196,
    city: "Tacoma",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 973,
    density: 4255.3,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98418,
    lat: 47.22325,
    lng: -122.44642,
    city: "Tacoma",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9644,
    density: 2207.7,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98421,
    lat: 47.25819,
    lng: -122.40107,
    city: "Tacoma",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1346,
    density: 79.9,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98422,
    lat: 47.28907,
    lng: -122.39123,
    city: "Tacoma",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21732,
    density: 1197.8,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53033: 2.22,
      53053: 97.78,
    },
    county_names_all: "Pierce|King",
    county_fips_all: "53053|53033",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98424,
    lat: 47.2343,
    lng: -122.3523,
    city: "Fife",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11524,
    density: 706.7,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98430,
    lat: 47.11733,
    lng: -122.56896,
    city: "Camp Murray",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98433,
    lat: 47.09121,
    lng: -122.60772,
    city: "Tacoma",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20137,
    density: 232.1,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98438,
    lat: 47.13514,
    lng: -122.49211,
    city: "Mcchord Afb",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 610,
    density: 244.9,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98439,
    lat: 47.13164,
    lng: -122.49603,
    city: "Lakewood",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5260,
    density: 373.2,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98443,
    lat: 47.20522,
    lng: -122.37592,
    city: "Tacoma",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5335,
    density: 380.5,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98444,
    lat: 47.15228,
    lng: -122.44887,
    city: "Tacoma",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35604,
    density: 1979.2,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98445,
    lat: 47.13985,
    lng: -122.40965,
    city: "Tacoma",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31973,
    density: 1181.4,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98446,
    lat: 47.12935,
    lng: -122.37424,
    city: "Tacoma",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11945,
    density: 423.5,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98447,
    lat: 47.14531,
    lng: -122.44392,
    city: "Tacoma",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 744,
    density: 2527,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98465,
    lat: 47.24868,
    lng: -122.53043,
    city: "Tacoma",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6656,
    density: 1587.7,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98466,
    lat: 47.22842,
    lng: -122.53479,
    city: "Tacoma",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29401,
    density: 1825.3,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98467,
    lat: 47.2038,
    lng: -122.5447,
    city: "University Place",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15381,
    density: 1243.6,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98498,
    lat: 47.16001,
    lng: -122.55971,
    city: "Lakewood",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 28764,
    density: 1116.8,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98499,
    lat: 47.16662,
    lng: -122.50624,
    city: "Lakewood",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32174,
    density: 1404.6,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98501,
    lat: 46.9783,
    lng: -122.86989,
    city: "Olympia",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43584,
    density: 482.1,
    county_fips: 53067,
    county_name: "Thurston",
    county_weights: {
      53067: 100,
    },
    county_names_all: "Thurston",
    county_fips_all: 53067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98502,
    lat: 47.08466,
    lng: -123.02958,
    city: "Olympia",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35307,
    density: 214.9,
    county_fips: 53067,
    county_name: "Thurston",
    county_weights: {
      53045: 0.46,
      53067: 99.54,
    },
    county_names_all: "Thurston|Mason",
    county_fips_all: "53067|53045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98503,
    lat: 47.02528,
    lng: -122.799,
    city: "Lacey",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42119,
    density: 1467.9,
    county_fips: 53067,
    county_name: "Thurston",
    county_weights: {
      53067: 100,
    },
    county_names_all: "Thurston",
    county_fips_all: 53067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98505,
    lat: 47.07321,
    lng: -122.97358,
    city: "Olympia",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 53067,
    county_name: "Thurston",
    county_weights: {
      53067: 100,
    },
    county_names_all: "Thurston",
    county_fips_all: 53067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98506,
    lat: 47.10286,
    lng: -122.87307,
    city: "Olympia",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18404,
    density: 316.6,
    county_fips: 53067,
    county_name: "Thurston",
    county_weights: {
      53067: 100,
    },
    county_names_all: "Thurston",
    county_fips_all: 53067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98512,
    lat: 46.95326,
    lng: -123.04259,
    city: "Olympia",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30833,
    density: 85.8,
    county_fips: 53067,
    county_name: "Thurston",
    county_weights: {
      53067: 100,
    },
    county_names_all: "Thurston",
    county_fips_all: 53067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98513,
    lat: 46.99074,
    lng: -122.73298,
    city: "Olympia",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36473,
    density: 282.4,
    county_fips: 53067,
    county_name: "Thurston",
    county_weights: {
      53067: 100,
    },
    county_names_all: "Thurston",
    county_fips_all: 53067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98516,
    lat: 47.09647,
    lng: -122.78265,
    city: "Olympia",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25332,
    density: 339.3,
    county_fips: 53067,
    county_name: "Thurston",
    county_weights: {
      53067: 100,
    },
    county_names_all: "Thurston",
    county_fips_all: 53067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98520,
    lat: 46.99478,
    lng: -123.81054,
    city: "Aberdeen",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24936,
    density: 44.3,
    county_fips: 53027,
    county_name: "Grays Harbor",
    county_weights: {
      53027: 100,
    },
    county_names_all: "Grays Harbor",
    county_fips_all: 53027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98524,
    lat: 47.36703,
    lng: -122.84548,
    city: "Allyn",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4220,
    density: 198.8,
    county_fips: 53045,
    county_name: "Mason",
    county_weights: {
      53045: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 53045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98526,
    lat: 47.47749,
    lng: -123.99227,
    city: "Amanda Park",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 198,
    density: 0.9,
    county_fips: 53027,
    county_name: "Grays Harbor",
    county_weights: {
      53027: 100,
    },
    county_names_all: "Grays Harbor",
    county_fips_all: 53027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98527,
    lat: 46.58917,
    lng: -123.90939,
    city: "Bay Center",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 227,
    density: 9,
    county_fips: 53049,
    county_name: "Pacific",
    county_weights: {
      53049: 100,
    },
    county_names_all: "Pacific",
    county_fips_all: 53049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98528,
    lat: 47.44605,
    lng: -122.89618,
    city: "Belfair",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12812,
    density: 68.4,
    county_fips: 53045,
    county_name: "Mason",
    county_weights: {
      53045: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 53045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98530,
    lat: 46.80519,
    lng: -122.86804,
    city: "Bucoda",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 608,
    density: 87.3,
    county_fips: 53067,
    county_name: "Thurston",
    county_weights: {
      53067: 100,
    },
    county_names_all: "Thurston",
    county_fips_all: 53067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98531,
    lat: 46.73646,
    lng: -122.91364,
    city: "Centralia",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26212,
    density: 78.4,
    county_fips: 53041,
    county_name: "Lewis",
    county_weights: {
      53041: 78.96,
      53067: 21.04,
    },
    county_names_all: "Lewis|Thurston",
    county_fips_all: "53041|53067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98532,
    lat: 46.63628,
    lng: -123.03444,
    city: "Chehalis",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25534,
    density: 31.6,
    county_fips: 53041,
    county_name: "Lewis",
    county_weights: {
      53041: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 53041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98533,
    lat: 46.67304,
    lng: -122.43115,
    city: "Cinebar",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 451,
    density: 1.5,
    county_fips: 53041,
    county_name: "Lewis",
    county_weights: {
      53041: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 53041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98535,
    lat: 47.0994,
    lng: -124.11973,
    city: "Copalis Beach",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 614,
    density: 11.8,
    county_fips: 53027,
    county_name: "Grays Harbor",
    county_weights: {
      53027: 100,
    },
    county_names_all: "Grays Harbor",
    county_fips_all: 53027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98536,
    lat: 47.18939,
    lng: -124.111,
    city: "Copalis Crossing",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 61,
    density: 0.4,
    county_fips: 53027,
    county_name: "Grays Harbor",
    county_weights: {
      53027: 100,
    },
    county_names_all: "Grays Harbor",
    county_fips_all: 53027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98537,
    lat: 46.81719,
    lng: -123.59768,
    city: "Cosmopolis",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2487,
    density: 5.9,
    county_fips: 53027,
    county_name: "Grays Harbor",
    county_weights: {
      53027: 66.86,
      53049: 33.14,
    },
    county_names_all: "Grays Harbor|Pacific",
    county_fips_all: "53027|53049",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98538,
    lat: 46.47422,
    lng: -123.15884,
    city: "Curtis",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 378,
    density: 1.3,
    county_fips: 53041,
    county_name: "Lewis",
    county_weights: {
      53041: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 53041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98539,
    lat: 46.63772,
    lng: -123.27315,
    city: "Doty",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 53041,
    county_name: "Lewis",
    county_weights: {
      53041: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 53041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98541,
    lat: 47.06877,
    lng: -123.40459,
    city: "Elma",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10858,
    density: 21.4,
    county_fips: 53027,
    county_name: "Grays Harbor",
    county_weights: {
      53027: 59.59,
      53045: 40.41,
    },
    county_names_all: "Grays Harbor|Mason",
    county_fips_all: "53027|53045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98542,
    lat: 46.5293,
    lng: -122.73155,
    city: "Ethel",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1080,
    density: 38.2,
    county_fips: 53041,
    county_name: "Lewis",
    county_weights: {
      53041: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 53041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98544,
    lat: 46.73912,
    lng: -123.02712,
    city: "Galvin",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 80,
    density: 307.4,
    county_fips: 53041,
    county_name: "Lewis",
    county_weights: {
      53041: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 53041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98546,
    lat: 47.32439,
    lng: -122.92362,
    city: "Grapeview",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3225,
    density: 36.4,
    county_fips: 53045,
    county_name: "Mason",
    county_weights: {
      53045: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 53045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98547,
    lat: 46.78622,
    lng: -124.01956,
    city: "Grayland",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1420,
    density: 8.9,
    county_fips: 53049,
    county_name: "Pacific",
    county_weights: {
      53027: 40.4,
      53049: 59.6,
    },
    county_names_all: "Pacific|Grays Harbor",
    county_fips_all: "53049|53027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98548,
    lat: 47.47064,
    lng: -123.29273,
    city: "Hoodsport",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1989,
    density: 4,
    county_fips: 53045,
    county_name: "Mason",
    county_weights: {
      53027: 0.12,
      53045: 99.88,
    },
    county_names_all: "Mason|Grays Harbor",
    county_fips_all: "53045|53027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98550,
    lat: 47.14081,
    lng: -123.90122,
    city: "Hoquiam",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11307,
    density: 16.4,
    county_fips: 53027,
    county_name: "Grays Harbor",
    county_weights: {
      53027: 100,
    },
    county_names_all: "Grays Harbor",
    county_fips_all: 53027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98552,
    lat: 47.3136,
    lng: -123.9444,
    city: "Humptulips",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 526,
    density: 2.7,
    county_fips: 53027,
    county_name: "Grays Harbor",
    county_weights: {
      53027: 100,
    },
    county_names_all: "Grays Harbor",
    county_fips_all: 53027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98555,
    lat: 47.54634,
    lng: -123.06369,
    city: "Lilliwaup",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 243,
    density: 3.5,
    county_fips: 53045,
    county_name: "Mason",
    county_weights: {
      53045: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 53045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98556,
    lat: 46.88565,
    lng: -123.1409,
    city: "Littlerock",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 53067,
    county_name: "Thurston",
    county_weights: {
      53067: 100,
    },
    county_names_all: "Thurston",
    county_fips_all: 53067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98557,
    lat: 47.04332,
    lng: -123.2681,
    city: "Mccleary",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3384,
    density: 36.8,
    county_fips: 53027,
    county_name: "Grays Harbor",
    county_weights: {
      53027: 97.89,
      53045: 2.11,
    },
    county_names_all: "Grays Harbor|Mason",
    county_fips_all: "53027|53045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98558,
    lat: 46.93579,
    lng: -122.55998,
    city: "Mckenna",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 64,
    density: 381.9,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 98.83,
      53067: 1.17,
    },
    county_names_all: "Pierce|Thurston",
    county_fips_all: "53053|53067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98559,
    lat: 46.95884,
    lng: -123.32749,
    city: "Malone",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 53027,
    county_name: "Grays Harbor",
    county_weights: {
      53027: 100,
    },
    county_names_all: "Grays Harbor",
    county_fips_all: 53027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98560,
    lat: 47.30577,
    lng: -123.43948,
    city: "Matlock",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 104,
    density: 0.9,
    county_fips: 53045,
    county_name: "Mason",
    county_weights: {
      53045: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 53045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98562,
    lat: 47.23877,
    lng: -124.20336,
    city: "Moclips",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 49,
    density: 19.4,
    county_fips: 53027,
    county_name: "Grays Harbor",
    county_weights: {
      53027: 100,
    },
    county_names_all: "Grays Harbor",
    county_fips_all: 53027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98563,
    lat: 47.2064,
    lng: -123.60824,
    city: "Montesano",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7691,
    density: 7.2,
    county_fips: 53027,
    county_name: "Grays Harbor",
    county_weights: {
      53027: 99.9,
      53045: 0.1,
    },
    county_names_all: "Grays Harbor|Mason",
    county_fips_all: "53027|53045",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98564,
    lat: 46.45666,
    lng: -122.43627,
    city: "Mossyrock",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2394,
    density: 6.4,
    county_fips: 53041,
    county_name: "Lewis",
    county_weights: {
      53041: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 53041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98565,
    lat: 46.57838,
    lng: -122.90693,
    city: "Napavine",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 807,
    density: 1343.1,
    county_fips: 53041,
    county_name: "Lewis",
    county_weights: {
      53041: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 53041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98566,
    lat: 47.39616,
    lng: -123.95976,
    city: "Neilton",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 53027,
    county_name: "Grays Harbor",
    county_weights: {
      53027: 100,
    },
    county_names_all: "Grays Harbor",
    county_fips_all: 53027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98568,
    lat: 46.86467,
    lng: -123.30235,
    city: "Oakville",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2492,
    density: 5.6,
    county_fips: 53027,
    county_name: "Grays Harbor",
    county_weights: {
      53027: 91.04,
      53041: 8.96,
    },
    county_names_all: "Grays Harbor|Lewis",
    county_fips_all: "53027|53041",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98569,
    lat: 47.00206,
    lng: -124.15479,
    city: "Ocean Shores",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6444,
    density: 187.8,
    county_fips: 53027,
    county_name: "Grays Harbor",
    county_weights: {
      53027: 100,
    },
    county_names_all: "Grays Harbor",
    county_fips_all: 53027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98570,
    lat: 46.63556,
    lng: -122.63534,
    city: "Onalaska",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4189,
    density: 12.8,
    county_fips: 53041,
    county_name: "Lewis",
    county_weights: {
      53041: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 53041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98571,
    lat: 47.20356,
    lng: -124.19532,
    city: "Pacific Beach",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 214,
    density: 21.3,
    county_fips: 53027,
    county_name: "Grays Harbor",
    county_weights: {
      53027: 100,
    },
    county_names_all: "Grays Harbor",
    county_fips_all: 53027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98572,
    lat: 46.55256,
    lng: -123.32429,
    city: "Pe Ell",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 925,
    density: 10.2,
    county_fips: 53041,
    county_name: "Lewis",
    county_weights: {
      53041: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 53041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98575,
    lat: 47.43607,
    lng: -123.79848,
    city: "Quinault",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 122,
    density: 0.8,
    county_fips: 53027,
    county_name: "Grays Harbor",
    county_weights: {
      53027: 100,
    },
    county_names_all: "Grays Harbor",
    county_fips_all: 53027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98576,
    lat: 46.84417,
    lng: -122.64687,
    city: "Rainier",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5196,
    density: 23.8,
    county_fips: 53067,
    county_name: "Thurston",
    county_weights: {
      53067: 100,
    },
    county_names_all: "Thurston",
    county_fips_all: 53067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98577,
    lat: 46.6418,
    lng: -123.60031,
    city: "Raymond",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7235,
    density: 7.7,
    county_fips: 53049,
    county_name: "Pacific",
    county_weights: {
      53049: 100,
    },
    county_names_all: "Pacific",
    county_fips_all: 53049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98579,
    lat: 46.79406,
    lng: -123.11952,
    city: "Rochester",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12845,
    density: 52.6,
    county_fips: 53067,
    county_name: "Thurston",
    county_weights: {
      53027: 0.47,
      53041: 40.3,
      53067: 59.23,
    },
    county_names_all: "Thurston|Lewis|Grays Harbor",
    county_fips_all: "53067|53041|53027",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98580,
    lat: 46.9918,
    lng: -122.50101,
    city: "Roy",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11495,
    density: 34.1,
    county_fips: 53053,
    county_name: "Pierce",
    county_weights: {
      53053: 100,
    },
    county_names_all: "Pierce",
    county_fips_all: 53053,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98581,
    lat: 46.35875,
    lng: -123.06865,
    city: "Ryderwood",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 424,
    density: 5.6,
    county_fips: 53015,
    county_name: "Cowlitz",
    county_weights: {
      53015: 100,
    },
    county_names_all: "Cowlitz",
    county_fips_all: 53015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98582,
    lat: 46.51686,
    lng: -122.62693,
    city: "Salkum",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 94,
    density: 6.2,
    county_fips: 53041,
    county_name: "Lewis",
    county_weights: {
      53041: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 53041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98583,
    lat: 47.00122,
    lng: -123.4875,
    city: "Satsop",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 97,
    density: 361.4,
    county_fips: 53027,
    county_name: "Grays Harbor",
    county_weights: {
      53027: 100,
    },
    county_names_all: "Grays Harbor",
    county_fips_all: 53027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98584,
    lat: 47.24608,
    lng: -123.16209,
    city: "Shelton",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37698,
    density: 40.5,
    county_fips: 53045,
    county_name: "Mason",
    county_weights: {
      53045: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 53045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98585,
    lat: 46.55436,
    lng: -122.5022,
    city: "Silver Creek",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 630,
    density: 10.8,
    county_fips: 53041,
    county_name: "Lewis",
    county_weights: {
      53041: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 53041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98586,
    lat: 46.55909,
    lng: -123.8391,
    city: "South Bend",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1763,
    density: 5.3,
    county_fips: 53049,
    county_name: "Pacific",
    county_weights: {
      53049: 100,
    },
    county_names_all: "Pacific",
    county_fips_all: 53049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98587,
    lat: 47.32039,
    lng: -124.1562,
    city: "Taholah",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 784,
    density: 5.2,
    county_fips: 53027,
    county_name: "Grays Harbor",
    county_weights: {
      53027: 100,
    },
    county_names_all: "Grays Harbor",
    county_fips_all: 53027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98588,
    lat: 47.43555,
    lng: -123.02261,
    city: "Tahuya",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1489,
    density: 12.8,
    county_fips: 53045,
    county_name: "Mason",
    county_weights: {
      53045: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 53045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98589,
    lat: 46.84133,
    lng: -122.82087,
    city: "Tenino",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6955,
    density: 29,
    county_fips: 53067,
    county_name: "Thurston",
    county_weights: {
      53067: 100,
    },
    county_names_all: "Thurston",
    county_fips_all: 53067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98590,
    lat: 46.71882,
    lng: -124.00272,
    city: "Tokeland",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 491,
    density: 62.7,
    county_fips: 53049,
    county_name: "Pacific",
    county_weights: {
      53049: 100,
    },
    county_names_all: "Pacific",
    county_fips_all: 53049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98591,
    lat: 46.44224,
    lng: -122.74671,
    city: "Toledo",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3411,
    density: 11.6,
    county_fips: 53041,
    county_name: "Lewis",
    county_weights: {
      53041: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 53041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98592,
    lat: 47.32895,
    lng: -123.07907,
    city: "Union",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1740,
    density: 38,
    county_fips: 53045,
    county_name: "Mason",
    county_weights: {
      53045: 100,
    },
    county_names_all: "Mason",
    county_fips_all: 53045,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98593,
    lat: 46.40767,
    lng: -123.00807,
    city: "Vader",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1232,
    density: 33.2,
    county_fips: 53041,
    county_name: "Lewis",
    county_weights: {
      53015: 0.27,
      53041: 99.73,
    },
    county_names_all: "Lewis|Cowlitz",
    county_fips_all: "53041|53015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98595,
    lat: 46.88302,
    lng: -124.1088,
    city: "Westport",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2716,
    density: 197.5,
    county_fips: 53027,
    county_name: "Grays Harbor",
    county_weights: {
      53027: 100,
    },
    county_names_all: "Grays Harbor",
    county_fips_all: 53027,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98596,
    lat: 46.49556,
    lng: -122.95364,
    city: "Winlock",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7579,
    density: 33,
    county_fips: 53041,
    county_name: "Lewis",
    county_weights: {
      53041: 100,
    },
    county_names_all: "Lewis",
    county_fips_all: 53041,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98597,
    lat: 46.85241,
    lng: -122.49212,
    city: "Yelm",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24968,
    density: 86.8,
    county_fips: 53067,
    county_name: "Thurston",
    county_weights: {
      53067: 100,
    },
    county_names_all: "Thurston",
    county_fips_all: 53067,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98601,
    lat: 45.93439,
    lng: -122.43857,
    city: "Amboy",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3266,
    density: 40.6,
    county_fips: 53011,
    county_name: "Clark",
    county_weights: {
      53011: 91.1,
      53015: 8.9,
    },
    county_names_all: "Clark|Cowlitz",
    county_fips_all: "53011|53015",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98602,
    lat: 45.8693,
    lng: -121.27966,
    city: "Appleton",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 120,
    density: 0.8,
    county_fips: 53039,
    county_name: "Klickitat",
    county_weights: {
      53039: 100,
    },
    county_names_all: "Klickitat",
    county_fips_all: 53039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98603,
    lat: 46.04223,
    lng: -122.42001,
    city: "Ariel",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 961,
    density: 3.2,
    county_fips: 53015,
    county_name: "Cowlitz",
    county_weights: {
      53015: 100,
    },
    county_names_all: "Cowlitz",
    county_fips_all: 53015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98604,
    lat: 45.80013,
    lng: -122.5054,
    city: "Battle Ground",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37333,
    density: 200.1,
    county_fips: 53011,
    county_name: "Clark",
    county_weights: {
      53011: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 53011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98605,
    lat: 45.77846,
    lng: -121.6393,
    city: "Bingen",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1089,
    density: 10.6,
    county_fips: 53059,
    county_name: "Skamania",
    county_weights: {
      53039: 7.69,
      53059: 92.31,
    },
    county_names_all: "Skamania|Klickitat",
    county_fips_all: "53059|53039",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98606,
    lat: 45.72921,
    lng: -122.45615,
    city: "Brush Prairie",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9203,
    density: 93.5,
    county_fips: 53011,
    county_name: "Clark",
    county_weights: {
      53011: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 53011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98607,
    lat: 45.64395,
    lng: -122.38242,
    city: "Camas",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32897,
    density: 266.7,
    county_fips: 53011,
    county_name: "Clark",
    county_weights: {
      53011: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 53011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98609,
    lat: 46.0717,
    lng: -122.86569,
    city: "Carrolls",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 53015,
    county_name: "Cowlitz",
    county_weights: {
      53015: 100,
    },
    county_names_all: "Cowlitz",
    county_fips_all: 53015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98610,
    lat: 45.77765,
    lng: -122.01401,
    city: "Carson",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3199,
    density: 8.7,
    county_fips: 53059,
    county_name: "Skamania",
    county_weights: {
      53059: 100,
    },
    county_names_all: "Skamania",
    county_fips_all: 53059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98611,
    lat: 46.30642,
    lng: -122.90479,
    city: "Castle Rock",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8803,
    density: 25,
    county_fips: 53015,
    county_name: "Cowlitz",
    county_weights: {
      53015: 100,
    },
    county_names_all: "Cowlitz",
    county_fips_all: 53015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98612,
    lat: 46.23462,
    lng: -123.31194,
    city: "Cathlamet",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3201,
    density: 12.2,
    county_fips: 53069,
    county_name: "Wahkiakum",
    county_weights: {
      53069: 100,
    },
    county_names_all: "Wahkiakum",
    county_fips_all: 53069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98613,
    lat: 45.7542,
    lng: -120.97235,
    city: "Centerville",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 407,
    density: 1.7,
    county_fips: 53039,
    county_name: "Klickitat",
    county_weights: {
      53039: 100,
    },
    county_names_all: "Klickitat",
    county_fips_all: 53039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98614,
    lat: 46.29459,
    lng: -123.9034,
    city: "Chinook",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 142,
    density: 1.8,
    county_fips: 53049,
    county_name: "Pacific",
    county_weights: {
      53049: 100,
    },
    county_names_all: "Pacific",
    county_fips_all: 53049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98616,
    lat: 46.06227,
    lng: -122.14599,
    city: "Cougar",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 103,
    density: 0.4,
    county_fips: 53059,
    county_name: "Skamania",
    county_weights: {
      53011: 0.15,
      53015: 4.12,
      53059: 95.73,
    },
    county_names_all: "Skamania|Cowlitz|Clark",
    county_fips_all: "53059|53015|53011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98617,
    lat: 45.64283,
    lng: -121.14229,
    city: "Dallesport",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1138,
    density: 25.5,
    county_fips: 53039,
    county_name: "Klickitat",
    county_weights: {
      53039: 100,
    },
    county_names_all: "Klickitat",
    county_fips_all: 53039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98619,
    lat: 45.97693,
    lng: -121.26568,
    city: "Glenwood",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 613,
    density: 1.5,
    county_fips: 53039,
    county_name: "Klickitat",
    county_weights: {
      53039: 100,
    },
    county_names_all: "Klickitat",
    county_fips_all: 53039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98620,
    lat: 45.87096,
    lng: -120.77846,
    city: "Goldendale",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7670,
    density: 6.3,
    county_fips: 53039,
    county_name: "Klickitat",
    county_weights: {
      53039: 100,
    },
    county_names_all: "Klickitat",
    county_fips_all: 53039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98621,
    lat: 46.4006,
    lng: -123.54428,
    city: "Grays River",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 309,
    density: 2.4,
    county_fips: 53049,
    county_name: "Pacific",
    county_weights: {
      53049: 58.05,
      53069: 41.95,
    },
    county_names_all: "Pacific|Wahkiakum",
    county_fips_all: "53049|53069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98623,
    lat: 45.79956,
    lng: -121.49347,
    city: "Husum",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 53039,
    county_name: "Klickitat",
    county_weights: {
      53039: 100,
    },
    county_names_all: "Klickitat",
    county_fips_all: 53039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98624,
    lat: 46.3578,
    lng: -123.94094,
    city: "Ilwaco",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1889,
    density: 20.9,
    county_fips: 53049,
    county_name: "Pacific",
    county_weights: {
      53049: 100,
    },
    county_names_all: "Pacific",
    county_fips_all: 53049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98625,
    lat: 46.10871,
    lng: -122.56093,
    city: "Kalama",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6516,
    density: 13,
    county_fips: 53015,
    county_name: "Cowlitz",
    county_weights: {
      53015: 100,
    },
    county_names_all: "Cowlitz",
    county_fips_all: 53015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98626,
    lat: 46.15317,
    lng: -122.78564,
    city: "Kelso",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25366,
    density: 72.8,
    county_fips: 53015,
    county_name: "Cowlitz",
    county_weights: {
      53015: 100,
    },
    county_names_all: "Cowlitz",
    county_fips_all: 53015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98628,
    lat: 45.85015,
    lng: -121.09887,
    city: "Klickitat",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 285,
    density: 10.3,
    county_fips: 53039,
    county_name: "Klickitat",
    county_weights: {
      53039: 100,
    },
    county_names_all: "Klickitat",
    county_fips_all: 53039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98629,
    lat: 45.88109,
    lng: -122.6148,
    city: "La Center",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8761,
    density: 89.5,
    county_fips: 53011,
    county_name: "Clark",
    county_weights: {
      53011: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 53011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98631,
    lat: 46.37988,
    lng: -124.02241,
    city: "Long Beach",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3055,
    density: 51.9,
    county_fips: 53049,
    county_name: "Pacific",
    county_weights: {
      53049: 100,
    },
    county_names_all: "Pacific",
    county_fips_all: 53049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98632,
    lat: 46.21223,
    lng: -123.06855,
    city: "Longview",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52489,
    density: 166.9,
    county_fips: 53015,
    county_name: "Cowlitz",
    county_weights: {
      53015: 99.76,
      53069: 0.24,
    },
    county_names_all: "Cowlitz|Wahkiakum",
    county_fips_all: "53015|53069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98635,
    lat: 45.74364,
    lng: -121.20915,
    city: "Lyle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1586,
    density: 4.6,
    county_fips: 53039,
    county_name: "Klickitat",
    county_weights: {
      53039: 100,
    },
    county_names_all: "Klickitat",
    county_fips_all: 53039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98638,
    lat: 46.4047,
    lng: -123.73588,
    city: "Naselle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1489,
    density: 3.4,
    county_fips: 53049,
    county_name: "Pacific",
    county_weights: {
      53049: 91.18,
      53069: 8.82,
    },
    county_names_all: "Pacific|Wahkiakum",
    county_fips_all: "53049|53069",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98639,
    lat: 45.64364,
    lng: -121.96288,
    city: "North Bonneville",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 855,
    density: 116.7,
    county_fips: 53059,
    county_name: "Skamania",
    county_weights: {
      53059: 100,
    },
    county_names_all: "Skamania",
    county_fips_all: 53059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98640,
    lat: 46.5429,
    lng: -124.04938,
    city: "Ocean Park",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4774,
    density: 130.9,
    county_fips: 53049,
    county_name: "Pacific",
    county_weights: {
      53049: 100,
    },
    county_names_all: "Pacific",
    county_fips_all: 53049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98641,
    lat: 46.56484,
    lng: -124.03932,
    city: "Oysterville",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 53049,
    county_name: "Pacific",
    county_weights: {
      53049: 100,
    },
    county_names_all: "Pacific",
    county_fips_all: 53049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98642,
    lat: 45.80262,
    lng: -122.7019,
    city: "Ridgefield",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20920,
    density: 142.1,
    county_fips: 53011,
    county_name: "Clark",
    county_weights: {
      53011: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 53011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98643,
    lat: 46.30326,
    lng: -123.62117,
    city: "Rosburg",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 355,
    density: 4,
    county_fips: 53069,
    county_name: "Wahkiakum",
    county_weights: {
      53069: 100,
    },
    county_names_all: "Wahkiakum",
    county_fips_all: 53069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98644,
    lat: 46.32861,
    lng: -124.04009,
    city: "Seaview",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 481,
    density: 59.4,
    county_fips: 53049,
    county_name: "Pacific",
    county_weights: {
      53049: 100,
    },
    county_names_all: "Pacific",
    county_fips_all: 53049,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98645,
    lat: 46.32509,
    lng: -122.77993,
    city: "Silverlake",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1962,
    density: 49.9,
    county_fips: 53015,
    county_name: "Cowlitz",
    county_weights: {
      53015: 100,
    },
    county_names_all: "Cowlitz",
    county_fips_all: 53015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98647,
    lat: 46.32137,
    lng: -123.4354,
    city: "Skamokawa",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 256,
    density: 1.4,
    county_fips: 53069,
    county_name: "Wahkiakum",
    county_weights: {
      53069: 100,
    },
    county_names_all: "Wahkiakum",
    county_fips_all: 53069,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98648,
    lat: 45.70563,
    lng: -121.9489,
    city: "Stevenson",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3207,
    density: 8.6,
    county_fips: 53059,
    county_name: "Skamania",
    county_weights: {
      53059: 100,
    },
    county_names_all: "Skamania",
    county_fips_all: 53059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98649,
    lat: 46.31504,
    lng: -122.53415,
    city: "Toutle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 860,
    density: 1.7,
    county_fips: 53015,
    county_name: "Cowlitz",
    county_weights: {
      53015: 100,
    },
    county_names_all: "Cowlitz",
    county_fips_all: 53015,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98650,
    lat: 45.97117,
    lng: -121.52732,
    city: "Trout Lake",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1144,
    density: 5.2,
    county_fips: 53039,
    county_name: "Klickitat",
    county_weights: {
      53039: 100,
    },
    county_names_all: "Klickitat",
    county_fips_all: 53039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98651,
    lat: 45.73419,
    lng: -121.58718,
    city: "Underwood",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1031,
    density: 30,
    county_fips: 53059,
    county_name: "Skamania",
    county_weights: {
      53059: 100,
    },
    county_names_all: "Skamania",
    county_fips_all: 53059,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98660,
    lat: 45.6866,
    lng: -122.73152,
    city: "Vancouver",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12305,
    density: 311.3,
    county_fips: 53011,
    county_name: "Clark",
    county_weights: {
      53011: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 53011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98661,
    lat: 45.63935,
    lng: -122.62586,
    city: "Vancouver",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48485,
    density: 1717.3,
    county_fips: 53011,
    county_name: "Clark",
    county_weights: {
      53011: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 53011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98662,
    lat: 45.68911,
    lng: -122.57742,
    city: "Vancouver",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33798,
    density: 1006.2,
    county_fips: 53011,
    county_name: "Clark",
    county_weights: {
      53011: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 53011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98663,
    lat: 45.65449,
    lng: -122.66228,
    city: "Vancouver",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15406,
    density: 1444.5,
    county_fips: 53011,
    county_name: "Clark",
    county_weights: {
      53011: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 53011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98664,
    lat: 45.61966,
    lng: -122.57738,
    city: "Vancouver",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23601,
    density: 1759.6,
    county_fips: 53011,
    county_name: "Clark",
    county_weights: {
      53011: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 53011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98665,
    lat: 45.68155,
    lng: -122.65417,
    city: "Vancouver",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27260,
    density: 1426.9,
    county_fips: 53011,
    county_name: "Clark",
    county_weights: {
      53011: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 53011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98670,
    lat: 45.86372,
    lng: -121.14599,
    city: "Wahkiacus",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37,
    density: 0.6,
    county_fips: 53039,
    county_name: "Klickitat",
    county_weights: {
      53039: 100,
    },
    county_names_all: "Klickitat",
    county_fips_all: 53039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98671,
    lat: 45.61143,
    lng: -122.24955,
    city: "Washougal",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23116,
    density: 110.1,
    county_fips: 53011,
    county_name: "Clark",
    county_weights: {
      53011: 50.26,
      53059: 49.74,
    },
    county_names_all: "Clark|Skamania",
    county_fips_all: "53011|53059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98672,
    lat: 45.81269,
    lng: -121.47393,
    city: "White Salmon",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7256,
    density: 20.2,
    county_fips: 53039,
    county_name: "Klickitat",
    county_weights: {
      53039: 95.7,
      53059: 4.3,
    },
    county_names_all: "Klickitat|Skamania",
    county_fips_all: "53039|53059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98673,
    lat: 45.67367,
    lng: -120.98129,
    city: "Wishram",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 544,
    density: 12.4,
    county_fips: 53039,
    county_name: "Klickitat",
    county_weights: {
      53039: 100,
    },
    county_names_all: "Klickitat",
    county_fips_all: 53039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98674,
    lat: 45.94672,
    lng: -122.65568,
    city: "Woodland",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14869,
    density: 66.4,
    county_fips: 53015,
    county_name: "Cowlitz",
    county_weights: {
      53011: 37.39,
      53015: 62.61,
    },
    county_names_all: "Cowlitz|Clark",
    county_fips_all: "53015|53011",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98675,
    lat: 45.86349,
    lng: -122.33104,
    city: "Yacolt",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7604,
    density: 18.9,
    county_fips: 53011,
    county_name: "Clark",
    county_weights: {
      53011: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 53011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98682,
    lat: 45.67296,
    lng: -122.48327,
    city: "Vancouver",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 63768,
    density: 863.5,
    county_fips: 53011,
    county_name: "Clark",
    county_weights: {
      53011: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 53011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98683,
    lat: 45.6027,
    lng: -122.50984,
    city: "Vancouver",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31676,
    density: 1685.4,
    county_fips: 53011,
    county_name: "Clark",
    county_weights: {
      53011: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 53011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98684,
    lat: 45.6308,
    lng: -122.51615,
    city: "Vancouver",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31805,
    density: 1733.5,
    county_fips: 53011,
    county_name: "Clark",
    county_weights: {
      53011: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 53011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98685,
    lat: 45.71596,
    lng: -122.69105,
    city: "Vancouver",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29788,
    density: 1124.3,
    county_fips: 53011,
    county_name: "Clark",
    county_weights: {
      53011: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 53011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98686,
    lat: 45.7239,
    lng: -122.62305,
    city: "Vancouver",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20059,
    density: 664.6,
    county_fips: 53011,
    county_name: "Clark",
    county_weights: {
      53011: 100,
    },
    county_names_all: "Clark",
    county_fips_all: 53011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98801,
    lat: 47.43183,
    lng: -120.34356,
    city: "Wenatchee",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43799,
    density: 110.1,
    county_fips: 53007,
    county_name: "Chelan",
    county_weights: {
      53007: 100,
    },
    county_names_all: "Chelan",
    county_fips_all: 53007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98802,
    lat: 47.49308,
    lng: -120.16493,
    city: "East Wenatchee",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31626,
    density: 67.7,
    county_fips: 53017,
    county_name: "Douglas",
    county_weights: {
      53017: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 53017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98811,
    lat: 47.73425,
    lng: -120.37379,
    city: "Ardenvoir",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 187,
    density: 142.7,
    county_fips: 53007,
    county_name: "Chelan",
    county_weights: {
      53007: 100,
    },
    county_names_all: "Chelan",
    county_fips_all: 53007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98812,
    lat: 48.13119,
    lng: -119.80687,
    city: "Brewster",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5227,
    density: 10.4,
    county_fips: 53047,
    county_name: "Okanogan",
    county_weights: {
      53017: 25.06,
      53047: 74.94,
    },
    county_names_all: "Okanogan|Douglas",
    county_fips_all: "53047|53017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98813,
    lat: 48.01107,
    lng: -119.61063,
    city: "Bridgeport",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3012,
    density: 11.6,
    county_fips: 53017,
    county_name: "Douglas",
    county_weights: {
      53017: 76.94,
      53047: 23.06,
    },
    county_names_all: "Douglas|Okanogan",
    county_fips_all: "53017|53047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98814,
    lat: 48.21001,
    lng: -120.22884,
    city: "Carlton",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 739,
    density: 1.9,
    county_fips: 53047,
    county_name: "Okanogan",
    county_weights: {
      53047: 100,
    },
    county_names_all: "Okanogan",
    county_fips_all: 53047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98815,
    lat: 47.52893,
    lng: -120.48459,
    city: "Cashmere",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7210,
    density: 28.7,
    county_fips: 53007,
    county_name: "Chelan",
    county_weights: {
      53007: 100,
    },
    county_names_all: "Chelan",
    county_fips_all: 53007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98816,
    lat: 48.0229,
    lng: -120.34361,
    city: "Chelan",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6005,
    density: 4.7,
    county_fips: 53007,
    county_name: "Chelan",
    county_weights: {
      53007: 98.63,
      53047: 1.37,
    },
    county_names_all: "Chelan|Okanogan",
    county_fips_all: "53007|53047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98817,
    lat: 47.79049,
    lng: -119.99588,
    city: "Chelan Falls",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 185,
    density: 77.2,
    county_fips: 53007,
    county_name: "Chelan",
    county_weights: {
      53007: 100,
    },
    county_names_all: "Chelan",
    county_fips_all: 53007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98819,
    lat: 48.59797,
    lng: -119.82327,
    city: "Conconully",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 233,
    density: 0.6,
    county_fips: 53047,
    county_name: "Okanogan",
    county_weights: {
      53047: 100,
    },
    county_names_all: "Okanogan",
    county_fips_all: 53047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98821,
    lat: 47.55199,
    lng: -120.56155,
    city: "Dryden",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1000,
    density: 292.4,
    county_fips: 53007,
    county_name: "Chelan",
    county_weights: {
      53007: 100,
    },
    county_names_all: "Chelan",
    county_fips_all: 53007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98822,
    lat: 47.86509,
    lng: -120.47694,
    city: "Entiat",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1798,
    density: 1.6,
    county_fips: 53007,
    county_name: "Chelan",
    county_weights: {
      53007: 100,
    },
    county_names_all: "Chelan",
    county_fips_all: 53007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98823,
    lat: 47.33853,
    lng: -119.63536,
    city: "Ephrata",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 11740,
    density: 15.2,
    county_fips: 53025,
    county_name: "Grant",
    county_weights: {
      53017: 26.78,
      53025: 73.22,
    },
    county_names_all: "Grant|Douglas",
    county_fips_all: "53025|53017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98824,
    lat: 47.06857,
    lng: -119.86653,
    city: "George",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 582,
    density: 235.4,
    county_fips: 53025,
    county_name: "Grant",
    county_weights: {
      53025: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 53025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98826,
    lat: 47.78772,
    lng: -120.85454,
    city: "Leavenworth",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7624,
    density: 2.9,
    county_fips: 53007,
    county_name: "Chelan",
    county_weights: {
      53007: 100,
    },
    county_names_all: "Chelan",
    county_fips_all: 53007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98827,
    lat: 48.86359,
    lng: -119.76726,
    city: "Loomis",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 421,
    density: 0.5,
    county_fips: 53047,
    county_name: "Okanogan",
    county_weights: {
      53047: 100,
    },
    county_names_all: "Okanogan",
    county_fips_all: 53047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98828,
    lat: 47.30741,
    lng: -120.1833,
    city: "Malaga",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2046,
    density: 12.9,
    county_fips: 53007,
    county_name: "Chelan",
    county_weights: {
      53007: 91.37,
      53037: 8.63,
    },
    county_names_all: "Chelan|Kittitas",
    county_fips_all: "53007|53037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98829,
    lat: 48.31103,
    lng: -119.80822,
    city: "Malott",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 451,
    density: 2.5,
    county_fips: 53047,
    county_name: "Okanogan",
    county_weights: {
      53047: 100,
    },
    county_names_all: "Okanogan",
    county_fips_all: 53047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98830,
    lat: 47.88702,
    lng: -119.52278,
    city: "Mansfield",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 492,
    density: 0.5,
    county_fips: 53017,
    county_name: "Douglas",
    county_weights: {
      53017: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 53017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98831,
    lat: 47.93451,
    lng: -120.12998,
    city: "Manson",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3529,
    density: 29,
    county_fips: 53007,
    county_name: "Chelan",
    county_weights: {
      53007: 100,
    },
    county_names_all: "Chelan",
    county_fips_all: 53007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98832,
    lat: 47.34669,
    lng: -119.02033,
    city: "Marlin",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 230,
    density: 0.5,
    county_fips: 53025,
    county_name: "Grant",
    county_weights: {
      53001: 1.03,
      53025: 69.47,
      53043: 29.5,
    },
    county_names_all: "Grant|Lincoln|Adams",
    county_fips_all: "53025|53043|53001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98833,
    lat: 48.77199,
    lng: -120.49447,
    city: "Mazama",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 137,
    density: 0.1,
    county_fips: 53047,
    county_name: "Okanogan",
    county_weights: {
      53047: 100,
    },
    county_names_all: "Okanogan",
    county_fips_all: 53047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98834,
    lat: 48.11712,
    lng: -120.08935,
    city: "Methow",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 234,
    density: 1.2,
    county_fips: 53047,
    county_name: "Okanogan",
    county_weights: {
      53047: 100,
    },
    county_names_all: "Okanogan",
    county_fips_all: 53047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98836,
    lat: 47.47615,
    lng: -120.42909,
    city: "Monitor",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 953,
    density: 51.4,
    county_fips: 53007,
    county_name: "Chelan",
    county_weights: {
      53007: 100,
    },
    county_names_all: "Chelan",
    county_fips_all: 53007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98837,
    lat: 47.14809,
    lng: -119.3163,
    city: "Moses Lake",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43952,
    density: 34.9,
    county_fips: 53025,
    county_name: "Grant",
    county_weights: {
      53025: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 53025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98840,
    lat: 48.27395,
    lng: -119.51838,
    city: "Okanogan",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4571,
    density: 3.3,
    county_fips: 53047,
    county_name: "Okanogan",
    county_weights: {
      53047: 100,
    },
    county_names_all: "Okanogan",
    county_fips_all: 53047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98841,
    lat: 48.37602,
    lng: -119.29817,
    city: "Omak",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9335,
    density: 12.2,
    county_fips: 53047,
    county_name: "Okanogan",
    county_weights: {
      53047: 100,
    },
    county_names_all: "Okanogan",
    county_fips_all: 53047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98843,
    lat: 47.73688,
    lng: -120.08618,
    city: "Orondo",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2185,
    density: 12.6,
    county_fips: 53017,
    county_name: "Douglas",
    county_weights: {
      53017: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 53017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98844,
    lat: 48.91618,
    lng: -119.24767,
    city: "Oroville",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4428,
    density: 5.1,
    county_fips: 53047,
    county_name: "Okanogan",
    county_weights: {
      53047: 100,
    },
    county_names_all: "Okanogan",
    county_fips_all: 53047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98845,
    lat: 47.43039,
    lng: -119.90923,
    city: "Palisades",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 266,
    density: 1.6,
    county_fips: 53017,
    county_name: "Douglas",
    county_weights: {
      53017: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 53017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98846,
    lat: 48.03481,
    lng: -119.97528,
    city: "Pateros",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1317,
    density: 6,
    county_fips: 53047,
    county_name: "Okanogan",
    county_weights: {
      53007: 4.57,
      53047: 95.43,
    },
    county_names_all: "Okanogan|Chelan",
    county_fips_all: "53047|53007",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98847,
    lat: 47.42236,
    lng: -120.62152,
    city: "Peshastin",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2295,
    density: 4.8,
    county_fips: 53007,
    county_name: "Chelan",
    county_weights: {
      53007: 100,
    },
    county_names_all: "Chelan",
    county_fips_all: 53007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98848,
    lat: 47.17182,
    lng: -119.84109,
    city: "Quincy",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12427,
    density: 10.5,
    county_fips: 53025,
    county_name: "Grant",
    county_weights: {
      53017: 2.28,
      53025: 97.72,
    },
    county_names_all: "Grant|Douglas",
    county_fips_all: "53025|53017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98849,
    lat: 48.54821,
    lng: -119.40789,
    city: "Riverside",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1216,
    density: 2.7,
    county_fips: 53047,
    county_name: "Okanogan",
    county_weights: {
      53047: 100,
    },
    county_names_all: "Okanogan",
    county_fips_all: 53047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98850,
    lat: 47.40048,
    lng: -120.03459,
    city: "Rock Island",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1688,
    density: 8.5,
    county_fips: 53017,
    county_name: "Douglas",
    county_weights: {
      53017: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 53017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98851,
    lat: 47.42002,
    lng: -119.43462,
    city: "Soap Lake",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4783,
    density: 12.6,
    county_fips: 53025,
    county_name: "Grant",
    county_weights: {
      53025: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 53025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98852,
    lat: 48.32169,
    lng: -120.63881,
    city: "Stehekin",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20,
    density: 0.1,
    county_fips: 53007,
    county_name: "Chelan",
    county_weights: {
      53007: 100,
    },
    county_names_all: "Chelan",
    county_fips_all: 53007,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98853,
    lat: 47.44655,
    lng: -119.28061,
    city: "Stratford",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14,
    density: 0.3,
    county_fips: 53025,
    county_name: "Grant",
    county_weights: {
      53025: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 53025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98855,
    lat: 48.67641,
    lng: -119.25634,
    city: "Tonasket",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6033,
    density: 3.7,
    county_fips: 53047,
    county_name: "Okanogan",
    county_weights: {
      53047: 100,
    },
    county_names_all: "Okanogan",
    county_fips_all: 53047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98856,
    lat: 48.37065,
    lng: -120.22762,
    city: "Twisp",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2612,
    density: 2.3,
    county_fips: 53047,
    county_name: "Okanogan",
    county_weights: {
      53047: 100,
    },
    county_names_all: "Okanogan",
    county_fips_all: 53047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98857,
    lat: 46.98656,
    lng: -119.03698,
    city: "Warden",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3534,
    density: 8.1,
    county_fips: 53025,
    county_name: "Grant",
    county_weights: {
      53001: 31.01,
      53025: 68.99,
    },
    county_names_all: "Grant|Adams",
    county_fips_all: "53025|53001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98858,
    lat: 47.67938,
    lng: -119.87974,
    city: "Waterville",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1838,
    density: 1.9,
    county_fips: 53017,
    county_name: "Douglas",
    county_weights: {
      53017: 100,
    },
    county_names_all: "Douglas",
    county_fips_all: 53017,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98859,
    lat: 48.81181,
    lng: -118.90871,
    city: "Wauconda",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 137,
    density: 0.4,
    county_fips: 53047,
    county_name: "Okanogan",
    county_weights: {
      53047: 100,
    },
    county_names_all: "Okanogan",
    county_fips_all: 53047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98860,
    lat: 47.46899,
    lng: -119.12391,
    city: "Wilson Creek",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 214,
    density: 0.8,
    county_fips: 53025,
    county_name: "Grant",
    county_weights: {
      53025: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 53025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98862,
    lat: 48.58491,
    lng: -120.22792,
    city: "Winthrop",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2605,
    density: 2.1,
    county_fips: 53047,
    county_name: "Okanogan",
    county_weights: {
      53047: 100,
    },
    county_names_all: "Okanogan",
    county_fips_all: 53047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98901,
    lat: 46.66935,
    lng: -120.33816,
    city: "Yakima",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31425,
    density: 65.8,
    county_fips: 53077,
    county_name: "Yakima",
    county_weights: {
      53037: 8.76,
      53077: 91.24,
    },
    county_names_all: "Yakima|Kittitas",
    county_fips_all: "53077|53037",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98902,
    lat: 46.59778,
    lng: -120.53393,
    city: "Yakima",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 46728,
    density: 1938.7,
    county_fips: 53077,
    county_name: "Yakima",
    county_weights: {
      53077: 100,
    },
    county_names_all: "Yakima",
    county_fips_all: 53077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98903,
    lat: 46.54807,
    lng: -120.90226,
    city: "Yakima",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15404,
    density: 30.9,
    county_fips: 53077,
    county_name: "Yakima",
    county_weights: {
      53077: 100,
    },
    county_names_all: "Yakima",
    county_fips_all: 53077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98908,
    lat: 46.62345,
    lng: -120.70582,
    city: "Yakima",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37004,
    density: 135.2,
    county_fips: 53077,
    county_name: "Yakima",
    county_weights: {
      53077: 100,
    },
    county_names_all: "Yakima",
    county_fips_all: 53077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98921,
    lat: 46.43082,
    lng: -120.31719,
    city: "Buena",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 158,
    density: 345.9,
    county_fips: 53077,
    county_name: "Yakima",
    county_weights: {
      53077: 100,
    },
    county_names_all: "Yakima",
    county_fips_all: 53077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98922,
    lat: 47.25056,
    lng: -120.8821,
    city: "Cle Elum",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7630,
    density: 7.1,
    county_fips: 53037,
    county_name: "Kittitas",
    county_weights: {
      53037: 100,
    },
    county_names_all: "Kittitas",
    county_fips_all: 53037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98923,
    lat: 46.66608,
    lng: -120.71723,
    city: "Cowiche",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1017,
    density: 67,
    county_fips: 53077,
    county_name: "Yakima",
    county_weights: {
      53077: 100,
    },
    county_names_all: "Yakima",
    county_fips_all: 53077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98925,
    lat: 47.28793,
    lng: -121.28089,
    city: "Easton",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 477,
    density: 1.5,
    county_fips: 53037,
    county_name: "Kittitas",
    county_weights: {
      53037: 100,
    },
    county_names_all: "Kittitas",
    county_fips_all: 53037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98926,
    lat: 46.99054,
    lng: -120.34902,
    city: "Ellensburg",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 34893,
    density: 14.4,
    county_fips: 53037,
    county_name: "Kittitas",
    county_weights: {
      53037: 100,
    },
    county_names_all: "Kittitas",
    county_fips_all: 53037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98930,
    lat: 46.26903,
    lng: -119.8953,
    city: "Grandview",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15263,
    density: 131.4,
    county_fips: 53077,
    county_name: "Yakima",
    county_weights: {
      53005: 37.63,
      53077: 62.37,
    },
    county_names_all: "Yakima|Benton",
    county_fips_all: "53077|53005",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98932,
    lat: 46.33217,
    lng: -120.16091,
    city: "Granger",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5442,
    density: 61.6,
    county_fips: 53077,
    county_name: "Yakima",
    county_weights: {
      53077: 100,
    },
    county_names_all: "Yakima",
    county_fips_all: 53077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98933,
    lat: 46.4029,
    lng: -120.63756,
    city: "Harrah",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1018,
    density: 14.1,
    county_fips: 53077,
    county_name: "Yakima",
    county_weights: {
      53077: 100,
    },
    county_names_all: "Yakima",
    county_fips_all: 53077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98934,
    lat: 46.98067,
    lng: -120.41941,
    city: "Kittitas",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 995,
    density: 337.4,
    county_fips: 53037,
    county_name: "Kittitas",
    county_weights: {
      53037: 100,
    },
    county_names_all: "Kittitas",
    county_fips_all: 53037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98935,
    lat: 46.13417,
    lng: -120.06877,
    city: "Mabton",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4398,
    density: 6.8,
    county_fips: 53077,
    county_name: "Yakima",
    county_weights: {
      53077: 100,
    },
    county_names_all: "Yakima",
    county_fips_all: 53077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98936,
    lat: 46.53597,
    lng: -120.15391,
    city: "Moxee",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6981,
    density: 19.4,
    county_fips: 53077,
    county_name: "Yakima",
    county_weights: {
      53077: 100,
    },
    county_names_all: "Yakima",
    county_fips_all: 53077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98937,
    lat: 46.77523,
    lng: -121.17808,
    city: "Naches",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4354,
    density: 1.9,
    county_fips: 53077,
    county_name: "Yakima",
    county_weights: {
      53077: 100,
    },
    county_names_all: "Yakima",
    county_fips_all: 53077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98938,
    lat: 46.38842,
    lng: -120.09662,
    city: "Outlook",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2178,
    density: 22.6,
    county_fips: 53077,
    county_name: "Yakima",
    county_weights: {
      53077: 100,
    },
    county_names_all: "Yakima",
    county_fips_all: 53077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98939,
    lat: 46.50105,
    lng: -120.47077,
    city: "Parker",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 67,
    density: 42.1,
    county_fips: 53077,
    county_name: "Yakima",
    county_weights: {
      53077: 100,
    },
    county_names_all: "Yakima",
    county_fips_all: 53077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98940,
    lat: 47.39682,
    lng: -121.06683,
    city: "Ronald",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 445,
    density: 1.1,
    county_fips: 53037,
    county_name: "Kittitas",
    county_weights: {
      53037: 100,
    },
    county_names_all: "Kittitas",
    county_fips_all: 53037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98941,
    lat: 47.22464,
    lng: -121.00021,
    city: "Roslyn",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 608,
    density: 148.1,
    county_fips: 53037,
    county_name: "Kittitas",
    county_weights: {
      53037: 100,
    },
    county_names_all: "Kittitas",
    county_fips_all: 53037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98942,
    lat: 46.80322,
    lng: -120.67454,
    city: "Selah",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17454,
    density: 36.8,
    county_fips: 53077,
    county_name: "Yakima",
    county_weights: {
      53077: 100,
    },
    county_names_all: "Yakima",
    county_fips_all: 53077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98943,
    lat: 47.18461,
    lng: -120.96089,
    city: "South Cle Elum",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1032,
    density: 478.6,
    county_fips: 53037,
    county_name: "Kittitas",
    county_weights: {
      53037: 100,
    },
    county_names_all: "Kittitas",
    county_fips_all: 53037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98944,
    lat: 46.49998,
    lng: -119.66533,
    city: "Sunnyside",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24949,
    density: 17.7,
    county_fips: 53005,
    county_name: "Benton",
    county_weights: {
      53005: 73.37,
      53077: 26.63,
    },
    county_names_all: "Benton|Yakima",
    county_fips_all: "53005|53077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98946,
    lat: 47.06515,
    lng: -120.76512,
    city: "Thorp",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 454,
    density: 3.8,
    county_fips: 53037,
    county_name: "Kittitas",
    county_weights: {
      53037: 100,
    },
    county_names_all: "Kittitas",
    county_fips_all: 53037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98947,
    lat: 46.68759,
    lng: -120.80916,
    city: "Tieton",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3266,
    density: 27.5,
    county_fips: 53077,
    county_name: "Yakima",
    county_weights: {
      53077: 100,
    },
    county_names_all: "Yakima",
    county_fips_all: 53077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98948,
    lat: 46.23067,
    lng: -120.37168,
    city: "Toppenish",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12601,
    density: 14.5,
    county_fips: 53077,
    county_name: "Yakima",
    county_weights: {
      53077: 100,
    },
    county_names_all: "Yakima",
    county_fips_all: 53077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98950,
    lat: 46.84642,
    lng: -119.9877,
    city: "Vantage",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 33,
    density: 0.3,
    county_fips: 53037,
    county_name: "Kittitas",
    county_weights: {
      53037: 100,
    },
    county_names_all: "Kittitas",
    county_fips_all: 53037,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98951,
    lat: 46.46046,
    lng: -120.51551,
    city: "Wapato",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13473,
    density: 34.9,
    county_fips: 53077,
    county_name: "Yakima",
    county_weights: {
      53077: 100,
    },
    county_names_all: "Yakima",
    county_fips_all: 53077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98952,
    lat: 46.34991,
    lng: -120.81561,
    city: "White Swan",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2125,
    density: 2.1,
    county_fips: 53077,
    county_name: "Yakima",
    county_weights: {
      53077: 100,
    },
    county_names_all: "Yakima",
    county_fips_all: 53077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 98953,
    lat: 46.44149,
    lng: -120.23284,
    city: "Zillah",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6461,
    density: 41.2,
    county_fips: 53077,
    county_name: "Yakima",
    county_weights: {
      53077: 100,
    },
    county_names_all: "Yakima",
    county_fips_all: 53077,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99001,
    lat: 47.63874,
    lng: -117.58582,
    city: "Airway Heights",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7330,
    density: 355.9,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99003,
    lat: 47.91997,
    lng: -117.27608,
    city: "Chattaroy",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4110,
    density: 20.8,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99004,
    lat: 47.40869,
    lng: -117.63575,
    city: "Cheney",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21189,
    density: 24.5,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 96.27,
      53075: 3.73,
    },
    county_names_all: "Spokane|Whitman",
    county_fips_all: "53063|53075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99005,
    lat: 47.84405,
    lng: -117.36346,
    city: "Colbert",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9770,
    density: 95.3,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99006,
    lat: 47.95208,
    lng: -117.51016,
    city: "Deer Park",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13397,
    density: 31.5,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53051: 4.81,
      53063: 54.47,
      53065: 40.72,
    },
    county_names_all: "Spokane|Stevens|Pend Oreille",
    county_fips_all: "53063|53065|53051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99008,
    lat: 47.50449,
    lng: -117.93533,
    city: "Edwall",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 470,
    density: 1.2,
    county_fips: 53043,
    county_name: "Lincoln",
    county_weights: {
      53043: 94.64,
      53063: 5.36,
    },
    county_names_all: "Lincoln|Spokane",
    county_fips_all: "53043|53063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99009,
    lat: 48.0253,
    lng: -117.24993,
    city: "Elk",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4423,
    density: 21.1,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53051: 34.41,
      53063: 65.59,
    },
    county_names_all: "Spokane|Pend Oreille",
    county_fips_all: "53063|53051",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99011,
    lat: 47.61867,
    lng: -117.64839,
    city: "Fairchild Air Force Base",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3464,
    density: 202,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99012,
    lat: 47.38137,
    lng: -117.19145,
    city: "Fairfield",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1006,
    density: 4.2,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99013,
    lat: 47.88498,
    lng: -117.83495,
    city: "Ford",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1856,
    density: 8.2,
    county_fips: 53065,
    county_name: "Stevens",
    county_weights: {
      53043: 14.25,
      53063: 15.56,
      53065: 70.19,
    },
    county_names_all: "Stevens|Spokane|Lincoln",
    county_fips_all: "53065|53063|53043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99014,
    lat: 47.56111,
    lng: -117.59666,
    city: "Four Lakes",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99016,
    lat: 47.6217,
    lng: -117.14623,
    city: "Greenacres",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15437,
    density: 242.1,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99017,
    lat: 47.1829,
    lng: -117.87611,
    city: "Lamont",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 131,
    density: 0.6,
    county_fips: 53075,
    county_name: "Whitman",
    county_weights: {
      53075: 100,
    },
    county_names_all: "Whitman",
    county_fips_all: 53075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99018,
    lat: 47.2917,
    lng: -117.15212,
    city: "Latah",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 279,
    density: 3.2,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99019,
    lat: 47.64222,
    lng: -117.07688,
    city: "Liberty Lake",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12244,
    density: 212.1,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99020,
    lat: 47.56314,
    lng: -117.49702,
    city: "Marshall",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99021,
    lat: 47.84951,
    lng: -117.18721,
    city: "Mead",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9441,
    density: 45.4,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99022,
    lat: 47.60084,
    lng: -117.70869,
    city: "Medical Lake",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8718,
    density: 49.3,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99023,
    lat: 47.56474,
    lng: -117.14466,
    city: "Mica",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 641,
    density: 13.6,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99025,
    lat: 47.78963,
    lng: -117.08751,
    city: "Newman Lake",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5510,
    density: 46.5,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99026,
    lat: 47.80375,
    lng: -117.625,
    city: "Nine Mile Falls",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8714,
    density: 53.3,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 75.63,
      53065: 24.37,
    },
    county_names_all: "Spokane|Stevens",
    county_fips_all: "53063|53065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99027,
    lat: 47.71107,
    lng: -117.12795,
    city: "Otis Orchards",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5985,
    density: 149.3,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99029,
    lat: 47.70639,
    lng: -117.82406,
    city: "Reardan",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1009,
    density: 3.5,
    county_fips: 53043,
    county_name: "Lincoln",
    county_weights: {
      53043: 54.58,
      53063: 45.42,
    },
    county_names_all: "Lincoln|Spokane",
    county_fips_all: "53043|53063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99030,
    lat: 47.47782,
    lng: -117.11302,
    city: "Rockford",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 905,
    density: 4.8,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99031,
    lat: 47.41973,
    lng: -117.35991,
    city: "Spangle",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1270,
    density: 6.4,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99032,
    lat: 47.32405,
    lng: -118.04613,
    city: "Sprague",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 698,
    density: 1.1,
    county_fips: 53043,
    county_name: "Lincoln",
    county_weights: {
      53001: 12.51,
      53043: 85.86,
      53063: 1.63,
    },
    county_names_all: "Lincoln|Adams|Spokane",
    county_fips_all: "53043|53001|53063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99033,
    lat: 47.23061,
    lng: -117.09782,
    city: "Tekoa",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 927,
    density: 9,
    county_fips: 53075,
    county_name: "Whitman",
    county_weights: {
      16009: 1.9,
      53063: 16.13,
      53075: 81.97,
    },
    county_names_all: "Whitman|Spokane|Benewah",
    county_fips_all: "53075|53063|16009",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99034,
    lat: 47.8862,
    lng: -117.76245,
    city: "Tumtum",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 88,
    density: 1.5,
    county_fips: 53065,
    county_name: "Stevens",
    county_weights: {
      53065: 100,
    },
    county_names_all: "Stevens",
    county_fips_all: 53065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99036,
    lat: 47.52005,
    lng: -117.27197,
    city: "Valleyford",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1794,
    density: 18.1,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99037,
    lat: 47.63734,
    lng: -117.19756,
    city: "Veradale",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14589,
    density: 895.6,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99039,
    lat: 47.33808,
    lng: -117.23131,
    city: "Waverly",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 135,
    density: 127.5,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99040,
    lat: 47.90355,
    lng: -117.99885,
    city: "Wellpinit",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 784,
    density: 2.8,
    county_fips: 53065,
    county_name: "Stevens",
    county_weights: {
      53065: 100,
    },
    county_names_all: "Stevens",
    county_fips_all: 53065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99101,
    lat: 48.31889,
    lng: -117.9483,
    city: "Addy",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1419,
    density: 5.7,
    county_fips: 53065,
    county_name: "Stevens",
    county_weights: {
      53065: 100,
    },
    county_names_all: "Stevens",
    county_fips_all: 53065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99102,
    lat: 46.79218,
    lng: -117.25029,
    city: "Albion",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 473,
    density: 535.9,
    county_fips: 53075,
    county_name: "Whitman",
    county_weights: {
      53075: 100,
    },
    county_names_all: "Whitman",
    county_fips_all: 53075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99103,
    lat: 47.73041,
    lng: -118.93171,
    city: "Almira",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 489,
    density: 0.8,
    county_fips: 53043,
    county_name: "Lincoln",
    county_weights: {
      53025: 23.86,
      53043: 76.14,
    },
    county_names_all: "Lincoln|Grant",
    county_fips_all: "53043|53025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99105,
    lat: 46.9213,
    lng: -118.08264,
    city: "Benge",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37,
    density: 0.1,
    county_fips: 53001,
    county_name: "Adams",
    county_weights: {
      53001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 53001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99109,
    lat: 48.29787,
    lng: -117.69852,
    city: "Chewelah",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4948,
    density: 6.1,
    county_fips: 53065,
    county_name: "Stevens",
    county_weights: {
      53065: 100,
    },
    county_names_all: "Stevens",
    county_fips_all: 53065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99110,
    lat: 48.0083,
    lng: -117.58112,
    city: "Clayton",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1724,
    density: 17.2,
    county_fips: 53065,
    county_name: "Stevens",
    county_weights: {
      53063: 7,
      53065: 93,
    },
    county_names_all: "Stevens|Spokane",
    county_fips_all: "53065|53063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99111,
    lat: 46.86281,
    lng: -117.44132,
    city: "Colfax",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4202,
    density: 5.3,
    county_fips: 53075,
    county_name: "Whitman",
    county_weights: {
      53075: 100,
    },
    county_names_all: "Whitman",
    county_fips_all: 53075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99113,
    lat: 46.58628,
    lng: -117.1935,
    city: "Colton",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 600,
    density: 2.4,
    county_fips: 53075,
    county_name: "Whitman",
    county_weights: {
      53075: 100,
    },
    county_names_all: "Whitman",
    county_fips_all: 53075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99114,
    lat: 48.66067,
    lng: -117.74333,
    city: "Colville",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12866,
    density: 6.9,
    county_fips: 53065,
    county_name: "Stevens",
    county_weights: {
      53065: 100,
    },
    county_names_all: "Stevens",
    county_fips_all: 53065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99115,
    lat: 47.67326,
    lng: -119.38965,
    city: "Coulee City",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1298,
    density: 1.2,
    county_fips: 53017,
    county_name: "Douglas",
    county_weights: {
      53017: 65.51,
      53025: 34.49,
    },
    county_names_all: "Douglas|Grant",
    county_fips_all: "53017|53025",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99116,
    lat: 48.01429,
    lng: -118.93063,
    city: "Coulee Dam",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1672,
    density: 13.7,
    county_fips: 53047,
    county_name: "Okanogan",
    county_weights: {
      53017: 0.31,
      53025: 2.75,
      53047: 96.94,
    },
    county_names_all: "Okanogan|Grant|Douglas",
    county_fips_all: "53047|53025|53017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99117,
    lat: 47.72818,
    lng: -118.50108,
    city: "Creston",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 530,
    density: 1.3,
    county_fips: 53043,
    county_name: "Lincoln",
    county_weights: {
      53043: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 53043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99118,
    lat: 48.89746,
    lng: -118.63797,
    city: "Curlew",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 794,
    density: 1.5,
    county_fips: 53019,
    county_name: "Ferry",
    county_weights: {
      53019: 100,
    },
    county_names_all: "Ferry",
    county_fips_all: 53019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99119,
    lat: 48.50946,
    lng: -117.29994,
    city: "Cusick",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1294,
    density: 1.3,
    county_fips: 53051,
    county_name: "Pend Oreille",
    county_weights: {
      53051: 100,
    },
    county_names_all: "Pend Oreille",
    county_fips_all: 53051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99121,
    lat: 48.94382,
    lng: -118.45568,
    city: "Danville",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 327,
    density: 2.4,
    county_fips: 53019,
    county_name: "Ferry",
    county_weights: {
      53019: 100,
    },
    county_names_all: "Ferry",
    county_fips_all: 53019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99122,
    lat: 47.67615,
    lng: -118.21774,
    city: "Davenport",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4338,
    density: 2.8,
    county_fips: 53043,
    county_name: "Lincoln",
    county_weights: {
      53043: 98.25,
      53065: 1.75,
    },
    county_names_all: "Lincoln|Stevens",
    county_fips_all: "53043|53065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99123,
    lat: 47.89738,
    lng: -119.04017,
    city: "Electric City",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 992,
    density: 19.1,
    county_fips: 53025,
    county_name: "Grant",
    county_weights: {
      53025: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 53025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99124,
    lat: 48.00284,
    lng: -118.95243,
    city: "Elmer City",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 277,
    density: 306.8,
    county_fips: 53047,
    county_name: "Okanogan",
    county_weights: {
      53017: 0.11,
      53047: 99.89,
    },
    county_names_all: "Okanogan|Douglas",
    county_fips_all: "53047|53017",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99125,
    lat: 46.95223,
    lng: -117.78556,
    city: "Endicott",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 603,
    density: 1.2,
    county_fips: 53075,
    county_name: "Whitman",
    county_weights: {
      53075: 100,
    },
    county_names_all: "Whitman",
    county_fips_all: 53075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99126,
    lat: 48.73574,
    lng: -117.97447,
    city: "Evans",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1019,
    density: 7.8,
    county_fips: 53065,
    county_name: "Stevens",
    county_weights: {
      53065: 100,
    },
    county_names_all: "Stevens",
    county_fips_all: 53065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99128,
    lat: 47.10045,
    lng: -117.08523,
    city: "Farmington",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 371,
    density: 2.4,
    county_fips: 53075,
    county_name: "Whitman",
    county_weights: {
      16057: 7.47,
      53075: 92.53,
    },
    county_names_all: "Whitman|Latah",
    county_fips_all: "53075|16057",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99129,
    lat: 48.00281,
    lng: -118.18342,
    city: "Fruitland",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 671,
    density: 1.8,
    county_fips: 53065,
    county_name: "Stevens",
    county_weights: {
      53065: 100,
    },
    county_names_all: "Stevens",
    county_fips_all: 53065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99130,
    lat: 46.99917,
    lng: -117.18556,
    city: "Garfield",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 855,
    density: 4.1,
    county_fips: 53075,
    county_name: "Whitman",
    county_weights: {
      53075: 100,
    },
    county_names_all: "Whitman",
    county_fips_all: 53075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99131,
    lat: 48.29511,
    lng: -118.11731,
    city: "Gifford",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 218,
    density: 4.8,
    county_fips: 53065,
    county_name: "Stevens",
    county_weights: {
      53065: 100,
    },
    county_names_all: "Stevens",
    county_fips_all: 53065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99133,
    lat: 48.0067,
    lng: -119.10613,
    city: "Grand Coulee",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1674,
    density: 3.5,
    county_fips: 53017,
    county_name: "Douglas",
    county_weights: {
      53017: 74.52,
      53025: 16.26,
      53043: 9.22,
    },
    county_names_all: "Douglas|Grant|Lincoln",
    county_fips_all: "53017|53025|53043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99134,
    lat: 47.43793,
    lng: -118.32347,
    city: "Harrington",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 531,
    density: 1.4,
    county_fips: 53043,
    county_name: "Lincoln",
    county_weights: {
      53043: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 53043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99135,
    lat: 47.65658,
    lng: -119.09608,
    city: "Hartline",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 374,
    density: 0.8,
    county_fips: 53025,
    county_name: "Grant",
    county_weights: {
      53025: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 53025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99136,
    lat: 46.6747,
    lng: -117.94889,
    city: "Hay",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20,
    density: 0.4,
    county_fips: 53075,
    county_name: "Whitman",
    county_weights: {
      53075: 100,
    },
    county_names_all: "Whitman",
    county_fips_all: 53075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99137,
    lat: 48.1659,
    lng: -118.09992,
    city: "Hunters",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 357,
    density: 1.5,
    county_fips: 53065,
    county_name: "Stevens",
    county_weights: {
      53065: 100,
    },
    county_names_all: "Stevens",
    county_fips_all: 53065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99138,
    lat: 48.23093,
    lng: -118.38876,
    city: "Inchelium",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1084,
    density: 0.7,
    county_fips: 53019,
    county_name: "Ferry",
    county_weights: {
      53019: 100,
    },
    county_names_all: "Ferry",
    county_fips_all: 53019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99139,
    lat: 48.73161,
    lng: -117.31371,
    city: "Ione",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1339,
    density: 1.6,
    county_fips: 53051,
    county_name: "Pend Oreille",
    county_weights: {
      53051: 100,
    },
    county_names_all: "Pend Oreille",
    county_fips_all: 53051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99140,
    lat: 48.135,
    lng: -118.68722,
    city: "Keller",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 489,
    density: 0.4,
    county_fips: 53019,
    county_name: "Ferry",
    county_weights: {
      53019: 100,
    },
    county_names_all: "Ferry",
    county_fips_all: 53019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99141,
    lat: 48.72571,
    lng: -118.17509,
    city: "Kettle Falls",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 5898,
    density: 3.6,
    county_fips: 53019,
    county_name: "Ferry",
    county_weights: {
      53019: 51.91,
      53065: 48.09,
    },
    county_names_all: "Ferry|Stevens",
    county_fips_all: "53019|53065",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99143,
    lat: 46.74627,
    lng: -117.85869,
    city: "Lacrosse",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 668,
    density: 0.8,
    county_fips: 53075,
    county_name: "Whitman",
    county_weights: {
      53075: 100,
    },
    county_names_all: "Whitman",
    county_fips_all: 53075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99144,
    lat: 47.3681,
    lng: -118.49041,
    city: "Lamona",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16,
    density: 0.1,
    county_fips: 53043,
    county_name: "Lincoln",
    county_weights: {
      53043: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 53043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99146,
    lat: 48.95766,
    lng: -118.29768,
    city: "Laurier",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25,
    density: 0.2,
    county_fips: 53019,
    county_name: "Ferry",
    county_weights: {
      53019: 100,
    },
    county_names_all: "Ferry",
    county_fips_all: 53019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99147,
    lat: 47.83604,
    lng: -118.43675,
    city: "Lincoln",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 159,
    density: 7,
    county_fips: 53043,
    county_name: "Lincoln",
    county_weights: {
      53043: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 53043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99148,
    lat: 48.10874,
    lng: -117.57514,
    city: "Loon Lake",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2057,
    density: 11.2,
    county_fips: 53065,
    county_name: "Stevens",
    county_weights: {
      53065: 100,
    },
    county_names_all: "Stevens",
    county_fips_all: 53065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99149,
    lat: 47.225,
    lng: -117.46794,
    city: "Malden",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 223,
    density: 44.9,
    county_fips: 53075,
    county_name: "Whitman",
    county_weights: {
      53075: 100,
    },
    county_names_all: "Whitman",
    county_fips_all: 53075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99150,
    lat: 48.80622,
    lng: -118.61071,
    city: "Malo",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 310,
    density: 3.7,
    county_fips: 53019,
    county_name: "Ferry",
    county_weights: {
      53019: 100,
    },
    county_names_all: "Ferry",
    county_fips_all: 53019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99151,
    lat: 48.66443,
    lng: -118.06125,
    city: "Marcus",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 176,
    density: 371.9,
    county_fips: 53065,
    county_name: "Stevens",
    county_weights: {
      53065: 100,
    },
    county_names_all: "Stevens",
    county_fips_all: 53065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99152,
    lat: 48.85066,
    lng: -117.39748,
    city: "Metaline",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 122,
    density: 10.7,
    county_fips: 53051,
    county_name: "Pend Oreille",
    county_weights: {
      53051: 100,
    },
    county_names_all: "Pend Oreille",
    county_fips_all: 53051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99153,
    lat: 48.90951,
    lng: -117.25229,
    city: "Metaline Falls",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 422,
    density: 0.7,
    county_fips: 53051,
    county_name: "Pend Oreille",
    county_weights: {
      53051: 100,
    },
    county_names_all: "Pend Oreille",
    county_fips_all: 53051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99154,
    lat: 47.39132,
    lng: -118.35576,
    city: "Mohler",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37,
    density: 0.9,
    county_fips: 53043,
    county_name: "Lincoln",
    county_weights: {
      53043: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 53043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99155,
    lat: 48.27737,
    lng: -118.9618,
    city: "Nespelem",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1231,
    density: 1.6,
    county_fips: 53047,
    county_name: "Okanogan",
    county_weights: {
      53047: 100,
    },
    county_names_all: "Okanogan",
    county_fips_all: 53047,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99156,
    lat: 48.16211,
    lng: -117.18826,
    city: "Newport",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8755,
    density: 12.4,
    county_fips: 53051,
    county_name: "Pend Oreille",
    county_weights: {
      53051: 89.64,
      53063: 10.36,
    },
    county_names_all: "Pend Oreille|Spokane",
    county_fips_all: "53051|53063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99157,
    lat: 48.93007,
    lng: -117.81753,
    city: "Northport",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 589,
    density: 3.5,
    county_fips: 53065,
    county_name: "Stevens",
    county_weights: {
      53065: 100,
    },
    county_names_all: "Stevens",
    county_fips_all: 53065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99158,
    lat: 47.13305,
    lng: -117.24008,
    city: "Oakesdale",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 585,
    density: 2.4,
    county_fips: 53075,
    county_name: "Whitman",
    county_weights: {
      53075: 100,
    },
    county_names_all: "Whitman",
    county_fips_all: 53075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99159,
    lat: 47.32872,
    lng: -118.74338,
    city: "Odessa",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1403,
    density: 1.1,
    county_fips: 53043,
    county_name: "Lincoln",
    county_weights: {
      53001: 32.05,
      53043: 67.95,
    },
    county_names_all: "Lincoln|Adams",
    county_fips_all: "53043|53001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99160,
    lat: 48.86895,
    lng: -118.30122,
    city: "Orient",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 113,
    density: 0.9,
    county_fips: 53019,
    county_name: "Ferry",
    county_weights: {
      53019: 100,
    },
    county_names_all: "Ferry",
    county_fips_all: 53019,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99161,
    lat: 46.89496,
    lng: -117.13169,
    city: "Palouse",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1278,
    density: 6.4,
    county_fips: 53075,
    county_name: "Whitman",
    county_weights: {
      53075: 100,
    },
    county_names_all: "Whitman",
    county_fips_all: 53075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99163,
    lat: 46.72798,
    lng: -117.21654,
    city: "Pullman",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36052,
    density: 66.1,
    county_fips: 53075,
    county_name: "Whitman",
    county_weights: {
      53075: 100,
    },
    county_names_all: "Whitman",
    county_fips_all: 53075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99166,
    lat: 48.61033,
    lng: -118.6715,
    city: "Republic",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3022,
    density: 2.4,
    county_fips: 53019,
    county_name: "Ferry",
    county_weights: {
      53019: 98.46,
      53047: 1.54,
    },
    county_names_all: "Ferry|Okanogan",
    county_fips_all: "53019|53047",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99167,
    lat: 48.41307,
    lng: -118.11733,
    city: "Rice",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 710,
    density: 4,
    county_fips: 53065,
    county_name: "Stevens",
    county_weights: {
      53065: 100,
    },
    county_names_all: "Stevens",
    county_fips_all: 53065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99169,
    lat: 47.11875,
    lng: -118.37424,
    city: "Ritzville",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2663,
    density: 1.4,
    county_fips: 53001,
    county_name: "Adams",
    county_weights: {
      53001: 92.71,
      53043: 7.29,
    },
    county_names_all: "Adams|Lincoln",
    county_fips_all: "53001|53043",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99170,
    lat: 47.25132,
    lng: -117.40203,
    city: "Rosalia",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1022,
    density: 2.3,
    county_fips: 53075,
    county_name: "Whitman",
    county_weights: {
      53063: 42.9,
      53075: 57.1,
    },
    county_names_all: "Whitman|Spokane",
    county_fips_all: "53075|53063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99171,
    lat: 47.10485,
    lng: -117.6495,
    city: "Saint John",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1018,
    density: 1.6,
    county_fips: 53075,
    county_name: "Whitman",
    county_weights: {
      53075: 100,
    },
    county_names_all: "Whitman",
    county_fips_all: 53075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99173,
    lat: 48.03702,
    lng: -117.85708,
    city: "Springdale",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1577,
    density: 4.3,
    county_fips: 53065,
    county_name: "Stevens",
    county_weights: {
      53065: 100,
    },
    county_names_all: "Stevens",
    county_fips_all: 53065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99174,
    lat: 47.00719,
    lng: -117.35682,
    city: "Steptoe",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 48,
    density: 679.2,
    county_fips: 53075,
    county_name: "Whitman",
    county_weights: {
      53075: 100,
    },
    county_names_all: "Whitman",
    county_fips_all: 53075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99176,
    lat: 47.09221,
    lng: -117.41224,
    city: "Thornton",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 150,
    density: 1.2,
    county_fips: 53075,
    county_name: "Whitman",
    county_weights: {
      53075: 100,
    },
    county_names_all: "Whitman",
    county_fips_all: 53075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99179,
    lat: 46.49239,
    lng: -117.10762,
    city: "Uniontown",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 458,
    density: 2.7,
    county_fips: 53075,
    county_name: "Whitman",
    county_weights: {
      53075: 100,
    },
    county_names_all: "Whitman",
    county_fips_all: 53075,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99180,
    lat: 48.30925,
    lng: -117.30663,
    city: "Usk",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1065,
    density: 2.5,
    county_fips: 53051,
    county_name: "Pend Oreille",
    county_weights: {
      53051: 100,
    },
    county_names_all: "Pend Oreille",
    county_fips_all: 53051,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99181,
    lat: 48.1456,
    lng: -117.76526,
    city: "Valley",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1788,
    density: 7.6,
    county_fips: 53065,
    county_name: "Stevens",
    county_weights: {
      53065: 100,
    },
    county_names_all: "Stevens",
    county_fips_all: 53065,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99185,
    lat: 47.74014,
    lng: -118.71697,
    city: "Wilbur",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1299,
    density: 1.8,
    county_fips: 53043,
    county_name: "Lincoln",
    county_weights: {
      53043: 100,
    },
    county_names_all: "Lincoln",
    county_fips_all: 53043,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99201,
    lat: 47.66271,
    lng: -117.43609,
    city: "Spokane",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13256,
    density: 1723.3,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99202,
    lat: 47.65709,
    lng: -117.37854,
    city: "Spokane",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21488,
    density: 1395.4,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99203,
    lat: 47.62945,
    lng: -117.40291,
    city: "Spokane",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21359,
    density: 1775,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99204,
    lat: 47.64726,
    lng: -117.42665,
    city: "Spokane",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7010,
    density: 2652.6,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99205,
    lat: 47.69657,
    lng: -117.44609,
    city: "Spokane",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43707,
    density: 1881.9,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99206,
    lat: 47.62755,
    lng: -117.25448,
    city: "Spokane",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40510,
    density: 669.7,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99207,
    lat: 47.68941,
    lng: -117.38911,
    city: "Spokane",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 31020,
    density: 2305.1,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99208,
    lat: 47.78071,
    lng: -117.46135,
    city: "Spokane",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 55092,
    density: 436.5,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99212,
    lat: 47.66504,
    lng: -117.30914,
    city: "Spokane",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21191,
    density: 667,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99216,
    lat: 47.68142,
    lng: -117.20826,
    city: "Spokane",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 26166,
    density: 709.8,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99217,
    lat: 47.7406,
    lng: -117.26241,
    city: "Spokane",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18073,
    density: 135.7,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99218,
    lat: 47.75894,
    lng: -117.4087,
    city: "Spokane",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17417,
    density: 990.2,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99223,
    lat: 47.58876,
    lng: -117.334,
    city: "Spokane",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32750,
    density: 394.4,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99224,
    lat: 47.64729,
    lng: -117.53552,
    city: "Spokane",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22172,
    density: 72.1,
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99251,
    lat: 47.75385,
    lng: -117.41797,
    city: "Spokane",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99258,
    lat: 47.66612,
    lng: -117.40246,
    city: "Spokane",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: 53063,
    county_name: "Spokane",
    county_weights: {
      53063: 100,
    },
    county_names_all: "Spokane",
    county_fips_all: 53063,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99301,
    lat: 46.39184,
    lng: -118.93509,
    city: "Pasco",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 81583,
    density: 64.8,
    county_fips: 53021,
    county_name: "Franklin",
    county_weights: {
      53021: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 53021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99320,
    lat: 46.32706,
    lng: -119.52483,
    city: "Benton City",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9696,
    density: 17.9,
    county_fips: 53005,
    county_name: "Benton",
    county_weights: {
      53005: 100,
    },
    county_names_all: "Benton",
    county_fips_all: 53005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99321,
    lat: 46.86576,
    lng: -119.88925,
    city: "Beverly",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 488,
    density: 5.4,
    county_fips: 53025,
    county_name: "Grant",
    county_weights: {
      53025: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 53025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99322,
    lat: 45.93176,
    lng: -120.14083,
    city: "Bickleton",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 448,
    density: 0.7,
    county_fips: 53039,
    county_name: "Klickitat",
    county_weights: {
      53039: 100,
    },
    county_names_all: "Klickitat",
    county_fips_all: 53039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99323,
    lat: 46.18677,
    lng: -118.85061,
    city: "Burbank",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4192,
    density: 12.2,
    county_fips: 53071,
    county_name: "Walla Walla",
    county_weights: {
      53071: 100,
    },
    county_names_all: "Walla Walla",
    county_fips_all: 53071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99324,
    lat: 46.04376,
    lng: -118.38542,
    city: "College Place",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9739,
    density: 1357,
    county_fips: 53071,
    county_name: "Walla Walla",
    county_weights: {
      53071: 100,
    },
    county_names_all: "Walla Walla",
    county_fips_all: 53071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99326,
    lat: 46.66705,
    lng: -118.83769,
    city: "Connell",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6666,
    density: 10.6,
    county_fips: 53021,
    county_name: "Franklin",
    county_weights: {
      53001: 12.02,
      53021: 87.98,
    },
    county_names_all: "Franklin|Adams",
    county_fips_all: "53021|53001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99328,
    lat: 46.26937,
    lng: -117.87956,
    city: "Dayton",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3718,
    density: 2.2,
    county_fips: 53013,
    county_name: "Columbia",
    county_weights: {
      53013: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 53013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99329,
    lat: 46.13943,
    lng: -118.14732,
    city: "Dixie",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 95,
    density: 71.9,
    county_fips: 53071,
    county_name: "Walla Walla",
    county_weights: {
      53071: 100,
    },
    county_names_all: "Walla Walla",
    county_fips_all: 53071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99330,
    lat: 46.49447,
    lng: -119.03021,
    city: "Eltopia",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1157,
    density: 5.1,
    county_fips: 53021,
    county_name: "Franklin",
    county_weights: {
      53021: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 53021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99333,
    lat: 46.68112,
    lng: -118.15262,
    city: "Hooper",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 69,
    density: 0.3,
    county_fips: 53075,
    county_name: "Whitman",
    county_weights: {
      53001: 11.07,
      53075: 88.93,
    },
    county_names_all: "Whitman|Adams",
    county_fips_all: "53075|53001",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99335,
    lat: 46.65544,
    lng: -118.47686,
    city: "Kahlotus",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 205,
    density: 0.5,
    county_fips: 53021,
    county_name: "Franklin",
    county_weights: {
      53021: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 53021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99336,
    lat: 46.21302,
    lng: -119.17954,
    city: "Kennewick",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52259,
    density: 1506.3,
    county_fips: 53005,
    county_name: "Benton",
    county_weights: {
      53005: 100,
    },
    county_names_all: "Benton",
    county_fips_all: 53005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99337,
    lat: 46.06235,
    lng: -119.09127,
    city: "Kennewick",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32080,
    density: 74.6,
    county_fips: 53005,
    county_name: "Benton",
    county_weights: {
      53005: 100,
    },
    county_names_all: "Benton",
    county_fips_all: 53005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99338,
    lat: 46.17362,
    lng: -119.27403,
    city: "Kennewick",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18473,
    density: 201.2,
    county_fips: 53005,
    county_name: "Benton",
    county_weights: {
      53005: 100,
    },
    county_names_all: "Benton",
    county_fips_all: 53005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99341,
    lat: 46.90663,
    lng: -118.64224,
    city: "Lind",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 687,
    density: 0.8,
    county_fips: 53001,
    county_name: "Adams",
    county_weights: {
      53001: 100,
    },
    county_names_all: "Adams",
    county_fips_all: 53001,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99343,
    lat: 46.59188,
    lng: -119.17065,
    city: "Mesa",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3037,
    density: 6.5,
    county_fips: 53021,
    county_name: "Franklin",
    county_weights: {
      53021: 100,
    },
    county_names_all: "Franklin",
    county_fips_all: 53021,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99344,
    lat: 46.82223,
    lng: -119.17221,
    city: "Othello",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18400,
    density: 14.6,
    county_fips: 53001,
    county_name: "Adams",
    county_weights: {
      53001: 64.62,
      53021: 15.64,
      53025: 19.74,
    },
    county_names_all: "Adams|Grant|Franklin",
    county_fips_all: "53001|53025|53021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99345,
    lat: 45.93623,
    lng: -119.65919,
    city: "Paterson",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 180,
    density: 0.5,
    county_fips: 53005,
    county_name: "Benton",
    county_weights: {
      53005: 100,
    },
    county_names_all: "Benton",
    county_fips_all: 53005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99346,
    lat: 46.02685,
    lng: -119.306,
    city: "Plymouth",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 443,
    density: 1.2,
    county_fips: 53005,
    county_name: "Benton",
    county_weights: {
      53005: 100,
    },
    county_names_all: "Benton",
    county_fips_all: 53005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99347,
    lat: 46.42531,
    lng: -117.57128,
    city: "Pomeroy",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2304,
    density: 1.2,
    county_fips: 53023,
    county_name: "Garfield",
    county_weights: {
      53013: 9.57,
      53023: 88.12,
      53075: 2.31,
    },
    county_names_all: "Garfield|Columbia|Whitman",
    county_fips_all: "53023|53013|53075",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99348,
    lat: 46.38681,
    lng: -118.44731,
    city: "Prescott",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1538,
    density: 1.1,
    county_fips: 53071,
    county_name: "Walla Walla",
    county_weights: {
      53013: 4.09,
      53071: 95.91,
    },
    county_names_all: "Walla Walla|Columbia",
    county_fips_all: "53071|53013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99349,
    lat: 46.73078,
    lng: -119.6996,
    city: "Mattawa",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9184,
    density: 13.3,
    county_fips: 53025,
    county_name: "Grant",
    county_weights: {
      53025: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 53025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99350,
    lat: 46.14477,
    lng: -119.70944,
    city: "Prosser",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14208,
    density: 9.1,
    county_fips: 53005,
    county_name: "Benton",
    county_weights: {
      53005: 86.55,
      53039: 12.61,
      53077: 0.84,
    },
    county_names_all: "Benton|Klickitat|Yakima",
    county_fips_all: "53005|53039|53077",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99352,
    lat: 46.24199,
    lng: -119.29067,
    city: "Richland",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 32246,
    density: 518.8,
    county_fips: 53005,
    county_name: "Benton",
    county_weights: {
      53005: 100,
    },
    county_names_all: "Benton",
    county_fips_all: 53005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99353,
    lat: 46.31747,
    lng: -119.37942,
    city: "West Richland",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16376,
    density: 245,
    county_fips: 53005,
    county_name: "Benton",
    county_weights: {
      53005: 100,
    },
    county_names_all: "Benton",
    county_fips_all: 53005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99354,
    lat: 46.33153,
    lng: -119.30106,
    city: "Richland",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23891,
    density: 385.4,
    county_fips: 53005,
    county_name: "Benton",
    county_weights: {
      53005: 100,
    },
    county_names_all: "Benton",
    county_fips_all: 53005,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99356,
    lat: 45.83459,
    lng: -120.36258,
    city: "Roosevelt",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 165,
    density: 0.2,
    county_fips: 53039,
    county_name: "Klickitat",
    county_weights: {
      53039: 100,
    },
    county_names_all: "Klickitat",
    county_fips_all: 53039,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99357,
    lat: 46.89295,
    lng: -119.67902,
    city: "Royal City",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4438,
    density: 7.9,
    county_fips: 53025,
    county_name: "Grant",
    county_weights: {
      53025: 100,
    },
    county_names_all: "Grant",
    county_fips_all: 53025,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99359,
    lat: 46.53325,
    lng: -118.15697,
    city: "Starbuck",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 168,
    density: 1.5,
    county_fips: 53013,
    county_name: "Columbia",
    county_weights: {
      53013: 100,
    },
    county_names_all: "Columbia",
    county_fips_all: 53013,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99360,
    lat: 46.09044,
    lng: -118.66745,
    city: "Touchet",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1569,
    density: 3.7,
    county_fips: 53071,
    county_name: "Walla Walla",
    county_weights: {
      53071: 100,
    },
    county_names_all: "Walla Walla",
    county_fips_all: 53071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99361,
    lat: 46.23691,
    lng: -118.14333,
    city: "Waitsburg",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1795,
    density: 3.1,
    county_fips: 53071,
    county_name: "Walla Walla",
    county_weights: {
      53013: 32.35,
      53071: 67.65,
    },
    county_names_all: "Walla Walla|Columbia",
    county_fips_all: "53071|53013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99362,
    lat: 46.08727,
    lng: -118.31269,
    city: "Walla Walla",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41779,
    density: 53.2,
    county_fips: 53071,
    county_name: "Walla Walla",
    county_weights: {
      41059: 8.42,
      53071: 91.58,
    },
    county_names_all: "Walla Walla|Umatilla",
    county_fips_all: "53071|41059",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99363,
    lat: 46.04821,
    lng: -118.89575,
    city: "Wallula",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 157,
    density: 2,
    county_fips: 53071,
    county_name: "Walla Walla",
    county_weights: {
      53071: 100,
    },
    county_names_all: "Walla Walla",
    county_fips_all: 53071,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99371,
    lat: 46.79144,
    lng: -118.30614,
    city: "Washtucna",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 327,
    density: 0.6,
    county_fips: 53001,
    county_name: "Adams",
    county_weights: {
      53001: 78.86,
      53021: 21.14,
    },
    county_names_all: "Adams|Franklin",
    county_fips_all: "53001|53021",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99401,
    lat: 46.09041,
    lng: -117.27336,
    city: "Anatone",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 376,
    density: 0.8,
    county_fips: 53003,
    county_name: "Asotin",
    county_weights: {
      53003: 100,
    },
    county_names_all: "Asotin",
    county_fips_all: 53003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99402,
    lat: 46.1868,
    lng: -117.14922,
    city: "Asotin",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1597,
    density: 1.8,
    county_fips: 53003,
    county_name: "Asotin",
    county_weights: {
      53003: 100,
    },
    county_names_all: "Asotin",
    county_fips_all: 53003,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99403,
    lat: 46.38114,
    lng: -117.25974,
    city: "Clarkston",
    state_id: "WA",
    state_name: "Washington",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20707,
    density: 55.7,
    county_fips: 53003,
    county_name: "Asotin",
    county_weights: {
      53003: 80.06,
      53023: 19.94,
    },
    county_names_all: "Asotin|Garfield",
    county_fips_all: "53003|53023",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Los_Angeles",
  },
  {
    zip: 99501,
    lat: 61.22005,
    lng: -149.85872,
    city: "Anchorage",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15961,
    density: 926.5,
    county_fips: "02020",
    county_name: "Anchorage",
    county_weights: {
      "02020": 100,
    },
    county_names_all: "Anchorage",
    county_fips_all: "02020",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99502,
    lat: 61.16323,
    lng: -149.98644,
    city: "Anchorage",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 25215,
    density: 554.4,
    county_fips: "02020",
    county_name: "Anchorage",
    county_weights: {
      "02020": 100,
    },
    county_names_all: "Anchorage",
    county_fips_all: "02020",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99503,
    lat: 61.90744,
    lng: -156.85203,
    city: "Anchorage",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13017,
    density: 243,
    county_fips: "02050",
    county_name: "Bethel",
    county_weights: {
      "02050": 84.02,
      "02020": 15.98,
    },
    county_names_all: "Bethel|Anchorage",
    county_fips_all: "02050|02020",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99504,
    lat: 61.19195,
    lng: -149.64255,
    city: "Anchorage",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41739,
    density: 437.7,
    county_fips: "02020",
    county_name: "Anchorage",
    county_weights: {
      "02020": 100,
    },
    county_names_all: "Anchorage",
    county_fips_all: "02020",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99505,
    lat: 61.27512,
    lng: -149.65197,
    city: "Jber",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 6054,
    density: 56,
    county_fips: "02020",
    county_name: "Anchorage",
    county_weights: {
      "02020": 100,
    },
    county_names_all: "Anchorage",
    county_fips_all: "02020",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99506,
    lat: 61.26505,
    lng: -149.80067,
    city: "Jber",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7263,
    density: 136.9,
    county_fips: "02020",
    county_name: "Anchorage",
    county_weights: {
      "02020": 100,
    },
    county_names_all: "Anchorage",
    county_fips_all: "02020",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99507,
    lat: 61.13336,
    lng: -149.69001,
    city: "Anchorage",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 36403,
    density: 297.2,
    county_fips: "02020",
    county_name: "Anchorage",
    county_weights: {
      "02020": 100,
    },
    county_names_all: "Anchorage",
    county_fips_all: "02020",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99508,
    lat: 61.20145,
    lng: -149.8146,
    city: "Anchorage",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 38042,
    density: 2055.8,
    county_fips: "02020",
    county_name: "Anchorage",
    county_weights: {
      "02020": 100,
    },
    county_names_all: "Anchorage",
    county_fips_all: "02020",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99513,
    lat: 61.21477,
    lng: -149.88566,
    city: "Anchorage",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "02020",
    county_name: "Anchorage",
    county_weights: {
      "02020": 100,
    },
    county_names_all: "Anchorage",
    county_fips_all: "02020",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99515,
    lat: 61.11733,
    lng: -149.88894,
    city: "Anchorage",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 22226,
    density: 811.6,
    county_fips: "02020",
    county_name: "Anchorage",
    county_weights: {
      "02020": 100,
    },
    county_names_all: "Anchorage",
    county_fips_all: "02020",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99516,
    lat: 61.0726,
    lng: -149.71812,
    city: "Anchorage",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20874,
    density: 183.6,
    county_fips: "02020",
    county_name: "Anchorage",
    county_weights: {
      "02020": 100,
    },
    county_names_all: "Anchorage",
    county_fips_all: "02020",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99517,
    lat: 61.19018,
    lng: -149.93676,
    city: "Anchorage",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15802,
    density: 1883.2,
    county_fips: "02020",
    county_name: "Anchorage",
    county_weights: {
      "02020": 100,
    },
    county_names_all: "Anchorage",
    county_fips_all: "02020",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99518,
    lat: 61.15949,
    lng: -149.88479,
    city: "Anchorage",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10737,
    density: 1094.4,
    county_fips: "02020",
    county_name: "Anchorage",
    county_weights: {
      "02020": 100,
    },
    county_names_all: "Anchorage",
    county_fips_all: "02020",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99519,
    lat: 70.1006,
    lng: -150.00014,
    city: "Anchorage",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "02185",
    county_name: "North Slope",
    county_weights: {
      "02185": 100,
    },
    county_names_all: "North Slope",
    county_fips_all: "02185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99530,
    lat: 61.18465,
    lng: -149.98356,
    city: "Anchorage",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "02020",
    county_name: "Anchorage",
    county_weights: {
      "02020": 100,
    },
    county_names_all: "Anchorage",
    county_fips_all: "02020",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99540,
    lat: 61.01464,
    lng: -149.36859,
    city: "Indian",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 301,
    density: 0.9,
    county_fips: "02020",
    county_name: "Anchorage",
    county_weights: {
      "02020": 100,
    },
    county_names_all: "Anchorage",
    county_fips_all: "02020",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99546,
    lat: 51.88145,
    lng: -176.62962,
    city: "Adak",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 188,
    density: 2.2,
    county_fips: "02016",
    county_name: "Aleutians West",
    county_weights: {
      "02016": 100,
    },
    county_names_all: "Aleutians West",
    county_fips_all: "02016",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Adak",
  },
  {
    zip: 99547,
    lat: 52.22888,
    lng: -174.20613,
    city: "Atka",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 43,
    density: 2.1,
    county_fips: "02016",
    county_name: "Aleutians West",
    county_weights: {
      "02016": 100,
    },
    county_names_all: "Aleutians West",
    county_fips_all: "02016",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Adak",
  },
  {
    zip: 99548,
    lat: 56.25468,
    lng: -158.76004,
    city: "Chignik Lake",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52,
    density: 1.3,
    county_fips: "02164",
    county_name: "Lake and Peninsula",
    county_weights: {
      "02164": 100,
    },
    county_names_all: "Lake and Peninsula",
    county_fips_all: "02164",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99549,
    lat: 56.94253,
    lng: -158.60474,
    city: "Port Heiden",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 62,
    density: 0.5,
    county_fips: "02164",
    county_name: "Lake and Peninsula",
    county_weights: {
      "02164": 100,
    },
    county_names_all: "Lake and Peninsula",
    county_fips_all: "02164",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99550,
    lat: 57.8758,
    lng: -152.8737,
    city: "Port Lions",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 145,
    density: 11.2,
    county_fips: "02150",
    county_name: "Kodiak Island",
    county_weights: {
      "02150": 100,
    },
    county_names_all: "Kodiak Island",
    county_fips_all: "02150",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99551,
    lat: 60.92101,
    lng: -161.40212,
    city: "Akiachak",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 461,
    density: 25.4,
    county_fips: "02050",
    county_name: "Bethel",
    county_weights: {
      "02050": 100,
    },
    county_names_all: "Bethel",
    county_fips_all: "02050",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99552,
    lat: 60.90614,
    lng: -161.21223,
    city: "Akiak",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 298,
    density: 60.9,
    county_fips: "02050",
    county_name: "Bethel",
    county_weights: {
      "02050": 100,
    },
    county_names_all: "Bethel",
    county_fips_all: "02050",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99553,
    lat: 54.1475,
    lng: -165.83687,
    city: "Akutan",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 760,
    density: 7.6,
    county_fips: "02013",
    county_name: "Aleutians East",
    county_weights: {
      "02013": 100,
    },
    county_names_all: "Aleutians East",
    county_fips_all: "02013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99554,
    lat: 62.69018,
    lng: -164.63054,
    city: "Alakanuk",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1063,
    density: 12.7,
    county_fips: "02158",
    county_name: "Kusilvak",
    county_weights: {
      "02158": 100,
    },
    county_names_all: "Kusilvak",
    county_fips_all: "02158",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99555,
    lat: 59.28859,
    lng: -158.67996,
    city: "Aleknagik",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 133,
    density: 1.6,
    county_fips: "02070",
    county_name: "Dillingham",
    county_weights: {
      "02070": 100,
    },
    county_names_all: "Dillingham",
    county_fips_all: "02070",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99556,
    lat: 59.82955,
    lng: -151.64298,
    city: "Anchor Point",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2684,
    density: 5.3,
    county_fips: "02122",
    county_name: "Kenai Peninsula",
    county_weights: {
      "02122": 100,
    },
    county_names_all: "Kenai Peninsula",
    county_fips_all: "02122",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99557,
    lat: 61.44142,
    lng: -155.90217,
    city: "Aniak",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 711,
    density: 0,
    county_fips: "02050",
    county_name: "Bethel",
    county_weights: {
      "02050": 100,
    },
    county_names_all: "Bethel",
    county_fips_all: "02050",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99558,
    lat: 62.65411,
    lng: -160.21396,
    city: "Anvik",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 85,
    density: 3.5,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99559,
    lat: 60.76487,
    lng: -161.90671,
    city: "Bethel",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8036,
    density: 54.9,
    county_fips: "02050",
    county_name: "Bethel",
    county_weights: {
      "02050": 100,
    },
    county_names_all: "Bethel",
    county_fips_all: "02050",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99561,
    lat: 60.15504,
    lng: -164.25495,
    city: "Chefornak",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 413,
    density: 30.5,
    county_fips: "02050",
    county_name: "Bethel",
    county_weights: {
      "02050": 100,
    },
    county_names_all: "Bethel",
    county_fips_all: "02050",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99563,
    lat: 61.55009,
    lng: -165.35813,
    city: "Chevak",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "02158",
    county_name: "Kusilvak",
    county_weights: {
      "02158": 100,
    },
    county_names_all: "Kusilvak",
    county_fips_all: "02158",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99564,
    lat: 56.30032,
    lng: -158.41315,
    city: "Chignik",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42,
    density: 1.5,
    county_fips: "02164",
    county_name: "Lake and Peninsula",
    county_weights: {
      "02164": 100,
    },
    county_names_all: "Lake and Peninsula",
    county_fips_all: "02164",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99565,
    lat: 56.30415,
    lng: -158.50039,
    city: "Chignik Lagoon",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 35,
    density: 1,
    county_fips: "02164",
    county_name: "Lake and Peninsula",
    county_weights: {
      "02164": 100,
    },
    county_names_all: "Lake and Peninsula",
    county_fips_all: "02164",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99566,
    lat: 61.28176,
    lng: -142.79338,
    city: "Chitina",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 71,
    density: 0,
    county_fips: "02066",
    county_name: "Copper River",
    county_weights: {
      "02066": 100,
    },
    county_names_all: "Copper River",
    county_fips_all: "02066",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99567,
    lat: 61.26625,
    lng: -148.86933,
    city: "Chugiak",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8872,
    density: 5.1,
    county_fips: "02020",
    county_name: "Anchorage",
    county_weights: {
      "02020": 100,
    },
    county_names_all: "Anchorage",
    county_fips_all: "02020",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99568,
    lat: 60.24952,
    lng: -150.38501,
    city: "Clam Gulch",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "02122",
    county_name: "Kenai Peninsula",
    county_weights: {
      "02122": 100,
    },
    county_names_all: "Kenai Peninsula",
    county_fips_all: "02122",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99569,
    lat: 58.81714,
    lng: -158.52914,
    city: "Clarks Point",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37,
    density: 1.9,
    county_fips: "02070",
    county_name: "Dillingham",
    county_weights: {
      "02070": 100,
    },
    county_names_all: "Dillingham",
    county_fips_all: "02070",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99571,
    lat: 55.29661,
    lng: -162.58634,
    city: "Cold Bay",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 221,
    density: 1.5,
    county_fips: "02013",
    county_name: "Aleutians East",
    county_weights: {
      "02013": 100,
    },
    county_names_all: "Aleutians East",
    county_fips_all: "02013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99572,
    lat: 60.49348,
    lng: -150.0567,
    city: "Cooper Landing",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 273,
    density: 1.3,
    county_fips: "02122",
    county_name: "Kenai Peninsula",
    county_weights: {
      "02122": 100,
    },
    county_names_all: "Kenai Peninsula",
    county_fips_all: "02122",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99573,
    lat: 61.60036,
    lng: -145.92446,
    city: "Copper Center",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 798,
    density: 0.1,
    county_fips: "02066",
    county_name: "Copper River",
    county_weights: {
      "02066": 100,
    },
    county_names_all: "Copper River",
    county_fips_all: "02066",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99574,
    lat: 60.73927,
    lng: -146.4061,
    city: "Cordova",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2302,
    density: 0.3,
    county_fips: "02063",
    county_name: "Chugach",
    county_weights: {
      "02063": 100,
    },
    county_names_all: "Chugach",
    county_fips_all: "02063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99575,
    lat: 61.84391,
    lng: -158.10825,
    city: "Crooked Creek",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 57,
    density: 0.2,
    county_fips: "02050",
    county_name: "Bethel",
    county_weights: {
      "02050": 100,
    },
    county_names_all: "Bethel",
    county_fips_all: "02050",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99576,
    lat: 59.77339,
    lng: -158.69309,
    city: "Dillingham",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2384,
    density: 0.1,
    county_fips: "02070",
    county_name: "Dillingham",
    county_weights: {
      "02070": 100,
    },
    county_names_all: "Dillingham",
    county_fips_all: "02070",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99577,
    lat: 61.1824,
    lng: -149.29229,
    city: "Eagle River",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 27333,
    density: 36.7,
    county_fips: "02020",
    county_name: "Anchorage",
    county_weights: {
      "02020": 100,
    },
    county_names_all: "Anchorage",
    county_fips_all: "02020",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99578,
    lat: 60.21644,
    lng: -162.03311,
    city: "Eek",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 575,
    density: 342.8,
    county_fips: "02050",
    county_name: "Bethel",
    county_weights: {
      "02050": 100,
    },
    county_names_all: "Bethel",
    county_fips_all: "02050",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99579,
    lat: 58.21813,
    lng: -157.40364,
    city: "Egegik",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 51,
    density: 0.7,
    county_fips: "02164",
    county_name: "Lake and Peninsula",
    county_weights: {
      "02164": 100,
    },
    county_names_all: "Lake and Peninsula",
    county_fips_all: "02164",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99580,
    lat: 59.34619,
    lng: -157.48607,
    city: "Ekwok",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 68,
    density: 1.6,
    county_fips: "02070",
    county_name: "Dillingham",
    county_weights: {
      "02070": 100,
    },
    county_names_all: "Dillingham",
    county_fips_all: "02070",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99581,
    lat: 62.82476,
    lng: -164.68692,
    city: "Emmonak",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "02158",
    county_name: "Kusilvak",
    county_weights: {
      "02158": 100,
    },
    county_names_all: "Kusilvak",
    county_fips_all: "02158",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99583,
    lat: 54.84305,
    lng: -163.39945,
    city: "False Pass",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 75,
    density: 2.4,
    county_fips: "02013",
    county_name: "Aleutians East",
    county_weights: {
      "02013": 100,
    },
    county_names_all: "Aleutians East",
    county_fips_all: "02013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99585,
    lat: 61.87532,
    lng: -162.04873,
    city: "Marshall",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 168,
    density: 16,
    county_fips: "02158",
    county_name: "Kusilvak",
    county_weights: {
      "02158": 100,
    },
    county_names_all: "Kusilvak",
    county_fips_all: "02158",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99586,
    lat: 62.67463,
    lng: -144.13884,
    city: "Gakona",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 389,
    density: 0.1,
    county_fips: "02066",
    county_name: "Copper River",
    county_weights: {
      "02066": 100,
    },
    county_names_all: "Copper River",
    county_fips_all: "02066",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99587,
    lat: 60.9103,
    lng: -148.84466,
    city: "Girdwood",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2025,
    density: 2.3,
    county_fips: "02020",
    county_name: "Anchorage",
    county_weights: {
      "02020": 100,
    },
    county_names_all: "Anchorage",
    county_fips_all: "02020",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99588,
    lat: 62.42192,
    lng: -146.4813,
    city: "Glennallen",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1372,
    density: 0.2,
    county_fips: "02066",
    county_name: "Copper River",
    county_weights: {
      "02066": 55.56,
      "02170": 44.44,
    },
    county_names_all: "Copper River|Matanuska-Susitna",
    county_fips_all: "02066|02170",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99589,
    lat: 59.21186,
    lng: -161.70123,
    city: "Goodnews Bay",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "02050",
    county_name: "Bethel",
    county_weights: {
      "02050": 100,
    },
    county_names_all: "Bethel",
    county_fips_all: "02050",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99590,
    lat: 62.89978,
    lng: -160.10782,
    city: "Grayling",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 200,
    density: 6.9,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99591,
    lat: 56.58075,
    lng: -169.61599,
    city: "Saint George Island",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 102,
    density: 1.1,
    county_fips: "02016",
    county_name: "Aleutians West",
    county_weights: {
      "02016": 100,
    },
    county_names_all: "Aleutians West",
    county_fips_all: "02016",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99602,
    lat: 62.1868,
    lng: -159.8198,
    city: "Holy Cross",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 257,
    density: 3.4,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99603,
    lat: 59.52364,
    lng: -151.22855,
    city: "Homer",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 10872,
    density: 3.9,
    county_fips: "02122",
    county_name: "Kenai Peninsula",
    county_weights: {
      "02122": 100,
    },
    county_names_all: "Kenai Peninsula",
    county_fips_all: "02122",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99604,
    lat: 61.52613,
    lng: -166.11458,
    city: "Hooper Bay",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 875,
    density: 45.1,
    county_fips: "02158",
    county_name: "Kusilvak",
    county_weights: {
      "02158": 100,
    },
    county_names_all: "Kusilvak",
    county_fips_all: "02158",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99605,
    lat: 60.83286,
    lng: -149.44797,
    city: "Hope",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 118,
    density: 0.2,
    county_fips: "02122",
    county_name: "Kenai Peninsula",
    county_weights: {
      "02122": 100,
    },
    county_names_all: "Kenai Peninsula",
    county_fips_all: "02122",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99606,
    lat: 59.66803,
    lng: -154.83362,
    city: "Iliamna",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 275,
    density: 1.7,
    county_fips: "02164",
    county_name: "Lake and Peninsula",
    county_weights: {
      "02164": 100,
    },
    county_names_all: "Lake and Peninsula",
    county_fips_all: "02164",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99607,
    lat: 61.5416,
    lng: -160.3337,
    city: "Kalskag",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 239,
    density: 26,
    county_fips: "02050",
    county_name: "Bethel",
    county_weights: {
      "02050": 100,
    },
    county_names_all: "Bethel",
    county_fips_all: "02050",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99608,
    lat: 57.58454,
    lng: -154.32545,
    city: "Karluk",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "02150",
    county_name: "Kodiak Island",
    county_weights: {
      "02150": 100,
    },
    county_names_all: "Kodiak Island",
    county_fips_all: "02150",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99609,
    lat: 60.87848,
    lng: -162.52725,
    city: "Kasigluk",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 414,
    density: 13.5,
    county_fips: "02050",
    county_name: "Bethel",
    county_weights: {
      "02050": 100,
    },
    county_names_all: "Bethel",
    county_fips_all: "02050",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99610,
    lat: 60.29172,
    lng: -151.27167,
    city: "Kasilof",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2199,
    density: 9.8,
    county_fips: "02122",
    county_name: "Kenai Peninsula",
    county_weights: {
      "02122": 100,
    },
    county_names_all: "Kenai Peninsula",
    county_fips_all: "02122",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99611,
    lat: 60.74777,
    lng: -150.89,
    city: "Kenai",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 14929,
    density: 10.9,
    county_fips: "02122",
    county_name: "Kenai Peninsula",
    county_weights: {
      "02122": 100,
    },
    county_names_all: "Kenai Peninsula",
    county_fips_all: "02122",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99612,
    lat: 55.08587,
    lng: -162.2978,
    city: "King Cove",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1147,
    density: 18,
    county_fips: "02013",
    county_name: "Aleutians East",
    county_weights: {
      "02013": 100,
    },
    county_names_all: "Aleutians East",
    county_fips_all: "02013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99613,
    lat: 59.13496,
    lng: -155.42696,
    city: "King Salmon",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 392,
    density: 0.1,
    county_fips: "02164",
    county_name: "Lake and Peninsula",
    county_weights: {
      "02164": 81.52,
      "02060": 18.48,
    },
    county_names_all: "Lake and Peninsula|Bristol Bay",
    county_fips_all: "02164|02060",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99614,
    lat: 59.9373,
    lng: -164.06158,
    city: "Kipnuk",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 360,
    density: 6.9,
    county_fips: "02050",
    county_name: "Bethel",
    county_weights: {
      "02050": 100,
    },
    county_names_all: "Bethel",
    county_fips_all: "02050",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99615,
    lat: 57.57705,
    lng: -153.39119,
    city: "Kodiak",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12852,
    density: 1.2,
    county_fips: "02150",
    county_name: "Kodiak Island",
    county_weights: {
      "02150": 100,
    },
    county_names_all: "Kodiak Island",
    county_fips_all: "02150",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99620,
    lat: 63.03047,
    lng: -163.553,
    city: "Kotlik",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1252,
    density: 161.5,
    county_fips: "02158",
    county_name: "Kusilvak",
    county_weights: {
      "02158": 100,
    },
    county_names_all: "Kusilvak",
    county_fips_all: "02158",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99621,
    lat: 60.79781,
    lng: -161.41469,
    city: "Kwethluk",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 459,
    density: 17.4,
    county_fips: "02050",
    county_name: "Bethel",
    county_weights: {
      "02050": 100,
    },
    county_names_all: "Bethel",
    county_fips_all: "02050",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99622,
    lat: 59.87667,
    lng: -163.17154,
    city: "Kwigillingok",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 425,
    density: 6.9,
    county_fips: "02050",
    county_name: "Bethel",
    county_weights: {
      "02050": 100,
    },
    county_names_all: "Bethel",
    county_fips_all: "02050",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99623,
    lat: 61.42919,
    lng: -149.91226,
    city: "Wasilla",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "02170",
    county_name: "Matanuska-Susitna",
    county_weights: {
      "02170": 100,
    },
    county_names_all: "Matanuska-Susitna",
    county_fips_all: "02170",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99624,
    lat: 57.44866,
    lng: -153.85811,
    city: "Larsen Bay",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29,
    density: 0.6,
    county_fips: "02150",
    county_name: "Kodiak Island",
    county_weights: {
      "02150": 100,
    },
    county_names_all: "Kodiak Island",
    county_fips_all: "02150",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99625,
    lat: 59.0683,
    lng: -156.90093,
    city: "Levelock",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 40,
    density: 0.9,
    county_fips: "02164",
    county_name: "Lake and Peninsula",
    county_weights: {
      "02164": 100,
    },
    county_names_all: "Lake and Peninsula",
    county_fips_all: "02164",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99626,
    lat: 61.51633,
    lng: -160.35564,
    city: "Lower Kalskag",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 293,
    density: 90.9,
    county_fips: "02050",
    county_name: "Bethel",
    county_weights: {
      "02050": 100,
    },
    county_names_all: "Bethel",
    county_fips_all: "02050",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99627,
    lat: 63.18657,
    lng: -154.75609,
    city: "McGrath",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 287,
    density: 0,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99628,
    lat: 58.9033,
    lng: -158.90867,
    city: "Manokotak",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 761,
    density: 3.7,
    county_fips: "02070",
    county_name: "Dillingham",
    county_weights: {
      "02070": 100,
    },
    county_names_all: "Dillingham",
    county_fips_all: "02070",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99630,
    lat: 60.37041,
    lng: -166.2672,
    city: "Mekoryuk",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 262,
    density: 14.3,
    county_fips: "02050",
    county_name: "Bethel",
    county_weights: {
      "02050": 100,
    },
    county_names_all: "Bethel",
    county_fips_all: "02050",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99631,
    lat: 60.60673,
    lng: -149.58071,
    city: "Moose Pass",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 267,
    density: 0.2,
    county_fips: "02122",
    county_name: "Kenai Peninsula",
    county_weights: {
      "02122": 100,
    },
    county_names_all: "Kenai Peninsula",
    county_fips_all: "02122",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99632,
    lat: 62.11232,
    lng: -163.66455,
    city: "Mountain Village",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1055,
    density: 16.2,
    county_fips: "02158",
    county_name: "Kusilvak",
    county_weights: {
      "02158": 100,
    },
    county_names_all: "Kusilvak",
    county_fips_all: "02158",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99633,
    lat: 58.78297,
    lng: -156.8984,
    city: "Naknek",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 370,
    density: 1.8,
    county_fips: "02060",
    county_name: "Bristol Bay",
    county_weights: {
      "02060": 100,
    },
    county_names_all: "Bristol Bay",
    county_fips_all: "02060",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99634,
    lat: 60.68682,
    lng: -162.00737,
    city: "Napakiak",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 746,
    density: 58.2,
    county_fips: "02050",
    county_name: "Bethel",
    county_weights: {
      "02050": 100,
    },
    county_names_all: "Bethel",
    county_fips_all: "02050",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99635,
    lat: 60.8062,
    lng: -152.67734,
    city: "Nikiski",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "02122",
    county_name: "Kenai Peninsula",
    county_weights: {
      "02122": 100,
    },
    county_names_all: "Kenai Peninsula",
    county_fips_all: "02122",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99636,
    lat: 59.47618,
    lng: -157.27099,
    city: "New Stuyahok",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 570,
    density: 6.5,
    county_fips: "02070",
    county_name: "Dillingham",
    county_weights: {
      "02070": 100,
    },
    county_names_all: "Dillingham",
    county_fips_all: "02070",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99637,
    lat: 60.5333,
    lng: -165.1557,
    city: "Toksook Bay",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 863,
    density: 11.6,
    county_fips: "02050",
    county_name: "Bethel",
    county_weights: {
      "02050": 100,
    },
    county_names_all: "Bethel",
    county_fips_all: "02050",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99638,
    lat: 53.01329,
    lng: -168.75359,
    city: "Nikolski",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 15,
    density: 0,
    county_fips: "02016",
    county_name: "Aleutians West",
    county_weights: {
      "02016": 100,
    },
    county_names_all: "Aleutians West",
    county_fips_all: "02016",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99639,
    lat: 59.99602,
    lng: -151.36177,
    city: "Ninilchik",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1232,
    density: 1.3,
    county_fips: "02122",
    county_name: "Kenai Peninsula",
    county_weights: {
      "02122": 100,
    },
    county_names_all: "Kenai Peninsula",
    county_fips_all: "02122",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99640,
    lat: 60.29813,
    lng: -155.40518,
    city: "Nondalton",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 120,
    density: 0,
    county_fips: "02164",
    county_name: "Lake and Peninsula",
    county_weights: {
      "02164": 100,
    },
    county_names_all: "Lake and Peninsula",
    county_fips_all: "02164",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99641,
    lat: 60.87722,
    lng: -162.46152,
    city: "Nunapitchuk",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 955,
    density: 52.7,
    county_fips: "02050",
    county_name: "Bethel",
    county_weights: {
      "02050": 100,
    },
    county_names_all: "Bethel",
    county_fips_all: "02050",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99643,
    lat: 57.21669,
    lng: -153.32658,
    city: "Old Harbor",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 217,
    density: 5.3,
    county_fips: "02150",
    county_name: "Kodiak Island",
    county_weights: {
      "02150": 100,
    },
    county_names_all: "Kodiak Island",
    county_fips_all: "02150",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99644,
    lat: 57.92512,
    lng: -152.4231,
    city: "Ouzinkie",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 140,
    density: 3.3,
    county_fips: "02150",
    county_name: "Kodiak Island",
    county_weights: {
      "02150": 100,
    },
    county_names_all: "Kodiak Island",
    county_fips_all: "02150",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99645,
    lat: 61.60763,
    lng: -148.90394,
    city: "Palmer",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 30435,
    density: 20,
    county_fips: "02170",
    county_name: "Matanuska-Susitna",
    county_weights: {
      "02170": 100,
    },
    county_names_all: "Matanuska-Susitna",
    county_fips_all: "02170",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99647,
    lat: 59.86411,
    lng: -154.01511,
    city: "Pedro Bay",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21,
    density: 0,
    county_fips: "02164",
    county_name: "Lake and Peninsula",
    county_weights: {
      "02164": 100,
    },
    county_names_all: "Lake and Peninsula",
    county_fips_all: "02164",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99648,
    lat: 55.93137,
    lng: -159.15598,
    city: "Perryville",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54,
    density: 1.9,
    county_fips: "02164",
    county_name: "Lake and Peninsula",
    county_weights: {
      "02164": 100,
    },
    county_names_all: "Lake and Peninsula",
    county_fips_all: "02164",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99649,
    lat: 57.51501,
    lng: -157.31076,
    city: "Pilot Point",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 91,
    density: 0.3,
    county_fips: "02164",
    county_name: "Lake and Peninsula",
    county_weights: {
      "02164": 100,
    },
    county_names_all: "Lake and Peninsula",
    county_fips_all: "02164",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99650,
    lat: 61.94255,
    lng: -162.88467,
    city: "Pilot Station",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 421,
    density: 101.2,
    county_fips: "02158",
    county_name: "Kusilvak",
    county_weights: {
      "02158": 100,
    },
    county_names_all: "Kusilvak",
    county_fips_all: "02158",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99651,
    lat: 58.97803,
    lng: -161.71853,
    city: "Platinum",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8,
    density: 0.1,
    county_fips: "02050",
    county_name: "Bethel",
    county_weights: {
      "02050": 100,
    },
    county_names_all: "Bethel",
    county_fips_all: "02050",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99652,
    lat: 61.52621,
    lng: -149.9616,
    city: "Big Lake",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3147,
    density: 9.9,
    county_fips: "02170",
    county_name: "Matanuska-Susitna",
    county_weights: {
      "02170": 100,
    },
    county_names_all: "Matanuska-Susitna",
    county_fips_all: "02170",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99653,
    lat: 60.16884,
    lng: -154.32328,
    city: "Port Alsworth",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 200,
    density: 3.4,
    county_fips: "02164",
    county_name: "Lake and Peninsula",
    county_weights: {
      "02164": 100,
    },
    county_names_all: "Lake and Peninsula",
    county_fips_all: "02164",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99654,
    lat: 61.607,
    lng: -149.41443,
    city: "Wasilla",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 66177,
    density: 224.9,
    county_fips: "02170",
    county_name: "Matanuska-Susitna",
    county_weights: {
      "02170": 100,
    },
    county_names_all: "Matanuska-Susitna",
    county_fips_all: "02170",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99655,
    lat: 59.74903,
    lng: -161.89437,
    city: "Quinhagak",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 856,
    density: 101.9,
    county_fips: "02050",
    county_name: "Bethel",
    county_weights: {
      "02050": 100,
    },
    county_names_all: "Bethel",
    county_fips_all: "02050",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99656,
    lat: 61.86309,
    lng: -157.41759,
    city: "Red Devil",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24,
    density: 0,
    county_fips: "02050",
    county_name: "Bethel",
    county_weights: {
      "02050": 100,
    },
    county_names_all: "Bethel",
    county_fips_all: "02050",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99657,
    lat: 61.78916,
    lng: -161.42698,
    city: "Russian Mission",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 193,
    density: 0.1,
    county_fips: "02158",
    county_name: "Kusilvak",
    county_weights: {
      "02158": 100,
    },
    county_names_all: "Kusilvak",
    county_fips_all: "02158",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99658,
    lat: 62.0761,
    lng: -163.28111,
    city: "Saint Marys",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 790,
    density: 7.1,
    county_fips: "02158",
    county_name: "Kusilvak",
    county_weights: {
      "02158": 100,
    },
    county_names_all: "Kusilvak",
    county_fips_all: "02158",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99659,
    lat: 63.4738,
    lng: -162.12295,
    city: "Saint Michael",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 340,
    density: 7,
    county_fips: "02180",
    county_name: "Nome",
    county_weights: {
      "02180": 100,
    },
    county_names_all: "Nome",
    county_fips_all: "02180",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99660,
    lat: 57.17993,
    lng: -170.27914,
    city: "Saint Paul Island",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 399,
    density: 3.6,
    county_fips: "02016",
    county_name: "Aleutians West",
    county_weights: {
      "02016": 100,
    },
    county_names_all: "Aleutians West",
    county_fips_all: "02016",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99661,
    lat: 55.27131,
    lng: -160.67431,
    city: "Sand Point",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1186,
    density: 2.6,
    county_fips: "02013",
    county_name: "Aleutians East",
    county_weights: {
      "02013": 100,
    },
    county_names_all: "Aleutians East",
    county_fips_all: "02013",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99662,
    lat: 61.84197,
    lng: -165.58329,
    city: "Scammon Bay",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 477,
    density: 393.4,
    county_fips: "02158",
    county_name: "Kusilvak",
    county_weights: {
      "02158": 100,
    },
    county_names_all: "Kusilvak",
    county_fips_all: "02158",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99663,
    lat: 59.39488,
    lng: -151.62729,
    city: "Seldovia",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 333,
    density: 1.1,
    county_fips: "02122",
    county_name: "Kenai Peninsula",
    county_weights: {
      "02122": 100,
    },
    county_names_all: "Kenai Peninsula",
    county_fips_all: "02122",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99664,
    lat: 60.13714,
    lng: -149.47123,
    city: "Seward",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4364,
    density: 0.6,
    county_fips: "02122",
    county_name: "Kenai Peninsula",
    county_weights: {
      "02122": 100,
    },
    county_names_all: "Kenai Peninsula",
    county_fips_all: "02122",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99665,
    lat: 62.66843,
    lng: -159.56298,
    city: "Shageluk",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56,
    density: 2.1,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99666,
    lat: 62.45498,
    lng: -165.09492,
    city: "Nunam Iqua",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 122,
    density: 0.6,
    county_fips: "02158",
    county_name: "Kusilvak",
    county_weights: {
      "02158": 100,
    },
    county_names_all: "Kusilvak",
    county_fips_all: "02158",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99667,
    lat: 61.85447,
    lng: -151.82056,
    city: "Skwentna",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 83,
    density: 0,
    county_fips: "02170",
    county_name: "Matanuska-Susitna",
    county_weights: {
      "02170": 100,
    },
    county_names_all: "Matanuska-Susitna",
    county_fips_all: "02170",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99668,
    lat: 61.65158,
    lng: -157.12508,
    city: "Sleetmute",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 78,
    density: 0.3,
    county_fips: "02050",
    county_name: "Bethel",
    county_weights: {
      "02050": 100,
    },
    county_names_all: "Bethel",
    county_fips_all: "02050",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99669,
    lat: 60.41497,
    lng: -151.00207,
    city: "Soldotna",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 17580,
    density: 27.7,
    county_fips: "02122",
    county_name: "Kenai Peninsula",
    county_weights: {
      "02122": 100,
    },
    county_names_all: "Kenai Peninsula",
    county_fips_all: "02122",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99670,
    lat: 58.66541,
    lng: -156.98831,
    city: "South Naknek",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42,
    density: 0.2,
    county_fips: "02060",
    county_name: "Bristol Bay",
    county_weights: {
      "02060": 100,
    },
    county_names_all: "Bristol Bay",
    county_fips_all: "02060",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99671,
    lat: 63.47048,
    lng: -162.25993,
    city: "Stebbins",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 620,
    density: 7.3,
    county_fips: "02180",
    county_name: "Nome",
    county_weights: {
      "02180": 100,
    },
    county_names_all: "Nome",
    county_fips_all: "02180",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99672,
    lat: 60.55026,
    lng: -150.77907,
    city: "Sterling",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3075,
    density: 18.8,
    county_fips: "02122",
    county_name: "Kenai Peninsula",
    county_weights: {
      "02122": 100,
    },
    county_names_all: "Kenai Peninsula",
    county_fips_all: "02122",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99674,
    lat: 61.69166,
    lng: -147.81997,
    city: "Sutton",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1252,
    density: 0.3,
    county_fips: "02170",
    county_name: "Matanuska-Susitna",
    county_weights: {
      "02170": 100,
    },
    county_names_all: "Matanuska-Susitna",
    county_fips_all: "02170",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99675,
    lat: 62.98268,
    lng: -156.08383,
    city: "Takotna",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99676,
    lat: 62.49792,
    lng: -149.65848,
    city: "Talkeetna",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1756,
    density: 0.6,
    county_fips: "02170",
    county_name: "Matanuska-Susitna",
    county_weights: {
      "02170": 100,
    },
    county_names_all: "Matanuska-Susitna",
    county_fips_all: "02170",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99677,
    lat: 60.89217,
    lng: -146.67249,
    city: "Tatitlek",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 41,
    density: 2.2,
    county_fips: "02063",
    county_name: "Chugach",
    county_weights: {
      "02063": 100,
    },
    county_names_all: "Chugach",
    county_fips_all: "02063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99678,
    lat: 59.20738,
    lng: -160.52622,
    city: "Togiak",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 981,
    density: 0.5,
    county_fips: "02070",
    county_name: "Dillingham",
    county_weights: {
      "02070": 100,
    },
    county_names_all: "Dillingham",
    county_fips_all: "02070",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99679,
    lat: 61.10509,
    lng: -160.94865,
    city: "Tuluksak",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 269,
    density: 36.4,
    county_fips: "02050",
    county_name: "Bethel",
    county_weights: {
      "02050": 100,
    },
    county_names_all: "Bethel",
    county_fips_all: "02050",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99680,
    lat: 60.34447,
    lng: -162.66367,
    city: "Tuntutuliak",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 844,
    density: 169.3,
    county_fips: "02050",
    county_name: "Bethel",
    county_weights: {
      "02050": 100,
    },
    county_names_all: "Bethel",
    county_fips_all: "02050",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99681,
    lat: 60.57902,
    lng: -165.20767,
    city: "Tununak",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 338,
    density: 2.1,
    county_fips: "02050",
    county_name: "Bethel",
    county_weights: {
      "02050": 100,
    },
    county_names_all: "Bethel",
    county_fips_all: "02050",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99682,
    lat: 61.17145,
    lng: -151.16797,
    city: "Tyonek",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 531,
    density: 1.8,
    county_fips: "02122",
    county_name: "Kenai Peninsula",
    county_weights: {
      "02122": 100,
    },
    county_names_all: "Kenai Peninsula",
    county_fips_all: "02122",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99683,
    lat: 62.45165,
    lng: -150.425,
    city: "Trapper Creek",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 354,
    density: 0.1,
    county_fips: "02170",
    county_name: "Matanuska-Susitna",
    county_weights: {
      "02170": 100,
    },
    county_names_all: "Matanuska-Susitna",
    county_fips_all: "02170",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99684,
    lat: 64.09938,
    lng: -160.32776,
    city: "Unalakleet",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 777,
    density: 0.2,
    county_fips: "02180",
    county_name: "Nome",
    county_weights: {
      "02180": 100,
    },
    county_names_all: "Nome",
    county_fips_all: "02180",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99685,
    lat: 53.87869,
    lng: -166.47125,
    city: "Unalaska",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4583,
    density: 31.4,
    county_fips: "02016",
    county_name: "Aleutians West",
    county_weights: {
      "02016": 100,
    },
    county_names_all: "Aleutians West",
    county_fips_all: "02016",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99686,
    lat: 61.04886,
    lng: -146.19038,
    city: "Valdez",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3874,
    density: 1.1,
    county_fips: "02063",
    county_name: "Chugach",
    county_weights: {
      "02063": 100,
    },
    county_names_all: "Chugach",
    county_fips_all: "02063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99688,
    lat: 61.89412,
    lng: -150.04749,
    city: "Willow",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2642,
    density: 0.6,
    county_fips: "02170",
    county_name: "Matanuska-Susitna",
    county_weights: {
      "02170": 100,
    },
    county_names_all: "Matanuska-Susitna",
    county_fips_all: "02170",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99689,
    lat: 59.51819,
    lng: -139.4869,
    city: "Yakutat",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 597,
    density: 1.1,
    county_fips: "02282",
    county_name: "Yakutat",
    county_weights: {
      "02282": 100,
    },
    county_names_all: "Yakutat",
    county_fips_all: "02282",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Yakutat",
  },
  {
    zip: 99690,
    lat: 60.48738,
    lng: -164.81953,
    city: "Nightmute",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 150,
    density: 0.6,
    county_fips: "02050",
    county_name: "Bethel",
    county_weights: {
      "02050": 100,
    },
    county_names_all: "Bethel",
    county_fips_all: "02050",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99691,
    lat: 62.74385,
    lng: -153.84293,
    city: "Nikolai",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 115,
    density: 0,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99692,
    lat: 53.88393,
    lng: -166.54498,
    city: "Dutch Harbor",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 175,
    density: 203.5,
    county_fips: "02016",
    county_name: "Aleutians West",
    county_weights: {
      "02016": 100,
    },
    county_names_all: "Aleutians West",
    county_fips_all: "02016",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99693,
    lat: 60.83738,
    lng: -148.15024,
    city: "Whittier",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 265,
    density: 1.7,
    county_fips: "02063",
    county_name: "Chugach",
    county_weights: {
      "02063": 100,
    },
    county_names_all: "Chugach",
    county_fips_all: "02063",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99694,
    lat: 61.61854,
    lng: -149.8255,
    city: "Houston",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1514,
    density: 21.8,
    county_fips: "02170",
    county_name: "Matanuska-Susitna",
    county_weights: {
      "02170": 100,
    },
    county_names_all: "Matanuska-Susitna",
    county_fips_all: "02170",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99695,
    lat: 55.91828,
    lng: -159.49335,
    city: "Anchorage",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "02164",
    county_name: "Lake and Peninsula",
    county_weights: {
      "02164": 100,
    },
    county_names_all: "Lake and Peninsula",
    county_fips_all: "02164",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99701,
    lat: 67.25435,
    lng: -149.87754,
    city: "Fairbanks",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 16578,
    density: 11.7,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 96.96,
      "02090": 3.04,
    },
    county_names_all: "Yukon-Koyukuk|Fairbanks North Star",
    county_fips_all: "02290|02090",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99702,
    lat: 64.64835,
    lng: -147.03879,
    city: "Eielson Afb",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3338,
    density: 61.2,
    county_fips: "02090",
    county_name: "Fairbanks North Star",
    county_weights: {
      "02090": 100,
    },
    county_names_all: "Fairbanks North Star",
    county_fips_all: "02090",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99703,
    lat: 64.83542,
    lng: -147.62612,
    city: "Fort Wainwright",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9403,
    density: 375.2,
    county_fips: "02090",
    county_name: "Fairbanks North Star",
    county_weights: {
      "02090": 100,
    },
    county_names_all: "Fairbanks North Star",
    county_fips_all: "02090",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99704,
    lat: 64.29023,
    lng: -149.20423,
    city: "Clear",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "02068",
    county_name: "Denali",
    county_weights: {
      "02068": 100,
    },
    county_names_all: "Denali",
    county_fips_all: "02068",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99705,
    lat: 64.77356,
    lng: -147.27055,
    city: "North Pole",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 23633,
    density: 63.8,
    county_fips: "02090",
    county_name: "Fairbanks North Star",
    county_weights: {
      "02090": 100,
    },
    county_names_all: "Fairbanks North Star",
    county_fips_all: "02090",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99706,
    lat: 64.0281,
    lng: -144.6331,
    city: "Fairbanks",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 7,
    density: 0,
    county_fips: "02240",
    county_name: "Southeast Fairbanks",
    county_weights: {
      "02240": 100,
    },
    county_names_all: "Southeast Fairbanks",
    county_fips_all: "02240",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99707,
    lat: 65.1551,
    lng: -146.25238,
    city: "Fairbanks",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "02090",
    county_name: "Fairbanks North Star",
    county_weights: {
      "02090": 100,
    },
    county_names_all: "Fairbanks North Star",
    county_fips_all: "02090",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99709,
    lat: 64.87402,
    lng: -148.22458,
    city: "Fairbanks",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29574,
    density: 22.4,
    county_fips: "02090",
    county_name: "Fairbanks North Star",
    county_weights: {
      "02090": 100,
    },
    county_names_all: "Fairbanks North Star",
    county_fips_all: "02090",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99712,
    lat: 64.98311,
    lng: -146.13946,
    city: "Fairbanks",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13887,
    density: 1.6,
    county_fips: "02090",
    county_name: "Fairbanks North Star",
    county_weights: {
      "02090": 100,
    },
    county_names_all: "Fairbanks North Star",
    county_fips_all: "02090",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99714,
    lat: 64.4368,
    lng: -146.69689,
    city: "Salcha",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1161,
    density: 1.3,
    county_fips: "02090",
    county_name: "Fairbanks North Star",
    county_weights: {
      "02090": 100,
    },
    county_names_all: "Fairbanks North Star",
    county_fips_all: "02090",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99720,
    lat: 66.56395,
    lng: -152.76395,
    city: "Allakaket",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 239,
    density: 2,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99721,
    lat: 68.14999,
    lng: -151.71616,
    city: "Anaktuvuk Pass",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 189,
    density: 14.1,
    county_fips: "02185",
    county_name: "North Slope",
    county_weights: {
      "02185": 100,
    },
    county_names_all: "North Slope",
    county_fips_all: "02185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99722,
    lat: 68.14208,
    lng: -145.49557,
    city: "Arctic Village",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 229,
    density: 1.4,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99723,
    lat: 71.27434,
    lng: -156.75394,
    city: "Barrow",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4360,
    density: 89.2,
    county_fips: "02185",
    county_name: "North Slope",
    county_weights: {
      "02185": 100,
    },
    county_names_all: "North Slope",
    county_fips_all: "02185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99724,
    lat: 66.32218,
    lng: -146.96636,
    city: "Beaver",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99725,
    lat: 64.8612,
    lng: -148.02387,
    city: "Ester",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "02090",
    county_name: "Fairbanks North Star",
    county_weights: {
      "02090": 100,
    },
    county_names_all: "Fairbanks North Star",
    county_fips_all: "02090",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99726,
    lat: 66.73615,
    lng: -151.47757,
    city: "Bettles Field",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 18,
    density: 0,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99727,
    lat: 65.97654,
    lng: -161.13918,
    city: "Buckland",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 684,
    density: 502.7,
    county_fips: "02188",
    county_name: "Northwest Arctic",
    county_weights: {
      "02188": 100,
    },
    county_names_all: "Northwest Arctic",
    county_fips_all: "02188",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99729,
    lat: 63.22686,
    lng: -148.10122,
    city: "Cantwell",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 210,
    density: 0,
    county_fips: "02170",
    county_name: "Matanuska-Susitna",
    county_weights: {
      "02170": 89.4,
      "02068": 10.6,
    },
    county_names_all: "Matanuska-Susitna|Denali",
    county_fips_all: "02170|02068",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99730,
    lat: 65.67807,
    lng: -145.54055,
    city: "Central",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42,
    density: 0,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99732,
    lat: 64.07945,
    lng: -141.97039,
    city: "Chicken",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 21,
    density: 0,
    county_fips: "02240",
    county_name: "Southeast Fairbanks",
    county_weights: {
      "02240": 100,
    },
    county_names_all: "Southeast Fairbanks",
    county_fips_all: "02240",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99733,
    lat: 65.79284,
    lng: -144.18282,
    city: "Circle",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42,
    density: 0.2,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99734,
    lat: 70.36201,
    lng: -149.0021,
    city: "Prudhoe Bay",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 586,
    density: 1,
    county_fips: "02185",
    county_name: "North Slope",
    county_weights: {
      "02185": 100,
    },
    county_names_all: "North Slope",
    county_fips_all: "02185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99736,
    lat: 66.07222,
    lng: -162.74349,
    city: "Deering",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 150,
    density: 11.5,
    county_fips: "02188",
    county_name: "Northwest Arctic",
    county_weights: {
      "02188": 100,
    },
    county_names_all: "Northwest Arctic",
    county_fips_all: "02188",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99737,
    lat: 63.62717,
    lng: -145.07539,
    city: "Delta Junction",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4660,
    density: 0.3,
    county_fips: "02240",
    county_name: "Southeast Fairbanks",
    county_weights: {
      "02240": 76.8,
      "02066": 23.2,
    },
    county_names_all: "Southeast Fairbanks|Copper River",
    county_fips_all: "02240|02066",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99738,
    lat: 65.14953,
    lng: -142.43307,
    city: "Eagle",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 158,
    density: 0,
    county_fips: "02240",
    county_name: "Southeast Fairbanks",
    county_weights: {
      "02240": 57.59,
      "02290": 42.41,
    },
    county_names_all: "Southeast Fairbanks|Yukon-Koyukuk",
    county_fips_all: "02240|02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99739,
    lat: 64.97626,
    lng: -162.8397,
    city: "Elim",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 220,
    density: 0,
    county_fips: "02180",
    county_name: "Nome",
    county_weights: {
      "02180": 100,
    },
    county_names_all: "Nome",
    county_fips_all: "02180",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99740,
    lat: 67.70759,
    lng: -143.95132,
    city: "Fort Yukon",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 473,
    density: 0,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99741,
    lat: 64.73808,
    lng: -156.86351,
    city: "Galena",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 505,
    density: 11,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99742,
    lat: 63.75375,
    lng: -171.68811,
    city: "Gambell",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 495,
    density: 18.2,
    county_fips: "02180",
    county_name: "Nome",
    county_weights: {
      "02180": 100,
    },
    county_names_all: "Nome",
    county_fips_all: "02180",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99743,
    lat: 63.90955,
    lng: -149.91736,
    city: "Healy",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1106,
    density: 0.1,
    county_fips: "02068",
    county_name: "Denali",
    county_weights: {
      "02068": 100,
    },
    county_names_all: "Denali",
    county_fips_all: "02068",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99744,
    lat: 64.31361,
    lng: -149.13217,
    city: "Anderson",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 151,
    density: 2.2,
    county_fips: "02068",
    county_name: "Denali",
    county_weights: {
      "02068": 100,
    },
    county_names_all: "Denali",
    county_fips_all: "02068",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99745,
    lat: 66.0472,
    lng: -154.24096,
    city: "Hughes",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 56,
    density: 7.1,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99746,
    lat: 65.70013,
    lng: -156.33856,
    city: "Huslia",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 275,
    density: 6.7,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99747,
    lat: 70.11882,
    lng: -143.67029,
    city: "Kaktovik",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 178,
    density: 11.5,
    county_fips: "02185",
    county_name: "North Slope",
    county_weights: {
      "02185": 100,
    },
    county_names_all: "North Slope",
    county_fips_all: "02185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99748,
    lat: 64.32229,
    lng: -158.74356,
    city: "Kaltag",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 209,
    density: 3.7,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99749,
    lat: 66.9786,
    lng: -160.43178,
    city: "Kiana",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 388,
    density: 138.3,
    county_fips: "02188",
    county_name: "Northwest Arctic",
    county_weights: {
      "02188": 100,
    },
    county_names_all: "Northwest Arctic",
    county_fips_all: "02188",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99750,
    lat: 67.73299,
    lng: -164.52122,
    city: "Kivalina",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "02188",
    county_name: "Northwest Arctic",
    county_weights: {
      "02188": 100,
    },
    county_names_all: "Northwest Arctic",
    county_fips_all: "02188",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99751,
    lat: 66.93103,
    lng: -156.89386,
    city: "Kobuk",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 151,
    density: 3.8,
    county_fips: "02188",
    county_name: "Northwest Arctic",
    county_weights: {
      "02188": 100,
    },
    county_names_all: "Northwest Arctic",
    county_fips_all: "02188",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99752,
    lat: 67.29316,
    lng: -161.91744,
    city: "Kotzebue",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3363,
    density: 0.3,
    county_fips: "02188",
    county_name: "Northwest Arctic",
    county_weights: {
      "02188": 100,
    },
    county_names_all: "Northwest Arctic",
    county_fips_all: "02188",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99753,
    lat: 64.94112,
    lng: -161.14536,
    city: "Koyuk",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 243,
    density: 18.4,
    county_fips: "02180",
    county_name: "Nome",
    county_weights: {
      "02180": 100,
    },
    county_names_all: "Nome",
    county_fips_all: "02180",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99754,
    lat: 64.9008,
    lng: -157.69462,
    city: "Koyukuk",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 52,
    density: 3.5,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99755,
    lat: 63.68849,
    lng: -148.88742,
    city: "Denali National Park",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 939,
    density: 2,
    county_fips: "02068",
    county_name: "Denali",
    county_weights: {
      "02068": 100,
    },
    county_names_all: "Denali",
    county_fips_all: "02068",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99756,
    lat: 64.93645,
    lng: -150.66654,
    city: "Manley Hot Springs",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 42,
    density: 0,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99757,
    lat: 63.83208,
    lng: -152.49481,
    city: "Lake Minchumina",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 24,
    density: 0,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99758,
    lat: 65.15175,
    lng: -149.3724,
    city: "Minto",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 136,
    density: 17.4,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99759,
    lat: 69.73723,
    lng: -162.83741,
    city: "Point Lay",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 176,
    density: 2.6,
    county_fips: "02185",
    county_name: "North Slope",
    county_weights: {
      "02185": 100,
    },
    county_names_all: "North Slope",
    county_fips_all: "02185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99760,
    lat: 64.37035,
    lng: -149.17513,
    city: "Nenana",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 629,
    density: 0.1,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 56.42,
      "02068": 42.47,
      "02090": 1.11,
    },
    county_names_all: "Yukon-Koyukuk|Denali|Fairbanks North Star",
    county_fips_all: "02290|02068|02090",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99761,
    lat: 67.6004,
    lng: -163.03459,
    city: "Noatak",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 422,
    density: 10.3,
    county_fips: "02188",
    county_name: "Northwest Arctic",
    county_weights: {
      "02188": 100,
    },
    county_names_all: "Northwest Arctic",
    county_fips_all: "02188",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99762,
    lat: 64.85078,
    lng: -164.80261,
    city: "Nome",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 4343,
    density: 1,
    county_fips: "02180",
    county_name: "Nome",
    county_weights: {
      "02180": 100,
    },
    county_names_all: "Nome",
    county_fips_all: "02180",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99763,
    lat: 66.82801,
    lng: -161.03735,
    city: "Noorvik",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 562,
    density: 265.9,
    county_fips: "02188",
    county_name: "Northwest Arctic",
    county_weights: {
      "02188": 100,
    },
    county_names_all: "Northwest Arctic",
    county_fips_all: "02188",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99764,
    lat: 62.76664,
    lng: -141.67447,
    city: "Northway",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 474,
    density: 0.1,
    county_fips: "02240",
    county_name: "Southeast Fairbanks",
    county_weights: {
      "02240": 100,
    },
    county_names_all: "Southeast Fairbanks",
    county_fips_all: "02240",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99765,
    lat: 64.73066,
    lng: -158.13108,
    city: "Nulato",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 300,
    density: 14.2,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99766,
    lat: 68.29104,
    lng: -166.04257,
    city: "Point Hope",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 724,
    density: 1,
    county_fips: "02185",
    county_name: "North Slope",
    county_weights: {
      "02185": 100,
    },
    county_names_all: "North Slope",
    county_fips_all: "02185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99767,
    lat: 65.49664,
    lng: -150.14393,
    city: "Rampart",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 54,
    density: 3.2,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99768,
    lat: 65.38635,
    lng: -153.53826,
    city: "Ruby",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 190,
    density: 0,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99769,
    lat: 63.67965,
    lng: -170.48309,
    city: "Savoonga",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 849,
    density: 55.8,
    county_fips: "02180",
    county_name: "Nome",
    county_weights: {
      "02180": 100,
    },
    county_names_all: "Nome",
    county_fips_all: "02180",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99770,
    lat: 66.60708,
    lng: -160.07136,
    city: "Selawik",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 728,
    density: 25.1,
    county_fips: "02188",
    county_name: "Northwest Arctic",
    county_weights: {
      "02188": 100,
    },
    county_names_all: "Northwest Arctic",
    county_fips_all: "02188",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99771,
    lat: 64.35764,
    lng: -161.1989,
    city: "Shaktoolik",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 324,
    density: 119.1,
    county_fips: "02180",
    county_name: "Nome",
    county_weights: {
      "02180": 100,
    },
    county_names_all: "Nome",
    county_fips_all: "02180",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99772,
    lat: 65.94811,
    lng: -165.80122,
    city: "Shishmaref",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 499,
    density: 0,
    county_fips: "02180",
    county_name: "Nome",
    county_weights: {
      "02180": 100,
    },
    county_names_all: "Nome",
    county_fips_all: "02180",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99773,
    lat: 66.88053,
    lng: -157.14993,
    city: "Shungnak",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 210,
    density: 10.1,
    county_fips: "02188",
    county_name: "Northwest Arctic",
    county_weights: {
      "02188": 100,
    },
    county_names_all: "Northwest Arctic",
    county_fips_all: "02188",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99774,
    lat: 66.0232,
    lng: -149.07982,
    city: "Stevens Village",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 9,
    density: 0.3,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99775,
    lat: 64.85744,
    lng: -147.83483,
    city: "Fairbanks",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1077,
    density: 864.8,
    county_fips: "02090",
    county_name: "Fairbanks North Star",
    county_weights: {
      "02090": 100,
    },
    county_names_all: "Fairbanks North Star",
    county_fips_all: "02090",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99776,
    lat: 63.35232,
    lng: -143.43181,
    city: "Tanacross",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 145,
    density: 0.7,
    county_fips: "02240",
    county_name: "Southeast Fairbanks",
    county_weights: {
      "02240": 100,
    },
    county_names_all: "Southeast Fairbanks",
    county_fips_all: "02240",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99777,
    lat: 65.18392,
    lng: -152.06673,
    city: "Tanana",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 173,
    density: 7.9,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99778,
    lat: 65.25309,
    lng: -166.342,
    city: "Teller",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 286,
    density: 74,
    county_fips: "02180",
    county_name: "Nome",
    county_weights: {
      "02180": 100,
    },
    county_names_all: "Nome",
    county_fips_all: "02180",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99780,
    lat: 63.46295,
    lng: -142.1701,
    city: "Tok",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1710,
    density: 0.1,
    county_fips: "02240",
    county_name: "Southeast Fairbanks",
    county_weights: {
      "02240": 94.75,
      "02066": 5.25,
    },
    county_names_all: "Southeast Fairbanks|Copper River",
    county_fips_all: "02240|02066",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99781,
    lat: 67.32073,
    lng: -145.98835,
    city: "Venetie",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 126,
    density: 0,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99782,
    lat: 70.63804,
    lng: -159.97121,
    city: "Wainwright",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 437,
    density: 16.4,
    county_fips: "02185",
    county_name: "North Slope",
    county_weights: {
      "02185": 100,
    },
    county_names_all: "North Slope",
    county_fips_all: "02185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99783,
    lat: 65.61191,
    lng: -168.07732,
    city: "Wales",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 222,
    density: 37.2,
    county_fips: "02180",
    county_name: "Nome",
    county_weights: {
      "02180": 100,
    },
    county_names_all: "Nome",
    county_fips_all: "02180",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99784,
    lat: 64.682,
    lng: -163.4067,
    city: "White Mountain",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 170,
    density: 96.3,
    county_fips: "02180",
    county_name: "Nome",
    county_weights: {
      "02180": 100,
    },
    county_names_all: "Nome",
    county_fips_all: "02180",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99785,
    lat: 65.34151,
    lng: -166.4942,
    city: "Brevig Mission",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 621,
    density: 100.7,
    county_fips: "02180",
    county_name: "Nome",
    county_weights: {
      "02180": 100,
    },
    county_names_all: "Nome",
    county_fips_all: "02180",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Nome",
  },
  {
    zip: 99786,
    lat: 67.08971,
    lng: -157.87253,
    city: "Ambler",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 275,
    density: 10.3,
    county_fips: "02188",
    county_name: "Northwest Arctic",
    county_weights: {
      "02188": 100,
    },
    county_names_all: "Northwest Arctic",
    county_fips_all: "02188",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99788,
    lat: 66.64629,
    lng: -143.78137,
    city: "Chalkyitsik",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 118,
    density: 5.4,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99789,
    lat: 70.21348,
    lng: -150.98966,
    city: "Nuiqsut",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 535,
    density: 23.2,
    county_fips: "02185",
    county_name: "North Slope",
    county_weights: {
      "02185": 100,
    },
    county_names_all: "North Slope",
    county_fips_all: "02185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99790,
    lat: 65.42642,
    lng: -148.18738,
    city: "Fairbanks",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 20,
    density: 0,
    county_fips: "02290",
    county_name: "Yukon-Koyukuk",
    county_weights: {
      "02290": 100,
    },
    county_names_all: "Yukon-Koyukuk",
    county_fips_all: "02290",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99791,
    lat: 70.48101,
    lng: -157.3835,
    city: "Atqasuk",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 135,
    density: 1.3,
    county_fips: "02185",
    county_name: "North Slope",
    county_weights: {
      "02185": 100,
    },
    county_names_all: "North Slope",
    county_fips_all: "02185",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Anchorage",
  },
  {
    zip: 99801,
    lat: 58.39785,
    lng: -134.05472,
    city: "Juneau",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29839,
    density: 5.2,
    county_fips: "02110",
    county_name: "Juneau",
    county_weights: {
      "02110": 100,
    },
    county_names_all: "Juneau",
    county_fips_all: "02110",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Juneau",
  },
  {
    zip: 99820,
    lat: 57.43552,
    lng: -134.28926,
    city: "Angoon",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 500,
    density: 0.2,
    county_fips: "02105",
    county_name: "Hoonah-Angoon",
    county_weights: {
      "02105": 100,
    },
    county_names_all: "Hoonah-Angoon",
    county_fips_all: "02105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Juneau",
  },
  {
    zip: 99824,
    lat: 58.27234,
    lng: -134.40082,
    city: "Douglas",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2260,
    density: 498.3,
    county_fips: "02110",
    county_name: "Juneau",
    county_weights: {
      "02110": 100,
    },
    county_names_all: "Juneau",
    county_fips_all: "02110",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Juneau",
  },
  {
    zip: 99825,
    lat: 58.12864,
    lng: -136.19507,
    city: "Elfin Cove",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 29,
    density: 0.1,
    county_fips: "02105",
    county_name: "Hoonah-Angoon",
    county_weights: {
      "02105": 100,
    },
    county_names_all: "Hoonah-Angoon",
    county_fips_all: "02105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Juneau",
  },
  {
    zip: 99826,
    lat: 58.39816,
    lng: -135.83456,
    city: "Gustavus",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 493,
    density: 3.5,
    county_fips: "02105",
    county_name: "Hoonah-Angoon",
    county_weights: {
      "02105": 100,
    },
    county_names_all: "Hoonah-Angoon",
    county_fips_all: "02105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Juneau",
  },
  {
    zip: 99827,
    lat: 59.02659,
    lng: -135.88483,
    city: "Haines",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2608,
    density: 0.3,
    county_fips: "02100",
    county_name: "Haines",
    county_weights: {
      "02100": 55.29,
      "02105": 44.71,
    },
    county_names_all: "Haines|Hoonah-Angoon",
    county_fips_all: "02100|02105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Juneau",
  },
  {
    zip: 99829,
    lat: 58.03502,
    lng: -135.33856,
    city: "Hoonah",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "02105",
    county_name: "Hoonah-Angoon",
    county_weights: {
      "02105": 100,
    },
    county_names_all: "Hoonah-Angoon",
    county_fips_all: "02105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Juneau",
  },
  {
    zip: 99830,
    lat: 56.78305,
    lng: -134.16688,
    city: "Kake",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 509,
    density: 0.7,
    county_fips: "02198",
    county_name: "Prince of Wales-Hyder",
    county_weights: {
      "02198": 100,
    },
    county_names_all: "Prince of Wales-Hyder",
    county_fips_all: "02198",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Sitka",
  },
  {
    zip: 99832,
    lat: 57.96611,
    lng: -136.08265,
    city: "Pelican",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 81,
    density: 0.3,
    county_fips: "02105",
    county_name: "Hoonah-Angoon",
    county_weights: {
      "02105": 100,
    },
    county_names_all: "Hoonah-Angoon",
    county_fips_all: "02105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Juneau",
  },
  {
    zip: 99833,
    lat: 56.82952,
    lng: -133.17986,
    city: "Petersburg",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 3278,
    density: 0.4,
    county_fips: "02195",
    county_name: "Petersburg",
    county_weights: {
      "02195": 64.92,
      "02198": 35.08,
    },
    county_names_all: "Petersburg|Prince of Wales-Hyder",
    county_fips_all: "02195|02198",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Sitka",
  },
  {
    zip: 99835,
    lat: 57.23891,
    lng: -135.2633,
    city: "Sitka",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 8569,
    density: 1.3,
    county_fips: "02220",
    county_name: "Sitka",
    county_weights: {
      "02220": 100,
    },
    county_names_all: "Sitka",
    county_fips_all: "02220",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Sitka",
  },
  {
    zip: 99836,
    lat: 56.23558,
    lng: -134.65333,
    city: "Port Alexander",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 74,
    density: 8.2,
    county_fips: "02198",
    county_name: "Prince of Wales-Hyder",
    county_weights: {
      "02198": 100,
    },
    county_names_all: "Prince of Wales-Hyder",
    county_fips_all: "02198",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Sitka",
  },
  {
    zip: 99840,
    lat: 59.56297,
    lng: -135.33626,
    city: "Skagway",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1300,
    density: 1.2,
    county_fips: "02230",
    county_name: "Skagway",
    county_weights: {
      "02230": 100,
    },
    county_names_all: "Skagway",
    county_fips_all: "02230",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Juneau",
  },
  {
    zip: 99841,
    lat: 58.00866,
    lng: -135.57397,
    city: "Tenakee Springs",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "02105",
    county_name: "Hoonah-Angoon",
    county_weights: {
      "02105": 100,
    },
    county_names_all: "Hoonah-Angoon",
    county_fips_all: "02105",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Juneau",
  },
  {
    zip: 99850,
    lat: 58.48821,
    lng: -135.48432,
    city: "Juneau",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: "",
    density: "",
    county_fips: "02100",
    county_name: "Haines",
    county_weights: {
      "02100": 100,
    },
    county_names_all: "Haines",
    county_fips_all: "02100",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Juneau",
  },
  {
    zip: 99901,
    lat: 55.6227,
    lng: -131.67157,
    city: "Ketchikan",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 13850,
    density: 2.7,
    county_fips: "02130",
    county_name: "Ketchikan Gateway",
    county_weights: {
      "02130": 86.23,
      "02198": 13.77,
    },
    county_names_all: "Ketchikan Gateway|Prince of Wales-Hyder",
    county_fips_all: "02130|02198",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Sitka",
  },
  {
    zip: 99903,
    lat: 55.73414,
    lng: -132.10669,
    city: "Meyers Chuck",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1,
    density: 0,
    county_fips: "02275",
    county_name: "Wrangell",
    county_weights: {
      "02275": 100,
    },
    county_names_all: "Wrangell",
    county_fips_all: "02275",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Sitka",
  },
  {
    zip: 99918,
    lat: 55.94605,
    lng: -132.74233,
    city: "Coffman Cove",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 271,
    density: 2.9,
    county_fips: "02198",
    county_name: "Prince of Wales-Hyder",
    county_weights: {
      "02198": 100,
    },
    county_names_all: "Prince of Wales-Hyder",
    county_fips_all: "02198",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Sitka",
  },
  {
    zip: 99919,
    lat: 55.64983,
    lng: -132.50337,
    city: "Thorne Bay",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 547,
    density: 4.3,
    county_fips: "02198",
    county_name: "Prince of Wales-Hyder",
    county_weights: {
      "02198": 100,
    },
    county_names_all: "Prince of Wales-Hyder",
    county_fips_all: "02198",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Sitka",
  },
  {
    zip: 99921,
    lat: 55.51989,
    lng: -132.81656,
    city: "Craig",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1953,
    density: 0.3,
    county_fips: "02198",
    county_name: "Prince of Wales-Hyder",
    county_weights: {
      "02198": 100,
    },
    county_names_all: "Prince of Wales-Hyder",
    county_fips_all: "02198",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Sitka",
  },
  {
    zip: 99922,
    lat: 55.30218,
    lng: -133.03264,
    city: "Hydaburg",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 383,
    density: 1.3,
    county_fips: "02198",
    county_name: "Prince of Wales-Hyder",
    county_weights: {
      "02198": 100,
    },
    county_names_all: "Prince of Wales-Hyder",
    county_fips_all: "02198",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Sitka",
  },
  {
    zip: 99923,
    lat: 55.98043,
    lng: -130.03803,
    city: "Hyder",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 12,
    density: 0.3,
    county_fips: "02198",
    county_name: "Prince of Wales-Hyder",
    county_weights: {
      "02198": 100,
    },
    county_names_all: "Prince of Wales-Hyder",
    county_fips_all: "02198",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Sitka",
  },
  {
    zip: 99925,
    lat: 55.55398,
    lng: -132.96276,
    city: "Klawock",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 990,
    density: 7.1,
    county_fips: "02198",
    county_name: "Prince of Wales-Hyder",
    county_weights: {
      "02198": 100,
    },
    county_names_all: "Prince of Wales-Hyder",
    county_fips_all: "02198",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Sitka",
  },
  {
    zip: 99926,
    lat: 55.12617,
    lng: -131.48928,
    city: "Metlakatla",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1582,
    density: 4.6,
    county_fips: "02198",
    county_name: "Prince of Wales-Hyder",
    county_weights: {
      "02198": 100,
    },
    county_names_all: "Prince of Wales-Hyder",
    county_fips_all: "02198",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Metlakatla",
  },
  {
    zip: 99927,
    lat: 56.33305,
    lng: -133.60044,
    city: "Point Baker",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 0,
    density: 0,
    county_fips: "02198",
    county_name: "Prince of Wales-Hyder",
    county_weights: {
      "02198": 100,
    },
    county_names_all: "Prince of Wales-Hyder",
    county_fips_all: "02198",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Sitka",
  },
  {
    zip: 99929,
    lat: 56.36089,
    lng: -132.00635,
    city: "Wrangell",
    state_id: "AK",
    state_name: "Alaska",
    zcta: "TRUE",
    parent_zcta: "",
    population: 2509,
    density: 0.4,
    county_fips: "02275",
    county_name: "Wrangell",
    county_weights: {
      "02275": 100,
    },
    county_names_all: "Wrangell",
    county_fips_all: "02275",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/Sitka",
  },
  {
    zip: 13021,
    lat: 42.91713,
    lng: -76.5542,
    city: "Auburn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 37528,
    density: 121.6,
    county_fips: 36011,
    county_name: "Cayuga",
    county_weights: {
      36011: 99.67,
      36067: 0.33,
    },
    county_names_all: "Cayuga|Onondaga",
    county_fips_all: "36011|36067",
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  },
  {
    zip: 13024,
    lat: 42.93453,
    lng: -76.57424,
    city: "Auburn",
    state_id: "NY",
    state_name: "New York",
    zcta: "TRUE",
    parent_zcta: "",
    population: 1671,
    density: 15533.1,
    county_fips: 36011,
    county_name: "Cayuga",
    county_weights: {
      36011: 100,
    },
    county_names_all: "Cayuga",
    county_fips_all: 36011,
    imprecise: "FALSE",
    military: "FALSE",
    timezone: "America/New_York",
  }
];
